function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("inVNu", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$558a346803bb9c9a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>(parcelRequire("AeWM3")).ApolloClientProvider);
    $parcel$export(module.exports, "IssueCreateModal", ()=>(parcelRequire("iiKA1")).default);
    $parcel$export(module.exports, "messages", ()=>(parcelRequire("4Ju2T")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $AeWM3;
    var $7CMCs;
    var $4R6GH;
    var $k8U9V;
    var $aCgtf;
    var $5rzqz;
    var $4Ju2T;
    var $9U8fV;
    var $bvFAf;
    var $4dA66;
    var $dVtn1;
    var $iiKA1;
    const $558a346803bb9c9a$var$onResetApolloCache = ()=>(0, (0, parcelRequire("AeWM3")).resetCache)((0, $0f49084c2859db45$export$9c9ee93e509f8666));
    const $558a346803bb9c9a$var$IssueCreateAppWithApolloProvider = ({ onError: onError })=>{
        const [{ isModalOpen: isModalOpen }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { deleteIssueRestoreMeta: deleteIssueRestoreMeta } = (0, (0, parcelRequire("aCgtf")).useIssueRestoreMetaService)();
        const _onError = (0, $5uXOq.useCallback)(()=>{
            onError?.();
            deleteIssueRestoreMeta();
        }, [
            onError,
            deleteIssueRestoreMeta
        ]);
        const { giraClient: giraClient } = (0, (0, parcelRequire("bvFAf")).useIssueCreateFromAnywhereContext)();
        (0, (0, parcelRequire("4dA66")).usePublishUseTriggerIssueCreateModalChange)();
        (0, (0, parcelRequire("k8U9V")).usePublishFormContext)();
        const renderIssueCreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore } = {})=>{
            if (isModalOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iiKA1")).default), {
                onTransformCreateFormProps: onTransformCreateFormProps,
                setShouldRestore: setShouldRestore,
                onResetApolloCache: $558a346803bb9c9a$var$onResetApolloCache
            });
            return null;
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) return isModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "issue-create-app",
            packageName: "jiraIssueCreate",
            fallback: "flag",
            onError: _onError,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: giraClient
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9U8fV")).NavigationDiscardChangesContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVtn1")).IssueRestoreWrapper), null, ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                id: "issue-create-app-children",
                packageName: "jiraIssueCreate",
                fallback: "flag",
                onError: _onError,
                sendToPrivacyUnsafeSplunk: true
            }, renderIssueCreateModal({
                onTransformCreateFormProps: onTransformCreateFormProps,
                setShouldRestore: setShouldRestore
            }))))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "issue-create-app",
            packageName: "jiraIssueCreate",
            fallback: "flag",
            onError: _onError,
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: giraClient
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9U8fV")).NavigationDiscardChangesContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVtn1")).IssueRestoreWrapper), null, ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                id: "issue-create-app-children",
                packageName: "jiraIssueCreate",
                fallback: "flag",
                onError: _onError,
                sendToPrivacyUnsafeSplunk: true
            }, renderIssueCreateModal({
                onTransformCreateFormProps: onTransformCreateFormProps,
                setShouldRestore: setShouldRestore
            }))))));
    };
    var $558a346803bb9c9a$export$2e2bcd8739ae039 = $558a346803bb9c9a$var$IssueCreateAppWithApolloProvider;
});
const $0f49084c2859db45$export$2eeebb625d70ae49 = 'SWAG';
const $0f49084c2859db45$export$9c9ee93e509f8666 = 'gira';
const $0f49084c2859db45$export$14a05c678c2af272 = 'REST';
const $0f49084c2859db45$export$b19c7b383ca04a4d = 'POLARIS';
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("1DiV8", function(module, exports) {
    $parcel$export(module.exports, "InvariantError", ()=>$13081c324be1f9ab$export$cea12affaee22fe8);
    $parcel$export(module.exports, "invariant", ()=>$13081c324be1f9ab$export$f5708dca728d7177);
    var $3VFsf;
    var $6cAn5 = parcelRequire("6cAn5");
    var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
    var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    } : $13081c324be1f9ab$var$_a;
    var $13081c324be1f9ab$export$cea12affaee22fe8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InvariantError, _super);
        function InvariantError(message) {
            if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
            var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
            _this.framesToPop = 1;
            _this.name = $13081c324be1f9ab$var$genericMessage;
            $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
            return _this;
        }
        return InvariantError;
    }(Error);
    function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
        if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
    }
    function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
        return function() {
            return console[method].apply(console, arguments);
        };
    }
    (function(invariant) {
        invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
        invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
    })($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
    var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
        env: {}
    };
    if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
    else try {
        Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
    } catch (atLeastWeTried) {}
    var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
    var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;
});
parcelRegister("k8U9V", function(module, exports) {
    $parcel$export(module.exports, "usePublishFormContext", ()=>$84720143e12f0bf1$export$9454401a65fa3f6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5eGnF;
    var $9svjh;
    var $45Cy1;
    const $84720143e12f0bf1$export$9454401a65fa3f6c = ()=>{
        const [state] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        (0, $5uXOq.useEffect)(()=>{
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, state);
        }, [
            publish,
            state
        ]);
    };
});
parcelRegister("5eGnF", function(module, exports) {
    $parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", ()=>$700db8c378cd19d9$export$876003a5b887f37e);
    const $700db8c378cd19d9$export$876003a5b887f37e = {
        MODAL_OPENED: 'MODAL_OPENED',
        MODAL_CLOSED: 'MODAL_CLOSED',
        MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
        MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
        MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
        MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
        MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
        CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
        CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
        ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
        PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
        ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
        RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
        USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
        STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
        CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
        CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
        FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
    };
});
parcelRegister("9svjh", function(module, exports) {
    $parcel$export(module.exports, "useGICLifeCycleEvents", ()=>$d9b2e43e4699b192$export$e3ff72f196296fcc);
    var $1mrD8;
    const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, (0, parcelRequire("1mrD8")).PubSubHub)();
    const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
            ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
        });
});
parcelRegister("1mrD8", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
    class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("45Cy1", function(module, exports) {
    $parcel$export(module.exports, "useCreateFormState", ()=>$fb3a5d31230745bd$export$64ff4e8b244effca);
    $parcel$export(module.exports, "useFormContext", ()=>$fb3a5d31230745bd$export$4d957a5e1be13b03);
    $parcel$export(module.exports, "useFormContextActions", ()=>$fb3a5d31230745bd$export$8b2a836c011f987c);
    $parcel$export(module.exports, "useFormContextInteractedFields", ()=>$fb3a5d31230745bd$export$43c5716796c2329e);
    $parcel$export(module.exports, "useIsCollapsedAreaExpanded", ()=>$fb3a5d31230745bd$export$ee8f126c0e25d653);
    $parcel$export(module.exports, "useIsSmartFieldsNew", ()=>$fb3a5d31230745bd$export$52b9b0c902b0ae2b);
    var $fr1K2 = parcelRequire("fr1K2");
    var $3sQ5x;
    var $iXqE5;
    const $fb3a5d31230745bd$export$d4c72bab9d6cc13a = {
        selectedProject: null,
        selectedIssueType: null,
        requestBackedIssueType: null,
        isEpicLinkSelected: false,
        isSubmitting: false,
        isOperationInProgress: false,
        shouldShowConfigureFieldModal: false,
        shouldShowFindFieldModal: false,
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: '',
            submitErrorMessage: '',
            submitFieldwiseErrors: {},
            inlineCreateError: null
        },
        dataFetchError: null,
        isFormDirty: false,
        areConfiguredFieldsModified: false,
        timeTrackingValue: '',
        ecosystem: {
            forge: {
                customFields: [],
                filteredOutModules: [],
                issueAdjustmentModules: [],
                hasFinishedLoading: false
            }
        },
        currentActiveTabIndex: 0,
        shouldAutoFocus: true,
        resetFormAction: null,
        isForgeFieldsDetected: false,
        canCreateAnotherIssue: false,
        createdIssues: [],
        watchers: [],
        interactedFields: {},
        expandedCollapsedAreas: [],
        isSmartFieldsNew: undefined,
        isSmartFieldsToggled: false,
        isFormLoaded: false
    };
    const $fb3a5d31230745bd$export$e324594224ef24da = {
        restoreState: (state)=>({ setState: setState })=>{
                setState((0, ($parcel$interopDefault($fr1K2)))(state, [
                    'isSubmitting',
                    'isOperationInProgress'
                ]));
            },
        setCurrentActiveTabIndex: (tabIndex)=>({ setState: setState, getState: getState })=>{
                const { currentActiveTabIndex: currentActiveTabIndex } = getState();
                if (tabIndex >= 0 && currentActiveTabIndex !== tabIndex) setState({
                    currentActiveTabIndex: tabIndex
                });
            },
        setShouldAutoFocus: (shouldAutoFocus)=>({ setState: setState })=>{
                setState({
                    shouldAutoFocus: shouldAutoFocus
                });
            },
        setSelectedProject: (project)=>({ setState: setState })=>{
                setState({
                    selectedProject: project
                });
            },
        setSelectedIssueType: (issueType)=>({ setState: setState })=>{
                setState({
                    selectedIssueType: issueType
                });
            },
        setRequestBackedIssueType: (issueType)=>({ setState: setState })=>{
                setState({
                    requestBackedIssueType: issueType
                });
            },
        setIsEpicLinkSelected: (isEpicLinkSelected)=>({ setState: setState })=>{
                setState({
                    isEpicLinkSelected: isEpicLinkSelected
                });
            },
        setMeta: (meta)=>({ setState: setState })=>{
                setState({
                    meta: meta
                });
            },
        setSubmitErrorMessage: (submitErrorMessage)=>({ setState: setState, getState: getState })=>{
                const { meta: meta } = getState();
                setState({
                    meta: {
                        ...meta,
                        submitErrorMessage: submitErrorMessage
                    }
                });
            },
        setTimeTrackingValue: (timeTrackingValue)=>({ setState: setState })=>{
                setState({
                    timeTrackingValue: timeTrackingValue
                });
            },
        setSubmitFieldwiseErrors: (fieldwiseErrors)=>({ setState: setState, getState: getState })=>{
                const { meta: meta } = getState();
                setState({
                    meta: {
                        ...meta,
                        submitFieldwiseErrors: fieldwiseErrors
                    }
                });
            },
        setInlineErrorMessage: (inlineCreateError)=>({ setState: setState, getState: getState })=>{
                const { meta: meta } = getState();
                setState({
                    meta: {
                        ...meta,
                        inlineCreateError: inlineCreateError
                    }
                });
            },
        setSubmitting: (isSubmitting)=>({ setState: setState })=>{
                setState({
                    isSubmitting: isSubmitting
                });
            },
        setIsOperationInProgress: (isOperationInProgress)=>({ setState: setState })=>{
                setState({
                    isOperationInProgress: isOperationInProgress
                });
            },
        toggleConfigureFieldsModalVisibility: (shouldShowConfigureFieldModal)=>({ setState: setState })=>{
                setState({
                    shouldShowConfigureFieldModal: shouldShowConfigureFieldModal
                });
            },
        toggleFindFieldsModalVisibility: (shouldShowFindFieldModal)=>({ setState: setState })=>{
                setState({
                    shouldShowFindFieldModal: shouldShowFindFieldModal
                });
            },
        resetFormContext: ()=>({ setState: setState })=>{
                setState({
                    ...$fb3a5d31230745bd$export$d4c72bab9d6cc13a
                });
            },
        setDataFetchError: (error)=>({ setState: setState })=>{
                setState({
                    dataFetchError: error
                });
            },
        setIsFormDirty: (isFormDirty)=>({ setState: setState })=>{
                setState({
                    isFormDirty: isFormDirty
                });
            },
        setAreConfiguredFieldsModified: (areConfiguredFieldsModified)=>({ setState: setState })=>{
                setState({
                    areConfiguredFieldsModified: areConfiguredFieldsModified
                });
            },
        setForgeModules: (customFields, issueAdjustmentModules, filteredOutModules, hasFinishedLoading)=>({ setState: setState, getState: getState })=>{
                const { ecosystem: ecosystem } = getState();
                setState({
                    ecosystem: {
                        ...ecosystem,
                        forge: {
                            customFields: customFields,
                            issueAdjustmentModules: issueAdjustmentModules,
                            hasFinishedLoading: !!hasFinishedLoading,
                            filteredOutModules: filteredOutModules
                        }
                    }
                });
            },
        setResetFormAction: (resetFormAction)=>({ setState: setState })=>{
                setState({
                    resetFormAction: resetFormAction
                });
            },
        setIsForgeFieldsDetected: (isForgeFieldsDetected)=>({ setState: setState })=>{
                setState({
                    isForgeFieldsDetected: isForgeFieldsDetected
                });
            },
        setCanCreateAnotherIssue: (canCreateAnotherIssue)=>({ setState: setState })=>{
                setState({
                    canCreateAnotherIssue: canCreateAnotherIssue
                });
            },
        addCreatedIssue: (createdIssue)=>({ getState: getState, setState: setState })=>{
                const { createdIssues: createdIssues } = getState();
                const mergedCreatedIssues = [
                    ...createdIssues,
                    createdIssue
                ];
                setState({
                    createdIssues: mergedCreatedIssues
                });
                return mergedCreatedIssues;
            },
        setWatchers: (watchers)=>({ setState: setState })=>{
                setState({
                    watchers: watchers
                });
            },
        setInteractedWithField: (fieldId)=>({ setState: setState, getState: getState })=>{
                const { interactedFields: interactedFields } = getState();
                setState({
                    interactedFields: {
                        ...interactedFields,
                        [fieldId]: true
                    }
                });
            },
        setExpandedCollapsedArea: (index, shouldExpand)=>({ setState: setState, getState: getState })=>{
                const { expandedCollapsedAreas: expandedCollapsedAreas } = getState();
                const newExpandedCollapsedAreas = expandedCollapsedAreas.slice(0);
                const isCurrentExpanded = expandedCollapsedAreas.includes(index);
                let shouldUpdate = false;
                if (!isCurrentExpanded && shouldExpand) {
                    newExpandedCollapsedAreas.push(index);
                    shouldUpdate = true;
                }
                if (isCurrentExpanded && !shouldExpand) {
                    newExpandedCollapsedAreas.splice(newExpandedCollapsedAreas.indexOf(index), 1);
                    shouldUpdate = true;
                }
                if (shouldUpdate) setState({
                    expandedCollapsedAreas: newExpandedCollapsedAreas
                });
            },
        resetExpandedCollapsedArea: ()=>({ setState: setState })=>{
                setState({
                    expandedCollapsedAreas: []
                });
            },
        setIsSmartFieldsNew: (isSmartFieldsNew)=>({ setState: setState })=>{
                setState({
                    isSmartFieldsNew: isSmartFieldsNew
                });
            },
        setIsSmartFieldsToggled: (isSmartFieldsToggled)=>({ setState: setState })=>{
                setState({
                    isSmartFieldsToggled: isSmartFieldsToggled
                });
            },
        setIsFormLoaded: (isFormLoaded)=>({ setState: setState })=>{
                setState({
                    isFormLoaded: isFormLoaded
                });
            }
    };
    const $fb3a5d31230745bd$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.form-context',
        initialState: $fb3a5d31230745bd$export$d4c72bab9d6cc13a,
        actions: $fb3a5d31230745bd$export$e324594224ef24da
    });
    const $fb3a5d31230745bd$export$e6a162613d6e6e63 = (state)=>{
        const { selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, areConfiguredFieldsModified: areConfiguredFieldsModified, requestBackedIssueType: requestBackedIssueType, isFormDirty: isFormDirty } = state;
        return {
            selectedProject: selectedProject,
            selectedIssueType: selectedIssueType,
            requestBackedIssueType: requestBackedIssueType,
            meta: meta,
            areConfiguredFieldsModified: areConfiguredFieldsModified,
            isFormDirty: isFormDirty
        };
    };
    const $fb3a5d31230745bd$export$64ff4e8b244effca = (0, (0, parcelRequire("3sQ5x")).createHook)($fb3a5d31230745bd$var$store, {
        selector: $fb3a5d31230745bd$export$e6a162613d6e6e63
    });
    const $fb3a5d31230745bd$export$4d957a5e1be13b03 = (0, (0, parcelRequire("3sQ5x")).createHook)($fb3a5d31230745bd$var$store);
    const $fb3a5d31230745bd$export$8b2a836c011f987c = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($fb3a5d31230745bd$var$store);
    const $fb3a5d31230745bd$var$getInteractedFieldsSelector = (state)=>state.interactedFields;
    const $fb3a5d31230745bd$export$43c5716796c2329e = (0, (0, parcelRequire("3sQ5x")).createHook)($fb3a5d31230745bd$var$store, {
        selector: $fb3a5d31230745bd$var$getInteractedFieldsSelector
    });
    const $fb3a5d31230745bd$var$getIsCollapsedAreaExpandedSelector = (state, index)=>state.expandedCollapsedAreas.includes(index);
    const $fb3a5d31230745bd$export$ee8f126c0e25d653 = (0, (0, parcelRequire("3sQ5x")).createHook)($fb3a5d31230745bd$var$store, {
        selector: (state, index)=>$fb3a5d31230745bd$var$getIsCollapsedAreaExpandedSelector(state, index)
    });
    const $fb3a5d31230745bd$export$52b9b0c902b0ae2b = (0, (0, parcelRequire("3sQ5x")).createHook)($fb3a5d31230745bd$var$store, {
        selector: (state)=>state.isSmartFieldsNew
    });
});
parcelRegister("aCgtf", function(module, exports) {
    $parcel$export(module.exports, "useIssueRestoreMetaService", ()=>$bffd0385d7f4b21c$export$8f688cfe533ab228);
    var $5uXOq = parcelRequire("5uXOq");
    var $eNf8a;
    const $bffd0385d7f4b21c$var$KEY = 'issue-restore-meta';
    const $bffd0385d7f4b21c$export$8f688cfe533ab228 = ()=>{
        const [storage] = (0, $5uXOq.useState)((0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}`));
        return {
            getIssueRestoreMeta: async ()=>storage.get($bffd0385d7f4b21c$var$KEY),
            createIssueRestoreMeta: async (data)=>{
                storage.set($bffd0385d7f4b21c$var$KEY, data);
                return data;
            },
            updateIssueRestoreMeta: async (data)=>{
                storage.set($bffd0385d7f4b21c$var$KEY, data);
                return data;
            },
            deleteIssueRestoreMeta: async ()=>{
                storage.remove($bffd0385d7f4b21c$var$KEY);
            }
        };
    };
});
const $9a94166e56e4a9e2$export$8fa5032778cf7801 = 'jira-issue-create-restore-';
parcelRegister("5rzqz", function(module, exports) {
    $parcel$export(module.exports, "useTriggerIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
    $parcel$export(module.exports, "useOpenIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$47cf258b1046080b);
    $parcel$export(module.exports, "withNewGICProvider", ()=>$0a31d64d52b4b5e9$export$558a195c5bfe3787);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $1Nspv;
    var $bGrWH;
    var $8zOmE;
    var $2NMNM;
    var $f5nIZ;
    var $2YP9W;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hULKg;
    var $cKWWX;
    var $6k7U1;
    const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
        inProgressIssueID: undefined,
        isModalOpen: false,
        isSubsequentLoad: false,
        isSubTaskCreationOpen: false,
        isCreateLinkedIssue: false,
        wasStateRestored: false,
        payload: null,
        id: 'create-issue-dialog',
        title: null,
        sectionMessage: null,
        submitErrorMessage: undefined,
        globalEventNamespaces: [
            (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
        ],
        fieldsToAddInPublishedData: [],
        alertsToBeLinked: undefined,
        onIssueCreate: null,
        onClose: null,
        displayOnlyRequiredFields: false,
        disableCreationSuccessFlag: false,
        displayCreateAnotherIssueToggle: true,
        displaySitePicker: false,
        disableProjectDropdown: false,
        disableIssueTypeDropdown: false,
        triggerPointKey: (0, (0, parcelRequire("hULKg")).TRIGGER_POINT_KEY_NOT_DEFINED),
        context: undefined,
        minimizableModalView: 'modal',
        persistentModalView: undefined,
        shouldPushMiniModalDiscoverability: undefined,
        shouldShowMiniModalSpotlight: undefined,
        wasModalRetriggered: false,
        openIssueCreateModalNextState: {},
        shouldInitFetchConfig: false,
        interactedWithModalChangerButtons: false,
        isModalLoadInContext: false,
        disableMinimizableModal: false,
        displayMinimizableButtons: true,
        displayHeaderActionContainer: true,
        overrideUseRequestTypeFieldsToggleState: undefined,
        containerStyle: {},
        isMiniDesignEnabled: false,
        isEnrolledAndTargetedForGicMultipleLayouts: false,
        sessionId: undefined,
        FieldWrapperComponent: undefined,
        ExternalControls: undefined,
        isCustomBoardWithIcc: false,
        jqlSwimlaneId: undefined,
        swimlaneMode: undefined,
        prefilledCustomFields: {},
        ecosystemCallback: undefined,
        product: undefined,
        actionSource: undefined
    };
    const $0a31d64d52b4b5e9$export$e324594224ef24da = {
        restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
                const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
                if (!isModalOpen && stateToRestore.isModalOpen) (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(isSubsequentLoad);
                setState(stateToRestore);
            },
        openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isModalOpen) setState({
                    wasModalRetriggered: true,
                    openIssueCreateModalNextState: nextState
                });
                else {
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                    const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                    const nextModalView = isDiscoverabilityPushEnabled ? (0, (0, parcelRequire("6k7U1")).getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, (0, parcelRequire("6k7U1")).discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        ...nextState
                    });
                }
            },
        closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
                const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
                const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    callbackPayload: undefined,
                    ...shouldPersistDiscoverabilityState && {
                        shouldPushMiniModalDiscoverability: true
                    },
                    ...isDiscoverabilityPushEnabled && {
                        persistentModalView: currentState.persistentModalView
                    },
                    ...shouldUpdatePersistentModalView && {
                        persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                    },
                    isModalOpen: false,
                    isSubsequentLoad: true
                });
                (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).abort({
                    metadata: {
                        wasStateRestored: getState().wasStateRestored
                    }
                });
            },
        clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    sectionMessage: null
                });
            },
        setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    displayOnlyRequiredFields: nextState
                });
            },
        setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
                setState({
                    minimizableModalView: minimizableModalView,
                    interactedWithModalChangerButtons: true
                });
            },
        resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
                if (applyNextState) {
                    const currentState = getState();
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                            persistentModalView: currentState.persistentModalView
                        },
                        inProgressIssueID: currentState.inProgressIssueID,
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: false,
                        minimizableModalView: 'modal',
                        openIssueCreateModalNextState: {},
                        shouldInitFetchConfig: true,
                        ...currentState.openIssueCreateModalNextState
                    });
                } else setState({
                    minimizableModalView: 'modal',
                    wasModalRetriggered: false,
                    openIssueCreateModalNextState: {}
                });
            },
        resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
                setState({
                    shouldInitFetchConfig: false
                });
            },
        setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    callbackPayload: {
                        id: currentState.callbackPayload?.id ?? '',
                        data: callbackPayload
                    }
                });
            },
        setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
                });
            },
        dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldShowMiniModalSpotlight: false
                });
            },
        setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    persistentModalView: persistentModalView
                });
            },
        removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
                setState({
                    alertsToBeLinked: alertsToBeLinked
                });
            },
        setSessionId: (sessionId)=>({ setState: setState })=>{
                setState({
                    sessionId: sessionId
                });
            }
    };
    const $0a31d64d52b4b5e9$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
        initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
        actions: $0a31d64d52b4b5e9$export$e324594224ef24da
    });
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
        const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
        const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
        const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal
        ]);
        return [
            createState,
            {
                ...otherActions,
                openIssueCreateModal: openIssueCreateModalWithAnalytics
            }
        ];
    };
    const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
        const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        return (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            if (nextState?.payload?.overrideCloudId && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) setSitePickerState({
                selectedCloudId: nextState?.payload?.overrideCloudId
            });
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal,
            setSitePickerState
        ]);
    };
    const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, (0, parcelRequire("51nlc")).createSubscriber)($0a31d64d52b4b5e9$var$store);
    function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
        return (props)=>{
            const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
            const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
            const currentIssueCreateVisibility = data && data?.gicOptInStatus;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                openIssueCreateModal: openIssueCreateModal,
                closeIssueCreateModal: closeIssueCreateModal,
                currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
                ...props
            });
        };
    }
});
parcelRegister("1Nspv", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueUFOExperience", ()=>$ff7fb599b8d98642$export$cd75c112ac11a83b);
    $parcel$export(module.exports, "StatusFieldLoad", ()=>$ff7fb599b8d98642$export$e890e797a25e655c);
    $parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", ()=>$ff7fb599b8d98642$export$70208657c8d471a7);
    $parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", ()=>$ff7fb599b8d98642$export$b2d8f8edec75f571);
    var $atdLB;
    var $duUGa;
    const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'global-issue-create.create-issue'
    });
    const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, (0, parcelRequire("duUGa")).UFOExperience)('global-issue-create.create-issue.status-field', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('modern-global-issue-create.modal.issue-submit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'modern-global-issue-create.modal.issue-submit'
    });
    const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('ecosystem-api-new-gic-prefilling', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'ecosystem-api-new-gic-prefilling'
    });
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
parcelRegister("hULKg", function(module, exports) {
    $parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", ()=>$62659eb193cd5c9c$export$a05673a22505d5ee);
    $parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$c78d329777576aa0);
    $parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$992ab052fd10f8e8);
    $parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", ()=>$62659eb193cd5c9c$export$affdc3af7a9a4677);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", ()=>$62659eb193cd5c9c$export$7e9cfd1f59e60910);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", ()=>$62659eb193cd5c9c$export$708499dcd016e5e9);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", ()=>$62659eb193cd5c9c$export$e1c8789144c4c810);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", ()=>$62659eb193cd5c9c$export$c5afabb7a17e802);
    $parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$2086a63173b79b56);
    $parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$fe1e5e4597147709);
    $parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$9bc326812a93707);
    $parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", ()=>$62659eb193cd5c9c$export$f352934e06f44599);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", ()=>$62659eb193cd5c9c$export$6ae07c77acc64360);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", ()=>$62659eb193cd5c9c$export$b41d0684e4b6ab1);
    $parcel$export(module.exports, "JSM_CREATE_PROBLEM_FROM_INCIDENT_AI", ()=>$62659eb193cd5c9c$export$1110454816343634);
    $parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", ()=>$62659eb193cd5c9c$export$be9b2b1329ff7ec9);
    $parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", ()=>$62659eb193cd5c9c$export$aa348159181703a0);
    $parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$f90eec3841adf619);
    $parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$718822a309bffada);
    $parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", ()=>$62659eb193cd5c9c$export$2753dafac81e805c);
    $parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", ()=>$62659eb193cd5c9c$export$7c4d5cc5711d9294);
    $parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", ()=>$62659eb193cd5c9c$export$998dfc72404b9e14);
    $parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", ()=>$62659eb193cd5c9c$export$fc180a4b5785d2f4);
    $parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", ()=>$62659eb193cd5c9c$export$946ec0b21cb84fd0);
    $parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", ()=>$62659eb193cd5c9c$export$5b97e2844e620e54);
    $parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", ()=>$62659eb193cd5c9c$export$b99842c2cf46f6be);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", ()=>$62659eb193cd5c9c$export$8d987f6e80b74000);
    $parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$8de9fa43731c4b5b);
    $parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", ()=>$62659eb193cd5c9c$export$87249ccbfd10fb78);
    $parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", ()=>$62659eb193cd5c9c$export$c0eeeb31d264de76);
    $parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", ()=>$62659eb193cd5c9c$export$f546e18e46478c84);
    $parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", ()=>$62659eb193cd5c9c$export$1784e634ba79f1f9);
    $parcel$export(module.exports, "JWM_INLINE_CREATE", ()=>$62659eb193cd5c9c$export$145eb8935a34e85e);
    $parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", ()=>$62659eb193cd5c9c$export$32648b574a536c8b);
    $parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", ()=>$62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
    const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
    const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
    const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
    const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
    const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
    const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
    const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
    const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
    const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
    const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
    const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
    const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
    const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
    const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
    const $62659eb193cd5c9c$export$1110454816343634 = 'jsm-create-problem-from-incident-ai';
    const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
    const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
    const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
    const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
    const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
    const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
    const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
    const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
    const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
    const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
    const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
    const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
    const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
    const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
    const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
    const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
    const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
    const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
    const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
    const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
    const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
    const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
    const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
    const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
    const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
    const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
    const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
    const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
    const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
    const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
    const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
    const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
        FIELD_IDS: [
            'description'
        ],
        TRIGGER_POINTS: [
            'service-desk-gen-ai-pir'
        ]
    };
});
parcelRegister("cKWWX", function(module, exports) {
    $parcel$export(module.exports, "useSitePickerContext", ()=>$c8055d212e869a3c$export$f8b5aae013e4cf77);
    var $3sQ5x;
    var $iXqE5;
    const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
        selectedCloudId: '',
        siteDomain: ''
    };
    const $c8055d212e869a3c$export$e324594224ef24da = {
        setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    selectedCloudId: selectedCloudId || '',
                    siteDomain: siteDomain || ''
                });
            }
    };
    const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue.fields.site-picker',
        initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
        actions: $c8055d212e869a3c$export$e324594224ef24da
    });
    const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, (0, parcelRequire("3sQ5x")).createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);
});
parcelRegister("6k7U1", function(module, exports) {
    $parcel$export(module.exports, "startGlobalIssueCreateMetrics", ()=>$8a2e4df39a48d5af$export$550b19803bc962ec);
    $parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", ()=>$8a2e4df39a48d5af$export$f6bc17a4d9120156);
    $parcel$export(module.exports, "discoverabilityPushModalViewOverride", ()=>$8a2e4df39a48d5af$export$8d246e5e04f0b424);
    $parcel$export(module.exports, "getNextModalView", ()=>$8a2e4df39a48d5af$export$720579602bb055a2);
    var $eTXmK;
    var $1Nspv;
    var $gEaAu;
    var $huY3x;
    const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).start();
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal-subsequent');
        else (0, (0, parcelRequire("eTXmK")).default)('global-issue.create-modal');
        globalIssueCreateModalLoadMetric.start();
        (0, (0, parcelRequire("huY3x")).startGlobalIssueCreateTTIWithAdjustments)();
    };
    const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
        if (!triggerPoint) return false;
        const acceptedTriggerPoints = [
            'global-create-button',
            'keyboard-shortcut'
        ];
        return acceptedTriggerPoints.includes(triggerPoint);
    };
    const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
        if (!shouldPushDiscoverability) return undefined;
        return {
            minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
            shouldPushMiniModalDiscoverability: true,
            shouldShowMiniModalSpotlight: isTriggerAccepted
        };
    };
    const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
        if (isTriggerAccepted) return persistentView || defaultView;
        return defaultView;
    };
});
parcelRegister("gEaAu", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateModalLoad", ()=>$ee246606338fc99e$export$5a01a7fa84b239c8);
    $parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", ()=>$ee246606338fc99e$export$c50ad3c31b6fcfc6);
    $parcel$export(module.exports, "successFlagDisplay", ()=>$ee246606338fc99e$export$4b2382574525bb0f);
    $parcel$export(module.exports, "successFlagAddToSprintAction", ()=>$ee246606338fc99e$export$7839bdaa2f6a2385);
    $parcel$export(module.exports, "successFlagClearFiltersAction", ()=>$ee246606338fc99e$export$c1592e4d8d98963e);
    var $dGrdR;
    const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal'
    });
    const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-modal-subsequent'
    });
    const $ee246606338fc99e$export$4b2382574525bb0f = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-display'
    });
    const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
    });
    const $ee246606338fc99e$export$c1592e4d8d98963e = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
    });
});
parcelRegister("huY3x", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874);
    $parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$457c9fb71ad5b3a9);
    $parcel$export(module.exports, "markGicTti", ()=>$06c7e44c59602f0c$export$ef664dac649a716c);
    $parcel$export(module.exports, "stopTTI", ()=>$06c7e44c59602f0c$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$06c7e44c59602f0c$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$06c7e44c59602f0c$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$06c7e44c59602f0c$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$06c7e44c59602f0c$export$d86f4868694f2aa7);
    var $dGrdR;
    var $a1HyB;
    const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, (0, parcelRequire("dGrdR")).metrics).interaction({
        key: 'global-issue-create-tti-with-adjustments',
        timings: [
            {
                key: 'gic-tti-delta',
                startMark: 'gic-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            },
            {
                key: 'gic-all-fields-tti',
                endMark: 'gic-all-fields-loaded'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
    };
    const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
    const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
            customData: customData
        });
    };
    const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
    };
    const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
    };
    const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
    };
    const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
    };
});
parcelRegister("4Ju2T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$617513ebca448608$export$2e2bcd8739ae039);
    var $7VHMR;
    var $617513ebca448608$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noSummary: {
            "id": "issue-create.common.no-summary",
            "defaultMessage": "(No summary)"
        },
        noSummaryWithIssueType: {
            "id": "issue-create.common.no-summary-with-issue-type",
            "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
        },
        resizeSpotlightMessage: {
            "id": "issue-create.common.resize-spotlight-message",
            "defaultMessage": "Resize or minimize your issue to pause editing and navigate around Jira."
        },
        resizeSpotlightMessageIssueTermRefresh: {
            "id": "issue-create.common.resize-spotlight-message-issue-term-refresh",
            "defaultMessage": "Resize or minimize your work item to pause editing and navigate around Jira."
        },
        miniModalSpotlightMessage: {
            "id": "issue-create.common.mini-modal-spotlight-message",
            "defaultMessage": "Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. "
        },
        miniModalSpotlightActionMessage: {
            "id": "issue-create.common.mini-modal-spotlight-action-message",
            "defaultMessage": "Got it"
        },
        miniModalSpotlightHeading: {
            "id": "issue-create.common.mini-modal-spotlight-heading",
            "defaultMessage": "Multitasking made easy"
        },
        noSummaryWithIssueTypeIssueTermRefresh: {
            "id": "issue-create.common.no-summary-with-issue-type-issue-term-refresh",
            "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
        }
    });
});
parcelRegister("9U8fV", function(module, exports) {
    $parcel$export(module.exports, "NavigationDiscardChangesContainer", ()=>$2f9e452bf52b998a$export$6b9c176805b3c455);
    $parcel$export(module.exports, "useNavigationDiscardChanges", ()=>$2f9e452bf52b998a$export$bf0dbeb75772072);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $lzF8p;
    const $2f9e452bf52b998a$export$d4c72bab9d6cc13a = {
        deferredNavigationLink: ''
    };
    const $2f9e452bf52b998a$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'NavigationDiscardChanges',
        initialState: $2f9e452bf52b998a$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("lzF8p")).actions
    });
    const $2f9e452bf52b998a$export$6b9c176805b3c455 = (0, (0, parcelRequire("gg7kZ")).createContainer)($2f9e452bf52b998a$var$store);
    const $2f9e452bf52b998a$export$bf0dbeb75772072 = (0, (0, parcelRequire("3sQ5x")).createHook)($2f9e452bf52b998a$var$store);
    const $2f9e452bf52b998a$export$9f61952484b5dffe = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($2f9e452bf52b998a$var$store);
});
parcelRegister("lzF8p", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$67f9388310602af9$export$e324594224ef24da);
    const $67f9388310602af9$export$a750007c2edb3b26 = (deferredNavigationLink)=>({ setState: setState })=>setState({
                deferredNavigationLink: deferredNavigationLink
            });
    const $67f9388310602af9$export$e324594224ef24da = {
        setDeferredNavigationLink: $67f9388310602af9$export$a750007c2edb3b26
    };
});
parcelRegister("bvFAf", function(module, exports) {
    $parcel$export(module.exports, "useIssueCreateFromAnywhereContext", ()=>$2c596761855a9e54$export$f99899ced542f49a);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXhsp;
    var $3M1CO;
    var $cKWWX;
    const $2c596761855a9e54$export$4cea60a165c59df0 = ()=>(0, (0, parcelRequire("aXhsp")).default);
    const $2c596761855a9e54$export$f99899ced542f49a = ()=>{
        const cloudIdRef = (0, $5uXOq.useRef)('');
        const [{ selectedCloudId: selectedCloudId }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (selectedCloudId && cloudIdRef.current !== selectedCloudId) cloudIdRef.current = selectedCloudId;
        }, [
            selectedCloudId
        ]);
        const originUrl = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("3M1CO")).transformOriginUrl)(selectedCloudId), [
            selectedCloudId
        ]);
        return {
            giraClient: {
                ...$2c596761855a9e54$export$4cea60a165c59df0(),
                ...originUrl && {
                    clientCreator: ()=>$2c596761855a9e54$export$4cea60a165c59df0()?.clientCreator(originUrl)
                }
            },
            resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId
        };
    };
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $aS6b9;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $dxpxC;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("aS6b9")).default)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("dxpxC")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("jojW6", function(module, exports) {
    $parcel$export(module.exports, "storeKeyNameFromField", ()=>$e1dfb923a27ca793$export$54be8689c65f3b56);
    $parcel$export(module.exports, "getStoreKeyName", ()=>$e1dfb923a27ca793$export$3cdb6c178b88cabe);
    $parcel$export(module.exports, "argumentsObjectFromField", ()=>$e1dfb923a27ca793$export$3f5a60fb6a781b4f);
    $parcel$export(module.exports, "resultKeyNameFromField", ()=>$e1dfb923a27ca793$export$7d1ad22471852218);
    $parcel$export(module.exports, "isField", ()=>$e1dfb923a27ca793$export$fb56ad75dd311c12);
    $parcel$export(module.exports, "isInlineFragment", ()=>$e1dfb923a27ca793$export$22a1cdafaf27bcff);
    $parcel$export(module.exports, "isIdValue", ()=>$e1dfb923a27ca793$export$e33b89a9aa87695);
    $parcel$export(module.exports, "toIdValue", ()=>$e1dfb923a27ca793$export$b124f125e34d720a);
    $parcel$export(module.exports, "isJsonValue", ()=>$e1dfb923a27ca793$export$226c1c6d1a5b660a);
    $parcel$export(module.exports, "getDirectiveInfoFromField", ()=>$e1dfb923a27ca793$export$2a7f471142984a91);
    $parcel$export(module.exports, "shouldInclude", ()=>$e1dfb923a27ca793$export$3dc388a5f013b4a5);
    $parcel$export(module.exports, "hasDirectives", ()=>$e1dfb923a27ca793$export$2dafb573e282fe8d);
    $parcel$export(module.exports, "hasClientExports", ()=>$e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
    $parcel$export(module.exports, "getFragmentQueryDocument", ()=>$e1dfb923a27ca793$export$abbf37c7cf644e41);
    $parcel$export(module.exports, "assign", ()=>$e1dfb923a27ca793$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "checkDocument", ()=>$e1dfb923a27ca793$export$a7d0d8111d2386df);
    $parcel$export(module.exports, "getOperationDefinition", ()=>$e1dfb923a27ca793$export$7a5b1fa979d2c158);
    $parcel$export(module.exports, "getOperationName", ()=>$e1dfb923a27ca793$export$41bca9dc6871dd4e);
    $parcel$export(module.exports, "getFragmentDefinitions", ()=>$e1dfb923a27ca793$export$5320a7ba9466a3df);
    $parcel$export(module.exports, "getQueryDefinition", ()=>$e1dfb923a27ca793$export$d96b2213c1b9d3a9);
    $parcel$export(module.exports, "getMainDefinition", ()=>$e1dfb923a27ca793$export$f431198736b7f96d);
    $parcel$export(module.exports, "createFragmentMap", ()=>$e1dfb923a27ca793$export$193789b4c8246dd4);
    $parcel$export(module.exports, "getDefaultValues", ()=>$e1dfb923a27ca793$export$84c19026e616569e);
    $parcel$export(module.exports, "removeDirectivesFromDocument", ()=>$e1dfb923a27ca793$export$e5ae0530da5fe96c);
    $parcel$export(module.exports, "addTypenameToDocument", ()=>$e1dfb923a27ca793$export$43b332f87950a467);
    $parcel$export(module.exports, "removeConnectionDirectiveFromDocument", ()=>$e1dfb923a27ca793$export$74985f3324559867);
    $parcel$export(module.exports, "buildQueryFromSelectionSet", ()=>$e1dfb923a27ca793$export$57c368c23873f32b);
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$e1dfb923a27ca793$export$8eae69e876ee321e);
    $parcel$export(module.exports, "canUseWeakMap", ()=>$e1dfb923a27ca793$export$772fbc04a0ad4ce9);
    $parcel$export(module.exports, "cloneDeep", ()=>$e1dfb923a27ca793$export$629a2bd3f5a49ecc);
    $parcel$export(module.exports, "isProduction", ()=>$e1dfb923a27ca793$export$f15d00aa73aafac4);
    $parcel$export(module.exports, "isTest", ()=>$e1dfb923a27ca793$export$410cbc2864fa25b5);
    $parcel$export(module.exports, "tryFunctionOrLogError", ()=>$e1dfb923a27ca793$export$50a91acae4904909);
    $parcel$export(module.exports, "graphQLResultHasError", ()=>$e1dfb923a27ca793$export$b4df399e879e53ab);
    $parcel$export(module.exports, "mergeDeep", ()=>$e1dfb923a27ca793$export$dd702b3c8240390c);
    $parcel$export(module.exports, "mergeDeepArray", ()=>$e1dfb923a27ca793$export$160070228be94b08);
    var $12QNw;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $fkrBp = parcelRequire("fkrBp");
    var $bqMzA = parcelRequire("bqMzA");
    var $6cAn5 = parcelRequire("6cAn5");
    function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
        return [
            'StringValue',
            'BooleanValue',
            'EnumValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
        return [
            'IntValue',
            'FloatValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$var$isStringValue(value) {
        return value.kind === 'StringValue';
    }
    function $e1dfb923a27ca793$var$isBooleanValue(value) {
        return value.kind === 'BooleanValue';
    }
    function $e1dfb923a27ca793$var$isIntValue(value) {
        return value.kind === 'IntValue';
    }
    function $e1dfb923a27ca793$var$isFloatValue(value) {
        return value.kind === 'FloatValue';
    }
    function $e1dfb923a27ca793$var$isVariable(value) {
        return value.kind === 'Variable';
    }
    function $e1dfb923a27ca793$var$isObjectValue(value) {
        return value.kind === 'ObjectValue';
    }
    function $e1dfb923a27ca793$var$isListValue(value) {
        return value.kind === 'ListValue';
    }
    function $e1dfb923a27ca793$var$isEnumValue(value) {
        return value.kind === 'EnumValue';
    }
    function $e1dfb923a27ca793$var$isNullValue(value) {
        return value.kind === 'NullValue';
    }
    function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
        if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
        else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
            var nestedArgObj_1 = {};
            value.fields.map(function(obj) {
                return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
            });
            argObj[name.value] = nestedArgObj_1;
        } else if ($e1dfb923a27ca793$var$isVariable(value)) {
            var variableValue = (variables || {})[value.name.value];
            argObj[name.value] = variableValue;
        } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
            var nestedArgArrayObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
        else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
        else throw new (0, $1DiV8.InvariantError)(17);
    }
    function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
        var directivesObj = null;
        if (field.directives) {
            directivesObj = {};
            field.directives.forEach(function(directive) {
                directivesObj[directive.name.value] = {};
                if (directive.arguments) directive.arguments.forEach(function(_a) {
                    var name = _a.name, value = _a.value;
                    return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
                });
            });
        }
        var argObj = null;
        if (field.arguments && field.arguments.length) {
            argObj = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
            });
        }
        return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
    }
    var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
        'connection',
        'include',
        'skip',
        'client',
        'rest',
        'export'
    ];
    function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
        if (directives && directives['connection'] && directives['connection']['key']) {
            if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
                var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
                filterKeys.sort();
                var queryArgs_1 = args;
                var filteredArgs_1 = {};
                filterKeys.forEach(function(key) {
                    filteredArgs_1[key] = queryArgs_1[key];
                });
                return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
            } else return directives['connection']['key'];
        }
        var completeFieldName = fieldName;
        if (args) {
            var stringifiedArgs = (0, ($parcel$interopDefault($fkrBp)))(args);
            completeFieldName += "(" + stringifiedArgs + ")";
        }
        if (directives) Object.keys(directives).forEach(function(key) {
            if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
            if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            else completeFieldName += "@" + key;
        });
        return completeFieldName;
    }
    function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
        if (field.arguments && field.arguments.length) {
            var argObj_1 = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
            });
            return argObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
        return field.alias ? field.alias.value : field.name.value;
    }
    function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
        return selection.kind === 'Field';
    }
    function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
        return selection.kind === 'InlineFragment';
    }
    function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
        return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
    }
    function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
        if (generated === void 0) generated = false;
        return (0, (0, parcelRequire("3VFsf")).__assign)({
            type: 'id',
            generated: generated
        }, typeof idConfig === 'string' ? {
            id: idConfig,
            typename: undefined
        } : idConfig);
    }
    function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
        return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
    }
    function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
        throw new (0, $1DiV8.InvariantError)(18);
    }
    function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
        if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
        switch(node.kind){
            case 'Variable':
                return onVariable(node);
            case 'NullValue':
                return null;
            case 'IntValue':
                return parseInt(node.value, 10);
            case 'FloatValue':
                return parseFloat(node.value);
            case 'ListValue':
                return node.values.map(function(v) {
                    return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
                });
            case 'ObjectValue':
                var value = {};
                for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                    var field = _a[_i];
                    value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
                }
                return value;
            default:
                return node.value;
        }
    }
    function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
        if (field.directives && field.directives.length) {
            var directiveObj_1 = {};
            field.directives.forEach(function(directive) {
                directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
            });
            return directiveObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
        if (variables === void 0) variables = {};
        return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
            var directive = _a.directive, ifArgument = _a.ifArgument;
            var evaledValue = false;
            if (ifArgument.value.kind === 'Variable') {
                evaledValue = variables[ifArgument.value.name.value];
                (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
            } else evaledValue = ifArgument.value.value;
            return directive.name.value === 'skip' ? !evaledValue : evaledValue;
        });
    }
    function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
        var names = [];
        (0, (0, parcelRequire("12QNw")).visit)(doc, {
            Directive: function(node) {
                names.push(node.name.value);
            }
        });
        return names;
    }
    function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
        return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
            return names.indexOf(name) > -1;
        });
    }
    function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
        return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'client'
        ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'export'
        ], document);
    }
    function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
        var value = _a.name.value;
        return value === 'skip' || value === 'include';
    }
    function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
        return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
            var ifArgument = directiveArguments[0];
            (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
            var ifValue = ifArgument.value;
            (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
            return {
                directive: directive,
                ifArgument: ifArgument
            };
        }) : [];
    }
    function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
        var actualFragmentName = fragmentName;
        var fragments = [];
        document.definitions.forEach(function(definition) {
            if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
            if (definition.kind === 'FragmentDefinition') fragments.push(definition);
        });
        if (typeof actualFragmentName === 'undefined') {
            (0, $1DiV8.invariant)(fragments.length === 1, 12);
            actualFragmentName = fragments[0].name.value;
        }
        var query = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, document), {
            definitions: (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {
                    kind: 'OperationDefinition',
                    operation: 'query',
                    selectionSet: {
                        kind: 'SelectionSet',
                        selections: [
                            {
                                kind: 'FragmentSpread',
                                name: {
                                    kind: 'Name',
                                    value: actualFragmentName
                                }
                            }
                        ]
                    }
                }
            ], document.definitions)
        });
        return query;
    }
    function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
        var sources = [];
        for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
        sources.forEach(function(source) {
            if (typeof source === 'undefined' || source === null) return;
            Object.keys(source).forEach(function(key) {
                target[key] = source[key];
            });
        });
        return target;
    }
    function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var mutationDef = doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
        })[0];
        (0, $1DiV8.invariant)(mutationDef, 1);
        return mutationDef;
    }
    function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
        (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
        var operations = doc.definitions.filter(function(d) {
            return d.kind !== 'FragmentDefinition';
        }).map(function(definition) {
            if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
            return definition;
        });
        (0, $1DiV8.invariant)(operations.length <= 1, 4);
        return doc;
    }
    function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition';
        })[0];
    }
    function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
        var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
        (0, $1DiV8.invariant)(def, 5);
        return def;
    }
    function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.name;
        }).map(function(x) {
            return x.name.value;
        })[0] || null;
    }
    function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'FragmentDefinition';
        });
    }
    function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
        var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
        (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
        return queryDef;
    }
    function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
        (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
        (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
        var fragmentDef = doc.definitions[0];
        (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
        return fragmentDef;
    }
    function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
        var fragmentDefinition;
        for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === 'OperationDefinition') {
                var operation = definition.operation;
                if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
            }
            if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
        }
        if (fragmentDefinition) return fragmentDefinition;
        throw new (0, $1DiV8.InvariantError)(10);
    }
    function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
        if (fragments === void 0) fragments = [];
        var symTable = {};
        fragments.forEach(function(fragment) {
            symTable[fragment.name.value] = fragment;
        });
        return symTable;
    }
    function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
        if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
            var defaultValues = definition.variableDefinitions.filter(function(_a) {
                var defaultValue = _a.defaultValue;
                return defaultValue;
            }).map(function(_a) {
                var variable = _a.variable, defaultValue = _a.defaultValue;
                var defaultValueObj = {};
                $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
                return defaultValueObj;
            });
            return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {}
            ], defaultValues));
        }
        return {};
    }
    function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
        var names = new Set();
        if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
        return names;
    }
    function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
        var target = 0;
        array.forEach(function(elem, i) {
            if (test.call(this, elem, i, array)) array[target++] = elem;
        }, context);
        array.length = target;
        return array;
    }
    var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
        kind: 'Field',
        name: {
            kind: 'Name',
            value: '__typename'
        }
    };
    function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
        return op.selectionSet.selections.every(function(selection) {
            return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
        });
    }
    function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
        return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
    }
    function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
        return function directiveMatcher(directive) {
            return directives.some(function(dir) {
                return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
            });
        };
    }
    function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
        var variablesInUse = Object.create(null);
        var variablesToRemove = [];
        var fragmentSpreadsInUse = Object.create(null);
        var fragmentSpreadsToRemove = [];
        var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            Variable: {
                enter: function(node, _key, parent) {
                    if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
                }
            },
            Field: {
                enter: function(node) {
                    if (directives && node.directives) {
                        var shouldRemoveField = directives.some(function(directive) {
                            return directive.remove;
                        });
                        if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                            if (node.arguments) node.arguments.forEach(function(arg) {
                                if (arg.value.kind === 'Variable') variablesToRemove.push({
                                    name: arg.value.name.value
                                });
                            });
                            if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value
                                });
                            });
                            return null;
                        }
                    }
                }
            },
            FragmentSpread: {
                enter: function(node) {
                    fragmentSpreadsInUse[node.name.value] = true;
                }
            },
            Directive: {
                enter: function(node) {
                    if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
                }
            }
        }));
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
            return !variablesInUse[v.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
            return !fragmentSpreadsInUse[fs.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
        return (0, (0, parcelRequire("12QNw")).visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
            SelectionSet: {
                enter: function(node, _key, parent) {
                    if (parent && parent.kind === 'OperationDefinition') return;
                    var selections = node.selections;
                    if (!selections) return;
                    var skip = selections.some(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                    });
                    if (skip) return;
                    var field = parent;
                    if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                        return d.name.value === 'export';
                    })) return;
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        selections: (0, (0, parcelRequire("3VFsf")).__spreadArrays)(selections, [
                            $e1dfb923a27ca793$var$TYPENAME_FIELD
                        ])
                    });
                }
            }
        });
    }
    var $e1dfb923a27ca793$var$connectionRemoveConfig = {
        test: function(directive) {
            var willRemove = directive.name.value === 'connection';
            if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            });
            return willRemove;
        }
    };
    function $e1dfb923a27ca793$export$74985f3324559867(doc) {
        return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            $e1dfb923a27ca793$var$connectionRemoveConfig
        ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
        });
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
        if (!selection.directives) return false;
        return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
    }
    function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var parentPath;
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            SelectionSet: {
                enter: function(node, _key, _parent, path) {
                    var currentPath = path.join('-');
                    if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                        if (node.selections) {
                            var selectionsWithDirectives = node.selections.filter(function(selection) {
                                return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                            });
                            if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                                selections: selectionsWithDirectives
                            });
                        } else return null;
                    }
                }
            }
        }));
    }
    function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
        return function argumentMatcher(argument) {
            return config.some(function(aConfig) {
                return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
            });
        };
    }
    function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
        var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return !config.some(function(arg) {
                                return arg.name === varDef.variable.name.value;
                            });
                        })
                    });
                }
            },
            Field: {
                enter: function(node) {
                    var shouldRemoveField = config.some(function(argConfig) {
                        return argConfig.remove;
                    });
                    if (shouldRemoveField) {
                        var argMatchCount_1 = 0;
                        node.arguments.forEach(function(arg) {
                            if (argMatcher(arg)) argMatchCount_1 += 1;
                        });
                        if (argMatchCount_1 === 1) return null;
                    }
                }
            },
            Argument: {
                enter: function(node) {
                    if (argMatcher(node)) return null;
                }
            }
        }));
    }
    function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
        function enter(node) {
            if (config.some(function(def) {
                return def.name === node.name.value;
            })) return null;
        }
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            FragmentSpread: {
                enter: enter
            },
            FragmentDefinition: {
                enter: enter
            }
        }));
    }
    function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
        var allFragments = [];
        selectionSet.selections.forEach(function(selection) {
            if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
                return allFragments.push(frag);
            });
            else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
        });
        return allFragments;
    }
    function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
        var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
        var definitionOperation = definition.operation;
        if (definitionOperation === 'query') return document;
        var modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(document, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        operation: 'query'
                    });
                }
            }
        });
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
        var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            {
                test: function(directive) {
                    return directive.name.value === 'client';
                },
                remove: true
            }
        ], document);
        if (modifiedDoc) modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(modifiedDoc, {
            FragmentDefinition: {
                enter: function(node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                            return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) return null;
                    }
                }
            }
        });
        return modifiedDoc;
    }
    var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
    var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
    function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
        return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
    }
    function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
        switch($e1dfb923a27ca793$var$toString.call(val)){
            case "[object Array]":
                if (seen.has(val)) return seen.get(val);
                var copy_1 = val.slice(0);
                seen.set(val, copy_1);
                copy_1.forEach(function(child, i) {
                    copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
                });
                return copy_1;
            case "[object Object]":
                if (seen.has(val)) return seen.get(val);
                var copy_2 = Object.create(Object.getPrototypeOf(val));
                seen.set(val, copy_2);
                Object.keys(val).forEach(function(key) {
                    copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
                });
                return copy_2;
            default:
                return val;
        }
    }
    function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
        if (typeof $6cAn5 !== 'undefined' && "production") return "production";
        return 'development';
    }
    function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
        return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
    }
    function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
    }
    function $e1dfb923a27ca793$export$df77466336fe5355() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
    }
    function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
    }
    function $e1dfb923a27ca793$export$50a91acae4904909(f) {
        try {
            return f();
        } catch (e) {
            if (console.error) console.error(e);
        }
    }
    function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
        return result.errors && result.errors.length;
    }
    function $e1dfb923a27ca793$var$deepFreeze(o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function(prop) {
            if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
        });
        return o;
    }
    function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
        if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
            var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
            if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
        }
        return obj;
    }
    var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    function $e1dfb923a27ca793$export$dd702b3c8240390c() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        return $e1dfb923a27ca793$export$160070228be94b08(sources);
    }
    function $e1dfb923a27ca793$export$160070228be94b08(sources) {
        var target = sources[0] || {};
        var count = sources.length;
        if (count > 1) {
            var pastCopies = [];
            target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
        }
        return target;
    }
    function $e1dfb923a27ca793$var$isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }
    function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
        if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
            if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            Object.keys(source).forEach(function(sourceKey) {
                var sourceValue = source[sourceKey];
                if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                } else target[sourceKey] = sourceValue;
            });
            return target;
        }
        return source;
    }
    function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
        if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, (0, parcelRequire("3VFsf")).__assign)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            pastCopies.push(value);
        }
        return value;
    }
    var $e1dfb923a27ca793$var$haveWarned = Object.create({});
    function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
        if (type === void 0) type = 'warn';
        if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
            if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
            if (type === 'error') console.error(msg);
            else console.warn(msg);
        }
    }
    function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
        return JSON.parse(JSON.stringify(data));
    }
});
parcelRegister("fkrBp", function(module, exports) {
    'use strict';
    module.exports = function(data, opts) {
        if (!opts) opts = {};
        if (typeof opts === 'function') opts = {
            cmp: opts
        };
        var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
        var cmp = opts.cmp && function(f) {
            return function(node) {
                return function(a, b) {
                    var aobj = {
                        key: a,
                        value: node[a]
                    };
                    var bobj = {
                        key: b,
                        value: node[b]
                    };
                    return f(aobj, bobj);
                };
            };
        }(opts.cmp);
        var seen = [];
        return function stringify(node) {
            if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
            if (node === undefined) return;
            if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
            if (typeof node !== 'object') return JSON.stringify(node);
            var i, out;
            if (Array.isArray(node)) {
                out = '[';
                for(i = 0; i < node.length; i++){
                    if (i) out += ',';
                    out += stringify(node[i]) || 'null';
                }
                return out + ']';
            }
            if (node === null) return 'null';
            if (seen.indexOf(node) !== -1) {
                if (cycles) return JSON.stringify('__cycle__');
                throw new TypeError('Converting circular structure to JSON');
            }
            var seenIndex = seen.push(node) - 1;
            var keys = Object.keys(node).sort(cmp && cmp(node));
            out = '';
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                var value = stringify(node[key]);
                if (!value) continue;
                if (out) out += ',';
                out += JSON.stringify(key) + ':' + value;
            }
            seen.splice(seenIndex, 1);
            return '{' + out + '}';
        }(data);
    };
});
parcelRegister("bqMzA", function(module, exports) {
    $parcel$export(module.exports, "equal", ()=>$8527cd05038b1b96$export$411ce8e5a71e3069);
    var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
    var $8527cd05038b1b96$var$previousComparisons = new Map();
    function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
        try {
            return $8527cd05038b1b96$var$check(a, b);
        } finally{
            $8527cd05038b1b96$var$previousComparisons.clear();
        }
    }
    function $8527cd05038b1b96$var$check(a, b) {
        if (a === b) return true;
        var aTag = $8527cd05038b1b96$var$toString.call(a);
        var bTag = $8527cd05038b1b96$var$toString.call(b);
        if (aTag !== bTag) return false;
        switch(aTag){
            case '[object Array]':
                if (a.length !== b.length) return false;
            case '[object Object]':
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aKeys = Object.keys(a);
                var bKeys = Object.keys(b);
                var keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                for(var k = 0; k < keyCount; ++k){
                    if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                for(var k = 0; k < keyCount; ++k){
                    var key = aKeys[k];
                    if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
                }
                return true;
            case '[object Error]':
                return a.name === b.name && a.message === b.message;
            case '[object Number]':
                if (a !== a) return b !== b;
            case '[object Boolean]':
            case '[object Date]':
                return +a === +b;
            case '[object RegExp]':
            case '[object String]':
                return a == "" + b;
            case '[object Map]':
            case '[object Set]':
                if (a.size !== b.size) return false;
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aIterator = a.entries();
                var isMap = aTag === '[object Map]';
                while(true){
                    var info = aIterator.next();
                    if (info.done) break;
                    var _a = info.value, aKey = _a[0], aValue = _a[1];
                    if (!b.has(aKey)) return false;
                    if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
        }
        return false;
    }
    function $8527cd05038b1b96$var$previouslyCompared(a, b) {
        var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
        if (bSet) {
            if (bSet.has(b)) return true;
        } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
        bSet.add(b);
        return false;
    }
    var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("e3a3O", function(module, exports) {
    $parcel$export(module.exports, "NetworkStatus", ()=>$02a3c2aebc919401$export$bd096ddbd246c79c);
    $parcel$export(module.exports, "ApolloError", ()=>$02a3c2aebc919401$export$26a337512320b8c6);
    $parcel$export(module.exports, "ApolloClient", ()=>$02a3c2aebc919401$export$13f5a5f0f1dbab88);
    $parcel$export(module.exports, "default", ()=>$02a3c2aebc919401$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $clSzL;
    var $aS6b9;
    var $ebaCz = parcelRequire("ebaCz");
    var $1DiV8 = parcelRequire("1DiV8");
    var $12QNw;
    var $02a3c2aebc919401$export$bd096ddbd246c79c;
    (function(NetworkStatus) {
        NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
        NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
        NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
        NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
        NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
        NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
        NetworkStatus[NetworkStatus["error"] = 8] = "error";
    })($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
    function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
        return networkStatus < 7;
    }
    var $02a3c2aebc919401$var$Observable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Observable, _super);
        function Observable() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Observable.prototype[0, $ebaCz.default] = function() {
            return this;
        };
        Observable.prototype['@@observable'] = function() {
            return this;
        };
        return Observable;
    }((0, (0, parcelRequire("aS6b9")).default));
    function $02a3c2aebc919401$var$isNonEmptyArray(value) {
        return Array.isArray(value) && value.length > 0;
    }
    function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
        return err.hasOwnProperty('graphQLErrors');
    }
    var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
        var message = '';
        if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
            var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
        if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
        message = message.replace(/\n$/, '');
        return message;
    };
    var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ApolloError, _super);
        function ApolloError(_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
            var _this = _super.call(this, errorMessage) || this;
            _this.graphQLErrors = graphQLErrors || [];
            _this.networkError = networkError || null;
            if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
            else _this.message = errorMessage;
            _this.extraInfo = extraInfo;
            _this.__proto__ = ApolloError.prototype;
            return _this;
        }
        return ApolloError;
    }(Error);
    var $02a3c2aebc919401$export$160bafb6ac1e0641;
    (function(FetchType) {
        FetchType[FetchType["normal"] = 1] = "normal";
        FetchType[FetchType["refetch"] = 2] = "refetch";
        FetchType[FetchType["poll"] = 3] = "poll";
    })($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
    var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
        if (policy === void 0) policy = 'none';
        return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
    };
    var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ObservableQuery, _super);
        function ObservableQuery(_a) {
            var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
            var _this = _super.call(this, function(observer) {
                return _this.onSubscribe(observer);
            }) || this;
            _this.observers = new Set();
            _this.subscriptions = new Set();
            _this.isTornDown = false;
            _this.options = options;
            _this.variables = options.variables || {};
            _this.queryId = queryManager.generateQueryId();
            _this.shouldSubscribe = shouldSubscribe;
            var opDef = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(options.query);
            _this.queryName = opDef && opDef.name && opDef.name.value;
            _this.queryManager = queryManager;
            return _this;
        }
        ObservableQuery.prototype.result = function() {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var observer = {
                    next: function(result) {
                        resolve(result);
                        _this.observers.delete(observer);
                        if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                        setTimeout(function() {
                            subscription.unsubscribe();
                        }, 0);
                    },
                    error: reject
                };
                var subscription = _this.subscribe(observer);
            });
        };
        ObservableQuery.prototype.currentResult = function() {
            var result = this.getCurrentResult();
            if (result.data === undefined) result.data = {};
            return result;
        };
        ObservableQuery.prototype.getCurrentResult = function() {
            if (this.isTornDown) {
                var lastResult = this.lastResult;
                return {
                    data: !this.lastError && lastResult && lastResult.data || void 0,
                    error: this.lastError,
                    loading: false,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
                };
            }
            var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
            var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
            var result;
            var fetchPolicy = this.options.fetchPolicy;
            var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
            if (queryStoreValue) {
                var networkStatus = queryStoreValue.networkStatus;
                if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError
                    })
                };
                if (queryStoreValue.variables) {
                    this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), queryStoreValue.variables);
                    this.variables = this.options.variables;
                }
                result = {
                    data: data,
                    loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                    networkStatus: networkStatus
                };
                if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
            } else {
                var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
                result = {
                    data: data,
                    loading: loading,
                    networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
                };
            }
            if (!partial) this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                stale: false
            }));
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                partial: partial
            });
        };
        ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
            var snapshot = this.lastResultSnapshot;
            return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
        };
        ObservableQuery.prototype.getLastResult = function() {
            return this.lastResult;
        };
        ObservableQuery.prototype.getLastError = function() {
            return this.lastError;
        };
        ObservableQuery.prototype.resetLastResults = function() {
            delete this.lastResult;
            delete this.lastResultSnapshot;
            delete this.lastError;
            this.isTornDown = false;
        };
        ObservableQuery.prototype.resetQueryStoreErrors = function() {
            var queryStore = this.queryManager.queryStore.get(this.queryId);
            if (queryStore) {
                queryStore.networkError = null;
                queryStore.graphQLErrors = [];
            }
        };
        ObservableQuery.prototype.refetch = function(variables) {
            var fetchPolicy = this.options.fetchPolicy;
            if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
            if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), variables);
            if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), this.variables);
            return this.queryManager.fetchQuery(this.queryId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), {
                fetchPolicy: fetchPolicy
            }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
        };
        ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
            var _this = this;
            (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
            var combinedOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), fetchMoreOptions), {
                variables: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), fetchMoreOptions.variables)
            })), {
                fetchPolicy: 'network-only'
            });
            var qid = this.queryManager.generateQueryId();
            return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
                _this.updateQuery(function(previousResult) {
                    return fetchMoreOptions.updateQuery(previousResult, {
                        fetchMoreResult: fetchMoreResult.data,
                        variables: combinedOptions.variables
                    });
                });
                _this.queryManager.stopQuery(qid);
                return fetchMoreResult;
            }, function(error) {
                _this.queryManager.stopQuery(qid);
                throw error;
            });
        };
        ObservableQuery.prototype.subscribeToMore = function(options) {
            var _this = this;
            var subscription = this.queryManager.startGraphQLSubscription({
                query: options.document,
                variables: options.variables
            }).subscribe({
                next: function(subscriptionData) {
                    var updateQuery = options.updateQuery;
                    if (updateQuery) _this.updateQuery(function(previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables
                        });
                    });
                },
                error: function(err) {
                    if (options.onError) {
                        options.onError(err);
                        return;
                    }
                }
            });
            this.subscriptions.add(subscription);
            return function() {
                if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
            };
        };
        ObservableQuery.prototype.setOptions = function(opts) {
            var oldFetchPolicy = this.options.fetchPolicy;
            this.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), opts);
            if (opts.pollInterval) this.startPolling(opts.pollInterval);
            else if (opts.pollInterval === 0) this.stopPolling();
            var fetchPolicy = opts.fetchPolicy;
            return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
        };
        ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
            if (tryFetch === void 0) tryFetch = false;
            if (fetchResults === void 0) fetchResults = true;
            this.isTornDown = false;
            variables = variables || this.variables;
            if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
            this.variables = this.options.variables = variables;
            if (!this.observers.size) return Promise.resolve();
            return this.queryManager.fetchQuery(this.queryId, this.options);
        };
        ObservableQuery.prototype.updateQuery = function(mapFn) {
            var queryManager = this.queryManager;
            var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
            var newResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                return mapFn(previousResult, {
                    variables: variables
                });
            });
            if (newResult) {
                queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
                queryManager.broadcastQueries();
            }
        };
        ObservableQuery.prototype.stopPolling = function() {
            this.queryManager.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
        };
        ObservableQuery.prototype.startPolling = function(pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            this.options.pollInterval = pollInterval;
            this.queryManager.startPollingQuery(this.options, this.queryId);
        };
        ObservableQuery.prototype.updateLastResult = function(newResult) {
            var previousResult = this.lastResult;
            this.lastResult = newResult;
            this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, (0, parcelRequire("jojW6")).cloneDeep)(newResult);
            return previousResult;
        };
        ObservableQuery.prototype.onSubscribe = function(observer) {
            var _this = this;
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !this.observers.size;
            this.observers.add(observer);
            if (observer.next && this.lastResult) observer.next(this.lastResult);
            if (observer.error && this.lastError) observer.error(this.lastError);
            if (first) this.setUpQuery();
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        };
        ObservableQuery.prototype.setUpQuery = function() {
            var _this = this;
            var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
            if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
            if (this.options.pollInterval) {
                $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
                queryManager.startPollingQuery(this.options, queryId);
            }
            var onError = function(error) {
                _this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, _this.lastResult), {
                    errors: error.graphQLErrors,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                    loading: false
                }));
                $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
            };
            queryManager.observeQuery(queryId, this.options, {
                next: function(result) {
                    if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                        var previousResult_1 = _this.updateLastResult(result);
                        var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                        if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                            else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                        });
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    }
                },
                error: onError
            }).catch(onError);
        };
        ObservableQuery.prototype.tearDownQuery = function() {
            var queryManager = this.queryManager;
            this.isTornDown = true;
            queryManager.stopPollingQuery(this.queryId);
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this.subscriptions.clear();
            queryManager.removeObservableQuery(this.queryId);
            queryManager.stopQuery(this.queryId);
            this.observers.clear();
        };
        return ObservableQuery;
    }($02a3c2aebc919401$var$Observable);
    function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
    function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
        var observersWithMethod = [];
        observers.forEach(function(obs) {
            return obs[method] && observersWithMethod.push(obs);
        });
        observersWithMethod.forEach(function(obs) {
            return obs[method](argument);
        });
    }
    function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
        var fetchPolicy = obsQuery.options.fetchPolicy;
        (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
    }
    var $02a3c2aebc919401$var$MutationStore = function() {
        function MutationStore() {
            this.store = {};
        }
        MutationStore.prototype.getStore = function() {
            return this.store;
        };
        MutationStore.prototype.get = function(mutationId) {
            return this.store[mutationId];
        };
        MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
            this.store[mutationId] = {
                mutation: mutation,
                variables: variables || {},
                loading: true,
                error: null
            };
        };
        MutationStore.prototype.markMutationError = function(mutationId, error) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = error;
            }
        };
        MutationStore.prototype.markMutationResult = function(mutationId) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = null;
            }
        };
        MutationStore.prototype.reset = function() {
            this.store = {};
        };
        return MutationStore;
    }();
    var $02a3c2aebc919401$var$QueryStore = function() {
        function QueryStore() {
            this.store = {};
        }
        QueryStore.prototype.getStore = function() {
            return this.store;
        };
        QueryStore.prototype.get = function(queryId) {
            return this.store[queryId];
        };
        QueryStore.prototype.initQuery = function(query) {
            var previousQuery = this.store[query.queryId];
            (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
            var isSetVariables = false;
            var previousVariables = null;
            if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
                if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                    isSetVariables = true;
                    previousVariables = previousQuery.variables;
                }
            }
            var networkStatus;
            if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
            else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
            else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
            else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            var graphQLErrors = [];
            if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
            this.store[query.queryId] = {
                document: query.document,
                variables: query.variables,
                previousVariables: previousVariables,
                networkError: null,
                graphQLErrors: graphQLErrors,
                networkStatus: networkStatus,
                metadata: query.metadata
            };
            if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
        };
        QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = null;
            this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
            this.store[queryId].previousVariables = null;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        };
        QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = error;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
            if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
        };
        QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
            var storeValue = this.store && this.store[queryId];
            if (storeValue) {
                storeValue.networkError = null;
                storeValue.previousVariables = null;
                if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            }
        };
        QueryStore.prototype.stopQuery = function(queryId) {
            delete this.store[queryId];
        };
        QueryStore.prototype.reset = function(observableQueryIds) {
            var _this = this;
            Object.keys(this.store).forEach(function(queryId) {
                if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
                else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            });
        };
        return QueryStore;
    }();
    function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    var $02a3c2aebc919401$var$LocalState = function() {
        function LocalState(_a) {
            var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
            this.cache = cache;
            if (client) this.client = client;
            if (resolvers) this.addResolvers(resolvers);
            if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
        }
        LocalState.prototype.addResolvers = function(resolvers) {
            var _this = this;
            this.resolvers = this.resolvers || {};
            if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
                _this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(_this.resolvers, resolverGroup);
            });
            else this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(this.resolvers, resolvers);
        };
        LocalState.prototype.setResolvers = function(resolvers) {
            this.resolvers = {};
            this.addResolvers(resolvers);
        };
        LocalState.prototype.getResolvers = function() {
            return this.resolvers || {};
        };
        LocalState.prototype.runResolvers = function(_a) {
            var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_c) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, remoteResult), {
                                data: localResult.result
                            });
                        })
                    ];
                    return [
                        2,
                        remoteResult
                    ];
                });
            });
        };
        LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
            this.fragmentMatcher = fragmentMatcher;
        };
        LocalState.prototype.getFragmentMatcher = function() {
            return this.fragmentMatcher;
        };
        LocalState.prototype.clientQuery = function(document) {
            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                'client'
            ], document)) {
                if (this.resolvers) return document;
            }
            return null;
        };
        LocalState.prototype.serverQuery = function(document) {
            return this.resolvers ? (0, (0, parcelRequire("jojW6")).removeClientSetsFromDocument)(document) : document;
        };
        LocalState.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var cache = this.cache;
            var newContext = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                cache: cache,
                getCacheKey: function(obj) {
                    if (cache.config) return cache.config.dataIdFromObject(obj);
                    else (0, $1DiV8.invariant)(false, 6);
                }
            });
            return newContext;
        };
        LocalState.prototype.addExportedVariables = function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, variables), data.exportedVariables);
                        })
                    ];
                    return [
                        2,
                        (0, (0, parcelRequire("3VFsf")).__assign)({}, variables)
                    ];
                });
            });
        };
        LocalState.prototype.shouldForceResolvers = function(document) {
            var forceResolvers = false;
            (0, (0, parcelRequire("12QNw")).visit)(document, {
                Directive: {
                    enter: function(node) {
                        if (node.name.value === 'client' && node.arguments) {
                            forceResolvers = node.arguments.some(function(arg) {
                                return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                            });
                            if (forceResolvers) return 0, (0, parcelRequire("12QNw")).BREAK;
                        }
                    }
                }
            });
            return forceResolvers;
        };
        LocalState.prototype.buildRootValueFromCache = function(document, variables) {
            return this.cache.diff({
                query: (0, (0, parcelRequire("jojW6")).buildQueryFromSelectionSet)(document),
                variables: variables,
                returnPartialData: true,
                optimistic: false
            }).result;
        };
        LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                    mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(document);
                    fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document);
                    fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
                    definitionOperation = mainDefinition.operation;
                    defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                    _a = this, cache = _a.cache, client = _a.client;
                    execContext = {
                        fragmentMap: fragmentMap,
                        context: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                            cache: cache,
                            client: client
                        }),
                        variables: variables,
                        fragmentMatcher: fragmentMatcher,
                        defaultOperationType: defaultOperationType,
                        exportedVariables: {},
                        onlyRunForcedResolvers: onlyRunForcedResolvers
                    };
                    return [
                        2,
                        this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                            return {
                                result: result,
                                exportedVariables: execContext.exportedVariables
                            };
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var fragmentMap, context, variables, resultsToMerge, execute;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                    resultsToMerge = [
                        rootValue
                    ];
                    execute = function(selection) {
                        return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                            var fragment, typeCondition;
                            return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return [
                                    2
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) return [
                                    2,
                                    this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                        var _a;
                                        if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                                    })
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                                else {
                                    fragment = fragmentMap[selection.name.value];
                                    (0, $1DiV8.invariant)(fragment, 7);
                                }
                                if (fragment && fragment.typeCondition) {
                                    typeCondition = fragment.typeCondition.name.value;
                                    if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                        2,
                                        this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                            resultsToMerge.push(fragmentResult);
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                            });
                        });
                    };
                    return [
                        2,
                        Promise.all(selectionSet.selections.map(execute)).then(function() {
                            return (0, (0, parcelRequire("jojW6")).mergeDeepArray)(resultsToMerge);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveField = function(field, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    variables = execContext.variables;
                    fieldName = field.name.value;
                    aliasedFieldName = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field);
                    aliasUsed = fieldName !== aliasedFieldName;
                    defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                    resultPromise = Promise.resolve(defaultResult);
                    if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                        resolverType = rootValue.__typename || execContext.defaultOperationType;
                        resolverMap = this.resolvers && this.resolvers[resolverType];
                        if (resolverMap) {
                            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                            if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables), execContext.context, {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }));
                        }
                    }
                    return [
                        2,
                        resultPromise.then(function(result) {
                            if (result === void 0) result = defaultResult;
                            if (field.directives) field.directives.forEach(function(directive) {
                                if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                    if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                                });
                            });
                            if (!field.selectionSet) return result;
                            if (result == null) return result;
                            if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
            var _this = this;
            return Promise.all(result.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
                if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }));
        };
        return LocalState;
    }();
    function $02a3c2aebc919401$var$multiplex(inner) {
        var observers = new Set();
        var sub = null;
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            observers.add(observer);
            sub = sub || inner.subscribe({
                next: function(value) {
                    observers.forEach(function(obs) {
                        return obs.next && obs.next(value);
                    });
                },
                error: function(error) {
                    observers.forEach(function(obs) {
                        return obs.error && obs.error(error);
                    });
                },
                complete: function() {
                    observers.forEach(function(obs) {
                        return obs.complete && obs.complete();
                    });
                }
            });
            return function() {
                if (observers.delete(observer) && !observers.size && sub) {
                    sub.unsubscribe();
                    sub = null;
                }
            };
        });
    }
    function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            var next = observer.next, error = observer.error, complete = observer.complete;
            var activeNextCount = 0;
            var completed = false;
            var handler = {
                next: function(value) {
                    ++activeNextCount;
                    new Promise(function(resolve) {
                        resolve(mapFn(value));
                    }).then(function(result) {
                        --activeNextCount;
                        next && next.call(observer, result);
                        completed && handler.complete();
                    }, function(e) {
                        --activeNextCount;
                        error && error.call(observer, e);
                    });
                },
                error: function(e) {
                    error && error.call(observer, e);
                },
                complete: function() {
                    completed = true;
                    if (!activeNextCount) complete && complete.call(observer);
                }
            };
            var sub = observable.subscribe(handler);
            return function() {
                return sub.unsubscribe();
            };
        });
    }
    var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $02a3c2aebc919401$var$QueryManager = function() {
        function QueryManager(_a) {
            var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
                return undefined;
            } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
            this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
            this.queryStore = new $02a3c2aebc919401$var$QueryStore();
            this.clientAwareness = {};
            this.idCounter = 1;
            this.queries = new Map();
            this.fetchQueryRejectFns = new Map();
            this.transformCache = new ((0, (0, parcelRequire("jojW6")).canUseWeakMap) ? WeakMap : Map)();
            this.inFlightLinkObservables = new Map();
            this.pollingInfoByQueryId = new Map();
            this.link = link;
            this.queryDeduplication = queryDeduplication;
            this.dataStore = store;
            this.onBroadcast = onBroadcast;
            this.clientAwareness = clientAwareness;
            this.localState = localState || new $02a3c2aebc919401$var$LocalState({
                cache: store.getCache()
            });
            this.ssrMode = ssrMode;
            this.assumeImmutableResults = !!assumeImmutableResults;
        }
        QueryManager.prototype.stop = function() {
            var _this = this;
            this.queries.forEach(function(_info, queryId) {
                _this.stopQueryNoBroadcast(queryId);
            });
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(8));
            });
        };
        QueryManager.prototype.mutate = function(_a) {
            var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mutationId, generateUpdateQueriesInfo, self;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            (0, $1DiV8.invariant)(mutation, 9);
                            (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                            mutationId = this.generateQueryId();
                            mutation = this.transform(mutation).document;
                            this.setQuery(mutationId, function() {
                                return {
                                    document: mutation
                                };
                            });
                            variables = this.getVariables(mutation, variables);
                            if (!this.transform(mutation).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(mutation, variables, context)
                            ];
                        case 1:
                            variables = _f.sent();
                            _f.label = 2;
                        case 2:
                            generateUpdateQueriesInfo = function() {
                                var ret = {};
                                if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                            updater: updateQueriesByName[queryName],
                                            query: _this.queryStore.get(queryId)
                                        };
                                    }
                                });
                                return ret;
                            };
                            this.mutationStore.initMutation(mutationId, mutation, variables);
                            this.dataStore.markMutationInit({
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                updateQueries: generateUpdateQueriesInfo(),
                                update: updateWithProxyFn,
                                optimisticResponse: optimisticResponse
                            });
                            this.broadcastQueries();
                            self = this;
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var storeResult;
                                    var error;
                                    self.getObservableFromLink(mutation, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                                        optimisticResponse: optimisticResponse
                                    }), variables, false).subscribe({
                                        next: function(result) {
                                            if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && errorPolicy === 'none') {
                                                error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                    graphQLErrors: result.errors
                                                });
                                                return;
                                            }
                                            self.mutationStore.markMutationResult(mutationId);
                                            if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn
                                            });
                                            storeResult = result;
                                        },
                                        error: function(err) {
                                            self.mutationStore.markMutationError(mutationId, err);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                                networkError: err
                                            }));
                                        },
                                        complete: function() {
                                            if (error) self.mutationStore.markMutationError(mutationId, error);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            if (error) {
                                                reject(error);
                                                return;
                                            }
                                            if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                            var refetchQueryPromises = [];
                                            if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                                if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                    var observableQuery = _a.observableQuery;
                                                    if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                                });
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only'
                                                    };
                                                    if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                            Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                                self.setQuery(mutationId, function() {
                                                    return {
                                                        document: null
                                                    };
                                                });
                                                if (errorPolicy === 'ignore' && storeResult && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                                resolve(storeResult);
                                            });
                                        }
                                    });
                                })
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                            query = this.transform(options.query).document;
                            variables = this.getVariables(query, options.variables);
                            if (!this.transform(query).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(query, variables, context)
                            ];
                        case 1:
                            variables = _e.sent();
                            _e.label = 2;
                        case 2:
                            options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                                variables: variables
                            });
                            isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                            needToFetch = isNetworkOnly;
                            if (!isNetworkOnly) {
                                _d = this.dataStore.getCache().diff({
                                    query: query,
                                    variables: variables,
                                    returnPartialData: true,
                                    optimistic: false
                                }), complete = _d.complete, result = _d.result;
                                needToFetch = !complete || fetchPolicy === 'cache-and-network';
                                storeResult = result;
                            }
                            shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                                'live'
                            ], query)) shouldFetch = true;
                            requestId = this.idCounter++;
                            cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                            this.setQuery(queryId, function() {
                                return {
                                    document: query,
                                    lastRequestId: requestId,
                                    invalidated: true,
                                    cancel: cancel
                                };
                            });
                            this.invalidate(fetchMoreForQueryId);
                            this.queryStore.initQuery({
                                queryId: queryId,
                                document: query,
                                storePreviousVariables: shouldFetch,
                                variables: variables,
                                isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                                isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                                metadata: metadata,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            });
                            this.broadcastQueries();
                            if (shouldFetch) {
                                networkResult = this.fetchRequest({
                                    requestId: requestId,
                                    queryId: queryId,
                                    document: query,
                                    options: options,
                                    fetchMoreForQueryId: fetchMoreForQueryId
                                }).catch(function(error) {
                                    if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                    else {
                                        if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                            _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                            _this.invalidate(queryId);
                                            _this.invalidate(fetchMoreForQueryId);
                                            _this.broadcastQueries();
                                        }
                                        throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: error
                                        });
                                    }
                                });
                                if (fetchPolicy !== 'cache-and-network') return [
                                    2,
                                    networkResult
                                ];
                                networkResult.catch(function() {});
                            }
                            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                            this.invalidate(queryId);
                            this.invalidate(fetchMoreForQueryId);
                            if (this.transform(query).hasForcedResolvers) return [
                                2,
                                this.localState.runResolvers({
                                    document: query,
                                    remoteResult: {
                                        data: storeResult
                                    },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true
                                }).then(function(result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })
                            ];
                            this.broadcastQueries();
                            return [
                                2,
                                {
                                    data: storeResult
                                }
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
            var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
            if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
                return {
                    newData: {
                        result: result.data,
                        complete: true
                    }
                };
            });
            else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        };
        QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
            var _this = this;
            function invoke(method, argument) {
                if (observer[method]) try {
                    observer[method](argument);
                } catch (e) {}
                else method;
            }
            return function(queryStoreValue, newData) {
                _this.invalidate(queryId, false);
                if (!queryStoreValue) return;
                var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
                var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
                if (fetchPolicy === 'standby') return;
                var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
                var lastResult = observableQuery && observableQuery.getLastResult();
                var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
                var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
                if (loading && !shouldNotifyIfLoading) return;
                var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
                var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
                if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                }));
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                            return {
                                newData: null
                            };
                        });
                        data = newData.result;
                        isMissing = !newData.complete;
                    } else {
                        var lastError = observableQuery && observableQuery.getLastError();
                        var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        } else {
                            var diffResult = _this.dataStore.getCache().diff({
                                query: document,
                                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                                returnPartialData: true,
                                optimistic: true
                            });
                            data = diffResult.result;
                            isMissing = !diffResult.complete;
                        }
                    }
                    var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                    var resultFromStore = {
                        data: stale ? lastResult && lastResult.data : data,
                        loading: loading,
                        networkStatus: queryStoreValue.networkStatus,
                        stale: stale
                    };
                    if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                    invoke('next', resultFromStore);
                } catch (networkError) {
                    invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                        networkError: networkError
                    }));
                }
            };
        };
        QueryManager.prototype.transform = function(document) {
            var transformCache = this.transformCache;
            if (!transformCache.has(document)) {
                var cache = this.dataStore.getCache();
                var transformed = cache.transformDocument(document);
                var forLink = (0, (0, parcelRequire("jojW6")).removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
                var clientQuery = this.localState.clientQuery(transformed);
                var serverQuery = this.localState.serverQuery(forLink);
                var cacheEntry_1 = {
                    document: transformed,
                    hasClientExports: (0, (0, parcelRequire("jojW6")).hasClientExports)(transformed),
                    hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                    clientQuery: clientQuery,
                    serverQuery: serverQuery,
                    defaultVars: (0, (0, parcelRequire("jojW6")).getDefaultValues)((0, (0, parcelRequire("jojW6")).getOperationDefinition)(transformed))
                };
                var add = function(doc) {
                    if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
                };
                add(document);
                add(transformed);
                add(clientQuery);
                add(serverQuery);
            }
            return transformCache.get(document);
        };
        QueryManager.prototype.getVariables = function(document, variables) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.transform(document).defaultVars), variables);
        };
        QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
            if (shouldSubscribe === void 0) shouldSubscribe = true;
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
            options.variables = this.getVariables(options.query, options.variables);
            if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
            var transformedOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, options);
            return new $02a3c2aebc919401$export$6c1b56eac59c9584({
                queryManager: this,
                options: transformedOptions,
                shouldSubscribe: shouldSubscribe
            });
        };
        QueryManager.prototype.query = function(options) {
            var _this = this;
            (0, $1DiV8.invariant)(options.query, 12);
            (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
            (0, $1DiV8.invariant)(!options.returnPartialData, 14);
            (0, $1DiV8.invariant)(!options.pollInterval, 15);
            return new Promise(function(resolve, reject) {
                var watchedQuery = _this.watchQuery(options, false);
                _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
                watchedQuery.result().then(resolve, reject).then(function() {
                    return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
                });
            });
        };
        QueryManager.prototype.generateQueryId = function() {
            return String(this.idCounter++);
        };
        QueryManager.prototype.stopQueryInStore = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
            this.stopPollingQuery(queryId);
            this.queryStore.stopQuery(queryId);
            this.invalidate(queryId);
        };
        QueryManager.prototype.addQueryListener = function(queryId, listener) {
            this.setQuery(queryId, function(_a) {
                var listeners = _a.listeners;
                listeners.add(listener);
                return {
                    invalidated: false
                };
            });
        };
        QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
            var _this = this;
            var cancel = this.getQuery(queryId).cancel;
            if (cancel) cancel();
            var previousResult = function() {
                var previousResult = null;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                if (observableQuery) {
                    var lastResult = observableQuery.getLastResult();
                    if (lastResult) previousResult = lastResult.data;
                }
                return previousResult;
            };
            return this.dataStore.getCache().watch({
                query: document,
                variables: options.variables,
                optimistic: true,
                previousResult: previousResult,
                callback: function(newData) {
                    _this.setQuery(queryId, function() {
                        return {
                            invalidated: true,
                            newData: newData
                        };
                    });
                }
            });
        };
        QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
            this.setQuery(queryId, function() {
                return {
                    observableQuery: observableQuery
                };
            });
        };
        QueryManager.prototype.removeObservableQuery = function(queryId) {
            var cancel = this.getQuery(queryId).cancel;
            this.setQuery(queryId, function() {
                return {
                    observableQuery: null
                };
            });
            if (cancel) cancel();
        };
        QueryManager.prototype.clearStore = function() {
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(16));
            });
            var resetIds = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) resetIds.push(queryId);
            });
            this.queryStore.reset(resetIds);
            this.mutationStore.reset();
            return this.dataStore.reset();
        };
        QueryManager.prototype.resetStore = function() {
            var _this = this;
            return this.clearStore().then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
            var _this = this;
            if (includeStandby === void 0) includeStandby = false;
            var observableQueryPromises = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) {
                    var fetchPolicy = observableQuery.options.fetchPolicy;
                    observableQuery.resetLastResults();
                    if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                    _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    _this.invalidate(queryId);
                }
            });
            this.broadcastQueries();
            return Promise.all(observableQueryPromises);
        };
        QueryManager.prototype.observeQuery = function(queryId, options, observer) {
            this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
            return this.fetchQuery(queryId, options);
        };
        QueryManager.prototype.startQuery = function(queryId, options, listener) {
            this.addQueryListener(queryId, listener);
            this.fetchQuery(queryId, options).catch(function() {
                return undefined;
            });
            return queryId;
        };
        QueryManager.prototype.startGraphQLSubscription = function(_a) {
            var _this = this;
            var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
            query = this.transform(query).document;
            variables = this.getVariables(query, variables);
            var makeObservable = function(variables) {
                return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                    if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                        _this.dataStore.markSubscriptionResult(result, query, variables);
                        _this.broadcastQueries();
                    }
                    if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    });
                    return result;
                });
            };
            if (this.transform(query).hasClientExports) {
                var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
                return new $02a3c2aebc919401$var$Observable(function(observer) {
                    var sub = null;
                    observablePromise_1.then(function(observable) {
                        return sub = observable.subscribe(observer);
                    }, observer.error);
                    return function() {
                        return sub && sub.unsubscribe();
                    };
                });
            }
            return makeObservable(variables);
        };
        QueryManager.prototype.stopQuery = function(queryId) {
            this.stopQueryNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.removeQuery(queryId);
        };
        QueryManager.prototype.removeQuery = function(queryId) {
            this.fetchQueryRejectFns.delete("query:" + queryId);
            this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
            this.getQuery(queryId).subscriptions.forEach(function(x) {
                return x.unsubscribe();
            });
            this.queries.delete(queryId);
        };
        QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
            if (optimistic === void 0) optimistic = true;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
            var lastResult = observableQuery.getLastResult();
            var newData = this.getQuery(observableQuery.queryId).newData;
            if (newData && newData.complete) return {
                data: newData.result,
                partial: false
            };
            if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
                data: undefined,
                partial: false
            };
            var _b = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                previousResult: lastResult ? lastResult.data : undefined,
                returnPartialData: true,
                optimistic: optimistic
            }), result = _b.result, complete = _b.complete;
            return {
                data: complete || returnPartialData ? result : void 0,
                partial: !complete
            };
        };
        QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
            var observableQuery;
            if (typeof queryIdOrObservable === 'string') {
                var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
                (0, $1DiV8.invariant)(foundObserveableQuery, 17);
                observableQuery = foundObserveableQuery;
            } else observableQuery = queryIdOrObservable;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query;
            return {
                previousResult: this.getCurrentQueryResult(observableQuery, false).data,
                variables: variables,
                document: query
            };
        };
        QueryManager.prototype.broadcastQueries = function() {
            var _this = this;
            this.onBroadcast();
            this.queries.forEach(function(info, id) {
                if (info.invalidated) info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            });
        };
        QueryManager.prototype.getLocalState = function() {
            return this.localState;
        };
        QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
            var _this = this;
            if (deduplication === void 0) deduplication = this.queryDeduplication;
            var observable;
            var serverQuery = this.transform(query).serverQuery;
            if (serverQuery) {
                var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
                var operation = {
                    query: serverQuery,
                    variables: variables,
                    operationName: (0, (0, parcelRequire("jojW6")).getOperationName)(serverQuery) || void 0,
                    context: this.prepareContext((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                        forceFetch: !deduplication
                    }))
                };
                context = operation.context;
                if (deduplication) {
                    var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                    inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                    var varJson_1 = JSON.stringify(variables);
                    observable = byVariables_1.get(varJson_1);
                    if (!observable) {
                        byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation)));
                        var cleanup = function() {
                            byVariables_1.delete(varJson_1);
                            if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                            cleanupSub_1.unsubscribe();
                        };
                        var cleanupSub_1 = observable.subscribe({
                            next: cleanup,
                            error: cleanup,
                            complete: cleanup
                        });
                    }
                } else observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation));
            } else {
                observable = $02a3c2aebc919401$var$Observable.of({
                    data: {}
                });
                context = this.prepareContext(context);
            }
            var clientQuery = this.transform(query).clientQuery;
            if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables
                });
            });
            return observable;
        };
        QueryManager.prototype.fetchRequest = function(_a) {
            var _this = this;
            var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
            var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
            var resultFromStore;
            var errorsFromStore;
            return new Promise(function(resolve, reject) {
                var observable = _this.getObservableFromLink(document, options.context, variables);
                var fqrfId = "fetchRequest:" + queryId;
                _this.fetchQueryRejectFns.set(fqrfId, reject);
                var cleanup = function() {
                    _this.fetchQueryRejectFns.delete(fqrfId);
                    _this.setQuery(queryId, function(_a) {
                        var subscriptions = _a.subscriptions;
                        subscriptions.delete(subscription);
                    });
                };
                var subscription = observable.map(function(result) {
                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                        _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(queryId);
                        _this.invalidate(fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    }));
                    if (errorPolicy === 'all') errorsFromStore = result.errors;
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                    else {
                        var _a = _this.dataStore.getCache().diff({
                            variables: variables,
                            query: document,
                            optimistic: false,
                            returnPartialData: true
                        }), result_1 = _a.result, complete = _a.complete;
                        if (complete || options.returnPartialData) resultFromStore = result_1;
                    }
                }).subscribe({
                    error: function(error) {
                        cleanup();
                        reject(error);
                    },
                    complete: function() {
                        cleanup();
                        resolve({
                            data: resultFromStore,
                            errors: errorsFromStore,
                            loading: false,
                            networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                            stale: false
                        });
                    }
                });
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.add(subscription);
                });
            });
        };
        QueryManager.prototype.getQuery = function(queryId) {
            return this.queries.get(queryId) || {
                listeners: new Set(),
                invalidated: false,
                document: null,
                newData: null,
                lastRequestId: 1,
                observableQuery: null,
                subscriptions: new Set()
            };
        };
        QueryManager.prototype.setQuery = function(queryId, updater) {
            var prev = this.getQuery(queryId);
            var newInfo = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, prev), updater(prev));
            this.queries.set(queryId, newInfo);
        };
        QueryManager.prototype.invalidate = function(queryId, invalidated) {
            if (invalidated === void 0) invalidated = true;
            if (queryId) this.setQuery(queryId, function() {
                return {
                    invalidated: invalidated
                };
            });
        };
        QueryManager.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var newContext = this.localState.prepareContext(context);
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, newContext), {
                clientAwareness: this.clientAwareness
            });
        };
        QueryManager.prototype.checkInFlight = function(queryId) {
            var query = this.queryStore.get(queryId);
            return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        };
        QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
            var _this = this;
            var pollInterval = options.pollInterval;
            (0, $1DiV8.invariant)(pollInterval, 18);
            if (!this.ssrMode) {
                var info = this.pollingInfoByQueryId.get(queryId);
                if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
                info.interval = pollInterval;
                info.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                    fetchPolicy: 'network-only'
                });
                var maybeFetch_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        if (_this.checkInFlight(queryId)) poll_1();
                        else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                    }
                };
                var poll_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        clearTimeout(info.timeout);
                        info.timeout = setTimeout(maybeFetch_1, info.interval);
                    }
                };
                if (listener) this.addQueryListener(queryId, listener);
                poll_1();
            }
            return queryId;
        };
        QueryManager.prototype.stopPollingQuery = function(queryId) {
            this.pollingInfoByQueryId.delete(queryId);
        };
        return QueryManager;
    }();
    var $02a3c2aebc919401$var$DataStore = function() {
        function DataStore(initialCache) {
            this.cache = initialCache;
        }
        DataStore.prototype.getCache = function() {
            return this.cache;
        };
        DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
            if (ignoreErrors === void 0) ignoreErrors = false;
            var writeWithErrors = !(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result);
            if (ignoreErrors && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && result.data) writeWithErrors = true;
            if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markMutationInit = function(mutation) {
            var _this = this;
            if (mutation.optimisticResponse) {
                var optimistic_1;
                if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
                else optimistic_1 = mutation.optimisticResponse;
                this.cache.recordOptimisticTransaction(function(c) {
                    var orig = _this.cache;
                    _this.cache = c;
                    try {
                        _this.markMutationResult({
                            mutationId: mutation.mutationId,
                            result: {
                                data: optimistic_1
                            },
                            document: mutation.document,
                            variables: mutation.variables,
                            updateQueries: mutation.updateQueries,
                            update: mutation.update
                        });
                    } finally{
                        _this.cache = orig;
                    }
                }, mutation.mutationId);
            }
        };
        DataStore.prototype.markMutationResult = function(mutation) {
            var _this = this;
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(mutation.result)) {
                var cacheWrites_1 = [
                    {
                        result: mutation.result.data,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables
                    }
                ];
                var updateQueries_1 = mutation.updateQueries;
                if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: (0, (0, parcelRequire("jojW6")).getOperationName)(query.document) || undefined,
                                queryVariables: query.variables
                            });
                        });
                        if (nextQueryResult) cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables
                        });
                    }
                });
                this.cache.performTransaction(function(c) {
                    cacheWrites_1.forEach(function(write) {
                        return c.write(write);
                    });
                    var update = mutation.update;
                    if (update) (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                        return update(c, mutation.result);
                    });
                });
            }
        };
        DataStore.prototype.markMutationComplete = function(_a) {
            var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
            if (optimisticResponse) this.cache.removeOptimistic(mutationId);
        };
        DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
            this.cache.write({
                result: newResult,
                dataId: 'ROOT_QUERY',
                variables: variables,
                query: document
            });
        };
        DataStore.prototype.reset = function() {
            return this.cache.reset();
        };
        return DataStore;
    }();
    var $02a3c2aebc919401$var$version = "2.6.10";
    var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
    var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
        function ApolloClient(options) {
            var _this = this;
            this.defaultOptions = {};
            this.resetStoreCallbacks = [];
            this.clearStoreCallbacks = [];
            var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
            var link = options.link;
            if (!link && resolvers) link = (0, (0, parcelRequire("clSzL")).ApolloLink).empty();
            if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
            this.link = link;
            this.cache = cache;
            this.store = new $02a3c2aebc919401$var$DataStore(cache);
            this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
            this.queryDeduplication = queryDeduplication;
            this.defaultOptions = defaultOptions || {};
            this.typeDefs = typeDefs;
            if (ssrForceFetchDelay) setTimeout(function() {
                return _this.disableNetworkFetches = false;
            }, ssrForceFetchDelay);
            this.watchQuery = this.watchQuery.bind(this);
            this.query = this.query.bind(this);
            this.mutate = this.mutate.bind(this);
            this.resetStore = this.resetStore.bind(this);
            this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
            var defaultConnectToDevTools = false;
            if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
            this.version = $02a3c2aebc919401$var$version;
            this.localState = new $02a3c2aebc919401$var$LocalState({
                cache: cache,
                client: this,
                resolvers: resolvers,
                fragmentMatcher: fragmentMatcher
            });
            this.queryManager = new $02a3c2aebc919401$var$QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: queryDeduplication,
                ssrMode: ssrMode,
                clientAwareness: {
                    name: clientAwarenessName,
                    version: clientAwarenessVersion
                },
                localState: this.localState,
                assumeImmutableResults: assumeImmutableResults,
                onBroadcast: function() {
                    if (_this.devToolsHookCb) _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore()
                        },
                        dataWithOptimisticResults: _this.cache.extract(true)
                    });
                }
            });
        }
        ApolloClient.prototype.stop = function() {
            this.queryManager.stop();
        };
        ApolloClient.prototype.watchQuery = function(options) {
            if (this.defaultOptions.watchQuery) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.watchQuery), options);
            if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.watchQuery(options);
        };
        ApolloClient.prototype.query = function(options) {
            if (this.defaultOptions.query) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.query), options);
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
            if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.query(options);
        };
        ApolloClient.prototype.mutate = function(options) {
            if (this.defaultOptions.mutate) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.mutate), options);
            return this.queryManager.mutate(options);
        };
        ApolloClient.prototype.subscribe = function(options) {
            return this.queryManager.startGraphQLSubscription(options);
        };
        ApolloClient.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readQuery(options, optimistic);
        };
        ApolloClient.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readFragment(options, optimistic);
        };
        ApolloClient.prototype.writeQuery = function(options) {
            var result = this.cache.writeQuery(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeFragment = function(options) {
            var result = this.cache.writeFragment(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeData = function(options) {
            var result = this.cache.writeData(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.__actionHookForDevTools = function(cb) {
            this.devToolsHookCb = cb;
        };
        ApolloClient.prototype.__requestRaw = function(payload) {
            return (0, (0, parcelRequire("clSzL")).execute)(this.link, payload);
        };
        ApolloClient.prototype.initQueryManager = function() {
            return this.queryManager;
        };
        ApolloClient.prototype.resetStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            }).then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        ApolloClient.prototype.clearStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            });
        };
        ApolloClient.prototype.onResetStore = function(cb) {
            var _this = this;
            this.resetStoreCallbacks.push(cb);
            return function() {
                _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.onClearStore = function(cb) {
            var _this = this;
            this.clearStoreCallbacks.push(cb);
            return function() {
                _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
            return this.queryManager.reFetchObservableQueries(includeStandby);
        };
        ApolloClient.prototype.extract = function(optimistic) {
            return this.cache.extract(optimistic);
        };
        ApolloClient.prototype.restore = function(serializedState) {
            return this.cache.restore(serializedState);
        };
        ApolloClient.prototype.addResolvers = function(resolvers) {
            this.localState.addResolvers(resolvers);
        };
        ApolloClient.prototype.setResolvers = function(resolvers) {
            this.localState.setResolvers(resolvers);
        };
        ApolloClient.prototype.getResolvers = function() {
            return this.localState.getResolvers();
        };
        ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
            this.localState.setFragmentMatcher(fragmentMatcher);
        };
        return ApolloClient;
    }();
    var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;
});
parcelRegister("clSzL", function(module, exports) {
    $parcel$export(module.exports, "makePromise", ()=>makePromise);
    $parcel$export(module.exports, "fromError", ()=>fromError);
    $parcel$export(module.exports, "ApolloLink", ()=>ApolloLink);
    $parcel$export(module.exports, "from", ()=>from);
    $parcel$export(module.exports, "split", ()=>split);
    $parcel$export(module.exports, "execute", ()=>execute);
    $parcel$export(module.exports, "Observable", ()=>(parcelRequire("aS6b9")).default);
    var $aS6b9;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $jojW6;
    function validateOperation(operation) {
        var OPERATION_FIELDS = [
            'query',
            'operationName',
            'variables',
            'extensions',
            'context'
        ];
        for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
            var key = _a[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
        }
        return operation;
    }
    var LinkError = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinkError, _super);
        function LinkError(message, link) {
            var _this = _super.call(this, message) || this;
            _this.link = link;
            return _this;
        }
        return LinkError;
    }(Error);
    function isTerminating(link) {
        return link.request.length <= 1;
    }
    function toPromise(observable) {
        var completed = false;
        return new Promise(function(resolve, reject) {
            observable.subscribe({
                next: function(data) {
                    if (completed) ;
                    else {
                        completed = true;
                        resolve(data);
                    }
                },
                error: reject
            });
        });
    }
    var makePromise = toPromise;
    function fromPromise(promise) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            promise.then(function(value) {
                observer.next(value);
                observer.complete();
            }).catch(observer.error.bind(observer));
        });
    }
    function fromError(errorValue) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            observer.error(errorValue);
        });
    }
    function transformOperation(operation) {
        var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
        };
        if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, (0, parcelRequire("jojW6")).getOperationName)(transformedOperation.query) : '';
        return transformedOperation;
    }
    function createOperation(starting, operation) {
        var context = (0, (0, parcelRequire("3VFsf")).__assign)({}, starting);
        var setContext = function(next) {
            if (typeof next === 'function') context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next(context));
            else context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next);
        };
        var getContext = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)({}, context);
        };
        Object.defineProperty(operation, 'setContext', {
            enumerable: false,
            value: setContext
        });
        Object.defineProperty(operation, 'getContext', {
            enumerable: false,
            value: getContext
        });
        Object.defineProperty(operation, 'toKey', {
            enumerable: false,
            value: function() {
                return getKey(operation);
            }
        });
        return operation;
    }
    function getKey(operation) {
        var query = operation.query, variables = operation.variables, operationName = operation.operationName;
        return JSON.stringify([
            operationName,
            query,
            variables
        ]);
    }
    function passthrough(op, forward) {
        return forward ? forward(op) : (0, (0, parcelRequire("aS6b9")).default).of();
    }
    function toLink(handler) {
        return typeof handler === 'function' ? new ApolloLink(handler) : handler;
    }
    function empty() {
        return new ApolloLink(function() {
            return (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    function from(links) {
        if (links.length === 0) return empty();
        return links.map(toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    }
    function split(test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    var concat = function(first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) return firstLink;
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    };
    var ApolloLink = function() {
        function ApolloLink(request) {
            if (request) this.request = request;
        }
        ApolloLink.prototype.split = function(test, left, right) {
            return this.concat(split(test, left, right || new ApolloLink(passthrough)));
        };
        ApolloLink.prototype.concat = function(next) {
            return concat(this, next);
        };
        ApolloLink.prototype.request = function(operation, forward) {
            throw new (0, $1DiV8.InvariantError)(1);
        };
        ApolloLink.empty = empty;
        ApolloLink.from = from;
        ApolloLink.split = split;
        ApolloLink.execute = execute;
        return ApolloLink;
    }();
    function execute(link, operation) {
        return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, (0, parcelRequire("aS6b9")).default).of();
    }
});
parcelRegister("aS6b9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ea3bd7f736c1eb4$export$2e2bcd8739ae039);
    var $4osjv = parcelRequire("4osjv");
    var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, ($parcel$interopDefault($4osjv)));
    var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;
});
parcelRegister("4osjv", function(module, exports) {
    module.exports = (parcelRequire("k0hXK")).Observable;
});
parcelRegister("k0hXK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Observable = void 0;
    function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $e901bdc1c9a5edd7$var$hasSymbols = function() {
        return typeof Symbol === 'function';
    };
    var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
    };
    var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
    };
    if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
    var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species');
    function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
        return value;
    }
    function $e901bdc1c9a5edd7$var$getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$isObservable(x) {
        return x instanceof $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$hostReportError(e) {
        if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
        else setTimeout(function() {
            throw e;
        });
    }
    function $e901bdc1c9a5edd7$var$enqueue(fn) {
        Promise.resolve().then(function() {
            try {
                fn();
            } catch (e) {
                $e901bdc1c9a5edd7$var$hostReportError(e);
            }
        });
    }
    function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (cleanup === undefined) return;
        subscription._cleanup = undefined;
        if (!cleanup) return;
        try {
            if (typeof cleanup === 'function') cleanup();
            else {
                var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
                if (unsubscribe) unsubscribe.call(cleanup);
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    }
    function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
        subscription._observer = undefined;
        subscription._queue = undefined;
        subscription._state = 'closed';
    }
    function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
        var queue = subscription._queue;
        if (!queue) return;
        subscription._queue = undefined;
        subscription._state = 'ready';
        for(var i = 0; i < queue.length; ++i){
            $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
            if (subscription._state === 'closed') break;
        }
    }
    function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
        subscription._state = 'running';
        var observer = subscription._observer;
        try {
            var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
            switch(type){
                case 'next':
                    if (m) m.call(observer, value);
                    break;
                case 'error':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer, value);
                    else throw value;
                    break;
                case 'complete':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer);
                    break;
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
        if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
        else if (subscription._state === 'running') subscription._state = 'ready';
    }
    function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
        if (subscription._state === 'closed') return;
        if (subscription._state === 'buffering') {
            subscription._queue.push({
                type: type,
                value: value
            });
            return;
        }
        if (subscription._state !== 'ready') {
            subscription._state = 'buffering';
            subscription._queue = [
                {
                    type: type,
                    value: value
                }
            ];
            $e901bdc1c9a5edd7$var$enqueue(function() {
                return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
            });
            return;
        }
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
    }
    var $e901bdc1c9a5edd7$var$Subscription = function() {
        function Subscription(observer, subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
            this._cleanup = undefined;
            this._observer = observer;
            this._queue = undefined;
            this._state = 'initializing';
            var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
            try {
                this._cleanup = subscriber.call(undefined, subscriptionObserver);
            } catch (e) {
                subscriptionObserver.error(e);
            }
            if (this._state === 'initializing') this._state = 'ready';
        }
        $e901bdc1c9a5edd7$var$_createClass(Subscription, [
            {
                key: "unsubscribe",
                value: function unsubscribe() {
                    if (this._state !== 'closed') {
                        $e901bdc1c9a5edd7$var$closeSubscription(this);
                        $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                    }
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._state === 'closed';
                }
            }
        ]);
        return Subscription;
    }();
    var $e901bdc1c9a5edd7$var$SubscriptionObserver = function() {
        function SubscriptionObserver(subscription) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
            this._subscription = subscription;
        }
        $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
            {
                key: "next",
                value: function next(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
                }
            },
            {
                key: "error",
                value: function error(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
                }
            },
            {
                key: "complete",
                value: function complete() {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._subscription._state === 'closed';
                }
            }
        ]);
        return SubscriptionObserver;
    }();
    var $e901bdc1c9a5edd7$var$Observable = function() {
        function Observable(subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
            if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
            if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
            this._subscriber = subscriber;
        }
        $e901bdc1c9a5edd7$var$_createClass(Observable, [
            {
                key: "subscribe",
                value: function subscribe(observer) {
                    if (typeof observer !== 'object' || observer === null) observer = {
                        next: observer,
                        error: arguments[1],
                        complete: arguments[2]
                    };
                    return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
                }
            },
            {
                key: "forEach",
                value: function forEach(fn) {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        if (typeof fn !== 'function') {
                            reject(new TypeError(fn + ' is not a function'));
                            return;
                        }
                        function done() {
                            subscription.unsubscribe();
                            resolve();
                        }
                        var subscription = _this.subscribe({
                            next: function(value) {
                                try {
                                    fn(value, done);
                                } catch (e) {
                                    reject(e);
                                    subscription.unsubscribe();
                                }
                            },
                            error: reject,
                            complete: resolve
                        });
                    });
                }
            },
            {
                key: "map",
                value: function map(fn) {
                    var _this2 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this2.subscribe({
                            next: function(value) {
                                try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "filter",
                value: function filter(fn) {
                    var _this3 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this3.subscribe({
                            next: function(value) {
                                try {
                                    if (!fn(value)) return;
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "reduce",
                value: function reduce(fn) {
                    var _this4 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    var hasSeed = arguments.length > 1;
                    var hasValue = false;
                    var seed = arguments[1];
                    var acc = seed;
                    return new C(function(observer) {
                        return _this4.subscribe({
                            next: function(value) {
                                var first = !hasValue;
                                hasValue = true;
                                if (!first || hasSeed) try {
                                    acc = fn(acc, value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                else acc = value;
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                                observer.next(acc);
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "concat",
                value: function concat() {
                    var _this5 = this;
                    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscription;
                        var index = 0;
                        function startNext(next) {
                            subscription = next.subscribe({
                                next: function(v) {
                                    observer.next(v);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    if (index === sources.length) {
                                        subscription = undefined;
                                        observer.complete();
                                    } else startNext(C.from(sources[index++]));
                                }
                            });
                        }
                        startNext(_this5);
                        return function() {
                            if (subscription) {
                                subscription.unsubscribe();
                                subscription = undefined;
                            }
                        };
                    });
                }
            },
            {
                key: "flatMap",
                value: function flatMap(fn) {
                    var _this6 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscriptions = [];
                        var outer = _this6.subscribe({
                            next: function(value) {
                                if (fn) try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                var inner = C.from(value).subscribe({
                                    next: function(value) {
                                        observer.next(value);
                                    },
                                    error: function(e) {
                                        observer.error(e);
                                    },
                                    complete: function() {
                                        var i = subscriptions.indexOf(inner);
                                        if (i >= 0) subscriptions.splice(i, 1);
                                        completeIfDone();
                                    }
                                });
                                subscriptions.push(inner);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                completeIfDone();
                            }
                        });
                        function completeIfDone() {
                            if (outer.closed && subscriptions.length === 0) observer.complete();
                        }
                        return function() {
                            subscriptions.forEach(function(s) {
                                return s.unsubscribe();
                            });
                            outer.unsubscribe();
                        };
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolObservable,
                value: function() {
                    return this;
                }
            }
        ], [
            {
                key: "from",
                value: function from(x) {
                    var C = typeof this === 'function' ? this : Observable;
                    if (x == null) throw new TypeError(x + ' is not an object');
                    var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                    if (method) {
                        var observable = method.call(x);
                        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                        if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                        return new C(function(observer) {
                            return observable.subscribe(observer);
                        });
                    }
                    if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                        method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                        if (method) return new C(function(observer) {
                            $e901bdc1c9a5edd7$var$enqueue(function() {
                                if (observer.closed) return;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;
                                try {
                                    for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _item = _step.value;
                                        observer.next(_item);
                                        if (observer.closed) return;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                    } finally{
                                        if (_didIteratorError) throw _iteratorError;
                                    }
                                }
                                observer.complete();
                            });
                        });
                    }
                    if (Array.isArray(x)) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < x.length; ++i){
                                observer.next(x[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                    throw new TypeError(x + ' is not observable');
                }
            },
            {
                key: "of",
                value: function of() {
                    for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                    var C = typeof this === 'function' ? this : Observable;
                    return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < items.length; ++i){
                                observer.next(items[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolSpecies,
                get: function() {
                    return this;
                }
            }
        ]);
        return Observable;
    }();
    module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
    if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
        value: {
            symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
            hostReportError: $e901bdc1c9a5edd7$var$hostReportError
        },
        configurable: true
    });
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    var $aS6b9;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $aS6b9;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    var $aS6b9;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $aS6b9;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("aS6b9")).default).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("aS6b9")).default).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("dxpxC", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$4350c2bcf1320fcf$export$fb326ed954631f3f);
    var $clSzL;
    var $bFU4G;
    const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("bFU4G")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("3M1CO", function(module, exports) {
    $parcel$export(module.exports, "transformStargateUrl", ()=>$3e143aeba8894d55$export$96f8b7181eacc12a);
    $parcel$export(module.exports, "transformCreateIssueUrl", ()=>$3e143aeba8894d55$export$3092c86dfb3d9d95);
    $parcel$export(module.exports, "transformOriginUrl", ()=>$3e143aeba8894d55$export$e32687a94f0c0d0c);
    const $3e143aeba8894d55$export$96f8b7181eacc12a = (url)=>{
        try {
            if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
                const urlObject = new URL(url);
                let urlPathArray = urlObject.pathname.split('/');
                urlPathArray = [
                    'gateway',
                    'api',
                    ...urlPathArray.slice(1)
                ];
                return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
            }
        } catch (e) {
            return url;
        }
        return url;
    };
    const $3e143aeba8894d55$export$3092c86dfb3d9d95 = ({ issueUrl: issueUrl, selectedCloudId: selectedCloudId })=>{
        if (!selectedCloudId) return issueUrl;
        return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
    };
    const $3e143aeba8894d55$export$e32687a94f0c0d0c = (selectedCloudId)=>selectedCloudId ? `${window.origin}/gateway/api/ex/jira/${selectedCloudId}` : null;
});
parcelRegister("4dA66", function(module, exports) {
    $parcel$export(module.exports, "usePublishUseTriggerIssueCreateModalChange", ()=>$5a87e27a6d56ef3a$export$def8d994aa8d00f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $5eGnF;
    var $9svjh;
    var $5rzqz;
    const $5a87e27a6d56ef3a$export$def8d994aa8d00f4 = ()=>{
        const [state] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        (0, $5uXOq.useEffect)(()=>publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, state), [
            publish,
            state
        ]);
    };
});
parcelRegister("dVtn1", function(module, exports) {
    $parcel$export(module.exports, "IssueRestoreWrapper", ()=>$0f8c284342b05b30$export$c5abd224bc075aa5);
    var $5uXOq = parcelRequire("5uXOq");
    var $45Cy1;
    var $9qNYv;
    var $5rzqz;
    var $1n4jA;
    var $ieDtd;
    const $0f8c284342b05b30$export$c5abd224bc075aa5 = ({ children: children })=>{
        const [, { restoreState: restoreTriggerIssueCreateModalState }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const [, { restoreState: restoreFormContext }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const isEmbedded = (0, (0, parcelRequire("1n4jA")).useIsEmbedded)();
        const [createIncidentModalState] = (0, (0, parcelRequire("ieDtd")).useQueryParam)('open_create_incident_modal');
        const isCreateIncidentModal = createIncidentModalState !== undefined;
        return isEmbedded || isCreateIncidentModal ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children?.({})) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9qNYv")).IssueRestore), {
            onRestoreTriggerIssueCreateModalState: restoreTriggerIssueCreateModalState,
            onRestoreFormContext: restoreFormContext
        }, children);
    };
});
parcelRegister("9qNYv", function(module, exports) {
    $parcel$export(module.exports, "IssueRestore", ()=>$f14610e697536670$export$20995982965fe5e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    var $4fT7I;
    var $gIPBO;
    var $67QNo;
    var $aCgtf;
    var $5TOSQ;
    var $fujGs;
    const $f14610e697536670$var$IssueRestoreInner = ({ children: children, ...rest })=>{
        const [{ inProgressIssueMetas: inProgressIssueMetas, isInitialised: isInitialised }, { init: init }] = (0, (0, parcelRequire("gIPBO")).useIssueRestoreMeta)();
        const inProgressIssueService = (0, (0, parcelRequire("67QNo")).useInProgressIssueService)();
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialised) init();
        }, [
            isInitialised,
            init
        ]);
        const activeInProgressIssueID = inProgressIssueMetas?.[0]?.inProgressIssueID;
        const activeShouldRestore = inProgressIssueMetas?.[0]?.shouldRestore;
        if (isInitialised) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4fT7I")).InProgressIssueStoreContainer), {
            inProgressIssueService: inProgressIssueService
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5TOSQ")).InProgressIssueInitialiser), {
            inProgressIssueID: activeInProgressIssueID,
            shouldRestore: activeShouldRestore,
            ...rest
        }, children));
        return null;
    };
    const $f14610e697536670$export$20995982965fe5e9 = ({ children: children, ...rest })=>{
        const issueRestoreMetaService = (0, (0, parcelRequire("aCgtf")).useIssueRestoreMetaService)();
        const [indexedDBAvailable] = (0, $5uXOq.useState)((0, (0, parcelRequire("fujGs")).isIndexedDBAvailable)());
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!indexedDBAvailable) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'indexedDB missing');
        }, [
            createAnalyticsEvent,
            indexedDBAvailable
        ]);
        if (!indexedDBAvailable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children?.({}));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gIPBO")).IssueRestoreMetaContainer), {
            issueRestoreMetaService: issueRestoreMetaService
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f14610e697536670$var$IssueRestoreInner, rest, children));
    };
});
parcelRegister("4fT7I", function(module, exports) {
    $parcel$export(module.exports, "useInProgressIssue", ()=>$3210c3aeb4604a51$export$4b6bb26ceba91de6);
    $parcel$export(module.exports, "InProgressIssueStoreContainer", ()=>$3210c3aeb4604a51$export$bd3e62a8e8bf35);
    $parcel$export(module.exports, "useInProgressIssueActions", ()=>$3210c3aeb4604a51$export$74b9a754a809ff62);
    $parcel$export(module.exports, "useIsFormDirty", ()=>$3210c3aeb4604a51$export$99feafa9b9955d05);
    $parcel$export(module.exports, "useIsModalOpen", ()=>$3210c3aeb4604a51$export$c09953967ff9ffea);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $2XPw9;
    const $3210c3aeb4604a51$export$d4c72bab9d6cc13a = {
        isInitialised: false,
        isSavingCounter: 0,
        id: '',
        formData: {},
        formDataDefaultValues: {},
        formContext: {},
        triggerIssueCreateModalState: undefined,
        statusField: {},
        restoreError: undefined
    };
    let $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = false;
    const $3210c3aeb4604a51$export$2cd70be39fa29781 = ()=>{
        $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = false;
    };
    const $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics = (eventName, state)=>{
        if ($3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics) return;
        $3210c3aeb4604a51$var$hasFiredUnexpectedEventErrorAnalytics = true;
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'useInProgressIssueService',
                packageName: 'jiraIssueCreateRestore'
            },
            attributes: {
                inProgressIssueID: state?.id,
                isModalOpen: state?.triggerIssueCreateModalState?.isModalOpen,
                wasStateRestored: state?.triggerIssueCreateModalState?.wasStateRestored,
                minimizableModalView: state?.triggerIssueCreateModalState?.minimizableModalView,
                eventName: eventName
            },
            error: new Error('InProgressIssue - unexpected event fired'),
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true
        });
    };
    const $3210c3aeb4604a51$var$THROTTLE_DELAY = 250;
    const $3210c3aeb4604a51$export$e324594224ef24da = {
        onTriggerIssueCreateModalStateChange: (triggerIssueCreateModalState)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!(currentState.id || triggerIssueCreateModalState.inProgressIssueID) || !(currentState?.triggerIssueCreateModalState?.isModalOpen || triggerIssueCreateModalState?.isModalOpen)) return;
                const overridePayload = {
                    project: currentState?.triggerIssueCreateModalState?.payload?.project,
                    issueType: currentState?.triggerIssueCreateModalState?.payload?.issueType,
                    requestType: currentState?.triggerIssueCreateModalState?.payload?.requestType
                };
                const newPayload = {
                    ...triggerIssueCreateModalState.payload || {},
                    ...overridePayload
                };
                setState({
                    id: triggerIssueCreateModalState.inProgressIssueID,
                    isSavingCounter: currentState.isSavingCounter + 1,
                    triggerIssueCreateModalState: {
                        ...triggerIssueCreateModalState,
                        payload: newPayload
                    }
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                const newState = getState();
                try {
                    await updateInProgressIssue(newState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(newState));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onTriggerIssueCreateModalStateChange'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onFormFieldUpdate: ({ fieldId: fieldId, value: value })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics(`onFormFieldUpdate - ${fieldId}`, currentState);
                    return;
                }
                const newFormData = {
                    ...currentState.formData,
                    [fieldId]: value
                };
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    formData: newFormData
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFormFieldUpdate'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setTimeout(()=>{
                    setState({
                        isSavingCounter: getState().isSavingCounter - 1
                    });
                }, $3210c3aeb4604a51$var$THROTTLE_DELAY + 1);
            },
        onClassificationLevelFieldChange: (classificationLevelField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onClassificationLevelFieldChange', currentState);
                    return;
                }
                setState({
                    isSavingCounter: getState().isSavingCounter + 1,
                    classificationLevelField: classificationLevelField
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                const newState = getState();
                try {
                    await updateInProgressIssue(newState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(newState));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onClassificationLevelFieldChange'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onStatusFieldChange: (statusField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onStatusFieldChange', currentState);
                    return;
                }
                setState({
                    isSavingCounter: getState().isSavingCounter + 1,
                    statusField: statusField
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                const newState = getState();
                try {
                    await updateInProgressIssue(newState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(newState));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onStatusFieldChange'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onFormContextUpdate: (formContext)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                const { id: id, triggerIssueCreateModalState: triggerIssueCreateModalState, isSavingCounter: isSavingCounter } = currentState;
                if (!id || !triggerIssueCreateModalState || !triggerIssueCreateModalState.isModalOpen) return;
                const currentFormContext = currentState.formContext;
                const newFormContext = formContext;
                if (triggerIssueCreateModalState && !(0, ($parcel$interopDefault($ajpes)))(newFormContext, currentFormContext)) {
                    const currentPayload = triggerIssueCreateModalState.payload;
                    const selectedIssueAndRequestType = newFormContext.selectedIssueType ? {
                        issueType: {
                            issueTypeId: (0, (0, parcelRequire("2XPw9")).isRequestType)(newFormContext.selectedIssueType) ? newFormContext.selectedIssueType.issueTypeId : newFormContext.selectedIssueType?.value
                        },
                        requestType: (0, (0, parcelRequire("2XPw9")).isRequestType)(newFormContext.selectedIssueType) ? {
                            key: newFormContext.selectedIssueType.requestTypeKey
                        } : undefined
                    } : undefined;
                    const newTriggerIssueCreateModalState = {
                        ...triggerIssueCreateModalState,
                        payload: {
                            ...currentPayload,
                            project: {
                                projectId: newFormContext.selectedProject?.value
                            },
                            ...selectedIssueAndRequestType
                        }
                    };
                    const newState = {
                        isSavingCounter: isSavingCounter + 1,
                        formContext: newFormContext,
                        triggerIssueCreateModalState: newTriggerIssueCreateModalState
                    };
                    setState(newState);
                    const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                    try {
                        await updateInProgressIssue(id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                    } catch (error) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'useInProgressIssueService',
                                packageName: 'jiraIssueCreateRestore'
                            },
                            error: error,
                            attributes: {
                                eventName: 'onFormContextUpdate'
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true
                        });
                        setState({
                            restoreError: error
                        });
                    }
                    setState({
                        isSavingCounter: getState().isSavingCounter - 1
                    });
                }
            },
        onModalOpened: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
                const newState = {
                    ...getState(),
                    id: inProgressIssueID
                };
                setState(newState);
                try {
                    await createInProgressIssue(inProgressIssueID, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(newState));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onModalOpened'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
            },
        onModalClosed: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                if (inProgressIssueID === getState().id) {
                    setState({
                        ...$3210c3aeb4604a51$export$d4c72bab9d6cc13a,
                        isInitialised: true,
                        restoreError: undefined
                    });
                    const { deleteInProgressIssue: deleteInProgressIssue } = inProgressIssueService;
                    try {
                        await deleteInProgressIssue(inProgressIssueID);
                    } catch (error) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'useInProgressIssueService',
                                packageName: 'jiraIssueCreateRestore'
                            },
                            error: error,
                            attributes: {
                                eventName: 'onModalClosed'
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            skipSentry: true
                        });
                        setState({
                            restoreError: error
                        });
                    }
                }
            },
        onModalDiscardExistingInProgressIssue: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const state = getState();
                setState({
                    ...$3210c3aeb4604a51$export$d4c72bab9d6cc13a,
                    isSavingCounter: state.isSavingCounter + 1,
                    id: state.id,
                    triggerIssueCreateModalState: state.triggerIssueCreateModalState,
                    formContext: state.formContext,
                    isInitialised: true,
                    restoreError: undefined
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(state.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onModalDiscardExistingInProgressIssue'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onResetFormFieldsForCreateAnother: (fieldsReset)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onResetFormFieldsForCreateAnother', currentState);
                    return;
                }
                const newFormData = {
                    ...currentState.formData,
                    ...fieldsReset.fieldsReset
                };
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    formData: newFormData
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onResetFormFieldsForCreateAnother'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onReinsertIntoBrowserStorage: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onReinsertIntoBrowserStorage', currentState);
                    return;
                }
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1
                });
                const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
                try {
                    await createInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(currentState));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onReinsertIntoBrowserStorage'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        init: (inProgressIssueID)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                if (inProgressIssueID) {
                    const { getInProgressIssue: getInProgressIssue } = inProgressIssueService;
                    try {
                        const inProgressIssue = await getInProgressIssue(inProgressIssueID);
                        setState({
                            ...inProgressIssue,
                            triggerIssueCreateModalState: inProgressIssue?.triggerIssueCreateModalState ? {
                                ...inProgressIssue?.triggerIssueCreateModalState,
                                wasStateRestored: true
                            } : undefined,
                            isInitialised: true
                        });
                    } catch (error) {
                        setState({
                            restoreError: error
                        });
                    }
                    return getState();
                }
                setState({
                    isInitialised: true
                });
                return getState();
            },
        onFormFieldConfigUpdate: ({ fieldConfig: fieldConfig })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState.id) return;
                let newFormDataDefaultValues = {};
                Object.values(fieldConfig).forEach((fieldData)=>{
                    const { fieldId: fieldId, defaultValue: defaultValue } = fieldData;
                    newFormDataDefaultValues = {
                        ...newFormDataDefaultValues,
                        [fieldId]: defaultValue
                    };
                });
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    formDataDefaultValues: newFormDataDefaultValues
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFormFieldConfigUpdate'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onIssueTypeChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onIssueTypeChange', currentState);
                    return;
                }
                const newFormDataDefaultValues = {};
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    formDataDefaultValues: newFormDataDefaultValues
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onIssueTypeChange'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        onProjectFieldChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
                const currentState = getState();
                if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                    $3210c3aeb4604a51$var$fireUnexpectedEventErrorAnalytics('onProjectFieldChange', currentState);
                    return;
                }
                const newFormDataDefaultValues = {};
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    formDataDefaultValues: newFormDataDefaultValues
                });
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(currentState.id, (0, (0, parcelRequire("2XPw9")).convertStateToInProgressIssueForStorage)(getState()));
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onProjectFieldChange'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            },
        setRestoreError: (restoreError)=>async ({ setState: setState })=>{
                setState({
                    restoreError: restoreError
                });
            }
    };
    const $3210c3aeb4604a51$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $3210c3aeb4604a51$export$d4c72bab9d6cc13a,
        actions: $3210c3aeb4604a51$export$e324594224ef24da
    });
    const $3210c3aeb4604a51$export$4b6bb26ceba91de6 = (0, (0, parcelRequire("3sQ5x")).createHook)($3210c3aeb4604a51$var$Store);
    const $3210c3aeb4604a51$export$bd3e62a8e8bf35 = (0, (0, parcelRequire("gg7kZ")).createContainer)($3210c3aeb4604a51$var$Store);
    const $3210c3aeb4604a51$export$74b9a754a809ff62 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($3210c3aeb4604a51$var$Store);
    const $3210c3aeb4604a51$var$getIsFormDirty = (state)=>state?.formContext?.isFormDirty;
    const $3210c3aeb4604a51$export$99feafa9b9955d05 = (0, (0, parcelRequire("3sQ5x")).createHook)($3210c3aeb4604a51$var$Store, {
        selector: $3210c3aeb4604a51$var$getIsFormDirty
    });
    const $3210c3aeb4604a51$var$getIsModalOpen = (state)=>Boolean(state?.id && state?.triggerIssueCreateModalState?.isModalOpen);
    const $3210c3aeb4604a51$export$c09953967ff9ffea = (0, (0, parcelRequire("3sQ5x")).createHook)($3210c3aeb4604a51$var$Store, {
        selector: $3210c3aeb4604a51$var$getIsModalOpen
    });
});
parcelRegister("2XPw9", function(module, exports) {
    $parcel$export(module.exports, "convertStateToInProgressIssueForStorage", ()=>$105ebbc716803e7a$export$2f809a820073cf71);
    $parcel$export(module.exports, "isRequestType", ()=>$105ebbc716803e7a$export$ff3afd1b5536cfed);
    var $fr1K2 = parcelRequire("fr1K2");
    function $105ebbc716803e7a$export$2f809a820073cf71(state) {
        try {
            return {
                ...(0, ($parcel$interopDefault($fr1K2)))(state, [
                    'isInitialised',
                    'isSavingCounter'
                ]),
                formContext: state?.formContext ? JSON.parse(JSON.stringify(state.formContext)) : undefined,
                triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify(state.triggerIssueCreateModalState)) : undefined
            };
        } catch  {
            return state;
        }
    }
    function $105ebbc716803e7a$export$ff3afd1b5536cfed(type) {
        if (!type) return false;
        return type.issueTypeId !== undefined;
    }
});
parcelRegister("gIPBO", function(module, exports) {
    $parcel$export(module.exports, "useIssueRestoreMeta", ()=>$19a15b767cc88c7a$export$bad3a2f4726801fb);
    $parcel$export(module.exports, "IssueRestoreMetaContainer", ()=>$19a15b767cc88c7a$export$e670c4748122991);
    $parcel$export(module.exports, "useIssueRestoreMetaActions", ()=>$19a15b767cc88c7a$export$2a548b3d17373434);
    $parcel$export(module.exports, "useIssueRestoreMetaSubscriptions", ()=>$19a15b767cc88c7a$export$270e0095f4e57380);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $5eGnF;
    var $9svjh;
    var $8zOmE;
    var $2NMNM;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $jnVBq;
    const $19a15b767cc88c7a$export$d4c72bab9d6cc13a = {
        isInitialised: false,
        isSavingCounter: 0,
        inProgressIssueMetas: [],
        restoreMetaError: undefined
    };
    const $19a15b767cc88c7a$export$e324594224ef24da = {
        init: ()=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
                if (!getState().isInitialised) try {
                    const { getIssueRestoreMeta: getIssueRestoreMeta, createIssueRestoreMeta: createIssueRestoreMeta } = issueRestoreMetaService;
                    let issueRestoreMeta = await getIssueRestoreMeta();
                    if (!issueRestoreMeta) issueRestoreMeta = await createIssueRestoreMeta({
                        inProgressIssueMetas: []
                    });
                    if (issueRestoreMeta.inProgressIssueMetas !== undefined) {
                        const filteredinProgressIssueMetas = issueRestoreMeta.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore === true);
                        issueRestoreMeta.inProgressIssueMetas = filteredinProgressIssueMetas;
                    }
                    setState({
                        ...issueRestoreMeta,
                        isInitialised: true
                    });
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useIssueCreateMetaService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreMetaError: error
                    });
                }
            },
        onModalOpened: ({ inProgressIssueID: inProgressIssueID, analyticsEvent: analyticsEvent })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
                const currentState = getState();
                if (currentState.inProgressIssueMetas !== undefined) {
                    if (!currentState.isInitialised || currentState.inProgressIssueMetas.map((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID).includes(inProgressIssueID)) return;
                    if (currentState.inProgressIssueMetas.find((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore)) analyticsEvent ? (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'Existing inProgressIssue onModalOpened', {
                        id: 'issueRestoreMetaOnModalOpened',
                        packageName: 'jiraIssueCreateRestore'
                    }) : (0, (0, parcelRequire("jcw0u")).default)({
                        error: new Error('Existing inProgressIssue onModalOpened'),
                        meta: {
                            id: 'issueRestoreMetaOnModalOpened',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        isSavingCounter: currentState.isSavingCounter + 1,
                        inProgressIssueMetas: [
                            {
                                inProgressIssueID: inProgressIssueID,
                                shouldRestore: true
                            }
                        ]
                    });
                }
                const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
                try {
                    await updateIssueRestoreMeta((0, (0, parcelRequire("jnVBq")).convertStateToIssueRestoreMeta)(getState()));
                    setState({
                        isSavingCounter: getState().isSavingCounter - 1
                    });
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useIssueCreateMetaService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreMetaError: error
                    });
                }
            },
        onModalClosed: ({ inProgressIssueID: inProgressIssueIDToBeRemoved })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
                const currentState = getState();
                const newInProgressIssueMetas = currentState.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID !== inProgressIssueIDToBeRemoved);
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    restoreMetaError: undefined,
                    inProgressIssueMetas: newInProgressIssueMetas
                });
                const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
                try {
                    await updateIssueRestoreMeta((0, (0, parcelRequire("jnVBq")).convertStateToIssueRestoreMeta)(getState()));
                    setState({
                        isSavingCounter: getState().isSavingCounter - 1
                    });
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useIssueCreateMetaService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreMetaError: error
                    });
                }
            },
        setShouldRestore: (inProgressIssueID, newShouldRestore)=>async ({ getState: getState, setState: setState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
                const currentState = getState();
                const inProgressIssueMetaIndex = currentState.inProgressIssueMetas.findIndex((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID === inProgressIssueID);
                if (inProgressIssueMetaIndex < 0) return;
                const newInProgressIssueMetas = [
                    ...currentState.inProgressIssueMetas
                ];
                newInProgressIssueMetas[inProgressIssueMetaIndex] = {
                    ...newInProgressIssueMetas[inProgressIssueMetaIndex],
                    shouldRestore: newShouldRestore
                };
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    inProgressIssueMetas: newInProgressIssueMetas
                });
                const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
                try {
                    await updateIssueRestoreMeta((0, (0, parcelRequire("jnVBq")).convertStateToIssueRestoreMeta)(getState()));
                    setState({
                        isSavingCounter: getState().isSavingCounter - 1
                    });
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useIssueCreateMetaService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreMetaError: error
                    });
                }
            }
    };
    const $19a15b767cc88c7a$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $19a15b767cc88c7a$export$d4c72bab9d6cc13a,
        actions: $19a15b767cc88c7a$export$e324594224ef24da
    });
    const $19a15b767cc88c7a$export$bad3a2f4726801fb = (0, (0, parcelRequire("3sQ5x")).createHook)($19a15b767cc88c7a$var$Store);
    const $19a15b767cc88c7a$export$e670c4748122991 = (0, (0, parcelRequire("gg7kZ")).createContainer)($19a15b767cc88c7a$var$Store);
    const $19a15b767cc88c7a$export$2a548b3d17373434 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($19a15b767cc88c7a$var$Store);
    const $19a15b767cc88c7a$export$270e0095f4e57380 = ()=>{
        const { onModalOpened: onModalOpened, onModalClosed: onModalClosed } = $19a15b767cc88c7a$export$2a548b3d17373434();
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            const onOpenModal = (params)=>onModalOpened({
                    ...params,
                    analyticsEvent: analyticsEvent
                });
            return subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onOpenModal);
        }, [
            createAnalyticsEvent,
            onModalOpened,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
            onModalClosed,
            subscribe
        ]);
    };
});
parcelRegister("jnVBq", function(module, exports) {
    $parcel$export(module.exports, "convertStateToIssueRestoreMeta", ()=>$0bce6dae01864809$export$4494f626031edfc9);
    var $fr1K2 = parcelRequire("fr1K2");
    function $0bce6dae01864809$export$4494f626031edfc9(state) {
        return (0, ($parcel$interopDefault($fr1K2)))(state, [
            'isInitialised',
            'isSavingCounter',
            'restoreMetaError'
        ]);
    }
});
parcelRegister("67QNo", function(module, exports) {
    $parcel$export(module.exports, "useInProgressIssueService", ()=>$19b5b427f27c6cac$export$6fc1ebae2c6a92c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $sn9QA;
    var $jcw0u;
    const $19b5b427f27c6cac$export$6fc1ebae2c6a92c1 = ()=>{
        const [storage] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("sn9QA")).createIndexedDBStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}in-progress-issue`, {
                shouldAutoReconnect: true
            }));
        return {
            getInProgressIssue: async (inProgressIssueID)=>storage.get(inProgressIssueID),
            createInProgressIssue: async (inProgressIssueID, data)=>{
                await storage.set(inProgressIssueID, data);
                return data;
            },
            updateInProgressIssue: async (inProgressIssueID, data)=>{
                if (await storage.get(inProgressIssueID)) await storage.set(inProgressIssueID, data);
                else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'updateInProgressIssue',
                            packageName: 'jiraIssueCreateRestore',
                            teamName: 'gryffindor'
                        },
                        attributes: {
                            message: "Tried to updateInProgressIssue with an inProgressIssueID that doesn't exist in indexed-db"
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return data;
                }
                return data;
            },
            deleteInProgressIssue: async (inProgressIssueID)=>{
                await storage.remove(inProgressIssueID);
            }
        };
    };
});
parcelRegister("sn9QA", function(module, exports) {
    $parcel$export(module.exports, "createIndexedDBStorageProvider", ()=>$cf3437e9474a0e2b$export$6ba36c4f5fb8919d);
    var $gJBT6 = parcelRequire("gJBT6");
    var $8vEj7;
    const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, ($parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const provider = (0, (0, parcelRequire("8vEj7")).createStorageProvider)(appPrefix);
        if (options?.shouldAutoReconnect) return (0, (0, parcelRequire("8vEj7")).withAutoReconnect)(provider);
        return provider;
    });
});
parcelRegister("8vEj7", function(module, exports) {
    $parcel$export(module.exports, "createStorageProvider", ()=>$33b8db71261fb346$export$8441605555fbd60c);
    $parcel$export(module.exports, "withAutoReconnect", ()=>$33b8db71261fb346$export$8432fe49db7d8865);
    var $jIIX7;
    const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
    const $33b8db71261fb346$var$createCustomStore = ()=>(0, (0, parcelRequire("jIIX7")).createStore)('keyval-store', 'keyval');
    let $33b8db71261fb346$var$customStore;
    const $33b8db71261fb346$var$getStore = ()=>{
        let store = $33b8db71261fb346$var$customStore;
        if (!store) {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
            store = $33b8db71261fb346$var$customStore;
        }
        return store;
    };
    const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
        const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
        const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
        const assertKey = (key)=>{
            if (!key) throw Error('You must provide a key');
        };
        const updateStoreKeys = async (key, remove = false)=>(0, (0, parcelRequire("jIIX7")).update)(KEYS_STORE_PREFIX, (currentKeys)=>{
                const storeKeys = new Set(currentKeys);
                if (remove) {
                    storeKeys.delete(key);
                    return Array.from(storeKeys.values());
                }
                storeKeys.add(key);
                return Array.from(storeKeys.values());
            }, $33b8db71261fb346$var$getStore());
        return {
            async get (key) {
                assertKey(key);
                return (0, (0, parcelRequire("jIIX7")).get)(prefix(key), $33b8db71261fb346$var$getStore());
            },
            async remove (key) {
                assertKey(key);
                const prefixedKey = prefix(key);
                await (0, (0, parcelRequire("jIIX7")).del)(prefixedKey, $33b8db71261fb346$var$getStore());
                return updateStoreKeys(prefixedKey, true);
            },
            async clearAll () {
                const prefixedKeys = await (0, (0, parcelRequire("jIIX7")).get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
                if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
                return (0, (0, parcelRequire("jIIX7")).delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
            },
            async set (key, value) {
                assertKey(key);
                const prefixedKey = prefix(key);
                if (typeof value === 'function') (0, (0, parcelRequire("jIIX7")).update)(prefixedKey, value);
                else (0, (0, parcelRequire("jIIX7")).set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
                return updateStoreKeys(prefixedKey);
            },
            async reconnect () {
                $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
            }
        };
    };
    const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
            async get (...args) {
                try {
                    return await storageProvider.get(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.get(...args);
                    }
                    throw e;
                }
            },
            async set (...args) {
                try {
                    return await storageProvider.set(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.set(...args);
                    }
                    throw e;
                }
            },
            async remove (...args) {
                try {
                    return await storageProvider.remove(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.remove(...args);
                    }
                    throw e;
                }
            },
            async clearAll (...args) {
                try {
                    return await storageProvider.clearAll(...args);
                } catch (e) {
                    if (e instanceof Error) {
                        await storageProvider.reconnect?.();
                        return storageProvider.clearAll(...args);
                    }
                    throw e;
                }
            },
            async reconnect () {
                await storageProvider.reconnect?.();
            }
        });
});
parcelRegister("jIIX7", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$e5b4ff07e835609c$export$f51a9068ac82ea43);
    $parcel$export(module.exports, "get", ()=>$e5b4ff07e835609c$export$3988ae62b71be9a3);
    $parcel$export(module.exports, "set", ()=>$e5b4ff07e835609c$export$adaa4cf7ef1b65be);
    $parcel$export(module.exports, "update", ()=>$e5b4ff07e835609c$export$722fbec263ad908a);
    $parcel$export(module.exports, "del", ()=>$e5b4ff07e835609c$export$1d2f21e549771e67);
    $parcel$export(module.exports, "delMany", ()=>$e5b4ff07e835609c$export$c8aa84257229cac8);
    function $e5b4ff07e835609c$export$b327150396135fe7(request) {
        return new Promise((resolve, reject)=>{
            request.oncomplete = request.onsuccess = ()=>resolve(request.result);
            request.onabort = request.onerror = ()=>reject(request.error);
        });
    }
    function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
        return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
    }
    let $e5b4ff07e835609c$var$defaultGetStoreFunc;
    function $e5b4ff07e835609c$var$defaultGetStore() {
        if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
        return $e5b4ff07e835609c$var$defaultGetStoreFunc;
    }
    function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
    }
    function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.put(value, key);
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            entries.forEach((entry)=>store.put(entry[1], entry[0]));
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
    }
    function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>new Promise((resolve, reject)=>{
                store.get(key).onsuccess = function() {
                    try {
                        store.put(updater(this.result), key);
                        resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                    } catch (err) {
                        reject(err);
                    }
                };
            }));
    }
    function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.delete(key);
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            keys.forEach((key)=>store.delete(key));
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readwrite', (store)=>{
            store.clear();
            return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
        });
    }
    function $e5b4ff07e835609c$var$eachCursor(store, callback) {
        store.openCursor().onsuccess = function() {
            if (!this.result) return;
            callback(this.result);
            this.result.continue();
        };
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    }
    function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
            const items = [];
            return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
        });
    }
    function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
            const items = [];
            return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
        });
    }
    function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
        return customStore('readonly', (store)=>{
            if (store.getAll && store.getAllKeys) return Promise.all([
                $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
                $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
            ]).then(([keys, values])=>keys.map((key, i)=>[
                        key,
                        values[i]
                    ]));
            const items = [];
            return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                        cursor.key,
                        cursor.value
                    ])).then(()=>items));
        });
    }
});
parcelRegister("5TOSQ", function(module, exports) {
    $parcel$export(module.exports, "InProgressIssueInitialiser", ()=>$866e80c7de6a476b$export$ee6dd146d425cafc);
    var $5uXOq = parcelRequire("5uXOq");
    var $4fT7I;
    var $gIPBO;
    var $cOppp;
    var $2JnMT;
    const $866e80c7de6a476b$export$ee6dd146d425cafc = ({ onRestoreTriggerIssueCreateModalState: onRestoreTriggerIssueCreateModalState, onRestoreFormContext: onRestoreFormContext, inProgressIssueID: inProgressIssueID, shouldRestore: shouldRestore, children: children })=>{
        const { init: init } = (0, (0, parcelRequire("4fT7I")).useInProgressIssueActions)();
        const [isInitialised, setIsInitialised] = (0, $5uXOq.useState)(false);
        const { setShouldRestore: setShouldRestore } = (0, (0, parcelRequire("gIPBO")).useIssueRestoreMetaActions)();
        const [initialInProgressIssue, setInitialInProgressIssue] = (0, $5uXOq.useState)();
        const initialiseInProgressIssues = (0, $5uXOq.useCallback)(async ()=>{
            if (!isInitialised) {
                const inProgressIssue = await init(inProgressIssueID);
                if (shouldRestore) {
                    if (inProgressIssueID && inProgressIssue) {
                        const { triggerIssueCreateModalState: triggerIssueCreateModalState, formContext: formContext } = inProgressIssue;
                        if (triggerIssueCreateModalState) onRestoreTriggerIssueCreateModalState(triggerIssueCreateModalState);
                        if (formContext) onRestoreFormContext(formContext);
                        setInitialInProgressIssue(inProgressIssue);
                    }
                }
                setIsInitialised(true);
            }
        }, [
            isInitialised,
            shouldRestore,
            init,
            inProgressIssueID,
            onRestoreTriggerIssueCreateModalState,
            onRestoreFormContext
        ]);
        const setShouldRestoreForInProgressIssue = (0, $5uXOq.useCallback)((newShouldRestore)=>{
            inProgressIssueID && setShouldRestore(inProgressIssueID, newShouldRestore);
        }, [
            inProgressIssueID,
            setShouldRestore
        ]);
        (0, $5uXOq.useEffect)(()=>{
            initialiseInProgressIssues();
        }, [
            initialiseInProgressIssues
        ]);
        const { onTransformCreateFormProps: onTransformCreateFormProps } = (0, (0, parcelRequire("cOppp")).useRestoreFormFields)(initialInProgressIssue);
        if (!isInitialised) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JnMT")).BackgroundActions), null), children?.({
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestoreForInProgressIssue
        }));
    };
});
parcelRegister("cOppp", function(module, exports) {
    $parcel$export(module.exports, "useRestoreFormFields", ()=>$499e757ef3621f84$export$c698b427f6c94ae8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $5eGnF;
    var $9svjh;
    var $eLuo5;
    function $499e757ef3621f84$export$c698b427f6c94ae8(initialInProgressIssue) {
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const inProgressIssue = (0, $5uXOq.useRef)();
        const fieldConfig = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            inProgressIssue.current = initialInProgressIssue;
        }, [
            initialInProgressIssue
        ]);
        const onTransformCreateFormProps = (0, $5uXOq.useCallback)((createFormProps)=>{
            if (!inProgressIssue?.current) return createFormProps;
            if (inProgressIssue?.current?.formData && (0, ($parcel$interopDefault($gccSB)))(fieldConfig.current)) {
                const transformedData = (0, (0, parcelRequire("eLuo5")).transformFieldConfigAndDirtyFieldsCurrentSession)(inProgressIssue?.current?.formData, inProgressIssue?.current?.formDataDefaultValues, createFormProps);
                fieldConfig.current = transformedData?.fieldConfig;
            }
            return {
                ...createFormProps,
                fieldConfig: fieldConfig.current || createFormProps.fieldConfig,
                classificationFieldProps: (0, (0, parcelRequire("eLuo5")).transformClassificationLevelFieldProps)(inProgressIssue?.current?.classificationLevelField, createFormProps?.classificationFieldProps),
                statusFieldProps: (0, (0, parcelRequire("eLuo5")).transformStatusFieldProps)(inProgressIssue?.current?.statusField, createFormProps?.statusFieldProps)
            };
        }, []);
        const onReset = (0, $5uXOq.useCallback)(()=>{
            inProgressIssue.current = undefined;
            fieldConfig.current = undefined;
        }, []);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onReset), [
            onReset,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onReset), [
            onReset,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onReset), [
            onReset,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onReset), [
            onReset,
            subscribe
        ]);
        const resp = (0, $5uXOq.useMemo)(()=>({
                onTransformCreateFormProps: onTransformCreateFormProps
            }), [
            onTransformCreateFormProps
        ]);
        return resp;
    }
});
parcelRegister("eLuo5", function(module, exports) {
    $parcel$export(module.exports, "transformFieldConfigAndDirtyFieldsCurrentSession", ()=>$490010337e155767$export$9c7389800790524c);
    $parcel$export(module.exports, "transformStatusFieldProps", ()=>$490010337e155767$export$561febabfe3c6361);
    $parcel$export(module.exports, "transformClassificationLevelFieldProps", ()=>$490010337e155767$export$6c4d1d5181504079);
    const $490010337e155767$export$9c7389800790524c = (formData, formDataDefaultValues, createFormProps)=>{
        const { fieldConfig: fieldConfig = {}, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession } = createFormProps;
        const newFieldConfig = {
            ...fieldConfig
        };
        const newDirtyFieldsCurrentSession = {
            ...dirtyFieldsCurrentSession?.current || {}
        };
        if (formDataDefaultValues) Object.keys(formDataDefaultValues).forEach((key)=>{
            if (newFieldConfig[key]) newFieldConfig[key] = {
                ...newFieldConfig[key],
                defaultValue: formDataDefaultValues[key],
                defaultValueDontTransform: false
            };
        });
        if (formData) Object.keys(formData).forEach((key)=>{
            if (newFieldConfig[key]) {
                newFieldConfig[key] = {
                    ...newFieldConfig[key],
                    defaultValue: formData[key],
                    defaultValueDontTransform: true
                };
                newDirtyFieldsCurrentSession[key] = true;
            }
        });
        dirtyFieldsCurrentSession.current = newDirtyFieldsCurrentSession;
        return {
            fieldConfig: newFieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession
        };
    };
    const $490010337e155767$export$561febabfe3c6361 = (statusField, statusFieldProps)=>{
        if (statusField?.selectedTransition) {
            const newStatusFieldProps = {
                ...statusFieldProps
            };
            newStatusFieldProps.initialTransition = statusField.selectedTransition;
            return newStatusFieldProps;
        }
        return statusFieldProps;
    };
    const $490010337e155767$export$6c4d1d5181504079 = (classificationLevelField, classificationFieldProps)=>{
        if (classificationLevelField?.selectedClassification) {
            const newClassificationFieldProps = {
                ...classificationFieldProps
            };
            newClassificationFieldProps.initialClassification = classificationLevelField.selectedClassification;
            return newClassificationFieldProps;
        }
        return classificationFieldProps;
    };
});
parcelRegister("2JnMT", function(module, exports) {
    $parcel$export(module.exports, "BackgroundActions", ()=>$7971009a47ab2c97$export$30e6eb305b44f25b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3zUT3;
    var $4Yfcs;
    var $gIPBO;
    var $4TnIy;
    var $6i3Qj;
    const $7971009a47ab2c97$export$30e6eb305b44f25b = ()=>{
        (0, (0, parcelRequire("6i3Qj")).useInProgressIssueSubscriptions)();
        (0, (0, parcelRequire("gIPBO")).useIssueRestoreMetaSubscriptions)();
        (0, (0, parcelRequire("3zUT3")).useBrowserStorageCleanup)();
        (0, (0, parcelRequire("4TnIy")).useShouldShowBrowserWarning)();
        const isSaving = (0, (0, parcelRequire("4Yfcs")).useIsIssueRestoreSaving)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7971009a47ab2c97$var$InvisibleDiv, {
            "data-testid": isSaving ? 'issue-create-restore.ui.issue-restore.in-progress-initialiser.saving' : 'issue-create-restore.ui.issue-restore.in-progress-initialiser.not-saving'
        });
    };
    const $7971009a47ab2c97$var$InvisibleDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3zUT3", function(module, exports) {
    $parcel$export(module.exports, "useBrowserStorageCleanup", ()=>$bc2fceb92f63e4a1$export$bbca530fb1561128);
    var $5uXOq = parcelRequire("5uXOq");
    var $kGsr8 = parcelRequire("kGsr8");
    var $jcw0u;
    var $5eGnF;
    var $9svjh;
    var $8zOmE;
    var $2NMNM;
    var $gucQ5;
    var $67QNo;
    var $4fT7I;
    var $gIPBO;
    var $6hAZF;
    function $bc2fceb92f63e4a1$export$95b1d08316d5a401() {
        const browserStorageCleanupService = (0, (0, parcelRequire("gucQ5")).useBrowserStorageCleanupService)();
        const [{ inProgressIssueMetas: inProgressIssueMetas }] = (0, (0, parcelRequire("gIPBO")).useIssueRestoreMeta)();
        const { setRestoreError: setRestoreError } = (0, (0, parcelRequire("4fT7I")).useInProgressIssueActions)();
        const sessionInProgressIssueIDs = (0, $5uXOq.useMemo)(()=>inProgressIssueMetas?.filter((item)=>item.shouldRestore).map((item)=>item.inProgressIssueID) || [], [
            inProgressIssueMetas
        ]);
        const [, { onReinsertIntoBrowserStorage: onReinsertIntoBrowserStorage }] = (0, (0, parcelRequire("4fT7I")).useInProgressIssue)();
        const inProgressIssueService = (0, (0, parcelRequire("67QNo")).useInProgressIssueService)();
        const [isOpen] = (0, (0, parcelRequire("4fT7I")).useIsModalOpen)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onModalOpened = (0, $5uXOq.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
            const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened',
                        stage: 'getBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
            const newBrowserStorageCleanup = {
                ...browserStorageCleanup || {},
                inProgressIssueIDs: (0, ($parcel$interopDefault($kGsr8)))([
                    ...browserStorageCleanup?.inProgressIssueIDs || [],
                    inProgressIssueID
                ])
            };
            if (browserStorageCleanup) await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened',
                        stage: 'updateBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
            else await browserStorageCleanupService.createBrowserStorageCleanup(newBrowserStorageCleanup).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened',
                        stage: 'createBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
        }, [
            browserStorageCleanupService,
            setRestoreError
        ]);
        const onModalClosed = (0, $5uXOq.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
            const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalClosed',
                        stage: 'getBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
            if (!browserStorageCleanup) return;
            const newBrowserStorageCleanup = {
                ...browserStorageCleanup,
                inProgressIssueIDs: sessionInProgressIssueIDs.filter((id)=>id !== inProgressIssueID)
            };
            const inProgressIssueIDsToRemove = browserStorageCleanup.inProgressIssueIDs.filter((id)=>!sessionInProgressIssueIDs.includes(id));
            await Promise.all([
                browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup),
                ...inProgressIssueIDsToRemove.map((id)=>inProgressIssueService.deleteInProgressIssue(id))
            ]).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalClosed',
                        stage: 'promiseAll'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onModalClosed', {
                inProgressIssueIDsToRemoveLength: inProgressIssueIDsToRemove.length
            });
        }, [
            browserStorageCleanupService,
            createAnalyticsEvent,
            inProgressIssueService,
            sessionInProgressIssueIDs,
            setRestoreError
        ]);
        const onFocusWindow = (0, $5uXOq.useCallback)(async ()=>{
            if (!isOpen) return;
            const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFocusWindow',
                        stage: 'getBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
            const missingInProgressIssueIDs = browserStorageCleanup && sessionInProgressIssueIDs.length ? sessionInProgressIssueIDs.filter((id)=>!browserStorageCleanup.inProgressIssueIDs.includes(id)) : [];
            if (missingInProgressIssueIDs.length) {
                await onReinsertIntoBrowserStorage();
                const newBrowserStorageCleanup = {
                    ...browserStorageCleanup,
                    inProgressIssueIDs: (0, ($parcel$interopDefault($kGsr8)))([
                        ...browserStorageCleanup?.inProgressIssueIDs || [],
                        ...missingInProgressIssueIDs
                    ])
                };
                await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup).catch((error)=>{
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useBrowserStorageCleanupController',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFocusWindow',
                            stage: 'updateBrowserStorageCleanup'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setRestoreError && setRestoreError(error);
                });
            }
            if (missingInProgressIssueIDs.length) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onFocusWindow', {
                missingInProgressIssueIDsLength: missingInProgressIssueIDs.length
            });
        }, [
            browserStorageCleanupService,
            sessionInProgressIssueIDs,
            setRestoreError,
            onReinsertIntoBrowserStorage,
            createAnalyticsEvent,
            isOpen
        ]);
        return {
            onModalOpened: onModalOpened,
            onModalClosed: onModalClosed,
            onFocusWindow: onFocusWindow
        };
    }
    function $bc2fceb92f63e4a1$export$bbca530fb1561128() {
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const { onModalOpened: onModalOpened, onModalClosed: onModalClosed, onFocusWindow: onFocusWindow } = $bc2fceb92f63e4a1$export$95b1d08316d5a401();
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened), [
            onModalOpened,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
            onModalClosed,
            subscribe
        ]);
        (0, (0, parcelRequire("6hAZF")).useOnWindowFocus)(onFocusWindow);
    }
});
parcelRegister("gucQ5", function(module, exports) {
    $parcel$export(module.exports, "useBrowserStorageCleanupService", ()=>$06b0ebeb30b89a35$export$7129d99907775838);
    var $5uXOq = parcelRequire("5uXOq");
    var $sn9QA;
    const $06b0ebeb30b89a35$var$KEY = 'browser-storage-cleanup';
    const $06b0ebeb30b89a35$export$7129d99907775838 = ()=>{
        const [storage] = (0, $5uXOq.useState)((0, (0, parcelRequire("sn9QA")).createIndexedDBStorageProvider)(`${(0, $9a94166e56e4a9e2$export$8fa5032778cf7801)}${$06b0ebeb30b89a35$var$KEY}`, {
            shouldAutoReconnect: true
        }));
        return {
            getBrowserStorageCleanup: async ()=>storage.get($06b0ebeb30b89a35$var$KEY),
            createBrowserStorageCleanup: async (data)=>{
                await storage.set($06b0ebeb30b89a35$var$KEY, data);
                return data;
            },
            updateBrowserStorageCleanup: async (data)=>{
                await storage.set($06b0ebeb30b89a35$var$KEY, data);
                return data;
            },
            deleteBrowserStorageCleanup: async ()=>{
                await storage.remove($06b0ebeb30b89a35$var$KEY);
            }
        };
    };
});
parcelRegister("6hAZF", function(module, exports) {
    $parcel$export(module.exports, "useOnWindowFocus", ()=>$9475392ebc83c7f2$export$921321d14c966d8f);
    var $5uXOq = parcelRequire("5uXOq");
    function $9475392ebc83c7f2$export$921321d14c966d8f(onFocus) {
        const onVisibilityChange = (0, $5uXOq.useCallback)(()=>{
            if (document.visibilityState === 'visible') onFocus();
        }, [
            onFocus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (window?.addEventListener) {
                window.addEventListener('visibilitychange', onVisibilityChange, false);
                window.addEventListener('focus', onFocus, false);
            }
            return ()=>{
                if (window?.removeEventListener) {
                    window.removeEventListener('visibilitychange', onVisibilityChange);
                    window.removeEventListener('focus', onFocus);
                }
            };
        });
    }
});
parcelRegister("4Yfcs", function(module, exports) {
    $parcel$export(module.exports, "useIsIssueRestoreSaving", ()=>$e13d81d2073fcf5c$export$c3cd53fd21626217);
    var $4fT7I;
    var $gIPBO;
    const $e13d81d2073fcf5c$export$c3cd53fd21626217 = ()=>{
        const [{ isSavingCounter: isSavingCounterInProgressIssue }] = (0, (0, parcelRequire("4fT7I")).useInProgressIssue)();
        const [{ isSavingCounter: isSavingCounterIssueRestoreMeta }] = (0, (0, parcelRequire("gIPBO")).useIssueRestoreMeta)();
        return !(isSavingCounterInProgressIssue === 0 && isSavingCounterIssueRestoreMeta === 0);
    };
});
parcelRegister("4TnIy", function(module, exports) {
    $parcel$export(module.exports, "useShouldShowBrowserWarning", ()=>$d7857bd1d483352b$export$b44a00b70df66767);
    var $dl69W;
    var $4fT7I;
    var $4Yfcs;
    var $8UVKs;
    const $d7857bd1d483352b$export$b44a00b70df66767 = ()=>{
        const [isModalOpen] = (0, (0, parcelRequire("4fT7I")).useIsModalOpen)();
        const [isFormDirty] = (0, (0, parcelRequire("4fT7I")).useIsFormDirty)();
        const isFormSavingIssueRestore = (0, (0, parcelRequire("4Yfcs")).useIsIssueRestoreSaving)();
        const hasRestoreFailed = (0, (0, parcelRequire("dl69W")).useHasRestoreFailed)();
        const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);
        (0, (0, parcelRequire("8UVKs")).useNavigationBlock)({
            forceBlock: shouldForceBlock,
            shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty)
        });
    };
});
parcelRegister("dl69W", function(module, exports) {
    $parcel$export(module.exports, "useHasRestoreFailed", ()=>$e2abd52300870bb9$export$2f3853c4298a8e98);
    var $4fT7I;
    var $gIPBO;
    const $e2abd52300870bb9$export$2f3853c4298a8e98 = ()=>{
        const [{ restoreError: restoreError }] = (0, (0, parcelRequire("4fT7I")).useInProgressIssue)();
        const [{ restoreMetaError: restoreMetaError }] = (0, (0, parcelRequire("gIPBO")).useIssueRestoreMeta)();
        return Boolean(restoreError || restoreMetaError);
    };
});
parcelRegister("8UVKs", function(module, exports) {
    $parcel$export(module.exports, "useNavigationBlock", ()=>$393bd6724ad5ea22$export$6948be8e76411f59);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $2NMNM;
    function $393bd6724ad5ea22$var$isSameOrigin(destination) {
        const destinationOrigin = new URL(destination).origin;
        return window.location.origin === destinationOrigin;
    }
    const $393bd6724ad5ea22$var$useIsSameOriginNavigationAPI = ({ isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin, isEnabled: isEnabled })=>{
        const onNavigate = (0, $5uXOq.useCallback)((e)=>{
            if (e.destination.sameDocument) isNavigatingWithinSameOrigin.current = false;
            else isNavigatingWithinSameOrigin.current = $393bd6724ad5ea22$var$isSameOrigin(e.destination.url);
            return isNavigatingWithinSameOrigin.current;
        }, [
            isNavigatingWithinSameOrigin
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const { navigation: navigation } = window;
            if (isEnabled && navigation) {
                navigation.addEventListener('navigate', onNavigate);
                return ()=>navigation.removeEventListener('navigate', onNavigate);
            }
            return undefined;
        }, [
            isEnabled,
            onNavigate
        ]);
        return {
            onNavigate: onNavigate
        };
    };
    const $393bd6724ad5ea22$export$6948be8e76411f59 = ({ forceBlock: forceBlock = false, shouldAttemptNavigationBlock: shouldAttemptNavigationBlock })=>{
        const isNavigatingWithinSameOrigin = (0, $5uXOq.useRef)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const hasNavigationApi = Boolean(window.navigation);
        const { onNavigate: onNavigate } = $393bd6724ad5ea22$var$useIsSameOriginNavigationAPI({
            isEnabled: hasNavigationApi,
            isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin
        });
        const onBeforeUnload = (0, $5uXOq.useCallback)((e)=>{
            const analyticsPayload = {
                hasNavigationApi: hasNavigationApi,
                forceBlock: forceBlock,
                isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin.current,
                shouldAttemptNavigationBlock: shouldAttemptNavigationBlock
            };
            const shouldBlockNavigation = forceBlock || shouldAttemptNavigationBlock && !isNavigatingWithinSameOrigin.current;
            isNavigatingWithinSameOrigin.current = false;
            if (shouldBlockNavigation) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock showBrowserUnloadPrompt', analyticsPayload);
                e.preventDefault();
                const message = '';
                e.returnValue = message;
                return message;
            }
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock dontShowBrowserUnloadPrompt', analyticsPayload);
            return undefined;
        }, [
            createAnalyticsEvent,
            forceBlock,
            hasNavigationApi,
            shouldAttemptNavigationBlock
        ]);
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('beforeunload', onBeforeUnload);
            return ()=>window.removeEventListener('beforeunload', onBeforeUnload);
        }, [
            onBeforeUnload
        ]);
        return {
            onBeforeUnload: onBeforeUnload,
            onNavigate: onNavigate
        };
    };
});
parcelRegister("6i3Qj", function(module, exports) {
    $parcel$export(module.exports, "useInProgressIssueSubscriptions", ()=>$5f6947b98a583af3$export$9b41c2cd5817917a);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $5eGnF;
    var $9svjh;
    var $dl69W;
    var $4fT7I;
    const $5f6947b98a583af3$var$THROTTLE_DELAY = 250;
    const $5f6947b98a583af3$export$9b41c2cd5817917a = ()=>{
        const [, { onFormFieldUpdate: onFormFieldUpdate, onModalOpened: onModalOpened, onModalClosed: onModalClosed, onModalDiscardExistingInProgressIssue: onModalDiscardExistingInProgressIssue, onFormContextUpdate: onFormContextUpdate, onTriggerIssueCreateModalStateChange: onTriggerIssueCreateModalStateChange, onStatusFieldChange: onStatusFieldChange, onClassificationLevelFieldChange: onClassificationLevelFieldChange, onResetFormFieldsForCreateAnother: onResetFormFieldsForCreateAnother, onFormFieldConfigUpdate: onFormFieldConfigUpdate, onIssueTypeChange: onIssueTypeChange, onProjectFieldChange: onProjectFieldChange }] = (0, (0, parcelRequire("4fT7I")).useInProgressIssue)();
        const hasRestoreFailed = (0, (0, parcelRequire("dl69W")).useHasRestoreFailed)();
        const shouldSubscribe = !hasRestoreFailed;
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const throttledOnFormFieldUpdate = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($34ck9)))(onFormFieldUpdate, $5f6947b98a583af3$var$THROTTLE_DELAY, {
                leading: true,
                trailing: true
            }), [
            onFormFieldUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, throttledOnFormFieldUpdate) : undefined, [
            throttledOnFormFieldUpdate,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, onFormContextUpdate) : undefined, [
            onFormContextUpdate,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened) : undefined, [
            onModalOpened,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed) : undefined, [
            onModalClosed,
            shouldSubscribe,
            subscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, onResetFormFieldsForCreateAnother) : undefined, [
            onResetFormFieldsForCreateAnother,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>{
            shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, onTriggerIssueCreateModalStateChange) : undefined;
        }, [
            onTriggerIssueCreateModalStateChange,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, onStatusFieldChange) : undefined, [
            onStatusFieldChange,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, onClassificationLevelFieldChange) : undefined, [
            onClassificationLevelFieldChange,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, onFormFieldConfigUpdate) : undefined, [
            onFormFieldConfigUpdate,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onIssueTypeChange) : undefined, [
            onIssueTypeChange,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onProjectFieldChange) : undefined, [
            onProjectFieldChange,
            subscribe,
            shouldSubscribe
        ]);
        (0, $5uXOq.useEffect)(()=>shouldSubscribe ? subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onModalDiscardExistingInProgressIssue) : undefined, [
            onModalDiscardExistingInProgressIssue,
            shouldSubscribe,
            subscribe
        ]);
    };
});
parcelRegister("fujGs", function(module, exports) {
    $parcel$export(module.exports, "isIndexedDBAvailable", ()=>$9717920c4a4fae46$export$3865db50535c2055);
    function $9717920c4a4fae46$export$3865db50535c2055() {
        try {
            return Boolean('indexedDB' in window) && Boolean(indexedDB?.databases());
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("1n4jA", function(module, exports) {
    $parcel$export(module.exports, "useIsEmbedded", ()=>$0eb03352cf5c3676$export$77140ffa938f9fd1);
    var $doZTA;
    const $0eb03352cf5c3676$export$77140ffa938f9fd1 = ()=>{
        const [{ location: { pathname: pathname } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return pathname.endsWith('/embed');
    };
});
parcelRegister("iiKA1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d356530bb9d5bb50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $8dO33;
    var $6BZYo;
    var $65Ltd;
    var $jcw0u;
    var $4R6GH;
    var $7HGHK;
    var $pa9q9;
    var $6ikhl;
    var $f8WR0;
    var $gUfkD;
    var $gEaAu;
    var $bGrWH;
    var $c7ZNt;
    var $2ntXc;
    var $9eKoH;
    var $5eGnF;
    var $9svjh;
    var $45Cy1;
    var $c0dQj;
    var $2KAtx;
    var $cKWWX;
    var $5rzqz;
    var $6k7U1;
    var $6jY6G;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $2NMNM;
    var $dAfqg;
    var $cn7wb;
    var $5knXz;
    var $9OXo1;
    var $eyBYT;
    var $c9aLX;
    var $10zMF;
    var $kHA0a;
    var $2K6wP;
    var $lr952;
    var $6OTur;
    var $6gjIc;
    var $9U8fV;
    var $hH1l8;
    var $bvFAf;
    var $jP8gL;
    var $a2K6a;
    var $j3DvU;
    var $hFu8Z;
    var $jagDx;
    var $br2XI;
    var $7qfv0;
    var $lFNHi;
    var $hXutx;
    var $eF4iR;
    var $7beZ9;
    var $42ZoK;
    var $dXTIs;
    const $d356530bb9d5bb50$var$DisabledRestoreNavigationPrompt = ({ setShouldRestore: setShouldRestore })=>{
        const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, (0, parcelRequire("9U8fV")).useNavigationDiscardChanges)();
        const [{ isFormDirty: isFormDirty }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const onConfirmHandler = (0, $5uXOq.useCallback)(()=>{
            setShouldRestore && setShouldRestore(false);
        }, [
            setShouldRestore
        ]);
        const onCancelHandler = (0, $5uXOq.useCallback)(()=>{
            setDeferredNavigationLink('');
        }, [
            setDeferredNavigationLink
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("10zMF")).navigationDiscardChangesPromptEntrypoint),
            entryPointProps: {
                navigateLink: isFormDirty ? deferredNavigationLink : '',
                onConfirm: onConfirmHandler,
                onCancel: onCancelHandler
            },
            interactionName: "navigateWithoutRestorePrompt",
            useInternalModal: false
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7beZ9")).NavigateWithoutRestorePrompt), {
                setShouldRestore: setShouldRestore,
                ref: ref
            }));
    };
    const $d356530bb9d5bb50$var$DismissModalEntryPointWrapper = ({ children: children, entryPointProps: entryPointProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("hFu8Z")).createIssueDismissModalEntryPoint),
            entryPointProps: entryPointProps,
            interactionName: "create-issue-dismiss-modal",
            modalProps: {
                width: 'small'
            },
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, children));
    const $d356530bb9d5bb50$var$CreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore, onResetApolloCache: onResetApolloCache })=>{
        const sessionIdRef = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($7Jxgt))).v4());
        const [{ payload: triggerIssueCreatePayload, displayOnlyRequiredFields: displayOnlyRequiredFields, disableCreationSuccessFlag: disableCreationSuccessFlag, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, isModalLoadInContext: isModalLoadInContext, triggerPointKey: triggerPointKey, interactedWithModalChangerButtons: interactedWithModalChangerButtons, inProgressIssueID: inProgressIssueID, sessionId: sessionId, wasStateRestored: wasStateRestored, isCustomBoardWithIcc: isCustomBoardWithIcc, jqlSwimlaneId: jqlSwimlaneId, swimlaneMode: swimlaneMode, ecosystemCallback: ecosystemCallback, product: product, actionSource: actionSource }, { setSessionId: setSessionId }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        (0, $5uXOq.useEffect)(()=>{
            if (!sessionId) setSessionId(sessionIdRef.current);
        }, [
            sessionId,
            setSessionId
        ]);
        const { showEnforcementIfPendingToShow: showEnforcementIfPendingToShow } = (0, (0, parcelRequire("5knXz")).useStorageEnforcement)();
        const [{ isLoading: isModalLoading, fieldConfig: modalFieldConfig, fieldTabs: modalFieldTabs, contextFields: modalContextFields, meta: modalFieldsDataMeta, error: modalFieldsDataError, apiLatency: modalApiLatency, additionalServices: modalAdditionalServices }, fetchModalConfig] = (0, (0, parcelRequire("j3DvU")).default)({
            displayOnlyRequiredFields: displayOnlyRequiredFields,
            triggerPointKey: triggerPointKey,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            triggerIssueCreatePayload: triggerIssueCreatePayload,
            isModalLoadInContext: isModalLoadInContext,
            ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                isCreateLinkedIssue: isCreateLinkedIssue
            } : {}
        });
        const classificationFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraDataClassificationField');
        const classificationFieldConfig = classificationFieldId ? modalFieldConfig[classificationFieldId] : undefined;
        const proformaConfiguration = modalAdditionalServices?.proformaConfiguration;
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const dirtyFieldsCurrentSession = (0, $5uXOq.useRef)({});
        const getFormState = (0, $5uXOq.useRef)(()=>null);
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const [{ isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, shouldShowConfigureFieldModal: shouldShowConfigureFieldModal, shouldShowFindFieldModal: shouldShowFindFieldModal, selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, dataFetchError: dataFetchError, isFormDirty: isCreateFormDirty, canCreateAnotherIssue: canCreateAnotherIssue, createdIssues: createdIssues }, { resetFormContext: resetFormContext, toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setForgeModules: setForgeModules, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setCanCreateAnotherIssue: setCanCreateAnotherIssue, addCreatedIssue: addCreatedIssue }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const [, { resetState: resetState }] = (0, (0, parcelRequire("6ikhl")).useInlineFieldsActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const { withMachineLearning: withMachineLearning } = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("lr952")).useSmartFieldsMachineLearning)() : {
            withMachineLearning: false
        };
        const shouldDisableActions = dataFetchError !== null;
        (0, $5uXOq.useEffect)(()=>{
            if (shouldDisableActions && setShouldRestore) {
                if (selectedProject === null) {
                    const analyticsEvent = createAnalyticsEvent({
                        actionSubject: 'noselectedproject',
                        action: 'error'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createIssueViewError');
                }
                setShouldRestore(false);
            }
        }, [
            shouldDisableActions,
            setShouldRestore,
            selectedProject,
            createAnalyticsEvent
        ]);
        const initFetchConfig = (0, $5uXOq.useCallback)(()=>{
            const issueCreateType = isCreateLinkedIssue && isModalLoadInContext && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                issueCreateType: isCreateLinkedIssue ? (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).linkedIssue : (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).standard
            } : {};
            if (!triggerIssueCreatePayload) fetchModalConfig({
                variables: (0, (0, parcelRequire("br2XI")).getQueryVariables)((0, (0, parcelRequire("br2XI")).getIssueCreateProjectForMount)(projectContext), null)
            });
            else {
                const { customFieldsToPreserveOnFormRecreation: customFieldsToPreserveOnFormRecreation = [], ...mainPayload } = triggerIssueCreatePayload;
                const parentId = mainPayload.parentId || null;
                const additionalContext = mainPayload.additionalContext || null;
                const projectPayload = (0, ($parcel$interopDefault($gccSB)))(mainPayload.project) ? null : mainPayload.project;
                fetchModalConfig({
                    variables: {
                        project: projectPayload,
                        issueType: mainPayload.issueType || null,
                        requestType: mainPayload.requestType || null,
                        defaultValues: mainPayload.defaultValues || null,
                        issueTypes: mainPayload.issueTypes || null,
                        requestTypes: mainPayload.requestTypes || null,
                        parentId: parentId,
                        additionalContext: additionalContext,
                        ...issueCreateType
                    }
                });
                dirtyFieldsCurrentSession.current = {
                    ...dirtyFieldsCurrentSession.current,
                    ...Object.fromEntries(customFieldsToPreserveOnFormRecreation.map((k)=>[
                            k,
                            true
                        ]))
                };
            }
        }, [
            isCreateLinkedIssue,
            isModalLoadInContext,
            triggerIssueCreatePayload,
            fetchModalConfig,
            projectContext
        ]);
        const [{ siteDomain: siteDomain, selectedCloudId: selectedCloudId }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        const [{ isLoading: isTransitionsLoading, error: transitionsError, transitions: transitions }, fetchTransitions] = (0, (0, parcelRequire("a2K6a")).default)();
        const shouldShowStatus = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("br2XI")).shouldShowStatusField)(selectedProject?.projectType, modalFieldConfig), [
            selectedProject,
            modalFieldConfig
        ]);
        const { resetAndReloadCreateForm: resetAndReloadCreateForm } = (0, (0, parcelRequire("bvFAf")).useIssueCreateFromAnywhereContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldShowStatus && selectedProject && selectedIssueType && !resetAndReloadCreateForm) fetchTransitions({
                projectId: selectedProject.value,
                issueTypeId: selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
                selectedCloudId: selectedCloudId
            });
        }, [
            fetchTransitions,
            selectedProject,
            selectedIssueType,
            shouldShowStatus,
            selectedCloudId,
            resetAndReloadCreateForm
        ]);
        const extraContext = (0, $5uXOq.useMemo)(()=>({
                issueType: selectedIssueType?.label,
                projectKey: selectedProject?.projectKey,
                classificationTags: selectedProject?.classificationTags
            }), [
            selectedProject,
            selectedIssueType
        ]);
        const { customFields: customFields, issueAdjustmentModules: issueAdjustmentModules, filteredOutModules: filteredOutModules, loadingStatus: loadingStatus } = (0, (0, parcelRequire("jP8gL")).useFetchForgeModules)(extraContext);
        const hasForgeFinishedLoading = loadingStatus === 'success' || loadingStatus === 'error';
        (0, $5uXOq.useEffect)(()=>{
            if (selectedProject && selectedIssueType) setForgeModules(customFields, issueAdjustmentModules, filteredOutModules, hasForgeFinishedLoading);
        }, [
            issueAdjustmentModules,
            setForgeModules,
            customFields,
            hasForgeFinishedLoading,
            filteredOutModules,
            selectedProject,
            selectedIssueType,
            shouldShowStatus
        ]);
        const [showIssuesCreated, setShowIssuesCreated] = (0, $5uXOq.useState)(false);
        const isApiCallTriggered = (0, $5uXOq.useRef)(false);
        if (!isApiCallTriggered.current) {
            initFetchConfig();
            inProgressIssueID && publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_OPENED, {
                inProgressIssueID: inProgressIssueID
            });
            const restoredCreatedIssuesExists = createdIssues?.length > 0;
            restoredCreatedIssuesExists && setShowIssuesCreated(restoredCreatedIssuesExists);
            isApiCallTriggered.current = true;
        }
        const [{ globalEventNamespaces: globalEventNamespaces, fieldsToAddInPublishedData: fieldsToAddInPublishedData, alertsToBeLinked: alertsToBeLinked, onIssueCreate: onIssueCreate, onClose: onClose, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, callbackPayload: callbackPayload }, { closeIssueCreateModal: closeIssueCreateModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const closeIssueCreateModalNew = (0, $5uXOq.useCallback)((issuesCreated)=>{
            closeIssueCreateModal(Boolean(issuesCreated?.length));
            inProgressIssueID && publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
                callbackPayload: callbackPayload,
                inProgressIssueID: inProgressIssueID,
                createdIssues: issuesCreated
            });
        }, [
            callbackPayload,
            closeIssueCreateModal,
            inProgressIssueID,
            publish
        ]);
        if (isGICPositioningEnabled()) {
            const [{ shouldInitFetchConfig: shouldInitFetchConfig }, { resetShouldInitFetchConfig: resetShouldInitFetchConfig }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
            (0, $5uXOq.useEffect)(()=>{
                if (shouldInitFetchConfig || resetAndReloadCreateForm) {
                    resetShouldInitFetchConfig();
                    initFetchConfig();
                }
            }, [
                initFetchConfig,
                resetShouldInitFetchConfig,
                shouldInitFetchConfig,
                resetAndReloadCreateForm
            ]);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (resetAndReloadCreateForm) resetFormContext();
        }, [
            resetAndReloadCreateForm,
            resetFormContext
        ]);
        const sourceThatFiredModalDismiss = (0, $5uXOq.useRef)(null);
        const [objectId, setObjectId] = (0, $5uXOq.useState)(undefined);
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const isCompanyManagedBoard = route?.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD) || route?.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD) || route?.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS);
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const showSuccessFlag = (0, $5uXOq.useCallback)((issueList, successFlagParams)=>{
            if (issueList?.length && !disableCreationSuccessFlag) {
                const flagId = (0, (0, parcelRequire("7HGHK")).toFlagId)((0, ($parcel$interopDefault($7Jxgt))).v4());
                const issueDiscoveryUrl = (0, (0, parcelRequire("2K6wP")).getIssueDiscoveryUrl)(issueList);
                showFlag({
                    id: flagId,
                    render: (flagProps)=>{
                        const successFlagProps = {
                            key: flagProps.key,
                            flagKey: flagProps.key,
                            id: flagId,
                            issueList: issueList,
                            issueDiscoveryUrl: issueDiscoveryUrl
                        };
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42ZoK")).default), {
                            ...successFlagProps,
                            successFlagParams: successFlagParams
                        });
                    }
                });
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'flag',
                    action: 'viewed'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createIssueSuccessNotification');
            }
        }, [
            createAnalyticsEvent,
            disableCreationSuccessFlag,
            showFlag
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const api = {
                renderSuccessFlag: (params)=>{
                    const issueList = params.issues.map((issue)=>({
                            issueId: issue.issueId,
                            issueKey: issue.issueKey
                        }));
                    (0, (0, parcelRequire("gEaAu")).successFlagDisplay).stop();
                    showSuccessFlag(issueList, params);
                }
            };
            if (isCompanyManagedBoard) (0, (0, parcelRequire("6BZYo")).loadBridge)({
                name: 'jira-agile/rapid/ui/gic-success-flag/bridge'
            }).then((bridge)=>bridge(api));
        }, [
            showSuccessFlag,
            isCompanyManagedBoard
        ]);
        const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)() : [
            {
                minimizableModalView: undefined
            }
        ];
        const [{ shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { updateView: updateView } = (0, (0, parcelRequire("cn7wb")).usePersistentIssueCreateModalViewResource)();
        const performCleanUp = (0, $5uXOq.useCallback)((shouldPublishCreatedIssues = false, issuesCreated)=>{
            const issueList = issuesCreated ?? createdIssues ?? [];
            if (!isCompanyManagedBoard) showSuccessFlag(issueList);
            else (0, (0, parcelRequire("gEaAu")).successFlagDisplay).start();
            const isMobileExperienceEnabled = (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)();
            closeIssueCreateModalNew(issueList);
            if (issuesCreated && !isMobileExperienceEnabled) updateView(minimizableModalView === 'mini' ? 'mini' : 'modal');
            if (shouldPublishCreatedIssues) (0, (0, parcelRequire("dXTIs")).publishCreatedIssues)({
                createdIssues: issueList,
                globalEventNamespaces: globalEventNamespaces,
                fieldsToAddInPublishedData: fieldsToAddInPublishedData,
                alertsToBeLinked: alertsToBeLinked,
                isSessionComplete: true,
                onIssueCreate: null,
                onClose: onClose,
                triggerPointKey: triggerPointKey,
                publishGICLifecycle: publish,
                inProgressIssueID: inProgressIssueID,
                callbackPayload: callbackPayload,
                selectedCloudId: selectedCloudId,
                jqlSwimlaneId: jqlSwimlaneId,
                ecosystemCallback: ecosystemCallback
            });
        }, [
            createdIssues,
            isCompanyManagedBoard,
            closeIssueCreateModalNew,
            showSuccessFlag,
            updateView,
            minimizableModalView,
            globalEventNamespaces,
            fieldsToAddInPublishedData,
            alertsToBeLinked,
            onClose,
            triggerPointKey,
            publish,
            inProgressIssueID,
            callbackPayload,
            selectedCloudId,
            jqlSwimlaneId,
            ecosystemCallback
        ]);
        const onCreateAnotherChange = (_, analyticsEvent)=>{
            setCanCreateAnotherIssue(!canCreateAnotherIssue);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createAnotherIssue', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
        };
        const handleTabIndexEmptyContainingRequiredField = ()=>{
            try {
                const fieldValues = getFormState.current()?.values || null;
                const tabIndex = (0, (0, parcelRequire("dXTIs")).getTabIndexWithError)(modalFieldTabs, fieldValues, modalFieldConfig);
                setCurrentActiveTabIndex(tabIndex);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        packageName: 'jiraIssueCreate',
                        id: 'gicModalTabChangeOnSubmit',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const handleEmptyAndRequiredFields = ()=>{
            try {
                const fieldValues = getFormState.current()?.values || null;
                let emptyRequiredFields = [];
                if (modalFieldConfig) emptyRequiredFields = Object.keys(modalFieldConfig)?.filter((fieldId)=>Boolean(modalFieldConfig[fieldId].isRequired) && fieldValues && (0, ($parcel$interopDefault($gccSB)))(fieldValues[fieldId]));
                const firstFieldIdWithError = (0, (0, parcelRequire("dXTIs")).getFirstFieldIdWithError)({
                    fields: Object.keys(fieldValues || {}),
                    emptyRequiredFields: emptyRequiredFields
                });
                (0, (0, parcelRequire("kHA0a")).scrollToField)(firstFieldIdWithError);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        packageName: 'jiraIssueCreate',
                        id: 'gicModalNextRequiredFieldFocusOnSubmit',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const onSubmit = (_, analyticsEvent)=>{
            handleTabIndexEmptyContainingRequiredField();
            handleEmptyAndRequiredFields();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createIssue', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none',
                gicSessionId: sessionIdRef.current
            });
        };
        const showWatchersWarningOrErrorFlag = (0, $5uXOq.useCallback)((response)=>{
            const config = (0, (0, parcelRequire("dXTIs")).getWatchersFlagConfigFromResponse)(response);
            if (config) setTimeout(()=>{
                showFlag(config);
            }, 600);
        }, [
            showFlag
        ]);
        const onIssueCreateSuccess = (0, $5uXOq.useCallback)((createdIssue, watchersResponse)=>{
            const issuesCreated = addCreatedIssue(createdIssue);
            setObjectId(String(createdIssue?.issueId));
            setShowIssuesCreated(showIssuesCreated || canCreateAnotherIssue);
            (0, (0, parcelRequire("dXTIs")).publishCreatedIssues)({
                createdIssues: [
                    createdIssue
                ],
                globalEventNamespaces: globalEventNamespaces,
                fieldsToAddInPublishedData: fieldsToAddInPublishedData,
                alertsToBeLinked: alertsToBeLinked,
                onIssueCreate: onIssueCreate,
                siteDomain: siteDomain,
                selectedCloudId: selectedCloudId,
                onClose: onClose,
                inProgressIssueID: inProgressIssueID,
                publishGICLifecycle: publish,
                isIssueCreateSuccess: true,
                callbackPayload: callbackPayload,
                jqlSwimlaneId: jqlSwimlaneId,
                ecosystemCallback: ecosystemCallback
            });
            if (!canCreateAnotherIssue) performCleanUp(true, issuesCreated);
            showWatchersWarningOrErrorFlag(watchersResponse);
        }, [
            addCreatedIssue,
            showIssuesCreated,
            canCreateAnotherIssue,
            globalEventNamespaces,
            fieldsToAddInPublishedData,
            alertsToBeLinked,
            onIssueCreate,
            siteDomain,
            selectedCloudId,
            onClose,
            inProgressIssueID,
            publish,
            callbackPayload,
            jqlSwimlaneId,
            ecosystemCallback,
            showWatchersWarningOrErrorFlag,
            performCleanUp
        ]);
        const showConfirmDismissModal = (source)=>{
            sourceThatFiredModalDismiss.current = source;
        };
        const hideConfirmDismissModal = ()=>{
            sourceThatFiredModalDismiss.current = null;
        };
        const onModalClose = (_, analyticsEvent, source)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, source, {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
            showEnforcementIfPendingToShow();
            performCleanUp(true);
            resetState();
        };
        const onModalCloseWithConfirm = (source)=>(_, analyticsEvent)=>{
                if (!isCreateFormDirty) {
                    onModalClose(_, analyticsEvent, source);
                    return;
                }
                showConfirmDismissModal(source);
            };
        const onConfirmDismissModalCancel = ()=>{
            hideConfirmDismissModal();
        };
        const onConfirmDismissModalConfirm = (_, analyticsEvent)=>{
            const source = sourceThatFiredModalDismiss && sourceThatFiredModalDismiss.current || '';
            onModalClose(_, analyticsEvent, source);
        };
        const [resetFormFieldsCounter, setResetFormFieldsCounter] = (0, $5uXOq.useState)(0);
        const incrementResetCounter = (0, $5uXOq.useCallback)(()=>{
            setResetFormFieldsCounter((n)=>n + 1);
        }, []);
        const hideConfigureFieldsModal = ()=>{
            toggleConfigureFieldsModalVisibility(false);
        };
        const hideFindFieldModal = ()=>{
            toggleFindFieldsModalVisibility(false);
        };
        const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, onOpenSpotlight: onOpenSpotlight, onCloseSpotlight: onCloseSpotlight } = isGICPositioningEnabled() ? (0, (0, parcelRequire("6OTur")).useChangerSpotlight)(minimizableModalView) : {};
        (0, $5uXOq.useEffect)(()=>resetFormContext, [
            resetFormContext
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const sprintFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraSprintField');
            if (sprintFieldId !== undefined) fieldsToAddInPublishedData.push(sprintFieldId);
        }, [
            fieldsToAddInPublishedData,
            modalFieldConfig
        ]);
        const fieldPropsExtensions = isGICPositioningEnabled() ? {
            description: {
                onFocus: onOpenSpotlight,
                onBlur: onCloseSpotlight
            }
        } : undefined;
        const preselectedStatus = triggerIssueCreatePayload?.status?.statusId;
        const classificationFieldProps = (0, (0, parcelRequire("2ntXc")).useClassificationFieldProps)(classificationFieldConfig);
        const buildCreateFormProps = (0, $5uXOq.useCallback)(()=>({
                isLoading: isModalLoading,
                fieldConfig: modalFieldConfig,
                fieldTabs: modalFieldTabs,
                contextFields: modalContextFields,
                meta: modalFieldsDataMeta,
                error: modalFieldsDataError,
                apiLatency: modalApiLatency,
                onFetchConfig: fetchModalConfig,
                onIssueCreateSuccess: onIssueCreateSuccess,
                canCreateAnotherIssue: canCreateAnotherIssue,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                getFormState: getFormState,
                onFormFieldsReset: incrementResetCounter,
                fieldPropsExtensions: fieldPropsExtensions,
                onResetApolloCache: onResetApolloCache,
                filteredOutModules: filteredOutModules,
                ...classificationFieldConfig && Array.isArray(classificationFieldConfig?.allowedValues) && classificationFieldConfig.allowedValues.length > 0 ? {
                    classificationFieldProps: classificationFieldProps
                } : {},
                ...shouldShowStatus ? {
                    statusFieldProps: {
                        preselectedTransition: transitions?.find((transition)=>transition.to.id === preselectedStatus),
                        initialTransition: transitions?.find((it)=>it.isInitial),
                        availableTransitions: transitions,
                        isTransitionsLoading: isTransitionsLoading,
                        transitionsError: transitionsError
                    }
                } : Object.freeze({}),
                proformaConfiguration: proformaConfiguration,
                watchersConfigurations: modalAdditionalServices.watchersConfigurations
            }), [
            isModalLoading,
            modalFieldConfig,
            modalFieldTabs,
            modalContextFields,
            modalFieldsDataMeta,
            modalFieldsDataError,
            modalApiLatency,
            fetchModalConfig,
            onIssueCreateSuccess,
            canCreateAnotherIssue,
            incrementResetCounter,
            fieldPropsExtensions,
            classificationFieldConfig,
            classificationFieldProps,
            shouldShowStatus,
            transitions,
            isTransitionsLoading,
            transitionsError,
            preselectedStatus,
            proformaConfiguration,
            onResetApolloCache,
            modalAdditionalServices.watchersConfigurations,
            filteredOutModules
        ]);
        const createFormProps = (0, $5uXOq.useMemo)(()=>{
            let formProps = buildCreateFormProps();
            if (onTransformCreateFormProps) formProps = onTransformCreateFormProps(formProps);
            return formProps;
        }, [
            buildCreateFormProps,
            onTransformCreateFormProps
        ]);
        const renderFormOrError = ()=>{
            if (shouldDisableActions) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qfv0")).default), null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jagDx")).default), createFormProps);
        };
        const currentUIModificationsConsentState = (0, (0, parcelRequire("f8WR0")).useUIModificationsConsentStatus)();
        const getShouldDisableSubmit = ()=>currentUIModificationsConsentState === (0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38) || !meta.areRequiredFieldsSupported || shouldDisableActions || !(0, ($parcel$interopDefault($gccSB)))(meta.queryErrorMessage);
        const [{ data: isRequestTypeFieldsLayoutEnabled }, { initialise: initialise }] = (0, (0, parcelRequire("hH1l8")).useRequestTypeFieldsLayoutPreference)();
        (0, $5uXOq.useEffect)(()=>{
            if (atlassianAccountId) initialise(atlassianAccountId, createAnalyticsEvent);
        }, [
            atlassianAccountId,
            createAnalyticsEvent,
            initialise
        ]);
        const isRequestTypeSelected = selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44);
        const renderConfigureFieldsModal = ()=>shouldShowConfigureFieldModal && selectedProject && selectedIssueType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9eKoH")).default), {
                onCancel: hideConfigureFieldsModal,
                project: {
                    projectId: selectedProject.value,
                    projectType: selectedProject.projectType
                },
                issueTypeId: isRequestTypeSelected ? selectedIssueType.issueTypeId : selectedIssueType.value,
                requestTypeKey: isRequestTypeSelected ? selectedIssueType.requestTypeKey : undefined,
                parentId: triggerIssueCreatePayload?.parentId?.parentId,
                setAreConfiguredFieldsModified: setAreConfiguredFieldsModified,
                onlyDisplayAllFieldsOption: isRequestTypeFieldsLayoutEnabled && isRequestTypeSelected,
                messageContent: isRequestTypeSelected ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hXutx")).JsmRequestTypeFieldsChangeboarding), null) : undefined
            }) : null;
        const renderFindFieldModal = ()=>shouldShowFindFieldModal && selectedProject && selectedIssueType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUfkD")).default), {
                project: {
                    projectId: selectedProject.value,
                    nextGenProject: selectedProject.isSimplified,
                    projectType: selectedProject.projectType
                },
                issueTypeId: selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
                operation: "CREATE",
                onCancel: hideFindFieldModal
            }) : null;
        const renderExistingGicWarningModal = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lFNHi")).ExistingGICWarning), null);
        const renderDisabledRestoreNavigationPrompt = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($d356530bb9d5bb50$var$DisabledRestoreNavigationPrompt, {
                setShouldRestore: setShouldRestore
            });
        const modalWrapper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF4iR")).ModalWrapper), {
            onModalCloseWithConfirm: onModalCloseWithConfirm,
            shouldDisableActions: shouldDisableActions,
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            isOperationInProgress: isOperationInProgress,
            canCreateAnotherIssue: canCreateAnotherIssue,
            onCreateAnotherChange: onCreateAnotherChange,
            getShouldDisableSubmit: getShouldDisableSubmit,
            createdIssues: createdIssues,
            displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
            shouldShowChangerSpotlight: isGICPositioningEnabled() ? !interactedWithModalChangerButtons && shouldShowChangerSpotlight : undefined,
            showIssuesCreated: showIssuesCreated,
            initialSummaryValue: (0, ($parcel$interopDefault($gccSB)))(createFormProps.fieldConfig) ? null : createFormProps.fieldConfig?.summary?.defaultValue || '',
            projectType: selectedProject?.projectType,
            selectedIssueType: selectedIssueType,
            setShouldRestore: setShouldRestore,
            watchersConfigurations: modalAdditionalServices.watchersConfigurations,
            ...isCreateFormDirty && selectedProject ? {
                dismissModalEntryPointWrapper: (p)=>(0, ($parcel$interopDefault($5uXOq))).createElement($d356530bb9d5bb50$var$DismissModalEntryPointWrapper, {
                        ...p,
                        entryPointProps: {
                            project: {
                                projectId: selectedProject.value,
                                projectType: selectedProject.projectType
                            },
                            sessionId: sessionIdRef.current,
                            onClose: onConfirmDismissModalCancel,
                            onConfirm: onConfirmDismissModalConfirm
                        }
                    })
            } : {}
        }, !isGICPositioningEnabled() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), null, renderFormOrError()), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9aLX")).UiModificationsEntryPoint), {
            issueTypeFieldType: modalContextFields.issuetype?.type || '',
            modalFieldConfig: modalFieldConfig,
            modules: issueAdjustmentModules,
            resetFormFieldsCounter: resetFormFieldsCounter,
            selectedIssueType: selectedIssueType,
            selectedProject: selectedProject,
            triggerPointKey: triggerPointKey
        }), renderConfigureFieldsModal(), renderFindFieldModal(), isGICPositioningEnabled() && renderExistingGicWarningModal(), renderDisabledRestoreNavigationPrompt());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "createIssue",
            containerType: "project",
            objectType: "issue",
            objectId: objectId,
            containerId: selectedProject ? selectedProject.value : '',
            attributes: {
                isNewGIC: true,
                isCreatingAnotherIssue: canCreateAnotherIssue,
                isSubtask: isSubTaskCreationOpen,
                triggerPointKey: triggerPointKey,
                projectType: selectedProject?.projectType,
                ...selectedProject ? {
                    nextGenProject: selectedProject.isSimplified
                } : {},
                ...isGICPositioningEnabled() ? {
                    gicViewState: minimizableModalView
                } : {},
                ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                    isCreateLinkedIssue: isCreateLinkedIssue
                } : {},
                hasProformaForm: !!proformaConfiguration?.hasProformaForm,
                wasStateRestored: wasStateRestored,
                isDiscoverabilityPush: !!shouldPushMiniModalDiscoverability && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(triggerPointKey),
                smartFieldsEnabled: withMachineLearning,
                sessionId: !sessionId ? sessionIdRef.current : sessionId,
                isCustomBoardWithIcc: isCustomBoardWithIcc,
                swimlaneMode: swimlaneMode,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...product ? {
                        product: product
                    } : {},
                    ...actionSource ? {
                        actionSource: actionSource
                    } : {}
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eyBYT")).UiModificationsContainer), null, modalWrapper));
    };
    var $d356530bb9d5bb50$export$2e2bcd8739ae039 = $d356530bb9d5bb50$var$CreateModal;
});
parcelRegister("8dO33", function(module, exports) {
    $parcel$export(module.exports, "SmartCardProvider", ()=>$08b794feb02c83c1$export$497ecb0280204df4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3f2cs = parcelRequire("3f2cs");
    var $cCcdH;
    var $k9B19;
    var $8b7fu;
    var $kECas;
    var $7cFR3;
    function $08b794feb02c83c1$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext));
        const defaultInitialState = (0, $5uXOq.useMemo)(()=>{
            return {};
        }, []);
        const { initialState: initialState } = storeOptions || {
            initialState: defaultInitialState
        };
        const store = (0, $5uXOq.useMemo)(()=>{
            return (0, $3f2cs.createStore)((0, (0, parcelRequire("8b7fu")).cardReducer), initialState);
        }, [
            initialState
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>{
            const client = customClient || new (0, (0, parcelRequire("7cFR3")).default)();
            if (product && client.setProduct) client.setProduct(product);
            const authFlow = customAuthFlow || 'oauth2';
            const getPreview = (url, platform)=>{
                const cardState = (0, (0, parcelRequire("cCcdH")).getUrl)(store, url);
                return cardState.details ? (0, (0, parcelRequire("k9B19")).extractPreview)(cardState.details.data, platform) : undefined;
            };
            return {
                renderers: renderers,
                store: store,
                prefetchStore: {},
                connections: {
                    client: client
                },
                config: {
                    authFlow: authFlow
                },
                extractors: {
                    getPreview: getPreview
                },
                featureFlags: featureFlags,
                isAdminHubAIEnabled: isAdminHubAIEnabled,
                product: product
            };
        }, [
            customClient,
            customAuthFlow,
            isAdminHubAIEnabled,
            product,
            renderers,
            featureFlags,
            store
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kECas")).SmartCardContext).Provider, {
            value: parentContext || providerValue
        }, children);
    }
    var $08b794feb02c83c1$export$2e2bcd8739ae039 = $08b794feb02c83c1$export$497ecb0280204df4;
});
parcelRegister("cCcdH", function(module, exports) {
    $parcel$export(module.exports, "getUrl", ()=>$ca3b29c0c8dd3593$export$94df0e59ebebf4a7);
    const $ca3b29c0c8dd3593$export$94df0e59ebebf4a7 = (store, url)=>{
        return store.getState()[url] || {
            status: 'pending'
        };
    };
});
parcelRegister("k9B19", function(module, exports) {
    $parcel$export(module.exports, "extractPreview", ()=>$596309a7bcc79771$export$4b0d98b1b7f6d115);
    var $TFljV;
    var $7OmtM;
    const $596309a7bcc79771$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
        const preview = jsonLd?.preview;
        const isSupported = (0, (0, parcelRequire("TFljV")).extractPlatformIsSupported)(preview, platform);
        if (preview && isSupported) {
            if (typeof preview === 'string') return {
                src: preview
            };
            else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                src: preview.interactiveHref,
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else if (preview['@type'] === 'Link') return {
                src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview),
                aspectRatio: preview['atlassian:aspectRatio']
            };
            else {
                if (preview.url || preview.href) {
                    if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                        src: preview.interactiveHref,
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                    return {
                        src: (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(preview.url || preview.href),
                        aspectRatio: preview['atlassian:aspectRatio']
                    };
                } else if (preview.content) return {
                    content: preview.content
                };
            }
        }
    };
});
parcelRegister("TFljV", function(module, exports) {
    $parcel$export(module.exports, "extractPlatformIsSupported", ()=>$f8cdc1e628cbc347$export$3e8ad908070b68b2);
    const $f8cdc1e628cbc347$export$3e8ad908070b68b2 = (preview, platform)=>{
        if (preview) {
            if (typeof preview === 'string') return true;
            else {
                const supportedPlatforms = preview['atlassian:supportedPlatforms'];
                if (supportedPlatforms) {
                    const isWeb = platform === 'web';
                    return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
                }
                return true;
            }
        }
        return false;
    };
});
parcelRegister("7OmtM", function(module, exports) {
    $parcel$export(module.exports, "extractUrlFromLinkJsonLd", ()=>$0784379594099aa0$export$396ba4ef2e37dc65);
    const $0784379594099aa0$export$396ba4ef2e37dc65 = (link)=>{
        if (typeof link === 'string') return link;
        else if (Array.isArray(link)) {
            if (link.length > 0) return $0784379594099aa0$export$396ba4ef2e37dc65(link[0]);
        } else return link.href;
    };
});
parcelRegister("8b7fu", function(module, exports) {
    $parcel$export(module.exports, "cardReducer", ()=>$92a815d7e26b35c0$export$3c7c3113a97b6492);
    var $2yPrN;
    var $fiKQs;
    const $92a815d7e26b35c0$var$isCardAction = (action)=>{
        return [
            (0, (0, parcelRequire("2yPrN")).ACTION_PENDING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING),
            (0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED),
            (0, (0, parcelRequire("2yPrN")).ACTION_RELOADING),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR),
            (0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK),
            (0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS)
        ].includes(action.type);
    };
    function $92a815d7e26b35c0$var$persistPayloadToState(payload, state, type) {
        const nextDetails = payload;
        const nextState = {
            ...state
        };
        if (nextDetails) {
            nextState.status = (0, (0, parcelRequire("fiKQs")).getStatus)(nextDetails);
            nextState.details = nextDetails;
        } else nextState.status = type;
        return nextState;
    }
    function $92a815d7e26b35c0$var$reduceToNextState(state, action) {
        switch(action.type){
            case 0, (0, parcelRequire("2yPrN")).ACTION_PENDING:
                return {
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVING:
                return {
                    ...state,
                    status: action.type
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, action.type);
            case 0, (0, parcelRequire("2yPrN")).ACTION_RELOADING:
                return $92a815d7e26b35c0$var$persistPayloadToState(action.payload, state, 'resolved');
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR:
                return {
                    ...state,
                    status: action.type,
                    error: action.error
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK:
                return {
                    ...state,
                    status: action.type,
                    error: action.error,
                    details: action.payload
                };
            case 0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS:
                return {
                    ...state,
                    metadataStatus: action.metadataStatus
                };
        }
    }
    const $92a815d7e26b35c0$export$3c7c3113a97b6492 = (state, action)=>{
        if (!$92a815d7e26b35c0$var$isCardAction(action)) return state;
        const cardState = state[action.url];
        const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
        if (hasSameStatus) return state;
        else {
            const nextState = $92a815d7e26b35c0$var$reduceToNextState(cardState, action);
            return {
                ...state,
                [action.url]: nextState
            };
        }
    };
});
parcelRegister("2yPrN", function(module, exports) {
    $parcel$export(module.exports, "ACTION_PENDING", ()=>$23a1ee9f12bb755d$export$6e470aad5ba8952e);
    $parcel$export(module.exports, "ACTION_RESOLVING", ()=>$23a1ee9f12bb755d$export$9a6a932a0a39498e);
    $parcel$export(module.exports, "ACTION_RESOLVED", ()=>$23a1ee9f12bb755d$export$63ec8bc7a8a75482);
    $parcel$export(module.exports, "ACTION_RELOADING", ()=>$23a1ee9f12bb755d$export$b8cfaa842c9ab487);
    $parcel$export(module.exports, "ACTION_ERROR", ()=>$23a1ee9f12bb755d$export$6d8ed3f9433dd372);
    $parcel$export(module.exports, "ACTION_ERROR_FALLBACK", ()=>$23a1ee9f12bb755d$export$cfbbb7126bc8a0c6);
    $parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", ()=>$23a1ee9f12bb755d$export$2c5edb971b673330);
    $parcel$export(module.exports, "cardAction", ()=>$23a1ee9f12bb755d$export$a884a52152489cc3);
    const $23a1ee9f12bb755d$export$6e470aad5ba8952e = 'pending';
    const $23a1ee9f12bb755d$export$9a6a932a0a39498e = 'resolving';
    const $23a1ee9f12bb755d$export$63ec8bc7a8a75482 = 'resolved';
    const $23a1ee9f12bb755d$export$b8cfaa842c9ab487 = 'reloading';
    const $23a1ee9f12bb755d$export$6d8ed3f9433dd372 = 'errored';
    const $23a1ee9f12bb755d$export$cfbbb7126bc8a0c6 = 'fallback';
    const $23a1ee9f12bb755d$export$76b5c1aca20759c6 = 'preload';
    const $23a1ee9f12bb755d$export$2c5edb971b673330 = 'metadata';
    const $23a1ee9f12bb755d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
            type: type,
            url: url,
            payload: payload,
            error: error,
            metadataStatus: metadataStatus,
            ignoreStatusCheck: ignoreStatusCheck
        });
});
parcelRegister("fiKQs", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$5c2f531cb20db568$export$b70265791d2079d4);
    const $5c2f531cb20db568$var$getStatusForNotFoundVisibility = (meta)=>{
        const accessType = meta.requestAccess?.accessType;
        if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
        return 'forbidden';
    };
    const $5c2f531cb20db568$export$b70265791d2079d4 = ({ meta: meta })=>{
        const { access: access, visibility: visibility } = meta;
        switch(access){
            case 'forbidden':
                if (visibility === 'not_found') return $5c2f531cb20db568$var$getStatusForNotFoundVisibility(meta);
                else return 'forbidden';
            case 'unauthorized':
                return 'unauthorized';
            default:
                return 'resolved';
        }
    };
});
parcelRegister("kECas", function(module, exports) {
    $parcel$export(module.exports, "SmartCardContext", ()=>$b53b46c99cf8fc02$export$156b523e63b4f63a);
    $parcel$export(module.exports, "useSmartLinkContext", ()=>$b53b46c99cf8fc02$export$e1d190b530cf0ee9);
    var $5uXOq = parcelRequire("5uXOq");
    const $b53b46c99cf8fc02$export$156b523e63b4f63a = (0, $5uXOq.createContext)(undefined);
    function $b53b46c99cf8fc02$export$e1d190b530cf0ee9() {
        const context = (0, $5uXOq.useContext)($b53b46c99cf8fc02$export$156b523e63b4f63a);
        if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
        return context;
    }
    var $b53b46c99cf8fc02$export$2e2bcd8739ae039 = $b53b46c99cf8fc02$export$156b523e63b4f63a;
});
parcelRegister("7cFR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d96ed473518bd99$export$2e2bcd8739ae039);
    var $hhZW9 = parcelRequire("hhZW9");
    var $hj8yn = parcelRequire("hj8yn");
    var $hLXaJ = parcelRequire("hLXaJ");
    var $kDZ6Z;
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $4Bkrp;
    var $iwKVT = parcelRequire("iwKVT");
    const $8d96ed473518bd99$var$MAX_BATCH_SIZE = 50;
    const $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES = 250;
    const $8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE = 100;
    const $8d96ed473518bd99$export$d6a66073b5d79eb3 = new (0, $iwKVT.LRUMap)($8d96ed473518bd99$var$URL_RESPONSE_CACHE_SIZE);
    class $8d96ed473518bd99$export$2e2bcd8739ae039 {
        constructor(envKey, baseUrlOverride){
            this.postBatchResolve = async (resources, resourceType = 'URL')=>{
                const deDuplicatedResources = [
                    ...new Set(resources)
                ];
                let resolvedResources = [];
                const headers = {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                    ...this.product ? {
                        'X-Product': this.product
                    } : {}
                };
                try {
                    if (resourceType === 'URL') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                            resourceUrl: resourceUrl
                        })), headers);
                    if (resourceType === 'ARI') resolvedResources = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                            ari: ari
                        })), headers);
                } catch (error) {
                    resolvedResources = resources.map(()=>{
                        const status = (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(error) ? error.status : 500;
                        const errorResponse = {
                            status: status,
                            error: error
                        };
                        return errorResponse;
                    });
                }
                const map = {};
                for(let i = 0; i < deDuplicatedResources.length; ++i){
                    const resource = deDuplicatedResources[i];
                    const data = resolvedResources[i];
                    map[resource] = data;
                }
                return resources.map((originalResource)=>map[originalResource]);
            };
            this.batchResolve = async (urls)=>{
                return this.postBatchResolve(urls, 'URL');
            };
            this.batchResolveAris = async (aris)=>{
                return this.postBatchResolve(aris, 'ARI');
            };
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.loadersByDomain = {};
            this.retryConfig = {
                retries: 2
            };
            this.resolvedCache = {};
            this.envKey = envKey;
            this.baseUrlOverride = baseUrlOverride;
        }
        setProduct(product) {
            this.product = product;
        }
        createLoader() {
            const batchResolveThrottler = (0, ($parcel$interopDefault($hLXaJ)))({
                limit: 1,
                interval: $8d96ed473518bd99$var$MIN_TIME_BETWEEN_BATCHES
            });
            const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
            return new (0, ($parcel$interopDefault($hhZW9)))((urls)=>throttledBatchResolve(urls), {
                maxBatchSize: $8d96ed473518bd99$var$MAX_BATCH_SIZE,
                cache: false
            });
        }
        getLoader(hostname) {
            if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
            return this.loadersByDomain[hostname];
        }
        async resolveUrl(url, force = false) {
            const hostname = new URL(url).hostname;
            const loader = this.getLoader(hostname);
            let responsePromise;
            responsePromise = $8d96ed473518bd99$export$d6a66073b5d79eb3.get(url);
            if (!responsePromise || force) {
                responsePromise = loader.load(url);
                $8d96ed473518bd99$export$d6a66073b5d79eb3.set(url, responsePromise);
            }
            let response;
            try {
                response = await responsePromise;
            } catch (e) {
                $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
                throw e;
            }
            const isUnresolvedLink = !(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response) || (0, (0, parcelRequire("fiKQs")).getStatus)(response.body) !== 'resolved';
            if (isUnresolvedLink) $8d96ed473518bd99$export$d6a66073b5d79eb3.delete(url);
            return response;
        }
        async prefetchData(url) {
            const response = await this.resolveUrl(url, false);
            if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response.body;
            else try {
                const retriedResponse = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                    if (!this.resolvedCache[url]) {
                        const response = await this.resolveUrl(url, false);
                        if ((0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) return response;
                        else throw new Error('Retry for URL failed');
                    } else throw new Error('Retry unneeded - link has been resolved.');
                }, this.retryConfig);
                return retriedResponse.body;
            } catch (err) {
                return undefined;
            }
        }
        isRateLimitError(response) {
            return (0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response) && response.error.status === 429;
        }
        async fetchData(url, force) {
            let response = await this.resolveUrl(url, force);
            if (this.isRateLimitError(response)) response = await (0, ($parcel$interopDefault($hj8yn)))(async ()=>{
                const retryResponse = await this.resolveUrl(url, false);
                if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
                return retryResponse;
            }, this.retryConfig);
            if (!(0, (0, parcelRequire("4Bkrp")).isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
            this.resolvedCache[url] = true;
            return response.body;
        }
        async fetchDataAris(aris) {
            return await this.batchResolveAris(aris);
        }
        async postData(data) {
            const requestData = {
                key: data.key,
                action: data.action,
                context: data.context
            };
            return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke`, requestData);
        }
        async search(data) {
            const { key: key, action: action } = data;
            const { query: query, context: context } = action;
            const requestData = {
                key: key,
                search: {
                    query: query,
                    context: context
                }
            };
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/invoke/search`, requestData);
            if ((0, (0, parcelRequire("4Bkrp")).isErrorResponse)(response)) throw this.mapErrorResponse(response);
            return response;
        }
        async fetchAvailableSearchProviders() {
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', `${this.resolverUrl}/providers`, {
                type: 'search'
            });
            return response.providers;
        }
        mapErrorResponse(response, hostname = '') {
            if (response?.error) {
                const errorType = response.error.type;
                const errorMessage = response.error.message;
                const extensionKey = response.error.extensionKey;
                if (response.error instanceof (0, (0, parcelRequire("dV0Jy")).NetworkError)) return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType);
                switch(errorType){
                    case 'ResolveBadRequestError':
                    case 'SearchBadRequestError':
                    case 'BadRequestError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveAuthError':
                    case 'SearchAuthError':
                    case 'AuthError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveUnsupportedError':
                    case 'SearchUnsupportedError':
                    case 'UnsupportedError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                    case 'ResolveFailedError':
                    case 'SearchFailedError':
                    case 'ResolveTimeoutError':
                    case 'SearchTimeoutError':
                    case 'SearchRateLimitError':
                    case 'ResolveRateLimitError':
                    case 'InternalServerError':
                    case 'TimeoutError':
                    case 'RateLimitError':
                        return new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, errorMessage, errorType, extensionKey);
                }
            }
            const { error: error, ...rest } = response || {};
            return new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
        }
        stringifyError(err) {
            return JSON.stringify(err, typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
        }
    }
});
parcelRegister("hhZW9", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $c964119340a5ebe3$var$DataLoader = function() {
        function DataLoader(batchLoadFn, options) {
            if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
            this._batchLoadFn = batchLoadFn;
            this._maxBatchSize = $c964119340a5ebe3$var$getValidMaxBatchSize(options);
            this._batchScheduleFn = $c964119340a5ebe3$var$getValidBatchScheduleFn(options);
            this._cacheKeyFn = $c964119340a5ebe3$var$getValidCacheKeyFn(options);
            this._cacheMap = $c964119340a5ebe3$var$getValidCacheMap(options);
            this._batch = null;
            this.name = $c964119340a5ebe3$var$getValidName(options);
        }
        var _proto = DataLoader.prototype;
        _proto.load = function load(key) {
            if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
            var batch = $c964119340a5ebe3$var$getCurrentBatch(this);
            var cacheMap = this._cacheMap;
            var cacheKey = this._cacheKeyFn(key);
            if (cacheMap) {
                var cachedPromise = cacheMap.get(cacheKey);
                if (cachedPromise) {
                    var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                    return new Promise(function(resolve) {
                        cacheHits.push(function() {
                            resolve(cachedPromise);
                        });
                    });
                }
            }
            batch.keys.push(key);
            var promise = new Promise(function(resolve, reject) {
                batch.callbacks.push({
                    resolve: resolve,
                    reject: reject
                });
            });
            if (cacheMap) cacheMap.set(cacheKey, promise);
            return promise;
        };
        _proto.loadMany = function loadMany(keys) {
            if (!$c964119340a5ebe3$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
            var loadPromises = [];
            for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
                return error;
            }));
            return Promise.all(loadPromises);
        };
        _proto.clear = function clear(key) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                cacheMap["delete"](cacheKey);
            }
            return this;
        };
        _proto.clearAll = function clearAll() {
            var cacheMap = this._cacheMap;
            if (cacheMap) cacheMap.clear();
            return this;
        };
        _proto.prime = function prime(key, value) {
            var cacheMap = this._cacheMap;
            if (cacheMap) {
                var cacheKey = this._cacheKeyFn(key);
                if (cacheMap.get(cacheKey) === undefined) {
                    var promise;
                    if (value instanceof Error) {
                        promise = Promise.reject(value);
                        promise["catch"](function() {});
                    } else promise = Promise.resolve(value);
                    cacheMap.set(cacheKey, promise);
                }
            }
            return this;
        };
        return DataLoader;
    }();
    var $c964119340a5ebe3$var$enqueuePostPromiseJob = typeof $6cAn5 === 'object' && typeof $6cAn5.nextTick === 'function' ? function(fn) {
        if (!$c964119340a5ebe3$var$resolvedPromise) $c964119340a5ebe3$var$resolvedPromise = Promise.resolve();
        $c964119340a5ebe3$var$resolvedPromise.then(function() {
            $6cAn5.nextTick(fn);
        });
    } : typeof setImmediate === 'function' ? function(fn) {
        setImmediate(fn);
    } : function(fn) {
        setTimeout(fn);
    };
    var $c964119340a5ebe3$var$resolvedPromise;
    function $c964119340a5ebe3$var$getCurrentBatch(loader) {
        var existingBatch = loader._batch;
        if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
        var newBatch = {
            hasDispatched: false,
            keys: [],
            callbacks: []
        };
        loader._batch = newBatch;
        loader._batchScheduleFn(function() {
            $c964119340a5ebe3$var$dispatchBatch(loader, newBatch);
        });
        return newBatch;
    }
    function $c964119340a5ebe3$var$dispatchBatch(loader, batch) {
        batch.hasDispatched = true;
        if (batch.keys.length === 0) {
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            return;
        }
        var batchPromise;
        try {
            batchPromise = loader._batchLoadFn(batch.keys);
        } catch (e) {
            return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
        }
        if (!batchPromise || typeof batchPromise.then !== 'function') return $c964119340a5ebe3$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
        batchPromise.then(function(values) {
            if (!$c964119340a5ebe3$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
            if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
            $c964119340a5ebe3$var$resolveCacheHits(batch);
            for(var i = 0; i < batch.callbacks.length; i++){
                var value = values[i];
                if (value instanceof Error) batch.callbacks[i].reject(value);
                else batch.callbacks[i].resolve(value);
            }
        })["catch"](function(error) {
            $c964119340a5ebe3$var$failedDispatch(loader, batch, error);
        });
    }
    function $c964119340a5ebe3$var$failedDispatch(loader, batch, error) {
        $c964119340a5ebe3$var$resolveCacheHits(batch);
        for(var i = 0; i < batch.keys.length; i++){
            loader.clear(batch.keys[i]);
            batch.callbacks[i].reject(error);
        }
    }
    function $c964119340a5ebe3$var$resolveCacheHits(batch) {
        if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
    }
    function $c964119340a5ebe3$var$getValidMaxBatchSize(options) {
        var shouldBatch = !options || options.batch !== false;
        if (!shouldBatch) return 1;
        var maxBatchSize = options && options.maxBatchSize;
        if (maxBatchSize === undefined) return Infinity;
        if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
        return maxBatchSize;
    }
    function $c964119340a5ebe3$var$getValidBatchScheduleFn(options) {
        var batchScheduleFn = options && options.batchScheduleFn;
        if (batchScheduleFn === undefined) return $c964119340a5ebe3$var$enqueuePostPromiseJob;
        if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
        return batchScheduleFn;
    }
    function $c964119340a5ebe3$var$getValidCacheKeyFn(options) {
        var cacheKeyFn = options && options.cacheKeyFn;
        if (cacheKeyFn === undefined) return function(key) {
            return key;
        };
        if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
        return cacheKeyFn;
    }
    function $c964119340a5ebe3$var$getValidCacheMap(options) {
        var shouldCache = !options || options.cache !== false;
        if (!shouldCache) return null;
        var cacheMap = options && options.cacheMap;
        if (cacheMap === undefined) return new Map();
        if (cacheMap !== null) {
            var cacheFunctions = [
                'get',
                'set',
                'delete',
                'clear'
            ];
            var missingFunctions = cacheFunctions.filter(function(fnName) {
                return cacheMap && typeof cacheMap[fnName] !== 'function';
            });
            if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
        }
        return cacheMap;
    }
    function $c964119340a5ebe3$var$getValidName(options) {
        if (options && options.name) return options.name;
        return null;
    }
    function $c964119340a5ebe3$var$isArrayLike(x) {
        return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
    }
    module.exports = $c964119340a5ebe3$var$DataLoader;
});
parcelRegister("hj8yn", function(module, exports) {
    var $iRstd = parcelRequire("iRstd");
    function $c99ad890679d3578$var$retry(fn, opts) {
        function run(resolve, reject) {
            var options = opts || {};
            if (!('randomize' in options)) options.randomize = true;
            var op = $iRstd.operation(options);
            function bail(err) {
                reject(err || new Error('Aborted'));
            }
            function onError(err, num) {
                if (err.bail) {
                    bail(err);
                    return;
                }
                if (!op.retry(err)) reject(op.mainError());
                else if (options.onRetry) options.onRetry(err, num);
            }
            function runAttempt(num) {
                var val;
                try {
                    val = fn(bail, num);
                } catch (err) {
                    onError(err, num);
                    return;
                }
                Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                    onError(err, num);
                });
            }
            op.attempt(runAttempt);
        }
        return new Promise(run);
    }
    module.exports = $c99ad890679d3578$var$retry;
});
parcelRegister("iRstd", function(module, exports) {
    module.exports = (parcelRequire("fqPwM"));
});
parcelRegister("fqPwM", function(module, exports) {
    var $fvybB = parcelRequire("fvybB");
    exports.operation = function(options) {
        var timeouts = exports.timeouts(options);
        return new $fvybB(timeouts, {
            forever: options && options.forever,
            unref: options && options.unref,
            maxRetryTime: options && options.maxRetryTime
        });
    };
    exports.timeouts = function(options) {
        if (options instanceof Array) return [].concat(options);
        var opts = {
            retries: 10,
            factor: 2,
            minTimeout: 1000,
            maxTimeout: Infinity,
            randomize: false
        };
        for(var key in options)opts[key] = options[key];
        if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
        var timeouts = [];
        for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
        if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
        timeouts.sort(function(a, b) {
            return a - b;
        });
        return timeouts;
    };
    exports.createTimeout = function(attempt, opts) {
        var random = opts.randomize ? Math.random() + 1 : 1;
        var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
        timeout = Math.min(timeout, opts.maxTimeout);
        return timeout;
    };
    exports.wrap = function(obj, options, methods) {
        if (options instanceof Array) {
            methods = options;
            options = null;
        }
        if (!methods) {
            methods = [];
            for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
        }
        for(var i = 0; i < methods.length; i++){
            var method = methods[i];
            var original = obj[method];
            obj[method] = (function retryWrapper(original) {
                var op = exports.operation(options);
                var args = Array.prototype.slice.call(arguments, 1);
                var callback = args.pop();
                args.push(function(err) {
                    if (op.retry(err)) return;
                    if (err) arguments[0] = op.mainError();
                    callback.apply(this, arguments);
                });
                op.attempt(function() {
                    original.apply(obj, args);
                });
            }).bind(obj, original);
            obj[method].options = options;
        }
    };
});
parcelRegister("fvybB", function(module, exports) {
    function $b4a444e76151e114$var$RetryOperation(timeouts, options) {
        if (typeof options === 'boolean') options = {
            forever: options
        };
        this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
        this._timeouts = timeouts;
        this._options = options || {};
        this._maxRetryTime = options && options.maxRetryTime || Infinity;
        this._fn = null;
        this._errors = [];
        this._attempts = 1;
        this._operationTimeout = null;
        this._operationTimeoutCb = null;
        this._timeout = null;
        this._operationStart = null;
        if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
    }
    module.exports = $b4a444e76151e114$var$RetryOperation;
    $b4a444e76151e114$var$RetryOperation.prototype.reset = function() {
        this._attempts = 1;
        this._timeouts = this._originalTimeouts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.stop = function() {
        if (this._timeout) clearTimeout(this._timeout);
        this._timeouts = [];
        this._cachedTimeouts = null;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.retry = function(err) {
        if (this._timeout) clearTimeout(this._timeout);
        if (!err) return false;
        var currentTime = new Date().getTime();
        if (err && currentTime - this._operationStart >= this._maxRetryTime) {
            this._errors.unshift(new Error('RetryOperation timeout occurred'));
            return false;
        }
        this._errors.push(err);
        var timeout = this._timeouts.shift();
        if (timeout === undefined) {
            if (this._cachedTimeouts) {
                this._errors.splice(this._errors.length - 1, this._errors.length);
                this._timeouts = this._cachedTimeouts.slice(0);
                timeout = this._timeouts.shift();
            } else return false;
        }
        var self = this;
        var timer = setTimeout(function() {
            self._attempts++;
            if (self._operationTimeoutCb) {
                self._timeout = setTimeout(function() {
                    self._operationTimeoutCb(self._attempts);
                }, self._operationTimeout);
                if (self._options.unref) self._timeout.unref();
            }
            self._fn(self._attempts);
        }, timeout);
        if (this._options.unref) timer.unref();
        return true;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
        this._fn = fn;
        if (timeoutOps) {
            if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
            if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
        }
        var self = this;
        if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
            self._operationTimeoutCb();
        }, self._operationTimeout);
        this._operationStart = new Date().getTime();
        this._fn(this._attempts);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.try = function(fn) {
        console.log('Using RetryOperation.try() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = function(fn) {
        console.log('Using RetryOperation.start() is deprecated');
        this.attempt(fn);
    };
    $b4a444e76151e114$var$RetryOperation.prototype.start = $b4a444e76151e114$var$RetryOperation.prototype.try;
    $b4a444e76151e114$var$RetryOperation.prototype.errors = function() {
        return this._errors;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.attempts = function() {
        return this._attempts;
    };
    $b4a444e76151e114$var$RetryOperation.prototype.mainError = function() {
        if (this._errors.length === 0) return null;
        var counts = {};
        var mainError = null;
        var mainErrorCount = 0;
        for(var i = 0; i < this._errors.length; i++){
            var error = this._errors[i];
            var message = error.message;
            var count = (counts[message] || 0) + 1;
            counts[message] = count;
            if (count >= mainErrorCount) {
                mainError = error;
                mainErrorCount = count;
            }
        }
        return mainError;
    };
});
parcelRegister("hLXaJ", function(module, exports) {
    'use strict';
    class $cf04b9d0ddc5d8fc$var$AbortError extends Error {
        constructor(){
            super('Throttled function aborted');
            this.name = 'AbortError';
        }
    }
    const $cf04b9d0ddc5d8fc$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
        if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
        if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
        const queue = new Map();
        let currentTick = 0;
        let activeCount = 0;
        function windowedDelay() {
            const now = Date.now();
            if (now - currentTick > interval) {
                activeCount = 1;
                currentTick = now;
                return 0;
            }
            if (activeCount < limit) activeCount++;
            else {
                currentTick += interval;
                activeCount = 1;
            }
            return currentTick - now;
        }
        const strictTicks = [];
        function strictDelay() {
            const now = Date.now();
            if (strictTicks.length < limit) {
                strictTicks.push(now);
                return 0;
            }
            const earliestTime = strictTicks.shift() + interval;
            if (now >= earliestTime) {
                strictTicks.push(now);
                return 0;
            }
            strictTicks.push(earliestTime);
            return earliestTime - now;
        }
        const getDelay = strict ? strictDelay : windowedDelay;
        return (function_)=>{
            const throttled = function(...args) {
                if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
                let timeout;
                return new Promise((resolve, reject)=>{
                    const execute = ()=>{
                        resolve(function_.apply(this, args));
                        queue.delete(timeout);
                    };
                    timeout = setTimeout(execute, getDelay());
                    queue.set(timeout, reject);
                });
            };
            throttled.abort = ()=>{
                for (const timeout of queue.keys()){
                    clearTimeout(timeout);
                    queue.get(timeout)(new $cf04b9d0ddc5d8fc$var$AbortError());
                }
                queue.clear();
                strictTicks.splice(0, strictTicks.length);
            };
            throttled.isEnabled = true;
            return throttled;
        };
    };
    module.exports = $cf04b9d0ddc5d8fc$var$pThrottle;
    module.exports.AbortError = $cf04b9d0ddc5d8fc$var$AbortError;
});
parcelRegister("kDZ6Z", function(module, exports) {
    $parcel$export(module.exports, "APIError", ()=>$8c263ecf028a2c14$export$3e5b797e39668f84);
    class $8c263ecf028a2c14$export$3e5b797e39668f84 extends Error {
        constructor(kind, hostname, message, type, extensionKey){
            super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
            this.name = 'APIError';
            this.type = type;
            this.kind = kind;
            this.message = message;
            this.hostname = hostname;
            this.extensionKey = extensionKey;
        }
    }
});
parcelRegister("itO4f", function(module, exports) {
    $parcel$export(module.exports, "getBaseUrl", ()=>$21a0efece812cd9a$export$f654b28f82155665);
    $parcel$export(module.exports, "getResolverUrl", ()=>$21a0efece812cd9a$export$dc37652c1696f231);
    const $21a0efece812cd9a$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
    const $21a0efece812cd9a$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
    const $21a0efece812cd9a$var$prodBaseUrl = 'https://api-private.atlassian.com';
    const $21a0efece812cd9a$export$e2b040f052407032 = {
        dev: $21a0efece812cd9a$var$devBaseUrl,
        development: $21a0efece812cd9a$var$devBaseUrl,
        stg: $21a0efece812cd9a$var$stgBaseUrl,
        staging: $21a0efece812cd9a$var$stgBaseUrl,
        prd: $21a0efece812cd9a$var$prodBaseUrl,
        prod: $21a0efece812cd9a$var$prodBaseUrl,
        production: $21a0efece812cd9a$var$prodBaseUrl
    };
    const $21a0efece812cd9a$export$f654b28f82155665 = (envKey)=>{
        if (envKey) return envKey in $21a0efece812cd9a$export$e2b040f052407032 ? $21a0efece812cd9a$export$e2b040f052407032[envKey] : $21a0efece812cd9a$var$prodBaseUrl;
        return typeof window.location !== 'undefined' ? window.location.origin : '';
    };
    const $21a0efece812cd9a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
        if (envKey || baseUrlOverride) {
            const baseUrl = baseUrlOverride || $21a0efece812cd9a$export$f654b28f82155665(envKey);
            return `${baseUrl}/object-resolver`;
        } else return '/gateway/api/object-resolver';
    };
    var $21a0efece812cd9a$export$2e2bcd8739ae039 = $21a0efece812cd9a$export$e2b040f052407032;
});
parcelRegister("dV0Jy", function(module, exports) {
    $parcel$export(module.exports, "NetworkError", ()=>$5576d4e9d0a3858d$export$bae979e68e4dc802);
    $parcel$export(module.exports, "request", ()=>$5576d4e9d0a3858d$export$b5fe3f66a567bec0);
    const $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES = [
        200,
        401,
        404
    ];
    class $5576d4e9d0a3858d$export$bae979e68e4dc802 extends Error {
        constructor(error){
            super(error);
        }
    }
    async function $5576d4e9d0a3858d$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $5576d4e9d0a3858d$var$ALLOWED_RESPONSE_STATUS_CODES) {
        const requestConfig = {
            method: method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Cache-Control': 'no-cache',
                'Content-Type': 'application/json',
                ...headers
            },
            ...data ? {
                body: JSON.stringify(data)
            } : {}
        };
        try {
            const response = await fetch(url, requestConfig);
            if (response.ok || statuses?.includes(response.status)) {
                if (statuses.includes(204)) {
                    const text = await response.text();
                    return text ? JSON.parse(text) : undefined;
                } else return await response.json();
            }
            throw response;
        } catch (error) {
            if (typeof error === 'string' || error instanceof TypeError) throw new $5576d4e9d0a3858d$export$bae979e68e4dc802(error);
            throw error;
        }
    }
});
parcelRegister("4Bkrp", function(module, exports) {
    $parcel$export(module.exports, "isSuccessfulResponse", ()=>$1e00e4fd9b26eb0f$export$1b59fe731a28a49d);
    $parcel$export(module.exports, "isErrorResponse", ()=>$1e00e4fd9b26eb0f$export$bea7bee8a87e7c52);
    const $1e00e4fd9b26eb0f$export$1b59fe731a28a49d = (response)=>{
        if (!response) return false;
        const hasSuccessfulStatus = response.status === 200;
        const hasSuccessBody = 'body' in response;
        return hasSuccessfulStatus && hasSuccessBody;
    };
    const $1e00e4fd9b26eb0f$export$bea7bee8a87e7c52 = (response)=>{
        if (!response) return false;
        const hasStatus = 'status' in response && response.status >= 200;
        const hasErrorBody = 'error' in response;
        return hasStatus && hasErrorBody;
    };
});
parcelRegister("iwKVT", function(module, exports) {
    !function(g, c) {
        c(module.exports);
    }(module.exports, function(g) {
        const c = Symbol("newer"), e = Symbol("older");
        class n {
            constructor(a, b){
                typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
            }
            _markEntryAsUsed(a) {
                if (a === this.newest) return;
                a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
            }
            assign(a) {
                let b, d = this.limit || Number.MAX_VALUE;
                this._keymap.clear();
                let m = a[Symbol.iterator]();
                for(let h = m.next(); !h.done; h = m.next()){
                    let f = new l(h.value[0], h.value[1]);
                    this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                    if (d-- == 0) throw new Error("overflow");
                }
                this.newest = b, this.size = this._keymap.size;
            }
            get(a) {
                var b = this._keymap.get(a);
                return b ? (this._markEntryAsUsed(b), b.value) : void 0;
            }
            set(a, b) {
                var d = this._keymap.get(a);
                return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
            }
            shift() {
                var a = this.oldest;
                if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                    a.key,
                    a.value
                ];
            }
            find(a) {
                let b = this._keymap.get(a);
                return b ? b.value : void 0;
            }
            has(a) {
                return this._keymap.has(a);
            }
            delete(a) {
                var b = this._keymap.get(a);
                return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
            }
            clear() {
                this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
            }
            keys() {
                return new j(this.oldest);
            }
            values() {
                return new k(this.oldest);
            }
            entries() {
                return this;
            }
            [Symbol.iterator]() {
                return new i(this.oldest);
            }
            forEach(a, b) {
                typeof b !== "object" && (b = this);
                let d = this.oldest;
                for(; d;)a.call(b, d.value, d.key, this), d = d[c];
            }
            toJSON() {
                for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                    key: d.key,
                    value: d.value
                }, d = d[c];
                return a;
            }
            toString() {
                for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
                return a;
            }
        }
        g.LRUMap = n;
        function l(a, b) {
            this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
        }
        function i(a) {
            this.entry = a;
        }
        i.prototype[Symbol.iterator] = function() {
            return this;
        }, i.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: [
                    a.key,
                    a.value
                ]
            }) : {
                done: !0,
                value: void 0
            };
        };
        function j(a) {
            this.entry = a;
        }
        j.prototype[Symbol.iterator] = function() {
            return this;
        }, j.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.key
            }) : {
                done: !0,
                value: void 0
            };
        };
        function k(a) {
            this.entry = a;
        }
        k.prototype[Symbol.iterator] = function() {
            return this;
        }, k.prototype.next = function() {
            let a = this.entry;
            return a ? (this.entry = a[c], {
                done: !1,
                value: a.value
            }) : {
                done: !0,
                value: void 0
            };
        };
    });
});
parcelRegister("f8WR0", function(module, exports) {
    $parcel$export(module.exports, "useUIModificationsConsentStatus", ()=>$acc0af1dbe16c569$export$e2c526d2c1843a0e);
    $parcel$export(module.exports, "useUIModificationsConsentStatusForApp", ()=>$acc0af1dbe16c569$export$7700bb22109a011e);
    $parcel$export(module.exports, "useUIModificationsConsentStatusForApps", ()=>$acc0af1dbe16c569$export$2a5a8f1570c161c6);
    var $e5wyW;
    var $4R6GH;
    var $6dDSs;
    var $3sQ5x;
    var $laCJ2;
    const $acc0af1dbe16c569$var$selectOverallConsentStatus = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38)) ? (0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38) : (0, $2aeb8c12bc7d07a0$export$45ca911896c5084f));
    const $acc0af1dbe16c569$var$selectConsentStatusDeprecated = (state)=>state.uiModificationsConsentStatusDeprecated;
    const $acc0af1dbe16c569$var$selectUIMConsentStatus = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps'), $acc0af1dbe16c569$var$selectOverallConsentStatus, $acc0af1dbe16c569$var$selectConsentStatusDeprecated);
    const $acc0af1dbe16c569$export$e2c526d2c1843a0e = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("laCJ2")).store), {
        selector: $acc0af1dbe16c569$var$selectUIMConsentStatus
    });
    const $acc0af1dbe16c569$export$7700bb22109a011e = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("laCJ2")).store), {
        selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $2aeb8c12bc7d07a0$export$39d15f3568f5a72c)
    });
    const $acc0af1dbe16c569$export$2a5a8f1570c161c6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("laCJ2")).store), {
        selector: (state)=>state.uiModificationsConsentStatus
    });
});
parcelRegister("laCJ2", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "useAdjustmentsEnabled", ()=>$f7dbb0638e5239f0$export$358ad850b2f6d6fe);
    $parcel$export(module.exports, "useAdjustmentsContextActions", ()=>$f7dbb0638e5239f0$export$4f2729981f4b81d2);
    $parcel$export(module.exports, "UiModificationContextContainer", ()=>$f7dbb0638e5239f0$export$5eb9c167b683d125);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $f7dbb0638e5239f0$var$initialState = {
        shouldUiModificationsLoad: 'unknown',
        hasFinishedLoading: false,
        adjustmentsAreEnabled: false,
        uiModificationsConsentStatusDeprecated: (0, $2aeb8c12bc7d07a0$export$39d15f3568f5a72c),
        uiModificationsConsentStatus: {}
    };
    const $f7dbb0638e5239f0$export$e324594224ef24da = {
        resetAdjustmentContext: ()=>({ setState: setState })=>{
                setState($f7dbb0638e5239f0$var$initialState);
            },
        setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
                setState({
                    shouldUiModificationsLoad: status
                });
            },
        setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
                setState({
                    hasFinishedLoading: hasFinishedLoading
                });
            },
        setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
                setState({
                    adjustmentsAreEnabled: enabled
                });
            },
        setUIModificationsConsentStatusDeprecated: (enabled)=>({ setState: setState })=>{
                setState({
                    uiModificationsConsentStatusDeprecated: enabled
                });
            },
        setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
                const currentConsentState = getState().uiModificationsConsentStatus;
                setState({
                    uiModificationsConsentStatus: {
                        ...currentConsentState,
                        [appId]: status
                    }
                });
            }
    };
    const $f7dbb0638e5239f0$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-adjustments-context',
        initialState: $f7dbb0638e5239f0$var$initialState,
        actions: $f7dbb0638e5239f0$export$e324594224ef24da
    });
    const $f7dbb0638e5239f0$export$a12f82a132dee079 = (0, (0, parcelRequire("3sQ5x")).createHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    const $f7dbb0638e5239f0$export$358ad850b2f6d6fe = (0, (0, parcelRequire("3sQ5x")).createStateHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9, {
        selector: (state)=>state.adjustmentsAreEnabled
    });
    const $f7dbb0638e5239f0$export$4f2729981f4b81d2 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($f7dbb0638e5239f0$export$6f57813fe9f31bf9);
    const $f7dbb0638e5239f0$export$5eb9c167b683d125 = (0, (0, parcelRequire("gg7kZ")).createContainer)($f7dbb0638e5239f0$export$6f57813fe9f31bf9, {
        displayName: 'UiModificationContextContainer'
    });
});
const $2aeb8c12bc7d07a0$export$39d15f3568f5a72c = 'unknown';
const $2aeb8c12bc7d07a0$export$d67d63332ce3ce38 = 'required';
const $2aeb8c12bc7d07a0$export$45ca911896c5084f = 'consented';
parcelRegister("gUfkD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b8d3b1683bb69c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $lfTZh;
    var $kxZPA;
    const $7b8d3b1683bb69c2$var$FindFieldModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("7G5bj")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/find-field/src/index.tsx"
    });
    var $7b8d3b1683bb69c2$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "AsyncFindFieldModal",
            packageName: "jiraIssueConfigFindField",
            fallback: "flag",
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "config-find-field-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7b8d3b1683bb69c2$var$FindFieldModal, props)));
});
parcelRegister("7G5bj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("a3NGg")
    ]).then(()=>parcelRequire('gLfH6'));
});
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
parcelRegister("c7ZNt", function(module, exports) {
    $parcel$export(module.exports, "transformProjectType", ()=>$ce1d90d73f191ff5$export$bd65219b3dd7789d);
    var $2vSU6;
    const $ce1d90d73f191ff5$export$bd65219b3dd7789d = (projectType)=>{
        if (!projectType) return 'none';
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return 'serviceManagement';
        if (projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) return 'workManagement';
        return projectType;
    };
});
parcelRegister("2ntXc", function(module, exports) {
    $parcel$export(module.exports, "useClassificationState", ()=>$b90b90d153a62455$export$4404b0743b8ee564);
    $parcel$export(module.exports, "useClassificationFieldProps", ()=>$b90b90d153a62455$export$e2bccade312f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $koVbs;
    var $54T03;
    var $5eGnF;
    var $9svjh;
    var $8zOmE;
    var $2NMNM;
    var $52tuV;
    const $b90b90d153a62455$export$4404b0743b8ee564 = (classificationOption)=>{
        const [selectedClassification, setSelectedClassification] = (0, $5uXOq.useState)(classificationOption);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const onClassificationOptionChange = (0, $5uXOq.useCallback)((option)=>{
            setSelectedClassification(option);
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'ClassificationInGIC changed');
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, {
                selectedClassification: option
            });
        }, [
            createAnalyticsEvent,
            publish
        ]);
        return [
            selectedClassification,
            setSelectedClassification,
            onClassificationOptionChange
        ];
    };
    const $b90b90d153a62455$export$e2a389820b14b290 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, $5uXOq.useCallback)((value)=>{
            if (!value) {
                const noClassificationOption = {
                    id: undefined,
                    definition: formatMessage((0, (0, parcelRequire("52tuV")).default).noClassificationOption),
                    color: undefined,
                    includeIcon: false
                };
                return noClassificationOption;
            }
            return (0, (0, parcelRequire("54T03")).getProjectDefaultClassificationOption)(formatMessage((0, (0, parcelRequire("52tuV")).default).projectDefaultClassificationOption), value);
        }, [
            formatMessage
        ]);
    };
    const $b90b90d153a62455$export$cdada88ebf1ccd9 = (classificationFieldConfig)=>{
        const allowedClassifications = classificationFieldConfig?.allowedValues?.map((value)=>$b90b90d153a62455$export$a30f3e09b4b8e281(value.node));
        return allowedClassifications;
    };
    const $b90b90d153a62455$export$a30f3e09b4b8e281 = (defaultValue)=>{
        const defaultClassification = defaultValue ? {
            id: defaultValue?.id,
            name: defaultValue?.name,
            definition: (0, (0, parcelRequire("co1wz")).ff)('dlp-field-selected-value-and-definition-changes_4jiut') ? defaultValue?.definition : defaultValue?.guidelines,
            color: defaultValue?.color?.colorKey
        } : undefined;
        return defaultClassification;
    };
    const $b90b90d153a62455$export$e2bccade312f8 = (classificationFieldConfig)=>{
        const getCreateClassificationLevel = $b90b90d153a62455$export$e2a389820b14b290();
        return (0, $5uXOq.useMemo)(()=>{
            let classificationFieldProps = {
                availableClassifications: undefined,
                initialClassification: undefined,
                isDisabled: false,
                nonEditableMessage: undefined
            };
            const allowedClassifications = $b90b90d153a62455$export$cdada88ebf1ccd9(classificationFieldConfig);
            const initialDefaultClassification = $b90b90d153a62455$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[0]);
            const projectDefaultClassification = $b90b90d153a62455$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[1]);
            const projectLevelClassification = getCreateClassificationLevel(projectDefaultClassification);
            const isFieldEditable = classificationFieldConfig?.isEditable;
            if (allowedClassifications) classificationFieldProps = {
                availableClassifications: allowedClassifications.concat(projectLevelClassification),
                initialClassification: initialDefaultClassification || projectLevelClassification,
                isDisabled: isFieldEditable === false,
                nonEditableMessage: classificationFieldConfig?.nonEditableReason
            };
            return classificationFieldProps;
        }, [
            classificationFieldConfig,
            getCreateClassificationLevel
        ]);
    };
});
parcelRegister("54T03", function(module, exports) {
    $parcel$export(module.exports, "getProjectDefaultClassificationOption", ()=>$abed6bbea4a3fb86$export$1f0ddb93897fde19);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $74sEg;
    const $abed6bbea4a3fb86$export$d890d332bbf5844a = (classifications)=>classifications ? {
            edges: classifications.map((classification)=>({
                    node: {
                        id: classification.id,
                        name: classification.name,
                        definition: classification.definition,
                        guidelines: classification.guideline,
                        color: {
                            colorKey: classification.color
                        }
                    }
                }))
        } : classifications;
    const $abed6bbea4a3fb86$var$OverflowWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $abed6bbea4a3fb86$var$ProjectDefaultTextWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1i6y",
                __cmplp.className
            ])
        });
    });
    const $abed6bbea4a3fb86$export$1f0ddb93897fde19 = (message, defaultClassificationLevel)=>{
        const color = typeof defaultClassificationLevel?.color === 'string' ? defaultClassificationLevel?.color : defaultClassificationLevel?.color?.colorKey;
        return {
            id: undefined,
            nameFormatter: (classification)=>(0, ($parcel$interopDefault($5uXOq))).createElement($abed6bbea4a3fb86$var$OverflowWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($abed6bbea4a3fb86$var$ProjectDefaultTextWrapper, null, message, " - "), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("74sEg")).ClassificationLozenge), {
                    ...classification,
                    name: defaultClassificationLevel?.name || ''
                })),
            color: color,
            definition: ''
        };
    };
});
parcelRegister("74sEg", function(module, exports) {
    $parcel$export(module.exports, "ClassificationLozenge", ()=>$5a84988b432bf2ca$export$f31d135f91971ac4);
    $parcel$export(module.exports, "DataClassificationDropdown", ()=>$5a84988b432bf2ca$export$37a6278f2f470b5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $LpImS = parcelRequire("LpImS");
    var $ajpes = parcelRequire("ajpes");
    var $059q9;
    var $kgoHi;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $bChGW;
    var $7K5PP;
    var $hxoiH;
    var $3bDjY;
    var $gmmpY;
    var $7Kq24;
    var $bj9nc;
    const $5a84988b432bf2ca$var$dangerTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.danger',
        paddingInlineStart: 'space.025'
    });
    const $5a84988b432bf2ca$var$CustomSingleValue = ({ children: children, ...props })=>{
        const { colorMode: colorMode = 'light' } = (0, (0, parcelRequire("hxoiH")).default)();
        const { data: data } = props;
        const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'GREY', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
        const inputName = classificationOverride?.name ?? name ?? nameLabel ?? definition;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).ContainerLabel), null, nameFormatter ? nameFormatter(data) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).ContainerIcon), {
            colorsConfig: (0, (0, parcelRequire("gmmpY")).colorsConfig)[colorMode][color],
            isIconOnly: includeIcon && !inputName
        }, includeIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Kq24")).ClassificationIcon), {
            width: 14,
            height: 14,
            isDisabled: false,
            color: (0, (0, parcelRequire("gmmpY")).colorsConfig)[colorMode][color].fontColor,
            disabledColorConfig: (0, (0, parcelRequire("gmmpY")).disabledColorConfig)[colorMode]
        }), inputName && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).Name), null, inputName))));
    };
    const $5a84988b432bf2ca$var$CustomOption = (props)=>{
        const { data: data } = props;
        const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, (name || nameLabel || includeIcon) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).ContainerLabel), {
            definitionExists: Boolean(definition)
        }, nameFormatter ? nameFormatter(data) : (0, ($parcel$interopDefault($5uXOq))).createElement($5a84988b432bf2ca$export$f31d135f91971ac4, data), nameLabel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).NameLabel), null, nameLabel)), definition && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).Definition), null, definition)));
    };
    const $5a84988b432bf2ca$export$f31d135f91971ac4 = (data)=>{
        const { colorMode: colorMode = 'light' } = (0, (0, parcelRequire("hxoiH")).default)();
        const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'GREY', colorOnlyIconBackground: colorOnlyIconBackground = false } = data || {};
        const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
        const iconComponent = includeIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Kq24")).ClassificationIcon), {
            width: 14,
            height: 14,
            isDisabled: false,
            color: (0, (0, parcelRequire("gmmpY")).colorsConfig)[colorMode][color].fontColor,
            disabledColorConfig: (0, (0, parcelRequire("gmmpY")).disabledColorConfig)[colorMode]
        });
        const nameComponent = name && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).Name), null, name.substring(0, (0, (0, parcelRequire("gmmpY")).nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1)));
        return colorOnlyIconBackground ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).ContainerIcon), {
            colorsConfig: (0, (0, parcelRequire("gmmpY")).colorsConfig)[colorMode][color],
            isIconOnly: includeIcon && !name
        }, iconComponent), nameComponent) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).ContainerIcon), {
            colorsConfig: (0, (0, parcelRequire("gmmpY")).colorsConfig)[colorMode][color],
            isIconOnly: includeIcon && !name
        }, iconComponent, nameComponent);
    };
    const $5a84988b432bf2ca$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange })=>{
        const onSelectChange = (option)=>{
            const selectedOption = {
                name: option?.name,
                definition: option?.definition,
                label: option?.nameLabel
            };
            const selectedClassification = options.find((opt)=>(0, ($parcel$interopDefault($ajpes)))({
                    name: opt.name,
                    definition: opt.definition,
                    label: opt.label
                }, selectedOption));
            if (!selectedOption || !selectedClassification) return;
            if (onChange) onChange(selectedClassification);
        };
        const transformToOptionType = (0, $5uXOq.useCallback)((classification)=>({
                ...(0, ($parcel$interopDefault($LpImS)))(classification),
                label: classification.name ?? classification.label ?? classification.definition,
                value: classification.name ?? classification.label ?? classification.definition,
                nameLabel: classification.label
            }), []);
        const transformedOptions = (0, $5uXOq.useMemo)(()=>options.map(transformToOptionType), [
            options,
            transformToOptionType
        ]);
        const renderDropdown = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                "aria-label": "data-classification-select",
                inputId: "data-classification-dropdown-input",
                options: transformedOptions,
                value: !value || errorMessage ? null : transformToOptionType(value),
                onChange: onSelectChange,
                onInputChange: onInputChange,
                isInvalid: Boolean(errorMessage),
                isDisabled: isDisabled,
                components: {
                    Option: $5a84988b432bf2ca$var$CustomOption,
                    SingleValue: $5a84988b432bf2ca$var$CustomSingleValue
                },
                styles: {
                    option: (baseStyles)=>({
                            ...baseStyles,
                            padding: "var(--ds-space-200, 16px)"
                        }),
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: 9999
                        })
                },
                menuPortalTarget: document.body
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100"
        }, label && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bj9nc")).DropdownLabel), {
            htmlFor: "data-classification-dropdown-input"
        }, label), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050"
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: disabledTooltipMessage
        }, renderDropdown()) : renderDropdown(), errorMessage && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            gap: "space.050",
            xcss: $5a84988b432bf2ca$var$dangerTextStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            size: "small",
            color: "inherit"
        }, errorMessage))));
    };
});
parcelRegister("059q9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));
    var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
    function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>$00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
            LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
        }, props));
    $00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
    var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;
});
parcelRegister("hAZqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ccf572dfbabebdf7$var$_UNSAFE_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>$ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
    var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;
});
parcelRegister("bChGW", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$ea75c1778b4e3ad2$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$ea75c1778b4e3ad2$export$71abc632aa29e6fe);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $ea75c1778b4e3ad2$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("95iuW")).ClearIndicator),
        Control: (0, (0, parcelRequire("eZFhY")).default),
        DropdownIndicator: (0, (0, parcelRequire("95iuW")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("95iuW")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("95iuW")).CrossIcon),
        Group: (0, (0, parcelRequire("i48X9")).default),
        GroupHeading: (0, (0, parcelRequire("i48X9")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("h1QWG")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("95iuW")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("dS5G5")).default),
        LoadingIndicator: (0, (0, parcelRequire("95iuW")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("aA8TC")).default),
        MenuList: (0, (0, parcelRequire("aA8TC")).MenuList),
        MenuPortal: (0, (0, parcelRequire("aA8TC")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("aA8TC")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("aA8TC")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hqcPo")).default),
        MultiValueContainer: (0, (0, parcelRequire("hqcPo")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hqcPo")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hqcPo")).MultiValueRemove),
        Option: (0, (0, parcelRequire("8l2RA")).default),
        Placeholder: (0, (0, parcelRequire("kKm82")).default),
        SelectContainer: (0, (0, parcelRequire("h1QWG")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("hpcbi")).default),
        ValueContainer: (0, (0, parcelRequire("h1QWG")).ValueContainer)
    };
    const $ea75c1778b4e3ad2$export$71abc632aa29e6fe = (props)=>({
            ...$ea75c1778b4e3ad2$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("h1QWG", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$78186faf13ea75d3$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$78186faf13ea75d3$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$78186faf13ea75d3$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$78186faf13ea75d3$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$78186faf13ea75d3$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$78186faf13ea75d3$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $gyjU7;
    const $78186faf13ea75d3$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            position: 'relative',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            pointerEvents: 'all',
            cursor: isDisabled ? 'not-allowed' : undefined
        });
    const $78186faf13ea75d3$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$47aec73c7aa6b9aa = ({ isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, selectProps: { controlShouldRenderValue: controlShouldRenderValue } })=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            padding: `${isCompact ? 0 : "var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
        });
    const $78186faf13ea75d3$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $78186faf13ea75d3$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0,
            paddingRight: "var(--ds-space-050, 4px)"
        });
    const $78186faf13ea75d3$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("gyjU7", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$109d3f9af5469308$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$109d3f9af5469308$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$109d3f9af5469308$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$109d3f9af5469308$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$109d3f9af5469308$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$109d3f9af5469308$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$109d3f9af5469308$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$109d3f9af5469308$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$109d3f9af5469308$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$109d3f9af5469308$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$109d3f9af5469308$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$109d3f9af5469308$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$109d3f9af5469308$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$109d3f9af5469308$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$109d3f9af5469308$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$109d3f9af5469308$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$109d3f9af5469308$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$109d3f9af5469308$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$109d3f9af5469308$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$109d3f9af5469308$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$109d3f9af5469308$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$109d3f9af5469308$export$4213b25a1c4e877);
    const $109d3f9af5469308$export$8793edee2d425525 = ()=>{};
    const $109d3f9af5469308$export$1643ccb46f49255c = ()=>'';
    function $109d3f9af5469308$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $109d3f9af5469308$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$109d3f9af5469308$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $109d3f9af5469308$export$33f062f47f21a01 = (value)=>{
        if ($109d3f9af5469308$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $109d3f9af5469308$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $109d3f9af5469308$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $109d3f9af5469308$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $109d3f9af5469308$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $109d3f9af5469308$export$2e0654fad740d2e4(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $109d3f9af5469308$export$c4a223a8ba9e4ea5(el) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $109d3f9af5469308$export$3f99968195accfaf(el, top) {
        if ($109d3f9af5469308$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $109d3f9af5469308$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $109d3f9af5469308$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $109d3f9af5469308$export$858c30343199f3af(element, to, duration = 200, callback = $109d3f9af5469308$export$8793edee2d425525) {
        const start = $109d3f9af5469308$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $109d3f9af5469308$var$easeOutCubic(currentTime, start, change, duration);
            $109d3f9af5469308$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $109d3f9af5469308$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $109d3f9af5469308$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $109d3f9af5469308$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $109d3f9af5469308$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $109d3f9af5469308$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $109d3f9af5469308$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $109d3f9af5469308$var$passiveOptionAccessed = false;
    const $109d3f9af5469308$var$options = {
        get passive () {
            return $109d3f9af5469308$var$passiveOptionAccessed = true;
        }
    };
    const $109d3f9af5469308$var$w = typeof window !== 'undefined' ? window : {};
    if ($109d3f9af5469308$var$w.addEventListener && $109d3f9af5469308$var$w.removeEventListener) {
        $109d3f9af5469308$var$w.addEventListener('p', $109d3f9af5469308$export$8793edee2d425525, $109d3f9af5469308$var$options);
        $109d3f9af5469308$var$w.removeEventListener('p', $109d3f9af5469308$export$8793edee2d425525, false);
    }
    const $109d3f9af5469308$export$b0622a6911dbeaf5 = $109d3f9af5469308$var$passiveOptionAccessed;
    function $109d3f9af5469308$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $109d3f9af5469308$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $109d3f9af5469308$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $109d3f9af5469308$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $109d3f9af5469308$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $109d3f9af5469308$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("eZFhY", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$728816cb4150b6bc$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$728816cb4150b6bc$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $728816cb4150b6bc$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, isCompact: isCompact, appearance: appearance })=>{
        let borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
        let backgroundColor = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)";
        let backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
        let borderColorHover = isFocused ? "var(--ds-border-focused, #388BFF)" : "var(--ds-border-input, #8590A2)";
        if (isDisabled) {
            backgroundColor = "var(--ds-background-disabled, #091E4208)";
            borderColor = "var(--ds-background-disabled, #091E4208)";
        }
        if (isInvalid) {
            borderColor = "var(--ds-border-danger, #E2483D)";
            borderColorHover = "var(--ds-border-danger, #E2483D)";
        }
        const transitionDuration = '200ms';
        if (appearance === 'subtle') {
            borderColor = isFocused ? "var(--ds-border-focused, #388BFF)" : 'transparent';
            backgroundColor = isFocused ? "var(--ds-surface, #FFFFFF)" : 'transparent';
            backgroundColorHover = isFocused ? "var(--ds-background-input-pressed, #FFFFFF)" : "var(--ds-background-input-hovered, #F7F8F9)";
        }
        if (appearance === 'none') {
            borderColor = 'transparent';
            backgroundColor = 'transparent';
            backgroundColorHover = 'transparent';
            borderColorHover = 'transparent';
        }
        return {
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            outline: '0 !important',
            position: 'relative',
            pointerEvents: isDisabled ? 'none' : undefined,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderStyle: 'solid',
            borderRadius: "var(--ds-border-radius-100, 3px)",
            borderWidth: "var(--ds-border-width, 1px)",
            boxShadow: isInvalid ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
            '&:focus-within': {
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
            },
            minHeight: isCompact ? 32 : 40,
            padding: 0,
            transition: `background-color ${transitionDuration} ease-in-out,
border-color ${transitionDuration} ease-in-out`,
            '::-webkit-scrollbar': {
                height: 8,
                width: 8
            },
            '::-webkit-scrollbar-corner': {
                display: 'none'
            },
            ':hover': {
                '::-webkit-scrollbar-thumb': {
                    backgroundColor: 'rgba(0,0,0,0.2)'
                },
                cursor: 'pointer',
                backgroundColor: backgroundColorHover,
                borderColor: borderColorHover
            },
            '::-webkit-scrollbar-thumb:hover': {
                backgroundColor: 'rgba(0,0,0,0.4)'
            }
        };
    };
    const $728816cb4150b6bc$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $728816cb4150b6bc$export$2e2bcd8739ae039 = $728816cb4150b6bc$var$Control;
});
parcelRegister("i48X9", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$902e86f4b4fe337b$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$902e86f4b4fe337b$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$902e86f4b4fe337b$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$902e86f4b4fe337b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $902e86f4b4fe337b$export$b6794329c1460634 = ({})=>({
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingTop: "var(--ds-space-100, 8px)"
        });
    const $902e86f4b4fe337b$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $902e86f4b4fe337b$export$e5a7fbb542efcb7d = ({})=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            fontSize: '75%',
            marginBottom: '0.25em',
            paddingLeft: "var(--ds-space-150, 12px)",
            paddingRight: "var(--ds-space-150, 12px)",
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            color: "var(--ds-text-subtle, #44546F)",
            fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
            textTransform: 'none'
        });
    const $902e86f4b4fe337b$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $902e86f4b4fe337b$export$2e2bcd8739ae039 = $902e86f4b4fe337b$var$Group;
});
parcelRegister("95iuW", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$13f090f36c42825d$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$13f090f36c42825d$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$13f090f36c42825d$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$13f090f36c42825d$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$13f090f36c42825d$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$13f090f36c42825d$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$13f090f36c42825d$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$13f090f36c42825d$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$13f090f36c42825d$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$13f090f36c42825d$export$7c20be4c1d342248);
    var $f8Sb3;
    var $gyjU7;
    function $13f090f36c42825d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13f090f36c42825d$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $13f090f36c42825d$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $13f090f36c42825d$var$styles,
            ...props
        });
    const $13f090f36c42825d$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $13f090f36c42825d$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $13f090f36c42825d$export$e1687335805e1230 = ({ isCompact: isCompact, isDisabled: isDisabled })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtle, #44546F)",
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
            ':hover': {
                color: "var(--ds-text-subtle, #44546F)"
            }
        });
    const $13f090f36c42825d$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$c5cbe1656ba71e6c, null));
    };
    const $13f090f36c42825d$export$9c0419fd944c1def = ({ isCompact: isCompact })=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            color: "var(--ds-text-subtlest, #626F86)",
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-025, 2px)"}`,
            ':hover': {
                color: "var(--ds-text-subtle, #44546F)"
            }
        });
    const $13f090f36c42825d$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$export$3b621d86b1566b2, null));
    };
    const $13f090f36c42825d$export$ec39646155d07fdd = ({ isDisabled: isDisabled })=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            backgroundColor: isDisabled ? "var(--ds-border-disabled, #091E420F)" : "var(--ds-border, #091E4224)",
            marginBottom: "var(--ds-space-100, 8px)",
            marginTop: "var(--ds-space-100, 8px)"
        });
    const $13f090f36c42825d$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $13f090f36c42825d$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $13f090f36c42825d$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, isCompact: isCompact, theme: { colors: colors } })=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: `${isCompact ? 0 : "var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`
        });
    const $13f090f36c42825d$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$13f090f36c42825d$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $13f090f36c42825d$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($13f090f36c42825d$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("dS5G5", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$1c949ac6f5985b40$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$1c949ac6f5985b40$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $1c949ac6f5985b40$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } })=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$1c949ac6f5985b40$var$containerStyle,
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: "var(--ds-text, hsl(0, 0%, 20%))"
        });
    const $1c949ac6f5985b40$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $1c949ac6f5985b40$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$1c949ac6f5985b40$var$spacingStyle
        }
    };
    const $1c949ac6f5985b40$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$1c949ac6f5985b40$var$spacingStyle
        });
    const $1c949ac6f5985b40$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("gyjU7")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $1c949ac6f5985b40$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $1c949ac6f5985b40$export$2e2bcd8739ae039 = $1c949ac6f5985b40$var$Input;
});
parcelRegister("aA8TC", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$1fde8cb844828ae2$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$1fde8cb844828ae2$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$1fde8cb844828ae2$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$1fde8cb844828ae2$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$1fde8cb844828ae2$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$1fde8cb844828ae2$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$1fde8cb844828ae2$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$1fde8cb844828ae2$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$1fde8cb844828ae2$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$1fde8cb844828ae2$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$1fde8cb844828ae2$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $gyjU7;
    function $1fde8cb844828ae2$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("gyjU7")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("gyjU7")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("gyjU7")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("gyjU7")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $1fde8cb844828ae2$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $1fde8cb844828ae2$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $1fde8cb844828ae2$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } })=>({
            label: 'menu',
            [$1fde8cb844828ae2$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            borderRadius: borderRadius,
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter,
            backgroundColor: "var(--ds-surface-overlay, white)",
            boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
        });
    const $1fde8cb844828ae2$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $1fde8cb844828ae2$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($1fde8cb844828ae2$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $1fde8cb844828ae2$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $1fde8cb844828ae2$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $1fde8cb844828ae2$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $1fde8cb844828ae2$export$2e2bcd8739ae039 = $1fde8cb844828ae2$var$Menu;
    const $1fde8cb844828ae2$export$abafed69cff95d5e = ({ maxHeight: maxHeight })=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        });
    const $1fde8cb844828ae2$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $1fde8cb844828ae2$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } })=>({
            textAlign: 'center',
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        });
    const $1fde8cb844828ae2$export$cf0e22534d8b0074 = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$98ec46397a8cb3cd = $1fde8cb844828ae2$var$noticeCSS;
    const $1fde8cb844828ae2$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $1fde8cb844828ae2$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $1fde8cb844828ae2$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $1fde8cb844828ae2$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($1fde8cb844828ae2$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("gyjU7")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1fde8cb844828ae2$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hqcPo", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$20933ad7b05a0c37$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$20933ad7b05a0c37$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$20933ad7b05a0c37$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$20933ad7b05a0c37$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$20933ad7b05a0c37$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$20933ad7b05a0c37$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$20933ad7b05a0c37$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $gyjU7;
    var $95iuW;
    const $20933ad7b05a0c37$export$23c213f7717186af = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } })=>{
        let backgroundColor;
        let color;
        if (isDisabled) {
            backgroundColor = "var(--ds-background-neutral, #091E420F)";
            color = "var(--ds-text-disabled, #091E424F)";
        } else if (isFocused) {
            backgroundColor = "var(--ds-background-selected, #E9F2FF)";
            color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
        } else {
            backgroundColor = (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : "var(--ds-background-neutral, #091E420F)";
            color = "var(--ds-text, hsl(0, 0%, 20%))";
        }
        return {
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            margin: "var(--ds-space-025, 2px)",
            borderRadius: "var(--ds-border-radius-050, 2px)",
            backgroundColor: backgroundColor,
            boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
            maxWidth: '100%',
            '@media screen and (-ms-high-contrast: active)': {
                border: isFocused ? '1px solid transparent' : 'none'
            },
            color: color,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                borderRadius: "var(--ds-border-radius-100, 4px)",
                borderColor: '#B7B9BE',
                borderWidth: "var(--ds-border-width, 1px)",
                borderStyle: 'solid',
                backgroundColor: "var(--ds-background-input, #FFFFFF)"
            }
        };
    };
    const $20933ad7b05a0c37$export$f40612612e0af964 = ({ cropWithEllipsis: cropWithEllipsis, isDisabled: isDisabled })=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            borderRadius: "var(--ds-border-radius-050, 2px)",
            fontSize: '85%',
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            padding: "var(--ds-space-025, 2px)",
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : 'inherit',
            paddingLeft: "var(--ds-space-075, 6px)",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: "var(--ds-space-050, 4px)"
            }
        });
    const $20933ad7b05a0c37$export$283467f6c4ac142b = ({ isFocused: isFocused })=>({
            alignItems: 'center',
            display: 'flex',
            backgroundColor: isFocused ? "var(--ds-UNSAFE-transparent, transparent)" : undefined,
            fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
            paddingLeft: "var(--ds-space-025, 2px)",
            paddingRight: "var(--ds-space-025, 2px)",
            borderRadius: '0px 2px 2px 0px',
            ':hover': {
                backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)",
                fill: "var(--ds-text-danger, #000)"
            },
            ':active': {
                backgroundColor: "var(--ds-background-danger-pressed, #FD9891)",
                fill: "var(--ds-text-danger, #000)"
            },
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && {
                backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                border: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
                appearance: 'none',
                borderRadius: "var(--ds-border-radius, 4px)",
                color: "var(--ds-text, #172B4D)",
                padding: "var(--ds-space-025, 2px)",
                marginRight: "var(--ds-space-025, 2px)",
                ':focus-visible': {
                    outlineOffset: "var(--ds-space-negative-025, -2px)"
                },
                ':hover': {
                    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                },
                ':active': {
                    backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                }
            }
        });
    const $20933ad7b05a0c37$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $20933ad7b05a0c37$export$cf9cf2a30a59265c = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    const $20933ad7b05a0c37$export$544aeea2a5ce08ee = $20933ad7b05a0c37$export$e1de505c1242dc1a;
    function $20933ad7b05a0c37$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("95iuW")).CrossIcon), {
            size: 14
        }));
    }
    const $20933ad7b05a0c37$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $20933ad7b05a0c37$export$2e2bcd8739ae039 = $20933ad7b05a0c37$var$MultiValue;
});
parcelRegister("8l2RA", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$6e6d67a90b457dc1$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$6e6d67a90b457dc1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $6e6d67a90b457dc1$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
        let color = "var(--ds-text, #172B4D)";
        if (isDisabled) color = "var(--ds-text-disabled, #091E424F)";
        else if (isSelected) color = "var(--ds-text-selected, #0C66E4)";
        let boxShadow;
        let backgroundColor;
        if (isDisabled) backgroundColor = undefined;
        else if (isSelected && isFocused) backgroundColor = "var(--ds-background-selected-hovered, #CCE0FF)";
        else if (isSelected) backgroundColor = "var(--ds-background-selected, #E9F2FF)";
        else if (isFocused) backgroundColor = "var(--ds-background-neutral-subtle-hovered, #091E420F)";
        if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${"var(--ds-border-selected, #0C66E4)"}`;
        const cursor = isDisabled ? 'not-allowed' : 'default';
        return {
            label: 'option',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            backgroundColor: backgroundColor,
            color: color,
            cursor: cursor,
            boxShadow: boxShadow,
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? "var(--ds-background-selected-pressed, #85B8FF)" : "var(--ds-background-neutral-subtle-pressed, #091E4224)" : undefined
            },
            '@media screen and (-ms-high-contrast: active)': {
                borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
            }
        };
    };
    const $6e6d67a90b457dc1$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $6e6d67a90b457dc1$export$2e2bcd8739ae039 = $6e6d67a90b457dc1$var$Option;
});
parcelRegister("kKm82", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$889d652a9d0dc097$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$889d652a9d0dc097$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $889d652a9d0dc097$export$5f3ffacd6594d90f = ({ isDisabled: isDisabled })=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            margin: `0 ${"var(--ds-space-025, 2px)"}`,
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text-subtlest, #626F86)"
        });
    const $889d652a9d0dc097$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $889d652a9d0dc097$export$2e2bcd8739ae039 = $889d652a9d0dc097$var$Placeholder;
});
parcelRegister("hpcbi", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$aff94346c62a222f$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$aff94346c62a222f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $aff94346c62a222f$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing } })=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: `0 ${"var(--ds-space-025, 2px)"}`,
            color: isDisabled ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)"
        });
    const $aff94346c62a222f$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("gyjU7")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $aff94346c62a222f$export$2e2bcd8739ae039 = $aff94346c62a222f$var$SingleValue;
});
parcelRegister("7K5PP", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$c2d344e1481a2d3b$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$c2d344e1481a2d3b$export$2e2bcd8739ae039);
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $eAthk;
    var $3c98u;
    const $c2d344e1481a2d3b$var$packageName = "platform-pkg";
    const $c2d344e1481a2d3b$var$packageVersion = "0.0.0-use.local";
    const $c2d344e1481a2d3b$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    const $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    const $c2d344e1481a2d3b$var$Select = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'select',
        packageName: $c2d344e1481a2d3b$var$packageName,
        packageVersion: $c2d344e1481a2d3b$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: $c2d344e1481a2d3b$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $c2d344e1481a2d3b$var$packageName,
                packageVersion: $c2d344e1481a2d3b$var$packageVersion
            }
        })
    })($c2d344e1481a2d3b$export$d1de3b251ccaa8a3));
    var $c2d344e1481a2d3b$export$2e2bcd8739ae039 = $c2d344e1481a2d3b$var$Select;
});
parcelRegister("eAthk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d0cf20527a3a891$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("iaInK")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $iaInK;
    var $9uJ4X;
    const $6d0cf20527a3a891$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("iaInK")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("9uJ4X")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $6d0cf20527a3a891$export$2e2bcd8739ae039 = $6d0cf20527a3a891$var$AsyncSelect;
});
parcelRegister("2QhWf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d8e863683b34816f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $aCMCu;
    var $eEtcC;
    var $bChGW;
    var $jtVgE;
    var $9cRAr;
    var $galqx;
    var $81i5b;
    var $aA8TC;
    var $5JAlL;
    var $7VXAu;
    var $5HBcW;
    var $gyjU7;
    const $d8e863683b34816f$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("gyjU7")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("5JAlL")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("eEtcC")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("eEtcC")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("eEtcC")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("eEtcC")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("gyjU7")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true
    };
    function $d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $d8e863683b34816f$var$isOptionSelected(props, option, selectValue);
        const label = $d8e863683b34816f$var$getOptionLabel(props, option);
        const value = $d8e863683b34816f$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $d8e863683b34816f$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$d8e863683b34816f$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$d8e863683b34816f$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $d8e863683b34816f$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $d8e863683b34816f$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("gyjU7")).notNullish));
    }
    function $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) {
        return $d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue));
    }
    function $d8e863683b34816f$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$d8e863683b34816f$var$shouldHideSelectedOptions(props) || !isSelected) && $d8e863683b34816f$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $d8e863683b34816f$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $d8e863683b34816f$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $d8e863683b34816f$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $d8e863683b34816f$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $d8e863683b34816f$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $d8e863683b34816f$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $d8e863683b34816f$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $d8e863683b34816f$var$getOptionValue(props, option);
        return selectValue.some((i)=>$d8e863683b34816f$var$getOptionValue(props, i) === candidate);
    }
    function $d8e863683b34816f$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $d8e863683b34816f$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $d8e863683b34816f$var$instanceId = 1;
    class $d8e863683b34816f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $d8e863683b34816f$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props), this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            }, this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, this.isAppleDevice = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("aCMCu")).isSafari)() : (0, (0, parcelRequire("aCMCu")).isAppleDevice)(), this.controlRef = null, this.getControlRef = (ref)=>{
                this.controlRef = ref;
            }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            }, this.inputRef = null, this.getInputRef = (ref)=>{
                this.inputRef = ref;
            }, this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            }, this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            }, this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("gyjU7")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("gyjU7")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            }, this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            }, this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("gyjU7")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            }, this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            }, this.getFocusedOptionId = (focusedOption)=>{
                return $d8e863683b34816f$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            }, this.getFocusableOptionsWithIds = ()=>{
                return $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, (0, parcelRequire("gyjU7")).classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
                return $d8e863683b34816f$var$getOptionLabel(this.props, data);
            }, this.getOptionValue = (data)=>{
                return $d8e863683b34816f$var$getOptionValue(this.props, data);
            }, this.getStyles = (key, props)=>{
                const base = (0, (0, parcelRequire("7VXAu")).defaultStyles)[key](props);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            }, this.getClassNames = (key, props)=>this.props.classNames[key]?.(props), this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            }, this.getComponents = ()=>{
                return (0, (0, parcelRequire("bChGW")).defaultComponents)(this.props);
            }, this.buildCategorizedOptions = ()=>$d8e863683b34816f$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$d8e863683b34816f$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            }, this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            }, this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            }, this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            }, this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            }, this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            }, this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("gyjU7")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            }, this.onCompositionStart = ()=>{
                this.isComposing = true;
            }, this.onCompositionEnd = ()=>{
                this.isComposing = false;
            }, this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            }, this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            }, this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            }, this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            }, this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            }, this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            }, this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            }, this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            }, this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            }, this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            }, this.shouldHideSelectedOptions = ()=>{
                return $d8e863683b34816f$var$shouldHideSelectedOptions(this.props);
            }, this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            }, this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$d8e863683b34816f$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("gyjU7")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $d8e863683b34816f$var$buildFocusableOptionsWithIds($d8e863683b34816f$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $d8e863683b34816f$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $d8e863683b34816f$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $d8e863683b34816f$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("gyjU7")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("5HBcW")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("5HBcW")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("5HBcW")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $d8e863683b34816f$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $d8e863683b34816f$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $d8e863683b34816f$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jtVgE")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("gyjU7")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            const isCompact = spacing === 'compact';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const isCompact = spacing === 'compact';
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, spacing: spacing } = this.props;
            const { isFocused: isFocused } = this.state;
            const isCompact = spacing === 'compact';
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isCompact: isCompact
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aA8TC")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("galqx")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cRAr")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81i5b")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            const isCompact = spacing === 'compact';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                appearance: appearance,
                isInvalid: isInvalid,
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen,
                isCompact: isCompact
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled,
                isCompact: isCompact
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("aCMCu", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$150018e79a44f2ed$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$150018e79a44f2ed$export$e1865c3bedcd822b);
    function $150018e79a44f2ed$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $150018e79a44f2ed$export$186c6964ca17d99() {
        return $150018e79a44f2ed$var$testPlatform(/^iPhone/i);
    }
    function $150018e79a44f2ed$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $150018e79a44f2ed$export$9ac100e40613ea10() {
        return $150018e79a44f2ed$var$testPlatform(/^Mac/i);
    }
    function $150018e79a44f2ed$export$7bef049ce92e4224() {
        return $150018e79a44f2ed$var$testPlatform(/^iPad/i) || $150018e79a44f2ed$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $150018e79a44f2ed$export$fedb369cb70207f1() {
        return $150018e79a44f2ed$export$186c6964ca17d99() || $150018e79a44f2ed$export$7bef049ce92e4224();
    }
    function $150018e79a44f2ed$export$e1865c3bedcd822b() {
        return $150018e79a44f2ed$export$9ac100e40613ea10() || $150018e79a44f2ed$export$fedb369cb70207f1();
    }
});
parcelRegister("eEtcC", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$1a3d0f2eb875e1af$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$1a3d0f2eb875e1af$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$1a3d0f2eb875e1af$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$1a3d0f2eb875e1af$export$56bd0c8d90db075);
    const $1a3d0f2eb875e1af$export$f4da216a6ca54656 = (group)=>group.label;
    const $1a3d0f2eb875e1af$export$dac6ace3020563ca = (option)=>option.label;
    const $1a3d0f2eb875e1af$export$40be908210c5a79c = (option)=>option.value;
    const $1a3d0f2eb875e1af$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("jtVgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afe53037961824c2$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gyjU7;
    const $afe53037961824c2$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $afe53037961824c2$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("gyjU7")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $afe53037961824c2$var$dummyInputStyles
        });
    }
});
parcelRegister("9cRAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a388fa48a9e96271$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $eGmKJ;
    function $a388fa48a9e96271$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a388fa48a9e96271$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $a388fa48a9e96271$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $a388fa48a9e96271$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("eGmKJ")).default)
        });
    var $a388fa48a9e96271$export$2e2bcd8739ae039 = $a388fa48a9e96271$var$RequiredInput;
});
parcelRegister("galqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15a49c0b3452f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $59IMp;
    var $3jzRI;
    function $e15a49c0b3452f71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15a49c0b3452f71$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $e15a49c0b3452f71$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $e15a49c0b3452f71$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("59IMp")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("3jzRI")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $e15a49c0b3452f71$var$blurSelectInput,
            css: $e15a49c0b3452f71$var$styles
        }), children(targetRef));
    }
});
parcelRegister("59IMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96c08116303d9e3a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    const $96c08116303d9e3a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $96c08116303d9e3a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $96c08116303d9e3a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("gyjU7")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("3jzRI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$840302f0f43020c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $840302f0f43020c5$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $840302f0f43020c5$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $840302f0f43020c5$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $840302f0f43020c5$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $840302f0f43020c5$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $840302f0f43020c5$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $840302f0f43020c5$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $840302f0f43020c5$var$activeScrollLocks = 0;
    const $840302f0f43020c5$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $840302f0f43020c5$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($840302f0f43020c5$var$LOCK_STYLES).forEach((key)=>{
                    const val = $840302f0f43020c5$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.addEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
            $840302f0f43020c5$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$840302f0f43020c5$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $840302f0f43020c5$var$activeScrollLocks = Math.max($840302f0f43020c5$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $840302f0f43020c5$var$activeScrollLocks < 1) $840302f0f43020c5$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $840302f0f43020c5$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $840302f0f43020c5$var$preventTouchMove, $840302f0f43020c5$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $840302f0f43020c5$var$preventInertiaScroll, $840302f0f43020c5$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $840302f0f43020c5$var$allowTouchMove, $840302f0f43020c5$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("81i5b", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3ccfcdca5695e58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dQlbw;
    var $bEd7d;
    const $a3ccfcdca5695e58$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("dQlbw")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bEd7d")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $a3ccfcdca5695e58$export$2e2bcd8739ae039 = $a3ccfcdca5695e58$var$LiveRegion;
});
parcelRegister("dQlbw", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$d3258ad64818881e$export$a7265767c78f9bae);
    var $VSDnB;
    const $d3258ad64818881e$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("VSDnB")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bEd7d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cc43afa82d3c33b$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7cc43afa82d3c33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7cc43afa82d3c33b$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $7cc43afa82d3c33b$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7cc43afa82d3c33b$var$styles,
            ...props
        });
    var $7cc43afa82d3c33b$export$2e2bcd8739ae039 = $7cc43afa82d3c33b$var$A11yText;
});
parcelRegister("5JAlL", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$2c9d8148d5bbcfb3$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $bXu2O;
    const $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("bXu2O")).stripDiacritics));
    const $2c9d8148d5bbcfb3$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $2c9d8148d5bbcfb3$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $2c9d8148d5bbcfb3$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $2c9d8148d5bbcfb3$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $2c9d8148d5bbcfb3$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $2c9d8148d5bbcfb3$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $2c9d8148d5bbcfb3$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("bXu2O")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("bXu2O", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$df93339199dda18e$export$b5bee4b27048330b);
    const $df93339199dda18e$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $df93339199dda18e$var$anyDiacritic = new RegExp('[' + $df93339199dda18e$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $df93339199dda18e$var$diacriticToBase = {};
    for(let i = 0; i < $df93339199dda18e$var$diacritics.length; i++){
        let diacritic = $df93339199dda18e$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$df93339199dda18e$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $df93339199dda18e$export$b5bee4b27048330b = (str)=>{
        return str.replace($df93339199dda18e$var$anyDiacritic, (match)=>$df93339199dda18e$var$diacriticToBase[match]);
    };
});
parcelRegister("7VXAu", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$11d0fd648d1f51c0$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$11d0fd648d1f51c0$export$e618dc39ac9ad607);
    var $h1QWG;
    var $eZFhY;
    var $i48X9;
    var $95iuW;
    var $dS5G5;
    var $aA8TC;
    var $hqcPo;
    var $8l2RA;
    var $kKm82;
    var $hpcbi;
    const $11d0fd648d1f51c0$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("95iuW")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("h1QWG")).containerCSS),
        control: (0, (0, parcelRequire("eZFhY")).css),
        dropdownIndicator: (0, (0, parcelRequire("95iuW")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("i48X9")).groupCSS),
        groupHeading: (0, (0, parcelRequire("i48X9")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("h1QWG")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("95iuW")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("dS5G5")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("95iuW")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("aA8TC")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("aA8TC")).menuCSS),
        menuList: (0, (0, parcelRequire("aA8TC")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("aA8TC")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hqcPo")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hqcPo")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hqcPo")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("aA8TC")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("8l2RA")).optionCSS),
        placeholder: (0, (0, parcelRequire("kKm82")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("hpcbi")).css),
        valueContainer: (0, (0, parcelRequire("h1QWG")).valueContainerCSS)
    };
    function $11d0fd648d1f51c0$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("5HBcW", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$f64b5780144c9fe8$export$164de7ab8df77ef0);
    const $f64b5780144c9fe8$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $f64b5780144c9fe8$var$borderRadius = 4;
    const $f64b5780144c9fe8$var$baseUnit = 4;
    const $f64b5780144c9fe8$var$controlHeight = 38;
    const $f64b5780144c9fe8$var$menuGutter = $f64b5780144c9fe8$var$baseUnit * 2;
    const $f64b5780144c9fe8$export$5458b64234d1333c = {
        baseUnit: $f64b5780144c9fe8$var$baseUnit,
        controlHeight: $f64b5780144c9fe8$var$controlHeight,
        menuGutter: $f64b5780144c9fe8$var$menuGutter
    };
    const $f64b5780144c9fe8$export$164de7ab8df77ef0 = {
        borderRadius: $f64b5780144c9fe8$var$borderRadius,
        colors: $f64b5780144c9fe8$export$8f45430ccf837300,
        spacing: $f64b5780144c9fe8$export$5458b64234d1333c
    };
});
parcelRegister("iaInK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e85c90096c52fe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gyjU7;
    function $7e85c90096c52fe4$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("gyjU7")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("9uJ4X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72b6d9d338d10de1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $72b6d9d338d10de1$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("3c98u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$628a0199069e875a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l4W7r;
    var $1k2at;
    var $j1GDZ;
    var $bA56e;
    var $1DATb;
    function $628a0199069e875a$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("l4W7r")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("l4W7r")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("l4W7r")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("1k2at")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("1k2at")).IndicatorSeparator,
                    Input: (0, parcelRequire("j1GDZ")).Input,
                    NoOptionsMessage: (0, parcelRequire("bA56e")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("1DATb")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid || validationState === 'error',
                ...restProps,
                components: components,
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("l4W7r", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$9145857df3efc9da$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$9145857df3efc9da$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$9145857df3efc9da$export$7c20be4c1d342248);
    var $f8Sb3;
    var $c8Oei;
    var $cQz2U;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $bChGW;
    var $eZJjh;
    const $9145857df3efc9da$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $9145857df3efc9da$var$dropdownWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.075'
    });
    const $9145857df3efc9da$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: $9145857df3efc9da$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $9145857df3efc9da$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            as: "span",
            xcss: $9145857df3efc9da$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $9145857df3efc9da$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            size: "small"
        })));
    };
});
parcelRegister("cQz2U", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95a586bfe482ffec$var$_react = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95a586bfe482ffec$var$_crossCircle = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("47etd")));
    var $95a586bfe482ffec$var$_selectClear = $95a586bfe482ffec$var$_interopRequireDefault((parcelRequire("673MF")));
    function $95a586bfe482ffec$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95a586bfe482ffec$var$CrossCircleIcon = (props)=>$95a586bfe482ffec$var$_react.default.createElement($95a586bfe482ffec$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $95a586bfe482ffec$var$_selectClear.default
        }, props));
    $95a586bfe482ffec$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $95a586bfe482ffec$var$_default = module.exports.default = $95a586bfe482ffec$var$CrossCircleIcon;
});
parcelRegister("47etd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ff30a5d9a7d32b6$var$_react = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ff30a5d9a7d32b6$var$_UNSAFE_baseNew = $2ff30a5d9a7d32b6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2ff30a5d9a7d32b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ff30a5d9a7d32b6$var$CrossCircleIcon = (props)=>$2ff30a5d9a7d32b6$var$_react.default.createElement($2ff30a5d9a7d32b6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $2ff30a5d9a7d32b6$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $2ff30a5d9a7d32b6$var$_default = module.exports.default = $2ff30a5d9a7d32b6$var$CrossCircleIcon;
});
parcelRegister("673MF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $473654f205f53fc4$var$_react = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $473654f205f53fc4$var$_crossCircle = $473654f205f53fc4$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $473654f205f53fc4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $473654f205f53fc4$var$SelectClearIcon = (props)=>$473654f205f53fc4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $473654f205f53fc4$var$_crossCircle.default
        }));
    $473654f205f53fc4$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $473654f205f53fc4$var$_default = module.exports.default = $473654f205f53fc4$var$SelectClearIcon;
});
parcelRegister("hI6SY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce4be313f95bc8ed$var$_react = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ce4be313f95bc8ed$var$_UNSAFE_baseNew = $ce4be313f95bc8ed$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ce4be313f95bc8ed$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ce4be313f95bc8ed$var$CrossCircleIcon = (props)=>$ce4be313f95bc8ed$var$_react.default.createElement($ce4be313f95bc8ed$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $ce4be313f95bc8ed$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $ce4be313f95bc8ed$var$_default = module.exports.default = $ce4be313f95bc8ed$var$CrossCircleIcon;
});
parcelRegister("1k2at", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$5fdfa3c8145f4e13$export$bd638c2ba7915668);
    var $f8Sb3;
    var $673MF;
    var $bjGSs;
    var $VSDnB;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $l4W7r;
    function $5fdfa3c8145f4e13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5fdfa3c8145f4e13$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $5fdfa3c8145f4e13$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $5fdfa3c8145f4e13$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $5fdfa3c8145f4e13$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                xcss: $5fdfa3c8145f4e13$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjGSs"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("673MF"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $5fdfa3c8145f4e13$var$disabledStyles : $5fdfa3c8145f4e13$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $5fdfa3c8145f4e13$export$bd638c2ba7915668 = null;
});
parcelRegister("bjGSs", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83d2ba975692c1a3$var$_react = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83d2ba975692c1a3$var$_UNSAFE_baseNew = $83d2ba975692c1a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83d2ba975692c1a3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83d2ba975692c1a3$var$CrossIcon = (props)=>$83d2ba975692c1a3$var$_react.default.createElement($83d2ba975692c1a3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $83d2ba975692c1a3$var$CrossIcon.displayName = 'CrossIcon';
    var $83d2ba975692c1a3$var$_default = module.exports.default = $83d2ba975692c1a3$var$CrossIcon;
});
parcelRegister("j1GDZ", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$4cb02513bf42b58e$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    function $4cb02513bf42b58e$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("bA56e", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$eeac7d0aa054dce2$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $bChGW;
    const $eeac7d0aa054dce2$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("1DATb", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$a998ee34d66f3da7$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$a998ee34d66f3da7$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$a998ee34d66f3da7$export$8ee33f304118fce4);
    function $a998ee34d66f3da7$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $a998ee34d66f3da7$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $a998ee34d66f3da7$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("gmmpY", function(module, exports) {
    $parcel$export(module.exports, "nameMaxLength", ()=>$2e622580cdfaa511$export$253bdad208569777);
    $parcel$export(module.exports, "guidelineMaxLength", ()=>$2e622580cdfaa511$export$e1444e5b0a63d793);
    $parcel$export(module.exports, "colorsConfig", ()=>$2e622580cdfaa511$export$fb2992e82b83582a);
    $parcel$export(module.exports, "disabledColorConfig", ()=>$2e622580cdfaa511$export$9cdea53b8993b139);
    var $i5FdW;
    var $lGSLk;
    const { formatMessage: $2e622580cdfaa511$var$formatMessage } = (0, (0, parcelRequire("i5FdW")).createIntl)({
        locale: 'en'
    });
    const $2e622580cdfaa511$export$89b67151eed9295a = {
        definition: $2e622580cdfaa511$var$formatMessage((0, (0, parcelRequire("lGSLk")).messages).noClassification),
        includeIcon: false
    };
    const $2e622580cdfaa511$export$253bdad208569777 = 50;
    const $2e622580cdfaa511$export$cbc3cef853d1014b = 1000;
    const $2e622580cdfaa511$export$e1444e5b0a63d793 = 1000;
    const $2e622580cdfaa511$export$fb2992e82b83582a = {
        light: {
            YELLOW: {
                fontColor: '#693200',
                bgColor: '#FFF5D4',
                bgColorHovered: '#FFE48F',
                bgColorPressed: '#FFC716',
                bgColorFocused: '#FFF5D4'
            },
            ORANGE: {
                fontColor: '#3A2C1F',
                bgColor: '#FFC716',
                bgColorHovered: '#FCA700',
                bgColorPressed: '#FA8700',
                bgColorFocused: '#FCA700'
            },
            RED: {
                fontColor: '#AE2E24',
                bgColor: '#FFECEB',
                bgColorHovered: '#FFD5D2',
                bgColorPressed: '#FD9891',
                bgColorFocused: '#FFECEB'
            },
            RED_BOLD: {
                fontColor: '#FFFFFF',
                bgColor: '#C9372C',
                bgColorHovered: '#AE2E24',
                bgColorPressed: '#5D1F1A',
                bgColorFocused: '#C9372C'
            },
            PURPLE: {
                fontColor: '#352C63',
                bgColor: '#DFD8FD',
                bgColorHovered: '#B8ACF6',
                bgColorPressed: '#9F8FEF',
                bgColorFocused: '#DFD8FD'
            },
            BLUE: {
                fontColor: '#09326C',
                bgColor: '#CCE0FF',
                bgColorHovered: '#85B8FF',
                bgColorPressed: '#579DFF',
                bgColorFocused: '#CCE0FF'
            },
            TEAL: {
                fontColor: '#206A83',
                bgColor: '#E7F9FF',
                bgColorHovered: '#C6EDFB',
                bgColorPressed: '#9DD9EE',
                bgColorFocused: '#E7F9FF'
            },
            GREEN: {
                fontColor: '#164B35',
                bgColor: '#BAF3DB',
                bgColorHovered: '#7EE2B8',
                bgColorPressed: '#4BCE97',
                bgColorFocused: '#BAF3DB'
            },
            GREY: {
                fontColor: '#172B4D',
                bgColor: '#F1F2F4',
                bgColorHovered: '#DCDFE4',
                bgColorPressed: '#B3B9C4',
                bgColorFocused: '#F1F2F4'
            },
            LIME: {
                fontColor: '#4C6B1F',
                bgColor: '#EFFFD6',
                bgColorHovered: '#D3F1A7',
                bgColorPressed: '#B3DF72',
                bgColorFocused: '#EFFFD6'
            }
        },
        dark: {
            YELLOW: {
                fontColor: '#FFE48F',
                bgColor: '#3A2C1F',
                bgColorHovered: '#693200',
                bgColorPressed: '#9E4C00',
                bgColorFocused: '#3A2C1F'
            },
            ORANGE: {
                fontColor: '#3A2C1F',
                bgColor: '#FFC716',
                bgColorHovered: '#FCA700',
                bgColorPressed: '#FA8700',
                bgColorFocused: '#FCA700'
            },
            RED: {
                fontColor: '#FD9891',
                bgColor: '#42221F',
                bgColorHovered: '#5D1F1A',
                bgColorPressed: '#AE2E24',
                bgColorFocused: '#42221F'
            },
            RED_BOLD: {
                fontColor: '#1D2125',
                bgColor: '#F87168',
                bgColorHovered: '#FD9891',
                bgColorPressed: '#FFD5D2',
                bgColorFocused: '#F87168'
            },
            PURPLE: {
                fontColor: '#DFD8FD',
                bgColor: '#352C63',
                bgColorHovered: '#5E4DB2',
                bgColorPressed: '#6E5DC6',
                bgColorFocused: '#352C63'
            },
            BLUE: {
                fontColor: '#CCE0FF',
                bgColor: '#09326C',
                bgColorHovered: '#0055CC',
                bgColorPressed: '#0C66E4',
                bgColorFocused: '#09326C'
            },
            TEAL: {
                fontColor: '#9DD9EE',
                bgColor: '#1E3137',
                bgColorHovered: '#164555',
                bgColorPressed: '#206A83',
                bgColorFocused: '#1E3137'
            },
            GREEN: {
                fontColor: '#BAF3DB',
                bgColor: '#164B35',
                bgColorHovered: '#216E4E',
                bgColorPressed: '#1F845A',
                bgColorFocused: '#164B35'
            },
            GREY: {
                fontColor: '#B6C2CF',
                bgColor: '#2C333A',
                bgColorHovered: '#38414A',
                bgColorPressed: '#454F59',
                bgColorFocused: '#2C333A'
            },
            LIME: {
                fontColor: '#B3DF72',
                bgColor: '#28311B',
                bgColorHovered: '#37471F',
                bgColorPressed: '#4C6B1F',
                bgColorFocused: '#28311B'
            }
        }
    };
    const $2e622580cdfaa511$export$9cdea53b8993b139 = {
        light: {
            fontColor: '#091E42',
            bgColor: 'rgba(9, 30, 66, 0.03)'
        },
        dark: {
            fontColor: '#BFDBF847',
            bgColor: 'rgba(3, 4, 4, 0.26)'
        }
    };
});
parcelRegister("lGSLk", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$8d9596bf354d4700$export$defe85febe8b728c);
    var $7VHMR;
    const $8d9596bf354d4700$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noClassification: {
            id: 'data-classification-level.no-classification',
            defaultMessage: 'No classification',
            description: 'Text for the no classification option'
        },
        classifyContent: {
            id: 'data-classification-level.edit-popup.classify-content',
            defaultMessage: 'Classify content',
            description: 'Text for the header of the edit popup'
        },
        selectClassification: {
            id: 'data-classification-level.edit-popup.select-classification',
            defaultMessage: 'Select classification',
            description: 'Text for the label of the select dropdown to select a classification'
        },
        updateButton: {
            id: 'data-classification-level.edit-popup.update-button',
            defaultMessage: 'Update',
            description: 'Text for the update button'
        },
        cancelButton: {
            id: 'data-classification-level.edit-popup.cancel-button',
            defaultMessage: 'Cancel',
            description: 'Text for the cancel button'
        },
        changeLevel: {
            id: 'data-classification-level.read-popup.change-level',
            defaultMessage: 'Change level',
            description: 'Text for the button that changes the level of the selected classification'
        },
        rules: {
            id: 'data-classification-level.rules',
            defaultMessage: '({associatedPoliciesCount, plural, one {# rule} other {# rules}})',
            description: 'Text next to the title of the classification describing the number of rules associated'
        }
    });
});
parcelRegister("7Kq24", function(module, exports) {
    $parcel$export(module.exports, "ClassificationIcon", ()=>$ba755001a3eae43b$export$d2e14829910b9b7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $eL2cT;
    const $ba755001a3eae43b$export$d2e14829910b9b7d = ({ color: color, width: width, height: height, isDisabled: isDisabled, disabledColorConfig: disabledColorConfig })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eL2cT")).SvgIcon), {
            width: width,
            height: height,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.4507 3.24947C11.7778 3.0101 12.2222 3.0101 12.5493 3.24947L12.6384 3.3145C12.6966 3.35693 12.7816 3.41879 12.8885 3.49621C13.1022 3.6511 13.4029 3.8681 13.7503 4.1163C14.4471 4.61402 15.325 5.23208 16.066 5.72614C16.731 6.16948 17.5184 6.51497 18.1606 6.75285C18.4775 6.87022 18.75 6.95808 18.9416 7.01617C19.0373 7.04516 19.1124 7.06659 19.1622 7.08044C19.1871 7.08736 19.2057 7.09238 19.2174 7.09549L19.2296 7.09873L19.231 7.09909C19.6299 7.20149 19.9142 7.55408 19.9294 7.96562L19 7.99995C19.9294 7.96562 19.9294 7.96545 19.9294 7.96562L19.9294 7.96637L19.9296 7.97092L19.9299 7.9823L19.9311 8.02272C19.9321 8.05733 19.9332 8.10704 19.9342 8.17035C19.9362 8.29692 19.9376 8.47816 19.9354 8.70198C19.931 9.14881 19.912 9.76955 19.8537 10.4665C19.7402 11.8241 19.4681 13.609 18.7732 14.9323C18.0039 16.3974 16.3463 17.7569 15.0203 18.6963C14.3347 19.182 13.6935 19.5855 13.2239 19.8675C12.9887 20.0088 12.7955 20.1202 12.66 20.1969C12.5923 20.2353 12.5389 20.265 12.5018 20.2855L12.4586 20.3092L12.4467 20.3157L12.442 20.3182C12.4419 20.3183 12.4413 20.3186 12 19.4999C11.566 20.3224 11.5658 20.3224 11.5657 20.3223L11.5606 20.3196L11.5484 20.3131L11.5044 20.2895C11.4666 20.269 11.4121 20.2393 11.3429 20.201C11.2047 20.1243 11.0075 20.013 10.7676 19.8718C10.2886 19.5899 9.63465 19.1866 8.93632 18.701C7.58714 17.763 5.89843 16.4025 5.12645 14.9323C4.4427 13.6301 4.19878 11.8354 4.10698 10.4745C4.0597 9.77357 4.05069 9.14709 4.05342 8.69567C4.05479 8.46954 4.05911 8.28624 4.06316 8.15821C4.06518 8.09417 4.06714 8.04388 4.06863 8.00888L4.07046 7.96804L4.07102 7.95657L4.07125 7.95199C4.07126 7.95182 4.07129 7.95125 5.00001 7.99995L4.07129 7.95125C4.09257 7.54532 4.37502 7.20025 4.76872 7.09917C4.7687 7.09917 4.76873 7.09916 4.76872 7.09917L4.7704 7.09873L4.78263 7.09549C4.79429 7.09238 4.81288 7.08736 4.83779 7.08044C4.88765 7.06659 4.96271 7.04516 5.05838 7.01617C5.25004 6.95808 5.52252 6.87022 5.8394 6.75285C6.48161 6.51498 7.26895 6.16948 7.93395 5.72614C8.67504 5.23208 9.55289 4.61402 10.2497 4.1163C10.5971 3.8681 10.8978 3.6511 11.1115 3.49621C11.2184 3.41879 11.3034 3.35693 11.3616 3.3145L11.4507 3.24947ZM5.91345 8.69663C5.91343 8.70005 5.91341 8.70348 5.91339 8.70693C5.91086 9.12508 5.91927 9.70457 5.96277 10.3493C6.05251 11.6797 6.28352 13.135 6.77323 14.0676C7.31396 15.0974 8.65034 16.2369 9.99807 17.1739C10.6482 17.6258 11.2607 18.0038 11.7109 18.2687C11.8151 18.33 11.9104 18.3852 11.9951 18.4336C12.0763 18.3862 12.1671 18.3325 12.2662 18.273C12.7071 18.0082 13.3072 17.6304 13.9451 17.1786C15.2657 16.243 16.5831 15.1025 17.1264 14.0676C17.6371 13.0952 17.89 11.63 18.0002 10.3116C18.0534 9.67538 18.0711 9.10545 18.0754 8.69297C17.9096 8.63851 17.7202 8.57322 17.5146 8.49705C16.8069 8.23492 15.8693 7.83042 15.0343 7.27375C14.2679 6.7628 13.3706 6.13086 12.6692 5.62983C12.4167 5.44946 12.1886 5.2854 12 5.14916C11.8114 5.2854 11.5833 5.44946 11.3308 5.62983C10.6294 6.13086 9.73213 6.7628 8.9657 7.27375C8.1307 7.83042 7.19314 8.23492 6.48544 8.49705C6.27515 8.57494 6.08188 8.64144 5.91345 8.69663ZM12 19.4999L11.5657 20.3223C11.8399 20.467 12.1684 20.4657 12.4413 20.3186L12 19.4999Z",
            fill: isDisabled ? disabledColorConfig.fontColor : color
        }));
    };
});
parcelRegister("eL2cT", function(module, exports) {
    $parcel$export(module.exports, "SvgIcon", ()=>$6cbad74b302984de$export$dbcb8210e8a983ed);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $6cbad74b302984de$export$dbcb8210e8a983ed = (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1vcp0mh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px"),
                "--_10ib6lf": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91efm _1tket1jn",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bj9nc", function(module, exports) {
    $parcel$export(module.exports, "DropdownLabel", ()=>$c00106226964da92$export$bef68440ec6a6159);
    $parcel$export(module.exports, "NameLabel", ()=>$c00106226964da92$export$63077572f44eb437);
    $parcel$export(module.exports, "ContainerLabel", ()=>$c00106226964da92$export$3944a9dffaf20407);
    $parcel$export(module.exports, "ContainerIcon", ()=>$c00106226964da92$export$6d6da6edaddd5876);
    $parcel$export(module.exports, "Name", ()=>$c00106226964da92$export$c7bd411105e2dec3);
    $parcel$export(module.exports, "Definition", ()=>$c00106226964da92$export$cf0290ef4b5a4f61);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $c00106226964da92$export$bef68440ec6a6159 = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _k48p1pd9",
                __cmplp.className
            ])
        });
    });
    const $c00106226964da92$export$63077572f44eb437 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _syaz15xy _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
                __cmplp.className
            ])
        });
    });
    const $c00106226964da92$export$3944a9dffaf20407 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { definitionExists: definitionExists, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_t9f321": (0, (0, parcelRequire("lD23V")).default)(__cmplp.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _otyrmjfo",
                __cmplp.className
            ])
        });
    });
    const $c00106226964da92$export$6d6da6edaddd5876 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isIconOnly: isIconOnly, colorsConfig: colorsConfig, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_139b6h8": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)"),
                "--_1udd052": (0, (0, parcelRequire("lD23V")).default)(__cmplp.colorsConfig.fontColor),
                "--_s8jg64": (0, (0, parcelRequire("lD23V")).default)(__cmplp.colorsConfig.bgColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _p12f1osq _o5721q9c _1bsb1wug _4cvr1h6o _1yt4v77o _u5f31gh9 _2rko1sit _syaz1tdf _11q71iaf _uiztglyw",
                __cmplp.className
            ])
        });
    });
    const $c00106226964da92$export$c7bd411105e2dec3 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _11c81oud _k48p19lj _vwz4dlk8 _18u0v77o _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $c00106226964da92$export$cf0290ef4b5a4f61 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz15xy _o5721jtm _1i4q1hna _slp31hna",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("52tuV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcb77fdfdd3b6ad9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bcb77fdfdd3b6ad9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        classificationFieldLabel: {
            "id": "issue-create-commons.data-classification-field.classification-field-label",
            "defaultMessage": "Classification level"
        },
        projectDefaultClassificationOption: {
            "id": "issue-create-commons.data-classification-field.project-default-classification-option",
            "defaultMessage": "Project default"
        },
        noClassificationOption: {
            "id": "issue-create-commons.data-classification-field.no-classification-option",
            "defaultMessage": "Project default - No classification"
        }
    });
});
parcelRegister("9eKoH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$448be576ffb80ea6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $448be576ffb80ea6$var$ConfigureFieldsModal = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("65UqO")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/configure-fields/src/index.tsx"
    });
    var $448be576ffb80ea6$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira.issue-create.configure-fields",
            packageName: "jiraIssueCreateConfigureFields"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "create-configure-fields-modal",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($448be576ffb80ea6$var$ConfigureFieldsModal, props)));
});
parcelRegister("65UqO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5Ck3F").then(()=>parcelRequire('LAKPi'));
});
parcelRegister("2KAtx", function(module, exports) {
    $parcel$export(module.exports, "ModalEntryPointPressableTrigger", ()=>$a17c22dd70443cfd$export$defad645fcc21c0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $iwwXK;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $luBm6;
    var $kMSay;
    var $9fuVs;
    var $4R6GH;
    var $c5vfY;
    var $7mPT9;
    var $gJdig;
    var $fiv1r;
    var $dWBzX;
    const $a17c22dd70443cfd$var$emptyObject = {};
    const $a17c22dd70443cfd$export$defad645fcc21c0a = ({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, interactionName: interactionName, title: title, modalProps: modalProps, useInternalModal: useInternalModal, forwardedRef: forwardedRef })=>{
        const { openModal: openModal } = (0, $5uXOq.useContext)((0, (0, parcelRequire("gJdig")).ModalContext));
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const metricName = (0, $5uXOq.useMemo)(()=>{
            if (interactionName) return interactionName;
            return entryPoint?.root?.getModuleName() ?? 'unknown';
        }, [
            entryPoint,
            interactionName
        ]);
        const pressTracing = (0, (0, parcelRequire("kMSay")).default)(metricName);
        const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $a17c22dd70443cfd$var$emptyObject), [
            entryPoint,
            entryPointParams,
            environmentProvider
        ]);
        const onBeforeLoad = (0, $5uXOq.useCallback)(()=>{
            if (interactionName) pressTracing();
        }, [
            interactionName,
            pressTracing
        ]);
        const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
            openModal(({ onClose: closeModal })=>{
                const onClose = ()=>{
                    entryPointProps?.onClose?.();
                    closeModal();
                    dispose();
                };
                const defaultFallbackInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, title ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, title) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
                    grow: "fill"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null));
                const defaultFallback = useInternalModal ? defaultFallbackInner : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    onClose: closeModal,
                    width: modalProps?.width,
                    height: modalProps?.height
                }, defaultFallbackInner);
                const container = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
                    entryPointReference: entryPointReference,
                    errorAttributes: errorAttributes,
                    errorFallback: "flag",
                    fallback: Fallback ? (0, ($parcel$interopDefault($5uXOq))).createElement(Fallback, {
                        onClose: closeModal
                    }) : defaultFallback,
                    id: metricName,
                    placeholderName: "modal-entry-point-pressable-trigger-container",
                    runtimeProps: {
                        ...entryPointProps ?? $a17c22dd70443cfd$var$emptyObject,
                        onClose: onClose
                    }
                });
                return useInternalModal ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
                    ...modalProps,
                    onClose: onClose
                }, container)) : container;
            });
        }, [
            openModal,
            title,
            useInternalModal,
            modalProps,
            errorAttributes,
            Fallback,
            metricName,
            entryPointProps
        ]);
        const triggerRef = (0, (0, parcelRequire("dWBzX")).usePressablePreloadRef)({
            load: load,
            onBeforeLoad: onBeforeLoad,
            onLoad: onLoad
        });
        if (forwardedRef != null && (0, (0, parcelRequire("4R6GH")).fg)('forward_ref_modalentrypointdropdownitemtrigger')) {
            const ref = (0, (0, parcelRequire("7mPT9")).default)(triggerRef, forwardedRef);
            return children({
                ref: ref
            });
        }
        return children({
            ref: triggerRef
        });
    };
});
parcelRegister("7mPT9", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$d1da29f25d5b5e0a$export$c9058316764c140e);
    $parcel$export(module.exports, "default", ()=>$d1da29f25d5b5e0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d1da29f25d5b5e0a$export$c9058316764c140e(...refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref != null) ref.current = value;
            });
        };
    }
    function $d1da29f25d5b5e0a$export$2e2bcd8739ae039(...refs) {
        return (0, $5uXOq.useMemo)(()=>$d1da29f25d5b5e0a$export$c9058316764c140e(...refs), refs);
    }
});
parcelRegister("dWBzX", function(module, exports) {
    $parcel$export(module.exports, "usePressablePreloadRef", ()=>$01294bc664dce1e5$export$1ff47f24e06a5d2d);
    var $5uXOq = parcelRequire("5uXOq");
    const $01294bc664dce1e5$var$PRELOAD_MAX_AGE = 2000;
    const $01294bc664dce1e5$var$TIME_TO_INTENT = 200;
    function $01294bc664dce1e5$export$1ff47f24e06a5d2d({ load: load, onBeforeLoad: onBeforeLoad, onLoad: onLoad }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const el = ref.current;
            if (!el) return;
            const request = {};
            const clearPreloadTimeouts = ()=>{
                if (typeof request.preloadIntentTimeout === 'number') {
                    clearTimeout(request.preloadIntentTimeout);
                    delete request.preloadIntentTimeout;
                }
                if (typeof request.preloadMaxAgeTimeout === 'number') {
                    clearTimeout(request.preloadMaxAgeTimeout);
                    delete request.preloadMaxAgeTimeout;
                }
            };
            const cancelPreload = ()=>{
                clearPreloadTimeouts();
                request.preload?.dispose();
            };
            const loadReference = ()=>{
                if (request.load) return request.load;
                const reference = request.preload?.reference ?? load();
                if (request.preload) delete request.preload;
                request.load = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.load;
                    }
                };
                return request.load;
            };
            const clickListener = ()=>{
                clearPreloadTimeouts();
                onBeforeLoad();
                onLoad(loadReference());
            };
            const mouseDownListener = ()=>{
                clearPreloadTimeouts();
                loadReference();
            };
            const preloadReference = ()=>{
                if (request.preloadIntentTimeout || request.preload) return;
                request.preloadIntentTimeout = setTimeout(()=>{
                    delete request.preloadIntentTimeout;
                    const reference = load();
                    request.preload = {
                        reference: reference,
                        dispose () {
                            reference.dispose();
                            delete request.preload;
                        }
                    };
                    request.preloadMaxAgeTimeout = setTimeout(()=>{
                        delete request.preloadMaxAgeTimeout;
                        request.preload?.dispose();
                    }, $01294bc664dce1e5$var$PRELOAD_MAX_AGE);
                }, $01294bc664dce1e5$var$TIME_TO_INTENT);
            };
            el.addEventListener('click', clickListener);
            el.addEventListener('mousedown', mouseDownListener);
            el.addEventListener('mouseenter', preloadReference);
            el.addEventListener('mouseleave', cancelPreload);
            return ()=>{
                cancelPreload();
                el.removeEventListener('click', clickListener);
                el.removeEventListener('mousedown', mouseDownListener);
                el.removeEventListener('mouseenter', preloadReference);
                el.removeEventListener('mouseleave', cancelPreload);
            };
        }, [
            load,
            onBeforeLoad,
            onLoad
        ]);
        return ref;
    }
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("isuse", function(module, exports) {
    $parcel$export(module.exports, "MountEvent", ()=>$1df0619a43ad69d9$export$2c6963927dbc68f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'mounted'
            });
            if (this.props.onMount) this.props.onMount(analyticsEvent);
        }
        render() {
            return null;
        }
    }
    const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, (0, parcelRequire("cb25w")).default)()($1df0619a43ad69d9$var$MountEventComponent);
});
parcelRegister("cn7wb", function(module, exports) {
    $parcel$export(module.exports, "usePersistentIssueCreateModalViewResource", ()=>$c55164aa1e8f5a83$export$20dbed3226e737bc);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $aHuqL;
    var $2YP9W;
    var $3X1Xr;
    const $c55164aa1e8f5a83$export$20dbed3226e737bc = ()=>{
        const { data: data, update: update } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("3X1Xr")).persistentIssueCreateModalViewResource));
        const updateView = (0, $5uXOq.useCallback)(async (view)=>{
            try {
                await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $fa76c7a777da2375$export$15187a597cef02df), view);
                update((state)=>({
                        ...state,
                        view: view
                    }));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'persistentIssueCreateModalViewState',
                        packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            update
        ]);
        const updateIsDiscoPushComplete = (0, $5uXOq.useCallback)(async (isDiscoPushComplete = true)=>{
            try {
                await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $fa76c7a777da2375$export$8977f91a75d8d265), isDiscoPushComplete);
                update((state)=>({
                        ...state,
                        isDiscoPushComplete: isDiscoPushComplete
                    }));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'miniModalDiscoverabilityPushState',
                        packageName: 'jiraRouterResourcesPersistentIssueCreateModalView',
                        teamName: 'gryffindor'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            update
        ]);
        return {
            data: data,
            updateView: updateView,
            updateIsDiscoPushComplete: updateIsDiscoPushComplete
        };
    };
});
const $fa76c7a777da2375$export$15187a597cef02df = 'jira.user.gic.persistent.modal.view.state';
const $fa76c7a777da2375$export$8977f91a75d8d265 = 'jira.user.gic.mini.modal.discoverability';
const $fa76c7a777da2375$export$f658cfd591eb583e = 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW';
parcelRegister("5knXz", function(module, exports) {
    $parcel$export(module.exports, "useStorageEnforcement", ()=>$a61178001d7e3bbc$export$fa2c25e1ed13a1a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $2gCtH;
    var $dAfqg;
    var $RnWyv;
    var $l2AwX;
    const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000;
    const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
        const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, (0, parcelRequire("l2AwX")).useEnforceStorageModal)();
        const issueViewMode = (0, (0, parcelRequire("2gCtH")).useViewMode)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const isInJSWProject = projectContextData?.projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT);
        const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
            const isOnCooldown = Date.now() - ((0, (0, parcelRequire("RnWyv")).localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
            if (isOnCooldown) {
                if (currentState.isOpen === 'pending') setEnforceStorageModalIsOpen({
                    isOpen: 'closed',
                    touchpoint: undefined
                });
            } else setEnforceStorageModalIsOpen({
                isOpen: 'open',
                touchpoint: touchpoint
            });
        }, [
            setEnforceStorageModalIsOpen,
            currentState.isOpen
        ]);
        const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
            if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
            if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
                isOpen: 'pending',
                touchpoint: touchpoint
            });
            else openModalIfNotOnCooldown(touchpoint);
        }, [
            isInJSWProject,
            issueViewMode,
            setEnforceStorageModalIsOpen,
            openModalIfNotOnCooldown
        ]);
        const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
            if (currentState.isOpen === 'pending') openModalIfNotOnCooldown(currentState.touchpoint);
        }, [
            currentState.isOpen,
            openModalIfNotOnCooldown,
            currentState.touchpoint
        ]);
        return {
            showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
            showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
        };
    };
});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$8f56a4ad6e1486ea = 10;
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';
parcelRegister("RnWyv", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$5fd7f3930a81124f$export$c2ed3351cac403d1);
    var $bSSG7;
    const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('enforce-storage-limits');
});
parcelRegister("eyBYT", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsContainer", ()=>$36c9c0c91723b06d$export$1834060b93715de7);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Y7lI;
    var $egcPe;
    const $36c9c0c91723b06d$export$1834060b93715de7 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Y7lI")).BaseUiModificationsContainer), {
            scope: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
            viewConfiguration: (0, (0, parcelRequire("egcPe")).GICViewConfiguration)
        }, children);
});
parcelRegister("1Y7lI", function(module, exports) {
    $parcel$export(module.exports, "BaseUiModificationsContainer", ()=>$5a461650d84e0337$export$8b7a045f60eb9797);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $laCJ2;
    var $dymCo;
    var $7vOTV;
    const $5a461650d84e0337$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, (0, parcelRequire("7vOTV")).useLoadViewConfiguration)(viewType, viewConfiguration);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dymCo")).LoadedUiModificationsContainer), {
            scope: scope,
            viewType: viewType,
            createAnalyticsEvent: createAnalyticsEvent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("laCJ2")).UiModificationContextContainer), {
            scope: scope
        }, children));
    };
});
parcelRegister("dymCo", function(module, exports) {
    $parcel$export(module.exports, "LoadedUiModificationsContainer", ()=>$e252b01af77a7c38$export$b087a12fbb84e8ac);
    var $gg7kZ;
    var $asu2W;
    const $e252b01af77a7c38$export$b087a12fbb84e8ac = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("asu2W")).store), {
        displayName: 'LoadedUiModificationsContainer',
        onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
                setState({
                    viewType: viewType
                });
            }
    });
});
parcelRegister("asu2W", function(module, exports) {
    $parcel$export(module.exports, "store", ()=>$ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    $parcel$export(module.exports, "useAdjustedField", ()=>$ef99e75ec2f2694e$export$df4b0714e8177e0e);
    $parcel$export(module.exports, "useAnalyticsData", ()=>$ef99e75ec2f2694e$export$45885672916a1436);
    $parcel$export(module.exports, "useIssueAdjustmentsActions", ()=>$ef99e75ec2f2694e$export$cb9a014ec14556d8);
    $parcel$export(module.exports, "useAdjustedScreenTabs", ()=>$ef99e75ec2f2694e$export$677b3e34bd14c681);
    var $4R6GH;
    var $3sQ5x;
    var $iXqE5;
    var $7rVee;
    var $9gKFJ;
    var $dsc5J;
    var $lWjzW;
    var $3Pzhj;
    var $f81nP;
    var $l97Ge;
    var $2MPbo;
    var $jZ1BZ;
    var $gwqYE;
    var $ifTQq;
    var $hk40m;
    var $bAAVc;
    var $5pnmQ;
    var $4qdFk;
    const $ef99e75ec2f2694e$var$name = 'issue-adjustments';
    const $ef99e75ec2f2694e$export$d4c72bab9d6cc13a = {
        formData: null,
        screenTabs: null,
        appliedChanges: null,
        error: null,
        analyticsData: {},
        registeredFieldsDeprecated: {},
        registeredFields: {},
        triggerFieldInitializationKey: 0,
        numberOfSupportedFields: 0,
        internalFormMetadata: {},
        viewType: null,
        experienceDataIsLoading: false,
        lastProcessedChange: null,
        fieldsInitialization: {
            startTime: null,
            timeoutId: undefined,
            status: 'notStarted'
        },
        appliedChangesHistory: {},
        appsErrors: {},
        notification: null
    };
    const { triggerFieldInitializationKey: $ef99e75ec2f2694e$var$triggerFieldInitializationKey, viewType: $ef99e75ec2f2694e$var$scopedViewType, numberOfSupportedFields: $ef99e75ec2f2694e$var$numberOfSupportedFields, ...$ef99e75ec2f2694e$var$stateForResetAllFields } = $ef99e75ec2f2694e$export$d4c72bab9d6cc13a;
    const $ef99e75ec2f2694e$export$e324594224ef24da = {
        triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
                setState({
                    triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
                });
            },
        processChange: (0, parcelRequire("gwqYE")).processChange,
        setFieldValue: (0, parcelRequire("hk40m")).setFieldValue,
        initializeField: (0, parcelRequire("f81nP")).initializeField,
        initializeFields: (0, parcelRequire("f81nP")).initializeFields,
        startFieldsInitialisationTimeout: (0, parcelRequire("3Pzhj")).startFieldsInitialisationTimeout,
        successFieldsInitalisation: (0, parcelRequire("3Pzhj")).successFieldsInitalisation,
        registerFields: (0, parcelRequire("ifTQq")).registerFields,
        unregisterFields: (0, parcelRequire("ifTQq")).unregisterFields,
        updateFields: (0, parcelRequire("5pnmQ")).updateFields,
        clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
                const previousState = getState().appliedChanges || {};
                if (previousState[fieldId]) {
                    const { value: value, ...otherFieldChanges } = previousState[fieldId];
                    setState({
                        appliedChanges: {
                            ...previousState,
                            [fieldId]: otherFieldChanges
                        }
                    });
                }
            },
        resetAllFields: ()=>({ setState: setState, getState: getState })=>{
                clearTimeout(getState().fieldsInitialization.timeoutId);
                setState($ef99e75ec2f2694e$var$stateForResetAllFields);
            },
        setError: (0, parcelRequire("lWjzW")).setError,
        resetError: (0, parcelRequire("lWjzW")).resetError,
        setAnalyticsData: (analyticsData)=>({ setState: setState, getState: getState })=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('drop_analyticsdata_for_jsm')) {
                    const previousState = getState().analyticsData ?? {};
                    setState({
                        analyticsData: {
                            ...previousState,
                            ...analyticsData
                        }
                    });
                }
            },
        setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
                setState({
                    numberOfSupportedFields: numberOfAllSupportedFields
                });
            },
        setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
                setState({
                    experienceDataIsLoading: experienceDataIsLoading
                });
            },
        setAppErrors: (0, parcelRequire("7rVee")).setAppErrors,
        resetAppErrors: (0, parcelRequire("7rVee")).resetAppErrors,
        addAppsErrors: (0, parcelRequire("7rVee")).addAppsErrors,
        initializeNoScreenTab: (0, parcelRequire("l97Ge")).initializeNoScreenTab,
        initializeScreenTabs: (0, parcelRequire("2MPbo")).initializeScreenTabs,
        updateScreenTabs: (0, parcelRequire("4qdFk")).updateScreenTabs,
        updateActiveScreenTab: (0, parcelRequire("bAAVc")).updateActiveScreenTab,
        detectAppliedChangesConflicts: (0, parcelRequire("dsc5J")).detectAppliedChangesConflicts,
        collectScreenTabsAppliedChangesHistory: (0, parcelRequire("9gKFJ")).collectScreenTabsAppliedChangesHistory,
        collectFieldsAppliedChangesHistory: (0, parcelRequire("9gKFJ")).collectFieldsAppliedChangesHistory,
        setNotification: (0, parcelRequire("jZ1BZ")).setNotification,
        resetNotification: (0, parcelRequire("jZ1BZ")).resetNotification
    };
    const $ef99e75ec2f2694e$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: $ef99e75ec2f2694e$var$name,
        initialState: $ef99e75ec2f2694e$export$d4c72bab9d6cc13a,
        actions: $ef99e75ec2f2694e$export$e324594224ef24da
    });
    const $ef99e75ec2f2694e$export$37792a602e748c08 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    const $ef99e75ec2f2694e$var$stableEmptyFieldFromIframe = {};
    const $ef99e75ec2f2694e$export$df4b0714e8177e0e = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $ef99e75ec2f2694e$var$stableEmptyFieldFromIframe
    });
    const $ef99e75ec2f2694e$export$45885672916a1436 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state)=>state.analyticsData
    });
    const $ef99e75ec2f2694e$export$cb9a014ec14556d8 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9);
    const $ef99e75ec2f2694e$export$677b3e34bd14c681 = (0, (0, parcelRequire("3sQ5x")).createHook)($ef99e75ec2f2694e$export$6f57813fe9f31bf9, {
        selector: (state)=>state.screenTabs
    });
});
parcelRegister("7rVee", function(module, exports) {
    $parcel$export(module.exports, "setAppErrors", ()=>$51d57126fd93ecb2$export$7054e2f8e68cf0dd);
    $parcel$export(module.exports, "addAppsErrors", ()=>$51d57126fd93ecb2$export$903d525e420c7d00);
    $parcel$export(module.exports, "resetAppErrors", ()=>$51d57126fd93ecb2$export$24c821207687a907);
    const $51d57126fd93ecb2$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            setState({
                appsErrors: {
                    ...previousState,
                    [appId]: errors
                }
            });
        };
    const $51d57126fd93ecb2$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
                acc[appId] = [
                    ...acc[appId] ?? [],
                    ...appErrors
                ];
                return acc;
            }, {
                ...previousState
            });
            setState({
                appsErrors: appsErrors
            });
        };
    const $51d57126fd93ecb2$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appsErrors ?? {};
            setState({
                appsErrors: {
                    ...previousState,
                    [appId]: null
                }
            });
        };
});
parcelRegister("9gKFJ", function(module, exports) {
    $parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", ()=>$161ca2ef8e97884e$export$1d2b7abeeea36239);
    $parcel$export(module.exports, "collectFieldsAppliedChangesHistory", ()=>$161ca2ef8e97884e$export$7d0f534e5b16dcc9);
    var $hsiqV;
    const $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
        const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
        const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
        return {
            ...currentAppliedChangesHistory,
            [changeId]: {
                apps: {
                    ...appliedChangesHistoryChangeId.apps,
                    [appId]: {
                        ...appliedChangesHistoryChangeIdApp,
                        ...newSingleAppChange
                    }
                },
                createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
            }
        };
    };
    const $161ca2ef8e97884e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
            const { appliedChangesHistory: appliedChangesHistory } = getState();
            if (!screenTabs.length) return;
            const newAppliedChangesHistory = $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange({
                currentAppliedChangesHistory: appliedChangesHistory,
                appId: appId,
                changeId: changeId,
                newSingleAppChange: {
                    tabs: {
                        type: (0, $ee1cb4d07e178dd8$export$f674b7a3bbd94b5)
                    }
                }
            });
            setState({
                appliedChangesHistory: newAppliedChangesHistory
            });
        };
    const $161ca2ef8e97884e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
            const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
            const singleAppChange = (0, (0, parcelRequire("hsiqV")).normalizeFieldsAppliedChangesForHistory)({
                fieldsChanges: fieldsChanges,
                internalFormMetadata: internalFormMetadata
            });
            const newAppliedChangesHistory = $161ca2ef8e97884e$var$prepareAppliedChangesHistoryForSingleChange({
                currentAppliedChangesHistory: appliedChangesHistory,
                appId: appId,
                changeId: changeId,
                newSingleAppChange: singleAppChange
            });
            setState({
                appliedChangesHistory: newAppliedChangesHistory
            });
        };
});
const $ee1cb4d07e178dd8$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $ee1cb4d07e178dd8$export$4a9f236a0db33834 = 'FIELD';
parcelRegister("hsiqV", function(module, exports) {
    $parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", ()=>$331671ca0401ed2b$export$8a23b3e9a1749620);
    var $4R6GH;
    const $331671ca0401ed2b$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
        return Object.keys(fieldChanges).reduce((acc, property)=>{
            const normalizedKey = `${fieldId}|${property}`;
            acc[normalizedKey] = {
                fieldId: fieldId,
                fieldType: fieldMetadata.fieldType,
                property: property,
                type: (0, $ee1cb4d07e178dd8$export$4a9f236a0db33834)
            };
            return acc;
        }, {});
    };
    const $331671ca0401ed2b$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
        return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
            const fieldMetadata = internalFormMetadata[fieldId];
            if ((0, (0, parcelRequire("4R6GH")).fg)('uim-check-for-undefined-field-metadata-in-history')) {
                if (!fieldMetadata) return acc;
            }
            const normalizedFieldHistory = $331671ca0401ed2b$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
            Object.assign(acc, normalizedFieldHistory);
            return acc;
        }, {});
    };
});
parcelRegister("dsc5J", function(module, exports) {
    $parcel$export(module.exports, "detectAppliedChangesConflicts", ()=>$3f81091b441597d8$export$90d94f20d157e756);
    var $4R6GH;
    var $dNpDc;
    var $2jyqu;
    var $7rVee;
    var $jZ1BZ;
    var $dDdm6;
    const $3f81091b441597d8$var$HISTORY_LOG_TTL = 60000;
    const $3f81091b441597d8$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
            return Date.now() - history.createdAt <= $3f81091b441597d8$var$HISTORY_LOG_TTL || existingChangeId === changeId;
        }));
    const $3f81091b441597d8$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
            const { appliedChangesHistory: appliedChangesHistory } = getState();
            const tidyAppliedChangesHistory = $3f81091b441597d8$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
            setState({
                appliedChangesHistory: tidyAppliedChangesHistory
            });
            const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
            const newChanges = appliedChangesHistoryChangeId?.apps[appId];
            if (!appliedChangesHistoryChangeId || !newChanges || Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
            const lifecycleHook = changeId === (0, $ff955bdb062d4e8f$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
            const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, (0, parcelRequire("dDdm6")).collectConflicts)({
                appliedChangesHistory: appliedChangesHistoryChangeId.apps,
                newChanges: newChanges,
                appIdOfNewChanges: appId,
                lifecycleHook: lifecycleHook
            });
            if (conflicts.length) {
                if ((0, (0, parcelRequire("4R6GH")).fg)('analytics-replace-jira-packages')) (0, (0, parcelRequire("2jyqu")).fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'conflicted',
                    actionSubject: 'jiraUiModifications.appliedChangesHistory',
                    attributes: {
                        conflictsCount: conflicts.length,
                        conflicts: conflicts,
                        conflictedApps: Object.keys(appErrorsMap),
                        viewType: viewType
                    }
                });
                else (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'appliedChangesHistory conflicted', viewType, {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap)
                });
                dispatch((0, (0, parcelRequire("7rVee")).addAppsErrors)({
                    errors: appErrorsMap
                }));
                dispatch((0, (0, parcelRequire("jZ1BZ")).setNotification)({
                    type: 'MULTIPLE_APPS_CONFLICTS'
                }));
            }
        };
});
parcelRegister("dNpDc", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalyticsWithoutContext", ()=>$d40341520e6b6a2e$export$92f0a000de1dacb3);
    $parcel$export(module.exports, "fireOperationalAnalyticsWithContext", ()=>$d40341520e6b6a2e$export$5ac7b3728975936c);
    var $8zOmE;
    var $g9E9n;
    const $d40341520e6b6a2e$export$92f0a000de1dacb3 = (actionSubject, action, viewType, attributes = {})=>(0, (0, parcelRequire("g9E9n")).getAnalyticsWebClient)().getInstance().sendOperationalEvent({
            action: action,
            actionSubject: `jiraUiModifications.${actionSubject}`,
            source: viewType,
            attributes: {
                ...attributes,
                viewType: viewType
            }
        });
    const $d40341520e6b6a2e$export$5ac7b3728975936c = (event, id, viewType, attributes = {})=>{
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, `jiraUiModifications.${id}`, {
            ...attributes,
            viewType: viewType
        });
    };
});
parcelRegister("2jyqu", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalEvent", ()=>$9253211b05747618$export$a1fb57756f0de62b);
    var $gB4mS;
    const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
        (0, (0, parcelRequire("gB4mS")).default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
            ...eventPayload,
            analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
        })(createAnalyticsEvent);
    };
});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';
const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';
const $ff955bdb062d4e8f$export$415cc1afa6445f90 = 'onInitChangeId';
const $ff955bdb062d4e8f$export$811b7f067a43b422 = 'jira:uiModifications';
parcelRegister("jZ1BZ", function(module, exports) {
    $parcel$export(module.exports, "setNotification", ()=>$a8d175f1be522910$export$b9c5e783593ff01d);
    $parcel$export(module.exports, "resetNotification", ()=>$a8d175f1be522910$export$caafa3945f199bc7);
    const $a8d175f1be522910$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
            setState({
                notification: {
                    type: notificationProperties.type
                }
            });
        };
    const $a8d175f1be522910$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
            setState({
                notification: null
            });
        };
});
parcelRegister("dDdm6", function(module, exports) {
    $parcel$export(module.exports, "collectConflicts", ()=>$60b8259bed273e2d$export$a06103ec99e4e394);
    var $fr1K2 = parcelRequire("fr1K2");
    var $7wDhr;
    const $60b8259bed273e2d$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
    const $60b8259bed273e2d$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
        const appErrors = conflicts.map((change)=>{
            if (change.type === (0, $ee1cb4d07e178dd8$export$f674b7a3bbd94b5)) return {
                type: (0, $36f69991a898da6d$export$2a3fdceaae2188d5),
                cause: (0, $36f69991a898da6d$export$877da1000325f8b5),
                lifecycleHook: lifecycleHook,
                message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$60b8259bed273e2d$var$MESSAGE_SUFFIX}`
            };
            const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
            const method = (0, (0, parcelRequire("7wDhr")).mapFieldPropertyToApiMethod)(property);
            return {
                type: (0, $36f69991a898da6d$export$2a3fdceaae2188d5),
                cause: (0, $36f69991a898da6d$export$e4ac32edd5da2ee7),
                fieldId: fieldId,
                fieldType: fieldType,
                method: method,
                lifecycleHook: lifecycleHook,
                message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$60b8259bed273e2d$var$MESSAGE_SUFFIX}`
            };
        });
        return appErrors;
    };
    const $60b8259bed273e2d$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
        return Object.entries((0, ($parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
            const previousChangesKeys = Object.keys(previousChanges);
            const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                    ...change,
                    lifecycleHook: lifecycleHook,
                    appIds: [
                        appId,
                        appIdOfNewChanges
                    ]
                }));
            acc.conflicts.push(...conflicts);
            const appErrors = $60b8259bed273e2d$var$mapToAppErrors({
                conflicts: conflicts,
                lifecycleHook: lifecycleHook
            });
            if (appErrors.length > 0) {
                acc.appErrorsMap[appId] = appErrors;
                acc.appErrorsMap[appIdOfNewChanges] = [
                    ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                    ...appErrors
                ];
            }
            return acc;
        }, {
            appErrorsMap: {},
            conflicts: []
        });
    };
});
const $36f69991a898da6d$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $36f69991a898da6d$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $36f69991a898da6d$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $36f69991a898da6d$export$e4ac32edd5da2ee7 = 'FIELD';
const $36f69991a898da6d$export$877da1000325f8b5 = 'SCREENTABS';
parcelRegister("7wDhr", function(module, exports) {
    $parcel$export(module.exports, "mapFieldPropertyToApiMethod", ()=>$7cabc464949619ac$export$e1cc7da28a1c4bb7);
    const $7cabc464949619ac$var$SET_NAME_METHOD = 'setName';
    const $7cabc464949619ac$var$SET_DESCRIPTION_METHOD = 'setDescription';
    const $7cabc464949619ac$var$SET_VISIBLE_METHOD = 'setVisible';
    const $7cabc464949619ac$var$SET_READ_ONLY_METHOD = 'setReadOnly';
    const $7cabc464949619ac$var$SET_VALUE_METHOD = 'setValue';
    const $7cabc464949619ac$var$SET_REQUIRED_METHOD = 'setRequired';
    const $7cabc464949619ac$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
    const $7cabc464949619ac$export$8325709d137b2606 = {
        fieldName: $7cabc464949619ac$var$SET_NAME_METHOD,
        description: $7cabc464949619ac$var$SET_DESCRIPTION_METHOD,
        isVisible: $7cabc464949619ac$var$SET_VISIBLE_METHOD,
        isReadOnly: $7cabc464949619ac$var$SET_READ_ONLY_METHOD,
        value: $7cabc464949619ac$var$SET_VALUE_METHOD,
        isRequired: $7cabc464949619ac$var$SET_REQUIRED_METHOD,
        optionsVisibility: $7cabc464949619ac$var$SET_OPTIONS_VISIBILITY_METHOD
    };
    const $7cabc464949619ac$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
        const method = $7cabc464949619ac$export$8325709d137b2606[fieldProperty];
        if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
        return method;
    };
});
parcelRegister("lWjzW", function(module, exports) {
    $parcel$export(module.exports, "setError", ()=>$3b252ac3f49ca2f5$export$b8d0bb2aa0adefe5);
    $parcel$export(module.exports, "resetError", ()=>$3b252ac3f49ca2f5$export$7e5930c6217b1d4e);
    const $3b252ac3f49ca2f5$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
            setState({
                error: {
                    errorCode: errorProperties.errorCode,
                    fieldName: errorProperties.fieldName
                }
            });
        };
    const $3b252ac3f49ca2f5$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
            setState({
                error: null
            });
        };
});
parcelRegister("3Pzhj", function(module, exports) {
    $parcel$export(module.exports, "startFieldsInitialisationTimeout", ()=>$db69240367e29f46$export$2c0f020b89dfa30b);
    $parcel$export(module.exports, "successFieldsInitalisation", ()=>$db69240367e29f46$export$cf768a695e83eefa);
    var $4R6GH;
    var $dNpDc;
    var $2jyqu;
    var $bLLxY;
    var $lWjzW;
    const $db69240367e29f46$var$getTimeout = ()=>50000;
    const $db69240367e29f46$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
    const $db69240367e29f46$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
    const $db69240367e29f46$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { fieldsInitialization: fieldsInitialization } = getState();
            if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
                const timeoutId = setTimeout(()=>dispatch($db69240367e29f46$export$8ce83a9201590a5e({
                        createAnalyticsEvent: createAnalyticsEvent
                    })), $db69240367e29f46$var$getTimeout());
                setState({
                    fieldsInitialization: {
                        startTime: performance.now(),
                        timeoutId: timeoutId,
                        status: 'inProgress'
                    }
                });
            }
        };
    const $db69240367e29f46$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
            const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
            const { startTime: startTime, status: status } = fieldsInitialization;
            if ($db69240367e29f46$var$isFieldInitialisationComplete(status) || ((0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs') ? (0, (0, parcelRequire("bLLxY")).selectReadyPublicDataForOnInit)(getState(), {
                viewType: viewType
            }) !== null : (0, (0, parcelRequire("bLLxY")).selectReadyFieldsOld)(getState(), undefined) !== null)) return;
            dispatch((0, (0, parcelRequire("lWjzW")).setError)({
                errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
            }));
            if ((0, (0, parcelRequire("4R6GH")).fg)('analytics-replace-jira-packages')) (0, (0, parcelRequire("2jyqu")).fireOperationalEvent)(createAnalyticsEvent, {
                action: 'timedOut',
                actionSubject: 'jiraUiModifications.fieldsInitialization',
                attributes: {
                    previousStatus: status,
                    configuredTimeout: $db69240367e29f46$var$getTimeout(),
                    fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                    initalizedFieldsCount: Object.keys(formData ?? {}).length,
                    experienceDataIsLoading: experienceDataIsLoading,
                    supportedFieldsCount: numberOfSupportedFields,
                    viewType: viewType
                }
            });
            else (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization timedOut', viewType, {
                previousStatus: status,
                configuredTimeout: $db69240367e29f46$var$getTimeout(),
                fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields
            });
            setState({
                fieldsInitialization: {
                    ...fieldsInitialization,
                    status: 'timedOut'
                }
            });
        };
    const $db69240367e29f46$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
            const { status: status } = getState().fieldsInitialization;
            if ($db69240367e29f46$var$isFieldInitialisationComplete(status)) return;
            const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
            const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
            clearTimeout(timeoutId);
            if ((0, (0, parcelRequire("4R6GH")).fg)('analytics-replace-jira-packages')) (0, (0, parcelRequire("2jyqu")).fireOperationalEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: 'jiraUiModifications.fieldsInitialization',
                attributes: {
                    previousStatus: status,
                    fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                    initalizedFieldsCount: numberOfSupportedFields,
                    viewType: viewType
                }
            });
            else (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization success', viewType, {
                previousStatus: status,
                fieldsInitializationTime: $db69240367e29f46$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields
            });
            setState({
                fieldsInitialization: {
                    ...fieldsInitialization,
                    status: 'success'
                }
            });
        };
});
parcelRegister("bLLxY", function(module, exports) {
    $parcel$export(module.exports, "selectReadyFieldsOld", ()=>$f325d3a34d0ad276$export$8f4fb114be4d807);
    $parcel$export(module.exports, "selectReadyPublicDataForOnInit", ()=>$f325d3a34d0ad276$export$4cadeedb8c3f31f7);
    var $6dDSs;
    var $d9r6K;
    const $f325d3a34d0ad276$export$8f4fb114be4d807 = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, experienceDataIsLoading)=>{
        if (formData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return formData;
        return null;
    });
    const $f325d3a34d0ad276$export$4cadeedb8c3f31f7 = (0, (0, parcelRequire("6dDSs")).createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
        if (formData !== null && !(0, (0, parcelRequire("d9r6K")).isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
            formData: formData,
            screenTabsData: []
        };
        if (formData !== null && screenTabsData !== null && (0, (0, parcelRequire("d9r6K")).isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
            formData: formData,
            screenTabsData: screenTabsData
        };
        return null;
    });
});
parcelRegister("d9r6K", function(module, exports) {
    $parcel$export(module.exports, "getSupportedFieldConfiguration", ()=>$f28ca877f892a554$export$8fc8d6775f1842b8);
    $parcel$export(module.exports, "isFieldTypeSupported", ()=>$f28ca877f892a554$export$b47920a5dd99844f);
    $parcel$export(module.exports, "getConsentMessage", ()=>$f28ca877f892a554$export$20eabd2b3ada6bf3);
    $parcel$export(module.exports, "isProjectTypeSupported", ()=>$f28ca877f892a554$export$cd7c26587dda4120);
    $parcel$export(module.exports, "getAnalytics", ()=>$f28ca877f892a554$export$b0297573c90085aa);
    $parcel$export(module.exports, "isTriggerPointSupported", ()=>$f28ca877f892a554$export$ef45e4471aa21b27);
    $parcel$export(module.exports, "isScreenTabsSupportEnabled", ()=>$f28ca877f892a554$export$71e5898a2b967ce3);
    var $9myvH;
    var $7vOTV;
    const $f28ca877f892a554$var$isKeyOf = (key, object)=>object[key] !== undefined;
    const $f28ca877f892a554$var$getConfigurationByViewType = ({ viewType: viewType })=>{
        const viewConfiguration = (0, (0, parcelRequire("7vOTV")).getViewConfiguration)(viewType);
        if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
        return viewConfiguration;
    };
    function $f28ca877f892a554$export$8fc8d6775f1842b8(viewType, fieldType) {
        const fieldsConfiguration = $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedFieldsConfiguration();
        if (!$f28ca877f892a554$var$isKeyOf(fieldType, fieldsConfiguration)) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: new Error('Unsupported field type.'),
                id: 'getSupportedFieldConfiguration',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
            return undefined;
        }
        return fieldsConfiguration[fieldType];
    }
    const $f28ca877f892a554$export$e4330d77fd93d1de = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedFieldTypes();
    const $f28ca877f892a554$export$72171ea4e785fc66 = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedProjectTypes();
    function $f28ca877f892a554$export$b47920a5dd99844f(viewType, fieldType) {
        return fieldType !== undefined && $f28ca877f892a554$export$e4330d77fd93d1de(viewType).includes(fieldType);
    }
    function $f28ca877f892a554$export$20eabd2b3ada6bf3(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getConsentMessage();
    }
    function $f28ca877f892a554$export$cd7c26587dda4120(project, viewType) {
        return $f28ca877f892a554$export$72171ea4e785fc66(viewType).includes(project.type);
    }
    function $f28ca877f892a554$export$b0297573c90085aa(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getAnalytics();
    }
    function $f28ca877f892a554$export$c0728caa743a409e(viewType) {
        return $f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).getSupportedTriggerPointsConfiguration();
    }
    const $f28ca877f892a554$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $f28ca877f892a554$export$c0728caa743a409e(viewType).has(triggerPoint);
    const $f28ca877f892a554$export$71e5898a2b967ce3 = (viewType)=>$f28ca877f892a554$var$getConfigurationByViewType({
            viewType: viewType
        }).isScreenTabsSupportEnabled();
});
parcelRegister("9myvH", function(module, exports) {
    $parcel$export(module.exports, "fireIAErrorAnalytics", ()=>$10357a302bd65fc5$export$319cadf5a1a1b6a7);
    var $jcw0u;
    var $bPtOr;
    const $10357a302bd65fc5$export$319cadf5a1a1b6a7 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        const packageName = `${viewType}jiraUiModifications`;
        (0, (0, parcelRequire("jcw0u")).default)({
            event: event,
            meta: {
                id: id,
                packageName: packageName,
                teamName: 'unbox'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorType: errorType,
                ...attributes
            }
        });
    };
    const $10357a302bd65fc5$export$7ca48916618a8ab2 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
        const errorType = (0, (0, parcelRequire("bPtOr")).getErrorType)(error);
        const packageName = 'jiraUiModifications';
        (0, (0, parcelRequire("jcw0u")).default)({
            event: event,
            meta: {
                id: id,
                teamName: 'unbox',
                packageName: packageName
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorType: errorType,
                ...attributes,
                viewType: viewType
            }
        });
    };
});
parcelRegister("7vOTV", function(module, exports) {
    $parcel$export(module.exports, "getViewConfiguration", ()=>$bbfcfa56d4cc54c6$export$176b6e68da08ffa2);
    $parcel$export(module.exports, "useLoadViewConfiguration", ()=>$bbfcfa56d4cc54c6$export$f0022a21ccd1f6be);
    var $5uXOq = parcelRequire("5uXOq");
    const $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS = new Map();
    const $bbfcfa56d4cc54c6$export$cda1ad403b37fe70 = (viewType, configuration)=>{
        if (!$bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.has(viewType)) $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
    };
    const $bbfcfa56d4cc54c6$export$176b6e68da08ffa2 = (viewType)=>$bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.get(viewType);
    const $bbfcfa56d4cc54c6$export$e8091eff40c4f16e = ()=>{
        $bbfcfa56d4cc54c6$var$VIEW_CONFIGURATIONS.clear();
    };
    const $bbfcfa56d4cc54c6$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
        (0, $5uXOq.useState)(()=>{
            $bbfcfa56d4cc54c6$export$cda1ad403b37fe70(viewType, new configurationClass());
        });
    };
});
parcelRegister("f81nP", function(module, exports) {
    $parcel$export(module.exports, "initializeField", ()=>$15384141fbdc5039$export$6b51e123e61a9615);
    $parcel$export(module.exports, "initializeFields", ()=>$15384141fbdc5039$export$4a6b4707110b0552);
    var $ePDG3;
    const $15384141fbdc5039$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
            const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            setState({
                formData: {
                    ...formData,
                    [field.fieldId]: {
                        fieldId: field.fieldId,
                        fieldName: field.fieldName,
                        description: field.description,
                        isVisible: field.isVisible,
                        fieldType: field.fieldType,
                        isReadOnly: field.isReadOnly,
                        isRequired: field.isRequired,
                        value: publicValue,
                        optionsVisibility: undefined
                    }
                },
                internalFormMetadata: {
                    ...internalFormMetadata,
                    [field.fieldId]: fieldMetadata
                }
            });
        };
    const $15384141fbdc5039$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
            const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
                const fieldMetadata = {
                    allowedValues: field.allowedValues,
                    isReadOnlyBySystem: field.isReadOnly,
                    isRequiredBySystem: field.isRequired,
                    fieldRenderer: metadata?.fieldRenderer,
                    fieldType: field.fieldType
                };
                const publicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                    fieldMetadata: fieldMetadata,
                    internalFieldValue: field.value,
                    fieldType: field.fieldType,
                    viewType: viewType
                });
                acc.formData[field.fieldId] = {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                };
                acc.internalFormMetadata[field.fieldId] = fieldMetadata;
                return acc;
            }, {
                internalFormMetadata: {},
                formData: {}
            });
            setState({
                formData: formData,
                internalFormMetadata: internalFormMetadata,
                numberOfSupportedFields: fields.length
            });
        };
});
parcelRegister("ePDG3", function(module, exports) {
    $parcel$export(module.exports, "mapFieldValueFromInternalToPublic", ()=>$c6f6fbfe7e0233e1$export$50806045b617d116);
    var $9myvH;
    var $d9r6K;
    const $c6f6fbfe7e0233e1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
        if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
        let value = internalFieldValue;
        try {
            const valueTransformer = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
            if (valueTransformer) value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
        } catch (error) {
            value = null;
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: error,
                id: 'internalToPublicValueTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        return value;
    };
});
parcelRegister("l97Ge", function(module, exports) {
    $parcel$export(module.exports, "initializeNoScreenTab", ()=>$d2f40011899724e0$export$93459ad9bfd6c380);
    const $d2f40011899724e0$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
            setState({
                screenTabs: []
            });
        };
});
parcelRegister("2MPbo", function(module, exports) {
    $parcel$export(module.exports, "initializeScreenTabs", ()=>$02ea37ca59c50e7a$export$7f7be235f64f029b);
    const $02ea37ca59c50e7a$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
            const { screenTabs: internalScreenTabs } = getState();
            const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
            setState({
                screenTabs: tabs.map(({ id: id }, index)=>({
                        id: id,
                        isVisible: true,
                        isActive: index === selected || index === previouslySelected
                    }))
            });
        };
});
parcelRegister("gwqYE", function(module, exports) {
    $parcel$export(module.exports, "processChange", ()=>$ce014541a04fdd22$export$352dfcce04d66748);
    var $3ZT8o = parcelRequire("3ZT8o");
    var $4R6GH;
    var $d9r6K;
    var $bhqjS;
    const $ce014541a04fdd22$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
            const emitChangeOn = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
            if (emitChangeOn !== eventType) return;
            const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
            const nextFormData = (0, (0, parcelRequire("bhqjS")).calculateNextFormValue)({
                internalFormMetadata: internalFormMetadata,
                formData: formData,
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: fieldValue,
                viewType: viewType
            });
            if (nextFormData === null) return;
            setTimeout(()=>{
                const changeId = (0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps') ? (0, ($parcel$interopDefault($3ZT8o)))() : undefined;
                setState({
                    lastProcessedChange: {
                        fieldId: fieldId,
                        changeId: changeId
                    },
                    formData: nextFormData
                });
            }, 0);
        };
});
parcelRegister("3ZT8o", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $2e91d6202798e8a1$var$idCounter = 0;
    function $2e91d6202798e8a1$var$uniqueId(prefix) {
        var id = ++$2e91d6202798e8a1$var$idCounter;
        return $jJVtR(prefix) + id;
    }
    module.exports = $2e91d6202798e8a1$var$uniqueId;
});
parcelRegister("bhqjS", function(module, exports) {
    $parcel$export(module.exports, "calculateNextFormValue", ()=>$df2387a66dda51fa$export$25441a03bb8f1cb0);
    var $ajpes = parcelRequire("ajpes");
    var $dNpDc;
    var $ePDG3;
    const $df2387a66dda51fa$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
        if (formData === null) return null;
        let newPublicValue;
        try {
            newPublicValue = (0, (0, parcelRequire("ePDG3")).mapFieldValueFromInternalToPublic)({
                fieldMetadata: internalFormMetadata[fieldId],
                internalFieldValue: fieldValue,
                fieldType: fieldType,
                viewType: viewType
            });
        } catch (e) {
            (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('internalToPublicValueTransformer', 'fieldMetadataUndefined', viewType, {
                fieldType: fieldType
            });
            return null;
        }
        const currentPublicValue = formData[fieldId]?.value;
        if ((0, ($parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
        return {
            ...formData,
            [fieldId]: {
                ...formData[fieldId],
                value: newPublicValue
            }
        };
    };
});
parcelRegister("ifTQq", function(module, exports) {
    $parcel$export(module.exports, "registerFields", ()=>$490b4304c5c98fd8$export$d4eb181b231cf88d);
    $parcel$export(module.exports, "unregisterFields", ()=>$490b4304c5c98fd8$export$1ca69a85bb7273de);
    var $fr1K2 = parcelRequire("fr1K2");
    var $kGsr8 = parcelRequire("kGsr8");
    var $4R6GH;
    const $490b4304c5c98fd8$var$registerFieldsFFOn = ({ getState: getState, setState: setState, changeId: changeId, appId: appId, fieldsToBeRegistered: fieldsToBeRegistered })=>{
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, ($parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
    const $490b4304c5c98fd8$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
            if (!Array.isArray(fieldsToBeRegistered)) return;
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) $490b4304c5c98fd8$var$registerFieldsFFOn({
                getState: getState,
                setState: setState,
                changeId: changeId,
                appId: appId,
                fieldsToBeRegistered: fieldsToBeRegistered
            });
            else {
                const alreadyRegisteredFields = getState().registeredFieldsDeprecated;
                setState({
                    registeredFieldsDeprecated: {
                        ...alreadyRegisteredFields,
                        [changeId]: fieldsToBeRegistered
                    }
                });
            }
        };
    const $490b4304c5c98fd8$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) {
                const { registeredFields: registeredFields } = getState();
                const registeredAppFields = registeredFields[appId] ?? {};
                const nextRegisteredAppFields = (0, ($parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
                setState({
                    registeredFields: {
                        ...registeredFields,
                        [appId]: nextRegisteredAppFields
                    }
                });
            } else setState({
                registeredFieldsDeprecated: (0, ($parcel$interopDefault($fr1K2)))(getState().registeredFieldsDeprecated, changeId)
            });
        };
});
parcelRegister("hk40m", function(module, exports) {
    $parcel$export(module.exports, "setFieldValue", ()=>$958b56c0b5134e36$export$6556d46d2662453c);
    var $bhqjS;
    const $958b56c0b5134e36$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
            const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
            if (!internalFormMetadata[fieldId]) return;
            const nextFormData = (0, (0, parcelRequire("bhqjS")).calculateNextFormValue)({
                internalFormMetadata: internalFormMetadata,
                formData: formData,
                fieldType: fieldType,
                fieldId: fieldId,
                fieldValue: fieldValue,
                viewType: viewType
            });
            if (nextFormData === null) return;
            setState({
                formData: nextFormData
            });
        };
});
parcelRegister("bAAVc", function(module, exports) {
    $parcel$export(module.exports, "updateActiveScreenTab", ()=>$f1d096c94b789717$export$21363496760d39cd);
    const $f1d096c94b789717$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
            const { screenTabs: screenTabs } = getState();
            if (screenTabs) setState({
                screenTabs: screenTabs.map((tab, index)=>({
                        ...tab,
                        isActive: index === selected
                    }))
            });
        };
});
parcelRegister("5pnmQ", function(module, exports) {
    $parcel$export(module.exports, "updateFields", ()=>$3fb6e39de728db49$export$cceae62fd4d1ef0a);
    var $gccSB = parcelRequire("gccSB");
    var $4R6GH;
    var $dNpDc;
    var $93Yir;
    var $hni9B;
    var $1u7E9;
    var $kVUQH;
    var $gMXSj;
    var $9gKFJ;
    var $fB4oc;
    const $3fb6e39de728db49$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId, intl: intl })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) {
                await dispatch($3fb6e39de728db49$export$7a87c0c70cfb2bfe({
                    changeId: changeId,
                    fieldsChanges: fieldsChanges,
                    lookupDataFromApi: lookupDataFromApi,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    appId: appId,
                    intl: intl
                }));
                return;
            }
            const appliedChanges = getState().appliedChanges || {};
            const formData = getState().formData || {};
            const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
            const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
                const fieldData = formData[fieldId];
                const internalMetadata = internalFormMetadata[fieldId];
                const fieldIsRegistered = (0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps') ? (0, (0, parcelRequire("hni9B")).fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, (0, parcelRequire("hni9B")).fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
                if (!fieldIsRegistered || !fieldData) {
                    console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                    (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId
                    });
                    return acc;
                }
                const lookupData = {
                    [(0, $e774cb836eab763c$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                    [(0, $e774cb836eab763c$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $e774cb836eab763c$export$3a106242c8f57ac2]
                };
                const supportedFieldChanges = await (0, (0, parcelRequire("fB4oc")).transformFieldChangesToInternalShape)({
                    fieldType: fieldData.fieldType,
                    fieldId: fieldId,
                    fieldFromIframe: fieldsChanges?.[fieldId],
                    lookupData: lookupData,
                    viewType: viewType,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    intl: intl
                });
                if (supportedFieldChanges.isValid === false) {
                    (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                    return acc;
                }
                const publicShapeChanges = (0, (0, parcelRequire("gMXSj")).transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
                const transformedFieldChanges = (0, (0, parcelRequire("1u7E9")).mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
                const combinedChangesToApply = {
                    ...appliedChanges[fieldId],
                    ...transformedFieldChanges
                };
                if (!(0, ($parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                    (await acc).changesToApply[fieldId] = combinedChangesToApply;
                    (await acc).incomingFormData[fieldId] = {
                        ...formData[fieldId],
                        ...publicShapeChanges
                    };
                }
                return acc;
            }, Promise.resolve({
                changesToApply: {
                    ...appliedChanges
                },
                incomingFormData: {
                    ...formData
                },
                errorsByField: {}
            }));
            if (!(0, ($parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, (0, parcelRequire("93Yir")).UiModificationsFieldsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("kVUQH")).prepareErrorsArray)(errorsByField)
            });
            setState({
                appliedChanges: changesToApply,
                formData: incomingFormData
            });
        };
    const $3fb6e39de728db49$export$7a87c0c70cfb2bfe = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId, intl: intl })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
            const appliedChanges = getState().appliedChanges ?? {};
            const formData = getState().formData ?? {};
            const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
            const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
                const fieldData = formData[fieldId];
                const internalMetadata = internalFormMetadata[fieldId];
                const fieldIsRegistered = (0, (0, parcelRequire("hni9B")).fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
                if (!fieldIsRegistered || !fieldData) {
                    console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                    (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId
                    });
                    return acc;
                }
                const lookupData = {
                    [(0, $e774cb836eab763c$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                    [(0, $e774cb836eab763c$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $e774cb836eab763c$export$3a106242c8f57ac2]
                };
                const supportedFieldChanges = await (0, (0, parcelRequire("fB4oc")).transformFieldChangesToInternalShape)({
                    fieldType: fieldData.fieldType,
                    fieldId: fieldId,
                    fieldFromIframe: fieldsChanges?.[fieldId],
                    lookupData: lookupData,
                    viewType: viewType,
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    intl: intl
                });
                if (supportedFieldChanges.isValid === false) {
                    (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                    return acc;
                }
                const publicShapeChanges = (0, (0, parcelRequire("gMXSj")).transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
                const transformedFieldChanges = (0, (0, parcelRequire("1u7E9")).mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
                const combinedChangesToApply = {
                    ...appliedChanges[fieldId],
                    ...transformedFieldChanges
                };
                if (!(0, ($parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                    (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                    (await acc).changesToApply[fieldId] = combinedChangesToApply;
                    (await acc).incomingFormData[fieldId] = {
                        ...formData[fieldId],
                        ...publicShapeChanges
                    };
                }
                return acc;
            }, Promise.resolve({
                changesToApply: {
                    ...appliedChanges
                },
                incomingFormData: {
                    ...formData
                },
                newAppliedChangesPublic: {},
                errorsByField: {}
            }));
            if (!(0, ($parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, (0, parcelRequire("93Yir")).UiModificationsFieldsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("kVUQH")).prepareErrorsArray)(errorsByField)
            });
            setState({
                appliedChanges: changesToApply,
                formData: incomingFormData
            });
            dispatch((0, (0, parcelRequire("9gKFJ")).collectFieldsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                fieldsChanges: newAppliedChangesPublic
            }));
        };
});
const $e774cb836eab763c$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $e774cb836eab763c$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $e774cb836eab763c$export$f5d5f6bb902f1027 = '-1';
const $e774cb836eab763c$export$106087dcfd4fb129 = 100;
parcelRegister("93Yir", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsFieldsValidationError", ()=>$5b6f63ca0e228ddb$export$9e8b5e552e255163);
    var $gUcnt;
    class $5b6f63ca0e228ddb$export$9e8b5e552e255163 extends (0, (0, parcelRequire("gUcnt")).UiModificationsValidationError) {
        constructor(message, attributes, cause){
            super(message, attributes, 'fields', cause);
        }
    }
});
parcelRegister("gUcnt", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsValidationError", ()=>$8e0bfdee7bf98a33$export$6e8165c81a6a65df);
    class $8e0bfdee7bf98a33$export$6e8165c81a6a65df extends Error {
        constructor(message, attributes, validationErrorType, cause){
            super(message, cause);
            this.attributes = attributes;
            this.validationErrorType = validationErrorType;
        }
    }
});
parcelRegister("hni9B", function(module, exports) {
    $parcel$export(module.exports, "fieldWasRegisteredDeprecated", ()=>$cfee9dff1dd1041b$export$fce3a63433d10493);
    $parcel$export(module.exports, "fieldWasRegistered", ()=>$cfee9dff1dd1041b$export$fbe9157c12cb4e7b);
    const $cfee9dff1dd1041b$export$fce3a63433d10493 = (registeredFields, changeId, fieldId)=>registeredFields[changeId]?.includes(fieldId);
    const $cfee9dff1dd1041b$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);
});
parcelRegister("1u7E9", function(module, exports) {
    $parcel$export(module.exports, "mapFieldPropertyNamesToInternal", ()=>$e9fe99ede0bfc5ac$export$460820f27643954e);
    var $d9r6K;
    const $e9fe99ede0bfc5ac$export$460820f27643954e = (properties, viewType, fieldType)=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const propertyMapping = fieldConfiguration?.propertyMapping;
        if (!propertyMapping) return properties;
        return Object.keys(properties).reduce((acc, propertyName)=>{
            const propertyMappingValue = propertyMapping[propertyName];
            acc[propertyMappingValue ?? propertyName] = properties[propertyName];
            return acc;
        }, {});
    };
});
parcelRegister("kVUQH", function(module, exports) {
    $parcel$export(module.exports, "prepareErrorsArray", ()=>$55355faba3ba8aca$export$e1fce51bc5be90b7);
    const $55355faba3ba8aca$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();
});
parcelRegister("gMXSj", function(module, exports) {
    $parcel$export(module.exports, "transformFieldToIframe", ()=>$ff2054f6419ee419$export$aa453854f74fab);
    var $9myvH;
    var $d9r6K;
    const $ff2054f6419ee419$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
        const publicShapeField = {
            ...fieldChanges
        };
        if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
            publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
        } catch (err) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: err,
                id: 'internalToPublicValueTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
            const lookupSource = fieldConfiguration?.lookupSource;
            const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
            publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
        } catch (err) {
            (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: err,
                id: 'internalToPublicOptionsVisibilityTransformer',
                viewType: viewType,
                attributes: {
                    fieldType: fieldType
                }
            });
        }
        return publicShapeField;
    };
});
parcelRegister("fB4oc", function(module, exports) {
    $parcel$export(module.exports, "transformFieldChangesToInternalShape", ()=>$e45f458eeb3547af$export$d14f85c01e334a1);
    var $gccSB = parcelRequire("gccSB");
    var $iyelu;
    var $d9r6K;
    var $7wDhr;
    var $6rgBv;
    var $ipjHo;
    const $e45f458eeb3547af$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment, intl: intl })=>{
        const fieldConfiguration = (0, (0, parcelRequire("d9r6K")).getSupportedFieldConfiguration)(viewType, fieldType);
        const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
        const fieldValidators = fieldConfiguration?.publicShapeValidators;
        if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
            ...(0, (0, parcelRequire("6rgBv")).VALID_RESULT),
            data: {}
        };
        const validatorsArray = Object.keys(fieldValidators);
        const lookupSource = fieldConfiguration?.lookupSource;
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
            if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, (0, parcelRequire("6rgBv")).VALID_RESULT;
            const propertyValue = fieldFromIframe[propertyName];
            const transformer = fieldTransformers[propertyName];
            const fieldContext = {
                fieldId: fieldId
            };
            try {
                const data = transformer ? await transformer(propertyValue, lookupValues, {
                    tenantContext: tenantContext,
                    viewContext: viewContext,
                    environment: environment,
                    fieldContext: fieldContext,
                    intl: intl
                }) : propertyValue;
                return {
                    isValid: true,
                    data: {
                        [propertyName]: data
                    }
                };
            } catch (err) {
                if (err instanceof (0, (0, parcelRequire("iyelu")).FieldValueLookupError)) {
                    const faultyValue = err.message || propertyValue;
                    return {
                        isValid: false,
                        error: {
                            fieldId: fieldId,
                            fieldType: fieldType,
                            type: (0, $36f69991a898da6d$export$d1996cb46a690190),
                            method: (0, (0, parcelRequire("7wDhr")).mapFieldPropertyToApiMethod)(propertyName),
                            message: `Invalid IDs provided: ${faultyValue}`
                        }
                    };
                }
                throw err;
            }
        }));
        const invalidTransformationResults = (0, (0, parcelRequire("ipjHo")).filterInvalidResults)(fieldTransformationResults);
        if (!(0, ($parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
            isValid: false,
            errors: invalidTransformationResults.map((result)=>result.error)
        };
        return (0, (0, parcelRequire("ipjHo")).mapValidResultsToFieldInternalShape)(fieldTransformationResults);
    };
});
parcelRegister("iyelu", function(module, exports) {
    $parcel$export(module.exports, "FieldValueLookupError", ()=>$7d9a5d144067113e$export$73c2f0689b6c4a5a);
    class $7d9a5d144067113e$export$73c2f0689b6c4a5a extends Error {
    }
});
parcelRegister("6rgBv", function(module, exports) {
    $parcel$export(module.exports, "VALID_RESULT", ()=>$b7fbd017e17733fd$export$ee79e3ab53b8db79);
    const $b7fbd017e17733fd$export$ee79e3ab53b8db79 = {
        isValid: true
    };
});
parcelRegister("ipjHo", function(module, exports) {
    $parcel$export(module.exports, "mapValidResultsToFieldInternalShape", ()=>$9b00f9608a01c0fc$export$a60dd8f1b025f23d);
    $parcel$export(module.exports, "filterInvalidResults", ()=>$9b00f9608a01c0fc$export$ddd005554aecd409);
    const $9b00f9608a01c0fc$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
            if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
                ...acc.data,
                ...result.data
            };
            return acc;
        }, {
            isValid: true,
            data: {}
        });
    const $9b00f9608a01c0fc$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
            if (result.isValid === false) acc.push(result);
            return acc;
        }, []);
});
parcelRegister("4qdFk", function(module, exports) {
    $parcel$export(module.exports, "updateScreenTabs", ()=>$6f863ceddcde4420$export$131c67fd312b8a11);
    var $4R6GH;
    var $hkYX3;
    var $ldH1m;
    var $iQI6L;
    var $9gKFJ;
    const $6f863ceddcde4420$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { screenTabs: internalScreenTabs } = getState();
            if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
            if (internalScreenTabs && (0, (0, parcelRequire("hkYX3")).screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
                const newScreenTabs = (0, (0, parcelRequire("hkYX3")).screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
                setState({
                    screenTabs: newScreenTabs
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) dispatch((0, (0, parcelRequire("9gKFJ")).collectScreenTabsAppliedChangesHistory)({
                    appId: appId,
                    changeId: changeId,
                    screenTabs: newScreenTabs
                }));
            } else throw new (0, (0, parcelRequire("ldH1m")).UiModificationsScreenTabsValidationError)('Transformation failed', {
                errors: (0, (0, parcelRequire("hkYX3")).getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, (0, parcelRequire("iQI6L")).toScreenTabsValidationError))
            });
        };
});
parcelRegister("hkYX3", function(module, exports) {
    $parcel$export(module.exports, "screenTabsPublicToInternalTransformer", ()=>$dc3e5a7f628b7026$export$9ca9b35e7b6a8bbc);
    $parcel$export(module.exports, "screenTabsPublicToInternalValidator", ()=>$dc3e5a7f628b7026$export$e7a91e7e430e691a);
    $parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", ()=>$dc3e5a7f628b7026$export$62d63af83dac7315);
    const $dc3e5a7f628b7026$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
    const $dc3e5a7f628b7026$var$isValidScreenTabId = (internalScreenTabs, id)=>$dc3e5a7f628b7026$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
    const $dc3e5a7f628b7026$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
    const $dc3e5a7f628b7026$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
    const $dc3e5a7f628b7026$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$dc3e5a7f628b7026$var$isValidScreenTabId(internalScreenTabs, id) && $dc3e5a7f628b7026$var$isValidScreenTabIsVisible(isVisible) && $dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive);
    const $dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
        if ($dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
        return acc;
    };
    const $dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
        if ($dc3e5a7f628b7026$var$isValidScreenTabIsActive(isActive) && isActive && $dc3e5a7f628b7026$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
        return acc;
    };
    const $dc3e5a7f628b7026$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
        let numberOfActiveScreenTabs = 0;
        const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
        const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
            const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
            if (!screenTabFromApp) return screenTabInternal;
            numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
            return {
                id: screenTabInternal.id,
                isVisible: screenTabFromApp.isVisible ?? true,
                isActive: screenTabFromApp.isActive
            };
        });
        if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
        return screenTabsInternalUpdated;
    };
    const $dc3e5a7f628b7026$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
        if (!Array.isArray(screenTabsFromApp)) return false;
        const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$dc3e5a7f628b7026$var$isValidScreenTabData(internalScreenTabs, data));
        const numberOfActiveScreenTabs = screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs, 0);
        const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs, 0);
        return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
    };
    const $dc3e5a7f628b7026$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
        if (!internalScreenTabs) return [
            'There are no screen tabs in the current view.'
        ];
        if (!Array.isArray(screenTabsFromApp)) return [
            'Your app must return screen tabs as an array.'
        ];
        const errors = [];
        if (screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
        if (screenTabsFromApp.reduce($dc3e5a7f628b7026$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
        return errors;
    };
});
parcelRegister("ldH1m", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsScreenTabsValidationError", ()=>$0cba70b8975758a2$export$faf1f1824ee0a136);
    var $gUcnt;
    class $0cba70b8975758a2$export$faf1f1824ee0a136 extends (0, (0, parcelRequire("gUcnt")).UiModificationsValidationError) {
        constructor(message, attributes, cause){
            super(message, attributes, 'screenTabs', cause);
        }
    }
});
parcelRegister("iQI6L", function(module, exports) {
    $parcel$export(module.exports, "toScreenTabsValidationError", ()=>$e7f1397478a6ee9f$export$b2675440ade984fb);
    const $e7f1397478a6ee9f$export$b2675440ade984fb = (message)=>({
            message: message,
            type: (0, $36f69991a898da6d$export$fd26696d109785a0)
        });
});
const $380826ec5efdda82$export$e615b7e9b8fb4715 = 'GIC';
parcelRegister("egcPe", function(module, exports) {
    $parcel$export(module.exports, "GICViewConfiguration", ()=>$9756b3802dbf6f61$export$99b59685fcab4ee);
    var $2vSU6;
    var $4R6GH;
    var $hULKg;
    var $5fc53;
    var $huY3x;
    var $7AkCN;
    var $9fmMA;
    var $bwumX;
    var $kUieP;
    var $iPOW1;
    var $ddViG;
    var $a9FQD;
    var $1paNN;
    var $fasDJ;
    var $4a9C5;
    var $cn6WY;
    var $4Vy4a;
    var $bjcpj;
    var $2V7xq;
    var $5CqLP;
    var $8HEBV;
    var $3fHwD;
    var $2UMtO;
    var $eCYWe;
    var $8eXWB;
    var $7Q9ye;
    var $ekLmV;
    var $2xJRj;
    var $esYap;
    var $3xNCX;
    var $kNR0c;
    var $echHY;
    var $9bTKH;
    var $7ZP8L;
    var $fPEV6;
    var $2AQeg;
    var $lK4Eh;
    var $ibFp9;
    var $9icMi;
    class $9756b3802dbf6f61$export$99b59685fcab4ee {
        getSupportedFieldsConfiguration() {
            const commonFieldValidators = (0, (0, parcelRequire("8HEBV")).getCommonFieldValidators)();
            return {
                [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldSetValueValidator)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur'
                },
                [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("4a9C5")).validatePrioritySetValue),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("echHY")).prioritySetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("echHY")).transformPrioritySetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("echHY")).transformPriorityGetValue),
                        optionsVisibility: (0, (0, parcelRequire("echHY")).transformPriorityGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("7AkCN")).assigneeSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("7AkCN")).assigneeSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("7AkCN")).assigneeGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$3a106242c8f57ac2)
                },
                [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2V7xq")).userPickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("lK4Eh")).userPickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("lK4Eh")).userPickerGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$3a106242c8f57ac2)
                },
                [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("a9FQD")).labelsSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("a9FQD")).labelsSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("a9FQD")).labelsGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("eCYWe")).validateDescriptionAndParagraphSetValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("eCYWe")).descriptionAndParagraphSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("eCYWe")).descriptionAndParagraphGetValueTransformer)
                    },
                    emitChangeOn: 'blur'
                },
                [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("bjcpj")).selectSetValueValidator),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("fPEV6")).selectSetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("fPEV6")).transformSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("fPEV6")).selectGetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("fPEV6")).transformSelectGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("eCYWe")).validateDescriptionAndParagraphSetValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("eCYWe")).descriptionAndParagraphSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("eCYWe")).descriptionAndParagraphGetValueTransformer)
                    },
                    emitChangeOn: 'blur'
                },
                [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("ekLmV")).validateMultiSelectSetValue),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("ekLmV")).multiSelectSetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("ekLmV")).transformMultiSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("ekLmV")).multiSelectGetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("ekLmV")).transformMultiSelectGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("kNR0c")).peopleSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("kNR0c")).peopleSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("kNR0c")).peopleGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$3a106242c8f57ac2)
                },
                [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2xJRj")).multiUserPickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("2xJRj")).multiUserPickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("2xJRj")).multiUserPickerGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$3a106242c8f57ac2)
                },
                [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldSetValueValidator)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur'
                },
                [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("7Q9ye")).validateMultiCheckboxSetValue),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("7Q9ye")).multiCheckboxSetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("7Q9ye")).transformMultiCheckboxSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("7Q9ye")).multiCheckboxGetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("7Q9ye")).transformMultiCheckboxGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2UMtO")).validateComponentsSetValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("2UMtO")).componentsSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("2UMtO")).componentsGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    requiredScopes: (0, (0, parcelRequire("bwumX")).componentsRequiredScopes)
                },
                [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("4Vy4a")).reporterSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("7ZP8L")).reporterSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("7ZP8L")).reporterGetValueTransformer)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$3a106242c8f57ac2)
                },
                [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("ibFp9")).fixVersionsSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("ibFp9")).transformVersionsSetValue)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("ibFp9")).transformVersionsGetValue)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    requiredScopes: (0, (0, parcelRequire("ibFp9")).versionsRequiredScopes)
                },
                [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: {
                    publicShapeValidators: {
                        value: (0, (0, parcelRequire("ddViG")).issueTypeSetValueValidator),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("8eXWB")).issueTypeSetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("8eXWB")).transformIssueTypeSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("8eXWB")).issueTypeGetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("8eXWB")).transformIssueTypeGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldSetValueValidator)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("2AQeg")).singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur'
                },
                [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("iPOW1")).validateDateTimePickerSetValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("iPOW1")).transformDateTimePickerSetValue)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("iPOW1")).transformDateTimePickerGetValue)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("cn6WY")).radioButtonsSetValueValidator),
                        optionsVisibility: (0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("9bTKH")).radioButtonsSetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("9bTKH")).transformRadioButtonsSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("9bTKH")).radioButtonsGetValueTransformer),
                        optionsVisibility: (0, (0, parcelRequire("9bTKH")).transformRadioButtonsGetOptionsVisibility)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    propertyMapping: {
                        optionsVisibility: 'allowedValues'
                    }
                },
                [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("1paNN")).validateNumberValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("esYap")).transformNumberToInternalValue)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("esYap")).transformNumberToPublicValue)
                    },
                    emitChangeOn: 'blur',
                    requiredScopes: (0, (0, parcelRequire("esYap")).numberIssueGicScopes)
                },
                [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("fasDJ")).parentSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("3xNCX")).parentSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("3xNCX")).parentGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("9fmMA")).validateCascadingSelectSetValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("3fHwD")).transformSetValueCascadingSelect)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("3fHwD")).transformGetValueCascadingSelect)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901)
                },
                [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("5CqLP")).validateVersionValue)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("ibFp9")).transformVersionsSetValue)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("ibFp9")).transformVersionsGetValue)
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $e774cb836eab763c$export$a1cacdcf198da901),
                    requiredScopes: (0, (0, parcelRequire("ibFp9")).versionsRequiredScopes)
                },
                [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                },
                [(0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueValidator)
                    },
                    publicToInternalTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerSetValueTransformer)
                    },
                    internalToPublicTransformers: {
                        value: (0, (0, parcelRequire("kUieP")).datePickerGetValueTransformer)
                    },
                    emitChangeOn: 'change'
                }
            };
        }
        getSupportedFieldTypes() {
            const supportedFieldTypes = [
                (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
                (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE),
                (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
                (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
                (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE),
                (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE),
                (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                (0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE),
                (0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE)
            ];
            if ((0, (0, parcelRequire("4R6GH")).fg)('uim-cascading-select-field-support-gic_h1cda')) supportedFieldTypes.push((0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE));
            return supportedFieldTypes;
        }
        getSupportedProjectTypes() {
            return [
                (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT),
                (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            ];
        }
        getConsentMessage() {
            return (0, (0, parcelRequire("9icMi")).default).obligatoryUimGicConsentMessage;
        }
        getAnalytics() {
            return this.analytics;
        }
        getSupportedTriggerPointsConfiguration() {
            return new Set([
                (0, (0, parcelRequire("hULKg")).GENERIC_FORGE_USE_PRODUCT_MODALS),
                (0, (0, parcelRequire("hULKg")).GENERIC_GLOBAL_CREATE_BUTTON),
                (0, (0, parcelRequire("hULKg")).GENERIC_KEYBOARD_SHORTCUT),
                (0, (0, parcelRequire("hULKg")).JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC),
                (0, (0, parcelRequire("hULKg")).JSW_CREATE_EPIC_ISSUE),
                (0, (0, parcelRequire("hULKg")).JSW_ISSUE_VIEW_CREATE_SUBTASK)
            ]);
        }
        constructor(){
            this.analytics = {
                stopTTI: (0, parcelRequire("huY3x")).stopTTI,
                cancelTTI: (0, parcelRequire("huY3x")).cancelTTI,
                markIframeLoad: (0, parcelRequire("huY3x")).markIframeLoad,
                markFieldsRegistered: (0, parcelRequire("huY3x")).markFieldsRegistered,
                markOnInitResolved: (0, parcelRequire("huY3x")).markOnInitResolved
            };
            this.isScreenTabsSupportEnabled = ()=>true;
        }
    }
});
parcelRegister("7AkCN", function(module, exports) {
    $parcel$export(module.exports, "assigneeSetValueValidator", ()=>$868ea0af53443827$export$a1b37d5eeb401ad6);
    $parcel$export(module.exports, "assigneeSetValueTransformer", ()=>$868ea0af53443827$export$d1aadee23fc64b9d);
    $parcel$export(module.exports, "assigneeGetValueTransformer", ()=>$868ea0af53443827$export$166948efaac892d3);
    $parcel$export(module.exports, "assigneeScopes", ()=>$868ea0af53443827$export$3c9d4db6ddd2a8e6);
    var $iyelu;
    var $eYMyc;
    var $fhSLy;
    var $cpl2T;
    var $frwJc;
    const $868ea0af53443827$export$a1b37d5eeb401ad6 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $868ea0af53443827$export$d1aadee23fc64b9d = (value, lookupValues, context)=>{
        if (value === null) return null;
        const { intl: intl } = context;
        if (value === (0, $e774cb836eab763c$export$f5d5f6bb902f1027) && intl) {
            const automaticUserOption = (0, (0, parcelRequire("fhSLy")).getAutomaticUserOption)(intl);
            return {
                accountId: automaticUserOption.accountId ?? (0, $e774cb836eab763c$export$f5d5f6bb902f1027),
                displayName: automaticUserOption.displayName,
                avatarUrls: {
                    '48x48': ''
                }
            };
        }
        const foundValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, lookupValues, 'accountId');
        if (!foundValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        const { accountId: accountId, name: displayName, picture: picture } = foundValue;
        return {
            accountId: accountId,
            displayName: displayName,
            avatarUrls: {
                '48x48': picture
            }
        };
    };
    const $868ea0af53443827$export$166948efaac892d3 = (value)=>{
        if (value === null) return null;
        const { accountId: accountId } = value;
        return {
            accountId: accountId
        };
    };
    const $868ea0af53443827$export$3c9d4db6ddd2a8e6 = {
        ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField),
        granular: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).granular,
            'read:user:jira'
        ],
        coarse: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).coarse,
            'read:jira-user'
        ]
    };
});
parcelRegister("eYMyc", function(module, exports) {
    $parcel$export(module.exports, "baseScopesRequiredPerField", ()=>$199c3236064b0a44$export$ec1ba7c44413935f);
    const $199c3236064b0a44$export$ec1ba7c44413935f = {
        granular: [
            'read:field:jira',
            'write:field:jira',
            'read:field-configuration:jira',
            'write:field-configuration:jira'
        ],
        coarse: [
            'read:jira-work',
            'write:jira-work',
            'manage:jira-configuration'
        ]
    };
});
parcelRegister("fhSLy", function(module, exports) {
    $parcel$export(module.exports, "getUnassignedUser", ()=>$bdabf260f25df73f$export$42c5a0b65ef9ee80);
    $parcel$export(module.exports, "getAutomaticUserOption", ()=>$bdabf260f25df73f$export$8d7a63500893c8c);
    $parcel$export(module.exports, "getInvitePeopleOption", ()=>$bdabf260f25df73f$export$84a82764cf0a696e);
    $parcel$export(module.exports, "getUserOptionFromUser", ()=>$bdabf260f25df73f$export$16086438354dcc85);
    $parcel$export(module.exports, "getUserFromUserOption", ()=>$bdabf260f25df73f$export$78a8bcc5bd21caa2);
    $parcel$export(module.exports, "getUserAvatarUrl", ()=>$bdabf260f25df73f$export$7d801d84202c7743);
    $parcel$export(module.exports, "getUserShape", ()=>$bdabf260f25df73f$export$322b6ab8c29a006e);
    var $7lGt2;
    var $12ZsE = parcelRequire("12ZsE");
    const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
            accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
            displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).unassignedOption),
            avatarUrls: {}
        });
    const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
            accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
            displayName: formatMessage((0, (0, parcelRequire("7lGt2")).default).automaticOption),
            avatarUrls: {}
        });
    const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
            accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
            displayName: formatMessage(isAdmin ? (0, (0, parcelRequire("7lGt2")).default).invitePeopleOptionAdmin : (0, (0, parcelRequire("7lGt2")).default).invitePeopleOption),
            avatarUrls: {
                '48x48': (0, ($parcel$interopDefault($12ZsE)))
            }
        });
    const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
            id: accountId || '',
            name: displayName,
            avatarUrl: avatarUrls['48x48'],
            byline: emailAddress
        });
    const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
            accountId: id,
            displayName: name,
            avatarUrls: {
                '48x48': avatarUrl
            }
        });
    const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
    const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
            accountId: accountId,
            displayName: displayName,
            avatarUrls: {
                '48x48': avatarUrl
            }
        });
});
parcelRegister("7lGt2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2aaed3328149e1d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unassignedOption: {
            "id": "issue-field-assignee.unassigned-option",
            "defaultMessage": "Unassigned"
        },
        automaticOption: {
            "id": "issue-field-assignee.automatic-option",
            "defaultMessage": "Automatic"
        },
        assignToMe: {
            "id": "issue-field-assignee.assign-to-me",
            "defaultMessage": "Assign to me"
        },
        searchForAssignee: {
            "id": "issue-field-assignee.search-for-assignee",
            "defaultMessage": "Search for assignee"
        },
        invitePeopleOption: {
            "id": "issue-field-assignee.invite-people-option",
            "defaultMessage": "Add teammate to Jira"
        },
        invitePeopleOptionAdmin: {
            "id": "issue-field-assignee.invite-people-option-admin",
            "defaultMessage": "Invite teammate to Jira"
        }
    });
});
parcelRegister("12ZsE", function(module, exports) {
    module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();
});
const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';
parcelRegister("cpl2T", function(module, exports) {
    $parcel$export(module.exports, "isNotEmptyString", ()=>$c781386ebe1eb569$export$582443c7ead02173);
    const $c781386ebe1eb569$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
});
parcelRegister("frwJc", function(module, exports) {
    $parcel$export(module.exports, "singleValueLookup", ()=>$4913cef5f57acebe$export$93a99fc9939aad85);
    const $4913cef5f57acebe$export$93a99fc9939aad85 = (value, lookupValues = [], lookupKey)=>lookupValues.find((option)=>option[lookupKey] === value);
});
parcelRegister("9fmMA", function(module, exports) {
    $parcel$export(module.exports, "validateCascadingSelectSetValue", ()=>$7c7c4bf4d7ff3eac$export$2d586ab6ce4d7126);
    $parcel$export(module.exports, "validateCascadingSelectWithAriSetValue", ()=>$7c7c4bf4d7ff3eac$export$1e029e8cc721ad5e);
    var $482Oe;
    var $cpl2T;
    const $7c7c4bf4d7ff3eac$export$2d586ab6ce4d7126 = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value.parentId) && ((0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value.childId) || value.childId === null);
    const $7c7c4bf4d7ff3eac$export$1e029e8cc721ad5e = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value.parentId) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value.parentId) && (value.childId === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value.childId) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value.childId));
});
parcelRegister("482Oe", function(module, exports) {
    $parcel$export(module.exports, "isAriResourceIdValid", ()=>$4c9868c4f22c3fe9$export$4d1e9901084f3bf6);
    var $e9E9F;
    const $4c9868c4f22c3fe9$var$CLOUD_ID_MOCK = 'cloud-id';
    const $4c9868c4f22c3fe9$var$ACTIOVATION_ID_MOCK = 'activation-id';
    const $4c9868c4f22c3fe9$var$FIELD_ID_MOCK = 'field-1';
    const $4c9868c4f22c3fe9$export$4d1e9901084f3bf6 = (optionId)=>{
        try {
            (0, (0, parcelRequire("e9E9F")).JiraIssueFieldOptionAri).create({
                siteId: $4c9868c4f22c3fe9$var$CLOUD_ID_MOCK,
                activationId: $4c9868c4f22c3fe9$var$ACTIOVATION_ID_MOCK,
                fieldId: $4c9868c4f22c3fe9$var$FIELD_ID_MOCK,
                optionId: optionId
            });
            return true;
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("e9E9F", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueFieldOptionAri", ()=>$a4e10de13cd7bf40$export$e3bc1ec22f941fbe);
    var $aeXsV;
    var $9KGzW;
    var $1C2Ux;
    var $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("aeXsV")).JiraIssueFieldOptionAriResourceOwner),
        resourceType: (0, (0, parcelRequire("aeXsV")).JiraIssueFieldOptionAriResourceType),
        resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
        resourceIdSegmentFormats: {
            activationId: /[a-zA-Z0-9\-]+/,
            fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
            optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
        }
    };
    var $a4e10de13cd7bf40$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
        }
        get siteId() {
            return this._siteId;
        }
        get activationId() {
            return this._activationId;
        }
        get fieldId() {
            return this._fieldId;
        }
        get optionId() {
            return this._optionId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
                platformQualifier: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
                resourceType: $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
                resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
                resourceIdSegmentValues: {
                    activationId: opts.activationId,
                    fieldId: opts.fieldId,
                    optionId: opts.optionId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
            return new _JiraIssueFieldOptionAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $a4e10de13cd7bf40$var$jiraIssueFieldOptionAriStaticOpts);
            return new _JiraIssueFieldOptionAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                activationId: this.activationId,
                fieldId: this.fieldId,
                optionId: this.optionId
            };
        }
    };
});
parcelRegister("aeXsV", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", ()=>$774956c9da7baac8$export$eb4f4cf0880fe5a8);
    $parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", ()=>$774956c9da7baac8$export$4bec333360908e78);
    var $774956c9da7baac8$export$eb4f4cf0880fe5a8 = "jira", $774956c9da7baac8$export$4bec333360908e78 = "issue-field-option";
});
parcelRegister("bwumX", function(module, exports) {
    $parcel$export(module.exports, "validateComponentsSetValue", ()=>$f1e11025fd7745a7$export$c65e64c3a855d5d2);
    $parcel$export(module.exports, "componentsRequiredScopes", ()=>$f1e11025fd7745a7$export$a818a96eabdabcb);
    var $eYMyc;
    var $cpl2T;
    const $f1e11025fd7745a7$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.length <= (0, $e774cb836eab763c$export$106087dcfd4fb129) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
    const $f1e11025fd7745a7$export$a818a96eabdabcb = {
        ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField),
        granular: [
            'read:project.component:jira',
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).granular,
            'write:field.default-value:jira'
        ]
    };
});
parcelRegister("kUieP", function(module, exports) {
    $parcel$export(module.exports, "datePickerSetValueValidator", ()=>$376d7f259486e553$export$c003579a97a2459e);
    $parcel$export(module.exports, "datePickerSetValueTransformer", ()=>$376d7f259486e553$export$cfb5350c1b8d2150);
    $parcel$export(module.exports, "datePickerGetValueTransformer", ()=>$376d7f259486e553$export$e844c6ac3a5cbef7);
    var $k7m40;
    var $jovBr;
    var $2753q;
    var $eZDAP;
    const $376d7f259486e553$var$dateHasExpectedFormat = (date)=>{
        const dateFormat = 'yyyy-MM-dd';
        if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
        const parsedDate = (0, (0, parcelRequire("2753q")).default)(date, dateFormat, new Date());
        return (0, (0, parcelRequire("jovBr")).default)(parsedDate);
    };
    const $376d7f259486e553$export$c003579a97a2459e = (value)=>value === null || $376d7f259486e553$var$dateHasExpectedFormat(value);
    const $376d7f259486e553$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
    const $376d7f259486e553$export$e844c6ac3a5cbef7 = (value)=>{
        if (!value) return null;
        const parsedDate = (0, (0, parcelRequire("eZDAP")).default)(value);
        if ((0, (0, parcelRequire("jovBr")).default)(parsedDate)) return (0, (0, parcelRequire("k7m40")).default)(parsedDate, 'yyyy-MM-dd');
        return null;
    };
});
parcelRegister("iPOW1", function(module, exports) {
    $parcel$export(module.exports, "validateDateTimePickerSetValue", ()=>$59f7b9f567d38b16$export$7930ddff407505cc);
    $parcel$export(module.exports, "transformDateTimePickerSetValue", ()=>$59f7b9f567d38b16$export$e81204f19744e19f);
    $parcel$export(module.exports, "transformDateTimePickerGetValue", ()=>$59f7b9f567d38b16$export$4cb6c79fda4a9c74);
    var $k7m40;
    var $6NYhy;
    var $jovBr;
    var $eZDAP;
    const $59f7b9f567d38b16$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
    const $59f7b9f567d38b16$export$a886f5166a4d311e = (fullDate)=>{
        if (typeof fullDate !== 'string') return false;
        return (0, (0, parcelRequire("6NYhy")).default)(fullDate, $59f7b9f567d38b16$var$formatString) && (0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(fullDate));
    };
    const $59f7b9f567d38b16$export$7930ddff407505cc = (value)=>value === null || $59f7b9f567d38b16$export$a886f5166a4d311e(value);
    const $59f7b9f567d38b16$export$e81204f19744e19f = (publicValue)=>publicValue === null ? '' : publicValue;
    const $59f7b9f567d38b16$export$4cb6c79fda4a9c74 = (value)=>{
        if (!value) return null;
        const parsedDate = (0, (0, parcelRequire("eZDAP")).default)(value);
        if ((0, (0, parcelRequire("jovBr")).default)(parsedDate)) return (0, (0, parcelRequire("k7m40")).default)(parsedDate, $59f7b9f567d38b16$var$formatString);
        return null;
    };
});
parcelRegister("ddViG", function(module, exports) {
    $parcel$export(module.exports, "issueTypeSetValueValidator", ()=>$463469cab0dbc32c$export$19e9b52e41260d79);
    $parcel$export(module.exports, "validateIssueTypeWithAriSetValue", ()=>$463469cab0dbc32c$export$91780d7591f86a1d);
    var $482Oe;
    var $cpl2T;
    const $463469cab0dbc32c$export$19e9b52e41260d79 = (value)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $463469cab0dbc32c$export$91780d7591f86a1d = (value)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value);
});
parcelRegister("a9FQD", function(module, exports) {
    $parcel$export(module.exports, "labelsRequiredScopes", ()=>$ab55693818f251d7$export$5397fc4189b6d690);
    $parcel$export(module.exports, "labelsSetValueValidator", ()=>$ab55693818f251d7$export$e67b5652c846b5f);
    $parcel$export(module.exports, "labelsSetValueTransformer", ()=>$ab55693818f251d7$export$861e9d180b68fea1);
    $parcel$export(module.exports, "labelsGetValueTransformer", ()=>$ab55693818f251d7$export$b0b12fd0b1cd9d3a);
    var $eYMyc;
    const $ab55693818f251d7$export$5397fc4189b6d690 = {
        granular: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).granular,
            'read:label:jira'
        ],
        coarse: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).coarse
        ]
    };
    const $ab55693818f251d7$export$e67b5652c846b5f = (value)=>typeof value === 'object' && value !== null && Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
    const $ab55693818f251d7$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
                value: label,
                label: label
            }));
    const $ab55693818f251d7$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);
});
parcelRegister("1paNN", function(module, exports) {
    $parcel$export(module.exports, "validateNumberValue", ()=>$a2073d4f18454e24$export$aeb074bfcd7963bd);
    $parcel$export(module.exports, "numberScopes", ()=>$a2073d4f18454e24$export$2ddc76933cd1391c);
    var $eYMyc;
    const $a2073d4f18454e24$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
    const $a2073d4f18454e24$export$2ddc76933cd1391c = (0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField);
});
parcelRegister("fasDJ", function(module, exports) {
    $parcel$export(module.exports, "parentSetValueValidator", ()=>$17f5bb12fa4559f0$export$ada98fdbc0faa607);
    $parcel$export(module.exports, "validateParentWithAriSetValueOld", ()=>$17f5bb12fa4559f0$export$b07dfe1a2fa93abc);
    $parcel$export(module.exports, "validateParentWithAriSetValue", ()=>$17f5bb12fa4559f0$export$e3aab6ae1b4e9174);
    $parcel$export(module.exports, "validateParentSetOptionsVisibilityAri", ()=>$17f5bb12fa4559f0$export$8cdcca29a2b25e60);
    $parcel$export(module.exports, "parentScopes", ()=>$17f5bb12fa4559f0$export$bdc8bd505789b6e8);
    var $8S2Xh;
    var $eYMyc;
    var $482Oe;
    var $cpl2T;
    var $5a2jR;
    const $17f5bb12fa4559f0$var$CLOUD_ID_MOCK = 'cloud-id';
    const $17f5bb12fa4559f0$export$9603e65f1e714629 = (optionId)=>{
        try {
            (0, (0, parcelRequire("8S2Xh")).JiraIssueAri).create({
                siteId: $17f5bb12fa4559f0$var$CLOUD_ID_MOCK,
                issueId: optionId
            });
            return true;
        } catch (e) {
            return false;
        }
    };
    const $17f5bb12fa4559f0$export$ada98fdbc0faa607 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $17f5bb12fa4559f0$export$b07dfe1a2fa93abc = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value);
    const $17f5bb12fa4559f0$export$e3aab6ae1b4e9174 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && $17f5bb12fa4559f0$export$9603e65f1e714629(value);
    const $17f5bb12fa4559f0$export$8cdcca29a2b25e60 = (optionsVisibility)=>(0, (0, parcelRequire("5a2jR")).validateSetOptionsVisibility)(optionsVisibility) && optionsVisibility.options.every((optionId)=>$17f5bb12fa4559f0$export$9603e65f1e714629(optionId));
    const $17f5bb12fa4559f0$export$bdc8bd505789b6e8 = (0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField);
});
parcelRegister("8S2Xh", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueAri", ()=>$6755a8b1c7a21b87$export$1da6808e89ee03e);
    var $bQ5aj;
    var $9KGzW;
    var $1C2Ux;
    var $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("bQ5aj")).JiraIssueAriResourceOwner),
        resourceType: (0, (0, parcelRequire("bQ5aj")).JiraIssueAriResourceType),
        resourceIdSlug: "{issueId}",
        resourceIdSegmentFormats: {
            issueId: /[0-9]+/
        }
    };
    var $6755a8b1c7a21b87$export$1da6808e89ee03e = class _JiraIssueAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
        }
        get siteId() {
            return this._siteId;
        }
        get issueId() {
            return this._issueId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.qualifier,
                platformQualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceOwner,
                resourceType: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceType,
                resourceId: `${opts.issueId}`,
                resourceIdSegmentValues: {
                    issueId: opts.issueId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
            return new _JiraIssueAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
            return new _JiraIssueAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                issueId: this.issueId
            };
        }
    };
});
parcelRegister("bQ5aj", function(module, exports) {
    $parcel$export(module.exports, "JiraIssueAriResourceOwner", ()=>$89e88ec215209f61$export$665a39f1b4e29e0a);
    $parcel$export(module.exports, "JiraIssueAriResourceType", ()=>$89e88ec215209f61$export$76beb4d0da177ad4);
    var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";
});
parcelRegister("5a2jR", function(module, exports) {
    $parcel$export(module.exports, "transformSelectSetOptionsVisibility", ()=>$990b12d5a8aaf054$export$81990085f8ab114b);
    $parcel$export(module.exports, "transformSetOptionsVisibilityForFrontendFilteringWithARIs", ()=>$990b12d5a8aaf054$export$19d00b5cfa21ccb4);
    $parcel$export(module.exports, "transformOptionIdsToARI", ()=>$990b12d5a8aaf054$export$aaa1909c16b4bd2c);
    $parcel$export(module.exports, "transformSetOptionsVisibilityAriIssueView", ()=>$990b12d5a8aaf054$export$66a7c94869edc6af);
    $parcel$export(module.exports, "transformSetOptionsVisibilityAri", ()=>$990b12d5a8aaf054$export$a68e1c2d1192287c);
    $parcel$export(module.exports, "transformSelectGetOptionsVisibility", ()=>$990b12d5a8aaf054$export$7c7ca81813eb0f65);
    $parcel$export(module.exports, "validateSetOptionsVisibility", ()=>$990b12d5a8aaf054$export$973aead813665e25);
    $parcel$export(module.exports, "validateSetOptionsVisibilityAri", ()=>$990b12d5a8aaf054$export$979d55c1d0a17c97);
    var $e9E9F;
    var $dXq4S;
    var $8HEBV;
    var $482Oe;
    const $990b12d5a8aaf054$export$81990085f8ab114b = ({ isVisible: isVisible, options: options })=>({
            operation: isVisible ? 'ALLOW' : 'EXCLUDE',
            ids: options
        });
    const $990b12d5a8aaf054$export$19d00b5cfa21ccb4 = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
            operation: isVisible ? 'ALLOW' : 'EXCLUDE',
            ids: $990b12d5a8aaf054$export$aaa1909c16b4bd2c(options, context)
        });
    const $990b12d5a8aaf054$var$transformOptionIdsToAriIssueView = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.map((optionId)=>{
            const resourceId = `${fieldContext.fieldId}/${optionId}`;
            return (0, (0, parcelRequire("dXq4S")).createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'issue-field-option',
                activationId: tenantContext.activationId,
                resourceId: resourceId
            });
        });
    const $990b12d5a8aaf054$export$66a7c94869edc6af = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
            operation: isVisible ? 'ALLOW' : 'EXCLUDE',
            optionIds: $990b12d5a8aaf054$var$transformOptionIdsToAriIssueView(options, context)
        });
    const $990b12d5a8aaf054$export$aaa1909c16b4bd2c = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.map((optionId)=>(0, (0, parcelRequire("e9E9F")).JiraIssueFieldOptionAri).create({
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId,
                fieldId: fieldContext.fieldId,
                optionId: optionId
            }).toString());
    const $990b12d5a8aaf054$export$a68e1c2d1192287c = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
            operation: isVisible ? 'ALLOW' : 'EXCLUDE',
            optionIds: $990b12d5a8aaf054$export$aaa1909c16b4bd2c(options, context)
        });
    const $990b12d5a8aaf054$export$7c7ca81813eb0f65 = ({ isVisible: isVisible, options: options })=>({
            isVisible: isVisible,
            options: options
        });
    const $990b12d5a8aaf054$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
    const $990b12d5a8aaf054$export$973aead813665e25 = (optionsVisibility)=>(0, (0, parcelRequire("8HEBV")).validateSetOptionsVisibilityRule)(optionsVisibility) && $990b12d5a8aaf054$export$914c7f5212c4c649(optionsVisibility);
    const $990b12d5a8aaf054$export$979d55c1d0a17c97 = (optionsVisibility)=>$990b12d5a8aaf054$export$973aead813665e25(optionsVisibility) && optionsVisibility.options.every((optionId)=>(0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(optionId));
});
parcelRegister("8HEBV", function(module, exports) {
    $parcel$export(module.exports, "getCommonFieldValidators", ()=>$17cf4b6df9a75fa7$export$68248012b0fecf7d);
    $parcel$export(module.exports, "validateSetOptionsVisibilityRule", ()=>$17cf4b6df9a75fa7$export$cb8a43658ea03ec7);
    var $l1C1k;
    var $3ivBz;
    var $9myvH;
    var $aNf5C;
    var $cpl2T;
    var $5s9fM;
    const $17cf4b6df9a75fa7$export$68248012b0fecf7d = ()=>({
            fieldName: (value)=>typeof value === 'string',
            isVisible: (value)=>typeof value === 'boolean',
            description: $17cf4b6df9a75fa7$export$b5ccb7b3af83de7e,
            isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
            isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
        });
    const $17cf4b6df9a75fa7$export$b5ccb7b3af83de7e = async (value)=>{
        if (typeof value !== 'string') return false;
        if (value === '') return true;
        try {
            const adfValue = await (0, (0, parcelRequire("3ivBz")).convertWikiToAdfAsync)(value);
            if (!adfValue) return false;
            (0, (0, parcelRequire("l1C1k")).traverse)(adfValue, {
                media: (node)=>{
                    if (node.attrs?.type === 'external' && node.attrs.url !== undefined) throw new (0, (0, parcelRequire("aNf5C")).ExternalImageValidationError)('Cannot contain external images');
                }
            });
        } catch (err) {
            if (!(err instanceof (0, (0, parcelRequire("aNf5C")).ExternalImageValidationError))) (0, (0, parcelRequire("9myvH")).fireIAErrorAnalytics)({
                error: err,
                id: 'descriptionWikiValidationException',
                viewType: undefined,
                attributes: {
                    errorCause: err?.cause,
                    message: err.message
                }
            });
            return false;
        }
        return true;
    };
    const $17cf4b6df9a75fa7$export$cb8a43658ea03ec7 = (optionsVisibility)=>(0, (0, parcelRequire("5s9fM")).isObject)(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
});
parcelRegister("l1C1k", function(module, exports) {
    $parcel$export(module.exports, "traverse", ()=>$b903aab814d8ed47$export$df3f009e3d155b20);
    function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
        return true;
    }
    function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
        if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
        return $b903aab814d8ed47$var$traverseNode(adf, {
            node: undefined
        }, visitors, 0, 0);
    }
    function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
        const visitor = visitors[adfNode.type] || visitors['any'];
        let newNode = {
            ...adfNode
        };
        if (visitor) {
            const processedNode = visitor({
                ...newNode
            }, parent, index, depth);
            if (processedNode === false) return false;
            newNode = processedNode || adfNode;
        }
        if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
            if (!node) return acc;
            const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
                node: newNode,
                parent: parent
            }, visitors, idx, depth + 1);
            if (processedNode !== false) acc.push(processedNode);
            return acc;
        }, []);
        return newNode;
    }
});
parcelRegister("3ivBz", function(module, exports) {
    $parcel$export(module.exports, "convertWikiToAdfAsync", ()=>$7769195ee47a7f4d$export$8e1b3b0130ee3556);
    const $7769195ee47a7f4d$export$8e1b3b0130ee3556 = async (wiki)=>{
        if (wiki === null || wiki === undefined || wiki === '') return Promise.resolve(null);
        const wikiPromise = await Promise.resolve((parcelRequire("dN5CS")));
        const schemaPromise = await Promise.resolve((parcelRequire("kOFhM")));
        const jsonPromise = await Promise.resolve((parcelRequire("hYNZx")));
        const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
            schemaPromise,
            wikiPromise,
            jsonPromise
        ]);
        const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
        const adfTransformer = new JSONTransformer();
        const pmNode = wikiTransformer.parse(wiki);
        return adfTransformer.encode(pmNode);
    };
});
parcelRegister("aNf5C", function(module, exports) {
    $parcel$export(module.exports, "ExternalImageValidationError", ()=>$8debe13c9259f0a1$export$af6b052883945124);
    class $8debe13c9259f0a1$export$af6b052883945124 extends Error {
    }
});
parcelRegister("5s9fM", function(module, exports) {
    $parcel$export(module.exports, "isObject", ()=>$dff7f664be7fa904$export$a6cdc56e425d0d0a);
    const $dff7f664be7fa904$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;
});
parcelRegister("4a9C5", function(module, exports) {
    $parcel$export(module.exports, "validatePrioritySetValue", ()=>$8cdcc768cc3441e4$export$feb916d6d9ca4953);
    $parcel$export(module.exports, "validatePriorityWithAriSetValue", ()=>$8cdcc768cc3441e4$export$d41ad24763f49041);
    $parcel$export(module.exports, "priorityScopes", ()=>$8cdcc768cc3441e4$export$de5c165bee5efef2);
    var $eYMyc;
    var $482Oe;
    var $cpl2T;
    const $8cdcc768cc3441e4$export$feb916d6d9ca4953 = (value)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $8cdcc768cc3441e4$export$d41ad24763f49041 = (value)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value);
    const $8cdcc768cc3441e4$export$de5c165bee5efef2 = {
        ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField),
        granular: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).granular,
            'read:priority:jira'
        ]
    };
});
parcelRegister("cn6WY", function(module, exports) {
    $parcel$export(module.exports, "radioButtonsSetValueValidator", ()=>$9075d0d4a1f38b3b$export$fd2e39ca7399c512);
    $parcel$export(module.exports, "validateRadioButtonsWithAriSetValue", ()=>$9075d0d4a1f38b3b$export$5fe5484755d2d441);
    $parcel$export(module.exports, "radioButtonsScopes", ()=>$9075d0d4a1f38b3b$export$baef9137cbf80a51);
    var $eYMyc;
    var $482Oe;
    var $cpl2T;
    const $9075d0d4a1f38b3b$export$fd2e39ca7399c512 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $9075d0d4a1f38b3b$export$5fe5484755d2d441 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value);
    const $9075d0d4a1f38b3b$export$baef9137cbf80a51 = (0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField);
});
parcelRegister("4Vy4a", function(module, exports) {
    $parcel$export(module.exports, "reporterSetValueValidator", ()=>$c947d730922d8264$export$b8b018eb25bdb4d8);
    var $dHHVN;
    var $cpl2T;
    const $c947d730922d8264$export$b8b018eb25bdb4d8 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("dHHVN")).isNotAutomaticId)(value);
});
parcelRegister("dHHVN", function(module, exports) {
    $parcel$export(module.exports, "isNotAutomaticId", ()=>$652bb6a7e5221244$export$ab4c3a3c49d7add);
    const $652bb6a7e5221244$export$ab4c3a3c49d7add = (value)=>value !== (0, $e774cb836eab763c$export$f5d5f6bb902f1027);
});
parcelRegister("bjcpj", function(module, exports) {
    $parcel$export(module.exports, "selectSetValueValidator", ()=>$6e3e172cb767dc4b$export$c02b1c2a574ca4c7);
    $parcel$export(module.exports, "selectWithAriSetValueValidator", ()=>$6e3e172cb767dc4b$export$f22935386c756879);
    $parcel$export(module.exports, "selectScopes", ()=>$6e3e172cb767dc4b$export$cb76f902c880ecb4);
    var $eYMyc;
    var $482Oe;
    var $cpl2T;
    const $6e3e172cb767dc4b$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value);
    const $6e3e172cb767dc4b$export$f22935386c756879 = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(value);
    const $6e3e172cb767dc4b$export$cb76f902c880ecb4 = (0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField);
});
parcelRegister("2V7xq", function(module, exports) {
    $parcel$export(module.exports, "userPickerSetValueValidator", ()=>$7572c9e53dc6713b$export$e01dbe42b757ec);
    var $dHHVN;
    var $cpl2T;
    const $7572c9e53dc6713b$export$e01dbe42b757ec = (value)=>value === null || (0, (0, parcelRequire("cpl2T")).isNotEmptyString)(value) && (0, (0, parcelRequire("dHHVN")).isNotAutomaticId)(value);
});
parcelRegister("5CqLP", function(module, exports) {
    $parcel$export(module.exports, "validateVersionValue", ()=>$041fc6519dfbe928$export$f3e581e8b1e2479a);
    $parcel$export(module.exports, "validateVersionWithAriSetValue", ()=>$041fc6519dfbe928$export$7b83966d45a2bceb);
    $parcel$export(module.exports, "versionsRequiredScopes", ()=>$041fc6519dfbe928$export$60db61c485973ad9);
    var $eYMyc;
    var $482Oe;
    var $cpl2T;
    const $041fc6519dfbe928$export$f3e581e8b1e2479a = (value)=>Array.isArray(value) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString)) && value.length <= (0, $e774cb836eab763c$export$106087dcfd4fb129);
    const $041fc6519dfbe928$export$7b83966d45a2bceb = (value)=>Array.isArray(value) && value.every((val)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(val) && (0, (0, parcelRequire("482Oe")).isAriResourceIdValid)(val)) && value.length <= (0, $e774cb836eab763c$export$106087dcfd4fb129);
    const $041fc6519dfbe928$export$60db61c485973ad9 = {
        granular: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).granular,
            'read:project-version:jira'
        ],
        coarse: [
            ...(0, (0, parcelRequire("eYMyc")).baseScopesRequiredPerField).coarse
        ]
    };
});
parcelRegister("3fHwD", function(module, exports) {
    $parcel$export(module.exports, "transformSetValueCascadingSelect", ()=>$1e3e134f6d96c80f$export$905a8d55c641a71e);
    $parcel$export(module.exports, "transformGetValueCascadingSelect", ()=>$1e3e134f6d96c80f$export$47e9770ed0d1c344);
    var $iyelu;
    var $cpl2T;
    var $frwJc;
    const $1e3e134f6d96c80f$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
        const foundOption = lookupData.find((currentOption)=>currentOption.parentOptionValue.id === parentId);
        if (!foundOption) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        const value = {
            parent: foundOption.parentOptionValue,
            child: childId !== null ? (0, (0, parcelRequire("frwJc")).singleValueLookup)(childId, foundOption.childOptionValues, 'id') : childId
        };
        return value;
    };
    const $1e3e134f6d96c80f$export$905a8d55c641a71e = (value, allowedValues)=>{
        if (value === null) return null;
        const cascadingSelectValue = $1e3e134f6d96c80f$var$findCascadingSelectLookupValues(allowedValues, value.parentId, value.childId);
        if (!(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(cascadingSelectValue.parent.value)) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            label: cascadingSelectValue.parent.value,
            value: cascadingSelectValue.parent.id,
            child: cascadingSelectValue.child ? {
                label: cascadingSelectValue.child.value,
                value: cascadingSelectValue.child.id
            } : null
        };
    };
    const $1e3e134f6d96c80f$export$47e9770ed0d1c344 = (cascadingValue)=>{
        if (!cascadingValue) return null;
        const { label: label, value: value, child: child } = cascadingValue;
        return child?.label && child?.value ? {
            parent: {
                id: value,
                value: label
            },
            child: {
                id: child.value,
                value: child.label
            }
        } : {
            parent: {
                id: value,
                value: label
            },
            child: null
        };
    };
});
parcelRegister("2UMtO", function(module, exports) {
    $parcel$export(module.exports, "validateComponentsSetValue", ()=>$09b0dd4b219b64a0$export$c65e64c3a855d5d2);
    $parcel$export(module.exports, "componentsGetValueTransformer", ()=>$09b0dd4b219b64a0$export$b6f14754491cc7aa);
    $parcel$export(module.exports, "componentsSetValueTransformer", ()=>$09b0dd4b219b64a0$export$777b614991f65d18);
    var $iyelu;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $09b0dd4b219b64a0$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
    const $09b0dd4b219b64a0$export$b6f14754491cc7aa = (internalValue)=>{
        if (!internalValue) return [];
        return internalValue.map(({ value: id, label: name })=>({
                id: id,
                name: name
            }));
    };
    const $09b0dd4b219b64a0$export$777b614991f65d18 = (publicValue, lookupValues)=>{
        if (!publicValue.length) return [];
        const filteredLookupValues = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(publicValue, lookupValues, 'id');
        if (publicValue.length !== filteredLookupValues.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(publicValue, lookupValues, 'id');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return filteredLookupValues.map(({ id: value, name: label })=>({
                value: value,
                label: label
            }));
    };
});
parcelRegister("9mqRh", function(module, exports) {
    $parcel$export(module.exports, "getValueLookupValuesDiff", ()=>$74662d637a90413e$export$6ebcd48e99f6b85);
    const $74662d637a90413e$export$6ebcd48e99f6b85 = (value, lookupValues = [], lookupKey)=>value.filter((id)=>!lookupValues.some((option)=>option[lookupKey] === id));
});
parcelRegister("fwvEZ", function(module, exports) {
    $parcel$export(module.exports, "multiValueLookup", ()=>$aa2173a319ebb478$export$12a8af52bc9e513e);
    const $aa2173a319ebb478$export$12a8af52bc9e513e = (value, lookupValues = [], lookupKey)=>lookupValues.filter((option)=>value.includes(option[lookupKey]));
});
parcelRegister("eCYWe", function(module, exports) {
    $parcel$export(module.exports, "validateDescriptionAndParagraphSetValue", ()=>$3b28326669e03dd9$export$55c0a47975b0f67);
    $parcel$export(module.exports, "descriptionAndParagraphSetValueTransformer", ()=>$3b28326669e03dd9$export$8596d284a0b8650f);
    $parcel$export(module.exports, "descriptionAndParagraphGetValueTransformer", ()=>$3b28326669e03dd9$export$736f124bc0a7d673);
    var $fr1K2 = parcelRequire("fr1K2");
    var $g9VtI;
    var $1K3Xb;
    const $3b28326669e03dd9$export$95433ac963f4aebe = 'JiraTextAreaField';
    const $3b28326669e03dd9$export$31a6c27df1f927b2 = 'JiraRichTextField';
    const $3b28326669e03dd9$export$55c0a47975b0f67 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
        switch(fieldRenderer){
            case $3b28326669e03dd9$export$31a6c27df1f927b2:
                return (0, (0, parcelRequire("g9VtI")).isValidADF)({
                    newValue: value,
                    currentValue: extra.currentField?.value,
                    viewType: extra.viewType
                });
            case $3b28326669e03dd9$export$95433ac963f4aebe:
                return Promise.resolve(typeof value === 'string');
            default:
                return Promise.resolve(false);
        }
    };
    const $3b28326669e03dd9$export$8596d284a0b8650f = (value)=>{
        if (typeof value === 'string') return value;
        return {
            ...value,
            overrideRequired: true
        };
    };
    const $3b28326669e03dd9$export$736f124bc0a7d673 = (value, fieldRenderer)=>{
        if (value === undefined) return fieldRenderer === $3b28326669e03dd9$export$31a6c27df1f927b2 ? (0, (0, parcelRequire("1K3Xb")).convertTextToAdf)('') : '';
        if (typeof value === 'string') return value;
        return (0, ($parcel$interopDefault($fr1K2)))(value, 'overrideRequired');
    };
});
parcelRegister("g9VtI", function(module, exports) {
    $parcel$export(module.exports, "isValidADF", ()=>$3abbf6d76be62361$export$94ea512f7afe62e4);
    var $1vRrA = parcelRequire("1vRrA");
    var $ajpes = parcelRequire("ajpes");
    var $bPWvi;
    var $l1C1k;
    var $dNpDc;
    const $3abbf6d76be62361$var$getADFValidator = async ()=>{
        const { validator: validator } = await (parcelRequire("jHQpH"));
        return validator;
    };
    const $3abbf6d76be62361$var$validateAdfExternalUrls = (adf)=>{
        try {
            (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
                media: (node)=>{
                    if (node.attrs?.type === 'external' && node.attrs?.url !== undefined) throw new Error('Cannot contain external images');
                },
                blockCard: ()=>{
                    throw new Error('Cannot contain blockCard');
                },
                embedCard: ()=>{
                    throw new Error('Cannot contain embedCard');
                }
            });
            return true;
        } catch (err) {
            return false;
        }
    };
    const $3abbf6d76be62361$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
        if (!currentValue || !currentValue.content.length) return $3abbf6d76be62361$var$validateAdfExternalUrls(newValue);
        const foundDiffNodes = (0, ($parcel$interopDefault($1vRrA)))(newValue.content, currentValue.content, (0, ($parcel$interopDefault($ajpes))));
        const formattedDiffAdf = (0, (0, parcelRequire("bPWvi")).doc)(...foundDiffNodes);
        return $3abbf6d76be62361$var$validateAdfExternalUrls(formattedDiffAdf);
    };
    const $3abbf6d76be62361$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue, viewType: viewType })=>{
        const validator = await $3abbf6d76be62361$var$getADFValidator();
        const validate = validator();
        const validationStartTime = performance.now();
        try {
            const isValidAdfNewValue = Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
            const isValidAdf = isValidAdfNewValue && $3abbf6d76be62361$export$6f13dd7501a16a00(newValue, currentValue);
            (0, (0, parcelRequire("dNpDc")).fireOperationalAnalyticsWithoutContext)('adfValidation', 'completed', viewType, {
                validatedInMs: Math.floor(performance.now() - validationStartTime)
            });
            return isValidAdf;
        } catch (e) {
            return false;
        }
    };
});
parcelRegister("1vRrA", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $hYfgW = parcelRequire("hYfgW");
    var $11a22487ca4cd1f5$var$differenceWith = $g7i7g(function(array, values) {
        var comparator = $hYfgW(values);
        if ($f3SOL(comparator)) comparator = undefined;
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true), undefined, comparator) : [];
    });
    module.exports = $11a22487ca4cd1f5$var$differenceWith;
});
parcelRegister("bPWvi", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$c17b5e301ceeeae8$export$2a111da947c407d2);
    const $c17b5e301ceeeae8$export$2a111da947c407d2 = (...content)=>({
            type: 'doc',
            version: 1,
            content: content
        });
});
parcelRegister("jHQpH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eRd8e").then(()=>parcelRequire('d9FJW'));
});
parcelRegister("1K3Xb", function(module, exports) {
    $parcel$export(module.exports, "convertTextToAdf", ()=>$903ba9c436cc186a$export$c10cf32c4acc1d57);
    var $bPWvi;
    var $50sdg;
    var $kz2lw;
    const $903ba9c436cc186a$export$c10cf32c4acc1d57 = (text)=>{
        if (text === '') return (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
        return (0, (0, parcelRequire("bPWvi")).doc)((0, (0, parcelRequire("50sdg")).paragraph)(text));
    };
});
parcelRegister("50sdg", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$b5360ede7330200d$export$9c206ddddb32a9b);
    var $3lRhe;
    const $b5360ede7330200d$export$9c206ddddb32a9b = (...content)=>({
            type: 'paragraph',
            content: (0, (0, parcelRequire("3lRhe")).createTextNodes)(content)
        });
});
parcelRegister("3lRhe", function(module, exports) {
    $parcel$export(module.exports, "createTextNodes", ()=>$4fbd120aea0a69b1$export$3a269a5941b62f04);
    var $gBTcG;
    function $4fbd120aea0a69b1$export$3a269a5941b62f04(nodes) {
        return nodes.map($4fbd120aea0a69b1$export$72b9432ea0656b50);
    }
    function $4fbd120aea0a69b1$export$72b9432ea0656b50(str) {
        return typeof str === 'string' ? (0, (0, parcelRequire("gBTcG")).text)(str) : str;
    }
});
parcelRegister("gBTcG", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$9654feec8f8dd4ec$export$6f093cfa640b7166);
    const $9654feec8f8dd4ec$export$6f093cfa640b7166 = (text)=>({
            type: 'text',
            text: text
        });
});
parcelRegister("8eXWB", function(module, exports) {
    $parcel$export(module.exports, "issueTypeSetValueTransformer", ()=>$fc5b994f4e030ea3$export$93e4fd33c48f4977);
    $parcel$export(module.exports, "issueTypeGetValueTransformer", ()=>$fc5b994f4e030ea3$export$391657d4e7f81237);
    $parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", ()=>$fc5b994f4e030ea3$export$db493bcecec5fb56);
    $parcel$export(module.exports, "transformIssueTypeGetOptionsVisibility", ()=>$fc5b994f4e030ea3$export$3a886340b0f20858);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $frwJc;
    const $fc5b994f4e030ea3$export$93e4fd33c48f4977 = (value, lookupValues)=>{
        const lookupValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, lookupValues, 'value');
        if (!lookupValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            iconUrl: lookupValue.iconUrl,
            label: lookupValue.label,
            value: lookupValue.value
        };
    };
    const $fc5b994f4e030ea3$export$391657d4e7f81237 = (value)=>{
        if (!value) return null;
        return {
            id: value.value,
            name: value.label
        };
    };
    const $fc5b994f4e030ea3$export$db493bcecec5fb56 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
    const $fc5b994f4e030ea3$export$3a886340b0f20858 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
});
parcelRegister("6aU71", function(module, exports) {
    $parcel$export(module.exports, "applyOptionsVisibilityRule", ()=>$f3275806245f2359$export$642f3f0b0177721e);
    const $f3275806245f2359$export$642f3f0b0177721e = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>isVisible ? lookupValues.filter((value)=>options.includes(value[optionKey])) : lookupValues.filter((value)=>!options.includes(value[optionKey]));
});
parcelRegister("nQYm2", function(module, exports) {
    $parcel$export(module.exports, "getAvailableOptionsVisibilityRule", ()=>$754cb1d9a51718dd$export$d614c43ae91f42cd);
    const $754cb1d9a51718dd$export$d614c43ae91f42cd = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>({
            isVisible: isVisible,
            options: options.filter((option)=>lookupValues.some((value)=>value[optionKey] === option))
        });
});
parcelRegister("7Q9ye", function(module, exports) {
    $parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", ()=>$df05d6290ea41580$export$115a0b8c81087c2c);
    $parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", ()=>$df05d6290ea41580$export$4471ab017a7abd7);
    $parcel$export(module.exports, "validateMultiCheckboxSetValue", ()=>$df05d6290ea41580$export$56639f1c650d9ba5);
    $parcel$export(module.exports, "multiCheckboxSetValueTransformer", ()=>$df05d6290ea41580$export$9ba1ee83cc9456ba);
    $parcel$export(module.exports, "multiCheckboxGetValueTransformer", ()=>$df05d6290ea41580$export$6d15ce1cc0bdffe7);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $df05d6290ea41580$export$115a0b8c81087c2c = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $df05d6290ea41580$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $df05d6290ea41580$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
    const $df05d6290ea41580$export$9ba1ee83cc9456ba = (publicValue, allowedValues)=>{
        if (!publicValue.length) return [];
        const foundValue = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(publicValue, allowedValues, 'id');
        if (foundValue.length !== publicValue.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(publicValue, foundValue, 'id');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return foundValue.map(({ value: value, id: id })=>({
                label: value,
                value: id
            }));
    };
    const $df05d6290ea41580$export$6d15ce1cc0bdffe7 = (internalValue)=>{
        if (!internalValue) return [];
        return internalValue.map(({ value: value, label: label })=>({
                id: value,
                value: label
            }));
    };
});
parcelRegister("ekLmV", function(module, exports) {
    $parcel$export(module.exports, "transformMultiSelectSetOptionsVisibility", ()=>$1e41cc0f0f684ca3$export$464f5c048bb44fae);
    $parcel$export(module.exports, "transformMultiSelectGetOptionsVisibility", ()=>$1e41cc0f0f684ca3$export$16ec76c8ef15bfca);
    $parcel$export(module.exports, "validateMultiSelectSetValue", ()=>$1e41cc0f0f684ca3$export$7002ea8d8a6dd444);
    $parcel$export(module.exports, "multiSelectSetValueTransformer", ()=>$1e41cc0f0f684ca3$export$87ccfa5280a3288f);
    $parcel$export(module.exports, "multiSelectGetValueTransformer", ()=>$1e41cc0f0f684ca3$export$9992ce1903b64c5);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $1e41cc0f0f684ca3$export$464f5c048bb44fae = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $1e41cc0f0f684ca3$export$16ec76c8ef15bfca = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $1e41cc0f0f684ca3$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
    const $1e41cc0f0f684ca3$export$87ccfa5280a3288f = (values, lookupValues)=>{
        if (!values.length) return [];
        const filteredValues = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(values, lookupValues, 'id');
        if (filteredValues.length !== values.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(values, filteredValues, 'id');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return filteredValues.map((val)=>({
                label: val.value,
                value: val.id
            }));
    };
    const $1e41cc0f0f684ca3$export$9992ce1903b64c5 = (internalValue)=>{
        if (!internalValue) return [];
        return internalValue.map(({ value: value, label: label })=>({
                id: value,
                value: label
            }));
    };
});
parcelRegister("2xJRj", function(module, exports) {
    $parcel$export(module.exports, "multiUserPickerSetValueValidator", ()=>$7dc4ebbf7b731405$export$161337c705ff4d65);
    $parcel$export(module.exports, "multiUserPickerSetValueTransformer", ()=>$7dc4ebbf7b731405$export$206658c0c308733e);
    $parcel$export(module.exports, "multiUserPickerGetValueTransformer", ()=>$7dc4ebbf7b731405$export$68e3fe5737fc7137);
    var $iyelu;
    var $dHHVN;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $7dc4ebbf7b731405$export$161337c705ff4d65 = (value)=>Array.isArray(value) && value.every((option)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(option) && (0, (0, parcelRequire("dHHVN")).isNotAutomaticId)(option));
    const $7dc4ebbf7b731405$export$206658c0c308733e = (values, lookupValues)=>{
        if (!values.length) return [];
        const filteredLookupValues = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(values, lookupValues, 'accountId');
        if (values.length !== filteredLookupValues.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
                id: id,
                name: name,
                avatarUrl: avatarUrl
            }));
    };
    const $7dc4ebbf7b731405$export$68e3fe5737fc7137 = (value)=>{
        if (!value) return [];
        return value.map(({ id: id })=>({
                accountId: id
            }));
    };
});
parcelRegister("esYap", function(module, exports) {
    $parcel$export(module.exports, "transformNumberToInternalValue", ()=>$dfcb58a867d3ce96$export$bdbd8c4d6c9c2efe);
    $parcel$export(module.exports, "transformNumberToPublicValue", ()=>$dfcb58a867d3ce96$export$8bdc28b51a4acc44);
    $parcel$export(module.exports, "numberIssueGicScopes", ()=>$dfcb58a867d3ce96$export$b7e1c026b8f78970);
    var $1paNN;
    const $dfcb58a867d3ce96$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
    const $dfcb58a867d3ce96$export$8bdc28b51a4acc44 = (internalValue)=>[
            undefined,
            ''
        ].includes(internalValue) ? null : Number(internalValue);
    const $dfcb58a867d3ce96$export$b7e1c026b8f78970 = {
        ...(0, (0, parcelRequire("1paNN")).numberScopes),
        granular: [
            ...(0, (0, parcelRequire("1paNN")).numberScopes).granular,
            'write:field.default-value:jira'
        ]
    };
});
parcelRegister("3xNCX", function(module, exports) {
    $parcel$export(module.exports, "parentSetValueTransformer", ()=>$5801cea69c174b0c$export$a65d296b5d388a59);
    $parcel$export(module.exports, "parentGetValueTransformer", ()=>$5801cea69c174b0c$export$ea591224dc3a0141);
    var $iyelu;
    var $iHPnC;
    var $0Q1Cs;
    async function $5801cea69c174b0c$export$a65d296b5d388a59(value, _lookupValues, { tenantContext: tenantContext }) {
        if (value === null) return null;
        try {
            const parentIssueDetails = await (0, (0, parcelRequire("0Q1Cs")).fetchParentIssueDetails)(tenantContext.cloudId, value);
            if (!parentIssueDetails) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(`Parent issue with issueId "${value}" not found`, {
                cause: (0, $0b20d04e9212d44f$export$4a4db137834138dd)
            });
            const issue = parentIssueDetails.jira?.issueById;
            const fields = issue?.fieldsById?.edges;
            if (!issue || !issue.issueId || !issue.key || !fields) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
                cause: (0, $0b20d04e9212d44f$export$aa7d91b2fd1ba261)
            });
            let issueTypeField = null;
            let summaryField = null;
            let statusField = null;
            for (const field of fields){
                if ((0, (0, parcelRequire("0Q1Cs")).isJiraIssueTypeFieldNode)(field?.node)) issueTypeField = field?.node ?? null;
                else if ((0, (0, parcelRequire("0Q1Cs")).isJiraSingleLineTextFieldNode)(field?.node)) summaryField = field?.node ?? null;
                else if ((0, (0, parcelRequire("0Q1Cs")).isJiraStatusFieldNode)(field?.node)) statusField = field?.node ?? null;
            }
            if (!issueTypeField || !summaryField || !statusField) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
                cause: (0, $0b20d04e9212d44f$export$aa7d91b2fd1ba261)
            });
            return {
                color: (0, (0, parcelRequire("iHPnC")).asColor)(parentIssueDetails.jira.issueById.issueColorField?.color?.colorKey) ?? undefined,
                value: parentIssueDetails.jira.issueById.issueId,
                isDone: (0, (0, parcelRequire("0Q1Cs")).checkParentIssueIsDone)(statusField),
                key: parentIssueDetails.jira.issueById.key,
                label: `${parentIssueDetails.jira.issueById.key} ${summaryField.text}`,
                fields: {
                    summary: summaryField.text ?? '',
                    issuetype: {
                        id: issueTypeField.issueType?.issueTypeId ?? undefined,
                        name: issueTypeField.issueType?.name ?? undefined,
                        iconUrl: issueTypeField.issueType?.avatar?.xsmall ?? ''
                    }
                }
            };
        } catch (error) {
            if (error instanceof Error && !('cause' in error)) error.cause = (0, $0b20d04e9212d44f$export$494a54d93664524d);
            if (error instanceof Error) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(error.message, {
                cause: error.cause
            });
            throw error;
        }
    }
    function $5801cea69c174b0c$export$ea591224dc3a0141(intervalValue) {
        if (!intervalValue) return null;
        return {
            id: intervalValue.value.toString(),
            key: intervalValue.key
        };
    }
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("ggSx2", function(module, exports) {
    var $cxSdl = parcelRequire("cxSdl");
    var $fxKlj = parcelRequire("fxKlj");
    var $etyzk = parcelRequire("etyzk");
    var $bd8870e21c3833a0$var$objectProto = Object.prototype;
    var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
    var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
        if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
        result[value] = key;
    }, $cxSdl($etyzk));
    module.exports = $bd8870e21c3833a0$var$invert;
});
parcelRegister("fxKlj", function(module, exports) {
    var $d1nCg = parcelRequire("d1nCg");
    function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
        return function(object, iteratee) {
            return $d1nCg(object, setter, toIteratee(iteratee), {});
        };
    }
    module.exports = $b50de2cb57eb155c$var$createInverter;
});
parcelRegister("d1nCg", function(module, exports) {
    var $hDnyx = parcelRequire("hDnyx");
    function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
        $hDnyx(object, function(value, key, object) {
            setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
    }
    module.exports = $97adb007e27dc709$var$baseInverter;
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $829f609a65d26a98$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
        [(0, $829f609a65d26a98$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
        [(0, $829f609a65d26a98$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
        [(0, $829f609a65d26a98$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
        [(0, $829f609a65d26a98$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
        [(0, $829f609a65d26a98$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
        [(0, $829f609a65d26a98$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        [(0, $829f609a65d26a98$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
        [(0, $829f609a65d26a98$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
        [(0, $829f609a65d26a98$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
        [(0, $829f609a65d26a98$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
        [(0, $829f609a65d26a98$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
        [(0, $829f609a65d26a98$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
        [(0, $829f609a65d26a98$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P500})`,
            text: "var(--ds-text-accent-purple, #803FA5)",
            textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $829f609a65d26a98$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B500})`,
            text: "var(--ds-text-accent-blue, #1558BC)",
            textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $829f609a65d26a98$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G500})`,
            text: "var(--ds-text-accent-green, #216E4E)",
            textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $829f609a65d26a98$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T500})`,
            text: "var(--ds-text-accent-teal, #206A83)",
            textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $829f609a65d26a98$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $829f609a65d26a98$exports).Y500})`,
            text: "var(--ds-text-accent-yellow, #7F5F01)",
            textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
            border: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R500})`,
            text: "var(--ds-text-accent-red, #AE2E24)",
            textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            border: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $829f609a65d26a98$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N500})`,
            text: "var(--ds-text-accent-gray, #505258)",
            textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
            border: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $829f609a65d26a98$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $829f609a65d26a98$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
            border: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $829f609a65d26a98$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
            border: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $829f609a65d26a98$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
            border: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $829f609a65d26a98$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $829f609a65d26a98$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $829f609a65d26a98$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
            border: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $829f609a65d26a98$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $829f609a65d26a98$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $829f609a65d26a98$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
            border: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $829f609a65d26a98$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $829f609a65d26a98$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $829f609a65d26a98$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
            border: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $829f609a65d26a98$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $829f609a65d26a98$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $829f609a65d26a98$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
            textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
            border: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $829f609a65d26a98$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $829f609a65d26a98$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
const $0b20d04e9212d44f$export$4a4db137834138dd = 'FETCH_PARENT_FIELD_NOT_FOUND';
const $0b20d04e9212d44f$export$aa7d91b2fd1ba261 = 'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
const $0b20d04e9212d44f$export$494a54d93664524d = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
const $0b20d04e9212d44f$export$db8af5ee2c36776e = 'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';
parcelRegister("0Q1Cs", function(module, exports) {
    $parcel$export(module.exports, "isJiraIssueTypeFieldNode", ()=>$5c62f02a12edc836$export$57eda1f5ad7133c3);
    $parcel$export(module.exports, "isJiraSingleLineTextFieldNode", ()=>$5c62f02a12edc836$export$ea2b75e2537cbccf);
    $parcel$export(module.exports, "isJiraStatusFieldNode", ()=>$5c62f02a12edc836$export$1a148ec51054fc5a);
    $parcel$export(module.exports, "fetchParentIssueDetails", ()=>$5c62f02a12edc836$export$ef5c4d73a6136d96);
    $parcel$export(module.exports, "checkParentIssueIsDone", ()=>$5c62f02a12edc836$export$2b30e3fdda29f6);
    var $8S2Xh;
    var $gULOk;
    var $92ECu;
    var $iBOrg;
    const $5c62f02a12edc836$export$57eda1f5ad7133c3 = (node)=>node?.__typename === 'JiraIssueTypeField';
    const $5c62f02a12edc836$export$ea2b75e2537cbccf = (node)=>node?.__typename === 'JiraSingleLineTextField';
    const $5c62f02a12edc836$export$1a148ec51054fc5a = (node)=>node?.__typename === 'JiraStatusField';
    const $5c62f02a12edc836$export$6ba84cffc20b9772 = (0, (0, parcelRequire("92ECu")).gqlTagGira)`
  query ParentIssueDetailsQuery($ari: ID!) {
    jira {
      issueById(id: $ari) {
        issueId
        key
        issueColorField {
          color {
            colorKey
          }
        }
        fieldsById(ids: ["summary", "issuetype", "status"]) {
          edges {
            node {
              __typename
              ... on JiraIssueTypeField {
                fieldId
                issueType {
                  issueTypeId
                  name
                  avatar {
                    xsmall
                  }
                }
              }
              ... on JiraSingleLineTextField {
                fieldId
                text
              }
              ... on JiraStatusField {
                fieldId
                status {
                  statusCategory {
                    statusCategoryId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
    async function $5c62f02a12edc836$export$ef5c4d73a6136d96(siteId, issueId) {
        try {
            const variables = {
                ari: (0, (0, parcelRequire("8S2Xh")).JiraIssueAri).create({
                    siteId: siteId,
                    issueId: issueId
                }).toString()
            };
            const { data: data } = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
                query: $5c62f02a12edc836$export$6ba84cffc20b9772,
                variables: variables,
                operationName: 'ParentIssueDetailsQuery'
            });
            return data;
        } catch (error) {
            throw new Error(`Error fetching data for parent issue with issueId "${issueId}"`, {
                cause: (0, $0b20d04e9212d44f$export$db8af5ee2c36776e)
            });
        }
    }
    const $5c62f02a12edc836$export$2b30e3fdda29f6 = (node)=>{
        const doneStatusCategoryId = (0, (0, parcelRequire("gULOk"))).StatusCategoryIds[(0, (0, parcelRequire("gULOk"))).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === node.status?.statusCategory?.statusCategoryId;
    };
});
parcelRegister("92ECu", function(module, exports) {
    $parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", ()=>$9387aa2a419a55f9$export$c46d621c29194aa4);
    $parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", ()=>$9387aa2a419a55f9$export$b2e398ce246f55b3);
    $parcel$export(module.exports, "gqlTagGira", ()=>$9387aa2a419a55f9$export$aeae6fc40846cf9f);
    const $9387aa2a419a55f9$export$c46d621c29194aa4 = 5;
    const $9387aa2a419a55f9$export$304a6c004edb30d8 = '-created';
    const $9387aa2a419a55f9$export$b2e398ce246f55b3 = 5;
    const $9387aa2a419a55f9$export$1c36ecc9afd61c73 = '-started';
    const $9387aa2a419a55f9$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
});
parcelRegister("iBOrg", function(module, exports) {
    $parcel$export(module.exports, "getClient", ()=>$3d6ab2890da8f9df$export$6bb76d6eba7e258c);
    var $7f4tk;
    var $fqpdr;
    const $3d6ab2890da8f9df$var$makeFetchClient = (baseUrl)=>({
            query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("fqpdr")).getGiraUrl)(baseUrl, operationName), {
                    method: 'POST',
                    body: JSON.stringify({
                        query: query,
                        variables: variables,
                        operationName: operationName
                    }),
                    signal: signal
                })
        });
    let $3d6ab2890da8f9df$var$client;
    const $3d6ab2890da8f9df$export$6bb76d6eba7e258c = (baseUrl)=>{
        if (!$3d6ab2890da8f9df$var$client) $3d6ab2890da8f9df$var$client = $3d6ab2890da8f9df$var$makeFetchClient(baseUrl);
        return $3d6ab2890da8f9df$var$client;
    };
});
parcelRegister("fqpdr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", ()=>$3789cf83eed10ddd$export$1780a132c0453fee);
    $parcel$export(module.exports, "getGiraUrl", ()=>$3789cf83eed10ddd$export$aefb19023b2eda55);
    $parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", ()=>$3789cf83eed10ddd$export$79eba9bf6dc9960d);
    $parcel$export(module.exports, "buildIssueQuery", ()=>$3789cf83eed10ddd$export$222ae9aca08830f0);
    $parcel$export(module.exports, "getGiraRequestOptions", ()=>$3789cf83eed10ddd$export$e1542dc7ff749de8);
    var $96nmc;
    var $EJMEI;
    var $8TkIN;
    var $e2Vt6;
    var $92ECu;
    var $6QL4r;
    var $5Pqa3;
    var $b1RJj;
    var $1HCMp;
    var $8JI9I;
    var $kNriQ;
    var $cRP2d;
    const $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING = '-created';
    const $3789cf83eed10ddd$export$1780a132c0453fee = 'issueViewInteractiveQuery';
    const $3789cf83eed10ddd$export$aefb19023b2eda55 = (_baseUrl, operation)=>`/rest/gira/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $3789cf83eed10ddd$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        canCreateSubTask
        canExportIssue
        ${(0, (0, parcelRequire("EJMEI")).default)({
            maxResults: (0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD),
            startAt: 0,
            orderBy: $3789cf83eed10ddd$var$CREATED_ORDER_DESCENDING,
            commentAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_COMMENTS_TO_LOAD)),
            hydrateData: false
        })}
        ${(0, (0, parcelRequire("cRP2d")).default)({
            startAt: 0,
            worklogAmount: Math.floor((0, (0, parcelRequire("92ECu")).NUM_INITIAL_WORKLOGS_TO_LOAD))
        })}
        ${(0, (0, parcelRequire("e2Vt6")).getEcosystemQuery)()}
        ${(0, (0, parcelRequire("8TkIN")).getContentPanelsQuery)()}
        ${(0, (0, parcelRequire("e2Vt6")).getLegacyRightWebPanelsQuery)()}
        totalAttachmentsCount
        ${(0, (0, parcelRequire("5Pqa3")).getContainersByTypeQuery)()}
        ${(0, (0, parcelRequire("kNriQ")).getRemoteLinksQuery)()}
    }
`;
    const $3789cf83eed10ddd$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
    const $3789cf83eed10ddd$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
    const $3789cf83eed10ddd$export$222ae9aca08830f0 = ()=>`
query ${$3789cf83eed10ddd$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$3789cf83eed10ddd$export$58eaa2ae4a5a410a()}
        ${(0, (0, parcelRequire("b1RJj")).default)()}
        ${$3789cf83eed10ddd$var$viewIssueQuery()}
        ${(0, (0, parcelRequire("6QL4r")).getJiraSettingsQuery)()}
        ${(0, (0, parcelRequire("1HCMp")).default)()}
        ${(0, (0, parcelRequire("8JI9I")).default)()}
    }

`;
    const $3789cf83eed10ddd$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
        const payload = {
            operationName: $3789cf83eed10ddd$export$1780a132c0453fee,
            query: $3789cf83eed10ddd$export$222ae9aca08830f0(),
            variables: {
                issueKey: issueKey,
                projectKey: projectKey
            }
        };
        return {
            method: 'POST',
            body: JSON.stringify(payload)
        };
    };
});
parcelRegister("96nmc", function(module, exports) {
    $parcel$export(module.exports, "appendOperationQuery", ()=>$8119dcf59ebfcad5$export$69694c3add0f6058);
    const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';
});
parcelRegister("EJMEI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01ae9b8d951a6992$export$2e2bcd8739ae039);
    var $4R6GH;
    var $6tI1D;
    var $9F91P;
    var $01ae9b8d951a6992$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount, hydrateData: hydrateData = true })=>{
        const commentPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).COMMENTS));
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
        const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
        const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
        const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jiv-14067-issue-details-agg-migration-comments') && !(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-14530-comments-consistency-check') && !hydrateData) return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
            startIndex
        }
    `;
        return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, (0, parcelRequire("9F91P")).isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("6tI1D", function(module, exports) {
    $parcel$export(module.exports, "COMMENTS", ()=>$ac458c74e4b12b29$export$4cab9dfa8fc858f4);
    $parcel$export(module.exports, "WORKLOG", ()=>$ac458c74e4b12b29$export$df36fc05622c402);
    $parcel$export(module.exports, "getAllUrlParams", ()=>$ac458c74e4b12b29$export$dca91ad250f6b082);
    $parcel$export(module.exports, "getPermalinkId", ()=>$ac458c74e4b12b29$export$bf42dbba4c31080e);
    var $dJl1T;
    const $ac458c74e4b12b29$export$b18d061fc042df1a = {
        COMMENTS: 'focusedCommentId',
        WORKLOG: 'focusedWorklogId'
    };
    const $ac458c74e4b12b29$export$4cab9dfa8fc858f4 = 'COMMENTS';
    const $ac458c74e4b12b29$export$df36fc05622c402 = 'WORKLOG';
    const $ac458c74e4b12b29$export$dca91ad250f6b082 = ()=>{
        let queryString = window.location.search.slice(1);
        const obj = {};
        if (queryString) {
            queryString = queryString.split('#')[0];
            const arr = queryString.split('&');
            for(let i = 0; i < arr.length; i += 1){
                const a = arr[i].split('=');
                const paramName = a[0];
                try {
                    const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                    obj[paramName] = paramValue;
                } catch (error) {
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
                }
            }
        }
        return obj;
    };
    const $ac458c74e4b12b29$export$bf42dbba4c31080e = (targetPermalinkType)=>{
        if (!$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]) return null;
        const urlParams = $ac458c74e4b12b29$export$dca91ad250f6b082();
        return urlParams[$ac458c74e4b12b29$export$b18d061fc042df1a[targetPermalinkType]];
    };
});
parcelRegister("9F91P", function(module, exports) {
    $parcel$export(module.exports, "isJsmTimelineEnabled", ()=>$38d603c6864a4cb1$export$575e1bf822db15b5);
    var $f9Owr;
    const $38d603c6864a4cb1$export$575e1bf822db15b5 = ()=>(0, (0, parcelRequire("f9Owr")).ff)('jsm-timelines-phase-2_70gja', false);
});
parcelRegister("8TkIN", function(module, exports) {
    $parcel$export(module.exports, "getContentPanelsQuery", ()=>$09fdc8c72c341092$export$e6f14eac549b679d);
    const $09fdc8c72c341092$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
    const $09fdc8c72c341092$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$09fdc8c72c341092$var$getContentPanelNode()}
            }
        }
    }
`;
    const $09fdc8c72c341092$export$e6f14eac549b679d = ()=>`
    ${$09fdc8c72c341092$var$getContentPanelsConnectionQuery()}
    ${$09fdc8c72c341092$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;
});
parcelRegister("e2Vt6", function(module, exports) {
    $parcel$export(module.exports, "getEcosystemQuery", ()=>$1771eed42c62eeca$export$edefef8c65e08bd2);
    $parcel$export(module.exports, "getLegacyRightWebPanelsQuery", ()=>$1771eed42c62eeca$export$92c9a3dc7076af51);
    var $f9Owr;
    const $1771eed42c62eeca$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
    const $1771eed42c62eeca$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, (0, parcelRequire("f9Owr")).ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$1771eed42c62eeca$var$getForgeQuery()}
    }
`;
    const $1771eed42c62eeca$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
});
parcelRegister("6QL4r", function(module, exports) {
    $parcel$export(module.exports, "getJiraSettingsQuery", ()=>$10470e592ba8e782$export$191f50c0f86b85ec);
    const $10470e592ba8e782$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
    const $10470e592ba8e782$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
    const $10470e592ba8e782$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;
});
parcelRegister("5Pqa3", function(module, exports) {
    $parcel$export(module.exports, "getContainersByTypeQuery", ()=>$85e2f5a62f1697d1$export$63131b2831854cc);
    const $85e2f5a62f1697d1$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;
});
parcelRegister("b1RJj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42429f0fa15c54ae$export$2e2bcd8739ae039);
    var $9wuCE;
    var $42429f0fa15c54ae$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, (0, parcelRequire("9wuCE")).getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;
});
parcelRegister("9wuCE", function(module, exports) {
    $parcel$export(module.exports, "getMaxTokenLength", ()=>$ebb491dcc11e8362$export$e40f2acaf1a50b00);
    const $ebb491dcc11e8362$var$nonIE11MaxTokenLength = 2 ** 16;
    const $ebb491dcc11e8362$export$e40f2acaf1a50b00 = ()=>$ebb491dcc11e8362$var$nonIE11MaxTokenLength;
});
parcelRegister("1HCMp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea17df757c74c46$export$2e2bcd8739ae039);
    var $co1wz;
    const $0ea17df757c74c46$export$9fc40cb6f3529ef = ()=>[
            'ADMINISTER_PROJECTS',
            'ASSIGN_ISSUES',
            'EDIT_ISSUES',
            'SCHEDULE_ISSUES',
            'ADD_COMMENTS',
            'DELETE_ALL_COMMENTS',
            'DELETE_OWN_COMMENTS',
            'EDIT_ALL_COMMENTS',
            'EDIT_OWN_COMMENTS',
            'CREATE_ISSUES',
            'DELETE_ISSUES',
            'MOVE_ISSUES',
            'MODIFY_REPORTER',
            'CREATE_ATTACHMENTS',
            'DELETE_ALL_ATTACHMENTS',
            'DELETE_OWN_ATTACHMENTS',
            'WORK_ON_ISSUES',
            'ASSIGNABLE_USER',
            'LINK_ISSUES',
            'VIEW_VOTERS_AND_WATCHERS',
            'MANAGE_WATCHERS',
            'EDIT_ALL_WORKLOGS',
            'EDIT_OWN_WORKLOGS',
            'DELETE_ALL_WORKLOGS',
            'DELETE_OWN_WORKLOGS',
            'VIEW_DEV_TOOLS',
            'SERVICEDESK_AGENT',
            'RESOLVE_ISSUES',
            'CLONE_ISSUE'
        ];
    const $0ea17df757c74c46$export$f5ff20e9116b53bc = ()=>{
        const permissionKeysForArchival = [
            'ARCHIVE_ISSUES',
            'UNARCHIVE_ISSUES'
        ];
        const permissionKeys = $0ea17df757c74c46$export$9fc40cb6f3529ef();
        if (!(0, (0, parcelRequire("co1wz")).ff)('issue-unarchival_wdpb9')) return permissionKeys;
        return [
            ...permissionKeys,
            ...permissionKeysForArchival
        ];
    };
    var $0ea17df757c74c46$export$2e2bcd8739ae039 = ()=>`

    permissions(issueKey:$issueKey, keys:["${$0ea17df757c74c46$export$f5ff20e9116b53bc().join('","')}"]) {
        key
        havePermission
    }
`;
});
parcelRegister("8JI9I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2232e63ddd04bbb1$export$2e2bcd8739ae039);
    var $2232e63ddd04bbb1$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;
});
parcelRegister("kNriQ", function(module, exports) {
    $parcel$export(module.exports, "getRemoteLinksQuery", ()=>$e19ca26272d1dd4d$export$6bbc6b72b0b57f25);
    const $e19ca26272d1dd4d$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;
});
parcelRegister("cRP2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$354b7c85b873ab44$export$2e2bcd8739ae039);
    var $6tI1D;
    var $354b7c85b873ab44$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
        const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
        const worklogPermalinkId = (0, (0, parcelRequire("6tI1D")).getPermalinkId)((0, (0, parcelRequire("6tI1D")).WORKLOG));
        if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
        const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
        const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
        return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
    };
});
parcelRegister("kNR0c", function(module, exports) {
    $parcel$export(module.exports, "peopleSetValueValidator", ()=>$27b85d932c2790f6$export$b553dcd60e54b2da);
    $parcel$export(module.exports, "peopleSetValueTransformer", ()=>$27b85d932c2790f6$export$6262031046230bac);
    $parcel$export(module.exports, "peopleGetValueTransformer", ()=>$27b85d932c2790f6$export$34e69b3ea0fd6308);
    var $iyelu;
    var $dHHVN;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $27b85d932c2790f6$export$b553dcd60e54b2da = (value)=>Array.isArray(value) && value.every((userId)=>(0, (0, parcelRequire("cpl2T")).isNotEmptyString)(userId) && (0, (0, parcelRequire("dHHVN")).isNotAutomaticId)(userId));
    const $27b85d932c2790f6$export$6262031046230bac = (value, lookupValues)=>{
        if (!value.length) return [];
        const filteredLookupValues = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(value, lookupValues, 'accountId');
        if (value.length !== filteredLookupValues.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(value, filteredLookupValues, 'accountId');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
                id: id,
                name: name,
                avatarUrl: avatarUrl
            }));
    };
    const $27b85d932c2790f6$export$34e69b3ea0fd6308 = (value)=>{
        if (!value) return [];
        const valueArray = Array.isArray(value) ? value : [
            value
        ];
        return valueArray.map(({ id: accountId })=>({
                accountId: accountId
            }));
    };
});
parcelRegister("echHY", function(module, exports) {
    $parcel$export(module.exports, "transformPrioritySetOptionsVisibility", ()=>$6a918f4f260599f3$export$722da4484009d687);
    $parcel$export(module.exports, "transformPriorityGetOptionsVisibility", ()=>$6a918f4f260599f3$export$3cc1c0d9b27ad517);
    $parcel$export(module.exports, "prioritySetValueTransformer", ()=>$6a918f4f260599f3$export$c6ef424ead917b72);
    $parcel$export(module.exports, "transformPriorityGetValue", ()=>$6a918f4f260599f3$export$95a791a89befdf91);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $frwJc;
    const $6a918f4f260599f3$export$722da4484009d687 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $6a918f4f260599f3$export$3cc1c0d9b27ad517 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $6a918f4f260599f3$export$c6ef424ead917b72 = (value, lookupValues)=>{
        const lookupValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, lookupValues, 'id');
        if (!lookupValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            label: lookupValue.name,
            value: lookupValue.id,
            iconUrl: lookupValue.iconUrl
        };
    };
    const $6a918f4f260599f3$export$95a791a89befdf91 = (priority)=>{
        if (!priority) return null;
        const { label: label, value: value, iconUrl: iconUrl } = priority;
        return {
            name: label,
            id: value,
            iconUrl: iconUrl
        };
    };
});
parcelRegister("9bTKH", function(module, exports) {
    $parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", ()=>$b8c8c73851b6870b$export$825e2dc660c855a0);
    $parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", ()=>$b8c8c73851b6870b$export$149e6a6e5e31219);
    $parcel$export(module.exports, "radioButtonsSetValueTransformer", ()=>$b8c8c73851b6870b$export$d23713245ea192a9);
    $parcel$export(module.exports, "radioButtonsGetValueTransformer", ()=>$b8c8c73851b6870b$export$624bfe758f4ad3c6);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $frwJc;
    const $b8c8c73851b6870b$export$825e2dc660c855a0 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $b8c8c73851b6870b$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $b8c8c73851b6870b$export$d23713245ea192a9 = (value, allowedValues)=>{
        if (value === null) return null;
        const foundValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, allowedValues, 'id');
        if (!foundValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            value: foundValue.id,
            label: foundValue.value
        };
    };
    const $b8c8c73851b6870b$export$624bfe758f4ad3c6 = (value)=>{
        if (!value) return null;
        const { label: label, value: id } = value;
        return {
            id: id,
            value: label
        };
    };
});
parcelRegister("7ZP8L", function(module, exports) {
    $parcel$export(module.exports, "reporterSetValueTransformer", ()=>$08c5334065401b8b$export$610accc7edd3f281);
    $parcel$export(module.exports, "reporterGetValueTransformer", ()=>$08c5334065401b8b$export$2c1706dd36f54bb3);
    var $iyelu;
    var $frwJc;
    const $08c5334065401b8b$export$610accc7edd3f281 = (value, lookupValues)=>{
        if (value === null) return null;
        const foundValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, lookupValues, 'accountId');
        if (!foundValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            id: foundValue.accountId,
            name: foundValue.name,
            avatarUrl: foundValue.picture
        };
    };
    const $08c5334065401b8b$export$2c1706dd36f54bb3 = (value)=>{
        if (!value) return null;
        const { id: accountId } = value;
        return {
            accountId: accountId
        };
    };
});
parcelRegister("fPEV6", function(module, exports) {
    $parcel$export(module.exports, "transformSelectSetOptionsVisibility", ()=>$ba46be9263a3175c$export$81990085f8ab114b);
    $parcel$export(module.exports, "transformSelectGetOptionsVisibility", ()=>$ba46be9263a3175c$export$7c7ca81813eb0f65);
    $parcel$export(module.exports, "selectSetValueTransformer", ()=>$ba46be9263a3175c$export$136c42b919fdec83);
    $parcel$export(module.exports, "selectGetValueTransformer", ()=>$ba46be9263a3175c$export$fd4db924c90bd0e2);
    var $iyelu;
    var $6aU71;
    var $nQYm2;
    var $frwJc;
    const $ba46be9263a3175c$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("6aU71")).applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $ba46be9263a3175c$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, (0, parcelRequire("nQYm2")).getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
    const $ba46be9263a3175c$export$136c42b919fdec83 = (value, allowedValues)=>{
        if (value === null) return null;
        const foundValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, allowedValues, 'id');
        if (!foundValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            value: foundValue.id,
            label: foundValue.value
        };
    };
    const $ba46be9263a3175c$export$fd4db924c90bd0e2 = (value)=>{
        if (!value) return null;
        const { label: label, value: id } = value;
        return {
            id: id,
            value: label
        };
    };
});
parcelRegister("2AQeg", function(module, exports) {
    $parcel$export(module.exports, "singleLineTextFieldSetValueValidator", ()=>$38b42e3ace3040e7$export$e0269944af4481cc);
    $parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", ()=>$38b42e3ace3040e7$export$161c77b6b09fc494);
    const $38b42e3ace3040e7$export$e0269944af4481cc = (value)=>typeof value === 'string';
    const $38b42e3ace3040e7$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';
});
parcelRegister("lK4Eh", function(module, exports) {
    $parcel$export(module.exports, "userPickerSetValueTransformer", ()=>$a7314ca0000b10b6$export$890d33cc39835486);
    $parcel$export(module.exports, "userPickerGetValueTransformer", ()=>$a7314ca0000b10b6$export$e87b0f36be178543);
    var $iyelu;
    var $frwJc;
    const $a7314ca0000b10b6$export$890d33cc39835486 = (value, lookupValues)=>{
        if (value === null) return null;
        const foundValue = (0, (0, parcelRequire("frwJc")).singleValueLookup)(value, lookupValues, 'accountId');
        if (!foundValue) throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)();
        return {
            id: foundValue.accountId,
            name: foundValue.name,
            avatarUrl: foundValue.picture
        };
    };
    const $a7314ca0000b10b6$export$e87b0f36be178543 = (value)=>{
        if (!value) return null;
        const { id: accountId } = value;
        return {
            accountId: accountId
        };
    };
});
parcelRegister("ibFp9", function(module, exports) {
    $parcel$export(module.exports, "fixVersionsSetValueValidator", ()=>$15216c199cee160c$export$423303d5750f732c);
    $parcel$export(module.exports, "transformVersionsSetValue", ()=>$15216c199cee160c$export$5706ac863a06e5ed);
    $parcel$export(module.exports, "transformVersionsGetValue", ()=>$15216c199cee160c$export$360c4edb055d9cb4);
    $parcel$export(module.exports, "versionsRequiredScopes", ()=>$15216c199cee160c$export$60db61c485973ad9);
    var $iyelu;
    var $5CqLP;
    var $9mqRh;
    var $cpl2T;
    var $fwvEZ;
    const $15216c199cee160c$export$423303d5750f732c = (value)=>Array.isArray(value) && value.every((0, (0, parcelRequire("cpl2T")).isNotEmptyString));
    const $15216c199cee160c$export$5706ac863a06e5ed = (values, lookupValues)=>{
        if (!values.length) return [];
        const filteredLookupValues = (0, (0, parcelRequire("fwvEZ")).multiValueLookup)(values, lookupValues, 'id');
        if (values.length !== filteredLookupValues.length) {
            const notFoundValues = (0, (0, parcelRequire("9mqRh")).getValueLookupValuesDiff)(values, filteredLookupValues, 'id');
            throw new (0, (0, parcelRequire("iyelu")).FieldValueLookupError)(notFoundValues.join());
        }
        return filteredLookupValues.map(({ name: name, id: id })=>({
                label: name,
                value: id
            }));
    };
    const $15216c199cee160c$export$360c4edb055d9cb4 = (internalValue)=>{
        if (!internalValue) return [];
        return internalValue.map(({ value: value, label: label })=>({
                id: value,
                name: label
            }));
    };
    const $15216c199cee160c$export$60db61c485973ad9 = {
        ...(0, (0, parcelRequire("5CqLP")).versionsRequiredScopes),
        granular: [
            ...(0, (0, parcelRequire("5CqLP")).versionsRequiredScopes).granular,
            'write:field.default-value:jira'
        ]
    };
});
parcelRegister("9icMi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81653562247c03af$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81653562247c03af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        obligatoryUimGicConsentMessage: {
            "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message",
            "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this issue."
        }
    });
});
parcelRegister("c9aLX", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsEntryPoint", ()=>$6a0a573c5ab6bbf9$export$c89b83ae4e6840b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $4R6GH;
    var $bPtOr;
    var $mTNgq;
    var $kforA;
    var $5fc53;
    var $iuQ6D;
    var $4FeER;
    const $6a0a573c5ab6bbf9$var$UiModificationsEntryPointLoaded = ({ issueTypeFieldType: issueTypeFieldType, modules: modules, modalFieldConfig: modalFieldConfig, resetFormFieldsCounter: resetFormFieldsCounter, selectedIssueType: selectedIssueType, selectedProject: selectedProject, triggerPointKey: triggerPointKey })=>{
        const issueAdjustmentsContext = (0, $5uXOq.useMemo)(()=>{
            if (selectedProject && selectedIssueType) return {
                project: {
                    id: selectedProject.value,
                    key: selectedProject.projectKey,
                    type: selectedProject.projectType,
                    isSimplified: selectedProject.isSimplified
                },
                issueType: {
                    id: selectedIssueType.value,
                    name: selectedIssueType.label
                }
            };
            return null;
        }, [
            selectedIssueType,
            selectedProject
        ]);
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                issueAdjustmentsContext: issueAdjustmentsContext,
                fieldsCount: (0, (0, parcelRequire("4FeER")).getSupportedFieldsCount)({
                    ...modalFieldConfig,
                    [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: {
                        fieldType: issueTypeFieldType
                    }
                }),
                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                resetFormFieldsCounter: resetFormFieldsCounter,
                modules: modules
            }), [
            issueAdjustmentsContext,
            issueTypeFieldType,
            modalFieldConfig,
            modules,
            resetFormFieldsCounter
        ]);
        if (!issueAdjustmentsContext) return null;
        if ((0, (0, parcelRequire("4R6GH")).fg)('uim_tenant_context_as_a_props')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuQ6D")).UiModificationsJiraCore), {
            triggerPointKey: triggerPointKey,
            runtimeProps: runtimeProps,
            containerId: "uiModifications",
            containerPackageName: "jiraUiModificationsViewGic"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kforA")).IssueAdjustmentsAsyncOld), {
            containerId: "uiModifications",
            containerPackageName: "jiraUiModificationsViewGic",
            runtimeProps: runtimeProps,
            triggerPointKey: triggerPointKey
        });
    };
    const $6a0a573c5ab6bbf9$export$c89b83ae4e6840b3 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "uiModifications",
            packageName: "jiraUiModificationsViewGic",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null),
            attributes: (error)=>({
                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                    viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715)
                }),
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6a0a573c5ab6bbf9$var$UiModificationsEntryPointLoaded, props));
});
parcelRegister("mTNgq", function(module, exports) {
    $parcel$export(module.exports, "IssueAdjustmentsErrorHandler", ()=>$f3c77fc718edb938$export$68b86a282e98ff70);
    var $5uXOq = parcelRequire("5uXOq");
    var $asu2W;
    const $f3c77fc718edb938$export$68b86a282e98ff70 = ()=>{
        const { setError: setError, resetError: resetError } = (0, (0, parcelRequire("asu2W")).useIssueAdjustmentsActions)();
        (0, $5uXOq.useEffect)(()=>{
            setError({
                errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
            });
            return ()=>resetError();
        }, [
            setError,
            resetError
        ]);
        return null;
    };
});
parcelRegister("kforA", function(module, exports) {
    $parcel$export(module.exports, "IssueAdjustmentsAsyncOld", ()=>$f2ace92846c43014$export$f4bc37e3cbdf5033);
    $parcel$export(module.exports, "IssueAdjustmentsAsync", ()=>$f2ace92846c43014$export$e2efea28577ab138);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $7XluA;
    var $4mO32;
    var $bPtOr;
    var $laCJ2;
    var $iPR37;
    var $d9r6K;
    var $aFWQF;
    var $mTNgq;
    const $f2ace92846c43014$export$84b9ffa7ecdfad72 = ()=>()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null);
    const $f2ace92846c43014$var$STABLE_EMPTY_OBJECT = {};
    const $f2ace92846c43014$export$f4bc37e3cbdf5033 = ({ containerId: containerId, containerPackageName: containerPackageName, runtimeProps: runtimeProps, triggerPointKey: triggerPointKey, errorFallback: errorFallback })=>{
        const { issueAdjustmentsContext: issueAdjustmentsContext, modules: modules, viewType: viewType } = runtimeProps;
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aFWQF")).issueAdjustmentsEntryPoint), $f2ace92846c43014$var$STABLE_EMPTY_OBJECT);
        const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, (0, parcelRequire("laCJ2")).useAdjustmentsContextActions)();
        const defaultErrorFallback = $f2ace92846c43014$export$84b9ffa7ecdfad72();
        const hasUiModificationsLoaded = (0, $5uXOq.useRef)(false);
        const shouldUiModificationsLoad = modules?.length > 0 && (0, (0, parcelRequire("d9r6K")).isTriggerPointSupported)(viewType, triggerPointKey) && (0, (0, parcelRequire("d9r6K")).isProjectTypeSupported)(issueAdjustmentsContext.project, viewType);
        (0, $5uXOq.useEffect)(()=>{
            const hasProjectAndIssueTypeFinishedLoading = issueAdjustmentsContext !== null;
            if (hasProjectAndIssueTypeFinishedLoading) setShouldUiModificationsLoad(shouldUiModificationsLoad ? 'yes' : 'no');
            if (shouldUiModificationsLoad && !hasUiModificationsLoaded.current) {
                entryPointActions.load();
                hasUiModificationsLoaded.current = true;
            }
        }, [
            issueAdjustmentsContext,
            shouldUiModificationsLoad,
            setShouldUiModificationsLoad,
            entryPointActions
        ]);
        if (shouldUiModificationsLoad) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    triggerPointKey: triggerPointKey
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: containerId,
            packageName: containerPackageName,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            errorFallback: errorFallback || defaultErrorFallback,
            errorAttributes: (error)=>({
                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                    viewType: runtimeProps.viewType
                }),
            runtimeProps: runtimeProps
        }));
        return null;
    };
    const $f2ace92846c43014$export$e2efea28577ab138 = ({ containerId: containerId, containerPackageName: containerPackageName, runtimeProps: runtimeProps, triggerPointKey: triggerPointKey, errorFallback: errorFallback, cloudId: cloudId, activationId: activationId })=>{
        const { issueAdjustmentsContext: issueAdjustmentsContext, modules: modules, viewType: viewType } = runtimeProps;
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("aFWQF")).issueAdjustmentsEntryPoint), $f2ace92846c43014$var$STABLE_EMPTY_OBJECT);
        const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, (0, parcelRequire("laCJ2")).useAdjustmentsContextActions)();
        const defaultErrorFallback = $f2ace92846c43014$export$84b9ffa7ecdfad72();
        const hasUiModificationsLoaded = (0, $5uXOq.useRef)(false);
        const shouldUiModificationsLoad = modules?.length > 0 && (0, (0, parcelRequire("d9r6K")).isTriggerPointSupported)(viewType, triggerPointKey) && (0, (0, parcelRequire("d9r6K")).isProjectTypeSupported)(issueAdjustmentsContext.project, viewType);
        (0, $5uXOq.useEffect)(()=>{
            const hasProjectAndIssueTypeFinishedLoading = issueAdjustmentsContext !== null;
            if (hasProjectAndIssueTypeFinishedLoading) setShouldUiModificationsLoad(shouldUiModificationsLoad ? 'yes' : 'no');
            if (shouldUiModificationsLoad && !hasUiModificationsLoaded.current) {
                entryPointActions.load();
                hasUiModificationsLoaded.current = true;
            }
        }, [
            issueAdjustmentsContext,
            shouldUiModificationsLoad,
            setShouldUiModificationsLoad,
            entryPointActions
        ]);
        const tenantContext = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                activationId: activationId
            }), [
            cloudId,
            activationId
        ]);
        if (shouldUiModificationsLoad) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                attributes: {
                    triggerPointKey: triggerPointKey
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iPR37")).TenantContextProvider), {
            value: tenantContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: containerId,
            packageName: containerPackageName,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null),
            errorFallback: errorFallback || defaultErrorFallback,
            errorAttributes: (error)=>({
                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                    viewType: runtimeProps.viewType
                }),
            runtimeProps: runtimeProps
        })));
        return null;
    };
});
parcelRegister("iPR37", function(module, exports) {
    $parcel$export(module.exports, "useTenantContext", ()=>$176d8d21a7454452$export$28e7c557f4d454d9);
    $parcel$export(module.exports, "TenantContextProvider", ()=>$176d8d21a7454452$export$e32355e80a92030c);
    var $5uXOq = parcelRequire("5uXOq");
    const $176d8d21a7454452$var$TenantContext = (0, $5uXOq.createContext)(null);
    const $176d8d21a7454452$export$28e7c557f4d454d9 = ()=>{
        const tenantContext = (0, $5uXOq.useContext)($176d8d21a7454452$var$TenantContext);
        if (tenantContext === null) throw new Error('tenantContext value is null');
        return tenantContext;
    };
    const $176d8d21a7454452$export$e32355e80a92030c = ({ children: children, value: value })=>{
        if (!value) throw new Error('TenantContextProvider requires a value');
        return (0, ($parcel$interopDefault($5uXOq))).createElement($176d8d21a7454452$var$TenantContext.Provider, {
            value: value
        }, children);
    };
});
parcelRegister("aFWQF", function(module, exports) {
    $parcel$export(module.exports, "issueAdjustmentsEntryPoint", ()=>$383bdd6a4ae55fe2$export$4e091e70f9620cd8);
    var $eufEc;
    var $fEDBv;
    const $383bdd6a4ae55fe2$export$4e091e70f9620cd8 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("8RRX6")), {
            moduleId: "45466920"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("8RRX6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j0SSk").then(()=>parcelRequire('bg3aH'));
});
parcelRegister("iuQ6D", function(module, exports) {
    $parcel$export(module.exports, "UiModificationsJiraCore", ()=>$bedee6f4d69151e0$export$605353dffa116f09);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $kforA;
    var $fjcgS;
    var $fY39E;
    var $koeKL;
    var $10UkC;
    const $bedee6f4d69151e0$export$605353dffa116f09 = (props)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const activationId = (0, (0, parcelRequire("fY39E")).useActivationId)();
        if ((0, (0, parcelRequire("4R6GH")).fg)('analytics-replace-jira-packages')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("10UkC")).AnalyticsListener), {
            analyticsWebClient: (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kforA")).IssueAdjustmentsAsync), {
            ...props,
            cloudId: cloudId,
            activationId: activationId
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kforA")).IssueAdjustmentsAsync), {
            ...props,
            cloudId: cloudId,
            activationId: activationId
        });
    };
});
parcelRegister("10UkC", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsListener", ()=>$5a540f0874acf87c$export$22edec767217cd60);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvUB1;
    var $kCVub;
    const $5a540f0874acf87c$export$7329bcdc3edcd90e = (event, client)=>{
        switch(event.type){
            case 0, $6e65040b988c460f$export$12346a674644c156:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $6e65040b988c460f$export$947dac6c72b26f81:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
        }
    };
    const $5a540f0874acf87c$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
            const eventData = (0, (0, parcelRequire("kCVub")).extractAWCDataFromEvent)(event);
            $5a540f0874acf87c$export$7329bcdc3edcd90e({
                type: eventData.type,
                ...eventData.payload
            }, analyticsWebClient);
        };
    const $5a540f0874acf87c$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
        const onEvent = (0, $5uXOq.useMemo)(()=>$5a540f0874acf87c$export$eee20638634729b3(analyticsWebClient), [
            analyticsWebClient
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvUB1")).default), {
            onEvent: onEvent,
            channel: (0, $aded369bac156944$export$8280e5c6104c5b40)
        }, children);
    };
});
parcelRegister("kCVub", function(module, exports) {
    $parcel$export(module.exports, "extractAWCDataFromEvent", ()=>$d006147c8436533b$export$1c850cf68c053906);
    var $cjFoH = parcelRequire("cjFoH");
    var $9xWGk = parcelRequire("9xWGk");
    var $8HgKr;
    const $d006147c8436533b$export$1c850cf68c053906 = (event)=>{
        const castedEvent = event;
        const analyticsType = (0, (0, parcelRequire("8HgKr")).getAnalyticsType)(castedEvent);
        const attributes = (0, (0, parcelRequire("8HgKr")).getAttributes)(castedEvent);
        const source = (0, (0, parcelRequire("8HgKr")).getSource)(castedEvent);
        const actionSubject = (0, (0, parcelRequire("8HgKr")).getActionSubject)(castedEvent);
        if (analyticsType === (0, $6e65040b988c460f$export$f1d537d508d2945a)) return {
            type: (0, $6e65040b988c460f$export$f1d537d508d2945a),
            payload: {
                name: source,
                attributes: attributes
            }
        };
        switch(analyticsType){
            case 0, $6e65040b988c460f$export$a1562d08625f5d7e:
            case 0, $6e65040b988c460f$export$947dac6c72b26f81:
            case 0, $6e65040b988c460f$export$12346a674644c156:
                {
                    const action = (0, (0, parcelRequire("8HgKr")).getAction)(castedEvent);
                    const actionSubjectId = (0, (0, parcelRequire("8HgKr")).getActionSubjectId)(castedEvent);
                    const containerId = (0, (0, parcelRequire("8HgKr")).getContainerId)(castedEvent);
                    const containerType = (0, (0, parcelRequire("8HgKr")).getContainerType)(castedEvent);
                    const objectId = (0, (0, parcelRequire("8HgKr")).getObjectId)(castedEvent);
                    const objectType = (0, (0, parcelRequire("8HgKr")).getObjectType)(castedEvent);
                    const tags = (0, (0, parcelRequire("8HgKr")).getTags)(castedEvent);
                    return {
                        type: analyticsType,
                        payload: (0, ($parcel$interopDefault($9xWGk)))({
                            action: action,
                            actionSubject: actionSubject,
                            actionSubjectId: actionSubjectId,
                            source: source,
                            tags: tags,
                            containerType: containerType,
                            containerId: containerId,
                            objectType: objectType,
                            objectId: objectId,
                            attributes: attributes
                        }, (0, ($parcel$interopDefault($cjFoH))))
                    };
                }
            default:
                return {
                    payload: {
                        source: source,
                        actionSubject: actionSubject,
                        attributes: attributes
                    },
                    type: undefined
                };
        }
    };
});
parcelRegister("8HgKr", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsType", ()=>$6831e52439d2a9a2$export$a3569ac53b82a914);
    $parcel$export(module.exports, "getAttributes", ()=>$6831e52439d2a9a2$export$fe94072fee8a6976);
    $parcel$export(module.exports, "getSource", ()=>$6831e52439d2a9a2$export$dd2b6e807fb37ba3);
    $parcel$export(module.exports, "getActionSubject", ()=>$6831e52439d2a9a2$export$6f40cdf6d42c018d);
    $parcel$export(module.exports, "getAction", ()=>$6831e52439d2a9a2$export$6ca3170acb89054);
    $parcel$export(module.exports, "getActionSubjectId", ()=>$6831e52439d2a9a2$export$b6f8db3ad0711b02);
    $parcel$export(module.exports, "getContainerId", ()=>$6831e52439d2a9a2$export$7c8178cc9001d237);
    $parcel$export(module.exports, "getContainerType", ()=>$6831e52439d2a9a2$export$acc6f3e19803b3dc);
    $parcel$export(module.exports, "getObjectId", ()=>$6831e52439d2a9a2$export$fa986b91291934c7);
    $parcel$export(module.exports, "getObjectType", ()=>$6831e52439d2a9a2$export$11cc42aebef2ef3a);
    $parcel$export(module.exports, "getTags", ()=>$6831e52439d2a9a2$export$af63d7414243dad3);
    var $183uB = parcelRequire("183uB");
    var $cjFoH = parcelRequire("cjFoH");
    var $hYfgW = parcelRequire("hYfgW");
    var $1UikQ = parcelRequire("1UikQ");
    var $9xWGk = parcelRequire("9xWGk");
    var $kGsr8 = parcelRequire("kGsr8");
    const $6831e52439d2a9a2$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
    const $6831e52439d2a9a2$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
    const $6831e52439d2a9a2$export$fe94072fee8a6976 = (event)=>{
        const contextAttributes = $6831e52439d2a9a2$var$extractFromContext(event, 'attributes');
        const payloadAttributes = event.payload.attributes;
        const allAttributes = (0, ($parcel$interopDefault($1UikQ)))(contextAttributes.reduce((result, extraAttributes)=>(0, ($parcel$interopDefault($1UikQ)))(result, extraAttributes), {}), payloadAttributes);
        const sources = $6831e52439d2a9a2$var$extractFromContext(event, 'source');
        const namespaces = sources.filter(Boolean).join('.');
        return (0, ($parcel$interopDefault($9xWGk)))({
            ...allAttributes,
            namespaces: namespaces
        }, (0, ($parcel$interopDefault($cjFoH))));
    };
    const $6831e52439d2a9a2$export$dd2b6e807fb37ba3 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'source').filter(Boolean));
    const $6831e52439d2a9a2$export$6f40cdf6d42c018d = (event)=>{
        const { actionSubject: actionSubject } = event.payload;
        if (actionSubject) return actionSubject;
        const component = (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'component').filter(Boolean)) || (0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'componentName').filter(Boolean));
        return component;
    };
    const $6831e52439d2a9a2$export$6ca3170acb89054 = (event)=>event.payload.action;
    const $6831e52439d2a9a2$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
    const $6831e52439d2a9a2$export$7c8178cc9001d237 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerId').filter(Boolean));
    const $6831e52439d2a9a2$export$acc6f3e19803b3dc = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'containerType').filter(Boolean));
    const $6831e52439d2a9a2$export$fa986b91291934c7 = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectId').filter(Boolean));
    const $6831e52439d2a9a2$export$11cc42aebef2ef3a = (event)=>(0, ($parcel$interopDefault($hYfgW)))($6831e52439d2a9a2$var$extractFromContext(event, 'objectType').filter(Boolean));
    const $6831e52439d2a9a2$export$af63d7414243dad3 = (event)=>{
        const tags = (0, ($parcel$interopDefault($kGsr8)))((0, ($parcel$interopDefault($183uB)))($6831e52439d2a9a2$var$extractFromContext(event, 'tags'))).filter(Boolean);
        return tags.length ? tags : undefined;
    };
});
parcelRegister("4FeER", function(module, exports) {
    $parcel$export(module.exports, "getSupportedFieldsCount", ()=>$7db90df2e35b2352$export$11f15170229125b6);
    var $d9r6K;
    const $7db90df2e35b2352$export$11f15170229125b6 = (fields)=>{
        if (!fields) return 0;
        return Object.values(fields).filter(({ fieldType: fieldType })=>(0, (0, parcelRequire("d9r6K")).isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType)).length;
    };
});
parcelRegister("10zMF", function(module, exports) {
    $parcel$export(module.exports, "navigationDiscardChangesPromptEntrypoint", ()=>$d013535599c23ad0$export$e3fb8f8e2efee889);
    var $eufEc;
    var $fEDBv;
    const $d013535599c23ad0$export$e3fb8f8e2efee889 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("9AReS"))), {
            moduleId: "5b0a027b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("9AReS", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "NavigationDiscardChangesPrompt", ()=>$630c46f8d9d76a94$export$80c1951973f41e27);
    $parcel$export(module.exports, "default", ()=>$630c46f8d9d76a94$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $2rqOp;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $6s1PB;
    var $koVbs;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $lVJAU;
    var $fEvvA;
    const $630c46f8d9d76a94$export$80c1951973f41e27 = ({ navigateLink: navigateLink, onConfirm: onConfirm, onCancel: onCancel })=>{
        const [isNavigating, setIsNavigating] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onCancelHandler = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'cancelNavigationDisardChangesPrompt', {
                navigateLink: navigateLink
            });
            onCancel?.();
        };
        const onConfirmHandler = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'confirmNavigationDisardChangesPrompt', {
                navigateLink: navigateLink
            });
            onConfirm && onConfirm();
            setIsNavigating(true);
            push(navigateLink);
        };
        if (!navigateLink) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "navigateWithoutRestore"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onCancelHandler,
            width: "small",
            shouldCloseOnOverlayClick: !isNavigating,
            shouldCloseOnEscapePress: !isNavigating,
            testId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage((0, (0, parcelRequire("fEvvA")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, (0, parcelRequire("fEvvA")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "issue-create.common.ui.navigation-discard-changes-prompt.button",
            appearance: "subtle-link",
            onClick: onCancelHandler,
            isDisabled: isNavigating
        }, formatMessage((0, (0, parcelRequire("fEvvA")).default).cancelButtonLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            testId: "issue-create.common.ui.navigation-discard-changes-prompt.loading-button",
            appearance: "primary",
            onClick: onConfirmHandler,
            isDisabled: isNavigating,
            isLoading: isNavigating
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, (0, parcelRequire("fEvvA")).default).confirmLabel : (0, (0, parcelRequire("fEvvA")).default).confirmButtonLabel))))));
    };
    function $630c46f8d9d76a94$export$2e2bcd8739ae039({ props: props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($630c46f8d9d76a94$export$80c1951973f41e27, props);
    }
});
parcelRegister("fEvvA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f90df22bac189d3a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f90df22bac189d3a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-create.common.navigation-discard-changes-prompt.title",
            "defaultMessage": "Your changes won\u2019t be saved"
        },
        cancelButtonLabel: {
            "id": "issue-create.common.navigation-discard-changes-prompt.cancel-button-label",
            "defaultMessage": "Go back"
        },
        confirmButtonLabel: {
            "id": "issue-create.common.navigation-discard-changes-prompt.confirm-button-label",
            "defaultMessage": "Discard issue"
        },
        confirmLabel: {
            "id": "issue-create.common.navigation-discard-changes-prompt.confirm-label",
            "defaultMessage": "Discard"
        },
        description: {
            "id": "issue-create.common.navigation-discard-changes-prompt.description",
            "defaultMessage": "We won\u2019t be able to save your data if you move away from this page."
        }
    });
});
parcelRegister("kHA0a", function(module, exports) {
    $parcel$export(module.exports, "scrollToElement", ()=>$3ba4865b52bac0cc$export$2353115f31f4d15);
    $parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", ()=>$3ba4865b52bac0cc$export$feb08457bf70a411);
    $parcel$export(module.exports, "scrollToField", ()=>$3ba4865b52bac0cc$export$a3f522e44642cd81);
    var $k9tnV;
    var $bGrWH;
    var $06PEc;
    var $aSoqm;
    const $3ba4865b52bac0cc$export$2353115f31f4d15 = (elementId)=>{
        const fieldRef = document.getElementById(elementId);
        if (fieldRef) (0, (0, parcelRequire("k9tnV")).default)(fieldRef, (0, (0, parcelRequire("bGrWH")).DEFAULT_SCROLL_OPTIONS));
    };
    const $3ba4865b52bac0cc$export$feb08457bf70a411 = (event)=>{
        if (event?.keyCode === (0, (0, parcelRequire("aSoqm")).ESC_KEY_KEYCODE)) event?.nativeEvent?.stopImmediatePropagation();
    };
    const $3ba4865b52bac0cc$export$a3f522e44642cd81 = (fieldId)=>{
        const fieldWithErrorRef = document.getElementById((0, (0, parcelRequire("06PEc")).getFieldContainerId)(fieldId));
        if (fieldWithErrorRef) (0, (0, parcelRequire("k9tnV")).default)(fieldWithErrorRef, (0, (0, parcelRequire("bGrWH")).DEFAULT_SCROLL_OPTIONS));
    };
});
parcelRegister("06PEc", function(module, exports) {
    $parcel$export(module.exports, "getFieldContainerId", ()=>$77cde28fab49b679$export$10904a5319f8077);
    const $77cde28fab49b679$export$10904a5319f8077 = (fieldId)=>`${fieldId}-container`;
});
parcelRegister("aSoqm", function(module, exports) {
    $parcel$export(module.exports, "FIELDS_LEARN_MORE_LINKS", ()=>$1d1e013afe0ab876$export$629cb7e52dfd594b);
    $parcel$export(module.exports, "USER_GIC_POSITIONING_SPOTLIGHT", ()=>$1d1e013afe0ab876$export$1056c1e726f183f9);
    $parcel$export(module.exports, "ESC_KEY_KEYCODE", ()=>$1d1e013afe0ab876$export$53016e09dd7d4dca);
    const $1d1e013afe0ab876$export$483ce8a526ee009f = 'https://support.atlassian.com/jira-core-cloud/docs/create-and-work-with-issues/';
    const $1d1e013afe0ab876$export$d807a38e79102eb0 = 'https://support.atlassian.com/jira-work-management/docs/what-is-the-new-jira-issue-create-experience/';
    const $1d1e013afe0ab876$export$629cb7e52dfd594b = {
        [(0, $962656cd6986cb06$export$252fb981af0e2e4e)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#ResolutionTypes',
        [(0, $962656cd6986cb06$export$909ba97f4a791588)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#SecurityLevels',
        [(0, $962656cd6986cb06$export$de14210faa5f2099)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#PriorityLevels'
    };
    const $1d1e013afe0ab876$export$1056c1e726f183f9 = 'jira.user.gic.positioning.spotlight';
    const $1d1e013afe0ab876$export$53016e09dd7d4dca = 27;
});
const $962656cd6986cb06$export$aa5680ad8f8be9fc = 'JiraProjectField';
const $962656cd6986cb06$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $962656cd6986cb06$export$a12a4b25ab12710c = 'JsmRequestTypeField';
const $962656cd6986cb06$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $962656cd6986cb06$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $962656cd6986cb06$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $962656cd6986cb06$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $962656cd6986cb06$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $962656cd6986cb06$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $962656cd6986cb06$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $962656cd6986cb06$export$b1ac879bb5cdf30a = 'JsmPeopleField';
const $962656cd6986cb06$export$e4d5e04bc56680dc = 'JiraNumberField';
const $962656cd6986cb06$export$d8312cdfa02c100d = 'JiraDateTimePickerField';
const $962656cd6986cb06$export$8723b724f0b3ac65 = 'JiraEpicLinkField';
const $962656cd6986cb06$export$64c7789e86344de5 = 'JiraLabelsField';
const $962656cd6986cb06$export$f4f101295d5cc151 = 'JiraSingleVersionPickerField';
const $962656cd6986cb06$export$5bb498d4f2f54799 = 'JiraMultipleVersionPickerField';
const $962656cd6986cb06$export$de14210faa5f2099 = 'JiraPriorityField';
const $962656cd6986cb06$export$47af4d6f62c134cf = 'JiraIssueLinkField';
const $962656cd6986cb06$export$e0b268941120d761 = 'JiraDatePickerField';
const $962656cd6986cb06$export$909ba97f4a791588 = 'JiraSecurityLevelField';
const $962656cd6986cb06$export$f2b56433dc0af401 = 'JiraUrlField';
const $962656cd6986cb06$export$d10237d945259f96 = 'JiraCheckboxesField';
const $962656cd6986cb06$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $962656cd6986cb06$export$fb8861017089d392 = 'JiraSingleSelectField';
const $962656cd6986cb06$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $962656cd6986cb06$export$16fe78a07e97f2ad = 'JiraSingleGroupPickerField';
const $962656cd6986cb06$export$3a1ae3e0f2d9b1b9 = 'JiraMultipleGroupPickerField';
const $962656cd6986cb06$export$64238d76a1dc0703 = 'JiraSprintField';
const $962656cd6986cb06$export$1070aada56fcaec9 = 'JiraColorField';
const $962656cd6986cb06$export$a9b3195cbef5c5ad = 'JiraAttachmentsField';
const $962656cd6986cb06$export$76d811609080a7aa = 'JiraIssueRestrictionField';
const $962656cd6986cb06$export$252fb981af0e2e4e = 'JiraResolutionField';
const $962656cd6986cb06$export$a36509fae9e84682 = 'JiraCascadingSelectField';
const $962656cd6986cb06$export$79443fedd031b437 = 'JiraTeamField';
const $962656cd6986cb06$export$5e56d79dfe9be3d = 'JiraAffectedServicesField';
const $962656cd6986cb06$export$d41ae99ff05f5cda = 'JsmMultipleSelectUserPickerField';
const $962656cd6986cb06$export$597fa240de2bfd92 = 'JiraCMDBField';
const $962656cd6986cb06$export$864384797e544339 = 'JsmOrganizationField';
const $962656cd6986cb06$export$7e5590c7c7a403c0 = 'JiraConnectTextField';
const $962656cd6986cb06$export$d854193d90dc547d = 'JiraConnectNumberField';
const $962656cd6986cb06$export$985c14eb8f3f0309 = 'JiraConnectSingleSelectField';
const $962656cd6986cb06$export$9f6f73ea02649f83 = 'JiraConnectMultipleSelectField';
const $962656cd6986cb06$export$aecc734a7c3591d7 = 'JiraTimeTrackingField';
const $962656cd6986cb06$export$d9861709f0b70c10 = 'JiraWorkLogField';
const $962656cd6986cb06$export$7a583e2ae9052377 = 'JiraConnectRichTextField';
const $962656cd6986cb06$export$8643f0b9cefed538 = 'JiraForgeStringField';
const $962656cd6986cb06$export$e0ece81bd398c799 = 'JiraForgeNumberField';
const $962656cd6986cb06$export$745c8245fea49a34 = 'JiraForgeUserField';
const $962656cd6986cb06$export$bbc6b85844b0ade5 = 'JiraForgeUsersField';
const $962656cd6986cb06$export$fd24d37af44fe736 = 'JiraForgeGroupField';
const $962656cd6986cb06$export$3027db6317a2a8ea = 'JiraForgeGroupsField';
const $962656cd6986cb06$export$f596336c24b128f5 = 'JiraForgeStringsField';
const $962656cd6986cb06$export$70ff025076e5fb13 = 'JiraForgeDatetimeField';
const $962656cd6986cb06$export$111f32c51678063a = 'JiraForgeDateField';
const $962656cd6986cb06$export$67aca33725b6a717 = 'JiraForgeObjectField';
const $962656cd6986cb06$export$1c7f7cfd2029442f = 'JiraAtlassianTeamField';
const $962656cd6986cb06$export$670384150af5f49e = 'JiraParentIssueField';
const $962656cd6986cb06$export$bf9df74e065af482 = 'JiraParentField';
const $962656cd6986cb06$export$e40f819979b3881d = 'JiraStatusField';
const $962656cd6986cb06$export$33f8a9cb608132ba = 'JiraServiceManagementRespondersField';
const $962656cd6986cb06$export$fc69de49ba08ae77 = 'JiraServiceManagementEntitlementField';
const $962656cd6986cb06$export$ede7166f44cc4bd6 = 'JiraCustomerServiceOrganizationField';
const $962656cd6986cb06$export$a138d5648dda03f0 = 'JiraMessageEditField';
const $962656cd6986cb06$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $962656cd6986cb06$export$d64150fd9c66969c = 'JiraReporterField';
const $962656cd6986cb06$export$95433ac963f4aebe = 'JiraTextAreaField';
const $962656cd6986cb06$export$f57941b9c1949a82 = 'JiraEpicColorField';
const $962656cd6986cb06$export$3e8dded8d83b5d95 = 'JiraAssetField';
parcelRegister("2K6wP", function(module, exports) {
    $parcel$export(module.exports, "getIssueDiscoveryUrl", ()=>$b2ea631f896ae096$export$852450339fdb3b37);
    const $b2ea631f896ae096$export$852450339fdb3b37 = (createdIssues)=>{
        if (createdIssues.length > 1) {
            const issueKeys = createdIssues.map((issue)=>issue.issueKey).join(',');
            const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
            return `/issues/?jql=${jqlSearch}`;
        }
        return `/browse/${createdIssues[0].issueKey}`;
    };
});
parcelRegister("lr952", function(module, exports) {
    $parcel$export(module.exports, "useSmartFieldsMachineLearning", ()=>$58cad0d162c177b0$export$2d70bc5538735402);
    var $coW0O;
    const $58cad0d162c177b0$export$2d70bc5538735402 = ()=>{
        const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } = (0, (0, parcelRequire("coW0O")).useSmartFieldsPreferenceResource)();
        const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;
        const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;
        return {
            withMachineLearning: withMachineLearning
        };
    };
});
parcelRegister("coW0O", function(module, exports) {
    $parcel$export(module.exports, "useSmartFieldsPreferenceResource", ()=>$7f9f79525cbc81c5$export$f66e1f764818b2e);
    $parcel$export(module.exports, "SmartFieldsPreference", ()=>$7f9f79525cbc81c5$export$bccde3fe1fc453a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $dTlW6;
    var $6s1PB;
    var $34Vv8;
    var $koVbs;
    var $8zOmE;
    var $aA974;
    var $2YP9W;
    var $3ep3z;
    var $6rdaE;
    var $gEEzS;
    const $7f9f79525cbc81c5$export$f66e1f764818b2e = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $7f9f79525cbc81c5$export$bccde3fe1fc453a0 = (0, (0, parcelRequire("34Vv8")).default)((props)=>{
        const { loading: loading, data: data, update: updateResource } = $7f9f79525cbc81c5$export$f66e1f764818b2e();
        const { updatePreferences: updatePreferences } = (0, (0, parcelRequire("gEEzS")).useSmartFieldsUpdateUserPreference)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { flagService: { showFlag: showFlag } } = props;
        const hasUserOptedOut = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
            data
        ]);
        const hasUserDismissedReadMore = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
            data
        ]);
        const { openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector } = (0, (0, parcelRequire("6rdaE")).useSmartFieldsFeedbackCollector)();
        const successTitleOptingOutMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3ep3z")).messages).successTitleOptingOutIssueTermRefresh : (0, (0, parcelRequire("3ep3z")).messages).successTitleOptingOut;
        const successTitleOptingInMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3ep3z")).messages).successTitleOptingInIssueTermRefresh : (0, (0, parcelRequire("3ep3z")).messages).successTitleOptingIn;
        const onChange = (0, $5uXOq.useCallback)(async (_, analyticsEventUI)=>{
            const value = !hasUserOptedOut;
            updateResource(()=>({
                    hasUserOptedOut: value,
                    hasUserDismissedReadMore: false
                }));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEventUI, 'toggleLabsGicSmartFields', {
                isSmartFieldsOptOut: value
            });
            try {
                await updatePreferences({
                    hasUserOptedOut: value,
                    hasUserDismissedReadMore: false
                });
                showFlag({
                    type: 'success',
                    title: value ? successTitleOptingOutMessage : successTitleOptingInMessage
                });
                if (value) openSmartFieldsFeedbackCollector({
                    feedbackTitle: formatMessage((0, (0, parcelRequire("3ep3z")).messages).feedbackOptOutTitle),
                    feedbackContext: [
                        {
                            id: 'smart-fields-opt-out',
                            value: 'opted-out'
                        }
                    ]
                });
            } catch (err) {
                updateResource(()=>({
                        hasUserOptedOut: hasUserOptedOut,
                        hasUserDismissedReadMore: hasUserDismissedReadMore
                    }));
                const actions = [
                    {
                        content: (0, (0, parcelRequire("3ep3z")).messages).refreshPageBtn,
                        onClick: ()=>{
                            window.location.reload();
                        }
                    }
                ];
                showFlag({
                    type: 'error',
                    title: value ? (0, (0, parcelRequire("3ep3z")).messages).errTitleOptingOut : (0, (0, parcelRequire("3ep3z")).messages).errTitleOptingIn,
                    description: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3ep3z")).messages).errDescriptionOptingInIssueTermRefresh : (0, (0, parcelRequire("3ep3z")).messages).errDescriptionOptingIn,
                    actions: actions
                });
            }
        }, [
            hasUserDismissedReadMore,
            hasUserOptedOut,
            updateResource,
            updatePreferences,
            showFlag,
            openSmartFieldsFeedbackCollector,
            formatMessage,
            successTitleOptingInMessage,
            successTitleOptingOutMessage
        ]);
        if (loading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            isChecked: !hasUserOptedOut,
            onChange: onChange,
            label: formatMessage((0, (0, parcelRequire("3ep3z")).messages).toggleAriaLabel)
        });
    });
});
parcelRegister("dTlW6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3db77843cf29c460$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $7fA4P;
    var $aFYTH;
    var $lahQ6;
    var $hzG2v;
    const $3db77843cf29c460$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $3db77843cf29c460$var$analyticsAttributes = {
        componentName: 'toggle',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $3db77843cf29c460$var$iconSizeMap = {
        regular: 'small',
        large: 'medium'
    };
    const $3db77843cf29c460$var$Toggle = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)((props, ref)=>{
        const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
        const isControlled = typeof isChecked === 'undefined';
        const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
        const handleBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnBlur,
            action: 'blur',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedFocus,
            action: 'focus',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const handleChange = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event, analyticsEvent)=>{
                if (isControlled) setChecked((checked)=>!checked);
                return providedChange(event, analyticsEvent);
            },
            action: 'change',
            analyticsData: analyticsContext,
            ...$3db77843cf29c460$var$analyticsAttributes
        });
        const shouldChecked = isControlled ? checked : isChecked;
        const controlProps = {
            'data-checked': shouldChecked ? shouldChecked : undefined,
            'data-disabled': isDisabled ? isDisabled : undefined,
            'data-size': size,
            'data-testid': testId ? testId : undefined
        };
        const toggleStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hzG2v")).getStyles)(size), [
            size
        ]);
        const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
        const labelId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            ...controlProps,
            css: toggleStyles
        }, label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: labelId,
            hidden: true
        }, label) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: ref,
            checked: shouldChecked,
            disabled: isDisabled,
            id: id,
            name: name,
            onBlur: handleBlur,
            onChange: handleChange,
            onFocus: handleFocus,
            type: "checkbox",
            value: value,
            "data-testid": testId && `${testId}--input`,
            "aria-labelledby": label ? labelId : undefined,
            "aria-describedby": descriptionId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: !shouldChecked,
            position: "left"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("7fA4P"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-check-icon`
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lahQ6")).default), {
            size: size,
            isHidden: shouldChecked,
            position: "right"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: legacyIconSize,
            testId: testId && `${testId}--toggle-cross-icon`
        }))));
    }));
    $3db77843cf29c460$var$Toggle.displayName = 'Toggle';
    var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;
});
parcelRegister("7fA4P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));
    var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>$5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
        }, props));
    $5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;
});
parcelRegister("f22iM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af18d40ba5b744b4$var$_UNSAFE_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>$af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
            type: 'utility'
        }, props));
    $af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;
});
parcelRegister("4DXCl", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
    function $36190cbd288fec69$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36190cbd288fec69$var$EditorDoneIcon = (props)=>$36190cbd288fec69$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $36190cbd288fec69$var$_checkMark.default
        }));
    $36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;
});
parcelRegister("bjo8S", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c43234bc70a485$var$_UNSAFE_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83c43234bc70a485$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c43234bc70a485$var$CheckMarkIcon = (props)=>$83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;
});
parcelRegister("aFYTH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c5cf8a572bea882$var$_react = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7c5cf8a572bea882$var$_cross = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("bjGSs")));
    var $7c5cf8a572bea882$var$_close = $7c5cf8a572bea882$var$_interopRequireDefault((parcelRequire("2C7j9")));
    function $7c5cf8a572bea882$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c5cf8a572bea882$var$CrossIcon = (props)=>$7c5cf8a572bea882$var$_react.default.createElement($7c5cf8a572bea882$var$_cross.default, Object.assign({
            LEGACY_fallbackIcon: $7c5cf8a572bea882$var$_close.default
        }, props));
    $7c5cf8a572bea882$var$CrossIcon.Name = 'CrossIconMigration';
    var $7c5cf8a572bea882$var$_default = module.exports.default = $7c5cf8a572bea882$var$CrossIcon;
});
parcelRegister("2C7j9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
    function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>$1e74cc92a54dd799$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
        }, props, {
            newIcon: $1e74cc92a54dd799$var$_close.default
        }));
    $1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
    var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;
});
parcelRegister("lahQ6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1cdaa1eb34599d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    const $ca1cdaa1eb34599d$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s ease',
        position: 'absolute',
        insetBlockStart: 'space.025'
    });
    const $ca1cdaa1eb34599d$var$iconContainerRegularStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '16px',
        height: '16px'
    });
    const $ca1cdaa1eb34599d$var$iconContainerLargeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '20px',
        height: '20px'
    });
    const $ca1cdaa1eb34599d$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca1cdaa1eb34599d$var$leftStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineStart: '3px'
    });
    const $ca1cdaa1eb34599d$var$rightStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: '3px'
    });
    const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "span",
            xcss: [
                $ca1cdaa1eb34599d$var$iconContainerStyles,
                isHidden && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$hiddenStyles,
                size === 'regular' && $ca1cdaa1eb34599d$var$iconContainerRegularStyles,
                size === 'large' && $ca1cdaa1eb34599d$var$iconContainerLargeStyles,
                position === 'left' && $ca1cdaa1eb34599d$var$leftStyles,
                position === 'right' && $ca1cdaa1eb34599d$var$rightStyles
            ]
        }, children);
    };
    var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;
});
parcelRegister("hzG2v", function(module, exports) {
    $parcel$export(module.exports, "getStyles", ()=>$3af6a5b9114f4fd0$export$ffd58b7f6f099a57);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3VjLl;
    const $3af6a5b9114f4fd0$var$globalGridSize = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $3af6a5b9114f4fd0$var$dimensions = {
        regular: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 4
        },
        large: {
            height: $3af6a5b9114f4fd0$var$globalGridSize * 2 + $3af6a5b9114f4fd0$var$globalGridSize / 2,
            width: $3af6a5b9114f4fd0$var$globalGridSize * 5
        }
    };
    const $3af6a5b9114f4fd0$var$getHeight = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].height;
    const $3af6a5b9114f4fd0$var$getWidth = ({ size: size })=>$3af6a5b9114f4fd0$var$dimensions[size].width;
    const $3af6a5b9114f4fd0$var$borderWidth = 2;
    const $3af6a5b9114f4fd0$var$paddingUnitless = $3af6a5b9114f4fd0$var$globalGridSize / 4;
    const $3af6a5b9114f4fd0$var$transition = 'transform 0.2s ease';
    const $3af6a5b9114f4fd0$export$ffd58b7f6f099a57 = (size)=>{
        const colors = (0, (0, parcelRequire("3VjLl")).getColors)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'content-box',
            display: 'inline-block',
            padding: $3af6a5b9114f4fd0$var$borderWidth,
            margin: $3af6a5b9114f4fd0$var$borderWidth,
            backgroundClip: 'content-box',
            backgroundColor: colors.backgroundColorUnchecked,
            borderRadius: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid transparent`,
            height: `${$3af6a5b9114f4fd0$var$getHeight({
                size: size
            })}px`,
            position: 'relative',
            transition: `${$3af6a5b9114f4fd0$var$transition}`,
            width: `${$3af6a5b9114f4fd0$var$getWidth({
                size: size
            })}px`,
            '&[data-checked]': {
                backgroundColor: colors.backgroundColorChecked,
                color: colors.iconColorChecked
            },
            '&[data-disabled]:not([data-checked])': {
                backgroundColor: colors.backgroundColorUncheckedDisabled
            },
            '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            '&:focus-within': {
                border: `${$3af6a5b9114f4fd0$var$borderWidth}px solid ${colors.borderColorFocus}`
            },
            '&:hover': {
                backgroundColor: colors.backgroundColorUncheckedHover,
                cursor: 'pointer'
            },
            '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
                cursor: 'not-allowed'
            },
            '&[data-checked]:hover': {
                backgroundColor: colors.backgroundColorCheckedHover
            },
            '&:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorUncheckedHover
            },
            '&[data-disabled]:not([data-checked]):hover': {
                backgroundColor: colors.backgroundColorCheckedDisabled
            },
            color: colors.iconColorUnchecked,
            '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
                color: colors.iconColorDisabled
            },
            'input[type="checkbox"]': {
                opacity: 0,
                margin: 0,
                padding: 0,
                border: 'none',
                '&:focus': {
                    outline: 'none !important'
                }
            },
            '::before': {
                backgroundColor: colors.handleBackgroundColor,
                borderRadius: "var(--ds-border-radius-circle, 50%)",
                content: '""',
                position: 'absolute',
                transform: 'initial',
                transition: $3af6a5b9114f4fd0$var$transition,
                insetBlockEnd: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`,
                height: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                width: `${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                }) - $3af6a5b9114f4fd0$var$paddingUnitless * 2}px`,
                insetInlineStart: `${2 * $3af6a5b9114f4fd0$var$paddingUnitless}px`
            },
            '&[data-checked]::before': {
                backgroundColor: colors.handleBackgroundColorChecked,
                transform: `translateX(${$3af6a5b9114f4fd0$var$getHeight({
                    size: size
                })}px)`
            },
            '&[data-disabled]::before': {
                backgroundColor: colors.handleBackgroundColorDisabled,
                zIndex: 1
            },
            ...size === 'large' && !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && {
                '> span > span': {
                    height: '20px',
                    width: '20px'
                }
            },
            '@media screen and (forced-colors: active)': {
                '::before': {
                    filter: 'grayscale(100%) invert(1)'
                },
                '&:focus-within': {
                    outline: '1px solid'
                }
            }
        });
    };
});
parcelRegister("3VjLl", function(module, exports) {
    $parcel$export(module.exports, "getColors", ()=>$7761f9acd89472cc$export$6cee60e8aa85e528);
    const $7761f9acd89472cc$var$colorMap = {
        backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderColorFocus: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        iconColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        iconColorDisabled: `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $7761f9acd89472cc$export$6cee60e8aa85e528 = ()=>$7761f9acd89472cc$var$colorMap;
});
parcelRegister("34Vv8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$827c4d80e4d41b48$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    const $827c4d80e4d41b48$var$withFlagService = (WrappedComponent)=>{
        return (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                flagService: (0, (0, parcelRequire("pa9q9")).flagService)
            });
    };
    var $827c4d80e4d41b48$export$2e2bcd8739ae039 = $827c4d80e4d41b48$var$withFlagService;
});
parcelRegister("3ep3z", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$75e353f61e166a9d$export$defe85febe8b728c);
    var $7VHMR;
    const $75e353f61e166a9d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        imgAltText: {
            "id": "personal-settings-gic-smart-fields.common.img-alt-text",
            "defaultMessage": "Hide unused fields when creating issues"
        },
        headerText: {
            "id": "personal-settings-gic-smart-fields.common.header-text",
            "defaultMessage": "Hide unused fields when creating issues"
        },
        descriptionText: {
            "id": "personal-settings-gic-smart-fields.common.description-text",
            "defaultMessage": "We\u2019ve implemented some smarts to make sure you have quick and easy access to the fields you actually use when you create issues. We\u2019re not removing the unused fields, you\u2019ll still be able to find them in a <strong>More fields</strong> section at the bottom of the issue create form. <link>Read more about the fields available when creating issues</link>"
        },
        loadingIndicatorAriaLabel: {
            "id": "personal-settings-gic-smart-fields.common.loading-indicator-aria-label",
            "defaultMessage": "Loading data for smart fields toggle button"
        },
        errTitleOptingOut: {
            "id": "personal-settings-gic-smart-fields.common.err-title-opting-out",
            "defaultMessage": "Failed to turn off"
        },
        errTitleOptingIn: {
            "id": "personal-settings-gic-smart-fields.common.err-title-opting-in",
            "defaultMessage": "Failed to turn on"
        },
        errDescriptionOptingIn: {
            "id": "personal-settings-gic-smart-fields.common.err-description-opting-in",
            "defaultMessage": "The issue should fix itself. You can try again in a few minutes, or refresh the page."
        },
        successTitleOptingIn: {
            "id": "personal-settings-gic-smart-fields.common.success-title-opting-in",
            "defaultMessage": "Now hiding unused fields when you create issues."
        },
        successTitleOptingOut: {
            "id": "personal-settings-gic-smart-fields.common.success-title-opting-out",
            "defaultMessage": "Unused fields now showing when you create issues."
        },
        refreshPageBtn: {
            "id": "personal-settings-gic-smart-fields.common.refresh-page-btn",
            "defaultMessage": "Refresh page"
        },
        feedbackTitle: {
            "id": "personal-settings-gic-smart-fields.common.feedback-title",
            "defaultMessage": "Share your feedback"
        },
        feedbackOptOutTitle: {
            "id": "personal-settings-gic-smart-fields.common.feedback-opt-out-title",
            "defaultMessage": "Before you go, help us improve the experience"
        },
        toggleAriaLabel: {
            "id": "personal-settings-gic-smart-fields.common.toggle-aria-label",
            "defaultMessage": "Toggle for hiding unused fields when creating issues"
        },
        imgAltTextIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.img-alt-text-issue-term-refresh",
            "defaultMessage": "Hide unused fields when creating work items"
        },
        headerTextIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.header-text-issue-term-refresh",
            "defaultMessage": "Hide unused fields when creating work items"
        },
        descriptionTextIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.description-text-issue-term-refresh",
            "defaultMessage": "We've moved fields you don't use when creating work to a <strong> More fields</strong> section below. <link>Read about the fields available when creating work</link>."
        },
        errDescriptionOptingInIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.err-description-opting-in-issue-term-refresh",
            "defaultMessage": "The issue should fix itself. You can try again in a few minutes, or refresh the page."
        },
        successTitleOptingInIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.success-title-opting-in-issue-term-refresh",
            "defaultMessage": "Now hiding unused fields when you create work items."
        },
        successTitleOptingOutIssueTermRefresh: {
            "id": "personal-settings-gic-smart-fields.common.success-title-opting-out-issue-term-refresh",
            "defaultMessage": "Unused fields now showing when you create work items."
        }
    });
});
parcelRegister("6rdaE", function(module, exports) {
    $parcel$export(module.exports, "useSmartFieldsFeedbackCollector", ()=>$3a2d0f7f67a54576$export$ffd83fb8be3279b);
    var $5uXOq = parcelRequire("5uXOq");
    var $dseDh;
    var $8zOmE;
    var $2NMNM;
    const $3a2d0f7f67a54576$export$25dc0a1e75f58d8f = '980acd66-d10b-474a-9ff1-48928fc1c8ad';
    const $3a2d0f7f67a54576$export$14b33d63628336c2 = 'gic.smart-fields';
    const $3a2d0f7f67a54576$export$ffd83fb8be3279b = ()=>{
        const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const openSmartFieldsFeedbackCollector = (0, $5uXOq.useCallback)((feedbackCollectorProps)=>{
            openFeedbackCollector({
                entrypointId: $3a2d0f7f67a54576$export$25dc0a1e75f58d8f,
                feedbackGroupId: $3a2d0f7f67a54576$export$14b33d63628336c2,
                onClose: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector closed');
                    resetFeedbackCollectorState();
                },
                onSubmit: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector submitted');
                },
                ...feedbackCollectorProps
            });
        }, [
            openFeedbackCollector,
            createAnalyticsEvent,
            resetFeedbackCollectorState
        ]);
        return {
            openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector
        };
    };
});
parcelRegister("gEEzS", function(module, exports) {
    $parcel$export(module.exports, "useSmartFieldsUpdateUserPreference", ()=>$2a8bf66056b8c1ad$export$d7a60913673e28ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $aHuqL;
    const $2a8bf66056b8c1ad$export$d7a60913673e28ef = ()=>{
        const updatePreferences = (0, $5uXOq.useCallback)(async (payload)=>{
            try {
                await (0, (0, parcelRequire("aHuqL")).userPreferenceAPI).set((0, $a11a54266737e598$export$b94951a11282ae6a), payload);
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: err instanceof Error ? err : new Error('Unknown error'),
                    meta: {
                        id: 'updateCommandPaletteOptInStatus',
                        packageName: 'jiraPersonalSettingsGicSmartFields',
                        teamName: 'deliveroo'
                    }
                });
                throw err;
            }
        }, []);
        return {
            updatePreferences: updatePreferences
        };
    };
});
const $a11a54266737e598$export$b94951a11282ae6a = 'gic-smart-fields-feature';
const $a11a54266737e598$export$5781c9f38e6a61fe = 'jira.create.smart.fields.is-enabled';
parcelRegister("6OTur", function(module, exports) {
    $parcel$export(module.exports, "useChangerSpotlight", ()=>$f1295c4f9d1bf347$export$6e0f4554859c42e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $c0dQj;
    var $aSoqm;
    var $9FXQH;
    const $f1295c4f9d1bf347$export$6e0f4554859c42e9 = (minimizableModalView)=>{
        const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = (0, $5uXOq.useState)(false);
        const [userPreferenceSpotlight, setUserPreferences] = (0, (0, parcelRequire("9FXQH")).useUserPreferences)((0, (0, parcelRequire("aSoqm")).USER_GIC_POSITIONING_SPOTLIGHT), false);
        const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;
        const isMobileExperienceEnabled = (0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)();
        const shouldShowChangerSpotlight = !hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight && !isMobileExperienceEnabled;
        const onCloseChangerSpotlight = (0, $5uXOq.useCallback)(()=>{
            if (!hasSeenGicPositioningSpotlight) {
                setAllowShowingChangerSpotlight(false);
                setUserPreferences(true);
            }
        }, [
            setAllowShowingChangerSpotlight,
            hasSeenGicPositioningSpotlight,
            setUserPreferences
        ]);
        const isModalView = minimizableModalView === 'modal';
        (0, $5uXOq.useEffect)(()=>{
            if (!isModalView && shouldShowChangerSpotlight) onCloseChangerSpotlight();
        }, [
            onCloseChangerSpotlight,
            isModalView,
            shouldShowChangerSpotlight
        ]);
        const onOpenSpotlight = ()=>{
            if (isModalView) setAllowShowingChangerSpotlight(true);
        };
        const onCloseSpotlight = ()=>{
            if (isModalView) onCloseChangerSpotlight();
        };
        return {
            shouldShowChangerSpotlight: shouldShowChangerSpotlight,
            onOpenSpotlight: onOpenSpotlight,
            onCloseSpotlight: onCloseSpotlight
        };
    };
});
parcelRegister("9FXQH", function(module, exports) {
    $parcel$export(module.exports, "useUserPreferences", ()=>$c1d22704a79507d0$export$b6472e0d8983f5f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $561FV = parcelRequire("561FV");
    var $jcw0u;
    var $eusud;
    const $c1d22704a79507d0$var$setGICUserPreferences = async (key, value)=>{
        try {
            await (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
                body: JSON.stringify({
                    value: value
                })
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getAPI3MyPreferences',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const $c1d22704a79507d0$export$b6472e0d8983f5f5 = (key, fallbackState)=>{
        const [state, setState] = (0, $5uXOq.useState)(fallbackState);
        (0, $5uXOq.useEffect)(()=>{
            const run = async ()=>{
                try {
                    const apiResult = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/mypreferences?key=${key}`);
                    if (typeof apiResult !== 'object' || !(0, ($parcel$interopDefault($561FV)))(apiResult, 'value')) {
                        const error = new Error('Invalid preference value');
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'getAPI3MyPreferences',
                                packageName: 'jiraIssueCreate',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return;
                    }
                    setState(apiResult.value);
                } catch (error) {
                    if (error.statusCode === 404) return;
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'getAPI3MyPreferences',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            };
            run();
        }, [
            key
        ]);
        const setUserPreferences = (0, $5uXOq.useCallback)((value)=>{
            $c1d22704a79507d0$var$setGICUserPreferences(key, value);
            setState(value);
        }, [
            key
        ]);
        return [
            state,
            setUserPreferences
        ];
    };
});
parcelRegister("6gjIc", function(module, exports) {
    $parcel$export(module.exports, "useIsGICPositioningEnabled", ()=>$f471b5e0614291f9$export$a782e9359ada4cd3);
    var $5uXOq = parcelRequire("5uXOq");
    var $PpuOf;
    const $f471b5e0614291f9$export$a782e9359ada4cd3 = ()=>{
        const [{ disableGICPositioning: disableGICPositioning }] = (0, (0, parcelRequire("PpuOf")).useGICPositioningEnabledController)();
        const isGICPositioningEnabled = (0, $5uXOq.useCallback)(()=>!disableGICPositioning, [
            disableGICPositioning
        ]);
        return isGICPositioningEnabled;
    };
});
parcelRegister("PpuOf", function(module, exports) {
    $parcel$export(module.exports, "useGICPositioningEnabledController", ()=>$51f8f3ede3c201de$export$9cc1c859181a0ff4);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $51f8f3ede3c201de$var$initialState = {
        disableGICPositioning: false
    };
    const $51f8f3ede3c201de$var$actions = {
        setDisableGICPositioning: (disableGICPositioning)=>({ setState: setState })=>{
                setState({
                    disableGICPositioning: disableGICPositioning
                });
            }
    };
    const $51f8f3ede3c201de$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $51f8f3ede3c201de$var$initialState,
        actions: $51f8f3ede3c201de$var$actions,
        name: 'GICPositioningEnabledController'
    });
    const $51f8f3ede3c201de$export$4bfa4009172d242 = (0, (0, parcelRequire("gg7kZ")).createContainer)($51f8f3ede3c201de$var$Store);
    const $51f8f3ede3c201de$export$9cc1c859181a0ff4 = (0, (0, parcelRequire("3sQ5x")).createHook)($51f8f3ede3c201de$var$Store);
});
parcelRegister("hH1l8", function(module, exports) {
    $parcel$export(module.exports, "useRequestTypeFieldsLayoutPreference", ()=>$37c1188b073578b5$export$7f6ea71dfb4ea52b);
    var $3sQ5x;
    var $iXqE5;
    var $6ailZ;
    var $co3D8;
    const $37c1188b073578b5$export$d4c72bab9d6cc13a = {
        isInitialised: false,
        data: (0, (0, parcelRequire("co3D8")).fallbackValue),
        isLoading: false
    };
    const $37c1188b073578b5$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'RequestTypeFieldsLayoutUserPreference',
        initialState: $37c1188b073578b5$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("6ailZ")).actions
    });
    const $37c1188b073578b5$export$7f6ea71dfb4ea52b = (0, (0, parcelRequire("3sQ5x")).createHook)($37c1188b073578b5$var$store);
});
parcelRegister("6ailZ", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$7fbb4dca8594e31d$export$e324594224ef24da);
    var $89SaW;
    var $jcw0u;
    var $jJZqs;
    var $fZneA;
    var $8zOmE;
    var $co3D8;
    const $7fbb4dca8594e31d$var$initialise = (accountId, createAnalyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (!state.isInitialised && accountId !== null) {
                setState({
                    isLoading: true
                });
                await (0, (0, parcelRequire("89SaW")).getUserProperty)(accountId, (0, (0, parcelRequire("co3D8")).propertyKey)).then((value)=>{
                    setState({
                        isInitialised: true,
                        data: value === (0, (0, parcelRequire("co3D8")).UserPreference).RequestFormFields,
                        isLoading: false
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
                }).catch((error)=>{
                    if (error.statusCode === (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef)) {
                        setState({
                            isLoading: false,
                            data: (0, (0, parcelRequire("co3D8")).fallbackValue)
                        });
                        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
                    } else {
                        setState({
                            isLoading: false
                        });
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'getRequestTypesLayoutPreference',
                                packageName: 'jiraIssueCreate',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            attributes: {
                                isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                });
            }
        };
    const $7fbb4dca8594e31d$var$setPreference = (accountId, isEnabled, createAnalyticsEvent, callback)=>async ({ setState: setState, getState: getState })=>{
            const { isLoading: isLoading, data: oldValue } = getState();
            if (accountId && !isLoading) {
                setState({
                    data: isEnabled,
                    isLoading: true
                });
                await (0, (0, parcelRequire("89SaW")).setUserProperties)(accountId, (0, (0, parcelRequire("co3D8")).propertyKey), JSON.stringify(isEnabled ? (0, (0, parcelRequire("co3D8")).UserPreference).RequestFormFields : (0, (0, parcelRequire("co3D8")).UserPreference).ScreenFields)).then((res)=>{
                    if (!res.ok) return res.text().then((errResp)=>{
                        throw new (0, (0, parcelRequire("jJZqs")).default)(res.status, errResp);
                    });
                    setState({
                        data: isEnabled,
                        isLoading: false
                    });
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'setRequestTypesLayoutPreference succeeded', {
                        isEnabled: isEnabled
                    });
                    return callback();
                }).catch((error)=>{
                    setState({
                        data: oldValue,
                        isLoading: false
                    });
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'setRequestTypesLayoutPreference',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(error)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                });
            }
        };
    const $7fbb4dca8594e31d$export$e324594224ef24da = {
        setPreference: $7fbb4dca8594e31d$var$setPreference,
        initialise: $7fbb4dca8594e31d$var$initialise
    };
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("co3D8", function(module, exports) {
    $parcel$export(module.exports, "fallbackValue", ()=>$9d1eec5baf6d3384$export$91cd7f5c38b6ba2);
    $parcel$export(module.exports, "propertyKey", ()=>$9d1eec5baf6d3384$export$52266bfa96e3a752);
    $parcel$export(module.exports, "UserPreference", ()=>$9d1eec5baf6d3384$export$9eb786c5fec4a558);
    const $9d1eec5baf6d3384$export$91cd7f5c38b6ba2 = true;
    const $9d1eec5baf6d3384$export$52266bfa96e3a752 = 'gic-jsm-fields-layout-preference';
    const $9d1eec5baf6d3384$export$9eb786c5fec4a558 = {
        ScreenFields: 'SCREEN_FIELDS',
        RequestFormFields: 'REQUEST_FORM_FIELDS'
    };
});
parcelRegister("jP8gL", function(module, exports) {
    $parcel$export(module.exports, "useFetchForgeModules", ()=>$31a99a356003c61f$export$36c81308105ff728);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $fn8B5 = parcelRequire("fn8B5");
    var $ajpes = parcelRequire("ajpes");
    var $cuHs1 = parcelRequire("cuHs1");
    var $1UikQ = parcelRequire("1UikQ");
    var $ld2hZ;
    var $e5wyW;
    var $4R6GH;
    var $k2DRb;
    var $awp3q;
    var $5vSAE;
    var $iVaKa;
    var $1MlDe;
    var $9OXo1;
    const $31a99a356003c61f$var$moduleToVariableKey = (module)=>(0, ($parcel$interopDefault($e4eHl)))(module);
    const $31a99a356003c61f$export$44097e02a91cd11a = (extensions)=>{
        const groupedExtensions = (0, ($parcel$interopDefault($fn8B5)))(extensions, 'type');
        const groupedExtensionsWithMappedKeys = (0, ($parcel$interopDefault($1UikQ)))((0, ($parcel$interopDefault($cuHs1)))(groupedExtensions, (_, key)=>$31a99a356003c61f$var$moduleToVariableKey(key)), (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)());
        const filteredOutDuplicatedExtensions = (0, (0, parcelRequire("1MlDe")).filterOutDuplicatedExtensions)(groupedExtensionsWithMappedKeys);
        const allowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        const accessNarrowedExtensions = (0, (0, parcelRequire("k2DRb")).getEmptyExtensionsObject)();
        Object.entries(filteredOutDuplicatedExtensions).forEach(([key, module])=>{
            const allowedExtensionsMap = new Map();
            const accessNarrowedExtensionsMap = new Map();
            module.forEach((moduleItem)=>{
                if (moduleItem?.dataClassificationPolicyDecision?.status === 'BLOCKED' || moduleItem?.hiddenBy) accessNarrowedExtensionsMap.set(moduleItem.id, moduleItem);
                else allowedExtensionsMap.set(moduleItem.id, moduleItem);
            });
            allowedExtensions[key] = [
                ...allowedExtensionsMap.values()
            ];
            accessNarrowedExtensions[key] = [
                ...accessNarrowedExtensionsMap.values()
            ];
        });
        return {
            extensions: allowedExtensions,
            accessNarrowedExtensions: accessNarrowedExtensions
        };
    };
    const $31a99a356003c61f$export$281dc5a8fd9afe5a = async (cloudId, isAnonymous, projectKey)=>{
        const extensionsData = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
            cloudId: cloudId,
            isAnonymous: isAnonymous,
            context: {
                projectKey: projectKey
            },
            includeHidden: true,
            includeScopes: true,
            types: [
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
                (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
            ],
            source: (0, (0, parcelRequire("k2DRb")).SOURCE_GLOBAL_ISSUE_CREATE)
        });
        const extensionsFlat = Object.values(extensionsData).flat();
        return $31a99a356003c61f$export$44097e02a91cd11a(extensionsFlat);
    };
    const $31a99a356003c61f$export$465b037a83cbb00 = (extraContext = {})=>{
        const { cloudId: cloudId, activationId: activationId, locale: locale } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const modulesToFetch = (0, $5uXOq.useMemo)(()=>[
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
                (0, (0, parcelRequire("k2DRb")).UI_MODIFICATIONS_MODULE)
            ], []);
        const classificationTags = extraContext?.classificationTags;
        const previousDataClassificationTags = (0, $5uXOq.useRef)([]);
        const dataClassificationTags = (0, $5uXOq.useMemo)(()=>{
            if (!classificationTags) return undefined;
            if (!(0, ($parcel$interopDefault($ajpes)))(previousDataClassificationTags.current, classificationTags)) previousDataClassificationTags.current = classificationTags;
            return previousDataClassificationTags.current;
        }, [
            classificationTags
        ]);
        const hasDataClassificationTags = !!dataClassificationTags;
        const request = (0, $5uXOq.useCallback)(()=>{
            const contextIds = [
                `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            ];
            return (0, (0, parcelRequire("iVaKa")).default)(cloudId, modulesToFetch, {
                tags: dataClassificationTags || []
            }, {
                include: {
                    scopes: true
                }
            }, (0, (0, parcelRequire("k2DRb")).SOURCE_GLOBAL_ISSUE_CREATE), contextIds, locale);
        }, [
            dataClassificationTags,
            cloudId,
            activationId,
            modulesToFetch,
            locale
        ]);
        const { data: data, error: error, fetch: fetch, loadingStatus: loadingStatus } = (0, (0, parcelRequire("ld2hZ")).useLoadingStatusService)(request, {
            loading: true
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!hasDataClassificationTags) return;
            fetch();
        }, [
            fetch,
            hasDataClassificationTags
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            const customFields = [];
            const issueAdjustmentModules = [];
            const filteredOutModules = [];
            const modules = data?.extensions;
            const accessNarrowedModules = data?.accessNarrowedExtensions;
            accessNarrowedModules?.jiraCustomField?.forEach((module)=>{
                filteredOutModules.push(module);
            });
            accessNarrowedModules?.jiraCustomFieldType?.forEach((module)=>{
                filteredOutModules.push(module);
            });
            modules?.jiraCustomField?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
                else filteredOutModules.push(module);
            });
            modules?.jiraCustomFieldType?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
                else filteredOutModules.push(module);
            });
            modules?.jiraUiModifications?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) issueAdjustmentModules.push(module);
            });
            return {
                customFields: customFields,
                issueAdjustmentModules: issueAdjustmentModules,
                filteredOutModules: filteredOutModules,
                error: error,
                loadingStatus: loadingStatus
            };
        }, [
            data,
            loadingStatus,
            error,
            extraContext
        ]);
    };
    const $31a99a356003c61f$export$601f3f73ad56dbff = (extraContext = {})=>{
        const { cloudId: cloudId, isAnonymous: isAnonymous } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const request = (0, $5uXOq.useCallback)(()=>{
            return $31a99a356003c61f$export$281dc5a8fd9afe5a(cloudId, isAnonymous, extraContext.projectKey);
        }, [
            cloudId,
            isAnonymous,
            extraContext.projectKey
        ]);
        const { data: data, error: error, fetch: fetch, loadingStatus: loadingStatus } = (0, (0, parcelRequire("ld2hZ")).useLoadingStatusService)(request, {
            loading: true
        });
        (0, $5uXOq.useEffect)(()=>{
            if (extraContext.projectKey) fetch();
        }, [
            fetch,
            extraContext.projectKey
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            const customFields = [];
            const issueAdjustmentModules = [];
            const filteredOutModules = [];
            const modules = data?.extensions;
            const accessNarrowedModules = data?.accessNarrowedExtensions;
            accessNarrowedModules?.jiraCustomField?.forEach((module)=>{
                filteredOutModules.push(module);
            });
            accessNarrowedModules?.jiraCustomFieldType?.forEach((module)=>{
                filteredOutModules.push(module);
            });
            modules?.jiraCustomField?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
                else filteredOutModules.push(module);
            });
            modules?.jiraCustomFieldType?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
                else filteredOutModules.push(module);
            });
            modules?.jiraUiModifications?.forEach((module)=>{
                if ((0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(module, extraContext)) issueAdjustmentModules.push(module);
            });
            return {
                customFields: customFields,
                issueAdjustmentModules: issueAdjustmentModules,
                filteredOutModules: filteredOutModules,
                error: error,
                loadingStatus: loadingStatus
            };
        }, [
            data,
            loadingStatus,
            error,
            extraContext
        ]);
    };
    const $31a99a356003c61f$export$36c81308105ff728 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $31a99a356003c61f$export$601f3f73ad56dbff, $31a99a356003c61f$export$465b037a83cbb00);
});
parcelRegister("a2K6a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55a130ca0c11e0b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ld2hZ;
    var $9OXo1;
    var $gJDCO;
    const $55a130ca0c11e0b2$var$useFetchTransitionsService = ()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const fetchTransitions = (0, $5uXOq.useCallback)(({ projectId: projectId, issueTypeId: issueTypeId, selectedCloudId: selectedCloudId })=>(0, (0, parcelRequire("gJDCO")).default)(selectedCloudId || cloudId, projectId, issueTypeId), [
            cloudId
        ]);
        const { loading: loading, error: error, data: data, fetch: fetch } = (0, (0, parcelRequire("ld2hZ")).useService)(fetchTransitions);
        return [
            {
                isLoading: loading,
                error: error,
                transitions: data
            },
            fetch
        ];
    };
    var $55a130ca0c11e0b2$export$2e2bcd8739ae039 = $55a130ca0c11e0b2$var$useFetchTransitionsService;
});
parcelRegister("gJDCO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51b007914d7cd1ca$export$2e2bcd8739ae039);
    var $jcw0u;
    var $eusud;
    var $1Nspv;
    var $eDfCU;
    const $51b007914d7cd1ca$var$constructEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;
    const $51b007914d7cd1ca$var$getTransitions = async (cloudId, projectId, issueTypeId)=>{
        const url = $51b007914d7cd1ca$var$constructEndpoint(cloudId);
        (0, (0, parcelRequire("1Nspv")).StatusFieldLoad).start();
        try {
            const resp = await (0, (0, parcelRequire("eusud")).performPostRequest)(url, {
                body: JSON.stringify({
                    projectId: projectId,
                    issueTypeId: issueTypeId
                })
            });
            (0, (0, parcelRequire("1Nspv")).StatusFieldLoad).success();
            return (0, (0, parcelRequire("eDfCU")).transformData)(resp);
        } catch (error) {
            (0, (0, parcelRequire("1Nspv")).StatusFieldLoad).failure();
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTransitions',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    var $51b007914d7cd1ca$export$2e2bcd8739ae039 = $51b007914d7cd1ca$var$getTransitions;
});
parcelRegister("eDfCU", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$fae18921f3745176$export$3ceb62baab058c6b);
    const $fae18921f3745176$var$shouldReplace = (existing, replacement)=>!existing.isInitial && replacement.isInitial || existing.isDisabled === true && !replacement.isDisabled;
    const $fae18921f3745176$export$3ceb62baab058c6b = (data)=>{
        const transitionMap = data.reduce((acc, val)=>{
            if (acc.has(val.to.id) && !$fae18921f3745176$var$shouldReplace(acc.get(val.to.id), val)) return acc;
            return acc.set(val.to.id, val);
        }, new Map());
        return Array.from(transitionMap.values());
    };
});
parcelRegister("j3DvU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e59cb64c763a10e$export$2e2bcd8739ae039);
    var $4R6GH;
    var $a6nj3;
    var $fWhMc;
    var $gdlF6;
    var $bVBVj;
    const $0e59cb64c763a10e$var$useModalLoadQuery = (props)=>{
        const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isSubTaskCreationOpen: isSubTaskCreationOpen = false, triggerIssueCreatePayload: triggerIssueCreatePayload, isModalLoadInContext: isModalLoadInContext = false, isCreateLinkedIssue: isCreateLinkedIssue } = props;
        const [{ isLoading: isLoading, fieldConfig: fieldConfigInitial, fieldTabs: fieldTabs, contextFields: contextFields, meta: meta, error: error, apiLatency: apiLatency, additionalServices: additionalServices }, fetchConfig] = (0, (0, parcelRequire("fWhMc")).default)({
            displayOnlyRequiredFields: displayOnlyRequiredFields,
            triggerPointKey: triggerPointKey
        });
        const fieldConfig = (0, (0, parcelRequire("bVBVj")).usePrefillCustomFields)(fieldConfigInitial);
        const [{ isLoading: isSubtaskLoading, fieldConfig: subtaskFieldConfig, fieldTabs: subtaskFieldTabs, contextFields: subtaskContextFields, meta: subtaskFieldsDataMeta, error: subtaskFieldsDataError, apiLatency: subtaskApiLatency, additionalServices: subtaskAdditionalServices }, fetchSubtaskConfig] = (0, (0, parcelRequire("gdlF6")).default)({
            displayOnlyRequiredFields: displayOnlyRequiredFields,
            triggerPointKey: triggerPointKey
        });
        const [{ isLoading: isLoadingInContext, fieldConfig: fieldConfigInContext, fieldTabs: fieldTabsInContext, contextFields: contextFieldsInContext, meta: fieldsDataMetaInContext, error: fieldsDataErrorInContext, apiLatency: apiLatencyInContext, additionalServices: additionalServicesInContext }, fetchConfigInContext] = (0, (0, parcelRequire("a6nj3")).default)({
            displayOnlyRequiredFields: displayOnlyRequiredFields,
            triggerPointKey: triggerPointKey,
            ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                isCreateLinkedIssue: isCreateLinkedIssue
            } : {}
        });
        const parentId = triggerIssueCreatePayload?.parentId || null;
        const additionalContext = triggerIssueCreatePayload?.additionalContext || null;
        if (isModalLoadInContext && additionalContext) return [
            {
                isLoading: isLoadingInContext,
                fieldConfig: fieldConfigInContext,
                fieldTabs: fieldTabsInContext,
                contextFields: contextFieldsInContext,
                meta: fieldsDataMetaInContext,
                error: fieldsDataErrorInContext,
                apiLatency: apiLatencyInContext,
                additionalServices: additionalServicesInContext
            },
            fetchConfigInContext
        ];
        if (isSubTaskCreationOpen && parentId) return [
            {
                isLoading: isSubtaskLoading,
                fieldConfig: subtaskFieldConfig,
                fieldTabs: subtaskFieldTabs,
                contextFields: subtaskContextFields,
                meta: subtaskFieldsDataMeta,
                error: subtaskFieldsDataError,
                apiLatency: subtaskApiLatency,
                additionalServices: subtaskAdditionalServices
            },
            fetchSubtaskConfig
        ];
        return [
            {
                isLoading: isLoading,
                fieldConfig: fieldConfig,
                fieldTabs: fieldTabs,
                contextFields: contextFields,
                meta: meta,
                error: error,
                apiLatency: apiLatency,
                additionalServices: additionalServices
            },
            fetchConfig
        ];
    };
    var $0e59cb64c763a10e$export$2e2bcd8739ae039 = $0e59cb64c763a10e$var$useModalLoadQuery;
});
parcelRegister("a6nj3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad8978445b67cbea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $8j2Ud;
    var $fcZ0a;
    var $lr952;
    var $iT5Ia;
    var $aHg9F;
    var $aK8En;
    var $3MuWj;
    const $ad8978445b67cbea$var$useFetchCreateConfigQueryInContext = (props = {})=>{
        const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue = false } = props;
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
        const apiStartTime = (0, $5uXOq.useRef)(0);
        const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
        const [data, setData] = (0, $5uXOq.useState)({
            fieldTabs: [],
            fieldConfig: {},
            contextFields: {},
            meta: {
                areRequiredFieldsSupported: true,
                queryErrorMessage: ''
            },
            additionalServices: {}
        });
        const { withMachineLearning: withMachineLearning } = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("lr952")).useSmartFieldsMachineLearning)() : {
            withMachineLearning: false
        };
        const oldFetchConfig = (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? (0, (0, parcelRequire("aHg9F")).getCreateConfigUserPreferredQueryInContextCLI)(isCreateLinkedIssue) : (0, (0, parcelRequire("aK8En")).CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT);
        const createConfigQuery = (0, (0, parcelRequire("4R6GH")).fg)('new-issue-create-fetch-config-query') ? (0, (0, parcelRequire("iT5Ia")).getCreateConfigQuery)({
            isInContext: true,
            withML: withMachineLearning,
            isCreateLinkedIssue: isCreateLinkedIssue,
            isCreateLinkedIssueFromIssueViewFGOn: !!(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view'),
            isJsmRespondersFieldEnabled: (0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false),
            isClassificationTagsEnabledForProject: !(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects')
        }) : (0, (0, parcelRequire("3MuWj")).getCreateConfigUserPreferredQueryInContext)(withMachineLearning, isCreateLinkedIssue);
        const [fetchConfigInContext] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? createConfigQuery : oldFetchConfig, {
            fetchPolicy: 'no-cache',
            onCompleted: (queryData)=>{
                setApiLatency(Math.floor(performance.now() - apiStartTime.current));
                setData((0, (0, parcelRequire("fcZ0a")).transformQueryResults)((0, (0, parcelRequire("fcZ0a")).tranformModalLoadDataInContext)(queryData), displayOnlyRequiredFields));
                setLoading(false);
            },
            onError: (error)=>{
                setFetchError(error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchCreateConfigQueryInContext',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        errorType: (0, (0, parcelRequire("8j2Ud")).handleApolloError)(error),
                        triggerPointKey: triggerPointKey
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
            setLoading(true);
            apiStartTime.current = performance.now();
            fetchConfigInContext(queryVariables);
        });
        return [
            {
                isLoading: loading,
                fieldTabs: data.fieldTabs,
                fieldConfig: data.fieldConfig,
                contextFields: data.contextFields,
                meta: data.meta,
                error: fetchError,
                apiLatency: apiLatency,
                additionalServices: data.additionalServices
            },
            handleFetch.current
        ];
    };
    var $ad8978445b67cbea$export$2e2bcd8739ae039 = $ad8978445b67cbea$var$useFetchCreateConfigQueryInContext;
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("8j2Ud", function(module, exports) {
    $parcel$export(module.exports, "handleApolloError", ()=>$8edb28f7df5f6239$export$31b755cdc25616f2);
    const $8edb28f7df5f6239$export$31b755cdc25616f2 = (error)=>{
        let errorType = 'unknown';
        if (error.networkError != null) errorType = 'networkError';
        else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
        return errorType;
    };
});
parcelRegister("fcZ0a", function(module, exports) {
    $parcel$export(module.exports, "transformQueryResults", ()=>$c9cbf8470d7adb43$export$142cac81f59c4a2b);
    $parcel$export(module.exports, "transformQueryData", ()=>$c9cbf8470d7adb43$export$e87b478b11690bbe);
    $parcel$export(module.exports, "tranformSubtaskData", ()=>$c9cbf8470d7adb43$export$2406de70fd65131a);
    $parcel$export(module.exports, "tranformModalLoadDataInContext", ()=>$c9cbf8470d7adb43$export$6f0b5e0a42086cba);
    var $9XE6b = parcelRequire("9XE6b");
    var $hGgHi = parcelRequire("hGgHi");
    var $jcw0u;
    var $4R6GH;
    var $bGrWH;
    var $3M1CO;
    var $5fc53;
    var $gItVn;
    var $do1Fc;
    var $cpg5L;
    var $ckBKW;
    const $c9cbf8470d7adb43$var$getTabLayoutInfoOld = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
        const fieldTabs = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.contentSection.items', []).map(({ id: id, name: name, items: items, tabId: tabId })=>{
            if (onlyRequiredField) {
                const filteredItems = items.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId));
                return filteredItems.length === 0 ? null : {
                    id: id,
                    name: name,
                    items: filteredItems.map(({ fieldId: fieldId })=>fieldId),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs') && {
                        tabId: tabId
                    }
                };
            }
            return {
                id: id,
                name: name,
                items: items.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId)).map(({ fieldId: fieldId })=>fieldId),
                ...(0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs') && {
                    tabId: tabId
                }
            };
        }).filter(Boolean);
        return fieldTabs;
    };
    const $c9cbf8470d7adb43$var$getTabLayoutInfoNew = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
        const fieldTabs = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.contentSection.items', []);
        return fieldTabs.map(({ id: id, name: name, items: items, collapsedItems: collapsedItems, tabId: tabId })=>{
            const filterItems = (itemsToFilter)=>itemsToFilter.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId)).map(({ fieldId: fieldId })=>fieldId);
            const filteredItems = filterItems(items || []);
            const filteredCollapsedItems = filterItems(collapsedItems || []);
            const result = {
                id: id,
                name: name,
                items: filteredItems,
                ...(0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs') && {
                    tabId: tabId
                }
            };
            result.collapsedItems = filteredCollapsedItems;
            if (onlyRequiredField && result.items.length === 0 && result.collapsedItems.length === 0) return null;
            return result;
        }).filter((tab)=>!!tab);
    };
    const $c9cbf8470d7adb43$export$1da66c24c878ae7 = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$var$getTabLayoutInfoNew({
            data: data,
            onlyRequiredField: onlyRequiredField,
            allFieldIds: allFieldIds
        });
        return $c9cbf8470d7adb43$var$getTabLayoutInfoOld({
            data: data,
            onlyRequiredField: onlyRequiredField,
            allFieldIds: allFieldIds
        });
    };
    const $c9cbf8470d7adb43$export$da99f019bcffa6fb = (timeTrackingSettings)=>{
        if (timeTrackingSettings) {
            const { defaultFormat: defaultFormat, workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultUnit: defaultUnit, isJiraConfiguredTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled } = timeTrackingSettings;
            let format = '';
            if (defaultFormat === 'DAYS') format = 'days';
            else if (defaultFormat === 'HOURS') format = 'hours';
            else format = 'pretty';
            let unit = '';
            if (defaultUnit === 'DAY') unit = 'day';
            else if (defaultUnit === 'HOUR') unit = 'hour';
            else if (defaultUnit === 'MINUTE') unit = 'minute';
            else unit = 'week';
            return {
                daysPerWeek: workingDaysPerWeek,
                hoursPerDay: workingHoursPerDay,
                format: format,
                defaultUnit: unit,
                isTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled
            };
        }
        return undefined;
    };
    const $c9cbf8470d7adb43$export$603097abf044854 = (data, onlyRequiredField = false)=>{
        const fields = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.fields.nodes', []);
        const contextFields = {};
        const fieldConfigData = {};
        const requiredFieldConfigData = {};
        let isRequiredFieldComponentSupported = true;
        let gqlTypeBeingProcessed;
        fields.forEach((fieldData)=>{
            try {
                const { __typename: gqlType, fieldId: fieldId, name: name, type: type, description: description, fieldConfig: fieldConfig = {}, searchUrl: searchUrl, mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig, isMulti: isMulti, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch, timeTrackingSettings: timeTrackingSettings, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize } = fieldData;
                gqlTypeBeingProcessed = gqlType;
                if (fieldId && !(0, (0, parcelRequire("bGrWH")).UNSUPPORTED_FIELD_TYPES_IN_GIC).includes(type)) {
                    if ((0, (0, parcelRequire("gItVn")).CONTEXT_FIELD_TYPES).includes(gqlType) && type !== (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)) {
                        let transformedData;
                        if (gqlType === (0, $962656cd6986cb06$export$aa5680ad8f8be9fc)) {
                            transformedData = (0, (0, parcelRequire("do1Fc")).transformProjectField)(fieldData);
                            contextFields[fieldId] = transformedData;
                        }
                        if (gqlType === (0, $962656cd6986cb06$export$2d5a62a3515ad4c6)) {
                            transformedData = (0, (0, parcelRequire("do1Fc")).transformIssueTypeField)(fieldData);
                            contextFields[fieldId] = transformedData;
                        }
                        if (gqlType === (0, $962656cd6986cb06$export$a12a4b25ab12710c)) {
                            const requestTypeFieldData = fieldData;
                            if (requestTypeFieldData?.requestType?.issueType) requestTypeFieldData.requestType.issueType.issueTypeName = contextFields?.issuetype?.selectedIssueType?.label;
                            transformedData = (0, (0, parcelRequire("do1Fc")).transformRequestTypeField)(requestTypeFieldData);
                            contextFields.requestType = transformedData;
                        }
                    } else {
                        const gqlTypeWithOverride = (0, (0, parcelRequire("ckBKW")).overrideGqlTypes)(fieldData);
                        const gqlFieldConfig = (0, (0, parcelRequire("gItVn")).getGqlFieldMap)()[gqlTypeWithOverride] || {};
                        const { defaultValueKey: defaultValueKey, allowedValuesKey: allowedValuesKey } = gqlFieldConfig;
                        let defaultValue;
                        if (Array.isArray(defaultValueKey)) defaultValue = defaultValueKey.map((key)=>key && (0, ($parcel$interopDefault($9XE6b)))(fieldData, key, undefined));
                        else defaultValue = defaultValueKey && (0, ($parcel$interopDefault($9XE6b)))(fieldData, defaultValueKey, undefined);
                        const allowedValues = allowedValuesKey && (0, ($parcel$interopDefault($9XE6b)))(fieldData, allowedValuesKey, undefined);
                        const isRequired = fieldConfig?.isRequired || false;
                        const isEditable = fieldConfig?.isEditable;
                        const nonEditableReason = fieldConfig?.nonEditableReason || {};
                        const copyLinksAndAttachments = gqlTypeWithOverride === (0, $962656cd6986cb06$export$47af4d6f62c134cf) && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? fieldData?.copyLinksAndAttachments : undefined;
                        fieldConfigData[fieldId] = {
                            gqlType: gqlTypeWithOverride,
                            fieldId: fieldId,
                            fieldName: name,
                            fieldType: type,
                            description: description,
                            isRequired: isRequired,
                            isEditable: isEditable,
                            nonEditableReason: nonEditableReason,
                            autoCompleteUrl: (0, (0, parcelRequire("3M1CO")).transformStargateUrl)(searchUrl || ''),
                            defaultValue: (0, ($parcel$interopDefault($hGgHi)))(defaultValue) ? undefined : defaultValue,
                            allowedValues: allowedValues,
                            additionalData: {
                                mediaContext: mediaContext,
                                isMulti: isMulti,
                                attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch,
                                timeTrackingSettings: $c9cbf8470d7adb43$export$da99f019bcffa6fb(timeTrackingSettings),
                                maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
                                ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                                    copyLinksAndAttachments: copyLinksAndAttachments
                                } : {}
                            }
                        };
                        if (adminRichTextConfig) fieldConfigData[fieldId].additionalData.adminRichTextConfig = adminRichTextConfig;
                        if (onlyRequiredField && isRequired) requiredFieldConfigData[fieldId] = fieldConfigData[fieldId];
                        if (isRequired && !('Component' in gqlFieldConfig)) isRequiredFieldComponentSupported = false;
                    }
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'processingApiFieldData',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        error: `processing ${gqlTypeBeingProcessed} failed`
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const errors = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.errors', []);
        const { unsupportedFields: unsupportedFields, isRequiredFieldTypeSupported: isRequiredFieldTypeSupported } = (0, (0, parcelRequire("cpg5L")).getGqlUnsupportedFields)(errors);
        return {
            fieldConfig: onlyRequiredField ? {
                ...requiredFieldConfigData
            } : {
                ...fieldConfigData,
                ...unsupportedFields
            },
            contextFields: contextFields,
            meta: {
                areRequiredFieldsSupported: isRequiredFieldTypeSupported && isRequiredFieldComponentSupported
            }
        };
    };
    const $c9cbf8470d7adb43$export$5fe007c334fc070a = (data)=>{
        const nodes = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateAdditionalServices.services.edges', []);
        const services = {};
        nodes.forEach(({ node: node })=>{
            services[node.serviceId] = node;
        });
        return services;
    };
    const $c9cbf8470d7adb43$export$142cac81f59c4a2b = (data, onlyRequiredField = false)=>{
        const fieldKeyedById = $c9cbf8470d7adb43$export$603097abf044854(data, onlyRequiredField);
        const { watchers: watchers, proforma: proforma } = $c9cbf8470d7adb43$export$5fe007c334fc070a(data);
        const result = {
            fieldTabs: $c9cbf8470d7adb43$export$1da66c24c878ae7({
                data: data,
                onlyRequiredField: onlyRequiredField,
                allFieldIds: Object.keys(fieldKeyedById.fieldConfig)
            }),
            ...fieldKeyedById,
            meta: {
                ...fieldKeyedById.meta,
                queryErrorMessage: (0, (0, parcelRequire("cpg5L")).getQueryErrorMessage)(data)
            },
            additionalServices: {
                watchersConfigurations: watchers?.permissions,
                proformaConfiguration: proforma?.proforma
            }
        };
        return $c9cbf8470d7adb43$var$validateRequiredFieldsFromTransformQueryResults(result);
    };
    const $c9cbf8470d7adb43$var$validateRequiredFieldsFromTransformQueryResults = (result)=>{
        const { fieldTabs: fieldTabs, fieldConfig: fieldConfig } = result;
        const newFieldTabs = fieldTabs.map((tab)=>{
            if (!tab.collapsedItems) return tab;
            const collapsedItems = tab.collapsedItems.filter((fieldId)=>{
                const field = fieldConfig[fieldId];
                if (field?.isRequired || fieldId === 'summary') return false;
                return true;
            });
            return {
                ...tab,
                collapsedItems: collapsedItems
            };
        });
        return {
            ...result,
            fieldTabs: newFieldTabs
        };
    };
    const $c9cbf8470d7adb43$export$e87b478b11690bbe = (data)=>({
            jiraIssueCreateFields: {
                ...data.jiraIssueCreateFields
            },
            ...data.jiraIssueCreateAdditionalServices ? {
                jiraIssueCreateAdditionalServices: {
                    ...data.jiraIssueCreateAdditionalServices
                }
            } : {},
            jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutWithML') ? {
                ...data.jiraIssueCreateLayoutWithML
            } : {
                ...data.jiraIssueCreateLayout
            }
        });
    const $c9cbf8470d7adb43$var$tranformSubtaskDataOld = (data)=>({
            jiraIssueCreateFields: {
                ...data.jiraSubtaskCreationFields
            },
            jiraIssueCreateLayout: {
                ...data.jiraSubtaskCreationLayout
            },
            jiraIssueCreateAdditionalServices: {
                ...data.jiraSubtaskCreationAdditionalServices
            }
        });
    const $c9cbf8470d7adb43$var$tranformSubtaskDataNew = (data)=>({
            jiraIssueCreateFields: {
                ...data.jiraSubtaskCreationFields
            },
            jiraIssueCreateAdditionalServices: {
                ...data.jiraSubtaskCreationAdditionalServices
            },
            jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraSubtaskCreationLayoutWithML') ? {
                ...data.jiraSubtaskCreationLayoutWithML
            } : {
                ...data.jiraSubtaskCreationLayout
            }
        });
    const $c9cbf8470d7adb43$export$2406de70fd65131a = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$var$tranformSubtaskDataNew(data);
        return $c9cbf8470d7adb43$var$tranformSubtaskDataOld(data);
    };
    const $c9cbf8470d7adb43$export$3882cbedc41c0e0a = (data)=>({
            jiraIssueCreateFields: {
                ...data.jiraIssueCreateFieldsInContext
            },
            jiraIssueCreateLayout: {
                ...data.jiraIssueCreateLayoutInContext
            },
            jiraIssueCreateAdditionalServices: {
                ...data.jiraIssueCreateAdditionalServices
            }
        });
    const $c9cbf8470d7adb43$export$9fb58334c8cb6162 = (data)=>({
            jiraIssueCreateFields: {
                ...data.jiraIssueCreateFieldsInContext
            },
            jiraIssueCreateAdditionalServices: {
                ...data.jiraIssueCreateAdditionalServices
            },
            jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutInContextWithML') ? {
                ...data.jiraIssueCreateLayoutInContextWithML
            } : {
                ...data.jiraIssueCreateLayoutInContext
            }
        });
    const $c9cbf8470d7adb43$export$6f0b5e0a42086cba = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) return $c9cbf8470d7adb43$export$9fb58334c8cb6162(data);
        return $c9cbf8470d7adb43$export$3882cbedc41c0e0a(data);
    };
});
parcelRegister("gItVn", function(module, exports) {
    $parcel$export(module.exports, "getGqlFieldMap", ()=>$e9926c7a0c5999db$export$472717ed4aec82f1);
    $parcel$export(module.exports, "UPDATE_FIELDS_CREATE_LINKED_ISSUE", ()=>$e9926c7a0c5999db$export$aed6a8ebeb442f9);
    $parcel$export(module.exports, "UPDATE_FIELDS", ()=>$e9926c7a0c5999db$export$e7c3e130e221f1f1);
    $parcel$export(module.exports, "CONTEXT_FIELD_TYPES", ()=>$e9926c7a0c5999db$export$ccf7c75b07963f11);
    var $8QpSo;
    var $co1wz;
    var $4R6GH;
    var $5kDIl;
    var $b6sRp;
    var $ii6hB;
    var $aZJYe;
    var $iZNZ0;
    var $id3OI;
    var $5FwUN;
    var $5rYSU;
    var $4kXb0;
    var $icXkU;
    var $bWtQ8;
    var $gbo8w;
    var $j0pqC;
    var $hy8Vj;
    var $bN8Bv;
    var $htVqS;
    var $1bQJO;
    var $ilY3g;
    var $cUXq3;
    var $776me;
    var $6vh1Z;
    var $iPfC3;
    var $9K1c2;
    var $2p4Te;
    var $iY8FG;
    var $cnfHu;
    var $fpis9;
    var $kEFc7;
    var $kRBrp;
    var $2cChB;
    var $h2h4F;
    var $8GQyc;
    var $evGBv;
    var $9sq52;
    var $kdeLq;
    var $5sz86;
    var $1IlAr;
    var $g2djo;
    var $eX2Td;
    var $gARR3;
    var $k5vQX;
    var $34EcD;
    var $bo14T;
    var $kU4qk;
    var $4oT51;
    var $jI6Lk;
    var $8mBES;
    var $eulr6;
    var $6GeOm;
    var $bNgRv;
    var $2QZDj;
    var $hnBts;
    var $lomXS;
    var $eWiSP;
    var $3mcIX;
    var $cOF52;
    var $5w5Vs;
    var $aPEdI;
    var $7gcm4;
    var $7Pdzq;
    var $3Z98Z;
    var $d8h6M;
    var $k4tyx;
    var $6HBPo;
    var $lfWSN;
    var $aQNfA;
    var $1AaWN;
    var $3pqs3;
    var $aqMtW;
    var $7nQJF;
    var $bB4xD;
    var $9cNbb;
    var $7svvp;
    var $b3x8f;
    var $d2fRu;
    var $iHPnC;
    var $2ngL6;
    var $em1U0;
    var $exGcw;
    var $6Fkzt;
    var $jv74C;
    var $feVbn;
    var $arYvt;
    var $6FMjJ;
    var $2QTbq;
    var $UwVOJ;
    var $deSKa;
    var $iVcsU;
    var $4IxfP;
    var $1D0eh;
    var $8TLRF;
    var $66d24;
    var $5pYli;
    var $5pHXe;
    var $249dD;
    var $1K3Xb;
    var $dTQPF;
    var $5fc53;
    var $162ej;
    var $aPcig;
    var $4nSAG;
    var $57aXd;
    var $7jsR9;
    var $4vfKb;
    var $h0fZ7;
    var $qzRgG;
    var $aeHT9;
    var $hPJET;
    var $3gK8l;
    var $kpa4m;
    var $f1o4d;
    var $cf9Hx;
    var $gsevN;
    const $e9926c7a0c5999db$var$createFieldMapItems = ()=>({
            [(0, $962656cd6986cb06$export$5e56d79dfe9be3d)]: {
                Component: (0, (0, parcelRequire("ii6hB")).default),
                defaultValueKey: 'selectedAffectedServices',
                submitTransform: (0, (0, parcelRequire("2ngL6")).mapOptionsToServiceEntities),
                retainUserInputTransform: (0, (0, parcelRequire("aZJYe")).mutateAffectedServicesField)
            },
            [(0, $962656cd6986cb06$export$23ca38ad884e35f1)]: {
                Component: (0, (0, parcelRequire("7nQJF")).default),
                defaultValueKey: 'text',
                retainUserInputTransform: (0, (0, parcelRequire("bB4xD")).mutateTextField)
            },
            [(0, $962656cd6986cb06$export$7e5590c7c7a403c0)]: {
                Component: (0, (0, parcelRequire("7nQJF")).default),
                defaultValueKey: 'text',
                retainUserInputTransform: (0, (0, parcelRequire("bB4xD")).mutateTextField)
            },
            [(0, $962656cd6986cb06$export$8643f0b9cefed538)]: {
                Component: (0, (0, parcelRequire("7nQJF")).default),
                defaultValueKey: 'text',
                retainUserInputTransform: (0, (0, parcelRequire("bB4xD")).mutateTextField)
            },
            [(0, $962656cd6986cb06$export$31a6c27df1f927b2)]: {
                Component: (0, (0, parcelRequire("4vfKb")).default),
                defaultValueKey: 'richText.adfValue.json',
                submitTransform: (0, (0, parcelRequire("h0fZ7")).sanitizeADFField),
                retainUserInputTransform: (0, (0, parcelRequire("h0fZ7")).mutateADFField)
            },
            [(0, $962656cd6986cb06$export$30b2c2de5e3007a4)]: {
                Component: (0, (0, parcelRequire("776me")).default),
                defaultValueKey: 'selectedComponents',
                allowedValuesKey: 'components.nodes',
                submitTransform: (0, (0, parcelRequire("6Fkzt")).mapOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("6vh1Z")).mutateComponentsField)
            },
            [(0, $962656cd6986cb06$export$f10e53e8928b61bd)]: {
                Component: (0, (0, parcelRequire("2p4Te")).default),
                defaultValueKey: [
                    'classificationLevel',
                    'defaultClassificationLevel'
                ],
                allowedValuesKey: 'classificationLevels.edges'
            },
            [(0, $962656cd6986cb06$export$3849bb04b4eee607)]: {
                Component: (0, (0, parcelRequire("lfWSN")).default),
                defaultValueKey: 'user',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateSingleUserPicker)
            },
            [(0, $962656cd6986cb06$export$745c8245fea49a34)]: {
                Component: (0, (0, parcelRequire("lfWSN")).default),
                defaultValueKey: 'user',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToAccountIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateSingleUserPicker)
            },
            [(0, $962656cd6986cb06$export$eca94ae30cb92d8)]: {
                Component: (0, (0, parcelRequire("gARR3")).default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateMultiUserPicker)
            },
            [(0, $962656cd6986cb06$export$d41ae99ff05f5cda)]: {
                Component: (0, (0, parcelRequire("gARR3")).default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateMultiUserPicker)
            },
            [(0, $962656cd6986cb06$export$bbc6b85844b0ade5)]: {
                Component: (0, (0, parcelRequire("gARR3")).default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToAccountIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateMultiUserPicker)
            },
            [(0, $962656cd6986cb06$export$2bb9d057bad89bfa)]: {
                Component: (0, (0, parcelRequire("6GeOm")).default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, (0, parcelRequire("bNgRv")).mapUserOptionOrOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("bNgRv")).mutatePeopleField)
            },
            [(0, $962656cd6986cb06$export$b1ac879bb5cdf30a)]: {
                Component: (0, (0, parcelRequire("6GeOm")).default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, (0, parcelRequire("bNgRv")).mapUserOptionOrOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("bNgRv")).mutatePeopleField)
            },
            [(0, $962656cd6986cb06$export$e4d5e04bc56680dc)]: {
                Component: (0, (0, parcelRequire("bo14T")).default),
                defaultValueKey: 'number',
                submitTransform: (0, (0, parcelRequire("kU4qk")).transformAsNumber),
                retainUserInputTransform: (0, (0, parcelRequire("kU4qk")).mutateNumberField)
            },
            [(0, $962656cd6986cb06$export$d854193d90dc547d)]: {
                Component: (0, (0, parcelRequire("bo14T")).default),
                defaultValueKey: 'number',
                submitTransform: (0, (0, parcelRequire("kU4qk")).transformAsNumber),
                retainUserInputTransform: (0, (0, parcelRequire("kU4qk")).mutateNumberField)
            },
            [(0, $962656cd6986cb06$export$e0ece81bd398c799)]: {
                Component: (0, (0, parcelRequire("bo14T")).default),
                defaultValueKey: 'number',
                submitTransform: (0, (0, parcelRequire("kU4qk")).transformAsNumber),
                retainUserInputTransform: (0, (0, parcelRequire("kU4qk")).mutateNumberField)
            },
            [(0, $962656cd6986cb06$export$d8312cdfa02c100d)]: {
                Component: (0, (0, parcelRequire("fpis9")).default),
                defaultValueKey: 'dateTime',
                submitTransform: (0, (0, parcelRequire("cnfHu")).transformDate),
                retainUserInputTransform: (0, (0, parcelRequire("kEFc7")).mutateDateTimeField)
            },
            [(0, $962656cd6986cb06$export$70ff025076e5fb13)]: {
                Component: (0, (0, parcelRequire("fpis9")).default),
                defaultValueKey: 'dateTime',
                submitTransform: (0, (0, parcelRequire("cnfHu")).transformDate),
                retainUserInputTransform: (0, (0, parcelRequire("kEFc7")).mutateDateTimeField)
            },
            [(0, $962656cd6986cb06$export$8723b724f0b3ac65)]: {
                Component: (0, (0, parcelRequire("qzRgG")).EpicLinkField),
                defaultValueKey: 'epic',
                submitTransform: (0, (0, parcelRequire("feVbn")).mapEpicLinkOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("kRBrp")).mutateEpicLinkField)
            },
            [(0, $962656cd6986cb06$export$64c7789e86344de5)]: {
                Component: (0, (0, parcelRequire("8GQyc")).default),
                defaultValueKey: 'selectedLabels',
                submitTransform: (0, (0, parcelRequire("2QTbq")).mapLabelOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("evGBv")).mutateLabelsFields)
            },
            [(0, $962656cd6986cb06$export$f596336c24b128f5)]: {
                Component: (0, (0, parcelRequire("8GQyc")).ForgeLabelsField),
                defaultValueKey: 'selectedLabels',
                submitTransform: (0, (0, parcelRequire("2QTbq")).mapLabelOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("evGBv")).mutateLabelsFields)
            },
            [(0, $962656cd6986cb06$export$3e8dded8d83b5d95)]: {
                Component: (0, (0, parcelRequire("iZNZ0")).default),
                defaultValueKey: 'selectedAssets',
                submitTransform: (0, (0, parcelRequire("id3OI")).mapAssetOptionsToAssetEntity),
                retainUserInputTransform: (0, (0, parcelRequire("id3OI")).mutateAssetsFields)
            },
            [(0, $962656cd6986cb06$export$f4f101295d5cc151)]: {
                Component: (0, (0, parcelRequire("aQNfA")).default),
                defaultValueKey: 'version',
                allowedValuesKey: 'versions.nodes',
                submitTransform: (0, (0, parcelRequire("dTQPF")).getVersionId),
                retainUserInputTransform: (0, (0, parcelRequire("1AaWN")).mutateSingleVersionField)
            },
            [(0, $962656cd6986cb06$export$5bb498d4f2f54799)]: {
                Component: (0, (0, parcelRequire("k5vQX")).default),
                defaultValueKey: 'selectedVersions',
                allowedValuesKey: 'versions.nodes',
                submitTransform: (0, (0, parcelRequire("dTQPF")).getVersionsIds),
                retainUserInputTransform: (0, (0, parcelRequire("34EcD")).mutateMultiVersionsField)
            },
            [(0, $962656cd6986cb06$export$de14210faa5f2099)]: {
                Component: (0, (0, parcelRequire("2QZDj")).default),
                defaultValueKey: 'priority',
                allowedValuesKey: 'priorities.nodes',
                submitTransform: (0, (0, parcelRequire("4IxfP")).mapOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("hnBts")).mutatePriorityField)
            },
            [(0, $962656cd6986cb06$export$e0b268941120d761)]: {
                Component: (0, (0, parcelRequire("iY8FG")).default),
                defaultValueKey: 'date',
                submitTransform: (0, (0, parcelRequire("cnfHu")).transformDate),
                retainUserInputTransform: (0, (0, parcelRequire("cnfHu")).mutateDateField)
            },
            [(0, $962656cd6986cb06$export$111f32c51678063a)]: {
                Component: (0, (0, parcelRequire("iY8FG")).default),
                defaultValueKey: 'date',
                submitTransform: (0, (0, parcelRequire("cnfHu")).transformDate),
                retainUserInputTransform: (0, (0, parcelRequire("cnfHu")).mutateDateField)
            },
            [(0, $962656cd6986cb06$export$909ba97f4a791588)]: {
                Component: (0, (0, parcelRequire("kpa4m")).default),
                defaultValueKey: 'securityLevel',
                allowedValuesKey: 'securityLevels.nodes',
                submitTransform: (0, (0, parcelRequire("f1o4d")).transformOnSubmit),
                retainUserInputTransform: (0, (0, parcelRequire("f1o4d")).mutateSecurityLevelField)
            },
            [(0, $962656cd6986cb06$export$76d811609080a7aa)]: {
                Component: (0, (0, parcelRequire("aeHT9")).default),
                defaultValueKey: 'selectedRoles',
                submitTransform: (0, (0, parcelRequire("5pYli")).mapRoleToRestrictionValue)
            },
            [(0, $962656cd6986cb06$export$f2b56433dc0af401)]: {
                Component: (0, (0, parcelRequire("b3x8f")).default),
                defaultValueKey: 'url',
                retainUserInputTransform: (0, (0, parcelRequire("d2fRu")).mutateUrlField)
            },
            [(0, $962656cd6986cb06$export$fb8861017089d392)]: {
                Component: (0, (0, parcelRequire("k4tyx")).default),
                defaultValueKey: 'fieldOption',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, (0, parcelRequire("5pHXe")).mapSelectOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("6HBPo")).mutateSingleSelectField)
            },
            [(0, $962656cd6986cb06$export$985c14eb8f3f0309)]: {
                Component: (0, (0, parcelRequire("k4tyx")).default),
                defaultValueKey: 'fieldOption',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, (0, parcelRequire("6HBPo")).mapSelectOptionsToConnectData),
                retainUserInputTransform: (0, (0, parcelRequire("6HBPo")).mutateSingleSelectField)
            },
            [(0, $962656cd6986cb06$export$2055419ff013de79)]: {
                Component: (0, (0, parcelRequire("g2djo")).default),
                defaultValueKey: 'selectedFieldOptions',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, (0, parcelRequire("5pHXe")).mapMultiSelectOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("eX2Td")).mutateMultiSelectField)
            },
            [(0, $962656cd6986cb06$export$9f6f73ea02649f83)]: {
                Component: (0, (0, parcelRequire("g2djo")).default),
                defaultValueKey: 'selectedFieldOptions',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, (0, parcelRequire("eX2Td")).mapMultiSelectOptionsToConnectData),
                retainUserInputTransform: (0, (0, parcelRequire("eX2Td")).mutateMultiSelectField)
            },
            [(0, $962656cd6986cb06$export$16fe78a07e97f2ad)]: {
                Component: (0, (0, parcelRequire("3Z98Z")).default),
                defaultValueKey: 'selectedGroup',
                submitTransform: (0, (0, parcelRequire("arYvt")).transformGroupToName),
                retainUserInputTransform: (0, (0, parcelRequire("d8h6M")).mutateSingleGroupPickerField)
            },
            [(0, $962656cd6986cb06$export$fd24d37af44fe736)]: {
                Component: (0, (0, parcelRequire("3Z98Z")).default),
                defaultValueKey: 'selectedGroup',
                submitTransform: (0, (0, parcelRequire("arYvt")).transformGroupToName),
                retainUserInputTransform: (0, (0, parcelRequire("d8h6M")).mutateSingleGroupPickerField)
            },
            [(0, $962656cd6986cb06$export$3a1ae3e0f2d9b1b9)]: {
                Component: (0, (0, parcelRequire("5sz86")).default),
                defaultValueKey: 'selectedGroups',
                submitTransform: (0, (0, parcelRequire("arYvt")).transformGroupsToNames),
                retainUserInputTransform: (0, (0, parcelRequire("1IlAr")).mutateMultipleGroupPickerField)
            },
            [(0, $962656cd6986cb06$export$3027db6317a2a8ea)]: {
                Component: (0, (0, parcelRequire("5sz86")).default),
                defaultValueKey: 'selectedGroups',
                submitTransform: (0, (0, parcelRequire("arYvt")).transformGroupsToNames),
                retainUserInputTransform: (0, (0, parcelRequire("1IlAr")).mutateMultipleGroupPickerField)
            },
            [(0, $962656cd6986cb06$export$64238d76a1dc0703)]: {
                Component: (0, (0, parcelRequire("3pqs3")).default),
                defaultValueKey: 'selectedSprints',
                submitTransform: (0, (0, parcelRequire("249dD")).mapSprintOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("aqMtW")).mutateJiraSprintField)
            },
            [(0, $962656cd6986cb06$export$47af4d6f62c134cf)]: {
                Component: (0, (0, parcelRequire("2cChB")).default),
                submitTransform: (0, (0, parcelRequire("6FMjJ")).mapOptionsToData),
                defaultValueKey: 'issueLinks',
                allowedValuesKey: 'issueLinkTypeRelations.nodes',
                retainUserInputTransform: (0, (0, parcelRequire("h2h4F")).mutateIssueLinksField)
            },
            [(0, $962656cd6986cb06$export$1070aada56fcaec9)]: {
                Component: (0, (0, parcelRequire("ilY3g")).default),
                defaultValueKey: 'color.colorKey',
                submitTransform: (0, (0, parcelRequire("iHPnC")).asServerColor),
                retainUserInputTransform: (0, (0, parcelRequire("cUXq3")).mutateIssueColorField)
            },
            [(0, $962656cd6986cb06$export$f57941b9c1949a82)]: {
                Component: (0, (0, parcelRequire("ilY3g")).default),
                defaultValueKey: 'color.colorKey',
                submitTransform: (0, (0, parcelRequire("iHPnC")).asClassicEpicColor),
                retainUserInputTransform: (0, (0, parcelRequire("cUXq3")).mutateEpicColorField)
            },
            [(0, $962656cd6986cb06$export$95433ac963f4aebe)]: {
                Component: (0, (0, parcelRequire("9cNbb")).default),
                defaultValueKey: 'richText.plainText',
                submitTransform: (0, (0, parcelRequire("1K3Xb")).convertTextToAdf),
                retainUserInputTransform: (0, (0, parcelRequire("7svvp")).mutateTextAreaField)
            },
            [(0, $962656cd6986cb06$export$67aca33725b6a717)]: {
                Component: (0, (0, parcelRequire("9cNbb")).default),
                defaultValueKey: 'object',
                submitTransform: (0, (0, parcelRequire("b6sRp")).transformJSONStringToObject),
                retainUserInputTransform: (0, (0, parcelRequire("7svvp")).mutateTextAreaField)
            },
            [(0, $962656cd6986cb06$export$f7a08bf17a7ac661)]: {
                Component: (0, (0, parcelRequire("5FwUN")).default),
                defaultValueKey: 'user',
                submitTransform: (0, (0, parcelRequire("5rYSU")).mapUserToAssigneeValue),
                retainUserInputTransform: (0, (0, parcelRequire("5rYSU")).mutateAssigneeUserPicker)
            },
            [(0, $962656cd6986cb06$export$d64150fd9c66969c)]: {
                Component: (0, (0, parcelRequire("cOF52")).default),
                defaultValueKey: 'user',
                submitTransform: (0, (0, parcelRequire("5kDIl")).mapUserOptionsToIds),
                retainUserInputTransform: (0, (0, parcelRequire("5kDIl")).mutateSingleUserPicker)
            },
            [(0, $962656cd6986cb06$export$252fb981af0e2e4e)]: {
                Component: (0, (0, parcelRequire("5w5Vs")).default),
                defaultValueKey: 'resolution',
                allowedValuesKey: 'resolutions.nodes',
                submitTransform: (0, (0, parcelRequire("66d24")).mapOptionToResolutionOption),
                retainUserInputTransform: (0, (0, parcelRequire("aPEdI")).mutateResolutionField)
            },
            [(0, $962656cd6986cb06$export$a9b3195cbef5c5ad)]: {
                Component: (0, (0, parcelRequire("7jsR9")).default),
                submitTransform: (0, (0, parcelRequire("bWtQ8")).getFileIdsFromFiles)
            },
            [(0, $962656cd6986cb06$export$a36509fae9e84682)]: {
                Component: (0, (0, parcelRequire("gbo8w")).default),
                defaultValueKey: 'cascadingOption',
                allowedValuesKey: 'cascadingOptions.nodes',
                submitTransform: (0, (0, parcelRequire("em1U0")).transformToServerValue),
                retainUserInputTransform: (0, (0, parcelRequire("j0pqC")).mutateCascadingSelectField)
            },
            [(0, $962656cd6986cb06$export$79443fedd031b437)]: {
                Component: (0, (0, parcelRequire("iPfC3")).default),
                defaultValueKey: 'selectedTeam',
                submitTransform: (0, (0, parcelRequire("jv74C")).transformTeamFieldTypeString),
                retainUserInputTransform: (0, (0, parcelRequire("9K1c2")).mutateTeamField)
            },
            [(0, $962656cd6986cb06$export$1c7f7cfd2029442f)]: {
                Component: (0, (0, parcelRequire("4kXb0")).default),
                defaultValueKey: 'JiraAtlassianTeamField',
                submitTransform: (0, (0, parcelRequire("icXkU")).transformAtlassianTeamFieldTypeString),
                retainUserInputTransform: (0, (0, parcelRequire("icXkU")).mutateAtlassianTeamField)
            },
            [(0, $962656cd6986cb06$export$597fa240de2bfd92)]: {
                Component: (0, (0, parcelRequire("htVqS")).default),
                defaultValueKey: 'selectedCmdbObjects',
                submitTransform: (0, (0, parcelRequire("1bQJO")).transformCmdbField),
                retainUserInputTransform: null
            },
            [(0, $962656cd6986cb06$export$864384797e544339)]: {
                Component: (0, (0, parcelRequire("4oT51")).default),
                defaultValueKey: 'selectedOrganizations',
                submitTransform: (0, (0, parcelRequire("UwVOJ")).mapOrganizationOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("jI6Lk")).mutateOrganizationsField)
            },
            [(0, $962656cd6986cb06$export$a138d5648dda03f0)]: {
                Component: (0, (0, parcelRequire("kdeLq")).default),
                defaultValueKey: 'richText.adfValue.json'
            },
            [(0, $962656cd6986cb06$export$aa5680ad8f8be9fc)]: {
                Component: (0, (0, parcelRequire("lomXS")).default),
                defaultValueKey: 'project',
                submitTransform: (0, (0, parcelRequire("1D0eh")).mapOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("eWiSP")).mutateProjectField)
            },
            [(0, $962656cd6986cb06$export$aecc734a7c3591d7)]: {
                Component: (0, (0, parcelRequire("cf9Hx")).default),
                submitTransform: (0, (0, parcelRequire("gsevN")).transformTimeTrackingValueToSubmitFormat),
                retainUserInputTransform: (0, (0, parcelRequire("gsevN")).mutateTimeTrackingField),
                defaultValueKey: 'originalEstimate'
            },
            [(0, $962656cd6986cb06$export$d9861709f0b70c10)]: {
                Component: (0, (0, parcelRequire("hPJET")).default),
                submitTransform: (0, (0, parcelRequire("9sq52")).getLogWorkSubmitValue)
            },
            [(0, $962656cd6986cb06$export$d10237d945259f96)]: {
                Component: (0, (0, parcelRequire("hy8Vj")).default),
                allowedValuesKey: 'fieldOptions.nodes',
                defaultValueKey: 'selectedFieldOptions',
                submitTransform: (0, (0, parcelRequire("exGcw")).mapOptionsToData),
                retainUserInputTransform: (0, (0, parcelRequire("bN8Bv")).mutateCheckboxField)
            },
            [(0, $962656cd6986cb06$export$670384150af5f49e)]: {
                Component: (0, (0, parcelRequire("3gK8l")).ParentLinkField),
                defaultValueKey: 'parentIssue',
                submitTransform: (0, (0, parcelRequire("deSKa")).mapOptionToData)
            },
            [(0, $962656cd6986cb06$export$bf9df74e065af482)]: {
                Component: (0, (0, parcelRequire("8mBES")).default),
                defaultValueKey: 'parentIssue',
                submitTransform: (0, (0, parcelRequire("iVcsU")).mapOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("eulr6")).mutateParentField)
            },
            ...(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui') ? {
                [(0, $962656cd6986cb06$export$33f8a9cb608132ba)]: {
                    Component: (0, (0, parcelRequire("7gcm4")).default),
                    defaultValueKey: 'selectedUsers',
                    submitTransform: (0, (0, parcelRequire("7Pdzq")).mapUserOptionsToAris)
                }
            } : {},
            [(0, $962656cd6986cb06$export$27854f490d658fc4)]: {
                Component: (0, (0, parcelRequire("3mcIX")).default),
                defaultValueKey: 'selectedOption',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, (0, parcelRequire("8TLRF")).mapOptionToData),
                retainUserInputTransform: (0, (0, parcelRequire("6HBPo")).mutateSingleSelectField)
            },
            [(0, $962656cd6986cb06$export$fc69de49ba08ae77)]: {
                Component: (0, (0, parcelRequire("4nSAG")).IssueCreateEntitlementField),
                defaultValueKey: 'selectedEntitlement',
                submitTransform: (0, (0, parcelRequire("57aXd")).mapEntitlementOptionToData),
                retainUserInputTransform: undefined
            },
            ...(0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap') ? {
                [(0, $962656cd6986cb06$export$ede7166f44cc4bd6)]: {
                    Component: (0, (0, parcelRequire("162ej")).IssueCreateOrganizationField),
                    defaultValueKey: 'selectedOrganization',
                    submitTransform: (0, (0, parcelRequire("aPcig")).mapOrganizationOptionToData),
                    retainUserInputTransform: undefined
                }
            } : {}
        });
    const $e9926c7a0c5999db$export$472717ed4aec82f1 = (0, (0, parcelRequire("8QpSo")).default)($e9926c7a0c5999db$var$createFieldMapItems);
    const $e9926c7a0c5999db$export$aed6a8ebeb442f9 = [
        (0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE),
        (0, (0, parcelRequire("5fc53")).WORK_LOG_TYPE),
        (0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)
    ];
    const $e9926c7a0c5999db$export$e7c3e130e221f1f1 = [
        (0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE),
        (0, (0, parcelRequire("5fc53")).WORK_LOG_TYPE)
    ];
    const $e9926c7a0c5999db$export$ccf7c75b07963f11 = [
        (0, $962656cd6986cb06$export$aa5680ad8f8be9fc),
        (0, $962656cd6986cb06$export$2d5a62a3515ad4c6),
        (0, $962656cd6986cb06$export$a12a4b25ab12710c)
    ];
});
parcelRegister("5kDIl", function(module, exports) {
    $parcel$export(module.exports, "transformJiraUserToUserOption", ()=>$5870d9a04b0eab40$export$3e406786572c35b0);
    $parcel$export(module.exports, "transformDefaultUserValues", ()=>$5870d9a04b0eab40$export$26760e7b66ccf1e1);
    $parcel$export(module.exports, "mapUserOptionsToIds", ()=>$5870d9a04b0eab40$export$2482a6858a4714ad);
    $parcel$export(module.exports, "mapUserOptionsToAccountIds", ()=>$5870d9a04b0eab40$export$e4490ea0dfe4173f);
    $parcel$export(module.exports, "mutateSingleUserPicker", ()=>$5870d9a04b0eab40$export$7937ee6404102aff);
    $parcel$export(module.exports, "mutateMultiUserPicker", ()=>$5870d9a04b0eab40$export$53e350638c0acebc);
    const $5870d9a04b0eab40$export$3e406786572c35b0 = (userData)=>({
            id: userData.accountId || '',
            name: userData.name || '',
            avatarUrl: userData.picture || ''
        });
    const $5870d9a04b0eab40$export$26760e7b66ccf1e1 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return defaultValue.map($5870d9a04b0eab40$export$3e406786572c35b0);
        return $5870d9a04b0eab40$export$3e406786572c35b0(defaultValue);
    };
    const $5870d9a04b0eab40$export$2482a6858a4714ad = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                id: option.id
            }));
        return {
            id: userOption.id
        };
    };
    const $5870d9a04b0eab40$export$e4490ea0dfe4173f = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                accountId: option.id
            }));
        return {
            accountId: userOption.id
        };
    };
    const $5870d9a04b0eab40$export$7937ee6404102aff = (selectedUser, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
            user: {
                accountId: selectedUser.id
            }
        });
    const $5870d9a04b0eab40$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$52003ca9b6035e0c),
            users: selectedUsers.map((user)=>({
                    accountId: user.id
                }))
        });
});
const $2b6d45687558f2b0$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $2b6d45687558f2b0$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';
parcelRegister("b6sRp", function(module, exports) {
    $parcel$export(module.exports, "transformJSONStringToObject", ()=>$93a6cb355dd35a44$export$2de59005e10fd82);
    var $agVdz = parcelRequire("agVdz");
    const $93a6cb355dd35a44$export$2de59005e10fd82 = (value)=>{
        try {
            if ((0, ($parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
        } catch (e) {
            return value;
        }
        return value;
    };
});
parcelRegister("agVdz", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $77a7c84c5ee0b808$var$stringTag = '[object String]';
    function $77a7c84c5ee0b808$var$isString(value) {
        return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
    }
    module.exports = $77a7c84c5ee0b808$var$isString;
});
parcelRegister("ii6hB", function(module, exports) {
    $parcel$export(module.exports, "AffectedServicesField", ()=>$387f926e9d9168ff$export$dbde2fdac14e77d6);
    $parcel$export(module.exports, "default", ()=>$387f926e9d9168ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $f0bro;
    var $7C5S0;
    var $YSJPS;
    var $hpV4g;
    var $gLdtQ;
    var $aZJYe;
    const $387f926e9d9168ff$export$dbde2fdac14e77d6 = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
        const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
        const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
        const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, (0, parcelRequire("aZJYe")).useFetchAffectedServicesName)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
                const ids = defaultValue.reduce((serviceIds, service)=>service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
                if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
                setShouldFetchServiceName(false);
            } else setSelectedOptions(value);
        }, [
            defaultValue,
            fetchAffectedServicesName,
            setSelectedOptions,
            shouldFetchServiceName,
            value
        ]);
        const getAffectedServicesEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f0bro")).default), {
                ...fieldProps,
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: selectedOptions,
                fieldId: fieldId,
                isInvalid: Boolean(error),
                isDisabled: !isEditable,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                fetchSuggestionsOnFocus: true
            });
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, getAffectedServicesEdit()) : getAffectedServicesEdit());
    };
    var $387f926e9d9168ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aZJYe")).transformDefaultAffectedServices)
    })($387f926e9d9168ff$export$dbde2fdac14e77d6);
});
parcelRegister("f0bro", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64bb95b3ef8c5394$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d7FF4;
    var $koVbs;
    var $lElIo;
    var $FtZX9;
    var $kEqrP;
    var $2WZSx;
    var $2ngL6;
    const $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $64bb95b3ef8c5394$var$AffectedServicesPickerEdit = (props)=>{
        const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const searchAffectedServices = async (query = '')=>{
            setLastFetchFailed(false);
            try {
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).start();
                const affectedServices = await (0, (0, parcelRequire("2ngL6")).fetchAffectedServices)(query, autoCompleteUrl);
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).success();
                return affectedServices;
            } catch (err) {
                setLastFetchFailed(true);
                (0, (0, parcelRequire("kEqrP")).fetchAffectedServicesExperience).failure();
                return [];
            }
        };
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await searchAffectedServices();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const loadOptionsDebounced = (0, (0, parcelRequire("FtZX9")).default)(searchAffectedServices, $64bb95b3ef8c5394$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
        const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, (0, parcelRequire("2WZSx")).default).failedFetch : (0, (0, parcelRequire("2WZSx")).default).noMatches), [
            formatMessage,
            lastFetchFailed
        ]);
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            ...fieldProps,
            classNamePrefix: "affected-services-picker",
            fieldId: fieldId,
            loadOptions: loadOptionsDebounced,
            onChange: onChange,
            autoFocus: false,
            ...defaultOptionsProps(),
            isClearable: Boolean(value),
            isMulti: true,
            value: value,
            validationState: isInvalid === true ? 'error' : null,
            noOptionsMessage: noOptionsMessage,
            placeholder: placeholder,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            "data-testid": "issue-field-affected-services.ui.edit.async-select"
        });
    };
    var $64bb95b3ef8c5394$export$2e2bcd8739ae039 = $64bb95b3ef8c5394$var$AffectedServicesPickerEdit;
});
parcelRegister("d7FF4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac4d84cf4438daea$export$2e2bcd8739ae039);
    var $eAthk;
    var $3c98u;
    const $ac4d84cf4438daea$var$AsyncSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("eAthk")).default));
    var $ac4d84cf4438daea$export$2e2bcd8739ae039 = $ac4d84cf4438daea$var$AsyncSelect;
});
parcelRegister("lElIo", function(module, exports) {
    $parcel$export(module.exports, "defaultSelectStyles", ()=>$f1f1a093823579de$export$b12192ea1a215e5f);
    $parcel$export(module.exports, "indicatorFixSelectStyles", ()=>$f1f1a093823579de$export$eca30945eaf474dd);
    var $gwIPs;
    const $f1f1a093823579de$export$b12192ea1a215e5f = {
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            }),
        menu: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            })
    };
    const $f1f1a093823579de$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
    const $f1f1a093823579de$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
    const $f1f1a093823579de$export$eca30945eaf474dd = {
        loadingIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            }),
        clearIndicator: (base)=>({
                ...base,
                paddingLeft: $f1f1a093823579de$var$inputIconPaddingLeft,
                paddingRight: $f1f1a093823579de$var$inputIconPaddingRight
            })
    };
    const $f1f1a093823579de$export$a9f371909ef7b4d6 = {
        container: (base)=>({
                ...base,
                border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R400})`}`,
                borderRadius: "var(--ds-space-050, 4px)"
            })
    };
});
parcelRegister("FtZX9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ebb46637e8f856b8$export$2e2bcd8739ae039);
    const $ebb46637e8f856b8$var$defer = ()=>{
        const deferred = {};
        deferred.promise = new Promise((resolve, reject)=>{
            deferred.resolve = resolve;
            deferred.reject = reject;
        });
        return deferred;
    };
    function $ebb46637e8f856b8$var$debounce(fn, wait = 0) {
        let deferred;
        let timer;
        let lastArgs;
        function flush() {
            const thisDeferred = deferred;
            clearTimeout(timer);
            if (thisDeferred) Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
            lastArgs = [];
            deferred = null;
        }
        return function debounced(...args) {
            if (deferred) clearTimeout(timer);
            else deferred = $ebb46637e8f856b8$var$defer();
            lastArgs = args;
            timer = setTimeout(flush.bind(this), wait);
            return deferred.promise;
        };
    }
    var $ebb46637e8f856b8$export$2e2bcd8739ae039 = $ebb46637e8f856b8$var$debounce;
});
parcelRegister("kEqrP", function(module, exports) {
    $parcel$export(module.exports, "graphModalExperience", ()=>$92ce1ce82a42bb8a$export$1b179afadba799dc);
    $parcel$export(module.exports, "rapidSearchExperience", ()=>$92ce1ce82a42bb8a$export$1a90deecc86e78f8);
    $parcel$export(module.exports, "autocompleteInsightFieldExperience", ()=>$92ce1ce82a42bb8a$export$94337fa170a193d2);
    $parcel$export(module.exports, "fetchAffectedServicesExperience", ()=>$92ce1ce82a42bb8a$export$ce8d2a860f4e0316);
    $parcel$export(module.exports, "objectDetailsViewExperience", ()=>$92ce1ce82a42bb8a$export$8e0a16d0fc0feba3);
    $parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", ()=>$92ce1ce82a42bb8a$export$5ae0e1bbe443c52b);
    $parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", ()=>$92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4);
    $parcel$export(module.exports, "createObjectTypeExperience", ()=>$92ce1ce82a42bb8a$export$15a29f6e079c9b3d);
    $parcel$export(module.exports, "createObjectExperience", ()=>$92ce1ce82a42bb8a$export$aaf507c87c29ab22);
    $parcel$export(module.exports, "loadSchemaObjectListExperience", ()=>$92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f);
    $parcel$export(module.exports, "loadAttributesConfigurationExperience", ()=>$92ce1ce82a42bb8a$export$8f63f06b0486e498);
    $parcel$export(module.exports, "updateObjectFilterExperience", ()=>$92ce1ce82a42bb8a$export$967859e6be8e6f4b);
    $parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", ()=>$92ce1ce82a42bb8a$export$e4deb66475dfa46b);
    $parcel$export(module.exports, "loadObjectDetailExperience", ()=>$92ce1ce82a42bb8a$export$3f1da23c065671d2);
    var $atdLB;
    var $duUGa;
    const $92ce1ce82a42bb8a$export$1b179afadba799dc = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$1a90deecc86e78f8 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$94337fa170a193d2 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        featureFlags: [
            'jsm-insight-field-performance-improvements_fplgq'
        ]
    });
    const $92ce1ce82a42bb8a$export$ce8d2a860f4e0316 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$8e0a16d0fc0feba3 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cmdb-object-details-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$5ae0e1bbe443c52b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$b9c9c5e92fa6a3a4 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$15a29f6e079c9b3d = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cmdb-create-object-type', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        timings: [
            {
                key: 'created-on-server',
                endMark: 'object-type-created-on-server'
            }
        ]
    });
    const $92ce1ce82a42bb8a$export$aaf507c87c29ab22 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.create-object', {
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
    });
    const $92ce1ce82a42bb8a$export$6f02ba4c2b1e3f5f = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cmdb-load-object-list', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$8f63f06b0486e498 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cmdb-load-attributes-tab', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $92ce1ce82a42bb8a$export$967859e6be8e6f4b = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cmdb-object-filter', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        timings: [
            {
                key: 'response-received',
                endMark: 'server-response-received'
            },
            {
                key: 'object-table-rendered',
                endMark: 'object-table-rendered'
            },
            {
                key: 'object-list-rendered',
                endMark: 'object-list-rendered'
            },
            {
                key: 'no-filter-results-rendered',
                endMark: 'no-filter-results-rendered'
            }
        ]
    });
    const $92ce1ce82a42bb8a$export$e4deb66475dfa46b = ()=>new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
            performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult,
            type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience
        });
    const $92ce1ce82a42bb8a$export$3f1da23c065671d2 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
});
parcelRegister("2WZSx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a56352311f156b3$export$2e2bcd8739ae039);
    var $7VHMR;
    const $9a56352311f156b3$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-affected-services.edit.no-matches",
            "defaultMessage": "No Matches"
        },
        failedFetch: {
            "id": "issue-field-affected-services.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        }
    });
    var $9a56352311f156b3$export$2e2bcd8739ae039 = $9a56352311f156b3$var$messages;
});
parcelRegister("2ngL6", function(module, exports) {
    $parcel$export(module.exports, "mapServiceEntitiesToOptions", ()=>$ee273b75b82219a4$export$23b96a30f377b741);
    $parcel$export(module.exports, "mapOptionsToServiceEntities", ()=>$ee273b75b82219a4$export$7dcfc49587479fac);
    $parcel$export(module.exports, "fetchAffectedServices", ()=>$ee273b75b82219a4$export$66d34216c85d32cb);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    const $ee273b75b82219a4$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
                label: name,
                value: id
            }));
    const $ee273b75b82219a4$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
                id: value,
                name: label
            }));
    const $ee273b75b82219a4$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify({
            query: inputValue
        });
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$ee273b75b82219a4$export$23b96a30f377b741(response.services)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchAffectedServices',
                packageName: 'jiraIssueFieldAffectedServices',
                logToSentry: !(0, (0, parcelRequire("jJZqs")).isValidationError)(error),
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    errorMessage: error.message
                }
            });
            throw error;
        });
    };
});
parcelRegister("7C5S0", function(module, exports) {
    $parcel$export(module.exports, "FieldContainer", ()=>$17c5ea94a7a7a600$export$b5c4b0e7cd7f148b);
    $parcel$export(module.exports, "Description", ()=>$17c5ea94a7a7a600$export$393edc798c47379d);
    $parcel$export(module.exports, "SelectContainer", ()=>$17c5ea94a7a7a600$export$446eebadefe1123b);
    $parcel$export(module.exports, "Divider", ()=>$17c5ea94a7a7a600$export$2e0a83ec2e27ecbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $c0dQj;
    const $17c5ea94a7a7a600$export$b5c4b0e7cd7f148b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_m2j5rp": (0, (0, parcelRequire("lD23V")).default)((()=>{
                    return typeof (__cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350)) === 'number' ? `${__cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350)}px` : __cmplp.width ?? ((0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)() ? '100%' : 350);
                })()),
                "--_1glwpqj": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.marginTop ?? 0}px`),
                "--_1i3s0vn": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.paddingBottom ?? 0}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb13r0 _19pknek2 _n3td11zn",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$393edc798c47379d = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$446eebadefe1123b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mjv",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$2e0a83ec2e27ecbb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3it94y _1bsb1osq _bfhkb5v6 _18s8gx6n",
                __cmplp.className
            ])
        });
    });
    const $17c5ea94a7a7a600$export$32dd8f1956fe77b1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("YSJPS", function(module, exports) {
    $parcel$export(module.exports, "StyledFieldSkeleton", ()=>$f113eb09b8933f94$export$ed5de990fe261b7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    const $f113eb09b8933f94$export$ed5de990fe261b7b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _1bsb1edt _otyr12x7",
                __cmplp.className
            ])
        });
    });
    $f113eb09b8933f94$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';
});
parcelRegister("1wbtX", function(module, exports) {
    $parcel$export(module.exports, "getKeyframes", ()=>$39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
    $parcel$export(module.exports, "Skeleton", ()=>$39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "Spacer", ()=>$39c21c8edc6f2616$export$d7a54cba636a8cd6);
    $parcel$export(module.exports, "SkeletonCompiled", ()=>$39c21c8edc6f2616$export$dc84d515085190e);
    $parcel$export(module.exports, "SpacerCompiled", ()=>$39c21c8edc6f2616$export$e477bb7d17087f28);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
        const fromPositionX = -Math.abs(offsetX) - 300;
        const toPositionX = fromPositionX + 2000;
        return (0, $47bDC.keyframes)({
            '0%': {
                backgroundPosition: `${fromPositionX}px 0`
            },
            '100%': {
                backgroundPosition: `${toPositionX}px 0`
            }
        });
    };
    const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
    const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-0"
    })((props)=>({
            animationDelay: props.theme.animationDelay || '0s',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`,
            backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $829f609a65d26a98$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $829f609a65d26a98$exports).N30})`} 50% )`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            height: props.height,
            width: props.width
        }));
    const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-1"
    })((props)=>({
            height: props.height
        }));
    const $39c21c8edc6f2616$export$dc84d515085190e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
                __cmplp.className
            ])
        });
    });
    const $39c21c8edc6f2616$export$e477bb7d17087f28 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1474",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hpV4g", function(module, exports) {
    $parcel$export(module.exports, "withFormField", ()=>$b3f935405140180d$export$17bf6386ac4a43ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7O4UO;
    var $dC5iT;
    var $8CUq3;
    var $7CMCs;
    var $jcw0u;
    var $4R6GH;
    var $5pZ9g;
    var $7Emtg;
    var $6cMZg;
    var $gifeQ;
    var $bPtOr;
    var $fl3Yy;
    var $1MgIu;
    var $3IJWP;
    var $59xJP;
    var $mTNgq;
    var $5eGnF;
    var $9svjh;
    var $2eeg1;
    var $dCm1o;
    var $aBZin;
    var $45JN1;
    var $iblgc;
    var $86fzT;
    const $b3f935405140180d$export$17bf6386ac4a43ba = (options)=>(Component)=>(ownProps)=>{
                const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
                const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
                const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
                const description = (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) ? (0, (0, parcelRequire("1MgIu")).extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
                const hasSentTransformDefaultValueError = (0, $5uXOq.useRef)(false);
                let transformedDefaultValue;
                try {
                    if (defaultValueDontTransform) transformedDefaultValue = defaultValue;
                    else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
                } catch (error) {
                    if (hasSentTransformDefaultValueError.current === false) {
                        hasSentTransformDefaultValueError.current = true;
                        (0, (0, parcelRequire("jcw0u")).default)({
                            meta: {
                                id: 'defaultValueTransformation',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            attributes: {
                                fieldType: fieldType
                            },
                            sendToPrivacyUnsafeSplunk: true
                        });
                    }
                }
                (0, $5uXOq.useLayoutEffect)(()=>{
                    onLayoutDone && onLayoutDone();
                }, [
                    onLayoutDone
                ]);
                const shouldSetWidth = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
                const renderComponent = (fieldProps, error)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                        ...ownPropsRest,
                        fieldId: fieldId,
                        fieldName: fieldName,
                        isRequired: isRequired,
                        fieldProps: fieldProps,
                        width: shouldSetWidth ? '100%' : undefined,
                        isMini: isMini,
                        description: description,
                        defaultValue: defaultValue,
                        error: error,
                        key: componentKey,
                        ariaLabelledBy: `${fieldId}-field-label`
                    });
                const renderFieldMessage = (0, $5uXOq.useCallback)((error)=>{
                    if (shouldRenderFieldMessage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
                        fieldId: fieldId,
                        description: description,
                        error: error,
                        fieldName: fieldName,
                        fieldHelpTextUrl: fieldHelpTextUrl,
                        onLinkClickEvent: onLinkClickEvent,
                        isMini: isMini
                    });
                    return null;
                }, [
                    description,
                    fieldHelpTextUrl,
                    fieldId,
                    fieldName,
                    isMini,
                    onLinkClickEvent,
                    shouldRenderFieldMessage
                ]);
                const extension = (0, $5uXOq.useMemo)(()=>{
                    if (typeof fieldType === 'string' && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, (0, parcelRequire("6cMZg")).getExtension)(fieldType, forge?.modules);
                    return null;
                }, [
                    fieldType,
                    forge?.modules,
                    forge?.hasFinishedLoading
                ]);
                (0, $5uXOq.useEffect)(()=>{
                    const shouldReportFailure = typeof fieldType === 'string' && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                    if (shouldReportFailure) (0, (0, parcelRequire("7Emtg")).reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
                }, [
                    fieldType,
                    extension,
                    forge?.modules,
                    forge?.filteredOutModules,
                    forge?.hasFinishedLoading
                ]);
                const renderFieldContent = (fieldProps, error)=>{
                    if (isCollapsed && (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) return null;
                    const fieldPropsWithPublish = {
                        ...fieldProps,
                        onChange: (value, ...rest)=>{
                            fieldProps.onChange(value, ...rest);
                            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                                fieldId: fieldId,
                                fieldName: fieldName,
                                fieldType: fieldType,
                                value: (0, (0, parcelRequire("aBZin")).getValueFromEventOrValue)(value)
                            });
                        }
                    };
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fieldType !== undefined && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5pZ9g")).ForgeField), {
                        fieldId: fieldId,
                        fieldName: fieldName,
                        fieldType: fieldType,
                        fieldProps: fieldPropsWithPublish,
                        error: error,
                        selectedProject: forge?.selectedProject,
                        selectedIssueType: forge?.selectedIssueType,
                        extension: extension,
                        renderFieldMessage: renderFieldMessage,
                        renderDefaultComponent: renderComponent
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, fieldWrapperElement ? (0, $5uXOq.cloneElement)(fieldWrapperElement, {}, [
                        renderComponent(fieldPropsWithPublish, error),
                        renderFieldMessage(error)
                    ]) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
                };
                const renderFieldLabel = (0, $5uXOq.useCallback)(()=>{
                    if (isCollapsed && (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) return '';
                    if (shouldHideLabel) return '';
                    if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType)) {
                        const { environment: environment } = (0, (0, parcelRequire("1MgIu")).extractEnvFromFieldDescription)(descriptionRaw);
                        return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f935405140180d$var$ForgeLabel, null, fieldName, " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                            environmentType: environment
                        }));
                    }
                    return fieldName;
                }, [
                    fieldName,
                    fieldType,
                    shouldHideLabel,
                    descriptionRaw,
                    isCollapsed
                ]);
                if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iblgc")).FieldSkeleton), null);
                if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && !extension) return null;
                const renderField = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    id: `${fieldId}-field`,
                    label: renderFieldLabel(),
                    elementAfterLabel: areUiModificationsBusy ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("59xJP")).FieldBusyIndicator), {
                        fieldId: fieldId
                    }) : undefined,
                    isRequired: isRequired,
                    name: fieldId,
                    defaultValue: transformedDefaultValue,
                    key: (0, (0, parcelRequire("86fzT")).generateKeyForRequiredFromUIM)({
                        fieldId: fieldId,
                        isRequiredFromUIM: isRequiredFromUIM === true
                    }),
                    validate: (value, _formState, { dirty: dirty })=>{
                        try {
                            const { type: type } = ownPropsRest;
                            if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) && isRequired) return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                            return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        } catch (error) {
                            (0, (0, parcelRequire("jcw0u")).default)({
                                meta: {
                                    id: 'fieldValidationIssue',
                                    packageName: 'jiraIssueCreateCommons',
                                    teamName: 'gryffindor'
                                },
                                error: error,
                                sendToPrivacyUnsafeSplunk: true
                            });
                            return undefined;
                        }
                    }
                }, ({ fieldProps: fieldProps, error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassOutput), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                        id: "issueAdjustmentsFieldValueDecorator",
                        packageName: "jiraIssueCreateModal",
                        fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps, error)),
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: (err)=>({
                                errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(err),
                                viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                                fieldId: fieldId,
                                fieldType: fieldType
                            })
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2eeg1")).FieldValueDecoratorAsync), {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        fieldProps: fieldProps
                    }, (interceptedFieldProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error))))));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "withFormField",
                    packageName: "jiraIssueCreateModal",
                    fallback: "unmount",
                    sendToPrivacyUnsafeSplunk: true
                }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && fieldId === 'assignee' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $b3f935405140180d$var$fieldStyles
                }, " ", renderField, " ") : renderField);
            };
    const $b3f935405140180d$var$ForgeLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81il0 _1e0c116y _4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $b3f935405140180d$var$fieldStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
});
parcelRegister("7O4UO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e20204ce79b642c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $9KnKW;
    var $dRN65;
    var $efXp3;
    var $2x3Cb;
    var $kxqHl;
    var $6cAn5 = parcelRequire("6cAn5");
    function $7e20204ce79b642c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7e20204ce79b642c$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $7e20204ce79b642c$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $7e20204ce79b642c$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $7e20204ce79b642c$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("efXp3")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
        const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $7e20204ce79b642c$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kxqHl")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("dRN65", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$706cd4dbd4574fd7$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $706cd4dbd4574fd7$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("efXp3", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$987e2ff089e89967$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$987e2ff089e89967$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$987e2ff089e89967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $987e2ff089e89967$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $987e2ff089e89967$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("2x3Cb", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$987b76a5b7a0ea9b$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$987b76a5b7a0ea9b$export$ed247974535929c7);
    var $f8Sb3;
    function $987b76a5b7a0ea9b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $987b76a5b7a0ea9b$var$fieldsetLabelStyles
        }, children);
    };
    var $987b76a5b7a0ea9b$export$2e2bcd8739ae039 = $987b76a5b7a0ea9b$export$b04be29aa201d4f5;
});
parcelRegister("kxqHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55ac25356e81a33$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d55ac25356e81a33$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d55ac25356e81a33$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d55ac25356e81a33$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
parcelRegister("5pZ9g", function(module, exports) {
    $parcel$export(module.exports, "ForgeField", ()=>$297a009f70430225$export$34a15d6027142c62);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $2RhPB;
    var $7Aezm;
    var $g5X3G;
    var $gifeQ;
    var $ELVDL;
    var $j5sSv;
    var $7fjFA;
    var $6cMZg;
    const $297a009f70430225$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
        const { onChange: onChange, value: value } = fieldProps;
        const extensionPayload = (0, $5uXOq.useMemo)(()=>{
            if (value === undefined) return {
                fieldValue: null
            };
            return {
                fieldValue: (0, (0, parcelRequire("6cMZg")).transformValueToExtensionData)(value, extension)
            };
        }, [
            extension,
            value
        ]);
        const extensionData = (0, $5uXOq.useMemo)(()=>{
            const defaultExtensionData = {
                fieldId: fieldId,
                fieldType: (0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
                fieldName: fieldName,
                renderContext: 'issue-create'
            };
            if (!selectedProject || !selectedIssueType) return defaultExtensionData;
            const issueTypeId = (0, (0, parcelRequire("g5X3G")).toIssueTypeId)(selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
            return {
                ...defaultExtensionData,
                project: {
                    id: (0, (0, parcelRequire("g5X3G")).toProjectId)(selectedProject.value),
                    key: (0, (0, parcelRequire("g5X3G")).toProjectKey)(selectedProject.projectKey),
                    type: selectedProject.projectType
                },
                issue: {
                    type: selectedIssueType.type === (0, $5363dcf42759d41f$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                    typeId: issueTypeId
                }
            };
        }, [
            selectedProject,
            selectedIssueType,
            fieldId,
            fieldName,
            fieldType
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                renderContext: 'issue-create',
                fieldType: extension?.properties.type,
                module: extension?.type,
                ...extension ? (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension) : {}
            }), [
            extension
        ]);
        if (!extension) return null;
        const renderDefaultView = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderDefaultComponent(fieldProps, error), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
                attributes: {
                    ...analyticsAttributes,
                    renderMode: 'default'
                }
            }));
        if (!extension.properties.edit) return renderDefaultView();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ELVDL")).EditMode), {
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            analyticsAttributes: analyticsAttributes,
            onChange: onChange
        });
    };
    const $297a009f70430225$export$34a15d6027142c62 = (props)=>{
        const { renderFieldMessage: renderFieldMessage, ...rest } = props;
        const { fieldId: fieldId, extension: extension, error: error } = rest;
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                renderContext: 'issue-create',
                ...extension && (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension)
            }), [
            extension
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Aezm")).EditAnalyticsWrapper), {
            attributes: analyticsAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j5sSv")).FieldContainer), {
            width: "100%",
            paddingBottom: 6
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($297a009f70430225$export$4f0175d9150f8767, rest), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7fjFA")).ForgeFieldMessage), {
            error: error,
            fieldId: fieldId,
            renderFieldMessage: renderFieldMessage
        })));
    };
});
parcelRegister("1rTGO", function(module, exports) {
    $parcel$export(module.exports, "ForgeScreenEvent", ()=>$abbdb580491d9d09$export$92d758d83665314b);
    $parcel$export(module.exports, "ForgeOperationaFailedEvent", ()=>$abbdb580491d9d09$export$a238c3c13f29c134);
    $parcel$export(module.exports, "ForgeErrorBoundary", ()=>$abbdb580491d9d09$export$ac7e7464cefab440);
    $parcel$export(module.exports, "ForgeAnalyticsWrapper", ()=>$abbdb580491d9d09$export$ad2a5d9127152fb8);
    $parcel$export(module.exports, "withMetrics", ()=>$abbdb580491d9d09$export$14e56d7f5d3f917c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $k2DRb;
    var $3mOWa;
    var $eOGyv;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $isuse;
    var $hBuqR;
    var $6MtPV;
    var $dd7Uh;
    var $2RhPB;
    var $9BrHy;
    var $8kVg1;
    const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes)
        });
    const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
            eventId: eventId,
            attributes: attributes
        });
        return null;
    };
    const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
        const hasForgeAccess = (0, (0, parcelRequire("eOGyv")).useHasForgeAccess)();
        const analyticsAttributes = (0, (0, parcelRequire("6MtPV")).createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        });
        const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, (0, parcelRequire("9BrHy")).getEventActionName)(eventId, action), analyticsAttributes);
        }, [
            eventId,
            action,
            analyticsAttributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: fireEvent
        });
    };
    const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.${eventId}`
        }, children);
    const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
        const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
            errorFallback
        ]);
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6MtPV")).createAttributes)({
                ...attributes,
                error: error
            }), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: eventId,
            packageName: (0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3),
            teamName: "smite",
            fallback: fallback,
            attributes: getAttributes,
            onError: onError,
            resetCaughtError: resetCaughtError
        }, children);
    };
    const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
        const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
            module: module,
            moduleType: moduleType,
            entryPoint: entryPoint
        });
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6MtPV")).createAttributes)(attributes), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
            eventId: eventId,
            attributes: analyticsAttributes,
            errorFallback: errorFallback,
            resetCaughtError: resetCaughtError
        }, shouldFireInitializedEvent && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
            eventId: eventId,
            action: "initialized",
            attributes: analyticsAttributes
        }), children));
    };
    function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
        if ((extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE) || extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
        if (extensionModule === (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
        return [
            (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_NAVIGATOR_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).BACKLOG_ACTION_MODULE)
        ].includes(extensionModule);
    }
    const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
            const startTime = (0, $5uXOq.useRef)(performance.now());
            const isCustomUI = (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, props.entryPoint);
            const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
            const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
            const extensionId = props.extension?.id;
            const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
                module: module,
                entryPoint: entryPoint
            });
            const browserMetricsEventId = (0, (0, parcelRequire("9BrHy")).getBrowserMetricsEventId)({
                module: module,
                entryPoint: entryPoint,
                forgeUiType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint)
            });
            const attributes = (0, $5uXOq.useMemo)(()=>({
                    ...analyticsAttributes,
                    ...(0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension, entryPoint)
                }), [
                analyticsAttributes,
                entryPoint,
                extension.id,
                isCustomUI
            ]);
            (0, $5uXOq.useEffect)(()=>{
                if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
                    startTime: startTime.current
                });
            }, []);
            const onError = (0, $5uXOq.useCallback)(()=>{
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).cancel();
            }, [
                extensionId
            ]);
            const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
                onInitialRender && onInitialRender(payload);
                if (payload?.error == null) {
                    const stopTimeDeduction = payload?.appTime || 0;
                    setExtensionRendered(true);
                    extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: browserMetricsEventId
                        }
                    });
                } else {
                    onError();
                    (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
                        eventId: eventId,
                        attributes: {
                            error: new Error(payload.error),
                            ...attributes
                        }
                    });
                }
            }, [
                onInitialRender,
                extensionId,
                browserMetricsEventId,
                onError,
                eventId,
                attributes
            ]);
            const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
                onLoad && onLoad();
                setExtensionRendered(true);
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now(),
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            }, [
                analyticsAttributes,
                extensionId,
                localId,
                onLoad
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
                eventId: eventId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...isCustomUI ? {
                    onLoad: onLoadCustomUiWithMetrics
                } : {
                    onInitialRender: onInitialRenderUiKitWithMetrics
                }
            }), isExtensionRendered && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
                attributes: attributes
            }));
        };
});
parcelRegister("3mOWa", function(module, exports) {
    $parcel$export(module.exports, "getForgeUIType", ()=>$e79bbc527e600bd1$export$aed4d8a86badbf61);
    $parcel$export(module.exports, "isCustomUIExtension", ()=>$e79bbc527e600bd1$export$edb00cfe4962b026);
    $parcel$export(module.exports, "isNativeUiExtension", ()=>$e79bbc527e600bd1$export$2ecba06e617fea0a);
    $parcel$export(module.exports, "overrideExtension", ()=>$e79bbc527e600bd1$export$42b85bc9b386c977);
    var $gccSB = parcelRequire("gccSB");
    var $e5wyW;
    var $4R6GH;
    const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
        const { render: render, resource: resource } = extension.properties;
        if (entryPoint && extension.properties[entryPoint]) {
            const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
            if (entryPointResource == null) return 'ui-kit';
            if (entryPointRender === 'native') return 'native-ui';
            return 'custom-ui';
        }
        if (resource == null) return 'ui-kit';
        if (render === 'native') return 'native-ui';
        return 'custom-ui';
    };
    const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
    const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
    const $e79bbc527e600bd1$var$overrideExtensionV2 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            }
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
    const $e79bbc527e600bd1$var$overrideExtensionV1 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            },
            requiresUserConsent: requiresUserConsent
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
    const $e79bbc527e600bd1$export$42b85bc9b386c977 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $e79bbc527e600bd1$var$overrideExtensionV2, $e79bbc527e600bd1$var$overrideExtensionV1);
});
parcelRegister("eOGyv", function(module, exports) {
    $parcel$export(module.exports, "useHasForgeAccess", ()=>$5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);
    var $cZpsT;
    const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return !isAnonymous;
    };
});
parcelRegister("dd7Uh", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$7d829a81d29f9e72$export$add44f896fb31ba3);
    var $hBuqR;
    var $8uOa6;
    const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: eventId,
            attributes: attributes
        });
    };
});
parcelRegister("2RhPB", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAttributesFromExtension", ()=>$3fba0b567cec1fe0$export$5d3b06ab08af139e);
    var $3mOWa;
    var $e0AC8;
    const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return {
            appId: appId,
            envId: envId,
            forgeType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint),
            envType: extension?.environmentType
        };
    };
});
parcelRegister("9BrHy", function(module, exports) {
    $parcel$export(module.exports, "getEventId", ()=>$10bc2a9e37d5a5bb$export$5639f6a927500d9);
    $parcel$export(module.exports, "getBrowserMetricsEventId", ()=>$10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
    $parcel$export(module.exports, "getEventActionName", ()=>$10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);
    var $k2DRb;
    var $6yg2S;
    var $hBuqR;
    const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
    const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
    const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
    const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, (0, parcelRequire("k2DRb")).SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
    const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
        const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
        return (0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
    };
    const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
    const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${eventId} ${action}`;
});
parcelRegister("7Aezm", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$f6c5a5a43a090916$export$c794eb4124961145);
    $parcel$export(module.exports, "EditAnalyticsWrapper", ()=>$f6c5a5a43a090916$export$947ae3996b2bc000);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    const $f6c5a5a43a090916$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $f6c5a5a43a090916$export$947ae3996b2bc000 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
            ...props
        });
});
parcelRegister("gifeQ", function(module, exports) {
    $parcel$export(module.exports, "isForgeCustomField", ()=>$89f92c26c7f930da$export$78cf1b56a8dede1f);
    $parcel$export(module.exports, "isForgeLegacyFieldType", ()=>$89f92c26c7f930da$export$3fb46a1fa454ffea);
    $parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", ()=>$89f92c26c7f930da$export$2b6a9cc67d548886);
    $parcel$export(module.exports, "focusFormButton", ()=>$89f92c26c7f930da$export$f1a0ef98758e7a8a);
    var $k2DRb;
    const $89f92c26c7f930da$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, (0, parcelRequire("k2DRb")).LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, (0, parcelRequire("k2DRb")).FORGE_FIELD_TYPE_PREFIX)));
    const $89f92c26c7f930da$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, (0, parcelRequire("k2DRb")).LEGACY_FORGE_FIELD_TYPE_PREFIX));
    const $89f92c26c7f930da$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, (0, parcelRequire("k2DRb")).PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
    const $89f92c26c7f930da$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$89f92c26c7f930da$export$78cf1b56a8dede1f(field.fieldType));
    const $89f92c26c7f930da$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
        const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
        if (button != null) button.focus();
    };
});
parcelRegister("ELVDL", function(module, exports) {
    $parcel$export(module.exports, "EditMode", ()=>$ed405e89d26d258c$export$5304145354a3bee9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $2RhPB;
    var $4JpPl;
    var $7Aezm;
    var $9wJ66;
    var $frltc;
    var $koVbs;
    var $6cMZg;
    var $gb8Pv;
    const $ed405e89d26d258c$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
        const [isModalMode, setIsModalMode] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const onEditConfirm = (0, $5uXOq.useCallback)((newValue)=>{
            onChange((0, (0, parcelRequire("6cMZg")).transformValue)(newValue, extension));
            (0, (0, parcelRequire("4JpPl")).fireTrackEditedEvent)('issue-create', analyticsAttributes);
        }, [
            extension,
            analyticsAttributes,
            onChange
        ]);
        const onModalRender = (0, $5uXOq.useCallback)(()=>setIsModalMode(true), []);
        if (isModalMode) {
            const translatedError = {
                message: intl.formatMessage((0, (0, parcelRequire("gb8Pv")).default).modalModeErrorTitle),
                errorMessage: intl.formatMessage((0, (0, parcelRequire("gb8Pv")).default).modalModeErrorDescription)
            };
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
                ...analyticsAttributes,
                extension: JSON.stringify(extension)
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("frltc")).ErrorPanel), {
                error: translatedError
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wJ66")).AsyncCustomFieldInlineEdit), {
            extension: extension,
            extensionData: extensionData,
            analyticsAttributes: analyticsAttributes,
            extensionPayload: extensionPayload,
            onSubmit: onEditConfirm,
            onModalRender: onModalRender
        });
    };
    const $ed405e89d26d258c$export$5304145354a3bee9 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Aezm")).EditAnalyticsWrapper), {
            attributes: (0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(props.extension)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ed405e89d26d258c$export$ba588b5cce278e96, props));
});
parcelRegister("4JpPl", function(module, exports) {
    $parcel$export(module.exports, "fireTrackEditedEvent", ()=>$d80ee50440a72c0c$export$1798d320c6527c08);
    $parcel$export(module.exports, "fireUiCanceledEvent", ()=>$d80ee50440a72c0c$export$fc09afa3d0d5294c);
    $parcel$export(module.exports, "fireOperationalEditFailedEvent", ()=>$d80ee50440a72c0c$export$762dee9e981de3e1);
    $parcel$export(module.exports, "fireUiTriggerClickEvent", ()=>$d80ee50440a72c0c$export$cfefb608fbbf02c9);
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$d80ee50440a72c0c$export$add44f896fb31ba3);
    var $k2DRb;
    var $8uOa6;
    var $9BrHy;
    var $8kVg1;
    var $hBuqR;
    const $d80ee50440a72c0c$var$moduleEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $d80ee50440a72c0c$var$triggerEventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
        module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
        moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
        entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)
    });
    const $d80ee50440a72c0c$export$1798d320c6527c08 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireTrackEvent)((0, (0, parcelRequire("hBuqR")).TRACK_ACTIONS).EDITED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$fc09afa3d0d5294c = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).CANCELED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$762dee9e981de3e1 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).EDIT_FAILED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
    const $d80ee50440a72c0c$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
            startTime: performance.now()
        });
        return (0, (0, parcelRequire("8uOa6")).fireUiEvent)((0, (0, parcelRequire("hBuqR")).UI_ACTIONS).CLICKED, {
            id: $d80ee50440a72c0c$var$triggerEventId,
            source: source,
            attributes: attributes
        });
    };
    const $d80ee50440a72c0c$export$add44f896fb31ba3 = (source, attributes)=>(0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: $d80ee50440a72c0c$var$moduleEventId,
            source: source,
            attributes: attributes
        });
});
parcelRegister("9wJ66", function(module, exports) {
    $parcel$export(module.exports, "AsyncCustomFieldInlineEdit", ()=>$05c72791f20b76f4$export$ca6c6772b322056d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2G8Ll;
    var $3oVvh;
    const $05c72791f20b76f4$var$isIssueViewProps = (props)=>props.extensionData.renderContext === 'issue-view';
    const $05c72791f20b76f4$var$isIssueCreateOrTransitionProps = (props)=>props.extensionData.renderContext === 'issue-create' || props.extensionData.renderContext === 'issue-transition';
    const $05c72791f20b76f4$export$980ea0297ad3a4c8 = (props)=>{
        if ($05c72791f20b76f4$var$isIssueViewProps(props)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3oVvh")).LazyCustomFieldInlineEditIssueView), props);
        if ($05c72791f20b76f4$var$isIssueCreateOrTransitionProps(props)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2G8Ll")).LazyCustomFieldInlineEditForm), props);
        return null;
    };
    const $05c72791f20b76f4$export$ca6c6772b322056d = $05c72791f20b76f4$export$980ea0297ad3a4c8;
});
parcelRegister("2G8Ll", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditForm", ()=>$3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $6ikhl;
    var $4JpPl;
    var $k2DRb;
    var $3mOWa;
    var $lfTZh;
    var $bLCKr;
    var $69dub;
    var $3OHUI;
    const $3e8d63ebec6f951f$var$skeletonConfig = [
        {
            width: 100
        }
    ];
    const $3e8d63ebec6f951f$export$eb4eaeb8dcd7d4ca = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
        const requestsCount = (0, $5uXOq.useRef)(0);
        const [, { setFieldState: setFieldState }] = (0, (0, parcelRequire("6ikhl")).useInlineField)(restProps.extensionData.fieldId);
        const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
        const loadingComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLCKr")).Skeleton), {
                skeletonConfig: $3e8d63ebec6f951f$var$skeletonConfig
            }), []);
        const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
            const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
                fieldId: extensionData.fieldId,
                fieldType: extensionData.fieldType,
                fieldName: extensionData.fieldName,
                renderContext: extensionData.renderContext
            };
            return {
                ...preparedExtensionData,
                type: extension.type,
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                isInline: true
            };
        }, [
            extension,
            extensionData
        ]);
        const extraProps = (0, $5uXOq.useMemo)(()=>({
                loadingComponent: loadingComponent,
                module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                extensionData: extensionDataValue,
                extensionPayload: extensionPayload,
                contextToken: (0, (0, parcelRequire("k2DRb")).CONTEXT_TOKEN_TYPE_JIRA)
            }), [
            extensionDataValue,
            extensionPayload,
            loadingComponent
        ]);
        const createRetryFunction = (0, $5uXOq.useCallback)((fieldValue)=>async ()=>{
                try {
                    setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)
                    });
                    requestsCount.current += 1;
                    const submitValue = await Promise.resolve(fieldValue);
                    onSubmit(submitValue);
                    requestsCount.current -= 1;
                    if (requestsCount.current === 0) setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4)
                    });
                } catch (error) {
                    setFieldState({
                        fieldId: extensionData.fieldId,
                        status: (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)
                    });
                    (0, (0, parcelRequire("4JpPl")).fireOperationalEditFailedEvent)(extensionData.renderContext, {
                        error: error,
                        isInline: true
                    });
                }
                return undefined;
            }, [
            onSubmit,
            extensionData,
            setFieldState
        ]);
        const submit = (0, $5uXOq.useCallback)(async ({ data: fieldValue })=>{
            const retryFunction = createRetryFunction(fieldValue);
            setFieldState({
                fieldId: extensionData.fieldId,
                retryFunction: retryFunction
            });
            await retryFunction();
            return undefined;
        }, [
            createRetryFunction,
            extensionData.fieldId,
            setFieldState
        ]);
        const bridge = (0, $5uXOq.useMemo)(()=>({
                submit: submit
            }), [
            submit
        ]);
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditExtension), {
            ...restProps,
            ...extraProps,
            onModalRender: onModalRender,
            onSubmit: onSubmit,
            bridge: bridge
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-inline-edit",
            fallback: loadingComponent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditRenderer), {
            ...restProps,
            ...extraProps,
            onModalRender: onModalRender,
            onSubmit: onSubmit,
            bridge: bridge
        })));
    };
});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';
parcelRegister("bLCKr", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$e1da1ba1fdde315e$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "SkeletonLayout", ()=>$e1da1ba1fdde315e$export$af3ba02ef74c9bdf);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dC5iT;
    var $8CUq3;
    const $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 = [];
    const $e1da1ba1fdde315e$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $e1da1ba1fdde315e$export$69f3c7f0b2b87aa2 })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e1da1ba1fdde315e$var$ForgeSkeleton, {
                "data-testId": `forgeskeleton-${index}`,
                key: index,
                width: width
            })));
    const $e1da1ba1fdde315e$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
        if (!layout) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: "forge-ui-async.common.ui.skeleton.box",
            xcss: $e1da1ba1fdde315e$var$layoutStyles
        }, children);
    };
    const $e1da1ba1fdde315e$var$shimmer = null;
    const $e1da1ba1fdde315e$var$ForgeSkeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1y04s53": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}%`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
                __cmplp.className
            ])
        });
    });
    const $e1da1ba1fdde315e$var$layoutStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingTop: 'space.200',
        paddingLeft: 'space.300',
        paddingRight: 'space.300'
    });
});
parcelRegister("69dub", function(module, exports) {
    $parcel$export(module.exports, "StopSubmitPropagation", ()=>$1d6031a605ad4b71$export$238f56c0891e9254);
    var $5uXOq = parcelRequire("5uXOq");
    const $1d6031a605ad4b71$export$e6dfd72ab29f8598 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
            onSubmit: props.onSubmit
        }, props.children);
    const $1d6031a605ad4b71$export$238f56c0891e9254 = ({ children: children })=>{
        const handleSubmit = (e)=>{
            e.stopPropagation();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1d6031a605ad4b71$export$e6dfd72ab29f8598, {
            onSubmit: handleSubmit
        }, children);
    };
});
parcelRegister("3OHUI", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditRenderer", ()=>$e47c1fd0d3acd296$export$eef5130ba28e0f4e);
    $parcel$export(module.exports, "LazyCustomFieldInlineEditExtension", ()=>$e47c1fd0d3acd296$export$299b8ce8659dec8c);
    var $1rTGO;
    var $8kVg1;
    var $hBuqR;
    var $kxZPA;
    const $e47c1fd0d3acd296$var$getModule = ()=>(0, (0, parcelRequire("8kVg1")).measureInitialPageLoadAsyncResourcesTiming)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("lf16s")));
    const $e47c1fd0d3acd296$var$getForgeExtensionModule = ()=>(0, (0, parcelRequire("8kVg1")).measureInitialPageLoadAsyncResourcesTiming)((0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, (0, parcelRequire("hBuqR")).PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("7kdGo")));
    const $e47c1fd0d3acd296$export$eef5130ba28e0f4e = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>$e47c1fd0d3acd296$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
        ssr: false
    }));
    const $e47c1fd0d3acd296$export$299b8ce8659dec8c = (0, (0, parcelRequire("1rTGO")).withMetrics)((0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>$e47c1fd0d3acd296$var$getForgeExtensionModule().then((module)=>module.CustomFieldInlineEdit), {
        ssr: false
    }));
});
parcelRegister("lf16s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2AjeU")
    ]).then(()=>parcelRequire('lDRdH'));
});
parcelRegister("7kdGo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2QVAD")
    ]).then(()=>parcelRequire('456zR'));
});
parcelRegister("3oVvh", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldInlineEditIssueView", ()=>$46e0705763f3c3d0$export$9929b4973c13a82f);
    var $5uXOq = parcelRequire("5uXOq");
    var $pa9q9;
    var $k2DRb;
    var $3mOWa;
    var $lfTZh;
    var $bLCKr;
    var $69dub;
    var $7IjIj;
    var $3OHUI;
    const $46e0705763f3c3d0$var$skeletonConfig = [
        {
            width: 100
        }
    ];
    const $46e0705763f3c3d0$export$9929b4973c13a82f = ({ onSave: onSave, onCancel: onCancel, onConfirm: onConfirm, onRender: onRender, ...restProps })=>{
        const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const loadingComponent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bLCKr")).Skeleton), {
                skeletonConfig: $46e0705763f3c3d0$var$skeletonConfig
            }), []);
        const extensionDataValue = (0, $5uXOq.useMemo)(()=>{
            const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
                fieldType: extensionData.fieldType,
                fieldId: extensionData.fieldId,
                fieldName: extensionData.fieldName,
                renderContext: extensionData.renderContext
            };
            return {
                ...preparedExtensionData,
                type: extension.type,
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                isInline: true
            };
        }, [
            extension.type,
            extensionData
        ]);
        const extraProps = (0, $5uXOq.useMemo)(()=>({
                loadingComponent: loadingComponent,
                module: (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
                entryPoint: (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT),
                extensionData: extensionDataValue,
                extensionPayload: extensionPayload,
                contextToken: (0, (0, parcelRequire("k2DRb")).CONTEXT_TOKEN_TYPE_JIRA)
            }), [
            extensionDataValue,
            extensionPayload,
            loadingComponent
        ]);
        const submit = (0, $5uXOq.useCallback)(({ data: fieldValue })=>(0, (0, parcelRequire("7IjIj")).onCustomFieldSubmit)(fieldValue, onSave, onConfirm, showFlag), [
            showFlag
        ]);
        const close = onCancel;
        const bridge = (0, $5uXOq.useMemo)(()=>({
                submit: submit,
                close: close
            }), [
            submit,
            close
        ]);
        if ((0, (0, parcelRequire("3mOWa")).isNativeUiExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT)) || (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(extension, (0, (0, parcelRequire("k2DRb")).ENTRY_POINT_EDIT))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditExtension), {
            ...restProps,
            ...extraProps,
            onCancel: onCancel,
            onLoad: onRender,
            onRender: onRender,
            bridge: bridge
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("69dub")).StopSubmitPropagation), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "custom-field-edit",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OHUI")).LazyCustomFieldInlineEditRenderer), {
            ...restProps,
            ...extraProps,
            onRender: onRender,
            onCancel: onCancel,
            bridge: bridge
        })));
    };
});
parcelRegister("7IjIj", function(module, exports) {
    $parcel$export(module.exports, "onCustomFieldSubmit", ()=>$7482280c9b50d561$export$fc8c2ed652969e74);
    var $jJZqs;
    var $dGSK4;
    const $7482280c9b50d561$export$fc8c2ed652969e74 = (fieldValue, onSave, onConfirm, showFlag)=>onSave(fieldValue).then((response)=>{
            if (response == null) return;
            if ('error' in response) {
                if (response.error) throw response.error;
            } else onConfirm(response.data);
        }).catch((error)=>{
            showFlag((0, (0, parcelRequire("dGSK4")).default)(error));
            if ((0, (0, parcelRequire("jJZqs")).isValidationError)(error)) throw error;
            throw Error(`Unable to save custom field, error: ${error.message}`);
        });
});
parcelRegister("dGSK4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60f776846cd27f9$export$2e2bcd8739ae039);
    var $jJZqs;
    var $eRDnE;
    var $ctOgQ;
    var $b60f776846cd27f9$export$2e2bcd8739ae039 = (error)=>(0, (0, parcelRequire("jJZqs")).isValidationError)(error) ? (0, (0, parcelRequire("ctOgQ")).default)(error.errors) : (0, (0, parcelRequire("eRDnE")).default)();
});
parcelRegister("eRDnE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41e1a5ac6c28ff9a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $41e1a5ac6c28ff9a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "forge-ui.common.flags.custom-field.edit-failed.generic-error.title",
            "defaultMessage": "We were unable to edit this custom field. Please try again."
        }
    });
    var $41e1a5ac6c28ff9a$export$2e2bcd8739ae039 = ()=>({
            type: 'error',
            title: $41e1a5ac6c28ff9a$var$messages.title,
            isAutoDismiss: false
        });
});
parcelRegister("ctOgQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59eef974107568f4$export$2e2bcd8739ae039);
    var $7VHMR;
    const $59eef974107568f4$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "forge-ui.common.flags.custom-field.edit-failed.validation-error.title",
            "defaultMessage": "Validation error"
        }
    });
    var $59eef974107568f4$export$2e2bcd8739ae039 = (errors)=>({
            type: 'error',
            title: $59eef974107568f4$var$messages.title,
            description: errors.map(({ error: error })=>error).join(', '),
            isAutoDismiss: false
        });
});
parcelRegister("frltc", function(module, exports) {
    $parcel$export(module.exports, "ErrorPanel", ()=>$a7cc7ee0610715db$export$9f3dc18e1adf5d8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $92Z2l;
    var $ctz0s;
    var $eZJjh;
    var $koVbs;
    var $lUtFZ;
    const $a7cc7ee0610715db$var$Loader = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$LoaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
            size: "large"
        }));
    const $a7cc7ee0610715db$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
        const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const onClickStopPropagation = (0, $5uXOq.useCallback)((e)=>e.stopPropagation(), []);
        const reinitializeApp = (0, $5uXOq.useCallback)(async (e)=>{
            setIsLoading(true);
            try {
                e.stopPropagation();
                if (onRetry) await onRetry();
            } catch  {} finally{
                setIsLoading(false);
            }
        }, [
            onRetry
        ]);
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$Loader, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ContentWrapper, {
            onClick: onClickStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            title: message,
            actions: onRetry ? [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                    onClick: reinitializeApp,
                    key: "refresh"
                }, intl.formatMessage((0, (0, parcelRequire("lUtFZ")).default).refreshApp))
            ] : []
        }, errorMessage && (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorMessageWrapper, null, errorMessage), errorDetails && (0, ($parcel$interopDefault($5uXOq))).createElement($a7cc7ee0610715db$var$ErrorDetailsWrapper, null, errorDetails)));
    };
    const $a7cc7ee0610715db$var$ContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _k7zyidpf",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$LoaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$ErrorMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721jtm",
                __cmplp.className
            ])
        });
    });
    const $a7cc7ee0610715db$var$ErrorDetailsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721jtm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lUtFZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c0d2ab7d73abc3f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $0c0d2ab7d73abc3f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        refreshApp: {
            "id": "forge-ui-renderers.common.error-panel.refresh-app",
            "defaultMessage": "Refresh app"
        }
    });
});
parcelRegister("6cMZg", function(module, exports) {
    $parcel$export(module.exports, "transformValue", ()=>$856789955d192c4b$export$98c150630afe5417);
    $parcel$export(module.exports, "transformValueToExtensionData", ()=>$856789955d192c4b$export$b82f09291a00d8c1);
    $parcel$export(module.exports, "getExtension", ()=>$856789955d192c4b$export$78d71f9ed5534abe);
    var $2QTbq;
    var $gifeQ;
    var $2pEv1;
    const $856789955d192c4b$export$98c150630afe5417 = (value, extension)=>{
        const { properties: { type: type, collection: collection } } = extension;
        switch(type){
            case 'string':
                if (collection === 'list' && Array.isArray(value)) return (0, (0, parcelRequire("2QTbq")).mapDataToLabelOptions)(value);
                return value;
            case 'object':
                return JSON.stringify(value);
            case 'user':
                if (value != null) return $856789955d192c4b$export$26760e7b66ccf1e1(value);
                return value;
            default:
                return value;
        }
    };
    const $856789955d192c4b$export$b82f09291a00d8c1 = (value, extension)=>{
        const type = extension?.properties?.type;
        const collection = extension?.properties?.collection;
        switch(type){
            case 'string':
                if (collection === 'list') return (0, (0, parcelRequire("2QTbq")).mapLabelOptionsToData)(value);
                return value;
            case 'object':
                return (0, (0, parcelRequire("2pEv1")).transformJSONStringToObject)(value);
            case 'user':
                if (value === null) return value;
                return $856789955d192c4b$export$e4490ea0dfe4173f(value);
            default:
                return value;
        }
    };
    const $856789955d192c4b$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? field.id === (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const $856789955d192c4b$export$e4490ea0dfe4173f = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                accountId: option.id
            }));
        return {
            accountId: userOption.id
        };
    };
    const $856789955d192c4b$export$3e406786572c35b0 = (userData)=>({
            id: userData.accountId || '',
            name: userData.name || '',
            avatarUrl: userData.picture || ''
        });
    const $856789955d192c4b$export$26760e7b66ccf1e1 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return defaultValue.map($856789955d192c4b$export$3e406786572c35b0);
        return $856789955d192c4b$export$3e406786572c35b0(defaultValue);
    };
});
parcelRegister("2QTbq", function(module, exports) {
    $parcel$export(module.exports, "mapDataToLabelOptions", ()=>$392cb309afc1042a$export$cd8e373d5b1325b1);
    $parcel$export(module.exports, "mapLabelOptionsToData", ()=>$392cb309afc1042a$export$1bf703d99c7bcef6);
    $parcel$export(module.exports, "mapLabelsResponseToLabelOptions", ()=>$392cb309afc1042a$export$37f55c1f665c1221);
    const $392cb309afc1042a$export$cd8e373d5b1325b1 = (data)=>{
        if (!data) return [];
        return data.map((value)=>({
                value: value,
                label: value
            }));
    };
    const $392cb309afc1042a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
    const $392cb309afc1042a$export$37f55c1f665c1221 = (response)=>{
        const { suggestions: suggestions } = response;
        if (!suggestions) return [];
        return suggestions.map(({ label: label })=>({
                label: label,
                value: label
            }));
    };
});
parcelRegister("2pEv1", function(module, exports) {
    $parcel$export(module.exports, "transformJSONStringToObject", ()=>$ff7dce57394b1eb3$export$2de59005e10fd82);
    var $agVdz = parcelRequire("agVdz");
    const $ff7dce57394b1eb3$export$2de59005e10fd82 = (value)=>{
        try {
            if ((0, ($parcel$interopDefault($agVdz)))(value) && JSON.parse(value)) return JSON.parse(value);
        } catch (e) {
            return value;
        }
        return value;
    };
});
parcelRegister("gb8Pv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c94c49b5b89ee482$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c94c49b5b89ee482$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalModeErrorTitle: {
            "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
            "defaultMessage": "We couldn't show this extension"
        },
        modalModeErrorDescription: {
            "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
            "defaultMessage": "Contact the app vendor to update the app."
        }
    });
});
parcelRegister("j5sSv", function(module, exports) {
    $parcel$export(module.exports, "FieldContainer", ()=>$41b83e50a34e2ca1$export$b5c4b0e7cd7f148b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $41b83e50a34e2ca1$export$b5c4b0e7cd7f148b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1r250ak": (0, (0, parcelRequire("lD23V")).default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
                "--_1glwpqj": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.marginTop ?? 0}px`),
                "--_1i3s0vn": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.paddingBottom ?? 0}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbuo76 _19pknek2 _n3td11zn",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7fjFA", function(module, exports) {
    $parcel$export(module.exports, "ForgeFieldMessage", ()=>$111a3dd21aa999b8$export$1df6b326181f4cdf);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $qfj8c;
    var $eZJjh;
    var $6ikhl;
    var $koVbs;
    var $jcuk9;
    var $3EMIO;
    const $111a3dd21aa999b8$export$1df6b326181f4cdf = (props)=>{
        const failedErrorMessageAppeared = (0, $5uXOq.useRef)(false);
        const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
        const [fieldState] = (0, (0, parcelRequire("6ikhl")).useInlineField)(fieldId);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const renderErrorMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldErrorTextLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jcuk9")).ForgeFieldDispatchButton), {
                fieldId: fieldId
            }));
        const renderSuccessMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ValidMessage), null, formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldSuccessTextLabel));
        const renderHelperMessage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement($111a3dd21aa999b8$var$MessagePartsSeparationWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                size: "small"
            })), formatMessage((0, (0, parcelRequire("3EMIO")).default).forgeFieldPendingTextLabel));
        const renderDefaultErrorMessage = ()=>{
            if (renderFieldMessage !== undefined && renderFieldMessage !== null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderFieldMessage(error));
            return null;
        };
        if (error !== undefined) return renderDefaultErrorMessage();
        if (failedErrorMessageAppeared.current) {
            if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
                case 0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd:
                    return renderErrorMessage();
                case 0, $3e5c7761c2e3cf02$export$9956c6a700e724c4:
                    return renderSuccessMessage();
                case 0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c:
                case 0, $3e5c7761c2e3cf02$export$2ace7d3737836262:
                    return renderHelperMessage();
                default:
                    return renderDefaultErrorMessage();
            }
            return null;
        }
        if (fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) {
            failedErrorMessageAppeared.current = true;
            return renderErrorMessage();
        }
        return renderDefaultErrorMessage();
    };
    const $111a3dd21aa999b8$var$MessagePartsSeparationWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_u5f31b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("qfj8c", function(module, exports) {
    $parcel$export(module.exports, "HelperMessage", ()=>$b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
    $parcel$export(module.exports, "ErrorMessage", ()=>$b2d5b368fed948c9$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ValidMessage", ()=>$b2d5b368fed948c9$export$5505afb209a532c8);
    $parcel$export(module.exports, "MessageWrapper", ()=>$b2d5b368fed948c9$export$ec445f12f63100a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $059q9;
    var $g4M8x;
    var $dRN65;
    function $b2d5b368fed948c9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b2d5b368fed948c9$var$messageStyles = {
        name: "drnq1s",
        styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
    };
    const $b2d5b368fed948c9$var$messageAppearanceStyles = {
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
        }),
        error: {
            name: "g75jq6",
            styles: "color:var(--ds-text-danger, #AE2A19)"
        },
        valid: {
            name: "118r6eb",
            styles: "color:var(--ds-text-success, #216E4E)"
        }
    };
    const $b2d5b368fed948c9$var$iconWrapperStyles = {
        name: "x5c876",
        styles: "display:flex;height:16px;align-items:center"
    };
    const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b2d5b368fed948c9$var$iconWrapperStyles
        }, children);
    };
    const $b2d5b368fed948c9$var$messageIcons = {
        error: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "error"
        }),
        valid: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("g4M8x"))))), {
            LEGACY_margin: "0 -2px 0 0",
            color: "currentColor",
            LEGACY_size: "small",
            label: "success"
        })
    };
    const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
        const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
        const messageRef = (0, $5uXOq.useRef)(null);
        const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
        const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$export$579aef2c392a54d4);
        (0, $5uXOq.useEffect)(()=>{
            if (messageRef.current) setHasMessageWrapper(isWrapper);
        }, [
            isWrapper
        ]);
        const content = typeof children === 'string' ? children : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b2d5b368fed948c9$var$messageStyles,
                $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
            ],
            "data-testid": testId,
            id: fieldId,
            ref: messageRef,
            "aria-live": !hasMessageWrapper ? 'polite' : undefined
        }, icon && (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$IconWrapper, null, icon), content);
    };
    const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dRN65")).FieldId).Consumer, null, (fieldId)=>(0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId
            }, children));
    const $b2d5b368fed948c9$export$579aef2c392a54d4 = (0, $5uXOq.createContext)({
        isWrapper: false
    });
    const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
        const contextValue = {
            isWrapper: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b2d5b368fed948c9$export$579aef2c392a54d4.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper"
        }, children));
    };
});
parcelRegister("g4M8x", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));
    var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
    function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bb425bfe72dc5677$var$SuccessIcon = (props)=>$bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
        }, props));
    $bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;
});
parcelRegister("hs3k8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0347594f5084a834$var$_UNSAFE_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0347594f5084a834$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0347594f5084a834$var$SuccessIcon = (props)=>$0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
    var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;
});
parcelRegister("kJ541", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
    function $f16bf031974cd311$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>$f16bf031974cd311$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
        }, props, {
            newIcon: $f16bf031974cd311$var$_success.default
        }));
    $f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
    var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;
});
parcelRegister("jcuk9", function(module, exports) {
    $parcel$export(module.exports, "ForgeFieldDispatchButton", ()=>$354a8a5375650812$export$59e3aafda495153);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $6ikhl;
    const $354a8a5375650812$export$59e3aafda495153 = (props)=>{
        const { fieldId: fieldId } = props;
        const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, (0, parcelRequire("6ikhl")).useInlineField)(fieldId);
        const onClickHandler = async ()=>{
            if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
        };
        const renderRetryButton = ()=>{
            if (fieldState !== undefined && fieldState?.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                spacing: "none",
                appearance: "link",
                onClick: onClickHandler
            }, "Try again?");
            return null;
        };
        return renderRetryButton();
    };
});
parcelRegister("3EMIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$477739caf5b64c43$export$2e2bcd8739ae039);
    var $7VHMR;
    var $477739caf5b64c43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forgeFieldErrorTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
            "defaultMessage": "We couldn't save the value of this custom field."
        },
        forgeFieldSuccessTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
            "defaultMessage": "Custom field value saved."
        },
        forgeFieldPendingTextLabel: {
            "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
            "defaultMessage": "Saving custom field value."
        }
    });
});
const $5363dcf42759d41f$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $5363dcf42759d41f$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $5363dcf42759d41f$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $5363dcf42759d41f$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $5363dcf42759d41f$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $5363dcf42759d41f$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $5363dcf42759d41f$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
const $5363dcf42759d41f$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $5363dcf42759d41f$export$ebb48b08205007c5 = 'ISSUE_TYPE';
parcelRegister("7Emtg", function(module, exports) {
    $parcel$export(module.exports, "reportForgeFailure", ()=>$6c61c34a1b63244f$export$e95b9e5003024a9c);
    var $4JpPl;
    var $gifeQ;
    const $6c61c34a1b63244f$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
        const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, (0, parcelRequire("gifeQ")).isForgeLegacyFieldType)(fieldType) ? field.id === (0, (0, parcelRequire("gifeQ")).getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
        const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
        if (isEmptyForgeData || isExtensionFilteredOut) return;
        (0, (0, parcelRequire("4JpPl")).fireOperationalFailedEvent)('issue-create', {
            error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
            renderContext: 'issue-create'
        });
    };
});
parcelRegister("fl3Yy", function(module, exports) {
    $parcel$export(module.exports, "EnvironmentLozenge", ()=>$730173a4987fa3e4$export$278f8e01799d0418);
    $parcel$export(module.exports, "nameWithCustomEnvironment", ()=>$730173a4987fa3e4$export$f9338c21ba7c7334);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $k2DRb;
    var $ousew;
    var $8Je4V;
    const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
        switch(environmentType){
            case 0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).developmentEnvironmentLozenge;
            case 0, (0, parcelRequire("k2DRb")).STAGING_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).stagingEnvironmentLozenge;
            default:
                return null;
        }
    };
    const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
        const { environmentType: environmentType } = props;
        const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
        return labelKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
            appearance: environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), labelKey)) : null;
    };
    const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
        if (environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, (0, parcelRequire("k2DRb")).DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
        return name;
    };
});
parcelRegister("8Je4V", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$838ac71f7259b5ef$export$defe85febe8b728c);
    var $7VHMR;
    const $838ac71f7259b5ef$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        developmentEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
            "defaultMessage": "DEV"
        },
        stagingEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
            "defaultMessage": "STG"
        }
    });
});
parcelRegister("1MgIu", function(module, exports) {
    $parcel$export(module.exports, "extractEnvFromFieldDescription", ()=>$91f4ce51875a932d$export$dfa36573f3bd00af);
    const $91f4ce51875a932d$var$DEV_PREFIX = '(DEVELOPMENT) ';
    const $91f4ce51875a932d$var$STG_PREFIX = '(STAGING) ';
    const $91f4ce51875a932d$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
        if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$DEV_PREFIX)) return {
            environment: 'DEVELOPMENT',
            description: descriptionWithEnv.replace($91f4ce51875a932d$var$DEV_PREFIX, '')
        };
        if (descriptionWithEnv?.startsWith($91f4ce51875a932d$var$STG_PREFIX)) return {
            environment: 'STAGING',
            description: descriptionWithEnv.replace($91f4ce51875a932d$var$STG_PREFIX, '')
        };
        return {
            environment: 'PRODUCTION',
            description: descriptionWithEnv ?? ''
        };
    };
});
parcelRegister("3IJWP", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryBypassProvider", ()=>$9680a0b11955a508$export$a5feb4d632b53009);
    $parcel$export(module.exports, "ErrorBoundaryBypassInput", ()=>$9680a0b11955a508$export$36798a6d5688c318);
    $parcel$export(module.exports, "ErrorBoundaryBypassOutput", ()=>$9680a0b11955a508$export$775be62266860b86);
    var $5uXOq = parcelRequire("5uXOq");
    const $9680a0b11955a508$var$ErrorBoundaryBypassApiContext = (0, $5uXOq.createContext)(null);
    const $9680a0b11955a508$var$ErrorBoundaryBypassErrorContext = (0, $5uXOq.createContext)(null);
    const $9680a0b11955a508$export$a5feb4d632b53009 = ({ children: children })=>{
        const [bypassedError, setBypassedError] = (0, $5uXOq.useState)(null);
        const api = (0, $5uXOq.useMemo)(()=>({
                swallowError: (error)=>{
                    setBypassedError(error);
                }
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9680a0b11955a508$var$ErrorBoundaryBypassErrorContext.Provider, {
            value: bypassedError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9680a0b11955a508$var$ErrorBoundaryBypassApiContext.Provider, {
            value: api
        }, children));
    };
    class $9680a0b11955a508$export$36798a6d5688c318 extends (0, $5uXOq.Component) {
        static getDerivedStateFromError() {
            return {
                hasError: true
            };
        }
        componentDidCatch(error) {
            if (this.context !== null) this.context.swallowError(error);
        }
        static{
            this.contextType = $9680a0b11955a508$var$ErrorBoundaryBypassApiContext;
        }
        render() {
            if (this.state.hasError) return null;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                hasError: false
            };
        }
    }
    const $9680a0b11955a508$export$775be62266860b86 = ()=>{
        const bypassedError = (0, $5uXOq.useContext)($9680a0b11955a508$var$ErrorBoundaryBypassErrorContext);
        if (bypassedError !== null) throw bypassedError;
        return null;
    };
});
parcelRegister("59xJP", function(module, exports) {
    $parcel$export(module.exports, "FieldBusyIndicator", ()=>$b68c1576a43006f5$export$cf3e115209fc94cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $eZJjh;
    var $3bDjY;
    var $l0sjw;
    var $4ZSFc;
    const $b68c1576a43006f5$export$cf3e115209fc94cb = (0, $5uXOq.memo)(({ fieldId: fieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const loadingMessage = formatMessage((0, (0, parcelRequire("4ZSFc")).default).fieldLevelIndicatorTooltipContent);
        const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
        const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            tag: "span",
            content: loadingMessage,
            testId: tooltipId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b68c1576a43006f5$export$4e31364808fb7483, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l0sjw")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            testId: indicatorId,
            size: "small"
        }))));
    });
    $b68c1576a43006f5$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
    const $b68c1576a43006f5$export$4e31364808fb7483 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u012x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l0sjw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f5b4df3c1787ede$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4eKbI;
    var $cEm1b;
    function $3f5b4df3c1787ede$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentProfilerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEm1b")).ProfilerContext));
        const ignoredRLLProfilerContext = (0, $5uXOq.useMemo)(()=>({
                ...parentProfilerContext,
                placeholderFallBackMounted () {},
                placeholderFallBackUnmounted () {}
            }), [
            parentProfilerContext
        ]);
        const kids = children != null ? children : null;
        if (!ignore) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4eKbI")).default), {
            ignore: ignore
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEm1b")).ProfilerContext).Provider, {
            value: ignoredRLLProfilerContext
        }, kids));
    }
});
parcelRegister("4eKbI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd3e682addb0cb4a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6wxJn;
    function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("6wxJn")).default));
        const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
            if (!parentContext) return null;
            return {
                ...parentContext,
                hold (...args) {
                    if (!ignore) return parentContext.hold(...args);
                }
            };
        }, [
            parentContext,
            ignore
        ]);
        const kids = children != null ? children : null;
        if (!ignoredInteractionContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, kids);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6wxJn")).default).Provider, {
            value: ignoredInteractionContext
        }, kids);
    }
});
parcelRegister("4ZSFc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974b96d64cf7f740$export$2e2bcd8739ae039);
    var $7VHMR;
    var $974b96d64cf7f740$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fieldLevelIndicatorTooltipContent: {
            id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
            defaultMessage: 'Loading UI modifications...',
            description: 'A tooltip message showed on UI modifications loading icon on each loading field'
        }
    });
});
parcelRegister("2eeg1", function(module, exports) {
    $parcel$export(module.exports, "FieldValueDecoratorAsync", ()=>$58ac5136636efa9f$export$24545fc29fe55980);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCJ2;
    var $d9r6K;
    var $62s0B;
    const $58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const undecoratedResult = children(fieldProps);
        if ((0, (0, parcelRequire("d9r6K")).isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), fieldType) && adjustmentsAreEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62s0B")).EnabledFieldValueDecorator), {
            fieldProps: fieldProps,
            fieldId: fieldId,
            fieldType: fieldType
        }, children);
        return undecoratedResult;
    };
    const $58ac5136636efa9f$export$24545fc29fe55980 = (0, $5uXOq.memo)($58ac5136636efa9f$var$FieldValueDecoratorAsyncNoMemo);
});
parcelRegister("62s0B", function(module, exports) {
    $parcel$export(module.exports, "EnabledFieldValueDecorator", ()=>$f47b896eac91b738$export$9d96bb1f53295b76);
    var $asu2W;
    var $9QJ7Z;
    const $f47b896eac91b738$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldType: fieldType, fieldProps: fieldProps })=>{
        const { onBlur: onBlur, onChange: onChange } = fieldProps;
        const { getFieldValue: getFieldValue } = (0, (0, parcelRequire("9QJ7Z")).useFormApi)();
        const { processChange: processChange } = (0, (0, parcelRequire("asu2W")).useIssueAdjustmentsActions)();
        const processChangeByType = (eventType)=>{
            processChange({
                fieldId: fieldId,
                fieldValue: getFieldValue(fieldId),
                eventType: eventType,
                fieldType: fieldType
            });
        };
        const interceptedFieldProps = {
            ...fieldProps,
            onChange: (modifiedValue)=>{
                onChange(modifiedValue);
                processChangeByType('change');
            },
            onBlur: ()=>{
                onBlur();
                processChangeByType('blur');
            }
        };
        return children(interceptedFieldProps);
    };
});
parcelRegister("9QJ7Z", function(module, exports) {
    $parcel$export(module.exports, "FormApiProvider", ()=>$33387961dd1f98b9$export$1e7be89a21d0c0ae);
    $parcel$export(module.exports, "useFormApi", ()=>$33387961dd1f98b9$export$4607062597b2b4df);
    var $5uXOq = parcelRequire("5uXOq");
    const $33387961dd1f98b9$var$Context = (0, $5uXOq.createContext)(null);
    const $33387961dd1f98b9$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
        const setFieldValueRef = (0, $5uXOq.useRef)(setFieldValue);
        setFieldValueRef.current = setFieldValue;
        const getFormStateRef = (0, $5uXOq.useRef)(getFormState);
        getFormStateRef.current = getFormState;
        const value = (0, $5uXOq.useMemo)(()=>({
                setFieldValue: (...args)=>setFieldValueRef.current(...args),
                getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId]
            }), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($33387961dd1f98b9$var$Context.Provider, {
            value: value
        }, children);
    };
    const $33387961dd1f98b9$export$4607062597b2b4df = ()=>{
        const context = (0, $5uXOq.useContext)($33387961dd1f98b9$var$Context);
        if (context === null) throw new Error('Missing FormApiProvider');
        return context;
    };
});
parcelRegister("aBZin", function(module, exports) {
    $parcel$export(module.exports, "getValueFromEventOrValue", ()=>$56aa95be299fa4e4$export$a59801673b41acfd);
    function $56aa95be299fa4e4$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $56aa95be299fa4e4$export$a59801673b41acfd(eventOrValue) {
        if ($56aa95be299fa4e4$var$isEvent(eventOrValue)) {
            const { currentTarget: currentTarget } = eventOrValue;
            if (currentTarget.type === 'checkbox') {
                if (currentTarget.checked) return currentTarget.value || true;
                return currentTarget.value ? undefined : false;
            }
            if (currentTarget) return currentTarget.value;
        }
        return eventOrValue;
    }
});
parcelRegister("45JN1", function(module, exports) {
    $parcel$export(module.exports, "FieldMessage", ()=>$f046862319512079$export$eb5013679a5d3f69);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $kOFhM;
    var $qfj8c;
    var $e4yMr;
    var $f5oqj;
    var $3bDjY;
    var $h17zy;
    var $4R6GH;
    var $aWse0;
    var $6a30R;
    var $4IoOR;
    var $aQb3V;
    const $f046862319512079$var$FieldHelpLink = (0, $5uXOq.memo)(({ fieldHelpTextUrl: fieldHelpTextUrl })=>{
        const learnMoreMessage = (0, (0, parcelRequire("aQb3V")).getLearnMoreMessage)(fieldHelpTextUrl ?? '');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            href: fieldHelpTextUrl,
            target: "_blank"
        }, formatMessage(learnMoreMessage));
    });
    const $f046862319512079$var$FieldMessageBehaviour = (props)=>{
        const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
        const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const maxHeight = 22;
        const emojiProvider = (0, (0, parcelRequire("h17zy")).useEmojiProvider)();
        const adfDocument = (0, $5uXOq.useMemo)(()=>{
            if (error) return null;
            if ((0, (0, parcelRequire("4R6GH")).fg)('replace_anchor_with_link')) return (0, (0, parcelRequire("4IoOR")).convertWikiToAdf)(description);
            let fieldDescription = description;
            if (fieldHelpTextUrl) {
                if (fieldDescription) fieldDescription = `${fieldDescription} ${(0, (0, parcelRequire("aQb3V")).getHelpText)(fieldHelpTextUrl, formatMessage)}`;
                else fieldDescription = (0, (0, parcelRequire("aQb3V")).getHelpText)(fieldHelpTextUrl, formatMessage);
            }
            return (0, (0, parcelRequire("4IoOR")).convertWikiToAdf)(fieldDescription);
        }, [
            description,
            error,
            fieldHelpTextUrl,
            formatMessage
        ]);
        if (error !== undefined && error !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, (0, (0, parcelRequire("aQb3V")).getErrorMessage)(error, fieldName, formatMessage, formatNumber));
        if (!adfDocument && !fieldHelpTextUrl) return null;
        const getRenderer = (isTruncated = false)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
                document: adfDocument,
                schema: (0, (0, parcelRequire("kOFhM")).defaultSchema),
                dataProviders: emojiProvider,
                disableHeadingIDs: true,
                featureFlags: {
                    codeBidiWarnings: true,
                    'code-bidi-warnings': true,
                    'renderer-tti-tracking': (0, (0, parcelRequire("4R6GH")).fg)('renderer_tti_tracking_jira'),
                    'allow-windowed-code-block': true
                },
                maxHeight: isTruncated ? maxHeight : undefined,
                truncated: isTruncated,
                fadeOutHeight: isTruncated ? 0 : undefined,
                eventHandlers: {
                    smartCard: {
                        onClick: (0, (0, parcelRequire("6a30R")).onLinkClick)
                    },
                    link: {
                        onClick: onLinkClickEvent || (0, (0, parcelRequire("6a30R")).onLinkClick)
                    }
                },
                smartLinks: (0, (0, parcelRequire("6a30R")).smartLinksDefault)
            });
        const getRenderedDescription = (truncatedRenderer = false)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$Description, {
                "data-testid": "issue-create-commons.common.ui.field-message.description",
                isMini: isMini,
                ...fieldId && {
                    id: `${fieldId}-field-message`
                }
            }, adfDocument && getRenderer(truncatedRenderer), fieldHelpTextUrl && (0, (0, parcelRequire("4R6GH")).fg)('replace_anchor_with_link') && (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldHelpLink, {
                fieldHelpTextUrl: fieldHelpTextUrl
            })));
        if (isMini) {
            if (adfDocument?.content[0]?.type === 'paragraph') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$TooltipContentContainer, null, getRenderer()),
                position: "bottom"
            }, getRenderedDescription(true));
            return null;
        }
        return getRenderedDescription();
    };
    const $f046862319512079$export$eb5013679a5d3f69 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f046862319512079$var$FieldMessageBehaviour, {
            key: `field-message-${props.fieldId}`,
            ...props
        });
    const $f046862319512079$var$TooltipContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_woio15cr _1f1h16g6 _13odidpf _9j7z1moj",
                __cmplp.className
            ])
        });
    });
    const $f046862319512079$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isMini: isMini, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_162p546": (0, (0, parcelRequire("lD23V")).default)(__cmplp.isMini && {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                })
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_woio1wmz _1f1hqk37 _13od1b66 _1pz31ynx",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kOFhM", function(module, exports) {
    $parcel$export(module.exports, "defaultSchemaConfig", ()=>$f27880a8173018db$export$e4e3ac1fa64862db);
    $parcel$export(module.exports, "getSchemaBasedOnStage", ()=>$f27880a8173018db$export$fd147e7d448dea03);
    $parcel$export(module.exports, "defaultSchema", ()=>$f27880a8173018db$export$1db618b7b2275ea1);
    var $8QpSo;
    var $aXBFx;
    var $7kC9H;
    var $47jug;
    var $gZoER;
    var $2FIVU;
    var $bFtEE;
    var $9UDEr;
    var $kBho7;
    const $f27880a8173018db$var$getDefaultSchemaConfig = ()=>{
        const defaultSchemaConfig = {
            nodes: [
                'doc',
                'paragraph',
                'text',
                'bulletList',
                'orderedList',
                'listItem',
                'heading',
                'blockquote',
                'codeBlock',
                'panel',
                'rule',
                'image',
                'caption',
                'mention',
                'media',
                'mediaGroup',
                'mediaSingle',
                'mediaInline',
                'confluenceUnsupportedBlock',
                'confluenceUnsupportedInline',
                'confluenceJiraIssue',
                'expand',
                'nestedExpand',
                'extension',
                'inlineExtension',
                'bodiedExtension',
                'hardBreak',
                'emoji',
                'table',
                'tableCell',
                'tableHeader',
                'tableRow',
                'decisionList',
                'decisionItem',
                'taskList',
                'taskItem',
                'unknownBlock',
                'date',
                'status',
                'placeholder',
                'layoutSection',
                'layoutColumn',
                'inlineCard',
                'blockCard',
                'embedCard',
                'unsupportedBlock',
                'unsupportedInline'
            ],
            marks: [
                'link',
                'em',
                'strong',
                'strike',
                'subsup',
                'underline',
                'code',
                'textColor',
                'backgroundColor',
                'confluenceInlineComment',
                'breakout',
                'alignment',
                'indentation',
                'annotation',
                'dataConsumer',
                'border',
                'unsupportedMark',
                'unsupportedNodeAttribute',
                'typeAheadQuery',
                'fragment'
            ]
        };
        return defaultSchemaConfig;
    };
    const $f27880a8173018db$export$e4e3ac1fa64862db = $f27880a8173018db$var$getDefaultSchemaConfig();
    const $f27880a8173018db$export$fd147e7d448dea03 = (0, (0, parcelRequire("8QpSo")).default)((stage = 'final')=>{
        const defaultSchemaConfig = $f27880a8173018db$var$getDefaultSchemaConfig();
        if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
            layoutSection: (0, (0, parcelRequire("gZoER")).layoutSectionWithSingleColumn),
            multiBodiedExtension: (0, (0, parcelRequire("47jug")).multiBodiedExtension),
            extensionFrame: (0, (0, parcelRequire("47jug")).extensionFrame),
            expand: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand),
            blockquote: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia),
            listItem: (0, (0, parcelRequire("2FIVU")).listItemWithDecisionStage0),
            panel: (0, (0, parcelRequire("bFtEE")).panelWithBlockquoteStage0)(true),
            table: (0, (0, parcelRequire("9UDEr")).tableWithNestedTable),
            tableRow: (0, (0, parcelRequire("9UDEr")).tableRowWithNestedTable),
            tableCell: (0, (0, parcelRequire("9UDEr")).tableCellWithNestedTable),
            tableHeader: (0, (0, parcelRequire("9UDEr")).tableHeaderWithNestedTable)
        };
        return (0, (0, parcelRequire("kBho7")).createSchema)(defaultSchemaConfig);
    });
    const $f27880a8173018db$export$1db618b7b2275ea1 = $f27880a8173018db$export$fd147e7d448dea03();
});
parcelRegister("aXBFx", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$7faca2534e4894a0$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>$7faca2534e4894a0$export$c4d50234112df933);
    $parcel$export(module.exports, "blockquoteWithList", ()=>$7faca2534e4894a0$export$9b4686c4b9672643);
    var $gthjq;
    const $7faca2534e4894a0$var$nodeSpecOptions = {
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    };
    const $7faca2534e4894a0$export$67dc04e652a298ca = (0, (0, parcelRequire("gthjq")).blockquoteLegacy)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$c4d50234112df933 = (0, (0, parcelRequire("gthjq")).blockquote)($7faca2534e4894a0$var$nodeSpecOptions);
    const $7faca2534e4894a0$export$9b4686c4b9672643 = (0, (0, parcelRequire("gthjq")).blockquoteWithoutNestedCodeblockOrMedia)({
        parseDOM: [
            {
                tag: 'blockquote'
            }
        ],
        toDOM () {
            return [
                'blockquote',
                0
            ];
        }
    });
});
parcelRegister("gthjq", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$bfdcc8a4590754dc$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "blockquote", ()=>$bfdcc8a4590754dc$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockquoteLegacy", ()=>$bfdcc8a4590754dc$export$199922e5af8e9a6);
    $parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", ()=>$bfdcc8a4590754dc$export$a91509d1c739c16f);
    $parcel$export(module.exports, "bodiedExtension", ()=>$bfdcc8a4590754dc$export$27903d543b563e39);
    $parcel$export(module.exports, "bulletList", ()=>$bfdcc8a4590754dc$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "caption", ()=>$bfdcc8a4590754dc$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "codeBlock", ()=>$bfdcc8a4590754dc$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$bfdcc8a4590754dc$export$daf889beb5092f95);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$bfdcc8a4590754dc$export$e6e4878f43c27cab);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$bfdcc8a4590754dc$export$3e6d667072febc87);
    $parcel$export(module.exports, "date", ()=>$bfdcc8a4590754dc$export$324d90190a8b822a);
    $parcel$export(module.exports, "decisionItem", ()=>$bfdcc8a4590754dc$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$bfdcc8a4590754dc$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "doc", ()=>$bfdcc8a4590754dc$export$2a111da947c407d2);
    $parcel$export(module.exports, "embedCard", ()=>$bfdcc8a4590754dc$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "emoji", ()=>$bfdcc8a4590754dc$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "expand", ()=>$bfdcc8a4590754dc$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithoutNestedExpand", ()=>$bfdcc8a4590754dc$export$63c0f3992661097b);
    $parcel$export(module.exports, "extension", ()=>$bfdcc8a4590754dc$export$1b45514b112dd749);
    $parcel$export(module.exports, "extensionFrameStage0", ()=>$bfdcc8a4590754dc$export$b555be60c7703afb);
    $parcel$export(module.exports, "hardBreak", ()=>$bfdcc8a4590754dc$export$371da9dd35aba193);
    $parcel$export(module.exports, "heading", ()=>$bfdcc8a4590754dc$export$46e4a324ac90507f);
    $parcel$export(module.exports, "image", ()=>$bfdcc8a4590754dc$export$5c452ff88e35e47d);
    $parcel$export(module.exports, "inlineCard", ()=>$bfdcc8a4590754dc$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "inlineExtensionWithMarks", ()=>$bfdcc8a4590754dc$export$b3b1e36c2105006d);
    $parcel$export(module.exports, "layoutColumn", ()=>$bfdcc8a4590754dc$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$bfdcc8a4590754dc$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionFull", ()=>$bfdcc8a4590754dc$export$cdae19acb0a520fd);
    $parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", ()=>$bfdcc8a4590754dc$export$206007566ca0aca5);
    $parcel$export(module.exports, "listItem", ()=>$bfdcc8a4590754dc$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithNestedDecisionStage0", ()=>$bfdcc8a4590754dc$export$df876f0305235056);
    $parcel$export(module.exports, "media", ()=>$bfdcc8a4590754dc$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "mediaGroup", ()=>$bfdcc8a4590754dc$export$2855e964765eac9);
    $parcel$export(module.exports, "mediaInline", ()=>$bfdcc8a4590754dc$export$38bab695e3f720f1);
    $parcel$export(module.exports, "mediaSingle", ()=>$bfdcc8a4590754dc$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleCaption", ()=>$bfdcc8a4590754dc$export$8d067f22dc2d1254);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$bfdcc8a4590754dc$export$7e767666f2ce108a);
    $parcel$export(module.exports, "mediaSingleWidthType", ()=>$bfdcc8a4590754dc$export$4bd9a38995f6bf50);
    $parcel$export(module.exports, "mention", ()=>$bfdcc8a4590754dc$export$db83999c14438df4);
    $parcel$export(module.exports, "multiBodiedExtensionStage0", ()=>$bfdcc8a4590754dc$export$750e45819f66d9d0);
    $parcel$export(module.exports, "nestedExpand", ()=>$bfdcc8a4590754dc$export$63cadbf5f4296627);
    $parcel$export(module.exports, "orderedList", ()=>$bfdcc8a4590754dc$export$a5dc81035676e7a);
    $parcel$export(module.exports, "panel", ()=>$bfdcc8a4590754dc$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panelWithNestedBlockquoteStage0", ()=>$bfdcc8a4590754dc$export$a1cf9918ad22c7e9);
    $parcel$export(module.exports, "paragraph", ()=>$bfdcc8a4590754dc$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "placeholder", ()=>$bfdcc8a4590754dc$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "rule", ()=>$bfdcc8a4590754dc$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "status", ()=>$bfdcc8a4590754dc$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "table", ()=>$bfdcc8a4590754dc$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$bfdcc8a4590754dc$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableCell", ()=>$bfdcc8a4590754dc$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$bfdcc8a4590754dc$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeader", ()=>$bfdcc8a4590754dc$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$bfdcc8a4590754dc$export$2a5a518232fa1a97);
    $parcel$export(module.exports, "tableRow", ()=>$bfdcc8a4590754dc$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$bfdcc8a4590754dc$export$7d657479499397);
    $parcel$export(module.exports, "taskItem", ()=>$bfdcc8a4590754dc$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$bfdcc8a4590754dc$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "text", ()=>$bfdcc8a4590754dc$export$6f093cfa640b7166);
    $parcel$export(module.exports, "unsupportedBlock", ()=>$bfdcc8a4590754dc$export$44b79b0979d0f0f7);
    $parcel$export(module.exports, "unsupportedInline", ()=>$bfdcc8a4590754dc$export$310ebe0d80122e9b);
    var $f0ccE;
    const $bfdcc8a4590754dc$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: null
            },
            datasource: {
                default: null
            },
            width: {
                default: null
            },
            layout: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$67dc04e652a298ca = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$199922e5af8e9a6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$a91509d1c739c16f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$27903d543b563e39 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$e7320d153c538837 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        defining: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a140c94e5ea26bee = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        selectable: false
    });
    const $bfdcc8a4590754dc$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
        marks: '_',
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(text | unsupportedInline)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$e4f1c66d84049f8b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(text | unsupportedInline)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            language: {
                default: null
            },
            uniqueId: {
                default: null
            }
        },
        code: true,
        defining: true
    });
    const $bfdcc8a4590754dc$export$daf889beb5092f95 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            issueKey: {
                default: ''
            },
            macroId: {
                default: null
            },
            schemaVersion: {
                default: null
            },
            server: {
                default: null
            },
            serverId: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$e6e4878f43c27cab = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$3e6d667072febc87 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        atom: true,
        attrs: {
            cxhtml: {
                default: null
            }
        }
    });
    const $bfdcc8a4590754dc$export$324d90190a8b822a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$47988d68fe575725 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            timestamp: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$6959e16eeff859b4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'DECIDED'
            }
        },
        defining: true
    });
    const $bfdcc8a4590754dc$export$62d45a65fb43d95e = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(decisionItem | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2a111da947c407d2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
    });
    const $bfdcc8a4590754dc$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            url: {
                default: ''
            },
            layout: {
                default: 'center'
            },
            width: {
                default: 100
            },
            originalHeight: {
                default: null
            },
            originalWidth: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a19185d1233fc4b2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$f5574b5d45fc2112 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            shortName: {
                default: ''
            },
            id: {
                default: ''
            },
            text: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9f77e0932fb78f72 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$7e3788972005cc72 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$63c0f3992661097b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
        group: 'block',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$1b45514b112dd749 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a8baf338431a691 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b555be60c7703afb = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
        marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
        attrs: {},
        selectable: false,
        definingAsContext: false,
        definingForContent: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$371da9dd35aba193 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: '\n'
            }
        },
        selectable: false,
        linebreakReplacement: true
    });
    const $bfdcc8a4590754dc$export$46e4a324ac90507f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$1b0c1557b234fa00 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$85461f751c457cc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$2b380a0f7e250af1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            level: {
                default: 1
            },
            localId: {
                default: null
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$5c452ff88e35e47d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            src: {
                default: ''
            },
            alt: {
                default: ''
            },
            title: {
                default: null
            }
        },
        draggable: true
    });
    const $bfdcc8a4590754dc$export$cbf8224b64e0d942 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$2f4e72b9459914ad = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            url: {
                default: null
            },
            data: {
                default: null
            }
        },
        selectable: true,
        draggable: true
    });
    const $bfdcc8a4590754dc$export$16b353b2649bd8d9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b3b1e36c2105006d = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            localId: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(block | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
        attrs: {
            width: {
                default: undefined
            }
        },
        selectable: false,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$cdae19acb0a520fd = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){2,3}',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        isolating: true
    });
    const $bfdcc8a4590754dc$export$206007566ca0aca5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            columnRuleStyle: {
                default: null
            }
        },
        isolating: true
    });
    const $bfdcc8a4590754dc$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$df876f0305235056 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$987d49ffe1b0900f = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            type: {
                default: 'file'
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            height: {
                default: null
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            __contextId: {
                default: null
            },
            __displayType: {
                default: null
            },
            __external: {
                default: false
            },
            __fileMimeType: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            url: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$2855e964765eac9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(media | unsupportedBlock)+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {},
        selectable: false
    });
    const $bfdcc8a4590754dc$export$38bab695e3f720f1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            type: {
                default: 'file'
            },
            url: {
                default: null
            },
            id: {
                default: ''
            },
            alt: {
                default: ''
            },
            collection: {
                default: ''
            },
            occurrenceKey: {
                default: null
            },
            width: {
                default: null
            },
            height: {
                default: null
            },
            __fileName: {
                default: null
            },
            __fileSize: {
                default: null
            },
            __fileMimeType: {
                default: null
            },
            __displayType: {
                default: null
            },
            __contextId: {
                default: null
            },
            __mediaTraceId: {
                default: null
            },
            __external: {
                default: false
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$969fe3781ca15058 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true,
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
    });
    const $bfdcc8a4590754dc$export$8d067f22dc2d1254 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            layout: {
                default: 'center'
            },
            width: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$7e767666f2ce108a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: false,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$4bd9a38995f6bf50 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'media|unsupportedBlock+|media unsupportedBlock+',
        marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        atom: true,
        attrs: {
            width: {
                default: null
            },
            layout: {
                default: 'center'
            },
            widthType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$db83999c14438df4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$46f790bd65f760d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            id: {
                default: ''
            },
            localId: {
                default: null
            },
            text: {
                default: ''
            },
            accessLevel: {
                default: ''
            },
            userType: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$750e45819f66d9d0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'extensionFrame+',
        marks: 'unsupportedNodeAttribute unsupportedMark',
        group: 'blockRootOnly',
        attrs: {
            extensionKey: {
                default: ''
            },
            extensionType: {
                default: ''
            },
            parameters: {
                default: null
            },
            text: {
                default: null
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: null
            }
        },
        selectable: true,
        definingAsContext: true
    });
    const $bfdcc8a4590754dc$export$63cadbf5f4296627 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$f03786aa6312d1e4 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        attrs: {
            title: {
                default: ''
            },
            __expanded: {
                default: true
            }
        },
        selectable: true,
        isolating: true
    });
    const $bfdcc8a4590754dc$export$a5dc81035676e7a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'listItem+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            order: {
                default: 1
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$21f42ab9b6679f44 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$a1cf9918ad22c7e9 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | blockquote)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            panelType: {
                default: 'info'
            },
            panelIcon: {
                default: null
            },
            panelIconId: {
                default: null
            },
            panelIconText: {
                default: null
            },
            panelColor: {
                default: null
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9c206ddddb32a9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$4f98472e6dc14293 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$ea332b61641b0588 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$a1f41dc4901771f8 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        attrs: {
            localId: {
                default: null
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        marks: '',
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            }
        },
        selectable: false
    });
    const $bfdcc8a4590754dc$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block'
    });
    const $bfdcc8a4590754dc$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$b6ce52be8d7a261 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            text: {
                default: ''
            },
            color: {
                default: ''
            },
            localId: {
                default: ''
            },
            style: {
                default: ''
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$9852986a3ec5f6a0 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$ce086a560a1d05f5 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'tableRow+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            displayMode: {
                default: null
            },
            isNumberColumnEnabled: {
                default: false
            },
            layout: {
                default: 'default'
            },
            localId: {
                default: ''
            },
            width: {
                default: null
            },
            __autoSize: {
                default: false
            }
        },
        selectable: true,
        isolating: true,
        tableRole: 'table'
    });
    const $bfdcc8a4590754dc$export$e1e720e5f4603e6a = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$abf39ca178940ff3 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'cell'
    });
    const $bfdcc8a4590754dc$export$48884d2a5190dc73 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$2a5a518232fa1a97 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
        marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
        attrs: {
            colspan: {
                default: 1
            },
            rowspan: {
                default: 1
            },
            colwidth: {
                default: null
            },
            background: {
                default: null
            }
        },
        selectable: false,
        isolating: true,
        tableRole: 'header_cell'
    });
    const $bfdcc8a4590754dc$export$ce666bf02318c957 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$7d657479499397 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(tableCell | tableHeader)+',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        selectable: false,
        tableRole: 'row'
    });
    const $bfdcc8a4590754dc$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: 'inline*',
        marks: '_',
        attrs: {
            localId: {
                default: ''
            },
            state: {
                default: 'TODO'
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$375b6afcc5f4d291 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
        marks: 'unsupportedMark unsupportedNodeAttribute',
        group: 'block',
        attrs: {
            localId: {
                default: ''
            }
        },
        selectable: false,
        defining: true
    });
    const $bfdcc8a4590754dc$export$6f093cfa640b7166 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$5ea06bc686c59dc2 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$93256a4c17b33a82 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline'
    });
    const $bfdcc8a4590754dc$export$a12828d0f14a2762 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({});
    const $bfdcc8a4590754dc$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'block',
        atom: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
    const $bfdcc8a4590754dc$export$310ebe0d80122e9b = (0, (0, parcelRequire("f0ccE")).createPMNodeSpecFactory)({
        group: 'inline',
        inline: true,
        attrs: {
            originalValue: {
                default: {}
            }
        },
        selectable: true
    });
});
parcelRegister("f0ccE", function(module, exports) {
    $parcel$export(module.exports, "createPMNodeSpecFactory", ()=>$aec0525c0df12bb9$export$bf0a80f00e2b8ff6);
    $parcel$export(module.exports, "createPMMarkSpecFactory", ()=>$aec0525c0df12bb9$export$cf5823ed4e9f4c6f);
    const $aec0525c0df12bb9$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...nodeSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
    const $aec0525c0df12bb9$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
            return {
                ...markSpec,
                ...parseDOM && {
                    parseDOM: parseDOM
                },
                ...toDOM && {
                    toDOM: toDOM
                },
                ...toDebugString && {
                    toDebugString: toDebugString
                }
            };
        };
});
parcelRegister("7kC9H", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$5567ff8f3f52f7a8$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>$5567ff8f3f52f7a8$export$7b80cba28d10b2c1);
    $parcel$export(module.exports, "toJSON", ()=>$5567ff8f3f52f7a8$export$54fd2c36b5cc6731);
    var $gthjq;
    function $5567ff8f3f52f7a8$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $5567ff8f3f52f7a8$var$nodeSpecOptions = {
        parseDOM: [
            {
                context: 'table//',
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'expand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="expand"]',
                getAttrs: $5567ff8f3f52f7a8$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'expand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    };
    const $5567ff8f3f52f7a8$export$9f77e0932fb78f72 = (0, (0, parcelRequire("gthjq")).expandWithoutNestedExpand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$7b80cba28d10b2c1 = (0, (0, parcelRequire("gthjq")).expand)($5567ff8f3f52f7a8$var$nodeSpecOptions);
    const $5567ff8f3f52f7a8$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("47jug", function(module, exports) {
    $parcel$export(module.exports, "extensionFrame", ()=>$2ff6ee9baaedd4b6$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$2ff6ee9baaedd4b6$export$c3c04d555a8b9013);
    var $CWpyq;
    var $gthjq;
    const $2ff6ee9baaedd4b6$export$4fdcae991fd743e7 = (0, (0, parcelRequire("gthjq")).extensionFrameStage0)({
        parseDOM: [
            {
                context: 'extensionFrame//',
                tag: 'div[data-extension-frame]',
                skip: true
            },
            {
                tag: 'div[data-extension-frame]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-extension-frame': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $2ff6ee9baaedd4b6$export$c3c04d555a8b9013 = (0, (0, parcelRequire("gthjq")).multiBodiedExtensionStage0)({
        parseDOM: [
            {
                context: 'multiBodiedExtension//',
                tag: '[data-node-type="multi-bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="multi-bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'multi-bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("CWpyq", function(module, exports) {
    $parcel$export(module.exports, "getExtensionAttrs", ()=>$0750dbf71b86cced$export$1765e2758fc47004);
    const $0750dbf71b86cced$export$d5f21755dc782a4a = (name)=>{
        return !!name && [
            'default',
            'wide',
            'full-width'
        ].includes(name);
    };
    const $0750dbf71b86cced$export$1765e2758fc47004 = (dom, isInline = false)=>{
        const extensionType = dom.getAttribute('data-extension-type');
        const extensionKey = dom.getAttribute('data-extension-key');
        if (!extensionType || !extensionKey) return false;
        const attrs = {
            extensionType: extensionType,
            extensionKey: extensionKey,
            text: dom.getAttribute('data-text') || undefined,
            parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
            localId: dom.getAttribute('data-local-id') || undefined
        };
        if (!isInline) {
            const rawLayout = dom.getAttribute('data-layout');
            attrs.layout = $0750dbf71b86cced$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
        }
        return attrs;
    };
});
parcelRegister("gZoER", function(module, exports) {
    $parcel$export(module.exports, "layoutSection", ()=>$c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>$c5e57867b1f8b9c7$export$4f9d8f623ff17117);
    var $gthjq;
    const $c5e57867b1f8b9c7$export$b3b6a70a7fa4a5be = (0, (0, parcelRequire("gthjq")).layoutSection)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$cdae19acb0a520fd = (0, (0, parcelRequire("gthjq")).layoutSectionFull)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-layout-section': 'true'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
    const $c5e57867b1f8b9c7$export$4f9d8f623ff17117 = (0, (0, parcelRequire("gthjq")).layoutSectionWithSingleColumnStage0)({
        parseDOM: [
            {
                context: 'layoutSection//|layoutColumn//',
                tag: 'div[data-layout-section]',
                skip: true
            },
            {
                tag: 'div[data-layout-section]',
                getAttrs: (dom)=>{
                    const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                    return columnRuleStyle ? {
                        columnRuleStyle: columnRuleStyle
                    } : {};
                }
            }
        ],
        toDOM (node) {
            const { columnRuleStyle: columnRuleStyle } = node.attrs;
            const attrs = {
                'data-layout-section': 'true',
                'data-column-rule-style': columnRuleStyle || undefined
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("2FIVU", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$1f2243de0d109562$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "listItemWithTask", ()=>$1f2243de0d109562$export$58dca2f0678302a4);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>$1f2243de0d109562$export$b2cd54d5ce935ddb);
    var $gthjq;
    const $1f2243de0d109562$export$76c7e83ecc9cdf05 = (0, (0, parcelRequire("gthjq")).listItem)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
    const $1f2243de0d109562$export$58dca2f0678302a4 = $1f2243de0d109562$export$76c7e83ecc9cdf05;
    const $1f2243de0d109562$export$b2cd54d5ce935ddb = (0, (0, parcelRequire("gthjq")).listItemWithNestedDecisionStage0)({
        parseDOM: [
            {
                tag: 'li'
            }
        ],
        toDOM () {
            return [
                'li',
                0
            ];
        }
    });
});
parcelRegister("bFtEE", function(module, exports) {
    $parcel$export(module.exports, "PanelType", ()=>$87ea86de426496d8$export$969277cf61e5a7aa);
    $parcel$export(module.exports, "extendedPanel", ()=>$87ea86de426496d8$export$ce20b13564211141);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>$87ea86de426496d8$export$1f8c55a804c909c7);
    var $gthjq;
    let $87ea86de426496d8$export$969277cf61e5a7aa = function(PanelType) {
        PanelType["INFO"] = "info";
        PanelType["NOTE"] = "note";
        PanelType["TIP"] = "tip";
        PanelType["WARNING"] = "warning";
        PanelType["ERROR"] = "error";
        PanelType["SUCCESS"] = "success";
        PanelType["CUSTOM"] = "custom";
        return PanelType;
    }({});
    const $87ea86de426496d8$var$getDomAttrs = (nodeAttrs)=>{
        const attrs = {
            'data-panel-type': nodeAttrs.panelType,
            'data-panel-icon': nodeAttrs.panelIcon,
            'data-panel-icon-id': nodeAttrs.panelIconId,
            'data-panel-icon-text': nodeAttrs.panelIconText,
            'data-panel-color': nodeAttrs.panelColor
        };
        return attrs;
    };
    const $87ea86de426496d8$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
        let parseDOMAttrs = {
            panelType: dom.getAttribute('data-panel-type')
        };
        if (allowCustomPanel) parseDOMAttrs = {
            ...parseDOMAttrs,
            panelIcon: dom.getAttribute('data-panel-icon'),
            panelIconId: dom.getAttribute('data-panel-icon-id'),
            panelIconText: dom.getAttribute('data-panel-icon-text'),
            panelColor: dom.getAttribute('data-panel-color')
        };
        else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $87ea86de426496d8$export$969277cf61e5a7aa.CUSTOM ? $87ea86de426496d8$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
        return parseDOMAttrs;
    };
    const $87ea86de426496d8$export$ce20b13564211141 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panel)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
    const $87ea86de426496d8$export$1f8c55a804c909c7 = (allowCustomPanel)=>{
        const panelNodeSpec = (0, (0, parcelRequire("gthjq")).panelWithNestedBlockquoteStage0)({
            parseDOM: [
                {
                    tag: 'div[data-panel-type]',
                    getAttrs: (dom)=>$87ea86de426496d8$var$getParseDOMAttrs(allowCustomPanel, dom)
                }
            ],
            toDOM (node) {
                const attrs = $87ea86de426496d8$var$getDomAttrs(node.attrs);
                const contentAttrs = {
                    'data-panel-content': 'true'
                };
                return [
                    'div',
                    attrs,
                    [
                        'div',
                        contentAttrs,
                        0
                    ]
                ];
            }
        });
        return panelNodeSpec;
    };
});
parcelRegister("9UDEr", function(module, exports) {
    $parcel$export(module.exports, "tablePrefixSelector", ()=>$737819f27951a815$export$9cfceb893b24742a);
    $parcel$export(module.exports, "tableCellSelector", ()=>$737819f27951a815$export$69cb4c3f80383763);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>$737819f27951a815$export$7b07d37d879c957f);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>$737819f27951a815$export$8dd42a84cd52da07);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>$737819f27951a815$export$5e26a5c19f0865d8);
    $parcel$export(module.exports, "getCellAttrs", ()=>$737819f27951a815$export$43977bde391e007);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>$737819f27951a815$export$363c8dda799bfe9c);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>$737819f27951a815$export$8cc2833b5b349a1e);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>$737819f27951a815$export$219b7f492ad209f8);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>$737819f27951a815$export$95e9c925fbf01d1c);
    $parcel$export(module.exports, "table", ()=>$737819f27951a815$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>$737819f27951a815$export$90e634fbace1f0c4);
    $parcel$export(module.exports, "tableStage0", ()=>$737819f27951a815$export$3862de5c8c9098cf);
    $parcel$export(module.exports, "tableToJSON", ()=>$737819f27951a815$export$1f92a2f429e06fa8);
    $parcel$export(module.exports, "tableRow", ()=>$737819f27951a815$export$ce666bf02318c957);
    $parcel$export(module.exports, "tableCell", ()=>$737819f27951a815$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "toJSONTableCell", ()=>$737819f27951a815$export$2ac34c099660f1a8);
    $parcel$export(module.exports, "tableHeader", ()=>$737819f27951a815$export$48884d2a5190dc73);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>$737819f27951a815$export$2af48797a1010bb1);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>$737819f27951a815$export$ce086a560a1d05f5);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>$737819f27951a815$export$7d657479499397);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>$737819f27951a815$export$abf39ca178940ff3);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>$737819f27951a815$export$2a5a518232fa1a97);
    var $daes7;
    var $51H8P;
    var $9IGaJ;
    var $87j2U;
    var $gthjq;
    const $737819f27951a815$export$9cfceb893b24742a = 'pm-table';
    const $737819f27951a815$export$69cb4c3f80383763 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-content-wrap`;
    const $737819f27951a815$export$7b07d37d879c957f = `${$737819f27951a815$export$9cfceb893b24742a}-header-content-wrap`;
    const $737819f27951a815$export$8dd42a84cd52da07 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
    const $737819f27951a815$export$5e26a5c19f0865d8 = `${$737819f27951a815$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
    const $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, (0, parcelRequire("51H8P")).N20).toLocaleLowerCase();
    const $737819f27951a815$export$43977bde391e007 = (dom, defaultValues = {})=>{
        const widthAttr = dom.getAttribute('data-colwidth');
        const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
        const colspan = Number(dom.getAttribute('colspan') || 1);
        let { backgroundColor: backgroundColor } = dom.style;
        const dataCellBackground = dom.getAttribute('data-cell-background');
        const dataCellBackgroundHexCode = dataCellBackground && (0, (0, parcelRequire("51H8P")).isHex)(dataCellBackground) ? dataCellBackground : undefined;
        if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
        else if (backgroundColor && (0, (0, parcelRequire("51H8P")).isRgb)(backgroundColor)) {
            const result = (0, (0, parcelRequire("51H8P")).rgbToHex)(backgroundColor);
            if (result !== null) backgroundColor = result;
        }
        const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
        return {
            colspan: colspan,
            rowspan: Number(dom.getAttribute('rowspan') || 1),
            colwidth: width && width.length === colspan ? width : null,
            background: backgroundHexCode
        };
    };
    let $737819f27951a815$var$testGlobalTheme;
    const $737819f27951a815$export$fd7e0dd2b74807f7 = (theme)=>{
        $737819f27951a815$var$testGlobalTheme = theme;
    };
    const $737819f27951a815$var$getGlobalTheme = ()=>{
        if ($737819f27951a815$var$testGlobalTheme) return {
            colorMode: $737819f27951a815$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $737819f27951a815$var$cssVariablePattern = /^var\(--.*\)$/;
    const $737819f27951a815$export$363c8dda799bfe9c = (node)=>{
        const attrs = {};
        const nodeType = node.type.name;
        if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
        if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
        if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
        if (node.attrs.background) {
            const { background: background } = node.attrs;
            const ignored = nodeType === 'tableHeader' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $737819f27951a815$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
            if (ignored) attrs.style = '';
            else {
                const color = (0, (0, parcelRequire("51H8P")).isRgb)(background) && (0, (0, parcelRequire("51H8P")).rgbToHex)(background) ? (0, (0, parcelRequire("51H8P")).rgbToHex)(background) : background;
                const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorBackgroundPaletteRawValue)(color);
                if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
                else if ($737819f27951a815$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
                else if ($737819f27951a815$var$getGlobalTheme().colorMode === 'dark') attrs.style = `background-color: ${(0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(color)};`;
                else attrs.style = `background-color: ${background};`;
                if (color) attrs['data-cell-background'] = color;
                attrs.colorname = $737819f27951a815$export$219b7f492ad209f8.get(color);
            }
        }
        if (nodeType === 'tableHeader') attrs.class = $737819f27951a815$export$7b07d37d879c957f;
        else attrs.class = $737819f27951a815$export$69cb4c3f80383763;
        return attrs;
    };
    const $737819f27951a815$export$219b7f492ad209f8 = new Map();
    const $737819f27951a815$export$95e9c925fbf01d1c = (0, (0, parcelRequire("51H8P")).hexToRgba)((0, (0, parcelRequire("51H8P")).N800), 0.12) || (0, (0, parcelRequire("51H8P")).N0);
    const $737819f27951a815$export$8cc2833b5b349a1e = new Map();
    [
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B50),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T50),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G50),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y50),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R50),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N20),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P75),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N60),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T100),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G200),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Dark yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R100),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P100),
            'Dark purple'
        ]
    ].forEach(([colorValue, colorName])=>{
        $737819f27951a815$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
        $737819f27951a815$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
    });
    const $737819f27951a815$var$tableNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    };
    const $737819f27951a815$var$createTableSpec = ()=>(0, (0, parcelRequire("gthjq")).table)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$9852986a3ec5f6a0 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$90e634fbace1f0c4 = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$export$3862de5c8c9098cf = $737819f27951a815$var$createTableSpec();
    const $737819f27951a815$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
    const $737819f27951a815$export$1f92a2f429e06fa8 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>$737819f27951a815$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
    const $737819f27951a815$var$tableRowNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'tr'
            }
        ],
        toDOM () {
            return [
                'tr',
                0
            ];
        }
    };
    const $737819f27951a815$export$ce666bf02318c957 = (0, (0, parcelRequire("gthjq")).tableRow)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$var$cellAttrs = {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    };
    const $737819f27951a815$var$tableCellNodeSpecOptions = {
        parseDOM: [
            {
                tag: '.ak-renderer-table-number-column',
                ignore: true
            },
            {
                tag: 'td',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom)
            }
        ],
        toDOM: (node)=>[
                'td',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$e1e720e5f4603e6a = (0, (0, parcelRequire("gthjq")).tableCell)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2ac34c099660f1a8 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($737819f27951a815$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
    const $737819f27951a815$var$tableHeaderNodeSpecOptions = {
        parseDOM: [
            {
                tag: 'th',
                getAttrs: (dom)=>$737819f27951a815$export$43977bde391e007(dom, {
                        background: $737819f27951a815$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                    })
            }
        ],
        toDOM: (node)=>[
                'th',
                $737819f27951a815$export$363c8dda799bfe9c(node),
                0
            ]
    };
    const $737819f27951a815$export$48884d2a5190dc73 = (0, (0, parcelRequire("gthjq")).tableHeader)($737819f27951a815$var$tableHeaderNodeSpecOptions);
    const $737819f27951a815$export$2af48797a1010bb1 = $737819f27951a815$export$2ac34c099660f1a8;
    const $737819f27951a815$export$ce086a560a1d05f5 = (0, (0, parcelRequire("gthjq")).tableWithNestedTable)($737819f27951a815$var$tableNodeSpecOptions);
    const $737819f27951a815$export$7d657479499397 = (0, (0, parcelRequire("gthjq")).tableRowWithNestedTable)($737819f27951a815$var$tableRowNodeSpecOptions);
    const $737819f27951a815$export$abf39ca178940ff3 = (0, (0, parcelRequire("gthjq")).tableCellWithNestedTable)($737819f27951a815$var$tableCellNodeSpecOptions);
    const $737819f27951a815$export$2a5a518232fa1a97 = (0, (0, parcelRequire("gthjq")).tableHeaderWithNestedTable)($737819f27951a815$var$tableHeaderNodeSpecOptions);
});
parcelRegister("daes7", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBorderPaletteColor", ()=>$99576b847e5fbb17$export$bad3c41dd33cb4bc);
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$99576b847e5fbb17$export$9c2f408d391feb93);
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$99576b847e5fbb17$export$8b58ff1b36bb75e0);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$99576b847e5fbb17$export$a270511a0e7fd61a);
    function $99576b847e5fbb17$export$bad3c41dd33cb4bc(hexColor) {
        return hexColor ? $99576b847e5fbb17$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
    }
    const $99576b847e5fbb17$export$aa000893c5e2b9c2 = {
        '#091E4224': 'var(--ds-border, #091E4224)',
        '#758195': 'var(--ds-border-bold, #758195)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$9c2f408d391feb93(hexColor) {
        return hexColor ? $99576b847e5fbb17$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
    }
    const $99576b847e5fbb17$export$57fa5089caad992 = {
        '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
        '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
        '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
        '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
        '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
        '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
        '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
        '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
        '#006644': 'var(--ds-text-accent-green, #006644)',
        '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
        '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
        '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
        '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
        '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
        '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
        '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
        '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
        '#403294': 'var(--ds-text-accent-purple, #403294)',
        '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
        '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
        '#172B4D': 'var(--ds-text, #172B4D)'
    };
    function $99576b847e5fbb17$export$8b58ff1b36bb75e0(hexColor) {
        return hexColor ? $99576b847e5fbb17$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
    }
    const $99576b847e5fbb17$export$12a518ff137dd389 = {
        '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
        '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
        '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
        '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
        '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
        '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
    };
    function $99576b847e5fbb17$export$a270511a0e7fd61a(hexColor) {
        const tokenData = hexColor ? $99576b847e5fbb17$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $99576b847e5fbb17$export$2462741d70e6a62f = {
        '#DEEBFF': {
            getValue: ()=>'#DEEBFF',
            token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
        },
        '#B3D4FF': {
            getValue: ()=>'#B3D4FF',
            token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
        },
        '#4C9AFF': {
            getValue: ()=>'#4C9AFF',
            token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
        },
        '#E6FCFF': {
            getValue: ()=>'#E6FCFF',
            token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
        },
        '#B3F5FF': {
            getValue: ()=>'#B3F5FF',
            token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
        },
        '#79E2F2': {
            getValue: ()=>'#79E2F2',
            token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
        },
        '#E3FCEF': {
            getValue: ()=>'#E3FCEF',
            token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
        },
        '#ABF5D1': {
            getValue: ()=>'#ABF5D1',
            token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
        },
        '#57D9A3': {
            getValue: ()=>'#57D9A3',
            token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
        },
        '#FFFAE6': {
            getValue: ()=>'#FFFAE6',
            token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
        },
        '#FFF0B3': {
            getValue: ()=>'#FFF0B3',
            token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
        },
        '#FFC400': {
            getValue: ()=>'#FFC400',
            token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
        },
        '#FFEBE6': {
            getValue: ()=>'#FFEBE6',
            token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
        },
        '#FFBDAD': {
            getValue: ()=>'#FFBDAD',
            token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
        },
        '#FF8F73': {
            getValue: ()=>'#FF8F73',
            token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
        },
        '#EAE6FF': {
            getValue: ()=>'#EAE6FF',
            token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
        },
        '#C0B6F2': {
            getValue: ()=>'#C0B6F2',
            token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
        },
        '#998DD9': {
            getValue: ()=>'#998DD9',
            token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
        },
        '#FFFFFF': {
            getValue: ()=>'#FFFFFF',
            token: 'var(--ds-surface, #FFFFFF)'
        },
        '#F4F5F7': {
            getValue: ()=>'#F4F5F7',
            token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
        },
        '#B3BAC5': {
            getValue: ()=>'#B3BAC5',
            token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
        }
    };
});
parcelRegister("51H8P", function(module, exports) {
    $parcel$export(module.exports, "R50", ()=>$3a8e82bcbd673dd1$export$4b84fd0e2c617bd);
    $parcel$export(module.exports, "R75", ()=>$3a8e82bcbd673dd1$export$b34b069eff244586);
    $parcel$export(module.exports, "R100", ()=>$3a8e82bcbd673dd1$export$be802dd0d8b57f35);
    $parcel$export(module.exports, "R300", ()=>$3a8e82bcbd673dd1$export$4a7404f376229999);
    $parcel$export(module.exports, "R400", ()=>$3a8e82bcbd673dd1$export$2010d0fb4295b346);
    $parcel$export(module.exports, "R500", ()=>$3a8e82bcbd673dd1$export$2837b5a1a71d5c02);
    $parcel$export(module.exports, "Y50", ()=>$3a8e82bcbd673dd1$export$8d9596b529bbb9cf);
    $parcel$export(module.exports, "Y75", ()=>$3a8e82bcbd673dd1$export$41060a744ab0b7ae);
    $parcel$export(module.exports, "Y200", ()=>$3a8e82bcbd673dd1$export$5aae31392d72caaa);
    $parcel$export(module.exports, "Y400", ()=>$3a8e82bcbd673dd1$export$59619663aa6500fb);
    $parcel$export(module.exports, "G50", ()=>$3a8e82bcbd673dd1$export$8a6341c32b6a3ee6);
    $parcel$export(module.exports, "G75", ()=>$3a8e82bcbd673dd1$export$69a3bf21b9686c2b);
    $parcel$export(module.exports, "G200", ()=>$3a8e82bcbd673dd1$export$747d86715d4175de);
    $parcel$export(module.exports, "G300", ()=>$3a8e82bcbd673dd1$export$940e1f69e873f202);
    $parcel$export(module.exports, "G400", ()=>$3a8e82bcbd673dd1$export$a49394138f7b8e85);
    $parcel$export(module.exports, "G500", ()=>$3a8e82bcbd673dd1$export$6fa04827ac68a4fb);
    $parcel$export(module.exports, "B50", ()=>$3a8e82bcbd673dd1$export$226de0355ed012f8);
    $parcel$export(module.exports, "B75", ()=>$3a8e82bcbd673dd1$export$8c13c2ee36917869);
    $parcel$export(module.exports, "B100", ()=>$3a8e82bcbd673dd1$export$ecfc1dff386a3e7a);
    $parcel$export(module.exports, "B400", ()=>$3a8e82bcbd673dd1$export$b3de0ae08da2ce64);
    $parcel$export(module.exports, "B500", ()=>$3a8e82bcbd673dd1$export$a6ee3d71bc067634);
    $parcel$export(module.exports, "L200", ()=>$3a8e82bcbd673dd1$export$f72948ef771f6f15);
    $parcel$export(module.exports, "N0", ()=>$3a8e82bcbd673dd1$export$29a4f05edc054374);
    $parcel$export(module.exports, "N20", ()=>$3a8e82bcbd673dd1$export$9fdfb749e33cdf97);
    $parcel$export(module.exports, "N30", ()=>$3a8e82bcbd673dd1$export$3e51e8f1440314ba);
    $parcel$export(module.exports, "N40", ()=>$3a8e82bcbd673dd1$export$1ce2d1575d444ceb);
    $parcel$export(module.exports, "N50", ()=>$3a8e82bcbd673dd1$export$8754fc7e6d8b3000);
    $parcel$export(module.exports, "N60", ()=>$3a8e82bcbd673dd1$export$c2e91cbeada39b8b);
    $parcel$export(module.exports, "N80", ()=>$3a8e82bcbd673dd1$export$eaa8c8a70ac22806);
    $parcel$export(module.exports, "N200", ()=>$3a8e82bcbd673dd1$export$f563ee71e9ee74cd);
    $parcel$export(module.exports, "N300", ()=>$3a8e82bcbd673dd1$export$e2ef2124cf4024b1);
    $parcel$export(module.exports, "Neutral300", ()=>$3a8e82bcbd673dd1$export$1ae1cebe22dcedb4);
    $parcel$export(module.exports, "N300A", ()=>$3a8e82bcbd673dd1$export$13609db0e6812ab8);
    $parcel$export(module.exports, "N500", ()=>$3a8e82bcbd673dd1$export$c39c0fe0f26207ae);
    $parcel$export(module.exports, "N600", ()=>$3a8e82bcbd673dd1$export$7090862dc3038a9f);
    $parcel$export(module.exports, "N800", ()=>$3a8e82bcbd673dd1$export$7d61b15e0da132af);
    $parcel$export(module.exports, "N1000", ()=>$3a8e82bcbd673dd1$export$f78789c8b01753cd);
    $parcel$export(module.exports, "M200", ()=>$3a8e82bcbd673dd1$export$a19f0c33186f7767);
    $parcel$export(module.exports, "O200", ()=>$3a8e82bcbd673dd1$export$51716a84e62e022c);
    $parcel$export(module.exports, "P50", ()=>$3a8e82bcbd673dd1$export$363e4475840015bb);
    $parcel$export(module.exports, "P75", ()=>$3a8e82bcbd673dd1$export$4b0a4417ed59760f);
    $parcel$export(module.exports, "P100", ()=>$3a8e82bcbd673dd1$export$6011520a64d9a187);
    $parcel$export(module.exports, "P200", ()=>$3a8e82bcbd673dd1$export$a7175d4e9206bc80);
    $parcel$export(module.exports, "P300", ()=>$3a8e82bcbd673dd1$export$b48405b95304b5a1);
    $parcel$export(module.exports, "P500", ()=>$3a8e82bcbd673dd1$export$147899de772240ec);
    $parcel$export(module.exports, "T50", ()=>$3a8e82bcbd673dd1$export$2cf711fe14c66f06);
    $parcel$export(module.exports, "T75", ()=>$3a8e82bcbd673dd1$export$7a8f4d33f6f9772c);
    $parcel$export(module.exports, "T100", ()=>$3a8e82bcbd673dd1$export$776c9c497ef08533);
    $parcel$export(module.exports, "T200", ()=>$3a8e82bcbd673dd1$export$69cb3ca10c1e330e);
    $parcel$export(module.exports, "T300", ()=>$3a8e82bcbd673dd1$export$9dc1ef0f3f48059b);
    $parcel$export(module.exports, "T500", ()=>$3a8e82bcbd673dd1$export$6036577f95c3877e);
    $parcel$export(module.exports, "normalizeHexColor", ()=>$3a8e82bcbd673dd1$export$b61655071712e690);
    $parcel$export(module.exports, "isHex", ()=>$3a8e82bcbd673dd1$export$8a9b6341a7c96bc);
    $parcel$export(module.exports, "isRgb", ()=>$3a8e82bcbd673dd1$export$e698776ec826343);
    $parcel$export(module.exports, "rgbToHex", ()=>$3a8e82bcbd673dd1$export$34d09c4a771c46ef);
    $parcel$export(module.exports, "hexToRgb", ()=>$3a8e82bcbd673dd1$export$5a544e13ad4e1fa5);
    $parcel$export(module.exports, "hexToRgba", ()=>$3a8e82bcbd673dd1$export$9665a07d9187b414);
    var $3nnJa = parcelRequire("3nnJa");
    const $3a8e82bcbd673dd1$export$4b84fd0e2c617bd = '#FFEBE6';
    const $3a8e82bcbd673dd1$export$b34b069eff244586 = '#FFBDAD';
    const $3a8e82bcbd673dd1$export$be802dd0d8b57f35 = '#FF8F73';
    const $3a8e82bcbd673dd1$export$4a7404f376229999 = '#FF5630';
    const $3a8e82bcbd673dd1$export$2010d0fb4295b346 = '#DE350B';
    const $3a8e82bcbd673dd1$export$2837b5a1a71d5c02 = '#BF2600';
    const $3a8e82bcbd673dd1$export$8d9596b529bbb9cf = '#FFFAE6';
    const $3a8e82bcbd673dd1$export$41060a744ab0b7ae = '#FFF0B3';
    const $3a8e82bcbd673dd1$export$5aae31392d72caaa = '#FFC400';
    const $3a8e82bcbd673dd1$export$59619663aa6500fb = '#FF991F';
    const $3a8e82bcbd673dd1$export$874739ea9e379ab6 = '#FF8B00';
    const $3a8e82bcbd673dd1$export$8a6341c32b6a3ee6 = '#E3FCEF';
    const $3a8e82bcbd673dd1$export$69a3bf21b9686c2b = '#ABF5D1';
    const $3a8e82bcbd673dd1$export$747d86715d4175de = '#57D9A3';
    const $3a8e82bcbd673dd1$export$940e1f69e873f202 = '#36B37E';
    const $3a8e82bcbd673dd1$export$a49394138f7b8e85 = '#00875A';
    const $3a8e82bcbd673dd1$export$6fa04827ac68a4fb = '#006644';
    const $3a8e82bcbd673dd1$export$226de0355ed012f8 = '#DEEBFF';
    const $3a8e82bcbd673dd1$export$8c13c2ee36917869 = '#B3D4FF';
    const $3a8e82bcbd673dd1$export$ecfc1dff386a3e7a = '#4C9AFF';
    const $3a8e82bcbd673dd1$export$b3de0ae08da2ce64 = '#0052CC';
    const $3a8e82bcbd673dd1$export$a6ee3d71bc067634 = '#0747A6';
    const $3a8e82bcbd673dd1$export$f72948ef771f6f15 = '#D3F1A7';
    const $3a8e82bcbd673dd1$export$29a4f05edc054374 = '#FFFFFF';
    const $3a8e82bcbd673dd1$export$9fdfb749e33cdf97 = '#F4F5F7';
    const $3a8e82bcbd673dd1$export$3e51e8f1440314ba = '#EBECF0';
    const $3a8e82bcbd673dd1$export$1ce2d1575d444ceb = '#DFE1E6';
    const $3a8e82bcbd673dd1$export$8754fc7e6d8b3000 = '#C1C7D0';
    const $3a8e82bcbd673dd1$export$c2e91cbeada39b8b = '#B3BAC5';
    const $3a8e82bcbd673dd1$export$eaa8c8a70ac22806 = '#97A0AF';
    const $3a8e82bcbd673dd1$export$7c87d337fb91a97d = '#8993A4';
    const $3a8e82bcbd673dd1$export$f563ee71e9ee74cd = '#6B778C';
    const $3a8e82bcbd673dd1$export$e2ef2124cf4024b1 = '#5E6C84';
    const $3a8e82bcbd673dd1$export$1ae1cebe22dcedb4 = '#DCDFE4';
    const $3a8e82bcbd673dd1$export$13609db0e6812ab8 = '#091E4224';
    const $3a8e82bcbd673dd1$export$c39c0fe0f26207ae = '#42526E';
    const $3a8e82bcbd673dd1$export$7090862dc3038a9f = '#758195';
    const $3a8e82bcbd673dd1$export$7d61b15e0da132af = '#172B4D';
    const $3a8e82bcbd673dd1$export$f78789c8b01753cd = '#172B4D';
    const $3a8e82bcbd673dd1$export$a19f0c33186f7767 = '#FDD0EC';
    const $3a8e82bcbd673dd1$export$51716a84e62e022c = '#FEDEC8';
    const $3a8e82bcbd673dd1$export$363e4475840015bb = '#EAE6FF';
    const $3a8e82bcbd673dd1$export$4b0a4417ed59760f = '#C0B6F2';
    const $3a8e82bcbd673dd1$export$6011520a64d9a187 = '#998DD9';
    const $3a8e82bcbd673dd1$export$a7175d4e9206bc80 = '#DFD8FD';
    const $3a8e82bcbd673dd1$export$b48405b95304b5a1 = '#6554C0';
    const $3a8e82bcbd673dd1$export$c71e4279dd54a18d = '#5243AA';
    const $3a8e82bcbd673dd1$export$147899de772240ec = '#403294';
    const $3a8e82bcbd673dd1$export$2cf711fe14c66f06 = '#E6FCFF';
    const $3a8e82bcbd673dd1$export$7a8f4d33f6f9772c = '#B3F5FF';
    const $3a8e82bcbd673dd1$export$776c9c497ef08533 = '#79E2F2';
    const $3a8e82bcbd673dd1$export$69cb3ca10c1e330e = '#C6EDFB';
    const $3a8e82bcbd673dd1$export$9dc1ef0f3f48059b = '#00B8D9';
    const $3a8e82bcbd673dd1$export$6036577f95c3877e = '#008DA6';
    function $3a8e82bcbd673dd1$export$b61655071712e690(color, defaultColor) {
        if (!color) return null;
        color = color.trim().toLowerCase();
        if ($3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) {
            if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
        } else if ($3a8e82bcbd673dd1$export$e698776ec826343(color)) return $3a8e82bcbd673dd1$export$34d09c4a771c46ef(color);
        else {
            if (color === 'default') return null;
            else if ($3nnJa.default && $3nnJa.default[color]) color = $3nnJa.default[color];
            else if ($3nnJa && $3nnJa[color]) color = $3nnJa[color];
            else return null;
        }
        if (color === defaultColor) return null;
        return color;
    }
    function $3a8e82bcbd673dd1$export$5a544e13ad4e1fa5(color) {
        if (!$3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color)) return null;
        let colorBits = color.substring(1).split('');
        if (colorBits.length === 3) colorBits = [
            colorBits[0],
            colorBits[0],
            colorBits[1],
            colorBits[1],
            colorBits[2],
            colorBits[2]
        ];
        const rgb = Number(`0x${colorBits.join('')}`);
        return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
    }
    function $3a8e82bcbd673dd1$export$9665a07d9187b414(rawColor, alpha) {
        const color = $3a8e82bcbd673dd1$export$b61655071712e690(rawColor);
        if (!color) return null;
        const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
        return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
    }
    function $3a8e82bcbd673dd1$export$34d09c4a771c46ef(value) {
        const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
        if (matches && matches.length >= 3) {
            const [red, green, blue] = matches.map(Number);
            return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
        }
        return null;
    }
    function $3a8e82bcbd673dd1$export$e698776ec826343(color) {
        return /rgba?\(/.test(color);
    }
    function $3a8e82bcbd673dd1$export$8a9b6341a7c96bc(color) {
        return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
    }
});
parcelRegister("3nnJa", function(module, exports) {
    module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");
});
parcelRegister("9IGaJ", function(module, exports) {
    $parcel$export(module.exports, "generateUuid", ()=>$7138efa2a0163ee8$export$1c3aefb711c3a4cc);
    $parcel$export(module.exports, "uuid", ()=>$7138efa2a0163ee8$export$31b40729666a4ae0);
    const $7138efa2a0163ee8$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0;
            return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
        });
    let $7138efa2a0163ee8$var$staticValue = false;
    const $7138efa2a0163ee8$export$31b40729666a4ae0 = {
        setStatic (value) {
            $7138efa2a0163ee8$var$staticValue = value;
        },
        generate () {
            return $7138efa2a0163ee8$var$staticValue || $7138efa2a0163ee8$export$1c3aefb711c3a4cc();
        }
    };
});
parcelRegister("87j2U", function(module, exports) {
    $parcel$export(module.exports, "getDarkModeLCHColor", ()=>$5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99);
    const $5e8dc04ff4ab4f7d$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
    const $5e8dc04ff4ab4f7d$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
    const $5e8dc04ff4ab4f7d$var$rgbFromHex = (input)=>{
        const fullHex = $5e8dc04ff4ab4f7d$var$expandShorthandHex(input);
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
        return result === null ? null : {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToHex = ({ r: r, g: g, b: b })=>{
        const convertComponent = (c)=>{
            const cBase16 = c.toString(16);
            return cBase16.length === 1 ? `0${cBase16}` : cBase16;
        };
        return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
    };
    const $5e8dc04ff4ab4f7d$var$rgbToXyz = (rgb)=>{
        const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
        const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
        const r = convertRgbComponent(rgb.r / 255);
        const g = convertRgbComponent(rgb.g / 255);
        const b = convertRgbComponent(rgb.b / 255);
        return {
            x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
            y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
            z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToLab = ({ x: x, y: y, z: z })=>({
            l: Math.max(116 * y - 16, 0),
            a: 500 * (x - y),
            b: 200 * (y - z)
        });
    const $5e8dc04ff4ab4f7d$var$labToLch = ({ l: l, a: a, b: b })=>{
        let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
        const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
        if (Math.round(c * 10000) === 0) h = Number.NaN;
        return {
            l: l,
            c: c,
            h: h
        };
    };
    const $5e8dc04ff4ab4f7d$var$lchToLab = ({ l: l, c: c, h: h })=>{
        const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
        return {
            l: l,
            a: Math.cos(convertH) * c,
            b: Math.sin(convertH) * c
        };
    };
    const $5e8dc04ff4ab4f7d$var$labToXyz = ({ l: l, a: a, b: b })=>{
        const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
        const y = (l + 16) / 116;
        const x = a / 500 + y;
        const z = y - b / 200;
        return {
            x: convertComponent(x) * 0.95047,
            y: convertComponent(y),
            z: convertComponent(z) * 1.08883
        };
    };
    const $5e8dc04ff4ab4f7d$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
        const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
        return {
            r: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
            g: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
            b: $5e8dc04ff4ab4f7d$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
        };
    };
    const $5e8dc04ff4ab4f7d$var$rgbToLch = (rgb)=>$5e8dc04ff4ab4f7d$var$labToLch($5e8dc04ff4ab4f7d$var$xyzToLab($5e8dc04ff4ab4f7d$var$rgbToXyz(rgb)));
    const $5e8dc04ff4ab4f7d$var$lchToRgb = (lch)=>$5e8dc04ff4ab4f7d$var$xyzToRgb($5e8dc04ff4ab4f7d$var$labToXyz($5e8dc04ff4ab4f7d$var$lchToLab(lch)));
    const $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return color;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        lch.l = $5e8dc04ff4ab4f7d$var$clamp(newPercent, 0, 100);
        return $5e8dc04ff4ab4f7d$var$rgbToHex($5e8dc04ff4ab4f7d$var$lchToRgb(lch));
    };
    const $5e8dc04ff4ab4f7d$var$getLightness = (color)=>{
        const rgb = $5e8dc04ff4ab4f7d$var$rgbFromHex(color);
        if (rgb === null) return 0;
        const lch = $5e8dc04ff4ab4f7d$var$rgbToLch(rgb);
        return lch.l;
    };
    const $5e8dc04ff4ab4f7d$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
        const lightness = $5e8dc04ff4ab4f7d$var$getLightness(currentBackgroundColor);
        const newLightness = Math.abs(100 - lightness);
        return $5e8dc04ff4ab4f7d$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
    };
});
parcelRegister("kBho7", function(module, exports) {
    $parcel$export(module.exports, "createSchema", ()=>$eff4c0443be4d23b$export$5f4ce795563f4211);
    var $kCV8T;
    var $7P7H6;
    var $aeGrH;
    var $88i6h;
    var $8jJss;
    var $14Vqw;
    var $zceQE;
    var $lcXoV;
    var $71k4W;
    var $cUwVZ;
    var $l3Tmi;
    var $29Vii;
    var $fK6mK;
    var $8XeG6;
    var $aUhe2;
    var $hhtT8;
    var $4NwJJ;
    var $c9aa1;
    var $dtyqo;
    var $8EAPB;
    var $jxVez;
    var $lVmBd;
    var $21PS7;
    var $aXBFx;
    var $5AxYU;
    var $kjhhp;
    var $5JeV5;
    var $8vlrc;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $b2VmY;
    var $Khvpb;
    var $8gSD8;
    var $xjCuM;
    var $kshOv;
    var $7DoMR;
    var $7kC9H;
    var $bFtEE;
    var $hhN5g;
    var $47jug;
    var $jnMM2;
    var $lRTZM;
    var $7lRBh;
    var $cCBEe;
    var $5BOuQ;
    var $4EbxI;
    var $gZoER;
    var $2FIVU;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $g7Cky;
    var $dx5eC;
    var $dwptW;
    var $abme3;
    var $dgJoa;
    var $M4hHz;
    var $18bvk;
    var $9UDEr;
    var $iThOL;
    var $43mJF;
    var $3DR6L;
    var $9X587;
    var $d1d6m;
    var $6kr5W;
    function $eff4c0443be4d23b$var$addItems(builtInItems, config, customSpecs = {}) {
        if (!config) return {};
        const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
            if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
            return items;
        }, {});
        return Object.keys(customSpecs).reduce((items, name)=>{
            if (items[name]) return items;
            items[name] = customSpecs[name];
            return items;
        }, items);
    }
    function $eff4c0443be4d23b$var$groupDeclaration(name) {
        return {
            name: `__${name}GroupDeclaration`,
            spec: {
                group: name
            }
        };
    }
    const $eff4c0443be4d23b$var$markGroupDeclarations = [
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$9b982809044276a6)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$4498a6080fed604c)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725)),
        $eff4c0443be4d23b$var$groupDeclaration((0, $72fd39d34ca5bb7c$export$b395009ca7f092c7))
    ];
    const $eff4c0443be4d23b$var$markGroupDeclarationsNames = $eff4c0443be4d23b$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
    const $eff4c0443be4d23b$var$nodesInOrder = [
        {
            name: 'doc',
            spec: (0, (0, parcelRequire("xjCuM")).doc)
        },
        {
            name: 'paragraph',
            spec: (0, (0, parcelRequire("abme3")).paragraph)
        },
        {
            name: 'text',
            spec: (0, (0, parcelRequire("3DR6L")).text)
        },
        {
            name: 'bulletList',
            spec: (0, (0, parcelRequire("kjhhp")).bulletList)
        },
        {
            name: 'orderedList',
            spec: (0, (0, parcelRequire("dwptW")).orderedListWithOrder)
        },
        {
            name: 'listItem',
            spec: (0, (0, parcelRequire("2FIVU")).listItemWithTask)
        },
        {
            name: 'heading',
            spec: (0, (0, parcelRequire("lRTZM")).heading)
        },
        {
            name: 'blockquote',
            spec: (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia)
        },
        {
            name: 'codeBlock',
            spec: (0, (0, parcelRequire("8vlrc")).codeBlock)
        },
        {
            name: 'panel',
            spec: (0, (0, parcelRequire("bFtEE")).extendedPanel)(true)
        },
        {
            name: 'rule',
            spec: (0, (0, parcelRequire("M4hHz")).rule)
        },
        {
            name: 'image',
            spec: (0, (0, parcelRequire("7lRBh")).image)
        },
        {
            name: 'mention',
            spec: (0, (0, parcelRequire("g7Cky")).mention)
        },
        {
            name: 'caption',
            spec: (0, (0, parcelRequire("5JeV5")).caption)
        },
        {
            name: 'media',
            spec: (0, (0, parcelRequire("7agO8")).media)
        },
        {
            name: 'mediaGroup',
            spec: (0, (0, parcelRequire("92lix")).mediaGroup)
        },
        {
            name: 'mediaSingle',
            spec: (0, (0, parcelRequire("bIGZ7")).mediaSingleFull)
        },
        {
            name: 'mediaInline',
            spec: (0, (0, parcelRequire("7Xgp3")).mediaInline)
        },
        {
            name: 'placeholder',
            spec: (0, (0, parcelRequire("dgJoa")).placeholder)
        },
        {
            name: 'layoutSection',
            spec: (0, (0, parcelRequire("gZoER")).layoutSection)
        },
        {
            name: 'layoutColumn',
            spec: (0, (0, parcelRequire("4EbxI")).layoutColumn)
        },
        {
            name: 'hardBreak',
            spec: (0, (0, parcelRequire("jnMM2")).hardBreak)
        },
        {
            name: 'emoji',
            spec: (0, (0, parcelRequire("7DoMR")).emoji)
        },
        {
            name: 'table',
            spec: (0, (0, parcelRequire("9UDEr")).table)
        },
        {
            name: 'tableCell',
            spec: (0, (0, parcelRequire("9UDEr")).tableCell)
        },
        {
            name: 'tableRow',
            spec: (0, (0, parcelRequire("9UDEr")).tableRow)
        },
        {
            name: 'tableHeader',
            spec: (0, (0, parcelRequire("9UDEr")).tableHeader)
        },
        {
            name: 'confluenceJiraIssue',
            spec: (0, (0, parcelRequire("6bbHe")).confluenceJiraIssue)
        },
        {
            name: 'confluenceUnsupportedInline',
            spec: (0, (0, parcelRequire("bd7A9")).confluenceUnsupportedInline)
        },
        {
            name: 'confluenceUnsupportedBlock',
            spec: (0, (0, parcelRequire("5y0tR")).confluenceUnsupportedBlock)
        },
        {
            name: 'decisionList',
            spec: (0, (0, parcelRequire("8gSD8")).decisionList)
        },
        {
            name: 'decisionItem',
            spec: (0, (0, parcelRequire("Khvpb")).decisionItem)
        },
        {
            name: 'taskList',
            spec: (0, (0, parcelRequire("43mJF")).taskList)
        },
        {
            name: 'taskItem',
            spec: (0, (0, parcelRequire("iThOL")).taskItem)
        },
        {
            name: 'date',
            spec: (0, (0, parcelRequire("b2VmY")).date)
        },
        {
            name: 'status',
            spec: (0, (0, parcelRequire("18bvk")).status)
        },
        {
            name: 'expand',
            spec: (0, (0, parcelRequire("7kC9H")).expandWithNestedExpand)
        },
        {
            name: 'nestedExpand',
            spec: (0, (0, parcelRequire("dx5eC")).nestedExpand)
        },
        {
            name: 'extension',
            spec: (0, (0, parcelRequire("hhN5g")).extension)
        },
        {
            name: 'inlineExtension',
            spec: (0, (0, parcelRequire("5BOuQ")).inlineExtension)
        },
        {
            name: 'bodiedExtension',
            spec: (0, (0, parcelRequire("5AxYU")).bodiedExtension)
        },
        {
            name: 'multiBodiedExtension',
            spec: (0, (0, parcelRequire("47jug")).multiBodiedExtension)
        },
        {
            name: 'extensionFrame',
            spec: (0, (0, parcelRequire("47jug")).extensionFrame)
        },
        {
            name: 'inlineCard',
            spec: (0, (0, parcelRequire("cCBEe")).inlineCard)
        },
        {
            name: 'blockCard',
            spec: (0, (0, parcelRequire("21PS7")).blockCard)
        },
        {
            name: 'embedCard',
            spec: (0, (0, parcelRequire("kshOv")).embedCard)
        },
        {
            name: 'unknownBlock',
            spec: (0, (0, parcelRequire("9X587")).default)
        },
        {
            name: 'unsupportedBlock',
            spec: (0, (0, parcelRequire("d1d6m")).unsupportedBlock)
        },
        {
            name: 'unsupportedInline',
            spec: (0, (0, parcelRequire("6kr5W")).unsupportedInline)
        }
    ];
    const $eff4c0443be4d23b$var$marksInOrder = [
        {
            name: 'link',
            spec: (0, (0, parcelRequire("8XeG6")).link)
        },
        {
            name: 'em',
            spec: (0, (0, parcelRequire("l3Tmi")).em)
        },
        {
            name: 'strong',
            spec: (0, (0, parcelRequire("hhtT8")).strong)
        },
        {
            name: 'textColor',
            spec: (0, (0, parcelRequire("c9aa1")).textColor)
        },
        {
            name: 'backgroundColor',
            spec: (0, (0, parcelRequire("8jJss")).backgroundColor)
        },
        {
            name: 'strike',
            spec: (0, (0, parcelRequire("aUhe2")).strike)
        },
        {
            name: 'subsup',
            spec: (0, (0, parcelRequire("4NwJJ")).subsup)
        },
        {
            name: 'underline',
            spec: (0, (0, parcelRequire("8EAPB")).underline)
        },
        {
            name: 'code',
            spec: (0, (0, parcelRequire("lcXoV")).code)
        },
        {
            name: 'typeAheadQuery',
            spec: (0, (0, parcelRequire("dtyqo")).typeAheadQuery)
        },
        {
            name: 'alignment',
            spec: (0, (0, parcelRequire("aeGrH")).alignment)
        },
        {
            name: 'annotation',
            spec: (0, (0, parcelRequire("88i6h")).annotation)
        },
        {
            name: 'confluenceInlineComment',
            spec: (0, (0, parcelRequire("71k4W")).confluenceInlineComment)
        },
        ...$eff4c0443be4d23b$var$markGroupDeclarations,
        {
            name: 'breakout',
            spec: (0, (0, parcelRequire("zceQE")).breakout)
        },
        {
            name: 'dataConsumer',
            spec: (0, (0, parcelRequire("cUwVZ")).dataConsumer)
        },
        {
            name: 'fragment',
            spec: (0, (0, parcelRequire("29Vii")).fragment)
        },
        {
            name: 'indentation',
            spec: (0, (0, parcelRequire("fK6mK")).indentation)
        },
        {
            name: 'border',
            spec: (0, (0, parcelRequire("14Vqw")).border)
        },
        {
            name: 'unsupportedMark',
            spec: (0, (0, parcelRequire("jxVez")).unsupportedMark)
        },
        {
            name: 'unsupportedNodeAttribute',
            spec: (0, (0, parcelRequire("lVmBd")).unsupportedNodeAttribute)
        }
    ];
    function $eff4c0443be4d23b$export$2d0c32a809131488() {
        const nodes = $eff4c0443be4d23b$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        const marks = $eff4c0443be4d23b$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
            acc[name] = spec;
            return acc;
        }, {});
        return {
            nodes: nodes,
            marks: marks
        };
    }
    function $eff4c0443be4d23b$export$5f4ce795563f4211(config) {
        const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
        const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
        const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($eff4c0443be4d23b$var$markGroupDeclarationsNames);
        let nodes = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$nodesInOrder, nodesConfig, customNodeSpecs);
        const marks = $eff4c0443be4d23b$var$addItems($eff4c0443be4d23b$var$marksInOrder, marksConfig, customMarkSpecs);
        nodes = (0, (0, parcelRequire("7P7H6")).sanitizeNodes)(nodes, marks);
        return new (0, (0, parcelRequire("kCV8T")).Schema)({
            nodes: nodes,
            marks: marks
        });
    }
    const $eff4c0443be4d23b$export$c77b6d30da5276a1 = true;
});
parcelRegister("kCV8T", function(module, exports) {
    $parcel$export(module.exports, "Fragment", ()=>$f043ae92c0a873f0$export$ffb0004e005737fa);
    $parcel$export(module.exports, "Mark", ()=>$f043ae92c0a873f0$export$c9d15bcfc6d42044);
    $parcel$export(module.exports, "ReplaceError", ()=>$f043ae92c0a873f0$export$6de0e778727af3f2);
    $parcel$export(module.exports, "Slice", ()=>$f043ae92c0a873f0$export$b3f2e2de3a8baa1e);
    $parcel$export(module.exports, "ResolvedPos", ()=>$f043ae92c0a873f0$export$b2a42f82e59e4b19);
    $parcel$export(module.exports, "NodeRange", ()=>$f043ae92c0a873f0$export$7bc461ceb770fb16);
    $parcel$export(module.exports, "Node", ()=>$f043ae92c0a873f0$export$85c928794f8d04d4);
    $parcel$export(module.exports, "MarkType", ()=>$f043ae92c0a873f0$export$b6a78689043c6521);
    $parcel$export(module.exports, "Schema", ()=>$f043ae92c0a873f0$export$19342e026b58ebb7);
    $parcel$export(module.exports, "DOMParser", ()=>$f043ae92c0a873f0$export$1059c6e7d2ce5669);
    $parcel$export(module.exports, "DOMSerializer", ()=>$f043ae92c0a873f0$export$3476b78f8f5a8b72);
    var $dHeNB;
    function $f043ae92c0a873f0$var$findDiffStart(a, b, pos) {
        for(let i = 0;; i++){
            if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
            let childA = a.child(i), childB = b.child(i);
            if (childA == childB) {
                pos += childA.nodeSize;
                continue;
            }
            if (!childA.sameMarkup(childB)) return pos;
            if (childA.isText && childA.text != childB.text) {
                for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
                return pos;
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffStart(childA.content, childB.content, pos + 1);
                if (inner != null) return inner;
            }
            pos += childA.nodeSize;
        }
    }
    function $f043ae92c0a873f0$var$findDiffEnd(a, b, posA, posB) {
        for(let iA = a.childCount, iB = b.childCount;;){
            if (iA == 0 || iB == 0) return iA == iB ? null : {
                a: posA,
                b: posB
            };
            let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
            if (childA == childB) {
                posA -= size;
                posB -= size;
                continue;
            }
            if (!childA.sameMarkup(childB)) return {
                a: posA,
                b: posB
            };
            if (childA.isText && childA.text != childB.text) {
                let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
                while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                    same++;
                    posA--;
                    posB--;
                }
                return {
                    a: posA,
                    b: posB
                };
            }
            if (childA.content.size || childB.content.size) {
                let inner = $f043ae92c0a873f0$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
                if (inner) return inner;
            }
            posA -= size;
            posB -= size;
        }
    }
    class $f043ae92c0a873f0$export$ffb0004e005737fa {
        constructor(content, size){
            this.content = content;
            this.size = size || 0;
            if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
        }
        nodesBetween(from, to, f, nodeStart = 0, parent) {
            for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                    let start = pos + 1;
                    child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
                }
                pos = end;
            }
        }
        descendants(f) {
            this.nodesBetween(0, this.size, f);
        }
        textBetween(from, to, blockSeparator, leafText) {
            let text = "", first = true;
            this.nodesBetween(from, to, (node, pos)=>{
                let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
                if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                    if (first) first = false;
                    else text += blockSeparator;
                }
                text += nodeText;
            }, 0);
            return text;
        }
        append(other) {
            if (!other.size) return this;
            if (!this.size) return other;
            let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
            if (last.isText && last.sameMarkup(first)) {
                content[content.length - 1] = last.withText(last.text + first.text);
                i = 1;
            }
            for(; i < other.content.length; i++)content.push(other.content[i]);
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(content, this.size + other.size);
        }
        cut(from, to = this.size) {
            if (from == 0 && to == this.size) return this;
            let result = [], size = 0;
            if (to > from) for(let i = 0, pos = 0; pos < to; i++){
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(result, size);
        }
        cutByIndex(from, to) {
            if (from == to) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (from == 0 && to == this.content.length) return this;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.slice(from, to));
        }
        replaceChild(index, node) {
            let current = this.content[index];
            if (current == node) return this;
            let copy = this.content.slice();
            let size = this.size + node.nodeSize - current.nodeSize;
            copy[index] = node;
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(copy, size);
        }
        addToStart(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                node
            ].concat(this.content), this.size + node.nodeSize);
        }
        addToEnd(node) {
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
        }
        eq(other) {
            if (this.content.length != other.content.length) return false;
            for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
            return true;
        }
        get firstChild() {
            return this.content.length ? this.content[0] : null;
        }
        get lastChild() {
            return this.content.length ? this.content[this.content.length - 1] : null;
        }
        get childCount() {
            return this.content.length;
        }
        child(index) {
            let found = this.content[index];
            if (!found) throw new RangeError("Index " + index + " out of range for " + this);
            return found;
        }
        maybeChild(index) {
            return this.content[index] || null;
        }
        forEach(f) {
            for(let i = 0, p = 0; i < this.content.length; i++){
                let child = this.content[i];
                f(child, p, i);
                p += child.nodeSize;
            }
        }
        findDiffStart(other, pos = 0) {
            return $f043ae92c0a873f0$var$findDiffStart(this, other, pos);
        }
        findDiffEnd(other, pos = this.size, otherPos = other.size) {
            return $f043ae92c0a873f0$var$findDiffEnd(this, other, pos, otherPos);
        }
        findIndex(pos, round = -1) {
            if (pos == 0) return $f043ae92c0a873f0$var$retIndex(0, pos);
            if (pos == this.size) return $f043ae92c0a873f0$var$retIndex(this.content.length, pos);
            if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
            for(let i = 0, curPos = 0;; i++){
                let cur = this.child(i), end = curPos + cur.nodeSize;
                if (end >= pos) {
                    if (end == pos || round > 0) return $f043ae92c0a873f0$var$retIndex(i + 1, end);
                    return $f043ae92c0a873f0$var$retIndex(i, curPos);
                }
                curPos = end;
            }
        }
        toString() {
            return "<" + this.toStringInner() + ">";
        }
        toStringInner() {
            return this.content.join(", ");
        }
        toJSON() {
            return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
        }
        static fromJSON(schema, value) {
            if (!value) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
        }
        static fromArray(array) {
            if (!array.length) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            let joined, size = 0;
            for(let i = 0; i < array.length; i++){
                let node = array[i];
                size += node.nodeSize;
                if (i && node.isText && array[i - 1].sameMarkup(node)) {
                    if (!joined) joined = array.slice(0, i);
                    joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
                } else if (joined) joined.push(node);
            }
            return new $f043ae92c0a873f0$export$ffb0004e005737fa(joined || array, size);
        }
        static from(nodes) {
            if (!nodes) return $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
            if (nodes instanceof $f043ae92c0a873f0$export$ffb0004e005737fa) return nodes;
            if (Array.isArray(nodes)) return this.fromArray(nodes);
            if (nodes.attrs) return new $f043ae92c0a873f0$export$ffb0004e005737fa([
                nodes
            ], nodes.nodeSize);
            throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
        }
    }
    $f043ae92c0a873f0$export$ffb0004e005737fa.empty = new $f043ae92c0a873f0$export$ffb0004e005737fa([], 0);
    const $f043ae92c0a873f0$var$found = {
        index: 0,
        offset: 0
    };
    function $f043ae92c0a873f0$var$retIndex(index, offset) {
        $f043ae92c0a873f0$var$found.index = index;
        $f043ae92c0a873f0$var$found.offset = offset;
        return $f043ae92c0a873f0$var$found;
    }
    function $f043ae92c0a873f0$var$compareDeep(a, b) {
        if (a === b) return true;
        if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
        let array = Array.isArray(a);
        if (Array.isArray(b) != array) return false;
        if (array) {
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!$f043ae92c0a873f0$var$compareDeep(a[i], b[i])) return false;
        } else {
            for(let p in a)if (!(p in b) || !$f043ae92c0a873f0$var$compareDeep(a[p], b[p])) return false;
            for(let p in b)if (!(p in a)) return false;
        }
        return true;
    }
    class $f043ae92c0a873f0$export$c9d15bcfc6d42044 {
        constructor(type, attrs){
            this.type = type;
            this.attrs = attrs;
        }
        addToSet(set) {
            let copy, placed = false;
            for(let i = 0; i < set.length; i++){
                let other = set[i];
                if (this.eq(other)) return set;
                if (this.type.excludes(other.type)) {
                    if (!copy) copy = set.slice(0, i);
                } else if (other.type.excludes(this.type)) return set;
                else {
                    if (!placed && other.type.rank > this.type.rank) {
                        if (!copy) copy = set.slice(0, i);
                        copy.push(this);
                        placed = true;
                    }
                    if (copy) copy.push(other);
                }
            }
            if (!copy) copy = set.slice();
            if (!placed) copy.push(this);
            return copy;
        }
        removeFromSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
            return false;
        }
        eq(other) {
            return this == other || this.type == other.type && $f043ae92c0a873f0$var$compareDeep(this.attrs, other.attrs);
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
            let type = schema.marks[json.type];
            if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
            let mark = type.create(json.attrs);
            type.checkAttrs(mark.attrs);
            return mark;
        }
        static sameSet(a, b) {
            if (a == b) return true;
            if (a.length != b.length) return false;
            for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
            return true;
        }
        static setFrom(marks) {
            if (!marks || Array.isArray(marks) && marks.length == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (marks instanceof $f043ae92c0a873f0$export$c9d15bcfc6d42044) return [
                marks
            ];
            let copy = marks.slice();
            copy.sort((a, b)=>a.type.rank - b.type.rank);
            return copy;
        }
    }
    $f043ae92c0a873f0$export$c9d15bcfc6d42044.none = [];
    class $f043ae92c0a873f0$export$6de0e778727af3f2 extends Error {
    }
    class $f043ae92c0a873f0$export$b3f2e2de3a8baa1e {
        constructor(content, openStart, openEnd){
            this.content = content;
            this.openStart = openStart;
            this.openEnd = openEnd;
        }
        get size() {
            return this.content.size - this.openStart - this.openEnd;
        }
        insertAt(pos, fragment) {
            let content = $f043ae92c0a873f0$var$insertInto(this.content, pos + this.openStart, fragment);
            return content && new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
        }
        removeBetween(from, to) {
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
        }
        eq(other) {
            return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
        }
        toString() {
            return this.content + "(" + this.openStart + "," + this.openEnd + ")";
        }
        toJSON() {
            if (!this.content.size) return null;
            let json = {
                content: this.content.toJSON()
            };
            if (this.openStart > 0) json.openStart = this.openStart;
            if (this.openEnd > 0) json.openEnd = this.openEnd;
            return json;
        }
        static fromJSON(schema, json) {
            if (!json) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
            if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
        }
        static maxOpen(fragment, openIsolating = true) {
            let openStart = 0, openEnd = 0;
            for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
            for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
        }
    }
    $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty = new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e($f043ae92c0a873f0$export$ffb0004e005737fa.empty, 0, 0);
    function $f043ae92c0a873f0$var$removeRange(content, from, to) {
        let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
        let { index: indexTo, offset: offsetTo } = content.findIndex(to);
        if (offset == from || child.isText) {
            if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
            return content.cut(0, from).append(content.cut(to));
        }
        if (index != indexTo) throw new RangeError("Removing non-flat range");
        return content.replaceChild(index, child.copy($f043ae92c0a873f0$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
    }
    function $f043ae92c0a873f0$var$insertInto(content, dist, insert, parent) {
        let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
        if (offset == dist || child.isText) {
            if (parent && !parent.canReplace(index, index, insert)) return null;
            return content.cut(0, dist).append(insert).append(content.cut(dist));
        }
        let inner = $f043ae92c0a873f0$var$insertInto(child.content, dist - offset - 1, insert);
        return inner && content.replaceChild(index, child.copy(inner));
    }
    function $f043ae92c0a873f0$var$replace($from, $to, slice) {
        if (slice.openStart > $from.depth) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inserted content deeper than insertion position");
        if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Inconsistent open depths");
        return $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, 0);
    }
    function $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth) {
        let index = $from.index(depth), node = $from.node(depth);
        if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
            let inner = $f043ae92c0a873f0$var$replaceOuter($from, $to, slice, depth + 1);
            return node.copy(node.content.replaceChild(index, inner));
        } else if (!slice.content.size) return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth));
        else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
            let parent = $from.parent, content = parent.content;
            return $f043ae92c0a873f0$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
        } else {
            let { start: start, end: end } = $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $from);
            return $f043ae92c0a873f0$var$close(node, $f043ae92c0a873f0$var$replaceThreeWay($from, start, end, $to, depth));
        }
    }
    function $f043ae92c0a873f0$var$checkJoin(main, sub) {
        if (!sub.type.compatibleContent(main.type)) throw new $f043ae92c0a873f0$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
    }
    function $f043ae92c0a873f0$var$joinable($before, $after, depth) {
        let node = $before.node(depth);
        $f043ae92c0a873f0$var$checkJoin(node, $after.node(depth));
        return node;
    }
    function $f043ae92c0a873f0$var$addNode(child, target) {
        let last = target.length - 1;
        if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
        else target.push(child);
    }
    function $f043ae92c0a873f0$var$addRange($start, $end, depth, target) {
        let node = ($end || $start).node(depth);
        let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
        if ($start) {
            startIndex = $start.index(depth);
            if ($start.depth > depth) startIndex++;
            else if ($start.textOffset) {
                $f043ae92c0a873f0$var$addNode($start.nodeAfter, target);
                startIndex++;
            }
        }
        for(let i = startIndex; i < endIndex; i++)$f043ae92c0a873f0$var$addNode(node.child(i), target);
        if ($end && $end.depth == depth && $end.textOffset) $f043ae92c0a873f0$var$addNode($end.nodeBefore, target);
    }
    function $f043ae92c0a873f0$var$close(node, content) {
        node.type.checkContent(content);
        return node.copy(content);
    }
    function $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth) {
        let openStart = $from.depth > depth && $f043ae92c0a873f0$var$joinable($from, $start, depth + 1);
        let openEnd = $to.depth > depth && $f043ae92c0a873f0$var$joinable($end, $to, depth + 1);
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
            $f043ae92c0a873f0$var$checkJoin(openStart, openEnd);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
        } else {
            if (openStart) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openStart, $f043ae92c0a873f0$var$replaceTwoWay($from, $start, depth + 1)), content);
            $f043ae92c0a873f0$var$addRange($start, $end, depth, content);
            if (openEnd) $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(openEnd, $f043ae92c0a873f0$var$replaceTwoWay($end, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth) {
        let content = [];
        $f043ae92c0a873f0$var$addRange(null, $from, depth, content);
        if ($from.depth > depth) {
            let type = $f043ae92c0a873f0$var$joinable($from, $to, depth + 1);
            $f043ae92c0a873f0$var$addNode($f043ae92c0a873f0$var$close(type, $f043ae92c0a873f0$var$replaceTwoWay($from, $to, depth + 1)), content);
        }
        $f043ae92c0a873f0$var$addRange($to, null, depth, content);
        return new $f043ae92c0a873f0$export$ffb0004e005737fa(content);
    }
    function $f043ae92c0a873f0$var$prepareSliceForReplace(slice, $along) {
        let extra = $along.depth - slice.openStart, parent = $along.node(extra);
        let node = parent.copy(slice.content);
        for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
        return {
            start: node.resolveNoCache(slice.openStart + extra),
            end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
        };
    }
    class $f043ae92c0a873f0$export$b2a42f82e59e4b19 {
        constructor(pos, path, parentOffset){
            this.pos = pos;
            this.path = path;
            this.parentOffset = parentOffset;
            this.depth = path.length / 3 - 1;
        }
        resolveDepth(val) {
            if (val == null) return this.depth;
            if (val < 0) return this.depth + val;
            return val;
        }
        get parent() {
            return this.node(this.depth);
        }
        get doc() {
            return this.node(0);
        }
        node(depth) {
            return this.path[this.resolveDepth(depth) * 3];
        }
        index(depth) {
            return this.path[this.resolveDepth(depth) * 3 + 1];
        }
        indexAfter(depth) {
            depth = this.resolveDepth(depth);
            return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
        }
        start(depth) {
            depth = this.resolveDepth(depth);
            return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        }
        end(depth) {
            depth = this.resolveDepth(depth);
            return this.start(depth) + this.node(depth).content.size;
        }
        before(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position before the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
        }
        after(depth) {
            depth = this.resolveDepth(depth);
            if (!depth) throw new RangeError("There is no position after the top-level node");
            return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
        }
        get textOffset() {
            return this.pos - this.path[this.path.length - 1];
        }
        get nodeAfter() {
            let parent = this.parent, index = this.index(this.depth);
            if (index == parent.childCount) return null;
            let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
            return dOff ? parent.child(index).cut(dOff) : child;
        }
        get nodeBefore() {
            let index = this.index(this.depth);
            let dOff = this.pos - this.path[this.path.length - 1];
            if (dOff) return this.parent.child(index).cut(0, dOff);
            return index == 0 ? null : this.parent.child(index - 1);
        }
        posAtIndex(index, depth) {
            depth = this.resolveDepth(depth);
            let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
            for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
            return pos;
        }
        marks() {
            let parent = this.parent, index = this.index();
            if (parent.content.size == 0) return $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            if (this.textOffset) return parent.child(index).marks;
            let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
            if (!main) {
                let tmp = main;
                main = other;
                other = tmp;
            }
            let marks = main.marks;
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        marksAcross($end) {
            let after = this.parent.maybeChild(this.index());
            if (!after || !after.isInline) return null;
            let marks = after.marks, next = $end.parent.maybeChild($end.index());
            for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
            return marks;
        }
        sharedDepth(pos) {
            for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
            return 0;
        }
        blockRange(other = this, pred) {
            if (other.pos < this.pos) return other.blockRange(this);
            for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $f043ae92c0a873f0$export$7bc461ceb770fb16(this, other, d);
            return null;
        }
        sameParent(other) {
            return this.pos - this.parentOffset == other.pos - other.parentOffset;
        }
        max(other) {
            return other.pos > this.pos ? other : this;
        }
        min(other) {
            return other.pos < this.pos ? other : this;
        }
        toString() {
            let str = "";
            for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
            return str + ":" + this.parentOffset;
        }
        static resolve(doc, pos) {
            if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
            let path = [];
            let start = 0, parentOffset = pos;
            for(let node = doc;;){
                let { index: index, offset: offset } = node.content.findIndex(parentOffset);
                let rem = parentOffset - offset;
                path.push(node, index, start + offset);
                if (!rem) break;
                node = node.child(index);
                if (node.isText) break;
                parentOffset = rem - 1;
                start += offset + 1;
            }
            return new $f043ae92c0a873f0$export$b2a42f82e59e4b19(pos, path, parentOffset);
        }
        static resolveCached(doc, pos) {
            let cache = $f043ae92c0a873f0$var$resolveCache.get(doc);
            if (cache) for(let i = 0; i < cache.elts.length; i++){
                let elt = cache.elts[i];
                if (elt.pos == pos) return elt;
            }
            else $f043ae92c0a873f0$var$resolveCache.set(doc, cache = new $f043ae92c0a873f0$var$ResolveCache);
            let result = cache.elts[cache.i] = $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(doc, pos);
            cache.i = (cache.i + 1) % $f043ae92c0a873f0$var$resolveCacheSize;
            return result;
        }
    }
    class $f043ae92c0a873f0$var$ResolveCache {
        constructor(){
            this.elts = [];
            this.i = 0;
        }
    }
    const $f043ae92c0a873f0$var$resolveCacheSize = 12, $f043ae92c0a873f0$var$resolveCache = new WeakMap();
    class $f043ae92c0a873f0$export$7bc461ceb770fb16 {
        constructor($from, $to, depth){
            this.$from = $from;
            this.$to = $to;
            this.depth = depth;
        }
        get start() {
            return this.$from.before(this.depth + 1);
        }
        get end() {
            return this.$to.after(this.depth + 1);
        }
        get parent() {
            return this.$from.node(this.depth);
        }
        get startIndex() {
            return this.$from.index(this.depth);
        }
        get endIndex() {
            return this.$to.indexAfter(this.depth);
        }
    }
    const $f043ae92c0a873f0$var$emptyAttrs = Object.create(null);
    class $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.content = content || $f043ae92c0a873f0$export$ffb0004e005737fa.empty;
        }
        get nodeSize() {
            return this.isLeaf ? 1 : 2 + this.content.size;
        }
        get childCount() {
            return this.content.childCount;
        }
        child(index) {
            return this.content.child(index);
        }
        maybeChild(index) {
            return this.content.maybeChild(index);
        }
        forEach(f) {
            this.content.forEach(f);
        }
        nodesBetween(from, to, f, startPos = 0) {
            this.content.nodesBetween(from, to, f, startPos, this);
        }
        descendants(f) {
            this.nodesBetween(0, this.content.size, f);
        }
        get textContent() {
            return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
        }
        textBetween(from, to, blockSeparator, leafText) {
            return this.content.textBetween(from, to, blockSeparator, leafText);
        }
        get firstChild() {
            return this.content.firstChild;
        }
        get lastChild() {
            return this.content.lastChild;
        }
        eq(other) {
            return this == other || this.sameMarkup(other) && this.content.eq(other.content);
        }
        sameMarkup(other) {
            return this.hasMarkup(other.type, other.attrs, other.marks);
        }
        hasMarkup(type, attrs, marks) {
            return this.type == type && $f043ae92c0a873f0$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $f043ae92c0a873f0$var$emptyAttrs) && $f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $f043ae92c0a873f0$export$c9d15bcfc6d42044.none);
        }
        copy(content = null) {
            if (content == this.content) return this;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
        }
        cut(from, to = this.content.size) {
            if (from == 0 && to == this.content.size) return this;
            return this.copy(this.content.cut(from, to));
        }
        slice(from, to = this.content.size, includeParents = false) {
            if (from == to) return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.empty;
            let $from = this.resolve(from), $to = this.resolve(to);
            let depth = includeParents ? 0 : $from.sharedDepth(to);
            let start = $from.start(depth), node = $from.node(depth);
            let content = node.content.cut($from.pos - start, $to.pos - start);
            return new $f043ae92c0a873f0$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
        }
        replace(from, to, slice) {
            return $f043ae92c0a873f0$var$replace(this.resolve(from), this.resolve(to), slice);
        }
        nodeAt(pos) {
            for(let node = this;;){
                let { index: index, offset: offset } = node.content.findIndex(pos);
                node = node.maybeChild(index);
                if (!node) return null;
                if (offset == pos || node.isText) return node;
                pos -= offset + 1;
            }
        }
        childAfter(pos) {
            let { index: index, offset: offset } = this.content.findIndex(pos);
            return {
                node: this.content.maybeChild(index),
                index: index,
                offset: offset
            };
        }
        childBefore(pos) {
            if (pos == 0) return {
                node: null,
                index: 0,
                offset: 0
            };
            let { index: index, offset: offset } = this.content.findIndex(pos);
            if (offset < pos) return {
                node: this.content.child(index),
                index: index,
                offset: offset
            };
            let node = this.content.child(index - 1);
            return {
                node: node,
                index: index - 1,
                offset: offset - node.nodeSize
            };
        }
        resolve(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolveCached(this, pos);
        }
        resolveNoCache(pos) {
            return $f043ae92c0a873f0$export$b2a42f82e59e4b19.resolve(this, pos);
        }
        rangeHasMark(from, to, type) {
            let found = false;
            if (to > from) this.nodesBetween(from, to, (node)=>{
                if (type.isInSet(node.marks)) found = true;
                return !found;
            });
            return found;
        }
        get isBlock() {
            return this.type.isBlock;
        }
        get isTextblock() {
            return this.type.isTextblock;
        }
        get inlineContent() {
            return this.type.inlineContent;
        }
        get isInline() {
            return this.type.isInline;
        }
        get isText() {
            return this.type.isText;
        }
        get isLeaf() {
            return this.type.isLeaf;
        }
        get isAtom() {
            return this.type.isAtom;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            let name = this.type.name;
            if (this.content.size) name += "(" + this.content.toStringInner() + ")";
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, name);
        }
        contentMatchAt(index) {
            let match = this.type.contentMatch.matchFragment(this.content, 0, index);
            if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
            return match;
        }
        canReplace(from, to, replacement = $f043ae92c0a873f0$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
            let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
            let two = one && one.matchFragment(this.content, to);
            if (!two || !two.validEnd) return false;
            for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
            return true;
        }
        canReplaceWith(from, to, type, marks) {
            if (marks && !this.type.allowsMarks(marks)) return false;
            let start = this.contentMatchAt(from).matchType(type);
            let end = start && start.matchFragment(this.content, to);
            return end ? end.validEnd : false;
        }
        canAppend(other) {
            if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
            else return this.type.compatibleContent(other.type);
        }
        check() {
            this.type.checkContent(this.content);
            this.type.checkAttrs(this.attrs);
            let copy = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            for(let i = 0; i < this.marks.length; i++){
                let mark = this.marks[i];
                mark.type.checkAttrs(mark.attrs);
                copy = mark.addToSet(copy);
            }
            if (!$f043ae92c0a873f0$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
            this.content.forEach((node)=>node.check());
        }
        toJSON() {
            let obj = {
                type: this.type.name
            };
            for(let _ in this.attrs){
                obj.attrs = this.attrs;
                break;
            }
            if (this.content.size) obj.content = this.content.toJSON();
            if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
            return obj;
        }
        static fromJSON(schema, json) {
            if (!json) throw new RangeError("Invalid input for Node.fromJSON");
            let marks = undefined;
            if (json.marks) {
                if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
                marks = json.marks.map(schema.markFromJSON);
            }
            if (json.type == "text") {
                if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
                return schema.text(json.text, marks);
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.fromJSON(schema, json.content);
            let node = schema.nodeType(json.type).create(json.attrs, content, marks);
            node.type.checkAttrs(node.attrs);
            return node;
        }
    }
    $f043ae92c0a873f0$export$85c928794f8d04d4.prototype.text = undefined;
    class $f043ae92c0a873f0$var$TextNode extends $f043ae92c0a873f0$export$85c928794f8d04d4 {
        constructor(type, attrs, content, marks){
            super(type, attrs, null, marks);
            if (!content) throw new RangeError("Empty text nodes are not allowed");
            this.text = content;
        }
        toString() {
            if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
            return $f043ae92c0a873f0$var$wrapMarks(this.marks, JSON.stringify(this.text));
        }
        get textContent() {
            return this.text;
        }
        textBetween(from, to) {
            return this.text.slice(from, to);
        }
        get nodeSize() {
            return this.text.length;
        }
        mark(marks) {
            return marks == this.marks ? this : new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, this.text, marks);
        }
        withText(text) {
            if (text == this.text) return this;
            return new $f043ae92c0a873f0$var$TextNode(this.type, this.attrs, text, this.marks);
        }
        cut(from = 0, to = this.text.length) {
            if (from == 0 && to == this.text.length) return this;
            return this.withText(this.text.slice(from, to));
        }
        eq(other) {
            return this.sameMarkup(other) && this.text == other.text;
        }
        toJSON() {
            let base = super.toJSON();
            base.text = this.text;
            return base;
        }
    }
    function $f043ae92c0a873f0$var$wrapMarks(marks, str) {
        for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
        return str;
    }
    class $f043ae92c0a873f0$export$364ed450558d7ec4 {
        constructor(validEnd){
            this.validEnd = validEnd;
            this.next = [];
            this.wrapCache = [];
        }
        static parse(string, nodeTypes) {
            let stream = new $f043ae92c0a873f0$var$TokenStream(string, nodeTypes);
            if (stream.next == null) return $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (stream.next) stream.err("Unexpected trailing text");
            let match = $f043ae92c0a873f0$var$dfa($f043ae92c0a873f0$var$nfa(expr));
            $f043ae92c0a873f0$var$checkForDeadEnds(match, stream);
            return match;
        }
        matchType(type) {
            for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
            return null;
        }
        matchFragment(frag, start = 0, end = frag.childCount) {
            let cur = this;
            for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
            return cur;
        }
        get inlineContent() {
            return this.next.length != 0 && this.next[0].type.isInline;
        }
        get defaultType() {
            for(let i = 0; i < this.next.length; i++){
                let { type: type } = this.next[i];
                if (!(type.isText || type.hasRequiredAttrs())) return type;
            }
            return null;
        }
        compatible(other) {
            for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
            return false;
        }
        fillBefore(after, toEnd = false, startIndex = 0) {
            let seen = [
                this
            ];
            function search(match, types) {
                let finished = match.matchFragment(after, startIndex);
                if (finished && (!toEnd || finished.validEnd)) return $f043ae92c0a873f0$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                        seen.push(next);
                        let found = search(next, types.concat(type));
                        if (found) return found;
                    }
                }
                return null;
            }
            return search(this, []);
        }
        findWrapping(target) {
            for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
            let computed = this.computeWrapping(target);
            this.wrapCache.push(target, computed);
            return computed;
        }
        computeWrapping(target) {
            let seen = Object.create(null), active = [
                {
                    match: this,
                    type: null,
                    via: null
                }
            ];
            while(active.length){
                let current = active.shift(), match = current.match;
                if (match.matchType(target)) {
                    let result = [];
                    for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                    return result.reverse();
                }
                for(let i = 0; i < match.next.length; i++){
                    let { type: type, next: next } = match.next[i];
                    if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                        active.push({
                            match: type.contentMatch,
                            type: type,
                            via: current
                        });
                        seen[type.name] = true;
                    }
                }
            }
            return null;
        }
        get edgeCount() {
            return this.next.length;
        }
        edge(n) {
            if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
            return this.next[n];
        }
        toString() {
            let seen = [];
            function scan(m) {
                seen.push(m);
                for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
            }
            scan(this);
            return seen.map((m, i)=>{
                let out = i + (m.validEnd ? "*" : " ") + " ";
                for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
                return out;
            }).join("\n");
        }
    }
    $f043ae92c0a873f0$export$364ed450558d7ec4.empty = new $f043ae92c0a873f0$export$364ed450558d7ec4(true);
    class $f043ae92c0a873f0$var$TokenStream {
        constructor(string, nodeTypes){
            this.string = string;
            this.nodeTypes = nodeTypes;
            this.inline = null;
            this.pos = 0;
            this.tokens = string.split(/\s*(?=\b|\W|$)/);
            if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
            if (this.tokens[0] == "") this.tokens.shift();
        }
        get next() {
            return this.tokens[this.pos];
        }
        eat(tok) {
            return this.next == tok && (this.pos++ || true);
        }
        err(str) {
            throw new SyntaxError(str + " (in content expression '" + this.string + "')");
        }
    }
    function $f043ae92c0a873f0$var$parseExpr(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSeq(stream));
        while (stream.eat("|"))
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSeq(stream) {
        let exprs = [];
        do exprs.push($f043ae92c0a873f0$var$parseExprSubscript(stream));
        while (stream.next && stream.next != ")" && stream.next != "|")
        return exprs.length == 1 ? exprs[0] : {
            type: "seq",
            exprs: exprs
        };
    }
    function $f043ae92c0a873f0$var$parseExprSubscript(stream) {
        let expr = $f043ae92c0a873f0$var$parseExprAtom(stream);
        for(;;){
            if (stream.eat("+")) expr = {
                type: "plus",
                expr: expr
            };
            else if (stream.eat("*")) expr = {
                type: "star",
                expr: expr
            };
            else if (stream.eat("?")) expr = {
                type: "opt",
                expr: expr
            };
            else if (stream.eat("{")) expr = $f043ae92c0a873f0$var$parseExprRange(stream, expr);
            else break;
        }
        return expr;
    }
    function $f043ae92c0a873f0$var$parseNum(stream) {
        if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
        let result = Number(stream.next);
        stream.pos++;
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprRange(stream, expr) {
        let min = $f043ae92c0a873f0$var$parseNum(stream), max = min;
        if (stream.eat(",")) {
            if (stream.next != "}") max = $f043ae92c0a873f0$var$parseNum(stream);
            else max = -1;
        }
        if (!stream.eat("}")) stream.err("Unclosed braced range");
        return {
            type: "range",
            min: min,
            max: max,
            expr: expr
        };
    }
    function $f043ae92c0a873f0$var$resolveName(stream, name) {
        let types = stream.nodeTypes, type = types[name];
        if (type) return [
            type
        ];
        let result = [];
        for(let typeName in types){
            let type = types[typeName];
            if (type.groups.indexOf(name) > -1) result.push(type);
        }
        if (result.length == 0) stream.err("No node type or group '" + name + "' found");
        return result;
    }
    function $f043ae92c0a873f0$var$parseExprAtom(stream) {
        if (stream.eat("(")) {
            let expr = $f043ae92c0a873f0$var$parseExpr(stream);
            if (!stream.eat(")")) stream.err("Missing closing paren");
            return expr;
        } else if (!/\W/.test(stream.next)) {
            let exprs = $f043ae92c0a873f0$var$resolveName(stream, stream.next).map((type)=>{
                if (stream.inline == null) stream.inline = type.isInline;
                else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
                return {
                    type: "name",
                    value: type
                };
            });
            stream.pos++;
            return exprs.length == 1 ? exprs[0] : {
                type: "choice",
                exprs: exprs
            };
        } else stream.err("Unexpected token '" + stream.next + "'");
    }
    function $f043ae92c0a873f0$var$nfa(expr) {
        let nfa = [
            []
        ];
        connect(compile(expr, 0), node());
        return nfa;
        function node() {
            return nfa.push([]) - 1;
        }
        function edge(from, to, term) {
            let edge = {
                term: term,
                to: to
            };
            nfa[from].push(edge);
            return edge;
        }
        function connect(edges, to) {
            edges.forEach((edge)=>edge.to = to);
        }
        function compile(expr, from) {
            if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
            else if (expr.type == "seq") for(let i = 0;; i++){
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1) return next;
                connect(next, from = node());
            }
            else if (expr.type == "star") {
                let loop = node();
                edge(from, loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "plus") {
                let loop = node();
                connect(compile(expr.expr, from), loop);
                connect(compile(expr.expr, loop), loop);
                return [
                    edge(loop)
                ];
            } else if (expr.type == "opt") return [
                edge(from)
            ].concat(compile(expr.expr, from));
            else if (expr.type == "range") {
                let cur = from;
                for(let i = 0; i < expr.min; i++){
                    let next = node();
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                if (expr.max == -1) connect(compile(expr.expr, cur), cur);
                else for(let i = expr.min; i < expr.max; i++){
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
                return [
                    edge(cur)
                ];
            } else if (expr.type == "name") return [
                edge(from, undefined, expr.value)
            ];
            else throw new Error("Unknown expr type");
        }
    }
    function $f043ae92c0a873f0$var$cmp(a, b) {
        return b - a;
    }
    function $f043ae92c0a873f0$var$nullFrom(nfa, node) {
        let result = [];
        scan(node);
        return result.sort($f043ae92c0a873f0$var$cmp);
        function scan(node) {
            let edges = nfa[node];
            if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
            result.push(node);
            for(let i = 0; i < edges.length; i++){
                let { term: term, to: to } = edges[i];
                if (!term && result.indexOf(to) == -1) scan(to);
            }
        }
    }
    function $f043ae92c0a873f0$var$dfa(nfa) {
        let labeled = Object.create(null);
        return explore($f043ae92c0a873f0$var$nullFrom(nfa, 0));
        function explore(states) {
            let out = [];
            states.forEach((node)=>{
                nfa[node].forEach(({ term: term, to: to })=>{
                    if (!term) return;
                    let set;
                    for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                    $f043ae92c0a873f0$var$nullFrom(nfa, to).forEach((node)=>{
                        if (!set) out.push([
                            term,
                            set = []
                        ]);
                        if (set.indexOf(node) == -1) set.push(node);
                    });
                });
            });
            let state = labeled[states.join(",")] = new $f043ae92c0a873f0$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
            for(let i = 0; i < out.length; i++){
                let states = out[i][1].sort($f043ae92c0a873f0$var$cmp);
                state.next.push({
                    type: out[i][0],
                    next: labeled[states.join(",")] || explore(states)
                });
            }
            return state;
        }
    }
    function $f043ae92c0a873f0$var$checkForDeadEnds(match, stream) {
        for(let i = 0, work = [
            match
        ]; i < work.length; i++){
            let state = work[i], dead = !state.validEnd, nodes = [];
            for(let j = 0; j < state.next.length; j++){
                let { type: type, next: next } = state.next[j];
                nodes.push(type.name);
                if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
                if (work.indexOf(next) == -1) work.push(next);
            }
            if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
        }
    }
    function $f043ae92c0a873f0$var$defaultAttrs(attrs) {
        let defaults = Object.create(null);
        for(let attrName in attrs){
            let attr = attrs[attrName];
            if (!attr.hasDefault) return null;
            defaults[attrName] = attr.default;
        }
        return defaults;
    }
    function $f043ae92c0a873f0$var$computeAttrs(attrs, value) {
        let built = Object.create(null);
        for(let name in attrs){
            let given = value && value[name];
            if (given === undefined) {
                let attr = attrs[name];
                if (attr.hasDefault) given = attr.default;
                else throw new RangeError("No value supplied for attribute " + name);
            }
            built[name] = given;
        }
        return built;
    }
    function $f043ae92c0a873f0$var$checkAttrs(attrs, values, type, name) {
        for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
        for(let name in attrs){
            let attr = attrs[name];
            if (attr.validate) attr.validate(values[name]);
        }
    }
    function $f043ae92c0a873f0$var$initAttrs(typeName, attrs) {
        let result = Object.create(null);
        if (attrs) for(let name in attrs)result[name] = new $f043ae92c0a873f0$var$Attribute(typeName, name, attrs[name]);
        return result;
    }
    class $f043ae92c0a873f0$export$f06e977173f1857c {
        constructor(name, schema, spec){
            this.name = name;
            this.schema = schema;
            this.spec = spec;
            this.markSet = null;
            this.groups = spec.group ? spec.group.split(" ") : [];
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.defaultAttrs = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.contentMatch = null;
            this.inlineContent = null;
            this.isBlock = !(spec.inline || name == "text");
            this.isText = name == "text";
        }
        get isInline() {
            return !this.isBlock;
        }
        get isTextblock() {
            return this.isBlock && this.inlineContent;
        }
        get isLeaf() {
            return this.contentMatch == $f043ae92c0a873f0$export$364ed450558d7ec4.empty;
        }
        get isAtom() {
            return this.isLeaf || !!this.spec.atom;
        }
        get whitespace() {
            return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
        }
        hasRequiredAttrs() {
            for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
            return false;
        }
        compatibleContent(other) {
            return this == other || this.contentMatch.compatible(other.contentMatch);
        }
        computeAttrs(attrs) {
            if (!attrs && this.defaultAttrs) return this.defaultAttrs;
            else return $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs);
        }
        create(attrs = null, content, marks) {
            if (this.isText) throw new Error("NodeType.create can't construct text nodes");
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $f043ae92c0a873f0$export$ffb0004e005737fa.from(content), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createChecked(attrs = null, content, marks) {
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            this.checkContent(content);
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        createAndFill(attrs = null, content, marks) {
            attrs = this.computeAttrs(attrs);
            content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(content);
            if (content.size) {
                let before = this.contentMatch.fillBefore(content);
                if (!before) return null;
                content = before.append(content);
            }
            let matched = this.contentMatch.matchFragment(content);
            let after = matched && matched.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true);
            if (!after) return null;
            return new $f043ae92c0a873f0$export$85c928794f8d04d4(this, attrs, content.append(after), $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        validContent(content) {
            let result = this.contentMatch.matchFragment(content);
            if (!result || !result.validEnd) return false;
            for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
            return true;
        }
        checkContent(content) {
            if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "node", this.name);
        }
        allowsMarkType(markType) {
            return this.markSet == null || this.markSet.indexOf(markType) > -1;
        }
        allowsMarks(marks) {
            if (this.markSet == null) return true;
            for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
            return true;
        }
        allowedMarks(marks) {
            if (this.markSet == null) return marks;
            let copy;
            for(let i = 0; i < marks.length; i++){
                if (!this.allowsMarkType(marks[i].type)) {
                    if (!copy) copy = marks.slice(0, i);
                } else if (copy) copy.push(marks[i]);
            }
            return !copy ? marks : copy.length ? copy : $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
        }
        static compile(nodes, schema) {
            let result = Object.create(null);
            nodes.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$f06e977173f1857c(name, schema, spec));
            let topType = schema.spec.topNode || "doc";
            if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
            if (!result.text) throw new RangeError("Every schema needs a 'text' type");
            for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
            return result;
        }
    }
    function $f043ae92c0a873f0$var$validateType(typeName, attrName, type) {
        let types = type.split("|");
        return (value)=>{
            let name = value === null ? "null" : typeof value;
            if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
        };
    }
    class $f043ae92c0a873f0$var$Attribute {
        constructor(typeName, attrName, options){
            this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
            this.default = options.default;
            this.validate = typeof options.validate == "string" ? $f043ae92c0a873f0$var$validateType(typeName, attrName, options.validate) : options.validate;
        }
        get isRequired() {
            return !this.hasDefault;
        }
    }
    class $f043ae92c0a873f0$export$b6a78689043c6521 {
        constructor(name, rank, schema, spec){
            this.name = name;
            this.rank = rank;
            this.schema = schema;
            this.spec = spec;
            this.attrs = $f043ae92c0a873f0$var$initAttrs(name, spec.attrs);
            this.excluded = null;
            let defaults = $f043ae92c0a873f0$var$defaultAttrs(this.attrs);
            this.instance = defaults ? new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, defaults) : null;
        }
        create(attrs = null) {
            if (!attrs && this.instance) return this.instance;
            return new $f043ae92c0a873f0$export$c9d15bcfc6d42044(this, $f043ae92c0a873f0$var$computeAttrs(this.attrs, attrs));
        }
        static compile(marks, schema) {
            let result = Object.create(null), rank = 0;
            marks.forEach((name, spec)=>result[name] = new $f043ae92c0a873f0$export$b6a78689043c6521(name, rank++, schema, spec));
            return result;
        }
        removeFromSet(set) {
            for(var i = 0; i < set.length; i++)if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
            return set;
        }
        isInSet(set) {
            for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
        }
        checkAttrs(attrs) {
            $f043ae92c0a873f0$var$checkAttrs(this.attrs, attrs, "mark", this.name);
        }
        excludes(other) {
            return this.excluded.indexOf(other) > -1;
        }
    }
    class $f043ae92c0a873f0$export$19342e026b58ebb7 {
        constructor(spec){
            this.linebreakReplacement = null;
            this.cached = Object.create(null);
            let instanceSpec = this.spec = {};
            for(let prop in spec)instanceSpec[prop] = spec[prop];
            instanceSpec.nodes = (0, (0, parcelRequire("dHeNB")).default).from(spec.nodes), instanceSpec.marks = (0, (0, parcelRequire("dHeNB")).default).from(spec.marks || {}), this.nodes = $f043ae92c0a873f0$export$f06e977173f1857c.compile(this.spec.nodes, this);
            this.marks = $f043ae92c0a873f0$export$b6a78689043c6521.compile(this.spec.marks, this);
            let contentExprCache = Object.create(null);
            for(let prop in this.nodes){
                if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
                let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
                type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $f043ae92c0a873f0$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
                type.inlineContent = type.contentMatch.inlineContent;
                if (type.spec.linebreakReplacement) {
                    if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                    if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                    this.linebreakReplacement = type;
                }
                type.markSet = markExpr == "_" ? null : markExpr ? $f043ae92c0a873f0$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
            }
            for(let prop in this.marks){
                let type = this.marks[prop], excl = type.spec.excludes;
                type.excluded = excl == null ? [
                    type
                ] : excl == "" ? [] : $f043ae92c0a873f0$var$gatherMarks(this, excl.split(" "));
            }
            this.nodeFromJSON = this.nodeFromJSON.bind(this);
            this.markFromJSON = this.markFromJSON.bind(this);
            this.topNodeType = this.nodes[this.spec.topNode || "doc"];
            this.cached.wrappings = Object.create(null);
        }
        node(type, attrs = null, content, marks) {
            if (typeof type == "string") type = this.nodeType(type);
            else if (!(type instanceof $f043ae92c0a873f0$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
            else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
            return type.createChecked(attrs, content, marks);
        }
        text(text, marks) {
            let type = this.nodes.text;
            return new $f043ae92c0a873f0$var$TextNode(type, type.defaultAttrs, text, $f043ae92c0a873f0$export$c9d15bcfc6d42044.setFrom(marks));
        }
        mark(type, attrs) {
            if (typeof type == "string") type = this.marks[type];
            return type.create(attrs);
        }
        nodeFromJSON(json) {
            return $f043ae92c0a873f0$export$85c928794f8d04d4.fromJSON(this, json);
        }
        markFromJSON(json) {
            return $f043ae92c0a873f0$export$c9d15bcfc6d42044.fromJSON(this, json);
        }
        nodeType(name) {
            let found = this.nodes[name];
            if (!found) throw new RangeError("Unknown node type: " + name);
            return found;
        }
    }
    function $f043ae92c0a873f0$var$gatherMarks(schema, marks) {
        let found = [];
        for(let i = 0; i < marks.length; i++){
            let name = marks[i], mark = schema.marks[name], ok = mark;
            if (mark) found.push(mark);
            else for(let prop in schema.marks){
                let mark = schema.marks[prop];
                if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
            }
            if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
        }
        return found;
    }
    function $f043ae92c0a873f0$var$isTagRule(rule) {
        return rule.tag != null;
    }
    function $f043ae92c0a873f0$var$isStyleRule(rule) {
        return rule.style != null;
    }
    class $f043ae92c0a873f0$export$1059c6e7d2ce5669 {
        constructor(schema, rules){
            this.schema = schema;
            this.rules = rules;
            this.tags = [];
            this.styles = [];
            let matchedStyles = this.matchedStyles = [];
            rules.forEach((rule)=>{
                if ($f043ae92c0a873f0$var$isTagRule(rule)) this.tags.push(rule);
                else if ($f043ae92c0a873f0$var$isStyleRule(rule)) {
                    let prop = /[^=]*/.exec(rule.style)[0];
                    if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                    this.styles.push(rule);
                }
            });
            this.normalizeLists = !this.tags.some((r)=>{
                if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
                let node = schema.nodes[r.node];
                return node.contentMatch.matchType(node);
            });
        }
        parse(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, false);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return context.finish();
        }
        parseSlice(dom, options = {}) {
            let context = new $f043ae92c0a873f0$var$ParseContext(this, options, true);
            context.addAll(dom, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, options.from, options.to);
            return $f043ae92c0a873f0$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
        }
        matchTag(dom, context, after) {
            for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
                let rule = this.tags[i];
                if ($f043ae92c0a873f0$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                    if (rule.getAttrs) {
                        let result = rule.getAttrs(dom);
                        if (result === false) continue;
                        rule.attrs = result || undefined;
                    }
                    return rule;
                }
            }
        }
        matchStyle(prop, value, context, after) {
            for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
                let rule = this.styles[i], style = rule.style;
                if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
                if (rule.getAttrs) {
                    let result = rule.getAttrs(value);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
        static schemaRules(schema) {
            let result = [];
            function insert(rule) {
                let priority = rule.priority == null ? 50 : rule.priority, i = 0;
                for(; i < result.length; i++){
                    let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                    if (nextPriority < priority) break;
                }
                result.splice(i, 0, rule);
            }
            for(let name in schema.marks){
                let rules = schema.marks[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
                });
            }
            for(let name in schema.nodes){
                let rules = schema.nodes[name].spec.parseDOM;
                if (rules) rules.forEach((rule)=>{
                    insert(rule = $f043ae92c0a873f0$var$copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
                });
            }
            return result;
        }
        static fromSchema(schema) {
            return schema.cached.domParser || (schema.cached.domParser = new $f043ae92c0a873f0$export$1059c6e7d2ce5669(schema, $f043ae92c0a873f0$export$1059c6e7d2ce5669.schemaRules(schema)));
        }
    }
    const $f043ae92c0a873f0$var$blockTags = {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        canvas: true,
        dd: true,
        div: true,
        dl: true,
        fieldset: true,
        figcaption: true,
        figure: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        li: true,
        noscript: true,
        ol: true,
        output: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        tfoot: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$ignoreTags = {
        head: true,
        noscript: true,
        object: true,
        script: true,
        style: true,
        title: true
    };
    const $f043ae92c0a873f0$var$listTags = {
        ol: true,
        ul: true
    };
    const $f043ae92c0a873f0$var$OPT_PRESERVE_WS = 1, $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL = 2, $f043ae92c0a873f0$var$OPT_OPEN_LEFT = 4;
    function $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWhitespace, base) {
        if (preserveWhitespace != null) return (preserveWhitespace ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : 0);
        return type && type.whitespace == "pre" ? $f043ae92c0a873f0$var$OPT_PRESERVE_WS | $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL : base & ~$f043ae92c0a873f0$var$OPT_OPEN_LEFT;
    }
    class $f043ae92c0a873f0$var$NodeContext {
        constructor(type, attrs, marks, solid, match, options){
            this.type = type;
            this.attrs = attrs;
            this.marks = marks;
            this.solid = solid;
            this.options = options;
            this.content = [];
            this.activeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            this.match = match || (options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT ? null : type.contentMatch);
        }
        findWrapping(node) {
            if (!this.match) {
                if (!this.type) return [];
                let fill = this.type.contentMatch.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.from(node));
                if (fill) this.match = this.type.contentMatch.matchFragment(fill);
                else {
                    let start = this.type.contentMatch, wrap;
                    if (wrap = start.findWrapping(node.type)) {
                        this.match = start;
                        return wrap;
                    } else return null;
                }
            }
            return this.match.findWrapping(node.type);
        }
        finish(openEnd) {
            if (!(this.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                let last = this.content[this.content.length - 1], m;
                if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                    let text = last;
                    if (last.text.length == m[0].length) this.content.pop();
                    else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
                }
            }
            let content = $f043ae92c0a873f0$export$ffb0004e005737fa.from(this.content);
            if (!openEnd && this.match) content = content.append(this.match.fillBefore($f043ae92c0a873f0$export$ffb0004e005737fa.empty, true));
            return this.type ? this.type.create(this.attrs, content, this.marks) : content;
        }
        inlineContext(node) {
            if (this.type) return this.type.inlineContent;
            if (this.content.length) return this.content[0].isInline;
            return node.parentNode && !$f043ae92c0a873f0$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
        }
    }
    class $f043ae92c0a873f0$var$ParseContext {
        constructor(parser, options, isOpen){
            this.parser = parser;
            this.options = options;
            this.isOpen = isOpen;
            this.open = 0;
            let topNode = options.topNode, topContext;
            let topOptions = $f043ae92c0a873f0$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $f043ae92c0a873f0$var$OPT_OPEN_LEFT : 0);
            if (topNode) topContext = new $f043ae92c0a873f0$var$NodeContext(topNode.type, topNode.attrs, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
            else if (isOpen) topContext = new $f043ae92c0a873f0$var$NodeContext(null, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            else topContext = new $f043ae92c0a873f0$var$NodeContext(parser.schema.topNodeType, null, $f043ae92c0a873f0$export$c9d15bcfc6d42044.none, true, null, topOptions);
            this.nodes = [
                topContext
            ];
            this.find = options.findPositions;
            this.needsBlock = false;
        }
        get top() {
            return this.nodes[this.open];
        }
        addDOM(dom, marks) {
            if (dom.nodeType == 3) this.addTextNode(dom, marks);
            else if (dom.nodeType == 1) this.addElement(dom, marks);
        }
        addTextNode(dom, marks) {
            let value = dom.nodeValue;
            let top = this.top;
            if (top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
                if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS)) {
                    value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                    if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                        let nodeBefore = top.content[top.content.length - 1];
                        let domNodeBefore = dom.previousSibling;
                        if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                    }
                } else if (!(top.options & $f043ae92c0a873f0$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
                else value = value.replace(/\r\n?/g, "\n");
                if (value) this.insertNode(this.parser.schema.text(value), marks);
                this.findInText(dom);
            } else this.findInside(dom);
        }
        addElement(dom, marks, matchAfter) {
            let name = dom.nodeName.toLowerCase(), ruleID;
            if ($f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $f043ae92c0a873f0$var$normalizeList(dom);
            let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
            if (rule ? rule.ignore : $f043ae92c0a873f0$var$ignoreTags.hasOwnProperty(name)) {
                this.findInside(dom);
                this.ignoreFallback(dom, marks);
            } else if (!rule || rule.skip || rule.closeParent) {
                if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
                else if (rule && rule.skip.nodeType) dom = rule.skip;
                let sync, top = this.top, oldNeedsBlock = this.needsBlock;
                if ($f043ae92c0a873f0$var$blockTags.hasOwnProperty(name)) {
                    if (top.content.length && top.content[0].isInline && this.open) {
                        this.open--;
                        top = this.top;
                    }
                    sync = true;
                    if (!top.type) this.needsBlock = true;
                } else if (!dom.firstChild) {
                    this.leafFallback(dom, marks);
                    return;
                }
                let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
                if (innerMarks) this.addAll(dom, innerMarks);
                if (sync) this.sync(top);
                this.needsBlock = oldNeedsBlock;
            } else {
                let innerMarks = this.readStyles(dom, marks);
                if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
            }
        }
        leafFallback(dom, marks) {
            if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
        }
        ignoreFallback(dom, marks) {
            if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
        }
        readStyles(dom, marks) {
            let styles = dom.style;
            if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value) for(let after = undefined;;){
                    let rule = this.parser.matchStyle(name, value, this, after);
                    if (!rule) break;
                    if (rule.ignore) return null;
                    if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                    else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                    if (rule.consuming === false) after = rule;
                    else break;
                }
            }
            return marks;
        }
        addElementByRule(dom, rule, marks, continueAfter) {
            let sync, nodeType;
            if (rule.node) {
                nodeType = this.parser.schema.nodes[rule.node];
                if (!nodeType.isLeaf) {
                    let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                    if (inner) {
                        sync = true;
                        marks = inner;
                    }
                } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
            } else {
                let markType = this.parser.schema.marks[rule.mark];
                marks = marks.concat(markType.create(rule.attrs));
            }
            let startIn = this.top;
            if (nodeType && nodeType.isLeaf) this.findInside(dom);
            else if (continueAfter) this.addElement(dom, marks, continueAfter);
            else if (rule.getContent) {
                this.findInside(dom);
                rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
            } else {
                let contentDOM = dom;
                if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
                else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
                else if (rule.contentElement) contentDOM = rule.contentElement;
                this.findAround(dom, contentDOM, true);
                this.addAll(contentDOM, marks);
            }
            if (sync && this.sync(startIn)) this.open--;
        }
        addAll(parent, marks, startIndex, endIndex) {
            let index = startIndex || 0;
            for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
                this.findAtPoint(parent, index);
                this.addDOM(dom, marks);
            }
            this.findAtPoint(parent, index);
        }
        findPlace(node, marks) {
            let route, sync;
            for(let depth = this.open; depth >= 0; depth--){
                let cx = this.nodes[depth];
                let found = cx.findWrapping(node);
                if (found && (!route || route.length > found.length)) {
                    route = found;
                    sync = cx;
                    if (!found.length) break;
                }
                if (cx.solid) break;
            }
            if (!route) return null;
            this.sync(sync);
            for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
            return marks;
        }
        insertNode(node, marks) {
            if (node.isInline && this.needsBlock && !this.top.type) {
                let block = this.textblockFromContext();
                if (block) marks = this.enterInner(block, null, marks);
            }
            let innerMarks = this.findPlace(node, marks);
            if (innerMarks) {
                this.closeExtra();
                let top = this.top;
                if (top.match) top.match = top.match.matchType(node.type);
                let nodeMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
                for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
                top.content.push(node.mark(nodeMarks));
                return true;
            }
            return false;
        }
        enter(type, attrs, marks, preserveWS) {
            let innerMarks = this.findPlace(type.create(attrs), marks);
            if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
            return innerMarks;
        }
        enterInner(type, attrs, marks, solid = false, preserveWS) {
            this.closeExtra();
            let top = this.top;
            top.match = top.match && top.match.matchType(type);
            let options = $f043ae92c0a873f0$var$wsOptionsFor(type, preserveWS, top.options);
            if (top.options & $f043ae92c0a873f0$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $f043ae92c0a873f0$var$OPT_OPEN_LEFT;
            let applyMarks = $f043ae92c0a873f0$export$c9d15bcfc6d42044.none;
            marks = marks.filter((m)=>{
                if (top.type ? top.type.allowsMarkType(m.type) : $f043ae92c0a873f0$var$markMayApply(m.type, type)) {
                    applyMarks = m.addToSet(applyMarks);
                    return false;
                }
                return true;
            });
            this.nodes.push(new $f043ae92c0a873f0$var$NodeContext(type, attrs, applyMarks, solid, null, options));
            this.open++;
            return marks;
        }
        closeExtra(openEnd = false) {
            let i = this.nodes.length - 1;
            if (i > this.open) {
                for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
                this.nodes.length = this.open + 1;
            }
        }
        finish() {
            this.open = 0;
            this.closeExtra(this.isOpen);
            return this.nodes[0].finish(this.isOpen || this.options.topOpen);
        }
        sync(to) {
            for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            return false;
        }
        get currentPos() {
            this.closeExtra();
            let pos = 0;
            for(let i = this.open; i >= 0; i--){
                let content = this.nodes[i].content;
                for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
                if (i) pos++;
            }
            return pos;
        }
        findAtPoint(parent, offset) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
            }
        }
        findInside(parent) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
            }
        }
        findAround(parent, content, before) {
            if (parent != content && this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
                }
            }
        }
        findInText(textNode) {
            if (this.find) {
                for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
        }
        matchesContext(context) {
            if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
            let parts = context.split("/");
            let option = this.options.context;
            let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
            let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
            let match = (i, depth)=>{
                for(; i >= 0; i--){
                    let part = parts[i];
                    if (part == "") {
                        if (i == parts.length - 1 || i == 0) continue;
                        for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                        return false;
                    } else {
                        let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                        if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                        depth--;
                    }
                }
                return true;
            };
            return match(parts.length - 1, this.open);
        }
        textblockFromContext() {
            let $context = this.options.context;
            if ($context) for(let d = $context.depth; d >= 0; d--){
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
            }
            for(let name in this.parser.schema.nodes){
                let type = this.parser.schema.nodes[name];
                if (type.isTextblock && type.defaultAttrs) return type;
            }
        }
    }
    function $f043ae92c0a873f0$var$normalizeList(dom) {
        for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
            let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
            if (name && $f043ae92c0a873f0$var$listTags.hasOwnProperty(name) && prevItem) {
                prevItem.appendChild(child);
                child = prevItem;
            } else if (name == "li") prevItem = child;
            else if (name) prevItem = null;
        }
    }
    function $f043ae92c0a873f0$var$matches(dom, selector) {
        return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
    }
    function $f043ae92c0a873f0$var$copy(obj) {
        let copy = {};
        for(let prop in obj)copy[prop] = obj[prop];
        return copy;
    }
    function $f043ae92c0a873f0$var$markMayApply(markType, nodeType) {
        let nodes = nodeType.schema.nodes;
        for(let name in nodes){
            let parent = nodes[name];
            if (!parent.allowsMarkType(markType)) continue;
            let seen = [], scan = (match)=>{
                seen.push(match);
                for(let i = 0; i < match.edgeCount; i++){
                    let { type: type, next: next } = match.edge(i);
                    if (type == nodeType) return true;
                    if (seen.indexOf(next) < 0 && scan(next)) return true;
                }
            };
            if (scan(parent.contentMatch)) return true;
        }
    }
    class $f043ae92c0a873f0$export$3476b78f8f5a8b72 {
        constructor(nodes, marks){
            this.nodes = nodes;
            this.marks = marks;
        }
        serializeFragment(fragment, options = {}, target) {
            if (!target) target = $f043ae92c0a873f0$var$doc(options).createDocumentFragment();
            let top = target, active = [];
            fragment.forEach((node)=>{
                if (active.length || node.marks.length) {
                    let keep = 0, rendered = 0;
                    while(keep < active.length && rendered < node.marks.length){
                        let next = node.marks[rendered];
                        if (!this.marks[next.type.name]) {
                            rendered++;
                            continue;
                        }
                        if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                        keep++;
                        rendered++;
                    }
                    while(keep < active.length)top = active.pop()[1];
                    while(rendered < node.marks.length){
                        let add = node.marks[rendered++];
                        let markDOM = this.serializeMark(add, node.isInline, options);
                        if (markDOM) {
                            active.push([
                                add,
                                top
                            ]);
                            top.appendChild(markDOM.dom);
                            top = markDOM.contentDOM || markDOM.dom;
                        }
                    }
                }
                top.appendChild(this.serializeNodeInner(node, options));
            });
            return target;
        }
        serializeNodeInner(node, options) {
            let { dom: dom, contentDOM: contentDOM } = $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
            if (contentDOM) {
                if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
                this.serializeFragment(node.content, options, contentDOM);
            }
            return dom;
        }
        serializeNode(node, options = {}) {
            let dom = this.serializeNodeInner(node, options);
            for(let i = node.marks.length - 1; i >= 0; i--){
                let wrap = this.serializeMark(node.marks[i], node.isInline, options);
                if (wrap) {
                    (wrap.contentDOM || wrap.dom).appendChild(dom);
                    dom = wrap.dom;
                }
            }
            return dom;
        }
        serializeMark(mark, inline, options = {}) {
            let toDOM = this.marks[mark.type.name];
            return toDOM && $f043ae92c0a873f0$var$renderSpec($f043ae92c0a873f0$var$doc(options), toDOM(mark, inline), null, mark.attrs);
        }
        static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
            return $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
        }
        static fromSchema(schema) {
            return schema.cached.domSerializer || (schema.cached.domSerializer = new $f043ae92c0a873f0$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
        }
        static nodesFromSchema(schema) {
            let result = $f043ae92c0a873f0$var$gatherToDOM(schema.nodes);
            if (!result.text) result.text = (node)=>node.text;
            return result;
        }
        static marksFromSchema(schema) {
            return $f043ae92c0a873f0$var$gatherToDOM(schema.marks);
        }
    }
    function $f043ae92c0a873f0$var$gatherToDOM(obj) {
        let result = {};
        for(let name in obj){
            let toDOM = obj[name].spec.toDOM;
            if (toDOM) result[name] = toDOM;
        }
        return result;
    }
    function $f043ae92c0a873f0$var$doc(options) {
        return options.document || window.document;
    }
    const $f043ae92c0a873f0$var$suspiciousAttributeCache = new WeakMap();
    function $f043ae92c0a873f0$var$suspiciousAttributes(attrs) {
        let value = $f043ae92c0a873f0$var$suspiciousAttributeCache.get(attrs);
        if (value === undefined) $f043ae92c0a873f0$var$suspiciousAttributeCache.set(attrs, value = $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs));
        return value;
    }
    function $f043ae92c0a873f0$var$suspiciousAttributesInner(attrs) {
        let result = null;
        function scan(value) {
            if (value && typeof value == "object") {
                if (Array.isArray(value)) {
                    if (typeof value[0] == "string") {
                        if (!result) result = [];
                        result.push(value);
                    } else for(let i = 0; i < value.length; i++)scan(value[i]);
                } else for(let prop in value)scan(value[prop]);
            }
        }
        scan(attrs);
        return result;
    }
    function $f043ae92c0a873f0$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], suspicious;
        if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
        if (blockArraysIn && (suspicious = $f043ae92c0a873f0$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
        let space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $f043ae92c0a873f0$var$renderSpec(doc, child, xmlNS, blockArraysIn);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
});
parcelRegister("dHeNB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f8ac547b0b2e1f8$export$2e2bcd8739ae039);
    function $9f8ac547b0b2e1f8$var$OrderedMap(content) {
        this.content = content;
    }
    $9f8ac547b0b2e1f8$var$OrderedMap.prototype = {
        constructor: $9f8ac547b0b2e1f8$var$OrderedMap,
        find: function(key) {
            for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
            return -1;
        },
        get: function(key) {
            var found = this.find(key);
            return found == -1 ? undefined : this.content[found + 1];
        },
        update: function(key, value, newKey) {
            var self = newKey && newKey != key ? this.remove(newKey) : this;
            var found = self.find(key), content = self.content.slice();
            if (found == -1) content.push(newKey || key, value);
            else {
                content[found + 1] = value;
                if (newKey) content[found] = newKey;
            }
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        remove: function(key) {
            var found = this.find(key);
            if (found == -1) return this;
            var content = this.content.slice();
            content.splice(found, 2);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addToStart: function(key, value) {
            return new $9f8ac547b0b2e1f8$var$OrderedMap([
                key,
                value
            ].concat(this.remove(key).content));
        },
        addToEnd: function(key, value) {
            var content = this.remove(key).content.slice();
            content.push(key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        addBefore: function(place, key, value) {
            var without = this.remove(key), content = without.content.slice();
            var found = without.find(place);
            content.splice(found == -1 ? content.length : found, 0, key, value);
            return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
        },
        forEach: function(f) {
            for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
        },
        prepend: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(map.content.concat(this.subtract(map).content));
        },
        append: function(map) {
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            if (!map.size) return this;
            return new $9f8ac547b0b2e1f8$var$OrderedMap(this.subtract(map).content.concat(map.content));
        },
        subtract: function(map) {
            var result = this;
            map = $9f8ac547b0b2e1f8$var$OrderedMap.from(map);
            for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
            return result;
        },
        toObject: function() {
            var result = {};
            this.forEach(function(key, value) {
                result[key] = value;
            });
            return result;
        },
        get size () {
            return this.content.length >> 1;
        }
    };
    $9f8ac547b0b2e1f8$var$OrderedMap.from = function(value) {
        if (value instanceof $9f8ac547b0b2e1f8$var$OrderedMap) return value;
        var content = [];
        if (value) for(var prop in value)content.push(prop, value[prop]);
        return new $9f8ac547b0b2e1f8$var$OrderedMap(content);
    };
    var $9f8ac547b0b2e1f8$export$2e2bcd8739ae039 = $9f8ac547b0b2e1f8$var$OrderedMap;
});
const $72fd39d34ca5bb7c$export$4498a6080fed604c = 'fontStyle';
const $72fd39d34ca5bb7c$export$f8e8a5f34f6ea725 = 'searchQuery';
const $72fd39d34ca5bb7c$export$b395009ca7f092c7 = 'link';
const $72fd39d34ca5bb7c$export$9b982809044276a6 = 'color';
const $72fd39d34ca5bb7c$export$470d0905851e47a1 = 'alignment';
const $72fd39d34ca5bb7c$export$bacb7f4b06a06b22 = 'indentation';
parcelRegister("7P7H6", function(module, exports) {
    $parcel$export(module.exports, "sanitizeNodes", ()=>$5b2343b4eb27461c$export$daf54fed04c8fb77);
    function $5b2343b4eb27461c$export$daf54fed04c8fb77(nodes, supportedMarks) {
        const nodeNames = Object.keys(nodes);
        nodeNames.forEach((nodeKey)=>{
            const nodeSpec = {
                ...nodes[nodeKey]
            };
            if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
            if (nodeSpec.content) nodeSpec.content = $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
            nodes[nodeKey] = nodeSpec;
        });
        return nodes;
    }
    function $5b2343b4eb27461c$var$sanitizeNodeSpecContent(nodes, rawContent) {
        const content = rawContent.replace(/\W/g, ' ');
        const contentKeys = content.split(' ');
        const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$5b2343b4eb27461c$var$isContentSupported(nodes, contentKey));
        return unsupportedContentKeys.reduce((newContent, nodeName)=>$5b2343b4eb27461c$var$sanitizedContent(newContent, nodeName), rawContent);
    }
    function $5b2343b4eb27461c$var$sanitizedContent(content, invalidContent) {
        if (!invalidContent.length) return content || '';
        if (!content || !content.match(/\w/)) return '';
        const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
        return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
    }
    function $5b2343b4eb27461c$var$isContentSupported(nodes, contentKey) {
        const nodeKeys = Object.keys(nodes);
        if (nodeKeys.indexOf(contentKey) > -1) return true;
        for(const supportedKey in nodes){
            const nodeSpec = nodes[supportedKey];
            if (nodeSpec && nodeSpec.group === contentKey) return true;
        }
        return false;
    }
});
parcelRegister("aeGrH", function(module, exports) {
    $parcel$export(module.exports, "alignmentPositionMap", ()=>$773c2309706a915e$export$be9cf49015769bbd);
    $parcel$export(module.exports, "alignment", ()=>$773c2309706a915e$export$8e53000a4ec837);
    var $2fTAU;
    const $773c2309706a915e$export$be9cf49015769bbd = {
        end: 'right',
        right: 'end',
        center: 'center'
    };
    const $773c2309706a915e$export$8e53000a4ec837 = (0, (0, parcelRequire("2fTAU")).alignment)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-block-mark',
                getAttrs: (dom)=>{
                    const align = dom.getAttribute('data-align');
                    return align ? {
                        align: align
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                    'data-align': mark.attrs.align
                },
                0
            ];
        }
    });
});
parcelRegister("2fTAU", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>$1a481b607696d815$export$8e53000a4ec837);
    $parcel$export(module.exports, "annotation", ()=>$1a481b607696d815$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "backgroundColor", ()=>$1a481b607696d815$export$8c5a050822fd698c);
    $parcel$export(module.exports, "border", ()=>$1a481b607696d815$export$1edee58a52776cd9);
    $parcel$export(module.exports, "breakout", ()=>$1a481b607696d815$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "code", ()=>$1a481b607696d815$export$6565f9f03506010b);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$1a481b607696d815$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "dataConsumer", ()=>$1a481b607696d815$export$3024f02c495408d6);
    $parcel$export(module.exports, "em", ()=>$1a481b607696d815$export$c63c6f932822f543);
    $parcel$export(module.exports, "fragment", ()=>$1a481b607696d815$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "indentation", ()=>$1a481b607696d815$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "link", ()=>$1a481b607696d815$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "strike", ()=>$1a481b607696d815$export$4899a95d70ec5056);
    $parcel$export(module.exports, "strong", ()=>$1a481b607696d815$export$59ae2c325a998f89);
    $parcel$export(module.exports, "subsup", ()=>$1a481b607696d815$export$b3401ee80eb31041);
    $parcel$export(module.exports, "textColor", ()=>$1a481b607696d815$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "typeAheadQuery", ()=>$1a481b607696d815$export$20af3dabbb5538df);
    $parcel$export(module.exports, "underline", ()=>$1a481b607696d815$export$425327af25286e5e);
    $parcel$export(module.exports, "unsupportedMark", ()=>$1a481b607696d815$export$30d78d5eb6719bb8);
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$1a481b607696d815$export$a316dc07ff5182a2);
    var $f0ccE;
    const $1a481b607696d815$export$8e53000a4ec837 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            align: {}
        },
        excludes: 'alignment indentation',
        group: 'alignment'
    });
    const $1a481b607696d815$export$8512c9afa7b24c3b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            id: {
                default: ''
            },
            annotationType: {
                default: 'inlineComment'
            }
        },
        inclusive: true,
        excludes: '',
        group: 'annotation'
    });
    const $1a481b607696d815$export$8c5a050822fd698c = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        excludes: 'color',
        group: 'color'
    });
    const $1a481b607696d815$export$1edee58a52776cd9 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            size: {},
            color: {}
        },
        inclusive: false
    });
    const $1a481b607696d815$export$89015c65f1c75e3f = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            mode: {
                default: 'wide'
            },
            width: {
                default: null
            }
        },
        inclusive: false,
        spanning: false
    });
    const $1a481b607696d815$export$6565f9f03506010b = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        excludes: 'fontStyle link searchQuery color'
    });
    const $1a481b607696d815$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            reference: {
                default: ''
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$3024f02c495408d6 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            sources: {
                default: []
            }
        }
    });
    const $1a481b607696d815$export$c63c6f932822f543 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$f00aeb236b6f05af = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            localId: {
                default: ''
            },
            name: {
                default: null
            }
        },
        inclusive: false,
        excludes: ''
    });
    const $1a481b607696d815$export$480c699bd4ec0d86 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            level: {}
        },
        excludes: 'indentation alignment',
        group: 'indentation'
    });
    const $1a481b607696d815$export$9c30223ca0a664fb = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            href: {},
            __confluenceMetadata: {
                default: null
            }
        },
        inclusive: false,
        excludes: 'link',
        group: 'link'
    });
    const $1a481b607696d815$export$4899a95d70ec5056 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$59ae2c325a998f89 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$b3401ee80eb31041 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            type: {
                default: 'sub'
            }
        },
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$32f78bffcd82ff28 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            color: {}
        },
        inclusive: true,
        group: 'color'
    });
    const $1a481b607696d815$export$20af3dabbb5538df = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            trigger: {
                default: ''
            }
        },
        inclusive: true,
        group: 'searchQuery'
    });
    const $1a481b607696d815$export$425327af25286e5e = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        inclusive: true,
        group: 'fontStyle'
    });
    const $1a481b607696d815$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            originalValue: {}
        },
        excludes: ''
    });
    const $1a481b607696d815$export$a316dc07ff5182a2 = (0, (0, parcelRequire("f0ccE")).createPMMarkSpecFactory)({
        attrs: {
            unsupported: {},
            type: {}
        }
    });
});
parcelRegister("88i6h", function(module, exports) {
    $parcel$export(module.exports, "AnnotationTypes", ()=>$5ebd1c6c912098fc$export$94aa2fc69ad33d19);
    $parcel$export(module.exports, "AnnotationMarkStates", ()=>$5ebd1c6c912098fc$export$4bab14797673da9f);
    $parcel$export(module.exports, "buildDataAttributes", ()=>$5ebd1c6c912098fc$export$93a98caa8bc6cb07);
    $parcel$export(module.exports, "annotation", ()=>$5ebd1c6c912098fc$export$8512c9afa7b24c3b);
    var $2fTAU;
    let $5ebd1c6c912098fc$export$94aa2fc69ad33d19 = function(AnnotationTypes) {
        AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
        return AnnotationTypes;
    }({});
    let $5ebd1c6c912098fc$export$4bab14797673da9f = function(AnnotationMarkStates) {
        AnnotationMarkStates["RESOLVED"] = "resolved";
        AnnotationMarkStates["ACTIVE"] = "active";
        return AnnotationMarkStates;
    }({});
    function $5ebd1c6c912098fc$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
        const data = {
            'data-mark-type': 'annotation',
            'data-mark-annotation-type': annotationType,
            'data-id': id
        };
        if (state) return {
            ...data,
            'data-mark-annotation-state': state
        };
        return data;
    }
    const $5ebd1c6c912098fc$export$8512c9afa7b24c3b = (0, (0, parcelRequire("2fTAU")).annotation)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="annotation"]',
                mark: 'annotation',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-id'),
                        annotationType: dom.getAttribute('data-mark-annotation-type')
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'class': 'fabric-editor-annotation',
                    ...$5ebd1c6c912098fc$export$93a98caa8bc6cb07({
                        id: node.attrs.id,
                        annotationType: node.attrs.annotationType
                    })
                },
                0
            ];
        }
    });
});
parcelRegister("8jJss", function(module, exports) {
    $parcel$export(module.exports, "backgroundColor", ()=>$60e35c16db44f137$export$8c5a050822fd698c);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $c9aa1;
    var $87j2U;
    const $60e35c16db44f137$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).Neutral300),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T200),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).L200),
            'Lime'
        ],
        [
            (0, (0, parcelRequire("51H8P")).O200),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).M200),
            'Magenta'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P200),
            'Purple'
        ]
    ];
    const $60e35c16db44f137$export$14ec3f21a268e497 = new Map();
    $60e35c16db44f137$var$colorArrayPalette.forEach(([color, label])=>$60e35c16db44f137$export$14ec3f21a268e497.set(color.toLowerCase(), label));
    const $60e35c16db44f137$export$8c5a050822fd698c = (0, (0, parcelRequire("2fTAU")).backgroundColor)({
        parseDOM: [
            {
                style: 'background-color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-background-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.backgroundCustomColor;
                    return hexColor && $60e35c16db44f137$export$14ec3f21a268e497.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ((0, (0, parcelRequire("c9aa1")).getGlobalTheme)().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-background-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-background-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("c9aa1", function(module, exports) {
    $parcel$export(module.exports, "colorPalette", ()=>$8d7e34fd69d04bb8$export$569885e57444f84a);
    $parcel$export(module.exports, "getGlobalTheme", ()=>$8d7e34fd69d04bb8$export$813ecdf77207a053);
    $parcel$export(module.exports, "textColor", ()=>$8d7e34fd69d04bb8$export$32f78bffcd82ff28);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    var $87j2U;
    const $8d7e34fd69d04bb8$var$colorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).B500),
            'Dark blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T500),
            'Dark teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G500),
            'Dark green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y400),
            'Orange'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R500),
            'Dark red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P500),
            'Dark purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N80),
            'Light gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B100),
            'Blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T300),
            'Teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G300),
            'Green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y200),
            'Yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R300),
            'Red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P300),
            'Purple'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N0),
            'White'
        ],
        [
            (0, (0, parcelRequire("51H8P")).B75),
            'Light blue'
        ],
        [
            (0, (0, parcelRequire("51H8P")).T75),
            'Light teal'
        ],
        [
            (0, (0, parcelRequire("51H8P")).G75),
            'Light green'
        ],
        [
            (0, (0, parcelRequire("51H8P")).Y75),
            'Light yellow'
        ],
        [
            (0, (0, parcelRequire("51H8P")).R75),
            'Light red'
        ],
        [
            (0, (0, parcelRequire("51H8P")).P50),
            'Light purple'
        ]
    ];
    const $8d7e34fd69d04bb8$export$569885e57444f84a = new Map();
    const $8d7e34fd69d04bb8$export$81e5ed9e84fe2e28 = $8d7e34fd69d04bb8$export$569885e57444f84a;
    $8d7e34fd69d04bb8$var$colorArrayPalette.forEach(([color, label])=>$8d7e34fd69d04bb8$export$569885e57444f84a.set(color.toLowerCase(), label));
    let $8d7e34fd69d04bb8$var$testGlobalTheme;
    const $8d7e34fd69d04bb8$export$fd7e0dd2b74807f7 = (theme)=>{
        $8d7e34fd69d04bb8$var$testGlobalTheme = theme;
    };
    const $8d7e34fd69d04bb8$export$813ecdf77207a053 = ()=>{
        if ($8d7e34fd69d04bb8$var$testGlobalTheme) return {
            colorMode: $8d7e34fd69d04bb8$var$testGlobalTheme
        };
        const element = document.documentElement;
        const colorMode = element.getAttribute('data-color-mode') || '';
        return {
            colorMode: colorMode
        };
    };
    const $8d7e34fd69d04bb8$export$32f78bffcd82ff28 = (0, (0, parcelRequire("2fTAU")).textColor)({
        parseDOM: [
            {
                style: 'color',
                getAttrs: (maybeValue)=>{
                    const value = maybeValue;
                    let hexColor;
                    if (value.match(/^rgb/i)) hexColor = (0, (0, parcelRequire("51H8P")).rgbToHex)(value);
                    else if (value[0] === '#') hexColor = value.toLowerCase();
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            },
            {
                tag: '.fabric-text-color-mark',
                getAttrs: (maybeElement)=>{
                    if (!(maybeElement instanceof HTMLElement)) return false;
                    const hexColor = maybeElement.dataset.textCustomColor;
                    return hexColor && $8d7e34fd69d04bb8$export$569885e57444f84a.has(hexColor) ? {
                        color: hexColor
                    } : false;
                }
            }
        ],
        toDOM (mark) {
            let paletteColorValue;
            const tokenColor = (0, (0, parcelRequire("daes7")).hexToEditorTextPaletteColor)(mark.attrs.color);
            if (tokenColor) paletteColorValue = tokenColor;
            else if ($8d7e34fd69d04bb8$export$813ecdf77207a053().colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(mark.attrs.color);
            else paletteColorValue = mark.attrs.color;
            return [
                'span',
                {
                    class: 'fabric-text-color-mark',
                    style: `--custom-palette-color: ${paletteColorValue}`,
                    ['data-text-custom-color']: mark.attrs.color
                }
            ];
        }
    });
});
parcelRegister("14Vqw", function(module, exports) {
    $parcel$export(module.exports, "borderColorPalette", ()=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7);
    $parcel$export(module.exports, "border", ()=>$0c92b5eb9dbe9377$export$1edee58a52776cd9);
    var $2fTAU;
    var $daes7;
    var $51H8P;
    const $0c92b5eb9dbe9377$var$borderColorArrayPalette = [
        [
            (0, (0, parcelRequire("51H8P")).N300A),
            'Subtle gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N600),
            'Gray'
        ],
        [
            (0, (0, parcelRequire("51H8P")).N1000),
            'Bold gray'
        ]
    ];
    const $0c92b5eb9dbe9377$export$e4e044c989c86ca7 = new Map();
    $0c92b5eb9dbe9377$var$borderColorArrayPalette.forEach(([color, label])=>$0c92b5eb9dbe9377$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
    const $0c92b5eb9dbe9377$export$1edee58a52776cd9 = (0, (0, parcelRequire("2fTAU")).border)({
        parseDOM: [
            {
                tag: '[data-mark-type="border"]',
                getAttrs: (domNode)=>{
                    var _dom$getAttribute, _dom$getAttribute2;
                    const dom = domNode;
                    const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                    const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                    return {
                        size: size > 3 ? 3 : size < 1 ? false : size,
                        color: $0c92b5eb9dbe9377$export$e4e044c989c86ca7.has(color) ? color : false
                    };
                }
            }
        ],
        toDOM (mark, isInline) {
            const wrapperStyle = isInline ? 'span' : 'div';
            const paletteColorValue = (0, (0, parcelRequire("daes7")).hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'border',
                    'data-color': mark.attrs.color,
                    'data-size': mark.attrs.size,
                    style: `--custom-palette-color: ${paletteColorValue}`
                }
            ];
        }
    });
});
parcelRegister("zceQE", function(module, exports) {
    $parcel$export(module.exports, "breakout", ()=>$069cc34ec2ef025e$export$89015c65f1c75e3f);
    var $2fTAU;
    const $069cc34ec2ef025e$var$allowedTypes = [
        'wide',
        'full-width'
    ];
    const $069cc34ec2ef025e$export$89015c65f1c75e3f = (0, (0, parcelRequire("2fTAU")).breakout)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-breakout-mark',
                getAttrs (dom) {
                    const mode = dom.getAttribute('data-mode');
                    const width = dom.getAttribute('data-width');
                    return {
                        mode: $069cc34ec2ef025e$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                        width: width ? parseInt(width) : null
                    };
                }
            }
        ],
        toDOM (mark) {
            var _mark$attrs;
            return [
                'div',
                {
                    class: 'fabric-editor-breakout-mark',
                    'data-mode': mark.attrs.mode,
                    'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
                },
                0
            ];
        }
    });
});
parcelRegister("lcXoV", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$f708cbc93f02b120$export$6565f9f03506010b);
    var $2fTAU;
    const $f708cbc93f02b120$export$6565f9f03506010b = (0, (0, parcelRequire("2fTAU")).code)({
        parseDOM: [
            {
                tag: 'span.code',
                preserveWhitespace: true
            },
            {
                tag: 'code',
                preserveWhitespace: true
            },
            {
                tag: 'tt',
                preserveWhitespace: true
            },
            {
                tag: 'span',
                preserveWhitespace: true,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre') return {};
                    if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                    return false;
                }
            }
        ],
        toDOM () {
            return [
                'span',
                {
                    class: 'code',
                    spellcheck: 'false'
                }
            ];
        }
    });
});
parcelRegister("71k4W", function(module, exports) {
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$51c833981031ae17$export$f3b72f8fc4684ecd);
    var $2fTAU;
    const $51c833981031ae17$export$f3b72f8fc4684ecd = (0, (0, parcelRequire("2fTAU")).confluenceInlineComment)({
        parseDOM: [
            {
                tag: 'span[data-mark-type="confluenceInlineComment"]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-mark-type': 'confluenceInlineComment',
                    'data-reference': node.attrs.reference
                }
            ];
        }
    });
});
parcelRegister("cUwVZ", function(module, exports) {
    $parcel$export(module.exports, "dataConsumer", ()=>$966443126bdc8969$export$3024f02c495408d6);
    $parcel$export(module.exports, "toJSON", ()=>$966443126bdc8969$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $966443126bdc8969$var$parseDataConsumer = (maybeValue)=>{
        const sources = (0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
        try {
            return sources ? {
                sources: JSON.parse(sources)
            } : false;
        } catch  {
            return false;
        }
    };
    const $966443126bdc8969$export$3024f02c495408d6 = (0, (0, parcelRequire("2fTAU")).dataConsumer)({
        parseDOM: [
            {
                tag: '[data-mark-type="dataConsumer"]',
                getAttrs: (maybeValue)=>$966443126bdc8969$var$parseDataConsumer(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'dataConsumer',
                    'data-sources': JSON.stringify(mark.attrs.sources)
                }
            ];
        }
    });
    const $966443126bdc8969$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
                return {
                    ...acc,
                    [key]: mark.attrs[key]
                };
            }, {})
        };
    };
});
parcelRegister("6VXbJ", function(module, exports) {
    $parcel$export(module.exports, "isDOMElement", ()=>$50c5fa8010b73128$export$c296e2d4365c37a5);
    const $50c5fa8010b73128$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
});
parcelRegister("l3Tmi", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$f554d1dac524ac83$export$c63c6f932822f543);
    var $2fTAU;
    const $f554d1dac524ac83$var$emDOM = [
        'em'
    ];
    const $f554d1dac524ac83$export$c63c6f932822f543 = (0, (0, parcelRequire("2fTAU")).em)({
        parseDOM: [
            {
                tag: 'i'
            },
            {
                tag: 'em'
            },
            {
                style: 'font-style=italic'
            }
        ],
        toDOM () {
            return $f554d1dac524ac83$var$emDOM;
        }
    });
});
parcelRegister("29Vii", function(module, exports) {
    $parcel$export(module.exports, "fragment", ()=>$1928dd6d160b68a9$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "toJSON", ()=>$1928dd6d160b68a9$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $6VXbJ;
    const $1928dd6d160b68a9$var$parseFragment = (maybeValue)=>{
        var _maybeValue$getAttrib;
        if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(maybeValue)) return false;
        const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
        const localId = maybeValue.getAttribute('data-localId');
        if (!localId) return false;
        return {
            localId: localId,
            name: name
        };
    };
    const $1928dd6d160b68a9$export$f00aeb236b6f05af = (0, (0, parcelRequire("2fTAU")).fragment)({
        parseDOM: [
            {
                tag: '[data-mark-type="fragment"]',
                getAttrs: (maybeValue)=>$1928dd6d160b68a9$var$parseFragment(maybeValue)
            }
        ],
        toDOM (mark, inline) {
            const wrapperStyle = inline ? 'span' : 'div';
            return [
                wrapperStyle,
                {
                    'data-mark-type': 'fragment',
                    'data-name': mark.attrs.name,
                    'data-localId': mark.attrs.localId
                }
            ];
        }
    });
    const $1928dd6d160b68a9$export$54fd2c36b5cc6731 = (mark)=>{
        return {
            type: mark.type.name,
            attrs: {
                localId: mark.attrs.localId,
                ...mark.attrs.name ? {
                    name: mark.attrs.name
                } : {}
            }
        };
    };
});
parcelRegister("fK6mK", function(module, exports) {
    $parcel$export(module.exports, "indentation", ()=>$b760170dcfe13435$export$480c699bd4ec0d86);
    var $2fTAU;
    const $b760170dcfe13435$export$480c699bd4ec0d86 = (0, (0, parcelRequire("2fTAU")).indentation)({
        parseDOM: [
            {
                tag: 'div.fabric-editor-indentation-mark',
                getAttrs (dom) {
                    const level = +(dom.getAttribute('data-level') || '0');
                    return {
                        level: level > 6 ? 6 : level < 1 ? false : level
                    };
                }
            }
        ],
        toDOM (mark) {
            return [
                'div',
                {
                    class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                    'data-level': mark.attrs.level
                },
                0
            ];
        }
    });
});
parcelRegister("8XeG6", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$684f383282dda449$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "toJSON", ()=>$684f383282dda449$export$54fd2c36b5cc6731);
    var $2fTAU;
    var $iZOJ9;
    const $684f383282dda449$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
            const dom = domNode;
            const href = dom.getAttribute(attribute) || '';
            const attrs = {
                __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
            };
            if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(href)) return false;
            if ((0, (0, parcelRequire("iZOJ9")).isRootRelative)(href)) {
                attrs.href = href;
                return attrs;
            }
            attrs.href = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)(href);
            return attrs;
        };
    const $684f383282dda449$export$9c30223ca0a664fb = (0, (0, parcelRequire("2fTAU")).link)({
        parseDOM: [
            {
                tag: '[data-block-link]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('data-block-link'),
                contentElement: (node)=>{
                    const clone = node.cloneNode(true);
                    clone.removeAttribute('data-block-link');
                    clone.setAttribute('data-skip-paste', 'true');
                    const wrapper = document.createElement('div');
                    wrapper.appendChild(clone);
                    return wrapper;
                }
            },
            {
                tag: 'a[href]',
                getAttrs: $684f383282dda449$export$b5f67017585d1431('href')
            }
        ],
        toDOM (node, isInline) {
            const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
                if (key === '__confluenceMetadata') {
                    if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
                } else if (key === 'href') attrs[key] = (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
                else attrs[key] = node.attrs[key];
                return attrs;
            }, {});
            if (isInline) return [
                'a',
                attrs
            ];
            return [
                'a',
                {
                    ...attrs,
                    ['data-block-link']: 'true',
                    class: 'blockLink'
                },
                0
            ];
        }
    });
    const $684f383282dda449$var$OPTIONAL_ATTRS = [
        'title',
        'id',
        'collection',
        'occurrenceKey',
        '__confluenceMetadata'
    ];
    const $684f383282dda449$export$54fd2c36b5cc6731 = (mark)=>({
            type: mark.type.name,
            attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
                if ($684f383282dda449$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
                return attrs;
            }, {})
        });
});
parcelRegister("iZOJ9", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$dd4545da25e52dce$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "linkify", ()=>$dd4545da25e52dce$export$8ccbde94d5c7f8e7);
    $parcel$export(module.exports, "linkifyMatch", ()=>$dd4545da25e52dce$export$6f7d7761b97f967);
    $parcel$export(module.exports, "getLinkMatch", ()=>$dd4545da25e52dce$export$ce9ae45aed3e4ec);
    $parcel$export(module.exports, "normalizeUrl", ()=>$dd4545da25e52dce$export$6535eb414fa2c8b6);
    $parcel$export(module.exports, "isRootRelative", ()=>$dd4545da25e52dce$export$23579274a7a24f7b);
    var $i6xkD = parcelRequire("i6xkD");
    const $dd4545da25e52dce$var$whitelistedURLPatterns = [
        /^https?:\/\//im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\//im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:/im,
        /^facetime:/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^sourcetree:\/\//im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^#/im
    ];
    const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        if (urlTrimmed.length === 0) return true;
        return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, ($parcel$interopDefault($i6xkD)))();
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
    const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
        validate: /[^\s]+/
    };
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
    const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
    $dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
    const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
        if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
        const matches = [];
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
        if (!str) return null;
        let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
        if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
        return match && match[0];
    }
    function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
        const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
        return match && match.url || '';
    }
    function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
        return url.startsWith('/') || url === '#top' || url === '#';
    }
});
parcelRegister("i6xkD", function(module, exports) {
    'use strict';
    function $d2e2a485107d561a$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $d2e2a485107d561a$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $d2e2a485107d561a$var$isString(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object String]';
    }
    function $d2e2a485107d561a$var$isObject(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
    }
    function $d2e2a485107d561a$var$isRegExp(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
    }
    function $d2e2a485107d561a$var$isFunction(obj) {
        return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
    }
    function $d2e2a485107d561a$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $d2e2a485107d561a$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $d2e2a485107d561a$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $d2e2a485107d561a$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $d2e2a485107d561a$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $d2e2a485107d561a$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $d2e2a485107d561a$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $d2e2a485107d561a$var$compile(self) {
        var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($d2e2a485107d561a$var$isObject(val)) {
                if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
                else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($d2e2a485107d561a$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $d2e2a485107d561a$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($d2e2a485107d561a$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
        $d2e2a485107d561a$var$resetScanCache(self);
    }
    function $d2e2a485107d561a$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $d2e2a485107d561a$var$createMatch(self, shift) {
        var match = new $d2e2a485107d561a$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $d2e2a485107d561a$var$compile(this);
    }
    $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($d2e2a485107d561a$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $d2e2a485107d561a$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $d2e2a485107d561a$var$compile(this);
        return this;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $d2e2a485107d561a$var$LinkifyIt;
});
parcelRegister("9mKTr", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,3}[a-zA-Z0-9%/]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("b9ep3", function(module, exports) {
    module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
});
parcelRegister("23ErL", function(module, exports) {
    module.exports = /[\0-\x1F\x7F-\x9F]/;
});
parcelRegister("oRY4m", function(module, exports) {
    module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
});
parcelRegister("9bBmm", function(module, exports) {
    module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;
});
parcelRegister("aUhe2", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$7f0c7ef7d4ef76e7$export$4899a95d70ec5056);
    var $2fTAU;
    const $7f0c7ef7d4ef76e7$export$4899a95d70ec5056 = (0, (0, parcelRequire("2fTAU")).strike)({
        parseDOM: [
            {
                tag: 'strike'
            },
            {
                tag: 's'
            },
            {
                tag: 'del'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'line-through' && null
            }
        ],
        toDOM () {
            return [
                's'
            ];
        }
    });
});
parcelRegister("hhtT8", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$c94b3560d4129743$export$59ae2c325a998f89);
    var $2fTAU;
    const $c94b3560d4129743$var$strongDOM = [
        'strong'
    ];
    const $c94b3560d4129743$export$59ae2c325a998f89 = (0, (0, parcelRequire("2fTAU")).strong)({
        parseDOM: [
            {
                tag: 'strong'
            },
            {
                tag: 'b',
                getAttrs (node) {
                    const element = node;
                    return element.style.fontWeight !== 'normal' && null;
                }
            },
            {
                tag: 'span',
                getAttrs (node) {
                    const element = node;
                    const { fontWeight: fontWeight } = element.style;
                    return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
                }
            }
        ],
        toDOM () {
            return $c94b3560d4129743$var$strongDOM;
        }
    });
});
parcelRegister("4NwJJ", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$37e521d9accf6615$export$b3401ee80eb31041);
    var $2fTAU;
    function $37e521d9accf6615$var$getAttrFromVerticalAlign(node) {
        if (node === 'sub') return {
            type: 'sub'
        };
        if (node === 'super') return {
            type: 'sup'
        };
        return false;
    }
    const $37e521d9accf6615$export$b3401ee80eb31041 = (0, (0, parcelRequire("2fTAU")).subsup)({
        parseDOM: [
            {
                tag: 'sub',
                attrs: {
                    type: 'sub'
                }
            },
            {
                tag: 'sup',
                attrs: {
                    type: 'sup'
                }
            },
            {
                style: 'vertical-align=super',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            },
            {
                style: 'vertical-align=sub',
                getAttrs: (node)=>$37e521d9accf6615$var$getAttrFromVerticalAlign(node)
            }
        ],
        toDOM (mark) {
            return [
                mark.attrs.type
            ];
        }
    });
});
parcelRegister("dtyqo", function(module, exports) {
    $parcel$export(module.exports, "typeAheadQuery", ()=>$9cf8afcff83743a0$export$20af3dabbb5538df);
    var $2fTAU;
    var $51H8P;
    const $9cf8afcff83743a0$export$20af3dabbb5538df = (0, (0, parcelRequire("2fTAU")).typeAheadQuery)({
        parseDOM: [
            {
                tag: 'span[data-type-ahead-query]'
            }
        ],
        toDOM (node) {
            return [
                'span',
                {
                    'data-type-ahead-query': 'true',
                    'data-trigger': node.attrs.trigger,
                    style: `color: ${(0, (0, parcelRequire("51H8P")).B400)}`
                }
            ];
        }
    });
});
parcelRegister("8EAPB", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$64cea1116bb0e8f8$export$425327af25286e5e);
    var $2fTAU;
    const $64cea1116bb0e8f8$export$425327af25286e5e = (0, (0, parcelRequire("2fTAU")).underline)({
        parseDOM: [
            {
                tag: 'u'
            },
            {
                style: 'text-decoration',
                getAttrs: (value)=>value === 'underline' && null
            }
        ],
        toDOM () {
            return [
                'u'
            ];
        }
    });
});
parcelRegister("jxVez", function(module, exports) {
    $parcel$export(module.exports, "unsupportedMark", ()=>$e3ad7edb6364f3b2$export$30d78d5eb6719bb8);
    var $2fTAU;
    const $e3ad7edb6364f3b2$export$30d78d5eb6719bb8 = (0, (0, parcelRequire("2fTAU")).unsupportedMark)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("lVmBd", function(module, exports) {
    $parcel$export(module.exports, "unsupportedNodeAttribute", ()=>$ff60739479aa7be3$export$a316dc07ff5182a2);
    var $2fTAU;
    const $ff60739479aa7be3$export$a316dc07ff5182a2 = (0, (0, parcelRequire("2fTAU")).unsupportedNodeAttribute)({
        toDOM () {
            return [
                'span'
            ];
        }
    });
});
parcelRegister("21PS7", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$17a3e9738ed289c7$export$c4c2f833baaebdb8);
    var $gthjq;
    const $17a3e9738ed289c7$var$getCommonAttributesFromDom = (dom)=>{
        const anchor = dom;
        const data = anchor.getAttribute('data-card-data');
        const datasource = anchor.getAttribute('data-datasource');
        return {
            data: data ? JSON.parse(data) : undefined,
            layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
            width: Number(dom.getAttribute('data-width')) || undefined,
            datasource: datasource ? JSON.parse(datasource) : undefined
        };
    };
    const $17a3e9738ed289c7$export$c4c2f833baaebdb8 = (0, (0, parcelRequire("gthjq")).blockCard)({
        parseDOM: [
            {
                tag: 'a[data-block-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('href') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            },
            {
                tag: 'div[data-block-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    return {
                        url: anchor.getAttribute('data-card-url') || undefined,
                        ...$17a3e9738ed289c7$var$getCommonAttributesFromDom(dom)
                    };
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                href: url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`
            };
            return [
                'a',
                attrs,
                (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
            ];
        }
    });
});
parcelRegister("5AxYU", function(module, exports) {
    $parcel$export(module.exports, "bodiedExtension", ()=>$411aac89e34c8741$export$27903d543b563e39);
    var $CWpyq;
    var $gthjq;
    const $411aac89e34c8741$export$27903d543b563e39 = (0, (0, parcelRequire("gthjq")).bodiedExtension)({
        parseDOM: [
            {
                context: 'bodiedExtension//',
                tag: '[data-node-type="bodied-extension"]',
                skip: true
            },
            {
                tag: '[data-node-type="bodied-extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("kjhhp", function(module, exports) {
    $parcel$export(module.exports, "bulletListSelector", ()=>$ec92fc66e86ee824$export$5f25a39efab3b58b);
    $parcel$export(module.exports, "bulletList", ()=>$ec92fc66e86ee824$export$a140c94e5ea26bee);
    var $gthjq;
    const $ec92fc66e86ee824$export$5f25a39efab3b58b = '.ak-ul';
    const $ec92fc66e86ee824$export$a140c94e5ea26bee = (0, (0, parcelRequire("gthjq")).bulletList)({
        parseDOM: [
            {
                tag: 'ul'
            }
        ],
        toDOM () {
            const attrs = {
                class: $ec92fc66e86ee824$export$5f25a39efab3b58b.substr(1)
            };
            return [
                'ul',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("5JeV5", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$42bcba7b958fdfd3$export$8e3c2dfdc4f0453d);
    var $gthjq;
    const $42bcba7b958fdfd3$export$8e3c2dfdc4f0453d = (0, (0, parcelRequire("gthjq")).caption)({
        parseDOM: [
            {
                tag: 'figcaption[data-caption]'
            }
        ],
        toDOM () {
            const attrs = {
                'data-caption': 'true'
            };
            return [
                'figcaption',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("8vlrc", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$6311d90c8f0b12c7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "toJSON", ()=>$6311d90c8f0b12c7$export$54fd2c36b5cc6731);
    var $kCV8T;
    var $gthjq;
    const $6311d90c8f0b12c7$var$getLanguageFromEditorStyle = (dom)=>{
        return dom.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle = (dom)=>{
        if (dom && dom.classList.contains('codehilite')) return $6311d90c8f0b12c7$var$extractLanguageFromClass(dom.className);
        return;
    };
    const $6311d90c8f0b12c7$var$getLanguageFromCode = (dom)=>{
        const firstChild = dom.firstElementChild;
        if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
    };
    const $6311d90c8f0b12c7$var$extractLanguageFromClass = (className)=>{
        const languageRegex = /(?:^|\s)language-([^\s]+)/;
        const result = languageRegex.exec(className);
        if (result && result[1]) return result[1];
        return;
    };
    const $6311d90c8f0b12c7$var$removeLastNewLine = (dom)=>{
        const parent = dom && dom.parentElement;
        if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
        return dom;
    };
    function $6311d90c8f0b12c7$var$parseCodeFromHtml(node) {
        let code = '';
        node.childNodes.forEach((child)=>{
            if (child.nodeType === Node.TEXT_NODE) code += child.nodeValue;
            else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
                const tagName = child.tagName.toLowerCase();
                if (tagName === 'div' || tagName === 'p') {
                    if (child.previousElementSibling !== null) code += '\n';
                }
                if (tagName === 'br') code += '\n';
                else code += $6311d90c8f0b12c7$var$parseCodeFromHtml(child);
            }
        });
        return code;
    }
    const $6311d90c8f0b12c7$export$7bb0d5c671655cc4 = (0, (0, parcelRequire("gthjq")).codeBlock)({
        parseDOM: [
            {
                tag: 'pre',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    let dom = domNode;
                    const language = $6311d90c8f0b12c7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromEditorStyle(dom.parentElement) || $6311d90c8f0b12c7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                    dom = $6311d90c8f0b12c7$var$removeLastNewLine(dom);
                    return {
                        language: language
                    };
                }
            },
            {
                tag: 'div[style]',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                    return false;
                },
                getContent: (domNode, schema)=>{
                    const code = $6311d90c8f0b12c7$var$parseCodeFromHtml(domNode);
                    return code ? (0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(code)) : (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                }
            },
            {
                tag: 'table[style]',
                preserveWhitespace: 'full',
                getAttrs: (dom)=>{
                    if (dom.querySelector('td[class*="blob-code"]')) return {};
                    return false;
                }
            },
            {
                tag: 'div.code-block',
                preserveWhitespace: 'full',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                    if (lineNumber.length > 0) lineNumber.forEach((line)=>line.remove());
                    return {};
                }
            }
        ],
        toDOM (node) {
            return [
                'pre',
                [
                    'code',
                    {
                        'data-language': node.attrs.language
                    },
                    0
                ]
            ];
        }
    });
    const $6311d90c8f0b12c7$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((memo, key)=>{
                if (key === 'uniqueId') return memo;
                if (key === 'language' && node.attrs.language === null) return memo;
                memo[key] = node.attrs[key];
                return memo;
            }, {})
        });
});
parcelRegister("6bbHe", function(module, exports) {
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>$47fcd7cf328a46ad$export$daf889beb5092f95);
    var $gthjq;
    const $47fcd7cf328a46ad$var$name = 'confluenceJiraIssue';
    const $47fcd7cf328a46ad$export$daf889beb5092f95 = (0, (0, parcelRequire("gthjq")).confluenceJiraIssue)({
        parseDOM: [
            {
                tag: `span[data-node-type="${$47fcd7cf328a46ad$var$name}"]`,
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        issueKey: dom.textContent,
                        macroId: dom.dataset && dom.dataset.macroId,
                        schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                        server: dom.dataset && dom.dataset.server,
                        serverId: dom.dataset && dom.dataset.serverId
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': $47fcd7cf328a46ad$var$name,
                'data-macro-id': node.attrs.macroId,
                'data-schema-version': node.attrs.schemaVersion,
                'data-server': node.attrs.server,
                'data-server-id': node.attrs.serverId,
                'data-jira-issue': node.attrs.issueKey
            };
            return [
                'span',
                attrs,
                node.attrs.issueKey
            ];
        }
    });
});
parcelRegister("5y0tR", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>$40a0802970c8dfd0$export$e6e4878f43c27cab);
    var $gthjq;
    const $40a0802970c8dfd0$var$name = 'confluenceUnsupportedBlock';
    const $40a0802970c8dfd0$export$e6e4878f43c27cab = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedBlock)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $40a0802970c8dfd0$var$name,
                'data-confluence-unsupported': 'block',
                'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$40a0802970c8dfd0$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("bd7A9", function(module, exports) {
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>$8296ca40a4ed2ee7$export$3e6d667072febc87);
    var $gthjq;
    const $8296ca40a4ed2ee7$var$name = 'confluenceUnsupportedInline';
    const $8296ca40a4ed2ee7$export$3e6d667072febc87 = (0, (0, parcelRequire("gthjq")).confluenceUnsupportedInline)({
        toDOM (node) {
            const attrs = {
                'data-node-type': $8296ca40a4ed2ee7$var$name,
                'data-confluence-unsupported': 'inline',
                'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$8296ca40a4ed2ee7$var$name}"]`,
                getAttrs (dom) {
                    return {
                        cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                    };
                }
            }
        ]
    });
});
parcelRegister("b2VmY", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$80ac620012a63cc1$export$324d90190a8b822a);
    var $gthjq;
    const $80ac620012a63cc1$export$324d90190a8b822a = (0, (0, parcelRequire("gthjq")).date)({
        parseDOM: [
            {
                tag: 'span[data-node-type="date"]',
                getAttrs: (dom)=>({
                        timestamp: dom.getAttribute('data-timestamp')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'date',
                'data-timestamp': node.attrs.timestamp
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("Khvpb", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$08b1e03a19cbdc24$export$6959e16eeff859b4);
    var $9IGaJ;
    var $gthjq;
    const $08b1e03a19cbdc24$export$6959e16eeff859b4 = (0, (0, parcelRequire("gthjq")).decisionItem)({
        parseDOM: [
            {
                tag: 'li[data-decision-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-decision-state')
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state
            };
            return [
                'li',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("8gSD8", function(module, exports) {
    $parcel$export(module.exports, "decisionListSelector", ()=>$605a31c9af2a8977$export$a5393ce68c2ff601);
    $parcel$export(module.exports, "decisionList", ()=>$605a31c9af2a8977$export$62d45a65fb43d95e);
    var $9IGaJ;
    var $gthjq;
    const $605a31c9af2a8977$var$name = 'decisionList';
    const $605a31c9af2a8977$export$a5393ce68c2ff601 = `[data-node-type="${$605a31c9af2a8977$var$name}"]`;
    const $605a31c9af2a8977$export$62d45a65fb43d95e = (0, (0, parcelRequire("gthjq")).decisionList)({
        parseDOM: [
            {
                tag: `ol${$605a31c9af2a8977$export$a5393ce68c2ff601}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $605a31c9af2a8977$var$name,
                'data-decision-list-local-id': localId || 'local-decision-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("xjCuM", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$06424d48e92613a9$export$2a111da947c407d2);
    var $gthjq;
    const $06424d48e92613a9$export$2a111da947c407d2 = (0, (0, parcelRequire("gthjq")).doc)({});
});
parcelRegister("kshOv", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$ee443d93678dbe0b$export$be4283d9a1cb1ff6);
    var $gthjq;
    const $ee443d93678dbe0b$export$be4283d9a1cb1ff6 = (0, (0, parcelRequire("gthjq")).embedCard)({
        parseDOM: [
            {
                tag: 'div[data-embed-card]',
                getAttrs: (dom)=>({
                        url: dom.getAttribute('data-card-url'),
                        layout: dom.getAttribute('data-layout') || 'center',
                        width: Number(dom.getAttribute('data-width')) || null,
                        originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                        originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                    })
            }
        ],
        toDOM (node) {
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("7DoMR", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$58ef6723e99e5604$export$a19185d1233fc4b2);
    var $4pzsz;
    var $gthjq;
    const $58ef6723e99e5604$export$a19185d1233fc4b2 = (0, (0, parcelRequire("gthjq")).emoji)({
        parseDOM: [
            {
                tag: 'div.ak-editor-panel__icon span',
                ignore: true
            },
            {
                tag: 'span[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            },
            {
                tag: 'img[data-emoticon-name]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
            },
            {
                tag: 'img[data-hipchat-emoticon]',
                getAttrs: (dom)=>(0, (0, parcelRequire("4pzsz")).acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
            },
            {
                tag: 'img.emoji[data-emoji-short-name]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        shortName: dom.getAttribute('data-emoji-short-name') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.shortName.default,
                        id: dom.getAttribute('data-emoji-id') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.id.default,
                        text: dom.getAttribute('data-emoji-text') || $58ef6723e99e5604$export$a19185d1233fc4b2.attrs.text.default
                    };
                }
            }
        ],
        toDOM (node) {
            const { shortName: shortName, id: id, text: text } = node.attrs;
            const attrs = {
                'data-emoji-short-name': shortName,
                'data-emoji-id': id,
                'data-emoji-text': text,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("4pzsz", function(module, exports) {
    $parcel$export(module.exports, "acNameToEmoji", ()=>$336500cbd1ca0f10$export$f61e93bda2a8b420);
    $parcel$export(module.exports, "acShortcutToEmoji", ()=>$336500cbd1ca0f10$export$441f8b58f5790a68);
    $parcel$export(module.exports, "getEmojiAcName", ()=>$336500cbd1ca0f10$export$880a2465992fbbe);
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID = '2b50';
    const $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
    const $336500cbd1ca0f10$var$HC_EMOTICON_PREFIX = 'atlassian-';
    const $336500cbd1ca0f10$var$acNameToEmojiMap = {
        smile: [
            '1f642',
            ':slight_smile:',
            '\uD83D\uDE42'
        ],
        sad: [
            '1f641',
            ':slight_frown:',
            '\uD83D\uDE41'
        ],
        cheeky: [
            '1f61b',
            ':stuck_out_tongue:',
            '\uD83D\uDE1B'
        ],
        laugh: [
            '1f600',
            ':grinning:',
            '\uD83D\uDE00'
        ],
        wink: [
            '1f609',
            ':wink:',
            '\uD83D\uDE09'
        ],
        information: [
            '2139',
            ':information_source:',
            '\u2139'
        ],
        tick: [
            '2705',
            ':white_check_mark:',
            '\u2705'
        ],
        cross: [
            '274c',
            ':x:',
            '\u274C'
        ],
        warning: [
            '26a0',
            ':warning:',
            '\u26A0'
        ],
        plus: [
            '2795',
            ':heavy_plus_sign:',
            '\u2795'
        ],
        minus: [
            '2796',
            ':heavy_minus_sign:',
            '\u2796'
        ],
        question: [
            '2753',
            ':question:',
            '\u003F'
        ],
        'thumbs-up': [
            '1f44d',
            ':thumbsup:',
            '\uD83D\uDC4D'
        ],
        'thumbs-down': [
            '1f44e',
            ':thumbsdown:',
            '\uD83D\uDC4E'
        ],
        'light-on': [
            '1f4a1',
            ':bulb:',
            '\uD83D\uDCA1'
        ],
        'yellow-star': [
            '2b50',
            ':star:',
            '\uD83D\uDC9B'
        ],
        'light-off': [
            '1f6ab',
            ':no_entry_sign:',
            '\uD83D\uDEAB'
        ],
        'red-star': [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'green-star': [
            '1f49a',
            ':green_heart:',
            '\uD83D\uDC9A'
        ],
        'blue-star': [
            '1f499',
            ':blue_heart:',
            '\uD83D\uDC99'
        ],
        heart: [
            '2764',
            ':heart:',
            '\u2764\uFE0F'
        ],
        'broken-heart': [
            '1f494',
            ':broken_heart:',
            '\uD83D\uDC94'
        ]
    };
    function $336500cbd1ca0f10$export$f61e93bda2a8b420(acName) {
        const emojiData = $336500cbd1ca0f10$var$acNameToEmojiMap[acName];
        return emojiData ? {
            id: emojiData[0],
            shortName: emojiData[1],
            text: emojiData[2]
        } : {
            id: $336500cbd1ca0f10$var$DEFAULT_EMOJI_ID,
            shortName: `:${acName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$export$bc94e44ec0e7bd82(emojiId) {
        const filterEmojis = (acName)=>$336500cbd1ca0f10$var$acNameToEmojiMap[acName] ? $336500cbd1ca0f10$var$acNameToEmojiMap[acName][0] === emojiId : false;
        return Object.keys($336500cbd1ca0f10$var$acNameToEmojiMap).filter(filterEmojis)[0];
    }
    function $336500cbd1ca0f10$export$441f8b58f5790a68(hipchatEmoticonShortName) {
        return {
            id: `${$336500cbd1ca0f10$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
            shortName: `:${hipchatEmoticonShortName}:`,
            text: ''
        };
    }
    function $336500cbd1ca0f10$var$getAcNameFromShortName(shortName) {
        return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
    }
    function $336500cbd1ca0f10$export$880a2465992fbbe({ id: id, shortName: shortName }) {
        if ($336500cbd1ca0f10$var$DEFAULT_EMOJI_ID === id) {
            const possibleName = $336500cbd1ca0f10$var$getAcNameFromShortName(shortName);
            if (possibleName in $336500cbd1ca0f10$var$acNameToEmojiMap) return possibleName;
        }
        return $336500cbd1ca0f10$export$bc94e44ec0e7bd82(id) || $336500cbd1ca0f10$var$DEFAULT_EMOJI_ACNAME;
    }
});
parcelRegister("hhN5g", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$c95a1940f4fa6aee$export$1b45514b112dd749);
    var $CWpyq;
    var $gthjq;
    const $c95a1940f4fa6aee$export$1b45514b112dd749 = (0, (0, parcelRequire("gthjq")).extension)({
        parseDOM: [
            {
                tag: '[data-node-type="extension"]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId
            };
            return [
                'div',
                attrs
            ];
        }
    });
});
parcelRegister("jnMM2", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$e1c5ffc4cc369fdc$export$371da9dd35aba193);
    var $gthjq;
    const $e1c5ffc4cc369fdc$export$371da9dd35aba193 = (0, (0, parcelRequire("gthjq")).hardBreak)({
        parseDOM: [
            {
                tag: 'br'
            }
        ],
        toDOM () {
            return [
                'br'
            ];
        }
    });
});
parcelRegister("lRTZM", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$feb9fbb7aabe0cc7$export$46e4a324ac90507f);
    var $gthjq;
    const $feb9fbb7aabe0cc7$var$getAttrs = (level)=>(domNode)=>{
            var _heading$attrs, _heading$attrs$localI;
            return {
                level: level,
                localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $feb9fbb7aabe0cc7$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
            };
        };
    const $feb9fbb7aabe0cc7$export$46e4a324ac90507f = (0, (0, parcelRequire("gthjq")).heading)({
        parseDOM: [
            {
                tag: 'h1',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(1)
            },
            {
                tag: 'h2',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(2)
            },
            {
                tag: 'h3',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(3)
            },
            {
                tag: 'h4',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(4)
            },
            {
                tag: 'h5',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(5)
            },
            {
                tag: 'h6',
                getAttrs: $feb9fbb7aabe0cc7$var$getAttrs(6)
            }
        ],
        toDOM (node) {
            const { level: level, localId: localId } = node.attrs;
            const name = 'h' + level;
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("7lRBh", function(module, exports) {
    $parcel$export(module.exports, "image", ()=>$55a4127c569d3934$export$5c452ff88e35e47d);
    var $gthjq;
    const $55a4127c569d3934$export$5c452ff88e35e47d = (0, (0, parcelRequire("gthjq")).image)({
        parseDOM: [
            {
                tag: 'img[src^="data:image/"]',
                ignore: true
            },
            {
                tag: 'img[src]',
                getAttrs (domNode) {
                    const dom = domNode;
                    return {
                        src: dom.getAttribute('src'),
                        alt: dom.getAttribute('alt'),
                        title: dom.getAttribute('title')
                    };
                }
            }
        ],
        toDOM (node) {
            return [
                'img',
                node.attrs
            ];
        }
    });
});
parcelRegister("cCBEe", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$93063cb7956d3766$export$cbf8224b64e0d942);
    var $gthjq;
    const $93063cb7956d3766$export$cbf8224b64e0d942 = (0, (0, parcelRequire("gthjq")).inlineCard)({
        parseDOM: [
            {
                tag: 'a[data-inline-card], span[data-inline-card]',
                priority: 100,
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                        data: data ? JSON.parse(data) : null
                    };
                }
            },
            {
                tag: 'div[data-inline-card]',
                getAttrs: (dom)=>{
                    const anchor = dom;
                    const data = anchor.getAttribute('data-card-data');
                    return {
                        url: anchor.getAttribute('data-card-url'),
                        data: data ? JSON.parse(data) : null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
            };
            if (node.attrs.url) return [
                'a',
                attrs,
                node.attrs.url
            ];
            else return [
                'a',
                attrs
            ];
        }
    });
});
parcelRegister("5BOuQ", function(module, exports) {
    $parcel$export(module.exports, "inlineExtension", ()=>$4157940155363fee$export$16b353b2649bd8d9);
    var $CWpyq;
    var $gthjq;
    const $4157940155363fee$export$16b353b2649bd8d9 = (0, (0, parcelRequire("gthjq")).inlineExtensionWithMarks)({
        parseDOM: [
            {
                tag: 'span[data-extension-type]',
                getAttrs: (domNode)=>(0, (0, parcelRequire("CWpyq")).getExtensionAttrs)(domNode, true)
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-local-id:': node.attrs.localId,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs
            ];
        }
    });
});
parcelRegister("4EbxI", function(module, exports) {
    $parcel$export(module.exports, "layoutColumn", ()=>$3623d9fd8951cfd2$export$ab76e7c03cd6f650);
    var $gthjq;
    const $3623d9fd8951cfd2$export$ab76e7c03cd6f650 = (0, (0, parcelRequire("gthjq")).layoutColumn)({
        parseDOM: [
            {
                context: 'layoutColumn//',
                tag: 'div[data-layout-column]',
                skip: true
            },
            {
                tag: 'div[data-layout-column]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        width: Number(dom.getAttribute('data-column-width')) || undefined
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-layout-column': 'true'
            };
            const { width: width } = node.attrs;
            if (width) {
                attrs['style'] = `flex-basis: ${width}%`;
                attrs['data-column-width'] = `${width}`;
            }
            const contentAttrs = {
                'data-layout-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
});
parcelRegister("7agO8", function(module, exports) {
    $parcel$export(module.exports, "createMediaSpec", ()=>$5376813d9b4ea07d$export$35bdbf5bc8caa677);
    $parcel$export(module.exports, "copyPrivateAttributes", ()=>$5376813d9b4ea07d$export$111130fa8968d741);
    $parcel$export(module.exports, "media", ()=>$5376813d9b4ea07d$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "toJSON", ()=>$5376813d9b4ea07d$export$54fd2c36b5cc6731);
    var $51H8P;
    var $gthjq;
    const $5376813d9b4ea07d$export$bb3fe706be61f640 = (0, (0, parcelRequire("gthjq")).media)({}).attrs;
    const $5376813d9b4ea07d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
        const domNodeType = inline ? 'span' : 'div';
        const nodeName = inline ? 'mediaInline' : 'media';
        const parseDOM = [
            {
                tag: `${domNodeType}[data-node-type="${nodeName}"]`,
                getAttrs: (dom)=>{
                    const attrs = {};
                    if (attributes) Object.keys(attributes).forEach((k)=>{
                        const key = $5376813d9b4ea07d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                        const value = dom.getAttribute(`data-${key}`) || '';
                        if (value) attrs[k] = value;
                    });
                    if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                    const width = Number(attrs.width);
                    if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                    const height = Number(attrs.height);
                    if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                    return attrs;
                }
            },
            {
                tag: 'img[src^="data:image"]',
                ignore: true
            }
        ];
        const toDOM = (node)=>{
            const attrs = {
                'data-id': node.attrs.id,
                'data-node-type': `${nodeName}`,
                'data-type': node.attrs.type,
                'data-collection': node.attrs.collection,
                'data-occurrence-key': node.attrs.occurrenceKey,
                'data-width': node.attrs.width,
                'data-height': node.attrs.height,
                'data-url': node.attrs.url,
                'data-alt': node.attrs.alt,
                title: 'Attachment',
                style: `display: inline-block; border-radius: 3px; background: ${(0, (0, parcelRequire("51H8P")).N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
            };
            $5376813d9b4ea07d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$5376813d9b4ea07d$export$f84fdfb973c05bd8(key.slice(2))}`);
            return [
                `${domNodeType}`,
                attrs
            ];
        };
        if (inline) return (0, (0, parcelRequire("gthjq")).mediaInline)({
            parseDOM: parseDOM,
            toDOM: toDOM
        });
        return (0, (0, parcelRequire("gthjq")).media)({
            parseDOM: [
                ...parseDOM,
                {
                    tag: 'img:not(.smart-link-icon)',
                    getAttrs: (dom)=>{
                        return {
                            type: 'external',
                            url: dom.getAttribute('src') || '',
                            alt: dom.getAttribute('alt') || ''
                        };
                    }
                }
            ],
            toDOM: toDOM
        });
    };
    const $5376813d9b4ea07d$export$987d49ffe1b0900f = $5376813d9b4ea07d$export$35bdbf5bc8caa677($5376813d9b4ea07d$export$bb3fe706be61f640, false);
    const $5376813d9b4ea07d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
    const $5376813d9b4ea07d$export$111130fa8968d741 = (from, to, map)=>{
        if ($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs) Object.keys($5376813d9b4ea07d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const $5376813d9b4ea07d$var$optionalAttributes = [
        'occurrenceKey',
        'width',
        'height',
        'url',
        'alt'
    ];
    const $5376813d9b4ea07d$var$externalOnlyAttributes = [
        'type',
        'url',
        'width',
        'height',
        'alt'
    ];
    const $5376813d9b4ea07d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
                if (node.attrs.type === 'external' && $5376813d9b4ea07d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
                if ($5376813d9b4ea07d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
                if ([
                    'width',
                    'height'
                ].indexOf(key) !== -1) {
                    obj[key] = Number(node.attrs[key]);
                    return obj;
                }
                obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("92lix", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$6944d24b2c8b0dd9$export$2855e964765eac9);
    var $gthjq;
    const $6944d24b2c8b0dd9$export$2855e964765eac9 = (0, (0, parcelRequire("gthjq")).mediaGroup)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaGroup"]'
            },
            {
                tag: 'div[class="MediaGroup"]'
            }
        ],
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    });
});
parcelRegister("7Xgp3", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$5caac46433adf3f0$export$38bab695e3f720f1);
    var $7agO8;
    var $gthjq;
    const $5caac46433adf3f0$export$38bab695e3f720f1 = (0, (0, parcelRequire("7agO8")).createMediaSpec)((0, (0, parcelRequire("gthjq")).mediaInline)({}).attrs, true);
});
parcelRegister("bIGZ7", function(module, exports) {
    $parcel$export(module.exports, "mediaSingleSpec", ()=>$888525ada96954d1$export$5a1e124099b60c6b);
    $parcel$export(module.exports, "mediaSingle", ()=>$888525ada96954d1$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>$888525ada96954d1$export$d35e6c006d4abdfb);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>$888525ada96954d1$export$9c58e19811ce4cf5);
    $parcel$export(module.exports, "mediaSingleFull", ()=>$888525ada96954d1$export$7e767666f2ce108a);
    $parcel$export(module.exports, "toJSON", ()=>$888525ada96954d1$export$54fd2c36b5cc6731);
    var $ITAJ1;
    var $6VXbJ;
    var $gthjq;
    const $888525ada96954d1$export$bb3fe706be61f640 = {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        }
    };
    const $888525ada96954d1$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
        const getAttrs = (dom)=>{
            if (!(0, (0, parcelRequire("6VXbJ")).isDOMElement)(dom)) return {
                layout: 'center'
            };
            const layout = dom.getAttribute('data-layout') || 'center';
            const width = Number(dom.getAttribute('data-width')) || null;
            const widthType = dom.getAttribute('data-width-type');
            if (withExtendedWidthTypes) return {
                layout: layout,
                width: width,
                widthType: widthType
            };
            else if (widthType === (0, (0, parcelRequire("ITAJ1")).WidthType).PIXEL) return {
                layout: layout
            };
            else return {
                layout: layout,
                width: width
            };
        };
        const getAttrsFromNode = (node)=>{
            const { layout: layout, width: width } = node.attrs;
            const attrs = {
                'data-node-type': 'mediaSingle',
                'data-layout': layout,
                'data-width': ''
            };
            if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
            if (withExtendedWidthTypes && node.attrs.widthType) {
                const { widthType: widthType } = node.attrs;
                return {
                    ...attrs,
                    'data-width-type': widthType || (0, (0, parcelRequire("ITAJ1")).WidthType).PERCENTAGE
                };
            }
            return attrs;
        };
        if (withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleFull)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (withExtendedWidthTypes && !withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleWidthType)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        if (!withExtendedWidthTypes && withCaption) return (0, (0, parcelRequire("gthjq")).mediaSingleCaption)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
        return (0, (0, parcelRequire("gthjq")).mediaSingle)({
            parseDOM: [
                {
                    tag: 'div[data-node-type="mediaSingle"]',
                    getAttrs: getAttrs
                }
            ],
            toDOM (node) {
                return [
                    'div',
                    getAttrsFromNode(node),
                    0
                ];
            }
        });
    };
    const $888525ada96954d1$export$969fe3781ca15058 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$d35e6c006d4abdfb = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: false
    });
    const $888525ada96954d1$export$9c58e19811ce4cf5 = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: false,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$7e767666f2ce108a = $888525ada96954d1$export$5a1e124099b60c6b({
        withCaption: true,
        withExtendedWidthTypes: true
    });
    const $888525ada96954d1$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if (node.attrs[key] !== null) obj[key] = node.attrs[key];
                return obj;
            }, {})
        });
});
parcelRegister("ITAJ1", function(module, exports) {
    $parcel$export(module.exports, "WidthType", ()=>$086f3b754fef02e1$export$4d41558722ac7eed);
    let $086f3b754fef02e1$export$4d41558722ac7eed = function(WidthType) {
        WidthType["PIXEL"] = "pixel";
        WidthType["PERCENTAGE"] = "percentage";
        return WidthType;
    }({});
});
parcelRegister("g7Cky", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$bbcb0873d657d42d$export$db83999c14438df4);
    $parcel$export(module.exports, "toJSON", ()=>$bbcb0873d657d42d$export$54fd2c36b5cc6731);
    var $9IGaJ;
    var $gthjq;
    let $bbcb0873d657d42d$export$abebb208988c258 = function(USER_TYPES) {
        USER_TYPES["DEFAULT"] = "DEFAULT";
        USER_TYPES["SPECIAL"] = "SPECIAL";
        USER_TYPES["APP"] = "APP";
        return USER_TYPES;
    }({});
    const $bbcb0873d657d42d$export$db83999c14438df4 = (0, (0, parcelRequire("gthjq")).mention)({
        parseDOM: [
            {
                tag: 'span[data-mention-id]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const attrs = {
                        id: dom.getAttribute('data-mention-id') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.id.default,
                        text: dom.textContent || $bbcb0873d657d42d$export$db83999c14438df4.attrs.text.default,
                        accessLevel: dom.getAttribute('data-access-level') || $bbcb0873d657d42d$export$db83999c14438df4.attrs.accessLevel.default,
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    };
                    const userType = dom.getAttribute('data-user-type');
                    if ($bbcb0873d657d42d$export$abebb208988c258[userType]) attrs.userType = userType;
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
            const attrs = {
                'data-mention-id': id,
                'data-access-level': accessLevel,
                contenteditable: 'false'
            };
            if (localId) attrs['data-local-id'] = localId;
            if (userType) attrs['data-user-type'] = userType;
            return [
                'span',
                attrs,
                text
            ];
        }
    });
    const $bbcb0873d657d42d$var$isOptional = (key)=>{
        return [
            'userType',
            'localId'
        ].indexOf(key) > -1;
    };
    const $bbcb0873d657d42d$export$54fd2c36b5cc6731 = (node)=>({
            attrs: Object.keys(node.attrs).reduce((obj, key)=>{
                if ($bbcb0873d657d42d$var$isOptional(key) && !node.attrs[key]) return obj;
                return {
                    ...obj,
                    [key]: node.attrs[key]
                };
            }, {})
        });
});
parcelRegister("dx5eC", function(module, exports) {
    $parcel$export(module.exports, "nestedExpand", ()=>$9da26af350402964$export$63cadbf5f4296627);
    var $gthjq;
    function $9da26af350402964$var$getExpandAttrs(domNode) {
        const dom = domNode;
        return {
            title: dom.getAttribute('data-title'),
            __expanded: true
        };
    }
    const $9da26af350402964$export$63cadbf5f4296627 = (0, (0, parcelRequire("gthjq")).nestedExpand)({
        parseDOM: [
            {
                context: 'nestedExpand//',
                tag: '[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            },
            {
                tag: '[data-node-type="nestedExpand"] button',
                ignore: true
            },
            {
                tag: '[data-node-type="expand"] button',
                ignore: true
            },
            {
                tag: 'div[data-node-type="nestedExpand"]',
                getAttrs: $9da26af350402964$var$getExpandAttrs
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'nestedExpand',
                'data-title': node.attrs.title,
                'data-expanded': node.attrs.__expanded
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("dwptW", function(module, exports) {
    $parcel$export(module.exports, "orderedListSelector", ()=>$9d8207b1e6c47527$export$4e7125c7ff595be5);
    $parcel$export(module.exports, "orderedList", ()=>$9d8207b1e6c47527$export$a5dc81035676e7a);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>$9d8207b1e6c47527$export$b9ab759e8298198f);
    var $gthjq;
    const $9d8207b1e6c47527$export$4e7125c7ff595be5 = '.ak-ol';
    const $9d8207b1e6c47527$export$a5dc81035676e7a = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol'
            }
        ],
        toDOM () {
            const attrs = {
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
    const $9d8207b1e6c47527$var$resolveStart = (start)=>{
        const num = Number(start);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $9d8207b1e6c47527$export$b9ab759e8298198f = (0, (0, parcelRequire("gthjq")).orderedList)({
        parseDOM: [
            {
                tag: 'ol',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    const startDOMAttr = dom.getAttribute('start');
                    if (startDOMAttr) {
                        const start = $9d8207b1e6c47527$var$resolveStart(startDOMAttr);
                        if (typeof start === 'number') return {
                            order: start
                        };
                    }
                    return null;
                }
            }
        ],
        toDOM (node) {
            var _node$attrs;
            const start = $9d8207b1e6c47527$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
            const attrs = {
                start: typeof start === 'number' ? String(start) : undefined,
                class: $9d8207b1e6c47527$export$4e7125c7ff595be5.substr(1)
            };
            return [
                'ol',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("abme3", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$769c2c0b195d79f6$export$9c206ddddb32a9b);
    var $gthjq;
    const $769c2c0b195d79f6$export$9c206ddddb32a9b = (0, (0, parcelRequire("gthjq")).paragraph)({
        parseDOM: [
            {
                tag: 'p',
                getAttrs: (domNode)=>{
                    var _paragraph$attrs, _paragraph$attrs$loca;
                    const dom = domNode;
                    const attrs = {
                        localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $769c2c0b195d79f6$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                    };
                    return attrs;
                }
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const name = 'p';
            const attrs = localId !== undefined && localId !== null ? [
                {
                    'data-local-id': localId
                }
            ] : [];
            return [
                name,
                ...attrs,
                0
            ];
        }
    });
});
parcelRegister("dgJoa", function(module, exports) {
    $parcel$export(module.exports, "placeholder", ()=>$9a8ffa3be19d5bd0$export$c7187bbd1a7a9244);
    var $gthjq;
    const $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244 = (0, (0, parcelRequire("gthjq")).placeholder)({
        parseDOM: [
            {
                tag: 'span[data-placeholder]',
                getAttrs: (dom)=>({
                        text: dom.getAttribute('data-placeholder') || $9a8ffa3be19d5bd0$export$c7187bbd1a7a9244.attrs.text.default
                    })
            }
        ],
        toDOM (node) {
            const { text: text } = node.attrs;
            const attrs = {
                'data-placeholder': text,
                contenteditable: 'true'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("M4hHz", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$0907ce9fea0294ca$export$fbeb3a3956e8a3c7);
    var $gthjq;
    const $0907ce9fea0294ca$var$hrDOM = [
        'hr'
    ];
    const $0907ce9fea0294ca$export$fbeb3a3956e8a3c7 = (0, (0, parcelRequire("gthjq")).rule)({
        parseDOM: [
            {
                tag: 'hr'
            }
        ],
        toDOM () {
            return $0907ce9fea0294ca$var$hrDOM;
        }
    });
});
parcelRegister("18bvk", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$0d2f764e7fea7c00$export$471f7ae5c4103ae1);
    var $9IGaJ;
    var $gthjq;
    const $0d2f764e7fea7c00$export$471f7ae5c4103ae1 = (0, (0, parcelRequire("gthjq")).status)({
        parseDOM: [
            {
                tag: 'span[data-node-type="status"]',
                getAttrs: (domNode)=>{
                    const dom = domNode;
                    return {
                        text: dom.textContent.replace(/\n/, '').trim(),
                        color: dom.getAttribute('data-color'),
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        style: dom.getAttribute('data-style')
                    };
                }
            }
        ],
        toDOM (node) {
            const { text: text, color: color, localId: localId, style: style } = node.attrs;
            const attrs = {
                'data-node-type': 'status',
                'data-color': color,
                'data-local-id': localId,
                'data-style': style,
                contenteditable: 'false'
            };
            return [
                'span',
                attrs,
                text
            ];
        }
    });
});
parcelRegister("iThOL", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390);
    var $9IGaJ;
    var $gthjq;
    const $dc0b2f4f47f16dc0$export$6d8b0ef52e2e6390 = (0, (0, parcelRequire("gthjq")).taskItem)({
        parseDOM: [
            {
                tag: 'div[data-task-local-id]',
                priority: 100,
                getAttrs: (dom)=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate(),
                        state: dom.getAttribute('data-task-state') || 'TODO'
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-task-local-id': localId || 'local-task',
                'data-task-state': state || 'TODO'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("43mJF", function(module, exports) {
    $parcel$export(module.exports, "taskListSelector", ()=>$2f3914100d01687b$export$c0ec71adb7a18fb2);
    $parcel$export(module.exports, "taskList", ()=>$2f3914100d01687b$export$375b6afcc5f4d291);
    var $9IGaJ;
    var $gthjq;
    const $2f3914100d01687b$var$name = 'actionList';
    const $2f3914100d01687b$export$c0ec71adb7a18fb2 = `[data-node-type="${$2f3914100d01687b$var$name}"]`;
    const $2f3914100d01687b$export$375b6afcc5f4d291 = (0, (0, parcelRequire("gthjq")).taskList)({
        parseDOM: [
            {
                tag: `div${$2f3914100d01687b$export$c0ec71adb7a18fb2}`,
                priority: 100,
                getAttrs: ()=>({
                        localId: (0, (0, parcelRequire("9IGaJ")).uuid).generate()
                    })
            }
        ],
        toDOM (node) {
            const { localId: localId } = node.attrs;
            const attrs = {
                'data-node-type': $2f3914100d01687b$var$name,
                'data-task-list-local-id': localId || 'local-task-list',
                style: 'list-style: none; padding-left: 0'
            };
            return [
                'div',
                attrs,
                0
            ];
        }
    });
});
parcelRegister("3DR6L", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$2a6e35cab1a01b8e$export$6f093cfa640b7166);
    var $gthjq;
    const $2a6e35cab1a01b8e$export$6f093cfa640b7166 = (0, (0, parcelRequire("gthjq")).text)({
        toDebugString: ()=>'text_node'
    });
});
parcelRegister("9X587", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01deabc8204e5493$export$2e2bcd8739ae039);
    const $01deabc8204e5493$var$name = 'unknownBlock';
    var $01deabc8204e5493$export$2e2bcd8739ae039 = {
        group: 'block',
        content: 'inline+',
        marks: '_',
        toDOM () {
            return [
                'div',
                {
                    'data-node-type': $01deabc8204e5493$var$name
                },
                0
            ];
        },
        parseDOM: [
            {
                tag: `div[data-node-type="${$01deabc8204e5493$var$name}"]`
            }
        ]
    };
});
parcelRegister("d1d6m", function(module, exports) {
    $parcel$export(module.exports, "unsupportedBlock", ()=>$97a5880db351ce36$export$44b79b0979d0f0f7);
    var $gthjq;
    const $97a5880db351ce36$export$44b79b0979d0f0f7 = (0, (0, parcelRequire("gthjq")).unsupportedBlock)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedBlock"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedBlock',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'div',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("6kr5W", function(module, exports) {
    $parcel$export(module.exports, "unsupportedInline", ()=>$49b9a0cbcfdcc3a0$export$310ebe0d80122e9b);
    var $gthjq;
    const $49b9a0cbcfdcc3a0$export$310ebe0d80122e9b = (0, (0, parcelRequire("gthjq")).unsupportedInline)({
        parseDOM: [
            {
                tag: '[data-node-type="unsupportedInline"]',
                getAttrs: (dom)=>({
                        originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                    })
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-node-type': 'unsupportedInline',
                'data-original-value': JSON.stringify(node.attrs.originalValue)
            };
            return [
                'span',
                attrs,
                'Unsupported content'
            ];
        }
    });
});
parcelRegister("f5oqj", function(module, exports) {
    $parcel$export(module.exports, "defaultNodeComponents", ()=>$3de1eca32602d427$export$ee31295d51950741);
    $parcel$export(module.exports, "default", ()=>$3de1eca32602d427$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $kOFhM;
    var $dGzaM;
    var $9S8fM;
    var $gmhCD = parcelRequire("gmhCD");
    var $9Iju4;
    var $fIJEx;
    var $iiXGq;
    var $4ceoy;
    var $2DpUZ;
    var $iN9lO;
    var $4NUlu;
    var $fc6h8;
    var $ap7h6;
    var $gE8f9;
    var $kFiBa;
    var $VSDnB;
    var $4zXba;
    var $iHYdz;
    var $dWAZk = parcelRequire("dWAZk");
    var $1PVpv = parcelRequire("1PVpv");
    var $bXrHm = parcelRequire("bXrHm");
    var $9gOVJ;
    var $12yAL;
    var $OxITw;
    var $3lRy2;
    var $gkwXh;
    var $knXBU;
    var $TM1uy;
    var $4BsEy;
    var $jUVor;
    var $fCNtA;
    var $1pTqN;
    var $4YrGg;
    var $3kKuL;
    var $K5Jsy;
    var $TPpI8;
    var $dyURG;
    var $8QpSo;
    var $8Eu7T;
    var $1urn6;
    var $gJX6d;
    var $kgV4b;
    function $3de1eca32602d427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3de1eca32602d427$export$47b2879ca9bbf67a = 2000;
    const $3de1eca32602d427$export$1b622068be977101 = 3000;
    const $3de1eca32602d427$var$packageName = "platform-pkg";
    const $3de1eca32602d427$var$packageVersion = "0.0.0-use.local";
    const $3de1eca32602d427$var$setAsQueryContainerStyles = {
        name: "isqlwl",
        styles: "container-name:ak-renderer-wrapper;container-type:inline-size;contain:layout style inline-size"
    };
    const $3de1eca32602d427$export$ee31295d51950741 = (0, (0, parcelRequire("gJX6d")).nodeToReact);
    class $3de1eca32602d427$export$5161b00bb85c4267 extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props), this.renderedMeasurementDistortedDurationMonitor = (0, (0, parcelRequire("ap7h6")).getDistortedDurationMonitor)(), this.createRendererContext = (0, (0, parcelRequire("8QpSo")).default)((featureFlags, isTopLevelRenderer)=>{
                const normalizedFeatureFlags = (0, (0, parcelRequire("4zXba")).normalizeFeatureFlags)(featureFlags);
                return {
                    featureFlags: normalizedFeatureFlags,
                    isTopLevelRenderer: isTopLevelRenderer === undefined
                };
            }), this.fireAnalyticsEvent = (event)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) {
                    const channel = (0, $dWAZk.FabricChannel).editor;
                    createAnalyticsEvent(event).fire(channel);
                }
            }, this.getSchema = (0, (0, parcelRequire("8QpSo")).default)((schema, adfStage)=>{
                if (schema) return schema;
                return (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(adfStage);
            }), this.onMouseDownEditView = ()=>{
                const windowSelection = window.getSelection();
                this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
            }, this.handleMouseTripleClickInTables = (event)=>{
                if ((0, (0, parcelRequire("gE8f9")).browser).ios || (0, (0, parcelRequire("gE8f9")).browser).android) return;
                const badBrowser = (0, (0, parcelRequire("gE8f9")).browser).chrome || (0, (0, parcelRequire("gE8f9")).browser).safari;
                const tripleClick = event.detail >= 3;
                if (!(badBrowser && tripleClick)) return;
                const selection = window.getSelection();
                if (!selection) return;
                const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
                const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
                if (!rangeSelection) return;
                const target = event.target;
                const tableCell = target.closest('td,th');
                const clickedInCell = Boolean(tableCell);
                if (!clickedInCell) return;
                const anchorInCell = tableCell.contains(anchorNode);
                const focusInCell = tableCell.contains(focusNode);
                const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
                if (!selectionStartsOrEndsOutsideClickedCell) return;
                const elementToSelect = anchorInCell ? anchorNode.parentElement?.closest('div,p') : focusInCell ? focusNode.parentElement?.closest('div,p') : tableCell;
                if (elementToSelect) selection.selectAllChildren(elementToSelect);
            };
            this.providerFactory = props.dataProviders || new (0, (0, parcelRequire("dGzaM")).default)();
            this.serializer = new (0, (0, parcelRequire("9gOVJ")).default)(this.deriveSerializerProps(props));
            this.editorRef = props.innerRef || (0, ($parcel$interopDefault($5uXOq))).createRef();
            this.id = (0, ($parcel$interopDefault($bXrHm)))();
            (0, (0, parcelRequire("iN9lO")).startMeasure)(`Renderer Render Time: ${this.id}`);
        }
        anchorLinkAnalytics() {
            const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
            const { disableHeadingIDs: disableHeadingIDs } = this.props;
            if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
                const anchorLinkElement = document.getElementById(hash);
                if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANCHOR_LINK,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                });
            }
        }
        componentDidMount() {
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).STARTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            });
            this.rafID = requestAnimationFrame(()=>{
                (0, (0, parcelRequire("iN9lO")).stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                    const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, (0, parcelRequire("fc6h8")).shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $3de1eca32602d427$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $3de1eca32602d427$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                    if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).RENDERED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                        attributes: {
                            platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                            duration: duration,
                            distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                            ttfb: (0, (0, parcelRequire("kFiBa")).getResponseEndTime)(),
                            nodes: (0, (0, parcelRequire("kgV4b")).countNodes)(this.props.document),
                            severity: severity
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                    this.renderedMeasurementDistortedDurationMonitor.cleanup();
                    delete this.renderedMeasurementDistortedDurationMonitor;
                });
                this.anchorLinkAnalytics();
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const nextMedia = nextProps.media || {};
            const media = this.props.media || {};
            if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, (0, parcelRequire("9gOVJ")).default)(this.deriveSerializerProps(nextProps));
        }
        deriveSerializerProps(props) {
            const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
            const { annotationProvider: annotationProvider } = props;
            const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
            const { featureFlags: featureFlags } = this.createRendererContext(props.featureFlags, props.isTopLevelRenderer);
            return {
                startPos: props.startPos,
                providers: this.providerFactory,
                eventHandlers: props.eventHandlers,
                extensionHandlers: props.extensionHandlers,
                portal: props.portal,
                objectContext: {
                    adDoc: props.document,
                    schema: props.schema,
                    ...props.rendererContext
                },
                appearance: props.appearance,
                disableHeadingIDs: props.disableHeadingIDs,
                disableActions: props.disableActions,
                allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
                allowColumnSorting: props.allowColumnSorting,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                shouldOpenMediaViewer: props.shouldOpenMediaViewer,
                allowAltTextOnImages: props.allowAltTextOnImages,
                stickyHeaders: stickyHeaders,
                allowMediaLinking: props.media && props.media.allowLinking,
                surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
                media: props.media,
                emojiResourceConfig: props.emojiResourceConfig,
                smartLinks: props.smartLinks,
                allowCopyToClipboard: props.allowCopyToClipboard,
                allowWrapCodeBlock: props.allowWrapCodeBlock,
                allowCustomPanels: props.allowCustomPanels,
                allowAnnotations: props.allowAnnotations,
                allowSelectAllTrap: props.allowSelectAllTrap,
                allowPlaceholderText: props.allowPlaceholderText,
                nodeComponents: props.nodeComponents,
                allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
                isInsideOfInlineExtension: props.isInsideOfInlineExtension,
                textHighlighter: props.UNSTABLE_textHighlighter,
                allowTableAlignment: props.UNSTABLE_allowTableAlignment,
                allowTableResizing: props.UNSTABLE_allowTableResizing
            };
        }
        render() {
            const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
            const rendererContext = this.createRendererContext(this.props.featureFlags, this.props.isTopLevelRenderer);
            const allowNestedHeaderLinks = (0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
            const handleWrapperOnClick = (event)=>{
                const targetElement = event.target;
                this.handleMouseTripleClickInTables(event);
                if (!this.props.eventHandlers?.onUnhandledClick) return;
                if (!(targetElement instanceof window.Element)) return;
                const rendererWrapper = event.currentTarget;
                const isInteractiveElementInTree = (0, (0, parcelRequire("K5Jsy")).findInTree)(targetElement, rendererWrapper, (0, (0, parcelRequire("TPpI8")).isInteractiveElement));
                if (isInteractiveElementInTree) return;
                const windowSelection = window.getSelection();
                const selection = windowSelection !== null ? windowSelection.toString() : undefined;
                const hasSelection = selection && selection.length !== 0;
                const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
                const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
                if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
            };
            try {
                const schema = this.getSchema(this.props.schema, this.props.adfStage);
                const { result: result, stat: stat, pmDoc: pmDoc } = (0, (0, parcelRequire("12yAL")).renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance, this.props.includeNodesCountInStats);
                if (onComplete) onComplete(stat);
                const rendererOutput = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dyURG")).RendererContextProvider), {
                    value: rendererContext
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1pTqN")).ActiveHeaderIdProvider), {
                    value: (0, (0, parcelRequire("3kKuL")).getActiveHeadingId)(allowHeadingAnchorLinks)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("TM1uy")).default).Provider, {
                    value: {
                        fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                    }
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4BsEy")).Provider), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9S8fM")).ProviderFactoryProvider), {
                    value: this.providerFactory
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    allowColumnSorting: allowColumnSorting,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowCustomPanels: allowCustomPanels,
                    allowPlaceholderText: allowPlaceholderText,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    innerRef: this.editorRef,
                    onClick: handleWrapperOnClick,
                    onMouseDown: this.onMouseDownEditView,
                    ssr: media?.ssr,
                    isInsideOfInlineExtension: this.props.isInsideOfInlineExtension,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, enableSsrInlineScripts ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jUVor")).BreakoutSSRInlineScript), null) : null, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererActionsInternalUpdater, {
                    doc: pmDoc,
                    schema: schema,
                    onAnalyticsEvent: this.fireAnalyticsEvent
                }, result)))))));
                let rendererResult = truncated ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3lRy2")).TruncatedWrapper), {
                    height: maxHeight,
                    fadeHeight: fadeOutHeight
                }, rendererOutput) : rendererOutput;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, rendererResult);
            } catch (e) {
                if (onError) onError(e);
                return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RendererWrapper, {
                    allowAnnotations: allowAnnotations,
                    appearance: appearance,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    allowPlaceholderText: allowPlaceholderText,
                    allowColumnSorting: allowColumnSorting,
                    allowNestedHeaderLinks: allowNestedHeaderLinks,
                    useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
                    addTelepointer: this.props.addTelepointer,
                    onClick: handleWrapperOnClick,
                    isTopLevelRenderer: rendererContext.isTopLevelRenderer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iiXGq")).default), null));
            }
        }
        componentWillUnmount() {
            const { dataProviders: dataProviders } = this.props;
            if (this.rafID) window.cancelAnimationFrame(this.rafID);
            if (!dataProviders) this.providerFactory.destroy();
        }
    }
    function $3de1eca32602d427$export$88530751e3977073(props) {
        const { startPos: startPos } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("4YrGg")).AnnotationsPositionContext));
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("dyURG")).useRendererContext)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$5161b00bb85c4267, {
            ...props,
            startPos: startPos,
            isTopLevelRenderer: isTopLevelRenderer
        }));
    }
    const $3de1eca32602d427$export$af81ffb59b6ef0dd = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
            data: {
                appearance: (0, (0, parcelRequire("4NUlu")).getAnalyticsAppearance)(props.appearance),
                packageName: $3de1eca32602d427$var$packageName,
                packageVersion: $3de1eca32602d427$var$packageVersion,
                componentName: 'renderer',
                editorSessionId: (0, ($parcel$interopDefault($bXrHm)))()
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2DpUZ")).WithCreateAnalyticsEvent), {
            render: (createAnalyticsEvent)=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8Eu7T")).ErrorBoundary), {
                    component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                    rethrowError: true,
                    fallbackComponent: null,
                    createAnalyticsEvent: createAnalyticsEvent
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fIJEx")).IntlErrorBoundary), null, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$88530751e3977073, {
                    ...props,
                    createAnalyticsEvent: createAnalyticsEvent
                })));
            }
        })));
    const $3de1eca32602d427$var$RendererWrapper = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        const createTelepointer = ()=>{
            const telepointer = document.createElement('span');
            telepointer.textContent = '\u200b';
            telepointer.id = (0, (0, parcelRequire("OxITw")).TELEPOINTER_ID);
            return telepointer;
        };
        const initialUpdate = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
                const renderer = innerRef.current.querySelector('.ak-renderer-document');
                if (initialUpdate.current) {
                    const lastChild = renderer.lastChild;
                    lastChild && lastChild.appendChild(createTelepointer());
                }
                const mutateTelepointer = (mutations)=>{
                    mutations.forEach((mutation)=>{
                        if (initialUpdate.current) {
                            const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("OxITw")).TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            const lastChild = renderer.lastChild;
                            lastChild && lastChild.appendChild(createTelepointer());
                            initialUpdate.current = false;
                        }
                        if (mutation.type === 'characterData') {
                            const parentNode = mutation.target.parentElement;
                            if (parentNode) {
                                const oldTelepointer = renderer.querySelector(`#${(0, (0, parcelRequire("OxITw")).TELEPOINTER_ID)}`);
                                if (oldTelepointer) oldTelepointer.remove();
                                parentNode.appendChild(createTelepointer());
                            }
                        }
                    });
                };
                const observer = new MutationObserver(mutateTelepointer);
                observer.observe(innerRef.current, {
                    characterData: true,
                    attributes: false,
                    childList: true,
                    subtree: true
                });
                return ()=>observer.disconnect();
            }
        }, [
            innerRef,
            addTelepointer
        ]);
        const renderer = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthProvider), {
            className: `ak-renderer-wrapper is-${appearance}`,
            "data-appearance": appearance,
            shouldCheckExistingValue: isInsideOfInlineExtension
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Iju4")).BaseTheme), {
            baseFontSize: appearance && appearance !== 'comment' ? (0, (0, parcelRequire("iHYdz")).akEditorFullPageDefaultFontSize) : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1urn6")).EditorMediaClientProvider), {
            ssr: ssr
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            onClick: onClick,
            onMouseDown: onMouseDown,
            css: (0, (0, parcelRequire("OxITw")).rendererStyles)({
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: !!allowColumnSorting,
                useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
                allowAnnotations: props.allowAnnotations,
                allowTableResizing: allowTableResizing
            })
        }, children))));
        return (appearance === 'full-page' || appearance === 'full-width' || appearance === 'comment') && isTopLevelRenderer && (0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing') ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3de1eca32602d427$var$setAsQueryContainerStyles
        }, renderer) : renderer;
    });
    const $3de1eca32602d427$var$RootRendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    function $3de1eca32602d427$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
        const rootRendererContextValue = (0, ($parcel$interopDefault($5uXOq))).useContext($3de1eca32602d427$var$RootRendererContext);
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const rendererRef = (0, $5uXOq.useRef)(null);
        let _doc;
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) _doc = rootRendererContextValue.doc;
        else _doc = doc;
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
            else actions._privateUnregisterRenderer();
            return ()=>actions._privateUnregisterRenderer();
        }, [
            actions,
            schema,
            _doc,
            onAnalyticsEvent
        ]);
        if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$var$RootRendererContext.Provider, {
            value: {
                doc: _doc
            }
        }, children);
        return children;
    }
    const $3de1eca32602d427$var$RendererWithAnnotationSelection = (props)=>{
        const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
        const localRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const innerRef = props.innerRef || localRef;
        if (!allowAnnotations) return (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fCNtA")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4YrGg")).AnnotationsWrapper), {
            rendererRef: innerRef,
            adfDocument: adfDocument,
            annotationProvider: props.annotationProvider,
            isNestedRender: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($3de1eca32602d427$export$af81ffb59b6ef0dd, {
            innerRef: innerRef,
            ...props,
            featureFlags: props.featureFlags
        })));
    };
    var $3de1eca32602d427$export$2e2bcd8739ae039 = $3de1eca32602d427$var$RendererWithAnnotationSelection;
});
parcelRegister("dGzaM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$586c606cb83743fd$export$2e2bcd8739ae039);
    function $586c606cb83743fd$var$isUndefined(x) {
        return x === undefined;
    }
    class $586c606cb83743fd$export$2e2bcd8739ae039 {
        static create(providers) {
            const providerFactory = new $586c606cb83743fd$export$2e2bcd8739ae039();
            const keys = Object.keys(providers);
            keys.forEach((name)=>{
                providerFactory.setProvider(name, providers[name]);
            });
            return providerFactory;
        }
        destroy() {
            this.providers.clear();
            this.subscribers.clear();
        }
        isEmpty() {
            return !this.providers.size && !this.subscribers.size;
        }
        setProvider(name, provider) {
            if (this.providers.get(name) === provider) return;
            if (!$586c606cb83743fd$var$isUndefined(provider)) this.providers.set(name, provider);
            else this.providers.delete(name);
            this.notifyUpdated(name, provider);
        }
        removeProvider(name) {
            this.providers.delete(name);
            this.notifyUpdated(name);
        }
        subscribe(name, handler) {
            const handlers = this.subscribers.get(name) || [];
            handlers.push(handler);
            this.subscribers.set(name, handlers);
            const provider = this.providers.get(name);
            if (provider) handler(name, provider);
            return provider;
        }
        unsubscribe(name, handler) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            const index = handlers.indexOf(handler);
            if (index !== -1) handlers.splice(index, 1);
            if (handlers.length === 0) this.subscribers.delete(name);
            else this.subscribers.set(name, handlers);
        }
        unsubscribeAll(name) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            this.subscribers.delete(name);
        }
        hasProvider(name) {
            return this.providers.has(name);
        }
        notifyUpdated(name, provider) {
            const handlers = this.subscribers.get(name);
            if (!handlers) return;
            handlers.forEach((handler)=>{
                handler(name, provider);
            });
        }
        constructor(){
            this.providers = new Map();
            this.subscribers = new Map();
        }
    }
});
parcelRegister("9S8fM", function(module, exports) {
    $parcel$export(module.exports, "ProviderFactoryProvider", ()=>$d1ee541d73df1fcd$export$617c134b25cc4265);
    $parcel$export(module.exports, "useProvider", ()=>$d1ee541d73df1fcd$export$693cdb10cec23617);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGzaM;
    const $d1ee541d73df1fcd$var$ProviderFactoryContext = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("dGzaM")).default)());
    const $d1ee541d73df1fcd$export$617c134b25cc4265 = $d1ee541d73df1fcd$var$ProviderFactoryContext.Provider;
    const $d1ee541d73df1fcd$export$a3af4b6980aa23b5 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($d1ee541d73df1fcd$var$ProviderFactoryContext);
    const $d1ee541d73df1fcd$export$693cdb10cec23617 = (name)=>{
        const [provider, setProvider] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const providerFactory = $d1ee541d73df1fcd$export$a3af4b6980aa23b5();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const providerHandler = (_, provider)=>{
                setProvider(provider);
            };
            providerFactory.subscribe(name, providerHandler);
            return ()=>{
                providerFactory.unsubscribe(name, providerHandler);
            };
        }, [
            name,
            providerFactory
        ]);
        return provider;
    };
});
parcelRegister("gmhCD", function(module, exports) {
    $parcel$export(module.exports, "editorExperiment", ()=>$a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
    var $5IPCv;
    var $hdkTE = parcelRequire("hdkTE");
    var $a0Psj = parcelRequire("a0Psj");
    function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
        exposure: false
    }) {
        const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
        if ((0, $a0Psj._overrides)[experimentName] !== undefined) return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
        if (!(0, $a0Psj._product)) return experimentConfig.defaultValue === expectedExperimentValue;
        const experimentKey = experimentConfig.productKeys?.[0, $a0Psj._product];
        if (!experimentKey) return (0, $hdkTE.editorExperimentsConfig)[experimentName].defaultValue === expectedExperimentValue;
        const experimentValue = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue(experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
            typeGuard: experimentConfig.typeGuard,
            fireExperimentExposure: options.exposure
        });
        return expectedExperimentValue === experimentValue;
    }
});
parcelRegister("hdkTE", function(module, exports) {
    $parcel$export(module.exports, "editorExperimentsConfig", ()=>$7a273b3c03491c92$export$6cbb856f286b07ef);
    var $9qwvi = parcelRequire("9qwvi");
    const $7a273b3c03491c92$export$6cbb856f286b07ef = {
        'example-boolean': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_boolean'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'example-multivariate': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package_multivariate'
            },
            param: 'variant',
            typeGuard: (0, $9qwvi.oneOf)([
                'one',
                'two',
                'three'
            ]),
            defaultValue: 'one'
        },
        'test-new-experiments-package': {
            productKeys: {
                confluence: 'confluence_editor_experiment_test_new_package',
                jira: 'jira_editor_experiment_test_new_package'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'basic-text-transformations': {
            productKeys: {
                confluence: 'platform_editor_basic_text_transformations'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'dnd-input-performance-optimisation': {
            productKeys: {
                confluence: 'platform_editor_dnd_input_performance_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'element-level-templates': {
            productKeys: {
                confluence: 'platform_editor_element_level_templates'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'add-media-from-url': {
            productKeys: {
                confluence: 'platform_editor_add_media_from_url'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_drag_and_drop_nested'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'table-nested-dnd': {
            productKeys: {
                confluence: 'platform_editor_elements_dnd_nested_table'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'insert-menu-in-right-rail': {
            productKeys: {
                confluence: 'platform_editor_insert_menu_in_right_rail'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        support_table_in_comment: {
            productKeys: {
                confluence: 'platform_editor_support_table_in_comment_exp'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_exp_lazy_node_views: {
            productKeys: {
                confluence: 'platform_editor_exp_lazy_node_views'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_ai_button_block_elements: {
            productKeys: {
                confluence: 'platform_editor_ai_ai_button_block_elements'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_renderer_table_sticky_scrollbar: {
            productKeys: {
                confluence: 'platform_renderer_table_sticky_scrollbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nest-media-and-codeblock-in-quote': {
            productKeys: {
                confluence: 'platform_editor_nest_media_and_codeblock_in_quotes'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nested-expand-in-expand': {
            productKeys: {
                confluence: 'platform_editor_nest_nested_expand_in_expand'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_table_use_shared_state_hook: {
            productKeys: {
                confluence: 'platform_editor_table_use_shared_state_hook'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_multi_prompts': {
            productKeys: {
                confluence: 'editor_ai_-_multi_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_additional_editor_prompts: {
            productKeys: {
                confluence: 'platform_editor_ai_additional_editor_prompts'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        comment_on_bodied_extensions: {
            productKeys: {
                confluence: 'platform_editor_comment_on_bodied_extensions'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'optimised-apply-dnd': {
            productKeys: {
                confluence: 'platform_editor_element_dnd_apply_optimisation'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_1p_placeholder_hints: {
            productKeys: {
                confluence: 'platform_editor_ai_1p_placeholder_hints'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'example-placeholders',
                'tip-placeholders'
            ]),
            defaultValue: 'control'
        },
        advanced_layouts: {
            productKeys: {
                confluence: 'platform_editor_advanced_layouts'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        support_table_in_comment_jira: {
            productKeys: {
                jira: 'platform_editor_support_table_in_comment_jira'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        comment_on_inline_node_spotlight: {
            productKeys: {
                confluence: 'platform_editor_comment_on_inline_node_spotlight'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'editor_ai_-_proactive_ai_model_variations': {
            productKeys: {
                confluence: 'editor_ai_-_proactive_ai_model_variations'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'skip_grammar'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_refine_response_button: {
            productKeys: {
                confluence: 'platform_editor_ai_refine_response_button'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'platform_editor_ai-prompts-placeholder': {
            productKeys: {
                confluence: 'platform_editor_ai-prompts-placeholder'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'test'
            ]),
            defaultValue: 'control'
        },
        'editor_ai_-_gpt4_experiment': {
            productKeys: {
                confluence: 'editor_ai_-_gpt4_experiment'
            },
            param: 'cohort',
            typeGuard: (0, $9qwvi.oneOf)([
                'control',
                'einstein'
            ]),
            defaultValue: 'control'
        },
        platform_editor_ai_facepile: {
            productKeys: {
                confluence: 'platform_editor_ai_facepile'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        'nested-tables-in-tables': {
            productKeys: {
                confluence: 'platform_editor_nested_tables'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_change_tone_floating_toolbar: {
            productKeys: {
                confluence: 'platform_editor_ai_change_tone_floating_toolbar'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_response_history: {
            productKeys: {
                confluence: 'platform_editor_ai_response_history'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        issue_view_action_items: {
            productKeys: {
                jira: 'issue_view_action_items'
            },
            param: 'isActionItemsEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        contextual_formatting_toolbar: {
            productKeys: {
                confluence: 'platform_editor_contextual_formatting_toolbar_exp'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_1p_smart_link_unfurl_in_prompt: {
            productKeys: {
                confluence: 'platform_editor_ai_1p_smart_link_unfurl_in_prompt'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_draft_with_ai: {
            productKeys: {
                confluence: 'platform_editor_ai_draft_with_ai'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        },
        platform_editor_ai_unsplash_page_header: {
            productKeys: {
                confluence: 'platform_editor_ai_unsplash_page_header'
            },
            param: 'isEnabled',
            typeGuard: (0, $9qwvi.isBoolean),
            defaultValue: false
        }
    };
});
parcelRegister("9qwvi", function(module, exports) {
    $parcel$export(module.exports, "isBoolean", ()=>$41035ee8947774ef$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "oneOf", ()=>$41035ee8947774ef$export$a9a18ae5ba42aeab);
    function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
        return typeof value === 'boolean';
    }
    function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
        function typeGuard(value) {
            return values.includes(value);
        }
        if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
        return typeGuard;
    }
    const $41035ee8947774ef$var$IS_TESTING_ENV = false;
});
parcelRegister("a0Psj", function(module, exports) {
    $parcel$export(module.exports, "_overrides", ()=>$ae2371e90434836c$export$e5d73bf4f8e2ae96);
    $parcel$export(module.exports, "_product", ()=>$ae2371e90434836c$export$cf7305fc65acbf0d);
    $parcel$export(module.exports, "setupEditorExperiments", ()=>$ae2371e90434836c$export$1c2b6dbf79eb3560);
    var $hdkTE = parcelRequire("hdkTE");
    let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
    let $ae2371e90434836c$export$cf7305fc65acbf0d;
    function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, overrides) {
        if (overrides) {
            overrides = Object.entries(overrides).reduce((acc, [key, value])=>{
                const config = (0, $hdkTE.editorExperimentsConfig)[key];
                if (config) acc = {
                    ...acc,
                    [key]: config.typeGuard(value) ? value : config.defaultValue
                };
                return acc;
            }, {});
            $ae2371e90434836c$export$e5d73bf4f8e2ae96 = overrides;
        }
        $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    }
});
parcelRegister("9Iju4", function(module, exports) {
    $parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", ()=>$b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1);
    $parcel$export(module.exports, "BaseTheme", ()=>$b0fd15d81ba0fb5a$export$a1a213d350ca51ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0wej;
    var $iHYdz;
    var $4ceoy;
    function $b0fd15d81ba0fb5a$export$b5ccf4d25d2c5af1(breakpoint) {
        switch(breakpoint){
            case 'M':
            case 'L':
                return 760;
            default:
                return 680;
        }
    }
    function $b0fd15d81ba0fb5a$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
        const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
                baseFontSize: baseFontSize || 14,
                layoutMaxWidth: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth)
            }), [
            baseFontSize
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0wej")).a), {
            theme: memoizedTheme
        }, children);
    }
    function $b0fd15d81ba0fb5a$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ breakpoint: breakpoint })=>(0, ($parcel$interopDefault($5uXOq))).createElement($b0fd15d81ba0fb5a$export$3de34996b814f0f0, {
                breakpoint: breakpoint,
                baseFontSize: baseFontSize
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children)));
    }
});
parcelRegister("iHYdz", function(module, exports) {
    $parcel$export(module.exports, "akEditorFullPageDefaultFontSize", ()=>$01f0a5ace820da37$export$fe6b0b821a0e9067);
    $parcel$export(module.exports, "akEditorCodeFontFamily", ()=>$01f0a5ace820da37$export$9a7c520c39e1f0aa);
    $parcel$export(module.exports, "akEditorSubtleAccent", ()=>$01f0a5ace820da37$export$1d762aef048d30f9);
    $parcel$export(module.exports, "akEditorBlockquoteBorderColor", ()=>$01f0a5ace820da37$export$a7a75e50ae62d0a8);
    $parcel$export(module.exports, "akEditorDeleteBackground", ()=>$01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
    $parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", ()=>$01f0a5ace820da37$export$8f7d2d784079e274);
    $parcel$export(module.exports, "akEditorDeleteBorder", ()=>$01f0a5ace820da37$export$3c108a6bc41bb5f2);
    $parcel$export(module.exports, "akEditorDeleteIconColor", ()=>$01f0a5ace820da37$export$bf3aaa2106c119fd);
    $parcel$export(module.exports, "akEditorCustomIconSize", ()=>$01f0a5ace820da37$export$d2715266dd4a1fd1);
    $parcel$export(module.exports, "akEditorSelectedBorderColor", ()=>$01f0a5ace820da37$export$cf524c1b49838a49);
    $parcel$export(module.exports, "akEditorSelectedBorderSize", ()=>$01f0a5ace820da37$export$8dac549e32469ac4);
    $parcel$export(module.exports, "akEditorSelectedBorder", ()=>$01f0a5ace820da37$export$6e1e1996c4e8cc51);
    $parcel$export(module.exports, "akEditorSelectedBoxShadow", ()=>$01f0a5ace820da37$export$b6a59ac3a19b6343);
    $parcel$export(module.exports, "akEditorSelectedBorderBoldSize", ()=>$01f0a5ace820da37$export$befaaae517e3d864);
    $parcel$export(module.exports, "akEditorUnitZIndex", ()=>$01f0a5ace820da37$export$f35cc48f3398ab79);
    $parcel$export(module.exports, "akEditorShadowZIndex", ()=>$01f0a5ace820da37$export$b46cda584c619451);
    $parcel$export(module.exports, "akEditorStickyHeaderZIndex", ()=>$01f0a5ace820da37$export$6bed85de54b5de42);
    $parcel$export(module.exports, "akEditorSmallZIndex", ()=>$01f0a5ace820da37$export$321ddd2f049dd12);
    $parcel$export(module.exports, "akEditorGridLineZIndex", ()=>$01f0a5ace820da37$export$daeac9b8422ac3c2);
    $parcel$export(module.exports, "akEditorMenuZIndex", ()=>$01f0a5ace820da37$export$501d46e11ed5bf73);
    $parcel$export(module.exports, "akEditorFloatingPanelZIndex", ()=>$01f0a5ace820da37$export$6817b4b6a5ef78f1);
    $parcel$export(module.exports, "akEditorFloatingDialogZIndex", ()=>$01f0a5ace820da37$export$93768eb72dec48ce);
    $parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", ()=>$01f0a5ace820da37$export$c0aec4e0896849a0);
    $parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", ()=>$01f0a5ace820da37$export$5886f057e4f21fe4);
    $parcel$export(module.exports, "akEditorTableToolbarSize", ()=>$01f0a5ace820da37$export$6e85faa46d537a3f);
    $parcel$export(module.exports, "akEditorTableBorder", ()=>$01f0a5ace820da37$export$36ba77fba4a62d5f);
    $parcel$export(module.exports, "akEditorTableToolbar", ()=>$01f0a5ace820da37$export$640eef769748f78f);
    $parcel$export(module.exports, "akEditorTableHeaderCellBackground", ()=>$01f0a5ace820da37$export$4c6f61fb4b9ae93);
    $parcel$export(module.exports, "akEditorTableBorderSelected", ()=>$01f0a5ace820da37$export$f7bbcec54ff5bc47);
    $parcel$export(module.exports, "akEditorFullPageMaxWidth", ()=>$01f0a5ace820da37$export$fad19f16d3f953a3);
    $parcel$export(module.exports, "akEditorDefaultLayoutWidth", ()=>$01f0a5ace820da37$export$9db045950eedb49f);
    $parcel$export(module.exports, "akEditorWideLayoutWidth", ()=>$01f0a5ace820da37$export$74c442132af16a);
    $parcel$export(module.exports, "akEditorFullWidthLayoutWidth", ()=>$01f0a5ace820da37$export$f580e3d28d0986de);
    $parcel$export(module.exports, "akEditorTableNumberColumnWidth", ()=>$01f0a5ace820da37$export$37df10057d36a0e5);
    $parcel$export(module.exports, "akEditorBreakoutPadding", ()=>$01f0a5ace820da37$export$437293c5e9fc2703);
    $parcel$export(module.exports, "akEditorGutterPadding", ()=>$01f0a5ace820da37$export$6e0f4d52efd3d2d);
    $parcel$export(module.exports, "akEditorGutterPaddingDynamic", ()=>$01f0a5ace820da37$export$f222e0c7a2dc5324);
    $parcel$export(module.exports, "akEditorMobileBreakoutPoint", ()=>$01f0a5ace820da37$export$efe8561bbd3f74d2);
    $parcel$export(module.exports, "akEditorTableCellMinWidth", ()=>$01f0a5ace820da37$export$e4d39a9e8607c1d3);
    $parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", ()=>$01f0a5ace820da37$export$43946f2400ab6f1f);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", ()=>$01f0a5ace820da37$export$558438ae7fd4b8ce);
    $parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", ()=>$01f0a5ace820da37$export$6beb98d32d4ca149);
    $parcel$export(module.exports, "akEditorSwoopCubicBezier", ()=>$01f0a5ace820da37$export$3b24948cd5dbb087);
    $parcel$export(module.exports, "gridMediumMaxWidth", ()=>$01f0a5ace820da37$export$5edb4f38c3eacb1a);
    $parcel$export(module.exports, "breakoutWideScaleRatio", ()=>$01f0a5ace820da37$export$e60820063058ed59);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", ()=>$01f0a5ace820da37$export$60da500206e2ceec);
    $parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", ()=>$01f0a5ace820da37$export$c0e6648ae1bb2fac);
    $parcel$export(module.exports, "akRichMediaResizeZIndex", ()=>$01f0a5ace820da37$export$fb15fade89f67217);
    $parcel$export(module.exports, "akLayoutGutterOffset", ()=>$01f0a5ace820da37$export$847030921e9d5a40);
    $parcel$export(module.exports, "akEditorLineHeight", ()=>$01f0a5ace820da37$export$40eb41ab799f0329);
    $parcel$export(module.exports, "akEditorToolbarKeylineHeight", ()=>$01f0a5ace820da37$export$d29cb2c31fcbb7c5);
    $parcel$export(module.exports, "akEditorContextPanelWidth", ()=>$01f0a5ace820da37$export$688a6dc01e760755);
    $parcel$export(module.exports, "akEditorTableCellBlanketSelected", ()=>$01f0a5ace820da37$export$e736f2caf3b39eb3);
    $parcel$export(module.exports, "akEditorTableCellBlanketDeleted", ()=>$01f0a5ace820da37$export$de3cef07cda55645);
    $parcel$export(module.exports, "akEditorWrappedNodeZIndex", ()=>$01f0a5ace820da37$export$e88f6c898960b391);
    $parcel$export(module.exports, "layoutBreakpointWidth", ()=>$01f0a5ace820da37$export$e5c605f2b2a12b00);
    $parcel$export(module.exports, "blockNodesVerticalMargin", ()=>$01f0a5ace820da37$export$1d0d506416d457f1);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", ()=>$01f0a5ace820da37$export$e683ef42725d1713);
    $parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", ()=>$01f0a5ace820da37$export$226c784ba04bd04b);
    $parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", ()=>$01f0a5ace820da37$export$214ff00e5618d86c);
    $parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", ()=>$01f0a5ace820da37$export$d7726a000ae2d7c);
    $parcel$export(module.exports, "akEditorSelectedNodeClassName", ()=>$01f0a5ace820da37$export$a02a3f1515c2e21a);
    $parcel$export(module.exports, "editorFontSize", ()=>$01f0a5ace820da37$export$58a725ff69bda73a);
    $parcel$export(module.exports, "relativeFontSizeToBase16", ()=>$01f0a5ace820da37$export$59733a9f61449b25);
    $parcel$export(module.exports, "akEditorMobileMaxWidth", ()=>$01f0a5ace820da37$export$9369fd010fa0ddd6);
    $parcel$export(module.exports, "avatarColors", ()=>$01f0a5ace820da37$export$312e1e71424c4aa1);
    var $VSDnB;
    const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
    const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
    const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
    const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
    const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
    const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)';
    const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
    const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
    const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
    const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
    const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
    const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
    const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
    const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
    const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
    const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
    const $01f0a5ace820da37$export$b46cda584c619451 = 2;
    const $01f0a5ace820da37$export$6bed85de54b5de42 = 11;
    const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
    const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
    const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
    const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
    const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
    const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
    const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
    const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
    const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
    const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
    const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
    const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
    const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
    const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
    const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
    const $01f0a5ace820da37$export$9db045950eedb49f = 760;
    const $01f0a5ace820da37$export$74c442132af16a = 960;
    const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
    const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
    const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
    const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
    const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
    const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_core_increase_full_page_guttering') ? 52 : 32;
    const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
    const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
    const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
    const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
    const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
    const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
    const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
    const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
    const $01f0a5ace820da37$export$60da500206e2ceec = 905;
    const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011;
    const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
    const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
    const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
    const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
    const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
    const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
    const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
    const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
    const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2;
    const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
        SMALL: 550,
        MEDIUM: 760
    };
    const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
    const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
    const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
    const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
    const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
    const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
    const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>"var(--ds-space-500, 40px)";
    const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
    const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
    const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
                theme: theme
            }) * multiplier;
    const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
        if (typeof px === 'string') px = parseInt(px);
        if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
        return `${px / 16}rem`;
    };
    const $01f0a5ace820da37$export$96b72b7f243fa693 = {
        laptopHiDPI: {
            width: 1440,
            height: 900
        },
        laptopMDPI: {
            width: 1280,
            height: 800
        },
        tabletL: {
            width: 1024,
            height: 1366
        },
        tabletS: {
            width: 768,
            height: 1024
        },
        mobileM: {
            width: 414,
            height: 736
        },
        mobileS: {
            width: 375,
            height: 667
        },
        mobileXS: {
            width: 320,
            height: 568
        }
    };
    const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
    const $01f0a5ace820da37$export$846a716e9e69a8df = [
        [
            'White',
            '#000000'
        ],
        [
            'Light blue',
            '#0C294F'
        ],
        [
            'Light teal',
            '#0C343B'
        ],
        [
            'Light green',
            '#052E21'
        ],
        [
            'Light yellow',
            '#484123'
        ],
        [
            'Light red',
            '#441C13'
        ],
        [
            'Light purple',
            '#282249'
        ],
        [
            'Light gray',
            '#202328'
        ],
        [
            'Blue',
            '#0B3165'
        ],
        [
            'Teal',
            '#044853'
        ],
        [
            'Green',
            '#053927'
        ],
        [
            'Yellow',
            '#6F5C25'
        ],
        [
            'Red',
            '#582013'
        ],
        [
            'Purple',
            '#3E327B'
        ],
        [
            'Gray',
            '#475262'
        ],
        [
            'Dark blue',
            '#003884'
        ],
        [
            'Dark teal',
            '#055866'
        ],
        [
            'Dark green',
            '#044932'
        ],
        [
            'Dark yellow',
            '#82641C'
        ],
        [
            'Dark red',
            '#6B2A19'
        ],
        [
            'Dark purple',
            '#4D38B2'
        ]
    ].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
    function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
        return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
    }
    const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
        "var(--ds-icon-accent-red, #C9372C)",
        "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
        "var(--ds-icon-accent-magenta, #CD519D)",
        "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
        "var(--ds-icon-accent-orange, #E56910)",
        "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
        "var(--ds-icon-accent-green, #22A06B)",
        "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
        "var(--ds-icon-accent-blue, #1D7AFC)",
        "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
        "var(--ds-icon-accent-teal, #2898BD)",
        "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
        "var(--ds-icon-accent-lime, #6A9A23)",
        "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
        "var(--ds-icon-accent-purple, #8270DB)",
        "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
        "var(--ds-icon-accent-gray, #758195)",
        "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
        "var(--ds-icon-accent-yellow, #B38600)",
        "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
        "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
    ];
    const $01f0a5ace820da37$export$42608c013398a830 = [
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
        },
        {
            textColor: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
        },
        {
            textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
            backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
        }
    ];
});
parcelRegister("4ceoy", function(module, exports) {
    $parcel$export(module.exports, "getBreakpoint", ()=>$a2904bcfe480568e$export$1eb095b00b926404);
    $parcel$export(module.exports, "createWidthContext", ()=>$a2904bcfe480568e$export$31a4966bffb9ac98);
    $parcel$export(module.exports, "WidthContext", ()=>$a2904bcfe480568e$export$27e39f636459b9f);
    $parcel$export(module.exports, "WidthConsumer", ()=>$a2904bcfe480568e$export$5d8538aa831b6ebb);
    $parcel$export(module.exports, "WidthProvider", ()=>$a2904bcfe480568e$export$7921e18173e8c666);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8QpSo;
    var $7nRxN;
    var $gJlZe;
    var $1v3g5;
    function $a2904bcfe480568e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a2904bcfe480568e$var$styles = {
        name: "pw7jst",
        styles: "position:relative;width:100%"
    };
    const $a2904bcfe480568e$var$SCROLLBAR_WIDTH = 30;
    function $a2904bcfe480568e$export$1eb095b00b926404(width = 0) {
        const MAX_S = 1266;
        const MAX_M = 2146;
        if (width >= MAX_S && width < MAX_M) return 'M';
        else if (width >= MAX_M) return 'L';
        return 'S';
    }
    function $a2904bcfe480568e$export$31a4966bffb9ac98(width = 0) {
        return {
            width: width,
            breakpoint: $a2904bcfe480568e$export$1eb095b00b926404(width)
        };
    }
    const $a2904bcfe480568e$export$27e39f636459b9f = (0, ($parcel$interopDefault($5uXOq))).createContext($a2904bcfe480568e$export$31a4966bffb9ac98());
    const { Provider: $a2904bcfe480568e$var$Provider, Consumer: $a2904bcfe480568e$export$5d8538aa831b6ebb } = $a2904bcfe480568e$export$27e39f636459b9f;
    const $a2904bcfe480568e$export$df154c49e93b2ac2 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return (0, (0, parcelRequire("1v3g5")).isSSR)() ? 0 : document.body?.offsetWidth ?? 0;
    });
    const $a2904bcfe480568e$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
        const existingContextValue = (0, $5uXOq.useContext)($a2904bcfe480568e$export$27e39f636459b9f);
        const [width, setWidth] = (0, $5uXOq.useState)($a2904bcfe480568e$export$df154c49e93b2ac2);
        const widthRef = (0, $5uXOq.useRef)(width);
        const isMountedRef = (0, $5uXOq.useRef)(true);
        const providerValue = (0, $5uXOq.useMemo)(()=>$a2904bcfe480568e$export$31a4966bffb9ac98(width), [
            width
        ]);
        const updateWidth = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("7nRxN")).default)((nextWidth)=>{
                const currentWidth = widthRef.current || 0;
                if (Math.abs(currentWidth - nextWidth) < $a2904bcfe480568e$var$SCROLLBAR_WIDTH) return;
                if (!isMountedRef.current) return;
                setWidth(nextWidth);
            });
        }, []);
        const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
        (0, ($parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
            isMountedRef.current = true;
            return ()=>{
                isMountedRef.current = false;
            };
        }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $a2904bcfe480568e$var$styles,
            className: className
        }, !skipWidthDetection && (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gJlZe")).WidthObserver), {
            setWidth: updateWidth,
            offscreen: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($a2904bcfe480568e$var$Provider, {
            value: providerValue
        }, children)), skipWidthDetection && children);
    };
});
parcelRegister("1v3g5", function(module, exports) {
    $parcel$export(module.exports, "isSSR", ()=>$161da1f5bf80dbfb$export$48d7c418edadb60c);
    var $6cAn5 = parcelRequire("6cAn5");
    function $161da1f5bf80dbfb$export$48d7c418edadb60c() {
        try {
            return Boolean(typeof document === 'undefined' || typeof $6cAn5 !== 'undefined' && $6cAn5?.env?.REACT_SSR);
        } catch (e) {
            return false;
        }
    }
});
parcelRegister("fIJEx", function(module, exports) {
    $parcel$export(module.exports, "IntlErrorBoundary", ()=>$f1eccfecc1c43fb5$export$7df0749115d18d19);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    const $f1eccfecc1c43fb5$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
    const $f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
    class $f1eccfecc1c43fb5$export$7df0749115d18d19 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch(error, errorInfo) {
            if ($f1eccfecc1c43fb5$var$isMissingIntlProviderInAncestryError(error)) this.setState({
                missingIntlProviderInAncestry: true
            });
            else throw error;
        }
        render() {
            if (this.state.missingIntlProviderInAncestry) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: "en"
            }, this.props.children);
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                missingIntlProviderInAncestry: false
            };
        }
    }
});
parcelRegister("iiXGq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$94120525d10931b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $iHYdz;
    var $eJS47;
    var $3bDjY;
    var $gkwXh;
    var $7R1zM;
    var $d54NZ;
    var $9tFGn;
    const $94120525d10931b9$var$blockNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'flex',
        fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
        margin: `${"var(--ds-space-100, 8px)"} 0`,
        minHeight: '24px',
        padding: "var(--ds-space-150, 12px)",
        textAlign: 'center',
        verticalAlign: 'text-bottom',
        minWidth: '120px',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $94120525d10931b9$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("9tFGn")).getUnsupportedContent)((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedBlockContent, (0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("d54NZ")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $94120525d10931b9$var$blockNodeStyle,
            className: "unsupported"
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            label: "?",
            size: "small"
        })))));
    };
    var $94120525d10931b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($94120525d10931b9$var$UnsupportedBlockNode);
});
parcelRegister("gkwXh", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$97c56ca7515fdb59$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$97c56ca7515fdb59$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "INPUT_METHOD", ()=>$97c56ca7515fdb59$export$85f107b1fcc9d96f);
    $parcel$export(module.exports, "INSERT_MEDIA_VIA", ()=>$97c56ca7515fdb59$export$9b31fa32ae3f8051);
    $parcel$export(module.exports, "TRIGGER_METHOD", ()=>$97c56ca7515fdb59$export$81a8b7dba1aa8f75);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$97c56ca7515fdb59$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$97c56ca7515fdb59$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "CONTENT_COMPONENT", ()=>$97c56ca7515fdb59$export$9f0b2adf3cfd71b7);
    var $97c56ca7515fdb59$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($97c56ca7515fdb59$export$76a2e4c433c23bb9 || ($97c56ca7515fdb59$export$76a2e4c433c23bb9 = {}));
    var $97c56ca7515fdb59$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["ACTIVATED"] = "activated";
        ACTION["ADDED"] = "added";
        ACTION["BROWSER_FREEZE"] = "browserFreeze";
        ACTION["CANCELLED"] = "cancelled";
        ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
        ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
        ACTION["CHANGED_ICON"] = "changedIcon";
        ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
        ACTION["CHANGED_LAYOUT"] = "changedLayout";
        ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
        ACTION["CHANGED_TYPE"] = "changedType";
        ACTION["CHANGED_URL"] = "changedUrl";
        ACTION["CLEARED"] = "cleared";
        ACTION["CLICKED"] = "clicked";
        ACTION["CLOSED"] = "closed";
        ACTION["COMMITTED"] = "committed";
        ACTION["CONNECTED_NODES"] = "connectedNodes";
        ACTION["CONVERTED"] = "converted";
        ACTION["COPIED"] = "copied";
        ACTION["CUT"] = "cut";
        ACTION["DEACTIVATED"] = "deactivated";
        ACTION["DECREMENTED"] = "decremented";
        ACTION["DELETED"] = "deleted";
        ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
        ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
        ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
        ACTION["DISMISSED"] = "dismissed";
        ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
        ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
        ACTION["DOUBLE_CLICKED"] = "doubleClicked";
        ACTION["DRAGGED"] = "dragged";
        ACTION["EDITED"] = "edited";
        ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
        ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
        ACTION["EDITOR_MOUNTED"] = "mounted";
        ACTION["EDITOR_TTI"] = "tti";
        ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
        ACTION["RE_RENDERED"] = "reRendered";
        ACTION["ENTERED"] = "entered";
        ACTION["ERRORED"] = "errored";
        ACTION["EXPOSED"] = "exposed";
        ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
        ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
        ACTION["FIND_PERFORMED"] = "findPerformed";
        ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
        ACTION["FORMATTED"] = "formatted";
        ACTION["HELP_OPENED"] = "helpOpened";
        ACTION["HIGHLIGHTED"] = "highlighted";
        ACTION["INCREMENTED"] = "incremented";
        ACTION["INDENTED"] = "indented";
        ACTION["INITIALISED"] = "initialised";
        ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
        ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
        ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
        ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
        ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
        ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
        ACTION["INSERTED"] = "inserted";
        ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
        ACTION["INVOKED"] = "invoked";
        ACTION["GOT_CONNECTIONS"] = "gotConnections";
        ACTION["LANGUAGE_SELECTED"] = "languageSelected";
        ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
        ACTION["MATCHED"] = "matched";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
        ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
        ACTION["OPENED"] = "opened";
        ACTION["OUTDENTED"] = "outdented";
        ACTION["PASTED"] = "pasted";
        ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
        ACTION["PASTED_TIMED"] = "pastedTimed";
        ACTION["PRESSED"] = "pressed";
        ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
        ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
        ACTION["REPLACED_ALL"] = "replacedAll";
        ACTION["REPLACED_ONE"] = "replacedOne";
        ACTION["RESOLVED"] = "resolved";
        ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
        ACTION["SELECTED"] = "selected";
        ACTION["SHOWN"] = "shown";
        ACTION["SLOW_INPUT"] = "slowInput";
        ACTION["STARTED"] = "started";
        ACTION["STOPPED"] = "stopped";
        ACTION["SUBSTITUTED"] = "autoSubstituted";
        ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
        ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
        ACTION["SYNCHRONY_ERROR"] = "synchronyError";
        ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
        ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
        ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
        ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
        ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
        ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
        ACTION["TYPING_FINISHED"] = "typingFinished";
        ACTION["TYPING_STARTED"] = "typingStarted";
        ACTION["UNLINK"] = "unlinked";
        ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
        ACTION["UPDATED"] = "updated";
        ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
        ACTION["UPDATED_SOURCE"] = "updatedSource";
        ACTION["UPDATED_TARGET"] = "updatedTarget";
        ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
        ACTION["RENDERED"] = "rendered";
        ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
        ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
        ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
        ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
        ACTION["REMOVE_ICON"] = "removedIcon";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaughtV2";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["STEPS_TRACKED"] = "stepsTracked";
        ACTION["STEPS_FILTERED"] = "stepsFiltered";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
        ACTION["RECORD_VIDEO"] = "recordVideo";
        ACTION["INSERT_VIDEO"] = "insertVideo";
        ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
        ACTION["ADD_CHILD"] = "addChild";
        ACTION["CHANGE_ACTIVE"] = "changeActive";
        ACTION["REMOVE_CHILD"] = "removeChild";
        ACTION["UPDATE_PARAMETERS"] = "updateParameters";
        ACTION["GET_CHILDERN"] = "getChildern";
        ACTION["MOVED"] = "moved";
        ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
        ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
        ACTION["UPLOAD_FAILED"] = "uploadFailed";
        ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    })($97c56ca7515fdb59$export$9523889e0a5da4ba || ($97c56ca7515fdb59$export$9523889e0a5da4ba = {}));
    var $97c56ca7515fdb59$export$85f107b1fcc9d96f;
    (function(INPUT_METHOD) {
        INPUT_METHOD["ASCII"] = "ascii";
        INPUT_METHOD["AUTO"] = "auto";
        INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
        INPUT_METHOD["BUTTON"] = "button";
        INPUT_METHOD["BLUR"] = "blur";
        INPUT_METHOD["CARD"] = "card";
        INPUT_METHOD["CLIPBOARD"] = "clipboard";
        INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
        INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
        INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
        INPUT_METHOD["DRAG"] = "drag";
        INPUT_METHOD["EXTERNAL"] = "external";
        INPUT_METHOD["EXTENSION_API"] = "extensionApi";
        INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
        INPUT_METHOD["FORMATTING"] = "autoformatting";
        INPUT_METHOD["INSERT_MENU"] = "insertMenu";
        INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
        INPUT_METHOD["KEYBOARD"] = "keyboard";
        INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
        INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
        INPUT_METHOD["MANUAL"] = "manual";
        INPUT_METHOD["PICKER"] = "picker";
        INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
        INPUT_METHOD["PREFILL"] = "prefill";
        INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
        INPUT_METHOD["SHORTCUT"] = "shortcut";
        INPUT_METHOD["TOOLBAR"] = "toolbar";
        INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
        INPUT_METHOD["DATASOURCE"] = "datasource_config";
        INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
        INPUT_METHOD["MOUSE"] = "mouse";
        INPUT_METHOD["BROWSER"] = "browser";
        INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    })($97c56ca7515fdb59$export$85f107b1fcc9d96f || ($97c56ca7515fdb59$export$85f107b1fcc9d96f = {}));
    var $97c56ca7515fdb59$export$9b31fa32ae3f8051;
    (function(INSERT_MEDIA_VIA) {
        INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
        INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
        INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    })($97c56ca7515fdb59$export$9b31fa32ae3f8051 || ($97c56ca7515fdb59$export$9b31fa32ae3f8051 = {}));
    var $97c56ca7515fdb59$export$81a8b7dba1aa8f75;
    (function(TRIGGER_METHOD) {
        TRIGGER_METHOD["BUTTON"] = "button";
        TRIGGER_METHOD["KEYBOARD"] = "keyboard";
        TRIGGER_METHOD["SHORTCUT"] = "shortcut";
        TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    })($97c56ca7515fdb59$export$81a8b7dba1aa8f75 || ($97c56ca7515fdb59$export$81a8b7dba1aa8f75 = {}));
    var $97c56ca7515fdb59$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["COLLAB"] = "collab";
        ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
        ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
        ACTION_SUBJECT["DATE"] = "date";
        ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
        ACTION_SUBJECT["DOCUMENT"] = "document";
        ACTION_SUBJECT["EDITOR"] = "editor";
        ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
        ACTION_SUBJECT["EMBEDS"] = "embeds";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["EXTENSION"] = "extension";
        ACTION_SUBJECT["FEATURE"] = "feature";
        ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
        ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
        ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
        ACTION_SUBJECT["HELP"] = "help";
        ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
        ACTION_SUBJECT["LAYOUT"] = "layout";
        ACTION_SUBJECT["LIST"] = "list";
        ACTION_SUBJECT["MEDIA"] = "media";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["MENTION"] = "mention";
        ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["PANEL"] = "panel";
        ACTION_SUBJECT["PICKER"] = "picker";
        ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
        ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
        ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
        ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT["SELECTION"] = "selection";
        ACTION_SUBJECT["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
        ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
        ACTION_SUBJECT["TEXT"] = "text";
        ACTION_SUBJECT["TOOLBAR"] = "toolbar";
        ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
        ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
        ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
        ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["TOOLTIP"] = "tooltip";
        ACTION_SUBJECT["LOOM"] = "loom";
        ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
        ACTION_SUBJECT["DRAG"] = "drag";
        ACTION_SUBJECT["ELEMENT"] = "element";
        ACTION_SUBJECT["CONTEXT_MENU"] = "contextMenu";
        ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
        ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
        ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
        ACTION_SUBJECT["DECORATION"] = "decoration";
        ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    })($97c56ca7515fdb59$export$7525482b5931e326 || ($97c56ca7515fdb59$export$7525482b5931e326 = {}));
    var $97c56ca7515fdb59$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["ACTION"] = "action";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
        ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
        ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
        ACTION_SUBJECT_ID["ALL"] = "all";
        ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
        ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
        ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
        ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["BORDER"] = "border";
        ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
        ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
        ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
        ACTION_SUBJECT_ID["CANCEL"] = "cancel";
        ACTION_SUBJECT_ID["CAPTION"] = "caption";
        ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
        ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
        ACTION_SUBJECT_ID["CELL"] = "cell";
        ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
        ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
        ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
        ACTION_SUBJECT_ID["DATE"] = "date";
        ACTION_SUBJECT_ID["DATE_DAY"] = "day";
        ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
        ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
        ACTION_SUBJECT_ID["DECISION"] = "decision";
        ACTION_SUBJECT_ID["DIVIDER"] = "divider";
        ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
        ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
        ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
        ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
        ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
        ACTION_SUBJECT_ID["EMOJI"] = "emoji";
        ACTION_SUBJECT_ID["EXPAND"] = "expand";
        ACTION_SUBJECT_ID["EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
        ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
        ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
        ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
        ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
        ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
        ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
        ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
        ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
        ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
        ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
        ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
        ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
        ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
        ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
        ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
        ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
        ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
        ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
        ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
        ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
        ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["LAYOUT"] = "layout";
        ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
        ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
        ACTION_SUBJECT_ID["MEDIA"] = "media";
        ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
        ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
        ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
        ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["MENTION"] = "mention";
        ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
        ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["NODE"] = "node";
        ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
        ACTION_SUBJECT_ID["PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
        ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
        ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
        ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
        ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
        ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
        ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
        ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
        ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
        ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
        ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
        ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
        ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
        ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
        ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
        ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
        ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
        ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
        ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
        ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
        ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
        ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
        ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
        ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
        ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
        ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
        ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
        ACTION_SUBJECT_ID["PUNC"] = "punctuation";
        ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
        ACTION_SUBJECT_ID["RANGE"] = "range";
        ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
        ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
        ACTION_SUBJECT_ID["RESIZED"] = "resized";
        ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
        ACTION_SUBJECT_ID["SAVE"] = "save";
        ACTION_SUBJECT_ID["SECTION"] = "section";
        ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
        ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
        ACTION_SUBJECT_ID["STATUS"] = "status";
        ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
        ACTION_SUBJECT_ID["TABLE"] = "table";
        ACTION_SUBJECT_ID["TEXT"] = "text";
        ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
        ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
        ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
        ACTION_SUBJECT_ID["UNLINK"] = "unlink";
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
        ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
        ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
        ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
        ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
        ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
        ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
        ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    })($97c56ca7515fdb59$export$9957974f8b4d8f74 || ($97c56ca7515fdb59$export$9957974f8b4d8f74 = {}));
    var $97c56ca7515fdb59$export$75ef928acd21e35b;
    (function(FLOATING_CONTROLS_TITLE) {
        FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
        FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
        FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
        FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
        FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
        FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
        FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    })($97c56ca7515fdb59$export$75ef928acd21e35b || ($97c56ca7515fdb59$export$75ef928acd21e35b = {}));
    var $97c56ca7515fdb59$export$9f0b2adf3cfd71b7;
    (function(CONTENT_COMPONENT) {
        CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
        CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
        CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
        CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    })($97c56ca7515fdb59$export$9f0b2adf3cfd71b7 || ($97c56ca7515fdb59$export$9f0b2adf3cfd71b7 = {}));
});
parcelRegister("7R1zM", function(module, exports) {
    $parcel$export(module.exports, "unsupportedContentMessages", ()=>$757d518931aaa671$export$32ec96484dd3ba39);
    var $7VHMR;
    const $757d518931aaa671$export$32ec96484dd3ba39 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unsupportedInlineContent: {
            id: 'fabric.editor.unsupportedInlineContent',
            defaultMessage: 'Unsupported content',
            description: 'Unsupported content'
        },
        unsupportedBlockContent: {
            id: 'fabric.editor.unsupportedBlockContent',
            defaultMessage: 'This editor does not support displaying this content',
            description: 'This editor does not support displaying this content'
        },
        unsupportedContentTooltip: {
            id: 'fabric.editor.unsupportedContentTooltip',
            defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
            description: 'Content is not available in this editor, this will be preserved when you edit and save'
        }
    });
});
parcelRegister("d54NZ", function(module, exports) {
    $parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", ()=>$850930d0b79c2a61$export$d343369b8f25914);
    $parcel$export(module.exports, "fireUnsupportedEvent", ()=>$850930d0b79c2a61$export$e1051b410945e4d4);
    $parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", ()=>$850930d0b79c2a61$export$3a34598135e7219b);
    var $gkwXh;
    const $850930d0b79c2a61$var$whitelistedAttributes = [
        'align',
        'annotationType',
        'extensionKey',
        'extensionType',
        'layout',
        'type',
        'localId',
        'mode',
        'language',
        'timestamp',
        'state',
        'originalWidth',
        'originalHeight',
        'height',
        'width',
        'shortName',
        'level',
        'userType',
        'order',
        'panelType',
        'color',
        'style',
        'isNumberColumnEnabled',
        'colspan',
        'rowspan',
        'colwidth',
        'background'
    ];
    function $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
        const { name: name } = node.type;
        return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
    }
    const $850930d0b79c2a61$var$sanitizeMarks = (marks = [])=>{
        let sanitizedMarks = [];
        marks.forEach((mark)=>{
            if (mark.attrs) {
                const attrs = $850930d0b79c2a61$var$sanitizeAttributes(mark.attrs);
                sanitizedMarks.push({
                    ...mark,
                    attrs: attrs
                });
            } else sanitizedMarks.push({
                ...mark
            });
        });
        return sanitizedMarks;
    };
    const $850930d0b79c2a61$var$sanitizeAttributes = (attrs = {})=>{
        let sanitizedAttrs = Object.assign({}, attrs);
        Object.keys(attrs).filter((key)=>!$850930d0b79c2a61$var$whitelistedAttributes.includes(key)).forEach((key)=>{
            sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
        });
        return sanitizedAttrs;
    };
    const $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        dispatchAnalyticsEvent({
            action: action,
            actionSubjectId: unsupportedContentType,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TOOLTIP,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI,
            attributes: {
                unsupportedNodeType: originalNodeType
            }
        });
    };
    const $850930d0b79c2a61$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
        const { type: nodeType, marks: nodeMarks } = node;
        const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
        const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
        const parentType = ancestorHierarchy.split(' ').pop() || '';
        if (nodeMarks.length) nodeMarks.forEach((mark)=>{
            if (mark.type === unsupportedMark) {
                const { originalValue: originalValue } = mark.attrs || {};
                const { type: type } = originalValue || {};
                const unsupportedNode = {
                    type: type || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: originalValue.attrs || {}
                };
                $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
            } else if (mark.type === unsupportedNodeAttribute) {
                const { unsupported: unsupported } = mark.attrs || {};
                const unsupportedNodeAttribute = {
                    type: nodeType.name || '',
                    ancestry: ancestorHierarchy,
                    parentType: parentType,
                    marks: [],
                    attrs: unsupported || {}
                };
                $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
            }
        });
        if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
            const { originalValue: originalValue } = node.attrs || {};
            const { marks: marks } = originalValue || [];
            const { attrs: attrs } = originalValue || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: marks || [],
                attrs: attrs || {}
            };
            const actionSubjectId = nodeType === unsupportedInline ? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
            $850930d0b79c2a61$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
        } else node.content.forEach((childNode)=>$850930d0b79c2a61$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $850930d0b79c2a61$var$concatAncestorHierarchy(node, ancestorHierarchy)));
    };
    const $850930d0b79c2a61$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
        const sanitizedAttrs = $850930d0b79c2a61$var$sanitizeAttributes(unsupportedNode.attrs);
        const sanitizedMarks = $850930d0b79c2a61$var$sanitizeMarks(unsupportedNode.marks);
        const sanitizedUnsupportedNode = {
            type: unsupportedNode.type,
            ancestry: unsupportedNode.ancestry,
            parentType: unsupportedNode.parentType,
            attrs: sanitizedAttrs,
            marks: sanitizedMarks
        };
        const payload = {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: actionSubjectId,
            attributes: {
                unsupportedNode: sanitizedUnsupportedNode,
                ...!!errorCode && {
                    errorCode: errorCode
                }
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
        dispatchAnalyticsEvent(payload);
    };
    const $850930d0b79c2a61$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
        $850930d0b79c2a61$var$trackUnsupportedContentTooltipActionFor((0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
    };
});
parcelRegister("9tFGn", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContent", ()=>$3ba5e7dd155390b9$export$d4ded51d0f0bd2df);
    function $3ba5e7dd155390b9$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
        let defaultLocale = 'en';
        let canTranslateToLocale = true;
        let locale = intl ? intl.locale : defaultLocale;
        let finalMessage = message.defaultMessage;
        if (node && locale.startsWith(defaultLocale)) {
            const { originalValue: originalValue } = node.attrs;
            if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
                finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
                canTranslateToLocale = false;
            } else if (originalValue.type) {
                finalMessage = `${prefix} ${originalValue.type}`;
                canTranslateToLocale = false;
            }
        }
        if (intl && canTranslateToLocale) return intl.formatMessage(message);
        return finalMessage;
    }
});
parcelRegister("2DpUZ", function(module, exports) {
    $parcel$export(module.exports, "WithCreateAnalyticsEvent", ()=>$10143a74d71d9da7$export$9ac3d19711324187);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    const $10143a74d71d9da7$export$9ac3d19711324187 = (0, (0, parcelRequire("cb25w")).default)()(class WithCreateAnalyticsEvent extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return render(createAnalyticsEvent);
        }
    });
});
parcelRegister("iN9lO", function(module, exports) {
    $parcel$export(module.exports, "startMeasure", ()=>$420059dd531814dc$export$b62aa2130c86b59b);
    $parcel$export(module.exports, "stopMeasure", ()=>$420059dd531814dc$export$37c25be427bec097);
    $parcel$export(module.exports, "clearMeasure", ()=>$420059dd531814dc$export$6f766653554dac02);
    var $b7gJe;
    const $420059dd531814dc$var$measureMap = new Map();
    function $420059dd531814dc$export$b62aa2130c86b59b(measureName) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::start`);
        $420059dd531814dc$var$measureMap.set(measureName, performance.now());
    }
    function $420059dd531814dc$export$37c25be427bec097(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        performance.mark(`${measureName}::end`);
        const start = onMeasureComplete ? $420059dd531814dc$var$measureMap.get(measureName) : undefined;
        try {
            performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
        } catch (error) {} finally{
            if (onMeasureComplete) {
                const entry = performance.getEntriesByName(measureName).pop();
                if (entry) onMeasureComplete(entry.duration, entry.startTime);
                else if (start) onMeasureComplete(performance.now() - start, start);
            }
            $420059dd531814dc$export$6f766653554dac02(measureName);
        }
    }
    function $420059dd531814dc$export$6f766653554dac02(measureName) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        $420059dd531814dc$var$measureMap.delete(measureName);
        performance.clearMarks(`${measureName}::start`);
        performance.clearMarks(`${measureName}::end`);
        performance.clearMeasures(measureName);
    }
});
parcelRegister("b7gJe", function(module, exports) {
    $parcel$export(module.exports, "isPerformanceAPIAvailable", ()=>$da51e67df7144cd5$export$b5717a625dd4a3eb);
    $parcel$export(module.exports, "isPerformanceObserverAvailable", ()=>$da51e67df7144cd5$export$48995af1e77d8643);
    let $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
    function $da51e67df7144cd5$export$b5717a625dd4a3eb() {
        if ($da51e67df7144cd5$var$hasRequiredPerformanceAPIs === undefined) $da51e67df7144cd5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType',
            'now'
        ].every((api)=>!!performance[api]);
        return $da51e67df7144cd5$var$hasRequiredPerformanceAPIs;
    }
    function $da51e67df7144cd5$export$48995af1e77d8643() {
        return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
    }
    function $da51e67df7144cd5$export$4370ec0f52022f66() {
        return $da51e67df7144cd5$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
    }
});
parcelRegister("4NUlu", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAppearance", ()=>$d9ce436f8d702318$export$be87849653b93e6b);
    $parcel$export(module.exports, "getAnalyticsEditorAppearance", ()=>$d9ce436f8d702318$export$31ae53e002edded0);
    $parcel$export(module.exports, "getAnalyticsEventSeverity", ()=>$d9ce436f8d702318$export$f8edd689e8b20f3a);
    $parcel$export(module.exports, "analyticsEventKey", ()=>$d9ce436f8d702318$export$288273ee3e3b6132);
    var $d93fQ = parcelRequire("d93fQ");
    const $d9ce436f8d702318$export$be87849653b93e6b = (appearance)=>{
        switch(appearance){
            case 'full-page':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
            case 'full-width':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
            case 'comment':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).COMMENT;
            case 'chromeless':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
            case 'mobile':
                return (0, $d93fQ.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        }
    };
    const $d9ce436f8d702318$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$d9ce436f8d702318$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
    const $d9ce436f8d702318$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
        if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
        if (duration > degradedThreshold) return "blocking";
        return "normal";
    };
    var $d9ce436f8d702318$export$6a6bef12562cd865;
    (function(SEVERITY) {
        SEVERITY["NORMAL"] = "normal";
        SEVERITY["DEGRADED"] = "degraded";
        SEVERITY["BLOCKING"] = "blocking";
    })($d9ce436f8d702318$export$6a6bef12562cd865 || ($d9ce436f8d702318$export$6a6bef12562cd865 = {}));
    const $d9ce436f8d702318$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
});
parcelRegister("fc6h8", function(module, exports) {
    $parcel$export(module.exports, "shouldForceTracking", ()=>$d5e5ded83470406e$export$5b59d3e9e22dbdc6);
    const $d5e5ded83470406e$export$5b59d3e9e22dbdc6 = ()=>{
        try {
            const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
            return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
        } catch (err) {
            console.warn(err);
            return false;
        }
    };
});
parcelRegister("ap7h6", function(module, exports) {
    $parcel$export(module.exports, "getDistortedDurationMonitor", ()=>$3e05ce213e57560b$export$70f7d127254a90c);
    $parcel$export(module.exports, "measureRender", ()=>$3e05ce213e57560b$export$267ed650a5d21ae6);
    var $b7gJe;
    const $3e05ce213e57560b$export$70f7d127254a90c = ()=>{
        if (typeof document === 'undefined') return {
            distortedDuration: false,
            cleanup () {}
        };
        let distortedDuration = document.visibilityState !== 'visible';
        function handleVisibilityChange() {
            if (document.visibilityState !== 'visible') distortedDuration = true;
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return {
            distortedDuration: distortedDuration,
            cleanup () {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            }
        };
    };
    function $3e05ce213e57560b$export$267ed650a5d21ae6(measureName, onMeasureComplete) {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        const startMark = `[START]: ${measureName}`;
        const endMark = `[END]: ${measureName}`;
        const startTime = performance.now();
        performance.mark(startMark);
        let distortedDurationMonitor = $3e05ce213e57560b$export$70f7d127254a90c();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                performance.mark(endMark);
                distortedDurationMonitor.cleanup();
                const duration = performance.now() - startTime;
                try {
                    performance.measure(measureName, startMark, endMark);
                    const entry = performance.getEntriesByName(measureName).pop();
                    if (!entry) onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                    else onMeasureComplete({
                        duration: entry.duration,
                        startTime: entry.startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                } catch (e) {
                    onMeasureComplete({
                        duration: duration,
                        startTime: startTime,
                        distortedDuration: distortedDurationMonitor.distortedDuration
                    });
                }
                performance.clearMeasures(measureName);
                performance.clearMarks(startMark);
                performance.clearMarks(endMark);
            });
        });
    }
});
parcelRegister("gE8f9", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$6911d91f679e4e6c$export$3f2684e5d7cb1006);
    const $6911d91f679e4e6c$export$3f2684e5d7cb1006 = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.mac = /Mac/.test(navigator.platform);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.windows = navigator.userAgentData?.platform === 'Windows' || /Windows|Win\d+/i.test(navigator.userAgent);
        let ie = $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.android = /Android \d/.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $6911d91f679e4e6c$export$3f2684e5d7cb1006.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
});
parcelRegister("kFiBa", function(module, exports) {
    $parcel$export(module.exports, "getResponseEndTime", ()=>$9d05c46136d117ff$export$92d097a1155bbe27);
    var $b7gJe;
    function $9d05c46136d117ff$export$92d097a1155bbe27() {
        if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
        const nav = performance.getEntriesByType('navigation')[0];
        if (nav) return nav.responseEnd;
        return;
    }
});
parcelRegister("4zXba", function(module, exports) {
    $parcel$export(module.exports, "normalizeFeatureFlags", ()=>$e819a2725d93345d$export$f1485fc4974593c0);
    $parcel$export(module.exports, "getEnabledFeatureFlagKeys", ()=>$e819a2725d93345d$export$6d018dd0f6cbebcb);
    var $e4eHl = parcelRequire("e4eHl");
    var $3T6Xo = parcelRequire("3T6Xo");
    const $e819a2725d93345d$var$EMPTY = {};
    function $e819a2725d93345d$var$isObjectFlagKey(key, value, objectFlagKeys) {
        return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
    }
    function $e819a2725d93345d$var$isValidJSONObject(value) {
        try {
            let result = JSON.parse(value);
            if (typeof result === 'object' && result !== null) return true;
            return false;
        } catch (err) {
            return false;
        }
    }
    function $e819a2725d93345d$export$f1485fc4974593c0(rawFeatureFlags, options) {
        if (!rawFeatureFlags) return $e819a2725d93345d$var$EMPTY;
        return Object.entries(rawFeatureFlags).filter((e)=>{
            if (typeof e[1] === 'boolean') return true;
            if ($e819a2725d93345d$var$isObjectFlagKey((0, ($parcel$interopDefault($e4eHl)))(e[0]), e[1], options?.objectFlagKeys) && $e819a2725d93345d$var$isValidJSONObject(e[1])) return true;
            return false;
        }).filter(([key])=>(0, ($parcel$interopDefault($3T6Xo)))(key) === key).map(([key, value])=>[
                (0, ($parcel$interopDefault($e4eHl)))(key),
                value
            ]).reduce((flags, [key, value])=>{
            if ($e819a2725d93345d$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
            if (typeof value === 'boolean') flags[key] = value;
            return flags;
        }, {});
    }
    function $e819a2725d93345d$export$6d018dd0f6cbebcb(featureFlags) {
        return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
    }
});
parcelRegister("9gOVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a549b54270369c2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kCV8T;
    var $gmhCD = parcelRequire("gmhCD");
    var $3kKuL;
    parcelRequire("gJX6d");
    var $5KNWO;
    var $gJX6d;
    var $5BLIh;
    var $cKKwC;
    var $GDkvY;
    var $eQNWQ;
    var $5or39;
    var $K5Jsy;
    var $5r0mK = parcelRequire("5r0mK");
    var $bzwTW;
    var $bVGKe;
    var $h5tvG;
    var $3VpWO;
    function $a549b54270369c2c$var$mergeMarks(marksAndNodes) {
        return marksAndNodes.reduce((acc, markOrNode)=>{
            const prev = acc.length && acc[acc.length - 1] || null;
            if (markOrNode.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && prev && prev.type instanceof (0, (0, parcelRequire("kCV8T")).MarkType) && Array.isArray(prev.content) && (0, (0, parcelRequire("eQNWQ")).isSameMark)(prev, markOrNode)) prev.content = $a549b54270369c2c$var$mergeMarks(prev.content.concat(markOrNode.content));
            else acc.push(markOrNode);
            return acc;
        }, []);
    }
    class $a549b54270369c2c$export$2e2bcd8739ae039 {
        constructor(init){
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.allowCopyToClipboard = false;
            this.allowWrapCodeBlock = false;
            this.allowPlaceholderText = true;
            this.allowCustomPanels = false;
            this.surroundTextNodesWithTextWrapper = false;
            this.allowAnnotations = false;
            this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
                const pos = this.startPos;
                const currentPath = parentInfo && parentInfo.path || [];
                const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
                const nodeKey = `${node.type.name}__${this.startPos}`;
                const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, (0, parcelRequire("gJX6d")).toReact)(node, {
                    allowSelectAllTrap: this.allowSelectAllTrap,
                    allowWindowedCodeBlock: this.allowWindowedCodeBlock
                }, this.nodeComponents), nodeKey, {
                    parentIsIncompleteTask: parentIsIncompleteTask,
                    path: [
                        ...currentPath,
                        node
                    ],
                    pos: this.startPos
                });
                this.startPos = pos + node.nodeSize;
                const marks = node.marks ? [
                    ...node.marks
                ] : [];
                const isMedia = node.type.name === 'media';
                const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
                const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
                return marks.reduceRight((content, mark)=>{
                    if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                    return this.renderMark((0, (0, parcelRequire("GDkvY")).toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
                }, serializedContent);
            };
            this.withMediaMarkProps = (node, mark, defaultProps)=>{
                if (mark.type.name === 'link' && node.type.name === 'media') return {
                    ...defaultProps,
                    isMediaLink: true
                };
                if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                    ...defaultProps,
                    isMediaInline: true
                };
                return defaultProps;
            };
            this.getUnsupportedContentProps = (node)=>{
                return {
                    node: node,
                    dispatchAnalyticsEvent: this.fireAnalyticsEvent
                };
            };
            this.getAnnotationMarkProps = (mark, marksParentPath)=>{
                const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                    if ((0, (0, parcelRequire("cKKwC")).isAnnotationMark)(parent)) return [
                        ...acc,
                        parent.attrs.id
                    ];
                    return acc;
                }, []);
                return {
                    id: mark.attrs.id,
                    annotationType: mark.attrs.annotationType,
                    annotationParentIds: annotationParentIds,
                    allowAnnotations: this.allowAnnotations,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
            };
            this.getMarkProps = (mark, marksParentPath, node)=>{
                if ((0, (0, parcelRequire("cKKwC")).isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
                const { key: key, ...otherAttrs } = mark.attrs;
                const extraProps = {
                    isInline: node?.isInline
                };
                const markSpecificProps = (0, (0, parcelRequire("bVGKe")).isCodeMark)(mark) ? {
                    codeBidiWarningTooltipEnabled: false
                } : {};
                const props = {
                    eventHandlers: this.eventHandlers,
                    fireAnalyticsEvent: this.fireAnalyticsEvent,
                    markKey: key,
                    ...otherAttrs,
                    ...extraProps,
                    ...markSpecificProps,
                    dataAttributes: {
                        'data-renderer-mark': true
                    }
                };
                return props;
            };
            if ((0, $gmhCD.editorExperiment)('comment_on_bodied_extensions', true)) {
                this.initStartPos = init.startPos || 1;
                this.startPos = init.startPos || 1;
            } else {
                this.initStartPos = 1;
                this.startPos = 1;
            }
            this.providers = init.providers;
            this.eventHandlers = init.eventHandlers;
            this.extensionHandlers = init.extensionHandlers;
            this.portal = init.portal;
            this.rendererContext = init.objectContext;
            this.appearance = init.appearance;
            this.disableHeadingIDs = init.disableHeadingIDs;
            this.disableActions = init.disableActions;
            this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
            this.allowCopyToClipboard = init.allowCopyToClipboard;
            this.allowWrapCodeBlock = init.allowWrapCodeBlock;
            this.allowPlaceholderText = init.allowPlaceholderText;
            this.allowCustomPanels = init.allowCustomPanels;
            this.allowColumnSorting = init.allowColumnSorting;
            this.fireAnalyticsEvent = init.fireAnalyticsEvent;
            this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
            this.allowAltTextOnImages = init.allowAltTextOnImages;
            this.stickyHeaders = init.stickyHeaders;
            this.allowMediaLinking = init.allowMediaLinking;
            this.allowAnnotations = Boolean(init.allowAnnotations);
            this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
            this.media = init.media;
            this.emojiResourceConfig = init.emojiResourceConfig;
            this.smartLinks = init.smartLinks;
            this.allowSelectAllTrap = init.allowSelectAllTrap;
            this.nodeComponents = init.nodeComponents;
            this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
            this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
            this.textHighlighter = init.textHighlighter;
            this.allowTableAlignment = init.allowTableAlignment;
            this.allowTableResizing = init.allowTableResizing;
        }
        resetState() {
            this.headingIds = [];
            this.expandHeadingIds = [];
            this.startPos = this.initStartPos;
        }
        getNodeProps(node, parentInfo) {
            const path = parentInfo ? parentInfo.path : undefined;
            switch(node.type.name){
                case 'date':
                    return this.getDateProps(node, parentInfo, path);
                case 'hardBreak':
                    return this.getHardBreakProps(node, path);
                case 'heading':
                    return this.getHeadingProps(node, path);
                case 'media':
                    return this.getMediaProps(node, path);
                case 'emoji':
                    return this.getEmojiProps(node);
                case 'mediaGroup':
                    return this.getMediaGroupProps(node);
                case 'mediaInline':
                    return this.getMediaInlineProps(node);
                case 'mediaSingle':
                    return this.getMediaSingleProps(node, path);
                case 'table':
                    return this.getTableProps(node, path);
                case 'tableHeader':
                case 'tableRow':
                    return this.getTableChildrenProps(node);
                case 'taskItem':
                    return this.getTaskItemProps(node, path);
                case 'embedCard':
                    return this.getEmbedCardProps(node, path);
                case 'blockCard':
                    return this.getBlockCardProps(node, path);
                case 'expand':
                    return this.getExpandProps(node, path);
                case 'unsupportedBlock':
                case 'unsupportedInline':
                    return this.getUnsupportedContentProps(node);
                case 'codeBlock':
                    return this.getCodeBlockProps(node);
                case 'panel':
                    return this.getPanelProps(node);
                default:
                    return this.getProps(node, path);
            }
        }
        serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, (0, parcelRequire("5KNWO")).DocWithSelectAllTrap) : (0, (0, parcelRequire("5KNWO")).default), key = 'root-0', parentInfo) {
            if (key === 'root-0') this.resetState();
            return this.renderNode(target, props, key, $a549b54270369c2c$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
                if ((0, (0, parcelRequire("gJX6d")).isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                    index: index,
                    parentInfo: parentInfo
                });
                return this.serializeFragmentChild(node, {
                    index: index,
                    parentInfo: parentInfo
                });
            }));
        }
        serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
            const currentPath = parentInfo && parentInfo.path || [];
            const nodePosition = parentInfo && parentInfo.pos || 1;
            return $a549b54270369c2c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
                return this.serializeMark({
                    mark: mark,
                    parentNode: {
                        path: currentPath,
                        pos: nodePosition
                    },
                    parentMark: {
                        path: [
                            mark
                        ]
                    }
                });
            });
        }
        serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
            if (!(0, (0, parcelRequire("gJX6d")).isTextNode)(mark)) {
                const serializeContent = (childMark, index)=>this.serializeMark({
                        mark: childMark,
                        parentNode: parentNode,
                        parentMark: {
                            path: [
                                ...parentMark.path,
                                childMark
                            ]
                        }
                    });
                const content = (mark.content || []).map(serializeContent);
                const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
                return this.renderMark((0, (0, parcelRequire("GDkvY")).toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
            }
            const startPos = this.startPos;
            const endPos = startPos + mark.nodeSize;
            this.startPos = endPos;
            const textKey = `text-wrapper_${this.startPos}`;
            if (this.surroundTextNodesWithTextWrapper) {
                const parentDepth = Math.max(parentNode.path.length - 1, 0);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5BLIh")).default), {
                    key: textKey,
                    startPos: startPos + parentDepth,
                    endPos: endPos + parentDepth,
                    textHighlighter: this.textHighlighter,
                    marks: mark.marks
                }, mark.text);
            }
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(mark.text, this.textHighlighter);
            return (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
        }
        renderNode(NodeComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(NodeComponent, {
                key: key,
                ...props
            }, content);
        }
        renderMark(MarkComponent, props, key, content) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement(MarkComponent, {
                key: key,
                ...props
            }, content);
        }
        getTableChildrenProps(node) {
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting
            };
        }
        getTableProps(node, path = []) {
            const stickyHeaders = !(0, (0, parcelRequire("bzwTW")).insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            const isInsideMultiBodiedExtension = (0, (0, parcelRequire("bzwTW")).insideMultiBodiedExtension)(path, node.type.schema);
            return {
                ...this.getProps(node),
                allowColumnSorting: this.allowColumnSorting,
                columnWidths: (0, (0, parcelRequire("5or39")).calcTableColumnWidths)(node),
                tableNode: node,
                stickyHeaders: stickyHeaders,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
                allowTableAlignment: this.allowTableAlignment,
                allowTableResizing: this.allowTableResizing
            };
        }
        getDateProps(node, parentInfo, path = []) {
            return {
                timestamp: node.attrs && node.attrs.timestamp,
                parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
                dataAttributes: {
                    'data-renderer-start-pos': this.startPos + path.length
                }
            };
        }
        getMediaSingleProps(node, path = []) {
            const { marks: { link: link } } = node.type.schema;
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            const isLinkMark = (mark)=>mark.type === link;
            const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
            return {
                ...this.getProps(node, path),
                isInsideOfBlockNode: isInsideOfBlockNode,
                childHasLink: childHasLink,
                allowCaptions: this.media && this.media.allowCaptions,
                featureFlags: this.media && this.media.featureFlags
            };
        }
        getMediaProps(node, path = []) {
            const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
            const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
            const isAnnotationMark = (mark)=>mark.type === annotation;
            const isLinkMark = (mark)=>mark.type === link;
            const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
            return {
                ...this.getProps(node, path),
                marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
                isLinkMark: isLinkMark,
                isBorderMark: isBorderMark,
                isAnnotationMark: isAnnotationMark,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                ssr: this.media?.ssr,
                allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
            };
        }
        getEmojiProps(node) {
            return {
                ...this.getProps(node),
                resourceConfig: this.emojiResourceConfig
            };
        }
        getEmbedCardProps(node, path = []) {
            const isInsideOfBlockNode = (0, (0, parcelRequire("bzwTW")).insideBlockNode)(path, node.type.schema);
            return {
                ...this.getProps(node),
                isInsideOfBlockNode: isInsideOfBlockNode
            };
        }
        getBlockCardProps(node, path = []) {
            return {
                ...this.getProps(node),
                isNodeNested: path.length > 0
            };
        }
        getMediaGroupProps(node) {
            return {
                ...this.getProps(node),
                shouldOpenMediaViewer: this.shouldOpenMediaViewer,
                allowAltTextOnImages: this.allowAltTextOnImages,
                featureFlags: this.media && this.media.featureFlags,
                enableDownloadButton: this.media?.enableDownloadButton,
                ssr: this.media?.ssr
            };
        }
        getMediaInlineProps(node) {
            return {
                ...this.getProps(node),
                ssr: this.media?.ssr
            };
        }
        getTaskItemProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                disabled: this.disableActions
            };
        }
        getHardBreakProps(node, path = []) {
            let forceNewLine = false;
            const parentNode = path.length > 0 ? path[path.length - 1] : null;
            if (parentNode && parentNode.lastChild === node) forceNewLine = true;
            return {
                ...this.getProps(node),
                forceNewLine: forceNewLine
            };
        }
        getCodeBlockProps(node) {
            const codeBidiWarningTooltipEnabled = false;
            return {
                ...this.getProps(node),
                text: node.textContent,
                codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
            };
        }
        getPanelProps(node) {
            return {
                ...this.getProps(node),
                allowCustomPanels: this.allowCustomPanels
            };
        }
        getProps(node, path = []) {
            const startPos = this.startPos + path.length;
            return {
                text: node.text,
                providers: this.providers,
                eventHandlers: this.eventHandlers,
                extensionHandlers: this.extensionHandlers,
                portal: this.portal,
                rendererContext: this.rendererContext,
                serializer: this,
                content: node.content ? node.content.toJSON() : undefined,
                allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
                allowCopyToClipboard: this.allowCopyToClipboard,
                allowWrapCodeBlock: this.allowWrapCodeBlock,
                allowPlaceholderText: this.allowPlaceholderText,
                rendererAppearance: this.appearance,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                nodeType: node.type.name,
                marks: node.marks,
                smartLinks: this.smartLinks,
                isInsideOfInlineExtension: this.isInsideOfInlineExtension,
                dataAttributes: {
                    'data-renderer-start-pos': startPos
                },
                startPos: startPos,
                path: path,
                ...node.attrs
            };
        }
        headingAnchorSupported(path = []) {
            const isImmediateParent = (path, nodeName)=>{
                return path.length > 0 && path[path.length - 1].type.name === nodeName;
            };
            return (0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
        }
        getHeadingProps(node, path = []) {
            return {
                ...this.getProps(node, path),
                content: node.content ? node.content.toJSON() : undefined,
                headingId: this.getHeadingId(node, this.headingIds),
                showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
            };
        }
        getExpandProps(node, path = []) {
            if (!(0, (0, parcelRequire("3kKuL")).isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
            const nestedHeaderIds = (0, $5r0mK.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
            return {
                ...this.getProps(node),
                nestedHeaderIds: nestedHeaderIds
            };
        }
        getHeadingId(node, headingIds) {
            if (this.disableHeadingIDs || !node.content.size) return;
            const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, (0, parcelRequire("K5Jsy")).getText)(node) || ''), '').trim().replace(/\s/g, '-');
            if (!nodeContent) return;
            return this.getUniqueHeadingId(nodeContent, headingIds);
        }
        getUniqueHeadingId(baseId, headingIds, counter = 0) {
            if (counter === 0 && headingIds.indexOf(baseId) === -1) {
                headingIds.push(baseId);
                return baseId;
            } else if (counter !== 0) {
                const headingId = `${baseId}.${counter}`;
                if (headingIds.indexOf(headingId) === -1) {
                    headingIds.push(headingId);
                    return headingId;
                }
            }
            return this.getUniqueHeadingId(baseId, headingIds, ++counter);
        }
        static getChildNodes(fragment) {
            const children = [];
            fragment.forEach((node)=>{
                children.push(node);
            });
            return (0, (0, parcelRequire("gJX6d")).mergeTextNodes)(children);
        }
        static getMarks(node) {
            if (!node.marks || node.marks.length === 0) return [];
            return (0, (0, parcelRequire("eQNWQ")).getMarksByOrder)(node.marks);
        }
        static buildMarkStructure(content) {
            return $a549b54270369c2c$var$mergeMarks(content.map((node)=>{
                const nodeMarks = this.getMarks(node);
                if (nodeMarks.length === 0) return node;
                return nodeMarks.reverse().reduce((acc, mark)=>{
                    const { eq: eq } = mark;
                    return {
                        ...mark,
                        eq: eq,
                        content: [
                            acc
                        ]
                    };
                }, node);
            }));
        }
        static fromSchema(_, init) {
            return new $a549b54270369c2c$export$2e2bcd8739ae039(init);
        }
    }
});
parcelRegister("3kKuL", function(module, exports) {
    $parcel$export(module.exports, "isNestedHeaderLinksEnabled", ()=>$e845fca6b21fd822$export$7aa7587d1ce9583c);
    $parcel$export(module.exports, "getActiveHeadingId", ()=>$e845fca6b21fd822$export$acb253d79d72af92);
    function $e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
        if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
        const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
        return !!allowNestedHeaderLinks;
    }
    function $e845fca6b21fd822$export$acb253d79d72af92(allowHeadingAnchorLinks) {
        if (!$e845fca6b21fd822$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
        return allowHeadingAnchorLinks.activeHeadingId;
    }
});
parcelRegister("gJX6d", function(module, exports) {
    $parcel$export(module.exports, "InlineCard", ()=>$2b5167c1d6aa176d$export$aff6291803939b05);
    $parcel$export(module.exports, "nodeToReact", ()=>$2b5167c1d6aa176d$export$3931063f6a5f290e);
    $parcel$export(module.exports, "toReact", ()=>$2b5167c1d6aa176d$export$d4334b129116aad7);
    $parcel$export(module.exports, "mergeTextNodes", ()=>$2b5167c1d6aa176d$export$8045509d14b5046f);
    $parcel$export(module.exports, "isTextWrapper", ()=>$2b5167c1d6aa176d$export$d4ebd3557ee7fac1);
    $parcel$export(module.exports, "isTextNode", ()=>$2b5167c1d6aa176d$export$ccbedd67ef6e9417);
    $parcel$export(module.exports, "Doc", ()=>(parcelRequire("5KNWO")).default);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>(parcelRequire("5KNWO")).DocWithSelectAllTrap);
    var $4qBtX = parcelRequire("4qBtX");
    var $atrOQ;
    var $4dtZR;
    var $bQeYo;
    var $cOnYv;
    var $cWRvh;
    var $5KNWO;
    var $i8Zwf;
    var $lKIDi;
    var $7AttJ;
    var $112O7;
    var $ieJGA;
    var $3RqVz;
    var $qjsNK;
    var $jHa9U;
    var $6svWT;
    var $9FXQX;
    var $hqBb9;
    var $ixoQV;
    var $dkc63;
    var $cWojJ;
    var $i4Lgj;
    var $gfMkN;
    var $iiXGq;
    var $9kpKZ;
    const $2b5167c1d6aa176d$export$a22ee8f907eecb5f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8BH8p")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6c415d1fdae3dfdb = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6seAF")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$771a55a10b0a40ae = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("xgpzA")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$27c4189b8be1bf93 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("vMisH")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$b458dfa720128865 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("i873P")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$b6f73a2b0b0de599 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("lOJRn")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6341f9a885713487 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6tOdT")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$96e9906d6d93a972 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("hC3g2")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$56cc48506ff790a = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("j2dSX")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$2ddb90ad54e5f587 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("7F34O")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$6789d7ecdc77631b = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("5yCyD")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$aff6291803939b05 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("1lRkv")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("hoG8t")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$7fc53215244aec38 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("BpGvF")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$d7858be3df00d59 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("RmF2p")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("d6mGh")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$888d74bc001c3a5d = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("lFguI")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$e891316fea657d90 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("h4pi8")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$49bd1dfb0ad29c40 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("dZ3Pj")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $2b5167c1d6aa176d$export$3931063f6a5f290e = {
        blockquote: (0, (0, parcelRequire("atrOQ")).default),
        bulletList: (0, (0, parcelRequire("cWRvh")).default),
        blockCard: $2b5167c1d6aa176d$export$d18ccd25c0d2c6b0,
        caption: (0, (0, parcelRequire("jHa9U")).default),
        date: $2b5167c1d6aa176d$export$6341f9a885713487,
        decisionItem: $2b5167c1d6aa176d$export$b6f73a2b0b0de599,
        decisionList: $2b5167c1d6aa176d$export$b458dfa720128865,
        doc: (0, (0, parcelRequire("5KNWO")).default),
        emoji: $2b5167c1d6aa176d$export$56cc48506ff790a,
        extension: (0, (0, parcelRequire("i8Zwf")).default),
        bodiedExtension: (0, (0, parcelRequire("4dtZR")).default),
        multiBodiedExtension: (0, (0, parcelRequire("bQeYo")).default),
        extensionFrame: (0, (0, parcelRequire("cOnYv")).default),
        hardBreak: (0, (0, parcelRequire("lKIDi")).default),
        heading: (0, (0, parcelRequire("7AttJ")).default),
        inlineCard: $2b5167c1d6aa176d$export$aff6291803939b05,
        inlineExtension: (0, (0, parcelRequire("112O7")).default),
        layoutSection: (0, (0, parcelRequire("ieJGA")).default),
        layoutColumn: (0, (0, parcelRequire("3RqVz")).default),
        listItem: (0, (0, parcelRequire("qjsNK")).default),
        media: $2b5167c1d6aa176d$export$7fc53215244aec38,
        mediaGroup: $2b5167c1d6aa176d$export$d7858be3df00d59,
        mediaInline: $2b5167c1d6aa176d$export$462ea7c2a1c4cb1f,
        mediaSingle: $2b5167c1d6aa176d$export$888d74bc001c3a5d,
        mention: $2b5167c1d6aa176d$export$e891316fea657d90,
        orderedList: (0, (0, parcelRequire("6svWT")).default),
        panel: $2b5167c1d6aa176d$export$2ddb90ad54e5f587,
        paragraph: (0, (0, parcelRequire("9FXQX")).default),
        placeholder: (0, (0, parcelRequire("hqBb9")).default),
        rule: (0, (0, parcelRequire("ixoQV")).default),
        status: $2b5167c1d6aa176d$export$96e9906d6d93a972,
        taskItem: $2b5167c1d6aa176d$export$27c4189b8be1bf93,
        taskList: $2b5167c1d6aa176d$export$771a55a10b0a40ae,
        table: (0, (0, parcelRequire("dkc63")).default),
        tableCell: (0, (0, parcelRequire("cWojJ")).TableCell),
        tableHeader: (0, (0, parcelRequire("cWojJ")).TableHeader),
        tableRow: (0, (0, parcelRequire("i4Lgj")).default),
        unknownBlock: (0, (0, parcelRequire("gfMkN")).default),
        unsupportedBlock: (0, (0, parcelRequire("iiXGq")).default),
        unsupportedInline: (0, (0, parcelRequire("9kpKZ")).default),
        expand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
        nestedExpand: $2b5167c1d6aa176d$export$49bd1dfb0ad29c40,
        embedCard: $2b5167c1d6aa176d$export$6789d7ecdc77631b
    };
    const $2b5167c1d6aa176d$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
        if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, (0, parcelRequire("5KNWO")).DocWithSelectAllTrap;
        if (node.type.name === 'codeBlock') {
            if (flags?.allowWindowedCodeBlock === true) return $2b5167c1d6aa176d$export$a22ee8f907eecb5f;
            return $2b5167c1d6aa176d$export$6c415d1fdae3dfdb;
        }
        const nodes = {
            ...$2b5167c1d6aa176d$export$3931063f6a5f290e,
            ...nodeComponents
        };
        return nodes[node.type.name];
    };
    const $2b5167c1d6aa176d$export$8045509d14b5046f = (nodes)=>{
        return nodes.reduce((acc, current)=>{
            if (!$2b5167c1d6aa176d$export$1879817ac5c922b7(current.type.name)) {
                acc.push(current);
                return acc;
            }
            if (acc.length > 0 && $2b5167c1d6aa176d$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
                const textWrapper = acc[acc.length - 1];
                textWrapper.content.push(current);
                textWrapper.nodeSize += current.nodeSize;
            } else acc.push({
                type: {
                    name: 'textWrapper'
                },
                content: [
                    current
                ],
                nodeSize: current.nodeSize
            });
            return acc;
        }, []);
    };
    const $2b5167c1d6aa176d$export$1879817ac5c922b7 = (type)=>{
        return type === 'text';
    };
    const $2b5167c1d6aa176d$export$d4ebd3557ee7fac1 = (node)=>{
        return node.type.name === 'textWrapper';
    };
    function $2b5167c1d6aa176d$export$ccbedd67ef6e9417(node) {
        return node.type.name === 'text';
    }
    const $2b5167c1d6aa176d$var$whitespaceRegex = /^\s*$/;
    const $2b5167c1d6aa176d$export$dd0c7365db1f79a5 = (doc)=>{
        if (doc.childCount !== 1) return false;
        const parentNodes = [];
        doc.forEach((child)=>parentNodes.push(child));
        const node = parentNodes[0];
        return node.type.name === 'paragraph' && $2b5167c1d6aa176d$var$isEmojiBlock(node.content);
    };
    const $2b5167c1d6aa176d$var$isEmojiBlock = (pnode)=>{
        const content = [];
        if (pnode.childCount > 7) return false;
        pnode.forEach((child)=>content.push(child));
        let emojiCount = 0;
        for(let i = 0; i < content.length; ++i){
            const node = content[i];
            switch(node.type.name){
                case 'text':
                    if (node.text && !node.text.match($2b5167c1d6aa176d$var$whitespaceRegex)) return false;
                    continue;
                case 'emoji':
                    if (++emojiCount > 3) return false;
                    continue;
                default:
                    return false;
            }
        }
        return emojiCount > 0;
    };
});
parcelRegister("atrOQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d51d57a125840f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8d51d57a125840f5$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("blockquote", null, props.children);
    }
});
parcelRegister("4dtZR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9e9d2beaec6b895$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $i8Zwf;
    var $8Eu7T;
    var $fAZXL;
    var $cWCI0;
    var $gkwXh;
    var $4YrGg;
    const $b9e9d2beaec6b895$var$BodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Eu7T")).ErrorBoundary), {
            component: (0, (0, parcelRequire("cWCI0")).ACTION_SUBJECT).RENDERER,
            componentId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EXTENSION_BODIED,
            createAnalyticsEvent: createAnalyticsEvent,
            additionalInfo: `${extensionType}: ${extensionKey} `
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YrGg")).AnnotationsPositionContext).Provider, {
            value: {
                startPos: props.startPos + 1
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "bodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("i8Zwf")).renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                }, removeOverflow);
            } catch (e) {}
            return (0, (0, parcelRequire("i8Zwf")).renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        })));
    };
    var $b9e9d2beaec6b895$export$2e2bcd8739ae039 = $b9e9d2beaec6b895$var$BodiedExtension;
});
parcelRegister("i8Zwf", function(module, exports) {
    $parcel$export(module.exports, "renderExtension", ()=>$1a97cbb70a611ae8$export$b7482bdc8aff85e4);
    $parcel$export(module.exports, "default", ()=>$1a97cbb70a611ae8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fAZXL;
    var $ajc8Z;
    var $4ceoy;
    var $eOOFp;
    var $l8Gxi;
    const $1a97cbb70a611ae8$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const { isTopLevel: isTopLevel = true } = options || {};
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: options.handleRef,
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: overflowContainerClass
            }, content)));
    };
    const $1a97cbb70a611ae8$var$Extension = (props)=>{
        const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "extension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(result, layout, {
                    isTopLevel: path.length < 1,
                    handleRef: handleRef,
                    shadowClassNames: shadowClassNames
                });
            } catch (e) {}
            return $1a97cbb70a611ae8$export$b7482bdc8aff85e4(text || 'extension', layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        });
    };
    var $1a97cbb70a611ae8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ajc8Z")).default)($1a97cbb70a611ae8$var$Extension, {
        overflowSelector: `.${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    });
});
parcelRegister("fAZXL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45cce7a6859f4709$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $gnH2s;
    var $9Egzu;
    var $2vGdQ;
    const $45cce7a6859f4709$var$inlineExtensionStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        maxWidth: '100%',
        verticalAlign: 'middle',
        margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
        '& .rich-media-item': {
            maxWidth: '100%'
        }
    });
    function $45cce7a6859f4709$export$2e2bcd8739ae039(props) {
        const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
        const isMounted = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        const localGetNodeRenderer = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>(0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("gnH2s")).getNodeRenderer)), []);
        const [extensionProvider, setExtensionProvider] = (0, ($parcel$interopDefault($5uXOq))).useState(null);
        const handleProvider = (0, ($parcel$interopDefault($5uXOq))).useCallback((name, providerPromise)=>{
            providerPromise && providerPromise.then((provider)=>{
                if (isMounted.current) setExtensionProvider(provider);
            });
        }, []);
        const renderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((extensionProvider)=>{
            const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const node = {
                type: type,
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content || text,
                localId: localId,
                fragmentLocalId: fragmentLocalId
            };
            let result = null;
            try {
                if (extensionHandlers && extensionHandlers[extensionType]) {
                    const render = (0, (0, parcelRequire("2vGdQ")).getExtensionRenderer)(extensionHandlers[extensionType]);
                    result = render(node, rendererContext.adDoc);
                }
                if (!result && extensionProvider) {
                    const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                    if (node.type === 'multiBodiedExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node,
                        actions: actions
                    });
                    else if (node.type === 'inlineExtension') result = (0, (0, parcelRequire("f8Sb3")).jsx)($45cce7a6859f4709$var$InlineNodeRendererWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = (0, (0, parcelRequire("f8Sb3")).jsx)(NodeRenderer, {
                        node: node
                    });
                }
            } catch (e) {}
            return children({
                result: result
            });
        }, [
            actions,
            children,
            content,
            extensionHandlers,
            extensionKey,
            extensionType,
            localGetNodeRenderer,
            localId,
            marks,
            parameters,
            rendererContext?.adDoc,
            text,
            type
        ]);
        const setupAndRenderExtensionNode = (0, ($parcel$interopDefault($5uXOq))).useCallback((providers)=>{
            if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
            return renderExtensionNode(extensionProvider);
        }, [
            extensionProvider,
            handleProvider,
            renderExtensionNode
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, []);
        if (!props.providers) return setupAndRenderExtensionNode({});
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Egzu")).WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: props.providers,
            renderNode: setupAndRenderExtensionNode
        });
    }
    const $45cce7a6859f4709$var$InlineNodeRendererWrapper = ({ children: children })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: "inline-extension-renderer",
            css: $45cce7a6859f4709$var$inlineExtensionStyle
        }, children));
    };
});
parcelRegister("gnH2s", function(module, exports) {
    $parcel$export(module.exports, "getExtensionModuleNode", ()=>$36d4284a17bc60a0$export$82dd45c2db936caf);
    $parcel$export(module.exports, "getExtensionModuleNodePrivateProps", ()=>$36d4284a17bc60a0$export$426f8efd8690d8aa);
    $parcel$export(module.exports, "getNodeRenderer", ()=>$36d4284a17bc60a0$export$67a7d49db68d30a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $izxHQ;
    async function $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
        const [extKey, nodeKey] = (0, (0, parcelRequire("izxHQ")).getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const manifest = await extensionProvider.getExtension(extensionType, extKey);
        if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
        if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
        const node = manifest.modules.nodes[nodeKey];
        if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
        return node;
    }
    async function $36d4284a17bc60a0$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
        const moduleNode = await $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
        return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
            acc[key] = moduleNode[key];
            return acc;
        }, {});
    }
    function $36d4284a17bc60a0$var$ExtensionLoading(props) {
        if (props.error || props.timedOut) {
            console.error('Error rendering extension', props.error);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, "Error loading the extension!");
        } else return null;
    }
    function $36d4284a17bc60a0$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>{
                return $36d4284a17bc60a0$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, (0, parcelRequire("izxHQ")).resolveImport)(node.render()));
            },
            loading: $36d4284a17bc60a0$var$ExtensionLoading
        });
    }
});
parcelRegister("izxHQ", function(module, exports) {
    $parcel$export(module.exports, "getExtensionKeyAndNodeKey", ()=>$23c4e3f9598df846$export$8a49818572e1d105);
    $parcel$export(module.exports, "buildAction", ()=>$23c4e3f9598df846$export$bb33bcdd9a10a608);
    $parcel$export(module.exports, "resolveImport", ()=>$23c4e3f9598df846$export$d69c9b451c47653b);
    const $23c4e3f9598df846$export$a7d04c836550045a = 'com.atlassian.ecosystem';
    const $23c4e3f9598df846$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
        if (extensionType === $23c4e3f9598df846$export$a7d04c836550045a) return [
            extensionKey,
            'default'
        ];
        const [extKey, nodeKey = 'default'] = extensionKey.split(':');
        return [
            extKey,
            nodeKey
        ];
    };
    const $23c4e3f9598df846$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
        if (!nodeKey || nodeKey === 'default') return extensionKey;
        return `${extensionKey}:${nodeKey}`;
    };
    function $23c4e3f9598df846$export$bb33bcdd9a10a608(action, manifest) {
        if (typeof action === 'function') return action;
        if (action.type === 'node' && manifest.modules.nodes) return $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest);
    }
    const $23c4e3f9598df846$export$d69c9b451c47653b = async (importPromise)=>{
        const importedModule = await importPromise;
        return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
    };
    function $23c4e3f9598df846$export$33863d887d6f4bfd(action, manifest) {
        if (!manifest.modules.nodes) return;
        const node = manifest.modules.nodes[action.key];
        const extensionKey = $23c4e3f9598df846$export$5f3eb042babacbbd(manifest.key, action.key);
        const extension = {
            type: node.type,
            attrs: {
                extensionType: manifest.type,
                extensionKey: extensionKey,
                parameters: action.parameters
            }
        };
        if (node.type === 'bodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'paragraph',
                    content: []
                }
            ]
        };
        else if (node.type === 'multiBodiedExtension') return {
            ...extension,
            content: [
                {
                    type: 'extensionFrame',
                    content: [
                        {
                            type: 'paragraph',
                            content: []
                        }
                    ]
                }
            ]
        };
        return extension;
    }
});
parcelRegister("9Egzu", function(module, exports) {
    $parcel$export(module.exports, "WithProviders", ()=>$76144329c6f313cf$export$d498ee8be33e096f);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    class $76144329c6f313cf$export$d498ee8be33e096f extends (0, $5uXOq.PureComponent) {
        static{
            this.displayName = 'WithProviders';
        }
        constructor(props){
            super(props), this.mounted = false, this.handleProviderIfMounted = (name, provider)=>{
                if (!this.mounted) return;
                this.handleProvider(name, provider);
            }, this.handleProvider = (name, provider)=>{
                this.setState(({ providers: providers })=>{
                    return {
                        providers: {
                            ...providers,
                            [name]: provider
                        }
                    };
                });
            };
            this.mounted = false;
            const providers = {};
            this.props.providers.forEach((name)=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) {
                    const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
                    providers[name] = providerPromise;
                } else providers[name] = undefined;
            });
            this.state = {
                providers: providers
            };
        }
        componentDidMount() {
            this.mounted = true;
        }
        UNSAFE_componentWillMount() {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) {
                const { providers: providers, providerFactory: providerFactory } = this.props;
                providers.forEach((name)=>{
                    providerFactory.subscribe(name, this.handleProvider);
                });
            }
        }
        componentWillUnmount() {
            const { providers: providers, providerFactory: providerFactory } = this.props;
            providers.forEach((name)=>{
                providerFactory.unsubscribe(name, this.handleProvider);
            });
        }
        render() {
            const { state: state, props: props } = this;
            const { renderNode: renderNode } = props;
            return renderNode(state.providers);
        }
    }
});
parcelRegister("2vGdQ", function(module, exports) {
    $parcel$export(module.exports, "getExtensionRenderer", ()=>$f7ce50c6d2d400b7$export$9214452ef07eda7);
    function $f7ce50c6d2d400b7$export$9214452ef07eda7(extensionHandler) {
        if (typeof extensionHandler === 'object') return extensionHandler.render;
        else return extensionHandler;
    }
});
parcelRegister("ajc8Z", function(module, exports) {
    $parcel$export(module.exports, "shadowClassNames", ()=>$0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5);
    $parcel$export(module.exports, "default", ()=>$0d6cb6e0383d0ba0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bbl9Y;
    const $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5 = {
        RIGHT_SHADOW: 'right-shadow',
        LEFT_SHADOW: 'left-shadow'
    };
    function $0d6cb6e0383d0ba0$export$2e2bcd8739ae039(Component, options) {
        return class OverflowShadow extends (0, ($parcel$interopDefault($5uXOq))).Component {
            componentWillUnmount() {
                if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
                if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
                this.updateShadows();
            }
            componentDidUpdate() {
                if (!options.useShadowObserver) this.updateShadows();
            }
            initShadowObserver() {
                if (this.shadowObserver || !this.overflowContainer) return;
                this.shadowObserver = new (0, (0, parcelRequire("bbl9Y")).ShadowObserver)({
                    scrollContainer: this.overflowContainer,
                    onUpdateShadows: (shadowStates)=>{
                        this.setState((prevState)=>{
                            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                            if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                                showLeftShadow: showLeftShadow,
                                showRightShadow: showRightShadow
                            };
                            return null;
                        });
                    }
                });
            }
            render() {
                const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
                let classNames = [
                    showRightShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                    showLeftShadow && $0d6cb6e0383d0ba0$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                    options.useShadowObserver && (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SHADOW_CONTAINER
                ].filter(Boolean).join(' ');
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    handleRef: this.handleContainer,
                    shadowClassNames: classNames,
                    ...this.props
                });
            }
            constructor(...args){
                super(...args), this.overflowContainerWidth = 0, this.state = {
                    showLeftShadow: false,
                    showRightShadow: false
                }, this.handleScroll = (event)=>{
                    if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                    this.updateShadows();
                }, this.updateShadows = ()=>{
                    if (options.useShadowObserver) return;
                    this.setState((prevState)=>{
                        if (!this.overflowContainer) return;
                        const diff = this.calcOverflowDiff();
                        const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                        const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }, this.showLeftShadow = (overflowContainer)=>{
                    return !!overflowContainer && overflowContainer.scrollLeft > 0;
                }, this.calcOverflowDiff = ()=>{
                    if (!this.overflowContainer) return 0;
                    this.diff = this.calcScrollableWidth();
                    return this.diff - this.overflowContainer.offsetWidth;
                }, this.calcScrollableWidth = ()=>{
                    if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                    if (!this.scrollable) return 0;
                    let width = 0;
                    for(let i = 0; i < this.scrollable.length; i++){
                        const scrollableElement = this.scrollable[i];
                        width += scrollableElement.scrollWidth;
                    }
                    return width;
                }, this.handleContainer = (container)=>{
                    if (!container || this.container) return;
                    this.container = container;
                    this.overflowContainer = container.querySelector(options.overflowSelector);
                    if (!this.overflowContainer) this.overflowContainer = container;
                    if (options.useShadowObserver) {
                        this.initShadowObserver();
                        return;
                    }
                    this.updateShadows();
                    this.overflowContainer.addEventListener('scroll', this.handleScroll);
                };
            }
        };
    }
});
parcelRegister("bbl9Y", function(module, exports) {
    $parcel$export(module.exports, "shadowObserverClassNames", ()=>$cd027df5593f4e8b$export$1cbe0bb16052178d);
    $parcel$export(module.exports, "ShadowObserver", ()=>$cd027df5593f4e8b$export$51a5b28e4fb2dba2);
    var $cd027df5593f4e8b$export$ebeea2fe2e93862e;
    (function(ShadowKeys) {
        ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
        ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    })($cd027df5593f4e8b$export$ebeea2fe2e93862e || ($cd027df5593f4e8b$export$ebeea2fe2e93862e = {}));
    const $cd027df5593f4e8b$export$1cbe0bb16052178d = {
        SENTINEL_LEFT: 'sentinel-left',
        SENTINEL_RIGHT: 'sentinel-right',
        SHADOW_CONTAINER: 'with-shadow-observer'
    };
    const $cd027df5593f4e8b$var$requestIdleCallback = (fn)=>{
        return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
    };
    const $cd027df5593f4e8b$var$cancelIdleCallback = (id)=>{
        return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
    };
    class $cd027df5593f4e8b$export$51a5b28e4fb2dba2 {
        constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
            this.sentinels = {};
            this.shadowStates = {
                ["showLeftShadow"]: false,
                ["showRightShadow"]: false
            };
            this.init = ()=>{
                if (!this.scrollContainer || this.intersectionObserver) return;
                this.sentinels.right = document.createElement('div');
                this.sentinels.right.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT);
                this.scrollContainer.appendChild(this.sentinels.right);
                this.sentinels.left = document.createElement('div');
                this.sentinels.left.classList.add($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT);
                this.scrollContainer.prepend(this.sentinels.left);
                this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                    entries.forEach(this.onIntersect);
                }, {
                    root: this.scrollContainer,
                    rootMargin: '1px'
                });
                this.intersectionObserver.observe(this.sentinels.left);
                this.intersectionObserver.observe(this.sentinels.right);
            };
            this.onIntersect = (entry)=>{
                this.requestCallbackId = $cd027df5593f4e8b$var$requestIdleCallback(()=>{
                    if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                    if (entry.target.classList.contains($cd027df5593f4e8b$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                    this.onUpdateShadows(this.shadowStates);
                });
            };
            this.scrollContainer = scrollContainer;
            this.onUpdateShadows = onUpdateShadows;
            this.init();
        }
        dispose() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = undefined;
                this.requestCallbackId && $cd027df5593f4e8b$var$cancelIdleCallback(this.requestCallbackId);
            }
        }
    }
});
parcelRegister("eOOFp", function(module, exports) {
    $parcel$export(module.exports, "breakoutConsts", ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c);
    $parcel$export(module.exports, "absoluteBreakoutWidth", ()=>$081c5ce54850cd88$export$b34ea040d1533a3);
    $parcel$export(module.exports, "calcWideWidth", ()=>$081c5ce54850cd88$export$86325001fe8f3adc);
    $parcel$export(module.exports, "calcBreakoutWidth", ()=>$081c5ce54850cd88$export$5f4502874a28dfce);
    $parcel$export(module.exports, "calcBreakoutWithCustomWidth", ()=>$081c5ce54850cd88$export$ccc0a02edddeed39);
    $parcel$export(module.exports, "calculateBreakoutStyles", ()=>$081c5ce54850cd88$export$c377853ecdd53e5b);
    $parcel$export(module.exports, "calcBreakoutWidthPx", ()=>$081c5ce54850cd88$export$586300c53bd298dd);
    $parcel$export(module.exports, "getNextBreakoutMode", ()=>$081c5ce54850cd88$export$7eb758567e6644fd);
    $parcel$export(module.exports, "getTitle", ()=>$081c5ce54850cd88$export$70d1bf7729efff40);
    var $iHYdz;
    var $8DYpW;
    var $9Iju4;
    var $4ceoy;
    var $eQcNy;
    const $081c5ce54850cd88$export$ead1fecec2ecf57c = {
        padding: (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding),
        defaultLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth),
        wideScaleRatio: (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio),
        fullWidthLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth),
        wideLayoutWidth: (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth),
        mapBreakpointToLayoutMaxWidth: (0, parcelRequire("9Iju4")).mapBreakpointToLayoutMaxWidth,
        getBreakpoint: (0, parcelRequire("4ceoy")).getBreakpoint,
        calcBreakoutWidth: (layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    let wideWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $081c5ce54850cd88$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
        calcLineLength: ()=>$081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth,
        calcWideWidth: (containerWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? $081c5ce54850cd88$export$ead1fecec2ecf57c.padding);
            const layoutMaxWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $081c5ce54850cd88$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
    };
    const $081c5ce54850cd88$export$b34ea040d1533a3 = (layout, containerWidth)=>{
        const breakoutWidth = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
        if (breakoutWidth.endsWith('%')) switch(layout){
            case 'full-width':
                return 0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth;
            default:
                return $081c5ce54850cd88$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($081c5ce54850cd88$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        }
        return parseInt(breakoutWidth, 10);
    };
    const $081c5ce54850cd88$export$86325001fe8f3adc = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcWideWidth;
    const $081c5ce54850cd88$export$5f4502874a28dfce = $081c5ce54850cd88$export$ead1fecec2ecf57c.calcBreakoutWidth;
    const $081c5ce54850cd88$export$ccc0a02edddeed39 = (mode, width, editorContainerWidth)=>{
        if (width !== null && width > 0) {
            const effectiveFullWidth = editorContainerWidth - $081c5ce54850cd88$export$ead1fecec2ecf57c.padding;
            return `${Math.min(width, effectiveFullWidth)}px`;
        }
        return $081c5ce54850cd88$export$5f4502874a28dfce(mode, editorContainerWidth);
    };
    function $081c5ce54850cd88$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
        const breakoutWidth = $081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth);
        const breakoutWidthPx = (0, (0, parcelRequire("eQcNy")).parsePx)(breakoutWidth);
        if (!widthStateLineLength) return {
            type: 'line-length-unknown',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            display: 'flex',
            justifyContent: 'center',
            transform: 'none',
            transition: `min-width 0.5s ${0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier}`
        };
        return {
            type: 'line-length-known',
            width: breakoutWidth,
            minWidth: breakoutWidthPx,
            transition: `min-width 0.5s ${0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier}`,
            transform: `translateX(-50%)`,
            marginLeft: `50%`
        };
    }
    function $081c5ce54850cd88$export$586300c53bd298dd(mode, widthStateWidth, padding) {
        return (0, (0, parcelRequire("eQcNy")).parsePx)($081c5ce54850cd88$export$5f4502874a28dfce(mode, widthStateWidth, padding));
    }
    const $081c5ce54850cd88$export$7eb758567e6644fd = (currentMode)=>{
        if (currentMode === 'full-width') return 'center';
        else if (currentMode === 'wide') return 'full-width';
        return 'wide';
    };
    const $081c5ce54850cd88$export$70d1bf7729efff40 = (layout)=>{
        switch(layout){
            case 'full-width':
                return (0, (0, parcelRequire("8DYpW")).default).layoutFixedWidth;
            case 'wide':
                return (0, (0, parcelRequire("8DYpW")).default).layoutFullWidth;
            default:
                return (0, (0, parcelRequire("8DYpW")).default).layoutWide;
        }
    };
});
parcelRegister("8DYpW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb832a3bfaa1d66d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $l9HLU;
    var $8cp3a;
    var $9NKqk;
    var $fJyLQ;
    var $gSYO9;
    var $jDuvE;
    var $lQKNV;
    var $2i4K4;
    var $eX53M;
    var $80CM7;
    var $kXnoC;
    var $eDTMN;
    var $2V0EL;
    var $kFJBG;
    var $7S9ZN;
    var $6OcHr;
    var $dbepQ;
    var $kANLZ;
    var $kmmxF;
    var $80TXs;
    var $9QBHe;
    var $kAM3u;
    var $6lWmZ;
    var $ixwvf;
    var $fJm1A;
    var $ecAvy;
    var $7ywdr;
    var $1ElKj;
    var $3AEXe;
    var $eb832a3bfaa1d66d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        layoutFixedWidth: {
            id: 'fabric.editor.layoutFixedWidth',
            defaultMessage: 'Back to center',
            description: 'Display your element (image, table, extension, etc) as standard width'
        },
        layoutWide: {
            id: 'fabric.editor.layoutWide',
            defaultMessage: 'Go wide',
            description: 'Display your element (image, table, extension, etc) wider than normal'
        },
        layoutFullWidth: {
            id: 'fabric.editor.layoutFullWidth',
            defaultMessage: 'Go full width',
            description: 'Display your element (image, table, extension, etc) as full width'
        },
        alignImageRight: {
            id: 'fabric.editor.alignImageRight',
            defaultMessage: 'Align right',
            description: 'Aligns image to the right'
        },
        alignImageCenter: {
            id: 'fabric.editor.alignImageCenter',
            defaultMessage: 'Align center',
            description: 'Aligns image to the center'
        },
        alignImageLeft: {
            id: 'fabric.editor.alignImageLeft',
            defaultMessage: 'Align left',
            description: 'Aligns image to the left'
        },
        remove: {
            id: 'fabric.editor.remove',
            defaultMessage: 'Remove',
            description: 'Delete the element (image, panel, table, etc.) from your document'
        },
        removeEmoji: {
            id: 'fabric.editor.removeEmoji',
            defaultMessage: 'Remove emoji',
            description: 'Remove the emoji panel icon from custom panel'
        },
        visit: {
            id: 'fabric.editor.visit',
            defaultMessage: 'Open link in a new window',
            description: 'Open the link in a new window'
        },
        inviteToEditButtonTitle: {
            id: 'fabric.editor.editMode.inviteToEditButton.title',
            defaultMessage: 'Invite to edit',
            description: 'Invite another user to edit the current document'
        },
        saveButton: {
            id: 'fabric.editor.saveButton',
            defaultMessage: 'Save',
            description: 'Submit and save a comment or document'
        },
        cancelButton: {
            id: 'fabric.editor.cancelButton',
            defaultMessage: 'Cancel',
            description: 'Discard the current comment or document'
        },
        taskList: {
            id: 'fabric.editor.tooltip.taskList',
            defaultMessage: 'an action item',
            description: 'an action item in the Editor'
        },
        bulletList: {
            id: 'fabric.editor.tooltip.bulletList',
            defaultMessage: 'a list',
            description: 'a list item in the Editor'
        },
        nestedExpand: {
            id: 'fabric.editor.tooltip.nestedExpand',
            defaultMessage: 'a nested expand',
            description: 'expand node which is nested'
        },
        decisionList: {
            id: 'fabric.editor.tooltip.decisionList',
            defaultMessage: 'a decision list',
            description: 'a list of decisions'
        },
        defaultBlockNode: {
            id: 'fabric.editor.tooltip.defaultBlockNode',
            defaultMessage: 'a block node',
            description: 'a block node element'
        },
        panel: {
            id: 'fabric.editor.tooltip.blockPanel',
            defaultMessage: 'a panel',
            description: 'Panel node in the Editor'
        },
        blockquote: {
            id: 'fabric.editor.blockquote',
            defaultMessage: 'a quote',
            description: 'a quote node'
        },
        timeUpdated: {
            id: 'fabric.editor.time.updated',
            defaultMessage: 'Updated',
            description: 'Time last updated'
        },
        timeViewed: {
            id: 'fabric.editor.time.viewed',
            defaultMessage: 'Viewed',
            description: 'Time last viewed'
        },
        timeAgo: {
            id: 'fabric.editor.time.ago',
            defaultMessage: 'ago',
            description: 'Some time ago'
        },
        copyToClipboard: {
            id: 'fabric.editor.copyToClipboard',
            defaultMessage: 'Copy',
            description: 'Copy the whole content of the element to your clipboard'
        },
        copiedToClipboard: {
            id: 'fabric.editor.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the whole content of the element to clipboard'
        }
    });
});
parcelRegister("l9HLU", function(module, exports) {
    $parcel$export(module.exports, "alignmentMessages", ()=>$c0194801a7a2c28d$export$5229ffea355cfdf6);
    var $7VHMR;
    const $c0194801a7a2c28d$export$5229ffea355cfdf6 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        alignment: {
            id: 'fabric.editor.alignment',
            defaultMessage: 'Text alignment',
            description: 'Opens drop down menu of options to configure text alignment'
        },
        alignLeft: {
            id: 'fabric.editor.alignLeft',
            defaultMessage: 'Align left',
            description: 'label stating that text is aligned left'
        },
        alignCenter: {
            id: 'fabric.editor.alignCenter',
            defaultMessage: 'Align center',
            description: 'label stating that text is aligned center'
        },
        alignRight: {
            id: 'fabric.editor.alignRight',
            defaultMessage: 'Align right',
            description: 'label stating that text is aligned right'
        }
    });
});
parcelRegister("8cp3a", function(module, exports) {
    $parcel$export(module.exports, "annotationMessages", ()=>$0f161f19f888f3d2$export$ff612ca71703201d);
    var $7VHMR;
    const $0f161f19f888f3d2$export$ff612ca71703201d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createComment: {
            id: 'fabric.editor.createComment',
            defaultMessage: 'Comment',
            description: 'Create/add an inline comment based on the users selection'
        },
        createCommentInvalid: {
            id: 'fabric.editor.createCommentInvalid',
            defaultMessage: 'You can only comment on text and headings',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        createCommentDisabled: {
            id: 'fabric.editor.createCommentDisabled',
            defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
            description: 'Error message to communicate to the user they can only do the current action in certain contexts'
        },
        toolbar: {
            id: 'fabric.editor.annotationToolbar',
            defaultMessage: 'Annotation toolbar',
            description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
        },
        createCommentOnInlineNodeSpotlightBody: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.body',
            defaultMessage: 'You can now leave comments on inline elements like links, dates, statuses and mentions.',
            description: 'The body content of the spotlight message that appears when the user can leave comments on inline nodes'
        },
        createCommentOnInlineNodeSpotlightAction: {
            id: 'fabric.editor.createCommentOnInlineNodeSpotlight.action',
            defaultMessage: 'Got it',
            description: 'The content of the action button that closes the spotlight'
        }
    });
});
parcelRegister("9NKqk", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f845f8650b83fa4e$export$defe85febe8b728c);
    var $7VHMR;
    const $f845f8650b83fa4e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        normal: {
            id: 'fabric.editor.normal',
            defaultMessage: 'Normal text',
            description: 'This is the default text style'
        },
        heading1: {
            id: 'fabric.editor.heading1',
            defaultMessage: 'Heading 1',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading1Description: {
            id: 'fabric.editor.heading1Description',
            defaultMessage: 'Use this for a top level heading',
            description: 'Description of the main heading, heading 1'
        },
        heading2: {
            id: 'fabric.editor.heading2',
            defaultMessage: 'Heading 2',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading2Description: {
            id: 'fabric.editor.heading2Description',
            defaultMessage: 'Use this for key sections',
            description: 'Description of a subtitle heading or secondary heading'
        },
        heading3: {
            id: 'fabric.editor.heading3',
            defaultMessage: 'Heading 3',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading3Description: {
            id: 'fabric.editor.heading3Description',
            defaultMessage: 'Use this for sub sections and group headings',
            description: ''
        },
        heading4: {
            id: 'fabric.editor.heading4',
            defaultMessage: 'Heading 4',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading4Description: {
            id: 'fabric.editor.heading4Description',
            defaultMessage: 'Use this for deep headings',
            description: ''
        },
        heading5: {
            id: 'fabric.editor.heading5',
            defaultMessage: 'Heading 5',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading5Description: {
            id: 'fabric.editor.heading5Description',
            defaultMessage: 'Use this for grouping list items',
            description: ''
        },
        heading6: {
            id: 'fabric.editor.heading6',
            defaultMessage: 'Heading 6',
            description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
        },
        heading6Description: {
            id: 'fabric.editor.heading6Description',
            defaultMessage: 'Use this for low level headings',
            description: ''
        },
        blockquote: {
            id: 'fabric.editor.blockquote2',
            defaultMessage: 'Quote',
            description: 'Quote some text'
        },
        blockquoteDescription: {
            id: 'fabric.editor.blockquote.description',
            defaultMessage: 'Insert a quote or citation',
            description: 'Quote some text'
        },
        codeblock: {
            id: 'fabric.editor.codeblock',
            defaultMessage: 'Code snippet',
            description: 'Insert a snippet/segment of code (code block)'
        },
        codeblockDescription: {
            id: 'fabric.editor.codeblock.description',
            defaultMessage: 'Display code with syntax highlighting',
            description: 'Insert a snippet/segment of code (code block)'
        },
        infoPanel: {
            id: 'fabric.editor.infoPanel',
            defaultMessage: 'Info panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        infoPanelDescription: {
            id: 'fabric.editor.infoPanel.description',
            defaultMessage: 'Highlight information in a colored panel',
            description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
        },
        notePanel: {
            id: 'fabric.editor.notePanel',
            defaultMessage: 'Note panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        notePanelDescription: {
            id: 'fabric.editor.notePanel.description',
            defaultMessage: 'Add a note in a colored panel',
            description: 'Visually distinguishes your text by adding a note panel'
        },
        successPanel: {
            id: 'fabric.editor.successPanel',
            defaultMessage: 'Success panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        successPanelDescription: {
            id: 'fabric.editor.successPanel.description',
            defaultMessage: 'Add tips in a colored panel',
            description: 'Visually distinguishes your text by adding a success panel'
        },
        warningPanel: {
            id: 'fabric.editor.warningPanel',
            defaultMessage: 'Warning panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        warningPanelDescription: {
            id: 'fabric.editor.warningPanel.description',
            defaultMessage: 'Add a note of caution in a colored panel',
            description: 'Visually distinguishes your text by adding a warning panel'
        },
        errorPanel: {
            id: 'fabric.editor.errorPanel',
            defaultMessage: 'Error panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        errorPanelDescription: {
            id: 'fabric.editor.errorPanel.description',
            defaultMessage: 'Call out errors in a colored panel',
            description: 'Visually distinguishes your text by adding a error panel'
        },
        customPanel: {
            id: 'fabric.editor.customPanel',
            defaultMessage: 'Custom panel',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color'
        },
        customPanelDescription: {
            id: 'fabric.editor.customPanel.description',
            defaultMessage: 'Add a note with an emoji and colored background',
            description: 'Visually distinguishes your panel by adding a emoji icon and background color '
        },
        panel: {
            id: 'fabric.editor.panel',
            defaultMessage: 'Panel',
            description: 'Visually distinguishes your text by adding a panel'
        },
        other: {
            id: 'fabric.editor.other',
            defaultMessage: 'Others...',
            description: 'Other text formatting'
        }
    });
});
parcelRegister("fJyLQ", function(module, exports) {
    $parcel$export(module.exports, "codeBidiWarningMessages", ()=>$bc1b61e25b99393f$export$42bb270d1224182);
    var $7VHMR;
    const $bc1b61e25b99393f$export$42bb270d1224182 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'fabric.editor.codeBidiWarningLabel',
            defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
            description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
        }
    });
});
parcelRegister("gSYO9", function(module, exports) {
    $parcel$export(module.exports, "linkMessages", ()=>$6ccabeb0d4490fe2$export$4ce3884394d6d9);
    var $7VHMR;
    const $6ccabeb0d4490fe2$export$4ce3884394d6d9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openLink: {
            id: 'fabric.editor.openLink',
            defaultMessage: 'Open link in a new tab',
            description: 'Opens the link in a new tab'
        }
    });
});
parcelRegister("jDuvE", function(module, exports) {
    $parcel$export(module.exports, "linkToolbarMessages", ()=>$8ffd20c106600435$export$2d7676d841c8ae9);
    var $7VHMR;
    const $8ffd20c106600435$export$2d7676d841c8ae9 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addLink: {
            id: 'fabric.editor.mediaAddLink',
            defaultMessage: 'Add link',
            description: 'Add link'
        },
        unableToOpenLink: {
            id: 'fabric.editor.unableToOpenLink',
            defaultMessage: 'Unable to open this link',
            description: 'Unable to open this link'
        },
        unlink: {
            id: 'fabric.editor.unlink',
            defaultMessage: 'Unlink',
            description: 'Removes the hyperlink but keeps your text.'
        },
        editDatasourceStandalone: {
            id: 'fabric.editor.editDatasourceStandalone',
            defaultMessage: 'Edit',
            description: 'A standalone edit button to edit the datasource via a config modal'
        },
        editDatasourceStandaloneTooltip: {
            id: 'fabric.editor.editDatasourceStandaloneTooltip',
            defaultMessage: 'Edit search query',
            description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
        },
        editLink: {
            id: 'fabric.editor.editLink',
            defaultMessage: 'Edit link',
            description: 'Edit the link, update display text'
        },
        placeholder: {
            id: 'fabric.editor.hyperlinkToolbarPlaceholder',
            defaultMessage: 'Paste or search for link',
            description: 'Paste or search for link'
        },
        linkPlaceholder: {
            id: 'fabric.editor.linkPlaceholder',
            defaultMessage: 'Paste link',
            description: 'Create a new link by pasting a URL.'
        },
        linkAddress: {
            id: 'fabric.editor.linkAddress',
            defaultMessage: 'Link address',
            description: 'Insert the address of the link'
        },
        invalidLink: {
            id: 'fabric.editor.invalidLink',
            defaultMessage: 'Please enter a valid link.',
            description: 'Please enter a valid link.'
        },
        emptyLink: {
            id: 'fabric.editor.emptyLink',
            defaultMessage: 'Please enter a link.',
            description: 'Please enter a link.'
        },
        settingsLink: {
            id: 'fabric.editor.settingsLinks',
            defaultMessage: 'Go to Link Preferences',
            description: 'Go to Link Preferences'
        },
        editDatasource: {
            id: 'fabric.editor.edit.datasource',
            defaultMessage: 'Edit search query',
            description: 'Datasource toolbar edit button'
        },
        searchInput: {
            id: 'fabric.editor.edit.searchInput',
            defaultMessage: 'Add a link',
            description: 'Label for the search media input'
        }
    });
});
parcelRegister("lQKNV", function(module, exports) {
    $parcel$export(module.exports, "codeBlockButtonMessages", ()=>$20d0fb06aaa96548$export$74e304339778e94d);
    var $7VHMR;
    const $20d0fb06aaa96548$export$74e304339778e94d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
            defaultMessage: 'Copy as text',
            description: 'Copy the content of the code block as text to your clipboard'
        },
        copiedCodeToClipboard: {
            id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
            defaultMessage: 'Copied!',
            description: 'Copied the content of the code block as text to clipboard'
        },
        wrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
            defaultMessage: 'Turn on wrap',
            description: 'Wrap the content of the code block'
        },
        unwrapCode: {
            id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
            defaultMessage: 'Turn off wrap',
            description: 'Wrap the content of the code block'
        },
        selectLanguage: {
            id: 'fabric.editor.selectLanguage',
            defaultMessage: 'Select language',
            description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
        }
    });
});
parcelRegister("2i4K4", function(module, exports) {
    $parcel$export(module.exports, "toolbarInsertBlockMessages", ()=>$4423ee10317a70cf$export$70c8a7203d95247);
    var $7VHMR;
    const $4423ee10317a70cf$export$70c8a7203d95247 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        action: {
            id: 'fabric.editor.action',
            defaultMessage: 'Action item',
            description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
        },
        actionDescription: {
            id: 'fabric.editor.action.description',
            defaultMessage: 'Create and assign action items',
            description: ''
        },
        closeInsertRightRail: {
            id: 'fabric.editor.insertRightRail.close',
            defaultMessage: 'Close',
            description: 'Close button label'
        },
        link: {
            id: 'fabric.editor.link',
            defaultMessage: 'Link',
            description: 'Insert a hyperlink'
        },
        linkDescription: {
            id: 'fabric.editor.link.description',
            defaultMessage: 'Insert a link',
            description: 'Insert a hyperlink'
        },
        mediaFiles: {
            id: 'fabric.editor.mediaFiles',
            defaultMessage: 'Image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        addMediaFiles: {
            id: 'fabric.editor.addMediaFiles',
            defaultMessage: 'Add image, video, or file',
            description: 'Insert one or more files, videos or images'
        },
        insertRightRailTitle: {
            id: 'fabric.editor.insertRightRail.title',
            defaultMessage: 'Insert',
            description: 'Insert a node into the document'
        },
        mediaFilesDescription: {
            id: 'fabric.editor.mediaFiles.description',
            defaultMessage: 'Add images and other files to your page',
            description: 'Insert one or more files or images'
        },
        image: {
            id: 'fabric.editor.image',
            defaultMessage: 'Image',
            description: 'Insert an image.'
        },
        mention: {
            id: 'fabric.editor.mention',
            defaultMessage: 'Mention',
            description: 'Reference another person in your document'
        },
        mentionDescription: {
            id: 'fabric.editor.mention.description',
            defaultMessage: 'Mention someone to send them a notification',
            description: 'Reference another person in your document'
        },
        emoji: {
            id: 'fabric.editor.emoji',
            defaultMessage: 'Emoji',
            description: 'Insert an emoticon or smiley :-)'
        },
        emojiDescription: {
            id: 'fabric.editor.emoji.description',
            defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
            description: 'Insert an emoticon or smiley :-)'
        },
        table: {
            id: 'fabric.editor.table',
            defaultMessage: 'Table',
            description: 'Inserts a table in the document'
        },
        tableDescription: {
            id: 'fabric.editor.table.description',
            defaultMessage: 'Insert a table',
            description: 'Inserts a table in the document'
        },
        tableSelector: {
            id: 'fabric.editor.tableSelector',
            defaultMessage: 'Table size',
            description: 'Opens a table selector that lets you insert a table of custom size'
        },
        tableSelectorDescription: {
            id: 'fabric.editor.tableSelector.description',
            defaultMessage: 'Add a table using popup to select a custom size',
            description: 'Opens a table selector that lets you insert a table of a custom size'
        },
        tableSizeSelectorButton: {
            id: 'fabric.editor.tableSizeSelectorButton',
            defaultMessage: '{numberOfColumns} by {numberOfRows}',
            description: 'Creates a table of custom size'
        },
        tableSizeSelectorPopup: {
            id: 'fabric.editor.tableSizeSelectorPopup',
            defaultMessage: 'Table size selector',
            description: 'Table selector popup to create table of custom size'
        },
        expand: {
            id: 'fabric.editor.expand',
            defaultMessage: 'Expand',
            description: 'Inserts an expand in the document'
        },
        expandDescription: {
            id: 'fabric.editor.expand.description',
            defaultMessage: 'Insert an expand',
            description: 'Inserts an expand in the document'
        },
        decision: {
            id: 'fabric.editor.decision',
            defaultMessage: 'Decision',
            description: "Capture a decision you\u2019ve made"
        },
        decisionDescription: {
            id: 'fabric.editor.decision.description',
            defaultMessage: "Capture decisions so they\u2019re easy to track",
            description: "Capture a decision you\u2019ve made"
        },
        feedbackDialog: {
            id: 'fabric.editor.feedbackDialog',
            defaultMessage: 'Give feedback',
            description: 'Open the feedback dialog from editor'
        },
        feedbackDialogDescription: {
            id: 'fabric.editor.feedbackDialog.description',
            defaultMessage: 'Tell us about your experience using the new editor',
            description: 'Description for feedback option under quick insert dropdown'
        },
        horizontalRule: {
            id: 'fabric.editor.horizontalRule',
            defaultMessage: 'Divider',
            description: 'A horizontal rule or divider'
        },
        horizontalRuleDescription: {
            id: 'fabric.editor.horizontalRule.description',
            defaultMessage: 'Separate content with a horizontal line',
            description: 'A horizontal rule or divider'
        },
        date: {
            id: 'fabric.editor.date',
            defaultMessage: 'Date',
            description: 'Opens a date picker that lets you select a date'
        },
        dateDescription: {
            id: 'fabric.editor.date.description',
            defaultMessage: 'Add a date using a calendar',
            description: 'Opens a date picker that lets you select a date'
        },
        placeholderText: {
            id: 'fabric.editor.placeholderText',
            defaultMessage: 'Placeholder text',
            description: 'Inserts a text placeholder into the page'
        },
        placeholderTextDescription: {
            id: 'fabric.editor.placeholderText.description',
            defaultMessage: 'Insert a text placeholder into the page',
            description: 'Inserts a text placeholder into the page'
        },
        columns: {
            id: 'fabric.editor.columns',
            defaultMessage: 'Layouts',
            description: 'Create a multi column section or layout'
        },
        columnsDescription: {
            id: 'fabric.editor.columns.description',
            defaultMessage: 'Structure your page using sections',
            description: 'Create a multi column section or layout'
        },
        status: {
            id: 'fabric.editor.status',
            defaultMessage: 'Status',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        statusDescription: {
            id: 'fabric.editor.status.description',
            defaultMessage: 'Add a custom status label',
            description: 'Inserts an item representing the status of an activity to task.'
        },
        viewMore: {
            id: 'fabric.editor.viewMore',
            defaultMessage: 'View more',
            description: ''
        },
        insertMenu: {
            id: 'fabric.editor.insertMenu',
            defaultMessage: 'Insert elements',
            description: 'Opens a menu of additional items that can be inserted into your document.'
        },
        help: {
            id: 'fabric.editor.help',
            defaultMessage: 'Help',
            description: 'Opens up the help dialog'
        },
        helpDescription: {
            id: 'fabric.editor.help.description',
            defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
            description: 'Browse all the keyboard shortcuts and markdown options'
        },
        recordVideo: {
            id: 'fabric.editor.recordVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideo: {
            id: 'fabric.editor.addLoomVideo',
            defaultMessage: 'Record a Loom video',
            description: 'Record a Loom video'
        },
        addLoomVideoComment: {
            id: 'fabric.editor.addLoomVideoComment',
            defaultMessage: 'Record a Loom video comment',
            description: 'Record a Loom video comment'
        },
        recordVideoDescription: {
            id: 'fabric.editor.recordVideo.description',
            defaultMessage: 'Record and share your screen and thoughts',
            description: 'Record and share your screen and thoughts'
        },
        recordLoomShortTitle: {
            id: 'fabric.editor.recordLoomShortTitle',
            defaultMessage: 'Record',
            description: 'Record'
        },
        turnInto: {
            id: 'fabric.editor.turnInto',
            defaultMessage: 'Turn into',
            description: 'Turn selected texts into another element containing those texts'
        }
    });
});
parcelRegister("eX53M", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$0e5cb7a66b16e8d0$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $0e5cb7a66b16e8d0$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        wrapLeft: {
            id: 'fabric.editor.wrapLeft',
            defaultMessage: 'Wrap left',
            description: 'Aligns your image to the left and wraps text around it.'
        },
        wrapRight: {
            id: 'fabric.editor.wrapRight',
            defaultMessage: 'Wrap right',
            description: 'Aligns your image to the right and wraps text around it.'
        },
        changeToMediaSingle: {
            id: 'fabric.editor.media_change_mediasingle',
            defaultMessage: 'Original size',
            description: 'In the context of a media inline image, it allows the user to convert it to media single'
        },
        changeToMediaInlineImage: {
            id: 'fabric.editor.media_change_mediainline_default',
            defaultMessage: 'Inline',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
        },
        changeToMediaInlineImageCaptionWarning: {
            id: 'fabric.editor.media_change_mediainline_caption_warn',
            defaultMessage: 'Inline (caption will be removed)',
            description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
        }
    });
});
parcelRegister("80CM7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$402c787ddf19f01c$export$defe85febe8b728c);
    var $7VHMR;
    const $402c787ddf19f01c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        url: {
            id: 'fabric.editor.url',
            defaultMessage: 'Display URL',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        block: {
            id: 'fabric.editor.displayBlock',
            defaultMessage: 'Display card',
            description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
        },
        inline: {
            id: 'fabric.editor.displayInline',
            defaultMessage: 'Display inline',
            description: 'Display link with the title only.'
        },
        embed: {
            id: 'fabric.editor.displayEmbed',
            defaultMessage: 'Display embed',
            description: 'Display link as an embedded object'
        },
        link: {
            id: 'fabric.editor.displayLink',
            defaultMessage: 'Display as text',
            description: 'Convert the card to become a regular text-based hyperlink.'
        },
        card: {
            id: 'fabric.editor.cardFloatingControls',
            defaultMessage: 'Card options',
            description: 'Options to change card type'
        },
        blockCardUnavailable: {
            id: 'fabric.editor.blockCardUnavailable',
            defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
            description: 'Warning message to show the user that this node cannot change its view'
        },
        displayOptionUnavailableInParentNode: {
            id: 'fabric.editor.displayOptionUnavailableInParentNode',
            defaultMessage: "This display option isn't available inside {node}",
            description: 'Warning message to show the user that this node option is not available inside a parent node type'
        },
        urlTitle: {
            id: 'fabric.editor.urlTitle',
            defaultMessage: 'URL',
            description: 'Title for option to convert the card to become a regular text-based hyperlink.'
        },
        blockTitle: {
            id: 'fabric.editor.blockTitle',
            defaultMessage: 'Card',
            description: 'Title for option to display link in the card view.'
        },
        inlineTitle: {
            id: 'fabric.editor.inlineTitle',
            defaultMessage: 'Inline',
            description: 'Title for option to display link in the inline view.'
        },
        embedTitle: {
            id: 'fabric.editor.embedTitle',
            defaultMessage: 'Embed',
            description: 'Title for option to display link as an embedded object.'
        },
        urlDescription: {
            id: 'fabric.editor.urlDescription',
            defaultMessage: 'Display link as URL',
            description: 'Description for option to convert the card to become a regular text-based hyperlink.'
        },
        blockDescription: {
            id: 'fabric.editor.blockDescription',
            defaultMessage: 'Display more information about a link, including a summary and actions',
            description: 'Description for option to display link in the card view.'
        },
        inlineDescription: {
            id: 'fabric.editor.inlineDescription',
            defaultMessage: 'Display link as inline text',
            description: 'Description for option to display link in the inline view.'
        },
        embedDescription: {
            id: 'fabric.editor.ecombedDescription',
            defaultMessage: 'Display an interactive preview of a link',
            description: 'Description for option to display link as an embedded object.'
        },
        editDropdownExpandIconLabel: {
            id: 'fabric.editor.editDropdownExpandIconLabel',
            defaultMessage: 'Expand dropdown menu',
            description: 'Text of an icon to expand the dropdown'
        },
        editDropdownTriggerTitle: {
            id: 'fabric.editor.editDropdownTriggerTitle',
            defaultMessage: 'Edit',
            description: 'Text of a button to trigger opening an edit dropdown'
        },
        editDropdownEditLinkTitle: {
            id: 'fabric.editor.editDropdownEditLinkTitle',
            defaultMessage: 'Edit link',
            description: 'Edit dropdown edit link button text'
        },
        editDropdownEditDatasourceTitle: {
            id: 'fabric.editor.editDropdownEditDatasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Edit dropdown edit datasource button text'
        },
        datasourceTitle: {
            id: 'fabric.editor.datasourceTitle',
            defaultMessage: 'Edit search query',
            description: 'Tooltip of button to edit a card into a datasource'
        },
        datasourceAppearanceTitle: {
            id: 'fabric.editor.datasourceAppearanceTitle',
            defaultMessage: 'List',
            description: 'Tooltip of button to change to datasource appearance'
        },
        datasourceJiraIssue: {
            id: 'fabric.editor.datasource.jiraIssue',
            defaultMessage: 'Jira Issues',
            description: 'Insert a jira datasource table'
        },
        datasourceJiraIssueDescription: {
            id: 'fabric.editor.datasource.jiraIssue.description',
            defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
            description: 'Insert a jira datasource table'
        },
        datasourceAssetsObjectsGeneralAvailability: {
            id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
            defaultMessage: 'Assets',
            description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
        },
        datasourceAssetsObjectsDescription: {
            id: 'fabric.editor.datasource.assetsObjects.description',
            defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
        },
        inlineOverlay: {
            id: 'fabric.editor.inlineOverlay',
            defaultMessage: 'Configure',
            description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
        },
        inlineConfigureLink: {
            id: 'fabric.editor.inlineConfigureLink',
            defaultMessage: 'Configure link',
            description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
        },
        inlineGoToLink: {
            id: 'fabric.editor.inlineGoToLink',
            defaultMessage: 'Go to link',
            description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
        },
        datasourceConfluenceSearch: {
            id: 'fabric.editor.datasource.confluenceSearch',
            defaultMessage: 'Insert Confluence list',
            description: 'Title shown for Confluence Search datasource on QuickInsert options'
        },
        datasourceConfluenceSearchDescription: {
            id: 'fabric.editor.datasource.confluenceSearch.description',
            defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
            description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
        }
    });
});
parcelRegister("kXnoC", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$19e3f2f865259995$export$defe85febe8b728c);
    var $7VHMR;
    const $19e3f2f865259995$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toolbarLabel: {
            id: 'fabric.editor.toolbarLabel',
            defaultMessage: 'Editor',
            description: 'Label for the ARIA region landmark'
        },
        pageActionsLabel: {
            id: 'fabric.editor.pageActionsLabel',
            defaultMessage: 'Page actions',
            description: 'Label for the ARIA region landmark'
        },
        editableContentLabel: {
            id: 'fabric.editor.editableContentLabel',
            defaultMessage: 'Editable content',
            description: 'Label for the ARIA region landmark'
        }
    });
});
parcelRegister("eDTMN", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$ec9866e02d0168cb$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $ec9866e02d0168cb$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        underline: {
            id: 'fabric.editor.underline',
            defaultMessage: 'Underline',
            description: 'Whether the text selection has underlined text'
        },
        strike: {
            id: 'fabric.editor.strike',
            defaultMessage: 'Strikethrough',
            description: 'Whether the text selection has crossed out text'
        },
        code: {
            id: 'fabric.editor.code',
            defaultMessage: 'Code',
            description: 'Whether the text selection has monospaced/code font'
        },
        codeOn: {
            id: 'fabric.editor.code.on',
            defaultMessage: '{textFormattingOff}, Code On',
            description: 'Reports that code formatting has been turned on'
        },
        subscript: {
            id: 'fabric.editor.subscript',
            defaultMessage: 'Subscript',
            description: 'Whether the text selection is written below the line in a slightly smaller size'
        },
        subscriptOffSuperscriptOn: {
            id: 'fabric.editor.subscript.off.superscript.on',
            defaultMessage: 'Subscript Off, Superscript On',
            description: 'Reports text formatting in case when subscript off and superscript on'
        },
        superscript: {
            id: 'fabric.editor.superscript',
            defaultMessage: 'Superscript',
            description: 'Whether the text selection is written above the line in a slightly smaller size'
        },
        superscriptOffSubscriptOn: {
            id: 'fabric.editor.superscript.off.subscript.on',
            defaultMessage: 'Superscript Off, Subscript On',
            description: 'Describe text formatting in case when Superscript Off and Subscript on'
        },
        clearFormatting: {
            id: 'fabric.editor.clearFormatting',
            defaultMessage: 'Clear formatting',
            description: 'Remove all rich text formatting from the selected text'
        },
        moreFormatting: {
            id: 'fabric.editor.moreFormatting',
            defaultMessage: 'More formatting',
            description: 'Clicking this will show a menu with additional formatting options'
        },
        textFormatting: {
            id: 'fabric.editor.textFormatting',
            defaultMessage: 'Text formatting',
            description: 'Aria label for the wrapper of text format buttons'
        },
        bold: {
            id: 'fabric.editor.bold',
            defaultMessage: 'Bold',
            description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
        },
        italic: {
            id: 'fabric.editor.italic',
            defaultMessage: 'Italic',
            description: 'This refers to italics or emphasized formatting.'
        },
        on: {
            id: 'fabric.editor.on',
            defaultMessage: '{formattingType} On',
            description: 'Reports that text formatting has been turned on'
        },
        off: {
            id: 'fabric.editor.off',
            defaultMessage: '{formattingType} Off',
            description: 'Reports that text formatting has been turned off'
        },
        textStyles: {
            id: 'fabric.editor.textStyles',
            defaultMessage: '{blockTypeName} Text styles',
            description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
        },
        textStylesTooltip: {
            id: 'fabric.editor.textStylesTooltip',
            defaultMessage: 'Text styles',
            description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
        },
        textFormattingOff: {
            id: 'fabric.editor.text.formatting.off',
            defaultMessage: 'Text formatting Off',
            description: 'Reports that text formatting has been turned off'
        },
        navigateToEditorToolbar: {
            id: 'fabric.editor.navigate.toolbar.editor',
            defaultMessage: 'Navigate to editor toolbar',
            description: 'Navigate to the main editor toolbar.'
        },
        navigateToFloatingToolbar: {
            id: 'fabric.editor.navigate.toolbar.floating',
            defaultMessage: 'Navigate to floating toolbar',
            description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
        }
    });
});
parcelRegister("2V0EL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bcecf16097bd0035$export$defe85febe8b728c);
    var $7VHMR;
    const $bcecf16097bd0035$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tableOptions: {
            id: 'fabric.editor.tableOptions',
            defaultMessage: 'Table options',
            description: 'Opens a menu with additional table options'
        },
        tableSizeIncreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
            defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
        },
        tableSizeDecreaseScreenReaderInformation: {
            id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
            defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
            description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
        },
        headerRow: {
            id: 'fabric.editor.headerRow',
            defaultMessage: 'Header row',
            description: 'Marks the first table row as a header row'
        },
        headerColumn: {
            id: 'fabric.editor.headerColumn',
            defaultMessage: 'Header column',
            description: 'Marks the first table column as a header row'
        },
        numberedColumn: {
            id: 'fabric.editor.numberedColumn',
            defaultMessage: 'Numbered column',
            description: 'Adds an auto-numbering column to your table'
        },
        collapseTable: {
            id: 'fabric.editor.collapseTable',
            defaultMessage: 'Collapse table',
            description: 'Wraps table in an expand'
        },
        resizeTable: {
            id: 'fabric.editor.tables.resizeTable',
            defaultMessage: 'Resize table',
            description: 'Tooltip displayed on custom table width resize hande'
        },
        insertColumn: {
            id: 'fabric.editor.insertColumn',
            defaultMessage: 'Insert column right',
            description: 'Inserts a new column to the right of selected column.'
        },
        addColumnLeft: {
            id: 'fabric.editor.addColumnLeft',
            defaultMessage: 'Add column left',
            description: 'Adds a new column to the left of selected column.'
        },
        addColumnRight: {
            id: 'fabric.editor.addColumnRight',
            defaultMessage: 'Add column right',
            description: 'Adds a new column to the right of selected column.'
        },
        insertColumnDrag: {
            id: 'fabric.editor.insertColumnDrag',
            defaultMessage: 'Insert column',
            description: 'Inserts a new column to the right of selected column.'
        },
        removeColumns: {
            id: 'fabric.editor.removeColumns',
            defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
            description: 'Deletes a table column.'
        },
        insertRow: {
            id: 'fabric.editor.insertRow',
            defaultMessage: 'Insert row below',
            description: 'Inserts a new row below the selected row.'
        },
        addRowAbove: {
            id: 'fabric.editor.addRowAbove',
            defaultMessage: 'Add row above',
            description: 'Adds a new row above the selected row.'
        },
        addRowBelow: {
            id: 'fabric.editor.addRowBelow',
            defaultMessage: 'Add row below',
            description: 'Adds a new row below the selected row.'
        },
        moveColumnLeft: {
            id: 'fabric.editor.moveColumnLeft',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
            description: 'Moves a column or columns to the left.'
        },
        moveColumnRight: {
            id: 'fabric.editor.moveColumnRight',
            defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
            description: 'Moves a column or columns to the right.'
        },
        moveRowUp: {
            id: 'fabric.editor.moveRowUp',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
            description: 'Moves a row or selected rows up.'
        },
        moveRowDown: {
            id: 'fabric.editor.moveDownDown',
            defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
            description: 'Moves a row or selected rows down.'
        },
        insertRowDrag: {
            id: 'fabric.editor.insertRowDrag',
            defaultMessage: 'Insert row',
            description: 'Inserts a new row below the selected row.'
        },
        removeRows: {
            id: 'fabric.editor.removeRows',
            defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
            description: 'Deletes a table row.'
        },
        rowNumbers: {
            id: 'fabrid.editor.rowNumbers',
            defaultMessage: 'Row numbers',
            desciption: 'Adds a number to each row except header row'
        },
        rowsAreInserted: {
            id: 'fabric.editor.rowsAreInserted',
            defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
            description: 'Assistive message following the insertion of row(s)'
        },
        rowsAreRemoved: {
            id: 'fabric.editor.rowsAreRemoved',
            defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
            description: 'Assistive message following the removal of row(s)'
        },
        rowSelected: {
            id: 'fabric.editor.rowSelected',
            defaultMessage: 'Row {index} of {total} selected',
            description: 'Assistive message following the selection of a row'
        },
        rowMovedUp: {
            id: 'fabric.editor.rowMovedUp',
            defaultMessage: 'Row moved up to {index} of {total}',
            description: 'Assistive message following the upward movement of a row'
        },
        rowMovedDown: {
            id: 'fabric.editor.rowMovedDown',
            defaultMessage: 'Row moved down to {index} of {total}',
            description: 'Assistive message following the downward movement of a row'
        },
        columnsAreInserted: {
            id: 'fabric.editor.columnsAreInserted',
            defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
            description: 'Assistive message following the insertion of column(s)'
        },
        columnsAreRemoved: {
            id: 'fabric.editor.columnsAreRemoved',
            defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
            description: 'Assistive message following the removal of column(s)'
        },
        columnSelected: {
            id: 'fabric.editor.columnSelected',
            defaultMessage: 'Column {index} of {total} selected',
            description: 'Assistive message following the selection of a column'
        },
        columnMovedLeft: {
            id: 'fabric.editor.columnMovedLeft',
            defaultMessage: 'Column moved left to {index} of {total}',
            description: 'Assistive message following the left movement of a column'
        },
        columnMovedRight: {
            id: 'fabric.editor.columnMovedRight',
            defaultMessage: 'Column moved right to {index} of {total}',
            description: 'Assistive message following the right movement of a column'
        },
        cellOptions: {
            id: 'fabric.editor.cellOptions',
            defaultMessage: 'Cell options',
            description: 'Opens a menu with options for the current table cell.'
        },
        confirmDeleteLinkedModalOKButton: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
            defaultMessage: 'Delete',
            description: 'Action button label for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessage: {
            id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
            defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
            description: 'Message for confirm modal when deleting a table linked to an extension.'
        },
        confirmDeleteLinkedModalMessagePrefix: {
            id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
            defaultMessage: 'Deleting',
            description: 'prefix for confirmation dialog text'
        },
        confirmModalCheckboxLabel: {
            id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
            defaultMessage: 'Also delete connected elements',
            description: 'checkbox label text'
        },
        deleteElementTitle: {
            id: 'fabric.editor.extension.deleteElementTitle',
            defaultMessage: 'Delete element',
            description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
        },
        unnamedSource: {
            id: 'fabric.editor.extension.sourceNoTitledName',
            defaultMessage: 'this element',
            description: 'The current element without preset name been selected'
        },
        adjustColumns: {
            id: 'fabric.editor.tables.adjustColumn',
            defaultMessage: 'Adjust column',
            description: 'Tooltip displayed on table column resize handle'
        },
        cornerControl: {
            id: 'fabric.editor.cornerControl',
            defaultMessage: 'Highlight table',
            description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
        },
        cellBackground: {
            id: 'fabric.editor.cellBackground',
            defaultMessage: 'Cell background',
            description: 'Change the background color of a table cell.'
        },
        backgroundColor: {
            id: 'fabric.editor.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Change the background color of a table cell.'
        },
        mergeCells: {
            id: 'fabric.editor.mergeCells',
            defaultMessage: 'Merge cells',
            description: 'Merge tables cells together.'
        },
        splitCell: {
            id: 'fabric.editor.splitCell',
            defaultMessage: 'Split cell',
            description: 'Split a merged table cell.'
        },
        clearCells: {
            id: 'fabric.editor.clearCells',
            defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
            description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
        },
        sortColumnASC: {
            id: 'fabric.editor.sortColumnASC',
            defaultMessage: "Sort column A \u2192 Z",
            description: 'Sort column in ascending order'
        },
        sortColumnDESC: {
            id: 'fabric.editor.sortColumnDESC',
            defaultMessage: "Sort column Z \u2192 A",
            description: 'Sort column in descending order'
        },
        sortColumnIncreasing: {
            id: 'fabric.editor.sortColumnIncreasing',
            defaultMessage: 'Sort increasing',
            description: 'Sort column in ascending order'
        },
        sortColumnDecreasing: {
            id: 'fabric.editor.sortColumnDecreasing',
            defaultMessage: 'Sort decreasing',
            description: 'Sort column in descending order'
        },
        canNotSortTable: {
            id: 'fabric.editor.canNotSortTable',
            defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
            description: `Split your cells to enable this feature`
        },
        distributeColumns: {
            id: 'fabric.editor.distributeColumns',
            defaultMessage: `Distribute columns`,
            description: `Distribute widths between selected columns`
        },
        lockColumnWidths: {
            id: 'fabric.editor.lockColumns',
            defaultMessage: 'Fixed column widths',
            description: 'Toggle button to enable fixed column widths'
        },
        rowControl: {
            id: 'fabric.editor.rowControl',
            defaultMessage: 'Highlight row',
            description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
        },
        rowDragHandle: {
            id: 'fabric.editor.rowDragHandle',
            defaultMessage: 'Row options',
            description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
        },
        columnDragHandle: {
            id: 'fabric.editor.columnDragHandle',
            defaultMessage: 'Column options',
            description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
        },
        fullWidthLabel: {
            id: 'fabric.editor.tableFullWidthLabel',
            defaultMessage: 'Full-width',
            description: 'Trigger table width to full-width mode'
        },
        startedColumnResize: {
            id: 'fabric.editor.tables.startedColumnResize',
            defaultMessage: 'Started column resize',
            description: 'Screen Reader announces when the user engages the column resizer'
        },
        focusedOtherResize: {
            id: 'fabric.editor.tables.otherResize',
            defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
            description: 'Screen Reader announces when the user switches to the left or right column resizer'
        },
        changedColumnWidth: {
            id: 'fabric.editor.tables.columnWidth',
            defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
            description: 'Screen Reader announces when the user modifies the column width'
        },
        columnResizeStop: {
            id: 'fabric.editor.tables.resizeStop',
            defaultMessage: 'Stopped resize',
            description: 'Screen Reader announces when the user discontinues the resizing operation'
        },
        columnResizeOverflow: {
            id: 'fabric.editor.tables.columnResizeOverflow',
            defaultMessage: 'You can only resize this column while the table has a scroll bar.',
            description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
        },
        columnResizeLast: {
            id: 'fabric.editor.tables.columnResizeLast',
            defaultMessage: 'You can only resize this column to the left.',
            description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
        },
        tableAlignmentOptions: {
            id: 'fabric.editor.tableAlignmentOptions',
            defaultMessage: 'Alignment options',
            description: 'Opens a menu with additional table alignment options'
        },
        alignTableCenter: {
            id: 'fabric.editor.alignTableCenter',
            defaultMessage: 'Align center',
            description: 'Aligns table to the center'
        },
        alignTableLeft: {
            id: 'fabric.editor.alignTableLeft',
            defaultMessage: 'Align left',
            description: 'Aligns table to the left'
        }
    });
});
parcelRegister("kFJBG", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a872fd5a03f73724$export$defe85febe8b728c);
    var $7VHMR;
    const $a872fd5a03f73724$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unorderedList: {
            id: 'fabric.editor.unorderedList',
            defaultMessage: 'Bullet list',
            description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
        },
        unorderedListDescription: {
            id: 'fabric.editor.unorderedList.description',
            defaultMessage: 'Create an unordered list',
            description: ''
        },
        orderedList: {
            id: 'fabric.editor.orderedList',
            defaultMessage: 'Numbered list',
            description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
        },
        orderedListDescription: {
            id: 'fabric.editor.orderedList.description',
            defaultMessage: 'Create an ordered list',
            description: ''
        },
        lists: {
            id: 'fabric.editor.lists',
            defaultMessage: 'Lists',
            description: 'Menu shows ordered/bullet list and unordered/numbered lists'
        },
        listsFormat: {
            id: 'fabric.editor.listsFormat',
            defaultMessage: 'List formatting',
            description: 'Aria label for the wrapper of list buttons'
        }
    });
});
parcelRegister("7S9ZN", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9078664297972b18$export$defe85febe8b728c);
    var $7VHMR;
    const $9078664297972b18$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        undo: {
            id: 'fabric.editor.undo',
            defaultMessage: 'Undo',
            description: 'Undo the previously performed action.'
        },
        redo: {
            id: 'fabric.editor.redo',
            defaultMessage: 'Redo',
            description: 'Redo the previously undone action.'
        }
    });
});
parcelRegister("6OcHr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b883afcc2fb8665e$export$defe85febe8b728c);
    var $7VHMR;
    const $b883afcc2fb8665e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.statusPlaceholder',
            defaultMessage: 'Set a status',
            description: 'Placeholder description for an empty (new) status item in the editor'
        },
        editText: {
            id: 'fabric.editor.editStatusText',
            defaultMessage: 'Edit Status',
            description: 'Title for the input that changes the status text'
        },
        editColor: {
            id: 'fabric.editor.editStatusColor',
            defaultMessage: 'Edit Status Color',
            description: 'Title for the color picker that changes the status color'
        }
    });
});
parcelRegister("dbepQ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$19b9098ff265842b$export$defe85febe8b728c);
    var $7VHMR;
    const $19b9098ff265842b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editText: {
            id: 'fabric.editor.editDateText',
            defaultMessage: 'Edit Date',
            description: 'Title for the input that changes the date'
        },
        invalidDateError: {
            id: 'fabric.editor.invalidDateError',
            defaultMessage: 'Enter a valid date',
            description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
        },
        onKeyUpDownText: {
            id: 'fabric.editor.upDown',
            defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
            description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
        }
    });
});
parcelRegister("kANLZ", function(module, exports) {
    $parcel$export(module.exports, "toolbarMessages", ()=>$2ae4030e88533f57$export$81b075fd34c2f0bb);
    var $7VHMR;
    const $2ae4030e88533f57$export$81b075fd34c2f0bb = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        singleColumn: {
            id: 'fabric.editor.single',
            defaultMessage: 'Single column layout',
            description: 'Layout with one single column'
        },
        twoColumns: {
            id: 'fabric.editor.twoColumns',
            defaultMessage: 'Two columns layout',
            description: 'Layout with two columns of equal width'
        },
        threeColumns: {
            id: 'fabric.editor.threeColumns',
            defaultMessage: 'Three columns layout',
            description: 'Layout with three columns of equal width'
        },
        fourColumns: {
            id: 'fabric.editor.fourColumns',
            defaultMessage: 'Four columns layout',
            description: 'Layout with four columns of equal width'
        },
        fiveColumns: {
            id: 'fabric.editor.fiveColumns',
            defaultMessage: 'Five columns layout',
            description: 'Layout with five columns of equal width'
        },
        rightSidebar: {
            id: 'fabric.editor.rightSidebar',
            defaultMessage: 'Right sidebar layout',
            description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
        },
        leftSidebar: {
            id: 'fabric.editor.leftSidebar',
            defaultMessage: 'Left sidebar layout',
            description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
        },
        threeColumnsWithSidebars: {
            id: 'fabric.editor.threeColumnsWithSidebars',
            defaultMessage: 'Three columns with sidebars layout',
            description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
        },
        threeColumnsWithLeftSidebars: {
            id: 'fabric.editor.threeColumnsWithLeftSidebars',
            defaultMessage: 'Three columns with left sidebar layout',
            description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
        },
        threeColumnsWithRightSidebars: {
            id: 'fabric.editor.threeColumnsWithRightSidebars',
            defaultMessage: 'Three columns with right sidebar layout',
            description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
        },
        floatingToolbarRadioGroupAriaLabel: {
            id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
            defaultMessage: 'Layout options',
            description: "a floating toolbar radiogroup's aria label"
        },
        layoutPlaceholder: {
            id: 'fabric.editor.layout.placeholder',
            defaultMessage: 'Add content',
            description: 'Add placeholder text for empty layout'
        },
        columnOption: {
            id: 'fabric.editor.layout.columnOption',
            defaultMessage: '{count, plural, one {-column} other {{count}-columns}}',
            description: 'column option text for layout'
        }
    });
});
parcelRegister("kmmxF", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e4735e0a5cdca6f9$export$defe85febe8b728c);
    var $7VHMR;
    const $e4735e0a5cdca6f9$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        indent: {
            id: 'fabric.editor.indent',
            defaultMessage: 'Indent',
            description: 'Indent a list item, paragraph or heading'
        },
        outdent: {
            id: 'fabric.editor.outdent',
            defaultMessage: 'Outdent',
            description: 'Outdent a list item, paragraph or heading'
        }
    });
});
parcelRegister("80TXs", function(module, exports) {
    $parcel$export(module.exports, "avatarGroupMessages", ()=>$cedd04a0024a64f8$export$8a0e7c3f8f5b8868);
    var $7VHMR;
    const $cedd04a0024a64f8$export$8a0e7c3f8f5b8868 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editors: {
            id: 'fabric.editor.editors',
            defaultMessage: 'Editors',
            description: 'classifying the people that are currently editing the document'
        }
    });
});
parcelRegister("9QBHe", function(module, exports) {
    $parcel$export(module.exports, "findReplaceMessages", ()=>$b943fdad34912591$export$b46a930e1a386b2e);
    var $7VHMR;
    const $b943fdad34912591$export$b46a930e1a386b2e = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        find: {
            id: 'fabric.editor.find',
            defaultMessage: 'Find',
            description: 'The word or phrase to search for on the document'
        },
        matchCase: {
            id: 'fabric.editor.matchCase',
            defaultMessage: 'Match case',
            description: 'Toggle whether should also match case when searching for text'
        },
        findNext: {
            id: 'fabric.editor.findNext',
            defaultMessage: 'Find next',
            description: 'Locate the next occurrence of the word or phrase that was searched for'
        },
        findPrevious: {
            id: 'fabric.editor.findPrevious',
            defaultMessage: 'Find previous',
            description: 'Locate the previous occurrence of the word or phrase that was searched for'
        },
        closeFindReplaceDialog: {
            id: 'fabric.editor.closeFindReplaceDialog',
            defaultMessage: 'Close',
            description: 'Cancel search and close the "Find and Replace" dialog'
        },
        noResultsFound: {
            id: 'fabric.editor.noResultsFound',
            defaultMessage: 'No results',
            description: 'No matches were found for the word or phrase that was searched for'
        },
        resultsCount: {
            id: 'fabric.editor.resultsCount',
            description: 'Text for selected search match position and total results count',
            defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
        },
        findReplaceToolbarButton: {
            id: 'fabric.editor.findReplaceToolbarButton',
            defaultMessage: 'Find and replace',
            description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
        },
        replaceWith: {
            id: 'fabric.editor.replaceWith',
            defaultMessage: 'Replace with',
            description: 'The value that will replace the word or phrase that was searched for'
        },
        replace: {
            id: 'fabric.editor.replace',
            defaultMessage: 'Replace',
            description: 'Replace only the currently selected instance of the word or phrase'
        },
        replaceAll: {
            id: 'fabric.editor.replaceAll',
            defaultMessage: 'Replace all',
            description: 'Replace all instances of the word or phrase throughout the entire document'
        },
        replaceSuccess: {
            id: 'fabric.editor.replaceSuccess',
            defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
            description: 'Text when replacement succesfully done'
        }
    });
});
parcelRegister("kAM3u", function(module, exports) {
    $parcel$export(module.exports, "textColorMessages", ()=>$147c4cd461faf1fe$export$effb4ee8b6f74abe);
    var $7VHMR;
    const $147c4cd461faf1fe$export$effb4ee8b6f74abe = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        textColor: {
            id: 'fabric.editor.textColor',
            defaultMessage: '{selectedColorName} Text color',
            description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
        },
        textColorTooltip: {
            id: 'fabric.editor.textColorTooltip',
            defaultMessage: 'Text color',
            description: 'Toolip of menu that provides access to various colors of text.'
        }
    });
});
parcelRegister("6lWmZ", function(module, exports) {
    $parcel$export(module.exports, "tasksAndDecisionsMessages", ()=>$65d46911a2519e83$export$273d864e9e6d0b1f);
    var $7VHMR;
    const $65d46911a2519e83$export$273d864e9e6d0b1f = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        taskPlaceholder: {
            id: 'fabric.editor.taskPlaceholder',
            defaultMessage: "Type your action, use '@' to assign to someone.",
            description: 'Placeholder description for an empty action/task in the editor'
        },
        decisionPlaceholder: {
            id: 'fabric.editor.decisionPlaceholder',
            defaultMessage: "Add a decision\u2026",
            description: 'Placeholder description for an empty decision in the editor'
        },
        editAccessTitle: {
            id: 'fabric.editor.editAccessTitle',
            defaultMessage: 'You need edit access',
            description: 'Title in the popup when we click on action item checkbox without edit permission'
        },
        requestToEditDescription: {
            id: 'fabric.editor.requestToEditDescription',
            defaultMessage: 'When you request access, the page owner will receive a notification.',
            description: 'Description in the popup when we click on action item checkbox without edit permission'
        },
        requestToEdit: {
            id: 'fabric.editor.requestToEdit',
            defaultMessage: 'Request to edit',
            description: 'Button in the popup when we click on action item checkbox without edit permission'
        },
        dismiss: {
            id: 'fabric.editor.requestToEditDismiss',
            defaultMessage: 'Dismiss',
            description: 'Button in the popup when we click on dismiss without edit permission'
        }
    });
});
parcelRegister("ixwvf", function(module, exports) {
    $parcel$export(module.exports, "placeholderTextMessages", ()=>$358e275c47040b0e$export$ee8ab8a034b5a8bd);
    var $7VHMR;
    const $358e275c47040b0e$export$ee8ab8a034b5a8bd = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderTextPlaceholder: {
            id: 'fabric.editor.placeholderTextPlaceholder',
            defaultMessage: 'Add placeholder text',
            description: ''
        }
    });
});
parcelRegister("fJm1A", function(module, exports) {
    $parcel$export(module.exports, "pasteOptionsToolbarMessages", ()=>$b0fedd2e9a93e39a$export$703e803e9cb0cea4);
    var $7VHMR;
    const $b0fedd2e9a93e39a$export$703e803e9cb0cea4 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pasteOptions: {
            id: 'fabric.editor.pasteOptions',
            defaultMessage: 'Paste options',
            description: 'Opens a menu with additional paste options'
        },
        plainText: {
            id: 'fabric.editor.plainText',
            defaultMessage: 'Use plain text',
            description: 'Converts pasted text into plain text'
        },
        markdown: {
            id: 'fabric.editor.useMarkdown',
            defaultMessage: 'Use Markdown',
            description: 'Converts pasted text into Markdown'
        },
        richText: {
            id: 'fabric.editor.richText',
            defaultMessage: 'Use rich text',
            description: 'Converts pasted text into Rich text'
        }
    });
});
parcelRegister("ecAvy", function(module, exports) {
    $parcel$export(module.exports, "panelMessages", ()=>$e955dc2d97d725ff$export$7bb18eb6f9170174);
    var $7VHMR;
    const $e955dc2d97d725ff$export$7bb18eb6f9170174 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        info: {
            id: 'fabric.editor.info',
            defaultMessage: 'Info',
            description: 'Panels provide a way to highlight text. The info panel has a blue background.'
        },
        note: {
            id: 'fabric.editor.note',
            defaultMessage: 'Note',
            description: 'Panels provide a way to highlight text. The note panel has a purple background.'
        },
        success: {
            id: 'fabric.editor.success',
            defaultMessage: 'Success',
            description: 'Panels provide a way to highlight text. The success panel has a green background.'
        },
        warning: {
            id: 'fabric.editor.warning',
            defaultMessage: 'Warning',
            description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
        },
        error: {
            id: 'fabric.editor.error',
            defaultMessage: 'Error',
            description: 'Panels provide a way to highlight text. The error panel has a red background.'
        },
        emoji: {
            id: 'fabric.editor.panel.emoji',
            defaultMessage: 'Add emoji',
            description: 'Select the panel icon'
        },
        backgroundColor: {
            id: 'fabric.editor.panel.backgroundColor',
            defaultMessage: 'Background color',
            description: 'Select the panel background color.'
        },
        panelsGroup: {
            id: 'fabric.editor.panel.panelsGroup',
            defaultMessage: 'Panel Types',
            description: 'aria-label for group of panels the floating toolbar'
        }
    });
});
parcelRegister("7ywdr", function(module, exports) {
    $parcel$export(module.exports, "mentionMessages", ()=>$a3d6d16f96d339d5$export$33aafd5ccbbbd00a);
    var $7VHMR;
    const $a3d6d16f96d339d5$export$33aafd5ccbbbd00a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteItemTitle: {
            id: 'fabric.editor.inviteItem.title',
            defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
            description: 'Title of the invite teammate item in typeahead plugin'
        },
        mentionsAddLabel: {
            id: 'fabric.editor.mentionsAddLabel',
            defaultMessage: 'add-icon',
            description: 'icon label to describe adding a new mention'
        },
        mentionsIconLabel: {
            id: 'fabric.editor.mentionsIconLabel',
            defaultMessage: 'Mention',
            description: 'icon label to describe the mention icon'
        },
        mentionsNodeLabel: {
            id: 'fabric.editor.mentionNode.label',
            defaultMessage: 'Tagged user',
            description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
        }
    });
});
parcelRegister("1ElKj", function(module, exports) {
    $parcel$export(module.exports, "helpDialogMessages", ()=>$691908dbd48d7aae$export$83c85447c71428ba);
    var $7VHMR;
    const $691908dbd48d7aae$export$83c85447c71428ba = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editorHelp: {
            id: 'fabric.editor.editorHelp',
            defaultMessage: 'Editor help',
            description: 'Title of editor help dialog.'
        },
        helpDialogTips: {
            id: 'fabric.editor.helpDialogTips',
            defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
            description: 'Hint about how to open a dialog quickly using a shortcut.'
        },
        keyboardShortcuts: {
            id: 'fabric.editor.keyboardShortcuts',
            defaultMessage: 'Keyboard shortcuts',
            description: ''
        },
        markdown: {
            id: 'fabric.editor.markdown',
            defaultMessage: 'Markdown',
            description: 'It is a name of popular markup language.'
        },
        pastePlainText: {
            id: 'fabric.editor.pastePlainText',
            defaultMessage: 'Paste plain text',
            description: ''
        },
        CheckUncheckActionItem: {
            id: 'fabric.editor.checkUncheckActionItem',
            defaultMessage: 'Toggle action item',
            description: 'For Check/Uncheck Action item use shortcut'
        },
        InsertTableColumn: {
            id: 'fabric.editor.insertTableColumn',
            defaultMessage: 'Insert table column',
            description: 'For insert table column'
        },
        InsertTableRow: {
            id: 'fabric.editor.insertTableRow',
            defaultMessage: 'Insert table row',
            description: 'For insert table row'
        },
        altText: {
            id: 'fabric.editor.altText',
            defaultMessage: 'Alt text',
            description: 'Alternative text for image.'
        },
        selectTableRow: {
            id: 'fabric.editor.selectTableRow',
            defaultMessage: 'Select table row',
            description: 'Hint for selecting a table row using a shortcut'
        },
        selectTableColumn: {
            id: 'fabric.editor.selectTableColumn',
            defaultMessage: 'Select table column',
            description: 'Hint for selecting a table column using a shortcut'
        },
        selectColumnResize: {
            id: 'fabric.editor.selectColumnResize',
            defaultMessage: 'Select column resize',
            description: 'Hint for selecting a column resize a shortcut'
        },
        increaseSize: {
            id: 'fabric.editor.increaseSize',
            defaultMessage: 'Increase table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
        },
        decreaseSize: {
            id: 'fabric.editor.decreaseSize',
            defaultMessage: 'Decrease table or media size',
            description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
        },
        openCellOptions: {
            id: 'fabric.editor.openCellOptions',
            defaultMessage: 'Open cell options',
            description: 'Keyboard shortcut to open cell options.'
        },
        focusTableResizeHandle: {
            id: 'fabric.editor.focusTableResizeHandle',
            defaultMessage: 'Focus table resize handle',
            description: 'Focus table resize handle'
        },
        closeHelpDialog: {
            id: 'fabric.editor.closeHelpDialog',
            defaultMessage: 'Close help dialog',
            description: ''
        },
        quickInsert: {
            id: 'fabric.editor.quickInsert',
            defaultMessage: 'Quick insert',
            description: 'Name of a feature, which let you insert items quickly.'
        },
        highlightColor: {
            id: 'fabric.editor.highlightColor',
            defaultMessage: 'Toggle highlight color palette',
            description: 'Keyboard shortcut to toggle highlight color palette.'
        }
    });
});
parcelRegister("3AEXe", function(module, exports) {
    $parcel$export(module.exports, "mediaInsertMessages", ()=>$a755ba82139b4a7d$export$7eb9dc59242bbc45);
    var $7VHMR;
    const $a755ba82139b4a7d$export$7eb9dc59242bbc45 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadPreview: {
            id: 'fabric.editor.media.insert.loadPreview',
            defaultMessage: 'Load preview',
            description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
        },
        insert: {
            id: 'fabric.editor.media.insert.insert',
            defaultMessage: 'Insert',
            description: 'Text on the modal action button that inserts the linked media file into the editor document'
        },
        pasteLinkToUpload: {
            id: 'fabric.editor.media.insert.pasteLinkToUpload',
            defaultMessage: 'Paste link to upload',
            description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
        },
        cancel: {
            id: 'fabric.editor.media.insert.cancel',
            defaultMessage: 'Cancel',
            description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
        },
        fromUrlErrorMessage: {
            id: 'fabric.editor.media.insert.fromUrlErrorMessage',
            defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
            description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
        },
        fromUrlWarning: {
            id: 'fabric.editor.media.insert.fromUrlWarning',
            defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
            description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
        },
        localFileNetworkErrorMessage: {
            id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
            defaultMessage: 'File upload error. Check file path or network.',
            description: 'Error message displayed when a network error occurs during file upload'
        },
        localFileErrorMessage: {
            id: 'fabric.editor.media.insert.localFileErrorMessage',
            defaultMessage: "This file couldn\u2019t be uploaded.",
            description: 'Generic catch-all error message displayed when file upload fails'
        },
        mediaAlt: {
            id: 'fabric.editor.media.insert.mediaAlt',
            defaultMessage: 'Preview for uploaded image or video file',
            description: 'Alt text describing a preview of an image uploaded.'
        },
        upload: {
            id: 'fabric.editor.media.insert.upload',
            defaultMessage: 'Upload',
            description: 'Text on a button that opens a file picker dialog to upload a media file'
        },
        linkTabTitle: {
            id: 'fabric.editor.media.insert.linkTabTitle',
            defaultMessage: 'Link',
            description: 'Title of the navigation tab that allows users to insert media from a URL or link'
        },
        fileTabTitle: {
            id: 'fabric.editor.media.insert.fileTabTitle',
            defaultMessage: 'File',
            description: 'Title of the navigation tab that allows users to upload local media files'
        },
        mediaPickerPopupAriaLabel: {
            id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
            defaultMessage: 'Media picker',
            description: 'Accessibility label for the media picker popup'
        },
        invalidUrlErrorMessage: {
            id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
            defaultMessage: 'Invalid link',
            description: 'Error message displayed when a user tries to insert media from an invalid URL'
        }
    });
});
parcelRegister("eQcNy", function(module, exports) {
    $parcel$export(module.exports, "walkUpTreeUntil", ()=>$ab609be3c0cbf6e9$export$df14aaf7a527ab0c);
    $parcel$export(module.exports, "unwrap", ()=>$ab609be3c0cbf6e9$export$debb760848ca95a);
    $parcel$export(module.exports, "removeNestedEmptyEls", ()=>$ab609be3c0cbf6e9$export$5b66dc78851adb5e);
    $parcel$export(module.exports, "containsClassName", ()=>$ab609be3c0cbf6e9$export$c8913a477cc44663);
    $parcel$export(module.exports, "closest", ()=>$ab609be3c0cbf6e9$export$ff7f7c97cdce86e);
    $parcel$export(module.exports, "closestElement", ()=>$ab609be3c0cbf6e9$export$d508bcfb7f019487);
    $parcel$export(module.exports, "parsePx", ()=>$ab609be3c0cbf6e9$export$b0eef8cd00b29d5c);
    $parcel$export(module.exports, "maphElem", ()=>$ab609be3c0cbf6e9$export$5b6ab01a6efa50e2);
    function $ab609be3c0cbf6e9$export$df14aaf7a527ab0c(element, shouldStop) {
        let rootElement = element;
        while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
        return rootElement;
    }
    function $ab609be3c0cbf6e9$export$debb760848ca95a(parent, wrapped) {
        const docsFragment = document.createDocumentFragment();
        Array.from(wrapped.children).forEach((child)=>{
            docsFragment.appendChild(child);
        });
        parent.replaceChild(docsFragment, wrapped);
    }
    function $ab609be3c0cbf6e9$export$5b66dc78851adb5e(el) {
        while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
            const parentEl = el.parentElement;
            parentEl.removeChild(el);
            el = parentEl;
        }
    }
    const $ab609be3c0cbf6e9$export$c8913a477cc44663 = (node, className)=>{
        if (!node) return false;
        if (node.classList && node.classList.contains) return node.classList.contains(className);
        if (!node.className) return false;
        const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
        return classNames.split(' ').indexOf(className) !== -1;
    };
    function $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s) {
        if (!node) return null;
        let el = node;
        if (!document.documentElement || !document.documentElement.contains(el)) return null;
        if (el.closest) return el.closest(s);
        do {
            const matchfn = el.matches ? el.matches : el.msMatchesSelector;
            if (matchfn && matchfn.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        }while (el !== null && el.nodeType === 1)
        return null;
    }
    function $ab609be3c0cbf6e9$export$d508bcfb7f019487(node, s) {
        return $ab609be3c0cbf6e9$export$ff7f7c97cdce86e(node, s);
    }
    function $ab609be3c0cbf6e9$export$b0eef8cd00b29d5c(pxStr) {
        if (!pxStr.endsWith('px')) return undefined;
        const maybeNumber = parseInt(pxStr, 10);
        return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
    }
    function $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback) {
        const array = [];
        for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
        return array;
    }
    function $ab609be3c0cbf6e9$export$5b6ab01a6efa50e2(elem, callback) {
        return $ab609be3c0cbf6e9$export$b2d5d4f1aeebddf1(elem, callback);
    }
});
parcelRegister("l8Gxi", function(module, exports) {
    $parcel$export(module.exports, "RendererCssClassName", ()=>$ca55565f908e8e5d$export$91f3bbbf974496e2);
    const $ca55565f908e8e5d$var$clPrefix = 'ak-renderer-';
    const $ca55565f908e8e5d$export$91f3bbbf974496e2 = {
        DOCUMENT: `${$ca55565f908e8e5d$var$clPrefix}document`,
        EXTENSION: `${$ca55565f908e8e5d$var$clPrefix}extension`,
        EXTENSION_CENTER_ALIGN: `${$ca55565f908e8e5d$var$clPrefix}extension-center-align`,
        EXTENSION_OVERFLOW_CONTAINER: `${$ca55565f908e8e5d$var$clPrefix}extension-overflow-container`,
        NUMBER_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}table-number-column`,
        SORTABLE_COLUMN_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column__wrapper`,
        SORTABLE_COLUMN: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sortable-column`,
        SORTABLE_COLUMN_ICON_WRAPPER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__wrapper`,
        SORTABLE_COLUMN_NO_ORDER: `${$ca55565f908e8e5d$var$clPrefix}tableHeader-sorting-icon__no-order`
    };
});
parcelRegister("8Eu7T", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$19f8e43ef61748ed$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $dWAZk = parcelRequire("dWAZk");
    var $1KzE6;
    var $knXBU;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $19f8e43ef61748ed$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        fireAnalyticsEvent(event) {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $dWAZk.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        }
        hasFallback() {
            return typeof this.props.fallbackComponent !== 'undefined';
        }
        shouldRecover() {
            return this.hasFallback() && this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            const additionalInfo = this.props.additionalInfo ?? '';
            this.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CRASHED,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error?.message}`,
                    componentStack: errorInfo?.componentStack || undefined,
                    errorRethrown: Boolean(this.props.rethrowError)
                }
            });
            (0, (0, parcelRequire("1KzE6")).logException)(error, {
                location: 'renderer'
            });
            const pattern = /Failed to execute.*on 'Node'.*/;
            const matchesPattern = pattern.test(error.message);
            if (matchesPattern) {
                this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CAUGHT_DOM_ERROR,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        errorMessage: `${additionalInfo}${error?.message}`
                    }
                });
                this.setState(()=>({
                        domError: true
                    }));
            }
            if (this.hasFallback()) this.setState({
                errorCaptured: true
            }, ()=>{
                if (this.props.rethrowError) throw error;
            });
        }
        render() {
            if (this.state.domError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: (0, ($parcel$interopDefault($7Jxgt)))()
            }, this.props.children);
            if (this.shouldRecover()) return this.props.fallbackComponent;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                errorCaptured: false,
                domError: false
            };
        }
    }
});
parcelRegister("1KzE6", function(module, exports) {
    $parcel$export(module.exports, "logException", ()=>$8cb678cf4830ec10$export$f86b2a1a2ce291b3);
    var $8eFcy;
    const $8cb678cf4830ec10$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
    const $8cb678cf4830ec10$var$packageName = 'editor-common';
    const $8cb678cf4830ec10$var$packageVersion = "0.0.0-use.local";
    const $8cb678cf4830ec10$var$sanitiseSentryEvents = (data, _hint)=>{
        if (data.request) delete data.request.url;
        return data;
    };
    const $8cb678cf4830ec10$export$f86b2a1a2ce291b3 = async (error, tags)=>{
        try {
            const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("hv9fq"));
            const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("2dUbL"));
            const sentryOptions = {
                dsn: (0, (0, parcelRequire("8eFcy")).isFedRamp)() ? undefined : $8cb678cf4830ec10$var$SENTRY_DSN,
                release: `${$8cb678cf4830ec10$var$packageName}@${$8cb678cf4830ec10$var$packageVersion}`,
                environment: undefined ?? 'unknown',
                ignoreErrors: [
                    /^network error/i,
                    /^network failure/i,
                    'TypeError: Failed to fetch',
                    'ResizeObserver loop limit exceeded',
                    /ResizeObserver loop completed with undelivered notifications/
                ],
                autoSessionTracking: false,
                integrations: (_integrations)=>[
                        ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                        new ExtraErrorData()
                    ],
                beforeSend: $8cb678cf4830ec10$var$sanitiseSentryEvents
            };
            const client = new BrowserClient(sentryOptions);
            const hub = getCurrentHub();
            hub.bindClient(client);
            hub.withScope((scope)=>{
                scope.setTags({
                    'jira-bundler': window.BUNDLER_VERSION,
                    'jira-variant': window.BUILD_VARIANT,
                    'jira-release': window.BUILD_KEY,
                    'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                    ...tags
                });
                scope.clearBreadcrumbs();
                hub.captureException(error);
            });
            return client.close();
        } catch (_error) {}
    };
});
parcelRegister("8eFcy", function(module, exports) {
    $parcel$export(module.exports, "isFedRamp", ()=>$1a8a754a294d51a4$export$64d6499adf9b2e51);
    const $1a8a754a294d51a4$var$FEDRAMP_MODERATE = 'fedramp-moderate';
    function $1a8a754a294d51a4$export$64d6499adf9b2e51() {
        const global = globalThis;
        const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (env) return env === $1a8a754a294d51a4$var$FEDRAMP_MODERATE;
        const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
        return matches ? matches.length > 0 : false;
    }
});
parcelRegister("hv9fq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("56SDo").then(()=>parcelRequire('hFoxV'));
});
parcelRegister("2dUbL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a12Xb").then(()=>parcelRequire('1dEW4'));
});
parcelRegister("knXBU", function(module, exports) {
    $parcel$export(module.exports, "PLATFORM", ()=>$11894d4d5d86b4b1$export$88c4881e092abcaf);
    $parcel$export(module.exports, "MODE", ()=>$11894d4d5d86b4b1$export$e48589d9e4824227);
    var $11894d4d5d86b4b1$export$88c4881e092abcaf;
    (function(PLATFORM) {
        PLATFORM["NATIVE"] = "mobileNative";
        PLATFORM["HYBRID"] = "mobileHybrid";
        PLATFORM["WEB"] = "web";
    })($11894d4d5d86b4b1$export$88c4881e092abcaf || ($11894d4d5d86b4b1$export$88c4881e092abcaf = {}));
    var $11894d4d5d86b4b1$export$e48589d9e4824227;
    (function(MODE) {
        MODE["RENDERER"] = "renderer";
        MODE["EDITOR"] = "editor";
    })($11894d4d5d86b4b1$export$e48589d9e4824227 || ($11894d4d5d86b4b1$export$e48589d9e4824227 = {}));
    var $11894d4d5d86b4b1$var$RESOLVE_METHOD;
    (function(RESOLVE_METHOD) {
        RESOLVE_METHOD["COMPONENT"] = "component";
        RESOLVE_METHOD["CONSUMER"] = "consumer";
        RESOLVE_METHOD["ORPHANED"] = "orphaned";
    })($11894d4d5d86b4b1$var$RESOLVE_METHOD || ($11894d4d5d86b4b1$var$RESOLVE_METHOD = {}));
});
parcelRegister("cWCI0", function(module, exports) {
    $parcel$export(module.exports, "EVENT_TYPE", ()=>$78ed418dcea0e38c$export$76a2e4c433c23bb9);
    $parcel$export(module.exports, "ACTION", ()=>$78ed418dcea0e38c$export$9523889e0a5da4ba);
    $parcel$export(module.exports, "ACTION_SUBJECT", ()=>$78ed418dcea0e38c$export$7525482b5931e326);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$78ed418dcea0e38c$export$9957974f8b4d8f74);
    var $78ed418dcea0e38c$export$76a2e4c433c23bb9;
    (function(EVENT_TYPE) {
        EVENT_TYPE["OPERATIONAL"] = "operational";
        EVENT_TYPE["SCREEN"] = "screen";
        EVENT_TYPE["TRACK"] = "track";
        EVENT_TYPE["UI"] = "ui";
    })($78ed418dcea0e38c$export$76a2e4c433c23bb9 || ($78ed418dcea0e38c$export$76a2e4c433c23bb9 = {}));
    var $78ed418dcea0e38c$export$9523889e0a5da4ba;
    (function(ACTION) {
        ACTION["STARTED"] = "started";
        ACTION["RENDERED"] = "rendered";
        ACTION["RENDERER_TTI"] = "tti";
        ACTION["CRASHED"] = "unhandledErrorCaught";
        ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
        ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
        ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
        ACTION["CLICKED"] = "clicked";
        ACTION["VIEWED"] = "viewed";
        ACTION["VISITED"] = "visited";
        ACTION["SORT_COLUMN"] = "sortedColumn";
        ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
        ACTION["TOGGLE_EXPAND"] = "toggleExpand";
        ACTION["INSERTED"] = "inserted";
        ACTION["OPENED"] = "opened";
        ACTION["CLOSED"] = "closed";
        ACTION["DELETED"] = "deleted";
        ACTION["EDITED"] = "edited";
        ACTION["RESOLVED"] = "resolved";
        ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
        ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
        ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    })($78ed418dcea0e38c$export$9523889e0a5da4ba || ($78ed418dcea0e38c$export$9523889e0a5da4ba = {}));
    var $78ed418dcea0e38c$export$7525482b5931e326;
    (function(ACTION_SUBJECT) {
        ACTION_SUBJECT["RENDERER"] = "renderer";
        ACTION_SUBJECT["BUTTON"] = "button";
        ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
        ACTION_SUBJECT["TABLE"] = "table";
        ACTION_SUBJECT["EXPAND"] = "expand";
        ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
        ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
        ACTION_SUBJECT["LINK"] = "link";
        ACTION_SUBJECT["ANNOTATION"] = "annotation";
        ACTION_SUBJECT["MEDIA"] = "media";
    })($78ed418dcea0e38c$export$7525482b5931e326 || ($78ed418dcea0e38c$export$7525482b5931e326 = {}));
    var $78ed418dcea0e38c$export$9957974f8b4d8f74;
    (function(ACTION_SUBJECT_ID) {
        ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
        ACTION_SUBJECT_ID["LINK"] = "link";
        ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
        ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
        ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    })($78ed418dcea0e38c$export$9957974f8b4d8f74 || ($78ed418dcea0e38c$export$9957974f8b4d8f74 = {}));
});
parcelRegister("4YrGg", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsPositionContext", ()=>$5dd0541565473935$export$8c8c3e12db6c0591);
    $parcel$export(module.exports, "AnnotationsWrapper", ()=>$5dd0541565473935$export$cef0157dd42cbb3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $eka68;
    var $8Mz83;
    var $iYAgE;
    var $joddd;
    var $1oOiu;
    var $2NMNM;
    var $2EsbE;
    var $kuusl;
    var $4dDLS;
    var $5uoEK;
    const $5dd0541565473935$var$LoadAnnotations = (0, ($parcel$interopDefault($5uXOq))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        (0, (0, parcelRequire("joddd")).useLoadAnnotations)({
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        });
        return null;
    });
    const $5dd0541565473935$export$8c8c3e12db6c0591 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        startPos: 1
    });
    const $5dd0541565473935$export$cef0157dd42cbb3f = (props)=>{
        const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
        const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
        const inlineCommentAnnotationsState = (0, (0, parcelRequire("1oOiu")).useAnnotationStateByTypeEvent)({
            type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT,
            updateSubscriber: updateSubscriber || null
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).ProvidersContext).Provider, {
            value: annotationProvider
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext).Provider, {
            value: inlineCommentAnnotationsState
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2EsbE")).AnnotationRangeProvider), {
            allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kuusl")).AnnotationHoverContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Mz83")).AnnotationsContextWrapper), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5dd0541565473935$var$LoadAnnotations, {
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eka68")).AnnotationView), {
            isNestedRender: isNestedRender,
            createAnalyticsEvent: createAnalyticsEvent
        }), children)))));
    };
});
parcelRegister("eka68", function(module, exports) {
    $parcel$export(module.exports, "AnnotationView", ()=>$38b360e678e45e5a$export$41cd4a02859c2806);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    var $1oOiu;
    var $fCNtA;
    const $38b360e678e45e5a$export$41cd4a02859c2806 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        const actionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const inlineCommentProvider = providers && providers.inlineComment;
        const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
        const viewComponentProps = (0, (0, parcelRequire("1oOiu")).useAnnotationClickEvent)({
            updateSubscriber: updateSubscriber,
            createAnalyticsEvent: props.createAnalyticsEvent,
            isNestedRender: props.isNestedRender
        });
        const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
        const deleteAnnotation = (0, $5uXOq.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
            actionContext
        ]);
        const getInlineNodeTypes = (0, $5uXOq.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
            actionContext
        ]);
        if (ViewComponent && viewComponentProps) {
            const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ViewComponent, {
                annotations: annotations,
                clickElementTarget: clickElementTarget,
                deleteAnnotation: deleteAnnotation,
                getInlineNodeTypes: getInlineNodeTypes
            });
        }
        return null;
    };
});
parcelRegister("iYAgE", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsDraftContext", ()=>$1cf3b601714e6f28$export$365d1799d81a236d);
    $parcel$export(module.exports, "ProvidersContext", ()=>$1cf3b601714e6f28$export$6a26b015ac619737);
    $parcel$export(module.exports, "InlineCommentsStateContext", ()=>$1cf3b601714e6f28$export$aafe46a36ef535ba);
    $parcel$export(module.exports, "AnnotationsDraftContextWrapper", ()=>$1cf3b601714e6f28$export$153126608e00390);
    var $5uXOq = parcelRequire("5uXOq");
    const $1cf3b601714e6f28$export$365d1799d81a236d = (0, $5uXOq.createContext)(null);
    const $1cf3b601714e6f28$export$6a26b015ac619737 = (0, $5uXOq.createContext)(null);
    const $1cf3b601714e6f28$export$aafe46a36ef535ba = (0, $5uXOq.createContext)({});
    class $1cf3b601714e6f28$export$153126608e00390 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            const { position: position } = this.state;
            const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
            const clearAnnotationDraft = this.clearAnnotationDraft;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($1cf3b601714e6f28$export$365d1799d81a236d.Provider, {
                value: position
            }, children({
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }
        constructor(...args){
            super(...args), this.state = {
                position: null
            }, this.applyAnnotationDraftAt = (nextPosition)=>{
                const { setDraftRange: setDraftRange } = this.props;
                setDraftRange();
                this.setState({
                    position: nextPosition
                });
            }, this.clearAnnotationDraft = ()=>{
                const { clearDraftRange: clearDraftRange } = this.props;
                clearDraftRange();
                this.setState({
                    position: null
                });
            };
        }
    }
});
parcelRegister("1oOiu", function(module, exports) {
    $parcel$export(module.exports, "useAnnotationStateByTypeEvent", ()=>$477334c02b9da473$export$95f9f9045e92d283);
    $parcel$export(module.exports, "useHasFocusEvent", ()=>$477334c02b9da473$export$48f5d7f6702be07c);
    $parcel$export(module.exports, "useAnnotationClickEvent", ()=>$477334c02b9da473$export$26cf539704e444c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $dEtqo;
    var $5IPCv;
    var $88i6h;
    var $gkwXh;
    var $dWAZk = parcelRequire("dWAZk");
    const $477334c02b9da473$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
        const [states, setStates] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                if (!payload) return;
                const nextStates = Object.values(payload).reduce((acc, curr)=>{
                    if (curr.id && curr.annotationType === type) {
                        const isEmpty = curr.state === null || curr.state === undefined;
                        return {
                            ...acc,
                            [curr.id]: !isEmpty ? curr.state : states[curr.id]
                        };
                    }
                    return acc;
                }, {});
                setStates({
                    ...states,
                    ...nextStates
                });
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }, [
            states,
            type,
            updateSubscriber
        ]);
        return states;
    };
    const $477334c02b9da473$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
        const [hasFocus, setHasFocus] = (0, $5uXOq.useState)(false);
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber) return;
            const cb = (payload)=>{
                setHasFocus(payload && payload.annotationId === id);
            };
            const callbackForHoveredAnnotation = (payload)=>{
                setIsHovered(payload && payload.annotationId === id);
            };
            const removeFocus = ()=>{
                setHasFocus(false);
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            const removeHoverEffect = ()=>{
                setIsHovered(false);
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }, [
            id,
            updateSubscriber,
            isInlineCommentsKbAccessible
        ]);
        return {
            hasFocus: hasFocus,
            isHovered: isHovered
        };
    };
    const $477334c02b9da473$export$26cf539704e444c1 = (props)=>{
        const [annotationClickEvent, setAnnotationClickEvent] = (0, $5uXOq.useState)(null);
        const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!updateSubscriber || isNestedRender) return;
            const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
                const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                        id: id,
                        type: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
                    }));
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: annotationsByType.length || 0,
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
                setAnnotationClickEvent({
                    annotations: annotationsByType,
                    clickElementTarget: eventTarget
                });
            };
            const deselectCb = ()=>{
                setAnnotationClickEvent({
                    annotations: [],
                    clickElementTarget: undefined
                });
                if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
            };
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }, [
            updateSubscriber,
            createAnalyticsEvent,
            isInlineCommentsKbAccessible,
            isNestedRender
        ]);
        return annotationClickEvent;
    };
});
parcelRegister("dEtqo", function(module, exports) {
    $parcel$export(module.exports, "AnnotationUpdateEvent", ()=>$916fd31c0363f129$export$c1c4b33b4e7b1c70);
    var $6Oghe = parcelRequire("6Oghe");
    var $916fd31c0363f129$export$c1c4b33b4e7b1c70;
    (function(AnnotationUpdateEvent) {
        AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
        AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
        AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
        AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
        AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
        AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    })($916fd31c0363f129$export$c1c4b33b4e7b1c70 || ($916fd31c0363f129$export$c1c4b33b4e7b1c70 = {}));
    class $916fd31c0363f129$export$7cc60aa9ef845515 {
        emit(event, params) {
            if (typeof params === 'undefined') return this.emitter.emit(event);
            return this.emitter.emit(event, params);
        }
        on(event, listener) {
            return this.emitter.on(event, listener);
        }
        off(event, listener) {
            return this.emitter.removeListener(event, listener);
        }
        listeners(event) {
            return this.emitter.listeners(event);
        }
        constructor(){
            this.emitter = new (0, ($parcel$interopDefault($6Oghe)))();
        }
    }
});
parcelRegister("6Oghe", function(module, exports) {
    'use strict';
    var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
    var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
        return Function.prototype.apply.call(target, receiver, args);
    };
    var $4f5409da028b4771$var$ReflectOwnKeys;
    if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
    else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
    };
    else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
        return Object.getOwnPropertyNames(target);
    };
    function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
        if (console && console.warn) console.warn(warning);
    }
    var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
        return value !== value;
    };
    function $4f5409da028b4771$var$EventEmitter() {
        $4f5409da028b4771$var$EventEmitter.init.call(this);
    }
    module.exports = $4f5409da028b4771$var$EventEmitter;
    module.exports.once = $4f5409da028b4771$var$once;
    $4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
    $4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
    $4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
    $4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
    var $4f5409da028b4771$var$defaultMaxListeners = 10;
    function $4f5409da028b4771$var$checkListener(listener) {
        if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
    }
    Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
        enumerable: true,
        get: function() {
            return $4f5409da028b4771$var$defaultMaxListeners;
        },
        set: function(arg) {
            if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
            $4f5409da028b4771$var$defaultMaxListeners = arg;
        }
    });
    $4f5409da028b4771$var$EventEmitter.init = function() {
        if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        }
        this._maxListeners = this._maxListeners || undefined;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
        if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
        this._maxListeners = n;
        return this;
    };
    function $4f5409da028b4771$var$_getMaxListeners(that) {
        if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
        return that._maxListeners;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
        return $4f5409da028b4771$var$_getMaxListeners(this);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
        var args = [];
        for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
        var doError = type === 'error';
        var events = this._events;
        if (events !== undefined) doError = doError && events.error === undefined;
        else if (!doError) return false;
        if (doError) {
            var er;
            if (args.length > 0) er = args[0];
            if (er instanceof Error) throw er;
            var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
            err.context = er;
            throw err;
        }
        var handler = events[type];
        if (handler === undefined) return false;
        if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
        else {
            var len = handler.length;
            var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
            for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
        }
        return true;
    };
    function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
        var m;
        var events;
        var existing;
        $4f5409da028b4771$var$checkListener(listener);
        events = target._events;
        if (events === undefined) {
            events = target._events = Object.create(null);
            target._eventsCount = 0;
        } else {
            if (events.newListener !== undefined) {
                target.emit('newListener', type, listener.listener ? listener.listener : listener);
                events = target._events;
            }
            existing = events[type];
        }
        if (existing === undefined) {
            existing = events[type] = listener;
            ++target._eventsCount;
        } else {
            if (typeof existing === 'function') existing = events[type] = prepend ? [
                listener,
                existing
            ] : [
                existing,
                listener
            ];
            else if (prepend) existing.unshift(listener);
            else existing.push(listener);
            m = $4f5409da028b4771$var$_getMaxListeners(target);
            if (m > 0 && existing.length > m && !existing.warned) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $4f5409da028b4771$var$ProcessEmitWarning(w);
            }
        }
        return target;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, false);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
    $4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
        return $4f5409da028b4771$var$_addListener(this, type, listener, true);
    };
    function $4f5409da028b4771$var$onceWrapper() {
        if (!this.fired) {
            this.target.removeListener(this.type, this.wrapFn);
            this.fired = true;
            if (arguments.length === 0) return this.listener.call(this.target);
            return this.listener.apply(this.target, arguments);
        }
    }
    function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
        var state = {
            fired: false,
            wrapFn: undefined,
            target: target,
            type: type,
            listener: listener
        };
        var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
        wrapped.listener = listener;
        state.wrapFn = wrapped;
        return wrapped;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
        $4f5409da028b4771$var$checkListener(listener);
        this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
        var list, events, position, i, originalListener;
        $4f5409da028b4771$var$checkListener(listener);
        events = this._events;
        if (events === undefined) return this;
        list = events[type];
        if (list === undefined) return this;
        if (list === listener || list.listener === listener) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else {
                delete events[type];
                if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
            }
        } else if (typeof list !== 'function') {
            position = -1;
            for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
                originalListener = list[i].listener;
                position = i;
                break;
            }
            if (position < 0) return this;
            if (position === 0) list.shift();
            else $4f5409da028b4771$var$spliceOne(list, position);
            if (list.length === 1) events[type] = list[0];
            if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
        }
        return this;
    };
    $4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
    $4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
        var listeners, events, i;
        events = this._events;
        if (events === undefined) return this;
        if (events.removeListener === undefined) {
            if (arguments.length === 0) {
                this._events = Object.create(null);
                this._eventsCount = 0;
            } else if (events[type] !== undefined) {
                if (--this._eventsCount === 0) this._events = Object.create(null);
                else delete events[type];
            }
            return this;
        }
        if (arguments.length === 0) {
            var keys = Object.keys(events);
            var key;
            for(i = 0; i < keys.length; ++i){
                key = keys[i];
                if (key === 'removeListener') continue;
                this.removeAllListeners(key);
            }
            this.removeAllListeners('removeListener');
            this._events = Object.create(null);
            this._eventsCount = 0;
            return this;
        }
        listeners = events[type];
        if (typeof listeners === 'function') this.removeListener(type, listeners);
        else if (listeners !== undefined) for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
        return this;
    };
    function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
        var events = target._events;
        if (events === undefined) return [];
        var evlistener = events[type];
        if (evlistener === undefined) return [];
        if (typeof evlistener === 'function') return unwrap ? [
            evlistener.listener || evlistener
        ] : [
            evlistener
        ];
        return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
    }
    $4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, true);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
        return $4f5409da028b4771$var$_listeners(this, type, false);
    };
    $4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
        if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
        else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
    };
    $4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
    function $4f5409da028b4771$var$listenerCount(type) {
        var events = this._events;
        if (events !== undefined) {
            var evlistener = events[type];
            if (typeof evlistener === 'function') return 1;
            else if (evlistener !== undefined) return evlistener.length;
        }
        return 0;
    }
    $4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
        return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
    };
    function $4f5409da028b4771$var$arrayClone(arr, n) {
        var copy = new Array(n);
        for(var i = 0; i < n; ++i)copy[i] = arr[i];
        return copy;
    }
    function $4f5409da028b4771$var$spliceOne(list, index) {
        for(; index + 1 < list.length; index++)list[index] = list[index + 1];
        list.pop();
    }
    function $4f5409da028b4771$var$unwrapListeners(arr) {
        var ret = new Array(arr.length);
        for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
        return ret;
    }
    function $4f5409da028b4771$var$once(emitter, name) {
        return new Promise(function(resolve, reject) {
            function errorListener(err) {
                emitter.removeListener(name, resolver);
                reject(err);
            }
            function resolver() {
                if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
                resolve([].slice.call(arguments));
            }
            $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
                once: true
            });
            if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
                once: true
            });
        });
    }
    function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
        if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
    }
    function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
        if (typeof emitter.on === 'function') {
            if (flags.once) emitter.once(name, listener);
            else emitter.on(name, listener);
        } else if (typeof emitter.addEventListener === 'function') emitter.addEventListener(name, function wrapListener(arg) {
            if (flags.once) emitter.removeEventListener(name, wrapListener);
            listener(arg);
        });
        else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
    }
});
parcelRegister("fCNtA", function(module, exports) {
    $parcel$export(module.exports, "RendererContext", ()=>$7e61ed70df2336e9$export$1e9ea4edb6d1bfe6);
    $parcel$export(module.exports, "RendererActionsContext", ()=>$7e61ed70df2336e9$export$66feffbad722f9d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $6pY1y;
    const $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6 = (0, ($parcel$interopDefault($5uXOq))).createContext(new (0, (0, parcelRequire("6pY1y")).default)());
    function $7e61ed70df2336e9$export$66feffbad722f9d4({ children: children, context: context }) {
        const actions = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("6pY1y")).default)(true), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Provider, {
            value: context || actions
        }, (0, ($parcel$interopDefault($5uXOq))).Children.only(children));
    }
    const $7e61ed70df2336e9$export$d5fcf151601331bc = $7e61ed70df2336e9$export$1e9ea4edb6d1bfe6.Consumer;
});
parcelRegister("6pY1y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e7850a7dc1aaf7e$export$2e2bcd8739ae039);
    var $hYNZx;
    var $h03xs;
    var $88i6h;
    var $gZGBX;
    var $eS2Dn;
    var $cMPbW;
    var $gkwXh;
    var $hAPWV;
    var $4apTl;
    var $VSDnB;
    class $5e7850a7dc1aaf7e$export$2e2bcd8739ae039 {
        constructor(initFromContext = false){
            this.initFromContext = false;
            this.initFromContext = initFromContext;
            this.transformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
        }
        _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
            if (!this.initFromContext) return;
            else if (!this.ref) this.ref = ref;
            else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
            this.doc = doc;
            this.schema = schema;
            this.onAnalyticsEvent = onAnalyticsEvent;
        }
        _privateUnregisterRenderer() {
            this.doc = undefined;
            this.ref = undefined;
            this.schema = undefined;
        }
        _privateValidatePositionsForAnnotation(from, to) {
            if (!this.doc || !this.schema) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('forbid_comments_on_empty_newlines')) {
                const currentSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(this.doc, from, to);
                if ((0, (0, parcelRequire("h03xs")).isEmptyTextSelection)(currentSelection, this.schema)) return false;
            }
            return (0, (0, parcelRequire("h03xs")).canApplyAnnotationOnRange)({
                from: from,
                to: to
            }, this.doc, this.schema);
        }
        deleteAnnotation(annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const mark = this.schema.marks.annotation.create({
                id: annotationId,
                annotationType: annotationType
            });
            let from;
            let to;
            let nodePos;
            let step;
            this.doc.descendants((node, pos)=>{
                const found = mark.isInSet(node.marks);
                if (found && node.type.name === 'media') nodePos = pos;
                if (found && !from) {
                    from = pos;
                    to = pos + node.nodeSize;
                } else if (found && from) to = pos + node.nodeSize;
                return true;
            });
            if (nodePos !== undefined) step = new (0, (0, parcelRequire("eS2Dn")).RemoveNodeMarkStep)(nodePos, mark);
            else {
                if (from === undefined || to === undefined) return false;
                step = new (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep)(from, to, mark);
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (this.onAnalyticsEvent) {
                const payload = {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).DELETED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        inlineNodeNames: step instanceof (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep) ? (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                            pos: {
                                from: from,
                                to: to
                            },
                            actions: this
                        }) : undefined
                    }
                };
                this.onAnalyticsEvent(payload);
            }
            if (!failed && doc) return {
                step: step,
                doc: this.transformer.encode(doc)
            };
            return false;
        }
        annotate(range, annotationId, annotationType) {
            if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos) return false;
            const { from: from, to: to } = pos;
            const validPositions = this._privateValidatePositionsForAnnotation(from, to);
            if (!validPositions) return false;
            return this.applyAnnotation(pos, {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            });
        }
        isValidAnnotationRange(range) {
            if (!range) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (this.isRendererWithinRange(range)) return false;
            }
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        isRangeAnnotatable(range) {
            try {
                if (!range) return false;
                const { startContainer: startContainer, endContainer: endContainer } = range;
                if (startContainer.parentElement?.closest('.ak-renderer-extension') || endContainer.parentElement?.closest('.ak-renderer-extension')) return false;
                return this.isValidAnnotationRange(range);
            } catch  {
                return false;
            }
        }
        isRendererWithinRange(range) {
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
            return false;
        }
        isValidAnnotationPosition(pos) {
            if (!pos || !this.doc) return false;
            return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
        }
        getPositionFromRange(range) {
            if (!this.doc || !this.schema || !range) return false;
            return (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
        }
        getAnnotationMarks() {
            const { schema: schema, doc: doc } = this;
            if (!schema || !doc) return [];
            const { marks: { annotation: annotationMarkType } } = schema;
            if (!annotationMarkType) return [];
            const marks = [];
            doc.descendants((node)=>{
                const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
                if (!annotationsMark || !annotationsMark.length) return true;
                marks.push(...annotationsMark);
                return false;
            });
            const uniqueMarks = new Map();
            marks.forEach((m)=>{
                uniqueMarks.set(m.attrs.id, m);
            });
            return Array.from(uniqueMarks.values());
        }
        getAnnotationsByPosition(range) {
            if (!this.doc || !this.schema) return [];
            const pos = (0, (0, parcelRequire("cMPbW")).getPosFromRange)(range);
            if (!pos || !this.doc) return [];
            return (0, (0, parcelRequire("h03xs")).getAnnotationIdsFromRange)(pos, this.doc, this.schema);
        }
        applyAnnotation(pos, annotation) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const { annotationId: annotationId, annotationType: annotationType } = annotation;
            let step;
            let targetNodeType;
            const beforeNodePos = from;
            const possibleNode = this.doc.nodeAt(beforeNodePos);
            if (possibleNode?.type.name === 'media') {
                targetNodeType = 'media';
                step = new (0, (0, parcelRequire("eS2Dn")).AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                    id: annotationId,
                    type: annotationType
                }));
            } else {
                const resolvedNode = this.doc.resolve(from).node();
                targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
                step = (0, (0, parcelRequire("cMPbW")).createAnnotationStep)(from, to, {
                    annotationId: annotationId,
                    annotationType: annotationType,
                    schema: this.schema
                });
            }
            const { doc: doc, failed: failed } = step.apply(this.doc);
            if (failed || !doc) return false;
            const originalSelection = doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("hAPWV")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                step: step,
                doc: this.transformer.encode(doc),
                inlineNodeTypes: (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    actions: this,
                    pos: {
                        from: from,
                        to: to
                    }
                }),
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos,
                targetNodeType: targetNodeType
            };
        }
        generateAnnotationIndexMatch(pos) {
            if (!this.doc || !pos || !this.schema) return false;
            const { from: from, to: to } = pos;
            const originalSelection = this.doc.textBetween(from, to);
            const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, (0, parcelRequire("hAPWV")).getIndexMatch)(this.doc, this.schema, originalSelection, from);
            return {
                originalSelection: originalSelection,
                numMatches: numMatches,
                matchIndex: matchIndex,
                pos: blockNodePos
            };
        }
        getInlineNodeTypes(annotationId) {
            if (!this.doc || !this.schema) return [];
            return (0, (0, parcelRequire("h03xs")).getAnnotationInlineNodeTypes)({
                doc: this.doc,
                schema: this.schema
            }, annotationId);
        }
    }
});
parcelRegister("hYNZx", function(module, exports) {
    $parcel$export(module.exports, "SchemaStage", ()=>$c960adc5c7547145$export$933e6445c497ffd5);
    $parcel$export(module.exports, "JSONTransformer", ()=>$c960adc5c7547145$export$98cb1d9308d0944d);
    var $ajpes = parcelRequire("ajpes");
    var $8vlrc;
    var $cUwVZ;
    var $7kC9H;
    var $29Vii;
    var $8XeG6;
    var $bIGZ7;
    var $7agO8;
    var $g7Cky;
    var $9UDEr;
    var $kOFhM;
    var $fVI2q;
    var $0Cgjx;
    var $c960adc5c7547145$export$933e6445c497ffd5;
    (function(SchemaStage) {
        SchemaStage["FINAL"] = "final";
        SchemaStage["STAGE_0"] = "stage0";
    })($c960adc5c7547145$export$933e6445c497ffd5 || ($c960adc5c7547145$export$933e6445c497ffd5 = {}));
    const $c960adc5c7547145$var$isType = (type)=>(node)=>node.type.name === type;
    const $c960adc5c7547145$var$isCodeBlock = $c960adc5c7547145$var$isType('codeBlock');
    const $c960adc5c7547145$var$isMediaNode = $c960adc5c7547145$var$isType('media');
    const $c960adc5c7547145$var$isMediaInline = $c960adc5c7547145$var$isType('mediaInline');
    const $c960adc5c7547145$var$isMediaSingleNode = $c960adc5c7547145$var$isType('mediaSingle');
    const $c960adc5c7547145$var$isMentionNode = $c960adc5c7547145$var$isType('mention');
    const $c960adc5c7547145$var$isParagraph = $c960adc5c7547145$var$isType('paragraph');
    const $c960adc5c7547145$var$isHeading = $c960adc5c7547145$var$isType('heading');
    const $c960adc5c7547145$var$isTable = $c960adc5c7547145$var$isType('table');
    const $c960adc5c7547145$var$isTableCell = $c960adc5c7547145$var$isType('tableCell');
    const $c960adc5c7547145$var$isTableHeader = $c960adc5c7547145$var$isType('tableHeader');
    const $c960adc5c7547145$var$isLinkMark = $c960adc5c7547145$var$isType('link');
    const $c960adc5c7547145$var$isUnsupportedMark = $c960adc5c7547145$var$isType('unsupportedMark');
    const $c960adc5c7547145$var$isUnsupportedNodeAttributeMark = $c960adc5c7547145$var$isType('unsupportedNodeAttribute');
    const $c960adc5c7547145$var$isExpand = $c960adc5c7547145$var$isType('expand');
    const $c960adc5c7547145$var$isNestedExpand = $c960adc5c7547145$var$isType('nestedExpand');
    const $c960adc5c7547145$var$isUnsupportedNode = (node)=>$c960adc5c7547145$var$isType('unsupportedBlock')(node) || $c960adc5c7547145$var$isType('unsupportedInline')(node);
    const $c960adc5c7547145$var$isDataConsumer = $c960adc5c7547145$var$isType('dataConsumer');
    const $c960adc5c7547145$var$isFragmentMark = $c960adc5c7547145$var$isType('fragment');
    const $c960adc5c7547145$var$isHardBreak = $c960adc5c7547145$var$isType('hardBreak');
    const $c960adc5c7547145$var$filterNull = (subject)=>{
        let output = {
            ...subject
        };
        for(const key in output){
            const current = output[key];
            if (current === null) {
                const { [key]: unusedKey, ...filteredObj } = output;
                output = filteredObj;
            } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $c960adc5c7547145$var$filterNull(current);
        }
        return output;
    };
    const $c960adc5c7547145$var$createDocFromContent = (content)=>{
        return {
            version: 1,
            type: 'doc',
            content: content || []
        };
    };
    const $c960adc5c7547145$var$emptyDoc = $c960adc5c7547145$var$createDocFromContent([
        {
            type: 'paragraph',
            content: []
        }
    ]);
    const $c960adc5c7547145$var$toJSON = (node, mentionMap)=>{
        const obj = {
            type: node.type.name
        };
        if ($c960adc5c7547145$var$isUnsupportedNode(node)) return node.attrs.originalValue;
        else if ($c960adc5c7547145$var$isMediaNode(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMediaSingleNode(node)) obj.attrs = (0, (0, parcelRequire("bIGZ7")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMediaInline(node)) obj.attrs = (0, (0, parcelRequire("7agO8")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isMentionNode(node)) obj.attrs = (0, (0, parcelRequire("g7Cky")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isCodeBlock(node)) obj.attrs = (0, (0, parcelRequire("8vlrc")).toJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isTable(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).tableToJSON)(node).attrs;
        else if ($c960adc5c7547145$var$isTableCell(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableCell)(node).attrs;
        else if ($c960adc5c7547145$var$isTableHeader(node)) obj.attrs = (0, (0, parcelRequire("9UDEr")).toJSONTableHeader)(node).attrs;
        else if ($c960adc5c7547145$var$isExpand(node) || $c960adc5c7547145$var$isNestedExpand(node)) obj.attrs = (0, (0, parcelRequire("7kC9H")).toJSON)(node).attrs;
        else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
        if (obj.attrs) obj.attrs = $c960adc5c7547145$var$filterNull(obj.attrs);
        if ($c960adc5c7547145$var$isMentionNode(node) && mentionMap) {
            const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
            const text = obj.attrs?.text ?? '';
            obj.attrs = {
                ...obj.attrs,
                text: !!text ? text : name
            };
        }
        if ($c960adc5c7547145$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
        if ($c960adc5c7547145$var$isHardBreak(node)) delete obj.attrs;
        if (node.isText) obj.text = node.textContent;
        else node.content.forEach((child)=>{
            obj.content = obj.content || [];
            obj.content.push($c960adc5c7547145$var$toJSON(child, mentionMap));
        });
        if ($c960adc5c7547145$var$isParagraph(node) || $c960adc5c7547145$var$isHeading(node)) obj.content = obj.content || [];
        if (node.marks.length) {
            const parsedMarks = node.marks.map((mark)=>{
                if ($c960adc5c7547145$var$isUnsupportedMark(mark)) return $c960adc5c7547145$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
                else if ($c960adc5c7547145$var$isUnsupportedNodeAttributeMark(mark)) return null;
                else if ($c960adc5c7547145$var$isLinkMark(mark)) return (0, (0, parcelRequire("8XeG6")).toJSON)(mark);
                else if ($c960adc5c7547145$var$isDataConsumer(mark)) {
                    const serialised = (0, (0, parcelRequire("cUwVZ")).toJSON)(mark);
                    return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
                } else if ($c960adc5c7547145$var$isFragmentMark(mark)) {
                    const fragmentMark = (0, (0, parcelRequire("29Vii")).toJSON)(mark);
                    if (!fragmentMark.attrs.localId) return null;
                    return fragmentMark;
                } else return mark.toJSON();
            }).filter((maybeMark)=>maybeMark !== null);
            obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
            const nodeAttributeMark = node.marks.find($c960adc5c7547145$var$isUnsupportedNodeAttributeMark);
            if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
                ...$c960adc5c7547145$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
            };
        }
        return obj;
    };
    const $c960adc5c7547145$var$canOverrideMark = (mark, existingMarks)=>{
        if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, (0, parcelRequire("fVI2q")).markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
        return false;
    };
    const $c960adc5c7547145$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
        const nodeAttributes = node.type.spec.attrs;
        const attributes = {
            ...mark.attrs.unsupported,
            ...obj.attrs
        };
        for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
            const attribute = nodeAttributes ? nodeAttributes[key] : null;
            if (attribute) {
                if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                    ...attributes,
                    [key]: mark.attrs.unsupported[key]
                };
            }
        }
        return attributes;
    };
    class $c960adc5c7547145$export$98cb1d9308d0944d {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), mentionMap){
            this.schema = schema;
            this.mentionMap = mentionMap;
        }
        encode(node) {
            const content = [];
            node.content.forEach((child)=>{
                content.push((0, (0, parcelRequire("0Cgjx")).sanitizeNode)($c960adc5c7547145$var$toJSON(child, this.mentionMap)));
            });
            if (!content || (0, ($parcel$interopDefault($ajpes)))(content, $c960adc5c7547145$var$emptyDoc.content)) return $c960adc5c7547145$var$createDocFromContent([]);
            return $c960adc5c7547145$var$createDocFromContent(content);
        }
        internalParse(content, schema) {
            const doc = schema.nodeFromJSON(content);
            doc.check();
            return doc;
        }
        parse(content, stage) {
            if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
            const schema = !!stage ? (0, (0, parcelRequire("kOFhM")).getSchemaBasedOnStage)(stage) : this.schema;
            if (!content.content || content.content.length === 0) return this.internalParse($c960adc5c7547145$var$emptyDoc, schema);
            return this.internalParse(content, schema);
        }
        encodeNode(node) {
            return (0, (0, parcelRequire("0Cgjx")).sanitizeNode)($c960adc5c7547145$var$toJSON(node, this.mentionMap));
        }
    }
});
parcelRegister("fVI2q", function(module, exports) {
    $parcel$export(module.exports, "markOverrideRuleFor", ()=>$7f7cf8cf5d94f891$export$28e4e3c024cce988);
    const $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return true;
        }
    };
    const $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour = {
        canOverrideUnsupportedMark: ()=>{
            return false;
        }
    };
    const $7f7cf8cf5d94f891$export$28e4e3c024cce988 = (type)=>{
        switch(type){
            case 'link':
            case 'em':
            case 'strong':
            case 'strike':
            case 'subsup':
            case 'underline':
            case 'code':
            case 'textColor':
            case 'backgroundColor':
            case 'confluenceInlineComment':
            case 'breakout':
            case 'alignment':
            case 'indentation':
            case 'border':
                return $7f7cf8cf5d94f891$var$defaultAllowOverrideBehaviour;
            default:
                return $7f7cf8cf5d94f891$var$defaultDoNotAllowOverrideBehaviour;
        }
    };
});
parcelRegister("0Cgjx", function(module, exports) {
    $parcel$export(module.exports, "sanitizeNode", ()=>$45db1c8142107da9$export$48b382180baf8e88);
    var $aSk3Q;
    var $l1C1k;
    var $VSDnB;
    var $hRZSy;
    const $45db1c8142107da9$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
    function $45db1c8142107da9$export$48b382180baf8e88(json) {
        const sanitizedJSON = (0, (0, parcelRequire("l1C1k")).traverse)(json, {
            text: (node)=>{
                if (!node || !Array.isArray(node.marks)) return node;
                return {
                    ...node,
                    marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
                };
            },
            status: (node)=>{
                if (node.attrs && !!node.attrs.text) return (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks)(node);
                return false;
            },
            caption: (node)=>{
                if (node.content) return node;
                return false;
            },
            tableCell: (node)=>{
                if ($45db1c8142107da9$var$hasNestedTable(node) && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("aSk3Q")).transformNestedTableNodeOutgoingDocument)(node);
            },
            tableHeader: (node)=>{
                if ($45db1c8142107da9$var$hasNestedTable(node) && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) return (0, (0, parcelRequire("aSk3Q")).transformNestedTableNodeOutgoingDocument)(node);
            },
            emoji: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            mention: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            date: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks),
            hardBreak: (0, (0, parcelRequire("hRZSy")).removeMarks),
            inlineCard: (0, (0, parcelRequire("hRZSy")).removeNonAnnotationMarks)
        });
        return sanitizedJSON;
    }
});
parcelRegister("aSk3Q", function(module, exports) {
    $parcel$export(module.exports, "transformNestedTablesIncomingDocument", ()=>$2dd8f1bba9a54435$export$18544d0b5f43e4a1);
    $parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", ()=>$2dd8f1bba9a54435$export$8a334a7d9fe120ec);
    var $l1C1k;
    var $gxbjN;
    var $8YCkv;
    const $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.nesting', $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
    const $2dd8f1bba9a54435$var$isNestedTableExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY;
    const $2dd8f1bba9a54435$var$transformNestedTableExtension = (nestedTableExtension)=>{
        if (!nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent) return false;
        try {
            return JSON.parse(nestedTableExtension.attrs?.parameters?.macroParams?.nestedContent.value);
        } catch (e) {
            throw new (0, (0, parcelRequire("8YCkv")).NodeNestingTransformError)('Failed to parse nested table content');
        }
    };
    const $2dd8f1bba9a54435$export$18544d0b5f43e4a1 = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            extension: (node)=>{
                if ($2dd8f1bba9a54435$var$isNestedTableExtension(node)) {
                    isTransformed = true;
                    return $2dd8f1bba9a54435$var$transformNestedTableExtension(node);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
    const $2dd8f1bba9a54435$export$8a334a7d9fe120ec = (tableCellNode)=>{
        try {
            return {
                ...tableCellNode,
                content: tableCellNode.content?.map((childNode)=>{
                    if (childNode?.type === 'table') return (0, (0, parcelRequire("gxbjN")).extension)({
                        extensionType: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_TYPE,
                        extensionKey: $2dd8f1bba9a54435$var$NESTED_TABLE_EXTENSION_KEY,
                        parameters: {
                            macroParams: {
                                nestedContent: {
                                    value: JSON.stringify(childNode)
                                }
                            }
                        }
                    });
                    return childNode;
                })
            };
        } catch (e) {
            throw new (0, (0, parcelRequire("8YCkv")).NodeNestingTransformError)('Failed to encode nested table node');
        }
    };
});
parcelRegister("gxbjN", function(module, exports) {
    $parcel$export(module.exports, "extension", ()=>$ec4576859225619a$export$1b45514b112dd749);
    const $ec4576859225619a$export$1b45514b112dd749 = (attrs)=>({
            type: 'extension',
            attrs: attrs
        });
});
parcelRegister("8YCkv", function(module, exports) {
    $parcel$export(module.exports, "NodeNestingTransformError", ()=>$b0271efedae2a0b7$export$3d8e8d2182f13924);
    class $b0271efedae2a0b7$export$3d8e8d2182f13924 extends Error {
        constructor(message){
            super(message);
            this.name = 'NodeNestingTransformError';
        }
    }
});
parcelRegister("hRZSy", function(module, exports) {
    $parcel$export(module.exports, "removeMarks", ()=>$7e7bed7752b3d3e8$export$9bf001d8ef76e497);
    $parcel$export(module.exports, "removeNonAnnotationMarks", ()=>$7e7bed7752b3d3e8$export$8cae9126fc577085);
    function $7e7bed7752b3d3e8$export$9bf001d8ef76e497(node) {
        let newNode = {
            ...node
        };
        delete newNode.marks;
        return newNode;
    }
    function $7e7bed7752b3d3e8$export$8cae9126fc577085(node) {
        let newNode = {
            ...node
        };
        if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
        return newNode;
    }
});
parcelRegister("h03xs", function(module, exports) {
    $parcel$export(module.exports, "canApplyAnnotationOnRange", ()=>$ccb20202dc8fa865$export$77ddf8216f9eb904);
    $parcel$export(module.exports, "getAnnotationIdsFromRange", ()=>$ccb20202dc8fa865$export$badbcc229c848aec);
    $parcel$export(module.exports, "hasAnnotationMark", ()=>$ccb20202dc8fa865$export$5fe1412b20386053);
    $parcel$export(module.exports, "containsAnyAnnotations", ()=>$ccb20202dc8fa865$export$1976770b876b2728);
    $parcel$export(module.exports, "getRangeInlineNodeNames", ()=>$ccb20202dc8fa865$export$35054451202ed5d9);
    $parcel$export(module.exports, "getAnnotationInlineNodeTypes", ()=>$ccb20202dc8fa865$export$8261bc1f662f3f6e);
    $parcel$export(module.exports, "getAnnotationMarksForPos", ()=>$ccb20202dc8fa865$export$bb1945a828f2864b);
    $parcel$export(module.exports, "isEmptyTextSelection", ()=>$ccb20202dc8fa865$export$2efbc6d84ea0fbec);
    var $88i6h;
    var $VSDnB;
    const $ccb20202dc8fa865$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
        let foundInvalid = false;
        doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
            if (schema.nodes.hardBreak === node.type) return false;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                    foundInvalid = true;
                    return false;
                }
            } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
            return true;
        });
        return !foundInvalid;
    };
    const $ccb20202dc8fa865$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
        const { from: from, to: to } = rangeSelection;
        let annotations = new Set();
        doc.nodesBetween(from, to, (node)=>{
            if (!node.marks) return true;
            node.marks.forEach((mark)=>{
                if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
            });
            return true;
        });
        return Array.from(annotations);
    };
    function $ccb20202dc8fa865$export$5fe1412b20386053(node, state) {
        const { schema: { marks: { annotation: annotationMark } } } = state;
        return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
    }
    function $ccb20202dc8fa865$export$1976770b876b2728(slice, state) {
        if (!slice.content.size) return false;
        let hasAnnotation = false;
        slice.content.forEach((node)=>{
            hasAnnotation = hasAnnotation || $ccb20202dc8fa865$export$5fe1412b20386053(node, state);
            if (hasAnnotation) return true;
            node.descendants((node)=>{
                if ($ccb20202dc8fa865$export$5fe1412b20386053(node, state)) {
                    hasAnnotation = true;
                    return false;
                }
                return true;
            });
        });
        return hasAnnotation;
    }
    function $ccb20202dc8fa865$export$35054451202ed5d9({ doc: doc, pos: pos }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        let nodeNames = new Set();
        try {
            doc.nodesBetween(pos.from, pos.to, (node)=>{
                if (node.isInline) nodeNames.add(node.type.name);
            });
            const sortedNames = [
                ...nodeNames
            ].sort();
            return sortedNames;
        } catch  {
            return undefined;
        }
    }
    function $ccb20202dc8fa865$export$8261bc1f662f3f6e(state, annotationId) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const mark = state.schema.marks.annotation.create({
            id: annotationId,
            annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
        });
        const inlineNodeNames = new Set();
        state.doc.descendants((node, pos)=>{
            if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
            return true;
        });
        return [
            ...inlineNodeNames
        ].sort();
    }
    function $ccb20202dc8fa865$export$bb1945a828f2864b(pos) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_paste_insert_nodes')) return undefined;
        const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
        return annotationMarks;
    }
    function $ccb20202dc8fa865$export$2efbc6d84ea0fbec(selection, schema) {
        const { text: text, paragraph: paragraph } = schema.nodes;
        let hasContent = false;
        selection.content().content.descendants((node)=>{
            if (node.type === paragraph && !node.content.size) return false;
            if (node.type !== text || !node.textContent) hasContent = true;
            return !hasContent;
        });
        return !hasContent;
    }
});
parcelRegister("gZGBX", function(module, exports) {
    $parcel$export(module.exports, "Selection", ()=>$c5f36586ce432e9f$export$52baac22726c72bf);
    $parcel$export(module.exports, "SelectionRange", ()=>$c5f36586ce432e9f$export$7bd1839c3c5d5bd4);
    $parcel$export(module.exports, "TextSelection", ()=>$c5f36586ce432e9f$export$c2b25f346d19bcbb);
    $parcel$export(module.exports, "AllSelection", ()=>$c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    $parcel$export(module.exports, "NodeSelection", ()=>$c5f36586ce432e9f$export$e2940151ac854c0b);
    $parcel$export(module.exports, "Transaction", ()=>$c5f36586ce432e9f$export$febc5573c75cefb0);
    $parcel$export(module.exports, "EditorState", ()=>$c5f36586ce432e9f$export$afa855cbfaff27f2);
    $parcel$export(module.exports, "Plugin", ()=>$c5f36586ce432e9f$export$901cf72dabf2112a);
    $parcel$export(module.exports, "PluginKey", ()=>$c5f36586ce432e9f$export$1692d8b0e89cecc3);
    var $kCV8T;
    var $eS2Dn;
    const $c5f36586ce432e9f$var$classesById = Object.create(null);
    class $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head, ranges){
            this.$anchor = $anchor;
            this.$head = $head;
            this.ranges = ranges || [
                new $c5f36586ce432e9f$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
            ];
        }
        get anchor() {
            return this.$anchor.pos;
        }
        get head() {
            return this.$head.pos;
        }
        get from() {
            return this.$from.pos;
        }
        get to() {
            return this.$to.pos;
        }
        get $from() {
            return this.ranges[0].$from;
        }
        get $to() {
            return this.ranges[0].$to;
        }
        get empty() {
            let ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
            return true;
        }
        content() {
            return this.$from.doc.slice(this.from, this.to, true);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let lastNode = content.content.lastChild, lastParent = null;
            for(let i = 0; i < content.openEnd; i++){
                lastParent = lastNode;
                lastNode = lastNode.lastChild;
            }
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, (0, parcelRequire("kCV8T")).Slice).empty : content);
                if (i == 0) $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
            }
        }
        replaceWith(tr, node) {
            let mapFrom = tr.steps.length, ranges = this.ranges;
            for(let i = 0; i < ranges.length; i++){
                let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
                let from = mapping.map($from.pos), to = mapping.map($to.pos);
                if (i) tr.deleteRange(from, to);
                else {
                    tr.replaceRangeWith(from, to, node);
                    $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
                }
            }
        }
        static findFrom($pos, dir, textOnly = false) {
            let inner = $pos.parent.inlineContent ? new $c5f36586ce432e9f$export$c2b25f346d19bcbb($pos) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
            if (inner) return inner;
            for(let depth = $pos.depth - 1; depth >= 0; depth--){
                let found = dir < 0 ? $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $c5f36586ce432e9f$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
                if (found) return found;
            }
            return null;
        }
        static near($pos, bias = 1) {
            return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95($pos.node(0));
        }
        static atStart(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, 0, 0, 1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static atEnd(doc) {
            return $c5f36586ce432e9f$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        static fromJSON(doc, json) {
            if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
            let cls = $c5f36586ce432e9f$var$classesById[json.type];
            if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
            return cls.fromJSON(doc, json);
        }
        static jsonID(id, selectionClass) {
            if (id in $c5f36586ce432e9f$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
            $c5f36586ce432e9f$var$classesById[id] = selectionClass;
            selectionClass.prototype.jsonID = id;
            return selectionClass;
        }
        getBookmark() {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.prototype.visible = true;
    class $c5f36586ce432e9f$export$7bd1839c3c5d5bd4 {
        constructor($from, $to){
            this.$from = $from;
            this.$to = $to;
        }
    }
    let $c5f36586ce432e9f$var$warnedAboutTextSelection = false;
    function $c5f36586ce432e9f$var$checkTextSelection($pos) {
        if (!$c5f36586ce432e9f$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
            $c5f36586ce432e9f$var$warnedAboutTextSelection = true;
            console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
        }
    }
    class $c5f36586ce432e9f$export$c2b25f346d19bcbb extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($anchor, $head = $anchor){
            $c5f36586ce432e9f$var$checkTextSelection($anchor);
            $c5f36586ce432e9f$var$checkTextSelection($head);
            super($anchor, $head);
        }
        get $cursor() {
            return this.$anchor.pos == this.$head.pos ? this.$head : null;
        }
        map(doc, mapping) {
            let $head = doc.resolve(mapping.map(this.head));
            if (!$head.parent.inlineContent) return $c5f36586ce432e9f$export$52baac22726c72bf.near($head);
            let $anchor = doc.resolve(mapping.map(this.anchor));
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            super.replace(tr, content);
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                let marks = this.$from.marksAcross(this.$to);
                if (marks) tr.ensureMarks(marks);
            }
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$TextBookmark(this.anchor, this.head);
        }
        toJSON() {
            return {
                type: "text",
                anchor: this.anchor,
                head: this.head
            };
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
        }
        static create(doc, anchor, head = anchor) {
            let $anchor = doc.resolve(anchor);
            return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
        }
        static between($anchor, $head, bias) {
            let dPos = $anchor.pos - $head.pos;
            if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
            if (!$head.parent.inlineContent) {
                let found = $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($head, -bias, true);
                if (found) $head = found.$head;
                else return $c5f36586ce432e9f$export$52baac22726c72bf.near($head, bias);
            }
            if (!$anchor.parent.inlineContent) {
                if (dPos == 0) $anchor = $head;
                else {
                    $anchor = ($c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $c5f36586ce432e9f$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                    if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
                }
            }
            return new $c5f36586ce432e9f$export$c2b25f346d19bcbb($anchor, $head);
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("text", $c5f36586ce432e9f$export$c2b25f346d19bcbb);
    class $c5f36586ce432e9f$var$TextBookmark {
        constructor(anchor, head){
            this.anchor = anchor;
            this.head = head;
        }
        map(mapping) {
            return new $c5f36586ce432e9f$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
        }
        resolve(doc) {
            return $c5f36586ce432e9f$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
        }
    }
    class $c5f36586ce432e9f$export$e2940151ac854c0b extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor($pos){
            let node = $pos.nodeAfter;
            let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
            super($pos, $end);
            this.node = node;
        }
        map(doc, mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            let $pos = doc.resolve(pos);
            if (deleted) return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
            return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
        }
        content() {
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(this.node), 0, 0);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$e2940151ac854c0b && other.anchor == this.anchor;
        }
        toJSON() {
            return {
                type: "node",
                anchor: this.anchor
            };
        }
        getBookmark() {
            return new $c5f36586ce432e9f$var$NodeBookmark(this.anchor);
        }
        static fromJSON(doc, json) {
            if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(json.anchor));
        }
        static create(doc, from) {
            return new $c5f36586ce432e9f$export$e2940151ac854c0b(doc.resolve(from));
        }
        static isSelectable(node) {
            return !node.isText && node.type.spec.selectable !== false;
        }
    }
    $c5f36586ce432e9f$export$e2940151ac854c0b.prototype.visible = false;
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("node", $c5f36586ce432e9f$export$e2940151ac854c0b);
    class $c5f36586ce432e9f$var$NodeBookmark {
        constructor(anchor){
            this.anchor = anchor;
        }
        map(mapping) {
            let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
            return deleted ? new $c5f36586ce432e9f$var$TextBookmark(pos, pos) : new $c5f36586ce432e9f$var$NodeBookmark(pos);
        }
        resolve(doc) {
            let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
            if (node && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(node)) return new $c5f36586ce432e9f$export$e2940151ac854c0b($pos);
            return $c5f36586ce432e9f$export$52baac22726c72bf.near($pos);
        }
    }
    class $c5f36586ce432e9f$export$c15d9ba76bdbcd95 extends $c5f36586ce432e9f$export$52baac22726c72bf {
        constructor(doc){
            super(doc.resolve(0), doc.resolve(doc.content.size));
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            if (content == (0, (0, parcelRequire("kCV8T")).Slice).empty) {
                tr.delete(0, tr.doc.content.size);
                let sel = $c5f36586ce432e9f$export$52baac22726c72bf.atStart(tr.doc);
                if (!sel.eq(tr.selection)) tr.setSelection(sel);
            } else super.replace(tr, content);
        }
        toJSON() {
            return {
                type: "all"
            };
        }
        static fromJSON(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        map(doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
        eq(other) {
            return other instanceof $c5f36586ce432e9f$export$c15d9ba76bdbcd95;
        }
        getBookmark() {
            return $c5f36586ce432e9f$var$AllBookmark;
        }
    }
    $c5f36586ce432e9f$export$52baac22726c72bf.jsonID("all", $c5f36586ce432e9f$export$c15d9ba76bdbcd95);
    const $c5f36586ce432e9f$var$AllBookmark = {
        map () {
            return this;
        },
        resolve (doc) {
            return new $c5f36586ce432e9f$export$c15d9ba76bdbcd95(doc);
        }
    };
    function $c5f36586ce432e9f$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
        if (node.inlineContent) return $c5f36586ce432e9f$export$c2b25f346d19bcbb.create(doc, pos);
        for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
            let child = node.child(i);
            if (!child.isAtom) {
                let inner = $c5f36586ce432e9f$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
                if (inner) return inner;
            } else if (!text && $c5f36586ce432e9f$export$e2940151ac854c0b.isSelectable(child)) return $c5f36586ce432e9f$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
            pos += child.nodeSize * dir;
        }
        return null;
    }
    function $c5f36586ce432e9f$var$selectionToInsertionEnd(tr, startLen, bias) {
        let last = tr.steps.length - 1;
        if (last < startLen) return;
        let step = tr.steps[last];
        if (!(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return;
        let map = tr.mapping.maps[last], end;
        map.forEach((_from, _to, _newFrom, newTo)=>{
            if (end == null) end = newTo;
        });
        tr.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
    }
    const $c5f36586ce432e9f$var$UPDATED_SEL = 1, $c5f36586ce432e9f$var$UPDATED_MARKS = 2, $c5f36586ce432e9f$var$UPDATED_SCROLL = 4;
    class $c5f36586ce432e9f$export$febc5573c75cefb0 extends (0, (0, parcelRequire("eS2Dn")).Transform) {
        constructor(state){
            super(state.doc);
            this.curSelectionFor = 0;
            this.updated = 0;
            this.meta = Object.create(null);
            this.time = Date.now();
            this.curSelection = state.selection;
            this.storedMarks = state.storedMarks;
        }
        get selection() {
            if (this.curSelectionFor < this.steps.length) {
                this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
                this.curSelectionFor = this.steps.length;
            }
            return this.curSelection;
        }
        setSelection(selection) {
            if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
            this.curSelection = selection;
            this.curSelectionFor = this.steps.length;
            this.updated = (this.updated | $c5f36586ce432e9f$var$UPDATED_SEL) & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
            return this;
        }
        get selectionSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SEL) > 0;
        }
        setStoredMarks(marks) {
            this.storedMarks = marks;
            this.updated |= $c5f36586ce432e9f$var$UPDATED_MARKS;
            return this;
        }
        ensureMarks(marks) {
            if (!(0, (0, parcelRequire("kCV8T")).Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
            return this;
        }
        addStoredMark(mark) {
            return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
        }
        removeStoredMark(mark) {
            return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
        }
        get storedMarksSet() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_MARKS) > 0;
        }
        addStep(step, doc) {
            super.addStep(step, doc);
            this.updated = this.updated & ~$c5f36586ce432e9f$var$UPDATED_MARKS;
            this.storedMarks = null;
        }
        setTime(time) {
            this.time = time;
            return this;
        }
        replaceSelection(slice) {
            this.selection.replace(this, slice);
            return this;
        }
        replaceSelectionWith(node, inheritMarks = true) {
            let selection = this.selection;
            if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, (0, parcelRequire("kCV8T")).Mark).none));
            selection.replaceWith(this, node);
            return this;
        }
        deleteSelection() {
            this.selection.replace(this);
            return this;
        }
        insertText(text, from, to) {
            let schema = this.doc.type.schema;
            if (from == null) {
                if (!text) return this.deleteSelection();
                return this.replaceSelectionWith(schema.text(text), true);
            } else {
                if (to == null) to = from;
                to = to == null ? from : to;
                if (!text) return this.deleteRange(from, to);
                let marks = this.storedMarks;
                if (!marks) {
                    let $from = this.doc.resolve(from);
                    marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
                }
                this.replaceRangeWith(from, to, schema.text(text, marks));
                if (!this.selection.empty) this.setSelection($c5f36586ce432e9f$export$52baac22726c72bf.near(this.selection.$to));
                return this;
            }
        }
        setMeta(key, value) {
            this.meta[typeof key == "string" ? key : key.key] = value;
            return this;
        }
        getMeta(key) {
            return this.meta[typeof key == "string" ? key : key.key];
        }
        get isGeneric() {
            for(let _ in this.meta)return false;
            return true;
        }
        scrollIntoView() {
            this.updated |= $c5f36586ce432e9f$var$UPDATED_SCROLL;
            return this;
        }
        get scrolledIntoView() {
            return (this.updated & $c5f36586ce432e9f$var$UPDATED_SCROLL) > 0;
        }
    }
    function $c5f36586ce432e9f$var$bind(f, self) {
        return !self || !f ? f : f.bind(self);
    }
    class $c5f36586ce432e9f$var$FieldDesc {
        constructor(name, desc, self){
            this.name = name;
            this.init = $c5f36586ce432e9f$var$bind(desc.init, self);
            this.apply = $c5f36586ce432e9f$var$bind(desc.apply, self);
        }
    }
    const $c5f36586ce432e9f$var$baseFields = [
        new $c5f36586ce432e9f$var$FieldDesc("doc", {
            init (config) {
                return config.doc || config.schema.topNodeType.createAndFill();
            },
            apply (tr) {
                return tr.doc;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("selection", {
            init (config, instance) {
                return config.selection || $c5f36586ce432e9f$export$52baac22726c72bf.atStart(instance.doc);
            },
            apply (tr) {
                return tr.selection;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("storedMarks", {
            init (config) {
                return config.storedMarks || null;
            },
            apply (tr, _marks, _old, state) {
                return state.selection.$cursor ? tr.storedMarks : null;
            }
        }),
        new $c5f36586ce432e9f$var$FieldDesc("scrollToSelection", {
            init () {
                return 0;
            },
            apply (tr, prev) {
                return tr.scrolledIntoView ? prev + 1 : prev;
            }
        })
    ];
    class $c5f36586ce432e9f$var$Configuration {
        constructor(schema, plugins){
            this.schema = schema;
            this.plugins = [];
            this.pluginsByKey = Object.create(null);
            this.fields = $c5f36586ce432e9f$var$baseFields.slice();
            if (plugins) plugins.forEach((plugin)=>{
                if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state) this.fields.push(new $c5f36586ce432e9f$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
        }
    }
    class $c5f36586ce432e9f$export$afa855cbfaff27f2 {
        constructor(config){
            this.config = config;
        }
        get schema() {
            return this.config.schema;
        }
        get plugins() {
            return this.config.plugins;
        }
        apply(tr) {
            return this.applyTransaction(tr).state;
        }
        filterTransaction(tr, ignore = -1) {
            for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
            }
            return true;
        }
        applyTransaction(rootTr) {
            if (!this.filterTransaction(rootTr)) return {
                state: this,
                transactions: []
            };
            let trs = [
                rootTr
            ], newState = this.applyInner(rootTr), seen = null;
            for(;;){
                let haveNew = false;
                for(let i = 0; i < this.config.plugins.length; i++){
                    let plugin = this.config.plugins[i];
                    if (plugin.spec.appendTransaction) {
                        let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                        let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                        if (tr && newState.filterTransaction(tr, i)) {
                            tr.setMeta("appendedTransaction", rootTr);
                            if (!seen) {
                                seen = [];
                                for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                    state: newState,
                                    n: trs.length
                                } : {
                                    state: this,
                                    n: 0
                                });
                            }
                            trs.push(tr);
                            newState = newState.applyInner(tr);
                            haveNew = true;
                        }
                        if (seen) seen[i] = {
                            state: newState,
                            n: trs.length
                        };
                    }
                }
                if (!haveNew) return {
                    state: newState,
                    transactions: trs
                };
            }
        }
        applyInner(tr) {
            if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
            let newInstance = new $c5f36586ce432e9f$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
            for(let i = 0; i < fields.length; i++){
                let field = fields[i];
                newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
            }
            return newInstance;
        }
        get tr() {
            return new $c5f36586ce432e9f$export$febc5573c75cefb0(this);
        }
        static create(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
            return instance;
        }
        reconfigure(config) {
            let $config = new $c5f36586ce432e9f$var$Configuration(this.schema, config.plugins);
            let fields = $config.fields, instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            for(let i = 0; i < fields.length; i++){
                let name = fields[i].name;
                instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
            }
            return instance;
        }
        toJSON(pluginFields) {
            let result = {
                doc: this.doc.toJSON(),
                selection: this.selection.toJSON()
            };
            if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
            if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
                if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
            return result;
        }
        static fromJSON(config, json, pluginFields) {
            if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
            if (!config.schema) throw new RangeError("Required config field 'schema' missing");
            let $config = new $c5f36586ce432e9f$var$Configuration(config.schema, config.plugins);
            let instance = new $c5f36586ce432e9f$export$afa855cbfaff27f2($config);
            $config.fields.forEach((field)=>{
                if (field.name == "doc") instance.doc = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(config.schema, json.doc);
                else if (field.name == "selection") instance.selection = $c5f36586ce432e9f$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
                else if (field.name == "storedMarks") {
                    if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
                } else {
                    if (pluginFields) for(let prop in pluginFields){
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                    instance[field.name] = field.init(config, instance);
                }
            });
            return instance;
        }
    }
    function $c5f36586ce432e9f$var$bindProps(obj, self, target) {
        for(let prop in obj){
            let val = obj[prop];
            if (val instanceof Function) val = val.bind(self);
            else if (prop == "handleDOMEvents") val = $c5f36586ce432e9f$var$bindProps(val, self, {});
            target[prop] = val;
        }
        return target;
    }
    class $c5f36586ce432e9f$export$901cf72dabf2112a {
        constructor(spec){
            this.spec = spec;
            this.props = {};
            if (spec.props) $c5f36586ce432e9f$var$bindProps(spec.props, this, this.props);
            this.key = spec.key ? spec.key.key : $c5f36586ce432e9f$var$createKey("plugin");
        }
        getState(state) {
            return state[this.key];
        }
    }
    const $c5f36586ce432e9f$var$keys = Object.create(null);
    function $c5f36586ce432e9f$var$createKey(name) {
        if (name in $c5f36586ce432e9f$var$keys) return name + "$" + ++$c5f36586ce432e9f$var$keys[name];
        $c5f36586ce432e9f$var$keys[name] = 0;
        return name + "$";
    }
    class $c5f36586ce432e9f$export$1692d8b0e89cecc3 {
        constructor(name = "key"){
            this.key = $c5f36586ce432e9f$var$createKey(name);
        }
        get(state) {
            return state.config.pluginsByKey[this.key];
        }
        getState(state) {
            return state[this.key];
        }
    }
});
parcelRegister("eS2Dn", function(module, exports) {
    $parcel$export(module.exports, "StepMap", ()=>$ad3826e817ebec37$export$c53d01c3ab9721b3);
    $parcel$export(module.exports, "Mapping", ()=>$ad3826e817ebec37$export$f5f785078011b62);
    $parcel$export(module.exports, "Step", ()=>$ad3826e817ebec37$export$fd55ce593607084a);
    $parcel$export(module.exports, "StepResult", ()=>$ad3826e817ebec37$export$8ebf1578a4199c09);
    $parcel$export(module.exports, "AddMarkStep", ()=>$ad3826e817ebec37$export$d24ba56b0e3464a9);
    $parcel$export(module.exports, "RemoveMarkStep", ()=>$ad3826e817ebec37$export$94150db1311f67a9);
    $parcel$export(module.exports, "AddNodeMarkStep", ()=>$ad3826e817ebec37$export$adefd16c402fee4e);
    $parcel$export(module.exports, "RemoveNodeMarkStep", ()=>$ad3826e817ebec37$export$fdf7d1dc10724da2);
    $parcel$export(module.exports, "ReplaceStep", ()=>$ad3826e817ebec37$export$5c860b2e74034756);
    $parcel$export(module.exports, "ReplaceAroundStep", ()=>$ad3826e817ebec37$export$444ba800d6024a98);
    $parcel$export(module.exports, "liftTarget", ()=>$ad3826e817ebec37$export$f1508b72cc76a09e);
    $parcel$export(module.exports, "findWrapping", ()=>$ad3826e817ebec37$export$118cb9a83e81ba37);
    $parcel$export(module.exports, "canSplit", ()=>$ad3826e817ebec37$export$5aaf008897aef029);
    $parcel$export(module.exports, "canJoin", ()=>$ad3826e817ebec37$export$f15f89fd9d8cc98a);
    $parcel$export(module.exports, "joinPoint", ()=>$ad3826e817ebec37$export$41b1d4cb5ceb3147);
    $parcel$export(module.exports, "insertPoint", ()=>$ad3826e817ebec37$export$64cb316d02de1dd1);
    $parcel$export(module.exports, "dropPoint", ()=>$ad3826e817ebec37$export$2819d598d048fc9c);
    $parcel$export(module.exports, "replaceStep", ()=>$ad3826e817ebec37$export$ed6ac67359824afd);
    $parcel$export(module.exports, "AttrStep", ()=>$ad3826e817ebec37$export$626399c38172f669);
    $parcel$export(module.exports, "DocAttrStep", ()=>$ad3826e817ebec37$export$f50707b396300ac9);
    $parcel$export(module.exports, "Transform", ()=>$ad3826e817ebec37$export$563a914cafbdc389);
    var $kCV8T;
    const $ad3826e817ebec37$var$lower16 = 0xffff;
    const $ad3826e817ebec37$var$factor16 = Math.pow(2, 16);
    function $ad3826e817ebec37$var$makeRecover(index, offset) {
        return index + offset * $ad3826e817ebec37$var$factor16;
    }
    function $ad3826e817ebec37$var$recoverIndex(value) {
        return value & $ad3826e817ebec37$var$lower16;
    }
    function $ad3826e817ebec37$var$recoverOffset(value) {
        return (value - (value & $ad3826e817ebec37$var$lower16)) / $ad3826e817ebec37$var$factor16;
    }
    const $ad3826e817ebec37$var$DEL_BEFORE = 1, $ad3826e817ebec37$var$DEL_AFTER = 2, $ad3826e817ebec37$var$DEL_ACROSS = 4, $ad3826e817ebec37$var$DEL_SIDE = 8;
    class $ad3826e817ebec37$export$c77c9be41668e9b4 {
        constructor(pos, delInfo, recover){
            this.pos = pos;
            this.delInfo = delInfo;
            this.recover = recover;
        }
        get deleted() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_SIDE) > 0;
        }
        get deletedBefore() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_BEFORE | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAfter() {
            return (this.delInfo & ($ad3826e817ebec37$var$DEL_AFTER | $ad3826e817ebec37$var$DEL_ACROSS)) > 0;
        }
        get deletedAcross() {
            return (this.delInfo & $ad3826e817ebec37$var$DEL_ACROSS) > 0;
        }
    }
    class $ad3826e817ebec37$export$c53d01c3ab9721b3 {
        constructor(ranges, inverted = false){
            this.ranges = ranges;
            this.inverted = inverted;
            if (!ranges.length && $ad3826e817ebec37$export$c53d01c3ab9721b3.empty) return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        recover(value) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(value);
            if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
            return this.ranges[index * 3] + diff + $ad3826e817ebec37$var$recoverOffset(value);
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        map(pos, assoc = 1) {
            return this._map(pos, assoc, true);
        }
        _map(pos, assoc, simple) {
            let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
                if (pos <= end) {
                    let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                    let result = start + diff + (side < 0 ? 0 : newSize);
                    if (simple) return result;
                    let recover = pos == (assoc < 0 ? start : end) ? null : $ad3826e817ebec37$var$makeRecover(i / 3, pos - start);
                    let del = pos == start ? $ad3826e817ebec37$var$DEL_AFTER : pos == end ? $ad3826e817ebec37$var$DEL_BEFORE : $ad3826e817ebec37$var$DEL_ACROSS;
                    if (assoc < 0 ? pos != start : pos != end) del |= $ad3826e817ebec37$var$DEL_SIDE;
                    return new $ad3826e817ebec37$export$c77c9be41668e9b4(result, del, recover);
                }
                diff += newSize - oldSize;
            }
            return simple ? pos + diff : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos + diff, 0, null);
        }
        touches(pos, recover) {
            let diff = 0, index = $ad3826e817ebec37$var$recoverIndex(recover);
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i] - (this.inverted ? diff : 0);
                if (start > pos) break;
                let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
                if (pos <= end && i == index * 3) return true;
                diff += this.ranges[i + newIndex] - oldSize;
            }
            return false;
        }
        forEach(f) {
            let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
            for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
                let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
                let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
                f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
                diff += newSize - oldSize;
            }
        }
        invert() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
        }
        toString() {
            return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
        }
        static offset(n) {
            return n == 0 ? $ad3826e817ebec37$export$c53d01c3ab9721b3.empty : new $ad3826e817ebec37$export$c53d01c3ab9721b3(n < 0 ? [
                0,
                -n,
                0
            ] : [
                0,
                0,
                n
            ]);
        }
    }
    $ad3826e817ebec37$export$c53d01c3ab9721b3.empty = new $ad3826e817ebec37$export$c53d01c3ab9721b3([]);
    class $ad3826e817ebec37$export$f5f785078011b62 {
        constructor(maps = [], mirror, from = 0, to = maps.length){
            this.maps = maps;
            this.mirror = mirror;
            this.from = from;
            this.to = to;
        }
        slice(from = 0, to = this.maps.length) {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps, this.mirror, from, to);
        }
        copy() {
            return new $ad3826e817ebec37$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
        }
        appendMap(map, mirrors) {
            this.to = this.maps.push(map);
            if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
        }
        appendMapping(mapping) {
            for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
            }
        }
        getMirror(n) {
            if (this.mirror) {
                for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
            }
        }
        setMirror(n, m) {
            if (!this.mirror) this.mirror = [];
            this.mirror.push(n, m);
        }
        appendMappingInverted(mapping) {
            for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
                let mirr = mapping.getMirror(i);
                this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
            }
        }
        invert() {
            let inverse = new $ad3826e817ebec37$export$f5f785078011b62;
            inverse.appendMappingInverted(this);
            return inverse;
        }
        map(pos, assoc = 1) {
            if (this.mirror) return this._map(pos, assoc, true);
            for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
            return pos;
        }
        mapResult(pos, assoc = 1) {
            return this._map(pos, assoc, false);
        }
        _map(pos, assoc, simple) {
            let delInfo = 0;
            for(let i = this.from; i < this.to; i++){
                let map = this.maps[i], result = map.mapResult(pos, assoc);
                if (result.recover != null) {
                    let corr = this.getMirror(i);
                    if (corr != null && corr > i && corr < this.to) {
                        i = corr;
                        pos = this.maps[corr].recover(result.recover);
                        continue;
                    }
                }
                delInfo |= result.delInfo;
                pos = result.pos;
            }
            return simple ? pos : new $ad3826e817ebec37$export$c77c9be41668e9b4(pos, delInfo, null);
        }
    }
    const $ad3826e817ebec37$var$stepsByID = Object.create(null);
    class $ad3826e817ebec37$export$fd55ce593607084a {
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        merge(other) {
            return null;
        }
        static fromJSON(schema, json) {
            if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
            let type = $ad3826e817ebec37$var$stepsByID[json.stepType];
            if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
            return type.fromJSON(schema, json);
        }
        static jsonID(id, stepClass) {
            if (id in $ad3826e817ebec37$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
            $ad3826e817ebec37$var$stepsByID[id] = stepClass;
            stepClass.prototype.jsonID = id;
            return stepClass;
        }
    }
    class $ad3826e817ebec37$export$8ebf1578a4199c09 {
        constructor(doc, failed){
            this.doc = doc;
            this.failed = failed;
        }
        static ok(doc) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(doc, null);
        }
        static fail(message) {
            return new $ad3826e817ebec37$export$8ebf1578a4199c09(null, message);
        }
        static fromReplace(doc, from, to, slice) {
            try {
                return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
            } catch (e) {
                if (e instanceof (0, (0, parcelRequire("kCV8T")).ReplaceError)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail(e.message);
                throw e;
            }
        }
    }
    function $ad3826e817ebec37$var$mapFragment(fragment, f, parent) {
        let mapped = [];
        for(let i = 0; i < fragment.childCount; i++){
            let child = fragment.child(i);
            if (child.content.size) child = child.copy($ad3826e817ebec37$var$mapFragment(child.content, f, child));
            if (child.isInline) child = f(child, parent, i);
            mapped.push(child);
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(mapped);
    }
    class $ad3826e817ebec37$export$d24ba56b0e3464a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
            let parent = $from.node($from.sharedDepth(this.to));
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node, parent)=>{
                if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
                return node.mark(this.mark.addToSet(node.marks));
            }, parent), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$94150db1311f67a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "addMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addMark", $ad3826e817ebec37$export$d24ba56b0e3464a9);
    class $ad3826e817ebec37$export$94150db1311f67a9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, mark){
            super();
            this.from = from;
            this.to = to;
            this.mark = mark;
        }
        apply(doc) {
            let oldSlice = doc.slice(this.from, this.to);
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$mapFragment(oldSlice.content, (node)=>{
                return node.mark(this.mark.removeFromSet(node.marks));
            }, doc), oldSlice.openStart, oldSlice.openEnd);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
        }
        invert() {
            return new $ad3826e817ebec37$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deleted && to.deleted || from.pos >= to.pos) return null;
            return new $ad3826e817ebec37$export$94150db1311f67a9(from.pos, to.pos, this.mark);
        }
        merge(other) {
            if (other instanceof $ad3826e817ebec37$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $ad3826e817ebec37$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
            return null;
        }
        toJSON() {
            return {
                stepType: "removeMark",
                mark: this.mark.toJSON(),
                from: this.from,
                to: this.to
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeMark", $ad3826e817ebec37$export$94150db1311f67a9);
    class $ad3826e817ebec37$export$adefd16c402fee4e extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (node) {
                let newSet = this.mark.addToSet(node.marks);
                if (newSet.length == node.marks.length) {
                    for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, node.marks[i]);
                    return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
                }
            }
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$adefd16c402fee4e(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "addNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("addNodeMark", $ad3826e817ebec37$export$adefd16c402fee4e);
    class $ad3826e817ebec37$export$fdf7d1dc10724da2 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, mark){
            super();
            this.pos = pos;
            this.mark = mark;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at mark step's position");
            let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        invert(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node || !this.mark.isInSet(node.marks)) return this;
            return new $ad3826e817ebec37$export$adefd16c402fee4e(this.pos, this.mark);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos.pos, this.mark);
        }
        toJSON() {
            return {
                stepType: "removeNodeMark",
                pos: this.pos,
                mark: this.mark.toJSON()
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
            return new $ad3826e817ebec37$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("removeNodeMark", $ad3826e817ebec37$export$fdf7d1dc10724da2);
    class $ad3826e817ebec37$export$5c860b2e74034756 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, slice, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.slice = slice;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && $ad3826e817ebec37$var$contentBetween(doc, this.from, this.to)) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.to - this.from,
                this.slice.size
            ]);
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            if (from.deletedAcross && to.deletedAcross) return null;
            return new $ad3826e817ebec37$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
        }
        merge(other) {
            if (!(other instanceof $ad3826e817ebec37$export$5c860b2e74034756) || other.structure || this.structure) return null;
            if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
            } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
                let slice = this.slice.size + other.slice.size == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
                return new $ad3826e817ebec37$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
            } else return null;
        }
        toJSON() {
            let json = {
                stepType: "replace",
                from: this.from,
                to: this.to
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
            return new $ad3826e817ebec37$export$5c860b2e74034756(json.from, json.to, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replace", $ad3826e817ebec37$export$5c860b2e74034756);
    class $ad3826e817ebec37$export$444ba800d6024a98 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(from, to, gapFrom, gapTo, slice, insert, structure = false){
            super();
            this.from = from;
            this.to = to;
            this.gapFrom = gapFrom;
            this.gapTo = gapTo;
            this.slice = slice;
            this.insert = insert;
            this.structure = structure;
        }
        apply(doc) {
            if (this.structure && ($ad3826e817ebec37$var$contentBetween(doc, this.from, this.gapFrom) || $ad3826e817ebec37$var$contentBetween(doc, this.gapTo, this.to))) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
            let gap = doc.slice(this.gapFrom, this.gapTo);
            if (gap.openStart || gap.openEnd) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Gap is not a flat range");
            let inserted = this.slice.insertAt(this.insert, gap.content);
            if (!inserted) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("Content does not fit in gap");
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
        }
        getMap() {
            return new $ad3826e817ebec37$export$c53d01c3ab9721b3([
                this.from,
                this.gapFrom - this.from,
                this.insert,
                this.gapTo,
                this.to - this.gapTo,
                this.slice.size - this.insert
            ]);
        }
        invert(doc) {
            let gap = this.gapTo - this.gapFrom;
            return new $ad3826e817ebec37$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
        }
        map(mapping) {
            let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
            let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
            let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
            if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
            return new $ad3826e817ebec37$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
        }
        toJSON() {
            let json = {
                stepType: "replaceAround",
                from: this.from,
                to: this.to,
                gapFrom: this.gapFrom,
                gapTo: this.gapTo,
                insert: this.insert
            };
            if (this.slice.size) json.slice = this.slice.toJSON();
            if (this.structure) json.structure = true;
            return json;
        }
        static fromJSON(schema, json) {
            if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
            return new $ad3826e817ebec37$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("replaceAround", $ad3826e817ebec37$export$444ba800d6024a98);
    function $ad3826e817ebec37$var$contentBetween(doc, from, to) {
        let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
        while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
            depth--;
            dist--;
        }
        if (dist > 0) {
            let next = $from.node(depth).maybeChild($from.indexAfter(depth));
            while(dist > 0){
                if (!next || next.isLeaf) return true;
                next = next.firstChild;
                dist--;
            }
        }
        return false;
    }
    function $ad3826e817ebec37$var$addMark(tr, from, to, mark) {
        let removed = [], added = [];
        let removing, adding;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (!node.isInline) return;
            let marks = node.marks;
            if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
                let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
                let newSet = mark.addToSet(marks);
                for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                    else removed.push(removing = new $ad3826e817ebec37$export$94150db1311f67a9(start, end, marks[i]));
                }
                if (adding && adding.to == start) adding.to = end;
                else added.push(adding = new $ad3826e817ebec37$export$d24ba56b0e3464a9(start, end, mark));
            }
        });
        removed.forEach((s)=>tr.step(s));
        added.forEach((s)=>tr.step(s));
    }
    function $ad3826e817ebec37$var$removeMark(tr, from, to, mark) {
        let matched = [], step = 0;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isInline) return;
            step++;
            let toRemove = null;
            if (mark instanceof (0, (0, parcelRequire("kCV8T")).MarkType)) {
                let set = node.marks, found;
                while(found = mark.isInSet(set)){
                    (toRemove || (toRemove = [])).push(found);
                    set = found.removeFromSet(set);
                }
            } else if (mark) {
                if (mark.isInSet(node.marks)) toRemove = [
                    mark
                ];
            } else toRemove = node.marks;
            if (toRemove && toRemove.length) {
                let end = Math.min(pos + node.nodeSize, to);
                for(let i = 0; i < toRemove.length; i++){
                    let style = toRemove[i], found;
                    for(let j = 0; j < matched.length; j++){
                        let m = matched[j];
                        if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                    }
                    if (found) {
                        found.to = end;
                        found.step = step;
                    } else matched.push({
                        style: style,
                        from: Math.max(pos, from),
                        to: end,
                        step: step
                    });
                }
            }
        });
        matched.forEach((m)=>tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(m.from, m.to, m.style)));
    }
    function $ad3826e817ebec37$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
        let node = tr.doc.nodeAt(pos);
        let replSteps = [], cur = pos + 1;
        for(let i = 0; i < node.childCount; i++){
            let child = node.child(i), end = cur + child.nodeSize;
            let allowed = match.matchType(child.type);
            if (!allowed) replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur, end, (0, (0, parcelRequire("kCV8T")).Slice).empty));
            else {
                match = allowed;
                for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $ad3826e817ebec37$export$94150db1311f67a9(cur, end, child.marks[j]));
                if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                    let m, newline = /\r?\n|\r/g, slice;
                    while(m = newline.exec(child.text)){
                        if (!slice) slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                        replSteps.push(new $ad3826e817ebec37$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                    }
                }
            }
            cur = end;
        }
        if (!match.validEnd) {
            let fill = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            tr.replace(cur, cur, new (0, (0, parcelRequire("kCV8T")).Slice)(fill, 0, 0));
        }
        for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
    }
    function $ad3826e817ebec37$var$canCut(node, start, end) {
        return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
    }
    function $ad3826e817ebec37$export$f1508b72cc76a09e(range) {
        let parent = range.parent;
        let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
        for(let depth = range.depth;; --depth){
            let node = range.$from.node(depth);
            let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
            if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
            if (depth == 0 || node.type.spec.isolating || !$ad3826e817ebec37$var$canCut(node, index, endIndex)) break;
        }
        return null;
    }
    function $ad3826e817ebec37$var$lift(tr, range, target) {
        let { $from: $from, $to: $to, depth: depth } = range;
        let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
        let start = gapStart, end = gapEnd;
        let before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openStart = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(d).copy(before));
            openStart++;
        } else start--;
        let after = (0, (0, parcelRequire("kCV8T")).Fragment).empty, openEnd = 0;
        for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from($to.node(d).copy(after));
            openEnd++;
        } else end++;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
    }
    function $ad3826e817ebec37$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
        let around = $ad3826e817ebec37$var$findWrappingOutside(range, nodeType);
        let inner = around && $ad3826e817ebec37$var$findWrappingInside(innerRange, nodeType);
        if (!inner) return null;
        return around.map($ad3826e817ebec37$var$withAttrs).concat({
            type: nodeType,
            attrs: attrs
        }).concat(inner.map($ad3826e817ebec37$var$withAttrs));
    }
    function $ad3826e817ebec37$var$withAttrs(type) {
        return {
            type: type,
            attrs: null
        };
    }
    function $ad3826e817ebec37$var$findWrappingOutside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let around = parent.contentMatchAt(startIndex).findWrapping(type);
        if (!around) return null;
        let outer = around.length ? around[0] : type;
        return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
    }
    function $ad3826e817ebec37$var$findWrappingInside(range, type) {
        let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
        let inner = parent.child(startIndex);
        let inside = type.contentMatch.findWrapping(inner.type);
        if (!inside) return null;
        let lastType = inside.length ? inside[inside.length - 1] : type;
        let innerMatch = lastType.contentMatch;
        for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
        if (!innerMatch || !innerMatch.validEnd) return null;
        return inside;
    }
    function $ad3826e817ebec37$var$wrap(tr, range, wrappers) {
        let content = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let i = wrappers.length - 1; i >= 0; i--){
            if (content.size) {
                let match = wrappers[i].type.contentMatch.matchFragment(content);
                if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
            }
            content = (0, (0, parcelRequire("kCV8T")).Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
        }
        let start = range.start, end = range.end;
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(start, end, start, end, new (0, (0, parcelRequire("kCV8T")).Slice)(content, 0, 0), wrappers.length, true));
    }
    function $ad3826e817ebec37$var$setBlockType(tr, from, to, type, attrs) {
        if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
        let mapFrom = tr.steps.length;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
            if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $ad3826e817ebec37$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
                let convertNewlines = null;
                if (type.schema.linebreakReplacement) {
                    let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                    if (pre && !supportLinebreak) convertNewlines = false;
                    else if (!pre && supportLinebreak) convertNewlines = true;
                }
                if (convertNewlines === false) $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom);
                $ad3826e817ebec37$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
                let mapping = tr.mapping.slice(mapFrom);
                let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
                tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
                if (convertNewlines === true) $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom);
                return false;
            }
        });
    }
    function $ad3826e817ebec37$var$replaceNewlines(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.isText) {
                let m, newline = /\r?\n|\r/g;
                while(m = newline.exec(child.text)){
                    let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                    tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
                }
            }
        });
    }
    function $ad3826e817ebec37$var$replaceLinebreaks(tr, node, pos, mapFrom) {
        node.forEach((child, offset)=>{
            if (child.type == child.type.schema.linebreakReplacement) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
                tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
            }
        });
    }
    function $ad3826e817ebec37$var$canChangeType(doc, pos, type) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, type);
    }
    function $ad3826e817ebec37$var$setNodeMarkup(tr, pos, type, attrs, marks) {
        let node = tr.doc.nodeAt(pos);
        if (!node) throw new RangeError("No node at given position");
        if (!type) type = node.type;
        let newNode = type.create(attrs, null, marks || node.marks);
        if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
        if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
        tr.step(new $ad3826e817ebec37$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(newNode), 0, 0), 1, true));
    }
    function $ad3826e817ebec37$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
        let $pos = doc.resolve(pos), base = $pos.depth - depth;
        let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
        if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
        for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
            let node = $pos.node(d), index = $pos.index(d);
            if (node.type.spec.isolating) return false;
            let rest = node.content.cutByIndex(index, node.childCount);
            let overrideChild = typesAfter && typesAfter[i + 1];
            if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
            let after = typesAfter && typesAfter[i] || node;
            if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
        }
        let index = $pos.indexAfter(base);
        let baseType = typesAfter && typesAfter[0];
        return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
    }
    function $ad3826e817ebec37$var$split(tr, pos, depth = 1, typesAfter) {
        let $pos = tr.doc.resolve(pos), before = (0, (0, parcelRequire("kCV8T")).Fragment).empty, after = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
            before = (0, (0, parcelRequire("kCV8T")).Fragment).from($pos.node(d).copy(before));
            let typeAfter = typesAfter && typesAfter[i];
            after = (0, (0, parcelRequire("kCV8T")).Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
        }
        tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(pos, pos, new (0, (0, parcelRequire("kCV8T")).Slice)(before.append(after), depth, depth), true));
    }
    function $ad3826e817ebec37$export$f15f89fd9d8cc98a(doc, pos) {
        let $pos = doc.resolve(pos), index = $pos.index();
        return $ad3826e817ebec37$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
    }
    function $ad3826e817ebec37$var$joinable(a, b) {
        return !!(a && b && !a.isLeaf && a.canAppend(b));
    }
    function $ad3826e817ebec37$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
        let $pos = doc.resolve(pos);
        for(let d = $pos.depth;; d--){
            let before, after, index = $pos.index(d);
            if (d == $pos.depth) {
                before = $pos.nodeBefore;
                after = $pos.nodeAfter;
            } else if (dir > 0) {
                before = $pos.node(d + 1);
                index++;
                after = $pos.node(d).maybeChild(index);
            } else {
                before = $pos.node(d).maybeChild(index - 1);
                after = $pos.node(d + 1);
            }
            if (before && !before.isTextblock && $ad3826e817ebec37$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
            if (d == 0) break;
            pos = dir < 0 ? $pos.before(d) : $pos.after(d);
        }
    }
    function $ad3826e817ebec37$var$join(tr, pos, depth) {
        let step = new $ad3826e817ebec37$export$5c860b2e74034756(pos - depth, pos + depth, (0, (0, parcelRequire("kCV8T")).Slice).empty, true);
        tr.step(step);
    }
    function $ad3826e817ebec37$export$64cb316d02de1dd1(doc, pos, nodeType) {
        let $pos = doc.resolve(pos);
        if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
        if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
            if (index > 0) return null;
        }
        if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
            if (index < $pos.node(d).childCount) return null;
        }
        return null;
    }
    function $ad3826e817ebec37$export$2819d598d048fc9c(doc, pos, slice) {
        let $pos = doc.resolve(pos);
        if (!slice.content.size) return pos;
        let content = slice.content;
        for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
        for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
        return null;
    }
    function $ad3826e817ebec37$export$ed6ac67359824afd(doc, from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
        if (from == to && !slice.size) return null;
        let $from = doc.resolve(from), $to = doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice);
        return new $ad3826e817ebec37$var$Fitter($from, $to, slice).fit();
    }
    function $ad3826e817ebec37$var$fitsTrivially($from, $to, slice) {
        return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
    }
    class $ad3826e817ebec37$var$Fitter {
        constructor($from, $to, unplaced){
            this.$from = $from;
            this.$to = $to;
            this.unplaced = unplaced;
            this.frontier = [];
            this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
            for(let i = 0; i <= $from.depth; i++){
                let node = $from.node(i);
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt($from.indexAfter(i))
                });
            }
            for(let i = $from.depth; i > 0; i--)this.placed = (0, (0, parcelRequire("kCV8T")).Fragment).from($from.node(i).copy(this.placed));
        }
        get depth() {
            return this.frontier.length - 1;
        }
        fit() {
            while(this.unplaced.size){
                let fit = this.findFittable();
                if (fit) this.placeNodes(fit);
                else this.openMore() || this.dropNode();
            }
            let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
            let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
            if (!$to) return null;
            let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
            while(openStart && openEnd && content.childCount == 1){
                content = content.firstChild.content;
                openStart--;
                openEnd--;
            }
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd);
            if (moveInline > -1) return new $ad3826e817ebec37$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
            if (slice.size || $from.pos != this.$to.pos) return new $ad3826e817ebec37$export$5c860b2e74034756($from.pos, $to.pos, slice);
            return null;
        }
        findFittable() {
            let startDepth = this.unplaced.openStart;
            for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
                let node = cur.firstChild;
                if (cur.childCount > 1) openEnd = 0;
                if (node.type.spec.isolating && openEnd <= d) {
                    startDepth = d;
                    break;
                }
                cur = node.content;
            }
            for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = $ad3826e817ebec37$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                } else fragment = this.unplaced.content;
                let first = fragment.firstChild;
                for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                    let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        inject: inject
                    };
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                        sliceDepth: sliceDepth,
                        frontierDepth: frontierDepth,
                        parent: parent,
                        wrap: wrap
                    };
                    if (parent && match.matchType(parent.type)) break;
                }
            }
        }
        openMore() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (!inner.childCount || inner.firstChild.isLeaf) return false;
            this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
            return true;
        }
        dropNode() {
            let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
            let inner = $ad3826e817ebec37$var$contentAt(content, openStart);
            if (inner.childCount <= 1 && openStart > 0) {
                let openAtEnd = content.size - openStart <= openStart + inner.size;
                this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
            } else this.unplaced = new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
        placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
            while(this.depth > frontierDepth)this.closeFrontierNode();
            if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
            let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
            let openStart = slice.openStart - sliceDepth;
            let taken = 0, add = [];
            let { match: match, type: type } = this.frontier[frontierDepth];
            if (inject) {
                for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
                match = match.matchFragment(inject);
            }
            let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
            while(taken < fragment.childCount){
                let next = fragment.child(taken), matches = match.matchType(next.type);
                if (!matches) break;
                taken++;
                if (taken > 1 || openStart == 0 || next.content.size) {
                    match = matches;
                    add.push($ad3826e817ebec37$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
                }
            }
            let toEnd = taken == fragment.childCount;
            if (!toEnd) openEndCount = -1;
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, frontierDepth, (0, (0, parcelRequire("kCV8T")).Fragment).from(add));
            this.frontier[frontierDepth].match = match;
            if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
            for(let i = 0, cur = fragment; i < openEndCount; i++){
                let node = cur.lastChild;
                this.frontier.push({
                    type: node.type,
                    match: node.contentMatchAt(node.childCount)
                });
                cur = node.content;
            }
            this.unplaced = !toEnd ? new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, (0, parcelRequire("kCV8T")).Slice).empty : new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
        }
        mustMoveInline() {
            if (!this.$to.parent.isTextblock) return -1;
            let top = this.frontier[this.depth], level;
            if (!top.type.isTextblock || !$ad3826e817ebec37$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
            let { depth: depth } = this.$to, after = this.$to.after(depth);
            while(depth > 1 && after == this.$to.end(--depth))++after;
            return after;
        }
        findCloseLevel($to) {
            scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
                let { match: match, type: type } = this.frontier[i];
                let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
                let fit = $ad3826e817ebec37$var$contentAfterFits($to, i, type, match, dropInner);
                if (!fit) continue;
                for(let d = i - 1; d >= 0; d--){
                    let { match: match, type: type } = this.frontier[d];
                    let matches = $ad3826e817ebec37$var$contentAfterFits($to, d, type, match, true);
                    if (!matches || matches.childCount) continue scan;
                }
                return {
                    depth: i,
                    fit: fit,
                    move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
                };
            }
        }
        close($to) {
            let close = this.findCloseLevel($to);
            if (!close) return null;
            while(this.depth > close.depth)this.closeFrontierNode();
            if (close.fit.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, close.depth, close.fit);
            $to = close.move;
            for(let d = close.depth + 1; d <= $to.depth; d++){
                let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
                this.openFrontierNode(node.type, node.attrs, add);
            }
            return $to;
        }
        openFrontierNode(type, attrs = null, content) {
            let top = this.frontier[this.depth];
            top.match = top.match.matchType(type);
            this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.depth, (0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(attrs, content)));
            this.frontier.push({
                type: type,
                match: type.contentMatch
            });
        }
        closeFrontierNode() {
            let open = this.frontier.pop();
            let add = open.match.fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
            if (add.childCount) this.placed = $ad3826e817ebec37$var$addToFragment(this.placed, this.frontier.length, add);
        }
    }
    function $ad3826e817ebec37$var$dropFromFragment(fragment, depth, count) {
        if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
        return fragment.replaceChild(0, fragment.firstChild.copy($ad3826e817ebec37$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
    }
    function $ad3826e817ebec37$var$addToFragment(fragment, depth, content) {
        if (depth == 0) return fragment.append(content);
        return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($ad3826e817ebec37$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
    }
    function $ad3826e817ebec37$var$contentAt(fragment, depth) {
        for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
        return fragment;
    }
    function $ad3826e817ebec37$var$closeNodeStart(node, openStart, openEnd) {
        if (openStart <= 0) return node;
        let frag = node.content;
        if (openStart > 1) frag = frag.replaceChild(0, $ad3826e817ebec37$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
        if (openStart > 0) {
            frag = node.type.contentMatch.fillBefore(frag).append(frag);
            if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return node.copy(frag);
    }
    function $ad3826e817ebec37$var$contentAfterFits($to, depth, type, match, open) {
        let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
        if (index == node.childCount && !type.compatibleContent(node.type)) return null;
        let fit = match.fillBefore(node.content, true, index);
        return fit && !$ad3826e817ebec37$var$invalidMarks(type, node.content, index) ? fit : null;
    }
    function $ad3826e817ebec37$var$invalidMarks(type, fragment, start) {
        for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
        return false;
    }
    function $ad3826e817ebec37$var$definesContent(type) {
        return type.spec.defining || type.spec.definingForContent;
    }
    function $ad3826e817ebec37$var$replaceRange(tr, from, to, slice) {
        if (!slice.size) return tr.deleteRange(from, to);
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        if ($ad3826e817ebec37$var$fitsTrivially($from, $to, slice)) return tr.step(new $ad3826e817ebec37$export$5c860b2e74034756(from, to, slice));
        let targetDepths = $ad3826e817ebec37$var$coveredDepths($from, tr.doc.resolve(to));
        if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
        let preferredTarget = -($from.depth + 1);
        targetDepths.unshift(preferredTarget);
        for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
            let spec = $from.node(d).type.spec;
            if (spec.defining || spec.definingAsContext || spec.isolating) break;
            if (targetDepths.indexOf(d) > -1) preferredTarget = d;
            else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
        }
        let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
        let leftNodes = [], preferredDepth = slice.openStart;
        for(let content = slice.content, i = 0;; i++){
            let node = content.firstChild;
            leftNodes.push(node);
            if (i == slice.openStart) break;
            content = node.content;
        }
        for(let d = preferredDepth - 1; d >= 0; d--){
            let leftNode = leftNodes[d], def = $ad3826e817ebec37$var$definesContent(leftNode.type);
            if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
            else if (def || !leftNode.type.isTextblock) break;
        }
        for(let j = slice.openStart; j >= 0; j--){
            let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
            let insert = leftNodes[openDepth];
            if (!insert) continue;
            for(let i = 0; i < targetDepths.length; i++){
                let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
                if (targetDepth < 0) {
                    expand = false;
                    targetDepth = -targetDepth;
                }
                let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
                if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, (0, parcelRequire("kCV8T")).Slice)($ad3826e817ebec37$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
            }
        }
        let startSteps = tr.steps.length;
        for(let i = targetDepths.length - 1; i >= 0; i--){
            tr.replace(from, to, slice);
            if (tr.steps.length > startSteps) break;
            let depth = targetDepths[i];
            if (depth < 0) continue;
            from = $from.before(depth);
            to = $to.after(depth);
        }
    }
    function $ad3826e817ebec37$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
        if (depth < oldOpen) {
            let first = fragment.firstChild;
            fragment = fragment.replaceChild(0, first.copy($ad3826e817ebec37$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
        }
        if (depth > newOpen) {
            let match = parent.contentMatchAt(0);
            let start = match.fillBefore(fragment).append(fragment);
            fragment = start.append(match.matchFragment(start).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        }
        return fragment;
    }
    function $ad3826e817ebec37$var$replaceRangeWith(tr, from, to, node) {
        if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
            let point = $ad3826e817ebec37$export$64cb316d02de1dd1(tr.doc, from, node.type);
            if (point != null) from = to = point;
        }
        tr.replaceRange(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(node), 0, 0));
    }
    function $ad3826e817ebec37$var$deleteRange(tr, from, to) {
        let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
        let covered = $ad3826e817ebec37$var$coveredDepths($from, $to);
        for(let i = 0; i < covered.length; i++){
            let depth = covered[i], last = i == covered.length - 1;
            if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
            if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
        }
        for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
            if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
        }
        tr.delete(from, to);
    }
    function $ad3826e817ebec37$var$coveredDepths($from, $to) {
        let result = [], minDepth = Math.min($from.depth, $to.depth);
        for(let d = minDepth; d >= 0; d--){
            let start = $from.start(d);
            if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
            if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
        }
        return result;
    }
    class $ad3826e817ebec37$export$626399c38172f669 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(pos, attr, value){
            super();
            this.pos = pos;
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let node = doc.nodeAt(this.pos);
            if (!node) return $ad3826e817ebec37$export$8ebf1578a4199c09.fail("No node at attribute step's position");
            let attrs = Object.create(null);
            for(let name in node.attrs)attrs[name] = node.attrs[name];
            attrs[this.attr] = this.value;
            let updated = node.type.create(attrs, null, node.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
        }
        map(mapping) {
            let pos = mapping.mapResult(this.pos, 1);
            return pos.deletedAfter ? null : new $ad3826e817ebec37$export$626399c38172f669(pos.pos, this.attr, this.value);
        }
        toJSON() {
            return {
                stepType: "attr",
                pos: this.pos,
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
            return new $ad3826e817ebec37$export$626399c38172f669(json.pos, json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("attr", $ad3826e817ebec37$export$626399c38172f669);
    class $ad3826e817ebec37$export$f50707b396300ac9 extends $ad3826e817ebec37$export$fd55ce593607084a {
        constructor(attr, value){
            super();
            this.attr = attr;
            this.value = value;
        }
        apply(doc) {
            let attrs = Object.create(null);
            for(let name in doc.attrs)attrs[name] = doc.attrs[name];
            attrs[this.attr] = this.value;
            let updated = doc.type.create(attrs, doc.content, doc.marks);
            return $ad3826e817ebec37$export$8ebf1578a4199c09.ok(updated);
        }
        getMap() {
            return $ad3826e817ebec37$export$c53d01c3ab9721b3.empty;
        }
        invert(doc) {
            return new $ad3826e817ebec37$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
        }
        map(mapping) {
            return this;
        }
        toJSON() {
            return {
                stepType: "docAttr",
                attr: this.attr,
                value: this.value
            };
        }
        static fromJSON(schema, json) {
            if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
            return new $ad3826e817ebec37$export$f50707b396300ac9(json.attr, json.value);
        }
    }
    $ad3826e817ebec37$export$fd55ce593607084a.jsonID("docAttr", $ad3826e817ebec37$export$f50707b396300ac9);
    let $ad3826e817ebec37$export$88cc3a1dfce48dd3 = class extends Error {
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3 = function TransformError(message) {
        let err = Error.call(this, message);
        err.__proto__ = TransformError.prototype;
        return err;
    };
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.constructor = $ad3826e817ebec37$export$88cc3a1dfce48dd3;
    $ad3826e817ebec37$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
    class $ad3826e817ebec37$export$563a914cafbdc389 {
        constructor(doc){
            this.doc = doc;
            this.steps = [];
            this.docs = [];
            this.mapping = new $ad3826e817ebec37$export$f5f785078011b62;
        }
        get before() {
            return this.docs.length ? this.docs[0] : this.doc;
        }
        step(step) {
            let result = this.maybeStep(step);
            if (result.failed) throw new $ad3826e817ebec37$export$88cc3a1dfce48dd3(result.failed);
            return this;
        }
        maybeStep(step) {
            let result = step.apply(this.doc);
            if (!result.failed) this.addStep(step, result.doc);
            return result;
        }
        get docChanged() {
            return this.steps.length > 0;
        }
        addStep(step, doc) {
            this.docs.push(this.doc);
            this.steps.push(step);
            this.mapping.appendMap(step.getMap());
            this.doc = doc;
        }
        replace(from, to = from, slice = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            let step = $ad3826e817ebec37$export$ed6ac67359824afd(this.doc, from, to, slice);
            if (step) this.step(step);
            return this;
        }
        replaceWith(from, to, content) {
            return this.replace(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(content), 0, 0));
        }
        delete(from, to) {
            return this.replace(from, to, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
        insert(pos, content) {
            return this.replaceWith(pos, pos, content);
        }
        replaceRange(from, to, slice) {
            $ad3826e817ebec37$var$replaceRange(this, from, to, slice);
            return this;
        }
        replaceRangeWith(from, to, node) {
            $ad3826e817ebec37$var$replaceRangeWith(this, from, to, node);
            return this;
        }
        deleteRange(from, to) {
            $ad3826e817ebec37$var$deleteRange(this, from, to);
            return this;
        }
        lift(range, target) {
            $ad3826e817ebec37$var$lift(this, range, target);
            return this;
        }
        join(pos, depth = 1) {
            $ad3826e817ebec37$var$join(this, pos, depth);
            return this;
        }
        wrap(range, wrappers) {
            $ad3826e817ebec37$var$wrap(this, range, wrappers);
            return this;
        }
        setBlockType(from, to = from, type, attrs = null) {
            $ad3826e817ebec37$var$setBlockType(this, from, to, type, attrs);
            return this;
        }
        setNodeMarkup(pos, type, attrs = null, marks) {
            $ad3826e817ebec37$var$setNodeMarkup(this, pos, type, attrs, marks);
            return this;
        }
        setNodeAttribute(pos, attr, value) {
            this.step(new $ad3826e817ebec37$export$626399c38172f669(pos, attr, value));
            return this;
        }
        setDocAttribute(attr, value) {
            this.step(new $ad3826e817ebec37$export$f50707b396300ac9(attr, value));
            return this;
        }
        addNodeMark(pos, mark) {
            this.step(new $ad3826e817ebec37$export$adefd16c402fee4e(pos, mark));
            return this;
        }
        removeNodeMark(pos, mark) {
            if (!(mark instanceof (0, (0, parcelRequire("kCV8T")).Mark))) {
                let node = this.doc.nodeAt(pos);
                if (!node) throw new RangeError("No node at position " + pos);
                mark = mark.isInSet(node.marks);
                if (!mark) return this;
            }
            this.step(new $ad3826e817ebec37$export$fdf7d1dc10724da2(pos, mark));
            return this;
        }
        split(pos, depth = 1, typesAfter) {
            $ad3826e817ebec37$var$split(this, pos, depth, typesAfter);
            return this;
        }
        addMark(from, to, mark) {
            $ad3826e817ebec37$var$addMark(this, from, to, mark);
            return this;
        }
        removeMark(from, to, mark) {
            $ad3826e817ebec37$var$removeMark(this, from, to, mark);
            return this;
        }
        clearIncompatible(pos, parentType, match) {
            $ad3826e817ebec37$var$clearIncompatible(this, pos, parentType, match);
            return this;
        }
    }
});
parcelRegister("cMPbW", function(module, exports) {
    $parcel$export(module.exports, "isRoot", ()=>$c9441534493a403f$export$e3140dc7d0c35e48);
    $parcel$export(module.exports, "getPosFromRange", ()=>$c9441534493a403f$export$243cdddc5b21d8c1);
    $parcel$export(module.exports, "createAnnotationStep", ()=>$c9441534493a403f$export$74899f7e5acb5cd3);
    var $VSDnB;
    var $eS2Dn;
    function $c9441534493a403f$var$getStartPos(element) {
        return parseInt(element.dataset.rendererStartPos || '-1', 10);
    }
    const $c9441534493a403f$var$getNodeType = (element)=>element.dataset.nodeType;
    function $c9441534493a403f$var$isPositionPointer(element) {
        return $c9441534493a403f$var$getStartPos(element) > -1;
    }
    function $c9441534493a403f$var$findParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
        if ($c9441534493a403f$var$isPositionPointer(parentElement)) return parentElement;
        return $c9441534493a403f$var$findParent(parentElement);
    }
    function $c9441534493a403f$var$findMediaParent(element) {
        const { parentElement: parentElement } = element;
        if (!parentElement || $c9441534493a403f$export$e3140dc7d0c35e48(parentElement)) return null;
        if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
        return $c9441534493a403f$var$findMediaParent(parentElement);
    }
    function $c9441534493a403f$var$findParentBeforePointer(element) {
        const { parentElement: parentElement } = element;
        if ($c9441534493a403f$export$e3140dc7d0c35e48(parentElement) || !parentElement) return null;
        if ($c9441534493a403f$var$isPositionPointer(parentElement)) return element;
        return $c9441534493a403f$var$findParentBeforePointer(parentElement);
    }
    function $c9441534493a403f$var$isElementNode(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    }
    function $c9441534493a403f$var$isTextNode(node) {
        return node.nodeType === Node.TEXT_NODE;
    }
    function $c9441534493a403f$var$isHighlightTextNode(node) {
        return !!node?.dataset?.highlighted;
    }
    function $c9441534493a403f$var$isNodeInlineMark(node) {
        return $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    }
    function $c9441534493a403f$var$isElementInlineMark(element) {
        return !!element && Boolean(element.dataset.rendererMark);
    }
    function $c9441534493a403f$var$isNodeInlineTextMark(node) {
        if (node === null) return false;
        const isInlineMark = $c9441534493a403f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
        if (!isInlineMark) return false;
        if ($c9441534493a403f$var$hasInlineNodeDescendant(node)) return false;
        return true;
    }
    function $c9441534493a403f$var$hasInlineNodeDescendant(node) {
        if ($c9441534493a403f$var$isElementNode(node)) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.dataset.annotationInlineNode === 'true') return true;
            } else {
                if (node.dataset.inlineCard === 'true') return true;
            }
            return Array.from(node.childNodes).some($c9441534493a403f$var$hasInlineNodeDescendant);
        }
        return false;
    }
    function $c9441534493a403f$var$resolveNodePos(node) {
        let resolvedPos = 0;
        let prev = node.previousSibling;
        while(prev){
            if (prev && ($c9441534493a403f$var$isTextNode(prev) || $c9441534493a403f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
            else if (prev) {
                if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                    if ($c9441534493a403f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                    else resolvedPos += 1;
                } else if ($c9441534493a403f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            }
            prev = prev.previousSibling;
        }
        return resolvedPos;
    }
    function $c9441534493a403f$export$e3140dc7d0c35e48(element) {
        return !!element && element.classList.contains('ak-renderer-document');
    }
    function $c9441534493a403f$export$5db587db55468da7(node, offset, findEnd = false) {
        if (!node) return false;
        if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
            const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
            const potentialParent = (0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
            if (startPosAncestor?.hasAttribute(potentialParent)) {
                if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
                else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
            }
        }
        if (node instanceof HTMLElement && $c9441534493a403f$var$isPositionPointer(node)) {
            if (findEnd) {
                let count = $c9441534493a403f$var$getStartPos(node);
                const children = node.childNodes;
                for(let i = 0; i < offset; i++)count += children[i]?.textContent?.length || 1;
                return count;
            }
            return $c9441534493a403f$var$getStartPos(node) + offset;
        }
        const parent = $c9441534493a403f$var$findParent(node);
        if (!parent) return false;
        let resolvedPos = $c9441534493a403f$var$getStartPos(parent);
        let current = node;
        if (current.parentElement && current.parentElement !== parent) {
            const preParentPointer = $c9441534493a403f$var$findParentBeforePointer(current.parentElement);
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (!($c9441534493a403f$var$isNodeInlineTextMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                    current = current.parentElement;
                    offset = 0;
                }
            } else if (!($c9441534493a403f$var$isElementInlineMark(preParentPointer) || $c9441534493a403f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
            resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
            while(current && current.parentElement !== parent){
                current = current.parentNode;
                if (current) {
                    const nodePos = $c9441534493a403f$var$resolveNodePos(current);
                    resolvedPos += nodePos;
                }
            }
        } else resolvedPos += $c9441534493a403f$var$resolveNodePos(current);
        return resolvedPos + offset;
    }
    function $c9441534493a403f$export$243cdddc5b21d8c1(range) {
        const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
        const possibleMediaOrMediaSingleElement = $c9441534493a403f$var$findParent(startContainer);
        const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && /media|mediaSingle/.test($c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
        if (isMediaOrMediaSingle) {
            let pos;
            const mediaSingleElement = $c9441534493a403f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $c9441534493a403f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $c9441534493a403f$var$getStartPos(mediaSingleElement);
            if (pos !== undefined) return {
                from: pos,
                to: pos
            };
        }
        const from = $c9441534493a403f$export$5db587db55468da7(startContainer, startOffset);
        const findEnd = true;
        const to = $c9441534493a403f$export$5db587db55468da7(endContainer, endOffset, findEnd);
        if (from === false || to === false) return false;
        return {
            from: from,
            to: to
        };
    }
    function $c9441534493a403f$export$74899f7e5acb5cd3(from, to, opts) {
        return new (0, (0, parcelRequire("eS2Dn")).AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
            id: opts.annotationId,
            annotationType: opts.annotationType
        }));
    }
});
parcelRegister("hAPWV", function(module, exports) {
    $parcel$export(module.exports, "getIndexMatch", ()=>$8b6d6fb20e026dde$export$fb7dab895a0d310e);
    function $8b6d6fb20e026dde$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
        let textContent = '';
        let matchIndex = 0;
        let numMatches = 0;
        let blockNodePos;
        doc.descendants((node, pos)=>{
            const nodeType = node.type;
            const { media: media } = schema.nodes;
            if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) return true;
            const nodeStart = pos;
            const nodeEnd = nodeStart + node.nodeSize;
            if (startIndex >= nodeStart && startIndex <= nodeEnd) {
                if (nodeType === media) blockNodePos = pos;
                textContent += doc.textBetween(nodeStart, startIndex - 1);
                matchIndex = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
                textContent += doc.textBetween(startIndex, nodeEnd);
            } else textContent += node.textContent;
            return true;
        });
        numMatches = $8b6d6fb20e026dde$export$3c2359e76fc742da(textContent, selectedText);
        return {
            numMatches: numMatches,
            matchIndex: matchIndex,
            textContent: textContent,
            blockNodePos: blockNodePos
        };
    }
    function $8b6d6fb20e026dde$export$3c2359e76fc742da(searchString, query) {
        if (searchString === '' || query === '') return 0;
        const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
        return (searchString.match(reg) || []).length;
    }
});
parcelRegister("4apTl", function(module, exports) {
    $parcel$export(module.exports, "getRendererRangeInlineNodeNames", ()=>$3b0115c3167e4664$export$b0ea72d31617ccea);
    var $h03xs;
    var $VSDnB;
    function $3b0115c3167e4664$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
        const { doc: doc } = actions;
        if (!pos || !doc) return undefined;
        const inlineNodeNames = (0, (0, parcelRequire("h03xs")).getRangeInlineNodeNames)({
            doc: doc,
            pos: pos
        });
        return inlineNodeNames;
    }
});
parcelRegister("8Mz83", function(module, exports) {
    $parcel$export(module.exports, "AnnotationsContextWrapper", ()=>$68c25c02b6872087$export$787af8a111ff3c03);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    var $6MIvG;
    var $iatcV;
    var $2EsbE;
    const $68c25c02b6872087$export$787af8a111ff3c03 = (props)=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        const { range: range, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
        const inlineCommentProvider = providers && providers.inlineComment;
        const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
        const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
        const setRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            setDraftRange(range, type);
        }, [
            range,
            setDraftRange,
            type
        ]);
        const clearRangeForDraft = (0, $5uXOq.useCallback)(()=>{
            clearDraftRange(type);
        }, [
            type,
            clearDraftRange
        ]);
        const render = (0, $5uXOq.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children, !!hoverComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MIvG")).RangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                component: hoverComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }), !!selectionComponent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iatcV")).SelectionRangeValidator), {
                createAnalyticsEvent: createAnalyticsEvent,
                rendererRef: rendererRef,
                selectionComponent: selectionComponent,
                applyAnnotationDraftAt: applyAnnotationDraftAt,
                clearAnnotationDraft: clearAnnotationDraft
            }));
        }, [
            hoverComponent,
            selectionComponent,
            children,
            rendererRef,
            createAnalyticsEvent
        ]);
        if (!selectionComponent && !hoverComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iYAgE")).AnnotationsDraftContextWrapper), {
            setDraftRange: setRangeForDraft,
            clearDraftRange: clearRangeForDraft
        }, render);
    };
});
parcelRegister("6MIvG", function(module, exports) {
    $parcel$export(module.exports, "RangeValidator", ()=>$38d3fe2fadcf735b$export$6d8376a902cb8aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $7g31n;
    var $fCNtA;
    var $2EsbE;
    var $kuusl;
    const $38d3fe2fadcf735b$export$6d8376a902cb8aa7 = (props)=>{
        const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const { clearHoverRange: clearHoverRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { range: range, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        const { isWithinRange: isWithinRange } = (0, (0, parcelRequire("kuusl")).useAnnotationHoverContext)();
        if (!range || type !== 'hover') return null;
        const documentPosition = actions.getPositionFromRange(range);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7g31n")).Mounter), {
            isWithinRange: isWithinRange,
            range: range,
            wrapperDOM: rendererRef,
            component: component,
            onClose: clearHoverRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: true,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("7g31n", function(module, exports) {
    $parcel$export(module.exports, "Mounter", ()=>$3da53cae08f8e9e6$export$2109cd350bcf6eda);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $fVTp8;
    var $dWAZk = parcelRequire("dWAZk");
    var $gkwXh;
    var $fCNtA;
    const $3da53cae08f8e9e6$export$2109cd350bcf6eda = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return applyAnnotation(draftDocumentPosition || documentPosition, annotation);
        }, [
            isAnnotationAllowed,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {},
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }).fire((0, $dWAZk.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("fVTp8")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {}
            }).fire((0, $dWAZk.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            isWithinRange: isWithinRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback
        });
    });
});
parcelRegister("fVTp8", function(module, exports) {
    $parcel$export(module.exports, "dataAttributes", ()=>$c2a45e53becb69f1$export$15d6ddc168d35719);
    $parcel$export(module.exports, "updateWindowSelectionAroundDraft", ()=>$c2a45e53becb69f1$export$e14699d956e87e73);
    const $c2a45e53becb69f1$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
        return {
            ['data-annotation-draft-mark']: true,
            ['data-draft-start-at']: from,
            ['data-draft-end-at']: to
        };
    };
    const $c2a45e53becb69f1$var$buildDataAttributesQuery = (pos)=>{
        const a = $c2a45e53becb69f1$export$15d6ddc168d35719(pos);
        return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
    };
    const $c2a45e53becb69f1$export$e14699d956e87e73 = (pos)=>{
        const sel = window.getSelection();
        if (!sel) return false;
        const draftNodes = document.querySelectorAll($c2a45e53becb69f1$var$buildDataAttributesQuery(pos));
        if (!draftNodes || draftNodes.length === 0) return false;
        sel.removeAllRanges();
        const range = document.createRange();
        range.setStart(draftNodes[0], 0);
        range.setEndAfter(draftNodes[draftNodes.length - 1]);
        sel.addRange(range);
        return true;
    };
});
parcelRegister("2EsbE", function(module, exports) {
    $parcel$export(module.exports, "AnnotationRangeProvider", ()=>$7c7af48337b91c7a$export$30384a6aedd19fee);
    $parcel$export(module.exports, "useAnnotationRangeState", ()=>$7c7af48337b91c7a$export$e07ee6d6cc95d9a0);
    $parcel$export(module.exports, "useAnnotationRangeDispatch", ()=>$7c7af48337b91c7a$export$708fc397e2b6f08d);
    var $5uXOq = parcelRequire("5uXOq");
    function $7c7af48337b91c7a$var$reducer(state, action) {
        switch(action.type){
            case 'clear':
                if (!!state.range || !!state.type) return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'clearSelection':
                if (state.type === 'selection') return {
                    ...state,
                    range: null,
                    type: null
                };
                return state;
            case 'clearDraftSelection':
                if (state.type === 'selection') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearDraftHover':
                if (state.type === 'hover') return {
                    ...state,
                    draftRange: null
                };
                return state;
            case 'clearHover':
                if (state.type === 'hover') return {
                    range: null,
                    draftRange: null,
                    type: null
                };
                return state;
            case 'setSelection':
                if (state.range !== action.range || state.type !== 'selection') return {
                    ...state,
                    range: action.range,
                    type: 'selection'
                };
                return state;
            case 'setHover':
                if (state.range !== action.range || state.type !== 'hover') return {
                    ...state,
                    range: action.range,
                    type: 'hover'
                };
                return state;
            case 'setDraftSelection':
                if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                    range: null,
                    draftRange: action.draftRange,
                    type: null
                };
                return state;
            case 'setDraftHover':
                if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                    ...state,
                    draftRange: action.draftRange
                };
                return state;
        }
    }
    const $7c7af48337b91c7a$var$AnnotationRangeStateContext = (0, $5uXOq.createContext)({
        range: null,
        draftRange: null,
        type: null
    });
    const $7c7af48337b91c7a$var$AnnotationRangeDispatchContext = (0, $5uXOq.createContext)({
        clearRange: ()=>{},
        clearSelectionRange: ()=>{},
        clearDraftRange: ()=>{},
        clearHoverRange: ()=>{},
        setRange: ()=>{},
        setDraftRange: ()=>{}
    });
    const $7c7af48337b91c7a$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
        const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $5uXOq.useReducer)($7c7af48337b91c7a$var$reducer, {
            range: null,
            draftRange: null,
            type: null
        });
        const clearRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clear'
            }), []);
        const clearSelectionRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearSelection'
            }), []);
        const clearDraftRange = (0, $5uXOq.useCallback)((type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'clearDraftHover'
                });
                return;
            }
            dispatch({
                type: 'clearDraftSelection'
            });
        }, []);
        const clearHoverRange = (0, $5uXOq.useCallback)(()=>dispatch({
                type: 'clearHover'
            }), []);
        const setRange = (0, $5uXOq.useCallback)((range)=>dispatch({
                type: 'setSelection',
                range: range
            }), []);
        const setDraftRange = (0, $5uXOq.useCallback)((range, type)=>{
            if (type === 'hover') {
                dispatch({
                    type: 'setDraftHover',
                    draftRange: range
                });
                return;
            }
            dispatch({
                type: 'setDraftSelection',
                draftRange: range
            });
        }, []);
        const setHoverTarget = (0, $5uXOq.useCallback)((target)=>{
            const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
            if (!mediaNode) return;
            const range = document.createRange();
            range.setStartBefore(mediaNode);
            range.setEndAfter(mediaNode);
            dispatch({
                type: 'setHover',
                range: range
            });
        }, []);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                range: range,
                draftRange: draftRange,
                type: type
            }), [
            range,
            draftRange,
            type
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                clearRange: clearRange,
                clearSelectionRange: clearSelectionRange,
                clearDraftRange: clearDraftRange,
                clearHoverRange: clearHoverRange,
                setRange: setRange,
                setDraftRange: setDraftRange,
                setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
            }), [
            allowCommentsOnMedia,
            clearRange,
            clearSelectionRange,
            clearDraftRange,
            clearHoverRange,
            setRange,
            setDraftRange,
            setHoverTarget
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c7af48337b91c7a$var$AnnotationRangeDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $7c7af48337b91c7a$export$e07ee6d6cc95d9a0 = ()=>{
        return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeStateContext);
    };
    const $7c7af48337b91c7a$export$708fc397e2b6f08d = ()=>{
        return (0, $5uXOq.useContext)($7c7af48337b91c7a$var$AnnotationRangeDispatchContext);
    };
});
parcelRegister("kuusl", function(module, exports) {
    $parcel$export(module.exports, "AnnotationHoverContext", ()=>$b758d405b6d3becf$export$b3db0feb20552fc3);
    $parcel$export(module.exports, "useAnnotationHoverContext", ()=>$b758d405b6d3becf$export$a02bfcbbbf920306);
    $parcel$export(module.exports, "useAnnotationHoverDispatch", ()=>$b758d405b6d3becf$export$c288883964405c82);
    var $5uXOq = parcelRequire("5uXOq");
    const $b758d405b6d3becf$var$AnnotationHoverStateContext = (0, $5uXOq.createContext)({
        isWithinRange: false
    });
    const $b758d405b6d3becf$var$AnnotationHoverDispatchContext = (0, $5uXOq.createContext)({
        cancelTimeout: ()=>{},
        initiateTimeout: ()=>{},
        setIsWithinRange: ()=>{}
    });
    const $b758d405b6d3becf$export$b3db0feb20552fc3 = ({ children: children })=>{
        const [isWithinRange, setIsWithinRange] = (0, $5uXOq.useState)(false);
        const timeoutHandler = (0, $5uXOq.useRef)();
        const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
            if (timeoutHandler) clearTimeout(timeoutHandler.current);
        }, [
            timeoutHandler
        ]);
        const initiateTimeout = (0, $5uXOq.useCallback)(()=>{
            if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
                setIsWithinRange(false);
            }, 500);
        }, [
            isWithinRange
        ]);
        const stateData = (0, $5uXOq.useMemo)(()=>({
                isWithinRange: isWithinRange
            }), [
            isWithinRange
        ]);
        const dispatchData = (0, $5uXOq.useMemo)(()=>({
                cancelTimeout: cancelTimeout,
                initiateTimeout: initiateTimeout,
                setIsWithinRange: setIsWithinRange
            }), [
            cancelTimeout,
            initiateTimeout,
            setIsWithinRange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverStateContext.Provider, {
            value: stateData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b758d405b6d3becf$var$AnnotationHoverDispatchContext.Provider, {
            value: dispatchData
        }, children));
    };
    const $b758d405b6d3becf$export$a02bfcbbbf920306 = ()=>{
        return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverStateContext);
    };
    const $b758d405b6d3becf$export$c288883964405c82 = ()=>{
        return (0, $5uXOq.useContext)($b758d405b6d3becf$var$AnnotationHoverDispatchContext);
    };
});
parcelRegister("iatcV", function(module, exports) {
    $parcel$export(module.exports, "SelectionRangeValidator", ()=>$d73a3647df6a8131$export$74435b85e23b84d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $jWe7H;
    var $bZQ2Q;
    var $fCNtA;
    const $d73a3647df6a8131$export$74435b85e23b84d9 = (props)=>{
        const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const [range, draftRange, clearRange] = (0, (0, parcelRequire("jWe7H")).useUserSelectionRange)({
            rendererRef: rendererRef
        });
        if (!range && !draftRange) return null;
        const documentPosition = actions.getPositionFromRange(range);
        let isAnnotationAllowedOnRange = false;
        try {
            isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
        } catch  {
            isAnnotationAllowedOnRange = false;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZQ2Q")).SelectionInlineCommentMounter), {
            range: range,
            draftRange: draftRange,
            wrapperDOM: rendererRef,
            component: selectionComponent,
            onClose: clearRange,
            documentPosition: documentPosition,
            isAnnotationAllowed: isAnnotationAllowedOnRange,
            applyAnnotation: actions.applyAnnotation.bind(actions),
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
            clearAnnotationDraft: clearAnnotationDraft,
            createAnalyticsEvent: createAnalyticsEvent
        });
    };
});
parcelRegister("jWe7H", function(module, exports) {
    $parcel$export(module.exports, "useUserSelectionRange", ()=>$cd0f4805a1ba9aff$export$47201332e612f5a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $2EsbE;
    var $jqO24;
    var $cMPbW;
    const $cd0f4805a1ba9aff$export$47201332e612f5a4 = (props)=>{
        const { rendererRef: { current: rendererDOM } } = props;
        const selectionTimeoutRef = (0, $5uXOq.useRef)();
        const { clearRange: clearRange, setRange: setRange } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeDispatch)();
        const { range: range, draftRange: draftRange, type: type } = (0, (0, parcelRequire("2EsbE")).useAnnotationRangeState)();
        (0, $5uXOq.useEffect)(()=>{
            if (!document || !rendererDOM) return;
            const onSelectionChange = (event)=>{
                if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
                selectionTimeoutRef.current = setTimeout(()=>{
                    const sel = document.getSelection();
                    if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                    const _range = sel.getRangeAt(0);
                    if (rendererDOM && (0, (0, parcelRequire("jqO24")).isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_allow_annotation_triple_click')) {
                            const { startContainer: startContainer, endContainer: endContainer, commonAncestorContainer: commonAncestorContainer } = _range;
                            const parentNode = startContainer.parentNode;
                            const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                            if (isTripleClick && (0, (0, parcelRequire("cMPbW")).isRoot)(commonAncestorContainer) && parentNode?.nodeName === 'P') {
                                const lastChild = parentNode?.lastChild && parentNode?.lastChild?.nodeType === Node.TEXT_NODE ? parentNode?.lastChild : parentNode?.lastChild?.childNodes[0];
                                _range.setEnd(lastChild, lastChild.length || 0);
                            }
                        }
                        setRange(_range.cloneRange());
                    }
                }, 250);
            };
            document.addEventListener('selectionchange', onSelectionChange);
            return ()=>{
                document.removeEventListener('selectionchange', onSelectionChange);
                clearRange();
            };
        }, [
            rendererDOM,
            setRange,
            clearRange
        ]);
        return [
            type === 'selection' ? range : null,
            draftRange,
            clearRange
        ];
    };
});
parcelRegister("jqO24", function(module, exports) {
    $parcel$export(module.exports, "isRangeInsideOfRendererContainer", ()=>$8373eb69e5c4287b$export$90ee8f2d9317f430);
    const $8373eb69e5c4287b$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
        const sourceRange = document.createRange();
        sourceRange.selectNode(rendererDOM);
        const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
        const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
        const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
        return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
    };
});
parcelRegister("bZQ2Q", function(module, exports) {
    $parcel$export(module.exports, "SelectionInlineCommentMounter", ()=>$7e4c7bbc0d380e24$export$ca7741472ed8ba00);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $VSDnB;
    var $fVTp8;
    var $dWAZk = parcelRequire("dWAZk");
    var $gkwXh;
    var $4apTl;
    var $fCNtA;
    const $7e4c7bbc0d380e24$export$ca7741472ed8ba00 = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
        const [draftDocumentPosition, setDraftDocumentPosition] = (0, $5uXOq.useState)();
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const inlineNodeTypes = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('annotations_defensive_node_name_calculations')) {
                if (!actions.isRangeAnnotatable(range)) return undefined;
                return (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
            } else {
                if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return undefined;
                if (actions.isValidAnnotationRange(range)) return (0, (0, parcelRequire("4apTl")).getRendererRangeInlineNodeNames)({
                    pos: documentPosition,
                    actions: actions
                });
                else return undefined;
            }
        }, [
            documentPosition,
            actions,
            range
        ]);
        const onCreateCallback = (0, $5uXOq.useCallback)((annotationId)=>{
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation) return false;
            const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
            if (!isCreateAllowedOnPosition) return false;
            const annotation = {
                annotationId: annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }).fire((0, $dWAZk.FabricChannel).editor);
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            actions,
            documentPosition,
            applyAnnotation,
            draftDocumentPosition,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        const createIndexCallback = (0, $5uXOq.useCallback)(()=>{
            if (!documentPosition || !generateIndexMatch) return false;
            const result = generateIndexMatch(documentPosition);
            if (!result) return false;
            return result;
        }, [
            documentPosition,
            generateIndexMatch
        ]);
        const applyDraftModeCallback = (0, $5uXOq.useCallback)((options)=>{
            if (!documentPosition || !isAnnotationAllowed) {
                if (createAnalyticsEvent) createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CREATE_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    attributes: {
                        inlineNodeNames: inlineNodeTypes
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }).fire((0, $dWAZk.FabricChannel).editor);
                return false;
            }
            setDraftDocumentPosition(documentPosition);
            applyAnnotationDraftAt(documentPosition);
            if (createAnalyticsEvent) {
                const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
                createAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).OPENED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        overlap: uniqueAnnotationsInRange.length,
                        inlineNodeNames: inlineNodeTypes
                    }
                }).fire((0, $dWAZk.FabricChannel).editor);
            }
            window.requestAnimationFrame(()=>{
                if (options.keepNativeSelection) (0, (0, parcelRequire("fVTp8")).updateWindowSelectionAroundDraft)(documentPosition);
                else {
                    const sel = window.getSelection();
                    if (sel) sel.removeAllRanges();
                }
            });
            const positionToAnnotate = draftDocumentPosition || documentPosition;
            if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
            const annotation = {
                annotationId: options.annotationId,
                annotationType: (0, (0, parcelRequire("88i6h")).AnnotationTypes).INLINE_COMMENT
            };
            return applyAnnotation(positionToAnnotate, annotation);
        }, [
            documentPosition,
            isAnnotationAllowed,
            applyAnnotationDraftAt,
            createAnalyticsEvent,
            applyAnnotation,
            draftDocumentPosition,
            actions,
            range,
            inlineNodeTypes
        ]);
        const removeDraftModeCallback = (0, $5uXOq.useCallback)(()=>{
            clearAnnotationDraft();
            setDraftDocumentPosition(null);
            const sel = window.getSelection();
            if (sel) sel.removeAllRanges();
        }, [
            clearAnnotationDraft
        ]);
        const onCloseCallback = (0, $5uXOq.useCallback)(()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CLOSED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $dWAZk.FabricChannel).editor);
            removeDraftModeCallback();
            onCloseProps();
        }, [
            onCloseProps,
            removeDraftModeCallback,
            createAnalyticsEvent,
            inlineNodeTypes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            range: range,
            draftRange: draftRange,
            wrapperDOM: wrapperDOM.current,
            isAnnotationAllowed: isAnnotationAllowed,
            onClose: onCloseCallback,
            onCreate: onCreateCallback,
            getAnnotationIndexMatch: createIndexCallback,
            applyDraftMode: applyDraftModeCallback,
            removeDraftMode: removeDraftModeCallback,
            inlineNodeTypes: inlineNodeTypes
        });
    });
});
parcelRegister("joddd", function(module, exports) {
    $parcel$export(module.exports, "useLoadAnnotations", ()=>$9aa08f3110a2b008$export$39f7c1a861a0d41c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dEtqo;
    var $iYAgE;
    var $fCNtA;
    const $9aa08f3110a2b008$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
        const actions = (0, $5uXOq.useContext)((0, (0, parcelRequire("fCNtA")).RendererContext));
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        (0, $5uXOq.useEffect)(()=>{
            if (!providers) return;
            const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
            const annotations = actions.getAnnotationMarks();
            if (!annotations.length) {
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: 0
                });
                return;
            }
            const ids = annotations.map((mark)=>mark.attrs.id);
            const cb = (data)=>{
                if (!updateSubscriberInlineComment) return;
                const payload = data.reduce((acc, value)=>({
                        ...acc,
                        [value.id]: value
                    }), {});
                updateSubscriberInlineComment.emit((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
                onLoadComplete && onLoadComplete({
                    numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
                });
            };
            inlineCommentGetState(ids, isNestedRender).then(cb);
        }, [
            actions,
            providers,
            adfDocument,
            isNestedRender,
            onLoadComplete
        ]);
    };
});
parcelRegister("4dDLS", function(module, exports) {
    $parcel$export(module.exports, "TextWithAnnotationDraft", ()=>$3c5c154ced085d7f$export$69a4e0ac39aaf9b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dLpur;
    var $iYAgE;
    var $i9Z2i;
    var $b60W1;
    var $fVTp8;
    var $5Lu5s;
    var $h5tvG;
    var $3VpWO;
    const $3c5c154ced085d7f$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().common, (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().focus);
    const $3c5c154ced085d7f$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("mark", {
            "data-renderer-mark": true,
            ...(0, (0, parcelRequire("fVTp8")).dataAttributes)(draftPosition),
            css: $3c5c154ced085d7f$var$markStyles
        }, children);
    };
    const $3c5c154ced085d7f$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).START) return 0;
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).END) return fragmentCount - 1;
        if (annotationPosition === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
        return -1;
    };
    const $3c5c154ced085d7f$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
        const annotateIndex = $3c5c154ced085d7f$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
        return texts.map((value, index)=>{
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(value, textHighlighter);
            if (annotateIndex === index) return (0, (0, parcelRequire("f8Sb3")).jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
                key: index,
                draftPosition: draftPosition
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        });
    };
    const $3c5c154ced085d7f$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
        const textPosition = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                start: startPos,
                end: endPos
            }), [
            endPos,
            startPos
        ]);
        const nextDraftPosition = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("iYAgE")).AnnotationsDraftContext));
        const shouldApplyAnnotationAt = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (!nextDraftPosition) return false;
            return (0, (0, parcelRequire("b60W1")).calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
        }, [
            nextDraftPosition,
            textPosition
        ]);
        const textString = (0, (0, parcelRequire("i9Z2i")).findTextString)(children);
        if (!textString) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children);
        if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        if (shouldApplyAnnotationAt === (0, (0, parcelRequire("dLpur")).InsertDraftPosition).AROUND_TEXT) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)($3c5c154ced085d7f$export$8062d68eccdfa39c, {
                key: 0,
                draftPosition: nextDraftPosition
            }, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const offsets = (0, (0, parcelRequire("i9Z2i")).calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
        const texts = (0, (0, parcelRequire("i9Z2i")).splitText)(textString, offsets);
        if (!texts) {
            const segments = (0, (0, parcelRequire("h5tvG")).segmentText)(textString, textHighlighter);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("3VpWO")).renderTextSegments)(segments, textHighlighter, marks || [], startPos));
        }
        const components = $3c5c154ced085d7f$export$b756d37afc321d72({
            texts: texts,
            shouldApplyAnnotationAt: shouldApplyAnnotationAt,
            draftPosition: nextDraftPosition,
            textHighlighter: textHighlighter,
            marks: marks
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, components);
    };
});
parcelRegister("dLpur", function(module, exports) {
    $parcel$export(module.exports, "InsertDraftPosition", ()=>$0808a380eaa6574c$export$c1bd4813440b4505);
    var $0808a380eaa6574c$export$c1bd4813440b4505;
    (function(InsertDraftPosition) {
        InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
        InsertDraftPosition["START"] = "START";
        InsertDraftPosition["END"] = "END";
        InsertDraftPosition["INSIDE"] = "INSIDE";
    })($0808a380eaa6574c$export$c1bd4813440b4505 || ($0808a380eaa6574c$export$c1bd4813440b4505 = {}));
});
parcelRegister("i9Z2i", function(module, exports) {
    $parcel$export(module.exports, "findTextString", ()=>$b2e5f988c70f5313$export$a9795c84b22a1f06);
    $parcel$export(module.exports, "splitText", ()=>$b2e5f988c70f5313$export$2878cc467c8be8fe);
    $parcel$export(module.exports, "calcTextSplitOffset", ()=>$b2e5f988c70f5313$export$1059bfc467f4f55d);
    var $5uXOq = parcelRequire("5uXOq");
    const $b2e5f988c70f5313$export$a9795c84b22a1f06 = (reactNode)=>{
        let result = null;
        const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(reactNode);
        for (const childNode of children){
            if (result) break;
            else if (typeof childNode === 'string') result = childNode;
            else if ($b2e5f988c70f5313$var$isReactElement(childNode) && childNode.props.children) result = $b2e5f988c70f5313$export$a9795c84b22a1f06(childNode.props.children);
        }
        return result;
    };
    function $b2e5f988c70f5313$var$isReactElement(child) {
        return !!child.type;
    }
    const $b2e5f988c70f5313$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
        if (endOffset > text.length || endOffset - startOffset <= 0) return null;
        return [
            text.slice(0, startOffset),
            text.slice(startOffset, endOffset),
            text.slice(endOffset)
        ].filter(Boolean);
    };
    const $b2e5f988c70f5313$export$1059bfc467f4f55d = (position, textPosition, text)=>{
        const { start: start, end: end } = textPosition;
        const startOffset = Math.max(position.from - start, 0);
        const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
        return {
            startOffset: startOffset,
            endOffset: endOffset
        };
    };
});
parcelRegister("b60W1", function(module, exports) {
    $parcel$export(module.exports, "calcInsertDraftPositionOnText", ()=>$cc6d6765c9b34830$export$b1baddbd5f289877);
    var $dLpur;
    const $cc6d6765c9b34830$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
        const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
        if (isRangePositionAroundText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).AROUND_TEXT;
        const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
        if (isRangePositionInsideText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).INSIDE;
        const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
        if (isRangePositionStartingAtText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).END;
        const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
        if (isRangePositionEndingAtText) return (0, (0, parcelRequire("dLpur")).InsertDraftPosition).START;
        return false;
    };
});
parcelRegister("5Lu5s", function(module, exports) {
    $parcel$export(module.exports, "AnnotationSharedClassNames", ()=>$973d0f0bfe5e36b9$export$b0aeb22a160e5b4c);
    $parcel$export(module.exports, "BlockAnnotationSharedClassNames", ()=>$973d0f0bfe5e36b9$export$ac15f3ad21fefeac);
    $parcel$export(module.exports, "AnnotationSharedCSSByState", ()=>$973d0f0bfe5e36b9$export$261ebe180da42726);
    $parcel$export(module.exports, "annotationSharedStyles", ()=>$973d0f0bfe5e36b9$export$5f72fe1d39f8129b);
    var $f8Sb3;
    var $VSDnB;
    function $973d0f0bfe5e36b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $973d0f0bfe5e36b9$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
    const $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c = {
        focus: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-focus`,
        blur: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-blur`,
        draft: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-draft`,
        hover: `${$973d0f0bfe5e36b9$export$6d0ce11e3a04da25}-hover`
    };
    const $973d0f0bfe5e36b9$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
    const $973d0f0bfe5e36b9$export$ac15f3ad21fefeac = {
        focus: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-focus`,
        blur: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-blur`,
        draft: `${$973d0f0bfe5e36b9$export$3600479d19dfa7a9}-draft`
    };
    var $973d0f0bfe5e36b9$var$_ref = {
        name: "j33ko3",
        styles: "background:var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
    };
    var $973d0f0bfe5e36b9$var$_ref2 = {
        name: "kh65d",
        styles: "background:var(--ds-background-accent-yellow-subtlest, #FFF7D6);border-bottom-color:var(--ds-border-accent-yellow, #B38600)"
    };
    var $973d0f0bfe5e36b9$var$_ref3 = {
        name: "buc4yh",
        styles: "background:var(--ds-background-accent-yellow-subtlest-pressed, #F5CD47);border-bottom-color:var(--ds-border-accent-yellow, #B38600);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"
    };
    const $973d0f0bfe5e36b9$export$261ebe180da42726 = ()=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return {
            common: {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                '&:has(.card), &:has([data-inline-card])': (0, (0, parcelRequire("VSDnB")).fg)('annotations_align_editor_and_renderer_styles') ? {
                    padding: '5px 0 3px 0'
                } : {
                    paddingTop: '4px',
                    border: 'none',
                    boxShadow: `0 2px 0 0 ${"var(--ds-border-accent-yellow, #B38600)"}`
                },
                '&:has(.date-lozenger-container)': {
                    paddingTop: '2px'
                }
            },
            focus: $973d0f0bfe5e36b9$var$_ref3,
            blur: $973d0f0bfe5e36b9$var$_ref2,
            hover: $973d0f0bfe5e36b9$var$_ref
        };
        else return {
            focus: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                cursor: 'pointer'
            }),
            blur: (0, (0, parcelRequire("f8Sb3")).css)({
                background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
                borderBottom: `2px solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
                cursor: 'pointer'
            })
        };
    };
    const $973d0f0bfe5e36b9$export$5f72fe1d39f8129b = ()=>(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, ",.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.hover, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().common, ";", $973d0f0bfe5e36b9$export$261ebe180da42726().hover, ";}}") : (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.focus, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.draft, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().focus, ";cursor:initial;}.", $973d0f0bfe5e36b9$export$b0aeb22a160e5b4c.blur, "{", $973d0f0bfe5e36b9$export$261ebe180da42726().blur, ";}}");
});
parcelRegister("h5tvG", function(module, exports) {
    $parcel$export(module.exports, "segmentText", ()=>$63dc04a72edc8a4d$export$93301b6f1ff0b0c3);
    function $63dc04a72edc8a4d$export$93301b6f1ff0b0c3(text, highlighter) {
        if (!highlighter || !text) return [
            {
                type: 'plain',
                text: text ?? ''
            }
        ];
        const segments = [];
        let pos = 0;
        try {
            const markTextSegmentMatches = text.matchAll(highlighter.pattern);
            for (const markTextMatch of markTextSegmentMatches){
                if (markTextMatch.index !== 0) segments.push({
                    type: 'plain',
                    text: text.substring(pos, markTextMatch.index)
                });
                segments.push({
                    type: 'match',
                    text: markTextMatch[0],
                    groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
                });
                pos = markTextMatch.index + markTextMatch[0].length;
            }
            if (pos < text.length) segments.push({
                type: 'plain',
                text: text.substring(pos)
            });
            return segments;
        } catch (_e) {}
        return [
            {
                type: 'plain',
                text: text
            }
        ];
    }
});
parcelRegister("3VpWO", function(module, exports) {
    $parcel$export(module.exports, "renderTextSegments", ()=>$eefbbe172cfc7a10$export$8a20fd0614851c5f);
    var $5uXOq = parcelRequire("5uXOq");
    function $eefbbe172cfc7a10$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
        const Component = textHighlighter?.component;
        const marks = new Set(marksList.map((m)=>m.type.name));
        function renderSegment(segment, idx = 0) {
            if (segment.type === 'plain' || !Component) return segment.text;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-highlighted": true,
                "data-vc": "highlighted-text"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                match: segment.text,
                groups: segment.groups,
                marks: marks,
                key: `${segment.text}_${startPos}_${idx}`,
                startPos: startPos + idx
            }, segment.text));
        }
        if (segments.length === 1) return renderSegment(segments[0]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: `text-wrapper_${startPos}`
        }, segments.map(renderSegment));
    }
});
parcelRegister("5uoEK", function(module, exports) {
    $parcel$export(module.exports, "MarkElement", ()=>$97291021c9f24158$export$f3069f755c1eba0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $8u8ms;
    var $1oOiu;
    var $6Oe8V;
    var $3N1TD;
    var $iYAgE;
    var $dEtqo;
    const $97291021c9f24158$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
        const updateSubscriber = (0, (0, parcelRequire("3N1TD")).useInlineCommentSubscriberContext)();
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext));
        const { hasFocus: hasFocus, isHovered: isHovered } = (0, (0, parcelRequire("1oOiu")).useHasFocusEvent)({
            id: id,
            updateSubscriber: updateSubscriber
        });
        const dataAttributesMemorized = (0, $5uXOq.useMemo)(()=>dataAttributes, [
            dataAttributes
        ]);
        const onClick = (0, $5uXOq.useCallback)((props)=>{
            if (!updateSubscriber) return;
            if (useBlockLevel) return;
            const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
            updateSubscriber.emit((0, (0, parcelRequire("dEtqo")).AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: annotationIds,
                eventTarget: eventTarget
            });
        }, [
            updateSubscriber,
            useBlockLevel
        ]);
        const activeParentIds = (0, (0, parcelRequire("6Oe8V")).useInlineCommentsFilter)({
            annotationIds: annotationParentIds,
            filter: {
                state: (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8u8ms")).MarkComponent), {
            id: id,
            dataAttributes: dataAttributesMemorized,
            annotationParentIds: activeParentIds,
            onClick: onClick,
            hasFocus: hasFocus,
            isHovered: isHovered,
            state: states[id],
            useBlockLevel: useBlockLevel
        }, children);
    };
});
parcelRegister("8u8ms", function(module, exports) {
    $parcel$export(module.exports, "MarkComponent", ()=>$c95b45af50ffb058$export$4f5a51511304fdd0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5IPCv;
    var $5Lu5s;
    var $88i6h;
    var $VSDnB;
    var $koVbs;
    var $1Bd5P;
    const $c95b45af50ffb058$var$markStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE, "']{", (0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().common : '', " ", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().focus, ";}&[data-is-hovered='true']:not([data-has-focus='true']),&:hover:not(:focus){", (0, (0, parcelRequire("5Lu5s")).AnnotationSharedCSSByState)().hover, ";}}");
    const $c95b45af50ffb058$var$isMobile = ()=>{
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    const $c95b45af50ffb058$var$accessibilityStyles = (startMarker, endMarker)=>(0, (0, parcelRequire("f8Sb3")).css)({
            '&::before, &::after': {
                clipPath: 'inset(100%)',
                clip: 'rect(1px, 1px, 1px, 1px)',
                height: '1px',
                overflow: 'hidden',
                position: 'absolute',
                whiteSpace: 'nowrap',
                width: '1px'
            },
            '&::before': {
                content: `' [${startMarker}] '`
            },
            '&::after': {
                content: `' [${endMarker}] '`
            }
        });
    const $c95b45af50ffb058$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
        const isInlineCommentsKbAccessible = (0, (0, parcelRequire("5IPCv")).default).checkGate('inline_comments_keyboard_accessible_renderer');
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const annotationIds = (0, $5uXOq.useMemo)(()=>[
                ...new Set([
                    ...annotationParentIds,
                    id
                ])
            ], [
            id,
            annotationParentIds
        ]);
        const onMarkClick = (0, $5uXOq.useCallback)((event)=>{
            if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
            if (event.defaultPrevented || state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE) return;
            if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) {
                if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                    if (event.target.closest('[data-mention-id]')) ;
                    else {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }
            } else event.preventDefault();
            onClick({
                eventTarget: event.target,
                annotationIds: annotationIds
            });
        }, [
            annotationIds,
            onClick,
            state
        ]);
        const onMarkEnter = (evt)=>{
            const focusedElementTag = document.activeElement?.tagName;
            if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
        };
        const overriddenData = !state ? dataAttributes : {
            ...dataAttributes,
            'data-mark-annotation-state': state,
            'data-has-focus': hasFocus,
            'data-is-hovered': isHovered
        };
        const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $c95b45af50ffb058$var$isMobile() ? {} : {
            role: 'button',
            tabIndex: 0,
            onKeyDown: onMarkEnter,
            'aria-expanded': hasFocus
        } : {};
        const accessibility = state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).ACTIVE ? {
            'aria-disabled': true
        } : {
            'aria-details': annotationIds.join(', '),
            ...desktopAccessibilityAttributes
        };
        const getAccessibilityStyles = ()=>{
            if ($c95b45af50ffb058$var$isMobile()) return {};
            if (isInlineCommentsKbAccessible && state !== (0, (0, parcelRequire("88i6h")).AnnotationMarkStates).RESOLVED) {
                const startMarker = intl.formatMessage((0, (0, parcelRequire("1Bd5P")).inlineCommentMessages).contentRendererInlineCommentMarkerStart);
                const endMarker = intl.formatMessage((0, (0, parcelRequire("1Bd5P")).inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
                return $c95b45af50ffb058$var$accessibilityStyles(startMarker, endMarker);
            } else return {};
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)(useBlockLevel ? 'div' : 'mark', {
            id: id,
            [(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
            ...accessibility,
            ...overriddenData,
            ...!useBlockLevel && {
                css: [
                    $c95b45af50ffb058$var$markStyles,
                    getAccessibilityStyles()
                ]
            }
        }, children);
    };
});
parcelRegister("1Bd5P", function(module, exports) {
    $parcel$export(module.exports, "headingAnchorLinkMessages", ()=>$bb2bb569629ca076$export$74bada844422036d);
    $parcel$export(module.exports, "tableCellMessages", ()=>$bb2bb569629ca076$export$c79ebc36348824d1);
    $parcel$export(module.exports, "inlineCommentMessages", ()=>$bb2bb569629ca076$export$9f52c375a6ef34fc);
    var $7VHMR;
    const $bb2bb569629ca076$export$74bada844422036d = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copyHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copyAnchorLink',
            defaultMessage: 'Copy link to heading',
            description: 'Copy heading link to clipboard'
        },
        copiedHeadingLinkToClipboard: {
            id: 'fabric.editor.headingLink.copied',
            defaultMessage: 'Copied!',
            description: 'Copied heading link to clipboard'
        },
        failedToCopyHeadingLink: {
            id: 'fabric.editor.headingLink.failedToCopy',
            defaultMessage: 'Copy failed',
            description: 'failed to copy heading link to clipboard'
        },
        copyAriaLabel: {
            id: 'fabric.editor.headingLink.copyAriaLabel',
            defaultMessage: 'Copy',
            description: 'copy aria label for link icon'
        }
    });
    const $bb2bb569629ca076$export$c79ebc36348824d1 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneSortingLabel: {
            id: 'fabric.editor.headingLink.noneSortingLabel',
            defaultMessage: 'none',
            description: 'this table column is not sorted'
        },
        ascSortingLabel: {
            id: 'fabric.editor.headingLink.ascSortingLabel',
            defaultMessage: 'ascending',
            description: 'this table column is sorted in ascending order'
        },
        descSortingLabel: {
            id: 'fabric.editor.headingLink.descSortingLabel',
            defaultMessage: 'descending',
            description: 'this table column is sorted in descending order'
        }
    });
    const $bb2bb569629ca076$export$9f52c375a6ef34fc = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        contentRendererInlineCommentMarkerStart: {
            id: 'fabric.editor.inlineComment.marker.start',
            defaultMessage: 'inline comment start',
            description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
        },
        contentRendererInlineCommentMarkerEnd: {
            id: 'fabric.editor.inlineComment.marker.end',
            defaultMessage: 'inline comment end',
            description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
        }
    });
});
parcelRegister("6Oe8V", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentsFilter", ()=>$588f60613625d184$export$8e7d47f9e38ad4f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    const $588f60613625d184$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
        const states = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).InlineCommentsStateContext));
        return (0, $5uXOq.useMemo)(()=>{
            return annotationIds.reduce((acc, id)=>{
                if (states && states[id] === stateFilter) return [
                    ...acc,
                    id
                ];
                return acc;
            }, []);
        }, [
            annotationIds,
            states,
            stateFilter
        ]);
    };
});
parcelRegister("3N1TD", function(module, exports) {
    $parcel$export(module.exports, "useInlineCommentSubscriberContext", ()=>$861d152b5ce122b2$export$b46737175cffd396);
    var $5uXOq = parcelRequire("5uXOq");
    var $iYAgE;
    const $861d152b5ce122b2$export$b46737175cffd396 = ()=>{
        const providers = (0, $5uXOq.useContext)((0, (0, parcelRequire("iYAgE")).ProvidersContext));
        if (!providers) return null;
        const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
        return updateSubscriber || null;
    };
});
parcelRegister("bQeYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5dc6f3b113435da$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Zwf;
    var $fAZXL;
    var $edXiX;
    var $4ceoy;
    var $l8Gxi;
    var $eOOFp;
    const $c5dc6f3b113435da$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
        const actions = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return {
                changeActive (index) {
                    return updateActiveChild(index);
                },
                addChild () {
                    return false;
                },
                getChildrenCount () {
                    return children ? children?.length : 0;
                },
                removeChild (index) {
                    return false;
                },
                updateParameters (parameters) {
                    return false;
                },
                getChildren () {
                    return [];
                }
            };
        }, [
            updateActiveChild,
            children
        ]);
        return actions;
    };
    const $c5dc6f3b113435da$var$navigationCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
    const $c5dc6f3b113435da$var$MultiBodiedExtension = (props)=>{
        const { children: children, layout: layout = 'default', path: path = [] } = props;
        const [activeChildIndex, setActiveChildIndex] = (0, $5uXOq.useState)(0);
        const removeOverflow = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
        const overflowContainerClass = !removeOverflow ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
        const updateActiveChild = (0, ($parcel$interopDefault($5uXOq))).useCallback((index)=>{
            if (typeof index !== 'number') {
                setActiveChildIndex(0);
                return false;
            }
            setActiveChildIndex(index);
            return true;
        }, [
            setActiveChildIndex
        ]);
        const actions = $c5dc6f3b113435da$var$useMultiBodiedExtensionActions({
            updateActiveChild: updateActiveChild,
            children: children
        });
        const containerCssExtended = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, (0, parcelRequire("edXiX")).sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
        const isTopLevel = path.length < 1;
        const centerAlignClass = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
        function renderMbeContent(width) {
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
                style: {
                    width: isTopLevel ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, width) : '100%'
                },
                "data-layout": layout
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
                className: "multiBodiedExtension-navigation",
                css: $c5dc6f3b113435da$var$navigationCssExtended,
                "data-testid": "multiBodiedExtension-navigation"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fAZXL")).default), {
                ...props,
                actions: actions,
                type: "multiBodiedExtension"
            }, ({ result: result })=>{
                try {
                    if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, (0, parcelRequire("i8Zwf")).renderExtension)(result, layout, {
                        isTopLevel: path.length < 1
                    });
                } catch (e) {}
                return (0, (0, parcelRequire("i8Zwf")).renderExtension)(children, layout, {
                    isTopLevel: path.length < 1
                });
            })), (0, (0, parcelRequire("f8Sb3")).jsx)("article", {
                "data-testid": "multiBodiedExtension--frames",
                className: `multiBodiedExtension--frames`
            }, children));
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("section", {
            className: "multiBodiedExtension--container",
            css: containerCssExtended,
            "data-testid": "multiBodiedExtension--container",
            "data-active-child-index": activeChildIndex,
            "data-layout": layout
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
    };
    var $c5dc6f3b113435da$export$2e2bcd8739ae039 = $c5dc6f3b113435da$var$MultiBodiedExtension;
});
parcelRegister("edXiX", function(module, exports) {
    $parcel$export(module.exports, "removeMarginsAndBorder", ()=>$a5dc814f02ba73ab$export$8df0393dc2d5d656);
    $parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", ()=>$a5dc814f02ba73ab$export$9c7196ca47f67390);
    var $f8Sb3;
    function $a5dc814f02ba73ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a5dc814f02ba73ab$var$mbeExtensionContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        background: 'transparent !important',
        'padding:': {
            left: `${"var(--ds-space-100, 8px)"} !important`,
            right: `${"var(--ds-space-100, 8px)"} !important`
        },
        paddingBottom: "var(--ds-space-100, 8px)",
        '&.remove-padding': {
            paddingBottom: 0
        },
        position: 'relative',
        verticalAlign: 'middle',
        cursor: 'pointer',
        '.multiBodiedExtension-handler-result': {
            marginLeft: "var(--ds-space-100, 8px)"
        },
        ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
            display: 'none',
            background: "var(--ds-surface, white)"
        },
        '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
            "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
                marginTop: 0
            }
        }
    });
    const $a5dc814f02ba73ab$var$mbeNavigation = {
        name: "2ubief",
        styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
    };
    const $a5dc814f02ba73ab$var$extensionFrameContent = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} !important`,
        display: 'block',
        minHeight: '100px',
        background: "var(--ds-surface, white)",
        borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
        borderBottomRightRadius: "var(--ds-border-radius, 3px)",
        marginLeft: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)",
        cursor: 'initial',
        '.pm-table-with-controls': {
            marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
            paddingRight: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.bodiedExtensionView-content-wrap': {
            marginTop: `${"var(--ds-space-150, 12px)"} !important`
        },
        '.extensionView-content-wrap': {
            marginTop: `${"var(--ds-space-100, 8px)"} !important`
        }
    });
    const $a5dc814f02ba73ab$export$8df0393dc2d5d656 = {
        name: "c620zi",
        styles: "margin-left:0;margin-right:0;border:none"
    };
    const $a5dc814f02ba73ab$export$9c7196ca47f67390 = {
        mbeExtensionContainer: $a5dc814f02ba73ab$var$mbeExtensionContainer,
        mbeNavigation: $a5dc814f02ba73ab$var$mbeNavigation,
        extensionFrameContent: $a5dc814f02ba73ab$var$extensionFrameContent
    };
});
parcelRegister("cOnYv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$adf8f8318644b4cb$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $adf8f8318644b4cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $adf8f8318644b4cb$var$containerCSS = {
        name: "ecvjkq",
        styles: "min-height:100px"
    };
    const $adf8f8318644b4cb$var$ExtensionFrame = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $adf8f8318644b4cb$var$containerCSS,
            "data-extension-frame": "true",
            style: {
                flexBasis: `100%`
            }
        }, props.children);
    };
    var $adf8f8318644b4cb$export$2e2bcd8739ae039 = $adf8f8318644b4cb$var$ExtensionFrame;
});
parcelRegister("cWRvh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b4346c39a86c4f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kjhhp;
    var $503mU;
    function $4b4346c39a86c4f3$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ul", {
            className: (0, (0, parcelRequire("kjhhp")).bulletListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("503mU")).getListIndentLevel)(props.path) : 1
        }, props.children);
    }
});
parcelRegister("503mU", function(module, exports) {
    $parcel$export(module.exports, "getListIndentLevel", ()=>$95f5719763d590de$export$75aa84e85754623e);
    function $95f5719763d590de$export$75aa84e85754623e(path) {
        let count = 1;
        path.forEach((node)=>{
            if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
        });
        return count;
    }
});
parcelRegister("5KNWO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e507ebac88967e63$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "DocWithSelectAllTrap", ()=>$e507ebac88967e63$export$41121a410ca2f650);
    var $5uXOq = parcelRequire("5uXOq");
    var $l8Gxi;
    var $bGnBY;
    function $e507ebac88967e63$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
    function $e507ebac88967e63$export$41121a410ca2f650(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: (0, (0, parcelRequire("bGnBY")).useSelectAllTrap)(),
            className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT
        }, props.children);
    }
});
parcelRegister("bGnBY", function(module, exports) {
    $parcel$export(module.exports, "useSelectAllTrap", ()=>$08249876083d1eac$export$98871b245ee25215);
    var $gkwXh;
    var $5uXOq = parcelRequire("5uXOq");
    var $TM1uy;
    var $lb6Ua;
    var $VSDnB;
    const $08249876083d1eac$export$98871b245ee25215 = ()=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("TM1uy")).default));
        const ref = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const clicked = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const caught = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
        const onKeyDown = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            const el = ref.current;
            if (!el) return;
            const modKey = mac ? e.metaKey : e.ctrlKey;
            if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
            const elementSelection = (0, (0, parcelRequire("lb6Ua")).ElementSelection).fromWindow();
            const isInput = (0, (0, parcelRequire("VSDnB")).fg)('platform-datasources-enable-two-way-sync') ? e.target?.matches?.('input') : false;
            if (elementSelection.eq(caught.current) || isInput) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECT_ALL_ESCAPED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER
                });
                return;
            }
            if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
                fireAnalyticsEvent({
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECT_ALL_CAUGHT,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER
                });
                e.preventDefault();
                caught.current = elementSelection.select(el);
            }
        }, [
            mac,
            ref,
            fireAnalyticsEvent,
            clicked,
            caught
        ]);
        const onClick = (0, ($parcel$interopDefault($5uXOq))).useCallback((e)=>{
            clicked.current = ref.current?.contains(e.target) ?? false;
        }, [
            ref,
            clicked
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            window.addEventListener('keydown', onKeyDown);
            window.addEventListener('click', onClick);
            return ()=>{
                window.removeEventListener('keydown', onKeyDown);
                window.removeEventListener('click', onClick);
            };
        }, [
            onKeyDown,
            onClick
        ]);
        return ref;
    };
});
parcelRegister("TM1uy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64e1e4f8cfab5159$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $64e1e4f8cfab5159$var$AnalyticsContext = (0, ($parcel$interopDefault($5uXOq))).createContext({
        fireAnalyticsEvent: (_event)=>null
    });
    var $64e1e4f8cfab5159$export$2e2bcd8739ae039 = $64e1e4f8cfab5159$var$AnalyticsContext;
});
parcelRegister("lb6Ua", function(module, exports) {
    $parcel$export(module.exports, "ElementSelection", ()=>$854590065f4073c9$export$6e6724d89f27411);
    class $854590065f4073c9$export$6e6724d89f27411 {
        constructor(selection){
            this.type = selection ? selection.type : 'None';
            if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
        }
        eq(selection) {
            if (!selection) return false;
            if (this.range && selection.range) {
                const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
                const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
                return startMatches && endMatches;
            }
            return this.type === 'None' && selection.type === 'None';
        }
        inside(el) {
            return el.contains(this.range?.commonAncestorContainer ?? null);
        }
        select(el) {
            const range = document.createRange();
            range.selectNodeContents(el);
            const selection = window.getSelection();
            if (selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
            return $854590065f4073c9$export$6e6724d89f27411.fromWindow();
        }
        static fromWindow(win = window) {
            return new $854590065f4073c9$export$6e6724d89f27411(win.getSelection());
        }
    }
});
parcelRegister("lKIDi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98a311e98fd838fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $98a311e98fd838fb$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
        if (forceNewLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("br", null);
    };
    var $98a311e98fd838fb$export$2e2bcd8739ae039 = $98a311e98fd838fb$var$HardBreak;
});
parcelRegister("7AttJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e20de8dc9c3ed0b1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rouw;
    var $gkwXh;
    var $TM1uy;
    var $jSk6P;
    const $e20de8dc9c3ed0b1$var$getCurrentUrlWithHash = (hash = '')=>{
        const url = new URL(window.location.href);
        url.search = '';
        url.hash = encodeURIComponent(hash);
        return url.href;
    };
    function $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks) {
        if (!marks || !marks.length) return false;
        return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
    }
    function $e20de8dc9c3ed0b1$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TM1uy")).default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rouw")).default), {
                enableNestedHeaderLinks: enableNestedHeaderLinks,
                level: level,
                onCopyText: ()=>{
                    fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                    return (0, (0, parcelRequire("jSk6P")).copyTextToClipboard)($e20de8dc9c3ed0b1$var$getCurrentUrlWithHash(headingId));
                }
            }));
    }
    function $e20de8dc9c3ed0b1$var$Heading(props) {
        const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
        const HX = `h${props.level}`;
        const showAnchorLink = !!props.showAnchorLink;
        const isRightAligned = $e20de8dc9c3ed0b1$var$hasRightAlignmentMark(marks);
        const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
        const headingIdToUse = invisible ? undefined : headingId;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(HX, {
            id: headingIdToUse,
            ...dataAttributes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, showAnchorLink && headingId && isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        }), props.children, showAnchorLink && headingId && !isRightAligned && (0, ($parcel$interopDefault($5uXOq))).createElement($e20de8dc9c3ed0b1$var$WrappedHeadingAnchor, {
            level: props.level,
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            headingId: headingId
        })));
    }
    var $e20de8dc9c3ed0b1$export$2e2bcd8739ae039 = $e20de8dc9c3ed0b1$var$Heading;
});
parcelRegister("3rouw", function(module, exports) {
    $parcel$export(module.exports, "HeadingAnchorWrapperClassName", ()=>$b36f5408031b5508$export$3c9cedc52604835d);
    $parcel$export(module.exports, "default", ()=>$b36f5408031b5508$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $458iJ;
    var $3bDjY;
    var $8RXs9;
    var $1Bd5P;
    const $b36f5408031b5508$export$3c9cedc52604835d = 'heading-anchor-wrapper';
    const $b36f5408031b5508$var$CopyAnchorWrapperWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...rest,
            className: $b36f5408031b5508$export$3c9cedc52604835d,
            ref: ref
        }, children));
    });
    const $b36f5408031b5508$var$copyAnchorButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        outline: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        cursor: 'pointer',
        right: 0
    });
    class $b36f5408031b5508$var$HeadingAnchor extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        componentDidMount() {
            this.resetMessage();
        }
        render() {
            const { tooltipMessage: tooltipMessage } = this.state;
            if (tooltipMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                tag: $b36f5408031b5508$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage
            }, this.renderAnchorButton());
            return this.renderAnchorButton();
        }
        constructor(...args){
            super(...args), this.state = {
                tooltipMessage: '',
                isClicked: false
            }, this.setTooltipState = (message, isClicked = false)=>{
                this.setState({
                    tooltipMessage: this.props.intl.formatMessage(message),
                    isClicked: isClicked
                });
            }, this.getCopyAriaLabel = ()=>{
                const { copyAriaLabel: copyAriaLabel } = (0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages);
                return this.props.intl.formatMessage(copyAriaLabel);
            }, this.copyToClipboard = async (event)=>{
                const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages);
                event.stopPropagation();
                try {
                    await this.props.onCopyText();
                    this.setTooltipState(copiedHeadingLinkToClipboard, true);
                } catch (e) {
                    this.setTooltipState(failedToCopyHeadingLink);
                }
            }, this.resetMessage = ()=>{
                this.setTooltipState((0, (0, parcelRequire("1Bd5P")).headingAnchorLinkMessages).copyHeadingLinkToClipboard);
            }, this.renderAnchorButton = ()=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                    css: $b36f5408031b5508$var$copyAnchorButtonStyles,
                    onMouseLeave: this.resetMessage,
                    onClick: this.copyToClipboard,
                    "aria-label": this.state.tooltipMessage,
                    type: "button"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("458iJ"))))), {
                    label: this.getCopyAriaLabel(),
                    size: this.props.level > 3 ? 'small' : 'medium',
                    primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
                }));
            };
        }
    }
    var $b36f5408031b5508$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($b36f5408031b5508$var$HeadingAnchor);
});
parcelRegister("458iJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2f8e117d74b4de46$var$LinkIcon = (props)=>$2f8e117d74b4de46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $2f8e117d74b4de46$var$_link.default
        }));
    $2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
    var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;
});
parcelRegister("1f9bV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0e7e525cdad15340$var$_UNSAFE_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $0e7e525cdad15340$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0e7e525cdad15340$var$LinkIcon = (props)=>$0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
    var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;
});
parcelRegister("jSk6P", function(module, exports) {
    $parcel$export(module.exports, "copyTextToClipboard", ()=>$2ff51d830678d63e$export$f980440e1ab4537d);
    const $2ff51d830678d63e$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
            const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
            if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
            else reject('Clipboard API is not supported');
        });
});
parcelRegister("112O7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4bc2ade6d275922$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fAZXL;
    const $a4bc2ade6d275922$var$InlineExtension = (props)=>{
        const { text: text } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fAZXL")).default), {
            ...props,
            type: "inlineExtension"
        }, ({ result: result })=>{
            try {
                if (result && (0, ($parcel$interopDefault($5uXOq))).isValidElement(result)) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, result);
            } catch (e) {}
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text || 'inlineExtension');
        });
    };
    var $a4bc2ade6d275922$export$2e2bcd8739ae039 = $a4bc2ade6d275922$var$InlineExtension;
});
parcelRegister("ieJGA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57fd1bc0570bfa35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    function $57fd1bc0570bfa35$export$2e2bcd8739ae039(props) {
        const isAdvancedLayoutsPreRelease2 = (0, $gmhCD.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_pre_release_2');
        return isAdvancedLayoutsPreRelease2 ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "layout-section-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true,
            "data-layout-columns": props?.content?.length
        }, props.children)) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-section": true
        }, props.children);
    }
});
parcelRegister("3RqVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93f45378df34617d$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $iEGtv;
    var $4ceoy;
    const $93f45378df34617d$var$layoutColumnClearMarginTopStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("iEGtv")).clearNextSiblingMarginTopStyle), (0, (0, parcelRequire("iEGtv")).clearNextSiblingBlockMarkMarginTopStyle));
    function $93f45378df34617d$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-layout-column": true,
            "data-column-width": props.width,
            style: {
                flexBasis: `${props.width}%`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $93f45378df34617d$var$layoutColumnClearMarginTopStyles
        }), props.children));
    }
});
parcelRegister("iEGtv", function(module, exports) {
    $parcel$export(module.exports, "clearNextSiblingMarginTopStyle", ()=>$1f25160b5efdbc99$export$b15ec88fc1f2e843);
    $parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", ()=>$1f25160b5efdbc99$export$eb3aaa9338936d44);
    var $f8Sb3;
    function $1f25160b5efdbc99$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1f25160b5efdbc99$export$b15ec88fc1f2e843 = {
        name: "1f3w791",
        styles: "& + *{margin-top:0 !important;}"
    };
    const $1f25160b5efdbc99$var$textElements = [
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ];
    const $1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors = $1f25160b5efdbc99$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
    const $1f25160b5efdbc99$export$eb3aaa9338936d44 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`${$1f25160b5efdbc99$var$nextSiblingBlockMarkContentSelectors}`]: {
            marginTop: '0 !important'
        }
    });
});
parcelRegister("qjsNK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccd334ef870d278c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $ccd334ef870d278c$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, props.children);
    }
});
parcelRegister("jHa9U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fce9f67e250185e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8hSwr;
    const $4fce9f67e250185e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8hSwr")).default), {
            hasContent: true,
            dataAttributes: dataAttributes
        }, children);
    };
    var $4fce9f67e250185e$export$2e2bcd8739ae039 = $4fce9f67e250185e$var$RenderCaption;
});
parcelRegister("8hSwr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bb2c70aa755b661$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $2AEnW;
    function $5bb2c70aa755b661$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5bb2c70aa755b661$var$captionWrapperStyle = {
        name: "1f0iwez",
        styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #44546F)"
    };
    const $5bb2c70aa755b661$var$placeholderStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        position: 'absolute',
        top: 'space.0',
        width: '100%'
    });
    class $5bb2c70aa755b661$export$f7feb87190a94c76 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
            const showPlaceholder = !selected && !hasContent;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-media-caption": true,
                "data-testid": "media-caption",
                ...dataAttributes,
                css: $5bb2c70aa755b661$var$captionWrapperStyle
            }, showPlaceholder ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $5bb2c70aa755b661$var$placeholderStyle
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), null, formatMessage((0, (0, parcelRequire("2AEnW")).messages).placeholder))) : null, children);
        }
    }
    var $5bb2c70aa755b661$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5bb2c70aa755b661$export$f7feb87190a94c76);
});
parcelRegister("2AEnW", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$aa314c48a072d691$export$defe85febe8b728c);
    var $7VHMR;
    const $aa314c48a072d691$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.editor.captionPlaceholder',
            defaultMessage: 'Add a caption',
            description: 'Placeholder description for an empty (new) caption in the editor'
        }
    });
});
parcelRegister("6svWT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6654d29b704d772$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dwptW;
    var $jlYLw;
    var $uTDrM;
    var $503mU;
    function $e6654d29b704d772$export$2e2bcd8739ae039(props) {
        let extraProps = {};
        const itemCounterDigitsSize = (0, (0, parcelRequire("uTDrM")).getItemCounterDigitsSize)({
            order: props.order,
            itemsCount: props?.content?.length
        });
        if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, (0, parcelRequire("jlYLw")).getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
        if (props.order !== undefined) extraProps.start = (0, (0, parcelRequire("uTDrM")).resolveOrder)(props.order);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("ol", {
            className: (0, (0, parcelRequire("dwptW")).orderedListSelector).substr(1),
            "data-indent-level": props.path ? (0, (0, parcelRequire("503mU")).getListIndentLevel)(props.path) : 1,
            start: props.start,
            ...extraProps
        }, props.children);
    }
});
parcelRegister("jlYLw", function(module, exports) {
    $parcel$export(module.exports, "listItemCounterPadding", ()=>$6a64108c33d9274c$export$bafd6beec0797f87);
    $parcel$export(module.exports, "getOrderedListInlineStyles", ()=>$6a64108c33d9274c$export$6d31fdb1d74cee3e);
    $parcel$export(module.exports, "listsSharedStyles", ()=>$6a64108c33d9274c$export$ea95db02cc29c78f);
    var $f8Sb3;
    var $kjhhp;
    var $dwptW;
    var $gE8f9;
    const $6a64108c33d9274c$export$bafd6beec0797f87 = 24;
    var $6a64108c33d9274c$var$CSS_VAR_NAMES;
    (function(CSS_VAR_NAMES) {
        CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    })($6a64108c33d9274c$var$CSS_VAR_NAMES || ($6a64108c33d9274c$var$CSS_VAR_NAMES = {}));
    const $6a64108c33d9274c$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
        let paddingLeft = `2.385ch`;
        if (itemCounterDigitsSize >= 3) {
            const fixedBasePx = 2;
            paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
        }
        return paddingLeft;
    };
    const $6a64108c33d9274c$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
    function $6a64108c33d9274c$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
        const style = {
            ["--ed--list--item-counter--padding"]: $6a64108c33d9274c$var$getItemCounterLeftPadding(itemCounterDigitsSize)
        };
        if (styleFormat === 'string') return $6a64108c33d9274c$var$stringifyStyle(style);
        return style;
    }
    const $6a64108c33d9274c$export$ea95db02cc29c78f = (0, (0, parcelRequire("f8Sb3")).css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $6a64108c33d9274c$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, (0, parcelRequire("gE8f9")).browser).gecko ? 'display: inline-block;' : '', ";}}", (0, (0, parcelRequire("dwptW")).orderedListSelector), ",", (0, (0, parcelRequire("kjhhp")).bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");
});
parcelRegister("uTDrM", function(module, exports) {
    $parcel$export(module.exports, "resolveOrder", ()=>$ebe278356715a8a4$export$d445360e2a3c026b);
    $parcel$export(module.exports, "getOrderFromOrderedListNode", ()=>$ebe278356715a8a4$export$cbefb5b89ef0719f);
    $parcel$export(module.exports, "getItemCounterDigitsSize", ()=>$ebe278356715a8a4$export$320582fc14ba1e0f);
    $parcel$export(module.exports, "isListNode", ()=>$ebe278356715a8a4$export$a7d7d2b9ba4d4dbb);
    $parcel$export(module.exports, "isParagraphNode", ()=>$ebe278356715a8a4$export$35f600abfe6f0127);
    $parcel$export(module.exports, "isListItemNode", ()=>$ebe278356715a8a4$export$2ddb0a75547407f6);
    $parcel$export(module.exports, "isBulletList", ()=>$ebe278356715a8a4$export$35b2f400604e700);
    const $ebe278356715a8a4$export$8ef94ae42a3729bd = 1;
    const $ebe278356715a8a4$export$d445360e2a3c026b = (order)=>{
        const num = Number(order);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $ebe278356715a8a4$export$cbefb5b89ef0719f = (orderedListNode)=>{
        const order = orderedListNode?.attrs?.order;
        return $ebe278356715a8a4$export$d445360e2a3c026b(order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
    };
    const $ebe278356715a8a4$export$320582fc14ba1e0f = (options)=>{
        const order = $ebe278356715a8a4$export$d445360e2a3c026b(options.order) ?? $ebe278356715a8a4$export$8ef94ae42a3729bd;
        const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
        const largestCounter = order + (itemsCount - 1);
        return String(largestCounter)?.split('.')?.[0]?.length;
    };
    function $ebe278356715a8a4$export$a7d7d2b9ba4d4dbb(node) {
        return Boolean(node && node.type && [
            'orderedList',
            'bulletList'
        ].includes(node.type.name));
    }
    function $ebe278356715a8a4$export$35f600abfe6f0127(node) {
        return Boolean(node && node.type && 'paragraph' === node.type.name);
    }
    function $ebe278356715a8a4$export$2ddb0a75547407f6(node) {
        return Boolean(node && node.type && 'listItem' === node.type.name);
    }
    function $ebe278356715a8a4$export$35b2f400604e700(node) {
        return Boolean(node && node.type && 'bulletList' === node.type.name);
    }
});
parcelRegister("9FXQX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$26d2961aa3d14cef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $EGPjg;
    function $26d2961aa3d14cef$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("p", dataAttributes, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("EGPjg")).default), null, children)));
    }
});
parcelRegister("EGPjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$372a7010ecff9ba7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $372a7010ecff9ba7$export$2e2bcd8739ae039(props) {
        const { children: children } = props;
        const childCount = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).length;
        if (!childCount) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, "\xa0");
        return children;
    }
});
parcelRegister("hqBb9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$add04eab04996fda$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $add04eab04996fda$export$2e2bcd8739ae039(props) {
        if (props.allowPlaceholderText) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-placeholder": `${props.text}`
        }, props.text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", null);
    }
});
parcelRegister("ixoQV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1bb5022786e53a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e1bb5022786e53a6$export$2e2bcd8739ae039() {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("hr", {
            role: "presentation"
        });
    }
});
parcelRegister("dkc63", function(module, exports) {
    $parcel$export(module.exports, "isTableResizingEnabled", ()=>$7478efdfea2a60bf$export$eec82c0a93aa66d9);
    $parcel$export(module.exports, "isStickyScrollbarEnabled", ()=>$7478efdfea2a60bf$export$bdb2dadcb04aad50);
    $parcel$export(module.exports, "default", ()=>$7478efdfea2a60bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6gEe5;
    var $ajc8Z;
    var $4ceoy;
    var $VSDnB;
    var $5vnE9;
    var $5or39;
    var $5J0oM;
    var $9BYlQ;
    var $iHYdz;
    var $fKLIs;
    var $gmhCD = parcelRequire("gmhCD");
    var $OxITw;
    var $cWojJ;
    var $4BsEy;
    var $2aXGN;
    var $a4mor;
    var $kjIja;
    var $eIscD;
    const $7478efdfea2a60bf$export$eec82c0a93aa66d9 = (appearance)=>(0, (0, parcelRequire("kjIja")).isFullWidthOrFullPageAppearance)(appearance) || (0, (0, parcelRequire("kjIja")).isCommentAppearance)(appearance) && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
            exposure: true
        });
    const $7478efdfea2a60bf$export$bdb2dadcb04aad50 = (appearance)=>(0, (0, parcelRequire("kjIja")).isFullWidthOrFullPageAppearance)(appearance) && (0, $gmhCD.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
            exposure: true
        });
    const $7478efdfea2a60bf$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
        if (!tableOrderStatus || tableOrderStatus.order === (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER) return children;
        const { order: order, columnIndex: columnIndex } = tableOrderStatus;
        const compareNodesInOrder = (0, (0, parcelRequire("5J0oM")).createCompareNodes)({
            getInlineCardTextFromStore (attrs) {
                const { url: url } = attrs;
                if (!url) return null;
                return smartCardStorage.get(url) || null;
            }
        }, order);
        const tableArray = (0, (0, parcelRequire("5or39")).convertProsemirrorTableNodeToArrayOfRows)(tableNode);
        const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
                rowNodes: rowNodes,
                rowReact: children[index]
            }));
        const headerRow = tableArrayWithChildren.shift();
        const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        return sortedTable.map((elem)=>elem.rowReact);
    };
    const $7478efdfea2a60bf$var$hasRowspan = (row)=>{
        let hasRowspan = false;
        row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
        return hasRowspan;
    };
    const $7478efdfea2a60bf$var$getRefTop = (refElement)=>{
        return Math.round(refElement.getBoundingClientRect().top);
    };
    const $7478efdfea2a60bf$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
    const $7478efdfea2a60bf$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
    const $7478efdfea2a60bf$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
        return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
            if (index === 0) return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                tableOrderStatus: tableOrderStatus,
                onSorting: onSorting
            });
            return row;
        });
    };
    const $7478efdfea2a60bf$var$isHeaderRowEnabled = (rows)=>{
        if (!rows.length) return false;
        const { children: children } = rows[0].props;
        if (!children.length) return false;
        if (children.length === 1) return children[0].type === (0, (0, parcelRequire("cWojJ")).TableHeader);
        return children.every((node)=>node.type === (0, (0, parcelRequire("cWojJ")).TableHeader));
    };
    const $7478efdfea2a60bf$var$tableCanBeSticky = (node, children)=>{
        return $7478efdfea2a60bf$var$isHeaderRowEnabled(children) && node && node.firstChild && !$7478efdfea2a60bf$var$hasRowspan(node.firstChild);
    };
    class $7478efdfea2a60bf$export$f2c3aea42b2a048f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            this.resizeObserver = new ResizeObserver(this.applyResizerChange);
            if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
            if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
            if (this.props.stickyHeaders) {
                this.overflowParent = (0, (0, parcelRequire("2aXGN")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
                this.overflowParent.addEventListener('scroll', this.onScroll);
            }
            if (this.wrapperRef.current && $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, (0, parcelRequire("eIscD")).TableStickyScrollbar)(this.wrapperRef.current);
        }
        componentDidUpdate(prevProps, prevState) {
            if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, (0, parcelRequire("2aXGN")).OverflowParent).fromElement(this.tableRef.current, this.props.stickyHeaders?.defaultScrollRootId_DO_NOT_USE);
            else if (!this.props.stickyHeaders && this.overflowParent) {
                this.overflowParent.removeEventListener('scroll', this.onScroll);
                this.overflowParent = null;
            }
            if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
            if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        }
        get pinTop() {
            if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
            return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, (0, parcelRequire("6gEe5")).tableMarginTop) - (0, (0, parcelRequire("2aXGN")).tableStickyPadding);
        }
        get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
            return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
        }
        get stickyTop() {
            switch(this.state.stickyMode){
                case 'pin-bottom':
                    return this.pinTop;
                case 'stick':
                    const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                    if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                        const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                        return offsetTop + overflowParentOffsetTop;
                    } else return offsetTop;
                default:
                    return undefined;
            }
        }
        render() {
            const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing } = this.props;
            const { stickyMode: stickyMode } = this.state;
            const lineLengthFixedWidth = (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
            let left;
            let updatedLayout;
            const isRenderWidthValid = !!renderWidth && renderWidth > 0;
            const renderWidthCSS = rendererAppearance === 'full-page' ? `100cqw - ${0, (0, parcelRequire("OxITw")).FullPagePadding}px * 2` : `100cqw`;
            const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
                if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return [
                    isRenderWidthValid ? Math.min((0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth),
                    `min(${(0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
                ];
                else if (rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width) {
                    const tableContainerWidth = (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? renderWidth : tableContainerWidth,
                        renderWidthCSS
                    ];
                } else {
                    const tableContainerWidth = (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
                    return [
                        isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                        `min(${tableContainerWidth}px, ${renderWidthCSS})`
                    ];
                }
            };
            const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
            const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
            const fullWidthLineLength = isRenderWidthValid ? Math.min((0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), renderWidth) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth);
            const fullWidthLineLengthCSS = `min(${(0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
            const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
            const isCommentAppearanceAndTableAlignmentEnabled = (0, (0, parcelRequire("kjIja")).isCommentAppearance)(rendererAppearance) && allowTableAlignment;
            const lineLength = (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
            const lineLengthCSS = (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
            const fixTableSSRResizing = (0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing');
            const tableWidthNew = fixTableSSRResizing ? (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode) : tableWidth;
            const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && isTableAlignStart && ((0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, (0, parcelRequire("kjIja")).isFullWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
            let leftCSS;
            if (shouldCalculateLeftForAlignment) {
                left = (tableWidth - lineLength) / 2;
                leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
            }
            if (fixTableSSRResizing) {
                if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance)) leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
            } else if (!shouldCalculateLeftForAlignment && (0, (0, parcelRequire("kjIja")).isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
            const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(this.props.children);
            const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
            if (isFullWidth) updatedLayout = 'full-width';
            else if (tableNode?.attrs.width) updatedLayout = 'custom';
            else updatedLayout = layout;
            let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
            if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) finalTableContainerWidth = tableNode?.attrs.width && tableNode?.attrs.width !== (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) finalTableContainerWidth = (tableNode?.attrs.layout === 'align-start' || tableNode?.attrs.layout === 'center') && tableNode?.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
            let style;
            if (fixTableSSRResizing) style = {
                width: finalTableContainerWidth,
                left: leftCSS ? `calc(${leftCSS})` : undefined,
                marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
            };
            else style = {
                width: finalTableContainerWidth,
                left: left,
                marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
                "data-layout": updatedLayout,
                ref: this.props.handleRef,
                style: style
            }, $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                "data-testid": "sticky-scrollbar-sentinel-top"
            }), stickyHeaders && $7478efdfea2a60bf$var$tableCanBeSticky(tableNode, children) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2aXGN")).StickyTable), {
                isNumberColumnEnabled: isNumberColumnEnabled,
                tableWidth: tableWidth,
                layout: layout,
                renderWidth: renderWidth,
                handleRef: this.props.handleRef,
                shadowClassNames: this.props.shadowClassNames,
                top: this.stickyTop,
                mode: stickyMode,
                innerRef: this.stickyWrapperRef,
                wrapperWidth: this.state.wrapperWidth,
                columnWidths: columnWidths,
                rowHeight: this.state.headerRowHeight,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                allowTableResizing: allowTableResizing
            }, [
                children && children[0]
            ]), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER,
                ref: this.wrapperRef,
                onScroll: this.props.stickyHeaders && this.onWrapperScrolled
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a4mor")).Table), {
                innerRef: this.tableRef,
                columnWidths: columnWidths,
                layout: layout,
                isNumberColumnEnabled: isNumberColumnEnabled,
                renderWidth: renderWidth,
                tableNode: tableNode,
                rendererAppearance: rendererAppearance,
                isInsideOfBlockNode: isInsideOfBlockNode,
                isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
                allowTableResizing: allowTableResizing
            }, this.grabFirstRowRef(children))), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                ref: this.stickyScrollbarRef,
                style: {
                    height: "var(--ds-space-250, 20px)",
                    display: fixTableSSRResizing ? 'none' : 'block',
                    width: '100%'
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    width: this.tableRef.current?.clientWidth,
                    height: '100%'
                }
            })), $7478efdfea2a60bf$export$bdb2dadcb04aad50(this.props.rendererAppearance) && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                "data-testid": "sticky-scrollbar-sentinel-bottom"
            })));
        }
        constructor(...args){
            super(...args), this.state = {
                stickyMode: 'none',
                wrapperWidth: 0,
                headerRowHeight: 0
            }, this.tableRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.stickyHeaderRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.stickyScrollbarRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.stickyWrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.wrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
                let wrapperWidth = this.state.wrapperWidth;
                let headerRowHeight = this.state.headerRowHeight;
                for (const entry of entries){
                    if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                    else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
                }
                if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                    wrapperWidth: wrapperWidth,
                    headerRowHeight: headerRowHeight
                });
            }, this.componentWillUnmount = ()=>{
                if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
                if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
                if (this.resizeObserver) this.resizeObserver.disconnect();
                if (this.stickyScrollbar) this.stickyScrollbar.dispose();
            }, this.getScrollTop = ()=>{
                const { stickyHeaders: stickyHeaders } = this.props;
                const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
                return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
            }, this.updateSticky = ()=>{
                const tableElem = this.tableRef.current;
                const refElem = this.stickyHeaderRef.current;
                if (!tableElem || !refElem) return;
                const scrollTop = this.getScrollTop() + (0, (0, parcelRequire("2aXGN")).tableStickyPadding);
                const tableTop = $7478efdfea2a60bf$var$getRefTop(tableElem);
                const tableBottom = tableTop + tableElem.clientHeight;
                const shouldSticky = $7478efdfea2a60bf$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
                const shouldPin = $7478efdfea2a60bf$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
                let stickyMode = 'none';
                if (shouldPin) stickyMode = 'pin-bottom';
                else if (shouldSticky) stickyMode = 'stick';
                if (this.state.stickyMode !== stickyMode) this.setState({
                    stickyMode: stickyMode
                });
                this.nextFrame = undefined;
            }, this.onScroll = ()=>{
                if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
            }, this.onWrapperScrolled = ()=>{
                if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
                this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
                if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            }, this.grabFirstRowRef = (children)=>{
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(children || false, (child, idx)=>{
                    if (idx === 0 && (0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        innerRef: this.stickyHeaderRef
                    });
                    return child;
                });
            };
        }
    }
    class $7478efdfea2a60bf$export$91e0997fd3f75d56 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children } = this.props;
            if (!children) return null;
            let childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            const orderedChildren = (0, (0, parcelRequire("5vnE9")).compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$f2c3aea42b2a048f, this.props, orderedChildren);
        }
        constructor(...args){
            super(...args), this.state = {
                tableOrderStatus: undefined
            }, this.addSortableColumn = (childrenArray)=>{
                const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
                const { tableOrderStatus: tableOrderStatus } = this.state;
                if (allowColumnSorting && $7478efdfea2a60bf$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, (0, parcelRequire("5or39")).hasMergedCell)(tableNode)) return $7478efdfea2a60bf$var$addSortableColumn($7478efdfea2a60bf$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
                return childrenArray;
            }, this.changeSortOrder = (columnIndex, sortOrder)=>{
                this.setState({
                    tableOrderStatus: {
                        columnIndex: columnIndex,
                        order: sortOrder
                    }
                });
            }, this.addNumberColumnIndexes = (rows)=>{
                const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
                const headerRowEnabled = $7478efdfea2a60bf$var$isHeaderRowEnabled(rows);
                return (0, ($parcel$interopDefault($5uXOq))).Children.map(rows, (row, index)=>{
                    return (0, ($parcel$interopDefault($5uXOq))).cloneElement((0, ($parcel$interopDefault($5uXOq))).Children.only(row), {
                        isNumberColumnEnabled: isNumberColumnEnabled,
                        index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                    });
                });
            };
        }
    }
    const $7478efdfea2a60bf$var$TableWithShadows = (0, (0, parcelRequire("ajc8Z")).default)($7478efdfea2a60bf$export$91e0997fd3f75d56, {
        overflowSelector: `.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
        useShadowObserver: true
    });
    const $7478efdfea2a60bf$var$TableWithWidth = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>{
            const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, (0, parcelRequire("OxITw")).FullPagePadding) * 2 : width;
            const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
            if (colWidthsSum || props.allowTableResizing) return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$var$TableWithShadows, {
                renderWidth: renderWidth,
                ...props
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7478efdfea2a60bf$export$91e0997fd3f75d56, {
                renderWidth: renderWidth,
                ...props
            });
        });
    };
    var $7478efdfea2a60bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("4BsEy")).withSmartCardStorage)($7478efdfea2a60bf$var$TableWithWidth);
});
parcelRegister("6gEe5", function(module, exports) {
    $parcel$export(module.exports, "tableMarginTop", ()=>$356bd8bd1d42bb7c$export$808015ab1dd6897a);
    $parcel$export(module.exports, "tableMarginTopWithControl", ()=>$356bd8bd1d42bb7c$export$910bf0d22c3d10f2);
    $parcel$export(module.exports, "tableMarginSides", ()=>$356bd8bd1d42bb7c$export$a43e30915fab3ccf);
    $parcel$export(module.exports, "tableCellMinWidth", ()=>$356bd8bd1d42bb7c$export$531f77930bf508de);
    $parcel$export(module.exports, "tableNewColumnMinWidth", ()=>$356bd8bd1d42bb7c$export$c60fae4049791eae);
    $parcel$export(module.exports, "tableCellBorderWidth", ()=>$356bd8bd1d42bb7c$export$72aad729077aa0fb);
    $parcel$export(module.exports, "tableCellPadding", ()=>$356bd8bd1d42bb7c$export$e56b8ca552b280f6);
    $parcel$export(module.exports, "TableSharedCssClassName", ()=>$356bd8bd1d42bb7c$export$c096bca5477eb7ad);
    $parcel$export(module.exports, "tableSharedStyle", ()=>$356bd8bd1d42bb7c$export$c2bf8eea75aa9302);
    $parcel$export(module.exports, "calcTableWidth", ()=>$356bd8bd1d42bb7c$export$d7ece4d8beb06815);
    var $f8Sb3;
    var $9UDEr;
    var $iHYdz;
    var $eluMF;
    var $gmhCD = parcelRequire("gmhCD");
    var $gE8f9;
    var $cYeQP;
    var $hgR8Y;
    function $356bd8bd1d42bb7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $356bd8bd1d42bb7c$export$808015ab1dd6897a = 24;
    const $356bd8bd1d42bb7c$export$afe1899c3eea9823 = 16;
    const $356bd8bd1d42bb7c$export$910bf0d22c3d10f2 = 14;
    const $356bd8bd1d42bb7c$export$a43e30915fab3ccf = 8;
    const $356bd8bd1d42bb7c$export$531f77930bf508de = 48;
    const $356bd8bd1d42bb7c$export$c60fae4049791eae = 140;
    const $356bd8bd1d42bb7c$export$72aad729077aa0fb = 1;
    const $356bd8bd1d42bb7c$export$e56b8ca552b280f6 = 8;
    const $356bd8bd1d42bb7c$export$bba39e724bc39451 = 6;
    const $356bd8bd1d42bb7c$export$c096bca5477eb7ad = {
        TABLE_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-container`,
        TABLE_NODE_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-wrapper`,
        TABLE_LEFT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-left-shadow`,
        TABLE_RIGHT_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-right-shadow`,
        TABLE_STICKY_SHADOW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-shadow`,
        TABLE_STICKY_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-wrapper`,
        TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-container`,
        TABLE_STICKY_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-top`,
        TABLE_STICKY_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-sentinel-bottom`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
        TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
        TABLE_SHADOW_SENTINEL_LEFT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-left`,
        TABLE_SHADOW_SENTINEL_RIGHT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-shadow-sentinel-right`,
        TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, (0, parcelRequire("9UDEr")).tableCellContentDomSelector),
        TABLE_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableCellSelector),
        TABLE_HEADER_CELL_WRAPPER: (0, (0, parcelRequire("9UDEr")).tableHeaderSelector),
        TABLE_ROW_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls-wrapper`,
        TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-controls-decoration`,
        TABLE_RESIZER_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resizer-container`
    };
    var $356bd8bd1d42bb7c$var$_ref = {
        name: "qubt66",
        styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
    };
    var $356bd8bd1d42bb7c$var$_ref2 = {
        name: "1fct7qz",
        styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
    };
    const $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $356bd8bd1d42bb7c$var$_ref2 : $356bd8bd1d42bb7c$var$_ref;
    const $356bd8bd1d42bb7c$export$c2bf8eea75aa9302 = ()=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("hgR8Y")).tableCellBackgroundStyleOverride)(), " .", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $356bd8bd1d42bb7c$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $356bd8bd1d42bb7c$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $356bd8bd1d42bb7c$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $gmhCD.editorExperiment)('table-nested-dnd', true) ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, (0, parcelRequire("gE8f9")).browser).gecko || (0, (0, parcelRequire("gE8f9")).browser).ie || (0, (0, parcelRequire("gE8f9")).browser).mac && (0, (0, parcelRequire("gE8f9")).browser).chrome ? 'background-clip: padding-box;' : '', " ", $356bd8bd1d42bb7c$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
    const $356bd8bd1d42bb7c$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
        switch(layout){
            case 'full-width':
                return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth);
            case 'wide':
                if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding) : 0), (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth));
                return 0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth;
            default:
                return 'inherit';
        }
    };
});
parcelRegister("eluMF", function(module, exports) {
    $parcel$export(module.exports, "overflowShadow", ()=>$b41fea6975363b1e$export$c5c1e4f4640336fb);
    var $f8Sb3;
    const $b41fea6975363b1e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
        const width = "var(--ds-space-100, 8px)";
        const leftCoverWidthResolved = leftCoverWidth || width;
        const rightCoverWidthResolved = rightCoverWidth || width;
        return (0, (0, parcelRequire("f8Sb3")).css)();
    };
});
parcelRegister("cYeQP", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockSharedCssClassName", ()=>$dca73d3fed5e4b1b$export$42659c26f026f6ea);
    $parcel$export(module.exports, "codeBlockSharedStyles", ()=>$dca73d3fed5e4b1b$export$a4fbe21dc6fae881);
    $parcel$export(module.exports, "codeBlockInListSafariFix", ()=>$dca73d3fed5e4b1b$export$3aa5ee2f4c156533);
    var $f8Sb3;
    var $iHYdz;
    var $eluMF;
    const $dca73d3fed5e4b1b$export$42659c26f026f6ea = {
        CODEBLOCK_CONTAINER: 'code-block',
        CODEBLOCK_START: 'code-block--start',
        CODEBLOCK_END: 'code-block--end',
        CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
        CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
        CODEBLOCK_CONTENT: 'code-content',
        DS_CODEBLOCK: '[data-ds--code--code-block]',
        CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
        CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
    };
    const $dca73d3fed5e4b1b$export$a4fbe21dc6fae881 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPED, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{margin-right:var(--ds-space-100, 8px);code{display:block;word-break:break-word;white-space:pre-wrap;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, ">.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;white-space:pre;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px);margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0 0;font-family:", (0, (0, parcelRequire("iHYdz")).akEditorCodeFontFamily), ";min-width:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellMinWidth), "px;cursor:pointer;clear:both;--ds--code--bg-color:transparent;white-space:normal;.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{position:relative;background-color:var(--ds-background-neutral, #091E420F);display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, (0, parcelRequire("eluMF")).overflowShadow)({
            leftCoverWidth: "var(--ds-space-300, 24px)"
        }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #091E420F);position:relative;width:var(--lineNumberGutterWidth, 2rem);padding:0px var(--ds-space-100, 8px);flex-shrink:0;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";box-sizing:content-box;}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{code{tab-size:4;cursor:text;color:var(--ds-text, #172B4D);border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";line-height:1.5rem;}}.", $dca73d3fed5e4b1b$export$42659c26f026f6ea.CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET, "{pointer-events:none;user-select:none;width:var(--lineNumberGutterWidth, 2rem);left:0;position:absolute;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14), ";padding:0px var(--ds-space-100, 8px);line-height:1.5rem;text-align:right;color:var(--ds-text-subtlest, #505F79);box-sizing:content-box;}}");
    const $dca73d3fed5e4b1b$export$3aa5ee2f4c156533 = (0, (0, parcelRequire("f8Sb3")).css)("::before{content:' ';line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em!important;}");
});
parcelRegister("hgR8Y", function(module, exports) {
    $parcel$export(module.exports, "tableCellBackgroundStyleOverride", ()=>$eaa2b3bf40c7fca9$export$677e93f0f5f9623a);
    var $f8Sb3;
    var $9UDEr;
    var $hAs1r;
    const $eaa2b3bf40c7fca9$var$mapBackgroundColors = ()=>{
        let cssString = '';
        (0, (0, parcelRequire("9UDEr")).tableBackgroundColorNames).forEach((value, key)=>{
            const paletteColorValue = (0, (0, parcelRequire("hAs1r")).hexToEditorBackgroundPaletteColor)(value);
            if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
        });
        return cssString;
    };
    const $eaa2b3bf40c7fca9$export$677e93f0f5f9623a = ()=>(0, (0, parcelRequire("f8Sb3")).css)($eaa2b3bf40c7fca9$var$mapBackgroundColors());
});
parcelRegister("hAs1r", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", ()=>$3966f91ec47ca318$export$5f6a44a42a4b38c2);
    $parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", ()=>$3966f91ec47ca318$export$a270511a0e7fd61a);
    var $kTHGn;
    function $3966f91ec47ca318$export$5f6a44a42a4b38c2(hexColor) {
        const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.token : undefined;
    }
    function $3966f91ec47ca318$export$a270511a0e7fd61a(hexColor) {
        const tokenData = $3966f91ec47ca318$export$2462741d70e6a62f[hexColor.toUpperCase()];
        return tokenData ? tokenData.getValue(hexColor) : undefined;
    }
    const $3966f91ec47ca318$export$2462741d70e6a62f = {
        ['#DEEBFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtlest', fallback),
            token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
        },
        ['#B3D4FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtler', fallback),
            token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
        },
        ['#4C9AFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.blue.subtle', fallback),
            token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
        },
        ['#E6FCFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtlest', fallback),
            token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
        },
        ['#B3F5FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtler', fallback),
            token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
        },
        ['#79E2F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.teal.subtle', fallback),
            token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
        },
        ['#E3FCEF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtlest', fallback),
            token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
        },
        ['#ABF5D1']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtler', fallback),
            token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
        },
        ['#57D9A3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.green.subtle', fallback),
            token: "var(--ds-background-accent-green-subtle, #57D9A3)"
        },
        ['#FFFAE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.yellow.subtlest', fallback),
            token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
        },
        ['#FFF0B3']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.yellow.subtler', fallback),
            token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
        },
        ['#FFC400']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.orange.subtle', fallback),
            token: "var(--ds-background-accent-orange-subtle, #FFC400)"
        },
        ['#FFEBE6']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtlest', fallback),
            token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
        },
        ['#FFBDAD']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtler', fallback),
            token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
        },
        ['#FF8F73']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.red.subtle', fallback),
            token: "var(--ds-background-accent-red-subtle, #FF8F73)"
        },
        ['#EAE6FF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtlest', fallback),
            token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
        },
        ['#C0B6F2']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtler', fallback),
            token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
        },
        ['#998DD9']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.purple.subtle', fallback),
            token: "var(--ds-background-accent-purple-subtle, #998DD9)"
        },
        ['#FFFFFF']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('elevation.surface', fallback),
            token: "var(--ds-surface, #FFFFFF)"
        },
        ['#F4F5F7']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.gray.subtlest', fallback),
            token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
        },
        ['#B3BAC5']: {
            getValue: (fallback)=>(0, (0, parcelRequire("kTHGn")).default)('color.background.accent.gray.subtle', fallback),
            token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
        }
    };
});
parcelRegister("5vnE9", function(module, exports) {
    $parcel$export(module.exports, "compose", ()=>$8cb395a24b5942e2$export$f672e0b6f7222cd7);
    function $8cb395a24b5942e2$export$f672e0b6f7222cd7(func, ...funcs) {
        const allFuncs = [
            func,
            ...funcs
        ];
        return function composed(raw) {
            return allFuncs.reduceRight((memo, func)=>func(memo), raw);
        };
    }
});
parcelRegister("5or39", function(module, exports) {
    $parcel$export(module.exports, "calcTableColumnWidths", ()=>$a59f56ae192d20af$export$98951d3cdcfd364b);
    $parcel$export(module.exports, "hasMergedCell", ()=>$a59f56ae192d20af$export$f9d610bfbb78949b);
    $parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", ()=>$a59f56ae192d20af$export$69fbfaf01f2fd534);
    $parcel$export(module.exports, "isPositionNearTableRow", ()=>$a59f56ae192d20af$export$889a8e446452be16);
    function $a59f56ae192d20af$export$98951d3cdcfd364b(node) {
        let tableColumnWidths = [];
        const firstRow = node.firstChild;
        if (firstRow) firstRow.forEach((colNode)=>{
            let colwidth = colNode.attrs.colwidth || [
                0
            ];
            if (colwidth) tableColumnWidths = [
                ...tableColumnWidths,
                ...colwidth
            ];
        });
        return tableColumnWidths;
    }
    function $a59f56ae192d20af$export$f9d610bfbb78949b(tableNode) {
        let hasSpan = false;
        tableNode.descendants((node)=>{
            if (node.type.name === 'tableRow') return true;
            const { colspan: colspan, rowspan: rowspan } = node.attrs;
            if (colspan > 1 || rowspan > 1) hasSpan = true;
            return false;
        });
        return hasSpan;
    }
    function $a59f56ae192d20af$export$69fbfaf01f2fd534(tableNode) {
        const result = [];
        tableNode.forEach((rowNode)=>{
            if (rowNode.type.name === 'tableRow') {
                const row = [];
                rowNode.forEach((n)=>row.push(n));
                result.push(row);
            }
        });
        return result;
    }
    function $a59f56ae192d20af$export$889a8e446452be16(pos, schema, direction) {
        if (!schema.nodes.tableRow) return false;
        let doc = pos.doc;
        let resolved = pos;
        const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
        while(resolved.depth > 0){
            const siblingType = resolved[sibling]?.type;
            if (siblingType === schema.nodes.tableRow) return true;
            resolved = doc.resolve(resolved[direction]());
        }
        return false;
    }
});
parcelRegister("5J0oM", function(module, exports) {
    $parcel$export(module.exports, "createCompareNodes", ()=>$c09b1d49576acabb$export$49215374a8bec29c);
    var $9BYlQ;
    var $c09b1d49576acabb$export$e2e108cbe2e4f865;
    (function(ContentType) {
        ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
        ContentType[ContentType["TEXT"] = 5] = "TEXT";
        ContentType[ContentType["MENTION"] = 10] = "MENTION";
        ContentType[ContentType["DATE"] = 15] = "DATE";
        ContentType[ContentType["STATUS"] = 20] = "STATUS";
        ContentType[ContentType["LINK"] = 25] = "LINK";
    })($c09b1d49576acabb$export$e2e108cbe2e4f865 || ($c09b1d49576acabb$export$e2e108cbe2e4f865 = {}));
    function $c09b1d49576acabb$var$getLinkMark(node) {
        const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
        return linkMark || null;
    }
    function $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
        if (!stringNumber.trim().length) return null;
        const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
        if (Number.isNaN(maybeANumber)) return null;
        return maybeANumber;
    }
    function $c09b1d49576acabb$export$8ebf986086b1866f() {
        const locale = window.navigator.language;
        const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
        const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
        const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
        const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
        return (text)=>{
            if (!text.trim().length) return null;
            const result = text.split(numericPattern);
            const tokens = result.reduce((acc, stringNumber)=>{
                if (!stringNumber?.length) return acc;
                const maybeANumber = $c09b1d49576acabb$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
                if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
                else acc.push(stringNumber);
                return acc;
            }, []);
            if (tokens.length === 1) return tokens[0];
            return tokens.join('');
        };
    }
    function $c09b1d49576acabb$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
        const linkMark = $c09b1d49576acabb$var$getLinkMark(textNode);
        if (linkMark) {
            const value = textNode.text || '';
            return {
                type: 25,
                value: value
            };
        }
        const text = textNode.text || '';
        const normalizedText = normalizeTextParser(text);
        if (typeof normalizedText === 'number') return {
            type: 0,
            value: normalizedText
        };
        return {
            type: 5,
            value: normalizedText ?? text
        };
    }
    function $c09b1d49576acabb$var$getMetaFromNode(node, options, normalizeTextParser) {
        if (!node) return null;
        const firstChild = node.firstChild;
        if (!firstChild) return null;
        switch(firstChild.type.name){
            case 'heading':
            case 'paragraph':
                return $c09b1d49576acabb$var$getMetaFromNode(firstChild, options, normalizeTextParser);
            case 'inlineCard':
                {
                    const attrs = firstChild.attrs;
                    const maybeTitle = options.getInlineCardTextFromStore(attrs);
                    if (maybeTitle) return {
                        type: 25,
                        value: maybeTitle
                    };
                    const url = attrs.url;
                    return {
                        type: 25,
                        value: url ? url : ''
                    };
                }
            case 'text':
                return $c09b1d49576acabb$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
            case 'status':
                {
                    const text = firstChild.attrs.text;
                    return {
                        type: 20,
                        value: text
                    };
                }
            case 'date':
                {
                    const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                    return {
                        type: 15,
                        value: timestamp
                    };
                }
            case 'mention':
                {
                    const text = firstChild.attrs.text || '';
                    return {
                        type: 10,
                        value: text.toLowerCase()
                    };
                }
            default:
                return null;
        }
    }
    function $c09b1d49576acabb$var$compareValue(valueA, valueB) {
        if (valueA === valueB) return 0;
        if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
            caseFirst: 'upper',
            numeric: true
        });
        return valueA > valueB ? 1 : -1;
    }
    const $c09b1d49576acabb$export$49215374a8bec29c = (options, order = (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC)=>{
        const normalizeTextParser = $c09b1d49576acabb$export$8ebf986086b1866f();
        return (nodeA, nodeB)=>{
            const metaNodeA = $c09b1d49576acabb$var$getMetaFromNode(nodeA, options, normalizeTextParser);
            const metaNodeB = $c09b1d49576acabb$var$getMetaFromNode(nodeB, options, normalizeTextParser);
            if (metaNodeA === null || metaNodeB === null) return $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
            return (order === (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC ? -1 : 1) * $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB);
        };
    };
    function $c09b1d49576acabb$var$compareMetaFromNode(metaNodeA, metaNodeB) {
        if (metaNodeA === metaNodeB) return 0;
        if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
        if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
        return $c09b1d49576acabb$var$compareValue(metaNodeA.value, metaNodeB.value);
    }
});
parcelRegister("9BYlQ", function(module, exports) {
    $parcel$export(module.exports, "SortOrder", ()=>$42ab1316856d1585$export$7ae723045d45777a);
    var $dEtqo;
    var $kXC89;
    var $42ab1316856d1585$export$7ae723045d45777a;
    (function(SortOrder) {
        SortOrder["ASC"] = "asc";
        SortOrder["DESC"] = "desc";
        SortOrder["NO_ORDER"] = "no_order";
    })($42ab1316856d1585$export$7ae723045d45777a || ($42ab1316856d1585$export$7ae723045d45777a = {}));
});
parcelRegister("kXC89", function(module, exports) {
    $parcel$export(module.exports, "ToolbarSize", ()=>$fa36a5395f686390$export$ed55211407a9423);
    $parcel$export(module.exports, "ToolbarWidths", ()=>$fa36a5395f686390$export$423b5e8c92d477b9);
    $parcel$export(module.exports, "ToolbarWidthsNext", ()=>$fa36a5395f686390$export$3f050002d3df641b);
    $parcel$export(module.exports, "ToolbarWidthsFullPage", ()=>$fa36a5395f686390$export$63ca43752be70b90);
    $parcel$export(module.exports, "ToolbarWidthsFullPageNext", ()=>$fa36a5395f686390$export$501a79d885598191);
    var $fa36a5395f686390$export$ed55211407a9423;
    (function(ToolbarSize) {
        ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
        ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
        ToolbarSize[ToolbarSize["L"] = 4] = "L";
        ToolbarSize[ToolbarSize["M"] = 3] = "M";
        ToolbarSize[ToolbarSize["S"] = 2] = "S";
        ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    })($fa36a5395f686390$export$ed55211407a9423 || ($fa36a5395f686390$export$ed55211407a9423 = {}));
    var $fa36a5395f686390$export$423b5e8c92d477b9;
    (function(ToolbarWidths) {
        ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
        ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
        ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
        ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
        ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    })($fa36a5395f686390$export$423b5e8c92d477b9 || ($fa36a5395f686390$export$423b5e8c92d477b9 = {}));
    var $fa36a5395f686390$export$3f050002d3df641b;
    (function(ToolbarWidthsNext) {
        ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
        ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
        ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
        ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
        ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    })($fa36a5395f686390$export$3f050002d3df641b || ($fa36a5395f686390$export$3f050002d3df641b = {}));
    var $fa36a5395f686390$export$63ca43752be70b90;
    (function(ToolbarWidthsFullPage) {
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
        ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    })($fa36a5395f686390$export$63ca43752be70b90 || ($fa36a5395f686390$export$63ca43752be70b90 = {}));
    var $fa36a5395f686390$export$501a79d885598191;
    (function(ToolbarWidthsFullPageNext) {
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
        ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    })($fa36a5395f686390$export$501a79d885598191 || ($fa36a5395f686390$export$501a79d885598191 = {}));
});
parcelRegister("fKLIs", function(module, exports) {
    $parcel$export(module.exports, "layoutToWidth", ()=>$78b5f00ff26d55fc$export$9b77d38feba5446);
    $parcel$export(module.exports, "getParentNodeWidth", ()=>$78b5f00ff26d55fc$export$d76cc081ce1449a8);
    $parcel$export(module.exports, "getTableContainerWidth", ()=>$78b5f00ff26d55fc$export$3930799be057b305);
    var $5r0mK = parcelRequire("5r0mK");
    var $iHYdz;
    var $bQr2R;
    var $ejmVg;
    var $eOOFp;
    const $78b5f00ff26d55fc$var$GRID_SIZE = 8;
    const $78b5f00ff26d55fc$export$9b77d38feba5446 = {
        default: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth),
        wide: (0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth),
        'full-width': (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)
    };
    const $78b5f00ff26d55fc$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
        if (!pos) return;
        const node = $78b5f00ff26d55fc$var$getNestedParentNode(pos, state);
        if (!node) return;
        let layout = node.attrs.layout || 'default';
        const { schema: schema } = state;
        const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
        if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
        let parentWidth = $78b5f00ff26d55fc$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
        const contextPanelPluginKey = {
            key: 'contextPanelPluginKey$',
            getState: (state)=>{
                return state['contextPanelPluginKey$'];
            }
        };
        if (node.type === schema.nodes.layoutSection) {
            parentWidth += (0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) * 2;
            if (containerWidth.width > (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
                parentWidth -= ((0, (0, parcelRequire("ejmVg")).LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
        }
        switch(node.type){
            case schema.nodes.layoutSection:
                parentWidth -= (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING) * 2;
                break;
            case schema.nodes.bodiedExtension:
                parentWidth -= (0, (0, parcelRequire("bQr2R")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.extensionFrame:
                parentWidth -= (0, (0, parcelRequire("bQr2R")).BODIED_EXT_PADDING) * 2;
                break;
            case schema.nodes.expand:
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 2;
                parentWidth += $78b5f00ff26d55fc$var$GRID_SIZE * 3;
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE;
                parentWidth -= $78b5f00ff26d55fc$var$GRID_SIZE * 4 - $78b5f00ff26d55fc$var$GRID_SIZE / 2;
                break;
        }
        parentWidth -= 2;
        return parentWidth;
    };
    const $78b5f00ff26d55fc$var$getNestedParentNode = (tablePos, state)=>{
        if (tablePos === undefined) return null;
        const $pos = state.doc.resolve(tablePos);
        const parent = (0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.extensionFrame,
            state.schema.nodes.layoutSection,
            state.schema.nodes.expand
        ]);
        return parent ? parent.node : null;
    };
    const $78b5f00ff26d55fc$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
        return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth)) : (0, (0, parcelRequire("eOOFp")).absoluteBreakoutWidth)(layout, containerWidth.width);
    };
    const $78b5f00ff26d55fc$export$3930799be057b305 = (node)=>{
        if (node?.attrs.width) return node.attrs.width;
        return $78b5f00ff26d55fc$export$9b77d38feba5446[node?.attrs.layout] || (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
    };
    const $78b5f00ff26d55fc$export$9724081a0d43786a = (node, offset)=>{
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        if (isNumberColumnEnabled && offset > 0) return $78b5f00ff26d55fc$export$3930799be057b305(node) - offset;
        return $78b5f00ff26d55fc$export$3930799be057b305(node);
    };
});
parcelRegister("5r0mK", function(module, exports) {
    $parcel$export(module.exports, "removeParentNodeOfType", ()=>$3f4fc20879d21ebe$export$5dd18664fe8bcbde);
    $parcel$export(module.exports, "findParentNodeOfType", ()=>$3f4fc20879d21ebe$export$1a3a74094b9968e);
    $parcel$export(module.exports, "replaceParentNodeOfType", ()=>$3f4fc20879d21ebe$export$b72cc612b642c071);
    $parcel$export(module.exports, "removeSelectedNode", ()=>$3f4fc20879d21ebe$export$7d6e4e6663186878);
    $parcel$export(module.exports, "isNodeSelection", ()=>$3f4fc20879d21ebe$export$a8c1d2c13abf8822);
    $parcel$export(module.exports, "replaceSelectedNode", ()=>$3f4fc20879d21ebe$export$39874bca494f9ba3);
    $parcel$export(module.exports, "setTextSelection", ()=>$3f4fc20879d21ebe$export$1df6d14df6b0b758);
    $parcel$export(module.exports, "safeInsert", ()=>$3f4fc20879d21ebe$export$5fe92db78385e37c);
    $parcel$export(module.exports, "canInsert", ()=>$3f4fc20879d21ebe$export$b4d1262a40ad21d4);
    $parcel$export(module.exports, "removeNodeBefore", ()=>$3f4fc20879d21ebe$export$ffb1550ab6c3d03c);
    $parcel$export(module.exports, "findPositionOfNodeBefore", ()=>$3f4fc20879d21ebe$export$f8088819b1e2c2dc);
    $parcel$export(module.exports, "findParentNode", ()=>$3f4fc20879d21ebe$export$dc159056ffdb4c76);
    $parcel$export(module.exports, "findParentNodeClosestToPos", ()=>$3f4fc20879d21ebe$export$fe09644e3bc6166b);
    $parcel$export(module.exports, "findDomRefAtPos", ()=>$3f4fc20879d21ebe$export$666ce65defe9ad6e);
    $parcel$export(module.exports, "hasParentNode", ()=>$3f4fc20879d21ebe$export$178ecaf80f45fdb6);
    $parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", ()=>$3f4fc20879d21ebe$export$8bf0d019bde85d18);
    $parcel$export(module.exports, "hasParentNodeOfType", ()=>$3f4fc20879d21ebe$export$14f438bb7227ce63);
    $parcel$export(module.exports, "findParentDomRefOfType", ()=>$3f4fc20879d21ebe$export$faeafc1151740116);
    $parcel$export(module.exports, "findSelectedNodeOfType", ()=>$3f4fc20879d21ebe$export$924aa2dd4d9a67fa);
    $parcel$export(module.exports, "flatten", ()=>$3f4fc20879d21ebe$export$bffa455ba8c619a6);
    $parcel$export(module.exports, "findChildren", ()=>$3f4fc20879d21ebe$export$f94ca194e830789c);
    $parcel$export(module.exports, "findChildrenByType", ()=>$3f4fc20879d21ebe$export$96bb9476c7c69f39);
    $parcel$export(module.exports, "contains", ()=>$3f4fc20879d21ebe$export$2344b14b097df817);
    var $gZGBX;
    var $kCV8T;
    var $3f4fc20879d21ebe$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$removeNodeAtPos(parent.pos)(tr);
            return tr;
        };
    var $3f4fc20879d21ebe$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
            if (!Array.isArray(nodeType)) nodeType = [
                nodeType
            ];
            for(let i = 0, count = nodeType.length; i < count; i++){
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType[i])(tr.selection);
                if (parent) {
                    const newTr = $3f4fc20879d21ebe$var$replaceNodeAtPos(parent.pos, content)(tr);
                    if (newTr !== tr) return newTr;
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$7d6e4e6663186878 = (tr)=>{
        if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
            const from = tr.selection.$from.pos;
            const to = tr.selection.$to.pos;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(from, to));
        }
        return tr;
    };
    var $3f4fc20879d21ebe$export$39874bca494f9ba3 = (content)=>(tr)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const { $from: $from, $to: $to } = tr.selection;
                if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, (0, parcelRequire("kCV8T")).Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $3f4fc20879d21ebe$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve($from.pos))));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
            const nextSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(position), dir, true);
            if (nextSelection) return tr.setSelection(nextSelection);
            return tr;
        };
    var $3f4fc20879d21ebe$var$isSelectableNode = (node)=>Boolean(node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.type && node.type.spec.selectable);
    var $3f4fc20879d21ebe$var$shouldSelectNode = (node)=>$3f4fc20879d21ebe$var$isSelectableNode(node) && node.type.isLeaf;
    var $3f4fc20879d21ebe$var$setSelection = (node, pos, tr)=>{
        if ($3f4fc20879d21ebe$var$shouldSelectNode(node)) return tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve(pos)));
        return $3f4fc20879d21ebe$export$1df6d14df6b0b758(pos)(tr);
    };
    var $3f4fc20879d21ebe$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
            const hasPosition = typeof position === "number";
            const { $from: $from } = tr.selection;
            const $insertPos = hasPosition ? tr.doc.resolve(position) : $3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
            const { parent: parent } = $insertPos;
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$39874bca494f9ba3(content)(tr);
                if (oldTr !== tr) return tr;
            }
            if ($3f4fc20879d21ebe$var$isEmptyParagraph(parent)) {
                const oldTr = tr;
                tr = $3f4fc20879d21ebe$export$b72cc612b642c071(parent.type, content)(tr);
                if (oldTr !== tr) {
                    const pos = $3f4fc20879d21ebe$var$isSelectableNode(content) ? $insertPos.before($insertPos.depth) : $insertPos.pos;
                    return $3f4fc20879d21ebe$var$setSelection(content, pos, tr);
                }
            }
            if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($insertPos, content)) {
                tr.insert($insertPos.pos, content);
                const pos = hasPosition ? $insertPos.pos : $3f4fc20879d21ebe$var$isSelectableNode(content) ? tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
                return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
            }
            for(let i = $insertPos.depth; i > 0; i--){
                const pos = $insertPos.after(i);
                const $pos = tr.doc.resolve(pos);
                if ($3f4fc20879d21ebe$export$b4d1262a40ad21d4($pos, content)) {
                    tr.insert(pos, content);
                    return $3f4fc20879d21ebe$var$cloneTr($3f4fc20879d21ebe$var$setSelection(content, pos, tr));
                }
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
            return tr;
        };
    var $3f4fc20879d21ebe$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
            if (!$3f4fc20879d21ebe$export$a8c1d2c13abf8822(tr.selection)) {
                const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeType)(tr.selection);
                if (parent) return $3f4fc20879d21ebe$var$cloneTr(tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, parent.pos)));
            }
            return tr;
        };
    var $3f4fc20879d21ebe$export$ffb1550ab6c3d03c = (tr)=>{
        const position = $3f4fc20879d21ebe$export$f8088819b1e2c2dc(tr.selection);
        if (typeof position === "number") return $3f4fc20879d21ebe$var$removeNodeAtPos(position)(tr);
        return tr;
    };
    var $3f4fc20879d21ebe$export$a8c1d2c13abf8822 = (selection)=>{
        return selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
    };
    var $3f4fc20879d21ebe$var$equalNodeType = (nodeType, node)=>{
        return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
    };
    var $3f4fc20879d21ebe$var$cloneTr = (tr)=>{
        return Object.assign(Object.create(tr), tr).setTime(Date.now());
    };
    var $3f4fc20879d21ebe$var$replaceNodeAtPos = (position, content)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            const $pos = tr.doc.resolve(position);
            if (!node) return tr;
            if ($3f4fc20879d21ebe$var$canReplace($pos, content)) {
                tr = tr.replaceWith(position, position + node.nodeSize, content);
                const start = tr.selection.$from.pos - 1;
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
                tr = $3f4fc20879d21ebe$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
                return $3f4fc20879d21ebe$var$cloneTr(tr);
            }
            return tr;
        };
    var $3f4fc20879d21ebe$var$canReplace = ($pos, content)=>{
        const node = $pos.node($pos.depth);
        return node && node.type.validContent(content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) ? content : (0, (0, parcelRequire("kCV8T")).Fragment).from(content));
    };
    var $3f4fc20879d21ebe$var$removeNodeAtPos = (position)=>(tr)=>{
            const node = tr.doc.nodeAt(position);
            if (!node) return tr;
            return $3f4fc20879d21ebe$var$cloneTr(tr.delete(position, position + node.nodeSize));
        };
    var $3f4fc20879d21ebe$export$b4d1262a40ad21d4 = ($pos, content)=>{
        const index = $pos.index();
        if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) return $pos.parent.canReplace(index, index, content);
        else if (content instanceof (0, (0, parcelRequire("kCV8T")).Node)) return $pos.parent.canReplaceWith(index, index, content.type);
        return false;
    };
    var $3f4fc20879d21ebe$var$isEmptyParagraph = (node)=>{
        return !node || node.type.name === "paragraph" && node.nodeSize === 2;
    };
    var $3f4fc20879d21ebe$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
            if (validateSameParent && !$from.sameParent($to)) {
                let depth = Math.min($from.depth, $to.depth);
                while(depth >= 0){
                    const fromNode = $from.node(depth);
                    const toNode = $to.node(depth);
                    if (toNode === fromNode) {
                        if (predicate(fromNode)) return {
                            pos: depth > 0 ? $from.before(depth) : 0,
                            start: $from.start(depth),
                            depth: depth,
                            node: fromNode
                        };
                    }
                    depth = depth - 1;
                }
                return;
            }
            return $3f4fc20879d21ebe$export$fe09644e3bc6166b($from, predicate);
        };
    var $3f4fc20879d21ebe$export$fe09644e3bc6166b = ($pos, predicate)=>{
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
    };
    var $3f4fc20879d21ebe$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
            const parent = $3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
            if (parent) return $3f4fc20879d21ebe$export$666ce65defe9ad6e(parent.pos, domAtPos);
        };
    var $3f4fc20879d21ebe$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
            return !!$3f4fc20879d21ebe$export$dc159056ffdb4c76(predicate)(selection);
        };
    var $3f4fc20879d21ebe$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$dc159056ffdb4c76((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
        return $3f4fc20879d21ebe$export$fe09644e3bc6166b($pos, (node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node));
    };
    var $3f4fc20879d21ebe$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
            return $3f4fc20879d21ebe$export$178ecaf80f45fdb6((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node))(selection);
        };
    var $3f4fc20879d21ebe$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
            return $3f4fc20879d21ebe$export$8556d79fa8189214((node)=>$3f4fc20879d21ebe$var$equalNodeType(nodeType, node), domAtPos)(selection);
        };
    var $3f4fc20879d21ebe$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
            if ($3f4fc20879d21ebe$export$a8c1d2c13abf8822(selection)) {
                const { node: node, $from: $from } = selection;
                if ($3f4fc20879d21ebe$var$equalNodeType(nodeType, node)) return {
                    node: node,
                    start: $from.start(),
                    pos: $from.pos,
                    depth: $from.depth
                };
            }
        };
    var $3f4fc20879d21ebe$export$f8088819b1e2c2dc = (selection)=>{
        const { nodeBefore: nodeBefore } = selection.$from;
        const maybeSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(selection.$from, -1);
        if (maybeSelection && nodeBefore) {
            const parent = $3f4fc20879d21ebe$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
            if (parent) return parent.pos;
            return maybeSelection.$from.pos;
        }
    };
    var $3f4fc20879d21ebe$export$666ce65defe9ad6e = (position, domAtPos)=>{
        const dom = domAtPos(position);
        const node = dom.node.childNodes[dom.offset];
        if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
        if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
        return node;
    };
    var $3f4fc20879d21ebe$export$bffa455ba8c619a6 = (node, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        const result = [];
        node.descendants((child, pos)=>{
            result.push({
                node: child,
                pos: pos
            });
            if (!descend) return false;
        });
        return result;
    };
    var $3f4fc20879d21ebe$export$f94ca194e830789c = (node, predicate, descend = true)=>{
        if (!node) throw new Error('Invalid "node" parameter');
        else if (!predicate) throw new Error('Invalid "predicate" parameter');
        return $3f4fc20879d21ebe$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
    };
    var $3f4fc20879d21ebe$export$53418710fbc2d8cc = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isText, descend);
    };
    var $3f4fc20879d21ebe$export$ddc1620722e25671 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
    };
    var $3f4fc20879d21ebe$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
    };
    var $3f4fc20879d21ebe$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
    };
    var $3f4fc20879d21ebe$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
    };
    var $3f4fc20879d21ebe$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
        return $3f4fc20879d21ebe$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
    };
    var $3f4fc20879d21ebe$export$2344b14b097df817 = (node, nodeType)=>{
        return !!$3f4fc20879d21ebe$export$96bb9476c7c69f39(node, nodeType).length;
    };
});
parcelRegister("bQr2R", function(module, exports) {
    $parcel$export(module.exports, "BODIED_EXT_PADDING", ()=>$6a203c68476205e6$export$5ac5087fe1217160);
    $parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", ()=>$6a203c68476205e6$export$91624ec52c59c24c);
    const $6a203c68476205e6$export$f5ecdce4c60ff98b = 8;
    const $6a203c68476205e6$export$5ac5087fe1217160 = $6a203c68476205e6$export$f5ecdce4c60ff98b * 2;
    const $6a203c68476205e6$export$91624ec52c59c24c = 12;
});
parcelRegister("ejmVg", function(module, exports) {
    $parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", ()=>$16b49a7404f3316f$export$cd04f19842abff0);
    $parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", ()=>$16b49a7404f3316f$export$a1bb91aa2d5fcce8);
    const $16b49a7404f3316f$export$cd04f19842abff0 = 8;
    const $16b49a7404f3316f$export$a1bb91aa2d5fcce8 = $16b49a7404f3316f$export$cd04f19842abff0 * 1.5;
});
parcelRegister("OxITw", function(module, exports) {
    $parcel$export(module.exports, "FullPagePadding", ()=>$19a4579e32968c00$export$12fd658e5eef0d79);
    $parcel$export(module.exports, "TELEPOINTER_ID", ()=>$19a4579e32968c00$export$74b525449cc7cbd1);
    $parcel$export(module.exports, "rendererStyles", ()=>$19a4579e32968c00$export$1c4377249312209);
    var $f8Sb3;
    var $VSDnB;
    var $k5uoT;
    var $3RZIb;
    var $cSyk1;
    var $9R9Rb;
    var $1xqpZ;
    var $cx4Bg;
    var $kRRtM;
    var $cYeQP;
    var $7Acon;
    var $719f3;
    var $4E5wI;
    var $idytF;
    var $5fBxY;
    var $jlYLw;
    var $ceYEW;
    var $4jyW9;
    var $bv4Ps;
    var $aSoqv;
    var $iJOES;
    var $6gEe5;
    var $1bQ0V;
    var $jRk4M;
    var $fwxzS;
    var $ajc8Z;
    var $bbl9Y;
    var $gE8f9;
    var $iHYdz;
    var $l8Gxi;
    var $3rouw;
    var $2o2hu;
    var $dkc63;
    var $gmhCD = parcelRequire("gmhCD");
    const $19a4579e32968c00$export$12fd658e5eef0d79 = 32;
    const $19a4579e32968c00$var$tableShadowWidth = 32;
    const $19a4579e32968c00$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
    const $19a4579e32968c00$var$telepointerStyles = (colorMode)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("#", $19a4579e32968c00$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:700;width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
    };
    const $19a4579e32968c00$var$getLineHeight = (fontCode)=>(0, (0, parcelRequire("3RZIb")).headingSizes)[fontCode].lineHeight / (0, (0, parcelRequire("3RZIb")).headingSizes)[fontCode].size;
    const $19a4579e32968c00$var$headingSizes = {
        h1: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h700')
        },
        h2: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h600')
        },
        h3: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h500')
        },
        h4: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h400')
        },
        h5: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h300')
        },
        h6: {
            lineHeight: $19a4579e32968c00$var$getLineHeight('h100')
        }
    };
    const $19a4579e32968c00$var$headingAnchorStyle = (headingTag)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{position:absolute;height:", $19a4579e32968c00$var$headingSizes[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
    const $19a4579e32968c00$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowNestedHeaderLinks) return '';
        return (0, (0, parcelRequire("f8Sb3")).css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
    };
    const $19a4579e32968c00$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
        if (!allowColumnSorting) return '';
        let headingsCss = '';
        if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, (0, parcelRequire("3rouw")).HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $gmhCD.editorExperiment)('table-nested-dnd', true) ? `${0, (0, parcelRequire("6gEe5")).tableCellPadding}px ${"var(--ds-space-250, 20px)"}` : `${0, (0, parcelRequire("6gEe5")).tableCellPadding}px`, ";border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";}}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
    };
    const $19a4579e32968c00$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
        if (appearance !== 'full-page') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $19a4579e32968c00$export$12fd658e5eef0d79 : 0, "px;");
    };
    const $19a4579e32968c00$var$fullWidthStyles = ({ appearance: appearance })=>{
        if (appearance !== 'full-width') return '';
        return (0, (0, parcelRequire("f8Sb3")).css)("max-width:", (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark:not([data-has-width='true']),.ak-renderer-extension{width:100%!important;}", (0, (0, parcelRequire("dkc63")).isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
    };
    const $19a4579e32968c00$var$breakoutWidthStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("*:not([data-mark-type='fragment']) .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
    };
    const $19a4579e32968c00$var$getShadowOverrides = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW, "::before{width:", $19a4579e32968c00$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
    };
    function $19a4579e32968c00$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
        if (!(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes')) return '';
        if ((0, (0, parcelRequire("VSDnB")).fg)('annotations_align_editor_and_renderer_styles')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& [data-annotation-draft-mark][data-annotation-inline-node]': {
                borderBottom: '2px solid transparent',
                cursor: 'pointer',
                padding: '1px 0 2px',
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
                borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
                padding: '5px 0 3px 0'
            },
            '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
                paddingTop: "var(--ds-space-025, 2px)"
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
                background: `var(--ds-background-accent-yellow-subtler, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
                borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`}`,
                boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, -1px 2px 3px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
                cursor: 'pointer',
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
            }
        });
    }
    const $19a4579e32968c00$var$tableRowHeight = 44;
    const $19a4579e32968c00$var$stickyScrollbarStyles = `
	position: relative;
	flex-direction: column;

	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
	  width: 100%;
	  display: block;
	  visibility: hidden;
	  overflow-x: auto;
	  position: sticky;
	  bottom: ${"var(--ds-space-0, 0px)"};
	  z-index: 1;
	}

	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
	> .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   position: absolute;
	   width: 100%;
	   height: 1px;
	   margin-top: -1px;
	   // need this to avoid sentinel being focused via keyboard
	   // this still allows it to be detected by intersection observer
	   visibility: hidden;
	 }
	 > .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
	   top: ${$19a4579e32968c00$var$tableRowHeight * 3}px;
	 }
	 > .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
	   bottom:  ${"var(--ds-space-250, 20px)"}; // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
	 }
  `;
    const $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2 = ()=>(0, $gmhCD.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_pre_release_2');
    const $19a4579e32968c00$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
            const { colorMode: colorMode, typography: typography } = (0, (0, parcelRequire("cSyk1")).default)();
            const themeProps = {
                theme: theme
            };
            const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, appearance: appearance } = wrapperProps;
            return (0, (0, parcelRequire("f8Sb3")).css)("font-size:", (0, (0, parcelRequire("iHYdz")).editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $19a4579e32968c00$var$fullPageStyles(wrapperProps, themeProps), " ", $19a4579e32968c00$var$fullWidthStyles(wrapperProps), " .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "{", (0, (0, parcelRequire("9R9Rb")).mediaInlineImageStyles), ";}& h1{", $19a4579e32968c00$var$headingAnchorStyle('h1'), ";}& h2{", $19a4579e32968c00$var$headingAnchorStyle('h2'), ";}& h3{", $19a4579e32968c00$var$headingAnchorStyle('h3'), ";}& h4{", $19a4579e32968c00$var$headingAnchorStyle('h4'), ";}& h5{", $19a4579e32968c00$var$headingAnchorStyle('h5'), ";}& h6{", $19a4579e32968c00$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";}", $19a4579e32968c00$var$telepointerStyles(colorMode), " ", (0, (0, parcelRequire("fwxzS")).whitespaceSharedStyles), ";", (0, (0, parcelRequire("kRRtM")).blockquoteSharedStyles), ";", (0, (0, parcelRequire("idytF")).headingsSharedStyles)(typography), ";", (0, (0, parcelRequire("bv4Ps")).ruleSharedStyles)(), ";", (0, (0, parcelRequire("4jyW9")).paragraphSharedStyles)(typography), ";", (0, (0, parcelRequire("jlYLw")).listsSharedStyles), ";", (0, (0, parcelRequire("5fBxY")).indentationSharedStyles), ";", (0, (0, parcelRequire("cx4Bg")).blockMarksSharedStyles), ";", (0, (0, parcelRequire("7Acon")).codeMarkSharedStyles)(), ";", (0, (0, parcelRequire("aSoqv")).shadowSharedStyle), ";", (0, (0, parcelRequire("4E5wI")).dateSharedStyle), ";", (0, (0, parcelRequire("jRk4M")).textColorStyles), ";", (0, (0, parcelRequire("1xqpZ")).backgroundColorStyles)(), ";", (0, (0, parcelRequire("1bQ0V")).tasksAndDecisionsStyles), ";", (0, (0, parcelRequire("iJOES")).smartCardSharedStyles), " ", $19a4579e32968c00$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:", (0, (0, parcelRequire("k5uoT")).fontFamily)(), ";font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)((0, (0, parcelRequire("k5uoT")).fontSize)()), ";font-weight:400;white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$829f609a65d26a98$export$920c0d5c49070351})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`, ";color:", `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-align-start,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-center,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $19a4579e32968c00$var$alignedHeadingAnchorStyle(wrapperProps), (0, (0, parcelRequire("ceYEW")).mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, ">{", $19a4579e32968c00$var$breakoutWidthStyle(), " * .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, "{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION, "{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, (0, parcelRequire("6gEe5")).tableSharedStyle)(), " .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, " .", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW, "::before{top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop) - 1, "px;height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px);z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";}", $19a4579e32968c00$var$getShadowOverrides(), " ", (0, (0, parcelRequire("dkc63")).isStickyScrollbarEnabled)(appearance) ? $19a4579e32968c00$var$stickyScrollbarStyles : '', " & .", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px);}table{height:1px;", $19a4579e32968c00$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}table tr:first-of-type{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";width:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`, ";font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)((0, (0, parcelRequire("k5uoT")).fontSize)()), ";}.fixed .", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $19a4579e32968c00$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, (0, parcelRequire("2o2hu")).getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2() ? (0, (0, parcelRequire("719f3")).columnLayoutResponsiveSharedStyle) : (0, (0, parcelRequire("719f3")).columnLayoutSharedStyle), ";", $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2() && (0, (0, parcelRequire("719f3")).columnLayoutResponsiveRendererStyles), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:", $19a4579e32968c00$var$isAdvancedLayoutsPreRelease2() ? 0 : "var(--ds-space-400, 32px)", ";}@media screen and (max-width: ", (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, (0, parcelRequire("gE8f9")).browser).safari ? (0, (0, parcelRequire("cYeQP")).codeBlockInListSafariFix) : '', ";}");
        };
    const $19a4579e32968c00$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
        if (codeBlockRenderAsBlock) return '';
        return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
    };
});
parcelRegister("9R9Rb", function(module, exports) {
    $parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", ()=>$c55873fb36219b19$export$dd2e16f83ae6aa78);
    $parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$7ab34e219ce6eef);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$263a8a844c370a89);
    $parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", ()=>$c55873fb36219b19$export$b0d1f1e1fb3c4b46);
    $parcel$export(module.exports, "mediaInlineImageStyles", ()=>$c55873fb36219b19$export$dee15762144889b7);
    $parcel$export(module.exports, "wrapperStyle", ()=>$c55873fb36219b19$export$c4d4f06a25de97f);
    $parcel$export(module.exports, "selectedStyle", ()=>$c55873fb36219b19$export$a7abb1b3dc25813f);
    $parcel$export(module.exports, "borderStyle", ()=>$c55873fb36219b19$export$4d0a7f76ad443516);
    var $f8Sb3;
    var $dR3f5;
    const $c55873fb36219b19$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
    const $c55873fb36219b19$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
    const $c55873fb36219b19$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
    const $c55873fb36219b19$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
    const $c55873fb36219b19$var$inlineImageHeight = (height, margin = 0)=>(0, (0, parcelRequire("f8Sb3")).css)(">.mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>.", $c55873fb36219b19$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
    const $c55873fb36219b19$export$dee15762144889b7 = (0, (0, parcelRequire("f8Sb3")).css)(".", $c55873fb36219b19$export$dd2e16f83ae6aa78, "{height:", (0, (0, parcelRequire("dR3f5")).referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h1'], -3), ";}h2{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h2'], -3), ";}h3{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h3'], -2), ";}h4{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h4'], -2), ";}h5{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h5'], -2), ";}h6{", $c55873fb36219b19$var$inlineImageHeight((0, (0, parcelRequire("dR3f5")).referenceHeights)['h6'], -2), ";}");
    const $c55873fb36219b19$export$c4d4f06a25de97f = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        verticalAlign: 'middle',
        overflow: 'hidden',
        borderRadius: `${"var(--ds-border-radius, 3px)"}`,
        aspectRatio: `var(${$c55873fb36219b19$export$7ab34e219ce6eef}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
        maxWidth: '100%'
    });
    const $c55873fb36219b19$export$a7abb1b3dc25813f = (0, (0, parcelRequire("f8Sb3")).css)({
        boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #0C66E4)"}`,
        outline: 'none'
    });
    const $c55873fb36219b19$export$4d0a7f76ad443516 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(${$c55873fb36219b19$export$b0d1f1e1fb3c4b46})`,
        borderStyle: 'solid',
        borderRadius: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
        borderWidth: `calc(var(${$c55873fb36219b19$export$263a8a844c370a89}, ${(0, (0, parcelRequire("dR3f5")).DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
        boxSizing: `border-box`
    });
});
parcelRegister("dR3f5", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", ()=>$c9848698b53f0c39$export$d722b7527b1834a8);
    $parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", ()=>$c9848698b53f0c39$export$da894f7669b4e67c);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", ()=>$c9848698b53f0c39$export$286cf28b87ad4b4f);
    $parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", ()=>$c9848698b53f0c39$export$64fe09732fb8680);
    $parcel$export(module.exports, "referenceHeights", ()=>$c9848698b53f0c39$export$c1317a9224e4d798);
    const $c9848698b53f0c39$export$d722b7527b1834a8 = 250;
    const $c9848698b53f0c39$export$da894f7669b4e67c = 200;
    const $c9848698b53f0c39$export$286cf28b87ad4b4f = $c9848698b53f0c39$export$d722b7527b1834a8 / $c9848698b53f0c39$export$da894f7669b4e67c;
    const $c9848698b53f0c39$export$64fe09732fb8680 = 0;
    const $c9848698b53f0c39$export$c1317a9224e4d798 = {
        p: 22,
        h1: 36,
        h2: 31,
        h3: 25,
        h4: 23,
        h5: 20,
        h6: 18
    };
});
parcelRegister("1xqpZ", function(module, exports) {
    $parcel$export(module.exports, "backgroundColorStyles", ()=>$31831d84911fc513$export$e4cca17cf56e99d);
    function $31831d84911fc513$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $31831d84911fc513$var$_ref = {
        name: "7ixjog",
        styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
    };
    const $31831d84911fc513$export$e4cca17cf56e99d = ()=>{
        return $31831d84911fc513$var$_ref;
    };
});
parcelRegister("cx4Bg", function(module, exports) {
    $parcel$export(module.exports, "blockMarksSharedStyles", ()=>$e319ea6be2c09fe0$export$33edc553df878c50);
    function $e319ea6be2c09fe0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e319ea6be2c09fe0$export$33edc553df878c50 = {
        name: "1p01ut3",
        styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
    };
});
parcelRegister("kRRtM", function(module, exports) {
    $parcel$export(module.exports, "blockquoteSharedStyles", ()=>$93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee);
    var $f8Sb3;
    var $iHYdz;
    const $93fa07ea5b1e3295$export$1b5f3b43e6c4a8ee = (0, (0, parcelRequire("f8Sb3")).css)({
        '& blockquote': {
            boxSizing: 'border-box',
            color: 'inherit',
            width: '100%',
            display: 'inline-block',
            paddingLeft: "var(--ds-space-200, 16px)",
            borderLeft: `2px solid ${`var(--ds-border, ${(0, (0, parcelRequire("iHYdz")).akEditorBlockquoteBorderColor)})`}`,
            margin: `${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0 0 0`,
            marginRight: 0,
            "[dir='rtl'] &": {
                paddingLeft: 0,
                paddingRight: "var(--ds-space-200, 16px)"
            },
            '&:first-child': {
                marginTop: 0
            },
            '&::before': {
                content: "''"
            },
            '&::after': {
                content: 'none'
            },
            '& p': {
                display: 'block'
            },
            '& table, & table:last-child': {
                display: 'inline-table'
            },
            '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
                display: 'block'
            }
        }
    });
});
parcelRegister("7Acon", function(module, exports) {
    $parcel$export(module.exports, "codeMarkSharedStyles", ()=>$4ae245bd686f7965$export$ea799c18f699972b);
    var $f8Sb3;
    var $1HkQx;
    const $4ae245bd686f7965$export$ea799c18f699972b = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '.code': {
                '--ds--code--bg-color': "var(--ds-background-neutral, #091E420F)",
                ...(0, (0, parcelRequire("1HkQx")).getCodeStyles)()
            }
        });
    };
});
parcelRegister("1HkQx", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$a9c1aabaca189fa1$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$a9c1aabaca189fa1$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$a9c1aabaca189fa1$export$57a2d4b573afd64a);
    var $lBXbx;
    var $8CJbG;
    const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $a9c1aabaca189fa1$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("lBXbx")).SPACING),
            marginRight: (0, (0, parcelRequire("lBXbx")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $a9c1aabaca189fa1$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $a9c1aabaca189fa1$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("lBXbx")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $a9c1aabaca189fa1$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("lBXbx")).SPACING}px 0` : (0, (0, parcelRequire("lBXbx")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("lBXbx")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme),
                ...$a9c1aabaca189fa1$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $a9c1aabaca189fa1$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("lBXbx")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("lBXbx")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("lBXbx")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("lBXbx")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("lBXbx")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("lBXbx")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $a9c1aabaca189fa1$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("8CJbG")).getBaseTheme)();
        const baseStyles = $a9c1aabaca189fa1$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $a9c1aabaca189fa1$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("8CJbG")).getBaseTheme)(),
            ...(0, (0, parcelRequire("8CJbG")).getColorPalette)(),
            lineNumberWidth: maxLines ? $a9c1aabaca189fa1$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("lBXbx", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$6ec31795911692d1$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$6ec31795911692d1$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$6ec31795911692d1$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$6ec31795911692d1$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$6ec31795911692d1$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$6ec31795911692d1$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$6ec31795911692d1$export$1758fda69688282e);
    var $k5uoT;
    const $6ec31795911692d1$export$431ac46d758d98c8 = 12;
    const $6ec31795911692d1$export$8e3c04032121c606 = '20px';
    const $6ec31795911692d1$export$c8b5dc30e9f2b86e = '4px';
    const $6ec31795911692d1$export$82ea42e772d49e5b = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $6ec31795911692d1$export$eeeea0ff98e06fff = $6ec31795911692d1$export$82ea42e772d49e5b * 2;
    const $6ec31795911692d1$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $6ec31795911692d1$export$1758fda69688282e = '--ds--code--bg-color';
    const $6ec31795911692d1$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("8CJbG", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$eac5fe855702cfc1$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$eac5fe855702cfc1$export$fe2a6478976e8b17);
    var $8QpSo;
    var $kTHGn;
    const $eac5fe855702cfc1$var$T800 = '#067384';
    const $eac5fe855702cfc1$var$Y1100 = '#7A5D1A';
    const $eac5fe855702cfc1$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("kTHGn")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
        });
    const $eac5fe855702cfc1$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$829f609a65d26a98$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$eac5fe855702cfc1$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$eac5fe855702cfc1$var$Y1100})`
        };
    });
    const $eac5fe855702cfc1$var$getTheme = ()=>({
            ...$eac5fe855702cfc1$export$4464aa303b3e4fda(),
            ...$eac5fe855702cfc1$export$fe2a6478976e8b17()
        });
    var $eac5fe855702cfc1$export$2e2bcd8739ae039 = $eac5fe855702cfc1$var$getTheme;
});
parcelRegister("719f3", function(module, exports) {
    $parcel$export(module.exports, "columnLayoutSharedStyle", ()=>$2e5d010f6440279f$export$6891a39948814a80);
    $parcel$export(module.exports, "columnLayoutResponsiveSharedStyle", ()=>$2e5d010f6440279f$export$3afcac98e7ca927d);
    $parcel$export(module.exports, "columnLayoutResponsiveRendererStyles", ()=>$2e5d010f6440279f$export$f2451ec7aca7656c);
    var $f8Sb3;
    var $iHYdz;
    function $2e5d010f6440279f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2e5d010f6440279f$export$6891a39948814a80 = (0, (0, parcelRequire("f8Sb3")).css)({
        '[data-layout-section]': {
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            '& > *': {
                flex: 1,
                minWidth: 0
            },
            '& > .unsupportedBlockView-content-wrap': {
                minWidth: 'initial'
            },
            [`@media screen and (max-width: ${0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth}px)`]: {
                flexDirection: 'column'
            }
        }
    });
    const $2e5d010f6440279f$export$3afcac98e7ca927d = {
        name: "ee7qh9",
        styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
    };
    const $2e5d010f6440279f$export$f2451ec7aca7656c = (0, (0, parcelRequire("f8Sb3")).css)({
        '.layout-section-container': {
            '[data-layout-section]': {
                [`@container layout-area (max-width:${(0, (0, parcelRequire("iHYdz")).layoutBreakpointWidth).MEDIUM - 1}px)`]: {
                    flexDirection: 'column'
                }
            }
        }
    });
});
parcelRegister("4E5wI", function(module, exports) {
    $parcel$export(module.exports, "DateSharedCssClassName", ()=>$174371b9df7208d5$export$99cdf122d0bb9f95);
    $parcel$export(module.exports, "dateSharedStyle", ()=>$174371b9df7208d5$export$86f86bd772084bf4);
    var $f8Sb3;
    const $174371b9df7208d5$export$99cdf122d0bb9f95 = {
        DATE_WRAPPER: `date-lozenger-container`,
        DATE_CONTAINER: 'dateView-content-wrap'
    };
    const $174371b9df7208d5$export$86f86bd772084bf4 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`.${$174371b9df7208d5$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
            whiteSpace: 'unset'
        }
    });
});
parcelRegister("idytF", function(module, exports) {
    $parcel$export(module.exports, "headingsSharedStyles", ()=>$152b62c033bbf99a$export$9272613b68afed4b);
    var $f8Sb3;
    var $VSDnB;
    var $04VvC;
    const $152b62c033bbf99a$var$headingWithAlignmentStyles = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_heading_margin_fix') ? {
            '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
                '> h1:first-child': {
                    marginTop: '1.667em'
                },
                ' > h2:first-child': {
                    marginTop: '1.8em'
                },
                '> h3:first-child': {
                    marginTop: '2em'
                },
                '> h4:first-child': {
                    marginTop: '1.357em'
                },
                '> h5:first-child': {
                    marginTop: '1.667em'
                },
                '> h6:first-child': {
                    marginTop: '1.455em'
                }
            },
            '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
                '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                    marginTop: '0'
                }
            }
        } : {};
    const $152b62c033bbf99a$export$9272613b68afed4b = (typographyTheme)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_typography_ugc')) return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h1', typographyTheme),
                marginBottom: 0,
                marginTop: '1.45833em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                },
                '&::before': {}
            },
            '& h2': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h2', typographyTheme),
                marginTop: '1.4em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h3': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h3', typographyTheme),
                marginTop: '1.31249em',
                marginBottom: 0,
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h4': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h4', typographyTheme),
                marginTop: '1.25em',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h5': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h5', typographyTheme),
                marginTop: '1.45833em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            '& h6': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.heading.h6', typographyTheme),
                marginTop: '1.59091em',
                textTransform: 'none',
                '& strong': {
                    fontWeight: (0, (0, parcelRequire("04VvC")).default)('editor.font.weight.heading.h1.bold', typographyTheme)
                }
            },
            ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
        });
        else return (0, (0, parcelRequire("f8Sb3")).css)({
            '& h1': {
                fontSize: `${24 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 28 / 24,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.01em`,
                marginBottom: 0,
                marginTop: '1.667em'
            },
            '& h2': {
                fontSize: `${20 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.2,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-medium, 500)",
                letterSpacing: `-0.008em`,
                marginTop: '1.8em',
                marginBottom: 0
            },
            '& h3': {
                fontSize: `${16 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 1.25,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.006em`,
                marginTop: '2em',
                marginBottom: 0
            },
            '& h4': {
                fontSize: `${1}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 14,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                letterSpacing: `-0.003em`,
                marginTop: '1.357em'
            },
            '& h5': {
                fontSize: `${12 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 12,
                color: "var(--ds-text, #172B4D)",
                fontWeight: "var(--ds-font-weight-semibold, 600)",
                marginTop: '1.667em',
                textTransform: 'none'
            },
            '& h6': {
                fontSize: `${11 / 14}em`,
                fontStyle: 'inherit',
                lineHeight: 16 / 11,
                color: "var(--ds-text-subtlest, #626F86)",
                fontWeight: "var(--ds-font-weight-bold, 700)",
                marginTop: '1.455em',
                textTransform: 'none'
            },
            ...$152b62c033bbf99a$var$headingWithAlignmentStyles()
        });
    };
});
parcelRegister("04VvC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53f731000984869b$export$2e2bcd8739ae039);
    var $kqZva;
    function $53f731000984869b$var$editorUGCToken(path, typographyTheme) {
        let token;
        switch(typographyTheme){
            case 'typography-modernized':
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokensModernized)[path];
                break;
            case 'typography-refreshed':
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokensRefreshed)[path];
                break;
            default:
                token = (0, (0, parcelRequire("kqZva")).editorUGCTokens)[path];
                break;
        }
        return token;
    }
    var $53f731000984869b$export$2e2bcd8739ae039 = $53f731000984869b$var$editorUGCToken;
});
parcelRegister("kqZva", function(module, exports) {
    $parcel$export(module.exports, "editorUGCTokens", ()=>$5558cddd9c1ce385$export$4a3637dc6e2ae29e);
    $parcel$export(module.exports, "editorUGCTokensModernized", ()=>$5558cddd9c1ce385$export$95588e746468319e);
    $parcel$export(module.exports, "editorUGCTokensRefreshed", ()=>$5558cddd9c1ce385$export$63adc0ebe3278d31);
    const $5558cddd9c1ce385$export$4a3637dc6e2ae29e = {
        'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $5558cddd9c1ce385$export$95588e746468319e = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
    const $5558cddd9c1ce385$export$63adc0ebe3278d31 = {
        'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        'editor.font.weight.heading.h1.bold': '700',
        'editor.font.weight.heading.h2.bold': '700',
        'editor.font.weight.heading.h3.bold': '700',
        'editor.font.weight.heading.h4.bold': '700',
        'editor.font.weight.heading.h5.bold': '700',
        'editor.font.weight.heading.h6.bold': '700'
    };
});
parcelRegister("5fBxY", function(module, exports) {
    $parcel$export(module.exports, "indentationSharedStyles", ()=>$586c09e19d6f6d26$export$6856b92f564d3de8);
    function $586c09e19d6f6d26$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $586c09e19d6f6d26$export$6856b92f564d3de8 = {
        name: "1bgz9nd",
        styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
    };
});
parcelRegister("ceYEW", function(module, exports) {
    $parcel$export(module.exports, "richMediaClassName", ()=>$5c06afce66d8efef$export$cfe6da7d522d87bb);
    $parcel$export(module.exports, "mediaSingleSharedStyle", ()=>$5c06afce66d8efef$export$d031611b96ba4cf0);
    $parcel$export(module.exports, "mediaSingleSharedStyleNew", ()=>$5c06afce66d8efef$export$b51dea84d928a378);
    var $f8Sb3;
    var $iHYdz;
    const $5c06afce66d8efef$export$cfe6da7d522d87bb = 'rich-media-item';
    const $5c06afce66d8efef$var$wrappedMediaBreakoutPoint = 410;
    const $5c06afce66d8efef$export$d031611b96ba4cf0 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
    const $5c06afce66d8efef$export$b51dea84d928a378 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`li .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            margin: 0
        },
        '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
            content: "''",
            display: 'block',
            height: 0
        },
        '&.ua-firefox': {
            '.mediaSingleView-content-wrap': {
                userSelect: 'none'
            },
            '.captionView-content-wrap': {
                userSelect: 'text'
            }
        },
        ".mediaSingleView-content-wrap[layout^='wrap-']": {
            position: 'relative',
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorWrappedNodeZIndex)
        },
        ".mediaSingleView-content-wrap[layout='center']": {
            clear: 'both'
        },
        [`table .${$5c06afce66d8efef$export$cfe6da7d522d87bb}`]: {
            marginTop: "var(--ds-space-150, 12px)",
            marginBottom: "var(--ds-space-150, 12px)",
            clear: 'both',
            '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
                clear: 'none',
                '&:first-child': {
                    marginTop: "var(--ds-space-150, 12px)"
                }
            }
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left`]: {
            clear: 'both'
        },
        [`.${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-left, .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right + .${$5c06afce66d8efef$export$cfe6da7d522d87bb}.image-wrap-right`]: {
            marginRight: 0,
            marginLeft: 0
        },
        [`@media all and (max-width: ${$5c06afce66d8efef$var$wrappedMediaBreakoutPoint}px)`]: {
            "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
                float: 'none',
                overflow: 'auto',
                margin: `${"var(--ds-space-150, 12px)"} 0`
            }
        }
    });
});
parcelRegister("4jyW9", function(module, exports) {
    $parcel$export(module.exports, "paragraphSharedStyles", ()=>$0bce92e99beab9a0$export$2f49074d75b0e29f);
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    var $04VvC;
    const $0bce92e99beab9a0$export$2f49074d75b0e29f = (typographyTheme)=>{
        return (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_typography_ugc') ? (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                font: (0, (0, parcelRequire("04VvC")).default)('editor.font.body', typographyTheme),
                marginTop: (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin),
                marginBottom: 0
            }
        }) : (0, (0, parcelRequire("f8Sb3")).css)({
            '& p': {
                fontSize: '1em',
                lineHeight: (0, (0, parcelRequire("iHYdz")).akEditorLineHeight),
                fontWeight: 'normal',
                marginTop: (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin),
                marginBottom: 0,
                letterSpacing: '-0.005em'
            }
        });
    };
});
parcelRegister("bv4Ps", function(module, exports) {
    $parcel$export(module.exports, "ruleSharedStyles", ()=>$f15d364691bf541f$export$329434b3a2da905e);
    var $f8Sb3;
    var $iHYdz;
    const $f15d364691bf541f$export$329434b3a2da905e = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& hr': {
                border: 'none',
                backgroundColor: "var(--ds-border, #091E4224)",
                margin: `${(0, (0, parcelRequire("iHYdz")).akEditorLineHeight)}em 0`,
                height: '2px',
                borderRadius: '1px'
            }
        });
});
parcelRegister("aSoqv", function(module, exports) {
    $parcel$export(module.exports, "shadowSharedStyle", ()=>$0235d3a2f78ffda6$export$985ce3da3286f9ed);
    var $f8Sb3;
    var $iHYdz;
    var $ajc8Z;
    var $bbl9Y;
    const $0235d3a2f78ffda6$var$shadowWidth = 8;
    const $0235d3a2f78ffda6$export$985ce3da3286f9ed = (0, (0, parcelRequire("f8Sb3")).css)({
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::before, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::after, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::before, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::after`]: {
            display: 'none',
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorShadowZIndex),
            width: `${$0235d3a2f78ffda6$var$shadowWidth}px`,
            content: "''",
            height: 'calc(100%)'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}, .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}`]: {
            position: 'relative'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).LEFT_SHADOW}::before`]: {
            background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            top: '0px',
            left: 0,
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("ajc8Z")).shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #091e4229)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
            right: '0px',
            top: '0px',
            display: 'block'
        },
        [`& .${(0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_LEFT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        },
        [`& .${(0, (0, parcelRequire("bbl9Y")).shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: '100%',
            width: '0px',
            minWidth: '0px'
        }
    });
});
parcelRegister("iJOES", function(module, exports) {
    $parcel$export(module.exports, "SmartCardSharedCssClassName", ()=>$bc13534612fcd0a2$export$4ccd31bf665a88f6);
    $parcel$export(module.exports, "smartCardSharedStyles", ()=>$bc13534612fcd0a2$export$83e107f0a431e184);
    var $iHYdz;
    const $bc13534612fcd0a2$export$4ccd31bf665a88f6 = {
        INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
        BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
        EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
        DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
        LOADER_WRAPPER: 'loader-wrapper'
    };
    const $bc13534612fcd0a2$export$83e107f0a431e184 = `
  .${$bc13534612fcd0a2$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;
});
parcelRegister("1bQ0V", function(module, exports) {
    $parcel$export(module.exports, "TaskDecisionSharedCssClassName", ()=>$2398d5ed497032ce$export$a7172b75d403a0e4);
    $parcel$export(module.exports, "tasksAndDecisionsStyles", ()=>$2398d5ed497032ce$export$df437277fbc8b4f5);
    var $f8Sb3;
    var $iHYdz;
    const $2398d5ed497032ce$export$a7172b75d403a0e4 = {
        DECISION_CONTAINER: 'decisionItemView-content-wrap',
        TASK_CONTAINER: 'taskItemView-content-wrap',
        TASK_ITEM: 'task-item'
    };
    const $2398d5ed497032ce$export$df437277fbc8b4f5 = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{.taskItemView-content-wrap,.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellMinWidth), "px;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}}.", $2398d5ed497032ce$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, (0, parcelRequire("iHYdz")).akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");
});
parcelRegister("jRk4M", function(module, exports) {
    $parcel$export(module.exports, "textColorStyles", ()=>$e9c9f96b9e0ca8df$export$a518ea5d00002b38);
    function $e9c9f96b9e0ca8df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e9c9f96b9e0ca8df$export$a518ea5d00002b38 = {
        name: "1nlqh0j",
        styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
    };
});
parcelRegister("fwxzS", function(module, exports) {
    $parcel$export(module.exports, "whitespaceSharedStyles", ()=>$308dad73f97ce24c$export$c9ce3bfa46d7acba);
    function $308dad73f97ce24c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $308dad73f97ce24c$export$c9ce3bfa46d7acba = {
        name: "1s8ykn2",
        styles: "word-wrap:break-word;white-space:pre-wrap"
    };
});
parcelRegister("2o2hu", function(module, exports) {
    $parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", ()=>$67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a);
    $parcel$export(module.exports, "default", ()=>$67d1fb0f1c6fc210$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $iHYdz;
    var $cYeQP;
    var $23OJc;
    var $l8Gxi;
    const $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
    const $67d1fb0f1c6fc210$export$afbde0e7339bed51 = {
        CONTAINER: 'light-weight-code-block'
    };
    const $67d1fb0f1c6fc210$export$3f1ff491ca7c4c4a = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).DOCUMENT, ">.", $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER, " .", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}");
    };
    const $67d1fb0f1c6fc210$var$LightWeightCodeBlock = (0, $5uXOq.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
        const textRows = (0, $5uXOq.useMemo)(()=>(text ?? '').split('\n'), [
            text
        ]);
        const { renderBidiWarnings: renderBidiWarnings } = (0, (0, parcelRequire("23OJc")).useBidiWarnings)({
            enableWarningTooltip: codeBidiWarningTooltipEnabled
        });
        const classNames = [
            $67d1fb0f1c6fc210$export$afbde0e7339bed51.CONTAINER,
            className
        ].join(' ');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: classNames,
            ref: ref,
            css: [
                (0, (0, parcelRequire("cYeQP")).codeBlockSharedStyles)(),
                $67d1fb0f1c6fc210$var$lightWeightCodeBlockStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
        }, textRows.map((_, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                key: index
            }))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("code", null, renderBidiWarnings(text))))));
    });
    var $67d1fb0f1c6fc210$export$2e2bcd8739ae039 = $67d1fb0f1c6fc210$var$LightWeightCodeBlock;
});
parcelRegister("23OJc", function(module, exports) {
    $parcel$export(module.exports, "useBidiWarnings", ()=>$807954ab13bca9b8$export$9fb9fe546a188c7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lrHA4;
    var $fJyLQ;
    var $31cgS;
    const $807954ab13bca9b8$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const warningLabel = intl.formatMessage((0, (0, parcelRequire("fJyLQ")).codeBidiWarningMessages).label);
        const renderBidiWarnings = (text)=>{
            return (0, (0, parcelRequire("31cgS")).default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lrHA4")).default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: warningLabel,
                    tooltipEnabled: enableWarningTooltip
                }));
        };
        return {
            renderBidiWarnings: renderBidiWarnings,
            warningLabel: warningLabel
        };
    };
});
parcelRegister("lrHA4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e6443bd1dfeaac7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $abxiq;
    function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: label,
            tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("abxiq")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("abxiq", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$59fdc1b7b0ae96c9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jldZL;
    const $59fdc1b7b0ae96c9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $829f609a65d26a98$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $59fdc1b7b0ae96c9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("31cgS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e16562bd8c2aca9b$export$2e2bcd8739ae039);
    const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
const $75c933b3daaf1f19$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;
parcelRegister("cWojJ", function(module, exports) {
    $parcel$export(module.exports, "TableHeader", ()=>$decaf4f5703baa00$export$f850895b287ef28e);
    $parcel$export(module.exports, "TableCell", ()=>$decaf4f5703baa00$export$1e4baea7053fc0e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $9UDEr;
    var $hxoiH;
    var $9BYlQ;
    var $hAs1r;
    var $hrpWq;
    var $knXBU;
    var $gkwXh;
    var $l8Gxi;
    var $koVbs;
    var $1Bd5P;
    const $decaf4f5703baa00$var$IgnoreSorting = [
        'LABEL',
        'INPUT'
    ];
    const $decaf4f5703baa00$var$nextStatusOrder = (currentSortOrder)=>{
        switch(currentSortOrder){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
        }
        return (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
    };
    const $decaf4f5703baa00$var$getSortOrderLabel = (intl, currentSortOrder)=>{
        const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, (0, parcelRequire("1Bd5P")).tableCellMessages);
        switch(currentSortOrder){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noneSortingLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascSortingLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descSortingLabel);
            default:
                return intl.formatMessage(noneSortingLabel);
        }
    };
    const $decaf4f5703baa00$var$getDataAttributes = (colwidth, background)=>{
        const attrs = {};
        if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
        if (background) attrs['data-cell-background'] = background;
        return attrs;
    };
    const $decaf4f5703baa00$var$cssVariablePattern = /^var\(--.*\)$/;
    const $decaf4f5703baa00$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
        const style = {};
        if (background && !background.includes('--ds-background-neutral')) {
            const tokenColor = (0, (0, parcelRequire("hAs1r")).hexToEditorBackgroundPaletteRawValue)(background);
            if (tokenColor) style.backgroundColor = tokenColor;
            else if ($decaf4f5703baa00$var$cssVariablePattern.test(background)) style.backgroundColor = background;
            else if (colorMode === 'dark') style.backgroundColor = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(background);
            else style.backgroundColor = background;
        }
        if (colGroupWidth) {
            style.width = colGroupWidth;
            style.minWidth = colGroupWidth;
        }
        if (offsetTop !== undefined) style.top = offsetTop;
        return style;
    };
    const $decaf4f5703baa00$var$getWithCellProps = (WrapperComponent)=>{
        return function WithCellProps(props) {
            const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
            const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
            const colorName = background ? (0, (0, parcelRequire("9UDEr")).tableBackgroundColorPalette).get(background) : '';
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                rowSpan: rowspan,
                colSpan: colspan,
                style: $decaf4f5703baa00$var$getStyle({
                    background: background,
                    colGroupWidth: colGroupWidth,
                    offsetTop: offsetTop,
                    colorMode: colorMode
                }),
                colorname: colorName,
                onClick: onClick,
                className: className,
                ...$decaf4f5703baa00$var$getDataAttributes(colwidth, background),
                "aria-sort": ariaSort
            }, children);
        };
    };
    const $decaf4f5703baa00$var$TH = $decaf4f5703baa00$var$getWithCellProps('th');
    const $decaf4f5703baa00$export$cfca40ca5c56a38e = (WrapperComponent)=>{
        return function THWithSortableColumn(props) {
            const intl = (0, (0, parcelRequire("koVbs")).default)();
            const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
            const sortOrderedClassName = sortOrdered === (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER ? (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
            if (!allowColumnSorting || !isHeaderRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, props);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, {
                ...props,
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
                ariaSort: $decaf4f5703baa00$var$getSortOrderLabel(intl, sortOrdered)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN
            }, children, (0, ($parcel$interopDefault($5uXOq))).createElement("figure", {
                className: `${(0, (0, parcelRequire("l8Gxi")).RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrpWq")).default), {
                isSortingAllowed: !!onSorting,
                sortOrdered: sortOrdered,
                onClick: sort,
                onKeyDown: onKeyPress
            }))));
            function onKeyPress(event) {
                const keys = [
                    ' ',
                    'Enter',
                    'Spacebar'
                ];
                const { tagName: tagName } = event.target;
                if (keys.includes(event.key) && !$decaf4f5703baa00$var$IgnoreSorting.includes(tagName)) {
                    event.preventDefault();
                    sort();
                }
            }
            function sort() {
                const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
                if (onSorting && columnIndex != null) {
                    const sortOrder = $decaf4f5703baa00$var$nextStatusOrder(sortOrdered);
                    onSorting(columnIndex, sortOrder);
                    fireAnalyticsEvent && fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).SORT_COLUMN,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TABLE,
                        attributes: {
                            platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                            mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER,
                            columnIndex: columnIndex,
                            sortOrder: sortOrder
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                    });
                } else fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SORT_COLUMN_NOT_ALLOWED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                });
            }
        };
    };
    const $decaf4f5703baa00$export$f850895b287ef28e = $decaf4f5703baa00$export$cfca40ca5c56a38e($decaf4f5703baa00$var$TH);
    const $decaf4f5703baa00$var$TD = $decaf4f5703baa00$var$getWithCellProps('td');
    const $decaf4f5703baa00$export$1e4baea7053fc0e3 = $decaf4f5703baa00$var$TD;
});
parcelRegister("hrpWq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d33846969f29997f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8RXs9;
    var $VSDnB;
    var $3bDjY;
    var $9BYlQ;
    var $3hakN;
    function $d33846969f29997f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d33846969f29997f$var$annotationRangeFixStyle = {
        name: "oldbq4",
        styles: "user-select:none"
    };
    var $d33846969f29997f$export$c3618f310f725028;
    (function(StatusClassNames) {
        StatusClassNames["ASC"] = "sorting-icon-svg__asc";
        StatusClassNames["DESC"] = "sorting-icon-svg__desc";
        StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
        StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    })($d33846969f29997f$export$c3618f310f725028 || ($d33846969f29997f$export$c3618f310f725028 = {}));
    const $d33846969f29997f$var$buttonStyles = (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F1F2F4);}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
    const $d33846969f29997f$var$iconWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
    const $d33846969f29997f$var$iconStyles = {
        name: "1uj2pwb",
        styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
    };
    const $d33846969f29997f$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
        const activated = sortOrdered !== (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
        const activeStatusClass = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
        if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
            default:
                return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
        }
    };
    const $d33846969f29997f$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, (0, parcelRequire("3hakN")).sortingIconMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return '';
    };
    const $d33846969f29997f$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
        const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, (0, parcelRequire("3hakN")).sortingAriaLabelMessages);
        if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
        switch(sortOrdered){
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER:
                return intl.formatMessage(noOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).ASC:
                return intl.formatMessage(ascOrderLabel);
            case (0, (0, parcelRequire("9BYlQ")).SortOrder).DESC:
                return intl.formatMessage(descOrderLabel);
        }
        return intl.formatMessage(defaultLabel);
    };
    const $d33846969f29997f$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
        const buttonClassName = `${(0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23}__not-allowed `}`;
        const content = $d33846969f29997f$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
        const ariaLabel = $d33846969f29997f$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
        const handleClick = ()=>{
            if (isSortingAllowed) onClick();
        };
        const handleKeyDown = (event)=>{
            if (isSortingAllowed) onKeyDown(event);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            delay: 0,
            content: content,
            position: "top"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d33846969f29997f$var$buttonStyles,
            className: buttonClassName,
            role: "button",
            tabIndex: isSortingAllowed ? 0 : -1,
            "aria-label": ariaLabel,
            "aria-disabled": !isSortingAllowed,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d33846969f29997f$var$iconWrapperStyles,
            className: $d33846969f29997f$var$getIconClassName(isSortingAllowed, sortOrdered)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $d33846969f29997f$var$iconStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_allow_annotation_triple_click') && $d33846969f29997f$var$annotationRangeFixStyle
            ]
        }))));
    };
    var $d33846969f29997f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d33846969f29997f$var$SortingIcon);
});
parcelRegister("3hakN", function(module, exports) {
    $parcel$export(module.exports, "sortingIconMessages", ()=>$c1f584a2cfc01515$export$458c50917513cd1a);
    $parcel$export(module.exports, "sortingAriaLabelMessages", ()=>$c1f584a2cfc01515$export$f142573f51a67577);
    var $7VHMR;
    const $c1f584a2cfc01515$export$458c50917513cd1a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.headingLink.noOrderLabel',
            defaultMessage: 'Sort column A to Z',
            description: 'Sort the column in ascending order'
        },
        ascOrderLabel: {
            id: 'fabric.editor.headingLink.ascOrderLabel',
            defaultMessage: 'Sort column Z to A',
            description: 'Sort the column in descending order'
        },
        descOrderLabel: {
            id: 'fabric.editor.headingLink.descOrderLabel',
            defaultMessage: 'Clear sorting',
            description: 'clear the sorting from this column'
        },
        invalidLabel: {
            id: 'fabric.editor.headingLink.invalidLabel',
            defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
            description: 'this sort is invalid for merged cells'
        }
    });
    const $c1f584a2cfc01515$export$f142573f51a67577 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.no',
            defaultMessage: 'No sort applied to the column',
            description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
        },
        ascOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.asc',
            defaultMessage: 'Ascending sort applied',
            description: 'Aria-label for Sort column button when ascending sorting was applied'
        },
        descOrderLabel: {
            id: 'fabric.editor.tableHeader.sorting.desc',
            defaultMessage: 'Descending sort applied',
            description: 'Aria-label for Sort column button when descending sorting was applied'
        },
        invalidLabel: {
            id: 'fabric.editor.tableHeader.sorting.invalid',
            defaultMessage: `You can't sort a table with merged cells`,
            description: 'Aria-label for Sort column button when sorting is not possible'
        },
        defaultLabel: {
            id: 'fabric.editor.tableHeader.sorting.default',
            defaultMessage: 'Sort the column',
            description: 'Default aria-label for Sort column button'
        }
    });
});
parcelRegister("4BsEy", function(module, exports) {
    $parcel$export(module.exports, "Provider", ()=>$3b927b61a8274f19$export$2881499e37b75b9a);
    $parcel$export(module.exports, "withSmartCardStorage", ()=>$3b927b61a8274f19$export$65e2d5a272a382b0);
    var $5uXOq = parcelRequire("5uXOq");
    const $3b927b61a8274f19$export$841858b892ce1f4c = (0, ($parcel$interopDefault($5uXOq))).createContext(new Map());
    const $3b927b61a8274f19$export$2881499e37b75b9a = function({ children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Provider, {
            value: new Map()
        }, children);
    };
    const $3b927b61a8274f19$export$65e2d5a272a382b0 = (WrappedComponent)=>{
        return class extends (0, ($parcel$interopDefault($5uXOq))).Component {
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement($3b927b61a8274f19$export$841858b892ce1f4c.Consumer, null, (storage)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                        ...this.props,
                        smartCardStorage: storage
                    }));
            }
        };
    };
});
parcelRegister("2aXGN", function(module, exports) {
    $parcel$export(module.exports, "tableStickyPadding", ()=>$9b3e020198447653$export$3de6413b528017ca);
    $parcel$export(module.exports, "StickyTable", ()=>$9b3e020198447653$export$fd9654fc359d55a3);
    $parcel$export(module.exports, "OverflowParent", ()=>$9b3e020198447653$export$e97bc6692974bd0b);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $6gEe5;
    var $iHYdz;
    var $a4mor;
    var $6cOrl;
    function $9b3e020198447653$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9b3e020198447653$export$3de6413b528017ca = 8;
    const $9b3e020198447653$var$modeSpecficStyles = {
        none: {
            name: "eivff4",
            styles: "display:none"
        },
        stick: {
            name: "duudsh",
            styles: "position:fixed"
        },
        'pin-bottom': {
            name: "a4hmbt",
            styles: "position:absolute"
        }
    };
    const $9b3e020198447653$var$fixedTableDivStaticStyles = (top, width, allowTableResizing)=>{
        let stickyHeaderZIndex;
        if (allowTableResizing) stickyHeaderZIndex = 13;
        else stickyHeaderZIndex = (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex);
        return (0, (0, parcelRequire("f8Sb3")).css)(typeof top === 'number' && `top: ${top}px;`, {
            width: `${width}px`,
            zIndex: stickyHeaderZIndex,
            [`& .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
                marginTop: 0,
                marginBottom: 0,
                tr: {
                    background: "var(--ds-surface, white)"
                }
            },
            borderTop: `${$9b3e020198447653$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
            background: "var(--ds-surface-overlay, white)",
            boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
            "div[data-expanded='false'] &": {
                display: 'none'
            },
            [`& .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
                top: '0px',
                height: '100%'
            },
            "&.fixed-table-div-custom-table-resizing[mode='stick']": {
                zIndex: stickyHeaderZIndex
            }
        });
    };
    const $9b3e020198447653$var$FixedTableDiv = (props)=>{
        const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
        const fixedTableCss = [
            $9b3e020198447653$var$fixedTableDivStaticStyles(top, wrapperWidth, allowTableResizing),
            $9b3e020198447653$var$modeSpecficStyles?.[mode]
        ];
        const attrs = {
            mode: mode
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...attrs,
            "data-testid": "sticky-table-fixed",
            className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
            css: fixedTableCss
        }, props.children);
    };
    const $9b3e020198447653$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing })=>{
        let styles;
        if (allowTableResizing) styles = (0, (0, parcelRequire("f8Sb3")).css)({
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'absolute'
        });
        else styles = (0, (0, parcelRequire("f8Sb3")).css)({
            left: left && left < 0 ? left : undefined,
            top: mode === 'pin-bottom' ? top : undefined,
            position: 'relative'
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($9b3e020198447653$var$FixedTableDiv, {
            top: mode === 'stick' ? top : undefined,
            mode: rowHeight > 300 ? 'none' : mode,
            wrapperWidth: wrapperWidth,
            allowTableResizing: allowTableResizing
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
            "data-layout": layout,
            style: {
                width: tableWidth
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            className: `${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
            style: {
                overflow: 'hidden'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a4mor")).Table), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance
        }, (0, (0, parcelRequire("6cOrl")).recursivelyInjectProps)(children, {
            invisible: true
        })))))));
    };
    function $9b3e020198447653$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
        let parent = table;
        if (!parent) return null;
        while(parent = parent.parentElement){
            const style = window.getComputedStyle(parent);
            if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
            if (!!defaultScrollRootId && parent.id === defaultScrollRootId) return parent;
        }
        return null;
    }
    class $9b3e020198447653$export$e97bc6692974bd0b {
        constructor(ref){
            this.ref = ref;
            this.ref = ref;
        }
        static fromElement(el, defaultScrollRootId) {
            return new $9b3e020198447653$export$e97bc6692974bd0b($9b3e020198447653$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
        }
        get isElement() {
            return this.ref instanceof HTMLElement;
        }
        get id() {
            if (this.ref instanceof HTMLElement) return this.ref.id;
            return '';
        }
        get top() {
            if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
            return 0;
        }
        addEventListener(type, cb, ...args) {
            this.ref.addEventListener(type, cb, ...args);
        }
        removeEventListener(type, cb, ...args) {
            this.ref.removeEventListener(type, cb, ...args);
        }
    }
});
parcelRegister("a4mor", function(module, exports) {
    $parcel$export(module.exports, "Table", ()=>$40c6d2c88bc98a0d$export$54ec01a60f47d33d);
    var $5uXOq = parcelRequire("5uXOq");
    var $3nHPA;
    var $fKLIs;
    var $iHYdz;
    const $40c6d2c88bc98a0d$export$54ec01a60f47d33d = (0, ($parcel$interopDefault($5uXOq))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing })=>{
        let tableWidth = tableNode ? (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode) : (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth);
        if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !tableNode.attrs?.width) tableWidth = 'inherit';
        if (rendererAppearance === 'comment' && !allowTableResizing) tableWidth = renderWidth;
        const tableLayout = tableNode?.attrs.layout;
        const tableDisplayMode = tableNode?.attrs.displayMode;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("table", {
            "data-testid": "renderer-table",
            "data-number-column": isNumberColumnEnabled,
            "data-table-width": tableWidth,
            "data-layout": tableLayout,
            "data-table-display-mode": tableDisplayMode,
            ref: innerRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3nHPA")).Colgroup), {
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("tbody", null, children));
    });
});
parcelRegister("3nHPA", function(module, exports) {
    $parcel$export(module.exports, "Colgroup", ()=>$ae0cfecd7422435f$export$89efc2d0ceeaa030);
    var $5uXOq = parcelRequire("5uXOq");
    var $6gEe5;
    var $iHYdz;
    var $gmhCD = parcelRequire("gmhCD");
    var $fKLIs;
    var $VSDnB;
    var $9JDnL;
    var $dyURG;
    const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT = 0.3;
    const $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
    const $ae0cfecd7422435f$var$isTableColumnResized = (columnWidths)=>{
        const filteredWidths = columnWidths.filter((width)=>width !== 0);
        return !!filteredWidths.length;
    };
    const $ae0cfecd7422435f$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
        if (columnWidth === 0) return columnWidth;
        if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, (0, parcelRequire("6gEe5")).tableCellMinWidth));
        return Math.max(columnWidth - (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), zeroWidthColumnsCount ? (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) : (0, (0, parcelRequire("6gEe5")).tableCellMinWidth));
    };
    const $ae0cfecd7422435f$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
        const noNumColumnScalePercent = renderWidth / tableWidth;
        const numColumnScalePercent = (renderWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)) / (tableWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth));
        const diffPercent = 1 - noNumColumnScalePercent;
        return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
    };
    const $ae0cfecd7422435f$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
    const $ae0cfecd7422435f$var$renderScaleDownColgroup = (props)=>{
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer } = props;
        if (!columnWidths) return [];
        const tableColumnResized = $ae0cfecd7422435f$var$isTableColumnResized(columnWidths);
        const noOfColumns = columnWidths.length;
        let targetWidths;
        const isRendererNested = isTopLevelRenderer === false && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_nested_table_in_nested_parent_fix');
        const tableContainerWidth = rendererAppearance === 'comment' && !tableNode?.attrs.width || isRendererNested ? renderWidth : (0, (0, parcelRequire("fKLIs")).getTableContainerWidth)(tableNode);
        if (allowTableResizing && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableColumnResized) {
            const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
            const defaultColumnWidth = tableWidth / noOfColumns;
            targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
        } else if (!tableColumnResized) return null;
        const sumOfColumns = $ae0cfecd7422435f$var$colWidthSum(columnWidths);
        const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
        const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
        if (forceScaleForNumColumn) {
            const scalePercentage = +((tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)) / tableContainerWidth);
            const targetMaxWidth = tableContainerWidth - (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth);
            let totalWidthAfterScale = 0;
            const newScaledTargetWidths = columnWidths.map((width)=>{
                const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
                const newWidth = Math.floor(patchedWidth * scalePercentage);
                totalWidthAfterScale += newWidth;
                return newWidth;
            });
            const diff = targetMaxWidth - totalWidthAfterScale;
            targetWidths = newScaledTargetWidths;
            if (diff > 0 || diff < 0 && Math.abs(diff) < (0, (0, parcelRequire("6gEe5")).tableCellMinWidth)) {
                let updated = false;
                targetWidths = targetWidths.map((width)=>{
                    if (!updated && width + diff > (0, (0, parcelRequire("6gEe5")).tableCellMinWidth)) {
                        updated = true;
                        width += diff;
                    }
                    return width;
                });
            }
        }
        targetWidths = targetWidths || columnWidths;
        const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
        let tableWidth = isNumberColumnEnabled ? (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) : 0;
        let minTableWidth = tableWidth;
        let zeroWidthColumnsCount = 0;
        targetWidths.forEach((width)=>{
            if (width) tableWidth += Math.ceil(width);
            else zeroWidthColumnsCount += 1;
            minTableWidth += Math.ceil(width) || (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth);
        });
        let cellMinWidth = 0;
        let scaleDownPercent = 0;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
        const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $ae0cfecd7422435f$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $ae0cfecd7422435f$var$MAX_SCALING_PERCENT;
        if (zeroWidthColumnsCount > 0) {
            if (minTableWidth > maxTableWidth) {
                const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
                cellMinWidth = minWidth < (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) ? (0, (0, parcelRequire("iHYdz")).akEditorTableLegacyCellMinWidth) : minWidth;
            }
        } else if (renderWidth < tableWidth && !isTableWidthFixed) {
            const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !tableNode?.attrs.width;
            scaleDownPercent = $ae0cfecd7422435f$var$calcScalePercent({
                renderWidth: renderWidth,
                tableWidth: tableWidth,
                maxScale: shouldTable100ScaleDown ? 1 : maxScalingPercent,
                isNumberColumnEnabled: isNumberColumnEnabled
            });
        }
        return targetWidths.map((colWidth)=>{
            const width = $ae0cfecd7422435f$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
            const style = width ? {
                width: `${width}px`
            } : {};
            return style;
        });
    };
    const $ae0cfecd7422435f$export$89efc2d0ceeaa030 = (props)=>{
        const { isTopLevelRenderer: isTopLevelRenderer } = (0, (0, parcelRequire("dyURG")).useRendererContext)();
        let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
        const flags = (0, (0, parcelRequire("9JDnL")).useFeatureFlags)();
        if (!columnWidths) return null;
        const colStyles = $ae0cfecd7422435f$var$renderScaleDownColgroup({
            ...props,
            isTopLevelRenderer: isTopLevelRenderer,
            isTableScalingEnabled: !!(flags && 'tablePreserveWidth' in flags && flags.tablePreserveWidth) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            }) || props.rendererAppearance === 'comment' && (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width')
        });
        if (!colStyles) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("colgroup", null, isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("col", {
            style: {
                width: (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth)
            },
            "data-test-id": 'num'
        }), colStyles.map((style, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement("col", {
                key: idx,
                style: style
            })));
    };
});
parcelRegister("9JDnL", function(module, exports) {
    $parcel$export(module.exports, "useFeatureFlags", ()=>$7cc75954bd6ebac0$export$90335b3ff08f335);
    var $dyURG;
    const $7cc75954bd6ebac0$export$90335b3ff08f335 = ()=>(0, (0, parcelRequire("dyURG")).useRendererContext)()?.featureFlags;
});
parcelRegister("dyURG", function(module, exports) {
    $parcel$export(module.exports, "useRendererContext", ()=>$6d8aa882825f4203$export$a906432540ed7ed8);
    $parcel$export(module.exports, "RendererContextProvider", ()=>$6d8aa882825f4203$export$ca5df47902194781);
    var $5uXOq = parcelRequire("5uXOq");
    const $6d8aa882825f4203$var$RendererContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    const $6d8aa882825f4203$export$a906432540ed7ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext($6d8aa882825f4203$var$RendererContext);
    const $6d8aa882825f4203$export$ca5df47902194781 = $6d8aa882825f4203$var$RendererContext.Provider;
});
parcelRegister("6cOrl", function(module, exports) {
    $parcel$export(module.exports, "recursivelyInjectProps", ()=>$7a2ba32d880ccda8$export$40e12ce8e0a76b0c);
    var $5uXOq = parcelRequire("5uXOq");
    function $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(children, propsToInject) {
        return (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).map((child)=>{
            if (!(0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return child;
            if (child.props.children) child = (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                children: $7a2ba32d880ccda8$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
            });
            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, propsToInject);
        });
    }
});
parcelRegister("kjIja", function(module, exports) {
    $parcel$export(module.exports, "isFullWidthAppearance", ()=>$b5d34963b73650ed$export$c0112b8340d4924b);
    $parcel$export(module.exports, "isFullPageAppearance", ()=>$b5d34963b73650ed$export$a64737a81cde10b4);
    $parcel$export(module.exports, "isCommentAppearance", ()=>$b5d34963b73650ed$export$f77d2ff45b2c53ed);
    $parcel$export(module.exports, "isFullWidthOrFullPageAppearance", ()=>$b5d34963b73650ed$export$33331a99fac775a1);
    const $b5d34963b73650ed$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
    const $b5d34963b73650ed$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
    const $b5d34963b73650ed$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
    const $b5d34963b73650ed$export$33331a99fac775a1 = (appearance)=>$b5d34963b73650ed$export$a64737a81cde10b4(appearance) || $b5d34963b73650ed$export$c0112b8340d4924b(appearance);
});
parcelRegister("eIscD", function(module, exports) {
    $parcel$export(module.exports, "TableStickyScrollbar", ()=>$ea0307076d72d83e$export$8c072780619cfc83);
    var $6gEe5;
    class $ea0307076d72d83e$export$8c072780619cfc83 {
        constructor(wrapper){
            this.sentinels = {};
            this.handleScroll = (event)=>{
                if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
                this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
            };
            this.wrapper = wrapper;
            this.init();
        }
        dispose() {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
            this.deleteIntersectionObserver();
        }
        scrollLeft(left) {
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
        }
        init() {
            if (!this.wrapper) return;
            this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
            if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
                passive: true
            });
            this.createIntersectionObserver();
        }
        createIntersectionObserver() {
            this.rendererScrollableElement = window.document;
            if (!this.rendererScrollableElement || !this.wrapper) return;
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                if (!this.stickyScrollbarContainerElement) return;
                entries.forEach((entry)=>{
                    const target = entry.target;
                    if (target.classList.contains((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                    if (target.classList.contains((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
                });
            }, {
                root: this.rendererScrollableElement
            });
            this.sentinels.bottom = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)?.item(0);
            this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
            [
                this.sentinels.bottom,
                this.sentinels.top
            ].forEach((el)=>this.intersectionObserver.observe(el));
        }
        deleteIntersectionObserver() {
            if (this.intersectionObserver) {
                if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
                this.intersectionObserver.disconnect();
            }
        }
        sentinelBottomCallback(entry) {
            const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0);
            this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
            this.toggle();
        }
        sentinelTopCallback(entry) {
            const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
            this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
            this.toggle();
        }
        toggle() {
            if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
            else this.hide();
        }
        hide() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
        }
        show() {
            if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
        }
    }
});
parcelRegister("i4Lgj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6d6cf54c99dd1cb3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5vnE9;
    var $9BYlQ;
    var $l8Gxi;
    class $6d6cf54c99dd1cb3$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, innerRef: innerRef } = this.props;
            const childrenArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement("tr", {
                ref: innerRef
            }, this.props.isNumberColumnEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement("td", {
                className: (0, (0, parcelRequire("l8Gxi")).RendererCssClassName).NUMBER_COLUMN
            }, this.props.index), (0, (0, parcelRequire("5vnE9")).compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
        }
        constructor(...args){
            super(...args), this.state = {
                colGroupWidths: []
            }, this.addSortableColumn = (childrenArray)=>{
                const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
                if (allowColumnSorting) {
                    const isHeaderRow = !rowIndex;
                    childrenArray = childrenArray.map((child, index)=>{
                        if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) {
                            const { tableOrderStatus: tableOrderStatus } = this.props;
                            let sortOrdered = (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
                            if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, (0, parcelRequire("9BYlQ")).SortOrder).NO_ORDER;
                            return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                                columnIndex: index,
                                onSorting: this.props.onSorting,
                                sortOrdered: sortOrdered,
                                isHeaderRow: isHeaderRow
                            });
                        }
                    });
                }
                return childrenArray;
            }, this.addColGroupWidth = (childrenArray)=>{
                if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                    if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(child)) return (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        colGroupWidth: this.state.colGroupWidths[index]
                    });
                });
                return childrenArray;
            };
        }
    }
});
parcelRegister("gfMkN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5be854e6b8cbd84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $d5be854e6b8cbd84$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "UnknownBlock"
        }, props.children);
    }
});
parcelRegister("9kpKZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5b743bc5ccb58a13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $iHYdz;
    var $eJS47;
    var $3bDjY;
    var $gkwXh;
    var $7R1zM;
    var $d54NZ;
    var $9tFGn;
    const $5b743bc5ccb58a13$var$inlineNodeStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        alignItems: 'center',
        background: "var(--ds-background-disabled, #091E4208)",
        border: `1px dashed ${"var(--ds-border-disabled, #091E420F)"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        cursor: 'default',
        display: 'inline-flex',
        fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
        margin: `0 ${"var(--ds-space-025, 2px)"}`,
        minHeight: '24px',
        padding: `0 ${"var(--ds-space-100, 8px)"}`,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap'
    });
    const $5b743bc5ccb58a13$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const message = (0, (0, parcelRequire("9tFGn")).getUnsupportedContent)((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
        const tooltipContent = intl.formatMessage((0, (0, parcelRequire("7R1zM")).unsupportedContentMessages).unsupportedContentTooltip);
        const { current: style } = (0, $5uXOq.useRef)({
            padding: '4px'
        });
        const originalNodeType = node?.attrs.originalValue.type;
        const tooltipOnShowHandler = (0, $5uXOq.useCallback)(()=>dispatchAnalyticsEvent && (0, (0, parcelRequire("d54NZ")).trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
            dispatchAnalyticsEvent,
            originalNodeType
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5b743bc5ccb58a13$var$inlineNodeStyle
        }, message, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: false,
            position: "bottom",
            onShow: tooltipOnShowHandler,
            strategy: "absolute"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: style
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJS47"))))), {
            label: "?",
            size: "small"
        }))));
    };
    var $5b743bc5ccb58a13$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($5b743bc5ccb58a13$var$UnsupportedInlineNode);
});
parcelRegister("8BH8p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jv5OL").then(()=>parcelRequire('fyj1u'));
});
parcelRegister("6seAF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("27B3z").then(()=>parcelRequire('bO8HO'));
});
parcelRegister("xgpzA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("wQW1L").then(()=>parcelRequire('iLXzZ'));
});
parcelRegister("vMisH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("hY7zf")
    ]).then(()=>parcelRequire('5Y7e4'));
});
parcelRegister("i873P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7lItE").then(()=>parcelRequire('h2Mqp'));
});
parcelRegister("lOJRn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6OdqE").then(()=>parcelRequire('sFJC1'));
});
parcelRegister("6tOdT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8PYkX").then(()=>parcelRequire('4hMem'));
});
parcelRegister("hC3g2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aetML")
    ]).then(()=>parcelRequire('c3ssB'));
});
parcelRegister("j2dSX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9VCdz")
    ]).then(()=>parcelRequire('hibqv'));
});
parcelRegister("7F34O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h0TDs")
    ]).then(()=>parcelRequire('1lkep'));
});
parcelRegister("5yCyD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hLGxH")
    ]).then(()=>parcelRequire('fz1ZD'));
});
parcelRegister("1lRkv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("13w3s")
    ]).then(()=>parcelRequire('lD0Zb'));
});
parcelRegister("hoG8t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("YsZeU")
    ]).then(()=>parcelRequire('gQwn3'));
});
parcelRegister("BpGvF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2Q2XH")
    ]).then(()=>parcelRequire('aPwmB'));
});
parcelRegister("RmF2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4B3Pp")
    ]).then(()=>parcelRequire('ebIkR'));
});
parcelRegister("d6mGh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("c5BYw")
    ]).then(()=>parcelRequire('74PfD'));
});
parcelRegister("lFguI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QV79").then(()=>parcelRequire('9jt2S'));
});
parcelRegister("h4pi8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iJ6aZ")
    ]).then(()=>parcelRequire('V5Yjo'));
});
parcelRegister("dZ3Pj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcqJ9")
    ]).then(()=>parcelRequire('hA9EZ'));
});
parcelRegister("5BLIh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1269296b575a9fc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4dDLS;
    const $e1269296b575a9fc$var$TextWrapper = (props)=>{
        const { startPos: startPos, endPos: endPos } = props;
        const { children: children } = props;
        if (!children) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4dDLS")).TextWithAnnotationDraft), {
            startPos: startPos,
            endPos: endPos,
            textHighlighter: props.textHighlighter,
            marks: props.marks
        }, children);
    };
    var $e1269296b575a9fc$export$2e2bcd8739ae039 = $e1269296b575a9fc$var$TextWrapper;
});
parcelRegister("cKKwC", function(module, exports) {
    $parcel$export(module.exports, "isAnnotationMark", ()=>$d006a5118aec07b0$export$855795c145f03402);
    $parcel$export(module.exports, "default", ()=>$d006a5118aec07b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $88i6h;
    var $5uoEK;
    const $d006a5118aec07b0$export$855795c145f03402 = (mark)=>{
        return mark && mark.type && mark.type.name === 'annotation';
    };
    const $d006a5118aec07b0$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
        const data = {
            ...dataAttributes,
            ...(0, (0, parcelRequire("88i6h")).buildDataAttributes)({
                id: id,
                annotationType: annotationType
            })
        };
        if (allowAnnotations) return isMediaInline ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5uoEK")).MarkElement), {
            id: id,
            dataAttributes: data,
            annotationParentIds: annotationParentIds,
            annotationType: annotationType,
            useBlockLevel: useBlockLevel
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            id: id,
            ...data
        }, children);
    };
    var $d006a5118aec07b0$export$2e2bcd8739ae039 = $d006a5118aec07b0$var$AnnotationComponent;
});
parcelRegister("GDkvY", function(module, exports) {
    $parcel$export(module.exports, "toReact", ()=>$d1627eb50b8d1823$export$d4334b129116aad7);
    var $bVGKe;
    var $lqKi3;
    var $kgK5w;
    var $f14yv;
    var $eVxaj;
    var $gUlHA;
    var $c15YI;
    var $koUAb;
    var $eESZY;
    var $95Yll;
    var $lbdLJ;
    var $9xZ5X;
    var $g5EjF;
    var $acz8Q;
    var $8DQfy;
    var $g9yqu;
    var $cKKwC;
    var $itF0z;
    var $6EeUE;
    const $d1627eb50b8d1823$export$c00d967a0f56fdb7 = {
        code: (0, (0, parcelRequire("bVGKe")).default),
        em: (0, (0, parcelRequire("lqKi3")).default),
        link: (0, (0, parcelRequire("kgK5w")).default),
        strike: (0, (0, parcelRequire("f14yv")).default),
        strong: (0, (0, parcelRequire("eVxaj")).default),
        subsup: (0, (0, parcelRequire("gUlHA")).default),
        textColor: (0, (0, parcelRequire("c15YI")).default),
        backgroundColor: (0, (0, parcelRequire("koUAb")).default),
        underline: (0, (0, parcelRequire("eESZY")).default),
        annotation: (0, (0, parcelRequire("cKKwC")).default),
        border: (0, (0, parcelRequire("itF0z")).default),
        confluenceInlineComment: (0, (0, parcelRequire("6EeUE")).default),
        breakout: (0, (0, parcelRequire("95Yll")).default),
        alignment: (0, (0, parcelRequire("lbdLJ")).default),
        indentation: (0, (0, parcelRequire("9xZ5X")).default),
        unsupportedMark: (0, (0, parcelRequire("g5EjF")).default),
        unsupportedNodeAttribute: (0, (0, parcelRequire("acz8Q")).default),
        dataConsumer: (0, (0, parcelRequire("8DQfy")).default),
        fragment: (0, (0, parcelRequire("g9yqu")).default)
    };
    const $d1627eb50b8d1823$export$d4334b129116aad7 = (mark)=>{
        return $d1627eb50b8d1823$export$c00d967a0f56fdb7[mark.type.name];
    };
});
parcelRegister("bVGKe", function(module, exports) {
    $parcel$export(module.exports, "isCodeMark", ()=>$caa083dc61fd842d$export$86390c02c110ec2f);
    $parcel$export(module.exports, "default", ()=>$caa083dc61fd842d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $O2UjQ;
    var $fJyLQ;
    const $caa083dc61fd842d$export$86390c02c110ec2f = (mark)=>{
        return mark && mark.type && mark.type.name === 'code';
    };
    function $caa083dc61fd842d$export$7cea6ffa7022e85f(props) {
        const codeBidiWarningLabel = props.intl.formatMessage((0, (0, parcelRequire("fJyLQ")).codeBidiWarningMessages).label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("O2UjQ")).default), {
            className: "code",
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
            ...props.dataAttributes
        }, props.children);
    }
    var $caa083dc61fd842d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($caa083dc61fd842d$export$7cea6ffa7022e85f);
});
parcelRegister("O2UjQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c9c981a54265bdd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lrHA4;
    var $31cgS;
    var $lBXbx;
    var $1HkQx;
    const $4c9c981a54265bdd$var$styles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline',
        padding: '2px 0.5ch',
        backgroundColor: `var(${(0, (0, parcelRequire("lBXbx")).VAR_CODE_BG_COLOR)}, ${"var(--ds-background-neutral, #091E420F)"})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderStyle: 'none',
        boxDecorationBreak: 'clone',
        color: "var(--ds-text, #172B4D)",
        font: "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        lineHeight: 'inherit',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    });
    const $4c9c981a54265bdd$var$Code = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Code({ testId: testId, ...props }, ref) {
        const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
        const decoratedChildren = codeBidiWarnings ? (0, (0, parcelRequire("f8Sb3")).jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        }, children) : children;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("code", {
            ref: ref,
            "data-testid": testId,
            css: $4c9c981a54265bdd$var$styles,
            ...otherProps
        }, decoratedChildren));
    }));
    function $4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
        const replacedChildren = (0, ($parcel$interopDefault($5uXOq))).Children.map(children, (childNode)=>{
            if (typeof childNode === 'string') {
                const decorated = (0, (0, parcelRequire("31cgS")).default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lrHA4")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            if ($4c9c981a54265bdd$var$isReactElement(childNode) && childNode.props.children) {
                const newChildNode = (0, ($parcel$interopDefault($5uXOq))).cloneElement(childNode, {
                    children: (0, (0, parcelRequire("f8Sb3")).jsx)($4c9c981a54265bdd$var$RenderCodeChildrenWithBidiWarnings, {
                        codeBidiWarningLabel: codeBidiWarningLabel,
                        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                    }, childNode.props.children)
                });
                return newChildNode;
            }
            return childNode;
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, replacedChildren);
    }
    function $4c9c981a54265bdd$var$isReactElement(child) {
        return !!child.type;
    }
    $4c9c981a54265bdd$var$Code.displayName = 'Code';
    var $4c9c981a54265bdd$export$2e2bcd8739ae039 = $4c9c981a54265bdd$var$Code;
});
parcelRegister("lqKi3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fd21faba719ebab1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $fd21faba719ebab1$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("em", props.dataAttributes, props.children);
    }
});
parcelRegister("kgK5w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9900830cb94354be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $K5Jsy;
    var $knXBU;
    var $gkwXh;
    var $iHvAB;
    var $daJ0i;
    const $9900830cb94354be$var$anchorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '&:hover': {
            color: `var(--ds-link, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(--ds-link-pressed, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
        }
    });
    function $9900830cb94354be$export$2e2bcd8739ae039(props) {
        const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
        const anchorProps = {
            href: href,
            target: target,
            title: href
        };
        if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
        const handler = (0, (0, parcelRequire("K5Jsy")).getEventHandler)(eventHandlers, 'link');
        if (isMediaLink) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, props.children);
        const analyticsData = {
            attributes: {
                location: 'renderer'
            },
            location: 'renderer'
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("daJ0i")).default), {
            data: analyticsData
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iHvAB")).default), {
            css: $9900830cb94354be$var$anchorStyles,
            onClick: (e)=>{
                if (fireAnalyticsEvent) fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).VISITED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).LINK,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                        mode: (0, (0, parcelRequire("knXBU")).MODE).RENDERER
                    }
                });
                if (handler) handler(e, href);
            },
            ...anchorProps,
            ...dataAttributes
        }, props.children));
    }
});
parcelRegister("K5Jsy", function(module, exports) {
    $parcel$export(module.exports, "ADFEncoder", ()=>$75b48ee07210971a$export$bcf771b83128eae7);
    $parcel$export(module.exports, "getText", ()=>$75b48ee07210971a$export$c72d34660a162238);
    $parcel$export(module.exports, "getEventHandler", ()=>$75b48ee07210971a$export$eee20638634729b3);
    $parcel$export(module.exports, "findInTree", ()=>$75b48ee07210971a$export$38b61ebf4950cd39);
    var $kOFhM;
    var $hYNZx;
    function $75b48ee07210971a$var$createEncoder(parser, encoder) {
        return (value)=>encoder.encode(parser.parse(value));
    }
    class $75b48ee07210971a$export$bcf771b83128eae7 {
        constructor(createTransformerWithSchema){
            const transformer = createTransformerWithSchema((0, (0, parcelRequire("kOFhM")).defaultSchema));
            this.encode = $75b48ee07210971a$var$createEncoder(transformer, new (0, (0, parcelRequire("hYNZx")).JSONTransformer)());
        }
    }
    const $75b48ee07210971a$export$c72d34660a162238 = (node)=>{
        return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
    };
    const $75b48ee07210971a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
        return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
    };
    function $75b48ee07210971a$export$38b61ebf4950cd39(element, topElement, evaluate) {
        if (element === topElement) return false;
        if (evaluate(element)) return true;
        if (!element.parentElement) return false;
        return $75b48ee07210971a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
    }
});
parcelRegister("iHvAB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65e7a399613e0863$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $994MI;
    var $g2eZ6;
    var $66xOO;
    var $hTTxJ;
    var $cI2hq;
    const $65e7a399613e0863$var$PACKAGE_DATA = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        componentName: 'linkUrl'
    };
    const $65e7a399613e0863$var$Link = (0, (0, parcelRequire("g2eZ6")).withLinkClickedEvent)('a');
    const $65e7a399613e0863$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
        const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, (0, parcelRequire("cI2hq")).useLinkWarningModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("66xOO")).LinkAnalyticsContext), {
            url: href,
            display: "url"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($65e7a399613e0863$var$Link, {
            "data-testid": testId,
            href: href,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTTxJ")).default), linkWarningModalProps));
    };
    var $65e7a399613e0863$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)($65e7a399613e0863$var$PACKAGE_DATA)($65e7a399613e0863$var$LinkUrl);
});
parcelRegister("g2eZ6", function(module, exports) {
    $parcel$export(module.exports, "fireLinkClickedEvent", ()=>$473b45d487f9fd1b$export$7987de3055fbdcb0);
    $parcel$export(module.exports, "withLinkClickedEvent", ()=>$473b45d487f9fd1b$export$263352d59c0c5966);
    var $5uXOq = parcelRequire("5uXOq");
    var $b6uPu;
    var $4URMI;
    var $fzJZi;
    const $473b45d487f9fd1b$export$cfb45d54e1604f6c = new Map([
        [
            undefined,
            'none'
        ],
        [
            0,
            'left'
        ],
        [
            1,
            'middle'
        ],
        [
            2,
            'right'
        ]
    ]);
    const $473b45d487f9fd1b$export$74743eda5dda3ccf = (e)=>{
        return [
            'alt',
            'ctrl',
            'meta',
            'shift'
        ].filter((key)=>e[`${key}Key`] === true);
    };
    const $473b45d487f9fd1b$var$isContentEditable = (el)=>{
        return el instanceof HTMLElement && el.isContentEditable;
    };
    function $473b45d487f9fd1b$export$d2a83e3b34be812b(e, clickType) {
        const { mac: mac, safari: safari } = (0, (0, parcelRequire("b6uPu")).browser)();
        if ($473b45d487f9fd1b$var$isContentEditable(e.currentTarget) && [
            'left',
            'middle'
        ].includes(clickType)) return 'contentEditable';
        switch(clickType){
            case 'left':
            case 'keyboard':
                {
                    if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                    if (e.shiftKey) {
                        if (safari) return 'alt';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.ctrlKey) {
                        if (mac) return 'clickThrough';
                        return 'clickThroughNewTabOrWindow';
                    }
                    if (e.altKey) return 'alt';
                    const target = e.currentTarget.getAttribute('target');
                    if (target === '_blank') return 'clickThroughNewTabOrWindow';
                    return 'clickThrough';
                }
            case 'middle':
                return 'clickThroughNewTabOrWindow';
            case 'right':
                return 'contextMenu';
        }
        return 'unknown';
    }
    const $473b45d487f9fd1b$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
            action: 'clicked',
            actionSubject: 'link',
            eventType: 'ui',
            attributes: {
                clickType: clickType,
                clickOutcome: clickOutcome,
                keysHeld: keysHeld,
                defaultPrevented: defaultPrevented
            }
        });
    const $473b45d487f9fd1b$export$7fedc699766c16de = (event)=>{
        const isKeyboard = event.nativeEvent.detail === 0;
        const clickType = isKeyboard ? 'keyboard' : $473b45d487f9fd1b$export$cfb45d54e1604f6c.get(event.button);
        if (!clickType) return;
        const clickOutcome = $473b45d487f9fd1b$export$d2a83e3b34be812b(event, clickType);
        const keysHeld = $473b45d487f9fd1b$export$74743eda5dda3ccf(event);
        const defaultPrevented = event.defaultPrevented;
        const linkClickedEventResult = $473b45d487f9fd1b$var$linkClickedEvent({
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        });
        if (event.currentTarget instanceof HTMLAnchorElement) {
            const url = event.currentTarget.href;
            return {
                ...linkClickedEventResult,
                nonPrivacySafeAttributes: {
                    url: url
                }
            };
        } else return linkClickedEventResult;
    };
    const $473b45d487f9fd1b$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
            const payload = $473b45d487f9fd1b$export$7fedc699766c16de(event);
            if (payload) createAnalyticsEvent({
                ...payload,
                ...overrides,
                attributes: {
                    ...payload.attributes,
                    ...overrides?.attributes
                },
                nonPrivacySafeAttributes: {
                    ...payload.nonPrivacySafeAttributes,
                    ...overrides?.nonPrivacySafeAttributes
                }
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
    const $473b45d487f9fd1b$var$getDisplayName = (WrappedComponent)=>{
        if (typeof WrappedComponent === 'string') return WrappedComponent;
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    };
    function $473b45d487f9fd1b$export$263352d59c0c5966(WrappedComponent) {
        const Component = (props)=>{
            const onClick = (0, (0, parcelRequire("4URMI")).useLinkClicked)(props.onClick);
            const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)(props.onMouseDown);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                onClick: onClick,
                onMouseDown: onMouseDown
            });
        };
        Component.displayName = `withLinkClickedEvent(${$473b45d487f9fd1b$var$getDisplayName(WrappedComponent)})`;
        return Component;
    }
});
parcelRegister("b6uPu", function(module, exports) {
    $parcel$export(module.exports, "browser", ()=>$7f7209ce5c1e8d08$export$3f2684e5d7cb1006);
    const $7f7209ce5c1e8d08$var$result = {
        mac: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    if (typeof navigator !== 'undefined') {
        const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
        const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
        const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.mac = /Mac/.test(navigator.platform);
        let ie = $7f7209ce5c1e8d08$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
        $7f7209ce5c1e8d08$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
        $7f7209ce5c1e8d08$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
        $7f7209ce5c1e8d08$var$result.android = /Android \d/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
        $7f7209ce5c1e8d08$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
        $7f7209ce5c1e8d08$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
        $7f7209ce5c1e8d08$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
        $7f7209ce5c1e8d08$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
    }
    function $7f7209ce5c1e8d08$export$3f2684e5d7cb1006() {
        return $7f7209ce5c1e8d08$var$result;
    }
});
parcelRegister("4URMI", function(module, exports) {
    $parcel$export(module.exports, "useLinkClicked", ()=>$0d5ea96be37e2b5d$export$5993d3ca6c85f774);
    $parcel$export(module.exports, "useMouseDownEvent", ()=>$0d5ea96be37e2b5d$export$df67f318ded0283c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $g2eZ6;
    var $0d5ea96be37e2b5d$export$81a5b494baf0f17c;
    (function(ClickButton) {
        ClickButton[ClickButton["Left"] = 0] = "Left";
        ClickButton[ClickButton["Middle"] = 1] = "Middle";
        ClickButton[ClickButton["Right"] = 2] = "Right";
    })($0d5ea96be37e2b5d$export$81a5b494baf0f17c || ($0d5ea96be37e2b5d$export$81a5b494baf0f17c = {}));
    const $0d5ea96be37e2b5d$export$5993d3ca6c85f774 = (handler, predicate)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)((...args)=>{
            const [event] = args;
            handler?.apply(null, args);
            if (!predicate || predicate?.(event)) (0, (0, parcelRequire("g2eZ6")).fireLinkClickedEvent)(createAnalyticsEvent)(event);
        }, [
            handler,
            predicate,
            createAnalyticsEvent
        ]);
    };
    const $0d5ea96be37e2b5d$var$isNotLeftClick = (event)=>event.button !== 0;
    const $0d5ea96be37e2b5d$export$df67f318ded0283c = (onMouseDown)=>{
        return $0d5ea96be37e2b5d$export$5993d3ca6c85f774(onMouseDown, $0d5ea96be37e2b5d$var$isNotLeftClick);
    };
});
parcelRegister("fzJZi", function(module, exports) {
    $parcel$export(module.exports, "ANALYTICS_CHANNEL", ()=>$3b4d25437cc28513$export$85183a312807388d);
    $parcel$export(module.exports, "context", ()=>$3b4d25437cc28513$export$a078c61943f9dbbe);
    $parcel$export(module.exports, "TrackQuickActionType", ()=>$3b4d25437cc28513$export$72af824fa910c33e);
    $parcel$export(module.exports, "TrackQuickActionFailureReason", ()=>$3b4d25437cc28513$export$c89e475f7f7174c2);
    $parcel$export(module.exports, "SmartLinkEvents", ()=>$3b4d25437cc28513$export$b91e0203b928470c);
    $parcel$export(module.exports, "resolvedEvent", ()=>$3b4d25437cc28513$export$e2e1bab8375c3115);
    $parcel$export(module.exports, "unresolvedEvent", ()=>$3b4d25437cc28513$export$331b399cdebbb8d4);
    $parcel$export(module.exports, "invokeSucceededEvent", ()=>$3b4d25437cc28513$export$237caeb1002642ba);
    $parcel$export(module.exports, "invokeFailedEvent", ()=>$3b4d25437cc28513$export$ac488bf3e4c7f93);
    $parcel$export(module.exports, "connectSucceededEvent", ()=>$3b4d25437cc28513$export$5f549b8ba38f19b1);
    $parcel$export(module.exports, "connectFailedEvent", ()=>$3b4d25437cc28513$export$fdfcba182edbb89a);
    $parcel$export(module.exports, "uiAuthEvent", ()=>$3b4d25437cc28513$export$5318734335f1d8b8);
    $parcel$export(module.exports, "uiAuthAlternateAccountEvent", ()=>$3b4d25437cc28513$export$14f2ce8523ccb652);
    $parcel$export(module.exports, "uiCardClickedEvent", ()=>$3b4d25437cc28513$export$8b5d1f55370347a1);
    $parcel$export(module.exports, "uiActionClickedEvent", ()=>$3b4d25437cc28513$export$e00b9d79d3367530);
    $parcel$export(module.exports, "uiClosedAuthEvent", ()=>$3b4d25437cc28513$export$fe5b1f066ca3365d);
    $parcel$export(module.exports, "uiRenderSuccessEvent", ()=>$3b4d25437cc28513$export$bd308326cf1076aa);
    $parcel$export(module.exports, "uiRenderFailedEvent", ()=>$3b4d25437cc28513$export$1543b6391f48a5e2);
    $parcel$export(module.exports, "uiHoverCardViewedEvent", ()=>$3b4d25437cc28513$export$e80a2f97cccab3b1);
    $parcel$export(module.exports, "uiHoverCardDismissedEvent", ()=>$3b4d25437cc28513$export$3d10c6f90bc461d3);
    $parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", ()=>$3b4d25437cc28513$export$ad3275d7dff50d21);
    $parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", ()=>$3b4d25437cc28513$export$925348ae8d2e0bf3);
    $parcel$export(module.exports, "chunkloadFailedEvent", ()=>$3b4d25437cc28513$export$2b6bbed3753f06f9);
    $parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", ()=>$3b4d25437cc28513$export$94c3643533642ab);
    $parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", ()=>$3b4d25437cc28513$export$18dfe458db0b743d);
    $parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", ()=>$3b4d25437cc28513$export$9a352e2e15b3de89);
    $parcel$export(module.exports, "uiServerActionClicked", ()=>$3b4d25437cc28513$export$a66dc699502b5d28);
    var $T540Y;
    var $5vDFA;
    const $3b4d25437cc28513$export$85183a312807388d = 'media';
    const $3b4d25437cc28513$export$a078c61943f9dbbe = {
        componentName: 'smart-cards',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    var $3b4d25437cc28513$export$72af824fa910c33e;
    (function(TrackQuickActionType) {
        TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    })($3b4d25437cc28513$export$72af824fa910c33e || ($3b4d25437cc28513$export$72af824fa910c33e = {}));
    var $3b4d25437cc28513$export$c89e475f7f7174c2;
    (function(TrackQuickActionFailureReason) {
        TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
        TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
        TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    })($3b4d25437cc28513$export$c89e475f7f7174c2 || ($3b4d25437cc28513$export$c89e475f7f7174c2 = {}));
    const $3b4d25437cc28513$export$bbd674aacb40a160 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'Follow',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
    };
    const $3b4d25437cc28513$export$baf70a532f8c6fa6 = {
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
        [(0, (0, parcelRequire("T540Y")).SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
    };
    const $3b4d25437cc28513$var$uiActionSubjectIds = {
        DownloadAction: 'downloadDocument',
        PreviewAction: 'invokePreviewScreen',
        ViewAction: 'shortcutGoToLink',
        StatusAction: 'issueStatusUpdate'
    };
    class $3b4d25437cc28513$export$b91e0203b928470c {
        insertSmartLink(url, type, createAnalyticsEvent) {
            $3b4d25437cc28513$export$2a123f7ee48a122c({
                action: 'inserted',
                actionSubject: 'smartLink',
                eventType: 'track',
                attributes: {
                    type: type
                },
                nonPrivacySafeAttributes: {
                    domainName: url
                }
            }, createAnalyticsEvent);
        }
    }
    const $3b4d25437cc28513$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
        if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($3b4d25437cc28513$export$85183a312807388d);
    };
    const $3b4d25437cc28513$export$e2e1bab8375c3115 = (props)=>({
            action: 'resolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...props,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
            action: 'unresolved',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                id: id,
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                ...definitionId ? {
                    definitionId: definitionId
                } : {},
                ...extensionKey ? {
                    extensionKey: extensionKey
                } : {},
                ...resourceType ? {
                    resourceType: resourceType
                } : {},
                ...destinationSubproduct ? {
                    destinationSubproduct: destinationSubproduct
                } : {},
                ...destinationProduct ? {
                    destinationProduct: destinationProduct
                } : {},
                ...location ? {
                    location: location
                } : {},
                reason: status,
                error: error ? {
                    message: error?.message,
                    kind: error?.kind,
                    type: error?.type
                } : undefined
            }
        });
    const $3b4d25437cc28513$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'resolved') : undefined;
        return {
            action: 'resolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                extensionKey: extensionKey,
                duration: measure?.duration
            }
        };
    };
    const $3b4d25437cc28513$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
        const measure = id ? (0, (0, parcelRequire("5vDFA")).getMeasure)(id, 'errored') : undefined;
        return {
            action: 'unresolved',
            actionSubject: 'smartLinkAction',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                duration: measure?.duration,
                reason: reason
            }
        };
    };
    const $3b4d25437cc28513$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'connectSucceeded',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
            action: 'connectFailed',
            actionSubject: 'smartLink',
            actionSubjectId: reason,
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                reason: reason,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'connectAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'tryAnotherAccount',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                definitionId: definitionId,
                extensionKey: extensionKey,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: actionSubjectId,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                status: status,
                definitionId: definitionId,
                extensionKey: extensionKey,
                display: display,
                isModifierKeyPressed: isModifierKeyPressed,
                location: location,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct
            }
        });
    const $3b4d25437cc28513$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$var$uiActionSubjectIds[actionType],
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                display: display,
                actionType: actionType,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'closed',
            actionSubject: 'consentModal',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display
            }
        });
    const $3b4d25437cc28513$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
            action: 'renderSuccess',
            actionSubject: 'smartLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                display: display,
                canBeDatasource: canBeDatasource
            }
        });
    const $3b4d25437cc28513$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            actionSubject: 'smartLink',
            action: 'renderFailed',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'viewed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
            action: 'dismissed',
            actionSubject: 'hoverCard',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                hoverTime: hoverTime,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod,
                status: status
            }
        });
    const $3b4d25437cc28513$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'shortcutGoToLink',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                id: id,
                previewDisplay: previewDisplay,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                previewInvokeMethod: previewInvokeMethod
            }
        });
    const $3b4d25437cc28513$export$925348ae8d2e0bf3 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'learnMore',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
            action: 'chunkLoadFailed',
            actionSubject: 'smartLink',
            eventType: 'operational',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe,
                error: error,
                errorInfo: errorInfo,
                display: display,
                extensionKey: extensionKey,
                definitionId: definitionId,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            }
        });
    const $3b4d25437cc28513$export$94c3643533642ab = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusLozenge',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$18dfe458db0b743d = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusListItem',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$9a352e2e15b3de89 = ()=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'smartLinkStatusOpenPreview',
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
    const $3b4d25437cc28513$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $3b4d25437cc28513$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
            eventType: 'ui',
            attributes: {
                ...$3b4d25437cc28513$export$a078c61943f9dbbe
            }
        });
});
parcelRegister("T540Y", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkActionType", ()=>$171ae91e706973ef$export$6324b7946ad663e9);
    $parcel$export(module.exports, "InvokeError", ()=>$171ae91e706973ef$export$d4d72202bff63658);
    var $171ae91e706973ef$export$6324b7946ad663e9;
    (function(SmartLinkActionType) {
        SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
        SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
        SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
        SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
    })($171ae91e706973ef$export$6324b7946ad663e9 || ($171ae91e706973ef$export$6324b7946ad663e9 = {}));
    class $171ae91e706973ef$export$d4d72202bff63658 extends Error {
        constructor(message, errorCode){
            super(message);
            this.errorCode = errorCode;
        }
    }
});
parcelRegister("5vDFA", function(module, exports) {
    $parcel$export(module.exports, "clearMarks", ()=>$483ef2a5b4b04745$export$1a717feb4df1a945);
    $parcel$export(module.exports, "clearMeasures", ()=>$483ef2a5b4b04745$export$de42547d395c8271);
    $parcel$export(module.exports, "getMeasure", ()=>$483ef2a5b4b04745$export$d6e97a903ae9a3aa);
    $parcel$export(module.exports, "mark", ()=>$483ef2a5b4b04745$export$bf7f2fce5c1cf636);
    $parcel$export(module.exports, "create", ()=>$483ef2a5b4b04745$export$185802fd694ee1f5);
    const $483ef2a5b4b04745$var$isPerformanceAPIAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && [
            'measure',
            'clearMeasures',
            'clearMarks',
            'getEntriesByName',
            'getEntriesByType'
        ].every((api)=>!!performance[api]);
    };
    const $483ef2a5b4b04745$var$hasPerformanceAPIAvailable = $483ef2a5b4b04745$var$isPerformanceAPIAvailable();
    const $483ef2a5b4b04745$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
    const $483ef2a5b4b04745$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
    const $483ef2a5b4b04745$export$1a717feb4df1a945 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
            marks.forEach((mark)=>performance.clearMarks(mark.name));
        }
    };
    const $483ef2a5b4b04745$export$de42547d395c8271 = (id)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
            measures.forEach((measure)=>performance.clearMeasures(measure.name));
        }
    };
    const $483ef2a5b4b04745$var$getMark = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            const marks = performance.getEntriesByName(name);
            if (marks.length > 0) return marks[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$d6e97a903ae9a3aa = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measures = performance.getEntriesByName(name);
            if (measures.length > 0) return measures[0];
            return undefined;
        }
    };
    const $483ef2a5b4b04745$export$bf7f2fce5c1cf636 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$fcff3185c7ce7f2b(id, status);
            performance.mark(name);
        }
    };
    const $483ef2a5b4b04745$export$185802fd694ee1f5 = (id, status)=>{
        if ($483ef2a5b4b04745$var$hasPerformanceAPIAvailable) {
            const name = $483ef2a5b4b04745$export$984df7f61dd7928f(id, status);
            const measure = $483ef2a5b4b04745$export$d6e97a903ae9a3aa(id, status);
            if (!measure) {
                const startMark = $483ef2a5b4b04745$var$getMark(id, 'pending');
                const endMark = $483ef2a5b4b04745$var$getMark(id, status);
                if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
            }
        }
    };
});
parcelRegister("66xOO", function(module, exports) {
    $parcel$export(module.exports, "LinkAnalyticsContext", ()=>$a51765c35bf0b052$export$9458cdec663b9ff1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    const $a51765c35bf0b052$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
        const displayCategory = display === 'url' ? 'link' : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: {
                source: source,
                attributes: {
                    displayCategory: displayCategory,
                    display: display,
                    id: id
                }
            }
        }, children);
    };
});
parcelRegister("hTTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ef61591d3052acd$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $8RXs9;
    var $i5FdW;
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $7zaVw;
    var $5joKY;
    const $6ef61591d3052acd$var$WarningModal = (props)=>{
        const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            testId: "link-with-safety-warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jgVsb")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).check_this_link))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7QSqG")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("5joKY")).breakWordsCss)
        }, url && unsafeLinkText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("7zaVw")).messages).link_safety_warning_message,
            values: {
                unsafeLinkText: unsafeLinkText,
                a: ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                        href: url,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, url)
            }
        }))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("juxqI")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            onClick: onClose
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).go_back)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "warning",
            onClick: onContinue,
            autoFocus: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).continue)))));
        return intl ? content : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, content);
    };
    var $6ef61591d3052acd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($6ef61591d3052acd$var$WarningModal, {
        enforceContext: false
    });
});
parcelRegister("7zaVw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a298b78183f16654$export$defe85febe8b728c);
    var $7VHMR;
    const $a298b78183f16654$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actions: {
            id: 'fabric.linking.actions',
            defaultMessage: 'Actions',
            description: ''
        },
        add_account: {
            id: 'fabric.linking.add_account',
            defaultMessage: 'Add account',
            description: 'Allows to add a new account'
        },
        ai_summarize: {
            id: 'fabric.linking.ai_summarize',
            defaultMessage: 'Summarize',
            description: 'Action to summarize link resource content with AI'
        },
        ai_summarized: {
            id: 'fabric.linking.ai_summarized',
            defaultMessage: 'Summarized by Atlassian Intelligence',
            description: 'Shown with the content summarised by AI.'
        },
        ai_summarized_abbreviation: {
            id: 'fabric.linking.ai_summarized_abbreviation',
            defaultMessage: 'Summarized by AI',
            description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
        },
        ai_summarized_info: {
            id: 'fabric.linking.ai_summarized_info',
            defaultMessage: 'Information quality may vary. <a>Learn more</a>',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarized_info_short: {
            id: 'fabric.linking.ai_summarized_info_short',
            defaultMessage: 'Content quality may vary',
            description: 'Additional info about the content summarised by AI.'
        },
        ai_summarizing: {
            id: 'fabric.linking.ai_summarizing',
            defaultMessage: 'Atlassian Intelligence is working...',
            description: 'Shown when AI summary is summarising the link resource content.'
        },
        ai_summary_error_generic: {
            id: 'fabric.linking.ai_summary_error_generic',
            defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
            description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
        },
        ai_summary_error_acceptable_use_violation: {
            id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
            defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
            description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
        },
        ai_summary_error_hipaa_content_detected: {
            id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
            defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
            description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
        },
        ai_summary_error_exceeding_context_length_error: {
            id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
            defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
            description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
        },
        assigned_to: {
            id: 'fabric.linking.assigned_to',
            defaultMessage: 'Assigned to {context}',
            description: 'Indicates the person or entity that the resource is assigned to.'
        },
        automation_action_title: {
            id: 'fabric.linking.automation-action.title',
            defaultMessage: 'View automation rules',
            description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
        },
        automation_action_icon_label: {
            id: 'fabric.linking.automation-action.icon.label',
            defaultMessage: 'Automation icon',
            description: 'The label for the automation icon inside of the button opening the automation menu.'
        },
        automation_action_tooltip: {
            id: 'fabric.linking.automation-action.tooltip',
            defaultMessage: 'Select an automation rule to run',
            description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
        },
        automation_action_confluence_page_modal_title: {
            id: 'fabric.linking.automation-action.confluence.page.modal.title',
            defaultMessage: 'Page automations',
            description: 'The title of the automation modal when the SmartLink is a Confluence page'
        },
        automation_action_confluence_page_modal_description: {
            id: 'fabric.linking.automation-action.confluence.page.modal.description',
            defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
            description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
        },
        cancel: {
            id: 'fabric.linking.cancel',
            defaultMessage: 'Cancel',
            description: 'cancel'
        },
        beta: {
            id: 'fabric.linking.beta',
            defaultMessage: 'Beta',
            description: 'Indicates a beta phase of the feature.'
        },
        cannot_connect: {
            id: 'fabric.linking.cannot_connect',
            defaultMessage: "Can't connect, try again",
            description: 'Error for when a provided link is not found.'
        },
        cannot_find_link: {
            id: 'fabric.linking.cannot_find_link',
            defaultMessage: "Can't find link",
            description: 'Error for when a provided link is not found.'
        },
        click_to_join: {
            id: 'fabric.linking.click_to_join',
            defaultMessage: 'Join {context}',
            description: 'Allows the user join the product or service immediately'
        },
        click_to_join_description: {
            id: 'fabric.linking.click_to_join_description',
            defaultMessage: "You've been approved, so you can join {context} right away.",
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        close: {
            id: 'fabric.linking.close',
            defaultMessage: 'Close',
            description: ''
        },
        check_this_link: {
            id: 'fabric.linking.check_this_link',
            defaultMessage: 'Check this link',
            description: 'Link safety warning modal header'
        },
        connect_to: {
            id: 'fabric.linking.connect_to',
            defaultMessage: 'Connect to {name}',
            description: 'Allows the user to connect with different types of external services'
        },
        connect_account_description: {
            id: 'fabric.linking.connect_account_description',
            defaultMessage: "We'll open a new page to help you connect your {name} account",
            description: 'Explains what will happen when the users connects to a new account'
        },
        connect_link_account: {
            id: 'fabric.linking.connect_link_account',
            defaultMessage: 'Connect to preview',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
        },
        connect_link_account_card: {
            id: 'fabric.linking.connect_link_account_card_view',
            defaultMessage: 'Connect',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_link_account_card_name: {
            id: 'fabric.linking.connect_link_account_card_view_name',
            defaultMessage: 'Connect your {context} account',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
        },
        connect_link_account_card_description: {
            id: 'fabric.linking.connect_link_account_card_view_description',
            defaultMessage: 'To show a preview of this link, connect your {context} account.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
        },
        connect_unauthorised_account_action: {
            id: 'fabric.linking.connect_unauthorised_account_action',
            defaultMessage: 'Connect to {context}',
            description: 'Shown on a button to connect user external account to their Atlassian account.'
        },
        connect_unauthorised_account_description: {
            id: 'fabric.linking.connect_unauthorised_account_description',
            defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
        },
        connect_unauthorised_account_description_no_provider: {
            id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
            defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
            description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
        },
        continue: {
            id: 'fabric.linking.continue',
            defaultMessage: 'Continue',
            description: 'continue'
        },
        copy_url_to_clipboard: {
            id: 'fabric.linking.copy_url_to_clipboard',
            defaultMessage: 'Copy link',
            description: ''
        },
        copied_url_to_clipboard: {
            id: 'fabric.linking.copied_url_to_clipboard',
            defaultMessage: 'Copied!',
            description: 'Url has been copied to the clipboard'
        },
        could_not_load_link: {
            id: 'fabric.linking.couldnt_load_link',
            defaultMessage: "We couldn't load this link for an unknown reason.",
            description: 'Error case for card view - link could not be loaded.'
        },
        created_by: {
            id: 'fabric.linking.created_by',
            defaultMessage: 'Created by {context}',
            description: 'Indicates the person or entity that created the resource.'
        },
        created_on_relative: {
            id: 'fabric.linking.create_on_relative',
            defaultMessage: 'Created {context}',
            description: 'Indicated when entity was created (relative form)'
        },
        created_on_absolute: {
            id: 'fabric.linking.create_on_absolute',
            defaultMessage: 'Created on {context}',
            description: 'Indicated when entity was created (absolute form)'
        },
        delete: {
            id: 'fabric.linking.delete',
            defaultMessage: 'Delete',
            description: 'Allow a user to delete a link'
        },
        download: {
            id: 'fabric.linking.download',
            defaultMessage: 'Download',
            description: ''
        },
        download_description: {
            id: 'fabric.linking.download_description',
            defaultMessage: 'Download this file into your local storage',
            description: 'Description on what Download does'
        },
        download_file: {
            id: 'fabric.linking.download_file',
            defaultMessage: 'Download file',
            description: 'Allow a user to download a file'
        },
        ai_summary_action: {
            id: 'fabric.linking.ai_summary_action',
            defaultMessage: 'Summarize with AI',
            description: 'Allow a user to summarize a link'
        },
        ai_summary_action_description: {
            id: 'fabric.linking.ai_summary_action_description',
            defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
            description: 'Description of what the summarize link with AI action does'
        },
        copy_summary_action: {
            id: 'fabric.linking.copy_summary_action',
            defaultMessage: 'Copy summary',
            description: 'Allow a user to copy a generated summary'
        },
        copy_summary_action_description: {
            id: 'fabric.linking.copy_summary_action_description',
            defaultMessage: 'Copy summary',
            description: 'Description of what the copy summary AI action does'
        },
        copied_summary_action_description: {
            id: 'fabric.linking.copied_summary_action_description',
            defaultMessage: 'Copied summary to clipboard',
            description: 'Confirmation to the user that the summry has been copied'
        },
        edit: {
            id: 'fabric.linking.edit',
            defaultMessage: 'Edit',
            description: 'Allow a user to edit a link'
        },
        follow: {
            id: 'fabric.linking.follow',
            defaultMessage: 'Follow',
            description: 'Click to follow a project.'
        },
        follow_project_description: {
            id: 'fabric.linking.follow_project_description',
            defaultMessage: 'Follow to get notifications on this project',
            description: 'Description on what Follow does'
        },
        follow_project: {
            id: 'fabric.linking.follow_project',
            defaultMessage: 'Follow project',
            description: 'Click to follow a project.'
        },
        follow_project_error: {
            id: 'fabric.linking.follow_project_error',
            defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas project'
        },
        follow_goal_description: {
            id: 'fabric.linking.follow_goal_description',
            defaultMessage: 'Follow this goal to get notifications on updates',
            description: 'Description on what Follow does'
        },
        follow_goal: {
            id: 'fabric.linking.follow_goal',
            defaultMessage: 'Follow goal',
            description: 'Click to follow a project.'
        },
        follow_goal_error: {
            id: 'fabric.linking.follow_goal_error',
            defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when following an Atlas goal'
        },
        go_back: {
            id: 'fabric.linking.go_back',
            defaultMessage: 'Go back',
            description: 'go back'
        },
        invalid_permissions: {
            id: 'fabric.linking.invalid_permissions',
            defaultMessage: 'Restricted content',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        invalid_permissions_description: {
            id: 'fabric.linking.invalid_permissions_description',
            defaultMessage: "You'll need to request access or try a different account to view this preview.",
            description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
        },
        join_to_view: {
            id: 'fabric.linking.join_to_view',
            defaultMessage: 'Join {context} to view this issue',
            description: 'Allows the user join the product or service immediately'
        },
        learn_more_about_smart_links: {
            id: 'fabric.linking.learn_more_about_smart_links',
            defaultMessage: 'Learn more about Smart Links.',
            description: 'An anchor link to redirect user to a page about Smart Links.'
        },
        learn_more_about_connecting_account: {
            id: 'fabric.linking.learn_more_about_connecting_account',
            defaultMessage: 'Learn more about connecting your account to Atlassian products.',
            description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
        },
        loading: {
            id: 'fabric.linking.loading',
            defaultMessage: 'Loading...',
            description: 'Indicates an element on a page is loading.'
        },
        modified_by: {
            id: 'fabric.linking.updated_by',
            defaultMessage: 'Modified by {context}',
            description: 'Indicates the person or entity that modified the resource.'
        },
        modified_on_relative: {
            id: 'fabric.linking.modified_on_relative',
            defaultMessage: 'Updated {context}',
            description: 'Indicated when entity was modified (relative form)'
        },
        modified_on_absolute: {
            id: 'fabric.linking.modified_on_absolute',
            defaultMessage: 'Updated on {context}',
            description: 'Indicated when entity was modified (absolute form)'
        },
        more_actions: {
            id: 'fabric.linking.more_actions',
            defaultMessage: 'More actions',
            description: 'Allows the users to see more link actions'
        },
        open_issue_in_jira: {
            id: 'fabric.linking.open_issue_in_jira',
            defaultMessage: 'Open issue in Jira',
            description: 'Click to open link in Jira'
        },
        open_link_in_a_new_tab: {
            id: 'fabric.linking.open_link_in_a_new_tab',
            defaultMessage: 'Open link in a new tab',
            description: 'Click to open link in a new tab'
        },
        owned_by: {
            id: 'fabric.linking.owned_by',
            defaultMessage: 'Owned by {context}',
            description: 'Indicates the person or entity that owns or maintains the resource.'
        },
        preview_description: {
            id: 'fabric.linking.preview_description',
            defaultMessage: 'Open a full screen preview of this link',
            description: 'Description on what Preview does'
        },
        preview_improved: {
            id: 'fabric.linking.preview_improved',
            defaultMessage: 'Open preview',
            description: 'Click to view a richer view of your content, without needing to navigate to it.'
        },
        preview_close: {
            id: 'fabric.linking.preview_close',
            defaultMessage: 'Close preview',
            description: 'Click to close embed preview modal.'
        },
        preview_max_size: {
            id: 'fabric.linking.preview_max_size',
            defaultMessage: 'View full screen',
            description: 'Click to increase embed preview modal size to a maximum viewing size.'
        },
        preview_min_size: {
            id: 'fabric.linking.preview_min_size',
            defaultMessage: 'Close full screen',
            description: 'Click to decrease embed preview modal size to a minimum viewing size.'
        },
        priority_blocker: {
            id: 'fabric.linking.priority_blocker',
            defaultMessage: 'Blocker',
            description: 'Indicated priority as blocker'
        },
        priority_critical: {
            id: 'fabric.linking.priority_critical',
            defaultMessage: 'Critical',
            description: 'Indicated priority as critical'
        },
        priority_high: {
            id: 'fabric.linking.priority_high',
            defaultMessage: 'High',
            description: 'Indicated priority as high'
        },
        priority_highest: {
            id: 'fabric.linking.priority_highest',
            defaultMessage: 'Highest',
            description: 'Indicated priority as highest'
        },
        priority_low: {
            id: 'fabric.linking.priority_low',
            defaultMessage: 'Low',
            description: 'Indicated priority as low'
        },
        priority_lowest: {
            id: 'fabric.linking.priority_lowest',
            defaultMessage: 'Lowest',
            description: 'Indicated priority as lowest'
        },
        priority_major: {
            id: 'fabric.linking.priority_major',
            defaultMessage: 'Major',
            description: 'Indicated priority as major'
        },
        priority_medium: {
            id: 'fabric.linking.priority_medium',
            defaultMessage: 'Medium',
            description: 'Indicated priority as medium'
        },
        priority_minor: {
            id: 'fabric.linking.priority_minor',
            defaultMessage: 'Minor',
            description: 'Indicated priority as minor'
        },
        priority_trivial: {
            id: 'fabric.linking.priority_trivial',
            defaultMessage: 'Trivial',
            description: 'Indicated priority as trivial'
        },
        priority_undefined: {
            id: 'fabric.linking.priority_undefined',
            defaultMessage: 'Undefined',
            description: 'Indicated priority as unknown'
        },
        forbidden_access: {
            id: 'fabric.linking.forbidden_access',
            defaultMessage: 'Your access is forbidden',
            description: 'Shown when a user does not have access to a resource behind the link.'
        },
        pending_request: {
            id: 'fabric.linking.pending_request',
            defaultMessage: 'Your access request is pending',
            description: 'Shown when a user has requested an access but status is pending.'
        },
        read_time: {
            id: 'fabric.linking.read_time',
            defaultMessage: '{context} min read',
            description: 'Estimated time to read this resource'
        },
        restricted_link: {
            id: 'fabric.linking.restricted_link',
            defaultMessage: 'Restricted link, try another account',
            description: 'Message shown when a user does not have permissions to view an item'
        },
        request_access_to_view: {
            id: 'fabric.linking.request_access_to_view',
            defaultMessage: 'Request access to {context} to view this issue',
            description: 'Allows the user to request access to a product or service'
        },
        request_denied: {
            id: 'fabric.linking.request_denied',
            defaultMessage: 'Your access request was denied',
            description: 'The user had request access but the request was denied by a product or service'
        },
        retry: {
            id: 'fabric.linking.retry',
            defaultMessage: 'Retry',
            description: 'Allows user to perform an action again'
        },
        save: {
            id: 'fabric.linking.save',
            defaultMessage: 'Save',
            description: 'Just the "save" word'
        },
        sent_on_relative: {
            id: 'fabric.linking.sent_on_relative',
            defaultMessage: 'Sent {context}',
            description: 'Indicated when entity was sent (relative form)'
        },
        sent_on_absolute: {
            id: 'fabric.linking.sent_on_absolute',
            defaultMessage: 'Sent on {context}',
            description: 'Indicated when entity was sent (absolute form)'
        },
        status_change_load_error: {
            id: 'fabric.linking.status_change_load_error',
            defaultMessage: "We couldn\u2019t load the statuses and transitions",
            description: 'Informs the user that the loading of status transitions failed'
        },
        status_change_permission_error: {
            id: 'fabric.linking.status_change_permission_error',
            defaultMessage: "You don\u2019t have permission to transition this issue. ",
            description: 'Informs the user that they do not have enough permissions to update a status'
        },
        status_change_update_error: {
            id: 'fabric.linking.status_change_update_error',
            defaultMessage: "We couldn\u2019t update the status",
            description: "Occurs when a user tries to update an issue's status but fails to do so"
        },
        try_again: {
            id: 'fabric.linking.try_again',
            defaultMessage: 'Try again',
            description: 'Allow the user to try an action again'
        },
        try_another_account: {
            id: 'fabric.linking.try_another_account',
            defaultMessage: 'Try another account',
            description: 'Allows the user to try an action again with a different account'
        },
        link_safety_warning_message: {
            id: 'fabric.linking.link_safety_warning_message',
            defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
            description: 'Link safety check warning message'
        },
        unauthorised_account_description: {
            id: 'fabric.linking.unauthorised_account_description',
            defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_description_no_provider: {
            id: 'fabric.linking.unauthorised_account_description_no_provider',
            defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
            description: 'Explains that user does not have access to a link.'
        },
        unauthorised_account_name: {
            id: 'fabric.linking.unauthorised_account_name',
            defaultMessage: "We can't display private pages from {context}",
            description: 'Shown when a user does not have access to a link.'
        },
        unauthorised_account_name_no_provider: {
            id: 'fabric.linking.unauthorised_account_name_no_provider',
            defaultMessage: "We can't display private pages",
            description: 'Shown when a user does not have access to a link.'
        },
        unassigned: {
            id: 'fabric.linking.unassigned',
            defaultMessage: 'Unassigned',
            description: 'Shown as a tooltip text for a default unassigned fallback avatar'
        },
        unfollow: {
            id: 'fabric.linking.unfollow',
            defaultMessage: 'Unfollow',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_description: {
            id: 'fabric.linking.unfollow_project_description',
            defaultMessage: 'Unfollow to stop receiving project notifications',
            description: 'Description on what Unfollow does'
        },
        unfollow_project: {
            id: 'fabric.linking.unfollow_project',
            defaultMessage: 'Unfollow project',
            description: 'Click to unfollow a project.'
        },
        unfollow_project_error: {
            id: 'fabric.linking.unfollow_project_error',
            defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
        },
        unfollow_goal_description: {
            id: 'fabric.linking.unfollow_goal_description',
            defaultMessage: 'Unfollow to stop receiving notifications for this goal',
            description: 'Description on what Unfollow does'
        },
        unfollow_goal: {
            id: 'fabric.linking.unfollow_goal',
            defaultMessage: 'Unfollow goal',
            description: 'Click to unfollow a project.'
        },
        unfollow_goal_error: {
            id: 'fabric.linking.unfollow_goal_error',
            defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
            description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
        },
        unlink_account: {
            id: 'fabric.linking.unlink_account',
            defaultMessage: 'Unlink Account',
            description: 'Allows to remove a connected account from the user'
        },
        view: {
            id: 'fabric.linking.view',
            defaultMessage: 'View',
            description: 'Go through to a piece of content to view it in its original context.'
        },
        viewIn: {
            id: 'fabric.linking.srclink',
            defaultMessage: 'View in',
            description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
        },
        viewOriginal: {
            id: 'fabric.linking.srclinkunknown',
            defaultMessage: 'View Original',
            description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
        },
        default_no_access_title: {
            id: 'fabric.linking.no_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they dont have access to certain content'
        },
        direct_access_title: {
            id: 'fabric.linking.direct_access_title',
            defaultMessage: 'Join {product} to view this content',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access_description: {
            id: 'fabric.linking.direct_access_description',
            defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
            description: 'Informs the user that they have access to this product, and can sign up or join right away.'
        },
        direct_access: {
            id: 'fabric.linking.direct_access',
            defaultMessage: 'Join now',
            description: 'Allows the user join the product or service immediately'
        },
        request_access_description: {
            id: 'fabric.linking.request_access_description',
            defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
            description: 'Informs the user to request access to a product by talking to the website administrator'
        },
        request_access: {
            id: 'fabric.linking.request_access',
            defaultMessage: 'Request access',
            description: 'Allows the user to request access to a product or service'
        },
        request_access_pending_title: {
            id: 'fabric.linking.request_access_pending_title',
            defaultMessage: 'Access to {product} is pending',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_access_pending_description: {
            id: 'fabric.linking.request_access_pending_description',
            defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
            description: 'Informs the user that their request to view this content is pending website administrator approval'
        },
        request_access_pending: {
            id: 'fabric.linking.request_access_pending',
            defaultMessage: 'Pending approval',
            description: 'Informs the user that their request to view this content is pending'
        },
        request_denied_description: {
            id: 'fabric.linking.request_denied_description',
            defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
            description: 'Informs the user that their request to view this content was denied'
        },
        access_exists_description: {
            id: 'fabric.linking.access_exists_description',
            defaultMessage: 'Request access to view this content from {hostname}.',
            description: 'Informs the user to contact the website administrator to request access to a product'
        },
        not_found_description: {
            id: 'fabric.linking.not_found_description',
            defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
            description: 'Error case for when a provided item is not found within the list of items'
        },
        not_found_title: {
            id: 'fabric.linking.not_found_title',
            defaultMessage: "We can't show you this {product} page",
            description: 'Error case for when a provided link is not found'
        },
        forbidden_title: {
            id: 'fabric.linking.forbidden_title',
            defaultMessage: "You don't have access to this content",
            description: 'Informs the user that they do not have access to the linked content.'
        },
        forbidden_description: {
            id: 'fabric.linking.forbidden_description',
            defaultMessage: 'Contact your admin to request access to {hostname}.',
            description: 'Informs the user that they must contact the site administrator for access.'
        },
        related: {
            id: 'fabric.linking.related',
            defaultMessage: 'Related',
            description: 'Informs the user about related resources'
        },
        generic_error_message: {
            id: 'fabric.linking.generic_error_message',
            defaultMessage: 'An error occurred',
            description: 'A generic error message to the user'
        },
        related_links_modal_title: {
            id: 'fabric.linking.related_links_modal_title',
            defaultMessage: 'Recent links',
            description: 'Shown as the title for the related links modal'
        },
        related_links_view_related_urls: {
            id: 'fabric.linking.related_links_view_related_urls',
            defaultMessage: 'View recent links',
            description: 'Action to view related links to the given resource'
        },
        related_links_found_in: {
            id: 'fabric.linking.related_links_found_in',
            defaultMessage: 'Found In',
            description: 'Informs the user of the resources are found in the given url'
        },
        related_links_not_found: {
            id: 'fabric.linking.related_links_not_found',
            defaultMessage: "We didn't find any links to show here.",
            description: 'Informs the user that there are no related resources for the given url'
        },
        related_links_includes_links_to: {
            id: 'fabric.linking.related_links_includes_links_to',
            defaultMessage: 'Includes Links To',
            description: 'Informs the user of the resources the url links to'
        },
        related_links_modal_error_header: {
            id: 'fabric.linking.related_links_modal_error_header',
            defaultMessage: 'Something went wrong',
            description: 'Title for related links error'
        },
        related_links_modal_error_message: {
            id: 'fabric.linking.related_links_modal_error_message',
            defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
            description: 'Informs the user that there was a problem loading related links'
        },
        related_links_modal_unavailable_header: {
            id: 'fabric.linking.related_links_modal_unavailable_header',
            defaultMessage: 'No recent links',
            description: 'Title for related links being unavailable'
        },
        related_links_modal_unavailable_message: {
            id: 'fabric.linking.related_links_modal_unavailable_message',
            defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
            description: 'Informs the user that related links were not found but may be available in the future'
        }
    });
});
parcelRegister("5joKY", function(module, exports) {
    $parcel$export(module.exports, "breakWordsCss", ()=>$b66aa972276b3574$export$e4dda5b86d39ace5);
    function $b66aa972276b3574$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b66aa972276b3574$export$e4dda5b86d39ace5 = {
        name: "1ujvzzx",
        styles: "white-space:pre-line;word-break:break-all"
    };
});
parcelRegister("cI2hq", function(module, exports) {
    $parcel$export(module.exports, "useLinkWarningModal", ()=>$afd5dc953340b04b$export$32b76c003683c2ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $57Lhk;
    var $fzJZi;
    const $afd5dc953340b04b$var$toUrl = (url, base)=>{
        try {
            return new URL(url, base);
        } catch  {
            return undefined;
        }
    };
    const $afd5dc953340b04b$export$32b76c003683c2ec = ()=>{
        const [unsafeLinkText, setUnsafeLinkText] = (0, $5uXOq.useState)(null);
        const [url, setUrl] = (0, $5uXOq.useState)(null);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const sendWarningModalViewedEvent = ()=>{
            createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'linkSafetyWarningModal',
                eventType: 'screen',
                name: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
        const sendContinueClickedEvent = ()=>{
            createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'linkSafetyWarningModalContinue',
                eventType: 'ui',
                screen: 'linkSafetyWarningModal'
            }).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
        };
        const isLinkSafe = (event, href)=>{
            if (!href) return true;
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            const normalisedUrlFromLinkText = (0, (0, parcelRequire("57Lhk")).normalizeUrl)(linkText);
            if (!normalisedUrlFromLinkText) return true;
            const anchorLinkRegex = new RegExp(/^#/im);
            const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
            const isAnchorLink = anchorLinkRegex.test(href);
            if (isAnchorLink || isLinkTextAnchorLink) return true;
            const relativeLinkRegex = new RegExp(/^\//im);
            const isRelativeHrefLink = relativeLinkRegex.test(href);
            if (isRelativeHrefLink) return true;
            const hrefUrl = $afd5dc953340b04b$var$toUrl(href, window.location.origin);
            const linkTextUrl = $afd5dc953340b04b$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
            if (!hrefUrl || !linkTextUrl) return true;
            const httpProtocols = [
                'http:',
                'https:'
            ];
            let areProtocolsEquivalent;
            if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
                const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
                areProtocolsEquivalent = noUserNameAndPassword;
            } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
            const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
            if (!areEquivalentLinks) return false;
            return true;
        };
        const showSafetyWarningModal = (event, href)=>{
            event.preventDefault();
            const anchor = event.currentTarget;
            const linkText = anchor.innerText;
            setUnsafeLinkText(linkText);
            href && setUrl(href);
            setIsOpen(true);
            sendWarningModalViewedEvent();
        };
        const onClose = ()=>{
            setIsOpen(false);
            setUnsafeLinkText(null);
            setUrl(null);
        };
        const onContinue = ()=>{
            onClose();
            sendContinueClickedEvent();
            url && window.open(url, '_blank', 'noopener noreferrer');
        };
        return {
            isLinkSafe: isLinkSafe,
            isOpen: isOpen,
            onClose: onClose,
            onContinue: onContinue,
            showSafetyWarningModal: showSafetyWarningModal,
            unsafeLinkText: unsafeLinkText,
            url: url
        };
    };
});
parcelRegister("57Lhk", function(module, exports) {
    $parcel$export(module.exports, "isSafeUrl", ()=>$8f5c48f3a9939b0b$export$c9f92f5469372e0f);
    $parcel$export(module.exports, "normalizeUrl", ()=>$8f5c48f3a9939b0b$export$6535eb414fa2c8b6);
    var $e2gHg = parcelRequire("e2gHg");
    const $8f5c48f3a9939b0b$var$linkify = (0, ($parcel$interopDefault($e2gHg)))();
    $8f5c48f3a9939b0b$var$linkify.add('sourcetree:', 'http:');
    $8f5c48f3a9939b0b$var$linkify.add('jamfselfservice:', 'http:');
    $8f5c48f3a9939b0b$var$linkify.add('notes:', 'http:');
    const $8f5c48f3a9939b0b$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    const $8f5c48f3a9939b0b$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    $8f5c48f3a9939b0b$var$tlds.push($8f5c48f3a9939b0b$var$tlds2Char);
    $8f5c48f3a9939b0b$var$linkify.tlds($8f5c48f3a9939b0b$var$tlds, false);
    const $8f5c48f3a9939b0b$var$whitelistedURLPatterns = [
        /^https?:\/\/[^\s]*$/im,
        /^ftps?:\/\//im,
        /^gopher:\/\//im,
        /^integrity:\/\//im,
        /^file:\/\//im,
        /^smb:\/\//im,
        /^dynamicsnav:\/\//im,
        /^jamfselfservice:\/\/[^\s]*$/im,
        /^\//im,
        /^mailto:/im,
        /^skype:/im,
        /^callto:[^\s]*$/im,
        /^facetime:[^\s]*$/im,
        /^git:/im,
        /^irc6?:/im,
        /^news:/im,
        /^nntp:/im,
        /^feed:/im,
        /^cvs:/im,
        /^svn:/im,
        /^mvn:/im,
        /^ssh:/im,
        /^scp:\/\//im,
        /^sftp:\/\//im,
        /^itms:/im,
        /^notes:/im,
        /^notes:\/\//im,
        /^hipchat:\/\//im,
        /^sourcetree:/im,
        /^urn:/im,
        /^tel:/im,
        /^xmpp:/im,
        /^telnet:/im,
        /^vnc:/im,
        /^rdp:/im,
        /^whatsapp:/im,
        /^slack:/im,
        /^sips?:/im,
        /^magnet:/im,
        /^foo:/im,
        /^#/im
    ];
    const $8f5c48f3a9939b0b$var$normaliseLinkHref = (url)=>{
        const match = $8f5c48f3a9939b0b$var$getLinkMatch(url);
        return match && match.url || null;
    };
    const $8f5c48f3a9939b0b$var$getLinkMatch = (str)=>{
        if (!str) return null;
        let match = $8f5c48f3a9939b0b$var$linkifyMatch(str);
        if (!match.length) match = $8f5c48f3a9939b0b$var$linkify.match(str);
        return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
    };
    const $8f5c48f3a9939b0b$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
    const $8f5c48f3a9939b0b$var$linkifyMatch = (text)=>{
        const matches = [];
        if (!$8f5c48f3a9939b0b$var$LINK_REGEXP.test(text)) return matches;
        let startpos = 0;
        let substr;
        while(substr = text.substr(startpos)){
            const link = (substr.match($8f5c48f3a9939b0b$var$LINK_REGEXP) || [
                ''
            ])[0];
            if (link) {
                const index = substr.search($8f5c48f3a9939b0b$var$LINK_REGEXP);
                const start = index >= 0 ? index + startpos : index;
                const end = start + link.length;
                matches.push({
                    index: start,
                    lastIndex: end,
                    raw: link,
                    url: link,
                    text: link,
                    schema: ''
                });
                startpos += end;
            } else break;
        }
        return matches;
    };
    const $8f5c48f3a9939b0b$export$c9f92f5469372e0f = (url)=>{
        const urlTrimmed = url.trim();
        return $8f5c48f3a9939b0b$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
    };
    function $8f5c48f3a9939b0b$export$6535eb414fa2c8b6(url) {
        if (!url) return '';
        const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
        if ($8f5c48f3a9939b0b$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
        return $8f5c48f3a9939b0b$var$normaliseLinkHref(urlWithoutNewlines);
    }
});
parcelRegister("e2gHg", function(module, exports) {
    'use strict';
    function $a37e3434b26d3f31$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $a37e3434b26d3f31$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $a37e3434b26d3f31$var$isString(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object String]';
    }
    function $a37e3434b26d3f31$var$isObject(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Object]';
    }
    function $a37e3434b26d3f31$var$isRegExp(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object RegExp]';
    }
    function $a37e3434b26d3f31$var$isFunction(obj) {
        return $a37e3434b26d3f31$var$_class(obj) === '[object Function]';
    }
    function $a37e3434b26d3f31$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $a37e3434b26d3f31$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $a37e3434b26d3f31$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $a37e3434b26d3f31$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $a37e3434b26d3f31$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $a37e3434b26d3f31$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $a37e3434b26d3f31$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $a37e3434b26d3f31$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $a37e3434b26d3f31$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $a37e3434b26d3f31$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $a37e3434b26d3f31$var$compile(self) {
        var re = self.re = (parcelRequire("d5qnw"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($a37e3434b26d3f31$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($a37e3434b26d3f31$var$isObject(val)) {
                if ($a37e3434b26d3f31$var$isRegExp(val.validate)) compiled.validate = $a37e3434b26d3f31$var$createValidator(val.validate);
                else if ($a37e3434b26d3f31$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($a37e3434b26d3f31$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $a37e3434b26d3f31$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($a37e3434b26d3f31$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $a37e3434b26d3f31$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($a37e3434b26d3f31$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
        $a37e3434b26d3f31$var$resetScanCache(self);
    }
    function $a37e3434b26d3f31$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $a37e3434b26d3f31$var$createMatch(self, shift) {
        var match = new $a37e3434b26d3f31$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $a37e3434b26d3f31$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $a37e3434b26d3f31$var$LinkifyIt)) return new $a37e3434b26d3f31$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($a37e3434b26d3f31$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $a37e3434b26d3f31$var$assign({}, $a37e3434b26d3f31$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $a37e3434b26d3f31$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $a37e3434b26d3f31$var$compile(this);
    }
    $a37e3434b26d3f31$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $a37e3434b26d3f31$var$assign(this.__opts__, options);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($a37e3434b26d3f31$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $a37e3434b26d3f31$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $a37e3434b26d3f31$var$compile(this);
        return this;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $a37e3434b26d3f31$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $a37e3434b26d3f31$var$LinkifyIt;
});
parcelRegister("d5qnw", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + ';(?!' + re.src_ZCc + ').|' + '\\!+(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("f14yv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31acef3336a9ea7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $e31acef3336a9ea7$export$2e2bcd8739ae039(props) {
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            style: {
                textDecoration: 'line-through'
            }
        }, props.children));
    }
});
parcelRegister("eVxaj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3356ea5acdd73a43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $3356ea5acdd73a43$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("strong", props.dataAttributes, props.children);
    }
});
parcelRegister("gUlHA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c264e87eca3a3d05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $c264e87eca3a3d05$var$isSub = (type)=>{
        return type === 'sub';
    };
    function $c264e87eca3a3d05$export$2e2bcd8739ae039(props) {
        if ($c264e87eca3a3d05$var$isSub(props.type)) return (0, ($parcel$interopDefault($5uXOq))).createElement("sub", props.dataAttributes, props.children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("sup", props.dataAttributes, props.children);
    }
});
parcelRegister("c15YI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c8904856eee164f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $lKA8N;
    var $hxoiH;
    function $c8904856eee164f6$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("lKA8N")).hexToEditorTextPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = (0, (0, parcelRequire("lKA8N")).hexToEditorTextPaletteColor)(props.color) || props.color;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-text-custom-color": props.color,
            className: "fabric-text-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("lKA8N", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextPaletteColor", ()=>$965e3166a7c18c5e$export$9c2f408d391feb93);
    function $965e3166a7c18c5e$export$9c2f408d391feb93(hexColor) {
        return $965e3166a7c18c5e$export$57fa5089caad992[hexColor.toUpperCase()];
    }
    const $965e3166a7c18c5e$export$57fa5089caad992 = {
        ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
        ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
        ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
        ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
        ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
        ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
        ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
        ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
        ['#006644']: "var(--ds-text-accent-green, #006644)",
        ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
        ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
        ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
        ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
        ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
        ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
        ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
        ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
        ['#403294']: "var(--ds-text-accent-purple, #403294)",
        ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
        ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
        ['#172B4D']: "var(--ds-text, #172B4D)"
    };
});
parcelRegister("koUAb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d139f843714a421$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $87j2U;
    var $7dikW;
    var $hxoiH;
    function $7d139f843714a421$export$2e2bcd8739ae039(props) {
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        let paletteColorValue;
        const tokenColor = (0, (0, parcelRequire("7dikW")).hexToEditorTextBackgroundPaletteColor)(props.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if (colorMode === 'dark') paletteColorValue = (0, (0, parcelRequire("87j2U")).getDarkModeLCHColor)(props.color);
        else paletteColorValue = props.color;
        const style = (0, $5uXOq.useMemo)(()=>({
                ['--custom-palette-color']: paletteColorValue
            }), [
            paletteColorValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props.dataAttributes,
            "data-background-custom-color": props.color,
            className: "fabric-background-color-mark",
            style: style
        }, props.children);
    }
});
parcelRegister("7dikW", function(module, exports) {
    $parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", ()=>$b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0);
    const $b5a4f7ad3e4ae03c$export$12a518ff137dd389 = {
        ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
        ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
    };
    function $b5a4f7ad3e4ae03c$export$8b58ff1b36bb75e0(hexColor) {
        return $b5a4f7ad3e4ae03c$export$12a518ff137dd389[hexColor.toUpperCase()];
    }
});
parcelRegister("eESZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f8016b636a69d58$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $6f8016b636a69d58$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("u", props.dataAttributes, props.children);
    }
});
parcelRegister("95Yll", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56f1f5242a99941b$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $4ceoy;
    var $eOOFp;
    var $iHYdz;
    var $gmhCD = parcelRequire("gmhCD");
    var $VSDnB;
    const $56f1f5242a99941b$var$wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `${(0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin)} 0`,
        marginLeft: '50%',
        transform: 'translateX(-50%)'
    });
    function $56f1f5242a99941b$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $56f1f5242a99941b$var$wrapperStyles,
                "data-mode": props.mode,
                ...(0, $gmhCD.editorExperiment)('advanced_layouts', true) && {
                    'data-has-width': !!props.width
                },
                style: {
                    width: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? (0, (0, parcelRequire("eOOFp")).calcBreakoutWithCustomWidth)(props.mode, 'width' in props ? props.width : null, width) : (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(props.mode, width)
                },
                className: "fabric-editor-breakout-mark fabric-editor-block-mark"
            }, props.children));
    }
});
parcelRegister("lbdLJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1b7090399d1e727$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $aeGrH;
    const $d1b7090399d1e727$var$MarkWrapper = (props)=>{
        const styles = props['data-align'] ? (0, (0, parcelRequire("f8Sb3")).css)("text-align:", (0, (0, parcelRequire("aeGrH")).alignmentPositionMap)[props['data-align']], ";") : '';
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles,
            ...props
        }, props.children));
    };
    function $d1b7090399d1e727$export$2e2bcd8739ae039(props) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($d1b7090399d1e727$var$MarkWrapper, {
            className: "fabric-editor-block-mark fabric-editor-alignment",
            "data-align": props.align
        }, props.children);
    }
});
parcelRegister("9xZ5X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef073b46e3c6008$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $3ef073b46e3c6008$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "fabric-editor-block-mark fabric-editor-indentation-mark",
            "data-level": props.level
        }, props.children);
    }
});
parcelRegister("g5EjF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1398622ac205fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b1398622ac205fad$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("acz8Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04eeed03d14d0e78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $04eeed03d14d0e78$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", props.dataAttributes, props.children);
    }
});
parcelRegister("8DQfy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009dff5e97619965$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $009dff5e97619965$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
            "data-mark-type": "dataConsumer",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("g9yqu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ac6eff929f5b91e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ac6eff929f5b91e$export$2e2bcd8739ae039(props) {
        const WrapperElement = props.isInline ? 'span' : 'div';
        return (0, ($parcel$interopDefault($5uXOq))).createElement(WrapperElement, {
            "data-localId": props.localId,
            "data-name": props.name,
            "data-mark-type": "fragment",
            ...props.dataAttributes
        }, props.children);
    }
});
parcelRegister("itF0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f200b42408cc462$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $7f200b42408cc462$export$2e2bcd8739ae039(props) {
        const borderColor = props.color ?? '';
        const borderSize = props.size ?? 0;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-color": borderColor,
            "data-size": borderSize,
            "data-mark-type": "border"
        }, props.children);
    }
});
parcelRegister("6EeUE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efbb661461ca3406$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    class $efbb661461ca3406$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        render() {
            const { reference: reference, children: children } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": reference
            }, children);
        }
    }
});
parcelRegister("eQNWQ", function(module, exports) {
    $parcel$export(module.exports, "getMarksByOrder", ()=>$7bbfc2d34b0938dd$export$99a33ed044c278ae);
    $parcel$export(module.exports, "isSameMark", ()=>$7bbfc2d34b0938dd$export$b1304404bdc42b7a);
    $parcel$export(module.exports, "getValidDocument", ()=>$7bbfc2d34b0938dd$export$fb80336a7e408cb3);
    $parcel$export(module.exports, "getValidNode", ()=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd);
    var $9IGaJ;
    var $kc0v7;
    var $iZOJ9;
    var $bFtEE;
    var $kOFhM;
    var $VSDnB;
    const $7bbfc2d34b0938dd$export$3b94ef2190b2d585 = {
        FINAL: 'final',
        STAGE_0: 'stage0'
    };
    const $7bbfc2d34b0938dd$export$62d5811a2955c1d8 = [
        'fragment',
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'confluenceInlineComment',
        'annotation',
        'dataConsumer'
    ];
    const $7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb = (type)=>{
        return type === 'sub' || type === 'sup';
    };
    const $7bbfc2d34b0938dd$export$99a33ed044c278ae = (marks)=>{
        return [
            ...marks
        ].sort((a, b)=>$7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(a.type.name) - $7bbfc2d34b0938dd$export$62d5811a2955c1d8.indexOf(b.type.name));
    };
    const $7bbfc2d34b0938dd$export$b1304404bdc42b7a = (mark, otherMark)=>{
        if (!mark || !otherMark) return false;
        return mark.eq(otherMark);
    };
    const $7bbfc2d34b0938dd$export$fb80336a7e408cb3 = (doc, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const node = $7bbfc2d34b0938dd$export$81b20b6c83a56bd(doc, schema, adfStage);
        if (node.type === 'doc') {
            node.content = $7bbfc2d34b0938dd$var$wrapInlineNodes(node.content);
            return node;
        }
        return null;
    };
    const $7bbfc2d34b0938dd$var$wrapInlineNodes = (nodes = [])=>{
        return nodes.map((node)=>(0, (0, parcelRequire("kc0v7")).inlineNodes).has(node.type) ? {
                type: 'paragraph',
                content: [
                    node
                ]
            } : node);
    };
    const $7bbfc2d34b0938dd$export$fafd4f799ee68da0 = (content, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        return content.map((node)=>$7bbfc2d34b0938dd$export$81b20b6c83a56bd(node, schema, adfStage));
    };
    const $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
    const $7bbfc2d34b0938dd$var$RELATIVE_LINK = /^\//;
    const $7bbfc2d34b0938dd$var$ANCHOR_LINK = /^#/;
    const $7bbfc2d34b0938dd$var$flattenUnknownBlockTree = (node, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const output = [];
        let isPrevLeafNode = false;
        for(let i = 0; i < node.content.length; i++){
            const childNode = node.content[i];
            const isLeafNode = !(childNode.content && childNode.content.length);
            if (i > 0) {
                if (isPrevLeafNode) output.push({
                    type: 'text',
                    text: ' '
                });
                else output.push({
                    type: 'hardBreak'
                });
            }
            if (isLeafNode) output.push($7bbfc2d34b0938dd$export$81b20b6c83a56bd(childNode, schema, adfStage));
            else output.push(...$7bbfc2d34b0938dd$var$flattenUnknownBlockTree(childNode, schema, adfStage));
            isPrevLeafNode = isLeafNode;
        }
        return output;
    };
    const $7bbfc2d34b0938dd$export$b9908ef75cad1e0e = (node)=>{
        const { attrs: attrs = {}, content: content, text: text, type: type } = node;
        if (!content || !content.length) {
            const unknownInlineNode = {
                type: 'text',
                text: text || attrs.text || `[${type}]`
            };
            const { textUrl: textUrl } = attrs;
            if (textUrl && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(textUrl)) unknownInlineNode.marks = [
                {
                    type: 'link',
                    attrs: {
                        href: textUrl
                    }
                }
            ];
            return unknownInlineNode;
        }
        return {
            type: 'unknownBlock',
            content: $7bbfc2d34b0938dd$var$flattenUnknownBlockTree(node)
        };
    };
    const $7bbfc2d34b0938dd$var$getValidMarks = (marks, adfStage = 'final')=>{
        if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
            const validMark = $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9(mark, adfStage);
            if (validMark) acc.push(validMark);
            return acc;
        }, []);
        return marks;
    };
    const $7bbfc2d34b0938dd$export$81b20b6c83a56bd = (originalNode, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final')=>{
        const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
        let { content: content } = originalNode;
        const node = {
            attrs: attrs,
            marks: marks,
            text: text,
            type: type
        };
        if (content) node.content = content = $7bbfc2d34b0938dd$export$fafd4f799ee68da0(content, schema, adfStage);
        if (!schema.nodes[type]) return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
        if (type) switch(type){
            case 'doc':
                {
                    const { version: version } = originalNode;
                    if (version && content && content.length) return {
                        type: type,
                        content: content
                    };
                    break;
                }
            case 'codeBlock':
                if (content) content = content.reduce((acc, val)=>{
                    if (val.type === 'text') acc.push({
                        type: val.type,
                        text: val.text
                    });
                    return acc;
                }, []);
                if (attrs && attrs.language) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
                return {
                    type: type,
                    content: content,
                    marks: marks
                };
            case 'date':
                if (attrs && attrs.timestamp) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'status':
                if (attrs && attrs.text && attrs.color) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'emoji':
                if (attrs && attrs.shortName) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'inlineExtension':
            case 'extension':
                if (attrs && attrs.extensionType && attrs.extensionKey) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'inlineCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs,
                    ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                        marks: marks
                    } : {}
                };
                break;
            case 'blockCard':
                if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url))) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'embedCard':
                if (attrs && (attrs.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'bodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'multiBodiedExtension':
                if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'extensionFrame':
                if (content) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
                break;
            case 'hardBreak':
                return {
                    type: type
                };
            case 'caption':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaInline':
                {
                    let mediaId = '';
                    let mediaCollection = [];
                    if (attrs) {
                        const { id: id, collection: collection } = attrs;
                        mediaId = id;
                        mediaCollection = collection;
                    }
                    if (mediaId && mediaCollection) return {
                        type: type,
                        attrs: attrs,
                        marks: marks
                    };
                    break;
                }
            case 'media':
                {
                    let mediaId = '';
                    let mediaType = '';
                    let mediaCollection = [];
                    let mediaUrl = '';
                    if (attrs) {
                        const { id: id, collection: collection, type: type, url: url } = attrs;
                        mediaId = id;
                        mediaType = type;
                        mediaCollection = collection;
                        mediaUrl = url;
                    }
                    if (mediaType === 'external' && !!mediaUrl) {
                        const mediaAttrs = {
                            type: mediaType,
                            url: mediaUrl,
                            width: attrs.width,
                            height: attrs.height
                        };
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    } else if (mediaId && mediaType) {
                        const mediaAttrs = {
                            type: mediaType,
                            id: mediaId,
                            collection: mediaCollection
                        };
                        if (attrs.width) mediaAttrs.width = attrs.width;
                        if (attrs.height) mediaAttrs.height = attrs.height;
                        if (attrs.alt) mediaAttrs.alt = attrs.alt;
                        const getMarks = $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage);
                        return getMarks ? {
                            type: type,
                            attrs: mediaAttrs,
                            marks: getMarks
                        } : {
                            type: type,
                            attrs: mediaAttrs
                        };
                    }
                    break;
                }
            case 'mediaGroup':
                if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                    type: type,
                    content: content
                };
                break;
            case 'mediaSingle':
                {
                    const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                    const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                    if (containsJustMedia || containsMediaAndCaption) return {
                        type: type,
                        attrs: attrs,
                        content: content,
                        marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                    };
                    break;
                }
            case 'mention':
                {
                    let mentionText = '';
                    let mentionId;
                    let mentionAccess;
                    if (attrs) {
                        const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                        mentionText = text || displayName;
                        mentionId = id;
                        mentionAccess = accessLevel;
                    }
                    if (!mentionText) mentionText = text || '@unknown';
                    if (mentionText && mentionId) {
                        const mentionNode = {
                            type: type,
                            attrs: {
                                id: mentionId,
                                text: mentionText,
                                accessLevel: ''
                            },
                            ...(0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? {
                                marks: marks
                            } : {}
                        };
                        if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                        return mentionNode;
                    }
                    break;
                }
            case 'paragraph':
                if (adfStage === 'stage0') {
                    let paragraphNode = {
                        type: type,
                        content: content || []
                    };
                    if (attrs && attrs.localId) paragraphNode.attrs = {
                        localId: attrs.localId
                    };
                    if (marks) paragraphNode.marks = [
                        ...marks
                    ];
                    return paragraphNode;
                }
                return marks ? {
                    type: type,
                    content: content || [],
                    marks: marks
                } : {
                    type: type,
                    content: content || []
                };
            case 'rule':
                return {
                    type: type
                };
            case 'text':
                {
                    let { marks: marks } = node;
                    if (text) return marks ? {
                        type: type,
                        text: text,
                        marks: $7bbfc2d34b0938dd$var$getValidMarks(marks, adfStage)
                    } : {
                        type: type,
                        text: text
                    };
                    break;
                }
            case 'heading':
                if (attrs) {
                    const { level: level } = attrs;
                    const between = (x, a, b)=>x >= a && x <= b;
                    if (level && between(level, 1, 6)) {
                        if (adfStage === 'stage0') {
                            let headingNode = {
                                type: type,
                                content: content,
                                attrs: {
                                    level: level
                                }
                            };
                            if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                            if (marks) headingNode.marks = [
                                ...marks
                            ];
                            return headingNode;
                        }
                        return marks ? {
                            type: type,
                            content: content,
                            marks: marks,
                            attrs: {
                                level: level
                            }
                        } : {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                    }
                }
                break;
            case 'bulletList':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'orderedList':
                if (content) return {
                    type: type,
                    content: content,
                    attrs: {
                        order: attrs && attrs.order
                    }
                };
                break;
            case 'listItem':
                if (content) return {
                    type: type,
                    content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content)
                };
                break;
            case 'blockquote':
                if (content) return {
                    type: type,
                    content: content
                };
                break;
            case 'panel':
                if (attrs && content) {
                    const { panelType: panelType } = attrs;
                    if (Object.values((0, (0, parcelRequire("bFtEE")).PanelType)).includes(panelType)) return {
                        type: type,
                        attrs: attrs,
                        content: content
                    };
                }
                break;
            case 'layoutSection':
                if (content) return {
                    type: type,
                    marks: marks,
                    content: content
                };
                break;
            case 'layoutColumn':
                if (attrs && content) {
                    if (attrs.width > 0 && attrs.width <= 100) return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'decisionList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'decisionItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'DECIDED'
                    }
                };
            case 'taskList':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)()
                    }
                };
            case 'taskItem':
                return {
                    type: type,
                    content: content,
                    attrs: {
                        localId: attrs && attrs.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                        state: attrs && attrs.state || 'TODO'
                    }
                };
            case 'table':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                    if (adfStage === 'stage0') return {
                        type: type,
                        content: content,
                        attrs: {
                            ...attrs,
                            localId: attrs?.localId || (0, (0, parcelRequire("9IGaJ")).generateUuid)(),
                            width: attrs?.width || null
                        }
                    };
                    return {
                        type: type,
                        content: content,
                        attrs: attrs
                    };
                }
                break;
            case 'tableRow':
                if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                    type: type,
                    content: content
                };
                break;
            case 'tableCell':
            case 'tableHeader':
                if (content) {
                    const cellAttrs = {};
                    if (attrs) {
                        if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                        if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                        if (attrs.background) cellAttrs.background = attrs.background;
                        if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                    }
                    return {
                        type: type,
                        content: $7bbfc2d34b0938dd$var$wrapInlineNodes(content),
                        attrs: attrs ? cellAttrs : undefined
                    };
                }
                break;
            case 'image':
                if (attrs && attrs.src) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'placeholder':
                if (attrs && typeof attrs.text !== 'undefined') return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'expand':
            case 'nestedExpand':
                return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: marks
                };
        }
        return $7bbfc2d34b0938dd$export$b9908ef75cad1e0e(node);
    };
    const $7bbfc2d34b0938dd$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
        const { attrs: attrs, type: type } = mark;
        if (type) switch(type){
            case 'code':
                return {
                    type: type
                };
            case 'em':
                return {
                    type: type
                };
            case 'link':
                if (attrs) {
                    const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                    let linkHref = href || url;
                    if (linkHref && linkHref.indexOf(':') === -1 && !$7bbfc2d34b0938dd$var$RELATIVE_LINK.test(linkHref) && !$7bbfc2d34b0938dd$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                    const linkAttrs = {
                        href: linkHref
                    };
                    if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                    if (linkHref && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(linkHref)) return {
                        type: type,
                        attrs: linkAttrs
                    };
                }
                break;
            case 'strike':
                return {
                    type: type
                };
            case 'strong':
                return {
                    type: type
                };
            case 'subsup':
                if (attrs && attrs['type']) {
                    const subSupType = attrs['type'];
                    if ($7bbfc2d34b0938dd$export$30f8aa4cc1f8c1cb(subSupType)) return {
                        type: type,
                        attrs: {
                            type: subSupType
                        }
                    };
                }
                break;
            case 'textColor':
                if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
            case 'underline':
                return {
                    type: type
                };
            case 'annotation':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'backgroundColor':
                if (attrs && $7bbfc2d34b0938dd$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                    type: type,
                    attrs: attrs
                };
                break;
        }
        if (adfStage === 'stage0') switch(type){
            case 'confluenceInlineComment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'dataConsumer':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'fragment':
                return {
                    type: type,
                    attrs: attrs
                };
            case 'border':
                return {
                    type: type,
                    attrs: attrs
                };
        }
        return null;
    };
});
parcelRegister("kc0v7", function(module, exports) {
    $parcel$export(module.exports, "inlineNodes", ()=>$eb355120b38723aa$export$b1f729c6af6f2a6e);
    var $ctVrM;
    const $eb355120b38723aa$var$typedNodes = (0, parcelRequire("ctVrM"));
    const $eb355120b38723aa$export$b1f729c6af6f2a6e = new Set(Object.keys($eb355120b38723aa$var$typedNodes).filter((key)=>$eb355120b38723aa$var$typedNodes[key] && $eb355120b38723aa$var$typedNodes[key].group === 'inline'));
});
parcelRegister("ctVrM", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("7kC9H")).expand);
    $parcel$export(module.exports, "expandWithNestedExpand", ()=>(parcelRequire("7kC9H")).expandWithNestedExpand);
    $parcel$export(module.exports, "expandToJSON", ()=>(parcelRequire("7kC9H")).toJSON);
    $parcel$export(module.exports, "confluenceJiraIssue", ()=>(parcelRequire("6bbHe")).confluenceJiraIssue);
    $parcel$export(module.exports, "confluenceUnsupportedBlock", ()=>(parcelRequire("5y0tR")).confluenceUnsupportedBlock);
    $parcel$export(module.exports, "confluenceUnsupportedInline", ()=>(parcelRequire("bd7A9")).confluenceUnsupportedInline);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("xjCuM")).doc);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("aXBFx")).blockquote);
    $parcel$export(module.exports, "blockquoteWithList", ()=>(parcelRequire("aXBFx")).blockquoteWithList);
    $parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", ()=>(parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("kjhhp")).bulletList);
    $parcel$export(module.exports, "bulletListSelector", ()=>(parcelRequire("kjhhp")).bulletListSelector);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("8vlrc")).codeBlock);
    $parcel$export(module.exports, "codeBlockToJSON", ()=>(parcelRequire("8vlrc")).toJSON);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("jnMM2")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("lRTZM")).heading);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("M4hHz")).rule);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("dwptW")).orderedList);
    $parcel$export(module.exports, "orderedListSelector", ()=>(parcelRequire("dwptW")).orderedListSelector);
    $parcel$export(module.exports, "orderedListWithOrder", ()=>(parcelRequire("dwptW")).orderedListWithOrder);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("abme3")).paragraph);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("7DoMR")).emoji);
    $parcel$export(module.exports, "image", ()=>(parcelRequire("7lRBh")).image);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("g7Cky")).mention);
    $parcel$export(module.exports, "mentionToJSON", ()=>(parcelRequire("g7Cky")).toJSON);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("2FIVU")).listItem);
    $parcel$export(module.exports, "listItemWithTask", ()=>(parcelRequire("2FIVU")).listItemWithTask);
    $parcel$export(module.exports, "listItemWithDecisionStage0", ()=>(parcelRequire("2FIVU")).listItemWithDecisionStage0);
    $parcel$export(module.exports, "extendedPanel", ()=>(parcelRequire("bFtEE")).extendedPanel);
    $parcel$export(module.exports, "PanelType", ()=>(parcelRequire("bFtEE")).PanelType);
    $parcel$export(module.exports, "panelWithBlockquoteStage0", ()=>(parcelRequire("bFtEE")).panelWithBlockquoteStage0);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("3DR6L")).text);
    $parcel$export(module.exports, "unknownBlock", ()=>(parcelRequire("9X587")).default);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5JeV5")).caption);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("7agO8")).media);
    $parcel$export(module.exports, "copyPrivateMediaAttributes", ()=>(parcelRequire("7agO8")).copyPrivateAttributes);
    $parcel$export(module.exports, "mediaToJSON", ()=>(parcelRequire("7agO8")).toJSON);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("92lix")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("7Xgp3")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("bIGZ7")).mediaSingle);
    $parcel$export(module.exports, "mediaSingleSpec", ()=>(parcelRequire("bIGZ7")).mediaSingleSpec);
    $parcel$export(module.exports, "mediaSingleWithCaption", ()=>(parcelRequire("bIGZ7")).mediaSingleWithCaption);
    $parcel$export(module.exports, "mediaSingleWithWidthType", ()=>(parcelRequire("bIGZ7")).mediaSingleWithWidthType);
    $parcel$export(module.exports, "mediaSingleFull", ()=>(parcelRequire("bIGZ7")).mediaSingleFull);
    $parcel$export(module.exports, "mediaSingleToJSON", ()=>(parcelRequire("bIGZ7")).toJSON);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("9UDEr")).table);
    $parcel$export(module.exports, "tableWithNestedTable", ()=>(parcelRequire("9UDEr")).tableWithNestedTable);
    $parcel$export(module.exports, "tableRowWithNestedTable", ()=>(parcelRequire("9UDEr")).tableRowWithNestedTable);
    $parcel$export(module.exports, "tableCellWithNestedTable", ()=>(parcelRequire("9UDEr")).tableCellWithNestedTable);
    $parcel$export(module.exports, "tableHeaderWithNestedTable", ()=>(parcelRequire("9UDEr")).tableHeaderWithNestedTable);
    $parcel$export(module.exports, "tableStage0", ()=>(parcelRequire("9UDEr")).tableStage0);
    $parcel$export(module.exports, "tableWithCustomWidth", ()=>(parcelRequire("9UDEr")).tableWithCustomWidth);
    $parcel$export(module.exports, "tableToJSON", ()=>(parcelRequire("9UDEr")).tableToJSON);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("9UDEr")).tableCell);
    $parcel$export(module.exports, "toJSONTableCell", ()=>(parcelRequire("9UDEr")).toJSONTableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("9UDEr")).tableHeader);
    $parcel$export(module.exports, "toJSONTableHeader", ()=>(parcelRequire("9UDEr")).toJSONTableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("9UDEr")).tableRow);
    $parcel$export(module.exports, "tableBackgroundColorPalette", ()=>(parcelRequire("9UDEr")).tableBackgroundColorPalette);
    $parcel$export(module.exports, "tableBackgroundBorderColor", ()=>(parcelRequire("9UDEr")).tableBackgroundBorderColor);
    $parcel$export(module.exports, "tableBackgroundColorNames", ()=>(parcelRequire("9UDEr")).tableBackgroundColorNames);
    $parcel$export(module.exports, "getCellAttrs", ()=>(parcelRequire("9UDEr")).getCellAttrs);
    $parcel$export(module.exports, "getCellDomAttrs", ()=>(parcelRequire("9UDEr")).getCellDomAttrs);
    $parcel$export(module.exports, "tablePrefixSelector", ()=>(parcelRequire("9UDEr")).tablePrefixSelector);
    $parcel$export(module.exports, "tableCellSelector", ()=>(parcelRequire("9UDEr")).tableCellSelector);
    $parcel$export(module.exports, "tableHeaderSelector", ()=>(parcelRequire("9UDEr")).tableHeaderSelector);
    $parcel$export(module.exports, "tableCellContentWrapperSelector", ()=>(parcelRequire("9UDEr")).tableCellContentWrapperSelector);
    $parcel$export(module.exports, "tableCellContentDomSelector", ()=>(parcelRequire("9UDEr")).tableCellContentDomSelector);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("8gSD8")).decisionList);
    $parcel$export(module.exports, "decisionListSelector", ()=>(parcelRequire("8gSD8")).decisionListSelector);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("Khvpb")).decisionItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("43mJF")).taskList);
    $parcel$export(module.exports, "taskListSelector", ()=>(parcelRequire("43mJF")).taskListSelector);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("iThOL")).taskItem);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("b2VmY")).date);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("dgJoa")).placeholder);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("gZoER")).layoutSection);
    $parcel$export(module.exports, "layoutSectionWithSingleColumn", ()=>(parcelRequire("gZoER")).layoutSectionWithSingleColumn);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("4EbxI")).layoutColumn);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("cCBEe")).inlineCard);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("21PS7")).blockCard);
    $parcel$export(module.exports, "unsupportedBlock", ()=>(parcelRequire("d1d6m")).unsupportedBlock);
    $parcel$export(module.exports, "unsupportedInline", ()=>(parcelRequire("6kr5W")).unsupportedInline);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("18bvk")).status);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("dx5eC")).nestedExpand);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("kshOv")).embedCard);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("hhN5g")).extension);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5BOuQ")).inlineExtension);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5AxYU")).bodiedExtension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("47jug")).extensionFrame);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("47jug")).multiBodiedExtension);
    var $7kC9H;
    var $6bbHe;
    var $5y0tR;
    var $bd7A9;
    var $xjCuM;
    var $aXBFx;
    var $kjhhp;
    var $8vlrc;
    var $jnMM2;
    var $lRTZM;
    var $M4hHz;
    var $dwptW;
    var $abme3;
    var $7DoMR;
    var $7lRBh;
    var $g7Cky;
    var $2FIVU;
    var $bFtEE;
    var $3DR6L;
    var $9X587;
    var $5JeV5;
    var $7agO8;
    var $92lix;
    var $7Xgp3;
    var $bIGZ7;
    var $9UDEr;
    var $8gSD8;
    var $Khvpb;
    var $43mJF;
    var $iThOL;
    var $b2VmY;
    var $dgJoa;
    var $gZoER;
    var $4EbxI;
    var $cCBEe;
    var $21PS7;
    var $d1d6m;
    var $6kr5W;
    var $18bvk;
    var $dx5eC;
    var $kshOv;
    var $hhN5g;
    var $5BOuQ;
    var $5AxYU;
    var $47jug;
});
parcelRegister("bzwTW", function(module, exports) {
    $parcel$export(module.exports, "insideBreakoutLayout", ()=>$99a90b85f857f7e6$export$d7bc71cca336a3b);
    $parcel$export(module.exports, "insideBlockNode", ()=>$99a90b85f857f7e6$export$42ddc573eb5a7b43);
    $parcel$export(module.exports, "insideMultiBodiedExtension", ()=>$99a90b85f857f7e6$export$9f1e9347b0411934);
    const $99a90b85f857f7e6$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
    const $99a90b85f857f7e6$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
    const $99a90b85f857f7e6$export$d7bc71cca336a3b = (path)=>path.some((item)=>$99a90b85f857f7e6$var$isLayoutNode(item) && $99a90b85f857f7e6$var$hasBreakOutMark(item));
    const $99a90b85f857f7e6$export$42ddc573eb5a7b43 = (path, schema)=>{
        const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
        const blockNodeNames = [
            expand,
            nestedExpand,
            layoutColumn
        ].filter((node)=>Boolean(node)).map((node)=>node.name);
        return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
    };
    const $99a90b85f857f7e6$export$9f1e9347b0411934 = (path, schema)=>{
        const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
        return path.some((n)=>n.type === multiBodiedExtension);
    };
});
parcelRegister("12yAL", function(module, exports) {
    $parcel$export(module.exports, "renderDocument", ()=>$af6d4930d9141440$export$59a54f98b9753d5c);
    var $8QpSo;
    var $kOFhM;
    var $eQNWQ;
    var $d54NZ;
    var $4IuOY;
    var $gkwXh;
    var $knXBU;
    var $1cjf7;
    var $4FBRr;
    var $aSk3Q;
    var $kgV4b;
    var $VSDnB;
    const $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
    const $af6d4930d9141440$var$withStopwatch = (cb)=>{
        const startTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const output = cb();
        const endTime = $af6d4930d9141440$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
        const time = endTime - startTime;
        return {
            output: output,
            time: time
        };
    };
    const $af6d4930d9141440$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
        let result;
        if (useSpecBasedValidator) {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("4FBRr")).transformMediaLinkMarks)(doc);
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).MEDIA_LINK_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            result = (0, (0, parcelRequire("4IuOY")).validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
        } else result = (0, (0, parcelRequire("eQNWQ")).getValidDocument)(doc, schema, adfStage);
        if (!result) return result;
        if (result.type === 'doc' && useSpecBasedValidator) {
            if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
                type: 'paragraph',
                content: []
            });
            if (!result.version) result.version = 1;
        }
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) try {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("aSk3Q")).transformNestedTablesIncomingDocument)(result);
            if (isTransformed) {
                dispatchAnalyticsEvent?.({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                result = transformedAdf;
            }
        } catch (e) {
            dispatchAnalyticsEvent?.({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
        }
        return result;
    };
    const $af6d4930d9141440$var$memoValidation = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_validation, (newArgs, lastArgs)=>{
        const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
        const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
        const result = $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
        return result;
    });
    const $af6d4930d9141440$var$areDocsEqual = (docA, docB)=>{
        if (docA === docB) return true;
        if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
        if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
        return JSON.stringify(docA) === JSON.stringify(docB);
    };
    const $af6d4930d9141440$var$_serializeFragment = (serializer, doc)=>{
        return serializer.serializeFragment(doc.content);
    };
    const $af6d4930d9141440$var$memoSerializeFragment = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_serializeFragment, (newArgs, lastArgs)=>{
        const [newSerializer, newDoc] = newArgs;
        const [oldSerializer, oldDoc] = lastArgs;
        return newSerializer === oldSerializer && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
    });
    const $af6d4930d9141440$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
        const pmNode = schema.nodeFromJSON(doc);
        try {
            pmNode.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    errorStack: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        }
        return pmNode;
    };
    const $af6d4930d9141440$var$memoCreateNodeAndCheck = (0, (0, parcelRequire("8QpSo")).default)($af6d4930d9141440$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
        const [newSchema, newDoc] = newArgs;
        const [oldSchema, oldDoc] = lastArgs;
        return newSchema === oldSchema && $af6d4930d9141440$var$areDocsEqual(newDoc, oldDoc);
    });
    const $af6d4930d9141440$export$59a54f98b9753d5c = (doc, serializer, schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats)=>{
        const stat = {
            sanitizeTime: 0
        };
        const { output: validDoc, time: sanitizeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
        });
        stat.sanitizeTime = sanitizeTime;
        if (!validDoc) return {
            stat: stat,
            result: null
        };
        const { output: node, time: buildTreeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
        });
        stat.buildTreeTime = buildTreeTime;
        const { output: result, time: serializeTime } = $af6d4930d9141440$var$withStopwatch(()=>{
            return $af6d4930d9141440$var$memoSerializeFragment(serializer, node);
        });
        stat.serializeTime = serializeTime;
        if (dispatchAnalyticsEvent && useSpecBasedValidator) {
            (0, (0, parcelRequire("d54NZ")).findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
            if (unsupportedContentLevelsTracking?.enabled) {
                const documentData = {
                    doc: validDoc,
                    appearance: appearance,
                    rendererId: rendererId
                };
                (0, (0, parcelRequire("1cjf7")).trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
            }
        }
        if (includeNodesCountInStats) stat.nodesCount = (0, (0, parcelRequire("kgV4b")).countNodes)(doc);
        return {
            result: result,
            stat: stat,
            pmDoc: node
        };
    };
});
parcelRegister("4IuOY", function(module, exports) {
    $parcel$export(module.exports, "validateADFEntity", ()=>$2c0bbb60cfee2804$export$884cfad20dece33e);
    var $905ey;
    var $gkwXh;
    var $d54NZ;
    const $2c0bbb60cfee2804$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
    const $2c0bbb60cfee2804$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
        return (entity, error, options)=>{
            return $2c0bbb60cfee2804$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
        };
    };
    const $2c0bbb60cfee2804$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
        if (entity && entity.type === $2c0bbb60cfee2804$export$8e7fd962b4d3895d) return entity;
        if (options.isMark) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(error.meta, 'mark');
        if (options.isNodeAttribute) {
            const entityType = entity && entity.type ? entity.type : undefined;
            return {
                type: $2c0bbb60cfee2804$export$8e7fd962b4d3895d,
                attrs: {
                    type: {
                        nodeType: entityType
                    },
                    unsupported: error.meta
                }
            };
        }
        if (entity && marks.indexOf(entity.type) > -1) return;
        if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
            type: 'paragraph',
            content: []
        };
        if (error.code === 'INVALID_CONTENT_LENGTH') {
            if (error.meta && options.allowUnsupportedBlock && entity.content) return $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
            else if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        }
        if (options.allowUnsupportedBlock) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
        if (options.allowUnsupportedInline) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity, 'inline');
        if (dispatchAnalyticsEvent) $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
        return entity;
    };
    function $2c0bbb60cfee2804$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
        const meta = error.meta;
        if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
            return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : validate(child, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
        });
        if (meta.type === 'minimum') {
            if (entity.content.length === 0) return $2c0bbb60cfee2804$export$87b732fa69cdf16e(entity);
            entity.content = entity.content.filter((x)=>!!x).map((child)=>{
                return child.type !== 'unsupportedBlock' ? $2c0bbb60cfee2804$export$87b732fa69cdf16e(child) : child;
            });
        }
        return entity;
    }
    function $2c0bbb60cfee2804$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
        if (!dispatchAnalyticsEvent) return;
        (0, (0, parcelRequire("d54NZ")).fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
            type: entity.type || '',
            ancestry: entity.ancestorHierarchy || '',
            parentType: entity.parentType || '',
            marks: entity.marks || [],
            attrs: entity.attrs || {}
        }, error.code);
    }
    const $2c0bbb60cfee2804$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
        const nodes = Object.keys(schema.nodes);
        const marks = Object.keys(schema.marks);
        const validate = (0, (0, parcelRequire("905ey")).validator)(nodes, marks, {
            allowPrivateAttributes: true
        });
        const emptyDoc = {
            type: 'doc',
            content: []
        };
        const { entity: entity = emptyDoc } = validate(node, $2c0bbb60cfee2804$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
        return entity;
    };
    function $2c0bbb60cfee2804$export$87b732fa69cdf16e(originalValue, type = 'block') {
        let unsupportedNodeType;
        switch(type){
            case 'inline':
                unsupportedNodeType = 'unsupportedInline';
                break;
            case 'mark':
                unsupportedNodeType = 'unsupportedMark';
                break;
            default:
                unsupportedNodeType = 'unsupportedBlock';
        }
        return {
            type: unsupportedNodeType,
            attrs: {
                originalValue: originalValue
            }
        };
    }
});
parcelRegister("905ey", function(module, exports) {
    $parcel$export(module.exports, "validator", ()=>$e861220f24467804$export$956325f45c5d174a);
    var $gsiq1;
    var $iiazc;
    var $1H4Aw;
    function $e861220f24467804$var$mapMarksItems(spec, fn = (x)=>x) {
        if (spec.props && spec.props.marks) {
            const { items: items, ...rest } = spec.props.marks;
            return {
                ...spec,
                props: {
                    ...spec.props,
                    marks: {
                        ...rest,
                        items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                            fn(items)
                        ] : [
                            []
                        ]
                    }
                }
            };
        } else return spec;
    }
    const $e861220f24467804$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
            const result = predicate(key, obj[key], obj);
            acc[result ? 0 : 1].push(key);
            return acc;
        }, [
            [],
            []
        ]);
    function $e861220f24467804$var$createSpec(nodes, marks) {
        return Object.keys((0, parcelRequire("gsiq1"))).reduce((newSpecs, k)=>{
            const spec = {
                ...(0, parcelRequire("gsiq1"))[k]
            };
            if (spec.props) {
                spec.props = {
                    ...spec.props
                };
                if (spec.props.content) {
                    if ((0, (0, parcelRequire("iiazc")).isString)(spec.props.content)) spec.props.content = (0, parcelRequire("gsiq1"))[spec.props.content];
                    if (Array.isArray(spec.props.content)) spec.props.content = {
                        type: 'array',
                        items: (spec.props.content || []).map((arr)=>arr.items)
                    };
                    else spec.props.content = {
                        ...spec.props.content
                    };
                    spec.props.content.items = spec.props.content.items.map((item)=>(0, (0, parcelRequire("iiazc")).isString)(item) ? Array.isArray((0, parcelRequire("gsiq1"))[item]) ? (0, parcelRequire("gsiq1"))[item] : [
                            item
                        ] : item).map((item)=>item.map((subItem)=>Array.isArray((0, parcelRequire("gsiq1"))[subItem]) ? (0, parcelRequire("gsiq1"))[subItem] : (0, (0, parcelRequire("iiazc")).isString)(subItem) ? subItem : [
                                'text',
                                subItem
                            ]).filter((subItem)=>{
                            if (nodes) {
                                if (Array.isArray(subItem)) {
                                    const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                    if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                    return isMainNodeSupported;
                                }
                                return nodes.indexOf(subItem) > -1;
                            }
                            return true;
                        }).map((subItem)=>Array.isArray(subItem) && marks ? [
                                subItem[0],
                                $e861220f24467804$var$mapMarksItems(subItem[1])
                            ] : subItem));
                }
            }
            newSpecs[k] = spec;
            return newSpecs;
        }, {});
    }
    function $e861220f24467804$var$getOptionsForType(type, list) {
        if (!list) return {};
        for(let i = 0, len = list.length; i < len; i++){
            const spec = list[i];
            let name = spec;
            let options = {};
            if (Array.isArray(spec)) [name, options] = spec;
            if (name === type) return options;
        }
        return false;
    }
    const $e861220f24467804$var$isValidatorSpecAttrs = (spec)=>{
        return !!spec.props;
    };
    function $e861220f24467804$export$66c739158ef99a42(spec, value) {
        if (!(0, (0, parcelRequire("iiazc")).isDefined)(value)) return !!spec.optional;
        if ($e861220f24467804$var$isValidatorSpecAttrs(spec)) {
            const [_, invalidKeys] = $e861220f24467804$var$partitionObject(spec.props, (key, subSpec)=>$e861220f24467804$export$66c739158ef99a42(subSpec, value[key]));
            return invalidKeys.length === 0;
        }
        if (!(0, (0, parcelRequire("iiazc")).isDefined)(spec.type)) return !!spec.optional;
        switch(spec.type){
            case 'boolean':
                return (0, (0, parcelRequire("iiazc")).isBoolean)(value);
            case 'number':
                return (0, (0, parcelRequire("iiazc")).isNumber)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'integer':
                return (0, (0, parcelRequire("iiazc")).isInteger)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.maximum) ? spec.maximum >= value : true);
            case 'string':
                const validatorFnPassed = (rule)=>typeof value === 'string' && (0, (0, parcelRequire("iiazc")).isDefined)((0, (0, parcelRequire("1H4Aw")).validatorFnMap)[rule]) && (0, (0, parcelRequire("1H4Aw")).validatorFnMap)[rule](value);
                return (0, (0, parcelRequire("iiazc")).isString)(value) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, (0, parcelRequire("iiazc")).isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
            case 'object':
                return (0, (0, parcelRequire("iiazc")).isPlainObject)(value);
            case 'array':
                if (Array.isArray(value)) {
                    const isTuple = !!spec.isTupleLike;
                    const { minItems: minItems, maxItems: maxItems } = spec;
                    if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                    if (isTuple) {
                        const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                        return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$e861220f24467804$export$66c739158ef99a42(spec.items[i], value[i]));
                    } else return value.every((valueItem)=>spec.items.some((itemSpec)=>$e861220f24467804$export$66c739158ef99a42(itemSpec, valueItem)));
                }
                return false;
            case 'enum':
                return (0, (0, parcelRequire("iiazc")).isString)(value) && spec.values.indexOf(value) > -1;
        }
    }
    const $e861220f24467804$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
    const $e861220f24467804$var$getUnsupportedOptions = (spec)=>{
        if (spec && spec.props && spec.props.content) {
            const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
            return {
                allowUnsupportedBlock: allowUnsupportedBlock,
                allowUnsupportedInline: allowUnsupportedInline
            };
        }
        return {};
    };
    const $e861220f24467804$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
        const message = $e861220f24467804$var$errorMessageFor(child.type, 'invalid content');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message
        }, $e861220f24467804$var$getUnsupportedOptions(parentSpec));
    };
    const $e861220f24467804$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
        const message = errorMessage || $e861220f24467804$var$errorMessageFor(mark.type, 'unsupported mark');
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            ...mark
        }, {
            code: errorCode,
            message: message,
            meta: mark
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: true
        });
    };
    const $e861220f24467804$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
        if (!errorCallback) throw new Error(message);
        else return errorCallback({
            type: entity.type
        }, {
            code: errorCode,
            message: message,
            meta: invalidAttributes
        }, {
            allowUnsupportedBlock: false,
            allowUnsupportedInline: false,
            isMark: false,
            isNodeAttribute: true
        });
    };
    function $e861220f24467804$export$956325f45c5d174a(nodes, marks, options) {
        const validatorSpecs = $e861220f24467804$var$createSpec(nodes, marks);
        const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
        const validate = (entity, errorCallback, allowed, parentSpec)=>{
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        };
        const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
            const { type: type } = entity;
            let newEntity = {
                ...entity
            };
            const err = (code, msg, meta)=>{
                const message = $e861220f24467804$var$errorMessageFor(type, msg);
                if (errorCallback) return {
                    valid: false,
                    entity: errorCallback(newEntity, {
                        code: code,
                        message: message,
                        meta: meta
                    }, $e861220f24467804$var$getUnsupportedOptions(parentSpec))
                };
                else throw new Error(message);
            };
            if (type) {
                const typeOptions = $e861220f24467804$var$getOptionsForType(type, allowed);
                if (typeOptions === false) return isMark ? {
                    valid: false
                } : err('INVALID_TYPE', 'type not allowed here');
                const spec = validatorSpecs[type];
                if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
                const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
                if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
            } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
            return {
                valid: true,
                entity: newEntity
            };
        };
        return validate;
        function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
            let validationResult;
            if (validator.props && validator.props.marks) {
                const marksSet = allowedMarksFor(validator);
                const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
                validationResult = {
                    valid: true,
                    entity: newEntity,
                    marksValidationOutput: marksValidationResult
                };
            } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
            return validationResult;
        }
        function validatorFor(spec, typeOptions) {
            return {
                ...spec,
                ...typeOptions,
                ...spec.props ? {
                    props: {
                        ...spec.props,
                        ...typeOptions['props'] || {}
                    }
                } : {}
            };
        }
        function marksAfterValidation(entity, errorCallback, marksSet, validator) {
            return entity.marks ? entity.marks.map((mark)=>{
                const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
                if (mode === 'strict' && isAKnownMark) {
                    const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                    const finalMark = finalResult.entity;
                    if (finalMark) return {
                        valid: true,
                        originalMark: mark,
                        newMark: finalMark
                    };
                    else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                        valid: false,
                        originalMark: mark,
                        errorCode: finalResult.marksValidationOutput[0].errorCode,
                        message: finalResult.marksValidationOutput[0].message
                    };
                    else return {
                        valid: false,
                        originalMark: mark,
                        errorCode: 'INVALID_TYPE'
                    };
                } else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_CONTENT'
                };
            }) : [];
        }
        function allowedMarksFor(validator) {
            const { items: items } = validator.props.marks;
            const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
            return marksSet;
        }
        function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
            const errorCode = 'REDUNDANT_MARKS';
            const currentMarks = prevEntity.marks || [];
            const newMarks = currentMarks.map((mark)=>{
                const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
                if (isUnsupportedNodeAttributeMark) return mark;
                return $e861220f24467804$var$unsupportedMarkContent(errorCode, mark, errorCallback);
            });
            if (newMarks.length) {
                newEntity.marks = newMarks;
                return {
                    valid: true,
                    entity: newEntity
                };
            } else return err('REDUNDANT_MARKS', 'redundant marks', {
                marks: Object.keys(currentMarks)
            });
        }
        function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.required) {
                if (!validatorSpec.required.every((prop)=>(0, (0, parcelRequire("iiazc")).isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
            }
            return result;
        }
        function textPropertyValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.text) {
                if ((0, (0, parcelRequire("iiazc")).isDefined)(prevEntity.text) && !$e861220f24467804$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
            }
            return result;
        }
        function contentLengthValidationFor(validatorSpec, prevEntity, err) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            if (validatorSpec.props.content && prevEntity.content) {
                const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
                const length = prevEntity.content.length;
                if ((0, (0, parcelRequire("iiazc")).isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                    length: length,
                    requiredLength: minItems,
                    type: 'minimum'
                });
                else if ((0, (0, parcelRequire("iiazc")).isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                    length: length,
                    requiredLength: maxItems,
                    type: 'maximum'
                });
            }
            return result;
        }
        function invalidAttributesFor(validatorSpec, prevEntity) {
            let invalidAttrs = [];
            let validatorAttrs = {};
            if (validatorSpec.props && validatorSpec.props.attrs) {
                const attrOptions = (0, (0, parcelRequire("iiazc")).makeArray)(validatorSpec.props.attrs);
                for(let i = 0, length = attrOptions.length; i < length; ++i){
                    const attrOption = attrOptions[i];
                    if (attrOption && attrOption.props) [, invalidAttrs] = $e861220f24467804$var$partitionObject(attrOption.props, (key, spec)=>{
                        const valueToValidate = prevEntity.attrs[key];
                        return $e861220f24467804$export$66c739158ef99a42(spec, valueToValidate);
                    });
                    validatorAttrs = attrOption;
                    if (!invalidAttrs.length) break;
                }
            }
            return {
                invalidAttrs: invalidAttrs,
                validatorAttrs: validatorAttrs
            };
        }
        function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
            const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
            if (prevEntity.attrs) {
                if (!validatorSpecAllowsAttributes) {
                    if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                    const attrs = Object.keys(prevEntity.attrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
                }
                const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
                if (hasUnsupportedAttrs) {
                    if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                    return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
                }
            }
            return {
                valid: true,
                entity: prevEntity
            };
        }
        function validateAttributes(validatorSpec, prevEntity, attributes) {
            const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
            const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
            const validatorAttrs = invalidAttributesResult.validatorAttrs;
            const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
            const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
            const hasRedundantAttrs = redundantAttrs.length > 0;
            const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
            return {
                hasUnsupportedAttrs: hasUnsupportedAttrs,
                invalidAttrs: invalidAttrs,
                redundantAttrs: redundantAttrs
            };
        }
        function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
            const attr = invalidAttrs.concat(redundantAttrs);
            let result = {
                valid: true,
                entity: prevEntity
            };
            const message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const errorCode = 'UNSUPPORTED_ATTRIBUTES';
            newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
            result = {
                valid: true,
                entity: newEntity
            };
            return result;
        }
        function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
            let errorCode = 'INVALID_ATTRIBUTES';
            let message = $e861220f24467804$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
            const hasRedundantAttrs = redundantAttrs.length;
            const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
            if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
                errorCode = 'REDUNDANT_ATTRIBUTES';
                message = $e861220f24467804$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
            }
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
            const message = $e861220f24467804$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
            const errorCode = 'REDUNDANT_ATTRIBUTES';
            const markValidationResult = {
                valid: true,
                originalMark: prevEntity,
                errorCode: errorCode,
                message: message
            };
            return {
                valid: false,
                marksValidationOutput: [
                    markValidationResult
                ]
            };
        }
        function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
            let invalidValues = {};
            for(let invalidAttr in invalidAttrs){
                invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
                if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
            }
            const unsupportedNodeAttributeValues = $e861220f24467804$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
            const finalEntity = {
                ...newEntity
            };
            if (finalEntity.marks) {
                if (!unsupportedNodeAttributeValues) return finalEntity.marks;
                const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
                if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
                else finalEntity.marks.push(unsupportedNodeAttributeValues);
                return finalEntity.marks;
            } else return [
                unsupportedNodeAttributeValues
            ];
        }
        function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
            let result = {
                valid: true,
                entity: prevEntity
            };
            const [requiredProps, redundantProps] = $e861220f24467804$var$partitionObject(prevEntity, (k)=>(0, (0, parcelRequire("iiazc")).isDefined)(validatorSpec.props[k]));
            if (redundantProps.length) {
                if (mode === 'loose') {
                    newEntity = {
                        type: type
                    };
                    requiredProps.reduce((acc, p)=>(0, (0, parcelRequire("iiazc")).copy)(prevEntity, acc, p), newEntity);
                } else {
                    if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                        props: redundantProps
                    });
                }
            }
            return result;
        }
        function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
            let specBasedValidationResult = {
                hasValidated: false
            };
            const validatorSpec = validatorFor(spec, typeOptions);
            if (!validatorSpec) return specBasedValidationResult;
            const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!requiredPropertyValidatonResult.valid) return {
                hasValidated: true,
                result: requiredPropertyValidatonResult
            };
            if (!validatorSpec.props) {
                const props = Object.keys(prevEntity);
                if (props.length > 1) return {
                    hasValidated: true,
                    result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                        props: props
                    })
                };
                return specBasedValidationResult;
            }
            const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
            if (!textPropertyValidationResult.valid) return {
                hasValidated: true,
                result: textPropertyValidationResult
            };
            const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
            if (!contentLengthValidationResult.valid) return {
                hasValidated: true,
                result: contentLengthValidationResult
            };
            const [, missingProps] = $e861220f24467804$var$partitionObject(validatorSpec.props, (k, v)=>{
                const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
                return isOptional || (0, (0, parcelRequire("iiazc")).isDefined)(prevEntity[k]);
            });
            if (missingProps.length) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'required prop missing', {
                    props: missingProps
                })
            };
            const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
            if (!attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            if (isMark && attributesValidationResult.valid) return {
                hasValidated: true,
                result: attributesValidationResult
            };
            const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
            if (!extraPropsValidationResult.valid) return {
                hasValidated: true,
                result: extraPropsValidationResult
            };
            if (validatorSpec.props.content) {
                const contentValidatorSpec = validatorSpec.props.content;
                if (prevEntity.content) {
                    const validateChildNode = (child, index)=>{
                        if (child === undefined) return child;
                        const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                            let marksAreValid = true;
                            if (childEntity && childEntity.marks && marksValidationOutput) {
                                const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                                const finalMarks = marksValidationOutput.map((mr)=>{
                                    if (mr.valid) return mr.newMark;
                                    else {
                                        if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $e861220f24467804$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                        return;
                                    }
                                }).filter(Boolean);
                                if (finalMarks.length) childEntity.marks = finalMarks;
                                else {
                                    delete childEntity.marks;
                                    marksAreValid = false;
                                }
                            }
                            return {
                                valid: marksAreValid,
                                entity: childEntity
                            };
                        };
                        const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                        if (hasMultipleCombinationOfContentAllowed) {
                            const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, (0, parcelRequire("iiazc")).makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                            const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                            return entity;
                        }
                        const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some((spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                        if (allowedSpecsForEntity.length) {
                            if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                            const maybeArray = (0, (0, parcelRequire("iiazc")).makeArray)(allowedSpecsForEntity[0]);
                            const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                            if (allowedSpecsForChild.length === 0) return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                            let firstError;
                            let firstChild;
                            for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                                const allowedValueForCurrentSpec = [
                                    allowedSpecsForChild[i]
                                ];
                                const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                                if (valid) {
                                    const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                    const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                    const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                    if (marksAreValid && !unsupportedMarks.length) return entity;
                                    else firstChild = firstChild || newChildEntity;
                                } else firstChild = firstChild || newChildEntity;
                            } catch (error) {
                                firstError = firstError || error;
                            }
                            if (!errorCallback) throw firstError;
                            else return firstChild;
                        } else return $e861220f24467804$var$invalidChildContent(child, errorCallback, validatorSpec);
                    };
                    newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
                } else if (!contentValidatorSpec.optional) return {
                    hasValidated: true,
                    result: err('MISSING_PROPERTIES', 'missing `content` prop')
                };
            }
            if (prevEntity.marks) return {
                hasValidated: true,
                result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
            };
            return specBasedValidationResult;
        }
    }
});
parcelRegister("gsiq1", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>(parcelRequire("5fjVx")).alignment);
    $parcel$export(module.exports, "annotation", ()=>(parcelRequire("5fjVx")).annotation);
    $parcel$export(module.exports, "backgroundColor", ()=>(parcelRequire("5fjVx")).backgroundColor);
    $parcel$export(module.exports, "blockCard", ()=>(parcelRequire("5fjVx")).blockCard);
    $parcel$export(module.exports, "block_content", ()=>(parcelRequire("5fjVx")).block_content);
    $parcel$export(module.exports, "blockRootOnly", ()=>(parcelRequire("5fjVx")).blockRootOnly);
    $parcel$export(module.exports, "blockquote", ()=>(parcelRequire("5fjVx")).blockquote);
    $parcel$export(module.exports, "bodiedExtension", ()=>(parcelRequire("5fjVx")).bodiedExtension);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>(parcelRequire("5fjVx")).bodiedExtension_with_marks);
    $parcel$export(module.exports, "border", ()=>(parcelRequire("5fjVx")).border);
    $parcel$export(module.exports, "breakout", ()=>(parcelRequire("5fjVx")).breakout);
    $parcel$export(module.exports, "bulletList", ()=>(parcelRequire("5fjVx")).bulletList);
    $parcel$export(module.exports, "caption", ()=>(parcelRequire("5fjVx")).caption);
    $parcel$export(module.exports, "code", ()=>(parcelRequire("5fjVx")).code);
    $parcel$export(module.exports, "codeBlock", ()=>(parcelRequire("5fjVx")).codeBlock);
    $parcel$export(module.exports, "codeBlock_root_only", ()=>(parcelRequire("5fjVx")).codeBlock_root_only);
    $parcel$export(module.exports, "text_with_no_marks", ()=>(parcelRequire("5fjVx")).text_with_no_marks);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>(parcelRequire("5fjVx")).confluenceInlineComment);
    $parcel$export(module.exports, "dataConsumer", ()=>(parcelRequire("5fjVx")).dataConsumer);
    $parcel$export(module.exports, "date", ()=>(parcelRequire("5fjVx")).date);
    $parcel$export(module.exports, "decisionItem", ()=>(parcelRequire("5fjVx")).decisionItem);
    $parcel$export(module.exports, "decisionList", ()=>(parcelRequire("5fjVx")).decisionList);
    $parcel$export(module.exports, "doc", ()=>(parcelRequire("5fjVx")).doc);
    $parcel$export(module.exports, "em", ()=>(parcelRequire("5fjVx")).em);
    $parcel$export(module.exports, "embedCard", ()=>(parcelRequire("5fjVx")).embedCard);
    $parcel$export(module.exports, "emoji", ()=>(parcelRequire("5fjVx")).emoji);
    $parcel$export(module.exports, "expand", ()=>(parcelRequire("5fjVx")).expand);
    $parcel$export(module.exports, "expand_root_only", ()=>(parcelRequire("5fjVx")).expand_root_only);
    $parcel$export(module.exports, "extension", ()=>(parcelRequire("5fjVx")).extension);
    $parcel$export(module.exports, "extensionFrame", ()=>(parcelRequire("5fjVx")).extensionFrame);
    $parcel$export(module.exports, "extension_with_marks", ()=>(parcelRequire("5fjVx")).extension_with_marks);
    $parcel$export(module.exports, "fragment", ()=>(parcelRequire("5fjVx")).fragment);
    $parcel$export(module.exports, "hardBreak", ()=>(parcelRequire("5fjVx")).hardBreak);
    $parcel$export(module.exports, "heading", ()=>(parcelRequire("5fjVx")).heading);
    $parcel$export(module.exports, "heading_with_alignment", ()=>(parcelRequire("5fjVx")).heading_with_alignment);
    $parcel$export(module.exports, "heading_with_indentation", ()=>(parcelRequire("5fjVx")).heading_with_indentation);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>(parcelRequire("5fjVx")).heading_with_no_marks);
    $parcel$export(module.exports, "indentation", ()=>(parcelRequire("5fjVx")).indentation);
    $parcel$export(module.exports, "inlineCard", ()=>(parcelRequire("5fjVx")).inlineCard);
    $parcel$export(module.exports, "inlineExtension", ()=>(parcelRequire("5fjVx")).inlineExtension);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>(parcelRequire("5fjVx")).inlineExtension_with_marks);
    $parcel$export(module.exports, "inline_content", ()=>(parcelRequire("5fjVx")).inline_content);
    $parcel$export(module.exports, "layoutColumn", ()=>(parcelRequire("5fjVx")).layoutColumn);
    $parcel$export(module.exports, "layoutSection", ()=>(parcelRequire("5fjVx")).layoutSection);
    $parcel$export(module.exports, "layoutSection_full", ()=>(parcelRequire("5fjVx")).layoutSection_full);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>(parcelRequire("5fjVx")).layoutSection_with_single_column);
    $parcel$export(module.exports, "link", ()=>(parcelRequire("5fjVx")).link);
    $parcel$export(module.exports, "listItem", ()=>(parcelRequire("5fjVx")).listItem);
    $parcel$export(module.exports, "media", ()=>(parcelRequire("5fjVx")).media);
    $parcel$export(module.exports, "mediaGroup", ()=>(parcelRequire("5fjVx")).mediaGroup);
    $parcel$export(module.exports, "mediaInline", ()=>(parcelRequire("5fjVx")).mediaInline);
    $parcel$export(module.exports, "mediaSingle", ()=>(parcelRequire("5fjVx")).mediaSingle);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>(parcelRequire("5fjVx")).mediaSingle_caption);
    $parcel$export(module.exports, "mediaSingle_full", ()=>(parcelRequire("5fjVx")).mediaSingle_full);
    $parcel$export(module.exports, "mention", ()=>(parcelRequire("5fjVx")).mention);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>(parcelRequire("5fjVx")).multiBodiedExtension);
    $parcel$export(module.exports, "nestedExpand", ()=>(parcelRequire("5fjVx")).nestedExpand);
    $parcel$export(module.exports, "nestedExpand_content", ()=>(parcelRequire("5fjVx")).nestedExpand_content);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>(parcelRequire("5fjVx")).nestedExpand_with_no_marks);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>(parcelRequire("5fjVx")).non_nestable_block_content);
    $parcel$export(module.exports, "orderedList", ()=>(parcelRequire("5fjVx")).orderedList);
    $parcel$export(module.exports, "panel", ()=>(parcelRequire("5fjVx")).panel);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>(parcelRequire("5fjVx")).panel_with_nested_blockquote);
    $parcel$export(module.exports, "paragraph", ()=>(parcelRequire("5fjVx")).paragraph);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>(parcelRequire("5fjVx")).paragraph_with_alignment);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>(parcelRequire("5fjVx")).paragraph_with_indentation);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>(parcelRequire("5fjVx")).paragraph_with_no_marks);
    $parcel$export(module.exports, "placeholder", ()=>(parcelRequire("5fjVx")).placeholder);
    $parcel$export(module.exports, "rule", ()=>(parcelRequire("5fjVx")).rule);
    $parcel$export(module.exports, "status", ()=>(parcelRequire("5fjVx")).status);
    $parcel$export(module.exports, "strike", ()=>(parcelRequire("5fjVx")).strike);
    $parcel$export(module.exports, "strong", ()=>(parcelRequire("5fjVx")).strong);
    $parcel$export(module.exports, "subsup", ()=>(parcelRequire("5fjVx")).subsup);
    $parcel$export(module.exports, "table", ()=>(parcelRequire("5fjVx")).table);
    $parcel$export(module.exports, "tableCell", ()=>(parcelRequire("5fjVx")).tableCell);
    $parcel$export(module.exports, "tableHeader", ()=>(parcelRequire("5fjVx")).tableHeader);
    $parcel$export(module.exports, "tableRow", ()=>(parcelRequire("5fjVx")).tableRow);
    $parcel$export(module.exports, "taskItem", ()=>(parcelRequire("5fjVx")).taskItem);
    $parcel$export(module.exports, "taskList", ()=>(parcelRequire("5fjVx")).taskList);
    $parcel$export(module.exports, "text", ()=>(parcelRequire("5fjVx")).text);
    $parcel$export(module.exports, "textColor", ()=>(parcelRequire("5fjVx")).textColor);
    $parcel$export(module.exports, "text_code_inline", ()=>(parcelRequire("5fjVx")).text_code_inline);
    $parcel$export(module.exports, "text_formatted", ()=>(parcelRequire("5fjVx")).text_formatted);
    $parcel$export(module.exports, "text_link_inline", ()=>(parcelRequire("5fjVx")).text_link_inline);
    $parcel$export(module.exports, "underline", ()=>(parcelRequire("5fjVx")).underline);
    var $5fjVx;
});
parcelRegister("5fjVx", function(module, exports) {
    $parcel$export(module.exports, "alignment", ()=>$3d1dcf8b9eccd1a7$export$8e53000a4ec837);
    $parcel$export(module.exports, "annotation", ()=>$3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b);
    $parcel$export(module.exports, "backgroundColor", ()=>$3d1dcf8b9eccd1a7$export$8c5a050822fd698c);
    $parcel$export(module.exports, "block_content", ()=>$3d1dcf8b9eccd1a7$export$a31afb40076fa18b);
    $parcel$export(module.exports, "blockCard", ()=>$3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8);
    $parcel$export(module.exports, "blockquote", ()=>$3d1dcf8b9eccd1a7$export$67dc04e652a298ca);
    $parcel$export(module.exports, "blockRootOnly", ()=>$3d1dcf8b9eccd1a7$export$ebb5393736e9ba23);
    $parcel$export(module.exports, "bodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$27903d543b563e39);
    $parcel$export(module.exports, "bodiedExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$ee052cc5b2356e83);
    $parcel$export(module.exports, "border", ()=>$3d1dcf8b9eccd1a7$export$1edee58a52776cd9);
    $parcel$export(module.exports, "breakout", ()=>$3d1dcf8b9eccd1a7$export$89015c65f1c75e3f);
    $parcel$export(module.exports, "bulletList", ()=>$3d1dcf8b9eccd1a7$export$a140c94e5ea26bee);
    $parcel$export(module.exports, "caption", ()=>$3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d);
    $parcel$export(module.exports, "code", ()=>$3d1dcf8b9eccd1a7$export$6565f9f03506010b);
    $parcel$export(module.exports, "codeBlock", ()=>$3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4);
    $parcel$export(module.exports, "codeBlock_root_only", ()=>$3d1dcf8b9eccd1a7$export$38d90d1aac6883a3);
    $parcel$export(module.exports, "confluenceInlineComment", ()=>$3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd);
    $parcel$export(module.exports, "dataConsumer", ()=>$3d1dcf8b9eccd1a7$export$3024f02c495408d6);
    $parcel$export(module.exports, "date", ()=>$3d1dcf8b9eccd1a7$export$324d90190a8b822a);
    $parcel$export(module.exports, "decisionItem", ()=>$3d1dcf8b9eccd1a7$export$6959e16eeff859b4);
    $parcel$export(module.exports, "decisionList", ()=>$3d1dcf8b9eccd1a7$export$62d45a65fb43d95e);
    $parcel$export(module.exports, "doc", ()=>$3d1dcf8b9eccd1a7$export$2a111da947c407d2);
    $parcel$export(module.exports, "em", ()=>$3d1dcf8b9eccd1a7$export$c63c6f932822f543);
    $parcel$export(module.exports, "embedCard", ()=>$3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6);
    $parcel$export(module.exports, "emoji", ()=>$3d1dcf8b9eccd1a7$export$a19185d1233fc4b2);
    $parcel$export(module.exports, "expand", ()=>$3d1dcf8b9eccd1a7$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "expand_root_only", ()=>$3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c);
    $parcel$export(module.exports, "extension", ()=>$3d1dcf8b9eccd1a7$export$1b45514b112dd749);
    $parcel$export(module.exports, "extension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$15be7c145cec614a);
    $parcel$export(module.exports, "extensionFrame", ()=>$3d1dcf8b9eccd1a7$export$4fdcae991fd743e7);
    $parcel$export(module.exports, "fragment", ()=>$3d1dcf8b9eccd1a7$export$f00aeb236b6f05af);
    $parcel$export(module.exports, "hardBreak", ()=>$3d1dcf8b9eccd1a7$export$371da9dd35aba193);
    $parcel$export(module.exports, "heading", ()=>$3d1dcf8b9eccd1a7$export$46e4a324ac90507f);
    $parcel$export(module.exports, "heading_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$c17edf9af655deaf);
    $parcel$export(module.exports, "heading_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$1902f9737466a0dc);
    $parcel$export(module.exports, "heading_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$7b491e75f1be9278);
    $parcel$export(module.exports, "indentation", ()=>$3d1dcf8b9eccd1a7$export$480c699bd4ec0d86);
    $parcel$export(module.exports, "inline_content", ()=>$3d1dcf8b9eccd1a7$export$e23e6162adaa368d);
    $parcel$export(module.exports, "inlineCard", ()=>$3d1dcf8b9eccd1a7$export$cbf8224b64e0d942);
    $parcel$export(module.exports, "inlineExtension", ()=>$3d1dcf8b9eccd1a7$export$16b353b2649bd8d9);
    $parcel$export(module.exports, "inlineExtension_with_marks", ()=>$3d1dcf8b9eccd1a7$export$e37f10815f36843d);
    $parcel$export(module.exports, "layoutColumn", ()=>$3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650);
    $parcel$export(module.exports, "layoutSection", ()=>$3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be);
    $parcel$export(module.exports, "layoutSection_full", ()=>$3d1dcf8b9eccd1a7$export$941b63fbd931e449);
    $parcel$export(module.exports, "layoutSection_with_single_column", ()=>$3d1dcf8b9eccd1a7$export$e0e9834198e8601d);
    $parcel$export(module.exports, "link", ()=>$3d1dcf8b9eccd1a7$export$9c30223ca0a664fb);
    $parcel$export(module.exports, "listItem", ()=>$3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05);
    $parcel$export(module.exports, "media", ()=>$3d1dcf8b9eccd1a7$export$987d49ffe1b0900f);
    $parcel$export(module.exports, "mediaGroup", ()=>$3d1dcf8b9eccd1a7$export$2855e964765eac9);
    $parcel$export(module.exports, "mediaInline", ()=>$3d1dcf8b9eccd1a7$export$38bab695e3f720f1);
    $parcel$export(module.exports, "mediaSingle", ()=>$3d1dcf8b9eccd1a7$export$969fe3781ca15058);
    $parcel$export(module.exports, "mediaSingle_caption", ()=>$3d1dcf8b9eccd1a7$export$68b0ead306f9670f);
    $parcel$export(module.exports, "mediaSingle_full", ()=>$3d1dcf8b9eccd1a7$export$f7fd577406abd5f8);
    $parcel$export(module.exports, "mention", ()=>$3d1dcf8b9eccd1a7$export$db83999c14438df4);
    $parcel$export(module.exports, "multiBodiedExtension", ()=>$3d1dcf8b9eccd1a7$export$c3c04d555a8b9013);
    $parcel$export(module.exports, "nestedExpand", ()=>$3d1dcf8b9eccd1a7$export$63cadbf5f4296627);
    $parcel$export(module.exports, "nestedExpand_content", ()=>$3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e);
    $parcel$export(module.exports, "nestedExpand_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f);
    $parcel$export(module.exports, "non_nestable_block_content", ()=>$3d1dcf8b9eccd1a7$export$ed866000601e7fa5);
    $parcel$export(module.exports, "orderedList", ()=>$3d1dcf8b9eccd1a7$export$a5dc81035676e7a);
    $parcel$export(module.exports, "panel", ()=>$3d1dcf8b9eccd1a7$export$21f42ab9b6679f44);
    $parcel$export(module.exports, "panel_with_nested_blockquote", ()=>$3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3);
    $parcel$export(module.exports, "paragraph", ()=>$3d1dcf8b9eccd1a7$export$9c206ddddb32a9b);
    $parcel$export(module.exports, "paragraph_with_alignment", ()=>$3d1dcf8b9eccd1a7$export$9ca11c06877e5c64);
    $parcel$export(module.exports, "paragraph_with_indentation", ()=>$3d1dcf8b9eccd1a7$export$a3bd66932996fb7d);
    $parcel$export(module.exports, "paragraph_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5);
    $parcel$export(module.exports, "placeholder", ()=>$3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "rule", ()=>$3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7);
    $parcel$export(module.exports, "status", ()=>$3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1);
    $parcel$export(module.exports, "strike", ()=>$3d1dcf8b9eccd1a7$export$4899a95d70ec5056);
    $parcel$export(module.exports, "strong", ()=>$3d1dcf8b9eccd1a7$export$59ae2c325a998f89);
    $parcel$export(module.exports, "subsup", ()=>$3d1dcf8b9eccd1a7$export$b3401ee80eb31041);
    $parcel$export(module.exports, "table", ()=>$3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0);
    $parcel$export(module.exports, "tableCell", ()=>$3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a);
    $parcel$export(module.exports, "tableHeader", ()=>$3d1dcf8b9eccd1a7$export$48884d2a5190dc73);
    $parcel$export(module.exports, "tableRow", ()=>$3d1dcf8b9eccd1a7$export$ce666bf02318c957);
    $parcel$export(module.exports, "taskItem", ()=>$3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390);
    $parcel$export(module.exports, "taskList", ()=>$3d1dcf8b9eccd1a7$export$375b6afcc5f4d291);
    $parcel$export(module.exports, "text", ()=>$3d1dcf8b9eccd1a7$export$6f093cfa640b7166);
    $parcel$export(module.exports, "text_code_inline", ()=>$3d1dcf8b9eccd1a7$export$5008c13f04d544f6);
    $parcel$export(module.exports, "text_formatted", ()=>$3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c);
    $parcel$export(module.exports, "text_link_inline", ()=>$3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c);
    $parcel$export(module.exports, "text_with_no_marks", ()=>$3d1dcf8b9eccd1a7$export$437a3d96346717e0);
    $parcel$export(module.exports, "textColor", ()=>$3d1dcf8b9eccd1a7$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "underline", ()=>$3d1dcf8b9eccd1a7$export$425327af25286e5e);
    const $3d1dcf8b9eccd1a7$export$8e53000a4ec837 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'alignment'
                ]
            },
            attrs: {
                props: {
                    align: {
                        type: 'enum',
                        values: [
                            'center',
                            'end'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8512c9afa7b24c3b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'annotation'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    annotationType: {
                        type: 'enum',
                        values: [
                            'inlineComment'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8c5a050822fd698c = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'backgroundColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        pattern: '^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a31afb40076fa18b = [
        'blockCard',
        'paragraph_with_no_marks',
        'paragraph_with_alignment',
        'paragraph_with_indentation',
        'mediaSingle_caption',
        'mediaSingle_full',
        'codeBlock',
        'taskList',
        'bulletList',
        'orderedList',
        'heading_with_no_marks',
        'heading_with_alignment',
        'heading_with_indentation',
        'mediaGroup',
        'decisionList',
        'rule',
        'panel',
        'panel_with_nested_blockquote',
        'blockquote',
        'extension_with_marks',
        'embedCard',
        'table',
        'expand',
        'bodiedExtension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$c4c2f833baaebdb8 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            optional: true,
                            validatorFn: 'safeUrl'
                        },
                        datasource: {
                            props: {
                                id: {
                                    type: 'string'
                                },
                                parameters: {
                                    type: 'object'
                                },
                                views: {
                                    items: [
                                        {
                                            props: {
                                                properties: {
                                                    optional: true,
                                                    type: 'object'
                                                },
                                                type: {
                                                    type: 'string'
                                                }
                                            }
                                        }
                                    ],
                                    minItems: 1,
                                    type: 'array'
                                }
                            }
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ]
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$67dc04e652a298ca = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'blockquote'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'orderedList',
                        'bulletList',
                        'codeBlock',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ebb5393736e9ba23 = [
        'multiBodiedExtension'
    ];
    const $3d1dcf8b9eccd1a7$export$27903d543b563e39 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'non_nestable_block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$ee052cc5b2356e83 = [
        'bodiedExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$1edee58a52776cd9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'border'
                ]
            },
            attrs: {
                props: {
                    size: {
                        type: 'number',
                        minimum: 1,
                        maximum: 3
                    },
                    color: {
                        pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$89015c65f1c75e3f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'breakout'
                ]
            },
            attrs: {
                props: {
                    mode: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width'
                        ]
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a140c94e5ea26bee = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'bulletList'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$8e3c2dfdc4f0453d = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'caption'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'hardBreak',
                        'mention',
                        'emoji',
                        'date',
                        'placeholder',
                        'inlineCard',
                        'status',
                        'text_formatted',
                        'text_code_inline'
                    ]
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6565f9f03506010b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'code'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$7bb0d5c671655cc4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'codeBlock'
                ]
            },
            attrs: {
                props: {
                    language: {
                        type: 'string',
                        optional: true
                    },
                    uniqueId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'text_with_no_marks'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$38d90d1aac6883a3 = [
        'codeBlock',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f3b72f8fc4684ecd = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'confluenceInlineComment'
                ]
            },
            attrs: {
                props: {
                    reference: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$3024f02c495408d6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'dataConsumer'
                ]
            },
            attrs: {
                props: {
                    sources: {
                        type: 'array',
                        items: [
                            {
                                type: 'string'
                            }
                        ],
                        minItems: 1
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$324d90190a8b822a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'date'
                ]
            },
            attrs: {
                props: {
                    timestamp: {
                        minLength: 1,
                        type: 'string'
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6959e16eeff859b4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$62d45a65fb43d95e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'decisionList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'decisionItem'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2a111da947c407d2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'doc'
                ]
            },
            version: {
                type: 'enum',
                values: [
                    1
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'blockCard',
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'paragraph_with_indentation',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'bulletList',
                        'orderedList',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'mediaGroup',
                        'decisionList',
                        'rule',
                        'panel',
                        'panel_with_nested_blockquote',
                        'blockquote',
                        'extension_with_marks',
                        'embedCard',
                        'table',
                        'expand',
                        'bodiedExtension_with_marks',
                        'codeBlock_root_only',
                        'layoutSection_with_single_column',
                        'layoutSection_full',
                        'multiBodiedExtension',
                        'expand_root_only'
                    ]
                ],
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c63c6f932822f543 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'em'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$be4283d9a1cb1ff6 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'embedCard'
                ]
            },
            attrs: {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    width: {
                        type: 'number',
                        maximum: 100,
                        minimum: 0,
                        optional: true
                    },
                    originalHeight: {
                        type: 'number',
                        optional: true
                    },
                    originalWidth: {
                        type: 'number',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$a19185d1233fc4b2 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'emoji'
                ]
            },
            attrs: {
                props: {
                    shortName: {
                        type: 'string'
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9f77e0932fb78f72 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'expand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'decisionList',
                        'taskList',
                        'table',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b2817c6954dd6d2c = [
        'expand',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$1b45514b112dd749 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$15be7c145cec614a = [
        'extension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$4fdcae991fd743e7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'extensionFrame'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'codeBlock',
                        'mediaGroup',
                        'mediaSingle_full',
                        'mediaSingle_caption',
                        'decisionList',
                        'taskList',
                        'table',
                        'extension_with_marks',
                        'bodiedExtension_with_marks',
                        'blockCard',
                        'embedCard'
                    ]
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$f00aeb236b6f05af = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'fragment'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        minLength: 1,
                        type: 'string'
                    },
                    name: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$371da9dd35aba193 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'hardBreak'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'enum',
                        values: [
                            '\n'
                        ],
                        optional: true
                    }
                },
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$46e4a324ac90507f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'heading'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c17edf9af655deaf = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$1902f9737466a0dc = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$7b491e75f1be9278 = [
        'heading',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$480c699bd4ec0d86 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'indentation'
                ]
            },
            attrs: {
                props: {
                    level: {
                        type: 'number',
                        minimum: 1,
                        maximum: 6
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e23e6162adaa368d = [
        'text_formatted',
        'text_code_inline',
        'date',
        'emoji',
        'hardBreak',
        'inlineCard',
        'mention',
        'placeholder',
        'status',
        'inlineExtension_with_marks',
        'mediaInline'
    ];
    const $3d1dcf8b9eccd1a7$export$cbf8224b64e0d942 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineCard'
                ]
            },
            attrs: [
                {
                    props: {
                        url: {
                            type: 'string',
                            validatorFn: 'safeUrl'
                        }
                    }
                },
                {
                    props: {
                        data: {
                            type: 'object'
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$16b353b2649bd8d9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'inlineExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        minLength: 1,
                        type: 'string'
                    },
                    extensionType: {
                        minLength: 1,
                        type: 'string'
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    localId: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e37f10815f36843d = [
        'inlineExtension',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'dataConsumer',
                            'fragment'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$ab76e7c03cd6f650 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutColumn'
                ]
            },
            attrs: {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'block_content'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3b6a70a7fa4a5be = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$941b63fbd931e449 = [
        'layoutSection',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 2,
                    maxItems: 3,
                    allowUnsupportedBlock: true
                },
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$e0e9834198e8601d = [
        'layoutSection',
        {
            props: {
                attrs: {
                    props: {
                        columnRuleStyle: {
                            type: 'enum',
                            values: [
                                'solid'
                            ],
                            optional: true
                        }
                    },
                    optional: true
                },
                content: {
                    type: 'array',
                    items: [
                        'layoutColumn'
                    ],
                    minItems: 1,
                    maxItems: 5,
                    allowUnsupportedBlock: true
                },
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'breakout'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9c30223ca0a664fb = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'link'
                ]
            },
            attrs: {
                props: {
                    href: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    title: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string',
                        optional: true
                    },
                    occurrenceKey: {
                        type: 'string',
                        optional: true
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$76c7e83ecc9cdf05 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'listItem'
                ]
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$2b82905b9aebbab0 = [
        'listItem',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock',
                            'decisionList'
                        ],
                        [
                            'paragraph_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'taskList',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock',
                            'decisionList'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$987d49ffe1b0900f = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'media'
                ]
            },
            attrs: [
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'link',
                                'file'
                            ]
                        },
                        id: {
                            minLength: 1,
                            type: 'string'
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        collection: {
                            type: 'string'
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        occurrenceKey: {
                            minLength: 1,
                            type: 'string',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        type: {
                            type: 'enum',
                            values: [
                                'external'
                            ]
                        },
                        alt: {
                            type: 'string',
                            optional: true
                        },
                        height: {
                            type: 'number',
                            optional: true
                        },
                        width: {
                            type: 'number',
                            optional: true
                        },
                        url: {
                            type: 'string'
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        },
        required: [
            'attrs'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$2855e964765eac9 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaGroup'
                ]
            },
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$38bab695e3f720f1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaInline'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file',
                            'image'
                        ],
                        optional: true
                    },
                    url: {
                        type: 'string',
                        optional: true
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    data: {
                        type: 'object',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'annotation',
                        'border'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$969fe3781ca15058 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mediaSingle'
                ]
            },
            attrs: [
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0,
                            maximum: 100,
                            optional: true
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'percentage'
                            ],
                            optional: true
                        }
                    }
                },
                {
                    props: {
                        width: {
                            type: 'number',
                            minimum: 0
                        },
                        widthType: {
                            type: 'enum',
                            values: [
                                'pixel'
                            ]
                        },
                        layout: {
                            type: 'enum',
                            values: [
                                'wide',
                                'full-width',
                                'center',
                                'wrap-right',
                                'wrap-left',
                                'align-end',
                                'align-start'
                            ]
                        }
                    }
                }
            ],
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$68b0ead306f9670f = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    isTupleLike: true,
                    items: [
                        'media',
                        'caption'
                    ],
                    minItems: 1,
                    maxItems: 2,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f7fd577406abd5f8 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$af10954ff7b86f88 = [
        'mediaSingle',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        'media'
                    ],
                    minItems: 1,
                    maxItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$db83999c14438df4 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'mention'
                ]
            },
            attrs: {
                props: {
                    id: {
                        type: 'string'
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    accessLevel: {
                        type: 'string',
                        optional: true
                    },
                    userType: {
                        type: 'enum',
                        values: [
                            'DEFAULT',
                            'SPECIAL',
                            'APP'
                        ],
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$c3c04d555a8b9013 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'multiBodiedExtension'
                ]
            },
            attrs: {
                props: {
                    extensionKey: {
                        type: 'string',
                        minLength: 1
                    },
                    extensionType: {
                        type: 'string',
                        minLength: 1
                    },
                    parameters: {
                        type: 'object',
                        optional: true
                    },
                    text: {
                        type: 'string',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'default',
                            'wide',
                            'full-width'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        optional: true,
                        minLength: 1
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'extensionFrame'
                ]
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$63cadbf5f4296627 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'nestedExpand'
                ]
            },
            attrs: {
                props: {
                    title: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: 'nestedExpand_content'
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$9584f52f3ebd5d7e = {
        type: 'array',
        items: [
            [
                'paragraph_with_no_marks',
                'heading_with_no_marks',
                'mediaSingle_caption',
                'mediaSingle_full',
                'mediaGroup',
                'codeBlock',
                'bulletList',
                'orderedList',
                'taskList',
                'decisionList',
                'rule',
                'panel',
                'blockquote'
            ]
        ],
        minItems: 1,
        allowUnsupportedBlock: true
    };
    const $3d1dcf8b9eccd1a7$export$b756fc994eb0bc4f = [
        'nestedExpand',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$ed866000601e7fa5 = [
        'paragraph_with_no_marks',
        'panel',
        'blockquote',
        'orderedList',
        'bulletList',
        'rule',
        'heading_with_no_marks',
        'codeBlock',
        'mediaGroup',
        'mediaSingle_caption',
        'mediaSingle_full',
        'decisionList',
        'taskList',
        'table',
        'blockCard',
        'embedCard',
        'extension_with_marks'
    ];
    const $3d1dcf8b9eccd1a7$export$a5dc81035676e7a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'orderedList'
                ]
            },
            attrs: {
                props: {
                    order: {
                        type: 'number',
                        minimum: 0,
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'listItem',
                        'listItem_with_nested_decision'
                    ]
                ],
                minItems: 1
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$21f42ab9b6679f44 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'panel'
                ]
            },
            attrs: {
                props: {
                    panelType: {
                        type: 'enum',
                        values: [
                            'info',
                            'note',
                            'tip',
                            'warning',
                            'error',
                            'success',
                            'custom'
                        ]
                    },
                    panelIcon: {
                        type: 'string',
                        optional: true
                    },
                    panelIconId: {
                        type: 'string',
                        optional: true
                    },
                    panelIconText: {
                        type: 'string',
                        optional: true
                    },
                    panelColor: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard',
                        'mediaGroup',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'taskList',
                        'rule',
                        'decisionList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$5d60af6db74e5cd3 = [
        'panel',
        {
            props: {
                content: {
                    type: 'array',
                    items: [
                        [
                            'paragraph_with_no_marks',
                            'heading_with_no_marks',
                            'bulletList',
                            'orderedList',
                            'blockCard',
                            'mediaGroup',
                            'mediaSingle_caption',
                            'mediaSingle_full',
                            'codeBlock',
                            'taskList',
                            'rule',
                            'decisionList',
                            'blockquote'
                        ]
                    ],
                    minItems: 1,
                    allowUnsupportedBlock: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$9c206ddddb32a9b = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'paragraph'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9ca11c06877e5c64 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'alignment'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$a3bd66932996fb7d = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'indentation'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$f06f75eb1e56b0c5 = [
        'paragraph',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$c7187bbd1a7a9244 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'placeholder'
                ]
            },
            attrs: {
                props: {
                    text: {
                        type: 'string'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$fbeb3a3956e8a3c7 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'rule'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$471f7ae5c4103ae1 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'status'
                ]
            },
            attrs: {
                props: {
                    text: {
                        minLength: 1,
                        type: 'string'
                    },
                    color: {
                        type: 'enum',
                        values: [
                            'neutral',
                            'purple',
                            'blue',
                            'red',
                            'yellow',
                            'green'
                        ]
                    },
                    localId: {
                        type: 'string',
                        optional: true
                    },
                    style: {
                        type: 'string',
                        optional: true
                    }
                }
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'annotation'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$4899a95d70ec5056 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strike'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$59ae2c325a998f89 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'strong'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$b3401ee80eb31041 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'subsup'
                ]
            },
            attrs: {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'sub',
                            'sup'
                        ]
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$9852986a3ec5f6a0 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'table'
                ]
            },
            attrs: {
                props: {
                    displayMode: {
                        type: 'enum',
                        values: [
                            'default',
                            'fixed'
                        ],
                        optional: true
                    },
                    isNumberColumnEnabled: {
                        type: 'boolean',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'align-end',
                            'align-start',
                            'default'
                        ],
                        optional: true
                    },
                    localId: {
                        type: 'string',
                        minLength: 1,
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'tableRow'
                ],
                minItems: 1
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'fragment'
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$e1e720e5f4603e6a = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableCell'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$48884d2a5190dc73 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableHeader'
                ]
            },
            attrs: {
                props: {
                    colspan: {
                        type: 'number',
                        optional: true
                    },
                    rowspan: {
                        type: 'number',
                        optional: true
                    },
                    colwidth: {
                        type: 'array',
                        items: [
                            {
                                type: 'number'
                            }
                        ],
                        optional: true
                    },
                    background: {
                        type: 'string',
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'paragraph_with_alignment',
                        'panel',
                        'blockquote',
                        'orderedList',
                        'bulletList',
                        'rule',
                        'heading_with_no_marks',
                        'heading_with_alignment',
                        'heading_with_indentation',
                        'codeBlock',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'mediaGroup',
                        'decisionList',
                        'taskList',
                        'blockCard',
                        'embedCard',
                        'extension_with_marks',
                        'nestedExpand_with_no_marks',
                        'nestedExpand'
                    ]
                ],
                minItems: 1
            }
        },
        required: [
            'content'
        ]
    };
    const $3d1dcf8b9eccd1a7$export$ce666bf02318c957 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'tableRow'
                ]
            },
            content: {
                type: 'array',
                items: [
                    [
                        'tableCell',
                        'tableHeader'
                    ]
                ]
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6d8b0ef52e2e6390 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskItem'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    },
                    state: {
                        type: 'enum',
                        values: [
                            'TODO',
                            'DONE'
                        ]
                    }
                }
            },
            content: {
                type: 'array',
                items: [
                    'inline_content'
                ],
                optional: true,
                allowUnsupportedInline: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$375b6afcc5f4d291 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'taskList'
                ]
            },
            attrs: {
                props: {
                    localId: {
                        type: 'string'
                    }
                }
            },
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'taskItem',
                    [
                        'taskItem',
                        'taskList'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$6f093cfa640b7166 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'text'
                ]
            },
            text: {
                type: 'string',
                minLength: 1
            },
            marks: {
                type: 'array',
                items: [],
                optional: true
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$5008c13f04d544f6 = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'code',
                            'link',
                            'annotation'
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$d24a7becb4e0da7c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        [
                            'link',
                            'em',
                            'strong',
                            'strike',
                            'subsup',
                            'underline',
                            'textColor',
                            'annotation',
                            'backgroundColor',
                            null
                        ]
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$2a9d18d5b3064e6c = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    optional: true,
                    items: [
                        'link'
                    ]
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$437a3d96346717e0 = [
        'text',
        {
            props: {
                marks: {
                    type: 'array',
                    maxItems: 0,
                    items: [],
                    optional: true
                }
            }
        }
    ];
    const $3d1dcf8b9eccd1a7$export$32f78bffcd82ff28 = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'textColor'
                ]
            },
            attrs: {
                props: {
                    color: {
                        type: 'string',
                        pattern: '^#[0-9a-fA-F]{6}$'
                    }
                }
            }
        }
    };
    const $3d1dcf8b9eccd1a7$export$425327af25286e5e = {
        props: {
            type: {
                type: 'enum',
                values: [
                    'underline'
                ]
            }
        }
    };
});
parcelRegister("iiazc", function(module, exports) {
    $parcel$export(module.exports, "isDefined", ()=>$2c8456da404b8e3f$export$4e62c701997796c1);
    $parcel$export(module.exports, "isNumber", ()=>$2c8456da404b8e3f$export$7e4aa119212bc614);
    $parcel$export(module.exports, "isInteger", ()=>$2c8456da404b8e3f$export$a287f47fed4544b8);
    $parcel$export(module.exports, "isBoolean", ()=>$2c8456da404b8e3f$export$f9ce7b637dfbe238);
    $parcel$export(module.exports, "isString", ()=>$2c8456da404b8e3f$export$844ec244b1367d54);
    $parcel$export(module.exports, "isPlainObject", ()=>$2c8456da404b8e3f$export$53b83ca8eaab0383);
    $parcel$export(module.exports, "copy", ()=>$2c8456da404b8e3f$export$784d13d8ee351f07);
    $parcel$export(module.exports, "makeArray", ()=>$2c8456da404b8e3f$export$7b85fd78dd236198);
    const $2c8456da404b8e3f$export$4e62c701997796c1 = (x)=>x != null;
    const $2c8456da404b8e3f$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
    const $2c8456da404b8e3f$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
    const $2c8456da404b8e3f$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
    const $2c8456da404b8e3f$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
    const $2c8456da404b8e3f$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
    const $2c8456da404b8e3f$export$784d13d8ee351f07 = (source, dest, key)=>{
        dest[key] = source[key];
        return dest;
    };
    const $2c8456da404b8e3f$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
            maybeArray
        ];
});
parcelRegister("1H4Aw", function(module, exports) {
    $parcel$export(module.exports, "validatorFnMap", ()=>$608e35270d0ca1e8$export$d1b377ca77ac267d);
    var $iZOJ9;
    const $608e35270d0ca1e8$export$d1b377ca77ac267d = {
        safeUrl: (0, (0, parcelRequire("iZOJ9")).isSafeUrl)
    };
});
parcelRegister("1cjf7", function(module, exports) {
    $parcel$export(module.exports, "trackUnsupportedContentLevels", ()=>$dad344c5873159ce$export$a43de96edd8d0a0);
    var $4NUlu;
    var $2KwKW;
    var $gkwXh;
    var $knXBU;
    let $dad344c5873159ce$var$rendersMap = {};
    const $dad344c5873159ce$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
        try {
            const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, (0, parcelRequire("2KwKW")).getUnsupportedContentLevelData)(item.doc, thresholds);
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    appearance: (0, (0, parcelRequire("4NUlu")).getAnalyticsAppearance)(item.appearance),
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    unsupportedContentLevelSeverity: severity,
                    unsupportedContentLevelPercentage: percentage,
                    unsupportedNodesCount: unsupportedNodes,
                    supportedNodesCount: supportedNodes,
                    unsupportedNodeTypeCount: unsupportedNodeTypeCount
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        } catch (err) {
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, (0, parcelRequire("knXBU")).PLATFORM).WEB,
                    error: err instanceof Error ? err.message : String(err)
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        }
    };
    const $dad344c5873159ce$var$schedule = (fn)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
        else setTimeout(fn, 0);
    };
    const $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE = 100;
    const $dad344c5873159ce$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
        const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
        const appearance = item.appearance ?? 'unknown';
        if (!$dad344c5873159ce$var$rendersMap[appearance]) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
        const didProcessRenderer = $dad344c5873159ce$var$rendersMap[appearance].has(item.rendererId);
        if (didProcessRenderer) return;
        $dad344c5873159ce$var$rendersMap[appearance].add(item.rendererId);
        const sampleRate = samplingRates && samplingRates[appearance] || $dad344c5873159ce$var$DEFAULT_SAMPLING_RATE;
        if ($dad344c5873159ce$var$rendersMap[appearance].size === 1) $dad344c5873159ce$var$schedule(()=>$dad344c5873159ce$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
        if ($dad344c5873159ce$var$rendersMap[appearance].size % sampleRate === 0) $dad344c5873159ce$var$rendersMap[appearance] = new Set();
    };
});
parcelRegister("2KwKW", function(module, exports) {
    $parcel$export(module.exports, "getUnsupportedContentLevelData", ()=>$4210b4deee40727f$export$484b83e0462998d);
    var $l1C1k;
    var $4210b4deee40727f$export$6632e71a22d31bf1;
    (function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
        UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    })($4210b4deee40727f$export$6632e71a22d31bf1 || ($4210b4deee40727f$export$6632e71a22d31bf1 = {}));
    const $4210b4deee40727f$export$f9f8a29778652c3e = {
        DEGRADED: 10,
        BLOCKING: 25
    };
    const $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
        return {
            degraded: customThresholds?.degraded || $4210b4deee40727f$export$f9f8a29778652c3e.DEGRADED,
            blocking: customThresholds?.blocking || $4210b4deee40727f$export$f9f8a29778652c3e.BLOCKING
        };
    };
    const $4210b4deee40727f$var$countSupportedUnsupportedNodes = (validDocument)=>{
        let unsupportedNodes = 0;
        let supportedNodes = 0;
        const unsupportedNodeTypeCount = {};
        const unsupportedNodeTypes = [
            'unsupportedInline',
            'unsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceUnsupportedBlock'
        ];
        (0, (0, parcelRequire("l1C1k")).traverse)(validDocument, {
            any: (node)=>{
                if (unsupportedNodeTypes.includes(node.type)) {
                    const originalNode = node.attrs?.originalValue;
                    if (originalNode) (0, (0, parcelRequire("l1C1k")).traverse)(originalNode, {
                        any: (unsupportedNode, parent)=>{
                            unsupportedNodes++;
                            const parentType = parent.parent?.node?.type ?? 'unknown';
                            const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                            unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                        }
                    });
                    return false;
                } else supportedNodes++;
            }
        });
        return {
            unsupportedNodes: unsupportedNodes,
            supportedNodes: supportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        };
    };
    const $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
        if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
        if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
        return "normal";
    };
    const $4210b4deee40727f$export$484b83e0462998d = (validDocument, customThresholds)=>{
        const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $4210b4deee40727f$var$countSupportedUnsupportedNodes(validDocument);
        const thresholds = $4210b4deee40727f$var$buildUnsupportedContentLevelThresholds(customThresholds);
        const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
        const severity = $4210b4deee40727f$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
        return {
            severity: severity,
            percentage: percentage,
            counts: {
                supportedNodes: supportedNodes,
                unsupportedNodes: unsupportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            }
        };
    };
});
parcelRegister("4FBRr", function(module, exports) {
    $parcel$export(module.exports, "transformMediaLinkMarks", ()=>$75bd921bb3a8c47e$export$6528700f3fa2fe2a);
    var $l1C1k;
    const $75bd921bb3a8c47e$export$6528700f3fa2fe2a = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            mediaSingle: (node)=>{
                if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
                let linkMark = null;
                node.marks.forEach((mark, i)=>{
                    if (mark.type === 'link') {
                        linkMark = mark;
                        node.marks?.splice(i, 1);
                        isTransformed = true;
                    }
                });
                if (node.marks.length === 0) delete node.marks;
                if (linkMark) {
                    const mediaNode = node.content[0];
                    if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                    else if (!mediaNode.marks) mediaNode.marks = [
                        linkMark
                    ];
                }
                return node;
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("kgV4b", function(module, exports) {
    $parcel$export(module.exports, "countNodes", ()=>$7ac8dee2b321f8fd$export$1daf15cbaf649dad);
    var $3Y1bF;
    function $7ac8dee2b321f8fd$export$1daf15cbaf649dad(adfDocument) {
        return (0, (0, parcelRequire("3Y1bF")).reduce)(adfDocument, (acc, node)=>{
            acc[node.type] = (acc[node.type] || 0) + 1;
            return acc;
        }, {});
    }
});
parcelRegister("3Y1bF", function(module, exports) {
    $parcel$export(module.exports, "reduce", ()=>$de5bae64a9d3f36e$export$533b26079ad0b4b);
    var $l1C1k;
    function $de5bae64a9d3f36e$export$533b26079ad0b4b(adf, callback, initial) {
        let result = initial;
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                result = callback(result, node);
            }
        });
        return result;
    }
});
parcelRegister("3lRy2", function(module, exports) {
    $parcel$export(module.exports, "TruncatedWrapper", ()=>$de95a93fc343bd51$export$79ad592494094f07);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    const $de95a93fc343bd51$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>(0, (0, parcelRequire("f8Sb3")).css)({
            position: 'relative',
            overflowY: 'hidden',
            maxHeight: `${maxHeight}px`,
            '&::after': {
                content: "''",
                position: 'absolute',
                top: `${top}px`,
                bottom: 0,
                left: 0,
                right: 0,
                backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
            }
        });
    const $de95a93fc343bd51$var$FadeOut = (props)=>{
        const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
        const top = height - fadeHeight;
        const styles = $de95a93fc343bd51$var$fadeOutStyles(height, top, backgroundColor);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles
        }, children);
    };
    class $de95a93fc343bd51$export$79ad592494094f07 extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
        }
        render() {
            const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)($de95a93fc343bd51$var$FadeOut, {
                height: height,
                fadeHeight: fadeHeight,
                backgroundColor: backgroundColor
            }, children);
        }
    }
});
parcelRegister("jUVor", function(module, exports) {
    $parcel$export(module.exports, "BreakoutSSRInlineScript", ()=>$5224f7c9e411dec4$export$cfc1361be0de4203);
    var $5uXOq = parcelRequire("5uXOq");
    var $eOOFp;
    var $VSDnB;
    var $OxITw;
    function $5224f7c9e411dec4$export$cfc1361be0de4203() {
        if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
        const id = Math.floor(Math.random() * 9999990001) + 9999;
        const context = $5224f7c9e411dec4$export$92859d13f30c883e(id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            "data-breakout-script-id": id,
            dangerouslySetInnerHTML: {
                __html: context
            }
        });
    }
    function $5224f7c9e411dec4$export$92859d13f30c883e(id) {
        return `
  (function(window){
    ${$5224f7c9e411dec4$export$47813c4121c8b4b3};
    (${$5224f7c9e411dec4$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${Boolean((0, (0, parcelRequire("VSDnB")).fg)('platform-fix-table-ssr-resizing'))});
  })(window);
`;
    }
    const $5224f7c9e411dec4$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, (0, parcelRequire("eOOFp")).breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, (0, parcelRequire("eOOFp")).breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, (0, parcelRequire("OxITw")).FullPagePadding).toString()};
`;
    function $5224f7c9e411dec4$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldFixTableResizing) {
        const MEDIA_NODE_TYPE = 'mediaSingle';
        const WIDE_LAYOUT_MODES = [
            'full-width',
            'wide',
            'custom'
        ];
        function findUp(element, condition) {
            if (!element) return;
            while(element.parentElement){
                if (condition(element)) return element.parentElement;
                element = element.parentElement;
            }
        }
        const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
        if (!renderer) return;
        const observer = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((item)=>{
                if (item.target.nodeType !== Node.ELEMENT_NODE) return;
                if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                    if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                    let width;
                    const node = maybeNode;
                    const mode = node.dataset.mode || node.dataset.layout || '';
                    if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                    if (!shouldFixTableResizing) {
                        if (node.classList.contains('pm-table-container') && mode === 'custom') {
                            const rendererWidth = renderer.offsetWidth;
                            const effectiveWidth = rendererWidth - breakoutConsts.padding;
                            width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                        } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                        if (node.style.width === width) return;
                        node.style.width = width;
                        if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                            const lineLength = breakoutConsts.calcLineLength();
                            const left = lineLength / 2 - parseInt(width) / 2;
                            if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                            else node.style.left = '';
                        }
                    }
                });
                else if (item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
            });
        });
        const applyMediaBreakout = (card)=>{
            if (card.style.width) return;
            const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
            if (tableParent) return;
            const mode = card.dataset.mode || card.dataset.layout || '';
            const width = card.dataset.width;
            const isPixelBasedResizing = card.dataset.widthType === 'pixel';
            if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
            else if (width && !isPixelBasedResizing) card.style.width = `${width}%`;
        };
        observer.observe(renderer, {
            childList: true,
            subtree: true
        });
        const disconnect = ()=>{
            observer.disconnect();
            window.removeEventListener('load', disconnect);
        };
        window.addEventListener('load', disconnect);
    }
    const $5224f7c9e411dec4$export$2a0b3eeee3f2ea40 = (0, (0, parcelRequire("eOOFp")).breakoutConsts).calcLineLength;
});
parcelRegister("1pTqN", function(module, exports) {
    $parcel$export(module.exports, "ActiveHeaderIdProvider", ()=>$ae2d04c26b960a03$export$20439b49fdd0d26c);
    $parcel$export(module.exports, "ActiveHeaderIdConsumer", ()=>$ae2d04c26b960a03$export$cddc3c6ebe2d2cec);
    var $5uXOq = parcelRequire("5uXOq");
    const { Provider: $ae2d04c26b960a03$export$20439b49fdd0d26c, Consumer: $ae2d04c26b960a03$var$Consumer } = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $ae2d04c26b960a03$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
        const [activeHeaderId, setActiveHeaderId] = (0, $5uXOq.useState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ae2d04c26b960a03$var$Consumer, null, (newActiveHeaderId)=>{
            if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
            else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
                setActiveHeaderId(newActiveHeaderId);
                onNestedHeaderIdMatch();
            }
            return null;
        });
    };
});
parcelRegister("TPpI8", function(module, exports) {
    $parcel$export(module.exports, "isInteractiveElement", ()=>$2d523c4d7c031fc5$export$3dee5e4542c672d9);
    function $2d523c4d7c031fc5$export$3dee5e4542c672d9(element) {
        if ('href' in element && element.href != null) return true;
        if (element.classList.contains((0, $9e7f9e5fe795995b$export$42c8d07e41ed1e74))) return true;
        if (element.classList.contains((0, $025bde419ff72534$export$7a6526d4be3b7eb3))) return true;
        return false;
    }
});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
const $9e7f9e5fe795995b$export$42c8d07e41ed1e74 = 'media-viewer-popup';
parcelRegister("1urn6", function(module, exports) {
    $parcel$export(module.exports, "EditorMediaClientProvider", ()=>$d9518b7b87f036fd$export$77218b6ff680865f);
    var $5uXOq = parcelRequire("5uXOq");
    var $cEHh7;
    var $9S8fM;
    const $d9518b7b87f036fd$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
        const [mediaClientConfig, setMediaClientConfig] = (0, $5uXOq.useState)();
        const mediaProvider = (0, (0, parcelRequire("9S8fM")).useProvider)('mediaProvider');
        const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
        const contextMediaClient = (0, $5uXOq.useContext)((0, (0, parcelRequire("cEHh7")).MediaClientContext));
        const mediaClient = (0, $5uXOq.useMemo)(()=>mediaClientConfig ? (0, (0, parcelRequire("cEHh7")).getMediaClient)(mediaClientConfig) : undefined, [
            mediaClientConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (ssr?.config) setMediaClientConfig(ssr.config);
            else if (mediaProvider) mediaProvider.then((provider)=>{
                setMediaClientConfig(provider.viewMediaClientConfig);
            });
        }, [
            mediaProvider,
            ssr
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEHh7")).MediaClientContext).Provider, {
            value: shouldSkipContext ? mediaClient : contextMediaClient
        }, children);
    };
});
parcelRegister("cEHh7", function(module, exports) {
    $parcel$export(module.exports, "MediaClientContext", ()=>$2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
    $parcel$export(module.exports, "getMediaClient", ()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417);
    $parcel$export(module.exports, "MediaClientProvider", ()=>$2a03c62fd3cc05ea$export$5bff351c86f56d97);
    $parcel$export(module.exports, "useMediaClient", ()=>$2a03c62fd3cc05ea$export$8b3e87ea56c3a345);
    var $5uXOq = parcelRequire("5uXOq");
    var $9z04W;
    const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $2a03c62fd3cc05ea$export$f92e83e86b03c398 = new Map();
    const $2a03c62fd3cc05ea$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
        if (!mediaClientConfig) return new (0, (0, parcelRequire("9z04W")).MediaClient)({
            authProvider: ()=>Promise.resolve({
                    clientId: '',
                    token: '',
                    baseUrl: ''
                })
        });
        let mediaClient = $2a03c62fd3cc05ea$export$f92e83e86b03c398.get(mediaClientConfig);
        if (!mediaClient) {
            mediaClient = new (0, (0, parcelRequire("9z04W")).MediaClient)(mediaClientConfig);
            $2a03c62fd3cc05ea$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
        }
        return mediaClient;
    };
    const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
        const mediaClient = (0, $5uXOq.useMemo)(()=>$2a03c62fd3cc05ea$export$c9ecbc1b719fd417(clientConfig), [
            clientConfig
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
    };
    const $2a03c62fd3cc05ea$export$8b3e87ea56c3a345 = ()=>{
        const mediaClient = (0, ($parcel$interopDefault($5uXOq))).useContext($2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
        if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
        return mediaClient;
    };
});
parcelRegister("9z04W", function(module, exports) {
    $parcel$export(module.exports, "MediaClient", ()=>$a9f77c891230da5c$export$fba8b4ca6d386aec);
    var $7n9mn = parcelRequire("7n9mn");
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $1FyHg;
    var $iKPaV;
    var $5eAc2;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $a9f77c891230da5c$export$fba8b4ca6d386aec {
        constructor(mediaClientConfig, store = (0, $fN64m.mediaStore), mediaApi){
            this.mediaClientConfig = mediaClientConfig;
            this.store = store;
            this.mediaStore = mediaApi ?? new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: mediaClientConfig.authProvider,
                initialAuth: mediaClientConfig.initialAuth,
                chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $gPrGh.ChunkHashAlgorithm).Sha256 : (0, $gPrGh.ChunkHashAlgorithm).Sha1,
                authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
            });
            this.config = mediaClientConfig;
            this.file = new (0, (0, parcelRequire("iKPaV")).FileFetcherImpl)(this.mediaStore, this.store);
            this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
            this.stargate = new (0, (0, parcelRequire("5eAc2")).StargateClient)(mediaClientConfig.stargateBaseUrl);
        }
        __DO_NOT_USE__getMediaStore() {
            return this.store;
        }
        getImage(id, params, controller, fetchMaxRes, traceContext) {
            return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
        }
        getImageUrl(id, params) {
            return this.mediaStore.getFileImageURL(id, params);
        }
        getImageUrlSync(id, params) {
            return this.mediaStore.getFileImageURLSync(id, params);
        }
        async getImageMetadata(id, params) {
            return (await this.mediaStore.getImageMetadata(id, params)).metadata;
        }
        async mobileUploadPromise() {
            if (this.mobileUpload) return this.mobileUpload;
            const module = await (parcelRequire("hUEMO"));
            this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
            return this.mobileUpload;
        }
        async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
            await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
        }
        on(event, listener) {
            this.eventEmitter.on(event, listener);
        }
        off(event, listener) {
            this.eventEmitter.off(event, listener);
        }
        emit(event, payload) {
            return this.eventEmitter.emit(event, payload);
        }
    }
});
parcelRegister("LmkUS", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>(parcelRequire("6a8j4")).mediaState);
    $parcel$export(module.exports, "isClientBasedAuth", ()=>(parcelRequire("hQvj4")).isClientBasedAuth);
    $parcel$export(module.exports, "authToOwner", ()=>(parcelRequire("hQvj4")).authToOwner);
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>(parcelRequire("gPrGh")).ChunkHashAlgorithm);
    var $6a8j4 = parcelRequire("6a8j4");
    var $hQvj4 = parcelRequire("hQvj4");
    var $gPrGh = parcelRequire("gPrGh");
});
parcelRegister("6a8j4", function(module, exports) {
    $parcel$export(module.exports, "mediaState", ()=>$dc598dfdde7cc536$export$8cef61637918b288);
    var $7n9mn = parcelRequire("7n9mn");
    var $iwKVT = parcelRequire("iwKVT");
    const $dc598dfdde7cc536$export$8cef61637918b288 = {
        streams: new (0, $iwKVT.LRUMap)(1000),
        stateDeferreds: new Map(),
        eventEmitter: new (0, $7n9mn.EventEmitter2)()
    };
});
parcelRegister("hQvj4", function(module, exports) {
    $parcel$export(module.exports, "isClientBasedAuth", ()=>$449c85d7d5bc4f1f$export$6ba49fcac9c46e54);
    $parcel$export(module.exports, "authToOwner", ()=>$449c85d7d5bc4f1f$export$17f6055767a8d96a);
    function $449c85d7d5bc4f1f$export$6ba49fcac9c46e54(auth) {
        return !!auth.clientId;
    }
    function $449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth) {
        return !!auth.asapIssuer;
    }
    const $449c85d7d5bc4f1f$export$17f6055767a8d96a = (auth)=>{
        if ($449c85d7d5bc4f1f$export$af1ab14f2246ef72(auth)) return auth;
        const clientAuth = {
            id: auth.clientId,
            baseUrl: auth.baseUrl,
            token: auth.token
        };
        return clientAuth;
    };
});
parcelRegister("gPrGh", function(module, exports) {
    $parcel$export(module.exports, "ChunkHashAlgorithm", ()=>$506f1dfda055692a$export$d3e73a50cc549c2e);
    var $506f1dfda055692a$export$d3e73a50cc549c2e;
    (function(ChunkHashAlgorithm) {
        ChunkHashAlgorithm["Sha1"] = "sha1";
        ChunkHashAlgorithm["Sha256"] = "sha256";
    })($506f1dfda055692a$export$d3e73a50cc549c2e || ($506f1dfda055692a$export$d3e73a50cc549c2e = {}));
});
parcelRegister("1FyHg", function(module, exports) {
    $parcel$export(module.exports, "MediaStore", ()=>$5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba);
    $parcel$export(module.exports, "getMediaEnvironment", ()=>$5d0b8a2b8f8558c8$export$c8b741e18397852a);
    $parcel$export(module.exports, "getMediaRegion", ()=>$5d0b8a2b8f8558c8$export$20f9315304dd6726);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    var $hQvj4 = parcelRequire("hQvj4");
    var $7E56q;
    var $7LFAu;
    var $hzvnk;
    var $ale1y;
    var $eeVEv;
    var $5cMkQ;
    var $VSDnB;
    var $h2NC7;
    const $5d0b8a2b8f8558c8$var$MEDIA_API_REGION = 'media-api-region';
    const $5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
    const $5d0b8a2b8f8558c8$var$extendImageParams = (params, fetchMaxRes = false)=>{
        return {
            ...params,
            'max-age': params?.['max-age'] ?? (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE),
            allowAnimated: params?.allowAnimated ?? true,
            mode: params?.mode ?? 'crop',
            ...fetchMaxRes ? {
                width: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION),
                height: (0, (0, parcelRequire("7E56q")).MAX_RESOLUTION)
            } : {}
        };
    };
    const $5d0b8a2b8f8558c8$var$jsonHeaders = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const $5d0b8a2b8f8558c8$var$cdnFeatureFlag = (endpoint)=>{
        let result = endpoint;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery')) {
            if ((0, (0, parcelRequire("h2NC7")).isCommercial)()) result += '/cdn';
        }
        return result;
    };
    class $5d0b8a2b8f8558c8$export$572b8a2a9fd7cbba {
        constructor(config){
            this.config = config;
            this.resolveAuth = (authContext)=>(0, (0, parcelRequire("5cMkQ")).resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
            this.resolveInitialAuth = ()=>(0, (0, parcelRequire("5cMkQ")).resolveInitialAuth)(this.config.initialAuth);
            this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $gPrGh.ChunkHashAlgorithm).Sha1;
        }
        async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/collection/{collectionName}'
            };
            const body = {
                actions: [
                    {
                        action: 'remove',
                        item: {
                            type: 'file',
                            id: id,
                            occurrenceKey: occurrenceKey
                        }
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/collection/${collectionName}`, options);
        }
        createUpload(createUpTo = 1, collectionName, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                params: {
                    createUpTo: createUpTo,
                    hashAlgorithm: this._chunkHashAlgorithm
                },
                headers: {
                    Accept: 'application/json'
                },
                traceContext: traceContext
            };
            return this.request(`/upload`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/chunk/{etag}'
            };
            const options = {
                ...metadata,
                params: {
                    uploadId: uploadId,
                    partNumber: partNumber
                },
                authContext: {
                    collectionName: collectionName
                },
                body: blob,
                traceContext: traceContext
            };
            await this.request(`/chunk/${etag}`, options);
        }
        createFileFromUpload(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/upload'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/upload', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getRejectedResponseFromDescriptor(descriptor, limit) {
            return {
                fileId: descriptor.fileId,
                error: {
                    code: 'ExceedMaxFileSizeLimit',
                    title: 'The expected file size exceeded the maximum size limit.',
                    href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                    limit: limit,
                    size: descriptor.size
                }
            };
        }
        async touchFiles(body, params = {}, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/upload/createWithFiles'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext,
                params: {
                    hashAlgorithm: this._chunkHashAlgorithm
                }
            };
            return this.request('/upload/createWithFiles', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        getFile(fileId, params = {}, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${fileId}`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getFileImageURL(id, params) {
            const { collection: collectionName } = params || {};
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            return this.createFileImageURL(id, auth, params);
        }
        getFileImageURLSync(id, params) {
            const auth = this.resolveInitialAuth();
            return this.createFileImageURL(id, auth, params);
        }
        createFileImageURL(id, auth, params) {
            const options = {
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params),
                auth: auth
            };
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
        }
        async getFileBinary(id, collectionName, abortController, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const headers = {};
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${binaryEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: headers,
                params: {
                    collection: collectionName,
                    'max-age': `${maxAge}`
                }
            };
            return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getFileBinaryURL(id, collectionName, maxAge = (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)) {
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    dl: true,
                    collection: collectionName,
                    'max-age': maxAge
                },
                auth: auth
            };
            const binaryEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('binary');
            return (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)((0, (0, parcelRequire("ale1y")).createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
        }
        async getArtifactURL(artifacts, artifactName, collectionName) {
            const artifactUrl = (0, (0, parcelRequire("7LFAu")).getArtifactUrl)(artifacts, artifactName);
            if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
            const auth = await this.resolveAuth({
                collectionName: collectionName
            });
            const options = {
                params: {
                    collection: collectionName,
                    'max-age': (0, (0, parcelRequire("7E56q")).FILE_CACHE_MAX_AGE)
                },
                auth: auth
            };
            return (0, (0, parcelRequire("ale1y")).createUrl)((0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(artifactUrl, auth.token), options);
        }
        async getImage(id, params, controller, fetchMaxRes, traceContext) {
            const isWebpSupported = false;
            const headers = {};
            if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
            const imageEndpoint = $5d0b8a2b8f8558c8$var$cdnFeatureFlag('image');
            const metadata = {
                method: 'GET',
                endpoint: `/file/{fileId}/${imageEndpoint}`
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: $5d0b8a2b8f8558c8$var$extendImageParams(params, fetchMaxRes),
                headers: headers,
                traceContext: traceContext,
                addMediaClientParam: (0, (0, parcelRequire("VSDnB")).fg)('platform.media-card-performance-observer_a803k') && true
            };
            return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, (0, parcelRequire("ale1y")).createMapResponseToBlob)(metadata));
        }
        async getItems(ids, collectionName, traceContext) {
            const descriptors = ids.map((id)=>({
                    type: 'file',
                    id: id,
                    collection: collectionName
                }));
            const metadata = {
                method: 'POST',
                endpoint: '/items'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify({
                    descriptors: descriptors
                }),
                traceContext: traceContext
            };
            return this.request('/items', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async getImageMetadata(id, params, traceContext) {
            const metadata = {
                method: 'GET',
                endpoint: '/file/{fileId}/image/metadata'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params && params.collection
                },
                params: params,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/image/metadata`, options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
            const metadata = {
                method: 'PUT',
                endpoint: '/upload/{uploadId}/chunks'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: collectionName
                },
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            await this.request(`/upload/${uploadId}/chunks`, options);
        }
        copyFileWithToken(body, params, traceContext) {
            const metadata = {
                method: 'POST',
                endpoint: '/file/copy/withToken'
            };
            const options = {
                ...metadata,
                authContext: {
                    collectionName: params.collection
                },
                params: params,
                headers: $5d0b8a2b8f8558c8$var$jsonHeaders,
                body: JSON.stringify(body),
                traceContext: traceContext
            };
            return this.request('/file/copy/withToken', options).then((0, (0, parcelRequire("ale1y")).createMapResponseToJson)(metadata));
        }
        async request(path, options = {
            method: 'GET',
            endpoint: undefined,
            authContext: {}
        }, controller, useMediaCdn) {
            const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam } = options;
            const auth = await this.resolveAuth(authContext);
            const clientId = (0, $hQvj4.isClientBasedAuth)(auth) ? auth.clientId : undefined;
            const extendedTraceContext = (0, (0, parcelRequire("ale1y")).extendTraceContext)(traceContext);
            const extendedParams = addMediaClientParam ? {
                ...params,
                clientId: clientId
            } : params;
            let url = `${auth.baseUrl}${path}`;
            if (useMediaCdn) url = (0, (0, parcelRequire("eeVEv")).mapToMediaCdnUrl)(url, auth.token);
            const response = await (0, (0, parcelRequire("hzvnk")).request)(url, {
                method: method,
                endpoint: endpoint,
                auth: auth,
                params: extendedParams,
                headers: headers,
                body: body,
                clientOptions: clientOptions,
                traceContext: extendedTraceContext
            }, controller);
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
            $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
            return response;
        }
        async testUrl(url, options = {}) {
            const { traceContext: traceContext } = options;
            await (0, (0, parcelRequire("hzvnk")).request)(url, {
                method: 'HEAD',
                traceContext: (0, (0, parcelRequire("ale1y")).extendTraceContext)(traceContext),
                clientOptions: {
                    retryOptions: {
                        maxAttempts: 1
                    }
                }
            });
        }
        get chunkHashAlgorithm() {
            return this._chunkHashAlgorithm;
        }
    }
    const $5d0b8a2b8f8558c8$var$getValueFromSessionStorage = (key)=>{
        return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
    };
    const $5d0b8a2b8f8558c8$var$setKeyValueInSessionStorage = (key, value)=>{
        if (!value || !(window && window.sessionStorage)) return;
        const currentValue = window.sessionStorage.getItem(key);
        if (currentValue !== value) window.sessionStorage.setItem(key, value);
    };
    const $5d0b8a2b8f8558c8$export$c8b741e18397852a = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_ENVIRONMENT);
    };
    const $5d0b8a2b8f8558c8$export$20f9315304dd6726 = ()=>{
        return $5d0b8a2b8f8558c8$var$getValueFromSessionStorage($5d0b8a2b8f8558c8$var$MEDIA_API_REGION);
    };
});
parcelRegister("7E56q", function(module, exports) {
    $parcel$export(module.exports, "RECENTS_COLLECTION", ()=>$7a454a77a18dd963$export$860a16125e30000b);
    $parcel$export(module.exports, "FILE_CACHE_MAX_AGE", ()=>$7a454a77a18dd963$export$bd6e8fe09a90927b);
    $parcel$export(module.exports, "MAX_RESOLUTION", ()=>$7a454a77a18dd963$export$6e70f30e392bc53f);
    $parcel$export(module.exports, "CHUNK_SIZE", ()=>$7a454a77a18dd963$export$c1abb8bab1e615cd);
    $parcel$export(module.exports, "PROCESSING_BATCH_SIZE", ()=>$7a454a77a18dd963$export$3d5157f0def70e54);
    $parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", ()=>$7a454a77a18dd963$export$f14f521f3d306044);
    var $749LC;
    const $7a454a77a18dd963$export$860a16125e30000b = 'recents';
    const $7a454a77a18dd963$export$bd6e8fe09a90927b = 2592000;
    const $7a454a77a18dd963$export$6e70f30e392bc53f = 4096;
    const $7a454a77a18dd963$export$c1abb8bab1e615cd = 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    const $7a454a77a18dd963$export$3d5157f0def70e54 = 1000;
    const $7a454a77a18dd963$export$f14f521f3d306044 = 2 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB;
});
parcelRegister("749LC", function(module, exports) {
    $parcel$export(module.exports, "isNotFoundMediaItemDetails", ()=>$330ebd66cbfb5bbe$export$fd27d7abbc4a746d);
    $parcel$export(module.exports, "DATA_UNIT", ()=>$330ebd66cbfb5bbe$export$76cfea4c354af843);
    const $330ebd66cbfb5bbe$export$350ede7b7a6acf99 = (type)=>{
        const defaultPreviewableTypes = [
            'audio',
            'video',
            'image',
            'doc'
        ];
        return defaultPreviewableTypes.indexOf(type) > -1;
    };
    const $330ebd66cbfb5bbe$export$fd27d7abbc4a746d = (itemDetails)=>{
        return 'type' in itemDetails && itemDetails.type === 'not-found';
    };
    var $330ebd66cbfb5bbe$export$76cfea4c354af843;
    (function(DATA_UNIT) {
        DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
        DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
        DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    })($330ebd66cbfb5bbe$export$76cfea4c354af843 || ($330ebd66cbfb5bbe$export$76cfea4c354af843 = {}));
});
parcelRegister("7LFAu", function(module, exports) {
    $parcel$export(module.exports, "getArtifactUrl", ()=>$cc56e843db2c0cea$export$1cc24defa44e7f84);
    var $VSDnB;
    var $h2NC7;
    const $cc56e843db2c0cea$export$1cc24defa44e7f84 = (artifacts, prop)=>{
        if ((0, (0, parcelRequire("h2NC7")).isCommercial)() && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && artifacts[prop]?.url) return `${artifacts[prop]?.url}/cdn`;
        return artifacts[prop]?.url;
    };
});
parcelRegister("h2NC7", function(module, exports) {
    $parcel$export(module.exports, "isCommercial", ()=>$bc3c8a168b66c7db$export$df69ff6733e73e50);
    function $bc3c8a168b66c7db$export$df69ff6733e73e50() {
        const global = globalThis;
        const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
        if (perimeter) return perimeter === 'commercial';
        return !global.location?.hostname?.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/);
    }
});
parcelRegister("hzvnk", function(module, exports) {
    $parcel$export(module.exports, "request", ()=>$ac16e0b7f5d65450$export$b5fe3f66a567bec0);
    var $1As4I;
    var $ale1y;
    async function $ac16e0b7f5d65450$export$b5fe3f66a567bec0(url, options = {}, controller) {
        const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
        const { retryOptions: retryOptions } = clientOptions;
        const metadata = {
            method: method,
            endpoint: endpoint,
            traceContext: traceContext
        };
        const doFetch = ()=>fetch((0, (0, parcelRequire("ale1y")).createUrl)(url, {
                params: params
            }), {
                method: method,
                body: body,
                headers: (0, (0, parcelRequire("ale1y")).extendHeaders)(headers, auth, traceContext),
                signal: controller && controller.signal
            }).then((0, (0, parcelRequire("ale1y")).createProcessFetchResponse)(metadata));
        return (0, (0, parcelRequire("ale1y")).fetchRetry)(doFetch, metadata, retryOptions);
    }
});
parcelRegister("1As4I", function(module, exports) {
    $parcel$export(module.exports, "RequestError", ()=>$a9b96946563d0d09$export$43ee7d0e4f429743);
    $parcel$export(module.exports, "isRequestError", ()=>$a9b96946563d0d09$export$3717b1ffef4428ea);
    var $gFZHi;
    class $a9b96946563d0d09$export$43ee7d0e4f429743 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, metadata, innerError){
            super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
            return {
                reason: reason,
                method: method,
                endpoint: endpoint,
                mediaRegion: mediaRegion,
                mediaEnv: mediaEnv,
                attempts: attempts,
                clientExhaustedRetries: clientExhaustedRetries,
                statusCode: statusCode,
                metadata: {
                    traceContext: traceContext
                },
                innerError: innerError
            };
        }
    }
    function $a9b96946563d0d09$export$3717b1ffef4428ea(err) {
        return err instanceof $a9b96946563d0d09$export$43ee7d0e4f429743;
    }
});
parcelRegister("gFZHi", function(module, exports) {
    $parcel$export(module.exports, "BaseMediaClientError", ()=>$fd6342ef86e499fe$export$2b0aca14d61c3190);
    var $loYHr;
    class $fd6342ef86e499fe$export$2b0aca14d61c3190 extends Error {
        constructor(message){
            super(message), this.message = message;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
});
parcelRegister("loYHr", function(module, exports) {
    $parcel$export(module.exports, "isMediaClientError", ()=>$8608a1f56c9594c2$export$2491e0bbdb59256e);
    $parcel$export(module.exports, "getMediaClientErrorReason", ()=>$8608a1f56c9594c2$export$c15d72765ee2baa4);
    function $8608a1f56c9594c2$export$2491e0bbdb59256e(error) {
        return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
    }
    function $8608a1f56c9594c2$export$c15d72765ee2baa4(err) {
        return $8608a1f56c9594c2$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
    }
});
parcelRegister("ale1y", function(module, exports) {
    $parcel$export(module.exports, "isRateLimitedError", ()=>$96f7b73b7943f312$export$bc96a6a479480590);
    $parcel$export(module.exports, "extendTraceContext", ()=>$96f7b73b7943f312$export$ee24a95986dfd173);
    $parcel$export(module.exports, "createUrl", ()=>$96f7b73b7943f312$export$7138c24907de3954);
    $parcel$export(module.exports, "extendHeaders", ()=>$96f7b73b7943f312$export$18cfbabc415d771c);
    $parcel$export(module.exports, "createMapResponseToJson", ()=>$96f7b73b7943f312$export$e0519b126b73efa6);
    $parcel$export(module.exports, "createMapResponseToBlob", ()=>$96f7b73b7943f312$export$5cc7b0795397da86);
    $parcel$export(module.exports, "fetchRetry", ()=>$96f7b73b7943f312$export$782df2acbe10b22c);
    $parcel$export(module.exports, "createRequestErrorReason", ()=>$96f7b73b7943f312$export$6397609af718d008);
    $parcel$export(module.exports, "createProcessFetchResponse", ()=>$96f7b73b7943f312$export$6e2e477edb7d6032);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $27T0s;
    var $3JV6R;
    var $1As4I;
    function $96f7b73b7943f312$export$80c51ea1e89203dd(timeout) {
        return new Promise((resolve)=>setTimeout(resolve, timeout));
    }
    function $96f7b73b7943f312$export$de0b576cf7ce4a53(err) {
        return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
    }
    function $96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) {
        return err instanceof TypeError;
    }
    function $96f7b73b7943f312$export$bc96a6a479480590(error) {
        return !!error && (0, (0, parcelRequire("1As4I")).isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
    }
    const $96f7b73b7943f312$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
        } : undefined;
    const $96f7b73b7943f312$export$922566b90d0535ce = {
        traceId: 'x-b3-traceid',
        spanId: 'x-b3-spanid',
        parentSpanId: 'x-b3-parentspanid',
        sampled: 'x-b3-sampled',
        flags: 'x-b3-flags'
    };
    const $96f7b73b7943f312$var$mapTraceIdToRequestHeaders = (traceContext)=>{
        return traceContext ? {
            [$96f7b73b7943f312$export$922566b90d0535ce.traceId]: traceContext.traceId,
            [$96f7b73b7943f312$export$922566b90d0535ce.spanId]: traceContext.spanId
        } : {};
    };
    function $96f7b73b7943f312$export$eaf4479116d2f925(auth) {
        if (!auth) return {};
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            'X-Client-Id': auth.clientId,
            Authorization: `Bearer ${auth.token}`
        };
        return {
            'X-Issuer': auth.asapIssuer,
            Authorization: `Bearer ${auth.token}`
        };
    }
    function $96f7b73b7943f312$export$7138c24907de3954(url, { params: params, auth: auth }) {
        const parsedUrl = new URL(url, auth?.baseUrl);
        const authParams = auth && (0, (0, parcelRequire("3JV6R")).mapAuthToQueryParameters)(auth) || {};
        const paramsToAppend = {
            ...params,
            ...authParams
        };
        Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
            parsedUrl.searchParams.append(...pair);
        });
        parsedUrl.searchParams.sort();
        return parsedUrl.toString();
    }
    function $96f7b73b7943f312$export$18cfbabc415d771c(headers, auth, traceContext) {
        if (!auth && !traceContext && !headers) return undefined;
        return {
            ...headers ?? {},
            ...$96f7b73b7943f312$export$eaf4479116d2f925(auth),
            ...$96f7b73b7943f312$var$mapTraceIdToRequestHeaders(traceContext)
        };
    }
    function $96f7b73b7943f312$export$e0519b126b73efa6(metadata) {
        return async (response)=>{
            try {
                return await response.json();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    function $96f7b73b7943f312$export$5cc7b0795397da86(metadata) {
        return async (response)=>{
            try {
                return await response.blob();
            } catch (err) {
                throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverInvalidBody', {
                    ...metadata,
                    ...$96f7b73b7943f312$export$ea175c0c5497224(response),
                    statusCode: response.status
                }, err instanceof Error ? err : undefined);
            }
        };
    }
    const $96f7b73b7943f312$export$c65cfa70960d8fe5 = {
        startTimeoutInMs: 1000,
        maxAttempts: 5,
        factor: 2
    };
    function $96f7b73b7943f312$export$359f19ca51f9eba1(error, extraMetadata) {
        const { reason: reason, metadata: metadata, innerError: innerError } = error;
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...extraMetadata
        }, innerError);
    }
    async function $96f7b73b7943f312$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
        const options = {
            ...$96f7b73b7943f312$export$c65cfa70960d8fe5,
            ...overwriteOptions
        };
        const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
        let attempts = 0;
        let timeoutInMs = startTimeoutInMs;
        let lastError;
        const waitAndBumpTimeout = async ()=>{
            await $96f7b73b7943f312$export$80c51ea1e89203dd(timeoutInMs);
            timeoutInMs *= factor;
            attempts += 1;
        };
        while(attempts < maxAttempts)try {
            return await functionToRetry();
        } catch (err) {
            lastError = err;
            if ($96f7b73b7943f312$export$de0b576cf7ce4a53(err)) throw new (0, (0, parcelRequire("1As4I")).RequestError)('clientAbortedRequest', metadata, err);
            if (!$96f7b73b7943f312$export$ad8c5cf7dd4c3caf(err) && !(0, (0, parcelRequire("1As4I")).isRequestError)(err) || (0, (0, parcelRequire("1As4I")).isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
            await waitAndBumpTimeout();
        }
        if ((0, (0, parcelRequire("1As4I")).isRequestError)(lastError)) throw $96f7b73b7943f312$export$359f19ca51f9eba1(lastError, {
            attempts: attempts,
            clientExhaustedRetries: true
        });
        throw new (0, (0, parcelRequire("1As4I")).RequestError)('serverUnexpectedError', {
            ...metadata,
            attempts: attempts,
            clientExhaustedRetries: true
        }, lastError);
    }
    function $96f7b73b7943f312$export$6397609af718d008(statusCode) {
        switch(statusCode){
            case 400:
                return 'serverBadRequest';
            case 401:
                return 'serverUnauthorized';
            case 403:
                return 'serverForbidden';
            case 404:
                return 'serverNotFound';
            case 429:
                return 'serverRateLimited';
            case 500:
                return 'serverInternalError';
            case 502:
                return 'serverBadGateway';
            default:
                return 'serverUnexpectedError';
        }
    }
    function $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response) {
        const { status: statusCode } = response;
        const reason = $96f7b73b7943f312$export$6397609af718d008(statusCode);
        return new (0, (0, parcelRequire("1As4I")).RequestError)(reason, {
            ...metadata,
            ...$96f7b73b7943f312$export$ea175c0c5497224(response),
            statusCode: statusCode
        });
    }
    function $96f7b73b7943f312$export$6e2e477edb7d6032(metadata) {
        return (response)=>{
            if (response.ok || response.status < 400) return response;
            const requestError = $96f7b73b7943f312$export$d171f49f6b4ddc33(metadata, response);
            throw requestError;
        };
    }
    function $96f7b73b7943f312$export$ea175c0c5497224(response) {
        const { headers: headers } = response;
        const mediaRegion = headers.get('x-media-region') || 'unknown';
        const mediaEnv = headers.get('x-media-env') || 'unknown';
        return {
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv
        };
    }
});
parcelRegister("27T0s", function(module, exports) {
    $parcel$export(module.exports, "isUndefined", ()=>$5713248736bc73bb$export$fce6876652108ab);
    $parcel$export(module.exports, "omitBy", ()=>$5713248736bc73bb$export$d7a617dda645b4e3);
    $parcel$export(module.exports, "getRandomHex", ()=>$5713248736bc73bb$export$456b25e3a9b4a843);
    const $5713248736bc73bb$export$fce6876652108ab = (value)=>value === undefined;
    const $5713248736bc73bb$export$357523c63a2253b9 = (obj, keys = [])=>{
        if (obj === undefined) return {};
        return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
    };
    const $5713248736bc73bb$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
    const $5713248736bc73bb$export$61fc7d43ac8f84b0 = (func, wait)=>{
        let timeout;
        return (...args)=>{
            clearTimeout(timeout);
            timeout = setTimeout(()=>func(...args), wait);
        };
    };
    const $5713248736bc73bb$export$de994efd351b291c = (srcObj)=>{
        return (obj)=>{
            let key;
            for(key in srcObj){
                if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
            }
            return true;
        };
    };
    function $5713248736bc73bb$var$getRandomHexValues(byte) {
        return [
            ...Array(byte * 2)
        ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
    }
    function $5713248736bc73bb$export$456b25e3a9b4a843(byte) {
        let randomHex;
        if (window?.crypto) try {
            randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
        } catch (e) {
            randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        }
        else randomHex = $5713248736bc73bb$var$getRandomHexValues(byte);
        return randomHex;
    }
});
parcelRegister("3JV6R", function(module, exports) {
    $parcel$export(module.exports, "mapAuthToQueryParameters", ()=>$30be3f63a223d0a0$export$6833b130611df767);
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    function $30be3f63a223d0a0$export$6833b130611df767(auth) {
        if ((0, $hQvj4.isClientBasedAuth)(auth)) return {
            client: auth.clientId,
            token: auth.token
        };
        else return {
            issuer: auth.asapIssuer,
            token: auth.token
        };
    }
});
parcelRegister("eeVEv", function(module, exports) {
    $parcel$export(module.exports, "mapToMediaCdnUrl", ()=>$ac061c5da59ee1d7$export$fb88a576cf28364d);
    var $VSDnB;
    var $h2NC7;
    const $ac061c5da59ee1d7$export$8a9b6ab3569a543a = {
        'api.media.atlassian.com': 'media-cdn.atlassian.com',
        'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
    };
    const $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
    function $ac061c5da59ee1d7$export$fb88a576cf28364d(url, token) {
        const tokenLength = token?.length ?? 0;
        if (!(0, (0, parcelRequire("h2NC7")).isCommercial)() || tokenLength > $ac061c5da59ee1d7$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_delivery') && (0, (0, parcelRequire("VSDnB")).fg)('platform_media_cdn_single_host')) try {
            const parsedUrl = new URL(url);
            const cdnHost = $ac061c5da59ee1d7$export$8a9b6ab3569a543a[parsedUrl.host];
            if (!cdnHost) return url;
            parsedUrl.host = cdnHost;
            return parsedUrl.toString();
        } catch (error) {
            return url;
        }
        return url;
    }
});
parcelRegister("5cMkQ", function(module, exports) {
    $parcel$export(module.exports, "resolveAuth", ()=>$c6441b149d7d138c$export$4b4cec3dcdfce972);
    $parcel$export(module.exports, "resolveInitialAuth", ()=>$c6441b149d7d138c$export$5211e1371264aec3);
    var $ciNTb;
    var $irn0C;
    const $c6441b149d7d138c$export$560085fe411c0660 = 10000;
    const $c6441b149d7d138c$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $c6441b149d7d138c$export$560085fe411c0660)=>{
        let auth;
        try {
            auth = await Promise.race([
                authProvider(authContext),
                (0, (0, parcelRequire("irn0C")).rejectTimeout)(authProviderTimeout, new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('authProviderTimedOut'))
            ]);
        } catch (err) {
            if (err instanceof (0, (0, parcelRequire("ciNTb")).MediaStoreError)) throw err;
            throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
        }
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('emptyAuth');
        return auth;
    };
    const $c6441b149d7d138c$export$5211e1371264aec3 = (auth)=>{
        if (!auth) throw new (0, (0, parcelRequire("ciNTb")).MediaStoreError)('missingInitialAuth');
        return auth;
    };
});
parcelRegister("ciNTb", function(module, exports) {
    $parcel$export(module.exports, "MediaStoreError", ()=>$63300db0f534a20c$export$b78480bd311630bc);
    $parcel$export(module.exports, "isMediaStoreError", ()=>$63300db0f534a20c$export$8d2a9b675b2ce37a);
    var $gFZHi;
    class $63300db0f534a20c$export$b78480bd311630bc extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, innerError){
            super(reason), this.reason = reason, this.innerError = innerError;
        }
        get attributes() {
            const { reason: reason, innerError: innerError } = this;
            return {
                reason: reason,
                innerError: innerError
            };
        }
    }
    function $63300db0f534a20c$export$8d2a9b675b2ce37a(err) {
        return err instanceof $63300db0f534a20c$export$b78480bd311630bc;
    }
});
parcelRegister("irn0C", function(module, exports) {
    $parcel$export(module.exports, "rejectTimeout", ()=>$974e005d07aa0732$export$cf2d2a1124beacb2);
    const $974e005d07aa0732$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
            setTimeout(resolve, timeout, resolveWith);
        });
    const $974e005d07aa0732$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
            setTimeout(reject, timeout, rejectWith);
        });
});
parcelRegister("iKPaV", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherImpl", ()=>$acdec836078e8c40$export$fe17eabf77aabacb);
    $parcel$export(module.exports, "FileFetcherError", ()=>(parcelRequire("gpU3c")).FileFetcherError);
    var $aZdZn = parcelRequire("aZdZn");
    var $cVFxd = parcelRequire("cVFxd");
    var $bXrHm = parcelRequire("bXrHm");
    parcelRequire("LmkUS");
    var $hQvj4 = parcelRequire("hQvj4");
    var $txcJN;
    var $1FyHg;
    var $1Pp1U;
    var $749LC;
    var $gpU3c;
    var $i57HF;
    var $hkwMq;
    var $bfb59;
    var $7E56q;
    var $6CZ6k = parcelRequire("6CZ6k");
    var $7p3Ot;
    var $lVahM;
    var $dhdZw;
    var $gayAy;
    var $j1BIJ;
    var $lYDAe;
    var $29M1K;
    var $2Mh8o;
    var $jzW7G;
    var $gR4o6;
    var $dJ905;
    var $9KWg9;
    parcelRequire("8HaZs");
    var $fN64m = parcelRequire("fN64m");
    class $acdec836078e8c40$export$fe17eabf77aabacb {
        constructor(mediaApi, store = (0, $fN64m.mediaStore)){
            this.mediaApi = mediaApi;
            this.store = store;
            this.getErrorFileState = (error, id, occurrenceKey)=>{
                const { metadata: metadata, ...attributes } = error?.attributes ?? {};
                return typeof error === 'string' ? {
                    status: 'error',
                    id: id,
                    reason: error,
                    occurrenceKey: occurrenceKey,
                    message: error
                } : {
                    status: 'error',
                    id: id,
                    reason: error?.reason,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    },
                    occurrenceKey: occurrenceKey,
                    message: error?.message
                };
            };
            this.setFileState = (id, fileState)=>{
                this.store.setState((state)=>{
                    state.files[id] = fileState;
                });
            };
            this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const poll = new (0, (0, parcelRequire("dJ905")).PollingFunction)();
                poll.onError = (error)=>subject.error(error);
                poll.execute(async ()=>{
                    const response = await this.dataloader.load({
                        id: id,
                        collectionName: collectionName
                    });
                    if ((0, (0, parcelRequire("749LC")).isNotFoundMediaItemDetails)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('emptyItems', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    if ((0, (0, parcelRequire("9KWg9")).isEmptyFile)(response)) throw new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('zeroVersionFile', id, {
                        collectionName: collectionName,
                        occurrenceKey: occurrenceKey,
                        traceContext: response.metadataTraceContext
                    });
                    const fileState = (0, (0, parcelRequire("1Pp1U")).mapMediaItemToFileState)(id, response);
                    subject.next(fileState);
                    switch(fileState.status){
                        case 'processing':
                            poll.next();
                            break;
                        case 'processed':
                            subject.complete();
                            break;
                    }
                });
                return subject;
            };
            this.getUploadingFileStateBase = (file, upfrontId)=>{
                if (typeof file.content === 'string') file.content = (0, (0, parcelRequire("gayAy")).convertBase64ToBlob)(file.content);
                const { content: content, name: name = '' } = file;
                const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
                let preview;
                let size = 0;
                let mimeType = '';
                if (content instanceof Blob) {
                    size = content.size;
                    mimeType = content.type;
                    preview = {
                        value: content,
                        origin: 'local'
                    };
                }
                const mediaType = (0, (0, parcelRequire("lVahM")).getMediaTypeFromUploadableFile)(file);
                return {
                    id: id,
                    occurrenceKey: occurrenceKey,
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: mimeType,
                    preview: preview
                };
            };
            this.dataloader = (0, (0, parcelRequire("7p3Ot")).createFileDataloader)(mediaApi);
        }
        getFileState(id, options = {}) {
            const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
            if (!(0, ($parcel$interopDefault($6CZ6k)))(id)) {
                const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const err = new (0, (0, parcelRequire("gpU3c")).FileFetcherError)('invalidFileId', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const { metadata: metadata, ...attributes } = err?.attributes ?? {};
                const errorFileState = {
                    status: 'error',
                    id: id,
                    reason: err?.reason,
                    message: err?.message,
                    occurrenceKey: occurrenceKey,
                    details: {
                        ...attributes,
                        ...metadata?.traceContext && {
                            metadata: metadata
                        }
                    }
                };
                subject.error(err);
                this.setFileState(id, errorFileState);
                return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
            }
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)((0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().getOrInsert(id, ()=>{
                const subject = this.createDownloadFileStream(id, collectionName);
                subject.subscribe({
                    next: (fileState)=>{
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(id, errorFileState);
                    }
                });
                return subject;
            }));
        }
        getCurrentState(id, options) {
            return (0, (0, parcelRequire("lYDAe")).toPromise)(this.getFileState(id, options));
        }
        getArtifactURL(artifacts, artifactName, collectionName) {
            return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
        }
        getFileBinaryURL(id, collectionName, maxAge) {
            return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
        }
        touchFiles(descriptors, collection, traceContext) {
            return this.mediaApi.touchFiles({
                descriptors: descriptors
            }, {
                collection: collection
            }, traceContext).then(({ data: data })=>data);
        }
        generateUploadableFileUpfrontIds(collection, traceContext) {
            const id = (0, ($parcel$interopDefault($bXrHm)))();
            const occurrenceKey = (0, ($parcel$interopDefault($bXrHm)))();
            const touchFileDescriptor = {
                fileId: id,
                occurrenceKey: occurrenceKey,
                collection: collection
            };
            const deferredUploadId = this.touchFiles([
                touchFileDescriptor
            ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                deferredUploadId: deferredUploadId
            };
        }
        async uploadExternal(url, collection, traceContext) {
            const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
            const preview = new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) reject('Could not fetch the blob');
                resolve({
                    value: blob,
                    origin: 'remote'
                });
            });
            const name = url.split('/').pop() || '';
            const fileState = {
                status: 'processing',
                name: name,
                size: 0,
                mediaType: 'unknown',
                mimeType: '',
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            };
            subject.next(fileState);
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            this.setFileState(id, fileState);
            return new Promise(async (resolve, reject)=>{
                const blob = await deferredBlob;
                if (!blob) return reject('Could not download remote file');
                const { type: type, size: size } = blob;
                const file = {
                    content: blob,
                    mimeType: type,
                    collection: collection,
                    name: name,
                    size: size
                };
                const mediaType = (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
                subject.next({
                    status: 'processing',
                    name: name,
                    size: size,
                    mediaType: mediaType,
                    mimeType: type,
                    id: id,
                    occurrenceKey: occurrenceKey,
                    preview: preview
                });
                this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
                let dimensions;
                try {
                    dimensions = await (0, (0, parcelRequire("29M1K")).getDimensionsFromBlob)(mediaType, blob);
                } catch (error) {
                    reject(error);
                    return;
                }
                resolve({
                    dimensions: dimensions,
                    mimeType: type,
                    uploadableFileUpfrontIds: uploadableFileUpfrontIds
                });
            });
        }
        upload(file, controller, uploadableFileUpfrontIds, traceContext) {
            const { collection: collection } = file;
            const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            const stateBase = this.getUploadingFileStateBase(file, upfrontId);
            const subject = (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
            (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(id, subject);
            const onProgress = (progress)=>{
                const fileState = {
                    status: 'uploading',
                    ...stateBase,
                    progress: progress
                };
                subject.next(fileState);
                this.setFileState(id, fileState);
            };
            let processingSubscription = new (0, $aZdZn.Subscription)();
            const onUploadFinish = (error)=>{
                if (error) {
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                    return subject.error(error);
                }
                processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $cVFxd.map)((remoteFileState)=>({
                        ...stateBase,
                        ...remoteFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                    }))).subscribe({
                    next: (fileState)=>{
                        subject.next(fileState);
                        this.setFileState(id, fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        subject.error(err);
                        this.setFileState(id, errorFileState);
                    },
                    complete: subject.complete
                });
            };
            const { cancel: cancel } = (0, (0, parcelRequire("i57HF")).uploadFile)(file, this.mediaApi, upfrontId, {
                onUploadFinish: onUploadFinish,
                onProgress: onProgress
            }, traceContext);
            controller?.setAbort(()=>{
                cancel();
                processingSubscription.unsubscribe();
            });
            setTimeout(onProgress, 0, 0);
            return (0, (0, parcelRequire("j1BIJ")).fromObservable)(subject);
        }
        async downloadBinary(id, name = 'download', collectionName, traceContext) {
            const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
            (0, (0, parcelRequire("txcJN")).downloadUrl)(url, {
                name: name
            });
            (0, (0, parcelRequire("bfb59")).globalMediaEventEmitter).emit('media-viewed', {
                fileId: id,
                isUserCollection: collectionName === (0, (0, parcelRequire("7E56q")).RECENTS_COLLECTION),
                viewingLevel: 'download'
            });
            await this.mediaApi.testUrl(url, {
                traceContext: traceContext
            });
        }
        async copyFile(source, destination, options = {}, traceContext) {
            const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
            const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
            const { preview: preview, mimeType: mimeType } = options;
            const mediaStore = destination.mediaStore || new (0, (0, parcelRequire("1FyHg")).MediaStore)({
                authProvider: destinationAuthProvider
            });
            const owner = (0, $hQvj4.authToOwner)(await authProvider({
                collectionName: sourceCollection
            }));
            const body = {
                sourceFile: {
                    id: id,
                    collection: sourceCollection,
                    owner: owner
                }
            };
            const params = {
                collection: destinationCollectionName,
                replaceFileId: replaceFileId,
                occurrenceKey: occurrenceKey
            };
            const cache = (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)();
            let processingSubscription;
            try {
                const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
                const copiedFileWithMimeType = {
                    ...copiedFile,
                    ...mimeType ? {
                        mimeType: mimeType
                    } : undefined
                };
                const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
                const mediaType = copiedMimeType ? (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
                const copiedFileState = (0, (0, parcelRequire("1Pp1U")).mapMediaFileToFileState)({
                    data: copiedFileWithMimeType
                });
                const fileCache = cache.get(copiedId);
                const subject = fileCache || (0, (0, parcelRequire("2Mh8o")).createMediaSubject)();
                const previewOverride = !(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && !!preview ? {
                    preview: preview
                } : {};
                if (!(0, (0, parcelRequire("1Pp1U")).isFinalFileState)(copiedFileState) && copiedMimeType && await (0, (0, parcelRequire("gR4o6")).shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                    const fileState = {
                        ...copiedFileState,
                        ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                        ...previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                    processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                        next: (remoteFileState)=>{
                            const fileState = {
                                ...remoteFileState,
                                ...(0, (0, parcelRequire("dhdZw")).overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                                ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(remoteFileState) && previewOverride
                            };
                            this.setFileState(copiedId, fileState);
                            return subject.next(fileState);
                        },
                        error: (err)=>{
                            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                            this.setFileState(copiedId, errorFileState);
                            return subject.error(err);
                        },
                        complete: ()=>subject.complete()
                    });
                } else if (!(0, (0, parcelRequire("1Pp1U")).isProcessingFileState)(copiedFileState)) {
                    const fileState = {
                        ...copiedFileState,
                        ...!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(copiedFileState) && previewOverride
                    };
                    subject.next(fileState);
                    this.setFileState(copiedId, fileState);
                }
                if (!cache.has(copiedId)) (0, (0, parcelRequire("hkwMq")).getFileStreamsCache)().set(copiedId, subject);
                return copiedFile;
            } catch (error) {
                if (processingSubscription) processingSubscription.unsubscribe();
                if (replaceFileId) {
                    const fileCache = cache.get(replaceFileId);
                    const replaceFileState = this.store.getState().files[replaceFileId];
                    if (fileCache) fileCache.error(error);
                    else cache.set(id, (0, (0, parcelRequire("2Mh8o")).createMediaSubject)(error));
                    const key = replaceFileState ? replaceFileId : id;
                    const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                    this.setFileState(key, errorFileState);
                }
                throw error;
            }
        }
    }
});
parcelRegister("txcJN", function(module, exports) {
    $parcel$export(module.exports, "downloadUrl", ()=>$4c4bd5defea17306$export$8a96edb1c96563f4);
    const $4c4bd5defea17306$export$8a96edb1c96563f4 = (url, options)=>{
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        if (options && options.name) link.download = options.name;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
});
parcelRegister("1Pp1U", function(module, exports) {
    $parcel$export(module.exports, "isUploadingFileState", ()=>$8f64b07ac8c4c4df$export$70eb3481b487c668);
    $parcel$export(module.exports, "isProcessingFileState", ()=>$8f64b07ac8c4c4df$export$5c30e6dd75278e66);
    $parcel$export(module.exports, "isProcessedFileState", ()=>$8f64b07ac8c4c4df$export$1d17291aafa5f231);
    $parcel$export(module.exports, "isErrorFileState", ()=>$8f64b07ac8c4c4df$export$f863e1e09c8a926);
    $parcel$export(module.exports, "isPreviewableFileState", ()=>$8f64b07ac8c4c4df$export$92dd692b31e42e64);
    $parcel$export(module.exports, "isFinalFileState", ()=>$8f64b07ac8c4c4df$export$270b3fc27120edd0);
    $parcel$export(module.exports, "isImageRepresentationReady", ()=>$8f64b07ac8c4c4df$export$4e33ccde53b4f0bf);
    $parcel$export(module.exports, "mapMediaFileToFileState", ()=>$8f64b07ac8c4c4df$export$ddfd67d20657322f);
    $parcel$export(module.exports, "mapMediaItemToFileState", ()=>$8f64b07ac8c4c4df$export$ea3730792e8bebfb);
    const $8f64b07ac8c4c4df$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
    const $8f64b07ac8c4c4df$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
    const $8f64b07ac8c4c4df$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
    const $8f64b07ac8c4c4df$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
    const $8f64b07ac8c4c4df$export$92dd692b31e42e64 = (fileState)=>!$8f64b07ac8c4c4df$export$f863e1e09c8a926(fileState) && !!fileState.preview;
    const $8f64b07ac8c4c4df$export$270b3fc27120edd0 = (fileState)=>[
            'processed',
            'failed-processing',
            'error'
        ].includes(fileState.status);
    const $8f64b07ac8c4c4df$export$4e33ccde53b4f0bf = (fileState)=>{
        switch(fileState.status){
            case 'processing':
            case 'processed':
            case 'failed-processing':
                return !!(fileState.representations && fileState.representations.image);
            default:
                return false;
        }
    };
    const $8f64b07ac8c4c4df$export$ddfd67d20657322f = (mediaFile)=>{
        const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
        const baseState = {
            id: id,
            name: name,
            size: size,
            mediaType: mediaType,
            mimeType: mimeType,
            artifacts: artifacts,
            representations: representations,
            createdAt: createdAt,
            metadataTraceContext: metadataTraceContext
        };
        switch(processingStatus){
            case 'pending':
            case undefined:
                return {
                    ...baseState,
                    status: 'processing'
                };
            case 'succeeded':
                return {
                    ...baseState,
                    status: 'processed'
                };
            case 'failed':
                return {
                    ...baseState,
                    status: 'failed-processing'
                };
        }
    };
    const $8f64b07ac8c4c4df$export$ea3730792e8bebfb = (id, item)=>{
        return $8f64b07ac8c4c4df$export$ddfd67d20657322f({
            data: {
                id: id,
                ...item
            }
        });
    };
});
parcelRegister("gpU3c", function(module, exports) {
    $parcel$export(module.exports, "FileFetcherError", ()=>$5a4b48edf9ec6627$export$e3e60f0dab8641de);
    var $gFZHi;
    class $5a4b48edf9ec6627$export$e3e60f0dab8641de extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason), this.reason = reason, this.id = id, this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey,
                ...traceContext && {
                    metadata: {
                        traceContext: traceContext
                    }
                }
            };
        }
    }
    function $5a4b48edf9ec6627$export$5c3435f75ce0ce70(err) {
        return err instanceof $5a4b48edf9ec6627$export$e3e60f0dab8641de;
    }
});
parcelRegister("i57HF", function(module, exports) {
    $parcel$export(module.exports, "uploadFile", ()=>$8cd2ca9b1610ac88$export$a5575dbeeffdad98);
    var $fEpeZ;
    var $gI62y = parcelRequire("gI62y");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $f6rzU;
    var $20Dmg;
    var $7E56q;
    var $empHz;
    const $8cd2ca9b1610ac88$var$hashingFunction = async (blob, hashAlgorithm)=>{
        const hasher = await (0, (0, parcelRequire("f6rzU")).createHasher)(hashAlgorithm);
        return hasher.hash(blob);
    };
    const $8cd2ca9b1610ac88$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
            return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
        };
    const $8cd2ca9b1610ac88$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
        let offset = 0;
        return async (chunks)=>{
            await store.appendChunksToUpload(await deferredUploadId, {
                chunks: $8cd2ca9b1610ac88$var$hashedChunks(chunks),
                offset: offset
            }, collection, traceContext);
            offset += chunks.length;
        };
    };
    const $8cd2ca9b1610ac88$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
        const { collection: collection, name: name, mimeType: mimeType } = file;
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const body = file.size ? {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType,
            conditions: {
                size: file.size
            }
        } : {
            uploadId: uploadId,
            name: name,
            mimeType: mimeType
        };
        return store.createFileFromUpload(body, {
            occurrenceKey: occurrenceKey,
            collection: collection,
            replaceFileId: id
        }, traceContext);
    };
    const $8cd2ca9b1610ac88$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
        const { content: content, collection: collection } = file;
        const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        let chunkSize = (0, (0, parcelRequire("7E56q")).CHUNK_SIZE);
        try {
            if (content instanceof Blob) chunkSize = (0, (0, parcelRequire("empHz")).calculateChunkSize)(content.size);
        } catch (err) {
            if (err instanceof Error && err.message === (0, (0, parcelRequire("empHz")).fileSizeError)) callbacks?.onUploadFinish(new (0, (0, parcelRequire("20Dmg")).UploaderError)(err.message, id, {
                collectionName: collection,
                occurrenceKey: occurrenceKey
            }));
            return {
                cancel: ()=>{
                    callbacks?.onUploadFinish('canceled');
                }
            };
        }
        const chunkinatorObservable = (0, (0, parcelRequire("fEpeZ")).chunkinator)(content, {
            hashingFunction: (blob)=>$8cd2ca9b1610ac88$var$hashingFunction(blob, store.chunkHashAlgorithm),
            hashingConcurrency: 5,
            chunkSize: chunkSize,
            uploadingConcurrency: 3,
            uploadingFunction: $8cd2ca9b1610ac88$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
            processingBatchSize: (0, (0, parcelRequire("7E56q")).PROCESSING_BATCH_SIZE),
            processingFunction: $8cd2ca9b1610ac88$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
        }, {
            onProgress (progress) {
                if (callbacks) callbacks.onProgress(progress);
            }
        });
        const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
        const subscription = (0, $gI62y.from)(deferredUploadId).pipe((0, $ib0Rz.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $ib0Rz.concatMap)(()=>(0, $gI62y.from)($8cd2ca9b1610ac88$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
            error: (err)=>onUploadFinish(err),
            complete: ()=>onUploadFinish()
        });
        return {
            cancel: ()=>{
                subscription.unsubscribe();
                onUploadFinish('canceled');
            }
        };
    };
    const $8cd2ca9b1610ac88$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);
});
parcelRegister("fEpeZ", function(module, exports) {
    $parcel$export(module.exports, "chunkinator", ()=>$2c9b70a291565367$export$9ab6bef3838698f8);
    var $j7Dz8 = parcelRequire("j7Dz8");
    var $ib0Rz = parcelRequire("ib0Rz");
    var $9RLLl = parcelRequire("9RLLl");
    var $bXPjr = parcelRequire("bXPjr");
    var $dglPr;
    var $kDczJ;
    var $4Vmg1;
    var $6SPPN;
    var $RsgFX;
    var $gI62y = parcelRequire("gI62y");
    const $2c9b70a291565367$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $bXPjr.fromPromise)((0, (0, parcelRequire("RsgFX")).fetchBlob)(file)).pipe((0, $ib0Rz.concatMap)((blob)=>{
            const { chunkSize: chunkSize } = options;
            const { onProgress: onProgress } = callbacks;
            const totalChunks = Math.ceil(blob.size / chunkSize);
            const slicenatedBlobs = (0, (0, parcelRequire("dglPr")).slicenator)(blob, {
                size: chunkSize
            });
            const hashinatedBlobs = (0, (0, parcelRequire("kDczJ")).hashinator)(slicenatedBlobs, {
                concurrency: options.hashingConcurrency,
                hasher: options.hashingFunction
            });
            let uploadedChunks = 0;
            let uploadedBlobs = (0, (0, parcelRequire("4Vmg1")).uploadinator)(hashinatedBlobs, {
                concurrency: options.uploadingConcurrency,
                uploader: options.uploadingFunction
            });
            if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $j7Dz8.tap)(()=>{
                uploadedChunks += 1;
                onProgress(uploadedChunks / totalChunks);
            }));
            return (0, (0, parcelRequire("6SPPN")).processinator)(uploadedBlobs, {
                batchSize: options.processingBatchSize,
                processor: options.processingFunction
            }).pipe((0, $ib0Rz.concatMap)((batchedChunks)=>{
                return (0, $gI62y.from)(batchedChunks);
            }), (0, $9RLLl.bufferCount)(totalChunks));
        }));
    const $2c9b70a291565367$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
        return $2c9b70a291565367$export$88e80b3a0bb31f63(file, options, callbacks);
    };
});
parcelRegister("dglPr", function(module, exports) {
    $parcel$export(module.exports, "slicenator", ()=>$f0508944ab60c7e6$export$5b92d769f2f57509);
    var $eTa7E = parcelRequire("eTa7E");
    var $cVFxd = parcelRequire("cVFxd");
    const $f0508944ab60c7e6$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
        const totalChunks = Math.ceil(blob.size / chunkSize);
        return (0, $eTa7E.range)(0, totalChunks).pipe((0, $cVFxd.map)((index)=>{
            return {
                partNumber: index + 1,
                blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
            };
        }));
    };
});
parcelRegister("kDczJ", function(module, exports) {
    $parcel$export(module.exports, "hashinator", ()=>$3a9c605917062ecc$export$d5f5a550a38ec367);
    var $RsgFX;
    const $3a9c605917062ecc$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                    blob: slicedBlob.blob,
                    hash: `${hash}-${slicedBlob.blob.size}`,
                    partNumber: slicedBlob.partNumber
                }));
    const $3a9c605917062ecc$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, (0, parcelRequire("RsgFX")).asyncMap)($3a9c605917062ecc$export$28a452a485721473(hasher), concurrency)(blobs$);
});
parcelRegister("RsgFX", function(module, exports) {
    $parcel$export(module.exports, "fetchBlob", ()=>$32ba0ece4537a1a3$export$14e9cfd4a872cc1e);
    $parcel$export(module.exports, "asyncMap", ()=>$32ba0ece4537a1a3$export$707ee4c4c95d39e3);
    var $kVLXA = parcelRequire("kVLXA");
    var $80gxR = parcelRequire("80gxR");
    async function $32ba0ece4537a1a3$export$14e9cfd4a872cc1e(file) {
        if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
        else return file;
    }
    const $32ba0ece4537a1a3$var$notify = (promise, observer, onReady)=>{
        const notifier = {
            notifyIfReady: ()=>false
        };
        promise.then((value)=>{
            notifier.notifyIfReady = ()=>{
                observer.next(value);
                observer.complete();
                return true;
            };
            onReady(notifier);
        }, (reason)=>{
            notifier.notifyIfReady = ()=>{
                observer.error(reason);
                return true;
            };
            onReady(notifier);
        });
        return notifier;
    };
    const $32ba0ece4537a1a3$var$mapper = (project)=>{
        const notifiers = new Array();
        const onReady = ()=>{
            const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
            if (notReadyIdx > 0) notifiers.splice(0, notReadyIdx);
        };
        return (value)=>new (0, $kVLXA.Observable)((sub)=>{
                notifiers.push($32ba0ece4537a1a3$var$notify(project(value), sub, onReady));
            });
    };
    const $32ba0ece4537a1a3$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $80gxR.mergeMap)($32ba0ece4537a1a3$var$mapper(project), concurrent);
});
parcelRegister("4Vmg1", function(module, exports) {
    $parcel$export(module.exports, "uploadinator", ()=>$a4f565ebdd47f0f4$export$94ce0f3fcf999415);
    var $RsgFX;
    const $a4f565ebdd47f0f4$export$94ce0f3fcf999415 = (blobs$, options)=>{
        const upload = (blob)=>{
            return options.uploader(blob).then(()=>blob);
        };
        return blobs$.pipe((0, (0, parcelRequire("RsgFX")).asyncMap)(upload, options.concurrency));
    };
});
parcelRegister("6SPPN", function(module, exports) {
    $parcel$export(module.exports, "processinator", ()=>$389997e3e47b2450$export$2f21790600302ed);
    var $9RLLl = parcelRequire("9RLLl");
    var $ib0Rz = parcelRequire("ib0Rz");
    const $389997e3e47b2450$export$2f21790600302ed = (blobs$, options)=>{
        const process = (blobs)=>{
            if (options.processor) return options.processor(blobs).then(()=>blobs);
            else return Promise.resolve(blobs);
        };
        return blobs$.pipe((0, $9RLLl.bufferCount)(options.batchSize)).pipe((0, $ib0Rz.concatMap)(process));
    };
});
parcelRegister("f6rzU", function(module, exports) {
    $parcel$export(module.exports, "createHasher", ()=>$8249c54a4574cd31$export$14b114effbc08b6b);
    parcelRequire("LmkUS");
    var $gPrGh = parcelRequire("gPrGh");
    let $8249c54a4574cd31$var$hasher = null;
    let $8249c54a4574cd31$var$sha256Hasher = null;
    const $8249c54a4574cd31$export$b7d263e6bc26b29a = ()=>$8249c54a4574cd31$var$hasher = null;
    const $8249c54a4574cd31$export$14b114effbc08b6b = async (algorithm)=>{
        const numWorkers = 3;
        if (algorithm === (0, $gPrGh.ChunkHashAlgorithm).Sha256) {
            if (!$8249c54a4574cd31$var$sha256Hasher) {
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("gT6vU"));
                $8249c54a4574cd31$var$sha256Hasher = new SimpleHasher();
            }
            return $8249c54a4574cd31$var$sha256Hasher;
        } else if (!$8249c54a4574cd31$var$hasher) try {
            const { WorkerHasher: WorkerHasher } = await (parcelRequire("0c3mv"));
            $8249c54a4574cd31$var$hasher = new WorkerHasher(numWorkers);
        } catch (error) {
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("4yBex"));
            $8249c54a4574cd31$var$hasher = new SimpleHasher();
        }
        return $8249c54a4574cd31$var$hasher;
    };
});
parcelRegister("gT6vU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("istkm").then(()=>parcelRequire('kXp7T'));
});
parcelRegister("0c3mv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("l0S2x")
    ]).then(()=>parcelRequire('3Gx8H'));
});
parcelRegister("4yBex", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iIdh2")
    ]).then(()=>parcelRequire('e4mxx'));
});
parcelRegister("20Dmg", function(module, exports) {
    $parcel$export(module.exports, "UploaderError", ()=>$5ee433d2b5ace7bb$export$515240c3f059c807);
    var $gFZHi;
    class $5ee433d2b5ace7bb$export$515240c3f059c807 extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, id, metadata){
            super(reason), this.reason = reason, this.id = id, this.metadata = metadata;
        }
        get attributes() {
            const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
            return {
                reason: reason,
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            };
        }
    }
    function $5ee433d2b5ace7bb$export$80ee180172bc336(err) {
        return err instanceof $5ee433d2b5ace7bb$export$515240c3f059c807;
    }
});
parcelRegister("empHz", function(module, exports) {
    $parcel$export(module.exports, "fileSizeError", ()=>$247cdc788c0fb235$export$b36239e4c33c2902);
    $parcel$export(module.exports, "calculateChunkSize", ()=>$247cdc788c0fb235$export$71f452e02035c1e2);
    var $749LC;
    var $7E56q;
    const $247cdc788c0fb235$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
    const $247cdc788c0fb235$export$71f452e02035c1e2 = (fileSize)=>{
        if (fileSize > (0, (0, parcelRequire("7E56q")).MAX_UPLOAD_FILE_SIZE)) throw new Error($247cdc788c0fb235$export$b36239e4c33c2902);
        if (fileSize <= 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 5 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB) return 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        if (fileSize > 50 * (0, (0, parcelRequire("749LC")).DATA_UNIT).GB && fileSize <= 0.95 * (0, (0, parcelRequire("749LC")).DATA_UNIT).TB) return 100 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
        return 210 * (0, (0, parcelRequire("749LC")).DATA_UNIT).MB;
    };
});
parcelRegister("hkwMq", function(module, exports) {
    $parcel$export(module.exports, "getFileStreamsCache", ()=>$451397184147c26f$export$f2f061938c1e6810);
    class $451397184147c26f$export$4293896e79732236 {
        constructor(streams){
            this.streams = streams;
        }
        has(id) {
            return !!this.streams.find(id);
        }
        set(id, stream) {
            this.streams.set(id, stream);
        }
        get(id) {
            return this.streams.get(id);
        }
        getOrInsert(id, callback) {
            if (!this.has(id)) this.set(id, callback());
            return this.get(id);
        }
        removeAll() {
            this.streams.clear();
        }
        remove(id) {
            this.streams.delete(id);
        }
        get size() {
            return this.streams.size;
        }
    }
    let $451397184147c26f$var$streamCache;
    const $451397184147c26f$export$f2f061938c1e6810 = ()=>{
        if (!$451397184147c26f$var$streamCache) {
            const mediaState = (parcelRequire("6a8j4")).mediaState;
            $451397184147c26f$var$streamCache = new $451397184147c26f$export$4293896e79732236(mediaState.streams);
        }
        return $451397184147c26f$var$streamCache;
    };
});
parcelRegister("bfb59", function(module, exports) {
    $parcel$export(module.exports, "globalMediaEventEmitter", ()=>$22065e01bf236cb8$export$68d003d3105952ad);
    parcelRequire("LmkUS");
    var $6a8j4 = parcelRequire("6a8j4");
    const $22065e01bf236cb8$export$68d003d3105952ad = {
        on (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.on(event, listener);
        },
        off (event, listener) {
            if ((0, $6a8j4.mediaState).eventEmitter) (0, $6a8j4.mediaState).eventEmitter.off(event, listener);
        },
        emit (event, payload) {
            if ((0, $6a8j4.mediaState).eventEmitter) return (0, $6a8j4.mediaState).eventEmitter.emit(event, payload);
            return undefined;
        }
    };
});
parcelRegister("6CZ6k", function(module, exports) {
    var $5k7LC = parcelRequire("5k7LC");
    var $4d35b0145f276bfe$require$Buffer = $5k7LC.Buffer;
    var $4d35b0145f276bfe$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    var $4d35b0145f276bfe$var$_byteToHex = [];
    for(var $4d35b0145f276bfe$var$i = 0; $4d35b0145f276bfe$var$i < 256; $4d35b0145f276bfe$var$i++)$4d35b0145f276bfe$var$_byteToHex[$4d35b0145f276bfe$var$i] = ($4d35b0145f276bfe$var$i + 0x100).toString(16).substr(1);
    function $4d35b0145f276bfe$var$unparse(buf, offset) {
        var i = offset || 0, bth = $4d35b0145f276bfe$var$_byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
    }
    module.exports = function(uuid, version) {
        var parsedUuid;
        if ($4d35b0145f276bfe$require$Buffer.isBuffer(uuid)) parsedUuid = $4d35b0145f276bfe$var$unparse(uuid);
        else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
        else return false;
        parsedUuid = parsedUuid.toLowerCase();
        if (!$4d35b0145f276bfe$var$pattern.test(parsedUuid)) return false;
        if (version === undefined) version = $4d35b0145f276bfe$var$extractVersion(parsedUuid);
        else if ($4d35b0145f276bfe$var$extractVersion(parsedUuid) !== version) return false;
        switch(version){
            case 1:
            case 2:
                return true;
            case 3:
            case 4:
            case 5:
                return [
                    '8',
                    '9',
                    'a',
                    'b'
                ].indexOf(parsedUuid.charAt(19)) !== -1;
            default:
                throw new Error('Invalid version provided.');
        }
    };
    var $4d35b0145f276bfe$var$extractVersion = module.exports.version = function(uuid) {
        return uuid.charAt(14) | 0;
    };
});
parcelRegister("7p3Ot", function(module, exports) {
    $parcel$export(module.exports, "createFileDataloader", ()=>$40dc831f91888cf8$export$ae188fee39529b82);
    var $hhZW9 = parcelRequire("hhZW9");
    var $27T0s;
    const $40dc831f91888cf8$export$b79d95ee17a87a = 100;
    const $40dc831f91888cf8$var$isBatchLoadingErrorResult = (result)=>{
        return result.error instanceof Error;
    };
    const $40dc831f91888cf8$var$isResponseFileItem = (fileItem)=>{
        return 'details' in fileItem;
    };
    const $40dc831f91888cf8$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
    const $40dc831f91888cf8$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
        const itemsByKey = fileItems.reduce((prev, fileItem)=>{
            const { id: id, collection: collection } = fileItem;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collection);
            if ($40dc831f91888cf8$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
            else if ($40dc831f91888cf8$var$isResponseFileItem(fileItem)) prev[key] = {
                ...fileItem.details,
                metadataTraceContext: fileItem.metadataTraceContext
            };
            else prev[key] = {
                id: id,
                collection: collection,
                type: 'not-found',
                metadataTraceContext: fileItem.metadataTraceContext
            };
            return prev;
        }, {});
        return dataloaderKeys.map((dataloaderKey)=>{
            const { id: id, collectionName: collectionName } = dataloaderKey;
            const key = $40dc831f91888cf8$var$makeCacheKey(id, collectionName);
            return itemsByKey[key] || {
                id: id,
                type: 'not-found'
            };
        });
    };
    function $40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore) {
        return async (keys)=>{
            const nonCollectionName = '__media-single-file-collection__';
            const fileIdsByCollection = keys.reduce((acc, key)=>{
                const collectionName = key.collectionName || nonCollectionName;
                const fileIds = acc[collectionName] || [];
                if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
                acc[collectionName] = fileIds;
                return acc;
            }, {});
            const items = [];
            await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
                const metadataTraceContext = {
                    traceId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8),
                    spanId: (0, (0, parcelRequire("27T0s")).getRandomHex)(8)
                };
                const fileIds = fileIdsByCollection[collectionNameKey];
                const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
                try {
                    const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                    const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                            ...item,
                            metadataTraceContext: metadataTraceContext
                        }));
                    items.push(...itemsWithMetadataTraceContext);
                    const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                    const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                    fileIdsNotFound.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            type: 'not-found',
                            metadataTraceContext: metadataTraceContext
                        });
                    });
                } catch (error) {
                    fileIds.forEach((fileId)=>{
                        items.push({
                            id: fileId,
                            collection: collectionName,
                            error: error
                        });
                    });
                }
            }));
            return $40dc831f91888cf8$export$71cd2e8f8162d47b(keys, items);
        };
    }
    function $40dc831f91888cf8$export$ae188fee39529b82(mediaStore) {
        return new (0, ($parcel$interopDefault($hhZW9)))($40dc831f91888cf8$export$4a53beb129e8c49a(mediaStore), {
            maxBatchSize: $40dc831f91888cf8$export$b79d95ee17a87a
        });
    }
});
parcelRegister("lVahM", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromUploadableFile", ()=>$748ba0ab0f854341$export$ac3214931ffd82af);
    var $jzW7G;
    const $748ba0ab0f854341$export$ac3214931ffd82af = (file)=>{
        if (file.content instanceof Blob) {
            const type = file.content.type;
            return (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
        } else return 'unknown';
    };
});
parcelRegister("jzW7G", function(module, exports) {
    $parcel$export(module.exports, "getMediaTypeFromMimeType", ()=>$08d056d70136c4e2$export$79e1dc0d1801e8ef);
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>(parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser);
    var $92ewp;
    var $8GKRF;
    var $lF4MN;
    const $08d056d70136c4e2$export$79e1dc0d1801e8ef = (mimeType)=>{
        if ((0, (0, parcelRequire("92ewp")).isArchive)(mimeType)) return 'archive';
        if ((0, (0, parcelRequire("8GKRF")).isImageMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
        if ((0, (0, parcelRequire("8GKRF")).isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
        if ((0, (0, parcelRequire("8GKRF")).isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
        if ((0, (0, parcelRequire("8GKRF")).isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, (0, parcelRequire("lF4MN")).isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
        return 'unknown';
    };
});
parcelRegister("92ewp", function(module, exports) {
    $parcel$export(module.exports, "isArchive", ()=>$addf45fda6198a62$export$f47f3fe506e20fe6);
    const $addf45fda6198a62$export$f47f3fe506e20fe6 = (mimeType)=>[
            'application/x-archive',
            'application/x-cpio',
            'application/x-shar',
            'application/x-iso9660-image',
            'application/x-sbx',
            'application/x-tar',
            'application/x-bzip2',
            'application/gzip',
            'application/x-gzip',
            'application/x-lzip',
            'application/x-lzma',
            'application/x-lzop',
            'application/x-snappy-framed',
            'application/x-xz',
            'application/x-compress',
            'application/zstd',
            'application/x-7z-compressed',
            'application/x-ace-compressed',
            'application/x-astrotite-afa',
            'application/x-alz-compressed',
            'application/vnd.android.package-archive',
            'application/x-freearc',
            'application/x-arj',
            'application/x-b1',
            'application/vnd.ms-cab-compressed',
            'application/x-cfs-compressed',
            'application/x-dar',
            'application/x-dgc-compressed',
            'application/x-apple-diskimage',
            'application/x-gca-compressed',
            'application/java-archive',
            'application/x-lzh',
            'application/x-lzx',
            'application/x-rar-compressed',
            'application/x-stuffit',
            'application/x-stuffitx',
            'application/x-gtar',
            'application/x-ms-wim',
            'application/x-xar',
            'application/zip',
            'application/x-zoo',
            'application/x-par2'
        ].indexOf(mimeType.toLowerCase()) > -1;
});
parcelRegister("8GKRF", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$c021f2623a75015f);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$74325e3c843a9555);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$ff36075ea755a717);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$87bf945cf31ec2d9);
    $parcel$export(module.exports, "isMimeTypeSupportedByBrowser", ()=>$3af4ecf7d6cb882c$export$55ca6cdaf6093034);
    const $3af4ecf7d6cb882c$export$c021f2623a75015f = (mimeType)=>[
            'image/apng',
            'image/bmp',
            'image/gif',
            'image/x-icon',
            'image/jpeg',
            'image/png',
            'image/webp'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
    const $3af4ecf7d6cb882c$export$ff36075ea755a717 = (mimeType)=>[
            'audio/aac',
            'audio/flac',
            'audio/mp4',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/wav',
            'audio/x-wav'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$87bf945cf31ec2d9 = (mimeType)=>[
            'video/mp4',
            'video/quicktime'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $3af4ecf7d6cb882c$export$55ca6cdaf6093034 = (mimeType)=>$3af4ecf7d6cb882c$export$74325e3c843a9555(mimeType) || $3af4ecf7d6cb882c$export$c021f2623a75015f(mimeType) || $3af4ecf7d6cb882c$export$ff36075ea755a717(mimeType) || $3af4ecf7d6cb882c$export$87bf945cf31ec2d9(mimeType);
});
parcelRegister("lF4MN", function(module, exports) {
    $parcel$export(module.exports, "isImageMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$e9a065a80f76311e);
    $parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$86baad7a89d908e9);
    $parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$8cba23825d020bbb);
    $parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$9c2b4de5fdca2ce3);
    $parcel$export(module.exports, "isMimeTypeSupportedByServer", ()=>$8b8147e427110cee$export$548d9148a80556a3);
    const $8b8147e427110cee$export$e9a065a80f76311e = (mimeType)=>[
            'image/bmp',
            'image/x-windows-bmp',
            'application/dicom',
            'image/gif',
            'image/jpeg',
            'image/jpg',
            'image/jp_',
            'application/jpg',
            'application/x-jpg',
            'image/png',
            'application/png',
            'application/x-png',
            'application/vnd.adobe.photoshop',
            'image/vnd.adobe.photoshop',
            'image/photoshop',
            'image/x-photoshop',
            'image/psd',
            'application/photoshop',
            'application/psd',
            'zz-application/zz-winassoc-psd',
            'image/tiff',
            'image/x-tif',
            'image/x-tiff',
            'application/tif',
            'application/x-tif',
            'application/tiff',
            'application/x-tiff',
            'image/svg+xml',
            'image/heif',
            'image/heif-sequence',
            'image/heic',
            'image/heic-sequence'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$86baad7a89d908e9 = (mimeType)=>[
            'application/pdf',
            'application/x-pdf',
            'application/acrobat',
            'applications/vnd.pdf',
            'text/pdf',
            'text/x-pdf',
            'application/vnd.adobe.illustrator',
            'application/vnd.ms-office',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
            'application/vnd.ms-word.document.macroenabled.12',
            'application/vnd.ms-word.template.macroenabled.12',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
            'application/vnd.ms-excel.sheet.macroenabled.12',
            'application/vnd.ms-excel.template.macroenabled.12',
            'application/vnd.ms-excel.addin.macroenabled.12',
            'application/vnd.ms-excel.sheet.macroenabled',
            'application/vnd.ms-excel.template.macroenabled',
            'application/vnd.ms-excel.addin.macroenabled',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.openxmlformats-officedocument.presentationml.template',
            'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
            'application/vnd.ms-powerpoint.presentation.macroenabled.12',
            'application/vnd.ms-powerpoint.template.macroenabled.12',
            'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
            'application/vnd.sun.xml.writer',
            'application/vnd.sun.xml.writer.template',
            'application/vnd.sun.xml.draw',
            'application/vnd.sun.xml.draw.template',
            'application/vnd.oasis.opendocument.graphics',
            'application/vnd.oasis.opendocument.presentation',
            'application/x-vnd.oasis.opendocument.presentation',
            'application/vnd.sun.xml.calc',
            'application/vnd.sun.xml.calc.template',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-vnd.oasis.opendocument.spreadsheet',
            'application/vnd.oasis.opendocument.spreadsheet-template',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.text-template',
            'application/vnd.oasis.opendocument.text-master',
            'application/x-vnd.oasis.opendocument.text',
            'application/x-vnd.oasis.opendocument.text-template',
            'application/x-vnd.oasis.opendocument.text-master',
            'application/vnd.wordperfect',
            'text/csv',
            'text/x-diff',
            'text/x-perl',
            'text/x-python',
            'text/x-ruby',
            'text/rtf',
            'text/richtext',
            'text/plain',
            'application/txt',
            'application/rtf',
            'application/x-rtf',
            'application/postscript'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$8cba23825d020bbb = (mimeType)=>[
            'audio/aac',
            'audio/x-hx-aac-adts',
            'audio/vnd.dolby.dd-raw',
            'audio/aiff',
            'audio/x-aiff',
            'audio/x-monkeys-audio',
            'audio/x-ape',
            'audio/basic',
            'audio/flac',
            'audio/mp4',
            'audio/midi',
            'audio/x-matroska',
            'audio/x-mod',
            'audio/mpeg',
            'audio/ogg',
            'audio/x-ogg',
            'audio/x-pn-realaudio',
            'audio/wav',
            'audio/x-wav',
            'audio/x-ms-wma'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$9c2b4de5fdca2ce3 = (mimeType)=>[
            'video/3gpp',
            'video/3gpp2',
            'video/x-ms-asf',
            'video/avi',
            'video/msvideo',
            'video/x-msvideo',
            'video/x-dv',
            'video/x-flv',
            'video/m2ts',
            'video/x-m4v',
            'video/x-matroska',
            'video/quicktime',
            'video/mp4',
            'video/mpeg',
            'video/ogg',
            'video/x-ogg',
            'video/webm',
            'video/x-ms-wmv'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$94e1479e01d2af53 = (mimeType)=>[
            'binary/octet-stream'
        ].indexOf(mimeType.toLowerCase()) > -1;
    const $8b8147e427110cee$export$548d9148a80556a3 = (mimeType)=>$8b8147e427110cee$export$e9a065a80f76311e(mimeType) || $8b8147e427110cee$export$86baad7a89d908e9(mimeType) || $8b8147e427110cee$export$8cba23825d020bbb(mimeType) || $8b8147e427110cee$export$9c2b4de5fdca2ce3(mimeType) || $8b8147e427110cee$export$94e1479e01d2af53(mimeType);
});
parcelRegister("dhdZw", function(module, exports) {
    $parcel$export(module.exports, "overrideMediaTypeIfUnknown", ()=>$c0fce003746ff4f7$export$89097c0ec1e0dee1);
    var $1Pp1U;
    const $c0fce003746ff4f7$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
        if (!(0, (0, parcelRequire("1Pp1U")).isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
            mediaType: mediaType
        };
        return {};
    };
});
parcelRegister("gayAy", function(module, exports) {
    $parcel$export(module.exports, "convertBase64ToBlob", ()=>$0fff1104576a2bb3$export$ed17558b11b88056);
    const $0fff1104576a2bb3$export$ed17558b11b88056 = (base64)=>{
        const sliceSize = 512;
        const base64Data = base64.split(',')[1];
        const byteCharacters = atob(base64Data);
        const byteArrays = [];
        for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, {
            type: 'image/jpeg'
        });
    };
});
parcelRegister("j1BIJ", function(module, exports) {
    $parcel$export(module.exports, "fromObservable", ()=>$6582fd60bc4bbd36$export$4b2432e2d8723823);
    var $2Mh8o;
    function $6582fd60bc4bbd36$export$4b2432e2d8723823(observable) {
        return {
            subscribe: (observer)=>{
                const subscription = observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
                return {
                    unsubscribe: ()=>{
                        subscription.unsubscribe();
                    }
                };
            }
        };
    }
    function $6582fd60bc4bbd36$export$8659d1f07d151381(item) {
        return $6582fd60bc4bbd36$export$4b2432e2d8723823((0, (0, parcelRequire("2Mh8o")).createMediaSubject)(item));
    }
});
parcelRegister("2Mh8o", function(module, exports) {
    $parcel$export(module.exports, "createMediaSubject", ()=>$c9b8fad0d34272f1$export$bc76d51553fa5e35);
    var $dZ0DN = parcelRequire("dZ0DN");
    function $c9b8fad0d34272f1$export$bc76d51553fa5e35(initialState) {
        const subject = new (0, $dZ0DN.ReplaySubject)(1);
        if (initialState instanceof Error) subject.error(initialState);
        else if (initialState) subject.next(initialState);
        return subject;
    }
});
parcelRegister("lYDAe", function(module, exports) {
    $parcel$export(module.exports, "toPromise", ()=>$44429e0ad2a9ded6$export$4dbaaf6c79705e6c);
    var $aZdZn = parcelRequire("aZdZn");
    const $44429e0ad2a9ded6$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $aZdZn.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
                next: (state)=>{
                    resolve(state);
                    subscription.unsubscribe();
                },
                error: (error)=>{
                    reject(error);
                    subscription.unsubscribe();
                }
            })));
});
parcelRegister("29M1K", function(module, exports) {
    $parcel$export(module.exports, "getDimensionsFromBlob", ()=>$c92d9e8096a99b5b$export$71797c284d89a3e1);
    var $8IWWt;
    var $5CbXO;
    const $c92d9e8096a99b5b$export$71797c284d89a3e1 = async (mediaType, blob)=>{
        switch(mediaType){
            case 'image':
                {
                    const url = URL.createObjectURL(blob);
                    try {
                        return await (0, (0, parcelRequire("8IWWt")).getImageDimensionsFromBlob)(url);
                    } finally{
                        URL.revokeObjectURL(url);
                    }
                }
            case 'video':
                return (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(blob);
            default:
                throw new Error(`Can't extract dimensions from ${mediaType}`);
        }
    };
});
parcelRegister("8IWWt", function(module, exports) {
    $parcel$export(module.exports, "getImageDimensionsFromBlob", ()=>$094f7e5912c5e863$export$a1c3205f28a20414);
    const $094f7e5912c5e863$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = url;
            img.onload = ()=>resolve({
                    width: img.width,
                    height: img.height
                });
            img.onerror = reject;
        });
});
parcelRegister("5CbXO", function(module, exports) {
    $parcel$export(module.exports, "getVideoDimensionsFromBlob", ()=>$3629651e482443d2$export$62aabd5ff85d0451);
    const $3629651e482443d2$export$62aabd5ff85d0451 = async (blob)=>{
        return new Promise((resolve, reject)=>{
            const url = URL.createObjectURL(blob);
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;
            video.addEventListener('loadedmetadata', function timeupdateHandler() {
                video.removeEventListener('loadedmetadata', timeupdateHandler);
                resolve({
                    width: video.videoWidth,
                    height: video.videoHeight
                });
                URL.revokeObjectURL(url);
            });
            video.addEventListener('error', ()=>{
                reject(new Error('failed to load video'));
                URL.revokeObjectURL(url);
            });
        });
    };
});
parcelRegister("gR4o6", function(module, exports) {
    $parcel$export(module.exports, "shouldFetchRemoteFileStates", ()=>$81fca2ad541e7785$export$2ccdd6f9a9eba6a);
    var $8GKRF;
    var $lF4MN;
    var $5CbXO;
    async function $81fca2ad541e7785$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
        if ((mediaType === 'doc' || !(0, (0, parcelRequire("8GKRF")).isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, (0, parcelRequire("lF4MN")).isMimeTypeSupportedByServer)(mimeType)) return true;
        if (mediaType === 'video' && !!preview) {
            const content = (await preview).value;
            if (!(content instanceof Blob)) return false;
            try {
                const { width: width, height: height } = await (0, (0, parcelRequire("5CbXO")).getVideoDimensionsFromBlob)(content);
                return !width && !height;
            } catch (e) {
                return true;
            }
        }
        return false;
    }
});
parcelRegister("dJ905", function(module, exports) {
    $parcel$export(module.exports, "PollingFunction", ()=>$a9b60fcbc1595cd8$export$4c54d536f8e37dc2);
    var $j8kdR;
    const $a9b60fcbc1595cd8$export$9f15a162d6785fc9 = {
        poll_intervalMs: 3000,
        poll_maxAttempts: 30,
        poll_backoffFactor: 1.25,
        poll_maxIntervalMs: 200000
    };
    class $a9b60fcbc1595cd8$export$4c54d536f8e37dc2 {
        constructor(options){
            this.poll_intervalMs = 0;
            this.attempt = 1;
            this.shouldIterate = true;
            this.timeoutId = 0;
            this.options = {
                ...$a9b60fcbc1595cd8$export$9f15a162d6785fc9,
                ...options
            };
            this.poll_intervalMs = this.options.poll_intervalMs;
        }
        async execute(executor) {
            const { poll_maxAttempts: poll_maxAttempts } = this.options;
            if (poll_maxAttempts === 0) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            try {
                this.shouldIterate = false;
                await executor();
                if (!this.shouldIterate) return;
                if (this.attempt >= poll_maxAttempts) return this.fail(new (0, (0, parcelRequire("j8kdR")).PollingError)('pollingMaxAttemptsExceeded', this.attempt));
                this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
                this.attempt++;
                this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
            } catch (error) {
                this.fail(error);
            }
        }
        fail(error) {
            const { onError: onError } = this;
            this.cancel();
            onError && onError(error);
        }
        getIntervalMsForIteration(iteration) {
            let poll_intervalMs = this.options.poll_intervalMs;
            if (iteration === 1) return poll_intervalMs;
            for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
            return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
        }
        next() {
            this.shouldIterate = true;
        }
        cancel() {
            window.clearTimeout(this.timeoutId);
            this.timeoutId = 0;
        }
    }
});
parcelRegister("j8kdR", function(module, exports) {
    $parcel$export(module.exports, "PollingError", ()=>$ba72cde1b79a6066$export$c3748c310e92340a);
    $parcel$export(module.exports, "isPollingError", ()=>$ba72cde1b79a6066$export$541e3e52eea6fece);
    var $gFZHi;
    class $ba72cde1b79a6066$export$c3748c310e92340a extends (0, (0, parcelRequire("gFZHi")).BaseMediaClientError) {
        constructor(reason, attempts){
            super(reason), this.reason = reason, this.attempts = attempts;
        }
        get attributes() {
            const { reason: reason, attempts: attempts } = this;
            return {
                reason: reason,
                attempts: attempts
            };
        }
    }
    function $ba72cde1b79a6066$export$541e3e52eea6fece(err) {
        return err instanceof $ba72cde1b79a6066$export$c3748c310e92340a;
    }
});
parcelRegister("9KWg9", function(module, exports) {
    $parcel$export(module.exports, "isEmptyFile", ()=>$6625df65da5f0486$export$728192ce8dd94659);
    const $6625df65da5f0486$export$d32fc52697b2ec92 = 43200000;
    function $6625df65da5f0486$export$728192ce8dd94659(fileDetails, now = Date.now()) {
        const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
        if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
            const msSinceFileCreation = now - createdAt;
            if (msSinceFileCreation > $6625df65da5f0486$export$d32fc52697b2ec92) return true;
        }
        return false;
    }
});
parcelRegister("8HaZs", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>(parcelRequire("fN64m")).mediaStore);
    var $fN64m = parcelRequire("fN64m");
});
parcelRegister("fN64m", function(module, exports) {
    $parcel$export(module.exports, "mediaStore", ()=>$df71566ec1e8fa2a$export$5785580dea19518d);
    var $bIv98;
    var $70n8Q;
    var $ee7sp;
    const $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        }))));
    const $df71566ec1e8fa2a$var$mediaStoreWithDevtools = (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).devtools)((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
            files: {}
        })))));
    const $df71566ec1e8fa2a$export$5785580dea19518d = $df71566ec1e8fa2a$var$mediaStoreWithoutDevtools;
    const $df71566ec1e8fa2a$export$503459913a0dc356 = (initialStore)=>{
        return (0, (0, parcelRequire("ee7sp")).createStore)()((0, (0, parcelRequire("bIv98")).subscribeWithSelector)((0, (0, parcelRequire("70n8Q")).immer)(()=>({
                files: {},
                ...initialStore
            }))));
    };
});
parcelRegister("bIv98", function(module, exports) {
    $parcel$export(module.exports, "devtools", ()=>$887bf6c78f4461c3$export$6922d3b3a607469e);
    $parcel$export(module.exports, "subscribeWithSelector", ()=>$887bf6c78f4461c3$export$5c593627aef9f076);
    var $887bf6c78f4461c3$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/middleware.mjs"
    });
    const $887bf6c78f4461c3$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
            api.dispatch = (action)=>{
                set((state)=>reducer(state, action), false, action);
                return action;
            };
            api.dispatchFromDevtools = true;
            return {
                dispatch: (...a)=>api.dispatch(...a),
                ...initial
            };
        };
    const $887bf6c78f4461c3$export$4feba8a1bc8e9afd = $887bf6c78f4461c3$var$reduxImpl;
    const $887bf6c78f4461c3$var$trackedConnections = new Map();
    const $887bf6c78f4461c3$var$getTrackedConnectionState = (name)=>{
        const api = $887bf6c78f4461c3$var$trackedConnections.get(name);
        if (!api) return {};
        return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
                key,
                api2.getState()
            ]));
    };
    const $887bf6c78f4461c3$var$extractConnectionInformation = (store, extensionConnector, options)=>{
        if (store === void 0) return {
            type: "untracked",
            connection: extensionConnector.connect(options)
        };
        const existingConnection = $887bf6c78f4461c3$var$trackedConnections.get(options.name);
        if (existingConnection) return {
            type: "tracked",
            store: store,
            ...existingConnection
        };
        const newConnection = {
            connection: extensionConnector.connect(options),
            stores: {}
        };
        $887bf6c78f4461c3$var$trackedConnections.set(options.name, newConnection);
        return {
            type: "tracked",
            store: store,
            ...newConnection
        };
    };
    const $887bf6c78f4461c3$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
            const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
            let extensionConnector;
            try {
                extensionConnector = (enabled != null ? enabled : ($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
            } catch (e) {}
            if (!extensionConnector) {
                if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
                return fn(set, get, api);
            }
            const { connection: connection, ...connectionInformation } = $887bf6c78f4461c3$var$extractConnectionInformation(store, extensionConnector, options);
            let isRecording = true;
            api.setState = (state, replace, nameOrAction)=>{
                const r = set(state, replace);
                if (!isRecording) return r;
                const action = nameOrAction === void 0 ? {
                    type: anonymousActionType || "anonymous"
                } : typeof nameOrAction === "string" ? {
                    type: nameOrAction
                } : nameOrAction;
                if (store === void 0) {
                    connection == null || connection.send(action, get());
                    return r;
                }
                connection == null || connection.send({
                    ...action,
                    type: `${store}/${action.type}`
                }, {
                    ...$887bf6c78f4461c3$var$getTrackedConnectionState(options.name),
                    [store]: api.getState()
                });
                return r;
            };
            const setStateFromDevtools = (...a)=>{
                const originalIsRecording = isRecording;
                isRecording = false;
                set(...a);
                isRecording = originalIsRecording;
            };
            const initialState = fn(api.setState, get, api);
            if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
            else {
                connectionInformation.stores[connectionInformation.store] = api;
                connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                        key,
                        key === connectionInformation.store ? initialState : store2.getState()
                    ])));
            }
            if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
                let didWarnAboutReservedActionType = false;
                const originalDispatch = api.dispatch;
                api.dispatch = (...a)=>{
                    if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                        console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                        didWarnAboutReservedActionType = true;
                    }
                    originalDispatch(...a);
                };
            }
            connection.subscribe((message)=>{
                var _a;
                switch(message.type){
                    case "ACTION":
                        if (typeof message.payload !== "string") {
                            console.error("[zustand devtools middleware] Unsupported action format");
                            return;
                        }
                        return $887bf6c78f4461c3$var$parseJsonThen(message.payload, (action)=>{
                            if (action.type === "__setState") {
                                if (store === void 0) {
                                    setStateFromDevtools(action.state);
                                    return;
                                }
                                if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                                const stateFromDevtools = action.state[store];
                                if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                                if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                                return;
                            }
                            if (!api.dispatchFromDevtools) return;
                            if (typeof api.dispatch !== "function") return;
                            api.dispatch(action);
                        });
                    case "DISPATCH":
                        switch(message.payload.type){
                            case "RESET":
                                setStateFromDevtools(initialState);
                                if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "COMMIT":
                                if (store === void 0) {
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                return connection == null ? void 0 : connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                            case "ROLLBACK":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        connection == null || connection.init(api.getState());
                                        return;
                                    }
                                    setStateFromDevtools(state[store]);
                                    connection == null || connection.init($887bf6c78f4461c3$var$getTrackedConnectionState(options.name));
                                });
                            case "JUMP_TO_STATE":
                            case "JUMP_TO_ACTION":
                                return $887bf6c78f4461c3$var$parseJsonThen(message.state, (state)=>{
                                    if (store === void 0) {
                                        setStateFromDevtools(state);
                                        return;
                                    }
                                    if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                                });
                            case "IMPORT_STATE":
                                {
                                    const { nextLiftedState: nextLiftedState } = message.payload;
                                    const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                    if (!lastComputedState) return;
                                    if (store === void 0) setStateFromDevtools(lastComputedState);
                                    else setStateFromDevtools(lastComputedState[store]);
                                    connection == null || connection.send(null, nextLiftedState);
                                    return;
                                }
                            case "PAUSE_RECORDING":
                                return isRecording = !isRecording;
                        }
                        return;
                }
            });
            return initialState;
        };
    const $887bf6c78f4461c3$export$6922d3b3a607469e = $887bf6c78f4461c3$var$devtoolsImpl;
    const $887bf6c78f4461c3$var$parseJsonThen = (stringified, f)=>{
        let parsed;
        try {
            parsed = JSON.parse(stringified);
        } catch (e) {
            console.error("[zustand devtools middleware] Could not parse the received json", e);
        }
        if (parsed !== void 0) f(parsed);
    };
    const $887bf6c78f4461c3$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
            const origSubscribe = api.subscribe;
            api.subscribe = (selector, optListener, options)=>{
                let listener = selector;
                if (optListener) {
                    const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                    let currentSlice = selector(api.getState());
                    listener = (state)=>{
                        const nextSlice = selector(state);
                        if (!equalityFn(currentSlice, nextSlice)) {
                            const previousSlice = currentSlice;
                            optListener(currentSlice = nextSlice, previousSlice);
                        }
                    };
                    if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
                }
                return origSubscribe(listener);
            };
            const initialState = fn(set, get, api);
            return initialState;
        };
    const $887bf6c78f4461c3$export$5c593627aef9f076 = $887bf6c78f4461c3$var$subscribeWithSelectorImpl;
    const $887bf6c78f4461c3$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
    function $887bf6c78f4461c3$export$95a3b7b12ab518f9(getStorage, options) {
        let storage;
        try {
            storage = getStorage();
        } catch (e) {
            return;
        }
        const persistStorage = {
            getItem: (name)=>{
                var _a;
                const parse = (str2)=>{
                    if (str2 === null) return null;
                    return JSON.parse(str2, options == null ? void 0 : options.reviver);
                };
                const str = (_a = storage.getItem(name)) != null ? _a : null;
                if (str instanceof Promise) return str.then(parse);
                return parse(str);
            },
            setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
            removeItem: (name)=>storage.removeItem(name)
        };
        return persistStorage;
    }
    const $887bf6c78f4461c3$var$toThenable = (fn)=>(input)=>{
            try {
                const result = fn(input);
                if (result instanceof Promise) return result;
                return {
                    then (onFulfilled) {
                        return $887bf6c78f4461c3$var$toThenable(onFulfilled)(result);
                    },
                    catch (_onRejected) {
                        return this;
                    }
                };
            } catch (e) {
                return {
                    then (_onFulfilled) {
                        return this;
                    },
                    catch (onRejected) {
                        return $887bf6c78f4461c3$var$toThenable(onRejected)(e);
                    }
                };
            }
        };
    const $887bf6c78f4461c3$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                getStorage: ()=>localStorage,
                serialize: JSON.stringify,
                deserialize: JSON.parse,
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage;
            try {
                storage = options.getStorage();
            } catch (e) {}
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const thenableSerialize = $887bf6c78f4461c3$var$toThenable(options.serialize);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                let errorInSync;
                const thenable = thenableSerialize({
                    state: state,
                    version: options.version
                }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                    errorInSync = e;
                });
                if (errorInSync) throw errorInSync;
                return thenable;
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            let stateFromStorage;
            const hydrate = ()=>{
                var _a;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>cb(get()));
                const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                    if (storageValue) return options.deserialize(storageValue);
                }).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.getStorage) storage = newOptions.getStorage();
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
            let options = {
                storage: $887bf6c78f4461c3$export$95a3b7b12ab518f9(()=>localStorage),
                partialize: (state)=>state,
                version: 0,
                merge: (persistedState, currentState)=>({
                        ...currentState,
                        ...persistedState
                    }),
                ...baseOptions
            };
            let hasHydrated = false;
            const hydrationListeners = new Set();
            const finishHydrationListeners = new Set();
            let storage = options.storage;
            if (!storage) return config((...args)=>{
                console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
                set(...args);
            }, get, api);
            const setItem = ()=>{
                const state = options.partialize({
                    ...get()
                });
                return storage.setItem(options.name, {
                    state: state,
                    version: options.version
                });
            };
            const savedSetState = api.setState;
            api.setState = (state, replace)=>{
                savedSetState(state, replace);
                setItem();
            };
            const configResult = config((...args)=>{
                set(...args);
                setItem();
            }, get, api);
            api.getInitialState = ()=>configResult;
            let stateFromStorage;
            const hydrate = ()=>{
                var _a, _b;
                if (!storage) return;
                hasHydrated = false;
                hydrationListeners.forEach((cb)=>{
                    var _a2;
                    return cb((_a2 = get()) != null ? _a2 : configResult);
                });
                const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
                return $887bf6c78f4461c3$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                    if (deserializedStorageValue) {
                        if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                            if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                        } else return deserializedStorageValue.state;
                    }
                }).then((migratedState)=>{
                    var _a2;
                    stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                    set(stateFromStorage, true);
                    return setItem();
                }).then(()=>{
                    postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                    stateFromStorage = get();
                    hasHydrated = true;
                    finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
                }).catch((e)=>{
                    postRehydrationCallback == null || postRehydrationCallback(void 0, e);
                });
            };
            api.persist = {
                setOptions: (newOptions)=>{
                    options = {
                        ...options,
                        ...newOptions
                    };
                    if (newOptions.storage) storage = newOptions.storage;
                },
                clearStorage: ()=>{
                    storage == null || storage.removeItem(options.name);
                },
                getOptions: ()=>options,
                rehydrate: ()=>hydrate(),
                hasHydrated: ()=>hasHydrated,
                onHydrate: (cb)=>{
                    hydrationListeners.add(cb);
                    return ()=>{
                        hydrationListeners.delete(cb);
                    };
                },
                onFinishHydration: (cb)=>{
                    finishHydrationListeners.add(cb);
                    return ()=>{
                        finishHydrationListeners.delete(cb);
                    };
                }
            };
            if (!options.skipHydration) hydrate();
            return stateFromStorage || configResult;
        };
    const $887bf6c78f4461c3$var$persistImpl = (config, baseOptions)=>{
        if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
            if (($887bf6c78f4461c3$import_meta.env ? $887bf6c78f4461c3$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
            return $887bf6c78f4461c3$var$oldImpl(config, baseOptions);
        }
        return $887bf6c78f4461c3$var$newImpl(config, baseOptions);
    };
    const $887bf6c78f4461c3$export$9a6132153fba2e0 = $887bf6c78f4461c3$var$persistImpl;
});
parcelRegister("70n8Q", function(module, exports) {
    $parcel$export(module.exports, "immer", ()=>$519a7bf2c276fd5a$export$428de7ec69ac95c);
    var $86xFr;
    const $519a7bf2c276fd5a$var$immerImpl = (initializer)=>(set, get, store)=>{
            store.setState = (updater, replace, ...a)=>{
                const nextState = typeof updater === "function" ? (0, (0, parcelRequire("86xFr")).produce)(updater) : updater;
                return set(nextState, replace, ...a);
            };
            return initializer(store.setState, get, store);
        };
    const $519a7bf2c276fd5a$export$428de7ec69ac95c = $519a7bf2c276fd5a$var$immerImpl;
});
parcelRegister("86xFr", function(module, exports) {
    $parcel$export(module.exports, "produce", ()=>fn);
    function n(n) {
        for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
        var i, o;
        throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
            return "'" + n + "'";
        }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
    }
    function r(n) {
        return !!n && !!n[Q];
    }
    function t(n) {
        var r;
        return !!n && (function(n) {
            if (!n || "object" != typeof n) return !1;
            var r = Object.getPrototypeOf(n);
            if (null === r) return !0;
            var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
            return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
        }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
    }
    function e(t) {
        return r(t) || n(23, t), t[Q].t;
    }
    function i(n, r, t) {
        void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
            t && "symbol" == typeof e || r(e, n[e], n);
        }) : n.forEach(function(t, e) {
            return r(e, t, n);
        });
    }
    function o(n) {
        var r = n[Q];
        return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
    }
    function u(n, r) {
        return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
    }
    function a(n, r) {
        return 2 === o(n) ? n.get(r) : n[r];
    }
    function f(n, r, t) {
        var e = o(n);
        2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
    }
    function c(n, r) {
        return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
    }
    function s(n) {
        return X && n instanceof Map;
    }
    function v(n) {
        return q && n instanceof Set;
    }
    function p(n) {
        return n.o || n.t;
    }
    function l(n) {
        if (Array.isArray(n)) return Array.prototype.slice.call(n);
        var r = rn(n);
        delete r[Q];
        for(var t = nn(r), e = 0; e < t.length; e++){
            var i = t[e], o = r[i];
            !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
                configurable: !0,
                writable: !0,
                enumerable: o.enumerable,
                value: n[i]
            });
        }
        return Object.create(Object.getPrototypeOf(n), r);
    }
    function d(n, e) {
        return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
            return d(r, !0);
        }, !0)), n;
    }
    function h() {
        n(2);
    }
    function y(n) {
        return null == n || "object" != typeof n || Object.isFrozen(n);
    }
    function b(r) {
        var t = tn[r];
        return t || n(18, r), t;
    }
    function m(n, r) {
        tn[n] || (tn[n] = r);
    }
    function _() {
        return U;
    }
    function j(n, r) {
        r && (b("Patches"), n.u = [], n.s = [], n.v = r);
    }
    function g(n) {
        O(n), n.p.forEach(S), n.p = null;
    }
    function O(n) {
        n === U && (U = n.l);
    }
    function w(n) {
        return U = {
            p: [],
            l: U,
            h: n,
            m: !0,
            _: 0
        };
    }
    function S(n) {
        var r = n[Q];
        0 === r.i || 1 === r.i ? r.j() : r.g = !0;
    }
    function P(r, e) {
        e._ = e.p.length;
        var i = e.p[0], o = void 0 !== r && r !== i;
        return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
    }
    function M(n, r, t) {
        if (y(r)) return r;
        var e = r[Q];
        if (!e) return i(r, function(i, o) {
            return A(n, e, r, i, o, t);
        }, !0), r;
        if (e.A !== n) return r;
        if (!e.P) return x(n, e.t, !0), e.t;
        if (!e.I) {
            e.I = !0, e.A._--;
            var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
            3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
                return A(n, e, o, r, i, t, a);
            }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
        }
        return e.o;
    }
    function A(e, i, o, a, c, s, v) {
        if (r(c)) {
            var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
            if (f(o, a, p), !r(p)) return;
            e.m = !1;
        } else v && o.add(c);
        if (t(c) && !y(c)) {
            if (!e.h.D && e._ < 1) return;
            M(e, c), i && i.A.l || x(e, c);
        }
    }
    function x(n, r, t) {
        void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
    }
    function z(n, r) {
        var t = n[Q];
        return (t ? p(t) : n)[r];
    }
    function I(n, r) {
        if (r in n) for(var t = Object.getPrototypeOf(n); t;){
            var e = Object.getOwnPropertyDescriptor(t, r);
            if (e) return e;
            t = Object.getPrototypeOf(t);
        }
    }
    function k(n) {
        n.P || (n.P = !0, n.l && k(n.l));
    }
    function E(n) {
        n.o || (n.o = l(n.t));
    }
    function N(n, r, t) {
        var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
            var t = Array.isArray(n), e = {
                i: t ? 1 : 0,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: null,
                o: null,
                j: null,
                C: !1
            }, i = e, o = en;
            t && (i = [
                e
            ], o = on);
            var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
            return e.k = f, e.j = a, f;
        }(r, t) : b("ES5").J(r, t);
        return (t ? t.A : _()).p.push(e), e;
    }
    function R(e) {
        return r(e) || n(22, e), function n(r) {
            if (!t(r)) return r;
            var e, u = r[Q], c = o(r);
            if (u) {
                if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
                u.I = !0, e = D(r, c), u.I = !1;
            } else e = D(r, c);
            return i(e, function(r, t) {
                u && a(u.t, r) === t || f(e, r, n(t));
            }), 3 === c ? new Set(e) : e;
        }(e);
    }
    function D(n, r) {
        switch(r){
            case 2:
                return new Map(n);
            case 3:
                return Array.from(n);
        }
        return l(n);
    }
    function F() {
        function t(n, r) {
            var t = s[n];
            return t ? t.enumerable = r : s[n] = t = {
                configurable: !0,
                enumerable: r,
                get: function() {
                    var r = this[Q];
                    return en.get(r, n);
                },
                set: function(r) {
                    var t = this[Q];
                    en.set(t, n, r);
                }
            }, t;
        }
        function e(n) {
            for(var r = n.length - 1; r >= 0; r--){
                var t = n[r][Q];
                if (!t.P) switch(t.i){
                    case 5:
                        a(t) && k(t);
                        break;
                    case 4:
                        o(t) && k(t);
                }
            }
        }
        function o(n) {
            for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
                var o = e[i];
                if (o !== Q) {
                    var a = r[o];
                    if (void 0 === a && !u(r, o)) return !0;
                    var f = t[o], s = f && f[Q];
                    if (s ? s.t !== a : !c(f, a)) return !0;
                }
            }
            var v = !!r[Q];
            return e.length !== nn(r).length + (v ? 0 : 1);
        }
        function a(n) {
            var r = n.k;
            if (r.length !== n.t.length) return !0;
            var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
            if (t && !t.get) return !0;
            for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
            return !1;
        }
        function f(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var s = {};
        m("ES5", {
            J: function(n, r) {
                var e = Array.isArray(n), i = function(n, r) {
                    if (n) {
                        for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                        return e;
                    }
                    var o = rn(r);
                    delete o[Q];
                    for(var u = nn(o), a = 0; a < u.length; a++){
                        var f = u[a];
                        o[f] = t(f, n || !!o[f].enumerable);
                    }
                    return Object.create(Object.getPrototypeOf(r), o);
                }(e, n), o = {
                    i: e ? 5 : 4,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    R: {},
                    l: r,
                    t: n,
                    k: i,
                    o: null,
                    g: !1,
                    C: !1
                };
                return Object.defineProperty(i, Q, {
                    value: o,
                    writable: !0
                }), i;
            },
            S: function(n, t, o) {
                o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                    if (r && "object" == typeof r) {
                        var t = r[Q];
                        if (t) {
                            var e = t.t, o = t.k, f = t.R, c = t.i;
                            if (4 === c) i(o, function(r) {
                                r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                            }), i(e, function(n) {
                                void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                            });
                            else if (5 === c) {
                                if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                                else for(var v = e.length; v < o.length; v++)f[v] = !0;
                                for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                            }
                        }
                    }
                }(n.p[0]), e(n.p));
            },
            K: function(n) {
                return 4 === n.i ? o(n) : a(n);
            }
        });
    }
    function T() {
        function e(n) {
            if (!t(n)) return n;
            if (Array.isArray(n)) return n.map(e);
            if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
                return [
                    n[0],
                    e(n[1])
                ];
            }));
            if (v(n)) return new Set(Array.from(n).map(e));
            var r = Object.create(Object.getPrototypeOf(n));
            for(var i in n)r[i] = e(n[i]);
            return u(n, L) && (r[L] = n[L]), r;
        }
        function f(n) {
            return r(n) ? e(n) : n;
        }
        var c = "add";
        m("Patches", {
            $: function(r, t) {
                return t.forEach(function(t) {
                    for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                        var v = o(f), p = i[s];
                        "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                    }
                    var l = o(f), d = e(t.value), h = i[i.length - 1];
                    switch(u){
                        case "replace":
                            switch(l){
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    n(16);
                                default:
                                    return f[h] = d;
                            }
                        case c:
                            switch(l){
                                case 1:
                                    return "-" === h ? f.push(d) : f.splice(h, 0, d);
                                case 2:
                                    return f.set(h, d);
                                case 3:
                                    return f.add(d);
                                default:
                                    return f[h] = d;
                            }
                        case "remove":
                            switch(l){
                                case 1:
                                    return f.splice(h, 1);
                                case 2:
                                    return f.delete(h);
                                case 3:
                                    return f.delete(t.value);
                                default:
                                    return delete f[h];
                            }
                        default:
                            n(17, u);
                    }
                }), r;
            },
            N: function(n, r, t, e) {
                switch(n.i){
                    case 0:
                    case 4:
                    case 2:
                        return function(n, r, t, e) {
                            var o = n.t, s = n.o;
                            i(n.R, function(n, i) {
                                var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                                if (v !== p || "replace" !== l) {
                                    var d = r.concat(n);
                                    t.push("remove" === l ? {
                                        op: l,
                                        path: d
                                    } : {
                                        op: l,
                                        path: d,
                                        value: p
                                    }), e.push(l === c ? {
                                        op: "remove",
                                        path: d
                                    } : "remove" === l ? {
                                        op: c,
                                        path: d,
                                        value: f(v)
                                    } : {
                                        op: "replace",
                                        path: d,
                                        value: f(v)
                                    });
                                }
                            });
                        }(n, r, t, e);
                    case 5:
                    case 1:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.R, u = n.o;
                            if (u.length < i.length) {
                                var a = [
                                    u,
                                    i
                                ];
                                i = a[0], u = a[1];
                                var s = [
                                    e,
                                    t
                                ];
                                t = s[0], e = s[1];
                            }
                            for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                                var p = r.concat([
                                    v
                                ]);
                                t.push({
                                    op: "replace",
                                    path: p,
                                    value: f(u[v])
                                }), e.push({
                                    op: "replace",
                                    path: p,
                                    value: f(i[v])
                                });
                            }
                            for(var l = i.length; l < u.length; l++){
                                var d = r.concat([
                                    l
                                ]);
                                t.push({
                                    op: c,
                                    path: d,
                                    value: f(u[l])
                                });
                            }
                            i.length < u.length && e.push({
                                op: "replace",
                                path: r.concat([
                                    "length"
                                ]),
                                value: i.length
                            });
                        }(n, r, t, e);
                    case 3:
                        return function(n, r, t, e) {
                            var i = n.t, o = n.o, u = 0;
                            i.forEach(function(n) {
                                if (!o.has(n)) {
                                    var i = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: "remove",
                                        path: i,
                                        value: n
                                    }), e.unshift({
                                        op: c,
                                        path: i,
                                        value: n
                                    });
                                }
                                u++;
                            }), u = 0, o.forEach(function(n) {
                                if (!i.has(n)) {
                                    var o = r.concat([
                                        u
                                    ]);
                                    t.push({
                                        op: c,
                                        path: o,
                                        value: n
                                    }), e.unshift({
                                        op: "remove",
                                        path: o,
                                        value: n
                                    });
                                }
                                u++;
                            });
                        }(n, r, t, e);
                }
            },
            M: function(n, r, t, e) {
                t.push({
                    op: "replace",
                    path: [],
                    value: r === H ? void 0 : r
                }), e.push({
                    op: "replace",
                    path: [],
                    value: n
                });
            }
        });
    }
    function C() {
        function r(n, r) {
            function t() {
                this.constructor = n;
            }
            a(n, r), n.prototype = (t.prototype = r.prototype, new t);
        }
        function e(n) {
            n.o || (n.R = new Map, n.o = new Map(n.t));
        }
        function o(n) {
            n.o || (n.o = new Set, n.t.forEach(function(r) {
                if (t(r)) {
                    var e = N(n.A.h, r, n);
                    n.p.set(r, e), n.o.add(e);
                } else n.o.add(r);
            }));
        }
        function u(r) {
            r.g && n(3, JSON.stringify(p(r)));
        }
        var a = function(n, r) {
            return (a = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(n, r) {
                n.__proto__ = r;
            } || function(n, r) {
                for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
            })(n, r);
        }, f = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 2,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    R: void 0,
                    t: n,
                    k: this,
                    C: !1,
                    g: !1
                }, this;
            }
            r(n, Map);
            var o = n.prototype;
            return Object.defineProperty(o, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), o.has = function(n) {
                return p(this[Q]).has(n);
            }, o.set = function(n, r) {
                var t = this[Q];
                return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
            }, o.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
            }, o.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                    n.R.set(r, !1);
                }), n.o.clear());
            }, o.forEach = function(n, r) {
                var t = this;
                p(this[Q]).forEach(function(e, i) {
                    n.call(r, t.get(i), i, t);
                });
            }, o.get = function(n) {
                var r = this[Q];
                u(r);
                var i = p(r).get(n);
                if (r.I || !t(i)) return i;
                if (i !== r.t.get(n)) return i;
                var o = N(r.A.h, i, r);
                return e(r), r.o.set(n, o), o;
            }, o.keys = function() {
                return p(this[Q]).keys();
            }, o.values = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.values();
                }, n.next = function() {
                    var n = t.next();
                    return n.done ? n : {
                        done: !1,
                        value: r.get(n.value)
                    };
                }, n;
            }, o.entries = function() {
                var n, r = this, t = this.keys();
                return (n = {})[V] = function() {
                    return r.entries();
                }, n.next = function() {
                    var n = t.next();
                    if (n.done) return n;
                    var e = r.get(n.value);
                    return {
                        done: !1,
                        value: [
                            n.value,
                            e
                        ]
                    };
                }, n;
            }, o[V] = function() {
                return this.entries();
            }, n;
        }(), c = function() {
            function n(n, r) {
                return this[Q] = {
                    i: 3,
                    l: r,
                    A: r ? r.A : _(),
                    P: !1,
                    I: !1,
                    o: void 0,
                    t: n,
                    k: this,
                    p: new Map,
                    g: !1,
                    C: !1
                }, this;
            }
            r(n, Set);
            var t = n.prototype;
            return Object.defineProperty(t, "size", {
                get: function() {
                    return p(this[Q]).size;
                }
            }), t.has = function(n) {
                var r = this[Q];
                return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
            }, t.add = function(n) {
                var r = this[Q];
                return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
            }, t.delete = function(n) {
                if (!this.has(n)) return !1;
                var r = this[Q];
                return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
            }, t.clear = function() {
                var n = this[Q];
                u(n), p(n).size && (o(n), k(n), n.o.clear());
            }, t.values = function() {
                var n = this[Q];
                return u(n), o(n), n.o.values();
            }, t.entries = function() {
                var n = this[Q];
                return u(n), o(n), n.o.entries();
            }, t.keys = function() {
                return this.values();
            }, t[V] = function() {
                return this.values();
            }, t.forEach = function(n, r) {
                for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
            }, n;
        }();
        m("MapSet", {
            F: function(n, r) {
                return new f(n, r);
            },
            T: function(n, r) {
                return new c(n, r);
            }
        });
    }
    function J() {
        F(), C(), T();
    }
    function K(n) {
        return n;
    }
    function $(n) {
        return n;
    }
    var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
        0: "Illegal state",
        1: "Immer drafts cannot have computed properties",
        2: "This object has been frozen and should not be mutated",
        3: function(n) {
            return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
        },
        4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
        5: "Immer forbids circular references",
        6: "The first or second argument to `produce` must be a function",
        7: "The third argument to `produce` must be a function or undefined",
        8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
        9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
        10: "The given draft is already finalized",
        11: "Object.defineProperty() cannot be used on an Immer draft",
        12: "Object.setPrototypeOf() cannot be used on an Immer draft",
        13: "Immer only supports deleting array indices",
        14: "Immer only supports setting array indices and the 'length' property",
        15: function(n) {
            return "Cannot apply patch, path doesn't resolve: " + n;
        },
        16: 'Sets cannot have "replace" patches.',
        17: function(n) {
            return "Unsupported patch operation: " + n;
        },
        18: function(n) {
            return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
        },
        20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
        21: function(n) {
            return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
        },
        22: function(n) {
            return "'current' expects a draft, got: " + n;
        },
        23: function(n) {
            return "'original' expects a draft, got: " + n;
        },
        24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
    }, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
        return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
    } : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
        var r = {};
        return nn(n).forEach(function(t) {
            r[t] = Object.getOwnPropertyDescriptor(n, t);
        }), r;
    }, tn = {}, en = {
        get: function(n, r) {
            if (r === Q) return n;
            var e = p(n);
            if (!u(e, r)) return function(n, r, t) {
                var e, i = I(r, t);
                return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
            }(n, e, r);
            var i = e[r];
            return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
        },
        has: function(n, r) {
            return r in p(n);
        },
        ownKeys: function(n) {
            return Reflect.ownKeys(p(n));
        },
        set: function(n, r, t) {
            var e = I(p(n), r);
            if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
            if (!n.P) {
                var i = z(p(n), r), o = null == i ? void 0 : i[Q];
                if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
                if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
                E(n), k(n);
            }
            return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
        },
        deleteProperty: function(n, r) {
            return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
        },
        getOwnPropertyDescriptor: function(n, r) {
            var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
            return e ? {
                writable: !0,
                configurable: 1 !== n.i || "length" !== r,
                enumerable: e.enumerable,
                value: t[r]
            } : e;
        },
        defineProperty: function() {
            n(11);
        },
        getPrototypeOf: function(n) {
            return Object.getPrototypeOf(n.t);
        },
        setPrototypeOf: function() {
            n(12);
        }
    }, on = {};
    i(en, function(n, r) {
        on[n] = function() {
            return arguments[0] = arguments[0][0], r.apply(this, arguments);
        };
    }), on.deleteProperty = function(r, t) {
        return on.set.call(this, r, t, void 0);
    }, on.set = function(r, t, e) {
        return en.set.call(this, r[0], t, e, r[0]);
    };
    var un = function() {
        function e(r) {
            var e = this;
            this.O = B, this.D = !0, this.produce = function(r, i, o) {
                if ("function" == typeof r && "function" != typeof i) {
                    var u = i;
                    i = r;
                    var a = e;
                    return function(n) {
                        var r = this;
                        void 0 === n && (n = u);
                        for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                        return a.produce(n, function(n) {
                            var t;
                            return (t = i).call.apply(t, [
                                r,
                                n
                            ].concat(e));
                        });
                    };
                }
                var f;
                if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                    var c = w(e), s = N(e, r, void 0), v = !0;
                    try {
                        f = i(s), v = !1;
                    } finally{
                        v ? g(c) : O(c);
                    }
                    return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                        return j(c, o), P(n, c);
                    }, function(n) {
                        throw g(c), n;
                    }) : (j(c, o), P(f, c));
                }
                if (!r || "object" != typeof r) {
                    if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                        var p = [], l = [];
                        b("Patches").M(r, f, p, l), o(p, l);
                    }
                    return f;
                }
                n(21, r);
            }, this.produceWithPatches = function(n, r) {
                if ("function" == typeof n) return function(r) {
                    for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                    return e.produceWithPatches(r, function(r) {
                        return n.apply(void 0, [
                            r
                        ].concat(i));
                    });
                };
                var t, i, o = e.produce(n, r, function(n, r) {
                    t = n, i = r;
                });
                return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                    return [
                        n,
                        t,
                        i
                    ];
                }) : [
                    o,
                    t,
                    i
                ];
            }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
        }
        var i = e.prototype;
        return i.createDraft = function(e) {
            t(e) || n(8), r(e) && (e = R(e));
            var i = w(this), o = N(this, e, void 0);
            return o[Q].C = !0, O(i), o;
        }, i.finishDraft = function(r, t) {
            var e = r && r[Q];
            var i = e.A;
            return j(i, t), P(void 0, i);
        }, i.setAutoFreeze = function(n) {
            this.D = n;
        }, i.setUseProxies = function(r) {
            r && !B && n(20), this.O = r;
        }, i.applyPatches = function(n, t) {
            var e;
            for(e = t.length - 1; e >= 0; e--){
                var i = t[e];
                if (0 === i.path.length && "replace" === i.op) {
                    n = i.value;
                    break;
                }
            }
            e > -1 && (t = t.slice(e + 1));
            var o = b("Patches").$;
            return r(n) ? o(n, t) : this.produce(n, function(n) {
                return o(n, t);
            });
        }, e;
    }(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
    var $5e68ffea5fb572cb$export$2e2bcd8739ae039 = fn;
});
parcelRegister("ee7sp", function(module, exports) {
    $parcel$export(module.exports, "createStore", ()=>$a5b82856cfbd137f$export$f51a9068ac82ea43);
    var $a5b82856cfbd137f$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/vanilla.mjs"
    });
    const $a5b82856cfbd137f$var$createStoreImpl = (createState)=>{
        let state;
        const listeners = new Set();
        const setState = (partial, replace)=>{
            const nextState = typeof partial === "function" ? partial(state) : partial;
            if (!Object.is(nextState, state)) {
                const previousState = state;
                state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
                listeners.forEach((listener)=>listener(state, previousState));
            }
        };
        const getState = ()=>state;
        const getInitialState = ()=>initialState;
        const subscribe = (listener)=>{
            listeners.add(listener);
            return ()=>listeners.delete(listener);
        };
        const destroy = ()=>{
            if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
            listeners.clear();
        };
        const api = {
            setState: setState,
            getState: getState,
            getInitialState: getInitialState,
            subscribe: subscribe,
            destroy: destroy
        };
        const initialState = state = createState(setState, getState, api);
        return api;
    };
    const $a5b82856cfbd137f$export$f51a9068ac82ea43 = (createState)=>createState ? $a5b82856cfbd137f$var$createStoreImpl(createState) : $a5b82856cfbd137f$var$createStoreImpl;
    var $a5b82856cfbd137f$export$2e2bcd8739ae039 = (createState)=>{
        if (($a5b82856cfbd137f$import_meta.env ? $a5b82856cfbd137f$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
        return $a5b82856cfbd137f$export$f51a9068ac82ea43(createState);
    };
});
parcelRegister("5eAc2", function(module, exports) {
    $parcel$export(module.exports, "StargateClient", ()=>$0084b28d1d44d0da$export$c66ca190f89caaac);
    class $0084b28d1d44d0da$export$c66ca190f89caaac {
        constructor(baseUrl){
            this.baseUrl = baseUrl || '/gateway/api';
        }
        async fetchToken(clientId) {
            return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
                credentials: 'include',
                headers: {
                    'x-client-id': clientId
                }
            })).json();
        }
        isTokenExpired(token) {
            const currentTimeInSeconds = new Date().getTime() / 1000;
            return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
        }
    }
});
parcelRegister("hUEMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ais1M").then(()=>parcelRequire('piTsY'));
});
parcelRegister("h17zy", function(module, exports) {
    $parcel$export(module.exports, "useEmojiProvider", ()=>$502e0815e90e6f7b$export$d80cf6b7758b1c7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGzaM;
    var $hXRXz;
    var $90yGq;
    var $koeKL;
    const $502e0815e90e6f7b$export$d80cf6b7758b1c7e = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const atlassianAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const emojiProvider = (0, $5uXOq.useMemo)(()=>{
            const dataProviders = new (0, (0, parcelRequire("dGzaM")).default)();
            dataProviders.setProvider('emojiProvider', (0, (0, parcelRequire("hXRXz")).getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
            return dataProviders;
        }, [
            cloudId,
            atlassianAccountId
        ]);
        return emojiProvider;
    };
});
parcelRegister("hXRXz", function(module, exports) {
    $parcel$export(module.exports, "getEmojiProvider", ()=>$8599af293a85f3b3$export$8210f5f78c0bcf27);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", ()=>$8599af293a85f3b3$export$f9c5a1e85ff0cb72);
    $parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", ()=>$8599af293a85f3b3$export$7cda0fc535c2710f);
    var $3Uu1D;
    var $9CGZY;
    const $8599af293a85f3b3$var$baseProviders = (serviceBaseUrl)=>[
            {
                url: `${serviceBaseUrl}/emoji/standard`
            },
            {
                url: `${serviceBaseUrl}/emoji/atlassian`
            }
        ];
    const $8599af293a85f3b3$export$8210f5f78c0bcf27 = ()=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_SERVICEID), (serviceBaseUrl)=>{
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: $8599af293a85f3b3$var$baseProviders(serviceBaseUrl)
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: providers,
                allowUpload: true,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
    const $8599af293a85f3b3$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, (0, parcelRequire("9CGZY")).getServiceProvider)((0, (0, parcelRequire("9CGZY")).EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
            const providers = cloudId ? [
                ...$8599af293a85f3b3$var$baseProviders(serviceBaseUrl),
                {
                    url: `${serviceBaseUrl}/emoji/${cloudId}/site`
                }
            ] : $8599af293a85f3b3$var$baseProviders(serviceBaseUrl);
            const emojiResource = new (0, (0, parcelRequire("3Uu1D")).default)({
                providers: providers,
                allowUpload: false,
                currentUser: {
                    id: accountId
                }
            });
            return emojiResource.getEmojiProvider();
        });
});
parcelRegister("3Uu1D", function(module, exports) {
    $parcel$export(module.exports, "supportsUploadFeature", ()=>$b4e19b4b20da22f1$export$7b697b720032fd6f);
    $parcel$export(module.exports, "default", ()=>$b4e19b4b20da22f1$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    var $kin1Z;
    var $b8sgr;
    var $5B9Cy;
    var $d9blH;
    var $9AR2K;
    var $f2M1N;
    var $WeQTx;
    var $62WHo;
    var $d2UcN;
    const $b4e19b4b20da22f1$export$7b697b720032fd6f = (emojiProvider)=>{
        const emojiUploadProvider = emojiProvider;
        return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
    };
    class $b4e19b4b20da22f1$export$b5efafc6dd611ec5 extends (0, $dS9cn.AbstractResource) {
        constructor(config){
            super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
                if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
                return;
            }, this.isRepositoryAvailable = (repository)=>{
                return !!repository;
            }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
            this.emojiProviderConfig = config;
            this.recordConfig = config.recordConfig;
            this.currentUser = config.currentUser;
            if ((0, (0, parcelRequire("d9blH")).default)('localStorage')) this.selectedTone = this.loadStoredTone();
            if (config.providers.length === 0) throw new Error('No providers specified');
            this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
            this.initialLoaders = this.emojiProviderConfig.providers.length;
            this.activeLoaders = this.emojiProviderConfig.providers.length;
            this.emojiResponses = [];
        }
        async getEmojiProvider(options = {
            fetchAtStart: !this.fetchOnDemand
        }) {
            if (options.fetchAtStart) try {
                await this.fetchEmojiProvider();
            } catch (error) {
                (0, (0, parcelRequire("b8sgr")).default)(error);
                return Promise.resolve(this);
            }
            return Promise.resolve(this);
        }
        async fetchIndividualProvider(provider, index) {
            const providerType = this.getProviderType(provider);
            try {
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).start({
                    samplingRate: (0, (0, parcelRequire("kin1Z")).SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
                });
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                    type: providerType
                });
                const loader = new (0, (0, parcelRequire("f2M1N")).default)(provider);
                const emojiResponse = await loader.loadEmoji();
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).success();
                this.emojiResponses[index] = emojiResponse;
                this.initEmojiRepository(this.emojiResponses);
                await this.initSiteEmojiResource(emojiResponse, provider);
                this.activeLoaders--;
                this.performRetries();
                this.refreshLastFilter();
            } catch (error) {
                this.activeLoaders--;
                this.notifyError(error);
                (0, (0, parcelRequire("d2UcN")).sampledUfoEmojiResourceFetched)(providerType).failure({
                    metadata: {
                        reason: error,
                        source: 'EmojiProvider',
                        providerUrl: provider.url
                    }
                });
                (0, (0, parcelRequire("b8sgr")).default)(`failed to fetch emoji provider for ${provider.url}`, error);
                throw new Error(`failed to fetch emoji from ${provider.url}`);
            }
        }
        async fetchEmojiProvider(force = false) {
            if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
                this.isInitialised = true;
                this.emojiResponses = [];
                await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
            }
            return Promise.resolve(this.emojiRepository);
        }
        onlyFetchOnDemand() {
            return this.fetchOnDemand;
        }
        async fetchByEmojiId(emojiId, optimistic) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
                const emoji = await this.findByEmojiId(emojiId);
                if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
            if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
                const provider = {
                    url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                    securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
                };
                const loader = new (0, (0, parcelRequire("f2M1N")).default)(provider);
                try {
                    const loadEmoji = await loader.loadEmoji();
                    if (!loadEmoji.emojis[0]) return;
                    if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                    return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
                } catch  {
                    const emoji = await this.findByEmojiId(emojiId);
                    if (!emoji) return;
                    return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
                }
            }
            const emoji = await this.findByEmojiId(emojiId);
            if (!emoji) return;
            return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        getProviderType(provider) {
            if (provider.url.includes('/site')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).SITE;
            else if (provider.url.includes('/standard')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).STANDARD;
            else if (provider.url.includes('/atlassian')) return (0, (0, parcelRequire("9AR2K")).ProviderTypes).ATLASSIAN;
            return (0, (0, parcelRequire("9AR2K")).ProviderTypes).UNKNOWN;
        }
        initEmojiRepository(emojiResponses) {
            let emojis = [];
            emojiResponses.forEach((emojiResponse)=>{
                emojis = emojis.concat(emojiResponse.emojis);
            });
            this.emojiRepository = new (0, (0, parcelRequire("WeQTx")).default)(emojis);
        }
        initSiteEmojiResource(emojiResponse, provider) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
                this.siteEmojiResource = new (0, (0, parcelRequire("62WHo")).default)(provider, emojiResponse.mediaApiToken);
                const { emojis: emojis } = emojiResponse;
                if (emojis.length) {
                    const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                    if ((0, (0, parcelRequire("5B9Cy")).isPromise)(done)) return done.then(()=>{
                        (0, (0, parcelRequire("b8sgr")).default)('Primed siteEmojiResource');
                    }).catch(()=>{
                        (0, (0, parcelRequire("b8sgr")).default)('Failed to prime siteEmojiResource');
                    });
                    else (0, (0, parcelRequire("b8sgr")).default)('Already primed siteEmojiResource');
                } else (0, (0, parcelRequire("b8sgr")).default)('No emoji to prime siteEmojiResource with');
            }
            return Promise.resolve();
        }
        performRetries() {
            const currentRetries = this.retries;
            this.retries = new Map();
            currentRetries.forEach((resolveReject, retry)=>{
                const result = retry();
                if ((0, (0, parcelRequire("5B9Cy")).isPromise)(result)) result.then((response)=>{
                    resolveReject.resolve(response);
                }).catch((reason)=>{
                    resolveReject.reject(reason);
                });
                else resolveReject.resolve(result);
            });
        }
        loadStoredTone() {
            if (typeof window === 'undefined') return undefined;
            const storedToneString = window.localStorage.getItem((0, (0, parcelRequire("kin1Z")).selectedToneStorageKey));
            if (storedToneString) {
                const storedTone = parseInt(storedToneString, 10);
                return !isNaN(storedTone) ? storedTone : undefined;
            }
            return undefined;
        }
        refreshLastFilter() {
            if (typeof this.lastQuery !== 'undefined') {
                const { query: query, options: options } = this.lastQuery;
                this.filter(query, options);
            }
        }
        retryIfLoading(retry, defaultResponse) {
            if (!this.isLoaded()) return new Promise((resolve, reject)=>{
                this.retries.set(retry, {
                    resolve: resolve,
                    reject: reject
                });
            });
            return Promise.resolve(defaultResponse);
        }
        notifyResult(result) {
            if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
        }
        async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) {
                const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
                return {
                    ...emoji,
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
            return emoji;
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) return emoji;
            return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
        }
        optimisticMediaRendering(emoji, useAlt) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) return true;
            if (!this.isRepositoryAvailable(this.siteEmojiResource)) return false;
            const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(optimistic)) return false;
            return optimistic;
        }
        filter(query, options) {
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].start();
            (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].addMetadata({
                queryLength: query?.length || 0
            });
            this.lastQuery = {
                query: query,
                options: options
            };
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                const searchResults = this.emojiRepository.search(query, options);
                this.notifyResult(searchResults);
                (0, (0, parcelRequire("d2UcN")).ufoExperiences)['emoji-searched'].success({
                    metadata: {
                        emojisLength: searchResults.emojis.length,
                        source: options?.source || 'typeahead'
                    }
                });
            } else this.notifyNotReady();
        }
        findByShortName(shortName) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findByShortName(shortName);
            return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
        }
        findByEmojiId(emojiId) {
            const { id: id, shortName: shortName } = emojiId;
            if (this.isRepositoryAvailable(this.emojiRepository)) {
                if (id) {
                    const emoji = this.emojiRepository.findById(id);
                    if (emoji) return emoji;
                    if (this.isLoaded()) {
                        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                            if (!emoji) return this.findByShortName(shortName);
                            this.addUnknownEmoji(emoji);
                            return emoji;
                        });
                        return this.findByShortName(shortName);
                    }
                } else return this.findByShortName(shortName);
            }
            return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
        }
        findById(id) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
            return this.retryIfLoading(()=>this.findById(id), undefined);
        }
        findInCategory(categoryId) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
            return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
        }
        getAsciiMap() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
            return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
        }
        getFrequentlyUsed(options) {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
            return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
        }
        recordSelection(emoji) {
            const { recordConfig: recordConfig } = this;
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
            if (recordConfig) {
                const queryParams = {
                    emojiId: (0, (0, parcelRequire("5B9Cy")).toEmojiId)(emoji)
                };
                const requestInit = {
                    method: 'POST'
                };
                return (0, $dS9cn.utils).requestService(recordConfig, {
                    queryParams: queryParams,
                    requestInit: requestInit
                });
            }
            return Promise.resolve();
        }
        deleteSiteEmoji(emoji) {
            if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
                if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                    this.emojiRepository.delete(emoji);
                    return true;
                }
                return false;
            }).catch((err)=>{
                console.error('failed to delete site emoji', err);
                return false;
            });
            return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
        }
        getSelectedTone() {
            return this.selectedTone;
        }
        setSelectedTone(tone) {
            this.selectedTone = tone;
            if (typeof window === 'undefined') return;
            if ((0, (0, parcelRequire("d9blH")).default)('localStorage')) try {
                window.localStorage.setItem((0, (0, parcelRequire("kin1Z")).selectedToneStorageKey), tone ? tone.toString() : '');
            } catch (e) {
                console.error('failed to store selected emoji skin tone', e);
            }
        }
        calculateDynamicCategories() {
            if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
            return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
        }
        getCurrentUser() {
            return this.currentUser;
        }
        addUnknownEmoji(emoji) {
            if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
        }
    }
    class $b4e19b4b20da22f1$export$2e2bcd8739ae039 extends $b4e19b4b20da22f1$export$b5efafc6dd611ec5 {
        constructor(config){
            super(config);
            this.allowUpload = !!config.allowUpload;
        }
        isUploadSupported() {
            if (!this.allowUpload) return Promise.resolve(false);
            if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
            return this.retryIfLoading(()=>this.isUploadSupported(), false);
        }
        uploadCustomEmoji(upload, retry = false) {
            return this.isUploadSupported().then((supported)=>{
                if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
                return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                    emoji.representation.imagePath = upload.dataURL;
                    this.addUnknownEmoji(emoji);
                    this.refreshLastFilter();
                    return emoji;
                });
            });
        }
        prepareForUpload() {
            if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
            return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
        }
    }
});
parcelRegister("kin1Z", function(module, exports) {
    $parcel$export(module.exports, "customCategory", ()=>$1c1f8a5ed290c232$export$5e4e3d1c3e43156a);
    $parcel$export(module.exports, "frequentCategory", ()=>$1c1f8a5ed290c232$export$78ccdc4be403c468);
    $parcel$export(module.exports, "searchCategory", ()=>$1c1f8a5ed290c232$export$1b0258512be88334);
    $parcel$export(module.exports, "yourUploadsCategory", ()=>$1c1f8a5ed290c232$export$42b510423367f354);
    $parcel$export(module.exports, "customTitle", ()=>$1c1f8a5ed290c232$export$5d0f2d8ee50f86f5);
    $parcel$export(module.exports, "userCustomTitle", ()=>$1c1f8a5ed290c232$export$1debc2f10cc69389);
    $parcel$export(module.exports, "dataURLPrefix", ()=>$1c1f8a5ed290c232$export$8ac325bfd32359b0);
    $parcel$export(module.exports, "deleteEmojiLabel", ()=>$1c1f8a5ed290c232$export$a330961542edfe6f);
    $parcel$export(module.exports, "MAX_ORDINAL", ()=>$1c1f8a5ed290c232$export$1a817f1886276c6d);
    $parcel$export(module.exports, "defaultEmojiHeight", ()=>$1c1f8a5ed290c232$export$3f99ac31dc0406db);
    $parcel$export(module.exports, "emojiPickerWidth", ()=>$1c1f8a5ed290c232$export$d171dc12fee2b1da);
    $parcel$export(module.exports, "sizeGap", ()=>$1c1f8a5ed290c232$export$c10ac8125a260041);
    $parcel$export(module.exports, "defaultEmojiPickerSize", ()=>$1c1f8a5ed290c232$export$5248fb9e0cccc41f);
    $parcel$export(module.exports, "emojiPickerMinHeight", ()=>$1c1f8a5ed290c232$export$94f75d625e7801d3);
    $parcel$export(module.exports, "emojiPickerHeight", ()=>$1c1f8a5ed290c232$export$7ed599d166d65aea);
    $parcel$export(module.exports, "emojiPickerListHeight", ()=>$1c1f8a5ed290c232$export$7722b8e9522021df);
    $parcel$export(module.exports, "emojiPickerHeightWithPreview", ()=>$1c1f8a5ed290c232$export$e67f617938b111f1);
    $parcel$export(module.exports, "localStoragePrefix", ()=>$1c1f8a5ed290c232$export$e394a0c530ae5631);
    $parcel$export(module.exports, "selectedToneStorageKey", ()=>$1c1f8a5ed290c232$export$79ee4ef84c545f8f);
    $parcel$export(module.exports, "defaultCategories", ()=>$1c1f8a5ed290c232$export$d7ab74456f1aa1ad);
    $parcel$export(module.exports, "KeyboardKeys", ()=>$1c1f8a5ed290c232$export$70f9e5bc10d7eac);
    $parcel$export(module.exports, "KeyboardNavigationDirection", ()=>$1c1f8a5ed290c232$export$1c4f2adc1f8e19d3);
    $parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$99130b698ea188ae);
    $parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$84b035f8d01101cc);
    $parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$e27d4e477c0cd4ec);
    $parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", ()=>$1c1f8a5ed290c232$export$97027974dc06eeee);
    $parcel$export(module.exports, "DEFAULT_TONE", ()=>$1c1f8a5ed290c232$export$4f0ee90b28d6efc5);
    $parcel$export(module.exports, "EMOJI_LIST_COLUMNS", ()=>$1c1f8a5ed290c232$export$2829f3ec323f8ec0);
    $parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", ()=>$1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2);
    $parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", ()=>$1c1f8a5ed290c232$export$858e8dc100a97278);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", ()=>$1c1f8a5ed290c232$export$83aab2ae64548423);
    $parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", ()=>$1c1f8a5ed290c232$export$66cabad5e268b05e);
    const $1c1f8a5ed290c232$export$5e4e3d1c3e43156a = 'CUSTOM';
    const $1c1f8a5ed290c232$export$78ccdc4be403c468 = 'FREQUENT';
    const $1c1f8a5ed290c232$export$2c4b04c3aacdf1b3 = 'SITE';
    const $1c1f8a5ed290c232$export$1b0258512be88334 = 'SEARCH';
    const $1c1f8a5ed290c232$export$42b510423367f354 = 'USER_CUSTOM';
    const $1c1f8a5ed290c232$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
    const $1c1f8a5ed290c232$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
    const $1c1f8a5ed290c232$export$8ac325bfd32359b0 = 'data:';
    const $1c1f8a5ed290c232$export$a330961542edfe6f = 'delete-emoji';
    const $1c1f8a5ed290c232$export$1a817f1886276c6d = 100000;
    const $1c1f8a5ed290c232$export$3f99ac31dc0406db = 20;
    const $1c1f8a5ed290c232$export$d171dc12fee2b1da = 350;
    const $1c1f8a5ed290c232$export$c10ac8125a260041 = 80;
    const $1c1f8a5ed290c232$export$5248fb9e0cccc41f = 'medium';
    const $1c1f8a5ed290c232$export$94f75d625e7801d3 = 260;
    const $1c1f8a5ed290c232$export$7ed599d166d65aea = 295;
    const $1c1f8a5ed290c232$export$7722b8e9522021df = $1c1f8a5ed290c232$export$7ed599d166d65aea - 58;
    const $1c1f8a5ed290c232$export$e218e5cb105a0e22 = 54;
    const $1c1f8a5ed290c232$export$e67f617938b111f1 = $1c1f8a5ed290c232$export$7ed599d166d65aea + $1c1f8a5ed290c232$export$e218e5cb105a0e22;
    const $1c1f8a5ed290c232$export$e394a0c530ae5631 = 'fabric.emoji';
    const $1c1f8a5ed290c232$export$79ee4ef84c545f8f = `${$1c1f8a5ed290c232$export$e394a0c530ae5631}.selectedTone`;
    const $1c1f8a5ed290c232$export$d7ab74456f1aa1ad = [
        'PEOPLE',
        'NATURE',
        'FOODS',
        'ACTIVITY',
        'PLACES',
        'OBJECTS',
        'SYMBOLS',
        'FLAGS'
    ];
    var $1c1f8a5ed290c232$export$70f9e5bc10d7eac;
    (function(KeyboardKeys) {
        KeyboardKeys["ArrowLeft"] = "ArrowLeft";
        KeyboardKeys["ArrowRight"] = "ArrowRight";
        KeyboardKeys["ArrowUp"] = "ArrowUp";
        KeyboardKeys["ArrowDown"] = "ArrowDown";
        KeyboardKeys["PageUp"] = "PageUp";
        KeyboardKeys["PageDown"] = "PageDown";
        KeyboardKeys["Home"] = "Home";
        KeyboardKeys["End"] = "End";
        KeyboardKeys["Enter"] = "Enter";
        KeyboardKeys["Tab"] = "Tab";
        KeyboardKeys["Space"] = " ";
        KeyboardKeys["Backspace"] = "Backspace";
    })($1c1f8a5ed290c232$export$70f9e5bc10d7eac || ($1c1f8a5ed290c232$export$70f9e5bc10d7eac = {}));
    var $1c1f8a5ed290c232$export$1c4f2adc1f8e19d3;
    (function(KeyboardNavigationDirection) {
        KeyboardNavigationDirection["Down"] = "Down";
        KeyboardNavigationDirection["Up"] = "Up";
        KeyboardNavigationDirection["Left"] = "Left";
        KeyboardNavigationDirection["Right"] = "Right";
    })($1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 || ($1c1f8a5ed290c232$export$1c4f2adc1f8e19d3 = {}));
    const $1c1f8a5ed290c232$export$99130b698ea188ae = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End"
    ];
    const $1c1f8a5ed290c232$export$84b035f8d01101cc = [
        "Enter",
        "Backspace",
        " "
    ];
    const $1c1f8a5ed290c232$export$e27d4e477c0cd4ec = [
        "Enter",
        "Tab",
        " "
    ];
    const $1c1f8a5ed290c232$export$97027974dc06eeee = [
        "ArrowRight",
        "ArrowLeft",
        "Home",
        "End",
        "ArrowUp",
        "ArrowDown",
        "PageUp",
        "PageDown"
    ];
    const $1c1f8a5ed290c232$export$4f0ee90b28d6efc5 = 0;
    const $1c1f8a5ed290c232$export$9f7de4293d27f3aa = 50;
    const $1c1f8a5ed290c232$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
    const $1c1f8a5ed290c232$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
    const $1c1f8a5ed290c232$export$2829f3ec323f8ec0 = 8;
    const $1c1f8a5ed290c232$export$ce3a0e7d2d7d6ba2 = 5;
    const $1c1f8a5ed290c232$export$858e8dc100a97278 = 150;
    const $1c1f8a5ed290c232$export$83aab2ae64548423 = 20;
    const $1c1f8a5ed290c232$export$66cabad5e268b05e = 100;
});
parcelRegister("b8sgr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b76154abb8f2c59$export$2e2bcd8739ae039);
    let $1b76154abb8f2c59$var$debugEnabled = false;
    let $1b76154abb8f2c59$var$stacktracesEnabled = false;
    function $1b76154abb8f2c59$export$748ada60eaf985cc(enable) {
        $1b76154abb8f2c59$var$debugEnabled = enable;
    }
    function $1b76154abb8f2c59$export$4f7017086af31c25(enable) {
        $1b76154abb8f2c59$var$stacktracesEnabled = enable;
    }
    function $1b76154abb8f2c59$export$2a858f450a2f66d() {
        if ($1b76154abb8f2c59$var$stacktracesEnabled) console.log(new Error().stack);
    }
    function $1b76154abb8f2c59$export$2e2bcd8739ae039(msg, ...args) {
        if ($1b76154abb8f2c59$var$debugEnabled) console.log(msg, ...args);
    }
});
parcelRegister("5B9Cy", function(module, exports) {
    $parcel$export(module.exports, "isSpriteServiceRepresentation", ()=>$fb1b6c003b1856ef$export$1c52f72b88b558e8);
    $parcel$export(module.exports, "isSpriteRepresentation", ()=>$fb1b6c003b1856ef$export$a194199d673d75de);
    $parcel$export(module.exports, "isImageRepresentation", ()=>$fb1b6c003b1856ef$export$90b099a26fbd8b41);
    $parcel$export(module.exports, "isMediaRepresentation", ()=>$fb1b6c003b1856ef$export$979133dc1df141c6);
    $parcel$export(module.exports, "isPromise", ()=>$fb1b6c003b1856ef$export$4369c812aac99591);
    $parcel$export(module.exports, "isEmojiDescription", ()=>$fb1b6c003b1856ef$export$378ed2c87d03531c);
    $parcel$export(module.exports, "isMediaEmoji", ()=>$fb1b6c003b1856ef$export$a7e82c67204c73a1);
    $parcel$export(module.exports, "isLoadedMediaEmoji", ()=>$fb1b6c003b1856ef$export$d25a80b2c86d7fdf);
    $parcel$export(module.exports, "isEmojiDescriptionWithVariations", ()=>$fb1b6c003b1856ef$export$b0ed6d8df471f3cc);
    $parcel$export(module.exports, "isEmojiVariationDescription", ()=>$fb1b6c003b1856ef$export$82a0350e1f6b5c0a);
    $parcel$export(module.exports, "isMessagesKey", ()=>$fb1b6c003b1856ef$export$dddfba07c16c94d2);
    $parcel$export(module.exports, "toEmojiId", ()=>$fb1b6c003b1856ef$export$8d7d3de6b5b305d1);
    $parcel$export(module.exports, "containsEmojiId", ()=>$fb1b6c003b1856ef$export$39ed0ad389e58ef7);
    $parcel$export(module.exports, "convertImageToMediaRepresentation", ()=>$fb1b6c003b1856ef$export$20a1bd1d33069ce7);
    $parcel$export(module.exports, "convertMediaToImageEmoji", ()=>$fb1b6c003b1856ef$export$f1a89a11f425faaa);
    $parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", ()=>$fb1b6c003b1856ef$export$a48c58c688a3131);
    $parcel$export(module.exports, "getCategoryId", ()=>$fb1b6c003b1856ef$export$4bcbf61cb6832a8e);
    var $aSE1r;
    var $kin1Z;
    const $fb1b6c003b1856ef$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
    const $fb1b6c003b1856ef$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
    const $fb1b6c003b1856ef$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
    const $fb1b6c003b1856ef$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
    const $fb1b6c003b1856ef$export$4369c812aac99591 = (p)=>!!(p && p.then);
    const $fb1b6c003b1856ef$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
    const $fb1b6c003b1856ef$export$a7e82c67204c73a1 = (emoji)=>$fb1b6c003b1856ef$export$979133dc1df141c6(emoji.representation);
    const $fb1b6c003b1856ef$export$7720a4954d6f75f8 = (rep)=>$fb1b6c003b1856ef$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, (0, parcelRequire("kin1Z")).dataURLPrefix)) === 0;
    const $fb1b6c003b1856ef$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, (0, parcelRequire("kin1Z")).customCategory) && $fb1b6c003b1856ef$export$7720a4954d6f75f8(emoji.representation);
    const $fb1b6c003b1856ef$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
    const $fb1b6c003b1856ef$export$82a0350e1f6b5c0a = (object)=>{
        return 'baseId' in object;
    };
    const $fb1b6c003b1856ef$export$dddfba07c16c94d2 = (key)=>key in (0, (0, parcelRequire("aSE1r")).messages);
    const $fb1b6c003b1856ef$export$8d7d3de6b5b305d1 = (emoji)=>({
            shortName: emoji.shortName,
            id: emoji.id,
            fallback: emoji.fallback
        });
    const $fb1b6c003b1856ef$export$2dbfa5a5d35af350 = (emoji)=>{
        if (!emoji) return undefined;
        return $fb1b6c003b1856ef$export$8d7d3de6b5b305d1(emoji);
    };
    const $fb1b6c003b1856ef$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
    const $fb1b6c003b1856ef$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
        if (!emojiId) return false;
        for(let i = 0; i < emojis.length; i++){
            if ($fb1b6c003b1856ef$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
        }
        return false;
    };
    const $fb1b6c003b1856ef$export$20a1bd1d33069ce7 = (rep)=>({
            mediaPath: rep.imagePath,
            height: rep.height,
            width: rep.width
        });
    const $fb1b6c003b1856ef$export$3197405d49d2e298 = (rep, newImagePath)=>({
            imagePath: newImagePath || rep.mediaPath,
            height: rep.height,
            width: rep.width
        });
    const $fb1b6c003b1856ef$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
        const mediaRepresentation = emoji.representation;
        const mediaAltRepresentation = emoji.altRepresentation;
        const imgPath = !useAlt ? newImagePath : undefined;
        const altImgPath = useAlt ? newImagePath : undefined;
        if (!$fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) && !$fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
        const representation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
        const altRepresentation = $fb1b6c003b1856ef$export$979133dc1df141c6(mediaAltRepresentation) ? $fb1b6c003b1856ef$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
        const baseEmoji = {
            ...emoji,
            representation: representation
        };
        return $fb1b6c003b1856ef$export$a48c58c688a3131(baseEmoji, altRepresentation);
    };
    const $fb1b6c003b1856ef$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
        if (!altRepresentation) return emoji;
        return {
            ...emoji,
            altRepresentation: altRepresentation
        };
    };
    const $fb1b6c003b1856ef$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;
});
parcelRegister("aSE1r", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$11d87ef7c2048740$export$defe85febe8b728c);
    var $7VHMR;
    const $11d87ef7c2048740$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deleteEmojiTooltip: {
            id: 'fabric.emoji.delete.tooltip',
            defaultMessage: 'Delete',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTooltipForScreenreader: {
            id: 'fabric.emoji.delete.screenreader.tooltip',
            defaultMessage: 'To delete {shortName} emoji, press Backspace',
            description: 'Tooltip content for delete emoji when focus on deletable emoji'
        },
        deleteEmojiTitle: {
            id: 'fabric.emoji.delete.title',
            defaultMessage: 'Remove emoji',
            description: 'Title for emoji removal dialog'
        },
        deleteEmojiDescription: {
            id: 'fabric.emoji.delete.description',
            defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
            description: 'Description for emoji removal dialog'
        },
        deleteEmojiLabel: {
            id: 'fabric.emoji.delete.label',
            defaultMessage: 'Remove',
            description: 'Button label to remove emoji'
        },
        addCustomEmojiLabel: {
            id: 'fabric.emoji.add.custom.emoji.label',
            defaultMessage: 'Add your own emoji',
            description: 'Button label to add custom emoji'
        },
        emojiPlaceholder: {
            id: 'fabric.emoji.placeholder',
            defaultMessage: 'e.g. hello',
            description: 'Placeholder for emoji that provides an example for emoji name'
        },
        emojiNameAriaLabel: {
            id: 'fabric.emoji.name.ariaLabel',
            defaultMessage: 'Enter a name for the new emoji',
            description: 'Explains to enter a name for a new emoji'
        },
        emojiChooseFileTitle: {
            id: 'fabric.emoji.choose.file.title',
            defaultMessage: 'Choose file',
            description: 'Choose custom emoji file'
        },
        emojiChooseFileScreenReaderDescription: {
            id: 'fabric.emoji.choose.file.screenReaderDescription',
            defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
            description: 'Message indicating the purpose of choosing the file and requirements for the file'
        },
        emojiSelectSkinToneButtonAriaLabelText: {
            id: 'fabric.emoji.select.skin.tone.ariaLabel',
            defaultMessage: 'Choose your skin tone, {selectedTone} selected',
            description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
        },
        emojiSelectSkinToneListAriaLabelText: {
            id: 'fabric.emoji.select.skin.list.ariaLabel',
            defaultMessage: 'Skin tone selector',
            description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
        },
        emojiImageRequirements: {
            id: 'fabric.emoji.image.requirements',
            defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
            description: 'Message for emoji image requirements and maximum file size'
        },
        emojiPreviewTitle: {
            id: 'fabric.emoji.preview.title',
            defaultMessage: 'Preview',
            description: 'Emoji preview title'
        },
        emojiPreview: {
            id: 'fabric.emoji.preview',
            defaultMessage: 'Your new emoji {emoji} looks great',
            description: 'Emoji preview'
        },
        addEmojiLabel: {
            id: 'fabric.emoji.add.label',
            defaultMessage: 'Add emoji',
            description: 'verb - Button label to add emoji'
        },
        retryLabel: {
            id: 'fabric.emoji.retry.label',
            defaultMessage: 'Retry',
            description: 'verb - Button label to retry upload'
        },
        cancelLabel: {
            id: 'fabric.emoji.cancel.label',
            defaultMessage: 'Cancel',
            description: 'verb - button label to cancel operation'
        },
        searchPlaceholder: {
            id: 'fabric.emoji.search.placeholder',
            defaultMessage: 'Search',
            description: 'Placeholder for search emoji field'
        },
        searchLabel: {
            id: 'fabric.emoji.search.label',
            defaultMessage: 'Emoji name',
            description: 'verb - button label to search'
        },
        searchResultsStatusSeeAll: {
            id: 'fabric.emoji.search.status',
            defaultMessage: 'Seeing all emojis',
            description: 'search results status when no search query for screenreader to read out'
        },
        categoriesSelectorLabel: {
            id: 'fabric.emoji.categories.label',
            defaultMessage: 'Choose an emoji category',
            description: 'Aria label for Emoji categories selector at the top of emoji picker'
        },
        categoriesSearchResults: {
            id: 'fabric.emoji.categories.search.results',
            defaultMessage: 'Search results',
            description: 'Emoji categories search results'
        },
        frequentCategory: {
            id: 'fabric.emoji.category.frequent',
            defaultMessage: 'Frequent',
            description: 'Emoji frequent category'
        },
        peopleCategory: {
            id: 'fabric.emoji.category.people',
            defaultMessage: 'People',
            description: 'Emoji frequent category'
        },
        natureCategory: {
            id: 'fabric.emoji.category.nature',
            defaultMessage: 'Nature',
            description: 'Emoji nature category'
        },
        foodsCategory: {
            id: 'fabric.emoji.category.foods',
            defaultMessage: 'Food & Drink',
            description: 'Emoji Foods category'
        },
        activityCategory: {
            id: 'fabric.emoji.category.activity',
            defaultMessage: 'Activity',
            description: 'Emoji activity category'
        },
        placesCategory: {
            id: 'fabric.emoji.category.places',
            defaultMessage: 'Travel & Places',
            description: 'Emoji Places category'
        },
        objectsCategory: {
            id: 'fabric.emoji.category.objects',
            defaultMessage: 'Objects',
            description: 'Emoji objects category'
        },
        symbolsCategory: {
            id: 'fabric.emoji.category.symbols',
            defaultMessage: 'Symbols',
            description: 'Emoji symbols category'
        },
        flagsCategory: {
            id: 'fabric.emoji.category.flags',
            defaultMessage: 'Flags',
            description: 'Emoji flags category'
        },
        productivityCategory: {
            id: 'fabric.emoji.category.productivity',
            defaultMessage: 'Productivity',
            description: 'Emoji productivity category'
        },
        userUploadsCustomCategory: {
            id: 'fabric.emoji.category.user.uploads',
            defaultMessage: 'Your uploads',
            description: 'User uploads in the custom category'
        },
        allUploadsCustomCategory: {
            id: 'fabric.emoji.category.all.uploads',
            defaultMessage: 'All uploads',
            description: 'All uploads in the custom category'
        },
        deleteEmojiFailed: {
            id: 'fabric.emoji.error.delete.failed',
            defaultMessage: 'Remove failed',
            description: 'Error message when custom emoji failed to be removed'
        },
        emojiInvalidImage: {
            id: 'fabric.emoji.error.invalid.image',
            defaultMessage: 'Selected image is invalid',
            description: 'Error message for invalid selected image'
        },
        emojiUploadFailed: {
            id: 'fabric.emoji.error.upload.failed',
            defaultMessage: 'Upload failed',
            description: 'Failed to upload emoji image'
        },
        emojiImageTooBig: {
            id: 'fabric.emoji.error.image.too.big',
            defaultMessage: 'Selected image is more than 1 MB',
            description: 'Error message for image too big, beyond the size limit'
        },
        emojiPickerTitle: {
            id: 'fabric.emoji.picker',
            defaultMessage: 'Emoji picker',
            description: 'Aria label for emoji picker'
        },
        emojiPickerListPanel: {
            id: 'fabric.emoji.pickerlist.tabpanel',
            defaultMessage: 'Emojis actions and list panel',
            description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
        },
        emojiPickerGrid: {
            id: 'fabric.emoji.pickerlist.grid',
            defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
            description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
        },
        emojiButtonRoleDescription: {
            id: 'fabric.emoji.emojipicker.emoi.roledescription',
            defaultMessage: 'emoji button',
            description: `Aria roledescription for emoji button, used in emoji picker.`
        },
        error: {
            id: 'fabric.emoji.emojipicker.error',
            defaultMessage: 'Error!',
            description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
        }
    });
});
parcelRegister("d9blH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0506955bcee8f359$export$2e2bcd8739ae039);
    function $0506955bcee8f359$export$2e2bcd8739ae039(type) {
        if (typeof window === 'undefined') return false;
        var storage;
        try {
            storage = window[type];
            var x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage && storage.length !== 0;
        }
    }
});
parcelRegister("9AR2K", function(module, exports) {
    $parcel$export(module.exports, "SearchSort", ()=>$d0b081d2572cc7bf$export$a15e9a4340d08b2e);
    $parcel$export(module.exports, "SearchSourceTypes", ()=>$d0b081d2572cc7bf$export$db41220f541db607);
    $parcel$export(module.exports, "ProviderTypes", ()=>$d0b081d2572cc7bf$export$bf337c9223e5c8b);
    $parcel$export(module.exports, "UfoExperienceName", ()=>$d0b081d2572cc7bf$export$d0d1c9cd31a11a64);
    $parcel$export(module.exports, "UfoComponentName", ()=>$d0b081d2572cc7bf$export$122ce5c8fda96269);
    $parcel$export(module.exports, "UfoEmojiTimingsKeys", ()=>$d0b081d2572cc7bf$export$265ee18146a6885e);
    $parcel$export(module.exports, "UfoEmojiTimings", ()=>$d0b081d2572cc7bf$export$482549d945a3723);
    var $d0b081d2572cc7bf$export$a15e9a4340d08b2e;
    (function(SearchSort) {
        SearchSort[SearchSort["None"] = 0] = "None";
        SearchSort[SearchSort["Default"] = 1] = "Default";
        SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    })($d0b081d2572cc7bf$export$a15e9a4340d08b2e || ($d0b081d2572cc7bf$export$a15e9a4340d08b2e = {}));
    var $d0b081d2572cc7bf$export$db41220f541db607;
    (function(SearchSourceTypes) {
        SearchSourceTypes["PICKER"] = "picker";
        SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    })($d0b081d2572cc7bf$export$db41220f541db607 || ($d0b081d2572cc7bf$export$db41220f541db607 = {}));
    var $d0b081d2572cc7bf$export$bf337c9223e5c8b;
    (function(ProviderTypes) {
        ProviderTypes["SITE"] = "SITE";
        ProviderTypes["STANDARD"] = "STANDARD";
        ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
        ProviderTypes["UNKNOWN"] = "UNKNOWN";
        ProviderTypes["SINGLE"] = "SINGLE";
    })($d0b081d2572cc7bf$export$bf337c9223e5c8b || ($d0b081d2572cc7bf$export$bf337c9223e5c8b = {}));
    var $d0b081d2572cc7bf$export$d0d1c9cd31a11a64;
    (function(UfoExperienceName) {
        UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
        UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
        UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
        UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
        UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
        UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    })($d0b081d2572cc7bf$export$d0d1c9cd31a11a64 || ($d0b081d2572cc7bf$export$d0d1c9cd31a11a64 = {}));
    var $d0b081d2572cc7bf$export$122ce5c8fda96269;
    (function(UfoComponentName) {
        UfoComponentName["EMOJI"] = "emoji";
        UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
        UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    })($d0b081d2572cc7bf$export$122ce5c8fda96269 || ($d0b081d2572cc7bf$export$122ce5c8fda96269 = {}));
    var $d0b081d2572cc7bf$export$265ee18146a6885e;
    (function(UfoEmojiTimingsKeys) {
        UfoEmojiTimingsKeys["FMP"] = "fmp";
        UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
        UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
        UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
        UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    })($d0b081d2572cc7bf$export$265ee18146a6885e || ($d0b081d2572cc7bf$export$265ee18146a6885e = {}));
    var $d0b081d2572cc7bf$export$482549d945a3723;
    (function(UfoEmojiTimings) {
        UfoEmojiTimings["FMP_END"] = "fmp";
        UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
        UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
        UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
        UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
        UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
        UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
        UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    })($d0b081d2572cc7bf$export$482549d945a3723 || ($d0b081d2572cc7bf$export$482549d945a3723 = {}));
});
parcelRegister("f2M1N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8439b55200f22364$export$2e2bcd8739ae039);
    var $0Bueq;
    class $8439b55200f22364$export$2e2bcd8739ae039 {
        constructor(config){
            this.config = config;
        }
        loadEmoji() {
            const emojisPromise = (0, (0, parcelRequire("0Bueq")).emojiRequest)(this.config);
            return emojisPromise.then((emojiServiceResponse)=>(0, (0, parcelRequire("0Bueq")).denormaliseEmojiServiceResponse)(emojiServiceResponse));
        }
    }
});
parcelRegister("0Bueq", function(module, exports) {
    $parcel$export(module.exports, "emojiRequest", ()=>$9b95bf1aff58b644$export$ea1accde4cc117f4);
    $parcel$export(module.exports, "getAltRepresentation", ()=>$9b95bf1aff58b644$export$4a0301d636367e1d);
    $parcel$export(module.exports, "denormaliseEmojiServiceResponse", ()=>$9b95bf1aff58b644$export$afaea97e40b5ca70);
    $parcel$export(module.exports, "shouldUseAltRepresentation", ()=>$9b95bf1aff58b644$export$b7e9058f156d8d19);
    var $dS9cn = parcelRequire("dS9cn");
    var $5B9Cy;
    var $b8sgr;
    const $9b95bf1aff58b644$export$ea1accde4cc117f4 = (provider, options)=>{
        const { getRatio: getRatio = $9b95bf1aff58b644$export$d39ce20a37bba061, ...serviceConfig } = provider;
        const scaleQueryParams = $9b95bf1aff58b644$var$calculateScale(getRatio);
        const { queryParams: queryParams = {}, ...otherOptions } = options || {};
        const requestOptions = {
            ...otherOptions,
            queryParams: {
                ...scaleQueryParams,
                ...queryParams,
                preferredRepresentation: 'IMAGE'
            }
        };
        return (0, $dS9cn.utils).requestService(serviceConfig, requestOptions);
    };
    const $9b95bf1aff58b644$var$calculateScale = (getRatio)=>{
        if (getRatio() > 1) return {
            scale: 'XHDPI',
            altScale: 'XXXHDPI'
        };
        return {
            altScale: 'XHDPI'
        };
    };
    const $9b95bf1aff58b644$export$d39ce20a37bba061 = ()=>{
        if (typeof window === 'undefined') return 0;
        return window.devicePixelRatio;
    };
    const $9b95bf1aff58b644$export$4a0301d636367e1d = (reps)=>{
        return reps[$9b95bf1aff58b644$var$calculateScale($9b95bf1aff58b644$export$d39ce20a37bba061).altScale];
    };
    const $9b95bf1aff58b644$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
    const $9b95bf1aff58b644$export$55077db3efc820aa = (representation, meta)=>{
        if ((0, (0, parcelRequire("5B9Cy")).isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
            const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
            const spriteSheet = meta.spriteSheets[spriteRef];
            if (spriteSheet) return {
                sprite: spriteSheet,
                height: height,
                width: width,
                x: x,
                y: y,
                xIndex: xIndex,
                yIndex: yIndex
            };
        } else if ((0, (0, parcelRequire("5B9Cy")).isImageRepresentation)(representation)) {
            const { height: height, width: width, imagePath: imagePath } = representation;
            if ($9b95bf1aff58b644$export$db05e6ae1fd416af(imagePath, meta)) return (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(representation);
            return {
                height: height,
                width: width,
                imagePath: imagePath
            };
        }
        (0, (0, parcelRequire("b8sgr")).default)('failed conversion for representation', representation, meta);
        return undefined;
    };
    const $9b95bf1aff58b644$export$aa9faa01267cb2e7 = (altReps, meta)=>{
        return !altReps || Object.keys(altReps).length === 0 ? undefined : $9b95bf1aff58b644$export$55077db3efc820aa($9b95bf1aff58b644$export$4a0301d636367e1d(altReps), meta);
    };
    const $9b95bf1aff58b644$export$e3da49c88c2e54d5 = (emoji, meta)=>{
        if (!emoji.skinVariations) return [];
        const skinEmoji = emoji.skinVariations;
        const baseId = emoji.id;
        return skinEmoji.map((skin)=>{
            const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
            return {
                baseId: baseId,
                representation: $9b95bf1aff58b644$export$55077db3efc820aa(representation, meta),
                altRepresentation: $9b95bf1aff58b644$export$aa9faa01267cb2e7(altRepresentations, meta),
                ...other
            };
        });
    };
    const $9b95bf1aff58b644$export$afaea97e40b5ca70 = (emojiData)=>{
        const emojis = emojiData.emojis.map((emoji)=>{
            const newRepresentation = $9b95bf1aff58b644$export$55077db3efc820aa(emoji.representation, emojiData.meta);
            const altRepresentation = $9b95bf1aff58b644$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
            const newSkinVariations = $9b95bf1aff58b644$export$e3da49c88c2e54d5(emoji, emojiData.meta);
            const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
            const response = {
                ...trimmedServiceDesc,
                representation: newRepresentation,
                skinVariations: newSkinVariations
            };
            return (0, (0, parcelRequire("5B9Cy")).buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
        });
        const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
        return {
            emojis: emojis,
            mediaApiToken: mediaApiToken
        };
    };
    const $9b95bf1aff58b644$var$getHeight = (fitToHeight)=>$9b95bf1aff58b644$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
    const $9b95bf1aff58b644$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $9b95bf1aff58b644$var$getHeight(fitToHeight) > emoji.representation.height);
});
parcelRegister("WeQTx", function(module, exports) {
    $parcel$export(module.exports, "getEmojiVariation", ()=>$1d50887d5f60ae61$export$e55e46e1520c899d);
    $parcel$export(module.exports, "default", ()=>$1d50887d5f60ae61$export$2e2bcd8739ae039);
    var $lH7AH = parcelRequire("lH7AH");
    var $kin1Z;
    var $5B9Cy;
    var $9AR2K;
    var $9aDRG;
    var $fjHZk;
    var $8Ov1g;
    var $VSDnB;
    class $1d50887d5f60ae61$var$Tokenizer {
        tokenize(text) {
            return this.tokenizeAsTokens(text).map((token)=>token.token);
        }
        tokenizeAsTokens(text) {
            let match;
            let tokens = [];
            (0, (0, parcelRequire("9aDRG")).tokenizerRegex).lastIndex = 0;
            while((match = (0, (0, parcelRequire("9aDRG")).tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
                token: match[0],
                start: match.index
            });
            return tokens;
        }
    }
    const $1d50887d5f60ae61$var$addAllVariants = (emoji, fnKey, map)=>{
        const key = fnKey(emoji);
        if (!map.has(key)) map.set(key, []);
        const emojisForKey = map.get(key);
        if (emojisForKey) emojisForKey.push(emoji);
        if ((0, (0, parcelRequire("5B9Cy")).isEmojiDescriptionWithVariations)(emoji)) {
            const variations = emoji.skinVariations;
            if (variations) variations.forEach((variation)=>$1d50887d5f60ae61$var$addAllVariants(variation, fnKey, map));
        }
    };
    const $1d50887d5f60ae61$var$findByKey = (map, key)=>{
        const emojis = map.get(key);
        if (emojis && emojis.length) return emojis[emojis.length - 1];
        return undefined;
    };
    const $1d50887d5f60ae61$var$splitQuery = (query = '')=>{
        const isColonQuery = query.indexOf(':') === 0;
        if (isColonQuery) return {
            nameQuery: query.slice(1),
            asciiQuery: query
        };
        return {
            nameQuery: query,
            asciiQuery: ''
        };
    };
    const $1d50887d5f60ae61$export$e55e46e1520c899d = (emoji, options)=>{
        if ((0, (0, parcelRequire("5B9Cy")).isEmojiDescriptionWithVariations)(emoji) && options) {
            const skinTone = options.skinTone;
            if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
                const skinToneEmoji = emoji.skinVariations[skinTone - 1];
                if (skinToneEmoji) return skinToneEmoji;
            }
        }
        return emoji;
    };
    const $1d50887d5f60ae61$var$findEmojiIndex = (emojis, toFind)=>{
        const findId = toFind.id;
        let match = -1;
        emojis.forEach((emoji, index)=>{
            if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
                match = index;
                return;
            }
        });
        return match;
    };
    class $1d50887d5f60ae61$export$2e2bcd8739ae039 {
        static{
            this.defaultEmojiWeight = 1000000;
        }
        constructor(emojis, usageTracker){
            this.fullSearchReady = false;
            this.emojis = emojis;
            this.initMembers(usageTracker);
        }
        all() {
            const options = {
                sort: (0, (0, parcelRequire("9AR2K")).SearchSort).None
            };
            return this.search('', options);
        }
        search(query, options) {
            let filteredEmoji = [];
            const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $1d50887d5f60ae61$var$splitQuery(query);
            if (nameQuery) {
                filteredEmoji = this.getSearchIndex().search(nameQuery);
                if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
            } else filteredEmoji = this.getAllSearchableEmojis();
            filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
            return {
                emojis: filteredEmoji,
                query: query
            };
        }
        findAllMatchingShortName(shortName) {
            return this.shortNameMap.get(shortName) || [];
        }
        findByShortName(shortName) {
            return $1d50887d5f60ae61$var$findByKey(this.shortNameMap, shortName);
        }
        findById(id) {
            return $1d50887d5f60ae61$var$findByKey(this.idMap, id);
        }
        findByAsciiRepresentation(asciiEmoji) {
            return this.asciiMap.get(asciiEmoji);
        }
        findInCategory(categoryId) {
            if (categoryId === (0, (0, parcelRequire("kin1Z")).frequentCategory)) return this.getFrequentlyUsed();
            else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
        }
        addUnknownEmoji(emoji) {
            this.emojis = [
                ...this.emojis,
                emoji
            ];
            this.getSearchIndex().addDocuments([
                emoji
            ]);
            this.addToMaps(emoji);
            this.addToDynamicCategories(emoji);
        }
        getAsciiMap() {
            return this.asciiMap;
        }
        getFrequentlyUsed(options) {
            const emojiIds = this.usageTracker.getOrder();
            let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
            if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
            return emojiResult;
        }
        getDynamicCategoryList() {
            return this.dynamicCategoryList.slice();
        }
        used(emoji) {
            this.usageTracker.recordUsage(emoji);
            if (this.dynamicCategoryList.indexOf((0, (0, parcelRequire("kin1Z")).frequentCategory)) === -1) {
                if (typeof window === 'undefined') return;
                window.setTimeout(()=>{
                    this.dynamicCategoryList.push((0, (0, parcelRequire("kin1Z")).frequentCategory));
                });
            }
        }
        delete(emoji) {
            const deletedIndex = $1d50887d5f60ae61$var$findEmojiIndex(this.emojis, emoji);
            if (deletedIndex !== -1) {
                this.emojis.splice(deletedIndex, 1);
                this.initMembers(this.usageTracker);
            }
        }
        withAsciiMatch(ascii, emojis) {
            let result = emojis;
            const asciiEmoji = this.findByAsciiRepresentation(ascii);
            if (asciiEmoji) {
                result = emojis.filter((e)=>e.id !== asciiEmoji.id);
                result = [
                    asciiEmoji,
                    ...result
                ];
            }
            return result;
        }
        applySearchOptions(emojis, query, options) {
            if (!options) options = {};
            if (options.sort === undefined) options.sort = (0, (0, parcelRequire("9AR2K")).SearchSort).Default;
            let comparator;
            if (options.sort === (0, (0, parcelRequire("9AR2K")).SearchSort).Default) comparator = (0, (0, parcelRequire("fjHZk")).createSearchEmojiComparator)(query, this.usageTracker.getOrder());
            else if (options.sort === (0, (0, parcelRequire("9AR2K")).SearchSort).UsageFrequency) comparator = (0, (0, parcelRequire("fjHZk")).createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
            if (comparator) {
                comparator.compare = comparator.compare.bind(comparator);
                emojis = emojis.sort(comparator.compare);
            }
            if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
            if (options.skinTone) return emojis.map((emoji)=>{
                return $1d50887d5f60ae61$export$e55e46e1520c899d(emoji, options);
            });
            return emojis;
        }
        initMembers(usageTracker) {
            this.usageTracker = usageTracker || new (0, (0, parcelRequire("8Ov1g")).UsageFrequencyTracker)();
            this.initRepositoryMetadata();
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
        }
        initRepositoryMetadata() {
            this.shortNameMap = new Map();
            this.idMap = new Map();
            this.asciiMap = new Map();
            const categorySet = new Set();
            this.emojis.forEach((emoji)=>{
                categorySet.add(emoji.category);
                this.addToMaps(emoji);
            });
            if (this.usageTracker.getOrder().length) categorySet.add((0, (0, parcelRequire("kin1Z")).frequentCategory));
            this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, (0, parcelRequire("kin1Z")).defaultCategories).indexOf(category) === -1);
        }
        initSearchIndex() {
            this.fullSearch = new (0, $lH7AH.Search)('id');
            this.fullSearch.tokenizer = new $1d50887d5f60ae61$var$Tokenizer();
            this.fullSearch.searchIndex = new (0, $lH7AH.UnorderedSearchIndex)();
            this.fullSearch.addIndex('name');
            this.fullSearch.addIndex('shortName');
            this.fullSearch.addDocuments(this.getAllSearchableEmojis());
            this.fullSearchReady = true;
        }
        getSearchIndex() {
            if (!this.fullSearchReady) this.initSearchIndex();
            return this.fullSearch;
        }
        getAllSearchableEmojis() {
            return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
        }
        addToMaps(emoji) {
            if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight;
            if (typeof emoji.id === 'undefined') emoji.id = $1d50887d5f60ae61$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
            $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
            $1d50887d5f60ae61$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
            if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
        }
        addToDynamicCategories(emoji) {
            const category = (0, (0, parcelRequire("5B9Cy")).getCategoryId)(emoji);
            if ((0, (0, parcelRequire("kin1Z")).defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
        }
    }
});
parcelRegister("lH7AH", function(module, exports) {
    $parcel$export(module.exports, "UnorderedSearchIndex", ()=>$fcb38080bd8576e6$export$5e70dbef3f0d47db);
    $parcel$export(module.exports, "Search", ()=>$fcb38080bd8576e6$export$4b85d3515bd863a5);
    var $fcb38080bd8576e6$export$58ac23006833dfe0 = function() {
        function AllSubstringsIndexStrategy() {}
        var _proto = AllSubstringsIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string;
            for(var i = 0, length = token.length; i < length; ++i){
                string = '';
                for(var j = i; j < length; ++j){
                    string += token.charAt(j);
                    expandedTokens.push(string);
                }
            }
            return expandedTokens;
        };
        return AllSubstringsIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$1dcc2d6a64836c8f = function() {
        function ExactWordIndexStrategy() {}
        var _proto = ExactWordIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            return token ? [
                token
            ] : [];
        };
        return ExactWordIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$eb7fc80cfe9abfe6 = function() {
        function PrefixIndexStrategy() {}
        var _proto = PrefixIndexStrategy.prototype;
        _proto.expandToken = function expandToken(token) {
            var expandedTokens = [];
            var string = '';
            for(var i = 0, length = token.length; i < length; ++i){
                string += token.charAt(i);
                expandedTokens.push(string);
            }
            return expandedTokens;
        };
        return PrefixIndexStrategy;
    }();
    var $fcb38080bd8576e6$export$b88ffe9b5486f99a = function() {
        function CaseSensitiveSanitizer() {}
        var _proto = CaseSensitiveSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.trim() : '';
        };
        return CaseSensitiveSanitizer;
    }();
    var $fcb38080bd8576e6$export$147e8ac43c84713a = function() {
        function LowerCaseSanitizer() {}
        var _proto = LowerCaseSanitizer.prototype;
        _proto.sanitize = function sanitize(text) {
            return text ? text.toLocaleLowerCase().trim() : '';
        };
        return LowerCaseSanitizer;
    }();
    function $fcb38080bd8576e6$var$getNestedFieldValue(object, path) {
        path = path || [];
        object = object || {};
        var value = object;
        for(var i = 0; i < path.length; i++){
            value = value[path[i]];
            if (value == null) return null;
        }
        return value;
    }
    var $fcb38080bd8576e6$export$a1138c79781169cc = function() {
        function TfIdfSearchIndex(uidFieldName) {
            this._uidFieldName = uidFieldName;
            this._tokenToIdfCache = {};
            this._tokenMap = {};
        }
        var _proto = TfIdfSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            this._tokenToIdfCache = {};
            var tokenMap = this._tokenMap;
            var tokenDatum;
            if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
                $numDocumentOccurrences: 0,
                $totalNumOccurrences: 1,
                $uidMap: {}
            };
            else {
                tokenDatum = tokenMap[token];
                tokenDatum.$totalNumOccurrences++;
            }
            var uidMap = tokenDatum.$uidMap;
            if (typeof uidMap[uid] !== 'object') {
                tokenDatum.$numDocumentOccurrences++;
                uidMap[uid] = {
                    $document: doc,
                    $numTokenOccurrences: 1
                };
            } else uidMap[uid].$numTokenOccurrences++;
        };
        _proto.search = function search(tokens, corpus) {
            var uidToDocumentMap = {};
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var tokenMetadata = this._tokenMap[token];
                if (!tokenMetadata) return [];
                if (i === 0) {
                    var keys = Object.keys(tokenMetadata.$uidMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                    }
                } else {
                    var keys = Object.keys(uidToDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                    }
                }
            }
            var documents = [];
            for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
            var calculateTfIdf = this._createCalculateTfIdf();
            return documents.sort(function(documentA, documentB) {
                return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
            });
        };
        _proto._createCalculateIdf = function _createCalculateIdf() {
            var tokenMap = this._tokenMap;
            var tokenToIdfCache = this._tokenToIdfCache;
            return function calculateIdf(token, documents) {
                if (!tokenToIdfCache[token]) {
                    var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                    tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
                }
                return tokenToIdfCache[token];
            };
        };
        _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
            var tokenMap = this._tokenMap;
            var uidFieldName = this._uidFieldName;
            var calculateIdf = this._createCalculateIdf();
            return function calculateTfIdf(tokens, document, documents) {
                var score = 0;
                for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                    var token = tokens[i];
                    var inverseDocumentFrequency = calculateIdf(token, documents);
                    if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                    var uid;
                    if (uidFieldName instanceof Array) uid = document && $fcb38080bd8576e6$var$getNestedFieldValue(document, uidFieldName);
                    else uid = document && document[uidFieldName];
                    var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                    score += termFrequency * inverseDocumentFrequency;
                }
                return score;
            };
        };
        return TfIdfSearchIndex;
    }();
    var $fcb38080bd8576e6$export$5e70dbef3f0d47db = function() {
        function UnorderedSearchIndex() {
            this._tokenToUidToDocumentMap = {};
        }
        var _proto = UnorderedSearchIndex.prototype;
        _proto.indexDocument = function indexDocument(token, uid, doc) {
            if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
            this._tokenToUidToDocumentMap[token][uid] = doc;
        };
        _proto.search = function search(tokens, corpus) {
            var intersectingDocumentMap = {};
            var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = tokens[i];
                var documentMap = tokenToUidToDocumentMap[token];
                if (!documentMap) return [];
                if (i === 0) {
                    var keys = Object.keys(documentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        intersectingDocumentMap[uid] = documentMap[uid];
                    }
                } else {
                    var keys = Object.keys(intersectingDocumentMap);
                    for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                        var uid = keys[j];
                        if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                    }
                }
            }
            var keys = Object.keys(intersectingDocumentMap);
            var documents = [];
            for(var i = 0, numKeys = keys.length; i < numKeys; i++){
                var uid = keys[i];
                documents.push(intersectingDocumentMap[uid]);
            }
            return documents;
        };
        return UnorderedSearchIndex;
    }();
    var $fcb38080bd8576e6$var$REGEX = /[^a-zа-яё0-9\-']+/i;
    var $fcb38080bd8576e6$export$f5ac5ec3cb556ad6 = function() {
        function SimpleTokenizer() {}
        var _proto = SimpleTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return text.split($fcb38080bd8576e6$var$REGEX).filter(function(text) {
                return text;
            });
        };
        return SimpleTokenizer;
    }();
    var $fcb38080bd8576e6$export$d2c689c98d4dcb27 = function() {
        function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
            this._stemmingFunction = stemmingFunction;
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StemmingTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).map(this._stemmingFunction);
        };
        return StemmingTokenizer;
    }();
    var $fcb38080bd8576e6$export$eeaf491a400e882a = {
        a: true,
        able: true,
        about: true,
        across: true,
        after: true,
        all: true,
        almost: true,
        also: true,
        am: true,
        among: true,
        an: true,
        and: true,
        any: true,
        are: true,
        as: true,
        at: true,
        be: true,
        because: true,
        been: true,
        but: true,
        by: true,
        can: true,
        cannot: true,
        could: true,
        dear: true,
        did: true,
        'do': true,
        does: true,
        either: true,
        'else': true,
        ever: true,
        every: true,
        'for': true,
        from: true,
        'get': true,
        got: true,
        had: true,
        has: true,
        have: true,
        he: true,
        her: true,
        hers: true,
        him: true,
        his: true,
        how: true,
        however: true,
        i: true,
        'if': true,
        'in': true,
        into: true,
        is: true,
        it: true,
        its: true,
        just: true,
        least: true,
        "let": true,
        like: true,
        likely: true,
        may: true,
        me: true,
        might: true,
        most: true,
        must: true,
        my: true,
        neither: true,
        no: true,
        nor: true,
        not: true,
        of: true,
        off: true,
        often: true,
        on: true,
        only: true,
        or: true,
        other: true,
        our: true,
        own: true,
        rather: true,
        said: true,
        say: true,
        says: true,
        she: true,
        should: true,
        since: true,
        so: true,
        some: true,
        than: true,
        that: true,
        the: true,
        their: true,
        them: true,
        then: true,
        there: true,
        these: true,
        they: true,
        'this': true,
        tis: true,
        to: true,
        too: true,
        twas: true,
        us: true,
        wants: true,
        was: true,
        we: true,
        were: true,
        what: true,
        when: true,
        where: true,
        which: true,
        'while': true,
        who: true,
        whom: true,
        why: true,
        will: true,
        'with': true,
        would: true,
        yet: true,
        you: true,
        your: true
    };
    $fcb38080bd8576e6$export$eeaf491a400e882a.constructor = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.hasOwnProperty = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.isPrototypeOf = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.propertyIsEnumerable = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.toLocaleString = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.toString = false;
    $fcb38080bd8576e6$export$eeaf491a400e882a.valueOf = false;
    var $fcb38080bd8576e6$export$59d4dfff8ed0ca89 = function() {
        function StopWordsTokenizer(decoratedTokenizer) {
            this._tokenizer = decoratedTokenizer;
        }
        var _proto = StopWordsTokenizer.prototype;
        _proto.tokenize = function tokenize(text) {
            return this._tokenizer.tokenize(text).filter(function(token) {
                return !$fcb38080bd8576e6$export$eeaf491a400e882a[token];
            });
        };
        return StopWordsTokenizer;
    }();
    function $fcb38080bd8576e6$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $fcb38080bd8576e6$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $fcb38080bd8576e6$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $fcb38080bd8576e6$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $fcb38080bd8576e6$export$4b85d3515bd863a5 = function() {
        function Search(uidFieldName) {
            if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
            this._uidFieldName = uidFieldName;
            this._indexStrategy = new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
            this._searchIndex = new $fcb38080bd8576e6$export$a1138c79781169cc(uidFieldName);
            this._sanitizer = new $fcb38080bd8576e6$export$147e8ac43c84713a();
            this._tokenizer = new $fcb38080bd8576e6$export$f5ac5ec3cb556ad6();
            this._documents = [];
            this._searchableFields = [];
        }
        var _proto = Search.prototype;
        _proto.addDocument = function addDocument(document) {
            this.addDocuments([
                document
            ]);
        };
        _proto.addDocuments = function addDocuments(documents) {
            this._documents = this._documents.concat(documents);
            this.indexDocuments_(documents, this._searchableFields);
        };
        _proto.addIndex = function addIndex(field) {
            this._searchableFields.push(field);
            this.indexDocuments_(this._documents, [
                field
            ]);
        };
        _proto.search = function search(query) {
            var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
            return this._searchIndex.search(tokens, this._documents);
        };
        _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
            this._initialized = true;
            var indexStrategy = this._indexStrategy;
            var sanitizer = this._sanitizer;
            var searchIndex = this._searchIndex;
            var tokenizer = this._tokenizer;
            var uidFieldName = this._uidFieldName;
            for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
                var doc = documents[di];
                var uid;
                if (uidFieldName instanceof Array) uid = $fcb38080bd8576e6$var$getNestedFieldValue(doc, uidFieldName);
                else uid = doc[uidFieldName];
                for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                    var fieldValue;
                    var searchableField = _searchableFields[sfi];
                    if (searchableField instanceof Array) fieldValue = $fcb38080bd8576e6$var$getNestedFieldValue(doc, searchableField);
                    else fieldValue = doc[searchableField];
                    if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                    if (typeof fieldValue === 'string') {
                        var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                        for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                            var fieldToken = fieldTokens[fti];
                            var expandedTokens = indexStrategy.expandToken(fieldToken);
                            for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                                var expandedToken = expandedTokens[eti];
                                searchIndex.indexDocument(expandedToken, uid, doc);
                            }
                        }
                    }
                }
            }
        };
        $fcb38080bd8576e6$var$_createClass(Search, [
            {
                key: "indexStrategy",
                set: function set(value) {
                    if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                    this._indexStrategy = value;
                },
                get: function get() {
                    return this._indexStrategy;
                }
            },
            {
                key: "sanitizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                    this._sanitizer = value;
                },
                get: function get() {
                    return this._sanitizer;
                }
            },
            {
                key: "searchIndex",
                set: function set(value) {
                    if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                    this._searchIndex = value;
                },
                get: function get() {
                    return this._searchIndex;
                }
            },
            {
                key: "tokenizer",
                set: function set(value) {
                    if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                    this._tokenizer = value;
                },
                get: function get() {
                    return this._tokenizer;
                }
            }
        ]);
        return Search;
    }();
    var $fcb38080bd8576e6$export$11e693a7f8ce1bcc = function() {
        function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
            this._indexStrategy = opt_indexStrategy || new $fcb38080bd8576e6$export$eb7fc80cfe9abfe6();
            this._sanitizer = opt_sanitizer || new $fcb38080bd8576e6$export$147e8ac43c84713a();
            this._wrapperTagName = opt_wrapperTagName || 'mark';
        }
        var _proto = TokenHighlighter.prototype;
        _proto.highlight = function highlight(text, tokens) {
            var tagsLength = this._wrapText('').length;
            var tokenDictionary = Object.create(null);
            for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
                var token = this._sanitizer.sanitize(tokens[i]);
                var expandedTokens = this._indexStrategy.expandToken(token);
                for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                    var expandedToken = expandedTokens[j];
                    if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                        token
                    ];
                    else tokenDictionary[expandedToken].push(token);
                }
            }
            var actualCurrentWord = '';
            var sanitizedCurrentWord = '';
            var currentWordStartIndex = 0;
            for(var i = 0, textLength = text.length; i < textLength; i++){
                var character = text.charAt(i);
                if (character === ' ') {
                    actualCurrentWord = '';
                    sanitizedCurrentWord = '';
                    currentWordStartIndex = i + 1;
                } else {
                    actualCurrentWord += character;
                    sanitizedCurrentWord += this._sanitizer.sanitize(character);
                }
                if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                    actualCurrentWord = this._wrapText(actualCurrentWord);
                    text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                    i += tagsLength;
                    textLength += tagsLength;
                }
            }
            return text;
        };
        _proto._wrapText = function _wrapText(text) {
            var tagName = this._wrapperTagName;
            return "<" + tagName + ">" + text + "</" + tagName + ">";
        };
        return TokenHighlighter;
    }();
});
parcelRegister("9aDRG", function(module, exports) {
    $parcel$export(module.exports, "tokenizerRegex", ()=>$646a79216f1b7bf8$export$6558e5d0f0e834f8);
    const $646a79216f1b7bf8$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');
});
parcelRegister("fjHZk", function(module, exports) {
    $parcel$export(module.exports, "createSearchEmojiComparator", ()=>$60550181d33ca139$export$e6097b005751df7);
    $parcel$export(module.exports, "createUsageOnlyEmojiComparator", ()=>$60550181d33ca139$export$1bd055808eeccb4e);
    var $kin1Z;
    var $5B9Cy;
    function $60550181d33ca139$export$e6097b005751df7(query, orderedIds) {
        const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
        const comparators = [];
        if (query) comparators.push(new $60550181d33ca139$export$ff92575cd1bbad0e(query));
        if (textQuery) comparators.push(new $60550181d33ca139$export$3026b08b79541139(textQuery));
        if (orderedIds && orderedIds.length) comparators.push(new $60550181d33ca139$export$55e24837a4bf653(orderedIds));
        if (textQuery) comparators.push(new $60550181d33ca139$export$587c775915dc4869(textQuery, 'shortName'), new $60550181d33ca139$export$587c775915dc4869(textQuery, 'name'));
        comparators.push($60550181d33ca139$export$165e96ceead77edd.Instance, $60550181d33ca139$export$30ce221e1adf48c1.Instance);
        const comparator = new $60550181d33ca139$export$a8052d0852821684(...comparators);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    function $60550181d33ca139$export$1bd055808eeccb4e(orderedIds) {
        const comparator = new $60550181d33ca139$export$a8052d0852821684(new $60550181d33ca139$export$55e24837a4bf653(orderedIds), new $60550181d33ca139$export$a7f7a0b04013a8a8(), $60550181d33ca139$export$165e96ceead77edd.Instance);
        comparator.compare = comparator.compare.bind(comparator);
        return comparator;
    }
    class $60550181d33ca139$export$a8052d0852821684 {
        constructor(...comparators){
            this.chain = comparators;
        }
        compare(e1, e2) {
            for(let i = 0; i < this.chain.length; i++){
                const result = this.chain[i].compare(e1, e2);
                if (result !== 0) return result;
            }
            return 0;
        }
    }
    class $60550181d33ca139$export$ff92575cd1bbad0e {
        constructor(query){
            this.query = query;
        }
        compare(e1, e2) {
            const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
            const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
            if (e1HasAscii && !e2HasAscii) return -1;
            else if (!e1HasAscii && e2HasAscii) return 1;
            return 0;
        }
    }
    class $60550181d33ca139$export$3026b08b79541139 {
        constructor(query){
            this.colonQuery = `:${query}:`;
            this.typeComparator = new $60550181d33ca139$export$a7f7a0b04013a8a8(true);
        }
        compare(e1, e2) {
            if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
            else if (e1.shortName === this.colonQuery) return -1;
            else if (e2.shortName === this.colonQuery) return 1;
            return 0;
        }
    }
    class $60550181d33ca139$export$a7f7a0b04013a8a8 {
        constructor(reverse){
            if (reverse) this.typeToNumber = new Map([
                [
                    'SITE',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'STANDARD',
                    2
                ]
            ]);
            else this.typeToNumber = new Map([
                [
                    'STANDARD',
                    0
                ],
                [
                    'ATLASSIAN',
                    1
                ],
                [
                    'SITE',
                    2
                ]
            ]);
        }
        compare(e1, e2) {
            return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
        }
        emojiTypeToOrdinal(emoji) {
            let ordinal = this.typeToNumber.get(emoji.type);
            if (ordinal === undefined) ordinal = 10;
            return ordinal;
        }
    }
    class $60550181d33ca139$export$55e24837a4bf653 {
        constructor(orderedIds){
            this.positionLookup = new Map();
            orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
        }
        compare(e1, e2) {
            if (!e1.id || !e2.id) return 0;
            let i1 = this.getPositionInOrder(e1);
            let i2 = this.getPositionInOrder(e2);
            return i1 - i2;
        }
        getPositionInOrder(emoji) {
            let id = emoji.id ? emoji.id : '0';
            if ((0, (0, parcelRequire("5B9Cy")).isEmojiVariationDescription)(emoji)) id = emoji.baseId;
            const position = this.positionLookup.get(id);
            if (position) return position;
            else return 0, (0, parcelRequire("kin1Z")).MAX_ORDINAL;
        }
    }
    class $60550181d33ca139$export$587c775915dc4869 {
        constructor(query, propertyToCompare){
            this.query = query;
            if (!propertyToCompare) throw new Error('propertyToCompare is required');
            this.propertyName = propertyToCompare;
        }
        getScore(emoji) {
            const propertyValue = emoji[this.propertyName];
            const score = propertyValue ? propertyValue.indexOf(this.query) : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            return score === -1 ? (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL) : score;
        }
        compare(e1, e2) {
            return this.getScore(e1) - this.getScore(e2);
        }
    }
    class $60550181d33ca139$export$165e96ceead77edd {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            let o1 = e1.order ? e1.order : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            let o2 = e2.order ? e2.order : (0, (0, parcelRequire("kin1Z")).MAX_ORDINAL);
            return o1 - o2;
        }
    }
    class $60550181d33ca139$export$30ce221e1adf48c1 {
        constructor(){}
        static get Instance() {
            return this.INSTANCE || (this.INSTANCE = new this());
        }
        compare(e1, e2) {
            return e1.shortName.localeCompare(e2.shortName);
        }
    }
});
parcelRegister("8Ov1g", function(module, exports) {
    $parcel$export(module.exports, "UsageFrequencyTracker", ()=>$03e35e6585a0c1a4$export$3f86810331c44209);
    var $5B9Cy;
    var $kin1Z;
    var $2FvtQ;
    var $fWsKa;
    var $d9blH;
    class $03e35e6585a0c1a4$export$3f86810331c44209 {
        static{
            this.queueOptions = {
                storage: (0, (0, parcelRequire("d9blH")).default)('localStorage') ? window.localStorage : undefined,
                storagePrefix: (0, (0, parcelRequire("kin1Z")).localStoragePrefix),
                maxDuplicates: 25,
                minUniqueItems: 5
            };
        }
        constructor(useStorageIfPossible = true){
            const options = $03e35e6585a0c1a4$export$3f86810331c44209.queueOptions;
            if (useStorageIfPossible && options.storage) {
                const queueOptions = {
                    ...options,
                    storage: options.storage
                };
                this.queue = new (0, (0, parcelRequire("fWsKa")).default)(queueOptions);
            } else this.queue = new (0, (0, parcelRequire("2FvtQ")).default)(options);
            this.gateway = new $03e35e6585a0c1a4$export$a0e1fa6601cae894(10);
        }
        recordUsage(emoji) {
            let emojiId = emoji.id;
            if (emojiId) {
                if ((0, (0, parcelRequire("5B9Cy")).isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
                this.gateway.submit(()=>{
                    if (emojiId) this.queue.enqueue(emojiId);
                });
            }
        }
        getOrder() {
            return this.queue.getItemsOrderedByDuplicateCount();
        }
        clear() {
            this.queue.clear();
        }
    }
    class $03e35e6585a0c1a4$export$a0e1fa6601cae894 {
        constructor(maximumPermitted){
            if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
            this.maximumPermitted = maximumPermitted;
            this.count = 0;
        }
        submit(f) {
            if (this.count >= this.maximumPermitted) return false;
            this.count++;
            const wrappedFunc = ()=>{
                try {
                    f();
                } finally{
                    this.completed();
                }
            };
            if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
            return true;
        }
        completed() {
            this.count--;
        }
    }
});
parcelRegister("2FvtQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e862ce217e71f514$export$2e2bcd8739ae039);
    class $e862ce217e71f514$export$2e2bcd8739ae039 {
        constructor(options){
            if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
            if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
            this.maximumSize = options.maxDuplicates * options.minUniqueItems;
            this.perItemSize = options.maxDuplicates;
            this.createEmptyState();
        }
        enqueue(item) {
            this.enqueueWithoutOrdering(item);
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItemsOrderedByDuplicateCount() {
            return this.itemsOrderedByFrequency;
        }
        clear() {
            this.createEmptyState();
        }
        bulkEnqueue(items) {
            items.map((item)=>this.enqueueWithoutOrdering(item));
            this.itemsOrderedByFrequency = this.orderItemsByFrequency();
        }
        getItems() {
            return this.items;
        }
        createEmptyState() {
            this.items = new Array();
            this.itemCountMap = new Map();
            this.itemsOrderedByFrequency = new Array();
        }
        enqueueWithoutOrdering(item) {
            const count = this.itemCountMap.get(item);
            if (count && count >= this.perItemSize) this.removeFirstOccurrence(item);
            else if (this.items.length >= this.maximumSize) this.remove();
            this.add(item);
        }
        orderItemsByFrequency() {
            const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
                return b[1] - a[1];
            });
            return orderedEntries.map((value)=>value[0]);
        }
        decrementCount(item) {
            let count = this.itemCountMap.get(item);
            if (count) {
                count--;
                if (count > 0) this.itemCountMap.set(item, count);
                else this.itemCountMap.delete(item);
            }
        }
        removeFirstOccurrence(item) {
            const index = this.items.indexOf(item);
            if (index !== -1) {
                this.items.splice(index, 1);
                this.decrementCount(item);
            }
        }
        remove() {
            const removed = this.items.shift();
            if (removed !== undefined) this.decrementCount(removed);
            return removed;
        }
        add(item) {
            this.items.push(item);
            const count = this.itemCountMap.get(item);
            if (count) this.itemCountMap.set(item, count + 1);
            else this.itemCountMap.set(item, 1);
        }
    }
});
parcelRegister("fWsKa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e6962a764dc80122$export$2e2bcd8739ae039);
    var $2FvtQ;
    var $b8sgr;
    class $e6962a764dc80122$export$2e2bcd8739ae039 extends (0, (0, parcelRequire("2FvtQ")).default) {
        static{
            this.storageKey = 'lastUsed';
        }
        constructor(options){
            super(options);
            this.storage = options.storage;
            this.prefixedStorageKey = `${options.storagePrefix}.${$e6962a764dc80122$export$2e2bcd8739ae039.storageKey}`;
            this.load();
        }
        enqueue(item) {
            super.enqueue(item);
            this.save();
        }
        clear() {
            super.clear();
            this.storage.removeItem(this.prefixedStorageKey);
        }
        load() {
            const itemsJson = this.storage.getItem(this.prefixedStorageKey);
            if (itemsJson) try {
                const items = JSON.parse(itemsJson);
                this.bulkEnqueue(items);
            } catch (e) {
                (0, (0, parcelRequire("b8sgr")).default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
            }
        }
        save() {
            const itemsJson = JSON.stringify(this.getItems());
            try {
                this.storage.setItem(this.prefixedStorageKey, itemsJson);
            } catch (e) {
                (0, (0, parcelRequire("b8sgr")).default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
            }
        }
    }
});
parcelRegister("62WHo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f7f47d6423aa49d$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    var $cEHh7;
    var $5B9Cy;
    var $0l85J;
    var $0Bueq;
    var $ijzU9;
    var $b8sgr;
    const $9f7f47d6423aa49d$export$6f3a08dea02a7b2b = 0.95;
    class $9f7f47d6423aa49d$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig, mediaApiToken){
            this.postToEmojiService = (upload, fileId)=>{
                const { shortName: shortName, name: name } = upload;
                const { width: width, height: height } = upload;
                const requestInit = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        shortName: shortName,
                        name: name,
                        width: width,
                        height: height,
                        fileId: fileId
                    })
                };
                return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                    requestInit: requestInit
                }).then((response)=>{
                    const { emojis: emojis } = response;
                    if (emojis.length) {
                        const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                        const response = {
                            ...emoji,
                            representation: (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(emoji.representation)
                        };
                        const altRepresentation = (0, (0, parcelRequire("0Bueq")).getAltRepresentation)(altRepresentations || {});
                        const imgAltRepresentation = altRepresentation ? (0, (0, parcelRequire("5B9Cy")).convertImageToMediaRepresentation)(altRepresentation) : undefined;
                        return (0, (0, parcelRequire("5B9Cy")).buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                    }
                    throw new Error('No emoji returns from upload. Upload failed.');
                });
            };
            this.siteServiceConfig = siteServiceConfig;
            this.mediaApiToken = mediaApiToken;
            this.tokenManager = new (0, (0, parcelRequire("ijzU9")).default)(siteServiceConfig);
            this.tokenManager.addToken('read', mediaApiToken);
            this.mediaEmojiCache = new (0, (0, parcelRequire("0l85J")).default)(this.tokenManager);
        }
        async generateTokenisedMediaURLS(representation, altRepresentation) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return {
                representation: representation,
                altRepresentation: altRepresentation
            };
            try {
                const readToken = await this.tokenManager.getToken('read');
                return Object.entries({
                    representation: representation,
                    altRepresentation: altRepresentation
                }).reduce((acc, [key, value])=>{
                    if (value && (0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(value)) {
                        const path = new URL(value.mediaPath);
                        const params = path.searchParams;
                        if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                        if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                        acc[key] = {
                            ...value,
                            mediaPath: path.toString()
                        };
                    }
                    return acc;
                }, {
                    representation: representation,
                    altRepresentation: altRepresentation
                });
            } catch (error) {
                return {
                    representation: representation,
                    altRepresentation: altRepresentation
                };
            }
        }
        loadMediaEmoji(emoji, useAlt) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
            return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(emoji, useAlt) {
            const representation = useAlt ? emoji.altRepresentation : emoji.representation;
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
            const { mediaPath: mediaPath } = representation;
            return this.mediaEmojiCache.optimisticRendering(mediaPath);
        }
        uploadEmoji(upload, retry = false, progressCallback) {
            const startTime = Date.now();
            return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
                const tokenLoadTime = Date.now() - startTime;
                (0, (0, parcelRequire("b8sgr")).default)('upload token load time', tokenLoadTime);
                return new Promise((resolve, reject)=>{
                    const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                    const mediaClient = (0, (0, parcelRequire("cEHh7")).getMediaClient)({
                        authProvider: ()=>Promise.resolve({
                                clientId: clientId,
                                token: uploadToken.jwt,
                                baseUrl: url
                            }),
                        useSha256ForUploads: true
                    });
                    const subscription = mediaClient.file.upload({
                        content: upload.dataURL,
                        name: upload.filename,
                        collection: collectionName
                    }).subscribe({
                        next: (state)=>{
                            if (state.status === 'uploading' && progressCallback) progressCallback({
                                percent: state.progress * $9f7f47d6423aa49d$export$6f3a08dea02a7b2b
                            });
                            else if (state.status === 'processing') {
                                subscription.unsubscribe();
                                const totalUploadTime = Date.now() - startTime;
                                const mediaUploadTime = totalUploadTime - tokenLoadTime;
                                (0, (0, parcelRequire("b8sgr")).default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                                this.postToEmojiService(upload, state.id).then((emoji)=>{
                                    resolve(emoji);
                                }).catch((httpError)=>{
                                    reject(httpError.reason || httpError);
                                });
                            }
                        },
                        error (error) {
                            reject(error);
                        }
                    });
                });
            });
        }
        hasUploadToken() {
            const tokenPromise = this.tokenManager.getToken('upload');
            return tokenPromise.then((token)=>{
                return token !== undefined;
            }, ()=>{
                return false;
            });
        }
        prepareForUpload() {
            this.tokenManager.getToken('upload');
        }
        findEmoji(emojiId) {
            if (!emojiId.id) return Promise.reject(false);
            const path = `../${encodeURIComponent(emojiId.id)}`;
            return (0, (0, parcelRequire("0Bueq")).emojiRequest)(this.siteServiceConfig, {
                path: path
            }).then((serviceResponse)=>{
                const response = (0, (0, parcelRequire("0Bueq")).denormaliseEmojiServiceResponse)(serviceResponse);
                return response.emojis[0];
            }).catch((error)=>{
                (0, (0, parcelRequire("b8sgr")).default)('failed to load emoji', emojiId, error);
                return undefined;
            });
        }
        deleteEmoji(emoji) {
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaEmoji)(emoji) && !(0, (0, parcelRequire("5B9Cy")).isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
            if (!emoji.id) return Promise.reject(false);
            const path = `${encodeURIComponent(emoji.id)}`;
            const requestInit = {
                method: 'DELETE'
            };
            return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                path: path,
                requestInit: requestInit
            }).then(()=>true).catch(()=>false);
        }
    }
});
parcelRegister("0l85J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$468763407d64700f$export$2e2bcd8739ae039);
    var $5B9Cy;
    var $aEbo8;
    var $b8sgr;
    var $iwKVT = parcelRequire("iwKVT");
    const $468763407d64700f$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
    const $468763407d64700f$var$isUnsupportedBrowser = ()=>{
        const isIE = !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        return isIE || isEdge;
    };
    class $468763407d64700f$export$3850f566ce8d817a {
        constructor(mediaImageLoader){
            this.cachedImageUrls = new Set();
            (0, (0, parcelRequire("b8sgr")).default)('BrowserCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            if (this.cachedImageUrls.has(mediaPath)) return emoji;
            return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
                this.cachedImageUrls.add(mediaPath);
                return emoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return true;
        }
        static supported(mediaPath, mediaImageLoader) {
            if ($468763407d64700f$var$isUnsupportedBrowser()) return Promise.resolve(false);
            return mediaImageLoader.loadMediaImage(mediaPath).then(()=>new Promise((resolve)=>{
                    const img = new Image();
                    img.addEventListener('load', ()=>{
                        resolve(true);
                    });
                    img.addEventListener('error', ()=>{
                        resolve(false);
                    });
                    img.src = mediaPath;
                })).catch(()=>false);
        }
    }
    const $468763407d64700f$var$maxImageCached = 1000;
    const $468763407d64700f$var$maxImageSize = 10000;
    class $468763407d64700f$export$b522858a3709f4c {
        constructor(mediaImageLoader){
            (0, (0, parcelRequire("b8sgr")).default)('MemoryCacheStrategy');
            this.mediaImageLoader = mediaImageLoader;
            this.dataURLCache = new (0, $iwKVT.LRUMap)($468763407d64700f$var$maxImageCached);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const dataURL = this.dataURLCache.get(mediaPath);
            if (dataURL) return (0, (0, parcelRequire("5B9Cy")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
                const loadedEmoji = (0, (0, parcelRequire("5B9Cy")).convertMediaToImageEmoji)(emoji, dataURL, useAlt);
                if (dataURL.length <= $468763407d64700f$var$maxImageSize) this.dataURLCache.set(mediaPath, dataURL);
                else (0, (0, parcelRequire("b8sgr")).default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
                return loadedEmoji;
            }).catch(()=>{
                return undefined;
            });
        }
        optimisticRendering() {
            return false;
        }
    }
    class $468763407d64700f$export$2e2bcd8739ae039 {
        constructor(tokenManager){
            this.waitingInitUrls = [];
            (0, (0, parcelRequire("b8sgr")).default)('MediaEmojiCache');
            this.mediaImageLoader = new (0, (0, parcelRequire("aEbo8")).default)(tokenManager);
        }
        loadEmoji(emoji, useAlt) {
            const representation = $468763407d64700f$var$getRequiredRepresentation(emoji, useAlt);
            if (!(0, (0, parcelRequire("5B9Cy")).isMediaRepresentation)(representation)) return emoji;
            const { mediaPath: mediaPath } = representation;
            const emojiCache = this.getCache(mediaPath);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
            return emojiCache.loadEmoji(emoji, useAlt);
        }
        optimisticRendering(url) {
            const emojiCache = this.getCache(url);
            if ((0, (0, parcelRequire("5B9Cy")).isPromise)(emojiCache)) return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
            return emojiCache.optimisticRendering();
        }
        getCache(url) {
            if (this.cache) return this.cache;
            this.waitingInitUrls.push(url);
            if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
                this.cache = cache;
                this.cacheLoading = undefined;
                return cache;
            }).catch((err)=>{
                this.cacheLoading = undefined;
                throw err;
            });
            return this.cacheLoading;
        }
        initCache() {
            const url = this.waitingInitUrls.pop();
            if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
            return $468763407d64700f$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
                this.waitingInitUrls = [];
                this.cacheLoading = undefined;
                if (supported) return new $468763407d64700f$export$3850f566ce8d817a(this.mediaImageLoader);
                return new $468763407d64700f$export$b522858a3709f4c(this.mediaImageLoader);
            }).catch(()=>{
                return this.initCache();
            });
        }
    }
});
parcelRegister("aEbo8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12bf8241dae2d3e6$export$2e2bcd8739ae039);
    var $gQ3yg;
    const $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit = 16;
    const $12bf8241dae2d3e6$var$backoffMaxDelayInMillis = 600;
    const $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound = 2;
    class $12bf8241dae2d3e6$export$2e2bcd8739ae039 {
        constructor(tokenManager, options){
            this.mediaImageQueue = [];
            this.activeProcessing = 0;
            this.pendingRequests = new Map();
            this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $12bf8241dae2d3e6$var$defaultConcurrentDownloadLimit;
            this.tokenManager = tokenManager;
        }
        loadMediaImage(url) {
            const maybePending = this.pendingRequests.get(url);
            if (maybePending !== undefined) return maybePending;
            const pending = new Promise((resolve, reject)=>{
                this.mediaImageQueue.push({
                    url: url,
                    resolve: resolve,
                    reject: reject
                });
                this.processFromQueue();
            }).then((result)=>{
                this.pendingRequests.delete(url);
                return result;
            }).catch((error)=>{
                this.pendingRequests.delete(url);
                throw error;
            });
            this.pendingRequests.set(url, pending);
            return pending;
        }
        getQueueSize() {
            return this.mediaImageQueue.length;
        }
        getActiveDownloads() {
            return this.activeProcessing;
        }
        processFromQueue() {
            while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
                this.activeProcessing++;
                const item = this.mediaImageQueue.shift();
                const { url: url, resolve: resolve, reject: reject } = item;
                this.tokenManager.getToken('read', false).then((token)=>{
                    this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                        resolve(dataURL);
                        this.completedItem();
                    }).catch((error)=>{
                        reject(error);
                        this.completedItem();
                    });
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }
        }
        completedItem() {
            this.activeProcessing--;
            this.processFromQueue();
        }
        delay(durationInMillis) {
            return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
        }
        requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $12bf8241dae2d3e6$var$defaultMaxRetriesOnNotFound) {
            return (0, (0, parcelRequire("gQ3yg")).imageAcceptHeader)().then((acceptHeader)=>{
                const options = {
                    headers: {
                        Authorization: `Bearer ${token.jwt}`,
                        'X-Client-Id': token.clientId,
                        Accept: acceptHeader
                    }
                };
                return fetch(url, options).then((response)=>{
                    if (response.status === 404 && retriesOnNotFound > 0) return this.delay($12bf8241dae2d3e6$var$backoffMaxDelayInMillis / retriesOnNotFound).then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                    else if (response.status === 403 && retryOnAuthError) return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                    else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                    throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
                });
            });
        }
        readBlob(blob) {
            return new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.addEventListener('load', ()=>resolve(reader.result));
                reader.addEventListener('error', ()=>reject(reader.error));
                reader.readAsDataURL(blob);
            });
        }
    }
});
parcelRegister("gQ3yg", function(module, exports) {
    $parcel$export(module.exports, "getNaturalImageSize", ()=>$0ad0cc252faa2438$export$90153ab95f408dfa);
    $parcel$export(module.exports, "parseImage", ()=>$0ad0cc252faa2438$export$37bbb051492a18a7);
    $parcel$export(module.exports, "hasFileExceededSize", ()=>$0ad0cc252faa2438$export$a115ddd5941792f1);
    $parcel$export(module.exports, "imageAcceptHeader", ()=>$0ad0cc252faa2438$export$f8e7886bc155c2e6);
    const $0ad0cc252faa2438$var$maxEmojiSizeInBytes = 1048576;
    const $0ad0cc252faa2438$export$90153ab95f408dfa = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.addEventListener('load', ()=>{
                resolve({
                    width: img.naturalWidth,
                    height: img.naturalHeight
                });
            });
            img.addEventListener('error', reject);
            img.src = dataURL;
        });
    };
    const $0ad0cc252faa2438$export$37bbb051492a18a7 = (dataURL)=>{
        return new Promise((resolve, reject)=>{
            let img = new Image();
            img.onload = ()=>resolve({
                    src: img.src
                });
            img.onerror = ()=>reject();
            img.src = dataURL;
        });
    };
    const $0ad0cc252faa2438$export$a115ddd5941792f1 = (file)=>{
        return file && file.size > $0ad0cc252faa2438$var$maxEmojiSizeInBytes;
    };
    let $0ad0cc252faa2438$var$isWebpSupported;
    const $0ad0cc252faa2438$export$c5a964eb84c7fca8 = ()=>{
        if ($0ad0cc252faa2438$var$isWebpSupported !== undefined) return Promise.resolve($0ad0cc252faa2438$var$isWebpSupported);
        return new Promise((resolve)=>{
            const img = new Image();
            const checkSupport = ()=>{
                $0ad0cc252faa2438$var$isWebpSupported = img.height === 2;
                resolve($0ad0cc252faa2438$var$isWebpSupported);
            };
            img.addEventListener('load', checkSupport);
            img.addEventListener('error', checkSupport);
            img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
        });
    };
    const $0ad0cc252faa2438$export$f8e7886bc155c2e6 = ()=>$0ad0cc252faa2438$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
            const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
            const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
            return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
        });
});
parcelRegister("ijzU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$237e13119c8cb0fd$export$2e2bcd8739ae039);
    var $dS9cn = parcelRequire("dS9cn");
    const $237e13119c8cb0fd$export$866c20c059277b6 = 30;
    class $237e13119c8cb0fd$export$2e2bcd8739ae039 {
        constructor(siteServiceConfig){
            this.siteServiceConfig = siteServiceConfig;
            this.tokens = new Map();
        }
        isValidToken(mediaApiToken) {
            const nowInSeconds = Date.now() / 1000;
            const expiresAt = mediaApiToken.expiresAt - $237e13119c8cb0fd$export$866c20c059277b6;
            if (nowInSeconds < expiresAt) return true;
            return false;
        }
        fetchNewToken(type) {
            return (0, $dS9cn.utils).requestService(this.siteServiceConfig, {
                path: `token/${type}`
            });
        }
        addToken(type, mediaApiToken) {
            this.tokens.set(type, {
                mediaApiToken: mediaApiToken
            });
        }
        getToken(type, forceRefresh) {
            let tokenDetail = this.tokens.get(type);
            if (!tokenDetail) {
                tokenDetail = {};
                this.tokens.set(type, tokenDetail);
            }
            const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
            if (mediaApiToken) {
                if (this.isValidToken(mediaApiToken) && !forceRefresh) return Promise.resolve(mediaApiToken);
            }
            if (activeTokenRefresh) return activeTokenRefresh;
            tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
                tokenDetail.mediaApiToken = token;
                tokenDetail.activeTokenRefresh = undefined;
                return token;
            });
            return tokenDetail.activeTokenRefresh;
        }
    }
});
parcelRegister("d2UcN", function(module, exports) {
    $parcel$export(module.exports, "ufoExperiences", ()=>$350e11372b641899$export$615f888019c45765);
    $parcel$export(module.exports, "sampledUfoRenderedEmoji", ()=>$350e11372b641899$export$71c8cba6f1251ea9);
    $parcel$export(module.exports, "hasUfoMarked", ()=>$350e11372b641899$export$a9be054d2a5cedc0);
    $parcel$export(module.exports, "sampledUfoEmojiResourceFetched", ()=>$350e11372b641899$export$1466212a1606133);
    var $9AR2K;
    var $cBycP;
    var $7Zbvr;
    var $boHLC;
    var $bHWpv;
    const $350e11372b641899$var$createRenderExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
        };
    };
    const $350e11372b641899$var$createInlineExperience = (componentName)=>{
        return {
            platform: {
                component: componentName
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
        };
    };
    const $350e11372b641899$var$customEmojiTimings = [
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).FMP,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).FMP_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).METADATA,
            component: 'resourced-emoji',
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).METADATA_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).MEDIADATA,
            component: 'caching-emoji',
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MEDIA_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).MOUNTED,
            component: 'emoji',
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).MOUNTED_END
        },
        {
            key: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimingsKeys).ONLOAD,
            startMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_START,
            endMark: (0, (0, parcelRequire("9AR2K")).UfoEmojiTimings).ONLOAD_END
        }
    ];
    const $350e11372b641899$export$615f888019c45765 = {
        'emoji-rendered': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_RENDERED, {
            platform: {
                component: (0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI
            },
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).Custom,
            timings: $350e11372b641899$var$customEmojiTimings
        }),
        'emoji-resource-fetched': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_RESOURCE_FETCHED, $350e11372b641899$var$createRenderExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-picker-opened': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_PICKER_OPENED, $350e11372b641899$var$createRenderExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER)),
        'emoji-selection-recorded': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_SELECTION_RECORDED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PROVIDER)),
        'emoji-uploaded': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_UPLOADED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER)),
        'emoji-searched': new (0, (0, parcelRequire("boHLC")).UFOExperience)((0, (0, parcelRequire("9AR2K")).UfoExperienceName).EMOJI_SEARCHED, $350e11372b641899$var$createInlineExperience((0, (0, parcelRequire("9AR2K")).UfoComponentName).EMOJI_PICKER))
    };
    const $350e11372b641899$export$71c8cba6f1251ea9 = (emojiId)=>{
        return (0, (0, parcelRequire("bHWpv")).withSampling)($350e11372b641899$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
    };
    const $350e11372b641899$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
        return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
    };
    const $350e11372b641899$export$1466212a1606133 = (providerType)=>{
        return (0, (0, parcelRequire("bHWpv")).withSampling)($350e11372b641899$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
    };
});
parcelRegister("cBycP", function(module, exports) {
    $parcel$export(module.exports, "ConcurrentExperience", ()=>$d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);
    var $dCAsn;
    var $boHLC;
    class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
        constructor(experienceId, config){
            this.instances = {};
            this.experienceId = experienceId;
            this.config = config;
        }
        getInstance(instanceId) {
            if (!this.instances[instanceId]) this.instances[instanceId] = new (0, (0, parcelRequire("boHLC")).UFOExperience)(this.experienceId, this.config, instanceId);
            return this.instances[instanceId];
        }
        release(instanceId) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('instanceId', instanceId);
            if (this.instances[instanceId]) this.instances[instanceId].abort();
            delete this.instances[instanceId];
        }
    }
});
parcelRegister("dCAsn", function(module, exports) {
    $parcel$export(module.exports, "ufolog", ()=>$c8856379f9e2d7e8$export$b4958caff08a0960);
    $parcel$export(module.exports, "ufowarn", ()=>$c8856379f9e2d7e8$export$d53d07b6034c4560);
    class $c8856379f9e2d7e8$var$UFOLogger {
        static{
            this.UFOprefix = "[ufo\uD83D\uDEF8]";
        }
        log(...args) {
            this.enabled && console.log($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        warn(...args) {
            this.enabled && console.warn($c8856379f9e2d7e8$var$UFOLogger.UFOprefix, ...args);
        }
        enable() {
            this.enabled = true;
        }
        disable() {
            this.enabled = false;
        }
        constructor(){
            this.enabled = false;
        }
    }
    const $c8856379f9e2d7e8$export$4ab84f6f04f6566d = new $c8856379f9e2d7e8$var$UFOLogger();
    const $c8856379f9e2d7e8$export$b4958caff08a0960 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.log(...args);
    };
    const $c8856379f9e2d7e8$export$d53d07b6034c4560 = (...args)=>{
        $c8856379f9e2d7e8$export$4ab84f6f04f6566d.warn(...args);
    };
});
parcelRegister("boHLC", function(module, exports) {
    $parcel$export(module.exports, "UFOExperience", ()=>$69d53cdb5241e240$export$c00d22927c60484a);
    var $iLwDN;
    class $69d53cdb5241e240$export$c00d22927c60484a extends (0, (0, parcelRequire("iLwDN")).UFOAbstractExperience) {
    }
});
parcelRegister("iLwDN", function(module, exports) {
    $parcel$export(module.exports, "UFOAbstractExperience", ()=>$cc70575b2203e361$export$d31c89db257648c);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1vlV8;
    var $dCAsn;
    var $dlucd;
    var $blQsS;
    var $9tjMO;
    var $1CRHx;
    var $jZA09;
    var $hM2B6;
    var $7Zbvr;
    const $cc70575b2203e361$var$getPageVisibleState = ()=>{
        return !(0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, (0, parcelRequire("blQsS")).PageVisibleState).VISIBLE : (0, (0, parcelRequire("blQsS")).PageVisibleState).HIDDEN;
    };
    const $cc70575b2203e361$export$c753e8669d30c8ad = (timestamp)=>{
        if (timestamp !== undefined) return ~~timestamp;
        return (0, (0, parcelRequire("9tjMO")).roundPerfNow)();
    };
    class $cc70575b2203e361$export$d31c89db257648c {
        constructor(id, config, instanceId = null){
            this.state = (0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED;
            this.instanceId = null;
            this.parent = null;
            this.category = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.explicitTimings = {};
            this.isSSROutputAsFMP = false;
            this.uuid = null;
            this._until = null;
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this.performanceConfig = {};
            this.setPageVisibleStateToMixed = ()=>{
                this.pageVisibleState = (0, (0, parcelRequire("blQsS")).PageVisibleState).MIXED;
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            };
            this.id = id;
            this.category = config?.category || null;
            this.until = config?.until || null;
            this.instanceId = instanceId;
            this.handleDoneBind = this._handleDoneExperience.bind(this);
            this.type = config.type;
            this.performanceType = config.performanceType;
            this.performanceConfig = config.performanceConfig || {};
            this.config = config;
            this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
            this.featureFlags = config.featureFlags || [];
            this.timings = config.timings || [];
            if (config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
        }
        async transition(newState, timestamp) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('async transition', this.id, this.state.id, newState.id);
            if ((0, (0, parcelRequire("hM2B6")).canTransition)(this.state, newState)) {
                (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
                if (newState === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED) this._reset();
                if (this.state.final && !newState.final) {
                    this.metrics.startTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    this.uuid = (0, $7Jxgt.v4)();
                }
                this.state = newState;
                if (newState.final) {
                    this.metrics.endTime = $cc70575b2203e361$export$c753e8669d30c8ad(timestamp);
                    if (!this._isManualStateEnabled()) (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).unsubscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                    const data = await this.exportData();
                    (0, (0, parcelRequire("dCAsn")).ufolog)('this.parent', this.parent);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).experiencePayloadEvent)(data));
                }
                return true;
            }
            (0, (0, parcelRequire("dCAsn")).ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
            (0, (0, parcelRequire("dCAsn")).ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
            return false;
        }
        async start(startTime) {
            const transitionSuccessful = await this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED, startTime);
            if (transitionSuccessful) {
                this.pageVisibleState = $cc70575b2203e361$var$getPageVisibleState();
                (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                if (!this._isManualStateEnabled()) {
                    (0, (0, parcelRequire("dCAsn")).ufolog)('subscribed', this.id);
                    (0, (0, parcelRequire("1vlV8")).getGlobalEventStream)().push((0, (0, parcelRequire("1vlV8")).subscribeEvent)((0, (0, parcelRequire("blQsS")).SUBSCRIBE_ALL), this.handleDoneBind));
                }
            }
        }
        mark(name, timestamp) {
            if (name !== (0, (0, parcelRequire("blQsS")).FMP_MARK) && name !== (0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
            else (0, (0, parcelRequire("dCAsn")).ufowarn)('please use markFMP or markInlineResponse for specialised marks');
        }
        _mark(name, timestamp) {
            this.metrics.marks.push({
                name: name,
                time: $cc70575b2203e361$export$c753e8669d30c8ad(timestamp)
            });
            this.transition((0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS);
        }
        markFMP(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).FMP_MARK), timestamp);
        }
        markInlineResponse(timestamp) {
            this._mark((0, (0, parcelRequire("blQsS")).INLINE_RESPONSE_MARK), timestamp);
        }
        _isManualStateEnabled() {
            return this.until === null;
        }
        _validateManualState() {
            if (!this._isManualStateEnabled()) {
                (0, (0, parcelRequire("dCAsn")).ufowarn)('manual change of state not allowed as "until" is defined');
                return false;
            }
            return true;
        }
        switchToEndState(state, config) {
            if (!config?.force && !this._validateManualState()) return null;
            if (config?.metadata) this.addMetadata(config.metadata);
            (0, (0, parcelRequire("dlucd")).visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            return this.transition(state);
        }
        async success(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED, config);
        }
        async failure(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED, config);
        }
        async abort(config) {
            return this.switchToEndState((0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED, config);
        }
        addMetadata(data) {
            Object.assign(this.metadata, data);
        }
        _handleDoneExperience(data) {
            (0, (0, parcelRequire("dCAsn")).ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
            if (data.state.final) {
                if (this._until !== null) {
                    const { done: done, state: state } = this._until(data);
                    if (done && !this.state.final) this.transition(state);
                }
            }
        }
        async getId() {
            return this.id;
        }
        async exportData() {
            return {
                id: await this.getId(),
                uuid: this.uuid,
                type: this.type,
                schemaVersion: (0, $bbbd8b5766b053fb$export$2295b861f318254a) || 'unknown',
                performanceType: this.performanceType,
                category: this.category,
                state: this.state,
                metadata: {
                    ...this.metadata
                },
                metrics: {
                    ...this.metrics
                },
                children: [
                    ...this.childExperiences
                ],
                result: {
                    success: !!this.state.success,
                    startTime: this.metrics.startTime,
                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                },
                platform: this.config.platform || null,
                pageVisibleState: this.pageVisibleState,
                featureFlags: this.featureFlags,
                isSSROutputAsFMP: this.isSSROutputAsFMP,
                timings: this.timings,
                explicitTimings: this.explicitTimings,
                performanceConfig: this.performanceConfig
            };
        }
        _reset() {
            this.parent = null;
            this.metadata = {};
            this.onDoneCallbacks = [];
            this.childExperiences = [];
            this.metrics = {
                startTime: null,
                endTime: null,
                marks: []
            };
            this._until = this.until ? this.until() : null;
        }
    }
});
const $bbbd8b5766b053fb$export$2295b861f318254a = '0.1.5';
parcelRegister("1vlV8", function(module, exports) {
    $parcel$export(module.exports, "getGlobalEventStream", ()=>$d117cb8be5e8747a$export$6123a44dc2384540);
    $parcel$export(module.exports, "subscribeEvent", ()=>$d117cb8be5e8747a$export$37863216db4b714d);
    $parcel$export(module.exports, "unsubscribeEvent", ()=>$d117cb8be5e8747a$export$ee1a7bd1fc9ea85e);
    $parcel$export(module.exports, "experiencePayloadEvent", ()=>$d117cb8be5e8747a$export$7c957416596ca127);
    var $dCAsn;
    var $blQsS;
    const $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH = 250;
    const $d117cb8be5e8747a$export$6123a44dc2384540 = ()=>{
        if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
            const earlyStream = (()=>{
                const stream = [];
                return {
                    __buffer_only__: true,
                    push: (event)=>{
                        if (stream.length < $d117cb8be5e8747a$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                    },
                    getStream: ()=>stream
                };
            })();
            globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
        }
        return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
    };
    const $d117cb8be5e8747a$export$c1522520b417b066 = (eventStream)=>{
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
            (0, (0, parcelRequire("dCAsn")).ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
            return;
        }
        if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
    };
    const $d117cb8be5e8747a$export$37863216db4b714d = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).SUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).UNSUBSCRIBE,
            payload: {
                experienceId: experienceId,
                callback: callback
            }
        };
    };
    const $d117cb8be5e8747a$export$7c957416596ca127 = (data)=>{
        return {
            type: (0, (0, parcelRequire("blQsS")).UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
            payload: data
        };
    };
});
parcelRegister("blQsS", function(module, exports) {
    $parcel$export(module.exports, "UFOGlobalEventStreamEventType", ()=>$2d245cff606eb60d$export$96253c35c37cf96b);
    $parcel$export(module.exports, "PageVisibleState", ()=>$2d245cff606eb60d$export$a12c67b37a306b13);
    $parcel$export(module.exports, "SUBSCRIBE_ALL", ()=>$2d245cff606eb60d$export$79bf131685ad41d7);
    $parcel$export(module.exports, "FMP_MARK", ()=>$2d245cff606eb60d$export$9f2bf58999404c75);
    $parcel$export(module.exports, "INLINE_RESPONSE_MARK", ()=>$2d245cff606eb60d$export$837e0f79a8056912);
    var $2d245cff606eb60d$export$96253c35c37cf96b;
    (function(UFOGlobalEventStreamEventType) {
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
        UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    })($2d245cff606eb60d$export$96253c35c37cf96b || ($2d245cff606eb60d$export$96253c35c37cf96b = {}));
    var $2d245cff606eb60d$export$a12c67b37a306b13;
    (function(PageVisibleState) {
        PageVisibleState["VISIBLE"] = "visible";
        PageVisibleState["HIDDEN"] = "hidden";
        PageVisibleState["MIXED"] = "mixed";
    })($2d245cff606eb60d$export$a12c67b37a306b13 || ($2d245cff606eb60d$export$a12c67b37a306b13 = {}));
    var $2d245cff606eb60d$export$66b33c055cbb625e;
    (function(PageLoadMetrics) {
        PageLoadMetrics["fmp"] = "fmp";
        PageLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$66b33c055cbb625e || ($2d245cff606eb60d$export$66b33c055cbb625e = {}));
    var $2d245cff606eb60d$export$3ce489cbe02dc21b;
    (function(PageSegmentLoadMetrics) {
        PageSegmentLoadMetrics["fmp"] = "fmp";
        PageSegmentLoadMetrics["tti"] = "tti";
    })($2d245cff606eb60d$export$3ce489cbe02dc21b || ($2d245cff606eb60d$export$3ce489cbe02dc21b = {}));
    var $2d245cff606eb60d$export$341b330828bd3906;
    (function(InteractionMetrics) {
        InteractionMetrics["response"] = "response";
        InteractionMetrics["result"] = "result";
    })($2d245cff606eb60d$export$341b330828bd3906 || ($2d245cff606eb60d$export$341b330828bd3906 = {}));
    var $2d245cff606eb60d$export$b9b20160f581e4f8;
    (function(CustomMetrics) {
        CustomMetrics["duration"] = "duration";
    })($2d245cff606eb60d$export$b9b20160f581e4f8 || ($2d245cff606eb60d$export$b9b20160f581e4f8 = {}));
    const $2d245cff606eb60d$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
    const $2d245cff606eb60d$export$9f2bf58999404c75 = 'fmp';
    const $2d245cff606eb60d$export$837e0f79a8056912 = 'inline-response';
});
parcelRegister("dlucd", function(module, exports) {
    $parcel$export(module.exports, "visibilityChangeObserver", ()=>$46b8336a04974a29$export$13e680397ec8f3eb);
    var $1CRHx;
    class $46b8336a04974a29$var$VisibilityChangeObserver {
        start() {
            if (this.started) return;
            this.started = true;
            document.addEventListener('visibilitychange', this.broadcast);
            if ((0, (0, parcelRequire("1CRHx")).isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
        }
        subscribe(callback) {
            this.observers.push(callback);
        }
        unsubscribe(callback) {
            this.observers = this.observers.filter((fn)=>fn !== callback);
        }
        constructor(){
            this.started = false;
            this.observers = [];
            this.broadcast = ()=>{
                this.observers.forEach((fn)=>fn());
                this.observers = [];
            };
        }
    }
    const $46b8336a04974a29$export$13e680397ec8f3eb = new $46b8336a04974a29$var$VisibilityChangeObserver();
});
parcelRegister("1CRHx", function(module, exports) {
    $parcel$export(module.exports, "isWindowObjectAvailable", ()=>$5d24ea5e24f61a4f$export$15e172712955e18f);
    const $5d24ea5e24f61a4f$export$15e172712955e18f = ()=>{
        return typeof window !== 'undefined';
    };
});
parcelRegister("9tjMO", function(module, exports) {
    $parcel$export(module.exports, "roundPerfNow", ()=>$29608d3bcf65c265$export$5f490af6b2b115cf);
    const $29608d3bcf65c265$export$5f490af6b2b115cf = ()=>~~performance.now();
});
parcelRegister("jZA09", function(module, exports) {
    $parcel$export(module.exports, "UFOExperienceState", ()=>$175f7a63840c5fab$export$81b70111112841a0);
    const $175f7a63840c5fab$export$81b70111112841a0 = {
        NOT_STARTED: {
            id: 'NOT_STARTED',
            final: true
        },
        STARTED: {
            id: 'STARTED'
        },
        IN_PROGRESS: {
            id: 'IN_PROGRESS'
        },
        BLOCKED: {
            id: 'BLOCKED'
        },
        RECOVERED: {
            id: 'RECOVERED'
        },
        SUCCEEDED: {
            id: 'SUCCEEDED',
            final: true,
            success: true
        },
        SUCCEEDED_WAITING_FOR_DEPS: {
            id: 'SUCCEEDED_WAITING_FOR_DEPS'
        },
        FAILED: {
            id: 'FAILED',
            final: true
        },
        ABORTED: {
            id: 'ABORTED',
            final: true
        }
    };
});
parcelRegister("hM2B6", function(module, exports) {
    $parcel$export(module.exports, "canTransition", ()=>$6edf4365ea9733d4$export$178881f329fdb81f);
    var $jZA09;
    const $6edf4365ea9733d4$var$UFOStateAvailableTransitions = {
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).NOT_STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).BLOCKED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).RECOVERED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).SUCCEEDED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id,
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ],
        [(0, (0, parcelRequire("jZA09")).UFOExperienceState).ABORTED.id]: [
            (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
        ]
    };
    const $6edf4365ea9733d4$export$178881f329fdb81f = (state1, state2)=>{
        return $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id] && $6edf4365ea9733d4$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
    };
});
parcelRegister("7Zbvr", function(module, exports) {
    $parcel$export(module.exports, "ExperienceTypes", ()=>$e40e68027603de60$export$994164cf3ae1cc9a);
    $parcel$export(module.exports, "ExperiencePerformanceTypes", ()=>$e40e68027603de60$export$cc26007c03242fff);
    var $e40e68027603de60$export$994164cf3ae1cc9a;
    (function(ExperienceTypes) {
        ExperienceTypes["Load"] = "load";
        ExperienceTypes["Experience"] = "experience";
        ExperienceTypes["Operation"] = "operation";
    })($e40e68027603de60$export$994164cf3ae1cc9a || ($e40e68027603de60$export$994164cf3ae1cc9a = {}));
    var $e40e68027603de60$export$cc26007c03242fff;
    (function(ExperiencePerformanceTypes) {
        ExperiencePerformanceTypes["PageLoad"] = "page-load";
        ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
        ExperiencePerformanceTypes["InlineResult"] = "inline-result";
        ExperiencePerformanceTypes["Custom"] = "custom";
    })($e40e68027603de60$export$cc26007c03242fff || ($e40e68027603de60$export$cc26007c03242fff = {}));
});
parcelRegister("bHWpv", function(module, exports) {
    $parcel$export(module.exports, "withSampling", ()=>$8c8d9cbeece0ed73$export$dc2f0946255b3f89);
    const $8c8d9cbeece0ed73$export$c7c4959fece2f3ec = {};
    const $8c8d9cbeece0ed73$export$cdff9a865136ae27 = ()=>{
        for (const prop of Object.getOwnPropertyNames($8c8d9cbeece0ed73$export$c7c4959fece2f3ec))delete $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[prop];
    };
    const $8c8d9cbeece0ed73$export$1c967630b3ea2d58 = (rate)=>{
        if (rate === 1) return true;
        if (rate === 0) return false;
        return Math.random() * rate <= 1;
    };
    const $8c8d9cbeece0ed73$var$hasSampledFromStart = (experience)=>{
        if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id]) return false;
        if (experience.instanceId) return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
        return $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[experience.id].sampled;
    };
    const $8c8d9cbeece0ed73$export$dc2f0946255b3f89 = (ufoExperience)=>{
        const init = ()=>{
            if (!$8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id]) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id] = {
                sampled: false,
                sampledInstance: {}
            };
        };
        const start = async (options)=>{
            if ($8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            const isSampled = options.samplingFunc || $8c8d9cbeece0ed73$export$1c967630b3ea2d58;
            if (!isSampled(options.samplingRate)) {
                if (ufoExperience.instanceId) $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
                return;
            }
            if (ufoExperience.instanceId) {
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
                $8c8d9cbeece0ed73$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
            }
            return ufoExperience.start(options.startTime);
        };
        const success = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.success(config);
        };
        const failure = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.failure(config);
        };
        const abort = async (config)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return null;
            return ufoExperience.abort(config);
        };
        const addMetadata = (data)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.addMetadata(data);
        };
        const mark = (name, timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.mark(name, timestamp);
        };
        const markFMP = (timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markFMP(timestamp);
        };
        const markInlineResponse = (timestamp)=>{
            if (!$8c8d9cbeece0ed73$var$hasSampledFromStart(ufoExperience)) return;
            return ufoExperience.markInlineResponse(timestamp);
        };
        init();
        return {
            ...ufoExperience,
            start: start,
            addMetadata: addMetadata,
            success: success,
            failure: failure,
            abort: abort,
            mark: mark,
            markFMP: markFMP,
            markInlineResponse: markInlineResponse
        };
    };
});
parcelRegister("9CGZY", function(module, exports) {
    $parcel$export(module.exports, "EMOJI_SERVICEID", ()=>$2d9090d159781c68$export$f3c4ed49c0fff3de);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", ()=>$2d9090d159781c68$export$f8b39b441e3e8eb2);
    $parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", ()=>$2d9090d159781c68$export$2cdcb9248b6d4704);
    $parcel$export(module.exports, "getServiceProvider", ()=>$2d9090d159781c68$export$a4c27db78169052e);
    $parcel$export(module.exports, "default", ()=>$2d9090d159781c68$export$2e2bcd8739ae039);
    var $j8DrX;
    const $2d9090d159781c68$var$providersRepository = {};
    const $2d9090d159781c68$export$f3c4ed49c0fff3de = 'emoji';
    const $2d9090d159781c68$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
    const $2d9090d159781c68$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
    const $2d9090d159781c68$var$getServiceBaseUrl = (serviceId)=>{
        if (serviceId === $2d9090d159781c68$export$f8b39b441e3e8eb2 || serviceId === $2d9090d159781c68$export$2cdcb9248b6d4704) return (0, (0, parcelRequire("j8DrX")).default)('ajs-fabric-emoji-url');
        return (0, (0, parcelRequire("j8DrX")).default)(`ajs-fabric-${serviceId}-url`);
    };
    const $2d9090d159781c68$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
        try {
            let serviceProvider = $2d9090d159781c68$var$providersRepository[serviceId];
            if (serviceProvider === undefined) {
                const serviceBaseUrl = $2d9090d159781c68$var$getServiceBaseUrl(serviceId);
                if (serviceBaseUrl) {
                    serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                    $2d9090d159781c68$var$providersRepository[serviceId] = serviceProvider;
                }
            }
            return serviceProvider;
        } catch (e) {
            return null;
        }
    };
    const $2d9090d159781c68$export$59790759c19337ec = ()=>{
        Object.keys($2d9090d159781c68$var$providersRepository).forEach((key)=>{
            delete $2d9090d159781c68$var$providersRepository[key];
        });
    };
    var $2d9090d159781c68$export$2e2bcd8739ae039 = $2d9090d159781c68$var$getServiceBaseUrl;
});
parcelRegister("6a30R", function(module, exports) {
    $parcel$export(module.exports, "isExternalLink", ()=>$97cd92cd81dfd9ff$export$b98882f166bb7ce2);
    $parcel$export(module.exports, "onLinkClick", ()=>$97cd92cd81dfd9ff$export$dccc97e4cadc9724);
    $parcel$export(module.exports, "smartLinksDefault", ()=>$97cd92cd81dfd9ff$export$4f1b881d7a962ce6);
    $parcel$export(module.exports, "useSmartCardProductType", ()=>$97cd92cd81dfd9ff$export$3f864e37674c79e7);
    $parcel$export(module.exports, "useSmartCardIsAIEnabled", ()=>$97cd92cd81dfd9ff$export$af081b1242bfa300);
    $parcel$export(module.exports, "SmartCardProviderWithAIHooks", ()=>$97cd92cd81dfd9ff$export$ca9fa6647337e334);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dO33;
    var $dn5wJ;
    var $2vSU6;
    var $2gCtH;
    var $iixvy;
    var $93Yeu;
    const $97cd92cd81dfd9ff$var$isLeftClick = (event)=>event.button === 0;
    const $97cd92cd81dfd9ff$var$isMiddleClick = (event)=>event.button === 1;
    const $97cd92cd81dfd9ff$var$isCmdOrCtrlClick = (event)=>$97cd92cd81dfd9ff$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
    const $97cd92cd81dfd9ff$export$b98882f166bb7ce2 = (url)=>{
        try {
            const { hostname: hostname, pathname: pathname } = new URL(url);
            return (hostname !== window.location.hostname || ![
                '/jira',
                '/browse'
            ].some((includedPath)=>pathname.startsWith(includedPath)));
        } catch (err) {
            return true;
        }
    };
    const $97cd92cd81dfd9ff$export$dccc97e4cadc9724 = (event, url)=>{
        if (!url) return;
        if ($97cd92cd81dfd9ff$export$b98882f166bb7ce2(url)) {
            event.preventDefault();
            window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }
        if (event.defaultPrevented) {
            const mouseEvent = event;
            $97cd92cd81dfd9ff$var$isCmdOrCtrlClick(mouseEvent) || $97cd92cd81dfd9ff$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
        }
    };
    const $97cd92cd81dfd9ff$export$4f1b881d7a962ce6 = {
        actionOptions: {
            hide: false,
            exclude: [
                (0, (0, parcelRequire("dn5wJ")).CardAction).ChangeStatusAction
            ]
        }
    };
    const $97cd92cd81dfd9ff$export$4761115a9e18aa47 = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return 'JWM';
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return 'JSW';
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'JSM';
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return 'JPD';
            default:
                return undefined;
        }
    };
    const $97cd92cd81dfd9ff$export$3f864e37674c79e7 = ()=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        const product = (0, $5uXOq.useMemo)(()=>$97cd92cd81dfd9ff$export$4761115a9e18aa47(projectType) ?? 'JSW', [
            projectType
        ]);
        return product;
    };
    const $97cd92cd81dfd9ff$export$af081b1242bfa300 = ()=>{
        const isAiOptInEnabled = (0, (0, parcelRequire("2gCtH")).useIsAiOptInEnabled)();
        const isPremium = (0, (0, parcelRequire("iixvy")).useIsPremium)();
        const isAIFeatureEnabled = (0, $5uXOq.useMemo)(()=>isAiOptInEnabled && isPremium, [
            isAiOptInEnabled,
            isPremium
        ]);
        return isAIFeatureEnabled;
    };
    const $97cd92cd81dfd9ff$export$ca9fa6647337e334 = (props)=>{
        const product = $97cd92cd81dfd9ff$export$3f864e37674c79e7();
        const isAIEnabled = $97cd92cd81dfd9ff$export$af081b1242bfa300();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dO33")).SmartCardProvider), {
            product: product,
            isAdminHubAIEnabled: isAIEnabled,
            ...props
        }, props.children);
    };
});
parcelRegister("dn5wJ", function(module, exports) {
    $parcel$export(module.exports, "CardAction", ()=>$b402a0f22139e437$export$f40b7e0b762b928b);
    var $b402a0f22139e437$export$f40b7e0b762b928b;
    (function(CardAction) {
        CardAction["DownloadAction"] = "DownloadAction";
        CardAction["PreviewAction"] = "PreviewAction";
        CardAction["ViewAction"] = "ViewAction";
        CardAction["ChangeStatusAction"] = "ChangeStatusAction";
        CardAction["FollowAction"] = "FollowAction";
        CardAction["CopyLinkAction"] = "CopyLinkAction";
        CardAction["AISummaryAction"] = "AISummaryAction";
        CardAction["AutomationAction"] = "AutomationAction";
    })($b402a0f22139e437$export$f40b7e0b762b928b || ($b402a0f22139e437$export$f40b7e0b762b928b = {}));
});
parcelRegister("iixvy", function(module, exports) {
    $parcel$export(module.exports, "useIsPremium", ()=>$545133d1825caa45$export$1bb5840a003dc643);
    $parcel$export(module.exports, "useOptInStatus", ()=>$545133d1825caa45$export$5e56b08674e48311);
    $parcel$export(module.exports, "useAIOptIn", ()=>$545133d1825caa45$export$49e57b9044cda91c);
    var $5uXOq = parcelRequire("5uXOq");
    var $kTK0a;
    var $aIZdc;
    var $2vSU6;
    var $6s1PB;
    var $2gCtH;
    var $5NH95;
    var $93Yeu;
    var $14XJw;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $ljlOe;
    var $44KLa;
    const $545133d1825caa45$var$DISABLED = 'disabled';
    const $545133d1825caa45$var$DISABLED_OPT_IN = 'disabled-opt-in';
    const $545133d1825caa45$var$ENABLED = 'enabled';
    const $545133d1825caa45$export$1bb5840a003dc643 = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$10e0dafdd792475b = ()=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const projectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectType = (0, (0, parcelRequire("93Yeu")).useProjectType)(projectKey);
        if (!appEditions) return false;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return appEditions.core === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return appEditions.software === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return appEditions.serviceDesk === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION);
            default:
                return false;
        }
    };
    const $545133d1825caa45$export$bd66bcf1f00b19d2 = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isPremium = $545133d1825caa45$export$1bb5840a003dc643();
        const isSupportedENV = !(0, (0, parcelRequire("aIZdc")).isFedRamp)();
        return isOrgAdmin && isPremium && isSupportedENV;
    };
    const $545133d1825caa45$export$1276193c77ae88bf = ()=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isStandard = $545133d1825caa45$export$10e0dafdd792475b();
        const isSupportedENV = !(0, (0, parcelRequire("aIZdc")).isFedRamp)();
        return isOrgAdmin && isStandard && isSupportedENV;
    };
    const $545133d1825caa45$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
        const canOptIn = $545133d1825caa45$export$bd66bcf1f00b19d2();
        const canStartPremiumTrial = $545133d1825caa45$export$1276193c77ae88bf();
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return $545133d1825caa45$var$DISABLED;
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { experimentValue: aiUpsellInEditorEnabled } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorRequirements)(product) : {
            experimentValue: false
        };
        if (aiUpsellInEditorEnabled) return $545133d1825caa45$var$DISABLED_OPT_IN;
        const isValidForGlobalOptIn = [
            product !== 'JPD',
            canOptIn
        ].every((condition)=>condition === true);
        const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
        const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? $545133d1825caa45$var$DISABLED_OPT_IN : $545133d1825caa45$var$DISABLED;
        return isAIOptedIn ? $545133d1825caa45$var$ENABLED : globalOptInEnabled;
    };
    const $545133d1825caa45$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
        const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
        const optInStatus = $545133d1825caa45$export$5e56b08674e48311(isAiOptInEnabled, product);
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const [showOptInModal, setShowOptInModal] = (0, $5uXOq.useState)(false);
        const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $5uXOq.useState)(false);
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const canStartTrial = $545133d1825caa45$export$1276193c77ae88bf();
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { isExperimentEnabled: isAIUpsellInEditorFreeEnabled, triggerUpsellFlow: triggerAIUpsellInEditorFreeFlow, UpsellModal: AIUpsellInEditorFreeModal } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorFree)(optInStatus, product) : {
            isExperimentEnabled: false,
            triggerUpsellFlow: ()=>{},
            UpsellModal: null
        };
        const triggerOptInFlow = (0, $5uXOq.useCallback)(()=>{
            setShowOptInModal(true);
        }, [
            setShowOptInModal
        ]);
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            setShowPremiumTrialModal(true);
        }, [
            setShowPremiumTrialModal
        ]);
        const aiOptInModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowOptInModal(false);
            const adminLink = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInModal), {
                showOptInModal: showOptInModal,
                isOrgAdmin: isOrgAdmin,
                onCloseModal: onCloseModal,
                adminLink: adminLink
            });
        }, [
            orgId,
            isOrgAdmin,
            showOptInModal
        ]);
        const aiUpsellModal = (0, $5uXOq.useMemo)(()=>{
            const onCloseModal = ()=>setShowPremiumTrialModal(false);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContextProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("44KLa")).OptInUpsellModal), {
                "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
                showPremiumTrialModal: showPremiumTrialModal,
                onCloseModal: onCloseModal
            }));
        }, [
            showPremiumTrialModal
        ]);
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return {
            optInStatus: $545133d1825caa45$var$DISABLED,
            triggerOptInFlow: ()=>{},
            AIOptInModal: null
        };
        if (isAIUpsellInEditorFreeEnabled) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerAIUpsellInEditorFreeFlow,
            AIOptInModal: AIUpsellInEditorFreeModal
        };
        if (optInStatus === $545133d1825caa45$var$DISABLED || optInStatus === $545133d1825caa45$var$ENABLED) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: null
        };
        if (canStartTrial && optInStatus === $545133d1825caa45$var$DISABLED_OPT_IN) return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerUpsellFlow,
            AIOptInModal: aiUpsellModal
        };
        return {
            optInStatus: optInStatus,
            triggerOptInFlow: triggerOptInFlow,
            AIOptInModal: aiOptInModal
        };
    };
});
parcelRegister("5NH95", function(module, exports) {
    $parcel$export(module.exports, "useAIUpsellInEditorRequirements", ()=>$26b3b3762ac33b52$export$38bfb0ec25eaa6b2);
    $parcel$export(module.exports, "useAIUpsellInEditorFree", ()=>$26b3b3762ac33b52$export$beacfd188d344f95);
    $parcel$export(module.exports, "AIUpsellButtonWrapper", ()=>$26b3b3762ac33b52$export$c44b9b0347b51c37);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $aIZdc;
    var $2vSU6;
    var $6s1PB;
    var $fmQtB;
    var $8zOmE;
    var $2NMNM;
    var $ldyPw;
    var $k9JTq;
    var $cNd4s;
    var $7xCut;
    const { fireEventOnce: $26b3b3762ac33b52$var$fireEventOnce } = (()=>{
        let hasFired = false;
        return {
            fireEventOnce: (fireFunction)=>{
                if (!hasFired) {
                    fireFunction();
                    hasFired = true;
                }
            }
        };
    })();
    const $26b3b3762ac33b52$var$useGetSupportedProjectType = (product)=>{
        switch(product){
            case 'JSW':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'JSM':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'JWM':
            case 'JPD':
            default:
                return undefined;
        }
    };
    const $26b3b3762ac33b52$var$useGetSupportedEdition = (product)=>{
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        if (!appEditions) return undefined;
        if (projectType) return (0, (0, parcelRequire("ldyPw")).getEditionForProject)(projectType, appEditions);
        return undefined;
    };
    const $26b3b3762ac33b52$export$38bfb0ec25eaa6b2 = (product)=>{
        const isOrgAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [config, fireExperimentExposure] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const statsigExperimentValue = config.get('experimentEnabled', undefined);
        const siteMeetsRequirements = $26b3b3762ac33b52$var$useGetSupportedEdition(product) === (0, (0, parcelRequire("ldyPw")).FREE_EDITION) && isOrgAdmin && !(0, (0, parcelRequire("aIZdc")).isFedRamp)() && typeof statsigExperimentValue === 'boolean';
        const experimentValue = siteMeetsRequirements ? statsigExperimentValue : undefined;
        const fireExposure = (0, $5uXOq.useCallback)(()=>{
            fireExperimentExposure();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'experiment exposed', {
                experimentKey: 'aiUpsellInEditorFree',
                isEligible: siteMeetsRequirements,
                cohort: experimentValue
            });
        }, [
            createAnalyticsEvent,
            experimentValue,
            fireExperimentExposure,
            siteMeetsRequirements
        ]);
        return {
            siteMeetsRequirements: siteMeetsRequirements,
            experimentValue: experimentValue,
            statsigExperimentValue: statsigExperimentValue,
            fireExperimentExposure: fireExposure
        };
    };
    const $26b3b3762ac33b52$export$beacfd188d344f95 = (optInStatus, product)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [showUpsellModal, setShowUpsellModal] = (0, $5uXOq.useState)(false);
        const { siteMeetsRequirements: siteMeetsRequirements, statsigExperimentValue: statsigExperimentValue, fireExperimentExposure: fireExperimentExposure } = $26b3b3762ac33b52$export$38bfb0ec25eaa6b2(product);
        const projectType = $26b3b3762ac33b52$var$useGetSupportedProjectType(product);
        const siteMeetsOptInRequirements = siteMeetsRequirements && optInStatus !== 'enabled';
        const experimentValue = siteMeetsOptInRequirements ? statsigExperimentValue : undefined;
        const isEnrolledInExperiment = typeof experimentValue === 'boolean';
        const isExperimentEnabled = isEnrolledInExperiment && experimentValue;
        const triggerUpsellFlow = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'triggerUpsellFlow',
                actionSubject: 'aiUpsellInEditorFree'
            }), 'aiUpsellInEditorFreeTrigger', {});
            setShowUpsellModal(true);
            (0, (0, parcelRequire("7xCut")).setUpsellButtonWrapperClicked)(true);
        }, [
            createAnalyticsEvent
        ]);
        const UpsellModal = (0, $5uXOq.useMemo)(()=>showUpsellModal && projectType ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fmQtB")).AsyncAiUpsellInEditorFreeModal), {
                projectType: projectType,
                testId: "platform-react-hooks-use-ai-upsell-in-editor-free.growth-ai-upsell-in-editor-modal",
                onModalClose: ()=>setShowUpsellModal(false)
            }) : null, [
            showUpsellModal,
            projectType
        ]);
        return {
            isEnrolledInExperiment: isEnrolledInExperiment,
            isExperimentEnabled: isExperimentEnabled,
            fireExperimentExposure: fireExperimentExposure,
            triggerUpsellFlow: triggerUpsellFlow,
            UpsellModal: UpsellModal
        };
    };
    const $26b3b3762ac33b52$export$c44b9b0347b51c37 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isClicked = (0, (0, parcelRequire("7xCut")).getUpsellButtonWrapperClicked)();
        (0, $5uXOq.useEffect)(()=>{
            $26b3b3762ac33b52$var$fireEventOnce(()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button viewed', 'aiUpsellInEditorFreeToolbarButton', {}));
        }, [
            createAnalyticsEvent
        ]);
        return !isClicked ? (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonContainer, {
            "data-testid": "platform-react-hooks-use-ai-upsell-in-editor-free.ai-upsell-button-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26b3b3762ac33b52$var$AIUpsellButtonInner, null, children)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    const $26b3b3762ac33b52$var$AIUpsellButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko44q7 _11q7otc5 _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $26b3b3762ac33b52$var$AIUpsellButtonInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fmQtB", function(module, exports) {
    $parcel$export(module.exports, "AsyncAiUpsellInEditorFreeModal", ()=>$2c23576aa5eb8dba$export$827041a383456a6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $kxZPA;
    const $2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("6zDy2")), {
        ssr: false,
        moduleId: "./src/packages/growth/ai-upsell-in-editor-free-modal/src/ui/index.tsx"
    });
    const $2c23576aa5eb8dba$export$827041a383456a6a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "asyncAiUpsellInEditorFreeModal",
            packageName: "jira-growth-ai-upsell-in-editor-free-modal",
            teamName: "growth-tako",
            render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2c23576aa5eb8dba$var$LazyAiUpsellInEditorFreeModal, props));
});
parcelRegister("6zDy2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bQd01")
    ]).then(()=>parcelRequire('b738i'));
});
parcelRegister("7xCut", function(module, exports) {
    $parcel$export(module.exports, "getUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$f7d51ee95145148b);
    $parcel$export(module.exports, "setUpsellButtonWrapperClicked", ()=>$b8d3bd23ca283e73$export$b595420beb43f9ce);
    var $bSSG7;
    const $b8d3bd23ca283e73$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('ai-upsell-in-editor-free');
    function $b8d3bd23ca283e73$export$f7d51ee95145148b() {
        return Boolean($b8d3bd23ca283e73$export$c2ed3351cac403d1.get('upsellButtonWrapperClicked') ?? false);
    }
    function $b8d3bd23ca283e73$export$b595420beb43f9ce(value) {
        $b8d3bd23ca283e73$export$c2ed3351cac403d1.set('upsellButtonWrapperClicked', value);
    }
});
parcelRegister("ljlOe", function(module, exports) {
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", ()=>$82777381236a0306$export$77aa5ca661b0742c);
    $parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", ()=>$82777381236a0306$export$dd0a751f23b19473);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mO32;
    var $l37qh;
    var $b3Gth;
    const $82777381236a0306$export$77aa5ca661b0742c = (0, (0, parcelRequire("l37qh")).createUseEntryPointContext)();
    const $82777381236a0306$export$dd0a751f23b19473 = ({ children: children })=>{
        const entryPointParams = {};
        const entryPointResult = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("b3Gth")).entryPointPremiumUpgradeModal), entryPointParams);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($82777381236a0306$export$77aa5ca661b0742c.Provider, {
            value: entryPointResult
        }, children);
    };
});
parcelRegister("l37qh", function(module, exports) {
    $parcel$export(module.exports, "createUseEntryPointContext", ()=>$6e7e19c2d291c94c$export$41bce2223126846b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>(0, $5uXOq.createContext)({
            entryPointActions: {
                cancelPreload () {},
                load () {},
                preload () {},
                unload () {}
            },
            entryPointReferenceSubject: {
                getValue: ()=>null,
                subscribe: ()=>()=>{}
            },
            stopMetric () {}
        });
});
parcelRegister("b3Gth", function(module, exports) {
    $parcel$export(module.exports, "entryPointPremiumUpgradeModal", ()=>$a50fd4829307668f$export$7116d5b1a93db8d6);
    var $eufEc;
    var $fEDBv;
    const $a50fd4829307668f$export$7116d5b1a93db8d6 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("paDrG")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
            moduleId: "1102b440"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("paDrG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5azfZ")
    ]).then(()=>parcelRequire('5s8iH'));
});
parcelRegister("44KLa", function(module, exports) {
    $parcel$export(module.exports, "OptInModal", ()=>$bf7c19a18c627984$export$1697f043758ae8d2);
    $parcel$export(module.exports, "OptInUpsellModal", ()=>$bf7c19a18c627984$export$bbf8d259a508a485);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $i8Qvm;
    var $4UN9Z;
    var $7XluA;
    var $8zOmE;
    var $2NMNM;
    var $ljlOe;
    var $ejjdc;
    const $bf7c19a18c627984$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, showOptInModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4UN9Z")).default), {
            source: "jira-editor",
            product: "jira",
            isOrgAdmin: isOrgAdmin,
            onAdminClose: onCloseModal,
            adminLink: adminLink
        })));
    const $bf7c19a18c627984$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const runtimeProps = (0, $5uXOq.useMemo)(()=>({
                onClose: ()=>{
                    entryPointActions.unload();
                    const analyticsEvent = createAnalyticsEvent({
                        actionSubject: 'button',
                        action: 'clicked'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
                }
            }), [
            entryPointActions,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, showPremiumTrialModal && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
            width: "fit-content",
            onClose: onCloseModal
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejjdc")).AIOptInPremiumUpsell), {
            onClose: onCloseModal
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
            packageName: "platform-react-hooks-use-ai-opt-in",
            runtimeProps: runtimeProps
        }));
    };
});
parcelRegister("4UN9Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$498daaeb8cd4c6ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $eCeGD;
    var $1GGwS;
    var $dC5iT;
    var $8CUq3;
    var $c0x54 = parcelRequire("c0x54");
    var $ek69Y;
    var $lJhAv;
    const $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtlest',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $498daaeb8cd4c6ec$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onLearnMoreClicked = (e)=>{
            e.stopPropagation();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                    attributes: {
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const formatMessageValues = {
            a: (s)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $3490940fa7f2fa1c$export$550fac1a4ec3d365),
                    target: "_blank",
                    onClick: onLearnMoreClicked
                }, s),
            br: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
        };
        const defaultHeader = formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogHeaderText);
        const header = headerText ?? defaultHeader;
        const body = bodyText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogBodyText, formatMessageValues);
        const orgAdminBody = adminBodyText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminBodyText, formatMessageValues);
        const orgAdminHeader = adminHeaderText ?? defaultHeader;
        (0, $5uXOq.useEffect)(()=>{
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, ($parcel$interopDefault($c0x54)))
            ]);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'aiGlobalOptInDialog',
                    attributes: {
                        source: source,
                        product: product,
                        isOrgAdmin: !!isOrgAdmin
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        }, [
            createAnalyticsEvent,
            source,
            product,
            isOrgAdmin
        ]);
        const onCloseClicked = (e)=>{
            e.stopPropagation();
            onAdminClose?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        const onCTAClicked = (e)=>{
            e.stopPropagation();
            onAdminCTA?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                    attributes: {
                        product: product
                    },
                    tags: [
                        'fabricElements'
                    ]
                }
            }).fire();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).OptInBackgroundBorder), {
            width: width,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).OptInContainer), null, image ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ImageWrapper), null, image) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ImageWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: (0, ($parcel$interopDefault($c0x54))),
            height: "96px",
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ContentContainer), null, isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $498daaeb8cd4c6ec$var$VisibleTextOrgAdminStyles
        }, formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInAdminOnlyVisible)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).BodyWrapper), {
            "data-testid": "dialog-body-text"
        }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lJhAv")).ButtonContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onCloseClicked,
            testId: "admin-close-button"
        }, adminCloseCTAText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminMaybeLaterButtonText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1GGwS")).default), {
            appearance: "primary",
            onClick: onCTAClicked,
            href: adminLink ?? (0, $3490940fa7f2fa1c$export$bae9a077d7ed5dfe),
            target: "_blank",
            testId: "admin-cta-button"
        }, adminCTAText ?? formatMessage((0, (0, parcelRequire("ek69Y")).messages).aiOptInDialogAdminGetStartedButtonText))))));
    };
    var $498daaeb8cd4c6ec$export$2e2bcd8739ae039 = $498daaeb8cd4c6ec$var$AiOptIn;
});
parcelRegister("1GGwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9768e745d0380796$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhmo0;
    var $fuBHX;
    const $9768e745d0380796$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("fuBHX")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhmo0")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $9768e745d0380796$var$WithRef = (0, $5uXOq.forwardRef)($9768e745d0380796$var$LinkButtonBase);
    const $9768e745d0380796$var$LinkButton = (0, $5uXOq.memo)($9768e745d0380796$var$WithRef);
    var $9768e745d0380796$export$2e2bcd8739ae039 = $9768e745d0380796$var$LinkButton;
});
parcelRegister("c0x54", function(module, exports) {
    module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();
});
const $3490940fa7f2fa1c$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $3490940fa7f2fa1c$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
parcelRegister("ek69Y", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$5fe19a2c65ae0a6d$export$defe85febe8b728c);
    var $7VHMR;
    const $5fe19a2c65ae0a6d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aiOptInDialogHeaderText: {
            id: 'ai-opt-in.dialog.header.text',
            defaultMessage: 'Work smarter, not harder',
            description: 'Header text for AI Opt In Dialog'
        },
        aiOptInDialogBodyText: {
            id: 'ai-opt-in.dialog.body.text',
            defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
            description: 'Body text for AI Opt In Dialog'
        },
        aiOptInDialogLearnMoreLinkText: {
            id: 'ai-opt-in.dialog.learn-more.link.text',
            defaultMessage: 'Learn more about Atlassian Intelligence',
            description: 'Learn more link text for AI Opt In Dialog'
        },
        aiOptInDialogAdminBodyText: {
            id: 'ai-opt-in.dialog.admin.body.text',
            defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of AI Opt In Dialog'
        },
        aiOptInDialogAdminMaybeLaterButtonText: {
            id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
            defaultMessage: 'Maybe later',
            description: 'Admin maybe later button text'
        },
        aiOptInDialogAdminGetStartedButtonText: {
            id: 'ai-opt-in.dialog.admin.get-started.button.text',
            defaultMessage: 'Get started',
            description: 'Admin get started button text'
        },
        aiOptInBannerBodyText: {
            id: 'ai-opt-in.banner.body.text',
            defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
            description: 'Body text for Banner version of AI Opt In Dialog'
        },
        aiOptInBannerLearnMoreText: {
            id: 'ai-opt-in.banner.learn.more.text',
            defaultMessage: 'Learn more',
            description: 'Learn more text for Banner cta of AI Opt In Dialog'
        },
        aiOptInAdminBannerBodyText: {
            id: 'ai-opt-in.banner.admin.body.text',
            defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
            description: 'Body text for Admin version of the Banner Ai Opt In'
        },
        aiOptInAdminOnlyVisible: {
            id: 'ai-opt-in.admin.only.visible.text',
            defaultMessage: 'This message is only visible to org admins.',
            description: 'Text message to let org admins know that the content is only visible to them.'
        }
    });
});
parcelRegister("lJhAv", function(module, exports) {
    $parcel$export(module.exports, "OptInBackgroundBorder", ()=>$1bcec8f5b168d85d$export$24c280970213bb11);
    $parcel$export(module.exports, "OptInContainer", ()=>$1bcec8f5b168d85d$export$a0fab83bea8ccf2e);
    $parcel$export(module.exports, "ImageWrapper", ()=>$1bcec8f5b168d85d$export$75f07c36086c2c81);
    $parcel$export(module.exports, "ContentContainer", ()=>$1bcec8f5b168d85d$export$9d2b4227a95687cc);
    $parcel$export(module.exports, "HeaderWrapper", ()=>$1bcec8f5b168d85d$export$960a49cc3d27a090);
    $parcel$export(module.exports, "BodyWrapper", ()=>$1bcec8f5b168d85d$export$14966827497f4695);
    $parcel$export(module.exports, "ButtonContainer", ()=>$1bcec8f5b168d85d$export$eddf54ea3db8d0f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $1bcec8f5b168d85d$export$24c280970213bb11 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1vcp0mh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16qs1o46 _2rko14y2 _1yt4v77o _kqswh2mm _11q71lxv",
                __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$a0fab83bea8ccf2e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$75f07c36086c2c81 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$9d2b4227a95687cc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81bk4",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$14966827497f4695 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c81oud",
                __cmplp.className
            ])
        });
    });
    const $1bcec8f5b168d85d$export$eddf54ea3db8d0f0 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ejjdc", function(module, exports) {
    $parcel$export(module.exports, "AIOptInPremiumUpsell", ()=>$678322372bbc5cca$export$54e4ba490d2c6bb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $l1N8i;
    var $2C7j9;
    var $c8oLN;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $gEusR;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $2ogyS;
    var $iau6N;
    const $678322372bbc5cca$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'screen',
                action: 'viewed'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
        }, [
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $678322372bbc5cca$var$containerBorderStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignBlock: "stretch",
            xcss: $678322372bbc5cca$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "end",
            grow: "fill",
            xcss: $678322372bbc5cca$var$headerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            onClick: onClose,
            label: formatMessage((0, (0, parcelRequire("2ogyS")).messages).closeModal),
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2C7j9")))))
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8oLN")).default), {
            all: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEusR")).default), {
            alt: ""
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            alignInline: "stretch",
            space: "space.200",
            xcss: $678322372bbc5cca$var$textContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium",
            as: "h2"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iau6N")).StartPremiumTrialButton), {
            onCloseParent: onClose
        })))));
    };
    const $678322372bbc5cca$var$containerBorderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        boxShadow: 'elevation.shadow.overlay',
        borderRadius: 'border.radius',
        width: '438px',
        position: 'relative',
        padding: 'space.025',
        background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $829f609a65d26a98$export$c71e4279dd54a18d)})`} 100%
    )`
    });
    const $678322372bbc5cca$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        backgroundColor: 'elevation.surface.overlay',
        overflow: 'hidden'
    });
    const $678322372bbc5cca$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        padding: 'space.075',
        right: 'space.025'
    });
    const $678322372bbc5cca$var$textContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.300'
    });
});
parcelRegister("c8oLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e401c8401021557f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8CUq3;
    function $e401c8401021557f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e401c8401021557f$var$baseStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $e401c8401021557f$var$blockBleedMap = {
        'space.025': {
            name: "9w2fxh",
            styles: "margin-block:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "1qhe0y6",
            styles: "margin-block:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "s0o2nz",
            styles: "margin-block:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "151e4o3",
            styles: "margin-block:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "16sn062",
            styles: "margin-block:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$inlineBleedMap = {
        'space.025': {
            name: "16oxh68",
            styles: "margin-inline:var(--ds-space-negative-025, -0.125rem)"
        },
        'space.050': {
            name: "tdc6fz",
            styles: "margin-inline:var(--ds-space-negative-050, -0.25rem)"
        },
        'space.100': {
            name: "crujrn",
            styles: "margin-inline:var(--ds-space-negative-100, -0.5rem)"
        },
        'space.150': {
            name: "y28d58",
            styles: "margin-inline:var(--ds-space-negative-150, -0.75rem)"
        },
        'space.200': {
            name: "1vfkteg",
            styles: "margin-inline:var(--ds-space-negative-200, -1rem)"
        }
    };
    const $e401c8401021557f$var$Bleed = (0, ($parcel$interopDefault($5uXOq))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("8CUq3")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: resolvedStyles.static,
            css: [
                $e401c8401021557f$var$baseStyles,
                (inline || all) && $e401c8401021557f$var$inlineBleedMap[inline || all],
                (block || all) && $e401c8401021557f$var$blockBleedMap[block || all],
                resolvedStyles.emotion
            ],
            "data-testid": testId
        }, children);
    });
    $e401c8401021557f$var$Bleed.displayName = 'Bleed';
    var $e401c8401021557f$export$2e2bcd8739ae039 = $e401c8401021557f$var$Bleed;
});
parcelRegister("gEusR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daf0e2023e742d66$export$2e2bcd8739ae039);
    var $dCLgq;
    var $8nOP6 = parcelRequire("8nOP6");
    var $4aPxh = parcelRequire("4aPxh");
    const $daf0e2023e742d66$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($4aPxh)),
        srcDark: ($parcel$interopDefault($8nOP6))
    });
    var $daf0e2023e742d66$export$2e2bcd8739ae039 = $daf0e2023e742d66$var$Illustration;
    const $daf0e2023e742d66$export$a179c88182cb9d56 = [
        0,
        0,
        438,
        96
    ];
});
parcelRegister("8nOP6", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();
});
parcelRegister("4aPxh", function(module, exports) {
    module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();
});
parcelRegister("2ogyS", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$703e8ca8733c69fc$export$defe85febe8b728c);
    var $7VHMR;
    const $703e8ca8733c69fc$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
            "defaultMessage": "Write better, work faster with Atlassian Intelligence"
        },
        body: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
            "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
        },
        closeModal: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
            "defaultMessage": "Close Modal"
        },
        tryItFreeButton: {
            "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
            "defaultMessage": "Try it free"
        }
    });
});
parcelRegister("iau6N", function(module, exports) {
    $parcel$export(module.exports, "StartPremiumTrialButton", ()=>$d916fa2fae12e75a$export$a2651a739f515dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $8EYBJ;
    var $47gW9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $ljlOe;
    var $2ogyS;
    const $d916fa2fae12e75a$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, (0, parcelRequire("ljlOe")).AIUpsellPremiumTrialEntryPointContext));
        const triggerRef = (0, (0, parcelRequire("47gW9")).useEntryPointButtonTrigger)(entryPointActions);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClickAnalytics = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
        }, [
            createAnalyticsEvent
        ]);
        const onClick = ()=>{
            onCloseParent && onCloseParent();
            onClickAnalytics();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            onClick: onClick,
            ref: triggerRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8EYBJ"))))), {
                size: "small",
                label: "",
                primaryColor: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`
            }),
            theme: (current, themeProps)=>({
                    buttonStyles: {
                        ...current(themeProps).buttonStyles,
                        display: 'flex',
                        alignItems: 'center',
                        background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$exports).N0})`,
                        outline: 'none',
                        boxSizing: 'border-box',
                        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                        borderRadius: "var(--ds-space-050, 4px)",
                        height: "var(--ds-space-400, 32px)",
                        border: 'none',
                        fontSize: '14px',
                        gap: "var(--ds-space-025, 2px)"
                    },
                    spinnerStyles: current(themeProps).spinnerStyles
                })
        }, formatMessage((0, (0, parcelRequire("2ogyS")).messages).tryItFreeButton));
    };
});
parcelRegister("47gW9", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointButtonTrigger", ()=>$1be876415a945060$export$25d2524a63315ed);
    $parcel$export(module.exports, "getDefaultEntrypointActionEventMap", ()=>$1be876415a945060$export$5f13515bd3a35325);
    var $5uXOq = parcelRequire("5uXOq");
    var $iRKpN;
    const $1be876415a945060$export$25d2524a63315ed = (actions, isActive = true, eventMap = $1be876415a945060$export$5f13515bd3a35325(actions))=>{
        const removePreviousListeners = (0, $5uXOq.useRef)(null);
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>()=>{
                removePreviousListeners.current?.();
                removePreviousListeners.current = null;
                isMounted.current = false;
            }, []);
        return (0, $5uXOq.useCallback)((element)=>{
            if (!isMounted.current) return;
            removePreviousListeners.current?.();
            if (element && isActive) {
                (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                    element: element,
                    operationName: 'add',
                    eventMap: eventMap
                });
                removePreviousListeners.current = ()=>{
                    (0, (0, parcelRequire("iRKpN")).modifyListeners)({
                        element: element,
                        operationName: 'remove',
                        eventMap: eventMap
                    });
                };
            } else removePreviousListeners.current = null;
        }, [
            eventMap,
            isActive
        ]);
    };
    const $1be876415a945060$export$5f13515bd3a35325 = (actions)=>({
            click: actions.load,
            mouseenter: actions.preload,
            mouseleave: actions.cancelPreload,
            focusin: actions.preload,
            focusout: actions.cancelPreload
        });
});
parcelRegister("iRKpN", function(module, exports) {
    $parcel$export(module.exports, "modifyListeners", ()=>$62bae43418420b8a$export$15257a36a7e3f9d6);
    function $62bae43418420b8a$export$15257a36a7e3f9d6(params) {
        const { element: element, operationName: operationName, eventMap: eventMap } = params;
        const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
        if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
    }
});
parcelRegister("4IoOR", function(module, exports) {
    $parcel$export(module.exports, "convertWikiToAdf", ()=>$7c8efe67867622a1$export$3dfdef94497f0395);
    var $kOFhM;
    var $hYNZx;
    var $dN5CS;
    const $7c8efe67867622a1$var$wikiTransformer = new (0, (0, parcelRequire("dN5CS")).WikiMarkupTransformer)((0, (0, parcelRequire("kOFhM")).defaultSchema));
    const $7c8efe67867622a1$var$adfTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    const $7c8efe67867622a1$export$3dfdef94497f0395 = (wiki)=>{
        if (wiki === null || wiki === undefined || wiki === '') return null;
        const pmNode = $7c8efe67867622a1$var$wikiTransformer.parse(wiki);
        return $7c8efe67867622a1$var$adfTransformer.encode(pmNode);
    };
});
parcelRegister("dN5CS", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "WikiMarkupTransformer", ()=>$4011ad83704160d6$export$caaa00407b56b900);
    $parcel$export(module.exports, "default", ()=>$4011ad83704160d6$export$2e2bcd8739ae039);
    var $kOFhM;
    var $lxtC7;
    var $djcbG;
    var $bOMPB;
    class $4011ad83704160d6$export$caaa00407b56b900 {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema)){
            this.schema = schema;
        }
        sanitizeWikiMarkup(wikiMarkup) {
            return wikiMarkup.replace(/\0/g, '');
        }
        encode(node, context) {
            const wikiMarkup = (0, (0, parcelRequire("lxtC7")).encode)(node, $4011ad83704160d6$var$normalizeContextObject(context));
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            return sanitizedWikiMarkup;
        }
        parse(wikiMarkup, context) {
            const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
            const tree = new (0, (0, parcelRequire("djcbG")).default)(this.schema, sanitizedWikiMarkup);
            return tree.getProseMirrorModel(this.buildContext($4011ad83704160d6$var$normalizeContextObject(context)));
        }
        buildContext(context) {
            return context ? {
                ...context,
                issueKeyRegex: context.conversion ? (0, (0, parcelRequire("bOMPB")).buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
            } : {};
        }
    }
    const $4011ad83704160d6$var$normalizeContextObject = (context)=>{
        if (!context || !context.conversion || !context.conversion.mentionConversion) return context;
        const mentionConversion = {};
        for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
        context.conversion.mentionConversion = mentionConversion;
        return context;
    };
    var $4011ad83704160d6$export$2e2bcd8739ae039 = $4011ad83704160d6$export$caaa00407b56b900;
});
parcelRegister("lxtC7", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$f10f1fd2bcfd2732$export$c564cdbbe6da493);
    var $03QYI;
    var $6ises;
    var $hgytR;
    var $b6sEJ;
    var $73kPn;
    var $1B6CN;
    var $8UMD2;
    var $fIzNZ;
    var $eTlm6;
    var $6obXI;
    var $h9tzi;
    var $abXFq;
    var $flJtr;
    var $czgKo;
    var $acqkf;
    var $1Nefo;
    var $69N10;
    var $12A17;
    var $bsbI5;
    const $f10f1fd2bcfd2732$var$nodeEncoderMapping = {
        blockquote: (0, parcelRequire("03QYI")).blockquote,
        bulletList: (0, parcelRequire("6ises")).bulletList,
        taskList: (0, parcelRequire("hgytR")).taskList,
        decisionList: (0, parcelRequire("b6sEJ")).decisionList,
        codeBlock: (0, parcelRequire("73kPn")).codeBlock,
        doc: (0, parcelRequire("1B6CN")).doc,
        heading: (0, parcelRequire("fIzNZ")).heading,
        caption: (0, parcelRequire("bsbI5")).caption,
        mediaGroup: (0, parcelRequire("eTlm6")).mediaGroup,
        mediaInline: (0, parcelRequire("6obXI")).mediaInline,
        mediaSingle: (0, (0, parcelRequire("eTlm6")).mediaGroup),
        orderedList: (0, parcelRequire("h9tzi")).orderedList,
        panel: (0, parcelRequire("abXFq")).panel,
        paragraph: (0, parcelRequire("flJtr")).paragraph,
        rule: (0, parcelRequire("czgKo")).rule,
        table: (0, parcelRequire("acqkf")).table,
        blockCard: (0, parcelRequire("69N10")).blockCard,
        embedCard: (0, parcelRequire("12A17")).embedCard,
        expand: (0, parcelRequire("8UMD2")).expand
    };
    function $f10f1fd2bcfd2732$export$c564cdbbe6da493(node, context) {
        const encoder = $f10f1fd2bcfd2732$var$nodeEncoderMapping[node.type.name];
        try {
            if (encoder) return encoder(node, {
                context: context
            });
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        } catch (err) {
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        }
    }
});
parcelRegister("03QYI", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$f393e710d4117486$export$67dc04e652a298ca);
    var $lxtC7;
    const $f393e710d4117486$export$67dc04e652a298ca = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return `{quote}${result.join('\n\n')}{quote}`;
    };
});
parcelRegister("6ises", function(module, exports) {
    $parcel$export(module.exports, "bulletList", ()=>$92e38ddcaccbcaf0$export$a140c94e5ea26bee);
    var $bxtEu;
    const $92e38ddcaccbcaf0$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("bxtEu")).listItem)(item, '*', context));
        });
        return result.join('\n');
    };
});
parcelRegister("bxtEu", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$b39a87ae4fdec39c$export$76c7e83ecc9cdf05);
    var $lxtC7;
    var $flJtr;
    var $1Nefo;
    var $73kPn;
    var $eTlm6;
    var $6obXI;
    const $b39a87ae4fdec39c$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
        const result = [];
        let contentBuffer = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'paragraph':
                    contentBuffer.push((0, (0, parcelRequire("flJtr")).paragraph)(n, {
                        context: context
                    }));
                    break;
                case 'bulletList':
                case 'orderedList':
                    {
                        if (contentBuffer.length) {
                            result.push(`${prefix} ${contentBuffer.join('\n')}`);
                            contentBuffer = [];
                        }
                        const nestedList = (0, (0, parcelRequire("lxtC7")).encode)(n, context).split('\n').map((line)=>{
                            if ([
                                '#',
                                '*'
                            ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                            return line;
                        }).join('\n');
                        result.push(nestedList);
                        break;
                    }
                case 'codeBlock':
                    contentBuffer.push((0, (0, parcelRequire("73kPn")).codeBlock)(n));
                    break;
                case 'mediaInline':
                    contentBuffer.push((0, (0, parcelRequire("6obXI")).mediaInline)(n, {
                        context: context
                    }));
                    break;
                case 'mediaSingle':
                    contentBuffer.push((0, (0, parcelRequire("eTlm6")).mediaGroup)(n, {
                        context: context
                    }));
                    break;
                default:
                    contentBuffer.push((0, (0, parcelRequire("1Nefo")).unknown)(n));
            }
        });
        if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
        return result.join('\n');
    };
});
parcelRegister("flJtr", function(module, exports) {
    $parcel$export(module.exports, "paragraph", ()=>$3fb83d21e304518d$export$9c206ddddb32a9b);
    var $bK2QZ;
    const $3fb83d21e304518d$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("bK2QZ", function(module, exports) {
    $parcel$export(module.exports, "inlines", ()=>$d36b73d9ad63ab63$export$96c94bfc00b85760);
    var $91ILy;
    var $e34Iq;
    var $6obXI;
    var $7GCbZ;
    var $6ayzl;
    var $5IuwX;
    var $1HDja;
    var $1Nefo;
    var $c08Yp;
    const $d36b73d9ad63ab63$var$inlinesEncoderMapping = {
        emoji: (0, parcelRequire("91ILy")).emoji,
        hardBreak: (0, parcelRequire("e34Iq")).hardBreak,
        mediaInline: (0, parcelRequire("6obXI")).mediaInline,
        mention: (0, parcelRequire("7GCbZ")).mention,
        text: (0, parcelRequire("6ayzl")).text,
        inlineCard: (0, parcelRequire("5IuwX")).inlineCard,
        status: (0, parcelRequire("1HDja")).status,
        date: (0, parcelRequire("c08Yp")).date
    };
    const $d36b73d9ad63ab63$export$96c94bfc00b85760 = (node, opts)=>{
        const encoder = $d36b73d9ad63ab63$var$inlinesEncoderMapping[node.type.name];
        if (encoder) return encoder(node, opts);
        return (0, (0, parcelRequire("1Nefo")).unknown)(node);
    };
});
parcelRegister("91ILy", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$15d1256cf1644afa$export$a19185d1233fc4b2);
    var $g5UJK;
    var $1Nefo;
    const $15d1256cf1644afa$export$a19185d1233fc4b2 = (node)=>{
        const value = (0, (0, parcelRequire("g5UJK")).mapping)[node.attrs.id];
        if (value) return value;
        if (node.attrs.shortName) return node.attrs.shortName;
        return (0, (0, parcelRequire("1Nefo")).unknown)(node);
    };
});
parcelRegister("g5UJK", function(module, exports) {
    $parcel$export(module.exports, "mapping", ()=>$c03ab45b5b0f3a2b$export$83e1f26587c4acd2);
    const $c03ab45b5b0f3a2b$export$83e1f26587c4acd2 = {
        '1f600': "\uD83D\uDE00",
        '1f603': "\uD83D\uDE03",
        '1f604': "\uD83D\uDE04",
        '1f601': "\uD83D\uDE01",
        '1f606': "\uD83D\uDE06",
        '1f605': "\uD83D\uDE05",
        '1f602': "\uD83D\uDE02",
        '1f923': "\uD83E\uDD23",
        '263a': "\u263A\uFE0F",
        '1f60a': "\uD83D\uDE0A",
        '1f607': "\uD83D\uDE07",
        '1f642': "\uD83D\uDE42",
        '1f643': "\uD83D\uDE43",
        '1f609': "\uD83D\uDE09",
        '1f60c': "\uD83D\uDE0C",
        '1f60d': "\uD83D\uDE0D",
        '1f618': "\uD83D\uDE18",
        '1f617': "\uD83D\uDE17",
        '1f619': "\uD83D\uDE19",
        '1f61a': "\uD83D\uDE1A",
        '1f60b': "\uD83D\uDE0B",
        '1f61c': "\uD83D\uDE1C",
        '1f61d': "\uD83D\uDE1D",
        '1f61b': "\uD83D\uDE1B",
        '1f911': "\uD83E\uDD11",
        '1f917': "\uD83E\uDD17",
        '1f913': "\uD83E\uDD13",
        '1f60e': "\uD83D\uDE0E",
        '1f921': "\uD83E\uDD21",
        '1f920': "\uD83E\uDD20",
        '1f60f': "\uD83D\uDE0F",
        '1f612': "\uD83D\uDE12",
        '1f61e': "\uD83D\uDE1E",
        '1f614': "\uD83D\uDE14",
        '1f61f': "\uD83D\uDE1F",
        '1f615': "\uD83D\uDE15",
        '1f641': "\uD83D\uDE41",
        '2639': "\u2639\uFE0F",
        '1f623': "\uD83D\uDE23",
        '1f616': "\uD83D\uDE16",
        '1f62b': "\uD83D\uDE2B",
        '1f629': "\uD83D\uDE29",
        '1f624': "\uD83D\uDE24",
        '1f620': "\uD83D\uDE20",
        '1f621': "\uD83D\uDE21",
        '1f636': "\uD83D\uDE36",
        '1f610': "\uD83D\uDE10",
        '1f611': "\uD83D\uDE11",
        '1f62f': "\uD83D\uDE2F",
        '1f626': "\uD83D\uDE26",
        '1f627': "\uD83D\uDE27",
        '1f62e': "\uD83D\uDE2E",
        '1f632': "\uD83D\uDE32",
        '1f635': "\uD83D\uDE35",
        '1f633': "\uD83D\uDE33",
        '1f631': "\uD83D\uDE31",
        '1f628': "\uD83D\uDE28",
        '1f630': "\uD83D\uDE30",
        '1f622': "\uD83D\uDE22",
        '1f625': "\uD83D\uDE25",
        '1f924': "\uD83E\uDD24",
        '1f62d': "\uD83D\uDE2D",
        '1f613': "\uD83D\uDE13",
        '1f62a': "\uD83D\uDE2A",
        '1f634': "\uD83D\uDE34",
        '1f644': "\uD83D\uDE44",
        '1f914': "\uD83E\uDD14",
        '1f925': "\uD83E\uDD25",
        '1f62c': "\uD83D\uDE2C",
        '1f910': "\uD83E\uDD10",
        '1f922': "\uD83E\uDD22",
        '1f927': "\uD83E\uDD27",
        '1f637': "\uD83D\uDE37",
        '1f912': "\uD83E\uDD12",
        '1f915': "\uD83E\uDD15",
        '1f608': "\uD83D\uDE08",
        '1f47f': "\uD83D\uDC7F",
        '1f479': "\uD83D\uDC79",
        '1f47a': "\uD83D\uDC7A",
        '1f4a9': "\uD83D\uDCA9",
        '1f47b': "\uD83D\uDC7B",
        '1f480': "\uD83D\uDC80",
        '2620': "\u2620\uFE0F",
        '1f47d': "\uD83D\uDC7D",
        '1f47e': "\uD83D\uDC7E",
        '1f916': "\uD83E\uDD16",
        '1f383': "\uD83C\uDF83",
        '1f63a': "\uD83D\uDE3A",
        '1f638': "\uD83D\uDE38",
        '1f639': "\uD83D\uDE39",
        '1f63b': "\uD83D\uDE3B",
        '1f63c': "\uD83D\uDE3C",
        '1f63d': "\uD83D\uDE3D",
        '1f640': "\uD83D\uDE40",
        '1f63f': "\uD83D\uDE3F",
        '1f63e': "\uD83D\uDE3E",
        '1f450': "\uD83D\uDC50",
        '1f64c': "\uD83D\uDE4C",
        '1f44f': "\uD83D\uDC4F",
        '1f64f': "\uD83D\uDE4F",
        '1f91d': "\uD83E\uDD1D",
        '1f44d': "\uD83D\uDC4D",
        '1f44e': "\uD83D\uDC4E",
        '1f44a': "\uD83D\uDC4A",
        '270a': "\u270A",
        '1f91b': "\uD83E\uDD1B",
        '1f91c': "\uD83E\uDD1C",
        '1f91e': "\uD83E\uDD1E",
        '270c': "\u270C\uFE0F",
        '1f918': "\uD83E\uDD18",
        '1f44c': "\uD83D\uDC4C",
        '1f448': "\uD83D\uDC48",
        '1f449': "\uD83D\uDC49",
        '1f446': "\uD83D\uDC46",
        '1f447': "\uD83D\uDC47",
        '261d': "\u261D\uFE0F",
        '270b': "\u270B",
        '1f91a': "\uD83E\uDD1A",
        '1f590': "\uD83D\uDD90\uFE0F",
        '1f596': "\uD83D\uDD96",
        '1f44b': "\uD83D\uDC4B",
        '1f919': "\uD83E\uDD19",
        '1f4aa': "\uD83D\uDCAA",
        '1f595': "\uD83D\uDD95",
        '270d': "\u270D\uFE0F",
        '1f933': "\uD83E\uDD33",
        '1f485': "\uD83D\uDC85",
        '1f48d': "\uD83D\uDC8D",
        '1f484': "\uD83D\uDC84",
        '1f48b': "\uD83D\uDC8B",
        '1f444': "\uD83D\uDC44",
        '1f445': "\uD83D\uDC45",
        '1f442': "\uD83D\uDC42",
        '1f443': "\uD83D\uDC43",
        '1f463': "\uD83D\uDC63",
        '1f441': "\uD83D\uDC41\uFE0F",
        '1f440': "\uD83D\uDC40",
        '1f5e3': "\uD83D\uDDE3\uFE0F",
        '1f464': "\uD83D\uDC64",
        '1f465': "\uD83D\uDC65",
        '1f476': "\uD83D\uDC76",
        '1f466': "\uD83D\uDC66",
        '1f467': "\uD83D\uDC67",
        '1f468': "\uD83D\uDC68",
        '1f469': "\uD83D\uDC69",
        '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
        '1f471': "\uD83D\uDC71",
        '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
        '1f474': "\uD83D\uDC74",
        '1f475': "\uD83D\uDC75",
        '1f472': "\uD83D\uDC72",
        '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
        '1f473': "\uD83D\uDC73",
        '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
        '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
        '1f46e': "\uD83D\uDC6E",
        '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
        '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
        '1f477': "\uD83D\uDC77",
        '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
        '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
        '1f482': "\uD83D\uDC82",
        '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
        '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
        '1f575': "\uD83D\uDD75\uFE0F",
        '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
        '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
        '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
        '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
        '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
        '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
        '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
        '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
        '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
        '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
        '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
        '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
        '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
        '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
        '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
        '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
        '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
        '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
        '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
        '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
        '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
        '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
        '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
        '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
        '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
        '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
        '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
        '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
        '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
        '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
        '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
        '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
        '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
        '1f936': "\uD83E\uDD36",
        '1f385': "\uD83C\uDF85",
        '1f478': "\uD83D\uDC78",
        '1f934': "\uD83E\uDD34",
        '1f470': "\uD83D\uDC70",
        '1f935': "\uD83E\uDD35",
        '1f47c': "\uD83D\uDC7C",
        '1f930': "\uD83E\uDD30",
        '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
        '1f647': "\uD83D\uDE47",
        '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
        '1f481': "\uD83D\uDC81",
        '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
        '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
        '1f645': "\uD83D\uDE45",
        '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
        '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
        '1f646': "\uD83D\uDE46",
        '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
        '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
        '1f64b': "\uD83D\uDE4B",
        '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
        '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
        '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
        '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
        '1f926': "\uD83E\uDD26",
        '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
        '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
        '1f937': "\uD83E\uDD37",
        '1f64e': "\uD83D\uDE4E",
        '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
        '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
        '1f64d': "\uD83D\uDE4D",
        '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
        '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
        '1f487': "\uD83D\uDC87",
        '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
        '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
        '1f486': "\uD83D\uDC86",
        '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
        '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
        '1f574': "\uD83D\uDD74\uFE0F",
        '1f483': "\uD83D\uDC83",
        '1f57a': "\uD83D\uDD7A",
        '1f46f': "\uD83D\uDC6F",
        '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
        '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
        '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
        '1f6b6': "\uD83D\uDEB6",
        '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
        '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
        '1f3c3': "\uD83C\uDFC3",
        '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
        '1f46b': "\uD83D\uDC6B",
        '1f46d': "\uD83D\uDC6D",
        '1f46c': "\uD83D\uDC6C",
        '1f491': "\uD83D\uDC91",
        '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f48f': "\uD83D\uDC8F",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
        '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f46a': "\uD83D\uDC6A",
        '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
        '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
        '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
        '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
        '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
        '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
        '1f45a': "\uD83D\uDC5A",
        '1f455': "\uD83D\uDC55",
        '1f456': "\uD83D\uDC56",
        '1f454': "\uD83D\uDC54",
        '1f457': "\uD83D\uDC57",
        '1f459': "\uD83D\uDC59",
        '1f458': "\uD83D\uDC58",
        '1f460': "\uD83D\uDC60",
        '1f461': "\uD83D\uDC61",
        '1f462': "\uD83D\uDC62",
        '1f45e': "\uD83D\uDC5E",
        '1f45f': "\uD83D\uDC5F",
        '1f452': "\uD83D\uDC52",
        '1f3a9': "\uD83C\uDFA9",
        '1f393': "\uD83C\uDF93",
        '1f451': "\uD83D\uDC51",
        '26d1': "\u26D1\uFE0F",
        '1f392': "\uD83C\uDF92",
        '1f45d': "\uD83D\uDC5D",
        '1f45b': "\uD83D\uDC5B",
        '1f45c': "\uD83D\uDC5C",
        '1f4bc': "\uD83D\uDCBC",
        '1f453': "\uD83D\uDC53",
        '1f576': "\uD83D\uDD76\uFE0F",
        '1f302': "\uD83C\uDF02",
        '2602': "\u2602\uFE0F",
        '1f436': "\uD83D\uDC36",
        '1f431': "\uD83D\uDC31",
        '1f42d': "\uD83D\uDC2D",
        '1f439': "\uD83D\uDC39",
        '1f430': "\uD83D\uDC30",
        '1f98a': "\uD83E\uDD8A",
        '1f43b': "\uD83D\uDC3B",
        '1f43c': "\uD83D\uDC3C",
        '1f428': "\uD83D\uDC28",
        '1f42f': "\uD83D\uDC2F",
        '1f981': "\uD83E\uDD81",
        '1f42e': "\uD83D\uDC2E",
        '1f437': "\uD83D\uDC37",
        '1f43d': "\uD83D\uDC3D",
        '1f438': "\uD83D\uDC38",
        '1f435': "\uD83D\uDC35",
        '1f648': "\uD83D\uDE48",
        '1f649': "\uD83D\uDE49",
        '1f64a': "\uD83D\uDE4A",
        '1f412': "\uD83D\uDC12",
        '1f414': "\uD83D\uDC14",
        '1f427': "\uD83D\uDC27",
        '1f426': "\uD83D\uDC26",
        '1f424': "\uD83D\uDC24",
        '1f423': "\uD83D\uDC23",
        '1f425': "\uD83D\uDC25",
        '1f986': "\uD83E\uDD86",
        '1f985': "\uD83E\uDD85",
        '1f989': "\uD83E\uDD89",
        '1f987': "\uD83E\uDD87",
        '1f43a': "\uD83D\uDC3A",
        '1f417': "\uD83D\uDC17",
        '1f434': "\uD83D\uDC34",
        '1f984': "\uD83E\uDD84",
        '1f41d': "\uD83D\uDC1D",
        '1f41b': "\uD83D\uDC1B",
        '1f98b': "\uD83E\uDD8B",
        '1f40c': "\uD83D\uDC0C",
        '1f41a': "\uD83D\uDC1A",
        '1f41e': "\uD83D\uDC1E",
        '1f41c': "\uD83D\uDC1C",
        '1f577': "\uD83D\uDD77\uFE0F",
        '1f578': "\uD83D\uDD78\uFE0F",
        '1f422': "\uD83D\uDC22",
        '1f40d': "\uD83D\uDC0D",
        '1f98e': "\uD83E\uDD8E",
        '1f982': "\uD83E\uDD82",
        '1f980': "\uD83E\uDD80",
        '1f991': "\uD83E\uDD91",
        '1f419': "\uD83D\uDC19",
        '1f990': "\uD83E\uDD90",
        '1f420': "\uD83D\uDC20",
        '1f41f': "\uD83D\uDC1F",
        '1f421': "\uD83D\uDC21",
        '1f42c': "\uD83D\uDC2C",
        '1f988': "\uD83E\uDD88",
        '1f433': "\uD83D\uDC33",
        '1f40b': "\uD83D\uDC0B",
        '1f40a': "\uD83D\uDC0A",
        '1f406': "\uD83D\uDC06",
        '1f405': "\uD83D\uDC05",
        '1f403': "\uD83D\uDC03",
        '1f402': "\uD83D\uDC02",
        '1f404': "\uD83D\uDC04",
        '1f98c': "\uD83E\uDD8C",
        '1f42a': "\uD83D\uDC2A",
        '1f42b': "\uD83D\uDC2B",
        '1f418': "\uD83D\uDC18",
        '1f98f': "\uD83E\uDD8F",
        '1f98d': "\uD83E\uDD8D",
        '1f40e': "\uD83D\uDC0E",
        '1f416': "\uD83D\uDC16",
        '1f410': "\uD83D\uDC10",
        '1f40f': "\uD83D\uDC0F",
        '1f411': "\uD83D\uDC11",
        '1f415': "\uD83D\uDC15",
        '1f429': "\uD83D\uDC29",
        '1f408': "\uD83D\uDC08",
        '1f413': "\uD83D\uDC13",
        '1f983': "\uD83E\uDD83",
        '1f54a': "\uD83D\uDD4A\uFE0F",
        '1f407': "\uD83D\uDC07",
        '1f401': "\uD83D\uDC01",
        '1f400': "\uD83D\uDC00",
        '1f43f': "\uD83D\uDC3F\uFE0F",
        '1f43e': "\uD83D\uDC3E",
        '1f409': "\uD83D\uDC09",
        '1f432': "\uD83D\uDC32",
        '1f335': "\uD83C\uDF35",
        '1f384': "\uD83C\uDF84",
        '1f332': "\uD83C\uDF32",
        '1f333': "\uD83C\uDF33",
        '1f334': "\uD83C\uDF34",
        '1f331': "\uD83C\uDF31",
        '1f33f': "\uD83C\uDF3F",
        '2618': "\u2618\uFE0F",
        '1f340': "\uD83C\uDF40",
        '1f38d': "\uD83C\uDF8D",
        '1f38b': "\uD83C\uDF8B",
        '1f343': "\uD83C\uDF43",
        '1f342': "\uD83C\uDF42",
        '1f341': "\uD83C\uDF41",
        '1f344': "\uD83C\uDF44",
        '1f33e': "\uD83C\uDF3E",
        '1f490': "\uD83D\uDC90",
        '1f337': "\uD83C\uDF37",
        '1f339': "\uD83C\uDF39",
        '1f940': "\uD83E\uDD40",
        '1f33b': "\uD83C\uDF3B",
        '1f33c': "\uD83C\uDF3C",
        '1f338': "\uD83C\uDF38",
        '1f33a': "\uD83C\uDF3A",
        '1f30e': "\uD83C\uDF0E",
        '1f30d': "\uD83C\uDF0D",
        '1f30f': "\uD83C\uDF0F",
        '1f315': "\uD83C\uDF15",
        '1f316': "\uD83C\uDF16",
        '1f317': "\uD83C\uDF17",
        '1f318': "\uD83C\uDF18",
        '1f311': "\uD83C\uDF11",
        '1f312': "\uD83C\uDF12",
        '1f313': "\uD83C\uDF13",
        '1f314': "\uD83C\uDF14",
        '1f31a': "\uD83C\uDF1A",
        '1f31d': "\uD83C\uDF1D",
        '1f31e': "\uD83C\uDF1E",
        '1f31b': "\uD83C\uDF1B",
        '1f31c': "\uD83C\uDF1C",
        '1f319': "\uD83C\uDF19",
        '1f4ab': "\uD83D\uDCAB",
        '2b50': "\u2B50",
        '1f31f': "\uD83C\uDF1F",
        '2728': "\u2728",
        '26a1': "\u26A1",
        '1f525': "\uD83D\uDD25",
        '1f4a5': "\uD83D\uDCA5",
        '2604': "\u2604\uFE0F",
        '2600': "\u2600\uFE0F",
        '1f324': "\uD83C\uDF24\uFE0F",
        '26c5': "\u26C5",
        '1f325': "\uD83C\uDF25\uFE0F",
        '1f326': "\uD83C\uDF26\uFE0F",
        '1f308': "\uD83C\uDF08",
        '2601': "\u2601\uFE0F",
        '1f327': "\uD83C\uDF27\uFE0F",
        '26c8': "\u26C8\uFE0F",
        '1f329': "\uD83C\uDF29\uFE0F",
        '1f328': "\uD83C\uDF28\uFE0F",
        '2603': "\u2603\uFE0F",
        '26c4': "\u26C4",
        '2744': "\u2744\uFE0F",
        '1f32c': "\uD83C\uDF2C\uFE0F",
        '1f4a8': "\uD83D\uDCA8",
        '1f32a': "\uD83C\uDF2A\uFE0F",
        '1f32b': "\uD83C\uDF2B\uFE0F",
        '1f30a': "\uD83C\uDF0A",
        '1f4a7': "\uD83D\uDCA7",
        '1f4a6': "\uD83D\uDCA6",
        '2614': "\u2614",
        '1f992': "\uD83E\uDD92",
        '1f993': "\uD83E\uDD93",
        '1f994': "\uD83E\uDD94",
        '1f995': "\uD83E\uDD95",
        '1f996': "\uD83E\uDD96",
        '1f997': "\uD83E\uDD97",
        '1f34f': "\uD83C\uDF4F",
        '1f34e': "\uD83C\uDF4E",
        '1f350': "\uD83C\uDF50",
        '1f34a': "\uD83C\uDF4A",
        '1f34b': "\uD83C\uDF4B",
        '1f34c': "\uD83C\uDF4C",
        '1f349': "\uD83C\uDF49",
        '1f347': "\uD83C\uDF47",
        '1f353': "\uD83C\uDF53",
        '1f348': "\uD83C\uDF48",
        '1f352': "\uD83C\uDF52",
        '1f351': "\uD83C\uDF51",
        '1f34d': "\uD83C\uDF4D",
        '1f95d': "\uD83E\uDD5D",
        '1f951': "\uD83E\uDD51",
        '1f345': "\uD83C\uDF45",
        '1f346': "\uD83C\uDF46",
        '1f952': "\uD83E\uDD52",
        '1f955': "\uD83E\uDD55",
        '1f33d': "\uD83C\uDF3D",
        '1f336': "\uD83C\uDF36\uFE0F",
        '1f954': "\uD83E\uDD54",
        '1f360': "\uD83C\uDF60",
        '1f330': "\uD83C\uDF30",
        '1f95c': "\uD83E\uDD5C",
        '1f36f': "\uD83C\uDF6F",
        '1f950': "\uD83E\uDD50",
        '1f35e': "\uD83C\uDF5E",
        '1f956': "\uD83E\uDD56",
        '1f9c0': "\uD83E\uDDC0",
        '1f95a': "\uD83E\uDD5A",
        '1f373': "\uD83C\uDF73",
        '1f953': "\uD83E\uDD53",
        '1f95e': "\uD83E\uDD5E",
        '1f364': "\uD83C\uDF64",
        '1f357': "\uD83C\uDF57",
        '1f356': "\uD83C\uDF56",
        '1f355': "\uD83C\uDF55",
        '1f32d': "\uD83C\uDF2D",
        '1f354': "\uD83C\uDF54",
        '1f35f': "\uD83C\uDF5F",
        '1f959': "\uD83E\uDD59",
        '1f32e': "\uD83C\uDF2E",
        '1f32f': "\uD83C\uDF2F",
        '1f957': "\uD83E\uDD57",
        '1f958': "\uD83E\uDD58",
        '1f35d': "\uD83C\uDF5D",
        '1f35c': "\uD83C\uDF5C",
        '1f372': "\uD83C\uDF72",
        '1f365': "\uD83C\uDF65",
        '1f363': "\uD83C\uDF63",
        '1f371': "\uD83C\uDF71",
        '1f35b': "\uD83C\uDF5B",
        '1f359': "\uD83C\uDF59",
        '1f35a': "\uD83C\uDF5A",
        '1f358': "\uD83C\uDF58",
        '1f362': "\uD83C\uDF62",
        '1f361': "\uD83C\uDF61",
        '1f367': "\uD83C\uDF67",
        '1f368': "\uD83C\uDF68",
        '1f366': "\uD83C\uDF66",
        '1f370': "\uD83C\uDF70",
        '1f382': "\uD83C\uDF82",
        '1f36e': "\uD83C\uDF6E",
        '1f36d': "\uD83C\uDF6D",
        '1f36c': "\uD83C\uDF6C",
        '1f36b': "\uD83C\uDF6B",
        '1f37f': "\uD83C\uDF7F",
        '1f369': "\uD83C\uDF69",
        '1f36a': "\uD83C\uDF6A",
        '1f95b': "\uD83E\uDD5B",
        '1f37c': "\uD83C\uDF7C",
        '2615': "\u2615",
        '1f375': "\uD83C\uDF75",
        '1f376': "\uD83C\uDF76",
        '1f37a': "\uD83C\uDF7A",
        '1f37b': "\uD83C\uDF7B",
        '1f942': "\uD83E\uDD42",
        '1f377': "\uD83C\uDF77",
        '1f943': "\uD83E\uDD43",
        '1f378': "\uD83C\uDF78",
        '1f379': "\uD83C\uDF79",
        '1f37e': "\uD83C\uDF7E",
        '1f944': "\uD83E\uDD44",
        '1f374': "\uD83C\uDF74",
        '1f37d': "\uD83C\uDF7D\uFE0F",
        '1f95f': "\uD83E\uDD5F",
        '1f960': "\uD83E\uDD60",
        '1f961': "\uD83E\uDD61",
        '1f962': "\uD83E\uDD62",
        '1f963': "\uD83E\uDD63",
        '1f964': "\uD83E\uDD64",
        '1f965': "\uD83E\uDD65",
        '1f966': "\uD83E\uDD66",
        '1f967': "\uD83E\uDD67",
        '1f968': "\uD83E\uDD68",
        '1f969': "\uD83E\uDD69",
        '1f96a': "\uD83E\uDD6A",
        '1f96b': "\uD83E\uDD6B",
        '26bd': "\u26BD",
        '1f3c0': "\uD83C\uDFC0",
        '1f3c8': "\uD83C\uDFC8",
        '26be': "\u26BE",
        '1f3be': "\uD83C\uDFBE",
        '1f3d0': "\uD83C\uDFD0",
        '1f3c9': "\uD83C\uDFC9",
        '1f3b1': "\uD83C\uDFB1",
        '1f3d3': "\uD83C\uDFD3",
        '1f3f8': "\uD83C\uDFF8",
        '1f945': "\uD83E\uDD45",
        '1f3d2': "\uD83C\uDFD2",
        '1f3d1': "\uD83C\uDFD1",
        '1f3cf': "\uD83C\uDFCF",
        '26f3': "\u26F3",
        '1f3f9': "\uD83C\uDFF9",
        '1f3a3': "\uD83C\uDFA3",
        '1f94a': "\uD83E\uDD4A",
        '1f94b': "\uD83E\uDD4B",
        '26f8': "\u26F8\uFE0F",
        '1f3bf': "\uD83C\uDFBF",
        '26f7': "\u26F7\uFE0F",
        '1f3c2': "\uD83C\uDFC2",
        '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
        '1f3cb': "\uD83C\uDFCB\uFE0F",
        '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
        '1f93a': "\uD83E\uDD3A",
        '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
        '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
        '1f93c': "\uD83E\uDD3C",
        '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
        '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
        '1f938': "\uD83E\uDD38",
        '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
        '26f9': "\u26F9\uFE0F",
        '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
        '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
        '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
        '1f93e': "\uD83E\uDD3E",
        '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
        '1f3cc': "\uD83C\uDFCC\uFE0F",
        '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
        '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
        '1f3c4': "\uD83C\uDFC4",
        '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
        '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
        '1f3ca': "\uD83C\uDFCA",
        '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
        '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
        '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
        '1f93d': "\uD83E\uDD3D",
        '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
        '1f6a3': "\uD83D\uDEA3",
        '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
        '1f3c7': "\uD83C\uDFC7",
        '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
        '1f6b4': "\uD83D\uDEB4",
        '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
        '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
        '1f6b5': "\uD83D\uDEB5",
        '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
        '1f3bd': "\uD83C\uDFBD",
        '1f3c5': "\uD83C\uDFC5",
        '1f396': "\uD83C\uDF96\uFE0F",
        '1f947': "\uD83E\uDD47",
        '1f948': "\uD83E\uDD48",
        '1f949': "\uD83E\uDD49",
        '1f3c6': "\uD83C\uDFC6",
        '1f3f5': "\uD83C\uDFF5\uFE0F",
        '1f397': "\uD83C\uDF97\uFE0F",
        '1f3ab': "\uD83C\uDFAB",
        '1f39f': "\uD83C\uDF9F\uFE0F",
        '1f3aa': "\uD83C\uDFAA",
        '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
        '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
        '1f939': "\uD83E\uDD39",
        '1f3ad': "\uD83C\uDFAD",
        '1f3a8': "\uD83C\uDFA8",
        '1f3ac': "\uD83C\uDFAC",
        '1f3a4': "\uD83C\uDFA4",
        '1f3a7': "\uD83C\uDFA7",
        '1f3bc': "\uD83C\uDFBC",
        '1f3b9': "\uD83C\uDFB9",
        '1f941': "\uD83E\uDD41",
        '1f3b7': "\uD83C\uDFB7",
        '1f3ba': "\uD83C\uDFBA",
        '1f3b8': "\uD83C\uDFB8",
        '1f3bb': "\uD83C\uDFBB",
        '1f3b2': "\uD83C\uDFB2",
        '1f3af': "\uD83C\uDFAF",
        '1f3b3': "\uD83C\uDFB3",
        '1f3ae': "\uD83C\uDFAE",
        '1f3b0': "\uD83C\uDFB0",
        '1f6f7': "\uD83D\uDEF7",
        '1f931': "\uD83E\uDD31",
        '1f94c': "\uD83E\uDD4C",
        '1f9d6': "\uD83E\uDDD6",
        '1f9d7': "\uD83E\uDDD7",
        '1f9d8': "\uD83E\uDDD8",
        '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
        '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
        '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
        '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
        '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
        '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
        '1f697': "\uD83D\uDE97",
        '1f695': "\uD83D\uDE95",
        '1f699': "\uD83D\uDE99",
        '1f68c': "\uD83D\uDE8C",
        '1f68e': "\uD83D\uDE8E",
        '1f3ce': "\uD83C\uDFCE\uFE0F",
        '1f693': "\uD83D\uDE93",
        '1f691': "\uD83D\uDE91",
        '1f692': "\uD83D\uDE92",
        '1f690': "\uD83D\uDE90",
        '1f69a': "\uD83D\uDE9A",
        '1f69b': "\uD83D\uDE9B",
        '1f69c': "\uD83D\uDE9C",
        '1f6f4': "\uD83D\uDEF4",
        '1f6b2': "\uD83D\uDEB2",
        '1f6f5': "\uD83D\uDEF5",
        '1f3cd': "\uD83C\uDFCD\uFE0F",
        '1f6a8': "\uD83D\uDEA8",
        '1f694': "\uD83D\uDE94",
        '1f68d': "\uD83D\uDE8D",
        '1f698': "\uD83D\uDE98",
        '1f696': "\uD83D\uDE96",
        '1f6a1': "\uD83D\uDEA1",
        '1f6a0': "\uD83D\uDEA0",
        '1f69f': "\uD83D\uDE9F",
        '1f683': "\uD83D\uDE83",
        '1f68b': "\uD83D\uDE8B",
        '1f69e': "\uD83D\uDE9E",
        '1f69d': "\uD83D\uDE9D",
        '1f684': "\uD83D\uDE84",
        '1f685': "\uD83D\uDE85",
        '1f688': "\uD83D\uDE88",
        '1f682': "\uD83D\uDE82",
        '1f686': "\uD83D\uDE86",
        '1f687': "\uD83D\uDE87",
        '1f68a': "\uD83D\uDE8A",
        '1f689': "\uD83D\uDE89",
        '1f681': "\uD83D\uDE81",
        '1f6e9': "\uD83D\uDEE9\uFE0F",
        '2708': "\u2708\uFE0F",
        '1f6eb': "\uD83D\uDEEB",
        '1f6ec': "\uD83D\uDEEC",
        '1f680': "\uD83D\uDE80",
        '1f6f0': "\uD83D\uDEF0\uFE0F",
        '1f4ba': "\uD83D\uDCBA",
        '1f6f6': "\uD83D\uDEF6",
        '26f5': "\u26F5",
        '1f6e5': "\uD83D\uDEE5\uFE0F",
        '1f6a4': "\uD83D\uDEA4",
        '1f6f3': "\uD83D\uDEF3\uFE0F",
        '26f4': "\u26F4\uFE0F",
        '1f6a2': "\uD83D\uDEA2",
        '2693': "\u2693",
        '1f6a7': "\uD83D\uDEA7",
        '26fd': "\u26FD",
        '1f68f': "\uD83D\uDE8F",
        '1f6a6': "\uD83D\uDEA6",
        '1f6a5': "\uD83D\uDEA5",
        '1f5fa': "\uD83D\uDDFA\uFE0F",
        '1f5ff': "\uD83D\uDDFF",
        '1f5fd': "\uD83D\uDDFD",
        '26f2': "\u26F2",
        '1f5fc': "\uD83D\uDDFC",
        '1f3f0': "\uD83C\uDFF0",
        '1f3ef': "\uD83C\uDFEF",
        '1f3df': "\uD83C\uDFDF\uFE0F",
        '1f3a1': "\uD83C\uDFA1",
        '1f3a2': "\uD83C\uDFA2",
        '1f3a0': "\uD83C\uDFA0",
        '26f1': "\u26F1\uFE0F",
        '1f3d6': "\uD83C\uDFD6\uFE0F",
        '1f3dd': "\uD83C\uDFDD\uFE0F",
        '26f0': "\u26F0\uFE0F",
        '1f3d4': "\uD83C\uDFD4\uFE0F",
        '1f5fb': "\uD83D\uDDFB",
        '1f30b': "\uD83C\uDF0B",
        '1f3dc': "\uD83C\uDFDC\uFE0F",
        '1f3d5': "\uD83C\uDFD5\uFE0F",
        '26fa': "\u26FA",
        '1f6e4': "\uD83D\uDEE4\uFE0F",
        '1f6e3': "\uD83D\uDEE3\uFE0F",
        '1f3d7': "\uD83C\uDFD7\uFE0F",
        '1f3ed': "\uD83C\uDFED",
        '1f3e0': "\uD83C\uDFE0",
        '1f3e1': "\uD83C\uDFE1",
        '1f3d8': "\uD83C\uDFD8\uFE0F",
        '1f3da': "\uD83C\uDFDA\uFE0F",
        '1f3e2': "\uD83C\uDFE2",
        '1f3ec': "\uD83C\uDFEC",
        '1f3e3': "\uD83C\uDFE3",
        '1f3e4': "\uD83C\uDFE4",
        '1f3e5': "\uD83C\uDFE5",
        '1f3e6': "\uD83C\uDFE6",
        '1f3e8': "\uD83C\uDFE8",
        '1f3ea': "\uD83C\uDFEA",
        '1f3eb': "\uD83C\uDFEB",
        '1f3e9': "\uD83C\uDFE9",
        '1f492': "\uD83D\uDC92",
        '1f3db': "\uD83C\uDFDB\uFE0F",
        '26ea': "\u26EA",
        '1f54c': "\uD83D\uDD4C",
        '1f54d': "\uD83D\uDD4D",
        '1f54b': "\uD83D\uDD4B",
        '26e9': "\u26E9\uFE0F",
        '1f5fe': "\uD83D\uDDFE",
        '1f391': "\uD83C\uDF91",
        '1f3de': "\uD83C\uDFDE\uFE0F",
        '1f305': "\uD83C\uDF05",
        '1f304': "\uD83C\uDF04",
        '1f320': "\uD83C\uDF20",
        '1f387': "\uD83C\uDF87",
        '1f386': "\uD83C\uDF86",
        '1f307': "\uD83C\uDF07",
        '1f306': "\uD83C\uDF06",
        '1f3d9': "\uD83C\uDFD9\uFE0F",
        '1f303': "\uD83C\uDF03",
        '1f30c': "\uD83C\uDF0C",
        '1f309': "\uD83C\uDF09",
        '1f301': "\uD83C\uDF01",
        '1f6f8': "\uD83D\uDEF8",
        '231a': "\u231A",
        '1f4f1': "\uD83D\uDCF1",
        '1f4f2': "\uD83D\uDCF2",
        '1f4bb': "\uD83D\uDCBB",
        '2328': "\u2328\uFE0F",
        '1f5a5': "\uD83D\uDDA5\uFE0F",
        '1f5a8': "\uD83D\uDDA8\uFE0F",
        '1f5b1': "\uD83D\uDDB1\uFE0F",
        '1f5b2': "\uD83D\uDDB2\uFE0F",
        '1f579': "\uD83D\uDD79\uFE0F",
        '1f5dc': "\uD83D\uDDDC\uFE0F",
        '1f4bd': "\uD83D\uDCBD",
        '1f4be': "\uD83D\uDCBE",
        '1f4bf': "\uD83D\uDCBF",
        '1f4c0': "\uD83D\uDCC0",
        '1f4fc': "\uD83D\uDCFC",
        '1f4f7': "\uD83D\uDCF7",
        '1f4f8': "\uD83D\uDCF8",
        '1f4f9': "\uD83D\uDCF9",
        '1f3a5': "\uD83C\uDFA5",
        '1f4fd': "\uD83D\uDCFD\uFE0F",
        '1f39e': "\uD83C\uDF9E\uFE0F",
        '1f4de': "\uD83D\uDCDE",
        '260e': "\u260E\uFE0F",
        '1f4df': "\uD83D\uDCDF",
        '1f4e0': "\uD83D\uDCE0",
        '1f4fa': "\uD83D\uDCFA",
        '1f4fb': "\uD83D\uDCFB",
        '1f399': "\uD83C\uDF99\uFE0F",
        '1f39a': "\uD83C\uDF9A\uFE0F",
        '1f39b': "\uD83C\uDF9B\uFE0F",
        '23f1': "\u23F1\uFE0F",
        '23f2': "\u23F2\uFE0F",
        '23f0': "\u23F0",
        '1f570': "\uD83D\uDD70\uFE0F",
        '231b': "\u231B",
        '23f3': "\u23F3",
        '1f4e1': "\uD83D\uDCE1",
        '1f50b': "\uD83D\uDD0B",
        '1f50c': "\uD83D\uDD0C",
        '1f4a1': "\uD83D\uDCA1",
        '1f526': "\uD83D\uDD26",
        '1f56f': "\uD83D\uDD6F\uFE0F",
        '1f5d1': "\uD83D\uDDD1\uFE0F",
        '1f6e2': "\uD83D\uDEE2\uFE0F",
        '1f4b8': "\uD83D\uDCB8",
        '1f4b5': "\uD83D\uDCB5",
        '1f4b4': "\uD83D\uDCB4",
        '1f4b6': "\uD83D\uDCB6",
        '1f4b7': "\uD83D\uDCB7",
        '1f4b0': "\uD83D\uDCB0",
        '1f4b3': "\uD83D\uDCB3",
        '1f48e': "\uD83D\uDC8E",
        '2696': "\u2696\uFE0F",
        '1f527': "\uD83D\uDD27",
        '1f528': "\uD83D\uDD28",
        '2692': "\u2692\uFE0F",
        '1f6e0': "\uD83D\uDEE0\uFE0F",
        '26cf': "\u26CF\uFE0F",
        '1f529': "\uD83D\uDD29",
        '2699': "\u2699\uFE0F",
        '26d3': "\u26D3\uFE0F",
        '1f52b': "\uD83D\uDD2B",
        '1f4a3': "\uD83D\uDCA3",
        '1f52a': "\uD83D\uDD2A",
        '1f5e1': "\uD83D\uDDE1\uFE0F",
        '2694': "\u2694\uFE0F",
        '1f6e1': "\uD83D\uDEE1\uFE0F",
        '1f6ac': "\uD83D\uDEAC",
        '26b0': "\u26B0\uFE0F",
        '26b1': "\u26B1\uFE0F",
        '1f3fa': "\uD83C\uDFFA",
        '1f52e': "\uD83D\uDD2E",
        '1f4ff': "\uD83D\uDCFF",
        '1f488': "\uD83D\uDC88",
        '2697': "\u2697\uFE0F",
        '1f52d': "\uD83D\uDD2D",
        '1f52c': "\uD83D\uDD2C",
        '1f573': "\uD83D\uDD73\uFE0F",
        '1f48a': "\uD83D\uDC8A",
        '1f489': "\uD83D\uDC89",
        '1f321': "\uD83C\uDF21\uFE0F",
        '1f6bd': "\uD83D\uDEBD",
        '1f6b0': "\uD83D\uDEB0",
        '1f6bf': "\uD83D\uDEBF",
        '1f6c1': "\uD83D\uDEC1",
        '1f6c0': "\uD83D\uDEC0",
        '1f6ce': "\uD83D\uDECE\uFE0F",
        '1f511': "\uD83D\uDD11",
        '1f5dd': "\uD83D\uDDDD\uFE0F",
        '1f6aa': "\uD83D\uDEAA",
        '1f6cb': "\uD83D\uDECB\uFE0F",
        '1f6cf': "\uD83D\uDECF\uFE0F",
        '1f6cc': "\uD83D\uDECC",
        '1f5bc': "\uD83D\uDDBC\uFE0F",
        '1f6cd': "\uD83D\uDECD\uFE0F",
        '1f6d2': "\uD83D\uDED2",
        '1f381': "\uD83C\uDF81",
        '1f388': "\uD83C\uDF88",
        '1f38f': "\uD83C\uDF8F",
        '1f380': "\uD83C\uDF80",
        '1f38a': "\uD83C\uDF8A",
        '1f389': "\uD83C\uDF89",
        '1f38e': "\uD83C\uDF8E",
        '1f3ee': "\uD83C\uDFEE",
        '1f390': "\uD83C\uDF90",
        '2709': "\u2709\uFE0F",
        '1f4e9': "\uD83D\uDCE9",
        '1f4e8': "\uD83D\uDCE8",
        '1f4e7': "\uD83D\uDCE7",
        '1f48c': "\uD83D\uDC8C",
        '1f4e5': "\uD83D\uDCE5",
        '1f4e4': "\uD83D\uDCE4",
        '1f4e6': "\uD83D\uDCE6",
        '1f3f7': "\uD83C\uDFF7\uFE0F",
        '1f4ea': "\uD83D\uDCEA",
        '1f4eb': "\uD83D\uDCEB",
        '1f4ec': "\uD83D\uDCEC",
        '1f4ed': "\uD83D\uDCED",
        '1f4ee': "\uD83D\uDCEE",
        '1f4ef': "\uD83D\uDCEF",
        '1f4dc': "\uD83D\uDCDC",
        '1f4c3': "\uD83D\uDCC3",
        '1f4c4': "\uD83D\uDCC4",
        '1f4d1': "\uD83D\uDCD1",
        '1f4ca': "\uD83D\uDCCA",
        '1f4c8': "\uD83D\uDCC8",
        '1f4c9': "\uD83D\uDCC9",
        '1f5d2': "\uD83D\uDDD2\uFE0F",
        '1f5d3': "\uD83D\uDDD3\uFE0F",
        '1f4c6': "\uD83D\uDCC6",
        '1f4c5': "\uD83D\uDCC5",
        '1f4c7': "\uD83D\uDCC7",
        '1f5c3': "\uD83D\uDDC3\uFE0F",
        '1f5f3': "\uD83D\uDDF3\uFE0F",
        '1f5c4': "\uD83D\uDDC4\uFE0F",
        '1f4cb': "\uD83D\uDCCB",
        '1f4c1': "\uD83D\uDCC1",
        '1f4c2': "\uD83D\uDCC2",
        '1f5c2': "\uD83D\uDDC2\uFE0F",
        '1f5de': "\uD83D\uDDDE\uFE0F",
        '1f4f0': "\uD83D\uDCF0",
        '1f4d3': "\uD83D\uDCD3",
        '1f4d4': "\uD83D\uDCD4",
        '1f4d2': "\uD83D\uDCD2",
        '1f4d5': "\uD83D\uDCD5",
        '1f4d7': "\uD83D\uDCD7",
        '1f4d8': "\uD83D\uDCD8",
        '1f4d9': "\uD83D\uDCD9",
        '1f4da': "\uD83D\uDCDA",
        '1f4d6': "\uD83D\uDCD6",
        '1f516': "\uD83D\uDD16",
        '1f517': "\uD83D\uDD17",
        '1f4ce': "\uD83D\uDCCE",
        '1f587': "\uD83D\uDD87\uFE0F",
        '1f4d0': "\uD83D\uDCD0",
        '1f4cf': "\uD83D\uDCCF",
        '1f4cc': "\uD83D\uDCCC",
        '1f4cd': "\uD83D\uDCCD",
        '2702': "\u2702\uFE0F",
        '1f58a': "\uD83D\uDD8A\uFE0F",
        '1f58b': "\uD83D\uDD8B\uFE0F",
        '2712': "\u2712\uFE0F",
        '1f58c': "\uD83D\uDD8C\uFE0F",
        '1f58d': "\uD83D\uDD8D\uFE0F",
        '1f4dd': "\uD83D\uDCDD",
        '270f': "\u270F\uFE0F",
        '1f50d': "\uD83D\uDD0D",
        '1f50e': "\uD83D\uDD0E",
        '1f50f': "\uD83D\uDD0F",
        '1f510': "\uD83D\uDD10",
        '1f512': "\uD83D\uDD12",
        '1f513': "\uD83D\uDD13",
        '1f9e1': "\uD83E\uDDE1",
        '2764': "\u2764\uFE0F",
        '1f49b': "\uD83D\uDC9B",
        '1f49a': "\uD83D\uDC9A",
        '1f499': "\uD83D\uDC99",
        '1f49c': "\uD83D\uDC9C",
        '1f5a4': "\uD83D\uDDA4",
        '1f494': "\uD83D\uDC94",
        '2763': "\u2763\uFE0F",
        '1f495': "\uD83D\uDC95",
        '1f49e': "\uD83D\uDC9E",
        '1f493': "\uD83D\uDC93",
        '1f497': "\uD83D\uDC97",
        '1f496': "\uD83D\uDC96",
        '1f498': "\uD83D\uDC98",
        '1f49d': "\uD83D\uDC9D",
        '1f49f': "\uD83D\uDC9F",
        '262e': "\u262E\uFE0F",
        '271d': "\u271D\uFE0F",
        '262a': "\u262A\uFE0F",
        '1f549': "\uD83D\uDD49\uFE0F",
        '2638': "\u2638\uFE0F",
        '2721': "\u2721\uFE0F",
        '1f52f': "\uD83D\uDD2F",
        '1f54e': "\uD83D\uDD4E",
        '262f': "\u262F\uFE0F",
        '2626': "\u2626\uFE0F",
        '1f6d0': "\uD83D\uDED0",
        '26ce': "\u26CE",
        '2648': "\u2648",
        '2649': "\u2649",
        '264a': "\u264A",
        '264b': "\u264B",
        '264c': "\u264C",
        '264d': "\u264D",
        '264e': "\u264E",
        '264f': "\u264F",
        '2650': "\u2650",
        '2651': "\u2651",
        '2652': "\u2652",
        '2653': "\u2653",
        '1f194': "\uD83C\uDD94",
        '269b': "\u269B\uFE0F",
        '1f251': "\uD83C\uDE51",
        '2622': "\u2622\uFE0F",
        '2623': "\u2623\uFE0F",
        '1f4f4': "\uD83D\uDCF4",
        '1f4f3': "\uD83D\uDCF3",
        '1f236': "\uD83C\uDE36",
        '1f21a': "\uD83C\uDE1A",
        '1f238': "\uD83C\uDE38",
        '1f23a': "\uD83C\uDE3A",
        '1f237': "\uD83C\uDE37\uFE0F",
        '2734': "\u2734\uFE0F",
        '1f19a': "\uD83C\uDD9A",
        '1f4ae': "\uD83D\uDCAE",
        '1f250': "\uD83C\uDE50",
        '3299': "\u3299\uFE0F",
        '3297': "\u3297\uFE0F",
        '1f234': "\uD83C\uDE34",
        '1f235': "\uD83C\uDE35",
        '1f239': "\uD83C\uDE39",
        '1f232': "\uD83C\uDE32",
        '1f170': "\uD83C\uDD70\uFE0F",
        '1f171': "\uD83C\uDD71\uFE0F",
        '1f18e': "\uD83C\uDD8E",
        '1f191': "\uD83C\uDD91",
        '1f17e': "\uD83C\uDD7E\uFE0F",
        '1f198': "\uD83C\uDD98",
        '274c': "\u274C",
        '2b55': "\u2B55",
        '1f6d1': "\uD83D\uDED1",
        '26d4': "\u26D4",
        '1f4db': "\uD83D\uDCDB",
        '1f6ab': "\uD83D\uDEAB",
        '1f4af': "\uD83D\uDCAF",
        '1f4a2': "\uD83D\uDCA2",
        '2668': "\u2668\uFE0F",
        '1f6b7': "\uD83D\uDEB7",
        '1f6af': "\uD83D\uDEAF",
        '1f6b3': "\uD83D\uDEB3",
        '1f6b1': "\uD83D\uDEB1",
        '1f51e': "\uD83D\uDD1E",
        '1f4f5': "\uD83D\uDCF5",
        '1f6ad': "\uD83D\uDEAD",
        '2757': "\u2757",
        '2755': "\u2755",
        '2753': "\u2753",
        '2754': "\u2754",
        '203c': "\u203C\uFE0F",
        '2049': "\u2049\uFE0F",
        '1f505': "\uD83D\uDD05",
        '1f506': "\uD83D\uDD06",
        '303d': "\u303D\uFE0F",
        '26a0': "\u26A0\uFE0F",
        '1f6b8': "\uD83D\uDEB8",
        '1f531': "\uD83D\uDD31",
        '269c': "\u269C\uFE0F",
        '1f530': "\uD83D\uDD30",
        '267b': "\u267B\uFE0F",
        '2705': "\u2705",
        '1f22f': "\uD83C\uDE2F",
        '1f4b9': "\uD83D\uDCB9",
        '2747': "\u2747\uFE0F",
        '2733': "\u2733\uFE0F",
        '274e': "\u274E",
        '1f310': "\uD83C\uDF10",
        '1f4a0': "\uD83D\uDCA0",
        '24c2': "\u24C2\uFE0F",
        '1f300': "\uD83C\uDF00",
        '1f4a4': "\uD83D\uDCA4",
        '1f3e7': "\uD83C\uDFE7",
        '1f6be': "\uD83D\uDEBE",
        '267f': "\u267F",
        '1f17f': "\uD83C\uDD7F\uFE0F",
        '1f233': "\uD83C\uDE33",
        '1f202': "\uD83C\uDE02\uFE0F",
        '1f6c2': "\uD83D\uDEC2",
        '1f6c3': "\uD83D\uDEC3",
        '1f6c4': "\uD83D\uDEC4",
        '1f6c5': "\uD83D\uDEC5",
        '1f6b9': "\uD83D\uDEB9",
        '1f6ba': "\uD83D\uDEBA",
        '1f6bc': "\uD83D\uDEBC",
        '1f6bb': "\uD83D\uDEBB",
        '1f6ae': "\uD83D\uDEAE",
        '1f3a6': "\uD83C\uDFA6",
        '1f4f6': "\uD83D\uDCF6",
        '1f201': "\uD83C\uDE01",
        '1f523': "\uD83D\uDD23",
        '2139': "\u2139\uFE0F",
        '1f524': "\uD83D\uDD24",
        '1f521': "\uD83D\uDD21",
        '1f520': "\uD83D\uDD20",
        '1f196': "\uD83C\uDD96",
        '1f197': "\uD83C\uDD97",
        '1f199': "\uD83C\uDD99",
        '1f192': "\uD83C\uDD92",
        '1f195': "\uD83C\uDD95",
        '1f193': "\uD83C\uDD93",
        '30-20e3': "0\uFE0F\u20E3",
        '31-20e3': "1\uFE0F\u20E3",
        '32-20e3': "2\uFE0F\u20E3",
        '33-20e3': "3\uFE0F\u20E3",
        '34-20e3': "4\uFE0F\u20E3",
        '35-20e3': "5\uFE0F\u20E3",
        '36-20e3': "6\uFE0F\u20E3",
        '37-20e3': "7\uFE0F\u20E3",
        '38-20e3': "8\uFE0F\u20E3",
        '39-20e3': "9\uFE0F\u20E3",
        '1f51f': "\uD83D\uDD1F",
        '1f522': "\uD83D\uDD22",
        '23-20e3': "#\uFE0F\u20E3",
        '2a-20e3': "*\uFE0F\u20E3",
        '25b6': "\u25B6\uFE0F",
        '23f8': "\u23F8\uFE0F",
        '23ef': "\u23EF\uFE0F",
        '23f9': "\u23F9\uFE0F",
        '23fa': "\u23FA\uFE0F",
        '23cf': "\u23CF\uFE0F",
        '23ed': "\u23ED\uFE0F",
        '23ee': "\u23EE\uFE0F",
        '23e9': "\u23E9",
        '23ea': "\u23EA",
        '23eb': "\u23EB",
        '23ec': "\u23EC",
        '25c0': "\u25C0\uFE0F",
        '1f53c': "\uD83D\uDD3C",
        '1f53d': "\uD83D\uDD3D",
        '27a1': "\u27A1\uFE0F",
        '2b05': "\u2B05\uFE0F",
        '2b06': "\u2B06\uFE0F",
        '2b07': "\u2B07\uFE0F",
        '2197': "\u2197\uFE0F",
        '2198': "\u2198\uFE0F",
        '2199': "\u2199\uFE0F",
        '2196': "\u2196\uFE0F",
        '2195': "\u2195\uFE0F",
        '2194': "\u2194\uFE0F",
        '21aa': "\u21AA\uFE0F",
        '21a9': "\u21A9\uFE0F",
        '2934': "\u2934\uFE0F",
        '2935': "\u2935\uFE0F",
        '1f500': "\uD83D\uDD00",
        '1f501': "\uD83D\uDD01",
        '1f502': "\uD83D\uDD02",
        '1f504': "\uD83D\uDD04",
        '1f503': "\uD83D\uDD03",
        '1f3b5': "\uD83C\uDFB5",
        '1f3b6': "\uD83C\uDFB6",
        '2795': "\u2795",
        '2796': "\u2796",
        '2797': "\u2797",
        '2716': "\u2716\uFE0F",
        '1f4b2': "\uD83D\uDCB2",
        '1f4b1': "\uD83D\uDCB1",
        '2122': "\u2122\uFE0F",
        a9: "\xa9\uFE0F",
        ae: "\xae\uFE0F",
        '3030': "\u3030\uFE0F",
        '27b0': "\u27B0",
        '27bf': "\u27BF",
        '1f51a': "\uD83D\uDD1A",
        '1f519': "\uD83D\uDD19",
        '1f51b': "\uD83D\uDD1B",
        '1f51d': "\uD83D\uDD1D",
        '1f51c': "\uD83D\uDD1C",
        '2714': "\u2714\uFE0F",
        '2611': "\u2611\uFE0F",
        '1f518': "\uD83D\uDD18",
        '26aa': "\u26AA",
        '26ab': "\u26AB",
        '1f534': "\uD83D\uDD34",
        '1f535': "\uD83D\uDD35",
        '1f53a': "\uD83D\uDD3A",
        '1f53b': "\uD83D\uDD3B",
        '1f538': "\uD83D\uDD38",
        '1f539': "\uD83D\uDD39",
        '1f536': "\uD83D\uDD36",
        '1f537': "\uD83D\uDD37",
        '1f533': "\uD83D\uDD33",
        '1f532': "\uD83D\uDD32",
        '25aa': "\u25AA\uFE0F",
        '25ab': "\u25AB\uFE0F",
        '25fe': "\u25FE",
        '25fd': "\u25FD",
        '25fc': "\u25FC\uFE0F",
        '25fb': "\u25FB\uFE0F",
        '2b1b': "\u2B1B",
        '2b1c': "\u2B1C",
        '1f508': "\uD83D\uDD08",
        '1f507': "\uD83D\uDD07",
        '1f509': "\uD83D\uDD09",
        '1f50a': "\uD83D\uDD0A",
        '1f514': "\uD83D\uDD14",
        '1f515': "\uD83D\uDD15",
        '1f4e3': "\uD83D\uDCE3",
        '1f4e2': "\uD83D\uDCE2",
        '1f5e8': "\uD83D\uDDE8\uFE0F",
        '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
        '1f4ac': "\uD83D\uDCAC",
        '1f4ad': "\uD83D\uDCAD",
        '1f5ef': "\uD83D\uDDEF\uFE0F",
        '2660': "\u2660\uFE0F",
        '2663': "\u2663\uFE0F",
        '2665': "\u2665\uFE0F",
        '2666': "\u2666\uFE0F",
        '1f0cf': "\uD83C\uDCCF",
        '1f3b4': "\uD83C\uDFB4",
        '1f004': "\uD83C\uDC04",
        '1f550': "\uD83D\uDD50",
        '1f551': "\uD83D\uDD51",
        '1f552': "\uD83D\uDD52",
        '1f553': "\uD83D\uDD53",
        '1f554': "\uD83D\uDD54",
        '1f555': "\uD83D\uDD55",
        '1f556': "\uD83D\uDD56",
        '1f557': "\uD83D\uDD57",
        '1f558': "\uD83D\uDD58",
        '1f559': "\uD83D\uDD59",
        '1f55a': "\uD83D\uDD5A",
        '1f55b': "\uD83D\uDD5B",
        '1f55c': "\uD83D\uDD5C",
        '1f55d': "\uD83D\uDD5D",
        '1f55e': "\uD83D\uDD5E",
        '1f55f': "\uD83D\uDD5F",
        '1f560': "\uD83D\uDD60",
        '1f561': "\uD83D\uDD61",
        '1f562': "\uD83D\uDD62",
        '1f563': "\uD83D\uDD63",
        '1f564': "\uD83D\uDD64",
        '1f565': "\uD83D\uDD65",
        '1f566': "\uD83D\uDD66",
        '1f567': "\uD83D\uDD67",
        '1f3f3': "\uD83C\uDFF3\uFE0F",
        '1f3f4': "\uD83C\uDFF4",
        '1f3c1': "\uD83C\uDFC1",
        '1f6a9': "\uD83D\uDEA9",
        '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
        '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
        '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
        '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
        '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
        '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
        '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
        '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
        '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
        '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
        '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
        '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
        '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
        '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
        '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
        '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
        '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
        '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
        '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
        '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
        '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
        '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
        '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
        '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
        '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
        '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
        '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
        '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
        '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
        '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
        '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
        '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
        '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
        '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
        '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
        '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
        '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
        '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
        '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
        '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
        '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
        '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
        '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
        '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
        '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
        '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
        '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
        '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
        '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
        '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
        '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
        '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
        '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
        '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
        '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
        '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
        '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
        '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
        '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
        '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
        '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
        '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
        '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
        '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
        '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
        '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
        '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
        '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
        '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
        '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
        '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
        '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
        '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
        '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
        '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
        '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
        '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
        '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
        '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
        '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
        '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
        '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
        '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
        '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
        '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
        '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
        '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
        '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
        '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
        '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
        '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
        '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
        '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
        '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
        '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
        '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
        '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
        '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
        '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
        '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
        '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
        '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
        '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
        '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
        '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
        '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
        '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
        '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
        '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
        '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
        '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
        '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
        '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
        '1f38c': "\uD83C\uDF8C",
        '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
        '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
        '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
        '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
        '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
        '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
        '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
        '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
        '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
        '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
        '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
        '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
        '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
        '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
        '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
        '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
        '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
        '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
        '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
        '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
        '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
        '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
        '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
        '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
        '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
        '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
        '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
        '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
        '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
        '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
        '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
        '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
        '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
        '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
        '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
        '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
        '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
        '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
        '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
        '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
        '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
        '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
        '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
        '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
        '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
        '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
        '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
        '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
        '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
        '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
        '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
        '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
        '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
        '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
        '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
        '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
        '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
        '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
        '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
        '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
        '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
        '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
        '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
        '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
        '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
        '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
        '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
        '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
        '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
        '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
        '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
        '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
        '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
        '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
        '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
        '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
        '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
        '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
        '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
        '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
        '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
        '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
        '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
        '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
        '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
        '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
        '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
        '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
        '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
        '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
        '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
        '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
        '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
        '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
        '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
        '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
        '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
        '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
        '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
        '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
        '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
        '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
        '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
        '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
        '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
        '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
        '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
        '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
        '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
        '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
        '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
        '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
        '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
        '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
        '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
        '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
        '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
        '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
        '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
        '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
        '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
        '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
        '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
        '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
        '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
        '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
        '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
        '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
        '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
        '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
        '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
        '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
        '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
        '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
        '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
        '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
        '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
        '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
        '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
        '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
        '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
        '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
        '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
        '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
        '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
        '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
        '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
        '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
        '1f1ff': "\uD83C\uDDFF",
        '1f1fe': "\uD83C\uDDFE",
        '1f1fd': "\uD83C\uDDFD",
        '1f3fb': "\uD83C\uDFFB",
        '1f3fc': "\uD83C\uDFFC",
        '1f3fd': "\uD83C\uDFFD",
        '1f3fe': "\uD83C\uDFFE",
        '1f3ff': "\uD83C\uDFFF",
        '1f1fc': "\uD83C\uDDFC",
        '1f1fb': "\uD83C\uDDFB",
        '1f1fa': "\uD83C\uDDFA",
        '1f1f9': "\uD83C\uDDF9",
        '1f1f8': "\uD83C\uDDF8",
        '1f1f7': "\uD83C\uDDF7",
        '1f1f6': "\uD83C\uDDF6",
        '1f1f5': "\uD83C\uDDF5",
        '1f1f4': "\uD83C\uDDF4",
        '1f1f3': "\uD83C\uDDF3",
        '1f1f2': "\uD83C\uDDF2",
        '1f1f1': "\uD83C\uDDF1",
        '1f1f0': "\uD83C\uDDF0",
        '1f1ef': "\uD83C\uDDEF",
        '1f1ee': "\uD83C\uDDEE",
        '1f1ed': "\uD83C\uDDED",
        '1f1ec': "\uD83C\uDDEC",
        '1f1eb': "\uD83C\uDDEB",
        '1f1ea': "\uD83C\uDDEA",
        '1f1e9': "\uD83C\uDDE9",
        '1f1e8': "\uD83C\uDDE8",
        '1f1e7': "\uD83C\uDDE7",
        '1f1e6': "\uD83C\uDDE6",
        '2640': "\u2640\uFE0F",
        '2642': "\u2642\uFE0F",
        '2695': "\u2695\uFE0F",
        '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
        '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
        '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
        '1f928': "\uD83E\uDD28",
        '1f929': "\uD83E\uDD29",
        '1f92a': "\uD83E\uDD2A",
        '1f92b': "\uD83E\uDD2B",
        '1f92c': "\uD83E\uDD2C",
        '1f92d': "\uD83E\uDD2D",
        '1f92e': "\uD83E\uDD2E",
        '1f92f': "\uD83E\uDD2F",
        '1f9d0': "\uD83E\uDDD0",
        '1f9d1': "\uD83E\uDDD1",
        '1f9d2': "\uD83E\uDDD2",
        '1f9d3': "\uD83E\uDDD3",
        '1f9d4': "\uD83E\uDDD4",
        '1f9d5': "\uD83E\uDDD5",
        '1f9e0': "\uD83E\uDDE0",
        '1f9e2': "\uD83E\uDDE2",
        '1f9d9': "\uD83E\uDDD9",
        '1f9da': "\uD83E\uDDDA",
        '1f9db': "\uD83E\uDDDB",
        '1f9dc': "\uD83E\uDDDC",
        '1f9dd': "\uD83E\uDDDD",
        '1f9de': "\uD83E\uDDDE",
        '1f9df': "\uD83E\uDDDF",
        '1f9e3': "\uD83E\uDDE3",
        '1f9e4': "\uD83E\uDDE4",
        '1f9e5': "\uD83E\uDDE5",
        '1f9e6': "\uD83E\uDDE6",
        '1f91f': "\uD83E\uDD1F",
        '1f932': "\uD83E\uDD32",
        '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
        '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
        '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
        '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
        '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
        '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
        '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
        '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
        '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
        '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
        '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
        '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
        '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
        '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
        'atlassian-check_mark': '(/)',
        'atlassian-cross_mark': '(x)',
        'atlassian-plus': '(+)',
        'atlassian-minus': '(-)',
        'atlassian-light_bulb_on': '(on)',
        'atlassian-light_bulb_off': '(off)',
        'atlassian-flag_on': '(flag)',
        'atlassian-flag_off': '(flagoff)',
        'atlassian-warning': '(!)',
        'atlassian-question_mark': '(?)',
        'atlassian-info': '(i)',
        'atlassian-yellow_star': '(*y)',
        'atlassian-blue_star': '(*b)',
        'atlassian-green_star': '(*g)',
        'atlassian-red_star': '(*r)'
    };
});
parcelRegister("1Nefo", function(module, exports) {
    $parcel$export(module.exports, "unknown", ()=>$6e7c0aa132a04ffb$export$19282c40b967aec6);
    var $hYNZx;
    const $6e7c0aa132a04ffb$var$jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    const $6e7c0aa132a04ffb$export$19282c40b967aec6 = (node)=>{
        const content = JSON.stringify($6e7c0aa132a04ffb$var$jsonTransformer.encodeNode(node));
        return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
    };
});
parcelRegister("e34Iq", function(module, exports) {
    $parcel$export(module.exports, "hardBreak", ()=>$0b90673427e9e36d$export$371da9dd35aba193);
    const $0b90673427e9e36d$export$371da9dd35aba193 = (_node)=>{
        return '\n';
    };
});
parcelRegister("6obXI", function(module, exports) {
    $parcel$export(module.exports, "mediaInline", ()=>$b266c76290bae2fd$export$38bab695e3f720f1);
    const $b266c76290bae2fd$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
        let fileName;
        fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        return `[^${fileName}]`;
    };
});
parcelRegister("7GCbZ", function(module, exports) {
    $parcel$export(module.exports, "mention", ()=>$276f00c4f54975e4$export$db83999c14438df4);
    const $276f00c4f54975e4$var$PREFIX = 'accountid:';
    const $276f00c4f54975e4$var$UNKNOWN_USER = 'UNKNOWN_USER';
    const $276f00c4f54975e4$var$addPrefix = (content)=>content.toLowerCase().startsWith($276f00c4f54975e4$var$PREFIX) ? content : `${$276f00c4f54975e4$var$PREFIX}${content}`;
    const $276f00c4f54975e4$export$db83999c14438df4 = (node, { context: context } = {})=>{
        if (node.attrs.id === $276f00c4f54975e4$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
        const mentionKey = node.attrs.id.toLowerCase();
        const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $276f00c4f54975e4$var$addPrefix(node.attrs.id);
        return `[~${content}]`;
    };
});
parcelRegister("6ayzl", function(module, exports) {
    $parcel$export(module.exports, "text", ()=>$774ee87c38efef1c$export$6f093cfa640b7166);
    var $cG4PY;
    var $4yZSi;
    var $aDTWq;
    var $gdFeW;
    var $jo5YT;
    var $9fwgI;
    var $eKxrE;
    var $1x55I;
    var $8tKGr;
    const $774ee87c38efef1c$var$markEncoderMapping = new Map([
        [
            'em',
            (0, (0, parcelRequire("gdFeW")).em)
        ],
        [
            'strike',
            (0, (0, parcelRequire("9fwgI")).strike)
        ],
        [
            'strong',
            (0, (0, parcelRequire("eKxrE")).strong)
        ],
        [
            'subsup',
            (0, (0, parcelRequire("1x55I")).subsup)
        ],
        [
            'underline',
            (0, (0, parcelRequire("8tKGr")).underline)
        ],
        [
            'textColor',
            (0, (0, parcelRequire("aDTWq")).textColor)
        ],
        [
            'link',
            (0, (0, parcelRequire("jo5YT")).link)
        ],
        [
            'code',
            (0, (0, parcelRequire("4yZSi")).code)
        ]
    ]);
    const $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN = '(\\[~)';
    const $774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)';
    const $774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])';
    const $774ee87c38efef1c$var$isEscapeNeeded = (node, parent)=>{
        return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
    };
    function $774ee87c38efef1c$var$escapingWikiFormatter(text) {
        const pattern = [
            $774ee87c38efef1c$var$MENTION_ESCAPE_PATTERN,
            ...(0, (0, parcelRequire("cG4PY")).macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
        ].join('|');
        return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($774ee87c38efef1c$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2').replace(new RegExp($774ee87c38efef1c$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
    }
    const $774ee87c38efef1c$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
        let result = $774ee87c38efef1c$var$isEscapeNeeded(node, parent) ? $774ee87c38efef1c$var$escapingWikiFormatter(node.text) : node.text;
        $774ee87c38efef1c$var$markEncoderMapping.forEach((encoder, markName)=>{
            const mark = node.marks.find((m)=>m.type.name === markName);
            if (mark) result = encoder(result, mark.attrs);
        });
        return result;
    };
});
parcelRegister("cG4PY", function(module, exports) {
    $parcel$export(module.exports, "macroKeywordTokenMap", ()=>$87fdd6b952f97dba$export$afcd7edeca61ca93);
    $parcel$export(module.exports, "parseMacroKeyword", ()=>$87fdd6b952f97dba$export$39c29c0b4f759e52);
    $parcel$export(module.exports, "parseOtherKeyword", ()=>$87fdd6b952f97dba$export$ce89e528658ee2ac);
    $parcel$export(module.exports, "parseLeadingKeyword", ()=>$87fdd6b952f97dba$export$68162fc57528b560);
    $parcel$export(module.exports, "parseIssueKeyword", ()=>$87fdd6b952f97dba$export$bcec6d03770b152c);
    var $kSL4h;
    var $ayQVO;
    const $87fdd6b952f97dba$export$afcd7edeca61ca93 = [
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ADF_MACRO,
            regex: /^{adf/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ANCHOR_MACRO,
            regex: /^{anchor/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).CODE_MACRO,
            regex: /^{code/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE_MACRO,
            regex: /^{quote/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).NOFORMAT_MACRO,
            regex: /^{noformat/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).PANEL_MACRO,
            regex: /^{panel/i
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO,
            regex: /^{color/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).LOREM_MACRO,
            regex: /^{loremipsum/i
        }
    ];
    const $87fdd6b952f97dba$var$keywordTokenMap = {
        '[': (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT,
        http: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        ftp: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        jamfselfservice: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        irc: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        mailto: (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
        '\\\\': (0, (0, parcelRequire("kSL4h")).TokenType).FORCE_LINE_BREAK,
        '\r': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '\n': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '\r\n': (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
        '!': (0, (0, parcelRequire("kSL4h")).TokenType).MEDIA,
        '----': (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
        '---': (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
        '--': (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
        '{-}': (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
        '{+}': (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
        '{*}': (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
        '{^}': (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
        '{~}': (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
        '{_}': (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
        '{{{}': (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
        '{??}': (0, (0, parcelRequire("kSL4h")).TokenType).CITATION,
        '-': (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
        '+': (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
        '*': (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
        '^': (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
        '~': (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
        _: (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
        '{{': (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
        '??': (0, (0, parcelRequire("kSL4h")).TokenType).CITATION
    };
    const $87fdd6b952f97dba$var$keywordTokenMapKeys = Object.keys($87fdd6b952f97dba$var$keywordTokenMap);
    function $87fdd6b952f97dba$export$39c29c0b4f759e52(input) {
        for(let i = 0; i < $87fdd6b952f97dba$export$afcd7edeca61ca93.length; i++){
            const keyword = $87fdd6b952f97dba$export$afcd7edeca61ca93[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $87fdd6b952f97dba$export$ce89e528658ee2ac(input) {
        for(let i = 0; i < $87fdd6b952f97dba$var$keywordTokenMapKeys.length; i++){
            if (input.startsWith($87fdd6b952f97dba$var$keywordTokenMapKeys[i])) return {
                type: $87fdd6b952f97dba$var$keywordTokenMap[$87fdd6b952f97dba$var$keywordTokenMapKeys[i]]
            };
        }
        const char = input.charAt(0);
        if ([
            ':',
            '(',
            ';'
        ].indexOf(char) !== -1) return {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).EMOJI
        };
        return null;
    }
    const $87fdd6b952f97dba$var$leadingKeywordTokenMap = [
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE,
            regex: /^bq\./
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).HEADING,
            regex: /^h[1-6]\./
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            regex: /^-{4,5}(\s|$)/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            regex: /^-{3}\s/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            regex: /^-{2}\s/
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            regex: new RegExp(`^([*#]{1,${(0, (0, parcelRequire("ayQVO")).MAX_LIST_DEPTH)}}|-) `)
        },
        {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            regex: /^\|{1,2}/
        }
    ];
    function $87fdd6b952f97dba$export$68162fc57528b560(input) {
        for(let i = 0; i < $87fdd6b952f97dba$var$leadingKeywordTokenMap.length; i++){
            const keyword = $87fdd6b952f97dba$var$leadingKeywordTokenMap[i];
            if (keyword.regex.test(input)) return {
                type: keyword.type
            };
        }
        return null;
    }
    function $87fdd6b952f97dba$export$bcec6d03770b152c(input, issueKeyRegex) {
        if (issueKeyRegex && issueKeyRegex.test(input)) return {
            type: (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        };
        return null;
    }
});
parcelRegister("kSL4h", function(module, exports) {
    $parcel$export(module.exports, "TokenType", ()=>$160d182608400c84$export$f435f793048e7a0f);
    $parcel$export(module.exports, "parseToken", ()=>$160d182608400c84$export$af8f4e8328578827);
    var $4Foyv;
    var $30Un5;
    var $coK8g;
    var $5RdHN;
    var $55t1E;
    var $jor5q;
    var $hZ14o;
    var $6xaH8;
    var $jMpI6;
    var $iDsRr;
    var $7tIdE;
    var $1MGc3;
    var $ayQVO;
    var $kPrK8;
    var $4ZFIG;
    var $91y57;
    var $1Mtv8;
    var $77w3e;
    var $lf0Nr;
    var $4s89q;
    var $ir9MO;
    var $7E14k;
    var $9MeiU;
    var $f50H1;
    var $bSil4;
    var $4Dfwq;
    var $cjZPi;
    var $8tGpW;
    var $lyI5i;
    var $bOMPB;
    var $160d182608400c84$export$f435f793048e7a0f;
    (function(TokenType) {
        TokenType["ADF_MACRO"] = "ADF_MACRO";
        TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
        TokenType["CODE_MACRO"] = "CODE_MACRO";
        TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
        TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
        TokenType["PANEL_MACRO"] = "PANEL_MACRO";
        TokenType["COLOR_MACRO"] = "COLOR_MACRO";
        TokenType["LOREM_MACRO"] = "LOREM_MACRO";
        TokenType["QUOTE"] = "QUOTE";
        TokenType["STRING"] = "STRING";
        TokenType["ISSUE_KEY"] = "ISSUE_KEY";
        TokenType["LINK_FORMAT"] = "LINK_FORMAT";
        TokenType["LINK_TEXT"] = "LINK_TEXT";
        TokenType["MEDIA"] = "MEDIA";
        TokenType["HEADING"] = "HEADING";
        TokenType["LIST"] = "LIST";
        TokenType["TABLE"] = "TABLE";
        TokenType["RULER"] = "RULER";
        TokenType["HARD_BREAK"] = "HARD_BREAK";
        TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
        TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
        TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
        TokenType["STRONG"] = "STRONG";
        TokenType["MONOSPACE"] = "MONOSPACE";
        TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
        TokenType["SUBSCRIPT"] = "SUBSCRIPT";
        TokenType["EMPHASIS"] = "EMPHASIS";
        TokenType["CITATION"] = "CITATION";
        TokenType["DELETED"] = "DELETED";
        TokenType["INSERTED"] = "INSERTED";
        TokenType["EMOJI"] = "EMOJI";
        TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
    })($160d182608400c84$export$f435f793048e7a0f || ($160d182608400c84$export$f435f793048e7a0f = {}));
    const $160d182608400c84$var$tokenToTokenParserMapping = {
        ["DOUBLE_DASH_SYMBOL"]: (0, (0, parcelRequire("55t1E")).doubleDashSymbol),
        ["TRIPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("ir9MO")).tripleDashSymbol),
        ["QUADRUPLE_DASH_SYMBOL"]: (0, (0, parcelRequire("4ZFIG")).quadrupleDashSymbol),
        ["RULER"]: (0, (0, parcelRequire("91y57")).ruler),
        ["STRONG"]: (0, (0, parcelRequire("1Mtv8")).strong),
        ["MONOSPACE"]: (0, (0, parcelRequire("kPrK8")).monospace),
        ["SUPERSCRIPT"]: (0, (0, parcelRequire("lf0Nr")).superscript),
        ["SUBSCRIPT"]: (0, (0, parcelRequire("77w3e")).subscript),
        ["EMPHASIS"]: (0, (0, parcelRequire("hZ14o")).emphasis),
        ["CITATION"]: (0, (0, parcelRequire("coK8g")).citation),
        ["DELETED"]: (0, (0, parcelRequire("5RdHN")).deleted),
        ["INSERTED"]: (0, (0, parcelRequire("iDsRr")).inserted),
        ["HARD_BREAK"]: (0, (0, parcelRequire("6xaH8")).hardbreak),
        ["LINK_FORMAT"]: (0, (0, parcelRequire("7tIdE")).linkFormat),
        ["LINK_TEXT"]: (0, (0, parcelRequire("1MGc3")).linkText),
        ["HEADING"]: (0, (0, parcelRequire("jMpI6")).heading),
        ["MEDIA"]: (0, (0, parcelRequire("4Foyv")).media),
        ["LIST"]: (0, (0, parcelRequire("ayQVO")).list),
        ["QUOTE"]: (0, (0, parcelRequire("30Un5")).blockquote),
        ["TABLE"]: (0, (0, parcelRequire("4s89q")).table),
        ["EMOJI"]: (0, (0, parcelRequire("jor5q")).emoji),
        ["ADF_MACRO"]: (0, (0, parcelRequire("9MeiU")).adfMacro),
        ["ANCHOR_MACRO"]: (0, (0, parcelRequire("f50H1")).anchorMacro),
        ["CODE_MACRO"]: (0, (0, parcelRequire("bSil4")).codeMacro),
        ["QUOTE_MACRO"]: (0, (0, parcelRequire("4Dfwq")).quoteMacro),
        ["NOFORMAT_MACRO"]: (0, (0, parcelRequire("8tGpW")).noformatMacro),
        ["PANEL_MACRO"]: (0, (0, parcelRequire("7E14k")).panelMacro),
        ["COLOR_MACRO"]: (0, (0, parcelRequire("cjZPi")).colorMacro),
        ["FORCE_LINE_BREAK"]: (0, (0, parcelRequire("lyI5i")).forceLineBreak),
        ["ISSUE_KEY"]: (0, (0, parcelRequire("bOMPB")).issueKey)
    };
    function $160d182608400c84$export$af8f4e8328578827(input, type, position, schema, context) {
        const tokenParser = $160d182608400c84$var$tokenToTokenParserMapping[type];
        if (tokenParser) try {
            return tokenParser({
                input: input,
                position: position,
                schema: schema,
                context: context
            });
        } catch (err) {
            if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
            return $160d182608400c84$var$fallback(input, position);
        }
        return $160d182608400c84$var$fallback(input, position);
    }
    function $160d182608400c84$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("4Foyv", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$8b246e16d82e8dde$export$987d49ffe1b0900f);
    var $4V377;
    var $4ZUg7;
    var $eyO0H;
    const $8b246e16d82e8dde$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
        const rawContentProcessor = (raw, length)=>{
            const [rawContent, rawAttrs = ''] = raw.split('|');
            const node = (0, (0, parcelRequire("4V377")).default)(schema, rawContent, (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs, ','), context);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        };
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: '!',
            closing: '!',
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4V377", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2106e5f40786af56$export$2e2bcd8739ae039);
    var $1MGc3;
    const $2106e5f40786af56$var$defaultWidth = 200;
    const $2106e5f40786af56$var$defaultHeight = 183;
    const $2106e5f40786af56$var$clamp = (input, lower, upper)=>{
        if (upper !== undefined) input = input <= upper ? input : upper;
        if (lower !== undefined) input = input >= lower ? input : lower;
        return input;
    };
    function $2106e5f40786af56$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const { link: link } = schema.marks;
        const mediaMarks = [];
        let mediaNodeAttrs = {};
        if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $2106e5f40786af56$var$defaultWidth;
        if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $2106e5f40786af56$var$defaultHeight;
        const mediaSingleAttrs = {
            layout: 'center'
        };
        if (attrs.width && attrs.width.endsWith('%')) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaSingleAttrs.width = $2106e5f40786af56$var$clamp(parsed, 0, 100);
            mediaNodeAttrs = {};
        } else {
            if (attrs.width) {
                const parsed = parseInt(attrs.width, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
            }
            if (attrs.height) {
                const parsed = parseInt(attrs.height, 10);
                if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
            }
        }
        if (attrs.href) {
            const href = attrs.href.replace(/^"(.+)"$/, '$1');
            mediaMarks.push(link.create({
                href: href
            }));
        }
        if (attrs.alt) {
            const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
            mediaNodeAttrs.alt = altText;
        }
        if (filename.match((0, (0, parcelRequire("1MGc3")).LINK_TEXT_REGEXP))) {
            const externalMediaNode = media.createChecked({
                type: 'external',
                url: filename,
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
        } else {
            const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
            const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
            const mediaNode = media.createChecked({
                id: id,
                type: 'file',
                collection: collection || '',
                ...mediaNodeAttrs
            }, undefined, mediaMarks);
            return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
        }
    }
});
parcelRegister("1MGc3", function(module, exports) {
    $parcel$export(module.exports, "LINK_TEXT_REGEXP", ()=>$49f89f13b4b7c481$export$f69d1dce349473aa);
    $parcel$export(module.exports, "linkText", ()=>$49f89f13b4b7c481$export$cb7bcf09a05b7705);
    var $iZOJ9;
    var $iqYHB;
    const $49f89f13b4b7c481$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
    const $49f89f13b4b7c481$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
        let matches = input.substring(position).match($49f89f13b4b7c481$export$f69d1dce349473aa);
        if (!matches) return $49f89f13b4b7c481$var$fallback(input, position);
        const match = $49f89f13b4b7c481$var$trimBadEndChar(matches);
        const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
        const url = (0, (0, parcelRequire("iqYHB")).decode)($49f89f13b4b7c481$var$unescape(match[0]));
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return $49f89f13b4b7c481$var$fallback(input, position);
        const mark = schema.marks.link.create({
            href: url
        });
        const textNode = schema.text(textRepresentation, [
            mark
        ]);
        return {
            type: 'pmnode',
            nodes: [
                textNode
            ],
            length: match[0].length
        };
    };
    function $49f89f13b4b7c481$var$unescape(url) {
        let result = '';
        for(let i = 0; i < url.length; i++){
            const char = url[i];
            if (char !== '\\') {
                result += char;
                continue;
            }
            const nextChar = url[i + 1];
            if (nextChar) {
                result += nextChar;
                i++;
            }
        }
        return result;
    }
    function $49f89f13b4b7c481$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
    function $49f89f13b4b7c481$var$trimBadEndChar(input) {
        return [
            input[0].replace(/[.,>)\];}"\'!]*$/, ''),
            input[1],
            input[2].replace(/[.,>)\];}"\'!]*$/, '')
        ];
    }
});
parcelRegister("iqYHB", function(module, exports) {
    $parcel$export(module.exports, "decode", ()=>$c6b4ec3136742c55$export$2f872c0f2117be69);
    function $c6b4ec3136742c55$export$2f872c0f2117be69(raw) {
        if (typeof URL === 'function') {
            const decoded = new URL(raw);
            if (decoded.href) return decoded.href;
        }
        const anchor = document.createElement('a');
        anchor.href = raw;
        return anchor.href;
    }
});
parcelRegister("4ZUg7", function(module, exports) {
    $parcel$export(module.exports, "parseAttrs", ()=>$972abf9f01734b21$export$e1a9355cfd8f6c64);
    function $972abf9f01734b21$export$e1a9355cfd8f6c64(str, sep = '|') {
        const output = {};
        if (!str) return output;
        const attributesStr = str.split(sep);
        attributesStr.forEach((attributeStr)=>{
            const [key, ...value] = attributeStr.split('=');
            if (!output[key]) output[key] = value.join('=');
        });
        return output;
    }
});
parcelRegister("eyO0H", function(module, exports) {
    $parcel$export(module.exports, "commonFormatter", ()=>$dee2bdf3f1017b16$export$a71d57024d3da1c5);
    var $kSL4h;
    var $7tIdE;
    var $eWAZI;
    var $cG4PY;
    var $kSL4h;
    var $2weJO;
    const $dee2bdf3f1017b16$var$processState = {
        START: 0,
        BUFFER: 1,
        END: 2,
        INLINE_MACRO: 3,
        LINK_FORMAT: 4,
        ESCAPE: 5
    };
    function $dee2bdf3f1017b16$export$a71d57024d3da1c5(input, position, schema, opt) {
        let index = position;
        let state = $dee2bdf3f1017b16$var$processState.START;
        let buffer = [];
        const openingSymbolLength = opt.opening.length;
        const closingSymbolLength = opt.closing.length;
        const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
        const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
        while(index < input.length){
            const char = input.charAt(index);
            const twoChar = input.substr(index, 2);
            const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
            switch(state){
                case $dee2bdf3f1017b16$var$processState.START:
                    {
                        if (position > 0) {
                            const charBeforeOpening = input.charAt(position - 1);
                            if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $dee2bdf3f1017b16$var$fallback(input, index, openingSymbolLength);
                        }
                        const charAfterOpening = input.charAt(index + openingSymbolLength);
                        if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        index += openingSymbolLength;
                        continue;
                    }
                case $dee2bdf3f1017b16$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(index));
                        if (length) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                        if (charsMatchClosingSymbol === opt.closing) {
                            state = $dee2bdf3f1017b16$var$processState.END;
                            continue;
                        } else if (twoChar === '{{') {
                            buffer.push(twoChar);
                            index += 2;
                            continue;
                        } else if (char === '{') {
                            state = $dee2bdf3f1017b16$var$processState.INLINE_MACRO;
                            continue;
                        } else if (char === '[') {
                            state = $dee2bdf3f1017b16$var$processState.LINK_FORMAT;
                            continue;
                        } else if (char === '\\') {
                            state = $dee2bdf3f1017b16$var$processState.ESCAPE;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $dee2bdf3f1017b16$var$processState.END:
                    index += closingSymbolLength;
                    if (buffer.length === 0) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    if (index < input.length) {
                        const charAfterEnd = input.charAt(index);
                        if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                            buffer.push(charsMatchClosingSymbol);
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        }
                    }
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    return opt.rawContentProcessor(buffer.join(''), index - position);
                case $dee2bdf3f1017b16$var$processState.INLINE_MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, {});
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else if (match.type === (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO) {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    }
                case $dee2bdf3f1017b16$var$processState.LINK_FORMAT:
                    {
                        const token = (0, (0, parcelRequire("7tIdE")).linkFormat)({
                            input: input,
                            schema: schema,
                            position: index,
                            context: {}
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            state = $dee2bdf3f1017b16$var$processState.BUFFER;
                            continue;
                        }
                        return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
                    }
                case $dee2bdf3f1017b16$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("2weJO")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $dee2bdf3f1017b16$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        return $dee2bdf3f1017b16$var$fallback(input, position, openingSymbolLength);
    }
    function $dee2bdf3f1017b16$var$fallback(input, position, length) {
        return {
            type: 'text',
            text: input.substr(position, length),
            length: length
        };
    }
});
parcelRegister("7tIdE", function(module, exports) {
    $parcel$export(module.exports, "linkFormat", ()=>$0412731f8f85cc95$export$e1f888a4b6f2ee53);
    var $kSL4h;
    var $29zBb;
    var $9jjzg;
    var $gGleW;
    const $0412731f8f85cc95$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
    const $0412731f8f85cc95$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($0412731f8f85cc95$var$LINK_FORMAT_REGEXP);
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT
        ];
        if (!match) return $0412731f8f85cc95$var$fallback();
        const content = (0, (0, parcelRequire("gGleW")).parseContentLink)(match[1]);
        const resolvedLink = (0, (0, parcelRequire("9jjzg")).resolveLink)(content, schema, context);
        if (resolvedLink) return resolvedLink;
        const nodes = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: match[0]
        });
        return {
            type: 'pmnode',
            nodes: nodes,
            length: match[0].length
        };
    };
    function $0412731f8f85cc95$var$fallback() {
        return {
            type: 'text',
            text: '[',
            length: 1
        };
    }
});
parcelRegister("29zBb", function(module, exports) {
    $parcel$export(module.exports, "parseString", ()=>$e7a948cf285a18ed$export$960addfb9e5a0cde);
    var $04cDS;
    var $cG4PY;
    var $kSL4h;
    var $eWAZI;
    var $2weJO;
    var $20lXC;
    const $e7a948cf285a18ed$var$processState = {
        NEWLINE: 0,
        BUFFER: 1,
        TOKEN: 2,
        ESCAPE: 3
    };
    function $e7a948cf285a18ed$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
        let index = 0;
        let state = $e7a948cf285a18ed$var$processState.NEWLINE;
        let buffer = [];
        let tokenType = (0, (0, parcelRequire("kSL4h")).TokenType).STRING;
        let newLines = [];
        const output = [];
        let inlineNodes = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $e7a948cf285a18ed$var$processState.NEWLINE:
                    {
                        const substring = input.substring(index);
                        const length = (0, (0, parcelRequire("eWAZI")).parseWhitespaceOnly)(substring);
                        if (length) {
                            index += length;
                            if (includeLeadingSpace) buffer.push(char);
                            continue;
                        }
                        const match = (0, (0, parcelRequire("cG4PY")).parseLeadingKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $e7a948cf285a18ed$var$processState.TOKEN;
                            continue;
                        } else {
                            state = $e7a948cf285a18ed$var$processState.BUFFER;
                            continue;
                        }
                    }
                case $e7a948cf285a18ed$var$processState.BUFFER:
                    {
                        const substring = input.substring(index);
                        let match = null;
                        if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring);
                        else match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseOtherKeyword)(substring) || (0, (0, parcelRequire("cG4PY")).parseIssueKeyword)(substring, context.issueKeyRegex);
                        if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                            tokenType = match.type;
                            state = $e7a948cf285a18ed$var$processState.TOKEN;
                            continue;
                        }
                        if (char === '\\') {
                            state = $e7a948cf285a18ed$var$processState.ESCAPE;
                            continue;
                        }
                        buffer.push(char);
                        break;
                    }
                case $e7a948cf285a18ed$var$processState.TOKEN:
                    {
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, tokenType, index, schema, context);
                        if (token.type === 'text') buffer.push(token.text);
                        else if (token.type === 'pmnode') {
                            if (newLines.length >= 2 && (tokenType !== (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK || buffer.length > 0)) {
                                output.push(...(0, (0, parcelRequire("20lXC")).normalizePMNodes)(inlineNodes, schema));
                                inlineNodes = $e7a948cf285a18ed$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                    ...newLines
                                ] : [];
                                newLines = [];
                            }
                            if (inlineNodes.length === 0) newLines = [];
                            if (newLines.length > 0 && $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                                inlineNodes.push(...newLines);
                                newLines = [];
                            }
                            inlineNodes.push(...(0, (0, parcelRequire("04cDS")).createTextNode)(buffer.join(''), schema));
                            if (tokenType === (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK) newLines.push(...token.nodes);
                            else {
                                inlineNodes.push(...token.nodes);
                                if (token.nodes.length > 0) newLines = [];
                            }
                            buffer = [];
                        }
                        index += token.length;
                        if (tokenType === (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK) state = $e7a948cf285a18ed$var$processState.NEWLINE;
                        else state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                case $e7a948cf285a18ed$var$processState.ESCAPE:
                    {
                        const token = (0, (0, parcelRequire("2weJO")).escapeHandler)(input, index);
                        buffer.push(token.text);
                        index += token.length;
                        state = $e7a948cf285a18ed$var$processState.BUFFER;
                        continue;
                    }
                default:
            }
            index++;
        }
        const bufferedStr = buffer.join('');
        if (bufferedStr.length > 0) {
            if (newLines.length >= 2) {
                output.push(...(0, (0, parcelRequire("20lXC")).normalizePMNodes)(inlineNodes, schema));
                inlineNodes = [];
                newLines = [];
            }
            if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
            inlineNodes.push(...(0, (0, parcelRequire("04cDS")).createTextNode)(bufferedStr, schema));
        }
        return [
            ...output,
            ...inlineNodes
        ];
    }
    function $e7a948cf285a18ed$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
        if (currentNodes.length === 0) return false;
        if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
        if (buffer.length === 0) {
            if (nextNodes.length === 0) return false;
            if (nextNodes[0]?.type.name === 'hardBreak') return false;
            if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
        }
        return true;
    }
    function $e7a948cf285a18ed$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
        return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
    }
});
parcelRegister("04cDS", function(module, exports) {
    $parcel$export(module.exports, "createTextNode", ()=>$e67b0538295ca231$export$b2ce9ad90858ed7a);
    function $e67b0538295ca231$export$b2ce9ad90858ed7a(input, schema, marks) {
        if (input === '') return [];
        const node = schema.text(input, marks || []);
        return [
            node
        ];
    }
});
parcelRegister("eWAZI", function(module, exports) {
    $parcel$export(module.exports, "parseNewlineOnly", ()=>$b3a19bb1e901f2d4$export$1b7a83d725c8acf);
    $parcel$export(module.exports, "parseWhitespaceOnly", ()=>$b3a19bb1e901f2d4$export$9c597b035e16623b);
    function $b3a19bb1e901f2d4$export$877995a80ec11782(input) {
        const newlineLength = $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input);
        if (newlineLength) return newlineLength;
        const whitespaceLength = $b3a19bb1e901f2d4$export$9c597b035e16623b(input);
        if (whitespaceLength) return whitespaceLength;
        return 0;
    }
    function $b3a19bb1e901f2d4$export$9c597b035e16623b(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\t' || char === ' ') index++;
        return index;
    }
    function $b3a19bb1e901f2d4$export$1b7a83d725c8acf(input) {
        let index = 0;
        const char = input.charAt(index);
        if (char === '\r') {
            index++;
            if (input.charAt(index) === '\n') index++;
        } else if (char === '\n') index++;
        return index;
    }
});
parcelRegister("2weJO", function(module, exports) {
    $parcel$export(module.exports, "escapeHandler", ()=>$35d0c4c2d3000f41$export$d16e8e6cf9622f9a);
    const $35d0c4c2d3000f41$var$escapedChar = [
        '-',
        '#',
        '*',
        '_',
        '+',
        '?',
        '^',
        '~',
        '|',
        '%',
        '{',
        '}',
        '[',
        ']',
        '(',
        ')',
        '!',
        '@'
    ];
    function $35d0c4c2d3000f41$export$d16e8e6cf9622f9a(input, position) {
        let buffer = [];
        const char = input.charAt(position);
        const prevChar = input.charAt(position - 1);
        const nextChar = input.charAt(position + 1);
        if ($35d0c4c2d3000f41$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') buffer.push(char);
        buffer.push(nextChar);
        return {
            type: 'text',
            text: buffer.join(''),
            length: 2
        };
    }
});
parcelRegister("20lXC", function(module, exports) {
    $parcel$export(module.exports, "normalizePMNodes", ()=>$50669f552f016dd9$export$e21f6b7efdaf8b5d);
    var $4UJvN;
    function $50669f552f016dd9$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
        return [
            $50669f552f016dd9$var$normalizeMediaGroups,
            $50669f552f016dd9$export$2cef2a4c047f9887,
            $50669f552f016dd9$export$cd936b894f116ed8
        ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
    }
    function $50669f552f016dd9$export$2cef2a4c047f9887(nodes, schema, parentNode) {
        const output = [];
        for (const node of nodes)if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') output.push($50669f552f016dd9$var$convertNodeToExpand(node, schema));
        else output.push(node);
        return output;
    }
    function $50669f552f016dd9$export$cd936b894f116ed8(nodes, schema, _parentNode) {
        const output = [];
        let inlineNodeBuffer = [];
        for (const node of nodes){
            if (!node.isBlock) {
                inlineNodeBuffer.push(node);
                continue;
            }
            if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("4UJvN")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
            inlineNodeBuffer = [];
            output.push(node);
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, (0, parcelRequire("4UJvN")).createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        if (output.length === 0) return [
            (0, (0, parcelRequire("4UJvN")).createEmptyParagraphNode)(schema)
        ];
        return output;
    }
    function $50669f552f016dd9$var$normalizeMediaGroups(nodes, schema, _parentNode) {
        const output = [];
        let mediaGroupBuffer = [];
        let separatorBuffer = [];
        for (const n of nodes){
            if (n.type.name === 'mediaGroup' && n.childCount === 1) {
                mediaGroupBuffer.push(n);
                separatorBuffer = [];
                continue;
            }
            if (mediaGroupBuffer.length > 0) {
                if ($50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                    output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                    output.push(...separatorBuffer);
                    output.push(n);
                    mediaGroupBuffer = [];
                    separatorBuffer = [];
                } else separatorBuffer.push(n);
                continue;
            }
            output.push(n);
        }
        if (mediaGroupBuffer.length > 0) output.push($50669f552f016dd9$var$createMergedMediaGroup(mediaGroupBuffer, schema));
        output.push(...separatorBuffer);
        return output;
    }
    function $50669f552f016dd9$var$createMergedMediaGroup(mediaGroupNodes, schema) {
        const { mediaGroup: mediaGroup } = schema.nodes;
        const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
        return mediaGroup.createChecked({}, mediaNodes);
    }
    function $50669f552f016dd9$var$isSignificantSeparatorNode(n, separatorBuffer) {
        return $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) || !$50669f552f016dd9$var$isEmptyTextNode(n) || $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n);
    }
    function $50669f552f016dd9$var$isMediaGroupWithMultipleChildren(n) {
        return n.type.name === 'mediaGroup' && n.childCount > 1;
    }
    function $50669f552f016dd9$var$isHardBreak(n, separatorBuffer) {
        return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
    }
    function $50669f552f016dd9$var$isEmptyTextNode(n) {
        return n.textContent !== undefined && n.textContent.trim().length === 0;
    }
    function $50669f552f016dd9$export$19b6d0f3f1dd6ddf(input) {
        return input.trim().length === 0;
    }
    function $50669f552f016dd9$var$convertNodeToExpand(node, schema) {
        const { expand: expand } = schema.nodes;
        return expand.createChecked(node.attrs, node.content);
    }
});
parcelRegister("4UJvN", function(module, exports) {
    $parcel$export(module.exports, "createEmptyParagraphNode", ()=>$4ae1f625ac901e34$export$e930a5cfe8596ea0);
    $parcel$export(module.exports, "createParagraphNodeFromInlineNodes", ()=>$4ae1f625ac901e34$export$f0eaed48ea684567);
    function $4ae1f625ac901e34$export$e930a5cfe8596ea0(schema) {
        const { paragraph: paragraph } = schema.nodes;
        return paragraph.createChecked({}, []);
    }
    function $4ae1f625ac901e34$export$f0eaed48ea684567(inlineNodes, schema) {
        const { paragraph: paragraph } = schema.nodes;
        const result = [];
        const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
        if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
        return result;
    }
});
parcelRegister("9jjzg", function(module, exports) {
    $parcel$export(module.exports, "resolveLink", ()=>$c08b1d888f635e2c$export$c2baa561eb017101);
    var $30RSK;
    var $lRYXZ;
    var $b0Iw2;
    var $k1MiS;
    const $c08b1d888f635e2c$var$linkResolverStrategies = [
        (0, (0, parcelRequire("lRYXZ")).attachmentLinkResolver),
        (0, (0, parcelRequire("30RSK")).mentionLinkResolver),
        (0, (0, parcelRequire("k1MiS")).issueLinkResolver),
        (0, (0, parcelRequire("b0Iw2")).urlLinkResolver)
    ];
    function $c08b1d888f635e2c$export$c2baa561eb017101(link, schema, context) {
        const length = link.originalLinkText.length + 2;
        for (const resolver of $c08b1d888f635e2c$var$linkResolverStrategies){
            const resolvedLink = resolver(link, schema, context);
            if (resolvedLink) return {
                length: length,
                nodes: resolvedLink,
                type: 'pmnode'
            };
        }
        return undefined;
    }
});
parcelRegister("30RSK", function(module, exports) {
    $parcel$export(module.exports, "mentionLinkResolver", ()=>$bbe5fc702887fa8b$export$1da3b34e38fc6ca8);
    function $bbe5fc702887fa8b$export$1da3b34e38fc6ca8(link, schema, context) {
        if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
            schema.nodes.paragraph.createChecked({}, [
                schema.nodes.text.create({})
            ])
        ];
        if (link.notLinkBody.startsWith('~')) {
            const mentionText = link.notLinkBody.substring(1);
            const mentionKey = mentionText.toLowerCase();
            const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
            return [
                schema.nodes.mention.createChecked({
                    id: id
                })
            ];
        }
        return;
    }
});
parcelRegister("lRYXZ", function(module, exports) {
    $parcel$export(module.exports, "attachmentLinkResolver", ()=>$2514090e6b8dffff$export$ce918f41a76b8445);
    var $4vpto;
    function $2514090e6b8dffff$export$ce918f41a76b8445(link, schema, context) {
        if (link.attachmentName) return [
            (0, (0, parcelRequire("4vpto")).default)(schema, link.attachmentName, context)
        ];
        return;
    }
});
parcelRegister("4vpto", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$904a1bc635a5ad9a$export$2e2bcd8739ae039);
    function $904a1bc635a5ad9a$export$2e2bcd8739ae039(schema, filename, context = {}) {
        const { media: media, mediaGroup: mediaGroup } = schema.nodes;
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || ''
        });
        return mediaGroup.createChecked({}, mediaNode);
    }
});
parcelRegister("b0Iw2", function(module, exports) {
    $parcel$export(module.exports, "urlLinkResolver", ()=>$e20b005b86e07eab$export$b737d556d2167f9);
    var $kSL4h;
    var $iZOJ9;
    var $29zBb;
    var $gxAE9;
    function $e20b005b86e07eab$export$b737d556d2167f9(link, schema, context) {
        const output = [];
        const url = link.notLinkBody;
        const textRepresentation = link.linkBody || link.notLinkBody;
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return;
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        ];
        const rawContent = (0, (0, parcelRequire("29zBb")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: textRepresentation.replace(/^mailto:/, '')
        });
        const decoratedContent = rawContent.map((n)=>{
            const mark = schema.marks.link.create({
                href: url
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'link',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        output.push(...decoratedContent);
        if (!$e20b005b86e07eab$var$hasTextNode(rawContent)) {
            const mark = schema.marks.link.create({
                href: url
            });
            const linkTextNode = schema.text(textRepresentation, [
                mark
            ]);
            output.push(linkTextNode);
        }
        return output;
    }
    function $e20b005b86e07eab$var$hasTextNode(nodes) {
        return nodes.find((n)=>{
            return n.type.name === 'text';
        });
    }
});
parcelRegister("gxAE9", function(module, exports) {
    $parcel$export(module.exports, "hasAnyOfMarks", ()=>$fd57502cc274f1df$export$30c14ec359b8cbf0);
    $parcel$export(module.exports, "isDigit", ()=>$fd57502cc274f1df$export$727d9dbc4fbb948f);
    $parcel$export(module.exports, "isBlank", ()=>$fd57502cc274f1df$export$7ee701e290d9865);
    $parcel$export(module.exports, "isNotBlank", ()=>$fd57502cc274f1df$export$4d9e7a1c098df5e2);
    $parcel$export(module.exports, "getSurroundingSymbols", ()=>$fd57502cc274f1df$export$ddec3d40bf5e3693);
    $parcel$export(module.exports, "StringBuffer", ()=>$fd57502cc274f1df$export$83347051c3437dc9);
    function $fd57502cc274f1df$export$30c14ec359b8cbf0(node, types) {
        return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
    }
    function $fd57502cc274f1df$export$727d9dbc4fbb948f(value) {
        return !!value.match(/^\d$/);
    }
    function $fd57502cc274f1df$export$7ee701e290d9865(value) {
        return value === null || value.trim() === '';
    }
    function $fd57502cc274f1df$export$4d9e7a1c098df5e2(value) {
        return !$fd57502cc274f1df$export$7ee701e290d9865(value);
    }
    const $fd57502cc274f1df$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
        const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
        const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
        const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
        return {
            openingSymbol: openingSymbol,
            closingSymbol: closingSymbol
        };
    };
    class $fd57502cc274f1df$export$83347051c3437dc9 {
        constructor(buffer = ''){
            this.buffer = buffer;
        }
        indexOf(value) {
            return this.buffer.indexOf(value);
        }
        lastIndexOf(value) {
            return this.buffer.lastIndexOf(value);
        }
        charAt(index) {
            return this.buffer.charAt(index);
        }
        length() {
            return this.buffer.length;
        }
        delete(start, end) {
            this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
        }
        append(value) {
            this.buffer += value;
        }
        substring(start, end) {
            return this.buffer.substring(start, end);
        }
        deleteCharAt(index) {
            this.delete(index, index + 1);
        }
        toString() {
            return this.buffer;
        }
    }
});
parcelRegister("k1MiS", function(module, exports) {
    $parcel$export(module.exports, "issueLinkResolver", ()=>$7a9a102a7215e3d4$export$f40ed0efa65d4e8);
    var $bOMPB;
    function $7a9a102a7215e3d4$export$f40ed0efa65d4e8(link, schema, context) {
        const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
        if (linkTitle === 'smart-card' || linkTitle === 'block-link') return [
            schema.nodes.blockCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-link') return [
            schema.nodes.inlineCard.createChecked({
                url: notLinkBody
            })
        ];
        if (linkTitle === 'smart-embed') return [
            schema.nodes.embedCard.createChecked({
                url: notLinkBody
            })
        ];
        const issue = (0, (0, parcelRequire("bOMPB")).getIssue)(context, originalLinkText);
        if (issue) return (0, (0, parcelRequire("bOMPB")).buildInlineCard)(schema, issue);
        return undefined;
    }
});
parcelRegister("bOMPB", function(module, exports) {
    $parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", ()=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9);
    $parcel$export(module.exports, "issueKey", ()=>$ce5ca7baa00e39d0$export$a0d841e329cebd91);
    $parcel$export(module.exports, "getIssue", ()=>$ce5ca7baa00e39d0$export$34403cb88b30d33b);
    $parcel$export(module.exports, "buildInlineCard", ()=>$ce5ca7baa00e39d0$export$cdebb4bc59c595a);
    $parcel$export(module.exports, "buildIssueKeyRegex", ()=>$ce5ca7baa00e39d0$export$cd8701ad7512efee);
    var $gxAE9;
    const $ce5ca7baa00e39d0$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
    const $ce5ca7baa00e39d0$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
        if (!context.issueKeyRegex) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const match = input.substring(position).match(context.issueKeyRegex);
        if (!match) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const issue = $ce5ca7baa00e39d0$export$34403cb88b30d33b(context, match[0]);
        if (!issue) return $ce5ca7baa00e39d0$var$fallback(input, position);
        const charBefore = input.charAt(position - 1);
        const charAfter = input.charAt(position + issue.key.length);
        if ((0, (0, parcelRequire("gxAE9")).isNotBlank)(charBefore) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charBefore) || (0, (0, parcelRequire("gxAE9")).isNotBlank)(charAfter) && $ce5ca7baa00e39d0$var$isNotAllowedChars(charAfter)) return $ce5ca7baa00e39d0$var$fallback(input, position);
        return {
            type: 'pmnode',
            nodes: $ce5ca7baa00e39d0$export$cdebb4bc59c595a(schema, issue),
            length: match[0].length
        };
    };
    const $ce5ca7baa00e39d0$var$fallback = (input, position)=>({
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        });
    const $ce5ca7baa00e39d0$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
            key: key,
            url: context.conversion.inlineCardConversion[key]
        } : null;
    const $ce5ca7baa00e39d0$export$cdebb4bc59c595a = (schema, issue)=>{
        return [
            schema.nodes.inlineCard.createChecked({
                url: $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp(issue)
            })
        ];
    };
    const $ce5ca7baa00e39d0$var$withInlineCardFromTextStamp = (issue)=>$ce5ca7baa00e39d0$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
    const $ce5ca7baa00e39d0$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
    const $ce5ca7baa00e39d0$export$cd8701ad7512efee = (inlineCardConversion)=>{
        if (!inlineCardConversion) return undefined;
        const pattern = Object.keys(inlineCardConversion).join('|');
        if (!pattern) return undefined;
        return new RegExp(`^(${pattern})`);
    };
});
parcelRegister("gGleW", function(module, exports) {
    $parcel$export(module.exports, "parseContentLink", ()=>$57e1d7866034b37b$export$3a250a08d37b0eae);
    var $gxAE9;
    function $57e1d7866034b37b$var$trimIfPossible(s) {
        if (s === null) return null;
        return s.trim();
    }
    function $57e1d7866034b37b$var$extractLinkBody(buffer) {
        const indexOfBang = buffer.indexOf('!');
        const indexOfPipe = buffer.indexOf('|');
        const lastIndexOfBang = buffer.lastIndexOf('!');
        const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
        if (notEscaped) return $57e1d7866034b37b$var$divideOn(buffer, '|');
        const body = new (0, (0, parcelRequire("gxAE9")).StringBuffer)();
        let inEscape = false;
        for(let i = 0; i < buffer.length(); i++){
            const c = buffer.charAt(i);
            if (c === '!') inEscape = !inEscape;
            if (c === '|' && !inEscape) {
                buffer.delete(0, i + 1);
                return body.toString();
            }
            body.append(c);
        }
        return null;
    }
    function $57e1d7866034b37b$var$divideAfterLast(buffer, divider) {
        if (buffer.length() === 0) return null;
        return $57e1d7866034b37b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
    }
    function $57e1d7866034b37b$var$divideAfter(buffer, index) {
        if (typeof index === 'string') index = buffer.indexOf(index);
        if (index < 0) return null;
        else if (index === buffer.length() - 1) {
            buffer.deleteCharAt(buffer.length() - 1);
            return null;
        } else {
            const body = buffer.substring(index + 1);
            buffer.delete(index, buffer.length());
            return body;
        }
    }
    function $57e1d7866034b37b$var$divideOn(buffer, divider) {
        if (buffer.length() === 0) return null;
        const i = buffer.indexOf(divider);
        if (i < 0) return null;
        else if (i === 0) {
            buffer.deleteCharAt(0);
            return null;
        } else {
            const body = buffer.substring(0, i);
            buffer.delete(0, i + 1);
            return body;
        }
    }
    function $57e1d7866034b37b$var$extractNumber(buf) {
        const digits = new (0, (0, parcelRequire("gxAE9")).StringBuffer)();
        let i = 0;
        for(; i < buf.length() && (0, (0, parcelRequire("gxAE9")).isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
        if (i > 0) buf.delete(0, i);
        try {
            return parseInt(digits.toString(), 10);
        } catch (e) {
            return 0;
        }
    }
    function $57e1d7866034b37b$export$2d20cd44728d07a1(linkText) {
        const originalLinkText = linkText;
        if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
        const buf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(linkText);
        const linkBody = $57e1d7866034b37b$var$extractLinkBody(buf);
        const linkTitle = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '|'));
        const notLinkBody = buf.toString().trim();
        return {
            originalLinkText: originalLinkText,
            linkBody: linkBody,
            linkTitle: linkTitle,
            notLinkBody: notLinkBody
        };
    }
    function $57e1d7866034b37b$export$3a250a08d37b0eae(link) {
        if (typeof link === 'string') link = $57e1d7866034b37b$export$2d20cd44728d07a1(link);
        const { notLinkBody: notLinkBody } = link;
        let shortcutName = null;
        let shortcutValue = null;
        let spaceKey = null;
        let attachmentName = null;
        let anchor = null;
        let destinationTitle = '';
        let contentId = 0;
        if (!notLinkBody.startsWith('~')) {
            const shortcutBuf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(notLinkBody);
            shortcutName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfterLast(shortcutBuf, '@'));
            if ((0, (0, parcelRequire("gxAE9")).isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
        }
        const buf = new (0, (0, parcelRequire("gxAE9")).StringBuffer)(notLinkBody);
        if ((0, (0, parcelRequire("gxAE9")).isBlank)(shortcutName)) {
            spaceKey = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideOn(buf, ':'));
            if (buf.indexOf('$') === 0) {
                buf.deleteCharAt(0);
                contentId = $57e1d7866034b37b$var$extractNumber(buf);
                if (contentId === 0) return {
                    ...link,
                    shortcutName: shortcutName,
                    shortcutValue: shortcutValue,
                    spaceKey: spaceKey,
                    contentId: contentId,
                    attachmentName: attachmentName,
                    anchor: anchor,
                    destinationTitle: destinationTitle
                };
            }
            attachmentName = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '^'));
            anchor = $57e1d7866034b37b$var$trimIfPossible($57e1d7866034b37b$var$divideAfter(buf, '#'));
        }
        if (contentId === 0) destinationTitle = buf.toString().trim();
        return {
            ...link,
            shortcutName: shortcutName,
            shortcutValue: shortcutValue,
            spaceKey: spaceKey,
            contentId: contentId,
            attachmentName: attachmentName,
            anchor: anchor,
            destinationTitle: destinationTitle
        };
    }
});
parcelRegister("30Un5", function(module, exports) {
    $parcel$export(module.exports, "blockquote", ()=>$0c863b8155c1a336$export$67dc04e652a298ca);
    var $4Dfwq;
    const $0c863b8155c1a336$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
    const $0c863b8155c1a336$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
        const match = input.substring(position).match($0c863b8155c1a336$var$BLOCKQUOTE_REGEXP);
        if (!match) return $0c863b8155c1a336$var$fallback(input, position);
        const [, rawContent] = match;
        return (0, (0, parcelRequire("4Dfwq")).rawContentProcessor)('', rawContent, match[0].length, schema, context);
    };
    function $0c863b8155c1a336$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("4Dfwq", function(module, exports) {
    $parcel$export(module.exports, "quoteMacro", ()=>$0723b4b23edf777c$export$8f9545cee64b3251);
    $parcel$export(module.exports, "rawContentProcessor", ()=>$0723b4b23edf777c$export$c2a5e4612254bfa);
    var $3JW2n;
    var $gxAE9;
    var $20lXC;
    var $29zBb;
    const $0723b4b23edf777c$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'quote',
            paired: true,
            rawContentProcessor: $0723b4b23edf777c$export$c2a5e4612254bfa,
            context: context
        });
    };
    const $0723b4b23edf777c$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
        if (!rawContent.length) {
            const emptyQuote = $0723b4b23edf777c$var$emptyBlockquote(schema);
            return {
                type: 'pmnode',
                nodes: [
                    emptyQuote
                ],
                length: length
            };
        }
        const parsedContent = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("20lXC")).normalizePMNodes)(parsedContent, schema);
        return {
            type: 'pmnode',
            nodes: $0723b4b23edf777c$var$sanitize(normalizedContent, schema),
            length: length
        };
    };
    function $0723b4b23edf777c$var$emptyBlockquote(schema) {
        const p = schema.nodes.paragraph.createChecked({}, []);
        return schema.nodes.blockquote.createChecked({}, p);
    }
    function $0723b4b23edf777c$var$sanitize(nodes, schema) {
        const output = [];
        let contentBuffer = [];
        for (const n of nodes)switch(n.type.name){
            case 'paragraph':
            case 'bulletList':
            case 'orderedList':
            case 'codeBlock':
            case 'mediaSingle':
            case 'mediaGroup':
                contentBuffer.push(n);
                break;
            case 'heading':
                contentBuffer.push($0723b4b23edf777c$var$transformHeading(n, schema));
                break;
            default:
                if (contentBuffer.length) {
                    const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                    output.push(blockquote);
                    contentBuffer = [];
                }
                output.push(n);
        }
        if (contentBuffer.length) {
            const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
            output.push(blockquote);
        }
        return output;
    }
    function $0723b4b23edf777c$var$transformHeading(heading, schema) {
        const contentBuffer = [];
        heading.content.forEach((n)=>{
            const strong = schema.marks.strong.create();
            const italic = schema.marks.em.create();
            const gray = schema.marks.textColor.create({
                color: '#97a0af'
            });
            if (n.type.name === 'text') {
                if (n.text && heading.attrs.level === 1) n.text = n.text.toUpperCase();
                if (heading.attrs.level <= 4 && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'strong',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    strong
                ]);
                if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'em',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    italic
                ]);
                if (heading.attrs.level > 3 && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                    'textColor',
                    'code'
                ])) n = n.mark([
                    ...n.marks,
                    gray
                ]);
            }
            contentBuffer.push(n);
        });
        return schema.nodes.paragraph.createChecked({}, contentBuffer);
    }
});
parcelRegister("3JW2n", function(module, exports) {
    $parcel$export(module.exports, "commonMacro", ()=>$108725731ca4984f$export$b6a12943ac1bb1ba);
    function $108725731ca4984f$export$b6a12943ac1bb1ba(input, schema, opt) {
        const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
        const matchOpening = input.match(opening);
        if (!matchOpening) return $108725731ca4984f$var$fallback(input);
        const [, name, rawAttrs] = matchOpening;
        const openingLength = matchOpening[0].length;
        if (!opt.paired) return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
        const closing = new RegExp(`\{${name}\}`);
        const matchClosing = closing.exec(input.substring(openingLength));
        let rawContent = '';
        if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
        const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
        return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
    }
    function $108725731ca4984f$var$fallback(input) {
        return {
            type: 'text',
            text: input.substr(0, 1),
            length: 1
        };
    }
});
parcelRegister("coK8g", function(module, exports) {
    $parcel$export(module.exports, "citation", ()=>$624cf9f0f9a0e4f4$export$258632c953c109e9);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $624cf9f0f9a0e4f4$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY
        ];
        const contentDecorator = (n, index)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) {
                if (index === 0) n.text = `${0, $0c0aa3654d545c29$export$3bca9fae3002bd9b} ${n.text}`;
                return n.mark([
                    ...n.marks,
                    mark
                ]);
            }
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '??', '??');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
const $0c0aa3654d545c29$export$3bca9fae3002bd9b = "\u2014";
parcelRegister("5RdHN", function(module, exports) {
    $parcel$export(module.exports, "deleted", ()=>$b9ac580681c978af$export$bccbf0c716f226f4);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $b9ac580681c978af$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.strike.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'strike',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '-', '-');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("55t1E", function(module, exports) {
    $parcel$export(module.exports, "doubleDashSymbol", ()=>$74a06c4540bbf40b$export$65e3ca7c95899a2d);
    var $1rQjR;
    const $74a06c4540bbf40b$var$token = {
        type: 'text',
        text: '\u2013',
        length: 2
    };
    const $74a06c4540bbf40b$var$fallback = {
        ...$74a06c4540bbf40b$var$token,
        text: '--'
    };
    const $74a06c4540bbf40b$export$65e3ca7c95899a2d = (0, (0, parcelRequire("1rQjR")).createDashTokenParser)($74a06c4540bbf40b$var$token, $74a06c4540bbf40b$var$fallback);
});
parcelRegister("1rQjR", function(module, exports) {
    $parcel$export(module.exports, "createDashTokenParser", ()=>$75f433a8b52a8173$export$d43b58865d429e3c);
    const $75f433a8b52a8173$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
            if (position > 0) {
                const charBeforeToken = input.charAt(position - 1);
                if (!$75f433a8b52a8173$var$isSpace(charBeforeToken)) return fallback;
            }
            if (position + token.length < input.length) {
                const charAfterToken = input.charAt(position + token.length);
                if (!$75f433a8b52a8173$var$isSpace(charAfterToken)) return fallback;
            }
            return token;
        };
    const $75f433a8b52a8173$var$isSpace = (char)=>{
        return /\s/.test(char);
    };
});
parcelRegister("jor5q", function(module, exports) {
    $parcel$export(module.exports, "emoji", ()=>$487b5ddb28312972$export$a19185d1233fc4b2);
    const $487b5ddb28312972$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
    const $487b5ddb28312972$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
        const substring = input.substring(position);
        for(let i = 2; i <= 9 && i <= substring.length; ++i){
            const candidateText = substring.substring(0, i);
            const emojiId = $487b5ddb28312972$export$fabd2c9504f5bf35[candidateText];
            if (emojiId && $487b5ddb28312972$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
                type: 'pmnode',
                nodes: [
                    schema.nodes.emoji.createChecked($487b5ddb28312972$export$797c048dfde076a1[emojiId])
                ],
                length: i
            };
        }
        return {
            type: 'text',
            text: substring.substr(0, 1),
            length: 1
        };
    };
    const $487b5ddb28312972$export$797c048dfde076a1 = {
        '1f642': {
            id: '1f642',
            shortName: ':slight_smile:',
            text: "\uD83D\uDE42"
        },
        '1f61e': {
            id: '1f61e',
            shortName: ':disappointed:',
            text: "\uD83D\uDE1E"
        },
        '1f61b': {
            id: '1f61b',
            shortName: ':stuck_out_tongue:',
            text: "\uD83D\uDE1B"
        },
        '1f603': {
            id: '1f603',
            shortName: ':smiley:',
            text: "\uD83D\uDE03"
        },
        '1f609': {
            id: '1f609',
            shortName: ':wink:',
            text: "\uD83D\uDE09"
        },
        '1f44d': {
            id: '1f44d',
            shortName: ':thumbsup:',
            text: "\uD83D\uDC4D"
        },
        '1f44e': {
            id: '1f44e',
            shortName: ':thumbsdown:',
            text: "\uD83D\uDC4E"
        },
        'atlassian-info': {
            id: 'atlassian-info',
            shortName: ':info:',
            text: ':info:'
        },
        'atlassian-check_mark': {
            id: 'atlassian-check_mark',
            shortName: ':check_mark:',
            text: ':check_mark:'
        },
        'atlassian-cross_mark': {
            id: 'atlassian-cross_mark',
            shortName: ':cross_mark:',
            text: ':cross_mark:'
        },
        'atlassian-warning': {
            id: 'atlassian-warning',
            shortName: ':warning:',
            text: ':warning:'
        },
        'atlassian-plus': {
            id: 'atlassian-plus',
            shortName: ':plus:',
            text: ':plus:'
        },
        'atlassian-minus': {
            id: 'atlassian-minus',
            shortName: ':minus:',
            text: ':minus:'
        },
        'atlassian-question_mark': {
            id: 'atlassian-question_mark',
            shortName: ':question:',
            text: ':question:'
        },
        'atlassian-light_bulb_on': {
            id: 'atlassian-light_bulb_on',
            shortName: ':light_bulb_on:',
            text: ':light_bulb_on:'
        },
        'atlassian-light_bulb_off': {
            id: 'atlassian-light_bulb_off',
            shortName: ':light_bulb_off:',
            text: ':light_bulb_off:'
        },
        'atlassian-yellow_star': {
            id: 'atlassian-yellow_star',
            shortName: ':yellow_star:',
            text: ':yellow_star:'
        },
        'atlassian-red_star': {
            id: 'atlassian-red_star',
            shortName: ':red_star:',
            text: ':red_star:'
        },
        'atlassian-green_star': {
            id: 'atlassian-green_star',
            shortName: ':green_star:',
            text: ':green_star:'
        },
        'atlassian-blue_star': {
            id: 'atlassian-blue_star',
            shortName: ':blue_star:',
            text: ':blue_star:'
        },
        'atlassian-flag_on': {
            id: 'atlassian-flag_on',
            shortName: ':flag_on:',
            text: ':flag_on:'
        },
        'atlassian-flag_off': {
            id: 'atlassian-flag_off',
            shortName: ':flag_off:',
            text: ':flag_off:'
        }
    };
    const $487b5ddb28312972$export$fabd2c9504f5bf35 = {
        ':)': '1f642',
        ':-)': '1f642',
        ':(': '1f61e',
        ':-(': '1f61e',
        ':P': '1f61b',
        ':-P': '1f61b',
        ':p': '1f61b',
        ':-p': '1f61b',
        ':D': '1f603',
        ':-D': '1f603',
        ';)': '1f609',
        ';-)': '1f609',
        '(y)': '1f44d',
        '(n)': '1f44e',
        '(i)': 'atlassian-info',
        '(/)': 'atlassian-check_mark',
        '(x)': 'atlassian-cross_mark',
        '(!)': 'atlassian-warning',
        '(+)': 'atlassian-plus',
        '(-)': 'atlassian-minus',
        '(?)': 'atlassian-question_mark',
        '(on)': 'atlassian-light_bulb_on',
        '(off)': 'atlassian-light_bulb_off',
        '(*)': 'atlassian-yellow_star',
        '(*y)': 'atlassian-yellow_star',
        '(*r)': 'atlassian-red_star',
        '(*g)': 'atlassian-green_star',
        '(*b)': 'atlassian-blue_star',
        '(flag)': 'atlassian-flag_on',
        '(flagoff)': 'atlassian-flag_off'
    };
});
parcelRegister("hZ14o", function(module, exports) {
    $parcel$export(module.exports, "emphasis", ()=>$5100d4ec4f1b4884$export$bef81ba411953b51);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $5100d4ec4f1b4884$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.em.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '_', '_');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("6xaH8", function(module, exports) {
    $parcel$export(module.exports, "hardbreak", ()=>$bc70e1090faff3e6$export$ac55bb44695749c1);
    var $eWAZI;
    const $bc70e1090faff3e6$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(position));
        if (length === 0) return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
        return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: length
        };
    };
});
parcelRegister("jMpI6", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$ed15d3e22c065f91$export$46e4a324ac90507f);
    var $29zBb;
    var $kSL4h;
    const $ed15d3e22c065f91$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
    const $ed15d3e22c065f91$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL
        ];
        const match = input.substring(position).match($ed15d3e22c065f91$var$HEADING_REGEXP);
        if (!match) return $ed15d3e22c065f91$var$fallback(input, position);
        const level = parseInt(match[1], 10);
        const content = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            ignoreTokenTypes: ignoreTokenTypes,
            context: context,
            input: match[2]
        });
        try {
            const headingNode = schema.nodes.heading.createChecked({
                level: level
            }, content);
            return {
                type: 'pmnode',
                nodes: [
                    headingNode
                ],
                length: match[0].length
            };
        } catch (err) {
            return {
                type: 'text',
                text: '',
                length: 4
            };
        }
    };
    function $ed15d3e22c065f91$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("iDsRr", function(module, exports) {
    $parcel$export(module.exports, "inserted", ()=>$33f79eddf582429a$export$744ba74fb86b8ca7);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $33f79eddf582429a$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.underline.create();
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'underline',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '+', '+');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("ayQVO", function(module, exports) {
    $parcel$export(module.exports, "MAX_LIST_DEPTH", ()=>$4813b87fbe6448cc$export$d2a2f0ec33d903e1);
    $parcel$export(module.exports, "list", ()=>$4813b87fbe6448cc$export$8837f4fc672e936d);
    var $hnQWb;
    var $29zBb;
    var $20lXC;
    var $cG4PY;
    var $kSL4h;
    var $eWAZI;
    var $gxAE9;
    const $4813b87fbe6448cc$export$d2a2f0ec33d903e1 = 20;
    const $4813b87fbe6448cc$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$4813b87fbe6448cc$export$d2a2f0ec33d903e1}}) `);
    const $4813b87fbe6448cc$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
    const $4813b87fbe6448cc$var$processState = {
        NEW_LINE: 0,
        BUFFER: 1,
        END: 2,
        MACRO: 3
    };
    const $4813b87fbe6448cc$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        let index = position;
        let state = $4813b87fbe6448cc$var$processState.NEW_LINE;
        let buffer = [];
        let lastListSymbols = null;
        let builder = null;
        let contentBuffer = [];
        const output = [];
        while(index < input.length){
            const char = input.charAt(index);
            switch(state){
                case $4813b87fbe6448cc$var$processState.NEW_LINE:
                    {
                        const substring = input.substring(index);
                        const listMatch = substring.match($4813b87fbe6448cc$var$LIST_ITEM_REGEXP);
                        if (listMatch) {
                            const [, symbols] = listMatch;
                            const rulerMatch = symbols.match($4813b87fbe6448cc$var$RULER_SYMBOL_REGEXP);
                            if (rulerMatch) {
                                const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                                const emptyLineMatch = remainingAfterSymbol.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                                if (emptyLineMatch) {
                                    state = $4813b87fbe6448cc$var$processState.BUFFER;
                                    continue;
                                }
                            }
                            if (!builder) {
                                builder = new (0, (0, parcelRequire("hnQWb")).ListBuilder)(schema, symbols);
                                lastListSymbols = symbols;
                            } else {
                                if (buffer.length > 0) {
                                    const content = (0, (0, parcelRequire("29zBb")).parseString)({
                                        ignoreTokenTypes: ignoreTokenTypes,
                                        schema: schema,
                                        context: context,
                                        input: buffer.join(''),
                                        includeLeadingSpace: true
                                    });
                                    contentBuffer.push(...content);
                                    builder.add([
                                        {
                                            style: lastListSymbols,
                                            content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                                        }
                                    ]);
                                    buffer = [];
                                    contentBuffer = [];
                                }
                                lastListSymbols = symbols;
                                const type = (0, (0, parcelRequire("hnQWb")).getType)(symbols);
                                if (type !== builder.type && symbols.length === 1) {
                                    output.push(...builder.buildPMNode());
                                    builder = new (0, (0, parcelRequire("hnQWb")).ListBuilder)(schema, symbols);
                                }
                            }
                            index += listMatch[0].length;
                        }
                        const emptyLineMatch = substring.match($4813b87fbe6448cc$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            state = $4813b87fbe6448cc$var$processState.END;
                            continue;
                        }
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        continue;
                    }
                case $4813b87fbe6448cc$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(input.substring(index));
                        if (length) {
                            buffer.push(input.substr(index, length));
                            state = $4813b87fbe6448cc$var$processState.NEW_LINE;
                            index += length;
                            continue;
                        }
                        if (char === '{') {
                            state = $4813b87fbe6448cc$var$processState.MACRO;
                            continue;
                        } else buffer.push(char);
                        break;
                    }
                case $4813b87fbe6448cc$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            state = $4813b87fbe6448cc$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $4813b87fbe6448cc$var$processState.BUFFER;
                        continue;
                    }
                case $4813b87fbe6448cc$var$processState.END:
                    if (!builder) return $4813b87fbe6448cc$var$fallback(input, position);
                    if (buffer.length > 0) {
                        const content = (0, (0, parcelRequire("29zBb")).parseString)({
                            ignoreTokenTypes: ignoreTokenTypes,
                            schema: schema,
                            context: context,
                            input: buffer.join(''),
                            includeLeadingSpace: true
                        });
                        contentBuffer.push(...content);
                    }
                    builder.add([
                        {
                            style: lastListSymbols,
                            content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                        }
                    ]);
                    output.push(...builder.buildPMNode());
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
            }
            index++;
        }
        if (buffer.length > 0) {
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: buffer.join(''),
                includeLeadingSpace: true
            });
            contentBuffer.push(...content);
        }
        if (builder) {
            builder.add([
                {
                    style: lastListSymbols,
                    content: $4813b87fbe6448cc$var$sanitize((0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentBuffer, schema), schema)
                }
            ]);
            output.push(...builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $4813b87fbe6448cc$var$sanitize(nodes, schema) {
        return nodes.reduce((result, curr)=>{
            switch(curr.type.name){
                case 'blockquote':
                    curr.content.forEach((n)=>{
                        result.push(n);
                    });
                    break;
                case 'heading':
                    {
                        const contentBuffer = [];
                        curr.content.forEach((n)=>{
                            const mark = schema.marks.strong.create();
                            if (n.type.name === 'text') {
                                if (n.text) n.text = n.text.toUpperCase();
                                if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                                    'strong',
                                    'code'
                                ])) contentBuffer.push(n.mark([
                                    ...n.marks,
                                    mark
                                ]));
                                else contentBuffer.push(n);
                            } else contentBuffer.push(n);
                        });
                        const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                        result.push(p);
                        break;
                    }
                default:
                    result.push(curr);
            }
            return result;
        }, []);
    }
    function $4813b87fbe6448cc$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 1),
            length: 1
        };
    }
});
parcelRegister("hnQWb", function(module, exports) {
    $parcel$export(module.exports, "getType", ()=>$3303253e6091964c$export$e2b5c5db9e2009fd);
    $parcel$export(module.exports, "ListBuilder", ()=>$3303253e6091964c$export$876cfa3161bef296);
    const $3303253e6091964c$var$supportedContentType = [
        'paragraph',
        'orderedList',
        'bulletList',
        'mediaSingle',
        'codeBlock'
    ];
    function $3303253e6091964c$export$e2b5c5db9e2009fd(bullets) {
        return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
    }
    class $3303253e6091964c$export$876cfa3161bef296 {
        constructor(schema, bullets){
            this.parseList = (list)=>{
                const listNode = this.schema.nodes[list.type];
                const output = [];
                let listItemsBuffer = [];
                for(let i = 0; i < list.children.length; i++){
                    const parsedContent = this.parseListItem(list.children[i]);
                    for(let j = 0; j < parsedContent.length; j++){
                        const parsedNode = parsedContent[j];
                        if (parsedNode.type.name === 'listItem') {
                            listItemsBuffer.push(parsedNode);
                            continue;
                        }
                        if (listItemsBuffer.length) {
                            const list = listNode.createChecked({}, listItemsBuffer);
                            output.push(list);
                        }
                        output.push(parsedNode);
                        listItemsBuffer = [];
                    }
                }
                if (listItemsBuffer.length) {
                    const list = listNode.createChecked({}, listItemsBuffer);
                    output.push(list);
                }
                return output;
            };
            this.parseListItem = (item)=>{
                const output = [];
                if (!item.content) item.content = [];
                const parsedChildren = item.children.reduce((result, list)=>{
                    const parsedList = this.parseList(list);
                    result.push(...parsedList);
                    return result;
                }, []);
                item.content.push(...parsedChildren);
                let contentBuffer = [];
                for(let i = 0; i < item.content.length; i++){
                    const pmNode = item.content[i];
                    if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                    if (this.isParagraphEmptyTextNode(pmNode)) continue;
                    if ($3303253e6091964c$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                        const listItem = this.createListItem(contentBuffer, this.schema);
                        output.push(listItem);
                        output.push(pmNode);
                        contentBuffer = [];
                        continue;
                    }
                    contentBuffer.push(pmNode);
                }
                if (contentBuffer.length) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                }
                return output;
            };
            this.schema = schema;
            this.root = {
                children: [],
                type: $3303253e6091964c$export$e2b5c5db9e2009fd(bullets)
            };
            this.lastDepth = 1;
            this.lastList = this.root;
        }
        get type() {
            return this.root.type;
        }
        add(items) {
            for (const item of items){
                const { style: style, content: content } = item;
                if (style === null) {
                    this.appendToLastItem(content);
                    continue;
                }
                const depth = style.length;
                const type = $3303253e6091964c$export$e2b5c5db9e2009fd(style);
                if (depth > this.lastDepth) {
                    this.createNest(depth - this.lastDepth, type);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                } else if (depth === this.lastDepth) this.lastList = this.addListItem(type, content);
                else {
                    this.lastList = this.findAncestor(this.lastDepth - depth);
                    this.lastDepth = depth;
                    this.lastList = this.addListItem(type, content);
                }
            }
        }
        buildPMNode() {
            return this.parseList(this.root);
        }
        isParagraphEmptyTextNode(node) {
            if (node.type.name !== 'paragraph' || !node.childCount) return false;
            for(let i = 0; i < node.childCount; i++){
                const n = node.content.child(i);
                if (n.type.name !== 'text') return false;
                else if (n.textContent.trim() !== '') return false;
            }
            return true;
        }
        createListItem(content, schema) {
            if (content.length === 0 || [
                'paragraph',
                'mediaSingle'
            ].indexOf(content[0].type.name) === -1) content.unshift(this.schema.nodes.paragraph.createChecked());
            return schema.nodes.listItem.createChecked({}, content);
        }
        addListItem(type, content) {
            let list = this.lastList;
            if (list.type !== type) {
                const parent = list.parent;
                const newList = {
                    children: [],
                    type: type,
                    parent: parent
                };
                parent.children.push(newList);
                this.lastList = list = newList;
            }
            const listItem = {
                content: content,
                parent: list,
                children: []
            };
            list.children = [
                ...list.children,
                listItem
            ];
            return list;
        }
        appendToLastItem(content) {
            const { children: children } = this.lastList;
            const lastItem = children[children.length - 1];
            lastItem.content.push(...content);
        }
        createNest(depth, type) {
            while(depth-- > 0){
                if (this.lastList.children.length === 0) {
                    const listItem = {
                        parent: this.lastList,
                        children: []
                    };
                    this.lastList.children = [
                        listItem
                    ];
                }
                const nextItem = this.lastList.children[this.lastList.children.length - 1];
                nextItem.children = [
                    {
                        children: [],
                        parent: nextItem,
                        type: type
                    }
                ];
                this.lastList = nextItem.children[0];
            }
        }
        findAncestor(depth) {
            let list = this.lastList;
            while(depth-- > 0 && list.parent){
                const listItem = list.parent;
                if (listItem && listItem.parent) list = listItem.parent;
            }
            return list;
        }
    }
});
parcelRegister("kPrK8", function(module, exports) {
    $parcel$export(module.exports, "monospace", ()=>$7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $7b1a1e7fbe87f62a$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).ADF_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).ANCHOR_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).CODE_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).NOFORMAT_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).PANEL_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).COLOR_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).LOREM_MACRO,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUOTE,
            (0, (0, parcelRequire("kSL4h")).TokenType).STRING,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_FORMAT,
            (0, (0, parcelRequire("kSL4h")).TokenType).LINK_TEXT,
            (0, (0, parcelRequire("kSL4h")).TokenType).MEDIA,
            (0, (0, parcelRequire("kSL4h")).TokenType).HEADING,
            (0, (0, parcelRequire("kSL4h")).TokenType).LIST,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER,
            (0, (0, parcelRequire("kSL4h")).TokenType).HARD_BREAK,
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).STRONG,
            (0, (0, parcelRequire("kSL4h")).TokenType).MONOSPACE,
            (0, (0, parcelRequire("kSL4h")).TokenType).SUPERSCRIPT,
            (0, (0, parcelRequire("kSL4h")).TokenType).SUBSCRIPT,
            (0, (0, parcelRequire("kSL4h")).TokenType).EMPHASIS,
            (0, (0, parcelRequire("kSL4h")).TokenType).CITATION,
            (0, (0, parcelRequire("kSL4h")).TokenType).DELETED,
            (0, (0, parcelRequire("kSL4h")).TokenType).INSERTED,
            (0, (0, parcelRequire("kSL4h")).TokenType).EMOJI,
            (0, (0, parcelRequire("kSL4h")).TokenType).FORCE_LINE_BREAK
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.code.create();
            if (n.type.name === 'text' && n.marks.length) return n;
            return n.mark([
                mark
            ]);
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                ignoreTokenTypes: ignoreTokenTypes,
                schema: schema,
                context: context,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '{{', '}}');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4ZFIG", function(module, exports) {
    $parcel$export(module.exports, "quadrupleDashSymbol", ()=>$819171e80205fd1c$export$95a7907a71f31921);
    const $819171e80205fd1c$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
    const $819171e80205fd1c$export$95a7907a71f31921 = ({ input: input, position: position })=>{
        const match = input.substring(position).match($819171e80205fd1c$var$MULTI_DASH_REGEX);
        if (!match) return {
            type: 'text',
            text: '----',
            length: 4
        };
        return {
            type: 'text',
            text: input.substr(position, match[0].length),
            length: match[0].length
        };
    };
});
parcelRegister("91y57", function(module, exports) {
    $parcel$export(module.exports, "ruler", ()=>$cf2c039554fba6e4$export$f9adada2013e846e);
    var $i8dZb;
    const $cf2c039554fba6e4$var$RULER_REGEX = /^-{4,5}(\s|$)/;
    const $cf2c039554fba6e4$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
        const match = input.substring(position).match($cf2c039554fba6e4$var$RULER_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: (0, (0, parcelRequire("i8dZb")).createRuleNode)(schema),
            length: match[0].length
        };
        return {
            type: 'text',
            text: input.substring(position, 1),
            length: 1
        };
    };
});
parcelRegister("i8dZb", function(module, exports) {
    $parcel$export(module.exports, "createRuleNode", ()=>$d0cc271b2b6d9a56$export$4267f2e5716b018a);
    const $d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
    function $d0cc271b2b6d9a56$export$2e2bcd8739ae039(schema, containerNodeType) {
        const { paragraph: paragraph, rule: rule } = schema.nodes;
        if (containerNodeType) {
            const textNode = schema.text($d0cc271b2b6d9a56$var$HORIZONTAL_LINE_INSIDE_MACRO);
            return paragraph.createChecked({}, textNode);
        } else return rule.createChecked();
    }
    function $d0cc271b2b6d9a56$export$4267f2e5716b018a(schema) {
        const { rule: rule } = schema.nodes;
        const ruleNode = rule.createChecked();
        return [
            ruleNode
        ];
    }
});
parcelRegister("1Mtv8", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$da489456937eda28$export$59ae2c325a998f89);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $da489456937eda28$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (pmNode)=>{
            const mark = schema.marks.strong.create();
            if (pmNode.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(pmNode, [
                'strong',
                'code'
            ])) return pmNode.mark([
                ...pmNode.marks,
                mark
            ]);
            return pmNode;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '*', '*');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("77w3e", function(module, exports) {
    $parcel$export(module.exports, "subscript", ()=>$af8d85604a001a66$export$bc5390e4688d2822);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $af8d85604a001a66$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sub'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '~', '~');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("lf0Nr", function(module, exports) {
    $parcel$export(module.exports, "superscript", ()=>$6f4f331694cf9bb6$export$b4aab94a5fcfcead);
    var $kSL4h;
    var $gxAE9;
    var $eyO0H;
    var $29zBb;
    const $6f4f331694cf9bb6$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).ISSUE_KEY,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const contentDecorator = (n)=>{
            const mark = schema.marks.subsup.create({
                type: 'sup'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'subsup',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        };
        const rawContentProcessor = (raw, length)=>{
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: raw
            });
            const decoratedContent = content.map(contentDecorator);
            return {
                type: 'pmnode',
                nodes: decoratedContent,
                length: length
            };
        };
        const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, (0, parcelRequire("gxAE9")).getSurroundingSymbols)(input.substring(position), '^', '^');
        return (0, (0, parcelRequire("eyO0H")).commonFormatter)(input, position, schema, {
            opening: openingSymbol,
            closing: closingSymbol,
            context: context,
            rawContentProcessor: rawContentProcessor
        });
    };
});
parcelRegister("4s89q", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$8c7a9474c5649f43$export$9852986a3ec5f6a0);
    var $48GZN;
    var $29zBb;
    var $20lXC;
    var $7tIdE;
    var $4Foyv;
    var $jor5q;
    var $kSL4h;
    var $eWAZI;
    var $cG4PY;
    var $gxAE9;
    const $8c7a9474c5649f43$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
    const $8c7a9474c5649f43$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
    const $8c7a9474c5649f43$var$processState = {
        END_TABLE: 2,
        BUFFER: 4,
        CLOSE_ROW: 5,
        NEW_ROW: 6,
        LINE_BREAK: 7,
        LINK: 8,
        MEDIA: 9,
        MACRO: 10,
        EMOJI: 11
    };
    const $8c7a9474c5649f43$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE,
            (0, (0, parcelRequire("kSL4h")).TokenType).RULER
        ];
        const output = [];
        let index = position;
        let currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
        let buffer = [];
        let cellsBuffer = [];
        let cellStyle = '';
        let builder = null;
        while(index < input.length){
            const char = input.charAt(index);
            const substring = input.substring(index);
            switch(currentState){
                case $8c7a9474c5649f43$var$processState.NEW_ROW:
                    {
                        const tableMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                        if (tableMatch) {
                            if (!builder) builder = new (0, (0, parcelRequire("48GZN")).TableBuilder)(schema);
                            index += tableMatch[1].length;
                            cellStyle = tableMatch[2];
                            index += tableMatch[2].length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        }
                        currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.LINE_BREAK:
                    {
                        const emptyLineMatch = substring.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP);
                        if (emptyLineMatch) {
                            $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                            currentState = $8c7a9474c5649f43$var$processState.END_TABLE;
                            continue;
                        }
                        const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                        if (cellMatch) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                        else currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.BUFFER:
                    {
                        const length = (0, (0, parcelRequire("eWAZI")).parseNewlineOnly)(substring);
                        if (length) {
                            const endIndex = index;
                            const startIndex = input.lastIndexOf('|', endIndex) + 1;
                            const charsBefore = input.substring(startIndex, endIndex);
                            if (charsBefore === '' || charsBefore.match($8c7a9474c5649f43$var$EMPTY_LINE_REGEXP)) currentState = $8c7a9474c5649f43$var$processState.CLOSE_ROW;
                            else {
                                currentState = $8c7a9474c5649f43$var$processState.LINE_BREAK;
                                buffer.push(input.substr(index, length));
                            }
                            index += length;
                            continue;
                        }
                        switch(char){
                            case '|':
                                {
                                    $8c7a9474c5649f43$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                    buffer = [];
                                    const cellMatch = substring.match($8c7a9474c5649f43$var$CELL_REGEXP);
                                    if (cellMatch) {
                                        cellStyle = cellMatch[2];
                                        index += cellMatch[2].length;
                                        continue;
                                    }
                                    break;
                                }
                            case ':':
                            case ';':
                            case '(':
                                currentState = $8c7a9474c5649f43$var$processState.EMOJI;
                                continue;
                            case '[':
                                currentState = $8c7a9474c5649f43$var$processState.LINK;
                                continue;
                            case '!':
                                currentState = $8c7a9474c5649f43$var$processState.MEDIA;
                                continue;
                            case '{':
                                currentState = $8c7a9474c5649f43$var$processState.MACRO;
                                continue;
                            default:
                                buffer.push(char);
                                index++;
                                continue;
                        }
                        break;
                    }
                case $8c7a9474c5649f43$var$processState.CLOSE_ROW:
                    {
                        const bufferOutput = buffer.join('');
                        if (bufferOutput.trim().length > 0) {
                            $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                            buffer = [];
                        }
                        if (builder) {
                            builder.add(cellsBuffer);
                            cellsBuffer = [];
                        }
                        currentState = $8c7a9474c5649f43$var$processState.NEW_ROW;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.END_TABLE:
                    if (builder) {
                        if (cellsBuffer.length) builder.add(cellsBuffer);
                        output.push(builder.buildPMNode());
                    }
                    return {
                        type: 'pmnode',
                        nodes: output,
                        length: index - position
                    };
                case $8c7a9474c5649f43$var$processState.MEDIA:
                    {
                        const token = (0, (0, parcelRequire("4Foyv")).media)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.EMOJI:
                    {
                        const token = (0, (0, parcelRequire("jor5q")).emoji)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
                case $8c7a9474c5649f43$var$processState.LINK:
                    {
                        const token = (0, (0, parcelRequire("7tIdE")).linkFormat)({
                            input: input,
                            schema: schema,
                            context: context,
                            position: index
                        });
                        if (token.type === 'text') {
                            buffer.push(token.text);
                            index += token.length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        } else if (token.type === 'pmnode') {
                            buffer.push(input.substr(index, token.length));
                            index += token.length;
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            continue;
                        }
                        break;
                    }
                case $8c7a9474c5649f43$var$processState.MACRO:
                    {
                        const match = (0, (0, parcelRequire("cG4PY")).parseMacroKeyword)(input.substring(index));
                        if (!match) {
                            buffer.push(char);
                            currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                            break;
                        }
                        const token = (0, (0, parcelRequire("kSL4h")).parseToken)(input, match.type, index, schema, context);
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $8c7a9474c5649f43$var$processState.BUFFER;
                        continue;
                    }
            }
            index++;
        }
        const bufferOutput = buffer.join('');
        if (bufferOutput.trim().length > 0) $8c7a9474c5649f43$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
        if (builder) {
            if (cellsBuffer.length) builder.add(cellsBuffer);
            output.push(builder.buildPMNode());
        }
        return {
            type: 'pmnode',
            nodes: output,
            length: index - position
        };
    };
    function $8c7a9474c5649f43$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
        if (buffer.length) {
            let contentNode = (0, (0, parcelRequire("29zBb")).parseString)({
                schema: schema,
                context: context,
                ignoreTokenTypes: ignoreTokenTypes,
                input: buffer
            });
            if (style === '||') contentNode = contentNode.map((e)=>{
                return $8c7a9474c5649f43$var$createTableHeader(e, schema);
            });
            cellsBuffer.push({
                style: style,
                content: (0, (0, parcelRequire("20lXC")).normalizePMNodes)(contentNode, schema)
            });
        }
    }
    function $8c7a9474c5649f43$var$createTableHeader(node, schema) {
        const mark = schema.marks.strong.create();
        return $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema);
    }
    function $8c7a9474c5649f43$var$traverseContent(node, mark, schema) {
        if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
        for(let i = 0; i < node.content.childCount; i++){
            const child = node.content.child(i);
            const markedChild = $8c7a9474c5649f43$var$traverseNodeAndAddMarks(child, mark, schema);
            const updatedContent = node.content.replaceChild(i, markedChild);
            node = node.copy(updatedContent);
        }
        return node;
    }
    function $8c7a9474c5649f43$var$traverseNodeAndAddMarks(node, mark, schema) {
        if (node.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(node, [
            'strong',
            'code'
        ])) {
            const newNode = node.mark([
                ...node.marks,
                mark
            ]);
            return newNode;
        }
        return $8c7a9474c5649f43$var$traverseContent(node, mark, schema);
    }
});
parcelRegister("48GZN", function(module, exports) {
    $parcel$export(module.exports, "TableBuilder", ()=>$75a71ab9390c3135$export$9e18c07f56f31a89);
    function $75a71ab9390c3135$var$getType(style) {
        return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
    }
    class $75a71ab9390c3135$export$9e18c07f56f31a89 {
        constructor(schema){
            this.emptyTableCell = ()=>{
                const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
                return tableCell.createChecked({}, paragraph.createChecked());
            };
            this.emptyTableRow = ()=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, this.emptyTableCell());
            };
            this.buildTableNode = ()=>{
                const { root: root } = this;
                const { table: table } = this.schema.nodes;
                const content = root.rows.map(this.buildTableRowNode);
                if (content.length === 0) content.push(this.emptyTableRow());
                return table.createChecked({}, content);
            };
            this.buildTableRowNode = (row)=>{
                const { tableRow: tableRow } = this.schema.nodes;
                return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
            };
            this.buildTableCellNode = (cell)=>{
                const { type: type, content: content } = cell;
                if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
                const cellNode = this.schema.nodes[type];
                return cellNode.createChecked({}, content);
            };
            this.schema = schema;
            this.root = {
                rows: []
            };
        }
        get type() {
            return 'table';
        }
        add(cells) {
            if (!cells.length) return;
            let index = 0;
            for (const cell of cells){
                const { content: content, style: style } = cell;
                const cellType = $75a71ab9390c3135$var$getType(style);
                if (index === 0) this.addRow();
                const newCell = {
                    type: cellType,
                    content: content
                };
                this.lastRow.cells.push(newCell);
                index += 1;
            }
        }
        buildPMNode() {
            return this.buildTableNode();
        }
        addRow() {
            const { rows: rows } = this.root;
            const row = {
                cells: []
            };
            rows.push(row);
            this.lastRow = row;
        }
    }
});
parcelRegister("ir9MO", function(module, exports) {
    $parcel$export(module.exports, "tripleDashSymbol", ()=>$0a377f498827084a$export$edbcd749367de060);
    var $1rQjR;
    const $0a377f498827084a$var$token = {
        type: 'text',
        text: '\u2014',
        length: 3
    };
    const $0a377f498827084a$var$fallback = {
        ...$0a377f498827084a$var$token,
        text: '---'
    };
    const $0a377f498827084a$export$edbcd749367de060 = (0, (0, parcelRequire("1rQjR")).createDashTokenParser)($0a377f498827084a$var$token, $0a377f498827084a$var$fallback);
});
parcelRegister("7E14k", function(module, exports) {
    $parcel$export(module.exports, "panelMacro", ()=>$fa58ef1a18570456$export$5d7bf7e31a674541);
    var $3JW2n;
    var $29zBb;
    var $4ZUg7;
    var $20lXC;
    var $fQoRM;
    var $1agyv;
    const $fa58ef1a18570456$var$allowedNodeType = [
        'paragraph',
        'heading',
        'orderedList',
        'bulletList'
    ];
    const $fa58ef1a18570456$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'panel',
            paired: true,
            context: context,
            rawContentProcessor: $fa58ef1a18570456$var$rawContentProcessor
        });
    };
    const $fa58ef1a18570456$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const output = [];
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const nodeAttrs = {
            ...parsedAttrs,
            panelType: (0, (0, parcelRequire("fQoRM")).getPanelType)(parsedAttrs)
        };
        const parsedContent = (0, (0, parcelRequire("29zBb")).parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: [],
            input: rawContent
        });
        const normalizedContent = (0, (0, parcelRequire("20lXC")).normalizePMNodes)(parsedContent, schema);
        let contentBuffer = parsedAttrs.title ? [
            (0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema)
        ] : [];
        for (const n of normalizedContent)if ($fa58ef1a18570456$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
        else {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
            contentBuffer = [];
            output.push(panelNode);
            output.push(n);
        }
        if (contentBuffer.length > 0) {
            const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
            output.push(panelNode);
        }
        return {
            type: 'pmnode',
            nodes: output.length ? output : [
                $fa58ef1a18570456$var$emptyPanel(schema)
            ],
            length: length
        };
    };
    function $fa58ef1a18570456$var$emptyPanel(schema) {
        const p = schema.nodes.paragraph.createChecked();
        return schema.nodes.panel.createChecked({}, p);
    }
});
parcelRegister("fQoRM", function(module, exports) {
    $parcel$export(module.exports, "getPanelType", ()=>$afb9d2bd4cb626dc$export$fa00fa3d6c22a747);
    var $4PfBJ;
    const $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX = {
        hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
        hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
        prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
    };
    const $afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB = {
        info: {
            r: 222,
            g: 235,
            b: 255
        },
        note: {
            r: 234,
            g: 230,
            b: 255
        },
        success: {
            r: 227,
            g: 252,
            b: 239
        },
        warning: {
            r: 255,
            g: 250,
            b: 230
        },
        error: {
            r: 255,
            g: 235,
            b: 230
        }
    };
    function $afb9d2bd4cb626dc$export$fa00fa3d6c22a747(attrs) {
        const rgb = $afb9d2bd4cb626dc$var$generateRgb(attrs.bgColor);
        if (!rgb) return 'info';
        let mapTo = 'info';
        let smallestDistance = Infinity;
        Object.keys($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
            const distance = $afb9d2bd4cb626dc$var$distanceOfRgb($afb9d2bd4cb626dc$var$PANEL_TYPE_TO_RGB[panelType], rgb);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                mapTo = panelType;
            }
        });
        return mapTo;
    }
    function $afb9d2bd4cb626dc$var$distanceOfRgb(a, b) {
        return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
    }
    function $afb9d2bd4cb626dc$var$generateRgb(color) {
        switch(true){
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort.test(color) || $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.test(color):
                return $afb9d2bd4cb626dc$var$parseHex(color);
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb.test(color):
                return $afb9d2bd4cb626dc$var$parseRgb(color);
            case $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb.test(color):
                return $afb9d2bd4cb626dc$var$parsePrgb(color);
            default:
                return $afb9d2bd4cb626dc$var$parseColorName(color);
        }
    }
    function $afb9d2bd4cb626dc$var$parseHex(hex) {
        hex = hex.replace($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
            return r + r + g + g + b + b;
        });
        const result = $afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parseRgb(rgb) {
        const result = rgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.rgb);
        return result ? {
            r: parseInt(result[1], 10),
            g: parseInt(result[2], 10),
            b: parseInt(result[3], 10)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parsePrgb(prgb) {
        const result = prgb.match($afb9d2bd4cb626dc$var$COLOR_TYPE_REGEX.prgb);
        return result ? {
            r: Math.floor(255 * parseInt(result[1], 10) / 100),
            g: Math.floor(255 * parseInt(result[2], 10) / 100),
            b: Math.floor(255 * parseInt(result[4], 10) / 100)
        } : null;
    }
    function $afb9d2bd4cb626dc$var$parseColorName(color) {
        return (0, (0, parcelRequire("4PfBJ")).default)[color];
    }
});
parcelRegister("4PfBJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe6de0fe9d8acfe8$export$2e2bcd8739ae039);
    const $fe6de0fe9d8acfe8$var$mapping = {
        crimson: {
            r: 220,
            g: 20,
            b: 60
        },
        lightpink: {
            r: 255,
            g: 182,
            b: 193
        },
        pink: {
            r: 255,
            g: 192,
            b: 203
        },
        palevioletred: {
            r: 219,
            g: 112,
            b: 147
        },
        lavenderblush: {
            r: 255,
            g: 240,
            b: 245
        },
        hotpink: {
            r: 255,
            g: 105,
            b: 180
        },
        deeppink: {
            r: 255,
            g: 20,
            b: 147
        },
        mediumvioletred: {
            r: 199,
            g: 21,
            b: 133
        },
        orchid: {
            r: 218,
            g: 112,
            b: 214
        },
        thistle: {
            r: 216,
            g: 191,
            b: 216
        },
        plum: {
            r: 221,
            g: 160,
            b: 221
        },
        violet: {
            r: 238,
            g: 130,
            b: 238
        },
        fuchsia: {
            r: 255,
            g: 0,
            b: 255
        },
        darkmagenta: {
            r: 139,
            g: 0,
            b: 139
        },
        purple: {
            r: 128,
            g: 0,
            b: 128
        },
        mediumorchid: {
            r: 186,
            g: 85,
            b: 211
        },
        darkviolet: {
            r: 148,
            g: 0,
            b: 211
        },
        darkorchid: {
            r: 153,
            g: 50,
            b: 204
        },
        indigo: {
            r: 75,
            g: 0,
            b: 130
        },
        blueviolet: {
            r: 138,
            g: 43,
            b: 226
        },
        mediumpurple: {
            r: 147,
            g: 112,
            b: 219
        },
        darkslateblue: {
            r: 72,
            g: 61,
            b: 139
        },
        mediumslateblue: {
            r: 123,
            g: 104,
            b: 238
        },
        slateblue: {
            r: 106,
            g: 90,
            b: 205
        },
        ghostwhite: {
            r: 248,
            g: 248,
            b: 255
        },
        lavender: {
            r: 230,
            g: 230,
            b: 250
        },
        blue: {
            r: 0,
            g: 0,
            b: 255
        },
        mediumblue: {
            r: 0,
            g: 0,
            b: 205
        },
        darkblue: {
            r: 0,
            g: 0,
            b: 139
        },
        navy: {
            r: 0,
            g: 0,
            b: 128
        },
        midnightblue: {
            r: 25,
            g: 25,
            b: 112
        },
        royalblue: {
            r: 65,
            g: 105,
            b: 225
        },
        cornflowerblue: {
            r: 100,
            g: 149,
            b: 237
        },
        lightsteelblue: {
            r: 176,
            g: 196,
            b: 222
        },
        lightslategray: {
            r: 119,
            g: 136,
            b: 153
        },
        slategray: {
            r: 112,
            g: 128,
            b: 144
        },
        dodgerblue: {
            r: 30,
            g: 144,
            b: 255
        },
        aliceblue: {
            r: 240,
            g: 248,
            b: 255
        },
        steelblue: {
            r: 70,
            g: 130,
            b: 180
        },
        lightskyblue: {
            r: 135,
            g: 206,
            b: 250
        },
        skyblue: {
            r: 135,
            g: 206,
            b: 235
        },
        deepskyblue: {
            r: 0,
            g: 191,
            b: 255
        },
        lightblue: {
            r: 173,
            g: 216,
            b: 230
        },
        powderblue: {
            r: 176,
            g: 224,
            b: 230
        },
        cadetblue: {
            r: 95,
            g: 158,
            b: 160
        },
        darkturquoise: {
            r: 0,
            g: 206,
            b: 209
        },
        azure: {
            r: 240,
            g: 255,
            b: 255
        },
        lightcyan: {
            r: 224,
            g: 255,
            b: 255
        },
        paleturquoise: {
            r: 174,
            g: 238,
            b: 238
        },
        darkslategray: {
            r: 47,
            g: 79,
            b: 79
        },
        aqua: {
            r: 0,
            g: 255,
            b: 255
        },
        darkcyan: {
            r: 0,
            g: 139,
            b: 139
        },
        teal: {
            r: 0,
            g: 128,
            b: 128
        },
        mediumturquoise: {
            r: 72,
            g: 209,
            b: 204
        },
        lightseagreen: {
            r: 32,
            g: 178,
            b: 170
        },
        turquoise: {
            r: 64,
            g: 224,
            b: 208
        },
        aquamarine: {
            r: 127,
            g: 255,
            b: 212
        },
        mediumaquamarine: {
            r: 102,
            g: 205,
            b: 170
        },
        mediumspringgreen: {
            r: 0,
            g: 250,
            b: 154
        },
        mintcream: {
            r: 245,
            g: 255,
            b: 250
        },
        springgreen: {
            r: 0,
            g: 255,
            b: 127
        },
        mediumseagreen: {
            r: 60,
            g: 179,
            b: 113
        },
        seagreen: {
            r: 46,
            g: 139,
            b: 87
        },
        honeydew: {
            r: 240,
            g: 255,
            b: 240
        },
        darkseagreen: {
            r: 143,
            g: 188,
            b: 143
        },
        palegreen: {
            r: 152,
            g: 251,
            b: 152
        },
        lightgreen: {
            r: 144,
            g: 238,
            b: 144
        },
        limegreen: {
            r: 50,
            g: 205,
            b: 50
        },
        forestgreen: {
            r: 34,
            g: 139,
            b: 34
        },
        lime: {
            r: 0,
            g: 255,
            b: 0
        },
        green: {
            r: 0,
            g: 128,
            b: 0
        },
        darkgreen: {
            r: 0,
            g: 100,
            b: 0
        },
        lawngreen: {
            r: 124,
            g: 252,
            b: 0
        },
        chartreuse: {
            r: 127,
            g: 255,
            b: 0
        },
        greenyellow: {
            r: 173,
            g: 255,
            b: 47
        },
        darkolivegreen: {
            r: 85,
            g: 107,
            b: 47
        },
        olivedrab: {
            r: 107,
            g: 142,
            b: 35
        },
        yellowgreen: {
            r: 154,
            g: 205,
            b: 50
        },
        ivory: {
            r: 255,
            g: 255,
            b: 240
        },
        beige: {
            r: 245,
            g: 245,
            b: 220
        },
        lightyellow: {
            r: 255,
            g: 255,
            b: 224
        },
        lightgoldenrodyellow: {
            r: 250,
            g: 250,
            b: 210
        },
        yellow: {
            r: 255,
            g: 255,
            b: 0
        },
        olive: {
            r: 128,
            g: 128,
            b: 0
        },
        darkkhaki: {
            r: 189,
            g: 183,
            b: 107
        },
        khaki: {
            r: 240,
            g: 230,
            b: 140
        },
        palegoldenrod: {
            r: 238,
            g: 232,
            b: 170
        },
        lemonchiffon: {
            r: 255,
            g: 250,
            b: 205
        },
        gold: {
            r: 255,
            g: 215,
            b: 0
        },
        cornsilk: {
            r: 255,
            g: 248,
            b: 220
        },
        goldenrod: {
            r: 218,
            g: 165,
            b: 32
        },
        darkgoldenrod: {
            r: 184,
            g: 134,
            b: 11
        },
        orange: {
            r: 255,
            g: 128,
            b: 0
        },
        floralwhite: {
            r: 255,
            g: 250,
            b: 240
        },
        oldlace: {
            r: 253,
            g: 245,
            b: 230
        },
        wheat: {
            r: 245,
            g: 222,
            b: 179
        },
        moccasin: {
            r: 255,
            g: 228,
            b: 181
        },
        papayawhip: {
            r: 255,
            g: 239,
            b: 213
        },
        blanchedalmond: {
            r: 255,
            g: 235,
            b: 205
        },
        navajowhite: {
            r: 255,
            g: 222,
            b: 173
        },
        tan: {
            r: 210,
            g: 180,
            b: 140
        },
        antiquewhite: {
            r: 250,
            g: 235,
            b: 215
        },
        burlywood: {
            r: 222,
            g: 184,
            b: 135
        },
        bisque: {
            r: 255,
            g: 228,
            b: 196
        },
        darkorange: {
            r: 255,
            g: 140,
            b: 0
        },
        peru: {
            r: 205,
            g: 133,
            b: 63
        },
        linen: {
            r: 250,
            g: 240,
            b: 230
        },
        peachpuff: {
            r: 255,
            g: 218,
            b: 185
        },
        seashell: {
            r: 255,
            g: 245,
            b: 238
        },
        sandybrown: {
            r: 244,
            g: 164,
            b: 96
        },
        chocolate: {
            r: 210,
            g: 105,
            b: 30
        },
        saddlebrown: {
            r: 139,
            g: 69,
            b: 19
        },
        sienna: {
            r: 160,
            g: 82,
            b: 45
        },
        lightsalmon: {
            r: 255,
            g: 160,
            b: 122
        },
        coral: {
            r: 255,
            g: 127,
            b: 80
        },
        orangered: {
            r: 255,
            g: 69,
            b: 0
        },
        darksalmon: {
            r: 233,
            g: 150,
            b: 122
        },
        tomato: {
            r: 255,
            g: 99,
            b: 71
        },
        salmon: {
            r: 250,
            g: 128,
            b: 114
        },
        mistyrose: {
            r: 255,
            g: 228,
            b: 225
        },
        snow: {
            r: 255,
            g: 250,
            b: 250
        },
        rosybrown: {
            r: 188,
            g: 143,
            b: 143
        },
        lightcoral: {
            r: 240,
            g: 128,
            b: 128
        },
        indianred: {
            r: 205,
            g: 92,
            b: 92
        },
        brown: {
            r: 165,
            g: 42,
            b: 42
        },
        firebrick: {
            r: 178,
            g: 34,
            b: 34
        },
        red: {
            r: 255,
            g: 0,
            b: 0
        },
        darkred: {
            r: 139,
            g: 0,
            b: 0
        },
        maroon: {
            r: 128,
            g: 0,
            b: 0
        },
        white: {
            r: 255,
            g: 255,
            b: 255
        },
        gainsboro: {
            r: 220,
            g: 220,
            b: 220
        },
        lightgray: {
            r: 211,
            g: 211,
            b: 211
        },
        silver: {
            r: 192,
            g: 192,
            b: 192
        },
        darkgray: {
            r: 169,
            g: 169,
            b: 169
        },
        gray: {
            r: 128,
            g: 128,
            b: 128
        },
        dimgray: {
            r: 105,
            g: 105,
            b: 105
        },
        black: {
            r: 0,
            g: 0,
            b: 0
        },
        whitesmoke: {
            r: 245,
            g: 245,
            b: 245
        }
    };
    var $fe6de0fe9d8acfe8$export$2e2bcd8739ae039 = $fe6de0fe9d8acfe8$var$mapping;
});
parcelRegister("1agyv", function(module, exports) {
    $parcel$export(module.exports, "title", ()=>$9eccd901f1df184b$export$fb184b623420d9be);
    function $9eccd901f1df184b$export$fb184b623420d9be(text, schema) {
        const mark = schema.marks.strong.create();
        const title = schema.text(text, [
            mark
        ]);
        return schema.nodes.paragraph.createChecked({}, [
            title
        ]);
    }
});
parcelRegister("9MeiU", function(module, exports) {
    $parcel$export(module.exports, "adfMacro", ()=>$39fb2727ee273b16$export$8fb4b58db8f664fb);
    var $3JW2n;
    const $39fb2727ee273b16$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'adf',
            paired: true,
            context: context,
            rawContentProcessor: $39fb2727ee273b16$var$rawContentProcessor
        });
    };
    const $39fb2727ee273b16$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
        try {
            const json = JSON.parse(rawContent);
            const node = schema.nodeFromJSON(json);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        } catch (_e) {
            const textContent = `Invalid ADF Macro: ${rawContent}`;
            const textNode = rawContent.length ? schema.text(textContent) : undefined;
            const { codeBlock: codeBlock } = schema.nodes;
            const node = codeBlock.create({
                language: undefined
            }, textNode);
            return {
                type: 'pmnode',
                nodes: [
                    node
                ],
                length: length
            };
        }
    };
});
parcelRegister("f50H1", function(module, exports) {
    $parcel$export(module.exports, "anchorMacro", ()=>$4b331e3d410cf176$export$e660dadc21580fa2);
    var $3JW2n;
    const $4b331e3d410cf176$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'anchor',
            paired: false,
            context: context,
            rawContentProcessor: $4b331e3d410cf176$var$rawContentProcessor
        });
    };
    const $4b331e3d410cf176$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
        return {
            type: 'text',
            text: '',
            length: length
        };
    };
});
parcelRegister("bSil4", function(module, exports) {
    $parcel$export(module.exports, "codeMacro", ()=>$38ee74463de0ec95$export$db6c131ac26c7700);
    var $3JW2n;
    var $4ZUg7;
    var $1agyv;
    const $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES = [
        'abap',
        'actionscript',
        'ada',
        'arduino',
        'autoit',
        'c',
        'c++',
        'clojure',
        'coffeescript',
        'csharp',
        'css',
        'cuda',
        'd',
        'dart',
        'delphi',
        'elixir',
        'erlang',
        'fortran',
        'foxpro',
        'go',
        'groovy',
        'haskell',
        'haxe',
        'html',
        'java',
        'javascript',
        'json',
        'julia',
        'kotlin',
        'latex',
        'livescript',
        'lua',
        'mathematica',
        'matlab',
        'objective-c',
        'objective-j',
        'objectpascal',
        'ocaml',
        'octave',
        'perl',
        'php',
        'powershell',
        'prolog',
        'puppet',
        'python',
        'qml',
        'r',
        'racket',
        'restructuredtext',
        'ruby',
        'rust',
        'sass',
        'scala',
        'scheme',
        'shell',
        'smalltalk',
        'sql',
        'standardml',
        'swift',
        'tcl',
        'tex',
        'typescript',
        'vala',
        'vbnet',
        'verilog',
        'vhdl',
        'xml',
        'xquery'
    ];
    const $38ee74463de0ec95$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'code',
            paired: true,
            context: context,
            rawContentProcessor: $38ee74463de0ec95$var$rawContentProcessor
        });
    };
    const $38ee74463de0ec95$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema));
        const nodeAttrs = {
            ...parsedAttrs,
            language: $38ee74463de0ec95$var$getCodeLanguage(parsedAttrs)
        };
        output.push(codeBlock.createChecked(nodeAttrs, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
    function $38ee74463de0ec95$var$getCodeLanguage(attrs) {
        const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
        for (const language of $38ee74463de0ec95$var$SUPPORTED_CODEBOCK_LANGUAGES){
            if (keys.indexOf(language) !== -1) return language;
        }
        if (keys.indexOf('objc') !== -1) return 'objective-c';
        return 'java';
    }
});
parcelRegister("cjZPi", function(module, exports) {
    $parcel$export(module.exports, "colorMacro", ()=>$2374771f8fbda9ef$export$b557be495948d995);
    var $kSL4h;
    var $3JW2n;
    var $4ZUg7;
    var $29zBb;
    var $7p5zM;
    var $gxAE9;
    const $2374771f8fbda9ef$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'color',
            paired: true,
            context: context,
            rawContentProcessor: $2374771f8fbda9ef$var$rawContentProcessor
        });
    };
    const $2374771f8fbda9ef$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
        const ignoreTokenTypes = [
            (0, (0, parcelRequire("kSL4h")).TokenType).DOUBLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TRIPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).QUADRUPLE_DASH_SYMBOL,
            (0, (0, parcelRequire("kSL4h")).TokenType).TABLE
        ];
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const content = (0, (0, parcelRequire("29zBb")).parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: rawContent
        });
        const decoratedContent = content.map((n)=>{
            const mark = schema.marks.textColor.create({
                color: (0, (0, parcelRequire("7p5zM")).getEditorColor)(parsedAttrs) || '#000000'
            });
            if (n.type.name === 'text' && !(0, (0, parcelRequire("gxAE9")).hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) return n.mark([
                ...n.marks,
                mark
            ]);
            return n;
        });
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
});
parcelRegister("7p5zM", function(module, exports) {
    $parcel$export(module.exports, "getEditorColor", ()=>$dace0eb9654d7c1b$export$c0cfc6f23e0b7578);
    var $51H8P;
    function $dace0eb9654d7c1b$export$c0cfc6f23e0b7578(attrs) {
        const keys = Object.keys(attrs);
        return (0, (0, parcelRequire("51H8P")).normalizeHexColor)(keys[0]);
    }
});
parcelRegister("8tGpW", function(module, exports) {
    $parcel$export(module.exports, "noformatMacro", ()=>$7fe042bf55811a5b$export$9199752eb9b2d5b4);
    var $3JW2n;
    var $4ZUg7;
    var $1agyv;
    const $7fe042bf55811a5b$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
        return (0, (0, parcelRequire("3JW2n")).commonMacro)(input.substring(position), schema, {
            keyword: 'noformat',
            paired: true,
            context: context,
            rawContentProcessor: $7fe042bf55811a5b$var$rawContentProcessor
        });
    };
    const $7fe042bf55811a5b$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
        const output = [];
        const { codeBlock: codeBlock } = schema.nodes;
        const parsedAttrs = (0, (0, parcelRequire("4ZUg7")).parseAttrs)(rawAttrs);
        const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
        const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
        if (parsedAttrs.title) output.push((0, (0, parcelRequire("1agyv")).title)(parsedAttrs.title, schema));
        output.push(codeBlock.createChecked({}, textNode));
        return {
            type: 'pmnode',
            nodes: output,
            length: length
        };
    };
});
parcelRegister("lyI5i", function(module, exports) {
    $parcel$export(module.exports, "forceLineBreak", ()=>$90e9f72be02de2ac$export$2de3d7fd25cbc36);
    const $90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
    const $90e9f72be02de2ac$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
        if (position > 0) {
            const charBefore = input.charAt(position - 1);
            if (charBefore === '\\') return $90e9f72be02de2ac$var$fallback(input, position);
        }
        const match = input.substring(position).match($90e9f72be02de2ac$var$FORCE_LINE_BREAK_REGEX);
        if (match) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.hardBreak.createChecked()
            ],
            length: 2
        };
        return $90e9f72be02de2ac$var$fallback(input, position);
    };
    function $90e9f72be02de2ac$var$fallback(input, position) {
        return {
            type: 'text',
            text: input.substr(position, 2),
            length: 2
        };
    }
});
parcelRegister("4yZSi", function(module, exports) {
    $parcel$export(module.exports, "code", ()=>$e115b67b9a7c1782$export$6565f9f03506010b);
    const $e115b67b9a7c1782$export$6565f9f03506010b = (text)=>{
        return `{{${text}}}`;
    };
});
parcelRegister("aDTWq", function(module, exports) {
    $parcel$export(module.exports, "textColor", ()=>$ef3e88b1064ccc35$export$32f78bffcd82ff28);
    const $ef3e88b1064ccc35$export$32f78bffcd82ff28 = (text, attrs)=>{
        return `{color:${attrs.color}}${text}{color}`;
    };
});
parcelRegister("gdFeW", function(module, exports) {
    $parcel$export(module.exports, "em", ()=>$e431017de2633455$export$c63c6f932822f543);
    var $3ovek;
    const $e431017de2633455$export$c63c6f932822f543 = (text)=>{
        if (text.startsWith("\u2014 ")) return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text.substring(2), '??');
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '_');
    };
});
parcelRegister("3ovek", function(module, exports) {
    $parcel$export(module.exports, "baseMarkPattern", ()=>$7f6f940a63ef31a6$export$3d8aed7830783c75);
    const $7f6f940a63ef31a6$export$3d8aed7830783c75 = (text, token)=>{
        if (/^\s*$/.test(text)) return text;
        return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
    };
});
parcelRegister("jo5YT", function(module, exports) {
    $parcel$export(module.exports, "link", ()=>$5614ddd827a3bd70$export$9c30223ca0a664fb);
    const $5614ddd827a3bd70$export$9c30223ca0a664fb = (text, attrs)=>{
        return `[${text}|${attrs.href}]`;
    };
});
parcelRegister("9fwgI", function(module, exports) {
    $parcel$export(module.exports, "strike", ()=>$486b01102f007d8c$export$4899a95d70ec5056);
    var $3ovek;
    const $486b01102f007d8c$export$4899a95d70ec5056 = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '-');
    };
});
parcelRegister("eKxrE", function(module, exports) {
    $parcel$export(module.exports, "strong", ()=>$5f94e33f4e7efc4b$export$59ae2c325a998f89);
    var $3ovek;
    const $5f94e33f4e7efc4b$export$59ae2c325a998f89 = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '*');
    };
});
parcelRegister("1x55I", function(module, exports) {
    $parcel$export(module.exports, "subsup", ()=>$de8ae0bb6a3c8a22$export$b3401ee80eb31041);
    var $3ovek;
    const $de8ae0bb6a3c8a22$export$b3401ee80eb31041 = (text, attrs)=>{
        if (attrs.type === 'sub') return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '~');
        else return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '^');
    };
});
parcelRegister("8tKGr", function(module, exports) {
    $parcel$export(module.exports, "underline", ()=>$bb8b641056119651$export$425327af25286e5e);
    var $3ovek;
    const $bb8b641056119651$export$425327af25286e5e = (text)=>{
        return (0, (0, parcelRequire("3ovek")).baseMarkPattern)(text, '+');
    };
});
parcelRegister("5IuwX", function(module, exports) {
    $parcel$export(module.exports, "inlineCard", ()=>$c6769d560338119d$export$cbf8224b64e0d942);
    var $1Nefo;
    var $bOMPB;
    const $c6769d560338119d$export$cbf8224b64e0d942 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        const match = node.attrs.url.match((0, (0, parcelRequire("bOMPB")).INLINE_CARD_FROM_TEXT_STAMP));
        if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
        return `[${match[2]}]`;
    };
});
parcelRegister("1HDja", function(module, exports) {
    $parcel$export(module.exports, "status", ()=>$d0c82c4f36685012$export$471f7ae5c4103ae1);
    var $aDTWq;
    const $d0c82c4f36685012$var$color = {
        grey: (0, $829f609a65d26a98$export$eaa8c8a70ac22806),
        purple: (0, $829f609a65d26a98$export$b48405b95304b5a1),
        blue: (0, $829f609a65d26a98$export$9dc1ef0f3f48059b),
        red: (0, $829f609a65d26a98$export$4a7404f376229999),
        yellow: (0, $829f609a65d26a98$export$59619663aa6500fb),
        green: (0, $829f609a65d26a98$export$940e1f69e873f202)
    };
    const $d0c82c4f36685012$export$471f7ae5c4103ae1 = (node)=>{
        const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
        const newAttrs = {
            ...node.attrs
        };
        if ($d0c82c4f36685012$var$color[node.attrs.color]) newAttrs.color = $d0c82c4f36685012$var$color[node.attrs.color];
        else newAttrs.color = $d0c82c4f36685012$var$color['grey'];
        return (0, (0, parcelRequire("aDTWq")).textColor)(text, newAttrs);
    };
});
parcelRegister("c08Yp", function(module, exports) {
    $parcel$export(module.exports, "date", ()=>$61a6161cda09885d$export$324d90190a8b822a);
    const $61a6161cda09885d$export$324d90190a8b822a = (node)=>{
        const addLeadingZero = (val)=>{
            if (val < 10) return `0${val}`;
            return val;
        };
        const result = new Date(Number(node.attrs.timestamp));
        return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
    };
});
parcelRegister("73kPn", function(module, exports) {
    $parcel$export(module.exports, "codeBlock", ()=>$ef6a5d3a665df695$export$7bb0d5c671655cc4);
    var $bK2QZ;
    const $ef6a5d3a665df695$var$supportedLanguageInWiki = [
        'actionscript',
        'ada',
        'applescript',
        'bash',
        'c',
        'c#',
        'c++',
        'cpp',
        'css',
        'erlang',
        'go',
        'groovy',
        'haskell',
        'html',
        'java',
        'javascript',
        'js',
        'json',
        'lua',
        'none',
        'nyan',
        'objc',
        'perl',
        'php',
        'python',
        'r',
        'rainbow',
        'ruby',
        'scala',
        'sh',
        'sql',
        'swift',
        'visualbasic',
        'xml',
        'yaml'
    ];
    const $ef6a5d3a665df695$export$7bb0d5c671655cc4 = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                parent: node
            });
        });
        if ($ef6a5d3a665df695$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
        else return `{noformat}${result}{noformat}`;
    };
});
parcelRegister("eTlm6", function(module, exports) {
    $parcel$export(module.exports, "mediaGroup", ()=>$b3a3fb1c58065f07$export$2855e964765eac9);
    var $bsbI5;
    var $48ot6;
    var $1Nefo;
    const $b3a3fb1c58065f07$export$2855e964765eac9 = (node, opts = {})=>{
        const result = [];
        node.forEach((n)=>{
            switch(n.type.name){
                case 'media':
                    result.push((0, (0, parcelRequire("48ot6")).media)(n, {
                        ...opts,
                        parent: node
                    }));
                    break;
                case 'caption':
                    result.push((0, (0, parcelRequire("bsbI5")).caption)(n, opts));
                    break;
                default:
                    result.push((0, (0, parcelRequire("1Nefo")).unknown)(n));
                    break;
            }
        });
        return result.join('\n');
    };
});
parcelRegister("bsbI5", function(module, exports) {
    $parcel$export(module.exports, "caption", ()=>$58b84b7bf3a1608d$export$8e3c2dfdc4f0453d);
    var $bK2QZ;
    const $58b84b7bf3a1608d$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            });
        });
        return result;
    };
});
parcelRegister("48ot6", function(module, exports) {
    $parcel$export(module.exports, "media", ()=>$df984bb2074676e8$export$987d49ffe1b0900f);
    const $df984bb2074676e8$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
        let wikiAttrs = [];
        if (parent && parent.attrs.width) wikiAttrs.push(`width=${parent.attrs.width}%`);
        else {
            if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
            if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
        }
        if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
        if (node.marks.length) {
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
        }
        let fileName;
        if (node.attrs.type === 'external') fileName = node.attrs.url;
        else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
        if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
        if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
        return `!${fileName}|thumbnail!`;
    };
});
parcelRegister("hgytR", function(module, exports) {
    $parcel$export(module.exports, "taskList", ()=>$1fb2a139f9f264bf$export$375b6afcc5f4d291);
    var $4kMeo;
    const $1fb2a139f9f264bf$var$nestedNode = (node, depth = 1)=>{
        const result = [];
        node.forEach((item)=>{
            if (item.type.name === 'taskList') result.push($1fb2a139f9f264bf$var$nestedNode(item, depth + 1));
            else result.push((0, (0, parcelRequire("4kMeo")).taskItem)(item, depth));
        });
        return result.join('\n');
    };
    const $1fb2a139f9f264bf$export$375b6afcc5f4d291 = (node)=>{
        return $1fb2a139f9f264bf$var$nestedNode(node);
    };
});
parcelRegister("4kMeo", function(module, exports) {
    $parcel$export(module.exports, "taskItem", ()=>$b96ea7b246afcc42$export$6d8b0ef52e2e6390);
    var $bK2QZ;
    const $b96ea7b246afcc42$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            const prefix = Array(nestedLevel).fill('*').join('');
            if (node.attrs.state === 'DONE') result += `${prefix} -${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}-`;
            else result += `${prefix} ${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("b6sEJ", function(module, exports) {
    $parcel$export(module.exports, "decisionList", ()=>$9054c6d3a6a22504$export$62d45a65fb43d95e);
    var $h0oA4;
    const $9054c6d3a6a22504$export$62d45a65fb43d95e = (node)=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("h0oA4")).decisionItem)(item));
        });
        return result.join('\n');
    };
});
parcelRegister("h0oA4", function(module, exports) {
    $parcel$export(module.exports, "decisionItem", ()=>$6209b59f60b56dcd$export$6959e16eeff859b4);
    var $bK2QZ;
    const $6209b59f60b56dcd$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
        let result = '';
        node.forEach((n)=>{
            result += `* <> ${(0, (0, parcelRequire("bK2QZ")).inlines)(n, {
                context: context
            })}`;
        });
        return result;
    };
});
parcelRegister("1B6CN", function(module, exports) {
    $parcel$export(module.exports, "doc", ()=>$5ce407caf0707589$export$2a111da947c407d2);
    var $lxtC7;
    const $5ce407caf0707589$export$2a111da947c407d2 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return result.join('\n\n');
    };
});
parcelRegister("8UMD2", function(module, exports) {
    $parcel$export(module.exports, "expand", ()=>$dcda58106fc3b9ff$export$9f77e0932fb78f72);
    var $lxtC7;
    const $dcda58106fc3b9ff$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
        const result = [
            `*${node.attrs.title}*`,
            ''
        ];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return result.join('\n');
    };
});
parcelRegister("fIzNZ", function(module, exports) {
    $parcel$export(module.exports, "heading", ()=>$2a94cb79881b69b7$export$46e4a324ac90507f);
    var $bK2QZ;
    const $2a94cb79881b69b7$export$46e4a324ac90507f = (node)=>{
        let result = '';
        node.forEach((n)=>{
            result += (0, (0, parcelRequire("bK2QZ")).inlines)(n);
        });
        return `h${node.attrs.level}. ${result}`;
    };
});
parcelRegister("h9tzi", function(module, exports) {
    $parcel$export(module.exports, "orderedList", ()=>$c2a8fd1ebb40e986$export$a5dc81035676e7a);
    var $bxtEu;
    const $c2a8fd1ebb40e986$export$a5dc81035676e7a = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((item)=>{
            result.push((0, (0, parcelRequire("bxtEu")).listItem)(item, '#', context));
        });
        return result.join('\n');
    };
});
parcelRegister("abXFq", function(module, exports) {
    $parcel$export(module.exports, "panel", ()=>$d8008c2d580ced87$export$21f42ab9b6679f44);
    var $lxtC7;
    const $d8008c2d580ced87$var$panelTypeColorMapping = {
        info: '#deebff',
        note: '#eae6ff',
        success: '#e3fcef',
        warning: '#fffae6',
        error: '#ffebe6'
    };
    const $d8008c2d580ced87$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        return `{panel:bgColor=${$d8008c2d580ced87$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
    };
});
parcelRegister("czgKo", function(module, exports) {
    $parcel$export(module.exports, "rule", ()=>$bf5c50b1fb980df8$export$fbeb3a3956e8a3c7);
    const $bf5c50b1fb980df8$export$fbeb3a3956e8a3c7 = (_node)=>{
        return '----';
    };
});
parcelRegister("acqkf", function(module, exports) {
    $parcel$export(module.exports, "table", ()=>$6deed74ceb5bf80f$export$9852986a3ec5f6a0);
    var $lxtC7;
    var $1Nefo;
    const $6deed74ceb5bf80f$export$9852986a3ec5f6a0 = (node, opts = {})=>{
        try {
            const result = [];
            node.forEach((n)=>{
                result.push($6deed74ceb5bf80f$var$tableRow(n, opts));
            });
            return result.join('\n');
        } catch (err) {
            return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        }
    };
    const $6deed74ceb5bf80f$var$tableRow = (node, opts = {})=>{
        let result = '';
        let separator = '|';
        node.forEach((n)=>{
            if (n.type.name === 'tableHeader') separator = '||';
            else separator = '|';
            result = `${result}${separator}${$6deed74ceb5bf80f$var$tableCell(n, opts)}`;
        });
        return `${result}${separator}`;
    };
    const $6deed74ceb5bf80f$var$tableCell = (node, { context: context } = {})=>{
        if ($6deed74ceb5bf80f$var$hasMergedCell(node)) throw new Error('Advanced feature of table is not supported');
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("lxtC7")).encode)(n, context));
        });
        const output = result.join('\n').trim();
        return output === '' ? ' ' : output;
    };
    const $6deed74ceb5bf80f$var$hasMergedCell = (node)=>{
        if (!node.attrs) return false;
        if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
        if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
        return false;
    };
});
parcelRegister("69N10", function(module, exports) {
    $parcel$export(module.exports, "blockCard", ()=>$0c06383b3aca4143$export$c4c2f833baaebdb8);
    var $1Nefo;
    const $0c06383b3aca4143$export$c4c2f833baaebdb8 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
    };
});
parcelRegister("12A17", function(module, exports) {
    $parcel$export(module.exports, "embedCard", ()=>$c9c7f4b278041854$export$be4283d9a1cb1ff6);
    var $1Nefo;
    const $c9c7f4b278041854$export$be4283d9a1cb1ff6 = (node)=>{
        if (!node.attrs.url) return (0, (0, parcelRequire("1Nefo")).unknown)(node);
        return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
    };
});
parcelRegister("djcbG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74f62fc9e2776603$export$2e2bcd8739ae039);
    var $29zBb;
    var $20lXC;
    class $74f62fc9e2776603$export$2e2bcd8739ae039 {
        constructor(schema, wikiMarkup){
            this.schema = schema;
            this.wikiMarkup = wikiMarkup;
        }
        getProseMirrorModel(context) {
            const content = (0, (0, parcelRequire("29zBb")).parseString)({
                context: context,
                ignoreTokenTypes: [],
                input: this.wikiMarkup,
                schema: this.schema
            });
            return this.schema.nodes.doc.createChecked({}, (0, (0, parcelRequire("20lXC")).normalizePMNodes)(content, this.schema, 'doc'));
        }
    }
});
parcelRegister("aQb3V", function(module, exports) {
    $parcel$export(module.exports, "getLearnMoreMessage", ()=>$8cc68cbdef3ac4a4$export$2c1e5dc35269c547);
    $parcel$export(module.exports, "getHelpText", ()=>$8cc68cbdef3ac4a4$export$188aeee1ab8948d8);
    $parcel$export(module.exports, "getErrorMessage", ()=>$8cc68cbdef3ac4a4$export$82f46aa4e6535a45);
    var $6s1PB;
    var $bGrWH;
    var $7vNya;
    var $dOrZq;
    const $8cc68cbdef3ac4a4$export$2c1e5dc35269c547 = (fieldHelpTextUrl)=>{
        const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
        const learnMoreMessages = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7vNya")).LEARN_MORE_MESSAGES_WITH_ISSUE_TERM) : (0, (0, parcelRequire("7vNya")).LEARN_MORE_MESSAGES);
        if (urlSuffix in learnMoreMessages) return learnMoreMessages[urlSuffix];
        return (0, (0, parcelRequire("dOrZq")).default).fieldHelpTextLabel;
    };
    const $8cc68cbdef3ac4a4$export$188aeee1ab8948d8 = (fieldHelpTextUrl, formatMessage)=>{
        const helperMessage = $8cc68cbdef3ac4a4$export$2c1e5dc35269c547(fieldHelpTextUrl);
        return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
    };
    const $8cc68cbdef3ac4a4$export$82f46aa4e6535a45 = (validationError, fieldName, formatMessage, formatNumber)=>{
        switch(validationError){
            case 0, (0, parcelRequire("bGrWH")).REQUIRED:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).requiredErrorMessage, {
                    fieldName: fieldName
                });
            case 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).labelsMaxErrorMessage, {
                    MAX_ALLOWED_LABELS: formatNumber((0, $d46ffa3990e23a4d$export$1fdf850c93de8bae))
                });
            case 0, $d46ffa3990e23a4d$export$e77d629cc732976d:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).labelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
                });
            case 0, $d46ffa3990e23a4d$export$618e922e89e8bcae:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).stringInvalidErrorMessage, {
                    fieldName: fieldName,
                    MAX_STRING_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$fe1a70381f6491b5))
                });
            case 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f:
                return formatMessage((0, (0, parcelRequire("dOrZq")).default).forgeLabelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $d46ffa3990e23a4d$export$9151073f92820ff8))
                });
            default:
                return validationError;
        }
    };
});
const $d46ffa3990e23a4d$export$9151073f92820ff8 = 255;
const $d46ffa3990e23a4d$export$fe1a70381f6491b5 = 255;
const $d46ffa3990e23a4d$export$1fdf850c93de8bae = 55;
const $d46ffa3990e23a4d$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $d46ffa3990e23a4d$export$e77d629cc732976d = 'LABELS INVALID';
const $d46ffa3990e23a4d$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $d46ffa3990e23a4d$export$618e922e89e8bcae = 'STRING_INVALID';
parcelRegister("7vNya", function(module, exports) {
    $parcel$export(module.exports, "LEARN_MORE_MESSAGES_WITH_ISSUE_TERM", ()=>$6a6781d11d912198$export$1b2b0fc2cd5817de);
    $parcel$export(module.exports, "LEARN_MORE_MESSAGES", ()=>$6a6781d11d912198$export$eedb1bf75e1efb26);
    var $dOrZq;
    const $6a6781d11d912198$var$LEARN_MORE_TYPES = {
        IssueTypes: '#IssueTypes',
        PriorityLevels: '#PriorityLevels',
        ResolutionTypes: '#ResolutionTypes',
        SecurityLevels: '#SecurityLevels'
    };
    const $6a6781d11d912198$export$1b2b0fc2cd5817de = {
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpIssueTypesIssueTermRefresh,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpPriorityLevels,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpResolutionDefinitions,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpSecurityLevels
    };
    const $6a6781d11d912198$export$eedb1bf75e1efb26 = {
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.IssueTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpIssueTypes,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.PriorityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpPriorityLevels,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpResolutionDefinitions,
        [$6a6781d11d912198$var$LEARN_MORE_TYPES.SecurityLevels]: (0, (0, parcelRequire("dOrZq")).default).fieldHelpSecurityLevels
    };
});
parcelRegister("dOrZq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c5d9a42d37b19ea$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c5d9a42d37b19ea$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        requiredErrorMessage: {
            "id": "issue-create-commons.common.field-message.required-error-message",
            "defaultMessage": "{fieldName} is required"
        },
        labelsInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
            "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
        },
        stringInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.string-invalid-error-message",
            "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
        },
        forgeLabelsInvalidErrorMessage: {
            "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
            "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
        },
        labelsMaxErrorMessage: {
            "id": "issue-create-commons.common.field-message.labels-max-error-message",
            "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
        },
        fieldHelpTextLabel: {
            "id": "issue-create-commons.common.field-message.field-help-text-label",
            "defaultMessage": "Learn more"
        },
        fieldHelpIssueTypes: {
            "id": "issue-create-commons.common.field-message.field-help-issue-types",
            "defaultMessage": "Learn about issue types"
        },
        fieldHelpPriorityLevels: {
            "id": "issue-create-commons.common.field-message.field-help-priority-levels",
            "defaultMessage": "Learn about priority levels"
        },
        fieldHelpResolutionDefinitions: {
            "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
            "defaultMessage": "Resolutions definitions"
        },
        fieldHelpSecurityLevels: {
            "id": "issue-create-commons.common.field-message.field-help-security-levels",
            "defaultMessage": "More on security levels"
        },
        fieldHelpIssueTypesIssueTermRefresh: {
            "id": "issue-create-commons.common.field-message.field-help-issue-types-issue-term-refresh",
            "defaultMessage": "Learn about work types"
        }
    });
});
parcelRegister("iblgc", function(module, exports) {
    $parcel$export(module.exports, "FieldSkeleton", ()=>$20aa6a3390c971a5$export$f102dad4aafe4ad4);
    $parcel$export(module.exports, "default", ()=>$20aa6a3390c971a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    var $YSJPS;
    const $20aa6a3390c971a5$export$f102dad4aafe4ad4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
            "data-testid": "issue-create-commons.common.ui.loader.skeleton"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Label, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null), (0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$var$Description, null));
    const $20aa6a3390c971a5$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, Array.from({
            length: skeletonCount
        }, (_, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($20aa6a3390c971a5$export$f102dad4aafe4ad4, {
                key: `field-skeleton-${index}`
            })));
    var $20aa6a3390c971a5$export$2e2bcd8739ae039 = $20aa6a3390c971a5$var$IssueCreateLoader;
    const $20aa6a3390c971a5$var$Label = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
                __cmplp.className
            ])
        });
    });
    $20aa6a3390c971a5$var$Label.displayName = 'LabelSkeleton';
    const $20aa6a3390c971a5$var$Description = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ipxbi _1bsb1mjv",
                __cmplp.className
            ])
        });
    });
    $20aa6a3390c971a5$var$Description.displayName = 'DescriptionSkeleton';
});
parcelRegister("86fzT", function(module, exports) {
    $parcel$export(module.exports, "generateKeyForRequiredFromUIM", ()=>$81f27e245685507d$export$920d96e4692b3d51);
    const $81f27e245685507d$export$920d96e4692b3d51 = (parameters)=>{
        const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
        return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
    };
});
parcelRegister("gLdtQ", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", ()=>$60f472fd3d28277e$export$7c7171667037b275);
    $parcel$export(module.exports, "closeMenuOnScroll", ()=>$60f472fd3d28277e$export$fe334d83c6aac80f);
    const $60f472fd3d28277e$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
    const $60f472fd3d28277e$var$MENU_CLOSE_SELECTORS = [
        $60f472fd3d28277e$export$7c7171667037b275
    ];
    const $60f472fd3d28277e$export$fe334d83c6aac80f = (e)=>{
        if ($60f472fd3d28277e$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
        return false;
    };
});
parcelRegister("aZJYe", function(module, exports) {
    $parcel$export(module.exports, "mutateAffectedServicesField", ()=>$3cf4650743fd53da$export$c5ca3c9d905a51f0);
    $parcel$export(module.exports, "transformDefaultAffectedServices", ()=>$3cf4650743fd53da$export$6f4e94c57a16128c);
    $parcel$export(module.exports, "useFetchAffectedServicesName", ()=>$3cf4650743fd53da$export$9abe2f602f72a411);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    var $2ngL6;
    const $3cf4650743fd53da$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
            affectedServicesField: {
                fieldId: fieldId,
                affectedServices: selectedAffectedServices.map(({ value: value })=>({
                        serviceId: value
                    }))
            }
        });
    const $3cf4650743fd53da$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
                value: service.serviceId
            }));
    const $3cf4650743fd53da$export$9abe2f602f72a411 = ()=>{
        const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
        const baseUrl = '';
        const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
            setLoading(true);
            (0, (0, parcelRequire("7f4tk")).default)(`${baseUrl}/rest/service-registry-api/service`, {
                method: 'POST',
                body: JSON.stringify({
                    ids: ids
                })
            }).then((response)=>{
                setLoading(false);
                setSelectedOptions((0, (0, parcelRequire("2ngL6")).mapServiceEntitiesToOptions)(response.services));
            }).catch((error)=>{
                setLoading(false);
                setSelectedOptions([]);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchAffectedServicesName',
                        packageName: 'jiraIssueCreateCommons',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        });
        return [
            {
                isLoading: isLoading
            },
            handleFetch.current
        ];
    };
});
parcelRegister("iZNZ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$edda9d683fcffdb7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $cNmdz;
    var $7C5S0;
    var $YSJPS;
    var $hpV4g;
    var $gLdtQ;
    var $id3OI;
    const $edda9d683fcffdb7$var$AssetsField = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, width: width, fieldProps: { value: value, onChange: onChange }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, fieldId: fieldId, defaultValue: defaultValue, isEditable: isEditable = true, nonEditableReason: nonEditableReason, selectedProject: selectedProject, selectedIssueType: selectedIssueType, ariaLabelledBy: ariaLabelledBy } = props;
        const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $5uXOq.useState)(true);
        const [selectedOptions, setSelectedOptions] = (0, $5uXOq.useState)([]);
        const [{ isLoading: isLoading }, fetchAssetsName] = (0, (0, parcelRequire("id3OI")).useFetchAssetsWithId)();
        const projectId = selectedProject?.value || '';
        let issueTypeId;
        if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        (0, $5uXOq.useEffect)(()=>{
            if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
                const ids = defaultValue.map(({ serializedOrigin: serializedOrigin })=>serializedOrigin);
                fetchAssetsName(ids, setSelectedOptions);
                setShouldFetchServiceName(false);
            } else setSelectedOptions(value);
        }, [
            defaultValue,
            fetchAssetsName,
            setSelectedOptions,
            shouldFetchServiceName,
            value
        ]);
        const getAssetsEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cNmdz")).default), {
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: selectedOptions,
                fieldId: fieldId,
                isInvalid: Boolean(error),
                isDisabled: !isEditable,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                issueTypeId: issueTypeId,
                projectId: projectId,
                fetchSuggestionsOnFocus: true,
                ariaLabelledBy: ariaLabelledBy
            });
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, getAssetsEdit()) : getAssetsEdit());
    };
    var $edda9d683fcffdb7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("id3OI")).transformDefaultAssets)
    })($edda9d683fcffdb7$var$AssetsField);
});
parcelRegister("cNmdz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0efd85d3b7b73672$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d7FF4;
    var $koVbs;
    var $lElIo;
    var $FtZX9;
    var $2NMNM;
    var $90yGq;
    var $hGU7l;
    var $46K19;
    const $0efd85d3b7b73672$export$b7cbf126c81503e1 = 300;
    const $0efd85d3b7b73672$var$normalizeOnChangeValues = (onChange)=>(updatedValues)=>onChange(updatedValues || []);
    const $0efd85d3b7b73672$var$AssetsEdit = (props)=>{
        const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, isDisabled: isDisabled, issueTypeId: issueTypeId, projectId: projectId, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabelledBy: ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [assetFilterName, setAssetFilterName] = (0, $5uXOq.useState)([]);
        const [, setAssetFilterConfigError] = (0, $5uXOq.useState)(false);
        const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("46K19")).fetchFieldFilterNames)(createAnalyticsEvent({}), fieldId, projectId, issueTypeId).then((result)=>{
                setAssetFilterName(result.map((res)=>`${res.appKey}/${res.originId}`));
            }).catch(()=>{
                setAssetFilterConfigError(true);
            });
        }, [
            fieldId,
            projectId,
            issueTypeId,
            createAnalyticsEvent
        ]);
        const searchAssets = (0, $5uXOq.useCallback)(async (query)=>{
            setLastFetchFailed(false);
            return (0, (0, parcelRequire("46K19")).fetchAssets)(query, autoCompleteUrl, accountId, assetFilterName, createAnalyticsEvent({})).catch(()=>{
                setLastFetchFailed(true);
                return [];
            });
        }, [
            autoCompleteUrl,
            accountId,
            assetFilterName,
            createAnalyticsEvent
        ]);
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await searchAssets();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const loadOptionsDebounced = (0, (0, parcelRequire("FtZX9")).default)(searchAssets, $0efd85d3b7b73672$export$b7cbf126c81503e1);
        const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, (0, parcelRequire("hGU7l")).default).failedFetch : (0, (0, parcelRequire("hGU7l")).default).noMatches), [
            formatMessage,
            lastFetchFailed
        ]);
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            fieldId: fieldId,
            loadOptions: loadOptionsDebounced,
            onChange: $0efd85d3b7b73672$var$normalizeOnChangeValues(onChange),
            autoFocus: false,
            ...defaultOptionsProps(),
            isClearable: Boolean(value),
            isMulti: true,
            value: value,
            validationState: isInvalid === true ? 'error' : null,
            noOptionsMessage: noOptionsMessage,
            placeholder: placeholder,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            classNamePrefix: classNamePrefix,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $0efd85d3b7b73672$export$2e2bcd8739ae039 = $0efd85d3b7b73672$var$AssetsEdit;
});
parcelRegister("hGU7l", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$85aec46678298565$export$2e2bcd8739ae039);
    var $7VHMR;
    var $85aec46678298565$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-assets.edit.no-matches",
            "defaultMessage": "No Matches"
        },
        failedFetch: {
            "id": "issue-field-assets.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        }
    });
});
parcelRegister("46K19", function(module, exports) {
    $parcel$export(module.exports, "mapAssetEntityToAssetOptions", ()=>$3afecf084ac33106$export$65ae210119db9fc5);
    $parcel$export(module.exports, "fetchFieldFilterNames", ()=>$3afecf084ac33106$export$668516cfbde240de);
    $parcel$export(module.exports, "fetchAssets", ()=>$3afecf084ac33106$export$6411291ff3741ab1);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7f4tk;
    var $eusud;
    const $3afecf084ac33106$export$65ae210119db9fc5 = (data)=>data.map(({ label: label, origin: origin })=>({
                label: label.value,
                value: `${origin.appKey}/${origin.originId}`
            }));
    const $3afecf084ac33106$export$668516cfbde240de = async (analyticsEvent, customFieldId, projectId, issueTypeId)=>{
        const queryString = issueTypeId === null || issueTypeId === undefined ? (0, ($parcel$interopDefault($ebyGx))).stringify({
            projectId: projectId
        }) : (0, ($parcel$interopDefault($ebyGx))).stringify({
            projectId: projectId,
            issueTypeId: issueTypeId
        });
        return (0, (0, parcelRequire("7f4tk")).default)(`/rest/assetinternalapi/latest/field/${customFieldId}/config?${queryString}`).then((response)=>response?.types || []).catch((error)=>{
            if (error.statusCode === 404) return Promise.resolve([]);
            (0, (0, parcelRequire("jcw0u")).default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    packageName: 'jiraIssueFieldAssets',
                    id: 'fetchFieldFilterNames'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
    const $3afecf084ac33106$export$6411291ff3741ab1 = async (inputValue = '', autoCompleteUrl, accountId, assetTypesFilter, analyticsEvent)=>{
        const queryParams = {
            prioritizedAssignee: accountId,
            query: inputValue,
            type: assetTypesFilter
        };
        const queryString = (0, ($parcel$interopDefault($ebyGx))).stringify(queryParams);
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${queryString}`).then((response)=>$3afecf084ac33106$export$65ae210119db9fc5(response.values)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    packageName: 'jiraIssueFieldAssets',
                    id: 'fetchAssets'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
});
parcelRegister("id3OI", function(module, exports) {
    $parcel$export(module.exports, "mapAssetOptionsToAssetEntity", ()=>$c1c03d516473406c$export$15c347a847be44f6);
    $parcel$export(module.exports, "mutateAssetsFields", ()=>$c1c03d516473406c$export$9067b9149eea3adb);
    $parcel$export(module.exports, "transformDefaultAssets", ()=>$c1c03d516473406c$export$42e188fe92589513);
    $parcel$export(module.exports, "useFetchAssetsWithId", ()=>$c1c03d516473406c$export$aa4b3faecd2997ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $7f4tk;
    var $46K19;
    const $c1c03d516473406c$export$15c347a847be44f6 = (options)=>options.map(({ value: value })=>({
                appKey: value.split('/')[0],
                originId: value.split('/')[1],
                serializedOrigin: value,
                value: value
            }));
    const $c1c03d516473406c$export$9067b9149eea3adb = (selectedAssets, fieldId)=>({
            assetsField: {
                fieldId: fieldId,
                assets: selectedAssets.map(({ value: value })=>({
                        appKey: value.split('/')[0],
                        originId: value.split('/')[1],
                        serializedOrigin: value,
                        value: value
                    }))
            }
        });
    const $c1c03d516473406c$export$42e188fe92589513 = (defaultAssets)=>defaultAssets.map(({ serializedOrigin: serializedOrigin })=>({
                value: serializedOrigin
            }));
    const $c1c03d516473406c$export$aa4b3faecd2997ab = ()=>{
        const [isLoading, setLoading] = (0, $5uXOq.useState)(false);
        const handleFetch = (0, $5uXOq.useRef)((ids, setSelectedOptions)=>{
            setLoading(true);
            Promise.all(ids.map((id)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/assetapi/asset/${id}`))).then((response)=>{
                setLoading(false);
                setSelectedOptions((0, (0, parcelRequire("46K19")).mapAssetEntityToAssetOptions)(response));
            }).catch((error)=>{
                setLoading(false);
                setSelectedOptions([]);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchAssetsWithId',
                        packageName: 'jiraIssueCreateCommons',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        });
        return [
            {
                isLoading: isLoading
            },
            handleFetch.current
        ];
    };
});
parcelRegister("5FwUN", function(module, exports) {
    $parcel$export(module.exports, "AssigneeField", ()=>$489f100aee3a6307$export$7c52097ee36bd91);
    $parcel$export(module.exports, "default", ()=>$489f100aee3a6307$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $7XYc4;
    var $koVbs;
    var $89S0t;
    var $leRCk;
    var $dCm1o;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    var $bfnma;
    var $5rYSU;
    const $489f100aee3a6307$export$7c52097ee36bd91 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { autoCompleteUrl: autoCompleteUrl = '', width: width = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? '100%' : props.width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
        const [{ data: loggedInUser }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        const onAssignToMeClick = ()=>{
            onChange(loggedInUser);
        };
        const onAddAssigneeKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (id && (event.key === 'Enter' || event.key === ' ')) {
                onChange(loggedInUser);
                setTimeout(()=>document.getElementById(id)?.focus());
            }
        }, [
            id,
            loggedInUser,
            onChange
        ]);
        const showAssignToMe = loggedInUser && !isReadOnly;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($489f100aee3a6307$var$FieldContainer, {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89S0t")).default), {
            ...fieldProps,
            value: value,
            onChange: onChange,
            shouldPreloadAssignToMe: true,
            autoCompleteUrl: autoCompleteUrl,
            enableAutomaticOption: true,
            autoFocus: autoFocus,
            isDisabled: isReadOnly,
            width: width,
            inputId: id,
            openMenuOnClick: true
        }), showAssignToMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            spacing: "none",
            onClick: onAssignToMeClick,
            onKeyDown: onAddAssigneeKeyDown,
            testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
        }, formatMessage((0, (0, parcelRequire("bfnma")).default).assignToMe)));
    };
    var $489f100aee3a6307$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateAssigneeField),
        transformDefaultValue: (0, (0, parcelRequire("5rYSU")).transformDefaultAssigneeValue)
    })($489f100aee3a6307$export$7c52097ee36bd91);
    const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("7C5S0")).FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1v091b66",
                __cmplp.className
            ])
        });
    });
    const $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("7C5S0")).FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1v091b66 _1wqpstnw _acx6idpf _1h0p1n1a",
                __cmplp.className
            ])
        });
    });
    const $489f100aee3a6307$var$FieldContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)(), $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOn, $489f100aee3a6307$var$FieldContainerStylesWithVisualRefreshFFOff);
});
parcelRegister("89S0t", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a7ac4b7108cf6a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $cr0SA;
    var $aWse0;
    var $ecbCU;
    var $5fc53;
    var $8zOmE;
    var $2NMNM;
    var $atdLB;
    var $duUGa;
    var $fhSLy;
    var $7lGt2;
    var $h36wX;
    var $kt8K4;
    const $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
    const $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience = new (0, (0, parcelRequire("duUGa")).UFOExperience)('inline-assignee-picker.field-options-load', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom,
        category: 'inline-assignee-picker.field-options-load'
    });
    const $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $3a7ac4b7108cf6a7$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ariaLabel: ariaLabel, ...fieldProps })=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const self = (0, $5uXOq.useRef)({
            previousQuery: undefined
        }).current;
        const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, (0, parcelRequire("kt8K4")).default)(autoCompleteUrl || '');
        const [assigneeValue, assigneeOptions] = (0, (0, parcelRequire("h36wX")).useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
        const [, { openDrawer: openDrawer }] = (0, (0, parcelRequire("ecbCU")).useInvitePeopleDrawer)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (loading) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'loading'
                }), 'inlineAssigneeOptions loading');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.start();
            }
            if (error) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'failed'
                }), 'inlineAssigneeOptions failed');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.failure();
            }
            if (users.length) {
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
                    actionSubject: 'inlineAssigneePicker',
                    action: 'loaded'
                }), 'inlineAssigneeOptions loaded');
                $3a7ac4b7108cf6a7$var$InlineAssigneeFieldOptionsLoadExperience.success();
            }
        }, [
            loading,
            error,
            users,
            createAnalyticsEvent
        ]);
        const handleSearch = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((query)=>{
                if (query === '' && self.previousQuery === undefined) return;
                query !== self.previousQuery && fetchUsers(query);
                self.previousQuery = query;
            }, searchDebounceTimeout), [
            fetchUsers,
            searchDebounceTimeout,
            self.previousQuery
        ]);
        const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
            onFocus?.(sessionId);
            if (!users || !users.length) fetchUsers();
        }, [
            onFocus,
            users,
            fetchUsers
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
            onBlur?.(sessionId);
            self.previousQuery = undefined;
        }, [
            onBlur,
            self
        ]);
        const handleOnChange = (0, $5uXOq.useCallback)((updatedValue, action)=>{
            if (!updatedValue || Array.isArray(updatedValue)) return;
            if (enablePeopleInvite && updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) {
                openDrawer(createAnalyticsEvent ?? null, {
                    inviteFlow: 'assignee'
                });
                onChange?.(value, action);
                return;
            }
            let newValue;
            if (updatedValue.id === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) || updatedValue.id === (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7)) newValue = null;
            else newValue = (0, (0, parcelRequire("fhSLy")).getUserFromUserOption)(updatedValue);
            onChange?.(newValue, action);
        }, [
            enablePeopleInvite,
            onChange,
            openDrawer,
            value,
            createAnalyticsEvent
        ]);
        const controlProps = openMenuOnClick ? {
            openMenuOnClick: openMenuOnClick,
            onOpen: handleOnFocus
        } : {
            onFocus: handleOnFocus
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cr0SA")).UserPicker), {
            inputId: inputId,
            fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
            autoFocus: autoFocus,
            placeholder: intl.formatMessage((0, (0, parcelRequire("7lGt2")).default).searchForAssignee),
            isLoading: loading,
            options: assigneeOptions,
            value: assigneeValue,
            isMulti: false,
            isClearable: false,
            onBlur: handleOnBlur,
            onChange: handleOnChange,
            onInputChange: handleSearch,
            subtle: isSubtle,
            appearance: appearance,
            width: width,
            isDisabled: isDisabled,
            ariaLabelledBy: fieldProps['aria-labelledby'],
            UNSAFE_hasDraggableParentComponent: true,
            ariaLabel: ariaLabel,
            ...controlProps
        });
    };
    var $3a7ac4b7108cf6a7$export$2e2bcd8739ae039 = $3a7ac4b7108cf6a7$var$InlineAssigneePickerEdit;
});
parcelRegister("cr0SA", function(module, exports) {
    $parcel$export(module.exports, "UserPicker", ()=>$ee13645786fb45b4$export$83e0c73b09b3a9cd);
    var $cb25w;
    var $iOwNT;
    var $7K5PP;
    var $jZA09;
    var $5uXOq = parcelRequire("5uXOq");
    var $d3gzD;
    var $2wgOn;
    var $dyegP;
    var $fuG1P;
    var $hcX3V;
    var $hrO1B;
    var $2vFqP;
    var $pk97C;
    var $7Jxgt = parcelRequire("7Jxgt");
    class $ee13645786fb45b4$export$164f4d95e5d7e2f5 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
            this.ufoId = (0, $7Jxgt.v4)();
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            experienceForId.start();
        }
        static{
            this.defaultProps = {
                width: 350,
                isMulti: false
            };
        }
        componentDidMount() {
            const experienceForId = (0, (0, parcelRequire("pk97C")).userPickerRenderedUfoExperience).getInstance(this.ufoId);
            if ([
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id
            ].includes(experienceForId.state.id)) experienceForId.success();
        }
        render() {
            const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
            const width = this.props.width;
            const SelectComponent = allowEmail ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
            const creatableProps = suggestEmailsForDomain ? (0, (0, parcelRequire("hcX3V")).getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, (0, parcelRequire("fuG1P")).getCreatableProps)(isValidEmail);
            const defaultPickerProps = {
                closeMenuOnScroll: closeMenuOnScroll,
                menuPortalTarget: menuPortalTarget,
                menuPosition: menuPosition,
                menuShouldBlockScroll: menuShouldBlockScroll,
                captureMenuScroll: captureMenuScroll,
                required: required
            };
            const pickerProps = allowEmail ? {
                ...defaultPickerProps,
                ...creatableProps,
                emailLabel: emailLabel
            } : {
                ...defaultPickerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pk97C")).UfoErrorBoundary), {
                id: this.ufoId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hrO1B")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2vFqP")).ExusUserSourceProvider), {
                fetchUserSource: loadUserSource
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3gzD")).BaseUserPickerWithoutAnalytics), {
                ...this.props,
                width: width,
                SelectComponent: SelectComponent,
                styles: (0, (0, parcelRequire("2wgOn")).getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, this.props.isInvalid),
                components: (0, (0, parcelRequire("dyegP")).getComponents)(isMulti, anchor),
                pickerProps: pickerProps
            }))));
        }
    }
    const $ee13645786fb45b4$export$83e0c73b09b3a9cd = (0, (0, parcelRequire("cb25w")).default)()($ee13645786fb45b4$export$164f4d95e5d7e2f5);
});
parcelRegister("iOwNT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59b6485f0cb008dd$export$2e2bcd8739ae039);
    var $9OU1i;
    var $3c98u;
    const $59b6485f0cb008dd$var$CreatableSelect = (0, (0, parcelRequire("3c98u")).default)((0, (0, parcelRequire("9OU1i")).default));
    var $59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;
});
parcelRegister("9OU1i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29f1caecd9c7d5a$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useCreatable", ()=>(parcelRequire("2HH7Y")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $2QhWf;
    var $2HH7Y;
    var $9uJ4X;
    const $b29f1caecd9c7d5a$var$CreatableSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const creatableProps = (0, (0, parcelRequire("9uJ4X")).default)(props);
        const selectProps = (0, (0, parcelRequire("2HH7Y")).default)(creatableProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2QhWf")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;
});
parcelRegister("2HH7Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$994aeb783b6f955a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eEtcC;
    var $gyjU7;
    const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
        const candidate = String(inputValue).toLowerCase();
        const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
        const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
        return optionValue === candidate || optionLabel === candidate;
    };
    const $994aeb783b6f955a$var$builtins = {
        formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
        isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
        getNewOptionData: (inputValue, optionLabel)=>({
                label: optionLabel,
                value: inputValue,
                __isNew__: true
            })
    };
    function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
        const { getOptionValue: getOptionValue = (0, (0, parcelRequire("eEtcC")).getOptionValue), getOptionLabel: getOptionLabel = (0, (0, parcelRequire("eEtcC")).getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
        const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, (0, parcelRequire("gyjU7")).cleanValue)(value), propsOptions, {
                getOptionValue: getOptionValue,
                getOptionLabel: getOptionLabel
            }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
            formatCreateLabel,
            getNewOptionData,
            getOptionLabel,
            getOptionValue,
            inputValue,
            isValidNewOption,
            propsOptions,
            value
        ]);
        const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
                newOption,
                ...propsOptions
            ] : [
                ...propsOptions,
                newOption
            ] : propsOptions, [
            allowCreateWhileLoading,
            createOptionPosition,
            isLoading,
            newOption,
            propsOptions
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
            const valueArray = Array.isArray(newValue) ? newValue : [
                newValue
            ];
            if (valueArray[valueArray.length - 1] === newOption) {
                if (onCreateOption) onCreateOption(inputValue);
                else {
                    const newOptionData = getNewOptionData(inputValue, inputValue);
                    const newActionMeta = {
                        action: 'create-option',
                        name: name,
                        option: newOptionData
                    };
                    propsOnChange((0, (0, parcelRequire("gyjU7")).valueTernary)(isMulti, [
                        ...(0, (0, parcelRequire("gyjU7")).cleanValue)(value),
                        newOptionData
                    ], newOptionData), newActionMeta);
                }
                return;
            }
            propsOnChange(newValue, actionMeta);
        }, [
            getNewOptionData,
            inputValue,
            isMulti,
            name,
            newOption,
            onCreateOption,
            propsOnChange,
            value
        ]);
        return {
            ...restSelectProps,
            options: options,
            onChange: onChange
        };
    }
});
parcelRegister("d3gzD", function(module, exports) {
    $parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", ()=>$d045e9522a427a64$export$b4ff48c8d43b18c3);
    var $cb25w;
    var $jZA09;
    var $lFKmC = parcelRequire("lFKmC");
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fUmMr;
    var $78Gdn;
    var $8fG8p;
    var $3smIt;
    var $pk97C;
    const $d045e9522a427a64$var$loadingMessage = ()=>null;
    const $d045e9522a427a64$var$classNamePrefix = 'fabric-user-picker';
    class $d045e9522a427a64$export$b4ff48c8d43b18c3 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                isMulti: false,
                subtle: false,
                noBorder: false,
                textFieldBackgroundColor: false,
                isClearable: true,
                loadOptionsErrorMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).errorMessage),
                openMenuOnClick: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            const derivedState = {};
            if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
            if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
            if (nextProps.value !== undefined) derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.value);
            else if ((0, (0, parcelRequire("3smIt")).isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
                derivedState.value = (0, (0, parcelRequire("3smIt")).optionToSelectableOptions)(nextProps.defaultValue);
                derivedState.isDefaultSet = true;
            }
            if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
            if (nextProps.options !== undefined) derivedState.options = nextProps.options;
            return derivedState;
        }
        constructor(props){
            super(props), this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined, this.withSelectRef = (callback)=>()=>{
                    if (this.selectRef) callback(this.selectRef);
                }, this.nextOption = this.withSelectRef((select)=>select.focusOption('down')), this.previousOption = this.withSelectRef((select)=>select.focusOption('up')), this.focus = ()=>{
                if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
            }, this.blur = ()=>{
                if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
            }, this.selectOption = this.withSelectRef((select)=>{
                const focusedOption = select.state.focusedOption;
                select.selectOption(focusedOption);
            }), this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
                if (removedValue && removedValue.data.fixed) return;
                this.resetInputState();
                const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
                (0, (0, parcelRequire("3smIt")).callCallback)(onChange, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), action);
                switch(action){
                    case 'select-option':
                        if (value) (0, (0, parcelRequire("3smIt")).callCallback)(onSelection, (0, (0, parcelRequire("3smIt")).extractOptionValue)(value), this.getSessionId(), this);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).selectEvent), isMulti ? option : value);
                        this.session = isMulti ? (0, (0, parcelRequire("fUmMr")).startSession)() : undefined;
                        break;
                    case 'clear':
                        (0, (0, parcelRequire("3smIt")).callCallback)(onClear);
                        this.fireEvent((0, (0, parcelRequire("fUmMr")).clearEvent));
                        break;
                    case 'remove-value':
                    case 'pop-value':
                        if (removedValue) this.fireEvent((0, (0, parcelRequire("fUmMr")).deleteEvent), removedValue.data);
                        break;
                }
                this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
                if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                    const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                    this.setState({
                        value: remainingValues ? remainingValues : [],
                        menuIsOpen: true
                    });
                }
                if (!this.props.value) this.setState({
                    value: value ? value : []
                });
            }, this.handleSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.addOptions = (0, (0, parcelRequire("78Gdn")).batchByKey)((request, newOptions)=>{
                const { resolving: resolving } = this.state;
                this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                    if (inflightRequest.toString() === request) return {
                        options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                        count: count - newOptions.length,
                        resolving: count - newOptions.length !== 0
                    };
                    return null;
                });
            }), this.handleLoadOptionsError = ()=>{
                const { count: count } = this.state;
                const newCount = count - 1;
                const resolving = newCount !== 0;
                let showError = false;
                if (!resolving) showError = true;
                this.setState({
                    count: newCount,
                    resolving: resolving,
                    showError: showError
                });
                this.fireEvent((0, (0, parcelRequire("fUmMr")).failedEvent));
            }, this.debouncedLoadOptions = (0, ($parcel$interopDefault($lFKmC)))((search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                    const inflightRequest = previousRequest + 1;
                    const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                    const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                    let count = 0;
                    if ((0, (0, parcelRequire("3smIt")).isIterable)(result)) for (const value of result){
                        Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    else {
                        Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                        count++;
                    }
                    return {
                        inflightRequest: inflightRequest,
                        count: count,
                        resolving: count !== 0,
                        options: []
                    };
                });
            }, 200), this.abortOptionsShownUfoExperience = ()=>{
                if (this.optionsShownUfoExperienceInstance.state.id === (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id) this.optionsShownUfoExperienceInstance.abort();
            }, this.startOptionsShownUfoExperience = ()=>{
                this.abortOptionsShownUfoExperience();
                this.optionsShownUfoExperienceInstance.start();
            }, this.executeLoadOptions = (search)=>{
                const { loadOptions: loadOptions } = this.props;
                if (loadOptions) this.setState({
                    resolving: true,
                    showError: false
                }, ()=>this.debouncedLoadOptions(search));
            }, this.handleFocus = (event)=>{
                const { value: value, menuIsOpen: menuIsOpen } = this.state;
                if (!menuIsOpen || !this.session) this.startSession();
                this.startOptionsShownUfoExperience();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onFocus, this.getSessionId());
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    this.setState({
                        menuIsOpen: true
                    });
                    if (!this.props.isMulti && (0, (0, parcelRequire("3smIt")).isSingleValue)(value)) {
                        const input = event.target;
                        this.setState({
                            inputValue: value.label
                        }, ()=>{
                            if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                        });
                    }
                }
            }, this.resetInputState = ()=>{
                this.setState({
                    inputValue: ''
                });
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, '', this.getSessionId());
            }, this.handleBlur = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onBlur, this.getSessionId());
                if ((0, (0, parcelRequire("3smIt")).isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
                this.resetInputState();
                this.abortOptionsShownUfoExperience();
                this.setState({
                    menuIsOpen: false,
                    initialFocusHandled: false,
                    options: []
                });
            }, this.handleOpen = ()=>{
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onOpen, this.getSessionId());
                this.setState({
                    menuIsOpen: true
                });
            }, this.handleClose = ()=>{
                this.resetInputState();
                (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onClose, this.getSessionId());
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
            }, this.handleInputChange = (search, { action: action })=>{
                if (action === 'input-change' || action === 'set-value') {
                    (0, (0, parcelRequire("3smIt")).callCallback)(this.props.onInputChange, search, this.getSessionId());
                    this.setState({
                        inputValue: search
                    });
                    this.startOptionsShownUfoExperience();
                }
            }, this.fireEvent = (eventCreator, ...args)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) (0, (0, parcelRequire("fUmMr")).createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
            }, this.startSession = ()=>{
                this.session = (0, (0, parcelRequire("fUmMr")).startSession)();
                this.journeyId = this.getSessionId();
                this.fireEvent((0, (0, parcelRequire("fUmMr")).focusEvent));
            }, this.handleKeyDown = (event)=>{
                if (!this.isMenuOpenOnClickForSingleSelect) {
                    if (event.keyCode === 27) this.blur();
                    if (event.keyCode === 32 && !this.state.inputValue) {
                        event.preventDefault();
                        !this.props.disableInput && this.setState({
                            inputValue: ' '
                        });
                    }
                }
                if (this.session) {
                    this.session.lastKey = event.keyCode;
                    switch(event.keyCode){
                        case 38:
                            this.session.upCount++;
                            break;
                        case 40:
                            this.session.downCount++;
                            break;
                    }
                }
                this.props.onKeyDown && this.props.onKeyDown(event);
            }, this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
                this.setState({
                    hoveringClearIndicator: hoveringClearIndicator
                });
            }, this.getOptions = ()=>{
                const options = (0, (0, parcelRequire("3smIt")).getOptions)(this.state.options) || [];
                const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
                if (maxOptions === 0) return [];
                if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                    const { value: value } = this.state;
                    let filteredOptions = options;
                    if (isMulti && Array.isArray(value)) {
                        const valueIds = value.map((item)=>item.data.id);
                        filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                    }
                    return filteredOptions.slice(0, maxOptions);
                }
                return options;
            }, this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal', this.handleClickDraggableParentComponent = ()=>{
                if (this.state.initialFocusHandled) {
                    if (this.state.menuIsOpen) this.handleClose();
                    else this.handleOpen();
                } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                    this.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            this.state = {
                options: [],
                isDefaultSet: false,
                inflightRequest: 0,
                count: 0,
                hoveringClearIndicator: false,
                menuIsOpen: !!this.props.open,
                inputValue: props.search || '',
                resolving: false,
                showError: false,
                initialFocusHandled: false
            };
            this.optionsShownUfoExperienceInstance = (0, (0, parcelRequire("pk97C")).userPickerOptionsShownUfoExperience).getInstance((0, $7Jxgt.v4)());
        }
        get isMenuOpenOnClickForSingleSelect() {
            return this.props.openMenuOnClick && !this.props.isMulti;
        }
        componentDidMount() {
            const { open: open, search: search } = this.props;
            if (open) {
                if (!this.session) this.startSession();
                this.executeLoadOptions(search);
            }
        }
        componentDidUpdate(_, prevState) {
            const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
            if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
            if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
            if (!menuIsOpen && prevState.menuIsOpen && this.session) {
                this.fireEvent((0, (0, parcelRequire("fUmMr")).cancelEvent), prevState);
                this.session = undefined;
            }
            if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, (0, parcelRequire("fUmMr")).searchedEvent));
            if (this.state.inputValue !== prevState.inputValue) {
                if (this.session) this.session.inputChangeTime = Date.now();
            }
            if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).STARTED.id,
                (0, (0, parcelRequire("jZA09")).UFOExperienceState).IN_PROGRESS.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
        }
        get ariaProps() {
            const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
            const props = {
                ...this.props
            };
            return ariaLabels.reduce((obj, key)=>({
                    ...obj,
                    [key]: props[key]
                }), {});
        }
        render() {
            const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
            const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
            const appearance = this.getAppearance();
            const menuOpenDeciderProps = {
                ...!this.isMenuOpenOnClickForSingleSelect && {
                    menuIsOpen: menuIsOpen,
                    blurInputOnSelect: !isMulti,
                    openMenuOnFocus: true
                }
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
                name: name,
                value: value,
                autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
                "aria-labelledby": ariaLabelledBy,
                "aria-label": ariaLabel,
                "aria-live": ariaLive,
                "aria-required": required,
                required: required,
                ref: this.handleSelectRef,
                isMulti: isMulti,
                options: this.getOptions(),
                styles: styles,
                enableAnimation: isMulti,
                components: components,
                inputValue: inputValue,
                isLoading: count > 0 || resolving || isLoading,
                loadingMessage: $d045e9522a427a64$var$loadingMessage,
                menuPlacement: "auto",
                placeholder: placeholder ?? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).placeholder),
                addMoreMessage: addMoreMessage,
                classNamePrefix: $d045e9522a427a64$var$classNamePrefix,
                hoveringClearIndicator: hoveringClearIndicator,
                appearance: appearance,
                isClearable: isClearable,
                noBorder: noBorder,
                subtle: subtle,
                closeMenuOnSelect: !isMulti,
                noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
                footer: footer,
                isDisabled: isDisabled,
                isInvalid: isInvalid,
                isFocused: menuIsOpen,
                backspaceRemovesValue: isMulti,
                filterOption: null,
                clearValueLabel: clearValueLabel,
                menuMinWidth: menuMinWidth,
                menuPortalTarget: menuPortalTarget,
                disableInput: disableInput || isDisabled,
                instanceId: fieldId,
                inputId: inputId,
                onChange: this.handleChange,
                onMenuOpen: this.handleOpen,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onMenuClose: this.handleClose,
                onInputChange: this.handleInputChange,
                onClearIndicatorHover: this.handleClearIndicatorHover,
                onKeyDown: this.handleKeyDown,
                maxPickerHeight: maxPickerHeight,
                textFieldBackgroundColor: textFieldBackgroundColor,
                header: header,
                placeholderAvatar: placeholderAvatar,
                ...this.ariaProps,
                ...pickerProps,
                ...UNSAFE_hasDraggableParentComponent && {
                    onValueContainerClick: this.handleClickDraggableParentComponent
                },
                ...menuOpenDeciderProps
            });
        }
    }
    const $d045e9522a427a64$export$d099ade7b4f4d2a4 = (0, (0, parcelRequire("cb25w")).default)()($d045e9522a427a64$export$b4ff48c8d43b18c3);
});
parcelRegister("fUmMr", function(module, exports) {
    $parcel$export(module.exports, "startSession", ()=>$e345c0b18a65d683$export$c0d84948cecf78d8);
    $parcel$export(module.exports, "createAndFireEventInElementsChannel", ()=>$e345c0b18a65d683$export$53eef0dcd9611650);
    $parcel$export(module.exports, "focusEvent", ()=>$e345c0b18a65d683$export$e7818c470f37c4bd);
    $parcel$export(module.exports, "clearEvent", ()=>$e345c0b18a65d683$export$7b5800e732182efb);
    $parcel$export(module.exports, "deleteEvent", ()=>$e345c0b18a65d683$export$95711ec6c6227e9a);
    $parcel$export(module.exports, "cancelEvent", ()=>$e345c0b18a65d683$export$e9caaaecfee38128);
    $parcel$export(module.exports, "selectEvent", ()=>$e345c0b18a65d683$export$48143d759475d90f);
    $parcel$export(module.exports, "searchedEvent", ()=>$e345c0b18a65d683$export$911fb7184b6037eb);
    $parcel$export(module.exports, "failedEvent", ()=>$e345c0b18a65d683$export$c2aec355fef65c9c);
    $parcel$export(module.exports, "userInfoEvent", ()=>$e345c0b18a65d683$export$f541f04954b0c11e);
    var $gB4mS;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $3smIt;
    const $e345c0b18a65d683$var$packageName = "platform-pkg";
    const $e345c0b18a65d683$var$packageVersion = "0.0.0-use.local";
    const $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
    const $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
    const $e345c0b18a65d683$export$c0d84948cecf78d8 = ()=>({
            id: (0, $7Jxgt.v4)(),
            start: Date.now(),
            inputChangeTime: Date.now(),
            upCount: 0,
            downCount: 0,
            lastKey: undefined
        });
    const $e345c0b18a65d683$export$53eef0dcd9611650 = (0, (0, parcelRequire("gB4mS")).default)('fabric-elements');
    const $e345c0b18a65d683$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            attributes: {
                packageName: $e345c0b18a65d683$var$packageName,
                packageVersion: $e345c0b18a65d683$var$packageVersion,
                ...attributes
            }
        });
    const $e345c0b18a65d683$var$checkValidId = (id)=>{
        return $e345c0b18a65d683$var$UUID_REGEXP_NEW_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_OLD_AAID.test(id) || $e345c0b18a65d683$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
    };
    const $e345c0b18a65d683$var$optionData2Analytics = (option)=>{
        const { id: id, type: type } = option;
        const validatedData = {
            id: $e345c0b18a65d683$var$checkValidId(id) ? id : null,
            type: type || null
        };
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(option)) return {
            ...validatedData,
            type: 'external_user',
            sources: option.sources,
            externalUserType: option.externalUserType
        };
        if ((0, (0, parcelRequire("3smIt")).isCustom)(option) && option.analyticsType) return {
            ...validatedData,
            type: option.analyticsType
        };
        return validatedData;
    };
    const $e345c0b18a65d683$var$buildValueForAnalytics = (value)=>{
        if (value) {
            const valueToConvert = Array.isArray(value) ? value : [
                value
            ];
            return valueToConvert.map(({ data: data })=>$e345c0b18a65d683$var$optionData2Analytics(data));
        }
        return [];
    };
    const $e345c0b18a65d683$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            pickerType: $e345c0b18a65d683$var$pickerType(props),
            journeyId: journeyId
        });
    const $e345c0b18a65d683$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'focused', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            values: $e345c0b18a65d683$var$buildValueForAnalytics(state.value)
        });
    const $e345c0b18a65d683$export$7b5800e732182efb = (props, state, session, journeyId)=>$e345c0b18a65d683$var$createEvent('ui', 'cleared', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            pickerOpen: state.menuIsOpen,
            values: $e345c0b18a65d683$var$values(state)
        });
    const $e345c0b18a65d683$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'deleted', 'userPickerItem', {
            context: props.fieldId,
            sessionId: $e345c0b18a65d683$var$sessionId(session),
            journeyId: journeyId,
            value: $e345c0b18a65d683$var$optionData2Analytics(args[0]),
            pickerOpen: state.menuIsOpen
        });
    const $e345c0b18a65d683$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$e345c0b18a65d683$var$createEvent('ui', 'cancelled', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            queryLength: $e345c0b18a65d683$var$queryLength(args[0]),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(args[0]),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session)
        });
    const $e345c0b18a65d683$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
        return $e345c0b18a65d683$var$createEvent('ui', $e345c0b18a65d683$var$selectEventType(session), 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            position: $e345c0b18a65d683$var$position(state, args[0]),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            spaceInQuery: $e345c0b18a65d683$var$spaceInQuery(state),
            upKeyCount: $e345c0b18a65d683$var$upKeyCount(session),
            downKeyCount: $e345c0b18a65d683$var$downKeyCount(session),
            result: $e345c0b18a65d683$var$result(args[0]),
            numberOfResults: $e345c0b18a65d683$var$numberOfResults(state)
        });
    };
    const $e345c0b18a65d683$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
        const searchResults = $e345c0b18a65d683$var$results(state);
        return $e345c0b18a65d683$var$createEvent('operational', 'searched', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId),
            sessionDuration: $e345c0b18a65d683$var$sessionDuration(session),
            durationSinceInputChange: $e345c0b18a65d683$var$durationSinceInputChange(session),
            queryLength: $e345c0b18a65d683$var$queryLength(state),
            isLoading: $e345c0b18a65d683$var$isLoading(props, state),
            results: searchResults,
            numberOfResults: searchResults.length
        });
    };
    const $e345c0b18a65d683$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$e345c0b18a65d683$var$createEvent('operational', 'failed', 'userPicker', {
            ...$e345c0b18a65d683$var$createDefaultPickerAttributes(props, session, journeyId)
        });
    const $e345c0b18a65d683$export$f541f04954b0c11e = (sources, accountId)=>$e345c0b18a65d683$var$createEvent('ui', 'displayed', 'userInfo', {
            sources: sources,
            accountId: $e345c0b18a65d683$var$checkValidId(accountId) ? accountId : null
        });
    function $e345c0b18a65d683$var$queryLength(state) {
        return state.inputValue.length;
    }
    function $e345c0b18a65d683$var$selectEventType(session) {
        return session && session.lastKey === 13 ? 'pressed' : 'clicked';
    }
    function $e345c0b18a65d683$var$upKeyCount(session) {
        return session ? session.upCount : null;
    }
    function $e345c0b18a65d683$var$downKeyCount(session) {
        return session ? session.downCount : null;
    }
    function $e345c0b18a65d683$var$spaceInQuery(state) {
        return state.inputValue.indexOf(' ') !== -1;
    }
    function $e345c0b18a65d683$var$sessionDuration(session) {
        return session ? Date.now() - session.start : null;
    }
    function $e345c0b18a65d683$var$durationSinceInputChange(session) {
        return session ? Date.now() - session.inputChangeTime : null;
    }
    function $e345c0b18a65d683$var$sessionId(session) {
        return session && session.id;
    }
    function $e345c0b18a65d683$var$position(state, value) {
        return value ? state.options.findIndex((option)=>option === value.data) : -1;
    }
    function $e345c0b18a65d683$var$pickerType(props) {
        return props.isMulti ? 'multi' : 'single';
    }
    function $e345c0b18a65d683$var$result(option) {
        return option ? $e345c0b18a65d683$var$optionData2Analytics(option.data) : null;
    }
    function $e345c0b18a65d683$var$results(state) {
        return (state.options || []).map($e345c0b18a65d683$var$optionData2Analytics);
    }
    function $e345c0b18a65d683$var$isLoading(props, state) {
        return state.count > 0 || props.isLoading;
    }
    function $e345c0b18a65d683$var$values(state) {
        return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$e345c0b18a65d683$var$optionData2Analytics(option.data)) : [
            $e345c0b18a65d683$var$optionData2Analytics(state.value.data)
        ] : [];
    }
    function $e345c0b18a65d683$var$numberOfResults(state) {
        return (state.options || []).length;
    }
});
parcelRegister("3smIt", function(module, exports) {
    $parcel$export(module.exports, "isExternalUser", ()=>$02015d62698c11ec$export$f6058dbcb5980cb);
    $parcel$export(module.exports, "isUser", ()=>$02015d62698c11ec$export$2e44165f1da65304);
    $parcel$export(module.exports, "isTeam", ()=>$02015d62698c11ec$export$f8c4277cb588611f);
    $parcel$export(module.exports, "isGroup", ()=>$02015d62698c11ec$export$d7976824e9f55785);
    $parcel$export(module.exports, "isEmail", ()=>$02015d62698c11ec$export$7fbbfbca30081d0);
    $parcel$export(module.exports, "isCustom", ()=>$02015d62698c11ec$export$d3a8f0b77e9737fc);
    $parcel$export(module.exports, "isDefaultValuePopulated", ()=>$02015d62698c11ec$export$d6978985a41b0c8);
    $parcel$export(module.exports, "extractOptionValue", ()=>$02015d62698c11ec$export$7ae97131df521bff);
    $parcel$export(module.exports, "isIterable", ()=>$02015d62698c11ec$export$9652023d9040757);
    $parcel$export(module.exports, "getOptions", ()=>$02015d62698c11ec$export$d2312e68e1f5ad00);
    $parcel$export(module.exports, "optionToSelectableOptions", ()=>$02015d62698c11ec$export$e6fda14a194bcbcc);
    $parcel$export(module.exports, "getAvatarSize", ()=>$02015d62698c11ec$export$695fb564e621339a);
    $parcel$export(module.exports, "isChildInput", ()=>$02015d62698c11ec$export$3c62cf9a01367f27);
    $parcel$export(module.exports, "isSingleValue", ()=>$02015d62698c11ec$export$203c2bd2662d1ca2);
    $parcel$export(module.exports, "hasValue", ()=>$02015d62698c11ec$export$96bdbc84526f3739);
    $parcel$export(module.exports, "callCallback", ()=>$02015d62698c11ec$export$df325aa844b03c31);
    $parcel$export(module.exports, "getAvatarUrl", ()=>$02015d62698c11ec$export$b4f8f1f54acec99b);
    $parcel$export(module.exports, "isPopupUserPickerByComponent", ()=>$02015d62698c11ec$export$4f60a74234178416);
    $parcel$export(module.exports, "isLozengeText", ()=>$02015d62698c11ec$export$5419897287f5f1c7);
    var $8QpSo;
    var $b9dFI;
    const $02015d62698c11ec$export$f6058dbcb5980cb = (option)=>option.type === (0, $f93312f7d4958f08$export$50042ec1d2e00e63) || Boolean(option.isExternal);
    const $02015d62698c11ec$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $f93312f7d4958f08$export$8436e53e45ffe15b);
    const $02015d62698c11ec$export$f8c4277cb588611f = (option)=>option.type === (0, $f93312f7d4958f08$export$26bc40b960693765);
    const $02015d62698c11ec$export$d7976824e9f55785 = (option)=>option.type === (0, $f93312f7d4958f08$export$d460f747b73abb10);
    const $02015d62698c11ec$export$7fbbfbca30081d0 = (option)=>option.type === (0, $f93312f7d4958f08$export$6662b3461398ef8c);
    const $02015d62698c11ec$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $f93312f7d4958f08$export$eafd0979afa5b224);
    const $02015d62698c11ec$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
    const $02015d62698c11ec$var$isOptionData = (option)=>option.name !== undefined;
    const $02015d62698c11ec$export$3f993c492bd6c728 = (option)=>{
        if ($02015d62698c11ec$var$isOptionData(option)) return {
            data: option,
            isDisabled: option.isDisabled,
            label: option.name,
            value: option.id
        };
        else return {
            data: {
                ...option,
                name: option.id
            },
            isDisabled: option.isDisabled,
            label: option.id,
            value: option.id
        };
    };
    const $02015d62698c11ec$export$7ae97131df521bff = (value)=>{
        if (!value) return undefined;
        if (Array.isArray(value)) return value.map(({ data: option })=>option);
        return value.data;
    };
    const $02015d62698c11ec$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
    const $02015d62698c11ec$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((options)=>options.map($02015d62698c11ec$export$3f993c492bd6c728));
    const $02015d62698c11ec$export$e6fda14a194bcbcc = (0, (0, parcelRequire("8QpSo")).default)((defaultValue)=>{
        if (!defaultValue) return null;
        if (Array.isArray(defaultValue)) return defaultValue.map($02015d62698c11ec$export$3f993c492bd6c728);
        return $02015d62698c11ec$export$3f993c492bd6c728(defaultValue);
    });
    const $02015d62698c11ec$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
    const $02015d62698c11ec$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
    const $02015d62698c11ec$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
    const $02015d62698c11ec$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
    const $02015d62698c11ec$export$df325aa844b03c31 = (callback, ...args)=>{
        if (typeof callback === 'function') try {
            return callback(...args);
        } catch (error) {
            console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
        }
    };
    const $02015d62698c11ec$export$b4f8f1f54acec99b = (optionData)=>{
        if ($02015d62698c11ec$export$2e44165f1da65304(optionData) || $02015d62698c11ec$export$f8c4277cb588611f(optionData) || $02015d62698c11ec$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
        return undefined;
    };
    const $02015d62698c11ec$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, (0, parcelRequire("b9dFI")).default);
    const $02015d62698c11ec$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
    const $02015d62698c11ec$export$5419897287f5f1c7 = (lozengeProp)=>{
        return lozengeProp?.hasOwnProperty('text') || false;
    };
});
const $f93312f7d4958f08$export$8436e53e45ffe15b = 'user';
const $f93312f7d4958f08$export$50042ec1d2e00e63 = 'external_user';
const $f93312f7d4958f08$export$26bc40b960693765 = 'team';
const $f93312f7d4958f08$export$d460f747b73abb10 = 'group';
const $f93312f7d4958f08$export$6662b3461398ef8c = 'email';
const $f93312f7d4958f08$export$eafd0979afa5b224 = 'custom';
parcelRegister("b9dFI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$768d8504b373d7ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $5n5w4;
    var $283js;
    var $iGDLS;
    var $4wJSY = parcelRequire("4wJSY");
    var $9KnKW;
    var $7VXAu;
    var $7K5PP;
    var $1DATb;
    var $hT6ku;
    const $768d8504b373d7ff$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $768d8504b373d7ff$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $768d8504b373d7ff$var$defaultPopperProps = {
        modifiers: $768d8504b373d7ff$var$modifiers,
        placement: 'bottom-start'
    };
    const $768d8504b373d7ff$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $768d8504b373d7ff$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$768d8504b373d7ff$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hT6ku")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$768d8504b373d7ff$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5n5w4")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9KnKW")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iGDLS")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args), this.menuRef = null, this.selectRef = null, this.targetRef = null, this.unbindWindowClick = null, this.unbindWindowKeydown = null, this.defaultStyles = {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$eaa8c8a70ac22806})`
                    })
            }, this.isOpenControlled = this.props.isOpen !== undefined, this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen, this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hT6ku")).defaultComponents),
                mergedPopperProps: $768d8504b373d7ff$var$defaultPopperProps
            }, this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            }, this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            }, this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            }, this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            }, this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            }, this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            }, this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            }, this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                }, this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }, this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            }, this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            }, this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            }, this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            }, this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $768d8504b373d7ff$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hT6ku")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("1DATb")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("1DATb")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("1DATb")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("283js")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hT6ku")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer)));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
});
parcelRegister("5n5w4", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$3e93612641040812$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$3e93612641040812$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$3e93612641040812$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $3e93612641040812$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $3e93612641040812$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $3e93612641040812$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($3e93612641040812$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($3e93612641040812$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("283js", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$18cee5f949ac4034$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5n5w4;
    var $eclLw;
    var $fNOWl;
    var $18cee5f949ac4034$var$NOOP = function NOOP() {
        return void 0;
    };
    var $18cee5f949ac4034$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $18cee5f949ac4034$var$EMPTY_MODIFIERS = [];
    function $18cee5f949ac4034$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $18cee5f949ac4034$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("fNOWl")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $18cee5f949ac4034$var$NOOP,
                update: update || $18cee5f949ac4034$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("eclLw", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$a56311d537d20f47$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$a56311d537d20f47$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$a56311d537d20f47$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$a56311d537d20f47$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$a56311d537d20f47$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $a56311d537d20f47$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $a56311d537d20f47$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $a56311d537d20f47$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $a56311d537d20f47$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $a56311d537d20f47$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $a56311d537d20f47$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("fNOWl", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$b812f23d0bbb9e85$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $8Pv9O;
    var $lHrkK = parcelRequire("lHrkK");
    var $eclLw;
    var $b812f23d0bbb9e85$var$EMPTY_MODIFIERS = [];
    var $b812f23d0bbb9e85$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $b812f23d0bbb9e85$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("eclLw")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("eclLw")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("8Pv9O")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("8Pv9O", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$66db415bc009fd50$export$8f7491d57c8f97a9);
    var $dsn8Y;
    var $4TVC8;
    var $j8nKB;
    var $baic6;
    var $1AoLg;
    var $gy4Xr;
    var $3dDWl;
    var $1DdSC;
    var $gzAfz;
    var $6iLAT;
    var $66db415bc009fd50$export$d34966752335dd47 = [
        (0, (0, parcelRequire("4TVC8")).default),
        (0, (0, parcelRequire("j8nKB")).default),
        (0, (0, parcelRequire("baic6")).default),
        (0, (0, parcelRequire("1AoLg")).default),
        (0, (0, parcelRequire("gy4Xr")).default),
        (0, (0, parcelRequire("3dDWl")).default),
        (0, (0, parcelRequire("1DdSC")).default),
        (0, (0, parcelRequire("gzAfz")).default),
        (0, (0, parcelRequire("6iLAT")).default)
    ];
    var $66db415bc009fd50$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("dsn8Y")).popperGenerator)({
        defaultModifiers: $66db415bc009fd50$export$d34966752335dd47
    });
});
parcelRegister("dsn8Y", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$9cbfd7bdb6a4f3f1$export$ed5e13716264f202);
    var $gvlia;
    var $jkGDj;
    var $2r6BH;
    var $gbHJy;
    var $kcmIg;
    var $a8clb;
    var $i9xH7;
    var $gmkfg;
    var $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $9cbfd7bdb6a4f3f1$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $9cbfd7bdb6a4f3f1$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $9cbfd7bdb6a4f3f1$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("gmkfg")).isElement)(reference) ? (0, (0, parcelRequire("2r6BH")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("2r6BH")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("2r6BH")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("kcmIg")).default)((0, (0, parcelRequire("i9xH7")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("gvlia")).default)(reference, (0, (0, parcelRequire("gbHJy")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("jkGDj")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("a8clb")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$9cbfd7bdb6a4f3f1$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $9cbfd7bdb6a4f3f1$export$8f7491d57c8f97a9 = $9cbfd7bdb6a4f3f1$export$ed5e13716264f202();
});
parcelRegister("gvlia", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0400ebb908e52cb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $9FFjG;
    var $f5IBt;
    var $gmkfg;
    var $imzt5;
    var $eVELE;
    var $c6EdA;
    var $90xPK;
    function $c0400ebb908e52cb$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("90xPK")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("90xPK")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $c0400ebb908e52cb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent) && $c0400ebb908e52cb$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("eVELE")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("c6EdA")).default)(documentElement)) scroll = (0, (0, parcelRequire("9FFjG")).default)(offsetParent);
            if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("g2O7Z")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("imzt5")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("g2O7Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bae3b796a534b2cf$export$2e2bcd8739ae039);
    var $gmkfg;
    var $90xPK;
    var $1Prpe;
    var $d8bsQ;
    function $bae3b796a534b2cf$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("90xPK")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("gmkfg")).isElement)(element) ? (0, (0, parcelRequire("1Prpe")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("d8bsQ")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("gmkfg", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$be8e67adfa808002$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$be8e67adfa808002$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$be8e67adfa808002$export$af51f0f06c0f328a);
    var $1Prpe;
    function $be8e67adfa808002$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $be8e67adfa808002$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $be8e67adfa808002$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("1Prpe")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("1Prpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$154fd01b154b825f$export$2e2bcd8739ae039);
    function $154fd01b154b825f$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("90xPK", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$68ee5bce69e9df7e$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$68ee5bce69e9df7e$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$68ee5bce69e9df7e$export$2077e0241d6afd3c);
    var $68ee5bce69e9df7e$export$8960430cfd85939f = Math.max;
    var $68ee5bce69e9df7e$export$96ec731ed4dcb222 = Math.min;
    var $68ee5bce69e9df7e$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("d8bsQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98f4ea48bb7f7060$export$2e2bcd8739ae039);
    var $j5Xhq;
    function $98f4ea48bb7f7060$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("j5Xhq")).default)());
    }
});
parcelRegister("j5Xhq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de6c77c242bcf4cf$export$2e2bcd8739ae039);
    function $de6c77c242bcf4cf$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("9FFjG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70a7fdf85bb2e8b8$export$2e2bcd8739ae039);
    var $8YTLN;
    var $1Prpe;
    var $gmkfg;
    var $i1ad3;
    function $70a7fdf85bb2e8b8$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("1Prpe")).default)(node) || !(0, (0, parcelRequire("gmkfg")).isHTMLElement)(node)) return (0, (0, parcelRequire("8YTLN")).default)(node);
        else return (0, (0, parcelRequire("i1ad3")).default)(node);
    }
});
parcelRegister("8YTLN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$689f300ec0defb42$export$2e2bcd8739ae039);
    var $1Prpe;
    function $689f300ec0defb42$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("i1ad3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1e03d69dfb9832f$export$2e2bcd8739ae039);
    function $d1e03d69dfb9832f$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("f5IBt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afc9ebf0aa1487e4$export$2e2bcd8739ae039);
    function $afc9ebf0aa1487e4$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("imzt5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5e5cb506db8cdcb$export$2e2bcd8739ae039);
    var $g2O7Z;
    var $eVELE;
    var $8YTLN;
    function $d5e5cb506db8cdcb$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("g2O7Z")).default)((0, (0, parcelRequire("eVELE")).default)(element)).left + (0, (0, parcelRequire("8YTLN")).default)(element).scrollLeft;
    }
});
parcelRegister("eVELE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ade6032ba4b824fe$export$2e2bcd8739ae039);
    var $gmkfg;
    function $ade6032ba4b824fe$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("c6EdA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d053e13cecc73ee$export$2e2bcd8739ae039);
    var $1ix2F;
    function $8d053e13cecc73ee$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("1ix2F")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("1ix2F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f211a5db2cb1d1b$export$2e2bcd8739ae039);
    var $1Prpe;
    function $0f211a5db2cb1d1b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("1Prpe")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("jkGDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e130f49f6e9ebcb4$export$2e2bcd8739ae039);
    var $g2O7Z;
    function $e130f49f6e9ebcb4$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("g2O7Z")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("2r6BH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c633a6ac170841a$export$2e2bcd8739ae039);
    var $k82dT;
    var $eTUzl;
    var $1Prpe;
    var $c6EdA;
    function $1c633a6ac170841a$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("k82dT")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("1Prpe")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("c6EdA")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($1c633a6ac170841a$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(target)));
    }
});
parcelRegister("k82dT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea7647704a508683$export$2e2bcd8739ae039);
    var $eTUzl;
    var $c6EdA;
    var $f5IBt;
    var $gmkfg;
    function $ea7647704a508683$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("gmkfg")).isHTMLElement)(node) && (0, (0, parcelRequire("c6EdA")).default)(node)) return node;
        return $ea7647704a508683$export$2e2bcd8739ae039((0, (0, parcelRequire("eTUzl")).default)(node));
    }
});
parcelRegister("eTUzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ad921528f26834dd$export$2e2bcd8739ae039);
    var $f5IBt;
    var $eVELE;
    var $gmkfg;
    function $ad921528f26834dd$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("f5IBt")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("eVELE")).default)(element));
    }
});
parcelRegister("gbHJy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f9908a1e4106f$export$2e2bcd8739ae039);
    var $1Prpe;
    var $f5IBt;
    var $1ix2F;
    var $gmkfg;
    var $6hs9X;
    var $eTUzl;
    var $j5Xhq;
    function $bc8f9908a1e4106f$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || (0, (0, parcelRequire("1ix2F")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $bc8f9908a1e4106f$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("j5Xhq")).default)());
        if (isIE && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("1ix2F")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("eTUzl")).default)(element);
        if ((0, (0, parcelRequire("gmkfg")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("gmkfg")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("1ix2F")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $bc8f9908a1e4106f$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("1Prpe")).default)(element);
        var offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("6hs9X")).default)(offsetParent) && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')offsetParent = $bc8f9908a1e4106f$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("f5IBt")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("1ix2F")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $bc8f9908a1e4106f$var$getContainingBlock(element) || window;
    }
});
parcelRegister("6hs9X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$492a2c861940c94d$export$2e2bcd8739ae039);
    var $f5IBt;
    function $492a2c861940c94d$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("f5IBt")).default)(element)) >= 0;
    }
});
parcelRegister("kcmIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb468bf0752088cc$export$2e2bcd8739ae039);
    var $kJPed;
    function $eb468bf0752088cc$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $eb468bf0752088cc$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $eb468bf0752088cc$var$order(modifiers);
        return (0, (0, parcelRequire("kJPed")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("kJPed", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$f18fbf7b212a7c8e$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$f18fbf7b212a7c8e$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$f18fbf7b212a7c8e$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$f18fbf7b212a7c8e$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$f18fbf7b212a7c8e$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$f18fbf7b212a7c8e$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$f18fbf7b212a7c8e$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$f18fbf7b212a7c8e$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$f18fbf7b212a7c8e$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$f18fbf7b212a7c8e$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$f18fbf7b212a7c8e$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$f18fbf7b212a7c8e$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$f18fbf7b212a7c8e$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$f18fbf7b212a7c8e$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$f18fbf7b212a7c8e$export$d087d3878fdf71d5);
    var $f18fbf7b212a7c8e$export$1e95b668f3b82d = 'top';
    var $f18fbf7b212a7c8e$export$40e543e69a8b3fbb = 'bottom';
    var $f18fbf7b212a7c8e$export$79ffe56a765070d2 = 'right';
    var $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4 = 'left';
    var $f18fbf7b212a7c8e$export$dfb5619354ba860 = 'auto';
    var $f18fbf7b212a7c8e$export$aec2ce47c367b8c3 = [
        $f18fbf7b212a7c8e$export$1e95b668f3b82d,
        $f18fbf7b212a7c8e$export$40e543e69a8b3fbb,
        $f18fbf7b212a7c8e$export$79ffe56a765070d2,
        $f18fbf7b212a7c8e$export$eabcd2c8791e7bf4
    ];
    var $f18fbf7b212a7c8e$export$b3571188c770cc5a = 'start';
    var $f18fbf7b212a7c8e$export$bd5df0f255a350f8 = 'end';
    var $f18fbf7b212a7c8e$export$390fd549c5303b4d = 'clippingParents';
    var $f18fbf7b212a7c8e$export$d7b7311ec04a3e8f = 'viewport';
    var $f18fbf7b212a7c8e$export$ae5ab1c730825774 = 'popper';
    var $f18fbf7b212a7c8e$export$ca50aac9f3ba507f = 'reference';
    var $f18fbf7b212a7c8e$export$368f9a87e87fa4e1 = $f18fbf7b212a7c8e$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$803cd8101b6c182b = [].concat($f18fbf7b212a7c8e$export$aec2ce47c367b8c3, [
        $f18fbf7b212a7c8e$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $f18fbf7b212a7c8e$export$b3571188c770cc5a,
            placement + "-" + $f18fbf7b212a7c8e$export$bd5df0f255a350f8
        ]);
    }, []);
    var $f18fbf7b212a7c8e$export$421679a7c3d56e = 'beforeRead';
    var $f18fbf7b212a7c8e$export$aafa59e2e03f2942 = 'read';
    var $f18fbf7b212a7c8e$export$6964f6c886723980 = 'afterRead';
    var $f18fbf7b212a7c8e$export$c65e99957a05207c = 'beforeMain';
    var $f18fbf7b212a7c8e$export$f22da7240b7add18 = 'main';
    var $f18fbf7b212a7c8e$export$bab79516f2d662fe = 'afterMain';
    var $f18fbf7b212a7c8e$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $f18fbf7b212a7c8e$export$68d8715fc104d294 = 'write';
    var $f18fbf7b212a7c8e$export$70a6e5159acce2e6 = 'afterWrite';
    var $f18fbf7b212a7c8e$export$d087d3878fdf71d5 = [
        $f18fbf7b212a7c8e$export$421679a7c3d56e,
        $f18fbf7b212a7c8e$export$aafa59e2e03f2942,
        $f18fbf7b212a7c8e$export$6964f6c886723980,
        $f18fbf7b212a7c8e$export$c65e99957a05207c,
        $f18fbf7b212a7c8e$export$f22da7240b7add18,
        $f18fbf7b212a7c8e$export$bab79516f2d662fe,
        $f18fbf7b212a7c8e$export$8d4d2d70e7d46032,
        $f18fbf7b212a7c8e$export$68d8715fc104d294,
        $f18fbf7b212a7c8e$export$70a6e5159acce2e6
    ];
});
parcelRegister("a8clb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7604395822cc5d61$export$2e2bcd8739ae039);
    function $7604395822cc5d61$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("i9xH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3733441fcf2e882$export$2e2bcd8739ae039);
    function $d3733441fcf2e882$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("4TVC8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3918fd6b815bcf57$export$2e2bcd8739ae039);
    var $1Prpe;
    var $3918fd6b815bcf57$var$passive = {
        passive: true
    };
    function $3918fd6b815bcf57$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("1Prpe")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $3918fd6b815bcf57$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $3918fd6b815bcf57$var$passive);
        };
    }
    var $3918fd6b815bcf57$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $3918fd6b815bcf57$var$effect,
        data: {}
    };
});
parcelRegister("j8nKB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dee1300a39219bb5$export$2e2bcd8739ae039);
    var $dJ0Jl;
    function $dee1300a39219bb5$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $dee1300a39219bb5$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $dee1300a39219bb5$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dJ0Jl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fe00b5c334118ac$export$2e2bcd8739ae039);
    var $QXpw1;
    var $cGRJ4;
    var $9GF9F;
    var $kJPed;
    function $9fe00b5c334118ac$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("QXpw1")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("cGRJ4")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("kJPed")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("kJPed")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("kJPed")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("9GF9F")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("kJPed")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("kJPed")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("QXpw1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09f2f123ac4a9fdf$export$2e2bcd8739ae039);
    function $09f2f123ac4a9fdf$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("cGRJ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93d315208040ceed$export$2e2bcd8739ae039);
    function $93d315208040ceed$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("9GF9F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70d7f5cda4210aa3$export$2e2bcd8739ae039);
    function $70d7f5cda4210aa3$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("baic6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$820ebddbe0682e4f$export$2e2bcd8739ae039);
    var $kJPed;
    var $gbHJy;
    var $1Prpe;
    var $eVELE;
    var $1ix2F;
    var $QXpw1;
    var $cGRJ4;
    var $90xPK;
    var $820ebddbe0682e4f$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $820ebddbe0682e4f$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("90xPK")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("90xPK")).round)(y * dpr) / dpr || 0
        };
    }
    function $820ebddbe0682e4f$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("kJPed")).left);
        var sideY = (0, (0, parcelRequire("kJPed")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("gbHJy")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("1Prpe")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("eVELE")).default)(popper);
                if ((0, (0, parcelRequire("1ix2F")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("kJPed")).top) || (placement === (0, (0, parcelRequire("kJPed")).left) || placement === (0, (0, parcelRequire("kJPed")).right)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideY = (0, (0, parcelRequire("kJPed")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("kJPed")).left) || (placement === (0, (0, parcelRequire("kJPed")).top) || placement === (0, (0, parcelRequire("kJPed")).bottom)) && variation === (0, (0, parcelRequire("kJPed")).end)) {
                sideX = (0, (0, parcelRequire("kJPed")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $820ebddbe0682e4f$var$unsetSides);
        var _ref4 = roundOffsets === true ? $820ebddbe0682e4f$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("1Prpe")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $820ebddbe0682e4f$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("QXpw1")).default)(state.placement),
            variation: (0, (0, parcelRequire("cGRJ4")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $820ebddbe0682e4f$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $820ebddbe0682e4f$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $820ebddbe0682e4f$var$computeStyles,
        data: {}
    };
});
parcelRegister("1AoLg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$127c5c56b9511f5f$export$2e2bcd8739ae039);
    var $f5IBt;
    var $gmkfg;
    function $127c5c56b9511f5f$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $127c5c56b9511f5f$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) || !(0, (0, parcelRequire("f5IBt")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $127c5c56b9511f5f$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $127c5c56b9511f5f$var$applyStyles,
        effect: $127c5c56b9511f5f$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("gy4Xr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0c3aad300d72ee1$export$2e2bcd8739ae039);
    var $QXpw1;
    var $kJPed;
    function $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $c0c3aad300d72ee1$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("kJPed")).placements).reduce(function(acc, placement) {
            acc[placement] = $c0c3aad300d72ee1$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $c0c3aad300d72ee1$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $c0c3aad300d72ee1$var$offset
    };
});
parcelRegister("3dDWl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$258191447a7022df$export$2e2bcd8739ae039);
    var $jwSgb;
    var $QXpw1;
    var $4tIVJ;
    var $kgkit;
    var $cqF2x;
    var $kJPed;
    var $cGRJ4;
    function $258191447a7022df$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jwSgb")).default)(placement);
        return [
            (0, (0, parcelRequire("4tIVJ")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("4tIVJ")).default)(oppositePlacement)
        ];
    }
    function $258191447a7022df$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jwSgb")).default)(preferredPlacement)
        ] : $258191447a7022df$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("QXpw1")).default)(placement) === (0, (0, parcelRequire("kJPed")).auto) ? (0, (0, parcelRequire("cqF2x")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("QXpw1")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("cGRJ4")).default)(placement) === (0, (0, parcelRequire("kJPed")).start);
            var isVertical = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("kJPed")).right) : (0, (0, parcelRequire("kJPed")).left) : isStartVariation ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jwSgb")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $258191447a7022df$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $258191447a7022df$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jwSgb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37b1862c86f39c4$export$2e2bcd8739ae039);
    var $e37b1862c86f39c4$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e37b1862c86f39c4$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e37b1862c86f39c4$var$hash[matched];
        });
    }
});
parcelRegister("4tIVJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342cb90cb2622617$export$2e2bcd8739ae039);
    var $342cb90cb2622617$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $342cb90cb2622617$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $342cb90cb2622617$var$hash[matched];
        });
    }
});
parcelRegister("kgkit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec050bcf5e349283$export$2e2bcd8739ae039);
    var $dknpr;
    var $eVELE;
    var $g2O7Z;
    var $dJ0Jl;
    var $h8W1z;
    var $kJPed;
    var $gmkfg;
    var $gIXWB;
    var $50KfK;
    function $ec050bcf5e349283$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("kJPed")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("kJPed")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("kJPed")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? (0, (0, parcelRequire("kJPed")).reference) : (0, (0, parcelRequire("kJPed")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("dknpr")).default)((0, (0, parcelRequire("gmkfg")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("eVELE")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("g2O7Z")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dJ0Jl")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("h8W1z")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("kJPed")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("kJPed")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("kJPed")).right),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("kJPed")).top),
                    (0, (0, parcelRequire("kJPed")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("dknpr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b3f4d3932acb3b2$export$2e2bcd8739ae039);
    var $kJPed;
    var $3V2hG;
    var $9NXD7;
    var $2r6BH;
    var $gbHJy;
    var $eVELE;
    var $1ix2F;
    var $gmkfg;
    var $g2O7Z;
    var $eTUzl;
    var $j6yPg;
    var $f5IBt;
    var $h8W1z;
    var $90xPK;
    function $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("g2O7Z")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("kJPed")).viewport) ? (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("3V2hG")).default)(element, strategy)) : (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) ? $9b3f4d3932acb3b2$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("h8W1z")).default)((0, (0, parcelRequire("9NXD7")).default)((0, (0, parcelRequire("eVELE")).default)(element)));
    }
    function $9b3f4d3932acb3b2$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("2r6BH")).default)((0, (0, parcelRequire("eTUzl")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("1ix2F")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("gmkfg")).isHTMLElement)(element) ? (0, (0, parcelRequire("gbHJy")).default)(element) : element;
        if (!(0, (0, parcelRequire("gmkfg")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("gmkfg")).isElement)(clippingParent) && (0, (0, parcelRequire("j6yPg")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("f5IBt")).default)(clippingParent) !== 'body';
        });
    }
    function $9b3f4d3932acb3b2$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $9b3f4d3932acb3b2$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("90xPK")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("90xPK")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("90xPK")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("90xPK")).max)(rect.left, accRect.left);
            return accRect;
        }, $9b3f4d3932acb3b2$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("3V2hG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2da877912142c34b$export$2e2bcd8739ae039);
    var $1Prpe;
    var $eVELE;
    var $imzt5;
    var $d8bsQ;
    function $2da877912142c34b$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("1Prpe")).default)(element);
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("d8bsQ")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("imzt5")).default)(element),
            y: y
        };
    }
});
parcelRegister("9NXD7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7236f1f1532b7fe8$export$2e2bcd8739ae039);
    var $eVELE;
    var $1ix2F;
    var $imzt5;
    var $8YTLN;
    var $90xPK;
    function $7236f1f1532b7fe8$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("eVELE")).default)(element);
        var winScroll = (0, (0, parcelRequire("8YTLN")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("90xPK")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("90xPK")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("imzt5")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("1ix2F")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("90xPK")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("j6yPg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de89978be23479c4$export$2e2bcd8739ae039);
    var $gmkfg;
    function $de89978be23479c4$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("gmkfg")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("h8W1z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c7b0316bb2f8fd97$export$2e2bcd8739ae039);
    function $c7b0316bb2f8fd97$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("gIXWB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2cf410c4fe133f4$export$2e2bcd8739ae039);
    var $1ANH0;
    function $c2cf410c4fe133f4$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1ANH0")).default)(), paddingObject);
    }
});
parcelRegister("1ANH0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$128fb32b18b92ffa$export$2e2bcd8739ae039);
    function $128fb32b18b92ffa$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("50KfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3a60d4b4ac4f93e5$export$2e2bcd8739ae039);
    function $3a60d4b4ac4f93e5$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("cqF2x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c7bf65fbdbec33$export$2e2bcd8739ae039);
    var $cGRJ4;
    var $kJPed;
    var $kgkit;
    var $QXpw1;
    function $90c7bf65fbdbec33$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("kJPed")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("kJPed")).variationPlacements) : (0, (0, parcelRequire("kJPed")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("cGRJ4")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("kJPed")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kgkit")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("QXpw1")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("1DdSC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13043339457d5bc5$export$2e2bcd8739ae039);
    var $kJPed;
    var $QXpw1;
    var $9GF9F;
    var $dNtrn;
    var $4WpIh;
    var $jkGDj;
    var $gbHJy;
    var $kgkit;
    var $cGRJ4;
    var $1ANH0;
    var $90xPK;
    function $13043339457d5bc5$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var variation = (0, (0, parcelRequire("cGRJ4")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("dNtrn")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("kJPed")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("kJPed")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("jkGDj")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1ANH0")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("4WpIh")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("gbHJy")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("4WpIh")).within)(tether ? (0, (0, parcelRequire("90xPK")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("90xPK")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("kJPed")).top),
                (0, (0, parcelRequire("kJPed")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("4WpIh")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("4WpIh")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $13043339457d5bc5$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $13043339457d5bc5$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("dNtrn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0b6b03fadcbdfd7$export$2e2bcd8739ae039);
    function $a0b6b03fadcbdfd7$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("4WpIh", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$3990864f59117d05$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$3990864f59117d05$export$86c8af6d3ef0b4a);
    var $90xPK;
    function $3990864f59117d05$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("90xPK")).max)(min, (0, (0, parcelRequire("90xPK")).min)(value, max));
    }
    function $3990864f59117d05$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $3990864f59117d05$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("gzAfz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c10c08bd5e0ed9fb$export$2e2bcd8739ae039);
    var $QXpw1;
    var $jkGDj;
    var $j6yPg;
    var $gbHJy;
    var $9GF9F;
    var $4WpIh;
    var $gIXWB;
    var $50KfK;
    var $kJPed;
    var $c10c08bd5e0ed9fb$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("gIXWB")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("50KfK")).default)(padding, (0, (0, parcelRequire("kJPed")).basePlacements)));
    };
    function $c10c08bd5e0ed9fb$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("QXpw1")).default)(state.placement);
        var axis = (0, (0, parcelRequire("9GF9F")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("kJPed")).left),
            (0, (0, parcelRequire("kJPed")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $c10c08bd5e0ed9fb$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("jkGDj")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).top) : (0, (0, parcelRequire("kJPed")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("kJPed")).bottom) : (0, (0, parcelRequire("kJPed")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("gbHJy")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("4WpIh")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $c10c08bd5e0ed9fb$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("j6yPg")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $c10c08bd5e0ed9fb$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $c10c08bd5e0ed9fb$var$arrow,
        effect: $c10c08bd5e0ed9fb$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("6iLAT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$496957b0c691a0ed$export$2e2bcd8739ae039);
    var $kJPed;
    var $kgkit;
    function $496957b0c691a0ed$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $496957b0c691a0ed$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("kJPed")).top),
            (0, (0, parcelRequire("kJPed")).right),
            (0, (0, parcelRequire("kJPed")).bottom),
            (0, (0, parcelRequire("kJPed")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $496957b0c691a0ed$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kgkit")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $496957b0c691a0ed$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $496957b0c691a0ed$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $496957b0c691a0ed$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $496957b0c691a0ed$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $496957b0c691a0ed$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $496957b0c691a0ed$var$hide
    };
});
parcelRegister("iGDLS", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$d9aafffd117cbcc1$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $5n5w4;
    var $eclLw;
    function $d9aafffd117cbcc1$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("5n5w4")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("eclLw")).setRef)(innerRef, node);
            (0, (0, parcelRequire("eclLw")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("eclLw")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("eclLw")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hT6ku", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$3f79b132df1e01ff$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$3f79b132df1e01ff$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$3f79b132df1e01ff$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gMMNe;
    var $bChGW;
    var $k5uoT;
    var $jldZL;
    function $3f79b132df1e01ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3f79b132df1e01ff$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)}`})`
    });
    const $3f79b132df1e01ff$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $3f79b132df1e01ff$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $3f79b132df1e01ff$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $3f79b132df1e01ff$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $3f79b132df1e01ff$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gMMNe"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $3f79b132df1e01ff$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $3f79b132df1e01ff$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $3f79b132df1e01ff$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $3f79b132df1e01ff$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, props));
    const $3f79b132df1e01ff$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $3f79b132df1e01ff$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorSeparator, props);
    const $3f79b132df1e01ff$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ClearIndicator, props);
    const $3f79b132df1e01ff$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValueRemove, props);
    const $3f79b132df1e01ff$export$71abc632aa29e6fe = {
        Control: $3f79b132df1e01ff$var$Control,
        DropdownIndicator: $3f79b132df1e01ff$var$DropdownIndicator,
        Menu: $3f79b132df1e01ff$var$Menu,
        IndicatorSeparator: $3f79b132df1e01ff$var$IndicatorSeparator,
        ClearIndicator: $3f79b132df1e01ff$var$ClearIndicator,
        MultiValueRemove: $3f79b132df1e01ff$var$MultiValueRemove
    };
});
parcelRegister("gMMNe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c386fa4cb21167b0$var$_react = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c386fa4cb21167b0$var$_search = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("hyOJh")));
    var $c386fa4cb21167b0$var$_search2 = $c386fa4cb21167b0$var$_interopRequireDefault((parcelRequire("77ZoC")));
    function $c386fa4cb21167b0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c386fa4cb21167b0$var$SearchIcon = (props)=>$c386fa4cb21167b0$var$_react.default.createElement($c386fa4cb21167b0$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $c386fa4cb21167b0$var$_search2.default
        }, props));
    $c386fa4cb21167b0$var$SearchIcon.Name = 'SearchIconMigration';
    var $c386fa4cb21167b0$var$_default = module.exports.default = $c386fa4cb21167b0$var$SearchIcon;
});
parcelRegister("77ZoC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5308cfd5e45a5605$var$_react = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5308cfd5e45a5605$var$_search = $5308cfd5e45a5605$var$_interopRequireDefault((parcelRequire("hyOJh")));
    function $5308cfd5e45a5605$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5308cfd5e45a5605$var$EditorSearchIcon = (props)=>$5308cfd5e45a5605$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $5308cfd5e45a5605$var$_search.default
        }));
    $5308cfd5e45a5605$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $5308cfd5e45a5605$var$_default = module.exports.default = $5308cfd5e45a5605$var$EditorSearchIcon;
});
parcelRegister("78Gdn", function(module, exports) {
    $parcel$export(module.exports, "batchByKey", ()=>$2e9cc1cdc768945e$export$da86c38211c1c0a8);
    function $2e9cc1cdc768945e$export$da86c38211c1c0a8(callback) {
        const calls = {};
        return (key, ...args)=>{
            if (!calls[key]) {
                window.setTimeout(()=>{
                    callback(key, calls[key]);
                    delete calls[key];
                });
                calls[key] = [];
            }
            calls[key].push(args);
        };
    }
});
parcelRegister("8fG8p", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7b21650c04984462$export$defe85febe8b728c);
    var $7VHMR;
    const $7b21650c04984462$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            id: 'fabric.elements.user-picker.placeholder',
            defaultMessage: 'Enter people or teams...',
            description: 'Placeholder description for empty user/team/email select field.'
        },
        addMore: {
            id: 'fabric.elements.user-picker.placeholder.add-more',
            defaultMessage: 'add more people...',
            description: 'Placeholder for multi user picker when the field is not empty.'
        },
        remove: {
            id: 'fabric.elements.user-picker.multi.remove-item',
            defaultMessage: 'Remove',
            description: 'Tooltip for the single item remove button in a multi user select field.'
        },
        clear: {
            id: 'fabric.elements.user-picker.single.clear',
            defaultMessage: 'Clear',
            description: 'Tooltip for clear button in the single user select field.'
        },
        errorMessage: {
            id: 'fabric.elements.user-picker.error.message',
            defaultMessage: 'Something went wrong',
            description: 'Error message to display when options fail to load.'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.user-picker.team.member.count.including.you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.user-picker.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.user-picker.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        },
        addEmail: {
            id: 'fabric.elements.user-picker.email.add',
            defaultMessage: 'Add user',
            description: 'Byline for valid email option.'
        },
        selectToAddEmail: {
            id: 'fabric.elements.user-picker.email.select.to.add',
            defaultMessage: 'Select an email address',
            description: 'Byline for valid email option.'
        },
        continueToAddEmail: {
            id: 'fabric.elements.user-picker.email.add.potential',
            defaultMessage: 'Enter an email address',
            description: 'Byline for a potentially valid email option.'
        },
        groupByline: {
            id: 'fabric.elements.user-picker.group.byline',
            defaultMessage: 'Admin-managed group',
            description: 'Byline for admin-managed groups'
        },
        externalUserSourcesHeading: {
            id: 'fabric.elements.user-picker.external.sourced.from',
            defaultMessage: 'Found in:',
            description: 'From where the external user is coming'
        },
        externalUserSourcesError: {
            id: 'fabric.elements.user-picker.external.sourced.error',
            defaultMessage: "We can't connect you right now.",
            description: "Error message when we can't fetch a user's import sources"
        },
        slackProvider: {
            id: 'fabric.elements.user-picker.slack.provider',
            defaultMessage: 'Slack',
            description: 'This external user is sourced from Slack provider'
        },
        googleProvider: {
            id: 'fabric.elements.user-picker.google.provider',
            defaultMessage: 'Google',
            description: 'This external user is sourced from Google provider'
        },
        microsoftProvider: {
            id: 'fabric.elements.user-picker.microsoft.provider',
            defaultMessage: 'Microsoft',
            description: 'This external user is sourced from Microsoft provider'
        },
        gitHubProvider: {
            id: 'fabric.elements.user-picker.github.provider',
            defaultMessage: 'GitHub',
            description: 'This external user is sourced from GitHub provider'
        },
        jiraSource: {
            id: 'fabric.elements.user-picker.source.jira',
            defaultMessage: 'Jira',
            description: 'This external user is sourced from Jira'
        },
        confluenceSource: {
            id: 'fabric.elements.user-picker.source.confluence',
            defaultMessage: 'Confluence',
            description: 'This external user is sourced from Confluence'
        },
        otherAtlassianSource: {
            id: 'fabric.elements.user-picker.source.other-atlassian',
            defaultMessage: 'Other Atlassian products',
            description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
        },
        memberLozengeText: {
            id: 'fabric.elements.user-picker.member.lozenge.text',
            defaultMessage: 'MEMBER',
            description: 'Text within the Lozenge when the user is a workspace member'
        },
        guestLozengeText: {
            id: 'fabric.elements.user-picker.guest.lozenge.text',
            defaultMessage: 'GUEST',
            description: 'Text within the lozenge when the user is a guest of confluence'
        },
        guestUserLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
            defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
        },
        guestGroupLozengeTooltip: {
            id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
            defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
            description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
        }
    });
});
parcelRegister("pk97C", function(module, exports) {
    $parcel$export(module.exports, "userPickerRenderedUfoExperience", ()=>$06ebadcdd7d5e231$export$b49757166e1acfc2);
    $parcel$export(module.exports, "userPickerOptionsShownUfoExperience", ()=>$06ebadcdd7d5e231$export$135a264e0da507ae);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$06ebadcdd7d5e231$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    var $jZA09;
    const $06ebadcdd7d5e231$export$b49757166e1acfc2 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-rendered', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $06ebadcdd7d5e231$export$135a264e0da507ae = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('user-picker-options-shown', {
        platform: {
            component: 'user-picker'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    });
    class $06ebadcdd7d5e231$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            const instance = $06ebadcdd7d5e231$export$b49757166e1acfc2.getInstance(this.props.id);
            if (instance.state.id !== (0, (0, parcelRequire("jZA09")).UFOExperienceState).FAILED.id) instance.failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("2wgOn", function(module, exports) {
    $parcel$export(module.exports, "BORDER_PADDING", ()=>$01bdbab7be42e070$export$59c188914e58c94b);
    $parcel$export(module.exports, "getStyles", ()=>$01bdbab7be42e070$export$ffd58b7f6f099a57);
    $parcel$export(module.exports, "getPopupStyles", ()=>$01bdbab7be42e070$export$4e983f376ad8a3af);
    var $8QpSo;
    var $7VXAu;
    const $01bdbab7be42e070$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
    const $01bdbab7be42e070$export$53937c04f7dfc2ae = 6;
    const $01bdbab7be42e070$export$2c62ba763e976c54 = 39;
    const $01bdbab7be42e070$export$ffd58b7f6f099a57 = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, isCompact, overrideStyles, isInvalid)=>{
        let styles = {
            menu: (css, state)=>({
                    ...css,
                    width: width,
                    minWidth: state.selectProps.menuMinWidth,
                    zIndex: '400'
                }),
            menuList: (css)=>({
                    ...css,
                    zIndex: '400'
                }),
            control: (css, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    width: width,
                    borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                    backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`,
                    '&:hover .fabric-user-picker__clear-indicator': {
                        opacity: 1
                    },
                    ':hover': {
                        ...css[':hover'],
                        borderColor: isInvalid ? `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})` : state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $829f609a65d26a98$export$ecfc1dff386a3e7a})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $829f609a65d26a98$export$7c87d337fb91a97d})`,
                        backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $829f609a65d26a98$export$4b84fd0e2c617bd})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$29a4f05edc054374})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : `var(--ds-background-input-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`
                    },
                    padding: 0,
                    minHeight: isCompact ? 'none' : 44,
                    height: isCompact || isMulti ? '100%' : 44,
                    maxWidth: '100%'
                };
            },
            clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                    ...css,
                    opacity: 1,
                    '@media (hover: hover) and (pointer: fine)': {
                        opacity: 0
                    },
                    transition: css.transition + ', opacity 150ms',
                    paddingTop: 0,
                    padding: 0,
                    ':hover': {
                        color: `var(--ds-icon-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`
                    }
                }),
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
                const isMulti = state.selectProps.isMulti;
                return {
                    ...css,
                    gridTemplateColumns: 'auto 1fr',
                    paddingTop: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingBottom: isCompact ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    paddingLeft: isMulti ? $01bdbab7be42e070$export$59c188914e58c94b : 0,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                    scrollbarWidth: 'none',
                    maxHeight: state.selectProps.maxPickerHeight || '100%',
                    '::-webkit-scrollbar': {
                        width: 0,
                        background: 'transparent'
                    }
                };
            },
            multiValue: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'default'
                }),
            multiValueLabel: (css)=>({
                    ...css,
                    fontSize: '100%',
                    display: 'flex'
                }),
            multiValueRemove: (css)=>({
                    ...css,
                    borderRadius: 24,
                    cursor: 'pointer'
                }),
            placeholder: (css, state)=>{
                if (css.position === 'absolute' && !css.left) css.left = `${$01bdbab7be42e070$export$59c188914e58c94b}px`;
                return {
                    ...css,
                    gridArea: '1/2/2/3',
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    margin: 0,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                };
            },
            option: (css)=>({
                    ...css,
                    overflow: 'hidden'
                }),
            input: (css, state)=>({
                    ...css,
                    gridArea: '1/2/2/3',
                    gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                    margin: `${"var(--ds-space-050, 4px)"} 0`,
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: state.selectProps.isMulti ? 0 : $01bdbab7be42e070$export$59c188914e58c94b,
                    '& input::placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        opacity: 1
                    },
                    '& input:-ms-input-placeholder': {
                        color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$d6447c357493214f})`
                    }
                }),
            singleValue: (css)=>({
                    ...css,
                    margin: 0,
                    gridArea: '1/2/2/3'
                })
        };
        return overrideStyles ? (0, (0, parcelRequire("7VXAu")).mergeStyles)(styles, overrideStyles) : styles;
    });
    const $01bdbab7be42e070$export$4e983f376ad8a3af = (0, (0, parcelRequire("8QpSo")).default)((width, isMulti, overrideStyles)=>({
            ...$01bdbab7be42e070$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
        }));
});
parcelRegister("dyegP", function(module, exports) {
    $parcel$export(module.exports, "getComponents", ()=>$27e51ea041192381$export$4e811121b221213b);
    $parcel$export(module.exports, "getPopupComponents", ()=>$27e51ea041192381$export$19205fd341a6bb08);
    var $8QpSo;
    var $dqbw8;
    var $8Y8Qe;
    var $fIpmY;
    var $3QONt;
    var $6Kkci;
    var $OxpB4;
    var $ee8bl;
    var $h3ej5;
    var $6Ks8i;
    var $lYehz;
    const $27e51ea041192381$export$4e811121b221213b = (0, (0, parcelRequire("8QpSo")).default)((multi, anchor)=>{
        if (anchor) return {
            Control: anchor,
            Option: (0, parcelRequire("3QONt")).Option
        };
        else return {
            MultiValue: (0, parcelRequire("8Y8Qe")).MultiValue,
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: multi ? null : (0, (0, parcelRequire("dqbw8")).ClearIndicator),
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: multi ? (0, (0, parcelRequire("fIpmY")).MultiValueContainer) : (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, parcelRequire("OxpB4")).Input,
            Menu: (0, parcelRequire("lYehz")).Menu
        };
    });
    const $27e51ea041192381$export$19205fd341a6bb08 = (0, (0, parcelRequire("8QpSo")).default)((hasPopupTitle)=>{
        const baseProps = {
            DropdownIndicator: null,
            SingleValue: (0, parcelRequire("6Kkci")).SingleValue,
            ClearIndicator: (0, parcelRequire("dqbw8")).ClearIndicator,
            Option: (0, parcelRequire("3QONt")).Option,
            ValueContainer: (0, (0, parcelRequire("ee8bl")).SingleValueContainer),
            Input: (0, (0, parcelRequire("h3ej5")).PopupInput)
        };
        if (hasPopupTitle) return {
            ...baseProps,
            Control: (0, (0, parcelRequire("6Ks8i")).PopupControl)
        };
        return baseProps;
    });
});
parcelRegister("dqbw8", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$11bf495008933d24$export$ecf9cf59142dd54a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $11bf495008933d24$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    class $11bf495008933d24$export$ecf9cf59142dd54a extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
            const Indicator = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ClearIndicator, {
                ...this.props,
                innerProps: {
                    ...this.props.innerProps,
                    onMouseDown: this.handleMouseDown
                }
            });
            return clearValueLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: Indicator
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($11bf495008933d24$var$AsyncTooltip, {
                content: clearValueLabel
            }, Indicator)) : Indicator;
        }
        constructor(...args){
            super(...args), this.handleMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                const { clearValue: clearValue, selectProps: selectProps } = this.props;
                clearValue();
                if (selectProps && !selectProps.isFocused) event.stopPropagation();
            };
        }
    }
});
parcelRegister("inSCC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOT8O").then(()=>parcelRequire('8hfZh'));
});
parcelRegister("8Y8Qe", function(module, exports) {
    $parcel$export(module.exports, "MultiValue", ()=>$65368b71d1856c3a$export$419cdf50db8b579);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $bChGW;
    var $f8Sb3;
    var $dW8NE;
    var $5pJx4;
    var $3smIt;
    var $4hqZ5;
    var $fuhQD;
    var $VSDnB;
    function $65368b71d1856c3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $65368b71d1856c3a$export$118122ebc1e626fa = (valueContainer, control)=>{
        const { top: top, height: height } = valueContainer.getBoundingClientRect();
        const { height: controlHeight } = control.getBoundingClientRect();
        if (top - height < 0) valueContainer.scrollIntoView();
        if (top + height > controlHeight) valueContainer.scrollIntoView(false);
    };
    const $65368b71d1856c3a$var$groupTagContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.025',
        marginTop: 'space.025'
    });
    const $65368b71d1856c3a$var$nameWrapper = {
        name: "6urmvo",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
    };
    class $65368b71d1856c3a$export$419cdf50db8b579 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.getElemBefore = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dW8NE")).AddOptionAvatar), {
                    isLozenge: true
                });
                if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $65368b71d1856c3a$var$groupTagContainer
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("4hqZ5"))))), {
                    LEGACY_margin: "-2px 0 0 0",
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small"
                }));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "multi",
                    src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                    type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
                });
            }, this.getElemAfter = ()=>{
                const { data: { data: data } } = this.props;
                if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
                    size: "small"
                });
                return null;
            };
            this.containerRef = (0, ($parcel$interopDefault($5uXOq))).createRef();
        }
        componentDidUpdate() {
            const { isFocused: isFocused } = this.props;
            if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $65368b71d1856c3a$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
        }
        shouldComponentUpdate(nextProps) {
            const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
            const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
            return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        }
        render() {
            const { children: children, innerProps: innerProps, ...rest } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).MultiValue, {
                ...rest,
                innerProps: {
                    ref: this.containerRef
                },
                cropWithEllipsis: false
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, this.getElemBefore(), " ", (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $65368b71d1856c3a$var$nameWrapper
            }, children), this.getElemAfter()));
        }
    }
});
parcelRegister("dW8NE", function(module, exports) {
    $parcel$export(module.exports, "AddOptionAvatar", ()=>$f3236d5a67f7ff1f$export$df396db45e491922);
    var $aVnO1;
    var $f8Sb3;
    parcelRequire("5uXOq");
    const $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
        const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: padding,
            backgroundColor: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            marginLeft: "var(--ds-space-025, 2px)"
        });
    };
    const $f3236d5a67f7ff1f$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f3236d5a67f7ff1f$var$getEmailAvatarWrapperStyle(isLozenge)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))), {
            testId: "add-option-avatar-email-icon",
            label: label || '',
            LEGACY_size: isLozenge ? 'small' : 'medium',
            LEGACY_margin: "0 0 0 -2px",
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        })));
    };
});
parcelRegister("aVnO1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7f41b19bed4136e0$var$_react = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7f41b19bed4136e0$var$_email = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("eRB05")));
    var $7f41b19bed4136e0$var$_email2 = $7f41b19bed4136e0$var$_interopRequireDefault((parcelRequire("5bEkJ")));
    function $7f41b19bed4136e0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7f41b19bed4136e0$var$EmailIcon = (props)=>$7f41b19bed4136e0$var$_react.default.createElement($7f41b19bed4136e0$var$_email.default, Object.assign({
            LEGACY_fallbackIcon: $7f41b19bed4136e0$var$_email2.default
        }, props));
    $7f41b19bed4136e0$var$EmailIcon.Name = 'EmailIconMigration';
    var $7f41b19bed4136e0$var$_default = module.exports.default = $7f41b19bed4136e0$var$EmailIcon;
});
parcelRegister("eRB05", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad22b76beceec928$var$_react = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad22b76beceec928$var$_UNSAFE_baseNew = $ad22b76beceec928$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad22b76beceec928$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad22b76beceec928$var$EmailIcon = (props)=>$ad22b76beceec928$var$_react.default.createElement($ad22b76beceec928$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
        }, props));
    $ad22b76beceec928$var$EmailIcon.displayName = 'EmailIcon';
    var $ad22b76beceec928$var$_default = module.exports.default = $ad22b76beceec928$var$EmailIcon;
});
parcelRegister("5bEkJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3c6d443366bf8cbb$var$_react = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3c6d443366bf8cbb$var$_email = $3c6d443366bf8cbb$var$_interopRequireDefault((parcelRequire("eRB05")));
    function $3c6d443366bf8cbb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3c6d443366bf8cbb$var$EmailIcon = (props)=>$3c6d443366bf8cbb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
        }, props, {
            newIcon: $3c6d443366bf8cbb$var$_email.default
        }));
    $3c6d443366bf8cbb$var$EmailIcon.displayName = 'EmailIcon';
    var $3c6d443366bf8cbb$var$_default = module.exports.default = $3c6d443366bf8cbb$var$EmailIcon;
});
parcelRegister("5pJx4", function(module, exports) {
    $parcel$export(module.exports, "SizeableAvatar", ()=>$50cd04ab4dcbd6e5$export$44d81a88129649da);
    var $ujWmd;
    var $fwSAz;
    var $5uXOq = parcelRequire("5uXOq");
    var $3smIt;
    class $50cd04ab4dcbd6e5$export$44d81a88129649da extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
            const props = {
                size: (0, (0, parcelRequire("3smIt")).getAvatarSize)(appearance),
                src: src,
                borderColor: 'transparent',
                presence: presence
            };
            return type === 'team' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwSAz")).default), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), props);
        }
    }
});
parcelRegister("fwSAz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cdf5ede1a400c9d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ujWmd;
    var $2w1D3;
    const $6cdf5ede1a400c9d$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $6cdf5ede1a400c9d$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    function $6cdf5ede1a400c9d$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "circle",
            ...props,
            size: size,
            src: src,
            testId: `${testId}-team-avatar`
        }, (innerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w1D3")).TeamAvatarImage), {
                src: src,
                size: size,
                testId: testId,
                ...innerProps
            }));
    }
});
parcelRegister("2w1D3", function(module, exports) {
    $parcel$export(module.exports, "TeamAvatarImage", ()=>$7d2527153712d181$export$ac3673635a5387be);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $vIiRg;
    var $h8cgU;
    function $7d2527153712d181$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7d2527153712d181$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $7d2527153712d181$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $7d2527153712d181$var$ICON_PADDING = 4;
    const $7d2527153712d181$var$avatarDefaultIconStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        backgroundColor: $7d2527153712d181$var$ICON_COLOR,
        borderRadius: '50%',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $7d2527153712d181$var$nestedAvatarStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                width: `${size}px`,
                height: `${size}px`,
                '& svg': {
                    width: `${size - $7d2527153712d181$var$ICON_PADDING}px`,
                    height: `${size - $7d2527153712d181$var$ICON_PADDING}px`
                }
            })
        };
    }, {});
    const $7d2527153712d181$var$avatarImageStyles = {
        name: "n68006",
        styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
    };
    const $7d2527153712d181$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
        const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            setHasImageErrored(false);
        }, [
            src
        ]);
        if (!src || hasImageErrored) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $7d2527153712d181$var$avatarDefaultIconStyles,
                $7d2527153712d181$var$nestedAvatarStyles[size]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8cgU"))))), {
            label: alt,
            primaryColor: $7d2527153712d181$var$ICON_BACKGROUND,
            secondaryColor: $7d2527153712d181$var$ICON_COLOR,
            testId: testId && `${testId}--team`
        }));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", rest, (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
            src: src,
            alt: alt,
            "data-testid": testId && `${testId}--image`,
            css: $7d2527153712d181$var$avatarImageStyles,
            onError: ()=>setHasImageErrored(true)
        }));
    };
});
parcelRegister("h8cgU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c78cb3eb85357720$var$_react = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c78cb3eb85357720$var$_peopleGroup = $c78cb3eb85357720$var$_interopRequireDefault((parcelRequire("fptva")));
    function $c78cb3eb85357720$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c78cb3eb85357720$var$PeopleIcon = (props)=>$c78cb3eb85357720$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0z"/><path d="M13 12a1.997 1.997 0 0 0-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3 3 0 0 1 12.997 12z"/></g></svg>`
        }, props, {
            newIcon: $c78cb3eb85357720$var$_peopleGroup.default
        }));
    $c78cb3eb85357720$var$PeopleIcon.displayName = 'PeopleIcon';
    var $c78cb3eb85357720$var$_default = module.exports.default = $c78cb3eb85357720$var$PeopleIcon;
});
parcelRegister("4hqZ5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $31ddae7439c341a9$var$_react = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $31ddae7439c341a9$var$_peopleGroup = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("fptva")));
    var $31ddae7439c341a9$var$_people = $31ddae7439c341a9$var$_interopRequireDefault((parcelRequire("h8cgU")));
    function $31ddae7439c341a9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $31ddae7439c341a9$var$PeopleGroupIcon = (props)=>$31ddae7439c341a9$var$_react.default.createElement($31ddae7439c341a9$var$_peopleGroup.default, Object.assign({
            LEGACY_fallbackIcon: $31ddae7439c341a9$var$_people.default
        }, props));
    $31ddae7439c341a9$var$PeopleGroupIcon.Name = 'PeopleGroupIconMigration';
    var $31ddae7439c341a9$var$_default = module.exports.default = $31ddae7439c341a9$var$PeopleGroupIcon;
});
parcelRegister("fuhQD", function(module, exports) {
    $parcel$export(module.exports, "VerifiedTeamIcon", ()=>$a137cc376204c926$export$d7949f68d31e5edd);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gqGjQ;
    var $fGmbh;
    var $3bDjY;
    var $27dJz;
    const $a137cc376204c926$export$d7949f68d31e5edd = ({ size: size, label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, (0, parcelRequire("27dJz")).messages).verifiedIconDefaultTooltip) : undefined;
        return tooltipContent ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "aria-hidden": "true",
            "data-testid": "verified-team-icon"
        }, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            label: tooltipContent,
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gqGjQ"))))), {
            color: "var(--ds-icon-accent-blue, #1D7AFC)",
            LEGACY_size: size,
            spacing: "spacious",
            label: label,
            LEGACY_fallbackIcon: (0, (0, parcelRequire("fGmbh")).default)
        });
    };
});
parcelRegister("gqGjQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bf5fe6b7538334be$var$_react = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bf5fe6b7538334be$var$_UNSAFE_baseNew = $bf5fe6b7538334be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bf5fe6b7538334be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bf5fe6b7538334be$var$StatusVerifiedIcon = (props)=>$bf5fe6b7538334be$var$_react.default.createElement($bf5fe6b7538334be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.15.444a1.713 1.713 0 0 0-2.3 0L5.7 1.486a.2.2 0 0 1-.15.055L4 1.481a1.713 1.713 0 0 0-1.763 1.48l-.21 1.536a.2.2 0 0 1-.08.139l-1.226.95c-.696.54-.87 1.52-.4 2.266l.828 1.312c.03.047.04.104.027.159l-.328 1.515A1.713 1.713 0 0 0 2 12.831l1.477.474a.2.2 0 0 1 .123.103l.723 1.372c.41.78 1.346 1.12 2.162.787l1.436-.586a.2.2 0 0 1 .16 0l1.436.586a1.713 1.713 0 0 0 2.162-.787l.723-1.372a.2.2 0 0 1 .123-.103l1.477-.474a1.713 1.713 0 0 0 1.15-1.993l-.328-1.515a.2.2 0 0 1 .028-.159l.827-1.312a1.71 1.71 0 0 0-.4-2.266l-1.225-.95a.2.2 0 0 1-.08-.14l-.21-1.536A1.713 1.713 0 0 0 12 1.481l-1.55.06a.2.2 0 0 1-.15-.055zm3.176 5.036-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $bf5fe6b7538334be$var$StatusVerifiedIcon.displayName = 'StatusVerifiedIcon';
    var $bf5fe6b7538334be$var$_default = module.exports.default = $bf5fe6b7538334be$var$StatusVerifiedIcon;
});
parcelRegister("fGmbh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9bd2ad2ea16bb95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $d9bd2ad2ea16bb95$var$VerifiedIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "33",
            height: "32",
            viewBox: "0 0 33 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M18.6666 6.65507C17.7592 4.89362 15.2407 4.89362 14.3332 6.65507C13.7879 7.7135 12.5577 8.22306 11.4237 7.86022C9.53648 7.25639 7.75565 9.03721 8.35949 10.9244C8.72232 12.0584 8.21276 13.2886 7.15434 13.8339C5.39289 14.7414 5.39289 17.2599 7.15434 18.1674C8.21276 18.7127 8.72232 19.9429 8.35949 21.0769C7.75565 22.9641 9.53648 24.7449 11.4237 24.1411C12.5577 23.7783 13.7879 24.2878 14.3332 25.3462C15.2407 27.1077 17.7592 27.1077 18.6666 25.3462C19.212 24.2878 20.4421 23.7783 21.5761 24.1411C23.4634 24.7449 25.2442 22.9641 24.6404 21.0769C24.2775 19.9429 24.7871 18.7127 25.8455 18.1674C27.607 17.2599 27.607 14.7414 25.8455 13.8339C24.7871 13.2886 24.2775 12.0584 24.6404 10.9244C25.2442 9.03721 23.4634 7.25639 21.5761 7.86022C20.4421 8.22306 19.212 7.7135 18.6666 6.65507ZM20.7898 12.7002L20.8932 12.7923C21.323 13.2221 21.3537 13.8998 20.9853 14.365L20.8932 14.4684L16.1524 19.2091C15.7226 19.6389 15.0449 19.6696 14.5797 19.3012L14.4764 19.2091L12.106 16.8388C11.6431 16.3759 11.6431 15.6255 12.106 15.1627C12.5358 14.7329 13.2135 14.7022 13.6787 15.0706L13.7821 15.1627L15.3146 16.6944L19.2171 12.7923C19.6469 12.3625 20.3246 12.3318 20.7898 12.7002Z",
            fill: "currentColor"
        }));
    const $d9bd2ad2ea16bb95$var$VerifiedIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $d9bd2ad2ea16bb95$var$VerifiedIconGlyph
        });
    var $d9bd2ad2ea16bb95$export$2e2bcd8739ae039 = $d9bd2ad2ea16bb95$var$VerifiedIcon;
});
parcelRegister("27dJz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$952fb45ddff9712a$export$defe85febe8b728c);
    var $7VHMR;
    const $952fb45ddff9712a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        verifiedIconDefaultTooltip: {
            id: 'ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip',
            defaultMessage: 'Managed teams are verified because they can only be changed by an admin.',
            description: 'Tooltip text for the verified team icon'
        }
    });
});
parcelRegister("fIpmY", function(module, exports) {
    $parcel$export(module.exports, "MultiValueContainer", ()=>$0a44bca42d442dd9$export$cf9cf2a30a59265c);
    var $bChGW;
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $ousew;
    var $8fG8p;
    var $3smIt;
    var $jNYXM;
    class $0a44bca42d442dd9$export$cf9cf2a30a59265c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static getDerivedStateFromProps(nextProps, prevState) {
            return {
                valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
                previousValueSize: prevState.valueSize
            };
        }
        constructor(props){
            super(props), this.timeoutId = null, this.scrollToBottom = ()=>{
                this.timeoutId = window.setTimeout(()=>{
                    const { ref: { current: current } } = this.valueContainerInnerProps;
                    if (current !== null) {
                        const container = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(current);
                        if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                    }
                    this.timeoutId = null;
                });
            }, this.showPlaceholder = ()=>{
                const { selectProps: { value: value } } = this.props;
                return value && value.length > 0;
            }, this.addPlaceholder = (placeholder)=>{
                const children = (0, ($parcel$interopDefault($5uXOq))).Children.map(this.props.children, (child)=>(0, (0, parcelRequire("3smIt")).isChildInput)(child) && this.showPlaceholder() ? (0, ($parcel$interopDefault($5uXOq))).cloneElement(child, {
                        placeholder: placeholder
                    }) : child);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, children);
            }, this.renderChildren = ()=>{
                const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
                if (isDisabled) return this.props.children;
                if (addMoreMessage === undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("8fG8p")).messages).addMore, (addMore)=>{
                    let addMoreMessages = addMore;
                    if (addMore && typeof addMore === 'string') addMoreMessages = [
                        addMore
                    ];
                    const placeholder = addMoreMessages?.join('') ?? '';
                    return this.addPlaceholder(placeholder);
                });
                return this.addPlaceholder(addMoreMessage);
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
            this.state = {
                valueSize: 0,
                previousValueSize: 0
            };
            this.valueContainerInnerProps = {
                ref: (0, ($parcel$interopDefault($5uXOq))).createRef()
            };
        }
        componentDidUpdate() {
            const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
            const { isFocused: isFocused } = this.props.selectProps;
            if (valueSize > previousValueSize && isFocused) {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.scrollToBottom();
            }
        }
        componentWillUnmount() {
            if (this.timeoutId) window.clearTimeout(this.timeoutId);
        }
        render() {
            const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
            const props = {
                ...valueContainerProps,
                innerProps: this.valueContainerInnerProps
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).ValueContainer, props, this.renderChildren()));
        }
    }
});
parcelRegister("jNYXM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4661c12157fe2c0e$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $4661c12157fe2c0e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $4661c12157fe2c0e$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    const $4661c12157fe2c0e$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
        return isEnabled ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $4661c12157fe2c0e$var$_ref,
            onMouseDown: onMouseDown
        }, children) : children;
    };
    var $4661c12157fe2c0e$export$2e2bcd8739ae039 = $4661c12157fe2c0e$var$ValueContainerWrapper;
});
parcelRegister("3QONt", function(module, exports) {
    $parcel$export(module.exports, "Option", ()=>$99bbff5d4b124ec0$export$36d18380658d5d20);
    var $dC5iT;
    var $bChGW;
    var $3bDjY;
    var $5uXOq = parcelRequire("5uXOq");
    var $7SChb;
    var $IMPHa;
    var $8QliZ;
    var $jC9IK;
    var $3SqqV;
    var $f4ndh;
    var $3smIt;
    var $M0UM1;
    const $99bbff5d4b124ec0$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
    const $99bbff5d4b124ec0$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
        if ((0, (0, parcelRequire("3smIt")).isExternalUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("IMPHa")).default), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isUser)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7SChb")).UserOption), {
            user: data,
            status: status,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isEmail)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3SqqV")).default), {
            email: data,
            emailValidity: (0, (0, parcelRequire("M0UM1")).isValidEmail)(data.id),
            isSelected: isSelected,
            label: selectProps.emailLabel
        });
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QliZ")).default), {
            team: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isGroup)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jC9IK")).default), {
            group: data,
            isSelected: isSelected
        });
        if ((0, (0, parcelRequire("3smIt")).isCustom)(data)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4ndh")).default), {
            data: data,
            isSelected: isSelected
        });
        return null;
    };
    const $99bbff5d4b124ec0$var$dataOptionWithTooltip = (props)=>{
        if (props.data?.data?.tooltip) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: props.data?.data?.tooltip
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, $99bbff5d4b124ec0$var$dataOption(props)));
        return $99bbff5d4b124ec0$var$dataOption(props);
    };
    const $99bbff5d4b124ec0$export$36d18380658d5d20 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
            fallback: $99bbff5d4b124ec0$var$defaultOption(props)
        }, $99bbff5d4b124ec0$var$dataOptionWithTooltip(props)));
});
parcelRegister("7SChb", function(module, exports) {
    $parcel$export(module.exports, "UserOption", ()=>$f97ab606ddc0972b$export$8e59f78010871662);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $bfXHv;
    var $1Y8bw;
    var $5pJx4;
    var $3smIt;
    class $f97ab606ddc0972b$export$8e59f78010871662 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bfXHv")).AvatarItemOption), {
                avatar: this.renderAvatar(),
                lozenge: this.getLozengeProps(),
                isDisabled: this.props.user.isDisabled,
                primaryText: this.getPrimaryText(),
                secondaryText: this.renderSecondaryText()
            });
        }
        constructor(...args){
            super(...args), this.getPrimaryText = ()=>{
                const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
                const result = [
                    (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                        key: "name",
                        css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text, ${0, $829f609a65d26a98$export$7d61b15e0da132af})`)
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                        highlights: highlight && highlight.name
                    }, name))
                ];
                if ((0, (0, parcelRequire("3smIt")).hasValue)(publicName) && name.trim() !== publicName.trim()) result.push((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                    key: "publicName"
                }, ' ', (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, "(", (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Y8bw")).HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
                return result;
            }, this.renderSecondaryText = ()=>this.props.user.byline ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("bfXHv")).textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`)
                }, this.props.user.byline) : undefined, this.renderAvatar = ()=>{
                const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: "big",
                    src: avatarUrl,
                    presence: status
                });
            }, this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                    text: this.props.user.lozenge
                } : this.props.user.lozenge;
        }
    }
});
parcelRegister("bfXHv", function(module, exports) {
    $parcel$export(module.exports, "textWrapper", ()=>$9d51fec62de0f8e9$export$aa6223da92b253dd);
    $parcel$export(module.exports, "AvatarItemOption", ()=>$9d51fec62de0f8e9$export$164a9d9b3b86dd0c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lj8SI;
    var $3smIt;
    function $9d51fec62de0f8e9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9d51fec62de0f8e9$var$AsyncTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("inSCC")).then((module)=>{
            return {
                default: module.default
            };
        }));
    const $9d51fec62de0f8e9$var$wrapper = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            lineHeight: 1,
            outline: 'none',
            margin: 0,
            width: '100%',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
        });
    const $9d51fec62de0f8e9$var$optionWrapper = {
        name: "yyrqoa",
        styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
    };
    const $9d51fec62de0f8e9$var$getTextStyle = (isSecondary)=>{
        const secondaryCssArgs = isSecondary ? {
            fontSize: '0.85em'
        } : {};
        return (0, (0, parcelRequire("f8Sb3")).css)({
            margin: 0,
            overflowX: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...secondaryCssArgs
        });
    };
    const $9d51fec62de0f8e9$var$additionalInfo = {
        name: "tjo4qw",
        styles: "float:right"
    };
    const $9d51fec62de0f8e9$export$aa6223da92b253dd = (color)=>(0, (0, parcelRequire("f8Sb3")).css)({
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline',
            color: color
        });
    const $9d51fec62de0f8e9$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
        const renderLozenge = ()=>{
            if ((0, (0, parcelRequire("3smIt")).isLozengeText)(lozenge)) {
                if (lozenge?.tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                    fallback: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($9d51fec62de0f8e9$var$AsyncTooltip, {
                    content: lozenge.tooltip
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text)));
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), lozenge, lozenge.text);
            }
            return lozenge;
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $9d51fec62de0f8e9$var$wrapper(isDisabled)
        }, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$optionWrapper
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle()
        }, primaryText), secondaryText && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$getTextStyle(true)
        }, secondaryText))), lozenge && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9d51fec62de0f8e9$var$additionalInfo
        }, renderLozenge())));
    };
});
parcelRegister("1Y8bw", function(module, exports) {
    $parcel$export(module.exports, "HighlightText", ()=>$dbc13bb98bfc2c59$export$bb02e7bc6e1a7119);
    var $5uXOq = parcelRequire("5uXOq");
    class $dbc13bb98bfc2c59$export$bb02e7bc6e1a7119 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { children: children, highlights: highlights } = this.props;
            const parts = [];
            let lastIndex = 0;
            if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
                const lastHighlight = highlights[highlights.length - 1];
                if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
                if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
                return highlights;
            }, []).forEach((highlight)=>{
                const { start: start, end: end } = highlight;
                if (start >= end) return;
                if (start > lastIndex) parts.push({
                    value: children.substring(lastIndex, start),
                    matches: false
                });
                parts.push({
                    value: children.substring(start, end + 1),
                    matches: true
                });
                lastIndex = end + 1;
            });
            if (lastIndex < children.length) parts.push({
                value: children.substring(lastIndex, children.length),
                matches: false
            });
            return parts.map((part, index)=>{
                if (part.matches) return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: index
                }, part.value);
                return part.value;
            });
        }
    }
});
parcelRegister("IMPHa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$244ad38dc6a6e0e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $244ad38dc6a6e0e3$var$AsyncExternalUserOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("8ED06")).then((module)=>{
            return {
                default: module.ExternalUserOption
            };
        }));
    var $244ad38dc6a6e0e3$export$2e2bcd8739ae039 = $244ad38dc6a6e0e3$var$AsyncExternalUserOption;
});
parcelRegister("8ED06", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7GjMk")
    ]).then(()=>parcelRequire('358Ik'));
});
parcelRegister("8QliZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e55a6473b89765e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $6e55a6473b89765e$var$AsyncTeamOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("aepOh")).then((module)=>{
            return {
                default: module.TeamOption
            };
        }));
    var $6e55a6473b89765e$export$2e2bcd8739ae039 = $6e55a6473b89765e$var$AsyncTeamOption;
});
parcelRegister("aepOh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmRp3").then(()=>parcelRequire('8Pt0F'));
});
parcelRegister("jC9IK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d883d47691bcfd0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $d883d47691bcfd0f$var$AsyncGroupOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("i1qww")).then((module)=>{
            return {
                default: module.GroupOption
            };
        }));
    var $d883d47691bcfd0f$export$2e2bcd8739ae039 = $d883d47691bcfd0f$var$AsyncGroupOption;
});
parcelRegister("i1qww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("mdJEp").then(()=>parcelRequire('ctysX'));
});
parcelRegister("3SqqV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$120c09dc4c3dec5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $120c09dc4c3dec5f$var$AsyncEmailOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("bng6R")).then((module)=>{
            return {
                default: module.EmailOption
            };
        }));
    var $120c09dc4c3dec5f$export$2e2bcd8739ae039 = $120c09dc4c3dec5f$var$AsyncEmailOption;
});
parcelRegister("bng6R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("AE9nS").then(()=>parcelRequire('4CChz'));
});
parcelRegister("f4ndh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57cc7ffb924c0e65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $57cc7ffb924c0e65$var$AsyncCustomOption = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("3UNwy")).then((module)=>{
            return {
                default: module.CustomOption
            };
        }));
    var $57cc7ffb924c0e65$export$2e2bcd8739ae039 = $57cc7ffb924c0e65$var$AsyncCustomOption;
});
parcelRegister("3UNwy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQtwe").then(()=>parcelRequire('iphiD'));
});
parcelRegister("M0UM1", function(module, exports) {
    $parcel$export(module.exports, "isValidEmail", ()=>$8e40db00ccd032ac$export$371e338370561054);
    const $8e40db00ccd032ac$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    const $8e40db00ccd032ac$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
    const $8e40db00ccd032ac$export$371e338370561054 = (inputText)=>{
        if (inputText.match($8e40db00ccd032ac$var$validRegex)) return 'VALID';
        if (inputText.match($8e40db00ccd032ac$var$potentialRegex)) return 'POTENTIAL';
        return 'INVALID';
    };
});
parcelRegister("6Kkci", function(module, exports) {
    $parcel$export(module.exports, "SingleValue", ()=>$667e1159563155af$export$1949dac661ba6e3a);
    var $7sUFC;
    var $f8Sb3;
    var $bChGW;
    var $5pJx4;
    var $3smIt;
    var $fuhQD;
    var $VSDnB;
    var $f5TWP;
    const $667e1159563155af$var$avatarItemComponent = (0, (0, parcelRequire("f8Sb3")).css)({
        border: 'none !important',
        padding: `${"var(--ds-space-0, 0px)"} !important`,
        width: 'auto',
        overflow: 'hidden',
        minWidth: '100px',
        '& > span': {
            boxSizing: 'border-box'
        },
        '&:hover': {
            width: 'auto',
            padding: 0,
            border: 'none'
        }
    });
    const $667e1159563155af$var$ElementAfter = (props)=>{
        const { data: { data: data } } = props;
        if ((0, (0, parcelRequire("3smIt")).isTeam)(data) && data.verified) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fuhQD")).VerifiedTeamIcon), {
            size: "small"
        });
        return null;
    };
    const $667e1159563155af$export$1949dac661ba6e3a = (props)=>{
        const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
        return !isFocused ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).SingleValue, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7sUFC")).default), {
            backgroundColor: "transparent",
            avatar: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                src: (0, (0, parcelRequire("3smIt")).getAvatarUrl)(data),
                appearance: appearance,
                type: (0, (0, parcelRequire("3smIt")).isTeam)(data) && (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? 'team' : 'person'
            }),
            primaryText: (0, (0, parcelRequire("VSDnB")).fg)('verified-team-in-user-picker') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
                alignBlock: "center"
            }, label, (0, (0, parcelRequire("f8Sb3")).jsx)($667e1159563155af$var$ElementAfter, props)) : label
        }, ({ ref: ref, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $667e1159563155af$var$avatarItemComponent,
                ...props
            }))) : null;
    };
});
parcelRegister("7sUFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fee6a3655f9d2d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $cgL5K;
    var $k5uoT;
    var $vIiRg;
    var $kyyq3;
    function $0fee6a3655f9d2d5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0fee6a3655f9d2d5$var$avatarItemStyles = {
        name: "1dq1lfl",
        styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
    };
    const $0fee6a3655f9d2d5$var$secondaryTextOldStyles = {
        name: "1udad45",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
    };
    const $0fee6a3655f9d2d5$var$baseTextStyles = {
        name: "1sodx6b",
        styles: "display:block;color:var(--ds-text, #172B4D)"
    };
    const $0fee6a3655f9d2d5$var$truncationStyles = {
        name: "n3ut7m",
        styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
    };
    const $0fee6a3655f9d2d5$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px;
		border: ${0, (0, parcelRequire("vIiRg")).BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
    const $0fee6a3655f9d2d5$var$AvatarItem = (0, $5uXOq.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
        const getTestId = (testId, children)=>!children ? {
                'data-testid': `${testId}--itemInner`
            } : {
                testId: `${testId}--itemInner`
            };
        const componentProps = ()=>{
            if (isDisabled) return {
                disabled: true
            };
            return {
                ...href && (0, (0, parcelRequire("kyyq3")).getLinkProps)(href, target),
                ...onClick && !href ? (0, (0, parcelRequire("kyyq3")).getButtonProps)(onClick) : {
                    onClick: onClick
                }
            };
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>{
            const props = {
                ref: ref,
                className: $0fee6a3655f9d2d5$var$getStyles(css, {
                    backgroundColor: backgroundColor,
                    isInteractive: Boolean(onClick || href),
                    isDisabled: isDisabled
                }),
                ...componentProps(),
                ...testId && getTestId(testId, children),
                ...(onClick || href) && {
                    'aria-label': label
                },
                children: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, avatar, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $0fee6a3655f9d2d5$var$avatarItemStyles
                }, (0, (0, parcelRequire("VSDnB")).fg)('platform.design-system-team.avatar-item-font-size_830x6') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    maxLines: isTruncationDisabled ? undefined : 1
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                    color: "color.text.subtlest",
                    maxLines: isTruncationDisabled ? undefined : 1,
                    size: "UNSAFE_small"
                }, secondaryText)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, primaryText), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: [
                        $0fee6a3655f9d2d5$var$baseTextStyles,
                        $0fee6a3655f9d2d5$var$secondaryTextOldStyles,
                        !isTruncationDisabled && $0fee6a3655f9d2d5$var$truncationStyles
                    ]
                }, secondaryText))))
            };
            return children ? children(props) : (0, $5uXOq.createElement)((0, (0, parcelRequire("kyyq3")).getCustomElement)(isDisabled, href, onClick), props);
        });
    });
    $0fee6a3655f9d2d5$var$AvatarItem.displayName = 'AvatarItem';
    var $0fee6a3655f9d2d5$export$2e2bcd8739ae039 = $0fee6a3655f9d2d5$var$AvatarItem;
});
parcelRegister("OxpB4", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$98c53988263e2c5c$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    class $98c53988263e2c5c$export$f5b8910cec6cf069 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        get ariaLabelledBy() {
            return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
        }
        get ariaDescribedBy() {
            return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Input, {
                ...this.props,
                "aria-labelledby": this.ariaLabelledBy,
                "aria-describedby": this.ariaDescribedBy,
                innerRef: this.props.innerRef,
                onKeyPress: this.handleKeyPress
            });
        }
        constructor(...args){
            super(...args), this.handleKeyPress = (e)=>{
                if (e.key === 'Enter') e.preventDefault();
                if (this.props.selectProps?.disableInput) e.preventDefault();
            };
        }
    }
});
parcelRegister("ee8bl", function(module, exports) {
    $parcel$export(module.exports, "SingleValueContainer", ()=>$bd8914f05f01f9cc$export$afa5f855316c6a48);
    var $bChGW;
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    var $5pJx4;
    var $2wgOn;
    var $jNYXM;
    function $bd8914f05f01f9cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bd8914f05f01f9cc$var$placeholderIconContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: (0, (0, parcelRequire("2wgOn")).BORDER_PADDING),
        lineHeight: 0,
        gridArea: '1/1/2/2'
    });
    const $bd8914f05f01f9cc$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
    var $bd8914f05f01f9cc$var$_ref = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
    class $bd8914f05f01f9cc$export$afa5f855316c6a48 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { children: children, ...valueContainerProps } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jNYXM")).default), {
                isEnabled: this.onValueContainerClick,
                onMouseDown: this.onValueContainerClick
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).ValueContainer, valueContainerProps, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $bd8914f05f01f9cc$var$placeholderIconContainer
            }, this.renderAvatar()), children));
        }
        constructor(...args){
            super(...args), this.renderAvatar = ()=>{
                const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
                if (isFocused || !hasValue) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5pJx4")).SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: $bd8914f05f01f9cc$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
                });
                return null;
            }, this.onValueContainerClick = this.props.selectProps.onValueContainerClick, this.Wrapper = ({ children: children })=>{
                return this.onValueContainerClick ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: $bd8914f05f01f9cc$var$_ref,
                    onMouseDown: this.onValueContainerClick
                }, children) : children;
            };
        }
    }
});
parcelRegister("h3ej5", function(module, exports) {
    $parcel$export(module.exports, "PopupInput", ()=>$be92b88945d06137$export$d8edbfd510a7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $OxpB4;
    class $be92b88945d06137$export$d8edbfd510a7db82 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            if (this.ref) this.ref.select();
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("OxpB4")).Input), {
                ...this.props,
                innerRef: this.handleInnerRef
            });
        }
        constructor(...args){
            super(...args), this.ref = null, this.handleInnerRef = (ref)=>{
                this.ref = ref;
                if (this.props.innerRef) this.props.innerRef(ref);
            };
        }
    }
});
parcelRegister("6Ks8i", function(module, exports) {
    $parcel$export(module.exports, "PopupControl", ()=>$77b9c0d4ebdf44c2$export$a0cb1b4352357fcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $77b9c0d4ebdf44c2$var$spacing = 8;
    const $77b9c0d4ebdf44c2$var$fontSize = 12;
    const $77b9c0d4ebdf44c2$var$innerHeight = $77b9c0d4ebdf44c2$var$spacing * 2;
    const $77b9c0d4ebdf44c2$var$lineHeight = $77b9c0d4ebdf44c2$var$innerHeight / $77b9c0d4ebdf44c2$var$fontSize;
    const $77b9c0d4ebdf44c2$var$controlWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    });
    const $77b9c0d4ebdf44c2$var$getLabelStyle = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
            fontSize: `${$77b9c0d4ebdf44c2$var$fontSize}px`,
            fontWeight: 600,
            lineHeight: `${$77b9c0d4ebdf44c2$var$lineHeight}`,
            paddingBottom: "var(--ds-space-050, 4px)",
            paddingLeft: "var(--ds-space-0, 0px)",
            paddingRight: "var(--ds-space-0, 0px)",
            paddingTop: "var(--ds-space-250, 20px)"
        });
    class $77b9c0d4ebdf44c2$export$a0cb1b4352357fcc extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const { selectProps: { popupTitle: popupTitle } } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$controlWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $77b9c0d4ebdf44c2$var$getLabelStyle()
            }, popupTitle), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Control, this.props));
        }
    }
});
parcelRegister("lYehz", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$9f291598157d275c$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $f8Sb3;
    const $9f291598157d275c$var$getFooterStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
        });
    };
    class $9f291598157d275c$export$d9b273488cd8ce6f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $9f291598157d275c$var$getFooterStyle()
            }, this.props.selectProps.footer));
        }
    }
});
parcelRegister("fuG1P", function(module, exports) {
    $parcel$export(module.exports, "getCreatableProps", ()=>$3865687a924ab788$export$36f97d8afa97203d);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $3865687a924ab788$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $3865687a924ab788$var$isValidNewOption = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(inputValue)=>inputValue && $3865687a924ab788$var$validOption.includes(isValidEmail(inputValue));
    const $3865687a924ab788$var$getNewOptionData = (inputValue)=>({
            label: inputValue,
            value: inputValue,
            data: {
                id: inputValue,
                name: inputValue,
                type: (0, $f93312f7d4958f08$export$6662b3461398ef8c)
            }
        });
    const $3865687a924ab788$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $3865687a924ab788$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    function $3865687a924ab788$var$creatableProps(isValidEmail) {
        return {
            allowCreateWhileLoading: true,
            createOptionPosition: 'first',
            isValidNewOption: $3865687a924ab788$var$isValidNewOption(isValidEmail),
            getNewOptionData: $3865687a924ab788$var$getNewOptionData,
            formatCreateLabel: $3865687a924ab788$var$formatCreateLabel,
            isOptionDisabled: $3865687a924ab788$var$isOptionDisabled(isValidEmail)
        };
    }
    const $3865687a924ab788$export$36f97d8afa97203d = (0, (0, parcelRequire("8QpSo")).default)($3865687a924ab788$var$creatableProps);
});
parcelRegister("hcX3V", function(module, exports) {
    $parcel$export(module.exports, "getCreatableSuggestedEmailProps", ()=>$fd587de6edc26aae$export$34b9dd2dd6a225e5);
    var $8QpSo;
    var $M0UM1;
    var $3smIt;
    const $fd587de6edc26aae$var$validOption = [
        'VALID',
        'POTENTIAL'
    ];
    const $fd587de6edc26aae$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
    const $fd587de6edc26aae$var$getNewOptionData = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail), emailDomain)=>(inputValue)=>{
            if (!inputValue) return null;
            const isEmail = inputValue && $fd587de6edc26aae$var$validOption.includes(isValidEmail(inputValue));
            const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
            return {
                label: value,
                value: value,
                data: {
                    id: value,
                    name: value,
                    type: (0, $f93312f7d4958f08$export$6662b3461398ef8c),
                    suggestion: true
                }
            };
        };
    const $fd587de6edc26aae$var$formatCreateLabel = (inputText)=>{
        if (inputText) return inputText.trim();
        return '';
    };
    const $fd587de6edc26aae$var$isOptionDisabled = (isValidEmail = (0, (0, parcelRequire("M0UM1")).isValidEmail))=>(option)=>{
            if ((0, (0, parcelRequire("3smIt")).isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
            return !!option.isDisabled;
        };
    const $fd587de6edc26aae$export$34b9dd2dd6a225e5 = (0, (0, parcelRequire("8QpSo")).default)((emailDomain, isValidEmail)=>({
            allowCreateWhileLoading: true,
            createOptionPosition: 'last',
            isValidNewOption: $fd587de6edc26aae$var$isValidNewOption,
            getNewOptionData: $fd587de6edc26aae$var$getNewOptionData(isValidEmail, emailDomain),
            formatCreateLabel: $fd587de6edc26aae$var$formatCreateLabel,
            isOptionDisabled: $fd587de6edc26aae$var$isOptionDisabled(isValidEmail)
        }));
});
parcelRegister("hrO1B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ce4a8fbf6631c4e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $55C8M;
    const $9ce4a8fbf6631c4e$var$EMPTY = {};
    const $9ce4a8fbf6631c4e$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($9ce4a8fbf6631c4e$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($9ce4a8fbf6631c4e$var$EMPTY);
            (0, (0, parcelRequire("55C8M")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $9ce4a8fbf6631c4e$var$MessagesIntlProvider = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children } = props;
        const messages = $9ce4a8fbf6631c4e$var$useI18n(intl.locale);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...intl.messages,
                ...messages
            };
        }, [
            intl.messages,
            messages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
    };
    var $9ce4a8fbf6631c4e$export$2e2bcd8739ae039 = $9ce4a8fbf6631c4e$var$MessagesIntlProvider;
});
parcelRegister("55C8M", function(module, exports) {
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$0d1c237fd5360db1$export$d0a3169680473b6c);
    const $0d1c237fd5360db1$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("asouP")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("gCFP1")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("ctXnR")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("5wasS")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("kXvsh")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("8wFHw")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("42RiL")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("01V88")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("7OhhH")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("ekPaa")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("cgaOk")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("4Ijhe")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("iO6Ar")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("DNotf")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("h1BPr")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("32FdM")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("6anuW")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("coeB4")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("4OfGz")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("7jMxK")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("8oKS4")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("lRSYN")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("lfcui")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("kC3tY")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("jRqJp")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("hXOFb")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("5mdNh")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("cj5fC")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("kZyWC")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $0d1c237fd5360db1$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("dVeZ7")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("asouP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5lpPT").then(()=>parcelRequire('gXZJY'));
});
parcelRegister("gCFP1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kfO0l").then(()=>parcelRequire('4a4Fm'));
});
parcelRegister("ctXnR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e7FWi").then(()=>parcelRequire('l8jlf'));
});
parcelRegister("dVeZ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("auLKS").then(()=>parcelRequire('8JpVG'));
});
parcelRegister("5wasS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3W1ZK").then(()=>parcelRequire('e3biM'));
});
parcelRegister("kXvsh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Tlspk").then(()=>parcelRequire('dnuc7'));
});
parcelRegister("8wFHw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5X8ey").then(()=>parcelRequire('l3vqz'));
});
parcelRegister("42RiL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bmWXN").then(()=>parcelRequire('4oZES'));
});
parcelRegister("01V88", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bI4uf").then(()=>parcelRequire('2WBzr'));
});
parcelRegister("7OhhH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2H83s").then(()=>parcelRequire('bfZBm'));
});
parcelRegister("ekPaa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lUuxE").then(()=>parcelRequire('1tcJ6'));
});
parcelRegister("cgaOk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eN4os").then(()=>parcelRequire('4duqz'));
});
parcelRegister("4Ijhe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gvuTb").then(()=>parcelRequire('dizwu'));
});
parcelRegister("iO6Ar", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Li3C").then(()=>parcelRequire('9N5CX'));
});
parcelRegister("DNotf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bh153").then(()=>parcelRequire('aZBlm'));
});
parcelRegister("h1BPr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gdZbx").then(()=>parcelRequire('fGwOM'));
});
parcelRegister("32FdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aMnvr").then(()=>parcelRequire('NLRKB'));
});
parcelRegister("6anuW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b7E7V").then(()=>parcelRequire('cHWkp'));
});
parcelRegister("coeB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCfU6").then(()=>parcelRequire('d6RJ6'));
});
parcelRegister("4OfGz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5b76P").then(()=>parcelRequire('bPIQC'));
});
parcelRegister("7jMxK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Qca8").then(()=>parcelRequire('foWaf'));
});
parcelRegister("8oKS4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8ExDS").then(()=>parcelRequire('d41ym'));
});
parcelRegister("lRSYN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("57IRb").then(()=>parcelRequire('77rKe'));
});
parcelRegister("lfcui", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6iyhv").then(()=>parcelRequire('lwY85'));
});
parcelRegister("kC3tY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6FMDk").then(()=>parcelRequire('j3ZnO'));
});
parcelRegister("jRqJp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6583j").then(()=>parcelRequire('I9Pmk'));
});
parcelRegister("hXOFb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hdz1o").then(()=>parcelRequire('h4y14'));
});
parcelRegister("5mdNh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jefTP").then(()=>parcelRequire('6gWmN'));
});
parcelRegister("cj5fC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j2uQo").then(()=>parcelRequire('haTkv'));
});
parcelRegister("kZyWC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("afbbf").then(()=>parcelRequire('lbgbB'));
});
parcelRegister("2vFqP", function(module, exports) {
    $parcel$export(module.exports, "ExusUserSourceProvider", ()=>$4629e0617f660bbc$export$bcd5c65b586ee3c3);
    $parcel$export(module.exports, "useUserSource", ()=>$4629e0617f660bbc$export$c6c0c1a2bac363f);
    var $5uXOq = parcelRequire("5uXOq");
    const $4629e0617f660bbc$var$ExusUserSourceContext = (0, $5uXOq.createContext)({});
    const $4629e0617f660bbc$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4629e0617f660bbc$var$ExusUserSourceContext.Provider, {
            value: {
                fetchUserSource: fetchUserSource
            }
        }, children);
    const $4629e0617f660bbc$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
        const { fetchUserSource: fetchUserSource } = (0, $5uXOq.useContext)($4629e0617f660bbc$var$ExusUserSourceContext);
        const [externalSources, setExternalSources] = (0, $5uXOq.useState)([]);
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const abortController = (0, $5uXOq.useMemo)(()=>{
            if (typeof AbortController === 'undefined') return;
            return new AbortController();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources.map((source)=>source.sourceType);
                setExternalSources(externalSourceTypes);
            }).catch((error)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error);
            });
            return cleanup;
        }, [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                sources: Array.from(new Set([
                    ...existingSources ?? [],
                    ...externalSources
                ])),
                loading: loading,
                error: error
            }), [
            error,
            existingSources,
            externalSources,
            loading
        ]);
    };
});
parcelRegister("h36wX", function(module, exports) {
    $parcel$export(module.exports, "useAssigneeOptions", ()=>$92b31ca8d85d4433$export$1eb7ccf9fc55d2e8);
    var $3OKtJ;
    var $8zOmE;
    var $2NMNM;
    var $itmJb;
    var $leRCk;
    var $fhSLy;
    var $7lGt2;
    const $92b31ca8d85d4433$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
        if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
        const action = 'rendered';
        const actionSubject = 'inviteItem';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            fieldId: 'assignee',
            userRole: isAdmin ? 'admin' : 'basic',
            suggestionsCount: suggestionsCount,
            source: 'assigneeField',
            ...isInviteAndAssignFromBoard && {
                isInviteAndAssignFromBoard: true
            }
        };
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const $92b31ca8d85d4433$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign)=>{
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const unassigned = (0, (0, parcelRequire("fhSLy")).getUnassignedUser)(intl);
        const automaticOption = (0, (0, parcelRequire("fhSLy")).getAutomaticUserOption)(intl);
        const valueOption = (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(value || unassigned);
        const [{ data: loggedInUser }] = (0, (0, parcelRequire("leRCk")).useUserSubscriber)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const loggedInUserOption = loggedInUser ? {
            ...(0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(loggedInUser),
            publicName: intl.formatMessage((0, (0, parcelRequire("7lGt2")).default).assignToMe)
        } : null;
        const isInvalidSearch = search === undefined || search === '';
        const showUnassigned = isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase());
        let showAutomaticOption = false;
        if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
        const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
        const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
        const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
        const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
        const userOptions = users.filter((user)=>(!isInvalidSearch || user.accountId !== valueOption.id) && !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, (0, parcelRequire("fhSLy")).getUserOptionFromUser));
        const invitePeopleOptions = [];
        if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
            if (isEligibleForInviteAndAssign) {
                invitePeopleOptions.push((0, (0, parcelRequire("3OKtJ")).getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
                $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
            } else {
                $92b31ca8d85d4433$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
                invitePeopleOptions.push((0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)((0, (0, parcelRequire("fhSLy")).getInvitePeopleOption)(intl, isAdmin)));
            }
        }
        const options = [
            ...showUnassigned ? [
                (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(unassigned)
            ] : [],
            ...showAutomaticOption ? [
                (0, (0, parcelRequire("fhSLy")).getUserOptionFromUser)(automaticOption)
            ] : [],
            ...showAssignToMe && loggedInUserOption !== null ? [
                loggedInUserOption
            ] : [],
            ...userOptions,
            ...invitePeopleOptions
        ];
        return [
            valueOption,
            options
        ];
    };
});
parcelRegister("3OKtJ", function(module, exports) {
    $parcel$export(module.exports, "isValidEmailAddress", ()=>$d369cb9a3149539e$export$866f45a7554d0870);
    $parcel$export(module.exports, "getInviteAndAssignPeopleOption", ()=>$d369cb9a3149539e$export$34e0d98131b0b98a);
    var $M0UM1;
    var $ivhIb = parcelRequire("ivhIb");
    var $eXneb;
    const $d369cb9a3149539e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
        const isEmail = inputValue && [
            (0, $a56e5eac5897104f$export$18d36911c7f94286),
            (0, $a56e5eac5897104f$export$da1c529049028734)
        ].includes((0, (0, parcelRequire("M0UM1")).isValidEmail)(inputValue));
        const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
        return value;
    };
    const $d369cb9a3149539e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, (0, parcelRequire("M0UM1")).isValidEmail)(inputValue) === (0, $a56e5eac5897104f$export$18d36911c7f94286);
    const $d369cb9a3149539e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
        const possibleEmail = $d369cb9a3149539e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
        return {
            id: (0, $a56e5eac5897104f$export$898547b9297d1a3a),
            name: possibleEmail,
            avatarUrl: (0, ($parcel$interopDefault($ivhIb))),
            byline: formatMessage((0, (0, parcelRequire("eXneb")).default).inviteAndAssign),
            isDisabled: (0, (0, parcelRequire("M0UM1")).isValidEmail)(possibleEmail) !== 'VALID'
        };
    };
});
parcelRegister("ivhIb", function(module, exports) {
    module.exports = new URL("email.very-specific-illu.43fa850c.png", import.meta.url).toString();
});
const $a56e5eac5897104f$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $a56e5eac5897104f$export$18d36911c7f94286 = 'VALID';
const $a56e5eac5897104f$export$da1c529049028734 = 'POTENTIAL';
parcelRegister("eXneb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31de51ead46cb5cc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31de51ead46cb5cc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteAndAssign: {
            "id": "invite-and-assign.common.invite-and-assign",
            "defaultMessage": "Invite and assign"
        }
    });
});
parcelRegister("kt8K4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$564a5b059c2a0fff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $7f4tk;
    const $564a5b059c2a0fff$var$useUsersQuery = (autoCompleteUrl)=>{
        const [users, setUsers] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const currentQuery = (0, $5uXOq.useRef)('');
        const fetchUsers = (0, $5uXOq.useCallback)((query = '')=>{
            if ([
                '',
                null,
                undefined
            ].includes(autoCompleteUrl)) return Promise.resolve([]);
            const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
            setLoading(true);
            currentQuery.current = query;
            if (error) setError(undefined);
            return (0, (0, parcelRequire("7f4tk")).default)(usersFetchUrl).then((response)=>{
                if (query === currentQuery.current) setUsers(response);
            }).catch((err)=>{
                if (query === currentQuery.current) setError(err);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
            }).finally(()=>setLoading(false));
        }, [
            autoCompleteUrl,
            error
        ]);
        return [
            {
                data: users,
                error: error,
                loading: loading
            },
            fetchUsers
        ];
    };
    var $564a5b059c2a0fff$export$2e2bcd8739ae039 = $564a5b059c2a0fff$var$useUsersQuery;
});
parcelRegister("jGVMX", function(module, exports) {
    $parcel$export(module.exports, "validateString", ()=>$e5b3b607ab8affce$export$d7b0a588f685ba7e);
    $parcel$export(module.exports, "validateSelectField", ()=>$e5b3b607ab8affce$export$53ded7ceec493f10);
    $parcel$export(module.exports, "validateCascadingSelectField", ()=>$e5b3b607ab8affce$export$837294b8fc732f20);
    $parcel$export(module.exports, "validateAssigneeField", ()=>$e5b3b607ab8affce$export$dd17aabe3f77b2ba);
    $parcel$export(module.exports, "validateUserPickerField", ()=>$e5b3b607ab8affce$export$356346770aab95cb);
    $parcel$export(module.exports, "validateCheckboxField", ()=>$e5b3b607ab8affce$export$7aa5e0976d0c384b);
    $parcel$export(module.exports, "validateComponentField", ()=>$e5b3b607ab8affce$export$89943b0814df306d);
    $parcel$export(module.exports, "validateCustomTeamsField", ()=>$e5b3b607ab8affce$export$364ea91bee38a994);
    $parcel$export(module.exports, "validateGroupPickerField", ()=>$e5b3b607ab8affce$export$c6d4785f3f46f73a);
    $parcel$export(module.exports, "validateMultiVersionsField", ()=>$e5b3b607ab8affce$export$727e23f536334715);
    $parcel$export(module.exports, "validateOrganizationsField", ()=>$e5b3b607ab8affce$export$b97bb8e170430af8);
    $parcel$export(module.exports, "validatePriorityField", ()=>$e5b3b607ab8affce$export$17fd881b060187f7);
    $parcel$export(module.exports, "validateRadioSelectField", ()=>$e5b3b607ab8affce$export$f69029476f9179b);
    $parcel$export(module.exports, "validateRadioGroupField", ()=>$e5b3b607ab8affce$export$d60dcaa093bca71d);
    $parcel$export(module.exports, "validateResolutionField", ()=>$e5b3b607ab8affce$export$316feff8e636f81f);
    $parcel$export(module.exports, "validateSingleVersionField", ()=>$e5b3b607ab8affce$export$45f7908dc93110fb);
    $parcel$export(module.exports, "validateLabelField", ()=>$e5b3b607ab8affce$export$1a8caa895b9fda26);
    $parcel$export(module.exports, "validateForgeLabelField", ()=>$e5b3b607ab8affce$export$bf4287ae453e2aab);
    var $bGrWH;
    const $e5b3b607ab8affce$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
        if (isRequired && !value?.trim?.()) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        if (typeof value === 'string' && type === 'text' && value?.length > (0, $d46ffa3990e23a4d$export$fe1a70381f6491b5)) return 0, $d46ffa3990e23a4d$export$618e922e89e8bcae;
        return undefined;
    };
    const $e5b3b607ab8affce$export$53ded7ceec493f10 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$837294b8fc732f20 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$dd17aabe3f77b2ba = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$356346770aab95cb = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$7aa5e0976d0c384b = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$89943b0814df306d = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$364ea91bee38a994 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$c6d4785f3f46f73a = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(value) && !value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$727e23f536334715 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (!value.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$b97bb8e170430af8 = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(data) && !data.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$17fd881b060187f7 = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$f69029476f9179b = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$d60dcaa093bca71d = (data, isRequired)=>{
        if (isRequired && !data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        return undefined;
    };
    const $e5b3b607ab8affce$export$316feff8e636f81f = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$45f7908dc93110fb = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $e5b3b607ab8affce$export$1a8caa895b9fda26 = (labels, isRequired)=>{
        if (isRequired) {
            if (!labels) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(labels) && !labels.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
        if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.includes(' ') || value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$e77d629cc732976d;
        return undefined;
    };
    const $e5b3b607ab8affce$export$bf4287ae453e2aab = (labels, isRequired)=>{
        if (isRequired) {
            if (!labels) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (Array.isArray(labels) && !labels.length) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        if (labels && labels?.length > (0, $d46ffa3990e23a4d$export$1fdf850c93de8bae)) return 0, $d46ffa3990e23a4d$export$fd7dfa1695d325ca;
        if (labels && labels.map((label)=>label?.value?.trim?.()).some((value)=>value.length > (0, $d46ffa3990e23a4d$export$9151073f92820ff8))) return 0, $d46ffa3990e23a4d$export$8d30d41a8828e14f;
        return undefined;
    };
});
parcelRegister("bfnma", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dd95939e2e05e754$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dd95939e2e05e754$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        assignToMe: {
            "id": "issue-create-commons.assignee-field.assign-to-me",
            "defaultMessage": "Assign to me"
        }
    });
});
parcelRegister("5rYSU", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultAssigneeValue", ()=>$b31c169a5b4e6cfd$export$f5415de9103f1c69);
    $parcel$export(module.exports, "mapUserToAssigneeValue", ()=>$b31c169a5b4e6cfd$export$c4dfa893fba82437);
    $parcel$export(module.exports, "mutateAssigneeUserPicker", ()=>$b31c169a5b4e6cfd$export$a6706b2f4762043b);
    const $b31c169a5b4e6cfd$export$f5415de9103f1c69 = (value)=>({
            accountId: (value.accountId === '-1' ? (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027) : value.accountId) || '',
            displayName: value.name || '',
            avatarUrls: value.picture !== undefined ? {
                '16x16': value.picture,
                '24x24': value.picture,
                '32x32': value.picture,
                '48x48': value.picture
            } : {}
        });
    const $b31c169a5b4e6cfd$export$c4dfa893fba82437 = (value)=>{
        if (value === null) return null;
        if (value.accountId === (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027)) return undefined;
        return {
            id: value.accountId
        };
    };
    const $b31c169a5b4e6cfd$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
        if (selectedUser === null || selectedUser.accountId === null) return null;
        return {
            fieldId: fieldId,
            mutationGroup: (0, $2b6d45687558f2b0$export$6684456d545bf498),
            user: {
                accountId: selectedUser.accountId
            }
        };
    };
});
parcelRegister("4kXb0", function(module, exports) {
    $parcel$export(module.exports, "AtlassianTeamsField", ()=>$2d376b3496c34d29$export$96c8ee98de63ec5b);
    $parcel$export(module.exports, "default", ()=>$2d376b3496c34d29$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $heNNl;
    var $8vFwj;
    var $4ajjx;
    var $lfTZh;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $icXkU;
    const $2d376b3496c34d29$var$overrideSelectStyles = {
        control: (base)=>({
                ...base,
                padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
            })
    };
    const $2d376b3496c34d29$var$stopFormPropagation = (e)=>{
        e.stopPropagation();
        e.preventDefault();
    };
    const $2d376b3496c34d29$export$96c8ee98de63ec5b = (props)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const siteId = tenantContext.cloudId;
        const [hackIsEditable, setHackIsEditable] = (0, $5uXOq.useState)(true);
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
        const onCreate = (0, $5uXOq.useCallback)((team)=>{
            if (team && team?.id !== value?.id) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                    memberCount: team.memberCount
                });
                setHackIsEditable(false);
                setTimeout(()=>{
                    onChange(team);
                    setHackIsEditable(true);
                }, 1000);
            }
        }, [
            createAnalyticsEvent,
            onChange,
            value?.id
        ]);
        const [createTeamDialog, createTeamDialogTrigger] = (0, (0, parcelRequire("8vFwj")).useCreateTeamDialog)({
            onCreate: onCreate
        });
        const getTeamEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-picker-edit",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ajjx")).AsyncTeamPickerEdit), {
                ...fieldProps,
                width: width,
                siteId: siteId,
                autoFocus: autoFocus,
                defaultValue: value,
                onChange: onChange,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isDisabled: isEditable === false || !hackIsEditable,
                styles: $2d376b3496c34d29$var$overrideSelectStyles,
                createTeamDialogTrigger: createTeamDialogTrigger
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, getTeamEdit()) : getTeamEdit(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "create-issue-field-team-create-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            name: "gic-create-team-dialog-form",
            onSubmit: $2d376b3496c34d29$var$stopFormPropagation
        }, createTeamDialog)));
    };
    var $2d376b3496c34d29$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("icXkU")).validateAtlassianTeamsField),
        transformDefaultValue: (0, (0, parcelRequire("icXkU")).transformDefaultAtlassianTeam)
    })($2d376b3496c34d29$export$96c8ee98de63ec5b);
});
parcelRegister("8vFwj", function(module, exports) {
    $parcel$export(module.exports, "useCreateTeamDialog", ()=>$e708dcb0d93e7fe3$export$e8b8170429d616be);
    var $5uXOq = parcelRequire("5uXOq");
    var $euiLX;
    var $pa9q9;
    var $1wpPp;
    var $4ywcn;
    var $8igKv;
    var $koVbs;
    var $lfTZh;
    var $cYlk7;
    var $14XJw;
    var $9OXo1;
    var $0Wtmq;
    var $kxZPA;
    const $e708dcb0d93e7fe3$export$75096afde50756fd = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("2FQLi")).then((module)=>module.TeamCreateDialog), {
        moduleId: "../platform/packages/people-and-teams/people-teams/src/index.ts"
    });
    const $e708dcb0d93e7fe3$export$e8b8170429d616be = (props = {})=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [inputTeamName, setInputTeamName] = (0, $5uXOq.useState)('');
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
        const addFlag = (0, $5uXOq.useCallback)(({ appearance: appearance, ...flagProps })=>{
            if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ywcn")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'warning') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8igKv")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
            if (appearance === 'error') showFlag((serviceProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wpPp")).default), {
                    messageType: "transactional",
                    ...flagProps,
                    ...serviceProps
                }));
        }, [
            showFlag
        ]);
        const { onCancel: onCancel } = {
            onCancel: ()=>null,
            ...props
        };
        const callback = (0, $5uXOq.useCallback)((teamName)=>{
            setInputTeamName(teamName);
            setIsOpen(true);
        }, []);
        const handleOnClose = ()=>{
            setIsOpen(false);
            onCancel();
        };
        const handleOnCreate = (team)=>{
            const formattedTeam = {
                ...team,
                name: team.displayName
            };
            props.onCreate?.(formattedTeam);
        };
        return [
            isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "team-create-dialog"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("0Wtmq")).PeopleAndTeamsConfigurationProvider), {
                product: "jira",
                locale: (0, (0, parcelRequire("euiLX")).default)(locale)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($e708dcb0d93e7fe3$export$75096afde50756fd, {
                cloudId: cloudId,
                orgId: orgId,
                product: "jira",
                principalId: atlassianAccountId || user.accountId || '',
                onClose: handleOnClose,
                onCreateTeamSuccess: handleOnCreate,
                extraAnalyticsAttrs: props.analyticsCtx,
                enableMembershipSettingsChoice: true,
                currentUser: user.accountId ? {
                    id: user.accountId,
                    fullName: user.userFullname,
                    avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                    ...user
                } : undefined,
                prepopulatedFields: {
                    teamName: inputTeamName
                },
                addFlag: addFlag
            }))) : null,
            callback
        ];
    };
});
parcelRegister("1wpPp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ebed3b5115fbfc5$export$2e2bcd8739ae039);
    var $3KRpp;
    var $2ebed3b5115fbfc5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).ErrorFlag);
});
parcelRegister("3KRpp", function(module, exports) {
    $parcel$export(module.exports, "CommonFlag", ()=>$ef767762d5402ccf$export$13d73238a031436b);
    $parcel$export(module.exports, "ErrorFlag", ()=>$ef767762d5402ccf$export$518ba8e0e60f145f);
    $parcel$export(module.exports, "ErrorAutoDismissFlag", ()=>$ef767762d5402ccf$export$3f75672bb90a4431);
    $parcel$export(module.exports, "InfoFlag", ()=>$ef767762d5402ccf$export$6a55b52e74c1e48e);
    $parcel$export(module.exports, "SuccessAutoDismissFlag", ()=>$ef767762d5402ccf$export$74a3c0748aa31355);
    $parcel$export(module.exports, "SuccessFlag", ()=>$ef767762d5402ccf$export$93bd4963a1d00fd5);
    $parcel$export(module.exports, "WarningFlag", ()=>$ef767762d5402ccf$export$23695d8281998f27);
    $parcel$export(module.exports, "FlagGroup", ()=>$ef767762d5402ccf$export$a2c3479950310d7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $kxZPA;
    const $ef767762d5402ccf$var$ForPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintJiraCommonFlag = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("lKKug")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$CommonFlagImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintJiraCommonFlag, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintJiraCommonFlag, props);
    const $ef767762d5402ccf$var$ForPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyForPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$AfterPaintFlagGroup = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("fhw5b")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
    });
    const $ef767762d5402ccf$var$FlagGroupImpl = (props)=>__SPA__ ? (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$AfterPaintFlagGroup, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$ForPaintFlagGroup, props);
    const $ef767762d5402ccf$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, props));
    const $ef767762d5402ccf$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            ...props
        }));
    const $ef767762d5402ccf$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "error",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "info",
            ...props
        }));
    const $ef767762d5402ccf$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            isAutoDismiss: true,
            ...props
        }));
    const $ef767762d5402ccf$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "success",
            ...props
        }));
    const $ef767762d5402ccf$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$CommonFlagImpl, {
            flagType: "warning",
            ...props
        }));
    const $ef767762d5402ccf$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ef767762d5402ccf$var$FlagGroupImpl, props));
});
parcelRegister("lKKug", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4yB9l")
    ]).then(()=>parcelRequire('8ZHDV'));
});
parcelRegister("fhw5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("Fkef4").then(()=>parcelRequire('5pz6a'));
});
parcelRegister("4ywcn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a612b92e24f3853$export$2e2bcd8739ae039);
    var $3KRpp;
    var $1a612b92e24f3853$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).SuccessFlag);
});
parcelRegister("8igKv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87b804070d792a00$export$2e2bcd8739ae039);
    var $3KRpp;
    var $87b804070d792a00$export$2e2bcd8739ae039 = (0, (0, parcelRequire("3KRpp")).WarningFlag);
});
parcelRegister("2FQLi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gPU4t")
    ]).then(()=>parcelRequire('75dcc'));
});
parcelRegister("4ajjx", function(module, exports) {
    $parcel$export(module.exports, "AsyncTeamPickerEdit", ()=>$81014c0bebd525f2$export$7db2ade8dff2be91);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $kxZPA;
    var $9n6Ty;
    const $81014c0bebd525f2$var$EMPTY_OBJECT = {};
    const $81014c0bebd525f2$export$eaed616868423e8a = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("eWvkp")), {
        moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
    });
    const $81014c0bebd525f2$export$7db2ade8dff2be91 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("9n6Ty")).asyncTeamPickerEditEntryPoint), $81014c0bebd525f2$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-atlassian-team-picker-edit",
            packageName: "jira-issue-field-team",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("9n6Ty", function(module, exports) {
    $parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", ()=>$306b3712a4b90308$export$80ec8c2b96e9988);
    var $eufEc;
    var $fEDBv;
    const $306b3712a4b90308$export$80ec8c2b96e9988 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("eWvkp")).then((module)=>module.TeamPickerEditEntryPointContent), {
            moduleId: "ce0fa7b5"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("eWvkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eEi3r").then(()=>parcelRequire('hgQ4J'));
});
parcelRegister("bGEod", function(module, exports) {
    $parcel$export(module.exports, "FieldLoader", ()=>$6a1003bb52c05df4$export$dbd27b551621740c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    const $6a1003bb52c05df4$export$dbd27b551621740c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "350px",
            height: "40px"
        });
});
parcelRegister("icXkU", function(module, exports) {
    $parcel$export(module.exports, "mutateAtlassianTeamField", ()=>$9b9cb321960b72df$export$c8b8a48d1ff67754);
    $parcel$export(module.exports, "transformDefaultAtlassianTeam", ()=>$9b9cb321960b72df$export$3fee94ad0b9e180c);
    $parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", ()=>$9b9cb321960b72df$export$450002773f9da0a4);
    $parcel$export(module.exports, "validateAtlassianTeamsField", ()=>$9b9cb321960b72df$export$8222f94513c7d2e6);
    var $bGrWH;
    const $9b9cb321960b72df$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
            fieldId: fieldId,
            mutationGroup: (0, $9f942793bea6ba7a$export$31fd86f8f183952c),
            team: {
                teamId: selectedTeam.id
            }
        } : null;
    const $9b9cb321960b72df$export$3fee94ad0b9e180c = (team)=>({
            name: team.name,
            id: team.teamId,
            avatarUrl: team?.avatar?.small
        });
    const $9b9cb321960b72df$export$450002773f9da0a4 = (team)=>{
        if (team && team.id) return team.id;
        return null;
    };
    const $9b9cb321960b72df$export$8222f94513c7d2e6 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
const $9f942793bea6ba7a$export$31fd86f8f183952c = 'atlassianTeamFields';
parcelRegister("bWtQ8", function(module, exports) {
    $parcel$export(module.exports, "getFileIdsFromFiles", ()=>$7bad3ba374b5e258$export$90bf402b5b4274c7);
    $parcel$export(module.exports, "validateAttachment", ()=>$7bad3ba374b5e258$export$8af997fabc69757a);
    $parcel$export(module.exports, "getFieldDropZoneContainerID", ()=>$7bad3ba374b5e258$export$2fab292eea84487a);
    var $bGrWH;
    const $7bad3ba374b5e258$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
    const $7bad3ba374b5e258$export$8af997fabc69757a = (value, isRequired)=>{
        if (isRequired) {
            if (!value || value.length === 0) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $7bad3ba374b5e258$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;
});
parcelRegister("gbo8w", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$094c2ce3abc8686f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $4zFcG;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $j0pqC;
    const $094c2ce3abc8686f$var$CascadingSelectField = (props)=>{
        const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
        const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, (0, parcelRequire("4R6GH")).fg)('uim-cascading-select-field-support-gic_h1cda') ? (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("j0pqC")).transformToCascadingSelectOptions)(cascadingSelectOptions), [
            cascadingSelectOptions
        ]) : (0, (0, parcelRequire("j0pqC")).transformToCascadingSelectOptions)(cascadingSelectOptions);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4zFcG")).AsyncCascadingSelectEdit), {
            ...fieldProps,
            value: value,
            allowedValues: allowedValues,
            allowedChildValues: allowedChildValues,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onChange: onChange,
            isInvalid: false,
            autoFocus: autoFocus,
            areOptionsOnSameRow: false,
            isEditable: (0, (0, parcelRequire("4R6GH")).fg)('uim-cascading-select-field-support-gic_h1cda') ? !isReadOnly && isEditable : isEditable
        }));
    };
    var $094c2ce3abc8686f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCascadingSelectField),
        transformDefaultValue: (0, parcelRequire("j0pqC")).transformDefaultValue
    })($094c2ce3abc8686f$var$CascadingSelectField);
});
parcelRegister("4zFcG", function(module, exports) {
    $parcel$export(module.exports, "AsyncCascadingSelectEdit", ()=>$0a411cf33e78ceb6$export$7db21897d0716698);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $kmnNN;
    const $0a411cf33e78ceb6$var$EMPTY_OBJECT = {};
    const $0a411cf33e78ceb6$export$7db21897d0716698 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kmnNN")).asyncCascadingSelectEditEntryPoint), $0a411cf33e78ceb6$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-field-cascading-select-edit",
            packageName: "jira-issue-field-cascading-select",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("kmnNN", function(module, exports) {
    $parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", ()=>$8f41019f840ae33a$export$336a3a4bd9539e41);
    var $eufEc;
    var $fEDBv;
    const $8f41019f840ae33a$export$336a3a4bd9539e41 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("4cejO")).then((module)=>module.CascadingSelectViewEntryPointContent), {
            moduleId: "dba9fb26"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("4cejO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bhpAB").then(()=>parcelRequire('aKsI4'));
});
parcelRegister("j0pqC", function(module, exports) {
    $parcel$export(module.exports, "transformToCascadingSelectOptions", ()=>$c7fead76ffb795b3$export$b06e6053830d7554);
    $parcel$export(module.exports, "transformDefaultValue", ()=>$c7fead76ffb795b3$export$e2f4e5d31db527cc);
    $parcel$export(module.exports, "mutateCascadingSelectField", ()=>$c7fead76ffb795b3$export$f402e35d933d11b5);
    const $c7fead76ffb795b3$export$facac75482a8e0c5 = (option)=>{
        const { value: value, id: id } = option || {};
        if (value && id) return {
            label: value,
            value: id
        };
        return null;
    };
    const $c7fead76ffb795b3$export$b06e6053830d7554 = (cascadingSelectData)=>{
        const allowedValues = [];
        const allowedChildValues = {};
        cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
            const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
            if (parentOptionValue !== null && transformedParentOption !== null) {
                allowedValues.push(transformedParentOption);
                allowedChildValues[parentOptionValue.id] = childOptionValues.map($c7fead76ffb795b3$export$facac75482a8e0c5);
            }
        });
        return {
            allowedValues: allowedValues,
            allowedChildValues: allowedChildValues
        };
    };
    const $c7fead76ffb795b3$export$e2f4e5d31db527cc = (defaultValue)=>{
        const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
        const transformedParentOption = $c7fead76ffb795b3$export$facac75482a8e0c5(parentOptionValue);
        let transformedDefaultValue = null;
        if (transformedParentOption !== null) transformedDefaultValue = {
            ...transformedParentOption,
            child: childOptionValue ? $c7fead76ffb795b3$export$facac75482a8e0c5(childOptionValue) : undefined
        };
        return transformedDefaultValue;
    };
    const $c7fead76ffb795b3$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
            fieldId: fieldId,
            parentOptionValue: {
                optionId: selectedOption.value
            },
            childOptionValue: selectedOption.child ? {
                optionId: selectedOption.child.value
            } : null,
            mutationGroup: (0, $4a7dfdb992f68644$export$31fd86f8f183952c)
        });
});
const $4a7dfdb992f68644$export$31fd86f8f183952c = 'cascadingSelectFields';
parcelRegister("hy8Vj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1139f036196a3fdd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6M0Pn;
    var $exGcw;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    const $1139f036196a3fdd$var$CheckboxField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, error: error, allowedValues: allowedValues, fieldId: fieldId, isReadOnly: isReadOnly = false } = props;
        const options = (0, (0, parcelRequire("exGcw")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6M0Pn")).default), {
            options: options,
            values: value,
            onChange: onChange,
            isInvalid: Boolean(error),
            isDisabled: isReadOnly,
            fieldId: fieldId
        }));
    };
    var $1139f036196a3fdd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCheckboxField),
        transformDefaultValue: (0, (0, parcelRequire("exGcw")).mapDataToOptions)
    })($1139f036196a3fdd$var$CheckboxField);
});
parcelRegister("6M0Pn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a9602fd0261806d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $hp1g9;
    var $exGcw;
    const $6a9602fd0261806d$var$CheckboxGroupEdit = (props)=>{
        const { values: values, options: options, isDisabled: isDisabled = false, onChange: onChange, isInvalid: isInvalid, fieldId: fieldId } = props;
        const onChangeCheckedItems = (event)=>{
            const itemValue = event.target.value;
            const retainValue = (0, (0, parcelRequire("exGcw")).setRetainValue)({
                options: options,
                itemValue: itemValue,
                values: values
            });
            onChange(retainValue);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, options?.map((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hp1g9")).default), {
                name: fieldId,
                key: option.value
            }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
                    ...fieldProps,
                    key: option.value,
                    value: option.value,
                    label: option.label,
                    isChecked: values?.some((data)=>data.value === option.value),
                    onChange: onChangeCheckedItems,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled
                }))));
    };
    var $6a9602fd0261806d$export$2e2bcd8739ae039 = $6a9602fd0261806d$var$CheckboxGroupEdit;
});
parcelRegister("kkJfY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3106eb14f9b0a593$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $5JjdN;
    var $kag1C;
    var $7xteU;
    var $hsLv2;
    var $e62YQ;
    const $3106eb14f9b0a593$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $3106eb14f9b0a593$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("5JjdN")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7xteU")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $3106eb14f9b0a593$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kag1C")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hsLv2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e62YQ")).default), null)));
    }));
    $3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
    var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;
});
parcelRegister("kag1C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0746a27410bc168$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dV6Te;
    var $VSDnB;
    function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
                fill: "inherit",
                x: "8",
                y: "11",
                width: "8",
                height: "2",
                rx: "1"
            });
        }
        if (isChecked) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration')) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                fill: "inherit"
            });
            else return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
                d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
                fill: "inherit"
            });
        }
        return null;
    }
    const $a0746a27410bc168$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') ? (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;
});
parcelRegister("7xteU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b368d644c230660$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $7b368d644c230660$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $7b368d644c230660$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $7b368d644c230660$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $7b368d644c230660$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $7b368d644c230660$var$baseStyles,
                label && $7b368d644c230660$var$textLabelLayoutStyles,
                isDisabled && $7b368d644c230660$var$disabledStyles,
                $7b368d644c230660$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("hsLv2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce636d67b4ff1120$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $ce636d67b4ff1120$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ce636d67b4ff1120$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $ce636d67b4ff1120$var$labelTextStyles
        }, children);
    }
});
parcelRegister("e62YQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2156c28a3894cac$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d2156c28a3894cac$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d2156c28a3894cac$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d2156c28a3894cac$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("hp1g9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ccbe97401ecc0bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7O4UO;
    const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
        const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
        const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
                ...currentValue,
                value
            ] : currentValue, [
            value,
            defaultIsChecked
        ]);
        return value !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            ...rest,
            defaultValue: defaultValue,
            transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                    ...currentValue,
                    value
                ] : currentValue.filter((v)=>v !== value)
        }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            ...rest,
            defaultValue: defaultIsChecked,
            transform: (event)=>event.currentTarget.checked
        }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            }));
    };
    $9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
        defaultIsChecked: false
    };
    var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;
});
parcelRegister("exGcw", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$8df41448adf6bbfb$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$8df41448adf6bbfb$export$ffef3a401aef987b);
    $parcel$export(module.exports, "setRetainValue", ()=>$8df41448adf6bbfb$export$7f2b89a121299348);
    const $8df41448adf6bbfb$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
                label: value,
                value: id
            }));
    const $8df41448adf6bbfb$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
                id: value,
                value: label
            }));
    const $8df41448adf6bbfb$export$7f2b89a121299348 = ({ options: options, itemValue: itemValue, values: values })=>{
        const selectedOption = options?.find((option)=>option.value === itemValue);
        let retainValue = [
            ...values || []
        ];
        let isElementAlreadyChecked = false;
        const newCheckedItems = values?.filter((item)=>{
            if (item.value === itemValue) isElementAlreadyChecked = true;
            return item.value !== itemValue;
        });
        if (isElementAlreadyChecked && newCheckedItems !== undefined) retainValue = newCheckedItems;
        else if (selectedOption) retainValue.push(selectedOption);
        return retainValue;
    };
});
parcelRegister("bN8Bv", function(module, exports) {
    $parcel$export(module.exports, "mutateCheckboxField", ()=>$48bc647953349865$export$23a688ac1e0973b5);
    const $48bc647953349865$export$23a688ac1e0973b5 = (values, fieldId)=>{
        const transformedValues = values.map(({ value: value })=>({
                optionId: value
            }));
        return {
            fieldId: fieldId,
            mutationGroup: (0, $c120cee24f2c37b0$export$31fd86f8f183952c),
            options: transformedValues
        };
    };
});
const $c120cee24f2c37b0$export$31fd86f8f183952c = 'multipleSelectFields';
parcelRegister("htVqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f0e8bfaa21e37b81$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqVnL;
    var $7ZmbO;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    const $f0e8bfaa21e37b81$var$CmdbField = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, additionalData: { isMulti: isMulti = false, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch }, fieldProps: { value: value, onChange: onChange }, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, selectedProject: selectedProject, autoFocus: autoFocus = false, width: width, fieldId: fieldId, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7ZmbO")).LimitData), {
            limitProperty: (0, (0, parcelRequire("7ZmbO")).MAX_CMDB_OBJECTS_PER_FIELD)
        }, (limit)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqVnL")).CmdbFieldObjectPicker), {
                autoCompleteUrl: `${autoCompleteUrl}?`,
                displayedValues: value,
                selectedValues: value,
                attributesToDisplayInSearch: attributesIncludedInAutoCompleteSearch,
                multiple: isMulti,
                onChange: onChange,
                autoFocus: autoFocus,
                limit: limit,
                menuPosition: "fixed",
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll),
                contextAndValuesOfIssueBeingCreated: {
                    ...contextAndValuesOfIssueBeingCreated,
                    fieldId: fieldId,
                    selectedProject: selectedProject
                },
                ariaLabelledBy: ariaLabelledBy
            })));
    };
    var $f0e8bfaa21e37b81$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({})($f0e8bfaa21e37b81$var$CmdbField);
});
parcelRegister("iqVnL", function(module, exports) {
    $parcel$export(module.exports, "CmdbFieldObjectPicker", ()=>$d3cb5af84ef48897$export$2c337ae5a2979962);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    var $7K5PP;
    var $4R6GH;
    var $pa9q9;
    var $koVbs;
    var $lE3p8;
    var $3j1Hg;
    var $johYW;
    var $8K3pq;
    var $dVEoL;
    var $4EFpF;
    var $cwlnA;
    var $3FZpe;
    var $iPF9E;
    const $d3cb5af84ef48897$export$f3d4a8207a9d907f = (attributesToDisplayInSearch)=>(cmdbObject)=>{
            const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
            const searchableLabel = cmdbObject.attributes.map((attribute)=>{
                if (attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label === true) return getDisplayValuesFromAttribute(attribute);
                return undefined;
            }).filter(Boolean).join(' ');
            return {
                value: cmdbObject.id,
                label: searchableLabel || cmdbObject.label,
                rawData: cmdbObject
            };
        };
    const $d3cb5af84ef48897$export$cc2466dccf2cb27d = (values)=>{
        if (!values) return values;
        return values.map((x)=>({
                label: x.label,
                value: x.objectId,
                rawData: x
            }));
    };
    const $d3cb5af84ef48897$export$2c337ae5a2979962 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasConfigError = (0, (0, parcelRequire("4R6GH")).fg)('fly-1966_show_error_if_field_not_configured') ? !props.attributesToDisplayInSearch?.length : false;
        const { autoCompleteUrl: autoCompleteUrl, attributesToDisplayInSearch: attributesToDisplayInSearch = [], multiple: multiple = false, displayedValues: displayedValues, selectedValues: selectedValues = [], onChange: propsOnChange, issueId: issueId, limit: limit, autoFocus: autoFocus, menuPosition: menuPosition = 'absolute', onCloseMenuOnScroll: onCloseMenuOnScroll, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        const fetchCmdbObjects = (searchValue)=>{
            if (typeof autoCompleteUrl === 'string' && autoCompleteUrl) return (0, (0, parcelRequire("8K3pq")).searchCmdbObjects)(autoCompleteUrl, searchValue, issueId, (0, (0, parcelRequire("lE3p8")).extractFieldValueMap)(contextAndValuesOfIssueBeingCreated));
            throw new Error('Invalid URL');
        };
        const transformObjectToSelectOption = (0, $5uXOq.useMemo)(()=>$d3cb5af84ef48897$export$f3d4a8207a9d907f(attributesToDisplayInSearch), [
            attributesToDisplayInSearch
        ]);
        const { selectProps: selectProps, error: error, totalNumberOfResults: totalNumberOfResults } = (0, (0, parcelRequire("3j1Hg")).usePaginatedAutocomplete)(selectedValues, fetchCmdbObjects, transformObjectToSelectOption, contextAndValuesOfIssueBeingCreated);
        let numberOfSearchResults;
        if ((0, (0, parcelRequire("4R6GH")).fg)('assets_rearch_total_count_deprecated_for_field')) numberOfSearchResults = (totalNumberOfResults ?? 0) >= (0, (0, parcelRequire("johYW")).MAX_OBJECT_COUNT_CUTOFF) ? `${0, (0, parcelRequire("johYW")).MAX_OBJECT_COUNT_CUTOFF}+` : totalNumberOfResults;
        else numberOfSearchResults = totalNumberOfResults;
        const selectPropsWithLabel = selectProps && Object.keys(selectProps).length && {
            ...selectProps,
            options: [
                {
                    label: formatMessage((0, (0, parcelRequire("3FZpe")).default).dropdownNumberOfSearchResultsLabel, {
                        numberOfSearchResults: numberOfSearchResults,
                        isLoading: selectProps.isLoading
                    }),
                    options: selectProps.options
                }
            ]
        };
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const onChange = (0, $5uXOq.useCallback)((selectedOption)=>{
            if (!selectedOption) {
                propsOnChange([]);
                return;
            }
            if (Array.isArray(selectedOption)) propsOnChange(selectedOption.map((x)=>x.rawData));
            if (!Array.isArray(selectedOption)) propsOnChange([
                selectedOption.rawData
            ]);
        }, [
            propsOnChange
        ]);
        const showGenericErrorFlag = (0, $5uXOq.useCallback)(()=>{
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("3FZpe")).default).errorTitleCmdbAssets),
                description: formatMessage((0, (0, parcelRequire("3FZpe")).default).errorMessage),
                isAutoDismiss: true
            });
        }, [
            formatMessage,
            showFlag
        ]);
        const responseErrorHandler = (0, $5uXOq.useMemo)(()=>({
                404: ()=>showGenericErrorFlag(),
                400: ()=>showFlag({
                        type: 'error',
                        title: formatMessage((0, (0, parcelRequire("3FZpe")).default).errorTitleCmdbFieldSearch),
                        description: formatMessage((0, (0, parcelRequire("3FZpe")).default).errorMessageCmdbFieldSearch),
                        isAutoDismiss: true
                    })
            }), [
            formatMessage,
            showFlag,
            showGenericErrorFlag
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) responseErrorHandler[error.statusCode] ? responseErrorHandler[error.statusCode]() : showGenericErrorFlag();
        }, [
            error,
            responseErrorHandler,
            showGenericErrorFlag
        ]);
        const { Option: Option } = (0, (0, parcelRequire("bChGW")).components);
        const customComponents = (0, $5uXOq.useMemo)(()=>({
                Option: (optionProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Option, optionProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4EFpF")).CmdbSelectOption), {
                        label: optionProps.label,
                        data: optionProps.data,
                        selectProps: optionProps.selectProps,
                        attributesToDisplayInSearch: attributesToDisplayInSearch
                    }))
            }), [
            attributesToDisplayInSearch
        ]);
        const singleObjectReached = !multiple && selectedValues.length === 1;
        const singleObjectExceeded = !multiple && selectedValues.length > 1;
        const objectLimitReached = selectedValues.length === limit;
        const objectLimitExceeded = selectedValues.length > limit;
        const shouldShowSelect = (multiple || selectedValues.length === 0) && selectedValues.length < limit;
        const getMessages = (objectLimit)=>{
            const validationMessages = [];
            singleObjectExceeded && validationMessages.push({
                label: 'warning',
                messageContent: formatMessage((0, (0, parcelRequire("3FZpe")).default).warningMultipleObjectsMessage)
            });
            objectLimitExceeded && validationMessages.push({
                label: 'warning',
                messageContent: formatMessage((0, (0, parcelRequire("3FZpe")).default).warningObjectLimitExceeded, {
                    objectLimit: objectLimit
                })
            });
            singleObjectReached && validationMessages.push({
                label: 'info',
                messageContent: formatMessage((0, (0, parcelRequire("3FZpe")).default).infoSingleObjectMessage)
            });
            objectLimitReached && validationMessages.push({
                label: 'info',
                messageContent: formatMessage((0, (0, parcelRequire("3FZpe")).default).infoObjectLimitReached, {
                    objectLimit: objectLimit
                })
            });
            return validationMessages.length > 0 ? [
                validationMessages[0]
            ] : [];
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId
        }, hasConfigError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVEoL")).CmdbFieldError), {
            fieldId: contextAndValuesOfIssueBeingCreated?.fieldId
        }), !hasConfigError && (displayedValues || shouldShowSelect) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            value: $d3cb5af84ef48897$export$cc2466dccf2cb27d(displayedValues),
            isMulti: multiple,
            autoFocus: autoFocus,
            onChange: onChange,
            placeholder: formatMessage((0, (0, parcelRequire("3FZpe")).default).searchPlaceholder),
            components: customComponents,
            isClearable: true,
            menuPlacement: "auto",
            menuPosition: menuPosition,
            styles: (0, (0, parcelRequire("iPF9E")).customStyles),
            closeMenuOnScroll: onCloseMenuOnScroll,
            ...selectPropsWithLabel,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cwlnA")).EditMessage), {
            messages: getMessages(limit)
        }));
    };
});
parcelRegister("lE3p8", function(module, exports) {
    $parcel$export(module.exports, "extractFieldValueMap", ()=>$bb48dc0efc8689b7$export$fb98c8002c9a4960);
    var $5fc53;
    const $bb48dc0efc8689b7$var$getStringValue = (fieldValues)=>fieldValues;
    const $bb48dc0efc8689b7$var$getJoinedArray = (fieldValues)=>fieldValues.map(({ value: value })=>value).join(',');
    const $bb48dc0efc8689b7$var$extractFieldValueMethods = {
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $bb48dc0efc8689b7$var$getStringValue,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $bb48dc0efc8689b7$var$getStringValue,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: $bb48dc0efc8689b7$var$getJoinedArray,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: ({ accountId: accountId })=>accountId,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: ({ id: id })=>id,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: ({ value: value })=>value,
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: ({ value: value })=>value,
        [(0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE)]: (fieldValues)=>fieldValues.map(({ workspaceId: workspaceId, objectId: objectId })=>`${workspaceId}:${objectId}`).join(',')
    };
    const $bb48dc0efc8689b7$var$extractIssueTypeValue = (selectedIssueType)=>selectedIssueType.type === 'REQUEST_TYPE' ? selectedIssueType.issueTypeId : selectedIssueType.value;
    const $bb48dc0efc8689b7$export$fb98c8002c9a4960 = (contextAndValues)=>{
        const result = {};
        if (contextAndValues) {
            const { getFormState: getFormState, fieldConfig: fieldConfig, selectedProject: selectedProject, selectedIssueType: selectedIssueType } = contextAndValues;
            const formData = getFormState().values;
            Object.keys(formData).forEach((fieldId)=>{
                const extractFieldValue = $bb48dc0efc8689b7$var$extractFieldValueMethods[fieldConfig[fieldId]?.fieldType];
                const fieldValues = formData[fieldId];
                if (extractFieldValue && fieldValues) result[fieldId] = extractFieldValue(fieldValues);
            });
            if (selectedProject) result.pid = selectedProject.value;
            if (selectedIssueType) result.issuetype = $bb48dc0efc8689b7$var$extractIssueTypeValue(selectedIssueType);
        }
        return result;
    };
});
parcelRegister("3j1Hg", function(module, exports) {
    $parcel$export(module.exports, "usePaginatedAutocomplete", ()=>$dd937729ff146f44$export$6e13ec0c80bdfaa8);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $kEqrP;
    var $lE3p8;
    var $6xC0V;
    const $dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions = (availableOptions, optionsToRemove)=>availableOptions.filter((optionFromRequest)=>!optionsToRemove.find((selectedOption)=>selectedOption.id === optionFromRequest.id));
    const $dd937729ff146f44$var$addOrReplaceNewResults = (action, optionsToSave)=>(oldOptions)=>{
            switch(action){
                case (0, (0, parcelRequire("6xC0V")).Actions).APPEND:
                    return [
                        ...oldOptions,
                        ...optionsToSave
                    ];
                case (0, (0, parcelRequire("6xC0V")).Actions).REPLACE:
                default:
                    return optionsToSave;
            }
        };
    const $dd937729ff146f44$var$calculateNumberOfResults = (totalNumberOfResults, savedResultFromTheSearch, displayedOptions)=>{
        if (totalNumberOfResults) return totalNumberOfResults - (savedResultFromTheSearch.length - displayedOptions.length);
        return totalNumberOfResults;
    };
    const $dd937729ff146f44$export$6e13ec0c80bdfaa8 = (selectedResults, doFetch, transform, contextAndValuesOfIssueBeingCreated)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [savedResultFromTheSearch, setSavedResultFromTheSearch] = (0, $5uXOq.useState)([]);
        const [hasUserEnteredTextForLastSearch, setHasUserEnteredTextForLastSearch] = (0, $5uXOq.useState)(undefined);
        const [totalNumberOfResults, setTotalNumberOfResults] = (0, $5uXOq.useState)();
        const [error, setError] = (0, $5uXOq.useState)();
        const fetchNextPageRef = (0, $5uXOq.useRef)();
        const isMenuOpen = (0, $5uXOq.useRef)(false);
        const oldContextRef = (0, $5uXOq.useRef)();
        const fetchSearchResults = async (fetchFunction, action)=>{
            setIsLoading(true);
            try {
                const { results: results, fetchNextPage: nextPageFunction, total: total } = await fetchFunction();
                setTotalNumberOfResults(total);
                const newOptions = $dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions(results, selectedResults);
                if (newOptions.length === 0 && nextPageFunction) await fetchSearchResults(nextPageFunction, (0, (0, parcelRequire("6xC0V")).Actions).APPEND);
                else fetchNextPageRef.current = nextPageFunction;
                setSavedResultFromTheSearch($dd937729ff146f44$var$addOrReplaceNewResults(action, results));
                (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).success();
                setIsLoading(false);
            } catch (err) {
                fetchNextPageRef.current = undefined;
                (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).failure();
                if (err && err.name === 'AbortError') return;
                setError(err);
                setIsLoading(false);
            }
        };
        const onInputChange = (searchValue, type)=>{
            if (type.action === 'input-change') {
                (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).start();
                setHasUserEnteredTextForLastSearch(searchValue !== '');
                fetchSearchResults(()=>doFetch(searchValue), (0, (0, parcelRequire("6xC0V")).Actions).REPLACE);
            }
        };
        const debouncedOnInputChange = (0, ($parcel$interopDefault($lFKmC)))(onInputChange, 400);
        const onMenuScrollToBottom = async ()=>{
            if (fetchNextPageRef.current) {
                (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).start();
                await fetchSearchResults(fetchNextPageRef.current, (0, (0, parcelRequire("6xC0V")).Actions).APPEND);
            }
        };
        const hasContextChanged = (currentContext)=>{
            const fieldId = contextAndValuesOfIssueBeingCreated?.fieldId;
            const oldContext = oldContextRef.current;
            if (!oldContext || !currentContext) return false;
            const currentContextKeys = Object.keys(currentContext);
            const oldContextKeys = Object.keys(oldContext);
            if (currentContextKeys.length !== oldContextKeys.length) return true;
            for(let i = 0; i < currentContextKeys.length; i += 1){
                const key = currentContextKeys[i];
                const value1 = currentContext[key];
                const value2 = oldContext[key];
                const isCheckingValueOfCurrentField = fieldId === key;
                if (!isCheckingValueOfCurrentField && value1 !== value2) return true;
            }
            return false;
        };
        const onMenuOpen = async ()=>{
            if (!isMenuOpen.current) {
                isMenuOpen.current = true;
                (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).start();
                const currentContext = (0, (0, parcelRequire("lE3p8")).extractFieldValueMap)(contextAndValuesOfIssueBeingCreated);
                if (hasUserEnteredTextForLastSearch !== false || hasContextChanged(currentContext)) {
                    await fetchSearchResults(()=>doFetch(''), (0, (0, parcelRequire("6xC0V")).Actions).REPLACE);
                    setHasUserEnteredTextForLastSearch(false);
                    oldContextRef.current = currentContext;
                } else (0, (0, parcelRequire("kEqrP")).autocompleteInsightFieldExperience).success();
            }
        };
        const onMenuClose = ()=>{
            isMenuOpen.current = false;
        };
        const displayedOptions = (0, $5uXOq.useMemo)(()=>$dd937729ff146f44$var$filterOutAlreadySelectedOptionFromAvailableOptions(savedResultFromTheSearch, selectedResults).map(transform), [
            savedResultFromTheSearch,
            selectedResults,
            transform
        ]);
        return {
            error: error,
            selectProps: {
                isLoading: isLoading,
                options: displayedOptions,
                onInputChange: debouncedOnInputChange,
                onMenuScrollToBottom: onMenuScrollToBottom,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose
            },
            totalNumberOfResults: $dd937729ff146f44$var$calculateNumberOfResults(totalNumberOfResults, savedResultFromTheSearch, displayedOptions)
        };
    };
});
parcelRegister("6xC0V", function(module, exports) {
    $parcel$export(module.exports, "Actions", ()=>$660633281bd3e7e6$export$b52183d5cfb26dc9);
    const $660633281bd3e7e6$export$b52183d5cfb26dc9 = Object.freeze({
        APPEND: 'APPEND',
        REPLACE: 'REPLACE'
    });
});
parcelRegister("johYW", function(module, exports) {
    $parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", ()=>$0761f987dd69a755$export$3d2246e48d9cfed3);
    $parcel$export(module.exports, "DATE_VALUE_FORMAT", ()=>$0761f987dd69a755$export$d1fb6689cfa66d9b);
    $parcel$export(module.exports, "TIME_VALUE_FORMAT", ()=>$0761f987dd69a755$export$5f2ab89513b5926a);
    $parcel$export(module.exports, "ZONE_VALUE_FORMAT", ()=>$0761f987dd69a755$export$5c2d6de3ca9adcbe);
    $parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", ()=>$0761f987dd69a755$export$defafc11b2455f78);
    $parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", ()=>$0761f987dd69a755$export$f61f3fa9ed38719a);
    $parcel$export(module.exports, "globalErrorContexts", ()=>$0761f987dd69a755$export$b896d7bac8b72b0);
    $parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", ()=>$0761f987dd69a755$export$89b103afe26b1ad0);
    const $0761f987dd69a755$export$3d2246e48d9cfed3 = [
        'p',
        'u',
        'a',
        'em',
        'strong',
        'span',
        'ol',
        'ul',
        'li',
        'pre',
        'code',
        'h2',
        'h3',
        'h4',
        'hr',
        'table',
        'thead',
        'tbody',
        'tr',
        'th',
        'td'
    ];
    const $0761f987dd69a755$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
    const $0761f987dd69a755$export$5f2ab89513b5926a = 'HH:mm';
    const $0761f987dd69a755$export$5c2d6de3ca9adcbe = 'XXX';
    const $0761f987dd69a755$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
    const $0761f987dd69a755$export$f97789ccd031e7d = 'dd/MMM/yy';
    const $0761f987dd69a755$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
    const $0761f987dd69a755$export$b896d7bac8b72b0 = [
        'objectsLimit',
        'objectTypeAttributesLimit',
        'objectSchemaLimit'
    ];
    const $0761f987dd69a755$export$89b103afe26b1ad0 = 1000;
});
parcelRegister("8K3pq", function(module, exports) {
    $parcel$export(module.exports, "searchCmdbObjects", ()=>$1ffad36294955285$export$24be3d709330b09);
    var $7f4tk;
    const $1ffad36294955285$var$RESULTS_PER_PAGE = 50;
    const $1ffad36294955285$var$transform = ({ size: size, hasNextPage: hasNextPage, results: results, total: total })=>({
            size: size,
            hasNextPage: hasNextPage,
            results: results.map((entry)=>({
                    ...entry,
                    attributes: entry.attributes.map((att)=>({
                            ...att,
                            type: att.objectTypeAttribute.type
                        }))
                })),
            total: total
        });
    let $1ffad36294955285$var$abortController = null;
    const $1ffad36294955285$export$24be3d709330b09 = async (autoCompleteUrl, query, issueId, fieldValueMap, page = 0)=>{
        if ($1ffad36294955285$var$abortController && $1ffad36294955285$var$abortController.abort) $1ffad36294955285$var$abortController.abort();
        $1ffad36294955285$var$abortController = new AbortController();
        const result = await (0, (0, parcelRequire("7f4tk")).default)(`${autoCompleteUrl}start=${$1ffad36294955285$var$RESULTS_PER_PAGE * page}&limit=${$1ffad36294955285$var$RESULTS_PER_PAGE}`, {
            method: 'POST',
            body: JSON.stringify({
                query: query,
                issueId: issueId,
                fieldValueMap: fieldValueMap
            }),
            signal: $1ffad36294955285$var$abortController.signal
        }).then($1ffad36294955285$var$transform);
        return {
            results: result.results,
            fetchNextPage: result.hasNextPage ? ()=>$1ffad36294955285$export$24be3d709330b09(autoCompleteUrl, query, issueId, fieldValueMap, page + 1) : undefined,
            total: result.total
        };
    };
});
parcelRegister("dVEoL", function(module, exports) {
    $parcel$export(module.exports, "CmdbFieldError", ()=>$852edac7ba234595$export$bd2288ff08a8a1d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $l1N8i;
    var $7nnPp;
    var $d2ta3;
    var $koVbs;
    var $ktP1V;
    var $04BO2;
    var $ahEft;
    var $9OXo1;
    var $3HIwk;
    const $852edac7ba234595$var$UpgradeToPremiumLink = (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: (0, (0, parcelRequire("04BO2")).getJsmChangeEditionUrl)(),
            target: "_blank"
        }, chunks);
    const $852edac7ba234595$export$cf18a118761851fd = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$var$InlineMessageContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
            label: "error",
            primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$exports).R400})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, children));
    const $852edac7ba234595$export$eb21c278059498f8 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("3HIwk")).default).errorInvalidFieldConfig));
    };
    const $852edac7ba234595$export$22a4392f7c676bd6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("3HIwk")).default).errorInvalidFieldConfigDisabledCmdbAssets));
    };
    const $852edac7ba234595$export$14493edb463e15ea = ({ fieldId: fieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("3HIwk")).default).errorInvalidFieldConfigAdmin)), fieldId && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-field-error.button",
            appearance: "link",
            href: (0, (0, parcelRequire("d2ta3")).getConfigureCustomFieldUrl)(fieldId),
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("3HIwk")).default).errorInvalidFieldConfigAdminLink)));
    };
    const $852edac7ba234595$export$3d5c9691c28d309d = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const notPremiumErrorAdmin = formatMessage((0, (0, parcelRequire("3HIwk")).default).errorInvalidFieldConfigDowngradedAdminCmdbAssets, {
            a: $852edac7ba234595$var$UpgradeToPremiumLink
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "span"
        }, notPremiumErrorAdmin);
    };
    const $852edac7ba234595$export$192152d4765eff13 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("3HIwk")).default).errorUnknown));
    };
    const $852edac7ba234595$export$bd2288ff08a8a1d9 = (props)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const hasPremium = (0, (0, parcelRequire("ahEft")).isPremiumInstance)(tenantContext);
        const isCmdbEnabled = (0, (0, parcelRequire("ktP1V")).isCMDBEnabledInEnvironment)();
        const { isAdmin: isAdmin } = tenantContext;
        const errorBody = (0, $5uXOq.useMemo)(()=>{
            if (!isCmdbEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$22a4392f7c676bd6, null);
            if (hasPremium && !isAdmin) return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$eb21c278059498f8, null);
            if (hasPremium && isAdmin) return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$14493edb463e15ea, {
                fieldId: props.fieldId
            });
            if (!hasPremium && isAdmin) return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$3d5c9691c28d309d, null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$192152d4765eff13, null);
        }, [
            hasPremium,
            isAdmin,
            isCmdbEnabled,
            props.fieldId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($852edac7ba234595$export$cf18a118761851fd, null, errorBody);
    };
    const $852edac7ba234595$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $852edac7ba234595$var$InlineMessageContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _ep9tidpf _1oh2idpf _9r1zidpf _99ztidpf _f5gaidpf _1m2uidpf _hstcidpf _9n9oidpf _1vkjeo28",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d2ta3", function(module, exports) {
    $parcel$export(module.exports, "getAssociateFieldToScreensUrl", ()=>$d0ff6fbc6d047529$export$23b03b7fae19e4d9);
    $parcel$export(module.exports, "getScreenUrl", ()=>$d0ff6fbc6d047529$export$f7bdae1f819aa43b);
    $parcel$export(module.exports, "getTranslateCustomFieldUrl", ()=>$d0ff6fbc6d047529$export$d190ce44f97f903);
    $parcel$export(module.exports, "getConfigureCustomFieldUrl", ()=>$d0ff6fbc6d047529$export$6e2455bbc376835a);
    $parcel$export(module.exports, "getEditCustomFieldUrl", ()=>$d0ff6fbc6d047529$export$16e5d0ee7be5b38f);
    $parcel$export(module.exports, "getDeleteCustomFieldUrl", ()=>$d0ff6fbc6d047529$export$45ccfea6f6fbf3cc);
    $parcel$export(module.exports, "defaultQuery", ()=>$d0ff6fbc6d047529$export$c08de3b5cc335eeb);
    $parcel$export(module.exports, "ITEMS_PER_PAGE", ()=>$d0ff6fbc6d047529$export$ec93a669a20aa982);
    $parcel$export(module.exports, "CUSTOM_FIELDS_TYPE", ()=>$d0ff6fbc6d047529$export$49b8e5da9a1d0738);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_CF_TYPE", ()=>$d0ff6fbc6d047529$export$d5f572ebd2c1f0d1);
    var $1AqFL;
    const $d0ff6fbc6d047529$export$23b03b7fae19e4d9 = (id)=>`/secure/admin/AssociateFieldToScreens!default.jspa?fieldId=${id}`;
    const $d0ff6fbc6d047529$export$f7bdae1f819aa43b = (screenId)=>`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;
    const $d0ff6fbc6d047529$export$d190ce44f97f903 = (id)=>`/secure/admin/TranslateCustomField!default.jspa?id=${(0, (0, parcelRequire("1AqFL")).getTrimId)(id)}`;
    const $d0ff6fbc6d047529$export$6e2455bbc376835a = (id)=>`/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${(0, (0, parcelRequire("1AqFL")).getTrimId)(id)}`;
    const $d0ff6fbc6d047529$export$16e5d0ee7be5b38f = (id)=>`/secure/admin/EditCustomField!default.jspa?id=${(0, (0, parcelRequire("1AqFL")).getTrimId)(id)}`;
    const $d0ff6fbc6d047529$export$45ccfea6f6fbf3cc = (id)=>`/secure/admin/DeleteCustomField!default.jspa?id=${(0, (0, parcelRequire("1AqFL")).getTrimId)(id)}`;
    const $d0ff6fbc6d047529$export$c08de3b5cc335eeb = {
        searchFilter: undefined,
        customFieldStatus: (0, $794f056043a7eb6b$export$2b35adb71b3f6143)
    };
    const $d0ff6fbc6d047529$export$ec93a669a20aa982 = 15;
    const $d0ff6fbc6d047529$export$49b8e5da9a1d0738 = 'custom';
    const $d0ff6fbc6d047529$export$d5f572ebd2c1f0d1 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
});
parcelRegister("1AqFL", function(module, exports) {
    $parcel$export(module.exports, "getTrimId", ()=>$ea8bf3cf6c912eab$export$4817065c39922b39);
    const $ea8bf3cf6c912eab$export$4817065c39922b39 = (id)=>id.split('_').reverse()[0];
});
const $794f056043a7eb6b$export$3c5e605ca7ade9f2 = 'NAME';
const $794f056043a7eb6b$export$965630dc71fb3a05 = 'LAST_USED';
const $794f056043a7eb6b$export$d5a7f00a6a604217 = 'SCREENS_AND_CONTEXTS';
const $794f056043a7eb6b$export$44d67b522cbcce6d = 'PROJECTS';
const $794f056043a7eb6b$export$421090ea46f71c9c = 'DELETED_ON';
const $794f056043a7eb6b$export$a7cd2db90465ec68 = 'PERMANENTLY_DELETING';
const $794f056043a7eb6b$export$2b35adb71b3f6143 = 'Active';
const $794f056043a7eb6b$export$f1ded5eab7e819b3 = 'Trashed';
parcelRegister("04BO2", function(module, exports) {
    $parcel$export(module.exports, "getProjectUrl", ()=>$27b6cf49cbe4c1ee$export$951b86b8e730b952);
    $parcel$export(module.exports, "getRequestTypesUrl", ()=>$27b6cf49cbe4c1ee$export$9d7c743b509e267);
    $parcel$export(module.exports, "getChangeRequestTypesUrl", ()=>$27b6cf49cbe4c1ee$export$6096ac65eb900914);
    $parcel$export(module.exports, "getProjectSettingsPageUrl", ()=>$27b6cf49cbe4c1ee$export$75ee62cffcd82d96);
    $parcel$export(module.exports, "getProjectSettingsUrl", ()=>$27b6cf49cbe4c1ee$export$a497c8f8c3782075);
    $parcel$export(module.exports, "getWorkflowSettingsUrl", ()=>$27b6cf49cbe4c1ee$export$c2a8139910ee6c);
    $parcel$export(module.exports, "getJsmChangeEditionUrl", ()=>$27b6cf49cbe4c1ee$export$b87292f363462760);
    $parcel$export(module.exports, "getUserManagementUrl", ()=>$27b6cf49cbe4c1ee$export$13f39b40814e5f3e);
    var $2vSU6;
    var $02Psx;
    var $l3Iek;
    var $k3the;
    var $2iuKi;
    var $9VXkC;
    const $27b6cf49cbe4c1ee$export$951b86b8e730b952 = (projectKey)=>(0, (0, parcelRequire("9VXkC")).generatePath)((0, (0, parcelRequire("2iuKi")).projectsRedirectRoute).path, {
            projectKey: projectKey
        });
    const $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, (0, parcelRequire("02Psx")).getNextgenSettingsIssueTypesUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey, issueTypeId);
    const $27b6cf49cbe4c1ee$export$9d7c743b509e267 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, (0, parcelRequire("9VXkC")).generatePath)((0, (0, parcelRequire("k3the")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute).path, {
            projectKey: projectKey
        });
    const $27b6cf49cbe4c1ee$export$6096ac65eb900914 = (projectKey, isSimplified = false)=>isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : `${$27b6cf49cbe4c1ee$export$9d7c743b509e267(projectKey, isSimplified)}/category/changes`;
    const $27b6cf49cbe4c1ee$export$75ee62cffcd82d96 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
    const $27b6cf49cbe4c1ee$export$a497c8f8c3782075 = (projectKey, isSimplified = false)=>{
        const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
        return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
    };
    const $27b6cf49cbe4c1ee$export$c2a8139910ee6c = (projectKey, issueTypeId, isSimplified = false)=>{
        if (!issueTypeId) return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey) : (0, (0, parcelRequire("9VXkC")).generatePath)((0, (0, parcelRequire("l3Iek")).legacyProjectSettingsWorkflowsRoute).path, {
            projectKey: projectKey
        });
        return isSimplified ? $27b6cf49cbe4c1ee$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
    };
    const $27b6cf49cbe4c1ee$export$b87292f363462760 = ()=>'/admin/billing/applications/change-edition/jira-servicedesk.ondemand';
    const $27b6cf49cbe4c1ee$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';
});
parcelRegister("l3Iek", function(module, exports) {
    $parcel$export(module.exports, "legacyProjectSettingsWorkflowsRoute", ()=>$31816b9f42bcb36a$export$b03606cedffdadf6);
    var $65Ltd;
    const $31816b9f42bcb36a$export$b03606cedffdadf6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        path: '/plugins/servlet/project-config/:projectKey/workflows'
    };
});
parcelRegister("2iuKi", function(module, exports) {
    $parcel$export(module.exports, "projectsRedirectRoute", ()=>$3aa0370b36d3207d$export$e6bc3ea427ddafb8);
    var $65Ltd;
    const $3aa0370b36d3207d$export$e6bc3ea427ddafb8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_REDIRECT),
        path: '/projects/:projectKey',
        query: [
            'selectedItem!=(.+)'
        ],
        exact: true
    };
});
parcelRegister("3HIwk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f44be5fc5fa441b4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f44be5fc5fa441b4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorInvalidFieldConfig: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config",
            "defaultMessage": "This field needs to be configured with an object schema. Please contact your admin to configure this field."
        },
        errorInvalidFieldConfigAdmin: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin",
            "defaultMessage": "This field needs to be configured with an object schema."
        },
        errorInvalidFieldConfigAdminLink: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin-link",
            "defaultMessage": "Configure this custom field"
        },
        errorInvalidFieldConfigDowngradedAdminCmdbAssets: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-downgraded-admin-cmdb-assets",
            "defaultMessage": "Assets is not available in this Jira instance. <a>Upgrade to Premium</a> to re-enable Assets and see this data."
        },
        errorInvalidFieldConfigDisabledCmdbAssets: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-disabled-cmdb-assets",
            "defaultMessage": "Assets is not available in this Jira instance."
        },
        errorUnknown: {
            "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-unknown",
            "defaultMessage": "Something went wrong. Please refresh the page or contact your admin if the problem persists."
        }
    });
});
parcelRegister("4EFpF", function(module, exports) {
    $parcel$export(module.exports, "CmdbSelectOption", ()=>$3013101aa5c29dc3$export$a7be07965a3ed09b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $bUUmN;
    const $3013101aa5c29dc3$export$fee117cd50d6234b = ({ match: match, children: children })=>{
        if (match === '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
        const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
            if (part.toLowerCase() === match.toLowerCase()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "strong",
                key: i
            }, part);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: i
            }, part);
        }));
    };
    const $3013101aa5c29dc3$export$cd0f2f750043f4bc = (attributes)=>attributes.map(({ objectAttributeValues: objectAttributeValues })=>objectAttributeValues.map(({ displayValue: displayValue })=>displayValue).join(', ')).join(' | ');
    const $3013101aa5c29dc3$export$a7be07965a3ed09b = ({ attributesToDisplayInSearch: attributesToDisplayInSearch, data: data, selectProps: selectProps, label: label })=>{
        const object = data.rawData;
        const { inputValue: inputValue } = selectProps;
        const displayedAttributes = (0, $5uXOq.useMemo)(()=>attributesToDisplayInSearch.map((attrName)=>attrName === 'Label' ? object.attributes.find((attr)=>attr.objectTypeAttribute.label) : object.attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(Boolean), [
            object,
            attributesToDisplayInSearch
        ]);
        const primaryAttributeString = displayedAttributes?.[0]?.objectAttributeValues?.filter((v)=>v.displayValue).map((v)=>v.displayValue).join(', ') || label;
        const attributesString = $3013101aa5c29dc3$export$cd0f2f750043f4bc(displayedAttributes.slice(1));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$Outer, {
            "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bUUmN")).MemoizedInsightIcon), {
            mediaClientConfig: object.avatar.mediaClientConfig,
            iconUrl: object.avatar.url48,
            label: object.label,
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$ObjectName, {
            "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
            match: inputValue ?? ''
        }, primaryAttributeString)), attributesString && (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$var$Attributes, {
            "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3013101aa5c29dc3$export$fee117cd50d6234b, {
            match: inputValue ?? ''
        }, attributesString))));
    };
    const $3013101aa5c29dc3$var$Outer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1yt41pyq _irr314ae",
                __cmplp.className
            ])
        });
    });
    const $3013101aa5c29dc3$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxutpp _1o9zidpf",
                __cmplp.className
            ])
        });
    });
    const $3013101aa5c29dc3$var$ObjectName = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41tcg",
                __cmplp.className
            ])
        });
    });
    const $3013101aa5c29dc3$var$Attributes = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bUUmN", function(module, exports) {
    $parcel$export(module.exports, "InsightIcon", ()=>$91b4a14cfc200b23$export$4f72cced31fa9b94);
    $parcel$export(module.exports, "MemoizedInsightIcon", ()=>$91b4a14cfc200b23$export$55641517b59933d7);
    $parcel$export(module.exports, "UnstyledInsightIcon", ()=>$91b4a14cfc200b23$export$30c7947f25987be2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $vIiRg;
    var $ujWmd;
    var $iDZjq;
    var $kOLg6;
    var $jcw0u;
    var $4R6GH;
    const $91b4a14cfc200b23$export$cc575ace31787a4e = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.issuer) && Boolean(mediaClientConfig.fileId);
    const $91b4a14cfc200b23$export$d80733771196ad02 = (mediaClientConfig)=>Boolean(mediaClientConfig.mediaBaseUrl) && Boolean(mediaClientConfig.mediaJwtToken) && Boolean(mediaClientConfig.clientId) && Boolean(mediaClientConfig.fileId);
    const $91b4a14cfc200b23$var$DefaultIcon = ({ size: size, label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            size: size,
            name: label
        });
    const $91b4a14cfc200b23$export$a39db5532f57c7c2 = (clientAuth)=>Promise.resolve({
            clientId: clientAuth.clientId,
            token: clientAuth.mediaJwtToken,
            baseUrl: clientAuth.mediaBaseUrl
        });
    const $91b4a14cfc200b23$export$a5f760203816608a = (asapAuth)=>Promise.resolve({
            asapIssuer: asapAuth.issuer,
            token: asapAuth.mediaJwtToken,
            baseUrl: asapAuth.mediaBaseUrl
        });
    const $91b4a14cfc200b23$export$4f72cced31fa9b94 = (props)=>{
        const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
        if ((0, (0, parcelRequire("4R6GH")).fg)('assets_rearch_media_client_auth')) {
            if (!mediaClientConfig || $91b4a14cfc200b23$export$d80733771196ad02(mediaClientConfig) === false) {
                if (iconUrl) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                    src: iconUrl,
                    appearance: "square",
                    size: size,
                    name: label
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                    size: size,
                    label: label
                });
            }
        } else if (!mediaClientConfig || $91b4a14cfc200b23$export$cc575ace31787a4e(mediaClientConfig) === false) {
            if (iconUrl) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                src: iconUrl,
                appearance: "square",
                size: size,
                name: label
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        const fileIdentifier = {
            id: mediaClientConfig.fileId,
            mediaItemType: 'file'
        };
        const imageSize = {
            width: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
            height: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size]
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kOLg6")).MediaImageWithErrorBoundary), {
            identifier: fileIdentifier,
            mediaClientConfig: {
                authProvider: ()=>(0, (0, parcelRequire("4R6GH")).fg)('assets_rearch_media_client_auth') ? $91b4a14cfc200b23$export$a39db5532f57c7c2(mediaClientConfig) : $91b4a14cfc200b23$export$a5f760203816608a(mediaClientConfig)
            },
            apiConfig: imageSize
        }, ({ loading: loading, error: error, data: data })=>{
            if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDZjq")).default), {
                appearance: "square",
                size: size
            });
            if (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'insightIcon',
                        packageName: 'jiraServicedeskInsightIcon',
                        teamName: 'falcons'
                    }
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                    size: size,
                    label: label
                });
            }
            if (!data) return (0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$DefaultIcon, {
                size: size,
                label: label
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
                src: data.src,
                appearance: "square",
                size: size,
                name: label
            });
        });
    };
    const $91b4a14cfc200b23$export$55641517b59933d7 = (0, $5uXOq.memo)($91b4a14cfc200b23$export$4f72cced31fa9b94);
    const $91b4a14cfc200b23$export$30c7947f25987be2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$var$UnstyledInsightIconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($91b4a14cfc200b23$export$55641517b59933d7, props));
    const $91b4a14cfc200b23$var$UnstyledInsightIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81i6y _p7r1tcjq _1ugpglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iDZjq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31b6b09c530db49a$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $vIiRg;
    function $31b6b09c530db49a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $31b6b09c530db49a$var$skeletonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        backgroundColor: `var(${(0, (0, parcelRequire("vIiRg")).CSS_VAR_AVATAR_BGCOLOR)})`,
        border: `${(0, (0, parcelRequire("vIiRg")).BORDER_WIDTH)}px solid transparent`
    });
    const $31b6b09c530db49a$var$sizeStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                width: `${size}px`,
                height: `${size}px`
            })
        };
    }, {});
    const $31b6b09c530db49a$var$radiusStyles = Object.entries((0, (0, parcelRequire("vIiRg")).AVATAR_RADIUS)).reduce((styles, [key, size])=>{
        return {
            ...styles,
            [key]: (0, (0, parcelRequire("f8Sb3")).css)({
                borderRadius: `${size}px`
            })
        };
    }, {});
    const $31b6b09c530db49a$var$defaultRadiusStyles = {
        name: "1by8p7f",
        styles: "border-radius:var(--ds-border-radius-circle, 50%)"
    };
    const $31b6b09c530db49a$var$strongOpacityStyles = {
        name: "19sqbed",
        styles: "opacity:0.3"
    };
    const $31b6b09c530db49a$var$defaultOpacityStyles = {
        name: "1rz7oiv",
        styles: "opacity:0.15"
    };
    const $31b6b09c530db49a$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $31b6b09c530db49a$var$skeletonStyles,
                $31b6b09c530db49a$var$sizeStyles[size ?? 'medium'],
                appearance === 'square' ? $31b6b09c530db49a$var$radiusStyles[size ?? 'medium'] : $31b6b09c530db49a$var$defaultRadiusStyles,
                weight === 'strong' ? $31b6b09c530db49a$var$strongOpacityStyles : $31b6b09c530db49a$var$defaultOpacityStyles
            ],
            style: {
                [(0, (0, parcelRequire("vIiRg")).CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
            }
        });
    var $31b6b09c530db49a$export$2e2bcd8739ae039 = $31b6b09c530db49a$var$Skeleton;
});
parcelRegister("kOLg6", function(module, exports) {
    $parcel$export(module.exports, "MediaImageWithErrorBoundary", ()=>$27dd12b02502711d$export$758a2fef95a29ad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $eYKm8;
    const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.children({
                loading: false,
                error: true
            }))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYKm8")).MediaImageWithMediaClient), props));
});
parcelRegister("eYKm8", function(module, exports) {
    $parcel$export(module.exports, "MediaImageWithMediaClient", ()=>$eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $iArlU;
    var $10b0h;
    const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
        const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
        const dimensions = {
            width: width,
            height: height
        };
        const { preview: preview, error: error, getSsrScriptProps: getSsrScriptProps } = (0, (0, parcelRequire("10b0h")).useFilePreview)({
            identifier: identifier,
            dimensions: dimensions,
            ssr: ssr,
            resizeMode: mode,
            allowAnimated: allowAnimated,
            upscale: upscale,
            maxAge: maxAge
        });
        let status = 'loading';
        if (preview?.dataURI) status = 'succeeded';
        else if (error) status = 'error';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
            loading: status === 'loading',
            error: status === 'error',
            data: status === 'succeeded' ? {
                status: status,
                src: preview?.dataURI
            } : undefined
        }), getSsrScriptProps && (0, ($parcel$interopDefault($5uXOq))).createElement("script", getSsrScriptProps()));
    };
    const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
        const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iArlU")).withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(MediaImageComponent, props);
    };
});
parcelRegister("iArlU", function(module, exports) {
    $parcel$export(module.exports, "withMediaClient", ()=>$104af301cec809a6$export$9f7977d4a2561bee);
    var $5uXOq = parcelRequire("5uXOq");
    var $cEHh7;
    const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEHh7")).MediaClientContext).Consumer, null, (value)=>value ? (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEHh7")).MediaClientProvider), {
                    clientConfig: mediaClientConfig
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cEHh7")).MediaClientContext).Consumer, null, (client)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                        ...otherProps,
                        mediaClient: client
                    }))));
});
parcelRegister("10b0h", function(module, exports) {
    $parcel$export(module.exports, "useFilePreview", ()=>$baceb2843b357d39$export$4eaebdef02112fe4);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Pp1U;
    var $24tOd;
    var $cEHh7;
    var $8GKRF;
    var $VSDnB;
    var $kGpuq;
    var $01sWe;
    var $3JWNV;
    var $4n1NZ;
    var $7xRaJ;
    var $3JZCV;
    var $jR4hE;
    var $8Kbwv;
    const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
        const mediaClient = (0, (0, parcelRequire("cEHh7")).useMediaClient)();
        const [status, setStatus] = (0, $5uXOq.useState)('loading');
        const [error, setError] = (0, $5uXOq.useState)();
        const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
        const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
        const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
        const ssrReliabilityRef = (0, $5uXOq.useRef)({
            server: {
                status: 'unknown'
            },
            client: {
                status: 'unknown'
            }
        });
        const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, (0, parcelRequire("8Kbwv")).createRequestDimensions)(dimensions) : undefined, [
            dimensions
        ]);
        const requestDimensionsRef = (0, (0, parcelRequire("8Kbwv")).useCurrentValueRef)(requestDimensions);
        let imageURLParams = {
            collection: identifier.collectionName,
            mode: resizeMode,
            ...requestDimensions,
            allowAnimated: allowAnimated,
            upscale: upscale,
            'max-age': maxAge
        };
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform.media-card-performance-observer_a803k')) imageURLParams = {
            ...imageURLParams,
            source: source
        };
        const previewInitializer = ()=>{
            const preview = (0, (0, parcelRequire("7xRaJ")).mediaFilePreviewCache).get(identifier.id, resizeMode);
            if (preview) return preview;
            if (ssr) {
                const ssrData = (0, (0, parcelRequire("jR4hE")).getSSRData)(identifier);
                if (ssrData?.error) ssrReliabilityRef.current.server = {
                    status: 'fail',
                    ...ssrData.error
                };
                if (!ssrData?.dataURI) try {
                    return (0, (0, parcelRequire("3JWNV")).getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
                } catch (e) {
                    ssrReliabilityRef.current[ssr] = {
                        status: 'fail',
                        ...(0, (0, parcelRequire("kGpuq")).extractErrorInfo)(e, traceContext)
                    };
                }
                else {
                    const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                    return {
                        dataURI: dataURI,
                        dimensions: dimensions,
                        source: 'ssr-data'
                    };
                }
            }
        };
        const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
        const { fileState: fileState } = (0, (0, parcelRequire("24tOd")).useFileState)(identifier.id, {
            skipRemote: skipRemote,
            collectionName: identifier.collectionName,
            occurrenceKey: identifier.occurrenceKey
        });
        const fileStatus = fileState?.status;
        const isBackendPreviewReady = !!fileState && (0, (0, parcelRequire("1Pp1U")).isImageRepresentationReady)(fileState);
        const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
        const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
        (0, $5uXOq.useEffect)(()=>{
            setStatus('loading');
        }, [
            identifier
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (status !== 'error') {
                if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
                else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                    setStatus('error');
                    setError(new (0, (0, parcelRequire("01sWe")).MediaFilePreviewError)('failed-processing'));
                } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                    setStatus('error');
                    setError(new (0, (0, parcelRequire("01sWe")).MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
                } else setStatus('loading');
            }
        }, [
            preview,
            status,
            fileStatus,
            isBackendPreviewReady,
            fileStateErrorMessage,
            upfrontPreviewStatus
        ]);
        const getAndCacheRemotePreviewRef = (0, (0, parcelRequire("8Kbwv")).useCurrentValueRef)(()=>{
            return (0, (0, parcelRequire("3JWNV")).getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
        });
        (0, $5uXOq.useEffect)(()=>{
            if (preview) setUpfrontPreviewStatus('resolved');
            else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
                setUpfrontPreviewStatus('resolving');
                const fetchedDimensions = {
                    ...requestDimensions
                };
                getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                    if (!(0, (0, parcelRequire("8Kbwv")).isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
                }).catch(()=>{}).finally(()=>{
                    setUpfrontPreviewStatus('resolved');
                });
            }
        }, [
            getAndCacheRemotePreviewRef,
            preview,
            requestDimensions,
            requestDimensionsRef,
            skipRemote,
            upfrontPreviewStatus
        ]);
        const mediaBlobUrlAttrsRef = (0, (0, parcelRequire("8Kbwv")).useCurrentValueRef)(mediaBlobUrlAttrs);
        (0, $5uXOq.useEffect)(()=>{
            const cachedPreview = (0, (0, parcelRequire("7xRaJ")).mediaFilePreviewCache).get(identifier.id, resizeMode);
            if (!preview && cachedPreview && !(0, (0, parcelRequire("8Kbwv")).isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
            else if (!preview && !isBannedLocalPreview && localBinary && (0, (0, parcelRequire("4n1NZ")).isSupportedLocalPreview)(mediaType) && (0, (0, parcelRequire("8GKRF")).isMimeTypeSupportedByBrowser)(mimeType || '')) (0, (0, parcelRequire("3JWNV")).getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                setNonCriticalError(e);
            });
            else if (!error && !nonCriticalError && (!preview || (0, (0, parcelRequire("8Kbwv")).isBigger)(preview.dimensions, requestDimensions) || (0, (0, parcelRequire("3JWNV")).isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, (0, parcelRequire("01sWe")).ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else setNonCriticalError(wrappedError);
            });
        }, [
            error,
            nonCriticalError,
            getAndCacheRemotePreviewRef,
            identifier.id,
            resizeMode,
            isBannedLocalPreview,
            mediaBlobUrlAttrsRef,
            preview,
            requestDimensions,
            skipRemote,
            isBackendPreviewReady,
            localBinary,
            mediaType,
            mimeType,
            upfrontPreviewStatus
        ]);
        const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
            if (!failedPreview) return;
            if ((0, (0, parcelRequire("3JWNV")).isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, (0, parcelRequire("kGpuq")).createFailedSSRObject)(failedPreview, traceContext);
            if ((0, (0, parcelRequire("3JWNV")).isSSRDataPreview)(failedPreview)) {
                ssrReliabilityRef.current.server = (0, (0, parcelRequire("kGpuq")).createFailedSSRObject)(failedPreview, traceContext);
                ssrReliabilityRef.current.client = (0, (0, parcelRequire("kGpuq")).createFailedSSRObject)(failedPreview, traceContext);
            }
            if (failedPreview.dataURI !== preview?.dataURI) return;
            const isLocal = (0, (0, parcelRequire("3JWNV")).isLocalPreview)(failedPreview);
            const isRemote = (0, (0, parcelRequire("3JWNV")).isRemotePreview)(failedPreview);
            if (isLocal || isRemote) {
                const error = new (0, (0, parcelRequire("01sWe")).ImageLoadError)(failedPreview?.source);
                (0, (0, parcelRequire("7xRaJ")).mediaFilePreviewCache).remove(identifier.id, resizeMode);
                if (isLocal) setIsBannedLocalPreview(true);
                if (isRemote) {
                    setStatus('error');
                    setError(error);
                }
                setPreview(undefined);
            }
        }, [
            identifier.id,
            preview?.dataURI,
            resizeMode,
            traceContext
        ]);
        const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
            if (newPreview) {
                if ((0, (0, parcelRequire("3JWNV")).isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                    status: 'success'
                };
                if ((0, (0, parcelRequire("3JWNV")).isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                    ssrReliabilityRef.current.server = {
                        status: 'success'
                    };
                    ssrReliabilityRef.current.client = {
                        status: 'success'
                    };
                }
            }
            if (newPreview?.dataURI !== preview?.dataURI) return;
        }, [
            preview?.dataURI
        ]);
        const getSsrScriptProps = ssr === 'server' ? ()=>(0, (0, parcelRequire("3JZCV")).generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
        return {
            preview: preview,
            status: status,
            error: error,
            nonCriticalError: nonCriticalError,
            ssrReliability: ssrReliabilityRef.current,
            onImageError: onImageError,
            onImageLoad: onImageLoad,
            getSsrScriptProps: getSsrScriptProps
        };
    };
});
parcelRegister("24tOd", function(module, exports) {
    $parcel$export(module.exports, "useFileState", ()=>$768d10f5fd62ab89$export$90ff537b0999afb);
    var $5uXOq = parcelRequire("5uXOq");
    var $cEHh7;
    var $k4CmR;
    function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
        const mediaClient = (0, (0, parcelRequire("cEHh7")).useMediaClient)();
        const fileState = (0, (0, parcelRequire("k4CmR")).useMediaStore)((state)=>state.files[id]);
        (0, $5uXOq.useEffect)(()=>{
            if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
        }, [
            id,
            mediaClient,
            collectionName,
            occurrenceKey,
            skipRemote,
            fileState
        ]);
        return {
            fileState: fileState
        };
    }
});
parcelRegister("k4CmR", function(module, exports) {
    $parcel$export(module.exports, "useMediaStore", ()=>$a907ffa2ecfaf54d$export$8a9cc8c330400af8);
    var $6esDR;
    var $cEHh7;
    const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, (0, parcelRequire("6esDR")).useStore)(store, selector, equals);
    function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
        const mediaClient = (0, (0, parcelRequire("cEHh7")).useMediaClient)();
        const store = mediaClient.__DO_NOT_USE__getMediaStore();
        const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
        return useBoundStore(selector, equals);
    }
});
parcelRegister("6esDR", function(module, exports) {
    $parcel$export(module.exports, "useStore", ()=>$489a4492a45245b1$export$6ccbb43953eebf8);
    var $ee7sp;
    var $5uXOq = parcelRequire("5uXOq");
    var $lNQti = parcelRequire("lNQti");
    var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
        url: "file:///node_modules/zustand/esm/index.mjs"
    });
    const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, ($parcel$interopDefault($5uXOq)));
    const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, ($parcel$interopDefault($lNQti)));
    let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
    const $489a4492a45245b1$var$identity = (arg)=>arg;
    function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
        if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
            console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
            $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
        }
        const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
        $489a4492a45245b1$var$useDebugValue(slice);
        return slice;
    }
    const $489a4492a45245b1$var$createImpl = (createState)=>{
        if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
        const api = typeof createState === "function" ? (0, (0, parcelRequire("ee7sp")).createStore)(createState) : createState;
        const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
        Object.assign(useBoundStore, api);
        return useBoundStore;
    };
    const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
    var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
        if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
        return $489a4492a45245b1$export$185802fd694ee1f5(createState);
    };
});
parcelRegister("lNQti", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("hUiTL"));
});
parcelRegister("hUiTL", function(module, exports) {
    $parcel$export(module.exports, "useSyncExternalStoreWithSelector", ()=>$d096537a1780f6c5$export$bf730a2d8bf68b42, (v)=>$d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
    var $d096537a1780f6c5$export$bf730a2d8bf68b42;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    var $goz36 = parcelRequire("goz36");
    function $d096537a1780f6c5$var$p(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
    $d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
        var c = $d096537a1780f6c5$var$t(null);
        if (null === c.current) {
            var f = {
                hasValue: !1,
                value: null
            };
            c.current = f;
        } else f = c.current;
        c = $d096537a1780f6c5$var$v(function() {
            function a(a) {
                if (!c) {
                    c = !0;
                    d = a;
                    a = l(a);
                    if (void 0 !== g && f.hasValue) {
                        var b = f.value;
                        if (g(b, a)) return k = b;
                    }
                    return k = a;
                }
                b = k;
                if ($d096537a1780f6c5$var$q(d, a)) return b;
                var e = l(a);
                if (void 0 !== g && g(b, e)) return b;
                d = a;
                return k = e;
            }
            var c = !1, d, k, m = void 0 === e ? null : e;
            return [
                function() {
                    return a(b());
                },
                null === m ? void 0 : function() {
                    return a(m());
                }
            ];
        }, [
            b,
            e,
            l,
            g
        ]);
        var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
        $d096537a1780f6c5$var$u(function() {
            f.hasValue = !0;
            f.value = d;
        }, [
            d
        ]);
        $d096537a1780f6c5$var$w(d);
        return d;
    };
});
parcelRegister("goz36", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("jcmQl"));
});
parcelRegister("jcmQl", function(module, exports) {
    $parcel$export(module.exports, "useSyncExternalStore", ()=>$dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v)=>$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
    var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
    'use strict';
    var $5uXOq = parcelRequire("5uXOq");
    function $dfa0db7ec3fca60b$var$h(a, b) {
        return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }
    var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
    function $dfa0db7ec3fca60b$var$q(a, b) {
        var d = b(), f = $dfa0db7ec3fca60b$var$l({
            inst: {
                value: d,
                getSnapshot: b
            }
        }), c = f[0].inst, g = f[1];
        $dfa0db7ec3fca60b$var$n(function() {
            c.value = d;
            c.getSnapshot = b;
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        }, [
            a,
            d,
            b
        ]);
        $dfa0db7ec3fca60b$var$m(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
            return a(function() {
                $dfa0db7ec3fca60b$var$r(c) && g({
                    inst: c
                });
            });
        }, [
            a
        ]);
        $dfa0db7ec3fca60b$var$p(d);
        return d;
    }
    function $dfa0db7ec3fca60b$var$r(a) {
        var b = a.getSnapshot;
        a = a.value;
        try {
            var d = b();
            return !$dfa0db7ec3fca60b$var$k(a, d);
        } catch (f) {
            return !0;
        }
    }
    function $dfa0db7ec3fca60b$var$t(a, b) {
        return b();
    }
    var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
    $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;
});
parcelRegister("kGpuq", function(module, exports) {
    $parcel$export(module.exports, "extractErrorInfo", ()=>$d93d75d54376e990$export$74aaf4784c2edb2c);
    $parcel$export(module.exports, "createFailedSSRObject", ()=>$d93d75d54376e990$export$768c370ed0dbaeb3);
    var $loYHr;
    var $1As4I;
    var $fVF5e;
    var $01sWe;
    const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
        if ((0, (0, parcelRequire("01sWe")).isMediaFilePreviewError)(error) && !!error.secondaryError) {
            if ((0, (0, parcelRequire("1As4I")).isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
            else if ((0, (0, parcelRequire("fVF5e")).isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
        }
    };
    const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
        if ((0, (0, parcelRequire("01sWe")).isMediaFilePreviewError)(error)) return error.primaryReason;
        else return 'nativeError';
    };
    const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
        if ((0, (0, parcelRequire("01sWe")).isMediaFilePreviewError)(error) && error.secondaryError) {
            const mediaClientReason = (0, (0, parcelRequire("loYHr")).isMediaClientError)(error.secondaryError) ? (0, (0, parcelRequire("loYHr")).getMediaClientErrorReason)(error.secondaryError) : (0, (0, parcelRequire("fVF5e")).getFileStateErrorReason)(error.secondaryError);
            if (mediaClientReason !== 'unknown') return mediaClientReason;
        }
        return 'nativeError';
    };
    const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
        if ((0, (0, parcelRequire("01sWe")).isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
        else return error.message;
    };
    const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
        return {
            failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
            error: $d93d75d54376e990$export$88c61dcad53762da(error),
            errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
            metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
        };
    };
    const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
            status: 'fail',
            ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, (0, parcelRequire("01sWe")).ImageLoadError)(preview.source), metadataTraceContext)
        });
});
parcelRegister("fVF5e", function(module, exports) {
    $parcel$export(module.exports, "MediaFileStateError", ()=>$2e194af23ca6b4a5$export$38242da09b559a);
    $parcel$export(module.exports, "isMediaFileStateError", ()=>$2e194af23ca6b4a5$export$166a250c03366459);
    $parcel$export(module.exports, "getFileStateErrorReason", ()=>$2e194af23ca6b4a5$export$2e87e6d20b09376d);
    class $2e194af23ca6b4a5$export$38242da09b559a extends Error {
        constructor(id, reason, message = '', details){
            super(reason), this.id = id, this.reason = reason, this.message = message, this.details = details;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
    function $2e194af23ca6b4a5$export$166a250c03366459(err) {
        return err instanceof Error && 'id' in err;
    }
    function $2e194af23ca6b4a5$export$2e87e6d20b09376d(err) {
        return $2e194af23ca6b4a5$export$166a250c03366459(err) ? err.details?.reason : 'unknown';
    }
});
parcelRegister("01sWe", function(module, exports) {
    $parcel$export(module.exports, "MediaFilePreviewError", ()=>$fcceba16863dd854$export$96e559194c287cf4);
    $parcel$export(module.exports, "LocalPreviewError", ()=>$fcceba16863dd854$export$2c035820a31723e);
    $parcel$export(module.exports, "RemotePreviewError", ()=>$fcceba16863dd854$export$10ab445310d30114);
    $parcel$export(module.exports, "SsrPreviewError", ()=>$fcceba16863dd854$export$18e89b7e50818288);
    $parcel$export(module.exports, "ImageLoadError", ()=>$fcceba16863dd854$export$d0a45ab59b4606b);
    $parcel$export(module.exports, "isMediaFilePreviewError", ()=>$fcceba16863dd854$export$553696a6e769784c);
    $parcel$export(module.exports, "ensureMediaFilePreviewError", ()=>$fcceba16863dd854$export$7156ce7b78b49bd7);
    class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
        constructor(primaryReason, secondaryError){
            super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
            Object.setPrototypeOf(this, new.target.prototype);
            if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
        }
    }
    class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
        constructor(primaryReason, secondaryError){
            super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        }
    }
    class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
        constructor(primaryReason, secondaryError){
            super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        }
    }
    class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
        constructor(primaryReason, secondaryError){
            super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        }
    }
    const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
        switch(source){
            case 'cache-remote':
                return 'cache-remote-uri';
            case 'cache-local':
                return 'cache-local-uri';
            case 'external':
                return 'external-uri';
            case 'local':
                return 'local-uri';
            case 'remote':
                return 'remote-uri';
            case 'ssr-client':
                return 'ssr-client-uri';
            case 'ssr-server':
            case 'ssr-data':
                return 'ssr-server-uri';
            default:
                return `unknown-uri`;
        }
    };
    class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
        constructor(source){
            super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
        }
    }
    function $fcceba16863dd854$export$553696a6e769784c(err) {
        return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
    }
    const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
    const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
    const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
    const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
        if ($fcceba16863dd854$export$553696a6e769784c(error)) {
            if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
            return error;
        }
        return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
    };
});
parcelRegister("3JWNV", function(module, exports) {
    $parcel$export(module.exports, "getSSRPreview", ()=>$609060e8f7210c63$export$faf1c301c59a1bdc);
    $parcel$export(module.exports, "isLocalPreview", ()=>$609060e8f7210c63$export$78ad02c5efc361c9);
    $parcel$export(module.exports, "isRemotePreview", ()=>$609060e8f7210c63$export$87442a14a8a19e0);
    $parcel$export(module.exports, "isSSRClientPreview", ()=>$609060e8f7210c63$export$36aae1afbc0a9661);
    $parcel$export(module.exports, "isSSRDataPreview", ()=>$609060e8f7210c63$export$f366c2c8a792cce6);
    $parcel$export(module.exports, "isSSRPreview", ()=>$609060e8f7210c63$export$dea79d05143ccf4);
    $parcel$export(module.exports, "getAndCacheRemotePreview", ()=>$609060e8f7210c63$export$49721bcc26fb9388);
    $parcel$export(module.exports, "getAndCacheLocalPreview", ()=>$609060e8f7210c63$export$98e935d981c884d);
    var $9KG2L;
    var $01sWe;
    var $7xRaJ;
    var $4n1NZ;
    const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
        let source;
        switch(preview.source){
            case 'local':
                source = 'cache-local';
                break;
            case 'remote':
                source = 'cache-remote';
                break;
            default:
                source = preview.source;
        }
        const dataURI = mediaBlobUrlAttrs ? (0, (0, parcelRequire("9KG2L")).addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
        (0, (0, parcelRequire("7xRaJ")).mediaFilePreviewCache).set(id, mode, {
            ...preview,
            source: source,
            dataURI: dataURI
        });
        return {
            ...preview,
            dataURI: dataURI
        };
    };
    const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
        let dataURI;
        try {
            const rawDataURI = mediaClient.getImageUrlSync(id, params);
            dataURI = mediaBlobUrlAttrs ? (0, (0, parcelRequire("9KG2L")).addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
            const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
            return {
                dataURI: dataURI,
                source: source,
                orientation: 1
            };
        } catch (e) {
            const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
            throw new (0, (0, parcelRequire("01sWe")).SsrPreviewError)(reason, e instanceof Error ? e : undefined);
        }
    };
    const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
        const localSources = [
            'local',
            'cache-local'
        ];
        return localSources.includes(preview.source);
    };
    const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
        const remoteSources = [
            'remote',
            'cache-remote'
        ];
        return remoteSources.includes(preview.source);
    };
    const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
    const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
    const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
        const ssrClientSources = [
            'ssr-client',
            'ssr-server',
            'ssr-data'
        ];
        return ssrClientSources.includes(preview.source);
    };
    const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
        const remotePreview = await (0, (0, parcelRequire("4n1NZ")).getRemotePreview)(mediaClient, id, params, traceContext);
        return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
            ...remotePreview,
            dimensions: dimensions
        }, mediaBlobUrlAttrs);
    };
    const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
        const localPreview = await (0, (0, parcelRequire("4n1NZ")).getLocalPreview)(filePreview);
        return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
            ...localPreview,
            dimensions: dimensions
        }, mediaBlobUrlAttrs);
    };
});
parcelRegister("9KG2L", function(module, exports) {
    $parcel$export(module.exports, "isMediaBlobUrl", ()=>$3193ea5c2295e37f$export$e1e8ad57ada2d90);
    $parcel$export(module.exports, "getAttrsFromUrl", ()=>$3193ea5c2295e37f$export$b91a9e94ff0cbb29);
    $parcel$export(module.exports, "addFileAttrsToUrl", ()=>$3193ea5c2295e37f$export$e51a8146182600b8);
    const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
    const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
        return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
    };
    const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
        const value = params.get(name);
        return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
    };
    const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
        const value = params.get(name);
        if (!value) return;
        return decodeURIComponent(value);
    };
    const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
        const url = new URL(blobUrl);
        const hash = url.hash.replace('#', '');
        const params = new URLSearchParams(hash);
        const id = params.get('id');
        const contextId = params.get('contextId');
        if (!id || !contextId) return;
        return {
            id: id,
            contextId: contextId,
            collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
            alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
            height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
            width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
            size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
            name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
            mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
        };
    };
    const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
        return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
            const value = json[key];
            if (typeof value === 'undefined' || value === null) return;
            return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
        }).join('&');
    };
    const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) return url;
        const mediaIdentifierAttr = {
            [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
        };
        const mergedAttrs = {
            ...mediaIdentifierAttr,
            ...fileAttrs
        };
        const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
        return `${url}#${queryAttrs}`;
    };
});
parcelRegister("7xRaJ", function(module, exports) {
    $parcel$export(module.exports, "mediaFilePreviewCache", ()=>$abbc266dbfedc514$export$b7e8ee3f7a41459);
    var $aAIop;
    const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
        const resizeMode = mode || 'crop';
        return [
            id,
            resizeMode
        ].join('-');
    };
    class $abbc266dbfedc514$export$7b50526c091bb915 {
        constructor(previewCache){
            this.previewCache = previewCache;
            this.get = (id, mode)=>{
                const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
                return this.previewCache.get(cacheKey);
            };
            this.set = (id, mode, cardPreview)=>{
                const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
                this.previewCache.set(cacheKey, cardPreview);
            };
            this.remove = (id, mode)=>{
                const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
                this.previewCache.remove(cacheKey);
            };
            this.clear = ()=>{
                this.previewCache.clear();
            };
        }
    }
    const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, (0, parcelRequire("aAIop")).createObjectURLCache)());
});
parcelRegister("aAIop", function(module, exports) {
    $parcel$export(module.exports, "createObjectURLCache", ()=>$0cfc22aea6c15367$export$ba71be67d5c32535);
    var $7n9mn = parcelRequire("7n9mn");
    var $iwKVT = parcelRequire("iwKVT");
    const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
    class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
        constructor(limit){
            super(limit);
            this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
        }
        shift() {
            const entry = super.shift();
            this.eventEmitter.emit('shift', entry);
            return entry;
        }
        on(event, callback) {
            this.eventEmitter.on(event, callback);
        }
    }
    class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
        constructor(size){
            this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
            this.cache.on('shift', (entry)=>{
                if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
            });
        }
        has(key) {
            return !!this.cache.find(key);
        }
        get(key) {
            return this.cache.get(key);
        }
        set(key, value) {
            this.cache.set(key, value);
        }
        remove(key) {
            const removed = this.cache.delete(key);
            removed && URL.revokeObjectURL(removed.dataURI);
        }
        clear() {
            this.cache.clear();
        }
    }
    const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);
});
parcelRegister("4n1NZ", function(module, exports) {
    $parcel$export(module.exports, "isSupportedLocalPreview", ()=>$3b75ec6170865ae7$export$1fa85b75e8662d54);
    $parcel$export(module.exports, "getLocalPreview", ()=>$3b75ec6170865ae7$export$3d6ed68e437b8c99);
    $parcel$export(module.exports, "getRemotePreview", ()=>$3b75ec6170865ae7$export$bfe20bd01db02b3);
    var $jzW7G;
    var $48aIR;
    var $01sWe;
    var $Nl5sY;
    const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
    const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
        try {
            const orientation = await (0, (0, parcelRequire("48aIR")).getOrientation)(value);
            const dataURI = URL.createObjectURL(value);
            return {
                dataURI: dataURI,
                orientation: orientation,
                source: 'local'
            };
        } catch (e) {
            throw new (0, (0, parcelRequire("01sWe")).LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
        }
    };
    const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
        try {
            const dataURI = await (0, (0, parcelRequire("Nl5sY")).takeSnapshot)(value);
            return {
                dataURI: dataURI,
                orientation: 1,
                source: 'local'
            };
        } catch (e) {
            throw new (0, (0, parcelRequire("01sWe")).LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
        }
    };
    const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
        let value;
        try {
            const resolvedFilePreview = await filePreview;
            value = resolvedFilePreview.value;
        } catch (e) {
            throw new (0, (0, parcelRequire("01sWe")).LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
        }
        if (typeof value === 'string') return {
            dataURI: value,
            orientation: 1,
            source: 'local'
        };
        else if (value instanceof Blob) {
            const { type: type } = value;
            const mediaType = (0, (0, parcelRequire("jzW7G")).getMediaTypeFromMimeType)(type);
            switch(mediaType){
                case 'image':
                    return $3b75ec6170865ae7$var$getImageLocalPreview(value);
                case 'video':
                    return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
                default:
                    throw new (0, (0, parcelRequire("01sWe")).LocalPreviewError)('local-preview-unsupported');
            }
        }
        throw new (0, (0, parcelRequire("01sWe")).LocalPreviewError)('local-preview-unsupported');
    };
    const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
        try {
            const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
            return {
                dataURI: URL.createObjectURL(blob),
                orientation: 1,
                source: 'remote'
            };
        } catch (e) {
            throw new (0, (0, parcelRequire("01sWe")).RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
        }
    };
});
parcelRegister("48aIR", function(module, exports) {
    $parcel$export(module.exports, "getImageInfo", ()=>$93f6c931eebc2be3$export$2176b0e68c10508f);
    $parcel$export(module.exports, "getOrientation", ()=>$93f6c931eebc2be3$export$67689507e8404821);
    var $k9Ch0;
    var $5m9mt;
    var $1xbJn;
    var $hNjKA;
    const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, (0, parcelRequire("k9Ch0")).SupportedImageMetaTag);
    const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
    async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
        const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
        if (!metadata) return null;
        const { width: width, height: height, tags: tags } = metadata;
        const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
        return {
            scaleFactor: scaleFactor,
            width: width,
            height: height
        };
    }
    function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
        const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
        if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
        else if (tags) {
            if (typeof tags['PixelPerUnitX'] === 'number') return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
            else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        } else return 1;
    }
    const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
        if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
            const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
            if (tagValue) {
                const numericValue = parseInt(tagValue, 10);
                if (isNaN(numericValue)) return (0, (0, parcelRequire("k9Ch0")).ExifOrientation)[tagValue];
                return numericValue;
            }
        }
        return 1;
    };
    async function $93f6c931eebc2be3$export$67689507e8404821(file) {
        const tags = await (0, (0, parcelRequire("5m9mt")).readImageMetaTags)(file);
        return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
    }
    function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
        try {
            const num = parseFloat(`${tags[key]}`);
            if (!isNaN(num)) return num;
        } catch (e) {}
        return defaultValue;
    }
    function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
        try {
            const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
            if (match) return parseFloat(match[1]);
        } catch (e) {}
        return null;
    }
    async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
        const { file: file, src: src } = fileInfo;
        const type = file.type;
        let width = 0;
        let height = 0;
        const tags = await (0, (0, parcelRequire("5m9mt")).readImageMetaTags)(file);
        if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
        if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
        const data = {
            type: type,
            width: width,
            height: height,
            naturalWidth: width,
            naturalHeight: height,
            tags: tags
        };
        try {
            const img = await (0, (0, parcelRequire("1xbJn")).loadImage)(src);
            const { width: width, height: height } = (0, (0, parcelRequire("1xbJn")).readImageNaturalOrientationFromDOM)(img);
            data.width = width;
            data.height = height;
            data.naturalWidth = img.naturalWidth;
            data.naturalHeight = img.naturalHeight;
        } catch (e) {
            return null;
        }
        return data;
    }
});
parcelRegister("k9Ch0", function(module, exports) {
    $parcel$export(module.exports, "ImageType", ()=>$8ba626f637ae3df3$export$48c85e6e32ef0825);
    $parcel$export(module.exports, "SupportedImageMetaTag", ()=>$8ba626f637ae3df3$export$e369bb48cf33e564);
    $parcel$export(module.exports, "ExifOrientation", ()=>$8ba626f637ae3df3$export$f6ea0c89fd7d156);
    var $8ba626f637ae3df3$export$48c85e6e32ef0825;
    (function(ImageType) {
        ImageType["JPEG"] = "image/jpeg";
        ImageType["PNG"] = "image/png";
    })($8ba626f637ae3df3$export$48c85e6e32ef0825 || ($8ba626f637ae3df3$export$48c85e6e32ef0825 = {}));
    var $8ba626f637ae3df3$export$e369bb48cf33e564;
    (function(SupportedImageMetaTag) {
        SupportedImageMetaTag["XResolution"] = "XResolution";
        SupportedImageMetaTag["YResolution"] = "YResolution";
        SupportedImageMetaTag["Orientation"] = "Orientation";
    })($8ba626f637ae3df3$export$e369bb48cf33e564 || ($8ba626f637ae3df3$export$e369bb48cf33e564 = {}));
    const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
        'top-left': 1,
        'top-right': 2,
        'bottom-right': 3,
        'bottom-left': 4,
        'left-top': 5,
        'right-top': 6,
        'right-bottom': 7,
        'left-bottom': 8
    };
});
parcelRegister("5m9mt", function(module, exports) {
    $parcel$export(module.exports, "readImageMetaTags", ()=>$6da5c9a89db4de84$export$41982b5c7acb23c4);
    var $k9Ch0;
    var $jkveD;
    var $kINoG;
    var $2edT6;
    async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
        const type = file.type;
        try {
            if (type === (0, (0, parcelRequire("k9Ch0")).ImageType).PNG) {
                const { iTXt: iTXt, pHYs: pHYs } = await (0, (0, parcelRequire("kINoG")).readPNGXMPMetaData)(file);
                const xmpMetaData = {
                    ...(0, (0, parcelRequire("2edT6")).parseXMPMetaData)(iTXt),
                    ...pHYs
                };
                return xmpMetaData;
            } else if (file.type === (0, (0, parcelRequire("k9Ch0")).ImageType).JPEG) return await (0, (0, parcelRequire("jkveD")).readJPEGExifMetaData)(file);
        } catch (e) {}
        return null;
    }
});
parcelRegister("jkveD", function(module, exports) {
    $parcel$export(module.exports, "readJPEGExifMetaData", ()=>$537aa8dc852a8555$export$556b2ccec62d7f2a);
    var $k9Ch0;
    const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, (0, parcelRequire("k9Ch0")).SupportedImageMetaTag);
    let $537aa8dc852a8555$var$loadImage;
    function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
        return new Promise(async (resolve, reject)=>{
            if (!$537aa8dc852a8555$var$loadImage) {
                const module = await (parcelRequire("kFwqQ"));
                $537aa8dc852a8555$var$loadImage = module.default || module;
            }
            $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
                try {
                    const tags = data && data.exif ? data.exif.getAll() : {};
                    Object.keys(tags).forEach((key)=>{
                        const value = tags[key];
                        if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) tags[key] = value.numerator;
                        if (typeof tags[key] === 'number') tags[key] = `${tags[key]}`;
                    });
                    resolve(tags);
                } catch (e) {
                    reject(e);
                }
            });
        });
    }
});
parcelRegister("kFwqQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7lJbN").then(()=>parcelRequire('8aLn9'));
});
parcelRegister("kINoG", function(module, exports) {
    $parcel$export(module.exports, "readPNGXMPMetaData", ()=>$013315ab2d0cc3cf$export$5fb37736440fca6f);
    var $1xbJn;
    let $013315ab2d0cc3cf$var$pngChunksExtract;
    async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
        if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
            const module = await (parcelRequire("yWJlB"));
            $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
        }
        const buffer = await (0, (0, parcelRequire("1xbJn")).fileToArrayBuffer)(file);
        const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
        return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
    }
    async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
        let iTXt = '';
        let pHYs = {};
        for(let i = 0; i < chunks.length; ++i){
            const chunk = chunks[i];
            if (chunk.name === 'IEND') break;
            if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
            if (chunk.name === 'pHYs') {
                const dv = new DataView(chunk.data.buffer);
                const unitSpecifier = dv.getUint8(8);
                if (unitSpecifier === 1) {
                    const PixelPerUnitX = dv.getUint32(0);
                    const PixelPerUnitY = dv.getUint32(4);
                    pHYs = {
                        PixelPerUnitX: PixelPerUnitX,
                        PixelPerUnitY: PixelPerUnitY
                    };
                }
            }
        }
        return {
            iTXt: iTXt,
            pHYs: pHYs
        };
    }
});
parcelRegister("1xbJn", function(module, exports) {
    $parcel$export(module.exports, "dataURItoFile", ()=>$3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
    $parcel$export(module.exports, "fileToDataURI", ()=>$3c9a3ebb8ee397f0$export$849633012686f7ee);
    $parcel$export(module.exports, "getFileInfo", ()=>$3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
    $parcel$export(module.exports, "fileToArrayBuffer", ()=>$3c9a3ebb8ee397f0$export$956310555b96755a);
    $parcel$export(module.exports, "loadImage", ()=>$3c9a3ebb8ee397f0$export$fe58198efe02b173);
    $parcel$export(module.exports, "readImageNaturalOrientationFromDOM", ()=>$3c9a3ebb8ee397f0$export$325d46491952db2d);
    $parcel$export(module.exports, "findParentByClassname", ()=>$3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
    $parcel$export(module.exports, "getMimeIcon", ()=>$3c9a3ebb8ee397f0$export$61a1de0822e2820);
    var $2tm8x;
    var $RiK2l;
    var $cHwqN;
    var $2sfBf;
    var $iABw2;
    var $7hpMa;
    var $dGYEZ;
    var $iBOon;
    var $jdlqN;
    var $c70Lr;
    var $2osAJ;
    var $7zjHG;
    var $8SPcB;
    var $es8mD;
    var $gYsK7;
    var $8RqHP;
    function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
        if (dataURI.length === 0) throw new Error('dataURI not found');
        const dataURIParts = dataURI.split(',');
        const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
        let mimeString;
        try {
            mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        } catch (e) {
            mimeString = 'application/octet-stream';
        }
        const intArray = new Uint8Array(byteString.length);
        for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
        const blob = new Blob([
            intArray
        ], {
            type: mimeString
        });
        try {
            return new File([
                blob
            ], filename, {
                type: mimeString
            });
        } catch (e) {
            const ie11File = blob;
            const date = new Date();
            ie11File.lastModified = date.getTime();
            ie11File.lastModifiedDate = date;
            ie11File.name = filename;
            ie11File.webkitRelativePath = '';
            return ie11File;
        }
    }
    function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.addEventListener('load', ()=>{
                const result = reader.result;
                if (typeof result === 'string') resolve(result);
                else if (result === null) reject();
            });
            reader.addEventListener('error', reject);
            reader.readAsDataURL(blob);
        });
    }
    async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
        return {
            file: file,
            src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
        };
    }
    async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
        return {
            file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
            src: src
        };
    }
    function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            reader.addEventListener('load', ()=>{
                const array = new Uint8Array(reader.result);
                resolve(array);
            });
            reader.addEventListener('error', reject);
            reader.readAsArrayBuffer(file);
        });
    }
    function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.src = src;
            img.onload = ()=>{
                resolve(img);
            };
            img.onerror = reject;
        });
    }
    function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
        img.style.position = 'absolute';
        img.style.visibility = 'hidden';
        document.body.appendChild(img);
        const { width: width, height: height } = img.getBoundingClientRect();
        document.body.removeChild(img);
        return {
            width: width,
            height: height
        };
    }
    const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
        if (element.classList.contains(className)) return element;
        let currentElement = element;
        while(currentElement.parentElement !== maxParentElement){
            if (currentElement.parentElement) {
                currentElement = currentElement.parentElement;
                if (currentElement.classList.contains(className)) return currentElement;
            } else return undefined;
        }
        return undefined;
    };
    const $3c9a3ebb8ee397f0$var$mimeTypes = [
        {
            label: 'pdf',
            mimeTypes: [
                'application/pdf'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2tm8x")))))
        },
        {
            label: 'google-form',
            mimeTypes: [
                'application/vnd.google-apps.form'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jdlqN")))))
        },
        {
            label: 'google-slides',
            mimeTypes: [
                'application/vnd.google-apps.presentation'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2osAJ")))))
        },
        {
            label: 'google-form',
            mimeTypes: [
                'application/vnd.google-apps.form'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jdlqN")))))
        },
        {
            label: 'google-sheets',
            mimeTypes: [
                'application/vnd.google-apps.spreadsheet'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("c70Lr")))))
        },
        {
            label: 'google-docs',
            mimeTypes: [
                'application/vnd.google-apps.document',
                'application/vnd.google-apps.kix'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iBOon")))))
        },
        {
            label: 'microsoft-word',
            mimeTypes: [
                'application/msword',
                'application/vnd.openxmlformats-officedocument.word'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2sfBf")))))
        },
        {
            label: 'presentation',
            mimeTypes: [
                'application/x-iwork-keynote-sffkey',
                'application/vnd.oasis.opendocument.presentation'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("es8mD")))))
        },
        {
            label: 'powerpoint-presentation',
            mimeTypes: [
                'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                'application/vnd.ms-powerpoint'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("cHwqN")))))
        },
        {
            label: 'giphy',
            mimeTypes: [
                'image/gif'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("RiK2l")))))
        },
        {
            label: 'spreadsheet',
            mimeTypes: [
                'text/csv'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("8SPcB")))))
        },
        {
            label: 'excel-spreadsheet',
            mimeTypes: [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'application/x-iwork-keynote-sffnumbers'
            ],
            icon: (0, ($parcel$interopDefault((0, parcelRequire("7zjHG")))))
        }
    ];
    function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
        const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
        if (iconInfo) return iconInfo;
        if ((0, (0, parcelRequire("8RqHP")).isCodeViewerItem)(fileName, mimeType)) return {
            label: 'source-code',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("gYsK7")))))
        };
        if (fileName.match(/.*\.sketch$/)) return {
            label: 'sketch',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iABw2")))))
        };
        if (fileName.match(/.*\.fig$/)) return {
            label: 'figma',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("7hpMa")))))
        };
        if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
            label: 'executable',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("dGYEZ")))))
        };
        return undefined;
    }
});
parcelRegister("2tm8x", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $1ccf7616b127308b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>$1ccf7616b127308b$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
    var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;
});
parcelRegister("RiK2l", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0a037d07967bfa4f$var$Gif24Icon = (props)=>$0a037d07967bfa4f$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
    var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;
});
parcelRegister("cHwqN", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $93f2a85309224bbe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>$93f2a85309224bbe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
    var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;
});
parcelRegister("2sfBf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>$1c9a4c12d2fc4227$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
    var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;
});
parcelRegister("iABw2", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $d888b0a1557aa645$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d888b0a1557aa645$var$Sketch24Icon = (props)=>$d888b0a1557aa645$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
    var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;
});
parcelRegister("7hpMa", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>$54ce1d7bd56eb231$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
    var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;
});
parcelRegister("dGYEZ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9f7e406d5bea49df$var$Executable24Icon = (props)=>$9f7e406d5bea49df$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
    var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;
});
parcelRegister("iBOon", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>$d8c2c58dddf5fcc0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
    var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;
});
parcelRegister("jdlqN", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>$dfcfdb061c664b77$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
    var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;
});
parcelRegister("c70Lr", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $8d16bb363c31083e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>$8d16bb363c31083e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
    var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;
});
parcelRegister("2osAJ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $1be4005185ae78d9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>$1be4005185ae78d9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
    var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;
});
parcelRegister("7zjHG", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $582b1603b710ea90$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>$582b1603b710ea90$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
    var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;
});
parcelRegister("8SPcB", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $677b15938c7d624c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>$677b15938c7d624c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
    var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;
});
parcelRegister("es8mD", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>$a85a2b23143ceb75$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
    var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;
});
parcelRegister("gYsK7", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $c5b88baa981b1084$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>$c5b88baa981b1084$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
        }, props, {
            size: 'medium'
        }));
    $c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
    var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;
});
parcelRegister("8RqHP", function(module, exports) {
    $parcel$export(module.exports, "getExtension", ()=>$60b93921782d6d1e$export$78d71f9ed5534abe);
    $parcel$export(module.exports, "isCodeViewerItem", ()=>$60b93921782d6d1e$export$bb139b46f345ca28);
    $parcel$export(module.exports, "getLanguageType", ()=>$60b93921782d6d1e$export$ba4368c844580f9e);
    function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
        if (filename.indexOf('.') > -1) return filename.split('.').pop();
        return '';
    }
    const $60b93921782d6d1e$var$codeViewerMimeTypes = [
        {
            mimetype: 'application/json',
            language: 'json'
        },
        {
            mimetype: 'text/html',
            language: 'html'
        }
    ];
    function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
        return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
    }
    function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
        if (mimetype) {
            const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
            if (languageForMimeType) return languageForMimeType.language;
        }
        const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
        switch(ext){
            case 'abap':
            case 'ada':
            case 'c':
            case 'css':
            case 'd':
            case 'dart':
            case 'go':
            case 'graphql':
            case 'groovy':
            case 'html':
            case 'java':
            case 'json':
            case 'matlab':
            case 'xml':
            case 'lua':
            case 'puppet':
            case 'qml':
            case 'sass':
            case 'sql':
            case 'php':
            case 'r':
            case 'swift':
            case 'tcl':
            case 'vala':
            case 'vhdl':
            case 'xquery':
                return ext;
            case 'as':
            case 'asc':
                return 'actionscript';
            case 'ino':
                return 'arduino';
            case 'au3':
                return 'autoit';
            case 'cpp':
            case 'h':
            case 'c++':
                return 'c++';
            case 'coffee':
                return 'coffeescript';
            case 'cs':
                return 'csharp';
            case 'cu':
                return 'cuda';
            case 'pas':
            case 'dpr':
            case 'dproj':
            case 'dpk':
                return 'delphi';
            case 'ex':
            case 'exs':
                return 'elixir';
            case 'erl':
            case 'hrl':
                return 'erlang';
            case 'f90':
            case 'for':
            case 'f':
            case 'fpp':
            case 'i':
            case 'i90':
            case 'ftn':
                return 'fortran';
            case 'dbc':
                return 'foxpro';
            case 'hs':
            case 'has':
                return 'haskell';
            case 'hx':
                return 'haxe';
            case 'js':
            case 'jsx':
                return 'javascript';
            case 'jl':
                return 'julia';
            case 'kt':
                return 'kotlin';
            case 'm':
            case 'mm':
                return 'objective-c';
            case 'j':
                return 'objective-j';
            case 'tex':
                return 'latex';
            case 'nb':
            case 'cdf':
                return 'mathematica';
            case 'cma':
                return 'ocaml';
            case 'pl':
                return 'perl';
            case 'py':
                return 'python';
            case 'ps1':
            case 'psd1':
            case 'psm1':
                return 'powershell';
            case 'rb':
                return 'ruby';
            case 'rst':
                return 'restructuredtext';
            case 'rs':
                return 'rust';
            case 'rkt':
                return 'racket';
            case 'sh':
                return 'shell';
            case 'sc':
            case 'sch':
                return 'scheme';
            case 'txt':
            case 'msg':
            case 'log':
            case 'csv':
            case 'md':
                return 'text';
            case 'ts':
            case 'tsx':
                return 'typescript';
            case 'v':
                return 'verilog';
            case 'xq':
            case 'xql':
            case 'xqm':
            case 'xqy':
                return 'xquery';
            case 'lock':
            case 'yaml':
            case 'yml':
                return 'yaml';
            default:
                return null;
        }
    }
});
parcelRegister("yWJlB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jODAF").then(()=>parcelRequire('eYIux'));
});
parcelRegister("2edT6", function(module, exports) {
    $parcel$export(module.exports, "parseXMPMetaData", ()=>$1cac606283e05089$export$55c3bc9841b19de2);
    function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
        const metadata = {};
        const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
        if (tags) tags.forEach((tag)=>{
            const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
            if (match) {
                const name = match[2];
                metadata[name] = match[3];
            }
        });
        return metadata;
    }
});
parcelRegister("hNjKA", function(module, exports) {
    $parcel$export(module.exports, "isRotated", ()=>$81d3fceca65be0fc$export$8af433705f41088f);
    $parcel$export(module.exports, "getCssFromImageOrientation", ()=>$81d3fceca65be0fc$export$43142f95b8de7a91);
    const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
        1: 'none',
        2: 'rotateY(180deg)',
        3: 'rotate(180deg)',
        4: 'rotate(180deg) rotateY(180deg)',
        5: 'rotate(270deg) rotateY(180deg)',
        6: 'rotate(90deg)',
        7: 'rotate(90deg) rotateY(180deg)',
        8: 'rotate(270deg)'
    };
    const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
    const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
        return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
    };
});
parcelRegister("Nl5sY", function(module, exports) {
    $parcel$export(module.exports, "takeSnapshot", ()=>$33ec34d1173165de$export$4269d30173168e5c);
    const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
        return new Promise((resolve, reject)=>{
            const url = URL.createObjectURL(blob);
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.src = url;
            video.muted = true;
            video.play().catch(()=>{
                return reject(new Error('failed to play video'));
            });
            video.addEventListener('timeupdate', function timeUpdateHandler() {
                video.removeEventListener('timeupdate', timeUpdateHandler);
                video.pause();
                URL.revokeObjectURL(url);
                if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const context = canvas.getContext('2d');
                if (!context) return reject(new Error('error creating canvas context'));
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
                const dataURL = canvas.toDataURL('image/jpeg', 0.85);
                resolve(dataURL);
            });
            video.addEventListener('error', ()=>{
                reject(new Error('failed to load video'));
                URL.revokeObjectURL(url);
            });
        });
    };
});
parcelRegister("3JZCV", function(module, exports) {
    $parcel$export(module.exports, "getMediaCardSSR", ()=>$293d53ca8ea6912a$export$ede93d4564eaa8da);
    $parcel$export(module.exports, "getKey", ()=>$293d53ca8ea6912a$export$a47fb462a08de82f);
    $parcel$export(module.exports, "generateScriptProps", ()=>$293d53ca8ea6912a$export$de7c49925e44d75d);
    var $1QRxp;
    const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
    const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
    function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
        const namespace = '__MEDIA_INTERNAL';
        if (!globalScope[namespace]) globalScope[namespace] = {};
        return globalScope[namespace];
    }
    function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
        const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
        const key = 'mediaCardSsr';
        if (!globalMedia[key]) globalMedia[key] = {};
        return globalMedia[key];
    }
    const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
    const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
    const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
        const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
        mediaCardSsr[key] = {
            dataURI: dataURI,
            dimensions: dimensions,
            error: error
        };
    };
    const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
        const functionCall = (0, (0, parcelRequire("1QRxp")).printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
        return (0, (0, parcelRequire("1QRxp")).printScript)([
            $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
            $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
            functionCall
        ]);
    };
    const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
            dangerouslySetInnerHTML: {
                __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
            }
        });
});
parcelRegister("1QRxp", function(module, exports) {
    $parcel$export(module.exports, "printFunctionCall", ()=>$56ce1649d25a132b$export$3742967cc82ac85a);
    $parcel$export(module.exports, "printScript", ()=>$56ce1649d25a132b$export$8b902fb69a2f17c1);
    const $56ce1649d25a132b$var$printParam = (param)=>{
        if (typeof param === 'string') return `'${param}'`;
        else if (typeof param === 'object') return JSON.stringify(param);
        else if (param === undefined) return 'undefined';
        return param;
    };
    const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
    const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
    const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;
});
parcelRegister("jR4hE", function(module, exports) {
    $parcel$export(module.exports, "getSSRData", ()=>$815e3e27cebcb154$export$d3a890b0f7844b6f);
    var $3JZCV;
    const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
        const mediaCardSsr = (0, (0, parcelRequire("3JZCV")).getMediaCardSSR)();
        if (!mediaCardSsr) return;
        return mediaCardSsr[(0, (0, parcelRequire("3JZCV")).getKey)(identifier)];
    };
});
parcelRegister("8Kbwv", function(module, exports) {
    $parcel$export(module.exports, "isBigger", ()=>$7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
    $parcel$export(module.exports, "createRequestDimensions", ()=>$7b6d905fc3b6f0e9$export$3063221e86a58f9);
    $parcel$export(module.exports, "useCurrentValueRef", ()=>$7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);
    var $5uXOq = parcelRequire("5uXOq");
    const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
        const { width: currentWidth, height: currentHeight } = current || {};
        const { width: nextWidth, height: nextHeight } = next || {};
        if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
            const nextIsWider = currentWidth < nextWidth;
            const nextIsHigher = currentHeight < nextHeight;
            return nextIsHigher || nextIsWider;
        } else return false;
    };
    function $7b6d905fc3b6f0e9$var$isRetina() {
        const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
        return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
    }
    const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
        if (!dimensions) return;
        const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
        const { width: width, height: height } = dimensions;
        const result = {};
        if (width) result.width = width * retinaFactor;
        if (height) result.height = height * retinaFactor;
        return result;
    };
    function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
        const ref = (0, $5uXOq.useRef)(value);
        ref.current = value;
        return ref;
    }
});
parcelRegister("cwlnA", function(module, exports) {
    $parcel$export(module.exports, "EditMessage", ()=>$d889bb2f85ca1ba9$export$1951eb47789629cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkuz9;
    var $hD8l9;
    const $d889bb2f85ca1ba9$export$1951eb47789629cd = (props)=>{
        const renderMessage = (message, index)=>{
            switch(message.label){
                case 'warning':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$MessageContainer, {
                        key: index
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hD8l9"))))), {
                        label: "warning",
                        primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$Message, null, message.messageContent));
                case 'info':
                    return (0, ($parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$MessageContainer, {
                        key: index
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
                        label: "info"
                    }), (0, ($parcel$interopDefault($5uXOq))).createElement($d889bb2f85ca1ba9$var$Message, null, message.messageContent));
                default:
                    return undefined;
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.messages.map(renderMessage));
    };
    const $d889bb2f85ca1ba9$var$MessageContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1thw _1e0c1txw _4cvr1h6o _11c81vlj _vwz41cnx",
                __cmplp.className
            ])
        });
    });
    const $d889bb2f85ca1ba9$var$Message = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hD8l9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cd5c8c5b40614fc0$var$_react = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cd5c8c5b40614fc0$var$_warning = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("34Rrn")));
    function $cd5c8c5b40614fc0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cd5c8c5b40614fc0$var$EditorWarningIcon = (props)=>$cd5c8c5b40614fc0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
        }, props, {
            newIcon: $cd5c8c5b40614fc0$var$_warning.default
        }));
    $cd5c8c5b40614fc0$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
    var $cd5c8c5b40614fc0$var$_default = module.exports.default = $cd5c8c5b40614fc0$var$EditorWarningIcon;
});
parcelRegister("3FZpe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61831286213bf4fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $61831286213bf4fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchPlaceholder: {
            "id": "servicedesk-cmdb-field-object-picker.search-placeholder",
            "defaultMessage": "Select or search for objects"
        },
        errorTitleCmdbAssets: {
            "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-assets",
            "defaultMessage": "Could not fetch Assets objects"
        },
        errorMessage: {
            "id": "servicedesk-cmdb-field-object-picker.error-message",
            "defaultMessage": "Please refresh the page and try again"
        },
        errorTitleCmdbFieldSearch: {
            "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-field-search",
            "defaultMessage": "We couldn't fetch any objects for this field"
        },
        errorMessageCmdbFieldSearch: {
            "id": "servicedesk-cmdb-field-object-picker.error-message-cmdb-field-search",
            "defaultMessage": "Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid."
        },
        infoSingleObjectMessage: {
            "id": "servicedesk-cmdb-field-object-picker.info-single-object-message",
            "defaultMessage": "This field can only store a single object"
        },
        warningMultipleObjectsMessage: {
            "id": "servicedesk-cmdb-field-object-picker.warning-multiple-objects-message",
            "defaultMessage": "This field is configured to store a single object. Remove some objects to save changes."
        },
        infoObjectLimitReached: {
            "id": "servicedesk-cmdb-field-object-picker.info-object-limit-reached",
            "defaultMessage": "This field can only store {objectLimit, plural, one {# object} other {# objects}}."
        },
        warningObjectLimitExceeded: {
            "id": "servicedesk-cmdb-field-object-picker.warning-object-limit-exceeded",
            "defaultMessage": "This field is configured to store {objectLimit, plural, one {# object} other {# objects}}. Remove some objects to save changes."
        },
        dropdownNumberOfSearchResultsLabel: {
            "id": "servicedesk-cmdb-field-object-picker.dropdown-number-of-search-results-label",
            "defaultMessage": "{numberOfSearchResults} search {numberOfSearchResults, plural, one {result} other {results}} {isLoading, select, true {(refreshing)} other {}}"
        }
    });
});
parcelRegister("iPF9E", function(module, exports) {
    $parcel$export(module.exports, "customStyles", ()=>$45ba3e86982e6cb6$export$edf5b2501a573922);
    var $gwIPs;
    const $45ba3e86982e6cb6$export$edf5b2501a573922 = {
        menu: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, (0, parcelRequire("gwIPs")).layers).modal
            })
    };
});
parcelRegister("7ZmbO", function(module, exports) {
    $parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", ()=>$92269289c1fdd627$export$dca2c2105b681490);
    $parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", ()=>$92269289c1fdd627$export$a48ac34d39e0fc22);
    $parcel$export(module.exports, "MAX_QUEUES_PER_SD", ()=>$92269289c1fdd627$export$2e0ba662d5bb7742);
    $parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", ()=>$92269289c1fdd627$export$eb69982aa3a172b4);
    $parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", ()=>$92269289c1fdd627$export$cb3888a8c43147d2);
    $parcel$export(module.exports, "LIMIT_DEFAULTS", ()=>$92269289c1fdd627$export$5ed1d2ac050e39d);
    $parcel$export(module.exports, "getLimit", ()=>$92269289c1fdd627$export$fb8ce379717a383d);
    $parcel$export(module.exports, "LimitData", ()=>$92269289c1fdd627$export$9989835030ecd317);
    $parcel$export(module.exports, "withLimitData", ()=>$92269289c1fdd627$export$c5d8aa8a650e690f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $7f4tk;
    const $92269289c1fdd627$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
    const $92269289c1fdd627$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
    const $92269289c1fdd627$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
    const $92269289c1fdd627$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
    const $92269289c1fdd627$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
    const $92269289c1fdd627$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
    const $92269289c1fdd627$export$5ed1d2ac050e39d = {
        [$92269289c1fdd627$export$dca2c2105b681490]: 30,
        [$92269289c1fdd627$export$a48ac34d39e0fc22]: 30,
        [$92269289c1fdd627$export$2e0ba662d5bb7742]: 300,
        [$92269289c1fdd627$export$eb69982aa3a172b4]: 30,
        [$92269289c1fdd627$export$cb3888a8c43147d2]: 20,
        [$92269289c1fdd627$export$801a603585fb94d8]: 50
    };
    const $92269289c1fdd627$var$limitCache = {};
    const $92269289c1fdd627$export$c419786abd6faaad = (limitProperty)=>{
        delete $92269289c1fdd627$var$limitCache[limitProperty];
    };
    const $92269289c1fdd627$export$fb8ce379717a383d = (limitProperty)=>{
        if (!$92269289c1fdd627$var$limitCache[limitProperty]) $92269289c1fdd627$var$limitCache[limitProperty] = (0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
            $92269289c1fdd627$export$c419786abd6faaad(limitProperty);
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
            throw error;
        });
        return $92269289c1fdd627$var$limitCache[limitProperty];
    };
    class $92269289c1fdd627$export$9989835030ecd317 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { limitProperty: limitProperty } = this.props;
            const defaultLimit = $92269289c1fdd627$export$5ed1d2ac050e39d[limitProperty];
            $92269289c1fdd627$export$fb8ce379717a383d(limitProperty).then((limit)=>{
                this.updateLimit(limit || defaultLimit);
            }).catch(()=>{
                this.updateLimit(defaultLimit);
            });
        }
        updateLimit(newLimit) {
            this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                    limit: newLimit
                } : undefined);
        }
        render() {
            return this.props.children(this.state.limit);
        }
        constructor(...args){
            super(...args), this.state = {
                limit: Infinity
            };
        }
    }
    const $92269289c1fdd627$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($92269289c1fdd627$export$9989835030ecd317, {
                limitProperty: limitProperty
            }, (limit)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    limit: limit,
                    ...props
                }));
});
parcelRegister("1bQJO", function(module, exports) {
    $parcel$export(module.exports, "transformCmdbField", ()=>$839547a6a65d7df8$export$3c3af8d272413d1c);
    const $839547a6a65d7df8$export$3c3af8d272413d1c = (options)=>options.map((option)=>({
                id: option.id,
                objectId: option.objectId,
                workspaceId: option.workspaceId
            }));
});
parcelRegister("ilY3g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b763cc6cea94fc6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bATF;
    var $iHPnC;
    var $hpV4g;
    const $b763cc6cea94fc6a$var$ColorPickerField = (props)=>{
        const { fieldProps: { value: value, onChange: onChange } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5bATF")).ColorPicker), {
            value: value,
            onChange: onChange,
            showColorName: true
        });
    };
    var $b763cc6cea94fc6a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("iHPnC")).asColor)
    })($b763cc6cea94fc6a$var$ColorPickerField);
});
parcelRegister("5bATF", function(module, exports) {
    $parcel$export(module.exports, "ColorPicker", ()=>$3ec05ed007c980a7$export$9feb1bc2e5f1ccb3);
    $parcel$export(module.exports, "ColorPickerWrapper", ()=>$3ec05ed007c980a7$export$3144fa159460e52e);
    $parcel$export(module.exports, "ColorName", ()=>$3ec05ed007c980a7$export$93f3fcc778132720);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3zNHM = parcelRequire("3zNHM");
    var $aWse0;
    var $heWHN;
    var $3f8iY;
    var $31AKf;
    const $3ec05ed007c980a7$var$popperProps = {
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        -10,
                        5
                    ]
                }
            }
        ]
    };
    const $3ec05ed007c980a7$export$9feb1bc2e5f1ccb3 = ({ value: color, showColorName: showColorName, onChange: onChange })=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const colorPalette = (0, (0, parcelRequire("3f8iY")).getI18nColorPalette)(intl);
        const colorString = (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color];
        const maybeColorLabel = colorPalette.filter((pcol)=>pcol.value === colorString)[0];
        const colorLabel = maybeColorLabel && maybeColorLabel.label || '';
        const onChangeHandler = (changedTo)=>{
            onChange((0, (0, parcelRequire("heWHN")).MAP_VALUE_TO_COLOR)[changedTo]);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3ec05ed007c980a7$export$3144fa159460e52e, {
            "data-testid": (0, (0, parcelRequire("3f8iY")).colorFieldDataTestId)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3zNHM.default), {
            label: intl.formatMessage((0, (0, parcelRequire("31AKf")).default).label),
            palette: colorPalette,
            selectedColor: colorString,
            cols: colorPalette.length / 2,
            onChange: onChangeHandler,
            popperProps: $3ec05ed007c980a7$var$popperProps
        }), showColorName && (0, ($parcel$interopDefault($5uXOq))).createElement($3ec05ed007c980a7$export$93f3fcc778132720, null, colorLabel));
    };
    var $3ec05ed007c980a7$export$2e2bcd8739ae039 = $3ec05ed007c980a7$export$9feb1bc2e5f1ccb3;
    const $3ec05ed007c980a7$export$3144fa159460e52e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _18u01i6y _ca0qu2gc _u5f3u2gc _4t3izwfg _z29hglyw",
                __cmplp.className
            ])
        });
    });
    $3ec05ed007c980a7$export$3144fa159460e52e.displayName = 'ColorPickerWrapper';
    const $3ec05ed007c980a7$export$93f3fcc778132720 = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s84w17",
                __cmplp.className
            ])
        });
    });
    $3ec05ed007c980a7$export$93f3fcc778132720.displayName = 'ColorName';
});
parcelRegister("3zNHM", function(module, exports) {
    $parcel$export(module.exports, "Compact", ()=>$06f62cb25bd09d8d$export$6479582a9c9e50ce);
    $parcel$export(module.exports, "default", ()=>$06f62cb25bd09d8d$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "ColorPaletteMenu", ()=>(parcelRequire("lGTQx")).default);
    var $3PpqK = parcelRequire("3PpqK");
    var $kD00A = parcelRequire("kD00A");
    var $lGTQx = parcelRequire("lGTQx");
    const { Compact: $06f62cb25bd09d8d$export$6479582a9c9e50ce, Standard: $06f62cb25bd09d8d$export$d5a1f56087d42b19 } = (0, $kD00A.Mode);
    var $06f62cb25bd09d8d$export$2e2bcd8739ae039 = (0, $3PpqK.default);
});
parcelRegister("3PpqK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f994db29f75e4622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $b9dFI;
    var $1ErJq = parcelRequire("1ErJq");
    var $jKrb6 = parcelRequire("jKrb6");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $8RXs9;
    var $VSDnB;
    var $7oXeG = parcelRequire("7oXeG");
    function $f994db29f75e4622$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f994db29f75e4622$var$defaultPopperProps = {
        strategy: 'fixed',
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            }
        ],
        placement: 'bottom-start'
    };
    const $f994db29f75e4622$var$packageName = "platform-pkg";
    const $f994db29f75e4622$var$packageVersion = "0.0.0-use.local";
    class $f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $f994db29f75e4622$var$defaultPopperProps, label: label = 'Color picker', triggerId: triggerId, selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl, variant: variant = 'fill' } = this.props;
            const { options: options, value: value } = (0, $5dAp2.getOptions)(palette, selectedColor, showDefaultSwatchColor);
            const fullLabel = this.getFullLabel(intl, value, label);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b9dFI")).default), {
                target: ({ ref: ref, isOpen: isOpen })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                        css: $f994db29f75e4622$var$colorCardWrapperStyles,
                        ref: ref
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1ErJq.default), {
                        ...value,
                        label: fullLabel,
                        expanded: isOpen,
                        swatchSize: selectedColourSwatchSize,
                        isDisabled: isDisabledSelectedSwatch,
                        id: triggerId,
                        variant: variant
                    })),
                popperProps: popperProps,
                maxMenuWidth: "auto",
                minMenuWidth: "auto",
                options: options,
                "aria-label": fullLabel,
                value: value,
                components: $jKrb6,
                onChange: this.onChangeSelect,
                searchThreshold: Number.MAX_VALUE,
                cols: cols,
                checkMarkColor: checkMarkColor,
                variant: variant,
                onKeyDown: this.onKeyDown,
                isTabbing: this.state.isTabbing,
                onOptionKeyDown: this.onOptionKeyDown,
                ...(0, (0, parcelRequire("VSDnB")).fg)('one_event_rules_them_all_fg') && {
                    onMenuOpen: this.props.onMenuOpen
                }
            });
        }
        constructor(...args){
            super(...args), this.createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit'), this.state = {
                isTabbing: false
            }, this.changeAnalyticsCaller = ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                    action: 'clicked',
                    actionSubject: 'color-picker',
                    attributes: {
                        componentName: 'color-picker',
                        packageName: $f994db29f75e4622$var$packageName,
                        packageVersion: $f994db29f75e4622$var$packageVersion
                    }
                })(createAnalyticsEvent);
                return undefined;
            }, this.onChangeSelect = (option)=>{
                this.props.onChange(option.value, this.changeAnalyticsCaller());
            }, this.onOptionKeyDown = (value)=>{
                this.props.onChange(value, this.changeAnalyticsCaller());
            }, this.onKeyDown = (e)=>{
                const key = e.key;
                if (key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) this.setState({
                    isTabbing: true
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2) || key === (0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8)) this.setState({
                    isTabbing: false
                });
                else if (key === (0, $8fa07a9626e5ffeb$export$929c2026f4dd54a2)) e.stopPropagation();
            }, this.getFullLabel = (intl, value, label)=>{
                if (value && value.label) return intl.formatMessage((0, $7oXeG.default).colorPickerAriaLabel, {
                    color: value.label,
                    message: label
                });
                else return label;
            };
        }
    }
    const $f994db29f75e4622$export$2fcf66ed38ff3cf5 = (0, (0, parcelRequire("8RXs9")).default)($f994db29f75e4622$var$ColorPickerWithoutAnalyticsBase);
    var $f994db29f75e4622$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: $f994db29f75e4622$var$packageName,
        packageVersion: $f994db29f75e4622$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)()($f994db29f75e4622$export$2fcf66ed38ff3cf5));
    const $f994db29f75e4622$var$colorCardWrapperStyles = {
        name: "1r5gb7q",
        styles: "display:inline-block"
    };
});
parcelRegister("1ErJq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$609735830782207d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $VSDnB;
    var $f8Sb3;
    function $609735830782207d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $609735830782207d$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled, id: id, variant: variant = 'fill' })=>{
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            event.currentTarget.focus();
            if (onClick) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        const isOutlineVariant = (0, (0, parcelRequire("VSDnB")).fg)('thor_colourful_single_select_milestone1_gate') && variant === 'outline';
        const colorCardStyles = isOutlineVariant ? {
            borderColor: value || 'grey'
        } : {
            backgroundColor: value || 'transparent'
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: [
                $609735830782207d$var$sharedColorContainerStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorContainerSize : $609735830782207d$var$defaultColorContainerSize,
                $609735830782207d$var$colorCardButtonStyles,
                expanded && !(0, (0, parcelRequire("VSDnB")).fg)('platform-design-system-dsp-20821-color-pickr-focus') && $609735830782207d$var$colorCardButtonFocusedStyles
            ],
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            "aria-label": label,
            "aria-expanded": expanded,
            "aria-haspopup": true,
            type: "button",
            id: id
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $609735830782207d$var$colorCardWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                isOutlineVariant ? $609735830782207d$var$colorCardContentStylesOutline : $609735830782207d$var$colorCardContentStyles,
                swatchSize === 'small' ? $609735830782207d$var$smallColorCardContentSize : $609735830782207d$var$defaultColorCardContentSize
            ],
            style: colorCardStyles
        }))));
    };
    var $609735830782207d$export$2e2bcd8739ae039 = $609735830782207d$var$ColorCard;
    const $609735830782207d$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: '6px',
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $609735830782207d$var$smallColorContainerSize = {
        name: "1435ao5",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
    };
    const $609735830782207d$var$defaultColorContainerSize = {
        name: "1uafl10",
        styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
    };
    const $609735830782207d$var$colorCardButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover': {
            borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        },
        ':not(:focus):hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
            outline: 'none'
        }
    });
    const $609735830782207d$var$colorCardButtonFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        outline: 'none'
    });
    const $609735830782207d$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $609735830782207d$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
    const $609735830782207d$var$colorCardContentStylesOutline = {
        name: "tg36ij",
        styles: "border-radius:var(--ds-border-radius-100, 3px);border-width:var(--ds-border-width-outline, 2px);border-style:solid"
    };
    const $609735830782207d$var$smallColorCardContentSize = {
        name: "1rrhp72",
        styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
    };
    const $609735830782207d$var$defaultColorCardContentSize = {
        name: "ljflj6",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
    };
});
parcelRegister("jKrb6", function(module, exports) {
    $parcel$export(module.exports, "MenuList", ()=>$b794a85d007e2dce$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "Option", ()=>$b794a85d007e2dce$export$36d18380658d5d20);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$b794a85d007e2dce$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "Placeholder", ()=>$b794a85d007e2dce$export$84712d0562a614b8);
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    var $koVbs;
    var $7oXeG = parcelRequire("7oXeG");
    function $b794a85d007e2dce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b794a85d007e2dce$export$d4c4e98c5044dc8 = (props)=>{
        const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorPaletteContainerStyles,
            role: "group",
            "aria-label": formatMessage((0, $7oXeG.default).menuListAriaLabel),
            style: {
                maxWidth: cols ? (0, $5dAp2.getWidth)(cols) : undefined
            },
            ref: innerRef
        }, children);
    };
    const $b794a85d007e2dce$export$36d18380658d5d20 = (props)=>{
        const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing, variant: variant }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b794a85d007e2dce$var$colorCardWrapperStyles,
            ...innerProps,
            role: "radio",
            "aria-checked": isSelected,
            "aria-selected": undefined,
            "aria-label": label
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
            type: (0, $8fa07a9626e5ffeb$export$9fea11a016bc5bcf),
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            focused: isFocused,
            selected: isSelected,
            onKeyDown: (value)=>onOptionKeyDown(value),
            isTabbing: isTabbing,
            variant: variant
        }));
    };
    const $b794a85d007e2dce$export$ec98719d3db7f2e4 = ()=>null;
    const $b794a85d007e2dce$export$84712d0562a614b8 = ()=>null;
    const $b794a85d007e2dce$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $b794a85d007e2dce$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
});
parcelRegister("l0sd0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d681a23420d49946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eJbwP;
    var $3bDjY;
    var $VSDnB;
    var $f8Sb3;
    var $bWn3s;
    function $d681a23420d49946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d681a23420d49946$var$ColorCard = (0, $5uXOq.forwardRef)((props, componentRef)=>{
        const { type: type, autoFocus: autoFocus = true, initialFocusRef: initialFocusRef, isInsideMenu: isInsideMenu = true, value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $829f609a65d26a98$export$29a4f05edc054374), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown, variant: variant = 'fill' } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const isInitialFocus = (0, $5uXOq.useRef)(true);
        const isColorPaletteMenu = type === (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963);
        const handleMouseDown = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                onClick(event, value);
            }
        }, [
            onClick,
            value
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((isColorPaletteMenu || isTabbing === undefined || isTabbing) && onClick && (event.key === (0, $8fa07a9626e5ffeb$export$8152f929a25a0ff4) || event.key === (0, $8fa07a9626e5ffeb$export$e51a3576c045c8d5))) {
                event.preventDefault();
                if (isTabbing) event.stopPropagation();
                onClick(event, value);
            }
            if (isColorPaletteMenu) onKeyDown?.(event);
            else if (event.key === (0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b)) {
                event.preventDefault();
                event.stopPropagation();
            }
        }, [
            isColorPaletteMenu,
            isTabbing,
            value,
            onClick,
            onKeyDown
        ]);
        (0, $5uXOq.useImperativeHandle)(componentRef, ()=>({
                focus: ()=>{
                    if (isColorPaletteMenu) {
                        if (isInitialFocus.current) {
                            autoFocus && !initialFocusRef && ref.current?.focus();
                            isInitialFocus.current = false;
                        } else ref.current?.focus();
                    }
                }
            }), [
            autoFocus,
            isColorPaletteMenu,
            initialFocusRef
        ]);
        const isInsideMenuRole = isInsideMenu ? 'menuitemradio' : 'radio';
        const role = isColorPaletteMenu ? isInsideMenuRole : 'presentation';
        const ariaChecked = isColorPaletteMenu ? selected : undefined;
        const ariaLabel = isColorPaletteMenu ? label : undefined;
        const isOutlineVariant = (0, (0, parcelRequire("VSDnB")).fg)('thor_colourful_single_select_milestone1_gate') && variant === 'outline';
        const newCheckmarkColor = isOutlineVariant ? "var(--ds-icon, #44546F)" : checkMarkColor;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: label
        }, (tooltipProps)=>{
            delete tooltipProps['aria-describedby'];
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...tooltipProps,
                ref: initialFocusRef ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref,
                    initialFocusRef
                ]) : (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    tooltipProps.ref
                ]),
                role: role,
                tabIndex: selected ? 0 : -1,
                "aria-checked": ariaChecked,
                "aria-label": ariaLabel,
                css: [
                    $d681a23420d49946$var$sharedColorContainerStyles,
                    (isColorPaletteMenu || isTabbing === undefined || isTabbing) && $d681a23420d49946$var$colorCardOptionTabbingStyles,
                    focused && (isColorPaletteMenu || !isTabbing) && $d681a23420d49946$var$colorCardOptionFocusedStyles
                ],
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                onKeyDown: handleKeyDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $d681a23420d49946$var$colorCardWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: isOutlineVariant ? $d681a23420d49946$var$colorCardContentStylesOutline : $d681a23420d49946$var$colorCardContentStyles,
                style: isOutlineVariant ? {
                    borderColor: value || 'grey'
                } : {
                    backgroundColor: value || 'transparent'
                }
            }, selected && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eJbwP"))))), {
                color: newCheckmarkColor,
                label: "",
                spacing: "spacious",
                LEGACY_margin: "1px"
            })))));
        });
    });
    var $d681a23420d49946$export$2e2bcd8739ae039 = $d681a23420d49946$var$ColorCard;
    const $d681a23420d49946$var$colorCardOptionTabbingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':hover, :focus': {
            borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
        }
    });
    const $d681a23420d49946$var$colorCardOptionFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`
    });
    const $d681a23420d49946$var$sharedColorContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        position: 'relative',
        width: "var(--ds-space-400, 32px)",
        height: "var(--ds-space-400, 32px)",
        border: '2px solid transparent',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-border-radius-200, 6px)",
        transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: "var(--ds-space-0, 0px)",
        cursor: 'pointer',
        outline: 'none'
    });
    const $d681a23420d49946$var$colorCardWrapperStyles = {
        name: "10qlvma",
        styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
    };
    const $d681a23420d49946$var$colorCardContentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-300, 24px)",
        height: "var(--ds-space-300, 24px)",
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$4b16f52932fda51)})`}`
    });
    const $d681a23420d49946$var$colorCardContentStylesOutline = {
        name: "cejn3m",
        styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);border-radius:var(--ds-border-radius-100, 3px);border-width:var(--ds-border-width-outline, 2px);border-style:solid"
    };
});
parcelRegister("eJbwP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));
    var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
    function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>$ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
            LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
        }, props));
    $ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
    var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;
});
const $8fa07a9626e5ffeb$export$9fea11a016bc5bcf = 'COLOR_PICKER';
const $8fa07a9626e5ffeb$export$2643a2cdce1d3963 = 'COLOR_PALETTE_MENU';
const $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac = 32;
const $8fa07a9626e5ffeb$export$e51a3576c045c8d5 = ' ';
const $8fa07a9626e5ffeb$export$8152f929a25a0ff4 = 'Enter';
const $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2 = 'ArrowUp';
const $8fa07a9626e5ffeb$export$1734a06b2397c2a8 = 'ArrowDown';
const $8fa07a9626e5ffeb$export$842fd6cf65a6b80c = 'ArrowLeft';
const $8fa07a9626e5ffeb$export$695331c89a36efd6 = 'ArrowRight';
const $8fa07a9626e5ffeb$export$10f6869ed0a7d75b = 'Tab';
const $8fa07a9626e5ffeb$export$929c2026f4dd54a2 = 'Escape';
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("5dAp2", function(module, exports) {
    $parcel$export(module.exports, "getWidth", ()=>$38874a93fb14a10d$export$3c49c185de0c2bfc);
    $parcel$export(module.exports, "getOptions", ()=>$38874a93fb14a10d$export$d2312e68e1f5ad00);
    var $k5uoT;
    var $8QpSo;
    var $kD00A = parcelRequire("kD00A");
    const $38874a93fb14a10d$export$3c49c185de0c2bfc = (cols, mode)=>{
        const width = cols * ((0, $8fa07a9626e5ffeb$export$64c9b8c6e6a2c6ac) + (0, (0, parcelRequire("k5uoT")).gridSize)() / 2);
        return mode === (0, $kD00A.Mode).Standard ? width + (0, (0, parcelRequire("k5uoT")).gridSize)() : width;
    };
    const $38874a93fb14a10d$export$d2312e68e1f5ad00 = (0, (0, parcelRequire("8QpSo")).default)((palette, selectedColor, showDefaultSwatchColor)=>{
        let focusedItemIndex = 0;
        let defaultSelectedColor = palette[0];
        if (!showDefaultSwatchColor) defaultSelectedColor = {
            label: '',
            value: ''
        };
        const value = palette.find((color, index)=>{
            if (color.value === selectedColor) {
                focusedItemIndex = index;
                return true;
            }
            return false;
        }) || defaultSelectedColor;
        return {
            options: palette,
            value: value,
            focusedItemIndex: focusedItemIndex
        };
    });
});
parcelRegister("kD00A", function(module, exports) {
    $parcel$export(module.exports, "Mode", ()=>$e25de60b37efd75a$export$9484bbecc3c49a2e);
    var $e25de60b37efd75a$export$9484bbecc3c49a2e;
    (function(Mode) {
        Mode[Mode["Compact"] = 0] = "Compact";
        Mode[Mode["Standard"] = 1] = "Standard";
    })($e25de60b37efd75a$export$9484bbecc3c49a2e || ($e25de60b37efd75a$export$9484bbecc3c49a2e = {}));
});
parcelRegister("7oXeG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d42a6da5a6d06680$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d42a6da5a6d06680$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        colorPickerAriaLabel: {
            id: 'jira.color-picker.src.color-picker-aria-label',
            defaultMessage: '{color} selected, {message}',
            description: 'This text is used as aria-label text in color picker component'
        },
        menuListAriaLabel: {
            id: 'jira.color-picker.src.menu-list-aria-label',
            defaultMessage: 'Color picker list',
            description: 'This text is used as aria-label text for the listbox element in color picker component'
        }
    });
});
parcelRegister("lGTQx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5e30770a4da4328$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kD00A = parcelRequire("kD00A");
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $l0sd0 = parcelRequire("l0sd0");
    var $5dAp2 = parcelRequire("5dAp2");
    var $f8Sb3;
    function $c5e30770a4da4328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5e30770a4da4328$export$4bbfe93c6a14e8e6 = ({ autoFocus: autoFocus = true, isFocusLockEnabled: isFocusLockEnabled = true, isInsideMenu: isInsideMenu = true, createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $kD00A.Mode).Standard, initialFocusRef: initialFocusRef, variant: variant = 'fill' })=>{
        const { options: options, value: selectedValue } = (0, $5dAp2.getOptions)(palette, selectedColor);
        const fullLabel = `${label}, ${selectedValue.label} selected`;
        const selectedColorIndex = selectedValue.value ? options.findIndex(({ value: value })=>value === selectedValue.value) : 0;
        const [focusedIndex, setFocusedIndex] = (0, $5uXOq.useState)(selectedColorIndex);
        const createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
        const changeAnalyticsCaller = ()=>{
            if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-palette-menu',
                attributes: {
                    componentName: 'color-picker',
                    packageName: "platform-pkg",
                    packageVersion: "0.0.0-use.local"
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        const colorCardRefs = (0, $5uXOq.useMemo)(()=>[], []);
        const handleChange = (event, value)=>{
            onChange(event, value, changeAnalyticsCaller());
        };
        (0, $5uXOq.useEffect)(()=>{
            colorCardRefs[focusedIndex]?.focus();
        }, [
            focusedIndex,
            colorCardRefs
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const numItems = options.length;
            switch(event.key){
                case 0, $8fa07a9626e5ffeb$export$1734a06b2397c2a8:
                case 0, $8fa07a9626e5ffeb$export$695331c89a36efd6:
                    setFocusedIndex((prevIndex)=>(prevIndex + 1) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$b34c7ae3fd8138d2:
                case 0, $8fa07a9626e5ffeb$export$842fd6cf65a6b80c:
                    setFocusedIndex((prevIndex)=>(prevIndex - 1 + numItems) % numItems);
                    break;
                case 0, $8fa07a9626e5ffeb$export$10f6869ed0a7d75b:
                    if (isFocusLockEnabled) {
                        event.preventDefault();
                        event.stopPropagation();
                        setFocusedIndex(selectedColorIndex);
                    }
                    break;
                default:
                    break;
            }
        }, [
            isFocusLockEnabled,
            selectedColorIndex,
            setFocusedIndex,
            options
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-label": fullLabel,
            role: isInsideMenu ? 'menu' : 'radiogroup',
            css: [
                $c5e30770a4da4328$var$colorPaletteMenuStyles,
                mode === (0, $kD00A.Mode).Standard && $c5e30770a4da4328$var$colorPaletteMenuStandardStyles
            ],
            style: {
                width: `${(0, $5dAp2.getWidth)(cols, mode)}px`
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $c5e30770a4da4328$var$colorPaletteContainerStyles,
                mode === (0, $kD00A.Mode).Compact && $c5e30770a4da4328$var$colorPaletteContainerCompactStyles
            ]
        }, options.map(({ label: label, value: value }, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $c5e30770a4da4328$var$colorCardWrapperStyles,
                key: value
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $l0sd0.default), {
                type: (0, $8fa07a9626e5ffeb$export$2643a2cdce1d3963),
                label: label,
                value: value,
                checkMarkColor: checkMarkColor,
                isOption: true,
                selected: value === selectedValue.value,
                onClick: handleChange,
                ref: (ref)=>{
                    colorCardRefs[index] = ref;
                },
                autoFocus: autoFocus,
                initialFocusRef: value === selectedValue.value ? initialFocusRef : undefined,
                isInsideMenu: isInsideMenu,
                onKeyDown: handleKeyDown,
                variant: variant
            })))));
    };
    var $c5e30770a4da4328$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'color-picker',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    })((0, (0, parcelRequire("cb25w")).default)()($c5e30770a4da4328$export$4bbfe93c6a14e8e6));
    const $c5e30770a4da4328$var$colorCardWrapperStyles = {
        name: "yotnll",
        styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerStyles = {
        name: "4t056h",
        styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
    };
    const $c5e30770a4da4328$var$colorPaletteContainerCompactStyles = {
        name: "h6te2n",
        styles: "padding:var(--ds-space-0, 0)"
    };
    const $c5e30770a4da4328$var$colorPaletteMenuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'relative',
        margin: "var(--ds-space-0, 0)",
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $c5e30770a4da4328$var$colorPaletteMenuStandardStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}, 0 0 8px ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)}`})`
    });
});
parcelRegister("3f8iY", function(module, exports) {
    $parcel$export(module.exports, "colorFieldDataTestId", ()=>$fc41f338de3fb481$export$d5ae1babf783fed9);
    $parcel$export(module.exports, "getI18nColorPalette", ()=>$fc41f338de3fb481$export$9ceccb3244ae7dac);
    var $8QpSo;
    var $iHPnC;
    const $fc41f338de3fb481$export$d5ae1babf783fed9 = 'issue.views.issue-base.foundation.color.color-picker-wrapper';
    const $fc41f338de3fb481$export$9ceccb3244ae7dac = (0, (0, parcelRequire("8QpSo")).default)(({ formatMessage: formatMessage })=>(0, (0, parcelRequire("iHPnC")).getDefaultColorPalette)(formatMessage));
});
parcelRegister("31AKf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55ddc856d47f5246$export$2e2bcd8739ae039);
    var $7VHMR;
    var $55ddc856d47f5246$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            "id": "color-picker.edit.label",
            "defaultMessage": "Change color"
        }
    });
});
parcelRegister("cUXq3", function(module, exports) {
    $parcel$export(module.exports, "mutateEpicColorField", ()=>$197093e9d83b1af7$export$80288f09329d6da0);
    $parcel$export(module.exports, "mutateIssueColorField", ()=>$197093e9d83b1af7$export$9e0b17281ec856bc);
    var $iHPnC;
    const $197093e9d83b1af7$export$80288f09329d6da0 = (selectedColor, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $bb4032e21dd9602d$export$31fd86f8f183952c),
            color: {
                name: (0, (0, parcelRequire("iHPnC")).asClassicEpicColor)(selectedColor)
            }
        });
    const $197093e9d83b1af7$export$9e0b17281ec856bc = (selectedColor, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $bb4032e21dd9602d$export$31fd86f8f183952c),
            color: {
                name: (0, (0, parcelRequire("iHPnC")).asServerColor)(selectedColor)
            }
        });
});
const $bb4032e21dd9602d$export$31fd86f8f183952c = 'colorFields';
parcelRegister("776me", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6c3a95c2efe6aba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $hFon0;
    var $koVbs;
    var $as9La;
    var $6Fkzt;
    var $45JN1;
    var $7C5S0;
    var $YSJPS;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $b399U;
    const $f6c3a95c2efe6aba$var$ComponentsField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isDisabled = allowedValues.length === 0;
        const options = (0, (0, parcelRequire("6Fkzt")).mapDataToOptions)(allowedValues);
        const { projectKey: projectKey } = selectedProject || {};
        const projectKeyStr = projectKey || '';
        const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, (0, parcelRequire("hFon0")).useGlobalComponentsProperty)(projectKeyStr);
        const getComponentSelectEdit = ()=>{
            if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("YSJPS")).StyledFieldSkeleton), null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("as9La")).default), {
                ...fieldProps,
                options: options,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                value: value,
                onChange: onChange,
                autoFocus: autoFocus,
                isInvalid: Boolean(error),
                showFooter: false,
                projectKey: projectKeyStr,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("b399U")).default).none) : '',
                isDisabled: isDisabled || isReadOnly,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                canCreateNewItem: !areGlobalComponentsEnabled,
                inputId: id,
                isRequired: isRequired
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("b399U")).default).tooltipWhenDisabled)
        }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $f6c3a95c2efe6aba$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("6Fkzt")).mapDataToOptions),
        validator: (0, (0, parcelRequire("jGVMX")).validateComponentField),
        shouldRenderFieldMessage: false
    })($f6c3a95c2efe6aba$var$ComponentsField);
});
parcelRegister("hFon0", function(module, exports) {
    $parcel$export(module.exports, "useGlobalComponentsProperty", ()=>$e88d764a116eddca$export$a070f388fcd93df0);
    var $5uXOq = parcelRequire("5uXOq");
    var $do78Z;
    var $feQhf;
    function $e88d764a116eddca$export$a070f388fcd93df0(projectKey) {
        const [loading, setLoading] = (0, $5uXOq.useState)(true);
        const [enabled, setEnabled] = (0, $5uXOq.useState)(undefined);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const loadGlobalComponentsProperty = (0, $5uXOq.useCallback)(()=>{
            setEnabled(undefined);
            setError(undefined);
            setLoading(true);
        }, [
            setEnabled,
            setError,
            setLoading
        ]);
        const resolveGlobalComponentsProperty = (0, $5uXOq.useCallback)((value)=>{
            if (value instanceof Error) {
                setEnabled(undefined);
                setError(value);
            } else {
                setEnabled(value);
                setError(undefined);
            }
            setLoading(false);
        }, [
            setEnabled,
            setError,
            setLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            loadGlobalComponentsProperty();
            (0, (0, parcelRequire("feQhf")).getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
        }, [
            loadGlobalComponentsProperty,
            resolveGlobalComponentsProperty,
            projectKey
        ]);
        const setProperty = (0, $5uXOq.useCallback)((newValue)=>{
            loadGlobalComponentsProperty();
            return (0, (0, parcelRequire("feQhf")).setGlobalComponentsProperty)(projectKey, newValue).then(()=>(0, (0, parcelRequire("do78Z")).default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
                resolveGlobalComponentsProperty(e);
                throw e;
            });
        }, [
            loadGlobalComponentsProperty,
            resolveGlobalComponentsProperty,
            projectKey
        ]);
        return {
            enabled: enabled,
            loading: loading,
            error: error,
            setProperty: setProperty
        };
    }
});
parcelRegister("do78Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b15e5e3de311da0$export$2e2bcd8739ae039);
    var $c3jsi;
    var $1AJVB;
    var $2b15e5e3de311da0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("c3jsi")).default)((0, (0, parcelRequire("1AJVB")).props));
});
parcelRegister("c3jsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ccdca2a0bd8756d7$export$2e2bcd8739ae039);
    var $8Op28;
    const $ccdca2a0bd8756d7$var$pNothing = ()=>Promise.resolve();
    var $ccdca2a0bd8756d7$export$2e2bcd8739ae039 = (config)=>{
        if (!false) {
            const Cache = (0, (0, parcelRequire("8Op28")).default)(config);
            const getAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
            const get = (key)=>Cache.then((cache)=>cache.get(key));
            const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
            const remove = (key)=>Cache.then((cache)=>cache.delete(key));
            const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
            const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
            const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>Promise.all(entries.map(([key])=>cache.delete(key)))).then(()=>{}));
            return {
                get: get,
                getAll: getAll,
                set: set,
                remove: remove,
                update: update,
                refresh: refresh,
                clearAll: clearAll
            };
        }
        return {
            get: $ccdca2a0bd8756d7$var$pNothing,
            getAll: ()=>Promise.resolve([]),
            set: ()=>Promise.resolve(),
            remove: $ccdca2a0bd8756d7$var$pNothing,
            update: $ccdca2a0bd8756d7$var$pNothing,
            refresh: ()=>Promise.resolve([]),
            clearAll: $ccdca2a0bd8756d7$var$pNothing
        };
    };
});
parcelRegister("8Op28", function(module, exports) {
    $parcel$export(module.exports, "Cache", ()=>$3e46065a4b1d2500$export$94affb487e701bf2);
    $parcel$export(module.exports, "default", ()=>$3e46065a4b1d2500$export$2e2bcd8739ae039);
    var $bSSG7;
    var $eNf8a;
    var $dJl1T;
    var $1NZBJ;
    const $3e46065a4b1d2500$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
    function $3e46065a4b1d2500$export$94affb487e701bf2(props) {
        const cache = new Map();
        const { size: size } = props;
        let storage;
        let hasSyncedFromStorage = false;
        const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
            name: `Cache ${props.cacheKey}`,
            serialize: true
        }) : null;
        const syncWithDevTools = (type, payload)=>{
            if ((0, (0, parcelRequire("1NZBJ")).default).devTools) devTools && devTools.send({
                type: type,
                payload: payload
            }, cache, {}, props.cacheKey);
        };
        const removeExpiredKeysFromStorage = async (store)=>{
            const updatedStore = {
                ...store
            };
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return {};
            const { cacheKey: cacheKey, maxAge: maxAge } = props;
            if (maxAge !== undefined) {
                Object.keys(store).forEach((key)=>{
                    const keyAge = $3e46065a4b1d2500$var$calculateEntryAge(store[key].timestamp);
                    if (keyAge > maxAge) {
                        syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                            [String(key)]: updatedStore[key]
                        });
                        delete updatedStore[key];
                        cache.delete(key);
                    }
                });
                storage.set(cacheKey, updatedStore);
            }
            return updatedStore;
        };
        const removeExpiredEntry = (key, val)=>{
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { maxAge: maxAge } = props;
                if (maxAge !== undefined && $3e46065a4b1d2500$var$calculateEntryAge(val.timestamp) > maxAge) {
                    syncWithDevTools((0, $43a74598c9c16cf3$export$26d12233004a7a60), {
                        [String(key)]: val
                    });
                    cache.delete(key);
                    return true;
                }
            }
            return false;
        };
        const createStore = ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)) storage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            else storage = (0, (0, parcelRequire("eNf8a")).createSessionStorageProvider)((0, (0, parcelRequire("1NZBJ")).CACHE_PREFIX));
            return storage;
        };
        const set = async (key, value)=>{
            await load();
            cache.delete(key);
            const entry = {
                value: value,
                timestamp: Date.now()
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$5e8f180ef0142226), {
                [String(key)]: entry
            });
            if (cache.size > size) {
                const keys = cache.keys();
                const firstEntry = keys.next().value;
                if (firstEntry !== undefined) {
                    cache.delete(firstEntry);
                    syncWithDevTools((0, $43a74598c9c16cf3$export$a61768fefd33fcb1), firstEntry);
                    if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) delete storedContent[firstEntry];
                }
            }
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const load = async ()=>{
            if (false || hasSyncedFromStorage) return;
            hasSyncedFromStorage = true;
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            const { cacheKey: cacheKey } = props;
            storage = createStore();
            try {
                let data = storage.get(cacheKey) || {};
                data = await removeExpiredKeysFromStorage(data);
                syncWithDevTools((0, $43a74598c9c16cf3$export$61f74127e2b53cbe), data);
                const orderedKeys = Object.keys(data).sort((key1, key2)=>data[key1].timestamp - data[key2].timestamp);
                await Promise.all(orderedKeys.map(async (key)=>{
                    await set(key, data[key].value);
                }));
            } catch (err) {
                (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData((0, $43a74598c9c16cf3$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
                throw err;
            }
        };
        const clear = async ()=>{
            await load();
            cache.clear();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const { cacheKey: cacheKey } = props;
                storage.remove(cacheKey);
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$6c4d37c7f376a1de), {});
        };
        const get = async (key)=>{
            await load();
            let val = cache.get(key);
            if (val) {
                if (removeExpiredEntry(key, val)) val = undefined;
            }
            syncWithDevTools((0, $43a74598c9c16cf3$export$1bb358554aac31c1), {
                [String(key)]: val
            });
            return val && val.value;
        };
        const update = async (key, value)=>{
            await load();
            const previousValue = cache.get(key);
            if (!previousValue) return;
            const entry = {
                value: value,
                timestamp: previousValue.timestamp
            };
            let storedContent = {};
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                storedContent = storage.get(props.cacheKey) || {};
                storedContent[key] = entry;
            }
            cache.set(key, entry);
            syncWithDevTools((0, $43a74598c9c16cf3$export$e271b26eefe41db8), {
                [String(key)]: entry
            });
            props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
        };
        const getEntries = async ()=>{
            await load();
            const entries = Array.from(cache.entries()).filter(([key, value])=>!removeExpiredEntry(key, value));
            syncWithDevTools((0, $43a74598c9c16cf3$export$9eb68924983e00fb), entries);
            return entries.map(([key, { value: value }])=>[
                    key,
                    value
                ]);
        };
        const deleteEntry = async (key)=>{
            await load();
            if (props.storageType !== (0, $43a74598c9c16cf3$export$bf340b99118a1511)) {
                const storedContent = storage.get(props.cacheKey) || {};
                delete storedContent[key];
                storage.set(props.cacheKey, storedContent);
            }
            cache.delete(key);
            syncWithDevTools((0, $43a74598c9c16cf3$export$4bd2facc4a3e6aa1), {
                [String(key)]: cache.get(key)
            });
        };
        const refresh = async ()=>{
            if (props.storageType === (0, $43a74598c9c16cf3$export$bf340b99118a1511)) return;
            cache.clear();
            hasSyncedFromStorage = false;
            await load();
        };
        if ((0, (0, parcelRequire("1NZBJ")).default).scopes.current !== (0, (0, parcelRequire("1NZBJ")).default).scopes.prev) clear();
        return {
            cache: cache,
            get: get,
            set: set,
            delete: deleteEntry,
            clear: clear,
            load: load,
            update: update,
            getEntries: getEntries,
            refresh: refresh
        };
    }
    const $3e46065a4b1d2500$var$cacheMap = {};
    const $3e46065a4b1d2500$var$getCache = async (props)=>{
        await (0, (0, parcelRequire("1NZBJ")).scopeGuard)().catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
        });
        const { cacheKey: cacheKey } = props;
        $3e46065a4b1d2500$var$cacheMap[cacheKey] = $3e46065a4b1d2500$var$cacheMap[cacheKey] || new $3e46065a4b1d2500$export$94affb487e701bf2(props);
        return $3e46065a4b1d2500$var$cacheMap[cacheKey];
    };
    const $3e46065a4b1d2500$export$710d301bf26d9700 = ()=>{
        Object.values($3e46065a4b1d2500$var$cacheMap).forEach((cache)=>cache.clear());
    };
    var $3e46065a4b1d2500$export$2e2bcd8739ae039 = $3e46065a4b1d2500$var$getCache;
});
const $43a74598c9c16cf3$export$7271276960377470 = 'common-cache';
const $43a74598c9c16cf3$export$a61768fefd33fcb1 = 'capacity exceeded';
const $43a74598c9c16cf3$export$6c4d37c7f376a1de = 'clear';
const $43a74598c9c16cf3$export$e271b26eefe41db8 = 'update';
const $43a74598c9c16cf3$export$4bd2facc4a3e6aa1 = 'delete';
const $43a74598c9c16cf3$export$26d12233004a7a60 = 'delete stale entry';
const $43a74598c9c16cf3$export$1bb358554aac31c1 = 'get';
const $43a74598c9c16cf3$export$61f74127e2b53cbe = 'hydrate';
const $43a74598c9c16cf3$export$5e8f180ef0142226 = 'set';
const $43a74598c9c16cf3$export$9eb68924983e00fb = 'get entries';
const $43a74598c9c16cf3$export$bf340b99118a1511 = 'memory';
const $43a74598c9c16cf3$export$2670cb7d5d4f7184 = 'local';
const $43a74598c9c16cf3$export$b796061ff0c82e1a = 'session';
parcelRegister("1AJVB", function(module, exports) {
    $parcel$export(module.exports, "props", ()=>$68c0e7b1e3ad3adb$export$8128bb6492cf3de7);
    const $68c0e7b1e3ad3adb$var$MAX_RESULTS = 10;
    const $68c0e7b1e3ad3adb$var$CACHE_SIZE = $68c0e7b1e3ad3adb$var$MAX_RESULTS * 2;
    const $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY = 'components';
    const $68c0e7b1e3ad3adb$export$8128bb6492cf3de7 = {
        size: $68c0e7b1e3ad3adb$var$CACHE_SIZE,
        cacheKey: $68c0e7b1e3ad3adb$var$COMPONENTS_CACHE_KEY,
        maxAge: 604800000,
        storageType: (0, $43a74598c9c16cf3$export$2670cb7d5d4f7184)
    };
});
parcelRegister("feQhf", function(module, exports) {
    $parcel$export(module.exports, "getGlobalComponentsProperty", ()=>$f3ade48088ec15c3$export$1db3503600a1638e);
    $parcel$export(module.exports, "setGlobalComponentsProperty", ()=>$f3ade48088ec15c3$export$71702a5b14caff65);
    var $jcw0u;
    var $eusud;
    const $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
    const $f3ade48088ec15c3$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
    const $f3ade48088ec15c3$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
    const $f3ade48088ec15c3$var$getProjectId = async (projectKey)=>{
        const project = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/project/${projectKey}`);
        return project?.id;
    };
    const $f3ade48088ec15c3$export$1db3503600a1638e = async (projectKey)=>{
        try {
            let endpoint;
            if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
                const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
                if (!projectId) return {
                    key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                    value: null
                };
                endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(endpoint);
        } catch (error) {
            if (error.statusCode === 404) return {
                key: $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getGlobalComponentsProperty',
                    packageName: 'jiraCompassCommon',
                    teamName: 'compass-lodestone'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectKey: projectKey
                }
            });
            throw error;
        }
    };
    async function $f3ade48088ec15c3$export$71702a5b14caff65(projectKey, value) {
        try {
            let endpoint;
            if (!$f3ade48088ec15c3$var$PROJECT_KEY_REGEX.test(projectKey)) {
                const projectId = await $f3ade48088ec15c3$var$getProjectId(projectKey);
                if (!projectId) return;
                endpoint = $f3ade48088ec15c3$var$url(projectId, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            } else endpoint = $f3ade48088ec15c3$var$url(projectKey, $f3ade48088ec15c3$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
            await (0, (0, parcelRequire("eusud")).performPutRequest)(endpoint, {
                body: JSON.stringify(value)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'setGlobalComponentsProperty',
                    packageName: 'jiraCompassCommon',
                    teamName: 'compass-lodestone'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectKey: projectKey
                }
            });
            throw error;
        }
    }
});
parcelRegister("as9La", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974a261702eec2af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iOwNT;
    var $koVbs;
    var $lElIo;
    var $2Icx9;
    var $lMeVa;
    const $974a261702eec2af$var$ComponentsSelectEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getNewInlineComponentCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, (0, parcelRequire("lMeVa")).default).createNewItem)})`, [
            formatNewInlineComponentCreateLabel,
            formatMessage
        ]);
        const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
            const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
            return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
        }, [
            canCreateNewItem,
            options
        ]);
        const handleInlineComponentCreate = (inputValue)=>{
            onChange([
                ...value || [],
                {
                    label: inputValue,
                    value: null
                }
            ]);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iOwNT")).default), {
            inputId: inputId,
            required: isRequired,
            ...fieldProps,
            value: value,
            options: options,
            placeholder: placeholder || formatMessage((0, (0, parcelRequire("lMeVa")).default).placeholder),
            onChange: onChange,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus: autoFocus,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            components: {
                MenuList: (menuListProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Icx9")).default), {
                        ...menuListProps,
                        showFooter: showFooter,
                        projectKey: projectKey
                    })
            },
            isMulti: true,
            isDisabled: isDisabled,
            isValidNewOption: isValidNewOption,
            formatCreateLabel: getNewInlineComponentCreateLabel,
            onCreateOption: handleInlineComponentCreate,
            className: "components-field-select",
            classNamePrefix: "components-field-select"
        });
    };
    var $974a261702eec2af$export$2e2bcd8739ae039 = $974a261702eec2af$var$ComponentsSelectEdit;
});
parcelRegister("2Icx9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5b255b0441ea615$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7ymNM;
    var $bChGW;
    var $koVbs;
    var $dyW5a;
    const $b5b255b0441ea615$var$MenuWithFooter = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, restProps, children), showFooter && (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$fd9000017733fabf, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$500fb058ad7aeb1, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$export$e0513c91be1318ca, {
            href: `/plugins/servlet/project-config/${projectKey}/administer-components`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
            label: "componentFooterAddIcon",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($b5b255b0441ea615$var$LinkText, null, footerLabel ?? formatMessage((0, (0, parcelRequire("dyW5a")).default).componentLabel))))));
    };
    var $b5b255b0441ea615$export$2e2bcd8739ae039 = $b5b255b0441ea615$var$MenuWithFooter;
    const $b5b255b0441ea615$var$LinkText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$fd9000017733fabf = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1yt41bpf _x3dope8f",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$500fb058ad7aeb1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41r6r _1bsb1osq _irr314ae",
                __cmplp.className
            ])
        });
    });
    const $b5b255b0441ea615$export$e0513c91be1318ca = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7ymNM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $57fd655943aa23fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57fd655943aa23fe$var$AddIcon = (props)=>$57fd655943aa23fe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
        }, props, {
            newIcon: $57fd655943aa23fe$var$_add.default
        }));
    $57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
    var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;
});
parcelRegister("dyW5a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86ca6088d964e72a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86ca6088d964e72a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        componentLabel: {
            "id": "issue-field-components-field.edit.menu.component-label",
            "defaultMessage": "Create new component"
        }
    });
});
parcelRegister("lMeVa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb020ac6d54b422f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb020ac6d54b422f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-components-field.edit.placeholder",
            "defaultMessage": "Select Component"
        },
        createNewItem: {
            "id": "issue-field-components-field.edit.create-new-item",
            "defaultMessage": "New Component"
        }
    });
});
parcelRegister("6Fkzt", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$4d2c67350b914b81$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$4d2c67350b914b81$export$ffef3a401aef987b);
    const $4d2c67350b914b81$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
                label: name,
                value: id
            }));
    const $4d2c67350b914b81$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
                id: value,
                name: label
            }));
});
parcelRegister("b399U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f31bbe63abb7b51a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $f31bbe63abb7b51a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.components-field.none",
            "defaultMessage": "None"
        },
        tooltipWhenDisabled: {
            "id": "issue-create-commons.components-field.tooltip-when-disabled",
            "defaultMessage": "We couldn't find any components for this project"
        }
    });
    var $f31bbe63abb7b51a$export$2e2bcd8739ae039 = $f31bbe63abb7b51a$var$messages;
});
parcelRegister("6vh1Z", function(module, exports) {
    $parcel$export(module.exports, "mutateComponentsField", ()=>$6f4dd9dc2621c172$export$499415d02c5db090);
    const $6f4dd9dc2621c172$export$499415d02c5db090 = (selectedComponents)=>({
            components: selectedComponents.reduce((acc, { value: value })=>{
                if (value !== null) acc.push({
                    componentId: value
                });
                return acc;
            }, [])
        });
});
parcelRegister("iPfC3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35cafe98c17438b5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $eb5hX;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $9K1c2;
    const $35cafe98c17438b5$export$c3b8fa1b9560fb7e = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        const getTeamEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eb5hX")).default), {
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: value,
                fieldId: fieldId,
                isInvalid: Boolean(error),
                isDisabled: !isEditable,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                fetchSuggestionsOnFocus: true,
                ariaLabelledBy: ariaLabelledBy
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, getTeamEdit()) : getTeamEdit());
    };
    var $35cafe98c17438b5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateCustomTeamsField),
        transformDefaultValue: (0, (0, parcelRequire("9K1c2")).transformDefaultTeam)
    })($35cafe98c17438b5$export$c3b8fa1b9560fb7e);
});
parcelRegister("eb5hX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$762657ba3faad803$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d7FF4;
    var $koVbs;
    var $lElIo;
    var $FtZX9;
    var $blh8O;
    var $b6swk;
    var $ibWtm;
    var $jv74C;
    const $762657ba3faad803$var$MenuList = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6swk")).default), props);
    const $762657ba3faad803$var$Option = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ibWtm")).default), props);
    const $762657ba3faad803$var$CustomTeamPickerEdit = (props)=>{
        const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const handleSearch = (0, (0, parcelRequire("FtZX9")).default)(async (query)=>(0, (0, parcelRequire("jv74C")).fetchTeams)(query || '', autoCompleteUrl), 300);
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await handleSearch();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        const noOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, (0, parcelRequire("blh8O")).default).noMatches), [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            fieldId: fieldId,
            ...defaultOptionsProps(),
            loadOptions: handleSearch,
            onChange: onChange,
            autoFocus: autoFocus,
            isClearable: Boolean(value),
            isMulti: false,
            value: value,
            validationState: isInvalid === true ? 'error' : null,
            components: {
                MenuList: $762657ba3faad803$var$MenuList,
                Option: $762657ba3faad803$var$Option
            },
            noOptionsMessage: noOptionsMessage,
            placeholder: placeholder,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            classNamePrefix: classNamePrefix,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $762657ba3faad803$export$2e2bcd8739ae039 = $762657ba3faad803$var$CustomTeamPickerEdit;
});
parcelRegister("blh8O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47204223650b9e34$export$2e2bcd8739ae039);
    var $7VHMR;
    const $47204223650b9e34$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        menuHeader: {
            "id": "issue-field-custom-team.menu-header",
            "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
        },
        noMatches: {
            "id": "issue-field-custom-team.no-matches",
            "defaultMessage": "No Matches"
        },
        menuFooter: {
            "id": "issue-field-custom-team.menu-footer",
            "defaultMessage": "Showing 100 results. To display more results, please refine your search."
        }
    });
    var $47204223650b9e34$export$2e2bcd8739ae039 = $47204223650b9e34$var$messages;
});
parcelRegister("b6swk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7d58b272b039ad0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bChGW;
    var $koVbs;
    var $blh8O;
    const $b7d58b272b039ad0$var$MenuListComponent = (props)=>{
        const { options: options } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const footer = options.length > 0 && options[0].moreResultsAvailable ? (0, ($parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$MenuFooterText, null, formatMessage((0, (0, parcelRequire("blh8O")).default).menuFooter)) : null;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).MenuList, props, (0, ($parcel$interopDefault($5uXOq))).createElement($b7d58b272b039ad0$var$Container, null, formatMessage((0, (0, parcelRequire("blh8O")).default).menuHeader)), props.children, footer));
    };
    var $b7d58b272b039ad0$export$2e2bcd8739ae039 = $b7d58b272b039ad0$var$MenuListComponent;
    const $b7d58b272b039ad0$var$MenuFooterText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1ifp _11c81oud _1yt41pyq",
                __cmplp.className
            ])
        });
    });
    const $b7d58b272b039ad0$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41pyq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ibWtm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82bc7e69d2cb0c6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $bChGW;
    var $7KPXo;
    const $82bc7e69d2cb0c6a$var$OptionComponent = (props)=>{
        const value = props.data;
        if (value) {
            const { avatarUrl: avatarUrl, label: label } = value;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionWrapper, null, avatarUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$Icon, {
                src: avatarUrl,
                alt: label
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $82bc7e69d2cb0c6a$var$boxStyle
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7KPXo")).default), {
                alt: ""
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($82bc7e69d2cb0c6a$var$OptionText, null, props.children))));
        }
        return null;
    };
    var $82bc7e69d2cb0c6a$export$2e2bcd8739ae039 = $82bc7e69d2cb0c6a$var$OptionComponent;
    const $82bc7e69d2cb0c6a$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bahv2br _1yt4otz2",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$OptionText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
    const $82bc7e69d2cb0c6a$var$boxStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '16px',
        width: '16px',
        marginRight: 'space.100'
    });
});
parcelRegister("7KPXo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f6eecaecb2670c4$export$2e2bcd8739ae039);
    var $dCLgq;
    var $6oKGV = parcelRequire("6oKGV");
    const $6f6eecaecb2670c4$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($6oKGV)),
        srcDark: ($parcel$interopDefault($6oKGV))
    });
    var $6f6eecaecb2670c4$export$2e2bcd8739ae039 = $6f6eecaecb2670c4$var$Illustration;
    const $6f6eecaecb2670c4$export$a179c88182cb9d56 = [
        0,
        0,
        596,
        596
    ];
});
parcelRegister("6oKGV", function(module, exports) {
    module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();
});
parcelRegister("jv74C", function(module, exports) {
    $parcel$export(module.exports, "transformTeamFieldTypeString", ()=>$dbbd6d0fcad033b6$export$f7d628c77d5447d0);
    $parcel$export(module.exports, "fetchTeams", ()=>$dbbd6d0fcad033b6$export$a789e725ac68b08d);
    var $eusud;
    const $dbbd6d0fcad033b6$export$4accbe1c2fbc55dd = (team)=>({
            label: team.title,
            value: team.id.toString(),
            isShared: team.shareable,
            avatarUrl: team.avatarUrl
        });
    const $dbbd6d0fcad033b6$export$f7d628c77d5447d0 = (team)=>{
        if (team) return team.value.toString();
        return null;
    };
    const $dbbd6d0fcad033b6$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(autoCompleteUrl, {
            body: JSON.stringify({
                excludedIds: [],
                maxResults: 100,
                query: query
            })
        });
        if (response) {
            const teams = response.teams.map($dbbd6d0fcad033b6$export$4accbe1c2fbc55dd);
            return [
                {
                    moreResultsAvailable: response.moreResultsAvailable,
                    options: teams
                }
            ];
        }
        return [];
    };
});
parcelRegister("9K1c2", function(module, exports) {
    $parcel$export(module.exports, "mutateTeamField", ()=>$e945ecd21dcd5234$export$8db32a33b76e5823);
    $parcel$export(module.exports, "transformDefaultTeam", ()=>$e945ecd21dcd5234$export$d2d64eb763c850a1);
    const $e945ecd21dcd5234$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
            fieldId: fieldId,
            mutationGroup: (0, $0a8c3ec56489edc2$export$31fd86f8f183952c),
            team: {
                teamId: selectedTeam.value
            }
        } : null;
    const $e945ecd21dcd5234$export$d2d64eb763c850a1 = (team)=>({
            label: team.name,
            value: team.teamId,
            isShared: true
        });
});
const $0a8c3ec56489edc2$export$31fd86f8f183952c = 'teamFields';
parcelRegister("2p4Te", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca41b2b247877065$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2x3Cb;
    var $kgoHi;
    var $74sEg;
    var $gwIPs;
    var $7CMCs;
    var $koVbs;
    var $7C5S0;
    var $52tuV;
    const $ca41b2b247877065$var$DataClassificationField = (props)=>{
        const { width: width, value: value, onChange: onChange, allowedValues: allowedValues, errorMessage: errorMessage, isDisabled: isDisabled, nonEditableReason: nonEditableReason } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "dataClassificationField",
            packageName: "jiraIssueCreateCommons",
            fallback: "unmount",
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width,
            marginTop: (0, (0, parcelRequire("gwIPs")).gridSize) * 2.25,
            paddingBottom: (0, (0, parcelRequire("gwIPs")).gridSize) * 2.25
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: "data-classification-dropdown-input",
            id: "data-classification-select"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            justifyContent: "start"
        }, formatMessage((0, (0, parcelRequire("52tuV")).default).classificationFieldLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("74sEg")).DataClassificationDropdown), {
            options: allowedValues,
            value: value,
            onChange: onChange,
            isDisabled: isDisabled,
            disabledTooltipMessage: nonEditableReason?.message,
            errorMessage: errorMessage
        })));
    };
    var $ca41b2b247877065$export$2e2bcd8739ae039 = $ca41b2b247877065$var$DataClassificationField;
});
parcelRegister("iY8FG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f022abefd67c0e3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cHapz;
    var $4R6GH;
    var $koVbs;
    var $1p96B;
    var $DVljb;
    var $7C5S0;
    var $hpV4g;
    var $9FL4D;
    var $jGVMX;
    var $eVzdP;
    const $f022abefd67c0e3c$var$DateField = (props)=>{
        const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const weekStartDay = (0, (0, parcelRequire("1p96B")).getLocale)(locale)?.options?.weekStartsOn;
        const safeValue = value === null ? undefined : value;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHapz")).default), {
            value: safeValue,
            isDisabled: isReadOnly,
            onChange: onChange,
            autoFocus: autoFocus,
            locale: locale,
            isInvalid: Boolean(error),
            selectProps: {
                onKeyDown: (0, (0, parcelRequire("9FL4D")).preventFormSubmitOnEnterKeyPress)
            },
            weekStartDay: weekStartDay,
            label: formatMessage((0, (0, parcelRequire("eVzdP")).default).ariaLabel),
            "aria-describedby": `${id}-helper`,
            id: id,
            placeholder: formatMessage((0, (0, parcelRequire("eVzdP")).default).placeholder),
            shouldShowCalendarButton: (0, (0, parcelRequire("4R6GH")).fg)('dst-enable-new-calendar-button-on-jira'),
            inputLabel: (0, (0, parcelRequire("4R6GH")).fg)('dst-enable-new-calendar-button-on-jira') ? formatMessage((0, (0, parcelRequire("eVzdP")).default).ariaLabel) : undefined
        }));
    };
    var $f022abefd67c0e3c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($f022abefd67c0e3c$var$DateField);
});
parcelRegister("cHapz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a844b50b385d50f7$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $2TI0z;
    var $jcbUF;
    const $a844b50b385d50f7$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    var $a844b50b385d50f7$export$2e2bcd8739ae039 = $a844b50b385d50f7$var$DatePicker;
});
parcelRegister("cKsfY", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$8f027f90da2b6bac$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("2TI0z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19201d0a1f7d7d54$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $19201d0a1f7d7d54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
    const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
    const $19201d0a1f7d7d54$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $19201d0a1f7d7d54$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
        defaultIsOpen: false,
        defaultValue: '',
        disabled: [],
        disabledDateFilter: (_)=>false,
        locale: 'en-US',
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $19201d0a1f7d7d54$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $19201d0a1f7d7d54$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        insetBlockStart: 0,
        insetInlineEnd: 0,
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles = {
        name: "jd0mtf",
        styles: "margin-inline-end:var(--ds-space-400, 2rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew = {
        name: "129q61y",
        styles: "margin-inline-end:var(--ds-space-050, 0.25rem)"
    };
    const $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles = {
        name: "sz3drw",
        styles: "margin-inline-end:var(--ds-space-025, 0.125rem)"
    };
    const $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $19201d0a1f7d7d54$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
        }
        constructor(props){
            super(props), this.containerRef = null, this.calendarRef = (0, $5uXOq.createRef)(), this.calendarButtonRef = (0, $5uXOq.createRef)(), this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
                this.setState({
                    calendarValue: (0, (0, parcelRequire("5RLF6")).getParsedISO)({
                        iso: iso
                    })
                });
            }, this.onCalendarSelect = ({ iso: iso })=>{
                this.setState({
                    selectInputValue: '',
                    isOpen: false,
                    calendarValue: iso,
                    value: iso,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onChange(iso);
                if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                this.setState({
                    isOpen: false
                });
            }, this.onInputClick = ()=>{
                if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onContainerBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (!this.containerRef?.contains(newlyFocusedElement)) {
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    this.props.onBlur(event);
                }
            }, this.onContainerFocus = ()=>{
                this.setState({
                    shouldSetFocusOnCurrentDay: false
                });
            }, this.onSelectBlur = (event)=>{
                const newlyFocusedElement = event.relatedTarget;
                if (this.state.clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else if (!this.containerRef?.contains(newlyFocusedElement)) this.setState({
                    isOpen: false,
                    isFocused: false,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onSelectFocus = (event)=>{
                const { clearingFromIcon: clearingFromIcon } = this.state;
                const value = this.getValue();
                if (clearingFromIcon) this.setState({
                    clearingFromIcon: false
                });
                else this.setState({
                    isOpen: !this.props.shouldShowCalendarButton,
                    calendarValue: value,
                    isFocused: true,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onFocus(event);
            }, this.onTextInput = (event)=>{
                const inputValue = event.target.value;
                if (inputValue) {
                    const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                        parseInputValue: this.props.parseInputValue,
                        dateFormat: this.props.dateFormat,
                        l10n: this.state.l10n
                    });
                    if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) this.setState({
                        calendarValue: (0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed)
                    });
                }
                this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
            }, this.onInputKeyDown = (event)=>{
                const { calendarValue: calendarValue } = this.state;
                const value = this.getValue();
                const keyPressed = event.key.toLowerCase();
                if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                    isOpen: true,
                    wasOpenedFromCalendarButton: false
                });
                switch(keyPressed){
                    case 'escape':
                        if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                        else {
                            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                            innerCombobox?.focus();
                        }
                        this.setState({
                            isOpen: false,
                            shouldSetFocusOnCurrentDay: false,
                            wasOpenedFromCalendarButton: false
                        });
                        break;
                    case 'backspace':
                    case 'delete':
                        {
                            const inputCount = 0;
                            if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) this.setState({
                                clearingFromIcon: false,
                                value: ''
                            });
                            break;
                        }
                    case 'enter':
                        if (!this.state.isOpen) return;
                        event.preventDefault();
                        if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                            disabled: this.props.disabled
                        })) {
                            const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                            const valueChanged = safeCalendarValue !== value;
                            this.setState({
                                selectInputValue: '',
                                isOpen: false,
                                value: safeCalendarValue,
                                calendarValue: safeCalendarValue,
                                wasOpenedFromCalendarButton: false
                            });
                            if (valueChanged) this.props.onChange(safeCalendarValue);
                        }
                        break;
                    case 'arrowdown':
                    case 'arrowup':
                        if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                            isOpen: true,
                            shouldSetFocusOnCurrentDay: true
                        });
                        break;
                    default:
                        break;
                }
            }, this.onCalendarButtonKeyDown = (e)=>{
                if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
                if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                    e.stopPropagation();
                    this.setState({
                        isKeyDown: true,
                        wasOpenedFromCalendarButton: true
                    });
                }
            }, this.onCalendarButtonClick = (e)=>{
                this.setState({
                    isOpen: !this.state.isOpen,
                    wasOpenedFromCalendarButton: true
                }, ()=>{
                    if (!this.state.isKeyDown) return;
                    this.setState({
                        isKeyDown: false
                    });
                    this.calendarRef?.current?.querySelector('button')?.focus();
                });
                e.stopPropagation();
            }, this.onClear = ()=>{
                let changedState = {
                    value: '',
                    calendarValue: this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date())
                };
                if (!this.props.hideIcon) changedState = {
                    ...changedState,
                    clearingFromIcon: true
                };
                this.setState(changedState);
                this.props.onChange('');
            }, this.onSelectChange = (_value, action)=>{
                if (action.action === 'clear') this.onClear();
            }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
                const onInputChange = this.props.selectProps?.onInputChange;
                if (onInputChange) onInputChange(selectInputValue, actionMeta);
                this.setState({
                    selectInputValue: selectInputValue
                });
            }, this.getContainerRef = (ref)=>{
                const oldRef = this.containerRef;
                this.containerRef = ref;
                if (oldRef == null && ref != null) this.forceUpdate();
            };
            this.state = {
                isKeyDown: false,
                isOpen: this.props.defaultIsOpen,
                isFocused: false,
                clearingFromIcon: false,
                selectInputValue: this.props.selectProps?.inputValue || '',
                value: this.props.value || this.props.defaultValue,
                calendarValue: this.props.value || this.props.defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()),
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(this.props.locale),
                locale: this.props.locale,
                shouldSetFocusOnCurrentDay: false,
                wasOpenedFromCalendarButton: false
            };
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.locale !== prevState.locale) return {
                l10n: (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(nextProps.locale),
                locale: nextProps.locale
            };
            else return null;
        }
        render() {
            const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = $19201d0a1f7d7d54$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
            const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
            const value = this.getValue();
            let actualSelectInputValue;
            actualSelectInputValue = selectInputValue;
            const menuIsOpen = this.getIsOpen() && !isDisabled;
            const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
            let clearIndicator = Icon;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                    xcss: $19201d0a1f7d7d54$var$dropdownIndicatorStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
            const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
            const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
                lang: this.props.locale
            });
            const selectComponents = {
                DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
                ...shouldShowCalendarButton ? {
                    IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                            ...props,
                            showClearIndicator: showClearIndicator
                        })
                } : {},
                Menu: (0, parcelRequire("gtijU")).Menu,
                SingleValue: SingleValue,
                ...!showClearIndicator && {
                    ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
                }
            };
            const { styles: selectStyles = {} } = selectProps;
            const disabledStyle = isDisabled ? {
                pointerEvents: 'none',
                color: "var(--ds-icon-disabled, inherit)"
            } : {};
            const calendarProps = {
                calendarContainerRef: this.containerRef,
                calendarDisabled: disabled,
                calendarDisabledDateFilter: disabledDateFilter,
                calendarMaxDate: maxDate,
                calendarMinDate: minDate,
                calendarRef: this.calendarRef,
                calendarValue: value && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(value)),
                calendarView: calendarValue,
                onCalendarChange: this.onCalendarChange,
                onCalendarSelect: this.onCalendarSelect,
                calendarLocale: locale,
                calendarWeekStartDay: weekStartDay,
                shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay
            };
            const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        paddingRight: "var(--ds-space-075, 6px)"
                    })
            });
            const initialValue = value ? {
                label: (0, (0, parcelRequire("5RLF6")).formatDate)(value, {
                    formatDisplayLabel: this.props.formatDisplayLabel,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }),
                value: value
            } : null;
            const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ...innerProps,
                css: $19201d0a1f7d7d54$var$pickerContainerStyles,
                role: "presentation",
                onBlur: this.onContainerBlur,
                onFocus: this.onContainerFocus,
                onClick: this.onInputClick,
                onInput: this.onTextInput,
                onKeyDown: this.onInputKeyDown,
                ref: this.getContainerRef,
                "data-testid": testId && `${testId}--container`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
                appearance: this.props.appearance,
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                components: selectComponents,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: this.onSelectBlur,
                onChange: this.onSelectChange,
                onFocus: this.onSelectFocus,
                onInputChange: this.handleSelectInputChange,
                placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                    placeholder: this.props.placeholder,
                    l10n: this.state.l10n
                }),
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
            }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9KnKW")).IdProvider), {
                prefix: "open-calendar-label--"
            }, ({ id: openCalendarLabelId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $19201d0a1f7d7d54$var$iconContainerStyles,
                        value && !hideIcon ? $19201d0a1f7d7d54$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStylesNew : $19201d0a1f7d7d54$var$iconSpacingWithoutClearButtonStyles
                    ]
                }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
                    id: openCalendarLabelId
                }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                    ...inputLabelId ? {
                        'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
                    } : {
                        'aria-label': fullopenCalendarLabel
                    },
                    onClick: this.onCalendarButtonClick,
                    onKeyDown: this.onCalendarButtonKeyDown,
                    ref: this.calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`,
                    type: "button",
                    backgroundColor: "color.background.neutral.subtle",
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
                    xcss: [
                        $19201d0a1f7d7d54$var$calendarButtonStyles,
                        (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $19201d0a1f7d7d54$var$calendarButtonFixedSizeStyles
                    ]
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($19201d0a1f7d7d54$var$CalendarIcon, {
                    label: "",
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                        color: "var(--ds-icon, #44546F)"
                    } : {
                        primaryColor: "var(--ds-icon, #44546F)"
                    }
                })))) : null));
        }
    }
    const $19201d0a1f7d7d54$var$DatePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'datePicker',
        packageName: $19201d0a1f7d7d54$var$packageName,
        packageVersion: $19201d0a1f7d7d54$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'selectedDate',
            actionSubject: 'datePicker',
            attributes: {
                componentName: 'datePicker',
                packageName: $19201d0a1f7d7d54$var$packageName,
                packageVersion: $19201d0a1f7d7d54$var$packageVersion
            }
        })
    })($19201d0a1f7d7d54$export$df43d21f5faca9f7));
    var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;
});
parcelRegister("acknU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));
    var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
    function $76cad653a4883392$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $76cad653a4883392$var$CalendarIcon = (props)=>$76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
            LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
        }, props));
    $76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
    var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;
});
parcelRegister("3fesp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $25cdfcb8bb836404$var$_UNSAFE_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $25cdfcb8bb836404$var$CalendarIcon = (props)=>$25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 6.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V6.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h2.25m-3.5 5h12.5m0 0V3c0-.69-.56-1.25-1.25-1.25h-2.25m-5.5 0V0m0 1.75V4.5m0-2.75h5.5m0 0V0m0 1.75V4.5"/>`
        }, props));
    $25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
    var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;
});
parcelRegister("cTemL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
    function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9625c3edd02eaf26$var$CalendarIcon = (props)=>$9625c3edd02eaf26$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
        }, props, {
            newIcon: $9625c3edd02eaf26$var$_calendar.default
        }));
    $9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
    var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;
});
parcelRegister("7qZ1x", function(module, exports) {
    $parcel$export(module.exports, "createLocalizationProvider", ()=>$71bdd27445bf5301$export$ea56ca58f08ffa52);
    var $lCAti;
    var $is0Fy;
    var $1cWOp;
    const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
        const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
                hour: 'numeric',
                minute: 'numeric'
            }).format(date);
        const getDays = (weekStartDay = 0, length)=>{
            const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
                weekday: length
            });
            const weekdays = [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ];
            const rotatedWeekdays = weekStartDay > 0 ? [
                ...weekdays.slice(weekStartDay),
                ...weekdays.slice(0, weekStartDay)
            ] : weekdays;
            return rotatedWeekdays.map((day)=>{
                const result = dayFormatter.format(new Date(2000, 9, day + 1, 12)).replace(/[\s\u200E]/g, '');
                if (length === 'short') return result.substring(0, 3);
                else return result;
            });
        };
        const getDaysShort = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'short');
        };
        const getDaysLong = (weekStartDay = 0)=>{
            return getDays(weekStartDay, 'long');
        };
        const getMonthsLong = ()=>{
            const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
                month: 'long'
            });
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ].map((month)=>monthFormatter.format(new Date(2020, month, 1)));
        };
        const parseDate = (date)=>(0, (0, parcelRequire("is0Fy")).createDateParser)(normalizedLocale)(date);
        const formatToParts = (date = new Date())=>{
            const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
            const fixedDate = new Date(date);
            fixedDate.setFullYear(2020);
            const fixedParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(fixedDate));
            const originalParts = (0, (0, parcelRequire("1cWOp")).toFormattedParts)(formatter.formatToParts(date));
            if (fixedParts.year) fixedParts.year = originalParts.year;
            if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
            return fixedParts;
        };
        return {
            getDaysShort: getDaysShort,
            getDaysLong: getDaysLong,
            getMonthsLong: getMonthsLong,
            formatDate: formatDate,
            formatTime: formatTime,
            parseDate: parseDate,
            formatToParts: formatToParts
        };
    };
});
parcelRegister("lCAti", function(module, exports) {
    $parcel$export(module.exports, "normalizeLocale", ()=>$13af55a9724edafd$export$dca0327c9b9c6498);
    const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
});
parcelRegister("is0Fy", function(module, exports) {
    $parcel$export(module.exports, "createDateParser", ()=>$d8bb223589902df4$export$cfa2ef2687faeda2);
    var $3wYKB;
    var $lCAti;
    const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
    const $d8bb223589902df4$var$INVARIANT = {
        year: 1993,
        month: 2,
        day: 18
    };
    const $d8bb223589902df4$var$INVARIANT_DATE = (0, (0, parcelRequire("3wYKB")).toDate)($d8bb223589902df4$var$INVARIANT);
    const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
    const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
    const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
    const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
        return matchResult.splice(1, 4).map((datePart)=>parseInt(datePart, 10));
    };
    const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
        const normalizedLocale = (0, (0, parcelRequire("lCAti")).normalizeLocale)(locale);
        const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
        const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
        const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
        const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
        if (!formatMatch) throw new Error('Unable to create DateParser');
        const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
        const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
        const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
        const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
        return (date)=>{
            const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
            if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
            const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
            const extractedDate = {
                year: dateParts[yearPosition],
                month: dateParts[monthPosition],
                day: dateParts[dayPosition]
            };
            const normalizedDate = (0, (0, parcelRequire("3wYKB")).normalizeDate)(extractedDate);
            if (!(0, (0, parcelRequire("3wYKB")).isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
            return (0, (0, parcelRequire("3wYKB")).toDate)(normalizedDate);
        };
    };
});
parcelRegister("3wYKB", function(module, exports) {
    $parcel$export(module.exports, "toDate", ()=>$121d324fc62f760d$export$e67a095c620b86fe);
    $parcel$export(module.exports, "isValid", ()=>$121d324fc62f760d$export$1ea939691cdc45b8);
    $parcel$export(module.exports, "normalizeDate", ()=>$121d324fc62f760d$export$fcc71269590ba0a8);
    const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        });
    const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>new Date(date.year, date.month - 1, date.day);
    const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    };
    const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
        if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
        return [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ][month - 1];
    };
    const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
        const { year: year, month: month, day: day } = date;
        const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
        return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
    };
    const $121d324fc62f760d$export$fcc71269590ba0a8 = (date)=>{
        const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
        const { year: year, month: month, day: day } = date;
        const fullYear = year < 100 ? 2000 + year : year;
        const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
        const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
        const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
        return {
            year: normalizedYear,
            month: normalizedMonth,
            day: normalizedDay
        };
    };
});
parcelRegister("1cWOp", function(module, exports) {
    $parcel$export(module.exports, "toFormattedParts", ()=>$56bd04270448c035$export$9b7ca29af37c192);
    const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
                ...result,
                [datePart.type]: datePart.value
            }), {});
});
parcelRegister("jHBnA", function(module, exports) {
    $parcel$export(module.exports, "EmptyComponent", ()=>$91948b176ea23188$export$5e30e9a24d6c1203);
    $parcel$export(module.exports, "placeholderDatetime", ()=>$91948b176ea23188$export$fff8babee5abe3e2);
    $parcel$export(module.exports, "defaultTimes", ()=>$91948b176ea23188$export$b42ffb9f09b1861b);
    $parcel$export(module.exports, "defaultTimeFormat", ()=>$91948b176ea23188$export$9e6d8fcf62256b85);
    $parcel$export(module.exports, "defaultDateFormat", ()=>$91948b176ea23188$export$75032c84f56650eb);
    $parcel$export(module.exports, "padToTwo", ()=>$91948b176ea23188$export$a7de57e5b672ccdb);
    $parcel$export(module.exports, "formatDateTimeZoneIntoIso", ()=>$91948b176ea23188$export$2eeb05a2ecc2ce0a);
    const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
    const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
    const $91948b176ea23188$export$b42ffb9f09b1861b = [
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00'
    ];
    const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
    const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
    function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
        return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
    }
    function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
        const needsLeadingZero = /^\d:/;
        const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
        return `${date}T${sanitizedTime}${zone}`;
    }
});
parcelRegister("5RLF6", function(module, exports) {
    $parcel$export(module.exports, "isDateDisabled", ()=>$e0db4b6edb7dbfac$export$d38e7e283938128c);
    $parcel$export(module.exports, "getParsedISO", ()=>$e0db4b6edb7dbfac$export$38db26406d1a1ee2);
    $parcel$export(module.exports, "parseDate", ()=>$e0db4b6edb7dbfac$export$6b862160d295c8e);
    $parcel$export(module.exports, "formatDate", ()=>$e0db4b6edb7dbfac$export$3ae94a2503e890a1);
    $parcel$export(module.exports, "getPlaceholder", ()=>$e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
    var $k7m40;
    var $5I2ju;
    var $eZDAP;
    var $2ucUe;
    var $jHBnA;
    const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
        const { disabled: disabled } = di;
        return disabled.indexOf(date) > -1;
    };
    const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
        const { iso: iso } = di;
        const [year, month, date] = iso.split('-');
        let newIso = iso;
        const parsedDate = parseInt(date, 10);
        const parsedMonth = parseInt(month, 10);
        const parsedYear = parseInt(year, 10);
        const lastDayInMonth = (0, (0, parcelRequire("5I2ju")).default)(new Date(parsedYear, parsedMonth - 1)).getDate();
        if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(lastDayInMonth)}`;
        else newIso = `${parsedYear}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedMonth)}-${(0, (0, parcelRequire("jHBnA")).padToTwo)(parsedDate)}`;
        return newIso;
    };
    const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
        const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
        if (parseInputValue) return parseInputValue(date, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        return l10n.parseDate(date);
    };
    const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
        const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
        if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, (0, parcelRequire("jHBnA")).defaultDateFormat));
        const date = (0, (0, parcelRequire("eZDAP")).default)(value);
        return dateFormat ? (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(dateFormat)) : l10n.formatDate(date);
    };
    const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
        const { placeholder: placeholder, l10n: l10n } = di;
        return placeholder || l10n.formatDate((0, (0, parcelRequire("jHBnA")).placeholderDatetime));
    };
});
parcelRegister("2ucUe", function(module, exports) {
    $parcel$export(module.exports, "convertTokens", ()=>$ca6f20a476eda5dc$export$4d5430175be73d45);
    const $ca6f20a476eda5dc$var$tokensMap = {
        M: 'L',
        Mo: 'Mo',
        MM: 'LL',
        MMM: 'LLL',
        MMMM: 'LLLL',
        Q: 'q',
        Qo: 'qo',
        D: 'd',
        Do: 'do',
        DD: 'dd',
        DDD: 'D',
        DDDo: 'Do',
        DDDD: 'DDD',
        d: 'i',
        do: 'io',
        dd: 'iiiiii',
        ddd: 'iii',
        dddd: 'iiii',
        A: 'a',
        a: 'a',
        aa: 'aaaa',
        E: 'i',
        W: 'I',
        Wo: 'Io',
        WW: 'II',
        YY: 'yy',
        YYYY: 'yyyy',
        GG: 'RR',
        GGGG: 'RRRR',
        H: 'H',
        HH: 'HH',
        h: 'h',
        hh: 'hh',
        m: 'm',
        mm: 'mm',
        s: 's',
        ss: 'ss',
        S: 'S',
        SS: 'SS',
        SSS: 'SSS',
        Z: 'xxx',
        ZZ: 'xx',
        X: 't',
        x: 'T'
    };
    const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
    const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp("(\\[[^\\[]*\\])|(\\\\)?('.+'|" + $ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
    function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
        const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
        if (!tokensCaptures) return format;
        return tokensCaptures.reduce((parsed, tokenString, index)=>{
            const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
            if (!v2token) {
                const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
                if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
                else parsed.escapedTextBuffer.push(tokenString);
            }
            const endOfString = index === tokensCaptures.length - 1;
            if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
                const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
                parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
                parsed.escapedTextBuffer = [];
            }
            if (v2token) parsed.formatBuffer.push(v2token);
            return parsed;
        }, {
            formatBuffer: [],
            escapedTextBuffer: []
        }).formatBuffer.join('');
    }
});
parcelRegister("iaQLg", function(module, exports) {
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$d73476b891de3e0c$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $bChGW;
    function $d73476b891de3e0c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d73476b891de3e0c$var$calendarButtonInclusionStyles = {
        name: "i3e4rp",
        styles: "margin-inline-start:var(--ds-space-400, 32px)"
    };
    const $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles = {
        name: "19a3ait",
        styles: "margin-inline-start:var(--ds-space-300, 24px)"
    };
    const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: showClearIndicator ? $d73476b891de3e0c$var$calendarButtonInclusionStyles : $d73476b891de3e0c$var$calendarButtonOnlyInclusionStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).IndicatorsContainer, rest));
});
parcelRegister("gtijU", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e800a879ee1613fc$export$d9b273488cd8ce6f);
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $1f0Hs;
    var $9MHPe;
    var $k5uoT;
    var $avHVh;
    function $e800a879ee1613fc$var$getValidDate(isos) {
        return isos.reduce((acc, iso)=>{
            const date = (0, (0, parcelRequire("eZDAP")).default)(iso);
            return (0, (0, parcelRequire("jovBr")).default)(date) ? {
                day: date.getDate(),
                month: date.getMonth() + 1,
                year: date.getFullYear()
            } : acc;
        }, {});
    }
    const $e800a879ee1613fc$var$menuStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog(),
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
        overflow: 'hidden'
    });
    const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
        const { calendarValue: calendarValue, calendarView: calendarView } = selectProps;
        const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
            calendarValue,
            calendarView
        ]);
        const onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $e800a879ee1613fc$var$menuStyles,
                ...innerProps,
                onMouseDown: onMenuMouseDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1f0Hs")).default), {
                day: day,
                month: month,
                year: year,
                disabled: selectProps.calendarDisabled,
                disabledDateFilter: selectProps.calendarDisabledDateFilter,
                minDate: selectProps.calendarMinDate,
                maxDate: selectProps.calendarMaxDate,
                nextMonthLabel: selectProps.nextMonthLabel,
                onChange: selectProps.onCalendarChange,
                onSelect: selectProps.onCalendarSelect,
                previousMonthLabel: selectProps.previousMonthLabel,
                ref: selectProps.calendarRef,
                selected: [
                    selectProps.calendarValue
                ],
                shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                locale: selectProps.calendarLocale,
                testId: selectProps.testId && `${selectProps.testId}--calendar`,
                weekStartDay: selectProps.calendarWeekStartDay
            })),
            testId: selectProps.testId
        }));
    };
});
parcelRegister("1f0Hs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16abbcd9b9109722$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $9KnKW;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $ePz3p;
    var $lJWdi;
    var $avO9B;
    var $iioJV;
    var $jihAA;
    var $bbnGB;
    var $hbcve;
    var $2TGJ3;
    var $f9D1v;
    var $9efze;
    const $16abbcd9b9109722$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-block',
        userSelect: 'none'
    });
    const $16abbcd9b9109722$var$analyticsAttributes = {
        componentName: 'calendar',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $16abbcd9b9109722$var$InnerCalendar = (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultSelected: defaultSelected = (0, (0, parcelRequire("iioJV")).blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: onChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: onFocus = (0, (0, parcelRequire("eGmKJ")).default), onSelect: onSelect = (0, (0, parcelRequire("eGmKJ")).default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
        const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, (0, parcelRequire("jihAA")).default)({
            day: day,
            defaultDay: defaultDay,
            month: month,
            defaultMonth: defaultMonth,
            year: year,
            defaultYear: defaultYear,
            today: today,
            selected: selected,
            defaultSelected: defaultSelected,
            previouslySelected: previouslySelected,
            defaultPreviouslySelected: defaultPreviouslySelected
        });
        const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
        const onChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, (0, parcelRequire("2TGJ3")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            shouldSetFocus: [
                shouldSetFocus,
                setShouldSetFocus
            ],
            onChange: onChangeWithAnalytics
        });
        const onSelectWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onSelect,
            action: 'selected',
            analyticsData: analyticsContext,
            ...$16abbcd9b9109722$var$analyticsAttributes
        });
        const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, (0, parcelRequire("f9D1v")).default)({
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                ,
                setPreviouslySelectedValue
            ],
            onSelect: onSelectWithAnalytics,
            navigate: navigate
        });
        const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, (0, parcelRequire("bbnGB")).default)({
            onFocus: onFocus,
            onBlur: onBlur
        });
        const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, (0, parcelRequire("9efze")).default)({
            locale: locale,
            weekStartDay: weekStartDay
        });
        const weeks = (0, (0, parcelRequire("hbcve")).default)({
            day: dayValue,
            month: monthValue,
            year: yearValue,
            today: todayValue,
            selected: selectedValue,
            previouslySelected: previouslySelectedValue,
            disabled: disabled,
            disabledDateFilter: disabledDateFilter,
            minDate: minDate,
            maxDate: maxDate,
            daysLong: daysLong,
            weekStartDay: weekStartDay
        });
        const getNextHeading = ()=>{
            const nextMonth = monthValue % 12;
            const showNextYear = monthValue === 12;
            return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
        };
        const getPreviousHeading = ()=>{
            const previousMonth = (monthValue + 12 - 2) % 12;
            const showPreviousYear = monthValue === 1;
            return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
        };
        const headerId = (0, (0, parcelRequire("9KnKW")).useId)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            className: className,
            style: style,
            onBlur: handleContainerBlur,
            onFocus: handleContainerFocus,
            "data-testid": testId && `${testId}--container`,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $16abbcd9b9109722$var$boxStyles,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ePz3p")).default), {
            monthLongTitle: monthsLong[monthValue - 1],
            year: yearValue,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel,
            nextHeading: getNextHeading(),
            previousHeading: getPreviousHeading(),
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev,
            headerId: headerId,
            tabIndex: tabIndex,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "grid",
            onKeyDown: handleContainerKeyDown,
            "aria-labelledby": headerId,
            testId: testId && `${testId}--calendar-dates`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avO9B")).default), {
            daysShort: daysShort,
            testId: testId
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lJWdi")).default), {
            weeks: weeks,
            handleClickDay: handleClickDay,
            monthsLong: monthsLong,
            shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
            tabIndex: tabIndex,
            testId: testId
        }))))));
    });
    const $16abbcd9b9109722$var$Calendar = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Calendar(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($16abbcd9b9109722$var$InnerCalendar, {
            ...props,
            ref: ref
        });
    }));
    $16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
    var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;
});
parcelRegister("ePz3p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995afee12cb828f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $42CjB;
    var $9KnKW;
    var $l1N8i;
    var $fmJTX;
    var $6s76W;
    var $dC5iT;
    var $f5TWP;
    const $995afee12cb828f6$var$Header = (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
        const announceId = (0, (0, parcelRequire("9KnKW")).useId)();
        const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $5uXOq.useState)(false);
        const handlePrevMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickPrev(e);
        };
        const handleNextMonthInteraction = (e)=>{
            if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
            handleClickNext(e);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            paddingInline: "space.100"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handlePrevMonthInteraction,
            testId: testId && `${testId}--previous-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("fmJTX"))))),
            label: `${previousMonthLabel}, ${previousHeading}`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
            id: announceId,
            testId: testId && `${testId}--current-month-year--container`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1N8i")).default), {
            size: "xsmall",
            as: "h2",
            id: headerId,
            testId: testId && `${testId}--current-month-year`
        }, `${monthLongTitle} ${year}`)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex,
            onClick: handleNextMonthInteraction,
            testId: testId && `${testId}--next-month`,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6s76W"))))),
            label: `${nextMonthLabel}, ${nextHeading}`
        })));
    });
    $995afee12cb828f6$var$Header.displayName = 'Header';
    var $995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;
});
parcelRegister("fmJTX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b2fc843461eabf96$var$_react = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b2fc843461eabf96$var$_chevronLeft = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("lRheX")));
    var $b2fc843461eabf96$var$_chevronLeftLarge = $b2fc843461eabf96$var$_interopRequireDefault((parcelRequire("a88oa")));
    function $b2fc843461eabf96$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b2fc843461eabf96$var$ChevronLeftIcon = (props)=>$b2fc843461eabf96$var$_react.default.createElement($b2fc843461eabf96$var$_chevronLeft.default, Object.assign({
            LEGACY_fallbackIcon: $b2fc843461eabf96$var$_chevronLeftLarge.default
        }, props));
    $b2fc843461eabf96$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
    var $b2fc843461eabf96$var$_default = module.exports.default = $b2fc843461eabf96$var$ChevronLeftIcon;
});
parcelRegister("lRheX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fe9bebc953515e63$var$_UNSAFE_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fe9bebc953515e63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>$fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;
});
parcelRegister("a88oa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7601289634e055f6$var$_react = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7601289634e055f6$var$_chevronLeft = $7601289634e055f6$var$_interopRequireDefault((parcelRequire("lRheX")));
    function $7601289634e055f6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7601289634e055f6$var$ChevronLeftLargeIcon = (props)=>$7601289634e055f6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
        }, props, {
            newIcon: $7601289634e055f6$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $7601289634e055f6$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
    var $7601289634e055f6$var$_default = module.exports.default = $7601289634e055f6$var$ChevronLeftLargeIcon;
});
parcelRegister("6s76W", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));
    var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
    function $4b2adfad98efb792$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>$4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
            LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
        }, props));
    $4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
    var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
parcelRegister("lJWdi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43f22a52ec309eeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $1q4y8;
    var $h581D;
    const $43f22a52ec309eeb$var$WeekDays = (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            role: "rowgroup",
            testId: testId && `${testId}--month`
        }, weeks.map((week, i)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
                key: i,
                testId: testId && `${testId}--week`
            }, week.values.map((weekDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1q4y8")).default), {
                    key: `${week.id}-${weekDay.id}`,
                    isDisabled: weekDay.isDisabled,
                    isFocused: weekDay.isFocused,
                    isToday: weekDay.isToday,
                    dayLong: weekDay.weekDayName,
                    month: weekDay.month,
                    monthLong: monthsLong[weekDay.month - 1],
                    onClick: handleClickDay,
                    isPreviouslySelected: weekDay.isPreviouslySelected,
                    isSelected: weekDay.isSelected,
                    isSibling: weekDay.isSiblingMonth,
                    year: weekDay.year,
                    shouldSetFocus: shouldSetFocus,
                    tabIndex: tabIndex,
                    testId: testId
                }, weekDay.day)))));
    });
    $43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
    var $43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;
});
parcelRegister("1q4y8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d70b02566a310b79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eGmKJ;
    var $bgrar;
    var $h0WbJ;
    const $d70b02566a310b79$var$Date = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, (0, parcelRequire("eGmKJ")).default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
        const dateRef = (0, $5uXOq.useRef)({
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: day,
                month: month,
                year: year,
                isDisabled: isDisabled
            };
        }, [
            day,
            month,
            year,
            isDisabled
        ]);
        const focusRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
        }, [
            isFocused,
            shouldSetFocus
        ]);
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
            if (!isDisabledValue) onClick({
                day: dayValue,
                month: monthValue,
                year: yearValue
            });
        }, [
            onClick
        ]);
        const dateCellStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("h0WbJ")).dateCellStyles)());
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            role: "gridcell",
            alignItems: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: dateCellStyles,
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
        }, day));
    }));
    $d70b02566a310b79$var$Date.displayName = 'Date';
    var $d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;
});
parcelRegister("h0WbJ", function(module, exports) {
    $parcel$export(module.exports, "dateCellStyles", ()=>$a52fc59169f9ec00$export$f62807af68630d86);
    const $a52fc59169f9ec00$export$f62807af68630d86 = ()=>({
            all: 'unset',
            display: 'block',
            padding: `${"var(--ds-space-050, 4px)"} 9px`,
            position: 'relative',
            backgroundColor: 'transparent',
            border: '2px solid transparent',
            borderRadius: 3,
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'pointer',
            flexGrow: 1,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            textAlign: 'center',
            '&[data-sibling]': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-today]': {
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
                fontWeight: "var(--ds-font-weight-bold, bold)",
                '&::after': {
                    display: 'block',
                    height: 2,
                    position: 'absolute',
                    right: "var(--ds-space-025, 2px)",
                    bottom: "var(--ds-space-025, 2px)",
                    left: "var(--ds-space-025, 2px)",
                    backgroundColor: 'currentColor',
                    content: '""'
                }
            },
            '&[data-prev-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-selected]': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$29a4f05edc054374})`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`,
                cursor: 'not-allowed'
            },
            '&:focus-visible': {
                border: `2px solid ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '&:hover': {
                backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $829f609a65d26a98$export$3e51e8f1440314ba})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&:active': {
                backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`
            },
            '&[data-selected]:hover': {
                backgroundColor: `var(--ds-background-selected-hovered, ${0, $829f609a65d26a98$export$226de0355ed012f8})`,
                color: `var(--ds-text-selected, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-prev-selected]:hover': {
                color: `var(--ds-text-subtle, ${0, $829f609a65d26a98$export$7090862dc3038a9f})`
            },
            '&[data-sibling]:hover': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`
            },
            '&[data-disabled]:hover': {
                backgroundColor: 'transparent',
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`
            }
        });
});
parcelRegister("h581D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8aba25f4ae00ff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bgrar;
    const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
        const row = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bgrar")).default), {
            testId: testId,
            templateColumns: "repeat(7, minmax(max-content, 1fr))",
            role: "row"
        }, children);
        return isHidden ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": "true"
        }, row) : row;
    };
    var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;
});
parcelRegister("avO9B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f29b1b1295ce3a84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $h581D;
    const $f29b1b1295ce3a84$var$columnHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: 'size.400',
        whiteSpace: 'nowrap',
        display: 'flex',
        justifyContent: 'center'
    });
    const $f29b1b1295ce3a84$var$WeekHeader = (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("h581D")).default), {
            isHidden: true,
            testId: testId && `${testId}--column-headers`
        }, daysShort.map((shortDay)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$columnHeaderStyles,
                key: shortDay,
                role: "columnheader",
                testId: testId && `${testId}--column-header`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
                weight: "bold",
                size: "UNSAFE_small",
                align: "center",
                color: "color.text.subtle"
            }, shortDay))));
    });
    $f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
    var $f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;
});
parcelRegister("iioJV", function(module, exports) {
    $parcel$export(module.exports, "arrowKeys", ()=>$85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
    $parcel$export(module.exports, "daysPerWeek", ()=>$85c2ac8e9452c4bf$export$3ae905d9742bef55);
    $parcel$export(module.exports, "monthsPerYear", ()=>$85c2ac8e9452c4bf$export$c9b7c010035d60c6);
    $parcel$export(module.exports, "blankStringArray", ()=>$85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
    const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
        ArrowDown: 'down',
        ArrowLeft: 'left',
        ArrowRight: 'right',
        ArrowUp: 'up'
    };
    const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
    const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
    const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];
});
parcelRegister("jihAA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$654a69afe715a212$export$2e2bcd8739ae039);
    var $33etG;
    var $f8qry;
    var $3EtUb;
    function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
        const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, (0, parcelRequire("f8qry")).default)(()=>{
            const now = new Date();
            const thisDay = now.getDate();
            const thisMonth = now.getMonth() + 1;
            const thisYear = now.getFullYear();
            return {
                thisDay: thisDay,
                thisMonth: thisMonth,
                thisYear: thisYear
            };
        });
        const [dayValue, setDayValue] = (0, (0, parcelRequire("33etG")).default)(day, ()=>defaultDay || thisDay);
        const [monthValue, setMonthValue] = (0, (0, parcelRequire("33etG")).default)(month, ()=>defaultMonth || thisMonth);
        const [yearValue, setYearValue] = (0, (0, parcelRequire("33etG")).default)(year, ()=>defaultYear || thisYear);
        const [todayValue] = (0, (0, parcelRequire("33etG")).default)(today, ()=>today || `${thisYear}-${(0, (0, parcelRequire("3EtUb")).default)(thisMonth)}-${(0, (0, parcelRequire("3EtUb")).default)(thisDay)}`);
        const [selectedValue, setSelectedValue] = (0, (0, parcelRequire("33etG")).default)(selected, ()=>defaultSelected);
        const [previouslySelectedValue, setPreviouslySelectedValue] = (0, (0, parcelRequire("33etG")).default)(previouslySelected, ()=>defaultPreviouslySelected);
        return {
            day: [
                dayValue,
                setDayValue
            ],
            month: [
                monthValue,
                setMonthValue
            ],
            year: [
                yearValue,
                setYearValue
            ],
            today: [
                todayValue
            ],
            selected: [
                selectedValue,
                setSelectedValue
            ],
            previous: [
                previouslySelectedValue,
                setPreviouslySelectedValue
            ]
        };
    }
});
parcelRegister("3EtUb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd804e1790f6d755$export$2e2bcd8739ae039);
    function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
        return num < 10 ? `0${num}` : `${num}`;
    }
});
parcelRegister("bbnGB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ccb38b64bb63461$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
        const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
            onBlur(event);
        }, [
            onBlur
        ]);
        const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
            onFocus(event);
        }, [
            onFocus
        ]);
        return {
            handleContainerBlur: handleContainerBlur,
            handleContainerFocus: handleContainerFocus
        };
    }
});
parcelRegister("hbcve", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe53b5f3382c02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZDAP;
    var $iioJV;
    var $6ASl9;
    var $5wbTt;
    function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
        const shouldDisplaySixthWeek = calendar.length % 6;
        const calendarLastValue = calendar[calendar.length - 1];
        return (0, $5uXOq.useMemo)(()=>{
            if (shouldDisplaySixthWeek) {
                const lastDayIsSibling = calendarLastValue.siblingMonth;
                const sliceStart = lastDayIsSibling ? (0, (0, parcelRequire("iioJV")).daysPerWeek) : 0;
                return (0, (0, parcelRequire("5wbTt")).default)(year, month, {
                    weekStartDay: weekStartDay
                }).slice(sliceStart, sliceStart + (0, (0, parcelRequire("iioJV")).daysPerWeek)).map((date)=>({
                        ...date,
                        siblingMonth: true
                    }));
            }
        }, [
            calendarLastValue,
            month,
            shouldDisplaySixthWeek,
            weekStartDay,
            year
        ]);
    }
    function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
        const calendar = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("5wbTt")).default)(year, month - 1, {
                weekStartDay: weekStartDay
            }), [
            month,
            weekStartDay,
            year
        ]);
        const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
            month: month,
            year: year,
            weekStartDay: weekStartDay
        });
        if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
        const minDate = minDateString ? (0, (0, parcelRequire("eZDAP")).default)(minDateString) : undefined;
        const maxDate = maxDateString ? (0, (0, parcelRequire("eZDAP")).default)(maxDateString) : undefined;
        const needJsDate = minDateString || maxDateString;
        return (0, $5uXOq.useMemo)(()=>{
            const weeks = [];
            calendar.forEach((date)=>{
                const dateAsString = (0, (0, parcelRequire("6ASl9")).default)(date, {
                    fixMonth: true
                });
                const JSDate = needJsDate ? (0, (0, parcelRequire("eZDAP")).default)(dateAsString) : undefined;
                let week;
                if (date.weekDay === weekStartDay) {
                    week = {
                        id: dateAsString,
                        values: []
                    };
                    weeks.push(week);
                } else week = weeks[weeks.length - 1];
                const weekDayOffset = (date.weekDay - weekStartDay) % 7;
                const weekDayName = daysLong[weekDayOffset];
                const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
                const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
                const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
                const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
                const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
                const isFocused = day === date.day && !date.siblingMonth;
                const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
                const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
                const isSiblingMonth = !!date.siblingMonth;
                const isToday = today === dateAsString;
                week.values.push({
                    id: dateAsString,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isToday: isToday,
                    month: date.month + 1,
                    isPreviouslySelected: isPreviouslySelected,
                    isSelected: isSelected,
                    isSiblingMonth: isSiblingMonth,
                    year: date.year,
                    day: date.day,
                    weekDayName: weekDayName
                });
            });
            return weeks;
        }, [
            calendar,
            day,
            disabled,
            disabledDateFilter,
            minDate,
            maxDate,
            needJsDate,
            previouslySelected,
            selected,
            today,
            weekStartDay,
            daysLong
        ]);
    }
});
parcelRegister("6ASl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6ae62fd51c4538f$export$2e2bcd8739ae039);
    var $3EtUb;
    function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
        return `${date.year}-${(0, (0, parcelRequire("3EtUb")).default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, (0, parcelRequire("3EtUb")).default)(date.day)}`;
    }
});
parcelRegister("5wbTt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dff1ed1384abe91$export$2e2bcd8739ae039);
    var $iioJV;
    var $9Zmg7;
    function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
        weekStartDay: 0
    }) {
        const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
        const utcYear = date.getUTCFullYear();
        const utcMonth = date.getUTCMonth();
        const calendar = [];
        const firstDay = date.getUTCDay();
        const firstDate = -(((0, (0, parcelRequire("iioJV")).daysPerWeek) - weekStartDay + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek));
        const lastDate = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth);
        const lastDay = (lastDate - firstDate) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
        const lastDateOfPreviousMonth = (0, (0, parcelRequire("9Zmg7")).default)(utcYear, utcMonth - 1);
        let dateCounter = firstDate;
        let currentDay;
        let currentDate;
        let currentDateObject = null;
        let calculatedMonth;
        let calculatedYear;
        const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) - lastDay : 0) + firstDate;
        while(dateCounter < maxDateCount){
            currentDate = dateCounter + 1;
            currentDay = ((dateCounter < 1 ? (0, (0, parcelRequire("iioJV")).daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, (0, parcelRequire("iioJV")).daysPerWeek);
            if (currentDate < 1 || currentDate > lastDate) {
                if (currentDate < 1) {
                    calculatedMonth = utcMonth - 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth < 0) {
                        calculatedMonth = (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1;
                        calculatedYear--;
                    }
                    currentDate = lastDateOfPreviousMonth + currentDate;
                } else if (currentDate > lastDate) {
                    calculatedMonth = utcMonth + 1;
                    calculatedYear = utcYear;
                    if (calculatedMonth > (0, (0, parcelRequire("iioJV")).monthsPerYear) - 1) {
                        calculatedMonth = 0;
                        calculatedYear++;
                    }
                    currentDate = dateCounter - lastDate + 1;
                }
                if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                    day: currentDate,
                    weekDay: currentDay,
                    month: calculatedMonth,
                    year: calculatedYear,
                    siblingMonth: true
                };
            } else currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: utcMonth,
                year: utcYear
            };
            calendar.push(currentDateObject);
            dateCounter++;
        }
        return calendar;
    }
});
parcelRegister("9Zmg7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$878800070b837d93$export$2e2bcd8739ae039);
    function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
        return new Date(year, month + 1, 0).getDate();
    }
});
parcelRegister("2TGJ3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$caae4eff24f6e8d0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    var $9Zmg7;
    const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === (0, (0, parcelRequire("iioJV")).monthsPerYear)) {
            month = 1;
            year += 1;
        } else month += 1;
        return {
            month: month,
            year: year
        };
    };
    const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
        let month = monthValue;
        let year = yearValue;
        if (month === 1) {
            month = (0, (0, parcelRequire("iioJV")).monthsPerYear);
            year -= 1;
        } else month -= 1;
        return {
            month: month,
            year: year
        };
    };
    function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            const isFocusableType = [
                'up',
                'down',
                'left',
                'right'
            ].includes(type);
            onChange({
                day: day,
                month: month,
                year: year,
                iso: iso,
                type: type
            });
            setDayValue(day);
            setMonthValue(month);
            setYearValue(year);
            setShouldSetFocus(isFocusableType);
        }, [
            onChange,
            setDayValue,
            setMonthValue,
            setYearValue,
            setShouldSetFocus
        ]);
        const navigate = (0, $5uXOq.useCallback)((type)=>{
            const { day: day, month: month, year: year } = dateRef.current;
            if (type === 'down') {
                const next = day + (0, (0, parcelRequire("iioJV")).daysPerWeek);
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: next - daysInMonth,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'left') {
                const prev = day - 1;
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1);
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            } else if (type === 'right') {
                const next = day + 1;
                const daysInMonth = (0, (0, parcelRequire("9Zmg7")).default)(year, month - 1);
                if (next > daysInMonth) {
                    const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                    triggerOnChange({
                        year: nextYear,
                        month: nextMonth,
                        day: 1,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: next,
                    type: type
                });
            } else if (type === 'up') {
                const prev = day - (0, (0, parcelRequire("iioJV")).daysPerWeek);
                if (prev < 1) {
                    const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                    const prevDay = (0, (0, parcelRequire("9Zmg7")).default)(prevYear, prevMonth - 1) + prev;
                    triggerOnChange({
                        year: prevYear,
                        month: prevMonth,
                        day: prevDay,
                        type: type
                    });
                } else triggerOnChange({
                    year: year,
                    month: month,
                    day: prev,
                    type: type
                });
            }
        }, [
            triggerOnChange
        ]);
        const handleClickNext = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'next'
            });
        }, [
            triggerOnChange
        ]);
        const handleClickPrev = (0, $5uXOq.useCallback)(()=>{
            const { day: day, month: month, year: year } = {
                ...dateRef.current,
                ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
            };
            triggerOnChange({
                day: day,
                month: month,
                year: year,
                type: 'prev'
            });
        }, [
            triggerOnChange
        ]);
        return {
            navigate: navigate,
            handleClickNext: handleClickNext,
            handleClickPrev: handleClickPrev
        };
    }
});
parcelRegister("f9D1v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42ec54640e7b9de4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iioJV;
    var $6ASl9;
    function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
        const dateRef = (0, $5uXOq.useRef)({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
        (0, $5uXOq.useEffect)(()=>{
            dateRef.current = {
                day: dayValue,
                month: monthValue,
                year: yearValue
            };
        }, [
            dayValue,
            monthValue,
            yearValue
        ]);
        const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            const iso = (0, (0, parcelRequire("6ASl9")).default)({
                year: year,
                month: month,
                day: day
            });
            onSelect({
                day: day,
                month: month,
                year: year,
                iso: iso
            });
            setPreviouslySelectedValue(selectedValue);
            setSelectedValue([
                iso
            ]);
        }, [
            onSelect,
            selectedValue,
            setPreviouslySelectedValue,
            setSelectedValue
        ]);
        const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
            triggerOnSelect({
                year: year,
                month: month,
                day: day
            });
        }, [
            triggerOnSelect
        ]);
        const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
            const { key: key } = e;
            const arrowKey = (0, (0, parcelRequire("iioJV")).arrowKeys)[key];
            if (key === 'Enter' || key === ' ') {
                e.preventDefault();
                triggerOnSelect(dateRef.current);
            } else if (arrowKey) {
                e.preventDefault();
                navigate(arrowKey);
            }
        }, [
            triggerOnSelect,
            navigate
        ]);
        return {
            handleClickDay: handleClickDay,
            handleContainerKeyDown: handleContainerKeyDown
        };
    }
});
parcelRegister("9efze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd6f430b06675a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qZ1x;
    function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
        const l10n = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale), [
            locale
        ]);
        const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
            l10n
        ]);
        const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
            l10n,
            weekStartDay
        ]);
        return {
            monthsLong: monthsLong,
            daysShort: daysShort,
            daysLong: daysLong
        };
    }
});
parcelRegister("avHVh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac07968b7cb494a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $5owSH;
    var $gkD4s;
    var $4oNEb;
    var $1V7PR;
    var $k5uoT;
    class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.inputValue !== this.props.inputValue) this.update();
        }
        render() {
            const { containerRef: containerRef, content: content, testId: testId } = this.props;
            if (!containerRef) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
            const divStyles = {
                background: 'transparent',
                position: 'absolute',
                top: 0,
                height: containerRef.getBoundingClientRect().height,
                width: containerRef.getBoundingClientRect().width - parseInt((0, (0, parcelRequire("5owSH")).sizes).small.slice(0, -2)) - (0, (0, parcelRequire("k5uoT")).gridSize)()
            };
            return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkD4s")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1V7PR")).Reference), null, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    "data-layer-child": true,
                    style: divStyles
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), null, ({ ref: ref, style: style, update: update })=>{
                this.update = update;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: ref,
                    style: {
                        ...style,
                        zIndex: (0, (0, parcelRequire("k5uoT")).layers).dialog()
                    },
                    "data-testid": testId && `${testId}--popper--container`
                }, content);
            })));
        }
        constructor(...args){
            super(...args), this.update = (0, (0, parcelRequire("eGmKJ")).default);
        }
    }
});
parcelRegister("6AqCE", function(module, exports) {
    $parcel$export(module.exports, "getShortISOString", ()=>$caee16c105163c22$export$77d5bc49fed7ef14);
    $parcel$export(module.exports, "getSafeCalendarValue", ()=>$caee16c105163c22$export$ff525416014fb67d);
    var $k7m40;
    var $2ucUe;
    function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
        return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD'));
    }
    function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
        const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
        if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
        return calendarValue;
    }
});
parcelRegister("dBs4v", function(module, exports) {
    $parcel$export(module.exports, "makeSingleValue", ()=>$9661917c82165ad2$export$6e30bf8cb1347b56);
    var $5uXOq = parcelRequire("5uXOq");
    var $bChGW;
    const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...rest })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).SingleValue, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                data: data,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: {
                    lang: lang
                },
                isDisabled: isDisabled,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children);
        };
});
parcelRegister("jcbUF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5b21daaca02ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $9KnKW;
    var $acknU;
    var $cTemL;
    var $7qZ1x;
    var $VSDnB;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $7K5PP;
    var $7VXAu;
    var $jldZL;
    var $jHBnA;
    var $5RLF6;
    var $iaQLg;
    var $gtijU;
    var $6AqCE;
    var $dBs4v;
    function $48f5b21daaca02ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $48f5b21daaca02ab$var$packageName = "platform-pkg";
    const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
    const $48f5b21daaca02ab$var$analyticsAttributes = {
        componentName: 'datePicker',
        packageName: $48f5b21daaca02ab$var$packageName,
        packageVersion: $48f5b21daaca02ab$var$packageVersion
    };
    const $48f5b21daaca02ab$var$pickerContainerStyles = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $48f5b21daaca02ab$var$dropdownIndicatorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: "var(--ds-space-300, 24px)",
        minHeight: "var(--ds-space-300, 24px)",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    });
    const $48f5b21daaca02ab$var$CalendarIcon = (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? (0, ($parcel$interopDefault((0, parcelRequire("acknU"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cTemL")))));
    const $48f5b21daaca02ab$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '100%',
        position: 'absolute',
        alignItems: 'center',
        flexBasis: 'inherit',
        color: 'color.text.subtlest',
        insetBlockStart: 'space.0',
        insetInlineEnd: 'space.0',
        transition: `color 150ms`,
        ':hover': {
            color: 'color.text.subtle'
        }
    });
    const $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.400'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.050'
    });
    const $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInlineEnd: 'space.025'
    });
    const $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: `${32 / 14}em`,
        height: `${32 / 14}em`
    });
    const $48f5b21daaca02ab$var$calendarButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $48f5b21daaca02ab$var$DatePicker = (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const calendarRef = (0, $5uXOq.useRef)(null);
        const calendarButtonRef = (0, $5uXOq.useRef)(null);
        const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = $48f5b21daaca02ab$var$CalendarIcon, id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
        const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
        const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
        const [l10n, setL10n] = (0, $5uXOq.useState)((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
        const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
        const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
        const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
        const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$48f5b21daaca02ab$var$analyticsAttributes
        });
        if (propLocale !== locale) {
            setL10n((0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(propLocale));
            setLocale(propLocale);
        }
        (0, $5uXOq.useEffect)(()=>{
            if (!isKeyDown) return;
            if (isOpen && wasOpenedFromCalendarButton) {
                setIsKeyDown(false);
                calendarRef?.current?.querySelector('button')?.focus();
            }
        }, [
            isKeyDown,
            calendarRef,
            isOpen,
            wasOpenedFromCalendarButton
        ]);
        const getValue = ()=>propValue ?? value;
        const getIsOpen = ()=>isOpenProp ?? isOpen;
        const onCalendarChange = ({ iso: iso })=>{
            setCalendarValue((0, (0, parcelRequire("5RLF6")).getParsedISO)({
                iso: iso
            }));
        };
        const onCalendarSelect = ({ iso: iso })=>{
            setSelectInputValue('');
            setIsOpen(false);
            setCalendarValue(iso);
            setValue(iso);
            setWasOpenedFromCalendarButton(false);
            onChangePropWithAnalytics(iso);
            if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
            else {
                const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            setIsOpen(false);
        };
        const onInputClick = ()=>{
            if (!isDisabled && !getIsOpen()) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                onBlur(event);
            }
        };
        const onContainerFocus = ()=>{
            setShouldSetFocusOnCurrentDay(false);
        };
        const onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (clearingFromIcon) setClearingFromIcon(false);
            else if (!containerRef?.current?.contains(newlyFocusedElement)) {
                setIsOpen(false);
                setIsFocused(false);
                setWasOpenedFromCalendarButton(false);
            }
        };
        const onSelectFocus = (event)=>{
            const value = getValue();
            if (clearingFromIcon) setClearingFromIcon(false);
            else {
                setIsOpen(!shouldShowCalendarButton);
                setCalendarValue(value);
                setIsFocused(true);
                setWasOpenedFromCalendarButton(false);
            }
            onFocus(event);
        };
        const onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, (0, parcelRequire("5RLF6")).parseDate)(inputValue, {
                    parseInputValue: rest?.parseInputValue,
                    dateFormat: rest?.dateFormat,
                    l10n: l10n
                });
                if (parsed && (0, (0, parcelRequire("jovBr")).default)(parsed)) setCalendarValue((0, (0, parcelRequire("6AqCE")).getShortISOString)(parsed));
            }
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        };
        const onInputKeyDown = (event)=>{
            const value = getValue();
            const keyPressed = event.key.toLowerCase();
            if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
                setIsOpen(true);
                setWasOpenedFromCalendarButton(false);
            }
            switch(keyPressed){
                case 'escape':
                    if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    setIsOpen(false);
                    setShouldSetFocusOnCurrentDay(false);
                    setWasOpenedFromCalendarButton(false);
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                            setClearingFromIcon(false);
                            setValue('');
                        }
                        break;
                    }
                case 'enter':
                    if (!isOpen) return;
                    event.preventDefault();
                    if (!(0, (0, parcelRequire("5RLF6")).isDateDisabled)(calendarValue, {
                        disabled: disabled
                    })) {
                        const safeCalendarValue = (0, (0, parcelRequire("6AqCE")).getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        setSelectInputValue('');
                        setIsOpen(false);
                        setValue(safeCalendarValue);
                        setCalendarValue(safeCalendarValue);
                        setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                        if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!shouldSetFocusOnCurrentDay) {
                        setIsOpen(true);
                        setShouldSetFocusOnCurrentDay(true);
                    }
                    break;
                default:
                    break;
            }
        };
        const onCalendarButtonKeyDown = (e)=>{
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                setIsKeyDown(true);
                setWasOpenedFromCalendarButton(true);
            }
        };
        const onCalendarButtonClick = (e)=>{
            setIsOpen(!isOpen);
            setWasOpenedFromCalendarButton(true);
            e.stopPropagation();
        };
        const onClear = ()=>{
            setValue('');
            setCalendarValue(defaultValue || (0, (0, parcelRequire("6AqCE")).getShortISOString)(new Date()));
            if (!hideIcon) setClearingFromIcon(true);
            onChangePropWithAnalytics('');
        };
        const onSelectChange = (_value, action)=>{
            if (action.action === 'clear') onClear();
        };
        const handleSelectInputChange = (selectInputValue, actionMeta)=>{
            if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
            setSelectInputValue(selectInputValue);
        };
        const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
            const oldRef = containerRef.current;
            containerRef.current = ref;
            if (oldRef == null && ref != null) forceUpdate();
        }, [
            containerRef
        ]);
        const getterValue = getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
        let clearIndicator = Icon;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration')) clearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $48f5b21daaca02ab$var$dropdownIndicatorStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Icon, props));
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: propLocale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, (0, parcelRequire("jHBnA")).EmptyComponent) : dropDownIcon,
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iaQLg")).IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: (0, parcelRequire("gtijU")).Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: containerRef.current,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: calendarRef,
            calendarValue: getterValue && (0, (0, parcelRequire("6AqCE")).getShortISOString)((0, (0, parcelRequire("eZDAP")).default)(getterValue)),
            calendarView: calendarValue,
            onCalendarChange: onCalendarChange,
            onCalendarSelect: onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay
        };
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-075, 6px)"
                })
        });
        const initialValue = getterValue ? {
            label: (0, (0, parcelRequire("5RLF6")).formatDate)(getterValue, {
                formatDisplayLabel: formatDisplayLabel,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }),
            value: getterValue
        } : null;
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel} , ${openCalendarLabel}` : openCalendarLabel;
        const openCalendarLabelId = `open-calendar-label--${(0, (0, parcelRequire("9KnKW")).useId)()}`;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...innerProps,
            css: $48f5b21daaca02ab$var$pickerContainerStyles,
            "data-testid": testId && `${testId}--container`,
            onBlur: onContainerBlur,
            onFocus: onContainerFocus,
            onClick: onInputClick,
            onInput: onTextInput,
            onKeyDown: onInputKeyDown,
            ref: getContainerRef,
            role: "presentation"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            name: name,
            type: "hidden",
            value: getterValue,
            "data-testid": testId && `${testId}--input`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7K5PP")).default), {
            appearance: appearance,
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            closeMenuOnSelect: true,
            components: selectComponents,
            enableAnimation: false,
            inputId: id,
            inputValue: actualSelectInputValue,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: menuIsOpen,
            onBlur: onSelectBlur,
            onChange: onSelectChange,
            onFocus: onSelectFocus,
            onInputChange: handleSelectInputChange,
            placeholder: (0, (0, parcelRequire("5RLF6")).getPlaceholder)({
                placeholder: placeholder,
                l10n: l10n
            }),
            styles: mergedStyles,
            value: initialValue,
            ...selectProps,
            isClearable: true,
            isInvalid: isInvalid,
            spacing: spacing,
            testId: testId,
            calendarContainerRef: calendarProps.calendarContainerRef,
            calendarDisabled: calendarProps.calendarDisabled,
            calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
            calendarLocale: calendarProps.calendarLocale,
            calendarMaxDate: calendarProps.calendarMaxDate,
            calendarMinDate: calendarProps.calendarMinDate,
            calendarRef: calendarProps.calendarRef,
            calendarValue: calendarProps.calendarValue,
            calendarView: calendarProps.calendarView,
            calendarWeekStartDay: calendarProps.calendarWeekStartDay,
            nextMonthLabel: nextMonthLabel,
            onCalendarChange: calendarProps.onCalendarChange,
            onCalendarSelect: calendarProps.onCalendarSelect,
            previousMonthLabel: previousMonthLabel,
            shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay
        }), shouldShowCalendarButton && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $48f5b21daaca02ab$var$iconContainerStyles,
                value && !hideIcon ? $48f5b21daaca02ab$var$iconSpacingWithClearButtonStyles : (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStylesNew : $48f5b21daaca02ab$var$iconSpacingWithoutClearButtonStyles
            ]
        }, inputLabelId && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            id: openCalendarLabelId
        }, ", ", openCalendarLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
            ...inputLabelId ? {
                'aria-labelledby': `${inputLabelId} ${openCalendarLabelId}`
            } : {
                'aria-label': fullopenCalendarLabel
            },
            onClick: onCalendarButtonClick,
            onKeyDown: onCalendarButtonKeyDown,
            ref: calendarButtonRef,
            testId: testId && `${testId}--open-calendar-button`,
            type: "button",
            backgroundColor: "color.background.neutral.subtle",
            padding: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? 'space.0' : 'space.050',
            xcss: [
                $48f5b21daaca02ab$var$calendarButtonStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') && $48f5b21daaca02ab$var$calendarButtonFixedSizeStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($48f5b21daaca02ab$var$CalendarIcon, {
            label: "",
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icon-ads-migration') ? {
                color: "var(--ds-icon, #44546F)"
            } : {
                primaryColor: "var(--ds-icon, #44546F)"
            }
        }))) : null));
    });
    var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;
});
parcelRegister("9FL4D", function(module, exports) {
    $parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", ()=>$ee02e7651d6a8221$export$9d2267fe165de4b6);
    const $ee02e7651d6a8221$export$9d2267fe165de4b6 = (event)=>{
        event.key === 'Enter' && event.preventDefault();
    };
});
parcelRegister("eVzdP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049ff715c3e8bf03$export$2e2bcd8739ae039);
    var $7VHMR;
    const $049ff715c3e8bf03$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-create-commons.date-field.placeholder",
            "defaultMessage": "Select date"
        },
        ariaLabel: {
            "id": "issue-create-commons.date-field.aria-label",
            "defaultMessage": "Enter a Date"
        }
    });
    var $049ff715c3e8bf03$export$2e2bcd8739ae039 = $049ff715c3e8bf03$var$messages;
});
parcelRegister("cnfHu", function(module, exports) {
    $parcel$export(module.exports, "mutateDateField", ()=>$b4588511439b4165$export$cc256064cc35499f);
    $parcel$export(module.exports, "transformDate", ()=>$b4588511439b4165$export$57e73ea84b51baf0);
    var $k7m40;
    var $eZDAP;
    const $b4588511439b4165$export$cc256064cc35499f = (date, fieldId)=>{
        const dateInputFormat = 'yyyy-MM-dd';
        return {
            fieldId: fieldId,
            date: {
                formattedDate: (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("eZDAP")).default)(date), dateInputFormat)
            },
            mutationGroup: (0, $93652339ecfdbba1$export$31fd86f8f183952c)
        };
    };
    const $b4588511439b4165$export$57e73ea84b51baf0 = (date)=>date || null;
});
const $93652339ecfdbba1$export$31fd86f8f183952c = 'datePickerFields';
parcelRegister("fpis9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9d01bc814484554$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cHu6v;
    var $lfTZh;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $9FL4D;
    var $jGVMX;
    var $lkRXf;
    const $a9d01bc814484554$export$ae1ced156568f0b0 = (props)=>{
        const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleChange = (dateTimeValue)=>{
            onChange(dateTimeValue || '');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "date-time-field-edit-view",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cHu6v")).AsyncDateTimeFieldEditView), {
            label: fieldName,
            ...fieldProps,
            isDisabled: isDisabled || isReadOnly,
            autoFocus: autoFocus,
            value: value,
            onChange: handleChange,
            isInvalid: Boolean(error),
            datePickerProps: {
                selectProps: {
                    onKeyDown: (0, (0, parcelRequire("9FL4D")).preventFormSubmitOnEnterKeyPress)
                },
                placeholder: formatMessage((0, (0, parcelRequire("lkRXf")).default).datePickerPlaceholder)
            },
            timePickerProps: {
                placeholder: formatMessage((0, (0, parcelRequire("lkRXf")).default).timePickerPlaceholder)
            }
        })));
    };
    var $a9d01bc814484554$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($a9d01bc814484554$export$ae1ced156568f0b0);
});
parcelRegister("cHu6v", function(module, exports) {
    $parcel$export(module.exports, "AsyncDateTimeFieldEditView", ()=>$f165d6e156b4ac02$export$657a1b8545a979b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $fwbTL;
    const $f165d6e156b4ac02$var$EMPTY_OBJECT = {};
    const $f165d6e156b4ac02$export$657a1b8545a979b8 = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("fwbTL")).asyncDateTimeFieldEditViewEntrypoint), $f165d6e156b4ac02$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "async-jira-issue-field-date-time-edit-view",
            packageName: "jira-issue-field-date-time",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                width: "350px",
                height: "40px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("fwbTL", function(module, exports) {
    $parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", ()=>$d8c60609c3da1617$export$971e82244ad6d423);
    var $eufEc;
    var $fEDBv;
    const $d8c60609c3da1617$export$971e82244ad6d423 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("iS54p")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
            moduleId: "267b9282"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("iS54p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hoRHv").then(()=>parcelRequire('7p4p7'));
});
parcelRegister("lkRXf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb6bff0fa93541ec$export$2e2bcd8739ae039);
    var $7VHMR;
    const $bb6bff0fa93541ec$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        datePickerPlaceholder: {
            "id": "issue-create-commons.date-time-field.date-picker-placeholder",
            "defaultMessage": "Select date"
        },
        timePickerPlaceholder: {
            "id": "issue-create-commons.date-time-field.time-picker-placeholder",
            "defaultMessage": "Select time"
        }
    });
    var $bb6bff0fa93541ec$export$2e2bcd8739ae039 = $bb6bff0fa93541ec$var$messages;
});
parcelRegister("kEFc7", function(module, exports) {
    $parcel$export(module.exports, "mutateDateTimeField", ()=>$6b040ff5d5a5d1fc$export$c17fd814c724a443);
    var $k7m40;
    var $eZDAP;
    const $6b040ff5d5a5d1fc$export$c17fd814c724a443 = (date, fieldId)=>{
        const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
        return {
            fieldId: fieldId,
            dateTime: {
                formattedDateTime: (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("eZDAP")).default)(date), dateTimeInputFormat)
            },
            mutationGroup: (0, $40767685c915f999$export$31fd86f8f183952c)
        };
    };
});
const $40767685c915f999$export$31fd86f8f183952c = 'dateTimePickerFields';
parcelRegister("kRBrp", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultEpicValue", ()=>$d87b14be842e0226$export$d1fe9e25b0dbb9af);
    $parcel$export(module.exports, "mutateEpicLinkField", ()=>$d87b14be842e0226$export$5e81faed0a30e719);
    const $d87b14be842e0226$export$d1fe9e25b0dbb9af = ({ key: key, summary: summary })=>({
            label: summary,
            value: key
        });
    const $d87b14be842e0226$export$5e81faed0a30e719 = ({ value: value }, fieldId)=>({
            epicLinkField: {
                fieldId: fieldId,
                epicLink: {
                    issueKey: value
                }
            }
        });
});
parcelRegister("2cChB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f58a08bbf942e9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkJfY;
    var $4R6GH;
    var $aWse0;
    var $7KR8k;
    var $6FMjJ;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $3IdTl;
    var $h2h4F;
    const $7f58a08bbf942e9a$export$5939eb0b0c440cdc = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, width: width, fieldId: fieldId, allowedValues: allowedValues, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isCreateLinkedIssue: isCreateLinkedIssue = false, additionalData: additionalData } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const options = (0, (0, parcelRequire("6FMjJ")).mapDataToOptions)(allowedValues);
        const { copyLinks: copyLinks, copyAttachments: copyAttachments } = additionalData?.copyLinksAndAttachments || {};
        (0, $5uXOq.useEffect)(()=>{
            if (isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view')) {
                if (value.includeAttachments === undefined && value.includeLinks === undefined) onChange({
                    ...value || {},
                    includeLinks: copyLinks || false,
                    includeAttachments: copyAttachments || false
                });
            }
        }, [
            copyAttachments,
            copyLinks,
            isCreateLinkedIssue,
            onChange,
            value
        ]);
        const onIssueLinksEditChange = (newValue)=>{
            onChange({
                ...value || {},
                ...newValue
            });
        };
        const onIncludeAttachmentsChange = (e)=>{
            onChange({
                ...value,
                includeAttachments: e.currentTarget.checked
            });
        };
        const onIncludeLinksChange = (e)=>{
            onChange({
                ...value,
                includeLinks: e.currentTarget.checked
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7KR8k")).IssueLinksEdit), {
            linkTypeOptions: options,
            autoFocus: autoFocus,
            autoCompleteUrl: autoCompleteUrl,
            onChange: isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? onIssueLinksEditChange : onChange,
            fetchSuggestionsOnMount: false,
            value: value,
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            inputId: id,
            isRequired: isRequired
        }), isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') && (0, ($parcel$interopDefault($5uXOq))).createElement($7f58a08bbf942e9a$var$CheckboxWrapper, null, additionalData?.copyLinksAndAttachments !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            onChange: onIncludeLinksChange,
            label: formatMessage((0, (0, parcelRequire("3IdTl")).default).includeLinks),
            isChecked: value?.includeLinks || false
        }), additionalData?.copyLinksAndAttachments !== null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            onChange: onIncludeAttachmentsChange,
            label: formatMessage((0, (0, parcelRequire("3IdTl")).default).includeAttachments),
            isChecked: value?.includeAttachments || false
        })));
    };
    var $7f58a08bbf942e9a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("h2h4F")).transformDefaultIssueLinksValue),
        validator: (0, (0, parcelRequire("h2h4F")).validateIssueLinksField)
    })($7f58a08bbf942e9a$export$5939eb0b0c440cdc);
    const $7f58a08bbf942e9a$var$CheckboxWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _ca0q1b66 _19bv1b66 _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7KR8k", function(module, exports) {
    $parcel$export(module.exports, "IssueLinksEdit", ()=>$374357294b45f900$export$4db6edf6dd313d5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dSKGh;
    var $9RIG1;
    const $374357294b45f900$export$4db6edf6dd313d5a = (props)=>{
        const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, onChange: onChange, linkTypeOptions: linkTypeOptions, autoFocus: autoFocus = false, value: value, fetchSuggestionsOnMount: fetchSuggestionsOnMount, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, isRequired: isRequired, inputId: inputId } = props;
        const onLinkTypeChange = (val)=>{
            onChange({
                linkType: val,
                issues: value ? value.issues : []
            });
        };
        const onLinkSearchChange = (val)=>{
            if (value) onChange({
                linkType: value.linkType,
                issues: val
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($374357294b45f900$var$FlexColumn, {
            "data-testid": "issue-field-issue-links.ui.edit.issue-links"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSKGh")).default), {
            options: linkTypeOptions,
            autoFocus: autoFocus,
            value: value ? value.linkType : undefined,
            onChange: onLinkTypeChange,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isDisabled,
            inputId: inputId,
            isRequired: isRequired
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9RIG1")).default), {
            fieldId: fieldId,
            value: value ? value.issues : undefined,
            fetchSuggestionsOnMount: fetchSuggestionsOnMount,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onLinkSearchChange,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isDisabled
        }));
    };
    const $374357294b45f900$var$FlexColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dSKGh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$975001f6f923cec5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $7K5PP;
    var $lElIo;
    const $975001f6f923cec5$var$IssueLinksType = (props)=>{
        const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (value === undefined) onChange(options[0]);
        }, [
            value,
            onChange,
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $975001f6f923cec5$var$linkTypeWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            inputId: inputId,
            required: isRequired,
            options: options,
            value: value,
            onChange: onChange,
            isMulti: false,
            autoFocus: autoFocus,
            defaultValue: options[0],
            closeMenuOnScroll: onCloseMenuOnScroll,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            isDisabled: isDisabled,
            classNamePrefix: "issue-link-type",
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        }));
    };
    var $975001f6f923cec5$export$2e2bcd8739ae039 = $975001f6f923cec5$var$IssueLinksType;
    const $975001f6f923cec5$var$linkTypeWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        marginBottom: 'space.100'
    });
});
parcelRegister("9RIG1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a262362dcdda63df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $eusud;
    var $koVbs;
    var $j7RHF;
    var $h1XvK;
    var $2xATL;
    const $a262362dcdda63df$var$IssueLinksSearchEdit = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [invalidSelections, setInValidSelections] = (0, $5uXOq.useState)([]);
        const [isInvalidState, setIsInvalidState] = (0, $5uXOq.useState)(false);
        const { fieldId: fieldId, onFocus: onFocus, onBlur: onBlur, value: value, options: options, onChange: onChange, autoCompleteUrl: autoCompleteUrl, loadingMessage: loadingMessage, getSuggestions: getSuggestions, useTransformSuggestions: useTransformSuggestions, noOptionsMessage: noOptionsMessage, fetchSuggestionsOnMount: fetchSuggestionsOnMount, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled } = props;
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query)=>{
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}${query}`);
            return response;
        }, [
            autoCompleteUrl
        ]);
        const updateInvalidSelections = (0, $5uXOq.useCallback)((selectionValues)=>{
            const issueKeyValues = selectionValues ? selectionValues.map((v)=>v.value) : [];
            const updateSelections = invalidSelections.length ? invalidSelections.filter((i)=>issueKeyValues.includes(i)) : [];
            if (updateSelections.length) setIsInvalidState(true);
            else setIsInvalidState(false);
            setInValidSelections(updateSelections);
        }, [
            invalidSelections
        ]);
        const onChangeSelectedValues = (0, $5uXOq.useCallback)((values, suggestions)=>{
            const currentHost = (0, (0, parcelRequire("2xATL")).getCurrentHostPattern)();
            updateInvalidSelections(values);
            const newIssueLinks = values !== null && values !== undefined ? values.map((issueLink)=>{
                const strippedIssueKey = (0, (0, parcelRequire("2xATL")).stripUrlToIssueKey)(currentHost, issueLink.value.toString());
                return {
                    ...issueLink,
                    iconUrl: issueLink.__isNew__ === true && suggestions && suggestions[0].options ? suggestions[0].options.find((option)=>option.value === issueLink.value)?.iconUrl : issueLink.iconUrl,
                    label: strippedIssueKey,
                    value: strippedIssueKey
                };
            }) : values;
            onChange(newIssueLinks);
        }, [
            onChange,
            updateInvalidSelections
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a262362dcdda63df$var$FlexRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $a262362dcdda63df$var$searchWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j7RHF")).SearchableSelect), {
            fieldId: fieldId,
            getSuggestions: getSuggestions !== undefined ? getSuggestions : fetchSuggestions,
            onChange: onChangeSelectedValues,
            isMulti: true,
            value: value,
            options: options,
            onBlur: onBlur,
            onFocus: onFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isDisabled,
            placeholder: formatMessage((0, (0, parcelRequire("h1XvK")).default).placeholder),
            getTransformedSuggestions: useTransformSuggestions !== undefined ? useTransformSuggestions : (0, (0, parcelRequire("2xATL")).transformIssueSuggestionItems),
            canCreateNewItem: true,
            loadingMessage: loadingMessage,
            noOptionsMessage: noOptionsMessage,
            onChangeQueryValue: (0, (0, parcelRequire("2xATL")).stripQueryValueToIssueKey),
            isInvalid: isInvalid === true || isInvalidState,
            fetchSuggestionsOnMount: fetchSuggestionsOnMount,
            formatCreateLabel: formatMessage((0, (0, parcelRequire("h1XvK")).default).createNewIssueLink),
            ariaLabel: formatMessage((0, (0, parcelRequire("h1XvK")).default).placeholder)
        })));
    };
    var $a262362dcdda63df$export$2e2bcd8739ae039 = $a262362dcdda63df$var$IssueLinksSearchEdit;
    const $a262362dcdda63df$var$searchWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $a262362dcdda63df$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("j7RHF", function(module, exports) {
    $parcel$export(module.exports, "SearchableSelect", ()=>$7e27a772eb8ee65d$export$6037a18d4e29dfa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $qfj8c;
    var $iOwNT;
    var $gwIPs;
    var $dJl1T;
    var $4R6GH;
    var $koVbs;
    var $6Vzc4;
    var $3BhEA;
    var $lElIo;
    var $fh3sQ;
    const $7e27a772eb8ee65d$export$251bdbdbce9550ea = 300;
    const $7e27a772eb8ee65d$var$logError = (msg)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.base-components-searchable-select', msg);
    const $7e27a772eb8ee65d$export$6037a18d4e29dfa9 = (props)=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [menuIsOpen, setMenuIsOpen] = (0, $5uXOq.useState)(false);
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const lastQuery = (0, $5uXOq.useRef)('');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fieldId: fieldId, isMulti: isMulti, isInvalid: isInvalid, placeholder: placeholder, value: value, options: options, components: components, canCreateNewItem: canCreateNewItem, classNamePrefix: classNamePrefix, onChangeQueryValue: onChangeQueryValue, onChange: onChange, onFocus: onFocus, onBlur: onBlur, fetchSuggestionsOnMount: fetchSuggestionsOnMount, getSuggestions: getSuggestions, formatOptionLabel: formatOptionLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, componentsProps: componentsProps, getTransformedSuggestions: getTransformedSuggestions, errorMessagePosition: errorMessagePosition, invalidMessage: invalidMessage, onPostTransformSuggestions: onPostTransformSuggestions, formatCreateLabel: formatCreateLabel, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
        const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
            if (lastQuery.current === query) {
                const response = getTransformedSuggestions(results, formatMessage, query);
                if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
                setSuggestions(response);
                if (query === '') setDefaultSuggestions(response);
            }
        }, [
            formatMessage,
            getTransformedSuggestions,
            onPostTransformSuggestions
        ]);
        const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FailedFetchOptionWrapper), null, formatMessage((0, (0, parcelRequire("fh3sQ")).default).failedFetch)), [
            formatMessage
        ]);
        const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            try {
                const response = await getSuggestions(query, componentsProps);
                setIsLoading(false);
                handleSuggestions(response, query);
            } catch (err) {
                setIsLoading(false);
                setHasLastFetchFailed(true);
                const failedOption = [
                    {
                        label: getFailedFetchMessage(),
                        value: '',
                        isDisabled: true
                    }
                ];
                setSuggestions(failedOption);
                if ((0, (0, parcelRequire("4R6GH")).fg)('thor-issue-view-enable-logging')) $7e27a772eb8ee65d$var$logError(err);
            }
        }, [
            componentsProps,
            getFailedFetchMessage,
            getSuggestions,
            handleSuggestions
        ]);
        (0, $5uXOq.useMemo)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoading(true);
                    requestSuggestions();
                } else if (options) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoading(true);
                    requestSuggestions();
                }
            }
        }, [
            componentsProps
        ]);
        const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(requestSuggestions, $7e27a772eb8ee65d$export$251bdbdbce9550ea), []);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedRequestSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                const transformedQuery = onChangeQueryValue ? onChangeQueryValue(query) : query;
                lastQuery.current = transformedQuery;
                setIsLoading(true);
                debouncedRequestSuggestions(transformedQuery);
            } else {
                lastQuery.current = '';
                setIsLoading(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedRequestSuggestions,
            defaultSuggestions,
            onChangeQueryValue
        ]);
        const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
            setMenuIsOpen(true);
            if (lastQuery.current === '' && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            }
            onFocus && onFocus(e);
        }, [
            defaultSuggestions,
            onFocus,
            requestSuggestions
        ]);
        const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
            setMenuIsOpen(false);
            onBlur && onBlur(e);
        }, [
            onBlur
        ]);
        const onChangeSelected = (0, $5uXOq.useCallback)((values)=>{
            onChange(values, suggestions);
        }, [
            onChange,
            suggestions
        ]);
        const getFormatOptionLabel = (0, $5uXOq.useCallback)((option, meta)=>{
            if (formatOptionLabel !== undefined) return formatOptionLabel(option, meta);
            if (option.iconUrl === undefined) return option.label;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).OptionWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).ImgSpan), null, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: option.iconUrl,
                alt: "",
                width: 2 * (0, (0, parcelRequire("gwIPs")).gridSize),
                height: 2 * (0, (0, parcelRequire("gwIPs")).gridSize),
                role: "none"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FlexSpan), null, option.label));
        }, [
            formatOptionLabel
        ]);
        const renderErrorMessage = (0, $5uXOq.useCallback)(()=>invalidMessage !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).ErrorMessageWrapper), {
                key: `${fieldId}-error-message`,
                errorMessagePosition: errorMessagePosition
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, invalidMessage)) : null, [
            errorMessagePosition,
            fieldId,
            invalidMessage
        ]);
        const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, (0, parcelRequire("fh3sQ")).default).createNewItem)})`, [
            formatCreateLabel,
            formatMessage
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, (0, parcelRequire("fh3sQ")).default).empty), [
            formatMessage,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, (0, parcelRequire("fh3sQ")).default).loading), [
            formatMessage,
            loadingMessage
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
        }, [
            hasLastFetchFailed
        ]);
        const isValidNewOption = (0, $5uXOq.useCallback)((query)=>{
            if (canCreateNewItem && query !== '') return true;
            return false;
        }, [
            canCreateNewItem
        ]);
        const renderSelectField = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iOwNT")).default), {
                classNamePrefix: classNamePrefix,
                key: fieldId,
                options: suggestions,
                autoFocus: autoFocus,
                value: value,
                onBlur: onSelectBlur,
                onFocus: onSelectFocus,
                noOptionsMessage: getNoOptionsMessage,
                loadingMessage: getLoadingMessage,
                menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
                styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
                placeholder: placeholder !== undefined ? placeholder : formatMessage((0, (0, parcelRequire("fh3sQ")).default).placeholder),
                onInputChange: onQueryChange,
                onChange: onChangeSelected,
                isLoading: menuIsOpen && isLoading,
                filterOption: filterOption,
                isClearable: true,
                formatOptionLabel: getFormatOptionLabel,
                components: components,
                componentsProps: componentsProps,
                isMulti: isMulti,
                isValidNewOption: isValidNewOption,
                validationState: isInvalid === true ? 'error' : null,
                formatCreateLabel: getCreateLabel,
                closeMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isDisabled,
                "aria-label": ariaLabel
            });
        const componentList = [
            renderSelectField()
        ];
        errorMessagePosition === 'top' ? componentList.unshift(renderErrorMessage()) : componentList.push(renderErrorMessage());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, componentList);
    };
    $7e27a772eb8ee65d$export$6037a18d4e29dfa9.defaultProps = {
        isMulti: false,
        canCreateNewItem: false,
        fetchSuggestionsOnMount: true
    };
    var $7e27a772eb8ee65d$export$2e2bcd8739ae039 = $7e27a772eb8ee65d$export$6037a18d4e29dfa9;
});
parcelRegister("6Vzc4", function(module, exports) {
    $parcel$export(module.exports, "FailedFetchOptionWrapper", ()=>$9302f6c83ce60c04$export$38a1a0a811e06255);
    $parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", ()=>$9302f6c83ce60c04$export$aa3357fb0ebcdb2b);
    $parcel$export(module.exports, "OptionWrapper", ()=>$9302f6c83ce60c04$export$d6f6a072cce04542);
    $parcel$export(module.exports, "ImgSpan", ()=>$9302f6c83ce60c04$export$df67068a00dece12);
    $parcel$export(module.exports, "FlexSpan", ()=>$9302f6c83ce60c04$export$d90eccb59fb62cab);
    $parcel$export(module.exports, "ErrorMessageWrapper", ()=>$9302f6c83ce60c04$export$9e874bb1adc98a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6s1PB;
    var $koVbs;
    var $goAgE;
    const $9302f6c83ce60c04$export$6ed0d629c0656ce1 = (query, label)=>[
            {
                options: [
                    {
                        label: label,
                        value: '',
                        isDisabled: true,
                        filterValues: [
                            query
                        ]
                    }
                ]
            }
        ];
    const $9302f6c83ce60c04$var$DefaultFailedFetchMessage = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const failedFetchMessage = (0, (0, parcelRequire("goAgE")).default).failedFetch;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$export$38a1a0a811e06255, null, (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, formatMessage(failedFetchMessage), " ", (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            role: "button",
            href: window.location.href,
            onClick: ()=>window.location.reload()
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("goAgE")).default).reloadIssueIssueTermRefresh : (0, (0, parcelRequire("goAgE")).default).reloadIssue))));
    };
    const $9302f6c83ce60c04$export$aa3357fb0ebcdb2b = (query)=>$9302f6c83ce60c04$export$6ed0d629c0656ce1(query, (0, ($parcel$interopDefault($5uXOq))).createElement($9302f6c83ce60c04$var$DefaultFailedFetchMessage, null));
    const $9302f6c83ce60c04$export$d6f6a072cce04542 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$38a1a0a811e06255 = (0, $5uXOq.forwardRef)(({ as: C = $9302f6c83ce60c04$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$df67068a00dece12 = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _u5f3u2gc",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$d90eccb59fb62cab = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $9302f6c83ce60c04$export$9e874bb1adc98a55 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("goAgE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7a2287a5c23e167$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b7a2287a5c23e167$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        failedFetch: {
            "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
            "defaultMessage": "Search failed."
        },
        reloadIssue: {
            "id": "issue-field-select-base.failed-fetch-options.reload-issue",
            "defaultMessage": "Try reloading the issue."
        },
        reloadIssueIssueTermRefresh: {
            "id": "issue-field-select-base.failed-fetch-options.reload-issue-issue-term-refresh",
            "defaultMessage": "Try reloading"
        }
    });
});
parcelRegister("3BhEA", function(module, exports) {
    $parcel$export(module.exports, "filterOptionByLabelAndFilterValues", ()=>$0eb6c4d40c779509$export$58bb91b619b113f6);
    var $8QpSo;
    var $5JAlL;
    const $0eb6c4d40c779509$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>typeof val === 'string' && val.toLowerCase().includes(inputValueIgnoredCase);
    const $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues = (option)=>{
        const { label: label, data: data } = option || {};
        const { filterValues: filterValues } = data || {};
        const labelString = typeof label === 'string' ? label : '';
        const filterValuesString = (filterValues || []).join(' ');
        return `${labelString} ${filterValuesString}`;
    };
    const $0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal = (0, (0, parcelRequire("8QpSo")).default)(()=>(0, (0, parcelRequire("5JAlL")).createFilter)({
            stringify: $0eb6c4d40c779509$var$stringifyLabelAndDataFilterValues
        }));
    const $0eb6c4d40c779509$export$58bb91b619b113f6 = (option, inputValue)=>$0eb6c4d40c779509$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);
});
parcelRegister("fh3sQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a46539e6d04481b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1a46539e6d04481b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        empty: {
            "id": "searchable-select.empty",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "searchable-select.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "searchable-select.placeholder",
            "defaultMessage": "Select an option"
        },
        loading: {
            "id": "searchable-select.loading",
            "defaultMessage": "Searching..."
        },
        createNewItem: {
            "id": "searchable-select.create-new-item",
            "defaultMessage": "Create"
        }
    });
});
parcelRegister("h1XvK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d11f601a4e5adff$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4d11f601a4e5adff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-issue-links.edit.search.placeholder",
            "defaultMessage": "Select Issue"
        },
        openIssues: {
            "id": "issue-field-issue-links.edit.search.open-issues",
            "defaultMessage": "Open Issues"
        },
        noHistoryResults: {
            "id": "issue-field-issue-links.edit.search.no-history-results",
            "defaultMessage": "Type to search for an issue summary or key"
        },
        singleInvalidIssue: {
            "id": "issue-field-issue-links.edit.search.single-invalid-issue",
            "defaultMessage": "We can't find an issue with the key"
        },
        multipleInvalidIssues: {
            "id": "issue-field-issue-links.edit.search.multiple-invalid-issues",
            "defaultMessage": "We can't find issues with the keys"
        },
        createNewIssueLink: {
            "id": "issue-field-issue-links.edit.search.create-new-issue-link",
            "defaultMessage": "Exact key"
        }
    });
});
parcelRegister("2xATL", function(module, exports) {
    $parcel$export(module.exports, "getCurrentHostPattern", ()=>$afdafd09cd63e727$export$47e10df7c3c19b6b);
    $parcel$export(module.exports, "stripUrlToIssueKey", ()=>$afdafd09cd63e727$export$1f3c6284caef177b);
    $parcel$export(module.exports, "stripQueryValueToIssueKey", ()=>$afdafd09cd63e727$export$a1fbc8ef5ec2d6e3);
    $parcel$export(module.exports, "transformIssueSuggestionItems", ()=>$afdafd09cd63e727$export$41cc13f7ec7b4b3d);
    var $h1XvK;
    const $afdafd09cd63e727$var$ISSUE_BROWSE_PATH = 'browse/';
    const $afdafd09cd63e727$var$ISSUE_KEY_REGEXP = /^(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
    const $afdafd09cd63e727$export$47e10df7c3c19b6b = ()=>{
        if (window.location.port !== '') return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
        return `${window.location.protocol}//${window.location.hostname}`;
    };
    const $afdafd09cd63e727$export$1f3c6284caef177b = (tenantUrl, candidateUrl)=>{
        let tenantUrlPath = tenantUrl;
        if (tenantUrlPath === undefined || candidateUrl === undefined) return candidateUrl || '';
        if (!tenantUrlPath.endsWith('/')) tenantUrlPath += '/';
        tenantUrlPath += $afdafd09cd63e727$var$ISSUE_BROWSE_PATH;
        if (candidateUrl.indexOf(tenantUrlPath) !== 0) return candidateUrl;
        const candidatePath = candidateUrl.slice(tenantUrlPath.length);
        const match = candidatePath.match($afdafd09cd63e727$var$ISSUE_KEY_REGEXP);
        if (match === null) return candidateUrl;
        return match[1] || '';
    };
    const $afdafd09cd63e727$export$a1fbc8ef5ec2d6e3 = (queryValue)=>{
        const currentHost = $afdafd09cd63e727$export$47e10df7c3c19b6b();
        return $afdafd09cd63e727$export$1f3c6284caef177b(currentHost, queryValue);
    };
    const $afdafd09cd63e727$export$41cc13f7ec7b4b3d = (results, formatMessage, query = '')=>{
        const { sections: sections } = results;
        const heading = formatMessage((0, (0, parcelRequire("h1XvK")).default).openIssues);
        const noSuggestionsMessage = formatMessage((0, (0, parcelRequire("h1XvK")).default).noHistoryResults);
        const suggestions = sections.map((section)=>section.issues).filter((issues)=>!!issues).reduce((flatten, current)=>flatten.concat(current.map((issue)=>({
                    label: `${issue.key} ${issue.summaryText}`,
                    value: issue.key,
                    id: issue.id ? issue.id.toString() : '',
                    iconUrl: issue.img,
                    filterValues: [
                        query
                    ]
                }))), []).reduce((uniq, current)=>uniq.findIndex((item)=>item.value === current.value) < 0 ? [
                ...uniq,
                current
            ] : uniq, []);
        if (suggestions.length) {
            const selectSuggestions = [
                {
                    label: heading,
                    options: suggestions
                }
            ];
            return selectSuggestions;
        }
        const noSuggestion = [
            {
                label: noSuggestionsMessage,
                isDisabled: true,
                value: ''
            }
        ];
        return noSuggestion;
    };
    const $afdafd09cd63e727$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
});
parcelRegister("6FMjJ", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOption", ()=>$0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa);
    $parcel$export(module.exports, "mapDataToOptions", ()=>$0d4f0c1fecf67eac$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$0d4f0c1fecf67eac$export$ffef3a401aef987b);
    const $0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa = (linkType)=>({
            id: linkType.linkTypeId,
            label: linkType.relationName,
            value: linkType.relationName,
            name: linkType.linkTypeName,
            direction: linkType.direction
        });
    const $0d4f0c1fecf67eac$export$99a866ffa3af7d8b = (linkTypes)=>linkTypes.map($0d4f0c1fecf67eac$export$5c1e24ea9ccb80aa);
    const $0d4f0c1fecf67eac$export$ffef3a401aef987b = (option)=>{
        if (option.issues.length === 0) return undefined;
        const direction = option.linkType.direction === 'INWARD' ? 'inwardIssues' : 'outwardIssues';
        return [
            {
                add: {
                    values: [
                        {
                            type: {
                                id: option.linkType.id
                            },
                            [direction]: option.issues.map((issue)=>({
                                    key: issue.value
                                }))
                        }
                    ]
                }
            }
        ];
    };
});
parcelRegister("3IdTl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a72be53e50da42c$export$2e2bcd8739ae039);
    var $7VHMR;
    const $7a72be53e50da42c$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        includeLinks: {
            "id": "issue-create-commons.issue-links-field.include-links",
            "defaultMessage": "Include links"
        },
        includeAttachments: {
            "id": "issue-create-commons.issue-links-field.include-attachments",
            "defaultMessage": "Include attachments"
        }
    });
    var $7a72be53e50da42c$export$2e2bcd8739ae039 = $7a72be53e50da42c$var$messages;
});
parcelRegister("h2h4F", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultIssueLinksValue", ()=>$4f5fb81cb5847464$export$acce6bb888b6838c);
    $parcel$export(module.exports, "validateIssueLinksField", ()=>$4f5fb81cb5847464$export$542fc2dd23d5dbdc);
    $parcel$export(module.exports, "mutateIssueLinksField", ()=>$4f5fb81cb5847464$export$c498672524a9f24d);
    var $4R6GH;
    var $bGrWH;
    var $6FMjJ;
    const $4f5fb81cb5847464$export$acce6bb888b6838c = (value)=>{
        if (value && value.length > 0) {
            const issues = [];
            value.forEach((issueLink)=>{
                if (issueLink.issue) issues.push({
                    iconUrl: issueLink.issue.avatar?.small,
                    id: issueLink.issue.issueId.toString(),
                    label: issueLink.issue.key,
                    value: issueLink.issue.key
                });
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                linkType: (0, (0, parcelRequire("6FMjJ")).mapDataToOption)(value?.[0]?.relatedBy),
                issues: issues,
                includeAttachments: undefined,
                includeLinks: undefined
            } : {
                linkType: (0, (0, parcelRequire("6FMjJ")).mapDataToOption)(value?.[0]?.relatedBy),
                issues: issues
            };
        }
        return undefined;
    };
    const $4f5fb81cb5847464$export$542fc2dd23d5dbdc = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
            if (value.issues.length === 0) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $4f5fb81cb5847464$export$c498672524a9f24d = (value)=>({
            issueLinks: {
                linkTypeName: value.linkType.value,
                linkedIssueKeys: value.issues.map((issue)=>issue.value.toString())
            }
        });
});
parcelRegister("8GQyc", function(module, exports) {
    $parcel$export(module.exports, "ForgeLabelsField", ()=>$34600c8cb7aa4373$export$f77bab10d748bb71);
    $parcel$export(module.exports, "default", ()=>$34600c8cb7aa4373$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $800rQ;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $evGBv;
    const $34600c8cb7aa4373$var$LabelsField = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("800rQ")).LabelsEdit), {
            isInvalid: Boolean(error),
            fetchSuggestionsOnMount: false,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly,
            inputId: id,
            isRequired: isRequired
        }));
    };
    const $34600c8cb7aa4373$export$f77bab10d748bb71 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateForgeLabelField),
        transformDefaultValue: (0, (0, parcelRequire("evGBv")).mapDataToLabelOptions)
    })($34600c8cb7aa4373$var$LabelsField);
    var $34600c8cb7aa4373$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateLabelField),
        transformDefaultValue: (0, (0, parcelRequire("evGBv")).mapDataToLabelOptions)
    })($34600c8cb7aa4373$var$LabelsField);
});
parcelRegister("800rQ", function(module, exports) {
    $parcel$export(module.exports, "LabelsEdit", ()=>$392f4ecadcf70f0f$export$23584166c0ffb901);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $4R6GH;
    var $koVbs;
    var $6Vzc4;
    var $3BhEA;
    var $lElIo;
    var $5fc53;
    var $2QTbq;
    var $l2SvC;
    var $e3wnO;
    var $l5gEe;
    const $392f4ecadcf70f0f$export$251bdbdbce9550ea = 300;
    const $392f4ecadcf70f0f$export$23584166c0ffb901 = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, (0, parcelRequire("5fc53")).LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const lastQuery = (0, $5uXOq.useRef)('');
        const sessionId = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($7Jxgt))).v4());
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, (0, parcelRequire("l2SvC")).useLabelsSuggestions)({
            fieldId: fieldId,
            getSuggestions: getSuggestions
        });
        const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FailedFetchOptionWrapper), null, formatMessage((0, (0, parcelRequire("l5gEe")).default).failedFetch)), [
            formatMessage
        ]);
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            try {
                const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
                setIsLoadingSuggestions(false);
                if (lastQuery.current === query) {
                    const results = (0, (0, parcelRequire("2QTbq")).mapLabelsResponseToLabelOptions)(response);
                    setSuggestions(results);
                    if (query === '') setDefaultSuggestions(results);
                }
            } catch (err) {
                setIsLoadingSuggestions(false);
                setHasLastFetchFailed(true);
                setSuggestions([
                    {
                        label: getFailedFetchMessage(),
                        value: '',
                        isDisabled: true
                    }
                ]);
            }
        }, [
            autoCompleteUrl,
            getFailedFetchMessage,
            getLabelsSuggestions,
            lastQuery,
            sessionId,
            setHasLastFetchFailed,
            setIsLoadingSuggestions
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) (0, $5uXOq.useEffect)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        else (0, $5uXOq.useMemo)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        const groupedSuggestions = (0, $5uXOq.useMemo)(()=>[
                {
                    label: formatMessage((0, (0, parcelRequire("l5gEe")).default).recent),
                    options: cachedOptions
                },
                {
                    label: formatMessage((0, (0, parcelRequire("l5gEe")).default).all),
                    options: suggestions || []
                }
            ], [
            cachedOptions,
            formatMessage,
            suggestions
        ]);
        const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(fetchSuggestions, $392f4ecadcf70f0f$export$251bdbdbce9550ea), []);
        const getCreateLabel = (0, $5uXOq.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, (0, parcelRequire("l5gEe")).default).createNewItem)})`, [
            formatCreateLabel,
            formatMessage
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, (0, parcelRequire("l5gEe")).default).empty), [
            formatMessage,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, (0, parcelRequire("l5gEe")).default).loading), [
            formatMessage,
            loadingMessage
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, query || '');
        }, [
            hasLastFetchFailed
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedFetchSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedFetchSuggestions,
            defaultSuggestions,
            setIsLoadingSuggestions,
            setSuggestions
        ]);
        const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
            if (!suggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions('');
            }
            onFocus && onFocus(e);
        }, [
            suggestions,
            onFocus,
            setIsLoadingSuggestions,
            fetchSuggestions
        ]);
        const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
            onBlur && onBlur(e);
        }, [
            onBlur
        ]);
        const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
        const isLoading = isLoadingSuggestions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e3wnO")).default), {
            isMulti: true,
            autoFocus: autoFocus,
            fieldId: fieldId,
            options: groupedSuggestions,
            value: value,
            isDisabled: isDisabled,
            onBlur: onSelectBlur,
            menuPosition: menuPosition,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            closeMenuOnScroll: onCloseMenuOnScroll,
            loadingMessage: getLoadingMessage,
            placeholder: formatMessage((0, (0, parcelRequire("l5gEe")).default).placeholder),
            onInputChange: onQueryChange,
            onChange: onChange,
            spacing: spacing,
            isLoading: isLoading,
            filterOption: filterOption,
            formatCreateLabel: getCreateLabel,
            validationState: isInvalid === true ? 'error' : null,
            sessionId: sessionId.current,
            "aria-label": ariaLabel,
            inputId: inputId,
            isRequired: isRequired,
            openMenuOnFocus: openMenuOnFocus
        });
    };
    var $392f4ecadcf70f0f$export$2e2bcd8739ae039 = $392f4ecadcf70f0f$export$23584166c0ffb901;
});
parcelRegister("l2SvC", function(module, exports) {
    $parcel$export(module.exports, "useLabelsSuggestions", ()=>$aed9af8029ae7a32$export$c5b80cd78ff71c5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $6RCeq;
    var $eusud;
    var $8SCDp;
    var $5fc53;
    var $2NMNM;
    const $aed9af8029ae7a32$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
        let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(url);
    };
    const $aed9af8029ae7a32$export$c5b80cd78ff71c5f = (props)=>{
        const { fieldId: fieldId, getSuggestions: getSuggestions = $aed9af8029ae7a32$export$343652b9755c68e7 } = props;
        const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const getLabelsSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
            const startTime = (0, (0, parcelRequire("6RCeq")).default).now();
            const queryLength = query.length;
            try {
                const response = await getSuggestions(autoCompleteUrl, query, sessionId);
                if (fieldId === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) (0, (0, parcelRequire("8SCDp")).fireSuggestionsRequestSuccessEvent)((0, (0, parcelRequire("5fc53")).LABELS_TYPE), startTime, createAnalyticsEvent, {
                    sessionId: sessionId,
                    queryLength: queryLength
                });
                setIsLoadingSuggestions(false);
                return response;
            } catch (error) {
                if (fieldId === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) (0, (0, parcelRequire("8SCDp")).fireSuggestionsRequestFailedEvent)((0, (0, parcelRequire("5fc53")).LABELS_TYPE), startTime, createAnalyticsEvent, {
                    sessionId: sessionId
                });
                setIsLoadingSuggestions(false);
                throw error;
            }
        }, [
            createAnalyticsEvent,
            fieldId,
            getSuggestions,
            setIsLoadingSuggestions
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>({
                getLabelsSuggestions: getLabelsSuggestions,
                setIsLoadingSuggestions: setIsLoadingSuggestions
            }), [
            getLabelsSuggestions,
            setIsLoadingSuggestions
        ]);
        return [
            {
                isLoadingSuggestions: isLoadingSuggestions
            },
            actions
        ];
    };
});
parcelRegister("8SCDp", function(module, exports) {
    $parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", ()=>$305439819cb2bcec$export$7eeca21c46efa338);
    $parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", ()=>$305439819cb2bcec$export$a31ac580130dee62);
    var $6RCeq;
    var $8zOmE;
    const $305439819cb2bcec$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
        const attributes = {
            ...additionalAttributes,
            elapsedTimeMs: (0, (0, parcelRequire("6RCeq")).default).now() - startTime
        };
        createAnalyticsEvent && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        }), `${actionSubject} ${action}`, attributes);
    };
    const $305439819cb2bcec$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
        $305439819cb2bcec$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
    };
    const $305439819cb2bcec$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
        $305439819cb2bcec$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
    };
});
parcelRegister("e3wnO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35584119a49c4bd8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $iOwNT;
    var $6RCeq;
    var $6s1PB;
    var $cSD7y;
    var $4R6GH;
    var $db8jg;
    var $2OMDV;
    var $8zOmE;
    var $2NMNM;
    var $biBfP;
    const $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
    const $35584119a49c4bd8$var$analyticsProps = {
        onChange: 'valueChanged',
        onInputChange: 'inputChanged',
        onMenuOpen: 'menuOpened',
        onMenuClose: 'menuClosed'
    };
    const $35584119a49c4bd8$export$29e0f2c0983c7379 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('select', $35584119a49c4bd8$var$analyticsProps)((0, (0, parcelRequire("iOwNT")).default));
    const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsViewOld = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, (0, parcelRequire("biBfP")).flattenOptions)(options));
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("biBfP")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                isDisabled: isDisabled,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading,
            isDisabled
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt === 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)(()=>{
            endSession();
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
            if (onChange) onChange(selectedValue, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange,
            isMulti
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            return ()=>{
                endSession();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const flattenedOption = (0, (0, parcelRequire("biBfP")).flattenOptions)(options);
            if (!(0, ($parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
        }, [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$29e0f2c0983c7379, {
            ...props,
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics
        });
    };
    const $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const editSessionId = (0, $5uXOq.useRef)();
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const editSessionStartedAt = (0, $5uXOq.useRef)(0);
        const [flatOptions, setFlatOptions] = (0, $5uXOq.useState)((0, (0, parcelRequire("biBfP")).flattenOptions)(options));
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("biBfP")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                isDisabled: isDisabled,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("biBfP")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("biBfP")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $35584119a49c4bd8$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading,
            isDisabled
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startEditSession = (0, $5uXOq.useCallback)(()=>{
            if (editSessionId.current === undefined) editSessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            editSessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'fieldEditSession', {
                editSessionId: editSessionId.current
            });
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent
        ]);
        const endEditSession = (0, $5uXOq.useCallback)(()=>{
            if (editSessionId.current !== undefined) {
                const config = (0, (0, parcelRequire("4R6GH")).fg)('labels_restricted_to_project_experiment') && (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('labels_restricted_to_project')[0];
                const elapsedTime = (0, (0, parcelRequire("6RCeq")).default).now() - editSessionStartedAt.current;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'fieldEditSession', {
                    elapsedTime: elapsedTime,
                    editSessionId: editSessionId.current,
                    ...config ? {
                        hasProjectScopedLabels: config.get('showProjectFilter', false)
                    } : {}
                });
            }
            editSessionId.current = undefined;
            editSessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)((interactionType)=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt !== 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime,
                    interactionType: interactionType
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)((interactionType)=>{
            endSession(interactionType);
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession('option created');
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession('option selected');
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("biBfP")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
            if (onChange) onChange(selectedValue, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange,
            isMulti
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            startSession();
            startEditSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            return ()=>{
                endSession();
                endEditSession();
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const flattenedOption = (0, (0, parcelRequire("biBfP")).flattenOptions)(options);
            if (!(0, ($parcel$interopDefault($ajpes)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
        }, [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($35584119a49c4bd8$export$29e0f2c0983c7379, {
            ...props,
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics
        });
    };
    var $35584119a49c4bd8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('labels_select_with_interaction_analytics', $35584119a49c4bd8$var$CreatableSelectWithAnalyticsView, $35584119a49c4bd8$var$CreatableSelectWithAnalyticsViewOld);
});
parcelRegister("db8jg", function(module, exports) {
    $parcel$export(module.exports, "memoizedHashString", ()=>$6aa2f917648b2dec$export$c9e165da390f6283);
    var $eb3tB = parcelRequire("eb3tB");
    var $8QpSo;
    var $4Pf62;
    const $6aa2f917648b2dec$export$fdd2c0ba94025c3c = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        return cloudId;
    });
    const $6aa2f917648b2dec$export$c9e165da390f6283 = (attribute)=>{
        const cloudId = $6aa2f917648b2dec$export$fdd2c0ba94025c3c();
        const hash = (0, $eb3tB.sha256)(`${cloudId}_${attribute.trim()}`);
        return hash;
    };
});
parcelRegister("eb3tB", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    (function() {
        'use strict';
        var ERROR = 'input is invalid type';
        var WINDOW = typeof window === 'object';
        var root = WINDOW ? window : {};
        if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
        var WEB_WORKER = !WINDOW && typeof self === 'object';
        var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $6cAn5 === 'object' && $6cAn5.versions && $6cAn5.versions.node;
        if (NODE_JS) root = $parcel$global;
        else if (WEB_WORKER) root = self;
        var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
        var AMD = typeof define === 'function' && define.amd;
        var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
        var HEX_CHARS = '0123456789abcdef'.split('');
        var EXTRA = [
            -2147483648,
            8388608,
            32768,
            128
        ];
        var SHIFT = [
            24,
            16,
            8,
            0
        ];
        var K = [
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ];
        var OUTPUT_TYPES = [
            'hex',
            'array',
            'digest',
            'arrayBuffer'
        ];
        var blocks = [];
        if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
            return Object.prototype.toString.call(obj) === '[object Array]';
        };
        if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
            return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
        };
        var createOutputMethod = function(outputType, is224) {
            return function(message) {
                return new Sha256(is224, true).update(message)[outputType]();
            };
        };
        var createMethod = function(is224) {
            var method = createOutputMethod('hex', is224);
            if (NODE_JS) method = nodeWrap(method, is224);
            method.create = function() {
                return new Sha256(is224);
            };
            method.update = function(message) {
                return method.create().update(message);
            };
            for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                var type = OUTPUT_TYPES[i];
                method[type] = createOutputMethod(type, is224);
            }
            return method;
        };
        var nodeWrap = function(method, is224) {
            var crypto = (parcelRequire("3gWwf"));
            var Buffer = (parcelRequire("3gWwf")).Buffer;
            var algorithm = is224 ? 'sha224' : 'sha256';
            var bufferFrom;
            if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
            else bufferFrom = function(message) {
                return new Buffer(message);
            };
            var nodeMethod = function(message) {
                if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
                else {
                    if (message === null || message === undefined) throw new Error(ERROR);
                    else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
                }
                if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
                else return method(message);
            };
            return nodeMethod;
        };
        var createHmacOutputMethod = function(outputType, is224) {
            return function(key, message) {
                return new HmacSha256(key, is224, true).update(message)[outputType]();
            };
        };
        var createHmacMethod = function(is224) {
            var method = createHmacOutputMethod('hex', is224);
            method.create = function(key) {
                return new HmacSha256(key, is224);
            };
            method.update = function(key, message) {
                return method.create(key).update(message);
            };
            for(var i = 0; i < OUTPUT_TYPES.length; ++i){
                var type = OUTPUT_TYPES[i];
                method[type] = createHmacOutputMethod(type, is224);
            }
            return method;
        };
        function Sha256(is224, sharedMemory) {
            if (sharedMemory) {
                blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
                this.blocks = blocks;
            } else this.blocks = [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            if (is224) {
                this.h0 = 0xc1059ed8;
                this.h1 = 0x367cd507;
                this.h2 = 0x3070dd17;
                this.h3 = 0xf70e5939;
                this.h4 = 0xffc00b31;
                this.h5 = 0x68581511;
                this.h6 = 0x64f98fa7;
                this.h7 = 0xbefa4fa4;
            } else {
                this.h0 = 0x6a09e667;
                this.h1 = 0xbb67ae85;
                this.h2 = 0x3c6ef372;
                this.h3 = 0xa54ff53a;
                this.h4 = 0x510e527f;
                this.h5 = 0x9b05688c;
                this.h6 = 0x1f83d9ab;
                this.h7 = 0x5be0cd19;
            }
            this.block = this.start = this.bytes = this.hBytes = 0;
            this.finalized = this.hashed = false;
            this.first = true;
            this.is224 = is224;
        }
        Sha256.prototype.update = function(message) {
            if (this.finalized) return;
            var notString, type = typeof message;
            if (type !== 'string') {
                if (type === 'object') {
                    if (message === null) throw new Error(ERROR);
                    else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                    else if (!Array.isArray(message)) {
                        if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                    }
                } else throw new Error(ERROR);
                notString = true;
            }
            var code, index = 0, i, length = message.length, blocks = this.blocks;
            while(index < length){
                if (this.hashed) {
                    this.hashed = false;
                    blocks[0] = this.block;
                    this.block = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
                }
                if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
                else for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                    else if (code < 0x800) {
                        blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else if (code < 0xd800 || code >= 0xe000) {
                        blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    }
                }
                this.lastByteIndex = i;
                this.bytes += i - this.start;
                if (i >= 64) {
                    this.block = blocks[16];
                    this.start = i - 64;
                    this.hash();
                    this.hashed = true;
                } else this.start = i;
            }
            if (this.bytes > 4294967295) {
                this.hBytes += this.bytes / 4294967296 << 0;
                this.bytes = this.bytes % 4294967296;
            }
            return this;
        };
        Sha256.prototype.finalize = function() {
            if (this.finalized) return;
            this.finalized = true;
            var blocks = this.blocks, i = this.lastByteIndex;
            blocks[16] = this.block;
            blocks[i >>> 2] |= EXTRA[i & 3];
            this.block = blocks[16];
            if (i >= 56) {
                if (!this.hashed) this.hash();
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
            blocks[15] = this.bytes << 3;
            this.hash();
        };
        Sha256.prototype.hash = function() {
            var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
            for(j = 16; j < 64; ++j){
                t1 = blocks[j - 15];
                s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
                t1 = blocks[j - 2];
                s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
                blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
            }
            bc = b & c;
            for(j = 0; j < 64; j += 4){
                if (this.first) {
                    if (this.is224) {
                        ab = 300032;
                        t1 = blocks[0] - 1413257819;
                        h = t1 - 150054599 << 0;
                        d = t1 + 24177077 << 0;
                    } else {
                        ab = 704751109;
                        t1 = blocks[0] - 210244248;
                        h = t1 - 1521486534 << 0;
                        d = t1 + 143694565 << 0;
                    }
                    this.first = false;
                } else {
                    s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                    s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                    ab = a & b;
                    maj = ab ^ a & c ^ bc;
                    ch = e & f ^ ~e & g;
                    t1 = h + s1 + ch + K[j] + blocks[j];
                    t2 = s0 + maj;
                    h = d + t1 << 0;
                    d = t1 + t2 << 0;
                }
                s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
                s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
                da = d & a;
                maj = da ^ d & b ^ ab;
                ch = h & e ^ ~h & f;
                t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
                t2 = s0 + maj;
                g = c + t1 << 0;
                c = t1 + t2 << 0;
                s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
                s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
                cd = c & d;
                maj = cd ^ c & a ^ da;
                ch = g & h ^ ~g & e;
                t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
                t2 = s0 + maj;
                f = b + t1 << 0;
                b = t1 + t2 << 0;
                s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
                s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
                bc = b & c;
                maj = bc ^ b & d ^ cd;
                ch = f & g ^ ~f & h;
                t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
                t2 = s0 + maj;
                e = a + t1 << 0;
                a = t1 + t2 << 0;
                this.chromeBugWorkAround = true;
            }
            this.h0 = this.h0 + a << 0;
            this.h1 = this.h1 + b << 0;
            this.h2 = this.h2 + c << 0;
            this.h3 = this.h3 + d << 0;
            this.h4 = this.h4 + e << 0;
            this.h5 = this.h5 + f << 0;
            this.h6 = this.h6 + g << 0;
            this.h7 = this.h7 + h << 0;
        };
        Sha256.prototype.hex = function() {
            this.finalize();
            var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
            var hex = HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >>> 28 & 0x0F] + HEX_CHARS[h4 >>> 24 & 0x0F] + HEX_CHARS[h4 >>> 20 & 0x0F] + HEX_CHARS[h4 >>> 16 & 0x0F] + HEX_CHARS[h4 >>> 12 & 0x0F] + HEX_CHARS[h4 >>> 8 & 0x0F] + HEX_CHARS[h4 >>> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >>> 28 & 0x0F] + HEX_CHARS[h5 >>> 24 & 0x0F] + HEX_CHARS[h5 >>> 20 & 0x0F] + HEX_CHARS[h5 >>> 16 & 0x0F] + HEX_CHARS[h5 >>> 12 & 0x0F] + HEX_CHARS[h5 >>> 8 & 0x0F] + HEX_CHARS[h5 >>> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >>> 28 & 0x0F] + HEX_CHARS[h6 >>> 24 & 0x0F] + HEX_CHARS[h6 >>> 20 & 0x0F] + HEX_CHARS[h6 >>> 16 & 0x0F] + HEX_CHARS[h6 >>> 12 & 0x0F] + HEX_CHARS[h6 >>> 8 & 0x0F] + HEX_CHARS[h6 >>> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
            if (!this.is224) hex += HEX_CHARS[h7 >>> 28 & 0x0F] + HEX_CHARS[h7 >>> 24 & 0x0F] + HEX_CHARS[h7 >>> 20 & 0x0F] + HEX_CHARS[h7 >>> 16 & 0x0F] + HEX_CHARS[h7 >>> 12 & 0x0F] + HEX_CHARS[h7 >>> 8 & 0x0F] + HEX_CHARS[h7 >>> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
            return hex;
        };
        Sha256.prototype.toString = Sha256.prototype.hex;
        Sha256.prototype.digest = function() {
            this.finalize();
            var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
            var arr = [
                h0 >>> 24 & 0xFF,
                h0 >>> 16 & 0xFF,
                h0 >>> 8 & 0xFF,
                h0 & 0xFF,
                h1 >>> 24 & 0xFF,
                h1 >>> 16 & 0xFF,
                h1 >>> 8 & 0xFF,
                h1 & 0xFF,
                h2 >>> 24 & 0xFF,
                h2 >>> 16 & 0xFF,
                h2 >>> 8 & 0xFF,
                h2 & 0xFF,
                h3 >>> 24 & 0xFF,
                h3 >>> 16 & 0xFF,
                h3 >>> 8 & 0xFF,
                h3 & 0xFF,
                h4 >>> 24 & 0xFF,
                h4 >>> 16 & 0xFF,
                h4 >>> 8 & 0xFF,
                h4 & 0xFF,
                h5 >>> 24 & 0xFF,
                h5 >>> 16 & 0xFF,
                h5 >>> 8 & 0xFF,
                h5 & 0xFF,
                h6 >>> 24 & 0xFF,
                h6 >>> 16 & 0xFF,
                h6 >>> 8 & 0xFF,
                h6 & 0xFF
            ];
            if (!this.is224) arr.push(h7 >>> 24 & 0xFF, h7 >>> 16 & 0xFF, h7 >>> 8 & 0xFF, h7 & 0xFF);
            return arr;
        };
        Sha256.prototype.array = Sha256.prototype.digest;
        Sha256.prototype.arrayBuffer = function() {
            this.finalize();
            var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
            var dataView = new DataView(buffer);
            dataView.setUint32(0, this.h0);
            dataView.setUint32(4, this.h1);
            dataView.setUint32(8, this.h2);
            dataView.setUint32(12, this.h3);
            dataView.setUint32(16, this.h4);
            dataView.setUint32(20, this.h5);
            dataView.setUint32(24, this.h6);
            if (!this.is224) dataView.setUint32(28, this.h7);
            return buffer;
        };
        function HmacSha256(key, is224, sharedMemory) {
            var i, type = typeof key;
            if (type === 'string') {
                var bytes = [], length = key.length, index = 0, code;
                for(i = 0; i < length; ++i){
                    code = key.charCodeAt(i);
                    if (code < 0x80) bytes[index++] = code;
                    else if (code < 0x800) {
                        bytes[index++] = 0xc0 | code >>> 6;
                        bytes[index++] = 0x80 | code & 0x3f;
                    } else if (code < 0xd800 || code >= 0xe000) {
                        bytes[index++] = 0xe0 | code >>> 12;
                        bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                        bytes[index++] = 0x80 | code & 0x3f;
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                        bytes[index++] = 0xf0 | code >>> 18;
                        bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                        bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                        bytes[index++] = 0x80 | code & 0x3f;
                    }
                }
                key = bytes;
            } else {
                if (type === 'object') {
                    if (key === null) throw new Error(ERROR);
                    else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                    else if (!Array.isArray(key)) {
                        if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                    }
                } else throw new Error(ERROR);
            }
            if (key.length > 64) key = new Sha256(is224, true).update(key).array();
            var oKeyPad = [], iKeyPad = [];
            for(i = 0; i < 64; ++i){
                var b = key[i] || 0;
                oKeyPad[i] = 0x5c ^ b;
                iKeyPad[i] = 0x36 ^ b;
            }
            Sha256.call(this, is224, sharedMemory);
            this.update(iKeyPad);
            this.oKeyPad = oKeyPad;
            this.inner = true;
            this.sharedMemory = sharedMemory;
        }
        HmacSha256.prototype = new Sha256();
        HmacSha256.prototype.finalize = function() {
            Sha256.prototype.finalize.call(this);
            if (this.inner) {
                this.inner = false;
                var innerHash = this.array();
                Sha256.call(this, this.is224, this.sharedMemory);
                this.update(this.oKeyPad);
                this.update(innerHash);
                Sha256.prototype.finalize.call(this);
            }
        };
        var exports = createMethod();
        exports.sha256 = exports;
        exports.sha224 = createMethod(true);
        exports.sha256.hmac = createHmacMethod();
        exports.sha224.hmac = createHmacMethod(true);
        if (COMMON_JS) module.exports = exports;
        else {
            root.sha256 = exports.sha256;
            root.sha224 = exports.sha224;
            if (AMD) define(function() {
                return exports;
            });
        }
    })();
});
parcelRegister("2OMDV", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsEventToProps", ()=>$28422a5dfa4a4065$export$3e9ef96ba97ea9dc);
    var $cb25w;
    const $28422a5dfa4a4065$export$871de8747c9eaa88 = (props, componentName)=>Object.keys(props).reduce((result, key)=>({
                ...result,
                [key]: {
                    action: props[key],
                    actionSubject: componentName
                }
            }), {});
    const $28422a5dfa4a4065$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>(WrappedComponent)=>(0, (0, parcelRequire("cb25w")).default)($28422a5dfa4a4065$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);
});
parcelRegister("biBfP", function(module, exports) {
    $parcel$export(module.exports, "getSafeValue", ()=>$e31cfbdea683954a$export$d05672fd1312a6d);
    $parcel$export(module.exports, "getSafeOptionsForAnalytics", ()=>$e31cfbdea683954a$export$fde3d804891b8254);
    $parcel$export(module.exports, "flattenOptions", ()=>$e31cfbdea683954a$export$7baa7c13b358b002);
    $parcel$export(module.exports, "getOptionValuesLengths", ()=>$e31cfbdea683954a$export$e2e167245697ed4e);
    $parcel$export(module.exports, "filterOptions", ()=>$e31cfbdea683954a$export$60d56ed3961c839c);
    var $chc6P = parcelRequire("chc6P");
    var $db8jg;
    const $e31cfbdea683954a$export$d05672fd1312a6d = (val)=>(0, (0, parcelRequire("db8jg")).memoizedHashString)(val.toString()).toString();
    const $e31cfbdea683954a$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$e31cfbdea683954a$export$d05672fd1312a6d(value));
    const $e31cfbdea683954a$export$7baa7c13b358b002 = (optionGroups)=>(0, ($parcel$interopDefault($chc6P)))(optionGroups.map((group)=>group.options));
    const $e31cfbdea683954a$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
    const $e31cfbdea683954a$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));
});
parcelRegister("chc6P", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $80afZ = parcelRequire("80afZ");
    function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
        return $ekcP3($80afZ(collection, iteratee), 1);
    }
    module.exports = $8f007734a6a4d9ac$var$flatMap;
});
parcelRegister("80afZ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $jXnVG = parcelRequire("jXnVG");
    var $8LQ84 = parcelRequire("8LQ84");
    function $5d3647a04b83e8d6$var$map(collection, iteratee) {
        var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
        return func(collection, $bxDef(iteratee, 3));
    }
    module.exports = $5d3647a04b83e8d6$var$map;
});
parcelRegister("l5gEe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef8773284d2f300e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ef8773284d2f300e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        empty: {
            "id": "issue-field-labels.edit.empty",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "issue-field-labels.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "issue-field-labels.edit.placeholder",
            "defaultMessage": "Select label"
        },
        createNewItem: {
            "id": "issue-field-labels.edit.create-new-item",
            "defaultMessage": "New label"
        },
        loading: {
            "id": "issue-field-labels.edit.loading",
            "defaultMessage": "Searching..."
        },
        recent: {
            "id": "issue-field-labels.edit.recent",
            "defaultMessage": "Recent labels"
        },
        all: {
            "id": "issue-field-labels.edit.all",
            "defaultMessage": "All labels"
        }
    });
});
parcelRegister("evGBv", function(module, exports) {
    $parcel$export(module.exports, "mapDataToLabelOptions", ()=>$df66270ab3f9af77$export$cd8e373d5b1325b1);
    $parcel$export(module.exports, "mutateLabelsFields", ()=>$df66270ab3f9af77$export$f691a7c5b86be653);
    const $df66270ab3f9af77$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
                value: name,
                label: name
            }));
    const $df66270ab3f9af77$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
            fieldId: fieldId,
            labels: selectedLabels.map(({ value: value })=>({
                    name: value
                })),
            mutationGroup: (0, $fbaea1aecc52fe2c$export$31fd86f8f183952c)
        });
});
const $fbaea1aecc52fe2c$export$31fd86f8f183952c = 'labelsFields';
parcelRegister("9sq52", function(module, exports) {
    $parcel$export(module.exports, "getIsTimeEstimateExceeded", ()=>$90724da7402a12e3$export$20e7052b315e94b);
    $parcel$export(module.exports, "getCalculatedTimeRemainingIfAny", ()=>$90724da7402a12e3$export$51a45955a3207e1b);
    $parcel$export(module.exports, "getLogWorkSubmitValue", ()=>$90724da7402a12e3$export$7d47ca3907f5addd);
    var $k7m40;
    var $axdWJ;
    var $khZ39;
    var $jXTQd;
    const $90724da7402a12e3$export$20e7052b315e94b = (args)=>{
        const { config: config, timeTrackingValue: timeTrackingValue, timeSpent: timeSpent, timeRemaining: timeRemaining } = args;
        const isTimeRemainingValid = (0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(timeRemaining);
        const isTimeSpentValid = (0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(timeSpent);
        const isTimeTrackingValid = (0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(timeTrackingValue);
        if (isTimeTrackingValid && (isTimeRemainingValid || isTimeSpentValid)) {
            let timeSpentInSeconds = 0;
            let timeRemainingInSeconds = 0;
            const timeTrackingValueInSeconds = (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue);
            if (isTimeSpentValid) timeSpentInSeconds = (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeSpent);
            if (isTimeRemainingValid) timeRemainingInSeconds = (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeRemaining);
            timeRemainingInSeconds = typeof timeRemainingInSeconds !== 'number' ? 0 : timeRemainingInSeconds;
            timeSpentInSeconds = typeof timeSpentInSeconds !== 'number' ? 0 : timeSpentInSeconds;
            if (typeof timeTrackingValueInSeconds === 'number') {
                if (timeSpentInSeconds + timeRemainingInSeconds > timeTrackingValueInSeconds) return true;
            }
        }
        return false;
    };
    const $90724da7402a12e3$export$51a45955a3207e1b = (args)=>{
        let calculatedTimeRemaining = null;
        const { timeSpent: timeSpent, timeTrackingValue: timeTrackingValue, config: config } = args;
        const isValidTimeTrackingValue = (0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(timeTrackingValue);
        if (!timeSpent && isValidTimeTrackingValue) return timeTrackingValue;
        const isValidTimeSpent = (0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(timeSpent);
        if (isValidTimeTrackingValue && isValidTimeSpent) {
            const timeSpentInSeconds = (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeSpent) || 0;
            const timeTrackingInSeconds = (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue) || 0;
            if (timeTrackingInSeconds >= timeSpentInSeconds) calculatedTimeRemaining = (0, (0, parcelRequire("khZ39")).default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingInSeconds - timeSpentInSeconds);
        }
        return calculatedTimeRemaining;
    };
    const $90724da7402a12e3$export$7d47ca3907f5addd = (value)=>{
        const { dateValue: dateValue, timeSpent: timeSpent, timeRemaining: timeRemaining, description: description } = value;
        const adjustEstimate = timeRemaining ? 'new' : 'leave';
        return [
            {
                add: {
                    started: dateValue ? (0, (0, parcelRequire("k7m40")).default)(new Date(dateValue), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxx") : undefined,
                    timeSpent: timeSpent,
                    adjustEstimate: adjustEstimate,
                    newEstimate: timeRemaining,
                    comment: description && JSON.stringify(description)
                }
            }
        ];
    };
});
parcelRegister("axdWJ", function(module, exports) {
    $parcel$export(module.exports, "formatTimeString", ()=>$3e1d4e008ffe7726$export$2de90790c3ad23b1);
    $parcel$export(module.exports, "isValidTimeString", ()=>$3e1d4e008ffe7726$export$669626963db3b187);
    $parcel$export(module.exports, "parseTimeString", ()=>$3e1d4e008ffe7726$export$53148bfa4e677363);
    var $caiLO;
    var $khZ39;
    var $jXTQd;
    var $51HJa;
    var $8KiHO;
    const $3e1d4e008ffe7726$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, (0, parcelRequire("khZ39")).default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
    const $3e1d4e008ffe7726$export$5eb9d332712102eb = (config)=>(value)=>{
            let trimmedValue = value.trim();
            const isValidNumber = (0, (0, parcelRequire("51HJa")).isNumeric)(trimmedValue.replaceAll(',', '.'));
            if (isValidNumber) {
                const { defaultUnit: defaultUnit } = config;
                trimmedValue = `${trimmedValue}${(0, (0, parcelRequire("8KiHO")).getDefaultTimeTrackingUnit)(defaultUnit)}`;
            }
            return trimmedValue;
        };
    const $3e1d4e008ffe7726$export$669626963db3b187 = (config)=>(value)=>{
            const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
            return timeString === '' || (0, (0, parcelRequire("caiLO")).default)(timeString);
        };
    const $3e1d4e008ffe7726$export$53148bfa4e677363 = (config)=>(value)=>{
            const timeString = $3e1d4e008ffe7726$export$5eb9d332712102eb(config)(value);
            if (!$3e1d4e008ffe7726$export$669626963db3b187(config)(timeString)) return 0;
            return (0, (0, parcelRequire("jXTQd")).default)(config.daysPerWeek, config.hoursPerDay)(timeString);
        };
});
parcelRegister("caiLO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8041043484b2005f$export$2e2bcd8739ae039);
    var $D5mr3 = parcelRequire("D5mr3");
    var $jXTQd;
    var $8041043484b2005f$export$2e2bcd8739ae039 = (timeString)=>{
        const result = (0, (0, parcelRequire("jXTQd")).default)(1, 1)(timeString);
        return result !== null && (0, ($parcel$interopDefault($D5mr3)))(result);
    };
});
parcelRegister("D5mr3", function(module, exports) {
    var $1V15E = parcelRequire("1V15E");
    var $0757cd3024f91218$var$nativeIsFinite = $1V15E.isFinite;
    function $0757cd3024f91218$var$isFinite(value) {
        return typeof value == 'number' && $0757cd3024f91218$var$nativeIsFinite(value);
    }
    module.exports = $0757cd3024f91218$var$isFinite;
});
parcelRegister("jXTQd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$805a43ba842f3e63$export$2e2bcd8739ae039);
    const $805a43ba842f3e63$var$MINUTES_PER_HOUR = 60;
    const $805a43ba842f3e63$var$SECONDS_PER_MINUTE = 60;
    const $805a43ba842f3e63$var$UNIT_STRING_PATTERN = /^(\d+(?:[.,]\d+)?)([wdhm])$/;
    const $805a43ba842f3e63$var$convertToUnitQuantity = (rawString)=>{
        const matches = $805a43ba842f3e63$var$UNIT_STRING_PATTERN.exec(rawString);
        if (!matches) return null;
        const normalizedQuantity = matches[1].replaceAll(',', '.');
        return {
            quantity: parseFloat(normalizedQuantity),
            unit: matches[2]
        };
    };
    const $805a43ba842f3e63$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
        const unitDefinitions = [
            {
                unit: 'w',
                seconds: daysPerWeek * hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
            },
            {
                unit: 'd',
                seconds: hoursPerDay * $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
            },
            {
                unit: 'h',
                seconds: $805a43ba842f3e63$var$MINUTES_PER_HOUR * $805a43ba842f3e63$var$SECONDS_PER_MINUTE
            },
            {
                unit: 'm',
                seconds: $805a43ba842f3e63$var$SECONDS_PER_MINUTE
            }
        ];
        return (timeString)=>{
            const unitQuantities = timeString.split(' ').map($805a43ba842f3e63$var$convertToUnitQuantity);
            let quantitiesConsumed = 0;
            let seconds = 0;
            for(let i = 0; i < unitDefinitions.length; i += 1){
                if (quantitiesConsumed === unitQuantities.length) break;
                const unitDefinition = unitDefinitions[i];
                const unitQuantity = unitQuantities[quantitiesConsumed];
                if (!unitQuantity) return null;
                if (unitQuantity.unit === unitDefinition.unit) {
                    seconds += unitQuantity.quantity * unitDefinition.seconds;
                    quantitiesConsumed += 1;
                }
            }
            if (quantitiesConsumed < unitQuantities.length) return null;
            return Math.floor(seconds);
        };
    };
    var $805a43ba842f3e63$export$2e2bcd8739ae039 = $805a43ba842f3e63$var$timeStringToSeconds;
});
parcelRegister("khZ39", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a56ddd74feeb1a3$export$2e2bcd8739ae039);
    const $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR = 60;
    const $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE = 60;
    var $5a56ddd74feeb1a3$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
        const units = [
            {
                suffix: 'w',
                seconds: daysPerWeek * hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
            },
            {
                suffix: 'd',
                seconds: hoursPerDay * $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
            },
            {
                suffix: 'h',
                seconds: $5a56ddd74feeb1a3$var$MINUTES_PER_HOUR * $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
            },
            {
                suffix: 'm',
                seconds: $5a56ddd74feeb1a3$var$SECONDS_PER_MINUTE
            }
        ];
        return (seconds)=>{
            const initial = {
                secondsRemaining: seconds,
                timeString: ''
            };
            const result = units.reduce((acc, unit)=>{
                if (unit.seconds <= 0) return acc;
                const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
                const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
                const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
                return {
                    secondsRemaining: updatedSecondsRemaining,
                    timeString: updatedTimeString
                };
            }, initial);
            return result.timeString.trim() || '0m';
        };
    };
});
parcelRegister("51HJa", function(module, exports) {
    $parcel$export(module.exports, "isNumeric", ()=>$04c692f002b6b2cc$export$e90fb89750dba83f);
    const $04c692f002b6b2cc$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));
});
parcelRegister("8KiHO", function(module, exports) {
    $parcel$export(module.exports, "getDefaultTimeTrackingUnit", ()=>$1cda22112bbc1ffb$export$2b38dfc7401492ba);
    const $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
        minute: 'm',
        hour: 'h',
        day: 'd',
        week: 'w'
    };
    const $1cda22112bbc1ffb$export$2b38dfc7401492ba = (serverDefaultUnit)=>$1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $1cda22112bbc1ffb$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;
});
parcelRegister("kdeLq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd2c82d962ad5471$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kOFhM;
    var $f5oqj;
    var $4R6GH;
    var $6a30R;
    const $bd2c82d962ad5471$var$MessageCFBehaviour = (props)=>{
        const { defaultValue: defaultValue } = props;
        if (defaultValue === undefined) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5oqj")).default), {
            document: defaultValue,
            schema: (0, (0, parcelRequire("kOFhM")).defaultSchema),
            disableHeadingIDs: true,
            eventHandlers: {
                smartCard: {
                    onClick: (0, (0, parcelRequire("6a30R")).onLinkClick)
                },
                link: {
                    onClick: (0, (0, parcelRequire("6a30R")).onLinkClick)
                }
            },
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                'renderer-tti-tracking': (0, (0, parcelRequire("4R6GH")).fg)('renderer_tti_tracking_jira')
            },
            smartLinks: (0, (0, parcelRequire("6a30R")).smartLinksDefault)
        });
    };
    const $bd2c82d962ad5471$var$MessageCF = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($bd2c82d962ad5471$var$MessageCFBehaviour, {
            key: "message-custom-field",
            ...props
        });
    var $bd2c82d962ad5471$export$2e2bcd8739ae039 = $bd2c82d962ad5471$var$MessageCF;
});
parcelRegister("5sz86", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0e92fcc13435d46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9EuZf;
    var $5fnvk;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $1IlAr;
    const $b0e92fcc13435d46$var$MultiGroupPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
        const getExtraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                groupPickerStyles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
            return {
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fnvk")).default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            isMulti: true,
            placeholder: " ",
            ...getExtraProps()
        }));
    };
    var $b0e92fcc13435d46$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateGroupPickerField),
        transformDefaultValue: (0, (0, parcelRequire("1IlAr")).transformGroupDefaultValueToUserOption)
    })($b0e92fcc13435d46$var$MultiGroupPickerField);
});
parcelRegister("9EuZf", function(module, exports) {
    $parcel$export(module.exports, "defaultUserPickerStyles", ()=>$378ea0219a6c1ff7$export$ddd4b90ea2d7a329);
    var $gwIPs;
    const $378ea0219a6c1ff7$export$ddd4b90ea2d7a329 = {
        menuPortal: (base)=>({
                ...base,
                zIndex: String((0, (0, parcelRequire("gwIPs")).layers).modal)
            })
    };
});
parcelRegister("5fnvk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81263082e0845513$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $cr0SA;
    var $koVbs;
    var $arYvt;
    var $hSBXu;
    var $lGKF5;
    var $3PgDR;
    const $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
    const $81263082e0845513$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: searchDebounceTimeout = $81263082e0845513$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const previousQuery = (0, $5uXOq.useRef)('');
        const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, (0, parcelRequire("hSBXu")).default)(autoCompleteUrl || '');
        const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(false);
        const getUserPickerControlStyle = (0, $5uXOq.useCallback)((styles)=>{
            if (isInvalid === true) return {
                ...styles,
                ...(0, (0, parcelRequire("3PgDR")).invalidStateStyle)
            };
            return styles;
        }, [
            isInvalid
        ]);
        const handleSearch = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((query)=>{
                setIsDropdownVisible(!!query);
                if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
                previousQuery.current = query || '';
            }, searchDebounceTimeout), [
            fetchGroups,
            previousQuery,
            searchDebounceTimeout
        ]);
        const handleOnFocus = (0, $5uXOq.useCallback)((sessionId)=>{
            setIsDropdownVisible(true);
            onFocus?.(sessionId);
            if (!groups || !groups.length) fetchGroups();
        }, [
            fetchGroups,
            groups,
            onFocus
        ]);
        const handleOnBlur = (0, $5uXOq.useCallback)((sessionId)=>{
            setIsDropdownVisible(false);
            onBlur?.(sessionId);
            previousQuery.current = '';
        }, [
            onBlur,
            previousQuery
        ]);
        const handleOnChange = (updatedValue)=>{
            onChange(updatedValue);
        };
        const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group));
        const onClear = ()=>{
            onChange(null);
        };
        const closeMenuOnScroll = (e)=>{
            if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
        };
        const getIsClearable = ()=>isClearable ? Boolean(value) : false;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cr0SA")).UserPicker), {
            ariaLabelledBy: fieldProps['aria-labelledby'],
            fieldId: fieldId,
            width: width,
            autoFocus: autoFocus,
            isLoading: loading,
            options: getOptions(),
            value: value,
            onFocus: handleOnFocus,
            onClear: onClear,
            isMulti: isMulti,
            isDisabled: isDisabled,
            isClearable: getIsClearable(),
            onBlur: handleOnBlur,
            onInputChange: handleSearch,
            onChange: handleOnChange,
            placeholder: placeholder,
            addMoreMessage: formatMessage((0, (0, parcelRequire("lGKF5")).default).addMoreGroupsPrompt),
            UNSAFE_hasDraggableParentComponent: true,
            closeMenuOnScroll: closeMenuOnScroll,
            open: isDropdownVisible,
            menuPosition: menuPosition,
            styles: {
                control: getUserPickerControlStyle,
                ...groupPickerStyles
            }
        });
    };
    var $81263082e0845513$export$2e2bcd8739ae039 = $81263082e0845513$var$GroupPicker;
});
parcelRegister("arYvt", function(module, exports) {
    $parcel$export(module.exports, "transformGroupToUserOption", ()=>$70d728bf86d0ecee$export$f9f97cb0418e400f);
    $parcel$export(module.exports, "transformUserPickerOptionToGroup", ()=>$70d728bf86d0ecee$export$7727449e04185a4c);
    $parcel$export(module.exports, "transformGroupToName", ()=>$70d728bf86d0ecee$export$c76efe48b8ca8203);
    $parcel$export(module.exports, "transformGroupsToNames", ()=>$70d728bf86d0ecee$export$285022bf9288513e);
    $parcel$export(module.exports, "appendTypePropertyToGroupOptions", ()=>$70d728bf86d0ecee$export$705009f1a414da46);
    const $70d728bf86d0ecee$export$f9f97cb0418e400f = (group)=>({
            id: group.name,
            name: group.name,
            type: 'group'
        });
    const $70d728bf86d0ecee$export$7727449e04185a4c = (userOption)=>({
            groupId: userOption.id,
            name: userOption.name,
            type: 'group'
        });
    const $70d728bf86d0ecee$export$c76efe48b8ca8203 = (group)=>({
            name: group.name
        });
    const $70d728bf86d0ecee$export$285022bf9288513e = (groups)=>groups.map((group)=>$70d728bf86d0ecee$export$c76efe48b8ca8203(group));
    const $70d728bf86d0ecee$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
                ...group,
                type: 'group'
            }));
});
parcelRegister("hSBXu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9613200b5cbe8cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $eusud;
    var $arYvt;
    const $b9613200b5cbe8cb$var$useGroupsQuery = (autoCompleteUrl)=>{
        const [groups, setGroups] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(undefined);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const currentQuery = (0, $5uXOq.useRef)('');
        const fetchGroups = (0, $5uXOq.useCallback)(async (query = '')=>{
            if ([
                '',
                null,
                undefined
            ].includes(autoCompleteUrl)) return Promise.resolve([]);
            const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
            setLoading(true);
            currentQuery.current = query;
            if (error) setError(undefined);
            try {
                const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(groupsFetchUrl);
                let groupsWithType = [];
                if (query === currentQuery.current) {
                    if (response && response.groups) {
                        groupsWithType = (0, (0, parcelRequire("arYvt")).appendTypePropertyToGroupOptions)(response.groups);
                        setGroups(groupsWithType);
                    } else setGroups([]);
                }
                return groupsWithType;
            } catch (err) {
                if (query === currentQuery.current) setError(err);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
                return err;
            } finally{
                setLoading(false);
            }
        }, [
            autoCompleteUrl,
            error
        ]);
        return {
            groups: groups,
            error: error,
            loading: loading,
            fetchGroups: fetchGroups
        };
    };
    var $b9613200b5cbe8cb$export$2e2bcd8739ae039 = $b9613200b5cbe8cb$var$useGroupsQuery;
});
parcelRegister("lGKF5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82d585cea41a3a80$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82d585cea41a3a80$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addMoreGroupsPrompt: {
            "id": "issue-field-group-picker.edit.add-more-groups-prompt",
            "defaultMessage": "add more groups..."
        }
    });
});
parcelRegister("3PgDR", function(module, exports) {
    $parcel$export(module.exports, "invalidStateStyle", ()=>$2e61feb10eb63767$export$f204658c943efb85);
    const $2e61feb10eb63767$export$f204658c943efb85 = {
        borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R400})`
    };
});
parcelRegister("1IlAr", function(module, exports) {
    $parcel$export(module.exports, "transformGroupDefaultValueToUserOption", ()=>$d2f2135dd78f2505$export$d9591be6713fcfc8);
    $parcel$export(module.exports, "mutateMultipleGroupPickerField", ()=>$d2f2135dd78f2505$export$8cb86783be488510);
    var $arYvt;
    const $d2f2135dd78f2505$export$d9591be6713fcfc8 = (group)=>{
        if (!group) return null;
        if (Array.isArray(group)) return group.map((groupItem)=>(0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(groupItem));
        return (0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group);
    };
    const $d2f2135dd78f2505$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
            fieldId: fieldId,
            groups: selectedGroups.map(({ name: name })=>({
                    groupName: name
                })),
            mutationGroup: (0, $795be18a4b521940$export$31fd86f8f183952c)
        });
});
const $795be18a4b521940$export$31fd86f8f183952c = 'multipleGroupPickerFields';
parcelRegister("g2djo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$970d61a7c1588270$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d3RWa;
    const $970d61a7c1588270$var$MultiSelectField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3RWa")).default), {
            ...props,
            isMulti: true
        });
    var $970d61a7c1588270$export$2e2bcd8739ae039 = $970d61a7c1588270$var$MultiSelectField;
});
parcelRegister("d3RWa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da96ee86c52df1e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cOyAh;
    var $5pHXe;
    var $gLdtQ;
    var $jGVMX;
    var $hpV4g;
    var $7C5S0;
    var $90YqS;
    const $da96ee86c52df1e6$var$SelectField = (props)=>{
        const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cOyAh")).default), {
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            options: (0, (0, parcelRequire("5pHXe")).mapDataToSelectOptions)(allowedValues),
            value: value,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            classNamePrefix: `select-${fieldId}`,
            isMulti: isMulti,
            hideSelectedOptions: true,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isClearable: true,
            onFilterOption: (0, (0, parcelRequire("90YqS")).onFilterOption),
            isDisabled: isReadOnly,
            isRequired: isRequired,
            inputId: id
        }));
    };
    var $da96ee86c52df1e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("90YqS")).transformDefaultSelectValues),
        validator: (0, (0, parcelRequire("jGVMX")).validateSelectField)
    })($da96ee86c52df1e6$var$SelectField);
});
parcelRegister("cOyAh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45ff8480905da065$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $lElIo;
    const $45ff8480905da065$var$SelectEdit = (props)=>{
        const { classNamePrefix: classNamePrefix, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            placeholder: placeholder,
            options: options,
            value: value,
            classNamePrefix: classNamePrefix,
            onChange: onChange,
            onBlur: onBlur,
            isMulti: isMulti,
            onFocus: onFocus,
            autoFocus: autoFocus,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            isClearable: isClearable,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            filterOption: onFilterOption,
            inputId: inputId,
            required: isRequired,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $45ff8480905da065$export$2e2bcd8739ae039 = $45ff8480905da065$var$SelectEdit;
});
parcelRegister("5pHXe", function(module, exports) {
    $parcel$export(module.exports, "mapSelectOptionsToData", ()=>$aeaea2f472af8476$export$7cdfccbc726f6f22);
    $parcel$export(module.exports, "mapMultiSelectOptionsToData", ()=>$aeaea2f472af8476$export$b91253d30be01e62);
    $parcel$export(module.exports, "mapDataToSelectOption", ()=>$aeaea2f472af8476$export$8f475f1fdc96a964);
    $parcel$export(module.exports, "mapDataToSelectOptions", ()=>$aeaea2f472af8476$export$dc22cde66e28d4af);
    const $aeaea2f472af8476$export$7cdfccbc726f6f22 = (option)=>({
            id: option.value,
            value: option.label
        });
    const $aeaea2f472af8476$export$b91253d30be01e62 = (options)=>options.map((option)=>({
                id: option.value,
                value: option.label
            }));
    const $aeaea2f472af8476$export$8f475f1fdc96a964 = (optionExternal)=>({
            label: optionExternal.value,
            value: optionExternal.id
        });
    const $aeaea2f472af8476$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$aeaea2f472af8476$export$8f475f1fdc96a964(optionExternal));
});
parcelRegister("90YqS", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultSelectValues", ()=>$3a49366a4ffd7ccc$export$cfb7677fb5241257);
    $parcel$export(module.exports, "onFilterOption", ()=>$3a49366a4ffd7ccc$export$5fde4483c43b93b);
    var $5pHXe;
    const $3a49366a4ffd7ccc$export$cfb7677fb5241257 = (defaultValue)=>{
        if (Array.isArray(defaultValue)) return (0, (0, parcelRequire("5pHXe")).mapDataToSelectOptions)(defaultValue);
        return (0, (0, parcelRequire("5pHXe")).mapDataToSelectOption)(defaultValue);
    };
    const $3a49366a4ffd7ccc$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());
});
parcelRegister("eX2Td", function(module, exports) {
    $parcel$export(module.exports, "mutateMultiSelectField", ()=>$12a9564789baecf3$export$3313ce8403b211b4);
    $parcel$export(module.exports, "mapMultiSelectOptionsToConnectData", ()=>$12a9564789baecf3$export$a7431ac3899bcd4d);
    const $12a9564789baecf3$export$3313ce8403b211b4 = (selectedValues, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $c31595b6f75564de$export$31fd86f8f183952c),
            options: selectedValues.map(({ value: value })=>({
                    optionId: value
                }))
        });
    const $12a9564789baecf3$export$a7431ac3899bcd4d = (options)=>options.map((option)=>option.value);
});
const $c31595b6f75564de$export$31fd86f8f183952c = 'multipleSelectFields';
parcelRegister("gARR3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06543e5a7cef326e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzCWA;
    const $06543e5a7cef326e$var$MultiUserPickerField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzCWA")).default), {
            ...props,
            isMulti: true,
            context: "CustomMultiUserField"
        });
    var $06543e5a7cef326e$export$2e2bcd8739ae039 = $06543e5a7cef326e$var$MultiUserPickerField;
});
parcelRegister("lzCWA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a02b9e46792852c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dQLtU;
    var $gLdtQ;
    var $jGVMX;
    var $hpV4g;
    var $7C5S0;
    var $5kDIl;
    const $a02b9e46792852c4$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
            context: context,
            ...projectKey && {
                project: projectKey
            },
            ...fieldId && {
                fieldId: fieldId
            },
            query: ''
        })}`;
    const $a02b9e46792852c4$var$UserPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dQLtU")).default), {
            autoCompleteUrl: $a02b9e46792852c4$var$getAutoCompleteUrl(context, fieldId, selectedProject?.projectKey),
            placeholder: placeholder,
            isDisabled: isReadOnly || isDisabled,
            onChange: onChange,
            value: value,
            appearance: "normal",
            isMulti: isMulti,
            autoFocus: autoFocus,
            fieldId: fieldId,
            fetchSuggestions: onFetchSuggestions,
            isClearable: true,
            width: width,
            inputId: id,
            onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
        }));
    };
    var $a02b9e46792852c4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateUserPickerField),
        transformDefaultValue: (0, (0, parcelRequire("5kDIl")).transformDefaultUserValues)
    })($a02b9e46792852c4$var$UserPickerField);
});
parcelRegister("dQLtU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4d56a824ba419e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jOrdN;
    var $9EuZf;
    const $e4d56a824ba419e6$var$UserPickerEdit = (props)=>{
        const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
        const extraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                styles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: onCloseMenuOnScroll
            };
            return {
                onCloseMenuOnScroll: onCloseMenuOnScroll
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jOrdN")).default), {
            ...fieldProps,
            fieldId: fieldId,
            inputId: inputId,
            appearance: appearance,
            width: width,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            placeholder: placeholder,
            isDisabled: isDisabled,
            isMulti: isMulti,
            autoCompleteUrl: autoCompleteUrl,
            fetchSuggestions: fetchSuggestions,
            emptyOption: emptyOption,
            onSelection: onSelection,
            onDataLoaded: onDataLoaded,
            onDataRequest: onDataRequest,
            onCancel: onCancel,
            isDropdownVisibleByDefault: isDropdownVisibleByDefault,
            isClearable: isClearable,
            isBulkEdit: isBulkEdit,
            ...extraProps()
        });
    };
    var $e4d56a824ba419e6$export$2e2bcd8739ae039 = $e4d56a824ba419e6$var$UserPickerEdit;
});
parcelRegister("jOrdN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f3563054ff092b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cr0SA;
    var $eusud;
    var $koVbs;
    var $duvPR;
    var $khYiH;
    const $9f3563054ff092b8$var$stringContains = (str, substr)=>{
        if (str == null) return false;
        if (substr == null || substr === '') return true;
        return str.toLowerCase().includes(substr.toLowerCase());
    };
    const $9f3563054ff092b8$export$251bdbdbce9550ea = 400;
    const $9f3563054ff092b8$var$UserPickerWrapper = (props)=>{
        const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, ($parcel$interopDefault($8Rkzz))), onSelection: onSelection = (0, ($parcel$interopDefault($8Rkzz))), onDataRequest: onDataRequest = (0, ($parcel$interopDefault($8Rkzz))), onDataLoaded: onDataLoaded = (0, ($parcel$interopDefault($8Rkzz))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, menuMinWidth: menuMinWidth, fetchSuggestions: fetchSuggestionsProps, ...fieldProps } = props;
        const [isDropdownVisible, setIsDropdownVisible] = (0, $5uXOq.useState)(Boolean(isDropdownVisibleByDefault));
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [query, setQueryString] = (0, $5uXOq.useState)(null);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [wasFocused, setWasFocused] = (0, $5uXOq.useState)(false);
        const [wasCleared, setWasCleared] = (0, $5uXOq.useState)(false);
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)([]);
        const [sessionId, setSessionId] = (0, $5uXOq.useState)('');
        const getEmptyValue = ()=>emptyOption ? {
                ...emptyOption,
                id: (0, $768a4f0fe483a263$export$61a0b64dfe00294c)
            } : null;
        const debounceTime = withoutDebounce ? 0 : $9f3563054ff092b8$export$251bdbdbce9550ea;
        const requestSuggestionsDebounced = (0, $5uXOq.useMemo)(()=>{
            const isCurrentValue = (userOptionValue)=>{
                if (!userOptionValue) return value === null;
                if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
                return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $768a4f0fe483a263$export$61a0b64dfe00294c);
            };
            const fetchSuggestions = async ()=>{
                let users = [];
                if (autoCompleteUrl !== undefined) {
                    const autoCompleteResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                    users = (0, (0, parcelRequire("khYiH")).mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
                }
                return users.map((userData)=>(0, (0, parcelRequire("khYiH")).mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
            };
            const handleSuggestions = (newSuggestions)=>{
                if (!isDropdownVisible || !newSuggestions) return;
                const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
                setIsLoading(false);
                setSuggestions(filteredSuggestions);
                onDataLoaded(!query, filteredSuggestions.length);
            };
            const handleError = ()=>{
                setIsLoading(false);
                setSuggestions([]);
            };
            const requestSuggestions = ()=>{
                onDataRequest(!query);
                if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                    handleSuggestions(results);
                }).catch(handleError);
                return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
            };
            return (0, ($parcel$interopDefault($lFKmC)))(()=>{
                requestSuggestions();
            }, debounceTime);
        }, [
            debounceTime,
            value,
            autoCompleteUrl,
            query,
            isBulkEdit,
            shouldShowEmailInOptions,
            isDropdownVisible,
            wasFocused,
            onDataLoaded,
            onDataRequest,
            fetchSuggestionsProps,
            sessionId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (query === null || !isDropdownVisible) return;
            requestSuggestionsDebounced();
            return ()=>{
                requestSuggestionsDebounced.cancel();
            };
        }, [
            requestSuggestionsDebounced,
            query,
            isDropdownVisible
        ]);
        const onSelectedValueChangeMulti = (userOptionValue)=>{
            if (userOptionValue && userOptionValue.length === 0) onChange(null);
            else onChange(userOptionValue);
        };
        const onSelectedValueChangeSingle = (userOptionValue)=>{
            const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
            if (valueId === (0, $768a4f0fe483a263$export$61a0b64dfe00294c)) onChange(null);
            else onChange(userOptionValue);
        };
        const onSuggestionSelect = (userOptionValue, sId)=>{
            setSessionId(sId || '');
            setWasFocused(false);
            setWasCleared(false);
            setIsLoading(false);
            setSuggestions([]);
            onSelection(sessionId);
            if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
            else onSelectedValueChangeSingle(userOptionValue);
        };
        const onBlur = ()=>{
            setIsDropdownVisible(false);
            setIsLoading(false);
            setWasFocused(false);
            setSuggestions([]);
            if (wasCleared) {
                onSuggestionSelect(getEmptyValue());
                return;
            }
            onCancel();
        };
        const onDropdownOpen = (sId)=>{
            setSessionId(sId || '');
            setQueryString('');
            setIsDropdownVisible(true);
            setIsLoading(true);
            setWasFocused(true);
            setWasCleared(false);
        };
        const onQueryChange = (queryStr, sId)=>{
            setSessionId(sId || '');
            setQueryString(queryStr || '');
            setIsLoading(!!queryStr);
            setWasFocused(false);
            setIsDropdownVisible(!!queryStr);
        };
        const onClear = ()=>{
            setWasCleared(true);
            onSuggestionSelect(null);
        };
        const closeMenuOnScroll = (e)=>{
            if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
        };
        const isMatchingQuery = (suggestion)=>{
            const { displayName: displayName, name: name } = suggestion;
            return !isLoading || $9f3563054ff092b8$var$stringContains(displayName, query) || $9f3563054ff092b8$var$stringContains(name, query);
        };
        const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
        const filteredSuggestions = getSuggestions();
        const pickerValue = value || getEmptyValue();
        const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, (0, parcelRequire("duvPR")).default).emptyQueryMessage) : undefined;
        const controlProps = openMenuOnClick ? {
            openMenuOnClick: openMenuOnClick,
            onOpen: onDropdownOpen
        } : {
            open: isDropdownVisible,
            onFocus: onDropdownOpen
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cr0SA")).UserPicker), {
            value: pickerValue,
            options: filteredSuggestions,
            isMulti: isMulti,
            fieldId: fieldId,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: portalElement,
            width: width,
            appearance: appearance,
            isClearable: isClearable,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            placeholder: placeholder,
            onBlur: onBlur,
            isLoading: isLoading && isDropdownVisible,
            onClear: onClear,
            onInputChange: onQueryChange,
            onChange: onSuggestionSelect,
            noBorder: noBorder,
            styles: styles,
            noOptionsMessage: getNoOptionsMessage,
            allowEmail: allowEmail,
            inputId: inputId,
            required: isRequired,
            ariaLabel: fieldProps['aria-label'],
            ariaLabelledBy: fieldProps['aria-labelledby'],
            closeMenuOnScroll: closeMenuOnScroll,
            menuPosition: menuPosition,
            ...controlProps
        });
    };
    var $9f3563054ff092b8$export$2e2bcd8739ae039 = $9f3563054ff092b8$var$UserPickerWrapper;
});
const $768a4f0fe483a263$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';
parcelRegister("duvPR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7ea6ee4d1ce51e6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e7ea6ee4d1ce51e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyQueryMessage: {
            "id": "base-user-picker.empty-query-message",
            "defaultMessage": "Start typing to get a list of possible matches."
        }
    });
});
parcelRegister("khYiH", function(module, exports) {
    $parcel$export(module.exports, "mapUserObjectToUserOption", ()=>$5eec43efc9e4eafe$export$e11fc32dba4fe919);
    $parcel$export(module.exports, "mapAutoCompleteResponseToUsers", ()=>$5eec43efc9e4eafe$export$ec325826d2bf6655);
    var $jcw0u;
    const $5eec43efc9e4eafe$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
        let userOption = {
            id: userData.accountId || '',
            name: userData.displayName || '',
            avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
        };
        if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) userOption = {
            ...userOption,
            byline: userData.emailAddress
        };
        return userOption;
    };
    const $5eec43efc9e4eafe$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
        try {
            if (isBulkEdit) {
                if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) return autoCompleteResponse.users;
            } else if (Array.isArray(autoCompleteResponse)) return autoCompleteResponse;
            throw Error('autoCompleteResponse is either null or not expected value');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'mapAutoCompleteResponse',
                    packageName: 'jiraBaseUserPicker',
                    teamName: 'gryffindor'
                },
                error: error
            });
        }
        return [];
    };
});
parcelRegister("k5vQX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$76983af27be6a3ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $hTBEr;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $cBHNh;
    var $34EcD;
    const $76983af27be6a3ff$var$MultiVersionsField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const options = (0, (0, parcelRequire("34EcD")).transformVersionExternalOptionstoVersionOptions)(allowedValues);
        const isDisabled = allowedValues.length === 0;
        const onChangeVersionsEdit = (versionEditValue)=>{
            if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
        };
        const getVersionsEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTBEr")).default), {
                options: options,
                value: value,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isMulti: true,
                onChange: onChangeVersionsEdit,
                isInvalid: Boolean(error),
                fieldId: fieldId,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isReadOnly || isDisabled,
                autoFocus: autoFocus,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("cBHNh")).default).none) : '',
                inputId: id,
                isRequired: isRequired
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("cBHNh")).default).tooltip)
        }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $76983af27be6a3ff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateMultiVersionsField),
        transformDefaultValue: (0, (0, parcelRequire("34EcD")).transformVersionExternalOptionstoVersionOptions),
        shouldRenderFieldMessage: false
    })($76983af27be6a3ff$var$MultiVersionsField);
});
parcelRegister("hTBEr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87c89427d751fd8d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $koVbs;
    var $lElIo;
    var $dTQPF;
    const $87c89427d751fd8d$var$Versions = (props)=>{
        const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, openMenuOnFocus: openMenuOnFocus = false } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getIsClearable = ()=>{
            if (!isClearable) return false;
            return Array.isArray(value) ? value.length > 0 : Boolean(value);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            placeholder: placeholder,
            options: (0, (0, parcelRequire("dTQPF")).getGroupedOptions)((0, (0, parcelRequire("dTQPF")).removeArchivedOptions)(options), formatMessage),
            validationState: isInvalid === true ? 'error' : null,
            value: value,
            fieldId: fieldId,
            isMulti: isMulti,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onChange: onChange,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isClearable: getIsClearable(),
            inputId: inputId,
            required: isRequired,
            classNamePrefix: classNamePrefix,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            openMenuOnFocus: openMenuOnFocus
        });
    };
    var $87c89427d751fd8d$export$2e2bcd8739ae039 = $87c89427d751fd8d$var$Versions;
});
parcelRegister("dTQPF", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalToVersion", ()=>$418fd006fc4a31c5$export$c1c38f7974aa8bed);
    $parcel$export(module.exports, "removeArchivedOptions", ()=>$418fd006fc4a31c5$export$6f0b68b6e372a0e6);
    $parcel$export(module.exports, "getGroupedOptions", ()=>$418fd006fc4a31c5$export$721c3d9226425f9c);
    $parcel$export(module.exports, "getVersionsIds", ()=>$418fd006fc4a31c5$export$c96a1607e976ccc6);
    $parcel$export(module.exports, "getVersionId", ()=>$418fd006fc4a31c5$export$d0a84488c5034e2b);
    var $lCBBY;
    const $418fd006fc4a31c5$var$getStatusFromRestOption = (option)=>{
        if (option.released) return 'RELEASED';
        if (option.archived) return 'ARCHIVED';
        return 'UNRELEASED';
    };
    const $418fd006fc4a31c5$export$eb178ff2323a1ab3 = (option)=>({
            label: option.name,
            value: option.id,
            status: $418fd006fc4a31c5$var$getStatusFromRestOption(option)
        });
    const $418fd006fc4a31c5$export$c1c38f7974aa8bed = (option)=>({
            label: option.name,
            value: option.id,
            status: option.status
        });
    const $418fd006fc4a31c5$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
    const $418fd006fc4a31c5$export$721c3d9226425f9c = (options, formatMessage)=>{
        const groupedOptions = [];
        if (options.length) {
            const versionOrder = options.length && options[0].status === 'RELEASED' ? [
                'RELEASED',
                'UNRELEASED'
            ] : [
                'UNRELEASED',
                'RELEASED'
            ];
            versionOrder.forEach((status)=>{
                const statusOptions = options.filter((option)=>option.status === status);
                if (statusOptions.length) groupedOptions.push({
                    options: statusOptions,
                    label: status === 'RELEASED' ? formatMessage((0, (0, parcelRequire("lCBBY")).default).released) : formatMessage((0, (0, parcelRequire("lCBBY")).default).unreleased)
                });
            });
        }
        return groupedOptions;
    };
    const $418fd006fc4a31c5$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
                id: v.value
            }));
    const $418fd006fc4a31c5$export$d0a84488c5034e2b = (selectedVersion)=>({
            id: selectedVersion.value
        });
});
parcelRegister("lCBBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a958e5bb1549bd80$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a958e5bb1549bd80$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        released: {
            "id": "issue-field-versions.released",
            "defaultMessage": "Released"
        },
        unreleased: {
            "id": "issue-field-versions.unreleased",
            "defaultMessage": "Unreleased"
        }
    });
    var $a958e5bb1549bd80$export$2e2bcd8739ae039 = $a958e5bb1549bd80$var$messages;
});
parcelRegister("cBHNh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b40c0e93e07915fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b40c0e93e07915fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.multi-versions-field.none",
            "defaultMessage": "None"
        },
        tooltip: {
            "id": "issue-create-commons.multi-versions-field.tooltip",
            "defaultMessage": "We couldn't find any versions for this project"
        }
    });
});
parcelRegister("34EcD", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", ()=>$f99feaf445ed0ec0$export$11cad9e2f2e9ae55);
    $parcel$export(module.exports, "mutateMultiVersionsField", ()=>$f99feaf445ed0ec0$export$6999207a9642bd09);
    var $dTQPF;
    const $f99feaf445ed0ec0$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion)(option));
    const $f99feaf445ed0ec0$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $a7d2b97eb2e0b950$export$31fd86f8f183952c),
            versions: selectedVersions.map(({ value: value })=>({
                    versionId: value
                }))
        });
});
const $a7d2b97eb2e0b950$export$31fd86f8f183952c = 'multipleVersionPickerFields';
parcelRegister("bo14T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dfdc9c56d4f0e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    var $hpV4g;
    var $jGVMX;
    var $kU4qk;
    const $69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e = (props)=>{
        const { width: width = 350, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).InputField), {
            type: "number",
            width: width,
            ...rest
        });
    };
    var $69dfdc9c56d4f0e9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString),
        transformDefaultValue: (0, (0, parcelRequire("kU4qk")).transformAsString)
    })($69dfdc9c56d4f0e9$export$63c5fa0b2fdccd2e);
});
parcelRegister("hMKLn", function(module, exports) {
    $parcel$export(module.exports, "InputField", ()=>$c59ad84f24b74144$export$dd2171e2b7d3bc5b);
    $parcel$export(module.exports, "default", ()=>$c59ad84f24b74144$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kY99m;
    var $jGVMX;
    var $hpV4g;
    var $lrbT7;
    const $c59ad84f24b74144$export$dd2171e2b7d3bc5b = (props)=>{
        const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...rest,
            onChange: onChange,
            value: value,
            type: type,
            width: width,
            step: "any",
            testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            onWheel: (0, (0, parcelRequire("lrbT7")).preventMouseScrollForNumericFieldHandler),
            isDisabled: isReadOnly || rest.isDisabled
        });
    };
    var $c59ad84f24b74144$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($c59ad84f24b74144$export$dd2171e2b7d3bc5b);
});
parcelRegister("kY99m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$509076ff0c6afa78$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $hbrbl;
    const $509076ff0c6afa78$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $509076ff0c6afa78$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$509076ff0c6afa78$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("hbrbl")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("hbrbl")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $509076ff0c6afa78$export$2e2bcd8739ae039 = $509076ff0c6afa78$var$Textfield;
});
parcelRegister("hbrbl", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$9b106cc21ace4b3b$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$9b106cc21ace4b3b$export$3eeb47dc8e6249d9);
    var $VSDnB;
    var $h9kUS;
    const $9b106cc21ace4b3b$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $9b106cc21ace4b3b$var$backgroundColor[appearance],
            borderColor: $9b106cc21ace4b3b$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $829f609a65d26a98$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorHover[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $9b106cc21ace4b3b$var$backgroundColorFocus[appearance],
                borderColor: $9b106cc21ace4b3b$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$9b106cc21ace4b3b$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $829f609a65d26a98$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $829f609a65d26a98$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $9b106cc21ace4b3b$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $9b106cc21ace4b3b$var$getMaxWidth = (width)=>!width ? `100%` : width in $9b106cc21ace4b3b$var$widthMap ? $9b106cc21ace4b3b$var$widthMap[width] : +width;
    const $9b106cc21ace4b3b$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$9b106cc21ace4b3b$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $9b106cc21ace4b3b$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $9b106cc21ace4b3b$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}` : `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"}` : `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $829f609a65d26a98$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $829f609a65d26a98$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            },
            [`${(0, (0, parcelRequire("h9kUS")).media).above.xs}`]: {
                font: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)" : undefined,
                '&[data-compact]': {
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : undefined
                },
                '&:not([data-compact])': {
                    padding: (0, (0, parcelRequire("VSDnB")).fg)('platform_design_system_team_safari_input_fix') ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : undefined
                }
            }
        });
});
parcelRegister("lrbT7", function(module, exports) {
    $parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", ()=>$0fe71c1efa633a57$export$3fedcbfe1c53d8f);
    const $0fe71c1efa633a57$export$3fedcbfe1c53d8f = (event)=>{
        if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
    };
});
parcelRegister("kU4qk", function(module, exports) {
    $parcel$export(module.exports, "transformAsNumber", ()=>$2648f8f88d1e9261$export$52c4e7404b9db862);
    $parcel$export(module.exports, "mutateNumberField", ()=>$2648f8f88d1e9261$export$6701d4d68ea6db95);
    $parcel$export(module.exports, "transformAsString", ()=>$2648f8f88d1e9261$export$afe59f8094df7220);
    const $2648f8f88d1e9261$export$52c4e7404b9db862 = (value)=>{
        if (value) return Number(value);
        return undefined;
    };
    const $2648f8f88d1e9261$export$6701d4d68ea6db95 = (value, fieldId)=>({
            fieldId: fieldId,
            value: Number(value),
            mutationGroup: (0, $358fca2fc5354374$export$31fd86f8f183952c)
        });
    const $2648f8f88d1e9261$export$afe59f8094df7220 = (value)=>{
        if (value !== undefined) return String(value);
        return undefined;
    };
});
const $358fca2fc5354374$export$31fd86f8f183952c = 'numberFields';
parcelRegister("4oT51", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$035663441f65b8aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $y9sir;
    var $lfTZh;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $jI6Lk;
    const $035663441f65b8aa$var$OrganizationsField = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "organizations-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("y9sir")).LazyOrganizationsEdit), {
            ...fieldProps,
            isInvalid: Boolean(error),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        })));
    };
    var $035663441f65b8aa$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateOrganizationsField),
        transformDefaultValue: (0, (0, parcelRequire("jI6Lk")).mapDataToOrganizationOptions)
    })($035663441f65b8aa$var$OrganizationsField);
});
parcelRegister("y9sir", function(module, exports) {
    $parcel$export(module.exports, "LazyOrganizationsEdit", ()=>$731c6e3fc7a471d9$export$f11d485f96c53cba);
    var $kxZPA;
    const $731c6e3fc7a471d9$export$f11d485f96c53cba = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("kPrnd")).then((module)=>module.OrganizationsEdit), {
        moduleId: "./src/packages/issue/fields/organizations/src/index.tsx"
    });
});
parcelRegister("kPrnd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9VJux")
    ]).then(()=>parcelRequire('brAq4'));
});
parcelRegister("jI6Lk", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOrganizationOptions", ()=>$69c9df32c454e79e$export$bb720a783a78b0f4);
    $parcel$export(module.exports, "mutateOrganizationsField", ()=>$69c9df32c454e79e$export$51fa85dc3b5fc461);
    const $69c9df32c454e79e$export$bb720a783a78b0f4 = (data)=>data.map(({ organizationName: organizationName, organizationId: organizationId })=>({
                value: organizationId,
                label: organizationName
            }));
    const $69c9df32c454e79e$export$51fa85dc3b5fc461 = (selectedOrganizations, fieldId)=>({
            organizationField: {
                fieldId: fieldId,
                organizations: selectedOrganizations.map(({ value: value })=>({
                        organizationId: value
                    }))
            }
        });
});
parcelRegister("8mBES", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28698af5fbb25d8a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $dC5iT;
    var $8CUq3;
    var $aIZdc;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $1iKBB;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $bA6nL;
    var $eulr6;
    const $28698af5fbb25d8a$export$96c87c0afbe06b37 = (props)=>{
        const { fieldId: fieldId, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let issueTypeId;
        if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1iKBB")).ParentFieldEdit), {
            fieldId: fieldId,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isExistingIssue: isExistingIssue,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            selectedProjectId: selectedProject ? selectedProject.value : undefined,
            selectedIssueTypeId: issueTypeId,
            fetchSuggestionsOnFocus: true,
            passedInIssueKey: (0, (0, parcelRequire("4R6GH")).fg)('render-modern-issue-transition') || (0, (0, parcelRequire("aIZdc")).isFedRamp)() ? issueKey : undefined,
            spacing: "default"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $28698af5fbb25d8a$var$fieldDescriptionStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("bA6nL")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("bA6nL")).default).description))));
    };
    const $28698af5fbb25d8a$var$fieldDescriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.100'
    });
    var $28698af5fbb25d8a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("eulr6")).transformDefaultParentValue),
        validator: (0, (0, parcelRequire("eulr6")).validateParentField)
    })($28698af5fbb25d8a$export$96c87c0afbe06b37);
});
parcelRegister("1iKBB", function(module, exports) {
    $parcel$export(module.exports, "ParentFieldEdit", ()=>$b89ca9fa2a80ab1b$export$55c2cccecfd24751);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $7K5PP;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $2gCtH;
    var $3BhEA;
    var $lElIo;
    var $koeKL;
    var $iVcsU;
    var $inRSh;
    var $3orGF;
    var $1sPJ0;
    var $6v0ju;
    const $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $b89ca9fa2a80ab1b$export$55c2cccecfd24751 = (props)=>{
        const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: fieldId, spacing: spacingProps = 'compact', 'aria-labelledby': ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [noOptionsMessage, setNoOptionsMessage] = (0, $5uXOq.useState)('');
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [excludeDone, setExcludeDone] = (0, $5uXOq.useState)(true);
        const isInitialMount = (0, $5uXOq.useRef)(true);
        const lastQuery = (0, $5uXOq.useRef)('');
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const onCheckboxClickOld = (0, $5uXOq.useCallback)(()=>{
            setExcludeDone(!excludeDone);
        }, [
            excludeDone
        ]);
        const componentPropsOld = (0, $5uXOq.useMemo)(()=>({
                isChecked: !excludeDone,
                onChange: onCheckboxClickOld
            }), [
            excludeDone,
            onCheckboxClickOld
        ]);
        const componentProps = (0, $5uXOq.useMemo)(()=>({
                onChange: (event)=>{
                    setExcludeDone(!event.target.checked);
                }
            }), []);
        const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
            if (context === 'menu') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: option.label
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1sPJ0")).default), {
                option: option
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, option.label || `${option.key} ${option.fields.summary}`);
        }, []);
        const searchParents = (0, $5uXOq.useCallback)(async (query = '')=>{
            setHasLastFetchFailed(false);
            try {
                lastQuery.current = query;
                if (isExistingIssue) {
                    const fetchedOptions = await (0, (0, parcelRequire("6v0ju")).fetchParentsForExisting)({
                        searchTerm: query,
                        issueKey: passedInIssueKey || issueKey,
                        cloudId: cloudId,
                        excludeDone: excludeDone
                    });
                    return fetchedOptions;
                }
                if (selectedProjectId && selectedIssueTypeId) {
                    const fetchedOptions = await (0, (0, parcelRequire("6v0ju")).fetchParentsForNew)({
                        searchTerm: query,
                        selectedProjectId: selectedProjectId,
                        selectedIssueTypeId: selectedIssueTypeId,
                        cloudId: cloudId,
                        excludeDone: excludeDone
                    });
                    return fetchedOptions;
                }
                setHasLastFetchFailed(true);
                return {
                    options: []
                };
            } catch  {
                setHasLastFetchFailed(true);
                return {
                    options: []
                };
            }
        }, [
            isExistingIssue,
            issueKey,
            cloudId,
            excludeDone,
            selectedProjectId,
            selectedIssueTypeId,
            passedInIssueKey
        ]);
        const requestSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            const response = await searchParents(query);
            if (lastQuery.current === query) {
                if (response.options !== undefined) {
                    setSuggestions(response.options);
                    if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                    if (query === '') setDefaultSuggestions(response.options);
                } else {
                    setSuggestions([]);
                    if (query === '') setDefaultSuggestions([]);
                }
                setIsLoading(false);
            }
        }, [
            searchParents
        ]);
        const debouncedRequestSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(requestSuggestions, $b89ca9fa2a80ab1b$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
            excludeDone
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedRequestSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoading(true);
                debouncedRequestSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoading(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedRequestSuggestions,
            defaultSuggestions
        ]);
        const handleFocus = (0, $5uXOq.useCallback)((e)=>{
            if (lastQuery.current === '' && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            }
            onFocus && onFocus(e);
        }, [
            defaultSuggestions,
            onFocus,
            requestSuggestions
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
        }, [
            hasLastFetchFailed
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>{
            const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, (0, parcelRequire("3orGF")).default).noMatches);
            return hasLastFetchFailed ? formatMessage((0, (0, parcelRequire("3orGF")).default).failedFetch) : noOptions;
        }, [
            formatMessage,
            hasLastFetchFailed,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>formatMessage((0, (0, parcelRequire("3orGF")).default).loading), [
            formatMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialMount.current) {
                setIsLoading(true);
                requestSuggestions(lastQuery.current);
            }
            isInitialMount.current = false;
        }, [
            excludeDone,
            requestSuggestions
        ]);
        const spacing = (0, $5uXOq.useMemo)(()=>spacingProps, [
            spacingProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            onKeyDown: (0, (0, parcelRequire("iVcsU")).preventEscKeyPropagationKeyPressHandler),
            inputId: `${fieldId}-field`,
            options: suggestions,
            value: value,
            formatOptionLabel: formatOptionLabel,
            onBlur: onBlur,
            onFocus: handleFocus,
            onChange: onChange,
            menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            closeMenuOnScroll: onCloseMenuOnScroll,
            isMulti: false,
            isLoading: isLoading,
            onInputChange: onQueryChange,
            loadingMessage: getLoadingMessage,
            noOptionsMessage: getNoOptionsMessage,
            placeholder: formatMessage((0, (0, parcelRequire("3orGF")).default).placeholder),
            components: {
                Menu: (0, parcelRequire("inRSh")).default
            },
            componentsProps: (0, (0, parcelRequire("4R6GH")).fg)('fix_show_done_issues_checkbox_in_parent_field') ? componentProps : componentPropsOld,
            autoFocus: autoFocus,
            filterOption: filterOption,
            validationState: isInvalid === true ? 'error' : undefined,
            hideSelectedOptions: true,
            isClearable: isClearable,
            ...isEditing !== undefined && {
                menuIsOpen: isEditing
            },
            isDisabled: isDisabled,
            defaultMenuIsOpen: defaultMenuIsOpen,
            classNamePrefix: classNamePrefix,
            spacing: spacing,
            "aria-label": formatMessage((0, (0, parcelRequire("3orGF")).default).placeholder),
            "aria-labelledby": ariaLabelledBy
        });
    };
});
parcelRegister("iVcsU", function(module, exports) {
    $parcel$export(module.exports, "getOptionColorElem", ()=>$608100d8bb869e55$export$b00899e73680c477);
    $parcel$export(module.exports, "mapDataToOptions", ()=>$608100d8bb869e55$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$608100d8bb869e55$export$fc800909123977f3);
    $parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", ()=>$608100d8bb869e55$export$feb08457bf70a411);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$608100d8bb869e55$export$949dc67535a8ff2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $heWHN;
    var $iHPnC;
    const $608100d8bb869e55$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color];
    const $608100d8bb869e55$export$b00899e73680c477 = (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement($608100d8bb869e55$var$ColorPatch, {
            color: color,
            "data-testid": `issue-field-parent.common.color-patch-${color}`
        });
    const $608100d8bb869e55$export$99a866ffa3af7d8b = (issueParents)=>{
        return issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
                id: id,
                key: key,
                fields: {
                    issuetype: issueType,
                    summary: summary
                },
                color: color,
                value: id,
                label: `${key} ${summary}`,
                isDone: isDone
            }));
    };
    const $608100d8bb869e55$export$fc800909123977f3 = (option)=>({
            id: option.value
        });
    const $608100d8bb869e55$export$9b822862d986dfdf = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $608100d8bb869e55$export$feb08457bf70a411 = (event)=>{
        if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
    };
    const $608100d8bb869e55$export$949dc67535a8ff2 = (color)=>$608100d8bb869e55$export$9b822862d986dfdf[color];
    const $608100d8bb869e55$var$ColorPatch = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1nzbko4": (0, (0, parcelRequire("lD23V")).default)($608100d8bb869e55$export$bc913b9c9057634d(__cmplp.color))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("inRSh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8f1b6faa7238bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kkJfY;
    var $bChGW;
    var $4R6GH;
    var $koVbs;
    var $drCen;
    const $bc8f1b6faa7238bb$var$Menu = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, ...restProps } = props;
        const isChecked = props.selectProps?.componentsProps?.isChecked || false;
        const isDefaultChecked = props.selectProps?.componentsProps?.isDefaultChecked || false;
        const label = formatMessage((0, (0, parcelRequire("drCen")).default).checkboxLabel);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === ' ') event.stopPropagation();
        }, []);
        const onChange = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            event.preventDefault();
            props.selectProps?.componentsProps?.onChange?.(event);
        }, [
            props.selectProps?.componentsProps
        ]);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('fix_show_done_issues_checkbox_in_parent_field')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            onKeyDown: onKeyDown,
            onClick: onChange,
            onChange: (0, ($parcel$interopDefault($8Rkzz))),
            isChecked: isChecked,
            id: "issue-field-parent.ui.edit.menu.checkbox"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxLabel, {
            onClick: onChange,
            htmlFor: "issue-field-parent.ui.edit.menu.checkbox",
            "data-testid": "issue-field-parent.ui.edit.menu.checkbox-label"
        }, label)), children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement($bc8f1b6faa7238bb$var$CheckboxWrapper, {
            onClick: props.selectProps?.componentsProps?.onChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            defaultChecked: isDefaultChecked,
            onKeyDown: onKeyDown,
            label: label
        })), children);
    };
    var $bc8f1b6faa7238bb$export$2e2bcd8739ae039 = $bc8f1b6faa7238bb$var$Menu;
    const $bc8f1b6faa7238bb$var$CheckboxWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt4lce4 _n7zlpe8f _4cvr1h6o _zulp1b66",
                __cmplp.className
            ])
        });
    });
    const $bc8f1b6faa7238bb$var$CheckboxLabel = (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("drCen", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90c6a6ed4bb83a84$export$2e2bcd8739ae039);
    var $7VHMR;
    var $90c6a6ed4bb83a84$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        checkboxLabel: {
            "id": "issue-field-parent.edit.menu.checkbox-label",
            "defaultMessage": "Show done issues"
        }
    });
});
parcelRegister("3orGF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f57b6631f3fbd470$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f57b6631f3fbd470$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-parent.edit.no-matches",
            "defaultMessage": "No matches"
        },
        failedFetch: {
            "id": "issue-field-parent.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "issue-field-parent.edit.placeholder",
            "defaultMessage": "Select parent"
        },
        loading: {
            "id": "issue-field-parent.edit.loading",
            "defaultMessage": "Searching..."
        }
    });
});
parcelRegister("1sPJ0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3aae186893156b3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4DXCl;
    var $koVbs;
    var $iVcsU;
    var $hVITp;
    const $3aae186893156b3c$var$renderOptionDescription = (option)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionDescriptionWrapper, null, option.description != null ? (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Description, null, option.description) : null);
    const $3aae186893156b3c$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionColorTypeKeyWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconColorKeyWrapper, null, option?.color ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("iVcsU")).getOptionColorElem)(option?.color), (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IconWithColor, {
            src: option.fields?.issuetype.iconUrl,
            alt: iconAltMessage
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$Icon, {
            src: option.fields?.issuetype.iconUrl,
            alt: iconAltMessage
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$IssueKey, null, option.key)), option.isDone ? (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$DoneWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4DXCl"))))), {
            primaryColor: `var(--ds-text-success, ${(0, $829f609a65d26a98$exports).G500})`,
            label: "done-parent-issue"
        }), doneParentLabel) : null);
    const $3aae186893156b3c$var$CustomOption = ({ option: option })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ('fields' in option) {
            const fields = option?.fields;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, $3aae186893156b3c$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, (0, parcelRequire("hVITp")).default).doneParentLabel), formatMessage((0, (0, parcelRequire("hVITp")).default).icon, {
                issueType: fields?.issuetype.name || ''
            })), option.fields.summary)));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionTextContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($3aae186893156b3c$var$OptionLabel, null, option.label), $3aae186893156b3c$var$renderOptionDescription(option)));
    };
    var $3aae186893156b3c$export$2e2bcd8739ae039 = $3aae186893156b3c$var$CustomOption;
    const $3aae186893156b3c$var$IconWithColor = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _p12f7vkz",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f7vkz",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$IconColorKeyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$DoneWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$IssueKey = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionColorTypeKeyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _otyr1b66",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionDescriptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _1e0c1txw _2lx2vrvc _4cvr1h6o _19pk1b66",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionTextContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $3aae186893156b3c$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hVITp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3c6ab058a23c088$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c3c6ab058a23c088$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        icon: {
            "id": "issue-field-parent.edit.option.icon",
            "defaultMessage": "{issueType} icon"
        },
        doneParentLabel: {
            "id": "issue-field-parent.edit.option.done-parent-label",
            "defaultMessage": "Done"
        }
    });
});
parcelRegister("6v0ju", function(module, exports) {
    $parcel$export(module.exports, "fetchParentsForNew", ()=>$2703467b5174b086$export$73bed6a0175e413);
    $parcel$export(module.exports, "fetchParentsForExisting", ()=>$2703467b5174b086$export$f995718992ca6c2f);
    var $jcw0u;
    var $cWEsa;
    var $cAZGv;
    var $iVcsU;
    const $2703467b5174b086$export$cfeee2ee86ead336 = 'bento';
    const $2703467b5174b086$export$73bed6a0175e413 = async (props)=>{
        const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
        try {
            const response = await (0, (0, parcelRequire("cAZGv")).fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
            return {
                options: (0, (0, parcelRequire("iVcsU")).mapDataToOptions)(response.candidates),
                message: response.message
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchParentsForNew',
                    packageName: 'jiraIssueFieldParent',
                    teamName: $2703467b5174b086$export$cfeee2ee86ead336
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw new Error(error);
        }
    };
    const $2703467b5174b086$export$f995718992ca6c2f = async (props)=>{
        const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
        try {
            const response = await (0, (0, parcelRequire("cWEsa")).fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
            return {
                options: (0, (0, parcelRequire("iVcsU")).mapDataToOptions)(response.candidates),
                message: response.message
            };
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchParentsForExisting',
                    packageName: 'jiraIssueFieldParent',
                    teamName: $2703467b5174b086$export$cfeee2ee86ead336
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("cWEsa", function(module, exports) {
    $parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", ()=>$96b7190bd204920f$export$59a0f41a1d5dcee0);
    var $jJZqs;
    var $d8JF2;
    var $2t8So;
    var $k90nh;
    var $1aPWY;
    const $96b7190bd204920f$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
        const response = (0, (0, parcelRequire("2t8So")).default)(cloudId, issueKey, searchTerm, excludeDone);
        const { data: data, errors: errors } = await response;
        if (!data || errors) {
            const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
            throw new (0, (0, parcelRequire("k90nh")).default)(new Error(message), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        }
        if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
            if (Array.isArray(errors) && errors.length > 0) {
                const errorMessage = JSON.stringify(errors);
                throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
            } else throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, (0, parcelRequire("d8JF2")).PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        }
        const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, (0, parcelRequire("1aPWY")).transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
        return {
            candidates: candidates,
            message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
        };
    };
});
parcelRegister("d8JF2", function(module, exports) {
    $parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", ()=>$9b9ac42d3f1a3741$export$c7c7f21787854c5b);
    $parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", ()=>$9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5);
    var $bItI4;
    const $9b9ac42d3f1a3741$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
    const $9b9ac42d3f1a3741$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$9b9ac42d3f1a3741$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, (0, parcelRequire("bItI4")).parentCandidatesForExistingIssueQuery)()}
    }
`;
});
parcelRegister("bItI4", function(module, exports) {
    $parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", ()=>$a63b2f209c365c28$export$f63a6e3151b9dd82);
    const $a63b2f209c365c28$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
    const $a63b2f209c365c28$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
    const $a63b2f209c365c28$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
    const $a63b2f209c365c28$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
    const $a63b2f209c365c28$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a63b2f209c365c28$var$issueType()}
      ${$a63b2f209c365c28$var$summary()}
      ${$a63b2f209c365c28$var$status()}
    }
  }
}`;
    const $a63b2f209c365c28$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$a63b2f209c365c28$var$color()}
              ${$a63b2f209c365c28$var$fieldsById()}
            }
          }
        }
        message
      }
    }
`;
});
parcelRegister("2t8So", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b07071af5f9e15eb$export$2e2bcd8739ae039);
    var $d8JF2;
    var $iBOrg;
    const $b07071af5f9e15eb$export$83bff8b82e36a9e9 = 20;
    var $b07071af5f9e15eb$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
        const variables = {
            cloudId: cloudId,
            issueKey: issueKey,
            searchTerm: searchTerm,
            excludeDone: excludeDone,
            first: $b07071af5f9e15eb$export$83bff8b82e36a9e9
        };
        const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
            query: (0, (0, parcelRequire("d8JF2")).buildParentCandidatesForExistingIssueQuery)(),
            variables: variables
        });
        return response;
    };
});
parcelRegister("k90nh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$602ab0b685964cde$export$2e2bcd8739ae039);
    var $jJZqs;
    class $602ab0b685964cde$export$2e2bcd8739ae039 extends Error {
        constructor(error, endpoint){
            if (error instanceof $602ab0b685964cde$export$2e2bcd8739ae039) return error;
            super(error.message);
            this.error = error;
            this.message = error.message;
            if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
                if (error.traceId != null) this.traceId = error.traceId;
                this.statusCode = error.statusCode;
            }
            this.endpoint = endpoint;
        }
    }
});
parcelRegister("1aPWY", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$9711633f84674efa$export$3ceb62baab058c6b);
    var $gULOk;
    var $jJZqs;
    var $heWHN;
    const $9711633f84674efa$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
            const edgeNode = edge.node;
            const fieldsEdges = edgeNode.fieldsById.edges;
            const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
            const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
            const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
            const colorField = edgeNode.issueColorField;
            if (summaryField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'summary',
                    error: 'Call to gira for parent candidates returned without summary data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (issueTypeField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'issueType',
                    error: 'Call to gira for parent candidates returned without issue type data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (statusField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'status',
                    error: 'Call to gira for parent candidates returned without status data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            if (issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Validation Error', [
                {
                    field: 'Issue Color',
                    error: 'Call to gira for parent candidates returned without color data'
                }
            ], (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef));
            const summaryFieldNode = summaryField.node;
            const issueTypeFieldNode = issueTypeField.node;
            const checkParentIssueIsDone = (statusCategoryId)=>{
                const doneStatusCategoryId = (0, (0, parcelRequire("gULOk"))).StatusCategoryIds[(0, (0, parcelRequire("gULOk"))).StatusCategoryTypes.DONE];
                return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
            };
            const isDone = checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId);
            const statusCategoryId = statusField?.node.status.statusCategory.statusCategoryId;
            const parent = {
                id: edgeNode.issueId,
                key: edgeNode.key,
                summary: summaryFieldNode.text,
                issueType: {
                    id: String(issueTypeFieldNode.issueType.issueTypeId),
                    name: issueTypeFieldNode.issueType.name,
                    iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
                },
                isDone: isDone,
                statusCategoryId: statusCategoryId
            };
            return {
                ...parent,
                color: colorField?.color?.colorKey ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
            };
        });
});
parcelRegister("cAZGv", function(module, exports) {
    $parcel$export(module.exports, "fetchParentCandidatesForNewIssue", ()=>$e563dea4a8edeb6a$export$48a29a1313179c04);
    var $jJZqs;
    var $78P89;
    var $iveGN;
    var $k90nh;
    var $1aPWY;
    const $e563dea4a8edeb6a$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
        const response = (0, (0, parcelRequire("iveGN")).default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
        const { data: data, errors: errors } = await response;
        if (!data || errors) {
            const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
            throw new (0, (0, parcelRequire("k90nh")).default)(new Error(message), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        }
        if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
            if (Array.isArray(errors) && errors.length > 0) {
                const errorMessage = JSON.stringify(errors);
                throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
            } else throw new (0, (0, parcelRequire("k90nh")).default)(new (0, (0, parcelRequire("jJZqs")).default)((0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        }
        const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, (0, parcelRequire("1aPWY")).transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
        return {
            candidates: candidates,
            message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
        };
    };
});
parcelRegister("78P89", function(module, exports) {
    $parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", ()=>$cf42cbd052db3ab7$export$26f006aaa0389bc0);
    $parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", ()=>$cf42cbd052db3ab7$export$453f3d2e0fac3592);
    var $eVi6b;
    const $cf42cbd052db3ab7$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
    const $cf42cbd052db3ab7$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$cf42cbd052db3ab7$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, (0, parcelRequire("eVi6b")).parentCandidatesForNewIssueQuery)()}
    }
`;
});
parcelRegister("eVi6b", function(module, exports) {
    $parcel$export(module.exports, "parentCandidatesForNewIssueQuery", ()=>$5f9b4891c9749af5$export$1dfd5c8a625d5960);
    const $5f9b4891c9749af5$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
    const $5f9b4891c9749af5$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
    const $5f9b4891c9749af5$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
    const $5f9b4891c9749af5$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
    const $5f9b4891c9749af5$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$5f9b4891c9749af5$var$issueType()}
      ${$5f9b4891c9749af5$var$summary()}
      ${$5f9b4891c9749af5$var$status()}
    }
  }
}`;
    const $5f9b4891c9749af5$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$5f9b4891c9749af5$var$color()}
                ${$5f9b4891c9749af5$var$fieldsById()}
              }
            }
          }
          message
        }
      }
`;
});
parcelRegister("iveGN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b9969b12a843159$export$2e2bcd8739ae039);
    var $78P89;
    var $iBOrg;
    const $4b9969b12a843159$export$1fd3b40492f4ef9f = 20;
    var $4b9969b12a843159$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
        const variables = {
            cloudId: cloudId,
            projectId: projectId,
            issueTypeId: issueTypeId,
            searchTerm: searchTerm,
            excludeDone: excludeDone,
            first: $4b9969b12a843159$export$1fd3b40492f4ef9f
        };
        const response = await (0, (0, parcelRequire("iBOrg")).getClient)('').query({
            query: (0, (0, parcelRequire("78P89")).buildParentCandidatesForNewIssueQuery)(),
            variables: variables,
            operationName: `jira_parenting_${(0, (0, parcelRequire("78P89")).PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
        });
        return response;
    };
});
parcelRegister("bA6nL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b53543067399a8c2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b53543067399a8c2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        description: {
            "id": "issue-create-commons.parent-field.description",
            "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
        },
        descriptionIssueTermRefresh: {
            "id": "issue-create-commons.parent-field.description-issue-term-refresh",
            "defaultMessage": "Your work type hierarchy determines the work items you can select here."
        }
    });
});
parcelRegister("eulr6", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultParentValue", ()=>$ca97e2610eb77570$export$f38bec4d01c88544);
    $parcel$export(module.exports, "validateParentField", ()=>$ca97e2610eb77570$export$656803053e0b9113);
    $parcel$export(module.exports, "mutateParentField", ()=>$ca97e2610eb77570$export$15ec054c85ac7db1);
    var $bGrWH;
    var $heWHN;
    const $ca97e2610eb77570$export$f38bec4d01c88544 = (defaultValue)=>{
        const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
        const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
        const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
        const summary = summaryField?.node.text;
        const label = `${key} ${summary}`;
        return {
            label: label,
            value: issueId,
            key: key,
            color: issueColorField && issueColorField.color !== null ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
            fields: {
                summary: summary,
                issuetype: {
                    name: issueTypeField?.node.issueType.name,
                    iconUrl: issueTypeField?.node.issueType.avatar.xsmall
                }
            }
        };
    };
    const $ca97e2610eb77570$export$656803053e0b9113 = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $ca97e2610eb77570$export$15ec054c85ac7db1 = ({ value: value })=>({
            parentField: {
                issueId: value
            }
        });
});
parcelRegister("6GeOm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cdc1d313fd94688$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $lzCWA;
    var $bNgRv;
    const $7cdc1d313fd94688$var$PeopleField = (props)=>{
        const { additionalData: { isMulti: isMulti }, autoCompleteUrl: autoCompleteUrl, selectedProject: selectedProject, ...rest } = props;
        const projectKey = selectedProject?.projectKey;
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query)=>{
            const autoCompleteResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/user/recommend?${new URLSearchParams({
                context: 'People',
                ...projectKey && {
                    project: projectKey
                },
                query: query ?? ''
            })}`);
            return (autoCompleteResponse ?? []).map((0, (0, parcelRequire("bNgRv")).transformToUserOption));
        }, [
            projectKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzCWA")).default), {
            ...rest,
            isMulti: isMulti,
            autoCompleteUrl: autoCompleteUrl,
            onFetchSuggestions: fetchSuggestions
        });
    };
    var $7cdc1d313fd94688$export$2e2bcd8739ae039 = $7cdc1d313fd94688$var$PeopleField;
});
parcelRegister("bNgRv", function(module, exports) {
    $parcel$export(module.exports, "mutatePeopleField", ()=>$d3f4b37ab9cd4018$export$62bbb242ba3788ab);
    $parcel$export(module.exports, "mapUserOptionOrOptionsToIds", ()=>$d3f4b37ab9cd4018$export$2ebc7514b112dd56);
    $parcel$export(module.exports, "transformToUserOption", ()=>$d3f4b37ab9cd4018$export$5924759166d7a225);
    const $d3f4b37ab9cd4018$export$62bbb242ba3788ab = (selectedValue, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $c84af56c6a8d1839$export$34a73409a6330355),
            users: Array.isArray(selectedValue) ? selectedValue.map((user)=>({
                    accountId: user.id
                })) : [
                {
                    accountId: selectedValue.id
                }
            ]
        });
    const $d3f4b37ab9cd4018$export$2ebc7514b112dd56 = (userOption)=>{
        if (Array.isArray(userOption)) return userOption.map((option)=>({
                id: option.id
            }));
        return [
            {
                id: userOption.id
            }
        ];
    };
    const $d3f4b37ab9cd4018$export$5924759166d7a225 = (userData)=>({
            id: userData.accountId,
            name: userData.displayName || '',
            avatarUrl: userData.avatarUrl || userData.avatarUrls?.['32x32'] || ''
        });
});
const $c84af56c6a8d1839$export$34a73409a6330355 = 'peopleFields';
parcelRegister("2QZDj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b29a3848e499878f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qOqP;
    var $4IxfP;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $hnBts;
    const $b29a3848e499878f$var$PriorityField = (props)=>{
        const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, ariaLabelledBy: ariaLabelledBy } = props;
        const options = (0, (0, parcelRequire("4IxfP")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qOqP")).default), {
            options: options,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly,
            inputId: id,
            isRequired: isRequired,
            ariaLabelledBy: ariaLabelledBy
        }));
    };
    var $b29a3848e499878f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validatePriorityField),
        transformDefaultValue: (0, parcelRequire("hnBts")).transformDefaultValue
    })($b29a3848e499878f$var$PriorityField);
});
parcelRegister("4qOqP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00acd3f7bdd60a4f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $9UhzQ;
    var $lElIo;
    const $00acd3f7bdd60a4f$var$PriorityEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            inputId: inputId,
            required: isRequired,
            value: value,
            options: options,
            placeholder: placeholder,
            onChange: onChange,
            onFocus: onFocus,
            onBlur: onBlur,
            autoFocus: autoFocus,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
            isClearable: false,
            hideSelectedOptions: true,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            classNamePrefix: classNamePrefix,
            openMenuOnFocus: openMenuOnFocus,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $00acd3f7bdd60a4f$export$2e2bcd8739ae039 = $00acd3f7bdd60a4f$var$PriorityEdit;
});
parcelRegister("9UhzQ", function(module, exports) {
    $parcel$export(module.exports, "formatOptionLabel", ()=>$7c6c645af44efe7b$export$322216d90ffb8d0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ujWmd;
    const $7c6c645af44efe7b$export$b4053b30a2d3983b = (props)=>{
        const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexRow, null, Boolean(iconUrl) && (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$AvatarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            appearance: "square",
            size: "xsmall",
            src: iconUrl,
            borderColor: "transparent"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$FlexColumn, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "issue-field-select-base.ui.format-option-label.c-label"
        }, label), optionContext === 'menu' && Boolean(description) && (0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$var$Description, null, description)));
    };
    const $7c6c645af44efe7b$export$322216d90ffb8d0e = (option, { context: context })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7c6c645af44efe7b$export$b4053b30a2d3983b, {
            option: option,
            optionContext: context
        });
    const $7c6c645af44efe7b$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$FlexColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2lx21bp4 _1e0c1txw _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$AvatarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxu2gc _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $7c6c645af44efe7b$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wyb1skh _syaz1rc1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4IxfP", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$ae732ed1951f68ed$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$ae732ed1951f68ed$export$fc800909123977f3);
    const $ae732ed1951f68ed$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
                label: name,
                value: id,
                iconUrl: iconUrl
            }));
    const $ae732ed1951f68ed$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
            id: value,
            name: label,
            iconUrl: iconUrl
        });
});
parcelRegister("hnBts", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultValue", ()=>$f6b5541ab69f5e0c$export$e2f4e5d31db527cc);
    $parcel$export(module.exports, "mutatePriorityField", ()=>$f6b5541ab69f5e0c$export$2c46dd13be598543);
    const $f6b5541ab69f5e0c$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        });
    const $f6b5541ab69f5e0c$export$2c46dd13be598543 = ({ value: value })=>({
            priority: {
                priorityId: value
            }
        });
});
parcelRegister("lomXS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a9db325d73e74e6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $6NfQh;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $eWiSP;
    const $6a9db325d73e74e6$var$ProjectCF = (props)=>{
        const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', fieldProps: { value: value = null, onChange: onChange, id: id }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NfQh")).ProjectCustomFieldEdit), {
            fieldId: fieldId,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            autoCompleteUrl: autoCompleteUrl,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnFocus: true,
            "aria-labelledby": ariaLabelledBy,
            ...(0, (0, parcelRequire("4R6GH")).fg)('async-project-cf-a11y-violations') && {
                fieldId: id || fieldId
            }
        }));
    };
    var $6a9db325d73e74e6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("eWiSP")).validateProjectField),
        transformDefaultValue: (0, (0, parcelRequire("eWiSP")).transformDefaultProjectValue)
    })($6a9db325d73e74e6$var$ProjectCF);
});
parcelRegister("6NfQh", function(module, exports) {
    $parcel$export(module.exports, "ProjectCustomFieldEdit", ()=>$6d7c2b47258fee64$export$8d413eb197febcb2);
    var $5uXOq = parcelRequire("5uXOq");
    var $d7FF4;
    var $dGrdR;
    var $4R6GH;
    var $koVbs;
    var $9UhzQ;
    var $lElIo;
    var $9kbEN;
    var $FtZX9;
    var $8zOmE;
    var $2NMNM;
    var $fFrY4;
    var $8OYXe;
    const $6d7c2b47258fee64$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
    const $6d7c2b47258fee64$var$PROJECT_OPTIONS_LOADED = 'issue-field-project-options-loaded';
    const $6d7c2b47258fee64$var$projectOptionsLoadedMetric = (0, (0, parcelRequire("dGrdR")).metrics).custom({
        key: $6d7c2b47258fee64$var$PROJECT_OPTIONS_LOADED
    });
    const $6d7c2b47258fee64$export$8d413eb197febcb2 = (props)=>{
        const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, blurInputOnSelect: blurInputOnSelect, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, hideSelectedOptions: hideSelectedOptions, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, openMenuOnFocus: openMenuOnFocus, spacing: spacing, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, isInvalid: isInvalid = false, value: value = null, onBlur: onBlur, 'aria-labelledby': ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [lastFetchFailed, setLastFetchFailed] = (0, $5uXOq.useState)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)([]);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const shouldFetchDefaultOptions = (0, $5uXOq.useRef)(true);
        const isInSampleAnalytics = (0, $5uXOq.useRef)((0, (0, parcelRequire("9kbEN")).isInSample)());
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireOptionsLoadedAnalyticsEvent = (duration)=>{
            const action = 'loaded';
            const actionSubject = 'projectFieldOptions';
            const event = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            const attrs = {
                duration: duration
            };
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
        };
        const searchProjects = async (query = '')=>{
            setLastFetchFailed(false);
            isInSampleAnalytics.current && $6d7c2b47258fee64$var$projectOptionsLoadedMetric.start();
            return (0, (0, parcelRequire("8OYXe")).fetchProjects)(query, autoCompleteUrl).then((projectsData)=>{
                if (isInSampleAnalytics.current) {
                    $6d7c2b47258fee64$var$projectOptionsLoadedMetric.stop();
                    const { start: start, stop: stop } = $6d7c2b47258fee64$var$projectOptionsLoadedMetric.getData();
                    const duration = stop && start ? stop - start : null;
                    fireOptionsLoadedAnalyticsEvent(duration);
                }
                return projectsData;
            }).catch(()=>{
                isInSampleAnalytics.current && $6d7c2b47258fee64$var$projectOptionsLoadedMetric.cancel();
                setLastFetchFailed(true);
                return [];
            });
        };
        const onFocus = async ()=>{
            if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
                shouldFetchDefaultOptions.current = false;
                setIsLoading && setIsLoading(true);
                const options = await searchProjects();
                setDefaultOptions && setDefaultOptions(options);
                setIsLoading && setIsLoading(false);
            }
        };
        const loadOptionsDebounced = (0, (0, parcelRequire("FtZX9")).default)(searchProjects, $6d7c2b47258fee64$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>formatMessage(lastFetchFailed ? (0, (0, parcelRequire("fFrY4")).default).failedFetch : (0, (0, parcelRequire("fFrY4")).default).noMatches), [
            formatMessage,
            lastFetchFailed
        ]);
        const defaultOptionsProps = ()=>{
            if (fetchSuggestionsOnFocus) return {
                onFocus: onFocus,
                isLoading: isLoading,
                defaultOptions: defaultOptions
            };
            return {};
        };
        const additionalSelectProps = {
            blurInputOnSelect: blurInputOnSelect,
            hideSelectedOptions: hideSelectedOptions,
            openMenuOnFocus: openMenuOnFocus,
            spacing: spacing
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d7FF4")).default), {
            fieldId: fieldId,
            autoFocus: autoFocus,
            ...defaultOptionsProps(),
            ...additionalSelectProps,
            isClearable: true,
            closeMenuOnScroll: onCloseMenuOnScroll,
            formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
            loadOptions: loadOptionsDebounced,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            noOptionsMessage: getNoOptionsMessage,
            placeholder: formatMessage((0, (0, parcelRequire("fFrY4")).default).placeholder),
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            validationState: isInvalid === true ? 'error' : null,
            value: value,
            onChange: onChange,
            onBlur: onBlur,
            "aria-labelledby": ariaLabelledBy,
            ...(0, (0, parcelRequire("4R6GH")).fg)('async-project-cf-a11y-violations') && {
                inputId: fieldId
            }
        });
    };
});
parcelRegister("9kbEN", function(module, exports) {
    $parcel$export(module.exports, "isInSample", ()=>$b9c2013a86366ec0$export$a994c91d08ead5ff);
    const $b9c2013a86366ec0$export$a994c91d08ead5ff = (sampleRate = (0, $670519621927ccc4$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;
});
const $670519621927ccc4$export$9fc1f2d681a9e609 = 100;
parcelRegister("fFrY4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54cd2640719875e5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $54cd2640719875e5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noMatches: {
            "id": "issue-field-project.edit.async-project-cf.no-matches",
            "defaultMessage": "No matches"
        },
        failedFetch: {
            "id": "issue-field-project.edit.async-project-cf.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        placeholder: {
            "id": "issue-field-project.edit.async-project-cf.placeholder",
            "defaultMessage": "Select project"
        },
        loading: {
            "id": "issue-field-project.edit.async-project-cf.loading",
            "defaultMessage": "Searching..."
        }
    });
});
parcelRegister("8OYXe", function(module, exports) {
    $parcel$export(module.exports, "fetchProjects", ()=>$01b71453e2061823$export$f0d2ca471cdb99b0);
    var $jcw0u;
    var $jJZqs;
    var $eusud;
    var $1D0eh;
    const $01b71453e2061823$export$f0d2ca471cdb99b0 = async (inputValue, autoCompleteUrl)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}${inputValue}`).then((response)=>(0, (0, parcelRequire("1D0eh")).mapDataToOptions)(response.values)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                error: error,
                id: 'fetchProjects',
                packageName: 'jiraIssueFieldProject',
                logToSentry: !(0, (0, parcelRequire("jJZqs")).isValidationError)(error),
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
});
parcelRegister("1D0eh", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOption", ()=>$ee5bde84b258a4cc$export$5c1e24ea9ccb80aa);
    $parcel$export(module.exports, "mapDataToOptions", ()=>$ee5bde84b258a4cc$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$ee5bde84b258a4cc$export$fc800909123977f3);
    const $ee5bde84b258a4cc$export$5c1e24ea9ccb80aa = (data)=>({
            label: data.name,
            value: data.key,
            iconUrl: data.avatarUrls['48x48'],
            projectId: data.id
        });
    const $ee5bde84b258a4cc$export$99a866ffa3af7d8b = (data)=>data.map($ee5bde84b258a4cc$export$5c1e24ea9ccb80aa);
    const $ee5bde84b258a4cc$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
            key: value,
            name: label,
            avatarUrls: {
                '48x48': iconUrl
            }
        });
});
parcelRegister("eWiSP", function(module, exports) {
    $parcel$export(module.exports, "mutateProjectField", ()=>$d63b347c9d814150$export$fb6480503bf79949);
    $parcel$export(module.exports, "validateProjectField", ()=>$d63b347c9d814150$export$5c1e30a9f731caaf);
    $parcel$export(module.exports, "transformDefaultProjectValue", ()=>$d63b347c9d814150$export$c77f86922e480ac0);
    var $bGrWH;
    const $d63b347c9d814150$export$fb6480503bf79949 = (selectedProject, fieldId)=>({
            projectFields: [
                {
                    fieldId: fieldId,
                    project: {
                        projectId: selectedProject.projectId || ''
                    }
                }
            ]
        });
    const $d63b347c9d814150$export$5c1e30a9f731caaf = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
    const $d63b347c9d814150$export$c77f86922e480ac0 = (data)=>({
            label: data.name,
            value: data.key,
            iconUrl: data.avatar.large,
            projectId: data.id
        });
});
parcelRegister("3mcIX", function(module, exports) {
    $parcel$export(module.exports, "RadioGroupField", ()=>$0b39b2f7e2adcce5$export$a314277471067e8a);
    $parcel$export(module.exports, "default", ()=>$0b39b2f7e2adcce5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l8nrv;
    var $8TLRF;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    var $8tTRx;
    const $0b39b2f7e2adcce5$export$a314277471067e8a = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false, ...fieldProps }, error: error, allowedValues: allowedValues, isReadOnly: isReadOnly = false } = props;
        const options = (0, (0, parcelRequire("8TLRF")).mapDataToOptions)(allowedValues);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8nrv")).default), {
            ...fieldProps,
            options: options,
            isDisabled: isReadOnly || isDisabled,
            value: value,
            onChange: onChange,
            isInvalid: Boolean(error)
        }));
    };
    var $0b39b2f7e2adcce5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateRadioGroupField),
        transformDefaultValue: (0, parcelRequire("8tTRx")).transformDefaultValue
    })($0b39b2f7e2adcce5$export$a314277471067e8a);
});
parcelRegister("l8nrv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b71e9e78a24d10c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3rLiX;
    const $8b71e9e78a24d10c$var$RadioGroupEdit = (props)=>{
        const { value: value, options: options, onChange: onChange, isInvalid: isInvalid, isDisabled: isDisabled = false, ...fieldProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3rLiX")).default), {
            ...fieldProps,
            value: value === null ? value : value?.value,
            options: options,
            isDisabled: isDisabled,
            onChange: (e)=>onChange(options.find((option)=>option.value === e?.target?.value) || null),
            isInvalid: isInvalid
        });
    };
    var $8b71e9e78a24d10c$export$2e2bcd8739ae039 = $8b71e9e78a24d10c$var$RadioGroupEdit;
});
parcelRegister("3rLiX", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$ca8b717dad009c8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eGmKJ;
    var $jouoW;
    const $ca8b717dad009c8c$var$noOptions = [];
    function $ca8b717dad009c8c$export$2e2bcd8739ae039(props) {
        const { onChange: onChange, options: options = $ca8b717dad009c8c$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, (0, parcelRequire("eGmKJ")).default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
        const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)(propValue !== undefined ? propValue : defaultValue);
        const onRadioChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setSelectedValue(e.currentTarget.value);
            if (onChange) onChange(e, analyticsEvent);
        }, [
            onChange
        ]);
        const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "radiogroup",
            "aria-labelledby": ariaLabelledBy,
            "data-testid": testId
        }, options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jouoW")).default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        }));
    }
});
parcelRegister("jouoW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d22fafff331be84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $eGmKJ;
    var $VSDnB;
    function $5d22fafff331be84$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5d22fafff331be84$var$packageName = "platform-pkg";
    const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
    const $5d22fafff331be84$var$noop = (0, (0, parcelRequire("eGmKJ")).default);
    const $5d22fafff331be84$var$labelPaddingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $5d22fafff331be84$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        boxSizing: 'border-box',
        position: 'relative',
        alignItems: 'flex-start',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$eaa8c8a70ac22806)})`,
            cursor: 'not-allowed'
        }
    });
    const $5d22fafff331be84$var$radioStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '24px',
        height: '24px',
        margin: "var(--ds-space-0, 0px)",
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        backgroundColor: 'var(--radio-background-color)',
        border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        MozAppearance: 'none',
        outline: 'none',
        '--radio-background-color': `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`,
        '--radio-dot-opacity': 0,
        transform: 'scale(calc(7 / 12))',
        transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
        verticalAlign: 'top',
        WebkitAppearance: 'none',
        '&::after': {
            width: 'calc(4px * 12 / 7)',
            height: 'calc(4px * 12 / 7)',
            position: 'absolute',
            background: 'var(--radio-dot-color)',
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: "''",
            opacity: 'var(--radio-dot-opacity)',
            transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
        },
        '&:hover': {
            '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        },
        '&:active': {
            '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`
        },
        '&:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&:checked': {
            '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            '--radio-dot-opacity': 1
        },
        '&:checked:hover': {
            '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`,
            '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`
        },
        '&:checked:active': {
            '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
            '--radio-border-color': `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`,
            '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        '&:checked:focus': {
            outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-border-width-indicator, 3px)"
        },
        '&[data-invalid], &:checked[data-invalid]': {
            '--radio-border-color': `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
        },
        '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
            cursor: 'not-allowed',
            '--radio-background-color': `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-border-color': `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`
        }
    });
    const $5d22fafff331be84$var$newRadioStyles = {
        name: "5rrwak",
        styles: "transform:scale(calc(7.5 / 12));&::after{width:calc(5.6px * 12 / 7);height:calc(5.6px * 12 / 7);}"
    };
    const $5d22fafff331be84$var$InnerRadio = (0, $5uXOq.forwardRef)(function Radio(props, ref) {
        const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props;
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'radio',
            packageName: $5d22fafff331be84$var$packageName,
            packageVersion: $5d22fafff331be84$var$packageVersion
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            "data-testid": testId && `${testId}--radio-label`,
            "data-disabled": isDisabled ? 'true' : undefined,
            css: $5d22fafff331be84$var$labelStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": testId && `${testId}--radio-input`,
            "data-invalid": isInvalid ? 'true' : undefined,
            css: [
                $5d22fafff331be84$var$radioStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && (0, (0, parcelRequire("VSDnB")).fg)('platform-icon-control-migration') && $5d22fafff331be84$var$newRadioStyles
            ],
            ref: ref
        }), label ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5d22fafff331be84$var$labelPaddingStyles
        }, label) : null);
    });
    const $5d22fafff331be84$var$Radio = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Radio(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($5d22fafff331be84$var$InnerRadio, {
            ...props,
            ref: ref
        });
    }));
    var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;
});
parcelRegister("8TLRF", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$cc42529534176e68$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$cc42529534176e68$export$fc800909123977f3);
    const $cc42529534176e68$export$99a866ffa3af7d8b = (data)=>data?.map(({ id: id, value: value })=>({
                label: value,
                value: id,
                testId: id
            }));
    const $cc42529534176e68$export$fc800909123977f3 = (option)=>({
            id: option?.value,
            value: option?.label
        });
});
parcelRegister("8tTRx", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultValue", ()=>$58a2b2055d1ede67$export$e2f4e5d31db527cc);
    const $58a2b2055d1ede67$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
            label: value,
            value: id,
            testId: id
        });
});
parcelRegister("cOF52", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a350fdd513ab8bcb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $apGhO;
    var $5kDIl;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    const $a350fdd513ab8bcb$var$ReporterField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, isRequired: isRequired, isReadOnly: isReadOnly = false, selectedProject: selectedProject } = props;
        const { projectType: projectType, projectKey: projectKey } = selectedProject || {};
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("apGhO")).default), {
            ...fieldProps,
            value: value,
            onChange: onChange,
            appearance: "normal",
            isDisabled: isReadOnly,
            autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
                context: 'Reporter',
                ...projectKey && {
                    project: projectKey
                },
                query: ''
            })}`,
            isMulti: false,
            autoFocus: autoFocus,
            isClearable: !isRequired,
            allowEmail: projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT),
            width: width,
            inputId: fieldProps.id,
            openMenuOnClick: true
        }));
    };
    var $a350fdd513ab8bcb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateUserPickerField),
        transformDefaultValue: (0, (0, parcelRequire("5kDIl")).transformJiraUserToUserOption)
    })($a350fdd513ab8bcb$var$ReporterField);
});
parcelRegister("apGhO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$657c7bee8e84f91c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jOrdN;
    var $khYiH;
    var $5fc53;
    var $cYlk7;
    var $1j4Sa;
    const $657c7bee8e84f91c$var$ReporterEdit = (props)=>{
        const { allowEmail: allowEmail = false, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value = null, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, onCancel: onCancel, isClearable: isClearable = true, fetchSuggestions: fetchSuggestionsProps, shouldSetDefaultValue: shouldSetDefaultValueProp = true, openMenuOnClick: openMenuOnClick = false, ...fieldProps } = props;
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const shouldSetDefaultValue = (0, $5uXOq.useRef)(!value && shouldSetDefaultValueProp);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldSetDefaultValue.current && user && !value) {
                shouldSetDefaultValue.current = false;
                onChange((0, (0, parcelRequire("khYiH")).mapUserObjectToUserOption)(user, true));
            }
        }, [
            onChange,
            user,
            value
        ]);
        const fetchSuggestionsCallback = (0, $5uXOq.useCallback)(async (query)=>(0, (0, parcelRequire("1j4Sa")).fetchSuggestions)(autoCompleteUrl, query), [
            autoCompleteUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jOrdN")).default), {
            ...fieldProps,
            appearance: appearance,
            width: width,
            fieldId: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            placeholder: placeholder,
            isDisabled: isDisabled,
            fetchSuggestions: fetchSuggestionsProps || fetchSuggestionsCallback,
            onSelection: onSelection,
            onCancel: onCancel,
            isClearable: isClearable,
            allowEmail: allowEmail,
            shouldShowEmailInOptions: true,
            openMenuOnClick: openMenuOnClick,
            "aria-labelledby": fieldProps['aria-labelledby']
        });
    };
    var $657c7bee8e84f91c$export$2e2bcd8739ae039 = $657c7bee8e84f91c$var$ReporterEdit;
});
parcelRegister("1j4Sa", function(module, exports) {
    $parcel$export(module.exports, "fetchSuggestions", ()=>$4c0a03770fcb0e17$export$ebf2f44fe450da2b);
    var $khYiH;
    var $eusud;
    const $4c0a03770fcb0e17$export$ebf2f44fe450da2b = async (autoCompleteUrl, query)=>{
        let users = [];
        const url = `${autoCompleteUrl}${query || ''}`;
        const suggestionsResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(url) || [];
        if (Array.isArray(suggestionsResponse)) users = suggestionsResponse.map((userFromApi)=>(0, (0, parcelRequire("khYiH")).mapUserObjectToUserOption)(userFromApi, true));
        else if (suggestionsResponse.users) users = suggestionsResponse.users.map((userFromApi)=>(0, (0, parcelRequire("khYiH")).mapUserObjectToUserOption)(userFromApi, true));
        return users;
    };
});
parcelRegister("5w5Vs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c879cc6a6a1de63f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bxulX;
    var $lfTZh;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $aPEdI;
    const $c879cc6a6a1de63f$var$ResolutionField = (props)=>{
        const { allowedValues: allowedValues, fieldId: fieldId, width: width, error: error, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "inline-resolution-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bxulX")).AsyncInlineResolutionEdit), {
            ...fieldProps,
            options: (0, (0, parcelRequire("aPEdI")).mapAllowedValuesToSelectOptions)(allowedValues),
            value: value,
            onChange: onChange,
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            classNamePrefix: `resolution-field-${fieldId}`,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
        })));
    };
    var $c879cc6a6a1de63f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aPEdI")).transformDefaultResolutionValue),
        validator: (0, (0, parcelRequire("jGVMX")).validateResolutionField)
    })($c879cc6a6a1de63f$var$ResolutionField);
});
parcelRegister("bxulX", function(module, exports) {
    $parcel$export(module.exports, "AsyncInlineResolutionEdit", ()=>$4a42014a1b6e02a2$export$af39bdbe1dcb0a1e);
    var $kxZPA;
    const $4a42014a1b6e02a2$export$af39bdbe1dcb0a1e = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("dvGfG")).then((module)=>module.InlineResolutionEdit), {
        moduleId: "./src/packages/issue/fields/resolution/src/index.tsx"
    });
});
parcelRegister("dvGfG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5DsWX").then(()=>parcelRequire('llFf1'));
});
parcelRegister("aPEdI", function(module, exports) {
    $parcel$export(module.exports, "mapAllowedValuesToSelectOptions", ()=>$b5ab8485a7a041fe$export$103f56c5c26f12e5);
    $parcel$export(module.exports, "transformDefaultResolutionValue", ()=>$b5ab8485a7a041fe$export$dbeca145fe19aaf1);
    $parcel$export(module.exports, "mutateResolutionField", ()=>$b5ab8485a7a041fe$export$a08b1e842f0a7a26);
    const $b5ab8485a7a041fe$export$103f56c5c26f12e5 = (allowedValues)=>allowedValues.map((value)=>({
                value: value.id,
                label: value.name
            }));
    const $b5ab8485a7a041fe$export$dbeca145fe19aaf1 = (value)=>({
            value: value.id,
            label: value.name
        });
    const $b5ab8485a7a041fe$export$a08b1e842f0a7a26 = (selectedResolution)=>({
            resolution: {
                resolutionId: selectedResolution.value
            }
        });
});
parcelRegister("7gcm4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cc39b6f15c02c20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $dQLtU;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    var $7Pdzq;
    const $5cc39b6f15c02c20$var$RespondersField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', placeholder: placeholder = '', isDisabled: isDisabled = false } = props;
        const onFetchSuggestions = async (query)=>{
            let responders = [];
            if (autoCompleteUrl !== undefined) {
                let autoCompleteResponse;
                try {
                    autoCompleteResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}/?query=${query || ''}`);
                } catch (err) {
                    return [];
                }
                if (autoCompleteResponse.responders) responders = autoCompleteResponse.responders;
            }
            return (0, (0, parcelRequire("7Pdzq")).transformDefaultUserValues)(responders);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dQLtU")).default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            placeholder: placeholder,
            isDisabled: isDisabled,
            onChange: onChange,
            value: value,
            appearance: "normal",
            isMulti: true,
            autoFocus: autoFocus,
            fieldId: fieldId,
            fetchSuggestions: onFetchSuggestions,
            isClearable: true
        }));
    };
    var $5cc39b6f15c02c20$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateUserPickerField),
        transformDefaultValue: (0, (0, parcelRequire("7Pdzq")).transformDefaultUserValues)
    })($5cc39b6f15c02c20$var$RespondersField);
});
parcelRegister("7Pdzq", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultUserValues", ()=>$78f37c024ed928fb$export$26760e7b66ccf1e1);
    $parcel$export(module.exports, "mapUserOptionsToAris", ()=>$78f37c024ed928fb$export$80dc4fd89a4c227d);
    const $78f37c024ed928fb$var$transformResponderTypeToUserOption = (userData)=>({
            id: userData?.ari || '',
            name: userData?.name || '',
            avatarUrl: userData?.avatarUrl || ''
        });
    const $78f37c024ed928fb$var$validateDefaultValue = (responder)=>{
        if (responder === null || responder === undefined) return false;
        if (!responder.ari || !responder.name) return false;
        return true;
    };
    const $78f37c024ed928fb$export$26760e7b66ccf1e1 = (defaultValue)=>{
        if (defaultValue === null || defaultValue === undefined) return [];
        return defaultValue.filter($78f37c024ed928fb$var$validateDefaultValue).map($78f37c024ed928fb$var$transformResponderTypeToUserOption);
    };
    const $78f37c024ed928fb$var$mapUserOptionToAri = (userData)=>({
            ari: userData.id
        });
    const $78f37c024ed928fb$export$80dc4fd89a4c227d = (userData)=>userData.map($78f37c024ed928fb$var$mapUserOptionToAri);
});
parcelRegister("3Z98Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ebb6e060acd861c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9EuZf;
    var $5fnvk;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $d8h6M;
    const $4ebb6e060acd861c$var$SingleGroupPickerField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, ariaLabelledBy: ariaLabelledBy } = props;
        const getExtraProps = ()=>{
            if (isDropdownMenuFixedAndLayered) return {
                menuPosition: 'fixed',
                groupPickerStyles: (0, (0, parcelRequire("9EuZf")).defaultUserPickerStyles),
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
            return {
                onCloseMenuOnScroll: (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll)
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fnvk")).default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            autoFocus: autoFocus,
            isMulti: false,
            "aria-labelledby": ariaLabelledBy,
            width: width,
            isInvalid: Boolean(error),
            placeholder: " ",
            ...getExtraProps()
        });
    };
    var $4ebb6e060acd861c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateGroupPickerField),
        transformDefaultValue: (0, (0, parcelRequire("d8h6M")).transformGroupDefaultValueToUserOption)
    })($4ebb6e060acd861c$var$SingleGroupPickerField);
});
parcelRegister("d8h6M", function(module, exports) {
    $parcel$export(module.exports, "transformGroupDefaultValueToUserOption", ()=>$dab4f2debb035d9d$export$d9591be6713fcfc8);
    $parcel$export(module.exports, "mutateSingleGroupPickerField", ()=>$dab4f2debb035d9d$export$daeca2ffaa5d8b62);
    var $arYvt;
    const $dab4f2debb035d9d$export$d9591be6713fcfc8 = (group)=>{
        if (!group) return null;
        return (0, (0, parcelRequire("arYvt")).transformGroupToUserOption)(group);
    };
    const $dab4f2debb035d9d$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
            fieldId: fieldId,
            group: {
                groupName: selectedGroup.name
            },
            mutationGroup: (0, $b977eeb5f24a5299$export$31fd86f8f183952c)
        });
});
const $b977eeb5f24a5299$export$31fd86f8f183952c = 'singleGroupPickerFields';
parcelRegister("k4tyx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$108361897c01a8f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $d3RWa;
    const $108361897c01a8f5$var$SingleSelectField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3RWa")).default), {
            ...props,
            isMulti: false
        });
    var $108361897c01a8f5$export$2e2bcd8739ae039 = $108361897c01a8f5$var$SingleSelectField;
});
parcelRegister("6HBPo", function(module, exports) {
    $parcel$export(module.exports, "mutateSingleSelectField", ()=>$6b9da676db8f86c9$export$35684f6945108587);
    $parcel$export(module.exports, "mapSelectOptionsToConnectData", ()=>$6b9da676db8f86c9$export$ed4050ca50f08036);
    const $6b9da676db8f86c9$export$35684f6945108587 = ({ value: value }, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $7d67a5d2a03fd88c$export$31fd86f8f183952c),
            option: {
                optionId: value
            }
        });
    const $6b9da676db8f86c9$export$ed4050ca50f08036 = (option)=>option.value;
});
const $7d67a5d2a03fd88c$export$31fd86f8f183952c = 'singleSelectFields';
parcelRegister("lfWSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8dbbb313a8b6153d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lzCWA;
    const $8dbbb313a8b6153d$var$SingleUserPickerField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lzCWA")).default), {
            ...props,
            isMulti: false,
            context: "CustomUserField"
        });
    var $8dbbb313a8b6153d$export$2e2bcd8739ae039 = $8dbbb313a8b6153d$var$SingleUserPickerField;
});
parcelRegister("aQNfA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d04647b01be2b83f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $koVbs;
    var $hTBEr;
    var $dTQPF;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $jGVMX;
    var $jrGSc;
    var $1AaWN;
    const $d04647b01be2b83f$var$SingleVersionField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, ariaLabelledBy: ariaLabelledBy } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onChangeVersionsEdit = (versionEditValue)=>{
            if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
        };
        const options = (0, (0, parcelRequire("1AaWN")).transformVersionExternalOptionstoVersionOptions)(allowedValues);
        const isDisabled = allowedValues.length === 0;
        const getVersionsEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTBEr")).default), {
                options: options,
                value: value,
                onChange: onChangeVersionsEdit,
                isInvalid: Boolean(error),
                fieldId: fieldId,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                isMulti: false,
                isDisabled: isDisabled,
                placeholder: isDisabled ? formatMessage((0, (0, parcelRequire("jrGSc")).default).none) : '',
                autoFocus: autoFocus,
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                ariaLabelledBy: ariaLabelledBy
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("jrGSc")).default).tooltip)
        }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }));
    };
    var $d04647b01be2b83f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateSingleVersionField),
        transformDefaultValue: (0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion),
        shouldRenderFieldMessage: false
    })($d04647b01be2b83f$var$SingleVersionField);
});
parcelRegister("jrGSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5396ea8e93f1b004$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5396ea8e93f1b004$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        none: {
            "id": "issue-create-commons.single-version-field.none",
            "defaultMessage": "None"
        },
        tooltip: {
            "id": "issue-create-commons.single-version-field.tooltip",
            "defaultMessage": "We couldn't find any versions for this project"
        }
    });
});
parcelRegister("1AaWN", function(module, exports) {
    $parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", ()=>$79dd8b3734a0e456$export$11cad9e2f2e9ae55);
    $parcel$export(module.exports, "mutateSingleVersionField", ()=>$79dd8b3734a0e456$export$57ed62196c76c8b6);
    var $dTQPF;
    const $79dd8b3734a0e456$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, (0, parcelRequire("dTQPF")).transformVersionExternalToVersion)(option));
    const $79dd8b3734a0e456$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $703505cc37235a2c$export$31fd86f8f183952c),
            version: {
                versionId: value
            }
        });
});
const $703505cc37235a2c$export$31fd86f8f183952c = 'singleVersionPickerFields';
parcelRegister("3pqs3", function(module, exports) {
    $parcel$export(module.exports, "SprintField", ()=>$83fe5b61920278eb$export$617303ef516d5a01);
    $parcel$export(module.exports, "default", ()=>$83fe5b61920278eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $92Z2l;
    var $3bDjY;
    var $6s1PB;
    var $koVbs;
    var $io7kF;
    var $3spCR;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $ahEu3;
    var $aqMtW;
    const $83fe5b61920278eb$export$617303ef516d5a01 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
        const renderSprintEdit = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("io7kF")).default), {
                fieldId: fieldId,
                autoCompleteUrl: autoCompleteUrl,
                onChange: onChange,
                value: value,
                isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
                fetchSuggestionsOnMount: false,
                autoFocus: autoFocus,
                isInvalid: Boolean(error),
                onCloseMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isEditable === false,
                getSuggestions: (0, (0, parcelRequire("aqMtW")).getSprintSuggestions),
                ...selectedProject?.projectKey ? {
                    projectKey: selectedProject?.projectKey
                } : {},
                inputId: id,
                isRequired: isRequired
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, renderSprintEdit()) : renderSprintEdit(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }), value && value.state === (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $83fe5b61920278eb$var$messageContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning",
            testId: "issue-create-commons.ui.sprint-field.required-fields-message"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("ahEu3")).default).activeSprintSelectionWarningMessageIssueTermRefresh : (0, (0, parcelRequire("ahEu3")).default).activeSprintSelectionWarningMessage))) : null);
    };
    var $83fe5b61920278eb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("aqMtW")).transformDefaultSprintValue),
        shouldRenderFieldMessage: false
    })($83fe5b61920278eb$export$617303ef516d5a01);
    const $83fe5b61920278eb$var$messageContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.050'
    });
});
parcelRegister("io7kF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e42898dffd6db898$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $4R6GH;
    var $koVbs;
    var $6Vzc4;
    var $3BhEA;
    var $9UhzQ;
    var $lElIo;
    var $gcvId;
    var $5fc53;
    var $249dD;
    var $bW9R0;
    var $egtXp;
    var $gxJKL;
    var $ckVH2;
    const $e42898dffd6db898$export$251bdbdbce9550ea = 300;
    const $e42898dffd6db898$var$SprintEdit = (props)=>{
        const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, (0, parcelRequire("5fc53")).SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus, 'aria-labelledby': ariaLabelledBy } = props;
        const [suggestions, setSuggestions] = (0, $5uXOq.useState)();
        const [defaultSuggestions, setDefaultSuggestions] = (0, $5uXOq.useState)();
        const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $5uXOq.useState)(false);
        const lastQuery = (0, $5uXOq.useRef)('');
        const [restrictSprints, setRestrictSprint] = (0, $5uXOq.useState)((0, (0, parcelRequire("egtXp")).getCheckboxValueFromLocalStorage)((0, (0, parcelRequire("egtXp")).EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
        const isInitialMount = (0, $5uXOq.useRef)(true);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, (0, parcelRequire("bW9R0")).useSprintSuggestions)({
            getSuggestions: getSuggestions
        });
        const onCheckboxClick = (0, $5uXOq.useCallback)(()=>{
            setRestrictSprint(!restrictSprints);
            (0, (0, parcelRequire("egtXp")).setCheckBoxValueInLocalStorage)((0, (0, parcelRequire("egtXp")).EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
        }, [
            restrictSprints
        ]);
        const componentProps = (0, $5uXOq.useMemo)(()=>({
                isChecked: restrictSprints,
                onChange: onCheckboxClick,
                projectKey: projectKey
            }), [
            restrictSprints,
            projectKey,
            onCheckboxClick
        ]);
        const handleSuggestions = (0, $5uXOq.useCallback)((results, query)=>{
            if (lastQuery.current === query) {
                const transformSuggestions = useTransformSuggestions || (0, (0, parcelRequire("249dD")).transformSuggestions);
                const response = transformSuggestions(results, formatMessage);
                if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
                setSuggestions(response);
                if (query === '') setDefaultSuggestions(response);
            }
        }, [
            formatMessage,
            useTransformSuggestions,
            onPostTransformSuggestions
        ]);
        const getFailedFetchMessage = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Vzc4")).FailedFetchOptionWrapper), null, formatMessage((0, (0, parcelRequire("ckVH2")).default).failedFetch)), [
            formatMessage
        ]);
        const fetchSuggestions = (0, $5uXOq.useCallback)(async (query = '')=>{
            try {
                let response;
                if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
                else response = await getSprintSuggestions(autoCompleteUrl, query);
                handleSuggestions(response, query);
            } catch (err) {
                setHasLastFetchFailed(true);
                const failedOption = [
                    {
                        label: getFailedFetchMessage(),
                        value: '',
                        isDisabled: true
                    }
                ];
                setSuggestions(failedOption);
            }
        }, [
            autoCompleteUrl,
            restrictSprints,
            projectKey,
            getFailedFetchMessage,
            getSprintSuggestions,
            handleSuggestions
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('_jira-concurrent-state-update-hasnt-mounted-yet')) (0, $5uXOq.useEffect)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        else (0, $5uXOq.useMemo)(()=>{
            if (fetchSuggestionsOnMount) {
                if (!options && !defaultSuggestions) {
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                } else if (options && !defaultSuggestions) {
                    setDefaultSuggestions(options);
                    setSuggestions(options);
                } else {
                    lastQuery.current = '';
                    setIsLoadingSuggestions(true);
                    fetchSuggestions();
                }
            }
        }, []);
        const debouncedFetchSuggestions = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(fetchSuggestions, $e42898dffd6db898$export$251bdbdbce9550ea), [
            restrictSprints
        ]);
        const getNoOptionsMessage = (0, $5uXOq.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, (0, parcelRequire("ckVH2")).default).empty), [
            formatMessage,
            noOptionsMessage
        ]);
        const getLoadingMessage = (0, $5uXOq.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, (0, parcelRequire("ckVH2")).default).loading), [
            formatMessage,
            loadingMessage
        ]);
        const filterOption = (0, $5uXOq.useCallback)((option, query)=>{
            if (hasLastFetchFailed) return true;
            return (0, (0, parcelRequire("3BhEA")).filterOptionByLabelAndFilterValues)(option, query || '');
        }, [
            hasLastFetchFailed
        ]);
        const onQueryChange = (0, $5uXOq.useCallback)((query)=>{
            debouncedFetchSuggestions.cancel();
            setHasLastFetchFailed(false);
            if (query) {
                lastQuery.current = query;
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(query);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(false);
                setSuggestions(defaultSuggestions);
            }
        }, [
            debouncedFetchSuggestions,
            defaultSuggestions,
            setIsLoadingSuggestions,
            setSuggestions
        ]);
        const onSelectFocus = (0, $5uXOq.useCallback)((e)=>{
            if (!suggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions('');
            }
            onFocus && onFocus(e);
        }, [
            fetchSuggestions,
            onFocus,
            setIsLoadingSuggestions,
            suggestions
        ]);
        const onSelectBlur = (0, $5uXOq.useCallback)((e)=>{
            onBlur && onBlur(e);
        }, [
            onBlur
        ]);
        const onValueChange = (0, $5uXOq.useCallback)((newValues)=>{
            onChange && onChange(newValues, suggestions);
        }, [
            onChange,
            suggestions
        ]);
        const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
        (0, $5uXOq.useEffect)(()=>{
            if (!isInitialMount.current) {
                setIsLoadingSuggestions(true);
                debouncedFetchSuggestions(lastQuery.current);
            }
            isInitialMount.current = false;
        }, [
            restrictSprints,
            debouncedFetchSuggestions,
            setIsLoadingSuggestions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gcvId")).default), {
            inputId: inputId,
            isRequired: isRequired,
            isClearable: true,
            hideSelectedOptions: true,
            autoFocus: autoFocus,
            fieldId: fieldId,
            options: suggestions,
            value: value,
            onBlur: onSelectBlur,
            menuPosition: menuPosition,
            componentsProps: projectKey ? componentProps : undefined,
            components: projectKey ? {
                Menu: (0, parcelRequire("gxJKL")).default
            } : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            closeMenuOnScroll: onCloseMenuOnScroll,
            loadingMessage: getLoadingMessage,
            placeholder: formatMessage((0, (0, parcelRequire("ckVH2")).default).placeholder),
            onInputChange: onQueryChange,
            onChange: onValueChange,
            spacing: spacing,
            isLoading: isLoadingSuggestions,
            filterOption: filterOption,
            formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
            validationState: isInvalid === true ? 'error' : null,
            isDisabled: isDisabled,
            openMenuOnFocus: openMenuOnFocus,
            "aria-labelledby": ariaLabelledBy
        });
    };
    var $e42898dffd6db898$export$2e2bcd8739ae039 = $e42898dffd6db898$var$SprintEdit;
});
parcelRegister("gcvId", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2132d0cd1f409256$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $iOwNT;
    var $6RCeq;
    var $koVbs;
    var $db8jg;
    var $2OMDV;
    var $8zOmE;
    var $2NMNM;
    var $8z9w3;
    var $dKKqb;
    const $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
    const $2132d0cd1f409256$var$analyticsProps = {
        onChange: 'valueChanged',
        onInputChange: 'inputChanged',
        onMenuOpen: 'menuOpened',
        onMenuClose: 'menuClosed'
    };
    const $2132d0cd1f409256$export$53574ab050410077 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('select', $2132d0cd1f409256$var$analyticsProps)((0, (0, parcelRequire("iOwNT")).default));
    const $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView = (props)=>{
        const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired, ariaLabel: ariaLabel = '' } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const hasSessionStarted = (0, $5uXOq.useRef)(false);
        const sessionId = (0, $5uXOq.useRef)(customSessionId);
        const sessionStartedAt = (0, $5uXOq.useRef)(0);
        const endSessionRef = (0, $5uXOq.useRef)(undefined);
        const [queryAtSetValue, setQueryAtSetValue] = (0, $5uXOq.useState)('');
        const [savedQuery, setSavedQuery] = (0, $5uXOq.useState)('');
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const flatOptions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("dKKqb")).flattenOptions)(options), [
            options
        ]);
        const getAnalyticsAttributes = (0, $5uXOq.useCallback)((query)=>{
            const selectedOptions = !(0, ($parcel$interopDefault($hGgHi)))(value) ? value : [];
            let filteredOptions = (0, (0, parcelRequire("dKKqb")).filterOptions)(flatOptions, query);
            const optionsLength = filteredOptions.length;
            filteredOptions = filteredOptions.slice(0, $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
            const safeFilteredOptions = (0, (0, parcelRequire("dKKqb")).getSafeOptionsForAnalytics)(filteredOptions);
            return {
                inputId: inputId,
                required: isRequired,
                fieldId: fieldId,
                isLoading: isLoading,
                optionsLength: optionsLength,
                componentName: 'select',
                packageName: '@atlaskit/select',
                optionValuesSafeForAnalytics: false,
                options: safeFilteredOptions,
                optionsLengths: (0, (0, parcelRequire("dKKqb")).getOptionValuesLengths)(filteredOptions),
                queryLength: query.length,
                queryHash: query === '' ? query : (0, (0, parcelRequire("db8jg")).memoizedHashString)(query),
                selectedOptions: (0, (0, parcelRequire("dKKqb")).getSafeOptionsForAnalytics)(selectedOptions),
                selectedOptionsLengths: (0, (0, parcelRequire("dKKqb")).getOptionValuesLengths)(selectedOptions),
                sessionId: sessionId.current,
                truncationSize: $2132d0cd1f409256$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
            };
        }, [
            value,
            flatOptions,
            inputId,
            isRequired,
            fieldId,
            isLoading
        ]);
        const getItemOrder = (0, $5uXOq.useCallback)((selectedItem)=>{
            const matchedIndexes = [];
            flatOptions.forEach((option, index)=>{
                if (option.value === selectedItem.value) matchedIndexes.push(index);
            });
            return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
        }, [
            flatOptions
        ]);
        const fireUIAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, query, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(query),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, attributes);
        }, [
            getAnalyticsAttributes
        ]);
        const fireTrackAnalyticsEvent = (0, $5uXOq.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
            const attributes = {
                ...getAnalyticsAttributes(savedQuery),
                ...extraAttributes
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
        }, [
            getAnalyticsAttributes,
            savedQuery
        ]);
        const startSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current === undefined) sessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            sessionStartedAt.current = (0, (0, parcelRequire("6RCeq")).default).now();
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'started'
            }), 'started', 'optionSelectionSession');
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const endSession = (0, $5uXOq.useCallback)(()=>{
            if (sessionId.current !== undefined) {
                const currentStartedAt = sessionStartedAt.current;
                const elapsedTime = currentStartedAt === 0 ? (0, (0, parcelRequire("6RCeq")).default).now() - currentStartedAt : 0;
                fireTrackAnalyticsEvent(createAnalyticsEvent({
                    action: 'ended'
                }), 'ended', 'optionSelectionSession', {
                    elapsedTime: elapsedTime
                });
            }
            sessionId.current = undefined;
            sessionStartedAt.current = 0;
        }, [
            createAnalyticsEvent,
            fireTrackAnalyticsEvent,
            sessionId,
            sessionStartedAt
        ]);
        const restartSession = (0, $5uXOq.useCallback)(()=>{
            endSession();
            startSession();
        }, [
            endSession,
            startSession
        ]);
        const fireInputChangedEvent = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'set-value') setQueryAtSetValue(savedQuery);
            setSavedQuery(query);
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'filter'
            });
            fireUIAnalyticsEvent(analyticsEvent, query);
        }, [
            fireUIAnalyticsEvent,
            savedQuery,
            setSavedQuery,
            setQueryAtSetValue
        ]);
        const fireOptionCreatedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'created',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const fireOptionRemovedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'removed',
                actionSubject: 'option'
            });
            fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
                removedItem: option ? (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value) : undefined
            });
        }, [
            fireUIAnalyticsEvent,
            savedQuery
        ]);
        const fireOptionSelectedEvent = (0, $5uXOq.useCallback)((option, analyticsEvent)=>{
            analyticsEvent.update({
                action: 'changed',
                actionSubject: 'option'
            });
            const oldSessionId = sessionId.current;
            restartSession();
            fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
                selectedOption: (0, (0, parcelRequire("dKKqb")).getSafeValue)(option.value),
                selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
                selectedOrder: getItemOrder(option),
                sessionId: oldSessionId
            });
        }, [
            fireUIAnalyticsEvent,
            getItemOrder,
            queryAtSetValue,
            restartSession,
            sessionId
        ]);
        const onChangeWithAnalytics = (0, $5uXOq.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
            const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
            switch(actionMeta.action){
                case 'create-option':
                    if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                    break;
                case 'remove-value':
                case 'pop-value':
                case 'deselect-option':
                    fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                    break;
                case 'select-option':
                    if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                    break;
                default:
                    break;
            }
            onChange && onChange(selectedOptionOrOptions, actionMeta);
        }, [
            fireOptionCreatedEvent,
            fireOptionRemovedEvent,
            fireOptionSelectedEvent,
            onChange
        ]);
        const onInputChangeWithAnalytics = (0, $5uXOq.useCallback)((query, actionMeta, analyticsEvent)=>{
            if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
            onInputChange && onInputChange(query, sessionId.current);
        }, [
            fireInputChangedEvent,
            onInputChange,
            sessionId
        ]);
        const isValidNewOption = (0, $5uXOq.useCallback)(()=>!!canCreateNewItem, [
            canCreateNewItem
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasSessionStarted.current) {
                startSession();
                fireInputChangedEvent('', {
                    action: 'fake-action'
                }, createAnalyticsEvent({}));
                hasSessionStarted.current = true;
            }
        }, [
            createAnalyticsEvent,
            fireInputChangedEvent,
            startSession
        ]);
        (0, $5uXOq.useEffect)(()=>{
            endSessionRef.current = endSession;
        }, [
            endSession
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                endSessionRef.current && endSessionRef.current();
            }, []);
        const { isRequired: required, ...propsWithoutRequired } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2132d0cd1f409256$export$53574ab050410077, {
            ...propsWithoutRequired,
            required: isRequired,
            onChange: onChangeWithAnalytics,
            onInputChange: onInputChangeWithAnalytics,
            isValidNewOption: isValidNewOption,
            label: ariaLabel || formatMessage((0, (0, parcelRequire("8z9w3")).default).ariaLabelForSelect)
        });
    };
    var $2132d0cd1f409256$export$2e2bcd8739ae039 = $2132d0cd1f409256$var$CreatableSelectWithAnalyticsView;
});
parcelRegister("8z9w3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$283d0de21cddfa94$export$2e2bcd8739ae039);
    var $7VHMR;
    var $283d0de21cddfa94$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ariaLabelForSelect: {
            "id": "issue-field-select-with-analytics.ariaLabel",
            "defaultMessage": "Select Field"
        }
    });
});
parcelRegister("dKKqb", function(module, exports) {
    $parcel$export(module.exports, "getSafeValue", ()=>$52dde5a2f186bbcb$export$d05672fd1312a6d);
    $parcel$export(module.exports, "getSafeOptionsForAnalytics", ()=>$52dde5a2f186bbcb$export$fde3d804891b8254);
    $parcel$export(module.exports, "flattenOptions", ()=>$52dde5a2f186bbcb$export$7baa7c13b358b002);
    $parcel$export(module.exports, "getOptionValuesLengths", ()=>$52dde5a2f186bbcb$export$e2e167245697ed4e);
    $parcel$export(module.exports, "filterOptions", ()=>$52dde5a2f186bbcb$export$60d56ed3961c839c);
    var $chc6P = parcelRequire("chc6P");
    var $db8jg;
    const $52dde5a2f186bbcb$export$d05672fd1312a6d = (val)=>(0, (0, parcelRequire("db8jg")).memoizedHashString)(val.toString()).toString();
    const $52dde5a2f186bbcb$export$fde3d804891b8254 = (items)=>{
        const itemsToFilter = Array.isArray(items) ? items : [
            items
        ];
        return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$52dde5a2f186bbcb$export$d05672fd1312a6d(value));
    };
    const $52dde5a2f186bbcb$export$7baa7c13b358b002 = (optionGroups)=>(0, ($parcel$interopDefault($chc6P)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
                optionOrGroup
            ]));
    const $52dde5a2f186bbcb$export$e2e167245697ed4e = (items)=>{
        const itemsToFilter = Array.isArray(items) ? items : [
            items
        ];
        return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
    };
    const $52dde5a2f186bbcb$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));
});
parcelRegister("249dD", function(module, exports) {
    $parcel$export(module.exports, "hasState", ()=>$cfadc135289d0d3a$export$d2fec4e2fc5f065a);
    $parcel$export(module.exports, "findSprintWithState", ()=>$cfadc135289d0d3a$export$fb6b70a9c996212b);
    $parcel$export(module.exports, "mapSprintOptionToData", ()=>$cfadc135289d0d3a$export$fb7a6b38a05bd2b7);
    $parcel$export(module.exports, "transformSuggestions", ()=>$cfadc135289d0d3a$export$1d0ee4320c26fb60);
    var $3spCR;
    var $e7pk8;
    const $cfadc135289d0d3a$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
    const $cfadc135289d0d3a$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
    const $cfadc135289d0d3a$export$fb6b70a9c996212b = (sprints, state)=>{
        if (!sprints) return undefined;
        return sprints.find($cfadc135289d0d3a$export$d2fec4e2fc5f065a(state));
    };
    const $cfadc135289d0d3a$export$d63c3784bf3852ca = (state)=>{
        if (state !== undefined) {
            const stateKey = state.toUpperCase();
            return (0, (0, parcelRequire("3spCR")).SPRINT_STATES)[stateKey];
        }
        return undefined;
    };
    const $cfadc135289d0d3a$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
    const $cfadc135289d0d3a$export$fbb2e1641ffac377 = (option)=>({
            id: Number(option.value),
            name: String(option.label),
            state: option.state,
            boardId: Number(option.data?.boardId) || 0
        });
    const $cfadc135289d0d3a$export$b9928e57702db7d9 = (items)=>items.map($cfadc135289d0d3a$export$fbb2e1641ffac377);
    const $cfadc135289d0d3a$export$cbdf60de7f2200e7 = (option)=>({
            id: Number(option.value),
            boardName: option.description,
            name: String(option.label),
            stateKey: $cfadc135289d0d3a$export$d63c3784bf3852ca(option.state),
            date: String(option.data?.date)
        });
    const $cfadc135289d0d3a$export$db10bf437c75c497 = (items)=>items.map($cfadc135289d0d3a$export$cbdf60de7f2200e7);
    const $cfadc135289d0d3a$export$15c97379ebef6b30 = (sprint)=>({
            id: sprint.id,
            description: sprint.boardName,
            label: sprint.name,
            state: sprint.stateKey,
            value: sprint.id,
            data: {
                date: sprint.date,
                fromCache: sprint.fromCache
            }
        });
    const $cfadc135289d0d3a$export$c1cb9e6f1beaee0d = (items)=>items.map($cfadc135289d0d3a$export$15c97379ebef6b30);
    const $cfadc135289d0d3a$export$ce3013ece3dbf252 = (sprint)=>({
            id: sprint.id,
            name: sprint.name,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            endDate: sprint.endDate || ''
        });
    const $cfadc135289d0d3a$export$755a6a3c6172f7e = (sprint)=>({
            label: sprint.name,
            value: sprint.id,
            href: $cfadc135289d0d3a$export$e6c9132cef5ee76f(sprint.id),
            state: $cfadc135289d0d3a$export$d63c3784bf3852ca(sprint.state),
            data: {
                boardId: sprint.boardId,
                date: sprint.startDate
            }
        });
    const $cfadc135289d0d3a$export$cbcaba92baa2e404 = (items)=>items.map($cfadc135289d0d3a$export$755a6a3c6172f7e);
    const $cfadc135289d0d3a$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
        const serverSuggestions = suggestionsFromServer.suggestions || [];
        const allMatches = suggestionsFromServer.allMatches || [];
        const allItems = serverSuggestions.concat(allMatches);
        const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).ACTIVE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, (0, parcelRequire("3spCR")).FUTURE_SPRINT_STATE)).map($cfadc135289d0d3a$export$15c97379ebef6b30);
        const sprints = [
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).activeSprints),
                options: activeItems
            },
            {
                label: formatMessage((0, (0, parcelRequire("e7pk8")).default).futureSprints),
                options: futureItems
            }
        ];
        return sprints;
    };
});
parcelRegister("3spCR", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$3ebc9911a79d714f);
    $parcel$export(module.exports, "FUTURE_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$863e42082c6bde5);
    $parcel$export(module.exports, "CLOSED_SPRINT_STATE", ()=>$113c1ed08a0bda4f$export$86cdef09a89e8c4b);
    $parcel$export(module.exports, "SPRINT_STATES", ()=>$113c1ed08a0bda4f$export$73a0206a4dc59760);
    const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
    const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
    const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
    const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
        ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
        CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
        FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
    };
});
parcelRegister("e7pk8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f3d56beb10e0cde$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1f3d56beb10e0cde$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activeSprints: {
            "id": "issue-field-sprint.common.active-sprints",
            "defaultMessage": "Active"
        },
        futureSprints: {
            "id": "issue-field-sprint.common.future-sprints",
            "defaultMessage": "Future"
        },
        recentSprints: {
            "id": "issue-field-sprint.common.recent-sprints",
            "defaultMessage": "Recent sprints"
        }
    });
});
parcelRegister("bW9R0", function(module, exports) {
    $parcel$export(module.exports, "useSprintSuggestions", ()=>$76a69867a9473261$export$16d0ab78a0b529dc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $eusud;
    const $76a69867a9473261$var$defaultParams = (0, $ebyGx.stringify)({
        maxActiveSprints: (0, $546eebefed97ea78$export$7112c73100e3ee45),
        maxResults: (0, $546eebefed97ea78$export$f6b2881bc1090cea)
    });
    const $76a69867a9473261$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
        let queryString;
        if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$76a69867a9473261$var$defaultParams}`;
        else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$76a69867a9473261$var$defaultParams}`;
        return (0, (0, parcelRequire("eusud")).performGetRequest)(queryString);
    };
    const $76a69867a9473261$export$16d0ab78a0b529dc = (props)=>{
        const { getSuggestions: getSuggestions = $76a69867a9473261$export$6945d45e210d19eb } = props || {};
        const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $5uXOq.useState)(false);
        const getSprintSuggestions = (0, $5uXOq.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
            try {
                const response = await getSuggestions(autoCompleteUrl, query, projectKey);
                setIsLoadingSuggestions(false);
                return response;
            } catch (error) {
                setIsLoadingSuggestions(false);
                throw error;
            }
        }, [
            getSuggestions,
            setIsLoadingSuggestions
        ]);
        const actions = (0, $5uXOq.useMemo)(()=>({
                getSprintSuggestions: getSprintSuggestions,
                setIsLoadingSuggestions: setIsLoadingSuggestions
            }), [
            getSprintSuggestions,
            setIsLoadingSuggestions
        ]);
        return [
            {
                isLoadingSuggestions: isLoadingSuggestions
            },
            actions
        ];
    };
});
const $546eebefed97ea78$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $546eebefed97ea78$export$7112c73100e3ee45 = 5;
const $546eebefed97ea78$export$f6b2881bc1090cea = 10;
parcelRegister("egtXp", function(module, exports) {
    $parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", ()=>$da54a1ad644b3ed6$export$90fd8fcc9388370d);
    $parcel$export(module.exports, "getCheckboxValueFromLocalStorage", ()=>$da54a1ad644b3ed6$export$b6ec857d138d143b);
    $parcel$export(module.exports, "setCheckBoxValueInLocalStorage", ()=>$da54a1ad644b3ed6$export$1750bf12ee05e0ac);
    var $ebyGx = parcelRequire("ebyGx");
    const $da54a1ad644b3ed6$var$getViewMode = ()=>(0, ($parcel$interopDefault($ebyGx))).parse(window.location.search).view || '';
    const $da54a1ad644b3ed6$export$d5e150c1e3186bd1 = ()=>$da54a1ad644b3ed6$var$getViewMode().includes('planning');
    const $da54a1ad644b3ed6$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
    const $da54a1ad644b3ed6$export$b6ec857d138d143b = (key)=>{
        const value = window.localStorage?.getItem(key);
        return value ? JSON.parse(value) : true;
    };
    const $da54a1ad644b3ed6$export$1750bf12ee05e0ac = (key, value)=>{
        try {
            window.localStorage.setItem(key, value);
        } catch  {}
    };
});
parcelRegister("gxJKL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb901ddd959c90f6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $bChGW;
    var $koVbs;
    var $ghRU5;
    var $kacDU;
    const $fb901ddd959c90f6$var$Menu = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { children: children, ...restProps } = props;
        const isChecked = props.selectProps?.componentsProps?.isChecked || false;
        const projectKey = props.selectProps?.componentsProps?.projectKey || null;
        const label = formatMessage((0, (0, parcelRequire("ghRU5")).default).checkboxLabel, {
            projectKey: projectKey
        });
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === ' ') event.stopPropagation();
        }, []);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bChGW")).components).Menu, restProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kacDU")).CheckboxWrapper), {
            onClick: props.selectProps?.componentsProps?.onChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            onKeyDown: onKeyDown,
            isChecked: isChecked,
            label: label,
            testId: "issue-field-sprint.ui.edit.menu.checkbox"
        })), children)));
    };
    var $fb901ddd959c90f6$export$2e2bcd8739ae039 = $fb901ddd959c90f6$var$Menu;
});
parcelRegister("ghRU5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7044cf08eb2bc7be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7044cf08eb2bc7be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        checkboxLabel: {
            "id": "issue-field-sprint.edit.menu.checkbox-label",
            "defaultMessage": "Only show sprints in this project ({projectKey})"
        }
    });
});
parcelRegister("kacDU", function(module, exports) {
    $parcel$export(module.exports, "CheckboxWrapper", ()=>$38a94e57c20f776f$export$eef12940a6696c78);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $38a94e57c20f776f$export$eef12940a6696c78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt41bs6 _n7zlpe8f _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ckVH2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fe9503663e56e29$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6fe9503663e56e29$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-sprint.edit.placeholder",
            "defaultMessage": "Select sprint"
        },
        empty: {
            "id": "issue-field-sprint.edit.empty",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "issue-field-sprint.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        loading: {
            "id": "issue-field-sprint.edit.loading",
            "defaultMessage": "Searching..."
        }
    });
});
parcelRegister("ahEu3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e77c8f330a49e37f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e77c8f330a49e37f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        activeSprintSelectionWarningMessage: {
            "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
            "defaultMessage": "Creating this issue will affect the active sprint's scope"
        },
        activeSprintSelectionWarningMessageIssueTermRefresh: {
            "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message-issue-term-refresh",
            "defaultMessage": "Creating this work item will affect the active sprint's scope"
        }
    });
});
parcelRegister("aqMtW", function(module, exports) {
    $parcel$export(module.exports, "transformDefaultSprintValue", ()=>$02b747729b1ec287$export$94efa001ab93bfd1);
    $parcel$export(module.exports, "mutateJiraSprintField", ()=>$02b747729b1ec287$export$38f8d6ec9f8dd490);
    $parcel$export(module.exports, "getSprintSuggestions", ()=>$02b747729b1ec287$export$a5ccca5b51d5d670);
    var $eusud;
    const $02b747729b1ec287$export$94efa001ab93bfd1 = (selectedSprints)=>{
        const sprint = selectedSprints[0];
        return sprint && {
            label: sprint.name,
            value: sprint.sprintId,
            state: sprint.state
        };
    };
    const $02b747729b1ec287$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
            sprintsField: {
                fieldId: fieldId,
                sprints: [
                    {
                        sprintId: value.toString()
                    }
                ]
            }
        });
    const $02b747729b1ec287$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
        const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
        if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
        return queryString;
    };
    const $02b747729b1ec287$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, (0, parcelRequire("eusud")).performGetRequest)($02b747729b1ec287$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));
});
parcelRegister("7nQJF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e43d0c98a72456c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    const $7e43d0c98a72456c$var$TextField = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).default), {
            type: "text",
            ...props
        });
    var $7e43d0c98a72456c$export$2e2bcd8739ae039 = $7e43d0c98a72456c$var$TextField;
});
parcelRegister("bB4xD", function(module, exports) {
    $parcel$export(module.exports, "mutateTextField", ()=>$6ad03e349a20a50c$export$5dd442db0007fb2d);
    const $6ad03e349a20a50c$export$5dd442db0007fb2d = (value, fieldId)=>({
            fieldId: fieldId,
            text: value,
            mutationGroup: (0, $5af824419799ac1a$export$31fd86f8f183952c)
        });
});
const $5af824419799ac1a$export$31fd86f8f183952c = 'singleLineTextFields';
parcelRegister("9cNbb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9bfbc76c8b6a999d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e7njR;
    var $7C5S0;
    var $hpV4g;
    var $jGVMX;
    const $9bfbc76c8b6a999d$var$TextAreaField = (props)=>{
        const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
        const onTextAreaChange = (e)=>{
            onChange(e.target.value);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e7njR")).default), {
            ...fieldProps,
            value: value,
            onChange: onTextAreaChange,
            onBlur: onBlur,
            isInvalid: Boolean(error),
            autoFocus: autoFocus,
            isDisabled: isReadOnly
        }));
    };
    var $9bfbc76c8b6a999d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("jGVMX")).validateString)
    })($9bfbc76c8b6a999d$var$TextAreaField);
});
parcelRegister("e7njR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ac310125020056c3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6LCpJ;
    const $ac310125020056c3$var$TextAreaEdit = (props)=>{
        const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6LCpJ")).default), {
            ...fieldProps,
            isRequired: isRequired,
            placeholder: placeholder,
            value: value,
            autoFocus: autoFocus,
            onBlur: onBlur,
            onFocus: onFocus,
            onChange: onChange,
            isInvalid: isInvalid,
            minimumRows: minimumRows,
            isDisabled: isDisabled
        });
    };
    var $ac310125020056c3$export$2e2bcd8739ae039 = $ac310125020056c3$var$TextAreaEdit;
});
parcelRegister("6LCpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$934f91ac04cc5aeb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $1qQmi;
    const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
    const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
    const $934f91ac04cc5aeb$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $934f91ac04cc5aeb$var$packageName,
        packageVersion: $934f91ac04cc5aeb$var$packageVersion
    };
    const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("1qQmi")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $934f91ac04cc5aeb$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$934f91ac04cc5aeb$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1qQmi")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("1qQmi")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $934f91ac04cc5aeb$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
    var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;
});
parcelRegister("1qQmi", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$0f8aaecc0e682a20$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$0f8aaecc0e682a20$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$0f8aaecc0e682a20$export$98856a888ef36079);
    var $f8Sb3;
    var $iaE2J;
    function $0f8aaecc0e682a20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0f8aaecc0e682a20$var$disabledRules = {
        backgroundColor: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("iaE2J")).disabledBackground,
        borderColor: (0, parcelRequire("iaE2J")).disabledBorder,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("iaE2J")).disabledTextColor
    };
    const $0f8aaecc0e682a20$var$invalidRules = {
        borderColor: (0, parcelRequire("iaE2J")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover
    };
    const $0f8aaecc0e682a20$var$backgroundColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$backgroundColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("iaE2J")).defaultBackgroundColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColor = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).transparent,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorFocus = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("iaE2J")).defaultBorderColorFocus,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$borderColorHover = {
        standard: (0, parcelRequire("iaE2J")).defaultBorderColor,
        subtle: (0, parcelRequire("iaE2J")).subtleBorderColorHover,
        none: (0, parcelRequire("iaE2J")).transparent
    };
    const $0f8aaecc0e682a20$var$lineHeightBase = 20;
    const $0f8aaecc0e682a20$var$lineHeightCompact = 16;
    const $0f8aaecc0e682a20$var$compactVerticalPadding = 2;
    const $0f8aaecc0e682a20$var$verticalPadding = 6;
    const $0f8aaecc0e682a20$var$horizontalPadding = 8;
    const $0f8aaecc0e682a20$var$transitionDuration = '0.2s';
    const $0f8aaecc0e682a20$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $0f8aaecc0e682a20$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $0f8aaecc0e682a20$export$12879c7697ed953d = 2;
    const $0f8aaecc0e682a20$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $0f8aaecc0e682a20$var$lineHeightBase * minimumRows;
        return contentHeight + $0f8aaecc0e682a20$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $0f8aaecc0e682a20$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $0f8aaecc0e682a20$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $0f8aaecc0e682a20$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorFocus[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColor[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorFocus,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColor,
                borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorFocus,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColor,
                    borderColor: $0f8aaecc0e682a20$var$disabledRules.borderColor
                }
            } : {}
        });
    const $0f8aaecc0e682a20$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("iaE2J")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $0f8aaecc0e682a20$var$disabledRules.textColor
        }
    });
    const $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $0f8aaecc0e682a20$var$backgroundColorHover[appearance],
                borderColor: $0f8aaecc0e682a20$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $0f8aaecc0e682a20$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $0f8aaecc0e682a20$var$invalidRules.backgroundColorHover,
                    borderColor: $0f8aaecc0e682a20$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$0f8aaecc0e682a20$var$invalidRules.borderColor}`
                }
            }
        });
    var $0f8aaecc0e682a20$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $0f8aaecc0e682a20$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $0f8aaecc0e682a20$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $0f8aaecc0e682a20$var$_ref2;
        return $0f8aaecc0e682a20$var$_ref;
    };
    const $0f8aaecc0e682a20$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $0f8aaecc0e682a20$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $0f8aaecc0e682a20$var$codeFontFamily : $0f8aaecc0e682a20$var$fontFamily
        });
    const $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $0f8aaecc0e682a20$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $0f8aaecc0e682a20$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$0f8aaecc0e682a20$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $0f8aaecc0e682a20$var$lineHeightBase / 14
            }
        });
    };
    const $0f8aaecc0e682a20$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out,
               border-color ${$0f8aaecc0e682a20$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$0f8aaecc0e682a20$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $0f8aaecc0e682a20$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$staticStyles, $0f8aaecc0e682a20$var$borderPaddingAndHeightStyles(minimumRows, appearance), $0f8aaecc0e682a20$var$resizeStyle(resize), $0f8aaecc0e682a20$var$borderStyle(appearance), $0f8aaecc0e682a20$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $0f8aaecc0e682a20$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($0f8aaecc0e682a20$var$bgAndBorderColorStyles(appearance), $0f8aaecc0e682a20$var$hoverBackgroundAndBorderStyles(appearance), $0f8aaecc0e682a20$var$placeholderStyles, {
            color: (0, parcelRequire("iaE2J")).textColor,
            '&:disabled': {
                color: $0f8aaecc0e682a20$var$disabledRules.textColor
            }
        });
});
parcelRegister("iaE2J", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$f788b902061573a8$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$f788b902061573a8$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$f788b902061573a8$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$f788b902061573a8$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$f788b902061573a8$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$f788b902061573a8$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$f788b902061573a8$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$f788b902061573a8$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$f788b902061573a8$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$f788b902061573a8$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$f788b902061573a8$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$f788b902061573a8$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$f788b902061573a8$export$f4d082c200a4b4b8);
    const $f788b902061573a8$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $f788b902061573a8$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $f788b902061573a8$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $f788b902061573a8$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`;
    const $f788b902061573a8$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $f788b902061573a8$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $829f609a65d26a98$export$e655ef011c4aa1a2)})`;
    const $f788b902061573a8$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $f788b902061573a8$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $f788b902061573a8$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $f788b902061573a8$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $f788b902061573a8$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`;
    const $f788b902061573a8$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`;
    const $f788b902061573a8$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("7svvp", function(module, exports) {
    $parcel$export(module.exports, "mutateTextAreaField", ()=>$93a5f312149817bd$export$26988cd8ac7fed9b);
    const $93a5f312149817bd$export$26988cd8ac7fed9b = (value, fieldId)=>({
            fieldId: fieldId,
            mutationGroup: (0, $4119cc28f5aed65e$export$31fd86f8f183952c),
            richText: {
                wikiText: value
            }
        });
});
const $4119cc28f5aed65e$export$31fd86f8f183952c = 'richTextFields';
parcelRegister("b3x8f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$097d081b3402af20$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hMKLn;
    const $097d081b3402af20$var$UrlField = (props)=>{
        const { width: width = 350, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMKLn")).default), {
            type: "url",
            width: width,
            ...rest
        });
    };
    var $097d081b3402af20$export$2e2bcd8739ae039 = $097d081b3402af20$var$UrlField;
});
parcelRegister("d2fRu", function(module, exports) {
    $parcel$export(module.exports, "mutateUrlField", ()=>$4284e73cbca56615$export$68f54af506df5feb);
    const $4284e73cbca56615$export$68f54af506df5feb = (url, fieldId)=>{
        const mutatedValue = {
            fieldId: fieldId,
            mutationGroup: (0, $cfa45186c89d86bf$export$31fd86f8f183952c)
        };
        mutatedValue.url = url;
        return mutatedValue;
    };
});
const $cfa45186c89d86bf$export$31fd86f8f183952c = 'urlFields';
parcelRegister("em1U0", function(module, exports) {
    $parcel$export(module.exports, "transformToOptionValue", ()=>$657085c715b654ca$export$d1480328df7a42bf);
    $parcel$export(module.exports, "transformToOptions", ()=>$657085c715b654ca$export$899758961952c638);
    $parcel$export(module.exports, "transformToParentChildOptionMap", ()=>$657085c715b654ca$export$575da772c90849b8);
    $parcel$export(module.exports, "transformToServerValue", ()=>$657085c715b654ca$export$6f0c6eec5b71d787);
    var $gJBT6 = parcelRequire("gJBT6");
    const $657085c715b654ca$export$d1480328df7a42bf = (serverValue)=>{
        if (!serverValue) return null;
        const { id: id, value: value, child: child } = serverValue;
        return {
            value: id,
            label: value,
            child: child && {
                value: child.id,
                label: child.value
            }
        };
    };
    const $657085c715b654ca$export$899758961952c638 = (0, ($parcel$interopDefault($gJBT6)))((values)=>values.map(({ id: id, value: value })=>({
                value: id,
                label: value
            })));
    const $657085c715b654ca$export$575da772c90849b8 = (0, ($parcel$interopDefault($gJBT6)))((values)=>values.reduce((acc, { id: id, children: children })=>{
            acc[id] = children ? $657085c715b654ca$export$899758961952c638(children) : [];
            return acc;
        }, {}));
    const $657085c715b654ca$export$6f0c6eec5b71d787 = (option)=>{
        if (!option) return null;
        const { label: label, value: value } = option;
        const child = option.child || undefined;
        return {
            id: value,
            value: label,
            child: child && {
                id: child.value,
                value: child.label
            }
        };
    };
});
parcelRegister("feVbn", function(module, exports) {
    $parcel$export(module.exports, "transformSuggestions", ()=>$ca52109385ad0f99$export$1d0ee4320c26fb60);
    $parcel$export(module.exports, "mapEpicLinkOptionToData", ()=>$ca52109385ad0f99$export$2d8fd73a87ecc4de);
    var $5uXOq = parcelRequire("5uXOq");
    var $heWHN;
    var $f1csm;
    var $fUop9;
    const $ca52109385ad0f99$export$b00899e73680c477 = (color)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fUop9")).ColorPatch), {
            color: color
        });
    const $ca52109385ad0f99$export$9227063fc962e54 = (epic)=>{
        const color = (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[epic.issueColor.key];
        return {
            color: color,
            label: epic.summary,
            value: epic.key,
            id: epic.id.toString(),
            description: epic.key,
            elemBefore: $ca52109385ad0f99$export$b00899e73680c477(color),
            filterValues: [
                epic.summary,
                epic.key
            ],
            isDone: epic.done
        };
    };
    const $ca52109385ad0f99$export$1d0ee4320c26fb60 = (response, formatMessage)=>{
        const epicLists = response.values || [];
        const epicLink = [
            {
                label: formatMessage((0, (0, parcelRequire("f1csm")).default).allEpics),
                options: epicLists.map($ca52109385ad0f99$export$9227063fc962e54)
            }
        ];
        return epicLink;
    };
    const $ca52109385ad0f99$export$2d8fd73a87ecc4de = ({ value: value })=>value;
});
parcelRegister("f1csm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5ef5ab582b8f652$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5ef5ab582b8f652$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholder: {
            "id": "issue-field-epic-link.edit.placeholder",
            "defaultMessage": "Select Epic"
        },
        noOptionsMessage: {
            "id": "issue-field-epic-link.edit.no-options-message",
            "defaultMessage": "No matches found"
        },
        failedFetch: {
            "id": "issue-field-epic-link.edit.failed-fetch",
            "defaultMessage": "Search failed. Please try again."
        },
        loadingMessage: {
            "id": "issue-field-epic-link.edit.loading-message",
            "defaultMessage": "Searching..."
        },
        allEpics: {
            "id": "issue-field-epic-link.edit.all-epics",
            "defaultMessage": "All epics"
        }
    });
});
parcelRegister("fUop9", function(module, exports) {
    $parcel$export(module.exports, "ColorPatch", ()=>$8331d8726710f714$export$a3f78762e82c8733);
    var $47bDC = parcelRequire("47bDC");
    var $gwIPs;
    var $heWHN;
    const $8331d8726710f714$export$a3f78762e82c8733 = (0, $47bDC.default).div.withConfig({
        componentId: "p05qyv-0"
    })((props)=>({
            width: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.5}px`,
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.5}px`,
            borderRadius: `${(0, (0, parcelRequire("gwIPs")).gridSize) / 2}px`,
            backgroundColor: (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[props.color]
        }));
});
parcelRegister("UwVOJ", function(module, exports) {
    $parcel$export(module.exports, "mapOrganizationOptionsToData", ()=>$f0a92a32c018d992$export$aa1a3b6fac8d058a);
    $parcel$export(module.exports, "mapDataToOrganizationOptions", ()=>$f0a92a32c018d992$export$bb720a783a78b0f4);
    const $f0a92a32c018d992$export$aa1a3b6fac8d058a = (options)=>options.map(({ value: value })=>Number.parseInt(value, 10));
    const $f0a92a32c018d992$export$bb720a783a78b0f4 = (data)=>data.map(({ id: id, name: name })=>({
                label: name,
                value: `${id}`
            }));
});
parcelRegister("deSKa", function(module, exports) {
    $parcel$export(module.exports, "mapDataToOptions", ()=>$19080530e7ffbd37$export$99a866ffa3af7d8b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$19080530e7ffbd37$export$fc800909123977f3);
    const $19080530e7ffbd37$export$4c05e2584b34e4d8 = (issueTypes)=>{
        const transformedIssueTypes = {};
        issueTypes.forEach((issueType)=>{
            const { id: id, iconUrl: iconUrl } = issueType;
            transformedIssueTypes[id] = iconUrl;
        });
        return transformedIssueTypes;
    };
    const $19080530e7ffbd37$export$227473965d2e27db = (projects)=>{
        const transformedProjects = {};
        projects.forEach((project)=>{
            const { id: id, key: key } = project;
            transformedProjects[id] = key;
        });
        return transformedProjects;
    };
    const $19080530e7ffbd37$export$99a866ffa3af7d8b = (response)=>{
        const transformedIssueTypes = $19080530e7ffbd37$export$4c05e2584b34e4d8(response.issueTypes);
        const transformedProjects = $19080530e7ffbd37$export$227473965d2e27db(response.projects);
        const transformedResponse = response.issues.map((issue)=>{
            const { issueKey: issueKey, issueSummary: issueSummary, issueTypeId: issueTypeId, projectId: projectId } = issue;
            const projectKey = transformedProjects[projectId];
            return {
                label: `${projectKey}-${issueKey} ${issueSummary}`,
                value: `${projectKey}-${issueKey}`,
                iconUrl: transformedIssueTypes[String(issueTypeId)]
            };
        });
        return transformedResponse;
    };
    const $19080530e7ffbd37$export$fc800909123977f3 = (option)=>option.value;
});
parcelRegister("66d24", function(module, exports) {
    $parcel$export(module.exports, "mapOptionToResolutionOption", ()=>$dbc7baed5320bad0$export$f915ce0689a595ca);
    $parcel$export(module.exports, "mapResolutionOptionToOption", ()=>$dbc7baed5320bad0$export$203456290cf27045);
    $parcel$export(module.exports, "mapAndFilterResolutionOptions", ()=>$dbc7baed5320bad0$export$38929c8b23814052);
    const $dbc7baed5320bad0$export$f915ce0689a595ca = (option)=>({
            id: option.value,
            name: option.label
        });
    const $dbc7baed5320bad0$export$203456290cf27045 = (option)=>({
            value: option.id,
            label: option.name
        });
    const $dbc7baed5320bad0$export$2ad0f62ebcc9982d = (options)=>options.map((option)=>$dbc7baed5320bad0$export$203456290cf27045(option));
    const $dbc7baed5320bad0$export$38929c8b23814052 = (currentOption, options)=>{
        if (!currentOption) return $dbc7baed5320bad0$export$2ad0f62ebcc9982d(options);
        return options.reduce((resolutionOptions, option)=>{
            if (option.id !== currentOption.id) resolutionOptions.push($dbc7baed5320bad0$export$203456290cf27045(option));
            return resolutionOptions;
        }, []);
    };
});
parcelRegister("5pYli", function(module, exports) {
    $parcel$export(module.exports, "getOptionLabel", ()=>$5c5f842bdc3f187c$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$5c5f842bdc3f187c$export$40be908210c5a79c);
    $parcel$export(module.exports, "convertRolesToCurrentRole", ()=>$5c5f842bdc3f187c$export$dede06c97eeff392);
    $parcel$export(module.exports, "transformRolesToArrayIfNull", ()=>$5c5f842bdc3f187c$export$394ee8daa9411a86);
    $parcel$export(module.exports, "mapRoleToRestrictionValue", ()=>$5c5f842bdc3f187c$export$3bb7b17fecda53ae);
    $parcel$export(module.exports, "isUserRoleIncludedInRestrictedRoles", ()=>$5c5f842bdc3f187c$export$e3d70e1822e7e331);
    var $cYhG6 = parcelRequire("cYhG6");
    const $5c5f842bdc3f187c$export$dac6ace3020563ca = (role)=>role.name;
    const $5c5f842bdc3f187c$export$40be908210c5a79c = (role)=>role.roleId;
    const $5c5f842bdc3f187c$export$dede06c97eeff392 = (selectedRoles, allRoles)=>{
        const transformedCurrentRoles = [];
        selectedRoles.forEach((restriction)=>{
            const matchedRestriction = allRoles.find((role)=>role.roleId === restriction.roleId);
            matchedRestriction && transformedCurrentRoles.push(matchedRestriction);
        });
        return transformedCurrentRoles;
    };
    const $5c5f842bdc3f187c$export$394ee8daa9411a86 = (roles, onChange)=>onChange(roles || []);
    const $5c5f842bdc3f187c$export$3bb7b17fecda53ae = (roles)=>({
            projectrole: roles.map(({ roleId: roleId })=>({
                    restrictionValue: roleId
                }))
        });
    const $5c5f842bdc3f187c$export$e3d70e1822e7e331 = (selectedRoles, rolesWithCurrentUserRole)=>{
        if (selectedRoles.length === 0) return true;
        const selectedRoleWithCurrentUserRoles = (0, ($parcel$interopDefault($cYhG6)))(selectedRoles, rolesWithCurrentUserRole, 'roleId');
        return Boolean(selectedRoleWithCurrentUserRoles.length);
    };
});
parcelRegister("cYhG6", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $9dThv = parcelRequire("9dThv");
    var $bxDef = parcelRequire("bxDef");
    var $g7i7g = parcelRequire("g7i7g");
    var $d9Hx6 = parcelRequire("d9Hx6");
    var $hYfgW = parcelRequire("hYfgW");
    var $026fe246c8ca749e$var$intersectionBy = $g7i7g(function(arrays) {
        var iteratee = $hYfgW(arrays), mapped = $1nIHN(arrays, $d9Hx6);
        if (iteratee === $hYfgW(mapped)) iteratee = undefined;
        else mapped.pop();
        return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped, $bxDef(iteratee, 2)) : [];
    });
    module.exports = $026fe246c8ca749e$var$intersectionBy;
});
parcelRegister("9dThv", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $6b7035a795ecd274$var$nativeMin = Math.min;
    function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
        while(othIndex--){
            var array = arrays[othIndex];
            if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
            maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
        }
        array = arrays[0];
        var index = -1, seen = caches[0];
        outer: while(++index < length && result.length < maxLength){
            var value = array[index], computed = iteratee ? iteratee(value) : value;
            value = comparator || value !== 0 ? value : 0;
            if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
                othIndex = othLength;
                while(--othIndex){
                    var cache = caches[othIndex];
                    if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                }
                if (seen) seen.push(computed);
                result.push(value);
            }
        }
        return result;
    }
    module.exports = $6b7035a795ecd274$var$baseIntersection;
});
parcelRegister("d9Hx6", function(module, exports) {
    var $f3SOL = parcelRequire("f3SOL");
    function $993de25d5a02863a$var$castArrayLikeObject(value) {
        return $f3SOL(value) ? value : [];
    }
    module.exports = $993de25d5a02863a$var$castArrayLikeObject;
});
parcelRegister("162ej", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateOrganizationField", ()=>$350bd0242f6ced06$export$589d64992e8dd3db);
    var $5uXOq = parcelRequire("5uXOq");
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $lfTZh;
    var $cipGj;
    var $aPcig;
    const $350bd0242f6ced06$var$OrganizationField = (props)=>{
        const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps } } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "organization-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cipGj")).LazyEditView), {
            ...fieldProps,
            onChange: onChange,
            value: value
        })));
    };
    const $350bd0242f6ced06$export$589d64992e8dd3db = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("aPcig")).validateOrganizationField)
    })($350bd0242f6ced06$var$OrganizationField);
});
parcelRegister("cipGj", function(module, exports) {
    $parcel$export(module.exports, "LazyEditView", ()=>$ae9893d99fa46ac0$export$a17259a78f401488);
    var $kxZPA;
    const $ae9893d99fa46ac0$export$a17259a78f401488 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("9fbu8")).then((module)=>module.EditView), {
        moduleId: "./src/packages/servicedesk/customer-service/custom-fields/src/common/ui/organization-edit-view/index.tsx"
    });
});
parcelRegister("9fbu8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4UkOW").then(()=>parcelRequire('2o1IU'));
});
parcelRegister("aPcig", function(module, exports) {
    $parcel$export(module.exports, "mapOrganizationOptionToData", ()=>$f08aaf4476b255ad$export$156d062414dbdd98);
    $parcel$export(module.exports, "validateOrganizationField", ()=>$f08aaf4476b255ad$export$90b32914fc328a85);
    var $bGrWH;
    const $f08aaf4476b255ad$export$156d062414dbdd98 = (option)=>option.value;
    const $f08aaf4476b255ad$export$608983f592de28e3 = (selectedOrganization, fieldId)=>({
            organizationField: {
                fieldId: fieldId,
                organization: {
                    organizationId: selectedOrganization.value
                }
            }
        });
    const $f08aaf4476b255ad$export$90b32914fc328a85 = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
parcelRegister("4nSAG", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateEntitlementField", ()=>$32ade2dcdc4f5704$export$99314741193b044b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $bGEod;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $lfTZh;
    var $iXVV6;
    var $5oFIy;
    var $ce4pa;
    var $dnjeJ;
    var $kAldV;
    var $iSKpR;
    var $57aXd;
    const $32ade2dcdc4f5704$export$48549219ad5358dc = (props)=>{
        const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated } = props;
        const { getFormState: getFormState } = contextAndValuesOfIssueBeingCreated;
        const formState = getFormState();
        const reporter = formState?.values?.reporter;
        const [currentReporter, setCurrentReporter] = (0, $5uXOq.useState)(reporter);
        (0, $5uXOq.useEffect)(()=>{
            if (reporter?.id !== currentReporter?.id) {
                onChange(null);
                setCurrentReporter(reporter);
            }
        }, [
            reporter,
            currentReporter,
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "entitlement-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "entitlementsFieldGIC",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: {
                entitlementsFieldViewed: 'GIC'
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kAldV")).LazyEditView), {
            ...fieldProps,
            isInvalid: Boolean(error),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onChange: onChange,
            value: value,
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            reporterId: reporter?.id,
            spacing: "default"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ce4pa")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("iSKpR")).entitlementFieldGicMountExperience)
        })));
    };
    const $32ade2dcdc4f5704$export$f13f32889402194 = (props)=>{
        (0, (0, parcelRequire("dnjeJ")).useUFOComponentExperience)((0, (0, parcelRequire("iSKpR")).entitlementFieldGicMountExperience));
        const onError = (_, error)=>{
            (0, (0, parcelRequire("iSKpR")).entitlementFieldGicMountExperience).failure();
            throw error;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "entitlementField",
            packageName: "jiraServicedeskCustomerServiceEntitlementsField",
            onError: onError,
            teamName: "boysenberry",
            sendToPrivacyUnsafeSplunk: true,
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($32ade2dcdc4f5704$export$48549219ad5358dc, props));
    };
    const $32ade2dcdc4f5704$export$99314741193b044b = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("57aXd")).validateEntitlementField)
    })($32ade2dcdc4f5704$export$f13f32889402194);
});
parcelRegister("dnjeJ", function(module, exports) {
    $parcel$export(module.exports, "useUFOComponentExperience", ()=>$44448c24118cb590$export$30ab340faaed55d4);
    var $5uXOq = parcelRequire("5uXOq");
    const $44448c24118cb590$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                experience.abort();
            };
        }, []);
        $44448c24118cb590$var$useConstructor(()=>experience.start());
        return null;
    };
});
parcelRegister("kAldV", function(module, exports) {
    $parcel$export(module.exports, "LazyEditView", ()=>$eed6115d0b450999$export$a17259a78f401488);
    var $kxZPA;
    const $eed6115d0b450999$export$a17259a78f401488 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("fzjkw")).then((module)=>module.EditView), {
        moduleId: "./src/packages/servicedesk/customer-service/entitlements-field/src/common/ui/edit-view/index.tsx"
    });
});
parcelRegister("fzjkw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cHlBI").then(()=>parcelRequire('b2rYE'));
});
parcelRegister("iSKpR", function(module, exports) {
    $parcel$export(module.exports, "entitlementFieldGicMountExperience", ()=>$1c7916d9adea851e$export$588fc8ac7a187272);
    $parcel$export(module.exports, "entitlementFieldDataFetchExperience", ()=>$1c7916d9adea851e$export$7f9aebf7c6d536d6);
    $parcel$export(module.exports, "entitlementFieldIssueViewMountExperience", ()=>$1c7916d9adea851e$export$66e03de8aa0e97b8);
    $parcel$export(module.exports, "editEntitlementFieldIssueViewExperience", ()=>$1c7916d9adea851e$export$6889e91b24599276);
    var $atdLB;
    var $duUGa;
    const $1c7916d9adea851e$export$588fc8ac7a187272 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cs-entitlement-custom-field-gic-mount', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
    const $1c7916d9adea851e$export$7f9aebf7c6d536d6 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cs-entitlement-custom-field-data-fetch', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
    const $1c7916d9adea851e$export$66e03de8aa0e97b8 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-mount', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $1c7916d9adea851e$export$6889e91b24599276 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-edit', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).InlineResult
    });
});
parcelRegister("57aXd", function(module, exports) {
    $parcel$export(module.exports, "mapEntitlementOptionToData", ()=>$8355eec375a084ab$export$1c1e5611b1980840);
    $parcel$export(module.exports, "validateEntitlementField", ()=>$8355eec375a084ab$export$3f9370506eb4fa6c);
    var $bGrWH;
    const $8355eec375a084ab$export$1c1e5611b1980840 = (option)=>option.value;
    const $8355eec375a084ab$export$3b43598c7abb6d70 = (selectedEntitlement, fieldId)=>({
            entitlementField: {
                fieldId: fieldId,
                entitlement: {
                    entitlementId: `${selectedEntitlement.value}`
                }
            }
        });
    const $8355eec375a084ab$export$3f9370506eb4fa6c = (value, isRequired)=>{
        if (isRequired) {
            if (!value) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
parcelRegister("7jsR9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4610a791cf117fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $69KT5 = parcelRequire("69KT5");
    var $qfj8c;
    var $4R6GH;
    var $koVbs;
    var $bGrWH;
    var $azL7v;
    var $iUFy5;
    var $cjoqp;
    const $d4610a791cf117fa$export$f10e1476c0ddb959 = ()=>(0, $5uXOq.useState)(false);
    const $d4610a791cf117fa$var$AttachmentsField = (props)=>{
        const { view: view } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const { fieldId: fieldId, fieldName: fieldName, description: description, isRequired: isRequired, additionalData: additionalData, selectedProject: selectedProject, onInProgressChange: onInProgressChange, additionalData: { maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize }, defaultValue: defaultValue, isCollapsed: isCollapsed } = props;
        const { mediaContext: mediaContext } = additionalData;
        const uploadToken = mediaContext?.uploadToken;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [attachmentSizeValidation, onAttachmentSizeValidation] = $d4610a791cf117fa$export$f10e1476c0ddb959();
        let attachmentUploadContext;
        if (uploadToken) attachmentUploadContext = {
            clientId: uploadToken.clientId,
            serviceHost: uploadToken.endpointUrl,
            collection: uploadToken.targetCollection,
            token: uploadToken.token
        };
        const dropzoneContainerId = view === 'modal' ? (0, (0, parcelRequire("bGrWH")).FORM_DROPZONE_CONTAINER_ID) : (0, (0, parcelRequire("bGrWH")).MINIMISED_DROPZONE_CONTAINER_ID);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("azL7v")).default), {
            fieldId: fieldId,
            fieldName: fieldName,
            description: description,
            isRequired: isRequired,
            mediaUploadContext: attachmentUploadContext,
            projectId: selectedProject?.value || null,
            onInProgressChange: onInProgressChange,
            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
            onAttachmentSizeValidation: onAttachmentSizeValidation,
            dropzoneContainerId: dropzoneContainerId,
            shouldScrollIntoViewOnUploadStart: true,
            defaultValue: defaultValue,
            ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                isCollapsed: isCollapsed
            }
        }), !attachmentUploadContext && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, (0, parcelRequire("cjoqp")).default).missingToken)), attachmentSizeValidation && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, (0, parcelRequire("cjoqp")).default).attachmentSizeLimitCheck), " (", (0, ($parcel$interopDefault($69KT5)))(maxAllowedTotalAttachmentsSize, {
            unitSeparator: ' '
        }), ")."));
    };
    var $d4610a791cf117fa$export$2e2bcd8739ae039 = $d4610a791cf117fa$var$AttachmentsField;
});
parcelRegister("69KT5", function(module, exports) {
    'use strict';
    module.exports = $47b7f435b4828cd6$var$bytes;
    module.exports.format = $47b7f435b4828cd6$var$format;
    module.exports.parse = $47b7f435b4828cd6$var$parse;
    var $47b7f435b4828cd6$var$formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
    var $47b7f435b4828cd6$var$formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
    var $47b7f435b4828cd6$var$map = {
        b: 1,
        kb: 1024,
        mb: 1048576,
        gb: 1073741824,
        tb: Math.pow(1024, 4),
        pb: Math.pow(1024, 5)
    };
    var $47b7f435b4828cd6$var$parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
    function $47b7f435b4828cd6$var$bytes(value, options) {
        if (typeof value === 'string') return $47b7f435b4828cd6$var$parse(value);
        if (typeof value === 'number') return $47b7f435b4828cd6$var$format(value, options);
        return null;
    }
    function $47b7f435b4828cd6$var$format(value, options) {
        if (!Number.isFinite(value)) return null;
        var mag = Math.abs(value);
        var thousandsSeparator = options && options.thousandsSeparator || '';
        var unitSeparator = options && options.unitSeparator || '';
        var decimalPlaces = options && options.decimalPlaces !== undefined ? options.decimalPlaces : 2;
        var fixedDecimals = Boolean(options && options.fixedDecimals);
        var unit = options && options.unit || '';
        if (!unit || !$47b7f435b4828cd6$var$map[unit.toLowerCase()]) {
            if (mag >= $47b7f435b4828cd6$var$map.pb) unit = 'PB';
            else if (mag >= $47b7f435b4828cd6$var$map.tb) unit = 'TB';
            else if (mag >= $47b7f435b4828cd6$var$map.gb) unit = 'GB';
            else if (mag >= $47b7f435b4828cd6$var$map.mb) unit = 'MB';
            else if (mag >= $47b7f435b4828cd6$var$map.kb) unit = 'KB';
            else unit = 'B';
        }
        var val = value / $47b7f435b4828cd6$var$map[unit.toLowerCase()];
        var str = val.toFixed(decimalPlaces);
        if (!fixedDecimals) str = str.replace($47b7f435b4828cd6$var$formatDecimalsRegExp, '$1');
        if (thousandsSeparator) str = str.split('.').map(function(s, i) {
            return i === 0 ? s.replace($47b7f435b4828cd6$var$formatThousandsRegExp, thousandsSeparator) : s;
        }).join('.');
        return str + unitSeparator + unit;
    }
    function $47b7f435b4828cd6$var$parse(val) {
        if (typeof val === 'number' && !isNaN(val)) return val;
        if (typeof val !== 'string') return null;
        var results = $47b7f435b4828cd6$var$parseRegExp.exec(val);
        var floatValue;
        var unit = 'b';
        if (!results) {
            floatValue = parseInt(val, 10);
            unit = 'b';
        } else {
            floatValue = parseFloat(results[1]);
            unit = results[4].toLowerCase();
        }
        if (isNaN(floatValue)) return null;
        return Math.floor($47b7f435b4828cd6$var$map[unit] * floatValue);
    }
});
parcelRegister("azL7v", function(module, exports) {
    $parcel$export(module.exports, "AttachmentsField", ()=>$e446c7b6c6df08e3$export$f7c49e57ef98664f);
    $parcel$export(module.exports, "default", ()=>$e446c7b6c6df08e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $k9tnV;
    var $eCeGD;
    var $aPRJS;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $bGrWH;
    var $3F8e9;
    var $lySs6;
    var $6UFK0;
    var $lfTZh;
    var $hpV4g;
    var $c431P;
    var $bWtQ8;
    const $e446c7b6c6df08e3$export$f7c49e57ef98664f = (props)=>{
        const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, (0, parcelRequire("lySs6")).default)({
            mediaUploadContext: mediaUploadContext,
            projectId: projectId,
            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
            onAttachmentSizeValidation: onAttachmentSizeValidation,
            attachmentCustomUploadURL: attachmentCustomUploadURL
        });
        const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
        (0, $5uXOq.useEffect)(()=>{
            if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
                const currentAttachments = [];
                setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: false
                    }))));
                setDefaultValueInitialized(true);
            }
        }, [
            setAttachments,
            defaultValue,
            isDefaultValueInitialized,
            setDefaultValueInitialized
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let shouldCallOnChange = false;
            const isValueAnArray = Array.isArray(value);
            if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
            if (!isValueAnArray && files.length) shouldCallOnChange = true;
            if (shouldCallOnChange) onChange(files);
        }, [
            files,
            onChange,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (value && value.shouldClear === true) setAttachments([]);
        }, [
            setAttachments,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onInProgressChange && onInProgressChange(isUploading);
        }, [
            isUploading,
            onInProgressChange
        ]);
        if (!mediaUploadContext) return null;
        const onAttachmentUploadStart = (uploadStartPayload)=>{
            onUploadStart(uploadStartPayload);
            if (shouldScrollIntoViewOnUploadStart) {
                const fieldElement = document.getElementById((0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId));
                if (fieldElement) (0, (0, parcelRequire("k9tnV")).default)(fieldElement, (0, (0, parcelRequire("bGrWH")).DEFAULT_SCROLL_OPTIONS));
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$FieldDropzoneContainer, {
            id: (0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneArea, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aPRJS"))))), {
            label: "Upload",
            primaryColor: `var(--ds-icon, ${(0, $829f609a65d26a98$exports).N100})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($e446c7b6c6df08e3$var$BrowseDropzoneAreaText, null, `${formatMessage((0, (0, parcelRequire("c431P")).default).dropzone)}`, "\xa0"), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6UFK0")).default), {
            ...fieldProps,
            mediaClientConfig: mediaClientConfig,
            uploadConfig: uploadConfig,
            onUploadError: onUploadError,
            onUploadStart: onAttachmentUploadStart,
            onUploadEnd: onUploadEnd,
            dropzoneContainer: document.getElementById(dropzoneContainerId || (0, (0, parcelRequire("bWtQ8")).getFieldDropZoneContainerID)(fieldId))
        }, ({ setIsBrowserOpen: setIsBrowserOpen })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $e446c7b6c6df08e3$var$browseButtonStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
                onClick: ()=>setIsBrowserOpen(true),
                "aria-label": formatMessage((0, (0, parcelRequire("c431P")).default).browseAriaLabel)
            }, formatMessage((0, (0, parcelRequire("c431P")).default).browse)))))), files.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e446c7b6c6df08e3$var$mediaContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "attachments-filmstrip-view",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3F8e9")).AsyncAttachmentsFilmstripView), {
            mediaClientConfig: mediaClientConfig,
            files: files,
            onRemoveFile: onRemoveFile,
            collectionName: mediaUploadContext.collection
        }))));
    };
    var $e446c7b6c6df08e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("bWtQ8")).validateAttachment)
    })($e446c7b6c6df08e3$export$f7c49e57ef98664f);
    const $e446c7b6c6df08e3$var$FieldDropzoneContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _1yt4utpp _189et94y _1dqogq9o _1h6dq6nq _syaz1e9r",
                __cmplp.className
            ])
        });
    });
    const $e446c7b6c6df08e3$var$mediaContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.050'
    });
    const $e446c7b6c6df08e3$var$browseButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075'
    });
    const $e446c7b6c6df08e3$var$BrowseDropzoneArea = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $e446c7b6c6df08e3$var$BrowseDropzoneAreaText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aPRJS", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
    function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7e385a40dadea6dc$var$UploadIcon = (props)=>$7e385a40dadea6dc$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
        }, props, {
            newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
        }));
    $7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
    var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;
});
parcelRegister("ePJ5X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $acc8cf07db1d2dba$var$_UNSAFE_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>$acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m4.429 3.18.217.718.358-.108.129-.35zm6.25.81-.723.2.151.55h.572zM8 8.75l.53-.53a.75.75 0 0 0-1.06 0zm2.405-5.754.723-.2zM2.5 6.5v-.482H1V6.5zm1.408-2.378.738-.224-.434-1.435-.738.223zm1.225-.683.157-.427-1.408-.517-.157.427zm4.549-.244.274.995 1.446-.398-.274-.995zm.997 1.546h1.191v-1.5h-1.19zM13.5 6.37v.13H15v-.13zm-7.97 5.91 3-3-1.06-1.06-3 3zm1.94-3 3 3 1.06-1.061-3-3zm-.22-.031V16h1.5V9.25zM13.5 6.5A1.5 1.5 0 0 1 12 8v1.5a3 3 0 0 0 3-3zm-6.044-5a2.31 2.31 0 0 1 2.226 1.695l1.446-.398A3.81 3.81 0 0 0 7.456 0zM5.29 3.012A2.31 2.31 0 0 1 7.456 1.5V0a3.81 3.81 0 0 0-3.574 2.495zm6.58 1.729c.9 0 1.63.73 1.63 1.63H15a3.13 3.13 0 0 0-3.13-3.13zM2.5 6.018a1.98 1.98 0 0 1 1.408-1.896l-.434-1.436A3.48 3.48 0 0 0 1 6.018zM4 8a1.5 1.5 0 0 1-1.5-1.5H1a3 3 0 0 0 3 3z"/>`
        }, props));
    $acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
    var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;
});
parcelRegister("3F8e9", function(module, exports) {
    $parcel$export(module.exports, "AsyncAttachmentsFilmstripView", ()=>$eb0c63a29297e8e6$export$85605b8f3b532b83);
    var $kxZPA;
    const $eb0c63a29297e8e6$export$85605b8f3b532b83 = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("6tE5l")).then((module)=>module.AttachmentsFilmstripView), {
        moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
    });
});
parcelRegister("6tE5l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kiYwA")
    ]).then(()=>parcelRequire('4MZE8'));
});
parcelRegister("lySs6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25872ff6af438731$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $f4KvR;
    const $25872ff6af438731$var$useAttachments = (attachmentArgs)=>{
        const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
        if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
        const [attachments, setAttachments] = (0, $5uXOq.useState)([]);
        const [files, setFiles] = (0, $5uXOq.useState)([]);
        const [isUploading, setUploading] = (0, $5uXOq.useState)(false);
        const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $5uXOq.useState)(false);
        const stateRef = (0, $5uXOq.useRef)();
        stateRef.current = files;
        (0, $5uXOq.useEffect)(()=>{
            setFiles(attachments.map((attachment)=>attachment.mediaFile));
            setUploading(attachments.some((attachment)=>attachment.isUploading));
        }, [
            attachments
        ]);
        const mediaClientConfig = (0, $5uXOq.useMemo)(()=>({
                authProvider: ()=>Promise.resolve({
                        baseUrl: mediaUploadContext.serviceHost,
                        clientId: mediaUploadContext.clientId,
                        token: mediaUploadContext.token
                    }),
                useSha256ForUploads: true
            }), [
            mediaUploadContext
        ]);
        const uploadConfig = (0, $5uXOq.useMemo)(()=>({
                uploadParams: {
                    collection: mediaUploadContext.collection
                }
            }), [
            mediaUploadContext.collection
        ]);
        const onUploadStart = (0, $5uXOq.useCallback)((uploadStartPayload)=>{
            const currentFiles = stateRef.current ? stateRef.current : [];
            const totalAttachments = [
                ...uploadStartPayload.files,
                ...currentFiles
            ];
            if (maxAllowedTotalAttachmentsSize === undefined || (0, (0, parcelRequire("f4KvR")).getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
                if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
                setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                            mediaFile: mediaFile,
                            isUploading: true
                        }))));
            } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
        }, [
            onAttachmentSizeValidation,
            maxAllowedTotalAttachmentsSize
        ]);
        const onUploadError = (0, $5uXOq.useCallback)((uploadError)=>{
            setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
        }, []);
        const onUploadEnd = (0, $5uXOq.useCallback)((uploadEndPayload)=>{
            (async ()=>{
                const mediaFile = uploadEndPayload.file;
                if (!(0, ($parcel$interopDefault($hGgHi)))(projectId)) await (0, (0, parcelRequire("f4KvR")).copyToAttachment)({
                    id: projectId,
                    isProjectId: true,
                    mediaFile: mediaFile,
                    attachmentCustomUploadURL: attachmentCustomUploadURL
                });
                else if (!(0, ($parcel$interopDefault($hGgHi)))(issueId)) await (0, (0, parcelRequire("f4KvR")).copyToAttachment)({
                    id: issueId,
                    isProjectId: false,
                    mediaFile: mediaFile,
                    attachmentCustomUploadURL: attachmentCustomUploadURL
                });
                setAttachments((currentAttachments)=>{
                    const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                    if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                        {
                            mediaFile: mediaFile,
                            isUploading: false
                        }
                    ]);
                    return currentAttachments;
                });
            })();
        }, [
            issueId,
            projectId,
            attachmentCustomUploadURL
        ]);
        const onRemoveFile = (fileToBeRemoved)=>{
            setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
        };
        return {
            files: files,
            setAttachments: setAttachments,
            onUploadStart: onUploadStart,
            onUploadError: onUploadError,
            mediaClientConfig: mediaClientConfig,
            uploadConfig: uploadConfig,
            onRemoveFile: onRemoveFile,
            onUploadEnd: onUploadEnd,
            isUploading: isUploading,
            isDefaultValueInitialized: isDefaultValueInitialized,
            setDefaultValueInitialized: setDefaultValueInitialized
        };
    };
    var $25872ff6af438731$export$2e2bcd8739ae039 = $25872ff6af438731$var$useAttachments;
});
parcelRegister("f4KvR", function(module, exports) {
    $parcel$export(module.exports, "copyToAttachment", ()=>$ac4c15282d67ab83$export$b9a44fdbc3de4b85);
    $parcel$export(module.exports, "getAttachmentsSize", ()=>$ac4c15282d67ab83$export$ed1597b81cfdb5f6);
    var $eusud;
    const $ac4c15282d67ab83$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
    const $ac4c15282d67ab83$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
    const $ac4c15282d67ab83$export$b9a44fdbc3de4b85 = async (props)=>{
        const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
        const { attachmentId: attachmentId } = await (0, (0, parcelRequire("eusud")).performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $ac4c15282d67ab83$export$a7455b0d8bb5c44e(id) : $ac4c15282d67ab83$export$cf1f2654bf86294f(id)), {
            body: JSON.stringify({
                fileId: mediaFile.id
            })
        });
        return attachmentId;
    };
    const $ac4c15282d67ab83$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);
});
parcelRegister("6UFK0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c958c4e419db9df$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ayrxQ;
    var $lU1w9;
    var $495Tz;
    const $2c958c4e419db9df$var$AttachmentsUpload = (props)=>{
        const [isBrowserOpen, setIsBrowserOpen] = (0, $5uXOq.useState)(false);
        const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
        const dropzoneConfig = {
            ...uploadConfig
        };
        const browserConfig = {
            ...uploadConfig,
            multiple: true
        };
        const clipboardConfig = {
            ...uploadConfig
        };
        if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayrxQ")).BrowserLoader), {
            isOpen: isBrowserOpen,
            config: browserConfig,
            mediaClientConfig: mediaClientConfig,
            onUploadsStart: onUploadStart,
            onError: onUploadError,
            onEnd: onUploadEnd,
            onClose: ()=>setIsBrowserOpen(false)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lU1w9")).DropzoneLoader), {
            mediaClientConfig: mediaClientConfig,
            config: dropzoneConfig,
            onUploadsStart: onUploadStart,
            onEnd: onUploadEnd
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("495Tz")).Clipboard), {
            mediaClientConfig: mediaClientConfig,
            config: clipboardConfig,
            onUploadsStart: onUploadStart,
            onEnd: onUploadEnd,
            isolated: false
        }), renderPropFn({
            setIsBrowserOpen: setIsBrowserOpen
        }));
    };
    var $2c958c4e419db9df$export$2e2bcd8739ae039 = $2c958c4e419db9df$var$AttachmentsUpload;
});
parcelRegister("ayrxQ", function(module, exports) {
    $parcel$export(module.exports, "BrowserLoader", ()=>$91b264e5a1a03fda$export$3ce634ac4a869e2c);
    var $5uXOq = parcelRequire("5uXOq");
    class $91b264e5a1a03fda$export$3ce634ac4a869e2c extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncBrowser';
        }
        componentDidMount() {
            this.mounted = true;
        }
        componentWillUnmount() {
            this.mounted = false;
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Browser) {
                const [mediaClient, browserModule] = await Promise.all([
                    (parcelRequire("2QwfG")),
                    (parcelRequire("1hhrg"))
                ]);
                $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
                if (this.mounted) this.setState({
                    Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
                });
            }
        }
        render() {
            if (!this.state.Browser) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(this.state.Browser, this.props);
        }
        constructor(...args){
            super(...args), this.mounted = false, this.state = {
                Browser: $91b264e5a1a03fda$export$3ce634ac4a869e2c.Browser
            };
        }
    }
});
parcelRegister("2QwfG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5GwtU").then(()=>parcelRequire('7b5A1'));
});
parcelRegister("1hhrg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("JoTl6").then(()=>parcelRequire('fr527'));
});
parcelRegister("lU1w9", function(module, exports) {
    $parcel$export(module.exports, "DropzoneLoader", ()=>$5f5f884766c60e4b$export$66201d263cd6342);
    var $5uXOq = parcelRequire("5uXOq");
    class $5f5f884766c60e4b$export$66201d263cd6342 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncDropzone';
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
                const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                    (parcelRequire("2QwfG")),
                    (parcelRequire("3pcVf")),
                    (parcelRequire("hbwgw"))
                ]);
                $5f5f884766c60e4b$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
                $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
                this.setState({
                    Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
                    MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
                });
            } catch (error) {}
        }
        render() {
            const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
            if (!Dropzone || !MediaPickerErrorBoundary) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(MediaPickerErrorBoundary, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Dropzone, this.props));
        }
        constructor(...args){
            super(...args), this.state = {
                Dropzone: $5f5f884766c60e4b$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $5f5f884766c60e4b$export$66201d263cd6342.MediaPickerErrorBoundary
            };
        }
    }
});
parcelRegister("3pcVf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aBP1r").then(()=>parcelRequire('cw5oc'));
});
parcelRegister("hbwgw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("3j9rr")
    ]).then(()=>parcelRequire('quJ0B'));
});
parcelRegister("495Tz", function(module, exports) {
    $parcel$export(module.exports, "Clipboard", ()=>$a204c5b4c1d898fb$export$8b44c43c7d8f0830);
    var $5uXOq = parcelRequire("5uXOq");
    var $2AN6s;
    var $46dC9;
    const $a204c5b4c1d898fb$export$7b1ba4955557a858 = ()=>null;
    const $a204c5b4c1d898fb$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
        const container = (0, (0, parcelRequire("46dC9")).useClipboardContextBoundary)();
        const onPaste = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            return false;
        }, []);
        const derivedConfig = (0, $5uXOq.useMemo)(()=>container ? {
                ...config,
                container: container,
                onPaste: onPaste
            } : config, [
            config,
            container,
            onPaste
        ]);
        if (!container && isolated !== false) return (0, ($parcel$interopDefault($5uXOq))).createElement($a204c5b4c1d898fb$export$7b1ba4955557a858, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2AN6s")).ClipboardLoader), {
            ...props,
            config: derivedConfig
        });
    };
});
parcelRegister("2AN6s", function(module, exports) {
    $parcel$export(module.exports, "ClipboardLoader", ()=>$943d05c2815ce49d$export$d7936799bf32b554);
    var $5uXOq = parcelRequire("5uXOq");
    class $943d05c2815ce49d$export$d7936799bf32b554 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.displayName = 'AsyncClipboard';
        }
        async UNSAFE_componentWillMount() {
            if (!this.state.Clipboard) {
                const [mediaClient, clipboardModule] = await Promise.all([
                    (parcelRequire("2QwfG")),
                    (parcelRequire("5BfdH"))
                ]);
                $943d05c2815ce49d$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
                this.setState({
                    Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
                });
            }
        }
        render() {
            if (!this.state.Clipboard) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(this.state.Clipboard, this.props);
        }
        constructor(...args){
            super(...args), this.state = {
                Clipboard: $943d05c2815ce49d$export$d7936799bf32b554.Clipboard
            };
        }
    }
});
parcelRegister("5BfdH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("axhr4").then(()=>parcelRequire('h0DlA'));
});
parcelRegister("46dC9", function(module, exports) {
    $parcel$export(module.exports, "ClipboardStoreContainer", ()=>$315b0e877a12fb17$export$c4bc9440a978eec1);
    $parcel$export(module.exports, "useClipboardContextActions", ()=>$315b0e877a12fb17$export$a3e41c5b3d4c30b7);
    $parcel$export(module.exports, "useClipboardContextBoundary", ()=>$315b0e877a12fb17$export$37046969a30ae0a0);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    const $315b0e877a12fb17$var$ClipboardStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'clipboard-store',
        initialState: {
            boundary: null
        },
        actions: {
            setClipBoardContext: (boundary)=>({ setState: setState })=>{
                    setState({
                        boundary: boundary
                    });
                }
        }
    });
    const $315b0e877a12fb17$export$c4bc9440a978eec1 = (0, (0, parcelRequire("gg7kZ")).createContainer)($315b0e877a12fb17$var$ClipboardStore);
    const $315b0e877a12fb17$export$a3e41c5b3d4c30b7 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($315b0e877a12fb17$var$ClipboardStore);
    const $315b0e877a12fb17$var$useClipboardContextBoundarySelector = (0, (0, parcelRequire("3sQ5x")).createHook)($315b0e877a12fb17$var$ClipboardStore, {
        selector: (state)=>state.boundary
    });
    const $315b0e877a12fb17$export$37046969a30ae0a0 = ()=>$315b0e877a12fb17$var$useClipboardContextBoundarySelector()[0];
});
parcelRegister("c431P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23a51dc4ce208a9a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $23a51dc4ce208a9a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dropzone: {
            "id": "issue-create-commons.attachments-field.dropzone",
            "defaultMessage": "Drop files to attach or"
        },
        browse: {
            "id": "issue-create-commons.attachments-field.browse",
            "defaultMessage": "Browse"
        },
        browseAriaLabel: {
            "id": "issue-create-commons.attachments-field.browse-aria-label",
            "defaultMessage": "Browse attachment"
        },
        missingToken: {
            "id": "issue-create-commons.attachments-field.missing-token",
            "defaultMessage": "Something went wrong"
        }
    });
    var $23a51dc4ce208a9a$export$2e2bcd8739ae039 = $23a51dc4ce208a9a$var$messages;
});
parcelRegister("iUFy5", function(module, exports) {
    $parcel$export(module.exports, "MinimizableModalProvider", ()=>$b1dce28e1d2cfa0c$export$582a26efcd805dfd);
    $parcel$export(module.exports, "useMinimizableModal", ()=>$b1dce28e1d2cfa0c$export$40bb90ec193b1c2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWt6p;
    var $kNC83;
    var $heCPy;
    const $b1dce28e1d2cfa0c$export$a9554de703151814 = (0, $5uXOq.createContext)({
        shouldFocusChanger: false,
        view: 'modal',
        previousView: 'modal',
        setView: ()=>{},
        unminimizeModal: ()=>{},
        onClose: ()=>{},
        transitionByKeyboardFrom: null,
        setTransitionByKeyboardFrom: ()=>{},
        setShouldFocusChanger: ()=>{},
        isTransitionInState: ()=>false,
        setTransitionState: ()=>{},
        shouldDisableViewChangerButtons: false,
        customDisabledViewChangerButtonsMessage: '',
        setShouldDisableViewChangerButtons: ()=>{},
        isNestedModal: false,
        setIsNestedModal: ()=>{},
        displayMinimizableButtons: true
    });
    const $b1dce28e1d2cfa0c$export$582a26efcd805dfd = ({ initialView: initialView = 'modal', view: view, onViewChange: onViewChange, onClose: onClose, children: children, displayMinimizableButtons: displayMinimizableButtons = true })=>{
        const [_view, _setView] = (0, $5uXOq.useState)(view || initialView);
        const actualView = (0, $5uXOq.useMemo)(()=>view || _view, [
            view,
            _view
        ]);
        const previousView = (0, (0, parcelRequire("heCPy")).usePrevious)(actualView, [
            'minimized'
        ]);
        const [modalState, setModalState] = (0, $5uXOq.useState)((0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        const [miniState, setMiniState] = (0, $5uXOq.useState)((0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        const [minimizedState, setMinimizedState] = (0, $5uXOq.useState)((0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        const [fullscreenState, setFullscreenState] = (0, $5uXOq.useState)((0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        const [_shouldDisableViewChangerButtons, _setShouldDisableViewChangerButtons] = (0, $5uXOq.useState)(false);
        const [_customDisabledViewChangerButtonsMessage, _setCustomDisabledViewChangerButtonsMessage] = (0, $5uXOq.useState)('');
        const [isNestedModal, setIsNestedModal] = (0, $5uXOq.useState)(false);
        const transitionByKeyboardFrom = (0, $5uXOq.useRef)(null);
        const shouldFocusChanger = (0, $5uXOq.useRef)(false);
        const currentTransitionState = (0, $5uXOq.useMemo)(()=>({
                modal: modalState,
                mini: miniState,
                minimized: minimizedState,
                fullscreen: fullscreenState
            }), [
            modalState,
            miniState,
            minimizedState,
            fullscreenState
        ]);
        const isTransitionInState = (0, $5uXOq.useCallback)((viewsTransitioning, state, fallbackForReducedMotion = true)=>{
            if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)()) return fallbackForReducedMotion;
            return viewsTransitioning.every((viewTransitioning)=>currentTransitionState[viewTransitioning] === state);
        }, [
            currentTransitionState
        ]);
        const setTransitionState = (0, $5uXOq.useCallback)((viewTransitioning, state)=>{
            if (viewTransitioning === 'modal') setModalState(state);
            if (viewTransitioning === 'mini') setMiniState(state);
            if (viewTransitioning === 'minimized') setMinimizedState(state);
            if (viewTransitioning === 'fullscreen') setFullscreenState(state);
        }, []);
        const setShouldFocusChanger = (hasTransitioned)=>{
            shouldFocusChanger.current = hasTransitioned;
        };
        const setView = (0, $5uXOq.useCallback)((newView, force = false)=>{
            if (_shouldDisableViewChangerButtons && !force) return;
            if (view) {
                if (onViewChange) onViewChange(newView);
                return;
            }
            _setView(newView);
        }, [
            _shouldDisableViewChangerButtons,
            onViewChange,
            view
        ]);
        const unminimizeModal = (0, $5uXOq.useCallback)((fallbackView)=>{
            if (previousView === 'minimized') {
                setView(fallbackView);
                return;
            }
            setView(previousView);
        }, [
            setView,
            previousView
        ]);
        const setTransitionByKeyboardFrom = (0, $5uXOq.useCallback)((keyPressedFrom)=>{
            transitionByKeyboardFrom.current = keyPressedFrom;
        }, []);
        const setShouldDisableViewChangerButtons = (0, $5uXOq.useCallback)((shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage = '')=>{
            _setShouldDisableViewChangerButtons(shouldDisableViewChangerButtons);
            _setCustomDisabledViewChangerButtonsMessage(customDisabledViewChangerButtonsMessage);
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                shouldFocusChanger: shouldFocusChanger.current,
                view: actualView,
                setView: setView,
                previousView: previousView,
                onClose: onClose,
                unminimizeModal: unminimizeModal,
                transitionByKeyboardFrom: transitionByKeyboardFrom.current,
                setTransitionByKeyboardFrom: setTransitionByKeyboardFrom,
                setShouldFocusChanger: setShouldFocusChanger,
                isTransitionInState: isTransitionInState,
                setTransitionState: setTransitionState,
                shouldDisableViewChangerButtons: _shouldDisableViewChangerButtons,
                customDisabledViewChangerButtonsMessage: _customDisabledViewChangerButtonsMessage,
                setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons,
                isNestedModal: isNestedModal,
                setIsNestedModal: setIsNestedModal,
                displayMinimizableButtons: displayMinimizableButtons
            }), [
            _customDisabledViewChangerButtonsMessage,
            _shouldDisableViewChangerButtons,
            actualView,
            isNestedModal,
            isTransitionInState,
            onClose,
            previousView,
            setShouldDisableViewChangerButtons,
            setTransitionByKeyboardFrom,
            setTransitionState,
            setView,
            unminimizeModal,
            displayMinimizableButtons
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b1dce28e1d2cfa0c$export$a9554de703151814.Provider, {
            value: context
        }, children);
    };
    const $b1dce28e1d2cfa0c$export$40bb90ec193b1c2f = ()=>{
        const context = (0, $5uXOq.useContext)($b1dce28e1d2cfa0c$export$a9554de703151814);
        if (context === undefined) throw new Error('useMinimizableModal must be used within a MinimizableModalProvider');
        return context;
    };
});
parcelRegister("kNC83", function(module, exports) {
    $parcel$export(module.exports, "TransitionState", ()=>$08cbc53ad238dde5$export$145c1ed87b1a2216);
    const $08cbc53ad238dde5$export$145c1ed87b1a2216 = {
        EXITED: 1,
        ENTERED: 2,
        TRANSITIONING: 3
    };
});
parcelRegister("heCPy", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$08906ec90ae413ff$export$5cae361ad82dce8b);
    var $5uXOq = parcelRequire("5uXOq");
    function $08906ec90ae413ff$export$5cae361ad82dce8b(value, ignoreValues) {
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            if (ref.current !== value && !ignoreValues.includes(value)) ref.current = value;
        }, [
            value,
            ignoreValues
        ]);
        return ref.current;
    }
});
parcelRegister("cjoqp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aeabca6159fd7931$export$2e2bcd8739ae039);
    var $7VHMR;
    var $aeabca6159fd7931$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        missingToken: {
            "id": "issue-create.common.fields.attachments-field.missing-token",
            "defaultMessage": "Something went wrong"
        },
        attachmentSizeLimitCheck: {
            "id": "issue-create.common.fields.attachments-field.attachment-size-limit-check",
            "defaultMessage": "We couldn\u2019t upload the attachment as you\u2019ve exceeded the limit"
        }
    });
});
parcelRegister("4vfKb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$facf0e52d6b312e1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fr1K2 = parcelRequire("fr1K2");
    var $eYh10;
    var $1wbtX;
    var $gwIPs;
    var $4R6GH;
    var $7C5S0;
    var $hpV4g;
    var $9ah8z;
    var $5UgCh;
    var $lfTZh;
    var $QTixP;
    var $14XJw;
    var $g5X3G;
    var $90yGq;
    var $koeKL;
    var $diNhq;
    var $6gjIc;
    var $h0fZ7;
    const $facf0e52d6b312e1$var$skeletonHeight = `${(0, (0, parcelRequire("gwIPs")).gridSize) * 18.75}px`;
    const $facf0e52d6b312e1$var$PRINCIPAL_ID = 'context';
    const $facf0e52d6b312e1$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME = 'Description';
    const $facf0e52d6b312e1$export$336230c809f2ec53 = (props)=>{
        const { width: width = '100%', fieldProps: { value: value, onChange: onChange, onBlur: onBlur }, selectedProject: selectedProject, defaultValue: defaultValue, additionalData: additionalData, fieldName: fieldName, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false, selectedIssueType: selectedIssueType, getFormState: getFormState } = props;
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const loggedInUserAccountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const { onFocus: onFocusField, onBlur: onBlurField } = isGICPositioningEnabled() ? props : {};
        const { mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig } = additionalData;
        let mediaUploadContext;
        const uploadToken = mediaContext?.uploadToken;
        if (uploadToken) mediaUploadContext = {
            clientId: uploadToken.clientId,
            serviceHost: uploadToken.endpointUrl,
            collection: uploadToken.targetCollection,
            token: uploadToken.token
        };
        const product = (0, (0, parcelRequire("QTixP")).getProductForEditorAIPlugin)(selectedProject?.projectType);
        const issueTypeLabel = selectedIssueType?.label?.toLowerCase();
        const allowIssueReformatter = (0, $5uXOq.useMemo)(()=>fieldName === $facf0e52d6b312e1$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME, [
            fieldName
        ]);
        const productConfig = (0, $5uXOq.useMemo)(()=>({
                product: 'jira',
                cloudId: cloudId
            }), [
            cloudId
        ]);
        const linkPicker = (0, (0, parcelRequire("diNhq")).useLinkPickerEditorProps)(undefined, productConfig);
        const editorPluginAIConfig = (0, $5uXOq.useMemo)(()=>({
                editorPluginAIConfig: {
                    product: product,
                    isAiOptInEnabled: !!adminRichTextConfig?.aiEnabledByProject,
                    allowIssueReformatter: allowIssueReformatter,
                    getAdditionalProps: ()=>({
                            issue_type_label: issueTypeLabel,
                            issue_summary: getFormState?.()?.values.summary || ''
                        }),
                    aiLifeCycleDynamicAttributesGetter: !(0, (0, parcelRequire("4R6GH")).fg)('editorai_dynamic_attributes_for_ai_life_cycle') ? undefined : ()=>({
                            issueTypeLabel: issueTypeLabel || ''
                        }),
                    linking: linkPicker ? {
                        linkPicker: linkPicker,
                        smartLinks: {
                            provider: Promise.resolve(new (0, (0, parcelRequire("eYh10")).EditorCardProvider)())
                        }
                    } : undefined,
                    getChannelVariables: (purpose)=>{
                        if (purpose === 'rovo-agent') {
                            if (typeof cloudId === 'string' && typeof loggedInUserAccountId === 'string') return {
                                cloudId: cloudId,
                                userId: loggedInUserAccountId,
                                contentURL: window.location.origin + window.location.pathname
                            };
                        }
                        return null;
                    },
                    actionSideEffects: {
                        continueInChat: ()=>{
                            const dockButton = document.getElementById('minimizable-modal.ui.modal-container.modal-header.mini-button');
                            dockButton?.click?.();
                        }
                    }
                }
            }), [
            product,
            adminRichTextConfig?.aiEnabledByProject,
            allowIssueReformatter,
            linkPicker,
            issueTypeLabel,
            getFormState,
            cloudId,
            loggedInUserAccountId
        ]);
        const editorConfig = (0, (0, parcelRequire("QTixP")).useEditorConfig)(editorPluginAIConfig);
        const mentionProvider = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("5UgCh")).UserTeamProjectMentionProviderWithResolverMentionName)({
            projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(`${selectedProject?.projectKey || ''}`),
            projectType: selectedProject?.projectType
        }, {
            userId: $facf0e52d6b312e1$var$PRINCIPAL_ID,
            cloudId: cloudId,
            orgId: orgId
        }));
        const editorKey = (0, $5uXOq.useRef)(Date.now());
        const mediaProvider = {
            viewContext: mediaUploadContext,
            uploadContext: mediaUploadContext
        };
        let actualValue = defaultValue;
        (0, $5uXOq.useEffect)(()=>{
            if (value?.resetRequired === true) {
                editorKey.current = Date.now();
                onChange((0, ($parcel$interopDefault($fr1K2)))(value, 'resetRequired'));
            }
        }, [
            defaultValue,
            onChange,
            value
        ]);
        const overrideRequired = value?.overrideRequired || false;
        actualValue = overrideRequired ? (0, ($parcel$interopDefault($fr1K2)))(value, 'overrideRequired') : value ?? defaultValue;
        (0, $5uXOq.useEffect)(()=>{
            if (overrideRequired === true) {
                editorKey.current = Date.now();
                onChange(actualValue);
            }
        }, [
            overrideRequired,
            onChange,
            actualValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "description-field",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
                height: $facf0e52d6b312e1$var$skeletonHeight
            })
        }, isGICPositioningEnabled() ? (0, ($parcel$interopDefault($5uXOq))).createElement($facf0e52d6b312e1$var$WrapperDiv, {
            tabIndex: -1,
            onFocus: ()=>{
                if (isGICPositioningEnabled() && onFocusField) onFocusField();
            },
            onBlur: isGICPositioningEnabled() ? onBlurField : undefined,
            "data-testid": isGICPositioningEnabled() ? 'issue-create.common.ui.fields.description-field.wrapper' : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ah8z")).AsyncRichTextEditView), {
            key: editorKey.current,
            onChange: onChange,
            onBlur: onBlur,
            defaultValue: actualValue,
            mentionProvider: mentionProvider.current,
            mediaContext: mediaProvider,
            shouldFocus: autoFocus,
            isDisabled: isReadOnly,
            assistiveLabel: fieldName,
            sharedEditorConfig: editorConfig
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ah8z")).AsyncRichTextEditView), {
            key: editorKey.current,
            onChange: onChange,
            onBlur: onBlur,
            defaultValue: actualValue,
            mentionProvider: mentionProvider.current,
            mediaContext: mediaProvider,
            shouldFocus: autoFocus,
            isDisabled: isReadOnly,
            assistiveLabel: fieldName,
            sharedEditorConfig: editorConfig
        })));
    };
    var $facf0e52d6b312e1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("h0fZ7")).validateDescriptionField)
    })($facf0e52d6b312e1$export$336230c809f2ec53);
    const $facf0e52d6b312e1$var$WrapperDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12ji1r31 _1qu2glyw _12y31o36",
                __cmplp.className
            ])
        });
    });
    $facf0e52d6b312e1$var$WrapperDiv.displayName = 'WrapperDiv';
});
parcelRegister("eYh10", function(module, exports) {
    $parcel$export(module.exports, "EditorCardProvider", ()=>$9c198639652e78ad$export$e4635c0135e1a519);
    var $hhZW9 = parcelRequire("hhZW9");
    var $itO4f;
    var $fiKQs;
    var $dV0Jy;
    var $k9B19;
    var $38Kxa;
    var $7cFR3;
    const $9c198639652e78ad$var$BATCH_WAIT_TIME = 50;
    const $9c198639652e78ad$var$isJiraRoadmapOrTimeline = (url)=>url.match(/^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/);
    const $9c198639652e78ad$var$isPolarisView = (url)=>url.match(/^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/);
    const $9c198639652e78ad$var$isJwmView = (url)=>url.match(/^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/);
    const $9c198639652e78ad$var$isGiphyMedia = (url)=>url.match(/^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//);
    const $9c198639652e78ad$var$isProformaView = (url)=>url.match(/^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/);
    class $9c198639652e78ad$export$e4635c0135e1a519 {
        constructor(envKey, baseUrlOverride){
            this.baseUrl = baseUrlOverride || (0, (0, parcelRequire("itO4f")).getBaseUrl)(envKey);
            this.resolverUrl = (0, (0, parcelRequire("itO4f")).getResolverUrl)(envKey, baseUrlOverride);
            this.transformer = new (0, (0, parcelRequire("38Kxa")).Transformer)();
            this.requestHeaders = {
                Origin: this.baseUrl
            };
            this.providersLoader = new (0, ($parcel$interopDefault($hhZW9)))((keys)=>this.batchProviders(keys), {
                batchScheduleFn: (callback)=>setTimeout(callback, $9c198639652e78ad$var$BATCH_WAIT_TIME)
            });
            this.cardClient = new (0, (0, parcelRequire("7cFR3")).default)(envKey, baseUrlOverride);
        }
        async batchProviders(keys) {
            const providersData = await this.fetchProvidersData();
            return keys.map(()=>providersData);
        }
        async check(resourceUrl) {
            try {
                const response = await this.cardClient.fetchData(resourceUrl);
                if ((0, (0, parcelRequire("fiKQs")).getStatus)(response) !== 'not_found') return true;
            } catch (e) {
                return false;
            }
        }
        async fetchProvidersData() {
            const endpoint = `${this.resolverUrl}/providers`;
            const response = await (0, (0, parcelRequire("dV0Jy")).request)('post', endpoint, undefined, this.requestHeaders);
            return {
                patterns: response.providers.reduce((allSources, provider)=>{
                    return allSources.concat(provider.patterns);
                }, []),
                userPreferences: response.userPreferences
            };
        }
        async loadProviderData() {
            try {
                this.providersData = await this.providersLoader.load('providersData');
            } catch (err) {
                console.error('failed to fetch /providers', err);
                this.providersLoader.clear('providerData');
                return undefined;
            }
        }
        async findPattern(url) {
            return !!await this.findPatternData(url) || !!await this.check(url);
        }
        doesUrlMatchPath(path, url) {
            const startingRegex = new RegExp(/^[a-zA-Z0-9]/).test(path) ? '(^|[^a-zA-Z0-9])' : '';
            const endingRegex = new RegExp(/[a-zA-Z0-9]$/).test(path) ? '($|[^a-zA-Z0-9])' : '';
            const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
            const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
            return regexPattern.test(url);
        }
        async findUserPreference(url) {
            if (!this.providersData) await this.loadProviderData();
            const userPreferences = this.providersData?.userPreferences;
            if (userPreferences) {
                const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
                const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
                if (allMatchedLabeledAppearances.length > 0) {
                    const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                    return longestMatchedLabeledAppearance.appearance;
                }
                if (defaultAppearance !== 'inline') return defaultAppearance;
            }
        }
        async findPatternData(url) {
            if (!this.providersData) await this.loadProviderData();
            return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
        }
        getHardCodedAppearance(url) {
            if ($9c198639652e78ad$var$isJiraRoadmapOrTimeline(url) || $9c198639652e78ad$var$isPolarisView(url) || $9c198639652e78ad$var$isJwmView(url) || $9c198639652e78ad$var$isGiphyMedia(url) || $9c198639652e78ad$var$isProformaView(url)) return 'embed';
        }
        async canBeResolvedAsEmbed(url) {
            try {
                const details = await this.cardClient.fetchData(url);
                const data = details && details.data;
                if (!data) return false;
                if ((0, (0, parcelRequire("fiKQs")).getStatus)(details) !== 'resolved') return false;
                const preview = (0, (0, parcelRequire("k9B19")).extractPreview)(data, 'web');
                return !!preview;
            } catch (e) {
                return false;
            }
        }
        async resolve(url, appearance, shouldForceAppearance) {
            try {
                if (shouldForceAppearance === true) return this.transformer.toAdf(url, appearance);
                const hardCodedAppearance = this.getHardCodedAppearance(url);
                const [matchedProviderPattern, userPreference] = await Promise.all([
                    this.findPatternData(url),
                    this.findUserPreference(url)
                ]);
                if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
                let isSupported = !!matchedProviderPattern || await this.check(url);
                if (isSupported) {
                    const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                    let preferredAppearance = shouldForceAppearance === undefined ? hardCodedAppearance || appearance : userPreference || hardCodedAppearance || providerDefaultAppearance || appearance;
                    if (preferredAppearance === userPreference && userPreference === 'embed') {
                        const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                        if (!canItBeEmbed) preferredAppearance = 'inline';
                    }
                    return this.transformer.toAdf(url, preferredAppearance);
                }
            } catch (e) {
                console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
            }
            return Promise.reject(undefined);
        }
    }
    const $9c198639652e78ad$export$b7c3c9a99f7959f5 = new $9c198639652e78ad$export$e4635c0135e1a519();
});
parcelRegister("38Kxa", function(module, exports) {
    $parcel$export(module.exports, "Transformer", ()=>$964b3a5e1dd4467f$export$f993aef960936087);
    class $964b3a5e1dd4467f$export$f993aef960936087 {
        buildInlineAdf(url) {
            return {
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            };
        }
        buildBlockAdf(url) {
            return {
                type: 'blockCard',
                attrs: {
                    url: url
                }
            };
        }
        buildEmbedAdf(url) {
            return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'wide'
                }
            };
        }
        toAdf(url, appearance) {
            switch(appearance){
                case 'inline':
                    return this.buildInlineAdf(url);
                case 'block':
                    return this.buildBlockAdf(url);
                case 'embed':
                    return this.buildEmbedAdf(url);
            }
        }
    }
});
parcelRegister("9ah8z", function(module, exports) {
    $parcel$export(module.exports, "AsyncRichTextEditView", ()=>$5d9d583311ca074a$export$ba962c8a1ae57ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $1wbtX;
    var $7XluA;
    var $4mO32;
    var $30zeq;
    const $5d9d583311ca074a$var$EMPTY_OBJECT = {};
    const $5d9d583311ca074a$export$ba962c8a1ae57ac = (props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("30zeq")).asyncRichTextEditEntryPoint), $5d9d583311ca074a$var$EMPTY_OBJECT);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-issue-field-rich-text-edit-async",
            packageName: "jira-issue-field-rich-text",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: props,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).SkeletonCompiled), {
                height: "150px"
            }),
            errorFallback: "unmount"
        });
    };
});
parcelRegister("30zeq", function(module, exports) {
    $parcel$export(module.exports, "asyncRichTextEditEntryPoint", ()=>$33d1c4c4e757e553$export$153c0381975152a7);
    var $eufEc;
    var $fEDBv;
    const $33d1c4c4e757e553$export$153c0381975152a7 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("74Gma")).then((module)=>module.EntryPointContent), {
            moduleId: "7ade4e9b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("74Gma", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gNIa8")
    ]).then(()=>parcelRequire('dhLv0'));
});
parcelRegister("5UgCh", function(module, exports) {
    $parcel$export(module.exports, "UserTeamProjectMentionProviderWithResolverMentionName", ()=>$19555268e20407e6$export$9bc9aba7518c0a7);
    var $cQ10e;
    var $cqJWb;
    var $5GjwW;
    var $97D2J;
    class $19555268e20407e6$export$9bc9aba7518c0a7 extends (0, (0, parcelRequire("97D2J")).UserTeamProjectMentionProvider) {
        constructor(projectOptions, teamOptions){
            super(projectOptions, teamOptions);
            this.config = {
                mentionNameResolver: new (0, (0, parcelRequire("cQ10e")).DefaultMentionNameResolver)(new (0, (0, parcelRequire("5GjwW")).default)())
            };
        }
        resolveMentionName(id) {
            if (!this.config.mentionNameResolver) return {
                id: id,
                name: '',
                status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).UNKNOWN
            };
            return this.config.mentionNameResolver.lookupName(id);
        }
        supportsMentionNameResolving() {
            return !!this.config.mentionNameResolver;
        }
        cacheMentionName(id, mentionName) {
            if (!this.config.mentionNameResolver) return;
            this.config.mentionNameResolver.cacheName(id, mentionName);
        }
    }
});
parcelRegister("cQ10e", function(module, exports) {
    $parcel$export(module.exports, "DefaultMentionNameResolver", ()=>$1a91bec96e20200d$export$2ae0434dccdcb77e);
    var $cqJWb;
    var $4kfbr;
    class $1a91bec96e20200d$export$2ae0434dccdcb77e {
        static{
            this.waitForBatch = 100;
        }
        static{
            this.waitForResolveAll = 800;
        }
        constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
            this.nameCache = new Map();
            this.nameQueue = new Map();
            this.nameStartTime = new Map();
            this.processingQueue = new Map();
            this.debounce = 0;
            this.debounceOnResolve = null;
            this.isOnResolvedAllCalled = false;
            this.processQueue = ()=>{
                clearTimeout(this.debounce);
                this.debounce = 0;
                const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
                this.nameQueue = extraQueue;
                this.processingQueue = $1a91bec96e20200d$export$71ea0798a8cad7d8(this.processingQueue, queue);
                this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                    response.forEach((mentionDetail)=>{
                        const { id: id } = mentionDetail;
                        queue.delete(id);
                        this.resolveQueueItem(mentionDetail);
                    });
                    queue.forEach((_callback, id)=>{
                        this.resolveQueueItem({
                            id: id,
                            status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).UNKNOWN
                        });
                    });
                }).catch(()=>{
                    queue.forEach((_callback, id)=>{
                        this.resolveQueueItem({
                            id: id,
                            status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).SERVICE_ERROR
                        });
                    });
                });
                if (this.nameQueue.size > 0) this.scheduleProcessQueue();
                else this.scheduleOnAllResolved();
            };
            this.client = client;
            this.fireHydrationEvent = (0, (0, parcelRequire("4kfbr")).fireAnalyticsMentionHydrationEvent)(analyticsProps);
            this.onResolvedAll = onResolvedAll;
        }
        lookupName(id) {
            const name = this.nameCache.get(id);
            if (name) {
                this.fireAnalytics(true, name);
                if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
                return name;
            }
            return new Promise((resolve)=>{
                const processingItems = this.processingQueue.get(id);
                if (processingItems) this.processingQueue.set(id, [
                    ...processingItems,
                    resolve
                ]);
                const queuedItems = this.nameQueue.get(id) || [];
                this.nameQueue.set(id, [
                    ...queuedItems,
                    resolve
                ]);
                if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
                this.scheduleProcessQueue();
                if (this.isQueueAtLimit()) this.processQueue();
            });
        }
        cacheName(id, name) {
            this.nameCache.set(id, {
                id: id,
                name: name,
                status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).OK
            });
        }
        scheduleProcessQueue() {
            if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $1a91bec96e20200d$export$2ae0434dccdcb77e.waitForBatch);
        }
        scheduleOnAllResolved() {
            if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
            this.debounceOnResolve = window.setTimeout(()=>{
                if (this.isOnResolvedAllCalled) return;
                this.onResolvedAll();
                this.isOnResolvedAllCalled = true;
            }, $1a91bec96e20200d$export$2ae0434dccdcb77e.waitForResolveAll);
        }
        isQueueAtLimit() {
            return this.nameQueue.size >= this.client.getLookupLimit();
        }
        splitQueueAtLimit() {
            const values = Array.from(this.nameQueue.entries());
            const splitPoint = this.client.getLookupLimit();
            return {
                queue: new Map(values.slice(0, splitPoint)),
                extraQueue: new Map(values.slice(splitPoint))
            };
        }
        resolveQueueItem(mentionDetail) {
            const { id: id } = mentionDetail;
            const resolvers = this.processingQueue.get(id);
            if (resolvers) {
                this.processingQueue.delete(id);
                this.nameCache.set(id, mentionDetail);
                resolvers.forEach((resolve)=>{
                    try {
                        resolve(mentionDetail);
                    } catch  {}
                });
                this.fireAnalytics(false, mentionDetail);
            }
        }
        fireAnalytics(fromCache, mentionDetail) {
            const { id: id } = mentionDetail;
            const action = mentionDetail.status === (0, (0, parcelRequire("cqJWb")).MentionNameStatus).OK ? 'completed' : 'failed';
            const start = this.nameStartTime.get(id);
            const duration = start ? Date.now() - start : 0;
            this.nameStartTime.delete(id);
            this.fireHydrationEvent(action, id, fromCache, duration);
        }
    }
    function $1a91bec96e20200d$export$71ea0798a8cad7d8(queueA, queueB) {
        const queueBeingMerged = new Map([
            ...queueA
        ]);
        [
            ...queueB
        ].forEach((item)=>{
            const [key, queueBCallbacks] = item;
            const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
            if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
            else {
                const queueACallbacks = queueBeingMerged.get(key) ?? [];
                const mergedCallbacks = new Set([
                    ...queueBCallbacks,
                    ...queueACallbacks
                ]);
                const deduplicatedCallbacks = Array.from(mergedCallbacks.values());
                queueBeingMerged.set(key, deduplicatedCallbacks);
            }
        });
        return queueBeingMerged;
    }
});
parcelRegister("cqJWb", function(module, exports) {
    $parcel$export(module.exports, "MentionType", ()=>$90ca79fb430b6e09$export$2102863a3c660c6b);
    $parcel$export(module.exports, "UserAccessLevel", ()=>$90ca79fb430b6e09$export$81124e6148ca5db0);
    $parcel$export(module.exports, "UserType", ()=>$90ca79fb430b6e09$export$8436e53e45ffe15b);
    $parcel$export(module.exports, "SliNames", ()=>$90ca79fb430b6e09$export$7afb0727c7d7e8af);
    $parcel$export(module.exports, "ComponentNames", ()=>$90ca79fb430b6e09$export$5c42d9dea6d035c1);
    $parcel$export(module.exports, "Actions", ()=>$90ca79fb430b6e09$export$b52183d5cfb26dc9);
    $parcel$export(module.exports, "MentionNameStatus", ()=>$90ca79fb430b6e09$export$b8fa67dc54502853);
    $parcel$export(module.exports, "isRestricted", ()=>$90ca79fb430b6e09$export$dbaa15dc1820b89a);
    $parcel$export(module.exports, "isSpecialMention", ()=>$90ca79fb430b6e09$export$37b8dcac6198c514);
    $parcel$export(module.exports, "isAppMention", ()=>$90ca79fb430b6e09$export$eb590c844d13454c);
    $parcel$export(module.exports, "isTeamMention", ()=>$90ca79fb430b6e09$export$803b1379348dbfd5);
    $parcel$export(module.exports, "isSpecialMentionText", ()=>$90ca79fb430b6e09$export$d13d4f976b36a397);
    $parcel$export(module.exports, "isPromise", ()=>$90ca79fb430b6e09$export$4369c812aac99591);
    var $90ca79fb430b6e09$export$2102863a3c660c6b;
    (function(MentionType) {
        MentionType[MentionType["SELF"] = 0] = "SELF";
        MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
        MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    })($90ca79fb430b6e09$export$2102863a3c660c6b || ($90ca79fb430b6e09$export$2102863a3c660c6b = {}));
    var $90ca79fb430b6e09$export$81124e6148ca5db0;
    (function(UserAccessLevel) {
        UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
        UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
        UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
        UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    })($90ca79fb430b6e09$export$81124e6148ca5db0 || ($90ca79fb430b6e09$export$81124e6148ca5db0 = {}));
    var $90ca79fb430b6e09$export$8436e53e45ffe15b;
    (function(UserType) {
        UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
        UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
        UserType[UserType["APP"] = 2] = "APP";
        UserType[UserType["TEAM"] = 3] = "TEAM";
        UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    })($90ca79fb430b6e09$export$8436e53e45ffe15b || ($90ca79fb430b6e09$export$8436e53e45ffe15b = {}));
    var $90ca79fb430b6e09$export$7afb0727c7d7e8af;
    (function(SliNames) {
        SliNames["SEARCH"] = "searchUser";
        SliNames["SEARCH_TEAM"] = "searchTeam";
        SliNames["INITIAL_STATE"] = "initialState";
        SliNames["SELECT"] = "select";
        SliNames["SELECT_TEAM"] = "selectTeam";
    })($90ca79fb430b6e09$export$7afb0727c7d7e8af || ($90ca79fb430b6e09$export$7afb0727c7d7e8af = {}));
    var $90ca79fb430b6e09$export$5c42d9dea6d035c1;
    (function(ComponentNames) {
        ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
        ComponentNames["MENTION"] = "mention";
    })($90ca79fb430b6e09$export$5c42d9dea6d035c1 || ($90ca79fb430b6e09$export$5c42d9dea6d035c1 = {}));
    var $90ca79fb430b6e09$export$b52183d5cfb26dc9;
    (function(Actions) {
        Actions["VIEWED"] = "viewed";
        Actions["CLICKED"] = "clicked";
        Actions["CLOSED"] = "closed";
        Actions["SUCCEEDED"] = "succeeded";
        Actions["FAILED"] = "failed";
    })($90ca79fb430b6e09$export$b52183d5cfb26dc9 || ($90ca79fb430b6e09$export$b52183d5cfb26dc9 = {}));
    var $90ca79fb430b6e09$export$b8fa67dc54502853;
    (function(MentionNameStatus) {
        MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
        MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
        MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    })($90ca79fb430b6e09$export$b8fa67dc54502853 || ($90ca79fb430b6e09$export$b8fa67dc54502853 = {}));
    function $90ca79fb430b6e09$export$dbaa15dc1820b89a(accessLevel) {
        return !!accessLevel && accessLevel === $90ca79fb430b6e09$export$81124e6148ca5db0[0];
    }
    function $90ca79fb430b6e09$export$37b8dcac6198c514(mention) {
        return !!mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[1];
    }
    function $90ca79fb430b6e09$export$eb590c844d13454c(mention) {
        return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[2];
    }
    function $90ca79fb430b6e09$export$803b1379348dbfd5(mention) {
        return mention.userType && mention.userType === $90ca79fb430b6e09$export$8436e53e45ffe15b[3];
    }
    function $90ca79fb430b6e09$export$d13d4f976b36a397(mentionText) {
        return mentionText && (mentionText === '@all' || mentionText === '@here');
    }
    const $90ca79fb430b6e09$export$4369c812aac99591 = (p)=>!!(p && p.then);
});
parcelRegister("4kfbr", function(module, exports) {
    $parcel$export(module.exports, "SLI_EVENT_TYPE", ()=>$f8976e2813fe24b2$export$245097525aef1262);
    $parcel$export(module.exports, "SMART_EVENT_TYPE", ()=>$f8976e2813fe24b2$export$c724588856bbfbcf);
    $parcel$export(module.exports, "fireAnalyticsMentionEvent", ()=>$f8976e2813fe24b2$export$44902bc7b3f0b09f);
    $parcel$export(module.exports, "fireAnalyticsMentionHydrationEvent", ()=>$f8976e2813fe24b2$export$91b2fa6a0fe06408);
    var $cqJWb;
    const $f8976e2813fe24b2$var$packageName = "platform-pkg";
    const $f8976e2813fe24b2$var$packageVersion = "0.0.0-use.local";
    const $f8976e2813fe24b2$export$245097525aef1262 = 'sli';
    const $f8976e2813fe24b2$export$c724588856bbfbcf = 'smart';
    const $f8976e2813fe24b2$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = {
                    action: action,
                    actionSubject: (0, (0, parcelRequire("cqJWb")).ComponentNames).TYPEAHEAD,
                    attributes: {
                        packageName: $f8976e2813fe24b2$var$packageName,
                        packageVersion: $f8976e2813fe24b2$var$packageVersion,
                        componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                        duration: Math.round(duration),
                        userIds: userIds,
                        queryLength: query ? query.length : 0
                    },
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
                };
                const analyticsEvent = props.createAnalyticsEvent(eventPayload);
                analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
            const payload = {
                action: action,
                actionSubject: actionSubject,
                eventType: (0, $676c5e519aa5ba55$export$a1562d08625f5d7e),
                attributes: {
                    packageName: $f8976e2813fe24b2$var$packageName,
                    packageVersion: $f8976e2813fe24b2$var$packageVersion,
                    componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                    accessLevel: accessLevel,
                    isSpecial: (0, (0, parcelRequire("cqJWb")).isSpecialMentionText)(text),
                    userId: id
                }
            };
            const event = createEvent(payload);
            event.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            return event;
        };
    const $f8976e2813fe24b2$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = $f8976e2813fe24b2$export$c357a2872628de7c(actionSubject, action);
                props.createAnalyticsEvent(eventPayload).fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
        const eventPayload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $676c5e519aa5ba55$export$12346a674644c156),
            attributes: {
                packageName: $f8976e2813fe24b2$var$packageName,
                packageVersion: $f8976e2813fe24b2$var$packageVersion,
                componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                ...attributes
            }
        };
        return eventPayload;
    };
    const $f8976e2813fe24b2$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
            if (props.createAnalyticsEvent) {
                const eventPayload = {
                    action: action,
                    actionSubject: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                    actionSubjectId: 'hydration',
                    attributes: {
                        packageName: $f8976e2813fe24b2$var$packageName,
                        packageVersion: $f8976e2813fe24b2$var$packageVersion,
                        componentName: (0, (0, parcelRequire("cqJWb")).ComponentNames).MENTION,
                        userId: userId,
                        fromCache: fromCache,
                        duration: Math.round(duration)
                    },
                    eventType: (0, $676c5e519aa5ba55$export$12346a674644c156)
                };
                const analyticsEvent = props.createAnalyticsEvent(eventPayload);
                analyticsEvent.fire((0, $094ce2d9636497d7$export$d821aa4c8afb384e));
            }
        };
    const $f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
    const $f8976e2813fe24b2$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
            if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$f8976e2813fe24b2$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
                accessLevel: accessLevel,
                isSpecial: (0, (0, parcelRequire("cqJWb")).isSpecialMentionText)(text)
            });
        };
});
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';
const $094ce2d9636497d7$export$d821aa4c8afb384e = 'fabric-elements';
parcelRegister("5GjwW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19675cdaadbe090b$export$2e2bcd8739ae039);
    var $cqJWb;
    const $19675cdaadbe090b$var$bulkUserPath = '/rest/api/3/user/bulk';
    const $19675cdaadbe090b$var$MAX_MENTIONS = 50;
    class $19675cdaadbe090b$export$2e2bcd8739ae039 {
        getLookupLimit() {
            return $19675cdaadbe090b$var$MAX_MENTIONS;
        }
        async lookupMentionNames(ids) {
            const params = ids.reduce((idParams, id, index)=>`${idParams}${index > 0 ? '&' : ''}accountId=${encodeURIComponent(id)}`, '');
            return fetch(`${$19675cdaadbe090b$var$bulkUserPath}?${params}&maxResults=${$19675cdaadbe090b$var$MAX_MENTIONS}`, {
                credentials: 'same-origin'
            }).then((response)=>response.json()).then((data)=>{
                if (!data || !data.values || !data.values.length) return [];
                return data.values.filter(Boolean).map((user)=>({
                        id: user.accountId,
                        name: user.displayName,
                        status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).OK
                    }));
            });
        }
    }
});
parcelRegister("97D2J", function(module, exports) {
    $parcel$export(module.exports, "UserTeamProjectMentionProvider", ()=>$d519702ba683d614$export$68d633262339b833);
    var $lFKmC = parcelRequire("lFKmC");
    var $hGgHi = parcelRequire("hGgHi");
    var $92lWB;
    var $eqACH;
    const $d519702ba683d614$var$MENTION_DEBOUNCE_MS = 150;
    class $d519702ba683d614$export$68d633262339b833 extends (0, (0, parcelRequire("92lWB")).ProjectMentionProvider) {
        constructor(projectOptions, teamOptions){
            super('', projectOptions.projectKey, projectOptions.projectType), this.debouncedSearch = (0, ($parcel$interopDefault($lFKmC)))(async (query, contextIdentifier)=>{
                const currentSearchTime = Date.now();
                try {
                    const mentionResults = await Promise.all([
                        this.teamMentionProvider.getRecommendedMentions(query, contextIdentifier),
                        this.search(query, contextIdentifier)
                    ]);
                    this.activeSearches.delete(query);
                    if (currentSearchTime > this.lastSearchTime) this.lastSearchTime = currentSearchTime;
                    return mentionResults.reduce((acc, mentionResult)=>{
                        if (mentionResult) acc.mentions = [
                            ...acc.mentions,
                            ...mentionResult.mentions
                        ];
                        return acc;
                    }, {
                        mentions: [],
                        query: query ?? ''
                    });
                } catch (e) {
                    if (!(0, ($parcel$interopDefault($hGgHi)))(query) && query.length > 0) this.activeSearches.delete(query);
                    throw e;
                }
            }, $d519702ba683d614$var$MENTION_DEBOUNCE_MS);
            this.teamMentionProvider = new (0, (0, parcelRequire("eqACH")).TeamMentionProvider)({
                cloudId: teamOptions.cloudId,
                userId: teamOptions.userId,
                orgId: teamOptions.orgId
            });
        }
        async filter(query, contextIdentifier) {
            try {
                const currentSearchTime = Date.now();
                const mentionResults = await this.debouncedSearch(query, contextIdentifier);
                const results = mentionResults ?? {
                    mentions: [],
                    query: query ?? ''
                };
                this._notifyListeners(results, {
                    duration: Date.now() - currentSearchTime
                });
                this._notifyAllResultsListeners(results);
            } catch (e) {
                this._notifyErrorListeners(e);
            }
        }
    }
});
parcelRegister("92lWB", function(module, exports) {
    $parcel$export(module.exports, "ProjectMentionProvider", ()=>$e29d82157b4dfb7f$export$40976f7091c70c78);
    var $ebyGx = parcelRequire("ebyGx");
    var $gVfsM;
    class $e29d82157b4dfb7f$export$40976f7091c70c78 extends (0, (0, parcelRequire("gVfsM")).AbstractMentionProvider) {
        constructor(baseUrl, projectKey, projectType){
            super(baseUrl, projectType), this.getQueryString = (query)=>(0, $ebyGx.stringify)({
                    query: query,
                    projectKey: this.projectKey,
                    maxResults: 10
                }), this.getUrl = (queryString)=>`${this.baseUrl}/rest/api/2/user/viewissue/search?${queryString}`, this.shouldHighlightMention = (mention)=>mention.id === this.projectKey;
            this.projectKey = projectKey;
        }
    }
});
parcelRegister("gVfsM", function(module, exports) {
    $parcel$export(module.exports, "AbstractMentionProvider", ()=>$b8e30b1d7a2c4e16$export$1503942bd70a06a4);
    var $lFKmC = parcelRequire("lFKmC");
    var $hGgHi = parcelRequire("hGgHi");
    var $3mm6g;
    var $4Pf62;
    var $7f4tk;
    var $ecbCU;
    var $4QRz9;
    const $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS = 150;
    class $b8e30b1d7a2c4e16$export$1503942bd70a06a4 extends (0, (0, parcelRequire("3mm6g")).AbstractMentionResource) {
        constructor(baseUrl, projectType, createAnalyticsEvent){
            super(), this.debouncedFilter = (0, ($parcel$interopDefault($lFKmC)))((query, contextIdentifier)=>{
                const currentSearchTime = Date.now();
                return this.search(query, contextIdentifier).then((mentionResult)=>{
                    this.activeSearches.delete(query);
                    if (currentSearchTime > this.lastSearchTime) {
                        this.lastSearchTime = currentSearchTime;
                        this._notifyListeners(mentionResult, {
                            duration: Date.now() - currentSearchTime
                        });
                    }
                    this._notifyAllResultsListeners(mentionResult);
                }).catch((e)=>{
                    if (!(0, ($parcel$interopDefault($hGgHi)))(query) && query.length > 0) this.activeSearches.delete(query);
                    this._notifyErrorListeners(e);
                });
            }, $b8e30b1d7a2c4e16$var$MENTION_DEBOUNCE_MS);
            this.baseUrl = baseUrl;
            this.lastSearchTime = 0;
            this.activeSearches = new Set();
            this.productName = (0, (0, parcelRequire("4QRz9")).subProductFromProjectType)(projectType);
            this.userRole = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
            this.onInviteItemClick = ()=>{
                (0, (0, parcelRequire("ecbCU")).triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                    inviteFlow: 'mention'
                });
            };
            this.shouldEnableInvite = true;
        }
        isFiltering(query) {
            return this.activeSearches.has(query);
        }
        filter(query, contextIdentifier) {
            return this.debouncedFilter(query, contextIdentifier);
        }
        search(query, context) {
            const queryString = this.getQueryString(query, context);
            const url = this.getUrl(queryString);
            this.activeSearches.add(query);
            return this.fetchMentions(url).then((users)=>users.map((user)=>({
                        name: user.displayName,
                        mentionName: user.displayName,
                        nickname: user.displayName,
                        id: user.accountId,
                        avatarUrl: user.avatarUrls['48x48']
                    }))).then((mentions)=>({
                    query: query,
                    mentions: mentions
                }));
        }
        fetchMentions(url) {
            return (0, (0, parcelRequire("7f4tk")).default)(url);
        }
    }
});
parcelRegister("3mm6g", function(module, exports) {
    $parcel$export(module.exports, "AbstractMentionResource", ()=>$9565842f98e50876$export$8576ba1ed2760927);
    $parcel$export(module.exports, "isResolvingMentionProvider", ()=>$9565842f98e50876$export$ae1fce5f69858ef3);
    var $dS9cn = parcelRequire("dS9cn");
    var $cqJWb;
    var $6Ctoj;
    var $4kfbr;
    var $lFKmC = parcelRequire("lFKmC");
    const $9565842f98e50876$var$MAX_QUERY_ITEMS = 100;
    const $9565842f98e50876$var$MAX_NOTIFIED_ITEMS = 20;
    const $9565842f98e50876$var$emptySecurityProvider = ()=>{
        return {
            params: {},
            headers: {}
        };
    };
    class $9565842f98e50876$export$4529f10aed0950d4 {
        constructor(){
            this.changeListeners = new Map();
            this.allResultsListeners = new Map();
            this.errListeners = new Map();
            this.infoListeners = new Map();
            this.analyticsListeners = new Map();
        }
        subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
            if (callback) this.changeListeners.set(key, callback);
            if (errCallback) this.errListeners.set(key, errCallback);
            if (infoCallback) this.infoListeners.set(key, infoCallback);
            if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
            if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
        }
        unsubscribe(key) {
            this.changeListeners.delete(key);
            this.errListeners.delete(key);
            this.infoListeners.delete(key);
            this.allResultsListeners.delete(key);
            this.analyticsListeners.delete(key);
        }
    }
    class $9565842f98e50876$export$8576ba1ed2760927 extends $9565842f98e50876$export$4529f10aed0950d4 {
        shouldHighlightMention(_mention) {
            return false;
        }
        filter(query) {
            throw new Error(`not yet implemented.\nParams: query=${query}`);
        }
        recordMentionSelection(_mention) {}
        isFiltering(_query) {
            return false;
        }
        _notifyListeners(mentionsResult, stats) {
            (0, (0, parcelRequire("6Ctoj")).default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
            this.changeListeners.forEach((listener, key)=>{
                try {
                    listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
                } catch (e) {
                    (0, (0, parcelRequire("6Ctoj")).default)(`error from listener '${key}', ignoring`, e);
                }
            });
        }
        _notifyAllResultsListeners(mentionsResult) {
            (0, (0, parcelRequire("6Ctoj")).default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
            this.allResultsListeners.forEach((listener, key)=>{
                try {
                    listener(mentionsResult.mentions.slice(0, $9565842f98e50876$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
                } catch (e) {
                    (0, (0, parcelRequire("6Ctoj")).default)(`error from listener '${key}', ignoring`, e);
                }
            });
        }
        _notifyErrorListeners(error, query) {
            this.errListeners.forEach((listener, key)=>{
                try {
                    listener(error, query);
                } catch (e) {
                    (0, (0, parcelRequire("6Ctoj")).default)(`error from listener '${key}', ignoring`, e);
                }
            });
        }
        _notifyInfoListeners(info) {
            this.infoListeners.forEach((listener, key)=>{
                try {
                    listener(info);
                } catch (e) {
                    (0, (0, parcelRequire("6Ctoj")).default)(`error from listener '${key}', ignoring`, e);
                }
            });
        }
        _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
            this.analyticsListeners.forEach((listener, key)=>{
                try {
                    listener(event, actionSubject, action, attributes);
                } catch (e) {
                    (0, (0, parcelRequire("6Ctoj")).default)(`error from listener '${key}', ignoring`, e);
                }
            });
        }
    }
    class $9565842f98e50876$export$5a4331e3e1c43553 extends $9565842f98e50876$export$8576ba1ed2760927 {
        constructor(config){
            super();
            this.verifyMentionConfig(config);
            this.config = config;
            this.lastReturnedSearch = 0;
            this.activeSearches = new Set();
            this.productName = config.productName;
            this.shouldEnableInvite = !!config.shouldEnableInvite;
            this.onInviteItemClick = config.onInviteItemClick;
            this.userRole = config.userRole || 'basic';
            if (this.config.debounceTime) this.filter = (0, ($parcel$interopDefault($lFKmC)))(this.filter, this.config.debounceTime);
        }
        shouldHighlightMention(mention) {
            if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
            return false;
        }
        notify(searchTime, mentionResult, query) {
            if (searchTime > this.lastReturnedSearch) {
                this.lastReturnedSearch = searchTime;
                this._notifyListeners(mentionResult, {
                    duration: Date.now() - searchTime
                });
            } else {
                const date = new Date(searchTime).toISOString().substr(17, 6);
                (0, (0, parcelRequire("6Ctoj")).default)('Stale search result, skipping', date, query);
            }
            this._notifyAllResultsListeners(mentionResult);
        }
        notifyError(error, query) {
            this._notifyErrorListeners(error, query);
            if (query) this.activeSearches.delete(query);
        }
        async filter(query, contextIdentifier) {
            try {
                const searchTime = Date.now();
                let results;
                if (!query) results = await this.initialState(contextIdentifier);
                else {
                    this.activeSearches.add(query);
                    const searchResponse = this.search(query, contextIdentifier);
                    results = await searchResponse.mentions;
                }
                this.notify(searchTime, results, query);
            } catch (error) {
                this.notifyError(error, query);
            }
        }
        recordMentionSelection(mention, contextIdentifier) {
            return this.recordSelection(mention, contextIdentifier).then(()=>{}, (error)=>(0, (0, parcelRequire("6Ctoj")).default)(`error recording mention selection: ${error}`, error));
        }
        isFiltering(query) {
            return this.activeSearches.has(query);
        }
        resolveMentionName(id) {
            if (!this.config.mentionNameResolver) return {
                id: id,
                name: '',
                status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).UNKNOWN
            };
            return this.config.mentionNameResolver.lookupName(id);
        }
        cacheMentionName(id, mentionName) {
            if (!this.config.mentionNameResolver) return;
            this.config.mentionNameResolver.cacheName(id, mentionName);
        }
        supportsMentionNameResolving() {
            return !!this.config.mentionNameResolver;
        }
        updateActiveSearches(query) {
            this.activeSearches.add(query);
        }
        verifyMentionConfig(config) {
            if (!config.url) throw new Error('config.url is a required parameter');
            if (!config.securityProvider) config.securityProvider = $9565842f98e50876$var$emptySecurityProvider;
        }
        initialState(contextIdentifier) {
            return this.remoteInitialState(contextIdentifier);
        }
        clearContext(contextIdentifier = {}) {
            return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                    [key]: contextIdentifier[key],
                    ...context
                }), {});
        }
        getQueryParams(contextIdentifier) {
            const configParams = {};
            if (this.config.containerId) configParams['containerId'] = this.config.containerId;
            if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
            return {
                ...configParams,
                ...this.clearContext(contextIdentifier)
            };
        }
        async remoteInitialState(contextIdentifier) {
            const queryParams = this.getQueryParams(contextIdentifier);
            const options = {
                path: 'bootstrap',
                queryParams: queryParams
            };
            try {
                const result = await (0, $dS9cn.utils).requestService(this.config, options);
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), (0, (0, parcelRequire("cqJWb")).SliNames).INITIAL_STATE, (0, (0, parcelRequire("cqJWb")).Actions).SUCCEEDED);
                return this.transformServiceResponse(result, '');
            } catch (error) {
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), (0, (0, parcelRequire("cqJWb")).SliNames).INITIAL_STATE, (0, (0, parcelRequire("cqJWb")).Actions).FAILED);
                throw error;
            }
        }
        search(query, contextIdentifier) {
            return {
                mentions: this.remoteSearch(query, contextIdentifier)
            };
        }
        async remoteSearch(query, contextIdentifier) {
            const options = {
                path: 'search',
                queryParams: {
                    query: query,
                    limit: $9565842f98e50876$var$MAX_QUERY_ITEMS,
                    ...this.getQueryParams(contextIdentifier)
                }
            };
            try {
                const result = await (0, $dS9cn.utils).requestService(this.config, options);
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), (0, (0, parcelRequire("cqJWb")).SliNames).SEARCH, (0, (0, parcelRequire("cqJWb")).Actions).SUCCEEDED);
                return this.transformServiceResponse(result, query);
            } catch (error) {
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), (0, (0, parcelRequire("cqJWb")).SliNames).SEARCH, (0, (0, parcelRequire("cqJWb")).Actions).FAILED);
                throw error;
            }
        }
        transformServiceResponse(result, query) {
            const mentions = result.mentions.map((mention)=>{
                let lozenge;
                if ((0, (0, parcelRequire("cqJWb")).isAppMention)(mention)) lozenge = mention.userType;
                else if ((0, (0, parcelRequire("cqJWb")).isTeamMention)(mention)) lozenge = mention.userType;
                return {
                    ...mention,
                    lozenge: lozenge,
                    query: query
                };
            });
            return {
                ...result,
                mentions: mentions,
                query: result.query || query
            };
        }
        async recordSelection(mention, contextIdentifier) {
            const options = {
                path: 'record',
                queryParams: {
                    selectedUserId: mention.id,
                    ...this.getQueryParams(contextIdentifier)
                },
                requestInit: {
                    method: 'POST'
                }
            };
            const sliName = (0, (0, parcelRequire("cqJWb")).isTeamMention)(mention) ? (0, (0, parcelRequire("cqJWb")).SliNames).SELECT_TEAM : (0, (0, parcelRequire("cqJWb")).SliNames).SELECT;
            try {
                const result = await (0, $dS9cn.utils).requestService(this.config, options);
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), sliName, (0, (0, parcelRequire("cqJWb")).Actions).SUCCEEDED);
                return result;
            } catch (error) {
                this._notifyAnalyticsListeners((0, (0, parcelRequire("4kfbr")).SLI_EVENT_TYPE), sliName, (0, (0, parcelRequire("cqJWb")).Actions).FAILED);
                throw error;
            }
        }
    }
    class $9565842f98e50876$export$65bd6083489bd8bb {
        constructor(statusCode, statusMessage){
            this.statusCode = statusCode;
            this.message = statusMessage;
            this.name = 'HttpError';
            this.stack = new Error().stack;
        }
    }
    const $9565842f98e50876$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
    var $9565842f98e50876$export$2e2bcd8739ae039 = $9565842f98e50876$export$5a4331e3e1c43553;
});
parcelRegister("6Ctoj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e109bd73548e92fc$export$2e2bcd8739ae039);
    let $e109bd73548e92fc$var$debugEnabled = false;
    let $e109bd73548e92fc$var$stacktracesEnabled = false;
    function $e109bd73548e92fc$export$748ada60eaf985cc(enable) {
        $e109bd73548e92fc$var$debugEnabled = enable;
    }
    function $e109bd73548e92fc$export$4f7017086af31c25(enable) {
        $e109bd73548e92fc$var$stacktracesEnabled = enable;
    }
    function $e109bd73548e92fc$export$2a858f450a2f66d() {
        if ($e109bd73548e92fc$var$stacktracesEnabled) console.log(new Error().stack);
    }
    function $e109bd73548e92fc$export$2e2bcd8739ae039(msg, ...args) {
        if ($e109bd73548e92fc$var$debugEnabled) console.log(msg, ...args);
    }
});
parcelRegister("4QRz9", function(module, exports) {
    $parcel$export(module.exports, "subProductFromProjectType", ()=>$e6c9433376b7f0e7$export$246e1e2a5c86a633);
    var $2vSU6;
    const $e6c9433376b7f0e7$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
    const $e6c9433376b7f0e7$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
    const $e6c9433376b7f0e7$var$CORE_APPLICATION_ROLE = 'jira-core';
    const $e6c9433376b7f0e7$export$246e1e2a5c86a633 = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return 'Jira Service Management';
            default:
                return 'Jira';
        }
    };
});
parcelRegister("eqACH", function(module, exports) {
    $parcel$export(module.exports, "TeamMentionProvider", ()=>$b205363457eed1d3$export$d113415d07aa661c);
    var $hb4ta;
    const $b205363457eed1d3$var$BaseSmartMentionConfigOptions = {
        env: 'prod',
        productKey: 'jira',
        includeTeams: true,
        includeUsers: false
    };
    class $b205363457eed1d3$export$d113415d07aa661c extends (0, (0, parcelRequire("hb4ta")).default) {
        constructor({ cloudId: cloudId, orgId: orgId, userId: userId }){
            super({
                ...$b205363457eed1d3$var$BaseSmartMentionConfigOptions,
                siteId: cloudId,
                orgId: orgId,
                principalId: userId ?? undefined
            });
        }
    }
});
parcelRegister("hb4ta", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78b5826b69e4fa06$export$2e2bcd8739ae039);
    var $3mm6g;
    var $cqJWb;
    var $2tzKd;
    var $029gh;
    var $2amqV;
    var $8sKzN;
    const $78b5826b69e4fa06$var$CONTEXT_TYPE = 'Mentions';
    const $78b5826b69e4fa06$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
    class $78b5826b69e4fa06$var$SmartMentionResource extends (0, (0, parcelRequire("3mm6g")).AbstractMentionResource) {
        constructor(smartMentionConfig){
            super();
            this.smartMentionConfig = $78b5826b69e4fa06$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
                ...smartMentionConfig,
                mentionNameResolver: new (0, (0, parcelRequire("2amqV")).DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
            };
            this.lastReturnedSearch = 0;
        }
        shouldHighlightMention(mention) {
            if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
            return false;
        }
        notify(searchTime, mentionResult, query) {
            if (searchTime > this.lastReturnedSearch) {
                this.lastReturnedSearch = searchTime;
                this._notifyListeners(mentionResult, {
                    duration: Date.now() - searchTime
                });
            }
            this._notifyAllResultsListeners(mentionResult);
        }
        notifyError(error, query) {
            this._notifyErrorListeners(error, query);
        }
        async filter(query, contextIdentifier) {
            this.contextIdentifier = contextIdentifier;
            const searchTime = Date.now();
            try {
                let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
                this.notify(searchTime, results, query);
            } catch (error) {
                this.notifyError(error, query);
            }
        }
        async getRecommendedMentions(query, contextIdentifier) {
            const startTime = window.performance.now();
            const conf = this.smartMentionConfig;
            const maxNumberOfResults = conf.maxNumberOfResults || 100;
            const request = {
                baseUrl: conf.baseUrl,
                context: {
                    productKey: conf.productKey,
                    contextType: $78b5826b69e4fa06$var$CONTEXT_TYPE,
                    principalId: conf.principalId || 'context',
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    siteId: conf.siteId,
                    organizationId: conf.orgId,
                    objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                    sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
                },
                includeGroups: conf.includeGroups,
                includeTeams: conf.includeTeams,
                includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
                maxNumberOfResults: maxNumberOfResults,
                searchQueryFilter: conf.searchQueryFilter,
                query: query
            };
            try {
                this._notifyAnalyticsListeners((0, (0, parcelRequire("029gh")).SMART_EVENT_TYPE), 'users', (0, (0, parcelRequire("029gh")).Actions).REQUESTED, (0, (0, parcelRequire("029gh")).defaultAttributes)(contextIdentifier));
                const users = await (0, (0, parcelRequire("8sKzN")).default)(request);
                const elapsedTimeMilli = window.performance.now() - startTime;
                const usersForAnalytics = (0, (0, parcelRequire("029gh")).getUsersForAnalytics)(users);
                this._notifyAnalyticsListeners((0, (0, parcelRequire("029gh")).SMART_EVENT_TYPE), 'usersRequest', (0, (0, parcelRequire("029gh")).Actions).SUCCESSFUL, {
                    elapsedTimeMilli: elapsedTimeMilli,
                    users: usersForAnalytics,
                    displayedUsers: usersForAnalytics,
                    ...(0, (0, parcelRequire("029gh")).defaultAttributes)(contextIdentifier)
                });
                const mentions = this.transformUsersToMentions(users);
                return {
                    mentions: mentions,
                    query: query
                };
            } catch (e) {
                const elapsedTimeMilli = window.performance.now() - startTime;
                this._notifyAnalyticsListeners((0, (0, parcelRequire("029gh")).SMART_EVENT_TYPE), 'usersRequest', (0, (0, parcelRequire("029gh")).Actions).FAILED, {
                    elapsedTimeMilli: elapsedTimeMilli,
                    ...(0, (0, parcelRequire("029gh")).defaultAttributes)(contextIdentifier)
                });
                throw e instanceof Error ? e : new Error(String(e));
            }
        }
        transformTeamMember(member) {
            return {
                id: member.id,
                name: member.name
            };
        }
        transformUserToMention(item) {
            const type = item.entityType;
            let defaultVals = {
                source: 'smarts'
            };
            if (type === (0, (0, parcelRequire("2tzKd")).EntityType).USER) {
                const user = item;
                return {
                    ...defaultVals,
                    id: user.id,
                    accessLevel: user.accessLevel,
                    avatarUrl: user.avatarUrl,
                    mentionName: user.nickname || '',
                    name: user.name,
                    userType: user.userType
                };
            }
            if (type === (0, (0, parcelRequire("2tzKd")).EntityType).TEAM) {
                const team = item;
                let teamLink = '';
                const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
                if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
                return {
                    ...defaultVals,
                    id: team.id,
                    name: team.displayName || '',
                    mentionName: team.displayName,
                    avatarUrl: team.smallAvatarImageUrl,
                    accessLevel: (0, (0, parcelRequire("cqJWb")).UserAccessLevel)[(0, (0, parcelRequire("cqJWb")).UserAccessLevel).CONTAINER],
                    userType: (0, (0, parcelRequire("cqJWb")).UserType)[(0, (0, parcelRequire("cqJWb")).UserType).TEAM],
                    lozenge: (0, (0, parcelRequire("cqJWb")).UserType)[(0, (0, parcelRequire("cqJWb")).UserType).TEAM],
                    context: {
                        members: team.members ? team.members.map(this.transformTeamMember) : [],
                        includesYou: team.includesYou || false,
                        memberCount: team.memberCount || 0,
                        teamLink: teamLink || defaultTeamLink
                    },
                    source: 'smarts'
                };
            }
            if (type === (0, (0, parcelRequire("2tzKd")).EntityType).GROUP) {
                const group = item;
                return {
                    ...defaultVals,
                    id: group.id,
                    userType: type.toLowerCase(),
                    name: group.name || '',
                    lozenge: type.toLowerCase()
                };
            }
            return {
                id: item.id,
                userType: (0, (0, parcelRequire("2tzKd")).EntityType).USER.toLowerCase(),
                avatarUrl: item.avatarUrl,
                name: item.name,
                lozenge: (0, (0, parcelRequire("2tzKd")).EntityType).USER.toLowerCase()
            };
        }
        transformUsersToMentions(recommendationItems) {
            return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
        }
        cacheMentionName(id, mentionName) {
            this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
        }
        resolveMentionName(id) {
            return this.smartMentionConfig.mentionNameResolver.lookupName(id);
        }
        supportsMentionNameResolving() {
            return true;
        }
        recordMentionSelection(_mention) {
            this._notifyAnalyticsListeners((0, (0, parcelRequire("029gh")).SMART_EVENT_TYPE), 'usersRequest', (0, (0, parcelRequire("029gh")).Actions).SELECTED, {
                selectedOption: _mention.id,
                ...(0, (0, parcelRequire("029gh")).defaultAttributes)(this.contextIdentifier)
            });
        }
    }
    var $78b5826b69e4fa06$export$2e2bcd8739ae039 = $78b5826b69e4fa06$var$SmartMentionResource;
});
parcelRegister("2tzKd", function(module, exports) {
    $parcel$export(module.exports, "EntityType", ()=>$9143070c87bffca9$export$8eda7e02f8f033b2);
    var $9143070c87bffca9$export$8eda7e02f8f033b2;
    (function(EntityType) {
        EntityType["USER"] = "USER";
        EntityType["TEAM"] = "TEAM";
        EntityType["GROUP"] = "GROUP";
    })($9143070c87bffca9$export$8eda7e02f8f033b2 || ($9143070c87bffca9$export$8eda7e02f8f033b2 = {}));
});
parcelRegister("029gh", function(module, exports) {
    $parcel$export(module.exports, "SMART_EVENT_TYPE", ()=>$9ae0decad8e7664b$export$c724588856bbfbcf);
    $parcel$export(module.exports, "Actions", ()=>$9ae0decad8e7664b$export$b52183d5cfb26dc9);
    $parcel$export(module.exports, "defaultAttributes", ()=>$9ae0decad8e7664b$export$38cd8db2db178f58);
    $parcel$export(module.exports, "getUsersForAnalytics", ()=>$9ae0decad8e7664b$export$e8be30a842a4b49d);
    const $9ae0decad8e7664b$export$c724588856bbfbcf = 'smart';
    var $9ae0decad8e7664b$export$b52183d5cfb26dc9;
    (function(Actions) {
        Actions["REQUESTED"] = "requested";
        Actions["SUCCESSFUL"] = "successful";
        Actions["SEARCHED"] = "searched";
        Actions["FAILED"] = "failed";
        Actions["SELECTED"] = "selected";
    })($9ae0decad8e7664b$export$b52183d5cfb26dc9 || ($9ae0decad8e7664b$export$b52183d5cfb26dc9 = {}));
    const $9ae0decad8e7664b$export$38cd8db2db178f58 = (context)=>{
        return {
            context: context?.objectId || '',
            sessionId: context?.sessionId || '',
            pickerType: 'mentions',
            source: 'smarts'
        };
    };
    const $9ae0decad8e7664b$export$e8be30a842a4b49d = (users)=>{
        return users ? users.map(({ id: id, entityType: entityType })=>({
                id: id,
                type: entityType.toLowerCase()
            })) : [];
    };
});
parcelRegister("2amqV", function(module, exports) {
    $parcel$export(module.exports, "DefaultMentionNameResolver", ()=>$d7e94daccd487415$export$2ae0434dccdcb77e);
    var $cqJWb;
    var $12kuH;
    var $lfBO6;
    const $d7e94daccd487415$var$buildUsersQuery = (accountIds)=>({
            query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
            variables: {
                accountIds: accountIds
            }
        });
    const $d7e94daccd487415$var$makeRequest = async (url, accountIds)=>{
        const query = $d7e94daccd487415$var$buildUsersQuery(accountIds);
        return (0, (0, parcelRequire("lfBO6")).graphqlQuery)(url, query);
    };
    class $d7e94daccd487415$export$2ae0434dccdcb77e {
        constructor(baseUrl){
            this.baseUrl = baseUrl;
            this.cache = new Map();
        }
        async lookupName(id) {
            try {
                if (this.cache.has(id)) return {
                    id: id,
                    name: this.cache.get(id),
                    status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).OK
                };
                const url = (0, (0, parcelRequire("12kuH")).PRD_CONFIG).getGraphQLUrl(this.baseUrl);
                const data = await $d7e94daccd487415$var$makeRequest(url, [
                    id
                ]);
                const userInfo = data.users?.find((user)=>user.accountId === id);
                return userInfo ? {
                    id: id,
                    name: userInfo.name,
                    status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).OK
                } : {
                    id: id,
                    status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).UNKNOWN
                };
            } catch (error) {
                return {
                    id: id,
                    status: (0, (0, parcelRequire("cqJWb")).MentionNameStatus).UNKNOWN
                };
            }
        }
        cacheName(id, name) {
            this.cache.set(id, name);
        }
    }
});
parcelRegister("12kuH", function(module, exports) {
    $parcel$export(module.exports, "PRD_CONFIG", ()=>$e1f33aba6362497a$export$d4fff2dfff3e2bc1);
    const $e1f33aba6362497a$export$d4fff2dfff3e2bc1 = {
        getRecommendationServiceUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
        },
        getUsersServiceUrl (productKey) {
            return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
        },
        getGraphQLUrl (baseUrl) {
            return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
        },
        getTeamsUrl (baseUrl) {
            return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
        }
    };
});
parcelRegister("lfBO6", function(module, exports) {
    $parcel$export(module.exports, "graphqlQuery", ()=>$9b021ceaa75f64e1$export$74eb8d79ae3e02b5);
    const $9b021ceaa75f64e1$var$buildHeaders = ()=>{
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    function $9b021ceaa75f64e1$export$74eb8d79ae3e02b5(serviceUrl, query) {
        const headers = $9b021ceaa75f64e1$var$buildHeaders();
        return fetch(new Request(`${serviceUrl}`, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify(query)
        })).then((response)=>{
            if (!response.ok) return Promise.reject({
                code: response.status,
                reason: response.statusText
            });
            return response;
        }).then((response)=>response.json()).then((json)=>{
            if (json.errors) return Promise.reject({
                reason: json.errors[0]?.category || 'default'
            });
            return json.data;
        });
    }
});
parcelRegister("8sKzN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$674292251195da91$export$2e2bcd8739ae039);
    var $12kuH;
    const $674292251195da91$var$getUserRecommendations = (request)=>{
        const url = (0, (0, parcelRequire("12kuH")).PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
        return fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                context: request.context,
                includeUsers: request.includeUsers,
                includeGroups: request.includeGroups,
                includeTeams: request.includeTeams,
                maxNumberOfResults: request.maxNumberOfResults,
                performSearchQueryOnly: false,
                searchQuery: {
                    cpusQueryHighlights: {
                        query: '',
                        field: ''
                    },
                    customQuery: '',
                    customerDirectoryId: '',
                    filter: request.searchQueryFilter || '',
                    minimumAccessLevel: 'APPLICATION',
                    queryString: request.query,
                    restrictTo: {
                        userIds: [],
                        groupIds: []
                    },
                    searchUserbase: false
                }
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject({
                message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
            });
        }).then((response)=>response.recommendedUsers);
    };
    var $674292251195da91$export$2e2bcd8739ae039 = $674292251195da91$var$getUserRecommendations;
});
parcelRegister("QTixP", function(module, exports) {
    $parcel$export(module.exports, "getProductForEditorAIPlugin", ()=>$ea0224ff44292610$export$ae2611ff27e7ff5);
    $parcel$export(module.exports, "useSharedEditorConfig", ()=>$ea0224ff44292610$export$a74853f2a973f6f);
    $parcel$export(module.exports, "useEditorConfig", ()=>$ea0224ff44292610$export$68f5e61568cc49bc);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkJfY;
    var $gI3Ag;
    var $3rirz;
    var $2vSU6;
    var $dJl1T;
    var $6s1PB;
    var $4R6GH;
    var $7iULw;
    var $dseDh;
    var $ousew;
    var $koVbs;
    var $iixvy;
    var $5NH95;
    var $f7Fws;
    var $l9wag;
    const $ea0224ff44292610$var$FEEDBACK_COLLECTOR_ID = 'fb2a9bff-f1e7-4deb-b396-7bfaae5af671';
    const $ea0224ff44292610$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
    const $ea0224ff44292610$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
    const $ea0224ff44292610$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
    const $ea0224ff44292610$var$buildAdditionalFields = (props, hasUserConsent)=>{
        if (!props || !props.getAIExperience) return undefined;
        const { getAIExperience: getAIExperience, sentiment: sentiment, editorAttributes: editorAttributes } = props;
        const aiExperience = getAIExperience?.(hasUserConsent) || {};
        let feedbackMetadataStringified = `sentiment: ${sentiment}\n`;
        Object.entries({
            ...aiExperience,
            ...editorAttributes
        }).forEach((item)=>{
            feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
        });
        return [
            {
                id: $ea0224ff44292610$var$FEEDBACK_CONTEXT_ID,
                value: feedbackMetadataStringified
            }
        ];
    };
    const $ea0224ff44292610$var$CanContactLabel = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("f7Fws")).default).canContactText,
            values: {
                a: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        target: "_blank",
                        href: $ea0224ff44292610$var$LINK_TO_PRIVACY_POLICY
                    }, chunks)
            }
        });
    const $ea0224ff44292610$var$EnrolLabel = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("f7Fws")).default).improveAtlassianText,
            values: {
                a: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        target: "_blank",
                        href: $ea0224ff44292610$var$LINK_TO_RESEARCH_GROUP
                    }, chunks)
            }
        });
    const $ea0224ff44292610$export$ae2611ff27e7ff5 = (projectType)=>{
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                return (0, (0, parcelRequire("l9wag")).Product).JWM;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
                return (0, (0, parcelRequire("l9wag")).Product).JSW;
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                return (0, (0, parcelRequire("l9wag")).Product).JSM;
            case 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT:
                return (0, (0, parcelRequire("l9wag")).Product).JPD;
            default:
                return null;
        }
    };
    const $ea0224ff44292610$export$7543cd52952bad27 = (editorPluginAIConfig)=>{
        const isAIOptedIn = editorPluginAIConfig.isAiOptInEnabled;
        return isAIOptedIn ? 'enabled' : 'disabled';
    };
    const $ea0224ff44292610$export$ff2962de2b2c930f = (product)=>{
        switch(product){
            case (0, (0, parcelRequire("l9wag")).Product).JSW:
                return 'jira-software';
            case (0, (0, parcelRequire("l9wag")).Product).JPD:
                return 'jpd';
            case (0, (0, parcelRequire("l9wag")).Product).JSM:
                return 'jsm';
            default:
                return 'jira';
        }
    };
    const $ea0224ff44292610$export$a74853f2a973f6f = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const PromptEditor = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gI3Ag")).createPromptEditor)({
                linking: editorPluginAIConfig?.linking,
                featureFlags: {},
                enableLinks: !!editorPluginAIConfig?.linking
            }), [
            editorPluginAIConfig?.linking
        ]);
        const editorPluginAI = (0, $5uXOq.useMemo)(()=>{
            if (!editorPluginAIConfig?.product) return undefined;
            const optInStatus = $ea0224ff44292610$export$7543cd52952bad27(editorPluginAIConfig);
            const editorPluginAIProvider = (0, (0, parcelRequire("3rirz")).createJiraEditorPluginAIProvider)({
                generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
                issueId: (0, (0, parcelRequire("4R6GH")).fg)('platform_editor_ai_suggested_response_fg') ? editorPluginAIConfig?.issueId : undefined,
                product: editorPluginAIConfig.product,
                allowIssueReformatter: (0, (0, parcelRequire("4R6GH")).fg)('platform_gravityai-1853_issue_reformatter_ga') ? editorPluginAIConfig?.allowIssueReformatter : editorPluginAIConfig.product === (0, (0, parcelRequire("l9wag")).Product).JSW && editorPluginAIConfig?.allowIssueReformatter,
                allowSuggestResponse: editorPluginAIConfig.allowSuggestResponse,
                getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
                handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                    try {
                        openFeedbackCollector({
                            entrypointId: (0, (0, parcelRequire("7iULw")).ENTRY_POINT_ID_GENERATIVE_AI),
                            feedbackCollectorId: $ea0224ff44292610$var$FEEDBACK_COLLECTOR_ID,
                            feedbackContext: [
                                {
                                    id: 'sentiment',
                                    value: sentiment
                                },
                                ...Object.entries(getAIExperience?.() ?? {}).map(([id, value])=>({
                                        id: id,
                                        value: value
                                    })),
                                ...Object.entries(editorAttributes).map(([id, value])=>({
                                        id: id,
                                        value: value
                                    }))
                            ]
                        });
                        return {
                            status: 'submitted'
                        };
                    } catch (error) {
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                        return {
                            status: 'failed'
                        };
                    }
                },
                PromptEditor: PromptEditor,
                getChannelVariables: editorPluginAIConfig?.getChannelVariables,
                actionSideEffects: editorPluginAIConfig?.actionSideEffects,
                actionOverrides: editorPluginAIConfig?.actionOverrides
            });
            return (0, (0, parcelRequire("3rirz")).createJiraEditorPluginAI)({
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: {
                    status: optInStatus,
                    triggerOptInFlow: ()=>{}
                }
            }).editorPluginAI;
        }, [
            editorPluginAIConfig,
            openFeedbackCollector,
            PromptEditor
        ]);
        return {
            dangerouslyAppendPlugins: {
                __plugins: editorPluginAI ? [
                    editorPluginAI
                ] : []
            }
        };
    };
    const $ea0224ff44292610$var$fireEmptyExperimentExposure = ()=>{};
    const $ea0224ff44292610$export$68f5e61568cc49bc = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
        const { openFeedbackCollector: openFeedbackCollector, updateCustomRenderComponent: updateCustomRenderComponent, updateAdditionalFields: updateAdditionalFields } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, (0, parcelRequire("iixvy")).useAIOptIn)({
            editorPluginAIConfig: editorPluginAIConfig
        });
        const [config] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_free_ai_feature_gate');
        const { isEnrolledInExperiment: isAIUpsellInEditorFreeEnrolled, isExperimentEnabled: isAIUpsellInEditorFreeEnabled, fireExperimentExposure: fireAIUpsellInEditorFreeExposure } = config.get('experimentEnabled', undefined) !== undefined ? (0, (0, parcelRequire("5NH95")).useAIUpsellInEditorFree)(optInStatus, editorPluginAIConfig?.product) : {
            isEnrolledInExperiment: false,
            isExperimentEnabled: false,
            fireExperimentExposure: $ea0224ff44292610$var$fireEmptyExperimentExposure
        };
        (0, $5uXOq.useEffect)(()=>{
            if (isAIUpsellInEditorFreeEnrolled) fireAIUpsellInEditorFreeExposure();
        }, [
            isAIUpsellInEditorFreeEnrolled,
            fireAIUpsellInEditorFreeExposure
        ]);
        const [hasUserConsent, setHasUserConsent] = (0, $5uXOq.useState)(false);
        const [additionalFieldsData, setAdditionalFieldsData] = (0, $5uXOq.useState)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleHasUserConsent = (0, $5uXOq.useCallback)(()=>{
            setHasUserConsent(!hasUserConsent);
            updateAdditionalFields($ea0224ff44292610$var$buildAdditionalFields(additionalFieldsData, !hasUserConsent));
        }, [
            hasUserConsent,
            additionalFieldsData,
            updateAdditionalFields
        ]);
        const renderCustomFeedbackContent = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
                label: formatMessage((0, (0, parcelRequire("f7Fws")).default).userConsentCheckboxLabel),
                onChange: handleHasUserConsent,
                isChecked: hasUserConsent
            }), [
            hasUserConsent,
            formatMessage,
            handleHasUserConsent
        ]);
        const PromptEditor = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gI3Ag")).createPromptEditor)({
                linking: editorPluginAIConfig?.linking,
                featureFlags: {},
                enableLinks: !!editorPluginAIConfig?.linking
            }), [
            editorPluginAIConfig?.linking
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateCustomRenderComponent(renderCustomFeedbackContent);
        }, [
            renderCustomFeedbackContent,
            updateCustomRenderComponent
        ]);
        const AIConfiguration = (0, $5uXOq.useMemo)(()=>{
            if (!editorPluginAIConfig?.product) return undefined;
            const editorPluginAIProvider = (0, (0, parcelRequire("3rirz")).createJiraEditorPluginAIProvider)({
                aiLifeCycleDynamicAttributesGetter: editorPluginAIConfig.aiLifeCycleDynamicAttributesGetter,
                generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
                issueId: (0, (0, parcelRequire("4R6GH")).fg)('platform_editor_ai_suggested_response_fg') ? editorPluginAIConfig?.issueId : undefined,
                product: editorPluginAIConfig.product,
                allowIssueReformatter: (0, (0, parcelRequire("4R6GH")).fg)('platform_gravityai-1853_issue_reformatter_ga') ? editorPluginAIConfig?.allowIssueReformatter : editorPluginAIConfig.product === (0, (0, parcelRequire("l9wag")).Product).JSW && editorPluginAIConfig?.allowIssueReformatter,
                allowSuggestResponse: editorPluginAIConfig.allowSuggestResponse,
                getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
                handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                    const feedbackContextData = {
                        getAIExperience: getAIExperience,
                        sentiment: sentiment,
                        editorAttributes: editorAttributes
                    };
                    const feedbackCollectorProps = {
                        entrypointId: (0, (0, parcelRequire("7iULw")).ENTRY_POINT_ID_GENERATIVE_AI),
                        feedbackTitle: formatMessage((0, (0, parcelRequire("f7Fws")).default).feedBackTitle),
                        feedbackCollectorId: $ea0224ff44292610$var$FEEDBACK_COLLECTOR_ID,
                        renderCustomContent: renderCustomFeedbackContent,
                        showTypeField: false,
                        summaryPlaceholder: formatMessage((0, (0, parcelRequire("f7Fws")).default).summaryPlaceholder),
                        additionalFields: $ea0224ff44292610$var$buildAdditionalFields(feedbackContextData, hasUserConsent),
                        canBeContactedLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($ea0224ff44292610$var$CanContactLabel, null),
                        enrolInResearchLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($ea0224ff44292610$var$EnrolLabel, null)
                    };
                    setAdditionalFieldsData(feedbackContextData);
                    try {
                        openFeedbackCollector(feedbackCollectorProps);
                        return {
                            status: 'submitted'
                        };
                    } catch (error) {
                        (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                        return {
                            status: 'failed'
                        };
                    }
                },
                PromptEditor: PromptEditor,
                AIButtonWrapper: isAIUpsellInEditorFreeEnabled ? (0, (0, parcelRequire("5NH95")).AIUpsellButtonWrapper) : undefined,
                getChannelVariables: editorPluginAIConfig?.getChannelVariables,
                actionSideEffects: editorPluginAIConfig?.actionSideEffects,
                actionOverrides: editorPluginAIConfig?.actionOverrides
            });
            return {
                plugin: (0, (0, parcelRequire("3rirz")).createJiraEditorPluginAI)({
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: {
                        status: optInStatus,
                        triggerOptInFlow: triggerOptInFlow
                    }
                }).editorPluginAI,
                AIConfiguration: {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: {
                        status: optInStatus,
                        triggerOptInFlow: triggerOptInFlow
                    }
                }
            };
        }, [
            hasUserConsent,
            optInStatus,
            triggerOptInFlow,
            editorPluginAIConfig,
            openFeedbackCollector,
            formatMessage,
            renderCustomFeedbackContent,
            PromptEditor,
            isAIUpsellInEditorFreeEnabled
        ]);
        return {
            props: {
                dangerouslyAppendPlugins: {
                    __plugins: AIConfiguration?.plugin ? [
                        AIConfiguration.plugin
                    ] : []
                },
                isAIUpsellInEditorFreeEnabled: isAIUpsellInEditorFreeEnabled
            },
            AIConfiguration: AIConfiguration?.AIConfiguration,
            components: {
                AIOptInModal: AIOptInModal
            }
        };
    };
});
parcelRegister("gI3Ag", function(module, exports) {
    $parcel$export(module.exports, "createPromptEditor", ()=>$9d86ac563656b71b$export$df4eed2eacb29ddb);
    var $5uXOq = parcelRequire("5uXOq");
    var $20Kbb;
    var $kjU5q;
    var $ankW9;
    var $5Xe3v;
    var $gZGBX;
    var $fLTqo;
    var $gmhCD = parcelRequire("gmhCD");
    var $eqXnF;
    var $5xDEh;
    const $9d86ac563656b71b$var$EditorWrapper = (props)=>{
        const appearance = 'chromeless';
        const { editorProps: editorProps, options: options } = props;
        const { onInputChange: onInputChange, onADFChange: onADFChange, defaultValue: defaultValue, enableLinks: enableLinks, setFocusHandlers: setFocusHandlers, setClearHandler: setClearHandler, setReplaceDocumentHandler: setReplaceDocumentHandler } = editorProps;
        const onChange = (0, $5uXOq.useCallback)((editorView)=>{
            if (onADFChange) onADFChange((0, (0, parcelRequire("20Kbb")).toJSON)(editorView.state.doc));
            if (onInputChange) {
                const textSerializer = (0, (0, parcelRequire("fLTqo")).default).fromSchema(editorView.state.schema);
                const text = textSerializer.serializeFragment(editorView.state.doc.content);
                onInputChange(text);
            }
        }, [
            onInputChange,
            onADFChange
        ]);
        const onSave = (0, $5uXOq.useCallback)((editorView)=>{
            onChange(editorView);
        }, [
            onChange
        ]);
        const { preset: preset, editorApi: editorApi } = (0, (0, parcelRequire("5Xe3v")).usePreset)(()=>(0, (0, parcelRequire("eqXnF")).createAIPromptPreset)({
                ...options,
                placeholder: {
                    placeholder: editorProps.placeholder
                },
                onSave: onSave,
                enableLinks: enableLinks
            }), [
            options,
            editorProps.placeholder
        ]);
        const onEditorReady = (0, $5uXOq.useCallback)((editorActions)=>{
            if (setClearHandler) setClearHandler(()=>editorActions.clear());
            if (setReplaceDocumentHandler && (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true)) setReplaceDocumentHandler((adf)=>editorActions.replaceDocument(adf));
            const editorView = editorActions._privateGetEditorView();
            if (editorView) {
                if (!editorActions.isDocumentEmpty()) editorView.dispatch(editorView.state.tr.setSelection(new (0, (0, parcelRequire("gZGBX")).AllSelection)(editorView.state.doc)));
            }
        }, [
            setClearHandler,
            setReplaceDocumentHandler
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (setFocusHandlers) setFocusHandlers(editorApi?.core?.actions.blur, editorApi?.core?.actions.focus);
        }, [
            editorApi,
            setFocusHandlers
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kjU5q")).ComposableEditor), {
            autoformattingProvider: (0, (0, parcelRequire("5xDEh")).maybeBuild1pAutoFormattingProvider)(options),
            appearance: appearance,
            minHeight: 20,
            preset: preset,
            shouldFocus: true,
            defaultValue: defaultValue,
            onChange: onChange,
            onEditorReady: onEditorReady
        });
    };
    function $9d86ac563656b71b$export$df4eed2eacb29ddb(options) {
        return (props)=>{
            const editorProps = {
                editorProps: props,
                options: options
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ankW9")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($9d86ac563656b71b$var$EditorWrapper, editorProps));
        };
    }
});
parcelRegister("20Kbb", function(module, exports) {
    $parcel$export(module.exports, "isParagraph", ()=>$4198c3b63e236a69$export$d7ae8c533ae18832);
    $parcel$export(module.exports, "isText", ()=>$4198c3b63e236a69$export$1879817ac5c922b7);
    $parcel$export(module.exports, "isLinkMark", ()=>$4198c3b63e236a69$export$5dfeda3a9e6fe056);
    $parcel$export(module.exports, "SelectedState", ()=>$4198c3b63e236a69$export$a6212ae0c82963af);
    $parcel$export(module.exports, "isNodeSelectedOrInRange", ()=>$4198c3b63e236a69$export$5125f50e751e84db);
    $parcel$export(module.exports, "isSupportedInParent", ()=>$4198c3b63e236a69$export$b6e38334b1fb4d1b);
    $parcel$export(module.exports, "isMediaNode", ()=>$4198c3b63e236a69$export$d6ca4605aefeca32);
    $parcel$export(module.exports, "isNodeBeforeMediaNode", ()=>$4198c3b63e236a69$export$cfaa7840b0c93780);
    $parcel$export(module.exports, "toJSON", ()=>$4198c3b63e236a69$export$54fd2c36b5cc6731);
    $parcel$export(module.exports, "nodeToJSON", ()=>$4198c3b63e236a69$export$3a858d3babd60825);
    var $hYNZx;
    var $5r0mK = parcelRequire("5r0mK");
    const $4198c3b63e236a69$export$cdc577fd3f583194 = (tr)=>{
        const nodes = [];
        const steps = tr.steps || [];
        steps.forEach((step)=>{
            step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                    if (!nodes.find((n)=>n === node)) nodes.push(node);
                    return false;
                });
            });
        });
        return nodes;
    };
    const $4198c3b63e236a69$export$4c39e41e39b3c449 = (node)=>{
        try {
            node.check();
        } catch (error) {
            return false;
        }
        return true;
    };
    const $4198c3b63e236a69$export$996213f7c272fc6f = (nodes)=>nodes.every($4198c3b63e236a69$export$4c39e41e39b3c449);
    const $4198c3b63e236a69$export$26b9f946b448f23e = (node, type)=>type && node && node.type === type;
    const $4198c3b63e236a69$export$d7ae8c533ae18832 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.paragraph);
    const $4198c3b63e236a69$export$1879817ac5c922b7 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.nodes.text);
    const $4198c3b63e236a69$export$5dfeda3a9e6fe056 = (node, schema)=>$4198c3b63e236a69$export$26b9f946b448f23e(node, schema.marks.link);
    var $4198c3b63e236a69$export$a6212ae0c82963af;
    (function(SelectedState) {
        SelectedState[SelectedState["selectedInRange"] = 0] = "selectedInRange";
        SelectedState[SelectedState["selectedInside"] = 1] = "selectedInside";
    })($4198c3b63e236a69$export$a6212ae0c82963af || ($4198c3b63e236a69$export$a6212ae0c82963af = {}));
    const $4198c3b63e236a69$export$5125f50e751e84db = (anchorPosition, headPosition, nodePosition, nodeSize)=>{
        if (typeof nodePosition !== 'number') return null;
        const rangeStart = Math.min(anchorPosition, headPosition);
        const rangeEnd = Math.max(anchorPosition, headPosition);
        const nodeStart = nodePosition;
        const nodeEnd = nodePosition + nodeSize;
        if (anchorPosition === headPosition) return null;
        if (rangeStart <= nodeStart && nodeEnd < rangeEnd || rangeStart < nodeStart && nodeEnd <= rangeEnd) return 0;
        if (nodeStart <= anchorPosition && headPosition <= nodeEnd) return 1;
        return null;
    };
    const $4198c3b63e236a69$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
        const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
        const parent = state.selection.$from.node(depth);
        return parent && parent.type.validContent(fragment);
    };
    const $4198c3b63e236a69$export$d6ca4605aefeca32 = (node)=>{
        return [
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name);
    };
    const $4198c3b63e236a69$export$cfaa7840b0c93780 = ($pos, state)=>{
        let nodeBefore = $pos.nodeBefore;
        if (!nodeBefore) {
            const depthOfParent = $pos.depth - 1 || 1;
            const parentNode = (0, $5r0mK.findParentNodeOfType)([
                state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
            ])(state.selection);
            const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
            const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
            if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
        }
        if (nodeBefore) return [
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(nodeBefore.type.name);
        return false;
    };
    const $4198c3b63e236a69$var$transformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    function $4198c3b63e236a69$export$54fd2c36b5cc6731(node) {
        return $4198c3b63e236a69$var$transformer.encode(node);
    }
    function $4198c3b63e236a69$export$3a858d3babd60825(node) {
        return $4198c3b63e236a69$var$transformer.encodeNode(node);
    }
});
parcelRegister("kjU5q", function(module, exports) {
    $parcel$export(module.exports, "ComposableEditor", ()=>$95f392e3544e55e0$export$36a7c46ebbddbc5d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7rHtO;
    var $1QYAr;
    function $95f392e3544e55e0$export$36a7c46ebbddbc5d(props) {
        const AppearanceComponent = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7rHtO")).default)(props.appearance), [
            props.appearance
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1QYAr")).CoreEditor), {
            ...props,
            AppearanceComponent: AppearanceComponent
        });
    }
});
parcelRegister("7rHtO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e8b0891f98bd31d$export$2e2bcd8739ae039);
    var $6ssPr;
    var $9YhuC;
    var $kuVsL;
    function $4e8b0891f98bd31d$export$2e2bcd8739ae039(appearance) {
        appearance = appearance || 'comment';
        switch(appearance){
            case 'full-page':
            case 'full-width':
                return 0, (0, parcelRequire("kuVsL")).FullPageEditor;
            case 'chromeless':
                return 0, (0, parcelRequire("6ssPr")).default;
            case 'comment':
                return 0, (0, parcelRequire("9YhuC")).CommentEditorWithIntl;
            default:
                throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
        }
    }
});
parcelRegister("6ssPr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74f2e2c18fdb60a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $awTmI;
    var $jZLtJ;
    var $iK9VQ;
    var $7s5ol;
    const $74f2e2c18fdb60a5$var$chromelessEditorStyles = (0, (0, parcelRequire("f8Sb3")).css)("line-height:20px;height:auto;overflow-x:hidden;overflow-y:auto;", (0, $4038285048829feb$export$b2380b18b089518f), "max-width:inherit;box-sizing:border-box;word-wrap:break-word;div > .ProseMirror{outline:none;white-space:pre-wrap;padding:0;margin:0;& > :last-child{padding-bottom:var(--ds-space-100, 0.5em);}}");
    const $74f2e2c18fdb60a5$var$ContentArea = (0, (0, parcelRequire("jZLtJ")).createEditorContentStyle)();
    $74f2e2c18fdb60a5$var$ContentArea.displayName = 'ContentArea';
    class $74f2e2c18fdb60a5$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = 'ChromelessEditorAppearance';
        }
        render() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)($74f2e2c18fdb60a5$var$RenderWithPluginState, {
                editorAPI: this.props.editorAPI,
                renderChrome: this.renderChrome
            });
        }
        constructor(...args){
            super(...args), this.appearance = 'chromeless', this.containerElement = null, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
                const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
                const maxContentSizeReached = Boolean(maxContentSize?.maxContentSizeReached);
                const { editorViewModeState: editorViewModeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(this.props.editorAPI, [
                    'editorViewMode'
                ]);
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7s5ol")).default), {
                    animate: maxContentSizeReached
                }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $74f2e2c18fdb60a5$var$chromelessEditorStyles,
                        maxHeight && (0, (0, parcelRequire("f8Sb3")).css)({
                            maxHeight: `${maxHeight}px`
                        }),
                        (0, (0, parcelRequire("f8Sb3")).css)({
                            minHeight: `${minHeight}px`
                        })
                    ],
                    "data-testid": "chromeless-editor",
                    ref: (ref)=>this.containerElement = ref
                }, (0, (0, parcelRequire("f8Sb3")).jsx)($74f2e2c18fdb60a5$var$ContentArea, {
                    className: "ak-editor-content-area",
                    featureFlags: featureFlags,
                    viewMode: editorViewModeState?.mode
                }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iK9VQ")).default), {
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    appearance: this.appearance,
                    items: contentComponents,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    containerElement: this.containerElement,
                    disabled: !!disabled,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    wrapperElement: this.containerElement,
                    pluginHooks: pluginHooks
                }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null)));
            };
        }
    }
    function $74f2e2c18fdb60a5$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
        const { maxContentSizeState: maxContentSizeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(editorAPI, [
            'maxContentSize'
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, renderChrome({
            maxContentSize: maxContentSizeState
        }));
    }
});
parcelRegister("awTmI", function(module, exports) {
    $parcel$export(module.exports, "useSharedPluginState", ()=>$c96ea81c1b46425f$export$a4c4fd90e2b72baa);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $c96ea81c1b46425f$var$mapValues(object, mapFunction) {
        return Object.entries(object).reduce((acc, [key, value])=>({
                ...acc,
                [key]: mapFunction(value)
            }), {});
    }
    function $c96ea81c1b46425f$var$useStaticPlugins(plugins) {
        return (0, $5uXOq.useMemo)(()=>plugins, []);
    }
    function $c96ea81c1b46425f$export$a4c4fd90e2b72baa(injectionApi, plugins) {
        const pluginNames = $c96ea81c1b46425f$var$useStaticPlugins(plugins);
        const namedExternalPlugins = (0, $5uXOq.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                    ...acc,
                    [`${String(pluginName)}State`]: injectionApi?.[pluginName]
                }), {}), [
            injectionApi,
            pluginNames
        ]);
        return $c96ea81c1b46425f$var$useSharedPluginStateInternal(namedExternalPlugins);
    }
    function $c96ea81c1b46425f$var$useSharedPluginStateInternal(externalPlugins) {
        const [pluginStates, setPluginState] = (0, $5uXOq.useState)($c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState()));
        const refStates = (0, $5uXOq.useRef)({});
        const mounted = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const debouncedPluginStateUpdate = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                setPluginState((currentPluginStates)=>({
                        ...currentPluginStates,
                        ...refStates.current
                    }));
            });
            if (mounted.current) {
                refStates.current = $c96ea81c1b46425f$var$mapValues(externalPlugins, (value)=>value?.sharedState.currentState());
                debouncedPluginStateUpdate();
            }
            const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
                return externalPlugin?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                    if (prevSharedState === nextSharedState) return;
                    refStates.current[pluginKey] = nextSharedState;
                    debouncedPluginStateUpdate();
                });
            });
            mounted.current = true;
            return ()=>{
                refStates.current = {};
                unsubs.forEach((cb)=>cb?.());
            };
        }, [
            externalPlugins
        ]);
        return pluginStates;
    }
});
const $4038285048829feb$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #44546F)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #2C3E5D)"};
  }
`;
parcelRegister("jZLtJ", function(module, exports) {
    $parcel$export(module.exports, "createEditorContentStyle", ()=>$6a8a55d341510e42$export$91e7c20fa6d6a4b5);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g0wej;
    var $gE8f9;
    var $3I3CN;
    var $3tpiv;
    var $fRmCC;
    var $aABH4;
    var $eAVGd;
    var $5Lu5s;
    var $1xqpZ;
    var $cx4Bg;
    var $cYeQP;
    var $7Acon;
    var $4E5wI;
    var $9zgV3;
    var $cr1aY;
    var $bYYy3;
    var $5fBxY;
    var $aN7BF;
    var $jlYLw;
    var $jQRg9;
    var $4jyW9;
    var $hVv9L;
    var $bv4Ps;
    var $aSoqv;
    var $iJOES;
    var $kRXi9;
    var $1bQ0V;
    var $jRk4M;
    var $ahG4O;
    var $fwxzS;
    parcelRequire("6jI8m");
    var $2uCrC;
    parcelRequire("ixETG");
    var $2PxPK;
    parcelRequire("4MADL");
    var $5oKtW;
    parcelRequire("kF9Xk");
    var $frkDk;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $VSDnB;
    var $hxoiH;
    var $fz5RS;
    var $9O4yy;
    var $cEh6Q;
    var $dv67m;
    var $cBEjw;
    var $hucfL;
    var $l5gcr;
    var $6UEu0;
    var $b3RpZ;
    var $aUTD3;
    var $5L329;
    function $6a8a55d341510e42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6a8a55d341510e42$export$4ea5976125a01ffa = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("aN7BF")).linkSharedStyle), ";}");
    const $6a8a55d341510e42$var$ruleStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("bv4Ps")).ruleSharedStyles)(), ";hr{cursor:pointer;padding:var(--ds-space-050, 4px) 0;margin:var(--ds-space-300, 24px) 0;background-clip:content-box;&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{outline:none;background-color:", `var(--ds-border-selected, ${(0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderColor)})`, ";}}}");
    const $6a8a55d341510e42$var$mentionsStyles = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("fRmCC")).MentionSharedCssClassName).MENTION_CONTAINER, "{&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " [data-mention-id]>span{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Background
    ]), "color:var(--ds-text-subtle, #44546F);}}.danger{.", (0, (0, parcelRequire("fRmCC")).MentionSharedCssClassName).MENTION_CONTAINER, ".", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>span>span{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", (0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackgroundWithOpacity)})`, ";}.", (0, (0, parcelRequire("fRmCC")).MentionSharedCssClassName).MENTION_CONTAINER, ">span>span>span{background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);}}");
    const $6a8a55d341510e42$var$listsStyles = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{li{position:relative;>p:not(:first-child){margin:var(--ds-space-050, 4px) 0 0 0;}>style:first-child+p{margin-top:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, (0, parcelRequire("gE8f9")).browser).safari ? (0, (0, parcelRequire("cYeQP")).codeBlockInListSafariFix) : '', ";}}");
    const $6a8a55d341510e42$var$emojiStyles = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("3tpiv")).EmojiSharedCssClassName).EMOJI_CONTAINER, "{display:inline-block;.", (0, (0, parcelRequire("3tpiv")).EmojiSharedCssClassName).EMOJI_NODE, "{cursor:pointer;&.", (0, (0, parcelRequire("3tpiv")).EmojiSharedCssClassName).EMOJI_IMAGE, ">span{display:flex;}}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{.", (0, (0, parcelRequire("3tpiv")).EmojiSharedCssClassName).EMOJI_SPRITE, ",.", (0, (0, parcelRequire("3tpiv")).EmojiSharedCssClassName).EMOJI_IMAGE, "{border-radius:2px;", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
    ]), ";}}}");
    const $6a8a55d341510e42$export$d3bdc0d52bb6c2c8 = {
        name: "12q9gkf",
        styles: ".ProseMirror .placeholder-decoration{color:var(--ds-text-subtlest, #626F86);width:100%;pointer-events:none;user-select:none;.placeholder-android{pointer-events:none;outline:none;user-select:none;position:absolute;}}"
    };
    const $6a8a55d341510e42$var$firstBlockNodeStyles = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{>.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).prefix, ",>.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ",>.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ",>div[data-task-list-local-id],>div[data-layout-section],>.", (0, (0, parcelRequire("cr1aY")).expandClassNames).prefix, "{&:first-child{margin-top:0;}}>hr:first-of-type{margin-top:0;}}");
    const $6a8a55d341510e42$export$42a58e6dfeaffebe = ()=>{
        return (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ssr_fix_block_controls') ? $6a8a55d341510e42$var$firstBlockNodeStyles : null;
    };
    const $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice = `1266px`;
    var $6a8a55d341510e42$var$_ref = {
        name: "1li8ktf",
        styles: ".hyperlink-open-link{min-width:24px;svg{max-width:18px;}}"
    };
    var $6a8a55d341510e42$var$_ref2 = {
        name: "1w3oq8q",
        styles: ".ProseMirror.ProseMirror-focused:has(.ProseMirror-mark-boundary-cursor){caret-color:transparent;}.ProseMirror:not(.ProseMirror-focused) .ProseMirror-mark-boundary-cursor{display:none;}"
    };
    var $6a8a55d341510e42$var$_ref3 = {
        name: "u7i8rn",
        styles: ".ProseMirror[contenteditable='false'] .taskItemView-content-wrap{pointer-events:none;opacity:0.7;}"
    };
    const $6a8a55d341510e42$var$contentStyles = (props)=>(0, (0, parcelRequire("f8Sb3")).css)("--ak-editor--default-gutter-padding:", (0, (0, parcelRequire("iHYdz")).akEditorGutterPadding), "px;--ak-editor--large-gutter-padding:52px;--ak-editor--default-layout-width:", (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth), "px;--ak-editor--full-width-layout-width:", (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth), "px;--ak-editor--line-length:min(\n\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\tvar(--ak-editor--default-layout-width)\n\t);--ak-editor--breakout-wide-layout-width:", (0, (0, parcelRequire("iHYdz")).akEditorCalculatedWideLayoutWidthSmallViewport), "px;--ak-editor--breakout-full-page-guttering-padding:calc(\n\t\tvar(--ak-editor--large-gutter-padding) * 2 + var(--ak-editor--default-gutter-padding)\n\t);.fabric-editor--full-width-mode{--ak-editor--line-length:min(\n\t\t\tcalc(100cqw - var(--ak-editor--large-gutter-padding) * 2),\n\t\t\tvar(--ak-editor--full-width-layout-width)\n\t\t);}.ProseMirror{--ak-editor-max-container-width:calc(100cqw - var(--ak-editor--large-gutter-padding));}.ProseMirror>div[data-prosemirror-node-block] [data-prosemirror-node-block]{--ak-editor-max-container-width:100%;}@container editor-area (width >= ", $6a8a55d341510e42$var$akEditorBreakpointForSmallDevice, "){.ProseMirror{--ak-editor--breakout-wide-layout-width:", (0, (0, parcelRequire("iHYdz")).akEditorCalculatedWideLayoutWidth), "px;}}.ProseMirror{outline:none;font-size:", (0, (0, parcelRequire("iHYdz")).editorFontSize)({
            theme: props.theme
        }), "px;", (0, (0, parcelRequire("fwxzS")).whitespaceSharedStyles), ";", (0, (0, parcelRequire("4jyW9")).paragraphSharedStyles)(props.typographyTheme), ";", (0, (0, parcelRequire("jlYLw")).listsSharedStyles), ";", (0, (0, parcelRequire("5fBxY")).indentationSharedStyles), ";", (0, (0, parcelRequire("aSoqv")).shadowSharedStyle), ";", (0, (0, parcelRequire("fz5RS")).InlineNodeViewSharedStyles), ";}", (0, (0, parcelRequire("VSDnB")).fg)('editor_request_to_edit_task') ? null : $6a8a55d341510e42$var$_ref3, " .ProseMirror-hideselection *::selection{background:transparent;}.ProseMirror-hideselection *::-moz-selection{background:transparent;}.ProseMirror-selectednode{outline:none;}.ProseMirror-selectednode:empty{outline:2px solid var(--ds-border-focused, #8cf);}", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_mark_boundary_cursor') ? $6a8a55d341510e42$var$_ref2 : null, " ", (0, (0, parcelRequire("frkDk")).placeholderTextStyles), " ", $6a8a55d341510e42$export$d3bdc0d52bb6c2c8, " ", (0, (0, parcelRequire("cEh6Q")).codeBlockStyles)(), " ", (0, (0, parcelRequire("2uCrC")).blocktypeStyles)(props.typographyTheme), " ", (0, (0, parcelRequire("7Acon")).codeMarkSharedStyles)(), " ", (0, (0, parcelRequire("jRk4M")).textColorStyles), " ", (0, (0, parcelRequire("1xqpZ")).backgroundColorStyles)(), " ", $6a8a55d341510e42$var$listsStyles, " ", $6a8a55d341510e42$var$ruleStyles(), " ", (0, (0, parcelRequire("6UEu0")).mediaStyles)(), " ", (0, (0, parcelRequire("l5gcr")).layoutStyles)(props.viewMode), " ", (0, (0, parcelRequire("3I3CN")).telepointerStyle), " ", (0, (0, parcelRequire("eAVGd")).gapCursorStyles), ";", (0, (0, parcelRequire("b3RpZ")).panelStyles)(), " ", $6a8a55d341510e42$var$mentionsStyles, " ", $6a8a55d341510e42$var$emojiStyles, " ", (0, (0, parcelRequire("1bQ0V")).tasksAndDecisionsStyles), " ", (0, (0, parcelRequire("bYYy3")).gridStyles), " ", $6a8a55d341510e42$export$4ea5976125a01ffa, " ", (0, (0, parcelRequire("cx4Bg")).blockMarksSharedStyles), " ", (0, (0, parcelRequire("4E5wI")).dateSharedStyle), " ", (0, (0, parcelRequire("hucfL")).extensionStyles), " ", (0, (0, parcelRequire("cBEjw")).expandStyles)(), " ", (0, (0, parcelRequire("2PxPK")).findReplaceStyles), " ", (0, (0, parcelRequire("5oKtW")).textHighlightStyle), " ", (0, (0, parcelRequire("5L329")).taskDecisionStyles), " ", (0, (0, parcelRequire("aUTD3")).statusStyles), " ", (0, (0, parcelRequire("5Lu5s")).annotationSharedStyles)(), " ", (0, (0, parcelRequire("kRXi9")).smartCardStyles)(), " ", (0, (0, parcelRequire("iJOES")).smartCardSharedStyles), " ", (0, (0, parcelRequire("dv67m")).dateStyles), " ", (0, (0, parcelRequire("9zgV3")).embedCardStyles)(), " ", (0, (0, parcelRequire("ahG4O")).unsupportedStyles), " ", (0, (0, parcelRequire("hVv9L")).resizerStyles), " ", (0, (0, parcelRequire("9O4yy")).aiPanelStyles)(props.colorMode), " ", $6a8a55d341510e42$export$42a58e6dfeaffebe(), " .panelView-content-wrap{box-sizing:border-box;}.mediaGroupView-content-wrap ul{padding:0;}div.fabric-editor-block-mark[class^='fabric-editor-align']{clear:none!important;}.fabric-editor-align-end{text-align:right;}.fabric-editor-align-start{text-align:left;}.fabric-editor-align-center{text-align:center;}.fabric-editor--full-width-mode{.pm-table-container{.code-block,.extension-container,.multiBodiedExtension--container{max-width:100%;}}}.pm-table-header-content-wrap :not(.fabric-editor-alignment),.pm-table-header-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark,.pm-table-cell-content-wrap :not(p, .fabric-editor-block-mark)+div.fabric-editor-block-mark{p:first-of-type{margin-top:0;}}.pm-table-cell-content-wrap .mediaGroupView-content-wrap{clear:both;}.hyperlink-floating-toolbar,.", (0, (0, parcelRequire("jQRg9")).ClassNames).FLOATING_TOOLBAR_COMPONENT, "{padding:0;}", !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? $6a8a55d341510e42$var$_ref : null, ";");
    const $6a8a55d341510e42$export$91e7c20fa6d6a4b5 = (styles)=>{
        return (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
            const { className: className, children: children, featureFlags: featureFlags } = props;
            const theme = (0, (0, parcelRequire("g0wej")).u)();
            const { colorMode: colorMode, typography: typography } = (0, (0, parcelRequire("hxoiH")).default)();
            const memoizedStyle = (0, $5uXOq.useMemo)(()=>$6a8a55d341510e42$var$contentStyles({
                    theme: theme,
                    colorMode: colorMode,
                    featureFlags: featureFlags,
                    viewMode: props.viewMode,
                    typographyTheme: typography
                }), [
                theme,
                colorMode,
                featureFlags,
                props.viewMode,
                typography
            ]);
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: className,
                ref: ref,
                css: [
                    memoizedStyle,
                    styles
                ]
            }, children));
        });
    };
    var $6a8a55d341510e42$export$2e2bcd8739ae039 = $6a8a55d341510e42$export$91e7c20fa6d6a4b5();
});
parcelRegister("3I3CN", function(module, exports) {
    $parcel$export(module.exports, "PROVIDER_ERROR_CODE", ()=>$b29cd5b2ebd43bff$export$54cb529986e2487b);
    $parcel$export(module.exports, "DisconnectReason", ()=>$b29cd5b2ebd43bff$export$258d16488300d83f);
    $parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", ()=>$b29cd5b2ebd43bff$export$75f1e2b0ae2c8197);
    $parcel$export(module.exports, "telepointerStyle", ()=>$b29cd5b2ebd43bff$export$c94087d6ea5127ad);
    $parcel$export(module.exports, "isDirtyTransaction", ()=>$b29cd5b2ebd43bff$export$c500b1bc696a0abc);
    $parcel$export(module.exports, "tintDirtyTransaction", ()=>$b29cd5b2ebd43bff$export$f25182515d14d793);
    var $f8Sb3;
    var $iHYdz;
    var $cSyk1;
    var $b29cd5b2ebd43bff$export$54cb529986e2487b;
    (function(PROVIDER_ERROR_CODE) {
        PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
        PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
        PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
        PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
        PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
        PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
        PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
        PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
        PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
        PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
        PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    })($b29cd5b2ebd43bff$export$54cb529986e2487b || ($b29cd5b2ebd43bff$export$54cb529986e2487b = {}));
    var $b29cd5b2ebd43bff$export$258d16488300d83f;
    (function(DisconnectReason) {
        DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
        DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
        DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
        DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
        DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
        DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    })($b29cd5b2ebd43bff$export$258d16488300d83f || ($b29cd5b2ebd43bff$export$258d16488300d83f = {}));
    const $b29cd5b2ebd43bff$var$telepointerColorStyle = (color, index)=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("cSyk1")).default)();
        const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${color} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${color} -850000%, transparent 150000%)`;
        return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${color};
        color: ${"var(--ds-text-inverse, #FFFFFF)"};
        border-color: ${color};
      }
    }
  `;
    };
    const $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197 = 'telepointer-dim';
    const $b29cd5b2ebd43bff$export$c94087d6ea5127ad = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, (0, parcelRequire("iHYdz")).avatarColors).map((color, index)=>$b29cd5b2ebd43bff$var$telepointerColorStyle(color, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge::after{content:attr(data-initial);position:absolute;display:block;top:-14px;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(9), ";padding:var(--ds-space-025, 2px);color:var(--ds-text-inverse, #FFFFFF);left:0px;border-radius:2px 2px 2px 0;line-height:initial;}&.", $b29cd5b2ebd43bff$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
    const $b29cd5b2ebd43bff$var$tintKey = 'collab:isDirtyTransaction';
    const $b29cd5b2ebd43bff$export$c500b1bc696a0abc = (tr)=>{
        return Boolean(tr.getMeta($b29cd5b2ebd43bff$var$tintKey));
    };
    const $b29cd5b2ebd43bff$export$f25182515d14d793 = (tr)=>{
        tr.setMeta($b29cd5b2ebd43bff$var$tintKey, true);
    };
});
parcelRegister("3tpiv", function(module, exports) {
    $parcel$export(module.exports, "EmojiSharedCssClassName", ()=>$0dd4329718798e0e$export$ee47248f9a998789);
    var $2TUWQ;
    const $0dd4329718798e0e$export$ee47248f9a998789 = {
        EMOJI_CONTAINER: 'emojiView-content-wrap',
        EMOJI_NODE: (0, (0, parcelRequire("2TUWQ")).emojiNodeStyles),
        EMOJI_SPRITE: (0, (0, parcelRequire("2TUWQ")).emojiSprite),
        EMOJI_IMAGE: (0, (0, parcelRequire("2TUWQ")).emojiImage),
        EMOJI_PLACEHOLDER: (0, (0, parcelRequire("2TUWQ")).placeholder)
    };
});
parcelRegister("2TUWQ", function(module, exports) {
    $parcel$export(module.exports, "commonSelectedStyles", ()=>$63856011855bb785$export$8633a0edef8e95dd);
    $parcel$export(module.exports, "selectOnHoverStyles", ()=>$63856011855bb785$export$860109dfd198259b);
    $parcel$export(module.exports, "emojiSprite", ()=>$63856011855bb785$export$1c10634420a08d8a);
    $parcel$export(module.exports, "emojiNodeStyles", ()=>$63856011855bb785$export$b06c4aab1d012063);
    $parcel$export(module.exports, "emojiImage", ()=>$63856011855bb785$export$da61cef1c8919f7c);
    $parcel$export(module.exports, "emojiDeleteButton", ()=>$63856011855bb785$export$b11fa39b56a371f6);
    $parcel$export(module.exports, "emojiMainStyle", ()=>$63856011855bb785$export$11462c0756c24ab6);
    $parcel$export(module.exports, "deletableEmoji", ()=>$63856011855bb785$export$22b19c311e9caa4);
    $parcel$export(module.exports, "deleteButton", ()=>$63856011855bb785$export$62f325dbfbc8f81);
    $parcel$export(module.exports, "emojiToneSelectorContainer", ()=>$63856011855bb785$export$db71293054aaa6b);
    $parcel$export(module.exports, "emojiImageContainer", ()=>$63856011855bb785$export$2734b068d8ad3149);
    $parcel$export(module.exports, "emojiSpriteContainer", ()=>$63856011855bb785$export$30d3e4d3e2eb9353);
    $parcel$export(module.exports, "placeholder", ()=>$63856011855bb785$export$c7187bbd1a7a9244);
    $parcel$export(module.exports, "placeholderContainer", ()=>$63856011855bb785$export$d2e90c45f7c3d8ae);
    $parcel$export(module.exports, "placeholderContainerAnimated", ()=>$63856011855bb785$export$7c86135efb919ea8);
    $parcel$export(module.exports, "hidden", ()=>$63856011855bb785$export$73920f18ca706874);
    $parcel$export(module.exports, "emojiButton", ()=>$63856011855bb785$export$8888b57f0a0f6212);
    $parcel$export(module.exports, "emojiRadio", ()=>$63856011855bb785$export$1f65a91a7e57ef09);
    $parcel$export(module.exports, "emojiPickerAddEmoji", ()=>$63856011855bb785$export$b0fe756d87022806);
    $parcel$export(module.exports, "previewText", ()=>$63856011855bb785$export$b0c1ec5994495ae0);
    $parcel$export(module.exports, "emojiName", ()=>$63856011855bb785$export$54f98cf16037e484);
    $parcel$export(module.exports, "emojiShortName", ()=>$63856011855bb785$export$f544abd4ed25bf26);
    $parcel$export(module.exports, "preview", ()=>$63856011855bb785$export$48c2d0f2f545ac27);
    $parcel$export(module.exports, "previewImg", ()=>$63856011855bb785$export$fd824239f75849bd);
    $parcel$export(module.exports, "emojiUpload", ()=>$63856011855bb785$export$1e9c48a9a2a120a2);
    $parcel$export(module.exports, "emojiUploadTop", ()=>$63856011855bb785$export$b79d6461124a02ae);
    $parcel$export(module.exports, "uploadChooseFileMessage", ()=>$63856011855bb785$export$e59dc3792ffcd30d);
    $parcel$export(module.exports, "closeEmojiUploadButton", ()=>$63856011855bb785$export$8560ff62d6d7b310);
    $parcel$export(module.exports, "uploadChooseFileRow", ()=>$63856011855bb785$export$8a3d57e9dcb73d21);
    $parcel$export(module.exports, "uploadChooseFileEmojiName", ()=>$63856011855bb785$export$3be66059eec1ad35);
    $parcel$export(module.exports, "uploadPreviewFooter", ()=>$63856011855bb785$export$88e7d769c40006c);
    $parcel$export(module.exports, "uploadPreview", ()=>$63856011855bb785$export$172e07efac4144fc);
    $parcel$export(module.exports, "uploadPreviewText", ()=>$63856011855bb785$export$8411439a61ad397e);
    $parcel$export(module.exports, "bigEmojiPreview", ()=>$63856011855bb785$export$4ddd1871b37bc98f);
    $parcel$export(module.exports, "uploadAddRow", ()=>$63856011855bb785$export$621cc43b2e7ce00c);
    $parcel$export(module.exports, "addCustomEmoji", ()=>$63856011855bb785$export$dced3bf3423d07ee);
    $parcel$export(module.exports, "deletePreview", ()=>$63856011855bb785$export$646fe58047f2f06b);
    $parcel$export(module.exports, "deleteText", ()=>$63856011855bb785$export$69b97c52b23537e1);
    $parcel$export(module.exports, "headingH5", ()=>$63856011855bb785$export$b47e8b05b9bbfd4d);
    $parcel$export(module.exports, "previewButtonGroup", ()=>$63856011855bb785$export$acd445d99f0cd2ca);
    $parcel$export(module.exports, "deleteFooter", ()=>$63856011855bb785$export$37160940a651309e);
    $parcel$export(module.exports, "emojiDeleteErrorMessage", ()=>$63856011855bb785$export$8e680fd3ed8103f1);
    $parcel$export(module.exports, "emojiChooseFileErrorMessage", ()=>$63856011855bb785$export$92939898c3fc14e8);
    $parcel$export(module.exports, "emojiPreviewErrorMessage", ()=>$63856011855bb785$export$363abc227d983415);
    $parcel$export(module.exports, "addCustomEmojiButton", ()=>$63856011855bb785$export$7de8c97e0e1a1a10);
    $parcel$export(module.exports, "buttonSpinner", ()=>$63856011855bb785$export$f65e889602b4eb1c);
    $parcel$export(module.exports, "emojiActionsWrapper", ()=>$63856011855bb785$export$a68c05d31ed3f6f6);
    $parcel$export(module.exports, "tooltipShortcutStyle", ()=>$63856011855bb785$export$e40bd189a7b2cd7);
    var $f8Sb3;
    var $kin1Z;
    var $24VeY;
    var $k5uoT;
    var $3RZIb;
    function $63856011855bb785$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $63856011855bb785$export$8633a0edef8e95dd = 'emoji-common-selected';
    const $63856011855bb785$export$860109dfd198259b = 'emoji-common-select-on-hover';
    const $63856011855bb785$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
    const $63856011855bb785$export$b06c4aab1d012063 = 'emoji-common-node';
    const $63856011855bb785$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
    const $63856011855bb785$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
    const $63856011855bb785$export$11462c0756c24ab6 = 'emoji-common-main-styles';
    const $63856011855bb785$export$22b19c311e9caa4 = 'emoji-common-deletable';
    const $63856011855bb785$export$62f325dbfbc8f81 = {
        name: "1e82evl",
        styles: "visibility:hidden;display:flex;position:absolute;top:var(--ds-space-negative-100, -8px);right:var(--ds-space-negative-100, -8px);z-index:1;& span{line-height:0;}"
    };
    const $63856011855bb785$export$db71293054aaa6b = {
        name: "nwmv0g",
        styles: "flex:1;display:flex;justify-content:flex-end;padding:11px 10px 12px 0"
    };
    const $63856011855bb785$export$2734b068d8ad3149 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: "var(--ds-border-radius-100, 3px)",
        backgroundColor: 'transparent',
        display: 'inline-block',
        verticalAlign: 'middle',
        margin: '-1px 0',
        img: {
            display: 'block'
        },
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover`]: {
            backgroundColor: (0, (0, parcelRequire("24VeY")).akEmojiSelectedBackgroundColor)
        },
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover .${$63856011855bb785$export$b11fa39b56a371f6}`]: {
            visibility: 'visible'
        },
        [`&.${$63856011855bb785$export$22b19c311e9caa4}`]: {
            position: 'relative'
        },
        [`&.${$63856011855bb785$export$22b19c311e9caa4}:focus-within .${$63856011855bb785$export$b11fa39b56a371f6}`]: {
            visibility: 'visible'
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$30d3e4d3e2eb9353 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        margin: '-1px 0',
        [`&.${$63856011855bb785$export$8633a0edef8e95dd},&.${$63856011855bb785$export$860109dfd198259b}:hover`]: {
            backgroundColor: (0, (0, parcelRequire("24VeY")).akEmojiSelectedBackgroundColor)
        },
        [`.${$63856011855bb785$export$1c10634420a08d8a}`]: {
            background: 'transparent no-repeat',
            display: 'inline-block',
            minHeight: `${(0, (0, parcelRequire("kin1Z")).defaultEmojiHeight)}px`,
            minWidth: `${(0, (0, parcelRequire("kin1Z")).defaultEmojiHeight)}px`,
            verticalAlign: 'middle'
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
    const $63856011855bb785$export$d2e90c45f7c3d8ae = {
        name: "gb7a29",
        styles: "position:relative;margin:-1px 0;display:inline-block;background:var(--ds-border, #f7f7f7);border-radius:var(--ds-border-radius-100, 3px);overflow:hidden;vertical-align:middle;white-space:nowrap;text-align:center"
    };
    const $63856011855bb785$var$easeSweep = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            transform: 'translateX(-100%)'
        },
        to: {
            transform: 'translateX(100%)'
        }
    });
    const $63856011855bb785$export$7c86135efb919ea8 = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`,
            height: '100%',
            width: '100%',
            animation: `${$63856011855bb785$var$easeSweep} 1s cubic-bezier(0.4, 0.0, 0.2, 1) infinite`
        }
    });
    const $63856011855bb785$export$73920f18ca706874 = {
        name: "1835etr",
        styles: "opacity:0;visibility:hidden;display:none"
    };
    const $63856011855bb785$export$8888b57f0a0f6212 = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: 'transparent',
        border: '0',
        borderRadius: "var(--ds-border-radius-100, 3px)",
        cursor: 'pointer',
        padding: 0,
        position: 'relative',
        display: 'inline-block',
        ['&::-moz-focus-inner']: {
            border: '0 none',
            padding: 0
        },
        '&>span': {
            padding: "var(--ds-space-075, 6px)",
            [`&>.${$63856011855bb785$export$1c10634420a08d8a}`]: {
                height: '24px',
                width: '24px'
            },
            [`&>img`]: {
                height: '24px',
                width: '24px'
            }
        },
        '&:focus': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$1f65a91a7e57ef09 = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        position: 'absolute',
        top: '-10px',
        left: '-10px',
        '+span': {
            borderRadius: "var(--ds-border-radius-100, 3px)"
        },
        '&:focus + span': {
            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
            transitionDuration: '0s, 0.2s',
            outline: 'none'
        }
    });
    const $63856011855bb785$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
    const $63856011855bb785$export$b0c1ec5994495ae0 = {
        name: "1dn05ko",
        styles: "display:flex;flex-direction:column;align-self:center;margin-top:var(--ds-space-negative-025, -2px);margin-left:10px;max-width:285px;width:285px;flex-grow:1;flex-shrink:1"
    };
    const $63856011855bb785$export$54f98cf16037e484 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ['&:first-letter']: {
            textTransform: 'uppercase'
        }
    });
    const $63856011855bb785$export$f544abd4ed25bf26 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        lineHeight: 1,
        marginBottom: "var(--ds-space-negative-025, -2px)",
        overflow: 'hidden',
        paddingBottom: "var(--ds-space-025, 2px)",
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ['&:first-of-type']: {
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`,
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
        }
    });
    const $63856011855bb785$export$48c2d0f2f545ac27 = {
        name: "xc6blf",
        styles: "display:flex;flex-direction:row;flex-wrap:nowrap;padding:10px;height:32px;align-items:center"
    };
    const $63856011855bb785$export$fd824239f75849bd = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-block',
        flex: 'initial',
        width: '32px',
        [`& .${$63856011855bb785$export$1c10634420a08d8a}, span[role="img"]`]: {
            width: '32px',
            height: '32px',
            padding: 0,
            maxHeight: 'inherit'
        },
        [`& span[role="img"] > img`]: {
            position: 'relative',
            left: '50%',
            top: '50%',
            transform: 'translateX(-50%) translateY(-50%)',
            maxHeight: '32px',
            maxWidth: '32px',
            padding: 0,
            display: 'block'
        }
    });
    const $63856011855bb785$export$4e6da4bf7766def = (0, (0, parcelRequire("f8Sb3")).css)({
        border: `1px solid ${"var(--ds-border, #fff)"}`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        display: 'block',
        margin: '0',
        overflowX: 'hidden',
        overflowY: 'auto',
        padding: '0'
    });
    const $63856011855bb785$export$1e9c48a9a2a120a2 = {
        name: "4ig074",
        styles: "height:78px;padding:10px;display:flex;flex-direction:column;justify-content:space-around"
    };
    const $63856011855bb785$export$b79d6461124a02ae = {
        name: "1vuh687",
        styles: "padding-bottom:7px;display:flex;justify-content:space-between;align-items:flex-end;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $63856011855bb785$export$e59dc3792ffcd30d = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`
        }
    });
    const $63856011855bb785$export$8560ff62d6d7b310 = {
        name: "zjik7",
        styles: "display:flex"
    };
    const $63856011855bb785$export$1179580a43517a40 = {
        name: "b4lf34",
        styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $63856011855bb785$export$8a3d57e9dcb73d21 = {
        name: "t04h3w",
        styles: "display:flex;justify-content:space-between;padding-bottom:7px"
    };
    const $63856011855bb785$export$3be66059eec1ad35 = (0, (0, parcelRequire("f8Sb3")).css)({
        flex: '1 1 auto',
        marginRight: '5px',
        input: {
            background: 'transparent',
            border: 0,
            outline: 'none',
            ['&:invalid']: {
                boxShadow: 'none'
            },
            ['&::-ms-clear']: {
                display: 'none'
            }
        }
    });
    const $63856011855bb785$export$88e7d769c40006c = {
        name: "9o0thy",
        styles: "display:flex;flex-direction:column;height:100px;padding:10px"
    };
    const $63856011855bb785$export$172e07efac4144fc = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        borderRadius: "var(--ds-border-radius-100, 3px)",
        padding: '10px'
    });
    const $63856011855bb785$export$8411439a61ad397e = (0, (0, parcelRequire("f8Sb3")).css)({
        h5: {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
            paddingBottom: "var(--ds-space-050, 4px)",
            font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
        },
        img: {
            maxHeight: '20px',
            maxWidth: '50px'
        }
    });
    const $63856011855bb785$export$4ddd1871b37bc98f = {
        name: "z1virw",
        styles: "padding-left:var(--ds-space-050, 4px);img{max-height:40px;max-width:100px;}"
    };
    const $63856011855bb785$export$621cc43b2e7ce00c = {
        name: "n5qme0",
        styles: "display:flex;justify-content:flex-end;align-items:center;padding-top:10px"
    };
    const $63856011855bb785$export$dced3bf3423d07ee = {
        name: "udr5k",
        styles: "align-self:center;margin-left:10px;margin-bottom:10px"
    };
    const $63856011855bb785$export$403c84b6b5d8319b = 'emoji-submit-delete';
    const $63856011855bb785$export$646fe58047f2f06b = {
        name: "k4dmy0",
        styles: "height:100px;padding:10px;display:flex;flex-direction:column;justify-content:flex-end"
    };
    const $63856011855bb785$export$69b97c52b23537e1 = (0, (0, parcelRequire("f8Sb3")).css)({
        height: '64px',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        '&:first-of-type': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`,
            lineHeight: '16px'
        }
    });
    const $63856011855bb785$export$b47e8b05b9bbfd4d = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            font: `var(--ds-font-body-UNSAFE_small, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.UNSAFE_small})`,
            fontWeight: "var(--ds-font-weight-semibold, 600)"
        }
    });
    const $63856011855bb785$export$1b3e3e033487450f = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: "var(--ds-space-025, 2px)",
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        fontFamily: (0, (0, parcelRequire("k5uoT")).fontFamily)()
    });
    const $63856011855bb785$export$acd445d99f0cd2ca = {
        name: "zjik7",
        styles: "display:flex"
    };
    const $63856011855bb785$export$37160940a651309e = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '40px',
        alignItems: 'center',
        justifyContent: 'space-between',
        font: `var(--ds-font-body, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.medium})`,
        img: {
            maxHeight: '32px',
            maxWidth: '72px'
        },
        [`.${$63856011855bb785$export$403c84b6b5d8319b}`]: {
            width: '84px',
            fontWeight: "var(--ds-font-weight-bold, bold)",
            marginRight: "var(--ds-space-050, 4px)"
        }
    });
    const $63856011855bb785$export$8e680fd3ed8103f1 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingRight: "var(--ds-space-050, 4px)"
    });
    const $63856011855bb785$export$92939898c3fc14e8 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
        paddingRight: '10px',
        justifyContent: 'flex-start'
    });
    const $63856011855bb785$export$363abc227d983415 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`,
        paddingRight: '10px',
        justifyContent: 'flex-end',
        alignItems: 'center'
    });
    const $63856011855bb785$export$7de8c97e0e1a1a10 = {
        name: "1vnsw82",
        styles: "max-width:285px"
    };
    const $63856011855bb785$export$f65e889602b4eb1c = {
        name: "15lh70q",
        styles: "margin-right:10px;margin-left:10px"
    };
    const $63856011855bb785$export$a68c05d31ed3f6f6 = {
        name: "5ej25d",
        styles: "display:flex;justify-content:flex-end;align-items:center"
    };
    const $63856011855bb785$export$e40bd189a7b2cd7 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: '3px',
        backgroundColor: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`,
        padding: `0 ${"var(--ds-space-025, 2px)"}`,
        label: 'tooltip-shortcut'
    });
});
parcelRegister("24VeY", function(module, exports) {
    $parcel$export(module.exports, "emojiPickerBorderColor", ()=>$cc9794b972f9b285$export$c925743aa555d078);
    $parcel$export(module.exports, "emojiPickerBoxShadow", ()=>$cc9794b972f9b285$export$af9bf85c64bea8f4);
    $parcel$export(module.exports, "noDialogContainerBorderColor", ()=>$cc9794b972f9b285$export$d4d7be6055c9b630);
    $parcel$export(module.exports, "noDialogContainerBorderRadius", ()=>$cc9794b972f9b285$export$1245062fdd1d17da);
    $parcel$export(module.exports, "noDialogContainerBoxShadow", ()=>$cc9794b972f9b285$export$e0fb6f9113466b83);
    $parcel$export(module.exports, "akEmojiSelectedBackgroundColor", ()=>$cc9794b972f9b285$export$57ff7d2ede5bd73);
    $parcel$export(module.exports, "emojiPreviewSelectedColor", ()=>$cc9794b972f9b285$export$19ac926916b8b927);
    $parcel$export(module.exports, "emojiTypeAheadMaxHeight", ()=>$cc9794b972f9b285$export$b68d1ac7839910c2);
    $parcel$export(module.exports, "emojiTypeAheadWidth", ()=>$cc9794b972f9b285$export$149c380dc04eef99);
    var $kin1Z;
    const $cc9794b972f9b285$export$23db3d0b0da6d608 = (0, (0, parcelRequire("kin1Z")).emojiPickerWidth);
    const $cc9794b972f9b285$export$7722b8e9522021df = 205;
    const $cc9794b972f9b285$export$c925743aa555d078 = `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $cc9794b972f9b285$export$af9bf85c64bea8f4 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
    const $cc9794b972f9b285$export$d4d7be6055c9b630 = `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`;
    const $cc9794b972f9b285$export$1245062fdd1d17da = "var(--ds-border-radius-100, 3px)";
    const $cc9794b972f9b285$export$e0fb6f9113466b83 = "var(--ds-shadow-overlay, 0 3px 6px rgba(0, 0, 0, 0.2))";
    const $cc9794b972f9b285$export$57ff7d2ede5bd73 = `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $cc9794b972f9b285$export$19ac926916b8b927 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $cc9794b972f9b285$export$b68d1ac7839910c2 = 350;
    const $cc9794b972f9b285$export$149c380dc04eef99 = 350;
});
parcelRegister("fRmCC", function(module, exports) {
    $parcel$export(module.exports, "MentionSharedCssClassName", ()=>$4843d72ed8c773f1$export$e5f60e08987c4e73);
    const $4843d72ed8c773f1$export$e5f60e08987c4e73 = {
        MENTION_CONTAINER: 'mentionView-content-wrap'
    };
});
parcelRegister("aABH4", function(module, exports) {
    $parcel$export(module.exports, "darkPanelColors", ()=>$c61dedcc3b2bdafe$export$804476272fbaff5e);
    $parcel$export(module.exports, "PanelSharedCssClassName", ()=>$c61dedcc3b2bdafe$export$6dd740b6c888e050);
    $parcel$export(module.exports, "getPanelTypeBackgroundNoTokens", ()=>$c61dedcc3b2bdafe$export$8099afddf1b1be78);
    $parcel$export(module.exports, "panelSharedStylesWithoutPrefix", ()=>$c61dedcc3b2bdafe$export$d707b378cb63679a);
    $parcel$export(module.exports, "panelSharedStyles", ()=>$c61dedcc3b2bdafe$export$fc98407afe711ba8);
    var $f8Sb3;
    var $bFtEE;
    var $hAs1r;
    var $iHYdz;
    var $iHYdz;
    var $2TUWQ;
    var $gmhCD = parcelRequire("gmhCD");
    const $c61dedcc3b2bdafe$var$lightPanelColors = {
        info: '#DEEBFF',
        note: '#EAE6FF',
        tip: '#E3FCEF',
        success: '#E3FCEF',
        warning: '#FFFAE6',
        error: '#FFEBE6'
    };
    const $c61dedcc3b2bdafe$export$804476272fbaff5e = {
        info: `#0C294F`,
        error: `#441C13`,
        warning: `#413001`,
        tip: `#052E21`,
        success: `#052E21`,
        note: `#282249`,
        R900: '#601D16',
        R100S: `#FFEFEB`,
        R300S: `#FFB5A3`,
        R500S: `#FF6B47`,
        R800S: `#C4320E`,
        R1200S: `#441C13`,
        Y900: '#533F04',
        Y100S: `#FFF3D1`,
        Y300S: `#FFDC7A`,
        Y500S: `#FFC933`,
        Y800S: `#D8A003`,
        Y1200S: `#413001`,
        G900: '#164B35',
        G100S: `#E3FCF0`,
        G300S: `#95EEC5`,
        G400S: `#60DCA8`,
        G900S: `#086848`,
        G1200S: `#052E21`,
        B900: '#09326C',
        B100S: '#E5F0FF',
        B300S: '#A3C9FF',
        B500S: '#4794FF',
        B800S: '#0055CC',
        B1200S: '#0C294F',
        P900: `#352C63`,
        P100S: `#EEEBFF`,
        P300S: `#CCC3FE`,
        P500S: `#A292F7`,
        P800S: `#5E49CA`,
        P1200S: `#282249`,
        T900: '#1D474C',
        T100S: `#DBFAFF`,
        T300S: `#78EBFC`,
        T400S: `#3AD6EE`,
        T900S: `#056270`,
        T1200S: `#0B3037`,
        DarkGray: '#161A1D',
        Gray: '#2C333A',
        LightGray: '#5A6977',
        TextColor: '#D9DDE3'
    };
    const $c61dedcc3b2bdafe$var$lightIconColor = {
        info: "var(--ds-icon-information, #1D7AFC)",
        note: "var(--ds-icon-discovery, #8270DB)",
        tip: "var(--ds-icon-success, #22A06B)",
        success: "var(--ds-icon-success, #22A06B)",
        warning: "var(--ds-icon-warning, #E56910)",
        error: "var(--ds-icon-danger, #C9372C)"
    };
    const $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment = -(24 - (0, (0, parcelRequire("iHYdz")).akEditorCustomIconSize)) / 2;
    const $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment = $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment - 1;
    function $c61dedcc3b2bdafe$export$9490e629452e7f9e(colorName, colorValue) {
        return `
  &[data-panel-color="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
    color: ${$c61dedcc3b2bdafe$export$804476272fbaff5e.TextColor};
  }
  `;
    }
    const $c61dedcc3b2bdafe$var$prefix = 'ak-editor-panel';
    const $c61dedcc3b2bdafe$export$6dd740b6c888e050 = {
        prefix: $c61dedcc3b2bdafe$var$prefix,
        content: `${$c61dedcc3b2bdafe$var$prefix}__content`,
        icon: `${$c61dedcc3b2bdafe$var$prefix}__icon`,
        noIcon: `${$c61dedcc3b2bdafe$var$prefix}__no-icon`
    };
    const $c61dedcc3b2bdafe$export$b0ee08fae091706a = {
        infoPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, (0, parcelRequire("bFtEE")).PanelType).INFO}]`,
        notePanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, (0, parcelRequire("bFtEE")).PanelType).NOTE}]`,
        warningPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, (0, parcelRequire("bFtEE")).PanelType).WARNING}]`,
        errorPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, (0, parcelRequire("bFtEE")).PanelType).ERROR}]`,
        successPanel: `.${$c61dedcc3b2bdafe$var$prefix}[data-panel-type=${(0, (0, parcelRequire("bFtEE")).PanelType).SUCCESS}]`,
        noteButton: `button[aria-label="Note"]`,
        warningButton: `button[aria-label="Warning"]`,
        removeButton: `button[aria-label="Remove"]`,
        colorPalette: `[aria-label="Background color"]`,
        selectedColor: `[aria-label="Light green"]`,
        removeEmojiIcon: `[aria-label="Remove emoji"]`,
        emojiIcon: `[aria-label="editor-add-emoji"]`,
        selectedEmoji: `[aria-label=":grinning:"]`,
        addYourOwnEmoji: `#add-custom-emoji`,
        emojiNameInCustomEmoji: `[aria-label="Enter a name for the new emoji"]`,
        title: `#editor-title`,
        emojiPopup: `[aria-label="Popup"]`,
        searchEmoji: `[aria-label="Emoji name"]`,
        orangeWarningIcon: `[aria-label=":warning:"]`,
        yellowWarningIcon: `[aria-label=":warning:"]  span:nth-child(1)`,
        copyButton: `button[aria-label="Copy"]`
    };
    const $c61dedcc3b2bdafe$var$iconDynamicStyles = (panelType)=>`color: ${$c61dedcc3b2bdafe$var$lightIconColor[panelType]};`;
    const $c61dedcc3b2bdafe$export$8099afddf1b1be78 = (panelType)=>$c61dedcc3b2bdafe$var$lightPanelColors[panelType] || 'none';
    const $c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc = (panelType)=>(0, (0, parcelRequire("hAs1r")).hexToEditorBackgroundPaletteColor)($c61dedcc3b2bdafe$var$lightPanelColors[panelType]) || 'none';
    const $c61dedcc3b2bdafe$var$mainDynamicStyles = (panelType)=>{
        return `
    background-color: ${$c61dedcc3b2bdafe$export$dd3f0fd482ae7ccc(panelType)};
    color: inherit;
  `;
    };
    const $c61dedcc3b2bdafe$export$d707b378cb63679a = ()=>(0, (0, parcelRequire("f8Sb3")).css)("border-radius:var(--ds-border-radius, 3px);margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0;padding-top:var(--ds-space-100, 8px);padding-right:var(--ds-space-200, 16px);padding-bottom:var(--ds-space-100, 8px);padding-left:var(--ds-space-100, 8px);min-width:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellMinWidth), "px;display:flex;position:relative;align-items:normal;word-break:break-word;", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).INFO), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{flex-shrink:0;height:var(--ds-space-300, 24px);width:var(--ds-space-300, 24px);box-sizing:content-box;padding-right:var(--ds-space-100, 8px);text-align:center;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;margin-top:0.1em;", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).INFO), ">span{vertical-align:middle;display:inline-flex;}.", (0, (0, parcelRequire("2TUWQ")).emojiSprite), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiSpriteVerticalAlignment, "px;}.", (0, (0, parcelRequire("2TUWQ")).emojiImage), "{vertical-align:", $c61dedcc3b2bdafe$var$panelEmojiImageVerticalAlignment, "px;@-moz-document url-prefix(){img{display:inline-block;}}}}.ak-editor-panel__content{margin:var(--ds-space-025, 2px) 0 var(--ds-space-025, 2px);flex:1 0 0;min-width:0;}&[data-panel-type='", (0, (0, parcelRequire("bFtEE")).PanelType).NOTE, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).NOTE), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).NOTE), ";}}&[data-panel-type='", (0, (0, parcelRequire("bFtEE")).PanelType).TIP, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).TIP), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).TIP), ";}}&[data-panel-type='", (0, (0, parcelRequire("bFtEE")).PanelType).WARNING, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).WARNING), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).WARNING), ";}}&[data-panel-type='", (0, (0, parcelRequire("bFtEE")).PanelType).ERROR, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).ERROR), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).ERROR), ";}}&[data-panel-type='", (0, (0, parcelRequire("bFtEE")).PanelType).SUCCESS, "']{", $c61dedcc3b2bdafe$var$mainDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).SUCCESS), " .", $c61dedcc3b2bdafe$export$6dd740b6c888e050.icon, "{", $c61dedcc3b2bdafe$var$iconDynamicStyles((0, (0, parcelRequire("bFtEE")).PanelType).SUCCESS), ";}}", (0, $gmhCD.editorExperiment)('nested-dnd', true) ? `&.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}` : '', ";");
    const $c61dedcc3b2bdafe$export$fc98407afe711ba8 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            [`.${$c61dedcc3b2bdafe$export$6dd740b6c888e050.prefix}`]: $c61dedcc3b2bdafe$export$d707b378cb63679a()
        });
});
parcelRegister("eAVGd", function(module, exports) {
    $parcel$export(module.exports, "hideCaretModifier", ()=>$618a810c9ab6b0dd$export$8adc5edbc4a22166);
    $parcel$export(module.exports, "gapCursorStyles", ()=>$618a810c9ab6b0dd$export$f6b9d90c2745834e);
    var $f8Sb3;
    const $618a810c9ab6b0dd$var$gapCursorBlink = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        'from, to': {
            opacity: 0
        },
        '50%': {
            opacity: 1
        }
    });
    const $618a810c9ab6b0dd$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
    const $618a810c9ab6b0dd$var$gapCursor = '.ProseMirror-gapcursor';
    const $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"])';
    const $618a810c9ab6b0dd$var$wrapLeft = '[layout="wrap-left"]';
    const $618a810c9ab6b0dd$var$wrapRight = '[layout="wrap-right"]';
    const $618a810c9ab6b0dd$export$f6b9d90c2745834e = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{&.", $618a810c9ab6b0dd$export$8adc5edbc4a22166, "{caret-color:transparent;}", $618a810c9ab6b0dd$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $618a810c9ab6b0dd$var$gapCursorBlink, " step-end infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $618a810c9ab6b0dd$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $618a810c9ab6b0dd$var$gapCursor, "{display:block;border-color:transparent;}}", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span ", $618a810c9ab6b0dd$var$wrapRight, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ",", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "{clear:none;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$wrapRight, ">div,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, ",", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "{float:left;}", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "::after,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+*>*,", $618a810c9ab6b0dd$var$wrapLeft, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$wrapRight, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapLeft, "+span+", $618a810c9ab6b0dd$var$wrapRight, "+*>*,", $618a810c9ab6b0dd$var$gapCursor, "+", $618a810c9ab6b0dd$var$wrapRight, "+span+", $618a810c9ab6b0dd$var$wrapLeft, "+*>*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+*,", $618a810c9ab6b0dd$var$prosemirrorwidgetNotBlock, "+", $618a810c9ab6b0dd$var$gapCursor, "+span+*{margin-top:0;}");
});
parcelRegister("9zgV3", function(module, exports) {
    $parcel$export(module.exports, "embedCardStyles", ()=>$4909a7644b753f01$export$5a1f57c6600b90f1);
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    function $4909a7644b753f01$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $4909a7644b753f01$var$_ref = {
        name: "b74184",
        styles: ".ProseMirror{.embedCardView-content-wrap[layout^='wrap-']{max-width:100%;}.embedCardView-content-wrap[layout='wrap-left']{float:left;}.embedCardView-content-wrap[layout='wrap-right']{float:right;}.embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']{clear:both;}}"
    };
    const $4909a7644b753f01$export$5a1f57c6600b90f1 = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_element_dnd_nested_fix_patch_3') ? (0, (0, parcelRequire("f8Sb3")).css)({
            '.ProseMirror': {
                ".embedCardView-content-wrap[layout^='wrap-']": {
                    maxWidth: '100%',
                    position: 'relative',
                    zIndex: (0, (0, parcelRequire("iHYdz")).akEditorWrappedNodeZIndex)
                },
                ".embedCardView-content-wrap[layout='wrap-left']": {
                    float: 'left'
                },
                ".embedCardView-content-wrap[layout='wrap-right']": {
                    float: 'right'
                },
                ".embedCardView-content-wrap[layout='wrap-right'] + .embedCardView-content-wrap[layout='wrap-left']": {
                    clear: 'both'
                }
            }
        }) : $4909a7644b753f01$var$_ref;
    const $4909a7644b753f01$export$9a900b6b0c1fa45 = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 ${"var(--ds-space-150, 12px)"}`
    });
});
parcelRegister("cr1aY", function(module, exports) {
    $parcel$export(module.exports, "expandIconContainerStyle", ()=>$93aa9de9747de328$export$2e9dabdcf16aeb54);
    $parcel$export(module.exports, "expandClassNames", ()=>$93aa9de9747de328$export$6ba39aa0ead007b7);
    function $93aa9de9747de328$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $93aa9de9747de328$export$e1f541b6d8e35681 = {
        name: "1igsh0u",
        styles: "margin-left:var(--ds-space-negative-100, -8px)"
    };
    const $93aa9de9747de328$export$2e9dabdcf16aeb54 = {
        name: "s5xdrg",
        styles: "display:flex;align-items:center"
    };
    const $93aa9de9747de328$var$prefix = 'ak-editor-expand';
    const $93aa9de9747de328$export$6ba39aa0ead007b7 = {
        prefix: $93aa9de9747de328$var$prefix,
        expanded: `${$93aa9de9747de328$var$prefix}__expanded`,
        titleContainer: `${$93aa9de9747de328$var$prefix}__title-container`,
        inputContainer: `${$93aa9de9747de328$var$prefix}__input-container`,
        iconContainer: `${$93aa9de9747de328$var$prefix}__icon-container`,
        icon: `${$93aa9de9747de328$var$prefix}__icon`,
        titleInput: `${$93aa9de9747de328$var$prefix}__title-input`,
        content: `${$93aa9de9747de328$var$prefix}__content`,
        type: (type)=>`${$93aa9de9747de328$var$prefix}__type-${type}`
    };
});
parcelRegister("bYYy3", function(module, exports) {
    $parcel$export(module.exports, "GRID_GUTTER", ()=>$ef9988a8733147ec$export$108900bf32350a8b);
    $parcel$export(module.exports, "gridStyles", ()=>$ef9988a8733147ec$export$61d0da483c72dda3);
    var $f8Sb3;
    var $iHYdz;
    const $ef9988a8733147ec$export$108900bf32350a8b = 12;
    const $ef9988a8733147ec$export$61d0da483c72dda3 = (0, (0, parcelRequire("f8Sb3")).css)({
        '.gridParent': {
            width: `calc(100% + ${$ef9988a8733147ec$export$108900bf32350a8b * 2}px)`,
            marginLeft: "var(--ds-space-negative-150, -12px)",
            marginRight: "var(--ds-space-negative-150, -12px)",
            transform: 'scale(1)',
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorGridLineZIndex)
        },
        '.gridContainer': {
            position: 'fixed',
            height: '100vh',
            width: '100%',
            pointerEvents: 'none'
        },
        '.gridLine': {
            borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
            display: 'inline-block',
            boxSizing: 'border-box',
            height: '100%',
            marginLeft: '-1px',
            transition: 'border-color 0.15s linear',
            zIndex: 0
        },
        '.highlight': {
            borderLeft: `1px solid ${"var(--ds-border-focused, #388BFF)"}`
        }
    });
});
parcelRegister("aN7BF", function(module, exports) {
    $parcel$export(module.exports, "linkSharedStyle", ()=>$536782e4b54ab634$export$d835732bf782c240);
    function $536782e4b54ab634$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $536782e4b54ab634$export$d835732bf782c240 = {
        name: "bp6sai",
        styles: "a.blockLink{display:block;}"
    };
});
parcelRegister("jQRg9", function(module, exports) {
    $parcel$export(module.exports, "ClassNames", ()=>$efb57f1d3580a030$export$9b9c0f9d9f3552b8);
    const $efb57f1d3580a030$var$prefix = 'pm-alt-text';
    const $efb57f1d3580a030$export$9b9c0f9d9f3552b8 = {
        FLOATING_TOOLBAR_COMPONENT: `${$efb57f1d3580a030$var$prefix}-alt-text-floating-toolbar`,
        MEDIA_CONTAINER: 'mediaView-content-wrap'
    };
});
parcelRegister("hVv9L", function(module, exports) {
    $parcel$export(module.exports, "resizerItemClassName", ()=>$fb7b1e8a090d8802$export$a06160db3520e5a2);
    $parcel$export(module.exports, "resizerHoverZoneClassName", ()=>$fb7b1e8a090d8802$export$c42cdcfd48254bda);
    $parcel$export(module.exports, "resizerExtendedZone", ()=>$fb7b1e8a090d8802$export$10b67c6ff1748bd);
    $parcel$export(module.exports, "resizerHandleClassName", ()=>$fb7b1e8a090d8802$export$6afc20f0ff6d041);
    $parcel$export(module.exports, "resizerHandleTrackClassName", ()=>$fb7b1e8a090d8802$export$a5792d7e2a486d41);
    $parcel$export(module.exports, "resizerHandleThumbClassName", ()=>$fb7b1e8a090d8802$export$2201bc1aaee73f36);
    $parcel$export(module.exports, "resizerDangerClassName", ()=>$fb7b1e8a090d8802$export$97a99610b6f0a178);
    $parcel$export(module.exports, "handleWrapperClass", ()=>$fb7b1e8a090d8802$export$b123b2c8a2536d05);
    $parcel$export(module.exports, "resizerHandleZIndex", ()=>$fb7b1e8a090d8802$export$3d867927ebf9bc1f);
    $parcel$export(module.exports, "resizerStyles", ()=>$fb7b1e8a090d8802$export$ce55ec61aa49b942);
    var $f8Sb3;
    var $iHYdz;
    const $fb7b1e8a090d8802$export$a06160db3520e5a2 = 'resizer-item';
    const $fb7b1e8a090d8802$export$c42cdcfd48254bda = 'resizer-hover-zone';
    const $fb7b1e8a090d8802$export$10b67c6ff1748bd = 'resizer-is-extended';
    const $fb7b1e8a090d8802$export$6afc20f0ff6d041 = 'resizer-handle';
    const $fb7b1e8a090d8802$export$a5792d7e2a486d41 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-track`;
    const $fb7b1e8a090d8802$export$2201bc1aaee73f36 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-thumb`;
    const $fb7b1e8a090d8802$export$97a99610b6f0a178 = `${$fb7b1e8a090d8802$export$6afc20f0ff6d041}-danger`;
    const $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName = 'ak-editor-selected-node';
    const $fb7b1e8a090d8802$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
    const $fb7b1e8a090d8802$export$3d867927ebf9bc1f = 1;
    const $fb7b1e8a090d8802$export$ce55ec61aa49b942 = (0, (0, parcelRequire("f8Sb3")).css)(".", $fb7b1e8a090d8802$export$a06160db3520e5a2, "{will-change:width;&:hover,&.display-handle{&>.", $fb7b1e8a090d8802$export$b123b2c8a2536d05, ">.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{visibility:visible;opacity:1;}}&.is-resizing{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}&.", $fb7b1e8a090d8802$export$97a99610b6f0a178, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{transition:none;background:", `var(--ds-icon-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";}}}.", $fb7b1e8a090d8802$export$6afc20f0ff6d041, "{display:flex;visibility:hidden;opacity:0;flex-direction:column;justify-content:center;align-items:center;width:7px;transition:visibility 0.2s,opacity 0.2s;& div[role='presentation']{width:100%;height:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;margin-top:var(--ds-space-negative-200, -16px);white-space:normal;}&.left{align-items:flex-start;}&.right{align-items:flex-end;}&.small{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:43px;}}&.medium{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:64px;}}&.large{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:96px;}}&.clamped{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{height:clamp(43px, calc(100% - 32px), 96px);}}&.sticky{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{position:sticky;top:var(--ds-space-150, 12px);bottom:var(--ds-space-150, 12px);}}&:hover{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}& .", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:visible;opacity:0.5;}}}.", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{content:' ';display:flex;width:3px;margin:0 var(--ds-space-025, 2px);height:64px;transition:background-color 0.2s;border-radius:6px;border:0;padding:0;z-index:2;outline:none;min-height:24px;background:var(--ds-border, #091E4224);&:hover{cursor:col-resize;}&:focus{background:var(--ds-border-selected, #0C66E4);&::after{content:'';position:absolute;top:var(--ds-space-negative-050, -4px);right:var(--ds-space-negative-050, -4px);bottom:var(--ds-space-negative-050, -4px);left:var(--ds-space-negative-050, -4px);border:2px solid var(--ds-border-focused, #388BFF);border-radius:inherit;z-index:-1;}}}.", $fb7b1e8a090d8802$export$a5792d7e2a486d41, "{visibility:hidden;position:absolute;width:7px;height:calc(100% - 40px);border-radius:4px;opacity:0;transition:background-color 0.2s,visibility 0.2s,opacity 0.2s;&.none{background:none;}&.shadow{background:var(--ds-background-selected, #E9F2FF);}&.full-height{background:var(--ds-background-selected, #E9F2FF);height:100%;min-height:36px;}}.", $fb7b1e8a090d8802$var$akEditorSelectedNodeClassName, "{& .", $fb7b1e8a090d8802$export$2201bc1aaee73f36, "{background:var(--ds-border-focused, #388BFF);}}.", $fb7b1e8a090d8802$export$c42cdcfd48254bda, "{position:relative;display:inline-block;width:100%;&.", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:0 var(--ds-space-150, 12px);left:var(--ds-space-negative-150, -12px);}}table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ",table .", $fb7b1e8a090d8802$export$c42cdcfd48254bda, ".", $fb7b1e8a090d8802$export$10b67c6ff1748bd, "{padding:unset;left:unset;}");
});
parcelRegister("kRXi9", function(module, exports) {
    $parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", ()=>$5eabaa6e34ebabc6$export$32f80df830e375f6);
    $parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", ()=>$5eabaa6e34ebabc6$export$863ae87a9d233606);
    $parcel$export(module.exports, "smartCardStyles", ()=>$5eabaa6e34ebabc6$export$b346a5d6d598424c);
    var $f8Sb3;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $VSDnB;
    var $iJOES;
    const $5eabaa6e34ebabc6$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
    const $5eabaa6e34ebabc6$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';
    const $5eabaa6e34ebabc6$export$b346a5d6d598424c = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).INLINE_CARD_CONTAINER, "{max-width:calc(100% - 20px);vertical-align:top;word-break:break-all;", (0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_on_inline_nodes') ? `.card-with-comment {
          background: ${"var(--ds-background-accent-yellow-subtler, #F8E6A0)"};
          border-bottom: 2px solid ${"var(--ds-border-accent-yellow, #B38600)"};
          box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)"};
        }` : '', " .card{padding-left:var(--ds-space-025, 2px);padding-right:var(--ds-space-025, 2px);padding-top:0.5em;padding-bottom:0.5em;margin-bottom:-0.5em;.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">a:focus{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
        ]), ";}}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
        ]), ";}.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{z-index:1;position:relative;}&.danger{.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">a{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";z-index:2;}}}.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:", (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') ? 'text' : 'pointer', ";a{cursor:", (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
        ]), " border-radius:var(--ds-border-radius-200, 8px);}&.danger{.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, "!important;}}}.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).DATASOURCE_CONTAINER, ".", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, "{max-width:100%;display:flex;justify-content:center;.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{cursor:pointer;background-color:var(--ds-background-neutral-subtle, #00000000);border-radius:var(--ds-border-radius-200, 8px);border:1px solid var(--ds-border, #091E4224);}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
        ]), " ", (0, (0, parcelRequire("VSDnB")).fg)('platform-datasources-enable-two-way-sync') ? `
					input::selection {
						background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
					}
					input::-moz-selection {
						background-color: ${"var(--ds-background-selected-hovered, #CCE0FF)"};
					}
				` : '', ";}}&.danger{.", $5eabaa6e34ebabc6$export$32f80df830e375f6, "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";}}}.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).EMBED_CARD_CONTAINER, "{.", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">div{cursor:pointer;a{cursor:", (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') ? 'pointer' : 'auto', ";}&::after{transition:box-shadow 0s;}}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).LOADER_WRAPPER, ">div::after{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
        ]), ";}&.danger{.media-card-frame::after{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, "!important;background:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";}}}.", $5eabaa6e34ebabc6$export$863ae87a9d233606, "{padding:0;}");
});
parcelRegister("5yojI", function(module, exports) {
    $parcel$export(module.exports, "getSelectionStyles", ()=>$e0952f45925e7685$export$fb186b651805ffe4);
    $parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", ()=>$e0952f45925e7685$export$a716852a0c5e54d5);
    var $iHYdz;
    var $bzmFE;
    const $e0952f45925e7685$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$e0952f45925e7685$var$getSelectionStyle(selectionStyle)).concat($e0952f45925e7685$export$a716852a0c5e54d5).join('\n');
    const $e0952f45925e7685$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
    const $e0952f45925e7685$var$getSelectionStyle = (style)=>{
        switch(style){
            case (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border:
                return `
        border: ${0, (0, parcelRequire("iHYdz")).akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
            case (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow:
                return `
        box-shadow: ${0, (0, parcelRequire("iHYdz")).akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
            case (0, (0, parcelRequire("bzmFE")).SelectionStyle).Background:
                return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
            case (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket:
                return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, (0, parcelRequire("iHYdz")).akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
            default:
                return '';
        }
    };
});
parcelRegister("bzmFE", function(module, exports) {
    $parcel$export(module.exports, "SelectionStyle", ()=>$2bcf46ee398650df$export$80010201b36a8290);
    var $2bcf46ee398650df$export$80010201b36a8290;
    (function(SelectionStyle) {
        SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
        SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
        SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
        SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    })($2bcf46ee398650df$export$80010201b36a8290 || ($2bcf46ee398650df$export$80010201b36a8290 = {}));
});
parcelRegister("ahG4O", function(module, exports) {
    $parcel$export(module.exports, "UnsupportedSharedCssClassName", ()=>$bb6144152e7474e0$export$629043421dcc56e5);
    $parcel$export(module.exports, "unsupportedStyles", ()=>$bb6144152e7474e0$export$637bcb89343f7ef4);
    var $f8Sb3;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $bb6144152e7474e0$export$629043421dcc56e5 = {
        BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
        INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
    };
    const $bb6144152e7474e0$var$inlineUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.INLINE_CONTAINER} > span:nth-of-type(2)`;
    const $bb6144152e7474e0$var$blockUnsupportedSelector = `.${$bb6144152e7474e0$export$629043421dcc56e5.BLOCK_CONTAINER} > div`;
    const $bb6144152e7474e0$export$637bcb89343f7ef4 = (0, (0, parcelRequire("f8Sb3")).css)($bb6144152e7474e0$var$blockUnsupportedSelector, ",", $bb6144152e7474e0$var$inlineUnsupportedSelector, "{cursor:pointer;}.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Background,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border
    ]), ";}.danger{.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), $bb6144152e7474e0$var$blockUnsupportedSelector, ",.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), $bb6144152e7474e0$var$inlineUnsupportedSelector, "{border:", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackgroundWithOpacity)})`, ";}}");
});
parcelRegister("6jI8m", function(module, exports) {
    $parcel$export(module.exports, "blocktypeStyles", ()=>(parcelRequire("2uCrC")).blocktypeStyles);
    var $2uCrC;
});
parcelRegister("2uCrC", function(module, exports) {
    $parcel$export(module.exports, "blocktypeStyles", ()=>$2b2214035a5c6632$export$610a2509037eaf6);
    var $f8Sb3;
    var $kRRtM;
    var $idytF;
    var $gmhCD = parcelRequire("gmhCD");
    const $2b2214035a5c6632$export$610a2509037eaf6 = (typographyTheme)=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("kRRtM")).blockquoteSharedStyles), ";", (0, (0, parcelRequire("idytF")).headingsSharedStyles)(typographyTheme), ";}", (0, $gmhCD.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-250, 20px)"};
	}

	/* Don't want extra padding for inline editor (nested) */
	.ak-editor-content-area .ak-editor-content-area .ProseMirror blockquote {
		padding-left: ${"var(--ds-space-200, 16px)"};
	}`, ";");
});
parcelRegister("ixETG", function(module, exports) {
    $parcel$export(module.exports, "findReplaceStyles", ()=>(parcelRequire("2PxPK")).findReplaceStyles);
    var $2PxPK;
});
parcelRegister("2PxPK", function(module, exports) {
    $parcel$export(module.exports, "searchMatchClass", ()=>$3a7cd0918514bb36$export$cec6db4af40340f0);
    $parcel$export(module.exports, "selectedSearchMatchClass", ()=>$3a7cd0918514bb36$export$bf208a338b2a2f1f);
    $parcel$export(module.exports, "findReplaceStyles", ()=>$3a7cd0918514bb36$export$c5ceb9c726010930);
    var $f8Sb3;
    const $3a7cd0918514bb36$export$cec6db4af40340f0 = 'search-match';
    const $3a7cd0918514bb36$export$bf208a338b2a2f1f = 'selected-search-match';
    const $3a7cd0918514bb36$export$c5ceb9c726010930 = (0, (0, parcelRequire("f8Sb3")).css)({
        [`.${$3a7cd0918514bb36$export$cec6db4af40340f0}`]: {
            borderRadius: '3px',
            backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
            boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px 0 ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px 0 ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})` + ', inset 0 0 0 1px ' + `var(--ds-border-input, ${`${0, $829f609a65d26a98$export$46987b49aab6d1a8}`})`
        },
        [`.${$3a7cd0918514bb36$export$bf208a338b2a2f1f}`]: {
            backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
        }
    });
});
parcelRegister("4MADL", function(module, exports) {
    $parcel$export(module.exports, "textHighlightStyle", ()=>(parcelRequire("5oKtW")).textHighlightStyle);
    var $5oKtW;
});
parcelRegister("5oKtW", function(module, exports) {
    $parcel$export(module.exports, "textHighlightStyle", ()=>$77eb7ebebd31d467$export$b286500adc7d91cd);
    var $f8Sb3;
    const $77eb7ebebd31d467$export$b286500adc7d91cd = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, $b47580417926a26e$export$78dda1ebb9a1ea84), "{background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff);}");
});
const $b47580417926a26e$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $b47580417926a26e$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $b47580417926a26e$export$78dda1ebb9a1ea84 = 'text-highlight';
const $b47580417926a26e$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $b47580417926a26e$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $b47580417926a26e$export$220f0307408bc0c = 'akEditor';
const $b47580417926a26e$export$299d35c5583816ad = 'paste-options-testid';
const $b47580417926a26e$export$d1234a98f427930 = 'paste-options$';
parcelRegister("kF9Xk", function(module, exports) {
    $parcel$export(module.exports, "placeholderTextStyles", ()=>(parcelRequire("frkDk")).placeholderTextStyles);
    var $frkDk;
});
parcelRegister("frkDk", function(module, exports) {
    $parcel$export(module.exports, "placeholderTextStyles", ()=>$5988333e7352203c$export$56bce713f2cb8aa7);
    var $f8Sb3;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $5988333e7352203c$export$56bce713f2cb8aa7 = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror span[data-placeholder]{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";display:inline;}.ProseMirror span.pm-placeholder{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder__text{display:inline;color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}.ProseMirror span.pm-placeholder.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Background
    ]), ";}.ProseMirror span.pm-placeholder__text[data-placeholder]::after{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";cursor:text;content:attr(data-placeholder);display:inline;}.ProseMirror{.ProseMirror-fake-text-cursor{display:inline;pointer-events:none;position:relative;}.ProseMirror-fake-text-cursor::after{content:'';display:inline;top:0;position:absolute;border-right:1px solid var(--ds-border, rgba(0, 0, 0, 0.4));}.ProseMirror-fake-text-selection{display:inline;pointer-events:none;position:relative;background-color:", `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$8c13c2ee36917869)})`, ";}}");
});
parcelRegister("fz5RS", function(module, exports) {
    $parcel$export(module.exports, "InlineNodeViewSharedStyles", ()=>$2404ec09d44bb929$export$3fc32cdc53f6edeb);
    var $f8Sb3;
    var $5BVRS;
    const $2404ec09d44bb929$export$3fc32cdc53f6edeb = (0, (0, parcelRequire("f8Sb3")).css)({
        [`.${0, (0, parcelRequire("5BVRS")).inlineNodeViewClassname}`]: {
            display: 'inline',
            userSelect: 'all',
            whiteSpace: 'nowrap',
            '& > *:not(.zeroWidthSpaceContainer)': {
                whiteSpace: 'pre-wrap'
            },
            '& > .assistive': {
                userSelect: 'none'
            }
        },
        '&.ua-safari': {
            [`.${0, (0, parcelRequire("5BVRS")).inlineNodeViewClassname}`]: {
                '::selection, *::selection': {
                    background: 'transparent'
                }
            }
        },
        [`&.ua-chrome .${0, (0, parcelRequire("5BVRS")).inlineNodeViewClassname} > span`]: {
            userSelect: 'none'
        },
        [`.${0, (0, parcelRequire("5BVRS")).inlineNodeViewClassname}AddZeroWidthSpace`]: {
            '::after': {
                content: `'${(0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)}'`
            }
        }
    });
});
parcelRegister("5BVRS", function(module, exports) {
    $parcel$export(module.exports, "inlineNodeViewClassname", ()=>$376ab61f8223d072$export$dfb58b577a6f1cd9);
    $parcel$export(module.exports, "getInlineNodeViewProducer", ()=>$376ab61f8223d072$export$17a8c3162956317d);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $gkwXh;
    var $1v3g5;
    var $9pOon;
    var $4NUlu;
    var $gE8f9;
    var $WXnhI;
    var $4tEIi;
    const $376ab61f8223d072$export$dfb58b577a6f1cd9 = 'inlineNodeView';
    function $376ab61f8223d072$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
        let currentNode = nodeViewParams.node;
        const key = (0, (0, parcelRequire("4tEIi")).generateUniqueNodeKey)();
        let domRef = document.createElement('span');
        domRef.contentEditable = 'false';
        $376ab61f8223d072$var$setDomAttrs(nodeViewParams.node, domRef);
        domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$376ab61f8223d072$export$dfb58b577a6f1cd9}`);
        function dispatchAnalyticsEvent(payload) {
            pmPluginFactoryParams.eventDispatcher.emit((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                payload: payload
            });
        }
        function renderComponent() {
            pmPluginFactoryParams.portalProviderAPI.render($376ab61f8223d072$var$getPortalChildren({
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                currentNode: currentNode,
                nodeViewParams: nodeViewParams,
                Component: Component,
                extraComponentProps: extraComponentProps
            }), domRef, key);
        }
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, (0, parcelRequire("WXnhI")).getPerformanceOptions)(nodeViewParams.view);
        trackingEnabled && (0, (0, parcelRequire("WXnhI")).startMeasureReactNodeViewRendered)({
            nodeTypeName: currentNode.type.name
        });
        renderComponent();
        trackingEnabled && (0, (0, parcelRequire("WXnhI")).stopMeasureReactNodeViewRendered)({
            nodeTypeName: currentNode.type.name,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        const nodeView = {
            get dom () {
                return domRef;
            },
            update (nextNode, _decorations) {
                if (currentNode.type !== nextNode.type) return false;
                if (!currentNode.sameMarkup(nextNode)) $376ab61f8223d072$var$setDomAttrs(nextNode, domRef);
                currentNode = nextNode;
                renderComponent();
                return true;
            },
            destroy () {
                pmPluginFactoryParams.portalProviderAPI.remove(key);
                domRef = undefined;
            },
            ...extraNodeViewProps
        };
        return nodeView;
    }
    function $376ab61f8223d072$var$setDomAttrs(node, element) {
        if ((0, (0, parcelRequire("1v3g5")).isSSR)()) return;
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    function $376ab61f8223d072$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
        return function portalChildren() {
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9pOon")).ErrorBoundary), {
                component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: currentNode?.type?.name ?? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: `zeroWidthSpaceContainer`
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
            }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)), (0, (0, parcelRequire("f8Sb3")).jsx)(Component, {
                view: nodeViewParams.view,
                getPos: nodeViewParams.getPos,
                node: currentNode,
                ...extraComponentProps
            }), (0, (0, parcelRequire("gE8f9")).browser).android ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: `zeroWidthSpaceContainer`,
                contentEditable: "false"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
            }), (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) : (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: `${$376ab61f8223d072$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
            }));
        };
    }
    function $376ab61f8223d072$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
        function nodeViewProducer(...nodeViewProducerParameters) {
            const nodeView = $376ab61f8223d072$var$createNodeView({
                nodeViewParams: {
                    node: nodeViewProducerParameters[0],
                    view: nodeViewProducerParameters[1],
                    getPos: nodeViewProducerParameters[2],
                    decorations: nodeViewProducerParameters[3]
                },
                pmPluginFactoryParams: pmPluginFactoryParams,
                Component: Component,
                extraComponentProps: extraComponentProps,
                extraNodeViewProps: extraNodeViewProps
            });
            return nodeView;
        }
        return nodeViewProducer;
    }
});
parcelRegister("9pOon", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$88b42bbe41ec844f$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $1KzE6;
    class $88b42bbe41ec844f$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        hasFallback() {
            return typeof this.props.fallbackComponent !== 'undefined';
        }
        shouldRecover() {
            return this.hasFallback() && this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).EDITOR_CRASHED,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error,
                    errorInfo: errorInfo,
                    errorRethrown: !this.hasFallback()
                }
            });
            (0, (0, parcelRequire("1KzE6")).logException)(error, {
                location: 'editor-common'
            });
            if (this.hasFallback()) this.setState({
                errorCaptured: true
            });
        }
        render() {
            if (this.shouldRecover()) return this.props.fallbackComponent;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                errorCaptured: false
            };
        }
    }
});
parcelRegister("WXnhI", function(module, exports) {
    $parcel$export(module.exports, "getPerformanceOptions", ()=>$c14b3b53100539b7$export$9838b97af1c61be);
    $parcel$export(module.exports, "startMeasureReactNodeViewRendered", ()=>$c14b3b53100539b7$export$2630f5971dfad231);
    $parcel$export(module.exports, "stopMeasureReactNodeViewRendered", ()=>$c14b3b53100539b7$export$dc5a82f0bfc526c3);
    var $gkwXh;
    var $iN9lO;
    let $c14b3b53100539b7$var$nodeViewRenderedEventsCounter = 0;
    const $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE = 100;
    const $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD = 7;
    function $c14b3b53100539b7$export$9838b97af1c61be(view) {
        const fakePluginKey = {
            key: 'analyticsPlugin$',
            getState: (state)=>{
                return state['analyticsPlugin$'];
            }
        };
        const pluginState = fakePluginKey.getState(view.state);
        const nodeViewTracking = pluginState && pluginState.performanceTracking ? pluginState.performanceTracking.nodeViewTracking || {} : {};
        const samplingRate = nodeViewTracking.samplingRate ?? $c14b3b53100539b7$var$DEFAULT_SAMPLING_RATE;
        const slowThreshold = nodeViewTracking.slowThreshold ?? $c14b3b53100539b7$var$DEFAULT_SLOW_THRESHOLD;
        return {
            trackingEnabled: !!nodeViewTracking.enabled,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        };
    }
    function $c14b3b53100539b7$export$2630f5971dfad231({ nodeTypeName: nodeTypeName }) {
        (0, (0, parcelRequire("iN9lO")).startMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`);
    }
    function $c14b3b53100539b7$export$dc5a82f0bfc526c3({ nodeTypeName: nodeTypeName, dispatchAnalyticsEvent: dispatchAnalyticsEvent, samplingRate: samplingRate, slowThreshold: slowThreshold }) {
        (0, (0, parcelRequire("iN9lO")).stopMeasure)(`\u{1F989}${nodeTypeName}::ReactNodeView`, (duration)=>{
            if (++$c14b3b53100539b7$var$nodeViewRenderedEventsCounter % samplingRate === 0 && duration > slowThreshold) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).REACT_NODEVIEW_RENDERED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    node: nodeTypeName,
                    duration: duration
                }
            });
        });
    }
});
const $0f804702eb36dd5e$export$15a09f5ef055bcfa = '\u200b';
const $0f804702eb36dd5e$export$2b4d00c13dcd3c1f = '\u200d';
parcelRegister("4tEIi", function(module, exports) {
    $parcel$export(module.exports, "generateUniqueNodeKey", ()=>$50f69fedc475632c$export$4a323a0542a1e4d1);
    var $bXrHm = parcelRequire("bXrHm");
    const $50f69fedc475632c$export$4a323a0542a1e4d1 = ()=>{
        return (0, ($parcel$interopDefault($bXrHm)))();
    };
});
parcelRegister("9O4yy", function(module, exports) {
    $parcel$export(module.exports, "aiPanelStyles", ()=>$1e36f2eb545c5b87$export$cdf1b75966a7ba92);
    var $f8Sb3;
    const $1e36f2eb545c5b87$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const $1e36f2eb545c5b87$var$rotationAnimation = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%': {
            '--panel-gradient-angle': '0deg',
            ...$1e36f2eb545c5b87$var$isFirefox ? {
                backgroundPosition: '100%'
            } : {}
        },
        '100%': {
            '--panel-gradient-angle': '360deg',
            ...$1e36f2eb545c5b87$var$isFirefox ? {
                backgroundPosition: '-100%'
            } : {}
        }
    });
    const $1e36f2eb545c5b87$var$aiPrismColor = {
        ['prism.border.step.1']: {
            light: '#0065FF',
            dark: '#0065FF80'
        },
        ['prism.border.step.2']: {
            light: '#0469FF',
            dark: '#0469FF80'
        },
        ['prism.border.step.3']: {
            light: '#BF63F3',
            dark: '#BF63F380'
        },
        ['prism.border.step.4']: {
            light: '#FFA900',
            dark: '#FFA90080'
        }
    };
    const $1e36f2eb545c5b87$var$prismBorderAnimationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before, &::after': {
            animation: `${$1e36f2eb545c5b87$var$rotationAnimation} linear 2s infinite`,
            ...$1e36f2eb545c5b87$var$isFirefox ? {
                animationDirection: 'normal',
                animationDuration: '1s'
            } : {},
            '@media (prefers-reduced-motion)': {
                animation: 'none'
            }
        }
    });
    const $1e36f2eb545c5b87$var$prismBorderStyles = (colorMode, hover)=>(0, (0, parcelRequire("f8Sb3")).css)({
            content: "''",
            position: 'absolute',
            zIndex: -1,
            width: `calc(100% + 2px)`,
            height: `calc(100% + 2px)`,
            top: `-1px`,
            left: `-1px`,
            borderRadius: `calc(${"var(--ds-border-radius-100, 3px)"} + 1px)`,
            transform: 'translate3d(0, 0, 0)',
            ...hover ? {
                background: "var(--ds-border-input, #8590A2)"
            } : $1e36f2eb545c5b87$var$isFirefox ? {
                background: `linear-gradient(90deg,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 12%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 24%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 48%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 64%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 80%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`,
                backgroundSize: '200%'
            } : {
                background: `conic-gradient(
								from var(--panel-gradient-angle, 270deg),
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 0%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.2'][colorMode ?? 'light']} 20%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.3'][colorMode ?? 'light']} 50%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.4'][colorMode ?? 'light']} 56%,
								${$1e36f2eb545c5b87$var$aiPrismColor['prism.border.step.1'][colorMode ?? 'light']} 100%
							)`
            }
        });
    const $1e36f2eb545c5b87$export$cdf1b75966a7ba92 = (colorMode)=>(0, (0, parcelRequire("f8Sb3")).css)("@property --panel-gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}div[extensionType='com.atlassian.ai-blocks']{.extension-label{display:none;}.extension-container{position:relative;box-shadow:none;overflow:unset;background-color:var(--ds-surface, #FFFFFF)!important;&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}&.with-hover-border{&::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode, true), ";}}& .with-margin-styles{background-color:var(--ds-surface, #FFFFFF)!important;border-radius:var(--ds-border-radius-100, 3px);}}}div[extensionType='com.atlassian.ai-blocks']:has(.streaming){.extension-container{box-shadow:none;overflow:unset;", $1e36f2eb545c5b87$var$prismBorderAnimationStyles, " &::before,&::after{", $1e36f2eb545c5b87$var$prismBorderStyles(colorMode), ";}}}div[extensionType='com.atlassian.ai-blocks'].danger{.extension-container{box-shadow:0 0 0 1px var(--ds-border-danger, #E2483D);}}div[extensiontype='com.atlassian.ai-blocks'][extensionkey='ai-action-items-block:aiActionItemsBodiedExtension']{div[data-node-type='actionList']{margin:0!important;}}");
});
parcelRegister("cEh6Q", function(module, exports) {
    $parcel$export(module.exports, "codeBlockStyles", ()=>$fae98ce4976198e8$export$4baaed2b257b830);
    var $f8Sb3;
    var $cYeQP;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $gmhCD = parcelRequire("gmhCD");
    function $fae98ce4976198e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $fae98ce4976198e8$var$_ref = {
        name: "1dgciks",
        styles: "&::after{height:100%;content:'';position:absolute;left:0;top:0;width:24px;background-color:var(--ds-blanket-danger, none);}"
    };
    const $fae98ce4976198e8$var$GutterDangerOverlay = ()=>$fae98ce4976198e8$var$_ref;
    const $fae98ce4976198e8$var$firstCodeBlockWithNoMargin = (0, $gmhCD.editorExperiment)('nested-dnd', true) ? {
        name: "142jt9z",
        styles: ".ak-editor-panel__content{>.code-block:first-child,>.ProseMirror-widget:first-child+.code-block,>.ProseMirror-widget:first-child+.ProseMirror-widget+.code-block{margin:0 0 0 0!important;}}"
    } : {
        name: "czrl7q",
        styles: ".ak-editor-panel__content{>.code-block:first-child{margin:0 0 0 0!important;}}"
    };
    const $fae98ce4976198e8$export$4baaed2b257b830 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("cYeQP")).codeBlockSharedStyles)(), ";}.ProseMirror li{>.code-block{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), ";}}.ProseMirror .code-block.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";}.ProseMirror .danger.code-block{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, #FFECEB);color:", `var(--ds-text-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:", `var(--ds-blanket-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";}}.ProseMirror .danger .code-block{.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-danger, rgba(255, 143, 115, 0.5));color:", `var(--ds-text-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";", $fae98ce4976198e8$var$GutterDangerOverlay(), ";}.", (0, (0, parcelRequire("cYeQP")).CodeBlockSharedCssClassName).CODEBLOCK_CONTENT, "{background-color:var(--ds-blanket-danger, rgba(255, 189, 173, 0.5));}}", $fae98ce4976198e8$var$firstCodeBlockWithNoMargin, ";");
});
parcelRegister("dv67m", function(module, exports) {
    $parcel$export(module.exports, "dateStyles", ()=>$f64e5f28f7da36f5$export$37579fbc35dcc1a9);
    var $f8Sb3;
    var $4E5wI;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $f64e5f28f7da36f5$export$37579fbc35dcc1a9 = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("4E5wI")).DateSharedCssClassName).DATE_CONTAINER, "{.", (0, (0, parcelRequire("4E5wI")).DateSharedCssClassName).DATE_WRAPPER, "{line-height:initial;cursor:pointer;}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{.", (0, (0, parcelRequire("4E5wI")).DateSharedCssClassName).DATE_WRAPPER, ">span{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
    ]), ";}}}.danger{.", (0, (0, parcelRequire("4E5wI")).DateSharedCssClassName).DATE_CONTAINER, ".", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("4E5wI")).DateSharedCssClassName).DATE_WRAPPER, ">span{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";}}");
});
parcelRegister("cBEjw", function(module, exports) {
    $parcel$export(module.exports, "expandStyles", ()=>$ac21c05ea8fc9971$export$4bb28258452e3b9a);
    var $f8Sb3;
    var $5HrRs;
    var $cr1aY;
    var $dVbMk;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    function $ac21c05ea8fc9971$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0.6))";
    var $ac21c05ea8fc9971$var$_ref2 = {
        name: "1t3zvjb",
        styles: "color:var(--ds-icon-subtle, #626F86)"
    };
    const $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR = ()=>$ac21c05ea8fc9971$var$_ref2;
    const $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR = "var(--ds-background-danger, #FFECEB)";
    const $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR = "var(--ds-border-danger, #E2483D)";
    var $ac21c05ea8fc9971$var$_ref = {
        name: "1oz7tqa",
        styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}>div.ak-editor-expand[data-node-type='nestedExpand']{margin-top:var(--ds-space-050, 0.25rem);}"
    };
    const $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $ac21c05ea8fc9971$var$_ref : '';
    const $ac21c05ea8fc9971$export$4bb28258452e3b9a = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("cr1aY")).expandClassNames).icon, ">div{display:flex;}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).prefix, "{", (0, (0, parcelRequire("dVbMk")).sharedExpandStyles).containerStyles({
            expanded: false,
            focused: false
        })(), " cursor:pointer;box-sizing:border-box;td>&{margin-top:0;}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(90deg);}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){", (0, $gmhCD.editorExperiment)('nested-dnd', true) ? (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]) + `border: ${0, (0, parcelRequire("iHYdz")).akEditorSelectedBorder};` : (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border
        ]), ";}&.danger{background:", $ac21c05ea8fc9971$var$DANGER_STATE_BACKGROUND_COLOR, ";border-color:", $ac21c05ea8fc9971$var$DANGER_STATE_BORDER_COLOR, ";}}.ProseMirror>.", (0, (0, parcelRequire("cr1aY")).expandClassNames).type('expand'), ",.", (0, (0, parcelRequire("5HrRs")).BreakoutCssClassName).BREAKOUT_MARK_DOM, ">.", (0, (0, parcelRequire("cr1aY")).expandClassNames).type('expand'), "{margin-left:-", (0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset), "px;margin-right:-", (0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset), "px;}", (0, $gmhCD.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror
		> .${(0, (0, parcelRequire("cr1aY")).expandClassNames).type('expand')},
		.${(0, (0, parcelRequire("5HrRs")).BreakoutCssClassName).BREAKOUT_MARK_DOM}
		> .${(0, (0, parcelRequire("cr1aY")).expandClassNames).type('expand')} {
		margin-left: -${(0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) + 8}px;
		margin-right: -${(0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) + 8}px;
	}`, " .", (0, (0, parcelRequire("cr1aY")).expandClassNames).content, "{", (0, (0, parcelRequire("dVbMk")).sharedExpandStyles).contentStyles({
            expanded: false,
            focused: false
        })(), " cursor:text;padding-top:0px;", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_drag_and_drop_expand_style_fix') && `overflow-x: clip;`, ";}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).titleInput, "{", (0, (0, parcelRequire("dVbMk")).sharedExpandStyles).titleInputStyles(), ";}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).titleContainer, "{", (0, (0, parcelRequire("dVbMk")).sharedExpandStyles).titleContainerStyles(), ";align-items:center;overflow:visible;}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).expanded, "{background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";border-color:var(--ds-border, #091E4224);.", (0, (0, parcelRequire("cr1aY")).expandClassNames).content, "{padding-top:var(--ds-space-100, 8px);", $ac21c05ea8fc9971$var$firstNodeWithNotMarginTop(), ";}}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).inputContainer, "{width:100%;}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).prefix, ":(.", (0, (0, parcelRequire("cr1aY")).expandClassNames).expanded, "){.expand-content-wrapper{height:auto;}}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).prefix, ":not(.", (0, (0, parcelRequire("cr1aY")).expandClassNames).expanded, "){.ak-editor-expand__content{position:absolute;height:1px;width:1px;overflow:hidden;clip:rect(1px, 1px, 1px, 1px);white-space:nowrap;}.", (0, (0, parcelRequire("cr1aY")).expandClassNames).iconContainer, " svg{", $ac21c05ea8fc9971$var$EXPAND_ICON_COLOR(), ";transform:rotate(0deg);}&:not(.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "):not(.danger){background:transparent;border-color:transparent;&:hover{border-color:var(--ds-border, #091E4224);background:", $ac21c05ea8fc9971$var$EXPAND_SELECTED_BACKGROUND, ";}}}");
});
parcelRegister("5HrRs", function(module, exports) {
    $parcel$export(module.exports, "BreakoutCssClassName", ()=>$96d4c7fd1ee4abdc$export$c21a3b023fccd534);
    const $96d4c7fd1ee4abdc$export$c21a3b023fccd534 = {
        BREAKOUT_MARK: 'fabric-editor-breakout-mark',
        BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
    };
});
parcelRegister("dVbMk", function(module, exports) {
    $parcel$export(module.exports, "sharedExpandStyles", ()=>$78318408d2d2a85d$export$8c0b53d8e8508fed);
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    const $78318408d2d2a85d$var$BORDER_RADIUS = "var(--ds-border-radius-100, 4px)";
    const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND = "var(--ds-background-neutral-subtle, transparent)";
    const $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND = "var(--ds-surface, rgba(255, 255, 255, 0.6))";
    const $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR = "var(--ds-border-focused, #388BFF)";
    const $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR = 'transparent';
    const $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR = "var(--ds-border, #091E4224)";
    const $78318408d2d2a85d$var$containerStyles = (styleProps)=>{
        const { expanded: expanded, focused: focused } = styleProps;
        const marginTop = "var(--ds-space-050, 0.25rem)";
        const marginBottom = 0;
        const marginHorizontal = styleProps['data-node-type'] === 'expand' ? `-${0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset}px` : 0;
        const margin = `${marginTop} ${marginHorizontal} ${marginBottom}`;
        return ()=>(0, (0, parcelRequire("f8Sb3")).css)({
                borderWidth: '1px',
                borderStyle: 'solid',
                borderColor: focused ? $78318408d2d2a85d$var$EXPAND_FOCUSED_BORDER_COLOR : expanded ? $78318408d2d2a85d$var$EXPAND_EXPANDED_BORDER_COLOR : $78318408d2d2a85d$var$EXPAND_COLLAPSED_BORDER_COLOR,
                borderRadius: $78318408d2d2a85d$var$BORDER_RADIUS,
                minHeight: '25px',
                background: !expanded ? $78318408d2d2a85d$var$EXPAND_COLLAPSED_BACKGROUND : $78318408d2d2a85d$var$EXPAND_SELECTED_BACKGROUND,
                margin: margin,
                transition: `background 0.3s ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}, border-color 0.3s ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`,
                padding: "var(--ds-space-100, 8px)",
                'td > :not(style):first-child, td > style:first-child + *': {
                    marginTop: 0
                }
            });
    };
    const $78318408d2d2a85d$var$contentStyles = (styleProps)=>()=>(0, (0, parcelRequire("f8Sb3")).css)("padding-top:", styleProps.expanded ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)", ";padding-right:var(--ds-space-100, 8px);padding-left:var(--ds-space-300, 24px);margin-left:var(--ds-space-050, 4px);display:flow-root;@supports not (display: flow-root){width:100%;box-sizing:border-box;}", !styleProps.expanded ? `
        .expand-content-wrapper, .nestedExpand-content-wrapper {
          /* We visually hide the content here to preserve the content during copy+paste */
          /* Do not add text nowrap here because inline comment navigation depends on the location of the text */
          width: 100%;
          display: block;
          height: 0;
          overflow: hidden;
          clip: rect(1px, 1px, 1px, 1px);
          user-select: none;
        }
      ` : '', ";");
    const $78318408d2d2a85d$var$titleInputStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            outline: 'none',
            border: 'none',
            fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
            lineHeight: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? 1 : (0, (0, parcelRequire("iHYdz")).akEditorLineHeight),
            fontWeight: 'normal',
            color: "var(--ds-text-subtlest, #626F86)",
            background: 'transparent',
            display: 'flex',
            flex: 1,
            padding: `0 0 0 ${"var(--ds-space-050, 4px)"}`,
            width: '100%',
            '&::placeholder': {
                opacity: 1,
                color: "var(--ds-text-subtlest, #626F86)"
            }
        });
    const $78318408d2d2a85d$var$titleContainerStyles = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            padding: 0,
            display: 'flex',
            alignItems: 'flex-start',
            background: 'none',
            border: 'none',
            fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(14),
            width: '100%',
            color: "var(--ds-text-subtle, #44546F)",
            overflow: 'hidden',
            cursor: 'pointer',
            '&:focus': {
                outline: 0
            }
        });
    const $78318408d2d2a85d$export$8c0b53d8e8508fed = {
        titleInputStyles: $78318408d2d2a85d$var$titleInputStyles,
        titleContainerStyles: $78318408d2d2a85d$var$titleContainerStyles,
        containerStyles: $78318408d2d2a85d$var$containerStyles,
        contentStyles: $78318408d2d2a85d$var$contentStyles
    };
});
parcelRegister("hucfL", function(module, exports) {
    $parcel$export(module.exports, "extensionStyles", ()=>$734bc965b81ee341$export$c0c648396dbd86d3);
    var $f8Sb3;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $734bc965b81ee341$var$extensionLabelStyles = (0, (0, parcelRequire("f8Sb3")).css)("&.danger>span>div>.extension-label{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);opacity:1;box-shadow:none;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div>.extension-label{background-color:var(--ds-background-selected, #E9F2FF);color:var(--ds-text-selected, #0C66E4);opacity:1;box-shadow:none;}&.danger>span>div>.extension-label>span{display:inline;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div .extension-label>span{display:inline;}&.danger.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container{opacity:1;}&.danger.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div>.extension-label.always-hide-label{opacity:0;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);}&.danger.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>div>.extension-label.with-bodied-macro-live-page-styles{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px var(--ds-border-danger, #E2483D);}&.danger.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">span>.extension-edit-toggle-container>.extension-edit-toggle{background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-text-danger, #AE2E24);box-shadow:none;}");
    const $734bc965b81ee341$var$dangerOverlayStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0.3,
        backgroundColor: `var(--ds-background-danger-hovered, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`
    });
    const $734bc965b81ee341$export$c0c648396dbd86d3 = (0, (0, parcelRequire("f8Sb3")).css)(".multiBodiedExtensionView-content-wrap{&.danger>span>.multiBodiedExtension--container{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.multiBodiedExtension--overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{&>span>.multiBodiedExtension--container{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
    ]), ";}}.multiBodiedExtension--container{width:100%;max-width:100%;}}.inlineExtensionView-content-wrap{", $734bc965b81ee341$var$extensionLabelStyles, ";&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";}&.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
    ]), ";}}}.bodied-extension-to-dom-label::after{content:attr(data-bodied-extension-label);}.extensionView-content-wrap,.multiBodiedExtensionView-content-wrap,.bodiedExtensionView-content-wrap{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0;&:first-of-type{margin-top:0;}&:last-of-type{margin-bottom:0;}&:not(.danger).", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{&>span>.extension-container{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
    ]), ";}}&.danger>span>.extension-container{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";}", $734bc965b81ee341$var$extensionLabelStyles, " &.danger>span>.with-danger-overlay{background-color:transparent;.extension-overlay{", $734bc965b81ee341$var$dangerOverlayStyles, ";}}&.inline{word-wrap:break-all;}}.extensionView-content-wrap .extension-container{overflow:hidden;}.bodiedExtensionView-content-wrap .extensionView-content-wrap .extension-container{width:100%;max-width:100%;}[data-mark-type='fragment']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin:", (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin), " 0;}}&:first-child{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-top:0;}}}&:nth-last-of-type(-n + 2):not(:first-of-type){&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}&>[data-mark-type='dataConsumer']{&>.extensionView-content-wrap,&>.bodiedExtensionView-content-wrap{margin-bottom:0;}}}}");
});
parcelRegister("l5gcr", function(module, exports) {
    $parcel$export(module.exports, "layoutStyles", ()=>$d274b53d45a9ace1$export$ac8f5049e4e10701);
    var $f8Sb3;
    var $719f3;
    var $ejmVg;
    parcelRequire("azRCC");
    var $eUhGn;
    parcelRequire("eTjGD");
    var $1v4Xe;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    function $d274b53d45a9ace1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d274b53d45a9ace1$var$isPreRelease2 = ()=>{
        return (0, $gmhCD.editorExperiment)('advanced_layouts', true) || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_pre_release_2');
    };
    var $d274b53d45a9ace1$var$_ref = {
        name: "kzeyqg",
        styles: ">:not(style):first-child,>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*{margin-top:0;}"
    };
    var $d274b53d45a9ace1$var$_ref2 = {
        name: "1fct7qz",
        styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
    };
    const $d274b53d45a9ace1$var$firstNodeWithNotMarginTop = ()=>(0, $gmhCD.editorExperiment)('nested-dnd', true) ? $d274b53d45a9ace1$var$_ref2 : $d274b53d45a9ace1$var$_ref;
    const $d274b53d45a9ace1$var$layoutColumnStyles = ()=>$d274b53d45a9ace1$var$isPreRelease2() ? (0, (0, parcelRequire("f8Sb3")).css)(">[data-layout-column]{margin:0 ", (0, (0, parcelRequire("ejmVg")).LAYOUT_SECTION_MARGIN) / 2, "px;}>[data-layout-column]:first-of-type{margin-left:0;}>[data-layout-column]:last-of-type{margin-right:0;}@media screen and (max-width: ", (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin:0;}}>[data-layout-column].", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";::before{width:calc(100% - 8px);left:4px;}}") : (0, (0, parcelRequire("f8Sb3")).css)("[data-layout-column]+[data-layout-column]{margin-left:", (0, (0, parcelRequire("ejmVg")).LAYOUT_SECTION_MARGIN), "px;}@media screen and (max-width: ", (0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth), "px){[data-layout-column]+[data-layout-column]{margin-left:0;}}");
    const $d274b53d45a9ace1$var$layoutSectionStyles = ()=>(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("719f3")).columnLayoutResponsiveSharedStyle), ";.layout-section-container [data-layout-section]{>.ProseMirror-widget{flex:none;display:contents!important;&[data-blocks-drag-handle-container] div{display:contents!important;}&[data-blocks-drop-target-container]{display:block!important;margin:var(--ds-space-negative-050, -4px);[data-drop-target-for-element]{position:absolute;}}&+[data-layout-column]{margin:0;}}>[data-layout-column]{margin:0;}}") : (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("719f3")).columnLayoutSharedStyle), ";");
    const $d274b53d45a9ace1$var$layoutBorderStyles = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)("&.selected [data-layout-column],&:hover [data-layout-column]{border:", viewMode === 'view' ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);}&.selected.danger [data-layout-column]{background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";border-color:", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), " ::after{background-color:transparent;}}}");
    const $d274b53d45a9ace1$var$columnSeparatorStyles = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)("[data-layout-content]::before{content:'';border-left:", viewMode === 'view' ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;height:calc(100% - 24px);margin-left:-25px;}");
    const $d274b53d45a9ace1$var$rowSeparatorStyles = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)("[data-layout-content]::before{content:'';border-top:", viewMode === 'view' ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);position:absolute;width:calc(100% - 32px);margin-top:-13px;border-left:unset;margin-left:unset;height:unset;}");
    const $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles = (breakpoint, viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)("&.selected,&:hover,&.selected.danger,&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){[data-layout-column]:not(:first-of-type){", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? `@container editor-area (max-width:${breakpoint}px)` : `@media screen and (max-width: ${(0, (0, parcelRequire("iHYdz")).gridMediumMaxWidth) - 1}px)`, "{", $d274b53d45a9ace1$var$rowSeparatorStyles(viewMode), ";}}}");
    const $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)("&.selected [data-layout-column]:not(:first-of-type),&:hover [data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}&.selected.danger ", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? `[data-layout-section]` : ``, "{background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", (0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder), ";border-radius:4px;[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger) ", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') ? `[data-layout-section]` : ``, "{box-shadow:0 0 0 ", viewMode === 'view' ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px var(--ds-border-selected, #0C66E4);border-radius:4px;background-color:var(--ds-background-selected, #E9F2FF);[data-layout-column]{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), " border:0px;::before{background-color:transparent;}}[data-layout-column]:not(:first-of-type){", $d274b53d45a9ace1$var$columnSeparatorStyles(viewMode), ";}}");
    const $d274b53d45a9ace1$var$layoutResponsiveStyles = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)(".fabric-editor--full-width-mode .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(854, viewMode), ";[data-layout-section]{@container editor-area (max-width:854px){flex-direction:column;}}}}.ak-editor-content-area:not(.fabric-editor--full-width-mode) .ProseMirror{>.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(918, viewMode), ";[data-layout-section]{@container editor-area (max-width:918px){flex-direction:column;}}}}.ProseMirror .fabric-editor-breakout-mark{.layoutSectionView-content-wrap{", $d274b53d45a9ace1$var$layoutWithSeparatorBorderResponsiveStyles(950, viewMode), ";[data-layout-section]{@container editor-area (max-width:950px){flex-direction:column;}}}}");
    const $d274b53d45a9ace1$export$ac8f5049e4e10701 = (viewMode)=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", $d274b53d45a9ace1$var$layoutSectionStyles(), " [data-layout-section]{margin:var(--ds-space-100, 8px) -", (0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset), "px 0;transition:border-color 0.3s ", (0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier), ";cursor:", viewMode === 'view' ? 'default' : 'pointer', ";", $d274b53d45a9ace1$var$layoutColumnStyles(), ";[data-layout-column]{flex:1;", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_drag_and_drop_target_v2') ? 'position: relative;' : '', " min-width:0;border:", viewMode === 'view' || (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid var(--ds-border, #091E4224);border-radius:4px;padding:", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING), "px ", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING) + ((0, $gmhCD.editorExperiment)('nested-dnd', true) ? 8 : 0), "px;box-sizing:border-box;>div{", $d274b53d45a9ace1$var$firstNodeWithNotMarginTop(), ">.embedCardView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.mediaSingleView-content-wrap:first-of-type .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor.-right:first-child+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor.-right+.mediaSingleView-content-wrap .rich-media-item,>.ProseMirror-gapcursor.-right:first-of-type+.embedCardView-content-wrap .rich-media-item{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+.mediaSingleView-content-wrap .rich-media-item,>style:first-child+.ProseMirror-gapcursor+span+.mediaSingleView-content-wrap .rich-media-item{margin-top:0;}>[data-node-type='decisionList']{li:first-of-type [data-decision-wrapper]{margin-top:0;}}}[data-layout-content]{height:100%;cursor:text;.mediaGroupView-content-wrap{clear:both;}}}}[data-layout-section],.layoutSectionView-content-wrap{", (0, $gmhCD.editorExperiment)('advanced_layouts', true) ? $d274b53d45a9ace1$var$layoutWithSeparatorBorderStyles(viewMode) : $d274b53d45a9ace1$var$layoutBorderStyles(viewMode), ";}}", (0, $gmhCD.editorExperiment)('advanced_layouts', true) && $d274b53d45a9ace1$var$layoutResponsiveStyles(viewMode), " .fabric-editor--full-width-mode .ProseMirror{[data-layout-section]{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "{margin:0 ", (0, (0, parcelRequire("1v4Xe")).tableMarginFullWidthMode), "px;}}}", (0, $gmhCD.editorExperiment)('nested-dnd', true) && !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_advanced_layouts_breakout_resizing') && `.ak-editor-content-area.appearance-full-page .ProseMirror [data-layout-section] {
				margin: ${"var(--ds-space-100, 8px)"} -${(0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) + 8}px 0;
				}`, ";");
});
parcelRegister("azRCC", function(module, exports) {
    $parcel$export(module.exports, "TableCssClassName", ()=>(parcelRequire("eUhGn")).TableCssClassName);
    var $eUhGn;
});
parcelRegister("eUhGn", function(module, exports) {
    $parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", ()=>$0a07d562442d8442$export$1a38c7157d718094);
    $parcel$export(module.exports, "TableDecorations", ()=>$0a07d562442d8442$export$fe8f2ca19399400e);
    $parcel$export(module.exports, "TableCssClassName", ()=>$0a07d562442d8442$export$19a8a7a6488b1b9f);
    $parcel$export(module.exports, "ShadowEvent", ()=>$0a07d562442d8442$export$ce63d9b315ac58c9);
    var $9UDEr;
    var $6gEe5;
    const $0a07d562442d8442$export$1a38c7157d718094 = 30;
    var $0a07d562442d8442$export$fe8f2ca19399400e;
    (function(TableDecorations) {
        TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
        TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
        TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
        TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
        TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
        TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
        TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
        TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
        TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
        TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
        TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
        TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
        TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
        TableDecorations["LAST_CELL_ELEMENT"] = "LAST_CELL_ELEMENT";
    })($0a07d562442d8442$export$fe8f2ca19399400e || ($0a07d562442d8442$export$fe8f2ca19399400e = {}));
    const $0a07d562442d8442$export$19a8a7a6488b1b9f = {
        ...(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName),
        COLUMN_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-controls`,
        COLUMN_CONTROLS_DECORATIONS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-controls-decoration`,
        COLUMN_SELECTED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column__selected`,
        ROW_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls-wrapper`,
        ROW_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls`,
        ROW_CONTROLS_INNER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls__inner`,
        ROW_CONTROLS_BUTTON_WRAP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls__button-wrap`,
        ROW_CONTROLS_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-controls__button`,
        CONTROLS_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__button`,
        CONTROLS_BUTTON_ICON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__button-icon`,
        CONTROLS_INSERT_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-button`,
        CONTROLS_INSERT_BUTTON_INNER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-button-inner`,
        CONTROLS_INSERT_BUTTON_WRAP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-button-wrap`,
        CONTROLS_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-line`,
        CONTROLS_BUTTON_OVERLAY: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__button-overlay`,
        DRAG_CONTROLS_INSERT_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button`,
        DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button-inner`,
        DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
        DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
        DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
        DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__drag-insert-button-wrap`,
        CONTROLS_INSERT_MARKER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-marker`,
        CONTROLS_INSERT_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-column`,
        CONTROLS_INSERT_ROW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__insert-row`,
        CONTROLS_DELETE_BUTTON_WRAP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__delete-button-wrap`,
        CONTROLS_DELETE_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls__delete-button`,
        CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls-floating__button-column`,
        CONTROLS_FLOATING_BUTTON_ROW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-controls-floating__button-row`,
        CORNER_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-corner-controls`,
        CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-corner-controls__insert-row-marker`,
        CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-corner-controls__insert-column-marker`,
        CONTROLS_CORNER_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-corner-button`,
        DRAG_ROW_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-row-controls-wrapper`,
        DRAG_ROW_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-row-controls`,
        DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
        DRAG_ROW_FLOATING_INSERT_DOT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-row-floating-insert-dot`,
        DRAG_COLUMN_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-column-controls`,
        DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
        DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-columns-floating-insert-dot`,
        DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-col-controls-wrapper`,
        DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-col-drop-target-controls`,
        DRAG_COLUMN_CONTROLS_INNER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-col-controls__inner`,
        DRAG_HANDLE_BUTTON_CONTAINER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-handle-button-container`,
        DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-handle-button-clickable-zone`,
        DRAG_CORNER_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-corner-button`,
        DRAG_CORNER_BUTTON_INNER: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-corner-button-inner`,
        DRAG_HANDLE_DISABLED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-handle-disabled`,
        DRAG_HANDLE_MINIMISED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-handle-minimised`,
        DRAG_SUBMENU: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-submenu`,
        DRAG_SUBMENU_ICON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-submenu-icon`,
        NUMBERED_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-numbered-column`,
        NUMBERED_COLUMN_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-numbered-column__button`,
        NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-numbered-column__button-disabled`,
        HOVERED_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-column`,
        HOVERED_ROW: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-row`,
        HOVERED_TABLE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-table`,
        HOVERED_NO_HIGHLIGHT: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-no-highlight`,
        HOVERED_CELL: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-cell`,
        HOVERED_CELL_IN_DANGER: 'danger',
        HOVERED_CELL_ACTIVE: 'active',
        HOVERED_CELL_WARNING: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-cell__warning`,
        HOVERED_DELETE_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-hovered-delete-button`,
        WITH_CONTROLS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-with-controls`,
        RESIZING_PLUGIN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resizing-plugin`,
        RESIZE_CURSOR: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resize-cursor`,
        IS_RESIZING: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-is-resizing`,
        RESIZE_HANDLE_DECORATION: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-resize-decoration`,
        CONTEXTUAL_SUBMENU: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-submenu`,
        CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-menu-button-wrap`,
        CONTEXTUAL_MENU_BUTTON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-menu-button`,
        CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-menu-button-fixed`,
        CONTEXTUAL_MENU_ICON: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-submenu-icon`,
        CONTEXTUAL_MENU_ICON_SMALL: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-contextual-submenu-icon-small`,
        SELECTED_CELL: 'selectedCell',
        NODEVIEW_WRAPPER: 'tableView-content-wrap',
        TABLE_SELECTED: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-table__selected`,
        TABLE_CELL: (0, (0, parcelRequire("9UDEr")).tableCellSelector),
        TABLE_HEADER_CELL: (0, (0, parcelRequire("9UDEr")).tableHeaderSelector),
        TABLE_STICKY: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-sticky`,
        TABLE_CHROMELESS: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-chromeless`,
        TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
        LAST_ITEM_IN_CELL: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-last-item-in-cell`,
        WITH_COLUMN_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-insert-line`,
        WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-insert-line__inactive`,
        WITH_FIRST_COLUMN_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-first-column-insert-line`,
        WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-first-column-insert-line__inactive`,
        WITH_LAST_COLUMN_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-last-column-insert-line`,
        WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-last-column-insert-line__inactive`,
        WITH_RESIZE_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-resize-line`,
        WITH_RESIZE_LINE_LAST_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-column-resize-line-last-column`,
        WITH_DRAG_RESIZE_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-column-resize-line`,
        WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-drag-column-resize-line-last-column`,
        WITH_ROW_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-insert-line`,
        WITH_ROW_INSERT_LINE_INACTIVE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-row-insert-line__inactive`,
        WITH_LAST_ROW_INSERT_LINE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-last-row-insert-line`,
        WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, (0, parcelRequire("9UDEr")).tablePrefixSelector)}-last-row-insert-line__inactive`
    };
    var $0a07d562442d8442$export$ce63d9b315ac58c9;
    (function(ShadowEvent) {
        ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
        ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    })($0a07d562442d8442$export$ce63d9b315ac58c9 || ($0a07d562442d8442$export$ce63d9b315ac58c9 = {}));
});
parcelRegister("eTjGD", function(module, exports) {
    $parcel$export(module.exports, "tableMarginFullWidthMode", ()=>(parcelRequire("1v4Xe")).tableMarginFullWidthMode);
    var $1v4Xe;
});
parcelRegister("1v4Xe", function(module, exports) {
    $parcel$export(module.exports, "tableCellBackgroundColor", ()=>$25c191bb2717b458$export$3efa753685336605);
    $parcel$export(module.exports, "tableHeaderCellBackgroundColor", ()=>$25c191bb2717b458$export$95883e661e73a1d1);
    $parcel$export(module.exports, "tableTextColor", ()=>$25c191bb2717b458$export$14da8da34a807702);
    $parcel$export(module.exports, "tableBorderColor", ()=>$25c191bb2717b458$export$60473ec4f7c2b794);
    $parcel$export(module.exports, "tableCellSelectedColor", ()=>$25c191bb2717b458$export$f26d047169b4195d);
    $parcel$export(module.exports, "tableToolbarSelectedColor", ()=>$25c191bb2717b458$export$8c5dd0fc35774ae1);
    $parcel$export(module.exports, "tableBorderSelectedColor", ()=>$25c191bb2717b458$export$9bf0891aaaf2fecb);
    $parcel$export(module.exports, "tableCellSelectedDeleteIconColor", ()=>$25c191bb2717b458$export$a699493d7d7580c3);
    $parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", ()=>$25c191bb2717b458$export$cd5e5900c9fa42dc);
    $parcel$export(module.exports, "tableCellDeleteColor", ()=>$25c191bb2717b458$export$3c2a828febe9d506);
    $parcel$export(module.exports, "tableBorderDeleteColor", ()=>$25c191bb2717b458$export$870d72a5700e711d);
    $parcel$export(module.exports, "tableToolbarDeleteColor", ()=>$25c191bb2717b458$export$e7bba7ffd7bf3c50);
    $parcel$export(module.exports, "tableCellHoverDeleteIconColor", ()=>$25c191bb2717b458$export$6cc2aa96833a5989);
    $parcel$export(module.exports, "tableCellHoverDeleteIconBackground", ()=>$25c191bb2717b458$export$9907ca2ad437ddcc);
    $parcel$export(module.exports, "tableBorderRadiusSize", ()=>$25c191bb2717b458$export$371da7842ff35a5b);
    $parcel$export(module.exports, "tablePadding", ()=>$25c191bb2717b458$export$e5ff276883773ffd);
    $parcel$export(module.exports, "tableScrollbarOffset", ()=>$25c191bb2717b458$export$92421f8864c287b1);
    $parcel$export(module.exports, "tableMarginFullWidthMode", ()=>$25c191bb2717b458$export$cbcfa4314b903419);
    $parcel$export(module.exports, "tableInsertColumnButtonSize", ()=>$25c191bb2717b458$export$6d23b13c5fcb846c);
    $parcel$export(module.exports, "tableDeleteButtonSize", ()=>$25c191bb2717b458$export$cb376ed67c7ae37e);
    $parcel$export(module.exports, "tableDeleteButtonOffset", ()=>$25c191bb2717b458$export$52b432855099b8bd);
    $parcel$export(module.exports, "tableToolbarSize", ()=>$25c191bb2717b458$export$a4d60e31f4f6188b);
    $parcel$export(module.exports, "tableControlsSpacing", ()=>$25c191bb2717b458$export$880976487022eb5);
    $parcel$export(module.exports, "tableInsertColumnButtonOffset", ()=>$25c191bb2717b458$export$73b1242ebdcc73be);
    $parcel$export(module.exports, "lineMarkerSize", ()=>$25c191bb2717b458$export$a3e71c692f2c2213);
    $parcel$export(module.exports, "columnControlsDecorationHeight", ()=>$25c191bb2717b458$export$62374dd2f63076b0);
    $parcel$export(module.exports, "columnControlsZIndex", ()=>$25c191bb2717b458$export$da0ccd381b1a80f);
    $parcel$export(module.exports, "columnControlsSelectedZIndex", ()=>$25c191bb2717b458$export$83da30a15600a83e);
    $parcel$export(module.exports, "rowControlsZIndex", ()=>$25c191bb2717b458$export$45aeeddcedd441ab);
    $parcel$export(module.exports, "insertLineWidth", ()=>$25c191bb2717b458$export$cc7ed656b7dcf729);
    $parcel$export(module.exports, "resizeHandlerAreaWidth", ()=>$25c191bb2717b458$export$72409f838e9c33c7);
    $parcel$export(module.exports, "resizeLineWidth", ()=>$25c191bb2717b458$export$45d9825f76985b4e);
    $parcel$export(module.exports, "resizeHandlerZIndex", ()=>$25c191bb2717b458$export$887c1388be90c08e);
    $parcel$export(module.exports, "contextualMenuTriggerSize", ()=>$25c191bb2717b458$export$3969371f057ce1e5);
    $parcel$export(module.exports, "contextualMenuDropdownWidth", ()=>$25c191bb2717b458$export$a6ed027d1a83416d);
    $parcel$export(module.exports, "contextualMenuDropdownWidthDnD", ()=>$25c191bb2717b458$export$42d9040c5091b076);
    $parcel$export(module.exports, "stickyRowZIndex", ()=>$25c191bb2717b458$export$1279af870a198fea);
    $parcel$export(module.exports, "stickyRowOffsetTop", ()=>$25c191bb2717b458$export$83c60dd0aac17107);
    $parcel$export(module.exports, "stickyHeaderBorderBottomWidth", ()=>$25c191bb2717b458$export$13b0e72269a9a3aa);
    $parcel$export(module.exports, "tableOverflowShadowWidth", ()=>$25c191bb2717b458$export$40311377f05dbfc4);
    $parcel$export(module.exports, "tableOverflowShadowWidthWide", ()=>$25c191bb2717b458$export$1680d391e1ce7b96);
    $parcel$export(module.exports, "tablePopupMenuFitHeight", ()=>$25c191bb2717b458$export$3cdde837cf189e96);
    $parcel$export(module.exports, "dropTargetsZIndex", ()=>$25c191bb2717b458$export$b2015400488f9243);
    $parcel$export(module.exports, "TABLE_SNAP_GAP", ()=>$25c191bb2717b458$export$8f6133b6e2b4291);
    $parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", ()=>$25c191bb2717b458$export$edb1b9caf8ff5b32);
    $parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", ()=>$25c191bb2717b458$export$7af5c65e392a647);
    $parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", ()=>$25c191bb2717b458$export$858d012f03ae70a5);
    $parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", ()=>$25c191bb2717b458$export$a13bd817a2eda041);
    $parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", ()=>$25c191bb2717b458$export$e0140c2b978caac5);
    $parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", ()=>$25c191bb2717b458$export$c6a9e7014cf7aedc);
    $parcel$export(module.exports, "dragMenuDropdownWidth", ()=>$25c191bb2717b458$export$963fb187132ee7cf);
    $parcel$export(module.exports, "dragTableInsertColumnButtonSize", ()=>$25c191bb2717b458$export$d18320cc8ee69115);
    $parcel$export(module.exports, "dropTargetExtendedWidth", ()=>$25c191bb2717b458$export$6bec1f8a2aa82be8);
    $parcel$export(module.exports, "colorPalletteColumns", ()=>$25c191bb2717b458$export$2c18704a8d793cdb);
    var $6gEe5;
    var $iHYdz;
    var $eUhGn;
    const $25c191bb2717b458$export$3efa753685336605 = `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $25c191bb2717b458$export$95883e661e73a1d1 = `var(--ds-background-accent-gray-subtlest, ${(0, (0, parcelRequire("iHYdz")).akEditorTableHeaderCellBackground)})`;
    const $25c191bb2717b458$export$1b578d7ab4fc0385 = `var(--ds-background-neutral-subtle, ${(0, (0, parcelRequire("iHYdz")).akEditorTableToolbar)})`;
    const $25c191bb2717b458$export$14da8da34a807702 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`;
    const $25c191bb2717b458$export$60473ec4f7c2b794 = `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`;
    const $25c191bb2717b458$export$5aac4cb73ae3f2da = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $25c191bb2717b458$export$f26d047169b4195d = `var(--ds-blanket-selected, ${(0, (0, parcelRequire("iHYdz")).akEditorTableCellBlanketSelected)})`;
    const $25c191bb2717b458$export$8c5dd0fc35774ae1 = `var(--ds-background-selected-pressed, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`;
    const $25c191bb2717b458$export$9bf0891aaaf2fecb = `var(--ds-border-focused, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorderSelected)})`;
    const $25c191bb2717b458$export$a699493d7d7580c3 = `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`;
    const $25c191bb2717b458$export$cd5e5900c9fa42dc = `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`;
    const $25c191bb2717b458$export$3c2a828febe9d506 = `var(--ds-blanket-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorTableCellBlanketDeleted)})`;
    const $25c191bb2717b458$export$870d72a5700e711d = `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`;
    const $25c191bb2717b458$export$e7bba7ffd7bf3c50 = `var(--ds-background-danger-pressed, ${(0, $829f609a65d26a98$export$b34b069eff244586)})`;
    const $25c191bb2717b458$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, white)";
    const $25c191bb2717b458$export$9907ca2ad437ddcc = `var(--ds-background-danger-bold, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`;
    const $25c191bb2717b458$export$371da7842ff35a5b = 3;
    const $25c191bb2717b458$export$e5ff276883773ffd = 8;
    const $25c191bb2717b458$export$92421f8864c287b1 = 15;
    const $25c191bb2717b458$export$cbcfa4314b903419 = 2;
    const $25c191bb2717b458$export$6d23b13c5fcb846c = 20;
    const $25c191bb2717b458$export$cb376ed67c7ae37e = 16;
    const $25c191bb2717b458$export$52b432855099b8bd = 6;
    const $25c191bb2717b458$export$a4d60e31f4f6188b = (0, (0, parcelRequire("iHYdz")).akEditorTableToolbarSize);
    const $25c191bb2717b458$export$880976487022eb5 = (0, (0, parcelRequire("6gEe5")).tableMarginTop) + $25c191bb2717b458$export$e5ff276883773ffd - (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth);
    const $25c191bb2717b458$export$73b1242ebdcc73be = 3;
    const $25c191bb2717b458$export$86dfc955b6099b88 = 32;
    const $25c191bb2717b458$export$893fc0cfd2a0c40e = 13;
    const $25c191bb2717b458$export$a3e71c692f2c2213 = 4;
    const $25c191bb2717b458$export$62374dd2f63076b0 = 25;
    const $25c191bb2717b458$export$da0ccd381b1a80f = (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 10;
    const $25c191bb2717b458$export$83da30a15600a83e = $25c191bb2717b458$export$da0ccd381b1a80f + 1;
    const $25c191bb2717b458$export$45aeeddcedd441ab = (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 10;
    const $25c191bb2717b458$export$5b53cc051bf05434 = $25c191bb2717b458$export$83da30a15600a83e + 1;
    const $25c191bb2717b458$export$cc7ed656b7dcf729 = 3;
    const $25c191bb2717b458$export$72409f838e9c33c7 = (0, (0, parcelRequire("eUhGn")).RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
    const $25c191bb2717b458$export$45d9825f76985b4e = 2;
    const $25c191bb2717b458$export$887c1388be90c08e = $25c191bb2717b458$export$da0ccd381b1a80f + (0, (0, parcelRequire("iHYdz")).akRichMediaResizeZIndex);
    const $25c191bb2717b458$export$3969371f057ce1e5 = 16;
    const $25c191bb2717b458$export$a6ed027d1a83416d = 180;
    const $25c191bb2717b458$export$42d9040c5091b076 = 250;
    const $25c191bb2717b458$export$1279af870a198fea = $25c191bb2717b458$export$887c1388be90c08e + 2;
    const $25c191bb2717b458$export$83c60dd0aac17107 = 8;
    const $25c191bb2717b458$export$13b0e72269a9a3aa = 1;
    const $25c191bb2717b458$export$40311377f05dbfc4 = 8;
    const $25c191bb2717b458$export$1680d391e1ce7b96 = 32;
    const $25c191bb2717b458$export$3cdde837cf189e96 = 188;
    const $25c191bb2717b458$export$b2015400488f9243 = 14;
    const $25c191bb2717b458$export$8f6133b6e2b4291 = 9;
    const $25c191bb2717b458$export$edb1b9caf8ff5b32 = 10;
    const $25c191bb2717b458$export$7af5c65e392a647 = 2;
    const $25c191bb2717b458$export$11cf30061861ec4a = 5;
    const $25c191bb2717b458$export$858d012f03ae70a5 = -68;
    const $25c191bb2717b458$export$a13bd817a2eda041 = 92;
    const $25c191bb2717b458$export$e0140c2b978caac5 = 4;
    const $25c191bb2717b458$export$c6a9e7014cf7aedc = 6;
    const $25c191bb2717b458$export$963fb187132ee7cf = 250;
    const $25c191bb2717b458$export$d18320cc8ee69115 = 16;
    const $25c191bb2717b458$export$6bec1f8a2aa82be8 = 150;
    const $25c191bb2717b458$export$2c18704a8d793cdb = 7;
    const $25c191bb2717b458$export$150cd2564fec30b7 = 8;
});
parcelRegister("6UEu0", function(module, exports) {
    $parcel$export(module.exports, "mediaStyles", ()=>$0d5dc640686a6518$export$abd2efc27ac7e809);
    var $f8Sb3;
    var $9R9Rb;
    var $ceYEW;
    var $iHYdz;
    var $79PaE;
    var $VSDnB;
    const $0d5dc640686a6518$export$abd2efc27ac7e809 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_element_dnd_nested_fix_patch_3') ? (0, (0, parcelRequire("ceYEW")).mediaSingleSharedStyleNew) : (0, (0, parcelRequire("ceYEW")).mediaSingleSharedStyle), " & [layout='full-width'] .", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ",& [layout='wide'] .", (0, (0, parcelRequire("ceYEW")).richMediaClassName), "{margin-left:50%;transform:translateX(-50%);}.media-extended-resize-experience[layout^='wrap-']{overflow:visible!important;}& [layout^='wrap-']+[layout^='wrap-']{clear:none;&+p,&+div[class^='fabric-editor-align'],&+ul,&+ol,&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{clear:both!important;}& .", (0, (0, parcelRequire("ceYEW")).richMediaClassName), "{margin-left:0;margin-right:0;}}", (0, (0, parcelRequire("9R9Rb")).mediaInlineImageStyles), " .mediaSingleView-content-wrap[layout^='wrap-']{max-width:100%;clear:inherit;}.mediaSingleView-content-wrap[layout='wrap-left']{float:left;}.mediaSingleView-content-wrap[layout='wrap-right']{float:right;}.mediaSingleView-content-wrap[layout='wrap-right']+.mediaSingleView-content-wrap[layout='wrap-left']{clear:both;}&>.mediaSingleView-content-wrap{.richMedia-resize-handle-right{margin-right:-", (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPaddingWide), "px;}.richMedia-resize-handle-left{margin-left:-", (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPaddingWide), "px;}}}.richMedia-resize-handle-right,.richMedia-resize-handle-left{display:flex;flex-direction:column;justify-content:center;}.richMedia-resize-handle-right{align-items:flex-end;padding-right:var(--ds-space-150, 12px);margin-right:-", (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-left{align-items:flex-start;padding-left:var(--ds-space-150, 12px);margin-left:-", (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPadding), "px;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{content:' ';display:flex;width:3px;height:64px;border-radius:6px;}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ":hover .richMedia-resize-handle-left::after,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ":hover .richMedia-resize-handle-right::after{background:var(--ds-border, #091E4224);}.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .richMedia-resize-handle-right::after,.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .richMedia-resize-handle-left::after,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .richMedia-resize-handle-right:hover::after,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .richMedia-resize-handle-left:hover::after,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".is-resizing .richMedia-resize-handle-right::after,.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), ".is-resizing .richMedia-resize-handle-left::after{background:var(--ds-border-focused, #388BFF);}.__resizable_base__{left:unset!important;width:auto!important;height:auto!important;}.danger>div>div>.media-card-frame,.danger>span>a{background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, ";box-shadow:0px 0px 0px ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderBoldSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";transition:background-color 0s,box-shadow 0s;}.danger{.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, (0, parcelRequire("79PaE")).inlinePlayerClassName), "::after{border:1px solid ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, "!important;}.richMedia-resize-handle-right::after,.richMedia-resize-handle-left::after{background:", `var(--ds-icon-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, "!important;}.resizer-handle-thumb{background:", `var(--ds-icon-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, "!important;}div div .media-card-frame,.inlineCardView-content-wrap>span>a{background-color:var(--ds-blanket-danger, rgb(255, 189, 173, 0.5));transition:background-color 0s;}div div .media-card-frame::after{box-shadow:none;}}.warning{.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, $025bde419ff72534$export$7a6526d4be3b7eb3), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, (0, parcelRequire("79PaE")).inlinePlayerClassName), "::after{border:1px solid var(--ds-border-warning, #E56910);}.", (0, (0, parcelRequire("ceYEW")).richMediaClassName), " .", (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3), "{box-shadow:0 0 0 1px var(--ds-border-warning, #E56910)!important;}.resizer-handle-thumb{background:var(--ds-icon-warning, #E56910)!important;}}.media-filmstrip-list-item{cursor:pointer;}.mediaGroupView-content-wrap.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " #newFileExperienceWrapper{box-shadow:", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBoxShadow), ";}");
});
parcelRegister("79PaE", function(module, exports) {
    $parcel$export(module.exports, "inlinePlayerClassName", ()=>$c63e9575ac7419ed$export$70bc5d30fe886af);
    $parcel$export(module.exports, "inlinePlayerWrapperStyles", ()=>$c63e9575ac7419ed$export$bffd1a8ecf8d5d06);
    var $f8Sb3;
    var $k5uoT;
    var $lv9SR;
    var $5yojI;
    var $bzmFE;
    const $c63e9575ac7419ed$var$getSelectedBorderStyle = ({ selected: selected })=>`
    ${0, (0, parcelRequire("5yojI")).hideNativeBrowserTextSelectionStyles}

    &::after {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      box-sizing: border-box;
      pointer-events: none;
      ${0, (0, parcelRequire("k5uoT")).borderRadius}
      ${selected ? (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border
        ]) : ''}
    }
  `;
    const $c63e9575ac7419ed$export$70bc5d30fe886af = 'media-card-inline-player';
    const $c63e9575ac7419ed$export$bffd1a8ecf8d5d06 = ({ dimensions: dimensions, selected: selected })=>(0, (0, parcelRequire("f8Sb3")).css)("width:", (0, (0, parcelRequire("lv9SR")).getDimensionsWithDefault)(dimensions).width || '100%', ";height:", (0, (0, parcelRequire("lv9SR")).getDimensionsWithDefault)(dimensions).height || 'auto', ";overflow:hidden;border-radius:", (0, (0, parcelRequire("k5uoT")).borderRadius)(), "px;position:relative;max-width:100%;max-height:100%;", $c63e9575ac7419ed$var$getSelectedBorderStyle(selected), " video{width:100%;height:100%;}");
    $c63e9575ac7419ed$export$bffd1a8ecf8d5d06.displayName = 'InlinePlayerWrapper';
});
parcelRegister("lv9SR", function(module, exports) {
    $parcel$export(module.exports, "getDimensionsWithDefault", ()=>$d8ce749d15267dc5$export$36acad525b1fb57b);
    const $d8ce749d15267dc5$export$36acad525b1fb57b = (dimensions = {
        width: '100%',
        height: '100%'
    })=>{
        return {
            height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
            width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
        };
    };
});
const $6d9332e5e7a86517$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';
parcelRegister("b3RpZ", function(module, exports) {
    $parcel$export(module.exports, "panelStyles", ()=>$baaf4c6520958d3a$export$8290cf129669d0cb);
    var $f8Sb3;
    var $aABH4;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $gmhCD = parcelRequire("gmhCD");
    const $baaf4c6520958d3a$export$8290cf129669d0cb = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", (0, (0, parcelRequire("aABH4")).panelSharedStyles)(), ";.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).prefix, "{cursor:pointer;&.danger{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", (0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder), ";background-color:", `var(--ds-background-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackground)})`, "!important;.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, "!important;}}}.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).content, "{cursor:text;}.danger .", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).prefix, "{&[data-panel-type]{background-color:", `var(--ds-blanket-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackgroundWithOpacity)})`, ";.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).icon, "{color:", `var(--ds-icon-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteIconColor)})`, ";}}}}.", (0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).prefix, ".", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ":not(.danger){", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";}", (0, $gmhCD.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area.appearance-full-page .ProseMirror {
		.ak-editor-panel .${(0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
		}

		.ak-editor-panel.${(0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).noIcon} {
			padding-left: ${"var(--ds-space-250, 20px)"};
			padding-right: ${"var(--ds-space-250, 20px)"};
		}
	}`, ";", (0, $gmhCD.editorExperiment)('nested-dnd', true) && `.ak-editor-content-area .ak-editor-content-area .ProseMirror {
		.ak-editor-panel .${(0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).icon} {
			padding-right: ${"var(--ds-space-100, 8px)"};
		}
		.ak-editor-panel.${(0, (0, parcelRequire("aABH4")).PanelSharedCssClassName).noIcon} {
			padding-right: ${"var(--ds-space-150, 12px)"};
			padding-left: ${"var(--ds-space-150, 12px)"};
		}
	}`, ";");
});
parcelRegister("aUTD3", function(module, exports) {
    $parcel$export(module.exports, "statusStyles", ()=>$2df8a0e92b077e8e$export$79c8c9ad308bbe07);
    var $f8Sb3;
    var $kZxLT;
    var $6gEe5;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $2df8a0e92b077e8e$export$79c8c9ad308bbe07 = (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CELL_WRAPPER, ",.", (0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_HEADER_CELL_WRAPPER, ",[data-layout-section]{.", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_CONTAINER, "{max-width:100%;line-height:0;>span{width:100%;}}}.", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_CONTAINER, "{>span{cursor:pointer;line-height:0;}&.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_LOZENGE, ">span{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow
    ]), ";}}.danger{.", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_LOZENGE, ">span{background-color:", (0, (0, parcelRequire("iHYdz")).akEditorDeleteBackgroundWithOpacity), ";}.", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_CONTAINER, ".", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), " .", (0, (0, parcelRequire("kZxLT")).StatusSharedCssClassName).STATUS_LOZENGE, ">span{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", (0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder), ";}}");
});
parcelRegister("kZxLT", function(module, exports) {
    $parcel$export(module.exports, "StatusSharedCssClassName", ()=>$1b48498df0149da7$export$b18e58a1c082b710);
    const $1b48498df0149da7$export$b18e58a1c082b710 = {
        STATUS_CONTAINER: 'statusView-content-wrap',
        STATUS_LOZENGE: 'status-lozenge-span'
    };
});
parcelRegister("5L329", function(module, exports) {
    $parcel$export(module.exports, "taskDecisionStyles", ()=>$f9553b9bb33991d4$export$6083a263609cde43);
    var $f8Sb3;
    var $1bQ0V;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    const $f9553b9bb33991d4$export$6083a263609cde43 = (0, (0, parcelRequire("f8Sb3")).css)("[data-decision-wrapper]{cursor:pointer;}.", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">[data-decision-wrapper],ol[data-node-type='decisionList'].", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), "{border-radius:4px;", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).BoxShadow,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
    ]), ";}.danger{.", (0, (0, parcelRequire("1bQ0V")).TaskDecisionSharedCssClassName).DECISION_CONTAINER, ".", (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName), ">div{box-shadow:0 0 0 ", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px ", `var(--ds-border-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBorder)})`, ";background-color:", `var(--ds-blanket-danger, ${(0, (0, parcelRequire("iHYdz")).akEditorDeleteBackgroundWithOpacity)})`, ";&::after{content:none;}}}");
});
parcelRegister("iK9VQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fee089fbaad1c4b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ajpes = parcelRequire("ajpes");
    var $gkwXh;
    var $VSDnB;
    var $26r0I;
    var $bLuIS;
    var $65Q6Y;
    function $fee089fbaad1c4b9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fee089fbaad1c4b9$var$pluginsComponentsWrapper = {
        name: "zjik7",
        styles: "display:flex"
    };
    class $fee089fbaad1c4b9$var$PluginSlotLegacy extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = 'PluginSlot';
        }
        shouldComponentUpdate(nextProps) {
            const { editorView: editorView, editorActions: editorActions, items: items, providerFactory: providerFactory, eventDispatcher: eventDispatcher, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, wrapperElement: wrapperElement } = this.props;
            return !(nextProps.editorView === editorView && nextProps.editorActions === editorActions && nextProps.items === items && nextProps.providerFactory === providerFactory && nextProps.eventDispatcher === eventDispatcher && nextProps.popupsMountPoint === popupsMountPoint && nextProps.popupsBoundariesElement === popupsBoundariesElement && nextProps.popupsScrollableElement === popupsScrollableElement && nextProps.containerElement === containerElement && nextProps.disabled === disabled && nextProps.wrapperElement === wrapperElement);
        }
        componentDidMount() {
            this.addModeChangeListener(this.props.contentArea);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.props.contentArea !== nextProps.contentArea) {
                this.removeModeChangeListener(this.props.contentArea);
                this.addModeChangeListener(nextProps.contentArea);
            }
        }
        componentWillUnmount() {
            this.removeModeChangeListener(this.props.contentArea);
        }
        render() {
            const { items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks } = this.props;
            if (!items && !pluginHooks || !editorView) return null;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bLuIS")).ErrorBoundary), {
                component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).PLUGIN_SLOT,
                fallbackComponent: null
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("65Q6Y")).MountPluginHooks), {
                editorView: editorView,
                pluginHooks: pluginHooks,
                containerElement: containerElement
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $fee089fbaad1c4b9$var$pluginsComponentsWrapper
            }, items?.map((component, key)=>{
                const props = {
                    key: key
                };
                const element = component({
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    appearance: appearance,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    containerElement: containerElement,
                    disabled: disabled,
                    wrapperElement: wrapperElement
                });
                return element && (0, ($parcel$interopDefault($5uXOq))).cloneElement(element, props);
            })));
        }
        constructor(...args){
            super(...args), this.transitionEvent = (0, (0, parcelRequire("26r0I")).whichTransitionEvent)(), this.forceComponentUpdate = (event)=>{
                if (event.propertyName.includes('width')) this.forceUpdate();
            }, this.removeModeChangeListener = (contentArea)=>{
                if (contentArea && this.transitionEvent) contentArea.removeEventListener(this.transitionEvent, this.forceComponentUpdate);
            }, this.addModeChangeListener = (contentArea)=>{
                if (contentArea && this.transitionEvent) contentArea.addEventListener(this.transitionEvent, this.forceComponentUpdate);
            };
        }
    }
    const $fee089fbaad1c4b9$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
        if (!items && !pluginHooks || !editorView) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bLuIS")).ErrorBoundary), {
            component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).PLUGIN_SLOT,
            fallbackComponent: null
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("65Q6Y")).MountPluginHooks), {
            editorView: editorView,
            pluginHooks: pluginHooks,
            containerElement: containerElement
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $fee089fbaad1c4b9$var$pluginsComponentsWrapper
        }, items?.map((component, key)=>{
            const props = {
                key: key
            };
            const element = component({
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                appearance: appearance,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: containerElement,
                disabled: disabled,
                wrapperElement: wrapperElement
            });
            return element && (0, ($parcel$interopDefault($5uXOq))).cloneElement(element, props);
        })));
    };
    const $fee089fbaad1c4b9$var$PluginSlotNew = (0, ($parcel$interopDefault($5uXOq))).memo($fee089fbaad1c4b9$var$PluginSlot, (0, ($parcel$interopDefault($ajpes))));
    $fee089fbaad1c4b9$var$PluginSlotNew.displayName = 'PluginSlot';
    function $fee089fbaad1c4b9$export$2e2bcd8739ae039({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks, contentArea: contentArea }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react_18_plugin_slot')) return (0, (0, parcelRequire("f8Sb3")).jsx)($fee089fbaad1c4b9$var$PluginSlotNew, {
            items: items,
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            wrapperElement: wrapperElement,
            pluginHooks: pluginHooks
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($fee089fbaad1c4b9$var$PluginSlotLegacy, {
            contentArea: contentArea,
            items: items,
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            appearance: appearance,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            containerElement: containerElement,
            disabled: disabled,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            wrapperElement: wrapperElement,
            pluginHooks: pluginHooks
        });
    }
});
parcelRegister("26r0I", function(module, exports) {
    $parcel$export(module.exports, "whichTransitionEvent", ()=>$6f2f8746314e7bdd$export$bd36fba2d672470e);
    var $az5cZ;
    var $5cNeT;
    function $6f2f8746314e7bdd$export$bd36fba2d672470e() {
        const el = document.createElement('fakeelement');
        const transitions = {
            transition: 'transitionend',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd',
            WebkitTransition: 'webkitTransitionEnd'
        };
        for(const t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        return;
    }
});
parcelRegister("az5cZ", function(module, exports) {
    $parcel$export(module.exports, "getNodesCount", ()=>$73bdd5ff554f00ca$export$3674f49b2d541ad);
    function $73bdd5ff554f00ca$export$3674f49b2d541ad(node) {
        let count = {};
        node.nodesBetween(0, node.nodeSize - 2, (node)=>{
            count[node.type.name] = (count[node.type.name] || 0) + 1;
        });
        return count;
    }
});
parcelRegister("5cNeT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b6d404d928de370$export$2e2bcd8739ae039);
    var $7b6d404d928de370$export$2e2bcd8739ae039 = {
        EDITOR_MOUNTED: 'Editor Component Mount Time',
        PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
        PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
        ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
    };
});
parcelRegister("bLuIS", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$d3f657eabcbe16a5$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $1KzE6;
    class $d3f657eabcbe16a5$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        hasFallback() {
            return typeof this.props.fallbackComponent !== 'undefined';
        }
        shouldRecover() {
            return this.hasFallback() && this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).EDITOR_CRASHED,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: error,
                    errorInfo: errorInfo,
                    errorRethrown: !this.hasFallback()
                }
            });
            (0, (0, parcelRequire("1KzE6")).logException)(error, {
                location: 'editor-core/ui'
            });
            if (this.hasFallback()) this.setState({
                errorCaptured: true
            });
        }
        render() {
            if (this.shouldRecover()) return this.props.fallbackComponent;
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                errorCaptured: false
            };
        }
    }
});
parcelRegister("65Q6Y", function(module, exports) {
    $parcel$export(module.exports, "MountPluginHooks", ()=>$4428e2244acd6367$export$a9224552b63e3fe8);
    var $5uXOq = parcelRequire("5uXOq");
    function $4428e2244acd6367$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement }) {
        usePluginHook({
            editorView: editorView,
            containerElement: containerElement
        });
        return null;
    }
    function $4428e2244acd6367$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement }) {
        if (!editorView) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, pluginHooks?.map((usePluginHook, key)=>(0, ($parcel$interopDefault($5uXOq))).createElement($4428e2244acd6367$var$MountPluginHook, {
                key: key,
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement
            })));
    }
});
parcelRegister("7s5ol", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a92b9f53390f6f70$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    const $a92b9f53390f6f70$var$pulseBackground = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '50%': {
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
        }
    });
    const $a92b9f53390f6f70$var$pulseBackgroundReverse = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%': {
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
        },
        '50%': {
            backgroundColor: 'auto'
        },
        '100%': {
            backgroundColor: "var(--ds-blanket-danger, #EF5C4814)"
        }
    });
    const $a92b9f53390f6f70$var$flashWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        '&.-flash > div': {
            animation: `0.25s ease-in-out ${$a92b9f53390f6f70$var$pulseBackgroundReverse}`
        },
        '& > div': {
            animation: "'none'"
        }
    });
    const $a92b9f53390f6f70$var$flashWrapperAnimated = (0, (0, parcelRequire("f8Sb3")).css)({
        [`${$a92b9f53390f6f70$var$flashWrapper} & > div`]: {
            animation: `0.25s ease-in-out ${$a92b9f53390f6f70$var$pulseBackground}`
        }
    });
    class $a92b9f53390f6f70$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const { animate: animate, children: children } = this.props;
            this.toggle = animate && !this.toggle;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: animate ? $a92b9f53390f6f70$var$flashWrapperAnimated : $a92b9f53390f6f70$var$flashWrapper,
                className: this.toggle ? '-flash' : ''
            }, children));
        }
        constructor(...args){
            super(...args), this.toggle = false;
        }
    }
});
parcelRegister("9YhuC", function(module, exports) {
    $parcel$export(module.exports, "CommentEditorWithIntl", ()=>$1f6a75b9646aed6f$export$7b9f3a51cd0c1967);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9ci4W = parcelRequire("9ci4W");
    var $koVbs;
    var $ldJSL;
    var $eCeGD;
    var $awTmI;
    var $bYYy3;
    var $4ceoy;
    var $kdDpx;
    parcelRequire("7uhma");
    var $cipm3;
    var $iHYdz;
    var $3hehr;
    var $cex0T;
    var $jZLtJ;
    var $iK9VQ;
    var $5093p;
    var $7s5ol;
    var $fBLMg;
    const $1f6a75b9646aed6f$var$CommentEditorMargin = 14;
    const $1f6a75b9646aed6f$var$commentEditorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        '.less-margin .ProseMirror': {
            margin: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
        },
        minWidth: '272px',
        height: 'auto',
        backgroundColor: "var(--ds-background-input, white)",
        border: `1px solid ${"var(--ds-border-input, #8590A2)"}`,
        boxSizing: 'border-box',
        borderRadius: "var(--ds-border-radius, 3px)",
        maxWidth: 'inherit',
        wordWrap: 'break-word'
    });
    const $1f6a75b9646aed6f$var$ContentArea = (0, (0, parcelRequire("jZLtJ")).createEditorContentStyle)((0, (0, parcelRequire("f8Sb3")).css)({
        flexGrow: 1,
        overflowX: 'clip',
        lineHeight: '24px',
        '.ProseMirror': {
            margin: "var(--ds-space-150, 12px)"
        },
        '.gridParent': {
            marginLeft: "var(--ds-space-025, 2px)",
            marginRight: "var(--ds-space-025, 2px)",
            width: `calc(100% + ${$1f6a75b9646aed6f$var$CommentEditorMargin - (0, (0, parcelRequire("bYYy3")).GRID_GUTTER)}px)`
        },
        padding: "var(--ds-space-250, 20px)"
    }, (0, (0, parcelRequire("cipm3")).tableCommentEditorStyles)));
    $1f6a75b9646aed6f$var$ContentArea.displayName = 'ContentArea';
    const $1f6a75b9646aed6f$var$secondaryToolbarStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxSizing: 'border-box',
        justifyContent: 'flex-end',
        alignItems: 'center',
        display: 'flex',
        padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-025, 2px)"}`
    });
    const $1f6a75b9646aed6f$var$appearance = 'comment';
    const $1f6a75b9646aed6f$export$7b9f3a51cd0c1967 = (props)=>{
        const { editorAPI: editorAPI } = props;
        const { mediaState: mediaState, maxContentSizeState: maxContentSizeState, primaryToolbarState: primaryToolbarState, editorViewModeState: editorViewModeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(editorAPI, [
            'media',
            'maxContentSize',
            'primaryToolbar',
            'editorViewMode'
        ]);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef } = props;
        const maxContentSizeReached = Boolean(maxContentSizeState?.maxContentSizeReached);
        const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
        const containerElement = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const wrapperElementRef = (0, $5uXOq.useMemo)(()=>innerRef || (0, ($parcel$interopDefault($5uXOq))).createRef(), [
            innerRef
        ]);
        const [saveButtonDisabled, setSaveButtonDisabled] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
            return ()=>mediaState?.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
        }, [
            mediaState
        ]);
        const handleSave = (0, $5uXOq.useCallback)(()=>{
            if (editorView && onSave) onSave(editorView);
        }, [
            editorView,
            onSave
        ]);
        const handleCancel = (0, $5uXOq.useCallback)(()=>{
            if (editorView && onCancel) onCancel(editorView);
        }, [
            editorView,
            onCancel
        ]);
        const isShortcutToFocusToolbar = (0, $5uXOq.useCallback)((event)=>{
            return event.altKey && (event.key === 'F9' || event.keyCode === 120);
        }, []);
        const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
        const handleEscape = (0, $5uXOq.useCallback)((event)=>{
            if (!editorView?.hasFocus()) editorView?.focus();
            event.preventDefault();
            event.stopPropagation();
        }, [
            editorView
        ]);
        let primaryToolbarComponents = primaryToolbarComponentsProp;
        if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7s5ol")).default), {
            animate: maxContentSizeReached
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1f6a75b9646aed6f$var$commentEditorStyles,
                (0, (0, parcelRequire("f8Sb3")).css)({
                    minHeight: `${minHeight}px`
                })
            ],
            className: "akEditor",
            ref: wrapperElementRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fBLMg")).MainToolbar), {
            useStickyToolbar: useStickyToolbar,
            twoLineEditorToolbar: isTwoLineToolbarEnabled
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kdDpx")).ToolbarArrowKeyNavigationProvider), {
            editorView: editorView,
            childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            editorAppearance: $1f6a75b9646aed6f$var$appearance,
            useStickyToolbar: useStickyToolbar,
            intl: intl
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5093p")).ToolbarWithSizeDetector), {
            editorView: editorView,
            editorActions: editorActions,
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            appearance: $1f6a75b9646aed6f$var$appearance,
            items: primaryToolbarComponents,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: !!disabled,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            containerElement: containerElement.current,
            twoLineEditorToolbar: isTwoLineToolbarEnabled
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("fBLMg")).mainToolbarCustomComponentsSlotStyle)(isTwoLineToolbarEnabled)
        }, customPrimaryToolbarComponents))), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cex0T")).default), {
            editorView: editorView,
            editorDisabled: disabled
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4ceoy")).WidthConsumer), null, ({ width: width })=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)($1f6a75b9646aed6f$var$ContentArea, {
                ref: containerElement,
                css: maxHeight ? (0, (0, parcelRequire("f8Sb3")).css)({
                    maxHeight: `${maxHeight}px`,
                    overflowY: 'auto'
                }) : null,
                className: (0, ($parcel$interopDefault($9ci4W)))('ak-editor-content-area', {
                    'less-margin': width < (0, (0, parcelRequire("iHYdz")).akEditorMobileBreakoutPoint)
                }),
                featureFlags: featureFlags,
                viewMode: editorViewModeState?.mode
            }, customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iK9VQ")).default), {
                editorView: editorView,
                editorActions: editorActions,
                eventDispatcher: eventDispatcher,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                providerFactory: providerFactory,
                appearance: $1f6a75b9646aed6f$var$appearance,
                items: contentComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                containerElement: containerElement.current,
                disabled: !!disabled,
                wrapperElement: wrapperElementRef.current,
                pluginHooks: pluginHooks
            }), editorDOMElement, customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null);
        }))), showSecondaryToolbar && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1f6a75b9646aed6f$var$secondaryToolbarStyles,
            "data-testid": "ak-editor-secondary-toolbar"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldJSL")).default), null, !!onSave && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "primary",
            onClick: handleSave,
            testId: "comment-save-button",
            isDisabled: disabled || saveButtonDisabled
        }, intl.formatMessage((0, (0, parcelRequire("3hehr")).default).saveButton)), !!onCancel && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: handleCancel,
            isDisabled: disabled
        }, intl.formatMessage((0, (0, parcelRequire("3hehr")).default).cancelButton))), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            style: {
                flexGrow: 1
            }
        }), customSecondaryToolbarComponents)));
    };
    $1f6a75b9646aed6f$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';
});
parcelRegister("9ci4W", function(module, exports) {
    (function() {
        'use strict';
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = '';
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (arg) classes = appendClass(classes, parseValue(arg));
            }
            return classes;
        }
        function parseValue(arg) {
            if (typeof arg === 'string' || typeof arg === 'number') return arg;
            if (typeof arg !== 'object') return '';
            if (Array.isArray(arg)) return classNames.apply(null, arg);
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
            var classes = '';
            for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
            return classes;
        }
        function appendClass(value, newClass) {
            if (!newClass) return value;
            if (value) return value + ' ' + newClass;
            return value + newClass;
        }
        if (0, module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define('classnames', [], function() {
            return classNames;
        });
        else window.classNames = classNames;
    })();
});
parcelRegister("kdDpx", function(module, exports) {
    $parcel$export(module.exports, "KeyDownHandlerContext", ()=>$78f86f420f59a10b$export$5455406531e3792c);
    $parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", ()=>$78f86f420f59a10b$export$9837e395eba6f527);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3fEIr;
    var $kXnoC;
    var $3AEXe;
    function $78f86f420f59a10b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $78f86f420f59a10b$export$5455406531e3792c = (0, ($parcel$interopDefault($5uXOq))).createContext({
        handleArrowLeft: ()=>{},
        handleArrowRight: ()=>{},
        handleTab: ()=>{}
    });
    const $78f86f420f59a10b$var$centeredToolbarContainer = {
        name: "1iikq5b",
        styles: "display:flex;width:100%;align-items:center"
    };
    const $78f86f420f59a10b$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const selectedItemIndex = (0, $5uXOq.useRef)(0);
        const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
            let index = 0;
            if (document.activeElement) {
                index = list.indexOf(document.activeElement);
                index = (index + 1) % list.length;
            }
            selectedItemIndex.current = index;
        }, []);
        const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
            let index = 0;
            if (document.activeElement) {
                index = list.indexOf(document.activeElement);
                index = (list.length + index - 1) % list.length;
            }
            selectedItemIndex.current = index;
        }, []);
        const handleArrowRight = ()=>{
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            incrementIndex(filteredFocusableElements);
            filteredFocusableElements[selectedItemIndex.current]?.focus();
        };
        const handleArrowLeft = ()=>{
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            decrementIndex(filteredFocusableElements);
            filteredFocusableElements[selectedItemIndex.current]?.focus();
        };
        const handleTab = ()=>{
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            filteredFocusableElements[selectedItemIndex.current]?.focus();
        };
        const handleTabLocal = ()=>{
            const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
            filteredFocusableElements.forEach((element)=>{
                element.setAttribute('tabindex', '-1');
            });
            filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
        };
        const focusAndScrollToElement = (element, scrollToElement = true)=>{
            if (scrollToElement) element?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
            element.focus();
        };
        const submenuKeydownHandleContext = {
            handleArrowLeft: handleArrowLeft,
            handleArrowRight: handleArrowRight,
            handleTab: handleTab
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!wrapperRef.current || disableArrowKeyNavigation) return;
            const { current: element } = wrapperRef;
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                if (targetElement instanceof HTMLElement && document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')?.contains(targetElement) || targetElement instanceof HTMLElement && document.querySelector('[data-test-id="color-picker-menu"]')?.contains(targetElement) || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
                const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
                if (menuWrapper) return;
                const elementBrowser = wrapperRef?.current?.querySelector(`#${(0, (0, parcelRequire("3fEIr")).ELEMENT_BROWSER_ID)}`);
                if (elementBrowser) return;
                const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
                if (!filteredFocusableElements || filteredFocusableElements?.length === 0) return;
                if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, (0, parcelRequire("3AEXe")).mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
                if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) selectedItemIndex.current = -1;
                else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
                const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
                switch(event.key){
                    case 'ArrowRight':
                        incrementIndex(filteredFocusableElements);
                        focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                        event.preventDefault();
                        break;
                    case 'ArrowLeft':
                        decrementIndex(filteredFocusableElements);
                        focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                        event.preventDefault();
                        break;
                    case 'Tab':
                        handleTabLocal();
                        break;
                    case 'Escape':
                        handleEscape(event);
                        break;
                    default:
                }
            };
            const globalKeyDownHandler = (event)=>{
                if (isShortcutToFocusToolbar(event)) {
                    const filteredFocusableElements = $78f86f420f59a10b$var$getFilteredFocusableElements(wrapperRef?.current);
                    filteredFocusableElements[0]?.focus();
                    filteredFocusableElements[0]?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                }
            };
            element?.addEventListener('keydown', handleKeyDown);
            const editorViewDom = editorView?.dom;
            if (isShortcutToFocusToolbar) editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener('keydown', handleKeyDown);
                if (isShortcutToFocusToolbar) editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            };
        }, [
            selectedItemIndex,
            wrapperRef,
            editorView,
            disableArrowKeyNavigation,
            handleEscape,
            childComponentSelector,
            incrementIndex,
            decrementIndex,
            isShortcutToFocusToolbar,
            editorAppearance,
            useStickyToolbar,
            intl
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: editorAppearance === 'comment' && $78f86f420f59a10b$var$centeredToolbarContainer,
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": intl.formatMessage((0, (0, parcelRequire("kXnoC")).messages).toolbarLabel),
            "aria-controls": (0, $c7748e834fcd4f22$export$b16ce0826b76e795)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($78f86f420f59a10b$export$5455406531e3792c.Provider, {
            value: submenuKeydownHandleContext
        }, children));
    };
    function $78f86f420f59a10b$var$getFocusableElements(rootNode) {
        if (!rootNode) return [];
        const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
        return Array.from(focusableModalElements);
    }
    function $78f86f420f59a10b$var$getFilteredFocusableElements(rootNode) {
        return $78f86f420f59a10b$var$getFocusableElements(rootNode).filter((elm)=>{
            const style = window.getComputedStyle(elm);
            const isVisible = style.visibility !== 'hidden' && style.display !== 'none';
            return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('.scroll-buttons') && isVisible;
        });
    }
});
parcelRegister("3fEIr", function(module, exports) {
    $parcel$export(module.exports, "GRID_SIZE", ()=>$e09bdf0cd98bec8e$export$bc90872e265d166e);
    $parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", ()=>$e09bdf0cd98bec8e$export$1f1798e92fa75806);
    $parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", ()=>$e09bdf0cd98bec8e$export$69bde1b03e8b5224);
    $parcel$export(module.exports, "SIDEBAR_WIDTH", ()=>$e09bdf0cd98bec8e$export$780035d9fe48eb32);
    $parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", ()=>$e09bdf0cd98bec8e$export$95b62a1773aa5ebe);
    $parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", ()=>$e09bdf0cd98bec8e$export$51a2d6b2c009fbfd);
    $parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", ()=>$e09bdf0cd98bec8e$export$df8bcac60101d466);
    $parcel$export(module.exports, "SCROLLBAR_WIDTH", ()=>$e09bdf0cd98bec8e$export$9a6bb2acef5e644a);
    $parcel$export(module.exports, "ELEMENT_LIST_PADDING", ()=>$e09bdf0cd98bec8e$export$3b8e93b2c0f295b0);
    $parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", ()=>$e09bdf0cd98bec8e$export$6d221f35db1b75aa);
    $parcel$export(module.exports, "ELEMENT_ITEM_PADDING", ()=>$e09bdf0cd98bec8e$export$ab53450bc5fd5b7d);
    $parcel$export(module.exports, "ELEMENT_BROWSER_ID", ()=>$e09bdf0cd98bec8e$export$6ee360fa4b93ee8e);
    const $e09bdf0cd98bec8e$export$bc90872e265d166e = 8;
    const $e09bdf0cd98bec8e$export$1f1798e92fa75806 = {
        small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 40,
        medium: $e09bdf0cd98bec8e$export$bc90872e265d166e * 75,
        large: $e09bdf0cd98bec8e$export$bc90872e265d166e * 128
    };
    const $e09bdf0cd98bec8e$export$69bde1b03e8b5224 = {
        small: $e09bdf0cd98bec8e$export$bc90872e265d166e * 50,
        medium: $e09bdf0cd98bec8e$export$1f1798e92fa75806.medium,
        large: $e09bdf0cd98bec8e$export$1f1798e92fa75806.large
    };
    const $e09bdf0cd98bec8e$export$780035d9fe48eb32 = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 25}px`;
    const $e09bdf0cd98bec8e$export$95b62a1773aa5ebe = `${$e09bdf0cd98bec8e$export$bc90872e265d166e * 6}px`;
    const $e09bdf0cd98bec8e$export$387950d54d372827 = '12px';
    const $e09bdf0cd98bec8e$export$51a2d6b2c009fbfd = '54px';
    const $e09bdf0cd98bec8e$export$df8bcac60101d466 = '20px';
    const $e09bdf0cd98bec8e$export$9a6bb2acef5e644a = 15;
    const $e09bdf0cd98bec8e$export$3b8e93b2c0f295b0 = 2;
    const $e09bdf0cd98bec8e$export$6d221f35db1b75aa = 60;
    const $e09bdf0cd98bec8e$export$ab53450bc5fd5b7d = 10;
    const $e09bdf0cd98bec8e$export$6ee360fa4b93ee8e = 'editor-element-browser';
});
const $c7748e834fcd4f22$export$b16ce0826b76e795 = 'ak-editor-textarea';
parcelRegister("7uhma", function(module, exports) {
    $parcel$export(module.exports, "tableFullPageEditorStyles", ()=>(parcelRequire("cipm3")).tableFullPageEditorStyles);
    $parcel$export(module.exports, "tableCommentEditorStyles", ()=>(parcelRequire("cipm3")).tableCommentEditorStyles);
    var $cipm3;
});
parcelRegister("cipm3", function(module, exports) {
    $parcel$export(module.exports, "insertColumnButtonOffset", ()=>$ba57a0e7ca2009cd$export$af45328890cf2a82);
    $parcel$export(module.exports, "tableStyles", ()=>$ba57a0e7ca2009cd$export$e938d6f191645a3e);
    $parcel$export(module.exports, "tableFullPageEditorStyles", ()=>$ba57a0e7ca2009cd$export$b0d19c9126eaec7a);
    $parcel$export(module.exports, "tableCommentEditorStyles", ()=>$ba57a0e7ca2009cd$export$61a2da566f69d1df);
    var $f8Sb3;
    var $gE8f9;
    var $6gEe5;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    var $k5uoT;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUhGn;
    var $1v4Xe;
    var $MDErT;
    const $ba57a0e7ca2009cd$var$cornerControlHeight = (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 1;
    const $ba57a0e7ca2009cd$export$af45328890cf2a82 = (0, (0, parcelRequire("1v4Xe")).tableInsertColumnButtonSize) / 2;
    const $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 = 44;
    const $ba57a0e7ca2009cd$var$rangeSelectionStyles = `
.${(0, (0, parcelRequire("eUhGn")).TableCssClassName).NODEVIEW_WRAPPER}.${(0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, (0, parcelRequire("5yojI")).getSelectionStyles)([
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket,
        (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border
    ])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
    const $ba57a0e7ca2009cd$var$sentinelStyles = `.${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER} {
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight)}px;
  }
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, (0, parcelRequire("1v4Xe")).tableScrollbarOffset) + (0, (0, parcelRequire("1v4Xe")).stickyRowOffsetTop) + (0, (0, parcelRequire("1v4Xe")).tablePadding) * 2 + 23}px;
  }
  &.${(0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS} {
    > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight)}px;
    }
  }
}`;
    const $ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles = `.${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER} {
 > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight) + $ba57a0e7ca2009cd$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, (0, parcelRequire("iHYdz")).MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
    const $ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles = `.${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER} {
  > .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
    const $ba57a0e7ca2009cd$var$stickyScrollbarStyles = `${$ba57a0e7ca2009cd$var$stickyScrollbarContainerStyles} ${$ba57a0e7ca2009cd$var$stickyScrollbarSentinelStyles}`;
    const $ba57a0e7ca2009cd$var$shadowSentinelStyles = `
  .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
    const $ba57a0e7ca2009cd$var$breakoutWidthStyling = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(">*:not([data-mark-type='fragment']) .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NODEVIEW_WRAPPER, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NODEVIEW_WRAPPER, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
    };
    const $ba57a0e7ca2009cd$var$viewModeSortStyles = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("th{.", (0, $f32dbb5556fcfa26$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}&:has(.is-active){.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}&:hover{.", (0, $75c933b3daaf1f19$export$bd4f24d8b1e86b23), "{opacity:1;}}}");
    };
    const $ba57a0e7ca2009cd$var$tableBorderStyles = ()=>{
        return `border-color: ${0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor}`;
    };
    const $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_SELECTED, ",&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_COLUMN, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
    };
    const $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle = ()=>{
        if ((0, (0, parcelRequire("gE8f9")).browser).gecko) return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
    };
    const $ba57a0e7ca2009cd$export$9989b31b7900261c = (props)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("6gEe5")).tableSharedStyle)(), ";", (0, (0, parcelRequire("MDErT")).columnControlsLineMarker)(), ";", (0, (0, parcelRequire("MDErT")).hoveredDeleteButton)(), ";", (0, (0, parcelRequire("MDErT")).hoveredCell)(), ";", (0, (0, parcelRequire("MDErT")).hoveredWarningCell), ";", (0, (0, parcelRequire("MDErT")).insertLine)(), ";", (0, (0, parcelRequire("MDErT")).resizeHandle)(), ";", $ba57a0e7ca2009cd$var$rangeSelectionStyles, ";", $ba57a0e7ca2009cd$var$viewModeSortStyles(), ";.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).LAST_ITEM_IN_CELL, "{margin-bottom:0;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, ",th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, "{background-color:", (0, (0, parcelRequire("1v4Xe")).tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";border-bottom:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, (0, parcelRequire("MDErT")).insertColumnButtonWrapper)(), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, (0, parcelRequire("MDErT")).insertRowButtonWrapper)(), ";}", (0, (0, parcelRequire("MDErT")).dragInsertButtonWrapper)(), " ", (0, (0, parcelRequire("MDErT")).dragCornerControlButton)(), (0, (0, parcelRequire("MDErT")).DeleteButton)(), ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, (0, parcelRequire("1v4Xe")).stickyRowOffsetTop) + 2, "px;width:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth), "px;position:fixed!important;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), "!important;box-shadow:0px -", (0, (0, parcelRequire("1v4Xe")).stickyRowOffsetTop), "px var(--ds-surface, white);border-right:0 none;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorSmallZIndex), "!important;background:var(--ds-surface, white);width:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;height:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;}", $ba57a0e7ca2009cd$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $ba57a0e7ca2009cd$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px solid var(--ds-surface, white);margin-left:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, green);}tr.sticky{padding-top:", (0, (0, parcelRequire("1v4Xe")).stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, white);box-sizing:content-box;box-shadow:0 6px 4px -4px ", `var(--ds-shadow-overflow-perimeter, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, ";margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;}tr.sticky th{border-bottom:", (0, (0, parcelRequire("1v4Xe")).stickyHeaderBorderBottomWidth), "px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";margin-right:-1px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $ba57a0e7ca2009cd$export$af45328890cf2a82 + 1, "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, (0, parcelRequire("1v4Xe")).resizeHandlerAreaWidth) - (0, (0, parcelRequire("1v4Xe")).resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, (0, parcelRequire("1v4Xe")).resizeHandlerAreaWidth) - (0, (0, parcelRequire("1v4Xe")).resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "{z-index:1;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, (0, parcelRequire("1v4Xe")).tableControlsSpacing), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, (0, parcelRequire("1v4Xe")).tableControlsSpacing) + 2, "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, (0, parcelRequire("1v4Xe")).tableControlsSpacing) - (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 2, "px solid var(--ds-surface, white);}", $ba57a0e7ca2009cd$var$sentinelStyles, " ", (0, (0, parcelRequire("MDErT")).OverflowShadow)(props.featureFlags?.tableDragAndDrop), " ", $ba57a0e7ca2009cd$var$stickyScrollbarStyles, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, (0, parcelRequire("1v4Xe")).tablePadding), "px;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, (0, parcelRequire("1v4Xe")).tablePadding), "px;&::after{right:6px!important;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, (0, parcelRequire("1v4Xe")).tablePadding), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) + (0, (0, parcelRequire("1v4Xe")).tablePadding) - 1, "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, "{width:", (0, (0, parcelRequire("1v4Xe")).tableOverflowShadowWidth), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CHROMELESS, "{left:8px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CHROMELESS, "{left:calc(100% - 16px);}}>.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $ba57a0e7ca2009cd$var$breakoutWidthStyling(), " ", (0, (0, parcelRequire("MDErT")).columnControlsDecoration)(), ";", (0, (0, parcelRequire("MDErT")).rowControlsWrapperDotStyle)(), ";.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, "{width:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 1, "px;height:", $ba57a0e7ca2009cd$var$cornerControlHeight, "px;display:none;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, (0, parcelRequire("MDErT")).InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 1, "px;height:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 1, "px;border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, (0, parcelRequire("1v4Xe")).tableBorderRadiusSize), "px;background:", (0, (0, parcelRequire("1v4Xe")).tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";background:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, (0, parcelRequire("iHYdz")).akEditorTableToolbarSize) + (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) + 1, "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";background:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";background:", (0, (0, parcelRequire("1v4Xe")).tableToolbarDeleteColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS, "{width:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, (0, parcelRequire("MDErT")).InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, (0, parcelRequire("MDErT")).HeaderButton)(`
        border-bottom: 1px solid ${(0, (0, parcelRequire("1v4Xe")).tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, (0, parcelRequire("1v4Xe")).tableToolbarSize)}px;

        .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, (0, parcelRequire("1v4Xe")).tableBorderRadiusSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:24px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, (0, parcelRequire("1v4Xe")).resizeHandlerZIndex), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:24px;width:100%;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #C1C7D0);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid ", `var(--ds-surface, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F4F5F7);}&>g>rect{fill:var(--ds-icon-disabled, #BFDBF847);}}}&:not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DCDFE4);}g{fill:var(--ds-icon-subtle, #626f86);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #579DFF);}g{fill:var(--ds-icon-inverse, #FFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #2684FF);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #579dff);}g{fill:var(--ds-icon-inverse, #fff);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #F87462);}g{fill:var(--ds-border-inverse, #FFF);}}}}}", (0, (0, parcelRequire("MDErT")).floatingColumnControls)(), " :not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS, "{", (0, (0, parcelRequire("MDErT")).HeaderButtonHover)(), " ", (0, (0, parcelRequire("MDErT")).HeaderButtonDanger)(), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, (0, parcelRequire("iHYdz")).akEditorTableToolbarSize), "px;top:", props.featureFlags?.tableDragAndDrop || (0, $gmhCD.editorExperiment)('support_table_in_comment_jira', true) ? 0 : (0, (0, parcelRequire("iHYdz")).akEditorTableToolbarSize), "px;width:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:10px 2px;text-align:center;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)((0, (0, parcelRequire("k5uoT")).fontSize)()), ";background-color:", (0, (0, parcelRequire("1v4Xe")).tableHeaderCellBackgroundColor), ";color:", (0, (0, parcelRequire("1v4Xe")).tableTextColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, ":first-of-type::after{content:'';display:block;height:33px;width:100%;background-color:var(--ds-surface, white);position:absolute;top:-34px;left:-1px;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CORNER_CONTROLS, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-bottom:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";position:relative;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}}}:not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{border-bottom:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";position:relative;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";color:", `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarDeleteColor), ";border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";border-left:0;color:", `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`, ";position:relative;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "::after,.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, (0, parcelRequire("iHYdz")).akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "{border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "::after{background:", (0, (0, parcelRequire("1v4Xe")).tableCellSelectedColor), ";z-index:", (0, (0, parcelRequire("iHYdz")).akEditorSmallZIndex), ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{background:", (0, (0, parcelRequire("1v4Xe")).tableCellDeleteColor), ";z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 100, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, ",td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, ",th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, ",th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 100, ";}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $ba57a0e7ca2009cd$var$tableBorderStyles(), ";z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 100, ";}}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px;left:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + 1, "px;z-index:", (0, (0, parcelRequire("1v4Xe")).rowControlsZIndex) + 4, ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop) - $ba57a0e7ca2009cd$var$cornerControlHeight + 1, "px;left:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_WRAPPER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorTableCellOnStickyHeaderZIndex) - 4, ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}");
    const $ba57a0e7ca2009cd$export$e938d6f191645a3e = (props)=>(0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror{", $ba57a0e7ca2009cd$export$9989b31b7900261c(props), ";}.ProseMirror.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $4038285048829feb$export$b2380b18b089518f), ";}}.ProseMirror.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}", $ba57a0e7ca2009cd$var$shadowSentinelStyles, ";");
    const $ba57a0e7ca2009cd$export$b0d19c9126eaec7a = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
    const $ba57a0e7ca2009cd$export$61a2da566f69d1df = (0, (0, parcelRequire("f8Sb3")).css)(".ProseMirror .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $4038285048829feb$export$b2380b18b089518f), ";}");
});
const $f32dbb5556fcfa26$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $f32dbb5556fcfa26$export$fb5c0ba8f0806db1 = 'is-disabled';
const $f32dbb5556fcfa26$export$665a01df2c44393a = 'data-sort-index';
parcelRegister("MDErT", function(module, exports) {
    $parcel$export(module.exports, "InsertMarker", ()=>$d31b53cc0f00ae8f$export$22ce45ffbca2b768);
    $parcel$export(module.exports, "HeaderButton", ()=>$d31b53cc0f00ae8f$export$c7c73467b57835d);
    $parcel$export(module.exports, "HeaderButtonHover", ()=>$d31b53cc0f00ae8f$export$eb5435fbd56e8d4);
    $parcel$export(module.exports, "HeaderButtonDanger", ()=>$d31b53cc0f00ae8f$export$7f243984d41e6570);
    $parcel$export(module.exports, "dragInsertButtonWrapper", ()=>$d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e);
    $parcel$export(module.exports, "dragCornerControlButton", ()=>$d31b53cc0f00ae8f$export$6134f9ac8c9f161f);
    $parcel$export(module.exports, "insertColumnButtonWrapper", ()=>$d31b53cc0f00ae8f$export$d9daf73b486785b9);
    $parcel$export(module.exports, "insertRowButtonWrapper", ()=>$d31b53cc0f00ae8f$export$595c9c01d7c39885);
    $parcel$export(module.exports, "columnControlsLineMarker", ()=>$d31b53cc0f00ae8f$export$6114ba9f95ca48dc);
    $parcel$export(module.exports, "DeleteButton", ()=>$d31b53cc0f00ae8f$export$d6f68d0fe29f8050);
    $parcel$export(module.exports, "OverflowShadow", ()=>$d31b53cc0f00ae8f$export$f802e22253ad2b2c);
    $parcel$export(module.exports, "floatingColumnControls", ()=>$d31b53cc0f00ae8f$export$125caa90718a4ea9);
    $parcel$export(module.exports, "rowControlsWrapperDotStyle", ()=>$d31b53cc0f00ae8f$export$a2258906ae78ec82);
    $parcel$export(module.exports, "columnControlsDecoration", ()=>$d31b53cc0f00ae8f$export$8c8180e74f25db6a);
    $parcel$export(module.exports, "hoveredDeleteButton", ()=>$d31b53cc0f00ae8f$export$4d63bf225990ad34);
    $parcel$export(module.exports, "hoveredCell", ()=>$d31b53cc0f00ae8f$export$1c46f5412a5a3ae0);
    $parcel$export(module.exports, "hoveredWarningCell", ()=>$d31b53cc0f00ae8f$export$40edb32b62e4fb85);
    $parcel$export(module.exports, "resizeHandle", ()=>$d31b53cc0f00ae8f$export$8e36b812ea421d73);
    $parcel$export(module.exports, "insertLine", ()=>$d31b53cc0f00ae8f$export$b9932a52fb1c7aad);
    var $f8Sb3;
    var $6gEe5;
    var $iHYdz;
    var $eUhGn;
    var $1v4Xe;
    const $d31b53cc0f00ae8f$var$InsertLine = (cssString)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";", cssString, ";}");
    const $d31b53cc0f00ae8f$var$Marker = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: (0, (0, parcelRequire("1v4Xe")).tableBorderColor),
            position: 'absolute',
            height: `${(0, (0, parcelRequire("1v4Xe")).lineMarkerSize)}px`,
            width: `${(0, (0, parcelRequire("1v4Xe")).lineMarkerSize)}px`,
            borderRadius: '50%',
            pointerEvents: 'none'
        });
    const $d31b53cc0f00ae8f$export$22ce45ffbca2b768 = (cssString)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_MARKER, "{", $d31b53cc0f00ae8f$var$Marker(), ";", cssString, ";}");
    const $d31b53cc0f00ae8f$var$Button = (cssString)=>(0, (0, parcelRequire("f8Sb3")).css)("border-radius:var(--ds-border-radius, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
    const $d31b53cc0f00ae8f$export$c7c73467b57835d = (cssString)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, "{background:", (0, (0, parcelRequire("1v4Xe")).tableHeaderCellBackgroundColor), ";border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, "{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";}");
    const $d31b53cc0f00ae8f$export$eb5435fbd56e8d4 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, ":hover{color:", `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`, ";background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";cursor:pointer;}");
    const $d31b53cc0f00ae8f$export$7f243984d41e6570 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarDeleteColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";position:relative;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex), ";}");
    const $d31b53cc0f00ae8f$var$InsertButton = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, (0, parcelRequire("1v4Xe")).tableInsertColumnButtonSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).tableInsertColumnButtonSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
      background: ${"var(--ds-surface-overlay, white)"};
      box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`};
      color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    `), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
    const $d31b53cc0f00ae8f$var$InsertButtonHover = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
    const $d31b53cc0f00ae8f$export$cfa9a9cdd25b9d6e = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) + 10, ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
    background: ${"var(--ds-surface-overlay, white)"};
    color: ${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #C1C7D0)"};
    border-radius: 50%;
    height: ${(0, (0, parcelRequire("1v4Xe")).dragTableInsertColumnButtonSize)}px;
    width: ${(0, (0, parcelRequire("1v4Xe")).dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";border:1px solid ", `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`, ";color:var(--ds-icon-inverse, white);cursor:pointer;}");
    const $d31b53cc0f00ae8f$export$6134f9ac8c9f161f = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 99, ";&.active .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #0C66E4);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFF);background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);border-radius:2px;width:5px;height:5px;position:relative;}");
    const $d31b53cc0f00ae8f$export$d9daf73b486785b9 = ()=>(0, (0, parcelRequire("f8Sb3")).css)($d31b53cc0f00ae8f$var$InsertButton(), $d31b53cc0f00ae8f$var$InsertButtonHover(), $d31b53cc0f00ae8f$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
    const $d31b53cc0f00ae8f$export$595c9c01d7c39885 = ()=>(0, (0, parcelRequire("f8Sb3")).css)($d31b53cc0f00ae8f$var$InsertButton(), $d31b53cc0f00ae8f$var$InsertButtonHover(), $d31b53cc0f00ae8f$var$InsertLine(`
    height: 2px;
    top: -11px;
	${''}
    left: ${(0, (0, parcelRequire("1v4Xe")).tableInsertColumnButtonSize) - 1}px;
  `));
    const $d31b53cc0f00ae8f$export$6114ba9f95ca48dc = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
    const $d31b53cc0f00ae8f$export$d6f68d0fe29f8050 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, (0, parcelRequire("1v4Xe")).tableDeleteButtonSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).tableDeleteButtonSize), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $d31b53cc0f00ae8f$var$Button(`
        background: ${(0, (0, parcelRequire("1v4Xe")).tableCellSelectedDeleteIconBackground)};
        color: ${(0, (0, parcelRequire("1v4Xe")).tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, (0, parcelRequire("1v4Xe")).tableCellHoverDeleteIconBackground), ";color:", (0, (0, parcelRequire("1v4Xe")).tableCellHoverDeleteIconColor), ";cursor:pointer;}");
    const $d31b53cc0f00ae8f$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, (0, parcelRequire("6gEe5")).tableMarginTop), "px;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorShadowZIndex), ";width:", (0, (0, parcelRequire("1v4Xe")).tableOverflowShadowWidthWide), "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto left,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_STICKY_SHADOW, ").", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{left:", (0, (0, parcelRequire("iHYdz")).akEditorTableNumberColumnWidth) - 1, "px;}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, "{background:linear-gradient(\n\t\t\t\tto right,\n\t\t\t\ttransparent 0,\n\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, " 140%\n\t\t\t),linear-gradient(\n\t\t\t\tto left,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:calc(100% - ", (0, (0, parcelRequire("1v4Xe")).tableOverflowShadowWidthWide), "px);}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, "{", $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";}}");
    const $d31b53cc0f00ae8f$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
        if (!isDragAndDropEnabled) return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_RIGHT_SHADOW, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, (0, parcelRequire("6gEe5")).tableMarginTopWithControl), "px);top:", (0, (0, parcelRequire("6gEe5")).tableMarginTopWithControl), "px;}");
    };
    const $d31b53cc0f00ae8f$var$columnHeaderButton = (cssString)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)({
            background: (0, (0, parcelRequire("1v4Xe")).tableHeaderCellBackgroundColor),
            display: 'block',
            boxSizing: 'border-box',
            padding: 0,
            ':focus': {
                outline: 'none'
            }
        }, cssString);
    };
    const $d31b53cc0f00ae8f$var$columnHeaderButtonSelected = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            backgroundColor: (0, (0, parcelRequire("1v4Xe")).tableToolbarSelectedColor),
            borderColor: (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor),
            zIndex: (0, (0, parcelRequire("1v4Xe")).columnControlsSelectedZIndex)
        });
    const $d31b53cc0f00ae8f$var$getFloatingDotOverrides = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("tr th:last-child .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";position:absolute;height:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
    };
    const $d31b53cc0f00ae8f$export$125caa90718a4ea9 = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
    };
    const $d31b53cc0f00ae8f$export$a2258906ae78ec82 = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("div.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, ">.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, ">.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";position:absolute;height:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;right:-1px;}");
    };
    const $d31b53cc0f00ae8f$export$8c8180e74f25db6a = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;height:", (0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";position:absolute;height:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;width:", (0, (0, parcelRequire("1v4Xe")).lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $d31b53cc0f00ae8f$var$columnHeaderButton(`
        border-right: ${(0, (0, parcelRequire("6gEe5")).tableCellBorderWidth)}px solid ${(0, (0, parcelRequire("1v4Xe")).tableBorderColor)};
        border-top: ${(0, (0, parcelRequire("6gEe5")).tableCellBorderWidth)}px solid ${(0, (0, parcelRequire("1v4Xe")).tableBorderColor)};
        border-bottom: ${(0, (0, parcelRequire("6gEe5")).tableCellBorderWidth)}px solid ${(0, (0, parcelRequire("1v4Xe")).tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, (0, parcelRequire("1v4Xe")).tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, (0, parcelRequire("1v4Xe")).columnControlsDecorationHeight) - (0, (0, parcelRequire("1v4Xe")).tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, (0, parcelRequire("1v4Xe")).columnControlsZIndex)};
      `), ";}}", $d31b53cc0f00ae8f$var$getFloatingDotOverrides(), " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_CONTROLS, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_SELECTED, ",&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_TABLE, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarDeleteColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_SELECTED, ",&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_COLUMN, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";border-left:", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";left:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_COLUMN, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}&.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, (0, parcelRequire("1v4Xe")).tableToolbarDeleteColor), ";border-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";border-left:", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";left:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;z-index:", (0, (0, parcelRequire("iHYdz")).akEditorUnitZIndex) * 100, ";}}}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CELL, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_HEADER_CELL, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $d31b53cc0f00ae8f$var$columnHeaderButtonSelected(), ";}}");
    };
    const $d31b53cc0f00ae8f$export$4d63bf225990ad34 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).COLUMN_SELECTED, ",.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, "{border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).SELECTED_CELL, "::after{background:", (0, (0, parcelRequire("1v4Xe")).tableCellDeleteColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, (0, parcelRequire("1v4Xe")).tableCellDeleteColor), ";border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, (0, parcelRequire("1v4Xe")).tableCellDeleteColor), ";border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderDeleteColor), ";}}}");
    const $d31b53cc0f00ae8f$export$1c46f5412a5a3ae0 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, "{position:relative;border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";}.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL, ".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, (0, parcelRequire("1v4Xe")).tableBorderColor), ";}}");
    const $d31b53cc0f00ae8f$export$40edb32b62e4fb85 = (0, (0, parcelRequire("f8Sb3")).css)(":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).IS_RESIZING, ") .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, ":not(.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).HOVERED_CELL_WARNING, "{background-color:", `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`, "!important;border:1px solid ", `var(--ds-border-warning, ${(0, $829f609a65d26a98$export$5aae31392d72caaa)})`, ";}}");
    const $d31b53cc0f00ae8f$var$resizeLineStyles = ()=>{
        return (0, (0, parcelRequire("f8Sb3")).css)("th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + ", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";top:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, (0, parcelRequire("1v4Xe")).resizeLineWidth), "px;height:calc(100% + ", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px);background-color:", (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor), ";z-index:", (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2, ";top:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;}");
    };
    const $d31b53cc0f00ae8f$export$8e36b812ea421d73 = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "{.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, (0, parcelRequire("1v4Xe")).resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, (0, parcelRequire("1v4Xe")).resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, (0, parcelRequire("1v4Xe")).resizeHandlerZIndex), ";}tr th:last-child .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, (0, parcelRequire("1v4Xe")).resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, (0, parcelRequire("1v4Xe")).resizeHandlerZIndex), ";}", $d31b53cc0f00ae8f$var$resizeLineStyles(), " table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_RESIZE_LINE, " .", (0, (0, parcelRequire("eUhGn")).TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;height:calc(100% + ", (0, (0, parcelRequire("1v4Xe")).tableToolbarSize) + (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px);}}");
    const $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        content: "' '",
        position: 'absolute',
        height: `calc(100% + ${(0, (0, parcelRequire("6gEe5")).tableCellBorderWidth) * 2}px)`,
        width: `${(0, (0, parcelRequire("1v4Xe")).insertLineWidth)}px`,
        zIndex: (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2
    });
    const $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        content: "' '",
        position: 'absolute',
        left: "var(--ds-space-negative-025, -2px)",
        height: `${(0, (0, parcelRequire("1v4Xe")).insertLineWidth)}px`,
        width: `calc(100% + ${(0, (0, parcelRequire("6gEe5")).tableCellBorderWidth) * 2}px)`,
        zIndex: (0, (0, parcelRequire("1v4Xe")).columnControlsZIndex) * 2
    });
    const $d31b53cc0f00ae8f$var$insertLineActiveColor = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: (0, (0, parcelRequire("1v4Xe")).tableBorderSelectedColor)
    });
    const $d31b53cc0f00ae8f$var$insertLineInactiveColor = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-accent-gray-subtler, ${(0, (0, parcelRequire("iHYdz")).akEditorTableBorder)})`
    });
    const $d31b53cc0f00ae8f$export$b9932a52fb1c7aad = ()=>(0, (0, parcelRequire("f8Sb3")).css)(".", (0, (0, parcelRequire("eUhGn")).TableCssClassName).TABLE_CONTAINER, "{td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, (0, parcelRequire("6gEe5")).tableCellBorderWidth), "px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " top:-1px;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}td.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineActiveColor, ";}th.", (0, (0, parcelRequire("eUhGn")).TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $d31b53cc0f00ae8f$var$tableCellRowInsertLineStyles, " bottom:0;", $d31b53cc0f00ae8f$var$insertLineInactiveColor, ";}}");
});
parcelRegister("3hehr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$72e2957b14844aa6$export$2e2bcd8739ae039);
    var $8DYpW;
    var $72e2957b14844aa6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8DYpW")).default);
});
parcelRegister("cex0T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78865ac916ce418a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $a3qhX;
    function $78865ac916ce418a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $78865ac916ce418a$var$clickWrapper = {
        name: "sox1a6",
        styles: "flex-grow:1;height:100%"
    };
    const $78865ac916ce418a$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
        const handleMouseDown = (0, ($parcel$interopDefault($5uXOq))).useCallback((event)=>{
            if (!editorView) return;
            if (!editorDisabled) (0, (0, parcelRequire("a3qhX")).clickAreaClickHandler)(editorView, event);
        }, [
            editorView,
            editorDisabled
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": "click-wrapper",
            css: $78865ac916ce418a$var$clickWrapper,
            onMouseDown: handleMouseDown
        }, children));
    };
    var $78865ac916ce418a$export$2e2bcd8739ae039 = $78865ac916ce418a$export$68468c5dbde37b99;
});
parcelRegister("a3qhX", function(module, exports) {
    $parcel$export(module.exports, "clickAreaClickHandler", ()=>$78b1133e759b60f6$export$28b64e3e5a38e8a2);
    var $3I3CN;
    var $jNU25;
    var $5Vvw4;
    var $eQcNy;
    const $78b1133e759b60f6$var$insideContentArea = (ref)=>{
        while(ref){
            if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
            ref = ref.parentNode;
        }
        return false;
    };
    const $78b1133e759b60f6$var$insideProseMirrorEditableArea = (ref)=>{
        return Boolean(ref?.closest('.ProseMirror'));
    };
    const $78b1133e759b60f6$export$79ba7abfc5f47a65 = (target)=>{
        const modalDialog = target?.closest('[role=dialog]');
        if (modalDialog) return !!modalDialog?.querySelector('.akEditor');
        return true;
    };
    const $78b1133e759b60f6$export$28b64e3e5a38e8a2 = (view, event)=>{
        const isEditorFocused = !!view?.hasFocus?.();
        if (!(event.target instanceof HTMLElement)) return;
        const target = event.target;
        const isTargetContentArea = target?.classList.contains('ak-editor-content-area');
        const isTargetChildOfContentArea = $78b1133e759b60f6$var$insideContentArea(target?.parentNode instanceof HTMLElement ? target?.parentNode : null);
        const isTargetInsideEditableArea = $78b1133e759b60f6$var$insideProseMirrorEditableArea(target);
        if (isTargetInsideEditableArea) return false;
        const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
        const isInputClicked = target?.nodeName === 'INPUT';
        const isPopupClicked = !!(0, (0, parcelRequire("eQcNy")).closestElement)(target, '[data-editor-popup]');
        const isTextAreaClicked = target?.nodeName === 'TEXTAREA';
        const isBreadcrumbClicked = !!(0, (0, parcelRequire("eQcNy")).closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
        const selection = window.getSelection();
        const isEditorPopupTextSelected = selection?.type === 'Range' && (0, (0, parcelRequire("eQcNy")).closestElement)(selection?.anchorNode, '[data-editor-popup]');
        const isEventComingFromInlineCommentPopup = Boolean((0, (0, parcelRequire("eQcNy")).closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, (0, parcelRequire("eQcNy")).closestElement)(target, 'div[offset]'));
        const isButtonClicked = Boolean((0, (0, parcelRequire("eQcNy")).closestElement)(event.currentTarget, 'button')) || Boolean((0, (0, parcelRequire("eQcNy")).closestElement)(target, 'button')) || event.currentTarget?.nodeName === 'BUTTON' || target?.nodeName === 'BUTTON';
        const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
        const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
        const isDatasourcePopupClicked = !!target?.closest('#column-picker-popup');
        const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
        const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
        const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
        const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
        const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
        const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && $78b1133e759b60f6$export$79ba7abfc5f47a65(target);
        if (isClickOutsideEditor && view) $78b1133e759b60f6$var$outsideProsemirrorEditorClickHandler(view, event);
    };
    const $78b1133e759b60f6$var$outsideProsemirrorEditorClickHandler = (view, event)=>{
        const { dispatch: dispatch, dom: dom, state: state } = view;
        const { tr: tr } = state;
        const isEditorFocused = !!view?.hasFocus?.();
        const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
        if (isBottomAreaClicked) {
            tr.setMeta('outsideProsemirrorEditorClicked', true);
            (0, (0, parcelRequire("jNU25")).addParagraphAtEnd)(tr);
        }
        (0, (0, parcelRequire("5Vvw4")).setSelectionTopLevelBlocks)(tr, event, dom, view.posAtCoords.bind(view), isEditorFocused);
        (0, (0, parcelRequire("3I3CN")).tintDirtyTransaction)(tr);
        if (!tr.docChanged && !tr.selectionSet) return;
        if (dispatch) dispatch(tr);
        view.focus();
        event.preventDefault();
    };
});
parcelRegister("jNU25", function(module, exports) {
    $parcel$export(module.exports, "addParagraphAtEnd", ()=>$2372cedf5b014ac0$export$fc18809329b5ff08);
    $parcel$export(module.exports, "changeImageAlignment", ()=>$2372cedf5b014ac0$export$774cc08dd90b6a6a);
    $parcel$export(module.exports, "createToggleBlockMarkOnRange", ()=>$2372cedf5b014ac0$export$1115c4cf51ae1924);
    $parcel$export(module.exports, "createToggleInlineMarkOnRange", ()=>$2372cedf5b014ac0$export$a10bb5a1a10022f6);
    $parcel$export(module.exports, "toggleBlockMark", ()=>$2372cedf5b014ac0$export$72d6145976985e8c);
    $parcel$export(module.exports, "findCutBefore", ()=>$2372cedf5b014ac0$export$ad1078cb3917e860);
    var $gZGBX;
    var $hFEwm;
    var $93WYh;
    function $2372cedf5b014ac0$export$fc18809329b5ff08(tr) {
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
        if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
            if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
        }
        tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, tr.doc.content.size - 1));
        tr.scrollIntoView();
    }
    function $2372cedf5b014ac0$export$2864da03fd603a92() {
        return function(state, dispatch) {
            const { tr: tr } = state;
            $2372cedf5b014ac0$export$fc18809329b5ff08(tr);
            if (dispatch) dispatch(tr);
            return true;
        };
    }
    const $2372cedf5b014ac0$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
            const { from: from, to: to } = state.selection;
            const tr = state.tr;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    layout: align === 'center' ? 'center' : `align-${align}`
                });
            });
            if (tr.docChanged && dispatch) {
                dispatch(tr.scrollIntoView());
                return true;
            }
            return false;
        };
    const $2372cedf5b014ac0$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
            let markApplied = false;
            state.doc.nodesBetween(from, to, (node, pos, parent)=>{
                if (!node.type.isBlock) return false;
                if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parent?.type.allowsMarkType(markType)) {
                    const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                    const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                    const newAttrs = getAttrs(prevAttrs, node);
                    if (newAttrs !== undefined) {
                        tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                        markApplied = true;
                    }
                }
                return;
            });
            return markApplied;
        };
    const $2372cedf5b014ac0$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
            let markApplied = false;
            state.doc.nodesBetween(from, to, (node, pos, parent)=>{
                if (parent?.type.allowsMarkType(markType)) {
                    const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                    const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                    const newAttrs = getAttrs(prevAttrs, node);
                    if (newAttrs !== undefined) {
                        tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                        tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, state.selection.from));
                        markApplied = true;
                    }
                }
                return;
            });
            return markApplied;
        };
    const $2372cedf5b014ac0$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
            let markApplied = false;
            const tr = state.tr;
            const toggleBlockMarkOnRange = $2372cedf5b014ac0$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
            if (state.selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) state.selection.forEachCell((cell, pos)=>{
                markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
            });
            else {
                const { from: from, to: to } = state.selection;
                markApplied = toggleBlockMarkOnRange(from, to, tr, state);
            }
            if (markApplied && tr.docChanged) {
                if (dispatch) dispatch(tr.scrollIntoView());
                return true;
            }
            return false;
        };
    const $2372cedf5b014ac0$export$59c0bf8874edecc7 = (state, dispatch)=>{
        const tr = state.tr;
        tr.replace(0, state.doc.nodeSize - 2);
        tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).atStart(tr.doc));
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
    function $2372cedf5b014ac0$export$ad1078cb3917e860($pos) {
        if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
            if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
            if ($pos.node(i).type.spec.isolating) break;
        }
        return null;
    }
    function $2372cedf5b014ac0$export$c6a04dca1ed03a3c(level) {
        return function(state, dispatch) {
            const { selection: selection, schema: schema, tr: tr } = state;
            const ranges = selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection) ? selection.ranges : [
                selection
            ];
            ranges.forEach(({ $from: $from, $to: $to })=>{
                tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                    level: level
                });
            });
            if (dispatch) dispatch(tr);
            return true;
        };
    }
});
parcelRegister("hFEwm", function(module, exports) {
    $parcel$export(module.exports, "CellSelection", ()=>$451fe475e5e2c47a$export$831cc7e2a83afa94);
    var $kCV8T;
    var $gZGBX;
    var $6MNnJ;
    var $uOUlv;
    var $6hQQ3;
    var $6e6o8;
    var $aKDxB;
    var $bQFBc;
    class $451fe475e5e2c47a$export$831cc7e2a83afa94 extends (0, (0, parcelRequire("gZGBX")).Selection) {
        constructor($anchorCell, $headCell = $anchorCell){
            const ranges = (0, (0, parcelRequire("aKDxB")).getCellSelectionRanges)($anchorCell, $headCell);
            super(ranges[0].$from, ranges[0].$to, ranges);
            this.$anchorCell = $anchorCell;
            this.$headCell = $headCell;
            this.visible = false;
        }
        map(doc, mapping) {
            const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
            const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
            if ((0, (0, parcelRequire("6hQQ3")).pointsAtCell)($anchorCell) && (0, (0, parcelRequire("6hQQ3")).pointsAtCell)($headCell) && (0, (0, parcelRequire("bQFBc")).inSameTable)($anchorCell, $headCell)) {
                const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
                if (tableChanged && this.isRowSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
                if (tableChanged && this.isColSelection()) return $451fe475e5e2c47a$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
                return new $451fe475e5e2c47a$export$831cc7e2a83afa94($anchorCell, $headCell);
            }
            return (0, (0, parcelRequire("gZGBX")).TextSelection).between($anchorCell, $headCell);
        }
        content() {
            const table = this.$anchorCell.node(-1);
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
            const start = this.$anchorCell.start(-1);
            const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
            const seen = {};
            const rows = [];
            for(let row = rect.top; row < rect.bottom; row++){
                const rowContent = [];
                for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                    const pos = map.map[index];
                    if (!seen[pos]) {
                        seen[pos] = true;
                        const cellRect = map.findCell(pos);
                        let cell = table.nodeAt(pos);
                        if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                        const extraLeft = rect.left - cellRect.left;
                        const extraRight = cellRect.right - rect.right;
                        if (extraLeft > 0 || extraRight > 0) {
                            let { attrs: attrs } = cell;
                            if (!attrs) throw new Error(`No cell at position ${pos}`);
                            if (extraLeft > 0) attrs = (0, (0, parcelRequire("6e6o8")).removeColSpan)(attrs, 0, extraLeft);
                            if (extraRight > 0) attrs = (0, (0, parcelRequire("6e6o8")).removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                            if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                            else cell = cell.type.create(attrs, cell.content);
                        }
                        if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                        if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                            const attrs = {
                                ...cell.attrs,
                                rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                            };
                            if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                            else cell = cell.type.create(attrs, cell.content);
                        }
                        if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                        rowContent.push(cell);
                    }
                }
                rows.push(table.child(row).copy((0, (0, parcelRequire("kCV8T")).Fragment).from(rowContent)));
            }
            const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(fragment), 1, 1);
        }
        replace(tr, content = (0, (0, parcelRequire("kCV8T")).Slice).empty) {
            const mapFrom = tr.steps.length;
            const { ranges: ranges } = this;
            for(let i = 0; i < ranges.length; i++){
                const { $from: $from, $to: $to } = ranges[i];
                const mapping = tr.mapping.slice(mapFrom);
                tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, (0, parcelRequire("kCV8T")).Slice).empty : content);
            }
            const sel = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
            if (sel) tr.setSelection(sel);
        }
        replaceWith(tr, node) {
            this.replace(tr, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(node), 0, 0));
        }
        forEachCell(f) {
            const table = this.$anchorCell.node(-1);
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
            const start = this.$anchorCell.start(-1);
            const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
            for(let i = 0; i < cells.length; i++){
                const cell = table.nodeAt(cells[i]);
                if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
                f(cell, start + cells[i]);
            }
        }
        isColSelection() {
            if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
            const anchorTop = this.$anchorCell.index(-1);
            const headTop = this.$headCell.index(-1);
            if (Math.min(anchorTop, headTop) > 0) return false;
            const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
            const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
            return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
        }
        static colSelection($anchorCell, $headCell = $anchorCell) {
            let $calculatedAnchorCell = $anchorCell;
            let $calculatedHeadCell = $headCell;
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get($calculatedAnchorCell.node(-1));
            const start = $calculatedAnchorCell.start(-1);
            const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
            const headRect = map.findCell($calculatedHeadCell.pos - start);
            const doc = $calculatedAnchorCell.node(0);
            if (anchorRect.top <= headRect.top) {
                if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
                if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
            } else {
                if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
                if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
            }
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
        }
        isRowSelection() {
            if (!this.$anchorCell || !this.$headCell) return false;
            const start = this.$anchorCell.start(-1);
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(this.$anchorCell.node(-1));
            const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
            const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
            const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
            let maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
            if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
            const anchorLeft = map.colCount(this.$anchorCell.pos - start);
            const headLeft = map.colCount(this.$headCell.pos - start);
            if (Math.min(anchorLeft, headLeft) > 0) return false;
            const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
            const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
            return Math.max(anchorRight, headRight) === map.width;
        }
        eq(other) {
            return other instanceof $451fe475e5e2c47a$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
        }
        static rowSelection($anchorCell, $headCell = $anchorCell) {
            let $calculatedAnchorCell = $anchorCell;
            let $calculatedHeadCell = $headCell;
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get($calculatedAnchorCell.node(-1));
            const start = $calculatedAnchorCell.start(-1);
            const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
            const headRect = map.findCell($calculatedHeadCell.pos - start);
            const doc = $calculatedAnchorCell.node(0);
            if (anchorRect.left <= headRect.left) {
                if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
                if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
            } else {
                if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
                if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
            }
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
        }
        toJSON() {
            return {
                type: 'cell',
                anchor: this.$anchorCell.pos,
                head: this.$headCell.pos
            };
        }
        static fromJSON(doc, json) {
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
        }
        static create(doc, anchorCell, headCell = anchorCell) {
            return new $451fe475e5e2c47a$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
        }
        getBookmark() {
            return new (0, (0, parcelRequire("6MNnJ")).CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
        }
    }
    (0, (0, parcelRequire("gZGBX")).Selection).jsonID('cell', $451fe475e5e2c47a$export$831cc7e2a83afa94);
});
parcelRegister("6MNnJ", function(module, exports) {
    $parcel$export(module.exports, "CellBookmark", ()=>$7bc56074adb266b5$export$ca751a6394ad160e);
    var $gZGBX;
    var $bQFBc;
    class $7bc56074adb266b5$export$ca751a6394ad160e {
        constructor(anchor, head){
            this.anchor = anchor;
            this.head = head;
        }
        map(mapping) {
            return new $7bc56074adb266b5$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
        }
        resolve(doc) {
            const $anchorCell = doc.resolve(this.anchor);
            const $headCell = doc.resolve(this.head);
            if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, (0, parcelRequire("bQFBc")).inSameTable)($anchorCell, $headCell)) {
                const data = {
                    type: 'cell',
                    anchor: $anchorCell.pos,
                    head: $headCell.pos
                };
                return (0, (0, parcelRequire("gZGBX")).Selection).fromJSON(doc, data);
            }
            return (0, (0, parcelRequire("gZGBX")).Selection).near($headCell, 1);
        }
    }
});
parcelRegister("bQFBc", function(module, exports) {
    $parcel$export(module.exports, "isInTable", ()=>$e501ca8feab95168$export$217a88ad224d1b11);
    $parcel$export(module.exports, "inSameTable", ()=>$e501ca8feab95168$export$debd62b44eb7e281);
    function $e501ca8feab95168$export$217a88ad224d1b11(state) {
        const { $head: $head } = state.selection;
        for(let d = $head.depth; d > 0; d--){
            if ($head.node(d).type.spec.tableRole === 'row') return true;
        }
        return false;
    }
    function $e501ca8feab95168$export$debd62b44eb7e281($a, $b) {
        return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
    }
});
parcelRegister("uOUlv", function(module, exports) {
    $parcel$export(module.exports, "Rect", ()=>$ca500cf7ecedd822$export$c79fc6492f3af13d);
    $parcel$export(module.exports, "TableProblemTypes", ()=>$ca500cf7ecedd822$export$d8cd393a71edca79);
    $parcel$export(module.exports, "TableMap", ()=>$ca500cf7ecedd822$export$493da463fed0a57a);
    let $ca500cf7ecedd822$var$readFromCache, $ca500cf7ecedd822$var$addToCache;
    if (typeof WeakMap !== 'undefined') {
        let cache = new WeakMap();
        $ca500cf7ecedd822$var$readFromCache = (key)=>cache.get(key);
        $ca500cf7ecedd822$var$addToCache = (key, value)=>{
            cache.set(key, value);
            return value;
        };
    } else {
        let cache = [];
        let cacheSize = 10;
        let cachePos = 0;
        $ca500cf7ecedd822$var$readFromCache = (key)=>{
            for(let i = 0; i < cache.length; i += 2){
                if (cache[i] === key) return cache[i + 1];
            }
        };
        $ca500cf7ecedd822$var$addToCache = (key, value)=>{
            if (cachePos === cacheSize) cachePos = 0;
            cache[cachePos++] = key;
            return cache[cachePos++] = value;
        };
    }
    class $ca500cf7ecedd822$export$c79fc6492f3af13d {
        constructor(left, top, right, bottom){
            this.left = left;
            this.top = top;
            this.right = right;
            this.bottom = bottom;
        }
    }
    var $ca500cf7ecedd822$export$d8cd393a71edca79;
    (function(TableProblemTypes) {
        TableProblemTypes["COLLISION"] = "collision";
        TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
        TableProblemTypes["MISSING"] = "missing";
        TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    })($ca500cf7ecedd822$export$d8cd393a71edca79 || ($ca500cf7ecedd822$export$d8cd393a71edca79 = {}));
    const $ca500cf7ecedd822$export$c60fae4049791eae = 140;
    class $ca500cf7ecedd822$export$493da463fed0a57a {
        constructor(width, height, map, problems, mapByColumn, mapByRow){
            this.mapByColumn = [];
            this.mapByRow = [];
            this.width = width;
            this.height = height;
            this.mapByColumn = mapByColumn || [];
            this.mapByRow = mapByRow || [];
            this.map = map;
            this.problems = problems;
        }
        findCell(pos) {
            for(let i = 0; i < this.map.length; i++){
                let curPos = this.map[i];
                if (curPos !== pos) continue;
                let left = i % this.width;
                let top = i / this.width | 0;
                let right = left + 1;
                let bottom = top + 1;
                for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
                for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
                return new $ca500cf7ecedd822$export$c79fc6492f3af13d(left, top, right, bottom);
            }
            throw new RangeError('No cell with offset ' + pos + ' found');
        }
        colCount(pos) {
            for(let i = 0; i < this.map.length; i++){
                if (this.map[i] === pos) return i % this.width;
            }
            throw new RangeError('No cell with offset ' + pos + ' found');
        }
        rowCount(pos) {
            if (this.width <= 0) throw new RangeError('Wrong table width found');
            for(let i = 0; i < this.map.length; i++){
                if (this.map[i] === pos) return Math.floor(i / this.width);
            }
            throw new RangeError('No cell with offset ' + pos + ' found');
        }
        isPosMerged(pos) {
            return this.map.includes(pos, this.map.indexOf(pos) + 1);
        }
        isCellMerged(row, col) {
            return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
        }
        isCellMergedTopLeft(row, col) {
            const pos = this.map[row * this.width + col];
            return (row > 0 && pos === this.map[(row - 1) * this.width + col] || col > 0 && pos === this.map[row * this.width + (col - 1)]);
        }
        isCellMergedBottomRight(row, col) {
            const pos = this.map[row * this.width + col];
            return (row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
        }
        nextCell(pos, axis, dir) {
            let { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
            if (axis === 'horiz') {
                if (dir < 0 ? left === 0 : right === this.width) return null;
                return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
            } else {
                if (dir < 0 ? top === 0 : bottom === this.height) return null;
                return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
            }
        }
        rectBetween(a, b) {
            let { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
            let { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
            return new $ca500cf7ecedd822$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
        }
        cellsInRect(rect) {
            let result = [];
            let seen = {};
            for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
                let index = row * this.width + col;
                let pos = this.map[index];
                if (seen[pos]) continue;
                seen[pos] = true;
                if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
            }
            return result;
        }
        positionAt(row, col, table) {
            for(let i = 0, rowStart = 0;; i++){
                let rowEnd = rowStart + table.child(i).nodeSize;
                if (i === row) {
                    let index = col + row * this.width;
                    let rowEndIndex = (row + 1) * this.width;
                    while(index < rowEndIndex && this.map[index] < rowStart)index++;
                    return index === rowEndIndex ? rowEnd - 1 : this.map[index];
                }
                rowStart = rowEnd;
            }
        }
        getMaxColInRow(pos) {
            let parentRowNode = pos.parent;
            if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
        }
        hasMergedCells() {
            const uniquePositions = new Set(this.map);
            return uniquePositions.size !== this.map.length;
        }
        static get(table) {
            return $ca500cf7ecedd822$var$readFromCache(table) || $ca500cf7ecedd822$var$addToCache(table, $ca500cf7ecedd822$var$computeMap(table));
        }
    }
    function $ca500cf7ecedd822$var$computeMap(table) {
        if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
        let width = $ca500cf7ecedd822$var$findWidth(table);
        let height = table.childCount;
        let map = [], mapPos = 0, problems = null, colWidths = [];
        for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
        for(let row = 0, pos = 0; row < height; row++){
            let rowNode = table.child(row);
            pos++;
            for(let i = 0;; i++){
                while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
                if (i === rowNode.childCount) break;
                let cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
                for(let h = 0; h < rowspan; h++){
                    if (h + row >= height) {
                        (problems || (problems = [])).push({
                            type: "overlong_rowspan",
                            pos: pos,
                            n: rowspan - h
                        });
                        break;
                    }
                    let start = mapPos + h * width;
                    for(let w = 0; w < colspan; w++){
                        if (map[start + w] === 0) map[start + w] = pos;
                        else (problems || (problems = [])).push({
                            type: "collision",
                            row: row,
                            pos: pos,
                            n: colspan - w
                        });
                        let colW = colwidth && colwidth[w];
                        if (colW) {
                            let widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                            if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                                colWidths[widthIndex] = colW;
                                colWidths[widthIndex + 1] = 1;
                            } else if (prev === colW) colWidths[widthIndex + 1]++;
                        }
                    }
                }
                mapPos += colspan;
                pos += cellNode.nodeSize;
            }
            let expectedPos = (row + 1) * width;
            let missing = 0;
            while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
            if (missing) (problems || (problems = [])).push({
                type: "missing",
                row: row,
                n: missing
            });
            pos++;
        }
        let mapByRow = Array(height);
        let mapByColumn = Array(width);
        for(let i = 0; i < map.length; i++){
            const columnIndex = i % width;
            mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
            mapByColumn[columnIndex].push(map[i]);
            const rowIndex = Math.trunc(i / width);
            mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
            mapByRow[rowIndex].push(map[i]);
        }
        let tableMap = new $ca500cf7ecedd822$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
        let badWidths = false;
        for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
        if (colWidths.length > 0 && colWidths.length !== width * 2) {
            for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($ca500cf7ecedd822$export$c60fae4049791eae, 0);
            badWidths = true;
        }
        if (badWidths) $ca500cf7ecedd822$var$findBadColWidths(tableMap, colWidths, table);
        return tableMap;
    }
    function $ca500cf7ecedd822$var$findWidth(table) {
        let width = -1;
        let hasRowSpan = false;
        for(let row = 0; row < table.childCount; row++){
            let rowNode = table.child(row);
            let rowWidth = 0;
            if (hasRowSpan) for(let j = 0; j < row; j++){
                let prevRow = table.child(j);
                for(let i = 0; i < prevRow.childCount; i++){
                    let cell = prevRow.child(i);
                    if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
                }
            }
            for(let i = 0; i < rowNode.childCount; i++){
                let cell = rowNode.child(i);
                rowWidth += cell.attrs.colspan;
                if (cell.attrs.rowspan > 1) hasRowSpan = true;
            }
            if (width === -1) width = rowWidth;
            else if (width !== rowWidth) width = Math.max(width, rowWidth);
        }
        return width;
    }
    function $ca500cf7ecedd822$var$findBadColWidths(map, colWidths, table) {
        if (!map.problems) map.problems = [];
        let seen = {};
        for(let i = 0; i < map.map.length; i++){
            let pos = map.map[i];
            if (seen[pos]) continue;
            seen[pos] = true;
            let node = table.nodeAt(pos), updated = null;
            for(let j = 0; j < node.attrs.colspan; j++){
                let col = (i + j) % map.width, colWidth = colWidths[col * 2];
                if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $ca500cf7ecedd822$var$freshColWidth(node.attrs)))[j] = colWidth;
            }
            if (updated) map.problems.unshift({
                type: "colwidth mismatch",
                pos: pos,
                colwidth: updated
            });
        }
    }
    function $ca500cf7ecedd822$var$freshColWidth(attrs) {
        if (attrs.colwidth) return attrs.colwidth.slice();
        let result = [];
        for(let i = 0; i < attrs.colspan; i++)result.push(0);
        return result;
    }
});
parcelRegister("6hQQ3", function(module, exports) {
    $parcel$export(module.exports, "pointsAtCell", ()=>$6704a47d099ba366$export$3c89e45c7dff9619);
    $parcel$export(module.exports, "cellNear", ()=>$6704a47d099ba366$export$7a283ef453dbae9e);
    $parcel$export(module.exports, "cellAround", ()=>$6704a47d099ba366$export$1f482d92c57578ce);
    $parcel$export(module.exports, "nextCell", ()=>$6704a47d099ba366$export$172699367bb25225);
    var $uOUlv;
    function $6704a47d099ba366$export$3c89e45c7dff9619($pos) {
        return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
    }
    function $6704a47d099ba366$export$7a283ef453dbae9e($pos) {
        for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
            const role = after.type.spec.tableRole;
            if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
        }
        for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
            const role = before.type.spec.tableRole;
            if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
        }
        return null;
    }
    function $6704a47d099ba366$export$1f482d92c57578ce($pos) {
        for(let d = $pos.depth - 1; d > 0; d--){
            if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
        }
        return null;
    }
    function $6704a47d099ba366$export$172699367bb25225($pos, axis, dir) {
        const start = $pos.start(-1);
        const map = (0, (0, parcelRequire("uOUlv")).TableMap).get($pos.node(-1));
        const moved = map.nextCell($pos.pos - start, axis, dir);
        return moved == null ? null : $pos.node(0).resolve(start + moved);
    }
});
parcelRegister("6e6o8", function(module, exports) {
    $parcel$export(module.exports, "removeColSpan", ()=>$44eb8577da1c519b$export$b24d9c3cc95412e0);
    $parcel$export(module.exports, "assertColspan", ()=>$44eb8577da1c519b$export$6fccdf7cee1b5201);
    $parcel$export(module.exports, "addColSpan", ()=>$44eb8577da1c519b$export$147ee78a1321ac36);
    function $44eb8577da1c519b$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
        if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
        const result = {
            ...attrs,
            colspan: attrs.colspan - n
        };
        if (result.colwidth) {
            result.colwidth = result.colwidth.slice();
            result.colwidth.splice(pos, n);
            if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
        }
        return result;
    }
    function $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs) {
        if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
        if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
    }
    function $44eb8577da1c519b$export$147ee78a1321ac36(attrs, pos, n = 1) {
        $44eb8577da1c519b$export$6fccdf7cee1b5201(attrs);
        const result = {
            ...attrs,
            colspan: attrs.colspan + n
        };
        if (result.colwidth) {
            result.colwidth = result.colwidth.slice();
            for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
        }
        return result;
    }
});
parcelRegister("aKDxB", function(module, exports) {
    $parcel$export(module.exports, "getCellSelectionRanges", ()=>$d20b421410b3cfed$export$a60a444208fd5099);
    var $gZGBX;
    var $uOUlv;
    function $d20b421410b3cfed$export$a60a444208fd5099($anchorCell, $headCell) {
        const table = $anchorCell.node(-1);
        const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
        const start = $anchorCell.start(-1);
        const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
        const doc = $anchorCell.node(0);
        const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
        cells.unshift($headCell.pos - start);
        return cells.map((pos)=>{
            const cell = table.nodeAt(pos);
            if (cell === null) throw new Error(`No cell at position ${pos}`);
            const from = pos + start + 1;
            return new (0, (0, parcelRequire("gZGBX")).SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
        });
    }
});
parcelRegister("93WYh", function(module, exports) {
    $parcel$export(module.exports, "insertBlock", ()=>$0e69bbce5359b325$export$f51280337625031);
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    const $0e69bbce5359b325$export$f51280337625031 = (state, nodeType, start, end, attrs)=>{
        const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
        const $pos = state.doc.resolve(start);
        if ($pos.nodeAfter.type !== hardBreak) return null;
        if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $5r0mK.hasParentNodeOfType)(listItem)(state.selection))) return null;
        let tr = state.tr.delete(start, end).split(start);
        let currentNode = tr.doc.nodeAt(start + 1);
        let nodeHasMoreContent = false;
        tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
            if (!nodeHasMoreContent && node.type === hardBreak) {
                nodeHasMoreContent = true;
                tr = tr.split(pos + 1).delete(pos, pos + 1);
            }
        });
        if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
        const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
        let content;
        let depth;
        if (nodeType === blockquote) {
            depth = 3;
            content = [
                paragraph.create({}, currentNode.content)
            ];
        } else {
            depth = 2;
            content = currentNode.content;
        }
        const newNode = nodeType.create(attrs, content);
        tr = tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve(start + 1))).replaceSelectionWith(newNode).setSelection(new (0, (0, parcelRequire("gZGBX")).TextSelection)(tr.doc.resolve(start + depth)));
        return tr;
    };
});
parcelRegister("5Vvw4", function(module, exports) {
    $parcel$export(module.exports, "setSelectionTopLevelBlocks", ()=>$d7ff16845adf5723$export$1b305efb24649ca5);
    $parcel$export(module.exports, "setGapCursorAtPos", ()=>$d7ff16845adf5723$export$44fdd7840a0a11f2);
    var $gZGBX;
    var $hPjvp;
    var $2xQXF;
    const $d7ff16845adf5723$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
        const rect = editorRef.getBoundingClientRect();
        if (event.clientY < rect.top) return {
            position: 0,
            side: (0, (0, parcelRequire("hPjvp")).Side).LEFT
        };
        if (rect.left > 0) {
            const coords = posAtCoords({
                left: rect.left,
                top: event.clientY
            });
            if (coords && coords.inside > -1) {
                const $from = tr.doc.resolve(coords.inside);
                const start = $from.before(1);
                const side = event.clientX < rect.left ? (0, (0, parcelRequire("hPjvp")).Side).LEFT : (0, (0, parcelRequire("hPjvp")).Side).RIGHT;
                let position;
                if (side === (0, (0, parcelRequire("hPjvp")).Side).LEFT) position = start;
                else {
                    const node = tr.doc.nodeAt(start);
                    if (node) position = start + node.nodeSize;
                }
                return {
                    position: position,
                    side: side
                };
            }
        }
        return null;
    };
    const $d7ff16845adf5723$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
        const cursorCoords = $d7ff16845adf5723$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
        if (!cursorCoords) return;
        const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
        if ($pos === null) return;
        const isGapCursorAllowed = cursorCoords.side === (0, (0, parcelRequire("hPjvp")).Side).LEFT ? (0, (0, parcelRequire("2xQXF")).isValidTargetNode)($pos.nodeAfter) : (0, (0, parcelRequire("2xQXF")).isValidTargetNode)($pos.nodeBefore);
        if (isGapCursorAllowed && (0, (0, parcelRequire("hPjvp")).GapCursorSelection).valid($pos)) {
            if (tr.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near($pos));
            else tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($pos, cursorCoords.side));
        } else if (editorFocused === false) {
            const selectionTemp = (0, (0, parcelRequire("gZGBX")).Selection).findFrom($pos, cursorCoords.side === (0, (0, parcelRequire("hPjvp")).Side).LEFT ? 1 : -1, true);
            if (selectionTemp) tr.setSelection(selectionTemp);
        }
    };
    const $d7ff16845adf5723$export$44fdd7840a0a11f2 = (position, side = (0, (0, parcelRequire("hPjvp")).Side).LEFT)=>(state, dispatch)=>{
            if (position > state.doc.content.size) return false;
            const $pos = state.doc.resolve(position);
            if ((0, (0, parcelRequire("hPjvp")).GapCursorSelection).valid($pos)) {
                if (dispatch) dispatch(state.tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($pos, side)));
                return true;
            }
            return false;
        };
});
parcelRegister("hPjvp", function(module, exports) {
    $parcel$export(module.exports, "Side", ()=>$b20495f9cc03905d$export$80a00690bda7f17e);
    $parcel$export(module.exports, "JSON_ID", ()=>$b20495f9cc03905d$export$d9f9f34e18094ffd);
    $parcel$export(module.exports, "GapCursorSelection", ()=>$b20495f9cc03905d$export$7d98c58ca1423246);
    var $kCV8T;
    var $gZGBX;
    var $2xQXF;
    var $b20495f9cc03905d$export$80a00690bda7f17e;
    (function(Side) {
        Side["LEFT"] = "left";
        Side["RIGHT"] = "right";
    })($b20495f9cc03905d$export$80a00690bda7f17e || ($b20495f9cc03905d$export$80a00690bda7f17e = {}));
    const $b20495f9cc03905d$export$d9f9f34e18094ffd = 'gapcursor';
    class $b20495f9cc03905d$export$7d98c58ca1423246 extends (0, (0, parcelRequire("gZGBX")).Selection) {
        constructor($pos, side = "left"){
            super($pos, $pos), this.side = side, this.visible = false;
        }
        static valid($pos) {
            const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
            const targetNode = (0, (0, parcelRequire("2xQXF")).isValidTargetNode)(nodeBefore) ? nodeBefore : (0, (0, parcelRequire("2xQXF")).isValidTargetNode)(nodeAfter) ? nodeAfter : null;
            if (!targetNode || parent.isTextblock) return false;
            const deflt = parent.contentMatchAt($pos.index()).defaultType;
            return deflt && deflt.isTextblock;
        }
        static findFrom($pos, dir, mustMove = false) {
            const side = dir === 1 ? "right" : "left";
            if (!mustMove && $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos)) return new $b20495f9cc03905d$export$7d98c58ca1423246($pos, side);
            let pos = $pos.pos;
            let next = null;
            for(let d = $pos.depth;; d--){
                const parent = $pos.node(d);
                if (side === "right" ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.maybeChild(side === "right" ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d === 0) return null;
                pos += dir;
                const $cur = $pos.doc.resolve(pos);
                if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
            }
            for(;;){
                next = side === "right" ? next.firstChild : next.lastChild;
                if (next === null) break;
                pos += dir;
                const $cur = $pos.doc.resolve(pos);
                if ($b20495f9cc03905d$export$7d98c58ca1423246.valid($cur)) return new $b20495f9cc03905d$export$7d98c58ca1423246($cur, side);
            }
            return null;
        }
        static fromJSON(doc, json) {
            return new $b20495f9cc03905d$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
        }
        map(doc, mapping) {
            const $pos = doc.resolve(mapping.map(this.head));
            return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos, this.side) : (0, (0, parcelRequire("gZGBX")).Selection).near($pos);
        }
        eq(other) {
            return other instanceof $b20495f9cc03905d$export$7d98c58ca1423246 && other.head === this.head;
        }
        content() {
            return (0, (0, parcelRequire("kCV8T")).Slice).empty;
        }
        getBookmark() {
            return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(this.anchor);
        }
        toJSON() {
            return {
                pos: this.head,
                type: $b20495f9cc03905d$export$d9f9f34e18094ffd,
                side: this.side
            };
        }
    }
    (0, (0, parcelRequire("gZGBX")).Selection).jsonID($b20495f9cc03905d$export$d9f9f34e18094ffd, $b20495f9cc03905d$export$7d98c58ca1423246);
    class $b20495f9cc03905d$export$afd2c0d75bc9ce6c {
        constructor(pos){
            this.pos = pos;
        }
        map(mapping) {
            return new $b20495f9cc03905d$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
        }
        resolve(doc) {
            const $pos = doc.resolve(this.pos);
            return $b20495f9cc03905d$export$7d98c58ca1423246.valid($pos) ? new $b20495f9cc03905d$export$7d98c58ca1423246($pos) : (0, (0, parcelRequire("gZGBX")).Selection).near($pos);
        }
    }
});
parcelRegister("2xQXF", function(module, exports) {
    $parcel$export(module.exports, "isValidTargetNode", ()=>$2d159bb5ec0bb7a6$export$b485b49b5e1715ef);
    var $3jyjs;
    const $2d159bb5ec0bb7a6$export$b485b49b5e1715ef = (node)=>{
        return !!node && !(0, (0, parcelRequire("3jyjs")).isIgnored)(node);
    };
});
parcelRegister("3jyjs", function(module, exports) {
    $parcel$export(module.exports, "isIgnored", ()=>$48a4afee3b713705$export$ac3f691269cd6d9b);
    const $48a4afee3b713705$var$IGNORED_NODES = [
        'paragraph',
        'bulletList',
        'orderedList',
        'listItem',
        'taskItem',
        'decisionItem',
        'heading',
        'blockquote',
        'layoutColumn',
        'caption',
        'media',
        'extensionFrame'
    ];
    const $48a4afee3b713705$export$ac3f691269cd6d9b = (node)=>{
        return !!node && $48a4afee3b713705$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
    };
});
parcelRegister("5093p", function(module, exports) {
    $parcel$export(module.exports, "ToolbarWithSizeDetector", ()=>$c2315883ffd82628$export$6bb21858343ac39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $1v3g5;
    var $iHYdz;
    var $gJlZe;
    var $5j6KQ;
    var $9CMqB;
    var $9Bsv7;
    var $9Hbxn;
    var $kXC89;
    const $c2315883ffd82628$var$toolbar = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        position: 'relative',
        [`@media (max-width: ${0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth}px)`]: {
            gridColumn: '1 / 2',
            gridRow: 2,
            width: 'calc(100% - 30px)',
            margin: `0 ${"var(--ds-space-200, 16px)"}`
        }
    });
    const $c2315883ffd82628$export$6bb21858343ac39d = (props)=>{
        const ref = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const [width, setWidth] = (0, ($parcel$interopDefault($5uXOq))).useState(undefined);
        const elementWidth = (0, (0, parcelRequire("9CMqB")).useElementWidth)(ref, {
            skip: typeof width !== 'undefined'
        });
        const defaultToolbarSize = (0, (0, parcelRequire("1v3g5")).isSSR)() && (0, (0, parcelRequire("5j6KQ")).isFullPage)(props.appearance) ? (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL : undefined;
        const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : (0, (0, parcelRequire("9Hbxn")).widthToToolbarSize)(width || elementWidth, props.appearance);
        const toolbarStyle = (0, $5uXOq.useMemo)(()=>{
            const toolbarWidth = (0, (0, parcelRequire("5j6KQ")).isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, (0, parcelRequire("kXC89")).ToolbarSize).S : (0, (0, parcelRequire("kXC89")).ToolbarSize).M;
            const toolbarMinWidth = (0, (0, parcelRequire("9Hbxn")).toolbarSizeToWidth)(toolbarWidth, props.appearance);
            const minWidth = `min-width: ${props.hasMinWidth ? toolbarMinWidth : '254'}px`;
            return [
                $c2315883ffd82628$var$toolbar,
                minWidth
            ];
        }, [
            props.appearance,
            props.hasMinWidth,
            props.twoLineEditorToolbar
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: toolbarStyle
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gJlZe")).WidthObserver), {
            setWidth: setWidth
        }), props.editorView && toolbarSize ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Bsv7")).Toolbar), {
            ...props,
            toolbarSize: toolbarSize
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref
        })));
    };
});
parcelRegister("5j6KQ", function(module, exports) {
    $parcel$export(module.exports, "isFullPage", ()=>$5d5227b0967d81cf$export$2800a15841f40ad7);
    function $5d5227b0967d81cf$export$2800a15841f40ad7(appearance) {
        return appearance === 'full-page' || appearance === 'full-width';
    }
});
parcelRegister("9CMqB", function(module, exports) {
    $parcel$export(module.exports, "useElementWidth", ()=>$e59cb6bcde959be1$export$1217913212f99c7);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    const $e59cb6bcde959be1$export$1217913212f99c7 = (ref, { skip: skip })=>{
        const [elementWidth, setWidth] = (0, ($parcel$interopDefault($5uXOq))).useState(undefined);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!skip && ref.current && !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_prevent_toolbar_width_reflow')) setWidth(Math.round(ref.current.getBoundingClientRect().width));
        }, [
            skip,
            setWidth,
            ref
        ]);
        return elementWidth;
    };
});
parcelRegister("9Bsv7", function(module, exports) {
    $parcel$export(module.exports, "Toolbar", ()=>$8c0c376ea2e85785$export$4c260019440d418f);
    var $5uXOq = parcelRequire("5uXOq");
    var $6bmop;
    var $kXC89;
    const $8c0c376ea2e85785$export$4c260019440d418f = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6bmop")).ToolbarInner), {
            items: props.items,
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            popupsMountPoint: props.popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            toolbarSize: props.toolbarSize,
            isToolbarReducedSpacing: props.toolbarSize < (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL,
            containerElement: props.containerElement
        });
    };
});
parcelRegister("6bmop", function(module, exports) {
    $parcel$export(module.exports, "ToolbarInner", ()=>$80b700b8d431b480$export$7c77e89663c6a665);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ajpes = parcelRequire("ajpes");
    var $1v3g5;
    var $iHYdz;
    const $80b700b8d431b480$var$toolbarComponentsWrapper = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        [`@media (max-width: ${0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth}px)`]: {
            justifyContent: 'space-between'
        }
    });
    class $80b700b8d431b480$export$7c77e89663c6a665 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        shouldComponentUpdate(nextProps) {
            return !(0, ($parcel$interopDefault($ajpes)))(nextProps, this.props);
        }
        render() {
            const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
            if (!items || !items.length) return null;
            if ((0, (0, parcelRequire("1v3g5")).isSSR)()) return null;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $80b700b8d431b480$var$toolbarComponentsWrapper,
                "data-vc": "toolbar-inner"
            }, items.map((component, key)=>{
                const element = component({
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    appearance: appearance,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    disabled: disabled,
                    toolbarSize: toolbarSize,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    containerElement: containerElement,
                    isLastItem: key === items.length - 1,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    wrapperElement: null
                });
                return element && (0, ($parcel$interopDefault($5uXOq))).cloneElement(element, {
                    key: key
                });
            }));
        }
    }
});
parcelRegister("9Hbxn", function(module, exports) {
    $parcel$export(module.exports, "toolbarSizeToWidth", ()=>$5ee4a44c812606dd$export$df8e48f984163082);
    $parcel$export(module.exports, "widthToToolbarSize", ()=>$5ee4a44c812606dd$export$886398ab6922a80f);
    var $VSDnB;
    var $5j6KQ;
    var $kXC89;
    const $5ee4a44c812606dd$var$toolbarSizesFullPageNext = [
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPageNext).XXL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPageNext).XL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPageNext).L,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).L
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPageNext).M,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).M
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPageNext).S,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).S
        }
    ];
    const $5ee4a44c812606dd$var$toolbarSizesFullPage = [
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPage).XXL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPage).XL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPage).L,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).L
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPage).M,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).M
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsFullPage).S,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).S
        }
    ];
    const $5ee4a44c812606dd$var$toolbarSizesNext = [
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsNext).XXL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsNext).XL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsNext).L,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).L
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsNext).M,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).M
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidthsNext).S,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).S
        }
    ];
    const $5ee4a44c812606dd$var$toolbarSizes = [
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).XXL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).XL,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XL
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).L,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).L
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).M,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).M
        },
        {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).S,
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).S
        }
    ];
    const $5ee4a44c812606dd$var$toolbarSizesForAppearance = (appearance)=>(0, (0, parcelRequire("5j6KQ")).isFullPage)(appearance) ? (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesFullPageNext : $5ee4a44c812606dd$var$toolbarSizesFullPage : (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_toolbar_responsive_fixes') ? $5ee4a44c812606dd$var$toolbarSizesNext : $5ee4a44c812606dd$var$toolbarSizes;
    const $5ee4a44c812606dd$export$df8e48f984163082 = (toolbarSize, appearance)=>{
        return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
            width: (0, (0, parcelRequire("kXC89")).ToolbarWidths).S
        }).width;
    };
    const $5ee4a44c812606dd$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
        return ($5ee4a44c812606dd$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
            size: (0, (0, parcelRequire("kXC89")).ToolbarSize).XXXS
        }).size;
    };
});
parcelRegister("fBLMg", function(module, exports) {
    $parcel$export(module.exports, "MainToolbar", ()=>$1a03e2eb8d62ff43$export$f7e5e5a2fbd99270);
    $parcel$export(module.exports, "mainToolbarCustomComponentsSlotStyle", ()=>$1a03e2eb8d62ff43$export$a9324f11be65944);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    const $1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
    const $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle = (isTwoLineEditorToolbar = false)=>(0, (0, parcelRequire("f8Sb3")).css)("position:relative;align-items:center;padding:var(--ds-space-100, 8px) var(--ds-space-100, 8px) 0;display:flex;height:auto;background-color:var(--ds-surface, white);box-shadow:none;padding-left:var(--ds-space-250, 20px);&>div{", isTwoLineEditorToolbar && `
        @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
          flex-direction: column-reverse;
          align-items: end;
          display: flex;
          justify-content: flex-end;
        }

        //make this more explicit for a toolbar
        > *:nth-child(1) {
          @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
            > div:nth-child(2) {
              justify-content: flex-end;
              display: flex;
            }
          }
        }
    `, ";>:first-child:not(style),>style:first-child+*{margin-left:0;}}.block-type-btn{padding-left:0;}", (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && 'span svg { max-width: 100%; }', ";");
    const $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle = (0, (0, parcelRequire("f8Sb3")).css)("position:relative;position:sticky;padding-bottom:var(--ds-space-100, 8px);z-index:", (0, (0, parcelRequire("iHYdz")).akEditorMenuZIndex), ";transition:box-shadow ease-in-out 0.2s;&.show-keyline{box-shadow:0 ", (0, (0, parcelRequire("iHYdz")).akEditorToolbarKeylineHeight), "px 0 0 var(--ds-background-accent-gray-subtlest, #F1F2F4);}");
    const $1a03e2eb8d62ff43$var$StickyToolbar = (props)=>{
        const [top, setTop] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            if (props.externalToolbarRef?.current?.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
            else setTop(props.offsetTop || 0);
        }, [
            props.externalToolbarRef,
            props.offsetTop
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
                $1a03e2eb8d62ff43$var$stickyToolbarWrapperStyle
            ],
            style: {
                top: `${top}px`
            },
            "data-testid": "ak-editor-main-toolbar",
            className: 'show-keyline'
        }, props.children));
    };
    const $1a03e2eb8d62ff43$var$FixedToolbar = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $1a03e2eb8d62ff43$var$mainToolbarWrapperStyle(props.twoLineEditorToolbar),
            "data-testid": "ak-editor-main-toolbar"
        }, props.children);
    const $1a03e2eb8d62ff43$var$getStickyParameters = (configuration)=>{
        const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
        const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
        if (typeof configuration !== 'object') return {
            externalToolbarRef: undefined,
            offsetTop: undefined
        };
        if (isUsingStickyOffset) return {
            offsetTop: configuration.offsetTop
        };
        if (isHTMLElement) return {
            externalToolbarRef: configuration
        };
    };
    const $1a03e2eb8d62ff43$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children })=>{
        if (useStickyToolbar) return (0, (0, parcelRequire("f8Sb3")).jsx)($1a03e2eb8d62ff43$var$StickyToolbar, {
            ...$1a03e2eb8d62ff43$var$getStickyParameters(useStickyToolbar),
            twoLineEditorToolbar: twoLineEditorToolbar
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($1a03e2eb8d62ff43$var$FixedToolbar, {
            twoLineEditorToolbar: twoLineEditorToolbar
        }, children);
    };
    const $1a03e2eb8d62ff43$export$a9324f11be65944 = (isTwoLineEditorToolbar = false)=>(0, (0, parcelRequire("f8Sb3")).css)("display:flex;justify-content:flex-end;align-items:center;flex-grow:1;padding-right:var(--ds-space-250, 20px);>div{display:flex;flex-shrink:0;}", isTwoLineEditorToolbar && `
    @media (max-width: ${$1a03e2eb8d62ff43$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT}px) {
      {
        padding-right: 0;
      }
    }
  `, ";");
});
parcelRegister("kuVsL", function(module, exports) {
    $parcel$export(module.exports, "FullPageEditor", ()=>$4ddf5ad19e1c12c5$export$a15423dd96de66f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gE8f9;
    var $awTmI;
    var $DXgOv;
    var $1YV33;
    var $eMbnU;
    var $2mrTE;
    const $4ddf5ad19e1c12c5$var$useShowKeyline = (contentAreaRef)=>{
        const [showKeyline, setShowKeyline] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!contentAreaRef.current?.contentArea) return;
            const intersection = new IntersectionObserver(([entry])=>{
                setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
            }, {
                root: undefined,
                threshold: (0, (0, parcelRequire("gE8f9")).browser).safari ? 0.98 : 1
            });
            intersection.observe(contentAreaRef.current.contentArea);
            return ()=>{
                intersection.disconnect();
            };
        }, [
            contentAreaRef
        ]);
        return showKeyline;
    };
    const $4ddf5ad19e1c12c5$export$a15423dd96de66f2 = (props)=>{
        const wrapperElementRef = (0, $5uXOq.useMemo)(()=>props.innerRef, [
            props.innerRef
        ]);
        const scrollContentContainerRef = (0, $5uXOq.useRef)(null);
        const showKeyline = $4ddf5ad19e1c12c5$var$useShowKeyline(scrollContentContainerRef);
        const editorAPI = props.editorAPI;
        const { editorViewModeState: editorViewModeState, primaryToolbarState: primaryToolbarState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(editorAPI, [
            'editorViewMode',
            'primaryToolbar'
        ]);
        let primaryToolbarComponents = props.primaryToolbarComponents;
        if (Array.isArray(primaryToolbarState?.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
        const isEditorToolbarHidden = editorViewModeState?.mode === 'view';
        const popupsBoundariesElement = props.popupsBoundariesElement || scrollContentContainerRef?.current?.containerArea || undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("DXgOv")).ContextPanelWidthProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2mrTE")).fullPageEditorWrapper),
            className: "akEditor",
            ref: wrapperElementRef
        }, !isEditorToolbarHidden && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eMbnU")).FullPageToolbar), {
            appearance: props.appearance,
            editorAPI: editorAPI,
            beforeIcon: props.primaryToolbarIconBefore,
            collabEdit: props.collabEdit,
            containerElement: scrollContentContainerRef.current?.scrollContainer ?? null,
            customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
            disabled: !!props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            editorActions: props.editorActions,
            editorDOMElement: props.editorDOMElement,
            editorView: props.editorView,
            eventDispatcher: props.eventDispatcher,
            hasMinWidth: props.enableToolbarMinWidth,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsMountPoint: props.popupsMountPoint,
            popupsScrollableElement: props.popupsScrollableElement,
            primaryToolbarComponents: primaryToolbarComponents,
            providerFactory: props.providerFactory,
            showKeyline: showKeyline,
            featureFlags: props.featureFlags
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1YV33")).FullPageContentArea), {
            editorAPI: editorAPI,
            ref: scrollContentContainerRef,
            appearance: props.appearance,
            contentComponents: props.contentComponents,
            contextPanel: props.contextPanel,
            customContentComponents: props.customContentComponents,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            editorActions: props.editorActions,
            editorDOMElement: props.editorDOMElement,
            editorView: props.editorView,
            eventDispatcher: props.eventDispatcher,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: props.popupsMountPoint,
            popupsScrollableElement: props.popupsScrollableElement,
            providerFactory: props.providerFactory,
            wrapperElement: wrapperElementRef?.current ?? null,
            pluginHooks: props.pluginHooks,
            featureFlags: props.featureFlags,
            isEditorToolbarHidden: isEditorToolbarHidden,
            viewMode: editorViewModeState?.mode
        })));
    };
});
parcelRegister("DXgOv", function(module, exports) {
    $parcel$export(module.exports, "ContextPanelWidthProvider", ()=>$7236ed0b18c0a994$export$ba19517e2c08f4aa);
    $parcel$export(module.exports, "ContextPanelConsumer", ()=>$7236ed0b18c0a994$export$24734d8d7782a3fc);
    var $5uXOq = parcelRequire("5uXOq");
    const $7236ed0b18c0a994$export$c174a7dc96b2afb8 = (0, ($parcel$interopDefault($5uXOq))).createContext({
        width: 0,
        positionedOverEditor: false,
        broadcastWidth: ()=>{},
        broadcastPosition: ()=>{}
    });
    class $7236ed0b18c0a994$export$ba19517e2c08f4aa extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props), this.state = {
                width: 0,
                positionedOverEditor: false
            }, this.broadcastSidebarWidth = (width)=>{
                if (width !== this.state.width) this.setState({
                    width: width
                });
            }, this.broadcastPosition = (positionedOverEditor)=>{
                if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                    positionedOverEditor: positionedOverEditor
                });
            };
        }
        render() {
            const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($7236ed0b18c0a994$export$e38af27e662e9783, {
                value: {
                    width: width,
                    positionedOverEditor: positionedOverEditor,
                    broadcastWidth: this.broadcastSidebarWidth,
                    broadcastPosition: this.broadcastPosition
                }
            }, this.props.children);
        }
    }
    const { Provider: $7236ed0b18c0a994$export$e38af27e662e9783, Consumer: $7236ed0b18c0a994$export$24734d8d7782a3fc } = $7236ed0b18c0a994$export$c174a7dc96b2afb8;
});
parcelRegister("1YV33", function(module, exports) {
    $parcel$export(module.exports, "FullPageContentArea", ()=>$0c715cb9d6308084$export$7db1e8e055ebd208);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g0wej;
    var $8RXs9;
    var $kXnoC;
    var $VSDnB;
    var $cex0T;
    var $hMZun;
    var $iK9VQ;
    var $2mrTE;
    const $0c715cb9d6308084$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
    const $0c715cb9d6308084$export$5c151fe82051a1a7 = 'ak-editor-container';
    const $0c715cb9d6308084$var$Content = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const theme = (0, (0, parcelRequire("g0wej")).u)();
        const fullWidthMode = props.appearance === 'full-width';
        const scrollContainerRef = (0, $5uXOq.useRef)(null);
        const contentAreaRef = (0, $5uXOq.useRef)(null);
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useImperativeHandle)(ref, ()=>({
                get scrollContainer () {
                    return scrollContainerRef.current;
                },
                get contentArea () {
                    return contentAreaRef.current;
                },
                get containerArea () {
                    return containerRef.current;
                }
            }), []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("2mrTE")).contentArea),
                props.isEditorToolbarHidden && (0, (0, parcelRequire("2mrTE")).contentAreaHeightNoToolbar)
            ],
            "data-testid": $0c715cb9d6308084$export$81adcdb8b9fca1f7,
            ref: containerRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_breakout_use_css') ? (0, (0, parcelRequire("2mrTE")).contentAreaWrapper) : (0, (0, parcelRequire("2mrTE")).contentAreaWrapperNoStyles),
            "data-testid": $0c715cb9d6308084$export$5c151fe82051a1a7,
            "data-editor-container": (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_breakout_use_css') ? 'true' : 'false'
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2mrTE")).ScrollContainer), {
            className: "fabric-editor-popup-scroll-parent",
            featureFlags: props.featureFlags,
            ref: scrollContainerRef,
            viewMode: props?.viewMode
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cex0T")).default), {
            editorView: props.editorView,
            editorDisabled: props.disabled
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2mrTE")).editorContentAreaStyle)({
                fullWidthMode: fullWidthMode,
                layoutMaxWidth: theme.layoutMaxWidth
            }),
            role: "region",
            "aria-label": props.intl.formatMessage((0, (0, parcelRequire("kXnoC")).messages).editableContentLabel),
            ref: contentAreaRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2mrTE")).editorContentGutterStyle)(),
            className: [
                'ak-editor-content-area',
                'appearance-full-page',
                fullWidthMode ? 'fabric-editor--full-width-mode' : ''
            ].join(' '),
            ref: contentAreaRef
        }, !!props.customContentComponents && 'before' in props.customContentComponents ? props.customContentComponents.before : props.customContentComponents, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iK9VQ")).default), {
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            items: props.contentComponents,
            pluginHooks: props.pluginHooks,
            contentArea: contentAreaRef.current ?? undefined,
            popupsMountPoint: props.popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: !!props.disabled,
            containerElement: scrollContainerRef.current,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            wrapperElement: props.wrapperElement
        }), props.editorDOMElement, !!props.customContentComponents && 'after' in props.customContentComponents ? props.customContentComponents.after : null))))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("2mrTE")).sidebarArea)
        }, props.contextPanel || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hMZun")).ContextPanel), {
            editorAPI: props.editorAPI,
            visible: false
        })));
    });
    const $0c715cb9d6308084$export$7db1e8e055ebd208 = (0, (0, parcelRequire("8RXs9")).default)($0c715cb9d6308084$var$Content, {
        forwardRef: true
    });
});
parcelRegister("hMZun", function(module, exports) {
    $parcel$export(module.exports, "ContextPanel", ()=>$38c4a2495ec84d05$export$c174a7dc96b2afb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ahdj0;
    var $awTmI;
    var $DXgOv;
    var $iHYdz;
    function $38c4a2495ec84d05$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $38c4a2495ec84d05$var$ANIM_SPEED_MS = 500;
    const $38c4a2495ec84d05$var$panelHidden = {
        name: "k2uqvh",
        styles: "width:0"
    };
    const $38c4a2495ec84d05$export$21f42ab9b6679f44 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `${(0, (0, parcelRequire("iHYdz")).akEditorContextPanelWidth)}px`,
        height: '100%',
        transition: `width ${$38c4a2495ec84d05$var$ANIM_SPEED_MS}ms ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`,
        overflow: 'hidden',
        boxShadow: `inset 2px 0 0 0 ${"var(--ds-border, #091E4224)"}`
    });
    const $38c4a2495ec84d05$export$a7db06668cad9adb = (0, (0, parcelRequire("f8Sb3")).css)({
        transition: `width 600ms ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`,
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0px`,
        width: `${(0, (0, parcelRequire("iHYdz")).akEditorContextPanelWidth)}px`,
        height: '100%',
        overflowY: 'auto'
    });
    class $38c4a2495ec84d05$export$2aac880ec6fe2608 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static getDerivedStateFromProps(props, state) {
            if (props.pluginContent !== state.currentPluginContent) return {
                ...state,
                currentPluginContent: props.pluginContent
            };
            return null;
        }
        unsetPluginContent() {
            this.setState({
                currentPluginContent: undefined
            });
        }
        componentDidMount() {
            this.setState({
                mounted: true
            });
        }
        render() {
            const width = (0, (0, parcelRequire("iHYdz")).akEditorContextPanelWidth);
            const userVisible = !!this.props.visible;
            const visible = userVisible || !!this.state.currentPluginContent;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("DXgOv")).ContextPanelConsumer), null, ({ broadcastWidth: broadcastWidth })=>{
                const contextPanelWidth = visible ? width : 0;
                broadcastWidth(contextPanelWidth);
                return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    css: [
                        $38c4a2495ec84d05$export$21f42ab9b6679f44,
                        !visible && $38c4a2495ec84d05$var$panelHidden
                    ],
                    "data-testid": "context-panel-panel",
                    "aria-labelledby": "context-panel-title",
                    role: "dialog"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                    "data-testid": "context-panel-content",
                    css: [
                        $38c4a2495ec84d05$export$a7db06668cad9adb,
                        !visible && $38c4a2495ec84d05$var$panelHidden
                    ]
                }, this.showPluginContent() || this.showProvidedContent(userVisible)));
            });
        }
        constructor(...args){
            super(...args), this.state = {
                mounted: false,
                currentPluginContent: undefined
            }, this.focusEditor = ()=>{
                const { editorAPI: editorAPI } = this.props;
                editorAPI?.core?.actions.focus({
                    scrollIntoView: false
                });
            }, this.showPluginContent = ()=>{
                const { pluginContent: pluginContent } = this.props;
                const { currentPluginContent: currentPluginContent } = this.state;
                if (!currentPluginContent) return;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ahdj0")).default), {
                    timeout: this.state.mounted ? $38c4a2495ec84d05$var$ANIM_SPEED_MS : 0,
                    in: !!pluginContent,
                    mountOnEnter: true,
                    unmountOnExit: true,
                    onExited: ()=>this.unsetPluginContent()
                }, currentPluginContent);
            }, this.showProvidedContent = (isVisible)=>{
                const { children: children } = this.props;
                if (!children) return;
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ahdj0")).default), {
                    timeout: this.state.mounted ? $38c4a2495ec84d05$var$ANIM_SPEED_MS : 0,
                    in: isVisible,
                    mountOnEnter: true,
                    unmountOnExit: true,
                    onExiting: this.focusEditor
                }, children);
            };
        }
    }
    function $38c4a2495ec84d05$export$c174a7dc96b2afb8(props) {
        const { contextPanelState: contextPanelState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(props.editorAPI, [
            'contextPanel'
        ]);
        const firstContent = contextPanelState && contextPanelState?.contents?.find(Boolean);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($38c4a2495ec84d05$export$2aac880ec6fe2608, {
            ...props,
            editorAPI: props.editorAPI,
            pluginContent: firstContent
        });
    }
});
parcelRegister("2mrTE", function(module, exports) {
    $parcel$export(module.exports, "fullPageEditorWrapper", ()=>$2ea8babea89be1bc$export$ffbc962f588258d5);
    $parcel$export(module.exports, "ScrollContainer", ()=>$2ea8babea89be1bc$export$2631a3ab3cdd158d);
    $parcel$export(module.exports, "contentArea", ()=>$2ea8babea89be1bc$export$26bdc8f90c1f72f6);
    $parcel$export(module.exports, "contentAreaWrapper", ()=>$2ea8babea89be1bc$export$484266f72d7ebbab);
    $parcel$export(module.exports, "contentAreaWrapperNoStyles", ()=>$2ea8babea89be1bc$export$aa4cbb8822476ad0);
    $parcel$export(module.exports, "contentAreaHeightNoToolbar", ()=>$2ea8babea89be1bc$export$848a137fb02bc242);
    $parcel$export(module.exports, "sidebarArea", ()=>$2ea8babea89be1bc$export$a838a71bfc839c1d);
    $parcel$export(module.exports, "editorContentAreaStyle", ()=>$2ea8babea89be1bc$export$fc070501506e6d7a);
    $parcel$export(module.exports, "editorContentGutterStyle", ()=>$2ea8babea89be1bc$export$95d13e1170f2991);
    var $f8Sb3;
    var $8gSD8;
    var $43mJF;
    parcelRequire("7uhma");
    var $cipm3;
    parcelRequire("eTjGD");
    var $1v4Xe;
    var $iHYdz;
    var $VSDnB;
    var $jZLtJ;
    function $2ea8babea89be1bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2ea8babea89be1bc$var$SWOOP_ANIMATION = `0.5s ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`;
    const $2ea8babea89be1bc$var$getTotalPadding = ()=>(0, (0, parcelRequire("iHYdz")).akEditorGutterPaddingDynamic)() * 2;
    const $2ea8babea89be1bc$export$ffbc962f588258d5 = {
        name: "cui2x",
        styles: "min-width:340px;height:100%;display:flex;flex-direction:column;box-sizing:border-box"
    };
    const $2ea8babea89be1bc$var$scrollStyles = (0, (0, parcelRequire("f8Sb3")).css)("flex-grow:1;height:100%;overflow-y:scroll;position:relative;display:flex;flex-direction:column;scroll-behavior:smooth;", (0, $4038285048829feb$export$b2380b18b089518f));
    const $2ea8babea89be1bc$export$2631a3ab3cdd158d = (0, (0, parcelRequire("jZLtJ")).createEditorContentStyle)($2ea8babea89be1bc$var$scrollStyles);
    $2ea8babea89be1bc$export$2631a3ab3cdd158d.displayName = 'ScrollContainer';
    const $2ea8babea89be1bc$export$26bdc8f90c1f72f6 = ()=>{
        const editorToolbarHeight = (0, (0, parcelRequire("iHYdz")).FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: 'row',
            height: `calc(100% - ${editorToolbarHeight})`,
            boxSizing: 'border-box',
            margin: 0,
            padding: 0,
            transition: `padding 0ms ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`
        });
    };
    const $2ea8babea89be1bc$export$484266f72d7ebbab = {
        name: "znpqtq",
        styles: "width:100%;container-type:inline-size;container-name:editor-area;contain:layout style inline-size"
    };
    const $2ea8babea89be1bc$export$aa4cbb8822476ad0 = {
        name: "49aokf",
        styles: "display:contents"
    };
    const $2ea8babea89be1bc$export$848a137fb02bc242 = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $2ea8babea89be1bc$export$a838a71bfc839c1d = {
        name: "x7r12n",
        styles: "height:100%;box-sizing:border-box;align-self:flex-end"
    };
    const $2ea8babea89be1bc$export$14d7990cf2a76cb6 = {
        name: "1ffp76g",
        styles: ".fabric-editor--full-width-mode{.pm-table-container, .code-block, .extension-container{display:none;}.multiBodiedExtension--container{display:none;}}"
    };
    const $2ea8babea89be1bc$var$editorContentAreaContainerStyle = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '.fabric-editor--full-width-mode': {
                '.code-block, .extension-container, .multiBodiedExtension--container': {
                    maxWidth: `calc(100% - ${(0, (0, parcelRequire("1v4Xe")).tableMarginFullWidthMode) * 2}px)`
                },
                '.extension-container.inline': {
                    maxWidth: '100%'
                },
                'td .extension-container.inline': {
                    maxWidth: 'inherit'
                },
                '[data-layout-section]': {
                    maxWidth: `calc(100% + ${(0, (0, parcelRequire("iHYdz")).akLayoutGutterOffset) * 2}px)`
                }
            }
        });
    const $2ea8babea89be1bc$export$fc070501506e6d7a = ({ layoutMaxWidth: layoutMaxWidth, fullWidthMode: fullWidthMode })=>[
            $2ea8babea89be1bc$var$editorContentArea,
            !fullWidthMode && $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith(layoutMaxWidth),
            $2ea8babea89be1bc$var$editorContentAreaContainerStyle()
        ];
    const $2ea8babea89be1bc$var$editorContentAreaWithLayoutWith = (layoutMaxWidth)=>(0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `${layoutMaxWidth + $2ea8babea89be1bc$var$getTotalPadding()}px`
        });
    const $2ea8babea89be1bc$var$editorContentArea = (0, (0, parcelRequire("f8Sb3")).css)({
        lineHeight: '24px',
        paddingTop: "var(--ds-space-600, 48px)",
        paddingBottom: "var(--ds-space-600, 48px)",
        height: 'calc( 100% - 105px )',
        width: '100%',
        margin: 'auto',
        flexDirection: 'column',
        flexGrow: 1,
        maxWidth: `${(0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth) + $2ea8babea89be1bc$var$getTotalPadding()}px`,
        transition: `max-width ${$2ea8babea89be1bc$var$SWOOP_ANIMATION}`,
        '& .ProseMirror': {
            flexGrow: 1,
            boxSizing: 'border-box',
            '& > *': {
                clear: 'both'
            },
            [`> p, > ul, > ol:not(${0, (0, parcelRequire("43mJF")).taskListSelector}):not(${0, (0, parcelRequire("8gSD8")).decisionListSelector}), > h1, > h2, > h3, > h4, > h5, > h6`]: {
                clear: 'none'
            },
            '> p:last-child': {
                marginBottom: "var(--ds-space-300, 24px)"
            }
        }
    }, (0, (0, parcelRequire("cipm3")).tableFullPageEditorStyles), ".fabric-editor--full-width-mode{.fabric-editor-breakout-mark, .extension-container.block, .pm-table-container{width:100% !important;}.fabric-editor-breakout-mark{margin-left:unset !important;transform:none !important;}}");
    const $2ea8babea89be1bc$export$95d13e1170f2991 = ()=>{
        const padding = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_core_increase_full_page_guttering') ? `0 52px` : `0 ${"var(--ds-space-400, 32px)"}`;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            boxSizing: 'border-box',
            padding: padding
        });
    };
});
parcelRegister("eMbnU", function(module, exports) {
    $parcel$export(module.exports, "FullPageToolbar", ()=>$53d9c5fa01d5f1ad$export$26f3f0e30f9545b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $kXnoC;
    var $DXgOv;
    var $kdDpx;
    var $5093p;
    var $5k24a;
    var $eWGrU;
    const $53d9c5fa01d5f1ad$export$477aaffea178bc4e = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $5uXOq.useState)(false);
        const { editorAPI: editorAPI } = props;
        const twoLineEditorToolbar = !!props.customPrimaryToolbarComponents;
        const nonCustomToolbar = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("eWGrU")).nonCustomToolbarWrapperStyle)
        }, props.beforeIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("eWGrU")).mainToolbarIconBeforeStyle)
        }, props.beforeIcon), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5093p")).ToolbarWithSizeDetector), {
            editorView: props.editorView,
            editorActions: props.editorActions,
            eventDispatcher: props.eventDispatcher,
            providerFactory: props.providerFactory,
            appearance: props.appearance,
            items: props.primaryToolbarComponents,
            popupsMountPoint: props.popupsMountPoint,
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsScrollableElement: props.popupsScrollableElement,
            disabled: props.disabled,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            containerElement: props.containerElement,
            hasMinWidth: props.hasMinWidth,
            twoLineEditorToolbar: twoLineEditorToolbar
        }));
        const customToolbar = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("eWGrU")).customToolbarWrapperStyle)
        }, !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5k24a")).BeforePrimaryToolbarWrapper), {
            beforePrimaryToolbarComponents: props.customPrimaryToolbarComponents?.before
        }) : null, editorAPI?.findReplace && twoLineEditorToolbar ? editorAPI?.findReplace.actions.getToolbarButton({
            popupsBoundariesElement: props.popupsBoundariesElement,
            popupsMountPoint: props.popupsMountPoint,
            popupsScrollableElement: props.popupsScrollableElement,
            editorView: props.editorView,
            containerElement: props.containerElement,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
        }) : null, !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents);
        (0, $5uXOq.useEffect)(()=>{
            if (twoLineEditorToolbar) {
                const updateOnResize = ()=>{
                    setShouldSplitToolbar(window.innerWidth <= (0, (0, parcelRequire("eWGrU")).MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
                };
                window.addEventListener('resize', updateOnResize);
                updateOnResize();
                return ()=>window.removeEventListener('resize', updateOnResize);
            }
        });
        const isShortcutToFocusToolbar = (event)=>{
            return event.altKey && (event.key === 'F9' || event.keyCode === 120);
        };
        const handleEscape = (event)=>{
            if (!props.editorView?.hasFocus()) props.editorView?.focus();
            event.preventDefault();
            event.stopPropagation();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("DXgOv")).ContextPanelConsumer), null, ({ width: contextPanelWidth })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kdDpx")).ToolbarArrowKeyNavigationProvider), {
                editorView: props.editorView,
                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                intl: props.intl
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("eWGrU")).mainToolbarStyle)(props.showKeyline || contextPanelWidth > 0, twoLineEditorToolbar),
                "data-testid": "ak-editor-main-toolbar"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("eWGrU")).mainToolbarFirstChildStyle)(twoLineEditorToolbar),
                role: "toolbar",
                "aria-label": props.intl.formatMessage((0, (0, parcelRequire("kXnoC")).messages).toolbarLabel)
            }, shouldSplitToolbar ? customToolbar : nonCustomToolbar), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("eWGrU")).mainToolbarSecondChildStyle)(twoLineEditorToolbar),
                "data-testid": 'avatar-group-outside-plugin',
                role: "region",
                "aria-label": props.intl.formatMessage((0, (0, parcelRequire("kXnoC")).messages).pageActionsLabel)
            }, shouldSplitToolbar ? nonCustomToolbar : customToolbar))));
    });
    const $53d9c5fa01d5f1ad$export$26f3f0e30f9545b4 = (0, (0, parcelRequire("8RXs9")).default)($53d9c5fa01d5f1ad$export$477aaffea178bc4e);
});
parcelRegister("5k24a", function(module, exports) {
    $parcel$export(module.exports, "BeforePrimaryToolbarWrapper", ()=>$b5e0689e02fdf117$export$b41281e8d2acb8ab);
    var $f8Sb3;
    function $b5e0689e02fdf117$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles = {
        name: "ep0vx",
        styles: "display:flex;flex-grow:1;justify-content:flex-end;align-items:center"
    };
    const $b5e0689e02fdf117$export$b41281e8d2acb8ab = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b5e0689e02fdf117$var$beforePrimaryToolbarPluginWrapperStyles,
            "data-testid": 'before-primary-toolbar-components-plugin'
        }, props.beforePrimaryToolbarComponents);
});
parcelRegister("eWGrU", function(module, exports) {
    $parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", ()=>$ea400237c23c8b06$export$f71dca5c73c8a7);
    $parcel$export(module.exports, "mainToolbarStyle", ()=>$ea400237c23c8b06$export$149462a46fbcc8c8);
    $parcel$export(module.exports, "mainToolbarIconBeforeStyle", ()=>$ea400237c23c8b06$export$8ae7cf5e67319342);
    $parcel$export(module.exports, "mainToolbarFirstChildStyle", ()=>$ea400237c23c8b06$export$53973a689c603614);
    $parcel$export(module.exports, "mainToolbarSecondChildStyle", ()=>$ea400237c23c8b06$export$b0242e3e235d994c);
    $parcel$export(module.exports, "nonCustomToolbarWrapperStyle", ()=>$ea400237c23c8b06$export$a41238ec40a49ad0);
    $parcel$export(module.exports, "customToolbarWrapperStyle", ()=>$ea400237c23c8b06$export$9c5878561f814452);
    var $f8Sb3;
    var $iHYdz;
    var $VSDnB;
    function $ea400237c23c8b06$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ea400237c23c8b06$export$f71dca5c73c8a7 = 868;
    const $ea400237c23c8b06$var$mainToolbarWithKeyline = (0, (0, parcelRequire("f8Sb3")).css)({
        boxShadow: `${"var(--ds-shadow-overflow, 0px 0px 8px #091E4228, 0px 0px 1px #091E421e)"}`
    });
    const $ea400237c23c8b06$var$mainToolbarTwoLineStyle = ()=>{
        const editorToolbarHeight = (0, (0, parcelRequire("iHYdz")).FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
                flexWrap: 'wrap',
                height: `calc(${editorToolbarHeight} * 2)`
            }
        });
    };
    const $ea400237c23c8b06$var$flexibleIconSize = {
        name: "1ymvw5b",
        styles: "& span svg{max-width:100%;}"
    };
    const $ea400237c23c8b06$var$mainToolbar = ()=>{
        const editorToolbarHeight = (0, (0, parcelRequire("iHYdz")).FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            position: 'relative',
            alignItems: 'center',
            boxShadow: 'none',
            borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
            transition: `box-shadow 200ms ${(0, (0, parcelRequire("iHYdz")).akEditorSwoopCubicBezier)}`,
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorFloatingDialogZIndex),
            display: 'flex',
            height: editorToolbarHeight,
            flexShrink: 0,
            backgroundColor: "var(--ds-surface, white)",
            '& object': {
                height: '0 !important'
            },
            [`@media (max-width: ${0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth}px)`]: {
                display: 'grid',
                height: `calc(${editorToolbarHeight} * 2)`
            }
        }, (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') && $ea400237c23c8b06$var$flexibleIconSize);
    };
    const $ea400237c23c8b06$export$149462a46fbcc8c8 = (showKeyline, twoLineEditorToolbar)=>[
            $ea400237c23c8b06$var$mainToolbar,
            showKeyline && $ea400237c23c8b06$var$mainToolbarWithKeyline,
            twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarTwoLineStyle
        ];
    const $ea400237c23c8b06$export$8ae7cf5e67319342 = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: "var(--ds-space-200, 16px)",
        height: "var(--ds-space-400, 32px)",
        width: "var(--ds-space-400, 32px)",
        [`@media (max-width: ${0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth}px)`]: {
            gridColumn: 1,
            gridRow: 1
        }
    });
    const $ea400237c23c8b06$var$mainToolbarFirstChild = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexGrow: 1,
        [`@media (max-width: ${0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth}px)`]: {
            gridColumn: 1,
            gridRow: 1
        }
    });
    const $ea400237c23c8b06$var$mainToolbarFirstChildTowLine = ()=>{
        const editorToolbarHeight = (0, (0, parcelRequire("iHYdz")).FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
                flex: '1 1 100%',
                height: editorToolbarHeight,
                justifyContent: 'flex-end',
                minWidth: 'fit-content'
            }
        });
    };
    const $ea400237c23c8b06$export$53973a689c603614 = (twoLineEditorToolbar)=>[
            $ea400237c23c8b06$var$mainToolbarFirstChild,
            twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarFirstChildTowLine
        ];
    const $ea400237c23c8b06$var$mainToolbarSecondChild = {
        name: "g8017n",
        styles: "min-width:fit-content"
    };
    const $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine = ()=>{
        const editorToolbarHeight = (0, (0, parcelRequire("iHYdz")).FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
        return (0, (0, parcelRequire("f8Sb3")).css)({
            [`@media (max-width: ${$ea400237c23c8b06$export$f71dca5c73c8a7}px)`]: {
                display: 'flex',
                flexGrow: 1,
                flex: '1 1 100%',
                margin: 'auto',
                height: editorToolbarHeight,
                minWidth: 0
            }
        });
    };
    const $ea400237c23c8b06$export$b0242e3e235d994c = (twoLineEditorToolbar)=>[
            $ea400237c23c8b06$var$mainToolbarSecondChild,
            twoLineEditorToolbar && $ea400237c23c8b06$var$mainToolbarSecondChildTwoLine
        ];
    const $ea400237c23c8b06$export$a41238ec40a49ad0 = {
        name: "t6ix9q",
        styles: "align-items:center;display:flex;flex-grow:1"
    };
    const $ea400237c23c8b06$export$9c5878561f814452 = {
        name: "1vr7vmn",
        styles: "align-items:center;display:flex"
    };
});
parcelRegister("1QYAr", function(module, exports) {
    $parcel$export(module.exports, "CoreEditor", ()=>$74a39720d38c82c6$export$be7eaacc86ce4514);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ajpes = parcelRequire("ajpes");
    var $bXrHm = parcelRequire("bXrHm");
    var $1PVpv = parcelRequire("1PVpv");
    var $2NMNM;
    var $gkwXh;
    var $ctLRZ;
    var $iN9lO;
    var $4NUlu;
    var $1rAg3;
    var $9lx6U;
    var $ankW9;
    var $5cNeT;
    var $8iwfw;
    var $cjRyP;
    var $dACrN;
    var $1d04s;
    var $jRRkB;
    var $2JODI;
    function $74a39720d38c82c6$var$Editor(passedProps) {
        const propsRef = (0, $5uXOq.useRef)(passedProps);
        const props = (0, (0, parcelRequire("1d04s")).default)(passedProps);
        (0, $5uXOq.useMemo)(()=>{
            propsRef.current = props;
        }, [
            props
        ]);
        const editorContext = (0, (0, parcelRequire("ankW9")).useEditorContext)();
        const editorActionsPlaceholderInstance = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("1rAg3")).default)(), []);
        const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const handleAnalyticsEvent = (0, $5uXOq.useCallback)((data)=>{
            (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(createAnalyticsEvent)(data);
        }, [
            createAnalyticsEvent
        ]);
        const getFeatureFlagsFromRef = (0, $5uXOq.useCallback)(()=>{
            return {
                ...(0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(propsRef.current.featureFlags),
                useNativeCollabPlugin: Boolean(typeof propsRef.current.collabEdit?.useNativePlugin === 'boolean' ? !!propsRef.current.collabEdit?.useNativePlugin : false)
            };
        }, []);
        const onEditorCreated = (0, $5uXOq.useCallback)((instance)=>{
            const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
            editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
            if (onEditorReady) {
                (0, (0, parcelRequire("iN9lO")).startMeasure)((0, (0, parcelRequire("5cNeT")).default).ON_EDITOR_READY_CALLBACK);
                onEditorReady(editorActions);
                (0, (0, parcelRequire("iN9lO")).stopMeasure)((0, (0, parcelRequire("5cNeT")).default).ON_EDITOR_READY_CALLBACK, (0, (0, parcelRequire("2JODI")).default)((0, (0, parcelRequire("gkwXh")).ACTION).ON_EDITOR_READY_CALLBACK, {
                    contextIdentifierProvider: contextIdentifierProvider,
                    featureFlags: featureFlags
                }, createAnalyticsEvent));
            }
        }, [
            editorActions,
            createAnalyticsEvent,
            getFeatureFlagsFromRef,
            propsRef
        ]);
        const onEditorDestroyed = (0, $5uXOq.useCallback)((_instance)=>{
            const { onDestroy: onDestroy } = propsRef.current;
            editorActions._privateUnregisterEditor();
            if (onDestroy) onDestroy();
        }, [
            editorActions,
            propsRef
        ]);
        (0, (0, parcelRequire("dACrN")).default)(props, createAnalyticsEvent);
        const providerFactory = (0, (0, parcelRequire("jRRkB")).default)(props, editorActions, createAnalyticsEvent);
        const { onSave: onSaveFromProps } = props;
        const handleSave = (0, $5uXOq.useCallback)((view)=>{
            if (onSaveFromProps) onSaveFromProps(view);
        }, [
            onSaveFromProps
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cjRyP")).EditorInternal), {
            props: props,
            handleAnalyticsEvent: handleAnalyticsEvent,
            createAnalyticsEvent: createAnalyticsEvent,
            preset: props.preset,
            handleSave: handleSave,
            editorActions: editorActions,
            onEditorCreated: onEditorCreated,
            onEditorDestroyed: onEditorDestroyed,
            providerFactory: providerFactory,
            AppearanceComponent: props.AppearanceComponent
        });
    }
    const $74a39720d38c82c6$var$useMemoEditorFeatureFlags = (featureFlags)=>{
        const ffRef = (0, $5uXOq.useRef)(featureFlags);
        if (!(0, ($parcel$interopDefault($ajpes)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
        return ffRef.current;
    };
    function $74a39720d38c82c6$export$be7eaacc86ce4514(props) {
        const editorSessionId = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($bXrHm)))());
        const data = (0, $5uXOq.useMemo)(()=>{
            return {
                packageName: (0, (0, parcelRequire("8iwfw")).name),
                packageVersion: (0, (0, parcelRequire("8iwfw")).version),
                componentName: 'editorCore',
                appearance: (0, (0, parcelRequire("4NUlu")).getAnalyticsAppearance)(props.appearance),
                editorSessionId: editorSessionId.current
            };
        }, [
            props.appearance
        ]);
        const memodEditorFeatureFlags = $74a39720d38c82c6$var$useMemoEditorFeatureFlags(props.featureFlags);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $1PVpv.FabricEditorAnalyticsContext), {
            data: data
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($74a39720d38c82c6$var$Editor, {
            ...props,
            featureFlags: memodEditorFeatureFlags
        }));
    }
    $74a39720d38c82c6$export$be7eaacc86ce4514.propTypes = {
        minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
            if (minHeight && appearance && ![
                'comment',
                'chromeless'
            ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
            return null;
        }
    };
    var $74a39720d38c82c6$export$2e2bcd8739ae039 = $74a39720d38c82c6$export$be7eaacc86ce4514;
});
parcelRegister("ctLRZ", function(module, exports) {
    $parcel$export(module.exports, "editorAnalyticsChannel", ()=>$c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6);
    $parcel$export(module.exports, "fireAnalyticsEvent", ()=>$c6d39b0cc0e8a4ed$export$c7d191551feb734);
    var $dWAZk = parcelRequire("dWAZk");
    var $3C0Tq;
    const $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;
    const $c6d39b0cc0e8a4ed$export$c7d191551feb734 = (createAnalyticsEvent)=>({ payload: payload, channel: channel = $c6d39b0cc0e8a4ed$export$1467dbbb3bb418c6 })=>{
            if (!createAnalyticsEvent) return;
            const queue = (0, (0, parcelRequire("3C0Tq")).AnalyticsQueue).get();
            queue.schedule(()=>createAnalyticsEvent(payload)?.fire(channel));
        };
});
parcelRegister("3C0Tq", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsQueue", ()=>$db724abd22ea4847$export$b44c4ba8fe19bbc7);
    var $8QpSo;
    class $db724abd22ea4847$export$b44c4ba8fe19bbc7 {
        static{
            this.get = (0, (0, parcelRequire("8QpSo")).default)(()=>new $db724abd22ea4847$export$b44c4ba8fe19bbc7());
        }
        constructor(){
            this.tasks = [];
            this.running = false;
        }
        request(fn) {
            if (window.requestIdleCallback) window.requestIdleCallback(fn);
            else {
                const start = performance.now();
                setTimeout(()=>{
                    fn({
                        didTimeout: false,
                        timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                    });
                }, 0);
            }
        }
        pending() {
            if (typeof window.navigator?.scheduling?.isInputPending === 'function') return window.navigator?.scheduling?.isInputPending() === true;
            return false;
        }
        process() {
            if (this.running) return;
            this.running = true;
            this.request((deadline)=>{
                while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                    const task = this.tasks.shift();
                    if (task) task();
                }
                this.running = false;
                if (this.tasks.length > 0) this.process();
            });
        }
        schedule(task) {
            this.tasks.push(task);
            this.process();
        }
    }
});
parcelRegister("1rAg3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbd26123fc5f51a3$export$2e2bcd8739ae039);
    var $gkwXh;
    var $agxMF;
    var $4NUlu;
    var $kCV8T;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $lY6DM;
    var $QWvft;
    var $9V8N3;
    var $b1dHu;
    var $pvAs1;
    var $lIbnY;
    var $9jeYG;
    const $fbd26123fc5f51a3$var$fakePluginKey = {
        key: 'nativeCollabProviderPlugin$',
        getState: (state)=>{
            return state['nativeCollabProviderPlugin$'];
        }
    };
    class $fbd26123fc5f51a3$export$2e2bcd8739ae039 {
        static from(view, eventDispatcher, transformer) {
            const editorActions = new $fbd26123fc5f51a3$export$2e2bcd8739ae039();
            editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
            return editorActions;
        }
        _privateGetEditorView() {
            return this.editorView;
        }
        _privateGetEventDispatcher() {
            return this.eventDispatcher;
        }
        getFeatureFlags() {
            return {};
        }
        _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
            this.contentTransformer = contentTransformer;
            this.eventDispatcher = eventDispatcher;
            this.getFeatureFlags = getFeatureFlags;
            if (!this.editorView && editorView) {
                this.editorView = editorView;
                this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
            } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
            if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
        }
        _privateUnregisterEditor() {
            this.editorView = undefined;
            this.contentTransformer = undefined;
            this.contentEncode = undefined;
            this.eventDispatcher = undefined;
            this.getFeatureFlags = ()=>({});
        }
        _privateSubscribe(cb) {
            if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
            this.listeners.push(cb);
        }
        _privateUnsubscribe(cb) {
            this.listeners = this.listeners.filter((c)=>c !== cb);
        }
        focus() {
            if (!this.editorView || this.editorView.hasFocus()) return false;
            this.editorView.focus();
            this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
            return true;
        }
        blur() {
            if (!this.editorView || !this.editorView.hasFocus()) return false;
            this.editorView.dom.blur();
            return true;
        }
        clear() {
            if (!this.editorView) return false;
            const editorView = this.editorView;
            const { state: state } = editorView;
            const tr = editorView.state.tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
            editorView.dispatch(tr);
            return true;
        }
        async getValue() {
            const { editorView: editorView } = this;
            if (!editorView) return;
            const doc = await (0, (0, parcelRequire("QWvft")).getEditorValueWithMedia)(editorView);
            const json = (0, (0, parcelRequire("9jeYG")).toJSON)(doc);
            if (!this.contentEncode) return json;
            const nodeSanitized = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(this.editorView.state.schema, json);
            try {
                return this.contentEncode(nodeSanitized);
            } catch (e) {
                this.dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).DOCUMENT_PROCESSING_ERROR,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                    }
                });
                throw e;
            }
        }
        getNodeByLocalId(id) {
            if (this.editorView?.state) {
                const nodes = (0, (0, parcelRequire("lIbnY")).findNodePosByLocalIds)(this.editorView?.state, [
                    id
                ]);
                const node = nodes.length >= 1 ? nodes[0] : undefined;
                return node?.node;
            }
        }
        getNodeByFragmentLocalId(id) {
            if (this.editorView?.state) {
                let nodes = (0, (0, parcelRequire("b1dHu")).findNodePosByFragmentLocalIds)(this.editorView?.state, [
                    id
                ]);
                return nodes.length > 0 ? nodes[0].node : undefined;
            }
        }
        getSelectedNode() {
            if (this.editorView?.state?.selection) {
                const { selection: selection } = this.editorView.state;
                if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return selection.node;
                return (0, $5r0mK.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)?.node;
            }
        }
        isDocumentEmpty() {
            if (!this.editorView) return true;
            return (0, (0, parcelRequire("pvAs1")).isEmptyDocument)(this.editorView.state.doc);
        }
        replaceDocument(rawValue, shouldScrollToBottom = true, shouldAddToHistory = true) {
            (0, (0, parcelRequire("9V8N3")).default)('EditorActions.replaceDocument', {
                shouldAddToHistory: shouldAddToHistory
            }, [
                {
                    property: 'shouldAddToHistory',
                    description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                    type: 'removed'
                }
            ]);
            if (!this.editorView || rawValue === undefined || rawValue === null) return false;
            if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
                doc: rawValue,
                shouldScrollToBottom: shouldScrollToBottom
            });
            return true;
        }
        replaceSelection(rawValue, tryToReplace) {
            if (!this.editorView) return false;
            const { state: state } = this.editorView;
            if (!rawValue) {
                const tr = state.tr.deleteSelection().scrollIntoView();
                this.editorView.dispatch(tr);
                return true;
            }
            const { schema: schema } = state;
            const content = Array.isArray(rawValue) ? (0, (0, parcelRequire("agxMF")).processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, (0, parcelRequire("agxMF")).processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
            if (!content) return false;
            this.editorView.dispatch((0, $5r0mK.safeInsert)(content, undefined, tryToReplace)(state.tr).scrollIntoView());
            return true;
        }
        appendText(text) {
            if (!this.editorView || !text) return false;
            const { state: state } = this.editorView;
            const lastChild = state.doc.lastChild;
            if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
            const tr = state.tr.insertText(text).scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        constructor(){
            this.listeners = [];
            this.dispatchAnalyticsEvent = (payload)=>{
                if (this.eventDispatcher) {
                    const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(this.eventDispatcher);
                    dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                        payload: payload
                    });
                }
            };
            this.getResolvedEditorState = async ()=>{
                const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
                if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
                if (!useNativeCollabPlugin) {
                    const editorValue = await this.getValue();
                    if (!editorValue) throw new Error('editorValue is undefined');
                    return {
                        content: editorValue,
                        title: null,
                        stepVersion: -1
                    };
                }
                const editorView = this.editorView;
                await (0, (0, parcelRequire("QWvft")).getEditorValueWithMedia)(editorView);
                const collabEditState = $fbd26123fc5f51a3$var$fakePluginKey.getState(editorView.state);
                return collabEditState?.getFinalAcknowledgedState();
            };
        }
    }
});
parcelRegister("agxMF", function(module, exports) {
    $parcel$export(module.exports, "processRawValueWithoutValidation", ()=>$06227a323d5b9cf2$export$cafe23194e65f591);
    $parcel$export(module.exports, "processRawValue", ()=>$06227a323d5b9cf2$export$f1a0a61081c3ed62);
    $parcel$export(module.exports, "processRawFragmentValue", ()=>$06227a323d5b9cf2$export$89b7989c347e6a7b);
    var $6pVhb;
    var $jzlPz;
    var $KiRx2;
    var $4FBRr;
    var $aSk3Q;
    var $g7mYL;
    var $dADdx;
    var $kCV8T;
    var $VSDnB;
    var $gkwXh;
    var $17TS1;
    var $d54NZ;
    var $4IuOY;
    const $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
        try {
            const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("aSk3Q")).transformNestedTablesIncomingDocument)(node);
            if (isTransformed && dispatchAnalyticsEvent) {
                dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).NESTED_TABLE_TRANSFORMED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                return {
                    transformedAdf: transformedAdf,
                    isTransformed: isTransformed
                };
            }
        } catch (e) {
            console.error('Failed to transform one or more nested tables in the document');
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            });
        }
        return {
            transformedAdf: node,
            isTransformed: false
        };
    };
    function $06227a323d5b9cf2$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
        if (!value) return;
        let node;
        if (typeof value === 'string') try {
            node = JSON.parse(value);
        } catch (e) {
            console.error(`Error processing value: ${value} isn't a valid JSON`);
            return;
        }
        else node = value;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) {
            const { transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
            return (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, transformedAdf);
        } else return (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, node);
    }
    function $06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
        if (!value) return;
        let node;
        if (typeof value === 'string') try {
            if (contentTransformer) {
                const doc = contentTransformer.parse(value);
                node = doc.toJSON();
            } else node = JSON.parse(value);
        } catch (e) {
            console.error(`Error processing value: ${value} isn't a valid JSON`);
            return;
        }
        else node = value;
        if (Array.isArray(node)) {
            console.error(`Error processing value: ${node} is an array, but it must be an object.`);
            return;
        }
        try {
            if (node.type === 'doc') {
                if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                    type: 'paragraph',
                    content: []
                });
                if (!node.version) node.version = 1;
            }
            if (contentTransformer) return (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, node);
            let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("4FBRr")).transformMediaLinkMarks)(node);
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).MEDIA_LINK_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("dADdx")).transformTextLinkCodeMarks)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).TEXT_LINK_MARK_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            let discardedMarks = [];
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, (0, parcelRequire("6pVhb")).transformDedupeMarks)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
                }
            });
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("g7mYL")).transformNodesMissingContent)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("jzlPz")).transformIndentationMarks)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INDENTATION_MARKS_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, (0, parcelRequire("KiRx2")).transformInvalidMediaContent)(transformedAdf));
            if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_use_nested_table_pm_nodes')) ({ transformedAdf: transformedAdf } = $06227a323d5b9cf2$var$transformNestedTablesWithAnalytics(transformedAdf, dispatchAnalyticsEvent));
            const entity = (0, (0, parcelRequire("4IuOY")).validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
            let newEntity = $06227a323d5b9cf2$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
            const parsedDoc = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, newEntity);
            try {
                parsedDoc.check();
            } catch (err) {
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                throw err;
            }
            if (dispatchAnalyticsEvent) (0, (0, parcelRequire("d54NZ")).findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
            return parsedDoc;
        } catch (e) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
            console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
            if ($06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(e)) throw e;
            return;
        }
    }
    function $06227a323d5b9cf2$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
        if (!value) return;
        const adfEntities = value.map((item)=>$06227a323d5b9cf2$export$f1a0a61081c3ed62(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
        if (adfEntities.length === 0) return;
        return (0, (0, parcelRequire("kCV8T")).Fragment).from(adfEntities);
    }
    function $06227a323d5b9cf2$var$isProseMirrorSchemaCheckError(error) {
        return error instanceof RangeError && (!!error.message.match(/^Invalid collection of marks for node/) || !!error.message.match(/^Invalid content for node/));
    }
    const $06227a323d5b9cf2$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
        if (sanitizePrivateContent && providerFactory) return (0, (0, parcelRequire("17TS1")).sanitizeNodeForPrivacy)(entity, providerFactory);
        return entity;
    };
});
parcelRegister("6pVhb", function(module, exports) {
    $parcel$export(module.exports, "transformDedupeMarks", ()=>$4ff23f41b9c1a5b1$export$af4e387303482581);
    var $l1C1k;
    const $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed = new Set([
        'strong',
        'underline',
        'textColor',
        'link',
        'em',
        'subsup',
        'strike',
        'backgroundColor'
    ]);
    const $4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks = (node)=>{
        const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>$4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
        if (!markTypes?.length) return false;
        return new Set(markTypes).size !== markTypes.length;
    };
    const $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
        const quota = new Map();
        const annotationsQuota = new Map();
        const discardedMarks = [];
        $4ff23f41b9c1a5b1$var$markDuplicatesDisallowed.forEach((mark)=>{
            quota.set(mark, false);
        });
        if (!node.marks) return {
            discardedMarks: discardedMarks
        };
        let dedupedMarks = node.marks.filter((mark)=>{
            const markType = mark.type;
            if (markType === 'annotation') {
                const id = mark.attrs?.id;
                if (annotationsQuota.has(id)) {
                    discardedMarks.push(mark);
                    return false;
                } else {
                    annotationsQuota.set(id, true);
                    return true;
                }
            }
            if (quota.has(markType)) {
                if (!quota.get(markType)) {
                    quota.set(markType, true);
                    return true;
                } else {
                    discardedMarks.push(mark);
                    return false;
                }
            }
            return true;
        });
        return {
            node: {
                ...node,
                marks: dedupedMarks
            },
            discardedMarks: discardedMarks
        };
    };
    const $4ff23f41b9c1a5b1$export$af4e387303482581 = (adf)=>{
        let isTransformed = false;
        let discardedMarks = [];
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            text: (node)=>{
                if ($4ff23f41b9c1a5b1$var$maybeHasDisallowedDuplicateMarks(node)) {
                    const result = $4ff23f41b9c1a5b1$var$maybeRemoveDisallowedDuplicateMarks(node);
                    const resultDiscardedMarks = result.discardedMarks;
                    if (resultDiscardedMarks.length) {
                        discardedMarks.push(...resultDiscardedMarks);
                        isTransformed = true;
                        return result.node;
                    }
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed,
            discardedMarks: discardedMarks
        };
    };
});
parcelRegister("jzlPz", function(module, exports) {
    $parcel$export(module.exports, "transformIndentationMarks", ()=>$8dff8a40c1912f4c$export$c06e4b521519af22);
    var $l1C1k;
    const $8dff8a40c1912f4c$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
    const $8dff8a40c1912f4c$var$removeIndentationFromHeadings = (node)=>{
        return {
            ...node,
            content: node.content?.map((childNode)=>{
                if (childNode?.type === 'heading') return {
                    ...childNode,
                    marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
                };
                return childNode;
            })
        };
    };
    const $8dff8a40c1912f4c$export$c06e4b521519af22 = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            tableCell: (node)=>{
                if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                    isTransformed = true;
                    return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
                }
            },
            tableHeader: (node)=>{
                if ($8dff8a40c1912f4c$var$hasChildHeadingWithIndentation(node)) {
                    isTransformed = true;
                    return $8dff8a40c1912f4c$var$removeIndentationFromHeadings(node);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("KiRx2", function(module, exports) {
    $parcel$export(module.exports, "transformInvalidMediaContent", ()=>$fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf);
    var $l1C1k;
    var $ebjue;
    const $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
        let childrenTypes = {};
        nodeContent.forEach((childNode, index)=>{
            if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
            if (!childrenTypes[childNode.type]) {
                childrenTypes[childNode.type] = 1;
                return;
            }
            childrenTypes[childNode.type]++;
        });
        return childrenTypes;
    };
    const $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes = (type, content, predicate)=>{
        let maxIterations = 10;
        let childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
            type
        ])[type];
        let firstPredicateNodeIndex = content.findIndex(predicate);
        while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
            content.splice(firstPredicateNodeIndex, 1);
            firstPredicateNodeIndex = content.findIndex(predicate);
            childrenTypeCounts = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(content, [
                type
            ])[type];
        }
    };
    const $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
        if (!node.content) return;
        const content = [
            ...node.content
        ];
        Object.keys(allowedTypes).forEach((type)=>{
            $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, (0, parcelRequire("ebjue")).isEmpty)(node));
            $fc6f50f3ab0dfe3c$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
        });
        return {
            ...node,
            content: content
        };
    };
    const $fc6f50f3ab0dfe3c$export$1c8c16d74c7a63bf = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            mediaSingle: (node)=>{
                if (!node?.content?.length) return;
                const disallowedDuplicateTypes = [
                    'media',
                    'caption'
                ];
                const childrenTypes = $fc6f50f3ab0dfe3c$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
                if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                    isTransformed = true;
                    return $fc6f50f3ab0dfe3c$var$deduplicateMediaSingleChildren(node, childrenTypes);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("g7mYL", function(module, exports) {
    $parcel$export(module.exports, "transformNodesMissingContent", ()=>$4a8cb4828f326aed$export$652814b83c30d251);
    var $l1C1k;
    var $6DeCT;
    var $50sdg;
    var $jVGjh;
    var $geBph;
    var $ebjue;
    const $4a8cb4828f326aed$var$getMaxColumnsCountForTable = (tableNode)=>{
        let colsInRow = 1;
        tableNode.content?.forEach((childNode)=>{
            if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
        });
        return colsInRow;
    };
    const $4a8cb4828f326aed$var$createValidEmptyContent = (node)=>{
        switch(node.type){
            case 'tableCell':
                return [
                    (0, (0, parcelRequire("50sdg")).paragraph)()
                ];
            default:
                return [];
        }
    };
    const $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
            if ((0, (0, parcelRequire("ebjue")).isEmpty)(node)) {
                reportTransform();
                return {
                    ...node,
                    content: $4a8cb4828f326aed$var$createValidEmptyContent(node)
                };
            }
        };
    const $4a8cb4828f326aed$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
    const $4a8cb4828f326aed$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
    const $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
        return parentListNode.content?.map((childNode)=>{
            if (childNode) switch(childNode.type){
                case 'listItem':
                    if ((0, (0, parcelRequire("ebjue")).isEmpty)(childNode)) {
                        const result = (0, (0, parcelRequire("6DeCT")).listItem)([
                            (0, (0, parcelRequire("50sdg")).paragraph)()
                        ]);
                        return result;
                    }
                    return childNode;
                case 'text':
                    return (0, (0, parcelRequire("6DeCT")).listItem)([
                        (0, (0, parcelRequire("50sdg")).paragraph)(childNode)
                    ]);
                default:
                    return (0, (0, parcelRequire("6DeCT")).listItem)([
                        childNode
                    ]);
            }
            return childNode;
        });
    };
    const $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
            if ($4a8cb4828f326aed$var$hasNonListItemChildren(node) || $4a8cb4828f326aed$var$hasEmptyListItemChildren(node)) {
                reportTransform();
                return {
                    ...node,
                    content: $4a8cb4828f326aed$var$tryCreateValidListItemWrappedChildren(node)
                };
            }
        };
    const $4a8cb4828f326aed$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
    const $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
        const maxColsCount = $4a8cb4828f326aed$var$getMaxColumnsCountForTable(parentTableNode);
        return parentTableNode.content?.map((childNode)=>{
            if (childNode) switch(childNode.type){
                case 'text':
                    return (0, (0, parcelRequire("geBph")).tableRow)([
                        (0, (0, parcelRequire("jVGjh")).tableCell)({})((0, (0, parcelRequire("50sdg")).paragraph)(childNode)),
                        ...new Array(maxColsCount - 1).fill((0, (0, parcelRequire("jVGjh")).tableCell)({})((0, (0, parcelRequire("50sdg")).paragraph)()))
                    ]);
                case 'tableCell':
                    return (0, (0, parcelRequire("geBph")).tableRow)([
                        childNode
                    ]);
                case 'tableRow':
                    if ((0, (0, parcelRequire("ebjue")).isEmpty)(childNode)) return (0, (0, parcelRequire("geBph")).tableRow)([
                        ...new Array(maxColsCount).fill((0, (0, parcelRequire("jVGjh")).tableCell)({})((0, (0, parcelRequire("50sdg")).paragraph)()))
                    ]);
                    return childNode;
                default:
                    return childNode;
            }
            return childNode;
        });
    };
    const $4a8cb4828f326aed$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
    const $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
            if ($4a8cb4828f326aed$var$hasEmptyTableRowChildren(node) || $4a8cb4828f326aed$var$hasNonTableRowChildren(node)) {
                reportTransform();
                return {
                    ...node,
                    content: $4a8cb4828f326aed$var$tryCreateValidTableRowWrappedChildren(node)
                };
            }
        };
    const $4a8cb4828f326aed$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
            if ((0, (0, parcelRequire("ebjue")).isEmpty)(node)) {
                reportTransform();
                return false;
            }
        };
    const $4a8cb4828f326aed$export$652814b83c30d251 = (adf)=>{
        let isTransformed = false;
        const reportTransform = ()=>{
            isTransformed = true;
        };
        let transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            tableCell: $4a8cb4828f326aed$var$fixIfTableCellInvalidEmpty(reportTransform)
        });
        transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(transformedAdf || adf, {
            mediaSingle: $4a8cb4828f326aed$var$removeMediaSingleWithNoContent(reportTransform)
        });
        transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(transformedAdf || adf, {
            bulletList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
            orderedList: $4a8cb4828f326aed$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
            table: $4a8cb4828f326aed$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("6DeCT", function(module, exports) {
    $parcel$export(module.exports, "listItem", ()=>$a2cd5bff5444dafb$export$76c7e83ecc9cdf05);
    const $a2cd5bff5444dafb$export$76c7e83ecc9cdf05 = (content)=>({
            type: 'listItem',
            content: content
        });
});
parcelRegister("jVGjh", function(module, exports) {
    $parcel$export(module.exports, "tableCell", ()=>$45a16984030f79a3$export$e1e720e5f4603e6a);
    const $45a16984030f79a3$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
                type: 'tableCell',
                attrs: attrs,
                content: content
            });
});
parcelRegister("geBph", function(module, exports) {
    $parcel$export(module.exports, "tableRow", ()=>$3b3a7f8c343ad0af$export$ce666bf02318c957);
    const $3b3a7f8c343ad0af$export$ce666bf02318c957 = (content)=>({
            type: 'tableRow',
            content: content
        });
});
parcelRegister("dADdx", function(module, exports) {
    $parcel$export(module.exports, "transformTextLinkCodeMarks", ()=>$1d4506554e727afe$export$3d531d2daf0e8a14);
    var $l1C1k;
    const $1d4506554e727afe$var$hasLinkAndCodeMarks = (node)=>{
        const marks = node.marks?.map((mark)=>mark.type);
        return marks?.includes('link') && marks?.includes('code');
    };
    const $1d4506554e727afe$var$removeCodeMarks = (node)=>{
        if (node.marks) return {
            ...node,
            marks: node.marks.filter((mark)=>mark.type !== 'code')
        };
        return node;
    };
    const $1d4506554e727afe$export$3d531d2daf0e8a14 = (adf)=>{
        let isTransformed = false;
        const transformedAdf = (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            text: (node)=>{
                if ($1d4506554e727afe$var$hasLinkAndCodeMarks(node)) {
                    isTransformed = true;
                    return $1d4506554e727afe$var$removeCodeMarks(node);
                }
            }
        });
        return {
            transformedAdf: transformedAdf,
            isTransformed: isTransformed
        };
    };
});
parcelRegister("17TS1", function(module, exports) {
    $parcel$export(module.exports, "sanitizeNodeForPrivacy", ()=>$149b214359f7ee68$export$8a32f625580e0a06);
    var $l1C1k;
    var $3mm6g;
    function $149b214359f7ee68$export$8a32f625580e0a06(json, providerFactory) {
        const mentionNames = new Map();
        let hasCacheableMentions = false;
        const sanitizedJSON = (0, (0, parcelRequire("l1C1k")).traverse)(json, {
            mention: (node)=>{
                if (node.attrs && node.attrs.text) {
                    hasCacheableMentions = true;
                    const text = node.attrs.text;
                    const name = text.startsWith('@') ? text.slice(1) : text;
                    mentionNames.set(node.attrs.id, name);
                }
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        text: ''
                    }
                };
            }
        });
        if (hasCacheableMentions && providerFactory) {
            const handler = (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>{
                    if ((0, (0, parcelRequire("3mm6g")).isResolvingMentionProvider)(provider)) {
                        mentionNames.forEach((name, id)=>{
                            provider.cacheMentionName(id, name);
                        });
                        mentionNames.clear();
                        providerFactory.unsubscribe('mentionProvider', handler);
                    }
                });
            };
            providerFactory.subscribe('mentionProvider', handler);
        }
        return sanitizedJSON;
    }
});
parcelRegister("lY6DM", function(module, exports) {
    $parcel$export(module.exports, "EventDispatcher", ()=>$468232df5c6ea546$export$ec8b666c5fe2c75a);
    $parcel$export(module.exports, "createDispatch", ()=>$468232df5c6ea546$export$f57f9cc7ce57b7d0);
    class $468232df5c6ea546$export$ec8b666c5fe2c75a {
        on(event, cb) {
            if (!this.listeners[event]) this.listeners[event] = new Set();
            this.listeners[event].add(cb);
        }
        has(event, cb) {
            if (!this.listeners[event]) return false;
            return this.listeners[event].has(cb);
        }
        off(event, cb) {
            if (!this.listeners[event]) return;
            if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
        }
        emit(event, data) {
            if (!this.listeners[event]) return;
            this.listeners[event].forEach((cb)=>cb(data));
        }
        destroy() {
            this.listeners = {};
        }
        constructor(){
            this.listeners = {};
        }
    }
    function $468232df5c6ea546$var$getEventFromEventName(eventName) {
        return typeof eventName === 'string' ? eventName : eventName.key;
    }
    function $468232df5c6ea546$export$f57f9cc7ce57b7d0(eventDispatcher) {
        return (eventName, data)=>{
            if (!eventName) throw new Error('event name is required!');
            eventDispatcher.emit($468232df5c6ea546$var$getEventFromEventName(eventName), data);
        };
    }
});
parcelRegister("QWvft", function(module, exports) {
    $parcel$export(module.exports, "getEditorValueWithMedia", ()=>$ef540e8b72c50d6c$export$99c45752ffdaa598);
    const $ef540e8b72c50d6c$var$mediaPluginKey = {
        key: 'mediaPlugin$',
        getState: (state)=>{
            return state['mediaPlugin$'];
        }
    };
    async function $ef540e8b72c50d6c$export$99c45752ffdaa598(editorView) {
        const mediaPluginState = editorView.state && $ef540e8b72c50d6c$var$mediaPluginKey.getState(editorView.state);
        if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
        return editorView.state.doc;
    }
});
parcelRegister("9V8N3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a285f68f22f6664d$export$2e2bcd8739ae039);
    function $a285f68f22f6664d$var$deprecationWarnings(className, props, deprecations) {
        return;
    }
    var $a285f68f22f6664d$export$2e2bcd8739ae039 = $a285f68f22f6664d$var$deprecationWarnings;
});
parcelRegister("b1dHu", function(module, exports) {
    $parcel$export(module.exports, "findNodePosByFragmentLocalIds", ()=>$d7150c63727d169a$export$1dc8bea8646ac811);
    const $d7150c63727d169a$export$1dc8bea8646ac811 = (state, ids)=>{
        if (ids.length === 0) return [];
        const nodes = [];
        const localIdSet = new Set(ids);
        state.doc.descendants((node, pos)=>{
            const fragmentLocalIdList = node.marks?.filter((m)=>m.type.name === 'fragment').map((m)=>m.attrs?.localId).filter((id)=>id && localIdSet.has(id));
            if (fragmentLocalIdList.length > 0) nodes.push({
                node: node,
                pos: pos
            });
            return localIdSet.size !== nodes.length;
        });
        return nodes;
    };
});
parcelRegister("pvAs1", function(module, exports) {
    $parcel$export(module.exports, "isEmptyDocument", ()=>$2b33f98e049d60d3$export$2da47a16c0b6bcb);
    function $2b33f98e049d60d3$export$b648602b09795358(node) {
        return !!node && node.type.name === 'paragraph' && !node.childCount;
    }
    function $2b33f98e049d60d3$export$2da47a16c0b6bcb(node) {
        const nodeChild = node.content.firstChild;
        if (node.childCount !== 1 || !nodeChild) return false;
        return $2b33f98e049d60d3$export$b648602b09795358(nodeChild);
    }
});
parcelRegister("lIbnY", function(module, exports) {
    $parcel$export(module.exports, "findNodePosByLocalIds", ()=>$59fd907a3078acac$export$947fc26275418e36);
    const $59fd907a3078acac$export$947fc26275418e36 = (state, ids, option = {})=>{
        if (ids.length === 0) return [];
        const nodes = [];
        const localIdSet = new Set(ids);
        if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
            node: state.doc,
            pos: 0
        });
        state.doc.descendants((node, pos)=>{
            if (localIdSet.has(node.attrs?.localId)) nodes.push({
                node: node,
                pos: pos
            });
            return localIdSet.size !== nodes.length;
        });
        return nodes;
    };
});
parcelRegister("9jeYG", function(module, exports) {
    $parcel$export(module.exports, "toJSON", ()=>$75ea2b648e87890e$export$54fd2c36b5cc6731);
    var $hYNZx;
    const $75ea2b648e87890e$var$transformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    function $75ea2b648e87890e$export$54fd2c36b5cc6731(node) {
        return $75ea2b648e87890e$var$transformer.encode(node);
    }
});
parcelRegister("9lx6U", function(module, exports) {
    $parcel$export(module.exports, "createFeatureFlagsFromProps", ()=>$e2b7bdbd9e154790$export$63102b0cbe181144);
    var $4zXba;
    function $e2b7bdbd9e154790$var$verifyJSON(json) {
        try {
            return JSON.parse(json);
        } catch (e) {
            return undefined;
        }
    }
    function $e2b7bdbd9e154790$var$getSpellCheck(featureFlags) {
        if (!!featureFlags?.['disableSpellcheckByBrowser']) return typeof featureFlags?.['disableSpellcheckByBrowser'] === 'object' ? featureFlags?.['disableSpellcheckByBrowser'] : typeof featureFlags?.['disableSpellcheckByBrowser'] === 'string' ? $e2b7bdbd9e154790$var$verifyJSON(featureFlags?.['disableSpellcheckByBrowser']) : undefined;
        if (!!featureFlags?.['disable-spellcheck-by-browser']) return typeof featureFlags?.['disable-spellcheck-by-browser'] === 'object' ? featureFlags?.['disable-spellcheck-by-browser'] : typeof featureFlags?.['disable-spellcheck-by-browser'] === 'string' ? $e2b7bdbd9e154790$var$verifyJSON(featureFlags?.['disable-spellcheck-by-browser']) : undefined;
        return undefined;
    }
    function $e2b7bdbd9e154790$export$63102b0cbe181144(featureFlags) {
        const normalizedFeatureFlags = (0, (0, parcelRequire("4zXba")).normalizeFeatureFlags)(featureFlags);
        return {
            ...normalizedFeatureFlags,
            catchAllTracking: false,
            showAvatarGroupAsPlugin: Boolean(typeof featureFlags?.showAvatarGroupAsPlugin === 'boolean' ? !!featureFlags?.showAvatarGroupAsPlugin : false),
            errorBoundaryDocStructure: Boolean(typeof featureFlags?.useErrorBoundaryDocStructure === 'boolean' ? !!featureFlags?.useErrorBoundaryDocStructure : false),
            synchronyErrorDocStructure: Boolean(typeof featureFlags?.synchronyErrorDocStructure === 'boolean' ? !!featureFlags?.synchronyErrorDocStructure : false),
            enableViewUpdateSubscription: Boolean(typeof featureFlags?.enableViewUpdateSubscription === 'boolean' ? !!featureFlags?.enableViewUpdateSubscription : false),
            collabAvatarScroll: Boolean(typeof featureFlags?.collabAvatarScroll === 'boolean' ? !!featureFlags?.collabAvatarScroll : false),
            twoLineEditorToolbar: Boolean(typeof featureFlags?.twoLineEditorToolbar === 'boolean' ? !!featureFlags?.twoLineEditorToolbar : false),
            disableSpellcheckByBrowser: $e2b7bdbd9e154790$var$getSpellCheck(featureFlags)
        };
    }
});
parcelRegister("ankW9", function(module, exports) {
    $parcel$export(module.exports, "useEditorContext", ()=>$0216bf80b2f4530e$export$b119c82498f162a5);
    $parcel$export(module.exports, "default", ()=>$0216bf80b2f4530e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $8v2ZL;
    var $VSDnB;
    var $1rAg3;
    const $0216bf80b2f4530e$export$b119c82498f162a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("8v2ZL")).EditorContext));
    class $0216bf80b2f4530e$export$797df872f5526664 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
        }
        render() {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) return (0, ($parcel$interopDefault($5uXOq))).createElement($0216bf80b2f4530e$var$LegacyEditorContextNew, this.props, this.props.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0216bf80b2f4530e$export$2e2bcd8739ae039, this.props, this.props.children);
        }
    }
    function $0216bf80b2f4530e$var$LegacyEditorContextNew({ children: children, editorActions: editorActions }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8v2ZL")).EditorContext).Provider, {
            value: {
                editorActions: editorActions ?? new (0, (0, parcelRequire("1rAg3")).default)()
            }
        }, children);
    }
    class $0216bf80b2f4530e$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.childContextTypes = {
                editorActions: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        constructor(props){
            super(props);
            this.editorActions = props.editorActions || new (0, (0, parcelRequire("1rAg3")).default)();
        }
        getChildContext() {
            return {
                editorActions: this.editorActions
            };
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8v2ZL")).EditorContext).Provider, {
                value: this.getChildContext()
            }, this.props.children);
        }
    }
});
parcelRegister("8v2ZL", function(module, exports) {
    $parcel$export(module.exports, "EditorContext", ()=>$1ceb886f8ac7152d$export$27b8dd149e32f6c7);
    var $5uXOq = parcelRequire("5uXOq");
    const $1ceb886f8ac7152d$export$27b8dd149e32f6c7 = (0, ($parcel$interopDefault($5uXOq))).createContext({});
});
parcelRegister("8iwfw", function(module, exports) {
    $parcel$export(module.exports, "name", ()=>$060d6f70d3cebea6$export$a8ff84c12d48cfa6);
    $parcel$export(module.exports, "version", ()=>$060d6f70d3cebea6$export$83d89fbfd8236492);
    const $060d6f70d3cebea6$export$a8ff84c12d48cfa6 = "platform-pkg";
    const $060d6f70d3cebea6$export$83d89fbfd8236492 = "0.0.0-use.local";
});
parcelRegister("cjRyP", function(module, exports) {
    $parcel$export(module.exports, "EditorInternal", ()=>$71ed6365bae516ba$export$2617c0dabe49c335);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gkwXh;
    var $gJcSd;
    var $VSDnB;
    var $ax7J7;
    var $9lx6U;
    var $fbZFm;
    var $7mkEO;
    var $kflkc;
    var $ankW9;
    var $fggrl;
    var $g5Huu;
    var $j0Vvw;
    var $geOTC;
    var $8pML4;
    function $71ed6365bae516ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $71ed6365bae516ba$var$editorContainerStyles = {
        name: "zxsb69",
        styles: "position:relative;width:100%;height:100%"
    };
    const $71ed6365bae516ba$export$2617c0dabe49c335 = (0, $5uXOq.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
        const overriddenEditorProps = {
            ...props,
            onSave: props.onSave ? handleSave : undefined,
            analyticsHandler: undefined
        };
        const featureFlags = (0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(props.featureFlags);
        const renderTrackingEnabled = !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_disable_rerender_tracking_jira');
        const useShallow = false;
        const [portalProviderAPI, PortalRenderer] = (0, (0, parcelRequire("gJcSd")).usePortalProvider)();
        const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, (0, parcelRequire("gJcSd")).usePortalProvider)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, renderTrackingEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("g5Huu")).RenderTracking), {
            componentProps: props,
            action: (0, (0, parcelRequire("gkwXh")).ACTION).RE_RENDERED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
            handleAnalyticsEvent: handleAnalyticsEvent,
            propsToIgnore: [
                'defaultValue'
            ],
            useShallow: useShallow
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ax7J7")).default), {
            errorTracking: true,
            createAnalyticsEvent: createAnalyticsEvent,
            contextIdentifierProvider: props.contextIdentifierProvider,
            featureFlags: featureFlags
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $71ed6365bae516ba$var$editorContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ankW9")).default), {
            editorActions: editorActions
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kflkc")).ContextAdapter), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fggrl")).IntlProviderIfMissingWrapper), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react_editor_view_react_18') ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7mkEO")).default), {
            editorProps: overriddenEditorProps,
            createAnalyticsEvent: createAnalyticsEvent,
            portalProviderAPI: portalProviderAPI,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            providerFactory: providerFactory,
            onEditorCreated: onEditorCreated,
            onEditorDestroyed: onEditorDestroyed,
            disabled: props.disabled,
            preset: preset,
            render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j0Vvw")).BaseThemeWrapper), {
                    baseFontSize: (0, (0, parcelRequire("8pML4")).getBaseFontSize)(props.appearance)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(AppearanceComponent, {
                    innerRef: editorRef,
                    editorAPI: editorAPI,
                    appearance: props.appearance,
                    disabled: props.disabled,
                    editorActions: editorActions,
                    editorDOMElement: editor,
                    editorView: view,
                    providerFactory: providerFactory,
                    eventDispatcher: eventDispatcher,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    maxHeight: props.maxHeight,
                    minHeight: props.minHeight,
                    onSave: props.onSave ? handleSave : undefined,
                    onCancel: props.onCancel,
                    popupsMountPoint: props.popupsMountPoint,
                    popupsBoundariesElement: props.popupsBoundariesElement,
                    popupsScrollableElement: props.popupsScrollableElement,
                    contentComponents: config.contentComponents,
                    primaryToolbarComponents: config.primaryToolbarComponents,
                    primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                    secondaryToolbarComponents: config.secondaryToolbarComponents,
                    customContentComponents: props.contentComponents,
                    customPrimaryToolbarComponents: props.primaryToolbarComponents,
                    customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                    contextPanel: props.contextPanel,
                    collabEdit: props.collabEdit,
                    persistScrollGutter: props.persistScrollGutter,
                    enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                    useStickyToolbar: props.useStickyToolbar,
                    featureFlags: featureFlags,
                    pluginHooks: config.pluginHooks
                }))
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)($71ed6365bae516ba$var$ReactEditorViewContextWrapper, {
            editorProps: overriddenEditorProps,
            createAnalyticsEvent: createAnalyticsEvent,
            portalProviderAPI: portalProviderAPI,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            providerFactory: providerFactory,
            onEditorCreated: onEditorCreated,
            onEditorDestroyed: onEditorDestroyed,
            disabled: props.disabled,
            preset: preset,
            render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j0Vvw")).BaseThemeWrapper), {
                    baseFontSize: (0, (0, parcelRequire("8pML4")).getBaseFontSize)(props.appearance)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(AppearanceComponent, {
                    innerRef: editorRef,
                    editorAPI: editorAPI,
                    appearance: props.appearance,
                    disabled: props.disabled,
                    editorActions: editorActions,
                    editorDOMElement: editor,
                    editorView: view,
                    providerFactory: providerFactory,
                    eventDispatcher: eventDispatcher,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    maxHeight: props.maxHeight,
                    minHeight: props.minHeight,
                    onSave: props.onSave ? handleSave : undefined,
                    onCancel: props.onCancel,
                    popupsMountPoint: props.popupsMountPoint,
                    popupsBoundariesElement: props.popupsBoundariesElement,
                    popupsScrollableElement: props.popupsScrollableElement,
                    contentComponents: config.contentComponents,
                    primaryToolbarComponents: config.primaryToolbarComponents,
                    primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                    secondaryToolbarComponents: config.secondaryToolbarComponents,
                    customContentComponents: props.contentComponents,
                    customPrimaryToolbarComponents: props.primaryToolbarComponents,
                    customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                    contextPanel: props.contextPanel,
                    collabEdit: props.collabEdit,
                    persistScrollGutter: props.persistScrollGutter,
                    enableToolbarMinWidth: props.featureFlags?.toolbarMinWidthOverflow != null ? !!props.featureFlags?.toolbarMinWidthOverflow : props.allowUndoRedoButtons,
                    useStickyToolbar: props.useStickyToolbar,
                    featureFlags: featureFlags,
                    pluginHooks: config.pluginHooks
                }))
        }), (0, (0, parcelRequire("f8Sb3")).jsx)(PortalRenderer, null), (0, (0, parcelRequire("f8Sb3")).jsx)(NodeViewPortalRenderer, null))))))));
    });
    function $71ed6365bae516ba$var$ReactEditorViewContextWrapper(props) {
        const [editorAPI, setEditorAPI] = (0, $5uXOq.useState)(undefined);
        const UNSAFE_cards = props.editorProps.UNSAFE_cards;
        const smartLinks = props.editorProps.smartLinks;
        (0, (0, parcelRequire("geOTC")).useProviders)({
            editorApi: editorAPI,
            contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
            mediaProvider: props.editorProps.media?.provider,
            cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
            emojiProvider: props.editorProps.emojiProvider,
            autoformattingProvider: props.editorProps.autoformattingProvider,
            taskDecisionProvider: props.editorProps.taskDecisionProvider
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fbZFm")).default), {
            ...props,
            editorAPI: editorAPI,
            setEditorAPI: setEditorAPI
        });
    }
});
parcelRegister("gJcSd", function(module, exports) {
    $parcel$export(module.exports, "usePortalProvider", ()=>$1a1c543e60e2eb98$export$9b00782c24eb3d6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $fi43S;
    var $kPNeK;
    function $1a1c543e60e2eb98$export$9b00782c24eb3d6b() {
        const portalManager = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("kPNeK")).PortalManager)(), []);
        const PortalRenderer = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("fi43S")).createPortalRendererComponent)(portalManager), [
            portalManager
        ]);
        const portalProviderAPI = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("fi43S")).getPortalProviderAPI)(portalManager), [
            portalManager
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                portalProviderAPI.destroy();
            };
        }, [
            portalManager,
            portalProviderAPI
        ]);
        return [
            portalProviderAPI,
            PortalRenderer
        ];
    }
});
parcelRegister("fi43S", function(module, exports) {
    $parcel$export(module.exports, "createPortalRendererComponent", ()=>$1acbd9e60fdf02dd$export$adfaaa25a1ea6e69);
    $parcel$export(module.exports, "getPortalProviderAPI", ()=>$1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fh7Yr;
    function $1acbd9e60fdf02dd$export$adfaaa25a1ea6e69(portalManager) {
        return function PortalRenderer() {
            const [buckets, setBuckets] = (0, $5uXOq.useState)(portalManager.getBuckets());
            (0, $5uXOq.useLayoutEffect)(()=>{
                portalManager.registerPortalRenderer(setBuckets);
                return ()=>{
                    portalManager.unregisterPortalRenderer();
                };
            }, []);
            const portalsElements = (0, $5uXOq.useMemo)(()=>buckets.map((_, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh7Yr")).PortalBucket), {
                        key: i,
                        id: i,
                        portalManager: portalManager
                    })), [
                buckets
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, portalsElements);
        };
    }
    const $1acbd9e60fdf02dd$export$3a6b5f5c5bba4bde = (portalManager)=>{
        const portalsMap = new Map();
        return {
            render: (children, container, key)=>{
                const portal = (0, $7nsd3.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal));
            },
            remove: (key)=>{
                portalsMap.get(key)?.();
                portalsMap.delete(key);
            },
            destroy: ()=>{
                portalsMap.clear();
                portalManager.destroy();
            }
        };
    };
});
parcelRegister("fh7Yr", function(module, exports) {
    $parcel$export(module.exports, "PortalBucket", ()=>$0dce56c275d3c858$export$828f0f29e8293a07);
    var $5uXOq = parcelRequire("5uXOq");
    function $0dce56c275d3c858$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
        const [portals, setPortals] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useLayoutEffect)(()=>{
            portalManager.registerBucket(id, setPortals);
            return ()=>{
                portalManager.unregisterBucket(id);
            };
        }, [
            id,
            portalManager
        ]);
        const portalElements = (0, $5uXOq.useMemo)(()=>Object.values(portals), [
            portals
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, portalElements);
    }
});
parcelRegister("kPNeK", function(module, exports) {
    $parcel$export(module.exports, "PortalManager", ()=>$1815e788e0c02d29$export$52c7ef79917c2f38);
    const $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS = 50;
    const $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
    const $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO = 0.5;
    function $1815e788e0c02d29$var$createEmptyBucket(capacity) {
        return {
            portals: {},
            capacity: capacity,
            updater: null
        };
    }
    class $1815e788e0c02d29$export$52c7ef79917c2f38 {
        constructor(initialBuckets = $1815e788e0c02d29$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $1815e788e0c02d29$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $1815e788e0c02d29$var$DEFAULT_SCALE_RATIO){
            this.maxBucketCapacity = maxBucketCapacity;
            this.scaleRatio = scaleRatio;
            this.buckets = Array.from({
                length: initialBuckets
            }, ()=>$1815e788e0c02d29$var$createEmptyBucket(maxBucketCapacity));
            this.portalToBucketMap = new Map();
            this.availableBuckets = new Set(Array.from({
                length: initialBuckets
            }, (_, i)=>i));
            this.portalRendererUpdater = null;
            this.scaleCapacityThreshold = maxBucketCapacity / 2;
        }
        getCurrentBucket() {
            return this.availableBuckets.values().next().value;
        }
        createBucket() {
            const currentBucket = this.getCurrentBucket();
            if (this.buckets[currentBucket].capacity > 0) return;
            else this.availableBuckets.delete(currentBucket);
            if (this.availableBuckets.size > 0) return;
            const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
            this.buckets = [
                ...this.buckets
            ];
            for(let i = 0; i < numBucketsToAdd; i++){
                this.buckets.push($1815e788e0c02d29$var$createEmptyBucket(this.maxBucketCapacity));
                this.availableBuckets.add(this.buckets.length - 1);
            }
            this.portalRendererUpdater?.(this.buckets);
        }
        getBuckets() {
            return this.buckets;
        }
        registerBucket(id, updater) {
            this.buckets[id].updater = updater;
            this.buckets[id].updater?.(()=>({
                    ...this.buckets[id].portals
                }));
        }
        unregisterBucket(id) {
            this.buckets[id].updater = null;
        }
        updateBuckets(id) {
            this.buckets[id].updater?.(()=>{
                return {
                    ...this.buckets[id].portals
                };
            });
        }
        registerPortal(key, portal) {
            this.createBucket();
            this.buckets[this.getCurrentBucket()].capacity -= 1;
            const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
            this.portalToBucketMap.set(key, id);
            if (this.buckets[id].portals[key] !== portal) {
                this.buckets[id].portals[key] = portal;
                this.updateBuckets(id);
            }
            return ()=>{
                delete this.buckets[id].portals[key];
                this.portalToBucketMap.delete(key);
                this.buckets[id].capacity += 1;
                if (this.buckets[id].capacity > this.scaleCapacityThreshold) this.availableBuckets.add(id);
                this.updateBuckets(id);
            };
        }
        registerPortalRenderer(updater) {
            if (!this.portalRendererUpdater) updater(()=>this.buckets);
            this.portalRendererUpdater = updater;
        }
        unregisterPortalRenderer() {
            this.portalRendererUpdater = null;
        }
        destroy() {
            this.buckets.forEach((bucket, id)=>{
                bucket.portals = {};
                bucket.updater = null;
                this.availableBuckets.add(id);
            });
            this.portalToBucketMap.clear();
            this.portalRendererUpdater = null;
            this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
        }
    }
});
parcelRegister("ax7J7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60d0c72e469dbfd3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $gkwXh;
    var $ctLRZ;
    var $ifv4n;
    var $fIJEx;
    var $1KzE6;
    var $1eqsC;
    var $jAZiu;
    class $60d0c72e469dbfd3$export$d6d3bedcc5fc09c8 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                rethrow: true,
                errorTracking: true
            };
        }
        constructor(props){
            super(props), this.browserExtensions = undefined, this.state = {
                error: undefined
            }, this.sendErrorData = async (analyticsErrorPayload)=>{
                const product = await this.getProductName();
                const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
                const sharedId = (0, ($parcel$interopDefault($7Jxgt)))();
                const browserInfo = window?.navigator?.userAgent || 'unknown';
                const attributes = {
                    product: product,
                    browserInfo: browserInfo,
                    error: error.toString(),
                    errorInfo: errorInfo,
                    errorId: sharedId,
                    browserExtensions: this.browserExtensions,
                    docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, (0, parcelRequire("ifv4n")).getDocStructure)(this.props.editorView.state.doc, {
                        compact: true
                    }) : undefined,
                    outdatedBrowser: (0, (0, parcelRequire("1eqsC")).isOutdatedBrowser)(browserInfo)
                };
                this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).EDITOR_CRASHED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: attributes
                });
                this.fireAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        errorId: sharedId
                    }
                });
                (0, (0, parcelRequire("1KzE6")).logException)(error, {
                    location: 'editor-core/create-editor',
                    product: product
                });
            }, this.getProductName = async ()=>{
                const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
                if (contextIdentifierProvider) {
                    const context = await contextIdentifierProvider;
                    if (context.product) return context.product;
                }
                return 'atlaskit';
            }, this.fireAnalyticsEvent = (event)=>{
                this.props.createAnalyticsEvent?.(event).fire((0, (0, parcelRequire("ctLRZ")).editorAnalyticsChannel));
            };
            this.featureFlags = props.featureFlags;
        }
        componentDidCatch(error, errorInfo) {
            if (this.state.error) return;
            if (this.props.errorTracking) this.sendErrorData({
                error: error,
                errorInfo: errorInfo,
                errorStack: error.stack
            });
            this.setState({
                error: error
            }, ()=>{
                if (this.props.rethrow) throw error;
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fIJEx")).IntlErrorBoundary), null, this.props.children);
        }
    }
    var $60d0c72e469dbfd3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("jAZiu")).WithEditorView)($60d0c72e469dbfd3$export$d6d3bedcc5fc09c8);
});
parcelRegister("ifv4n", function(module, exports) {
    $parcel$export(module.exports, "getDocStructure", ()=>$a2ddee04b57518c1$export$6451b72139862cbd);
    const $a2ddee04b57518c1$var$hash = {
        nodes: {
            doc: 'doc',
            paragraph: 'p',
            text: 't',
            bulletList: 'ul',
            orderedList: 'ol',
            listItem: 'li',
            heading: 'h',
            blockquote: 'blockq',
            codeBlock: 'codebl',
            panel: 'pnl',
            rule: 'rl',
            hardBreak: 'br',
            mention: 'ment',
            emoji: 'emj',
            image: 'img',
            caption: 'cap',
            media: 'media',
            mediaGroup: 'mediag',
            mediaSingle: 'medias',
            plain: 'pln',
            table: 'table',
            tableCell: 'td',
            tableHeader: 'th',
            tableRow: 'tr',
            decisionList: 'dl',
            decisionItem: 'di',
            taskList: 'tl',
            taskItem: 'ti',
            extension: 'ext',
            inlineExtension: 'exti',
            bodiedExtension: 'extb',
            multiBodiedExtension: 'extmbe',
            extensionFrame: 'extfrm',
            status: 'sts',
            placeholder: 'plh',
            inlineCard: 'cardi',
            blockCard: 'cardb',
            embedCard: 'carde',
            expand: 'exp',
            nestedExpand: 'expn',
            unsupportedBlock: 'unsupb',
            unsupportedInline: 'unsupi',
            unknownBlock: 'unkb',
            date: 'date'
        },
        marks: {
            em: 'em',
            strong: 'strong',
            code: 'code',
            strike: 'strike',
            underline: 'undline',
            link: 'lnk',
            subsup: 'subsup',
            textColor: 'txtclr',
            unsupportedMark: 'unsupmrk',
            unsupportedNodeAttribute: 'unsupnattr',
            annotation: 'anno'
        }
    };
    function $a2ddee04b57518c1$var$shortHash(type, isMark) {
        const code = $a2ddee04b57518c1$var$hash[isMark ? 'marks' : 'nodes'][type];
        return code ? code : type;
    }
    function $a2ddee04b57518c1$var$compactStringifier(node) {
        const isContentEmpty = !node.content;
        const isTextNode = node?.type === 'text';
        const hasMarks = node.marks?.length;
        const isContentArray = Array.isArray(node.content);
        const marks = (child)=>{
            if (hasMarks) return node.marks.reduce((str, mark)=>`${$a2ddee04b57518c1$var$shortHash(mark, true)}(${str})`, child);
            return child;
        };
        let content;
        if (isTextNode) content = String(node.nodeSize);
        else if (isContentEmpty) content = '';
        else if (isContentArray) content = node.content.map((node)=>$a2ddee04b57518c1$var$compactStringifier(node)).join(',');
        return marks(`${$a2ddee04b57518c1$var$shortHash(node.type, false)}(${content})`);
    }
    const $a2ddee04b57518c1$export$6451b72139862cbd = (doc, options)=>{
        try {
            const result = $a2ddee04b57518c1$var$getBlockNode(doc, 0);
            if (options?.compact) return $a2ddee04b57518c1$var$compactStringifier(result);
            return result;
        } catch (error) {
            return `Error logging document structure: ${error}`;
        }
    };
    const $a2ddee04b57518c1$var$getBlockNode = (node, pos)=>{
        const blockNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: node.nodeSize
        };
        const content = $a2ddee04b57518c1$var$getBlockNodeContent(node.content, pos);
        if (content.length > 0) blockNode.content = content;
        const marks = $a2ddee04b57518c1$var$getMarks(node);
        if (marks.length > 0) blockNode.marks = marks;
        return blockNode;
    };
    const $a2ddee04b57518c1$var$getBlockNodeContent = (node, pos)=>{
        if (!node || !node.content || !node.content.length) return [];
        let blockNodeContent = [];
        const { content: content } = node;
        if (content[0].isBlock) {
            let prevNode;
            blockNodeContent = content.map((node)=>{
                pos += prevNode ? prevNode.nodeSize : 1;
                prevNode = node;
                return $a2ddee04b57518c1$var$getBlockNode(node, pos);
            });
        } else {
            const result = $a2ddee04b57518c1$var$getInlineNodes(content, pos);
            blockNodeContent = result.inlineNodes;
            pos = result.pos;
        }
        return blockNodeContent;
    };
    const $a2ddee04b57518c1$var$getInlineNodes = (nodes, pos)=>{
        let inlineNodes = nodes.map((node)=>{
            const { nodeSize: nodeSize } = node;
            const inlineNode = {
                type: node.type.name,
                pos: pos,
                nodeSize: nodeSize
            };
            const marks = $a2ddee04b57518c1$var$getMarks(node);
            if (marks.length > 0) inlineNode.marks = marks;
            pos += nodeSize;
            return inlineNode;
        });
        return {
            inlineNodes: inlineNodes,
            pos: pos
        };
    };
    const $a2ddee04b57518c1$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);
});
parcelRegister("1eqsC", function(module, exports) {
    $parcel$export(module.exports, "isOutdatedBrowser", ()=>$f4d0395ac92d9621$export$12d09524e028927);
    const $f4d0395ac92d9621$export$12d09524e028927 = (userAgent)=>{
        const chrome = /Chrome\//.test(userAgent) && !/OPR\//.test(userAgent);
        const chromeVersion = chrome ? parseInt((userAgent.match(/Chrome\/(\d+)/) || [])[1], 10) : 0;
        if (chromeVersion >= 84) return false;
        const gecko = /gecko\/\d/i.test(userAgent);
        const geckoVersion = gecko ? parseInt((userAgent.match(/Firefox\/(\d+)/) || [])[1], 10) : 0;
        if (geckoVersion >= 84) return false;
        const edge = /Edge\/(\d+)/.exec(userAgent);
        const edgeVersion = edge ? +edge[1] : 0;
        if (edgeVersion >= 84) return false;
        const safari = !chrome && !gecko && /Version\/([0-9\._]+).*Safari/.test(userAgent);
        const safariVersion = safari ? parseInt((userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10) : 0;
        if (safariVersion >= 12) return false;
        return true;
    };
});
parcelRegister("jAZiu", function(module, exports) {
    $parcel$export(module.exports, "WithEditorView", ()=>$54173e5a1716911b$export$cf381084b490bd31);
    var $5uXOq = parcelRequire("5uXOq");
    var $ankW9;
    const $54173e5a1716911b$export$cf381084b490bd31 = (WrappedComponent)=>{
        const _WithFeatureFlags = (props)=>{
            const { editorActions: editorActions } = (0, (0, parcelRequire("ankW9")).useEditorContext)();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                editorView: editorActions?._privateGetEditorView()
            });
        };
        return _WithFeatureFlags;
    };
});
parcelRegister("fbZFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0780699b8986d8d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $bXrHm = parcelRequire("bXrHm");
    var $gkwXh;
    var $ctLRZ;
    var $hETfp;
    var $J5Axj;
    var $gE8f9;
    var $ifv4n;
    var $k4HYa;
    var $4zXba;
    var $iN9lO;
    var $ap7h6;
    var $kFiBa;
    var $3IZIX;
    var $agxMF;
    var $4NUlu;
    var $gZGBX;
    var $etG8M;
    var $VSDnB;
    var $lY6DM;
    var $4r96J;
    var $az5cZ;
    var $5j6KQ;
    var $g5Huu;
    var $5cNeT;
    var $bz2TZ;
    var $acfJa;
    var $dReYX;
    var $96xlM;
    var $9MoyJ;
    var $gAD8U;
    var $ijurB;
    var $9lx6U;
    var $h0q50;
    var $9wPsG;
    const $b0780699b8986d8d$var$EDIT_AREA_ID = 'ak-editor-textarea';
    function $b0780699b8986d8d$var$handleEditorFocus(view) {
        if (view.hasFocus()) return;
        return window.setTimeout(()=>{
            if (view.hasFocus()) return;
            if (!window.getSelection) {
                view.focus();
                return;
            }
            const domSelection = window.getSelection();
            if (!domSelection || domSelection.rangeCount === 0) {
                view.focus();
                return;
            }
            const range = domSelection.getRangeAt(0);
            if (range.startContainer.contains(view.dom)) {
                view.focus();
                return;
            }
            const anchor = view.posAtDOM(range.startContainer, range.startOffset);
            const head = view.posAtDOM(range.endContainer, range.endOffset);
            if (anchor < 0 || head < 0) {
                view.focus();
                return;
            }
            const selection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }, 0);
    }
    class $b0780699b8986d8d$export$e7d1b1cbca007e16 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        get transactionTracking() {
            return {
                enabled: false
            };
        }
        getPluginNames() {
            return this.editorState.plugins.map((p)=>p.key);
        }
        countNodes() {
            return (0, (0, parcelRequire("k4HYa")).countNodes)(this.editorState);
        }
        constructor(props){
            super(props), this.editorRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.canDispatchTransactions = true, this.onPluginObservation = (report)=>{
                this.dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).TRANSACTION_DISPATCHED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        report: report,
                        participants: this.pluginInjectionAPI.api().collabEdit?.sharedState.currentState()?.participants?.size() || 1
                    }
                });
            }, this.getEditorState = ()=>this.view?.state, this.getEditorView = ()=>this.view, this.formatFullWidthAppearance = (appearance)=>{
                if (appearance === 'full-width') return (0, (0, parcelRequire("hETfp")).FULL_WIDTH_MODE).FULL_WIDTH;
                return (0, (0, parcelRequire("hETfp")).FULL_WIDTH_MODE).FIXED_WIDTH;
            }, this.resetEditorState = ({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
                if (!this.view) return;
                this.blur();
                this.featureFlags = (0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(this.props.editorProps.featureFlags);
                this.editorState = this.createEditorState({
                    props: this.props,
                    doc: doc,
                    resetting: true,
                    selectionAtStart: !shouldScrollToBottom
                });
                this.view.updateState(this.editorState);
                this.props.editorProps.onChange?.(this.view, {
                    source: 'local'
                });
            }, this.blur = ()=>{
                if (!this.view) return;
                if (this.view.dom instanceof HTMLElement && this.view.hasFocus()) this.view.dom.blur();
                const sel = this.view.root.getSelection();
                if (sel) sel.removeAllRanges();
            }, this.handleAnalyticsEvent = (payload)=>{
                (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(this.props.createAnalyticsEvent)(payload);
            }, this.editorPlugins = [], this.createEditorState = (options)=>{
                let schema;
                if (this.view) {
                    if (options.resetting) schema = this.view.state.schema;
                    else {
                        console.warn('The editor does not support changing the schema dynamically.');
                        return this.editorState;
                    }
                } else {
                    this.config = (0, (0, parcelRequire("9MoyJ")).processPluginsList)(this.getPlugins(options.props.preset));
                    schema = (0, (0, parcelRequire("ijurB")).createSchema)(this.config);
                }
                const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
                const plugins = (0, (0, parcelRequire("9MoyJ")).createPMPlugins)({
                    schema: schema,
                    dispatch: this.dispatch,
                    errorReporter: this.errorReporter,
                    editorConfig: this.config,
                    eventDispatcher: this.eventDispatcher,
                    providerFactory: options.props.providerFactory,
                    portalProviderAPI: this.props.portalProviderAPI,
                    nodeViewPortalProviderAPI: this.props.nodeViewPortalProviderAPI,
                    dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                    featureFlags: this.featureFlags,
                    getIntl: ()=>this.props.intl,
                    onEditorStateUpdated: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states') ? this.pluginInjectionAPI.onEditorViewUpdated : undefined
                });
                this.contentTransformer = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
                let doc;
                const api = this.pluginInjectionAPI.api();
                if (options.doc) {
                    if (api?.collabEdit !== undefined && (0, (0, parcelRequire("VSDnB")).fg)('editor_load_conf_collab_docs_without_checks') || options.props.editorProps.skipValidation) doc = (0, (0, parcelRequire("agxMF")).processRawValueWithoutValidation)(schema, options.doc, this.dispatchAnalyticsEvent);
                    else doc = (0, (0, parcelRequire("agxMF")).processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, this.contentTransformer, this.dispatchAnalyticsEvent);
                }
                const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
                let selection;
                if (doc) {
                    if (isViewMode) {
                        const emptySelection = new (0, (0, parcelRequire("gZGBX")).TextSelection)(doc.resolve(0));
                        return (0, (0, parcelRequire("gZGBX")).EditorState).create({
                            schema: schema,
                            plugins: plugins,
                            doc: doc,
                            selection: emptySelection
                        });
                    } else selection = options.selectionAtStart ? (0, (0, parcelRequire("gZGBX")).Selection).atStart(doc) : (0, (0, parcelRequire("gZGBX")).Selection).atEnd(doc);
                }
                const patchedSelection = selection ? (0, (0, parcelRequire("gZGBX")).Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
                return (0, (0, parcelRequire("gZGBX")).EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: patchedSelection
                });
            }, this.onEditorViewStateUpdated = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
                this.config.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                    entry.callback({
                        originalTransaction: originalTransaction,
                        transactions: transactions,
                        oldEditorState: oldEditorState,
                        newEditorState: newEditorState
                    });
                });
            }, this.dispatchTransaction = (unsafeTransaction)=>{
                if (!this.view) return;
                const nodes = (0, (0, parcelRequire("4r96J")).findChangedNodesFromTransaction)(unsafeTransaction);
                const changedNodesValid = (0, (0, parcelRequire("96xlM")).validateNodes)(nodes);
                const transaction = new Proxy(unsafeTransaction, (0, (0, parcelRequire("acfJa")).freezeUnsafeTransactionProperties)({
                    dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                    pluginKey: 'unknown-reacteditorview'
                }));
                if (changedNodesValid) {
                    const oldEditorState = this.view.state;
                    const { state: editorState, transactions: transactions } = this.view.state.applyTransaction(transaction);
                    if (editorState === oldEditorState) return;
                    this.view.updateState(editorState);
                    if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states')) this.pluginInjectionAPI.onEditorViewUpdated({
                        newEditorState: editorState,
                        oldEditorState: oldEditorState
                    });
                    this.onEditorViewStateUpdated({
                        originalTransaction: transaction,
                        transactions: transactions,
                        oldEditorState: oldEditorState,
                        newEditorState: editorState
                    });
                    if (this.props.editorProps.onChange && transaction.docChanged) {
                        const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                        (0, (0, parcelRequire("iN9lO")).startMeasure)((0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE));
                        this.props.editorProps.onChange(this.view, {
                            source: source
                        });
                        (0, (0, parcelRequire("iN9lO")).stopMeasure)((0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE), (duration, startTime)=>{
                            this.dispatchAnalyticsEvent({
                                action: (0, (0, parcelRequire("gkwXh")).ACTION).ON_CHANGE_CALLBACK,
                                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    duration: duration,
                                    startTime: startTime
                                }
                            });
                        });
                    }
                    this.editorState = editorState;
                } else {
                    const invalidNodes = nodes.filter((node)=>!(0, (0, parcelRequire("96xlM")).validNode)(node)).map((node)=>(0, (0, parcelRequire("ifv4n")).getDocStructure)(node, {
                            compact: true
                        }));
                    this.dispatchAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).DISPATCHED_INVALID_TRANSACTION,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                        attributes: {
                            analyticsEventPayloads: (0, (0, parcelRequire("J5Axj")).getAnalyticsEventsFromTransaction)(transaction),
                            invalidNodes: invalidNodes
                        }
                    });
                }
            }, this.getDirectEditorProps = (state)=>{
                return {
                    state: state || this.editorState,
                    dispatchTransaction: (tr)=>{
                        if (this.canDispatchTransactions) this.dispatchTransaction(tr);
                    },
                    editable: (_state)=>!this.props.editorProps.disabled,
                    attributes: {
                        'data-gramm': 'false'
                    }
                };
            }, this.createEditorView = (node)=>{
                (0, (0, parcelRequire("ap7h6")).measureRender)((0, (0, parcelRequire("5cNeT")).default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
                    this.proseMirrorRenderedSeverity = (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(duration, (0, $da8c6c1b49848045$export$646a6982857f2cd5), (0, $da8c6c1b49848045$export$79d7eac6cbb6352d));
                    if (this.view) {
                        const nodes = (0, (0, parcelRequire("az5cZ")).getNodesCount)(this.view.state.doc);
                        const ttfb = (0, (0, parcelRequire("kFiBa")).getResponseEndTime)();
                        const contextIdentifier = this.pluginInjectionAPI.api().base?.sharedState.currentState();
                        this.dispatchAnalyticsEvent({
                            action: (0, (0, parcelRequire("gkwXh")).ACTION).PROSEMIRROR_RENDERED,
                            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                            attributes: {
                                duration: duration,
                                startTime: startTime,
                                nodes: nodes,
                                ttfb: ttfb,
                                severity: this.proseMirrorRenderedSeverity,
                                objectId: contextIdentifier?.objectId,
                                distortedDuration: distortedDuration
                            },
                            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                this.view = new (0, (0, parcelRequire("etG8M")).EditorView)({
                    mount: node
                }, this.getDirectEditorProps());
                this.pluginInjectionAPI.onEditorViewUpdated({
                    newEditorState: this.view.state,
                    oldEditorState: undefined
                });
            }, this.handleEditorViewRef = (node)=>{
                if (!this.view && node) {
                    this.createEditorView(node);
                    const view = this.view;
                    this.props.onEditorCreated({
                        view: view,
                        config: this.config,
                        eventDispatcher: this.eventDispatcher,
                        transformer: this.contentTransformer
                    });
                    if (this.props.editorProps.shouldFocus && view.props.editable && view.props.editable(view.state)) this.focusTimeoutId = $b0780699b8986d8d$var$handleEditorFocus(view);
                    this.forceUpdate();
                } else if (this.view && !node) {
                    this.props.onEditorDestroyed({
                        view: this.view,
                        config: this.config,
                        eventDispatcher: this.eventDispatcher,
                        transformer: this.contentTransformer
                    });
                    const analyticsConnected = this.eventDispatcher.has((0, (0, parcelRequire("4NUlu")).analyticsEventKey), this.handleAnalyticsEvent);
                    if (!analyticsConnected) this.eventDispatcher.on((0, (0, parcelRequire("4NUlu")).analyticsEventKey), this.handleAnalyticsEvent);
                    this.view.destroy();
                    if (!analyticsConnected) this.eventDispatcher.off((0, (0, parcelRequire("4NUlu")).analyticsEventKey), this.handleAnalyticsEvent);
                    this.view = undefined;
                }
            }, this.dispatchAnalyticsEvent = (payload)=>{
                if (this.eventDispatcher) {
                    const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(this.eventDispatcher);
                    dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                        payload: payload
                    });
                }
            }, this.editorId = (0, ($parcel$interopDefault($bXrHm)))(), this.createEditor = (assistiveLabel, assistiveDescribedBy)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: $b0780699b8986d8d$var$getUAPrefix(),
                    key: "ProseMirror",
                    ref: this.handleEditorViewRef,
                    "aria-label": assistiveLabel || this.props.intl.formatMessage((0, (0, parcelRequire("h0q50")).editorMessages).editorAssistiveLabel),
                    "aria-multiline": true,
                    role: "textbox",
                    id: $b0780699b8986d8d$var$EDIT_AREA_ID,
                    "aria-describedby": assistiveDescribedBy,
                    "data-editor-id": this.editorId
                });
            }, this.editor = this.createEditor(this.props.editorProps.assistiveLabel, this.props.editorProps?.assistiveDescribedBy);
            this.pluginInjectionAPI = new (0, (0, parcelRequire("3IZIX")).EditorPluginInjectionAPI)({
                getEditorState: this.getEditorState,
                getEditorView: this.getEditorView,
                fireAnalyticsEvent: this.handleAnalyticsEvent
            });
            const api = this.pluginInjectionAPI.api();
            props.setEditorAPI?.(api);
            this.eventDispatcher = new (0, (0, parcelRequire("lY6DM")).EventDispatcher)();
            this.dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(this.eventDispatcher);
            this.errorReporter = (0, (0, parcelRequire("9MoyJ")).createErrorReporter)(props.editorProps.errorReporterHandler);
            this.pluginPerformanceObserver = new (0, (0, parcelRequire("bz2TZ")).PluginPerformanceObserver)((report)=>this.onPluginObservation(report)).withPlugins(()=>this.getPluginNames()).withNodeCounts(()=>this.countNodes());
            this.featureFlags = (0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(this.props.editorProps.featureFlags);
            const featureFlagsEnabled = this.featureFlags ? (0, (0, parcelRequire("4zXba")).getEnabledFeatureFlagKeys)(this.featureFlags) : [];
            this.eventDispatcher.on((0, (0, parcelRequire("4NUlu")).analyticsEventKey), this.handleAnalyticsEvent);
            this.eventDispatcher.on('resetEditorState', this.resetEditorState);
            this.editorState = this.createEditorState({
                props: props,
                doc: props.editorProps.defaultValue,
                selectionAtStart: (0, (0, parcelRequire("5j6KQ")).isFullPage)(props.editorProps.appearance)
            });
            this.dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).STARTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                attributes: {
                    platform: (0, (0, parcelRequire("hETfp")).PLATFORMS).WEB,
                    featureFlags: featureFlagsEnabled
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (this.view && this.props.editorProps.disabled !== nextProps.editorProps.disabled) {
                this.view.setProps({
                    editable: (_state)=>!nextProps.editorProps.disabled
                });
                if (!nextProps.editorProps.disabled && nextProps.editorProps.shouldFocus) this.focusTimeoutId = $b0780699b8986d8d$var$handleEditorFocus(this.view);
            }
            const { appearance: appearance } = this.props.editorProps;
            const { appearance: nextAppearance } = nextProps.editorProps;
            if (this.props.preset !== nextProps.preset) this.reconfigureState(nextProps);
            if (nextAppearance !== appearance) {
                if (nextAppearance === 'full-width' || appearance === 'full-width') this.dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_FULL_WIDTH_MODE,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        previousMode: this.formatFullWidthAppearance(appearance),
                        newMode: this.formatFullWidthAppearance(nextAppearance)
                    }
                });
            }
            if (nextProps.editorProps.assistiveLabel !== this.props.editorProps.assistiveLabel || nextProps.editorProps?.assistiveDescribedBy !== this.props.editorProps?.assistiveDescribedBy) this.editor = this.createEditor(nextProps.editorProps.assistiveLabel, nextProps.editorProps?.assistiveDescribedBy);
        }
        reconfigureState(props) {
            if (!this.view) return;
            this.blur();
            const editorPlugins = this.getPlugins(props.preset);
            this.config = (0, (0, parcelRequire("9MoyJ")).processPluginsList)(editorPlugins);
            const state = this.editorState;
            const plugins = (0, (0, parcelRequire("9MoyJ")).createPMPlugins)({
                schema: state.schema,
                dispatch: this.dispatch,
                errorReporter: this.errorReporter,
                editorConfig: this.config,
                eventDispatcher: this.eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                featureFlags: (0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(props.editorProps.featureFlags),
                getIntl: ()=>this.props.intl,
                onEditorStateUpdated: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states') ? this.pluginInjectionAPI.onEditorViewUpdated : undefined
            });
            const newState = state.reconfigure({
                plugins: plugins
            });
            this.view.updateState(newState);
            return this.view.update({
                ...this.view.props,
                state: newState
            });
        }
        componentDidMount() {
            this.canDispatchTransactions = true;
        }
        componentWillUnmount() {
            this.canDispatchTransactions = false;
            clearTimeout(this.focusTimeoutId);
            if (this.reliabilityInterval) clearInterval(this.reliabilityInterval);
            this.pluginPerformanceObserver.disconnect();
            if (this.view) {
                const editorState = this.view.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            this.eventDispatcher.destroy();
        }
        getPlugins(preset) {
            const plugins = (0, (0, parcelRequire("gAD8U")).default)(preset, this.props.editorProps, this.pluginInjectionAPI);
            this.editorPlugins = plugins;
            return this.editorPlugins;
        }
        render() {
            const renderTrackingEnabled = !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_disable_rerender_tracking_jira');
            const useShallow = true;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wPsG")).default).Provider, {
                value: {
                    editorRef: this.editorRef,
                    editorView: this.view,
                    popupsMountPoint: this.props.editorProps.popupsMountPoint
                }
            }, renderTrackingEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g5Huu")).RenderTracking), {
                componentProps: this.props,
                action: (0, (0, parcelRequire("gkwXh")).ACTION).RE_RENDERED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).REACT_EDITOR_VIEW,
                handleAnalyticsEvent: this.handleAnalyticsEvent,
                useShallow: useShallow
            }), this.props.render ? this.props.render?.({
                editor: this.editor,
                view: this.view,
                config: this.config,
                eventDispatcher: this.eventDispatcher,
                transformer: this.contentTransformer,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                editorRef: this.editorRef,
                editorAPI: this.props.editorAPI
            }) ?? this.editor : this.editor);
        }
    }
    function $b0780699b8986d8d$var$getUAPrefix() {
        if ((0, (0, parcelRequire("gE8f9")).browser).chrome) return 'ua-chrome';
        else if ((0, (0, parcelRequire("gE8f9")).browser).ie) return 'ua-ie';
        else if ((0, (0, parcelRequire("gE8f9")).browser).gecko) return 'ua-firefox';
        else if ((0, (0, parcelRequire("gE8f9")).browser).safari) return 'ua-safari';
        return '';
    }
    var $b0780699b8986d8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($b0780699b8986d8d$export$e7d1b1cbca007e16);
});
parcelRegister("hETfp", function(module, exports) {
    $parcel$export(module.exports, "PLATFORMS", ()=>$64702af428f72834$export$a8d23193462f2b63);
    $parcel$export(module.exports, "MODE", ()=>$64702af428f72834$export$e48589d9e4824227);
    $parcel$export(module.exports, "FULL_WIDTH_MODE", ()=>$64702af428f72834$export$57453495b81e2dde);
    $parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", ()=>$64702af428f72834$export$60a219cfaef9722);
    var $64702af428f72834$export$a8d23193462f2b63;
    (function(PLATFORMS) {
        PLATFORMS["NATIVE"] = "mobileNative";
        PLATFORMS["HYBRID"] = "mobileHybrid";
        PLATFORMS["WEB"] = "web";
    })($64702af428f72834$export$a8d23193462f2b63 || ($64702af428f72834$export$a8d23193462f2b63 = {}));
    var $64702af428f72834$export$e48589d9e4824227;
    (function(MODE) {
        MODE["RENDERER"] = "renderer";
        MODE["EDITOR"] = "editor";
    })($64702af428f72834$export$e48589d9e4824227 || ($64702af428f72834$export$e48589d9e4824227 = {}));
    var $64702af428f72834$export$57453495b81e2dde;
    (function(FULL_WIDTH_MODE) {
        FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
        FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    })($64702af428f72834$export$57453495b81e2dde || ($64702af428f72834$export$57453495b81e2dde = {}));
    var $64702af428f72834$export$60a219cfaef9722;
    (function(BROWSER_FREEZE_INTERACTION_TYPE) {
        BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
        BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
        BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
        BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    })($64702af428f72834$export$60a219cfaef9722 || ($64702af428f72834$export$60a219cfaef9722 = {}));
});
parcelRegister("J5Axj", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsEventsFromTransaction", ()=>$6668461c370cf056$export$d9985be1ece4b7ee);
    var $8aY84;
    function $6668461c370cf056$export$d9985be1ece4b7ee(tr) {
        return tr.steps.filter((step)=>step instanceof (0, (0, parcelRequire("8aY84")).AnalyticsStep)).reduce((acc, step)=>[
                ...acc,
                ...step.analyticsEvents
            ], []);
    }
});
parcelRegister("8aY84", function(module, exports) {
    $parcel$export(module.exports, "AnalyticsStep", ()=>$5f3de64f68283b50$export$cc33374693c7fb23);
    var $eHiP8 = parcelRequire("eHiP8");
    var $eS2Dn;
    var $kCV8T;
    const $5f3de64f68283b50$export$9126078e8b0f76e4 = 'atlaskit-analytics';
    const $5f3de64f68283b50$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
    var $5f3de64f68283b50$var$HISTORY_ACTIONS = function(HISTORY_ACTIONS) {
        HISTORY_ACTIONS["UNDID"] = "undid";
        HISTORY_ACTIONS["REDID"] = "redid";
        return HISTORY_ACTIONS;
    }($5f3de64f68283b50$var$HISTORY_ACTIONS || {});
    function $5f3de64f68283b50$var$createUndoEvent(analyticsEvent) {
        var _analyticsEvent$paylo;
        return {
            ...analyticsEvent,
            payload: {
                action: $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID,
                actionSubject: analyticsEvent.payload.actionSubject,
                actionSubjectId: analyticsEvent.payload.action,
                attributes: {
                    ...analyticsEvent.payload.attributes,
                    actionSubjectId: analyticsEvent.payload.actionSubjectId,
                    inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
                },
                eventType: 'track'
            }
        };
    }
    const $5f3de64f68283b50$var$toggleEventAction = (analyticsEvent)=>({
            ...analyticsEvent,
            payload: {
                ...analyticsEvent.payload,
                action: analyticsEvent.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID ? $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID : $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID
            }
        });
    function $5f3de64f68283b50$var$isHistoryAnalyticsEvent(event) {
        return event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.UNDID || event.payload.action === $5f3de64f68283b50$var$HISTORY_ACTIONS.REDID;
    }
    class $5f3de64f68283b50$export$cc33374693c7fb23 extends (0, (0, parcelRequire("eS2Dn")).Step) {
        constructor(analyticsEvents, actionsToIgnore = [], pos){
            super();
            (0, $eHiP8.default)(this, "analyticsEvents", []);
            (0, $eHiP8.default)(this, "actionsToIgnore", []);
            this.analyticsEvents = analyticsEvents;
            this.actionsToIgnore = actionsToIgnore;
            this.pos = pos;
        }
        invert() {
            const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
                if ($5f3de64f68283b50$var$isHistoryAnalyticsEvent(analyticsEvent)) return $5f3de64f68283b50$var$toggleEventAction(analyticsEvent);
                else return $5f3de64f68283b50$var$createUndoEvent(analyticsEvent);
            });
            return new $5f3de64f68283b50$export$cc33374693c7fb23(analyticsEvents, []);
        }
        apply(doc) {
            return (0, (0, parcelRequire("eS2Dn")).StepResult).ok(doc);
        }
        map(mapping) {
            let newPos = this.pos;
            if (typeof newPos === 'number') newPos = mapping.map(newPos);
            return new $5f3de64f68283b50$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
        }
        getMap() {
            if (typeof this.pos === 'number') return new (0, (0, parcelRequire("eS2Dn")).StepMap)([
                this.pos,
                0,
                0
            ]);
            return new (0, (0, parcelRequire("eS2Dn")).StepMap)([]);
        }
        merge(other) {
            if (other instanceof $5f3de64f68283b50$export$cc33374693c7fb23) {
                const otherAnalyticsEvents = other.analyticsEvents;
                return new $5f3de64f68283b50$export$cc33374693c7fb23([
                    ...otherAnalyticsEvents,
                    ...this.analyticsEvents
                ]);
            }
            return null;
        }
        toJSON() {
            return {
                stepType: $5f3de64f68283b50$export$9126078e8b0f76e4
            };
        }
        static fromJSON() {
            return new (0, (0, parcelRequire("eS2Dn")).ReplaceStep)(0, 0, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
    }
    (0, (0, parcelRequire("eS2Dn")).Step).jsonID($5f3de64f68283b50$export$9126078e8b0f76e4, $5f3de64f68283b50$export$cc33374693c7fb23);
});
parcelRegister("k4HYa", function(module, exports) {
    $parcel$export(module.exports, "countNodes", ()=>$550dac80d474b87c$export$1daf15cbaf649dad);
    function $550dac80d474b87c$export$1daf15cbaf649dad(state) {
        const nodeCount = {};
        const extensionNodeCount = {};
        const nodeTypes = state.schema.nodes;
        const extensionNodeTypes = [
            nodeTypes.extension?.name,
            nodeTypes.inlineExtension?.name,
            nodeTypes.bodiedExtension?.name,
            nodeTypes.multiBodiedExtension?.name
        ];
        state.doc.descendants((node)=>{
            const nodeName = node.type.name;
            if (nodeName in nodeCount) nodeCount[nodeName]++;
            else nodeCount[nodeName] = 1;
            let extensionNodeName = nodeName;
            if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
                extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
                if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
                else extensionNodeCount[extensionNodeName] = 1;
            }
            return true;
        });
        return {
            nodeCount: nodeCount,
            extensionNodeCount: extensionNodeCount
        };
    }
});
parcelRegister("3IZIX", function(module, exports) {
    $parcel$export(module.exports, "EditorPluginInjectionAPI", ()=>$90985e08491cf82f$export$50ccbedb1c6559a0);
    var $ajpes = parcelRequire("ajpes");
    var $34ck9 = parcelRequire("34ck9");
    var $31bJ2;
    function $90985e08491cf82f$var$hasGetSharedState(plugin) {
        return typeof plugin.getSharedState === 'function';
    }
    function $90985e08491cf82f$var$hasActions(plugin) {
        return typeof plugin.actions === 'object';
    }
    function $90985e08491cf82f$var$hasCommands(plugin) {
        return typeof plugin.commands === 'object';
    }
    const $90985e08491cf82f$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $90985e08491cf82f$var$hasGetSharedState(plugin));
    const $90985e08491cf82f$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
        const isInitialization = !oldEditorState && newEditorState;
        const result = new Map();
        for (let plugin of plugins){
            if (!plugin || !$90985e08491cf82f$var$hasGetSharedState(plugin)) continue;
            const nextSharedState = plugin.getSharedState(newEditorState);
            const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
            const isSamePluginState = (0, ($parcel$interopDefault($ajpes)))(prevSharedState, nextSharedState);
            if (isInitialization || !isSamePluginState) result.set(plugin.name, {
                nextSharedState: nextSharedState,
                prevSharedState: prevSharedState
            });
        }
        return result;
    };
    const $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
    const $90985e08491cf82f$var$notifyListenersThrottled = (0, ($parcel$interopDefault($34ck9)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
        const callbacks = [];
        for (let [pluginName, diffs] of updatesToNotifyQueue.entries()){
            const pluginListeners = listeners.get(pluginName) || [];
            pluginListeners.forEach((callback)=>{
                diffs.forEach((diff)=>{
                    callbacks.push(callback.bind(callback, diff));
                });
            });
        }
        updatesToNotifyQueue.clear();
        if (callbacks.length === 0) return;
        callbacks.reverse().forEach((cb)=>{
            cb();
        });
    }, $90985e08491cf82f$var$THROTTLE_CALLS_FOR_MILLISECONDS);
    class $90985e08491cf82f$export$855252f33d470a3f {
    }
    class $90985e08491cf82f$var$ActionsAPI {
        createAPI(plugin) {
            if (!plugin || !$90985e08491cf82f$var$hasActions(plugin)) return {};
            return new Proxy(plugin.actions || {}, {
                get: function(target, prop, receiver) {
                    return Reflect.get(target, prop);
                }
            });
        }
    }
    class $90985e08491cf82f$var$EditorCommandsAPI {
        createAPI(plugin) {
            if (!plugin || !$90985e08491cf82f$var$hasCommands(plugin)) return {};
            return new Proxy(plugin.commands || {}, {
                get: function(target, prop, receiver) {
                    return Reflect.get(target, prop);
                }
            });
        }
    }
    class $90985e08491cf82f$export$da7528f3fb233b4a {
        constructor({ getEditorState: getEditorState }){
            this.updatesToNotifyQueue = new Map();
            this.getEditorState = getEditorState;
            this.listeners = new Map();
        }
        createAPI(plugin) {
            if (!plugin) return {
                currentState: ()=>undefined,
                onChange: (sub)=>{
                    return ()=>{};
                }
            };
            const pluginName = plugin.name;
            return {
                currentState: ()=>{
                    if (!$90985e08491cf82f$var$hasGetSharedState(plugin)) return undefined;
                    const state = this.getEditorState();
                    return plugin.getSharedState(state);
                },
                onChange: (sub)=>{
                    const pluginListeners = this.listeners.get(pluginName) || new Set();
                    pluginListeners.add(sub);
                    this.listeners.set(pluginName, pluginListeners);
                    return ()=>this.cleanupSubscription(pluginName, sub);
                }
            };
        }
        cleanupSubscription(pluginName, sub) {
            (this.listeners.get(pluginName) || new Set()).delete(sub);
        }
        notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
            const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
            const pluginsFiltered = $90985e08491cf82f$var$filterPluginsWithListeners({
                plugins: plugins,
                listeners: listeners
            });
            const sharedStateDiffs = $90985e08491cf82f$var$extractSharedStateFromPlugins({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState,
                plugins: pluginsFiltered
            });
            if (sharedStateDiffs.size === 0) return;
            for (let [pluginName, nextDiff] of sharedStateDiffs){
                const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
                updatesToNotifyQueue.set(pluginName, [
                    ...currentDiffQueue,
                    nextDiff
                ]);
            }
            $90985e08491cf82f$var$notifyListenersThrottled({
                updatesToNotifyQueue: updatesToNotifyQueue,
                listeners: listeners
            });
        }
        destroy() {
            this.listeners.clear();
            this.updatesToNotifyQueue.clear();
        }
    }
    const $90985e08491cf82f$var$editorAPICache = new WeakMap();
    class $90985e08491cf82f$export$50ccbedb1c6559a0 {
        constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent }){
            this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
                this.sharedStateAPI.notifyListeners({
                    newEditorState: newEditorState,
                    oldEditorState: oldEditorState,
                    plugins: this.plugins
                });
            };
            this.onEditorPluginInitialized = (plugin)=>{
                this.addPlugin(plugin);
            };
            this.addPlugin = (plugin)=>{
                if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
                this.plugins.set(plugin.name, plugin);
            };
            this.getPluginByName = (pluginName)=>{
                const plugin = this.plugins.get(pluginName);
                return plugin;
            };
            this.sharedStateAPI = new $90985e08491cf82f$export$da7528f3fb233b4a({
                getEditorState: getEditorState
            });
            this.plugins = new Map();
            this.actionsAPI = new $90985e08491cf82f$var$ActionsAPI();
            this.commandsAPI = new $90985e08491cf82f$var$EditorCommandsAPI();
            this.addPlugin((0, (0, parcelRequire("31bJ2")).corePlugin)({
                config: {
                    getEditorView: getEditorView,
                    fireAnalyticsEvent: fireAnalyticsEvent
                }
            }));
        }
        createAPI() {
            const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
            return new Proxy({}, {
                get: function(target, prop, receiver) {
                    if (prop === 'toJSON') return Reflect.get(target, prop);
                    const plugin = getPluginByName(prop);
                    if (!plugin) return undefined;
                    const sharedState = sharedStateAPI.createAPI(plugin);
                    const actions = actionsAPI.createAPI(plugin);
                    const commands = commandsAPI.createAPI(plugin);
                    const proxyCoreAPI = {
                        sharedState: sharedState,
                        actions: actions,
                        commands: commands
                    };
                    return proxyCoreAPI;
                }
            });
        }
        api() {
            if (!$90985e08491cf82f$var$editorAPICache.get(this)) $90985e08491cf82f$var$editorAPICache.set(this, this.createAPI());
            return $90985e08491cf82f$var$editorAPICache.get(this);
        }
    }
});
parcelRegister("31bJ2", function(module, exports) {
    $parcel$export(module.exports, "corePlugin", ()=>$bd2341d5492ad0c3$export$71ab138dd170c35);
    var $31nwk;
    var $hcUHh;
    const $bd2341d5492ad0c3$export$71ab138dd170c35 = ({ config: config })=>{
        return {
            name: 'core',
            actions: {
                execute: (command)=>{
                    const editorView = config?.getEditorView();
                    if (!editorView || !command) return false;
                    const { state: state, dispatch: dispatch } = editorView;
                    return (0, (0, parcelRequire("31nwk")).editorCommandToPMCommand)(command)(state, dispatch);
                },
                focus: (options)=>{
                    const editorView = config?.getEditorView();
                    if (!editorView || editorView.hasFocus()) return false;
                    editorView.focus();
                    if (options?.scrollIntoView ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                    return true;
                },
                blur: ()=>{
                    const editorView = config?.getEditorView();
                    if (!editorView || !editorView.hasFocus()) return false;
                    editorView.dom.blur();
                    return true;
                },
                requestDocument (onReceive, options) {
                    const view = config?.getEditorView() ?? null;
                    (0, (0, parcelRequire("hcUHh")).scheduleDocumentRequest)(view, onReceive, options?.transformer, config?.fireAnalyticsEvent);
                },
                createTransformer (cb) {
                    const view = config?.getEditorView() ?? null;
                    if (!view?.state.schema) return undefined;
                    return cb(view?.state.schema);
                }
            }
        };
    };
});
parcelRegister("31nwk", function(module, exports) {
    $parcel$export(module.exports, "editorCommandToPMCommand", ()=>$9c736ce93f64dbdf$export$bd352a83a17b2af8);
    $parcel$export(module.exports, "PassiveTransaction", ()=>$9c736ce93f64dbdf$export$95069e054e554fa9);
    var $gZGBX;
    function $9c736ce93f64dbdf$export$bd352a83a17b2af8(command) {
        return ({ tr: tr }, dispatch)=>{
            const newTr = command?.({
                tr: tr
            });
            if (!newTr) return false;
            if (newTr instanceof $9c736ce93f64dbdf$export$95069e054e554fa9) return true;
            dispatch?.(newTr);
            return true;
        };
    }
    class $9c736ce93f64dbdf$export$95069e054e554fa9 extends (0, (0, parcelRequire("gZGBX")).Transaction) {
        constructor(){
            super({});
        }
    }
});
parcelRegister("hcUHh", function(module, exports) {
    $parcel$export(module.exports, "scheduleDocumentRequest", ()=>$fb1316c40c469b7f$export$b1eb8a13e3cfe3de);
    var $hYNZx;
    var $kCV8T;
    var $gkwXh;
    const $fb1316c40c469b7f$var$transformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    function $fb1316c40c469b7f$export$54fd2c36b5cc6731(node) {
        return $fb1316c40c469b7f$var$transformer.encode(node);
    }
    function $fb1316c40c469b7f$var$createThrottleSchedule(callback) {
        let frameId;
        let lastArgs;
        const wrapperFn = (...args)=>{
            lastArgs = args;
            if (frameId) return;
            const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
            frameId = delayFunction(()=>{
                frameId = undefined;
                if (lastArgs) callback(...lastArgs);
            }, {
                timeout: 100
            });
        };
        return wrapperFn;
    }
    const $fb1316c40c469b7f$export$b1eb8a13e3cfe3de = $fb1316c40c469b7f$var$createThrottleSchedule($fb1316c40c469b7f$var$returnDocumentRequest);
    function $fb1316c40c469b7f$var$returnDocumentRequest(editorView, callback, transformer, fireAnalyticsEvent) {
        const { doc: doc, schema: schema } = editorView?.state ?? {};
        if (!doc || !schema) return undefined;
        try {
            const json = $fb1316c40c469b7f$export$54fd2c36b5cc6731(doc);
            if (typeof transformer === 'undefined') callback(json);
            else {
                const nodeSanitized = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, json);
                callback(transformer.encode(nodeSanitized));
            }
        } catch (e) {
            fireAnalyticsEvent?.({
                payload: {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).DOCUMENT_PROCESSING_ERROR,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                    }
                }
            });
            throw e;
        }
    }
});
parcelRegister("etG8M", function(module, exports) {
    $parcel$export(module.exports, "Decoration", ()=>$a8a4766474a1e455$export$10e30b733df217ea);
    $parcel$export(module.exports, "DecorationSet", ()=>$a8a4766474a1e455$export$93bf62eb445cec98);
    $parcel$export(module.exports, "EditorView", ()=>$a8a4766474a1e455$export$eece2fccabbb77c5);
    var $gZGBX;
    var $kCV8T;
    var $eS2Dn;
    const $a8a4766474a1e455$var$domIndex = function(node) {
        for(var index = 0;; index++){
            node = node.previousSibling;
            if (!node) return index;
        }
    };
    const $a8a4766474a1e455$var$parentNode = function(node) {
        let parent = node.assignedSlot || node.parentNode;
        return parent && parent.nodeType == 11 ? parent.host : parent;
    };
    let $a8a4766474a1e455$var$reusedRange = null;
    const $a8a4766474a1e455$var$textRange = function(node, from, to) {
        let range = $a8a4766474a1e455$var$reusedRange || ($a8a4766474a1e455$var$reusedRange = document.createRange());
        range.setEnd(node, to == null ? node.nodeValue.length : to);
        range.setStart(node, from || 0);
        return range;
    };
    const $a8a4766474a1e455$var$clearReusedRange = function() {
        $a8a4766474a1e455$var$reusedRange = null;
    };
    const $a8a4766474a1e455$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
        return targetNode && ($a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, -1) || $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, 1));
    };
    const $a8a4766474a1e455$var$atomElements = /^(img|br|input|textarea|hr)$/i;
    function $a8a4766474a1e455$var$scanFor(node, off, targetNode, targetOff, dir) {
        for(;;){
            if (node == targetNode && off == targetOff) return true;
            if (off == (dir < 0 ? 0 : $a8a4766474a1e455$var$nodeSize(node))) {
                let parent = node.parentNode;
                if (!parent || parent.nodeType != 1 || $a8a4766474a1e455$var$hasBlockDesc(node) || $a8a4766474a1e455$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
                off = $a8a4766474a1e455$var$domIndex(node) + (dir < 0 ? 0 : 1);
                node = parent;
            } else if (node.nodeType == 1) {
                node = node.childNodes[off + (dir < 0 ? -1 : 0)];
                if (node.contentEditable == "false") return false;
                off = dir < 0 ? $a8a4766474a1e455$var$nodeSize(node) : 0;
            } else return false;
        }
    }
    function $a8a4766474a1e455$var$nodeSize(node) {
        return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
    }
    function $a8a4766474a1e455$var$textNodeBefore$1(node, offset) {
        for(;;){
            if (node.nodeType == 3 && offset) return node;
            if (node.nodeType == 1 && offset > 0) {
                if (node.contentEditable == "false") return null;
                node = node.childNodes[offset - 1];
                offset = $a8a4766474a1e455$var$nodeSize(node);
            } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
                offset = $a8a4766474a1e455$var$domIndex(node);
                node = node.parentNode;
            } else return null;
        }
    }
    function $a8a4766474a1e455$var$textNodeAfter$1(node, offset) {
        for(;;){
            if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
            if (node.nodeType == 1 && offset < node.childNodes.length) {
                if (node.contentEditable == "false") return null;
                node = node.childNodes[offset];
                offset = 0;
            } else if (node.parentNode && !$a8a4766474a1e455$var$hasBlockDesc(node)) {
                offset = $a8a4766474a1e455$var$domIndex(node) + 1;
                node = node.parentNode;
            } else return null;
        }
    }
    function $a8a4766474a1e455$var$isOnEdge(node, offset, parent) {
        for(let atStart = offset == 0, atEnd = offset == $a8a4766474a1e455$var$nodeSize(node); atStart || atEnd;){
            if (node == parent) return true;
            let index = $a8a4766474a1e455$var$domIndex(node);
            node = node.parentNode;
            if (!node) return false;
            atStart = atStart && index == 0;
            atEnd = atEnd && index == $a8a4766474a1e455$var$nodeSize(node);
        }
    }
    function $a8a4766474a1e455$var$hasBlockDesc(dom) {
        let desc;
        for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
        return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
    }
    const $a8a4766474a1e455$var$selectionCollapsed = function(domSel) {
        return domSel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
    };
    function $a8a4766474a1e455$var$keyEvent(keyCode, key) {
        let event = document.createEvent("Event");
        event.initEvent("keydown", true, true);
        event.keyCode = keyCode;
        event.key = event.code = key;
        return event;
    }
    function $a8a4766474a1e455$var$deepActiveElement(doc) {
        let elt = doc.activeElement;
        while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
        return elt;
    }
    function $a8a4766474a1e455$var$caretFromPoint(doc, x, y) {
        if (doc.caretPositionFromPoint) try {
            let pos = doc.caretPositionFromPoint(x, y);
            if (pos) return {
                node: pos.offsetNode,
                offset: Math.min($a8a4766474a1e455$var$nodeSize(pos.offsetNode), pos.offset)
            };
        } catch (_) {}
        if (doc.caretRangeFromPoint) {
            let range = doc.caretRangeFromPoint(x, y);
            if (range) return {
                node: range.startContainer,
                offset: Math.min($a8a4766474a1e455$var$nodeSize(range.startContainer), range.startOffset)
            };
        }
    }
    const $a8a4766474a1e455$var$nav = typeof navigator != "undefined" ? navigator : null;
    const $a8a4766474a1e455$var$doc = typeof document != "undefined" ? document : null;
    const $a8a4766474a1e455$var$agent = $a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.userAgent || "";
    const $a8a4766474a1e455$var$ie_edge = /Edge\/(\d+)/.exec($a8a4766474a1e455$var$agent);
    const $a8a4766474a1e455$var$ie_upto10 = /MSIE \d/.exec($a8a4766474a1e455$var$agent);
    const $a8a4766474a1e455$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($a8a4766474a1e455$var$agent);
    const $a8a4766474a1e455$var$ie = !!($a8a4766474a1e455$var$ie_upto10 || $a8a4766474a1e455$var$ie_11up || $a8a4766474a1e455$var$ie_edge);
    const $a8a4766474a1e455$var$ie_version = $a8a4766474a1e455$var$ie_upto10 ? document.documentMode : $a8a4766474a1e455$var$ie_11up ? +$a8a4766474a1e455$var$ie_11up[1] : $a8a4766474a1e455$var$ie_edge ? +$a8a4766474a1e455$var$ie_edge[1] : 0;
    const $a8a4766474a1e455$var$gecko = !$a8a4766474a1e455$var$ie && /gecko\/(\d+)/i.test($a8a4766474a1e455$var$agent);
    $a8a4766474a1e455$var$gecko && (/Firefox\/(\d+)/.exec($a8a4766474a1e455$var$agent) || [
        0,
        0
    ])[1];
    const $a8a4766474a1e455$var$_chrome = !$a8a4766474a1e455$var$ie && /Chrome\/(\d+)/.exec($a8a4766474a1e455$var$agent);
    const $a8a4766474a1e455$var$chrome = !!$a8a4766474a1e455$var$_chrome;
    const $a8a4766474a1e455$var$chrome_version = $a8a4766474a1e455$var$_chrome ? +$a8a4766474a1e455$var$_chrome[1] : 0;
    const $a8a4766474a1e455$var$safari = !$a8a4766474a1e455$var$ie && !!$a8a4766474a1e455$var$nav && /Apple Computer/.test($a8a4766474a1e455$var$nav.vendor);
    const $a8a4766474a1e455$var$ios = $a8a4766474a1e455$var$safari && (/Mobile\/\w+/.test($a8a4766474a1e455$var$agent) || !!$a8a4766474a1e455$var$nav && $a8a4766474a1e455$var$nav.maxTouchPoints > 2);
    const $a8a4766474a1e455$var$mac = $a8a4766474a1e455$var$ios || ($a8a4766474a1e455$var$nav ? /Mac/.test($a8a4766474a1e455$var$nav.platform) : false);
    const $a8a4766474a1e455$var$windows = $a8a4766474a1e455$var$nav ? /Win/.test($a8a4766474a1e455$var$nav.platform) : false;
    const $a8a4766474a1e455$var$android = /Android \d/.test($a8a4766474a1e455$var$agent);
    const $a8a4766474a1e455$var$webkit = !!$a8a4766474a1e455$var$doc && "webkitFontSmoothing" in $a8a4766474a1e455$var$doc.documentElement.style;
    const $a8a4766474a1e455$var$webkit_version = $a8a4766474a1e455$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
        0,
        0
    ])[1] : 0;
    function $a8a4766474a1e455$var$windowRect(doc) {
        let vp = doc.defaultView && doc.defaultView.visualViewport;
        if (vp) return {
            left: 0,
            right: vp.width,
            top: 0,
            bottom: vp.height
        };
        return {
            left: 0,
            right: doc.documentElement.clientWidth,
            top: 0,
            bottom: doc.documentElement.clientHeight
        };
    }
    function $a8a4766474a1e455$var$getSide(value, side) {
        return typeof value == "number" ? value : value[side];
    }
    function $a8a4766474a1e455$var$clientRect(node) {
        let rect = node.getBoundingClientRect();
        let scaleX = rect.width / node.offsetWidth || 1;
        let scaleY = rect.height / node.offsetHeight || 1;
        return {
            left: rect.left,
            right: rect.left + node.clientWidth * scaleX,
            top: rect.top,
            bottom: rect.top + node.clientHeight * scaleY
        };
    }
    function $a8a4766474a1e455$var$scrollRectIntoView(view, rect, startDOM) {
        let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
        let doc = view.dom.ownerDocument;
        for(let parent = startDOM || view.dom;; parent = $a8a4766474a1e455$var$parentNode(parent)){
            if (!parent) break;
            if (parent.nodeType != 1) continue;
            let elt = parent;
            let atTop = elt == doc.body;
            let bounding = atTop ? $a8a4766474a1e455$var$windowRect(doc) : $a8a4766474a1e455$var$clientRect(elt);
            let moveX = 0, moveY = 0;
            if (rect.top < bounding.top + $a8a4766474a1e455$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top"));
            else if (rect.bottom > bounding.bottom - $a8a4766474a1e455$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $a8a4766474a1e455$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $a8a4766474a1e455$var$getSide(scrollMargin, "bottom");
            if (rect.left < bounding.left + $a8a4766474a1e455$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $a8a4766474a1e455$var$getSide(scrollMargin, "left"));
            else if (rect.right > bounding.right - $a8a4766474a1e455$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $a8a4766474a1e455$var$getSide(scrollMargin, "right");
            if (moveX || moveY) {
                if (atTop) doc.defaultView.scrollBy(moveX, moveY);
                else {
                    let startX = elt.scrollLeft, startY = elt.scrollTop;
                    if (moveY) elt.scrollTop += moveY;
                    if (moveX) elt.scrollLeft += moveX;
                    let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                    rect = {
                        left: rect.left - dX,
                        top: rect.top - dY,
                        right: rect.right - dX,
                        bottom: rect.bottom - dY
                    };
                }
            }
            if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
        }
    }
    function $a8a4766474a1e455$var$storeScrollPos(view) {
        let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
        let refDOM, refTop;
        for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
            let dom = view.root.elementFromPoint(x, y);
            if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
            let localRect = dom.getBoundingClientRect();
            if (localRect.top >= startY - 20) {
                refDOM = dom;
                refTop = localRect.top;
                break;
            }
        }
        return {
            refDOM: refDOM,
            refTop: refTop,
            stack: $a8a4766474a1e455$var$scrollStack(view.dom)
        };
    }
    function $a8a4766474a1e455$var$scrollStack(dom) {
        let stack = [], doc = dom.ownerDocument;
        for(let cur = dom; cur; cur = $a8a4766474a1e455$var$parentNode(cur)){
            stack.push({
                dom: cur,
                top: cur.scrollTop,
                left: cur.scrollLeft
            });
            if (dom == doc) break;
        }
        return stack;
    }
    function $a8a4766474a1e455$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
        let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
        $a8a4766474a1e455$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
    }
    function $a8a4766474a1e455$var$restoreScrollStack(stack, dTop) {
        for(let i = 0; i < stack.length; i++){
            let { dom: dom, top: top, left: left } = stack[i];
            if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
            if (dom.scrollLeft != left) dom.scrollLeft = left;
        }
    }
    let $a8a4766474a1e455$var$preventScrollSupported = null;
    function $a8a4766474a1e455$var$focusPreventScroll(dom) {
        if (dom.setActive) return dom.setActive();
        if ($a8a4766474a1e455$var$preventScrollSupported) return dom.focus($a8a4766474a1e455$var$preventScrollSupported);
        let stored = $a8a4766474a1e455$var$scrollStack(dom);
        dom.focus($a8a4766474a1e455$var$preventScrollSupported == null ? {
            get preventScroll () {
                $a8a4766474a1e455$var$preventScrollSupported = {
                    preventScroll: true
                };
                return true;
            }
        } : undefined);
        if (!$a8a4766474a1e455$var$preventScrollSupported) {
            $a8a4766474a1e455$var$preventScrollSupported = false;
            $a8a4766474a1e455$var$restoreScrollStack(stored, 0);
        }
    }
    function $a8a4766474a1e455$var$findOffsetInNode(node, coords) {
        let closest, dxClosest = 2e8, coordsClosest, offset = 0;
        let rowBot = coords.top, rowTop = coords.top;
        let firstBelow, coordsBelow;
        for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
            let rects;
            if (child.nodeType == 1) rects = child.getClientRects();
            else if (child.nodeType == 3) rects = $a8a4766474a1e455$var$textRange(child).getClientRects();
            else continue;
            for(let i = 0; i < rects.length; i++){
                let rect = rects[i];
                if (rect.top <= rowBot && rect.bottom >= rowTop) {
                    rowBot = Math.max(rect.bottom, rowBot);
                    rowTop = Math.min(rect.top, rowTop);
                    let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                    if (dx < dxClosest) {
                        closest = child;
                        dxClosest = dx;
                        coordsClosest = dx && closest.nodeType == 3 ? {
                            left: rect.right < coords.left ? rect.right : rect.left,
                            top: coords.top
                        } : coords;
                        if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                        continue;
                    }
                } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                    firstBelow = child;
                    coordsBelow = {
                        left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                        top: rect.top
                    };
                }
                if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
            }
        }
        if (!closest && firstBelow) {
            closest = firstBelow;
            coordsClosest = coordsBelow;
            dxClosest = 0;
        }
        if (closest && closest.nodeType == 3) return $a8a4766474a1e455$var$findOffsetInText(closest, coordsClosest);
        if (!closest || dxClosest && closest.nodeType == 1) return {
            node: node,
            offset: offset
        };
        return $a8a4766474a1e455$var$findOffsetInNode(closest, coordsClosest);
    }
    function $a8a4766474a1e455$var$findOffsetInText(node, coords) {
        let len = node.nodeValue.length;
        let range = document.createRange();
        for(let i = 0; i < len; i++){
            range.setEnd(node, i + 1);
            range.setStart(node, i);
            let rect = $a8a4766474a1e455$var$singleRect(range, 1);
            if (rect.top == rect.bottom) continue;
            if ($a8a4766474a1e455$var$inRect(coords, rect)) return {
                node: node,
                offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
            };
        }
        return {
            node: node,
            offset: 0
        };
    }
    function $a8a4766474a1e455$var$inRect(coords, rect) {
        return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
    }
    function $a8a4766474a1e455$var$targetKludge(dom, coords) {
        let parent = dom.parentNode;
        if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
        return dom;
    }
    function $a8a4766474a1e455$var$posFromElement(view, elt, coords) {
        let { node: node, offset: offset } = $a8a4766474a1e455$var$findOffsetInNode(elt, coords), bias = -1;
        if (node.nodeType == 1 && !node.firstChild) {
            let rect = node.getBoundingClientRect();
            bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
        }
        return view.docView.posFromDOM(node, offset, bias);
    }
    function $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords) {
        let outsideBlock = -1;
        for(let cur = node, sawBlock = false;;){
            if (cur == view.dom) break;
            let desc = view.docView.nearestDesc(cur, true);
            if (!desc) return null;
            if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM)) {
                let rect = desc.dom.getBoundingClientRect();
                if (desc.node.isBlock && desc.parent) {
                    if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                    else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                    sawBlock = true;
                }
                if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                    let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                    return before ? desc.posBefore : desc.posAfter;
                }
            }
            cur = desc.dom.parentNode;
        }
        return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
    }
    function $a8a4766474a1e455$var$elementFromPoint(element, coords, box) {
        let len = element.childNodes.length;
        if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
            let child = element.childNodes[i];
            if (child.nodeType == 1) {
                let rects = child.getClientRects();
                for(let j = 0; j < rects.length; j++){
                    let rect = rects[j];
                    if ($a8a4766474a1e455$var$inRect(coords, rect)) return $a8a4766474a1e455$var$elementFromPoint(child, coords, rect);
                }
            }
            if ((i = (i + 1) % len) == startI) break;
        }
        return element;
    }
    function $a8a4766474a1e455$var$posAtCoords(view, coords) {
        let doc = view.dom.ownerDocument, node, offset = 0;
        let caret = $a8a4766474a1e455$var$caretFromPoint(doc, coords.left, coords.top);
        if (caret) ({ node: node, offset: offset } = caret);
        let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
        let pos;
        if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
            let box = view.dom.getBoundingClientRect();
            if (!$a8a4766474a1e455$var$inRect(coords, box)) return null;
            elt = $a8a4766474a1e455$var$elementFromPoint(view.dom, coords, box);
            if (!elt) return null;
        }
        if ($a8a4766474a1e455$var$safari) {
            for(let p = elt; node && p; p = $a8a4766474a1e455$var$parentNode(p))if (p.draggable) node = undefined;
        }
        elt = $a8a4766474a1e455$var$targetKludge(elt, coords);
        if (node) {
            if ($a8a4766474a1e455$var$gecko && node.nodeType == 1) {
                offset = Math.min(offset, node.childNodes.length);
                if (offset < node.childNodes.length) {
                    let next = node.childNodes[offset], box;
                    if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
                }
            }
            let prev;
            if ($a8a4766474a1e455$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
            if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
            else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $a8a4766474a1e455$var$posFromCaret(view, node, offset, coords);
        }
        if (pos == null) pos = $a8a4766474a1e455$var$posFromElement(view, elt, coords);
        let desc = view.docView.nearestDesc(elt, true);
        return {
            pos: pos,
            inside: desc ? desc.posAtStart - desc.border : -1
        };
    }
    function $a8a4766474a1e455$var$nonZero(rect) {
        return rect.top < rect.bottom || rect.left < rect.right;
    }
    function $a8a4766474a1e455$var$singleRect(target, bias) {
        let rects = target.getClientRects();
        if (rects.length) {
            let first = rects[bias < 0 ? 0 : rects.length - 1];
            if ($a8a4766474a1e455$var$nonZero(first)) return first;
        }
        return Array.prototype.find.call(rects, $a8a4766474a1e455$var$nonZero) || target.getBoundingClientRect();
    }
    const $a8a4766474a1e455$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
    function $a8a4766474a1e455$var$coordsAtPos(view, pos, side) {
        let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
        let supportEmptyRange = $a8a4766474a1e455$var$webkit || $a8a4766474a1e455$var$gecko;
        if (node.nodeType == 3) {
            if (supportEmptyRange && ($a8a4766474a1e455$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
                let rect = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset), side);
                if ($a8a4766474a1e455$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                    let rectBefore = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset - 1, offset - 1), -1);
                    if (rectBefore.top == rect.top) {
                        let rectAfter = $a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, offset, offset + 1), -1);
                        if (rectAfter.top != rect.top) return $a8a4766474a1e455$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                    }
                }
                return rect;
            } else {
                let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
                if (side < 0 && !offset) {
                    to++;
                    takeSide = -1;
                } else if (side >= 0 && offset == node.nodeValue.length) {
                    from--;
                    takeSide = 1;
                } else if (side < 0) from--;
                else to++;
                return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect($a8a4766474a1e455$var$textRange(node, from, to), takeSide), takeSide < 0);
            }
        }
        let $dom = view.state.doc.resolve(pos - (atom || 0));
        if (!$dom.parent.inlineContent) {
            if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
                let before = node.childNodes[offset - 1];
                if (before.nodeType == 1) return $a8a4766474a1e455$var$flattenH(before.getBoundingClientRect(), false);
            }
            if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
                let after = node.childNodes[offset];
                if (after.nodeType == 1) return $a8a4766474a1e455$var$flattenH(after.getBoundingClientRect(), true);
            }
            return $a8a4766474a1e455$var$flattenH(node.getBoundingClientRect(), side >= 0);
        }
        if (atom == null && offset && (side < 0 || offset == $a8a4766474a1e455$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            let target = before.nodeType == 3 ? $a8a4766474a1e455$var$textRange(before, $a8a4766474a1e455$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
            if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, 1), false);
        }
        if (atom == null && offset < $a8a4766474a1e455$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
            let target = !after ? null : after.nodeType == 3 ? $a8a4766474a1e455$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
            if (target) return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(target, -1), true);
        }
        return $a8a4766474a1e455$var$flattenV($a8a4766474a1e455$var$singleRect(node.nodeType == 3 ? $a8a4766474a1e455$var$textRange(node) : node, -side), side >= 0);
    }
    function $a8a4766474a1e455$var$flattenV(rect, left) {
        if (rect.width == 0) return rect;
        let x = left ? rect.left : rect.right;
        return {
            top: rect.top,
            bottom: rect.bottom,
            left: x,
            right: x
        };
    }
    function $a8a4766474a1e455$var$flattenH(rect, top) {
        if (rect.height == 0) return rect;
        let y = top ? rect.top : rect.bottom;
        return {
            top: y,
            bottom: y,
            left: rect.left,
            right: rect.right
        };
    }
    function $a8a4766474a1e455$var$withFlushedState(view, state, f) {
        let viewState = view.state, active = view.root.activeElement;
        if (viewState != state) view.updateState(state);
        if (active != view.dom) view.focus();
        try {
            return f();
        } finally{
            if (viewState != state) view.updateState(viewState);
            if (active != view.dom && active) active.focus();
        }
    }
    function $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) {
        let sel = state.selection;
        let $pos = dir == "up" ? sel.$from : sel.$to;
        return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
            let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
            for(;;){
                let nearest = view.docView.nearestDesc(dom, true);
                if (!nearest) break;
                if (nearest.node.isBlock) {
                    dom = nearest.contentDOM || nearest.dom;
                    break;
                }
                dom = nearest.dom.parentNode;
            }
            let coords = $a8a4766474a1e455$var$coordsAtPos(view, $pos.pos, 1);
            for(let child = dom.firstChild; child; child = child.nextSibling){
                let boxes;
                if (child.nodeType == 1) boxes = child.getClientRects();
                else if (child.nodeType == 3) boxes = $a8a4766474a1e455$var$textRange(child, 0, child.nodeValue.length).getClientRects();
                else continue;
                for(let i = 0; i < boxes.length; i++){
                    let box = boxes[i];
                    if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
                }
            }
            return true;
        });
    }
    const $a8a4766474a1e455$var$maybeRTL = /[\u0590-\u08ac]/;
    function $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir) {
        let { $head: $head } = state.selection;
        if (!$head.parent.isTextblock) return false;
        let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
        let sel = view.domSelection();
        if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
        if (!$a8a4766474a1e455$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
        return $a8a4766474a1e455$var$withFlushedState(view, state, ()=>{
            let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
            let oldBidiLevel = sel.caretBidiLevel;
            sel.modify("move", dir, "character");
            let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
            let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
            let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
            try {
                sel.collapse(anchorNode, anchorOffset);
                if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
            } catch (_) {}
            if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
            return result;
        });
    }
    let $a8a4766474a1e455$var$cachedState = null;
    let $a8a4766474a1e455$var$cachedDir = null;
    let $a8a4766474a1e455$var$cachedResult = false;
    function $a8a4766474a1e455$var$endOfTextblock(view, state, dir) {
        if ($a8a4766474a1e455$var$cachedState == state && $a8a4766474a1e455$var$cachedDir == dir) return $a8a4766474a1e455$var$cachedResult;
        $a8a4766474a1e455$var$cachedState = state;
        $a8a4766474a1e455$var$cachedDir = dir;
        return $a8a4766474a1e455$var$cachedResult = dir == "up" || dir == "down" ? $a8a4766474a1e455$var$endOfTextblockVertical(view, state, dir) : $a8a4766474a1e455$var$endOfTextblockHorizontal(view, state, dir);
    }
    const $a8a4766474a1e455$var$NOT_DIRTY = 0, $a8a4766474a1e455$var$CHILD_DIRTY = 1, $a8a4766474a1e455$var$CONTENT_DIRTY = 2, $a8a4766474a1e455$var$NODE_DIRTY = 3;
    class $a8a4766474a1e455$var$ViewDesc {
        constructor(parent, children, dom, contentDOM){
            this.parent = parent;
            this.children = children;
            this.dom = dom;
            this.contentDOM = contentDOM;
            this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
            dom.pmViewDesc = this;
        }
        matchesWidget(widget) {
            return false;
        }
        matchesMark(mark) {
            return false;
        }
        matchesNode(node, outerDeco, innerDeco) {
            return false;
        }
        matchesHack(nodeName) {
            return false;
        }
        parseRule() {
            return null;
        }
        stopEvent(event) {
            return false;
        }
        get size() {
            let size = 0;
            for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
            return size;
        }
        get border() {
            return 0;
        }
        destroy() {
            this.parent = undefined;
            if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
            for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
        }
        posBeforeChild(child) {
            for(let i = 0, pos = this.posAtStart;; i++){
                let cur = this.children[i];
                if (cur == child) return pos;
                pos += cur.size;
            }
        }
        get posBefore() {
            return this.parent.posBeforeChild(this);
        }
        get posAtStart() {
            return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
        }
        get posAfter() {
            return this.posBefore + this.size;
        }
        get posAtEnd() {
            return this.posAtStart + this.size - 2 * this.border;
        }
        localPosFromDOM(dom, offset, bias) {
            if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
                if (bias < 0) {
                    let domBefore, desc;
                    if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                    else {
                        while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                        domBefore = dom.previousSibling;
                    }
                    while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                    return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
                } else {
                    let domAfter, desc;
                    if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                    else {
                        while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                        domAfter = dom.nextSibling;
                    }
                    while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                    return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
                }
            }
            let atEnd;
            if (dom == this.dom && this.contentDOM) atEnd = offset > $a8a4766474a1e455$var$domIndex(this.contentDOM);
            else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
            else if (this.dom.firstChild) {
                if (offset == 0) for(let search = dom;; search = search.parentNode){
                    if (search == this.dom) {
                        atEnd = false;
                        break;
                    }
                    if (search.previousSibling) break;
                }
                if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                    if (search == this.dom) {
                        atEnd = true;
                        break;
                    }
                    if (search.nextSibling) break;
                }
            }
            return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
        }
        nearestDesc(dom, onlyNodes = false) {
            for(let first = true, cur = dom; cur; cur = cur.parentNode){
                let desc = this.getDesc(cur), nodeDOM;
                if (desc && (!onlyNodes || desc.node)) {
                    if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                    else return desc;
                }
            }
        }
        getDesc(dom) {
            let desc = dom.pmViewDesc;
            for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
        }
        posFromDOM(dom, offset, bias) {
            for(let scan = dom; scan; scan = scan.parentNode){
                let desc = this.getDesc(scan);
                if (desc) return desc.localPosFromDOM(dom, offset, bias);
            }
            return -1;
        }
        descAt(pos) {
            for(let i = 0, offset = 0; i < this.children.length; i++){
                let child = this.children[i], end = offset + child.size;
                if (offset == pos && end != offset) {
                    while(!child.border && child.children.length)child = child.children[0];
                    return child;
                }
                if (pos < end) return child.descAt(pos - offset - child.border);
                offset = end;
            }
        }
        domFromPos(pos, side) {
            if (!this.contentDOM) return {
                node: this.dom,
                offset: 0,
                atom: pos + 1
            };
            let i = 0, offset = 0;
            for(let curPos = 0; i < this.children.length; i++){
                let child = this.children[i], end = curPos + child.size;
                if (end > pos || child instanceof $a8a4766474a1e455$var$TrailingHackViewDesc) {
                    offset = pos - curPos;
                    break;
                }
                curPos = end;
            }
            if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
            for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $a8a4766474a1e455$var$WidgetViewDesc && prev.side >= 0; i--);
            if (side <= 0) {
                let prev, enter = true;
                for(;; i--, enter = false){
                    prev = i ? this.children[i - 1] : null;
                    if (!prev || prev.dom.parentNode == this.contentDOM) break;
                }
                if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
                return {
                    node: this.contentDOM,
                    offset: prev ? $a8a4766474a1e455$var$domIndex(prev.dom) + 1 : 0
                };
            } else {
                let next, enter = true;
                for(;; i++, enter = false){
                    next = i < this.children.length ? this.children[i] : null;
                    if (!next || next.dom.parentNode == this.contentDOM) break;
                }
                if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
                return {
                    node: this.contentDOM,
                    offset: next ? $a8a4766474a1e455$var$domIndex(next.dom) : this.contentDOM.childNodes.length
                };
            }
        }
        parseRange(from, to, base = 0) {
            if (this.children.length == 0) return {
                node: this.contentDOM,
                from: from,
                to: to,
                fromOffset: 0,
                toOffset: this.contentDOM.childNodes.length
            };
            let fromOffset = -1, toOffset = -1;
            for(let offset = base, i = 0;; i++){
                let child = this.children[i], end = offset + child.size;
                if (fromOffset == -1 && from <= end) {
                    let childBase = offset + child.border;
                    if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                    from = offset;
                    for(let j = i; j > 0; j--){
                        let prev = this.children[j - 1];
                        if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                            fromOffset = $a8a4766474a1e455$var$domIndex(prev.dom) + 1;
                            break;
                        }
                        from -= prev.size;
                    }
                    if (fromOffset == -1) fromOffset = 0;
                }
                if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                    to = end;
                    for(let j = i + 1; j < this.children.length; j++){
                        let next = this.children[j];
                        if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                            toOffset = $a8a4766474a1e455$var$domIndex(next.dom);
                            break;
                        }
                        to += next.size;
                    }
                    if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                    break;
                }
                offset = end;
            }
            return {
                node: this.contentDOM,
                from: from,
                to: to,
                fromOffset: fromOffset,
                toOffset: toOffset
            };
        }
        emptyChildAt(side) {
            if (this.border || !this.contentDOM || !this.children.length) return false;
            let child = this.children[side < 0 ? 0 : this.children.length - 1];
            return child.size == 0 || child.emptyChildAt(side);
        }
        domAfterPos(pos) {
            let { node: node, offset: offset } = this.domFromPos(pos, 0);
            if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
            return node.childNodes[offset];
        }
        setSelection(anchor, head, root, force = false) {
            let from = Math.min(anchor, head), to = Math.max(anchor, head);
            for(let i = 0, offset = 0; i < this.children.length; i++){
                let child = this.children[i], end = offset + child.size;
                if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force);
                offset = end;
            }
            let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
            let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
            let domSel = root.getSelection();
            let brKludge = false;
            if (($a8a4766474a1e455$var$gecko || $a8a4766474a1e455$var$safari) && anchor == head) {
                let { node: node, offset: offset } = anchorDOM;
                if (node.nodeType == 3) {
                    brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                    if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                        if (after = scan.nextSibling) {
                            if (after.nodeName == "BR") anchorDOM = headDOM = {
                                node: after.parentNode,
                                offset: $a8a4766474a1e455$var$domIndex(after) + 1
                            };
                            break;
                        }
                        let desc = scan.pmViewDesc;
                        if (desc && desc.node && desc.node.isBlock) break;
                    }
                } else {
                    let prev = node.childNodes[offset - 1];
                    brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
                }
            }
            if ($a8a4766474a1e455$var$gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
                let after = domSel.focusNode.childNodes[domSel.focusOffset];
                if (after && after.contentEditable == "false") force = true;
            }
            if (!(force || brKludge && $a8a4766474a1e455$var$safari) && $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && $a8a4766474a1e455$var$isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) return;
            let domSelExtended = false;
            if ((domSel.extend || anchor == head) && !brKludge) {
                domSel.collapse(anchorDOM.node, anchorDOM.offset);
                try {
                    if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                    domSelExtended = true;
                } catch (_) {}
            }
            if (!domSelExtended) {
                if (anchor > head) {
                    let tmp = anchorDOM;
                    anchorDOM = headDOM;
                    headDOM = tmp;
                }
                let range = document.createRange();
                range.setEnd(headDOM.node, headDOM.offset);
                range.setStart(anchorDOM.node, anchorDOM.offset);
                domSel.removeAllRanges();
                domSel.addRange(range);
            }
        }
        ignoreMutation(mutation) {
            return !this.contentDOM && mutation.type != "selection";
        }
        get contentLost() {
            return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
        }
        markDirty(from, to) {
            for(let offset = 0, i = 0; i < this.children.length; i++){
                let child = this.children[i], end = offset + child.size;
                if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                    let startInside = offset + child.border, endInside = end - child.border;
                    if (from >= startInside && to <= endInside) {
                        this.dirty = from == offset || to == end ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
                        if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
                        else child.markDirty(from - startInside, to - startInside);
                        return;
                    } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$NODE_DIRTY;
                }
                offset = end;
            }
            this.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
        }
        markParentsDirty() {
            let level = 1;
            for(let node = this.parent; node; node = node.parent, level++){
                let dirty = level == 1 ? $a8a4766474a1e455$var$CONTENT_DIRTY : $a8a4766474a1e455$var$CHILD_DIRTY;
                if (node.dirty < dirty) node.dirty = dirty;
            }
        }
        get domAtom() {
            return false;
        }
        get ignoreForCoords() {
            return false;
        }
        isText(text) {
            return false;
        }
    }
    class $a8a4766474a1e455$var$WidgetViewDesc extends $a8a4766474a1e455$var$ViewDesc {
        constructor(parent, widget, view, pos){
            let self, dom = widget.type.toDOM;
            if (typeof dom == "function") dom = dom(view, ()=>{
                if (!self) return pos;
                if (self.parent) return self.parent.posBeforeChild(self);
            });
            if (!widget.type.spec.raw) {
                if (dom.nodeType != 1) {
                    let wrap = document.createElement("span");
                    wrap.appendChild(dom);
                    dom = wrap;
                }
                dom.contentEditable = "false";
                dom.classList.add("ProseMirror-widget");
            }
            super(parent, [], dom, null);
            this.widget = widget;
            this.widget = widget;
            self = this;
        }
        matchesWidget(widget) {
            return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && widget.type.eq(this.widget.type);
        }
        parseRule() {
            return {
                ignore: true
            };
        }
        stopEvent(event) {
            let stop = this.widget.spec.stopEvent;
            return stop ? stop(event) : false;
        }
        ignoreMutation(mutation) {
            return mutation.type != "selection" || this.widget.spec.ignoreSelection;
        }
        destroy() {
            this.widget.type.destroy(this.dom);
            super.destroy();
        }
        get domAtom() {
            return true;
        }
        get side() {
            return this.widget.type.side;
        }
    }
    class $a8a4766474a1e455$var$CompositionViewDesc extends $a8a4766474a1e455$var$ViewDesc {
        constructor(parent, dom, textDOM, text){
            super(parent, [], dom, null);
            this.textDOM = textDOM;
            this.text = text;
        }
        get size() {
            return this.text.length;
        }
        localPosFromDOM(dom, offset) {
            if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
            return this.posAtStart + offset;
        }
        domFromPos(pos) {
            return {
                node: this.textDOM,
                offset: pos
            };
        }
        ignoreMutation(mut) {
            return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
        }
    }
    class $a8a4766474a1e455$var$MarkViewDesc extends $a8a4766474a1e455$var$ViewDesc {
        constructor(parent, mark, dom, contentDOM){
            super(parent, [], dom, contentDOM);
            this.mark = mark;
        }
        static create(parent, mark, inline, view) {
            let custom = view.nodeViews[mark.type.name];
            let spec = custom && custom(mark, view, inline);
            if (!spec || !spec.dom) spec = (0, (0, parcelRequire("kCV8T")).DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
            return new $a8a4766474a1e455$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom);
        }
        parseRule() {
            if (this.dirty & $a8a4766474a1e455$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
            return {
                mark: this.mark.type.name,
                attrs: this.mark.attrs,
                contentElement: this.contentDOM
            };
        }
        matchesMark(mark) {
            return this.dirty != $a8a4766474a1e455$var$NODE_DIRTY && this.mark.eq(mark);
        }
        markDirty(from, to) {
            super.markDirty(from, to);
            if (this.dirty != $a8a4766474a1e455$var$NOT_DIRTY) {
                let parent = this.parent;
                while(!parent.node)parent = parent.parent;
                if (parent.dirty < this.dirty) parent.dirty = this.dirty;
                this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
            }
        }
        slice(from, to, view) {
            let copy = $a8a4766474a1e455$var$MarkViewDesc.create(this.parent, this.mark, true, view);
            let nodes = this.children, size = this.size;
            if (to < size) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, to, size, view);
            if (from > 0) nodes = $a8a4766474a1e455$var$replaceNodes(nodes, 0, from, view);
            for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
            copy.children = nodes;
            return copy;
        }
    }
    class $a8a4766474a1e455$var$NodeViewDesc extends $a8a4766474a1e455$var$ViewDesc {
        constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
            super(parent, [], dom, contentDOM);
            this.node = node;
            this.outerDeco = outerDeco;
            this.innerDeco = innerDeco;
            this.nodeDOM = nodeDOM;
        }
        static create(parent, node, outerDeco, innerDeco, view, pos) {
            let custom = view.nodeViews[node.type.name], descObj;
            let spec = custom && custom(node, view, ()=>{
                if (!descObj) return pos;
                if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
            }, outerDeco, innerDeco);
            let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
            if (node.isText) {
                if (!dom) dom = document.createTextNode(node.text);
                else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
            } else if (!dom) {
                let spec = (0, (0, parcelRequire("kCV8T")).DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
                ({ dom: dom, contentDOM: contentDOM } = spec);
            }
            if (!contentDOM && !node.isText && dom.nodeName != "BR") {
                if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
                if (node.type.spec.draggable) dom.draggable = true;
            }
            let nodeDOM = dom;
            dom = $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, node);
            if (spec) return descObj = new $a8a4766474a1e455$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
            else if (node.isText) return new $a8a4766474a1e455$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
            else return new $a8a4766474a1e455$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
        }
        parseRule() {
            if (this.node.type.spec.reparseInView) return null;
            let rule = {
                node: this.node.type.name,
                attrs: this.node.attrs
            };
            if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
            if (!this.contentDOM) rule.getContent = ()=>this.node.content;
            else if (!this.contentLost) rule.contentElement = this.contentDOM;
            else {
                for(let i = this.children.length - 1; i >= 0; i--){
                    let child = this.children[i];
                    if (this.dom.contains(child.dom.parentNode)) {
                        rule.contentElement = child.dom.parentNode;
                        break;
                    }
                }
                if (!rule.contentElement) rule.getContent = ()=>(0, (0, parcelRequire("kCV8T")).Fragment).empty;
            }
            return rule;
        }
        matchesNode(node, outerDeco, innerDeco) {
            return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && node.eq(this.node) && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
        }
        get size() {
            return this.node.nodeSize;
        }
        get border() {
            return this.node.isLeaf ? 0 : 1;
        }
        updateChildren(view, pos) {
            let inline = this.node.inlineContent, off = pos;
            let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
            let localComposition = composition && composition.pos > -1 ? composition : null;
            let compositionInChild = composition && composition.pos < 0;
            let updater = new $a8a4766474a1e455$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
            $a8a4766474a1e455$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
                if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
                else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, (0, parcelRequire("kCV8T")).Mark).none : this.node.child(i).marks, inline, view);
                updater.placeWidget(widget, view, off);
            }, (child, outerDeco, innerDeco, i)=>{
                updater.syncToMarks(child.marks, inline, view);
                let compIndex;
                if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
                else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
                else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
                else updater.addNode(child, outerDeco, innerDeco, view, off);
                off += child.nodeSize;
            });
            updater.syncToMarks([], inline, view);
            if (this.node.isTextblock) updater.addTextblockHacks();
            updater.destroyRest();
            if (updater.changed || this.dirty == $a8a4766474a1e455$var$CONTENT_DIRTY) {
                if (localComposition) this.protectLocalComposition(view, localComposition);
                $a8a4766474a1e455$var$renderDescs(this.contentDOM, this.children, view);
                if ($a8a4766474a1e455$var$ios) $a8a4766474a1e455$var$iosHacks(this.dom);
            }
        }
        localCompositionInfo(view, pos) {
            let { from: from, to: to } = view.state.selection;
            if (!(view.state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
            let textNode = view.input.compositionNode;
            if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
            if (this.node.inlineContent) {
                let text = textNode.nodeValue;
                let textPos = $a8a4766474a1e455$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
                return textPos < 0 ? null : {
                    node: textNode,
                    pos: textPos,
                    text: text
                };
            } else return {
                node: textNode,
                pos: -1,
                text: ""
            };
        }
        protectLocalComposition(view, { node: node, pos: pos, text: text }) {
            if (this.getDesc(node)) return;
            let topNode = node;
            for(;; topNode = topNode.parentNode){
                if (topNode.parentNode == this.contentDOM) break;
                while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
                while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
                if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
            }
            let desc = new $a8a4766474a1e455$var$CompositionViewDesc(this, topNode, node, text);
            view.input.compositionNodes.push(desc);
            this.children = $a8a4766474a1e455$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
        }
        update(node, outerDeco, innerDeco, view) {
            if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
            this.updateInner(node, outerDeco, innerDeco, view);
            return true;
        }
        updateInner(node, outerDeco, innerDeco, view) {
            this.updateOuterDeco(outerDeco);
            this.node = node;
            this.innerDeco = innerDeco;
            if (this.contentDOM) this.updateChildren(view, this.posAtStart);
            this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
        }
        updateOuterDeco(outerDeco) {
            if ($a8a4766474a1e455$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
            let needsWrap = this.nodeDOM.nodeType != 1;
            let oldDOM = this.dom;
            this.dom = $a8a4766474a1e455$var$patchOuterDeco(this.dom, this.nodeDOM, $a8a4766474a1e455$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $a8a4766474a1e455$var$computeOuterDeco(outerDeco, this.node, needsWrap));
            if (this.dom != oldDOM) {
                oldDOM.pmViewDesc = undefined;
                this.dom.pmViewDesc = this;
            }
            this.outerDeco = outerDeco;
        }
        selectNode() {
            if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
        }
        deselectNode() {
            if (this.nodeDOM.nodeType == 1) {
                this.nodeDOM.classList.remove("ProseMirror-selectednode");
                if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
            }
        }
        get domAtom() {
            return this.node.isAtom;
        }
    }
    function $a8a4766474a1e455$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
        $a8a4766474a1e455$var$applyOuterDeco(dom, outerDeco, doc);
        let docView = new $a8a4766474a1e455$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
        if (docView.contentDOM) docView.updateChildren(view, 0);
        return docView;
    }
    class $a8a4766474a1e455$var$TextViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
        constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
            super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
        }
        parseRule() {
            let skip = this.nodeDOM.parentNode;
            while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
            return {
                skip: skip || true
            };
        }
        update(node, outerDeco, innerDeco, view) {
            if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY || this.dirty != $a8a4766474a1e455$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
            this.updateOuterDeco(outerDeco);
            if ((this.dirty != $a8a4766474a1e455$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
                this.nodeDOM.nodeValue = node.text;
                if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
            }
            this.node = node;
            this.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
            return true;
        }
        inParent() {
            let parentDOM = this.parent.contentDOM;
            for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
            return false;
        }
        domFromPos(pos) {
            return {
                node: this.nodeDOM,
                offset: pos
            };
        }
        localPosFromDOM(dom, offset, bias) {
            if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
            return super.localPosFromDOM(dom, offset, bias);
        }
        ignoreMutation(mutation) {
            return mutation.type != "characterData" && mutation.type != "selection";
        }
        slice(from, to, view) {
            let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
            return new $a8a4766474a1e455$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
        }
        markDirty(from, to) {
            super.markDirty(from, to);
            if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $a8a4766474a1e455$var$NODE_DIRTY;
        }
        get domAtom() {
            return false;
        }
        isText(text) {
            return this.node.text == text;
        }
    }
    class $a8a4766474a1e455$var$TrailingHackViewDesc extends $a8a4766474a1e455$var$ViewDesc {
        parseRule() {
            return {
                ignore: true
            };
        }
        matchesHack(nodeName) {
            return this.dirty == $a8a4766474a1e455$var$NOT_DIRTY && this.dom.nodeName == nodeName;
        }
        get domAtom() {
            return true;
        }
        get ignoreForCoords() {
            return this.dom.nodeName == "IMG";
        }
    }
    class $a8a4766474a1e455$var$CustomNodeViewDesc extends $a8a4766474a1e455$var$NodeViewDesc {
        constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
            super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
            this.spec = spec;
        }
        update(node, outerDeco, innerDeco, view) {
            if (this.dirty == $a8a4766474a1e455$var$NODE_DIRTY) return false;
            if (this.spec.update) {
                let result = this.spec.update(node, outerDeco, innerDeco);
                if (result) this.updateInner(node, outerDeco, innerDeco, view);
                return result;
            } else if (!this.contentDOM && !node.isLeaf) return false;
            else return super.update(node, outerDeco, innerDeco, view);
        }
        selectNode() {
            this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
        }
        deselectNode() {
            this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
        }
        setSelection(anchor, head, root, force) {
            this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : super.setSelection(anchor, head, root, force);
        }
        destroy() {
            if (this.spec.destroy) this.spec.destroy();
            super.destroy();
        }
        stopEvent(event) {
            return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
        }
        ignoreMutation(mutation) {
            return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
        }
    }
    function $a8a4766474a1e455$var$renderDescs(parentDOM, descs, view) {
        let dom = parentDOM.firstChild, written = false;
        for(let i = 0; i < descs.length; i++){
            let desc = descs[i], childDOM = desc.dom;
            if (childDOM.parentNode == parentDOM) {
                while(childDOM != dom){
                    dom = $a8a4766474a1e455$var$rm(dom);
                    written = true;
                }
                dom = dom.nextSibling;
            } else {
                written = true;
                parentDOM.insertBefore(childDOM, dom);
            }
            if (desc instanceof $a8a4766474a1e455$var$MarkViewDesc) {
                let pos = dom ? dom.previousSibling : parentDOM.lastChild;
                $a8a4766474a1e455$var$renderDescs(desc.contentDOM, desc.children, view);
                dom = pos ? pos.nextSibling : parentDOM.firstChild;
            }
        }
        while(dom){
            dom = $a8a4766474a1e455$var$rm(dom);
            written = true;
        }
        if (written && view.trackWrites == parentDOM) view.trackWrites = null;
    }
    const $a8a4766474a1e455$var$OuterDecoLevel = function(nodeName) {
        if (nodeName) this.nodeName = nodeName;
    };
    $a8a4766474a1e455$var$OuterDecoLevel.prototype = Object.create(null);
    const $a8a4766474a1e455$var$noDeco = [
        new $a8a4766474a1e455$var$OuterDecoLevel
    ];
    function $a8a4766474a1e455$var$computeOuterDeco(outerDeco, node, needsWrap) {
        if (outerDeco.length == 0) return $a8a4766474a1e455$var$noDeco;
        let top = needsWrap ? $a8a4766474a1e455$var$noDeco[0] : new $a8a4766474a1e455$var$OuterDecoLevel, result = [
            top
        ];
        for(let i = 0; i < outerDeco.length; i++){
            let attrs = outerDeco[i].type.attrs;
            if (!attrs) continue;
            if (attrs.nodeName) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(attrs.nodeName));
            for(let name in attrs){
                let val = attrs[name];
                if (val == null) continue;
                if (needsWrap && result.length == 1) result.push(top = new $a8a4766474a1e455$var$OuterDecoLevel(node.isInline ? "span" : "div"));
                if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
                else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
                else if (name != "nodeName") top[name] = val;
            }
        }
        return result;
    }
    function $a8a4766474a1e455$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
        if (prevComputed == $a8a4766474a1e455$var$noDeco && curComputed == $a8a4766474a1e455$var$noDeco) return nodeDOM;
        let curDOM = nodeDOM;
        for(let i = 0; i < curComputed.length; i++){
            let deco = curComputed[i], prev = prevComputed[i];
            if (i) {
                let parent;
                if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
                else {
                    parent = document.createElement(deco.nodeName);
                    parent.pmIsDeco = true;
                    parent.appendChild(curDOM);
                    prev = $a8a4766474a1e455$var$noDeco[0];
                    curDOM = parent;
                }
            }
            $a8a4766474a1e455$var$patchAttributes(curDOM, prev || $a8a4766474a1e455$var$noDeco[0], deco);
        }
        return curDOM;
    }
    function $a8a4766474a1e455$var$patchAttributes(dom, prev, cur) {
        for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
        for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
        if (prev.class != cur.class) {
            let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
            let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
            for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
            for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
            if (dom.classList.length == 0) dom.removeAttribute("class");
        }
        if (prev.style != cur.style) {
            if (prev.style) {
                let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
                while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
            }
            if (cur.style) dom.style.cssText += cur.style;
        }
    }
    function $a8a4766474a1e455$var$applyOuterDeco(dom, deco, node) {
        return $a8a4766474a1e455$var$patchOuterDeco(dom, dom, $a8a4766474a1e455$var$noDeco, $a8a4766474a1e455$var$computeOuterDeco(deco, node, dom.nodeType != 1));
    }
    function $a8a4766474a1e455$var$sameOuterDeco(a, b) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
        return true;
    }
    function $a8a4766474a1e455$var$rm(dom) {
        let next = dom.nextSibling;
        dom.parentNode.removeChild(dom);
        return next;
    }
    class $a8a4766474a1e455$var$ViewTreeUpdater {
        constructor(top, lock, view){
            this.lock = lock;
            this.view = view;
            this.index = 0;
            this.stack = [];
            this.changed = false;
            this.top = top;
            this.preMatch = $a8a4766474a1e455$var$preMatch(top.node.content, top);
        }
        destroyBetween(start, end) {
            if (start == end) return;
            for(let i = start; i < end; i++)this.top.children[i].destroy();
            this.top.children.splice(start, end - start);
            this.changed = true;
        }
        destroyRest() {
            this.destroyBetween(this.index, this.top.children.length);
        }
        syncToMarks(marks, inline, view) {
            let keep = 0, depth = this.stack.length >> 1;
            let maxKeep = Math.min(depth, marks.length);
            while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
            while(keep < depth){
                this.destroyRest();
                this.top.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
                this.index = this.stack.pop();
                this.top = this.stack.pop();
                depth--;
            }
            while(depth < marks.length){
                this.stack.push(this.top, this.index + 1);
                let found = -1;
                for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                    let next = this.top.children[i];
                    if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                        found = i;
                        break;
                    }
                }
                if (found > -1) {
                    if (found > this.index) {
                        this.changed = true;
                        this.destroyBetween(this.index, found);
                    }
                    this.top = this.top.children[this.index];
                } else {
                    let markDesc = $a8a4766474a1e455$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                    this.top.children.splice(this.index, 0, markDesc);
                    this.top = markDesc;
                    this.changed = true;
                }
                this.index = 0;
                depth++;
            }
        }
        findNodeMatch(node, outerDeco, innerDeco, index) {
            let found = -1, targetDesc;
            if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
            else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
                let child = this.top.children[i];
                if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                    found = i;
                    break;
                }
            }
            if (found < 0) return false;
            this.destroyBetween(this.index, found);
            this.index++;
            return true;
        }
        updateNodeAt(node, outerDeco, innerDeco, index, view) {
            let child = this.top.children[index];
            if (child.dirty == $a8a4766474a1e455$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
            if (!child.update(node, outerDeco, innerDeco, view)) return false;
            this.destroyBetween(this.index, index);
            this.index++;
            return true;
        }
        findIndexWithChild(domNode) {
            for(;;){
                let parent = domNode.parentNode;
                if (!parent) return -1;
                if (parent == this.top.contentDOM) {
                    let desc = domNode.pmViewDesc;
                    if (desc) for(let i = this.index; i < this.top.children.length; i++){
                        if (this.top.children[i] == desc) return i;
                    }
                    return -1;
                }
                domNode = parent;
            }
        }
        updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
            for(let i = this.index; i < this.top.children.length; i++){
                let next = this.top.children[i];
                if (next instanceof $a8a4766474a1e455$var$NodeViewDesc) {
                    let preMatch = this.preMatch.matched.get(next);
                    if (preMatch != null && preMatch != index) return false;
                    let nextDOM = next.dom, updated;
                    let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $a8a4766474a1e455$var$NODE_DIRTY && $a8a4766474a1e455$var$sameOuterDeco(outerDeco, next.outerDeco));
                    if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                        this.destroyBetween(this.index, i);
                        if (next.dom != nextDOM) this.changed = true;
                        this.index++;
                        return true;
                    } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                        this.top.children[this.index] = updated;
                        if (updated.contentDOM) {
                            updated.dirty = $a8a4766474a1e455$var$CONTENT_DIRTY;
                            updated.updateChildren(view, pos + 1);
                            updated.dirty = $a8a4766474a1e455$var$NOT_DIRTY;
                        }
                        this.changed = true;
                        this.index++;
                        return true;
                    }
                    break;
                }
            }
            return false;
        }
        recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
            if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content)) return null;
            let wrapper = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
            if (wrapper.contentDOM) {
                wrapper.children = next.children;
                next.children = [];
                for (let ch of wrapper.children)ch.parent = wrapper;
            }
            next.destroy();
            return wrapper;
        }
        addNode(node, outerDeco, innerDeco, view, pos) {
            let desc = $a8a4766474a1e455$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
            if (desc.contentDOM) desc.updateChildren(view, pos + 1);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
        placeWidget(widget, view, pos) {
            let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
            if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
            else {
                let desc = new $a8a4766474a1e455$var$WidgetViewDesc(this.top, widget, view, pos);
                this.top.children.splice(this.index++, 0, desc);
                this.changed = true;
            }
        }
        addTextblockHacks() {
            let lastChild = this.top.children[this.index - 1], parent = this.top;
            while(lastChild instanceof $a8a4766474a1e455$var$MarkViewDesc){
                parent = lastChild;
                lastChild = parent.children[parent.children.length - 1];
            }
            if (!lastChild || !(lastChild instanceof $a8a4766474a1e455$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
                if (($a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
                this.addHackNode("BR", this.top);
            }
        }
        addHackNode(nodeName, parent) {
            if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
            else {
                let dom = document.createElement(nodeName);
                if (nodeName == "IMG") {
                    dom.className = "ProseMirror-separator";
                    dom.alt = "";
                }
                if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
                let hack = new $a8a4766474a1e455$var$TrailingHackViewDesc(this.top, [], dom, null);
                if (parent != this.top) parent.children.push(hack);
                else parent.children.splice(this.index++, 0, hack);
                this.changed = true;
            }
        }
        isLocked(node) {
            return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
        }
    }
    function $a8a4766474a1e455$var$preMatch(frag, parentDesc) {
        let curDesc = parentDesc, descI = curDesc.children.length;
        let fI = frag.childCount, matched = new Map, matches = [];
        outer: while(fI > 0){
            let desc;
            for(;;){
                if (descI) {
                    let next = curDesc.children[descI - 1];
                    if (next instanceof $a8a4766474a1e455$var$MarkViewDesc) {
                        curDesc = next;
                        descI = next.children.length;
                    } else {
                        desc = next;
                        descI--;
                        break;
                    }
                } else if (curDesc == parentDesc) break outer;
                else {
                    descI = curDesc.parent.children.indexOf(curDesc);
                    curDesc = curDesc.parent;
                }
            }
            let node = desc.node;
            if (!node) continue;
            if (node != frag.child(fI - 1)) break;
            --fI;
            matched.set(desc, fI);
            matches.push(desc);
        }
        return {
            index: fI,
            matched: matched,
            matches: matches.reverse()
        };
    }
    function $a8a4766474a1e455$var$compareSide(a, b) {
        return a.type.side - b.type.side;
    }
    function $a8a4766474a1e455$var$iterDeco(parent, deco, onWidget, onNode) {
        let locals = deco.locals(parent), offset = 0;
        if (locals.length == 0) {
            for(let i = 0; i < parent.childCount; i++){
                let child = parent.child(i);
                onNode(child, locals, deco.forChild(offset, child), i);
                offset += child.nodeSize;
            }
            return;
        }
        let decoIndex = 0, active = [], restNode = null;
        for(let parentIndex = 0;;){
            let widget, widgets;
            while(decoIndex < locals.length && locals[decoIndex].to == offset){
                let next = locals[decoIndex++];
                if (next.widget) {
                    if (!widget) widget = next;
                    else (widgets || (widgets = [
                        widget
                    ])).push(next);
                }
            }
            if (widget) {
                if (widgets) {
                    widgets.sort($a8a4766474a1e455$var$compareSide);
                    for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
                } else onWidget(widget, parentIndex, !!restNode);
            }
            let child, index;
            if (restNode) {
                index = -1;
                child = restNode;
                restNode = null;
            } else if (parentIndex < parent.childCount) {
                index = parentIndex;
                child = parent.child(parentIndex++);
            } else break;
            for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
            while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
            let end = offset + child.nodeSize;
            if (child.isText) {
                let cutAt = end;
                if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
                for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
                if (cutAt < end) {
                    restNode = child.cut(cutAt - offset);
                    child = child.cut(0, cutAt - offset);
                    end = cutAt;
                    index = -1;
                }
            } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
            let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
            onNode(child, outerDeco, deco.forChild(offset, child), index);
            offset = end;
        }
    }
    function $a8a4766474a1e455$var$iosHacks(dom) {
        if (dom.nodeName == "UL" || dom.nodeName == "OL") {
            let oldCSS = dom.style.cssText;
            dom.style.cssText = oldCSS + "; list-style: square !important";
            window.getComputedStyle(dom).listStyle;
            dom.style.cssText = oldCSS;
        }
    }
    function $a8a4766474a1e455$var$findTextInFragment(frag, text, from, to) {
        for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
            let child = frag.child(i++), childStart = pos;
            pos += child.nodeSize;
            if (!child.isText) continue;
            let str = child.text;
            while(i < frag.childCount){
                let next = frag.child(i++);
                pos += next.nodeSize;
                if (!next.isText) break;
                str += next.text;
            }
            if (pos >= from) {
                if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
                let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
                if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
                if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
            }
        }
        return -1;
    }
    function $a8a4766474a1e455$var$replaceNodes(nodes, from, to, view, replacement) {
        let result = [];
        for(let i = 0, off = 0; i < nodes.length; i++){
            let child = nodes[i], start = off, end = off += child.size;
            if (start >= to || end <= from) result.push(child);
            else {
                if (start < from) result.push(child.slice(0, from - start, view));
                if (replacement) {
                    result.push(replacement);
                    replacement = undefined;
                }
                if (end > to) result.push(child.slice(to - start, child.size, view));
            }
        }
        return result;
    }
    function $a8a4766474a1e455$var$selectionFromDOM(view, origin = null) {
        let domSel = view.domSelectionRange(), doc = view.state.doc;
        if (!domSel.focusNode) return null;
        let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
        let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
        if (head < 0) return null;
        let $head = doc.resolve(head), $anchor, selection;
        if ($a8a4766474a1e455$var$selectionCollapsed(domSel)) {
            $anchor = $head;
            while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
            let nearestDescNode = nearestDesc.node;
            if (nearestDesc && nearestDescNode.isAtom && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $a8a4766474a1e455$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
                let pos = nearestDesc.posBefore;
                selection = new (0, (0, parcelRequire("gZGBX")).NodeSelection)(head == pos ? $head : doc.resolve(pos));
            }
        } else {
            let anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
            if (anchor < 0) return null;
            $anchor = doc.resolve(anchor);
        }
        if (!selection) {
            let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
            selection = $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias);
        }
        return selection;
    }
    function $a8a4766474a1e455$var$editorOwnsSelection(view) {
        return view.editable ? view.hasFocus() : $a8a4766474a1e455$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
    }
    function $a8a4766474a1e455$var$selectionToDOM(view, force = false) {
        let sel = view.state.selection;
        $a8a4766474a1e455$var$syncNodeSelection(view, sel);
        if (!$a8a4766474a1e455$var$editorOwnsSelection(view)) return;
        if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $a8a4766474a1e455$var$chrome) {
            let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
            if (domSel.anchorNode && curSel.anchorNode && $a8a4766474a1e455$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
                view.input.mouseDown.delayedSelectionSync = true;
                view.domObserver.setCurSelection();
                return;
            }
        }
        view.domObserver.disconnectSelection();
        if (view.cursorWrapper) $a8a4766474a1e455$var$selectCursorWrapper(view);
        else {
            let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
            if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable && !(sel instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) {
                if (!sel.$from.parent.inlineContent) resetEditableFrom = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.from);
                if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $a8a4766474a1e455$var$temporarilyEditableNear(view, sel.to);
            }
            view.docView.setSelection(anchor, head, view.root, force);
            if ($a8a4766474a1e455$var$brokenSelectBetweenUneditable) {
                if (resetEditableFrom) $a8a4766474a1e455$var$resetEditable(resetEditableFrom);
                if (resetEditableTo) $a8a4766474a1e455$var$resetEditable(resetEditableTo);
            }
            if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
            else {
                view.dom.classList.add("ProseMirror-hideselection");
                if ("onselectionchange" in document) $a8a4766474a1e455$var$removeClassOnSelectionChange(view);
            }
        }
        view.domObserver.setCurSelection();
        view.domObserver.connectSelection();
    }
    const $a8a4766474a1e455$var$brokenSelectBetweenUneditable = $a8a4766474a1e455$var$safari || $a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$chrome_version < 63;
    function $a8a4766474a1e455$var$temporarilyEditableNear(view, pos) {
        let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
        let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
        let before = offset ? node.childNodes[offset - 1] : null;
        if ($a8a4766474a1e455$var$safari && after && after.contentEditable == "false") return $a8a4766474a1e455$var$setEditable(after);
        if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
            if (after) return $a8a4766474a1e455$var$setEditable(after);
            else if (before) return $a8a4766474a1e455$var$setEditable(before);
        }
    }
    function $a8a4766474a1e455$var$setEditable(element) {
        element.contentEditable = "true";
        if ($a8a4766474a1e455$var$safari && element.draggable) {
            element.draggable = false;
            element.wasDraggable = true;
        }
        return element;
    }
    function $a8a4766474a1e455$var$resetEditable(element) {
        element.contentEditable = "false";
        if (element.wasDraggable) {
            element.draggable = true;
            element.wasDraggable = null;
        }
    }
    function $a8a4766474a1e455$var$removeClassOnSelectionChange(view) {
        let doc = view.dom.ownerDocument;
        doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
        let domSel = view.domSelectionRange();
        let node = domSel.anchorNode, offset = domSel.anchorOffset;
        doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
            if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
                doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
                setTimeout(()=>{
                    if (!$a8a4766474a1e455$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
                }, 20);
            }
        });
    }
    function $a8a4766474a1e455$var$selectCursorWrapper(view) {
        let domSel = view.domSelection(), range = document.createRange();
        if (!domSel) return;
        let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
        if (img) range.setStart(node.parentNode, $a8a4766474a1e455$var$domIndex(node) + 1);
        else range.setStart(node, 0);
        range.collapse(true);
        domSel.removeAllRanges();
        domSel.addRange(range);
        if (!img && !view.state.selection.visible && $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11) {
            node.disabled = true;
            node.disabled = false;
        }
    }
    function $a8a4766474a1e455$var$syncNodeSelection(view, sel) {
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
            let desc = view.docView.descAt(sel.from);
            if (desc != view.lastSelectedViewDesc) {
                $a8a4766474a1e455$var$clearNodeSelection(view);
                if (desc) desc.selectNode();
                view.lastSelectedViewDesc = desc;
            }
        } else $a8a4766474a1e455$var$clearNodeSelection(view);
    }
    function $a8a4766474a1e455$var$clearNodeSelection(view) {
        if (view.lastSelectedViewDesc) {
            if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
            view.lastSelectedViewDesc = undefined;
        }
    }
    function $a8a4766474a1e455$var$selectionBetween(view, $anchor, $head, bias) {
        return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, (0, parcelRequire("gZGBX")).TextSelection).between($anchor, $head, bias);
    }
    function $a8a4766474a1e455$var$hasFocusAndSelection(view) {
        if (view.editable && !view.hasFocus()) return false;
        return $a8a4766474a1e455$var$hasSelection(view);
    }
    function $a8a4766474a1e455$var$hasSelection(view) {
        let sel = view.domSelectionRange();
        if (!sel.anchorNode) return false;
        try {
            return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
        } catch (_) {
            return false;
        }
    }
    function $a8a4766474a1e455$var$anchorInRightPlace(view) {
        let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
        let domSel = view.domSelectionRange();
        return $a8a4766474a1e455$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
    }
    function $a8a4766474a1e455$var$moveSelectionBlock(state, dir) {
        let { $anchor: $anchor, $head: $head } = state.selection;
        let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
        let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
        return $start && (0, (0, parcelRequire("gZGBX")).Selection).findFrom($start, dir);
    }
    function $a8a4766474a1e455$var$apply(view, sel) {
        view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
        return true;
    }
    function $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) {
        let sel = view.state.selection;
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
            if (mods.indexOf("s") > -1) {
                let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
                if (!node || node.isText || !node.isLeaf) return false;
                let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
                return $a8a4766474a1e455$var$apply(view, new (0, (0, parcelRequire("gZGBX")).TextSelection)(sel.$anchor, $newHead));
            } else if (!sel.empty) return false;
            else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
                let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
                if (next && next instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
                return false;
            } else if (!($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1)) {
                let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
                if (!node || node.isText) return false;
                let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
                if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
                if ((0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) return $a8a4766474a1e455$var$apply(view, new (0, (0, parcelRequire("gZGBX")).NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
                else if ($a8a4766474a1e455$var$webkit) return $a8a4766474a1e455$var$apply(view, new (0, (0, parcelRequire("gZGBX")).TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
                else return false;
            }
        } else if (sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && sel.node.isInline) return $a8a4766474a1e455$var$apply(view, new (0, (0, parcelRequire("gZGBX")).TextSelection)(dir > 0 ? sel.$to : sel.$from));
        else {
            let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
            if (next) return $a8a4766474a1e455$var$apply(view, next);
            return false;
        }
    }
    function $a8a4766474a1e455$var$nodeLen(node) {
        return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
    }
    function $a8a4766474a1e455$var$isIgnorable(dom, dir) {
        let desc = dom.pmViewDesc;
        return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
    }
    function $a8a4766474a1e455$var$skipIgnoredNodes(view, dir) {
        return dir < 0 ? $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) : $a8a4766474a1e455$var$skipIgnoredNodesAfter(view);
    }
    function $a8a4766474a1e455$var$skipIgnoredNodesBefore(view) {
        let sel = view.domSelectionRange();
        let node = sel.focusNode, offset = sel.focusOffset;
        if (!node) return;
        let moveNode, moveOffset, force = false;
        if ($a8a4766474a1e455$var$gecko && node.nodeType == 1 && offset < $a8a4766474a1e455$var$nodeLen(node) && $a8a4766474a1e455$var$isIgnorable(node.childNodes[offset], -1)) force = true;
        for(;;){
            if (offset > 0) {
                if (node.nodeType != 1) break;
                else {
                    let before = node.childNodes[offset - 1];
                    if ($a8a4766474a1e455$var$isIgnorable(before, -1)) {
                        moveNode = node;
                        moveOffset = --offset;
                    } else if (before.nodeType == 3) {
                        node = before;
                        offset = node.nodeValue.length;
                    } else break;
                }
            } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
            else {
                let prev = node.previousSibling;
                while(prev && $a8a4766474a1e455$var$isIgnorable(prev, -1)){
                    moveNode = node.parentNode;
                    moveOffset = $a8a4766474a1e455$var$domIndex(prev);
                    prev = prev.previousSibling;
                }
                if (!prev) {
                    node = node.parentNode;
                    if (node == view.dom) break;
                    offset = 0;
                } else {
                    node = prev;
                    offset = $a8a4766474a1e455$var$nodeLen(node);
                }
            }
        }
        if (force) $a8a4766474a1e455$var$setSelFocus(view, node, offset);
        else if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
    }
    function $a8a4766474a1e455$var$skipIgnoredNodesAfter(view) {
        let sel = view.domSelectionRange();
        let node = sel.focusNode, offset = sel.focusOffset;
        if (!node) return;
        let len = $a8a4766474a1e455$var$nodeLen(node);
        let moveNode, moveOffset;
        for(;;){
            if (offset < len) {
                if (node.nodeType != 1) break;
                let after = node.childNodes[offset];
                if ($a8a4766474a1e455$var$isIgnorable(after, 1)) {
                    moveNode = node;
                    moveOffset = ++offset;
                } else break;
            } else if ($a8a4766474a1e455$var$isBlockNode(node)) break;
            else {
                let next = node.nextSibling;
                while(next && $a8a4766474a1e455$var$isIgnorable(next, 1)){
                    moveNode = next.parentNode;
                    moveOffset = $a8a4766474a1e455$var$domIndex(next) + 1;
                    next = next.nextSibling;
                }
                if (!next) {
                    node = node.parentNode;
                    if (node == view.dom) break;
                    offset = len = 0;
                } else {
                    node = next;
                    offset = 0;
                    len = $a8a4766474a1e455$var$nodeLen(node);
                }
            }
        }
        if (moveNode) $a8a4766474a1e455$var$setSelFocus(view, moveNode, moveOffset);
    }
    function $a8a4766474a1e455$var$isBlockNode(dom) {
        let desc = dom.pmViewDesc;
        return desc && desc.node && desc.node.isBlock;
    }
    function $a8a4766474a1e455$var$textNodeAfter(node, offset) {
        while(node && offset == node.childNodes.length && !$a8a4766474a1e455$var$hasBlockDesc(node)){
            offset = $a8a4766474a1e455$var$domIndex(node) + 1;
            node = node.parentNode;
        }
        while(node && offset < node.childNodes.length){
            let next = node.childNodes[offset];
            if (next.nodeType == 3) return next;
            if (next.nodeType == 1 && next.contentEditable == "false") break;
            node = next;
            offset = 0;
        }
    }
    function $a8a4766474a1e455$var$textNodeBefore(node, offset) {
        while(node && !offset && !$a8a4766474a1e455$var$hasBlockDesc(node)){
            offset = $a8a4766474a1e455$var$domIndex(node);
            node = node.parentNode;
        }
        while(node && offset){
            let next = node.childNodes[offset - 1];
            if (next.nodeType == 3) return next;
            if (next.nodeType == 1 && next.contentEditable == "false") break;
            node = next;
            offset = node.childNodes.length;
        }
    }
    function $a8a4766474a1e455$var$setSelFocus(view, node, offset) {
        if (node.nodeType != 3) {
            let before, after;
            if (after = $a8a4766474a1e455$var$textNodeAfter(node, offset)) {
                node = after;
                offset = 0;
            } else if (before = $a8a4766474a1e455$var$textNodeBefore(node, offset)) {
                node = before;
                offset = before.nodeValue.length;
            }
        }
        let sel = view.domSelection();
        if (!sel) return;
        if ($a8a4766474a1e455$var$selectionCollapsed(sel)) {
            let range = document.createRange();
            range.setEnd(node, offset);
            range.setStart(node, offset);
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (sel.extend) sel.extend(node, offset);
        view.domObserver.setCurSelection();
        let { state: state } = view;
        setTimeout(()=>{
            if (view.state == state) $a8a4766474a1e455$var$selectionToDOM(view);
        }, 50);
    }
    function $a8a4766474a1e455$var$findDirection(view, pos) {
        let $pos = view.state.doc.resolve(pos);
        if (!($a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$windows) && $pos.parent.inlineContent) {
            let coords = view.coordsAtPos(pos);
            if (pos > $pos.start()) {
                let before = view.coordsAtPos(pos - 1);
                let mid = (before.top + before.bottom) / 2;
                if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
            }
            if (pos < $pos.end()) {
                let after = view.coordsAtPos(pos + 1);
                let mid = (after.top + after.bottom) / 2;
                if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
            }
        }
        let computed = getComputedStyle(view.dom).direction;
        return computed == "rtl" ? "rtl" : "ltr";
    }
    function $a8a4766474a1e455$var$selectVertically(view, dir, mods) {
        let sel = view.state.selection;
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
        if ($a8a4766474a1e455$var$mac && mods.indexOf("m") > -1) return false;
        let { $from: $from, $to: $to } = sel;
        if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
            let next = $a8a4766474a1e455$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return $a8a4766474a1e455$var$apply(view, next);
        }
        if (!$from.parent.inlineContent) {
            let side = dir < 0 ? $from : $to;
            let beyond = sel instanceof (0, (0, parcelRequire("gZGBX")).AllSelection) ? (0, (0, parcelRequire("gZGBX")).Selection).near(side, dir) : (0, (0, parcelRequire("gZGBX")).Selection).findFrom(side, dir);
            return beyond ? $a8a4766474a1e455$var$apply(view, beyond) : false;
        }
        return false;
    }
    function $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, dir) {
        if (!(view.state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return true;
        let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
        if (!$head.sameParent($anchor)) return true;
        if (!empty) return false;
        if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
        let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
        if (nextNode && !nextNode.isText) {
            let tr = view.state.tr;
            if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
            else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
            view.dispatch(tr);
            return true;
        }
        return false;
    }
    function $a8a4766474a1e455$var$switchEditable(view, node, state) {
        view.domObserver.stop();
        node.contentEditable = state;
        view.domObserver.start();
    }
    function $a8a4766474a1e455$var$safariDownArrowBug(view) {
        if (!$a8a4766474a1e455$var$safari || view.state.selection.$head.parentOffset > 0) return false;
        let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
        if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
            let child = focusNode.firstChild;
            $a8a4766474a1e455$var$switchEditable(view, child, "true");
            setTimeout(()=>$a8a4766474a1e455$var$switchEditable(view, child, "false"), 20);
        }
        return false;
    }
    function $a8a4766474a1e455$var$getMods(event) {
        let result = "";
        if (event.ctrlKey) result += "c";
        if (event.metaKey) result += "m";
        if (event.altKey) result += "a";
        if (event.shiftKey) result += "s";
        return result;
    }
    function $a8a4766474a1e455$var$captureKeyDown(view, event) {
        let code = event.keyCode, mods = $a8a4766474a1e455$var$getMods(event);
        if (code == 8 || $a8a4766474a1e455$var$mac && code == 72 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, -1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
        else if (code == 46 && !event.shiftKey || $a8a4766474a1e455$var$mac && code == 68 && mods == "c") return $a8a4766474a1e455$var$stopNativeHorizontalDelete(view, 1) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
        else if (code == 13 || code == 27) return true;
        else if (code == 37 || $a8a4766474a1e455$var$mac && code == 66 && mods == "c") {
            let dir = code == 37 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
            return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
        } else if (code == 39 || $a8a4766474a1e455$var$mac && code == 70 && mods == "c") {
            let dir = code == 39 ? $a8a4766474a1e455$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
            return $a8a4766474a1e455$var$selectHorizontally(view, dir, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, dir);
        } else if (code == 38 || $a8a4766474a1e455$var$mac && code == 80 && mods == "c") return $a8a4766474a1e455$var$selectVertically(view, -1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, -1);
        else if (code == 40 || $a8a4766474a1e455$var$mac && code == 78 && mods == "c") return $a8a4766474a1e455$var$safariDownArrowBug(view) || $a8a4766474a1e455$var$selectVertically(view, 1, mods) || $a8a4766474a1e455$var$skipIgnoredNodes(view, 1);
        else if (mods == ($a8a4766474a1e455$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
        return false;
    }
    function $a8a4766474a1e455$var$serializeForClipboard(view, slice) {
        view.someProp("transformCopied", (f)=>{
            slice = f(slice, view);
        });
        let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
        while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
            openStart--;
            openEnd--;
            let node = content.firstChild;
            context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
            content = node.content;
        }
        let serializer = view.someProp("clipboardSerializer") || (0, (0, parcelRequire("kCV8T")).DOMSerializer).fromSchema(view.state.schema);
        let doc = $a8a4766474a1e455$var$detachedDoc(), wrap = doc.createElement("div");
        wrap.appendChild(serializer.serializeFragment(content, {
            document: doc
        }));
        let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
        while(firstChild && firstChild.nodeType == 1 && (needsWrap = $a8a4766474a1e455$var$wrapMap[firstChild.nodeName.toLowerCase()])){
            for(let i = needsWrap.length - 1; i >= 0; i--){
                let wrapper = doc.createElement(needsWrap[i]);
                while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
                wrap.appendChild(wrapper);
                wrappers++;
            }
            firstChild = wrap.firstChild;
        }
        if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
        let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
        return {
            dom: wrap,
            text: text,
            slice: slice
        };
    }
    function $a8a4766474a1e455$var$parseFromClipboard(view, text, html, plainText, $context) {
        let inCode = $context.parent.type.spec.code;
        let dom, slice;
        if (!html && !text) return null;
        let asText = text && (plainText || inCode || !html);
        if (asText) {
            view.someProp("transformPastedText", (f)=>{
                text = f(text, inCode || plainText, view);
            });
            if (inCode) return text ? new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, (0, parcelRequire("kCV8T")).Slice).empty;
            let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
            if (parsed) slice = parsed;
            else {
                let marks = $context.marks();
                let { schema: schema } = view.state, serializer = (0, (0, parcelRequire("kCV8T")).DOMSerializer).fromSchema(schema);
                dom = document.createElement("div");
                text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                    let p = dom.appendChild(document.createElement("p"));
                    if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
                });
            }
        } else {
            view.someProp("transformPastedHTML", (f)=>{
                html = f(html, view);
            });
            dom = $a8a4766474a1e455$var$readHTML(html);
            if ($a8a4766474a1e455$var$webkit) $a8a4766474a1e455$var$restoreReplacedSpaces(dom);
        }
        let contextNode = dom && dom.querySelector("[data-pm-slice]");
        let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
        if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
            let child = dom.firstChild;
            while(child && child.nodeType != 1)child = child.nextSibling;
            if (!child) break;
            dom = child;
        }
        if (!slice) {
            let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, (0, parcelRequire("kCV8T")).DOMParser).fromSchema(view.state.schema);
            slice = parser.parseSlice(dom, {
                preserveWhitespace: !!(asText || sliceData),
                context: $context,
                ruleFromNode (dom) {
                    if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$a8a4766474a1e455$var$inlineParents.test(dom.parentNode.nodeName)) return {
                        ignore: true
                    };
                    return null;
                }
            });
        }
        if (sliceData) slice = $a8a4766474a1e455$var$addContext($a8a4766474a1e455$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
        else {
            slice = (0, (0, parcelRequire("kCV8T")).Slice).maxOpen($a8a4766474a1e455$var$normalizeSiblings(slice.content, $context), true);
            if (slice.openStart || slice.openEnd) {
                let openStart = 0, openEnd = 0;
                for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
                for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
                slice = $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd);
            }
        }
        view.someProp("transformPasted", (f)=>{
            slice = f(slice, view);
        });
        return slice;
    }
    const $a8a4766474a1e455$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
    function $a8a4766474a1e455$var$normalizeSiblings(fragment, $context) {
        if (fragment.childCount < 2) return fragment;
        for(let d = $context.depth; d >= 0; d--){
            let parent = $context.node(d);
            let match = parent.contentMatchAt($context.index(d));
            let lastWrap, result = [];
            fragment.forEach((node)=>{
                if (!result) return;
                let wrap = match.findWrapping(node.type), inLast;
                if (!wrap) return result = null;
                if (inLast = result.length && lastWrap.length && $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
                else {
                    if (result.length) result[result.length - 1] = $a8a4766474a1e455$var$closeRight(result[result.length - 1], lastWrap.length);
                    let wrapped = $a8a4766474a1e455$var$withWrappers(node, wrap);
                    result.push(wrapped);
                    match = match.matchType(wrapped.type);
                    lastWrap = wrap;
                }
            });
            if (result) return (0, (0, parcelRequire("kCV8T")).Fragment).from(result);
        }
        return fragment;
    }
    function $a8a4766474a1e455$var$withWrappers(node, wrap, from = 0) {
        for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, (0, parcelRequire("kCV8T")).Fragment).from(node));
        return node;
    }
    function $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
        if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
            let inner = $a8a4766474a1e455$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
            if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
            let match = sibling.contentMatchAt(sibling.childCount);
            if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, (0, parcelRequire("kCV8T")).Fragment).from($a8a4766474a1e455$var$withWrappers(node, wrap, depth + 1))));
        }
    }
    function $a8a4766474a1e455$var$closeRight(node, depth) {
        if (depth == 0) return node;
        let fragment = node.content.replaceChild(node.childCount - 1, $a8a4766474a1e455$var$closeRight(node.lastChild, depth - 1));
        let fill = node.contentMatchAt(node.childCount).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true);
        return node.copy(fragment.append(fill));
    }
    function $a8a4766474a1e455$var$closeRange(fragment, side, from, to, depth, openEnd) {
        let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
        if (fragment.childCount > 1) openEnd = 0;
        if (depth < to - 1) inner = $a8a4766474a1e455$var$closeRange(inner, side, from, to, depth + 1, openEnd);
        if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, (0, parcelRequire("kCV8T")).Fragment).empty, true));
        return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
    }
    function $a8a4766474a1e455$var$closeSlice(slice, openStart, openEnd) {
        if (openStart < slice.openStart) slice = new (0, (0, parcelRequire("kCV8T")).Slice)($a8a4766474a1e455$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
        if (openEnd < slice.openEnd) slice = new (0, (0, parcelRequire("kCV8T")).Slice)($a8a4766474a1e455$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
        return slice;
    }
    const $a8a4766474a1e455$var$wrapMap = {
        thead: [
            "table"
        ],
        tbody: [
            "table"
        ],
        tfoot: [
            "table"
        ],
        caption: [
            "table"
        ],
        colgroup: [
            "table"
        ],
        col: [
            "table",
            "colgroup"
        ],
        tr: [
            "table",
            "tbody"
        ],
        td: [
            "table",
            "tbody",
            "tr"
        ],
        th: [
            "table",
            "tbody",
            "tr"
        ]
    };
    let $a8a4766474a1e455$var$_detachedDoc = null;
    function $a8a4766474a1e455$var$detachedDoc() {
        return $a8a4766474a1e455$var$_detachedDoc || ($a8a4766474a1e455$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
    }
    function $a8a4766474a1e455$var$maybeWrapTrusted(html) {
        let trustedTypes = window.trustedTypes;
        if (!trustedTypes) return html;
        return trustedTypes.createPolicy("detachedDocument", {
            createHTML: (s)=>s
        }).createHTML(html);
    }
    function $a8a4766474a1e455$var$readHTML(html) {
        let metas = /^(\s*<meta [^>]*>)*/.exec(html);
        if (metas) html = html.slice(metas[0].length);
        let elt = $a8a4766474a1e455$var$detachedDoc().createElement("div");
        let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
        if (wrap = firstTag && $a8a4766474a1e455$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
        elt.innerHTML = $a8a4766474a1e455$var$maybeWrapTrusted(html);
        if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
        return elt;
    }
    function $a8a4766474a1e455$var$restoreReplacedSpaces(dom) {
        let nodes = dom.querySelectorAll($a8a4766474a1e455$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
        for(let i = 0; i < nodes.length; i++){
            let node = nodes[i];
            if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
        }
    }
    function $a8a4766474a1e455$var$addContext(slice, context) {
        if (!slice.size) return slice;
        let schema = slice.content.firstChild.type.schema, array;
        try {
            array = JSON.parse(context);
        } catch (e) {
            return slice;
        }
        let { content: content, openStart: openStart, openEnd: openEnd } = slice;
        for(let i = array.length - 2; i >= 0; i -= 2){
            let type = schema.nodes[array[i]];
            if (!type || type.hasRequiredAttrs()) break;
            content = (0, (0, parcelRequire("kCV8T")).Fragment).from(type.create(array[i + 1], content));
            openStart++;
            openEnd++;
        }
        return new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd);
    }
    const $a8a4766474a1e455$var$handlers = {};
    const $a8a4766474a1e455$var$editHandlers = {};
    const $a8a4766474a1e455$var$passiveHandlers = {
        touchstart: true,
        touchmove: true
    };
    class $a8a4766474a1e455$var$InputState {
        constructor(){
            this.shiftKey = false;
            this.mouseDown = null;
            this.lastKeyCode = null;
            this.lastKeyCodeTime = 0;
            this.lastClick = {
                time: 0,
                x: 0,
                y: 0,
                type: ""
            };
            this.lastSelectionOrigin = null;
            this.lastSelectionTime = 0;
            this.lastIOSEnter = 0;
            this.lastIOSEnterFallbackTimeout = -1;
            this.lastFocus = 0;
            this.lastTouch = 0;
            this.lastAndroidDelete = 0;
            this.composing = false;
            this.compositionNode = null;
            this.composingTimeout = -1;
            this.compositionNodes = [];
            this.compositionEndedAt = -200000000;
            this.compositionID = 1;
            this.compositionPendingChanges = 0;
            this.domChangeCount = 0;
            this.eventHandlers = Object.create(null);
            this.hideSelectionGuard = null;
        }
    }
    function $a8a4766474a1e455$var$initInput(view) {
        for(let event in $a8a4766474a1e455$var$handlers){
            let handler = $a8a4766474a1e455$var$handlers[event];
            view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
                if ($a8a4766474a1e455$var$eventBelongsToView(view, event) && !$a8a4766474a1e455$var$runCustomHandler(view, event) && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) handler(view, event);
            }, $a8a4766474a1e455$var$passiveHandlers[event] ? {
                passive: true
            } : undefined);
        }
        if ($a8a4766474a1e455$var$safari) view.dom.addEventListener("input", ()=>null);
        $a8a4766474a1e455$var$ensureListeners(view);
    }
    function $a8a4766474a1e455$var$setSelectionOrigin(view, origin) {
        view.input.lastSelectionOrigin = origin;
        view.input.lastSelectionTime = Date.now();
    }
    function $a8a4766474a1e455$var$destroyInput(view) {
        view.domObserver.stop();
        for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
        clearTimeout(view.input.composingTimeout);
        clearTimeout(view.input.lastIOSEnterFallbackTimeout);
    }
    function $a8a4766474a1e455$var$ensureListeners(view) {
        view.someProp("handleDOMEvents", (currentHandlers)=>{
            for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$a8a4766474a1e455$var$runCustomHandler(view, event));
        });
    }
    function $a8a4766474a1e455$var$runCustomHandler(view, event) {
        return view.someProp("handleDOMEvents", (handlers)=>{
            let handler = handlers[event.type];
            return handler ? handler(view, event) || event.defaultPrevented : false;
        });
    }
    function $a8a4766474a1e455$var$eventBelongsToView(view, event) {
        if (!event.bubbles) return true;
        if (event.defaultPrevented) return false;
        for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
        return true;
    }
    function $a8a4766474a1e455$var$dispatchEvent(view, event) {
        if (!$a8a4766474a1e455$var$runCustomHandler(view, event) && $a8a4766474a1e455$var$handlers[event.type] && (view.editable || !(event.type in $a8a4766474a1e455$var$editHandlers))) $a8a4766474a1e455$var$handlers[event.type](view, event);
    }
    $a8a4766474a1e455$var$editHandlers.keydown = (view, _event)=>{
        let event = _event;
        view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
        if ($a8a4766474a1e455$var$inOrNearComposition(view, event)) return;
        view.input.lastKeyCode = event.keyCode;
        view.input.lastKeyCodeTime = Date.now();
        if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome && event.keyCode == 13) return;
        if (view.domObserver.selectionChanged(view.domSelectionRange())) view.domObserver.flush();
        else if (event.keyCode != 229) view.domObserver.forceFlush();
        if ($a8a4766474a1e455$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
            let now = Date.now();
            view.input.lastIOSEnter = now;
            view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
                if (view.input.lastIOSEnter == now) {
                    view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")));
                    view.input.lastIOSEnter = 0;
                }
            }, 200);
        } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $a8a4766474a1e455$var$captureKeyDown(view, event)) event.preventDefault();
        else $a8a4766474a1e455$var$setSelectionOrigin(view, "key");
    };
    $a8a4766474a1e455$var$editHandlers.keyup = (view, event)=>{
        if (event.keyCode == 16) view.input.shiftKey = false;
    };
    $a8a4766474a1e455$var$editHandlers.keypress = (view, _event)=>{
        let event = _event;
        if ($a8a4766474a1e455$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $a8a4766474a1e455$var$mac && event.metaKey) return;
        if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
            event.preventDefault();
            return;
        }
        let sel = view.state.selection;
        if (!(sel instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) || !sel.$from.sameParent(sel.$to)) {
            let text = String.fromCharCode(event.charCode);
            if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
            event.preventDefault();
        }
    };
    function $a8a4766474a1e455$var$eventCoords(event) {
        return {
            left: event.clientX,
            top: event.clientY
        };
    }
    function $a8a4766474a1e455$var$isNear(event, click) {
        let dx = click.x - event.clientX, dy = click.y - event.clientY;
        return dx * dx + dy * dy < 100;
    }
    function $a8a4766474a1e455$var$runHandlerOnContext(view, propName, pos, inside, event) {
        if (inside == -1) return false;
        let $pos = view.state.doc.resolve(inside);
        for(let i = $pos.depth + 1; i > 0; i--){
            if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
        }
        return false;
    }
    function $a8a4766474a1e455$var$updateSelection(view, selection, origin) {
        if (!view.focused) view.focus();
        if (view.state.selection.eq(selection)) return;
        let tr = view.state.tr.setSelection(selection);
        if (origin == "pointer") tr.setMeta("pointer", true);
        view.dispatch(tr);
    }
    function $a8a4766474a1e455$var$selectClickedLeaf(view, inside) {
        if (inside == -1) return false;
        let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
        if (node && node.isAtom && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) {
            $a8a4766474a1e455$var$updateSelection(view, new (0, (0, parcelRequire("gZGBX")).NodeSelection)($pos), "pointer");
            return true;
        }
        return false;
    }
    function $a8a4766474a1e455$var$selectClickedNode(view, inside) {
        if (inside == -1) return false;
        let sel = view.state.selection, selectedNode, selectAt;
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) selectedNode = sel.node;
        let $pos = view.state.doc.resolve(inside);
        for(let i = $pos.depth + 1; i > 0; i--){
            let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
            if ((0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) {
                if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
                else selectAt = $pos.before(i);
                break;
            }
        }
        if (selectAt != null) {
            $a8a4766474a1e455$var$updateSelection(view, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(view.state.doc, selectAt), "pointer");
            return true;
        } else return false;
    }
    function $a8a4766474a1e455$var$handleSingleClick(view, pos, inside, event, selectNode) {
        return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $a8a4766474a1e455$var$selectClickedNode(view, inside) : $a8a4766474a1e455$var$selectClickedLeaf(view, inside));
    }
    function $a8a4766474a1e455$var$handleDoubleClick(view, pos, inside, event) {
        return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
    }
    function $a8a4766474a1e455$var$handleTripleClick(view, pos, inside, event) {
        return $a8a4766474a1e455$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $a8a4766474a1e455$var$defaultTripleClick(view, inside, event);
    }
    function $a8a4766474a1e455$var$defaultTripleClick(view, inside, event) {
        if (event.button != 0) return false;
        let doc = view.state.doc;
        if (inside == -1) {
            if (doc.inlineContent) {
                $a8a4766474a1e455$var$updateSelection(view, (0, (0, parcelRequire("gZGBX")).TextSelection).create(doc, 0, doc.content.size), "pointer");
                return true;
            }
            return false;
        }
        let $pos = doc.resolve(inside);
        for(let i = $pos.depth + 1; i > 0; i--){
            let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
            let nodePos = $pos.before(i);
            if (node.inlineContent) $a8a4766474a1e455$var$updateSelection(view, (0, (0, parcelRequire("gZGBX")).TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
            else if ((0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) $a8a4766474a1e455$var$updateSelection(view, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(doc, nodePos), "pointer");
            else continue;
            return true;
        }
    }
    function $a8a4766474a1e455$var$forceDOMFlush(view) {
        return $a8a4766474a1e455$var$endComposition(view);
    }
    const $a8a4766474a1e455$var$selectNodeModifier = $a8a4766474a1e455$var$mac ? "metaKey" : "ctrlKey";
    $a8a4766474a1e455$var$handlers.mousedown = (view, _event)=>{
        let event = _event;
        view.input.shiftKey = event.shiftKey;
        let flushed = $a8a4766474a1e455$var$forceDOMFlush(view);
        let now = Date.now(), type = "singleClick";
        if (now - view.input.lastClick.time < 500 && $a8a4766474a1e455$var$isNear(event, view.input.lastClick) && !event[$a8a4766474a1e455$var$selectNodeModifier]) {
            if (view.input.lastClick.type == "singleClick") type = "doubleClick";
            else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
        }
        view.input.lastClick = {
            time: now,
            x: event.clientX,
            y: event.clientY,
            type: type
        };
        let pos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
        if (!pos) return;
        if (type == "singleClick") {
            if (view.input.mouseDown) view.input.mouseDown.done();
            view.input.mouseDown = new $a8a4766474a1e455$var$MouseDown(view, pos, event, !!flushed);
        } else if ((type == "doubleClick" ? $a8a4766474a1e455$var$handleDoubleClick : $a8a4766474a1e455$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
        else $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
    };
    class $a8a4766474a1e455$var$MouseDown {
        constructor(view, pos, event, flushed){
            this.view = view;
            this.pos = pos;
            this.event = event;
            this.flushed = flushed;
            this.delayedSelectionSync = false;
            this.mightDrag = null;
            this.startDoc = view.state.doc;
            this.selectNode = !!event[$a8a4766474a1e455$var$selectNodeModifier];
            this.allowDefault = event.shiftKey;
            let targetNode, targetPos;
            if (pos.inside > -1) {
                targetNode = view.state.doc.nodeAt(pos.inside);
                targetPos = pos.inside;
            } else {
                let $pos = view.state.doc.resolve(pos.pos);
                targetNode = $pos.parent;
                targetPos = $pos.depth ? $pos.before() : 0;
            }
            const target = flushed ? null : event.target;
            const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
            this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
            let { selection: selection } = view.state;
            if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
                node: targetNode,
                pos: targetPos,
                addAttr: !!(this.target && !this.target.draggable),
                setUneditable: !!(this.target && $a8a4766474a1e455$var$gecko && !this.target.hasAttribute("contentEditable"))
            };
            if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
                this.view.domObserver.stop();
                if (this.mightDrag.addAttr) this.target.draggable = true;
                if (this.mightDrag.setUneditable) setTimeout(()=>{
                    if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
                }, 20);
                this.view.domObserver.start();
            }
            view.root.addEventListener("mouseup", this.up = this.up.bind(this));
            view.root.addEventListener("mousemove", this.move = this.move.bind(this));
            $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
        }
        done() {
            this.view.root.removeEventListener("mouseup", this.up);
            this.view.root.removeEventListener("mousemove", this.move);
            if (this.mightDrag && this.target) {
                this.view.domObserver.stop();
                if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
                if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
                this.view.domObserver.start();
            }
            if (this.delayedSelectionSync) setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(this.view));
            this.view.input.mouseDown = null;
        }
        up(event) {
            this.done();
            if (!this.view.dom.contains(event.target)) return;
            let pos = this.pos;
            if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
            this.updateAllowDefault(event);
            if (this.allowDefault || !pos) $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
            else if ($a8a4766474a1e455$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
            else if (event.button == 0 && (this.flushed || $a8a4766474a1e455$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || $a8a4766474a1e455$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
                $a8a4766474a1e455$var$updateSelection(this.view, (0, (0, parcelRequire("gZGBX")).Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
                event.preventDefault();
            } else $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
        }
        move(event) {
            this.updateAllowDefault(event);
            $a8a4766474a1e455$var$setSelectionOrigin(this.view, "pointer");
            if (event.buttons == 0) this.done();
        }
        updateAllowDefault(event) {
            if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
        }
    }
    $a8a4766474a1e455$var$handlers.touchstart = (view)=>{
        view.input.lastTouch = Date.now();
        $a8a4766474a1e455$var$forceDOMFlush(view);
        $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
    };
    $a8a4766474a1e455$var$handlers.touchmove = (view)=>{
        view.input.lastTouch = Date.now();
        $a8a4766474a1e455$var$setSelectionOrigin(view, "pointer");
    };
    $a8a4766474a1e455$var$handlers.contextmenu = (view)=>$a8a4766474a1e455$var$forceDOMFlush(view);
    function $a8a4766474a1e455$var$inOrNearComposition(view, event) {
        if (view.composing) return true;
        if ($a8a4766474a1e455$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
            view.input.compositionEndedAt = -200000000;
            return true;
        }
        return false;
    }
    const $a8a4766474a1e455$var$timeoutComposition = $a8a4766474a1e455$var$android ? 5000 : -1;
    $a8a4766474a1e455$var$editHandlers.compositionstart = $a8a4766474a1e455$var$editHandlers.compositionupdate = (view)=>{
        if (!view.composing) {
            view.domObserver.flush();
            let { state: state } = view, $pos = state.selection.$to;
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
                view.markCursor = view.state.storedMarks || $pos.marks();
                $a8a4766474a1e455$var$endComposition(view, true);
                view.markCursor = null;
            } else {
                $a8a4766474a1e455$var$endComposition(view, !state.selection.empty);
                if ($a8a4766474a1e455$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                    let sel = view.domSelectionRange();
                    for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                        let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                        if (!before) break;
                        if (before.nodeType == 3) {
                            let sel = view.domSelection();
                            if (sel) sel.collapse(before, before.nodeValue.length);
                            break;
                        } else {
                            node = before;
                            offset = -1;
                        }
                    }
                }
            }
            view.input.composing = true;
        }
        $a8a4766474a1e455$var$scheduleComposeEnd(view, $a8a4766474a1e455$var$timeoutComposition);
    };
    $a8a4766474a1e455$var$editHandlers.compositionend = (view, event)=>{
        if (view.composing) {
            view.input.composing = false;
            view.input.compositionEndedAt = event.timeStamp;
            view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
            view.input.compositionNode = null;
            if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
            view.input.compositionID++;
            $a8a4766474a1e455$var$scheduleComposeEnd(view, 20);
        }
    };
    function $a8a4766474a1e455$var$scheduleComposeEnd(view, delay) {
        clearTimeout(view.input.composingTimeout);
        if (delay > -1) view.input.composingTimeout = setTimeout(()=>$a8a4766474a1e455$var$endComposition(view), delay);
    }
    function $a8a4766474a1e455$var$clearComposition(view) {
        if (view.composing) {
            view.input.composing = false;
            view.input.compositionEndedAt = $a8a4766474a1e455$var$timestampFromCustomEvent();
        }
        while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
    }
    function $a8a4766474a1e455$var$findCompositionNode(view) {
        let sel = view.domSelectionRange();
        if (!sel.focusNode) return null;
        let textBefore = $a8a4766474a1e455$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
        let textAfter = $a8a4766474a1e455$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
        if (textBefore && textAfter && textBefore != textAfter) {
            let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
            if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
            if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
            else if (view.input.compositionNode == textAfter) {
                let descBefore = textBefore.pmViewDesc;
                if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
            }
        }
        return textBefore || textAfter;
    }
    function $a8a4766474a1e455$var$timestampFromCustomEvent() {
        let event = document.createEvent("Event");
        event.initEvent("event", true, true);
        return event.timeStamp;
    }
    function $a8a4766474a1e455$var$endComposition(view, restarting = false) {
        if ($a8a4766474a1e455$var$android && view.domObserver.flushingSoon >= 0) return;
        view.domObserver.forceFlush();
        $a8a4766474a1e455$var$clearComposition(view);
        if (restarting || view.docView && view.docView.dirty) {
            let sel = $a8a4766474a1e455$var$selectionFromDOM(view);
            if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
            else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
            else view.updateState(view.state);
            return true;
        }
        return false;
    }
    function $a8a4766474a1e455$var$captureCopy(view, dom) {
        if (!view.dom.parentNode) return;
        let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
        wrap.appendChild(dom);
        wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
        let sel = getSelection(), range = document.createRange();
        range.selectNodeContents(dom);
        view.dom.blur();
        sel.removeAllRanges();
        sel.addRange(range);
        setTimeout(()=>{
            if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
            view.focus();
        }, 50);
    }
    const $a8a4766474a1e455$var$brokenClipboardAPI = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version < 15 || $a8a4766474a1e455$var$ios && $a8a4766474a1e455$var$webkit_version < 604;
    $a8a4766474a1e455$var$handlers.copy = $a8a4766474a1e455$var$editHandlers.cut = (view, _event)=>{
        let event = _event;
        let sel = view.state.selection, cut = event.type == "cut";
        if (sel.empty) return;
        let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
        let slice = sel.content(), { dom: dom, text: text } = $a8a4766474a1e455$var$serializeForClipboard(view, slice);
        if (data) {
            event.preventDefault();
            data.clearData();
            data.setData("text/html", dom.innerHTML);
            data.setData("text/plain", text);
        } else $a8a4766474a1e455$var$captureCopy(view, dom);
        if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
    };
    function $a8a4766474a1e455$var$sliceSingleNode(slice) {
        return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
    }
    function $a8a4766474a1e455$var$capturePaste(view, event) {
        if (!view.dom.parentNode) return;
        let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
        let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
        if (!plainText) target.contentEditable = "true";
        target.style.cssText = "position: fixed; left: -10000px; top: 10px";
        target.focus();
        let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
        setTimeout(()=>{
            view.focus();
            if (target.parentNode) target.parentNode.removeChild(target);
            if (plainText) $a8a4766474a1e455$var$doPaste(view, target.value, null, plain, event);
            else $a8a4766474a1e455$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
        }, 50);
    }
    function $a8a4766474a1e455$var$doPaste(view, text, html, preferPlain, event) {
        let slice = $a8a4766474a1e455$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
        if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, (0, parcelRequire("kCV8T")).Slice).empty))) return true;
        if (!slice) return false;
        let singleNode = $a8a4766474a1e455$var$sliceSingleNode(slice);
        let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
        view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
        return true;
    }
    function $a8a4766474a1e455$var$getText(clipboardData) {
        let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
        if (text) return text;
        let uris = clipboardData.getData("text/uri-list");
        return uris ? uris.replace(/\r?\n/g, " ") : "";
    }
    $a8a4766474a1e455$var$editHandlers.paste = (view, _event)=>{
        let event = _event;
        if (view.composing && !$a8a4766474a1e455$var$android) return;
        let data = $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.clipboardData;
        let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
        if (data && $a8a4766474a1e455$var$doPaste(view, $a8a4766474a1e455$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
        else $a8a4766474a1e455$var$capturePaste(view, event);
    };
    class $a8a4766474a1e455$var$Dragging {
        constructor(slice, move, node){
            this.slice = slice;
            this.move = move;
            this.node = node;
        }
    }
    const $a8a4766474a1e455$var$dragCopyModifier = $a8a4766474a1e455$var$mac ? "altKey" : "ctrlKey";
    $a8a4766474a1e455$var$handlers.dragstart = (view, _event)=>{
        let event = _event;
        let mouseDown = view.input.mouseDown;
        if (mouseDown) mouseDown.done();
        if (!event.dataTransfer) return;
        let sel = view.state.selection;
        let pos = sel.empty ? null : view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
        let node;
        if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) ? sel.to - 1 : sel.to)) ;
        else if (mouseDown && mouseDown.mightDrag) node = (0, (0, parcelRequire("gZGBX")).NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
        else if (event.target && event.target.nodeType == 1) {
            let desc = view.docView.nearestDesc(event.target, true);
            if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, (0, parcelRequire("gZGBX")).NodeSelection).create(view.state.doc, desc.posBefore);
        }
        let draggedSlice = (node || view.state.selection).content();
        let { dom: dom, text: text, slice: slice } = $a8a4766474a1e455$var$serializeForClipboard(view, draggedSlice);
        if (!event.dataTransfer.files.length || !$a8a4766474a1e455$var$chrome || $a8a4766474a1e455$var$chrome_version > 120) event.dataTransfer.clearData();
        event.dataTransfer.setData($a8a4766474a1e455$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
        event.dataTransfer.effectAllowed = "copyMove";
        if (!$a8a4766474a1e455$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
        view.dragging = new $a8a4766474a1e455$var$Dragging(slice, !event[$a8a4766474a1e455$var$dragCopyModifier], node);
    };
    $a8a4766474a1e455$var$handlers.dragend = (view)=>{
        let dragging = view.dragging;
        window.setTimeout(()=>{
            if (view.dragging == dragging) view.dragging = null;
        }, 50);
    };
    $a8a4766474a1e455$var$editHandlers.dragover = $a8a4766474a1e455$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
    $a8a4766474a1e455$var$editHandlers.drop = (view, _event)=>{
        let event = _event;
        let dragging = view.dragging;
        view.dragging = null;
        if (!event.dataTransfer) return;
        let eventPos = view.posAtCoords($a8a4766474a1e455$var$eventCoords(event));
        if (!eventPos) return;
        let $mouse = view.state.doc.resolve(eventPos.pos);
        let slice = dragging && dragging.slice;
        if (slice) view.someProp("transformPasted", (f)=>{
            slice = f(slice, view);
        });
        else slice = $a8a4766474a1e455$var$parseFromClipboard(view, $a8a4766474a1e455$var$getText(event.dataTransfer), $a8a4766474a1e455$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
        let move = !!(dragging && !event[$a8a4766474a1e455$var$dragCopyModifier]);
        if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, (0, parcelRequire("kCV8T")).Slice).empty, move))) {
            event.preventDefault();
            return;
        }
        if (!slice) return;
        event.preventDefault();
        let insertPos = slice ? (0, (0, parcelRequire("eS2Dn")).dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
        if (insertPos == null) insertPos = $mouse.pos;
        let tr = view.state.tr;
        if (move) {
            let { node: node } = dragging;
            if (node) node.replace(tr);
            else tr.deleteSelection();
        }
        let pos = tr.mapping.map(insertPos);
        let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
        let beforeInsert = tr.doc;
        if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
        else tr.replaceRange(pos, pos, slice);
        if (tr.doc.eq(beforeInsert)) return;
        let $pos = tr.doc.resolve(pos);
        if (isNode && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)($pos));
        else {
            let end = tr.mapping.map(insertPos);
            tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
            tr.setSelection($a8a4766474a1e455$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
        }
        view.focus();
        view.dispatch(tr.setMeta("uiEvent", "drop"));
    };
    $a8a4766474a1e455$var$handlers.focus = (view)=>{
        view.input.lastFocus = Date.now();
        if (!view.focused) {
            view.domObserver.stop();
            view.dom.classList.add("ProseMirror-focused");
            view.domObserver.start();
            view.focused = true;
            setTimeout(()=>{
                if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $a8a4766474a1e455$var$selectionToDOM(view);
            }, 20);
        }
    };
    $a8a4766474a1e455$var$handlers.blur = (view, _event)=>{
        let event = _event;
        if (view.focused) {
            view.domObserver.stop();
            view.dom.classList.remove("ProseMirror-focused");
            view.domObserver.start();
            if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
            view.focused = false;
        }
    };
    $a8a4766474a1e455$var$handlers.beforeinput = (view, _event)=>{
        let event = _event;
        if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && event.inputType == "deleteContentBackward") {
            view.domObserver.flushSoon();
            let { domChangeCount: domChangeCount } = view.input;
            setTimeout(()=>{
                if (view.input.domChangeCount != domChangeCount) return;
                view.dom.blur();
                view.focus();
                if (view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) return;
                let { $cursor: $cursor } = view.state.selection;
                if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
            }, 50);
        }
    };
    for(let prop in $a8a4766474a1e455$var$editHandlers)$a8a4766474a1e455$var$handlers[prop] = $a8a4766474a1e455$var$editHandlers[prop];
    function $a8a4766474a1e455$var$compareObjs(a, b) {
        if (a == b) return true;
        for(let p in a)if (a[p] !== b[p]) return false;
        for(let p in b)if (!(p in a)) return false;
        return true;
    }
    class $a8a4766474a1e455$var$WidgetType {
        constructor(toDOM, spec){
            this.toDOM = toDOM;
            this.spec = spec || $a8a4766474a1e455$var$noSpec;
            this.side = this.spec.side || 0;
        }
        map(mapping, span, offset, oldOffset) {
            let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
            return deleted ? null : new $a8a4766474a1e455$export$10e30b733df217ea(pos - offset, pos - offset, this);
        }
        valid() {
            return true;
        }
        eq(other) {
            return this == other || other instanceof $a8a4766474a1e455$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec));
        }
        destroy(node) {
            if (this.spec.destroy) this.spec.destroy(node);
        }
    }
    class $a8a4766474a1e455$var$InlineType {
        constructor(attrs, spec){
            this.attrs = attrs;
            this.spec = spec || $a8a4766474a1e455$var$noSpec;
        }
        map(mapping, span, offset, oldOffset) {
            let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
            let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
            return from >= to ? null : new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this);
        }
        valid(_, span) {
            return span.from < span.to;
        }
        eq(other) {
            return this == other || other instanceof $a8a4766474a1e455$var$InlineType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
        }
        static is(span) {
            return span.type instanceof $a8a4766474a1e455$var$InlineType;
        }
        destroy() {}
    }
    class $a8a4766474a1e455$var$NodeType {
        constructor(attrs, spec){
            this.attrs = attrs;
            this.spec = spec || $a8a4766474a1e455$var$noSpec;
        }
        map(mapping, span, offset, oldOffset) {
            let from = mapping.mapResult(span.from + oldOffset, 1);
            if (from.deleted) return null;
            let to = mapping.mapResult(span.to + oldOffset, -1);
            if (to.deleted || to.pos <= from.pos) return null;
            return new $a8a4766474a1e455$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
        }
        valid(node, span) {
            let { index: index, offset: offset } = node.content.findIndex(span.from), child;
            return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
        }
        eq(other) {
            return this == other || other instanceof $a8a4766474a1e455$var$NodeType && $a8a4766474a1e455$var$compareObjs(this.attrs, other.attrs) && $a8a4766474a1e455$var$compareObjs(this.spec, other.spec);
        }
        destroy() {}
    }
    class $a8a4766474a1e455$export$10e30b733df217ea {
        constructor(from, to, type){
            this.from = from;
            this.to = to;
            this.type = type;
        }
        copy(from, to) {
            return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, this.type);
        }
        eq(other, offset = 0) {
            return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
        }
        map(mapping, offset, oldOffset) {
            return this.type.map(mapping, this, offset, oldOffset);
        }
        static widget(pos, toDOM, spec) {
            return new $a8a4766474a1e455$export$10e30b733df217ea(pos, pos, new $a8a4766474a1e455$var$WidgetType(toDOM, spec));
        }
        static inline(from, to, attrs, spec) {
            return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$InlineType(attrs, spec));
        }
        static node(from, to, attrs, spec) {
            return new $a8a4766474a1e455$export$10e30b733df217ea(from, to, new $a8a4766474a1e455$var$NodeType(attrs, spec));
        }
        get spec() {
            return this.type.spec;
        }
        get inline() {
            return this.type instanceof $a8a4766474a1e455$var$InlineType;
        }
        get widget() {
            return this.type instanceof $a8a4766474a1e455$var$WidgetType;
        }
    }
    const $a8a4766474a1e455$var$none = [], $a8a4766474a1e455$var$noSpec = {};
    class $a8a4766474a1e455$export$93bf62eb445cec98 {
        constructor(local, children){
            this.local = local.length ? local : $a8a4766474a1e455$var$none;
            this.children = children.length ? children : $a8a4766474a1e455$var$none;
        }
        static create(doc, decorations) {
            return decorations.length ? $a8a4766474a1e455$var$buildTree(decorations, doc, 0, $a8a4766474a1e455$var$noSpec) : $a8a4766474a1e455$var$empty;
        }
        find(start, end, predicate) {
            let result = [];
            this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
            return result;
        }
        findInner(start, end, result, offset, predicate) {
            for(let i = 0; i < this.local.length; i++){
                let span = this.local[i];
                if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
            }
            for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
                let childOff = this.children[i] + 1;
                this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
            }
        }
        map(mapping, doc, options) {
            if (this == $a8a4766474a1e455$var$empty || mapping.maps.length == 0) return this;
            return this.mapInner(mapping, doc, 0, 0, options || $a8a4766474a1e455$var$noSpec);
        }
        mapInner(mapping, node, offset, oldOffset, options) {
            let newLocal;
            for(let i = 0; i < this.local.length; i++){
                let mapped = this.local[i].map(mapping, offset, oldOffset);
                if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
                else if (options.onRemove) options.onRemove(this.local[i].spec);
            }
            if (this.children.length) return $a8a4766474a1e455$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
            else return newLocal ? new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none) : $a8a4766474a1e455$var$empty;
        }
        add(doc, decorations) {
            if (!decorations.length) return this;
            if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$export$93bf62eb445cec98.create(doc, decorations);
            return this.addInner(doc, decorations, 0);
        }
        addInner(doc, decorations, offset) {
            let children, childIndex = 0;
            doc.forEach((childNode, childOffset)=>{
                let baseOffset = childOffset + offset, found;
                if (!(found = $a8a4766474a1e455$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
                if (!children) children = this.children.slice();
                while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
                if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
                else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $a8a4766474a1e455$var$buildTree(found, childNode, baseOffset + 1, $a8a4766474a1e455$var$noSpec));
                childIndex += 3;
            });
            let local = $a8a4766474a1e455$var$moveSpans(childIndex ? $a8a4766474a1e455$var$withoutNulls(decorations) : decorations, -offset);
            for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
            return new $a8a4766474a1e455$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($a8a4766474a1e455$var$byPos) : this.local, children || this.children);
        }
        remove(decorations) {
            if (decorations.length == 0 || this == $a8a4766474a1e455$var$empty) return this;
            return this.removeInner(decorations, 0);
        }
        removeInner(decorations, offset) {
            let children = this.children, local = this.local;
            for(let i = 0; i < children.length; i += 3){
                let found;
                let from = children[i] + offset, to = children[i + 1] + offset;
                for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                    if (span.from > from && span.to < to) {
                        decorations[j] = null;
                        (found || (found = [])).push(span);
                    }
                }
                if (!found) continue;
                if (children == this.children) children = this.children.slice();
                let removed = children[i + 2].removeInner(found, from + 1);
                if (removed != $a8a4766474a1e455$var$empty) children[i + 2] = removed;
                else {
                    children.splice(i, 3);
                    i -= 3;
                }
            }
            if (local.length) {
                for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                    for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                        if (local == this.local) local = this.local.slice();
                        local.splice(j--, 1);
                    }
                }
            }
            if (children == this.children && local == this.local) return this;
            return local.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(local, children) : $a8a4766474a1e455$var$empty;
        }
        forChild(offset, node) {
            if (this == $a8a4766474a1e455$var$empty) return this;
            if (node.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
            let child, local;
            for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
                if (this.children[i] == offset) child = this.children[i + 2];
                break;
            }
            let start = offset + 1, end = start + node.content.size;
            for(let i = 0; i < this.local.length; i++){
                let dec = this.local[i];
                if (dec.from < end && dec.to > start && dec.type instanceof $a8a4766474a1e455$var$InlineType) {
                    let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                    if (from < to) (local || (local = [])).push(dec.copy(from, to));
                }
            }
            if (local) {
                let localSet = new $a8a4766474a1e455$export$93bf62eb445cec98(local.sort($a8a4766474a1e455$var$byPos), $a8a4766474a1e455$var$none);
                return child ? new $a8a4766474a1e455$var$DecorationGroup([
                    localSet,
                    child
                ]) : localSet;
            }
            return child || $a8a4766474a1e455$var$empty;
        }
        eq(other) {
            if (this == other) return true;
            if (!(other instanceof $a8a4766474a1e455$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
            for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
            for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
            return true;
        }
        locals(node) {
            return $a8a4766474a1e455$var$removeOverlap(this.localsInner(node));
        }
        localsInner(node) {
            if (this == $a8a4766474a1e455$var$empty) return $a8a4766474a1e455$var$none;
            if (node.inlineContent || !this.local.some($a8a4766474a1e455$var$InlineType.is)) return this.local;
            let result = [];
            for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $a8a4766474a1e455$var$InlineType)) result.push(this.local[i]);
            return result;
        }
        forEachSet(f) {
            f(this);
        }
    }
    $a8a4766474a1e455$export$93bf62eb445cec98.empty = new $a8a4766474a1e455$export$93bf62eb445cec98([], []);
    $a8a4766474a1e455$export$93bf62eb445cec98.removeOverlap = $a8a4766474a1e455$var$removeOverlap;
    const $a8a4766474a1e455$var$empty = $a8a4766474a1e455$export$93bf62eb445cec98.empty;
    class $a8a4766474a1e455$var$DecorationGroup {
        constructor(members){
            this.members = members;
        }
        map(mapping, doc) {
            const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $a8a4766474a1e455$var$noSpec));
            return $a8a4766474a1e455$var$DecorationGroup.from(mappedDecos);
        }
        forChild(offset, child) {
            if (child.isLeaf) return $a8a4766474a1e455$export$93bf62eb445cec98.empty;
            let found = [];
            for(let i = 0; i < this.members.length; i++){
                let result = this.members[i].forChild(offset, child);
                if (result == $a8a4766474a1e455$var$empty) continue;
                if (result instanceof $a8a4766474a1e455$var$DecorationGroup) found = found.concat(result.members);
                else found.push(result);
            }
            return $a8a4766474a1e455$var$DecorationGroup.from(found);
        }
        eq(other) {
            if (!(other instanceof $a8a4766474a1e455$var$DecorationGroup) || other.members.length != this.members.length) return false;
            for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
            return true;
        }
        locals(node) {
            let result, sorted = true;
            for(let i = 0; i < this.members.length; i++){
                let locals = this.members[i].localsInner(node);
                if (!locals.length) continue;
                if (!result) result = locals;
                else {
                    if (sorted) {
                        result = result.slice();
                        sorted = false;
                    }
                    for(let j = 0; j < locals.length; j++)result.push(locals[j]);
                }
            }
            return result ? $a8a4766474a1e455$var$removeOverlap(sorted ? result : result.sort($a8a4766474a1e455$var$byPos)) : $a8a4766474a1e455$var$none;
        }
        static from(members) {
            switch(members.length){
                case 0:
                    return $a8a4766474a1e455$var$empty;
                case 1:
                    return members[0];
                default:
                    return new $a8a4766474a1e455$var$DecorationGroup(members.every((m)=>m instanceof $a8a4766474a1e455$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $a8a4766474a1e455$export$93bf62eb445cec98 ? m : m.members), []));
            }
        }
        forEachSet(f) {
            for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
        }
    }
    function $a8a4766474a1e455$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
        let children = oldChildren.slice();
        for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
            let moved = 0;
            mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
                let dSize = newEnd - newStart - (oldEnd - oldStart);
                for(let i = 0; i < children.length; i += 3){
                    let end = children[i + 1];
                    if (end < 0 || oldStart > end + baseOffset - moved) continue;
                    let start = children[i] + baseOffset - moved;
                    if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                    else if (oldStart >= baseOffset && dSize) {
                        children[i] += dSize;
                        children[i + 1] += dSize;
                    }
                }
                moved += dSize;
            });
            baseOffset = mapping.maps[i].map(baseOffset, -1);
        }
        let mustRebuild = false;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            if (children[i + 1] == -2) {
                mustRebuild = true;
                children[i + 1] = -1;
                continue;
            }
            let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
            if (fromLocal < 0 || fromLocal >= node.content.size) {
                mustRebuild = true;
                continue;
            }
            let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
            let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
            let childNode = node.maybeChild(index);
            if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
                let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
                if (mapped != $a8a4766474a1e455$var$empty) {
                    children[i] = fromLocal;
                    children[i + 1] = toLocal;
                    children[i + 2] = mapped;
                } else {
                    children[i + 1] = -2;
                    mustRebuild = true;
                }
            } else mustRebuild = true;
        }
        if (mustRebuild) {
            let decorations = $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
            let built = $a8a4766474a1e455$var$buildTree(decorations, node, 0, options);
            newLocal = built.local;
            for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
                children.splice(i, 3);
                i -= 3;
            }
            for(let i = 0, j = 0; i < built.children.length; i += 3){
                let from = built.children[i];
                while(j < children.length && children[j] < from)j += 3;
                children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
            }
        }
        return new $a8a4766474a1e455$export$93bf62eb445cec98(newLocal.sort($a8a4766474a1e455$var$byPos), children);
    }
    function $a8a4766474a1e455$var$moveSpans(spans, offset) {
        if (!offset || !spans.length) return spans;
        let result = [];
        for(let i = 0; i < spans.length; i++){
            let span = spans[i];
            result.push(new $a8a4766474a1e455$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
        }
        return result;
    }
    function $a8a4766474a1e455$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
        function gather(set, oldOffset) {
            for(let i = 0; i < set.local.length; i++){
                let mapped = set.local[i].map(mapping, offset, oldOffset);
                if (mapped) decorations.push(mapped);
                else if (options.onRemove) options.onRemove(set.local[i].spec);
            }
            for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
        }
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
        return decorations;
    }
    function $a8a4766474a1e455$var$takeSpansForNode(spans, node, offset) {
        if (node.isLeaf) return null;
        let end = offset + node.nodeSize, found = null;
        for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
            (found || (found = [])).push(span);
            spans[i] = null;
        }
        return found;
    }
    function $a8a4766474a1e455$var$withoutNulls(array) {
        let result = [];
        for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
        return result;
    }
    function $a8a4766474a1e455$var$buildTree(spans, node, offset, options) {
        let children = [], hasNulls = false;
        node.forEach((childNode, localStart)=>{
            let found = $a8a4766474a1e455$var$takeSpansForNode(spans, childNode, localStart + offset);
            if (found) {
                hasNulls = true;
                let subtree = $a8a4766474a1e455$var$buildTree(found, childNode, offset + localStart + 1, options);
                if (subtree != $a8a4766474a1e455$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
            }
        });
        let locals = $a8a4766474a1e455$var$moveSpans(hasNulls ? $a8a4766474a1e455$var$withoutNulls(spans) : spans, -offset).sort($a8a4766474a1e455$var$byPos);
        for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
            if (options.onRemove) options.onRemove(locals[i].spec);
            locals.splice(i--, 1);
        }
        return locals.length || children.length ? new $a8a4766474a1e455$export$93bf62eb445cec98(locals, children) : $a8a4766474a1e455$var$empty;
    }
    function $a8a4766474a1e455$var$byPos(a, b) {
        return a.from - b.from || a.to - b.to;
    }
    function $a8a4766474a1e455$var$removeOverlap(spans) {
        let working = spans;
        for(let i = 0; i < working.length - 1; i++){
            let span = working[i];
            if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
                let next = working[j];
                if (next.from == span.from) {
                    if (next.to != span.to) {
                        if (working == spans) working = spans.slice();
                        working[j] = next.copy(next.from, span.to);
                        $a8a4766474a1e455$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                    }
                    continue;
                } else {
                    if (next.from < span.to) {
                        if (working == spans) working = spans.slice();
                        working[i] = span.copy(span.from, next.from);
                        $a8a4766474a1e455$var$insertAhead(working, j, span.copy(next.from, span.to));
                    }
                    break;
                }
            }
        }
        return working;
    }
    function $a8a4766474a1e455$var$insertAhead(array, i, deco) {
        while(i < array.length && $a8a4766474a1e455$var$byPos(deco, array[i]) > 0)i++;
        array.splice(i, 0, deco);
    }
    function $a8a4766474a1e455$var$viewDecorations(view) {
        let found = [];
        view.someProp("decorations", (f)=>{
            let result = f(view.state);
            if (result && result != $a8a4766474a1e455$var$empty) found.push(result);
        });
        if (view.cursorWrapper) found.push($a8a4766474a1e455$export$93bf62eb445cec98.create(view.state.doc, [
            view.cursorWrapper.deco
        ]));
        return $a8a4766474a1e455$var$DecorationGroup.from(found);
    }
    const $a8a4766474a1e455$var$observeOptions = {
        childList: true,
        characterData: true,
        characterDataOldValue: true,
        attributes: true,
        attributeOldValue: true,
        subtree: true
    };
    const $a8a4766474a1e455$var$useCharData = $a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11;
    class $a8a4766474a1e455$var$SelectionState {
        constructor(){
            this.anchorNode = null;
            this.anchorOffset = 0;
            this.focusNode = null;
            this.focusOffset = 0;
        }
        set(sel) {
            this.anchorNode = sel.anchorNode;
            this.anchorOffset = sel.anchorOffset;
            this.focusNode = sel.focusNode;
            this.focusOffset = sel.focusOffset;
        }
        clear() {
            this.anchorNode = this.focusNode = null;
        }
        eq(sel) {
            return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
        }
    }
    class $a8a4766474a1e455$var$DOMObserver {
        constructor(view, handleDOMChange){
            this.view = view;
            this.handleDOMChange = handleDOMChange;
            this.queue = [];
            this.flushingSoon = -1;
            this.observer = null;
            this.currentSelection = new $a8a4766474a1e455$var$SelectionState;
            this.onCharData = null;
            this.suppressingSelectionUpdates = false;
            this.lastChangedTextNode = null;
            this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
                for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
                if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
                else this.flush();
            });
            if ($a8a4766474a1e455$var$useCharData) this.onCharData = (e)=>{
                this.queue.push({
                    target: e.target,
                    type: "characterData",
                    oldValue: e.prevValue
                });
                this.flushSoon();
            };
            this.onSelectionChange = this.onSelectionChange.bind(this);
        }
        flushSoon() {
            if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
                this.flushingSoon = -1;
                this.flush();
            }, 20);
        }
        forceFlush() {
            if (this.flushingSoon > -1) {
                window.clearTimeout(this.flushingSoon);
                this.flushingSoon = -1;
                this.flush();
            }
        }
        start() {
            if (this.observer) {
                this.observer.takeRecords();
                this.observer.observe(this.view.dom, $a8a4766474a1e455$var$observeOptions);
            }
            if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
            this.connectSelection();
        }
        stop() {
            if (this.observer) {
                let take = this.observer.takeRecords();
                if (take.length) {
                    for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                    window.setTimeout(()=>this.flush(), 20);
                }
                this.observer.disconnect();
            }
            if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
            this.disconnectSelection();
        }
        connectSelection() {
            this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
        }
        disconnectSelection() {
            this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
        }
        suppressSelectionUpdates() {
            this.suppressingSelectionUpdates = true;
            setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
        }
        onSelectionChange() {
            if (!$a8a4766474a1e455$var$hasFocusAndSelection(this.view)) return;
            if (this.suppressingSelectionUpdates) return $a8a4766474a1e455$var$selectionToDOM(this.view);
            if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && !this.view.state.selection.empty) {
                let sel = this.view.domSelectionRange();
                if (sel.focusNode && $a8a4766474a1e455$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
            }
            this.flush();
        }
        setCurSelection() {
            this.currentSelection.set(this.view.domSelectionRange());
        }
        ignoreSelectionChange(sel) {
            if (!sel.focusNode) return true;
            let ancestors = new Set, container;
            for(let scan = sel.focusNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))ancestors.add(scan);
            for(let scan = sel.anchorNode; scan; scan = $a8a4766474a1e455$var$parentNode(scan))if (ancestors.has(scan)) {
                container = scan;
                break;
            }
            let desc = container && this.view.docView.nearestDesc(container);
            if (desc && desc.ignoreMutation({
                type: "selection",
                target: container.nodeType == 3 ? container.parentNode : container
            })) {
                this.setCurSelection();
                return true;
            }
        }
        pendingRecords() {
            if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
            return this.queue;
        }
        selectionChanged(sel) {
            return !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $a8a4766474a1e455$var$hasFocusAndSelection(this.view) && !this.ignoreSelectionChange(sel);
        }
        flush() {
            let { view: view } = this;
            if (!view.docView || this.flushingSoon > -1) return;
            let mutations = this.pendingRecords();
            if (mutations.length) this.queue = [];
            let sel = view.domSelectionRange(), newSel = this.selectionChanged(sel);
            let from = -1, to = -1, typeOver = false, added = [];
            if (view.editable) for(let i = 0; i < mutations.length; i++){
                let result = this.registerMutation(mutations[i], added);
                if (result) {
                    from = from < 0 ? result.from : Math.min(result.from, from);
                    to = to < 0 ? result.to : Math.max(result.to, to);
                    if (result.typeOver) typeOver = true;
                }
            }
            if ($a8a4766474a1e455$var$gecko && added.length) {
                let brs = added.filter((n)=>n.nodeName == "BR");
                if (brs.length == 2) {
                    let [a, b] = brs;
                    if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                    else a.remove();
                } else {
                    let { focusNode: focusNode } = this.currentSelection;
                    for (let br of brs){
                        let parent = br.parentNode;
                        if (parent && parent.nodeName == "LI" && (!focusNode || $a8a4766474a1e455$var$blockParent(view, focusNode) != parent)) br.remove();
                    }
                }
            }
            let readSel = null;
            if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $a8a4766474a1e455$var$selectionCollapsed(sel) && (readSel = $a8a4766474a1e455$var$selectionFromDOM(view)) && readSel.eq((0, (0, parcelRequire("gZGBX")).Selection).near(view.state.doc.resolve(0), 1))) {
                view.input.lastFocus = 0;
                $a8a4766474a1e455$var$selectionToDOM(view);
                this.currentSelection.set(sel);
                view.scrollToSelection();
            } else if (from > -1 || newSel) {
                if (from > -1) {
                    view.docView.markDirty(from, to);
                    $a8a4766474a1e455$var$checkCSS(view);
                }
                this.handleDOMChange(from, to, typeOver, added);
                if (view.docView && view.docView.dirty) view.updateState(view.state);
                else if (!this.currentSelection.eq(sel)) $a8a4766474a1e455$var$selectionToDOM(view);
                this.currentSelection.set(sel);
            }
        }
        registerMutation(mut, added) {
            if (added.indexOf(mut.target) > -1) return null;
            let desc = this.view.docView.nearestDesc(mut.target);
            if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
            if (!desc || desc.ignoreMutation(mut)) return null;
            if (mut.type == "childList") {
                for(let i = 0; i < mut.addedNodes.length; i++){
                    let node = mut.addedNodes[i];
                    added.push(node);
                    if (node.nodeType == 3) this.lastChangedTextNode = node;
                }
                if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                    from: desc.posBefore,
                    to: desc.posAfter
                };
                let prev = mut.previousSibling, next = mut.nextSibling;
                if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && mut.addedNodes.length) for(let i = 0; i < mut.addedNodes.length; i++){
                    let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                    if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                    if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
                }
                let fromOffset = prev && prev.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(prev) + 1 : 0;
                let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
                let toOffset = next && next.parentNode == mut.target ? $a8a4766474a1e455$var$domIndex(next) : mut.target.childNodes.length;
                let to = desc.localPosFromDOM(mut.target, toOffset, 1);
                return {
                    from: from,
                    to: to
                };
            } else if (mut.type == "attributes") return {
                from: desc.posAtStart - desc.border,
                to: desc.posAtEnd + desc.border
            };
            else {
                this.lastChangedTextNode = mut.target;
                return {
                    from: desc.posAtStart,
                    to: desc.posAtEnd,
                    typeOver: mut.target.nodeValue == mut.oldValue
                };
            }
        }
    }
    let $a8a4766474a1e455$var$cssChecked = new WeakMap();
    let $a8a4766474a1e455$var$cssCheckWarned = false;
    function $a8a4766474a1e455$var$checkCSS(view) {
        if ($a8a4766474a1e455$var$cssChecked.has(view)) return;
        $a8a4766474a1e455$var$cssChecked.set(view, null);
        if ([
            'normal',
            'nowrap',
            'pre-line'
        ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
            view.requiresGeckoHackNode = $a8a4766474a1e455$var$gecko;
            if ($a8a4766474a1e455$var$cssCheckWarned) return;
            console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
            $a8a4766474a1e455$var$cssCheckWarned = true;
        }
    }
    function $a8a4766474a1e455$var$rangeToSelectionRange(view, range) {
        let anchorNode = range.startContainer, anchorOffset = range.startOffset;
        let focusNode = range.endContainer, focusOffset = range.endOffset;
        let currentAnchor = view.domAtPos(view.state.selection.anchor);
        if ($a8a4766474a1e455$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
            focusNode,
            focusOffset,
            anchorNode,
            anchorOffset
        ];
        return {
            anchorNode: anchorNode,
            anchorOffset: anchorOffset,
            focusNode: focusNode,
            focusOffset: focusOffset
        };
    }
    function $a8a4766474a1e455$var$safariShadowSelectionRange(view, selection) {
        if (selection.getComposedRanges) {
            let range = selection.getComposedRanges(view.root)[0];
            if (range) return $a8a4766474a1e455$var$rangeToSelectionRange(view, range);
        }
        let found;
        function read(event) {
            event.preventDefault();
            event.stopImmediatePropagation();
            found = event.getTargetRanges()[0];
        }
        view.dom.addEventListener("beforeinput", read, true);
        document.execCommand("indent");
        view.dom.removeEventListener("beforeinput", read, true);
        return found ? $a8a4766474a1e455$var$rangeToSelectionRange(view, found) : null;
    }
    function $a8a4766474a1e455$var$blockParent(view, node) {
        for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
            let desc = view.docView.nearestDesc(p, true);
            if (desc && desc.node.isBlock) return p;
        }
        return null;
    }
    function $a8a4766474a1e455$var$parseBetween(view, from_, to_) {
        let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
        let domSel = view.domSelectionRange();
        let find;
        let anchor = domSel.anchorNode;
        if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
            find = [
                {
                    node: anchor,
                    offset: domSel.anchorOffset
                }
            ];
            if (!$a8a4766474a1e455$var$selectionCollapsed(domSel)) find.push({
                node: domSel.focusNode,
                offset: domSel.focusOffset
            });
        }
        if ($a8a4766474a1e455$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
            let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
            if (node.nodeName == "BR" && !desc) {
                toOffset = off;
                break;
            }
            if (!desc || desc.size) break;
        }
        let startDoc = view.state.doc;
        let parser = view.someProp("domParser") || (0, (0, parcelRequire("kCV8T")).DOMParser).fromSchema(view.state.schema);
        let $from = startDoc.resolve(from);
        let sel = null, doc = parser.parse(parent, {
            topNode: $from.parent,
            topMatch: $from.parent.contentMatchAt($from.index()),
            topOpen: true,
            from: fromOffset,
            to: toOffset,
            preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
            findPositions: find,
            ruleFromNode: $a8a4766474a1e455$var$ruleFromNode,
            context: $from
        });
        if (find && find[0].pos != null) {
            let anchor = find[0].pos, head = find[1] && find[1].pos;
            if (head == null) head = anchor;
            sel = {
                anchor: anchor + from,
                head: head + from
            };
        }
        return {
            doc: doc,
            sel: sel,
            from: from,
            to: to
        };
    }
    function $a8a4766474a1e455$var$ruleFromNode(dom) {
        let desc = dom.pmViewDesc;
        if (desc) return desc.parseRule();
        else if (dom.nodeName == "BR" && dom.parentNode) {
            if ($a8a4766474a1e455$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
                let skip = document.createElement("div");
                skip.appendChild(document.createElement("li"));
                return {
                    skip: skip
                };
            } else if (dom.parentNode.lastChild == dom || $a8a4766474a1e455$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
                ignore: true
            };
        } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
            ignore: true
        };
        return null;
    }
    const $a8a4766474a1e455$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
    function $a8a4766474a1e455$var$readDOMChange(view, from, to, typeOver, addedNodes) {
        let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
        view.input.compositionPendingChanges = 0;
        if (from < 0) {
            let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
            let newSel = $a8a4766474a1e455$var$selectionFromDOM(view, origin);
            if (newSel && !view.state.selection.eq(newSel)) {
                if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) return;
                let tr = view.state.tr.setSelection(newSel);
                if (origin == "pointer") tr.setMeta("pointer", true);
                else if (origin == "key") tr.scrollIntoView();
                if (compositionID) tr.setMeta("composition", compositionID);
                view.dispatch(tr);
            }
            return;
        }
        let $before = view.state.doc.resolve(from);
        let shared = $before.sharedDepth(to);
        from = $before.before(shared + 1);
        to = view.state.doc.resolve(to).after(shared + 1);
        let sel = view.state.selection;
        let parse = $a8a4766474a1e455$var$parseBetween(view, from, to);
        let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
        let preferredPos, preferredSide;
        if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
            preferredPos = view.state.selection.to;
            preferredSide = "end";
        } else {
            preferredPos = view.state.selection.from;
            preferredSide = "start";
        }
        view.input.lastKeyCode = null;
        let change = $a8a4766474a1e455$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
        if (change) view.input.domChangeCount++;
        if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $a8a4766474a1e455$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$a8a4766474a1e455$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
            view.input.lastIOSEnter = 0;
            return;
        }
        if (!change) {
            if (typeOver && sel instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
                start: sel.from,
                endA: sel.to,
                endB: sel.to
            };
            else {
                if (parse.sel) {
                    let sel = $a8a4766474a1e455$var$resolveSelection(view, view.state.doc, parse.sel);
                    if (sel && !sel.eq(view.state.selection)) {
                        let tr = view.state.tr.setSelection(sel);
                        if (compositionID) tr.setMeta("composition", compositionID);
                        view.dispatch(tr);
                    }
                }
                return;
            }
        }
        if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
            if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
            else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
                change.endB += view.state.selection.to - change.endA;
                change.endA = view.state.selection.to;
            }
        }
        if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
            change.start--;
            change.endA--;
            change.endB--;
        }
        let $from = parse.doc.resolveNoCache(change.start - parse.from);
        let $to = parse.doc.resolveNoCache(change.endB - parse.from);
        let $fromA = doc.resolve(change.start);
        let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
        let nextSel;
        if (($a8a4766474a1e455$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter")))) {
            view.input.lastIOSEnter = 0;
            return;
        }
        if (view.state.selection.anchor > change.start && $a8a4766474a1e455$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $a8a4766474a1e455$var$keyEvent(8, "Backspace")))) {
            if ($a8a4766474a1e455$var$android && $a8a4766474a1e455$var$chrome) view.domObserver.suppressSelectionUpdates();
            return;
        }
        if ($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && change.endB == change.start) view.input.lastAndroidDelete = Date.now();
        if ($a8a4766474a1e455$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
            change.endB -= 2;
            $to = parse.doc.resolveNoCache(change.endB - parse.from);
            setTimeout(()=>{
                view.someProp("handleKeyDown", function(f) {
                    return f(view, $a8a4766474a1e455$var$keyEvent(13, "Enter"));
                });
            }, 20);
        }
        let chFrom = change.start, chTo = change.endA;
        let tr, storedMarks, markChange;
        if (inlineChange) {
            if ($from.pos == $to.pos) {
                if ($a8a4766474a1e455$var$ie && $a8a4766474a1e455$var$ie_version <= 11 && $from.parentOffset == 0) {
                    view.domObserver.suppressSelectionUpdates();
                    setTimeout(()=>$a8a4766474a1e455$var$selectionToDOM(view), 20);
                }
                tr = view.state.tr.delete(chFrom, chTo);
                storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            } else if (change.endA == change.endB && (markChange = $a8a4766474a1e455$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
                tr = view.state.tr;
                if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
                else tr.removeMark(chFrom, chTo, markChange.mark);
            } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
                let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
                if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
                tr = view.state.tr.insertText(text, chFrom, chTo);
            }
        }
        if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $a8a4766474a1e455$var$resolveSelection(view, tr.doc, parse.sel);
            if (sel && !($a8a4766474a1e455$var$chrome && $a8a4766474a1e455$var$android && view.composing && sel.empty && (change.start != change.endB || view.input.lastAndroidDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $a8a4766474a1e455$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (storedMarks) tr.ensureMarks(storedMarks);
        if (compositionID) tr.setMeta("composition", compositionID);
        view.dispatch(tr.scrollIntoView());
    }
    function $a8a4766474a1e455$var$resolveSelection(view, doc, parsedSel) {
        if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
        return $a8a4766474a1e455$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
    }
    function $a8a4766474a1e455$var$isMarkChange(cur, prev) {
        let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
        let added = curMarks, removed = prevMarks, type, mark, update;
        for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
        for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
        if (added.length == 1 && removed.length == 0) {
            mark = added[0];
            type = "add";
            update = (node)=>node.mark(mark.addToSet(node.marks));
        } else if (added.length == 0 && removed.length == 1) {
            mark = removed[0];
            type = "remove";
            update = (node)=>node.mark(mark.removeFromSet(node.marks));
        } else return null;
        let updated = [];
        for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
        if ((0, (0, parcelRequire("kCV8T")).Fragment).from(updated).eq(cur)) return {
            mark: mark,
            type: type
        };
    }
    function $a8a4766474a1e455$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
        if (end - start <= $newEnd.pos - $newStart.pos || $a8a4766474a1e455$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
        let $start = old.resolve(start);
        if (!$newStart.parent.isTextblock) {
            let after = $start.nodeAfter;
            return after != null && end == start + after.nodeSize;
        }
        if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
        let $next = old.resolve($a8a4766474a1e455$var$skipClosingAndOpening($start, true, true));
        if (!$next.parent.isTextblock || $next.pos > end || $a8a4766474a1e455$var$skipClosingAndOpening($next, true, false) < end) return false;
        return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
    }
    function $a8a4766474a1e455$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
        let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
        while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
            depth--;
            end++;
            fromEnd = false;
        }
        if (mayOpen) {
            let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
            while(next && !next.isLeaf){
                next = next.firstChild;
                end++;
            }
        }
        return end;
    }
    function $a8a4766474a1e455$var$findDiff(a, b, pos, preferredPos, preferredSide) {
        let start = a.findDiffStart(b, pos);
        if (start == null) return null;
        let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
        if (preferredSide == "end") {
            let adjust = Math.max(0, start - Math.min(endA, endB));
            preferredPos -= endA + adjust - start;
        }
        if (endA < start && a.size < b.size) {
            let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
            start -= move;
            if (start && start < b.size && $a8a4766474a1e455$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
            endB = start + (endB - endA);
            endA = start;
        } else if (endB < start) {
            let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
            start -= move;
            if (start && start < a.size && $a8a4766474a1e455$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
            endA = start + (endA - endB);
            endB = start;
        }
        return {
            start: start,
            endA: endA,
            endB: endB
        };
    }
    function $a8a4766474a1e455$var$isSurrogatePair(str) {
        if (str.length != 2) return false;
        let a = str.charCodeAt(0), b = str.charCodeAt(1);
        return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
    }
    const $a8a4766474a1e455$export$38b79e3fdcfcfd68 = $a8a4766474a1e455$var$serializeForClipboard;
    const $a8a4766474a1e455$export$5d42ca91c11c9e4d = $a8a4766474a1e455$var$parseFromClipboard;
    const $a8a4766474a1e455$export$76b14d3c719c32fc = $a8a4766474a1e455$var$endComposition;
    class $a8a4766474a1e455$export$eece2fccabbb77c5 {
        constructor(place, props){
            this._root = null;
            this.focused = false;
            this.trackWrites = null;
            this.mounted = false;
            this.markCursor = null;
            this.cursorWrapper = null;
            this.lastSelectedViewDesc = undefined;
            this.input = new $a8a4766474a1e455$var$InputState;
            this.prevDirectPlugins = [];
            this.pluginViews = [];
            this.requiresGeckoHackNode = false;
            this.dragging = null;
            this._props = props;
            this.state = props.state;
            this.directPlugins = props.plugins || [];
            this.directPlugins.forEach($a8a4766474a1e455$var$checkStateComponent);
            this.dispatch = this.dispatch.bind(this);
            this.dom = place && place.mount || document.createElement("div");
            if (place) {
                if (place.appendChild) place.appendChild(this.dom);
                else if (typeof place == "function") place(this.dom);
                else if (place.mount) this.mounted = true;
            }
            this.editable = $a8a4766474a1e455$var$getEditable(this);
            $a8a4766474a1e455$var$updateCursorWrapper(this);
            this.nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
            this.docView = $a8a4766474a1e455$var$docViewDesc(this.state.doc, $a8a4766474a1e455$var$computeDocDeco(this), $a8a4766474a1e455$var$viewDecorations(this), this.dom, this);
            this.domObserver = new $a8a4766474a1e455$var$DOMObserver(this, (from, to, typeOver, added)=>$a8a4766474a1e455$var$readDOMChange(this, from, to, typeOver, added));
            this.domObserver.start();
            $a8a4766474a1e455$var$initInput(this);
            this.updatePluginViews();
        }
        get composing() {
            return this.input.composing;
        }
        get props() {
            if (this._props.state != this.state) {
                let prev = this._props;
                this._props = {};
                for(let name in prev)this._props[name] = prev[name];
                this._props.state = this.state;
            }
            return this._props;
        }
        update(props) {
            if (props.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
            let prevProps = this._props;
            this._props = props;
            if (props.plugins) {
                props.plugins.forEach($a8a4766474a1e455$var$checkStateComponent);
                this.directPlugins = props.plugins;
            }
            this.updateStateInner(props.state, prevProps);
        }
        setProps(props) {
            let updated = {};
            for(let name in this._props)updated[name] = this._props[name];
            updated.state = this.state;
            for(let name in props)updated[name] = props[name];
            this.update(updated);
        }
        updateState(state) {
            this.updateStateInner(state, this._props);
        }
        updateStateInner(state, prevProps) {
            var _a;
            let prev = this.state, redraw = false, updateSel = false;
            if (state.storedMarks && this.composing) {
                $a8a4766474a1e455$var$clearComposition(this);
                updateSel = true;
            }
            this.state = state;
            let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
            if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
                let nodeViews = $a8a4766474a1e455$var$buildNodeViews(this);
                if ($a8a4766474a1e455$var$changedNodeViews(nodeViews, this.nodeViews)) {
                    this.nodeViews = nodeViews;
                    redraw = true;
                }
            }
            if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $a8a4766474a1e455$var$ensureListeners(this);
            this.editable = $a8a4766474a1e455$var$getEditable(this);
            $a8a4766474a1e455$var$updateCursorWrapper(this);
            let innerDeco = $a8a4766474a1e455$var$viewDecorations(this), outerDeco = $a8a4766474a1e455$var$computeDocDeco(this);
            let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
            let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
            if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
            let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $a8a4766474a1e455$var$storeScrollPos(this);
            if (updateSel) {
                this.domObserver.stop();
                let forceSelUpdate = updateDoc && ($a8a4766474a1e455$var$ie || $a8a4766474a1e455$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $a8a4766474a1e455$var$selectionContextChanged(prev.selection, state.selection);
                if (updateDoc) {
                    let chromeKludge = $a8a4766474a1e455$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                    if (this.composing) this.input.compositionNode = $a8a4766474a1e455$var$findCompositionNode(this);
                    if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                        this.docView.updateOuterDeco(outerDeco);
                        this.docView.destroy();
                        this.docView = $a8a4766474a1e455$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                    }
                    if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
                }
                if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $a8a4766474a1e455$var$anchorInRightPlace(this))) $a8a4766474a1e455$var$selectionToDOM(this, forceSelUpdate);
                else {
                    $a8a4766474a1e455$var$syncNodeSelection(this, state.selection);
                    this.domObserver.setCurSelection();
                }
                this.domObserver.start();
            }
            this.updatePluginViews(prev);
            if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
            if (scroll == "reset") this.dom.scrollTop = 0;
            else if (scroll == "to selection") this.scrollToSelection();
            else if (oldScrollPos) $a8a4766474a1e455$var$resetScrollPos(oldScrollPos);
        }
        scrollToSelection() {
            let startDOM = this.domSelectionRange().focusNode;
            if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
            else if (this.state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
                let target = this.docView.domAfterPos(this.state.selection.from);
                if (target.nodeType == 1) $a8a4766474a1e455$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
            } else $a8a4766474a1e455$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
        }
        destroyPluginViews() {
            let view;
            while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
        }
        updatePluginViews(prevState) {
            if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
                this.prevDirectPlugins = this.directPlugins;
                this.destroyPluginViews();
                for(let i = 0; i < this.directPlugins.length; i++){
                    let plugin = this.directPlugins[i];
                    if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
                }
                for(let i = 0; i < this.state.plugins.length; i++){
                    let plugin = this.state.plugins[i];
                    if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
                }
            } else for(let i = 0; i < this.pluginViews.length; i++){
                let pluginView = this.pluginViews[i];
                if (pluginView.update) pluginView.update(this, prevState);
            }
        }
        updateDraggedNode(dragging, prev) {
            let sel = dragging.node, found = -1;
            if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
            else {
                let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
                let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
                if (moved == sel.node) found = movedPos;
            }
            this.dragging = new $a8a4766474a1e455$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, (0, parcelRequire("gZGBX")).NodeSelection).create(this.state.doc, found));
        }
        someProp(propName, f) {
            let prop = this._props && this._props[propName], value;
            if (prop != null && (value = f ? f(prop) : prop)) return value;
            for(let i = 0; i < this.directPlugins.length; i++){
                let prop = this.directPlugins[i].props[propName];
                if (prop != null && (value = f ? f(prop) : prop)) return value;
            }
            let plugins = this.state.plugins;
            if (plugins) for(let i = 0; i < plugins.length; i++){
                let prop = plugins[i].props[propName];
                if (prop != null && (value = f ? f(prop) : prop)) return value;
            }
        }
        hasFocus() {
            if ($a8a4766474a1e455$var$ie) {
                let node = this.root.activeElement;
                if (node == this.dom) return true;
                if (!node || !this.dom.contains(node)) return false;
                while(node && this.dom != node && this.dom.contains(node)){
                    if (node.contentEditable == 'false') return false;
                    node = node.parentElement;
                }
                return true;
            }
            return this.root.activeElement == this.dom;
        }
        focus() {
            this.domObserver.stop();
            if (this.editable) $a8a4766474a1e455$var$focusPreventScroll(this.dom);
            $a8a4766474a1e455$var$selectionToDOM(this);
            this.domObserver.start();
        }
        get root() {
            let cached = this._root;
            if (cached == null) {
                for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                    if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                    return this._root = search;
                }
            }
            return cached || document;
        }
        updateRoot() {
            this._root = null;
        }
        posAtCoords(coords) {
            return $a8a4766474a1e455$var$posAtCoords(this, coords);
        }
        coordsAtPos(pos, side = 1) {
            return $a8a4766474a1e455$var$coordsAtPos(this, pos, side);
        }
        domAtPos(pos, side = 0) {
            return this.docView.domFromPos(pos, side);
        }
        nodeDOM(pos) {
            let desc = this.docView.descAt(pos);
            return desc ? desc.nodeDOM : null;
        }
        posAtDOM(node, offset, bias = -1) {
            let pos = this.docView.posFromDOM(node, offset, bias);
            if (pos == null) throw new RangeError("DOM position not inside the editor");
            return pos;
        }
        endOfTextblock(dir, state) {
            return $a8a4766474a1e455$var$endOfTextblock(this, state || this.state, dir);
        }
        pasteHTML(html, event) {
            return $a8a4766474a1e455$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
        }
        pasteText(text, event) {
            return $a8a4766474a1e455$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
        }
        destroy() {
            if (!this.docView) return;
            $a8a4766474a1e455$var$destroyInput(this);
            this.destroyPluginViews();
            if (this.mounted) {
                this.docView.update(this.state.doc, [], $a8a4766474a1e455$var$viewDecorations(this), this);
                this.dom.textContent = "";
            } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
            this.docView.destroy();
            this.docView = null;
            $a8a4766474a1e455$var$clearReusedRange();
        }
        get isDestroyed() {
            return this.docView == null;
        }
        dispatchEvent(event) {
            return $a8a4766474a1e455$var$dispatchEvent(this, event);
        }
        dispatch(tr) {
            let dispatchTransaction = this._props.dispatchTransaction;
            if (dispatchTransaction) dispatchTransaction.call(this, tr);
            else this.updateState(this.state.apply(tr));
        }
        domSelectionRange() {
            let sel = this.domSelection();
            if (!sel) return {
                focusNode: null,
                focusOffset: 0,
                anchorNode: null,
                anchorOffset: 0
            };
            return $a8a4766474a1e455$var$safari && this.root.nodeType === 11 && $a8a4766474a1e455$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $a8a4766474a1e455$var$safariShadowSelectionRange(this, sel) || sel;
        }
        domSelection() {
            return this.root.getSelection();
        }
    }
    function $a8a4766474a1e455$var$computeDocDeco(view) {
        let attrs = Object.create(null);
        attrs.class = "ProseMirror";
        attrs.contenteditable = String(view.editable);
        view.someProp("attributes", (value)=>{
            if (typeof value == "function") value = value(view.state);
            if (value) for(let attr in value){
                if (attr == "class") attrs.class += " " + value[attr];
                else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
                else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
            }
        });
        if (!attrs.translate) attrs.translate = "no";
        return [
            $a8a4766474a1e455$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
        ];
    }
    function $a8a4766474a1e455$var$updateCursorWrapper(view) {
        if (view.markCursor) {
            let dom = document.createElement("img");
            dom.className = "ProseMirror-separator";
            dom.setAttribute("mark-placeholder", "true");
            dom.setAttribute("alt", "");
            view.cursorWrapper = {
                dom: dom,
                deco: $a8a4766474a1e455$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                    raw: true,
                    marks: view.markCursor
                })
            };
        } else view.cursorWrapper = null;
    }
    function $a8a4766474a1e455$var$getEditable(view) {
        return !view.someProp("editable", (value)=>value(view.state) === false);
    }
    function $a8a4766474a1e455$var$selectionContextChanged(sel1, sel2) {
        let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
        return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
    }
    function $a8a4766474a1e455$var$buildNodeViews(view) {
        let result = Object.create(null);
        function add(obj) {
            for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
        }
        view.someProp("nodeViews", add);
        view.someProp("markViews", add);
        return result;
    }
    function $a8a4766474a1e455$var$changedNodeViews(a, b) {
        let nA = 0, nB = 0;
        for(let prop in a){
            if (a[prop] != b[prop]) return true;
            nA++;
        }
        for(let _ in b)nB++;
        return nA != nB;
    }
    function $a8a4766474a1e455$var$checkStateComponent(plugin) {
        if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
    }
});
parcelRegister("4r96J", function(module, exports) {
    $parcel$export(module.exports, "findChangedNodesFromTransaction", ()=>$7155804a07622bac$export$cdc577fd3f583194);
    const $7155804a07622bac$export$cdc577fd3f583194 = (tr)=>{
        const nodes = [];
        const steps = tr.steps || [];
        steps.forEach((step)=>{
            step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                    if (!nodes.find((n)=>n === node)) nodes.push(node);
                    return false;
                });
            });
        });
        return nodes;
    };
});
parcelRegister("g5Huu", function(module, exports) {
    $parcel$export(module.exports, "RenderTracking", ()=>$d1e11c1c8b2cc0e9$export$fe16de086fea1f5f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $gkwXh;
    var $REa58;
    function $d1e11c1c8b2cc0e9$export$fe16de086fea1f5f(props) {
        const debouncedHandleAnalyticsEvent = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(props.handleAnalyticsEvent, 500), [
            props.handleAnalyticsEvent
        ]);
        (0, (0, parcelRequire("REa58")).useComponentRenderTracking)({
            onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
                if (!renderCount) return;
                debouncedHandleAnalyticsEvent({
                    payload: {
                        action: props.action,
                        actionSubject: props.actionSubject,
                        attributes: {
                            count: renderCount,
                            propsDifference: propsDifference
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
            },
            propsDiffingOptions: {
                enabled: true,
                props: props.componentProps,
                propsToIgnore: props.propsToIgnore,
                useShallow: props.useShallow
            },
            zeroBasedCount: true
        });
        return null;
    }
});
parcelRegister("REa58", function(module, exports) {
    $parcel$export(module.exports, "useComponentRenderTracking", ()=>$8eae713cd4396df0$export$ebce6d7d8ca67353);
    var $5uXOq = parcelRequire("5uXOq");
    var $bXrHm = parcelRequire("bXrHm");
    var $cCR0b;
    function $8eae713cd4396df0$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
        const propsRef = (0, $5uXOq.useRef)();
        const renderCountRef = (0, $5uXOq.useRef)(zeroBasedCount ? 0 : 1);
        const { current: componentId } = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($bXrHm)))());
        (0, $5uXOq.useEffect)(()=>{
            const lastProps = propsRef.current;
            const renderCount = renderCountRef.current;
            let propsDifference;
            if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, (0, parcelRequire("cCR0b")).getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, (0, parcelRequire("cCR0b")).getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
            const result = {
                renderCount: renderCount,
                propsDifference: propsDifference,
                componentId: componentId
            };
            onRender(result);
            if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
            renderCountRef.current = renderCountRef.current + 1;
        });
    }
});
parcelRegister("cCR0b", function(module, exports) {
    $parcel$export(module.exports, "getPropsDifference", ()=>$8e3652061a23f798$export$d438af18e3a25d10);
    $parcel$export(module.exports, "getShallowPropsDifference", ()=>$8e3652061a23f798$export$418b0a935c0a0030);
    var $5uXOq = parcelRequire("5uXOq");
    const $8e3652061a23f798$export$74743eda5dda3ccf = Object.keys;
    const $8e3652061a23f798$export$aedd1a2d18cbf42b = (object1, object2)=>{
        const oldKeys = object1 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object1) : [];
        const newKeys = object2 !== null ? $8e3652061a23f798$export$74743eda5dda3ccf(object2) : [];
        const removed = oldKeys.filter((key)=>!newKeys.includes(key));
        const added = newKeys.filter((key)=>!oldKeys.includes(key));
        const common = oldKeys.filter((key)=>newKeys.includes(key));
        return {
            added: added,
            common: common,
            removed: removed
        };
    };
    const $8e3652061a23f798$export$f4c1dafc9df1f03 = (value)=>{
        const valueType = typeof value;
        if (value === null) return 'null';
        else if (value === undefined) return 'undefined';
        else if (valueType === 'string' || valueType === 'number') return value;
        else if (valueType === 'symbol') return value.toString();
        else if (valueType === 'function') return `function:${value.name}`;
        else if (valueType === 'object') return {
            type: 'object',
            keys: Object.keys(value)
        };
    };
    const $8e3652061a23f798$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
        const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
        const changed = [];
        common.forEach((key)=>{
            const value1 = object1[key];
            const value2 = object2[key];
            const value1Type = typeof value1;
            const value2Type = typeof value2;
            if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
                if ((0, ($parcel$interopDefault($5uXOq))).isValidElement(value1) || (0, ($parcel$interopDefault($5uXOq))).isValidElement(value2)) changed.push({
                    key: key,
                    reactElementChanged: true
                });
                else if (value1Type === 'object' && value2Type === 'object') {
                    if (curDepth <= maxDepth) {
                        const difference = $8e3652061a23f798$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                        changed.push({
                            key: key,
                            difference: difference
                        });
                    } else changed.push({
                        key: key,
                        maxDepthReached: true
                    });
                } else changed.push({
                    key: key,
                    oldValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value1),
                    newValue: $8e3652061a23f798$export$f4c1dafc9df1f03(value2)
                });
            }
        });
        return {
            added: added,
            changed: changed,
            removed: removed
        };
    };
    const $8e3652061a23f798$export$418b0a935c0a0030 = (object1, object2)=>{
        const { added: added, common: common, removed: removed } = $8e3652061a23f798$export$aedd1a2d18cbf42b(object1, object2);
        const changed = common.filter((key)=>object1[key] !== object2[key]);
        return {
            added: added,
            changed: changed,
            removed: removed
        };
    };
});
parcelRegister("bz2TZ", function(module, exports) {
    $parcel$export(module.exports, "PluginPerformanceObserver", ()=>$81f2be97213f822a$export$ec2236f416a94e59);
    var $gc33h;
    var $1dYoo;
    var $dReYX;
    class $81f2be97213f822a$export$ec2236f416a94e59 {
        constructor(callback){
            this.callback = callback;
            this.getNodeCounts = ()=>[
                    {
                        nodeCount: {},
                        extensionNodeCount: {}
                    },
                    0
                ];
            this.getPlugins = ()=>[];
            this.getOptions = ()=>({});
            this.reportCount = 0;
            this.simpleObserver = new (0, (0, parcelRequire("1dYoo")).SimpleMeasurementLogger)();
            this.onObserveration = (entries)=>{
                const reports = entries.getEntriesByName((0, (0, parcelRequire("dReYX")).EVENT_NAME_DISPATCH_TRANSACTION)).map((entry)=>(0, (0, parcelRequire("gc33h")).PluginPerformanceReport).fromEntry(entry).withCount(++this.reportCount).withEntryList(entries).withNodes(...this.getNodeCounts()).withPlugins(this.getPlugins()).withOptions(this.getOptions()).toJSON());
                reports.filter((report)=>report.trigger !== 'none').forEach((report)=>this.callback(report));
            };
            this.observer = window.PerformanceObserver ? new PerformanceObserver(this.onObserveration) : {
                observe () {},
                disconnect () {},
                takeRecords () {
                    return [];
                }
            };
        }
        get isSimpleTracking() {
            const { usePerformanceMarks: usePerformanceMarks = (0, (0, parcelRequire("dReYX")).DEFAULT_USE_PERFORMANCE_MARK) } = this.getOptions();
            return !usePerformanceMarks;
        }
        withNodeCounts(getNodeCounts) {
            this.getNodeCounts = ()=>{
                const start = performance.now();
                const result = getNodeCounts();
                return [
                    result,
                    performance.now() - start
                ];
            };
            return this;
        }
        withPlugins(getPlugins) {
            this.getPlugins = getPlugins;
            return this;
        }
        withOptions(getOptions) {
            this.getOptions = getOptions;
            return this;
        }
        withTransactionTracker(getTransactionTracker) {
            this.getTransactionTracker = getTransactionTracker;
            return this;
        }
        observe() {
            if (this.isSimpleTracking) {
                this.simpleObserver.setPluginNames(this.getPlugins());
                this.simpleObserver.setOnObservation((entries)=>{
                    this.onObserveration(entries, this.observer);
                });
                this.getTransactionTracker && this.getTransactionTracker().addMeasureListener(this.simpleObserver.observed);
            } else try {
                this.observer.observe({
                    buffered: false,
                    type: 'measure'
                });
            } catch (err) {
                this.observer.observe({
                    entryTypes: [
                        'measure'
                    ]
                });
            }
        }
        disconnect() {
            if (this.isSimpleTracking) this.getTransactionTracker && this.getTransactionTracker().removeMeasureListener(this.simpleObserver.observed);
            else this.observer.disconnect();
        }
        takeRecords() {
            return this.observer.takeRecords();
        }
    }
});
parcelRegister("gc33h", function(module, exports) {
    $parcel$export(module.exports, "PluginPerformanceReport", ()=>$afac2d13a6872d8c$export$dd31167cbb51eda6);
    var $6x13H;
    var $dReYX;
    class $afac2d13a6872d8c$export$dd31167cbb51eda6 {
        constructor(entry){
            this.entry = entry;
            this.count = 0;
            this.pluginNames = [];
            this.nodes = {};
            this.extensionNodes = {};
            this.nodesDuration = 0;
            this.plugins = {};
            this.slowPlugins = {};
            this.options = {
                samplingRate: 100,
                slowThreshold: 300,
                outlierThreshold: 30,
                outlierFactor: 3
            };
            this.isChild = (child)=>child.startTime >= this.entry.startTime && child.startTime + child.duration <= this.entry.startTime + this.entry.duration;
        }
        static fromEntry(entry) {
            return new $afac2d13a6872d8c$export$dd31167cbb51eda6(entry);
        }
        getEntryByName(entryList, name) {
            return entryList.getEntriesByName(name).find(this.isChild);
        }
        getMethodSum(methods) {
            return Object.values(methods).reduce((a, b)=>a + b, 0);
        }
        greaterEquals(a, b) {
            return typeof b === 'number' ? a >= b : false;
        }
        hasOutlierMethods(methods, outliers) {
            return this.greaterEquals(methods.stateApply, outliers.stateApplyOutlier) || this.greaterEquals(methods.viewUpdate, outliers.viewUpdateOutlier);
        }
        get trigger() {
            if (this.entry.duration > this.options.slowThreshold) return 'slow';
            else if (this.hasSlowPlugins && this.entry.duration > this.options.outlierThreshold) return 'distribution';
            else if (this.count > 0 && this.count % this.options.samplingRate === 0) return 'sample';
            else return 'none';
        }
        get hasSlowPlugins() {
            return Object.keys(this.slowPlugins).length > 0;
        }
        withEntryList(entryList) {
            this.entryList = entryList;
            this.stateApplied = this.getEntryByName(entryList, (0, (0, parcelRequire("dReYX")).EVENT_NAME_STATE_APPLY));
            this.viewUpdated = this.getEntryByName(entryList, (0, (0, parcelRequire("dReYX")).EVENT_NAME_UPDATE_STATE));
            this.onChangeCalled = this.getEntryByName(entryList, (0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE));
            this.onEditorViewStateUpdatedCalled = this.getEntryByName(entryList, (0, (0, parcelRequire("dReYX")).EVENT_NAME_VIEW_STATE_UPDATED));
            this.withPlugins(this.pluginNames);
            return this;
        }
        withPlugins(pluginNames) {
            const emptyEntry = {
                duration: 0
            };
            this.pluginNames = pluginNames;
            this.plugins = pluginNames.reduce((acc, name)=>{
                const pluginApplied = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::apply`) || emptyEntry : emptyEntry;
                const pluginViewUpdated = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::view::update`) || emptyEntry : emptyEntry;
                const pluginOnEditorViewStateUpdated = this.entryList ? this.getEntryByName(this.entryList, `\u{1F989}${name}::onEditorViewStateUpdated`) || emptyEntry : emptyEntry;
                acc[name] = {
                    stateApply: pluginApplied.duration,
                    viewUpdate: pluginViewUpdated.duration,
                    onEditorViewStateUpdated: pluginOnEditorViewStateUpdated.duration
                };
                return acc;
            }, {});
            if (this.stateApplied && pluginNames.length > 0) {
                const pluginEntries = Object.entries(this.plugins);
                const stateApplyOutlier = (0, (0, parcelRequire("6x13H")).outlier)(pluginEntries.map(([, { stateApply: stateApply }])=>stateApply), this.options.outlierFactor);
                const viewUpdateOutlier = (0, (0, parcelRequire("6x13H")).outlier)(pluginEntries.map(([, { viewUpdate: viewUpdate }])=>viewUpdate), this.options.outlierFactor);
                const budget = this.options.outlierThreshold / pluginEntries.length;
                const pluginIsOutlier = ([, methods])=>this.getMethodSum(methods) > budget && this.hasOutlierMethods(methods, {
                        stateApplyOutlier: stateApplyOutlier,
                        viewUpdateOutlier: viewUpdateOutlier
                    });
                this.slowPlugins = pluginEntries.filter(pluginIsOutlier).reduce((acc, [n, d])=>({
                        ...acc,
                        [n]: d
                    }), {});
            }
            return this;
        }
        withNodes(nodesCount, nodesDuration = 0) {
            this.nodes = nodesCount.nodeCount;
            this.extensionNodes = nodesCount.extensionNodeCount;
            this.nodesDuration = nodesDuration;
            return this;
        }
        withCount(count) {
            this.count = count;
            return this;
        }
        withOptions(options) {
            Object.assign(this.options, options);
            return this;
        }
        toJSON() {
            return {
                trigger: this.trigger,
                duration: this.entry.duration,
                nodes: this.nodes,
                extensionNodes: this.extensionNodes,
                plugins: this.plugins,
                slowPlugins: this.slowPlugins,
                stepDurations: {
                    stateApply: this.stateApplied ? this.stateApplied.duration : 0,
                    viewUpdate: this.viewUpdated ? this.viewUpdated.duration : 0,
                    onChange: this.onChangeCalled ? this.onChangeCalled.duration : 0,
                    onEditorViewStateUpdated: this.onEditorViewStateUpdatedCalled ? this.onEditorViewStateUpdatedCalled.duration : 0,
                    countNodes: this.nodesDuration
                }
            };
        }
    }
});
parcelRegister("6x13H", function(module, exports) {
    $parcel$export(module.exports, "outlier", ()=>$211e9d6d9dffb1f1$export$4ff0c87b319d18d5);
    var $5Am3b;
    const $211e9d6d9dffb1f1$export$4ff0c87b319d18d5 = (input, factor)=>{
        const q1 = (0, (0, parcelRequire("5Am3b")).percentile)(input, 0.25);
        const q3 = (0, (0, parcelRequire("5Am3b")).percentile)(input, 0.75);
        if (typeof q1 === 'undefined' || typeof q3 === 'undefined') return;
        const iqr = q3 - q1;
        return q3 + iqr * factor;
    };
});
parcelRegister("5Am3b", function(module, exports) {
    $parcel$export(module.exports, "percentile", ()=>$291f53c81773e5a5$export$c4df44c805494ac9);
    const $291f53c81773e5a5$export$c4df44c805494ac9 = (input, fraction)=>{
        const sorted = input.sort((a, b)=>a - b);
        const position = sorted.length * fraction;
        const base = Math.floor(position);
        const rest = position - base;
        if (rest > 0) return sorted[base];
        const item = sorted[base - 1];
        const next = sorted[base];
        if (typeof item !== 'undefined' && typeof next !== 'undefined') return (item + next) / 2;
    };
});
parcelRegister("dReYX", function(module, exports) {
    $parcel$export(module.exports, "EVENT_NAME_STATE_APPLY", ()=>$78f2616dc044c230$export$5e38f3b295505ec8);
    $parcel$export(module.exports, "EVENT_NAME_UPDATE_STATE", ()=>$78f2616dc044c230$export$646ca0d076c98ad5);
    $parcel$export(module.exports, "EVENT_NAME_VIEW_STATE_UPDATED", ()=>$78f2616dc044c230$export$2f488cec9729a7d6);
    $parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", ()=>$78f2616dc044c230$export$bb82e7cfb8987f35);
    $parcel$export(module.exports, "EVENT_NAME_DISPATCH_TRANSACTION", ()=>$78f2616dc044c230$export$373baa16b824d295);
    $parcel$export(module.exports, "DEFAULT_USE_PERFORMANCE_MARK", ()=>$78f2616dc044c230$export$735da5ee20c885d5);
    var $b7gJe;
    var $iN9lO;
    var $5dI4U;
    const $78f2616dc044c230$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
    const $78f2616dc044c230$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
    const $78f2616dc044c230$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
    const $78f2616dc044c230$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
    const $78f2616dc044c230$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
    const $78f2616dc044c230$export$735da5ee20c885d5 = false;
    const $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE = 100;
    const $78f2616dc044c230$var$noop = ()=>{};
    class $78f2616dc044c230$export$7a054319813aafa {
        addMeasureListener(listener) {
            this.measureListeners.push(listener);
        }
        removeMeasureListener(listener) {
            const index = this.measureListeners.indexOf(listener);
            if (index > -1) this.measureListeners.splice(index, 1);
        }
        shouldTrackTransaction(options) {
            const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
            return trackingEnabled && this.dispatchCallCounter === samplingRate;
        }
        constructor(){
            this.dispatchCallCounter = 0;
            this.measureMap = new Map();
            this.measureListeners = [];
            this.bumpDispatchCounter = (options)=>{
                const { enabled: trackingEnabled, samplingRate: samplingRate = $78f2616dc044c230$var$DEFAULT_SAMPLING_RATE } = options;
                if (trackingEnabled) {
                    if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                    this.dispatchCallCounter++;
                }
                return this.dispatchCallCounter;
            };
            this.getMeasureHelpers = (options)=>{
                const { usePerformanceMarks: usePerformanceMarks = $78f2616dc044c230$export$735da5ee20c885d5 } = options;
                if (!this.shouldTrackTransaction(options)) return {
                    startMeasure: $78f2616dc044c230$var$noop,
                    stopMeasure: $78f2616dc044c230$var$noop
                };
                return {
                    startMeasure: usePerformanceMarks ? (0, (0, parcelRequire("iN9lO")).startMeasure) : this.startMeasureSimple,
                    stopMeasure: usePerformanceMarks ? (0, (0, parcelRequire("iN9lO")).stopMeasure) : this.stopMeasureSimple
                };
            };
            this.startMeasureSimple = (measureName)=>{
                if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
                this.measureMap.set(measureName, performance.now());
            };
            this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
                if (!(0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)()) return;
                const startTime = this.measureMap.get(measureName);
                if (startTime) {
                    const duration = (0, (0, parcelRequire("5dI4U")).getTimeSince)(startTime);
                    this.measureMap.delete(measureName);
                    if (onMeasureComplete) onMeasureComplete(duration, startTime);
                    this.measureListeners.forEach((listener)=>listener({
                            name: measureName,
                            duration: duration,
                            startTime: startTime
                        }));
                }
            };
        }
    }
});
parcelRegister("5dI4U", function(module, exports) {
    $parcel$export(module.exports, "getTimeSince", ()=>$b84a5fedb7732bc1$export$a26b90db2c8f1b97);
    const $b84a5fedb7732bc1$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;
});
parcelRegister("1dYoo", function(module, exports) {
    $parcel$export(module.exports, "SimpleMeasurementLogger", ()=>$d99858220d91b69e$export$b45b5a1c294321ea);
    var $dReYX;
    const $d99858220d91b69e$var$EVENT_NAMES = [
        (0, (0, parcelRequire("dReYX")).EVENT_NAME_STATE_APPLY),
        (0, (0, parcelRequire("dReYX")).EVENT_NAME_UPDATE_STATE),
        (0, (0, parcelRequire("dReYX")).EVENT_NAME_VIEW_STATE_UPDATED),
        (0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE),
        (0, (0, parcelRequire("dReYX")).EVENT_NAME_DISPATCH_TRANSACTION)
    ];
    class $d99858220d91b69e$export$b45b5a1c294321ea {
        constructor(){
            this.currentBatch = [];
            this.pluginNameCache = new Set();
            this.setPluginNames = (names)=>{
                this.pluginNameCache = new Set(names);
            };
            this.setOnObservation = (callback)=>{
                this.observationCallback = callback;
            };
            this.createPerformanceEntry = (reading)=>{
                return {
                    entryType: 'mark',
                    name: reading.name,
                    startTime: reading.startTime,
                    duration: reading.duration,
                    toJSON: ()=>JSON.stringify({
                            entryType: 'mark',
                            name: reading.name,
                            startTime: reading.startTime,
                            duration: reading.duration
                        })
                };
            };
            this.convertToEntryList = (batch)=>{
                return {
                    getEntries: ()=>batch,
                    getEntriesByName: (name, type)=>batch.filter((entry)=>entry.name === name),
                    getEntriesByType: (type)=>batch
                };
            };
            this.observed = (reading)=>{
                const { name: name } = reading;
                if (name.startsWith("\uD83E\uDD89")) {
                    const pluginName = name.split(':')[0]?.split("\uD83E\uDD89")[1] || '';
                    const isPluginApply = this.pluginNameCache.has(pluginName);
                    const isTransactionMeasurement = $d99858220d91b69e$var$EVENT_NAMES.includes(name);
                    if (isPluginApply || isTransactionMeasurement) this.currentBatch.push(this.createPerformanceEntry(reading));
                }
                if (name === (0, (0, parcelRequire("dReYX")).EVENT_NAME_DISPATCH_TRANSACTION)) {
                    if (this.observationCallback) {
                        const entries = this.convertToEntryList([
                            ...this.currentBatch
                        ]);
                        this.observationCallback(entries);
                    }
                    this.currentBatch = [];
                }
            };
        }
    }
});
parcelRegister("acfJa", function(module, exports) {
    $parcel$export(module.exports, "freezeUnsafeTransactionProperties", ()=>$1bc4cc3d64f3585e$export$668aa008bdae439f);
    var $gkwXh;
    const $1bc4cc3d64f3585e$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
    const $1bc4cc3d64f3585e$var$isUnsafeMethod = (prop)=>[
            'setSelection'
        ].includes(prop.toString());
    const $1bc4cc3d64f3585e$var$isReadOnlyProperty = (prop)=>[
            'doc',
            'docs',
            'steps',
            'selection'
        ].includes(prop.toString());
    const $1bc4cc3d64f3585e$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
        const isUnsafe = ()=>{
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    pluginKey: pluginKey || 'unknown'
                }
            });
            throw new Error($1bc4cc3d64f3585e$export$9f24e92219b6e945);
        };
        return {
            get: function(target, prop, receiver) {
                if ($1bc4cc3d64f3585e$var$isUnsafeMethod(prop)) isUnsafe();
                return Reflect.get(target, prop, receiver);
            },
            set: function(target, prop, receiver) {
                if ($1bc4cc3d64f3585e$var$isReadOnlyProperty(prop)) isUnsafe();
                return Reflect.set(target, prop, receiver);
            }
        };
    };
});
parcelRegister("96xlM", function(module, exports) {
    $parcel$export(module.exports, "validNode", ()=>$4488669a13e53cb9$export$4c39e41e39b3c449);
    $parcel$export(module.exports, "validateNodes", ()=>$4488669a13e53cb9$export$996213f7c272fc6f);
    const $4488669a13e53cb9$export$4c39e41e39b3c449 = (node)=>{
        try {
            node.check();
        } catch (error) {
            return false;
        }
        return true;
    };
    const $4488669a13e53cb9$export$996213f7c272fc6f = (nodes)=>nodes.every($4488669a13e53cb9$export$4c39e41e39b3c449);
});
const $da8c6c1b49848045$export$646a6982857f2cd5 = 2000;
const $da8c6c1b49848045$export$79d7eac6cbb6352d = 3000;
const $da8c6c1b49848045$export$7d7bd496a5206996 = 100;
parcelRegister("9MoyJ", function(module, exports) {
    $parcel$export(module.exports, "fixExcludes", ()=>$c0c676c2bd95d8c4$export$ef6c09ff452189fa);
    $parcel$export(module.exports, "processPluginsList", ()=>$c0c676c2bd95d8c4$export$7265233e78178a4);
    $parcel$export(module.exports, "createPMPlugins", ()=>$c0c676c2bd95d8c4$export$169329cb2979ef81);
    $parcel$export(module.exports, "createErrorReporter", ()=>$c0c676c2bd95d8c4$export$e98521bb0cea2db1);
    var $fTi1m;
    var $1AaPO;
    var $aZPvj;
    function $c0c676c2bd95d8c4$export$935d38a2e170d1f3(a, b) {
        return a.rank - b.rank;
    }
    function $c0c676c2bd95d8c4$export$ef6c09ff452189fa(marks) {
        const markKeys = Object.keys(marks);
        const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
        markKeys.forEach((markKey)=>{
            const mark = marks[markKey];
            if (mark.excludes) mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
        });
        return marks;
    }
    function $c0c676c2bd95d8c4$export$7265233e78178a4(plugins) {
        const pluginsOptions = plugins.reduce((acc, plugin)=>{
            if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
                if (!acc[pluginName]) acc[pluginName] = [];
                acc[pluginName].push(plugin.pluginsOptions[pluginName]);
            });
            return acc;
        }, {});
        return plugins.reduce((acc, plugin)=>{
            if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
            if (plugin.nodes) acc.nodes.push(...plugin.nodes());
            if (plugin.marks) acc.marks.push(...plugin.marks());
            if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
            if (plugin.usePluginHook) acc.pluginHooks.push(plugin.usePluginHook);
            if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
            if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
            if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
                pluginName: plugin.name,
                callback: plugin.onEditorViewStateUpdated
            });
            return acc;
        }, {
            nodes: [],
            marks: [],
            pmPlugins: [],
            contentComponents: [],
            pluginHooks: [],
            primaryToolbarComponents: [],
            secondaryToolbarComponents: [],
            onEditorViewStateUpdatedCallbacks: []
        });
    }
    function $c0c676c2bd95d8c4$export$169329cb2979ef81(config) {
        const { editorConfig: editorConfig } = config;
        const pmPlugins = editorConfig.pmPlugins.sort((0, (0, parcelRequire("aZPvj")).sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
                schema: config.schema,
                dispatch: config.dispatch,
                eventDispatcher: config.eventDispatcher,
                providerFactory: config.providerFactory,
                errorReporter: config.errorReporter,
                portalProviderAPI: config.portalProviderAPI,
                nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
                featureFlags: config.featureFlags || {},
                getIntl: config.getIntl
            })).filter((plugin)=>typeof plugin !== 'undefined');
        if (config.onEditorStateUpdated !== undefined) return [
            (0, (0, parcelRequire("1AaPO")).createEditorStateNotificationPlugin)(config.onEditorStateUpdated),
            ...pmPlugins
        ];
        return pmPlugins;
    }
    function $c0c676c2bd95d8c4$export$e98521bb0cea2db1(errorReporterHandler) {
        const errorReporter = new (0, (0, parcelRequire("fTi1m")).ErrorReporter)();
        if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
        return errorReporter;
    }
});
parcelRegister("fTi1m", function(module, exports) {
    $parcel$export(module.exports, "ErrorReporter", ()=>$af8126628ab56549$export$88da0ac32d9c271e);
    class $af8126628ab56549$export$88da0ac32d9c271e {
        captureMessage(msg, tags) {
            if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
        }
        captureException(err, tags) {
            if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
        }
        set handler(handler) {
            this.handlerStorage = handler;
        }
        constructor(){
            this.handlerStorage = null;
        }
    }
});
parcelRegister("1AaPO", function(module, exports) {
    $parcel$export(module.exports, "createEditorStateNotificationPlugin", ()=>$8fbcfb1366e3adf2$export$e0355cecc74597d);
    var $5KWxh;
    const $8fbcfb1366e3adf2$export$e0355cecc74597d = (onEditorStateUpdated)=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            view: ()=>{
                return {
                    update: (view, oldEditorState)=>{
                        onEditorStateUpdated({
                            oldEditorState: oldEditorState,
                            newEditorState: view.state
                        });
                    }
                };
            }
        });
});
parcelRegister("5KWxh", function(module, exports) {
    $parcel$export(module.exports, "SafePlugin", ()=>$11ce3f4f5d2ca62c$export$1d44e2741b8f180d);
    var $gZGBX;
    var $VSDnB;
    var $2RN5d;
    const $11ce3f4f5d2ca62c$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom })=>{
        const metadata = (0, (0, parcelRequire("2RN5d")).createProseMirrorMetadata)(nodeOrMark);
        Object.entries(metadata).forEach(([name, value])=>{
            dom.setAttribute(name, value);
        });
    };
    const $11ce3f4f5d2ca62c$var$wrapGetPosExceptions = (spec)=>{
        if (!spec?.props?.nodeViews) return spec;
        const unsafeNodeViews = spec.props.nodeViews;
        const safeNodeViews = new Proxy(unsafeNodeViews, {
            get (target, prop, receiver) {
                const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                    apply (target, thisArg, argumentsList) {
                        const [node, view, unsafeGetPos, ...more] = argumentsList;
                        const safeGetPos = (()=>{
                            try {
                                return unsafeGetPos();
                            } catch (e) {
                                return;
                            }
                            return;
                        }).bind(thisArg);
                        const result = Reflect.apply(target, thisArg, [
                            node,
                            view,
                            safeGetPos,
                            ...more
                        ]);
                        if (result?.dom instanceof HTMLElement && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_breakout_use_css')) $11ce3f4f5d2ca62c$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom
                        });
                        return result;
                    }
                });
                return safeNodeView;
            }
        });
        spec.props.nodeViews = safeNodeViews;
        return spec;
    };
    class $11ce3f4f5d2ca62c$export$1d44e2741b8f180d extends (0, (0, parcelRequire("gZGBX")).Plugin) {
        constructor(spec){
            super($11ce3f4f5d2ca62c$var$wrapGetPosExceptions(spec));
        }
    }
});
parcelRegister("2RN5d", function(module, exports) {
    $parcel$export(module.exports, "createProseMirrorMetadata", ()=>$d7292b4ed800dccb$export$3d8be158d19aadd1);
    var $kCV8T;
    const $d7292b4ed800dccb$var$isPMNode = (nodeOrMark)=>{
        return nodeOrMark instanceof (0, (0, parcelRequire("kCV8T")).Node) || Array.isArray(nodeOrMark.marks);
    };
    const $d7292b4ed800dccb$export$3d8be158d19aadd1 = (nodeOrMark)=>{
        const name = nodeOrMark.type.name;
        const isNode = $d7292b4ed800dccb$var$isPMNode(nodeOrMark);
        const commonAttributes = {
            'data-prosemirror-content-type': isNode ? 'node' : 'mark'
        };
        if (!isNode) return {
            ...commonAttributes,
            ['data-prosemirror-mark-name']: name
        };
        commonAttributes['data-prosemirror-node-name'] = name;
        if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
        if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
        return commonAttributes;
    };
});
parcelRegister("aZPvj", function(module, exports) {
    $parcel$export(module.exports, "sortByOrder", ()=>$c37ea3a6202d7c12$export$49afdc3354d5c84e);
    $parcel$export(module.exports, "sortByOrderWithTypeName", ()=>$c37ea3a6202d7c12$export$b4ae7ad1c009d0a1);
    const $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef = {
        plugins: [
            'featureFlagsContextPlugin',
            'compositionPlugin',
            'inlineCursorTargetPlugin',
            'typeAhead',
            'typeAheadInsertItem',
            'focusHandlerPlugin',
            'frozenEditor',
            'submitEditor',
            'saveOnEnter',
            'customAutoformatting',
            'newlinePreserveMarksPlugin',
            'imageUpload',
            'imageUploadInputRule',
            'clipboard',
            'paste',
            'pasteKeymap',
            'mention',
            'mentionInputRule',
            'mentionKeymap',
            'emoji',
            'placeholderText',
            'emojiInputRule',
            'emojiKeymap',
            'emojiAsciiInputRule',
            'blockType',
            'quickInsert',
            'tasksAndDecisions',
            'blockTypeInputRule',
            'tasksAndDecisionsInputRule',
            'list',
            'typeAheadKeymap',
            'typeAheadInputRule',
            'date',
            'dateKeymap',
            'indentationKeymap',
            'textColor',
            'highlight',
            'highlightKeymap',
            'alignmentPlugin',
            'listInputRule',
            'listKeymap',
            'codeBlock',
            'codeBlockIDEKeyBindings',
            'codeBlockKeyMap',
            'textFormatting',
            'textFormattingCursor',
            'textFormattingInputRule',
            'textFormattingSmartRule',
            'textFormattingClear',
            'textFormattingKeymap',
            'tasksAndDecisionsKeyMap',
            'expandKeymap',
            'tableSelectionKeymap',
            'tableKeymap',
            'captionKeymap',
            'mediaKeymap',
            'selectionKeymap',
            'gapCursorKeymap',
            'gapCursor',
            'syncUrlText',
            'fakeCursorToolbarPlugin',
            'hyperLink',
            'table',
            'tableDecorations',
            'hyperlinkInputRule',
            'tablePMColResizing',
            'hyperlinkKeymap',
            'tableColResizing',
            'undoRedoKeyMap',
            'blockTypeKeyMap',
            'tableEditing',
            'filterStepsPlugin',
            'pmCollab',
            'collab',
            'ruleInputRule',
            'ruleKeymap',
            'panel',
            'media',
            'mediaSingleKeymap',
            'mediaEditor',
            'unsupportedContent',
            'jiraIssue',
            'helpDialog',
            'helpDialogKeymap',
            'macro',
            'expand',
            'extension',
            'layout',
            'contextPanel',
            'selectionToolbar',
            'floatingToolbar',
            'clearMarksOnChange',
            'reactNodeView',
            'history',
            'undoRedoPlugin',
            'codeBlockIndent',
            'placeholder',
            'width',
            'maxContentSize',
            'multilineContent',
            'grid',
            'mobileDimensions',
            'scrollGutterPlugin',
            'analytics',
            'findReplace',
            'selection',
            'avatarGroup',
            'viewUpdateSubscription',
            'beforePrimaryToolbar',
            'inlineCode'
        ],
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'rule',
            'panel',
            'mention',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'unsupportedBlock',
            'unsupportedInline',
            'confluenceJiraIssue',
            'hardBreak',
            'emoji',
            'placeholder',
            'mediaSingle',
            'mediaGroup',
            'table',
            'expand',
            'nestedExpand',
            'media',
            'tableHeader',
            'decisionList',
            'tableRow',
            'decisionItem',
            'tableCell',
            'taskList',
            'taskItem',
            'extension',
            'bodiedExtension',
            'multiBodiedExtension',
            'inlineExtension',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard'
        ],
        marks: [
            'fragment',
            'link',
            'em',
            'strong',
            'textColor',
            'backgroundColor',
            'strike',
            'subsup',
            'underline',
            'code',
            'typeAheadQuery',
            'alignment',
            'breakout',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute'
        ]
    };
    function $c37ea3a6202d7c12$export$49afdc3354d5c84e(item) {
        return function(a, b) {
            return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.name);
        };
    }
    function $c37ea3a6202d7c12$export$b4ae7ad1c009d0a1(item) {
        return function(a, b) {
            return $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(a.type.name) - $c37ea3a6202d7c12$export$d4a08ec0aa6e0cef[item].indexOf(b.type.name);
        };
    }
});
parcelRegister("gAD8U", function(module, exports) {
    $parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", ()=>$fae66c98e35fd436$export$fdea1e40b8747a5b);
    $parcel$export(module.exports, "default", ()=>$fae66c98e35fd436$export$2e2bcd8739ae039);
    var $5j6KQ;
    var $9lx6U;
    const $fae66c98e35fd436$var$isCodeBlockAllowed = (options)=>{
        const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
        return exclude.indexOf('codeBlock') === -1;
    };
    function $fae66c98e35fd436$export$f94443780f769f8(props) {
        const { appearance: appearance } = props;
        if ((0, (0, parcelRequire("5j6KQ")).isFullPage)(appearance)) return {
            getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
        };
        return undefined;
    }
    function $fae66c98e35fd436$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
        const appearance = props.appearance;
        const cardOptions = props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards;
        return {
            ...props,
            createAnalyticsEvent: createAnalyticsEvent,
            typeAhead: {
                isMobile: false
            },
            featureFlags: (0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(props.featureFlags),
            paste: {
                cardOptions: cardOptions,
                sanitizePrivateContent: props.sanitizePrivateContent
            },
            base: {
                allowInlineCursorTarget: true,
                allowScrollGutter: $fae66c98e35fd436$export$f94443780f769f8(props)
            },
            blockType: {
                lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
                allowBlockType: props.allowBlockType,
                isUndoRedoButtonsEnabled: props.allowUndoRedoButtons
            },
            placeholder: {
                placeholder: props.placeholder,
                placeholderBracketHint: props.placeholderBracketHint
            },
            textFormatting: {
                ...props.textFormatting || {},
                responsiveToolbarMenu: props.textFormatting?.responsiveToolbarMenu != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
            },
            submitEditor: props.onSave,
            quickInsert: {
                enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
                elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
                disableDefaultItems: false,
                headless: false,
                emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
                prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
                onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
            },
            selection: {
                useLongPressSelection: false
            },
            hyperlinkOptions: {
                editorAppearance: props.appearance,
                linkPicker: props.linking?.linkPicker,
                onClickCallback: cardOptions?.onClickCallback,
                platform: 'web'
            },
            codeBlock: {
                ...props.codeBlock,
                useLongPressSelection: false,
                allowCompositionInputOverride: false
            }
        };
    }
    function $fae66c98e35fd436$export$2e2bcd8739ae039(preset, props, pluginInjectionAPI) {
        const excludes = new Set();
        if (!$fae66c98e35fd436$var$isCodeBlockAllowed({
            allowBlockType: props.allowBlockType
        })) excludes.add('codeBlock');
        return preset.build({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludes
        });
    }
});
parcelRegister("ijurB", function(module, exports) {
    $parcel$export(module.exports, "createSchema", ()=>$e23c0e6a9c2302d0$export$5f4ce795563f4211);
    var $7P7H6;
    var $2RN5d;
    var $kCV8T;
    var $VSDnB;
    var $9MoyJ;
    var $aZPvj;
    const $e23c0e6a9c2302d0$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
        if (!Array.isArray(domSpec)) return domSpec;
        const maybeDefinedAttributes = domSpec[1];
        const metadata = (0, (0, parcelRequire("2RN5d")).createProseMirrorMetadata)(nodeOrMark);
        const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
        if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
        else domSpec.splice(1, 0, metadata);
        return domSpec;
    };
    const $e23c0e6a9c2302d0$export$48404bb361c0cbc1 = (toDOM)=>{
        return new Proxy(toDOM, {
            apply (target, thisArg, argumentsList) {
                const domSpec = Reflect.apply(target, thisArg, argumentsList);
                if (!Array.isArray(domSpec)) return domSpec;
                const nodeOrMark = argumentsList[0];
                return $e23c0e6a9c2302d0$export$29c1e593063b23a7({
                    nodeOrMark: nodeOrMark,
                    domSpec: domSpec
                });
            }
        });
    };
    const $e23c0e6a9c2302d0$export$83e999ea28e263f4 = (spec)=>{
        return new Proxy(spec, {
            get (target, prop, receiver) {
                const result = Reflect.get(target, prop, receiver);
                if (prop === 'toDOM' && typeof result === 'function') return $e23c0e6a9c2302d0$export$48404bb361c0cbc1(result);
                return result;
            }
        });
    };
    function $e23c0e6a9c2302d0$export$5f4ce795563f4211(editorConfig) {
        const marks = (0, (0, parcelRequire("9MoyJ")).fixExcludes)(editorConfig.marks.sort((0, (0, parcelRequire("aZPvj")).sortByOrder)('marks')).reduce((acc, mark)=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_breakout_use_css')) acc[mark.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(mark.mark);
            else acc[mark.name] = mark.mark;
            return acc;
        }, {}));
        const nodes = (0, (0, parcelRequire("7P7H6")).sanitizeNodes)(editorConfig.nodes.sort((0, (0, parcelRequire("aZPvj")).sortByOrder)('nodes')).reduce((acc, node)=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_breakout_use_css')) acc[node.name] = $e23c0e6a9c2302d0$export$83e999ea28e263f4(node.node);
            else acc[node.name] = node.node;
            return acc;
        }, {}), marks);
        return new (0, (0, parcelRequire("kCV8T")).Schema)({
            nodes: nodes,
            marks: marks
        });
    }
});
parcelRegister("h0q50", function(module, exports) {
    $parcel$export(module.exports, "editorMessages", ()=>$83b423bd4c954bb9$export$3b488057bfc1868f);
    var $7VHMR;
    const $83b423bd4c954bb9$export$3b488057bfc1868f = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editorAssistiveLabel: {
            id: 'fabric.editor.editorAssistiveLabel',
            defaultMessage: 'Main content area, start typing to enter text.',
            description: 'Text that is read out by screen reader when the main editor is in focus'
        }
    });
});
parcelRegister("9wPsG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f6b73582c9c3325$export$2e2bcd8739ae039);
    var $12Kqg;
    var $0f6b73582c9c3325$export$2e2bcd8739ae039 = (0, (0, parcelRequire("12Kqg")).default);
});
parcelRegister("12Kqg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5be525c6bf2dfa69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $5be525c6bf2dfa69$var$ReactEditorViewContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    var $5be525c6bf2dfa69$export$2e2bcd8739ae039 = $5be525c6bf2dfa69$var$ReactEditorViewContext;
});
parcelRegister("7mkEO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f56d4067fdf7b51$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $bXrHm = parcelRequire("bXrHm");
    var $gkwXh;
    var $ctLRZ;
    var $hETfp;
    var $2cB15;
    var $7Em36;
    var $4zXba;
    var $ap7h6;
    var $kFiBa;
    var $3IZIX;
    var $agxMF;
    var $4NUlu;
    var $gZGBX;
    var $etG8M;
    var $VSDnB;
    var $geOTC;
    var $lY6DM;
    var $az5cZ;
    var $5j6KQ;
    var $g5Huu;
    var $5cNeT;
    var $9MoyJ;
    var $gAD8U;
    var $ijurB;
    var $9lx6U;
    var $h0q50;
    var $7HMhY;
    var $cj93n;
    var $jNTUV;
    var $kpgvz;
    var $ibPfm;
    var $9wPsG;
    const $3f56d4067fdf7b51$var$EDIT_AREA_ID = 'ak-editor-textarea';
    function $3f56d4067fdf7b51$var$ReactEditorView(props) {
        const { preset: preset, editorProps: { appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue } } = props;
        const [editorAPI, setEditorAPI] = (0, $5uXOq.useState)(undefined);
        const editorRef = (0, $5uXOq.useRef)(null);
        const viewRef = (0, $5uXOq.useRef)();
        const focusTimeoutId = (0, $5uXOq.useRef)();
        const canDispatchTransactions = (0, $5uXOq.useRef)(true);
        const editorId = (0, $5uXOq.useRef)((0, ($parcel$interopDefault($bXrHm)))());
        const eventDispatcher = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("lY6DM")).EventDispatcher)(), []);
        const config = (0, $5uXOq.useRef)({
            nodes: [],
            marks: [],
            pmPlugins: [],
            contentComponents: [],
            pluginHooks: [],
            primaryToolbarComponents: [],
            secondaryToolbarComponents: [],
            onEditorViewStateUpdatedCallbacks: []
        });
        const contentTransformer = (0, $5uXOq.useRef)(undefined);
        const featureFlags = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9lx6U")).createFeatureFlagsFromProps)(editorPropFeatureFlags), [
            editorPropFeatureFlags
        ]);
        const getEditorState = (0, $5uXOq.useCallback)(()=>viewRef.current?.state, []);
        const getEditorView = (0, $5uXOq.useCallback)(()=>viewRef.current, []);
        const dispatch = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("lY6DM")).createDispatch)(eventDispatcher), [
            eventDispatcher
        ]);
        const errorReporter = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9MoyJ")).createErrorReporter)(errorReporterHandler), [
            errorReporterHandler
        ]);
        const handleAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
        }, [
            props.createAnalyticsEvent
        ]);
        const dispatchAnalyticsEvent = (0, $5uXOq.useCallback)((payload)=>{
            const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(eventDispatcher);
            dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                payload: payload
            });
        }, [
            eventDispatcher
        ]);
        const pluginInjectionAPI = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("3IZIX")).EditorPluginInjectionAPI)({
            getEditorState: getEditorState,
            getEditorView: getEditorView,
            fireAnalyticsEvent: handleAnalyticsEvent
        }));
        (0, $5uXOq.useLayoutEffect)(()=>{
            setEditorAPI(pluginInjectionAPI.current.api());
        }, []);
        const createEditorState = (0, $5uXOq.useCallback)((options)=>{
            let schema;
            if (viewRef.current) {
                if (options.resetting) schema = viewRef.current.state.schema;
                else {
                    console.warn('The editor does not support changing the schema dynamically.');
                    return viewRef.current.state;
                }
            } else {
                config.current = (0, (0, parcelRequire("9MoyJ")).processPluginsList)((0, (0, parcelRequire("gAD8U")).default)(options.props.preset, props.editorProps, pluginInjectionAPI.current));
                schema = (0, (0, parcelRequire("ijurB")).createSchema)(config.current);
            }
            const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
            const plugins = (0, (0, parcelRequire("9MoyJ")).createPMPlugins)({
                schema: schema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: options.props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
            });
            contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
            const api = pluginInjectionAPI.current.api();
            let doc;
            if (options.doc) {
                if (api?.collabEdit !== undefined && (0, (0, parcelRequire("VSDnB")).fg)('editor_load_conf_collab_docs_without_checks')) doc = (0, (0, parcelRequire("agxMF")).processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
                else doc = (0, (0, parcelRequire("agxMF")).processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
            }
            const isViewMode = api?.editorViewMode?.sharedState.currentState().mode === 'view';
            let selection;
            if (doc) {
                if (isViewMode) {
                    const emptySelection = new (0, (0, parcelRequire("gZGBX")).TextSelection)(doc.resolve(0));
                    return (0, (0, parcelRequire("gZGBX")).EditorState).create({
                        schema: schema,
                        plugins: plugins,
                        doc: doc,
                        selection: emptySelection
                    });
                } else selection = options.selectionAtStart ? (0, (0, parcelRequire("gZGBX")).Selection).atStart(doc) : (0, (0, parcelRequire("gZGBX")).Selection).atEnd(doc);
            }
            const patchedSelection = selection ? (0, (0, parcelRequire("gZGBX")).Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
            return (0, (0, parcelRequire("gZGBX")).EditorState).create({
                schema: schema,
                plugins: plugins,
                doc: doc,
                selection: patchedSelection
            });
        }, [
            errorReporter,
            featureFlags,
            props.intl,
            props.portalProviderAPI,
            props.nodeViewPortalProviderAPI,
            props.editorProps,
            dispatchAnalyticsEvent,
            eventDispatcher,
            dispatch
        ]);
        const initialEditorState = (0, $5uXOq.useMemo)(()=>createEditorState({
                props: props,
                doc: defaultValue,
                selectionAtStart: (0, (0, parcelRequire("5j6KQ")).isFullPage)(nextAppearance)
            }), []);
        const getCurrentEditorState = (0, $5uXOq.useCallback)(()=>{
            return viewRef.current?.state ?? initialEditorState;
        }, [
            initialEditorState
        ]);
        const blur = (0, $5uXOq.useCallback)(()=>{
            if (!viewRef.current) return;
            if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
            const sel = viewRef.current.root.getSelection();
            if (sel) sel.removeAllRanges();
        }, []);
        const resetEditorState = (0, $5uXOq.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
            if (!viewRef.current) return;
            blur();
            const newEditorState = createEditorState({
                props: props,
                doc: doc,
                resetting: true,
                selectionAtStart: !shouldScrollToBottom
            });
            viewRef.current.updateState(newEditorState);
            props.editorProps.onChange?.(viewRef.current, {
                source: 'local'
            });
        }, [
            blur,
            createEditorState,
            props
        ]);
        (0, (0, parcelRequire("2cB15")).default)(()=>{
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).STARTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                attributes: {
                    platform: (0, (0, parcelRequire("hETfp")).PLATFORMS).WEB,
                    featureFlags: featureFlags ? (0, (0, parcelRequire("4zXba")).getEnabledFeatureFlagKeys)(featureFlags) : []
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            });
            canDispatchTransactions.current = true;
            eventDispatcher.on((0, (0, parcelRequire("4NUlu")).analyticsEventKey), handleAnalyticsEvent);
            eventDispatcher.on('resetEditorState', resetEditorState);
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            return ()=>{
                const focusTimeoutIdCurrent = focusTimeoutId.current;
                if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
                if (viewRef.current) {
                    const editorState = viewRef.current.state;
                    editorState.plugins.forEach((plugin)=>{
                        const state = plugin.getState(editorState);
                        if (state && state.destroy) state.destroy();
                    });
                }
                eventDispatcher.destroy();
            };
        }, [
            eventDispatcher
        ]);
        const reconfigureState = (0, $5uXOq.useCallback)((props)=>{
            if (!viewRef.current) return;
            blur();
            const editorPlugins = (0, (0, parcelRequire("gAD8U")).default)(props.preset, props.editorProps, pluginInjectionAPI.current);
            config.current = (0, (0, parcelRequire("9MoyJ")).processPluginsList)(editorPlugins);
            const state = viewRef.current.state;
            const plugins = (0, (0, parcelRequire("9MoyJ")).createPMPlugins)({
                schema: state.schema,
                dispatch: dispatch,
                errorReporter: errorReporter,
                editorConfig: config.current,
                eventDispatcher: eventDispatcher,
                providerFactory: props.providerFactory,
                portalProviderAPI: props.portalProviderAPI,
                nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                featureFlags: featureFlags,
                getIntl: ()=>props.intl,
                onEditorStateUpdated: (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states') ? pluginInjectionAPI.current.onEditorViewUpdated : undefined
            });
            const newState = state.reconfigure({
                plugins: plugins
            });
            viewRef.current.updateState(newState);
            return viewRef.current.update({
                ...viewRef.current.props,
                state: newState
            });
        }, [
            blur,
            dispatchAnalyticsEvent,
            eventDispatcher,
            dispatch,
            errorReporter,
            featureFlags
        ]);
        const onEditorViewUpdated = (0, $5uXOq.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_catch_missing_injection_states')) pluginInjectionAPI.current.onEditorViewUpdated({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState
            });
            config.current?.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
                entry.callback({
                    originalTransaction: originalTransaction,
                    transactions: transactions,
                    oldEditorState: oldEditorState,
                    newEditorState: newEditorState
                });
            });
        }, []);
        const dispatchTransaction = (0, (0, parcelRequire("jNTUV")).useDispatchTransaction)({
            onChange: props.editorProps.onChange,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            onEditorViewUpdated: onEditorViewUpdated
        });
        const UNSAFE_cards = props.editorProps.UNSAFE_cards;
        const smartLinks = props.editorProps.smartLinks;
        (0, (0, parcelRequire("geOTC")).useProviders)({
            editorApi: editorAPI,
            contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
            mediaProvider: props.editorProps.media?.provider,
            cardProvider: props.editorProps.linking?.smartLinks?.provider || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
            emojiProvider: props.editorProps.emojiProvider,
            autoformattingProvider: props.editorProps.autoformattingProvider,
            taskDecisionProvider: props.editorProps.taskDecisionProvider
        });
        const getDirectEditorProps = (0, $5uXOq.useCallback)((state)=>{
            return {
                state: state ?? getCurrentEditorState(),
                dispatchTransaction: (tr)=>{
                    if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
                },
                editable: (_state)=>!disabled,
                attributes: {
                    'data-gramm': 'false'
                }
            };
        }, [
            dispatchTransaction,
            disabled,
            getCurrentEditorState
        ]);
        const createEditorView = (0, $5uXOq.useCallback)((node)=>{
            (0, (0, parcelRequire("ap7h6")).measureRender)((0, (0, parcelRequire("5cNeT")).default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
                const proseMirrorRenderedSeverity = (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(duration, (0, $da8c6c1b49848045$export$646a6982857f2cd5), (0, $da8c6c1b49848045$export$79d7eac6cbb6352d));
                if (viewRef.current) {
                    const nodes = (0, (0, parcelRequire("az5cZ")).getNodesCount)(viewRef.current.state.doc);
                    const ttfb = (0, (0, parcelRequire("kFiBa")).getResponseEndTime)();
                    const contextIdentifier = pluginInjectionAPI.current.api().base?.sharedState.currentState();
                    dispatchAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).PROSEMIRROR_RENDERED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                        attributes: {
                            duration: duration,
                            startTime: startTime,
                            nodes: nodes,
                            ttfb: ttfb,
                            severity: proseMirrorRenderedSeverity,
                            objectId: contextIdentifier?.objectId,
                            distortedDuration: distortedDuration
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                }
            });
            const view = new (0, (0, parcelRequire("etG8M")).EditorView)({
                mount: node
            }, getDirectEditorProps());
            viewRef.current = view;
            pluginInjectionAPI.current.onEditorViewUpdated({
                newEditorState: viewRef.current.state,
                oldEditorState: undefined
            });
            return view;
        }, [
            getDirectEditorProps,
            dispatchAnalyticsEvent
        ]);
        const [_, setEditorView] = (0, $5uXOq.useState)(undefined);
        const { onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, editorProps: { shouldFocus: shouldFocus } } = props;
        const handleEditorViewRef = (0, $5uXOq.useCallback)((node)=>{
            if (!viewRef.current && node) {
                const view = createEditorView(node);
                onEditorCreated({
                    view: view,
                    config: config.current,
                    eventDispatcher: eventDispatcher,
                    transformer: contentTransformer.current
                });
                if (shouldFocus && view.props.editable && view.props.editable(view.state)) focusTimeoutId.current = (0, (0, parcelRequire("cj93n")).handleEditorFocus)(view);
                setEditorView(view);
            } else if (viewRef.current && !node) {
                onEditorDestroyed({
                    view: viewRef.current,
                    config: config.current,
                    eventDispatcher: eventDispatcher,
                    transformer: contentTransformer.current
                });
                const wasAnalyticsDisconnected = !eventDispatcher.has((0, (0, parcelRequire("4NUlu")).analyticsEventKey), handleAnalyticsEvent);
                if (wasAnalyticsDisconnected) {
                    eventDispatcher.on((0, (0, parcelRequire("4NUlu")).analyticsEventKey), handleAnalyticsEvent);
                    viewRef.current.destroy();
                    eventDispatcher.off((0, (0, parcelRequire("4NUlu")).analyticsEventKey), handleAnalyticsEvent);
                } else viewRef.current.destroy();
                viewRef.current = undefined;
            }
        }, [
            createEditorView,
            handleAnalyticsEvent,
            onEditorDestroyed,
            onEditorCreated,
            shouldFocus,
            eventDispatcher
        ]);
        const createEditor = (0, $5uXOq.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("7HMhY")).getUAPrefix)(),
                key: "ProseMirror",
                ref: handleEditorViewRef,
                "aria-label": assistiveLabel || props.intl.formatMessage((0, (0, parcelRequire("h0q50")).editorMessages).editorAssistiveLabel),
                "aria-multiline": true,
                role: "textbox",
                id: $3f56d4067fdf7b51$var$EDIT_AREA_ID,
                "aria-describedby": assistiveDescribedBy,
                "data-editor-id": editorId.current
            });
        }, [
            handleEditorViewRef,
            props.intl
        ]);
        const previousPreset = (0, (0, parcelRequire("7Em36")).default)(preset);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (previousPreset && previousPreset !== preset) reconfigureState(props);
        }, [
            reconfigureState,
            previousPreset,
            preset,
            props
        ]);
        const previousDisabledState = (0, (0, parcelRequire("7Em36")).default)(disabled);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (viewRef.current && previousDisabledState !== disabled) {
                viewRef.current.setProps({
                    editable: (_state)=>!disabled
                });
                if (!disabled && shouldFocus) focusTimeoutId.current = (0, (0, parcelRequire("cj93n")).handleEditorFocus)(viewRef.current);
            }
        }, [
            disabled,
            shouldFocus,
            previousDisabledState
        ]);
        (0, (0, parcelRequire("kpgvz")).useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
        (0, (0, parcelRequire("ibPfm")).usePluginPerformanceObserver)(getCurrentEditorState, pluginInjectionAPI, dispatchAnalyticsEvent);
        const editor = (0, $5uXOq.useMemo)(()=>createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy), [
            props.editorProps.assistiveLabel,
            props.editorProps.assistiveDescribedBy
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wPsG")).default).Provider, {
            value: {
                editorRef: editorRef,
                editorView: viewRef.current,
                popupsMountPoint: props.editorProps.popupsMountPoint
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g5Huu")).RenderTracking), {
            componentProps: props,
            action: (0, (0, parcelRequire("gkwXh")).ACTION).RE_RENDERED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).REACT_EDITOR_VIEW,
            handleAnalyticsEvent: handleAnalyticsEvent,
            useShallow: true
        }), props.render ? props.render?.({
            editor: editor,
            view: viewRef.current,
            config: config.current,
            eventDispatcher: eventDispatcher,
            transformer: contentTransformer.current,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorRef: editorRef,
            editorAPI: editorAPI
        }) ?? editor : editor);
    }
    var $3f56d4067fdf7b51$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($3f56d4067fdf7b51$var$ReactEditorView);
});
parcelRegister("2cB15", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$304fa3f1418bd834$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $304fa3f1418bd834$export$2e2bcd8739ae039(callback) {
        const hasRun = (0, $5uXOq.useRef)(false);
        if (!hasRun.current) {
            callback();
            hasRun.current = true;
        }
    }
});
parcelRegister("7Em36", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$474014b73fe6d1f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    function $474014b73fe6d1f7$export$2e2bcd8739ae039(value, initialValue) {
        const ref = (0, $5uXOq.useRef)(initialValue);
        if ((0, (0, parcelRequire("VSDnB")).fg)('use-effect-in-use-previous-props')) {
            (0, $5uXOq.useEffect)(()=>{
                ref.current = value;
            }, [
                value
            ]);
            return ref.current;
        }
        const prevValue = ref.current;
        ref.current = value;
        return prevValue;
    }
});
parcelRegister("geOTC", function(module, exports) {
    $parcel$export(module.exports, "useProviders", ()=>$4ce81023af8e02ce$export$e4c19534640d7866);
    var $5uXOq = parcelRequire("5uXOq");
    const $4ce81023af8e02ce$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
        (0, $5uXOq.useEffect)(()=>{
            async function setProvider() {
                if (!contextIdentifierProvider) return;
                const provider = await contextIdentifierProvider;
                editorApi?.core?.actions.execute(editorApi?.contextIdentifier?.commands.setProvider({
                    contextIdentifierProvider: provider
                }));
            }
            setProvider();
        }, [
            contextIdentifierProvider,
            editorApi
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (mediaProvider) editorApi?.media?.actions.setProvider(mediaProvider);
        }, [
            mediaProvider,
            editorApi
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (cardProvider) editorApi?.card?.actions.setProvider(cardProvider);
        }, [
            cardProvider,
            editorApi
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (emojiProvider) editorApi?.emoji?.actions.setProvider(emojiProvider);
        }, [
            emojiProvider,
            editorApi
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (autoformattingProvider) editorApi?.customAutoformat?.actions.setProvider(autoformattingProvider);
        }, [
            autoformattingProvider,
            editorApi
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (taskDecisionProvider) editorApi?.taskDecision?.actions.setProvider(taskDecisionProvider);
        }, [
            taskDecisionProvider,
            editorApi
        ]);
    };
});
parcelRegister("7HMhY", function(module, exports) {
    $parcel$export(module.exports, "getUAPrefix", ()=>$6f98ce41d7ee5a01$export$11a24c7b1b4aab81);
    var $gE8f9;
    function $6f98ce41d7ee5a01$export$11a24c7b1b4aab81() {
        if ((0, (0, parcelRequire("gE8f9")).browser).chrome) return 'ua-chrome';
        else if ((0, (0, parcelRequire("gE8f9")).browser).ie) return 'ua-ie';
        else if ((0, (0, parcelRequire("gE8f9")).browser).gecko) return 'ua-firefox';
        else if ((0, (0, parcelRequire("gE8f9")).browser).safari) return 'ua-safari';
        return '';
    }
});
parcelRegister("cj93n", function(module, exports) {
    $parcel$export(module.exports, "handleEditorFocus", ()=>$86566110343db703$export$ebebb7f5b9271fd7);
    var $gZGBX;
    function $86566110343db703$export$ebebb7f5b9271fd7(view) {
        if (view.hasFocus()) return;
        return window.setTimeout(()=>{
            if (view.hasFocus()) return;
            if (!window.getSelection) {
                view.focus();
                return;
            }
            const domSelection = window.getSelection();
            if (!domSelection || domSelection.rangeCount === 0) {
                view.focus();
                return;
            }
            const range = domSelection.getRangeAt(0);
            if (range.startContainer.contains(view.dom)) {
                view.focus();
                return;
            }
            const anchor = view.posAtDOM(range.startContainer, range.startOffset);
            const head = view.posAtDOM(range.endContainer, range.endOffset);
            if (anchor < 0 || head < 0) {
                view.focus();
                return;
            }
            const selection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(view.state.doc, anchor, head);
            const tr = view.state.tr.setSelection(selection);
            view.dispatch(tr);
            view.focus();
        }, 0);
    }
});
parcelRegister("jNTUV", function(module, exports) {
    $parcel$export(module.exports, "useDispatchTransaction", ()=>$8e65b5e3b9ae9277$export$b582387940572fe7);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $J5Axj;
    var $ifv4n;
    var $iN9lO;
    var $4r96J;
    var $acfJa;
    var $dReYX;
    var $96xlM;
    const $8e65b5e3b9ae9277$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated })=>{
        const onChangeRef = (0, $5uXOq.useRef)(onChange);
        (0, $5uXOq.useEffect)(()=>{
            onChangeRef.current = onChange;
        }, [
            onChange
        ]);
        const dispatchTransaction = (0, $5uXOq.useCallback)((view, unsafeTransaction)=>{
            if (!view) return;
            const nodes = (0, (0, parcelRequire("4r96J")).findChangedNodesFromTransaction)(unsafeTransaction);
            const changedNodesValid = (0, (0, parcelRequire("96xlM")).validateNodes)(nodes);
            const transaction = new Proxy(unsafeTransaction, (0, (0, parcelRequire("acfJa")).freezeUnsafeTransactionProperties)({
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginKey: 'unknown-reacteditorview'
            }));
            if (changedNodesValid) {
                const oldEditorState = view.state;
                const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
                if (newEditorState === oldEditorState) return;
                view.updateState(newEditorState);
                onEditorViewUpdated({
                    originalTransaction: transaction,
                    transactions: transactions,
                    oldEditorState: oldEditorState,
                    newEditorState: newEditorState
                });
                if (onChangeRef.current && transaction.docChanged) {
                    const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                    (0, (0, parcelRequire("iN9lO")).startMeasure)((0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE));
                    onChangeRef.current(view, {
                        source: source
                    });
                    (0, (0, parcelRequire("iN9lO")).stopMeasure)((0, (0, parcelRequire("dReYX")).EVENT_NAME_ON_CHANGE), (duration, startTime)=>{
                        dispatchAnalyticsEvent({
                            action: (0, (0, parcelRequire("gkwXh")).ACTION).ON_CHANGE_CALLBACK,
                            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                duration: duration,
                                startTime: startTime
                            }
                        });
                    });
                }
            } else {
                const invalidNodes = nodes.filter((node)=>!(0, (0, parcelRequire("96xlM")).validNode)(node)).map((node)=>(0, (0, parcelRequire("ifv4n")).getDocStructure)(node, {
                        compact: true
                    }));
                dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).DISPATCHED_INVALID_TRANSACTION,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        analyticsEventPayloads: (0, (0, parcelRequire("J5Axj")).getAnalyticsEventsFromTransaction)(transaction),
                        invalidNodes: invalidNodes
                    }
                });
            }
        }, [
            dispatchAnalyticsEvent,
            onEditorViewUpdated
        ]);
        return dispatchTransaction;
    };
});
parcelRegister("kpgvz", function(module, exports) {
    $parcel$export(module.exports, "useFireFullWidthEvent", ()=>$b28a7eb8b5fedc52$export$4998b7b36606f9c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $7Em36;
    var $1hwge;
    const $b28a7eb8b5fedc52$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
        const previousAppearance = (0, (0, parcelRequire("7Em36")).default)(appearance);
        (0, $5uXOq.useEffect)(()=>{
            if (appearance !== previousAppearance) {
                if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_FULL_WIDTH_MODE,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        previousMode: (0, (0, parcelRequire("1hwge")).formatFullWidthAppearance)(previousAppearance),
                        newMode: (0, (0, parcelRequire("1hwge")).formatFullWidthAppearance)(appearance)
                    }
                });
            }
        }, [
            appearance,
            previousAppearance,
            dispatchAnalyticsEvent
        ]);
    };
});
parcelRegister("1hwge", function(module, exports) {
    $parcel$export(module.exports, "formatFullWidthAppearance", ()=>$1e164d4b24e45932$export$47d5b79f3ddf0b92);
    var $hETfp;
    const $1e164d4b24e45932$export$47d5b79f3ddf0b92 = (appearance)=>{
        if (appearance === 'full-width') return (0, (0, parcelRequire("hETfp")).FULL_WIDTH_MODE).FULL_WIDTH;
        return (0, (0, parcelRequire("hETfp")).FULL_WIDTH_MODE).FIXED_WIDTH;
    };
});
parcelRegister("ibPfm", function(module, exports) {
    $parcel$export(module.exports, "usePluginPerformanceObserver", ()=>$b32d6999f8b27a22$export$50e3a53b626cf291);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $k4HYa;
    var $bz2TZ;
    const $b32d6999f8b27a22$export$50e3a53b626cf291 = (getEditorState, pluginInjectionAPI, dispatchAnalyticsEvent)=>{
        const onPluginObservation = (0, $5uXOq.useCallback)((report)=>{
            dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).TRANSACTION_DISPATCHED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    report: report,
                    participants: pluginInjectionAPI.current?.api().collabEdit?.sharedState.currentState()?.participants?.size() || 1
                }
            });
        }, [
            dispatchAnalyticsEvent,
            pluginInjectionAPI
        ]);
        const getPluginNames = (0, $5uXOq.useCallback)(()=>{
            return getEditorState()?.plugins.map((p)=>p.key);
        }, [
            getEditorState
        ]);
        const pluginPerformanceObserver = (0, $5uXOq.useMemo)(()=>{
            const state = getEditorState();
            return new (0, (0, parcelRequire("bz2TZ")).PluginPerformanceObserver)((report)=>onPluginObservation(report)).withPlugins(()=>getPluginNames()).withNodeCounts(()=>state ? (0, (0, parcelRequire("k4HYa")).countNodes)(state) : {
                    nodeCount: {},
                    extensionNodeCount: {}
                });
        }, [
            onPluginObservation,
            getPluginNames,
            getEditorState
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            return ()=>{
                pluginPerformanceObserver.disconnect();
            };
        }, [
            pluginPerformanceObserver
        ]);
    };
});
parcelRegister("kflkc", function(module, exports) {
    $parcel$export(module.exports, "ContextAdapter", ()=>$084226b391b51c18$export$171d95247be63a2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $fy0vt;
    var $kECas;
    function $084226b391b51c18$var$useContextMemoized(reactContext) {
        const value = (0, ($parcel$interopDefault($5uXOq))).useContext(reactContext);
        const context = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                Provider: reactContext.Provider,
                Consumer: reactContext.Consumer,
                value: value
            }), [
            value,
            reactContext
        ]);
        return context;
    }
    const $084226b391b51c18$export$171d95247be63a2d = ({ children: children })=>{
        const card = $084226b391b51c18$var$useContextMemoized((0, (0, parcelRequire("kECas")).SmartCardContext));
        const analytics = $084226b391b51c18$var$useContextMemoized((0, (0, parcelRequire("fy0vt")).default));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($084226b391b51c18$var$LegacyContextAdapter, {
            card: card,
            analytics: analytics
        }, children);
    };
    class $084226b391b51c18$var$LegacyContextAdapter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.childContextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        getChildContext() {
            return {
                contextAdapter: {
                    card: this.props.card,
                    analytics: this.props.analytics
                }
            };
        }
        render() {
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.contextState = {};
        }
    }
});
parcelRegister("fggrl", function(module, exports) {
    $parcel$export(module.exports, "IntlProviderIfMissingWrapper", ()=>$5641d4a75c12a4ef$export$742fe272b8921eea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i5FdW;
    const $5641d4a75c12a4ef$var$useCheckIntlContext = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("8RXs9")).Context)) === null;
    function $5641d4a75c12a4ef$export$742fe272b8921eea({ children: children }) {
        const missingIntlContext = $5641d4a75c12a4ef$var$useCheckIntlContext();
        if (missingIntlContext) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, children);
        return children;
    }
});
parcelRegister("j0Vvw", function(module, exports) {
    $parcel$export(module.exports, "BaseThemeWrapper", ()=>$ec97f93103c51466$export$3de34996b814f0f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0wej;
    var $iHYdz;
    const $ec97f93103c51466$var$defaultFontSize = 14;
    function $ec97f93103c51466$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
        const memoizedTheme = (0, $5uXOq.useMemo)(()=>({
                baseFontSize: baseFontSize || $ec97f93103c51466$var$defaultFontSize,
                layoutMaxWidth: (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth)
            }), [
            baseFontSize
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0wej")).a), {
            theme: memoizedTheme
        }, children);
    }
});
parcelRegister("8pML4", function(module, exports) {
    $parcel$export(module.exports, "getBaseFontSize", ()=>$5e4d3b841efcfea0$export$8e2864079bc476bd);
    var $iHYdz;
    function $5e4d3b841efcfea0$export$8e2864079bc476bd(appearance) {
        if (appearance === undefined) return 0, (0, parcelRequire("iHYdz")).akEditorFullPageDefaultFontSize;
        return ![
            'comment',
            'chromeless'
        ].includes(appearance) ? (0, (0, parcelRequire("iHYdz")).akEditorFullPageDefaultFontSize) : undefined;
    }
});
parcelRegister("dACrN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ad4bc9aab4b58d4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $iN9lO;
    var $5cNeT;
    var $2JODI;
    var $dCdqM;
    function $9ad4bc9aab4b58d4$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
        (0, (0, parcelRequire("dCdqM")).default)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("iN9lO")).stopMeasure)((0, (0, parcelRequire("5cNeT")).default).EDITOR_MOUNTED, (0, (0, parcelRequire("2JODI")).default)((0, (0, parcelRequire("gkwXh")).ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
            return ()=>{
                (0, (0, parcelRequire("iN9lO")).clearMeasure)((0, (0, parcelRequire("5cNeT")).default).EDITOR_MOUNTED);
                (0, (0, parcelRequire("iN9lO")).clearMeasure)((0, (0, parcelRequire("5cNeT")).default).ON_EDITOR_READY_CALLBACK);
            };
        }, []);
    }
});
parcelRegister("2JODI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b92cee7571d3699$export$2e2bcd8739ae039);
    var $gkwXh;
    var $ctLRZ;
    function $2b92cee7571d3699$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
        return async (duration, startTime)=>{
            const contextIdentifier = await props.contextIdentifierProvider;
            const objectId = contextIdentifier?.objectId;
            if (createAnalyticsEvent) (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(createAnalyticsEvent)({
                payload: {
                    action: action,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                    attributes: {
                        duration: duration,
                        startTime: startTime,
                        objectId: objectId
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                }
            });
        };
    }
});
parcelRegister("dCdqM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6123a7e35e2a74e1$export$2e2bcd8739ae039);
    var $2cB15;
    var $iN9lO;
    var $5cNeT;
    function $6123a7e35e2a74e1$export$2e2bcd8739ae039() {
        (0, (0, parcelRequire("2cB15")).default)(()=>{
            (0, (0, parcelRequire("iN9lO")).startMeasure)((0, (0, parcelRequire("5cNeT")).default).EDITOR_MOUNTED);
        });
    }
});
parcelRegister("1d04s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e3dd8adf4b990f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d = (passedProps)=>{
        const memodProps = (0, $5uXOq.useMemo)(()=>{
            const allProps = {
                preset: passedProps.preset,
                appearance: passedProps.appearance,
                contentComponents: passedProps.contentComponents,
                primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
                secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
                persistScrollGutter: passedProps.persistScrollGutter,
                quickInsert: passedProps.quickInsert,
                shouldFocus: passedProps.shouldFocus,
                disabled: passedProps.disabled,
                contextPanel: passedProps.contextPanel,
                errorReporterHandler: passedProps.errorReporterHandler,
                contentTransformerProvider: passedProps.contentTransformerProvider,
                maxHeight: passedProps.maxHeight,
                minHeight: passedProps.minHeight,
                placeholder: passedProps.placeholder,
                placeholderBracketHint: passedProps.placeholderBracketHint,
                defaultValue: passedProps.defaultValue,
                assistiveLabel: passedProps.assistiveLabel,
                assistiveDescribedBy: passedProps.assistiveDescribedBy,
                popupsMountPoint: passedProps.popupsMountPoint,
                popupsBoundariesElement: passedProps.popupsBoundariesElement,
                popupsScrollableElement: passedProps.popupsScrollableElement,
                editorActions: passedProps.editorActions,
                onEditorReady: passedProps.onEditorReady,
                onDestroy: passedProps.onDestroy,
                onChange: passedProps.onChange,
                onCancel: passedProps.onCancel,
                extensionProviders: passedProps.extensionProviders,
                UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
                useStickyToolbar: passedProps.useStickyToolbar,
                featureFlags: passedProps.featureFlags,
                onSave: passedProps.onSave,
                sanitizePrivateContent: passedProps.sanitizePrivateContent,
                media: passedProps.media,
                collabEdit: passedProps.collabEdit,
                primaryToolbarComponents: passedProps.primaryToolbarComponents,
                performanceTracking: passedProps.performanceTracking,
                inputSamplingLimit: passedProps.inputSamplingLimit,
                allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
                linking: passedProps.linking,
                activityProvider: passedProps.activityProvider,
                searchProvider: passedProps.searchProvider,
                annotationProviders: passedProps.annotationProviders,
                collabEditProvider: passedProps.collabEditProvider,
                presenceProvider: passedProps.presenceProvider,
                emojiProvider: passedProps.emojiProvider,
                taskDecisionProvider: passedProps.taskDecisionProvider,
                legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
                mentionProvider: passedProps.mentionProvider,
                autoformattingProvider: passedProps.autoformattingProvider,
                macroProvider: passedProps.macroProvider,
                contextIdentifierProvider: passedProps.contextIdentifierProvider,
                allowExpand: passedProps.allowExpand,
                allowNestedTasks: passedProps.allowNestedTasks,
                allowBlockType: passedProps.allowBlockType,
                allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
                allowBreakout: passedProps.allowBreakout,
                allowRule: passedProps.allowRule,
                allowHelpDialog: passedProps.allowHelpDialog,
                allowPanel: passedProps.allowPanel,
                allowExtension: passedProps.allowExtension,
                allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
                allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
                allowDate: passedProps.allowDate,
                allowLayouts: passedProps.allowLayouts,
                allowStatus: passedProps.allowStatus,
                allowTextAlignment: passedProps.allowTextAlignment,
                allowIndentation: passedProps.allowIndentation,
                showIndentationButtons: passedProps.showIndentationButtons,
                allowFindReplace: passedProps.allowFindReplace,
                allowBorderMark: passedProps.allowBorderMark,
                allowFragmentMark: passedProps.allowFragmentMark,
                autoScrollIntoView: passedProps.autoScrollIntoView,
                elementBrowser: passedProps.elementBrowser,
                maxContentSize: passedProps.maxContentSize,
                saveOnEnter: passedProps.saveOnEnter,
                feedbackInfo: passedProps.feedbackInfo,
                mention: passedProps.mention,
                mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
                uploadErrorHandler: passedProps.uploadErrorHandler,
                waitForMediaUpload: passedProps.waitForMediaUpload,
                extensionHandlers: passedProps.extensionHandlers,
                allowTextColor: passedProps.allowTextColor,
                allowTables: passedProps.allowTables,
                insertMenuItems: passedProps.insertMenuItems,
                UNSAFE_cards: passedProps.UNSAFE_cards,
                smartLinks: passedProps.smartLinks,
                allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
                codeBlock: passedProps.codeBlock,
                textFormatting: passedProps.textFormatting,
                dangerouslyAppendPlugins: passedProps.dangerouslyAppendPlugins,
                __livePage: passedProps.__livePage,
                AppearanceComponent: passedProps.AppearanceComponent,
                skipValidation: passedProps.skipValidation
            };
            const defaultProps = {
                appearance: 'comment',
                disabled: false,
                quickInsert: true
            };
            const nextProps = {
                ...defaultProps,
                ...allProps
            };
            return nextProps;
        }, [
            passedProps.preset,
            passedProps.appearance,
            passedProps.contentComponents,
            passedProps.primaryToolbarIconBefore,
            passedProps.secondaryToolbarComponents,
            passedProps.persistScrollGutter,
            passedProps.quickInsert,
            passedProps.shouldFocus,
            passedProps.disabled,
            passedProps.contextPanel,
            passedProps.errorReporterHandler,
            passedProps.contentTransformerProvider,
            passedProps.maxHeight,
            passedProps.minHeight,
            passedProps.placeholder,
            passedProps.placeholderBracketHint,
            passedProps.performanceTracking,
            passedProps.inputSamplingLimit,
            passedProps.defaultValue,
            passedProps.assistiveLabel,
            passedProps.assistiveDescribedBy,
            passedProps.popupsMountPoint,
            passedProps.popupsBoundariesElement,
            passedProps.popupsScrollableElement,
            passedProps.editorActions,
            passedProps.onEditorReady,
            passedProps.onDestroy,
            passedProps.onChange,
            passedProps.onCancel,
            passedProps.extensionProviders,
            passedProps.UNSAFE_useAnalyticsContext,
            passedProps.useStickyToolbar,
            passedProps.featureFlags,
            passedProps.onSave,
            passedProps.sanitizePrivateContent,
            passedProps.media,
            passedProps.collabEdit,
            passedProps.primaryToolbarComponents,
            passedProps.allowUndoRedoButtons,
            passedProps.linking,
            passedProps.activityProvider,
            passedProps.searchProvider,
            passedProps.annotationProviders,
            passedProps.collabEditProvider,
            passedProps.presenceProvider,
            passedProps.emojiProvider,
            passedProps.taskDecisionProvider,
            passedProps.legacyImageUploadProvider,
            passedProps.mentionProvider,
            passedProps.autoformattingProvider,
            passedProps.macroProvider,
            passedProps.contextIdentifierProvider,
            passedProps.allowExpand,
            passedProps.allowNestedTasks,
            passedProps.allowBlockType,
            passedProps.allowTasksAndDecisions,
            passedProps.allowBreakout,
            passedProps.allowRule,
            passedProps.allowHelpDialog,
            passedProps.allowPanel,
            passedProps.allowExtension,
            passedProps.allowConfluenceInlineComment,
            passedProps.allowTemplatePlaceholders,
            passedProps.allowDate,
            passedProps.allowLayouts,
            passedProps.allowStatus,
            passedProps.allowTextAlignment,
            passedProps.allowIndentation,
            passedProps.showIndentationButtons,
            passedProps.allowFindReplace,
            passedProps.allowBorderMark,
            passedProps.allowFragmentMark,
            passedProps.autoScrollIntoView,
            passedProps.elementBrowser,
            passedProps.maxContentSize,
            passedProps.saveOnEnter,
            passedProps.feedbackInfo,
            passedProps.mention,
            passedProps.mentionInsertDisplayName,
            passedProps.uploadErrorHandler,
            passedProps.waitForMediaUpload,
            passedProps.extensionHandlers,
            passedProps.allowTextColor,
            passedProps.allowTables,
            passedProps.insertMenuItems,
            passedProps.UNSAFE_cards,
            passedProps.smartLinks,
            passedProps.allowAnalyticsGASV3,
            passedProps.codeBlock,
            passedProps.textFormatting,
            passedProps.dangerouslyAppendPlugins,
            passedProps.__livePage,
            passedProps.AppearanceComponent,
            passedProps.skipValidation
        ]);
        return memodProps;
    };
    var $5e3dd8adf4b990f5$export$2e2bcd8739ae039 = $5e3dd8adf4b990f5$export$d9d7e48a5f16fb4d;
});
parcelRegister("jRRkB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5333f04c6da13671$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dGzaM;
    var $3thTj;
    var $bntD2;
    var $10FSK;
    var $2ncO1;
    function $5333f04c6da13671$var$prepareProviders(editorActions, quickInsert, extensionProviders, createAnalyticsEvent) {
        const extensionProvider = (0, (0, parcelRequire("3thTj")).default)(()=>editorActions)(extensionProviders);
        const quickInsertProvider = (0, (0, parcelRequire("bntD2")).default)(editorActions, extensionProvider, quickInsert, createAnalyticsEvent);
        return {
            extensionProvider: extensionProvider,
            quickInsertProvider: quickInsertProvider
        };
    }
    function $5333f04c6da13671$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
        const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
        const providers = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("10FSK")).default)({
                autoformattingProvider: autoformattingProvider,
                emojiProvider: emojiProvider,
                mentionProvider: mentionProvider,
                legacyImageUploadProvider: legacyImageUploadProvider,
                taskDecisionProvider: taskDecisionProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                searchProvider: searchProvider,
                macroProvider: macroProvider,
                activityProvider: activityProvider,
                collabEdit: collabEdit,
                collabEditProvider: collabEditProvider,
                presenceProvider: presenceProvider
            }), [
            autoformattingProvider,
            emojiProvider,
            mentionProvider,
            legacyImageUploadProvider,
            taskDecisionProvider,
            contextIdentifierProvider,
            searchProvider,
            macroProvider,
            activityProvider,
            collabEdit,
            collabEditProvider,
            presenceProvider
        ]);
        const providerFactory = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("dGzaM")).default)());
        const preparedProviders = (0, $5uXOq.useMemo)(()=>$5333f04c6da13671$var$prepareProviders(editorActions, quickInsert, extensionProviders, createAnalyticsEvent), [
            extensionProviders,
            quickInsert,
            editorActions,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("2ncO1")).default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
        }, [
            providers,
            preparedProviders
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                providerFactory.current.destroy();
            };
        }, []);
        return providerFactory.current;
    }
});
parcelRegister("3thTj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8798f349fd39c0ec$export$2e2bcd8739ae039);
    var $8QpSo;
    var $5WUYC;
    function $8798f349fd39c0ec$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
        if (!extensionProviders) return;
        if (typeof extensionProviders === 'function') return (0, (0, parcelRequire("5WUYC")).default)(extensionProviders(editorActions));
        return (0, (0, parcelRequire("5WUYC")).default)(extensionProviders);
    }
    const $8798f349fd39c0ec$var$prepareExtensionProvider = (getEditorActions)=>(0, (0, parcelRequire("8QpSo")).default)((extensionProviders)=>$8798f349fd39c0ec$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
    var $8798f349fd39c0ec$export$2e2bcd8739ae039 = $8798f349fd39c0ec$var$prepareExtensionProvider;
});
parcelRegister("5WUYC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d246d6c54b9ec0c3$export$2e2bcd8739ae039);
    var $lBEBY;
    var $d246d6c54b9ec0c3$export$2e2bcd8739ae039 = (extensionProviders)=>{
        const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, (0, parcelRequire("lBEBY")).default)(extensionProviders);
        return {
            getExtensions () {
                return invokeList('getExtensions');
            },
            getExtension (type, key) {
                return invokeSingle('getExtension', [
                    type,
                    key
                ]);
            },
            search (keyword) {
                return invokeList('search', [
                    keyword
                ]);
            },
            getAutoConverter () {
                return invokeList('getAutoConverter');
            }
        };
    };
});
parcelRegister("lBEBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c37a15ec98ede43$export$2e2bcd8739ae039);
    var $3B8Ug;
    const $8c37a15ec98ede43$var$flatten = (arr)=>[].concat(...arr);
    var $8c37a15ec98ede43$export$2e2bcd8739ae039 = (providers)=>{
        if (providers.length === 0) throw new Error('At least one provider must be provided');
        const getFulfilledProviders = async ()=>{
            const results = await (0, (0, parcelRequire("3B8Ug")).waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
            return (0, (0, parcelRequire("3B8Ug")).getOnlyFulfilled)(results);
        };
        const runInAllProviders = async (mapFunction)=>{
            return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
        };
        const createCallback = (methodName, args)=>(provider)=>{
                const method = provider[methodName];
                if (typeof method === 'function') return method.apply(provider, args);
                throw new Error(`"${String(methodName)}" isn't a function of the provider`);
            };
        const invokeSingle = async (methodName, args)=>{
            const callback = createCallback(methodName, args);
            return (0, (0, parcelRequire("3B8Ug")).waitForFirstFulfilledPromise)(await runInAllProviders(callback));
        };
        const invokeList = async (methodName, args)=>{
            const callback = createCallback(methodName, args);
            const results = await (0, (0, parcelRequire("3B8Ug")).waitForAllPromises)(await runInAllProviders(callback));
            const fulfilledResults = (0, (0, parcelRequire("3B8Ug")).getOnlyFulfilled)(results);
            return $8c37a15ec98ede43$var$flatten(fulfilledResults).filter((result)=>result);
        };
        return {
            invokeSingle: invokeSingle,
            invokeList: invokeList
        };
    };
});
parcelRegister("3B8Ug", function(module, exports) {
    $parcel$export(module.exports, "waitForAllPromises", ()=>$682d4194c4aac261$export$b43fdcffd84b7b0f);
    $parcel$export(module.exports, "waitForFirstFulfilledPromise", ()=>$682d4194c4aac261$export$cb8861b0e3f3dd6f);
    $parcel$export(module.exports, "getOnlyFulfilled", ()=>$682d4194c4aac261$export$b7581cbf0e22e36b);
    var $682d4194c4aac261$export$7103a54af3e45080;
    (function(ResultStatus) {
        ResultStatus["FULFILLED"] = "fulfilled";
        ResultStatus["FAILED"] = "failed";
    })($682d4194c4aac261$export$7103a54af3e45080 || ($682d4194c4aac261$export$7103a54af3e45080 = {}));
    const $682d4194c4aac261$var$isFullfilled = (result)=>result.status === "fulfilled";
    const $682d4194c4aac261$var$markFullfilled = (value)=>({
            status: "fulfilled",
            value: value
        });
    const $682d4194c4aac261$var$markRejected = (error)=>({
            status: "failed",
            reason: error
        });
    const $682d4194c4aac261$export$b43fdcffd84b7b0f = (promises)=>{
        return Promise.all(promises.map((result)=>result.then($682d4194c4aac261$var$markFullfilled).catch($682d4194c4aac261$var$markRejected)));
    };
    const $682d4194c4aac261$export$cb8861b0e3f3dd6f = (promises)=>{
        const rejectReasons = [];
        return new Promise((resolve, reject)=>{
            promises.forEach((promise)=>promise.then((value)=>{
                    if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                    resolve(value);
                }).catch((reason)=>{
                    rejectReasons.push(reason);
                    if (rejectReasons.length === promises.length) reject(reason);
                }));
        });
    };
    const $682d4194c4aac261$export$b7581cbf0e22e36b = (results)=>results.filter($682d4194c4aac261$var$isFullfilled).map((result)=>result.value);
});
parcelRegister("bntD2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$37ee1a571c17d3b4$export$2e2bcd8739ae039);
    var $f1ZF9;
    function $37ee1a571c17d3b4$export$2e2bcd8739ae039(editorActions, extensionProvider, quickInsert, createAnalyticsEvent) {
        const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
        const extensionQuickInsertProvider = extensionProvider && (0, (0, parcelRequire("f1ZF9")).extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, createAnalyticsEvent);
        return quickInsertProvider && extensionQuickInsertProvider ? (0, (0, parcelRequire("f1ZF9")).combineQuickInsertProviders)([
            quickInsertProvider,
            extensionQuickInsertProvider
        ]) : quickInsertProvider || extensionQuickInsertProvider;
    }
});
parcelRegister("f1ZF9", function(module, exports) {
    $parcel$export(module.exports, "extensionProviderToQuickInsertProvider", ()=>$acd9c39774394075$export$6b0bb34c2583056f);
    $parcel$export(module.exports, "combineQuickInsertProviders", ()=>$acd9c39774394075$export$e3759a254d73dcb7);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $gkwXh;
    var $ctLRZ;
    var $04ZRC;
    var $izxHQ;
    var $lBEBY;
    function $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source) {
        if (createAnalyticsEvent) (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }
        });
    }
    async function $acd9c39774394075$export$6b0bb34c2583056f(extensionProvider, editorActions, createAnalyticsEvent) {
        const extensions = await extensionProvider.getExtensions();
        return {
            getItems: ()=>{
                const quickInsertItems = (0, (0, parcelRequire("04ZRC")).getQuickInsertItemsFromModule)(extensions, (item)=>{
                    const Icon = (0, ($parcel$interopDefault($4qBtX)))({
                        loader: item.icon,
                        loading: ()=>null
                    });
                    return {
                        title: item.title,
                        description: item.description,
                        icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                                label: ""
                            }),
                        keywords: item.keywords,
                        featured: item.featured,
                        categories: item.categories,
                        action: (insert, state, source)=>{
                            if (typeof item.node === 'function') {
                                (0, (0, parcelRequire("izxHQ")).resolveImport)(item.node()).then((node)=>{
                                    $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source);
                                    if (node) editorActions.replaceSelection(node);
                                });
                                return insert('');
                            } else {
                                $acd9c39774394075$var$sendExtensionQuickInsertAnalytics(item, createAnalyticsEvent, source);
                                return insert(item.node);
                            }
                        }
                    };
                });
                return Promise.all(quickInsertItems);
            }
        };
    }
    async function $acd9c39774394075$export$e3759a254d73dcb7(quickInsertProviders) {
        const { invokeList: invokeList } = (0, (0, parcelRequire("lBEBY")).default)(quickInsertProviders);
        return {
            getItems () {
                return invokeList('getItems');
            }
        };
    }
});
parcelRegister("04ZRC", function(module, exports) {
    $parcel$export(module.exports, "getQuickInsertItemsFromModule", ()=>$ceac48cd89560646$export$a1d0004a197b97a3);
    $parcel$export(module.exports, "getAutoConvertPatternsFromModule", ()=>$ceac48cd89560646$export$60407594ea5edd1c);
    $parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", ()=>$ceac48cd89560646$export$38a3a11e6509754a);
    $parcel$export(module.exports, "getContextualToolbarItemsFromModule", ()=>$ceac48cd89560646$export$9d13b95c50a2a6c9);
    var $izxHQ;
    const $ceac48cd89560646$export$3f063810d7bf01bd = (arr, attr, keyRenamer)=>arr.reduce((acc, item)=>{
            acc[keyRenamer(item[attr])] = item;
            return acc;
        }, {});
    function $ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule) {
        const title = extensionModule.title || manifest.title;
        const key = `${manifest.key}:${extensionModule.key}`;
        const node = (0, (0, parcelRequire("izxHQ")).buildAction)(extensionModule.action, manifest);
        if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
        return {
            key: key,
            title: title,
            extensionType: manifest.type,
            extensionKey: manifest.key,
            keywords: extensionModule.keywords || manifest.keywords || [],
            featured: extensionModule.featured || false,
            categories: extensionModule.categories || manifest.categories || [],
            description: extensionModule.description || manifest.description,
            summary: manifest.summary,
            documentationUrl: manifest.documentationUrl,
            icon: extensionModule.icon || manifest.icons['48'],
            node: node
        };
    }
    const $ceac48cd89560646$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
        const items = extensions.map((manifest)=>{
            const modules = manifest.modules.quickInsert || [];
            return modules.map((extensionModule)=>$ceac48cd89560646$export$30871400b97708b4(manifest, extensionModule));
        });
        const flatItems = [].concat(...items);
        return flatItems.map(transformFunction);
    };
    async function $ceac48cd89560646$export$60407594ea5edd1c(extensions) {
        const items = await Promise.all(extensions.map(async (manifest)=>{
            if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
            return [];
        }));
        return [].concat(...items);
    }
    const $ceac48cd89560646$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
            for (const handler of autoConvertHandlers){
                const result = handler(text);
                if (result) return result;
            }
        };
    async function $ceac48cd89560646$export$38a3a11e6509754a(extensionProviderPromise) {
        const extensionProvider = await extensionProviderPromise;
        const extensionAutoConverters = await extensionProvider.getAutoConverter();
        return $ceac48cd89560646$export$5ae7aa0814ef4090(extensionAutoConverters);
    }
    const $ceac48cd89560646$var$logError = (msg, ...args)=>{
        console.error(msg, ...args);
    };
    const $ceac48cd89560646$var$toolbarItemToButtonConfig = (toolbarItem, parentKey)=>{
        const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarItem;
        const itemKey = [
            parentKey,
            key
        ].join(':');
        if (typeof action !== 'function') $ceac48cd89560646$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
        let labelAndIcon = {};
        switch(toolbarItem.display){
            case 'icon':
                if (!icon) $ceac48cd89560646$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
                labelAndIcon = {
                    icon: icon
                };
                break;
            case 'label':
                if (!label) $ceac48cd89560646$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
                labelAndIcon = {
                    label: label
                };
                break;
            default:
                if (!label || !icon) $ceac48cd89560646$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
                labelAndIcon = {
                    icon: icon,
                    label: label
                };
                break;
        }
        return {
            key: itemKey,
            ariaLabel: ariaLabel,
            tooltip: tooltip,
            tooltipStyle: tooltipStyle,
            action: action,
            disabled: disabled,
            ...labelAndIcon
        };
    };
    const $ceac48cd89560646$var$compareContext = (contextA, contextB)=>{
        if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
            if (contextA.type === 'node') return true;
            if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
        }
        return false;
    };
    const $ceac48cd89560646$var$hasDuplicateContext = (contextualToolbars)=>{
        if (contextualToolbars.length > 1) {
            const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
            return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$ceac48cd89560646$var$compareContext(currentContext, context)));
        }
    };
    const $ceac48cd89560646$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
        return extensions.map((extension)=>{
            if (extension.modules.contextualToolbars) {
                const duplicateContext = $ceac48cd89560646$var$hasDuplicateContext(extension.modules.contextualToolbars);
                if (duplicateContext) {
                    $ceac48cd89560646$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                    return [];
                }
                return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                    if ($ceac48cd89560646$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                        const { toolbarItems: toolbarItems } = contextualToolbar;
                        if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                        return toolbarItems;
                    }
                    return [];
                }).flatMap((toolbarButtons)=>toolbarButtons.map((toolbarButton)=>$ceac48cd89560646$var$toolbarItemToButtonConfig(toolbarButton, extension.key)));
            }
            return [];
        }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
    };
    function $ceac48cd89560646$var$shouldAddExtensionItemForNode(item, node) {
        if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
        if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
        const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
        if (extensionType && extensionType !== node.attrs?.extensionType) return false;
        if (typeof extensionKey === 'string') return extensionKey === node.attrs?.extensionKey;
        if (Array.isArray(extensionKey) && extensionKey.length) return extensionKey.includes(node.attrs?.extensionKey);
        return false;
    }
});
parcelRegister("10FSK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc30c3c0fe5f5799$export$2e2bcd8739ae039);
    function $bc30c3c0fe5f5799$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
        return {
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            autoformattingProvider: autoformattingProvider,
            activityProvider: activityProvider,
            imageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            presenceProvider: presenceProvider,
            macroProvider: macroProvider,
            collabEditProvider: collabEdit?.provider ? collabEdit.provider : collabEditProvider
        };
    }
});
parcelRegister("2ncO1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73e179e49684dee1$export$2e2bcd8739ae039);
    function $73e179e49684dee1$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
        providerFactory.setProvider('mentionProvider', mentionProvider);
        providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
        providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
        providerFactory.setProvider('collabEditProvider', collabEditProvider);
        providerFactory.setProvider('activityProvider', activityProvider);
        providerFactory.setProvider('searchProvider', searchProvider);
        providerFactory.setProvider('presenceProvider', presenceProvider);
        providerFactory.setProvider('macroProvider', macroProvider);
        if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
        if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
    }
});
parcelRegister("5Xe3v", function(module, exports) {
    $parcel$export(module.exports, "usePreset", ()=>$df819121659b5a33$export$1d81a44583df97d2);
    var $5uXOq = parcelRequire("5uXOq");
    var $jy0M7;
    var $VSDnB;
    function $df819121659b5a33$export$1d81a44583df97d2(createPreset, dependencies = []) {
        const [editorApi, setAPI] = (0, $5uXOq.useState)(undefined);
        const preset = (0, $5uXOq.useMemo)(()=>createPreset(new (0, (0, parcelRequire("jy0M7")).EditorPresetBuilder)()), dependencies);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_fix_api_strict_mode')) return preset.apiResolver.on((api)=>{
                setAPI(api);
            });
        }, [
            preset.apiResolver
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_fix_api_strict_mode')) preset.apiPromise.then((api)=>{
                setAPI(api);
            });
        }, [
            preset.apiPromise
        ]);
        return {
            editorApi: editorApi,
            preset: preset
        };
    }
});
parcelRegister("jy0M7", function(module, exports) {
    $parcel$export(module.exports, "EditorPresetBuilder", ()=>$727f0ffe9f739d15$export$dab03ba05a79e5c7);
    var $lY6DM;
    class $727f0ffe9f739d15$export$dab03ba05a79e5c7 {
        constructor(...more){
            this.apiEmitter = ()=>{};
            this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                    plugin,
                    undefined
                ];
            this.data = [
                ...more
            ];
            this.apiPromise = new Promise((r)=>this.resolver = r);
            this.apiResolver = new $727f0ffe9f739d15$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
        }
        add(nextOrTuple) {
            return new $727f0ffe9f739d15$export$dab03ba05a79e5c7(nextOrTuple, ...this.data);
        }
        maybeAdd(pluginToAdd, shouldAdd) {
            const pluginOrBuilder = typeof shouldAdd === 'function' ? shouldAdd(pluginToAdd, this) : shouldAdd;
            if (pluginOrBuilder instanceof $727f0ffe9f739d15$export$dab03ba05a79e5c7) return pluginOrBuilder;
            const nextPluginStack = [
                pluginOrBuilder ? pluginToAdd : undefined,
                ...this.data
            ];
            const nextEditorPresetBuilder = new $727f0ffe9f739d15$export$dab03ba05a79e5c7(...nextPluginStack);
            return nextEditorPresetBuilder;
        }
        has(plugin) {
            return this.data.some((pluginPreset)=>{
                if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
                return pluginPreset === plugin;
            });
        }
        build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
            const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
            const editorPlugins = this.processEditorPlugins({
                pluginInjectionAPI: pluginInjectionAPI,
                excludePlugins: excludePlugins
            });
            if (pluginInjectionAPI) {
                this.apiEmitter(pluginInjectionAPI.api());
                this.resolver?.(pluginInjectionAPI.api());
            }
            return this.removeExcludedPlugins(editorPlugins, excludePlugins);
        }
        verifyDuplicatedPlugins() {
            const cache = new Set();
            this.data.filter(Boolean).forEach((pluginEntry)=>{
                const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                    pluginEntry,
                    undefined
                ];
                if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
                cache.add(pluginFn);
            });
            return true;
        }
        processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
            this.verifyDuplicatedPlugins();
            const seen = new Set();
            const pluginsDataCopy = this.data.slice();
            const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
                const [fn, config] = this.safeEntry(entry);
                if (seen.has(fn)) return null;
                seen.add(fn);
                if (typeof fn !== 'function') return null;
                const plugin = pluginInjectionAPI ? fn({
                    config: config,
                    api: pluginInjectionAPI.api()
                }) : fn({
                    config: config
                });
                if (plugin && excludePlugins?.has(plugin.name)) return null;
                if (!pluginInjectionAPI) return plugin;
                pluginInjectionAPI.onEditorPluginInitialized(plugin);
                return plugin;
            }).filter(Boolean);
            return plugins;
        }
        removeExcludedPlugins(plugins, excludes) {
            if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
            return plugins;
        }
    }
    class $727f0ffe9f739d15$var$APIDispatcher {
        constructor(emitter){
            this.emitter = emitter;
            this.eventDispatcher = new (0, (0, parcelRequire("lY6DM")).EventDispatcher)();
            this.key = 'api-resolved-event';
            this.initialEvent = undefined;
            this.emitter((v)=>{
                this.initialEvent = v;
                this.eventDispatcher.emit(this.key, v);
            });
        }
        on(cb) {
            if (this.initialEvent !== undefined) Promise.resolve().then(()=>cb(this.initialEvent));
            this.eventDispatcher.on(this.key, cb);
            return ()=>{
                this.eventDispatcher.off(this.key, cb);
            };
        }
        destroy() {
            this.eventDispatcher.destroy();
        }
    }
});
parcelRegister("fLTqo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3162b9aa01f33877$export$2e2bcd8739ae039);
    var $kOFhM;
    var $e6OIt;
    class $3162b9aa01f33877$export$2e2bcd8739ae039 {
        constructor(schema){
            this.schema = schema;
            this.schema = schema;
        }
        serializeFragment(fragment) {
            const result = [];
            fragment.forEach((n)=>{
                result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, this.schema));
            });
            return result.join('\n').replace(/\n+/g, '\n');
        }
        static fromSchema(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema)) {
            return new $3162b9aa01f33877$export$2e2bcd8739ae039(schema);
        }
    }
});
parcelRegister("e6OIt", function(module, exports) {
    $parcel$export(module.exports, "reduce", ()=>$d81fee803f8be80c$export$533b26079ad0b4b);
    var $3pmcr;
    var $dFTQc;
    var $gePJb;
    var $kDX7I;
    var $imMk3;
    var $440xp;
    var $lFEBP;
    var $htHCj;
    var $khjO4;
    var $6e3uf;
    var $3LUJO;
    var $eAfxp;
    var $aBdRK;
    var $hHZcb;
    var $3uDza;
    var $jDcJt;
    var $ca29C;
    var $70D85;
    const $d81fee803f8be80c$export$533b26079ad0b4b = (node, schema)=>{
        const reducer = $d81fee803f8be80c$var$nodeToReducerMapping[node.type.name] || $d81fee803f8be80c$var$nodeToReducerMapping.unknown;
        return reducer(node, schema);
    };
    const $d81fee803f8be80c$var$nodeToReducerMapping = {
        blockquote: (0, parcelRequire("3pmcr")).default,
        bulletList: (0, parcelRequire("dFTQc")).default,
        date: (0, parcelRequire("gePJb")).default,
        decisionItem: (0, parcelRequire("kDX7I")).default,
        hardBreak: (0, parcelRequire("imMk3")).default,
        heading: (0, parcelRequire("440xp")).default,
        inlineCard: (0, parcelRequire("lFEBP")).default,
        listItem: (0, parcelRequire("htHCj")).default,
        mediaGroup: (0, parcelRequire("khjO4")).default,
        mention: (0, parcelRequire("6e3uf")).default,
        orderedList: (0, parcelRequire("3LUJO")).default,
        panel: (0, parcelRequire("eAfxp")).default,
        paragraph: (0, parcelRequire("aBdRK")).default,
        rule: (0, parcelRequire("hHZcb")).default,
        status: (0, parcelRequire("3uDza")).default,
        table: (0, parcelRequire("jDcJt")).default,
        taskItem: (0, parcelRequire("ca29C")).default,
        unknown: (0, parcelRequire("70D85")).default
    };
});
parcelRegister("3pmcr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b783d74f3fa943e7$export$2e2bcd8739ae039);
    var $e6OIt;
    const $b783d74f3fa943e7$var$blockquote = (node, schema)=>{
        const result = [];
        node.content.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        return `> ${result.join('')}`;
    };
    var $b783d74f3fa943e7$export$2e2bcd8739ae039 = $b783d74f3fa943e7$var$blockquote;
});
parcelRegister("dFTQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$749dbd2e6028b2d6$export$2e2bcd8739ae039);
    var $e6OIt;
    const $749dbd2e6028b2d6$var$bulletList = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push(`* ${(0, (0, parcelRequire("e6OIt")).reduce)(n, schema)}`);
        });
        return result.join('\n');
    };
    var $749dbd2e6028b2d6$export$2e2bcd8739ae039 = $749dbd2e6028b2d6$var$bulletList;
});
parcelRegister("gePJb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9583bb4b1b92a2c3$export$2e2bcd8739ae039);
    var $cAMv0;
    var $K5Jsy;
    const $9583bb4b1b92a2c3$var$date = (node, schema)=>{
        return node.attrs.timestamp ? (0, (0, parcelRequire("cAMv0")).timestampToIsoFormat)(node.attrs.timestamp) : (0, (0, parcelRequire("K5Jsy")).getText)(node);
    };
    var $9583bb4b1b92a2c3$export$2e2bcd8739ae039 = $9583bb4b1b92a2c3$var$date;
});
parcelRegister("cAMv0", function(module, exports) {
    $parcel$export(module.exports, "timestampToUTCDate", ()=>$c5b07ac9bae9c35c$export$56c3660a4ee2196a);
    $parcel$export(module.exports, "todayTimestampInUTC", ()=>$c5b07ac9bae9c35c$export$6297728405c48562);
    $parcel$export(module.exports, "timestampToString", ()=>$c5b07ac9bae9c35c$export$48755a044ef883a0);
    $parcel$export(module.exports, "timestampToIsoFormat", ()=>$c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1);
    $parcel$export(module.exports, "isPastDate", ()=>$c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e);
    $parcel$export(module.exports, "timestampToTaskContext", ()=>$c5b07ac9bae9c35c$export$fbc04a9e57b04a80);
    var $SzDmm;
    var $kUxFz;
    var $c5b07ac9bae9c35c$var$FORMATS;
    (function(FORMATS) {
        FORMATS["ISO_FORMAT"] = "YYYY-MM-DD";
        FORMATS["LOCALIZED_FORMAT"] = "LOCALIZED_FORMAT";
    })($c5b07ac9bae9c35c$var$FORMATS || ($c5b07ac9bae9c35c$var$FORMATS = {}));
    const $c5b07ac9bae9c35c$export$56c3660a4ee2196a = (timestamp)=>{
        const date = new Date(Number(timestamp));
        const day = date.getUTCDate();
        const month = date.getUTCMonth() + 1;
        const year = date.getUTCFullYear();
        return {
            day: day,
            month: month,
            year: year
        };
    };
    const $c5b07ac9bae9c35c$export$6297728405c48562 = ()=>{
        const today = new Date(Date.now());
        const todayInUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
        return todayInUTC.toString();
    };
    const $c5b07ac9bae9c35c$var$addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const $c5b07ac9bae9c35c$var$capitalizeFirstLetter = (str)=>{
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const $c5b07ac9bae9c35c$export$48755a044ef883a0 = (timestamp, intl, pattern)=>{
        if (!intl || pattern === "YYYY-MM-DD") return $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1(timestamp);
        const date = new Date(Number(timestamp));
        return intl.formatDate(date, {
            timeZone: 'UTC',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            formatMatcher: 'best fit'
        });
    };
    const $c5b07ac9bae9c35c$export$70a1b7b6fffe4dd1 = (timestamp)=>{
        const date = new Date(Number(timestamp));
        return `${date.getUTCFullYear()}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCMonth() + 1)}-${$c5b07ac9bae9c35c$var$addLeadingZero(date.getUTCDate())}`;
    };
    const $c5b07ac9bae9c35c$export$e6cc7bfc6e0e363e = (timestamp)=>{
        return (0, (0, parcelRequire("kUxFz")).default)(new Date(Number(timestamp)), new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562())));
    };
    const $c5b07ac9bae9c35c$export$fbc04a9e57b04a80 = (timestamp, intl)=>{
        const curDate = new Date(Number($c5b07ac9bae9c35c$export$6297728405c48562()));
        const givenDate = new Date(Number(timestamp));
        const distance = (0, (0, parcelRequire("SzDmm")).default)(givenDate, curDate);
        if (intl && [
            -1,
            0,
            1
        ].indexOf(distance) > -1) return $c5b07ac9bae9c35c$var$capitalizeFirstLetter(intl.formatRelativeTime(distance, 'day', {
            numeric: 'auto'
        }));
        return $c5b07ac9bae9c35c$export$48755a044ef883a0(timestamp, intl, "LOCALIZED_FORMAT");
    };
});
parcelRegister("kDX7I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bd72f6ac7c9da28$export$2e2bcd8739ae039);
    var $e6OIt;
    const $2bd72f6ac7c9da28$var$decisionItem = (node, schema)=>{
        const result = [];
        let previousNodeType = '';
        node.forEach((n)=>{
            const text = (0, (0, parcelRequire("e6OIt")).reduce)(n, schema);
            if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
            else result.push(text);
            previousNodeType = n.type.name;
        });
        return `<> ${result.join('').trim()}`;
    };
    var $2bd72f6ac7c9da28$export$2e2bcd8739ae039 = $2bd72f6ac7c9da28$var$decisionItem;
});
parcelRegister("imMk3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$225150f21995c312$export$2e2bcd8739ae039);
    const $225150f21995c312$var$hardBreak = ()=>{
        return '\n';
    };
    var $225150f21995c312$export$2e2bcd8739ae039 = $225150f21995c312$var$hardBreak;
});
parcelRegister("440xp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$138bcacc90088152$export$2e2bcd8739ae039);
    var $e6OIt;
    const $138bcacc90088152$var$heading = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        return result.join('');
    };
    var $138bcacc90088152$export$2e2bcd8739ae039 = $138bcacc90088152$var$heading;
});
parcelRegister("lFEBP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$624c2799ad9d8e95$export$2e2bcd8739ae039);
    var $K5Jsy;
    const $624c2799ad9d8e95$var$inlineCard = (node, schema)=>{
        return node.attrs.url || node.attrs.data?.url || (0, (0, parcelRequire("K5Jsy")).getText)(node);
    };
    var $624c2799ad9d8e95$export$2e2bcd8739ae039 = $624c2799ad9d8e95$var$inlineCard;
});
parcelRegister("htHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a088bc6174fa44e$export$2e2bcd8739ae039);
    var $e6OIt;
    const $1a088bc6174fa44e$var$listItem = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        return result.join('\n');
    };
    var $1a088bc6174fa44e$export$2e2bcd8739ae039 = $1a088bc6174fa44e$var$listItem;
});
parcelRegister("khjO4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8e89926131a2312a$export$2e2bcd8739ae039);
    const $8e89926131a2312a$var$mediaGroup = (node)=>{
        let childMediaFilesCount = 0;
        node.content.forEach((childNode)=>{
            if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
        });
        if (childMediaFilesCount) {
            const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
            return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
        }
        return '';
    };
    var $8e89926131a2312a$export$2e2bcd8739ae039 = $8e89926131a2312a$var$mediaGroup;
});
parcelRegister("6e3uf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2977203c4602e2c5$export$2e2bcd8739ae039);
    const $2977203c4602e2c5$var$mention = (node, schema)=>{
        if ([
            'all',
            'here'
        ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
        return `${node.attrs.text || '@unknown'}`;
    };
    var $2977203c4602e2c5$export$2e2bcd8739ae039 = $2977203c4602e2c5$var$mention;
});
parcelRegister("3LUJO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f90d7afe39bccffc$export$2e2bcd8739ae039);
    var $uTDrM;
    var $e6OIt;
    const $f90d7afe39bccffc$var$orderedList = (node, schema)=>{
        const result = [];
        const order = (0, (0, parcelRequire("uTDrM")).getOrderFromOrderedListNode)(node);
        node.forEach((n, _offset, index)=>{
            result.push(`${index + order}. ${(0, (0, parcelRequire("e6OIt")).reduce)(n, schema)}`);
        });
        return result.join('\n');
    };
    var $f90d7afe39bccffc$export$2e2bcd8739ae039 = $f90d7afe39bccffc$var$orderedList;
});
parcelRegister("eAfxp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8f54e9a672bbbf1$export$2e2bcd8739ae039);
    var $e6OIt;
    const $e8f54e9a672bbbf1$var$panel = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        return result.join('\n');
    };
    var $e8f54e9a672bbbf1$export$2e2bcd8739ae039 = $e8f54e9a672bbbf1$var$panel;
});
parcelRegister("aBdRK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bd298fed1fdb6b4$export$2e2bcd8739ae039);
    var $e6OIt;
    const $5bd298fed1fdb6b4$var$paragraph = (node, schema)=>{
        const result = [];
        let previousNodeType = '';
        node.forEach((n)=>{
            const text = (0, (0, parcelRequire("e6OIt")).reduce)(n, schema);
            if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
            else result.push(text);
            previousNodeType = n.type.name;
        });
        return result.join('').trim();
    };
    var $5bd298fed1fdb6b4$export$2e2bcd8739ae039 = $5bd298fed1fdb6b4$var$paragraph;
});
parcelRegister("hHZcb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b47562962a68bb7$export$2e2bcd8739ae039);
    const $9b47562962a68bb7$var$rule = ()=>{
        return '';
    };
    var $9b47562962a68bb7$export$2e2bcd8739ae039 = $9b47562962a68bb7$var$rule;
});
parcelRegister("3uDza", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffa78d4ec3c1edae$export$2e2bcd8739ae039);
    var $K5Jsy;
    const $ffa78d4ec3c1edae$var$status = (node, schema)=>{
        return node.attrs.text ? `[ ${node.attrs.text.toUpperCase()} ]` : (0, (0, parcelRequire("K5Jsy")).getText)(node);
    };
    var $ffa78d4ec3c1edae$export$2e2bcd8739ae039 = $ffa78d4ec3c1edae$var$status;
});
parcelRegister("jDcJt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3dc23c7a13259c83$export$2e2bcd8739ae039);
    var $e6OIt;
    const $3dc23c7a13259c83$var$table = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push($3dc23c7a13259c83$var$tableRow(n, schema));
        });
        return result.join('\n');
    };
    const $3dc23c7a13259c83$var$tableRow = (node, schema)=>{
        const result = [];
        let separator = '|';
        node.forEach((n)=>{
            result.push($3dc23c7a13259c83$var$tableCell(n, schema));
        });
        return `${separator}${result.join(`${separator}`)}${separator}`;
    };
    const $3dc23c7a13259c83$var$tableCell = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        return result.join('\n');
    };
    var $3dc23c7a13259c83$export$2e2bcd8739ae039 = $3dc23c7a13259c83$var$table;
});
parcelRegister("ca29C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8366ad5bb1422197$export$2e2bcd8739ae039);
    var $e6OIt;
    const $8366ad5bb1422197$var$taskItem = (node, schema)=>{
        const result = [];
        let previousNodeType = '';
        const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
        node.forEach((n)=>{
            const text = (0, (0, parcelRequire("e6OIt")).reduce)(n, schema);
            if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
            else result.push(text);
            previousNodeType = n.type.name;
        });
        return `${state} ${result.join('').trim()}`;
    };
    var $8366ad5bb1422197$export$2e2bcd8739ae039 = $8366ad5bb1422197$var$taskItem;
});
parcelRegister("70D85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce6f7879b7465532$export$2e2bcd8739ae039);
    var $K5Jsy;
    var $e6OIt;
    const $ce6f7879b7465532$var$unknown = (node, schema)=>{
        const result = [];
        node.forEach((n)=>{
            result.push((0, (0, parcelRequire("e6OIt")).reduce)(n, schema));
        });
        if (result.length > 0) return result.join('');
        return (0, (0, parcelRequire("K5Jsy")).getText)(node);
    };
    var $ce6f7879b7465532$export$2e2bcd8739ae039 = $ce6f7879b7465532$var$unknown;
});
parcelRegister("eqXnF", function(module, exports) {
    $parcel$export(module.exports, "createAIPromptPreset", ()=>$a8894c95ce979376$export$cd6e43a807ff0e0d);
    var $jy0M7;
    parcelRequire("g36b0");
    var $lsZ2i;
    parcelRequire("fxvTQ");
    var $3ypvl;
    parcelRequire("at6Ig");
    var $kiLfG;
    parcelRequire("aboEQ");
    var $2hnN6;
    parcelRequire("3nspz");
    var $7fslY;
    parcelRequire("cVzPm");
    var $9UHJN;
    parcelRequire("oFSWG");
    var $kd7KX;
    parcelRequire("ceDVv");
    var $izJY1;
    parcelRequire("gmJvQ");
    var $jnbcS;
    parcelRequire("4fHvc");
    var $gQCbY;
    parcelRequire("3wlyh");
    var $IBShN;
    parcelRequire("6mXgW");
    var $Ctl7E;
    parcelRequire("5I6Ej");
    var $29BTY;
    parcelRequire("2fcyF");
    var $1bV4T;
    parcelRequire("7bJco");
    var $4y8T6;
    parcelRequire("hrqyH");
    var $acf8A;
    parcelRequire("2DIrX");
    var $17hss;
    parcelRequire("bM5ai");
    var $53MdN;
    parcelRequire("ewWTS");
    var $294fK;
    parcelRequire("7o36A");
    var $EE6bW;
    parcelRequire("1jBun");
    var $bunIk;
    parcelRequire("644sF");
    var $aa15T;
    parcelRequire("gXAdO");
    var $cKx1R;
    parcelRequire("gYYLA");
    var $7ednl;
    parcelRequire("kMiBI");
    var $bTGGC;
    var $5xDEh;
    function $a8894c95ce979376$export$cd6e43a807ff0e0d(options) {
        const cardPluginData = {
            ...options.linking?.smartLinks,
            linkPicker: options.linking?.linkPicker,
            lpLinkPicker: options.featureFlags?.lpLinkPicker ?? false,
            disableFloatingToolbar: true,
            showUpgradeDiscoverability: false,
            allowBlockCards: false,
            allowEmbeds: false
        };
        const preset = new (0, (0, parcelRequire("jy0M7")).EditorPresetBuilder)().add([
            (0, (0, parcelRequire("29BTY")).featureFlagsPlugin),
            options.featureFlags
        ]).maybeAdd([
            (0, (0, parcelRequire("lsZ2i")).analyticsPlugin),
            {
                createAnalyticsEvent: options.createAnalyticsEvent
            }
        ], Boolean(options.allowAnalyticsGASV3)).add((0, (0, parcelRequire("kiLfG")).betterTypeHistoryPlugin)).add([
            (0, (0, parcelRequire("294fK")).pastePlugin),
            {}
        ]).add((0, (0, parcelRequire("kd7KX")).default)).add((0, (0, parcelRequire("4y8T6")).focusPlugin)).add((0, (0, parcelRequire("izJY1")).compositionPlugin)).add([
            (0, (0, parcelRequire("3ypvl")).default),
            {}
        ]).add((0, (0, parcelRequire("IBShN")).decorationsPlugin)).add((0, (0, parcelRequire("cKx1R")).typeAheadPlugin)).maybeAdd((0, (0, parcelRequire("17hss")).default), true).maybeAdd((0, (0, parcelRequire("7ednl")).undoRedoPlugin), true).add((0, (0, parcelRequire("9UHJN")).clearMarksOnEmptyDocPlugin)).maybeAdd([
            (0, (0, parcelRequire("53MdN")).hyperlinkPlugin),
            {
                disableFloatingToolbar: true
            }
        ], !!options.enableLinks).add((0, (0, parcelRequire("bTGGC")).widthPlugin)).add([
            (0, (0, parcelRequire("EE6bW")).placeholderPlugin),
            options.placeholder
        ]).add((0, (0, parcelRequire("Ctl7E")).editorDisabledPlugin)).add((0, (0, parcelRequire("jnbcS")).copyButtonPlugin)).add((0, (0, parcelRequire("1bV4T")).floatingToolbarPlugin)).add([
            (0, (0, parcelRequire("aa15T")).selectionPlugin),
            {}
        ]).add([
            (0, (0, parcelRequire("bunIk")).saveOnEnterPlugin),
            options.onSave
        ]).maybeAdd([
            (0, (0, parcelRequire("acf8A")).gridPlugin),
            {}
        ], true).maybeAdd([
            (0, (0, parcelRequire("7fslY")).cardPlugin),
            cardPluginData
        ], !!options.enableLinks).add([
            (0, (0, parcelRequire("2hnN6")).blockTypePlugin),
            {
                allowBlockType: {
                    exclude: [
                        'heading',
                        'blockquote'
                    ]
                }
            }
        ]).maybeAdd([
            (0, (0, parcelRequire("gQCbY")).customAutoformatPlugin),
            {
                autoformattingProvider: options.autoformattingProvider
            }
        ], Boolean((0, (0, parcelRequire("5xDEh")).is1pSmartLinkUnfurlInPromptEditorEnabled)(options)));
        return preset;
    }
});
parcelRegister("g36b0", function(module, exports) {
    $parcel$export(module.exports, "analyticsPlugin", ()=>(parcelRequire("lsZ2i")).analyticsPlugin);
    var $lsZ2i;
});
parcelRegister("lsZ2i", function(module, exports) {
    $parcel$export(module.exports, "analyticsPlugin", ()=>$38b0cff75c831b25$export$f26023c5d4a5ab44);
    var $5uXOq = parcelRequire("5uXOq");
    var $8aY84;
    var $2NMNM;
    var $gkwXh;
    var $ctLRZ;
    var $J5Axj;
    var $b7gJe;
    var $ap7h6;
    var $5KWxh;
    var $bgfWv;
    var $fLgtE;
    var $8Zx8B;
    var $78yQH;
    function $38b0cff75c831b25$var$createPlugin(options, featureFlags) {
        if (!options) return;
        const hasRequiredPerformanceAPIs = (0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)();
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("8Zx8B")).analyticsPluginKey),
            state: {
                init: ()=>{
                    return {
                        ...options,
                        fireAnalytics: (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(options.createAnalyticsEvent)
                    };
                },
                apply: (tr, pluginState, _, state)=>{
                    const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, (0, parcelRequire("8Zx8B")).analyticsPluginKey)) ?? {};
                    if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                        ...pluginState,
                        createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                    };
                    if (featureFlags.catchAllTracking) {
                        const analyticsEventWithChannel = (0, (0, parcelRequire("J5Axj")).getAnalyticsEventsFromTransaction)(tr);
                        if (analyticsEventWithChannel.length > 0) {
                            for (const { payload: payload, channel: channel } of analyticsEventWithChannel)if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED && payload.action !== (0, (0, parcelRequire("gkwXh")).ACTION).DELETED) {
                                const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                                (0, (0, parcelRequire("ap7h6")).measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                    (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                        payload: $38b0cff75c831b25$export$a3e5fcfb76b37e49({
                                            payload: payload,
                                            duration: duration,
                                            distortedDuration: distortedDuration
                                        }),
                                        channel: channel
                                    });
                                });
                            }
                        }
                    }
                    return pluginState;
                }
            }
        });
    }
    const $38b0cff75c831b25$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
        const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
        const analyticsEventPropQueue = new Set();
        return {
            name: 'analytics',
            getSharedState: (editorState)=>{
                if (!editorState) return {
                    createAnalyticsEvent: null,
                    attachAnalyticsEvent: null,
                    performanceTracking: undefined
                };
                const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, (0, parcelRequire("8Zx8B")).analyticsPluginKey).getState(editorState) ?? {};
                return {
                    createAnalyticsEvent: createAnalyticsEvent,
                    attachAnalyticsEvent: (0, (0, parcelRequire("bgfWv")).createAttachPayloadIntoTransaction)(editorState.selection),
                    performanceTracking: performanceTracking
                };
            },
            actions: {
                attachAnalyticsEvent: (payload, channel = (0, (0, parcelRequire("fLgtE")).editorAnalyticsChannel))=>(tr)=>{
                        const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                        if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                            analyticsEventPropQueue.add({
                                payload: payload,
                                channel: channel
                            });
                            return false;
                        }
                        attachAnalyticsEvent({
                            tr: tr,
                            payload: payload,
                            channel: channel
                        });
                        return true;
                    },
                fireAnalyticsEvent: (payload, channel = (0, (0, parcelRequire("fLgtE")).editorAnalyticsChannel))=>{
                    const { createAnalyticsEvent: createAnalyticsEvent } = api?.analytics?.sharedState.currentState() ?? {};
                    if (!createAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload
                        });
                        return;
                    }
                    (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(createAnalyticsEvent)({
                        payload: payload,
                        channel: channel
                    });
                }
            },
            usePluginHook ({ editorView: editorView }) {
                const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
                (0, $5uXOq.useLayoutEffect)(()=>{
                    const { dispatch: dispatch, state: { tr: tr } } = editorView;
                    tr.setMeta((0, (0, parcelRequire("8Zx8B")).analyticsPluginKey), {
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                    dispatch(tr);
                    analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                        createAnalyticsEvent(payload)?.fire(channel ?? (0, (0, parcelRequire("fLgtE")).editorAnalyticsChannel));
                    });
                    analyticsEventPropQueue.clear();
                }, [
                    createAnalyticsEvent,
                    editorView
                ]);
            },
            pmPlugins () {
                return [
                    {
                        name: 'analyticsPlugin',
                        plugin: ()=>$38b0cff75c831b25$var$createPlugin(options, featureFlags)
                    }
                ];
            },
            onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
                const pluginState = (0, (0, parcelRequire("8Zx8B")).analyticsPluginKey).getState(newEditorState);
                if (!pluginState || !pluginState.createAnalyticsEvent) return;
                const steps = transactions.reduce((acc, tr)=>{
                    const payloads = tr.steps.filter((step)=>step instanceof (0, (0, parcelRequire("8aY84")).AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                    acc.push(...payloads);
                    return acc;
                }, []);
                if (steps.length === 0) return;
                const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
                const undoAnaltyicsEventTransformer = (0, (0, parcelRequire("78yQH")).generateUndoRedoInputSoucePayload)(originalTransaction);
                steps.forEach(({ payload: payload, channel: channel })=>{
                    const nextPayload = undoAnaltyicsEventTransformer(payload);
                    (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(createAnalyticsEvent)({
                        payload: nextPayload,
                        channel: channel
                    });
                });
            }
        };
    };
    function $38b0cff75c831b25$export$a3e5fcfb76b37e49({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
        return {
            ...payload,
            attributes: {
                ...payload.attributes,
                duration: duration,
                distortedDuration: distortedDuration
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
        };
    }
});
parcelRegister("bgfWv", function(module, exports) {
    $parcel$export(module.exports, "createAttachPayloadIntoTransaction", ()=>$70c38d4fb0ac5a50$export$539ce7f09649e93);
    var $8aY84;
    var $gkwXh;
    var $eMmNA;
    var $7D97R;
    const $70c38d4fb0ac5a50$var$actionsToIgnore = [
        (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
        (0, (0, parcelRequire("gkwXh")).ACTION).OPENED
    ];
    const $70c38d4fb0ac5a50$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$70c38d4fb0ac5a50$export$dff9776b7883fc5f({
                payload: payload,
                selection: selection,
                tr: tr,
                channel: channel
            });
    const $70c38d4fb0ac5a50$export$dff9776b7883fc5f = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
        payload = (0, (0, parcelRequire("eMmNA")).getStateContext)(selection, payload, tr);
        payload = (0, (0, parcelRequire("7D97R")).mapActionSubjectIdToAttributes)(payload);
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(selection.$from.pos, -1);
        tr.step(new (0, (0, parcelRequire("8aY84")).AnalyticsStep)([
            {
                payload: payload,
                channel: channel
            }
        ], $70c38d4fb0ac5a50$var$actionsToIgnore, pos));
        if (storedMarks) tr.setStoredMarks(storedMarks);
    };
});
parcelRegister("eMmNA", function(module, exports) {
    $parcel$export(module.exports, "getStateContext", ()=>$b2e7d92ac50916bf$export$b8d8bec4e31cbd66);
    var $gkwXh;
    var $7IaNe;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $hFEwm;
    function $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection) {
        let type;
        let position;
        if (selection?.constructor?.name === 'GapCursorSelection') {
            type = (0, (0, parcelRequire("7IaNe")).SELECTION_TYPE).GAP_CURSOR;
            position = selection.side;
        } else if (selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) type = (0, (0, parcelRequire("7IaNe")).SELECTION_TYPE).CELL;
        else if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) type = (0, (0, parcelRequire("7IaNe")).SELECTION_TYPE).NODE;
        else if (selection.from !== selection.to) type = (0, (0, parcelRequire("7IaNe")).SELECTION_TYPE).RANGED;
        else {
            type = (0, (0, parcelRequire("7IaNe")).SELECTION_TYPE).CURSOR;
            const { from: from, $from: $from } = selection;
            if (from === $from.start()) position = (0, (0, parcelRequire("7IaNe")).SELECTION_POSITION).START;
            else if (from === $from.end()) position = (0, (0, parcelRequire("7IaNe")).SELECTION_POSITION).END;
            else position = (0, (0, parcelRequire("7IaNe")).SELECTION_POSITION).MIDDLE;
        }
        return {
            type: type,
            position: position
        };
    }
    function $b2e7d92ac50916bf$export$d770b562ead089d8(selection) {
        const { schema: schema, name: name } = selection.$from.doc.type;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return selection.node.type.name;
        if (selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) return schema.nodes.table.name;
        const parentNodeInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
        return parentNodeInfo ? parentNodeInfo.node.type.name : name;
    }
    function $b2e7d92ac50916bf$export$46ac691122c4c55e(oldSelection, newSelection) {
        const { schema: schema } = newSelection.$from.doc.type;
        const { nodes: { paragraph: paragraph, table: table } } = schema;
        if (oldSelection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) return table.name;
        const insertLocationInfo = (0, $5r0mK.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
        let parentNodePos = newSelection.$from.doc.resolve(insertLocationInfo?.start || 0);
        while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newSelection.$from.doc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
        return parentNodePos.node().type.name;
    }
    function $b2e7d92ac50916bf$export$b8d8bec4e31cbd66(selection, payload, tr) {
        if (!payload.attributes) return payload;
        const { type: type, position: position } = $b2e7d92ac50916bf$export$ab5b04535d7a5950(selection);
        payload.attributes.selectionType = type;
        if (position) payload.attributes.selectionPosition = position;
        const insertLocation = $b2e7d92ac50916bf$export$d770b562ead089d8(selection);
        if (payload.action === (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED && payload.actionSubject !== (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).ANNOTATION) payload.attributes.insertedLocation = $b2e7d92ac50916bf$export$46ac691122c4c55e(selection, tr.selection);
        if (payload.action === (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED && payload.actionSubject === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT && payload.attributes) payload.attributes.insertLocation = insertLocation;
        else payload.attributes.nodeLocation = insertLocation;
        return payload;
    }
});
parcelRegister("7IaNe", function(module, exports) {
    $parcel$export(module.exports, "SELECTION_TYPE", ()=>$4f3bea2b77126b29$export$96527b3d022fe7df);
    $parcel$export(module.exports, "SELECTION_POSITION", ()=>$4f3bea2b77126b29$export$f64a96dc7664cbe5);
    var $4f3bea2b77126b29$export$96527b3d022fe7df;
    (function(SELECTION_TYPE) {
        SELECTION_TYPE["CURSOR"] = "cursor";
        SELECTION_TYPE["RANGED"] = "ranged";
        SELECTION_TYPE["TEXT"] = "text";
        SELECTION_TYPE["NODE"] = "node";
        SELECTION_TYPE["CELL"] = "cell";
        SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    })($4f3bea2b77126b29$export$96527b3d022fe7df || ($4f3bea2b77126b29$export$96527b3d022fe7df = {}));
    var $4f3bea2b77126b29$export$f64a96dc7664cbe5;
    (function(SELECTION_POSITION) {
        SELECTION_POSITION["START"] = "start";
        SELECTION_POSITION["MIDDLE"] = "middle";
        SELECTION_POSITION["END"] = "end";
        SELECTION_POSITION["LEFT"] = "left";
        SELECTION_POSITION["RIGHT"] = "right";
    })($4f3bea2b77126b29$export$f64a96dc7664cbe5 || ($4f3bea2b77126b29$export$f64a96dc7664cbe5 = {}));
});
parcelRegister("7D97R", function(module, exports) {
    $parcel$export(module.exports, "mapActionSubjectIdToAttributes", ()=>$4733c7621036df00$export$dd48e359ffe98e59);
    var $gkwXh;
    function $4733c7621036df00$export$dd48e359ffe98e59(payload) {
        const documentInserted = payload.action === (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED && payload.actionSubject === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT;
        const textFormatted = payload.action === (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED && payload.actionSubject === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT;
        const hasActionSubjectId = !!payload.actionSubjectId;
        if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
            ...payload.attributes,
            actionSubjectId: payload.actionSubjectId
        };
        return payload;
    }
});
parcelRegister("fLgtE", function(module, exports) {
    $parcel$export(module.exports, "editorAnalyticsChannel", ()=>$9fde11f34ce18b49$export$1467dbbb3bb418c6);
    var $dWAZk = parcelRequire("dWAZk");
    var $4NUlu;
    const $9fde11f34ce18b49$export$288273ee3e3b6132 = (0, (0, parcelRequire("4NUlu")).analyticsEventKey);
    const $9fde11f34ce18b49$export$1467dbbb3bb418c6 = (0, $dWAZk.FabricChannel).editor;
});
parcelRegister("8Zx8B", function(module, exports) {
    $parcel$export(module.exports, "analyticsPluginKey", ()=>$2b7c67819c225dd8$export$c4a4504e8a9a0b2e);
    var $gZGBX;
    const $2b7c67819c225dd8$export$c4a4504e8a9a0b2e = new (0, (0, parcelRequire("gZGBX")).PluginKey)('analyticsPlugin');
});
parcelRegister("78yQH", function(module, exports) {
    $parcel$export(module.exports, "generateUndoRedoInputSoucePayload", ()=>$bbad6368f6555977$export$67d130a769494b9b);
    const $bbad6368f6555977$var$getUndoRedoInputSource = (tr)=>{
        return tr.getMeta('undoRedoPlugin$') ?? null;
    };
    const $bbad6368f6555977$export$67d130a769494b9b = (tr)=>{
        const undoRedoPluginInputSource = $bbad6368f6555977$var$getUndoRedoInputSource(tr);
        return (payload)=>{
            const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
                'undid',
                'redid'
            ].includes(payload.action);
            return !shouldAddHistoryTriggerMethodAttribute ? payload : {
                ...payload,
                attributes: {
                    ...payload.attributes,
                    historyTriggerMethod: undoRedoPluginInputSource
                }
            };
        };
    };
});
parcelRegister("fxvTQ", function(module, exports) {
    $parcel$export(module.exports, "basePlugin", ()=>(parcelRequire("3ypvl")).default);
    var $3ypvl;
});
parcelRegister("3ypvl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$569429171be00b66$export$2e2bcd8739ae039);
    var $xjCuM;
    var $abme3;
    var $3DR6L;
    var $6cqU9;
    var $2RHbH;
    var $fZzhT;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $bTmyI;
    var $jhGvF;
    var $f6qgr;
    var $hzDkr;
    var $djY8Z;
    var $7Y3BJ;
    var $6qtBk;
    var $9BF1z;
    var $j4mzV;
    var $jvNn7;
    const $569429171be00b66$var$basePlugin = ({ config: options, api: api })=>{
        const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
        return {
            name: 'base',
            getSharedState (editorState) {
                return {
                    keyboardHeight: (0, (0, parcelRequire("9BF1z")).getKeyboardHeight)(editorState)
                };
            },
            actions: {
                setKeyboardHeight: (0, parcelRequire("bTmyI")).setKeyboardHeight
            },
            pmPlugins () {
                const plugins = [
                    {
                        name: 'filterStepsPlugin',
                        plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, (0, parcelRequire("f6qgr")).default)(dispatchAnalyticsEvent)
                    }
                ];
                if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', true, {
                    exposure: true
                })) plugins.push({
                    name: 'lazyNodeViewDecorationsPlugin',
                    plugin: ()=>(0, (0, parcelRequire("7Y3BJ")).createLazyNodeViewDecorationPlugin)()
                });
                plugins.push({
                    name: 'inlineCursorTargetPlugin',
                    plugin: ()=>options && options.allowInlineCursorTarget ? (0, (0, parcelRequire("djY8Z")).default)() : undefined
                });
                plugins.push({
                    name: 'newlinePreserveMarksPlugin',
                    plugin: (0, (0, parcelRequire("6qtBk")).default)
                }, {
                    name: 'frozenEditor',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return (0, (0, parcelRequire("hzDkr")).default)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, (0, parcelRequire("jvNn7")).inputTracking), undefined);
                    }
                }, {
                    name: 'history',
                    plugin: ()=>(0, (0, parcelRequire("fZzhT")).history)()
                }, {
                    name: 'codeBlockIndent',
                    plugin: ()=>(0, (0, parcelRequire("6cqU9")).keymap)({
                            ...(0, (0, parcelRequire("2RHbH")).baseKeymap),
                            'Mod-[': ()=>true,
                            'Mod-]': ()=>true
                        })
                });
                if (options && options.allowScrollGutter) {
                    if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_improved_scroll_gutter')) plugins.push({
                        name: 'scrollGutterPlugin',
                        plugin: ()=>(0, (0, parcelRequire("j4mzV")).default)(options.allowScrollGutter)
                    });
                    else plugins.push({
                        name: 'scrollGutterPlugin',
                        plugin: ()=>(0, (0, parcelRequire("9BF1z")).default)(options.allowScrollGutter)
                    });
                }
                plugins.push({
                    name: 'disableSpellcheckingPlugin',
                    plugin: ()=>(0, (0, parcelRequire("jhGvF")).default)(featureFlags)
                });
                return plugins;
            },
            nodes () {
                return [
                    {
                        name: 'doc',
                        node: (0, (0, parcelRequire("xjCuM")).doc)
                    },
                    {
                        name: 'paragraph',
                        node: (0, (0, parcelRequire("abme3")).paragraph)
                    },
                    {
                        name: 'text',
                        node: (0, (0, parcelRequire("3DR6L")).text)
                    }
                ];
            }
        };
    };
    var $569429171be00b66$export$2e2bcd8739ae039 = $569429171be00b66$var$basePlugin;
});
parcelRegister("6cqU9", function(module, exports) {
    $parcel$export(module.exports, "keymap", ()=>$22bfd21edb49568b$export$5043418e2ef368d5);
    var $1SLCf = parcelRequire("1SLCf");
    var $vWFRY;
    var $5KWxh;
    function $22bfd21edb49568b$export$5043418e2ef368d5(bindings) {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            props: {
                handleKeyDown (view, event) {
                    const name = (0, $1SLCf.keyName)(event);
                    let keyboardEvent = event;
                    const isModKeyPressed = event.ctrlKey || event.metaKey;
                    const isNonLatinKey = name.length === 1 && /[^\u0000-\u007f]/.test(name);
                    const isDeadKey = name === 'Dead';
                    if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                        key: (0, $1SLCf.base)[event.keyCode],
                        code: event.code,
                        ctrlKey: event.ctrlKey,
                        altKey: event.altKey,
                        metaKey: event.metaKey,
                        shiftKey: event.shiftKey
                    });
                    return (0, (0, parcelRequire("vWFRY")).keydownHandler)(bindings)(view, keyboardEvent);
                }
            }
        });
    }
});
parcelRegister("1SLCf", function(module, exports) {
    $parcel$export(module.exports, "base", ()=>$15efc51ab78bc228$export$e2253033e6e1df16);
    $parcel$export(module.exports, "keyName", ()=>$15efc51ab78bc228$export$fb33aafd75404f4c);
    var $15efc51ab78bc228$export$e2253033e6e1df16 = {
        8: "Backspace",
        9: "Tab",
        10: "Enter",
        12: "NumLock",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        44: "PrintScreen",
        45: "Insert",
        46: "Delete",
        59: ";",
        61: "=",
        91: "Meta",
        92: "Meta",
        106: "*",
        107: "+",
        108: ",",
        109: "-",
        110: ".",
        111: "/",
        144: "NumLock",
        145: "ScrollLock",
        160: "Shift",
        161: "Shift",
        162: "Control",
        163: "Control",
        164: "Alt",
        165: "Alt",
        173: "-",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'"
    };
    var $15efc51ab78bc228$export$fba63a578e423eb = {
        48: ")",
        49: "!",
        50: "@",
        51: "#",
        52: "$",
        53: "%",
        54: "^",
        55: "&",
        56: "*",
        57: "(",
        59: ":",
        61: "+",
        173: "_",
        186: ":",
        187: "+",
        188: "<",
        189: "_",
        190: ">",
        191: "?",
        192: "~",
        219: "{",
        220: "|",
        221: "}",
        222: "\""
    };
    var $15efc51ab78bc228$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
    var $15efc51ab78bc228$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    for(var $15efc51ab78bc228$var$i = 0; $15efc51ab78bc228$var$i < 10; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[48 + $15efc51ab78bc228$var$i] = $15efc51ab78bc228$export$e2253033e6e1df16[96 + $15efc51ab78bc228$var$i] = String($15efc51ab78bc228$var$i);
    for(var $15efc51ab78bc228$var$i = 1; $15efc51ab78bc228$var$i <= 24; $15efc51ab78bc228$var$i++)$15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i + 111] = "F" + $15efc51ab78bc228$var$i;
    for(var $15efc51ab78bc228$var$i = 65; $15efc51ab78bc228$var$i <= 90; $15efc51ab78bc228$var$i++){
        $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i + 32);
        $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$i] = String.fromCharCode($15efc51ab78bc228$var$i);
    }
    for(var $15efc51ab78bc228$var$code in $15efc51ab78bc228$export$e2253033e6e1df16)if (!$15efc51ab78bc228$export$fba63a578e423eb.hasOwnProperty($15efc51ab78bc228$var$code)) $15efc51ab78bc228$export$fba63a578e423eb[$15efc51ab78bc228$var$code] = $15efc51ab78bc228$export$e2253033e6e1df16[$15efc51ab78bc228$var$code];
    function $15efc51ab78bc228$export$fb33aafd75404f4c(event) {
        var ignoreKey = $15efc51ab78bc228$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $15efc51ab78bc228$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
        var name = !ignoreKey && event.key || (event.shiftKey ? $15efc51ab78bc228$export$fba63a578e423eb : $15efc51ab78bc228$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
        if (name == "Esc") name = "Escape";
        if (name == "Del") name = "Delete";
        if (name == "Left") name = "ArrowLeft";
        if (name == "Up") name = "ArrowUp";
        if (name == "Right") name = "ArrowRight";
        if (name == "Down") name = "ArrowDown";
        return name;
    }
});
parcelRegister("vWFRY", function(module, exports) {
    $parcel$export(module.exports, "keymap", ()=>$060068dc8add2821$export$5043418e2ef368d5);
    $parcel$export(module.exports, "keydownHandler", ()=>$060068dc8add2821$export$53f558754f8b9fd1);
    var $1SLCf = parcelRequire("1SLCf");
    var $gZGBX;
    const $060068dc8add2821$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
    function $060068dc8add2821$var$normalizeKeyName(name) {
        let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
        if (result == "Space") result = " ";
        let alt, ctrl, shift, meta;
        for(let i = 0; i < parts.length - 1; i++){
            let mod = parts[i];
            if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
            else if (/^a(lt)?$/i.test(mod)) alt = true;
            else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
            else if (/^s(hift)?$/i.test(mod)) shift = true;
            else if (/^mod$/i.test(mod)) {
                if ($060068dc8add2821$var$mac) meta = true;
                else ctrl = true;
            } else throw new Error("Unrecognized modifier name: " + mod);
        }
        if (alt) result = "Alt-" + result;
        if (ctrl) result = "Ctrl-" + result;
        if (meta) result = "Meta-" + result;
        if (shift) result = "Shift-" + result;
        return result;
    }
    function $060068dc8add2821$var$normalize(map) {
        let copy = Object.create(null);
        for(let prop in map)copy[$060068dc8add2821$var$normalizeKeyName(prop)] = map[prop];
        return copy;
    }
    function $060068dc8add2821$var$modifiers(name, event, shift = true) {
        if (event.altKey) name = "Alt-" + name;
        if (event.ctrlKey) name = "Ctrl-" + name;
        if (event.metaKey) name = "Meta-" + name;
        if (shift && event.shiftKey) name = "Shift-" + name;
        return name;
    }
    function $060068dc8add2821$export$5043418e2ef368d5(bindings) {
        return new (0, (0, parcelRequire("gZGBX")).Plugin)({
            props: {
                handleKeyDown: $060068dc8add2821$export$53f558754f8b9fd1(bindings)
            }
        });
    }
    function $060068dc8add2821$export$53f558754f8b9fd1(bindings) {
        let map = $060068dc8add2821$var$normalize(bindings);
        return function(view, event) {
            let name = (0, $1SLCf.keyName)(event), baseName, direct = map[$060068dc8add2821$var$modifiers(name, event)];
            if (direct && direct(view.state, view.dispatch, view)) return true;
            if (name.length == 1 && name != " ") {
                if (event.shiftKey) {
                    let noShift = map[$060068dc8add2821$var$modifiers(name, event, false)];
                    if (noShift && noShift(view.state, view.dispatch, view)) return true;
                }
                if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $1SLCf.base)[event.keyCode]) && baseName != name) {
                    let fromCode = map[$060068dc8add2821$var$modifiers(baseName, event)];
                    if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
                }
            }
            return false;
        };
    }
});
parcelRegister("2RHbH", function(module, exports) {
    $parcel$export(module.exports, "deleteSelection", ()=>$2162082cf5257878$export$e9a518a637d1e641);
    $parcel$export(module.exports, "selectNodeBackward", ()=>$2162082cf5257878$export$52b8a4af68d19794);
    $parcel$export(module.exports, "createParagraphNear", ()=>$2162082cf5257878$export$d0f80ac1b4510888);
    $parcel$export(module.exports, "splitBlock", ()=>$2162082cf5257878$export$e99155638ff4dff0);
    $parcel$export(module.exports, "toggleMark", ()=>$2162082cf5257878$export$797ad2667b8015a8);
    $parcel$export(module.exports, "autoJoin", ()=>$2162082cf5257878$export$29903073afddcd8b);
    $parcel$export(module.exports, "chainCommands", ()=>$2162082cf5257878$export$146a774cdef7663a);
    $parcel$export(module.exports, "baseKeymap", ()=>$2162082cf5257878$export$4a0c2b85b1f0a889);
    var $eS2Dn;
    var $kCV8T;
    var $gZGBX;
    const $2162082cf5257878$export$e9a518a637d1e641 = (state, dispatch)=>{
        if (state.selection.empty) return false;
        if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
        return true;
    };
    function $2162082cf5257878$var$atBlockStart(state, view) {
        let { $cursor: $cursor } = state.selection;
        if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
        return $cursor;
    }
    const $2162082cf5257878$export$979097b097459299 = (state, dispatch, view)=>{
        let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
        if (!$cursor) return false;
        let $cut = $2162082cf5257878$var$findCutBefore($cursor);
        if (!$cut) {
            let range = $cursor.blockRange(), target = range && (0, (0, parcelRequire("eS2Dn")).liftTarget)(range);
            if (target == null) return false;
            if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
            return true;
        }
        let before = $cut.nodeBefore;
        if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
        if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(before, "end") || (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
            let delStep = (0, (0, parcelRequire("eS2Dn")).replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, (0, parcelRequire("kCV8T")).Slice).empty);
            if (delStep && delStep.slice.size < delStep.to - delStep.from) {
                if (dispatch) {
                    let tr = state.tr.step(delStep);
                    tr.setSelection($2162082cf5257878$var$textblockAt(before, "end") ? (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
        }
        if (before.isAtom && $cut.depth == $cursor.depth - 1) {
            if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
            return true;
        }
        return false;
    };
    const $2162082cf5257878$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
        let $cursor = $2162082cf5257878$var$atBlockStart(state, view);
        if (!$cursor) return false;
        let $cut = $2162082cf5257878$var$findCutBefore($cursor);
        return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
    };
    const $2162082cf5257878$export$e796bb96d22be2cd = (state, dispatch, view)=>{
        let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
        if (!$cursor) return false;
        let $cut = $2162082cf5257878$var$findCutAfter($cursor);
        return $cut ? $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) : false;
    };
    function $2162082cf5257878$var$joinTextblocksAround(state, $cut, dispatch) {
        let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
        for(; !beforeText.isTextblock; beforePos--){
            if (beforeText.type.spec.isolating) return false;
            let child = beforeText.lastChild;
            if (!child) return false;
            beforeText = child;
        }
        let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
        for(; !afterText.isTextblock; afterPos++){
            if (afterText.type.spec.isolating) return false;
            let child = afterText.firstChild;
            if (!child) return false;
            afterText = child;
        }
        let step = (0, (0, parcelRequire("eS2Dn")).replaceStep)(state.doc, beforePos, afterPos, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        if (!step || step.from != beforePos || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
        if (dispatch) {
            let tr = state.tr.step(step);
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, beforePos));
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    function $2162082cf5257878$var$textblockAt(node, side, only = false) {
        for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
            if (scan.isTextblock) return true;
            if (only && scan.childCount != 1) return false;
        }
        return false;
    }
    const $2162082cf5257878$export$52b8a4af68d19794 = (state, dispatch, view)=>{
        let { $head: $head, empty: empty } = state.selection, $cut = $head;
        if (!empty) return false;
        if ($head.parent.isTextblock) {
            if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
            $cut = $2162082cf5257878$var$findCutBefore($head);
        }
        let node = $cut && $cut.nodeBefore;
        if (!node || !(0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
        return true;
    };
    function $2162082cf5257878$var$findCutBefore($pos) {
        if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
            if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
            if ($pos.node(i).type.spec.isolating) break;
        }
        return null;
    }
    function $2162082cf5257878$var$atBlockEnd(state, view) {
        let { $cursor: $cursor } = state.selection;
        if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
        return $cursor;
    }
    const $2162082cf5257878$export$bf432e340007f9ef = (state, dispatch, view)=>{
        let $cursor = $2162082cf5257878$var$atBlockEnd(state, view);
        if (!$cursor) return false;
        let $cut = $2162082cf5257878$var$findCutAfter($cursor);
        if (!$cut) return false;
        let after = $cut.nodeAfter;
        if ($2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
        if ($cursor.parent.content.size == 0 && ($2162082cf5257878$var$textblockAt(after, "start") || (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(after))) {
            let delStep = (0, (0, parcelRequire("eS2Dn")).replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, (0, parcelRequire("kCV8T")).Slice).empty);
            if (delStep && delStep.slice.size < delStep.to - delStep.from) {
                if (dispatch) {
                    let tr = state.tr.step(delStep);
                    tr.setSelection($2162082cf5257878$var$textblockAt(after, "start") ? (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
        }
        if (after.isAtom && $cut.depth == $cursor.depth - 1) {
            if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
            return true;
        }
        return false;
    };
    const $2162082cf5257878$export$5835b52680b80cfd = (state, dispatch, view)=>{
        let { $head: $head, empty: empty } = state.selection, $cut = $head;
        if (!empty) return false;
        if ($head.parent.isTextblock) {
            if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
            $cut = $2162082cf5257878$var$findCutAfter($head);
        }
        let node = $cut && $cut.nodeAfter;
        if (!node || !(0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
        return true;
    };
    function $2162082cf5257878$var$findCutAfter($pos) {
        if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
            let parent = $pos.node(i);
            if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
            if (parent.type.spec.isolating) break;
        }
        return null;
    }
    const $2162082cf5257878$export$4bb15e6d4372b393 = (state, dispatch)=>{
        let sel = state.selection, nodeSel = sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection), point;
        if (nodeSel) {
            if (sel.node.isTextblock || !(0, (0, parcelRequire("eS2Dn")).canJoin)(state.doc, sel.from)) return false;
            point = sel.from;
        } else {
            point = (0, (0, parcelRequire("eS2Dn")).joinPoint)(state.doc, sel.from, -1);
            if (point == null) return false;
        }
        if (dispatch) {
            let tr = state.tr.join(point);
            if (nodeSel) tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
    const $2162082cf5257878$export$8dd967a262b064bb = (state, dispatch)=>{
        let sel = state.selection, point;
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
            if (sel.node.isTextblock || !(0, (0, parcelRequire("eS2Dn")).canJoin)(state.doc, sel.to)) return false;
            point = sel.to;
        } else {
            point = (0, (0, parcelRequire("eS2Dn")).joinPoint)(state.doc, sel.to, 1);
            if (point == null) return false;
        }
        if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
        return true;
    };
    const $2162082cf5257878$export$590e8b2c435046d9 = (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), target = range && (0, (0, parcelRequire("eS2Dn")).liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    };
    const $2162082cf5257878$export$a5d02b4b65e94f91 = (state, dispatch)=>{
        let { $head: $head, $anchor: $anchor } = state.selection;
        if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
        if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
        return true;
    };
    function $2162082cf5257878$var$defaultBlockAt(match) {
        for(let i = 0; i < match.edgeCount; i++){
            let { type: type } = match.edge(i);
            if (type.isTextblock && !type.hasRequiredAttrs()) return type;
        }
        return null;
    }
    const $2162082cf5257878$export$634b78845598ff5b = (state, dispatch)=>{
        let { $head: $head, $anchor: $anchor } = state.selection;
        if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
        let above = $head.node(-1), after = $head.indexAfter(-1), type = $2162082cf5257878$var$defaultBlockAt(above.contentMatchAt(after));
        if (!type || !above.canReplaceWith(after, after, type)) return false;
        if (dispatch) {
            let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
            tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near(tr.doc.resolve(pos), 1));
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
    const $2162082cf5257878$export$d0f80ac1b4510888 = (state, dispatch)=>{
        let sel = state.selection, { $from: $from, $to: $to } = sel;
        if (sel instanceof (0, (0, parcelRequire("gZGBX")).AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
        let type = $2162082cf5257878$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
        if (!type || !type.isTextblock) return false;
        if (dispatch) {
            let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
            let tr = state.tr.insert(side, type.createAndFill());
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, side + 1));
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
    const $2162082cf5257878$export$a3574cc681852c08 = (state, dispatch)=>{
        let { $cursor: $cursor } = state.selection;
        if (!$cursor || $cursor.parent.content.size) return false;
        if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
            let before = $cursor.before();
            if ((0, (0, parcelRequire("eS2Dn")).canSplit)(state.doc, before)) {
                if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
                return true;
            }
        }
        let range = $cursor.blockRange(), target = range && (0, (0, parcelRequire("eS2Dn")).liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    };
    function $2162082cf5257878$export$8bf8350f33b1e5ab(splitNode) {
        return (state, dispatch)=>{
            let { $from: $from, $to: $to } = state.selection;
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node.isBlock) {
                if (!$from.parentOffset || !(0, (0, parcelRequire("eS2Dn")).canSplit)(state.doc, $from.pos)) return false;
                if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
                return true;
            }
            if (!$from.parent.isBlock) return false;
            if (dispatch) {
                let atEnd = $to.parentOffset == $to.parent.content.size;
                let tr = state.tr;
                if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) || state.selection instanceof (0, (0, parcelRequire("gZGBX")).AllSelection)) tr.deleteSelection();
                let deflt = $from.depth == 0 ? null : $2162082cf5257878$var$defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                let types = splitType ? [
                    splitType
                ] : atEnd && deflt ? [
                    {
                        type: deflt
                    }
                ] : undefined;
                let can = (0, (0, parcelRequire("eS2Dn")).canSplit)(tr.doc, tr.mapping.map($from.pos), 1, types);
                if (!types && !can && (0, (0, parcelRequire("eS2Dn")).canSplit)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
                    {
                        type: deflt
                    }
                ] : undefined)) {
                    if (deflt) types = [
                        {
                            type: deflt
                        }
                    ];
                    can = true;
                }
                if (can) {
                    tr.split(tr.mapping.map($from.pos), 1, types);
                    if (!atEnd && !$from.parentOffset && $from.parent.type != deflt) {
                        let first = tr.mapping.map($from.before()), $first = tr.doc.resolve(first);
                        if (deflt && $from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                    }
                }
                dispatch(tr.scrollIntoView());
            }
            return true;
        };
    }
    const $2162082cf5257878$export$e99155638ff4dff0 = $2162082cf5257878$export$8bf8350f33b1e5ab();
    const $2162082cf5257878$export$eeb429476568b72b = (state, dispatch)=>{
        return $2162082cf5257878$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
    const $2162082cf5257878$export$a37f6aaa9169911d = (state, dispatch)=>{
        let { $from: $from, to: to } = state.selection, pos;
        let same = $from.sharedDepth(to);
        if (same == 0) return false;
        pos = $from.before(same);
        if (dispatch) dispatch(state.tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, pos)));
        return true;
    };
    const $2162082cf5257878$export$90aca4adda6ff0f5 = (state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, (0, parcelRequire("gZGBX")).AllSelection)(state.doc)));
        return true;
    };
    function $2162082cf5257878$var$joinMaybeClear(state, $pos, dispatch) {
        let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
        if (!before || !after || !before.type.compatibleContent(after.type)) return false;
        if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
            if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
            return true;
        }
        if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, (0, parcelRequire("eS2Dn")).canJoin)(state.doc, $pos.pos))) return false;
        if (dispatch) dispatch(state.tr.clearIncompatible($pos.pos, before.type, before.contentMatchAt(before.childCount)).join($pos.pos).scrollIntoView());
        return true;
    }
    function $2162082cf5257878$var$deleteBarrier(state, $cut, dispatch, dir) {
        let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
        let isolated = before.type.spec.isolating || after.type.spec.isolating;
        if (!isolated && $2162082cf5257878$var$joinMaybeClear(state, $cut, dispatch)) return true;
        let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
        if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
            if (dispatch) {
                let end = $cut.pos + after.nodeSize, wrap = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                for(let i = conn.length - 1; i >= 0; i--)wrap = (0, (0, parcelRequire("kCV8T")).Fragment).from(conn[i].create(null, wrap));
                wrap = (0, (0, parcelRequire("kCV8T")).Fragment).from(before.copy(wrap));
                let tr = state.tr.step(new (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, (0, parcelRequire("kCV8T")).Slice)(wrap, 1, 0), conn.length, true));
                let joinAt = end + 2 * conn.length;
                if ((0, (0, parcelRequire("eS2Dn")).canJoin)(tr.doc, joinAt)) tr.join(joinAt);
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, (0, parcelRequire("gZGBX")).Selection).findFrom($cut, 1);
        let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, (0, parcelRequire("eS2Dn")).liftTarget)(range);
        if (target != null && target >= $cut.depth) {
            if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
            return true;
        }
        if (canDelAfter && $2162082cf5257878$var$textblockAt(after, "start", true) && $2162082cf5257878$var$textblockAt(before, "end")) {
            let at = before, wrap = [];
            for(;;){
                wrap.push(at);
                if (at.isTextblock) break;
                at = at.lastChild;
            }
            let afterText = after, afterDepth = 1;
            for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
            if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
                if (dispatch) {
                    let end = (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                    for(let i = wrap.length - 1; i >= 0; i--)end = (0, (0, parcelRequire("kCV8T")).Fragment).from(wrap[i].copy(end));
                    let tr = state.tr.step(new (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, (0, parcelRequire("kCV8T")).Slice)(end, wrap.length, 0), 0, true));
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
        }
        return false;
    }
    function $2162082cf5257878$var$selectTextblockSide(side) {
        return function(state, dispatch) {
            let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
            let depth = $pos.depth;
            while($pos.node(depth).isInline){
                if (!depth) return false;
                depth--;
            }
            if (!$pos.node(depth).isTextblock) return false;
            if (dispatch) dispatch(state.tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
            return true;
        };
    }
    const $2162082cf5257878$export$c3a64f3c9604a1b1 = $2162082cf5257878$var$selectTextblockSide(-1);
    const $2162082cf5257878$export$a66c1876556415e5 = $2162082cf5257878$var$selectTextblockSide(1);
    function $2162082cf5257878$export$6e5e3c49755affd0(nodeType, attrs = null) {
        return function(state, dispatch) {
            let { $from: $from, $to: $to } = state.selection;
            let range = $from.blockRange($to), wrapping = range && (0, (0, parcelRequire("eS2Dn")).findWrapping)(range, nodeType, attrs);
            if (!wrapping) return false;
            if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
            return true;
        };
    }
    function $2162082cf5257878$export$36987f561c736aad(nodeType, attrs = null) {
        return function(state, dispatch) {
            let applicable = false;
            for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    if (applicable) return false;
                    if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                    if (node.type == nodeType) applicable = true;
                    else {
                        let $pos = state.doc.resolve(pos), index = $pos.index();
                        applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                    }
                });
            }
            if (!applicable) return false;
            if (dispatch) {
                let tr = state.tr;
                for(let i = 0; i < state.selection.ranges.length; i++){
                    let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                    tr.setBlockType(from, to, nodeType, attrs);
                }
                dispatch(tr.scrollIntoView());
            }
            return true;
        };
    }
    function $2162082cf5257878$var$markApplies(doc, ranges, type, enterAtoms) {
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i];
            let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
            doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
                can = node.inlineContent && node.type.allowsMarkType(type);
            });
            if (can) return true;
        }
        return false;
    }
    function $2162082cf5257878$var$removeInlineAtoms(ranges) {
        let result = [];
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i];
            $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                    if (pos + 1 > $from.pos) result.push(new (0, (0, parcelRequire("gZGBX")).SelectionRange)($from, $from.doc.resolve(pos + 1)));
                    $from = $from.doc.resolve(pos + 1 + node.content.size);
                    return false;
                }
            });
            if ($from.pos < $to.pos) result.push(new (0, (0, parcelRequire("gZGBX")).SelectionRange)($from, $to));
        }
        return result;
    }
    function $2162082cf5257878$export$797ad2667b8015a8(markType, attrs = null, options) {
        let removeWhenPresent = (options && options.removeWhenPresent) !== false;
        let enterAtoms = (options && options.enterInlineAtoms) !== false;
        return function(state, dispatch) {
            let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
            if (empty && !$cursor || !$2162082cf5257878$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
            if (dispatch) {
                if ($cursor) {
                    if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                    else dispatch(state.tr.addStoredMark(markType.create(attrs)));
                } else {
                    let add, tr = state.tr;
                    if (!enterAtoms) ranges = $2162082cf5257878$var$removeInlineAtoms(ranges);
                    if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                    else add = !ranges.every((r)=>{
                        let missing = false;
                        tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                            if (missing) return false;
                            missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                        });
                        return !missing;
                    });
                    for(let i = 0; i < ranges.length; i++){
                        let { $from: $from, $to: $to } = ranges[i];
                        if (!add) tr.removeMark($from.pos, $to.pos, markType);
                        else {
                            let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                            let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                            let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                            if (from + spaceStart < to) {
                                from += spaceStart;
                                to -= spaceEnd;
                            }
                            tr.addMark(from, to, markType.create(attrs));
                        }
                    }
                    dispatch(tr.scrollIntoView());
                }
            }
            return true;
        };
    }
    function $2162082cf5257878$var$wrapDispatchForJoin(dispatch, isJoinable) {
        return (tr)=>{
            if (!tr.isGeneric) return dispatch(tr);
            let ranges = [];
            for(let i = 0; i < tr.mapping.maps.length; i++){
                let map = tr.mapping.maps[i];
                for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
                map.forEach((_s, _e, from, to)=>ranges.push(from, to));
            }
            let joinable = [];
            for(let i = 0; i < ranges.length; i += 2){
                let from = ranges[i], to = ranges[i + 1];
                let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
                for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                    let after = parent.maybeChild(index);
                    if (!after) break;
                    if (index && joinable.indexOf(pos) == -1) {
                        let before = parent.child(index - 1);
                        if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                    }
                    pos += after.nodeSize;
                }
            }
            joinable.sort((a, b)=>a - b);
            for(let i = joinable.length - 1; i >= 0; i--)if ((0, (0, parcelRequire("eS2Dn")).canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
            dispatch(tr);
        };
    }
    function $2162082cf5257878$export$29903073afddcd8b(command, isJoinable) {
        let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
        return (state, dispatch, view)=>command(state, dispatch && $2162082cf5257878$var$wrapDispatchForJoin(dispatch, canJoin), view);
    }
    function $2162082cf5257878$export$146a774cdef7663a(...commands) {
        return function(state, dispatch, view) {
            for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
            return false;
        };
    }
    let $2162082cf5257878$var$backspace = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$979097b097459299, $2162082cf5257878$export$52b8a4af68d19794);
    let $2162082cf5257878$var$del = $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$e9a518a637d1e641, $2162082cf5257878$export$bf432e340007f9ef, $2162082cf5257878$export$5835b52680b80cfd);
    const $2162082cf5257878$export$eb36e8971b04df36 = {
        "Enter": $2162082cf5257878$export$146a774cdef7663a($2162082cf5257878$export$a5d02b4b65e94f91, $2162082cf5257878$export$d0f80ac1b4510888, $2162082cf5257878$export$a3574cc681852c08, $2162082cf5257878$export$e99155638ff4dff0),
        "Mod-Enter": $2162082cf5257878$export$634b78845598ff5b,
        "Backspace": $2162082cf5257878$var$backspace,
        "Mod-Backspace": $2162082cf5257878$var$backspace,
        "Shift-Backspace": $2162082cf5257878$var$backspace,
        "Delete": $2162082cf5257878$var$del,
        "Mod-Delete": $2162082cf5257878$var$del,
        "Mod-a": $2162082cf5257878$export$90aca4adda6ff0f5
    };
    const $2162082cf5257878$export$f292ad8dbd5063c8 = {
        "Ctrl-h": $2162082cf5257878$export$eb36e8971b04df36["Backspace"],
        "Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Backspace"],
        "Ctrl-d": $2162082cf5257878$export$eb36e8971b04df36["Delete"],
        "Ctrl-Alt-Backspace": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
        "Alt-Delete": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
        "Alt-d": $2162082cf5257878$export$eb36e8971b04df36["Mod-Delete"],
        "Ctrl-a": $2162082cf5257878$export$c3a64f3c9604a1b1,
        "Ctrl-e": $2162082cf5257878$export$a66c1876556415e5
    };
    for(let key in $2162082cf5257878$export$eb36e8971b04df36)$2162082cf5257878$export$f292ad8dbd5063c8[key] = $2162082cf5257878$export$eb36e8971b04df36[key];
    const $2162082cf5257878$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
    const $2162082cf5257878$export$4a0c2b85b1f0a889 = $2162082cf5257878$var$mac ? $2162082cf5257878$export$f292ad8dbd5063c8 : $2162082cf5257878$export$eb36e8971b04df36;
});
parcelRegister("fZzhT", function(module, exports) {
    $parcel$export(module.exports, "closeHistory", ()=>$ba47ece1f7bbc51a$export$181a649d919c589e);
    $parcel$export(module.exports, "history", ()=>$ba47ece1f7bbc51a$export$55abd4691b317664);
    $parcel$export(module.exports, "undo", ()=>$ba47ece1f7bbc51a$export$21f930c44940fd98);
    $parcel$export(module.exports, "redo", ()=>$ba47ece1f7bbc51a$export$1688e416fee0a49e);
    var $9fCT4 = parcelRequire("9fCT4");
    var $eS2Dn;
    var $gZGBX;
    const $ba47ece1f7bbc51a$var$max_empty_items = 500;
    class $ba47ece1f7bbc51a$var$Branch {
        constructor(items, eventCount){
            this.items = items;
            this.eventCount = eventCount;
        }
        popEvent(state, preserveItems) {
            if (this.eventCount == 0) return null;
            let end = this.items.length;
            for(;; end--){
                let next = this.items.get(end - 1);
                if (next.selection) {
                    --end;
                    break;
                }
            }
            let remap, mapFrom;
            if (preserveItems) {
                remap = this.remapping(end, this.items.length);
                mapFrom = remap.maps.length;
            }
            let transform = state.tr;
            let selection, remaining;
            let addAfter = [], addBefore = [];
            this.items.forEach((item, i)=>{
                if (!item.step) {
                    if (!remap) {
                        remap = this.remapping(end, i + 1);
                        mapFrom = remap.maps.length;
                    }
                    mapFrom--;
                    addBefore.push(item);
                    return;
                }
                if (remap) {
                    addBefore.push(new $ba47ece1f7bbc51a$var$Item(item.map));
                    let step = item.step.map(remap.slice(mapFrom)), map;
                    if (step && transform.maybeStep(step).doc) {
                        map = transform.mapping.maps[transform.mapping.maps.length - 1];
                        addAfter.push(new $ba47ece1f7bbc51a$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                    }
                    mapFrom--;
                    if (map) remap.appendMap(map, mapFrom);
                } else transform.maybeStep(item.step);
                if (item.selection) {
                    selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                    remaining = new $ba47ece1f7bbc51a$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                    return false;
                }
            }, this.items.length, 0);
            return {
                remaining: remaining,
                transform: transform,
                selection: selection
            };
        }
        addTransform(transform, selection, histOptions, preserveItems) {
            let newItems = [], eventCount = this.eventCount;
            let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
            for(let i = 0; i < transform.steps.length; i++){
                let step = transform.steps[i].invert(transform.docs[i]);
                let item = new $ba47ece1f7bbc51a$var$Item(transform.mapping.maps[i], step, selection), merged;
                if (merged = lastItem && lastItem.merge(item)) {
                    item = merged;
                    if (i) newItems.pop();
                    else oldItems = oldItems.slice(0, oldItems.length - 1);
                }
                newItems.push(item);
                if (selection) {
                    eventCount++;
                    selection = undefined;
                }
                if (!preserveItems) lastItem = item;
            }
            let overflow = eventCount - histOptions.depth;
            if (overflow > $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW) {
                oldItems = $ba47ece1f7bbc51a$var$cutOffEvents(oldItems, overflow);
                eventCount -= overflow;
            }
            return new $ba47ece1f7bbc51a$var$Branch(oldItems.append(newItems), eventCount);
        }
        remapping(from, to) {
            let maps = new (0, (0, parcelRequire("eS2Dn")).Mapping);
            this.items.forEach((item, i)=>{
                let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
                maps.appendMap(item.map, mirrorPos);
            }, from, to);
            return maps;
        }
        addMaps(array) {
            if (this.eventCount == 0) return this;
            return new $ba47ece1f7bbc51a$var$Branch(this.items.append(array.map((map)=>new $ba47ece1f7bbc51a$var$Item(map))), this.eventCount);
        }
        rebased(rebasedTransform, rebasedCount) {
            if (!this.eventCount) return this;
            let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
            let mapping = rebasedTransform.mapping;
            let newUntil = rebasedTransform.steps.length;
            let eventCount = this.eventCount;
            this.items.forEach((item)=>{
                if (item.selection) eventCount--;
            }, start);
            let iRebased = rebasedCount;
            this.items.forEach((item)=>{
                let pos = mapping.getMirror(--iRebased);
                if (pos == null) return;
                newUntil = Math.min(newUntil, pos);
                let map = mapping.maps[pos];
                if (item.step) {
                    let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                    let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                    if (selection) eventCount++;
                    rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map, step, selection));
                } else rebasedItems.push(new $ba47ece1f7bbc51a$var$Item(map));
            }, start);
            let newMaps = [];
            for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $ba47ece1f7bbc51a$var$Item(mapping.maps[i]));
            let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
            let branch = new $ba47ece1f7bbc51a$var$Branch(items, eventCount);
            if (branch.emptyItemCount() > $ba47ece1f7bbc51a$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
            return branch;
        }
        emptyItemCount() {
            let count = 0;
            this.items.forEach((item)=>{
                if (!item.step) count++;
            });
            return count;
        }
        compress(upto = this.items.length) {
            let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
            let items = [], events = 0;
            this.items.forEach((item, i)=>{
                if (i >= upto) {
                    items.push(item);
                    if (item.selection) events++;
                } else if (item.step) {
                    let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                    mapFrom--;
                    if (map) remap.appendMap(map, mapFrom);
                    if (step) {
                        let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                        if (selection) events++;
                        let newItem = new $ba47ece1f7bbc51a$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                        if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                        else items.push(newItem);
                    }
                } else if (item.map) mapFrom--;
            }, this.items.length, 0);
            return new $ba47ece1f7bbc51a$var$Branch((0, $9fCT4.default).from(items.reverse()), events);
        }
    }
    $ba47ece1f7bbc51a$var$Branch.empty = new $ba47ece1f7bbc51a$var$Branch((0, $9fCT4.default).empty, 0);
    function $ba47ece1f7bbc51a$var$cutOffEvents(items, n) {
        let cutPoint;
        items.forEach((item, i)=>{
            if (item.selection && n-- == 0) {
                cutPoint = i;
                return false;
            }
        });
        return items.slice(cutPoint);
    }
    class $ba47ece1f7bbc51a$var$Item {
        constructor(map, step, selection, mirrorOffset){
            this.map = map;
            this.step = step;
            this.selection = selection;
            this.mirrorOffset = mirrorOffset;
        }
        merge(other) {
            if (this.step && other.step && !other.selection) {
                let step = other.step.merge(this.step);
                if (step) return new $ba47ece1f7bbc51a$var$Item(step.getMap().invert(), step, this.selection);
            }
        }
    }
    class $ba47ece1f7bbc51a$var$HistoryState {
        constructor(done, undone, prevRanges, prevTime, prevComposition){
            this.done = done;
            this.undone = undone;
            this.prevRanges = prevRanges;
            this.prevTime = prevTime;
            this.prevComposition = prevComposition;
        }
    }
    const $ba47ece1f7bbc51a$var$DEPTH_OVERFLOW = 20;
    function $ba47ece1f7bbc51a$var$applyTransaction(history, state, tr, options) {
        let historyTr = tr.getMeta($ba47ece1f7bbc51a$var$historyKey), rebased;
        if (historyTr) return historyTr.historyState;
        if (tr.getMeta($ba47ece1f7bbc51a$var$closeHistoryKey)) history = new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone, null, 0, -1);
        let appended = tr.getMeta("appendedTransaction");
        if (tr.steps.length == 0) return history;
        else if (appended && appended.getMeta($ba47ece1f7bbc51a$var$historyKey)) {
            if (appended.getMeta($ba47ece1f7bbc51a$var$historyKey).redo) return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), history.undone, $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
            else return new $ba47ece1f7bbc51a$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
        } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
            let composition = tr.getMeta("composition");
            let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$ba47ece1f7bbc51a$var$isAdjacentTo(tr, history.prevRanges));
            let prevRanges = appended ? $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping) : $ba47ece1f7bbc51a$var$rangesFor(tr.mapping.maps);
            return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $ba47ece1f7bbc51a$var$mustPreserveItems(state)), $ba47ece1f7bbc51a$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
        } else if (rebased = tr.getMeta("rebased")) return new $ba47ece1f7bbc51a$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
        else return new $ba47ece1f7bbc51a$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $ba47ece1f7bbc51a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    }
    function $ba47ece1f7bbc51a$var$isAdjacentTo(transform, prevRanges) {
        if (!prevRanges) return false;
        if (!transform.docChanged) return true;
        let adjacent = false;
        transform.mapping.maps[0].forEach((start, end)=>{
            for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
        });
        return adjacent;
    }
    function $ba47ece1f7bbc51a$var$rangesFor(maps) {
        let result = [];
        for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
        return result;
    }
    function $ba47ece1f7bbc51a$var$mapRanges(ranges, mapping) {
        if (!ranges) return null;
        let result = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
            if (from <= to) result.push(from, to);
        }
        return result;
    }
    function $ba47ece1f7bbc51a$var$histTransaction(history, state, redo) {
        let preserveItems = $ba47ece1f7bbc51a$var$mustPreserveItems(state);
        let histOptions = $ba47ece1f7bbc51a$var$historyKey.get(state).spec.config;
        let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
        if (!pop) return null;
        let selection = pop.selection.resolve(pop.transform.doc);
        let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
        let newHist = new $ba47ece1f7bbc51a$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
        return pop.transform.setSelection(selection).setMeta($ba47ece1f7bbc51a$var$historyKey, {
            redo: redo,
            historyState: newHist
        });
    }
    let $ba47ece1f7bbc51a$var$cachedPreserveItems = false, $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = null;
    function $ba47ece1f7bbc51a$var$mustPreserveItems(state) {
        let plugins = state.plugins;
        if ($ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins != plugins) {
            $ba47ece1f7bbc51a$var$cachedPreserveItems = false;
            $ba47ece1f7bbc51a$var$cachedPreserveItemsPlugins = plugins;
            for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
                $ba47ece1f7bbc51a$var$cachedPreserveItems = true;
                break;
            }
        }
        return $ba47ece1f7bbc51a$var$cachedPreserveItems;
    }
    function $ba47ece1f7bbc51a$export$181a649d919c589e(tr) {
        return tr.setMeta($ba47ece1f7bbc51a$var$closeHistoryKey, true);
    }
    const $ba47ece1f7bbc51a$var$historyKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)("history");
    const $ba47ece1f7bbc51a$var$closeHistoryKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)("closeHistory");
    function $ba47ece1f7bbc51a$export$55abd4691b317664(config = {}) {
        config = {
            depth: config.depth || 100,
            newGroupDelay: config.newGroupDelay || 500
        };
        return new (0, (0, parcelRequire("gZGBX")).Plugin)({
            key: $ba47ece1f7bbc51a$var$historyKey,
            state: {
                init () {
                    return new $ba47ece1f7bbc51a$var$HistoryState($ba47ece1f7bbc51a$var$Branch.empty, $ba47ece1f7bbc51a$var$Branch.empty, null, 0, -1);
                },
                apply (tr, hist, state) {
                    return $ba47ece1f7bbc51a$var$applyTransaction(hist, state, tr, config);
                }
            },
            config: config,
            props: {
                handleDOMEvents: {
                    beforeinput (view, e) {
                        let inputType = e.inputType;
                        let command = inputType == "historyUndo" ? $ba47ece1f7bbc51a$export$21f930c44940fd98 : inputType == "historyRedo" ? $ba47ece1f7bbc51a$export$1688e416fee0a49e : null;
                        if (!command) return false;
                        e.preventDefault();
                        return command(view.state, view.dispatch);
                    }
                }
            }
        });
    }
    function $ba47ece1f7bbc51a$var$buildCommand(redo, scroll) {
        return (state, dispatch)=>{
            let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
            if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
            if (dispatch) {
                let tr = $ba47ece1f7bbc51a$var$histTransaction(hist, state, redo);
                if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
            }
            return true;
        };
    }
    const $ba47ece1f7bbc51a$export$21f930c44940fd98 = $ba47ece1f7bbc51a$var$buildCommand(false, true);
    const $ba47ece1f7bbc51a$export$1688e416fee0a49e = $ba47ece1f7bbc51a$var$buildCommand(true, true);
    const $ba47ece1f7bbc51a$export$24b5d280435f3a3f = $ba47ece1f7bbc51a$var$buildCommand(false, false);
    const $ba47ece1f7bbc51a$export$3774e54bae7be19b = $ba47ece1f7bbc51a$var$buildCommand(true, false);
    function $ba47ece1f7bbc51a$export$f8a176c2b9a10bdb(state) {
        let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
        return hist ? hist.done.eventCount : 0;
    }
    function $ba47ece1f7bbc51a$export$3ffe6b288e7d941b(state) {
        let hist = $ba47ece1f7bbc51a$var$historyKey.getState(state);
        return hist ? hist.undone.eventCount : 0;
    }
});
parcelRegister("9fCT4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bc3adfda0d77c81$export$2e2bcd8739ae039);
    var $6bc3adfda0d77c81$var$GOOD_LEAF_SIZE = 200;
    var $6bc3adfda0d77c81$var$RopeSequence = function RopeSequence() {};
    $6bc3adfda0d77c81$var$RopeSequence.prototype.append = function append(other) {
        if (!other.length) return this;
        other = $6bc3adfda0d77c81$var$RopeSequence.from(other);
        return !this.length && other || other.length < $6bc3adfda0d77c81$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $6bc3adfda0d77c81$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.prepend = function prepend(other) {
        if (!other.length) return this;
        return $6bc3adfda0d77c81$var$RopeSequence.from(other).append(this);
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.appendInner = function appendInner(other) {
        return new $6bc3adfda0d77c81$var$Append(this, other);
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.slice = function slice(from, to) {
        if (from === void 0) from = 0;
        if (to === void 0) to = this.length;
        if (from >= to) return $6bc3adfda0d77c81$var$RopeSequence.empty;
        return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.get = function get(i) {
        if (i < 0 || i >= this.length) return undefined;
        return this.getInner(i);
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
        if (from === void 0) from = 0;
        if (to === void 0) to = this.length;
        if (from <= to) this.forEachInner(f, from, to, 0);
        else this.forEachInvertedInner(f, from, to, 0);
    };
    $6bc3adfda0d77c81$var$RopeSequence.prototype.map = function map(f, from, to) {
        if (from === void 0) from = 0;
        if (to === void 0) to = this.length;
        var result = [];
        this.forEach(function(elt, i) {
            return result.push(f(elt, i));
        }, from, to);
        return result;
    };
    $6bc3adfda0d77c81$var$RopeSequence.from = function from(values) {
        if (values instanceof $6bc3adfda0d77c81$var$RopeSequence) return values;
        return values && values.length ? new $6bc3adfda0d77c81$var$Leaf(values) : $6bc3adfda0d77c81$var$RopeSequence.empty;
    };
    var $6bc3adfda0d77c81$var$Leaf = function(RopeSequence) {
        function Leaf(values) {
            RopeSequence.call(this);
            this.values = values;
        }
        if (RopeSequence) Leaf.__proto__ = RopeSequence;
        Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
        Leaf.prototype.constructor = Leaf;
        var prototypeAccessors = {
            length: {
                configurable: true
            },
            depth: {
                configurable: true
            }
        };
        Leaf.prototype.flatten = function flatten() {
            return this.values;
        };
        Leaf.prototype.sliceInner = function sliceInner(from, to) {
            if (from == 0 && to == this.length) return this;
            return new Leaf(this.values.slice(from, to));
        };
        Leaf.prototype.getInner = function getInner(i) {
            return this.values[i];
        };
        Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
            for(var i = from; i < to; i++){
                if (f(this.values[i], start + i) === false) return false;
            }
        };
        Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
            for(var i = from - 1; i >= to; i--){
                if (f(this.values[i], start + i) === false) return false;
            }
        };
        Leaf.prototype.leafAppend = function leafAppend(other) {
            if (this.length + other.length <= $6bc3adfda0d77c81$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
        };
        Leaf.prototype.leafPrepend = function leafPrepend(other) {
            if (this.length + other.length <= $6bc3adfda0d77c81$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
        };
        prototypeAccessors.length.get = function() {
            return this.values.length;
        };
        prototypeAccessors.depth.get = function() {
            return 0;
        };
        Object.defineProperties(Leaf.prototype, prototypeAccessors);
        return Leaf;
    }($6bc3adfda0d77c81$var$RopeSequence);
    $6bc3adfda0d77c81$var$RopeSequence.empty = new $6bc3adfda0d77c81$var$Leaf([]);
    var $6bc3adfda0d77c81$var$Append = function(RopeSequence) {
        function Append(left, right) {
            RopeSequence.call(this);
            this.left = left;
            this.right = right;
            this.length = left.length + right.length;
            this.depth = Math.max(left.depth, right.depth) + 1;
        }
        if (RopeSequence) Append.__proto__ = RopeSequence;
        Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
        Append.prototype.constructor = Append;
        Append.prototype.flatten = function flatten() {
            return this.left.flatten().concat(this.right.flatten());
        };
        Append.prototype.getInner = function getInner(i) {
            return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
        };
        Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
            var leftLen = this.left.length;
            if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
            if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
        };
        Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
            var leftLen = this.left.length;
            if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
            if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
        };
        Append.prototype.sliceInner = function sliceInner(from, to) {
            if (from == 0 && to == this.length) return this;
            var leftLen = this.left.length;
            if (to <= leftLen) return this.left.slice(from, to);
            if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
            return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
        };
        Append.prototype.leafAppend = function leafAppend(other) {
            var inner = this.right.leafAppend(other);
            if (inner) return new Append(this.left, inner);
        };
        Append.prototype.leafPrepend = function leafPrepend(other) {
            var inner = this.left.leafPrepend(other);
            if (inner) return new Append(inner, this.right);
        };
        Append.prototype.appendInner = function appendInner(other) {
            if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
            return new Append(this, other);
        };
        return Append;
    }($6bc3adfda0d77c81$var$RopeSequence);
    var $6bc3adfda0d77c81$var$ropeSequence = $6bc3adfda0d77c81$var$RopeSequence;
    var $6bc3adfda0d77c81$export$2e2bcd8739ae039 = $6bc3adfda0d77c81$var$ropeSequence;
});
parcelRegister("bTmyI", function(module, exports) {
    $parcel$export(module.exports, "setKeyboardHeight", ()=>$7dc100aaa9d9a233$export$b8c3ea160300668d);
    var $6OgMR;
    const $7dc100aaa9d9a233$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
            const { tr: tr } = state;
            tr.setMeta((0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey), {
                keyboardHeight: keyboardHeight
            });
            if (dispatch) dispatch(tr);
            return true;
        };
});
parcelRegister("6OgMR", function(module, exports) {
    $parcel$export(module.exports, "scrollGutterPluginKey", ()=>$418a73e08450538e$export$54fdd3c2782161ea);
    $parcel$export(module.exports, "getScrollGutterPluginState", ()=>$418a73e08450538e$export$a237783470abe542);
    var $gZGBX;
    const $418a73e08450538e$export$54fdd3c2782161ea = new (0, (0, parcelRequire("gZGBX")).PluginKey)('scrollGutter');
    const $418a73e08450538e$export$a237783470abe542 = (state)=>{
        if (state) return $418a73e08450538e$export$54fdd3c2782161ea.getState(state);
    };
});
parcelRegister("jhGvF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fcaf55d45289964b$export$2e2bcd8739ae039);
    var $gE8f9;
    var $5KWxh;
    var $gZGBX;
    function $fcaf55d45289964b$var$getCurrentBrowserAndVersion() {
        switch(true){
            case (0, (0, parcelRequire("gE8f9")).browser).chrome === true:
                return {
                    browser: 'chrome',
                    version: (0, (0, parcelRequire("gE8f9")).browser).chrome_version
                };
            case (0, (0, parcelRequire("gE8f9")).browser).ie === true:
                return {
                    browser: 'ie',
                    version: (0, (0, parcelRequire("gE8f9")).browser).ie_version
                };
            case (0, (0, parcelRequire("gE8f9")).browser).gecko === true:
                return {
                    browser: 'gecko',
                    version: (0, (0, parcelRequire("gE8f9")).browser).gecko_version
                };
            case (0, (0, parcelRequire("gE8f9")).browser).safari === true:
                return {
                    browser: 'safari',
                    version: (0, (0, parcelRequire("gE8f9")).browser).safari_version
                };
        }
        return undefined;
    }
    var $fcaf55d45289964b$export$2e2bcd8739ae039 = (featureFlags)=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: new (0, (0, parcelRequire("gZGBX")).PluginKey)('disableSpellchecking'),
            props: {
                attributes: (editorState)=>{
                    if (!featureFlags) return {};
                    const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                    const userCurrentBrowserAndVersion = $fcaf55d45289964b$var$getCurrentBrowserAndVersion();
                    if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                    const browserVersionDisableRange = browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                    if (!browserVersionDisableRange || !(0, (0, parcelRequire("gE8f9")).browser)[userCurrentBrowserAndVersion.browser]) return {};
                    const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : (0, (0, parcelRequire("gE8f9")).browser)[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                    if (shouldDisableSpellcheck) return {
                        spellcheck: 'false'
                    };
                    return {};
                }
            }
        });
});
parcelRegister("f6qgr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70f314a94b71d913$export$2e2bcd8739ae039);
    var $gkwXh;
    var $J5Axj;
    var $5KWxh;
    const $70f314a94b71d913$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
    var $70f314a94b71d913$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            filterTransaction (transaction) {
                if ($70f314a94b71d913$var$hasInvalidSteps(transaction)) {
                    console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                    dispatchAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                        attributes: {
                            analyticsEventPayloads: (0, (0, parcelRequire("J5Axj")).getAnalyticsEventsFromTransaction)(transaction)
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                    return false;
                }
                return true;
            }
        });
    };
});
parcelRegister("hzDkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcf75182aad6c615$export$2e2bcd8739ae039);
    var $gkwXh;
    var $hETfp;
    var $k4HYa;
    var $b7gJe;
    var $5KWxh;
    var $4NUlu;
    var $gZGBX;
    var $7PbVY;
    var $bBaPM;
    const $dcf75182aad6c615$export$70246689264eff75 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('frozenEditor');
    const $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
    const $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD = 300;
    const $dcf75182aad6c615$export$c8d5b833abcf8e80 = 600;
    const $dcf75182aad6c615$export$47b2879ca9bbf67a = 2000;
    const $dcf75182aad6c615$export$1b622068be977101 = 3000;
    const $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
    const $dcf75182aad6c615$export$5705ac5f923a65e7 = 100;
    const $dcf75182aad6c615$export$1c6feb3429832c55 = 500;
    const $dcf75182aad6c615$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
            const { state: state } = view;
            const nodesCount = getNodeCount(state);
            return dispatchAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).BROWSER_FREEZE,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                attributes: {
                    objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                    freezeTime: time,
                    nodeSize: state.doc.nodeSize,
                    ...nodesCount,
                    interactionType: interactionType,
                    severity: severity
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            });
        };
    var $dcf75182aad6c615$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
            let interactionType;
            let inputLatencyTracker = null;
            if (browserFreezeTracking?.trackInteractionType) interactionType = (0, (0, parcelRequire("7PbVY")).setInteractionType)((0, (0, parcelRequire("hETfp")).BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
            const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $dcf75182aad6c615$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
            const slowThreshold = $dcf75182aad6c615$var$DEFAULT_SLOW_THRESHOLD;
            const freezeThreshold = $dcf75182aad6c615$export$c8d5b833abcf8e80;
            const allowCountNodes = inputTracking && inputTracking.countNodes;
            let prevNodeCountState = null;
            let prevNodeCount = {};
            const getNodeCount = (state)=>{
                if (state === prevNodeCountState) return prevNodeCount;
                prevNodeCount = allowCountNodes ? (0, (0, parcelRequire("k4HYa")).countNodes)(state) : {};
                prevNodeCountState = state;
                return prevNodeCount;
            };
            const shouldTrackSeverity = inputTracking?.trackSeverity || $dcf75182aad6c615$var$DEFAULT_TRACK_SEVERITY_ENABLED;
            const severityThresholdNormal = inputTracking?.severityNormalThreshold || $dcf75182aad6c615$export$5705ac5f923a65e7;
            const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $dcf75182aad6c615$export$1c6feb3429832c55;
            const createDispatchSample = (action, view)=>(time, severity)=>{
                    const { state: state } = view;
                    const nodesCount = getNodeCount(state);
                    const samplePayload = {
                        action: action,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                        attributes: {
                            time: time,
                            nodeSize: state.doc.nodeSize,
                            ...nodesCount,
                            objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                            severity: shouldTrackSeverity ? severity : undefined
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    };
                    dispatchAnalyticsEvent(samplePayload);
                };
            const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                    const { state: state } = view;
                    const nodeCount = getNodeCount(state);
                    const averagePayload = {
                        action: action,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                        attributes: {
                            mean: mean,
                            median: median,
                            sampleSize: sampleSize,
                            ...nodeCount,
                            nodeSize: state.doc.nodeSize,
                            severity: shouldTrackSeverity ? severity : undefined,
                            objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    };
                    dispatchAnalyticsEvent(averagePayload);
                };
            return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
                key: $dcf75182aad6c615$export$70246689264eff75,
                props: (0, (0, parcelRequire("b7gJe")).isPerformanceAPIAvailable)() ? {
                    handleTextInput (view) {
                        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, (0, parcelRequire("hETfp")).BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                        if (inputLatencyTracker) {
                            const end = inputLatencyTracker.start();
                            requestAnimationFrame(end);
                        }
                        return false;
                    },
                    handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                        click: ()=>{
                            interactionType = (0, (0, parcelRequire("7PbVY")).setInteractionType)((0, (0, parcelRequire("hETfp")).BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                            return false;
                        },
                        paste: ()=>{
                            interactionType = (0, (0, parcelRequire("7PbVY")).setInteractionType)((0, (0, parcelRequire("hETfp")).BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                            return false;
                        }
                    } : undefined
                } : undefined,
                view (view) {
                    if (!(0, (0, parcelRequire("b7gJe")).isPerformanceObserverAvailable)()) return {};
                    inputLatencyTracker = new (0, (0, parcelRequire("bBaPM")).default)({
                        samplingRate: samplingRate,
                        slowThreshold: slowThreshold,
                        normalThreshold: severityThresholdNormal,
                        degradedThreshold: severityThresholdDegraded,
                        dispatchSample: createDispatchSample((0, (0, parcelRequire("gkwXh")).ACTION).INPUT_PERF_SAMPLING, view),
                        dispatchAverage: createDispatchAverage((0, (0, parcelRequire("gkwXh")).ACTION).INPUT_PERF_SAMPLING_AVG, view),
                        onSlowInput: (time)=>{
                            const { state: state } = view;
                            const nodesCount = getNodeCount(state);
                            dispatchAnalyticsEvent({
                                action: (0, (0, parcelRequire("gkwXh")).ACTION).SLOW_INPUT,
                                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                                attributes: {
                                    time: time,
                                    nodeSize: state.doc.nodeSize,
                                    ...nodesCount,
                                    objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                                },
                                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                            });
                        }
                    });
                    let observer;
                    try {
                        observer = new PerformanceObserver((list)=>{
                            const perfEntries = list.getEntries();
                            for(let i = 0; i < perfEntries.length; i++){
                                const { duration: duration } = perfEntries[i];
                                if (duration > freezeThreshold) $dcf75182aad6c615$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(duration, severityThresholdNormal, severityThresholdDegraded));
                            }
                        });
                        observer.observe({
                            entryTypes: [
                                'longtask'
                            ]
                        });
                    } catch (e) {}
                    return {
                        destroy: ()=>{
                            inputLatencyTracker?.flush();
                            observer?.disconnect();
                        }
                    };
                }
            });
        };
});
parcelRegister("7PbVY", function(module, exports) {
    $parcel$export(module.exports, "setInteractionType", ()=>$45d100a35c3d5461$export$324d9bc8f4935d84);
    const $45d100a35c3d5461$export$324d9bc8f4935d84 = (value)=>value;
});
parcelRegister("bBaPM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d507047ed4b373a7$export$2e2bcd8739ae039);
    var $4NUlu;
    var $87xqV;
    class $d507047ed4b373a7$export$2e2bcd8739ae039 {
        constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
            this.samples = [];
            this.total = 0;
            this.samplingRate = samplingRate;
            this.slowThreshold = slowThreshold;
            this.normalThreshold = normalThreshold;
            this.degradedThreshold = degradedThreshold;
            this.dispatchAverage = dispatchAverage;
            this.dispatchSample = dispatchSample;
            this.onSampleStart = onSampleStart;
            this.onSampleEnd = onSampleEnd;
            this.onSlowInput = onSlowInput;
        }
        start() {
            const currentStart = performance.now();
            if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
            const end = ()=>{
                if (currentStart === null) return;
                let isSlow = false;
                const time = (0, (0, parcelRequire("87xqV")).getTimeSince)(currentStart);
                this.push(time);
                if (time > this.slowThreshold) {
                    this.onSlowInput?.(time);
                    isSlow = true;
                }
                if (this.samples.length === this.samplingRate) {
                    this.flush();
                    this.onSampleEnd?.(time, {
                        isSlow: isSlow,
                        severity: this.severity(time)
                    });
                }
            };
            return end;
        }
        flush() {
            if (this.samples.length === 0) return;
            this.dispatch();
            this.samples = [];
            this.total = 0;
        }
        dispatch() {
            this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
            const median = this.getMedian();
            this.dispatchAverage?.({
                mean: this.getMean(),
                median: median,
                sampleSize: this.samples.length
            }, this.severity(median));
        }
        push(latency) {
            this.samples.push(latency);
            this.total += latency;
        }
        severity(time) {
            return (0, (0, parcelRequire("4NUlu")).getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
        }
        getLast() {
            return this.samples[this.samples.length - 1];
        }
        getMean() {
            return this.total / this.samples.length;
        }
        getMedian() {
            if (this.samples.length === 1) return this.samples[0];
            this.samples.sort((a, b)=>a - b);
            const middle = (this.samples.length + 1) / 2;
            const floorMiddle = Math.floor(middle);
            const remainder = middle % floorMiddle;
            if (remainder === 0) return this.samples[middle - 1];
            const left = this.samples[floorMiddle - 1];
            const right = this.samples[floorMiddle];
            return (left + right) / 2;
        }
    }
});
parcelRegister("87xqV", function(module, exports) {
    $parcel$export(module.exports, "getTimeSince", ()=>$396bbcbd47a6c46e$export$a26b90db2c8f1b97);
    const $396bbcbd47a6c46e$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;
});
parcelRegister("djY8Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66ccc9e8b26cedb9$export$2e2bcd8739ae039);
    var $gE8f9;
    var $5KWxh;
    var $594Yf;
    var $gZGBX;
    var $etG8M;
    var $VSDnB;
    const $66ccc9e8b26cedb9$export$8836bfc6be4cb708 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('inlineCursorTargetPlugin');
    const $66ccc9e8b26cedb9$var$isInlineNodeView = (node)=>{
        const isHardBreak = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_prevent_decorations_on_hardbreak') && node?.type === node?.type.schema.nodes.hardBreak;
        return node && node.type.isInline && !node.type.isText && !isHardBreak;
    };
    var $66ccc9e8b26cedb9$export$2e2bcd8739ae039 = ()=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $66ccc9e8b26cedb9$export$8836bfc6be4cb708,
            state: {
                init: ()=>({
                        cursorTarget: undefined
                    }),
                apply (tr) {
                    const { selection: selection, doc: doc } = tr;
                    const { $from: $from, $to: $to } = selection;
                    const safariShiftSelection = tr.getMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708);
                    if (selection && (0, (0, parcelRequire("594Yf")).isTextSelection)(selection) && !safariShiftSelection) {
                        const hasInlineNodeViewAfter = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                        const hasInlineNodeViewBefore = $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                        const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeAfter);
                        const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $66ccc9e8b26cedb9$var$isInlineNodeView($from.nodeBefore);
                        const createWidget = (side)=>{
                            const node = document.createElement('span');
                            node.contentEditable = 'true';
                            node.setAttribute('aria-hidden', 'true');
                            node.appendChild(document.createTextNode((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)));
                            node.className = 'cursor-target';
                            const { $from: $from } = selection;
                            const rightPosition = $from.pos;
                            const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                            const widgetPos = side === 'left' ? leftPosition : rightPosition;
                            return (0, (0, parcelRequire("etG8M")).Decoration).widget(widgetPos, node, {
                                raw: true,
                                key: 'inlineCursor'
                            });
                        };
                        if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                            cursorTarget: {
                                decorations: [
                                    createWidget('left'),
                                    createWidget('right')
                                ],
                                positions: {
                                    from: $from.pos,
                                    to: $to.pos
                                }
                            }
                        };
                    }
                    return {
                        cursorTarget: undefined
                    };
                }
            },
            props: {
                decorations (state) {
                    const { doc: doc } = state;
                    const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                    if ($66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, (0, parcelRequire("etG8M")).DecorationSet).create(doc, cursorTarget.decorations);
                    return null;
                },
                handleDOMEvents: {
                    keydown: (view, event)=>{
                        if ((0, (0, parcelRequire("gE8f9")).browser).safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($66ccc9e8b26cedb9$export$8836bfc6be4cb708, {
                            cursorTarget: undefined
                        }));
                        return false;
                    },
                    compositionend: (view, incorrectlyTypedEvent)=>{
                        const event = incorrectlyTypedEvent;
                        const { state: state } = view;
                        const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                        if (cursorTarget !== undefined) {
                            $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                                event: event,
                                cursorTarget: cursorTarget,
                                view: view
                            });
                            return true;
                        }
                        return false;
                    },
                    beforeinput: (view, incorrectlyTypedEvent)=>{
                        const event = incorrectlyTypedEvent;
                        const { state: state } = view;
                        const { cursorTarget: cursorTarget } = $66ccc9e8b26cedb9$export$8836bfc6be4cb708.getState(state);
                        if (!event.isComposing && cursorTarget !== undefined) {
                            $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({
                                event: event,
                                cursorTarget: cursorTarget,
                                view: view
                            });
                            return true;
                        }
                        return false;
                    }
                }
            }
        });
    };
    function $66ccc9e8b26cedb9$var$cursorTargetHasValidDecorations(cursorTarget) {
        if (!cursorTarget || cursorTarget.decorations.includes(null)) return false;
        return true;
    }
    function $66ccc9e8b26cedb9$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
        event.stopPropagation();
        event.preventDefault();
        const content = event.data || '';
        const tr = view.state.tr;
        const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content));
        if (potentiallyHandleByHandleTextInput) return;
        tr.insertText(content);
        view.dispatch(tr);
    }
});
parcelRegister("594Yf", function(module, exports) {
    $parcel$export(module.exports, "isEmptyParagraph", ()=>$91477cc465a54c49$export$b648602b09795358);
    $parcel$export(module.exports, "stepHasSlice", ()=>$91477cc465a54c49$export$53780b185b887309);
    $parcel$export(module.exports, "stepAddsOneOf", ()=>$91477cc465a54c49$export$f4d51ccab05f55c9);
    $parcel$export(module.exports, "extractSliceFromStep", ()=>$91477cc465a54c49$export$d0a9dfe2556a9577);
    $parcel$export(module.exports, "isTextSelection", ()=>$91477cc465a54c49$export$38b50bf35e79aaf3);
    $parcel$export(module.exports, "isElementInTableCell", ()=>$91477cc465a54c49$export$5588122b9eea7733);
    $parcel$export(module.exports, "isLastItemMediaGroup", ()=>$91477cc465a54c49$export$142c0ee6457f50d6);
    $parcel$export(module.exports, "setNodeSelection", ()=>$91477cc465a54c49$export$a367515ca2c9ace1);
    $parcel$export(module.exports, "setTextSelection", ()=>$91477cc465a54c49$export$1df6d14df6b0b758);
    $parcel$export(module.exports, "nonNullable", ()=>$91477cc465a54c49$export$26128561c93f5847);
    $parcel$export(module.exports, "isValidPosition", ()=>$91477cc465a54c49$export$de0495c7bd37bf4e);
    $parcel$export(module.exports, "isInLayoutColumn", ()=>$91477cc465a54c49$export$2de06a6e688827fd);
    $parcel$export(module.exports, "filterChildrenBetween", ()=>$91477cc465a54c49$export$e46323d96cf32194);
    $parcel$export(module.exports, "removeBlockMarks", ()=>$91477cc465a54c49$export$fba8af3b998832b9);
    var $gZGBX;
    var $eS2Dn;
    var $5r0mK = parcelRequire("5r0mK");
    var $hFEwm;
    var $eQcNy;
    function $91477cc465a54c49$export$b648602b09795358(node) {
        return !!node && node.type.name === 'paragraph' && !node.childCount;
    }
    const $91477cc465a54c49$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
    function $91477cc465a54c49$export$f4d51ccab05f55c9(step, nodeTypes) {
        let adds = false;
        if (!$91477cc465a54c49$export$53780b185b887309(step)) return adds;
        step.slice.content.descendants((node)=>{
            if (nodeTypes.has(node.type)) adds = true;
            return !adds;
        });
        return adds;
    }
    const $91477cc465a54c49$export$d0a9dfe2556a9577 = (step)=>{
        if (!(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep)) && !(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return null;
        const slice = step.slice;
        return slice;
    };
    const $91477cc465a54c49$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection);
    const $91477cc465a54c49$export$5588122b9eea7733 = (element)=>{
        return (0, (0, parcelRequire("eQcNy")).closest)(element, 'td') || (0, (0, parcelRequire("eQcNy")).closest)(element, 'th');
    };
    const $91477cc465a54c49$export$142c0ee6457f50d6 = (node)=>{
        const { content: content } = node;
        return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
    };
    const $91477cc465a54c49$export$a367515ca2c9ace1 = (view, pos)=>{
        const { state: state, dispatch: dispatch } = view;
        if (!isFinite(pos)) return;
        const tr = state.tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, pos));
        dispatch(tr);
    };
    function $91477cc465a54c49$export$1df6d14df6b0b758(view, anchor, head) {
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(state.doc, anchor, head));
        dispatch(tr);
    }
    function $91477cc465a54c49$export$abad69d764760c05(view) {
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr.setSelection(new (0, (0, parcelRequire("gZGBX")).AllSelection)(view.state.doc));
        dispatch(tr);
    }
    function $91477cc465a54c49$export$8f10f8581a0e9ba2(view, anchor, head) {
        const { state: state, dispatch: dispatch } = view;
        dispatch(state.tr.setSelection((0, (0, parcelRequire("hFEwm")).CellSelection).create(state.doc, anchor, head)));
    }
    function $91477cc465a54c49$export$26128561c93f5847(value) {
        return value !== null && value !== undefined;
    }
    const $91477cc465a54c49$export$de0495c7bd37bf4e = (pos, state)=>{
        if (typeof pos !== 'number') return false;
        if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
        return false;
    };
    const $91477cc465a54c49$export$2de06a6e688827fd = (state)=>{
        return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
    };
    function $91477cc465a54c49$export$e46323d96cf32194(doc, from, to, predicate) {
        const results = [];
        doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (predicate(node, pos, parent)) results.push({
                node: node,
                pos: pos
            });
        });
        return results;
    }
    const $91477cc465a54c49$export$fba8af3b998832b9 = (state, marks)=>{
        const { selection: selection, schema: schema } = state;
        let { tr: tr } = state;
        const marksToRemove = marks.filter(Boolean);
        if (marksToRemove.length === 0) return undefined;
        let blockMarksExists = false;
        const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
        state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
            if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
                blockMarksExists = true;
                const resolvedPos = state.doc.resolve(pos);
                const withoutBlockMarks = node.marks.filter($91477cc465a54c49$var$not(hasMark));
                tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
            }
        });
        return blockMarksExists ? tr : undefined;
    };
    const $91477cc465a54c49$var$not = (fn)=>(arg)=>!fn(arg);
});
parcelRegister("7Y3BJ", function(module, exports) {
    $parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", ()=>$65853fcadaed25d5$export$650082547b31be68);
    var $3xRyR;
    var $5KWxh;
    var $etG8M;
    const $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
    function $65853fcadaed25d5$export$650082547b31be68() {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey),
            state: {
                init: ()=>{
                    return {
                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                        nodeTypes: []
                    };
                },
                apply (tr, _oldState, newState) {
                    const actionPayload = tr.getMeta((0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey));
                    const pluginState = (0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey).getState(newState);
                    if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                        const decorations = [];
                        tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                            if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, (0, parcelRequire("etG8M")).Decoration).node(pos, pos + node.nodeSize, {
                                class: $65853fcadaed25d5$var$LAZY_NODE_VIEW_DECORATION_CLASS
                            }));
                        });
                        return {
                            decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, decorations)
                        };
                    }
                    if (actionPayload?.type === 'clear') return {
                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
                    };
                    if (tr.docChanged) return {
                        decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                    };
                    return pluginState;
                }
            },
            props: {
                decorations: (state)=>{
                    return (0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
                }
            },
            view (editorView) {
                return {
                    update () {
                        const pluginState = (0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey).getState(editorView.state);
                        if (pluginState.decorations !== (0, (0, parcelRequire("etG8M")).DecorationSet).empty) {
                            const tr = editorView.state.tr;
                            tr.setMeta((0, (0, parcelRequire("3xRyR")).lazyNodeViewDecorationPluginKey), {
                                type: 'clear'
                            });
                            editorView.dispatch(tr);
                        }
                    }
                };
            }
        });
    }
});
parcelRegister("3xRyR", function(module, exports) {
    $parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", ()=>$b4549f33660d686a$export$325659f41b2239a7);
    $parcel$export(module.exports, "withLazyLoading", ()=>$b4549f33660d686a$export$6b97b121e15a69b7);
    var $gZGBX;
    var $VSDnB;
    var $5qeGx;
    var $6J9GW;
    var $7KZr8;
    const $b4549f33660d686a$export$325659f41b2239a7 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('lazyNodeViewDecoration');
    const $b4549f33660d686a$var$requestedNodesPerEditorView = new WeakMap();
    const $b4549f33660d686a$var$resolvedNodesPerEditorView = new WeakMap();
    const $b4549f33660d686a$var$debounceToEditorViewMap = new WeakMap();
    const $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
    function $b4549f33660d686a$export$6c7e823c919edf69(view) {
        $b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.add(view);
    }
    const $b4549f33660d686a$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
        const createLazyNodeView = (node, view, getPos, decorations)=>{
            let requestedNodes = $b4549f33660d686a$var$requestedNodesPerEditorView.get(view);
            if (!requestedNodes) {
                requestedNodes = new Map();
                $b4549f33660d686a$var$requestedNodesPerEditorView.set(view, requestedNodes);
            }
            const resolvedNodeViews = $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view);
            if (!resolvedNodeViews) $b4549f33660d686a$var$resolvedNodesPerEditorView.set(view, new Map());
            const wasAlreadyRequested = requestedNodes.has(nodeName);
            if (wasAlreadyRequested) {
                const resolvedNodeView = resolvedNodeViews?.get(nodeName);
                if (resolvedNodeView && !$b4549f33660d686a$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations);
                return new (0, (0, parcelRequire("6J9GW")).LazyNodeView)(node, view, getPos, decorations);
            }
            const loaderPromise = loader().then((nodeViewFuncModule)=>{
                const nodeViewFunc = (node, view, getPos, decorations)=>{
                    const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions);
                    const dom = nodeView.dom;
                    dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                    if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ed-25557_lnv_add_ssr_placeholder')) {
                        const pos = getPos();
                        if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, (0, parcelRequire("6J9GW")).makeNodePlaceholderId)(node.type.name, pos));
                    }
                    return nodeView;
                };
                $b4549f33660d686a$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
                const [callbackId, nodeTypes] = $b4549f33660d686a$var$debounceToEditorViewMap.get(view) || [
                    null,
                    new Set()
                ];
                if (callbackId) (0, (0, parcelRequire("5qeGx")).cancelCallback)(callbackId);
                nodeTypes.add(node.type.name);
                const nextCallbackId = (0, (0, parcelRequire("5qeGx")).scheduleCallback)(()=>{
                    $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                        null,
                        new Set()
                    ]);
                    const tr = view.state.tr;
                    tr.setMeta($b4549f33660d686a$export$325659f41b2239a7, {
                        type: 'add',
                        nodeTypes: nodeTypes
                    });
                    view.dispatch(tr);
                });
                $b4549f33660d686a$var$debounceToEditorViewMap.set(view, [
                    nextCallbackId,
                    nodeTypes
                ]);
                return nodeViewFunc;
            });
            requestedNodes.set(nodeName, loaderPromise);
            typeof node.type?.spec?.toDOM;
            return new (0, (0, parcelRequire("6J9GW")).LazyNodeView)(node, view, getPos, decorations);
        };
        return createLazyNodeView;
    };
});
parcelRegister("5qeGx", function(module, exports) {
    $parcel$export(module.exports, "scheduleCallback", ()=>$76aba5618edd3d60$export$4db3c991f22dbc2d);
    $parcel$export(module.exports, "cancelCallback", ()=>$76aba5618edd3d60$export$b888d8f981c07a46);
    const $76aba5618edd3d60$var$hasIdleCallback = 'requestIdleCallback' in window;
    const $76aba5618edd3d60$export$4db3c991f22dbc2d = (cb, options)=>{
        return $76aba5618edd3d60$var$hasIdleCallback ? requestIdleCallback(cb, {
            timeout: 5000,
            ...options
        }) : requestAnimationFrame(cb);
    };
    const $76aba5618edd3d60$export$b888d8f981c07a46 = (id)=>{
        return $76aba5618edd3d60$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
    };
});
parcelRegister("6J9GW", function(module, exports) {
    $parcel$export(module.exports, "makeNodePlaceholderId", ()=>$178c99317a21749f$export$f306d9dd555af398);
    $parcel$export(module.exports, "LazyNodeView", ()=>$178c99317a21749f$export$dccb00b9da782c66);
    var $gJBT6 = parcelRequire("gJBT6");
    var $kCV8T;
    var $VSDnB;
    const $178c99317a21749f$var$getEditorLineWidth = (0, ($parcel$interopDefault($gJBT6)))((view)=>{
        return view.dom?.clientWidth;
    });
    function $178c99317a21749f$var$sameOuterDeco(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!a[i].type) return false;
            if (!a[i].type.eq(b[i].type)) return false;
        }
        return true;
    }
    function $178c99317a21749f$export$f306d9dd555af398(nodeType, pos) {
        return `${nodeType}:${pos}`;
    }
    class $178c99317a21749f$export$dccb00b9da782c66 {
        constructor(node, view, _getPos, outerDeco){
            this.update = (node, outerDeco)=>{
                const prevNode = this.node;
                this.node = node;
                if (!$178c99317a21749f$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
                return !this.node.sameMarkup(prevNode);
            };
            this.node = node;
            this.outerDeco = outerDeco;
            if (typeof node.type?.spec?.toDOM !== 'function') {
                this.dom = document.createElement('div');
                return;
            }
            const toDOMConfiguration = {
                editorLineWidth: $178c99317a21749f$var$getEditorLineWidth(view)
            };
            const fallback = (0, (0, parcelRequire("kCV8T")).DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, toDOMConfiguration));
            this.dom = fallback.dom;
            this.contentDOM = fallback.contentDOM;
            if (this.dom instanceof HTMLElement) {
                this.dom.setAttribute('data-lazy-node-view', node.type.name);
                this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
                this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ed-25557_lnv_add_ssr_placeholder')) {
                    const pos = _getPos();
                    if (pos !== undefined) this.dom.setAttribute('data-editor-lnv-placeholder', $178c99317a21749f$export$f306d9dd555af398(node.type.name, pos));
                }
            }
        }
        ignoreMutation() {
            if (this.node.type.isTextblock) return false;
            return true;
        }
    }
});
parcelRegister("7KZr8", function(module, exports) {
    $parcel$export(module.exports, "convertToInlineCss", ()=>$383278441dd86b5b$export$7da93c9174ab9340);
    function $383278441dd86b5b$var$hyphenate(property) {
        return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
    }
    function $383278441dd86b5b$export$7da93c9174ab9340(properties) {
        const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $383278441dd86b5b$var$hyphenate(property)}: ${value};`).join(' ');
        return cssString;
    }
});
parcelRegister("6qtBk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$459ed5956f03f982$export$2e2bcd8739ae039);
    var $5KWxh;
    var $k24a0;
    var $ggL2v;
    var $vWFRY;
    var $gZGBX;
    const $459ed5956f03f982$export$2f489388b18569dd = new (0, (0, parcelRequire("gZGBX")).PluginKey)('newlinePreserveMarksPlugin');
    const $459ed5956f03f982$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
    const $459ed5956f03f982$var$splitBlockPreservingMarks = (state, dispatch)=>{
        if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
        return true;
    };
    var $459ed5956f03f982$export$2e2bcd8739ae039 = ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $459ed5956f03f982$export$2f489388b18569dd,
            props: {
                handleKeyDown: (0, (0, parcelRequire("vWFRY")).keydownHandler)({
                    Enter: (0, (0, parcelRequire("k24a0")).filterCommand)([
                        (0, (0, parcelRequire("ggL2v")).isSelectionEndOfParagraph),
                        $459ed5956f03f982$var$isSelectionAligned
                    ], $459ed5956f03f982$var$splitBlockPreservingMarks)
                })
            }
        });
});
parcelRegister("k24a0", function(module, exports) {
    $parcel$export(module.exports, "walkNextNode", ()=>$9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0);
    $parcel$export(module.exports, "walkPrevNode", ()=>$9c1f67beb7dd4702$export$cab15df6ad89b5a0);
    $parcel$export(module.exports, "insertNewLineWithAnalytics", ()=>$9c1f67beb7dd4702$export$67efd148fa31066c);
    $parcel$export(module.exports, "createNewParagraphAbove", ()=>$9c1f67beb7dd4702$export$fd094c1e3c1540bf);
    $parcel$export(module.exports, "createParagraphNear", ()=>$9c1f67beb7dd4702$export$d0f80ac1b4510888);
    $parcel$export(module.exports, "createNewParagraphBelow", ()=>$9c1f67beb7dd4702$export$d4296e42f66d8dc6);
    $parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", ()=>$9c1f67beb7dd4702$export$a52ade1f964aef2c);
    $parcel$export(module.exports, "insertContentDeleteRange", ()=>$9c1f67beb7dd4702$export$1a87582f65bdc5db);
    $parcel$export(module.exports, "isEmptySelectionAtStart", ()=>$9c1f67beb7dd4702$export$55f1e30b4664ff16);
    $parcel$export(module.exports, "isEmptySelectionAtEnd", ()=>$9c1f67beb7dd4702$export$aedf35c057f77b82);
    $parcel$export(module.exports, "filterCommand", ()=>$9c1f67beb7dd4702$export$3dea766d36a8935f);
    var $kCV8T;
    var $gZGBX;
    var $gkwXh;
    var $14FOE;
    var $hPjvp;
    var $594Yf;
    var $20Kbb;
    const $9c1f67beb7dd4702$export$3dea766d36a8935f = (predicates, cmd)=>{
        return function(state, dispatch, view) {
            if (!Array.isArray(predicates)) predicates = [
                predicates
            ];
            if (predicates.some((pred)=>!pred(state, view))) return false;
            return cmd(state, dispatch, view) || false;
        };
    };
    const $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
        let $pos = $startPos;
        while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
        return {
            $pos: $pos,
            foundNode: $pos.pos < $pos.doc.nodeSize - 2
        };
    };
    const $9c1f67beb7dd4702$export$cab15df6ad89b5a0 = ($startPos)=>{
        let $pos = $startPos;
        while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
        return {
            $pos: $pos,
            foundNode: $pos.pos > 0
        };
    };
    function $9c1f67beb7dd4702$export$c2d9390f63354627() {
        return function(state, dispatch) {
            const { $from: $from } = state.selection;
            const parent = $from.parent;
            const { hardBreak: hardBreak } = state.schema.nodes;
            if (hardBreak) {
                const hardBreakNode = hardBreak.createChecked();
                if (parent && parent.type.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(hardBreakNode))) {
                    if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                    return true;
                }
            }
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
                if (dispatch) dispatch(state.tr.insertText('\n'));
                return true;
            }
            return false;
        };
    }
    const $9c1f67beb7dd4702$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, (0, parcelRequire("14FOE")).withAnalytics)(editorAnalyticsAPI, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).LINE_BREAK,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        })($9c1f67beb7dd4702$export$c2d9390f63354627());
    const $9c1f67beb7dd4702$export$fd094c1e3c1540bf = (state, dispatch)=>{
        const append = false;
        if (!$9c1f67beb7dd4702$var$canMoveUp(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
            $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
            return true;
        }
        return false;
    };
    const $9c1f67beb7dd4702$export$d4296e42f66d8dc6 = (state, dispatch)=>{
        const append = true;
        if (!$9c1f67beb7dd4702$var$canMoveDown(state) && $9c1f67beb7dd4702$var$canCreateParagraphNear(state)) {
            $9c1f67beb7dd4702$export$d0f80ac1b4510888(append)(state, dispatch);
            return true;
        }
        return false;
    };
    function $9c1f67beb7dd4702$var$canCreateParagraphNear(state) {
        const { selection: { $from: $from } } = state;
        const node = $from.node($from.depth);
        const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
        const isNodeSelection = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
        return $from.depth > 1 || isNodeSelection || insideCodeBlock;
    }
    function $9c1f67beb7dd4702$export$d0f80ac1b4510888(append = true) {
        return function(state, dispatch) {
            const paragraph = state.schema.nodes.paragraph;
            if (!paragraph) return false;
            let insertPos;
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
                if ($9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state)) return false;
                insertPos = $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append);
            } else insertPos = $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append);
            const tr = state.tr.insert(insertPos, paragraph.createAndFill());
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, insertPos + 1));
            if (dispatch) dispatch(tr);
            return true;
        };
    }
    function $9c1f67beb7dd4702$var$getInsertPosFromTextBlock(state, append) {
        const { $from: $from, $to: $to } = state.selection;
        let pos;
        if (!append) pos = $from.start(0);
        else pos = $to.end(0);
        return pos;
    }
    function $9c1f67beb7dd4702$var$getInsertPosFromNonTextBlock(state, append) {
        const { $from: $from, $to: $to } = state.selection;
        const nodeAtSelection = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
        const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
        let pos;
        if (!append) {
            pos = $from.start($from.depth);
            pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
        } else {
            pos = $to.end($to.depth);
            pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
        }
        return pos;
    }
    function $9c1f67beb7dd4702$var$topLevelNodeIsEmptyTextBlock(state) {
        const topLevelNode = state.selection.$from.node(1);
        return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
    }
    function $9c1f67beb7dd4702$var$canMoveUp(state) {
        const { selection: selection } = state;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && (0, (0, parcelRequire("20Kbb")).isMediaNode)(selection.node)) return true;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
            if (!selection.empty) return true;
        }
        return !$9c1f67beb7dd4702$export$e9083e8cbe24bec0(state);
    }
    function $9c1f67beb7dd4702$var$canMoveDown(state) {
        const { selection: selection } = state;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && (0, (0, parcelRequire("20Kbb")).isMediaNode)(selection.node)) return true;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
            if (!selection.empty) return true;
        }
        return !$9c1f67beb7dd4702$export$4ca816540352da02(state);
    }
    function $9c1f67beb7dd4702$export$4ca816540352da02(state) {
        const { selection: selection, doc: doc } = state;
        return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
    }
    function $9c1f67beb7dd4702$export$e9083e8cbe24bec0(state) {
        const { selection: selection } = state;
        return selection.$from.pos === selection.$from.depth;
    }
    const $9c1f67beb7dd4702$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
        return (state, dispatch, view)=>{
            const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
            const { $pos: $pos } = $9c1f67beb7dd4702$export$a5ae75c0b3dfe1c0($head);
            const nextPMNode = doc.nodeAt($pos.pos - 1);
            if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
                tr.deleteRange(pos - 1, pos + 1);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    };
    const $9c1f67beb7dd4702$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
        insertions.forEach((contentInsert)=>{
            let [content, pos] = contentInsert;
            tr.insert(tr.mapping.map(pos), content);
        });
        deletions.forEach((deleteRange)=>{
            let [firstPos, lastPos] = deleteRange;
            tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
        });
        tr.setSelection(new (0, (0, parcelRequire("gZGBX")).TextSelection)(getSelectionResolvedPos(tr)));
    };
    const $9c1f67beb7dd4702$export$55f1e30b4664ff16 = (state)=>{
        const { empty: empty, $from: $from } = state.selection;
        return empty && ($from.parentOffset === 0 || state.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection));
    };
    const $9c1f67beb7dd4702$export$aedf35c057f77b82 = (state)=>{
        const { empty: empty, $from: $from } = state.selection;
        return empty && ($from.end() === $from.pos || state.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection));
    };
});
parcelRegister("14FOE", function(module, exports) {
    $parcel$export(module.exports, "withAnalytics", ()=>$6ff06cde8c465d99$export$af9baadf0e4f6e13);
    function $6ff06cde8c465d99$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    if (dispatch) {
                        if (payload instanceof Function) {
                            const dynamicPayload = payload(state);
                            if (dynamicPayload) {
                                analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                                dispatch(tr);
                            }
                        } else {
                            analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                            dispatch(tr);
                        }
                    }
                }, view);
    }
});
parcelRegister("ggL2v", function(module, exports) {
    $parcel$export(module.exports, "getStepRange", ()=>$c63a5e20023dc0f3$export$c8e611b6ac095e6d);
    $parcel$export(module.exports, "hasDocAsParent", ()=>$c63a5e20023dc0f3$export$f76a7d770092ea11);
    $parcel$export(module.exports, "isEmptyDocument", ()=>$c63a5e20023dc0f3$export$2da47a16c0b6bcb);
    $parcel$export(module.exports, "bracketTyped", ()=>$c63a5e20023dc0f3$export$df0539d254c75c33);
    $parcel$export(module.exports, "nodesBetweenChanged", ()=>$c63a5e20023dc0f3$export$f9e52d2e832a6aae);
    $parcel$export(module.exports, "hasVisibleContent", ()=>$c63a5e20023dc0f3$export$c9083db5521330d3);
    $parcel$export(module.exports, "isSelectionEndOfParagraph", ()=>$c63a5e20023dc0f3$export$435c1d4e61a8723b);
    $parcel$export(module.exports, "getChangedNodes", ()=>$c63a5e20023dc0f3$export$fd9c3e0f31aab835);
    var $594Yf;
    const $c63a5e20023dc0f3$export$c8e611b6ac095e6d = (transaction)=>{
        let from = -1;
        let to = -1;
        transaction.mapping.maps.forEach((stepMap, index)=>{
            stepMap.forEach((oldStart, oldEnd)=>{
                const newStart = transaction.mapping.slice(index).map(oldStart, -1);
                const newEnd = transaction.mapping.slice(index).map(oldEnd);
                from = newStart < from || from === -1 ? newStart : from;
                to = newEnd > to || to === -1 ? newEnd : to;
            });
        });
        if (from !== -1) return {
            from: from,
            to: to
        };
        return null;
    };
    function $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor) {
        return $anchor.depth === 1;
    }
    function $c63a5e20023dc0f3$export$2da47a16c0b6bcb(node) {
        const nodeChild = node.content.firstChild;
        if (node.childCount !== 1 || !nodeChild) return false;
        return (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(nodeChild);
    }
    function $c63a5e20023dc0f3$export$df0539d254c75c33(state) {
        const { selection: selection } = state;
        const { $cursor: $cursor, $anchor: $anchor } = selection;
        if (!$cursor) return false;
        const node = $cursor.nodeBefore;
        if (!node) return false;
        if (node.type.name === 'text' && node.text === '{') {
            const paragraphNode = $anchor.node();
            return paragraphNode.marks.length === 0 && $c63a5e20023dc0f3$export$f76a7d770092ea11($anchor);
        }
        return false;
    }
    function $c63a5e20023dc0f3$export$f9e52d2e832a6aae(tr, f, startPos) {
        const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
        if (!stepRange) return;
        tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
    }
    function $c63a5e20023dc0f3$export$c9083db5521330d3(node) {
        const isInlineNodeHasVisibleContent = (inlineNode)=>{
            return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
        };
        if (node.isInline) return isInlineNodeHasVisibleContent(node);
        else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
        else if (!node.childCount) return false;
        for(let index = 0; index < node.childCount; index++){
            const child = node.child(index);
            const invisibleNodeTypes = [
                'paragraph',
                'text',
                'hardBreak'
            ];
            if (!invisibleNodeTypes.includes(child.type.name) || $c63a5e20023dc0f3$export$c9083db5521330d3(child)) return true;
        }
        return false;
    }
    const $c63a5e20023dc0f3$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
    function $c63a5e20023dc0f3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
        const nodes = [];
        const stepRange = $c63a5e20023dc0f3$export$c8e611b6ac095e6d(tr);
        if (!stepRange) return nodes;
        const from = Math.min(doc.nodeSize - 2, stepRange.from);
        const to = Math.min(doc.nodeSize - 2, stepRange.to);
        doc.nodesBetween(from, to, (node, pos)=>{
            nodes.push({
                node: node,
                pos: pos
            });
        });
        return nodes;
    }
    function $c63a5e20023dc0f3$export$fd9c3e0f31aab835(tr) {
        return $c63a5e20023dc0f3$var$getChangedNodesIn({
            tr: tr,
            doc: tr.doc
        });
    }
});
parcelRegister("9BF1z", function(module, exports) {
    $parcel$export(module.exports, "getKeyboardHeight", ()=>$f3f99b7d653fdd32$export$af5702f0c69bf4d7);
    $parcel$export(module.exports, "default", ()=>$f3f99b7d653fdd32$export$2e2bcd8739ae039);
    var $5KWxh;
    var $ggL2v;
    var $6OgMR;
    const $f3f99b7d653fdd32$export$af5702f0c69bf4d7 = (state)=>{
        if (state) {
            const scrollGutterPluginState = (0, (0, parcelRequire("6OgMR")).getScrollGutterPluginState)(state);
            return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
        }
    };
    const $f3f99b7d653fdd32$var$MIN_TAP_SIZE_IN_PX = 40;
    function $f3f99b7d653fdd32$var$supportsIntersectionObserver() {
        if (typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) return true;
        return false;
    }
    function $f3f99b7d653fdd32$var$listenForGutterVisibilityChanges(scrollElement, gutterIsVisible) {
        if ($f3f99b7d653fdd32$var$supportsIntersectionObserver()) {
            const observer = new IntersectionObserver((entries, _)=>{
                entries.forEach((entry)=>{
                    gutterIsVisible(entry.intersectionRatio > 0);
                });
            }, {
                root: scrollElement,
                rootMargin: '0px',
                threshold: 0
            });
            return observer;
        }
        return undefined;
    }
    function $f3f99b7d653fdd32$var$createGutter(gutterSize) {
        const gutter = document.createElement('div');
        gutter.style.paddingBottom = `${gutterSize}px`;
        gutter.id = (0, $f8b503fa770d54ab$export$c90c3407e87d7a1f).substr(1);
        let initialized = false;
        let mounted = false;
        let currentParent = null;
        let observer;
        let isVisible = false;
        return {
            addGutter (parent) {
                if (parent) {
                    currentParent = parent;
                    parent.deref()?.appendChild(gutter);
                    mounted = true;
                    if (observer) observer.observe(gutter);
                }
            },
            removeGutter () {
                const parentRef = currentParent?.deref();
                if (parentRef && mounted) {
                    mounted = false;
                    parentRef.removeChild(gutter);
                    if (observer) observer.unobserve(gutter);
                }
            },
            element () {
                return gutter;
            },
            isMounted () {
                return mounted;
            },
            visible () {
                if (observer) return isVisible;
                return mounted;
            },
            observe (scrollElement) {
                if (!initialized) {
                    initialized = true;
                    observer = $f3f99b7d653fdd32$var$listenForGutterVisibilityChanges(scrollElement, (visible)=>isVisible = visible);
                }
            },
            destroy () {
                if (observer) observer.disconnect();
                observer = undefined;
                this.removeGutter();
                initialized = mounted = false;
            }
        };
    }
    function $f3f99b7d653fdd32$var$getCaretTopPosition() {
        const windowSelection = window.getSelection();
        if (windowSelection && windowSelection.rangeCount > 0) {
            const range = windowSelection.getRangeAt(0);
            if (range) {
                const clientRects = range.getClientRects();
                if (clientRects && clientRects.length > 0) return clientRects[0].top;
                const container = range.startContainer;
                if (container && container.getBoundingClientRect) return container.getBoundingClientRect().top;
            }
        }
        return;
    }
    function $f3f99b7d653fdd32$var$scrollToGutterElement(scrollContainer, gutterElement, gutterSize) {
        const viewportHeight = scrollContainer.offsetHeight;
        const viewportOffsetY = scrollContainer.getBoundingClientRect().top;
        const caretTopPosition = $f3f99b7d653fdd32$var$getCaretTopPosition();
        if (!caretTopPosition) return false;
        const caretTopFromContainer = caretTopPosition - viewportOffsetY;
        const gutterThresholdTop = viewportHeight - gutterSize - $f3f99b7d653fdd32$var$MIN_TAP_SIZE_IN_PX * 2;
        if (caretTopFromContainer < gutterThresholdTop) return false;
        gutterElement.scrollIntoView(false);
        return true;
    }
    var $f3f99b7d653fdd32$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
        const { getScrollElement: getScrollElement, allowCustomScrollHandler: allowCustomScrollHandler, gutterSize: gutterSize = (0, $f8b503fa770d54ab$export$f4dbeaf4c0e3c381) } = pluginOptions;
        if (!getScrollElement) return undefined;
        const gutter = $f3f99b7d653fdd32$var$createGutter(gutterSize);
        let scrollElement = null;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey),
            state: {
                init: ()=>({}),
                apply: (tr, pluginState)=>{
                    if (tr.getMeta((0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey))) return tr.getMeta((0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey));
                    return pluginState;
                }
            },
            props: {
                scrollThreshold: gutterSize / 2,
                scrollMargin: gutterSize,
                handleScrollToSelection: ()=>{
                    if (allowCustomScrollHandler === false) return false;
                    if (!gutter.isMounted() || !gutter.visible() || !scrollElement) return false;
                    return $f3f99b7d653fdd32$var$scrollToGutterElement(scrollElement, gutter.element(), gutterSize);
                }
            },
            view (view) {
                scrollElement = getScrollElement(view);
                let editorElement = view.dom;
                let editorParentElement = editorElement.parentElement;
                let viewportElementHeight = 0;
                let contentElementHeight = 0;
                const addAndObserveGutter = ()=>{
                    if (!gutter.isMounted()) {
                        gutter.observe(scrollElement);
                        gutter.addGutter(editorParentElement ? new WeakRef(editorParentElement) : null);
                    }
                };
                const toggleGutter = (contentSize, threshold)=>{
                    if (pluginOptions.persistScrollGutter) {
                        if (!(0, (0, parcelRequire("ggL2v")).isEmptyDocument)(view.state.doc)) addAndObserveGutter();
                        else gutter.removeGutter();
                        return;
                    }
                    if (contentSize >= threshold) addAndObserveGutter();
                    else if (gutter.isMounted()) gutter.removeGutter();
                };
                const observerCallback = (entries)=>{
                    for (const entry of entries){
                        const elementHeight = Math.round(entry.contentRect.height);
                        if (entry.target === scrollElement) {
                            const keyboardHeight = $f3f99b7d653fdd32$export$af5702f0c69bf4d7(view?.state) ?? 0;
                            viewportElementHeight = elementHeight - keyboardHeight;
                        } else if (entry.target === editorParentElement) contentElementHeight = elementHeight - (gutter.isMounted() ? gutterSize : 0);
                    }
                    toggleGutter(contentElementHeight, viewportElementHeight);
                };
                const resizeObserver = new ResizeObserver(observerCallback);
                if (scrollElement && editorParentElement) {
                    resizeObserver.observe(scrollElement);
                    resizeObserver.observe(editorParentElement);
                }
                return {
                    destroy () {
                        gutter.destroy();
                        scrollElement = editorParentElement = editorElement = null;
                        resizeObserver.disconnect();
                    },
                    update (view, prevState) {
                        if (!scrollElement || !editorParentElement) return;
                        const state = view.state;
                        if (prevState.selection === state.selection) return;
                        const gutterThresholdHeight = viewportElementHeight - gutterSize;
                        toggleGutter(contentElementHeight, gutterThresholdHeight);
                    }
                };
            }
        });
    };
});
const $f8b503fa770d54ab$export$f4dbeaf4c0e3c381 = 120;
const $f8b503fa770d54ab$export$8b3ad80c47d385e3 = 36;
const $f8b503fa770d54ab$export$c90c3407e87d7a1f = '#editor-scroll-gutter';
parcelRegister("j4mzV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d3c8dc07d034971$export$2e2bcd8739ae039);
    var $5KWxh;
    var $6OgMR;
    const $5d3c8dc07d034971$var$GUTTER_SIZE_IN_PX = 120;
    const $5d3c8dc07d034971$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
    const $5d3c8dc07d034971$export$af5702f0c69bf4d7 = (state)=>{
        if (state) {
            const scrollGutterPluginState = (0, (0, parcelRequire("6OgMR")).getScrollGutterPluginState)(state);
            return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
        }
    };
    function $5d3c8dc07d034971$var$createGutter(gutterSize, parent) {
        const gutter = document.createElement('div');
        gutter.style.paddingBottom = `${gutterSize}px`;
        gutter.id = $5d3c8dc07d034971$var$GUTTER_SELECTOR_NAME;
        if (parent) parent.appendChild(gutter);
        return ()=>parent?.removeChild(gutter);
    }
    var $5d3c8dc07d034971$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
        const { getScrollElement: getScrollElement, gutterSize: gutterSize = $5d3c8dc07d034971$var$GUTTER_SIZE_IN_PX } = pluginOptions;
        if (!getScrollElement) return undefined;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey),
            state: {
                init: ()=>({}),
                apply: (tr, pluginState)=>{
                    if (tr.getMeta((0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey))) return tr.getMeta((0, (0, parcelRequire("6OgMR")).scrollGutterPluginKey));
                    return pluginState;
                }
            },
            props: {
                scrollThreshold: gutterSize,
                scrollMargin: gutterSize
            },
            view (view) {
                const scrollElement = getScrollElement(view);
                let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
                let editorParentElement = editorElement?.parentElement;
                let cleanup = ()=>{};
                if (editorParentElement && scrollElement) cleanup = $5d3c8dc07d034971$var$createGutter(gutterSize, editorParentElement);
                return {
                    destroy () {
                        cleanup();
                        editorParentElement = editorElement = null;
                    }
                };
            }
        });
    };
});
parcelRegister("jvNn7", function(module, exports) {
    $parcel$export(module.exports, "inputTracking", ()=>$48be400c3ac5f063$export$30b652f8daa79df4);
    const $48be400c3ac5f063$export$30b652f8daa79df4 = {
        enabled: true,
        samplingRate: 100,
        countNodes: true,
        trackSeverity: true,
        trackRenderingTime: false,
        trackSingleKeypress: false,
        severityDegradedThreshold: 273,
        severityNormalThreshold: 143
    };
});
parcelRegister("at6Ig", function(module, exports) {
    $parcel$export(module.exports, "betterTypeHistoryPlugin", ()=>(parcelRequire("kiLfG")).betterTypeHistoryPlugin);
    var $kiLfG;
});
parcelRegister("kiLfG", function(module, exports) {
    $parcel$export(module.exports, "betterTypeHistoryPlugin", ()=>$10c9d21a664b94c0$export$5587393ddd97118a);
    var $jkD4K;
    var $jsq8Z;
    const $10c9d21a664b94c0$export$5587393ddd97118a = ()=>{
        return {
            name: 'betterTypeHistory',
            actions: {
                flagPasteEvent (tr) {
                    tr.setMeta((0, (0, parcelRequire("jsq8Z")).pluginKey), true);
                    return tr;
                }
            },
            pmPlugins () {
                return [
                    {
                        name: 'betterTypeHistory',
                        plugin: ()=>(0, (0, parcelRequire("jkD4K")).default)()
                    }
                ];
            }
        };
    };
});
parcelRegister("jkD4K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f65bcd99d0e862c8$export$2e2bcd8739ae039);
    var $5KWxh;
    var $594Yf;
    var $fZzhT;
    var $kCV8T;
    var $gZGBX;
    var $eS2Dn;
    var $jsq8Z;
    const $f65bcd99d0e862c8$var$getEnterKeyboardActionStep = (trs)=>{
        const firstTr = trs.length === 1 && trs[0];
        if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return null;
        const { selection: selection, steps: steps } = firstTr;
        const replaceSteps = steps.filter((step)=>step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep));
        if (!selection.$cursor || replaceSteps.length !== 1) return null;
        return replaceSteps[0];
    };
    const $f65bcd99d0e862c8$var$isSliceSplittingBlockNode = (slice)=>{
        const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
        if (!hasOnlyTwoChildren) return false;
        const firstNode = slice.content.child(0);
        const secondNode = slice.content.child(1);
        return firstNode && secondNode && firstNode.type === secondNode.type;
    };
    const $f65bcd99d0e862c8$var$isSliceAddingNewlineChar = (slice, schema)=>{
        const newLine = (0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text('\n'));
        return slice.content.eq(newLine);
    };
    var $f65bcd99d0e862c8$export$2e2bcd8739ae039 = ()=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("jsq8Z")).pluginKey),
            appendTransaction: (transactions, oldState, newState)=>{
                const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, (0, parcelRequire("jsq8Z")).pluginKey)));
                if (hasHandlePasteMeta) return (0, (0, parcelRequire("fZzhT")).closeHistory)(newState.tr);
                const enterStep = $f65bcd99d0e862c8$var$getEnterKeyboardActionStep(transactions);
                if (!enterStep) return;
                const slice = (0, (0, parcelRequire("594Yf")).extractSliceFromStep)(enterStep);
                const { schema: schema } = newState;
                if (slice && ($f65bcd99d0e862c8$var$isSliceSplittingBlockNode(slice) || $f65bcd99d0e862c8$var$isSliceAddingNewlineChar(slice, schema))) return (0, (0, parcelRequire("fZzhT")).closeHistory)(newState.tr);
            }
        });
    };
});
parcelRegister("jsq8Z", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$1d2020e42b3f90c2$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $1d2020e42b3f90c2$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('betterTypeHistoryPlugin');
});
parcelRegister("aboEQ", function(module, exports) {
    $parcel$export(module.exports, "blockTypePlugin", ()=>(parcelRequire("2hnN6")).blockTypePlugin);
    var $2hnN6;
});
parcelRegister("2hnN6", function(module, exports) {
    $parcel$export(module.exports, "blockTypePlugin", ()=>$968ed2855767f974$export$896c3d927d705025);
    var $5uXOq = parcelRequire("5uXOq");
    var $aXBFx;
    var $jnMM2;
    var $lRTZM;
    var $gkwXh;
    var $6cqU9;
    var $e9qoo;
    var $9NKqk;
    var $I02Nt;
    var $kXC89;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $iJp6U;
    var $iJp6U;
    var $eKy27;
    var $kdso8;
    var $5pNa3;
    var $6AEe7;
    var $62ifj;
    const $968ed2855767f974$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
        if (!isAllowed) return [];
        return Array.from({
            length: 6
        }, (_v, idx)=>{
            const level = idx + 1;
            const descriptionDescriptor = (0, (0, parcelRequire("9NKqk")).messages)[`heading${level}Description`];
            const keyshortcut = (0, (0, parcelRequire("e9qoo")).tooltip)((0, (0, parcelRequire("6cqU9")).keymap)[`toggleHeading${level}`]);
            const id = `heading${level}`;
            return {
                id: id,
                title: formatMessage((0, (0, parcelRequire("9NKqk")).messages)[id]),
                description: formatMessage(descriptionDescriptor),
                priority: 1300,
                keywords: [
                    `h${level}`
                ],
                keyshortcut: keyshortcut,
                icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconHeading), {
                        level: level
                    }),
                action (insert, state) {
                    const tr = insert(state.schema.nodes.heading.createChecked({
                        level: level
                    }));
                    editorAnalyticsApi?.attachAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_HEADING,
                        attributes: {
                            inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT,
                            newHeadingLevel: level
                        }
                    })(tr);
                    return tr;
                }
            };
        });
    };
    const $968ed2855767f974$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
        if (!isAllowed) return [];
        return [
            {
                id: 'blockquote',
                title: formatMessage((0, (0, parcelRequire("9NKqk")).messages).blockquote),
                description: formatMessage((0, (0, parcelRequire("9NKqk")).messages).blockquoteDescription),
                priority: 1300,
                keyshortcut: '>',
                icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconQuote), null),
                action (insert, state) {
                    const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                    editorAnalyticsApi?.attachAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                        attributes: {
                            inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT
                        }
                    })(tr);
                    return tr;
                }
            }
        ];
    };
    const $968ed2855767f974$export$896c3d927d705025 = ({ config: options, api: api })=>{
        const isNestingInQuoteSchemaChanged = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_nest_in_quotes_adf_change') || (0, (0, parcelRequire("VSDnB")).fg)('editor_nest_media_and_codeblock_in_quotes_jira');
        const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
            let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL : toolbarSize < (0, (0, parcelRequire("kXC89")).ToolbarSize).XL;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, (0, parcelRequire("kXC89")).ToolbarSize).XXL;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("62ifj")).PrimaryToolbarComponent), {
                isSmall: isSmall,
                disabled: disabled,
                isToolbarReducedSpacing: isToolbarReducedSpacing,
                api: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                shouldUseDefaultRole: false
            });
        };
        api?.primaryToolbar?.actions.registerComponent({
            name: 'blockType',
            component: primaryToolbarComponent
        });
        return {
            name: 'blockType',
            nodes () {
                const nodes = [
                    {
                        name: 'heading',
                        node: (0, (0, parcelRequire("lRTZM")).heading)
                    },
                    {
                        name: 'blockquote',
                        node: isNestingInQuoteSchemaChanged ? (0, (0, parcelRequire("aXBFx")).blockquoteWithNestedCodeblockOrMedia) : (0, (0, parcelRequire("aXBFx")).blockquoteWithList)
                    },
                    {
                        name: 'hardBreak',
                        node: (0, (0, parcelRequire("jnMM2")).hardBreak)
                    }
                ];
                if (options && options.allowBlockType) {
                    const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
                }
                return nodes;
            },
            pmPlugins () {
                return [
                    {
                        name: 'blockType',
                        plugin: ({ dispatch: dispatch })=>(0, (0, parcelRequire("5pNa3")).createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph)
                    },
                    {
                        name: 'blockTypeInputRule',
                        plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, (0, parcelRequire("eKy27")).default)(api?.analytics?.actions, schema, featureFlags)
                    },
                    {
                        name: 'blockTypeKeyMap',
                        plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, (0, parcelRequire("kdso8")).default)(api?.analytics?.actions, schema, featureFlags)
                    }
                ];
            },
            actions: {
                insertBlockQuote (inputMethod) {
                    return (0, (0, parcelRequire("iJp6U")).insertBlockQuoteWithAnalytics)(inputMethod, api?.analytics?.actions);
                }
            },
            commands: {
                setTextLevel (level, inputMethod) {
                    return (0, (0, parcelRequire("iJp6U")).setBlockTypeWithAnalytics)(level, inputMethod, api?.analytics?.actions);
                }
            },
            getSharedState (editorState) {
                if (!editorState) return;
                return (0, (0, parcelRequire("5pNa3")).pluginKey).getState(editorState);
            },
            primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
            pluginsOptions: {
                selectionToolbar: ()=>{
                    if ((0, $gmhCD.editorExperiment)('contextual_formatting_toolbar', true)) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view, _idx, _dispatchAnalyticsEvent)=>{
                                if (!view) return;
                                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6AEe7")).FloatingToolbarComponent), {
                                    api: api
                                });
                            },
                            fallback: []
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ]
                        };
                    } else return undefined;
                },
                quickInsert: (intl)=>{
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$968ed2855767f974$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                        ...$968ed2855767f974$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                    ];
                }
            }
        };
    };
});
parcelRegister("e9qoo", function(module, exports) {
    $parcel$export(module.exports, "addAltText", ()=>$fd6a91b3693b55d8$export$82527b23b485fa7f);
    $parcel$export(module.exports, "navToEditorToolbar", ()=>$fd6a91b3693b55d8$export$9288bbefb6b7498b);
    $parcel$export(module.exports, "navToFloatingToolbar", ()=>$fd6a91b3693b55d8$export$7be006a99a30f86b);
    $parcel$export(module.exports, "toggleBold", ()=>$fd6a91b3693b55d8$export$183fe6d20e9e58ba);
    $parcel$export(module.exports, "toggleItalic", ()=>$fd6a91b3693b55d8$export$b03177f345903916);
    $parcel$export(module.exports, "toggleUnderline", ()=>$fd6a91b3693b55d8$export$6bcc93697958b66d);
    $parcel$export(module.exports, "toggleStrikethrough", ()=>$fd6a91b3693b55d8$export$6d564ba4eaf138d9);
    $parcel$export(module.exports, "toggleSubscript", ()=>$fd6a91b3693b55d8$export$d26ab98fee0c804);
    $parcel$export(module.exports, "toggleSuperscript", ()=>$fd6a91b3693b55d8$export$4af6b58e12324fd);
    $parcel$export(module.exports, "toggleCode", ()=>$fd6a91b3693b55d8$export$70686c6e7e15ed46);
    $parcel$export(module.exports, "pastePlainText", ()=>$fd6a91b3693b55d8$export$ab06dc742bb20e03);
    $parcel$export(module.exports, "clearFormatting", ()=>$fd6a91b3693b55d8$export$195de5d8e201efd7);
    $parcel$export(module.exports, "setNormalText", ()=>$fd6a91b3693b55d8$export$63c4f0859cc75dc6);
    $parcel$export(module.exports, "toggleHeading1", ()=>$fd6a91b3693b55d8$export$953ab0e6a5d310a9);
    $parcel$export(module.exports, "toggleHeading2", ()=>$fd6a91b3693b55d8$export$192a351cfd6ca247);
    $parcel$export(module.exports, "toggleHeading3", ()=>$fd6a91b3693b55d8$export$fe382f3f4c871c62);
    $parcel$export(module.exports, "toggleHeading4", ()=>$fd6a91b3693b55d8$export$4073e08db19e0e31);
    $parcel$export(module.exports, "toggleHeading5", ()=>$fd6a91b3693b55d8$export$b84e85b2035ddb39);
    $parcel$export(module.exports, "toggleHeading6", ()=>$fd6a91b3693b55d8$export$86b1ac99fd15509b);
    $parcel$export(module.exports, "toggleOrderedList", ()=>$fd6a91b3693b55d8$export$dca848a1b50b6a31);
    $parcel$export(module.exports, "toggleBulletList", ()=>$fd6a91b3693b55d8$export$c0e115f47553645e);
    $parcel$export(module.exports, "toggleBlockQuote", ()=>$fd6a91b3693b55d8$export$34ed0cbd4f7ff88);
    $parcel$export(module.exports, "insertNewLine", ()=>$fd6a91b3693b55d8$export$c2d9390f63354627);
    $parcel$export(module.exports, "insertRule", ()=>$fd6a91b3693b55d8$export$5f13bbad564673d4);
    $parcel$export(module.exports, "undo", ()=>$fd6a91b3693b55d8$export$21f930c44940fd98);
    $parcel$export(module.exports, "moveUp", ()=>$fd6a91b3693b55d8$export$44935f8a884b57b9);
    $parcel$export(module.exports, "moveDown", ()=>$fd6a91b3693b55d8$export$8eba228b343b3599);
    $parcel$export(module.exports, "moveLeft", ()=>$fd6a91b3693b55d8$export$108f27160c89e515);
    $parcel$export(module.exports, "moveRight", ()=>$fd6a91b3693b55d8$export$e2c874fbfec7201);
    $parcel$export(module.exports, "indentList", ()=>$fd6a91b3693b55d8$export$8066a906978eedb2);
    $parcel$export(module.exports, "outdentList", ()=>$fd6a91b3693b55d8$export$959569198ddbbe17);
    $parcel$export(module.exports, "redo", ()=>$fd6a91b3693b55d8$export$1688e416fee0a49e);
    $parcel$export(module.exports, "openHelp", ()=>$fd6a91b3693b55d8$export$1e2fd7795238a2d3);
    $parcel$export(module.exports, "addLink", ()=>$fd6a91b3693b55d8$export$56b88caa6d8a3bff);
    $parcel$export(module.exports, "addInlineComment", ()=>$fd6a91b3693b55d8$export$fd78ad47ea0892f4);
    $parcel$export(module.exports, "submit", ()=>$fd6a91b3693b55d8$export$853c27de4ce0f746);
    $parcel$export(module.exports, "enter", ()=>$fd6a91b3693b55d8$export$e668df1bcd81e4d2);
    $parcel$export(module.exports, "tab", ()=>$fd6a91b3693b55d8$export$62d58b1c91e8e902);
    $parcel$export(module.exports, "indent", ()=>$fd6a91b3693b55d8$export$79ebfa808dffa5c6);
    $parcel$export(module.exports, "outdent", ()=>$fd6a91b3693b55d8$export$25755c0352544598);
    $parcel$export(module.exports, "backspace", ()=>$fd6a91b3693b55d8$export$1ea584ca7009bcc1);
    $parcel$export(module.exports, "deleteKey", ()=>$fd6a91b3693b55d8$export$9603e93cdf38d7);
    $parcel$export(module.exports, "forwardDelete", ()=>$fd6a91b3693b55d8$export$9e41eded5cb7e706);
    $parcel$export(module.exports, "escape", ()=>$fd6a91b3693b55d8$export$4e7f196112fea3c5);
    $parcel$export(module.exports, "nextCell", ()=>$fd6a91b3693b55d8$export$172699367bb25225);
    $parcel$export(module.exports, "previousCell", ()=>$fd6a91b3693b55d8$export$69838570e03d7193);
    $parcel$export(module.exports, "shiftArrowUp", ()=>$fd6a91b3693b55d8$export$776c0cd47234205a);
    $parcel$export(module.exports, "shiftTab", ()=>$fd6a91b3693b55d8$export$9ad63694f5781e16);
    $parcel$export(module.exports, "toggleTable", ()=>$fd6a91b3693b55d8$export$33b9473b3f67763f);
    $parcel$export(module.exports, "focusTableResizer", ()=>$fd6a91b3693b55d8$export$a57fbe0d9c764ae0);
    $parcel$export(module.exports, "addRowBefore", ()=>$fd6a91b3693b55d8$export$2e3087448cf87857);
    $parcel$export(module.exports, "addRowAfter", ()=>$fd6a91b3693b55d8$export$fbcf51cabbe4a007);
    $parcel$export(module.exports, "addColumnAfter", ()=>$fd6a91b3693b55d8$export$bf95f7b7d259c19f);
    $parcel$export(module.exports, "addColumnBefore", ()=>$fd6a91b3693b55d8$export$717d5ccb817cdecc);
    $parcel$export(module.exports, "addRowBeforeVO", ()=>$fd6a91b3693b55d8$export$5851c701392d3bfd);
    $parcel$export(module.exports, "addRowAfterVO", ()=>$fd6a91b3693b55d8$export$73fa63faf0fd6077);
    $parcel$export(module.exports, "addColumnAfterVO", ()=>$fd6a91b3693b55d8$export$875b853996fced8d);
    $parcel$export(module.exports, "addColumnBeforeVO", ()=>$fd6a91b3693b55d8$export$414418ca306c22bd);
    $parcel$export(module.exports, "moveColumnLeft", ()=>$fd6a91b3693b55d8$export$f092689a35ce978d);
    $parcel$export(module.exports, "moveColumnRight", ()=>$fd6a91b3693b55d8$export$863ee96d9e15383b);
    $parcel$export(module.exports, "moveRowDown", ()=>$fd6a91b3693b55d8$export$13c2dd2d968ada2a);
    $parcel$export(module.exports, "moveRowUp", ()=>$fd6a91b3693b55d8$export$e6749a6fc243b921);
    $parcel$export(module.exports, "deleteColumn", ()=>$fd6a91b3693b55d8$export$f4f2d7d33085c714);
    $parcel$export(module.exports, "deleteRow", ()=>$fd6a91b3693b55d8$export$2ef39e5ffdaff9ed);
    $parcel$export(module.exports, "startColumnResizing", ()=>$fd6a91b3693b55d8$export$8f58457f1327dd26);
    $parcel$export(module.exports, "find", ()=>$fd6a91b3693b55d8$export$71aa6c912b956294);
    $parcel$export(module.exports, "alignLeft", ()=>$fd6a91b3693b55d8$export$ca42dd9a1a0eb501);
    $parcel$export(module.exports, "alignCenter", ()=>$fd6a91b3693b55d8$export$f4a51ff076cc9a09);
    $parcel$export(module.exports, "alignRight", ()=>$fd6a91b3693b55d8$export$faf8793e4a37a5a2);
    $parcel$export(module.exports, "toggleTaskItemCheckbox", ()=>$fd6a91b3693b55d8$export$6f041e7a1d88fa51);
    $parcel$export(module.exports, "selectRow", ()=>$fd6a91b3693b55d8$export$e247ed8cec4832f4);
    $parcel$export(module.exports, "selectColumn", ()=>$fd6a91b3693b55d8$export$c2e8772deb1607ea);
    $parcel$export(module.exports, "selectTable", ()=>$fd6a91b3693b55d8$export$625c5b9bf13f01a8);
    $parcel$export(module.exports, "increaseMediaSize", ()=>$fd6a91b3693b55d8$export$fdeca4160ac263c5);
    $parcel$export(module.exports, "decreaseMediaSize", ()=>$fd6a91b3693b55d8$export$5ec5f857fec297eb);
    $parcel$export(module.exports, "activateVideoControls", ()=>$fd6a91b3693b55d8$export$36141559a83247ee);
    $parcel$export(module.exports, "toggleHighlightPalette", ()=>$fd6a91b3693b55d8$export$ec123199f2fe4770);
    $parcel$export(module.exports, "focusToContextMenuTrigger", ()=>$fd6a91b3693b55d8$export$6b05735f625d1c82);
    $parcel$export(module.exports, "continueInRovoChat", ()=>$fd6a91b3693b55d8$export$54f122e0d55178a9);
    $parcel$export(module.exports, "formatShortcut", ()=>$fd6a91b3693b55d8$export$384a290f8c265cc5);
    $parcel$export(module.exports, "tooltip", ()=>$fd6a91b3693b55d8$export$4e6f96734dfe12f4);
    $parcel$export(module.exports, "ToolTipContent", ()=>$fd6a91b3693b55d8$export$4096cb8ab9668358);
    $parcel$export(module.exports, "findKeymapByDescription", ()=>$fd6a91b3693b55d8$export$c4e6735ce96cc7b3);
    $parcel$export(module.exports, "findShortcutByKeymap", ()=>$fd6a91b3693b55d8$export$d69faf3b7bc3451);
    $parcel$export(module.exports, "getAriaKeyshortcuts", ()=>$fd6a91b3693b55d8$export$6db28e5c399297b0);
    $parcel$export(module.exports, "bindKeymapWithCommand", ()=>$fd6a91b3693b55d8$export$4bced0ac29aaf950);
    $parcel$export(module.exports, "bindKeymapArrayWithCommand", ()=>$fd6a91b3693b55d8$export$e40cfdbcfa26f180);
    $parcel$export(module.exports, "bindKeymapWithEditorCommand", ()=>$fd6a91b3693b55d8$export$b87d3e1cb85f0ba1);
    $parcel$export(module.exports, "findKeyMapForBrowser", ()=>$fd6a91b3693b55d8$export$b2dbe47650bcfa54);
    $parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", ()=>$fd6a91b3693b55d8$export$f2da701c7659a26c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $1SLCf = parcelRequire("1SLCf");
    var $31nwk;
    var $gE8f9;
    var $6cqU9;
    const $fd6a91b3693b55d8$export$82527b23b485fa7f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
    const $fd6a91b3693b55d8$export$9288bbefb6b7498b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
    const $fd6a91b3693b55d8$export$7be006a99a30f86b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
    const $fd6a91b3693b55d8$export$183fe6d20e9e58ba = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bold', 'Mod-b');
    const $fd6a91b3693b55d8$export$b03177f345903916 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Italic', 'Mod-i');
    const $fd6a91b3693b55d8$export$6bcc93697958b66d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Underline', 'Mod-u');
    const $fd6a91b3693b55d8$export$6d564ba4eaf138d9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
    const $fd6a91b3693b55d8$export$d26ab98fee0c804 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
    const $fd6a91b3693b55d8$export$4af6b58e12324fd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
    const $fd6a91b3693b55d8$export$70686c6e7e15ed46 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
    const $fd6a91b3693b55d8$export$ab06dc742bb20e03 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
    const $fd6a91b3693b55d8$export$195de5d8e201efd7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
    const $fd6a91b3693b55d8$export$63c4f0859cc75dc6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
    const $fd6a91b3693b55d8$export$953ab0e6a5d310a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
    const $fd6a91b3693b55d8$export$192a351cfd6ca247 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
    const $fd6a91b3693b55d8$export$fe382f3f4c871c62 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
    const $fd6a91b3693b55d8$export$4073e08db19e0e31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
    const $fd6a91b3693b55d8$export$b84e85b2035ddb39 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
    const $fd6a91b3693b55d8$export$86b1ac99fd15509b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
    const $fd6a91b3693b55d8$export$dca848a1b50b6a31 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
    const $fd6a91b3693b55d8$export$17f69a767ce93bb3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
    const $fd6a91b3693b55d8$export$c0e115f47553645e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
    const $fd6a91b3693b55d8$export$34ed0cbd4f7ff88 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
    const $fd6a91b3693b55d8$export$c2d9390f63354627 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
    const $fd6a91b3693b55d8$export$dfd73a1c108b1570 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
    const $fd6a91b3693b55d8$export$9e5a9569a07601f2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split code block', 'Enter');
    const $fd6a91b3693b55d8$export$e920ee2eb756d384 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Split list item', 'Enter');
    const $fd6a91b3693b55d8$export$5f13bbad564673d4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
    const $fd6a91b3693b55d8$export$21f930c44940fd98 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Undo', 'Mod-z');
    const $fd6a91b3693b55d8$export$44935f8a884b57b9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
    const $fd6a91b3693b55d8$export$8eba228b343b3599 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
    const $fd6a91b3693b55d8$export$108f27160c89e515 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
    const $fd6a91b3693b55d8$export$e2c874fbfec7201 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
    const $fd6a91b3693b55d8$export$8066a906978eedb2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent List', 'Tab');
    const $fd6a91b3693b55d8$export$959569198ddbbe17 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
    const $fd6a91b3693b55d8$export$1688e416fee0a49e = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
    const $fd6a91b3693b55d8$export$1e2fd7795238a2d3 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
    const $fd6a91b3693b55d8$export$56b88caa6d8a3bff = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Link', 'Mod-k');
    const $fd6a91b3693b55d8$export$fd78ad47ea0892f4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
    const $fd6a91b3693b55d8$export$853c27de4ce0f746 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
    const $fd6a91b3693b55d8$export$e668df1bcd81e4d2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Enter', 'Enter');
    const $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
    const $fd6a91b3693b55d8$export$62d58b1c91e8e902 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Tab', 'Tab');
    const $fd6a91b3693b55d8$export$79ebfa808dffa5c6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Indent', 'Tab');
    const $fd6a91b3693b55d8$export$25755c0352544598 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
    const $fd6a91b3693b55d8$export$1ea584ca7009bcc1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Backspace', 'Backspace');
    const $fd6a91b3693b55d8$export$9603e93cdf38d7 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete', 'Delete');
    const $fd6a91b3693b55d8$export$9e41eded5cb7e706 = $fd6a91b3693b55d8$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
    const $fd6a91b3693b55d8$export$a941ed4b947d12f8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Space', 'Space');
    const $fd6a91b3693b55d8$export$4e7f196112fea3c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Escape', 'Escape');
    const $fd6a91b3693b55d8$export$172699367bb25225 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Next cell', 'Tab');
    const $fd6a91b3693b55d8$export$69838570e03d7193 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
    const $fd6a91b3693b55d8$export$776c0cd47234205a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
    const $fd6a91b3693b55d8$export$9ad63694f5781e16 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
    const $fd6a91b3693b55d8$export$33b9473b3f67763f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
    const $fd6a91b3693b55d8$export$a57fbe0d9c764ae0 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
    const $fd6a91b3693b55d8$export$2e3087448cf87857 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
    const $fd6a91b3693b55d8$export$fbcf51cabbe4a007 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
    const $fd6a91b3693b55d8$export$bf95f7b7d259c19f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
    const $fd6a91b3693b55d8$export$717d5ccb817cdecc = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
    const $fd6a91b3693b55d8$export$5851c701392d3bfd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
    const $fd6a91b3693b55d8$export$73fa63faf0fd6077 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
    const $fd6a91b3693b55d8$export$875b853996fced8d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
    const $fd6a91b3693b55d8$export$414418ca306c22bd = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
    const $fd6a91b3693b55d8$export$f092689a35ce978d = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
    const $fd6a91b3693b55d8$export$863ee96d9e15383b = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
    const $fd6a91b3693b55d8$export$13c2dd2d968ada2a = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
    const $fd6a91b3693b55d8$export$e6749a6fc243b921 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
    const $fd6a91b3693b55d8$export$f4f2d7d33085c714 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
    const $fd6a91b3693b55d8$export$2ef39e5ffdaff9ed = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
    const $fd6a91b3693b55d8$export$8f58457f1327dd26 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
    const $fd6a91b3693b55d8$export$af2a99f971a346e6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Cut', 'Mod-x');
    const $fd6a91b3693b55d8$export$784d13d8ee351f07 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Copy', 'Mod-c');
    const $fd6a91b3693b55d8$export$9b6706c8686cfc8e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-v');
    const $fd6a91b3693b55d8$export$3c1455b21d3e7aab = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
    const $fd6a91b3693b55d8$export$71aa6c912b956294 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Find', 'Mod-f');
    const $fd6a91b3693b55d8$export$ca42dd9a1a0eb501 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
    const $fd6a91b3693b55d8$export$f4a51ff076cc9a09 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
    const $fd6a91b3693b55d8$export$faf8793e4a37a5a2 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
    const $fd6a91b3693b55d8$export$6f041e7a1d88fa51 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
    const $fd6a91b3693b55d8$export$e247ed8cec4832f4 = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select row', [
        'Mod-Alt-Shift-ArrowLeft',
        'Mod-Alt-Shift-ArrowRight'
    ]);
    const $fd6a91b3693b55d8$export$c2e8772deb1607ea = $fd6a91b3693b55d8$export$5882c1dfa05eb556('Select column', [
        'Mod-Alt-Shift-ArrowDown',
        'Mod-Alt-Shift-ArrowUp'
    ]);
    const $fd6a91b3693b55d8$export$625c5b9bf13f01a8 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Select table', 'Mod-a');
    const $fd6a91b3693b55d8$export$fdeca4160ac263c5 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
    const $fd6a91b3693b55d8$export$5ec5f857fec297eb = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
    const $fd6a91b3693b55d8$export$36141559a83247ee = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
    const $fd6a91b3693b55d8$export$ec123199f2fe4770 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
    const $fd6a91b3693b55d8$export$6b05735f625d1c82 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
    const $fd6a91b3693b55d8$export$a1bdda43619f945f = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
    const $fd6a91b3693b55d8$export$9bf312985dc8137e = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
    const $fd6a91b3693b55d8$export$c4f661b85fc92fd1 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
    const $fd6a91b3693b55d8$export$61c867f4a21787f6 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
    const $fd6a91b3693b55d8$export$ba34d2a4e6aa10e4 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
    const $fd6a91b3693b55d8$export$54f122e0d55178a9 = $fd6a91b3693b55d8$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
    const $fd6a91b3693b55d8$var$arrowKeysMap = {
        ARROWLEFT: '\u2190',
        ARROWRIGHT: '\u2192',
        ARROWUP: '\u2191',
        ARROWDOWN: '\u2193'
    };
    const $fd6a91b3693b55d8$var$tooltipShortcutStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: '2px',
        backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
        padding: `0 ${"var(--ds-space-025, 2px)"}`,
        label: 'tooltip-shortcut'
    });
    function $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap) {
        let shortcut;
        if ((0, (0, parcelRequire("gE8f9")).browser).mac) shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
        else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
        const keys = shortcut.split('-');
        let lastKey = keys[keys.length - 1];
        if (lastKey.length === 1) lastKey = lastKey.toUpperCase();
        keys[keys.length - 1] = $fd6a91b3693b55d8$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
        return keys.join((0, (0, parcelRequire("gE8f9")).browser).mac ? '' : '+');
    }
    function $fd6a91b3693b55d8$export$4e6f96734dfe12f4(keymap, description) {
        if (keymap) {
            const shortcut = $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
            return description ? `${description} ${shortcut}` : shortcut;
        }
        return;
    }
    const $fd6a91b3693b55d8$export$4096cb8ab9668358 = (0, ($parcel$interopDefault($5uXOq))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
        const shortcut = shortcutOverride || keymap && $fd6a91b3693b55d8$export$384a290f8c265cc5(keymap);
        return shortcut || description ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, description, shortcut && description && '\u00A0', shortcut && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $fd6a91b3693b55d8$var$tooltipShortcutStyle
        }, shortcut)) : null;
    });
    const $fd6a91b3693b55d8$export$9f7e5fe6d45c5f7 = (0, ($parcel$interopDefault($5uXOq))).memo(({ helpDescriptors: helpDescriptors })=>{
        const keymapCount = helpDescriptors.length;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, helpDescriptors.map((descriptor, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), {
                key: index
            }, (0, (0, parcelRequire("f8Sb3")).jsx)($fd6a91b3693b55d8$export$4096cb8ab9668358, descriptor), " ", index < keymapCount - 1 && (0, (0, parcelRequire("f8Sb3")).jsx)("br", null))));
    });
    function $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description) {
        const matches = $fd6a91b3693b55d8$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
        return matches[0];
    }
    function $fd6a91b3693b55d8$export$ca66063a345ce3ab(description) {
        const keymap = $fd6a91b3693b55d8$export$c4e6735ce96cc7b3(description);
        if (keymap) return $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap);
        return;
    }
    function $fd6a91b3693b55d8$export$d69faf3b7bc3451(keymap) {
        if ((0, (0, parcelRequire("gE8f9")).browser).mac) return keymap.mac;
        return keymap.windows;
    }
    function $fd6a91b3693b55d8$export$6db28e5c399297b0(keymap) {
        let keyShortcuts;
        if (typeof keymap === 'string') keyShortcuts = keymap;
        else if (typeof keymap === 'object') keyShortcuts = keymap[(0, (0, parcelRequire("gE8f9")).browser).mac ? 'mac' : 'windows'];
        if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').map((modifier)=>{
            switch(modifier){
                case 'cmd':
                    return 'Meta';
                case 'ctrl':
                    return 'Control';
                case 'alt':
                    return 'Alt';
                case 'shift':
                    return 'Shift';
                case 'enter':
                    return 'Enter';
                case 'esc':
                    return 'Esc';
                case 'tab':
                    return 'Tab';
                case 'space':
                    return 'Space';
                case 'backspace':
                    return 'Backspace';
                case 'arrowup':
                    return 'Arrow Up';
                case 'arrowdown':
                    return 'Arrow Down';
                default:
                    return modifier.split('').join(' ');
            }
        }).join('+');
        else return undefined;
    }
    const $fd6a91b3693b55d8$var$ALL = [
        $fd6a91b3693b55d8$export$dca848a1b50b6a31,
        $fd6a91b3693b55d8$export$c0e115f47553645e,
        $fd6a91b3693b55d8$export$183fe6d20e9e58ba,
        $fd6a91b3693b55d8$export$b03177f345903916,
        $fd6a91b3693b55d8$export$6bcc93697958b66d,
        $fd6a91b3693b55d8$export$6d564ba4eaf138d9,
        $fd6a91b3693b55d8$export$d26ab98fee0c804,
        $fd6a91b3693b55d8$export$4af6b58e12324fd,
        $fd6a91b3693b55d8$export$70686c6e7e15ed46,
        $fd6a91b3693b55d8$export$63c4f0859cc75dc6,
        $fd6a91b3693b55d8$export$953ab0e6a5d310a9,
        $fd6a91b3693b55d8$export$192a351cfd6ca247,
        $fd6a91b3693b55d8$export$fe382f3f4c871c62,
        $fd6a91b3693b55d8$export$4073e08db19e0e31,
        $fd6a91b3693b55d8$export$b84e85b2035ddb39,
        $fd6a91b3693b55d8$export$86b1ac99fd15509b,
        $fd6a91b3693b55d8$export$34ed0cbd4f7ff88,
        $fd6a91b3693b55d8$export$c2d9390f63354627,
        $fd6a91b3693b55d8$export$5f13bbad564673d4,
        $fd6a91b3693b55d8$export$9e5a9569a07601f2,
        $fd6a91b3693b55d8$export$e920ee2eb756d384,
        $fd6a91b3693b55d8$export$1688e416fee0a49e,
        $fd6a91b3693b55d8$export$21f930c44940fd98,
        $fd6a91b3693b55d8$export$71aa6c912b956294,
        $fd6a91b3693b55d8$export$4e7f196112fea3c5,
        $fd6a91b3693b55d8$export$e668df1bcd81e4d2,
        $fd6a91b3693b55d8$export$9f99fe2ed5bb7a29
    ];
    function $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common) {
        return {
            description: description,
            windows: windows.replace(/Mod/i, 'Ctrl'),
            mac: mac.replace(/Mod/i, 'Cmd'),
            common: common
        };
    }
    function $fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, common) {
        const windows = common.replace(/Mod/i, 'Ctrl');
        const mac = common.replace(/Mod/i, 'Cmd');
        return $fd6a91b3693b55d8$export$d8a7f422d8d42038(description, windows, mac, common);
    }
    function $fd6a91b3693b55d8$export$5882c1dfa05eb556(description, shortcuts) {
        const keymapArray = [];
        shortcuts.forEach((shortcut)=>{
            keymapArray.push($fd6a91b3693b55d8$export$7e6b588cc98b34f1(description, shortcut));
        });
        return keymapArray;
    }
    function $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) {
        return (state, dispatch, editorView)=>{
            return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
        };
    }
    function $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
        const oldCmd = keymap[shortcut];
        keymap[shortcut] = oldCmd ? $fd6a91b3693b55d8$var$combineWithOldCommand(cmd, oldCmd) : cmd;
    }
    function $fd6a91b3693b55d8$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
        shortcutsArray.forEach((shortcut)=>{
            return $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
        });
    }
    function $fd6a91b3693b55d8$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
        $fd6a91b3693b55d8$export$4bced0ac29aaf950(shortcut, (0, (0, parcelRequire("31nwk")).editorCommandToPMCommand)(cmd), keymap);
    }
    function $fd6a91b3693b55d8$export$b2dbe47650bcfa54(keyMap) {
        if (keyMap) {
            if ((0, (0, parcelRequire("gE8f9")).browser).mac) return keyMap.mac;
            return keyMap.windows;
        }
        return;
    }
    function $fd6a91b3693b55d8$export$f2da701c7659a26c(event) {
        let keyboardEvent = event;
        const name = (0, $1SLCf.keyName)(event);
        if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && /^[A-Z]/.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
            key: (0, $1SLCf.base)[event.keyCode].toLowerCase(),
            code: event.code,
            ctrlKey: true
        });
        return keyboardEvent;
    }
});
parcelRegister("I02Nt", function(module, exports) {
    $parcel$export(module.exports, "IconAction", ()=>$513b94a8224240d6$export$e40fe94b4cff8ec5);
    $parcel$export(module.exports, "IconCode", ()=>$513b94a8224240d6$export$e332a83b9159d69d);
    $parcel$export(module.exports, "IconDate", ()=>$513b94a8224240d6$export$39617668a6028b06);
    $parcel$export(module.exports, "IconDecision", ()=>$513b94a8224240d6$export$6eb71591d1461541);
    $parcel$export(module.exports, "IconDivider", ()=>$513b94a8224240d6$export$f2ab17920c9d243);
    $parcel$export(module.exports, "IconEmoji", ()=>$513b94a8224240d6$export$8bd591d4b34dcafa);
    $parcel$export(module.exports, "IconImages", ()=>$513b94a8224240d6$export$c17cf1164355efc2);
    $parcel$export(module.exports, "IconLayout", ()=>$513b94a8224240d6$export$fba0c846789a9d87);
    $parcel$export(module.exports, "IconLink", ()=>$513b94a8224240d6$export$23da1e9f164f7ea1);
    $parcel$export(module.exports, "IconListNumber", ()=>$513b94a8224240d6$export$32f6affcc5f19c17);
    $parcel$export(module.exports, "IconList", ()=>$513b94a8224240d6$export$527d32aa1785fdd4);
    $parcel$export(module.exports, "IconMention", ()=>$513b94a8224240d6$export$de1d1a07ff53cf53);
    $parcel$export(module.exports, "IconPanelError", ()=>$513b94a8224240d6$export$a1c6b14f5f0a0c20);
    $parcel$export(module.exports, "IconPanelNote", ()=>$513b94a8224240d6$export$4d90d09f9e3039e);
    $parcel$export(module.exports, "IconPanelSuccess", ()=>$513b94a8224240d6$export$cc5c1cc765c068a0);
    $parcel$export(module.exports, "IconPanelWarning", ()=>$513b94a8224240d6$export$e728578e48814100);
    $parcel$export(module.exports, "IconPanel", ()=>$513b94a8224240d6$export$18978208c8652af3);
    $parcel$export(module.exports, "IconQuote", ()=>$513b94a8224240d6$export$2478ed0e296e2752);
    $parcel$export(module.exports, "IconStatus", ()=>$513b94a8224240d6$export$4635bc8225f90ec6);
    $parcel$export(module.exports, "IconTwoColumnLayout", ()=>$513b94a8224240d6$export$732a7fc4975ab5a4);
    $parcel$export(module.exports, "IconThreeColumnLayout", ()=>$513b94a8224240d6$export$fdfaf73f45072edb);
    $parcel$export(module.exports, "IconFourColumnLayout", ()=>$513b94a8224240d6$export$a1588f873a973762);
    $parcel$export(module.exports, "IconFiveColumnLayout", ()=>$513b94a8224240d6$export$ff1f32987b4c27d9);
    $parcel$export(module.exports, "IconHeading", ()=>$513b94a8224240d6$export$1a33a10ac24d7971);
    $parcel$export(module.exports, "IconFeedback", ()=>$513b94a8224240d6$export$e25449dcffb445e);
    $parcel$export(module.exports, "IconExpand", ()=>$513b94a8224240d6$export$209d03a445a7dc8e);
    $parcel$export(module.exports, "IconDatasourceJiraIssue", ()=>$513b94a8224240d6$export$c9b1dcefa7c9a7aa);
    $parcel$export(module.exports, "IconDatasourceAssetsObjects", ()=>$513b94a8224240d6$export$7d6f860161da0fa6);
    $parcel$export(module.exports, "IconDatasourceConfluenceSearch", ()=>$513b94a8224240d6$export$29a810fd0b8c3f03);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    const $513b94a8224240d6$export$e40fe94b4cff8ec5 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("bjq7P")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$e332a83b9159d69d = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("1w8rp")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$39617668a6028b06 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("7esG6")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$6eb71591d1461541 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("cIA68")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$f2ab17920c9d243 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("7csaN")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$8bd591d4b34dcafa = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("bY3XJ")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$c17cf1164355efc2 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("fRiSx")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$fba0c846789a9d87 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("2j30A")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$23da1e9f164f7ea1 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("aQK7B")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$32f6affcc5f19c17 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8nWNL")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$527d32aa1785fdd4 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("c17IE")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$de1d1a07ff53cf53 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("bD6B6")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$a1c6b14f5f0a0c20 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8XYNy")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$4d90d09f9e3039e = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("iP0s1")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$cc5c1cc765c068a0 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("cB5yX")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$e728578e48814100 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("iZh5x")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$18978208c8652af3 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("8fjcc")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$2478ed0e296e2752 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("5X72R")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$4635bc8225f90ec6 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("cHLHU")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$8f1e9e900568bfce = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("32VGt")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$732a7fc4975ab5a4 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("c7tky")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$fdfaf73f45072edb = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("51ffg")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$a1588f873a973762 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("e6yen")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$ff1f32987b4c27d9 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("3r5jy")).then((module)=>module.default),
        loading: ()=>null
    });
    function $513b94a8224240d6$var$importHeading(level) {
        switch(level){
            case 1:
                return (parcelRequire("4BdqG"));
            case 2:
                return (parcelRequire("gyWTq"));
            case 3:
                return (parcelRequire("3w21o"));
            case 4:
                return (parcelRequire("eoaBn"));
            case 5:
                return (parcelRequire("kZdo5"));
            case 6:
            default:
                return (parcelRequire("j5rWM"));
        }
    }
    const $513b94a8224240d6$export$1a33a10ac24d7971 = ({ level: level, ...props })=>{
        const Icon = (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>$513b94a8224240d6$var$importHeading(level).then((module)=>module.default),
            loading: ()=>null
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, props);
    };
    const $513b94a8224240d6$export$e25449dcffb445e = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("dpRfG")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$209d03a445a7dc8e = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("huAfq")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$c9b1dcefa7c9a7aa = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("1m3Bf")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$7d6f860161da0fa6 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("j1f3x")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$29a810fd0b8c3f03 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("d1io7")).then((module)=>module.default),
        loading: ()=>null
    });
    const $513b94a8224240d6$export$ccbb24eed51aea20 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("9kQm2")).then((module)=>module.default),
        loading: ()=>null
    });
});
parcelRegister("bjq7P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aH7nu").then(()=>parcelRequire('fGUVQ'));
});
parcelRegister("1w8rp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aPoaT").then(()=>parcelRequire('7mMCo'));
});
parcelRegister("7esG6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6qfEi").then(()=>parcelRequire('hhrZv'));
});
parcelRegister("cIA68", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j9Ncr").then(()=>parcelRequire('dWg6W'));
});
parcelRegister("7csaN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ahmZW").then(()=>parcelRequire('eAdWP'));
});
parcelRegister("bY3XJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cPvmS").then(()=>parcelRequire('i375O'));
});
parcelRegister("fRiSx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3V2y8").then(()=>parcelRequire('e88pi'));
});
parcelRegister("2j30A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cU9ce").then(()=>parcelRequire('7ZWch'));
});
parcelRegister("aQK7B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a05Bn").then(()=>parcelRequire('7AaHD'));
});
parcelRegister("8nWNL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8oQx9").then(()=>parcelRequire('2TyBm'));
});
parcelRegister("c17IE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("49Cyu").then(()=>parcelRequire('ieCqs'));
});
parcelRegister("bD6B6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iILx7").then(()=>parcelRequire('aIi75'));
});
parcelRegister("8XYNy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iUv8g").then(()=>parcelRequire('6m8b0'));
});
parcelRegister("iP0s1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bzHl5").then(()=>parcelRequire('hpPu5'));
});
parcelRegister("cB5yX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fDTYR").then(()=>parcelRequire('2d5K5'));
});
parcelRegister("iZh5x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3x7Og").then(()=>parcelRequire('j7B0X'));
});
parcelRegister("8fjcc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g1IYo").then(()=>parcelRequire('g2ofu'));
});
parcelRegister("5X72R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h2IHo").then(()=>parcelRequire('aWSsM'));
});
parcelRegister("cHLHU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("glTuS").then(()=>parcelRequire('clu4g'));
});
parcelRegister("32VGt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8mTi8").then(()=>parcelRequire('aKp87'));
});
parcelRegister("c7tky", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1ucv3").then(()=>parcelRequire('5a4B6'));
});
parcelRegister("51ffg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9mxsn").then(()=>parcelRequire('hZOiE'));
});
parcelRegister("e6yen", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("htes7").then(()=>parcelRequire('6P7Pf'));
});
parcelRegister("3r5jy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aoGCR").then(()=>parcelRequire('5ytLq'));
});
parcelRegister("4BdqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lx17z").then(()=>parcelRequire('dMM4v'));
});
parcelRegister("gyWTq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6eDig").then(()=>parcelRequire('6cKKb'));
});
parcelRegister("3w21o", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cVk2y").then(()=>parcelRequire('9iWN4'));
});
parcelRegister("eoaBn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3wW1N").then(()=>parcelRequire('eKOIc'));
});
parcelRegister("kZdo5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7OoHt").then(()=>parcelRequire('9OxUo'));
});
parcelRegister("j5rWM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hb1wm").then(()=>parcelRequire('dYSoJ'));
});
parcelRegister("dpRfG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aWjio").then(()=>parcelRequire('65bRZ'));
});
parcelRegister("huAfq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Qdct").then(()=>parcelRequire('hwHW3'));
});
parcelRegister("1m3Bf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("di0jw").then(()=>parcelRequire('aoo70'));
});
parcelRegister("j1f3x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kdjpy").then(()=>parcelRequire('jvVU5'));
});
parcelRegister("d1io7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("at6NW").then(()=>parcelRequire('4H15d'));
});
parcelRegister("9kQm2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7dD9P").then(()=>parcelRequire('8Giki'));
});
parcelRegister("iJp6U", function(module, exports) {
    $parcel$export(module.exports, "setBlockTypeWithAnalytics", ()=>$a2f47a40ffbb9304$export$3f9af78ebb95cc20);
    $parcel$export(module.exports, "setNormalTextWithAnalytics", ()=>$a2f47a40ffbb9304$export$283e32d0388e302a);
    $parcel$export(module.exports, "setHeadingWithAnalytics", ()=>$a2f47a40ffbb9304$export$52d74b15bd103d7f);
    $parcel$export(module.exports, "insertBlockQuoteWithAnalytics", ()=>$a2f47a40ffbb9304$export$50b4331f407b3ab6);
    $parcel$export(module.exports, "cleanUpAtTheStartOfDocument", ()=>$a2f47a40ffbb9304$export$9c6026f8ac831f44);
    var $gkwXh;
    var $14FOE;
    var $594Yf;
    var $aeKzo;
    var $hFEwm;
    var $k3Otq;
    function $a2f47a40ffbb9304$export$36987f561c736aad(name) {
        return ({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            if (name === (0, (0, parcelRequire("k3Otq")).NORMAL_TEXT).name && nodes.paragraph) return $a2f47a40ffbb9304$export$63c4f0859cc75dc6()({
                tr: tr
            });
            const headingBlockType = (0, (0, parcelRequire("k3Otq")).HEADINGS_BY_NAME)[name];
            if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(headingBlockType.level)({
                tr: tr
            });
            return null;
        };
    }
    function $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(level) {
        return function({ tr: tr }) {
            const { selection: selection, doc: { type: { schema: schema } } } = tr;
            const ranges = selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection) ? selection.ranges : [
                selection
            ];
            ranges.forEach(({ $from: $from, $to: $to })=>{
                tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                    level: level
                });
            });
            return tr;
        };
    }
    function $a2f47a40ffbb9304$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi) {
        return ({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            if (name === 'normal' && nodes.paragraph) return $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi)({
                tr: tr
            });
            const headingBlockType = (0, (0, parcelRequire("k3Otq")).HEADINGS_BY_NAME)[name];
            if (headingBlockType && nodes.heading && headingBlockType.level) return $a2f47a40ffbb9304$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi)({
                tr: tr
            });
            return null;
        };
    }
    function $a2f47a40ffbb9304$export$63c4f0859cc75dc6() {
        return function({ tr: tr }) {
            const { selection: selection, doc: { type: { schema: schema } } } = tr;
            const ranges = selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection) ? selection.ranges : [
                selection
            ];
            ranges.forEach(({ $from: $from, $to: $to })=>{
                tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
            });
            return tr;
        };
    }
    function $a2f47a40ffbb9304$var$withCurrentHeadingLevel(fn) {
        return ({ tr: tr })=>{
            const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
            const nodes = (0, (0, parcelRequire("594Yf")).filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
                return node.type === heading || node.type === paragraph;
            });
            let level;
            for (let node of nodes){
                const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
                if (!level) level = nodeLevel;
                else if (nodeLevel !== level) {
                    level = undefined;
                    break;
                }
            }
            return fn(level)({
                tr: tr
            });
        };
    }
    function $a2f47a40ffbb9304$export$283e32d0388e302a(inputMethod, editorAnalyticsApi) {
        return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: inputMethod,
                        newHeadingLevel: 0,
                        previousHeadingLevel: previousHeadingLevel
                    }
                })(tr);
                return $a2f47a40ffbb9304$export$63c4f0859cc75dc6()({
                    tr: tr
                });
            });
    }
    const $a2f47a40ffbb9304$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi)=>{
        return $a2f47a40ffbb9304$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: inputMethod,
                        newHeadingLevel: newHeadingLevel,
                        previousHeadingLevel: previousHeadingLevel
                    }
                })(tr);
                return $a2f47a40ffbb9304$export$c6a04dca1ed03a3c(newHeadingLevel)({
                    tr: tr
                });
            });
    };
    function $a2f47a40ffbb9304$var$insertBlockQuote() {
        return function(state, dispatch) {
            const { nodes: nodes } = state.schema;
            if (nodes.paragraph && nodes.blockquote) return (0, (0, parcelRequire("aeKzo")).wrapSelectionIn)(nodes.blockquote)(state, dispatch);
            return false;
        };
    }
    const $a2f47a40ffbb9304$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
        return (0, (0, parcelRequire("14FOE")).withAnalytics)(editorAnalyticsApi, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
            attributes: {
                inputMethod: inputMethod
            }
        })($a2f47a40ffbb9304$var$insertBlockQuote());
    };
    const $a2f47a40ffbb9304$export$9c6026f8ac831f44 = (state, dispatch)=>{
        const { $cursor: $cursor } = state.selection;
        if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
            const { tr: tr, schema: schema } = state;
            const { paragraph: paragraph } = schema.nodes;
            const { parent: parent } = $cursor;
            tr.setNodeMarkup(0, paragraph, parent.attrs, []);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
});
parcelRegister("aeKzo", function(module, exports) {
    $parcel$export(module.exports, "wrapSelectionIn", ()=>$e364b1498c53313f$export$f63f505240212912);
    var $iXNbm;
    function $e364b1498c53313f$export$f63f505240212912(type) {
        return function(state, dispatch) {
            let tr = (0, (0, parcelRequire("iXNbm")).createWrapSelectionTransaction)({
                state: state,
                type: type
            });
            if (dispatch) dispatch(tr);
            return true;
        };
    }
});
parcelRegister("iXNbm", function(module, exports) {
    $parcel$export(module.exports, "createWrapSelectionTransaction", ()=>$4678f0237e36a927$export$d5c308539c2b2123);
    $parcel$export(module.exports, "getWrappingOptions", ()=>$4678f0237e36a927$export$656aa714448bfa8a);
    var $gZGBX;
    var $eS2Dn;
    var $5r0mK = parcelRequire("5r0mK");
    var $594Yf;
    function $4678f0237e36a927$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
        let { tr: tr } = state;
        const { alignment: alignment, indentation: indentation } = state.schema.marks;
        const removeAlignTr = (0, (0, parcelRequire("594Yf")).removeBlockMarks)(state, [
            alignment,
            indentation
        ]);
        tr = removeAlignTr || tr;
        const { range: range, wrapping: wrapping } = $4678f0237e36a927$export$656aa714448bfa8a(state, type, nodeAttributes);
        if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
        else (0, $5r0mK.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
        return tr;
    }
    function $4678f0237e36a927$export$656aa714448bfa8a(state, type, nodeAttributes) {
        const { $from: $from, $to: $to, from: from } = state.selection;
        let range = $from.blockRange($to);
        const isMediaSelection = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node.type === state.schema.nodes.media;
        if (isMediaSelection) {
            const prev = from - 1;
            range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
        }
        let isAllowedChild = true;
        if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (!isAllowedChild) return false;
            return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
        });
        const wrapping = isAllowedChild && range && (0, (0, parcelRequire("eS2Dn")).findWrapping)(range, type, nodeAttributes);
        return {
            range: range,
            wrapping: wrapping
        };
    }
});
parcelRegister("k3Otq", function(module, exports) {
    $parcel$export(module.exports, "NORMAL_TEXT", ()=>$a73e542a2117996d$export$58d6de174a4025df);
    $parcel$export(module.exports, "HEADING_1", ()=>$a73e542a2117996d$export$aca53469ff012f69);
    $parcel$export(module.exports, "HEADING_2", ()=>$a73e542a2117996d$export$8af5e2d4f952c9f0);
    $parcel$export(module.exports, "HEADING_3", ()=>$a73e542a2117996d$export$4b4c4ef3a93a84d8);
    $parcel$export(module.exports, "HEADING_4", ()=>$a73e542a2117996d$export$67379271b4d26982);
    $parcel$export(module.exports, "HEADING_5", ()=>$a73e542a2117996d$export$230d7efa1736763e);
    $parcel$export(module.exports, "HEADING_6", ()=>$a73e542a2117996d$export$329adfa5d98f30d5);
    $parcel$export(module.exports, "BLOCK_QUOTE", ()=>$a73e542a2117996d$export$175cdd8bc7e4b125);
    $parcel$export(module.exports, "CODE_BLOCK", ()=>$a73e542a2117996d$export$cf55d1bff75690da);
    $parcel$export(module.exports, "PANEL", ()=>$a73e542a2117996d$export$867b449446b85962);
    $parcel$export(module.exports, "OTHER", ()=>$a73e542a2117996d$export$d46a05f8561f868a);
    $parcel$export(module.exports, "TEXT_BLOCK_TYPES", ()=>$a73e542a2117996d$export$2ec1d6c4f06d927);
    $parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", ()=>$a73e542a2117996d$export$c6516682f7569488);
    $parcel$export(module.exports, "HEADINGS_BY_LEVEL", ()=>$a73e542a2117996d$export$110c9c3e05131569);
    $parcel$export(module.exports, "HEADINGS_BY_NAME", ()=>$a73e542a2117996d$export$33dfdcd30c23ea87);
    var $9NKqk;
    const $a73e542a2117996d$export$58d6de174a4025df = {
        name: 'normal',
        title: (0, (0, parcelRequire("9NKqk")).messages).normal,
        nodeName: 'paragraph',
        tagName: 'p'
    };
    const $a73e542a2117996d$export$aca53469ff012f69 = {
        name: 'heading1',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading1,
        nodeName: 'heading',
        tagName: 'h1',
        level: 1
    };
    const $a73e542a2117996d$export$8af5e2d4f952c9f0 = {
        name: 'heading2',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading2,
        nodeName: 'heading',
        tagName: 'h2',
        level: 2
    };
    const $a73e542a2117996d$export$4b4c4ef3a93a84d8 = {
        name: 'heading3',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading3,
        nodeName: 'heading',
        tagName: 'h3',
        level: 3
    };
    const $a73e542a2117996d$export$67379271b4d26982 = {
        name: 'heading4',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading4,
        nodeName: 'heading',
        tagName: 'h4',
        level: 4
    };
    const $a73e542a2117996d$export$230d7efa1736763e = {
        name: 'heading5',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading5,
        nodeName: 'heading',
        tagName: 'h5',
        level: 5
    };
    const $a73e542a2117996d$export$329adfa5d98f30d5 = {
        name: 'heading6',
        title: (0, (0, parcelRequire("9NKqk")).messages).heading6,
        nodeName: 'heading',
        tagName: 'h6',
        level: 6
    };
    const $a73e542a2117996d$export$175cdd8bc7e4b125 = {
        name: 'blockquote',
        title: (0, (0, parcelRequire("9NKqk")).messages).blockquote,
        nodeName: 'blockquote'
    };
    const $a73e542a2117996d$export$cf55d1bff75690da = {
        name: 'codeblock',
        title: (0, (0, parcelRequire("9NKqk")).messages).codeblock,
        nodeName: 'codeBlock'
    };
    const $a73e542a2117996d$export$867b449446b85962 = {
        name: 'panel',
        title: (0, (0, parcelRequire("9NKqk")).messages).infoPanel,
        nodeName: 'panel'
    };
    const $a73e542a2117996d$export$d46a05f8561f868a = {
        name: 'other',
        title: (0, (0, parcelRequire("9NKqk")).messages).other,
        nodeName: ''
    };
    const $a73e542a2117996d$export$2ec1d6c4f06d927 = [
        $a73e542a2117996d$export$58d6de174a4025df,
        $a73e542a2117996d$export$aca53469ff012f69,
        $a73e542a2117996d$export$8af5e2d4f952c9f0,
        $a73e542a2117996d$export$4b4c4ef3a93a84d8,
        $a73e542a2117996d$export$67379271b4d26982,
        $a73e542a2117996d$export$230d7efa1736763e,
        $a73e542a2117996d$export$329adfa5d98f30d5
    ];
    const $a73e542a2117996d$export$c6516682f7569488 = [
        $a73e542a2117996d$export$175cdd8bc7e4b125,
        $a73e542a2117996d$export$cf55d1bff75690da,
        $a73e542a2117996d$export$867b449446b85962
    ];
    const $a73e542a2117996d$export$237f26fa8dbc0d9a = $a73e542a2117996d$export$2ec1d6c4f06d927.concat($a73e542a2117996d$export$c6516682f7569488);
    const $a73e542a2117996d$export$110c9c3e05131569 = $a73e542a2117996d$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
        if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
        return acc;
    }, {});
    const $a73e542a2117996d$export$33dfdcd30c23ea87 = $a73e542a2117996d$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
        if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
        return acc;
    }, {});
});
parcelRegister("eKy27", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ccb780a6937c50a$export$2e2bcd8739ae039);
    var $gkwXh;
    var $93WYh;
    var $5KWxh;
    var $2Abpa;
    var $inLhu;
    var $eWNtX;
    const $3ccb780a6937c50a$var$MAX_HEADING_LEVEL = 6;
    function $3ccb780a6937c50a$var$getHeadingLevel(match) {
        return {
            level: match[1].length
        };
    }
    function $3ccb780a6937c50a$var$headingRule(nodeType, maxLevel) {
        return (0, (0, parcelRequire("eWNtX")).createWrappingTextBlockRule)({
            match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
            nodeType: nodeType,
            getAttrs: $3ccb780a6937c50a$var$getHeadingLevel
        });
    }
    function $3ccb780a6937c50a$var$blockQuoteRule(nodeType) {
        return (0, (0, parcelRequire("eWNtX")).createJoinNodesRule)(/^\s*>\s$/, nodeType);
    }
    function $3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema) {
        const hashRule = $3ccb780a6937c50a$var$headingRule(schema.nodes.heading, $3ccb780a6937c50a$var$MAX_HEADING_LEVEL);
        const leftNodeReplacementHashRule = (0, (0, parcelRequire("2Abpa")).createRule)(new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}(#{1,6})\\s$`), (state, match, start, end)=>{
            const level = match[1].length;
            return (0, (0, parcelRequire("93WYh")).insertBlock)(state, schema.nodes.heading, start, end, {
                level: level
            });
        });
        const ruleWithHeadingAnalytics = (0, (0, parcelRequire("2Abpa")).inputRuleWithAnalytics)((_state, matchResult)=>({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING,
                    newHeadingLevel: $3ccb780a6937c50a$var$getHeadingLevel(matchResult).level
                }
            }), editorAnalyticsAPI);
        return [
            ruleWithHeadingAnalytics(hashRule),
            ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
        ];
    }
    function $3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
        const greatherThanRule = $3ccb780a6937c50a$var$blockQuoteRule(schema.nodes.blockquote);
        const leftNodeReplacementGreatherRule = (0, (0, parcelRequire("2Abpa")).createRule)(new RegExp(`${(0, $d19733ae55e58348$export$a96b909f1510512b)}\\s*>\\s$`), (state, _match, start, end)=>{
            return (0, (0, parcelRequire("93WYh")).insertBlock)(state, schema.nodes.blockquote, start, end);
        });
        const ruleWithBlockQuoteAnalytics = (0, (0, parcelRequire("2Abpa")).inputRuleWithAnalytics)({
            action: (0, (0, parcelRequire("gkwXh")).ACTION).FORMATTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING
            }
        }, editorAnalyticsAPI);
        return [
            ruleWithBlockQuoteAnalytics(greatherThanRule),
            ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
        ];
    }
    function $3ccb780a6937c50a$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
        const rules = [];
        if (schema.nodes.heading) rules.push(...$3ccb780a6937c50a$var$getHeadingRules(editorAnalyticsAPI, schema));
        if (schema.nodes.blockquote) rules.push(...$3ccb780a6937c50a$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
        if (rules.length !== 0) return new (0, (0, parcelRequire("5KWxh")).SafePlugin)((0, (0, parcelRequire("inLhu")).createPlugin)('block-type', rules, {
            isBlockNodeRule: true
        }));
        return;
    }
    var $3ccb780a6937c50a$export$2e2bcd8739ae039 = $3ccb780a6937c50a$var$inputRulePlugin;
});
parcelRegister("2Abpa", function(module, exports) {
    $parcel$export(module.exports, "inputRuleWithAnalytics", ()=>$9aa3f9797dcf58b2$export$333ee6e3f01bb8f9);
    $parcel$export(module.exports, "createWrappingJoinRule", ()=>$9aa3f9797dcf58b2$export$6341edfa2d147bc);
    $parcel$export(module.exports, "createRule", ()=>$9aa3f9797dcf58b2$export$56e87122f905fac0);
    var $fZzhT;
    var $eS2Dn;
    var $57ZlA;
    const $9aa3f9797dcf58b2$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
        return (originalRule)=>{
            const onHandlerApply = (state, tr, matchResult)=>{
                const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
                if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
                analyticsApi?.attachAnalyticsEvent(payload)(tr);
                if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
            };
            return {
                ...originalRule,
                onHandlerApply: onHandlerApply
            };
        };
    };
    const $9aa3f9797dcf58b2$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
        const handler = (state, match, start, end)=>{
            const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
            const tr = state.tr;
            const fixedStart = Math.max(start, 1);
            tr.delete(fixedStart, end);
            const $start = tr.doc.resolve(fixedStart);
            const range = $start.blockRange();
            const wrapping = range && (0, (0, parcelRequire("eS2Dn")).findWrapping)(range, nodeType, attrs);
            if (!wrapping || !range) return null;
            const parentNodePosMapped = tr.mapping.map(range.start);
            const parentNode = tr.doc.nodeAt(parentNodePosMapped);
            const lastWrap = wrapping[wrapping.length - 1];
            if (parentNode && lastWrap) {
                const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
                tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
            }
            tr.wrap(range, wrapping);
            const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
            if (before && before.type === nodeType && (0, (0, parcelRequire("eS2Dn")).canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, (0, parcelRequire("57ZlA")).JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
            return tr;
        };
        return $9aa3f9797dcf58b2$export$56e87122f905fac0(match, handler);
    };
    const $9aa3f9797dcf58b2$export$56e87122f905fac0 = (match, handler)=>{
        return {
            match: match,
            handler: handler,
            onHandlerApply: (_state, tr)=>{
                (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            }
        };
    };
});
parcelRegister("57ZlA", function(module, exports) {
    $parcel$export(module.exports, "DELETE_DIRECTION", ()=>$4b9a10a7caaf11e5$export$a9b79b94eb5ffad);
    $parcel$export(module.exports, "LIST_TEXT_SCENARIOS", ()=>$4b9a10a7caaf11e5$export$c3c848735ee9408a);
    $parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", ()=>$4b9a10a7caaf11e5$export$43e6a678b13eb45f);
    $parcel$export(module.exports, "OUTDENT_SCENARIOS", ()=>$4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8);
    var $4b9a10a7caaf11e5$export$a9b79b94eb5ffad;
    (function(DELETE_DIRECTION) {
        DELETE_DIRECTION["BACKWARD"] = "backward";
        DELETE_DIRECTION["FORWARD"] = "forward";
    })($4b9a10a7caaf11e5$export$a9b79b94eb5ffad || ($4b9a10a7caaf11e5$export$a9b79b94eb5ffad = {}));
    var $4b9a10a7caaf11e5$export$c3c848735ee9408a;
    (function(LIST_TEXT_SCENARIOS) {
        LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
        LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
        LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
        LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
        LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
        LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    })($4b9a10a7caaf11e5$export$c3c848735ee9408a || ($4b9a10a7caaf11e5$export$c3c848735ee9408a = {}));
    var $4b9a10a7caaf11e5$export$43e6a678b13eb45f;
    (function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
        JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
        JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
        JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    })($4b9a10a7caaf11e5$export$43e6a678b13eb45f || ($4b9a10a7caaf11e5$export$43e6a678b13eb45f = {}));
    var $4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8;
    (function(OUTDENT_SCENARIOS) {
        OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    })($4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8 || ($4b9a10a7caaf11e5$export$ed4ba8ac11f6cbc8 = {}));
});
parcelRegister("inLhu", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$0178415f004b9eed$export$ae829ec7b2625219);
    var $fZzhT;
    var $gZGBX;
    var $2CgsA;
    var $eLc4o;
    const $0178415f004b9eed$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
        const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
        const $from = state.doc.resolve(start);
        const $to = state.doc.resolve(end);
        const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
        return (marksInSelection || []).some(isUnsupportedMark);
    };
    const $0178415f004b9eed$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
        const { selection: selection } = state;
        if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return false;
        const { $cursor: $cursor } = selection;
        const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
        return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
    };
    const $0178415f004b9eed$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
        const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true } = options;
        const onInputEvent = ({ state: state, from: from, to: to })=>{
            const unsupportedMarks = isBlockNodeRule ? [
                'code',
                'link',
                'typeAheadQuery'
            ] : [
                'code'
            ];
            const $from = state.selection.$from;
            const isInline = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node.type.isInline;
            if ($from.parent.type.spec.code || !(state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) && !(0, (0, parcelRequire("2CgsA")).isGapCursorSelection)(state.selection) && !isInline || $0178415f004b9eed$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $0178415f004b9eed$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
            return true;
        };
        return (0, (0, parcelRequire("eLc4o")).createInputRulePlugin)(pluginName, rules, {
            allowInsertTextOnDocument: allowInsertTextOnDocument,
            onInputEvent: onInputEvent,
            onBeforeRegexMatch: (tr)=>{
                (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            }
        });
    };
});
parcelRegister("2CgsA", function(module, exports) {
    $parcel$export(module.exports, "isGapCursorSelection", ()=>$79c3774b0460e64a$export$b0e17cd4423f50ca);
    const $79c3774b0460e64a$export$b0e17cd4423f50ca = (selection)=>{
        return Boolean(selection.jsonID === 'gapcursor');
    };
});
parcelRegister("eLc4o", function(module, exports) {
    $parcel$export(module.exports, "createInputRulePlugin", ()=>$301ed6c086d04b75$export$dc83f374e2af640d);
    var $gZGBX;
    var $a7z0s;
    function $301ed6c086d04b75$export$dc83f374e2af640d(pluginName, rules, options = {}) {
        const onInputEvent = options?.onInputEvent;
        const onBeforeRegexMatch = options?.onBeforeRegexMatch;
        const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
        const pluginKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)(`inputRulePlugin__${pluginName}`);
        const inputEvent = (0, (0, parcelRequire("a7z0s")).createInputEventHandler)({
            allowInsertTextOnDocument: allowInsertTextOnDocument,
            pluginKey: pluginKey,
            rules: rules,
            onInputEvent: onInputEvent,
            onBeforeRegexMatch: onBeforeRegexMatch
        });
        return {
            key: pluginKey,
            state: {
                init () {
                    return null;
                },
                apply (tr, prev) {
                    const stored = tr.getMeta(pluginKey);
                    if (stored) return stored;
                    return tr.selectionSet || tr.docChanged ? null : prev;
                }
            },
            appendTransaction: (transactions, oldState, newState)=>{
                const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
                const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
                if (!pluginState || !transactionWithInputRuleMeta) return null;
                const { matchedRule: matchedRule, from: from, to: to } = pluginState;
                const { result: result } = matchedRule;
                const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
                const tr = matchedRule.handler(newState, result, from, mappedTo);
                if (!tr) return null;
                tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
                if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
                return tr;
            },
            props: {
                handleTextInput (view, from, to, text) {
                    return inputEvent({
                        view: view,
                        from: from,
                        to: to,
                        text: text
                    });
                },
                handleDOMEvents: {
                    compositionend: (view)=>{
                        setTimeout(()=>{
                            const selection = view.state.selection;
                            if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return;
                            const { $cursor: $cursor } = selection;
                            if ($cursor) inputEvent({
                                view: view,
                                from: $cursor.pos,
                                to: $cursor.pos,
                                text: ''
                            });
                        });
                        return false;
                    }
                }
            },
            isInputRules: true
        };
    }
});
const $d19733ae55e58348$export$a96b909f1510512b = '\ufffc';
const $d19733ae55e58348$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $d19733ae55e58348$export$af78bb669dec9658 = 500;
parcelRegister("a7z0s", function(module, exports) {
    $parcel$export(module.exports, "createInputEventHandler", ()=>$df6df97092dea2d9$export$9bcba4b183c6bb83);
    var $2CgsA;
    const $df6df97092dea2d9$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
            if (view.composing) return false;
            const state = view.state;
            const $from = state.doc.resolve(from);
            if ($from.parent.type.spec.code) return false;
            if (onInputEvent && !onInputEvent({
                state: state,
                from: from,
                to: to
            })) return false;
            const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658)), $from.parentOffset, undefined, (0, $d19733ae55e58348$export$a96b909f1510512b)) + text;
            const result = $df6df97092dea2d9$var$findMatchOnRules({
                rules: rules,
                textBefore: textBefore,
                from: from,
                to: to,
                state: state
            });
            if (!result) return false;
            const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
            tr.setMeta((0, $d19733ae55e58348$export$e56dc8305776db1f), true);
            tr.setMeta(pluginKey, {
                textInserted: text,
                from: result.from,
                to: result.to,
                matchedRule: result.matchedRule
            });
            if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
            view.dispatch(tr);
            return true;
        };
    function $df6df97092dea2d9$var$findMatchOnRules({ rules: rules, textBefore: textBefore, from: from, to: to, state: state }) {
        for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const matchString = (0, (0, parcelRequire("2CgsA")).isGapCursorSelection)(state.selection) ? textBefore.at(-1) ?? '' : textBefore;
            const match = rule.match.exec(matchString);
            if (!match) continue;
            const parentNodeStartAt = state.selection.$from.start();
            const offset = Math.max(0, state.selection.$from.parentOffset - (0, $d19733ae55e58348$export$af78bb669dec9658));
            const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
            const transform = rule.handler(state, match, fromFixed, to);
            if (transform) return {
                from: fromFixed,
                to: to,
                matchedRule: {
                    ...rule,
                    result: match
                }
            };
        }
        return null;
    }
});
parcelRegister("eWNtX", function(module, exports) {
    $parcel$export(module.exports, "isNodeAWrappingBlockNode", ()=>$4c437d0d04103ee6$export$3a2c03e35bc6c7a8);
    $parcel$export(module.exports, "createJoinNodesRule", ()=>$4c437d0d04103ee6$export$1fe8b64ae159a0fa);
    $parcel$export(module.exports, "createWrappingTextBlockRule", ()=>$4c437d0d04103ee6$export$644b98fd2fd87b8b);
    $parcel$export(module.exports, "areBlockTypesDisabled", ()=>$4c437d0d04103ee6$export$52adb8d9a3386cb8);
    var $2Abpa;
    var $k3Otq;
    const $4c437d0d04103ee6$export$3a2c03e35bc6c7a8 = (node)=>{
        if (!node) return false;
        return (0, (0, parcelRequire("k3Otq")).WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
    };
    const $4c437d0d04103ee6$export$1fe8b64ae159a0fa = (match, nodeType)=>{
        return (0, (0, parcelRequire("2Abpa")).createWrappingJoinRule)({
            nodeType: nodeType,
            match: match,
            getAttrs: {},
            joinPredicate: (_, node)=>node.type === nodeType
        });
    };
    const $4c437d0d04103ee6$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
        const handler = (state, match, start, end)=>{
            const fixedStart = Math.max(start, 1);
            const $start = state.doc.resolve(fixedStart);
            const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
            const nodeBefore = $start.node(-1);
            if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
            return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
        };
        return (0, (0, parcelRequire("2Abpa")).createRule)(match, handler);
    };
    function $4c437d0d04103ee6$var$getSelectedWrapperNodes(state) {
        const nodes = [];
        if (state.selection) {
            const { $from: $from, $to: $to } = state.selection;
            const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
            state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
                if (node.isBlock && [
                    blockquote,
                    panel,
                    orderedList,
                    bulletList,
                    listItem,
                    codeBlock,
                    decisionItem,
                    decisionList,
                    taskItem,
                    taskList
                ].indexOf(node.type) >= 0) nodes.push(node.type);
            });
        }
        return nodes;
    }
    function $4c437d0d04103ee6$export$52adb8d9a3386cb8(state) {
        const nodesTypes = $4c437d0d04103ee6$var$getSelectedWrapperNodes(state);
        const { panel: panel } = state.schema.nodes;
        return nodesTypes.filter((type)=>type !== panel).length > 0;
    }
});
parcelRegister("kdso8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25680dc6fd050d04$export$2e2bcd8739ae039);
    var $gkwXh;
    var $e9qoo;
    var $6cqU9;
    var $k24a0;
    var $2RHbH;
    var $fZzhT;
    var $k3Otq;
    var $iJp6U;
    var $jMN7x;
    var $7eSM1;
    var $eWNtX;
    const $25680dc6fd050d04$var$backspaceCommand = (0, (0, parcelRequire("2RHbH")).chainCommands)((0, (0, parcelRequire("iJp6U")).cleanUpAtTheStartOfDocument), (0, (0, parcelRequire("7eSM1")).deleteBlockContent)((0, (0, parcelRequire("eWNtX")).isNodeAWrappingBlockNode)), (0, (0, parcelRequire("jMN7x")).deleteAndMoveCursor));
    const $25680dc6fd050d04$var$del = (0, (0, parcelRequire("2RHbH")).chainCommands)((0, (0, parcelRequire("k24a0")).deleteEmptyParagraphAndMoveBlockUp)((0, (0, parcelRequire("eWNtX")).isNodeAWrappingBlockNode)), (0, (0, parcelRequire("7eSM1")).deleteBlockContent)((0, (0, parcelRequire("eWNtX")).isNodeAWrappingBlockNode)), (0, (0, parcelRequire("jMN7x")).deleteAndMoveCursor));
    function $25680dc6fd050d04$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
        const list = {};
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).insertNewLine).common, (0, (0, parcelRequire("k24a0")).insertNewLineWithAnalytics)(editorAnalyticsApi), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveUp).common, (0, (0, parcelRequire("k24a0")).createNewParagraphAbove), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveDown).common, (0, (0, parcelRequire("k24a0")).createNewParagraphBelow), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).findKeyMapForBrowser)((0, (0, parcelRequire("e9qoo")).redo)), (0, (0, parcelRequire("fZzhT")).redo), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).undo).common, (0, (0, parcelRequire("fZzhT")).undo), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).backspace).common, $25680dc6fd050d04$var$backspaceCommand, list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).deleteKey).common, $25680dc6fd050d04$var$del, list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).forwardDelete).mac, $25680dc6fd050d04$var$del, list);
        if (schema.nodes[(0, parcelRequire("k3Otq")).BLOCK_QUOTE.nodeName]) (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).findShortcutByKeymap)((0, (0, parcelRequire("e9qoo")).toggleBlockQuote)), (0, (0, parcelRequire("iJp6U")).insertBlockQuoteWithAnalytics)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
        return (0, (0, parcelRequire("6cqU9")).keymap)(list);
    }
});
parcelRegister("jMN7x", function(module, exports) {
    $parcel$export(module.exports, "deleteAndMoveCursor", ()=>$aab5fb9291da562a$export$6c408f720f6b44a7);
    var $gZGBX;
    const $aab5fb9291da562a$var$shouldMoveCursorAfterDelete = (state)=>{
        const { selection: { $from: $from, $to: $to } } = state;
        const nodeRange = $from.blockRange($to);
        if (!nodeRange) return false;
        const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
        const toPositionHasNodeAfter = !!$to.nodeAfter;
        if (hasSameAncestor || toPositionHasNodeAfter) return false;
        return true;
    };
    const $aab5fb9291da562a$export$6c408f720f6b44a7 = (state, dispatch)=>{
        if (state.selection.empty || !(state.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return false;
        if (!$aab5fb9291da562a$var$shouldMoveCursorAfterDelete(state)) return false;
        const { tr: tr } = state;
        tr.deleteSelection();
        const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
        tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near(tr.doc.resolve(previousPosition), -1));
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
});
parcelRegister("7eSM1", function(module, exports) {
    $parcel$export(module.exports, "deleteBlockContent", ()=>$523f65c5ad5003d8$export$9c1a524875bfb8ec);
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    const $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem = (state)=>{
        const isDecisionItemNodeSelected = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node.type.name === 'decisionItem';
        if (!isDecisionItemNodeSelected) return false;
        const decisionList = (0, $5r0mK.findParentNodeOfType)([
            state.schema.nodes.decisionList
        ])(state.selection)?.node;
        return decisionList?.childCount === 1;
    };
    const $523f65c5ad5003d8$var$isSelectedNodeMediaGroup = (state)=>{
        return Boolean(state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
    };
    function $523f65c5ad5003d8$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
        return (state, dispatch)=>{
            const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
            if ($from.pos === $to.pos) return false;
            let selectionCrossesWrappingBlockNode = false;
            doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (isNodeAWrappingBlockNode(node)) {
                    selectionCrossesWrappingBlockNode = true;
                    return false;
                }
            });
            if (!selectionCrossesWrappingBlockNode) return false;
            const isParentNodeOfTypePanel = (0, $5r0mK.hasParentNodeOfType)([
                state.schema.nodes.panel
            ])(state.selection);
            const isParentNodeOfTypeBlockQuote = (0, $5r0mK.hasParentNodeOfType)([
                state.schema.nodes.blockquote
            ])(state.selection);
            if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $523f65c5ad5003d8$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $523f65c5ad5003d8$var$isSelectedNodeSoleDecisionItem(state)) {
                tr.setSelection(new (0, (0, parcelRequire("gZGBX")).TextSelection)(tr.doc.resolve($from.before())));
                tr.delete($from.before(), $from.after());
            } else tr.delete($from.pos, $to.pos);
            if (dispatch) dispatch(tr);
            return true;
        };
    }
});
parcelRegister("5pNa3", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$eef5dca48c9b3cf7$export$18d4026d1ea86bb1);
    $parcel$export(module.exports, "createPlugin", ()=>$eef5dca48c9b3cf7$export$ae829ec7b2625219);
    var $gkwXh;
    var $gE8f9;
    var $5KWxh;
    var $gZGBX;
    var $gmhCD = parcelRequire("gmhCD");
    var $k3Otq;
    var $iJp6U;
    var $eTqxy;
    var $eWNtX;
    const $eef5dca48c9b3cf7$var$blockTypeForNode = (node, schema)=>{
        if (node.type === schema.nodes.heading) {
            const maybeNode = (0, (0, parcelRequire("k3Otq")).HEADINGS_BY_LEVEL)[node.attrs['level']];
            if (maybeNode) return maybeNode;
        } else if (node.type === schema.nodes.paragraph) return 0, (0, parcelRequire("k3Otq")).NORMAL_TEXT;
        return 0, (0, parcelRequire("k3Otq")).OTHER;
    };
    const $eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported = (blockType, state)=>{
        switch(blockType){
            case 0, (0, parcelRequire("k3Otq")).NORMAL_TEXT:
                return !!state.schema.nodes.paragraph;
            case 0, (0, parcelRequire("k3Otq")).HEADING_1:
            case 0, (0, parcelRequire("k3Otq")).HEADING_2:
            case 0, (0, parcelRequire("k3Otq")).HEADING_3:
            case 0, (0, parcelRequire("k3Otq")).HEADING_4:
            case 0, (0, parcelRequire("k3Otq")).HEADING_5:
            case 0, (0, parcelRequire("k3Otq")).HEADING_6:
                return !!state.schema.nodes.heading;
            case 0, (0, parcelRequire("k3Otq")).BLOCK_QUOTE:
                return !!state.schema.nodes.blockquote;
            case 0, (0, parcelRequire("k3Otq")).CODE_BLOCK:
                return !!state.schema.nodes.codeBlock;
            case 0, (0, parcelRequire("k3Otq")).PANEL:
                return !!state.schema.nodes.panel;
        }
        return;
    };
    const $eef5dca48c9b3cf7$var$detectBlockType = (availableBlockTypes, state)=>{
        if (!state.selection) return 0, (0, parcelRequire("k3Otq")).NORMAL_TEXT;
        let blockType;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $eef5dca48c9b3cf7$var$blockTypeForNode(node, state.schema));
            if (nodeBlockType.length > 0) {
                if (!blockType) blockType = nodeBlockType[0];
                else if (blockType !== (0, (0, parcelRequire("k3Otq")).OTHER) && blockType !== nodeBlockType[0]) blockType = (0, (0, parcelRequire("k3Otq")).OTHER);
            }
        });
        return blockType || (0, (0, parcelRequire("k3Otq")).OTHER);
    };
    const $eef5dca48c9b3cf7$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
        if (headingLevel === 0) return (0, (0, parcelRequire("iJp6U")).setNormalTextWithAnalytics)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING, editorAnalyticsApi);
        return (0, (0, parcelRequire("iJp6U")).setHeadingWithAnalytics)(headingLevel, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    };
    const $eef5dca48c9b3cf7$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('blockTypePlugin');
    const $eef5dca48c9b3cf7$export$ae829ec7b2625219 = (editorAPI, dispatch, lastNodeMustBeParagraph)=>{
        const editorAnalyticsApi = editorAPI?.analytics?.actions;
        let altKeyLocation = 0;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            appendTransaction (_transactions, _oldState, newState) {
                if (lastNodeMustBeParagraph) {
                    const pos = newState.doc.resolve(newState.doc.content.size - 1);
                    const lastNode = pos.node(1);
                    const { paragraph: paragraph } = newState.schema.nodes;
                    if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) return newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create()).setMeta('addToHistory', false);
                }
            },
            state: {
                init (_config, state) {
                    const availableBlockTypes = (0, (0, parcelRequire("k3Otq")).TEXT_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                    const availableWrapperBlockTypes = (0, (0, parcelRequire("k3Otq")).WRAPPER_BLOCK_TYPES).filter((blockType)=>$eef5dca48c9b3cf7$var$isBlockTypeSchemaSupported(blockType, state));
                    return {
                        currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(availableBlockTypes, state),
                        blockTypesDisabled: (0, (0, parcelRequire("eWNtX")).areBlockTypesDisabled)(state),
                        availableBlockTypes: availableBlockTypes,
                        availableWrapperBlockTypes: availableWrapperBlockTypes
                    };
                },
                apply (_tr, oldPluginState, _oldState, newState) {
                    const newPluginState = {
                        ...oldPluginState,
                        currentBlockType: $eef5dca48c9b3cf7$var$detectBlockType(oldPluginState.availableBlockTypes, newState),
                        blockTypesDisabled: (0, (0, parcelRequire("eWNtX")).areBlockTypesDisabled)(newState)
                    };
                    if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled) dispatch($eef5dca48c9b3cf7$export$18d4026d1ea86bb1, newPluginState);
                    return newPluginState;
                }
            },
            key: $eef5dca48c9b3cf7$export$18d4026d1ea86bb1,
            props: {
                handleKeyDown: (view, event)=>{
                    const headingLevel = (0, (0, parcelRequire("eTqxy")).HEADING_KEYS).indexOf(event.keyCode);
                    if (headingLevel > -1 && event.altKey) {
                        if ((0, (0, parcelRequire("gE8f9")).browser).mac && event.metaKey) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                        else if (!(0, (0, parcelRequire("gE8f9")).browser).mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($eef5dca48c9b3cf7$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    } else if (event.key === 'Alt') altKeyLocation = event.location;
                    else if (!event.altKey) altKeyLocation = 0;
                    return false;
                },
                handleDrop (view, event, slice, moved) {
                    return $eef5dca48c9b3cf7$export$2934db212a857195(view, event, slice);
                }
            }
        });
    };
    const $eef5dca48c9b3cf7$export$2934db212a857195 = (view, event, slice)=>{
        if ((0, $gmhCD.editorExperiment)('nest-media-and-codeblock-in-quote', false)) {
            let sliceContainsCodeBlockOrMedia = false;
            slice.content.forEach((node)=>{
                if (node.type === view.state.schema.nodes.codeBlock) sliceContainsCodeBlockOrMedia = true;
                else if (node.type === view.state.schema.nodes.mediaSingle) sliceContainsCodeBlockOrMedia = true;
                else if (node.type === view.state.schema.nodes.mediaGroup) sliceContainsCodeBlockOrMedia = true;
            });
            if (sliceContainsCodeBlockOrMedia) {
                const { state: state } = view;
                const { schema: schema } = state;
                const dropPos = view.posAtCoords({
                    left: event.clientX,
                    top: event.clientY
                });
                if (!dropPos) return false;
                const resolvedPos = state.doc.resolve(dropPos.pos);
                const dropLocationNodeType = resolvedPos.node().type;
                const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
                if (dropLocationNodeType === schema.nodes.blockquote || dropLocationParentNodeType === schema.nodes.blockquote) {
                    event.preventDefault();
                    return true;
                }
            }
        }
        return false;
    };
});
parcelRegister("eTqxy", function(module, exports) {
    $parcel$export(module.exports, "HEADING_KEYS", ()=>$3efc03d9dac5e81b$export$442e847723cf0569);
    const $3efc03d9dac5e81b$var$KEY_0 = 48;
    const $3efc03d9dac5e81b$var$KEY_1 = 49;
    const $3efc03d9dac5e81b$var$KEY_2 = 50;
    const $3efc03d9dac5e81b$var$KEY_3 = 51;
    const $3efc03d9dac5e81b$var$KEY_4 = 52;
    const $3efc03d9dac5e81b$var$KEY_5 = 53;
    const $3efc03d9dac5e81b$var$KEY_6 = 54;
    const $3efc03d9dac5e81b$export$442e847723cf0569 = [
        $3efc03d9dac5e81b$var$KEY_0,
        $3efc03d9dac5e81b$var$KEY_1,
        $3efc03d9dac5e81b$var$KEY_2,
        $3efc03d9dac5e81b$var$KEY_3,
        $3efc03d9dac5e81b$var$KEY_4,
        $3efc03d9dac5e81b$var$KEY_5,
        $3efc03d9dac5e81b$var$KEY_6
    ];
});
parcelRegister("6AEe7", function(module, exports) {
    $parcel$export(module.exports, "FloatingToolbarComponent", ()=>$0c9730fe31036e72$export$b15abb95157a91c7);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $awTmI;
    var $gmhCD = parcelRequire("gmhCD");
    var $6Gwcf;
    const $0c9730fe31036e72$var$FloatingToolbarSettings = {
        isSmall: true,
        disabled: false,
        isToolbarReducedSpacing: true,
        shouldUseDefaultRole: false
    };
    function $0c9730fe31036e72$export$b15abb95157a91c7({ api: api }) {
        const { blockTypeState: blockTypeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'blockType'
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, $gmhCD.editorExperiment)('contextual_formatting_toolbar', true, {
                exposure: true
            });
        }, []);
        const boundSetBlockType = (0, $5uXOq.useCallback)((name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB)), [
            api
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Gwcf")).default), {
            isSmall: $0c9730fe31036e72$var$FloatingToolbarSettings.isSmall,
            isDisabled: $0c9730fe31036e72$var$FloatingToolbarSettings.disabled,
            isReducedSpacing: $0c9730fe31036e72$var$FloatingToolbarSettings.isToolbarReducedSpacing,
            setTextLevel: boundSetBlockType,
            pluginState: blockTypeState,
            shouldUseDefaultRole: $0c9730fe31036e72$var$FloatingToolbarSettings.shouldUseDefaultRole,
            api: api
        });
    }
});
parcelRegister("6Gwcf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$407f1dfb51124f0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $e9qoo;
    var $ejItq;
    var $2rNvX;
    var $iHYdz;
    var $8Zdb4;
    var $ijWlC;
    var $fMJd2;
    class $407f1dfb51124f0f$var$ToolbarBlockType extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        componentDidMount() {
            const observer = new (0, (0, parcelRequire("8Zdb4")).default)(({ typography: typography })=>{
                if (typography !== this.state.typographyTheme) this.setState({
                    typographyTheme: typography
                });
            });
            this.setState({
                observer: observer
            });
            observer.observe();
        }
        componentWillUnmount() {
            this.state.observer?.disconnect();
        }
        render() {
            const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
            const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, pluginState: { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes }, shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
            const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
            if (isHeadingDisabled) return null;
            const blockTypeTitles = availableBlockTypes.filter((blockType)=>blockType.name === currentBlockType.name).map((blockType)=>blockType.title);
            if (!this.props.isDisabled && !blockTypesDisabled) {
                const items = this.createItems();
                return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("ejItq")).wrapperStyle)
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2rNvX")).DropdownMenuWithKeyboardNavigation), {
                    items: items,
                    onOpenChange: this.onOpenChange,
                    onItemActivated: this.handleSelectBlockType,
                    isOpen: active,
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    zIndex: (0, (0, parcelRequire("iHYdz")).akEditorMenuZIndex),
                    fitHeight: 360,
                    fitWidth: 106,
                    shouldUseDefaultRole: shouldUseDefaultRole,
                    shouldFocusFirstItem: ()=>{
                        if (isOpenedByKeyboard) this.setState({
                            ...this.state,
                            isOpenedByKeyboard: false
                        });
                        return isOpenedByKeyboard;
                    }
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ijWlC")).BlockTypeButton), {
                    isSmall: isSmall,
                    isReducedSpacing: isReducedSpacing,
                    selected: active,
                    disabled: false,
                    title: blockTypeTitles[0],
                    onClick: this.handleTriggerClick,
                    onKeyDown: this.handleTriggerByKeyboard,
                    formatMessage: formatMessage,
                    "aria-expanded": active,
                    blockTypeName: currentBlockType.name
                })), !api?.primaryToolbar && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                    css: (0, (0, parcelRequire("ejItq")).separatorStyles)
                })));
            }
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("ejItq")).wrapperStyle)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ijWlC")).BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: true,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType.name
            }), !api?.primaryToolbar && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("ejItq")).separatorStyles)
            })));
        }
        constructor(...args){
            super(...args), this.state = {
                active: false,
                isOpenedByKeyboard: false,
                typographyTheme: undefined,
                observer: null
            }, this.onOpenChange = (attrs)=>{
                this.setState({
                    ...this.state,
                    active: attrs.isOpen,
                    isOpenedByKeyboard: attrs.isOpenedByKeyboard
                });
            }, this.handleTriggerClick = ()=>{
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: false
                });
            }, this.handleTriggerByKeyboard = (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    this.onOpenChange({
                        isOpen: !this.state.active,
                        isOpenedByKeyboard: true
                    });
                }
            }, this.createItems = ()=>{
                const { intl: { formatMessage: formatMessage } } = this.props;
                const { currentBlockType: currentBlockType, availableBlockTypes: availableBlockTypes } = this.props.pluginState;
                const items = availableBlockTypes.map((blockType, index)=>{
                    const isActive = currentBlockType === blockType;
                    const tagName = blockType.tagName || 'p';
                    const Tag = tagName;
                    const keyMap = (0, (0, parcelRequire("e9qoo")).findKeymapByDescription)(blockType.title.defaultMessage);
                    return {
                        content: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                            css: (0, (0, parcelRequire("fMJd2")).blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Tag, null, formatMessage(blockType.title))),
                        value: blockType,
                        label: formatMessage(blockType.title),
                        'aria-label': (0, (0, parcelRequire("e9qoo")).tooltip)(keyMap, formatMessage(blockType.title)),
                        keyShortcuts: (0, (0, parcelRequire("e9qoo")).getAriaKeyshortcuts)(keyMap),
                        key: `${blockType.name}-${index}`,
                        elemAfter: (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                            css: [
                                (0, (0, parcelRequire("fMJd2")).keyboardShortcut),
                                isActive && (0, (0, parcelRequire("fMJd2")).keyboardShortcutSelect)
                            ]
                        }, (0, (0, parcelRequire("e9qoo")).tooltip)(keyMap)),
                        isActive: isActive
                    };
                });
                return [
                    {
                        items: items
                    }
                ];
            }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
                const blockType = item.value;
                this.props.setTextLevel(blockType.name);
                if (shouldCloseMenu) this.setState({
                    ...this.state,
                    active: false
                });
            };
        }
    }
    var $407f1dfb51124f0f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($407f1dfb51124f0f$var$ToolbarBlockType);
});
parcelRegister("ejItq", function(module, exports) {
    $parcel$export(module.exports, "buttonGroupStyle", ()=>$2e37247ce5cb1937$export$5897f954e99cc6c0);
    $parcel$export(module.exports, "separatorStyles", ()=>$2e37247ce5cb1937$export$39b9f83b35c7456d);
    $parcel$export(module.exports, "wrapperStyle", ()=>$2e37247ce5cb1937$export$c4d4f06a25de97f);
    $parcel$export(module.exports, "triggerWrapperStyles", ()=>$2e37247ce5cb1937$export$147e2cce6f264c9b);
    $parcel$export(module.exports, "triggerWrapperStylesWithPadding", ()=>$2e37247ce5cb1937$export$f2c6a721c78d3c4a);
    var $f8Sb3;
    function $2e37247ce5cb1937$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2e37247ce5cb1937$export$5897f954e99cc6c0 = {
        name: "85slrt",
        styles: "display:inline-flex;align-items:center;& > div{display:flex;}"
    };
    const $2e37247ce5cb1937$export$39b9f83b35c7456d = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-border, #091E4224)",
        width: '1px',
        height: '24px',
        display: 'inline-block',
        margin: `0 ${"var(--ds-space-100, 8px)"}`,
        userSelect: 'none'
    });
    const $2e37247ce5cb1937$export$c4d4f06a25de97f = {
        name: "3swfbj",
        styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto"
    };
    const $2e37247ce5cb1937$export$147e2cce6f264c9b = {
        name: "zjik7",
        styles: "display:flex"
    };
    const $2e37247ce5cb1937$export$f2c6a721c78d3c4a = {
        name: "cg6wix",
        styles: "display:flex;padding-right:var(--ds-space-025, 2px)"
    };
});
parcelRegister("2rNvX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc30f060f41991fa$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "DropdownMenuItem", ()=>$bc30f060f41991fa$export$ed97964d1871885d);
    $parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", ()=>$bc30f060f41991fa$export$9e0cd5a62a7d99cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $iHYdz;
    var $1aogK;
    var $eZUJu;
    var $9UCCQ;
    var $3bDjY;
    var $gKjGW;
    var $kdDpx;
    var $jdyxs;
    var $iraaj;
    var $4N9VB;
    var $2WNBA;
    var $8v0FX;
    function $bc30f060f41991fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc30f060f41991fa$var$wrapper = {
        name: "ul2689",
        styles: "& > div > div{display:flex;}"
    };
    const $bc30f060f41991fa$var$focusedMenuItemStyle = (0, (0, parcelRequire("f8Sb3")).css)({
        boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #388BFF)"}`,
        outline: 'none'
    });
    const $bc30f060f41991fa$var$buttonStyles = (isActive, submenuActive)=>{
        if (isActive) return (0, (0, parcelRequire("f8Sb3")).css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #6c798f);color:var(--ds-text, #fff);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        else return (0, (0, parcelRequire("f8Sb3")).css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #172B4D);background-color:var(--ds-background-neutral-subtle-hovered, rgb(244, 245, 247));}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, rgb(179, 212, 255))"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #091E424F);}:focus>span[aria-disabled='false']{", $bc30f060f41991fa$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    };
    const $bc30f060f41991fa$var$DropListWithOutsideClickTargetRef = (props)=>{
        const setOutsideClickTargetRef = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("jdyxs")).OutsideClickTargetRefContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iraaj")).default), {
            onDroplistRef: setOutsideClickTargetRef,
            ...props
        });
    };
    const $bc30f060f41991fa$var$DropListWithOutsideListeners = (0, (0, parcelRequire("jdyxs")).default)($bc30f060f41991fa$var$DropListWithOutsideClickTargetRef);
    class $bc30f060f41991fa$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        renderDropdownMenu() {
            const { target: target, popupPlacement: popupPlacement } = this.state;
            const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, allowEnterDefaultBehavior: allowEnterDefaultBehavior, handleEscapeKeydown: handleEscapeKeydown } = this.props;
            const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, (0, parcelRequire("8v0FX")).ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
                ...arrowKeyNavigationProviderOptions,
                onSelection: (index)=>{
                    let result = [];
                    if (typeof onItemActivated === 'function') {
                        result = items.reduce((result, group)=>{
                            return result.concat(group.items);
                        }, result);
                        onItemActivated({
                            item: result[index],
                            shouldCloseMenu: false
                        });
                    }
                }
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4N9VB")).default), {
                target: isOpen ? target : undefined,
                mountTo: mountTo,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                onPlacementChanged: this.updatePopupPlacement,
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: zIndex || (0, (0, parcelRequire("iHYdz")).akEditorFloatingPanelZIndex),
                offset: offset
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2WNBA")).ArrowKeyNavigationProvider), {
                ...navigationProviderProps,
                handleClose: this.handleCloseAndFocus,
                closeOnTab: true
            }, (0, (0, parcelRequire("f8Sb3")).jsx)($bc30f060f41991fa$var$DropListWithOutsideListeners, {
                isOpen: true,
                position: popupPlacement.join(' '),
                shouldFitContainer: true,
                handleClickOutside: this.handleClose,
                handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
                handleEnterKeydown: (e)=>{
                    if (!allowEnterDefaultBehavior) e.preventDefault();
                    e.stopPropagation();
                },
                targetRef: this.state.target
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                style: {
                    height: 0,
                    minWidth: fitWidth || 0
                }
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ref: this.popupRef
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
                role: shouldUseDefaultRole ? 'group' : 'menu'
            }, items.map((group, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9UCCQ")).default), {
                    hasSeparator: section?.hasSeparator && index > 0,
                    title: section?.title,
                    key: index
                }, group.items.map((item)=>(0, (0, parcelRequire("f8Sb3")).jsx)($bc30f060f41991fa$export$ed97964d1871885d, {
                        key: item.key ?? String(item.content),
                        item: item,
                        onItemActivated: this.props.onItemActivated,
                        shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                        onMouseEnter: this.props.onMouseEnter,
                        onMouseLeave: this.props.onMouseLeave
                    })))))))));
        }
        render() {
            const { children: children, isOpen: isOpen } = this.props;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $bc30f060f41991fa$var$wrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                ref: this.handleRef
            }, children), isOpen ? this.renderDropdownMenu() : null);
        }
        componentDidUpdate(previousProps) {
            const { mountTo: mountTo, isOpen: isOpen } = this.props;
            const isOpenToggled = isOpen !== previousProps.isOpen;
            if (isOpen && isOpenToggled) {
                if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    if (mountTo) {
                        mountTo.dispatchEvent(keyboardEvent);
                        return;
                    }
                    this.state.target?.dispatchEvent(keyboardEvent);
                }
            }
        }
        constructor(...args){
            super(...args), this.state = {
                popupPlacement: [
                    'bottom',
                    'left'
                ],
                selectionIndex: -1
            }, this.popupRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.handleRef = (target)=>{
                this.setState({
                    target: target || undefined
                });
            }, this.updatePopupPlacement = (placement)=>{
                const { popupPlacement: previousPlacement } = this.state;
                if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                    popupPlacement: placement
                });
            }, this.handleCloseAndFocus = (event)=>{
                this.state.target?.querySelector('button')?.focus();
                this.handleClose(event);
            }, this.handleClose = (event)=>{
                const { onOpenChange: onOpenChange } = this.props;
                if (onOpenChange) onOpenChange({
                    isOpen: false,
                    event: event
                });
            };
        }
    }
    const $bc30f060f41991fa$var$DropdownMenuItemCustomComponent = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ref: ref,
            ...rest,
            style: {
                position: 'static'
            }
        }, children);
    });
    function $bc30f060f41991fa$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
        const [submenuActive, setSubmenuActive] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        if (!item.onClick && !(item.value && item.value.name)) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            key: String(item.content)
        }, item.content);
        const _handleSubmenuActive = (event)=>{
            setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, (0, parcelRequire("gKjGW")).DropdownMenuSharedCssClassName).SUBMENU}`)));
        };
        const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
        const testId = item['data-testid'] || `dropdown-item__${item.content}`;
        const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
        const dropListItem = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: ()=>$bc30f060f41991fa$var$buttonStyles(item.isActive, submenuActive),
            tabIndex: tabIndex,
            "aria-disabled": item.isDisabled ? 'true' : 'false',
            onMouseDown: _handleSubmenuActive
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1aogK")).default), {
            item: item,
            key: item.key ?? String(item.content),
            testId: testId,
            role: shouldUseDefaultRole ? 'button' : 'menuitem',
            iconBefore: item.elemBefore,
            iconAfter: item.elemAfter,
            isDisabled: item.isDisabled,
            onClick: ()=>onItemActivated && onItemActivated({
                    item: item
                }),
            "aria-label": ariaLabel,
            "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
            "aria-keyshortcuts": item['aria-keyshortcuts'],
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            component: $bc30f060f41991fa$var$DropdownMenuItemCustomComponent,
            onMouseEnter: ()=>onMouseEnter && onMouseEnter({
                    item: item
                }),
            onMouseLeave: ()=>onMouseLeave && onMouseLeave({
                    item: item
                }),
            "aria-expanded": item['aria-expanded']
        }, item.content));
        if (item.tooltipDescription) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            key: item.key ?? String(item.content),
            content: item.tooltipDescription,
            position: item.tooltipPosition
        }, dropListItem);
        return dropListItem;
    }
    const $bc30f060f41991fa$export$9e0cd5a62a7d99cf = (0, ($parcel$interopDefault($5uXOq))).memo(({ ...props })=>{
        const keyDownHandlerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kdDpx")).KeyDownHandlerContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)($bc30f060f41991fa$export$2e2bcd8739ae039, {
            arrowKeyNavigationProviderOptions: {
                ...props.arrowKeyNavigationProviderOptions,
                keyDownHandlerContext: keyDownHandlerContext
            },
            ...props
        });
    });
});
parcelRegister("gKjGW", function(module, exports) {
    $parcel$export(module.exports, "DropdownMenuSharedCssClassName", ()=>$493935277ba8bc7b$export$94c0f60c32e7bd13);
    const $493935277ba8bc7b$export$15eb942addb87cf6 = 'pm-dropdown';
    const $493935277ba8bc7b$export$94c0f60c32e7bd13 = {
        SUBMENU: `${$493935277ba8bc7b$export$15eb942addb87cf6}-submenu`
    };
});
parcelRegister("jdyxs", function(module, exports) {
    $parcel$export(module.exports, "OutsideClickTargetRefContext", ()=>$4fed9d772c4caad7$export$798d66d2e25c3c95);
    $parcel$export(module.exports, "default", ()=>$4fed9d772c4caad7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $VSDnB;
    var $12Kqg;
    const $4fed9d772c4caad7$export$798d66d2e25c3c95 = (0, ($parcel$interopDefault($5uXOq))).createContext(()=>{});
    class $4fed9d772c4caad7$var$WithOutsideClick extends (0, $5uXOq.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document).addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) (this.props.popupsMountPoint ? this.props.popupsMountPoint : this.props.editorRef?.current || this.props.targetRef || document).removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.handleClick = (evt)=>{
                if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
                const domNode = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_replace_finddomnode_in_common') ? this.props.outsideClickTargetRef.current?.deref() : (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                    this.props.handleClickOutside(evt);
                    if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
                }
            }, this.handleKeydown = (evt)=>{
                if (!this.props.isActiveComponent) return;
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    this.props.handleEscapeKeydown(evt);
                    return false;
                } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
                else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) this.props.handleEscapeKeydown(evt);
            };
        }
    }
    function $4fed9d772c4caad7$var$hasIsOpen(props) {
        return 'isOpen' in props;
    }
    function $4fed9d772c4caad7$export$2e2bcd8739ae039(Component) {
        return ({ handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, closeOnTab: closeOnTab, ...props })=>{
            const isActiveProp = $4fed9d772c4caad7$var$hasIsOpen(props) ? props.isOpen : true;
            const [isActiveComponent, setActiveComponent] = (0, $5uXOq.useState)(false);
            const outsideClickTargetRef = (0, $5uXOq.useRef)(null);
            const setOutsideClickTargetRef = (0, $5uXOq.useCallback)((el)=>{
                outsideClickTargetRef.current = el && new WeakRef(el);
            }, [
                outsideClickTargetRef
            ]);
            (0, $5uXOq.useEffect)(()=>{
                requestAnimationFrame(()=>{
                    setActiveComponent(isActiveProp);
                });
            }, [
                isActiveProp
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12Kqg")).default).Consumer, null, ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement($4fed9d772c4caad7$export$798d66d2e25c3c95.Provider, {
                    value: setOutsideClickTargetRef
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($4fed9d772c4caad7$var$WithOutsideClick, {
                    editorView: editorView,
                    editorRef: editorRef,
                    targetRef: props.targetRef,
                    outsideClickTargetRef: outsideClickTargetRef,
                    popupsMountPoint: popupsMountPoint,
                    isActiveComponent: isActiveComponent,
                    handleClickOutside: handleClickOutside,
                    handleEnterKeydown: handleEnterKeydown,
                    handleEscapeKeydown: handleEscapeKeydown,
                    closeOnTab: closeOnTab
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props))));
        };
    }
});
parcelRegister("iraaj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0608b252bfbe5a2a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $cUHb0;
    const $0608b252bfbe5a2a$var$packageName = "platform-pkg";
    const $0608b252bfbe5a2a$var$packageVersion = "0.0.0-use.local";
    const $0608b252bfbe5a2a$var$halfFocusRing = 1;
    const $0608b252bfbe5a2a$var$dropOffset = '0, 8';
    class $0608b252bfbe5a2a$var$DropList extends (0, $5uXOq.Component) {
        render() {
            const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
            let layerContent = isOpen ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: this.menuWrapper,
                "data-role": "droplistContent",
                "data-testid": testId && `${testId}--content`,
                ref: this.handleContentRef,
                id: id,
                role: "presentation"
            }, children) : null;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: this.wrapperStyles,
                ref: this.handleDroplistRef
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cUHb0")).default), {
                content: layerContent,
                offset: $0608b252bfbe5a2a$var$dropOffset,
                position: position,
                onPositioned: onPositioned
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: this.triggerStyles,
                ref: this.handleTriggerRef
            }, trigger)));
        }
        constructor(...args){
            super(...args), this.wrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
                display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
                flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
                transitionDuration: '0.2s',
                transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
            }), this.triggerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
                transitionDuration: '0.2s',
                transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
                display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
                boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
            }), this.menuWrapper = ()=>{
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    color: "var(--ds-text, #172B4D)",
                    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                    borderRadius: "var(--ds-border-radius, 3px)",
                    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #091E4226, 0px 0px 1px #091E424f)",
                    boxSizing: 'border-box',
                    overflow: 'auto',
                    padding: `${"var(--ds-space-050, 4px)"} 0`,
                    maxHeight: '90vh'
                });
            }, this.componentDidMount = ()=>{
                this.setContentWidth();
                document.addEventListener('click', this.handleClickOutside, true);
                document.addEventListener('keydown', this.handleEsc);
            }, this.componentDidUpdate = ()=>{
                if (this.props.isOpen) this.setContentWidth();
            }, this.componentWillUnmount = ()=>{
                document.removeEventListener('click', this.handleClickOutside, true);
                document.removeEventListener('keydown', this.handleEsc);
            }, this.setContentWidth = ()=>{
                const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
                const { shouldFitContainer: shouldFitContainer } = this.props;
                if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $0608b252bfbe5a2a$var$halfFocusRing * 2}px`;
            }, this.handleEsc = (event)=>{
                if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
            }, this.handleClickOutside = (event)=>{
                if (this.props.isOpen) {
                    if (event.target instanceof Node) {
                        const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                        const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                        if (!withinTrigger && !withinContent) this.close(event);
                    }
                }
            }, this.close = (event)=>{
                if (this.props.onOpenChange) this.props.onOpenChange({
                    isOpen: false,
                    event: event
                });
            }, this.handleContentRef = (ref)=>{
                this.dropContentRef = ref;
                if (ref) ref.focus();
            }, this.handleDroplistRef = (ref)=>{
                this.props.onDroplistRef?.(ref);
            }, this.handleTriggerRef = (ref)=>{
                this.triggerRef = ref;
            };
        }
    }
    const $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("gB4mS")).default)('atlaskit');
    var $0608b252bfbe5a2a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'droplist',
        packageName: $0608b252bfbe5a2a$var$packageName,
        packageVersion: $0608b252bfbe5a2a$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onOpenChange: $0608b252bfbe5a2a$var$createAndFireEventOnAtlaskit({
            action: 'toggled',
            actionSubject: 'droplist',
            attributes: {
                componentName: 'droplist',
                packageName: $0608b252bfbe5a2a$var$packageName,
                packageVersion: $0608b252bfbe5a2a$var$packageVersion
            }
        })
    })($0608b252bfbe5a2a$var$DropList));
});
parcelRegister("cUHb0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bde32d597d72978f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fgNYa = parcelRequire("fgNYa");
    var $7nRxN;
    var $VSDnB;
    var $a488G;
    const $bde32d597d72978f$var$defaultState = {
        hasExtractedStyles: false,
        offsets: {
            popper: {
                left: -9999,
                top: -9999,
                position: null
            }
        },
        cssPosition: 'absolute',
        originalHeight: null,
        maxHeight: null
    };
    class $bde32d597d72978f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                boundariesElement: 'viewport',
                children: null,
                content: null,
                offset: '0, 0',
                position: 'right middle',
                zIndex: 400,
                lockScroll: false,
                isAlwaysFixed: false,
                onPositioned: ()=>{}
            };
        }
        constructor(props){
            super(props), this.targetRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.contentRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.extractStyles = (state)=>{
                if (state) {
                    const popperHeight = state.offsets.popper.height;
                    const left = Math.round(state.offsets.popper.left);
                    const top = Math.round(state.offsets.popper.top);
                    const cssPosition = 'absolute';
                    const originalHeight = this.state.originalHeight || popperHeight;
                    const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                    this.setState({
                        cssPosition: cssPosition,
                        hasExtractedStyles: true,
                        transform: `translate3d(${left}px, ${top}px, 0px)`,
                        originalHeight: originalHeight,
                        maxHeight: maxHeight
                    });
                }
            };
            this.state = $bde32d597d72978f$var$defaultState;
            this.extractStyles = (0, (0, parcelRequire("7nRxN")).default)(this.extractStyles.bind(this));
        }
        componentDidMount() {
            this.applyPopper(this.props);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) this.applyPopper(nextProps);
        }
        componentDidUpdate(prevProps, prevState) {
            const { onPositioned: onPositioned } = this.props;
            const { hasExtractedStyles: hasExtractedStyles } = this.state;
            if (this.props !== prevProps && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) this.applyPopper(this.props);
            if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
        }
        componentWillUnmount() {
            if (this.popper) this.popper.destroy();
        }
        calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
            let DocumentElementClientHeight = 0;
            if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
            if (cssPosition !== 'fixed') return null;
            const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
            return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? viewportHeight - 12 : null;
        }
        applyPopper(props) {
            if (!this.targetRef.current || !this.contentRef.current) return;
            if (this.popper) this.popper.destroy();
            if (!props.content) return;
            const isAlwaysFixed = false;
            const actualTarget = this.targetRef.current.children[0];
            const popperOpts = {
                placement: (0, (0, parcelRequire("a488G")).positionPropToPopperPosition)(props.position),
                onCreate: this.extractStyles,
                onUpdate: this.extractStyles,
                modifiers: {
                    applyStyle: {
                        enabled: false
                    },
                    hide: {
                        enabled: false
                    },
                    offset: {
                        enabled: true,
                        offset: this.props.offset
                    },
                    flip: {
                        enabled: false,
                        flipVariations: true,
                        boundariesElement: 'viewport',
                        padding: 0
                    },
                    preventOverflow: {
                        enabled: false,
                        escapeWithReference: true
                    }
                },
                positionFixed: isAlwaysFixed
            };
            if (actualTarget) this.popper = new (0, $fgNYa.default)(actualTarget, this.contentRef.current, popperOpts);
        }
        render() {
            const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
            const opacity = hasExtractedStyles ? {} : {
                opacity: 0
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.targetRef
            }, this.props.children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.contentRef,
                style: {
                    top: 0,
                    left: 0,
                    position: 'absolute',
                    transform: transform,
                    maxHeight: maxHeight ? maxHeight : 'auto',
                    ...opacity
                }
            }, this.props.content));
        }
    }
});
parcelRegister("fgNYa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1df1c8342df5413$export$2e2bcd8739ae039);
    var $b1df1c8342df5413$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
    var $b1df1c8342df5413$var$longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    var $b1df1c8342df5413$var$timeoutDuration = 0;
    for(var $b1df1c8342df5413$var$i = 0; $b1df1c8342df5413$var$i < $b1df1c8342df5413$var$longerTimeoutBrowsers.length; $b1df1c8342df5413$var$i += 1)if ($b1df1c8342df5413$var$isBrowser && navigator.userAgent.indexOf($b1df1c8342df5413$var$longerTimeoutBrowsers[$b1df1c8342df5413$var$i]) >= 0) {
        $b1df1c8342df5413$var$timeoutDuration = 1;
        break;
    }
    function $b1df1c8342df5413$var$microtaskDebounce(fn) {
        var called = false;
        return function() {
            if (called) return;
            called = true;
            window.Promise.resolve().then(function() {
                called = false;
                fn();
            });
        };
    }
    function $b1df1c8342df5413$var$taskDebounce(fn) {
        var scheduled = false;
        return function() {
            if (!scheduled) {
                scheduled = true;
                setTimeout(function() {
                    scheduled = false;
                    fn();
                }, $b1df1c8342df5413$var$timeoutDuration);
            }
        };
    }
    var $b1df1c8342df5413$var$supportsMicroTasks = $b1df1c8342df5413$var$isBrowser && window.Promise;
    var $b1df1c8342df5413$var$debounce = $b1df1c8342df5413$var$supportsMicroTasks ? $b1df1c8342df5413$var$microtaskDebounce : $b1df1c8342df5413$var$taskDebounce;
    function $b1df1c8342df5413$var$isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }
    function $b1df1c8342df5413$var$getStyleComputedProperty(element, property) {
        if (element.nodeType !== 1) return [];
        var window1 = element.ownerDocument.defaultView;
        var css = window1.getComputedStyle(element, null);
        return property ? css[property] : css;
    }
    function $b1df1c8342df5413$var$getParentNode(element) {
        if (element.nodeName === 'HTML') return element;
        return element.parentNode || element.host;
    }
    function $b1df1c8342df5413$var$getScrollParent(element) {
        if (!element) return document.body;
        switch(element.nodeName){
            case 'HTML':
            case 'BODY':
                return element.ownerDocument.body;
            case '#document':
                return element.body;
        }
        var _getStyleComputedProp = $b1df1c8342df5413$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
        if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
        return $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(element));
    }
    var $b1df1c8342df5413$var$isIE11 = $b1df1c8342df5413$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
    var $b1df1c8342df5413$var$isIE10 = $b1df1c8342df5413$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
    function $b1df1c8342df5413$var$isIE(version) {
        if (version === 11) return $b1df1c8342df5413$var$isIE11;
        if (version === 10) return $b1df1c8342df5413$var$isIE10;
        return $b1df1c8342df5413$var$isIE11 || $b1df1c8342df5413$var$isIE10;
    }
    function $b1df1c8342df5413$var$getOffsetParent(element) {
        if (!element) return document.documentElement;
        var noOffsetParent = $b1df1c8342df5413$var$isIE(10) ? document.body : null;
        var offsetParent = element.offsetParent || null;
        while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
        var nodeName = offsetParent && offsetParent.nodeName;
        if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
        if ([
            'TH',
            'TD',
            'TABLE'
        ].indexOf(offsetParent.nodeName) !== -1 && $b1df1c8342df5413$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $b1df1c8342df5413$var$getOffsetParent(offsetParent);
        return offsetParent;
    }
    function $b1df1c8342df5413$var$isOffsetContainer(element) {
        var nodeName = element.nodeName;
        if (nodeName === 'BODY') return false;
        return nodeName === 'HTML' || $b1df1c8342df5413$var$getOffsetParent(element.firstElementChild) === element;
    }
    function $b1df1c8342df5413$var$getRoot(node) {
        if (node.parentNode !== null) return $b1df1c8342df5413$var$getRoot(node.parentNode);
        return node;
    }
    function $b1df1c8342df5413$var$findCommonOffsetParent(element1, element2) {
        if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
        var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
        var start = order ? element1 : element2;
        var end = order ? element2 : element1;
        var range = document.createRange();
        range.setStart(start, 0);
        range.setEnd(end, 0);
        var commonAncestorContainer = range.commonAncestorContainer;
        if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
            if ($b1df1c8342df5413$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
            return $b1df1c8342df5413$var$getOffsetParent(commonAncestorContainer);
        }
        var element1root = $b1df1c8342df5413$var$getRoot(element1);
        if (element1root.host) return $b1df1c8342df5413$var$findCommonOffsetParent(element1root.host, element2);
        else return $b1df1c8342df5413$var$findCommonOffsetParent(element1, $b1df1c8342df5413$var$getRoot(element2).host);
    }
    function $b1df1c8342df5413$var$getScroll(element) {
        var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
        var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
        var nodeName = element.nodeName;
        if (nodeName === 'BODY' || nodeName === 'HTML') {
            var html = element.ownerDocument.documentElement;
            var scrollingElement = element.ownerDocument.scrollingElement || html;
            return scrollingElement[upperSide];
        }
        return element[upperSide];
    }
    function $b1df1c8342df5413$var$includeScroll(rect, element) {
        var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
        var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
        var modifier = subtract ? -1 : 1;
        rect.top += scrollTop * modifier;
        rect.bottom += scrollTop * modifier;
        rect.left += scrollLeft * modifier;
        rect.right += scrollLeft * modifier;
        return rect;
    }
    function $b1df1c8342df5413$var$getBordersSize(styles, axis) {
        var sideA = axis === 'x' ? 'Left' : 'Top';
        var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
        return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
    }
    function $b1df1c8342df5413$var$getSize(axis, body, html, computedStyle) {
        return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $b1df1c8342df5413$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
    }
    function $b1df1c8342df5413$var$getWindowSizes(document1) {
        var body = document1.body;
        var html = document1.documentElement;
        var computedStyle = $b1df1c8342df5413$var$isIE(10) && getComputedStyle(html);
        return {
            height: $b1df1c8342df5413$var$getSize('Height', body, html, computedStyle),
            width: $b1df1c8342df5413$var$getSize('Width', body, html, computedStyle)
        };
    }
    var $b1df1c8342df5413$var$classCallCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
    var $b1df1c8342df5413$var$createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $b1df1c8342df5413$var$defineProperty = function(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    };
    var $b1df1c8342df5413$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    function $b1df1c8342df5413$var$getClientRect(offsets) {
        return $b1df1c8342df5413$var$_extends({}, offsets, {
            right: offsets.left + offsets.width,
            bottom: offsets.top + offsets.height
        });
    }
    function $b1df1c8342df5413$var$getBoundingClientRect(element) {
        var rect = {};
        try {
            if ($b1df1c8342df5413$var$isIE(10)) {
                rect = element.getBoundingClientRect();
                var scrollTop = $b1df1c8342df5413$var$getScroll(element, 'top');
                var scrollLeft = $b1df1c8342df5413$var$getScroll(element, 'left');
                rect.top += scrollTop;
                rect.left += scrollLeft;
                rect.bottom += scrollTop;
                rect.right += scrollLeft;
            } else rect = element.getBoundingClientRect();
        } catch (e) {}
        var result = {
            left: rect.left,
            top: rect.top,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top
        };
        var sizes = element.nodeName === 'HTML' ? $b1df1c8342df5413$var$getWindowSizes(element.ownerDocument) : {};
        var width = sizes.width || element.clientWidth || result.right - result.left;
        var height = sizes.height || element.clientHeight || result.bottom - result.top;
        var horizScrollbar = element.offsetWidth - width;
        var vertScrollbar = element.offsetHeight - height;
        if (horizScrollbar || vertScrollbar) {
            var styles = $b1df1c8342df5413$var$getStyleComputedProperty(element);
            horizScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'x');
            vertScrollbar -= $b1df1c8342df5413$var$getBordersSize(styles, 'y');
            result.width -= horizScrollbar;
            result.height -= vertScrollbar;
        }
        return $b1df1c8342df5413$var$getClientRect(result);
    }
    function $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
        var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var isIE10 = $b1df1c8342df5413$var$isIE(10);
        var isHTML = parent.nodeName === 'HTML';
        var childrenRect = $b1df1c8342df5413$var$getBoundingClientRect(children);
        var parentRect = $b1df1c8342df5413$var$getBoundingClientRect(parent);
        var scrollParent = $b1df1c8342df5413$var$getScrollParent(children);
        var styles = $b1df1c8342df5413$var$getStyleComputedProperty(parent);
        var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
        var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
        if (fixedPosition && isHTML) {
            parentRect.top = Math.max(parentRect.top, 0);
            parentRect.left = Math.max(parentRect.left, 0);
        }
        var offsets = $b1df1c8342df5413$var$getClientRect({
            top: childrenRect.top - parentRect.top - borderTopWidth,
            left: childrenRect.left - parentRect.left - borderLeftWidth,
            width: childrenRect.width,
            height: childrenRect.height
        });
        offsets.marginTop = 0;
        offsets.marginLeft = 0;
        if (!isIE10 && isHTML) {
            var marginTop = parseFloat(styles.marginTop, 10);
            var marginLeft = parseFloat(styles.marginLeft, 10);
            offsets.top -= borderTopWidth - marginTop;
            offsets.bottom -= borderTopWidth - marginTop;
            offsets.left -= borderLeftWidth - marginLeft;
            offsets.right -= borderLeftWidth - marginLeft;
            offsets.marginTop = marginTop;
            offsets.marginLeft = marginLeft;
        }
        if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $b1df1c8342df5413$var$includeScroll(offsets, parent);
        return offsets;
    }
    function $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
        var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var html = element.ownerDocument.documentElement;
        var relativeOffset = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(element, html);
        var width = Math.max(html.clientWidth, window.innerWidth || 0);
        var height = Math.max(html.clientHeight, window.innerHeight || 0);
        var scrollTop = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html) : 0;
        var scrollLeft = !excludeScroll ? $b1df1c8342df5413$var$getScroll(html, 'left') : 0;
        var offset = {
            top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
            left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
            width: width,
            height: height
        };
        return $b1df1c8342df5413$var$getClientRect(offset);
    }
    function $b1df1c8342df5413$var$isFixed(element) {
        var nodeName = element.nodeName;
        if (nodeName === 'BODY' || nodeName === 'HTML') return false;
        if ($b1df1c8342df5413$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
        var parentNode = $b1df1c8342df5413$var$getParentNode(element);
        if (!parentNode) return false;
        return $b1df1c8342df5413$var$isFixed(parentNode);
    }
    function $b1df1c8342df5413$var$getFixedPositionOffsetParent(element) {
        if (!element || !element.parentElement || $b1df1c8342df5413$var$isIE()) return document.documentElement;
        var el = element.parentElement;
        while(el && $b1df1c8342df5413$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
        return el || document.documentElement;
    }
    function $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement) {
        var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var boundaries = {
            top: 0,
            left: 0
        };
        var offsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
        if (boundariesElement === 'viewport') boundaries = $b1df1c8342df5413$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
        else {
            var boundariesNode = void 0;
            if (boundariesElement === 'scrollParent') {
                boundariesNode = $b1df1c8342df5413$var$getScrollParent($b1df1c8342df5413$var$getParentNode(reference));
                if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
            } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
            else boundariesNode = boundariesElement;
            var offsets = $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
            if (boundariesNode.nodeName === 'HTML' && !$b1df1c8342df5413$var$isFixed(offsetParent)) {
                var _getWindowSizes = $b1df1c8342df5413$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
                boundaries.top += offsets.top - offsets.marginTop;
                boundaries.bottom = height + offsets.top;
                boundaries.left += offsets.left - offsets.marginLeft;
                boundaries.right = width + offsets.left;
            } else boundaries = offsets;
        }
        padding = padding || 0;
        var isPaddingNumber = typeof padding === 'number';
        boundaries.left += isPaddingNumber ? padding : padding.left || 0;
        boundaries.top += isPaddingNumber ? padding : padding.top || 0;
        boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
        boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
        return boundaries;
    }
    function $b1df1c8342df5413$var$getArea(_ref) {
        var width = _ref.width, height = _ref.height;
        return width * height;
    }
    function $b1df1c8342df5413$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
        var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        if (placement.indexOf('auto') === -1) return placement;
        var boundaries = $b1df1c8342df5413$var$getBoundaries(popper, reference, padding, boundariesElement);
        var rects = {
            top: {
                width: boundaries.width,
                height: refRect.top - boundaries.top
            },
            right: {
                width: boundaries.right - refRect.right,
                height: boundaries.height
            },
            bottom: {
                width: boundaries.width,
                height: boundaries.bottom - refRect.bottom
            },
            left: {
                width: refRect.left - boundaries.left,
                height: boundaries.height
            }
        };
        var sortedAreas = Object.keys(rects).map(function(key) {
            return $b1df1c8342df5413$var$_extends({
                key: key
            }, rects[key], {
                area: $b1df1c8342df5413$var$getArea(rects[key])
            });
        }).sort(function(a, b) {
            return b.area - a.area;
        });
        var filteredAreas = sortedAreas.filter(function(_ref2) {
            var width = _ref2.width, height = _ref2.height;
            return width >= popper.clientWidth && height >= popper.clientHeight;
        });
        var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
        var variation = placement.split('-')[1];
        return computedPlacement + (variation ? '-' + variation : '');
    }
    function $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference) {
        var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        var commonOffsetParent = fixedPosition ? $b1df1c8342df5413$var$getFixedPositionOffsetParent(popper) : $b1df1c8342df5413$var$findCommonOffsetParent(popper, reference);
        return $b1df1c8342df5413$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
    }
    function $b1df1c8342df5413$var$getOuterSizes(element) {
        var window1 = element.ownerDocument.defaultView;
        var styles = window1.getComputedStyle(element);
        var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
        var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
        var result = {
            width: element.offsetWidth + y,
            height: element.offsetHeight + x
        };
        return result;
    }
    function $b1df1c8342df5413$var$getOppositePlacement(placement) {
        var hash = {
            left: 'right',
            right: 'left',
            bottom: 'top',
            top: 'bottom'
        };
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return hash[matched];
        });
    }
    function $b1df1c8342df5413$var$getPopperOffsets(popper, referenceOffsets, placement) {
        placement = placement.split('-')[0];
        var popperRect = $b1df1c8342df5413$var$getOuterSizes(popper);
        var popperOffsets = {
            width: popperRect.width,
            height: popperRect.height
        };
        var isHoriz = [
            'right',
            'left'
        ].indexOf(placement) !== -1;
        var mainSide = isHoriz ? 'top' : 'left';
        var secondarySide = isHoriz ? 'left' : 'top';
        var measurement = isHoriz ? 'height' : 'width';
        var secondaryMeasurement = !isHoriz ? 'height' : 'width';
        popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
        if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
        else popperOffsets[secondarySide] = referenceOffsets[$b1df1c8342df5413$var$getOppositePlacement(secondarySide)];
        return popperOffsets;
    }
    function $b1df1c8342df5413$var$find(arr, check) {
        if (Array.prototype.find) return arr.find(check);
        return arr.filter(check)[0];
    }
    function $b1df1c8342df5413$var$findIndex(arr, prop, value) {
        if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
            return cur[prop] === value;
        });
        var match = $b1df1c8342df5413$var$find(arr, function(obj) {
            return obj[prop] === value;
        });
        return arr.indexOf(match);
    }
    function $b1df1c8342df5413$var$runModifiers(modifiers, data, ends) {
        var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $b1df1c8342df5413$var$findIndex(modifiers, 'name', ends));
        modifiersToRun.forEach(function(modifier) {
            if (modifier['function']) console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
            var fn = modifier['function'] || modifier.fn;
            if (modifier.enabled && $b1df1c8342df5413$var$isFunction(fn)) {
                data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
                data.offsets.reference = $b1df1c8342df5413$var$getClientRect(data.offsets.reference);
                data = fn(data, modifier);
            }
        });
        return data;
    }
    function $b1df1c8342df5413$var$update() {
        if (this.state.isDestroyed) return;
        var data = {
            instance: this,
            styles: {},
            arrowStyles: {},
            attributes: {},
            flipped: false,
            offsets: {}
        };
        data.offsets.reference = $b1df1c8342df5413$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
        data.placement = $b1df1c8342df5413$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
        data.originalPlacement = data.placement;
        data.positionFixed = this.options.positionFixed;
        data.offsets.popper = $b1df1c8342df5413$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
        data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
        data = $b1df1c8342df5413$var$runModifiers(this.modifiers, data);
        if (!this.state.isCreated) {
            this.state.isCreated = true;
            this.options.onCreate(data);
        } else this.options.onUpdate(data);
    }
    function $b1df1c8342df5413$var$isModifierEnabled(modifiers, modifierName) {
        return modifiers.some(function(_ref) {
            var name = _ref.name, enabled = _ref.enabled;
            return enabled && name === modifierName;
        });
    }
    function $b1df1c8342df5413$var$getSupportedPropertyName(property) {
        var prefixes = [
            false,
            'ms',
            'Webkit',
            'Moz',
            'O'
        ];
        var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var toCheck = prefix ? '' + prefix + upperProp : property;
            if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
        }
        return null;
    }
    function $b1df1c8342df5413$var$destroy() {
        this.state.isDestroyed = true;
        if ($b1df1c8342df5413$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
            this.popper.removeAttribute('x-placement');
            this.popper.style.position = '';
            this.popper.style.top = '';
            this.popper.style.left = '';
            this.popper.style.right = '';
            this.popper.style.bottom = '';
            this.popper.style.willChange = '';
            this.popper.style[$b1df1c8342df5413$var$getSupportedPropertyName('transform')] = '';
        }
        this.disableEventListeners();
        if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
        return this;
    }
    function $b1df1c8342df5413$var$getWindow(element) {
        var ownerDocument = element.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView : window;
    }
    function $b1df1c8342df5413$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
        var isBody = scrollParent.nodeName === 'BODY';
        var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
        target.addEventListener(event, callback, {
            passive: true
        });
        if (!isBody) $b1df1c8342df5413$var$attachToScrollParents($b1df1c8342df5413$var$getScrollParent(target.parentNode), event, callback, scrollParents);
        scrollParents.push(target);
    }
    function $b1df1c8342df5413$var$setupEventListeners(reference, options, state, updateBound) {
        state.updateBound = updateBound;
        $b1df1c8342df5413$var$getWindow(reference).addEventListener('resize', state.updateBound, {
            passive: true
        });
        var scrollElement = $b1df1c8342df5413$var$getScrollParent(reference);
        $b1df1c8342df5413$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
        state.scrollElement = scrollElement;
        state.eventsEnabled = true;
        return state;
    }
    function $b1df1c8342df5413$var$enableEventListeners() {
        if (!this.state.eventsEnabled) this.state = $b1df1c8342df5413$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
    }
    function $b1df1c8342df5413$var$removeEventListeners(reference, state) {
        $b1df1c8342df5413$var$getWindow(reference).removeEventListener('resize', state.updateBound);
        state.scrollParents.forEach(function(target) {
            target.removeEventListener('scroll', state.updateBound);
        });
        state.updateBound = null;
        state.scrollParents = [];
        state.scrollElement = null;
        state.eventsEnabled = false;
        return state;
    }
    function $b1df1c8342df5413$var$disableEventListeners() {
        if (this.state.eventsEnabled) {
            cancelAnimationFrame(this.scheduleUpdate);
            this.state = $b1df1c8342df5413$var$removeEventListeners(this.reference, this.state);
        }
    }
    function $b1df1c8342df5413$var$isNumeric(n) {
        return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
    }
    function $b1df1c8342df5413$var$setStyles(element, styles) {
        Object.keys(styles).forEach(function(prop) {
            var unit = '';
            if ([
                'width',
                'height',
                'top',
                'right',
                'bottom',
                'left'
            ].indexOf(prop) !== -1 && $b1df1c8342df5413$var$isNumeric(styles[prop])) unit = 'px';
            element.style[prop] = styles[prop] + unit;
        });
    }
    function $b1df1c8342df5413$var$setAttributes(element, attributes) {
        Object.keys(attributes).forEach(function(prop) {
            var value = attributes[prop];
            if (value !== false) element.setAttribute(prop, attributes[prop]);
            else element.removeAttribute(prop);
        });
    }
    function $b1df1c8342df5413$var$applyStyle(data) {
        $b1df1c8342df5413$var$setStyles(data.instance.popper, data.styles);
        $b1df1c8342df5413$var$setAttributes(data.instance.popper, data.attributes);
        if (data.arrowElement && Object.keys(data.arrowStyles).length) $b1df1c8342df5413$var$setStyles(data.arrowElement, data.arrowStyles);
        return data;
    }
    function $b1df1c8342df5413$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
        var referenceOffsets = $b1df1c8342df5413$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
        var placement = $b1df1c8342df5413$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
        popper.setAttribute('x-placement', placement);
        $b1df1c8342df5413$var$setStyles(popper, {
            position: options.positionFixed ? 'fixed' : 'absolute'
        });
        return options;
    }
    function $b1df1c8342df5413$var$getRoundedOffsets(data, shouldRound) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var round = Math.round, floor = Math.floor;
        var noRound = function noRound(v) {
            return v;
        };
        var referenceWidth = round(reference.width);
        var popperWidth = round(popper.width);
        var isVertical = [
            'left',
            'right'
        ].indexOf(data.placement) !== -1;
        var isVariation = data.placement.indexOf('-') !== -1;
        var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
        var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
        var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
        var verticalToInteger = !shouldRound ? noRound : round;
        return {
            left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
            top: verticalToInteger(popper.top),
            bottom: verticalToInteger(popper.bottom),
            right: horizontalToInteger(popper.right)
        };
    }
    var $b1df1c8342df5413$var$isFirefox = $b1df1c8342df5413$var$isBrowser && /Firefox/i.test(navigator.userAgent);
    function $b1df1c8342df5413$var$computeStyle(data, options) {
        var x = options.x, y = options.y;
        var popper = data.offsets.popper;
        var legacyGpuAccelerationOption = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
            return modifier.name === 'applyStyle';
        }).gpuAcceleration;
        if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
        var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
        var offsetParent = $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
        var offsetParentRect = $b1df1c8342df5413$var$getBoundingClientRect(offsetParent);
        var styles = {
            position: popper.position
        };
        var offsets = $b1df1c8342df5413$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$b1df1c8342df5413$var$isFirefox);
        var sideA = x === 'bottom' ? 'top' : 'bottom';
        var sideB = y === 'right' ? 'left' : 'right';
        var prefixedProperty = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
        var left = void 0, top = void 0;
        if (sideA === 'bottom') {
            if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
            else top = -offsetParentRect.height + offsets.bottom;
        } else top = offsets.top;
        if (sideB === 'right') {
            if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
            else left = -offsetParentRect.width + offsets.right;
        } else left = offsets.left;
        if (gpuAcceleration && prefixedProperty) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles[sideA] = 0;
            styles[sideB] = 0;
            styles.willChange = 'transform';
        } else {
            var invertTop = sideA === 'bottom' ? -1 : 1;
            var invertLeft = sideB === 'right' ? -1 : 1;
            styles[sideA] = top * invertTop;
            styles[sideB] = left * invertLeft;
            styles.willChange = sideA + ', ' + sideB;
        }
        var attributes = {
            'x-placement': data.placement
        };
        data.attributes = $b1df1c8342df5413$var$_extends({}, attributes, data.attributes);
        data.styles = $b1df1c8342df5413$var$_extends({}, styles, data.styles);
        data.arrowStyles = $b1df1c8342df5413$var$_extends({}, data.offsets.arrow, data.arrowStyles);
        return data;
    }
    function $b1df1c8342df5413$var$isModifierRequired(modifiers, requestingName, requestedName) {
        var requesting = $b1df1c8342df5413$var$find(modifiers, function(_ref) {
            var name = _ref.name;
            return name === requestingName;
        });
        var isRequired = !!requesting && modifiers.some(function(modifier) {
            return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
        });
        if (!isRequired) {
            var _requesting = '`' + requestingName + '`';
            var requested = '`' + requestedName + '`';
            console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
        }
        return isRequired;
    }
    function $b1df1c8342df5413$var$arrow(data, options) {
        var _data$offsets$arrow;
        if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
        var arrowElement = options.element;
        if (typeof arrowElement === 'string') {
            arrowElement = data.instance.popper.querySelector(arrowElement);
            if (!arrowElement) return data;
        } else if (!data.instance.popper.contains(arrowElement)) {
            console.warn('WARNING: `arrow.element` must be child of its popper element!');
            return data;
        }
        var placement = data.placement.split('-')[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isVertical = [
            'left',
            'right'
        ].indexOf(placement) !== -1;
        var len = isVertical ? 'height' : 'width';
        var sideCapitalized = isVertical ? 'Top' : 'Left';
        var side = sideCapitalized.toLowerCase();
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowElementSize = $b1df1c8342df5413$var$getOuterSizes(arrowElement)[len];
        if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
        if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
        data.offsets.popper = $b1df1c8342df5413$var$getClientRect(data.offsets.popper);
        var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
        var css = $b1df1c8342df5413$var$getStyleComputedProperty(data.instance.popper);
        var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
        var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
        var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
        sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
        data.arrowElement = arrowElement;
        data.offsets.arrow = (_data$offsets$arrow = {}, $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $b1df1c8342df5413$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
        return data;
    }
    function $b1df1c8342df5413$var$getOppositeVariation(variation) {
        if (variation === 'end') return 'start';
        else if (variation === 'start') return 'end';
        return variation;
    }
    var $b1df1c8342df5413$var$placements = [
        'auto-start',
        'auto',
        'auto-end',
        'top-start',
        'top',
        'top-end',
        'right-start',
        'right',
        'right-end',
        'bottom-end',
        'bottom',
        'bottom-start',
        'left-end',
        'left',
        'left-start'
    ];
    var $b1df1c8342df5413$var$validPlacements = $b1df1c8342df5413$var$placements.slice(3);
    function $b1df1c8342df5413$var$clockwise(placement) {
        var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var index = $b1df1c8342df5413$var$validPlacements.indexOf(placement);
        var arr = $b1df1c8342df5413$var$validPlacements.slice(index + 1).concat($b1df1c8342df5413$var$validPlacements.slice(0, index));
        return counter ? arr.reverse() : arr;
    }
    var $b1df1c8342df5413$var$BEHAVIORS = {
        FLIP: 'flip',
        CLOCKWISE: 'clockwise',
        COUNTERCLOCKWISE: 'counterclockwise'
    };
    function $b1df1c8342df5413$var$flip(data, options) {
        if ($b1df1c8342df5413$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
        if (data.flipped && data.placement === data.originalPlacement) return data;
        var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
        var placement = data.placement.split('-')[0];
        var placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';
        var flipOrder = [];
        switch(options.behavior){
            case $b1df1c8342df5413$var$BEHAVIORS.FLIP:
                flipOrder = [
                    placement,
                    placementOpposite
                ];
                break;
            case $b1df1c8342df5413$var$BEHAVIORS.CLOCKWISE:
                flipOrder = $b1df1c8342df5413$var$clockwise(placement);
                break;
            case $b1df1c8342df5413$var$BEHAVIORS.COUNTERCLOCKWISE:
                flipOrder = $b1df1c8342df5413$var$clockwise(placement, true);
                break;
            default:
                flipOrder = options.behavior;
        }
        flipOrder.forEach(function(step, index) {
            if (placement !== step || flipOrder.length === index + 1) return data;
            placement = data.placement.split('-')[0];
            placementOpposite = $b1df1c8342df5413$var$getOppositePlacement(placement);
            var popperOffsets = data.offsets.popper;
            var refOffsets = data.offsets.reference;
            var floor = Math.floor;
            var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
            var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
            var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
            var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
            var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
            var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
            var isVertical = [
                'top',
                'bottom'
            ].indexOf(placement) !== -1;
            var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
            var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
            var flippedVariation = flippedVariationByRef || flippedVariationByContent;
            if (overlapsRef || overflowsBoundaries || flippedVariation) {
                data.flipped = true;
                if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
                if (flippedVariation) variation = $b1df1c8342df5413$var$getOppositeVariation(variation);
                data.placement = placement + (variation ? '-' + variation : '');
                data.offsets.popper = $b1df1c8342df5413$var$_extends({}, data.offsets.popper, $b1df1c8342df5413$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
                data = $b1df1c8342df5413$var$runModifiers(data.instance.modifiers, data, 'flip');
            }
        });
        return data;
    }
    function $b1df1c8342df5413$var$keepTogether(data) {
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var placement = data.placement.split('-')[0];
        var floor = Math.floor;
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        var side = isVertical ? 'right' : 'bottom';
        var opSide = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
        if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
        return data;
    }
    function $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
        var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
        var value = +split[1];
        var unit = split[2];
        if (!value) return str;
        if (unit.indexOf('%') === 0) {
            var element = void 0;
            switch(unit){
                case '%p':
                    element = popperOffsets;
                    break;
                case '%':
                case '%r':
                default:
                    element = referenceOffsets;
            }
            var rect = $b1df1c8342df5413$var$getClientRect(element);
            return rect[measurement] / 100 * value;
        } else if (unit === 'vh' || unit === 'vw') {
            var size = void 0;
            if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            return size / 100 * value;
        } else return value;
    }
    function $b1df1c8342df5413$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
        var offsets = [
            0,
            0
        ];
        var useHeight = [
            'right',
            'left'
        ].indexOf(basePlacement) !== -1;
        var fragments = offset.split(/(\+|\-)/).map(function(frag) {
            return frag.trim();
        });
        var divider = fragments.indexOf($b1df1c8342df5413$var$find(fragments, function(frag) {
            return frag.search(/,|\s/) !== -1;
        }));
        if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
        var splitRegex = /\s*,\s*|\s+/;
        var ops = divider !== -1 ? [
            fragments.slice(0, divider).concat([
                fragments[divider].split(splitRegex)[0]
            ]),
            [
                fragments[divider].split(splitRegex)[1]
            ].concat(fragments.slice(divider + 1))
        ] : [
            fragments
        ];
        ops = ops.map(function(op, index) {
            var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
            var mergeWithPrevious = false;
            return op.reduce(function(a, b) {
                if (a[a.length - 1] === '' && [
                    '+',
                    '-'
                ].indexOf(b) !== -1) {
                    a[a.length - 1] = b;
                    mergeWithPrevious = true;
                    return a;
                } else if (mergeWithPrevious) {
                    a[a.length - 1] += b;
                    mergeWithPrevious = false;
                    return a;
                } else return a.concat(b);
            }, []).map(function(str) {
                return $b1df1c8342df5413$var$toValue(str, measurement, popperOffsets, referenceOffsets);
            });
        });
        ops.forEach(function(op, index) {
            op.forEach(function(frag, index2) {
                if ($b1df1c8342df5413$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
            });
        });
        return offsets;
    }
    function $b1df1c8342df5413$var$offset(data, _ref) {
        var offset = _ref.offset;
        var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var basePlacement = placement.split('-')[0];
        var offsets = void 0;
        if ($b1df1c8342df5413$var$isNumeric(+offset)) offsets = [
            +offset,
            0
        ];
        else offsets = $b1df1c8342df5413$var$parseOffset(offset, popper, reference, basePlacement);
        if (basePlacement === 'left') {
            popper.top += offsets[0];
            popper.left -= offsets[1];
        } else if (basePlacement === 'right') {
            popper.top += offsets[0];
            popper.left += offsets[1];
        } else if (basePlacement === 'top') {
            popper.left += offsets[0];
            popper.top -= offsets[1];
        } else if (basePlacement === 'bottom') {
            popper.left += offsets[0];
            popper.top += offsets[1];
        }
        data.popper = popper;
        return data;
    }
    function $b1df1c8342df5413$var$preventOverflow(data, options) {
        var boundariesElement = options.boundariesElement || $b1df1c8342df5413$var$getOffsetParent(data.instance.popper);
        if (data.instance.reference === boundariesElement) boundariesElement = $b1df1c8342df5413$var$getOffsetParent(boundariesElement);
        var transformProp = $b1df1c8342df5413$var$getSupportedPropertyName('transform');
        var popperStyles = data.instance.popper.style;
        var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
        popperStyles.top = '';
        popperStyles.left = '';
        popperStyles[transformProp] = '';
        var boundaries = $b1df1c8342df5413$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
        popperStyles.top = top;
        popperStyles.left = left;
        popperStyles[transformProp] = transform;
        options.boundaries = boundaries;
        var order = options.priority;
        var popper = data.offsets.popper;
        var check = {
            primary: function primary(placement) {
                var value = popper[placement];
                if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
                return $b1df1c8342df5413$var$defineProperty({}, placement, value);
            },
            secondary: function secondary(placement) {
                var mainSide = placement === 'right' ? 'left' : 'top';
                var value = popper[mainSide];
                if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
                return $b1df1c8342df5413$var$defineProperty({}, mainSide, value);
            }
        };
        order.forEach(function(placement) {
            var side = [
                'left',
                'top'
            ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
            popper = $b1df1c8342df5413$var$_extends({}, popper, check[side](placement));
        });
        data.offsets.popper = popper;
        return data;
    }
    function $b1df1c8342df5413$var$shift(data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftvariation = placement.split('-')[1];
        if (shiftvariation) {
            var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
            var isVertical = [
                'bottom',
                'top'
            ].indexOf(basePlacement) !== -1;
            var side = isVertical ? 'left' : 'top';
            var measurement = isVertical ? 'width' : 'height';
            var shiftOffsets = {
                start: $b1df1c8342df5413$var$defineProperty({}, side, reference[side]),
                end: $b1df1c8342df5413$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
            };
            data.offsets.popper = $b1df1c8342df5413$var$_extends({}, popper, shiftOffsets[shiftvariation]);
        }
        return data;
    }
    function $b1df1c8342df5413$var$hide(data) {
        if (!$b1df1c8342df5413$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
        var refRect = data.offsets.reference;
        var bound = $b1df1c8342df5413$var$find(data.instance.modifiers, function(modifier) {
            return modifier.name === 'preventOverflow';
        }).boundaries;
        if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
            if (data.hide === true) return data;
            data.hide = true;
            data.attributes['x-out-of-boundaries'] = '';
        } else {
            if (data.hide === false) return data;
            data.hide = false;
            data.attributes['x-out-of-boundaries'] = false;
        }
        return data;
    }
    function $b1df1c8342df5413$var$inner(data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
        var isHoriz = [
            'left',
            'right'
        ].indexOf(basePlacement) !== -1;
        var subtractLength = [
            'top',
            'left'
        ].indexOf(basePlacement) === -1;
        popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
        data.placement = $b1df1c8342df5413$var$getOppositePlacement(placement);
        data.offsets.popper = $b1df1c8342df5413$var$getClientRect(popper);
        return data;
    }
    var $b1df1c8342df5413$var$modifiers = {
        shift: {
            order: 100,
            enabled: true,
            fn: $b1df1c8342df5413$var$shift
        },
        offset: {
            order: 200,
            enabled: true,
            fn: $b1df1c8342df5413$var$offset,
            offset: 0
        },
        preventOverflow: {
            order: 300,
            enabled: true,
            fn: $b1df1c8342df5413$var$preventOverflow,
            priority: [
                'left',
                'right',
                'top',
                'bottom'
            ],
            padding: 5,
            boundariesElement: 'scrollParent'
        },
        keepTogether: {
            order: 400,
            enabled: true,
            fn: $b1df1c8342df5413$var$keepTogether
        },
        arrow: {
            order: 500,
            enabled: true,
            fn: $b1df1c8342df5413$var$arrow,
            element: '[x-arrow]'
        },
        flip: {
            order: 600,
            enabled: true,
            fn: $b1df1c8342df5413$var$flip,
            behavior: 'flip',
            padding: 5,
            boundariesElement: 'viewport',
            flipVariations: false,
            flipVariationsByContent: false
        },
        inner: {
            order: 700,
            enabled: false,
            fn: $b1df1c8342df5413$var$inner
        },
        hide: {
            order: 800,
            enabled: true,
            fn: $b1df1c8342df5413$var$hide
        },
        computeStyle: {
            order: 850,
            enabled: true,
            fn: $b1df1c8342df5413$var$computeStyle,
            gpuAcceleration: true,
            x: 'bottom',
            y: 'right'
        },
        applyStyle: {
            order: 900,
            enabled: true,
            fn: $b1df1c8342df5413$var$applyStyle,
            onLoad: $b1df1c8342df5413$var$applyStyleOnLoad,
            gpuAcceleration: undefined
        }
    };
    var $b1df1c8342df5413$var$Defaults = {
        placement: 'bottom',
        positionFixed: false,
        eventsEnabled: true,
        removeOnDestroy: false,
        onCreate: function onCreate() {},
        onUpdate: function onUpdate() {},
        modifiers: $b1df1c8342df5413$var$modifiers
    };
    var $b1df1c8342df5413$var$Popper = function() {
        function Popper(reference, popper) {
            var _this = this;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            $b1df1c8342df5413$var$classCallCheck(this, Popper);
            this.scheduleUpdate = function() {
                return requestAnimationFrame(_this.update);
            };
            this.update = $b1df1c8342df5413$var$debounce(this.update.bind(this));
            this.options = $b1df1c8342df5413$var$_extends({}, Popper.Defaults, options);
            this.state = {
                isDestroyed: false,
                isCreated: false,
                scrollParents: []
            };
            this.reference = reference && reference.jquery ? reference[0] : reference;
            this.popper = popper && popper.jquery ? popper[0] : popper;
            this.options.modifiers = {};
            Object.keys($b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
                _this.options.modifiers[name] = $b1df1c8342df5413$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
            });
            this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
                return $b1df1c8342df5413$var$_extends({
                    name: name
                }, _this.options.modifiers[name]);
            }).sort(function(a, b) {
                return a.order - b.order;
            });
            this.modifiers.forEach(function(modifierOptions) {
                if (modifierOptions.enabled && $b1df1c8342df5413$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
            });
            this.update();
            var eventsEnabled = this.options.eventsEnabled;
            if (eventsEnabled) this.enableEventListeners();
            this.state.eventsEnabled = eventsEnabled;
        }
        $b1df1c8342df5413$var$createClass(Popper, [
            {
                key: 'update',
                value: function update$$1() {
                    return $b1df1c8342df5413$var$update.call(this);
                }
            },
            {
                key: 'destroy',
                value: function destroy$$1() {
                    return $b1df1c8342df5413$var$destroy.call(this);
                }
            },
            {
                key: 'enableEventListeners',
                value: function enableEventListeners$$1() {
                    return $b1df1c8342df5413$var$enableEventListeners.call(this);
                }
            },
            {
                key: 'disableEventListeners',
                value: function disableEventListeners$$1() {
                    return $b1df1c8342df5413$var$disableEventListeners.call(this);
                }
            }
        ]);
        return Popper;
    }();
    $b1df1c8342df5413$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
    $b1df1c8342df5413$var$Popper.placements = $b1df1c8342df5413$var$placements;
    $b1df1c8342df5413$var$Popper.Defaults = $b1df1c8342df5413$var$Defaults;
    var $b1df1c8342df5413$export$2e2bcd8739ae039 = $b1df1c8342df5413$var$Popper;
});
parcelRegister("a488G", function(module, exports) {
    $parcel$export(module.exports, "positionPropToPopperPosition", ()=>$5ea83f05db9130f3$export$9e6a7c92c66a7cdd);
    const $5ea83f05db9130f3$var$positionMap = {
        'top left': {
            position: 'top-start',
            animation: 'top'
        },
        'top center': {
            position: 'top',
            animation: 'top'
        },
        'top right': {
            position: 'top-end',
            animation: 'top'
        },
        'right top': {
            position: 'right-start',
            animation: 'right'
        },
        'right middle': {
            position: 'right',
            animation: 'right'
        },
        'right bottom': {
            position: 'right-end',
            animation: 'right'
        },
        'bottom left': {
            position: 'bottom-start',
            animation: 'bottom'
        },
        'bottom center': {
            position: 'bottom',
            animation: 'bottom'
        },
        'bottom right': {
            position: 'bottom-end',
            animation: 'bottom'
        },
        'left top': {
            position: 'left-start',
            animation: 'left'
        },
        'left middle': {
            position: 'left',
            animation: 'left'
        },
        'left bottom': {
            position: 'left-end',
            animation: 'left'
        }
    };
    const $5ea83f05db9130f3$export$f6c90e9517ee2ce0 = {
        values: [
            'top left',
            'top center',
            'top right',
            'right top',
            'right middle',
            'right bottom',
            'bottom left',
            'bottom center',
            'bottom right',
            'left top',
            'left middle',
            'left bottom'
        ],
        default: 'right middle'
    };
    function $5ea83f05db9130f3$var$positionToPopper(position) {
        return position && $5ea83f05db9130f3$var$positionMap[position] ? $5ea83f05db9130f3$var$positionMap[position].position : null;
    }
    function $5ea83f05db9130f3$export$9e6a7c92c66a7cdd(position) {
        return $5ea83f05db9130f3$var$positionToPopper(position) || $5ea83f05db9130f3$var$positionMap[$5ea83f05db9130f3$export$f6c90e9517ee2ce0.default].position;
    }
});
parcelRegister("4N9VB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f05c89a5b988c61$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fGOj2 = parcelRequire("fGOj2");
    var $7nRxN;
    var $7nsd3 = parcelRequire("7nsd3");
    var $iHYdz;
    var $VSDnB;
    var $f3dKD;
    class $6f05c89a5b988c61$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                offset: [
                    0,
                    0
                ],
                allowOutOfBound: false
            };
        }
        calculatePosition(props, popup) {
            const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
            if (!target || !popup) return {};
            const placement = (0, (0, parcelRequire("f3dKD")).calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
            if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
                onPlacementChanged(placement);
                this.placement = placement;
            }
            let position = (0, (0, parcelRequire("f3dKD")).calculatePosition)({
                placement: placement,
                popup: popup,
                target: target,
                stick: stick,
                offset: offset,
                allowOutOfBounds: allowOutOfBounds,
                rect: rect
            });
            position = onPositionCalculated ? onPositionCalculated(position) : position;
            if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
            if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
            if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
            if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
            return {
                position: position,
                validPosition: (0, (0, parcelRequire("f3dKD")).validatePosition)(target)
            };
        }
        updatePosition(props = this.props, state = this.state) {
            const { popup: popup } = state;
            const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
            if (position && validPosition) (0, $7nsd3.flushSync)(()=>{
                this.setState({
                    position: position,
                    validPosition: validPosition
                });
            });
        }
        cannotSetPopup(popup, target, overflowScrollParent) {
            return !target || document.body.contains(target) && popup.offsetParent && !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
        }
        initPopup(popup) {
            this.popupRef.current = popup;
            const { target: target } = this.props;
            const overflowScrollParent = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(popup);
            if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
            this.setState({
                popup: popup
            });
            this.scheduledUpdatePosition(this.props);
            if (this.props.focusTrap) this.initFocusTrap();
        }
        UNSAFE_componentWillReceiveProps(newProps) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) this.scheduledUpdatePosition(newProps);
        }
        destroyFocusTrap() {
            this.initFocusTrap.cancel();
            this.focusTrap?.deactivate();
        }
        handleChangedFocusTrapProp(prevProps) {
            if (prevProps.focusTrap !== this.props.focusTrap) {
                if (!this.props.focusTrap) return this.focusTrap?.pause();
                if (this.focusTrap) this.focusTrap.unpause();
                return this.initFocusTrap();
            }
        }
        componentDidUpdate(prevProps) {
            this.handleChangedFocusTrapProp(prevProps);
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) {
                if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
            }
        }
        componentDidMount() {
            window.addEventListener('resize', this.onResize);
            const { stick: stick } = this.props;
            this.scrollParentElement = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(this.props.target);
            if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
            if (stick) this.scrollElement = this.scrollParentElement;
            else this.scrollElement = this.props.scrollableElement;
            if (this.scrollElement) this.scrollElement.addEventListener('scroll', this.onResize);
        }
        componentWillUnmount() {
            window.removeEventListener('resize', this.onResize);
            if (this.scrollElement) this.scrollElement.removeEventListener('scroll', this.onResize);
            if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
            this.scheduledUpdatePosition.cancel();
            this.destroyFocusTrap();
            const { onUnmount: onUnmount } = this.props;
            if (onUnmount) onUnmount();
        }
        renderPopup() {
            const { position: position } = this.state;
            const { shouldRenderPopup: shouldRenderPopup } = this.props;
            if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
            const ariaLabel = this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.handleRef,
                style: {
                    position: 'absolute',
                    zIndex: this.props.zIndex || (0, (0, parcelRequire("iHYdz")).akEditorFloatingPanelZIndex),
                    ...position,
                    ...this.props.style
                },
                "aria-label": ariaLabel,
                "data-testid": "popup-wrapper",
                "data-editor-popup": true
            }, this.props.children);
        }
        render() {
            const { target: target, mountTo: mountTo } = this.props;
            const { validPosition: validPosition } = this.state;
            if (!target || !validPosition) return null;
            if (mountTo) return (0, $7nsd3.createPortal)(this.renderPopup(), mountTo);
            return this.renderPopup();
        }
        constructor(...args){
            super(...args), this.rafIds = new Set(), this.state = {
                validPosition: true
            }, this.popupRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.placement = [
                '',
                ''
            ], this.handleRef = (popup)=>{
                if (!popup) return;
                this.initPopup(popup);
            }, this.scheduledUpdatePosition = (0, (0, parcelRequire("7nRxN")).default)((props)=>{
                this.updatePosition(this.props);
            }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
                this.scheduledUpdatePosition(this.props);
            }) : undefined, this.initFocusTrap = (0, (0, parcelRequire("7nRxN")).default)(()=>{
                const popup = this.popupRef.current;
                if (!popup) return;
                const trapConfig = {
                    clickOutsideDeactivates: true,
                    escapeDeactivates: true,
                    initialFocus: popup,
                    fallbackFocus: popup,
                    returnFocusOnDeactivate: false
                };
                this.focusTrap = (0, ($parcel$interopDefault($fGOj2)))(popup, trapConfig);
                this.focusTrap.activate();
            });
        }
    }
});
parcelRegister("f3dKD", function(module, exports) {
    $parcel$export(module.exports, "calculatePlacement", ()=>$6f8faaad8d1a72fc$export$b81415a09b611cb);
    $parcel$export(module.exports, "findOverflowScrollParent", ()=>$6f8faaad8d1a72fc$export$69742dd9a26edd3e);
    $parcel$export(module.exports, "calculatePosition", ()=>$6f8faaad8d1a72fc$export$b3ceb0cbf1056d98);
    $parcel$export(module.exports, "validatePosition", ()=>$6f8faaad8d1a72fc$export$ab306cb155a0ca1b);
    function $6f8faaad8d1a72fc$export$540dbd453ede1ce3(elem) {
        return elem === document.body;
    }
    function $6f8faaad8d1a72fc$export$ccbedd67ef6e9417(elem) {
        return elem && elem.nodeType === 3;
    }
    function $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
        if (forcePlacement && alignY) return alignY;
        if (!fitHeight) return 'bottom';
        if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) target = target.parentElement;
        const boundariesClientRect = boundariesElement.getBoundingClientRect();
        const { height: boundariesHeight } = boundariesClientRect;
        const boundariesTop = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        if (preventOverflow) {
            if (spaceAbove <= fitHeight) return 'bottom';
        }
        if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
        return 'top';
    }
    function $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
        if (forcePlacement && alignX && !preventOverflow) return alignX;
        if (!fitWidth) return alignX || 'left';
        if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) target = target.parentElement;
        const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
        const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
        const spaceLeft = targetLeft - boundariesLeft + targetWidth;
        const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
        if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
        else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
        return 'right';
    }
    function $6f8faaad8d1a72fc$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
        return [
            $6f8faaad8d1a72fc$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
            $6f8faaad8d1a72fc$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
        ];
    }
    const $6f8faaad8d1a72fc$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
        const position = {};
        if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
        else if (placement === 'end') {
            const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
            position.left = left;
        } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        if (!allowOutOfBounds) {
            if (position.left !== undefined) position.left = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
            if (position.right !== undefined) position.right = $6f8faaad8d1a72fc$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
        }
        return position;
    };
    const $6f8faaad8d1a72fc$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
        const minPopupMargin = 1;
        if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
        return Math.max(minPopupMargin, x);
    };
    const $6f8faaad8d1a72fc$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
        const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
        const newPos = {
            ...position
        };
        if (scrollParent) {
            let topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
            let targetEnd = targetHeight + topOffsetTop;
            if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
                const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
                let top = newPos.top || 0;
                top = top - (scroll + popup.clientHeight);
                newPos.top = top;
            }
        }
        return newPos;
    };
    const $6f8faaad8d1a72fc$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
        const scrollParent = $6f8faaad8d1a72fc$export$69742dd9a26edd3e(target);
        const newPos = {
            ...position
        };
        if (scrollParent) {
            const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
            const topBoundary = targetTop - scrollParentTop;
            const scrollParentScrollTop = scrollParent.scrollTop;
            if (topBoundary < 0) {
                const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
                if (placement === 'top') {
                    if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                    else newPos.bottom = topBoundary + (newPos.bottom || 0);
                }
                if (placement === 'start') {
                    if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                    else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
                }
            }
        }
        return newPos;
    };
    const $6f8faaad8d1a72fc$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
        const position = {};
        if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
        else {
            let top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
            position.top = top;
        }
        return position;
    };
    function $6f8faaad8d1a72fc$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
        let position = {};
        if (!target || !popup || !popup.offsetParent) return position;
        if ($6f8faaad8d1a72fc$export$ccbedd67ef6e9417(target)) target = target.parentElement;
        const popupOffsetParent = popup.offsetParent;
        const offsetParentStyle = popupOffsetParent.style;
        let borderBottomWidth = 0;
        if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
        const [verticalPlacement, horizontalPlacement] = placement;
        const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
        const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
        const isPopupParentBody = $6f8faaad8d1a72fc$export$540dbd453ede1ce3(popupOffsetParent);
        const verticalPosition = $6f8faaad8d1a72fc$var$calculateVerticalPlacement({
            placement: verticalPlacement,
            targetTop: targetTop,
            isPopupParentBody: isPopupParentBody,
            popupOffsetParentHeight: popupOffsetParentHeight,
            popupOffsetParentTop: popupOffsetParentTop,
            popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
            targetHeight: targetHeight,
            borderBottomWidth: borderBottomWidth,
            offset: offset
        });
        position = {
            ...position,
            ...verticalPosition
        };
        if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickTop({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popupOffsetParentHeight: popupOffsetParentHeight,
            popupOffsetParent: popupOffsetParent,
            popup: popup,
            offset: offset,
            position: position,
            placement: verticalPlacement
        });
        if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $6f8faaad8d1a72fc$var$calculateVerticalStickBottom({
            target: target,
            targetTop: targetTop,
            targetHeight: targetHeight,
            popup: popup,
            offset: offset,
            position: position
        });
        const horizontalPosition = $6f8faaad8d1a72fc$var$calculateHorizontalPlacement({
            placement: horizontalPlacement,
            targetLeft: targetLeft,
            targetRight: targetRight,
            targetWidth: targetWidth,
            isPopupParentBody: isPopupParentBody,
            popupOffsetParentLeft: popupOffsetParentLeft,
            popupOffsetParentRight: popupOffsetParentRight,
            popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
            popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
            popupClientWidth: popup.clientWidth || 0,
            offset: offset,
            allowOutOfBounds: allowOutOfBounds
        });
        position = {
            ...position,
            ...horizontalPosition
        };
        return position;
    }
    function $6f8faaad8d1a72fc$export$ab306cb155a0ca1b(popup) {
        if (!popup || !popup.offsetParent) return false;
        return true;
    }
    function $6f8faaad8d1a72fc$export$69742dd9a26edd3e(popup) {
        let parent = popup;
        if (!parent) return false;
        while(parent = parent.parentElement){
            const style = window.getComputedStyle(parent);
            if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
        }
        return false;
    }
});
parcelRegister("2WNBA", function(module, exports) {
    $parcel$export(module.exports, "ArrowKeyNavigationProvider", ()=>$4c1bb7d1103deeef$export$ee87cc4950b6d6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $12Kqg;
    var $7DsHK;
    var $1K0nW;
    var $8v0FX;
    const $4c1bb7d1103deeef$export$ee87cc4950b6d6fe = (props)=>{
        const { children: children, type: type, ...restProps } = props;
        if (type === (0, (0, parcelRequire("8v0FX")).ArrowKeyNavigationType).COLOR) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12Kqg")).default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7DsHK")).ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps
            }, children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12Kqg")).default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1K0nW")).MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps
            }, children));
    };
});
parcelRegister("7DsHK", function(module, exports) {
    $parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", ()=>$21327cd68207e48b$export$e17115e9cf808589);
    var $5uXOq = parcelRequire("5uXOq");
    const $21327cd68207e48b$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const currentSelectedColumnIndex = (0, $5uXOq.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
        const currentSelectedRowIndex = (0, $5uXOq.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
        const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
        const [listenerTargetElement] = (0, $5uXOq.useState)(element);
        const incrementRowIndex = (rowElements, columnElements)=>{
            if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
            else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
        };
        const decrementRowIndex = (rowElements, columnElements)=>{
            if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
            else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            const incrementColumnIndex = (rowElements, columnElements)=>{
                if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                    incrementRowIndex(rowElements, columnElements);
                    currentSelectedColumnIndex.current = 0;
                } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
            };
            const decrementColumnIndex = (rowElements, columnElements)=>{
                if (currentSelectedColumnIndex.current === 0) {
                    decrementRowIndex(rowElements, columnElements);
                    currentSelectedColumnIndex.current = columnElements.length - 1;
                } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
            };
            const focusColorSwatch = ()=>{
                const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
                const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
                const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
                if (!focusableElements || focusableElements?.length === 0) return;
                focusableElements[currentSelectedColumnIndex.current]?.focus();
            };
            const handleKeyDown = (event)=>{
                if (event.key === 'Tab' && closeOnTab) {
                    handleClose(event);
                    return;
                }
                const colorSwatchesRowElements = $21327cd68207e48b$var$getColorSwatchesRows(wrapperRef?.current);
                const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
                const focusableElements = $21327cd68207e48b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
                switch(event.key){
                    case 'ArrowDown':
                        incrementRowIndex(colorSwatchesRowElements, focusableElements);
                        focusColorSwatch();
                        event.preventDefault();
                        break;
                    case 'ArrowUp':
                        decrementRowIndex(colorSwatchesRowElements, focusableElements);
                        focusColorSwatch();
                        event.preventDefault();
                        break;
                    case 'ArrowLeft':
                        decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                        focusColorSwatch();
                        event.preventDefault();
                        break;
                    case 'ArrowRight':
                        incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                        focusColorSwatch();
                        event.preventDefault();
                        break;
                    case 'Escape':
                        if (!ignoreEscapeKey) handleClose(event);
                        break;
                    default:
                        return;
                }
            };
            listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
            if (isOpenedByKeyboard && isPopupPositioned) setTimeout(()=>{
                focusColorSwatch();
            });
            return ()=>{
                listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
            };
        }, [
            currentSelectedColumnIndex,
            isOpenedByKeyboard,
            isPopupPositioned,
            wrapperRef,
            handleClose,
            closeOnTab,
            ignoreEscapeKey,
            listenerTargetElement
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef
        }, children));
    };
    function $21327cd68207e48b$var$getColorSwatchesRows(rootNode) {
        if (!rootNode) return [];
        const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
        return Array.from(colorSwatchesRowElements);
    }
    function $21327cd68207e48b$var$getFocusableElements(rootNode) {
        if (!rootNode) return [];
        const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
        return Array.from(focusableModalElements);
    }
});
parcelRegister("1K0nW", function(module, exports) {
    $parcel$export(module.exports, "MenuArrowKeyNavigationProvider", ()=>$833d4b83be982376$export$e12b037790bf03e3);
    var $5uXOq = parcelRequire("5uXOq");
    const $833d4b83be982376$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
    const $833d4b83be982376$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $5uXOq.useState)(-1);
        const element = popupsMountPoint ? [
            popupsMountPoint,
            editorRef.current
        ] : [
            editorRef.current
        ];
        const [listenerTargetElement] = (0, $5uXOq.useState)(element);
        const incrementIndex = (0, $5uXOq.useCallback)((list)=>{
            const currentIndex = currentSelectedItemIndex;
            let nextIndex = (currentIndex + 1) % list.length;
            while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
            setCurrentSelectedItemIndex(nextIndex);
            return nextIndex;
        }, [
            currentSelectedItemIndex
        ]);
        const decrementIndex = (0, $5uXOq.useCallback)((list)=>{
            const currentIndex = currentSelectedItemIndex;
            let nextIndex = (list.length + currentIndex - 1) % list.length;
            while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
            setCurrentSelectedItemIndex(nextIndex);
            return nextIndex;
        }, [
            currentSelectedItemIndex
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const currentIndex = currentSelectedItemIndex;
            const list = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
            const currentElement = list[currentIndex];
            if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
                const focusIndex = incrementIndex(list);
                list[focusIndex]?.focus();
            }
        }, [
            currentSelectedItemIndex,
            onSelection,
            incrementIndex,
            decrementIndex
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (disableArrowKeyNavigation) return;
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (event.key === 'Tab' && closeOnTab) {
                    handleClose(event);
                    keyDownHandlerContext?.handleTab();
                    return;
                }
                const focusableElements = $833d4b83be982376$var$getFocusableElements(wrapperRef?.current);
                if (!focusableElements || focusableElements?.length === 0) return;
                if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
                switch(event.key){
                    case 'ArrowDown':
                        if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                            const focusIndex = incrementIndex(focusableElements);
                            focusableElements[focusIndex]?.focus();
                            event.preventDefault();
                        }
                        break;
                    case 'ArrowUp':
                        if ($833d4b83be982376$var$hasEnabledItems(focusableElements)) {
                            const focusIndex = decrementIndex(focusableElements);
                            focusableElements[focusIndex]?.focus();
                            event.preventDefault();
                        }
                        break;
                    case 'ArrowLeft':
                        if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                        if (!disableCloseOnArrowClick) handleClose(event);
                        if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                        break;
                    case 'ArrowRight':
                        if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                        if (!disableCloseOnArrowClick) handleClose(event);
                        if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                        break;
                    case 'Escape':
                        handleClose(event);
                        break;
                    case 'Enter':
                        if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                        break;
                    default:
                        return;
                }
            };
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                elem && elem.addEventListener('keydown', handleKeyDown);
            });
            return ()=>{
                listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                    elem && elem.removeEventListener('keydown', handleKeyDown);
                });
            };
        }, [
            currentSelectedItemIndex,
            wrapperRef,
            handleClose,
            disableArrowKeyNavigation,
            keyDownHandlerContext,
            closeOnTab,
            onSelection,
            incrementIndex,
            decrementIndex,
            listenerTargetElement,
            disableCloseOnArrowClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "menu-key-handler-wrapper custom-key-handler-wrapper",
            ref: wrapperRef
        }, children);
    };
    function $833d4b83be982376$var$getFocusableElements(rootNode) {
        if (!rootNode) return [];
        const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
        return Array.from(focusableModalElements);
    }
});
parcelRegister("8v0FX", function(module, exports) {
    $parcel$export(module.exports, "ArrowKeyNavigationType", ()=>$c55b0232d5331d8e$export$26c2c5e2f61f437a);
    var $c55b0232d5331d8e$export$26c2c5e2f61f437a;
    (function(ArrowKeyNavigationType) {
        ArrowKeyNavigationType["COLOR"] = "color";
        ArrowKeyNavigationType["MENU"] = "menu";
    })($c55b0232d5331d8e$export$26c2c5e2f61f437a || ($c55b0232d5331d8e$export$26c2c5e2f61f437a = {}));
});
parcelRegister("ijWlC", function(module, exports) {
    $parcel$export(module.exports, "BlockTypeButton", ()=>$7a2ae92542401a67$export$60665cf15e769742);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $eDTMN;
    var $cr1aY;
    var $ejItq;
    var $1jI4k;
    var $5Hpaz;
    var $3ti6y;
    var $c8Oei;
    var $dC5iT;
    var $8CUq3;
    var $k3Otq;
    var $fMJd2;
    const $7a2ae92542401a67$var$buttonContentStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
        overflow: 'hidden',
        padding: 'space.075'
    });
    const $7a2ae92542401a67$var$buttonContentReducedSpacingStyle = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.100',
        minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
    });
    const $7a2ae92542401a67$export$60665cf15e769742 = (props)=>{
        const blockTypeName = props.blockTypeName || '';
        const labelTextStyles = props.formatMessage((0, (0, parcelRequire("eDTMN")).toolbarMessages).textStyles, {
            blockTypeName: blockTypeName
        });
        const toolipTextStyles = props.formatMessage((0, (0, parcelRequire("eDTMN")).toolbarMessages).textStylesTooltip);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            spacing: props.isReducedSpacing ? 'none' : 'default',
            selected: props.selected,
            className: "block-type-btn",
            disabled: props.disabled,
            onClick: props.onClick,
            onKeyDown: props.onKeyDown,
            title: toolipTextStyles,
            "aria-label": labelTextStyles,
            "aria-haspopup": true,
            "aria-expanded": props['aria-expanded'],
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: [
                    (0, (0, parcelRequire("ejItq")).wrapperStyle),
                    props.isSmall && (0, (0, parcelRequire("fMJd2")).wrapperSmallStyle)
                ],
                "data-testid": "toolbar-block-type-text-styles-icon"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, props.isSmall && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5Hpaz"))))), {
                label: labelTextStyles,
                spacing: "spacious",
                color: "currentColor",
                LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("3ti6y")))))
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("cr1aY")).expandIconContainerStyle)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                label: "",
                color: "currentColor",
                LEGACY_margin: "0 0 0 -8px"
            }))))
        }, !props.isSmall && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $7a2ae92542401a67$var$buttonContentStyle,
                props.isReducedSpacing && $7a2ae92542401a67$var$buttonContentReducedSpacingStyle
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), props.title || (0, (0, parcelRequire("k3Otq")).NORMAL_TEXT).title)));
    };
});
parcelRegister("1jI4k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6db8a02783a4b1f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dWAZk = parcelRequire("dWAZk");
    var $3bDjY;
    var $gkwXh;
    var $e9qoo;
    var $gfv5d;
    function $f6db8a02783a4b1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f6db8a02783a4b1f$var$buttonWrapper = {
        name: "15currb",
        styles: "display:flex;height:100%"
    };
    const $f6db8a02783a4b1f$var$ToolbarButton = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
        const handleClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            if (disabled) return;
            if (buttonId) analyticsEvent.update((payload)=>({
                    ...payload,
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TOOLBAR_BUTTON,
                    actionSubjectId: buttonId,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                })).fire((0, $dWAZk.FabricChannel).editor);
            if (onClick) onClick(event);
            if (item && onItemClick) onItemClick(item);
        }, [
            disabled,
            onClick,
            onItemClick,
            item,
            buttonId
        ]);
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gfv5d")).default), {
            ref: ref,
            appearance: "subtle",
            testId: testId,
            className: className,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isDisabled: disabled,
            isSelected: selected,
            onClick: handleClick,
            spacing: spacing || 'default',
            target: target,
            shouldFitContainer: true,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-haspopup": ariaHasPopup,
            "aria-label": ariaLabel,
            "aria-pressed": ariaPressed,
            "aria-keyshortcuts": ariaKeyShortcuts,
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            "data-ds--level": dataDsLevel,
            rel: rel
        }, children);
        if (!title) return button;
        const tooltipContent = hideTooltip ? null : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e9qoo")).ToolTipContent), {
            description: title,
            keymap: keymap
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent,
            hideTooltipOnClick: true,
            position: titlePosition
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f6db8a02783a4b1f$var$buttonWrapper
        }, button));
    });
    var $f6db8a02783a4b1f$export$2e2bcd8739ae039 = $f6db8a02783a4b1f$var$ToolbarButton;
});
parcelRegister("gfv5d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$15e74c7dea01c8c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $15e74c7dea01c8c4$export$2e2bcd8739ae039 = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ref: ref,
            ...props,
            style: {
                alignItems: 'center'
            }
        });
    });
});
parcelRegister("5Hpaz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42647e07473269d7$var$_react = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42647e07473269d7$var$_UNSAFE_baseNew = $42647e07473269d7$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $42647e07473269d7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42647e07473269d7$var$TextIcon = (props)=>$42647e07473269d7$var$_react.default.createElement($42647e07473269d7$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8.063 1.75H2.75V5m5.313-3.25h5.187V5M8.063 1.75v12.5m0 0H10.5m-2.437 0H5.5"/>`
        }, props));
    $42647e07473269d7$var$TextIcon.displayName = 'TextIcon';
    var $42647e07473269d7$var$_default = module.exports.default = $42647e07473269d7$var$TextIcon;
});
parcelRegister("3ti6y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $28721fc49070f49d$var$_react = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $28721fc49070f49d$var$_textStyle = $28721fc49070f49d$var$_interopRequireDefault((parcelRequire("kauzw")));
    function $28721fc49070f49d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $28721fc49070f49d$var$EditorTextStyleIcon = (props)=>$28721fc49070f49d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m6.26 6.678-3.237 9.534a.5.5 0 0 0 .473.66h1.032a.75.75 0 0 0 .717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 0 0 .717.53h1.113a.5.5 0 0 0 .473-.66L9.337 6.677A1 1 0 0 0 8.39 6H7.207a1 1 0 0 0-.947.678M7.736 8.08h.051l1.364 4.453H6.372zm11.113 2.043v-.327a1 1 0 0 1 1-1H20a1 1 0 0 1 1 1v6.078a1 1 0 0 1-1 1h-.151a1 1 0 0 1-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404s-1.725.92-1.725 2.404c0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395"/></svg>`
        }, props, {
            newIcon: $28721fc49070f49d$var$_textStyle.default
        }));
    $28721fc49070f49d$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
    var $28721fc49070f49d$var$_default = module.exports.default = $28721fc49070f49d$var$EditorTextStyleIcon;
});
parcelRegister("kauzw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eaec74c566e8a5e8$var$_UNSAFE_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>$eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
        }, props));
    $eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
    var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;
});
parcelRegister("fMJd2", function(module, exports) {
    $parcel$export(module.exports, "blockTypeMenuItemStyle", ()=>$e41ad3cbd8b8f72e$export$2e548ca9c55ac73f);
    $parcel$export(module.exports, "keyboardShortcut", ()=>$e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a);
    $parcel$export(module.exports, "keyboardShortcutSelect", ()=>$e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae);
    $parcel$export(module.exports, "wrapperSmallStyle", ()=>$e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a);
    var $f8Sb3;
    var $idytF;
    var $24JcV;
    function $e41ad3cbd8b8f72e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e41ad3cbd8b8f72e$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
        const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, white)"} !important; }` : '';
        return ()=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("idytF")).headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}}", selectedStyle);
    };
    const $e41ad3cbd8b8f72e$export$54ea58af6cf8bf3a = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("24JcV")).shortcutStyle), {
        marginLeft: "var(--ds-space-200, 16px)",
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
    });
    const $e41ad3cbd8b8f72e$export$b09cf4fbc27c2bae = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$eece5f492e429f08)})`
    });
    const $e41ad3cbd8b8f72e$export$4f9ef2b7bddb4c3a = {
        name: "1eh91m4",
        styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
    };
    const $e41ad3cbd8b8f72e$export$e1f541b6d8e35681 = {
        name: "1igsh0u",
        styles: "margin-left:var(--ds-space-negative-100, -8px)"
    };
});
parcelRegister("24JcV", function(module, exports) {
    $parcel$export(module.exports, "shortcutStyle", ()=>$c5630718e5a09f0f$export$297e5814a2c821bb);
    var $f8Sb3;
    var $iHYdz;
    const $c5630718e5a09f0f$export$297e5814a2c821bb = (0, (0, parcelRequire("f8Sb3")).css)("background-color:var(--ds-background-neutral, #091E420F);color:var(--ds-text-subtle, #44546F);border-radius:var(--ds-border-radius, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, (0, parcelRequire("iHYdz")).akEditorMobileMaxWidth), "px){display:none;}");
});
parcelRegister("62ifj", function(module, exports) {
    $parcel$export(module.exports, "PrimaryToolbarComponent", ()=>$f4af8af866ff3914$export$94516d5cccf573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $awTmI;
    var $6Gwcf;
    function $f4af8af866ff3914$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
        const { blockTypeState: blockTypeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'blockType'
        ]);
        const boundSetBlockType = (name)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Gwcf")).default), {
            isSmall: isSmall,
            isDisabled: disabled,
            isReducedSpacing: isToolbarReducedSpacing,
            setTextLevel: boundSetBlockType,
            pluginState: blockTypeState,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: shouldUseDefaultRole,
            api: api
        });
    }
});
parcelRegister("3nspz", function(module, exports) {
    $parcel$export(module.exports, "cardPlugin", ()=>(parcelRequire("7fslY")).cardPlugin);
    var $7fslY;
});
parcelRegister("7fslY", function(module, exports) {
    $parcel$export(module.exports, "cardPlugin", ()=>$ec98e7cd7285dac8$export$2a6748328f902e16);
    var $5uXOq = parcelRequire("5uXOq");
    var $80CM7;
    var $I02Nt;
    var $3dBkm;
    var $lX6w0;
    var $f980L;
    var $ahNvu;
    var $nYpqR;
    var $jPiXc;
    var $ie3zK;
    var $kfdsX;
    var $lumM0;
    var $poQgC;
    var $dl2Ap;
    var $g0sA9;
    var $cEDVI;
    var $dUrXD;
    var $eZ5Wl;
    var $AYP48;
    var $6caZq;
    var $89B6e;
    const $ec98e7cd7285dac8$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
        let previousCardProvider;
        const cardPluginEvents = (0, (0, parcelRequire("ahNvu")).createEventsQueue)();
        return {
            name: 'card',
            getSharedState (editorState) {
                if (!editorState) return null;
                return (0, (0, parcelRequire("lumM0")).pluginKey).getState(editorState) || null;
            },
            nodes () {
                const nodes = [
                    {
                        name: 'inlineCard',
                        node: (0, (0, parcelRequire("g0sA9")).inlineCardSpecWithFixedToDOM)()
                    },
                    {
                        name: 'blockCard',
                        node: (0, (0, parcelRequire("poQgC")).blockCardSpecWithFixedToDOM)()
                    }
                ];
                if (options.allowEmbeds) nodes.push({
                    name: 'embedCard',
                    node: (0, (0, parcelRequire("dl2Ap")).embedCardSpecWithFixedToDOM)()
                });
                return nodes;
            },
            pmPlugins () {
                const allowBlockCards = options.allowBlockCards ?? true;
                const allowResizing = options.allowResizing ?? true;
                const useAlternativePreloader = options.useAlternativePreloader ?? true;
                const allowWrapping = options.allowWrapping ?? true;
                const allowAlignment = options.allowAlignment ?? true;
                const allowDatasource = options.allowDatasource ?? false;
                const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
                const plugins = [
                    {
                        name: 'card',
                        plugin: (0, (0, parcelRequire("kfdsX")).createPlugin)({
                            ...options,
                            allowBlockCards: allowBlockCards,
                            allowResizing: allowResizing,
                            useAlternativePreloader: useAlternativePreloader,
                            allowWrapping: allowWrapping,
                            allowAlignment: allowAlignment,
                            allowDatasource: allowDatasource,
                            cardPluginEvents: cardPluginEvents,
                            showUpgradeDiscoverability: showUpgradeDiscoverability
                        }, api)
                    }
                ];
                plugins.push({
                    name: 'cardKeymap',
                    plugin: ({ featureFlags: featureFlags })=>{
                        return (0, (0, parcelRequire("ie3zK")).cardKeymap)(featureFlags);
                    }
                });
                return plugins;
            },
            contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
                const breakoutEnabled = options.editorAppearance === 'full-page';
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AYP48")).EditorSmartCardEvents), {
                    editorView: editorView
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZ5Wl")).EditorLinkingPlatformAnalytics), {
                    cardPluginEvents: cardPluginEvents,
                    editorView: editorView
                }), breakoutEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6caZq")).default), {
                    api: api,
                    editorView: editorView,
                    mountPoint: popupsMountPoint,
                    scrollableElement: popupsScrollableElement,
                    boundariesElement: popupsBoundariesElement
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dUrXD")).default), {
                    api: api,
                    editorView: editorView
                }));
            },
            actions: {
                setProvider: async (providerPromise)=>{
                    const provider = await providerPromise;
                    if (previousCardProvider === provider || options?.provider === providerPromise) return false;
                    previousCardProvider = provider;
                    return api?.core.actions.execute(({ tr: tr })=>(0, (0, parcelRequire("nYpqR")).setProvider)(provider)(tr)) ?? false;
                },
                hideLinkToolbar: (0, parcelRequire("nYpqR")).hideLinkToolbar,
                queueCardsFromChangedTr: (0, parcelRequire("jPiXc")).queueCardsFromChangedTr,
                getStartingToolbarItems: (0, (0, parcelRequire("cEDVI")).getStartingToolbarItems)(options, api),
                getEndingToolbarItems: (0, (0, parcelRequire("cEDVI")).getEndingToolbarItems)(options, api)
            },
            pluginsOptions: {
                floatingToolbar: (0, (0, parcelRequire("cEDVI")).floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertArray = [];
                    if (!options.allowDatasource) return quickInsertArray;
                    quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceJiraIssue),
                        description: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceJiraIssueDescription),
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'jira'
                        ],
                        featured: true,
                        icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconDatasourceJiraIssue), null),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, (0, parcelRequire("nYpqR")).showDatasourceModal)('jira')(tr);
                            return tr;
                        }
                    });
                    if ((0, (0, parcelRequire("3dBkm")).canRenderDatasource)((0, (0, parcelRequire("lX6w0")).ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceAssetsObjectsGeneralAvailability),
                        description: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceAssetsObjectsDescription),
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'assets'
                        ],
                        icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconDatasourceAssetsObjects), null),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, (0, parcelRequire("nYpqR")).showDatasourceModal)('assets')(tr);
                            return tr;
                        }
                    });
                    if ((0, (0, parcelRequire("89B6e")).isDatasourceConfigEditable)((0, (0, parcelRequire("f980L")).CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceConfluenceSearch),
                        description: formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceConfluenceSearchDescription),
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'confluence'
                        ],
                        featured: true,
                        icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconDatasourceConfluenceSearch), null),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, (0, parcelRequire("nYpqR")).showDatasourceModal)('confluence-search')(tr);
                            return tr;
                        }
                    });
                    return quickInsertArray;
                }
            }
        };
    };
});
parcelRegister("3dBkm", function(module, exports) {
    $parcel$export(module.exports, "getDatasourceType", ()=>$690615f85cf46a23$export$19af9860957ca153);
    $parcel$export(module.exports, "canRenderDatasource", ()=>$690615f85cf46a23$export$1974047c293dd52e);
    var $lX6w0;
    var $f980L;
    var $7mvwv;
    var $VSDnB;
    const $690615f85cf46a23$export$19af9860957ca153 = (datasourceId)=>{
        switch(datasourceId){
            case 0, (0, parcelRequire("7mvwv")).JIRA_LIST_OF_LINKS_DATASOURCE_ID:
                return 'jira';
            case 0, (0, parcelRequire("lX6w0")).ASSETS_LIST_OF_LINKS_DATASOURCE_ID:
                return 'assets';
            case 0, (0, parcelRequire("f980L")).CONFLUENCE_SEARCH_DATASOURCE_ID:
                return 'confluence-search';
            default:
                return undefined;
        }
    };
    const $690615f85cf46a23$export$1974047c293dd52e = (datasourceId, defaultValue = true)=>{
        const datasourceType = $690615f85cf46a23$export$19af9860957ca153(datasourceId);
        switch(datasourceType){
            case 'jira':
                return true;
            case 'assets':
                if ((0, (0, parcelRequire("VSDnB")).fg)('linking_platform_datasource_assets_objects')) return true;
                return false;
            default:
                return defaultValue;
        }
    };
});
parcelRegister("lX6w0", function(module, exports) {
    $parcel$export(module.exports, "ASSETS_LIST_OF_LINKS_DATASOURCE_ID", ()=>$b26c1258743f5547$export$34a6fbdd67f09ff6);
    $parcel$export(module.exports, "default", ()=>$b26c1258743f5547$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b26c1258743f5547$export$34a6fbdd67f09ff6 = '361d618a-3c04-40ad-9b27-3c8ea6927020';
    const $b26c1258743f5547$var$LazyAssetsConfigModal = (0, $5uXOq.lazy)(()=>(parcelRequire("cFFHi")).then((module)=>({
                default: module.AssetsConfigModal
            })));
    const $b26c1258743f5547$var$AssetsConfigModalWithWrappers = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": 'assets-aql-datasource-table-suspense'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b26c1258743f5547$var$LazyAssetsConfigModal, props));
    };
    var $b26c1258743f5547$export$2e2bcd8739ae039 = $b26c1258743f5547$var$AssetsConfigModalWithWrappers;
});
parcelRegister("cFFHi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("Kr4ci")
    ]).then(()=>parcelRequire('4QSOw'));
});
parcelRegister("f980L", function(module, exports) {
    $parcel$export(module.exports, "CONFLUENCE_SEARCH_DATASOURCE_ID", ()=>$4b1899e250d97ce5$export$d9788d6cf1867282);
    $parcel$export(module.exports, "default", ()=>$4b1899e250d97ce5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $4b1899e250d97ce5$export$d9788d6cf1867282 = '768fc736-3af4-4a8f-b27e-203602bff8ca';
    const $4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal = (0, $5uXOq.lazy)(()=>(parcelRequire("dqcPy")).then((module)=>({
                default: module.ConfluenceSearchConfigModal
            })));
    const $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": 'confluence-search-datasource-table-suspense'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4b1899e250d97ce5$var$LazyConfluenceSearchConfigModal, props));
    };
    var $4b1899e250d97ce5$export$2e2bcd8739ae039 = $4b1899e250d97ce5$var$ConfluenceSearchConfigModalWithWrappers;
});
parcelRegister("dqcPy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("21Uj6")
    ]).then(()=>parcelRequire('ayFsd'));
});
parcelRegister("7mvwv", function(module, exports) {
    $parcel$export(module.exports, "JIRA_LIST_OF_LINKS_DATASOURCE_ID", ()=>$0edb3309d3119e6e$export$8ce19958117ece5c);
    $parcel$export(module.exports, "default", ()=>$0edb3309d3119e6e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0edb3309d3119e6e$export$8ce19958117ece5c = 'd8b75300-dfda-4519-b6cd-e49abbd50401';
    const $0edb3309d3119e6e$var$LazyJiraIssuesConfigModal = (0, $5uXOq.lazy)(()=>(parcelRequire("6MyHE")).then((module)=>({
                default: module.JiraIssuesConfigModal
            })));
    const $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": 'jira-datasource-table-suspense'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0edb3309d3119e6e$var$LazyJiraIssuesConfigModal, props));
    };
    var $0edb3309d3119e6e$export$2e2bcd8739ae039 = $0edb3309d3119e6e$var$JiraIssuesConfigModalWithWrappers;
});
parcelRegister("6MyHE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3BfG3")
    ]).then(()=>parcelRequire('2WQ9j'));
});
parcelRegister("ahNvu", function(module, exports) {
    $parcel$export(module.exports, "createEventsQueue", ()=>$b7c002719b67b505$export$5115a388c364848d);
    const $b7c002719b67b505$export$5115a388c364848d = ()=>{
        const queue = [];
        const subscribers = new Set();
        const subscribe = (subscriber)=>{
            subscribers.add(subscriber);
            return ()=>{
                subscribers.delete(subscriber);
            };
        };
        const push = (...events)=>{
            queue.push(...events);
        };
        const flush = ()=>{
            while(queue.length){
                const event = queue.shift();
                if (event) subscribers.forEach((subscriber)=>{
                    subscriber(event);
                });
            }
        };
        const getSize = ()=>queue.length;
        return {
            push: push,
            flush: flush,
            subscribe: subscribe,
            getSize: getSize
        };
    };
});
parcelRegister("nYpqR", function(module, exports) {
    $parcel$export(module.exports, "resolveCard", ()=>$cf821aeeee453783$export$2b7045d36e3e01d4);
    $parcel$export(module.exports, "queueCards", ()=>$cf821aeeee453783$export$5312e3a17c3f6d3);
    $parcel$export(module.exports, "registerCard", ()=>$cf821aeeee453783$export$af5afab36c1f83f6);
    $parcel$export(module.exports, "registerRemoveOverlay", ()=>$cf821aeeee453783$export$a3d5a5cb818ce9d9);
    $parcel$export(module.exports, "registerSmartCardEvents", ()=>$cf821aeeee453783$export$55288255874724a1);
    $parcel$export(module.exports, "setProvider", ()=>$cf821aeeee453783$export$1572b3eade6662f9);
    $parcel$export(module.exports, "setDatasourceTableRef", ()=>$cf821aeeee453783$export$f9c5be16586d220a);
    $parcel$export(module.exports, "setCardLayout", ()=>$cf821aeeee453783$export$c9a25858ed46807c);
    $parcel$export(module.exports, "setCardLayoutAndDatasourceTableRef", ()=>$cf821aeeee453783$export$dd3435a1df9b2a3f);
    $parcel$export(module.exports, "showLinkToolbar", ()=>$cf821aeeee453783$export$83c364d103479f90);
    $parcel$export(module.exports, "hideLinkToolbar", ()=>$cf821aeeee453783$export$bd1cd60a9b31da5e);
    $parcel$export(module.exports, "showDatasourceModal", ()=>$cf821aeeee453783$export$2c79f54b873d04be);
    $parcel$export(module.exports, "hideDatasourceModal", ()=>$cf821aeeee453783$export$e545bc176b552938);
    $parcel$export(module.exports, "clearOverlayCandidate", ()=>$cf821aeeee453783$export$a2922c2e95ff48f7);
    $parcel$export(module.exports, "setDatasourceStash", ()=>$cf821aeeee453783$export$53e36aa41bbce673);
    $parcel$export(module.exports, "removeDatasourceStash", ()=>$cf821aeeee453783$export$4b1fde77584594b5);
    var $lumM0;
    const $cf821aeeee453783$export$a884a52152489cc3 = (tr, action)=>{
        return tr.setMeta((0, (0, parcelRequire("lumM0")).pluginKey), action);
    };
    const $cf821aeeee453783$export$2b7045d36e3e01d4 = (url)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'RESOLVE',
                url: url
            });
    const $cf821aeeee453783$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'QUEUE',
                requests: requests
            });
    const $cf821aeeee453783$export$af5afab36c1f83f6 = (info)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'REGISTER',
                info: info
            });
    const $cf821aeeee453783$export$a3d5a5cb818ce9d9 = (callback)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
                callback: callback
            });
    const $cf821aeeee453783$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'REGISTER_EVENTS',
                smartLinkEvents: smartLinkEvents
            });
    const $cf821aeeee453783$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'SET_PROVIDER',
                provider: cardProvider
            });
    const $cf821aeeee453783$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'SET_DATASOURCE_TABLE_REF',
                datasourceTableRef: datasourceTableRef
            });
    const $cf821aeeee453783$export$c9a25858ed46807c = (layout)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'SET_CARD_LAYOUT',
                layout: layout
            });
    const $cf821aeeee453783$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
                layout: layout,
                datasourceTableRef: datasourceTableRef
            });
    const $cf821aeeee453783$export$83c364d103479f90 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SHOW_LINK_TOOLBAR'
        });
    const $cf821aeeee453783$export$bd1cd60a9b31da5e = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'HIDE_LINK_TOOLBAR'
        });
    const $cf821aeeee453783$export$2c79f54b873d04be = (modalType)=>(tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
                type: 'SHOW_DATASOURCE_MODAL',
                modalType: modalType
            });
    const $cf821aeeee453783$export$e545bc176b552938 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'HIDE_DATASOURCE_MODAL'
        });
    const $cf821aeeee453783$export$a2922c2e95ff48f7 = (tr)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'CLEAR_OVERLAY_CANDIDATE'
        });
    const $cf821aeeee453783$export$53e36aa41bbce673 = (tr, datasourceStash)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_STASH',
            datasourceStash: datasourceStash
        });
    const $cf821aeeee453783$export$4b1fde77584594b5 = (tr, url)=>$cf821aeeee453783$export$a884a52152489cc3(tr, {
            type: 'REMOVE_DATASOURCE_STASH',
            url: url
        });
});
parcelRegister("lumM0", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$9679942c324f0355$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $9679942c324f0355$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('cardPlugin');
});
parcelRegister("jPiXc", function(module, exports) {
    $parcel$export(module.exports, "replaceQueuedUrlWithCard", ()=>$2c36f52f15a584d8$export$78f5a0da64579d3e);
    $parcel$export(module.exports, "handleFallbackWithAnalytics", ()=>$2c36f52f15a584d8$export$2bb01cc4a12e0b44);
    $parcel$export(module.exports, "queueCardsFromChangedTr", ()=>$2c36f52f15a584d8$export$f17c48478174211e);
    $parcel$export(module.exports, "changeSelectedCardToLink", ()=>$2c36f52f15a584d8$export$3f14f692ecc2a0d9);
    $parcel$export(module.exports, "changeSelectedCardToLinkFallback", ()=>$2c36f52f15a584d8$export$56a04318a610dc7c);
    $parcel$export(module.exports, "updateCard", ()=>$2c36f52f15a584d8$export$884fcee347ca969b);
    $parcel$export(module.exports, "changeSelectedCardToText", ()=>$2c36f52f15a584d8$export$23c9e012c8c1ce24);
    $parcel$export(module.exports, "setSelectedCardAppearance", ()=>$2c36f52f15a584d8$export$a188ef61ddbb94f);
    $parcel$export(module.exports, "updateCardViaDatasource", ()=>$2c36f52f15a584d8$export$113cdaf1b279f308);
    $parcel$export(module.exports, "insertDatasource", ()=>$2c36f52f15a584d8$export$7f7b236478a618df);
    var $ajpes = parcelRequire("ajpes");
    var $iZOJ9;
    var $gkwXh;
    var $cPN3o;
    var $2iyV6;
    var $1ZWXY;
    var $h03xs;
    var $dPSMN;
    var $ggL2v;
    var $agxMF;
    var $fZzhT;
    var $gZGBX;
    var $VSDnB;
    var $89B6e;
    var $nYpqR;
    var $lumM0;
    var $1CO6U;
    function $2c36f52f15a584d8$var$replaceLinksToCards(tr, cardAdf, schema, request) {
        const { inlineCard: inlineCard } = schema.nodes;
        const { url: url } = request;
        if (!(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return;
        const pos = tr.mapping.map(request.pos);
        const $pos = tr.doc.resolve(pos);
        const $head = tr.selection.$head;
        const node = tr.doc.nodeAt(pos);
        if (!node || !node.type.isText) return;
        const replaceLink = request.shouldReplaceLink || (0, (0, parcelRequire("1CO6U")).shouldReplaceLink)(node, request.compareLinkText, url);
        if (!replaceLink) return;
        const nodes = [
            cardAdf
        ];
        if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
        tr.replaceWith(pos, pos + (node.text || url).length, nodes);
        if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_paste_insert_nodes')) {
            const annotationMarksForPos = (0, (0, parcelRequire("h03xs")).getAnnotationMarksForPos)($head);
            if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
                tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
            });
        }
        return $pos.node($pos.depth - 1).type.name;
    }
    const $2c36f52f15a584d8$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent)=>(editorState, dispatch)=>{
            const state = (0, (0, parcelRequire("lumM0")).pluginKey).getState(editorState);
            if (!state) return false;
            const requests = state.requests.filter((req)=>req.url === url);
            const schema = editorState.schema;
            const cardAdf = (0, (0, parcelRequire("agxMF")).processRawValue)(schema, cardData);
            let tr = editorState.tr;
            if (cardAdf) {
                const nodeContexts = requests.map((request)=>$2c36f52f15a584d8$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context);
                if (nodeContexts.length) {
                    const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                    const nodeType = 'inlineCard';
                    const [, , domainName] = url.split('/');
                    if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                    const inputMethod = requests[0].source;
                    const sourceEvent = requests[0].sourceEvent;
                    editorAnalyticsApi?.attachAnalyticsEvent({
                        action: analyticsAction || (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).SMART_LINK,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: inputMethod,
                            nodeType: nodeType,
                            nodeContext: nodeContext,
                            fromCurrentDomain: (0, (0, parcelRequire("dPSMN")).isFromCurrentDomain)(url)
                        },
                        nonPrivacySafeAttributes: {
                            domainName: domainName
                        }
                    })(tr);
                    (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(editorState.selection, tr, {
                        action: analyticsAction,
                        inputMethod: inputMethod,
                        cardAction: 'RESOLVE',
                        sourceEvent: sourceEvent
                    });
                }
            }
            if (dispatch) dispatch((0, (0, parcelRequire("nYpqR")).resolveCard)(url)((0, (0, parcelRequire("fZzhT")).closeHistory)(tr)));
            return true;
        };
    const $2c36f52f15a584d8$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
            const cardState = (0, (0, parcelRequire("lumM0")).pluginKey).getState(state);
            if (!cardState) return false;
            const tr = state.tr;
            if (request.source !== (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB) editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("dPSMN")).getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
            (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                action: request.analyticsAction,
                inputMethod: request.source,
                sourceEvent: request.sourceEvent
            });
            if (dispatch) dispatch((0, (0, parcelRequire("nYpqR")).resolveCard)(request.url)(tr));
            return true;
        };
    const $2c36f52f15a584d8$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
        const { schema: schema } = state;
        const { link: link } = schema.marks;
        const requests = [];
        (0, (0, parcelRequire("ggL2v")).nodesBetweenChanged)(tr, (node, pos)=>{
            if (!node.isText) return true;
            const linkMark = node.marks.find((mark)=>mark.type === link);
            if (linkMark) {
                if (!(0, (0, parcelRequire("1CO6U")).shouldReplaceLink)(node, normalizeLinkText)) return false;
                requests.push({
                    url: linkMark.attrs.href,
                    pos: pos,
                    appearance: appearance,
                    compareLinkText: normalizeLinkText,
                    source: source,
                    analyticsAction: analyticsAction,
                    sourceEvent: sourceEvent
                });
            }
            return false;
        });
        if (analyticsAction) (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
            action: analyticsAction
        });
        return (0, (0, parcelRequire("nYpqR")).queueCards)(requests)(tr);
    };
    const $2c36f52f15a584d8$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
        const { schema: schema } = state;
        const { link: link } = schema.marks;
        let requests = [];
        (0, (0, parcelRequire("ggL2v")).nodesBetweenChanged)(tr, (node, pos)=>{
            if (!node.isText) return true;
            const linkMark = node.marks.find((mark)=>mark.type === link);
            if (linkMark) {
                if (!(0, (0, parcelRequire("1CO6U")).shouldReplaceLink)(node, normalizeLinkText)) return false;
                requests.push({
                    url: linkMark.attrs.href,
                    pos: pos,
                    appearance: 'inline',
                    previousAppearance: previousAppearance,
                    compareLinkText: normalizeLinkText,
                    source: source,
                    analyticsAction: analyticsAction,
                    sourceEvent: sourceEvent
                });
            }
            return false;
        });
        (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
            action: analyticsAction
        });
        return (0, (0, parcelRequire("nYpqR")).queueCards)(requests)(tr);
    };
    const $2c36f52f15a584d8$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
        const { schema: schema } = state;
        const { link: link } = schema.marks;
        const requests = [];
        state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
            const linkMark = node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: appearance,
                previousAppearance: 'url',
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE,
                shouldReplaceLink: true
            });
        });
        (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, state.tr, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE
        });
        return (0, (0, parcelRequire("nYpqR")).queueCards)(requests)(state.tr);
    };
    const $2c36f52f15a584d8$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
            const selectedNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) ? state.selection.node : undefined;
            let tr;
            if (node && pos) tr = $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
            else tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href);
            $2c36f52f15a584d8$var$updateDatasourceStash(tr, selectedNode);
            if (sendAnalytics) {
                if (selectedNode) editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        newType: (0, (0, parcelRequire("cPN3o")).SMART_LINK_TYPE).URL,
                        previousType: (0, (0, parcelRequire("89B6e")).appearanceForNodeType)(selectedNode.type)
                    }
                })(tr);
            }
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        };
    const $2c36f52f15a584d8$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
            let tr;
            if (node && pos) tr = $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
            else tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href);
            if (sendAnalytics) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).ERRORED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Smart card falling back to link.'
                }
            })(tr);
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        };
    const $2c36f52f15a584d8$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
            const selectedNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node;
            if (!selectedNode) return false;
            const cardAppearance = (0, (0, parcelRequire("89B6e")).selectedCardAppearance)(state);
            const tr = $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, href, href);
            $2c36f52f15a584d8$export$717aabd99c4fc685(state, tr, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).MANUAL, (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        };
    function $2c36f52f15a584d8$var$cardToLinkWithTransaction(state, text, href) {
        const selectedNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node;
        if (!selectedNode) return state.tr;
        const { link: link } = state.schema.marks;
        const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
            link.create({
                href: href || url
            })
        ]), false);
        return tr;
    }
    function $2c36f52f15a584d8$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
        const { link: link } = state.schema.marks;
        const url = node.attrs.url || node.attrs.data.url;
        return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
            link.create({
                href: href || url
            })
        ]));
    }
    const $2c36f52f15a584d8$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
            const selectedNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && state.selection.node;
            if (!selectedNode) return false;
            const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
            if (dispatch) {
                (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK
                });
                tr.scrollIntoView();
                editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).unlinkPayload)((0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).CARD_INLINE))(tr);
                dispatch(tr);
            }
            return true;
        };
    const $2c36f52f15a584d8$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
            const selectedNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) ? state.selection.node : undefined;
            if (!selectedNode) {
                const tr = $2c36f52f15a584d8$export$c8301558911030d4(state, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB, appearance);
                if (dispatch) {
                    (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE
                    });
                    dispatch(tr.scrollIntoView());
                }
                return false;
            }
            if ((0, (0, parcelRequire("89B6e")).appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
            const attrs = $2c36f52f15a584d8$export$85bb3e53350e35b8(appearance, selectedNode);
            const { from: from, to: to } = state.selection;
            const nodeType = $2c36f52f15a584d8$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
            const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
            $2c36f52f15a584d8$var$updateDatasourceStash(tr, selectedNode);
            if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, to + 1));
            const previousNodePos = from - 1 > 0 ? from - 1 : 0;
            const previousNode = tr.doc.nodeAt(previousNodePos);
            if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {
                    newType: appearance,
                    previousType: (0, (0, parcelRequire("89B6e")).appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
            (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE
            });
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        };
    const $2c36f52f15a584d8$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
        switch(appearance){
            case 'inline':
                return linkNodes.inlineCard;
            case 'block':
                return linkNodes.blockCard;
            case 'embed':
                return linkNodes.embedCard;
        }
    };
    const $2c36f52f15a584d8$export$113cdaf1b279f308 = (args)=>{
        const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
        const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
        if (newAdf.type === 'blockCard') {
            if (node.attrs?.datasource && newAdf.attrs?.datasource) {
                const newAttrs = newAdf.attrs;
                const oldAttrs = node.attrs;
                const [newViews] = newAttrs.datasource.views ?? [];
                const [oldViews] = oldAttrs.datasource.views ?? [];
                const isColumnChange = !(0, ($parcel$interopDefault($ajpes)))(oldViews?.properties?.columns, newViews?.properties?.columns);
                const isUrlChange = newAttrs.url !== oldAttrs.url;
                if (isColumnChange || isUrlChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                    ...oldAttrs,
                    ...newAdf.attrs
                });
            } else if (node.type.isText) {
                let link;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                    if (linkMark) {
                        link = {
                            url: linkMark.attrs.href,
                            text: node.text,
                            pos: pos
                        };
                        return false;
                    }
                    return true;
                });
                if (link) {
                    const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                    tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                        newNode
                    ]);
                }
            } else tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
        } else if (newAdf.type === 'inlineCard') tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
        (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED,
            sourceEvent: sourceEvent,
            inputMethod: inputMethod
        });
        if (isDeletingConfig) {
            if (typeof node.attrs.url === 'string') (0, (0, parcelRequire("nYpqR")).removeDatasourceStash)(tr, node.attrs.url);
        } else (0, (0, parcelRequire("nYpqR")).hideDatasourceModal)(tr);
        view.dispatch(tr.scrollIntoView());
    };
    const $2c36f52f15a584d8$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
        const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
        const { attrs: attrs, type: type } = adf;
        const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
        const newNode = schemaNode.createChecked(attrs);
        newNode && tr.insert(from, newNode);
        (0, (0, parcelRequire("nYpqR")).hideDatasourceModal)(tr);
        (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
            sourceEvent: sourceEvent
        });
        view.dispatch(tr.scrollIntoView());
    };
    const $2c36f52f15a584d8$export$85bb3e53350e35b8 = (appearance, selectedNode)=>{
        if (appearance === 'embed') return {
            ...selectedNode.attrs,
            layout: 'center'
        };
        if ((0, (0, parcelRequire("89B6e")).isDatasourceNode)(selectedNode)) return {
            url: selectedNode.attrs.url
        };
        return selectedNode.attrs;
    };
    const $2c36f52f15a584d8$var$updateDatasourceStash = (tr, selectedNode)=>{
        if ((0, (0, parcelRequire("89B6e")).isDatasourceNode)(selectedNode) && !(0, (0, parcelRequire("89B6e")).isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, (0, parcelRequire("nYpqR")).setDatasourceStash)(tr, {
            url: selectedNode.attrs.url,
            views: selectedNode.attrs.datasource.views
        });
    };
});
parcelRegister("cPN3o", function(module, exports) {
    $parcel$export(module.exports, "LAYOUT_TYPE", ()=>$576fe822cbc87df1$export$9710eda883ce7be2);
    $parcel$export(module.exports, "SMART_LINK_TYPE", ()=>$576fe822cbc87df1$export$804a928ffc86c02c);
    var $576fe822cbc87df1$export$9710eda883ce7be2;
    (function(LAYOUT_TYPE) {
        LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
        LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
        LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
        LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
        LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
        LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
        LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
        LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    })($576fe822cbc87df1$export$9710eda883ce7be2 || ($576fe822cbc87df1$export$9710eda883ce7be2 = {}));
    var $576fe822cbc87df1$export$804a928ffc86c02c;
    (function(SMART_LINK_TYPE) {
        SMART_LINK_TYPE["INLINE_CARD"] = "inline";
        SMART_LINK_TYPE["BLOCK_CARD"] = "block";
        SMART_LINK_TYPE["URL"] = "url";
    })($576fe822cbc87df1$export$804a928ffc86c02c || ($576fe822cbc87df1$export$804a928ffc86c02c = {}));
});
parcelRegister("2iyV6", function(module, exports) {
    $parcel$export(module.exports, "buildEditLinkPayload", ()=>$d81ce512c6a47a5f$export$7f3c24765adf61f0);
    $parcel$export(module.exports, "buildVisitedLinkPayload", ()=>$d81ce512c6a47a5f$export$e81ec2390acfc152);
    $parcel$export(module.exports, "buildOpenedSettingsPayload", ()=>$d81ce512c6a47a5f$export$96aa8ae974c8591a);
    $parcel$export(module.exports, "unlinkPayload", ()=>$d81ce512c6a47a5f$export$aab75a08bdd88be4);
    var $gkwXh;
    const $d81ce512c6a47a5f$export$7f3c24765adf61f0 = (type)=>{
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
            actionSubject: type === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK ? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).HYPERLINK : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EDIT_LINK,
            attributes: type !== (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK ? {
                display: type
            } : {},
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
        };
    };
    const $d81ce512c6a47a5f$var$mapLinkTypeToCardAppearance = (type)=>{
        switch(type){
            case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).CARD_INLINE:
                return 'inline';
            case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).CARD_BLOCK:
                return 'block';
            case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EMBEDS:
                return 'embed';
            default:
                return 'url';
        }
    };
    const $d81ce512c6a47a5f$export$e81ec2390acfc152 = (type)=>{
        return type === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK ? {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).VISITED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).HYPERLINK,
            actionSubjectId: undefined,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        } : {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).VISITED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
    };
    const $d81ce512c6a47a5f$export$96aa8ae974c8591a = (type)=>{
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).GOTO_SMART_LINK_SETTINGS,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR,
                display: $d81ce512c6a47a5f$var$mapLinkTypeToCardAppearance(type)
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
        };
    };
    const $d81ce512c6a47a5f$export$aab75a08bdd88be4 = (type)=>{
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK,
            actionSubject: type === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK ? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).HYPERLINK : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type === (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK ? undefined : type,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
    };
});
parcelRegister("1ZWXY", function(module, exports) {
    $parcel$export(module.exports, "addLinkMetadata", ()=>$2c279959aed73c3c$export$e2d4855dca88ecc1);
    $parcel$export(module.exports, "getLinkMetadataFromTransaction", ()=>$2c279959aed73c3c$export$3aba02526a1e2e78);
    $parcel$export(module.exports, "commandWithMetadata", ()=>$2c279959aed73c3c$export$76125a95b70625ac);
    var $f5LPn;
    function $2c279959aed73c3c$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(initialSelection.$from.pos);
        tr.step(new (0, (0, parcelRequire("f5LPn")).LinkMetaStep)(pos, metadata));
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return tr;
    }
    function $2c279959aed73c3c$export$3aba02526a1e2e78(tr) {
        return tr.steps.reduce((metadata, step)=>{
            if (!(step instanceof (0, (0, parcelRequire("f5LPn")).LinkMetaStep))) return metadata;
            return {
                ...metadata,
                ...step.getMetadata()
            };
        }, {});
    }
    const $2c279959aed73c3c$export$76125a95b70625ac = (command, metadata)=>{
        return (state, dispatch, view)=>{
            if (!dispatch) return command(state, dispatch, view);
            return command(state, (tr)=>{
                $2c279959aed73c3c$export$e2d4855dca88ecc1(state.selection, tr, metadata);
                dispatch(tr);
            }, view);
        };
    };
});
parcelRegister("f5LPn", function(module, exports) {
    $parcel$export(module.exports, "LinkMetaStep", ()=>$afcc6c37d74355ec$export$40e33c9d27895078);
    var $kCV8T;
    var $eS2Dn;
    const $afcc6c37d74355ec$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
    const $afcc6c37d74355ec$export$2774298c489a128f = 'editor-linking-meta-invert';
    class $afcc6c37d74355ec$export$40e33c9d27895078 extends (0, (0, parcelRequire("eS2Dn")).Step) {
        constructor(pos, metadata, isInverted = false){
            super();
            this.pos = pos;
            this.metadata = metadata;
            this.isInverted = isInverted;
        }
        getMetadata() {
            return this.metadata;
        }
        invert() {
            const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
            return new $afcc6c37d74355ec$export$40e33c9d27895078(this.pos, metadata, true);
        }
        apply(doc) {
            return (0, (0, parcelRequire("eS2Dn")).StepResult).ok(doc);
        }
        map(mapping) {
            let newPos = this.pos;
            if (typeof newPos === 'number') newPos = mapping.map(newPos);
            return new $afcc6c37d74355ec$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
        }
        getMap() {
            return new (0, (0, parcelRequire("eS2Dn")).StepMap)([
                this.pos || 0,
                0,
                0
            ]);
        }
        merge() {
            return null;
        }
        toJSON() {
            return {
                stepType: 'replace',
                from: 0,
                to: 0
            };
        }
        static fromJSON() {
            return new (0, (0, parcelRequire("eS2Dn")).ReplaceStep)(0, 0, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
    }
    (0, (0, parcelRequire("eS2Dn")).Step).jsonID($afcc6c37d74355ec$export$954e3f6aa93d9ba3, $afcc6c37d74355ec$export$40e33c9d27895078);
});
parcelRegister("dPSMN", function(module, exports) {
    $parcel$export(module.exports, "LinkMatcher", ()=>$c71efdd24f85e7a0$export$4490385c12bf3d4);
    $parcel$export(module.exports, "normalizeUrl", ()=>$c71efdd24f85e7a0$export$6535eb414fa2c8b6);
    $parcel$export(module.exports, "linkifyContent", ()=>$c71efdd24f85e7a0$export$5a511fa58fab15e6);
    $parcel$export(module.exports, "findFilepaths", ()=>$c71efdd24f85e7a0$export$d37783fe63e2f0fe);
    $parcel$export(module.exports, "isLinkInMatches", ()=>$c71efdd24f85e7a0$export$5e652e74655163e5);
    $parcel$export(module.exports, "getLinkDomain", ()=>$c71efdd24f85e7a0$export$238a6141b3685c21);
    $parcel$export(module.exports, "isFromCurrentDomain", ()=>$c71efdd24f85e7a0$export$336c6a47b1dfa1bc);
    $parcel$export(module.exports, "getLinkCreationAnalyticsEvent", ()=>$c71efdd24f85e7a0$export$56039faad4eda709);
    $parcel$export(module.exports, "canLinkBeCreatedInRange", ()=>$c71efdd24f85e7a0$export$b7392a423e62dc8c);
    var $iZOJ9;
    var $gkwXh;
    var $gOwky;
    var $7vpuQ;
    const $c71efdd24f85e7a0$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
    const $c71efdd24f85e7a0$export$dabcc234035f6703 = /^(\$|{)/;
    class $c71efdd24f85e7a0$export$4490385c12bf3d4 {
        static create() {
            class LinkMatcherRegex {
                exec(str) {
                    const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                    const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                    const isLastStringValid = lastStringBeforeSpace.length > 0;
                    if (!str.endsWith(' ') || !isLastStringValid) return null;
                    if ($c71efdd24f85e7a0$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                    const links = (0, (0, parcelRequire("iZOJ9")).linkify).match(lastStringBeforeSpace);
                    if (!links || links.length === 0) return null;
                    const lastMatch = links[links.length - 1];
                    const lastLink = links[links.length - 1];
                    lastLink.input = str.substring(lastMatch.index);
                    lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                    lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                    return lastLink;
                }
            }
            return new LinkMatcherRegex();
        }
    }
    function $c71efdd24f85e7a0$export$6535eb414fa2c8b6(url) {
        if (!url) return '';
        if ((0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return url;
        return (0, (0, parcelRequire("iZOJ9")).normalizeUrl)(url);
    }
    function $c71efdd24f85e7a0$export$5a511fa58fab15e6(schema) {
        return (slice)=>(0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node, parent)=>{
                const isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
                const link = node.type.schema.marks.link;
                if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
                if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                    const linkified = [];
                    const text = node.text;
                    const matches = $c71efdd24f85e7a0$var$findLinkMatches(text).filter((0, (0, parcelRequire("gOwky")).shouldAutoLinkifyMatch));
                    let pos = 0;
                    const filepaths = $c71efdd24f85e7a0$export$d37783fe63e2f0fe(text);
                    matches.forEach((match)=>{
                        if ($c71efdd24f85e7a0$export$5e652e74655163e5(match.index, filepaths)) return;
                        if (match.index > 0) linkified.push(node.cut(pos, match.index));
                        linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                            href: $c71efdd24f85e7a0$export$6535eb414fa2c8b6(match.url)
                        }).addToSet(node.marks)));
                        pos = match.lastIndex;
                    });
                    if (pos < text.length) linkified.push(node.cut(pos));
                    return linkified;
                }
                return node;
            });
    }
    function $c71efdd24f85e7a0$export$238a6141b3685c21(url) {
        const withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
        const withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
        return withoutWWW.replace(/[:\/?#](.*)$/, '');
    }
    function $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url) {
        if (!window || !window.location) return false;
        const currentDomain = window.location.hostname;
        const linkDomain = $c71efdd24f85e7a0$export$238a6141b3685c21(url);
        return currentDomain === linkDomain;
    }
    function $c71efdd24f85e7a0$var$findLinkMatches(text) {
        if (text === '') return [];
        return (0, (0, parcelRequire("iZOJ9")).linkify).match(text) || [];
    }
    const $c71efdd24f85e7a0$export$d37783fe63e2f0fe = (text, offset = 0)=>{
        const localRegExp = new RegExp($c71efdd24f85e7a0$export$893fccbed37586dd);
        let match;
        const matchesList = [];
        const maxFilepathSize = 260;
        while((match = localRegExp.exec(text)) !== null){
            const start = match.index + offset;
            let end = localRegExp.lastIndex + offset;
            if (end - start > maxFilepathSize) end = start + maxFilepathSize;
            matchesList.push({
                startIndex: start,
                endIndex: end
            });
        }
        return matchesList;
    };
    const $c71efdd24f85e7a0$export$5e652e74655163e5 = (linkStart, matchesList)=>{
        for(let i = 0; i < matchesList.length; i++){
            if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
        }
        return false;
    };
    function $c71efdd24f85e7a0$export$56039faad4eda709(inputMethod, url) {
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).LINK,
            attributes: {
                inputMethod: inputMethod,
                fromCurrentDomain: $c71efdd24f85e7a0$export$336c6a47b1dfa1bc(url)
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            nonPrivacySafeAttributes: {
                linkDomain: $c71efdd24f85e7a0$export$238a6141b3685c21(url)
            }
        };
    }
    const $c71efdd24f85e7a0$export$b7392a423e62dc8c = (from, to)=>(state)=>{
            if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
                const $from = state.doc.resolve(from);
                const $to = state.doc.resolve(to);
                const link = state.schema.marks.link;
                if ($from.parent === $to.parent && $from.parent.isTextblock) {
                    if ($from.parent.type.allowsMarkType(link)) {
                        let allowed = true;
                        state.doc.nodesBetween(from, to, (node)=>{
                            allowed = allowed && !node.marks.some((m)=>m.type.excludes(link));
                            return allowed;
                        });
                        return allowed;
                    }
                }
            }
            return false;
        };
});
parcelRegister("gOwky", function(module, exports) {
    $parcel$export(module.exports, "shouldAutoLinkifyMatch", ()=>$a8453eeff8b41d2c$export$e19a09e301eaa6bb);
    const $a8453eeff8b41d2c$var$tldsToNotAutoLinkify = [
        'name',
        'zip',
        'doc',
        'mov',
        'md',
        'ps',
        'cc',
        'cs',
        'fs',
        'go',
        'js',
        'pl',
        'pm',
        'py',
        'rb',
        'rs',
        'sh',
        'ts',
        'cs',
        'vb'
    ];
    function $a8453eeff8b41d2c$export$977fe75b90bdd614(url) {
        const startsWithHttpHttps = /^https?:\/\//.test(url);
        if (startsWithHttpHttps) return true;
        const startsWithWWW = /^www\./.test(url);
        if (startsWithWWW) return true;
        try {
            const hostname = new URL(`https://${url}`).hostname;
            const parts = hostname.split('.');
            const tld = parts.length > 1 ? parts[parts.length - 1] : null;
            if (parts[0] === '') return true;
            if (!tld) return true;
            return !$a8453eeff8b41d2c$var$tldsToNotAutoLinkify.includes(tld);
        } catch (e) {
            return true;
        }
    }
    function $a8453eeff8b41d2c$export$e19a09e301eaa6bb(match) {
        return $a8453eeff8b41d2c$export$977fe75b90bdd614(match.raw);
    }
});
parcelRegister("7vpuQ", function(module, exports) {
    $parcel$export(module.exports, "getFragmentBackingArray", ()=>$cd200aea723473fd$export$7b8536c35e9eb7d2);
    $parcel$export(module.exports, "mapFragment", ()=>$cd200aea723473fd$export$81fe6b3b714fd0bf);
    $parcel$export(module.exports, "mapSlice", ()=>$cd200aea723473fd$export$d8264570c5933bbf);
    $parcel$export(module.exports, "flatmap", ()=>$cd200aea723473fd$export$c575791007f9dbd1);
    $parcel$export(module.exports, "mapChildren", ()=>$cd200aea723473fd$export$e0baa27f47733a4a);
    var $kCV8T;
    function $cd200aea723473fd$export$7b8536c35e9eb7d2(fragment) {
        return fragment.content;
    }
    function $cd200aea723473fd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
        const children = [];
        for(let i = 0, size = content.childCount; i < size; i++){
            const node = content.child(i);
            const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($cd200aea723473fd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
            if (transformed) {
                if (transformed instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) children.push(...$cd200aea723473fd$export$7b8536c35e9eb7d2(transformed));
                else if (Array.isArray(transformed)) children.push(...transformed);
                else children.push(transformed);
            }
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children);
    }
    function $cd200aea723473fd$export$d8264570c5933bbf(slice, callback) {
        const fragment = $cd200aea723473fd$export$81fe6b3b714fd0bf(slice.content, callback);
        return new (0, (0, parcelRequire("kCV8T")).Slice)(fragment, slice.openStart, slice.openEnd);
    }
    function $cd200aea723473fd$export$c575791007f9dbd1(fragment, callback) {
        const fragmentContent = [];
        for(let i = 0; i < fragment.childCount; i++){
            const child = callback(fragment.child(i), i, fragment);
            if (Array.isArray(child)) fragmentContent.push(...child);
            else fragmentContent.push(child);
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(fragmentContent);
    }
    function $cd200aea723473fd$export$e0baa27f47733a4a(node, callback) {
        const array = [];
        for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, (0, parcelRequire("kCV8T")).Fragment) ? node : node.content));
        return array;
    }
});
parcelRegister("89B6e", function(module, exports) {
    $parcel$export(module.exports, "appearanceForNodeType", ()=>$7ba6143c9ae250e1$export$71376de76fa352d1);
    $parcel$export(module.exports, "selectedCardAppearance", ()=>$7ba6143c9ae250e1$export$a5ff7aecd33e6813);
    $parcel$export(module.exports, "titleUrlPairFromNode", ()=>$7ba6143c9ae250e1$export$15bc29504ff06986);
    $parcel$export(module.exports, "displayInfoForCard", ()=>$7ba6143c9ae250e1$export$a6fcef6250c64f76);
    $parcel$export(module.exports, "findCardInfo", ()=>$7ba6143c9ae250e1$export$f3f2332ef0853029);
    $parcel$export(module.exports, "isEmbedSupportedAtPosition", ()=>$7ba6143c9ae250e1$export$b31d21baab1bb9f);
    $parcel$export(module.exports, "isBlockSupportedAtPosition", ()=>$7ba6143c9ae250e1$export$290208dc31723a19);
    $parcel$export(module.exports, "getResolvedAttributesFromStore", ()=>$7ba6143c9ae250e1$export$a0e5429851d8d8a9);
    $parcel$export(module.exports, "isDatasourceConfigEditable", ()=>$7ba6143c9ae250e1$export$c677d64dd26b7aa2);
    $parcel$export(module.exports, "isDatasourceNode", ()=>$7ba6143c9ae250e1$export$962cfe99b8da8614);
    $parcel$export(module.exports, "focusEditorView", ()=>$7ba6143c9ae250e1$export$bab6ff782a349bd3);
    $parcel$export(module.exports, "getAwarenessProps", ()=>$7ba6143c9ae250e1$export$ea8b03e32bcc0b2d);
    var $kCV8T;
    var $gZGBX;
    var $ffYTp;
    var $lX6w0;
    var $f980L;
    var $7mvwv;
    var $lumM0;
    const $7ba6143c9ae250e1$export$71376de76fa352d1 = (spec)=>{
        if (spec.name === 'inlineCard') return 'inline';
        else if (spec.name === 'blockCard') return 'block';
        else if (spec.name === 'embedCard') return 'embed';
        return;
    };
    const $7ba6143c9ae250e1$export$a5ff7aecd33e6813 = (state)=>{
        if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return $7ba6143c9ae250e1$export$71376de76fa352d1(state.selection.node.type);
    };
    const $7ba6143c9ae250e1$export$15bc29504ff06986 = (node)=>{
        const { attrs: attrs } = node;
        return {
            url: attrs.url || attrs.data && attrs.data.url,
            title: attrs.data && attrs.data.title
        };
    };
    const $7ba6143c9ae250e1$export$fe497395c317d106 = (titleUrlPair, info)=>{
        return {
            title: info && info.title || titleUrlPair.title,
            url: info && info.url || titleUrlPair.url
        };
    };
    const $7ba6143c9ae250e1$export$a6fcef6250c64f76 = (node, info)=>$7ba6143c9ae250e1$export$fe497395c317d106($7ba6143c9ae250e1$export$15bc29504ff06986(node), info);
    const $7ba6143c9ae250e1$export$f3f2332ef0853029 = (state)=>{
        const pluginState = (0, (0, parcelRequire("lumM0")).pluginKey).getState(state);
        if (!pluginState) return undefined;
        return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
    };
    const $7ba6143c9ae250e1$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
        const resolvedPosition = editorState.doc.resolve(currentNodePosition);
        const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
        return parent && parent.type.validContent(fragment);
    };
    const $7ba6143c9ae250e1$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$7ba6143c9ae250e1$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, (0, parcelRequire("kCV8T")).Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
    const $7ba6143c9ae250e1$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$7ba6143c9ae250e1$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, (0, parcelRequire("kCV8T")).Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
    const $7ba6143c9ae250e1$export$a0e5429851d8d8a9 = (url, display, store)=>{
        if (!store) return {};
        const urlState = store?.getState()[url];
        const displayCategory = display === 'url' ? 'link' : undefined;
        return (0, (0, parcelRequire("ffYTp")).getResolvedAttributes)({
            url: url,
            displayCategory: displayCategory
        }, urlState?.details);
    };
    const $7ba6143c9ae250e1$export$c677d64dd26b7aa2 = (datasourceId)=>{
        const datasourcesWithConfigModal = [
            (0, (0, parcelRequire("7mvwv")).JIRA_LIST_OF_LINKS_DATASOURCE_ID),
            (0, (0, parcelRequire("lX6w0")).ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
            (0, (0, parcelRequire("f980L")).CONFLUENCE_SEARCH_DATASOURCE_ID)
        ];
        return datasourcesWithConfigModal.includes(datasourceId);
    };
    const $7ba6143c9ae250e1$export$48ba7bd006cffb5e = (attrs)=>{
        if (!(typeof attrs === 'object' && attrs !== null)) return false;
        if (!('datasource' in attrs)) return false;
        if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
        const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
        const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
        const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
        return hasId && hasParameters && hasViews;
    };
    const $7ba6143c9ae250e1$export$962cfe99b8da8614 = (node)=>{
        if (!node) return false;
        return node.type.name === 'blockCard' && $7ba6143c9ae250e1$export$48ba7bd006cffb5e(node.attrs);
    };
    const $7ba6143c9ae250e1$export$bab6ff782a349bd3 = (editorView)=>{
        if (!editorView.hasFocus()) editorView.focus();
    };
    const $7ba6143c9ae250e1$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
        const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
        const linkPosition = getPosFunction?.();
        const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $7ba6143c9ae250e1$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
        const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $7ba6143c9ae250e1$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
        const isSelected = editorState.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && editorState.selection?.node?.type === editorState.schema.nodes.inlineCard && editorState.selection?.from === getPosFunction?.();
        return {
            isPulseEnabled: canBeUpgradedToEmbed,
            isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
            isSelected: isSelected
        };
    };
});
parcelRegister("ffYTp", function(module, exports) {
    $parcel$export(module.exports, "getResolvedAttributes", ()=>$842bbc6d3f3b5d59$export$7243431f5325a7b);
    var $fiKQs;
    var $iHcpV;
    const $842bbc6d3f3b5d59$export$7243431f5325a7b = (linkDetails, details, linkStatus)=>{
        const status = linkStatus ?? (details && (0, (0, parcelRequire("fiKQs")).getStatus)(details));
        const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, (0, parcelRequire("iHcpV")).getDisplayCategory)(status);
        return {
            status: status ?? null,
            statusDetails: details?.meta?.requestAccess?.accessType ?? null,
            displayCategory: displayCategory,
            extensionKey: details?.meta?.key ?? null,
            destinationTenantId: details?.meta?.tenantId ?? null,
            destinationContainerId: details?.meta?.containerId ?? null,
            destinationCategory: details?.meta?.category ?? null,
            destinationProduct: details?.meta?.product ?? null,
            destinationSubproduct: details?.meta?.subproduct ?? null,
            destinationObjectId: details?.meta?.objectId ?? null,
            destinationObjectType: details?.meta?.resourceType ?? null,
            canBeDatasource: (details?.datasources || []).length > 0
        };
    };
});
parcelRegister("iHcpV", function(module, exports) {
    $parcel$export(module.exports, "getDisplayCategory", ()=>$1a9daeca9ad503b7$export$28ddbae335bd80b5);
    const $1a9daeca9ad503b7$export$28ddbae335bd80b5 = (status)=>{
        return !status || status !== 'not_found' ? 'smartLink' : 'link';
    };
});
parcelRegister("1CO6U", function(module, exports) {
    $parcel$export(module.exports, "shouldReplaceLink", ()=>$d30737d2ce17b865$export$f85e921f66e987fa);
    var $iZOJ9;
    var $1M84d;
    function $d30737d2ce17b865$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (!linkMark) return false;
        const normalisedHref = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)((0, (0, parcelRequire("1M84d")).md).normalizeLinkText(linkMark.attrs.href));
        const normalizedLinkText = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)((0, (0, parcelRequire("1M84d")).md).normalizeLinkText(node.text || ''));
        if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
        if (compareToUrl) {
            const normalizedUrl = (0, (0, parcelRequire("iZOJ9")).normalizeUrl)((0, (0, parcelRequire("1M84d")).md).normalizeLinkText(compareToUrl));
            if (normalizedUrl !== normalisedHref) return false;
        }
        return true;
    }
});
parcelRegister("1M84d", function(module, exports) {
    $parcel$export(module.exports, "md", ()=>$76c5a60e1fbb7648$export$f4de1c043ce6927);
    var $ivSSX = parcelRequire("ivSSX");
    var $h4jau;
    var $2Suqb;
    var $3KuZM;
    var $igwks;
    const $76c5a60e1fbb7648$export$f4de1c043ce6927 = (0, ($parcel$interopDefault($ivSSX)))('zero', {
        html: false
    });
    $76c5a60e1fbb7648$export$f4de1c043ce6927.enable([
        'entity',
        'escape',
        'newline'
    ]);
    $76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, (0, parcelRequire("igwks")).default));
    $76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, (0, parcelRequire("2Suqb")).default));
    $76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, (0, parcelRequire("3KuZM")).default));
    $76c5a60e1fbb7648$export$f4de1c043ce6927.use((0, (0, parcelRequire("h4jau")).default));
});
parcelRegister("ivSSX", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("7fjdG"));
});
parcelRegister("7fjdG", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $1mGdb = parcelRequire("1mGdb");
    var $keGIi = parcelRequire("keGIi");
    var $aVlnc = parcelRequire("aVlnc");
    var $81Ci5 = parcelRequire("81Ci5");
    var $58y21 = parcelRequire("58y21");
    var $43kHv = parcelRequire("43kHv");
    var $aK6mt = parcelRequire("aK6mt");
    var $8F4WT = parcelRequire("8F4WT");
    var $5468d7bb65d238e2$var$config = {
        default: (parcelRequire("gcpUf")),
        zero: (parcelRequire("hbvGf")),
        commonmark: (parcelRequire("8Ubo6"))
    };
    var $5468d7bb65d238e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
    var $5468d7bb65d238e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
    function $5468d7bb65d238e2$var$validateLink(url) {
        var str = url.trim().toLowerCase();
        return $5468d7bb65d238e2$var$BAD_PROTO_RE.test(str) ? $5468d7bb65d238e2$var$GOOD_DATA_RE.test(str) ? true : false : true;
    }
    var $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR = [
        'http:',
        'https:',
        'mailto:'
    ];
    function $5468d7bb65d238e2$var$normalizeLink(url) {
        var parsed = $aK6mt.parse(url, true);
        if (parsed.hostname) {
            if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
                parsed.hostname = $8F4WT.toASCII(parsed.hostname);
            } catch (er) {}
        }
        return $aK6mt.encode($aK6mt.format(parsed));
    }
    function $5468d7bb65d238e2$var$normalizeLinkText(url) {
        var parsed = $aK6mt.parse(url, true);
        if (parsed.hostname) {
            if (!parsed.protocol || $5468d7bb65d238e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
                parsed.hostname = $8F4WT.toUnicode(parsed.hostname);
            } catch (er) {}
        }
        return $aK6mt.decode($aK6mt.format(parsed), $aK6mt.decode.defaultChars + '%');
    }
    function $5468d7bb65d238e2$var$MarkdownIt(presetName, options) {
        if (!(this instanceof $5468d7bb65d238e2$var$MarkdownIt)) return new $5468d7bb65d238e2$var$MarkdownIt(presetName, options);
        if (!options) {
            if (!$lKlAe.isString(presetName)) {
                options = presetName || {};
                presetName = 'default';
            }
        }
        this.inline = new $58y21();
        this.block = new $81Ci5();
        this.core = new $aVlnc();
        this.renderer = new $keGIi();
        this.linkify = new $43kHv();
        this.validateLink = $5468d7bb65d238e2$var$validateLink;
        this.normalizeLink = $5468d7bb65d238e2$var$normalizeLink;
        this.normalizeLinkText = $5468d7bb65d238e2$var$normalizeLinkText;
        this.utils = $lKlAe;
        this.helpers = $lKlAe.assign({}, $1mGdb);
        this.options = {};
        this.configure(presetName);
        if (options) this.set(options);
    }
    $5468d7bb65d238e2$var$MarkdownIt.prototype.set = function(options) {
        $lKlAe.assign(this.options, options);
        return this;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.configure = function(presets) {
        var self = this, presetName;
        if ($lKlAe.isString(presets)) {
            presetName = presets;
            presets = $5468d7bb65d238e2$var$config[presetName];
            if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
        }
        if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
        if (presets.options) self.set(presets.options);
        if (presets.components) Object.keys(presets.components).forEach(function(name) {
            if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
            if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
        });
        return this;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
        var result = [];
        if (!Array.isArray(list)) list = [
            list
        ];
        [
            'core',
            'block',
            'inline'
        ].forEach(function(chain) {
            result = result.concat(this[chain].ruler.enable(list, true));
        }, this);
        result = result.concat(this.inline.ruler2.enable(list, true));
        var missed = list.filter(function(name) {
            return result.indexOf(name) < 0;
        });
        if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
        return this;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
        var result = [];
        if (!Array.isArray(list)) list = [
            list
        ];
        [
            'core',
            'block',
            'inline'
        ].forEach(function(chain) {
            result = result.concat(this[chain].ruler.disable(list, true));
        }, this);
        result = result.concat(this.inline.ruler2.disable(list, true));
        var missed = list.filter(function(name) {
            return result.indexOf(name) < 0;
        });
        if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
        return this;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.use = function(plugin) {
        var args = [
            this
        ].concat(Array.prototype.slice.call(arguments, 1));
        plugin.apply(plugin, args);
        return this;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.parse = function(src, env) {
        if (typeof src !== 'string') throw new Error('Input data should be a String');
        var state = new this.core.State(src, this, env);
        this.core.process(state);
        return state.tokens;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.render = function(src, env) {
        env = env || {};
        return this.renderer.render(this.parse(src, env), this.options, env);
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
        var state = new this.core.State(src, this, env);
        state.inlineMode = true;
        this.core.process(state);
        return state.tokens;
    };
    $5468d7bb65d238e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
        env = env || {};
        return this.renderer.render(this.parseInline(src, env), this.options, env);
    };
    module.exports = $5468d7bb65d238e2$var$MarkdownIt;
});
parcelRegister("lKlAe", function(module, exports) {
    $parcel$export(module.exports, "lib", ()=>$fd4ea2dc11e83b2a$export$16c08b91f883959a, (v)=>$fd4ea2dc11e83b2a$export$16c08b91f883959a = v);
    $parcel$export(module.exports, "assign", ()=>$fd4ea2dc11e83b2a$export$e6e34fd1f2686227, (v)=>$fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = v);
    $parcel$export(module.exports, "isString", ()=>$fd4ea2dc11e83b2a$export$844ec244b1367d54, (v)=>$fd4ea2dc11e83b2a$export$844ec244b1367d54 = v);
    $parcel$export(module.exports, "has", ()=>$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5, (v)=>$fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = v);
    $parcel$export(module.exports, "unescapeMd", ()=>$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03, (v)=>$fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = v);
    $parcel$export(module.exports, "unescapeAll", ()=>$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c, (v)=>$fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = v);
    $parcel$export(module.exports, "isValidEntityCode", ()=>$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d, (v)=>$fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = v);
    $parcel$export(module.exports, "fromCodePoint", ()=>$fd4ea2dc11e83b2a$export$73bfc63873071f74, (v)=>$fd4ea2dc11e83b2a$export$73bfc63873071f74 = v);
    $parcel$export(module.exports, "escapeHtml", ()=>$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8, (v)=>$fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = v);
    $parcel$export(module.exports, "arrayReplaceAt", ()=>$fd4ea2dc11e83b2a$export$f78478f71955b6bc, (v)=>$fd4ea2dc11e83b2a$export$f78478f71955b6bc = v);
    $parcel$export(module.exports, "isSpace", ()=>$fd4ea2dc11e83b2a$export$1d5ccafae59b4926, (v)=>$fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = v);
    $parcel$export(module.exports, "isWhiteSpace", ()=>$fd4ea2dc11e83b2a$export$3c52dd84024ae72c, (v)=>$fd4ea2dc11e83b2a$export$3c52dd84024ae72c = v);
    $parcel$export(module.exports, "isMdAsciiPunct", ()=>$fd4ea2dc11e83b2a$export$829a0d33ae4e744, (v)=>$fd4ea2dc11e83b2a$export$829a0d33ae4e744 = v);
    $parcel$export(module.exports, "isPunctChar", ()=>$fd4ea2dc11e83b2a$export$4888a643af800fc1, (v)=>$fd4ea2dc11e83b2a$export$4888a643af800fc1 = v);
    $parcel$export(module.exports, "escapeRE", ()=>$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d, (v)=>$fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = v);
    $parcel$export(module.exports, "normalizeReference", ()=>$fd4ea2dc11e83b2a$export$20ef46802c8744b, (v)=>$fd4ea2dc11e83b2a$export$20ef46802c8744b = v);
    var $fd4ea2dc11e83b2a$export$16c08b91f883959a;
    var $fd4ea2dc11e83b2a$export$e6e34fd1f2686227;
    var $fd4ea2dc11e83b2a$export$844ec244b1367d54;
    var $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5;
    var $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03;
    var $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c;
    var $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d;
    var $fd4ea2dc11e83b2a$export$73bfc63873071f74;
    var $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8;
    var $fd4ea2dc11e83b2a$export$f78478f71955b6bc;
    var $fd4ea2dc11e83b2a$export$1d5ccafae59b4926;
    var $fd4ea2dc11e83b2a$export$3c52dd84024ae72c;
    var $fd4ea2dc11e83b2a$export$829a0d33ae4e744;
    var $fd4ea2dc11e83b2a$export$4888a643af800fc1;
    var $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d;
    var $fd4ea2dc11e83b2a$export$20ef46802c8744b;
    'use strict';
    function $fd4ea2dc11e83b2a$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $fd4ea2dc11e83b2a$var$isString(obj) {
        return $fd4ea2dc11e83b2a$var$_class(obj) === '[object String]';
    }
    var $fd4ea2dc11e83b2a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
    function $fd4ea2dc11e83b2a$var$has(object, key) {
        return $fd4ea2dc11e83b2a$var$_hasOwnProperty.call(object, key);
    }
    function $fd4ea2dc11e83b2a$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            if (typeof source !== 'object') throw new TypeError(source + 'must be object');
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $fd4ea2dc11e83b2a$var$arrayReplaceAt(src, pos, newElements) {
        return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
    }
    function $fd4ea2dc11e83b2a$var$isValidEntityCode(c) {
        if (c >= 0xD800 && c <= 0xDFFF) return false;
        if (c >= 0xFDD0 && c <= 0xFDEF) return false;
        if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
        if (c >= 0x00 && c <= 0x08) return false;
        if (c === 0x0B) return false;
        if (c >= 0x0E && c <= 0x1F) return false;
        if (c >= 0x7F && c <= 0x9F) return false;
        if (c > 0x10FFFF) return false;
        return true;
    }
    function $fd4ea2dc11e83b2a$var$fromCodePoint(c) {
        if (c > 0xffff) {
            c -= 0x10000;
            var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        }
        return String.fromCharCode(c);
    }
    var $fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
    var $fd4ea2dc11e83b2a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
    var $fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE = new RegExp($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE.source + '|' + $fd4ea2dc11e83b2a$var$ENTITY_RE.source, 'gi');
    var $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
    var $7MxGI = parcelRequire("7MxGI");
    function $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, name) {
        var code;
        if ($fd4ea2dc11e83b2a$var$has($7MxGI, name)) return $7MxGI[name];
        if (name.charCodeAt(0) === 0x23 && $fd4ea2dc11e83b2a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
            code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
            if ($fd4ea2dc11e83b2a$var$isValidEntityCode(code)) return $fd4ea2dc11e83b2a$var$fromCodePoint(code);
        }
        return match;
    }
    function $fd4ea2dc11e83b2a$var$unescapeMd(str) {
        if (str.indexOf('\\') < 0) return str;
        return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_MD_RE, '$1');
    }
    function $fd4ea2dc11e83b2a$var$unescapeAll(str) {
        if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
        return str.replace($fd4ea2dc11e83b2a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
            if (escaped) return escaped;
            return $fd4ea2dc11e83b2a$var$replaceEntityPattern(match, entity);
        });
    }
    var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
    var $fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
    var $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;'
    };
    function $fd4ea2dc11e83b2a$var$replaceUnsafeChar(ch) {
        return $fd4ea2dc11e83b2a$var$HTML_REPLACEMENTS[ch];
    }
    function $fd4ea2dc11e83b2a$var$escapeHtml(str) {
        if ($fd4ea2dc11e83b2a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($fd4ea2dc11e83b2a$var$HTML_ESCAPE_REPLACE_RE, $fd4ea2dc11e83b2a$var$replaceUnsafeChar);
        return str;
    }
    var $fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
    function $fd4ea2dc11e83b2a$var$escapeRE(str) {
        return str.replace($fd4ea2dc11e83b2a$var$REGEXP_ESCAPE_RE, '\\$&');
    }
    function $fd4ea2dc11e83b2a$var$isSpace(code) {
        switch(code){
            case 0x09:
            case 0x20:
                return true;
        }
        return false;
    }
    function $fd4ea2dc11e83b2a$var$isWhiteSpace(code) {
        if (code >= 0x2000 && code <= 0x200A) return true;
        switch(code){
            case 0x09:
            case 0x0A:
            case 0x0B:
            case 0x0C:
            case 0x0D:
            case 0x20:
            case 0xA0:
            case 0x1680:
            case 0x202F:
            case 0x205F:
            case 0x3000:
                return true;
        }
        return false;
    }
    var $9bBmm = parcelRequire("9bBmm");
    function $fd4ea2dc11e83b2a$var$isPunctChar(ch) {
        return $9bBmm.test(ch);
    }
    function $fd4ea2dc11e83b2a$var$isMdAsciiPunct(ch) {
        switch(ch){
            case 0x21:
            case 0x22:
            case 0x23:
            case 0x24:
            case 0x25:
            case 0x26:
            case 0x27:
            case 0x28:
            case 0x29:
            case 0x2A:
            case 0x2B:
            case 0x2C:
            case 0x2D:
            case 0x2E:
            case 0x2F:
            case 0x3A:
            case 0x3B:
            case 0x3C:
            case 0x3D:
            case 0x3E:
            case 0x3F:
            case 0x40:
            case 0x5B:
            case 0x5C:
            case 0x5D:
            case 0x5E:
            case 0x5F:
            case 0x60:
            case 0x7B:
            case 0x7C:
            case 0x7D:
            case 0x7E:
                return true;
            default:
                return false;
        }
    }
    function $fd4ea2dc11e83b2a$var$normalizeReference(str) {
        str = str.trim().replace(/\s+/g, ' ');
        if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
        return str.toLowerCase().toUpperCase();
    }
    $fd4ea2dc11e83b2a$export$16c08b91f883959a = {};
    $fd4ea2dc11e83b2a$export$16c08b91f883959a.mdurl = (parcelRequire("aK6mt"));
    $fd4ea2dc11e83b2a$export$16c08b91f883959a.ucmicro = (parcelRequire("7G9dc"));
    $fd4ea2dc11e83b2a$export$e6e34fd1f2686227 = $fd4ea2dc11e83b2a$var$assign;
    $fd4ea2dc11e83b2a$export$844ec244b1367d54 = $fd4ea2dc11e83b2a$var$isString;
    $fd4ea2dc11e83b2a$export$a4f4bb6b1453fff5 = $fd4ea2dc11e83b2a$var$has;
    $fd4ea2dc11e83b2a$export$5ccde1ea0c14bb03 = $fd4ea2dc11e83b2a$var$unescapeMd;
    $fd4ea2dc11e83b2a$export$db8a17c6655f7e2c = $fd4ea2dc11e83b2a$var$unescapeAll;
    $fd4ea2dc11e83b2a$export$644a8f5b13b2a36d = $fd4ea2dc11e83b2a$var$isValidEntityCode;
    $fd4ea2dc11e83b2a$export$73bfc63873071f74 = $fd4ea2dc11e83b2a$var$fromCodePoint;
    $fd4ea2dc11e83b2a$export$4cf11838cdc2a8a8 = $fd4ea2dc11e83b2a$var$escapeHtml;
    $fd4ea2dc11e83b2a$export$f78478f71955b6bc = $fd4ea2dc11e83b2a$var$arrayReplaceAt;
    $fd4ea2dc11e83b2a$export$1d5ccafae59b4926 = $fd4ea2dc11e83b2a$var$isSpace;
    $fd4ea2dc11e83b2a$export$3c52dd84024ae72c = $fd4ea2dc11e83b2a$var$isWhiteSpace;
    $fd4ea2dc11e83b2a$export$829a0d33ae4e744 = $fd4ea2dc11e83b2a$var$isMdAsciiPunct;
    $fd4ea2dc11e83b2a$export$4888a643af800fc1 = $fd4ea2dc11e83b2a$var$isPunctChar;
    $fd4ea2dc11e83b2a$export$bc616c8f7dc20d5d = $fd4ea2dc11e83b2a$var$escapeRE;
    $fd4ea2dc11e83b2a$export$20ef46802c8744b = $fd4ea2dc11e83b2a$var$normalizeReference;
});
parcelRegister("7MxGI", function(module, exports) {
    'use strict';
    module.exports = (parcelRequire("9yTii"));
});
parcelRegister("9yTii", function(module, exports) {
    module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');
});
parcelRegister("aK6mt", function(module, exports) {
    $parcel$export(module.exports, "encode", ()=>$7d2322841b1ac049$export$c564cdbbe6da493, (v)=>$7d2322841b1ac049$export$c564cdbbe6da493 = v);
    $parcel$export(module.exports, "decode", ()=>$7d2322841b1ac049$export$2f872c0f2117be69, (v)=>$7d2322841b1ac049$export$2f872c0f2117be69 = v);
    $parcel$export(module.exports, "format", ()=>$7d2322841b1ac049$export$d9468344d3651243, (v)=>$7d2322841b1ac049$export$d9468344d3651243 = v);
    $parcel$export(module.exports, "parse", ()=>$7d2322841b1ac049$export$98e6a39c04603d36, (v)=>$7d2322841b1ac049$export$98e6a39c04603d36 = v);
    var $7d2322841b1ac049$export$c564cdbbe6da493;
    var $7d2322841b1ac049$export$2f872c0f2117be69;
    var $7d2322841b1ac049$export$d9468344d3651243;
    var $7d2322841b1ac049$export$98e6a39c04603d36;
    'use strict';
    $7d2322841b1ac049$export$c564cdbbe6da493 = (parcelRequire("6jTHo"));
    $7d2322841b1ac049$export$2f872c0f2117be69 = (parcelRequire("qpEB3"));
    $7d2322841b1ac049$export$d9468344d3651243 = (parcelRequire("3yKUv"));
    $7d2322841b1ac049$export$98e6a39c04603d36 = (parcelRequire("bQztL"));
});
parcelRegister("6jTHo", function(module, exports) {
    'use strict';
    var $499fb90cb213ebc3$var$encodeCache = {};
    function $499fb90cb213ebc3$var$getEncodeCache(exclude) {
        var i, ch, cache = $499fb90cb213ebc3$var$encodeCache[exclude];
        if (cache) return cache;
        cache = $499fb90cb213ebc3$var$encodeCache[exclude] = [];
        for(i = 0; i < 128; i++){
            ch = String.fromCharCode(i);
            if (/^[0-9a-z]$/i.test(ch)) cache.push(ch);
            else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
        }
        for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
        return cache;
    }
    function $499fb90cb213ebc3$var$encode(string, exclude, keepEscaped) {
        var i, l, code, nextCode, cache, result = '';
        if (typeof exclude !== 'string') {
            keepEscaped = exclude;
            exclude = $499fb90cb213ebc3$var$encode.defaultChars;
        }
        if (typeof keepEscaped === 'undefined') keepEscaped = true;
        cache = $499fb90cb213ebc3$var$getEncodeCache(exclude);
        for(i = 0, l = string.length; i < l; i++){
            code = string.charCodeAt(i);
            if (keepEscaped && code === 0x25 && i + 2 < l) {
                if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                    result += string.slice(i, i + 3);
                    i += 2;
                    continue;
                }
            }
            if (code < 128) {
                result += cache[code];
                continue;
            }
            if (code >= 0xD800 && code <= 0xDFFF) {
                if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                    nextCode = string.charCodeAt(i + 1);
                    if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                        result += encodeURIComponent(string[i] + string[i + 1]);
                        i++;
                        continue;
                    }
                }
                result += '%EF%BF%BD';
                continue;
            }
            result += encodeURIComponent(string[i]);
        }
        return result;
    }
    $499fb90cb213ebc3$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
    $499fb90cb213ebc3$var$encode.componentChars = "-_.!~*'()";
    module.exports = $499fb90cb213ebc3$var$encode;
});
parcelRegister("qpEB3", function(module, exports) {
    'use strict';
    var $04f654215177967d$var$decodeCache = {};
    function $04f654215177967d$var$getDecodeCache(exclude) {
        var i, ch, cache = $04f654215177967d$var$decodeCache[exclude];
        if (cache) return cache;
        cache = $04f654215177967d$var$decodeCache[exclude] = [];
        for(i = 0; i < 128; i++){
            ch = String.fromCharCode(i);
            cache.push(ch);
        }
        for(i = 0; i < exclude.length; i++){
            ch = exclude.charCodeAt(i);
            cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
        }
        return cache;
    }
    function $04f654215177967d$var$decode(string, exclude) {
        var cache;
        if (typeof exclude !== 'string') exclude = $04f654215177967d$var$decode.defaultChars;
        cache = $04f654215177967d$var$getDecodeCache(exclude);
        return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
            var i, l, b1, b2, b3, b4, chr, result = '';
            for(i = 0, l = seq.length; i < l; i += 3){
                b1 = parseInt(seq.slice(i + 1, i + 3), 16);
                if (b1 < 0x80) {
                    result += cache[b1];
                    continue;
                }
                if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                    b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                    if ((b2 & 0xC0) === 0x80) {
                        chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                        if (chr < 0x80) result += '\ufffd\ufffd';
                        else result += String.fromCharCode(chr);
                        i += 3;
                        continue;
                    }
                }
                if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                    b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                    b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                    if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                        chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                        if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                        else result += String.fromCharCode(chr);
                        i += 6;
                        continue;
                    }
                }
                if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                    b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                    b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                    b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                    if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                        chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                        if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                        else {
                            chr -= 0x10000;
                            result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                        }
                        i += 9;
                        continue;
                    }
                }
                result += '\ufffd';
            }
            return result;
        });
    }
    $04f654215177967d$var$decode.defaultChars = ';/?:@&=+$,#';
    $04f654215177967d$var$decode.componentChars = '';
    module.exports = $04f654215177967d$var$decode;
});
parcelRegister("3yKUv", function(module, exports) {
    'use strict';
    module.exports = function format(url) {
        var result = '';
        result += url.protocol || '';
        result += url.slashes ? '//' : '';
        result += url.auth ? url.auth + '@' : '';
        if (url.hostname && url.hostname.indexOf(':') !== -1) result += '[' + url.hostname + ']';
        else result += url.hostname || '';
        result += url.port ? ':' + url.port : '';
        result += url.pathname || '';
        result += url.search || '';
        result += url.hash || '';
        return result;
    };
});
parcelRegister("bQztL", function(module, exports) {
    'use strict';
    function $8a0012734669979b$var$Url() {
        this.protocol = null;
        this.slashes = null;
        this.auth = null;
        this.port = null;
        this.hostname = null;
        this.hash = null;
        this.search = null;
        this.pathname = null;
    }
    var $8a0012734669979b$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $8a0012734669979b$var$portPattern = /:[0-9]*$/, $8a0012734669979b$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, $8a0012734669979b$var$delims = [
        '<',
        '>',
        '"',
        '`',
        ' ',
        '\r',
        '\n',
        '\t'
    ], $8a0012734669979b$var$unwise = [
        '{',
        '}',
        '|',
        '\\',
        '^',
        '`'
    ].concat($8a0012734669979b$var$delims), $8a0012734669979b$var$autoEscape = [
        '\''
    ].concat($8a0012734669979b$var$unwise), $8a0012734669979b$var$nonHostChars = [
        '%',
        '/',
        '?',
        ';',
        '#'
    ].concat($8a0012734669979b$var$autoEscape), $8a0012734669979b$var$hostEndingChars = [
        '/',
        '?',
        '#'
    ], $8a0012734669979b$var$hostnameMaxLen = 255, $8a0012734669979b$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $8a0012734669979b$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, $8a0012734669979b$var$hostlessProtocol = {
        'javascript': true,
        'javascript:': true
    }, $8a0012734669979b$var$slashedProtocol = {
        'http': true,
        'https': true,
        'ftp': true,
        'gopher': true,
        'file': true,
        'http:': true,
        'https:': true,
        'ftp:': true,
        'gopher:': true,
        'file:': true
    };
    function $8a0012734669979b$var$urlParse(url, slashesDenoteHost) {
        if (url && url instanceof $8a0012734669979b$var$Url) return url;
        var u = new $8a0012734669979b$var$Url();
        u.parse(url, slashesDenoteHost);
        return u;
    }
    $8a0012734669979b$var$Url.prototype.parse = function(url, slashesDenoteHost) {
        var i, l, lowerProto, hec, slashes, rest = url;
        rest = rest.trim();
        if (!slashesDenoteHost && url.split('#').length === 1) {
            var simplePath = $8a0012734669979b$var$simplePathPattern.exec(rest);
            if (simplePath) {
                this.pathname = simplePath[1];
                if (simplePath[2]) this.search = simplePath[2];
                return this;
            }
        }
        var proto = $8a0012734669979b$var$protocolPattern.exec(rest);
        if (proto) {
            proto = proto[0];
            lowerProto = proto.toLowerCase();
            this.protocol = proto;
            rest = rest.substr(proto.length);
        }
        if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
            slashes = rest.substr(0, 2) === '//';
            if (slashes && !(proto && $8a0012734669979b$var$hostlessProtocol[proto])) {
                rest = rest.substr(2);
                this.slashes = true;
            }
        }
        if (!$8a0012734669979b$var$hostlessProtocol[proto] && (slashes || proto && !$8a0012734669979b$var$slashedProtocol[proto])) {
            var hostEnd = -1;
            for(i = 0; i < $8a0012734669979b$var$hostEndingChars.length; i++){
                hec = rest.indexOf($8a0012734669979b$var$hostEndingChars[i]);
                if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
            }
            var auth, atSign;
            if (hostEnd === -1) atSign = rest.lastIndexOf('@');
            else atSign = rest.lastIndexOf('@', hostEnd);
            if (atSign !== -1) {
                auth = rest.slice(0, atSign);
                rest = rest.slice(atSign + 1);
                this.auth = auth;
            }
            hostEnd = -1;
            for(i = 0; i < $8a0012734669979b$var$nonHostChars.length; i++){
                hec = rest.indexOf($8a0012734669979b$var$nonHostChars[i]);
                if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
            }
            if (hostEnd === -1) hostEnd = rest.length;
            if (rest[hostEnd - 1] === ':') hostEnd--;
            var host = rest.slice(0, hostEnd);
            rest = rest.slice(hostEnd);
            this.parseHost(host);
            this.hostname = this.hostname || '';
            var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
            if (!ipv6Hostname) {
                var hostparts = this.hostname.split(/\./);
                for(i = 0, l = hostparts.length; i < l; i++){
                    var part = hostparts[i];
                    if (!part) continue;
                    if (!part.match($8a0012734669979b$var$hostnamePartPattern)) {
                        var newpart = '';
                        for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) newpart += 'x';
                        else newpart += part[j];
                        if (!newpart.match($8a0012734669979b$var$hostnamePartPattern)) {
                            var validParts = hostparts.slice(0, i);
                            var notHost = hostparts.slice(i + 1);
                            var bit = part.match($8a0012734669979b$var$hostnamePartStart);
                            if (bit) {
                                validParts.push(bit[1]);
                                notHost.unshift(bit[2]);
                            }
                            if (notHost.length) rest = notHost.join('.') + rest;
                            this.hostname = validParts.join('.');
                            break;
                        }
                    }
                }
            }
            if (this.hostname.length > $8a0012734669979b$var$hostnameMaxLen) this.hostname = '';
            if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
        }
        var hash = rest.indexOf('#');
        if (hash !== -1) {
            this.hash = rest.substr(hash);
            rest = rest.slice(0, hash);
        }
        var qm = rest.indexOf('?');
        if (qm !== -1) {
            this.search = rest.substr(qm);
            rest = rest.slice(0, qm);
        }
        if (rest) this.pathname = rest;
        if ($8a0012734669979b$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
        return this;
    };
    $8a0012734669979b$var$Url.prototype.parseHost = function(host) {
        var port = $8a0012734669979b$var$portPattern.exec(host);
        if (port) {
            port = port[0];
            if (port !== ':') this.port = port.substr(1);
            host = host.substr(0, host.length - port.length);
        }
        if (host) this.hostname = host;
    };
    module.exports = $8a0012734669979b$var$urlParse;
});
parcelRegister("7G9dc", function(module, exports) {
    $parcel$export(module.exports, "Any", ()=>$597399ee2a9a2974$export$b24b633b1364b94b, (v)=>$597399ee2a9a2974$export$b24b633b1364b94b = v);
    $parcel$export(module.exports, "Cc", ()=>$597399ee2a9a2974$export$15dafbac7aec8a57, (v)=>$597399ee2a9a2974$export$15dafbac7aec8a57 = v);
    $parcel$export(module.exports, "Cf", ()=>$597399ee2a9a2974$export$239cff0cce87eb56, (v)=>$597399ee2a9a2974$export$239cff0cce87eb56 = v);
    $parcel$export(module.exports, "P", ()=>$597399ee2a9a2974$export$56c0d5a1e737357d, (v)=>$597399ee2a9a2974$export$56c0d5a1e737357d = v);
    $parcel$export(module.exports, "Z", ()=>$597399ee2a9a2974$export$dc98b0b04f4c7758, (v)=>$597399ee2a9a2974$export$dc98b0b04f4c7758 = v);
    var $597399ee2a9a2974$export$b24b633b1364b94b;
    var $597399ee2a9a2974$export$15dafbac7aec8a57;
    var $597399ee2a9a2974$export$239cff0cce87eb56;
    var $597399ee2a9a2974$export$56c0d5a1e737357d;
    var $597399ee2a9a2974$export$dc98b0b04f4c7758;
    'use strict';
    $597399ee2a9a2974$export$b24b633b1364b94b = (parcelRequire("b9ep3"));
    $597399ee2a9a2974$export$15dafbac7aec8a57 = (parcelRequire("23ErL"));
    $597399ee2a9a2974$export$239cff0cce87eb56 = (parcelRequire("i4n2C"));
    $597399ee2a9a2974$export$56c0d5a1e737357d = (parcelRequire("9bBmm"));
    $597399ee2a9a2974$export$dc98b0b04f4c7758 = (parcelRequire("oRY4m"));
});
parcelRegister("i4n2C", function(module, exports) {
    module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;
});
parcelRegister("1mGdb", function(module, exports) {
    $parcel$export(module.exports, "parseLinkLabel", ()=>$0fe896e38fc1beac$export$2a2c8612930e58d0, (v)=>$0fe896e38fc1beac$export$2a2c8612930e58d0 = v);
    $parcel$export(module.exports, "parseLinkDestination", ()=>$0fe896e38fc1beac$export$22bd24080f95f2b3, (v)=>$0fe896e38fc1beac$export$22bd24080f95f2b3 = v);
    $parcel$export(module.exports, "parseLinkTitle", ()=>$0fe896e38fc1beac$export$89650c5477a69db9, (v)=>$0fe896e38fc1beac$export$89650c5477a69db9 = v);
    var $0fe896e38fc1beac$export$2a2c8612930e58d0;
    var $0fe896e38fc1beac$export$22bd24080f95f2b3;
    var $0fe896e38fc1beac$export$89650c5477a69db9;
    'use strict';
    $0fe896e38fc1beac$export$2a2c8612930e58d0 = (parcelRequire("8y5kB"));
    $0fe896e38fc1beac$export$22bd24080f95f2b3 = (parcelRequire("guwA0"));
    $0fe896e38fc1beac$export$89650c5477a69db9 = (parcelRequire("9bSCV"));
});
parcelRegister("8y5kB", function(module, exports) {
    'use strict';
    module.exports = function parseLinkLabel(state, start, disableNested) {
        var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
        state.pos = start + 1;
        level = 1;
        while(state.pos < max){
            marker = state.src.charCodeAt(state.pos);
            if (marker === 0x5D) {
                level--;
                if (level === 0) {
                    found = true;
                    break;
                }
            }
            prevPos = state.pos;
            state.md.inline.skipToken(state);
            if (marker === 0x5B) {
                if (prevPos === state.pos - 1) level++;
                else if (disableNested) {
                    state.pos = oldPos;
                    return -1;
                }
            }
        }
        if (found) labelEnd = state.pos;
        state.pos = oldPos;
        return labelEnd;
    };
});
parcelRegister("guwA0", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $c018b854bcc71549$require$unescapeAll = $lKlAe.unescapeAll;
    module.exports = function parseLinkDestination(str, start, max) {
        var code, level, pos = start, result = {
            ok: false,
            pos: 0,
            lines: 0,
            str: ''
        };
        if (str.charCodeAt(pos) === 0x3C) {
            pos++;
            while(pos < max){
                code = str.charCodeAt(pos);
                if (code === 0x0A) return result;
                if (code === 0x3C) return result;
                if (code === 0x3E) {
                    result.pos = pos + 1;
                    result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start + 1, pos));
                    result.ok = true;
                    return result;
                }
                if (code === 0x5C && pos + 1 < max) {
                    pos += 2;
                    continue;
                }
                pos++;
            }
            return result;
        }
        level = 0;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x20) break;
            if (code < 0x20 || code === 0x7F) break;
            if (code === 0x5C && pos + 1 < max) {
                if (str.charCodeAt(pos + 1) === 0x20) break;
                pos += 2;
                continue;
            }
            if (code === 0x28) {
                level++;
                if (level > 32) return result;
            }
            if (code === 0x29) {
                if (level === 0) break;
                level--;
            }
            pos++;
        }
        if (start === pos) return result;
        if (level !== 0) return result;
        result.str = $c018b854bcc71549$require$unescapeAll(str.slice(start, pos));
        result.pos = pos;
        result.ok = true;
        return result;
    };
});
parcelRegister("9bSCV", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $6b0f83e20702a9d5$require$unescapeAll = $lKlAe.unescapeAll;
    module.exports = function parseLinkTitle(str, start, max) {
        var code, marker, lines = 0, pos = start, result = {
            ok: false,
            pos: 0,
            lines: 0,
            str: ''
        };
        if (pos >= max) return result;
        marker = str.charCodeAt(pos);
        if (marker !== 0x22 && marker !== 0x27 && marker !== 0x28) return result;
        pos++;
        if (marker === 0x28) marker = 0x29;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === marker) {
                result.pos = pos + 1;
                result.lines = lines;
                result.str = $6b0f83e20702a9d5$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            } else if (code === 0x28 && marker === 0x29) return result;
            else if (code === 0x0A) lines++;
            else if (code === 0x5C && pos + 1 < max) {
                pos++;
                if (str.charCodeAt(pos) === 0x0A) lines++;
            }
            pos++;
        }
        return result;
    };
});
parcelRegister("keGIi", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $ebb63f71260e6c54$require$assign = $lKlAe.assign;
    var $lKlAe = parcelRequire("lKlAe");
    var $ebb63f71260e6c54$require$unescapeAll = $lKlAe.unescapeAll;
    var $lKlAe = parcelRequire("lKlAe");
    var $ebb63f71260e6c54$require$escapeHtml = $lKlAe.escapeHtml;
    var $ebb63f71260e6c54$var$default_rules = {};
    $ebb63f71260e6c54$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
        var token = tokens[idx];
        return '<code' + slf.renderAttrs(token) + '>' + $ebb63f71260e6c54$require$escapeHtml(token.content) + '</code>';
    };
    $ebb63f71260e6c54$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
        var token = tokens[idx];
        return '<pre' + slf.renderAttrs(token) + '><code>' + $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
    };
    $ebb63f71260e6c54$var$default_rules.fence = function(tokens, idx, options, env, slf) {
        var token = tokens[idx], info = token.info ? $ebb63f71260e6c54$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
        if (info) {
            arr = info.split(/(\s+)/g);
            langName = arr[0];
            langAttrs = arr.slice(2).join('');
        }
        if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $ebb63f71260e6c54$require$escapeHtml(token.content);
        else highlighted = $ebb63f71260e6c54$require$escapeHtml(token.content);
        if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
        if (info) {
            i = token.attrIndex('class');
            tmpAttrs = token.attrs ? token.attrs.slice() : [];
            if (i < 0) tmpAttrs.push([
                'class',
                options.langPrefix + langName
            ]);
            else {
                tmpAttrs[i] = tmpAttrs[i].slice();
                tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
            }
            tmpToken = {
                attrs: tmpAttrs
            };
            return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
        }
        return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
    };
    $ebb63f71260e6c54$var$default_rules.image = function(tokens, idx, options, env, slf) {
        var token = tokens[idx];
        token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
        return slf.renderToken(tokens, idx, options);
    };
    $ebb63f71260e6c54$var$default_rules.hardbreak = function(tokens, idx, options) {
        return options.xhtmlOut ? '<br />\n' : '<br>\n';
    };
    $ebb63f71260e6c54$var$default_rules.softbreak = function(tokens, idx, options) {
        return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
    };
    $ebb63f71260e6c54$var$default_rules.text = function(tokens, idx) {
        return $ebb63f71260e6c54$require$escapeHtml(tokens[idx].content);
    };
    $ebb63f71260e6c54$var$default_rules.html_block = function(tokens, idx) {
        return tokens[idx].content;
    };
    $ebb63f71260e6c54$var$default_rules.html_inline = function(tokens, idx) {
        return tokens[idx].content;
    };
    function $ebb63f71260e6c54$var$Renderer() {
        this.rules = $ebb63f71260e6c54$require$assign({}, $ebb63f71260e6c54$var$default_rules);
    }
    $ebb63f71260e6c54$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
        var i, l, result;
        if (!token.attrs) return '';
        result = '';
        for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][0]) + '="' + $ebb63f71260e6c54$require$escapeHtml(token.attrs[i][1]) + '"';
        return result;
    };
    $ebb63f71260e6c54$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
        var nextToken, result = '', needLf = false, token = tokens[idx];
        if (token.hidden) return '';
        if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
        result += (token.nesting === -1 ? '</' : '<') + token.tag;
        result += this.renderAttrs(token);
        if (token.nesting === 0 && options.xhtmlOut) result += ' /';
        if (token.block) {
            needLf = true;
            if (token.nesting === 1) {
                if (idx + 1 < tokens.length) {
                    nextToken = tokens[idx + 1];
                    if (nextToken.type === 'inline' || nextToken.hidden) needLf = false;
                    else if (nextToken.nesting === -1 && nextToken.tag === token.tag) needLf = false;
                }
            }
        }
        result += needLf ? '>\n' : '>';
        return result;
    };
    $ebb63f71260e6c54$var$Renderer.prototype.renderInline = function(tokens, options, env) {
        var type, result = '', rules = this.rules;
        for(var i = 0, len = tokens.length; i < len; i++){
            type = tokens[i].type;
            if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
            else result += this.renderToken(tokens, i, options);
        }
        return result;
    };
    $ebb63f71260e6c54$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
        var result = '';
        for(var i = 0, len = tokens.length; i < len; i++){
            if (tokens[i].type === 'text') result += tokens[i].content;
            else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
            else if (tokens[i].type === 'softbreak') result += '\n';
        }
        return result;
    };
    $ebb63f71260e6c54$var$Renderer.prototype.render = function(tokens, options, env) {
        var i, len, type, result = '', rules = this.rules;
        for(i = 0, len = tokens.length; i < len; i++){
            type = tokens[i].type;
            if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
            else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
            else result += this.renderToken(tokens, i, options, env);
        }
        return result;
    };
    module.exports = $ebb63f71260e6c54$var$Renderer;
});
parcelRegister("aVlnc", function(module, exports) {
    'use strict';
    var $3sin6 = parcelRequire("3sin6");
    var $7f3fce7f6016210f$var$_rules = [
        [
            'normalize',
            (parcelRequire("iWx6a"))
        ],
        [
            'block',
            (parcelRequire("iY2Wj"))
        ],
        [
            'inline',
            (parcelRequire("16b9L"))
        ],
        [
            'linkify',
            (parcelRequire("lOz8R"))
        ],
        [
            'replacements',
            (parcelRequire("45Efy"))
        ],
        [
            'smartquotes',
            (parcelRequire("6sbf2"))
        ],
        [
            'text_join',
            (parcelRequire("jEa7S"))
        ]
    ];
    function $7f3fce7f6016210f$var$Core() {
        this.ruler = new $3sin6();
        for(var i = 0; i < $7f3fce7f6016210f$var$_rules.length; i++)this.ruler.push($7f3fce7f6016210f$var$_rules[i][0], $7f3fce7f6016210f$var$_rules[i][1]);
    }
    $7f3fce7f6016210f$var$Core.prototype.process = function(state) {
        var i, l, rules;
        rules = this.ruler.getRules('');
        for(i = 0, l = rules.length; i < l; i++)rules[i](state);
    };
    $7f3fce7f6016210f$var$Core.prototype.State = (parcelRequire("dRBf6"));
    module.exports = $7f3fce7f6016210f$var$Core;
});
parcelRegister("3sin6", function(module, exports) {
    'use strict';
    function $28423cd2f7c52093$var$Ruler() {
        this.__rules__ = [];
        this.__cache__ = null;
    }
    $28423cd2f7c52093$var$Ruler.prototype.__find__ = function(name) {
        for(var i = 0; i < this.__rules__.length; i++){
            if (this.__rules__[i].name === name) return i;
        }
        return -1;
    };
    $28423cd2f7c52093$var$Ruler.prototype.__compile__ = function() {
        var self = this;
        var chains = [
            ''
        ];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            rule.alt.forEach(function(altName) {
                if (chains.indexOf(altName) < 0) chains.push(altName);
            });
        });
        self.__cache__ = {};
        chains.forEach(function(chain) {
            self.__cache__[chain] = [];
            self.__rules__.forEach(function(rule) {
                if (!rule.enabled) return;
                if (chain && rule.alt.indexOf(chain) < 0) return;
                self.__cache__[chain].push(rule.fn);
            });
        });
    };
    $28423cd2f7c52093$var$Ruler.prototype.at = function(name, fn, options) {
        var index = this.__find__(name);
        var opt = options || {};
        if (index === -1) throw new Error('Parser rule not found: ' + name);
        this.__rules__[index].fn = fn;
        this.__rules__[index].alt = opt.alt || [];
        this.__cache__ = null;
    };
    $28423cd2f7c52093$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
        var index = this.__find__(beforeName);
        var opt = options || {};
        if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
        this.__rules__.splice(index, 0, {
            name: ruleName,
            enabled: true,
            fn: fn,
            alt: opt.alt || []
        });
        this.__cache__ = null;
    };
    $28423cd2f7c52093$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
        var index = this.__find__(afterName);
        var opt = options || {};
        if (index === -1) throw new Error('Parser rule not found: ' + afterName);
        this.__rules__.splice(index + 1, 0, {
            name: ruleName,
            enabled: true,
            fn: fn,
            alt: opt.alt || []
        });
        this.__cache__ = null;
    };
    $28423cd2f7c52093$var$Ruler.prototype.push = function(ruleName, fn, options) {
        var opt = options || {};
        this.__rules__.push({
            name: ruleName,
            enabled: true,
            fn: fn,
            alt: opt.alt || []
        });
        this.__cache__ = null;
    };
    $28423cd2f7c52093$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
        if (!Array.isArray(list)) list = [
            list
        ];
        var result = [];
        list.forEach(function(name) {
            var idx = this.__find__(name);
            if (idx < 0) {
                if (ignoreInvalid) return;
                throw new Error('Rules manager: invalid rule name ' + name);
            }
            this.__rules__[idx].enabled = true;
            result.push(name);
        }, this);
        this.__cache__ = null;
        return result;
    };
    $28423cd2f7c52093$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
        if (!Array.isArray(list)) list = [
            list
        ];
        this.__rules__.forEach(function(rule) {
            rule.enabled = false;
        });
        this.enable(list, ignoreInvalid);
    };
    $28423cd2f7c52093$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
        if (!Array.isArray(list)) list = [
            list
        ];
        var result = [];
        list.forEach(function(name) {
            var idx = this.__find__(name);
            if (idx < 0) {
                if (ignoreInvalid) return;
                throw new Error('Rules manager: invalid rule name ' + name);
            }
            this.__rules__[idx].enabled = false;
            result.push(name);
        }, this);
        this.__cache__ = null;
        return result;
    };
    $28423cd2f7c52093$var$Ruler.prototype.getRules = function(chainName) {
        if (this.__cache__ === null) this.__compile__();
        return this.__cache__[chainName] || [];
    };
    module.exports = $28423cd2f7c52093$var$Ruler;
});
parcelRegister("iWx6a", function(module, exports) {
    'use strict';
    var $dca7516ecd2cb0cd$var$NEWLINES_RE = /\r\n?|\n/g;
    var $dca7516ecd2cb0cd$var$NULL_RE = /\0/g;
    module.exports = function normalize(state) {
        var str;
        str = state.src.replace($dca7516ecd2cb0cd$var$NEWLINES_RE, '\n');
        str = str.replace($dca7516ecd2cb0cd$var$NULL_RE, '\uFFFD');
        state.src = str;
    };
});
parcelRegister("iY2Wj", function(module, exports) {
    'use strict';
    module.exports = function block(state) {
        var token;
        if (state.inlineMode) {
            token = new state.Token('inline', '', 0);
            token.content = state.src;
            token.map = [
                0,
                1
            ];
            token.children = [];
            state.tokens.push(token);
        } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
    };
});
parcelRegister("16b9L", function(module, exports) {
    'use strict';
    module.exports = function inline(state) {
        var tokens = state.tokens, tok, i, l;
        for(i = 0, l = tokens.length; i < l; i++){
            tok = tokens[i];
            if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
        }
    };
});
parcelRegister("lOz8R", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $fe1986eb06b8c500$require$arrayReplaceAt = $lKlAe.arrayReplaceAt;
    function $fe1986eb06b8c500$var$isLinkOpen(str) {
        return /^<a[>\s]/i.test(str);
    }
    function $fe1986eb06b8c500$var$isLinkClose(str) {
        return /^<\/a\s*>/i.test(str);
    }
    module.exports = function linkify(state) {
        var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
        if (!state.md.options.linkify) return;
        for(j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
            tokens = blockTokens[j].children;
            htmlLinkLevel = 0;
            for(i = tokens.length - 1; i >= 0; i--){
                currentToken = tokens[i];
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                if (currentToken.type === 'html_inline') {
                    if ($fe1986eb06b8c500$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($fe1986eb06b8c500$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                    text = currentToken.content;
                    links = state.md.linkify.match(text);
                    nodes = [];
                    level = currentToken.level;
                    lastPos = 0;
                    if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                    for(ln = 0; ln < links.length; ln++){
                        url = links[ln].url;
                        fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        urlText = links[ln].text;
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        pos = links[ln].index;
                        if (pos > lastPos) {
                            token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    blockTokens[j].children = tokens = $fe1986eb06b8c500$require$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
});
parcelRegister("45Efy", function(module, exports) {
    'use strict';
    var $2fa6d9dae6dddfa0$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
    var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
    var $2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
    var $2fa6d9dae6dddfa0$var$SCOPED_ABBR = {
        c: "\xa9",
        r: "\xae",
        tm: "\u2122"
    };
    function $2fa6d9dae6dddfa0$var$replaceFn(match, name) {
        return $2fa6d9dae6dddfa0$var$SCOPED_ABBR[name.toLowerCase()];
    }
    function $2fa6d9dae6dddfa0$var$replace_scoped(inlineTokens) {
        var i, token, inside_autolink = 0;
        for(i = inlineTokens.length - 1; i >= 0; i--){
            token = inlineTokens[i];
            if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($2fa6d9dae6dddfa0$var$SCOPED_ABBR_RE, $2fa6d9dae6dddfa0$var$replaceFn);
            if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
            if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
        }
    }
    function $2fa6d9dae6dddfa0$var$replace_rare(inlineTokens) {
        var i, token, inside_autolink = 0;
        for(i = inlineTokens.length - 1; i >= 0; i--){
            token = inlineTokens[i];
            if (token.type === 'text' && !inside_autolink) {
                if ($2fa6d9dae6dddfa0$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1").replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',').replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014').replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
            }
            if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
            if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
        }
    }
    module.exports = function replace(state) {
        var blkIdx;
        if (!state.md.options.typographer) return;
        for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
            if (state.tokens[blkIdx].type !== 'inline') continue;
            if ($2fa6d9dae6dddfa0$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_scoped(state.tokens[blkIdx].children);
            if ($2fa6d9dae6dddfa0$var$RARE_RE.test(state.tokens[blkIdx].content)) $2fa6d9dae6dddfa0$var$replace_rare(state.tokens[blkIdx].children);
        }
    };
});
parcelRegister("6sbf2", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $4b2e13ec30356b37$require$isWhiteSpace = $lKlAe.isWhiteSpace;
    var $lKlAe = parcelRequire("lKlAe");
    var $4b2e13ec30356b37$require$isPunctChar = $lKlAe.isPunctChar;
    var $lKlAe = parcelRequire("lKlAe");
    var $4b2e13ec30356b37$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
    var $4b2e13ec30356b37$var$QUOTE_TEST_RE = /['"]/;
    var $4b2e13ec30356b37$var$QUOTE_RE = /['"]/g;
    var $4b2e13ec30356b37$var$APOSTROPHE = '\u2019';
    function $4b2e13ec30356b37$var$replaceAt(str, index, ch) {
        return str.slice(0, index) + ch + str.slice(index + 1);
    }
    function $4b2e13ec30356b37$var$process_inlines(tokens, state) {
        var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
        stack = [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            thisLevel = tokens[i].level;
            for(j = stack.length - 1; j >= 0; j--){
                if (stack[j].level <= thisLevel) break;
            }
            stack.length = j + 1;
            if (token.type !== 'text') continue;
            text = token.content;
            pos = 0;
            max = text.length;
            OUTER: while(pos < max){
                $4b2e13ec30356b37$var$QUOTE_RE.lastIndex = pos;
                t = $4b2e13ec30356b37$var$QUOTE_RE.exec(text);
                if (!t) break;
                canOpen = canClose = true;
                pos = t.index + 1;
                isSingle = t[0] === "'";
                lastChar = 0x20;
                if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
                else for(j = i - 1; j >= 0; j--){
                    if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break;
                    if (!tokens[j].content) continue;
                    lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                    break;
                }
                nextChar = 0x20;
                if (pos < max) nextChar = text.charCodeAt(pos);
                else for(j = i + 1; j < tokens.length; j++){
                    if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break;
                    if (!tokens[j].content) continue;
                    nextChar = tokens[j].content.charCodeAt(0);
                    break;
                }
                isLastPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(lastChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(lastChar));
                isNextPunctChar = $4b2e13ec30356b37$require$isMdAsciiPunct(nextChar) || $4b2e13ec30356b37$require$isPunctChar(String.fromCharCode(nextChar));
                isLastWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(lastChar);
                isNextWhiteSpace = $4b2e13ec30356b37$require$isWhiteSpace(nextChar);
                if (isNextWhiteSpace) canOpen = false;
                else if (isNextPunctChar) {
                    if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
                }
                if (isLastWhiteSpace) canClose = false;
                else if (isLastPunctChar) {
                    if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
                }
                if (nextChar === 0x22 && t[0] === '"') {
                    if (lastChar >= 0x30 && lastChar <= 0x39) canClose = canOpen = false;
                }
                if (canOpen && canClose) {
                    canOpen = isLastPunctChar;
                    canClose = isNextPunctChar;
                }
                if (!canOpen && !canClose) {
                    if (isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
                    continue;
                }
                if (canClose) for(j = stack.length - 1; j >= 0; j--){
                    item = stack[j];
                    if (stack[j].level < thisLevel) break;
                    if (item.single === isSingle && stack[j].level === thisLevel) {
                        item = stack[j];
                        if (isSingle) {
                            openQuote = state.md.options.quotes[2];
                            closeQuote = state.md.options.quotes[3];
                        } else {
                            openQuote = state.md.options.quotes[0];
                            closeQuote = state.md.options.quotes[1];
                        }
                        token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, closeQuote);
                        tokens[item.token].content = $4b2e13ec30356b37$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                        pos += closeQuote.length - 1;
                        if (item.token === i) pos += openQuote.length - 1;
                        text = token.content;
                        max = text.length;
                        stack.length = j;
                        continue OUTER;
                    }
                }
                if (canOpen) stack.push({
                    token: i,
                    pos: t.index,
                    single: isSingle,
                    level: thisLevel
                });
                else if (canClose && isSingle) token.content = $4b2e13ec30356b37$var$replaceAt(token.content, t.index, $4b2e13ec30356b37$var$APOSTROPHE);
            }
        }
    }
    module.exports = function smartquotes(state) {
        var blkIdx;
        if (!state.md.options.typographer) return;
        for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
            if (state.tokens[blkIdx].type !== 'inline' || !$4b2e13ec30356b37$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
            $4b2e13ec30356b37$var$process_inlines(state.tokens[blkIdx].children, state);
        }
    };
});
parcelRegister("jEa7S", function(module, exports) {
    'use strict';
    module.exports = function text_join(state) {
        var j, l, tokens, curr, max, last, blockTokens = state.tokens;
        for(j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline') continue;
            tokens = blockTokens[j].children;
            max = tokens.length;
            for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
            for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
            else {
                if (curr !== last) tokens[last] = tokens[curr];
                last++;
            }
            if (curr !== last) tokens.length = last;
        }
    };
});
parcelRegister("dRBf6", function(module, exports) {
    'use strict';
    var $jwpQf = parcelRequire("jwpQf");
    function $a17d1d317b1d68ad$var$StateCore(src, md, env) {
        this.src = src;
        this.env = env;
        this.tokens = [];
        this.inlineMode = false;
        this.md = md;
    }
    $a17d1d317b1d68ad$var$StateCore.prototype.Token = $jwpQf;
    module.exports = $a17d1d317b1d68ad$var$StateCore;
});
parcelRegister("jwpQf", function(module, exports) {
    'use strict';
    function $e3650d20fdc1ba98$var$Token(type, tag, nesting) {
        this.type = type;
        this.tag = tag;
        this.attrs = null;
        this.map = null;
        this.nesting = nesting;
        this.level = 0;
        this.children = null;
        this.content = '';
        this.markup = '';
        this.info = '';
        this.meta = null;
        this.block = false;
        this.hidden = false;
    }
    $e3650d20fdc1ba98$var$Token.prototype.attrIndex = function attrIndex(name) {
        var attrs, i, len;
        if (!this.attrs) return -1;
        attrs = this.attrs;
        for(i = 0, len = attrs.length; i < len; i++){
            if (attrs[i][0] === name) return i;
        }
        return -1;
    };
    $e3650d20fdc1ba98$var$Token.prototype.attrPush = function attrPush(attrData) {
        if (this.attrs) this.attrs.push(attrData);
        else this.attrs = [
            attrData
        ];
    };
    $e3650d20fdc1ba98$var$Token.prototype.attrSet = function attrSet(name, value) {
        var idx = this.attrIndex(name), attrData = [
            name,
            value
        ];
        if (idx < 0) this.attrPush(attrData);
        else this.attrs[idx] = attrData;
    };
    $e3650d20fdc1ba98$var$Token.prototype.attrGet = function attrGet(name) {
        var idx = this.attrIndex(name), value = null;
        if (idx >= 0) value = this.attrs[idx][1];
        return value;
    };
    $e3650d20fdc1ba98$var$Token.prototype.attrJoin = function attrJoin(name, value) {
        var idx = this.attrIndex(name);
        if (idx < 0) this.attrPush([
            name,
            value
        ]);
        else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
    };
    module.exports = $e3650d20fdc1ba98$var$Token;
});
parcelRegister("81Ci5", function(module, exports) {
    'use strict';
    var $3sin6 = parcelRequire("3sin6");
    var $5d7c1e72b0aff81a$var$_rules = [
        [
            'table',
            (parcelRequire("gSwCe")),
            [
                'paragraph',
                'reference'
            ]
        ],
        [
            'code',
            (parcelRequire("dHrHm"))
        ],
        [
            'fence',
            (parcelRequire("1KHgS")),
            [
                'paragraph',
                'reference',
                'blockquote',
                'list'
            ]
        ],
        [
            'blockquote',
            (parcelRequire("79uLo")),
            [
                'paragraph',
                'reference',
                'blockquote',
                'list'
            ]
        ],
        [
            'hr',
            (parcelRequire("a0gIO")),
            [
                'paragraph',
                'reference',
                'blockquote',
                'list'
            ]
        ],
        [
            'list',
            (parcelRequire("bFPxW")),
            [
                'paragraph',
                'reference',
                'blockquote'
            ]
        ],
        [
            'reference',
            (parcelRequire("6Cm2K"))
        ],
        [
            'html_block',
            (parcelRequire("3IX6c")),
            [
                'paragraph',
                'reference',
                'blockquote'
            ]
        ],
        [
            'heading',
            (parcelRequire("5VRwl")),
            [
                'paragraph',
                'reference',
                'blockquote'
            ]
        ],
        [
            'lheading',
            (parcelRequire("2v0Kv"))
        ],
        [
            'paragraph',
            (parcelRequire("d0isB"))
        ]
    ];
    function $5d7c1e72b0aff81a$var$ParserBlock() {
        this.ruler = new $3sin6();
        for(var i = 0; i < $5d7c1e72b0aff81a$var$_rules.length; i++)this.ruler.push($5d7c1e72b0aff81a$var$_rules[i][0], $5d7c1e72b0aff81a$var$_rules[i][1], {
            alt: ($5d7c1e72b0aff81a$var$_rules[i][2] || []).slice()
        });
    }
    $5d7c1e72b0aff81a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
        var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
        while(line < endLine){
            state.line = line = state.skipEmptyLines(line);
            if (line >= endLine) break;
            if (state.sCount[line] < state.blkIndent) break;
            if (state.level >= maxNesting) {
                state.line = endLine;
                break;
            }
            prevLine = state.line;
            for(i = 0; i < len; i++){
                ok = rules[i](state, line, endLine, false);
                if (ok) {
                    if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                    break;
                }
            }
            if (!ok) throw new Error('none of the block rules matched');
            state.tight = !hasEmptyLines;
            if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
            line = state.line;
            if (line < endLine && state.isEmpty(line)) {
                hasEmptyLines = true;
                line++;
                state.line = line;
            }
        }
    };
    $5d7c1e72b0aff81a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
        var state;
        if (!src) return;
        state = new this.State(src, md, env, outTokens);
        this.tokenize(state, state.line, state.lineMax);
    };
    $5d7c1e72b0aff81a$var$ParserBlock.prototype.State = (parcelRequire("l865e"));
    module.exports = $5d7c1e72b0aff81a$var$ParserBlock;
});
parcelRegister("gSwCe", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $c49afd4af32a69df$require$isSpace = $lKlAe.isSpace;
    function $c49afd4af32a69df$var$getLine(state, line) {
        var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
        return state.src.slice(pos, max);
    }
    function $c49afd4af32a69df$var$escapedSplit(str) {
        var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
        ch = str.charCodeAt(pos);
        while(pos < max){
            if (ch === 0x7c) {
                if (!isEscaped) {
                    result.push(current + str.substring(lastPos, pos));
                    current = '';
                    lastPos = pos + 1;
                } else {
                    current += str.substring(lastPos, pos - 1);
                    lastPos = pos;
                }
            }
            isEscaped = ch === 0x5c;
            pos++;
            ch = str.charCodeAt(pos);
        }
        result.push(current + str.substring(lastPos));
        return result;
    }
    module.exports = function table(state, startLine, endLine, silent) {
        var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
        if (startLine + 2 > endLine) return false;
        nextLine = startLine + 1;
        if (state.sCount[nextLine] < state.blkIndent) return false;
        if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        if (pos >= state.eMarks[nextLine]) return false;
        firstCh = state.src.charCodeAt(pos++);
        if (firstCh !== 0x7C && firstCh !== 0x2D && firstCh !== 0x3A) return false;
        if (pos >= state.eMarks[nextLine]) return false;
        secondCh = state.src.charCodeAt(pos++);
        if (secondCh !== 0x7C && secondCh !== 0x2D && secondCh !== 0x3A && !$c49afd4af32a69df$require$isSpace(secondCh)) return false;
        if (firstCh === 0x2D && $c49afd4af32a69df$require$isSpace(secondCh)) return false;
        while(pos < state.eMarks[nextLine]){
            ch = state.src.charCodeAt(pos);
            if (ch !== 0x7C && ch !== 0x2D && ch !== 0x3A && !$c49afd4af32a69df$require$isSpace(ch)) return false;
            pos++;
        }
        lineText = $c49afd4af32a69df$var$getLine(state, startLine + 1);
        columns = lineText.split('|');
        aligns = [];
        for(i = 0; i < columns.length; i++){
            t = columns[i].trim();
            if (!t) {
                if (i === 0 || i === columns.length - 1) continue;
                else return false;
            }
            if (!/^:?-+:?$/.test(t)) return false;
            if (t.charCodeAt(t.length - 1) === 0x3A) aligns.push(t.charCodeAt(0) === 0x3A ? 'center' : 'right');
            else if (t.charCodeAt(0) === 0x3A) aligns.push('left');
            else aligns.push('');
        }
        lineText = $c49afd4af32a69df$var$getLine(state, startLine).trim();
        if (lineText.indexOf('|') === -1) return false;
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        columns = $c49afd4af32a69df$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        columnCount = columns.length;
        if (columnCount === 0 || columnCount !== aligns.length) return false;
        if (silent) return true;
        oldParentType = state.parentType;
        state.parentType = 'table';
        terminatorRules = state.md.block.ruler.getRules('blockquote');
        token = state.push('table_open', 'table', 1);
        token.map = tableLines = [
            startLine,
            0
        ];
        token = state.push('thead_open', 'thead', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        for(i = 0; i < columns.length; i++){
            token = state.push('th_open', 'th', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i].trim();
            token.children = [];
            token = state.push('th_close', 'th', -1);
        }
        token = state.push('tr_close', 'tr', -1);
        token = state.push('thead_close', 'thead', -1);
        for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
            if (state.sCount[nextLine] < state.blkIndent) break;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
            lineText = $c49afd4af32a69df$var$getLine(state, nextLine).trim();
            if (!lineText) break;
            if (state.sCount[nextLine] - state.blkIndent >= 4) break;
            columns = $c49afd4af32a69df$var$escapedSplit(lineText);
            if (columns.length && columns[0] === '') columns.shift();
            if (columns.length && columns[columns.length - 1] === '') columns.pop();
            if (nextLine === startLine + 2) {
                token = state.push('tbody_open', 'tbody', 1);
                token.map = tbodyLines = [
                    startLine + 2,
                    0
                ];
            }
            token = state.push('tr_open', 'tr', 1);
            token.map = [
                nextLine,
                nextLine + 1
            ];
            for(i = 0; i < columnCount; i++){
                token = state.push('td_open', 'td', 1);
                if (aligns[i]) token.attrs = [
                    [
                        'style',
                        'text-align:' + aligns[i]
                    ]
                ];
                token = state.push('inline', '', 0);
                token.content = columns[i] ? columns[i].trim() : '';
                token.children = [];
                token = state.push('td_close', 'td', -1);
            }
            token = state.push('tr_close', 'tr', -1);
        }
        if (tbodyLines) {
            token = state.push('tbody_close', 'tbody', -1);
            tbodyLines[1] = nextLine;
        }
        token = state.push('table_close', 'table', -1);
        tableLines[1] = nextLine;
        state.parentType = oldParentType;
        state.line = nextLine;
        return true;
    };
});
parcelRegister("dHrHm", function(module, exports) {
    'use strict';
    module.exports = function code(state, startLine, endLine) {
        var nextLine, last, token;
        if (state.sCount[startLine] - state.blkIndent < 4) return false;
        last = nextLine = startLine + 1;
        while(nextLine < endLine){
            if (state.isEmpty(nextLine)) {
                nextLine++;
                continue;
            }
            if (state.sCount[nextLine] - state.blkIndent >= 4) {
                nextLine++;
                last = nextLine;
                continue;
            }
            break;
        }
        state.line = last;
        token = state.push('code_block', 'code', 0);
        token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
        token.map = [
            startLine,
            state.line
        ];
        return true;
    };
});
parcelRegister("1KHgS", function(module, exports) {
    'use strict';
    module.exports = function fence(state, startLine, endLine, silent) {
        var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        if (pos + 3 > max) return false;
        marker = state.src.charCodeAt(pos);
        if (marker !== 0x7E && marker !== 0x60) return false;
        mem = pos;
        pos = state.skipChars(pos, marker);
        len = pos - mem;
        if (len < 3) return false;
        markup = state.src.slice(mem, pos);
        params = state.src.slice(pos, max);
        if (marker === 0x60) {
            if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
        }
        if (silent) return true;
        nextLine = startLine;
        for(;;){
            nextLine++;
            if (nextLine >= endLine) break;
            pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
            if (state.src.charCodeAt(pos) !== marker) continue;
            if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
            pos = state.skipChars(pos, marker);
            if (pos - mem < len) continue;
            pos = state.skipSpaces(pos);
            if (pos < max) continue;
            haveEndMarker = true;
            break;
        }
        len = state.sCount[startLine];
        state.line = nextLine + (haveEndMarker ? 1 : 0);
        token = state.push('fence', 'code', 0);
        token.info = params;
        token.content = state.getLines(startLine + 1, nextLine, len, true);
        token.markup = markup;
        token.map = [
            startLine,
            state.line
        ];
        return true;
    };
});
parcelRegister("79uLo", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $53513ca36aaad8c7$require$isSpace = $lKlAe.isSpace;
    module.exports = function blockquote(state, startLine, endLine, silent) {
        var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        if (state.src.charCodeAt(pos) !== 0x3E) return false;
        if (silent) return true;
        oldBMarks = [];
        oldBSCount = [];
        oldSCount = [];
        oldTShift = [];
        terminatorRules = state.md.block.ruler.getRules('blockquote');
        oldParentType = state.parentType;
        state.parentType = 'blockquote';
        for(nextLine = startLine; nextLine < endLine; nextLine++){
            isOutdented = state.sCount[nextLine] < state.blkIndent;
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos >= max) break;
            if (state.src.charCodeAt(pos++) === 0x3E && !isOutdented) {
                initial = state.sCount[nextLine] + 1;
                if (state.src.charCodeAt(pos) === 0x20) {
                    pos++;
                    initial++;
                    adjustTab = false;
                    spaceAfterMarker = true;
                } else if (state.src.charCodeAt(pos) === 0x09) {
                    spaceAfterMarker = true;
                    if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                        pos++;
                        initial++;
                        adjustTab = false;
                    } else adjustTab = true;
                } else spaceAfterMarker = false;
                offset = initial;
                oldBMarks.push(state.bMarks[nextLine]);
                state.bMarks[nextLine] = pos;
                while(pos < max){
                    ch = state.src.charCodeAt(pos);
                    if ($53513ca36aaad8c7$require$isSpace(ch)) {
                        if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                        else offset++;
                    } else break;
                    pos++;
                }
                lastLineEmpty = pos >= max;
                oldBSCount.push(state.bsCount[nextLine]);
                state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] = offset - initial;
                oldTShift.push(state.tShift[nextLine]);
                state.tShift[nextLine] = pos - state.bMarks[nextLine];
                continue;
            }
            if (lastLineEmpty) break;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) {
                state.lineMax = nextLine;
                if (state.blkIndent !== 0) {
                    oldBMarks.push(state.bMarks[nextLine]);
                    oldBSCount.push(state.bsCount[nextLine]);
                    oldTShift.push(state.tShift[nextLine]);
                    oldSCount.push(state.sCount[nextLine]);
                    state.sCount[nextLine] -= state.blkIndent;
                }
                break;
            }
            oldBMarks.push(state.bMarks[nextLine]);
            oldBSCount.push(state.bsCount[nextLine]);
            oldTShift.push(state.tShift[nextLine]);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = -1;
        }
        oldIndent = state.blkIndent;
        state.blkIndent = 0;
        token = state.push('blockquote_open', 'blockquote', 1);
        token.markup = '>';
        token.map = lines = [
            startLine,
            0
        ];
        state.md.block.tokenize(state, startLine, nextLine);
        token = state.push('blockquote_close', 'blockquote', -1);
        token.markup = '>';
        state.lineMax = oldLineMax;
        state.parentType = oldParentType;
        lines[1] = state.line;
        for(i = 0; i < oldTShift.length; i++){
            state.bMarks[i + startLine] = oldBMarks[i];
            state.tShift[i + startLine] = oldTShift[i];
            state.sCount[i + startLine] = oldSCount[i];
            state.bsCount[i + startLine] = oldBSCount[i];
        }
        state.blkIndent = oldIndent;
        return true;
    };
});
parcelRegister("a0gIO", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $7486e013b11c48f5$require$isSpace = $lKlAe.isSpace;
    module.exports = function hr(state, startLine, endLine, silent) {
        var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        marker = state.src.charCodeAt(pos++);
        if (marker !== 0x2A && marker !== 0x2D && marker !== 0x5F) return false;
        cnt = 1;
        while(pos < max){
            ch = state.src.charCodeAt(pos++);
            if (ch !== marker && !$7486e013b11c48f5$require$isSpace(ch)) return false;
            if (ch === marker) cnt++;
        }
        if (cnt < 3) return false;
        if (silent) return true;
        state.line = startLine + 1;
        token = state.push('hr', 'hr', 0);
        token.map = [
            startLine,
            state.line
        ];
        token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
        return true;
    };
});
parcelRegister("bFPxW", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $87fb82138ea80db7$require$isSpace = $lKlAe.isSpace;
    function $87fb82138ea80db7$var$skipBulletListMarker(state, startLine) {
        var marker, pos, max, ch;
        pos = state.bMarks[startLine] + state.tShift[startLine];
        max = state.eMarks[startLine];
        marker = state.src.charCodeAt(pos++);
        if (marker !== 0x2A && marker !== 0x2D && marker !== 0x2B) return -1;
        if (pos < max) {
            ch = state.src.charCodeAt(pos);
            if (!$87fb82138ea80db7$require$isSpace(ch)) return -1;
        }
        return pos;
    }
    function $87fb82138ea80db7$var$skipOrderedListMarker(state, startLine) {
        var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
        if (pos + 1 >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch < 0x30 || ch > 0x39) return -1;
        for(;;){
            if (pos >= max) return -1;
            ch = state.src.charCodeAt(pos++);
            if (ch >= 0x30 && ch <= 0x39) {
                if (pos - start >= 10) return -1;
                continue;
            }
            if (ch === 0x29 || ch === 0x2e) break;
            return -1;
        }
        if (pos < max) {
            ch = state.src.charCodeAt(pos);
            if (!$87fb82138ea80db7$require$isSpace(ch)) return -1;
        }
        return pos;
    }
    function $87fb82138ea80db7$var$markTightParagraphs(state, idx) {
        var i, l, level = state.level + 2;
        for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
            state.tokens[i + 2].hidden = true;
            state.tokens[i].hidden = true;
            i += 2;
        }
    }
    module.exports = function list(state, startLine, endLine, silent) {
        var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
        if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
        if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
        if (silent && state.parentType === 'paragraph') {
            if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
        }
        if ((posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine)) >= 0) {
            isOrdered = true;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
            markerValue = Number(state.src.slice(start, posAfterMarker - 1));
            if (isTerminatingParagraph && markerValue !== 1) return false;
        } else if ((posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
        else return false;
        if (isTerminatingParagraph) {
            if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
        }
        if (silent) return true;
        markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
        listTokIdx = state.tokens.length;
        if (isOrdered) {
            token = state.push('ordered_list_open', 'ol', 1);
            if (markerValue !== 1) token.attrs = [
                [
                    'start',
                    markerValue
                ]
            ];
        } else token = state.push('bullet_list_open', 'ul', 1);
        token.map = listLines = [
            nextLine,
            0
        ];
        token.markup = String.fromCharCode(markerCharCode);
        prevEmptyEnd = false;
        terminatorRules = state.md.block.ruler.getRules('list');
        oldParentType = state.parentType;
        state.parentType = 'list';
        while(nextLine < endLine){
            pos = posAfterMarker;
            max = state.eMarks[nextLine];
            initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
                else if (ch === 0x20) offset++;
                else break;
                pos++;
            }
            contentStart = pos;
            if (contentStart >= max) indentAfterMarker = 1;
            else indentAfterMarker = offset - initial;
            if (indentAfterMarker > 4) indentAfterMarker = 1;
            indent = initial + indentAfterMarker;
            token = state.push('list_item_open', 'li', 1);
            token.markup = String.fromCharCode(markerCharCode);
            token.map = itemLines = [
                nextLine,
                0
            ];
            if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
            oldTight = state.tight;
            oldTShift = state.tShift[nextLine];
            oldSCount = state.sCount[nextLine];
            oldListIndent = state.listIndent;
            state.listIndent = state.blkIndent;
            state.blkIndent = indent;
            state.tight = true;
            state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
            state.sCount[nextLine] = offset;
            if (contentStart >= max && state.isEmpty(nextLine + 1)) state.line = Math.min(state.line + 2, endLine);
            else state.md.block.tokenize(state, nextLine, endLine, true);
            if (!state.tight || prevEmptyEnd) tight = false;
            prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
            state.blkIndent = state.listIndent;
            state.listIndent = oldListIndent;
            state.tShift[nextLine] = oldTShift;
            state.sCount[nextLine] = oldSCount;
            state.tight = oldTight;
            token = state.push('list_item_close', 'li', -1);
            token.markup = String.fromCharCode(markerCharCode);
            nextLine = state.line;
            itemLines[1] = nextLine;
            if (nextLine >= endLine) break;
            if (state.sCount[nextLine] < state.blkIndent) break;
            if (state.sCount[nextLine] - state.blkIndent >= 4) break;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
            if (isOrdered) {
                posAfterMarker = $87fb82138ea80db7$var$skipOrderedListMarker(state, nextLine);
                if (posAfterMarker < 0) break;
                start = state.bMarks[nextLine] + state.tShift[nextLine];
            } else {
                posAfterMarker = $87fb82138ea80db7$var$skipBulletListMarker(state, nextLine);
                if (posAfterMarker < 0) break;
            }
            if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
        }
        if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
        else token = state.push('bullet_list_close', 'ul', -1);
        token.markup = String.fromCharCode(markerCharCode);
        listLines[1] = nextLine;
        state.line = nextLine;
        state.parentType = oldParentType;
        if (tight) $87fb82138ea80db7$var$markTightParagraphs(state, listTokIdx);
        return true;
    };
});
parcelRegister("6Cm2K", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $4d1764068d639a24$require$normalizeReference = $lKlAe.normalizeReference;
    var $lKlAe = parcelRequire("lKlAe");
    var $4d1764068d639a24$require$isSpace = $lKlAe.isSpace;
    module.exports = function reference(state, startLine, _endLine, silent) {
        var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        if (state.src.charCodeAt(pos) !== 0x5B) return false;
        while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D && state.src.charCodeAt(pos - 1) !== 0x5C) {
            if (pos + 1 === max) return false;
            if (state.src.charCodeAt(pos + 1) !== 0x3A) return false;
            break;
        }
        endLine = state.lineMax;
        terminatorRules = state.md.block.ruler.getRules('reference');
        oldParentType = state.parentType;
        state.parentType = 'reference';
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            if (state.sCount[nextLine] - state.blkIndent > 3) continue;
            if (state.sCount[nextLine] < 0) continue;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
        str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
        max = str.length;
        for(pos = 1; pos < max; pos++){
            ch = str.charCodeAt(pos);
            if (ch === 0x5B) return false;
            else if (ch === 0x5D) {
                labelEnd = pos;
                break;
            } else if (ch === 0x0A) lines++;
            else if (ch === 0x5C) {
                pos++;
                if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
            }
        }
        if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A) return false;
        for(pos = labelEnd + 2; pos < max; pos++){
            ch = str.charCodeAt(pos);
            if (ch === 0x0A) lines++;
            else if ($4d1764068d639a24$require$isSpace(ch)) ;
            else break;
        }
        res = state.md.helpers.parseLinkDestination(str, pos, max);
        if (!res.ok) return false;
        href = state.md.normalizeLink(res.str);
        if (!state.md.validateLink(href)) return false;
        pos = res.pos;
        lines += res.lines;
        destEndPos = pos;
        destEndLineNo = lines;
        start = pos;
        for(; pos < max; pos++){
            ch = str.charCodeAt(pos);
            if (ch === 0x0A) lines++;
            else if ($4d1764068d639a24$require$isSpace(ch)) ;
            else break;
        }
        res = state.md.helpers.parseLinkTitle(str, pos, max);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            lines += res.lines;
        } else {
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
        }
        while(pos < max){
            ch = str.charCodeAt(pos);
            if (!$4d1764068d639a24$require$isSpace(ch)) break;
            pos++;
        }
        if (pos < max && str.charCodeAt(pos) !== 0x0A) {
            if (title) {
                title = '';
                pos = destEndPos;
                lines = destEndLineNo;
                while(pos < max){
                    ch = str.charCodeAt(pos);
                    if (!$4d1764068d639a24$require$isSpace(ch)) break;
                    pos++;
                }
            }
        }
        if (pos < max && str.charCodeAt(pos) !== 0x0A) return false;
        label = $4d1764068d639a24$require$normalizeReference(str.slice(1, labelEnd));
        if (!label) return false;
        if (silent) return true;
        if (typeof state.env.references === 'undefined') state.env.references = {};
        if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
            title: title,
            href: href
        };
        state.parentType = oldParentType;
        state.line = startLine + lines + 1;
        return true;
    };
});
parcelRegister("3IX6c", function(module, exports) {
    'use strict';
    var $9Jgti = parcelRequire("9Jgti");
    var $1RRsU = parcelRequire("1RRsU");
    var $2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE = $1RRsU.HTML_OPEN_CLOSE_TAG_RE;
    var $2b6352f7d75b50f9$var$HTML_SEQUENCES = [
        [
            /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
            /<\/(script|pre|style|textarea)>/i,
            true
        ],
        [
            /^<!--/,
            /-->/,
            true
        ],
        [
            /^<\?/,
            /\?>/,
            true
        ],
        [
            /^<![A-Z]/,
            />/,
            true
        ],
        [
            /^<!\[CDATA\[/,
            /\]\]>/,
            true
        ],
        [
            new RegExp('^</?(' + $9Jgti.join('|') + ')(?=(\\s|/?>|$))', 'i'),
            /^$/,
            true
        ],
        [
            new RegExp($2b6352f7d75b50f9$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
            /^$/,
            false
        ]
    ];
    module.exports = function html_block(state, startLine, endLine, silent) {
        var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        if (!state.md.options.html) return false;
        if (state.src.charCodeAt(pos) !== 0x3C) return false;
        lineText = state.src.slice(pos, max);
        for(i = 0; i < $2b6352f7d75b50f9$var$HTML_SEQUENCES.length; i++){
            if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][0].test(lineText)) break;
        }
        if (i === $2b6352f7d75b50f9$var$HTML_SEQUENCES.length) return false;
        if (silent) return $2b6352f7d75b50f9$var$HTML_SEQUENCES[i][2];
        nextLine = startLine + 1;
        if (!$2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
            if (state.sCount[nextLine] < state.blkIndent) break;
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            lineText = state.src.slice(pos, max);
            if ($2b6352f7d75b50f9$var$HTML_SEQUENCES[i][1].test(lineText)) {
                if (lineText.length !== 0) nextLine++;
                break;
            }
        }
        state.line = nextLine;
        token = state.push('html_block', '', 0);
        token.map = [
            startLine,
            nextLine
        ];
        token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
        return true;
    };
});
parcelRegister("9Jgti", function(module, exports) {
    'use strict';
    module.exports = [
        'address',
        'article',
        'aside',
        'base',
        'basefont',
        'blockquote',
        'body',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hr',
        'html',
        'iframe',
        'legend',
        'li',
        'link',
        'main',
        'menu',
        'menuitem',
        'nav',
        'noframes',
        'ol',
        'optgroup',
        'option',
        'p',
        'param',
        'section',
        'source',
        'summary',
        'table',
        'tbody',
        'td',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul'
    ];
});
parcelRegister("1RRsU", function(module, exports) {
    $parcel$export(module.exports, "HTML_TAG_RE", ()=>$15c436cb9ae50f13$export$6db61d2c3a16e419, (v)=>$15c436cb9ae50f13$export$6db61d2c3a16e419 = v);
    $parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", ()=>$15c436cb9ae50f13$export$cd48660d06f74639, (v)=>$15c436cb9ae50f13$export$cd48660d06f74639 = v);
    var $15c436cb9ae50f13$export$6db61d2c3a16e419;
    var $15c436cb9ae50f13$export$cd48660d06f74639;
    'use strict';
    var $15c436cb9ae50f13$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
    var $15c436cb9ae50f13$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
    var $15c436cb9ae50f13$var$single_quoted = "'[^']*'";
    var $15c436cb9ae50f13$var$double_quoted = '"[^"]*"';
    var $15c436cb9ae50f13$var$attr_value = '(?:' + $15c436cb9ae50f13$var$unquoted + '|' + $15c436cb9ae50f13$var$single_quoted + '|' + $15c436cb9ae50f13$var$double_quoted + ')';
    var $15c436cb9ae50f13$var$attribute = '(?:\\s+' + $15c436cb9ae50f13$var$attr_name + '(?:\\s*=\\s*' + $15c436cb9ae50f13$var$attr_value + ')?)';
    var $15c436cb9ae50f13$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $15c436cb9ae50f13$var$attribute + '*\\s*\\/?>';
    var $15c436cb9ae50f13$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
    var $15c436cb9ae50f13$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
    var $15c436cb9ae50f13$var$processing = '<[?][\\s\\S]*?[?]>';
    var $15c436cb9ae50f13$var$declaration = '<![A-Z]+\\s+[^>]*>';
    var $15c436cb9ae50f13$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
    var $15c436cb9ae50f13$var$HTML_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + '|' + $15c436cb9ae50f13$var$comment + '|' + $15c436cb9ae50f13$var$processing + '|' + $15c436cb9ae50f13$var$declaration + '|' + $15c436cb9ae50f13$var$cdata + ')');
    var $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $15c436cb9ae50f13$var$open_tag + '|' + $15c436cb9ae50f13$var$close_tag + ')');
    $15c436cb9ae50f13$export$6db61d2c3a16e419 = $15c436cb9ae50f13$var$HTML_TAG_RE;
    $15c436cb9ae50f13$export$cd48660d06f74639 = $15c436cb9ae50f13$var$HTML_OPEN_CLOSE_TAG_RE;
});
parcelRegister("5VRwl", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $451bcab957a0998a$require$isSpace = $lKlAe.isSpace;
    module.exports = function heading(state, startLine, endLine, silent) {
        var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x23 || pos >= max) return false;
        level = 1;
        ch = state.src.charCodeAt(++pos);
        while(ch === 0x23 && pos < max && level <= 6){
            level++;
            ch = state.src.charCodeAt(++pos);
        }
        if (level > 6 || pos < max && !$451bcab957a0998a$require$isSpace(ch)) return false;
        if (silent) return true;
        max = state.skipSpacesBack(max, pos);
        tmp = state.skipCharsBack(max, 0x23, pos);
        if (tmp > pos && $451bcab957a0998a$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
        state.line = startLine + 1;
        token = state.push('heading_open', 'h' + String(level), 1);
        token.markup = '########'.slice(0, level);
        token.map = [
            startLine,
            state.line
        ];
        token = state.push('inline', '', 0);
        token.content = state.src.slice(pos, max).trim();
        token.map = [
            startLine,
            state.line
        ];
        token.children = [];
        token = state.push('heading_close', 'h' + String(level), -1);
        token.markup = '########'.slice(0, level);
        return true;
    };
});
parcelRegister("2v0Kv", function(module, exports) {
    'use strict';
    module.exports = function lheading(state, startLine, endLine) {
        var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        oldParentType = state.parentType;
        state.parentType = 'paragraph';
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            if (state.sCount[nextLine] - state.blkIndent > 3) continue;
            if (state.sCount[nextLine] >= state.blkIndent) {
                pos = state.bMarks[nextLine] + state.tShift[nextLine];
                max = state.eMarks[nextLine];
                if (pos < max) {
                    marker = state.src.charCodeAt(pos);
                    if (marker === 0x2D || marker === 0x3D) {
                        pos = state.skipChars(pos, marker);
                        pos = state.skipSpaces(pos);
                        if (pos >= max) {
                            level = marker === 0x3D ? 1 : 2;
                            break;
                        }
                    }
                }
            }
            if (state.sCount[nextLine] < 0) continue;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
        if (!level) return false;
        content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
        state.line = nextLine + 1;
        token = state.push('heading_open', 'h' + String(level), 1);
        token.markup = String.fromCharCode(marker);
        token.map = [
            startLine,
            state.line
        ];
        token = state.push('inline', '', 0);
        token.content = content;
        token.map = [
            startLine,
            state.line - 1
        ];
        token.children = [];
        token = state.push('heading_close', 'h' + String(level), -1);
        token.markup = String.fromCharCode(marker);
        state.parentType = oldParentType;
        return true;
    };
});
parcelRegister("d0isB", function(module, exports) {
    'use strict';
    module.exports = function paragraph(state, startLine, endLine) {
        var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
        oldParentType = state.parentType;
        state.parentType = 'paragraph';
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            if (state.sCount[nextLine] - state.blkIndent > 3) continue;
            if (state.sCount[nextLine] < 0) continue;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
        content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
        state.line = nextLine;
        token = state.push('paragraph_open', 'p', 1);
        token.map = [
            startLine,
            state.line
        ];
        token = state.push('inline', '', 0);
        token.content = content;
        token.map = [
            startLine,
            state.line
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        state.parentType = oldParentType;
        return true;
    };
});
parcelRegister("l865e", function(module, exports) {
    'use strict';
    var $jwpQf = parcelRequire("jwpQf");
    var $lKlAe = parcelRequire("lKlAe");
    var $f61f10562433da3b$require$isSpace = $lKlAe.isSpace;
    function $f61f10562433da3b$var$StateBlock(src, md, env, tokens) {
        var ch, s, start, pos, len, indent, offset, indent_found;
        this.src = src;
        this.md = md;
        this.env = env;
        this.tokens = tokens;
        this.bMarks = [];
        this.eMarks = [];
        this.tShift = [];
        this.sCount = [];
        this.bsCount = [];
        this.blkIndent = 0;
        this.line = 0;
        this.lineMax = 0;
        this.tight = false;
        this.ddIndent = -1;
        this.listIndent = -1;
        this.parentType = 'root';
        this.level = 0;
        this.result = '';
        s = this.src;
        indent_found = false;
        for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
            ch = s.charCodeAt(pos);
            if (!indent_found) {
                if ($f61f10562433da3b$require$isSpace(ch)) {
                    indent++;
                    if (ch === 0x09) offset += 4 - offset % 4;
                    else offset++;
                    continue;
                } else indent_found = true;
            }
            if (ch === 0x0A || pos === len - 1) {
                if (ch !== 0x0A) pos++;
                this.bMarks.push(start);
                this.eMarks.push(pos);
                this.tShift.push(indent);
                this.sCount.push(offset);
                this.bsCount.push(0);
                indent_found = false;
                indent = 0;
                offset = 0;
                start = pos + 1;
            }
        }
        this.bMarks.push(s.length);
        this.eMarks.push(s.length);
        this.tShift.push(0);
        this.sCount.push(0);
        this.bsCount.push(0);
        this.lineMax = this.bMarks.length - 1;
    }
    $f61f10562433da3b$var$StateBlock.prototype.push = function(type, tag, nesting) {
        var token = new $jwpQf(type, tag, nesting);
        token.block = true;
        if (nesting < 0) this.level--;
        token.level = this.level;
        if (nesting > 0) this.level++;
        this.tokens.push(token);
        return token;
    };
    $f61f10562433da3b$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
        return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
    };
    $f61f10562433da3b$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
        for(var max = this.lineMax; from < max; from++){
            if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
        }
        return from;
    };
    $f61f10562433da3b$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
        var ch;
        for(var max = this.src.length; pos < max; pos++){
            ch = this.src.charCodeAt(pos);
            if (!$f61f10562433da3b$require$isSpace(ch)) break;
        }
        return pos;
    };
    $f61f10562433da3b$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
        if (pos <= min) return pos;
        while(pos > min){
            if (!$f61f10562433da3b$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
        }
        return pos;
    };
    $f61f10562433da3b$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
        for(var max = this.src.length; pos < max; pos++){
            if (this.src.charCodeAt(pos) !== code) break;
        }
        return pos;
    };
    $f61f10562433da3b$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
        if (pos <= min) return pos;
        while(pos > min){
            if (code !== this.src.charCodeAt(--pos)) return pos + 1;
        }
        return pos;
    };
    $f61f10562433da3b$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
        var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
        if (begin >= end) return '';
        queue = new Array(end - begin);
        for(i = 0; line < end; line++, i++){
            lineIndent = 0;
            lineStart = first = this.bMarks[line];
            if (line + 1 < end || keepLastLF) last = this.eMarks[line] + 1;
            else last = this.eMarks[line];
            while(first < last && lineIndent < indent){
                ch = this.src.charCodeAt(first);
                if ($f61f10562433da3b$require$isSpace(ch)) {
                    if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                    else lineIndent++;
                } else if (first - lineStart < this.tShift[line]) lineIndent++;
                else break;
                first++;
            }
            if (lineIndent > indent) queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
            else queue[i] = this.src.slice(first, last);
        }
        return queue.join('');
    };
    $f61f10562433da3b$var$StateBlock.prototype.Token = $jwpQf;
    module.exports = $f61f10562433da3b$var$StateBlock;
});
parcelRegister("58y21", function(module, exports) {
    'use strict';
    var $3sin6 = parcelRequire("3sin6");
    var $3bd81911677b8252$var$_rules = [
        [
            'text',
            (parcelRequire("gc14M"))
        ],
        [
            'linkify',
            (parcelRequire("2aNBd"))
        ],
        [
            'newline',
            (parcelRequire("a490I"))
        ],
        [
            'escape',
            (parcelRequire("027TI"))
        ],
        [
            'backticks',
            (parcelRequire("27paT"))
        ],
        [
            'strikethrough',
            (parcelRequire("lBrF9")).tokenize
        ],
        [
            'emphasis',
            (parcelRequire("2MLmq")).tokenize
        ],
        [
            'link',
            (parcelRequire("frx2x"))
        ],
        [
            'image',
            (parcelRequire("iUeRh"))
        ],
        [
            'autolink',
            (parcelRequire("ktOwv"))
        ],
        [
            'html_inline',
            (parcelRequire("1jFGt"))
        ],
        [
            'entity',
            (parcelRequire("jd9ks"))
        ]
    ];
    var $3bd81911677b8252$var$_rules2 = [
        [
            'balance_pairs',
            (parcelRequire("ey6sy"))
        ],
        [
            'strikethrough',
            (parcelRequire("lBrF9")).postProcess
        ],
        [
            'emphasis',
            (parcelRequire("2MLmq")).postProcess
        ],
        [
            'fragments_join',
            (parcelRequire("hrHpd"))
        ]
    ];
    function $3bd81911677b8252$var$ParserInline() {
        var i;
        this.ruler = new $3sin6();
        for(i = 0; i < $3bd81911677b8252$var$_rules.length; i++)this.ruler.push($3bd81911677b8252$var$_rules[i][0], $3bd81911677b8252$var$_rules[i][1]);
        this.ruler2 = new $3sin6();
        for(i = 0; i < $3bd81911677b8252$var$_rules2.length; i++)this.ruler2.push($3bd81911677b8252$var$_rules2[i][0], $3bd81911677b8252$var$_rules2[i][1]);
    }
    $3bd81911677b8252$var$ParserInline.prototype.skipToken = function(state) {
        var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
        if (typeof cache[pos] !== 'undefined') {
            state.pos = cache[pos];
            return;
        }
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            state.level++;
            ok = rules[i](state, true);
            state.level--;
            if (ok) {
                if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        else state.pos = state.posMax;
        if (!ok) state.pos++;
        cache[pos] = state.pos;
    };
    $3bd81911677b8252$var$ParserInline.prototype.tokenize = function(state) {
        var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
        while(state.pos < end){
            prevPos = state.pos;
            if (state.level < maxNesting) for(i = 0; i < len; i++){
                ok = rules[i](state, false);
                if (ok) {
                    if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                    break;
                }
            }
            if (ok) {
                if (state.pos >= end) break;
                continue;
            }
            state.pending += state.src[state.pos++];
        }
        if (state.pending) state.pushPending();
    };
    $3bd81911677b8252$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
        var i, rules, len;
        var state = new this.State(str, md, env, outTokens);
        this.tokenize(state);
        rules = this.ruler2.getRules('');
        len = rules.length;
        for(i = 0; i < len; i++)rules[i](state);
    };
    $3bd81911677b8252$var$ParserInline.prototype.State = (parcelRequire("82i7L"));
    module.exports = $3bd81911677b8252$var$ParserInline;
});
parcelRegister("gc14M", function(module, exports) {
    'use strict';
    function $bc9e9a00ea13b29d$var$isTerminatorChar(ch) {
        switch(ch){
            case 0x0A:
            case 0x21:
            case 0x23:
            case 0x24:
            case 0x25:
            case 0x26:
            case 0x2A:
            case 0x2B:
            case 0x2D:
            case 0x3A:
            case 0x3C:
            case 0x3D:
            case 0x3E:
            case 0x40:
            case 0x5B:
            case 0x5C:
            case 0x5D:
            case 0x5E:
            case 0x5F:
            case 0x60:
            case 0x7B:
            case 0x7D:
            case 0x7E:
                return true;
            default:
                return false;
        }
    }
    module.exports = function text(state, silent) {
        var pos = state.pos;
        while(pos < state.posMax && !$bc9e9a00ea13b29d$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
        if (pos === state.pos) return false;
        if (!silent) state.pending += state.src.slice(state.pos, pos);
        state.pos = pos;
        return true;
    };
});
parcelRegister("2aNBd", function(module, exports) {
    'use strict';
    var $1952fd4ef50e3f47$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
    module.exports = function linkify(state, silent) {
        var pos, max, match, proto, link, url, fullUrl, token;
        if (!state.md.options.linkify) return false;
        if (state.linkLevel > 0) return false;
        pos = state.pos;
        max = state.posMax;
        if (pos + 3 > max) return false;
        if (state.src.charCodeAt(pos) !== 0x3A) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x2F) return false;
        if (state.src.charCodeAt(pos + 2) !== 0x2F) return false;
        match = state.pending.match($1952fd4ef50e3f47$var$SCHEME_RE);
        if (!match) return false;
        proto = match[1];
        link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
        if (!link) return false;
        url = link.url;
        if (url.length <= proto.length) return false;
        url = url.replace(/\*+$/, '');
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            state.pending = state.pending.slice(0, -proto.length);
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'linkify';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'linkify';
            token.info = 'auto';
        }
        state.pos += url.length - proto.length;
        return true;
    };
});
parcelRegister("a490I", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $754144646e41a199$require$isSpace = $lKlAe.isSpace;
    module.exports = function newline(state, silent) {
        var pmax, max, ws, pos = state.pos;
        if (state.src.charCodeAt(pos) !== 0x0A) return false;
        pmax = state.pending.length - 1;
        max = state.posMax;
        if (!silent) {
            if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
                if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                    ws = pmax - 1;
                    while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                    state.pending = state.pending.slice(0, ws);
                    state.push('hardbreak', 'br', 0);
                } else {
                    state.pending = state.pending.slice(0, -1);
                    state.push('softbreak', 'br', 0);
                }
            } else state.push('softbreak', 'br', 0);
        }
        pos++;
        while(pos < max && $754144646e41a199$require$isSpace(state.src.charCodeAt(pos)))pos++;
        state.pos = pos;
        return true;
    };
});
parcelRegister("027TI", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $006650534e77ff18$require$isSpace = $lKlAe.isSpace;
    var $006650534e77ff18$var$ESCAPED = [];
    for(var $006650534e77ff18$var$i = 0; $006650534e77ff18$var$i < 256; $006650534e77ff18$var$i++)$006650534e77ff18$var$ESCAPED.push(0);
    '\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
        $006650534e77ff18$var$ESCAPED[ch.charCodeAt(0)] = 1;
    });
    module.exports = function escape(state, silent) {
        var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
        if (state.src.charCodeAt(pos) !== 0x5C) return false;
        pos++;
        if (pos >= max) return false;
        ch1 = state.src.charCodeAt(pos);
        if (ch1 === 0x0A) {
            if (!silent) state.push('hardbreak', 'br', 0);
            pos++;
            while(pos < max){
                ch1 = state.src.charCodeAt(pos);
                if (!$006650534e77ff18$require$isSpace(ch1)) break;
                pos++;
            }
            state.pos = pos;
            return true;
        }
        escapedStr = state.src[pos];
        if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
            ch2 = state.src.charCodeAt(pos + 1);
            if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
                escapedStr += state.src[pos + 1];
                pos++;
            }
        }
        origStr = '\\' + escapedStr;
        if (!silent) {
            token = state.push('text_special', '', 0);
            if (ch1 < 256 && $006650534e77ff18$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
            else token.content = origStr;
            token.markup = origStr;
            token.info = 'escape';
        }
        state.pos = pos + 1;
        return true;
    };
});
parcelRegister("27paT", function(module, exports) {
    'use strict';
    module.exports = function backtick(state, silent) {
        var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
        if (ch !== 0x60) return false;
        start = pos;
        pos++;
        max = state.posMax;
        while(pos < max && state.src.charCodeAt(pos) === 0x60)pos++;
        marker = state.src.slice(start, pos);
        openerLength = marker.length;
        if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
            if (!silent) state.pending += marker;
            state.pos += openerLength;
            return true;
        }
        matchEnd = pos;
        while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
            matchEnd = matchStart + 1;
            while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60)matchEnd++;
            closerLength = matchEnd - matchStart;
            if (closerLength === openerLength) {
                if (!silent) {
                    token = state.push('code_inline', 'code', 0);
                    token.markup = marker;
                    token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
                }
                state.pos = matchEnd;
                return true;
            }
            state.backticks[closerLength] = matchStart;
        }
        state.backticksScanned = true;
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    };
});
parcelRegister("lBrF9", function(module, exports) {
    $parcel$export(module.exports, "tokenize", ()=>$fba282ec8c4eab24$export$660b2ee2d4fb4eff, (v)=>$fba282ec8c4eab24$export$660b2ee2d4fb4eff = v);
    $parcel$export(module.exports, "postProcess", ()=>$fba282ec8c4eab24$export$7b804a0e0ce836d9, (v)=>$fba282ec8c4eab24$export$7b804a0e0ce836d9 = v);
    var $fba282ec8c4eab24$export$660b2ee2d4fb4eff;
    var $fba282ec8c4eab24$export$7b804a0e0ce836d9;
    'use strict';
    $fba282ec8c4eab24$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
        var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
        if (silent) return false;
        if (marker !== 0x7E) return false;
        scanned = state.scanDelims(state.pos, true);
        len = scanned.length;
        ch = String.fromCharCode(marker);
        if (len < 2) return false;
        if (len % 2) {
            token = state.push('text', '', 0);
            token.content = ch;
            len--;
        }
        for(i = 0; i < len; i += 2){
            token = state.push('text', '', 0);
            token.content = ch + ch;
            state.delimiters.push({
                marker: marker,
                length: 0,
                token: state.tokens.length - 1,
                end: -1,
                open: scanned.can_open,
                close: scanned.can_close
            });
        }
        state.pos += scanned.length;
        return true;
    };
    function $fba282ec8c4eab24$var$postProcess(state, delimiters) {
        var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
        for(i = 0; i < max; i++){
            startDelim = delimiters[i];
            if (startDelim.marker !== 0x7E) continue;
            if (startDelim.end === -1) continue;
            endDelim = delimiters[startDelim.end];
            token = state.tokens[startDelim.token];
            token.type = 's_open';
            token.tag = 's';
            token.nesting = 1;
            token.markup = '~~';
            token.content = '';
            token = state.tokens[endDelim.token];
            token.type = 's_close';
            token.tag = 's';
            token.nesting = -1;
            token.markup = '~~';
            token.content = '';
            if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
        }
        while(loneMarkers.length){
            i = loneMarkers.pop();
            j = i + 1;
            while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
            j--;
            if (i !== j) {
                token = state.tokens[j];
                state.tokens[j] = state.tokens[i];
                state.tokens[i] = token;
            }
        }
    }
    $fba282ec8c4eab24$export$7b804a0e0ce836d9 = function strikethrough(state) {
        var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
        $fba282ec8c4eab24$var$postProcess(state, state.delimiters);
        for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $fba282ec8c4eab24$var$postProcess(state, tokens_meta[curr].delimiters);
    };
});
parcelRegister("2MLmq", function(module, exports) {
    $parcel$export(module.exports, "tokenize", ()=>$2074cd535103ea35$export$660b2ee2d4fb4eff, (v)=>$2074cd535103ea35$export$660b2ee2d4fb4eff = v);
    $parcel$export(module.exports, "postProcess", ()=>$2074cd535103ea35$export$7b804a0e0ce836d9, (v)=>$2074cd535103ea35$export$7b804a0e0ce836d9 = v);
    var $2074cd535103ea35$export$660b2ee2d4fb4eff;
    var $2074cd535103ea35$export$7b804a0e0ce836d9;
    'use strict';
    $2074cd535103ea35$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
        var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
        if (silent) return false;
        if (marker !== 0x5F && marker !== 0x2A) return false;
        scanned = state.scanDelims(state.pos, marker === 0x2A);
        for(i = 0; i < scanned.length; i++){
            token = state.push('text', '', 0);
            token.content = String.fromCharCode(marker);
            state.delimiters.push({
                marker: marker,
                length: scanned.length,
                token: state.tokens.length - 1,
                end: -1,
                open: scanned.can_open,
                close: scanned.can_close
            });
        }
        state.pos += scanned.length;
        return true;
    };
    function $2074cd535103ea35$var$postProcess(state, delimiters) {
        var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
        for(i = max - 1; i >= 0; i--){
            startDelim = delimiters[i];
            if (startDelim.marker !== 0x5F && startDelim.marker !== 0x2A) continue;
            if (startDelim.end === -1) continue;
            endDelim = delimiters[startDelim.end];
            isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && delimiters[startDelim.end + 1].token === endDelim.token + 1;
            ch = String.fromCharCode(startDelim.marker);
            token = state.tokens[startDelim.token];
            token.type = isStrong ? 'strong_open' : 'em_open';
            token.tag = isStrong ? 'strong' : 'em';
            token.nesting = 1;
            token.markup = isStrong ? ch + ch : ch;
            token.content = '';
            token = state.tokens[endDelim.token];
            token.type = isStrong ? 'strong_close' : 'em_close';
            token.tag = isStrong ? 'strong' : 'em';
            token.nesting = -1;
            token.markup = isStrong ? ch + ch : ch;
            token.content = '';
            if (isStrong) {
                state.tokens[delimiters[i - 1].token].content = '';
                state.tokens[delimiters[startDelim.end + 1].token].content = '';
                i--;
            }
        }
    }
    $2074cd535103ea35$export$7b804a0e0ce836d9 = function emphasis(state) {
        var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
        $2074cd535103ea35$var$postProcess(state, state.delimiters);
        for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2074cd535103ea35$var$postProcess(state, tokens_meta[curr].delimiters);
    };
});
parcelRegister("frx2x", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $b3e301ae0b1788b5$require$normalizeReference = $lKlAe.normalizeReference;
    var $lKlAe = parcelRequire("lKlAe");
    var $b3e301ae0b1788b5$require$isSpace = $lKlAe.isSpace;
    module.exports = function link(state, silent) {
        var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
        if (state.src.charCodeAt(state.pos) !== 0x5B) return false;
        labelStart = state.pos + 1;
        labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
        if (labelEnd < 0) return false;
        pos = labelEnd + 1;
        if (pos < max && state.src.charCodeAt(pos) === 0x28) {
            parseReference = false;
            pos++;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
            }
            if (pos >= max) return false;
            start = pos;
            res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
            if (res.ok) {
                href = state.md.normalizeLink(res.str);
                if (state.md.validateLink(href)) pos = res.pos;
                else href = '';
                start = pos;
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                }
                res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
                if (pos < max && start !== pos && res.ok) {
                    title = res.str;
                    pos = res.pos;
                    for(; pos < max; pos++){
                        code = state.src.charCodeAt(pos);
                        if (!$b3e301ae0b1788b5$require$isSpace(code) && code !== 0x0A) break;
                    }
                }
            }
            if (pos >= max || state.src.charCodeAt(pos) !== 0x29) parseReference = true;
            pos++;
        }
        if (parseReference) {
            if (typeof state.env.references === 'undefined') return false;
            if (pos < max && state.src.charCodeAt(pos) === 0x5B) {
                start = pos + 1;
                pos = state.md.helpers.parseLinkLabel(state, pos);
                if (pos >= 0) label = state.src.slice(start, pos++);
                else pos = labelEnd + 1;
            } else pos = labelEnd + 1;
            if (!label) label = state.src.slice(labelStart, labelEnd);
            ref = state.env.references[$b3e301ae0b1788b5$require$normalizeReference(label)];
            if (!ref) {
                state.pos = oldPos;
                return false;
            }
            href = ref.href;
            title = ref.title;
        }
        if (!silent) {
            state.pos = labelStart;
            state.posMax = labelEnd;
            token = state.push('link_open', 'a', 1);
            token.attrs = attrs = [
                [
                    'href',
                    href
                ]
            ];
            if (title) attrs.push([
                'title',
                title
            ]);
            state.linkLevel++;
            state.md.inline.tokenize(state);
            state.linkLevel--;
            token = state.push('link_close', 'a', -1);
        }
        state.pos = pos;
        state.posMax = max;
        return true;
    };
});
parcelRegister("iUeRh", function(module, exports) {
    'use strict';
    var $lKlAe = parcelRequire("lKlAe");
    var $dc38fb80f8b4f166$require$normalizeReference = $lKlAe.normalizeReference;
    var $lKlAe = parcelRequire("lKlAe");
    var $dc38fb80f8b4f166$require$isSpace = $lKlAe.isSpace;
    module.exports = function image(state, silent) {
        var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
        if (state.src.charCodeAt(state.pos) !== 0x21) return false;
        if (state.src.charCodeAt(state.pos + 1) !== 0x5B) return false;
        labelStart = state.pos + 2;
        labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
        if (labelEnd < 0) return false;
        pos = labelEnd + 1;
        if (pos < max && state.src.charCodeAt(pos) === 0x28) {
            pos++;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
            if (pos >= max) return false;
            start = pos;
            res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
            if (res.ok) {
                href = state.md.normalizeLink(res.str);
                if (state.md.validateLink(href)) pos = res.pos;
                else href = '';
            }
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
            }
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$dc38fb80f8b4f166$require$isSpace(code) && code !== 0x0A) break;
                }
            } else title = '';
            if (pos >= max || state.src.charCodeAt(pos) !== 0x29) {
                state.pos = oldPos;
                return false;
            }
            pos++;
        } else {
            if (typeof state.env.references === 'undefined') return false;
            if (pos < max && state.src.charCodeAt(pos) === 0x5B) {
                start = pos + 1;
                pos = state.md.helpers.parseLinkLabel(state, pos);
                if (pos >= 0) label = state.src.slice(start, pos++);
                else pos = labelEnd + 1;
            } else pos = labelEnd + 1;
            if (!label) label = state.src.slice(labelStart, labelEnd);
            ref = state.env.references[$dc38fb80f8b4f166$require$normalizeReference(label)];
            if (!ref) {
                state.pos = oldPos;
                return false;
            }
            href = ref.href;
            title = ref.title;
        }
        if (!silent) {
            content = state.src.slice(labelStart, labelEnd);
            state.md.inline.parse(content, state.md, state.env, tokens = []);
            token = state.push('image', 'img', 0);
            token.attrs = attrs = [
                [
                    'src',
                    href
                ],
                [
                    'alt',
                    ''
                ]
            ];
            token.children = tokens;
            token.content = content;
            if (title) attrs.push([
                'title',
                title
            ]);
        }
        state.pos = pos;
        state.posMax = max;
        return true;
    };
});
parcelRegister("ktOwv", function(module, exports) {
    'use strict';
    var $ee8db4fa9cfd6224$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
    var $ee8db4fa9cfd6224$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
    module.exports = function autolink(state, silent) {
        var url, fullUrl, token, ch, start, max, pos = state.pos;
        if (state.src.charCodeAt(pos) !== 0x3C) return false;
        start = state.pos;
        max = state.posMax;
        for(;;){
            if (++pos >= max) return false;
            ch = state.src.charCodeAt(pos);
            if (ch === 0x3C) return false;
            if (ch === 0x3E) break;
        }
        url = state.src.slice(start + 1, pos);
        if ($ee8db4fa9cfd6224$var$AUTOLINK_RE.test(url)) {
            fullUrl = state.md.normalizeLink(url);
            if (!state.md.validateLink(fullUrl)) return false;
            if (!silent) {
                token = state.push('link_open', 'a', 1);
                token.attrs = [
                    [
                        'href',
                        fullUrl
                    ]
                ];
                token.markup = 'autolink';
                token.info = 'auto';
                token = state.push('text', '', 0);
                token.content = state.md.normalizeLinkText(url);
                token = state.push('link_close', 'a', -1);
                token.markup = 'autolink';
                token.info = 'auto';
            }
            state.pos += url.length + 2;
            return true;
        }
        if ($ee8db4fa9cfd6224$var$EMAIL_RE.test(url)) {
            fullUrl = state.md.normalizeLink('mailto:' + url);
            if (!state.md.validateLink(fullUrl)) return false;
            if (!silent) {
                token = state.push('link_open', 'a', 1);
                token.attrs = [
                    [
                        'href',
                        fullUrl
                    ]
                ];
                token.markup = 'autolink';
                token.info = 'auto';
                token = state.push('text', '', 0);
                token.content = state.md.normalizeLinkText(url);
                token = state.push('link_close', 'a', -1);
                token.markup = 'autolink';
                token.info = 'auto';
            }
            state.pos += url.length + 2;
            return true;
        }
        return false;
    };
});
parcelRegister("1jFGt", function(module, exports) {
    'use strict';
    var $1RRsU = parcelRequire("1RRsU");
    var $0f57e66455279f49$require$HTML_TAG_RE = $1RRsU.HTML_TAG_RE;
    function $0f57e66455279f49$var$isLinkOpen(str) {
        return /^<a[>\s]/i.test(str);
    }
    function $0f57e66455279f49$var$isLinkClose(str) {
        return /^<\/a\s*>/i.test(str);
    }
    function $0f57e66455279f49$var$isLetter(ch) {
        var lc = ch | 0x20;
        return lc >= 0x61 && lc <= 0x7a;
    }
    module.exports = function html_inline(state, silent) {
        var ch, match, max, token, pos = state.pos;
        if (!state.md.options.html) return false;
        max = state.posMax;
        if (state.src.charCodeAt(pos) !== 0x3C || pos + 2 >= max) return false;
        ch = state.src.charCodeAt(pos + 1);
        if (ch !== 0x21 && ch !== 0x3F && ch !== 0x2F && !$0f57e66455279f49$var$isLetter(ch)) return false;
        match = state.src.slice(pos).match($0f57e66455279f49$require$HTML_TAG_RE);
        if (!match) return false;
        if (!silent) {
            token = state.push('html_inline', '', 0);
            token.content = match[0];
            if ($0f57e66455279f49$var$isLinkOpen(token.content)) state.linkLevel++;
            if ($0f57e66455279f49$var$isLinkClose(token.content)) state.linkLevel--;
        }
        state.pos += match[0].length;
        return true;
    };
});
parcelRegister("jd9ks", function(module, exports) {
    'use strict';
    var $7MxGI = parcelRequire("7MxGI");
    var $lKlAe = parcelRequire("lKlAe");
    var $dfc677c78d4d441f$require$has = $lKlAe.has;
    var $lKlAe = parcelRequire("lKlAe");
    var $dfc677c78d4d441f$require$isValidEntityCode = $lKlAe.isValidEntityCode;
    var $lKlAe = parcelRequire("lKlAe");
    var $dfc677c78d4d441f$require$fromCodePoint = $lKlAe.fromCodePoint;
    var $dfc677c78d4d441f$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
    var $dfc677c78d4d441f$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
    module.exports = function entity(state, silent) {
        var ch, code, match, token, pos = state.pos, max = state.posMax;
        if (state.src.charCodeAt(pos) !== 0x26) return false;
        if (pos + 1 >= max) return false;
        ch = state.src.charCodeAt(pos + 1);
        if (ch === 0x23) {
            match = state.src.slice(pos).match($dfc677c78d4d441f$var$DIGITAL_RE);
            if (match) {
                if (!silent) {
                    code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                    token = state.push('text_special', '', 0);
                    token.content = $dfc677c78d4d441f$require$isValidEntityCode(code) ? $dfc677c78d4d441f$require$fromCodePoint(code) : $dfc677c78d4d441f$require$fromCodePoint(0xFFFD);
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        } else {
            match = state.src.slice(pos).match($dfc677c78d4d441f$var$NAMED_RE);
            if (match) {
                if ($dfc677c78d4d441f$require$has($7MxGI, match[1])) {
                    if (!silent) {
                        token = state.push('text_special', '', 0);
                        token.content = $7MxGI[match[1]];
                        token.markup = match[0];
                        token.info = 'entity';
                    }
                    state.pos += match[0].length;
                    return true;
                }
            }
        }
        return false;
    };
});
parcelRegister("ey6sy", function(module, exports) {
    'use strict';
    function $a979406325d16795$var$processDelimiters(delimiters) {
        var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
        if (!max) return;
        var headerIdx = 0;
        var lastTokenIdx = -2;
        var jumps = [];
        for(closerIdx = 0; closerIdx < max; closerIdx++){
            closer = delimiters[closerIdx];
            jumps.push(0);
            if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
            lastTokenIdx = closer.token;
            closer.length = closer.length || 0;
            if (!closer.close) continue;
            if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ];
            minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
            openerIdx = headerIdx - jumps[headerIdx] - 1;
            newMinOpenerIdx = openerIdx;
            for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
                opener = delimiters[openerIdx];
                if (opener.marker !== closer.marker) continue;
                if (opener.open && opener.end < 0) {
                    isOddMatch = false;
                    if (opener.close || closer.open) {
                        if ((opener.length + closer.length) % 3 === 0) {
                            if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                        }
                    }
                    if (!isOddMatch) {
                        lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                        jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                        jumps[openerIdx] = lastJump;
                        closer.open = false;
                        opener.end = closerIdx;
                        opener.close = false;
                        newMinOpenerIdx = -1;
                        lastTokenIdx = -2;
                        break;
                    }
                }
            }
            if (newMinOpenerIdx !== -1) openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
        }
    }
    module.exports = function link_pairs(state) {
        var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
        $a979406325d16795$var$processDelimiters(state.delimiters);
        for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a979406325d16795$var$processDelimiters(tokens_meta[curr].delimiters);
    };
});
parcelRegister("hrHpd", function(module, exports) {
    'use strict';
    module.exports = function fragments_join(state) {
        var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
        for(curr = last = 0; curr < max; curr++){
            if (tokens[curr].nesting < 0) level--;
            tokens[curr].level = level;
            if (tokens[curr].nesting > 0) level++;
            if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
            else {
                if (curr !== last) tokens[last] = tokens[curr];
                last++;
            }
        }
        if (curr !== last) tokens.length = last;
    };
});
parcelRegister("82i7L", function(module, exports) {
    'use strict';
    var $jwpQf = parcelRequire("jwpQf");
    var $lKlAe = parcelRequire("lKlAe");
    var $5d9c91befccde6a7$require$isWhiteSpace = $lKlAe.isWhiteSpace;
    var $lKlAe = parcelRequire("lKlAe");
    var $5d9c91befccde6a7$require$isPunctChar = $lKlAe.isPunctChar;
    var $lKlAe = parcelRequire("lKlAe");
    var $5d9c91befccde6a7$require$isMdAsciiPunct = $lKlAe.isMdAsciiPunct;
    function $5d9c91befccde6a7$var$StateInline(src, md, env, outTokens) {
        this.src = src;
        this.env = env;
        this.md = md;
        this.tokens = outTokens;
        this.tokens_meta = Array(outTokens.length);
        this.pos = 0;
        this.posMax = this.src.length;
        this.level = 0;
        this.pending = '';
        this.pendingLevel = 0;
        this.cache = {};
        this.delimiters = [];
        this._prev_delimiters = [];
        this.backticks = {};
        this.backticksScanned = false;
        this.linkLevel = 0;
    }
    $5d9c91befccde6a7$var$StateInline.prototype.pushPending = function() {
        var token = new $jwpQf('text', '', 0);
        token.content = this.pending;
        token.level = this.pendingLevel;
        this.tokens.push(token);
        this.pending = '';
        return token;
    };
    $5d9c91befccde6a7$var$StateInline.prototype.push = function(type, tag, nesting) {
        if (this.pending) this.pushPending();
        var token = new $jwpQf(type, tag, nesting);
        var token_meta = null;
        if (nesting < 0) {
            this.level--;
            this.delimiters = this._prev_delimiters.pop();
        }
        token.level = this.level;
        if (nesting > 0) {
            this.level++;
            this._prev_delimiters.push(this.delimiters);
            this.delimiters = [];
            token_meta = {
                delimiters: this.delimiters
            };
        }
        this.pendingLevel = this.level;
        this.tokens.push(token);
        this.tokens_meta.push(token_meta);
        return token;
    };
    $5d9c91befccde6a7$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
        var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
        lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
        while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
        count = pos - start;
        nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
        isLastPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(lastChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(lastChar));
        isNextPunctChar = $5d9c91befccde6a7$require$isMdAsciiPunct(nextChar) || $5d9c91befccde6a7$require$isPunctChar(String.fromCharCode(nextChar));
        isLastWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(lastChar);
        isNextWhiteSpace = $5d9c91befccde6a7$require$isWhiteSpace(nextChar);
        if (isNextWhiteSpace) left_flanking = false;
        else if (isNextPunctChar) {
            if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
        }
        if (isLastWhiteSpace) right_flanking = false;
        else if (isLastPunctChar) {
            if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
        }
        if (!canSplitWord) {
            can_open = left_flanking && (!right_flanking || isLastPunctChar);
            can_close = right_flanking && (!left_flanking || isNextPunctChar);
        } else {
            can_open = left_flanking;
            can_close = right_flanking;
        }
        return {
            can_open: can_open,
            can_close: can_close,
            length: count
        };
    };
    $5d9c91befccde6a7$var$StateInline.prototype.Token = $jwpQf;
    module.exports = $5d9c91befccde6a7$var$StateInline;
});
parcelRegister("43kHv", function(module, exports) {
    'use strict';
    function $2f377ffd6e81380f$var$assign(obj) {
        var sources = Array.prototype.slice.call(arguments, 1);
        sources.forEach(function(source) {
            if (!source) return;
            Object.keys(source).forEach(function(key) {
                obj[key] = source[key];
            });
        });
        return obj;
    }
    function $2f377ffd6e81380f$var$_class(obj) {
        return Object.prototype.toString.call(obj);
    }
    function $2f377ffd6e81380f$var$isString(obj) {
        return $2f377ffd6e81380f$var$_class(obj) === '[object String]';
    }
    function $2f377ffd6e81380f$var$isObject(obj) {
        return $2f377ffd6e81380f$var$_class(obj) === '[object Object]';
    }
    function $2f377ffd6e81380f$var$isRegExp(obj) {
        return $2f377ffd6e81380f$var$_class(obj) === '[object RegExp]';
    }
    function $2f377ffd6e81380f$var$isFunction(obj) {
        return $2f377ffd6e81380f$var$_class(obj) === '[object Function]';
    }
    function $2f377ffd6e81380f$var$escapeRE(str) {
        return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
    }
    var $2f377ffd6e81380f$var$defaultOptions = {
        fuzzyLink: true,
        fuzzyEmail: true,
        fuzzyIP: false
    };
    function $2f377ffd6e81380f$var$isOptionsObj(obj) {
        return Object.keys(obj || {}).reduce(function(acc, k) {
            return acc || $2f377ffd6e81380f$var$defaultOptions.hasOwnProperty(k);
        }, false);
    }
    var $2f377ffd6e81380f$var$defaultSchemas = {
        'http:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.http) self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
                if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
                return 0;
            }
        },
        'https:': 'http:',
        'ftp:': 'http:',
        '//': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.no_http) self.re.no_http = new RegExp('^' + self.re.src_auth + '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
                if (self.re.no_http.test(tail)) {
                    if (pos >= 3 && text[pos - 3] === ':') return 0;
                    if (pos >= 3 && text[pos - 3] === '/') return 0;
                    return tail.match(self.re.no_http)[0].length;
                }
                return 0;
            }
        },
        'mailto:': {
            validate: function(text, pos, self) {
                var tail = text.slice(pos);
                if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
                if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
                return 0;
            }
        }
    };
    var $2f377ffd6e81380f$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
    var $2f377ffd6e81380f$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
    function $2f377ffd6e81380f$var$resetScanCache(self) {
        self.__index__ = -1;
        self.__text_cache__ = '';
    }
    function $2f377ffd6e81380f$var$createValidator(re) {
        return function(text, pos) {
            var tail = text.slice(pos);
            if (re.test(tail)) return tail.match(re)[0].length;
            return 0;
        };
    }
    function $2f377ffd6e81380f$var$createNormalizer() {
        return function(match, self) {
            self.normalize(match);
        };
    }
    function $2f377ffd6e81380f$var$compile(self) {
        var re = self.re = (parcelRequire("5GUip"))(self.__opts__);
        var tlds = self.__tlds__.slice();
        self.onCompile();
        if (!self.__tlds_replaced__) tlds.push($2f377ffd6e81380f$var$tlds_2ch_src_re);
        tlds.push(re.src_xn);
        re.src_tlds = tlds.join('|');
        function untpl(tpl) {
            return tpl.replace('%TLDS%', re.src_tlds);
        }
        re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
        re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
        re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
        re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
        var aliases = [];
        self.__compiled__ = {};
        function schemaError(name, val) {
            throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
        }
        Object.keys(self.__schemas__).forEach(function(name) {
            var val = self.__schemas__[name];
            if (val === null) return;
            var compiled = {
                validate: null,
                link: null
            };
            self.__compiled__[name] = compiled;
            if ($2f377ffd6e81380f$var$isObject(val)) {
                if ($2f377ffd6e81380f$var$isRegExp(val.validate)) compiled.validate = $2f377ffd6e81380f$var$createValidator(val.validate);
                else if ($2f377ffd6e81380f$var$isFunction(val.validate)) compiled.validate = val.validate;
                else schemaError(name, val);
                if ($2f377ffd6e81380f$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
                else if (!val.normalize) compiled.normalize = $2f377ffd6e81380f$var$createNormalizer();
                else schemaError(name, val);
                return;
            }
            if ($2f377ffd6e81380f$var$isString(val)) {
                aliases.push(name);
                return;
            }
            schemaError(name, val);
        });
        aliases.forEach(function(alias) {
            if (!self.__compiled__[self.__schemas__[alias]]) return;
            self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
            self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
        });
        self.__compiled__[''] = {
            validate: null,
            normalize: $2f377ffd6e81380f$var$createNormalizer()
        };
        var slist = Object.keys(self.__compiled__).filter(function(name) {
            return name.length > 0 && self.__compiled__[name];
        }).map($2f377ffd6e81380f$var$escapeRE).join('|');
        self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
        self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
        self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
        self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
        $2f377ffd6e81380f$var$resetScanCache(self);
    }
    function $2f377ffd6e81380f$var$Match(self, shift) {
        var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
        this.schema = self.__schema__.toLowerCase();
        this.index = start + shift;
        this.lastIndex = end + shift;
        this.raw = text;
        this.text = text;
        this.url = text;
    }
    function $2f377ffd6e81380f$var$createMatch(self, shift) {
        var match = new $2f377ffd6e81380f$var$Match(self, shift);
        self.__compiled__[match.schema].normalize(match, self);
        return match;
    }
    function $2f377ffd6e81380f$var$LinkifyIt(schemas, options) {
        if (!(this instanceof $2f377ffd6e81380f$var$LinkifyIt)) return new $2f377ffd6e81380f$var$LinkifyIt(schemas, options);
        if (!options) {
            if ($2f377ffd6e81380f$var$isOptionsObj(schemas)) {
                options = schemas;
                schemas = {};
            }
        }
        this.__opts__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultOptions, options);
        this.__index__ = -1;
        this.__last_index__ = -1;
        this.__schema__ = '';
        this.__text_cache__ = '';
        this.__schemas__ = $2f377ffd6e81380f$var$assign({}, $2f377ffd6e81380f$var$defaultSchemas, schemas);
        this.__compiled__ = {};
        this.__tlds__ = $2f377ffd6e81380f$var$tlds_default;
        this.__tlds_replaced__ = false;
        this.re = {};
        $2f377ffd6e81380f$var$compile(this);
    }
    $2f377ffd6e81380f$var$LinkifyIt.prototype.add = function add(schema, definition) {
        this.__schemas__[schema] = definition;
        $2f377ffd6e81380f$var$compile(this);
        return this;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.set = function set(options) {
        this.__opts__ = $2f377ffd6e81380f$var$assign(this.__opts__, options);
        return this;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.test = function test(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return false;
        var m, ml, me, len, shift, next, re, tld_pos, at_pos;
        if (this.re.schema_test.test(text)) {
            re = this.re.schema_search;
            re.lastIndex = 0;
            while((m = re.exec(text)) !== null){
                len = this.testSchemaAt(text, m[2], re.lastIndex);
                if (len) {
                    this.__schema__ = m[2];
                    this.__index__ = m.index + m[1].length;
                    this.__last_index__ = m.index + m[0].length + len;
                    break;
                }
            }
        }
        if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
            tld_pos = text.search(this.re.host_fuzzy_test);
            if (tld_pos >= 0) {
                if (this.__index__ < 0 || tld_pos < this.__index__) {
                    if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                        shift = ml.index + ml[1].length;
                        if (this.__index__ < 0 || shift < this.__index__) {
                            this.__schema__ = '';
                            this.__index__ = shift;
                            this.__last_index__ = ml.index + ml[0].length;
                        }
                    }
                }
            }
        }
        if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
            at_pos = text.indexOf('@');
            if (at_pos >= 0) {
                if ((me = text.match(this.re.email_fuzzy)) !== null) {
                    shift = me.index + me[1].length;
                    next = me.index + me[0].length;
                    if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                        this.__schema__ = 'mailto:';
                        this.__index__ = shift;
                        this.__last_index__ = next;
                    }
                }
            }
        }
        return this.__index__ >= 0;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.pretest = function pretest(text) {
        return this.re.pretest.test(text);
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
        if (!this.__compiled__[schema.toLowerCase()]) return 0;
        return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.match = function match(text) {
        var shift = 0, result = [];
        if (this.__index__ >= 0 && this.__text_cache__ === text) {
            result.push($2f377ffd6e81380f$var$createMatch(this, shift));
            shift = this.__last_index__;
        }
        var tail = shift ? text.slice(shift) : text;
        while(this.test(tail)){
            result.push($2f377ffd6e81380f$var$createMatch(this, shift));
            tail = tail.slice(this.__last_index__);
            shift += this.__last_index__;
        }
        if (result.length) return result;
        return null;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
        this.__text_cache__ = text;
        this.__index__ = -1;
        if (!text.length) return null;
        var m = this.re.schema_at_start.exec(text);
        if (!m) return null;
        var len = this.testSchemaAt(text, m[2], m[0].length);
        if (!len) return null;
        this.__schema__ = m[2];
        this.__index__ = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        return $2f377ffd6e81380f$var$createMatch(this, 0);
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
        list = Array.isArray(list) ? list : [
            list
        ];
        if (!keepOld) {
            this.__tlds__ = list.slice();
            this.__tlds_replaced__ = true;
            $2f377ffd6e81380f$var$compile(this);
            return this;
        }
        this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
            return el !== arr[idx - 1];
        }).reverse();
        $2f377ffd6e81380f$var$compile(this);
        return this;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.normalize = function normalize(match) {
        if (!match.schema) match.url = 'http://' + match.url;
        if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
    };
    $2f377ffd6e81380f$var$LinkifyIt.prototype.onCompile = function onCompile() {};
    module.exports = $2f377ffd6e81380f$var$LinkifyIt;
});
parcelRegister("5GUip", function(module, exports) {
    'use strict';
    module.exports = function(opts) {
        var re = {};
        opts = opts || {};
        re.src_Any = (parcelRequire("b9ep3")).source;
        re.src_Cc = (parcelRequire("23ErL")).source;
        re.src_Z = (parcelRequire("oRY4m")).source;
        re.src_P = (parcelRequire("9bBmm")).source;
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join('|');
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join('|');
        var text_separators = '[><\uff5c]';
        re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
        re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
        re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
        re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
        re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + ';(?!' + re.src_ZCc + '|$)|' + '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
        re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
        re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
        re.src_domain_root = '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
        re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain + ')' + ')';
        re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
        re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
        re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
        re.tpl_link_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
        re.tpl_link_no_ip_fuzzy = '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
        return re;
    };
});
parcelRegister("8F4WT", function(module, exports) {
    $parcel$export(module.exports, "toUnicode", ()=>$64e5fdcb93eb2731$export$110c810e8727e62b);
    $parcel$export(module.exports, "toASCII", ()=>$64e5fdcb93eb2731$export$69111c4ea6e0c4a0);
    $parcel$export(module.exports, "default", ()=>$64e5fdcb93eb2731$export$2e2bcd8739ae039);
    'use strict';
    const $64e5fdcb93eb2731$var$maxInt = 2147483647;
    const $64e5fdcb93eb2731$var$base = 36;
    const $64e5fdcb93eb2731$var$tMin = 1;
    const $64e5fdcb93eb2731$var$tMax = 26;
    const $64e5fdcb93eb2731$var$skew = 38;
    const $64e5fdcb93eb2731$var$damp = 700;
    const $64e5fdcb93eb2731$var$initialBias = 72;
    const $64e5fdcb93eb2731$var$initialN = 128;
    const $64e5fdcb93eb2731$var$delimiter = '-';
    const $64e5fdcb93eb2731$var$regexPunycode = /^xn--/;
    const $64e5fdcb93eb2731$var$regexNonASCII = /[^\0-\x7F]/;
    const $64e5fdcb93eb2731$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g;
    const $64e5fdcb93eb2731$var$errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    };
    const $64e5fdcb93eb2731$var$baseMinusTMin = $64e5fdcb93eb2731$var$base - $64e5fdcb93eb2731$var$tMin;
    const $64e5fdcb93eb2731$var$floor = Math.floor;
    const $64e5fdcb93eb2731$var$stringFromCharCode = String.fromCharCode;
    function $64e5fdcb93eb2731$var$error(type) {
        throw new RangeError($64e5fdcb93eb2731$var$errors[type]);
    }
    function $64e5fdcb93eb2731$var$map(array, callback) {
        const result = [];
        let length = array.length;
        while(length--)result[length] = callback(array[length]);
        return result;
    }
    function $64e5fdcb93eb2731$var$mapDomain(domain, callback) {
        const parts = domain.split('@');
        let result = '';
        if (parts.length > 1) {
            result = parts[0] + '@';
            domain = parts[1];
        }
        domain = domain.replace($64e5fdcb93eb2731$var$regexSeparators, '\x2E');
        const labels = domain.split('.');
        const encoded = $64e5fdcb93eb2731$var$map(labels, callback).join('.');
        return result + encoded;
    }
    function $64e5fdcb93eb2731$export$c1700176c90f250f(string) {
        const output = [];
        let counter = 0;
        const length = string.length;
        while(counter < length){
            const value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                const extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    const $64e5fdcb93eb2731$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
    const $64e5fdcb93eb2731$var$basicToDigit = function(codePoint) {
        if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
        if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
        if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
        return $64e5fdcb93eb2731$var$base;
    };
    const $64e5fdcb93eb2731$var$digitToBasic = function(digit, flag) {
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    const $64e5fdcb93eb2731$var$adapt = function(delta, numPoints, firstTime) {
        let k = 0;
        delta = firstTime ? $64e5fdcb93eb2731$var$floor(delta / $64e5fdcb93eb2731$var$damp) : delta >> 1;
        delta += $64e5fdcb93eb2731$var$floor(delta / numPoints);
        for(; delta > $64e5fdcb93eb2731$var$baseMinusTMin * $64e5fdcb93eb2731$var$tMax >> 1; k += $64e5fdcb93eb2731$var$base)delta = $64e5fdcb93eb2731$var$floor(delta / $64e5fdcb93eb2731$var$baseMinusTMin);
        return $64e5fdcb93eb2731$var$floor(k + ($64e5fdcb93eb2731$var$baseMinusTMin + 1) * delta / (delta + $64e5fdcb93eb2731$var$skew));
    };
    const $64e5fdcb93eb2731$export$2f872c0f2117be69 = function(input) {
        const output = [];
        const inputLength = input.length;
        let i = 0;
        let n = $64e5fdcb93eb2731$var$initialN;
        let bias = $64e5fdcb93eb2731$var$initialBias;
        let basic = input.lastIndexOf($64e5fdcb93eb2731$var$delimiter);
        if (basic < 0) basic = 0;
        for(let j = 0; j < basic; ++j){
            if (input.charCodeAt(j) >= 0x80) $64e5fdcb93eb2731$var$error('not-basic');
            output.push(input.charCodeAt(j));
        }
        for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            const oldi = i;
            for(let w = 1, k = $64e5fdcb93eb2731$var$base;; k += $64e5fdcb93eb2731$var$base){
                if (index >= inputLength) $64e5fdcb93eb2731$var$error('invalid-input');
                const digit = $64e5fdcb93eb2731$var$basicToDigit(input.charCodeAt(index++));
                if (digit >= $64e5fdcb93eb2731$var$base) $64e5fdcb93eb2731$var$error('invalid-input');
                if (digit > $64e5fdcb93eb2731$var$floor(($64e5fdcb93eb2731$var$maxInt - i) / w)) $64e5fdcb93eb2731$var$error('overflow');
                i += digit * w;
                const t = k <= bias ? $64e5fdcb93eb2731$var$tMin : k >= bias + $64e5fdcb93eb2731$var$tMax ? $64e5fdcb93eb2731$var$tMax : k - bias;
                if (digit < t) break;
                const baseMinusT = $64e5fdcb93eb2731$var$base - t;
                if (w > $64e5fdcb93eb2731$var$floor($64e5fdcb93eb2731$var$maxInt / baseMinusT)) $64e5fdcb93eb2731$var$error('overflow');
                w *= baseMinusT;
            }
            const out = output.length + 1;
            bias = $64e5fdcb93eb2731$var$adapt(i - oldi, out, oldi == 0);
            if ($64e5fdcb93eb2731$var$floor(i / out) > $64e5fdcb93eb2731$var$maxInt - n) $64e5fdcb93eb2731$var$error('overflow');
            n += $64e5fdcb93eb2731$var$floor(i / out);
            i %= out;
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint(...output);
    };
    const $64e5fdcb93eb2731$export$c564cdbbe6da493 = function(input) {
        const output = [];
        input = $64e5fdcb93eb2731$export$c1700176c90f250f(input);
        const inputLength = input.length;
        let n = $64e5fdcb93eb2731$var$initialN;
        let delta = 0;
        let bias = $64e5fdcb93eb2731$var$initialBias;
        for (const currentValue of input)if (currentValue < 0x80) output.push($64e5fdcb93eb2731$var$stringFromCharCode(currentValue));
        const basicLength = output.length;
        let handledCPCount = basicLength;
        if (basicLength) output.push($64e5fdcb93eb2731$var$delimiter);
        while(handledCPCount < inputLength){
            let m = $64e5fdcb93eb2731$var$maxInt;
            for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
            const handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > $64e5fdcb93eb2731$var$floor(($64e5fdcb93eb2731$var$maxInt - delta) / handledCPCountPlusOne)) $64e5fdcb93eb2731$var$error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for (const currentValue of input){
                if (currentValue < n && ++delta > $64e5fdcb93eb2731$var$maxInt) $64e5fdcb93eb2731$var$error('overflow');
                if (currentValue === n) {
                    let q = delta;
                    for(let k = $64e5fdcb93eb2731$var$base;; k += $64e5fdcb93eb2731$var$base){
                        const t = k <= bias ? $64e5fdcb93eb2731$var$tMin : k >= bias + $64e5fdcb93eb2731$var$tMax ? $64e5fdcb93eb2731$var$tMax : k - bias;
                        if (q < t) break;
                        const qMinusT = q - t;
                        const baseMinusT = $64e5fdcb93eb2731$var$base - t;
                        output.push($64e5fdcb93eb2731$var$stringFromCharCode($64e5fdcb93eb2731$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = $64e5fdcb93eb2731$var$floor(qMinusT / baseMinusT);
                    }
                    output.push($64e5fdcb93eb2731$var$stringFromCharCode($64e5fdcb93eb2731$var$digitToBasic(q, 0)));
                    bias = $64e5fdcb93eb2731$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    };
    const $64e5fdcb93eb2731$export$110c810e8727e62b = function(input) {
        return $64e5fdcb93eb2731$var$mapDomain(input, function(string) {
            return $64e5fdcb93eb2731$var$regexPunycode.test(string) ? $64e5fdcb93eb2731$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
        });
    };
    const $64e5fdcb93eb2731$export$69111c4ea6e0c4a0 = function(input) {
        return $64e5fdcb93eb2731$var$mapDomain(input, function(string) {
            return $64e5fdcb93eb2731$var$regexNonASCII.test(string) ? 'xn--' + $64e5fdcb93eb2731$export$c564cdbbe6da493(string) : string;
        });
    };
    const $64e5fdcb93eb2731$var$punycode = {
        'version': '2.3.1',
        'ucs2': {
            'decode': $64e5fdcb93eb2731$export$c1700176c90f250f,
            'encode': $64e5fdcb93eb2731$export$f999239d9b149395
        },
        'decode': $64e5fdcb93eb2731$export$2f872c0f2117be69,
        'encode': $64e5fdcb93eb2731$export$c564cdbbe6da493,
        'toASCII': $64e5fdcb93eb2731$export$69111c4ea6e0c4a0,
        'toUnicode': $64e5fdcb93eb2731$export$110c810e8727e62b
    };
    var $64e5fdcb93eb2731$export$2e2bcd8739ae039 = $64e5fdcb93eb2731$var$punycode;
});
parcelRegister("gcpUf", function(module, exports) {
    'use strict';
    module.exports = {
        options: {
            html: false,
            xhtmlOut: false,
            breaks: false,
            langPrefix: 'language-',
            linkify: false,
            typographer: false,
            quotes: '\u201c\u201d\u2018\u2019',
            highlight: null,
            maxNesting: 100
        },
        components: {
            core: {},
            block: {},
            inline: {}
        }
    };
});
parcelRegister("hbvGf", function(module, exports) {
    'use strict';
    module.exports = {
        options: {
            html: false,
            xhtmlOut: false,
            breaks: false,
            langPrefix: 'language-',
            linkify: false,
            typographer: false,
            quotes: '\u201c\u201d\u2018\u2019',
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    'normalize',
                    'block',
                    'inline',
                    'text_join'
                ]
            },
            block: {
                rules: [
                    'paragraph'
                ]
            },
            inline: {
                rules: [
                    'text'
                ],
                rules2: [
                    'balance_pairs',
                    'fragments_join'
                ]
            }
        }
    };
});
parcelRegister("8Ubo6", function(module, exports) {
    'use strict';
    module.exports = {
        options: {
            html: true,
            xhtmlOut: true,
            breaks: false,
            langPrefix: 'language-',
            linkify: false,
            typographer: false,
            quotes: '\u201c\u201d\u2018\u2019',
            highlight: null,
            maxNesting: 20
        },
        components: {
            core: {
                rules: [
                    'normalize',
                    'block',
                    'inline',
                    'text_join'
                ]
            },
            block: {
                rules: [
                    'blockquote',
                    'code',
                    'fence',
                    'heading',
                    'hr',
                    'html_block',
                    'lheading',
                    'list',
                    'reference',
                    'paragraph'
                ]
            },
            inline: {
                rules: [
                    'autolink',
                    'backticks',
                    'emphasis',
                    'entity',
                    'escape',
                    'html_inline',
                    'image',
                    'link',
                    'newline',
                    'text'
                ],
                rules2: [
                    'balance_pairs',
                    'emphasis',
                    'fragments_join'
                ]
            }
        }
    };
});
parcelRegister("h4jau", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b58a68bc6bfddc85$export$2e2bcd8739ae039);
    function $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index) {
        const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
        if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
        else acc.push(token);
    }
    function $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index) {
        const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
        if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
        else acc.push(token);
    }
    function $b58a68bc6bfddc85$export$2e2bcd8739ae039(md) {
        md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
            state.tokens = state.tokens.reduce((acc, token, index)=>{
                const { type: type } = token;
                if (type === 'heading_open') $b58a68bc6bfddc85$var$handleHeadingOpen(state, token, acc, index);
                else if (type === 'heading_close') $b58a68bc6bfddc85$var$handleHeadingClose(state, token, acc, index);
                else acc.push(token);
                return acc;
            }, []);
        });
    }
});
parcelRegister("2Suqb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89029a8bda2c5b4f$export$2e2bcd8739ae039);
    var $e2gHg = parcelRequire("e2gHg");
    var $iZOJ9;
    var $dPSMN;
    var $gOwky;
    const $89029a8bda2c5b4f$var$arrayReplaceAt = (src, pos, newElements)=>{
        return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
    };
    const $89029a8bda2c5b4f$var$isLinkOpen = (str)=>{
        return /^<a[>\s]/i.test(str);
    };
    const $89029a8bda2c5b4f$var$isLinkClose = (str)=>{
        return /^<\/a\s*>/i.test(str);
    };
    const $89029a8bda2c5b4f$var$linkify = (state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, ($parcel$interopDefault($e2gHg)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                if (currentToken.type === 'html_inline') {
                    if ($89029a8bda2c5b4f$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($89029a8bda2c5b4f$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, (0, parcelRequire("iZOJ9")).linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    links = links.filter((link)=>(0, (0, parcelRequire("gOwky")).shouldAutoLinkifyMatch)(link));
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = (0, (0, parcelRequire("dPSMN")).findFilepaths)(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if ((0, (0, parcelRequire("dPSMN")).isLinkInMatches)(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    blockTokens[j].children = tokens = $89029a8bda2c5b4f$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
    var $89029a8bda2c5b4f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $89029a8bda2c5b4f$var$linkify);
});
parcelRegister("3KuZM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abad1ea2bea26d97$export$2e2bcd8739ae039);
    const $abad1ea2bea26d97$var$newline = (state, silent)=>{
        let pmax, pos = state.pos;
        if (state.src.charCodeAt(pos) !== 0x0a) return false;
        pmax = state.pending.length - 1;
        if (!silent) {
            if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
                if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) state.push('hardbreak', 'br', 0);
                else {
                    state.pending = state.pending.slice(0, -1);
                    state.push('softbreak', 'br', 0);
                }
            } else state.push('softbreak', 'br', 0);
        }
        pos++;
        state.pos = pos;
        return true;
    };
    var $abad1ea2bea26d97$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $abad1ea2bea26d97$var$newline);
});
parcelRegister("igwks", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fc5de6df8c35efad$export$2e2bcd8739ae039);
    const $fc5de6df8c35efad$var$paragraph = (state, startLine)=>{
        let content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph'), endLine = state.lineMax;
        oldParentType = state.parentType;
        state.parentType = 'paragraph';
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            if (state.sCount[nextLine] - state.blkIndent > 3) continue;
            if (state.sCount[nextLine] < 0) continue;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
        content = state.getLines(startLine, nextLine, state.blkIndent, false);
        state.line = nextLine;
        token = state.push('paragraph_open', 'p', 1);
        token.map = [
            startLine,
            state.line
        ];
        token = state.push('inline', '', 0);
        token.content = content;
        token.map = [
            startLine,
            state.line
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        state.parentType = oldParentType;
        return true;
    };
    var $fc5de6df8c35efad$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $fc5de6df8c35efad$var$paragraph);
});
parcelRegister("ie3zK", function(module, exports) {
    $parcel$export(module.exports, "cardKeymap", ()=>$8139e78644d8ae86$export$fc7a7a088775f35d);
    var $gE8f9;
    var $e9qoo;
    var $vWFRY;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    const $8139e78644d8ae86$var$lookupPixel = 10;
    const $8139e78644d8ae86$var$getClosestInlineCardPos = (state, editorView, direction)=>{
        const { selection: selection } = state;
        const { parent: parent } = selection.$from;
        const inlineCardType = state.schema.nodes.inlineCard;
        if (!(0, $5r0mK.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
        const coord = editorView.coordsAtPos(selection.$anchor.pos);
        const nearPos = editorView.posAtCoords({
            left: coord.left,
            top: direction === 'up' ? coord.top - $8139e78644d8ae86$var$lookupPixel : coord.bottom + $8139e78644d8ae86$var$lookupPixel
        })?.inside;
        if (typeof nearPos === 'number' && nearPos > -1) {
            const newNode = state.doc.nodeAt(nearPos);
            if (newNode) {
                if (newNode.type !== inlineCardType || (0, $5r0mK.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
                return nearPos;
            }
        }
        return null;
    };
    const $8139e78644d8ae86$var$selectAboveBelowInlineCard = (direction)=>{
        return (state, dispatch, editorView)=>{
            if (!editorView || !dispatch) return false;
            const pos = $8139e78644d8ae86$var$getClosestInlineCardPos(state, editorView, direction);
            if (pos) {
                dispatch(state.tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(state.doc.resolve(pos))));
                return true;
            }
            return false;
        };
    };
    function $8139e78644d8ae86$export$fc7a7a088775f35d(featureFlags) {
        const list = {};
        if ((0, (0, parcelRequire("gE8f9")).browser).chrome && (0, (0, parcelRequire("gE8f9")).browser).chrome_version > 90) {
            (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveUp).common, $8139e78644d8ae86$var$selectAboveBelowInlineCard('up'), list);
            (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveDown).common, $8139e78644d8ae86$var$selectAboveBelowInlineCard('down'), list);
        }
        return (0, (0, parcelRequire("vWFRY")).keymap)(list);
    }
});
parcelRegister("kfdsX", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$0267f0ce05faa855$export$ae829ec7b2625219);
    $parcel$export(module.exports, "pluginKey", ()=>(parcelRequire("lumM0")).pluginKey);
    var $7nRxN;
    var $5BVRS;
    var $5KWxh;
    var $kRXi9;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $VSDnB;
    var $1KE0Q;
    var $1Ly3h;
    var $2CVDy;
    var $ivF3y;
    var $6YTYp;
    var $N3kru;
    var $h162L;
    var $89B6e;
    var $nYpqR;
    var $lumM0;
    var $bYyIW;
    var $jhHFS;
    var $gBr25;
    const $0267f0ce05faa855$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
    const $0267f0ce05faa855$export$ee666af8a9b19e18 = 'card-plugin-element-allow-events';
    const $0267f0ce05faa855$export$7ae4cd3a66c1e050 = (event)=>{
        if (!(0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages')) return false;
        const target = event.target;
        if (target instanceof HTMLElement && target.closest(`.${$0267f0ce05faa855$export$ee666af8a9b19e18}`)) return false;
        return true;
    };
    const $0267f0ce05faa855$var$handleAwarenessOverlay = (view)=>{
        const currentState = (0, (0, parcelRequire("gBr25")).getPluginState)(view.state);
        const overlayCandidatePos = currentState?.overlayCandidatePosition;
        if (overlayCandidatePos) {
            currentState.removeOverlay?.();
            const tr = view.state.tr;
            (0, (0, parcelRequire("nYpqR")).clearOverlayCandidate)(tr);
            view.dispatch(tr);
        }
    };
    const $0267f0ce05faa855$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
            const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, __livePage: __livePage } = options;
            const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
            const inlineCardViewProducer = (0, (0, parcelRequire("5BVRS")).getInlineNodeViewProducer)({
                pmPluginFactoryParams: pmPluginFactoryParams,
                Component: (0, (0, parcelRequire("2CVDy")).InlineCardNodeView),
                extraComponentProps: {
                    useAlternativePreloader: useAlternativePreloader,
                    actionOptions: actionOptions,
                    enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    __livePage: __livePage
                },
                ...__livePage && (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') && {
                    extraNodeViewProps: {
                        stopEvent: $0267f0ce05faa855$export$7ae4cd3a66c1e050
                    }
                }
            });
            return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
                state: {
                    init () {
                        return {
                            requests: [],
                            provider: null,
                            cards: [],
                            datasourceStash: {},
                            showLinkingToolbar: false,
                            smartLinkEvents: undefined,
                            editorAppearance: editorAppearance,
                            showDatasourceModal: false,
                            datasourceModalType: undefined,
                            datasourceTableRef: undefined,
                            layout: undefined
                        };
                    },
                    apply (tr, pluginState, prevEditorState) {
                        const pluginStateWithUpdatedPos = (0, (0, parcelRequire("gBr25")).getPluginStateWithUpdatedPos)(pluginState, tr);
                        const meta = tr.getMeta((0, (0, parcelRequire("lumM0")).pluginKey));
                        if (cardPluginEvents) {
                            const events = (0, (0, parcelRequire("1KE0Q")).eventsFromTransaction)(tr, prevEditorState);
                            cardPluginEvents.push(...events);
                        }
                        if (!meta) {
                            if (pluginState.datasourceTableRef) {
                                if (!(tr.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) || !tr.selection.node.attrs.datasource) return {
                                    ...pluginStateWithUpdatedPos,
                                    datasourceTableRef: undefined
                                };
                            }
                        }
                        if (!meta) return pluginStateWithUpdatedPos;
                        if (!enableInlineUpgradeFeatures) return (0, (0, parcelRequire("bYyIW")).default)(pluginStateWithUpdatedPos, meta);
                        const newState = (0, (0, parcelRequire("bYyIW")).default)(pluginStateWithUpdatedPos, meta);
                        const isSingleInlineLink = pluginState?.requests?.length === 1 && pluginState.requests[0].appearance === 'inline';
                        const isSmartLinkPulseDiscovered = (0, (0, parcelRequire("1Ly3h")).isLocalStorageKeyDiscovered)($0267f0ce05faa855$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                        if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                        const linkPosition = pluginState.requests[0].pos;
                        const canBeUpgradedToBlock = allowBlockCards && (0, (0, parcelRequire("89B6e")).isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                        const canBeUpgradedToEmbed = allowEmbeds && (0, (0, parcelRequire("89B6e")).isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                        if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                        if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                        return newState;
                    }
                },
                filterTransaction (tr) {
                    if ((0, (0, parcelRequire("VSDnB")).fg)('platform_linking_enable_transaction_filtering')) {
                        const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                        if (isOutsideClicked) {
                            const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                            if (isInlineEditingActive) return false;
                        }
                        return true;
                    } else return true;
                },
                view (view) {
                    const domAtPos = view.domAtPos.bind(view);
                    const rafCancellationCallbacks = [];
                    if (options.provider) (0, (0, parcelRequire("jhHFS")).handleProvider)('cardProvider', options.provider, view);
                    return {
                        update (view, prevState) {
                            const currentState = (0, (0, parcelRequire("gBr25")).getPluginState)(view.state);
                            const oldState = (0, (0, parcelRequire("gBr25")).getPluginState)(prevState);
                            const { state: state, dispatch: dispatch } = view;
                            const { selection: selection, tr: tr, schema: schema } = state;
                            const isBlockCardSelected = selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selection.node?.type === schema.nodes.blockCard;
                            if (isBlockCardSelected) {
                                const datasourceTableRef = (0, $5r0mK.findDomRefAtPos)(selection.from, domAtPos)?.querySelector(`.${(0, (0, parcelRequire("kRXi9")).DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                                const { node: node } = selection;
                                const isDatasource = !!node?.attrs?.datasource;
                                const shouldUpdateTableRef = datasourceTableRef && currentState?.datasourceTableRef !== datasourceTableRef;
                                if (isDatasource && shouldUpdateTableRef) {
                                    const layout = (0, (0, parcelRequire("h162L")).isDatasourceTableLayout)(node.attrs.layout) ? node.attrs.layout : (0, $44fe84ed19a5b32b$export$60efea3f80310017);
                                    const isNested = selection.$anchor.depth > 0;
                                    if (!isNested) dispatch((0, (0, parcelRequire("nYpqR")).setCardLayoutAndDatasourceTableRef)({
                                        datasourceTableRef: datasourceTableRef,
                                        layout: layout
                                    })(tr));
                                }
                            } else if (currentState?.datasourceTableRef) dispatch((0, (0, parcelRequire("nYpqR")).setDatasourceTableRef)(undefined)(tr));
                            if (currentState && currentState.provider) {
                                const newRequests = (0, (0, parcelRequire("gBr25")).getNewRequests)(oldState, currentState);
                                const { provider: provider } = currentState;
                                newRequests.forEach((request)=>{
                                    const invoke = (0, (0, parcelRequire("7nRxN")).default)(()=>(0, (0, parcelRequire("jhHFS")).resolveWithProvider)(view, provider, request, options, pluginInjectionApi?.analytics?.actions, pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined));
                                    rafCancellationCallbacks.push(invoke.cancel);
                                    invoke();
                                });
                            }
                            cardPluginEvents?.flush();
                        },
                        destroy () {
                            rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                        }
                    };
                },
                props: {
                    nodeViews: {
                        inlineCard: (0, (0, parcelRequire("N3kru")).lazyInlineCardView)({
                            inlineCardViewProducer: inlineCardViewProducer
                        }),
                        blockCard: (0, (0, parcelRequire("ivF3y")).lazyBlockCardView)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            actionOptions: actionOptions,
                            pluginInjectionApi: pluginInjectionApi,
                            onClickCallback: onClickCallback,
                            allowDatasource: options.allowDatasource,
                            inlineCardViewProducer: inlineCardViewProducer
                        }),
                        embedCard: (0, (0, parcelRequire("6YTYp")).lazyEmbedCardView)({
                            allowResizing: allowResizing,
                            fullWidthMode: fullWidthMode,
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            pluginInjectionApi: pluginInjectionApi,
                            actionOptions: actionOptions,
                            onClickCallback: options.onClickCallback
                        })
                    },
                    ...enableInlineUpgradeFeatures && {
                        handleKeyDown: (view)=>{
                            $0267f0ce05faa855$var$handleAwarenessOverlay(view);
                            return false;
                        },
                        handleClick: (view)=>{
                            $0267f0ce05faa855$var$handleAwarenessOverlay(view);
                            return false;
                        }
                    }
                },
                key: (0, (0, parcelRequire("lumM0")).pluginKey)
            });
        };
});
const $44fe84ed19a5b32b$export$85183a312807388d = 'media';
const $44fe84ed19a5b32b$export$60efea3f80310017 = 'wide';
parcelRegister("1KE0Q", function(module, exports) {
    $parcel$export(module.exports, "eventsFromTransaction", ()=>$f858eabba9a33ee1$export$c985b35883eaea59);
    var $f5LPn;
    var $5ZnzP;
    var $gkwXh;
    var $1ZWXY;
    var $20Kbb;
    var $77j9j;
    var $eS2Dn;
    var $lumM0;
    var $gBr25;
    var $i3FS2;
    var $kAMX8;
    const $f858eabba9a33ee1$export$200d2ac836975ed5 = (tr, state)=>{
        const schema = tr.doc.type.schema;
        const removed = [];
        const inserted = [];
        const updated = [];
        const queuedForUpgrade = $f858eabba9a33ee1$var$isTransactionQueuedForUpgrade(tr);
        const isResolveReplace = $f858eabba9a33ee1$var$isTransactionResolveReplace(tr);
        const historyMeta = tr.getMeta((0, (0, parcelRequire("77j9j")).pmHistoryPluginKey));
        const isUndo = $f858eabba9a33ee1$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $f858eabba9a33ee1$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        const isUpdate = $f858eabba9a33ee1$var$isUpdateTr(tr, isUndo || isRedo);
        for(let i = 0; i < tr.steps.length; i++){
            const step = tr.steps[i];
            const stepMap = step.getMap();
            const removedInStep = [];
            const insertedInStep = [];
            const before = tr.docs[i] ?? tr.before;
            const after = tr.docs[i + 1] ?? tr.doc;
            if (step instanceof (0, (0, parcelRequire("eS2Dn")).AddMarkStep)) {
                const addMarkStep = step;
                if ((0, (0, parcelRequire("20Kbb")).isLinkMark)(addMarkStep.mark, schema)) {
                    const node = after.nodeAt(addMarkStep.from);
                    if (node) insertedInStep.push({
                        pos: addMarkStep.from,
                        node: node,
                        nodeContext: (0, (0, parcelRequire("kAMX8")).getNodeContext)(after, addMarkStep.from)
                    });
                }
            }
            if (step instanceof (0, (0, parcelRequire("eS2Dn")).RemoveMarkStep)) {
                const removeMarkStep = step;
                if ((0, (0, parcelRequire("20Kbb")).isLinkMark)(removeMarkStep.mark, schema)) {
                    const node = before.nodeAt(removeMarkStep.from);
                    if (node) removedInStep.push({
                        pos: removeMarkStep.from,
                        node: node,
                        nodeContext: (0, (0, parcelRequire("kAMX8")).getNodeContext)(before, removeMarkStep.from)
                    });
                }
            }
            stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
                const before = tr.docs[i];
                const after = tr.docs[i + 1] ?? tr.doc;
                const removedInRange = [];
                const insertedInRange = [];
                removedInRange.push(...(0, (0, parcelRequire("kAMX8")).findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, (0, parcelRequire("kAMX8")).getNodeSubject)(node)));
                insertedInRange.push(...(0, (0, parcelRequire("kAMX8")).findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, (0, parcelRequire("kAMX8")).getNodeSubject)(node)));
                removedInStep.push(...removedInRange);
                insertedInStep.push(...insertedInRange);
            });
            const omitRequestsForUpgrade = (links)=>{
                if (!queuedForUpgrade) return links;
                const queuedPositions = $f858eabba9a33ee1$var$getQueuedPositions(tr);
                return links.filter((link)=>!queuedPositions.includes(link.pos));
            };
            if (!isResolveReplace) removed.push(...removedInStep);
            inserted.push(...omitRequestsForUpgrade(insertedInStep));
        }
        if (inserted.length === 0 && isResolveReplace) {
            const positions = $f858eabba9a33ee1$var$getResolvePositions(tr, state);
            inserted.push(...(0, (0, parcelRequire("kAMX8")).findAtPositions)(tr, positions));
        }
        if (!isUpdate) {
            const { inputMethod: inputMethod } = (0, (0, parcelRequire("1ZWXY")).getLinkMetadataFromTransaction)(tr);
            if (!inputMethod && (0, (0, parcelRequire("kAMX8")).areSameNodes)(removed, inserted)) return {
                removed: [],
                inserted: [],
                updated: updated
            };
            return {
                removed: removed,
                inserted: inserted,
                updated: updated
            };
        }
        const updateInserted = [];
        const updateRemoved = [];
        for(let i = 0; i < inserted.length; i++){
            if (isResolveReplace) {
                const newLink = inserted[i];
                const mappedPos = tr.mapping.map(newLink.pos, -1);
                const previousDisplay = $f858eabba9a33ee1$var$getResolveLinkPrevDisplay(state, mappedPos);
                updated.push({
                    inserted: inserted[i],
                    previous: {
                        display: previousDisplay
                    }
                });
                continue;
            }
            if (inserted.length === removed.length) {
                const previousSubject = (0, (0, parcelRequire("kAMX8")).getNodeSubject)(removed[i].node);
                const currentSubject = (0, (0, parcelRequire("kAMX8")).getNodeSubject)(inserted[i].node);
                if ($f858eabba9a33ee1$var$isDatasourceUpgrade(previousSubject, currentSubject) || $f858eabba9a33ee1$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                    updateInserted.push(inserted[i]);
                    updateRemoved.push(removed[i]);
                } else updated.push({
                    removed: removed[i],
                    inserted: inserted[i]
                });
            }
        }
        return {
            inserted: updateInserted,
            removed: updateRemoved,
            updated: updated
        };
    };
    const $f858eabba9a33ee1$var$UPDATE_ACTIONS = [
        (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE,
        (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED
    ];
    const $f858eabba9a33ee1$var$isUpdateTr = (tr, isUndoOrRedo)=>{
        return !!tr.steps.find((step)=>{
            if (!(step instanceof (0, (0, parcelRequire("f5LPn")).LinkMetaStep))) return false;
            const { action: action, cardAction: cardAction } = step.getMetadata();
            if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
            if (!action) return false;
            return $f858eabba9a33ee1$var$UPDATE_ACTIONS.includes(action);
        });
    };
    const $f858eabba9a33ee1$var$hasType = (pluginMeta)=>{
        return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
    };
    const $f858eabba9a33ee1$var$isTransactionQueuedForUpgrade = (tr)=>{
        const pluginMeta = tr.getMeta((0, (0, parcelRequire("lumM0")).pluginKey));
        return $f858eabba9a33ee1$var$isMetadataQueue(pluginMeta);
    };
    const $f858eabba9a33ee1$var$isMetadataQueue = (metaData)=>{
        return $f858eabba9a33ee1$var$hasType(metaData) && metaData.type === 'QUEUE';
    };
    const $f858eabba9a33ee1$var$isTransactionResolveReplace = (tr)=>{
        const pluginMeta = tr.getMeta((0, (0, parcelRequire("lumM0")).pluginKey));
        return $f858eabba9a33ee1$var$isMetadataResolve(pluginMeta);
    };
    const $f858eabba9a33ee1$var$isMetadataResolve = (metaData)=>{
        return $f858eabba9a33ee1$var$hasType(metaData) && metaData.type === 'RESOLVE';
    };
    const $f858eabba9a33ee1$var$isHistoryMeta = (meta)=>{
        return typeof meta === 'object' && meta !== null && 'redo' in meta;
    };
    const $f858eabba9a33ee1$var$getQueuedPositions = (tr)=>{
        const pluginMeta = tr.getMeta((0, (0, parcelRequire("lumM0")).pluginKey));
        if (!$f858eabba9a33ee1$var$isMetadataQueue(pluginMeta)) return [];
        return pluginMeta.requests.map(({ pos: pos })=>pos);
    };
    const $f858eabba9a33ee1$var$getResolvePositions = (tr, state)=>{
        const cardState = (0, (0, parcelRequire("gBr25")).getPluginState)(state);
        if (!cardState) return [];
        const pluginMeta = tr.getMeta((0, (0, parcelRequire("lumM0")).pluginKey));
        if (!$f858eabba9a33ee1$var$isMetadataResolve(pluginMeta)) return [];
        return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
    };
    const $f858eabba9a33ee1$var$getResolveLinkPrevDisplay = (state, pos)=>{
        const cardState = (0, (0, parcelRequire("gBr25")).getPluginState)(state);
        if (!cardState) return undefined;
        return cardState.requests.find((request)=>request.pos === pos)?.previousAppearance;
    };
    const $f858eabba9a33ee1$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).DATASOURCE && currentSubject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).LINK;
    const $f858eabba9a33ee1$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).LINK && currentSubject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).DATASOURCE;
    function $f858eabba9a33ee1$export$c985b35883eaea59(tr, state) {
        const events = [];
        try {
            const isRemote = tr.getMeta('isRemote');
            const isReplaceDocument = tr.getMeta('replaceDocument');
            const isTableSort = tr.steps.find((step)=>step instanceof (0, (0, parcelRequire("5ZnzP")).TableSortStep));
            if (isRemote || isReplaceDocument || isTableSort) return events;
            const historyMeta = tr.getMeta((0, (0, parcelRequire("77j9j")).pmHistoryPluginKey));
            const isUndo = $f858eabba9a33ee1$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
            const isRedo = $f858eabba9a33ee1$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
            const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, (0, parcelRequire("1ZWXY")).getLinkMetadataFromTransaction)(tr);
            const { removed: removed, inserted: inserted, updated: updated } = $f858eabba9a33ee1$export$200d2ac836975ed5(tr, state);
            const MAX_LINK_EVENTS = 50;
            if ([
                removed,
                inserted,
                updated
            ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
            for(let i = 0; i < updated.length; i++){
                const update = updated[i];
                const { inserted: inserted } = update;
                const { node: node, nodeContext: nodeContext } = inserted;
                const subject = (0, (0, parcelRequire("kAMX8")).getNodeSubject)(node);
                const previousDisplay = 'removed' in update ? (0, (0, parcelRequire("kAMX8")).appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
                if (subject) events.push({
                    event: (0, (0, parcelRequire("i3FS2")).EVENT).UPDATED,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo,
                        previousDisplay: previousDisplay
                    }
                });
            }
            const pushEvents = (entities, event)=>{
                for(let i = 0; i < entities.length; i++){
                    const { node: node, nodeContext: nodeContext } = entities[i];
                    const subject = (0, (0, parcelRequire("kAMX8")).getNodeSubject)(node);
                    if (subject) events.push({
                        event: event,
                        subject: subject,
                        data: {
                            node: node,
                            nodeContext: nodeContext,
                            action: action,
                            inputMethod: inputMethod,
                            sourceEvent: sourceEvent,
                            isUndo: isUndo,
                            isRedo: isRedo
                        }
                    });
                }
            };
            pushEvents(removed, (0, (0, parcelRequire("i3FS2")).EVENT).DELETED);
            pushEvents(inserted, (0, (0, parcelRequire("i3FS2")).EVENT).CREATED);
            return events;
        } catch (err) {
            return events;
        }
    }
});
parcelRegister("5ZnzP", function(module, exports) {
    $parcel$export(module.exports, "TableSortStep", ()=>$9b15ba5eea984bbe$export$c1b7e6427b2a2113);
    var $kCV8T;
    var $eS2Dn;
    const $9b15ba5eea984bbe$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
    class $9b15ba5eea984bbe$export$c1b7e6427b2a2113 extends (0, (0, parcelRequire("eS2Dn")).Step) {
        constructor(pos, prev, next){
            super();
            this.prev = prev;
            this.next = next;
            this.pos = pos;
        }
        invert() {
            return new $9b15ba5eea984bbe$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
        }
        apply(doc) {
            return (0, (0, parcelRequire("eS2Dn")).StepResult).ok(doc);
        }
        map() {
            return null;
        }
        getMap() {
            return new (0, (0, parcelRequire("eS2Dn")).StepMap)([
                0,
                0,
                0
            ]);
        }
        toJSON() {
            return {
                stepType: $9b15ba5eea984bbe$export$3f33e36adb7672cc
            };
        }
        static fromJSON() {
            return new (0, (0, parcelRequire("eS2Dn")).ReplaceStep)(0, 0, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
    }
    (0, (0, parcelRequire("eS2Dn")).Step).jsonID($9b15ba5eea984bbe$export$3f33e36adb7672cc, $9b15ba5eea984bbe$export$c1b7e6427b2a2113);
});
parcelRegister("77j9j", function(module, exports) {
    $parcel$export(module.exports, "pmHistoryPluginKey", ()=>$3eac7c1ce2173d69$export$d4f2631252432abf);
    $parcel$export(module.exports, "shallowEqual", ()=>$3eac7c1ce2173d69$export$d36bdfa510afb180);
    $parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", ()=>$3eac7c1ce2173d69$export$51bf7c6695e13879);
    $parcel$export(module.exports, "isInListItem", ()=>$3eac7c1ce2173d69$export$92d47fcf661e090e);
    $parcel$export(module.exports, "findFarthestParentNode", ()=>$3eac7c1ce2173d69$export$6b982788a5f0ccef);
    $parcel$export(module.exports, "insideTableCell", ()=>$3eac7c1ce2173d69$export$1350ff12653c84d4);
    $parcel$export(module.exports, "checkNodeDown", ()=>$3eac7c1ce2173d69$export$d0951c59cd3dac0f);
    $parcel$export(module.exports, "isEmptyNode", ()=>$3eac7c1ce2173d69$export$641fdf56f693bfbc);
    $parcel$export(module.exports, "isNodeEmpty", ()=>$3eac7c1ce2173d69$export$cd58ff1081f6abe9);
    $parcel$export(module.exports, "isInEmptyLine", ()=>$3eac7c1ce2173d69$export$3b68253250b41118);
    $parcel$export(module.exports, "isEmptyParagraph", ()=>(parcelRequire("594Yf")).isEmptyParagraph);
    $parcel$export(module.exports, "hasDocAsParent", ()=>(parcelRequire("ggL2v")).hasDocAsParent);
    var $5r0mK = parcelRequire("5r0mK");
    var $ggL2v;
    var $594Yf;
    var $gOwky;
    var $h03xs;
    var $lVKVw;
    var $gE8f9;
    var $fTi1m;
    var $cAMv0;
    var $c1exv;
    var $eOOFp;
    var $20Kbb;
    var $aOimD;
    var $7vpuQ;
    var $eQcNy;
    var $4NUlu;
    var $2KwKW;
    var $d54NZ;
    var $2vGdQ;
    var $5or39;
    var $5J0oM;
    var $5vnE9;
    var $lGkyv;
    var $fc6h8;
    var $WXnhI;
    var $4AgYP;
    var $4IuOY;
    var $2Cwj1;
    var $hEIDx;
    var $uTDrM;
    var $dPSMN;
    var $j9To4;
    var $agxMF;
    var $cROsB;
    var $3dBkm;
    var $k24a0;
    var $2Abpa;
    var $cz9kf;
    var $iXNbm;
    var $aDFRV;
    var $aeKzo;
    var $2C7zq;
    var $biLOy;
    const $3eac7c1ce2173d69$export$d4f2631252432abf = 'history$';
    function $3eac7c1ce2173d69$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
    }
    function $3eac7c1ce2173d69$export$51bf7c6695e13879(selection) {
        const docNode = selection.$anchor.node(0);
        const rootNode = selection.$anchor.node(1);
        return docNode.lastChild === rootNode;
    }
    const $3eac7c1ce2173d69$export$92d47fcf661e090e = (state)=>{
        return (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
    };
    const $3eac7c1ce2173d69$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
            let candidate = null;
            for(let i = $pos.depth; i > 0; i--){
                const node = $pos.node(i);
                if (predicate(node)) candidate = {
                    pos: i > 0 ? $pos.before(i) : 0,
                    start: $pos.start(i),
                    depth: i,
                    node: node
                };
            }
            return candidate;
        };
    const $3eac7c1ce2173d69$export$1350ff12653c84d4 = (state)=>{
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        return (0, $5r0mK.hasParentNodeOfType)([
            tableCell,
            tableHeader
        ])(state.selection);
    };
    function $3eac7c1ce2173d69$var$findAncestorPosition(doc, pos) {
        const nestableBlocks = [
            'blockquote',
            'bulletList',
            'orderedList'
        ];
        if (pos.depth === 1) return pos;
        let node = pos.node(pos.depth);
        let newPos = pos;
        while(pos.depth >= 1){
            pos = doc.resolve(pos.before(pos.depth));
            node = pos.node(pos.depth);
            if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
        }
        return newPos;
    }
    function $3eac7c1ce2173d69$export$d0951c59cd3dac0f(selection, doc, filter) {
        const ancestorDepth = $3eac7c1ce2173d69$var$findAncestorPosition(doc, selection.$to).depth;
        if (ancestorDepth === 0) return false;
        const res = doc.resolve(selection.$to.after(ancestorDepth));
        return res.nodeAfter ? filter(res.nodeAfter) : false;
    }
    const $3eac7c1ce2173d69$export$641fdf56f693bfbc = (schema)=>{
        const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
        const innerIsEmptyNode = (node)=>{
            switch(node.type){
                case media:
                case mediaGroup:
                case mediaSingle:
                    return false;
                case paragraph:
                case codeBlock:
                case heading:
                case taskItem:
                case decisionItem:
                    return node.content.size === 0;
                case expand:
                case blockquote:
                case panel:
                case listItem:
                    return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
                case bulletList:
                case orderedList:
                    return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
                case taskList:
                case decisionList:
                    return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
                case doc:
                    let isEmpty = true;
                    node.content.forEach((child)=>{
                        isEmpty = isEmpty && innerIsEmptyNode(child);
                    });
                    return isEmpty;
                default:
                    return $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node);
            }
        };
        return innerIsEmptyNode;
    };
    function $3eac7c1ce2173d69$export$cd58ff1081f6abe9(node) {
        if (node && node.textContent) return false;
        if (!node || !node.childCount || node.childCount === 1 && (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(node.firstChild)) return true;
        const block = [];
        const nonBlock = [];
        node.forEach((child)=>{
            child.isInline ? nonBlock.push(child) : block.push(child);
        });
        return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
    }
    function $3eac7c1ce2173d69$export$3b68253250b41118(state) {
        const { selection: selection } = state;
        const { $cursor: $cursor, $anchor: $anchor } = selection;
        if (!$cursor) return false;
        const node = $cursor.node();
        if (!node) return false;
        return (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(node) && (0, (0, parcelRequire("ggL2v")).hasDocAsParent)($anchor);
    }
});
parcelRegister("lVKVw", function(module, exports) {
    $parcel$export(module.exports, "getExtensionLozengeData", ()=>$1938aba83063b4fb$export$4fd8ecadd193bea0);
    const $1938aba83063b4fb$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
        if (!node.attrs.parameters) return;
        const { macroMetadata: macroMetadata } = node.attrs.parameters;
        if (macroMetadata && macroMetadata.placeholder) {
            let placeholderData;
            macroMetadata.placeholder.forEach((placeholder)=>{
                if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
            });
            return placeholderData;
        }
        return;
    };
});
parcelRegister("c1exv", function(module, exports) {
    $parcel$export(module.exports, "withImageLoader", ()=>$9600f65038d22dcf$export$9b0f795b2e33f057);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    const $9600f65038d22dcf$export$3a0bcc6ff2e20f36 = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
            componentDidMount() {
                this.fetchImage(this.props);
            }
            UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.url !== this.props.url) {
                    this.setState({
                        imageStatus: 'loading'
                    });
                    this.fetchImage(nextProps);
                }
            }
            componentWillUnmount() {
                if (this.img) {
                    this.img.removeEventListener('load', this.onLoad);
                    this.img.removeEventListener('error', this.onError);
                    this.img = null;
                }
            }
            fetchImage({ url: url }) {
                if (url) {
                    if (!this.img) {
                        this.img = new Image();
                        this.img.addEventListener('load', this.onLoad);
                        this.img.addEventListener('error', this.onError);
                    }
                    this.img.src = url;
                }
            }
            render() {
                const { imageStatus: imageStatus } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapped, {
                    ...this.props,
                    imageStatus: imageStatus
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    imageStatus: 'loading'
                }, this.onLoad = ()=>{
                    this.setState({
                        imageStatus: 'complete'
                    });
                    const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                    if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                        width: this.img.naturalWidth,
                        height: this.img.naturalHeight
                    });
                }, this.onError = ()=>{
                    this.setState({
                        imageStatus: 'error'
                    });
                };
            }
        };
    const $9600f65038d22dcf$var$withImageLoaderNew = (Wrapped)=>class WithImageLoader extends (0, $5uXOq.Component) {
            componentDidMount() {
                this.fetchImage(this.props);
            }
            componentDidUpdate(newProps) {
                if (newProps.url !== this.props.url) {
                    this.setState({
                        imageStatus: 'loading'
                    });
                    this.fetchImage(newProps);
                }
            }
            componentWillUnmount() {
                if (this.img) {
                    this.img.removeEventListener('load', this.onLoad);
                    this.img.removeEventListener('error', this.onError);
                    this.img = null;
                }
            }
            fetchImage({ url: url }) {
                if (url) {
                    if (!this.img) {
                        this.img = new Image();
                        this.img.addEventListener('load', this.onLoad);
                        this.img.addEventListener('error', this.onError);
                    }
                    this.img.src = url;
                }
            }
            render() {
                const { imageStatus: imageStatus } = this.state;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapped, {
                    ...this.props,
                    imageStatus: imageStatus
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    imageStatus: 'loading'
                }, this.onLoad = ()=>{
                    this.setState({
                        imageStatus: 'complete'
                    });
                    const { onExternalImageLoaded: onExternalImageLoaded } = this.props;
                    if (onExternalImageLoaded && this.img) onExternalImageLoaded({
                        width: this.img.naturalWidth,
                        height: this.img.naturalHeight
                    });
                }, this.onError = ()=>{
                    this.setState({
                        imageStatus: 'error'
                    });
                };
            }
        };
    const $9600f65038d22dcf$export$9b0f795b2e33f057 = (Wrapped)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) return $9600f65038d22dcf$var$withImageLoaderNew(Wrapped);
        return $9600f65038d22dcf$export$3a0bcc6ff2e20f36(Wrapped);
    };
});
parcelRegister("aOimD", function(module, exports) {
    $parcel$export(module.exports, "pluginFactory", ()=>$b35c4d4356c0af83$export$3dd00fb488ab385a);
    function $b35c4d4356c0af83$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $b35c4d4356c0af83$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
        const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
        return {
            createPluginState (dispatch, initialState) {
                return {
                    init: (_, state)=>$b35c4d4356c0af83$var$isFunction(initialState) ? initialState(state) : initialState,
                    apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                        const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                        let newPluginState = oldPluginState;
                        const meta = tr.getMeta(pluginKey);
                        if (meta) newPluginState = reducer(oldPluginState, meta);
                        if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                        else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                        if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                        return newPluginState;
                    }
                };
            },
            createCommand (action, transform) {
                return (state, dispatch)=>{
                    if (dispatch) {
                        const tr = transform ? transform(state.tr, state) : state.tr;
                        const resolvedAction = $b35c4d4356c0af83$var$isFunction(action) ? action(state) : action;
                        if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                        else return false;
                    }
                    return true;
                };
            },
            getPluginState (state) {
                return pluginKey.getState(state);
            }
        };
    }
});
parcelRegister("lGkyv", function(module, exports) {
    $parcel$export(module.exports, "isTextInput", ()=>$4ed0bf9464bdda71$export$3e6057b9bf6b0bbb);
    var $eS2Dn;
    const $4ed0bf9464bdda71$export$3e6057b9bf6b0bbb = (tr)=>{
        const [step] = tr.steps;
        if (!step || !(step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep))) return false;
        const { slice: { content: content }, from: from, to: to } = step;
        const char = content.firstChild;
        return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
    };
});
parcelRegister("4AgYP", function(module, exports) {
    $parcel$export(module.exports, "sniffUserBrowserExtensions", ()=>$5be8a446da622e19$export$4cd1ca2600761f65);
    const $5be8a446da622e19$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
        const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
        return detectors.map((detector)=>({
                name: detector.name,
                state: {
                    detected: false
                },
                fns: {
                    async: detector.fns.async,
                    sync: detector.fns.sync
                }
            }));
    };
    const $5be8a446da622e19$var$RACE_COMPLETE = 'race_complete';
    const $5be8a446da622e19$var$SELECTORS = {
        GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
    };
    const $5be8a446da622e19$var$supportedDetectors = [
        {
            name: 'grammarly',
            fns: {
                sync: ()=>Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY)),
                async: (detected, cleanup)=>{
                    const exists = Boolean(document?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                    if (exists) detected();
                    let queue = [];
                    const processQueue = ()=>{
                        for (const mutations of queue){
                            for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                                const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($5be8a446da622e19$var$SELECTORS.GRAMMARLY));
                                if (exists) detected();
                            }
                        }
                        queue = [];
                    };
                    const intervalId = setInterval(()=>{
                        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(processQueue);
                        else window.requestAnimationFrame(processQueue);
                    }, 1000);
                    const observer = new MutationObserver((mutations)=>{
                        queue.push(mutations);
                    });
                    cleanup(()=>{
                        queue = [];
                        clearInterval(intervalId);
                        observer?.disconnect();
                    });
                    observer.observe(document.documentElement, {
                        childList: true,
                        subtree: true
                    });
                }
            }
        }
    ];
    function $5be8a446da622e19$export$4cd1ca2600761f65(options) {
        try {
            const detectors = $5be8a446da622e19$var$registerDetectors(options.extensions, $5be8a446da622e19$var$supportedDetectors);
            if (options.async === true) {
                const asyncCleanups = [];
                const asyncDetections = Promise.all(detectors.map((detector)=>{
                    return new Promise((resolve)=>{
                        const detected = ()=>{
                            detector.state.detected = true;
                            resolve();
                        };
                        const cleanup = (cb)=>{
                            asyncCleanups.push(cb);
                        };
                        if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                        else {
                            detector.state.detected = false;
                            resolve();
                        }
                    });
                }));
                const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $5be8a446da622e19$var$RACE_COMPLETE));
                return Promise.race([
                    asyncDetections,
                    globalTimeout
                ]).then(()=>{
                    return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
                }).catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
            } else return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
        } catch (err) {
            return options.async ? Promise.resolve([]) : [];
        }
    }
});
parcelRegister("2Cwj1", function(module, exports) {
    $parcel$export(module.exports, "autoJoinTr", ()=>$34e191c8f61c54e1$export$c7c1e59168a7f554);
    var $eS2Dn;
    function $34e191c8f61c54e1$export$c7c1e59168a7f554(tr, isJoinable) {
        if (Array.isArray(isJoinable)) {
            let types = isJoinable;
            isJoinable = (node)=>types.indexOf(node.type.name) > -1;
        }
        const ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            const map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        const joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            const from = ranges[i];
            const to = ranges[i + 1];
            const $from = tr.doc.resolve(from);
            const depth = $from.sharedDepth(to);
            const parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                const after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) === -1) {
                    const before = parent.child(index - 1);
                    if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, (0, parcelRequire("eS2Dn")).canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
    }
});
parcelRegister("hEIDx", function(module, exports) {
    $parcel$export(module.exports, "isReferencedSource", ()=>$0a8d6f5b4b6694a4$export$d35a68bd2e0b55da);
    $parcel$export(module.exports, "removeConnectedNodes", ()=>$0a8d6f5b4b6694a4$export$657e59857351232d);
    $parcel$export(module.exports, "getChildrenInfo", ()=>$0a8d6f5b4b6694a4$export$c98d43680e607ac1);
    $parcel$export(module.exports, "getNodeName", ()=>$0a8d6f5b4b6694a4$export$651544f548703224);
    const $0a8d6f5b4b6694a4$export$d35a68bd2e0b55da = (state, node)=>{
        if (!node) return false;
        let found = false;
        const localIds = new Set([
            node.attrs?.localId,
            node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
        ].filter(Boolean));
        if (!localIds.size) return false;
        state.doc.descendants((node)=>{
            if (found) return false;
            const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
            if (!dataConsumer) return true;
            found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
            return !found;
        });
        return found;
    };
    const $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4 = (state)=>{
        const result = {};
        const { doc: doc, schema: schema } = state;
        const normalizedIds = new Map();
        const dataConsumerSources = new Map();
        doc.descendants((node, pos)=>{
            let dataConsumer;
            let fragmentMark;
            node.marks.some((mark)=>{
                if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
                else if (mark.type === schema.marks.fragment) fragmentMark = mark;
                return !!dataConsumer && !!fragmentMark;
            });
            if (!fragmentMark && !node.attrs?.localId) return true;
            const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
            if (!normalizedId) return true;
            if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
            if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
            if (!!result[normalizedId]) return true;
            result[normalizedId] = {
                localId: normalizedId,
                name: fragmentMark?.attrs?.name,
                node: node,
                pos: pos,
                targets: []
            };
            if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
            return !dataConsumer;
        });
        for (const [localId, sources] of dataConsumerSources)sources.forEach((src)=>{
            const normalizedId = normalizedIds.get(src) ?? src;
            const srcLink = result[normalizedId];
            if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
        });
        return result;
    };
    const $0a8d6f5b4b6694a4$export$657e59857351232d = (state, node)=>{
        if (!node) return state.tr;
        const selectedLocalIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
        const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
        const idsToBeDeleted = $0a8d6f5b4b6694a4$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
        if (!idsToBeDeleted?.length) return state.tr;
        const { tr: tr } = state;
        let newTr = tr;
        idsToBeDeleted.forEach((id)=>{
            if (!allNodes[id]) return;
            const { node: node, pos: pos } = allNodes[id];
            newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
        });
        return newTr;
    };
    const $0a8d6f5b4b6694a4$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
        if (!selectedIds.size) return [];
        let searchSet = [
            ...selectedIds
        ];
        const deletedIds = new Set();
        while(searchSet.length){
            const id = searchSet.pop();
            if (allNodes[id]) {
                deletedIds.add(allNodes[id].localId);
                searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
            }
        }
        return Array.from(deletedIds);
    };
    const $0a8d6f5b4b6694a4$export$c98d43680e607ac1 = (state, node)=>{
        let allChildrenHadName = true;
        if (!node) return [];
        const childrenIdSet = new Set();
        const childrenInfoArray = [];
        const allNodes = $0a8d6f5b4b6694a4$export$82b9f8f75cc709b4(state);
        const selectedNodeIds = $0a8d6f5b4b6694a4$var$getSelectedLocalIds(state, node);
        selectedNodeIds.forEach((id)=>{
            if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
        });
        for (const id of childrenIdSet)if (!$0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes)) {
            allChildrenHadName = false;
            break;
        } else childrenInfoArray.push({
            id: id,
            name: $0a8d6f5b4b6694a4$var$getNodeNameById(id, allNodes),
            amount: $0a8d6f5b4b6694a4$var$getChildrenNodeAmount(id, allNodes)
        });
        return allChildrenHadName ? childrenInfoArray : [];
    };
    const $0a8d6f5b4b6694a4$var$getChildrenNodeAmount = (id, allNodes)=>{
        const searchTerms = new Set([
            id
        ]);
        const traverseHistory = new Map();
        const childrenIds = new Set();
        traverseHistory.set(id, false);
        while(searchTerms.size > 0){
            const [currTerm] = searchTerms;
            let targets = $0a8d6f5b4b6694a4$var$getNodeTargetsById(currTerm, allNodes);
            targets.forEach((target)=>{
                const isTargetCounted = traverseHistory.get(target);
                if (!isTargetCounted) {
                    searchTerms.add(target);
                    childrenIds.add(target);
                }
                target !== id && childrenIds.add(target);
            });
            traverseHistory.set(currTerm, true);
            searchTerms.delete(currTerm);
        }
        return childrenIds.size;
    };
    const $0a8d6f5b4b6694a4$var$getNodeTargetsById = (id, allNodes)=>{
        if (!id || !allNodes[id]) return [];
        return allNodes[id].targets;
    };
    const $0a8d6f5b4b6694a4$var$getNodeNameById = (id, allNodes)=>{
        if (typeof id === 'object') {
            let name;
            id.forEach((localId)=>{
                name = name ?? allNodes[localId]?.name;
            });
            return name || null;
        }
        if (!id || !allNodes[id]) return null;
        return allNodes[id].name;
    };
    const $0a8d6f5b4b6694a4$var$getSelectedLocalIds = (state, node)=>{
        if (!node) return new Set([]);
        const localIds = new Set([
            node.attrs?.localId,
            node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
        ].filter(Boolean));
        return localIds;
    };
    const $0a8d6f5b4b6694a4$export$651544f548703224 = (state, node)=>{
        return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
    };
});
parcelRegister("j9To4", function(module, exports) {
    $parcel$export(module.exports, "gridTypeForLayout", ()=>$d114efb4a396db73$export$27813bf9aa3826dc);
    const $d114efb4a396db73$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';
});
parcelRegister("cROsB", function(module, exports) {
    $parcel$export(module.exports, "shouldAddDefaultWrappedWidth", ()=>$3161276a2e2e68a3$export$7cd5aab2c4f1fb1e);
    $parcel$export(module.exports, "nonWrappedLayouts", ()=>$3161276a2e2e68a3$export$607795ead6e50626);
    $parcel$export(module.exports, "floatingLayouts", ()=>$3161276a2e2e68a3$export$7c0073a4d21b222d);
    $parcel$export(module.exports, "isRichMediaInsideOfBlockNode", ()=>$3161276a2e2e68a3$export$55fb9d6810f2e04b);
    $parcel$export(module.exports, "alignAttributes", ()=>$3161276a2e2e68a3$export$b2258912a400ba32);
    $parcel$export(module.exports, "calculateSnapPoints", ()=>$3161276a2e2e68a3$export$de65085e667b4bf1);
    var $5r0mK = parcelRequire("5r0mK");
    var $iHYdz;
    var $kKuJi;
    const $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e = (layout, width, lineLength)=>{
        return (0, (0, parcelRequire("kKuJi")).wrappedLayouts).indexOf(layout) > -1 && lineLength && width && width > 0.5 * lineLength;
    };
    const $3161276a2e2e68a3$export$607795ead6e50626 = [
        'center',
        'wide',
        'full-width'
    ];
    const $3161276a2e2e68a3$export$7c0073a4d21b222d = [
        'wrap-left',
        'wrap-right'
    ];
    const $3161276a2e2e68a3$export$55fb9d6810f2e04b = (view, pos)=>{
        if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
        const $pos = view.state.doc.resolve(pos);
        const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } = view.state.schema.nodes;
        return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
            expand,
            nestedExpand,
            layoutColumn
        ]);
    };
    const $3161276a2e2e68a3$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
        let width = oldAttrs.width;
        const oldLayout = oldAttrs.layout;
        const oldLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(oldLayout) > -1;
        const newLayoutIsNonWrapped = $3161276a2e2e68a3$export$607795ead6e50626.indexOf(layout) > -1;
        const newLayoutIsWrapped = (0, (0, parcelRequire("kKuJi")).wrappedLayouts).indexOf(layout) > -1;
        const oldLayoutIsWrapped = (0, (0, parcelRequire("kKuJi")).wrappedLayouts).indexOf(oldLayout) > -1;
        if (oldLayoutIsNonWrapped && $3161276a2e2e68a3$export$7cd5aab2c4f1fb1e(layout, originalWidth, lineLength)) {
            if (!width || width >= 100 || oldLayout !== 'center') width = 50;
        } else if (layout !== oldLayout && [
            'full-width',
            'wide'
        ].indexOf(oldLayout) > -1) width = undefined;
        else if (width) {
            const cols = Math.round(width / 100 * gridSize);
            let targetCols = cols;
            if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
                targetCols = Math.floor(targetCols / 2) * 2;
                width = undefined;
            } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
                if (cols <= 1) targetCols = 2;
                else if (cols >= gridSize) targetCols = 10;
            }
            if (targetCols !== cols) width = targetCols / gridSize * 100;
        }
        return {
            ...oldAttrs,
            layout: layout,
            width: width
        };
    };
    function $3161276a2e2e68a3$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
        const snapTargets = [];
        for(let i = 0; i < gridWidth; i++){
            const pxFromColumns = (0, (0, parcelRequire("kKuJi")).calcPxFromColumns)(i, lineLength, gridWidth);
            snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
        }
        snapTargets.push(lineLength - offsetLeft);
        const columns = wrappedLayout || insideInlineLike ? 1 : 2;
        const minimumWidth = (0, (0, parcelRequire("kKuJi")).calcPxFromColumns)(columns, lineLength, gridSize);
        let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        if (!$pos) return snapPoints;
        snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel && allowBreakoutSnapPoints) {
            snapPoints.push(akEditorWideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding);
            if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        snapPoints = snapPoints.sort((a, b)=>a - b);
        return snapPoints;
    }
});
parcelRegister("kKuJi", function(module, exports) {
    $parcel$export(module.exports, "calcPxFromColumns", ()=>$96e639534456f333$export$1e3701608f0cee80);
    $parcel$export(module.exports, "calcColumnsFromPx", ()=>$96e639534456f333$export$10912f14d8d54640);
    $parcel$export(module.exports, "calcPctFromPx", ()=>$96e639534456f333$export$55ddb36b3404ec6d);
    $parcel$export(module.exports, "wrappedLayouts", ()=>$96e639534456f333$export$405baca3d8bc263d);
    $parcel$export(module.exports, "calcMediaPxWidth", ()=>$96e639534456f333$export$5e51fc02b9ada5af);
    var $iHYdz;
    var $intz5;
    const $96e639534456f333$var$validWidthModes = [
        'center',
        'wrap-left',
        'wrap-right',
        'align-start',
        'align-end'
    ];
    const $96e639534456f333$export$adfc02948d64a4f2 = (layout)=>$96e639534456f333$var$validWidthModes.indexOf(layout) > -1;
    function $96e639534456f333$export$1e3701608f0cee80(columns, lineLength, gridSize) {
        const maxWidth = lineLength + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
        return maxWidth / gridSize * columns - (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
    }
    function $96e639534456f333$export$10912f14d8d54640(width, lineLength, gridSize) {
        const maxWidth = lineLength + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
        return (width + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
    }
    function $96e639534456f333$export$e70e278a1f662f8d(pct, lineLength) {
        const maxWidth = lineLength + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
        return maxWidth * pct - (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
    }
    function $96e639534456f333$export$55ddb36b3404ec6d(width, lineLength) {
        const maxWidth = lineLength + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE);
        return (width + (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
    }
    const $96e639534456f333$export$405baca3d8bc263d = [
        'wrap-left',
        'wrap-right',
        'align-end',
        'align-start'
    ];
    const $96e639534456f333$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil($96e639534456f333$export$e70e278a1f662f8d(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
    const $96e639534456f333$export$5e51fc02b9ada5af = (opts)=>{
        const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
        const { width: width, lineLength: lineLength } = containerWidth;
        const calculatedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
        const calculatedResizedPctWidth = $96e639534456f333$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
        if (layout === 'wide') {
            if (lineLength) {
                const wideWidth = Math.ceil(lineLength * (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio));
                return wideWidth > width ? lineLength : wideWidth;
            }
        } else if (layout === 'full-width') return width - (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding);
        else if (calculatedPctWidth) {
            if ($96e639534456f333$export$405baca3d8bc263d.indexOf(layout) > -1) {
                if (calculatedResizedPctWidth) {
                    if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                    return calculatedPctWidth;
                }
                return Math.min(calculatedPctWidth, origWidth);
            }
            if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
            return calculatedPctWidth;
        } else if (layout === 'center') {
            if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
            return Math.min(origWidth, lineLength || width);
        } else if (layout && $96e639534456f333$export$405baca3d8bc263d.indexOf(layout) !== -1) {
            const halfLineLength = Math.ceil((lineLength || width) / 2);
            return origWidth <= halfLineLength ? origWidth : halfLineLength;
        }
        return origWidth;
    };
    const $96e639534456f333$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
        const pxWidth = $96e639534456f333$export$e70e278a1f662f8d(gridWidth / 100, lineLength);
        const columnSpan = Math.round($96e639534456f333$export$10912f14d8d54640(pxWidth, lineLength, gridSize));
        const alignedWidth = $96e639534456f333$export$1e3701608f0cee80(columnSpan, lineLength, gridSize);
        return {
            height: height / width * alignedWidth,
            width: alignedWidth
        };
    };
});
parcelRegister("intz5", function(module, exports) {
    $parcel$export(module.exports, "MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH", ()=>$7676dd27b358f47a$export$5937600f4cc784f0);
    $parcel$export(module.exports, "MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH", ()=>$7676dd27b358f47a$export$71d660e8ca5b8f73);
    $parcel$export(module.exports, "MEDIA_SINGLE_SNAP_GAP", ()=>$7676dd27b358f47a$export$cd11d7d46412c89b);
    $parcel$export(module.exports, "MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN", ()=>$7676dd27b358f47a$export$8c5ac0b0c62a3d21);
    $parcel$export(module.exports, "MEDIA_SINGLE_GUTTER_SIZE", ()=>$7676dd27b358f47a$export$68d0abe4f03863fb);
    $parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", ()=>$7676dd27b358f47a$export$d722b7527b1834a8);
    $parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", ()=>$7676dd27b358f47a$export$da894f7669b4e67c);
    $parcel$export(module.exports, "MEDIA_SINGLE_RESIZE_THROTTLE_TIME", ()=>$7676dd27b358f47a$export$e13825c38da2ce1);
    $parcel$export(module.exports, "wrappedLayouts", ()=>$7676dd27b358f47a$export$405baca3d8bc263d);
    $parcel$export(module.exports, "DEFAULT_ROUNDING_INTERVAL", ()=>$7676dd27b358f47a$export$4d41d008e9cd4f34);
    $parcel$export(module.exports, "CAPTION_PLACEHOLDER_ID", ()=>$7676dd27b358f47a$export$b4b560efd3c61856);
    const $7676dd27b358f47a$export$5937600f4cc784f0 = 24;
    const $7676dd27b358f47a$export$71d660e8ca5b8f73 = 320;
    const $7676dd27b358f47a$export$cd11d7d46412c89b = 3;
    const $7676dd27b358f47a$export$71482734bb54ac3 = 10;
    const $7676dd27b358f47a$export$fd2b09475ada41cc = 12;
    const $7676dd27b358f47a$export$8c5ac0b0c62a3d21 = 8;
    const $7676dd27b358f47a$export$68d0abe4f03863fb = $7676dd27b358f47a$export$fd2b09475ada41cc * 2;
    const $7676dd27b358f47a$export$d722b7527b1834a8 = 250;
    const $7676dd27b358f47a$export$da894f7669b4e67c = 200;
    const $7676dd27b358f47a$export$e13825c38da2ce1 = 100;
    var $7676dd27b358f47a$export$c84671f46d6a1ca;
    (function(Layout) {
        Layout["FULL_WIDTH"] = "full-width";
        Layout["WIDE"] = "wide";
        Layout["CENTER"] = "center";
        Layout["ALIGN_START"] = "align-start";
        Layout["ALIGN_END"] = "align-end";
        Layout["WRAP_RIGHT"] = "wrap-right";
        Layout["WRAP_LEFT"] = "wrap-left";
    })($7676dd27b358f47a$export$c84671f46d6a1ca || ($7676dd27b358f47a$export$c84671f46d6a1ca = {}));
    const $7676dd27b358f47a$export$405baca3d8bc263d = [
        'wrap-left',
        'wrap-right',
        'align-end',
        'align-start'
    ];
    const $7676dd27b358f47a$export$4d41d008e9cd4f34 = 0.5;
    const $7676dd27b358f47a$export$b4b560efd3c61856 = 'caption-placeholder';
});
parcelRegister("cz9kf", function(module, exports) {
    $parcel$export(module.exports, "dedupe", ()=>$b4d75c9e493507f1$export$f3a259b74a77132f);
    function $b4d75c9e493507f1$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
        const seen = new Set();
        list.forEach((l)=>seen.add(iteratee(l)));
        return list.filter((l)=>{
            const it = iteratee(l);
            if (seen.has(it)) {
                seen.delete(it);
                return true;
            }
            return false;
        });
    }
});
parcelRegister("aDFRV", function(module, exports) {
    $parcel$export(module.exports, "transformNodeIntoListItem", ()=>$3e3acfe58aba3a90$export$f4c81471ccea5042);
    var $kCV8T;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $uTDrM;
    function $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from) {
        const sliceInserted = (0, (0, parcelRequire("kCV8T")).Slice).maxOpen((0, (0, parcelRequire("kCV8T")).Fragment).from(node));
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    function $3e3acfe58aba3a90$export$f4c81471ccea5042(tr, node) {
        const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
        const startLinePosition = $from.start();
        const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
        const startMapped = startLinePosition === from ? parentStartPosition : from;
        const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(tr.selection);
        const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        if (!selectionParentListNodeWithPos) return tr;
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1;
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth;
        const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
            bulletList,
            orderedList
        ]);
        const selectionIsInNestedList = !!grandParentListNode;
        let selectedListItemHasNestedList = false;
        selectionParentListItemNode?.node.content.forEach((child)=>{
            if ((0, (0, parcelRequire("uTDrM")).isListNode)(child)) selectedListItemHasNestedList = true;
        });
        if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $5r0mK.safeInsert)(node)(tr).scrollIntoView();
        const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
        let replaceTo;
        if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        $3e3acfe58aba3a90$var$setSelectionToValidTextNode(tr, node, from);
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
        const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const nodeOfOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ]);
        const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        return tr;
    }
});
parcelRegister("2C7zq", function(module, exports) {
    $parcel$export(module.exports, "calculateToolbarPositionAboveSelection", ()=>$5d709aa1b364f0a8$export$5966a251e0deb6ac);
    $parcel$export(module.exports, "calculateToolbarPositionTrackHead", ()=>$5d709aa1b364f0a8$export$4fdfbe77de19eec);
    const $5d709aa1b364f0a8$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
            const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
            if (!toolbar) return nextPos;
            const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
            const wrapperBounds = scrollWrapper.getBoundingClientRect();
            const selection = window && window.getSelection();
            const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
            if (!range) return nextPos;
            const toolbarRect = toolbar.getBoundingClientRect();
            const { head: head, anchor: anchor } = editorView.state.selection;
            const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
            const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
            let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
            let left = 0;
            if (topCoords.top !== bottomCoords.top) {
                if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
                else left = Math.min(topCoords.left, bottomCoords.left);
                const cliffPosition = range.getClientRects()[0];
                if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
            } else left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
            left -= toolbarRect.width / 2;
            if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
            return {
                top: top - wrapperBounds.top + scrollWrapper.scrollTop,
                left: Math.max(0, left - wrapperBounds.left)
            };
        };
    const $5d709aa1b364f0a8$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
            const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
            if (!toolbar) return nextPos;
            const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
            const wrapperBounds = scrollWrapper.getBoundingClientRect();
            const selection = window && window.getSelection();
            const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
            if (!range) return nextPos;
            const toolbarRect = toolbar.getBoundingClientRect();
            const { head: head, anchor: anchor } = editorView.state.selection;
            let topCoords = editorView.coordsAtPos(Math.min(head, anchor));
            let bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
            let top;
            if (head > anchor && topCoords.top !== bottomCoords.top) top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
            else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
            let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
            if (top < wrapperBounds.top) ({ top: top, left: left } = $5d709aa1b364f0a8$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
            return {
                top: top - wrapperBounds.top + scrollWrapper.scrollTop,
                left: Math.max(0, left - wrapperBounds.left)
            };
        };
    const $5d709aa1b364f0a8$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
        return {
            top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
            left: bottomCoords.right - toolbarRect.width / 2
        };
    };
});
parcelRegister("biLOy", function(module, exports) {
    $parcel$export(module.exports, "findNodePosByLocalIds", ()=>$f5822fec42041939$export$947fc26275418e36);
    const $f5822fec42041939$export$947fc26275418e36 = (state, ids, option = {})=>{
        if (ids.length === 0) return [];
        const nodes = [];
        const localIdSet = new Set(ids);
        if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
            node: state.doc,
            pos: 0
        });
        state.doc.descendants((node, pos)=>{
            if (localIdSet.has(node.attrs?.localId)) nodes.push({
                node: node,
                pos: pos
            });
            return localIdSet.size !== nodes.length;
        });
        return nodes;
    };
});
parcelRegister("gBr25", function(module, exports) {
    $parcel$export(module.exports, "getPluginState", ()=>$3db8d4710cf7a428$export$f05434c51e3762e);
    $parcel$export(module.exports, "getPluginStateWithUpdatedPos", ()=>$3db8d4710cf7a428$export$be237c815d2927d4);
    $parcel$export(module.exports, "getNewRequests", ()=>$3db8d4710cf7a428$export$cd9326e2f6dc42c0);
    var $lumM0;
    const $3db8d4710cf7a428$export$f05434c51e3762e = (editorState)=>(0, (0, parcelRequire("lumM0")).pluginKey).getState(editorState);
    const $3db8d4710cf7a428$export$be237c815d2927d4 = (pluginState, tr)=>({
            ...pluginState,
            requests: pluginState.requests.map((request)=>({
                    ...request,
                    pos: tr.mapping.map(request.pos)
                })),
            cards: pluginState.cards.map((card)=>({
                    ...card,
                    pos: tr.mapping.map(card.pos)
                }))
        });
    const $3db8d4710cf7a428$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
        if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$3db8d4710cf7a428$var$isSameRequest(oldReq, req)));
        return currentState.requests;
    };
    const $3db8d4710cf7a428$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;
});
parcelRegister("i3FS2", function(module, exports) {
    $parcel$export(module.exports, "EVENT", ()=>$ffa98524fff92b8e$export$e39a34cfd532e15);
    $parcel$export(module.exports, "EVENT_SUBJECT", ()=>$ffa98524fff92b8e$export$97c6cb64ce06a88a);
    var $ffa98524fff92b8e$export$e39a34cfd532e15;
    (function(EVENT) {
        EVENT["CREATED"] = "created";
        EVENT["UPDATED"] = "updated";
        EVENT["DELETED"] = "deleted";
    })($ffa98524fff92b8e$export$e39a34cfd532e15 || ($ffa98524fff92b8e$export$e39a34cfd532e15 = {}));
    var $ffa98524fff92b8e$export$97c6cb64ce06a88a;
    (function(EVENT_SUBJECT) {
        EVENT_SUBJECT["LINK"] = "link";
        EVENT_SUBJECT["DATASOURCE"] = "datasource";
    })($ffa98524fff92b8e$export$97c6cb64ce06a88a || ($ffa98524fff92b8e$export$97c6cb64ce06a88a = {}));
});
parcelRegister("kAMX8", function(module, exports) {
    $parcel$export(module.exports, "getNodeSubject", ()=>$8c65fa0cf2e92994$export$d3d4c2526aede29a);
    $parcel$export(module.exports, "appearanceForLink", ()=>$8c65fa0cf2e92994$export$599e1b655555ab1d);
    $parcel$export(module.exports, "getUrl", ()=>$8c65fa0cf2e92994$export$94df0e59ebebf4a7);
    $parcel$export(module.exports, "getNodeContext", ()=>$8c65fa0cf2e92994$export$c63a892fcfc539bc);
    $parcel$export(module.exports, "findAtPositions", ()=>$8c65fa0cf2e92994$export$7ea2145b3909e5c6);
    $parcel$export(module.exports, "findInNodeRange", ()=>$8c65fa0cf2e92994$export$dbc52ec0d340ce50);
    $parcel$export(module.exports, "areSameNodes", ()=>$8c65fa0cf2e92994$export$1f3592a520a7960d);
    var $89B6e;
    var $i3FS2;
    function $8c65fa0cf2e92994$export$962cfe99b8da8614(node) {
        return 'datasource' in node.attrs && !!node.attrs.datasource;
    }
    const $8c65fa0cf2e92994$export$26ada819291bd8df = (node)=>{
        if ($8c65fa0cf2e92994$export$962cfe99b8da8614(node)) return false;
        if (!!(0, (0, parcelRequire("89B6e")).appearanceForNodeType)(node.type)) return true;
        return $8c65fa0cf2e92994$var$hasLinkMark(node);
    };
    function $8c65fa0cf2e92994$export$d3d4c2526aede29a(node) {
        if ($8c65fa0cf2e92994$export$962cfe99b8da8614(node)) return (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).DATASOURCE;
        if ($8c65fa0cf2e92994$export$26ada819291bd8df(node)) return (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).LINK;
        return null;
    }
    function $8c65fa0cf2e92994$export$599e1b655555ab1d(node) {
        const appearance = (0, (0, parcelRequire("89B6e")).appearanceForNodeType)(node.type);
        if (appearance) return appearance;
        return 'url';
    }
    const $8c65fa0cf2e92994$var$getLinkMark = (node)=>{
        if (node.marks) for(let i = 0; i < node.marks.length; i++){
            const mark = node.marks[i];
            if (mark.type.name === 'link') return mark;
        }
    };
    const $8c65fa0cf2e92994$var$hasLinkMark = (node)=>{
        return !!$8c65fa0cf2e92994$var$getLinkMark(node);
    };
    function $8c65fa0cf2e92994$export$94df0e59ebebf4a7(node) {
        return node.attrs?.url ?? $8c65fa0cf2e92994$var$getLinkMark(node)?.attrs?.href;
    }
    const $8c65fa0cf2e92994$export$c63a892fcfc539bc = (doc, pos)=>{
        const $pos = doc.resolve(pos);
        const maxDepth = 3;
        for(let i = 0; i <= maxDepth; i++){
            const node = $pos.node($pos.depth - i);
            if (node && node.type.name !== 'paragraph') return node.type.name;
        }
        return 'unknown';
    };
    const $8c65fa0cf2e92994$export$7ea2145b3909e5c6 = (tr, positions)=>{
        const entities = [];
        for(let i = 0; i < positions.length; i++){
            const pos = positions[i];
            const node = tr.doc.nodeAt(pos);
            if (!node) continue;
            const nodeContext = $8c65fa0cf2e92994$export$c63a892fcfc539bc(tr.doc, pos);
            entities.push({
                pos: pos,
                node: node,
                nodeContext: nodeContext
            });
        }
        return entities;
    };
    const $8c65fa0cf2e92994$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
        const entities = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            if (predicate(node)) {
                const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
                if (entirelyInRange) {
                    const nodeContext = $8c65fa0cf2e92994$export$c63a892fcfc539bc(doc, pos);
                    entities.push({
                        pos: pos,
                        node: node,
                        nodeContext: nodeContext
                    });
                }
            }
        });
        return entities;
    };
    const $8c65fa0cf2e92994$export$1f3592a520a7960d = (setA, setB)=>{
        if (setA.length !== setB.length) return false;
        for(let i = 0; i < setA.length; i++){
            const a = setA[i];
            const b = setB[i];
            if ($8c65fa0cf2e92994$export$94df0e59ebebf4a7(a.node) !== $8c65fa0cf2e92994$export$94df0e59ebebf4a7(b.node) || $8c65fa0cf2e92994$export$599e1b655555ab1d(a.node) !== $8c65fa0cf2e92994$export$599e1b655555ab1d(b.node)) return false;
        }
        return true;
    };
});
parcelRegister("1Ly3h", function(module, exports) {
    $parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK", ()=>$b9571f5f70e5754a$export$613f4cbb1d6327d6);
    $parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR", ()=>$b9571f5f70e5754a$export$b1ab83c904a5352e);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", ()=>$b9571f5f70e5754a$export$2cf27d95188f1c13);
    $parcel$export(module.exports, "isLocalStorageKeyDiscovered", ()=>$b9571f5f70e5754a$export$f029a1bf9ca298da);
    $parcel$export(module.exports, "markLocalStorageKeyDiscovered", ()=>$b9571f5f70e5754a$export$6b9d1ae5ec92c88e);
    var $jtD64;
    const $b9571f5f70e5754a$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
    const $b9571f5f70e5754a$export$4521957a9ae858f5 = 'discovered';
    const $b9571f5f70e5754a$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
    const $b9571f5f70e5754a$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
    const $b9571f5f70e5754a$export$2cf27d95188f1c13 = 86400000;
    const $b9571f5f70e5754a$var$storageClient = new (0, (0, parcelRequire("jtD64")).default)($b9571f5f70e5754a$export$c0fd7e3ed450d078);
    const $b9571f5f70e5754a$export$f029a1bf9ca298da = (key)=>{
        try {
            const localStorageValue = $b9571f5f70e5754a$var$storageClient.getItem(key);
            return !!localStorageValue && localStorageValue === $b9571f5f70e5754a$export$4521957a9ae858f5;
        } catch  {
            return true;
        }
    };
    const $b9571f5f70e5754a$export$6b9d1ae5ec92c88e = (key, expiration)=>{
        try {
            $b9571f5f70e5754a$var$storageClient.setItemWithExpiry(key, $b9571f5f70e5754a$export$4521957a9ae858f5, expiration);
        } catch  {}
    };
});
parcelRegister("2CVDy", function(module, exports) {
    $parcel$export(module.exports, "InlineCard", ()=>$e51ccbda25c2841e$export$aff6291803939b05);
    $parcel$export(module.exports, "InlineCardNodeView", ()=>$e51ccbda25c2841e$export$2626b4e17577ac62);
    $parcel$export(module.exports, "inlineCardNodeView", ()=>$e51ccbda25c2841e$export$ebfb9e1798b8aa0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nRxN;
    var $awTmI;
    var $dtBvX;
    var $f3dKD;
    var $9kpKZ;
    var $gZGBX;
    var $VSDnB;
    var $kVZJG;
    var $nYpqR;
    var $5xe9f;
    var $89B6e;
    var $jdDDq;
    var $vNpIX;
    const $e51ccbda25c2841e$export$aff6291803939b05 = (0, $5uXOq.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: onClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions })=>{
        const { url: url, data: data } = node.attrs;
        const scrollContainer = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(view.dom) || undefined, [
            view.dom
        ]);
        const onResolve = (0, $5uXOq.useCallback)((data)=>{
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            (0, (0, parcelRequire("7nRxN")).default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                const tr = view.state.tr;
                (0, (0, parcelRequire("nYpqR")).registerCard)({
                    title: title,
                    url: url,
                    pos: pos
                })(tr);
                onRes?.(tr, title);
                view.dispatch(tr);
            })();
        }, [
            getPos,
            view,
            onRes
        ]);
        const onError = (0, $5uXOq.useCallback)((data)=>{
            const { url: url, err: err } = data;
            if (err) throw err;
            onResolve({
                url: url
            });
        }, [
            onResolve
        ]);
        const card = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVZJG")).Card), {
                key: url,
                url: url ?? data.url,
                appearance: "inline",
                onClick: onClick,
                container: scrollContainer,
                onResolve: onResolve,
                onError: onError,
                inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
                actionOptions: actionOptions,
                isHovered: isHovered,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions
            }), [
            url,
            data,
            onClick,
            scrollContainer,
            onResolve,
            onError,
            useAlternativePreloader,
            actionOptions,
            isHovered,
            showHoverPreview,
            hoverPreviewOptions
        ]);
        return cardContext && cardContext.value ? (0, ($parcel$interopDefault($5uXOq))).createElement(cardContext.Provider, {
            value: cardContext.value
        }, card) : data ? card : null;
    });
    const $e51ccbda25c2841e$var$WrappedInlineCardWithAwareness = (0, (0, parcelRequire("jdDDq")).Card)((0, (0, parcelRequire("vNpIX")).InlineCardWithAwareness), (0, (0, parcelRequire("9kpKZ")).default));
    const $e51ccbda25c2841e$var$WrappedInlineCard = (0, (0, parcelRequire("jdDDq")).Card)($e51ccbda25c2841e$export$aff6291803939b05, (0, (0, parcelRequire("9kpKZ")).default));
    function $e51ccbda25c2841e$export$2626b4e17577ac62(props) {
        const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, __livePage: __livePage } = props;
        const [isOverlayHovered, setIsOverlayHovered] = (0, $5uXOq.useState)(false);
        const { editorViewModeState: editorViewModeState, selectionState: selectionState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(pluginInjectionApi, [
            'selection',
            'editorViewMode'
        ]);
        const floatingToolbarNode = selectionState?.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selectionState?.selection.node;
        if (__livePage && (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages')) {
            const showHoverPreview = floatingToolbarNode !== node;
            const livePagesHoverCardFadeInDelay = 800;
            const inlineCard = (0, ($parcel$interopDefault($5uXOq))).createElement($e51ccbda25c2841e$var$WrappedInlineCard, {
                isHovered: isOverlayHovered,
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                onClickCallback: onClickCallback,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: {
                    fadeInDelay: livePagesHoverCardFadeInDelay
                }
            });
            return editorViewModeState?.mode === 'view' ? inlineCard : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5xe9f")).default), {
                targetElementPos: getPos(),
                view: view,
                isHoveredCallback: setIsOverlayHovered,
                onOpenLinkClick: (event)=>{
                    (0, (0, parcelRequire("dtBvX")).handleNavigation)({
                        fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                        onClickCallback: onClickCallback,
                        url: node.attrs.url,
                        event: event
                    });
                }
            }, inlineCard);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e51ccbda25c2841e$var$WrappedInlineCardWithAwareness, {
            node: node,
            view: view,
            getPos: getPos,
            actionOptions: actionOptions,
            useAlternativePreloader: useAlternativePreloader,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            ...enableInlineUpgradeFeatures && (0, (0, parcelRequire("89B6e")).getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, editorViewModeState?.mode === 'view')
        });
    }
    const $e51ccbda25c2841e$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
            return inlineCardViewProducer(node, view, getPos, decorations);
        };
});
parcelRegister("dtBvX", function(module, exports) {
    $parcel$export(module.exports, "handleNavigation", ()=>$e982cde5a43f97c0$export$706ad1af8096e280);
    var $gkwXh;
    var $hETfp;
    function $e982cde5a43f97c0$export$706ad1af8096e280({ url: url, event: event, onClickCallback: onClickCallback, fireAnalyticsEvent: fireAnalyticsEvent }) {
        if (fireAnalyticsEvent) fireAnalyticsEvent({
            action: (0, (0, parcelRequire("gkwXh")).ACTION).VISITED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).LINK,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                platform: (0, (0, parcelRequire("hETfp")).PLATFORMS).WEB,
                mode: (0, (0, parcelRequire("hETfp")).MODE).EDITOR
            }
        });
        if (url) {
            try {
                onClickCallback?.({
                    event: event,
                    url: url
                });
            } catch  {}
            if (!event.defaultPrevented) window.location.href = url;
        }
    }
});
parcelRegister("kVZJG", function(module, exports) {
    $parcel$export(module.exports, "Card", ()=>$fc8afc0c39cee453$export$60332b2344f7fe41);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i5FdW;
    var $994MI;
    var $cb25w;
    var $fzJZi;
    var $lpxJ1;
    class $fc8afc0c39cee453$var$PlainCard extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lpxJ1")).CardWithURLRenderer), this.props);
            return this.props.intl ? content : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                locale: "en"
            }, content);
        }
    }
    const $fc8afc0c39cee453$export$60332b2344f7fe41 = (0, (0, parcelRequire("994MI")).default)((0, (0, parcelRequire("fzJZi")).context))((0, (0, parcelRequire("cb25w")).default)()((0, (0, parcelRequire("8RXs9")).default)($fc8afc0c39cee453$var$PlainCard, {
        enforceContext: false
    })));
});
parcelRegister("lpxJ1", function(module, exports) {
    $parcel$export(module.exports, "CardWithURLRenderer", ()=>$422a0598dbbdc42a$export$e00a7788e30dc998);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $gKZoD;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $kXQmf;
    var $kxcRq;
    var $91tw3;
    var $5vDFA;
    var $i41Ob;
    const $422a0598dbbdc42a$export$a7690c318cd6a95e = (0, $5uXOq.lazy)(()=>(0, (0, parcelRequire("kxcRq")).importWithRetry)(()=>(parcelRequire("4kgag"))));
    function $422a0598dbbdc42a$export$e00a7788e30dc998(props) {
        (0, (0, parcelRequire("gKZoD")).di)($422a0598dbbdc42a$export$a7690c318cd6a95e);
        const [id] = (0, $5uXOq.useState)(()=>props.id ? props.id : (0, ($parcel$interopDefault($7Jxgt)))());
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                (0, (0, parcelRequire("5vDFA")).clearMarks)(id);
                (0, (0, parcelRequire("5vDFA")).clearMeasures)(id);
            };
        }, [
            id
        ]);
        const { url: url, appearance: appearance, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, onClick: onClick, container: container, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, inheritDimensions: inheritDimensions, platform: platform, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, children: children, ui: ui, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, showAuthTooltip: showAuthTooltip, placeholder: placeholder, fallbackComponent: fallbackComponent, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline } = props;
        const analytics = (0, (0, parcelRequire("kXQmf")).useSmartLinkAnalytics)(url ?? '', id);
        const isFlexibleUi = (0, (0, parcelRequire("91tw3")).isFlexibleUiCard)(children);
        const errorHandler = (0, $5uXOq.useCallback)((error, info)=>{
            const { componentStack: componentStack } = info;
            const errorInfo = {
                componentStack: componentStack
            };
            if (error.name === 'ChunkLoadError') analytics.operational.chunkloadFailedEvent({
                display: appearance,
                error: error,
                errorInfo: errorInfo
            });
            else if (error.name !== 'APIError') analytics.ui.renderFailedEvent({
                display: isFlexibleUi ? 'flexible' : appearance,
                id: id,
                error: error,
                errorInfo: errorInfo
            });
            onError && onError({
                status: 'errored',
                url: url ?? '',
                err: error
            });
        }, [
            analytics.operational,
            analytics.ui,
            appearance,
            id,
            onError,
            url,
            isFlexibleUi
        ]);
        if (!url) throw new Error('@atlaskit/smart-card: url property is missing.');
        const defaultFallBackComponent = ()=>null;
        const FallbackComponent = fallbackComponent ?? defaultFallBackComponent;
        const ErrorFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement(FallbackComponent, null);
        const cardWithUrlProps = {
            id: id,
            url: url,
            appearance: appearance,
            onClick: onClick,
            isSelected: isSelected,
            isHovered: isHovered,
            frameStyle: frameStyle,
            container: container,
            onResolve: onResolve,
            onError: onError,
            testId: testId,
            actionOptions: actionOptions,
            inheritDimensions: inheritDimensions,
            platform: platform,
            embedIframeRef: embedIframeRef,
            embedIframeUrlType: embedIframeUrlType,
            inlinePreloaderStyle: inlinePreloaderStyle,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            showAuthTooltip: showAuthTooltip,
            placeholder: placeholder,
            removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
            resolvingPlaceholder: resolvingPlaceholder,
            truncateInline: truncateInline
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            FallbackComponent: ErrorFallback,
            onError: errorHandler
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i41Ob")).LoadingCardLink), cardWithUrlProps)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($422a0598dbbdc42a$export$a7690c318cd6a95e, cardWithUrlProps, children)));
    }
});
parcelRegister("kXQmf", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkAnalytics", ()=>$6bc8b728824e2d0a$export$57c7fece972c9472);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $cCcdH;
    var $fzJZi;
    var $1n7Qj;
    var $fzJZi;
    var $fgpl1;
    var $1VPdD;
    var $kaKBF;
    const $6bc8b728824e2d0a$var$applyCommonAttributes = (event, commonAttributes)=>{
        if (event && event.attributes) {
            for (const [key, value] of Object.entries(commonAttributes))if (event.attributes[key] === undefined) event.attributes[key] = value;
        }
        return event;
    };
    const $6bc8b728824e2d0a$export$57c7fece972c9472 = (url, id, defaultLocation)=>{
        const { dispatchAnalytics: dispatchAnalytics } = (0, (0, parcelRequire("kaKBF")).useDispatchAnalytics)();
        const defaultId = id || 'NULL';
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const state = store ? (0, (0, parcelRequire("cCcdH")).getUrl)(store, url) : undefined;
        const details = state ? state.details : undefined;
        const extractedDefinitionId = (0, (0, parcelRequire("fgpl1")).getDefinitionId)(details);
        const extractedExtensionKey = (0, (0, parcelRequire("fgpl1")).getExtensionKey)(details);
        const extractedResourceType = (0, (0, parcelRequire("fgpl1")).getResourceType)(details);
        const extractedSubproduct = (0, (0, parcelRequire("fgpl1")).getSubproduct)(details);
        const extractedProduct = (0, (0, parcelRequire("fgpl1")).getProduct)(details);
        const extractedStatusDetails = (0, (0, parcelRequire("fgpl1")).getStatusDetails)(details);
        const commonAttributes = (0, $5uXOq.useMemo)(()=>({
                id: defaultId,
                definitionId: extractedDefinitionId,
                extensionKey: extractedExtensionKey,
                resourceType: extractedResourceType,
                destinationObjectType: extractedResourceType,
                destinationSubproduct: extractedSubproduct,
                destinationProduct: extractedProduct,
                location: defaultLocation,
                statusDetails: extractedStatusDetails
            }), [
            defaultId,
            extractedDefinitionId,
            extractedExtensionKey,
            extractedResourceType,
            extractedSubproduct,
            extractedProduct,
            defaultLocation,
            extractedStatusDetails
        ]);
        const ui = (0, $5uXOq.useMemo)(()=>({
                authEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                authAlternateAccountEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiAuthAlternateAccountEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                buttonClickedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                cardClickedEvent: ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiCardClickedEvent)({
                        id: id,
                        display: display,
                        status: status,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        isModifierKeyPressed: isModifierKeyPressed,
                        location: location,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        actionSubjectId: actionSubjectId
                    }), commonAttributes)),
                actionClickedEvent: ({ id: id, actionType: actionType, display: display, extensionKey: overrideExtensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const extensionKey = overrideExtensionKey ?? extractedExtensionKey;
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiActionClickedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardOpenLinkClickedEvent: ({ previewDisplay: previewDisplay, definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardOpenLinkClickedEvent)({
                        id: defaultId,
                        previewDisplay: previewDisplay,
                        definitionId: definitionId,
                        extensionKey: extensionKey,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod
                    }), commonAttributes));
                },
                closedAuthEvent: ({ display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiClosedAuthEvent)({
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes)),
                modalClosedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'closed',
                        actionSubject: 'modal',
                        actionSubjectId: data.actionSubjectId,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'ui'
                    }, commonAttributes)),
                renderSuccessEvent: ({ display: display, status: status, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource = false })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-rendered', experienceId, {
                        extensionKey: extensionKey,
                        display: display
                    });
                    (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)('smart-link-authenticated', experienceId, {
                        display: display
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderSuccessEvent)({
                        display: display,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        canBeDatasource: canBeDatasource
                    }), commonAttributes));
                },
                renderFailedEvent: ({ display: display, id: id, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-rendered', experienceId);
                    (0, (0, parcelRequire("1VPdD")).failUfoExperience)('smart-link-authenticated', experienceId);
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiRenderFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                hoverCardViewedEvent: ({ previewDisplay: previewDisplay, previewInvokeMethod: previewInvokeMethod, id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardViewedEvent)({
                        id: id,
                        previewDisplay: previewDisplay,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                hoverCardDismissedEvent: ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, previewInvokeMethod: previewInvokeMethod, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, status: status })=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiHoverCardDismissedEvent)({
                        previewDisplay: previewDisplay,
                        id: id,
                        hoverTime: hoverTime,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        previewInvokeMethod: previewInvokeMethod,
                        status: status
                    }), commonAttributes)),
                learnMoreClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiLearnMoreLinkClickedEvent)(), commonAttributes)),
                smartLinkLozengeActionClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusLozengeButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionListItemClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusListItemButtonClicked)(), commonAttributes)),
                smartLinkLozengeActionErrorOpenPreviewClickedEvent: ()=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiSmartLinkStatusOpenPreviewButtonClicked)(), commonAttributes)),
                smartLinkServerActionClickedEvent: (props)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).uiServerActionClicked)(props), commonAttributes))
            }), [
            dispatchAnalytics,
            commonAttributes,
            defaultId,
            extractedExtensionKey
        ]);
        const operational = (0, $5uXOq.useMemo)(()=>({
                invokeSucceededEvent: ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeSucceededEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                invokeFailedEvent: ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).invokeFailedEvent)({
                        id: id ?? defaultId,
                        actionType: actionType,
                        display: display,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectSucceededEvent: ({ id: id, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: 'success'
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectSucceededEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                connectFailedEvent: ({ id: id, reason: reason, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    const experienceId = id ? id : defaultId;
                    (0, (0, parcelRequire("1VPdD")).startUfoExperience)('smart-link-authenticated', experienceId, {
                        extensionKey: extensionKey,
                        status: reason
                    });
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).connectFailedEvent)({
                        ...commonAttributes,
                        id: experienceId,
                        reason: reason,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                },
                instrument: ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
                    const event = (0, (0, parcelRequire("1n7Qj")).instrumentEvent)({
                        ...commonAttributes,
                        id: id,
                        status: status,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location,
                        error: error
                    });
                    if (event) dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes(event, commonAttributes));
                },
                chunkloadFailedEvent: ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
                    dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes((0, (0, parcelRequire("fzJZi")).chunkloadFailedEvent)({
                        display: display,
                        error: error,
                        errorInfo: errorInfo,
                        extensionKey: extensionKey,
                        definitionId: definitionId,
                        resourceType: resourceType,
                        destinationProduct: destinationProduct,
                        destinationSubproduct: destinationSubproduct,
                        location: location
                    }), commonAttributes));
                }
            }), [
            defaultId,
            commonAttributes,
            dispatchAnalytics
        ]);
        const screen = (0, $5uXOq.useMemo)(()=>({
                modalViewedEvent: (data)=>dispatchAnalytics($6bc8b728824e2d0a$var$applyCommonAttributes({
                        action: 'viewed',
                        actionSubject: data.name,
                        attributes: {
                            ...(0, (0, parcelRequire("fzJZi")).context),
                            ...data.attributes
                        },
                        eventType: 'screen',
                        name: data.name
                    }, commonAttributes))
            }), [
            commonAttributes,
            dispatchAnalytics
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                ui: ui,
                operational: operational,
                screen: screen
            }), [
            ui,
            operational,
            screen
        ]);
    };
});
parcelRegister("1n7Qj", function(module, exports) {
    $parcel$export(module.exports, "instrumentEvent", ()=>$a8cb699408687216$export$860cf9c079ed505);
    var $5vDFA;
    var $fzJZi;
    const $a8cb699408687216$export$860cf9c079ed505 = ({ id: id, status: status, extensionKey: extensionKey, definitionId: definitionId, resourceType: resourceType, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, error: error })=>{
        const measure = (0, (0, parcelRequire("5vDFA")).getMeasure)(id, status) || {
            duration: undefined
        };
        if (status === 'resolved') {
            const event = (0, (0, parcelRequire("fzJZi")).resolvedEvent)({
                id: id,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        } else if (error?.type !== 'ResolveUnsupportedError') {
            const event = (0, (0, parcelRequire("fzJZi")).unresolvedEvent)({
                id: id,
                status: status,
                extensionKey: extensionKey,
                definitionId: definitionId,
                resourceType: resourceType,
                destinationProduct: destinationProduct,
                destinationSubproduct: destinationSubproduct,
                location: location,
                error: error
            });
            return {
                ...event,
                attributes: {
                    ...event.attributes,
                    duration: measure.duration
                }
            };
        }
    };
});
parcelRegister("fgpl1", function(module, exports) {
    $parcel$export(module.exports, "getByDefinitionId", ()=>$8cbc55b0be5f7abb$export$f75b0b690ab4dfb9);
    $parcel$export(module.exports, "getClickUrl", ()=>$8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02);
    $parcel$export(module.exports, "getDefinitionId", ()=>$8cbc55b0be5f7abb$export$46fa3e7718c82e41);
    $parcel$export(module.exports, "getExtensionKey", ()=>$8cbc55b0be5f7abb$export$218d96312e385949);
    $parcel$export(module.exports, "getResourceType", ()=>$8cbc55b0be5f7abb$export$16c0ebb0de9b767b);
    $parcel$export(module.exports, "getProduct", ()=>$8cbc55b0be5f7abb$export$e2005c9600188ac7);
    $parcel$export(module.exports, "getSubproduct", ()=>$8cbc55b0be5f7abb$export$f8fdefc70357968e);
    $parcel$export(module.exports, "getServices", ()=>$8cbc55b0be5f7abb$export$a009e3a1163d46fb);
    $parcel$export(module.exports, "getStatusDetails", ()=>$8cbc55b0be5f7abb$export$a752a116d184ffbd);
    $parcel$export(module.exports, "isFinalState", ()=>$8cbc55b0be5f7abb$export$d590d08942abc17a);
    $parcel$export(module.exports, "getCanBeDatasource", ()=>$8cbc55b0be5f7abb$export$ba6d13ab7b87c55c);
    $parcel$export(module.exports, "hasAuthScopeOverrides", ()=>$8cbc55b0be5f7abb$export$3f9446bb21b945a0);
    var $iCv9y;
    const $8cbc55b0be5f7abb$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
        const urls = Object.keys(store);
        return urls.filter((url)=>{
            const { details: details } = store[url];
            return details && details.meta.definitionId === definitionId;
        });
    };
    const $8cbc55b0be5f7abb$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
        if (jsonLd && jsonLd.data) {
            const visitUrl = (0, (0, parcelRequire("iCv9y")).extractVisitUrl)(jsonLd.data);
            if (visitUrl) return visitUrl;
        }
        return url;
    };
    const $8cbc55b0be5f7abb$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
    const $8cbc55b0be5f7abb$export$218d96312e385949 = (details)=>details?.meta?.key;
    const $8cbc55b0be5f7abb$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
    const $8cbc55b0be5f7abb$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
    const $8cbc55b0be5f7abb$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
    const $8cbc55b0be5f7abb$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
    const $8cbc55b0be5f7abb$export$ac5d414b1ebfab5a = (details)=>details && $8cbc55b0be5f7abb$export$cd41ae544cfc2a65(details) && $8cbc55b0be5f7abb$export$795910f5f15a9633(details);
    const $8cbc55b0be5f7abb$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
    const $8cbc55b0be5f7abb$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
    const $8cbc55b0be5f7abb$export$a752a116d184ffbd = (details)=>{
        return details?.meta?.requestAccess?.accessType;
    };
    const $8cbc55b0be5f7abb$export$d590d08942abc17a = (status)=>{
        return [
            'unauthorized',
            'forbidden',
            'errored',
            'resolved',
            'not_found'
        ].indexOf(status) > -1;
    };
    const $8cbc55b0be5f7abb$export$66805b16d2a1da7c = (details)=>details?.datasources;
    const $8cbc55b0be5f7abb$export$ba6d13ab7b87c55c = (details)=>{
        const datasources = $8cbc55b0be5f7abb$export$66805b16d2a1da7c(details);
        return !!datasources && datasources.length > 0;
    };
    const $8cbc55b0be5f7abb$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
});
parcelRegister("iCv9y", function(module, exports) {
    $parcel$export(module.exports, "extractVisitUrl", ()=>$28ad1893a5a5e6d3$export$c81497d3681f24f4);
    const $28ad1893a5a5e6d3$export$c81497d3681f24f4 = (jsonLd)=>{
        return jsonLd['atlassian:visitUrl'];
    };
});
parcelRegister("1VPdD", function(module, exports) {
    $parcel$export(module.exports, "startUfoExperience", ()=>$2308e6f5aae12b86$export$5e9287b6a10f8075);
    $parcel$export(module.exports, "succeedUfoExperience", ()=>$2308e6f5aae12b86$export$c5a5cf072c836c0e);
    $parcel$export(module.exports, "failUfoExperience", ()=>$2308e6f5aae12b86$export$8dda83bafca11b77);
    $parcel$export(module.exports, "addMetadataToExperience", ()=>$2308e6f5aae12b86$export$4084c0df4a03a6af);
    var $cBycP;
    var $7Zbvr;
    const $2308e6f5aae12b86$var$inlineExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$renderExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    };
    const $2308e6f5aae12b86$var$aiExperience = {
        platform: {
            component: 'smart-links'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).InlineResult
    };
    const $2308e6f5aae12b86$var$ufoExperiences = {
        'smart-link-rendered': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-rendered', $2308e6f5aae12b86$var$renderExperience),
        'smart-link-authenticated': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-authenticated', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-action-invocation': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-action-invocation', $2308e6f5aae12b86$var$inlineExperience),
        'smart-link-ai-summary': new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('smart-link-ai-summary', $2308e6f5aae12b86$var$aiExperience)
    };
    const $2308e6f5aae12b86$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.start();
        if (properties) experience.addMetadata(properties);
    };
    const $2308e6f5aae12b86$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.success({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
        const experience = $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id);
        experience.failure({
            metadata: properties
        });
    };
    const $2308e6f5aae12b86$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
        $2308e6f5aae12b86$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
    };
});
parcelRegister("kaKBF", function(module, exports) {
    $parcel$export(module.exports, "useDispatchAnalytics", ()=>$bbdf588730868cbb$export$5f37699fba0ba807);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $fzJZi;
    const $bbdf588730868cbb$export$5f37699fba0ba807 = (handler)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return {
            dispatchAnalytics: (0, $5uXOq.useMemo)(()=>{
                if (handler) return handler;
                return (payload)=>{
                    createAnalyticsEvent(payload).fire((0, (0, parcelRequire("fzJZi")).ANALYTICS_CHANNEL));
                };
            }, [
                handler,
                createAnalyticsEvent
            ])
        };
    };
});
parcelRegister("kxcRq", function(module, exports) {
    $parcel$export(module.exports, "isSpecialEvent", ()=>$c53851cced73411d$export$efca2c4705678489);
    $parcel$export(module.exports, "getIconForFileType", ()=>$c53851cced73411d$export$4d685c85ebc7a1e3);
    $parcel$export(module.exports, "getIframeSandboxAttribute", ()=>$c53851cced73411d$export$9b7e6a102056a387);
    $parcel$export(module.exports, "handleOnClick", ()=>$c53851cced73411d$export$ffccab2ae3d093ef);
    $parcel$export(module.exports, "isIntersectionObserverSupported", ()=>$c53851cced73411d$export$6c837641a9ab03cb);
    $parcel$export(module.exports, "importWithRetry", ()=>$c53851cced73411d$export$aacbf48ace518c5a);
    $parcel$export(module.exports, "downloadUrl", ()=>$c53851cced73411d$export$8a96edb1c96563f4);
    $parcel$export(module.exports, "openUrl", ()=>$c53851cced73411d$export$a238cfe4a10e6279);
    $parcel$export(module.exports, "getPreviewUrlWithTheme", ()=>$c53851cced73411d$export$4470f298c61a79da);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $imVhc;
    const $c53851cced73411d$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($c53851cced73411d$export$e6c5ffa684aac4d7() || $c53851cced73411d$export$d8de0cd37d316fdf(evt) || $c53851cced73411d$export$5b1771037ab7c451(evt));
    const $c53851cced73411d$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
    const $c53851cced73411d$export$d8de0cd37d316fdf = (event)=>event.metaKey || event.ctrlKey;
    const $c53851cced73411d$export$5b1771037ab7c451 = (event)=>event.button === 1;
    const $c53851cced73411d$export$4d685c85ebc7a1e3 = (fileMimeType)=>{
        if (!fileMimeType) return;
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label, importCb] = icon;
        if (!importCb) return;
        const Icon = (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importCb().then((module)=>module.default),
            loading: ()=>null
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            label: label,
            testId: "document-file-format-icon"
        });
    };
    const $c53851cced73411d$export$371bef29a3733127 = (fileMimeType)=>{
        let icon = $c53851cced73411d$var$typeToIcon[fileMimeType.toLowerCase()];
        if (!icon) return;
        const [label] = icon;
        return label;
    };
    const $c53851cced73411d$var$typeToIcon = {
        'text/plain': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.oasis.opendocument.text': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.apple.pages': [
            'Document',
            ()=>Promise.resolve((parcelRequire("duwKf")))
        ],
        'application/vnd.google-apps.document': [
            'Google Doc',
            ()=>(parcelRequire("jXySI"))
        ],
        'application/msword': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
            'Word document',
            ()=>(parcelRequire("1HfN1"))
        ],
        'application/pdf': [
            'PDF document',
            ()=>(parcelRequire("5GIkh"))
        ],
        'application/vnd.oasis.opendocument.spreadsheet': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.apple.numbers': [
            'Spreadsheet',
            ()=>(parcelRequire("dcnwM"))
        ],
        'application/vnd.google-apps.spreadsheet': [
            'Google Sheet',
            ()=>(parcelRequire("5bX2p"))
        ],
        'application/vnd.ms-excel': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            'Excel spreadsheet',
            ()=>(parcelRequire("asJlG"))
        ],
        'application/vnd.oasis.opendocument.presentation': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.apple.keynote': [
            'Presentation',
            ()=>(parcelRequire("dzrUL"))
        ],
        'application/vnd.google-apps.presentation': [
            'Google Slide',
            ()=>(parcelRequire("fZksg"))
        ],
        'application/vnd.ms-powerpoint': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': [
            'PowerPoint presentation',
            ()=>(parcelRequire("jHQ8I"))
        ],
        'application/vnd.google-apps.form': [
            'Google Form',
            ()=>(parcelRequire("k7KGr"))
        ],
        'image/png': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/jpeg': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/bmp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/webp': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/svg+xml': [
            'Image',
            ()=>(parcelRequire("17GQp"))
        ],
        'image/gif': [
            'GIF',
            ()=>(parcelRequire("gBOzU"))
        ],
        'audio/midi': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/mpeg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/webm': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/ogg': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'audio/wav': [
            'Audio',
            ()=>(parcelRequire("2P3xs"))
        ],
        'video/mp4': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/quicktime': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/mov': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/webm': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/ogg': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-ms-wmv': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'video/x-msvideo': [
            'Video',
            ()=>(parcelRequire("8Cn4N"))
        ],
        'application/zip': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-tar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-gtar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-7z-compressed': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/x-apple-diskimage': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/vnd.rar': [
            'Archive',
            ()=>(parcelRequire("1u9rQ"))
        ],
        'application/dmg': [
            'Executable',
            ()=>(parcelRequire("ayRxW"))
        ],
        'text/css': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'text/html': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/javascript': [
            'Source Code',
            ()=>(parcelRequire("boS7Q"))
        ],
        'application/octet-stream': [
            'Binary file',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/invision.prototype': [
            'Prototype',
            ()=>(parcelRequire("5GE4g"))
        ],
        'application/sketch': [
            'Sketch',
            ()=>(parcelRequire("ktas1"))
        ],
        folder: [
            'Folder',
            ()=>(parcelRequire("2KgZP"))
        ]
    };
    const $c53851cced73411d$export$9b7e6a102056a387 = (isTrusted)=>{
        if (isTrusted) return undefined;
        const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
        return sandboxPermissions;
    };
    const $c53851cced73411d$export$ffccab2ae3d093ef = (handler)=>(e)=>{
            e.preventDefault();
            e.stopPropagation();
            handler();
        };
    const $c53851cced73411d$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
    const $c53851cced73411d$export$e772c8ff12451969 = (ms)=>{
        return new Promise((resolve)=>setTimeout(resolve, ms));
    };
    const $c53851cced73411d$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
        try {
            return await importFn();
        } catch (error) {
            if (error.name === 'ChunkLoadError' && retries > 0) {
                await $c53851cced73411d$export$e772c8ff12451969(interval);
                return $c53851cced73411d$export$aacbf48ace518c5a(importFn, retries - 1, interval);
            } else throw error;
        }
    };
    const $c53851cced73411d$export$8a96edb1c96563f4 = async (url)=>{
        if (!url) return;
        const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        const iframeName = 'media-download-iframe';
        const link = document.createElement('a');
        let iframe = document.getElementById(iframeName);
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.id = iframeName;
            iframe.name = iframeName;
            document.body.appendChild(iframe);
        }
        link.href = url;
        link.download = url;
        link.target = isIE11 || isSafari ? '_blank' : iframeName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const $c53851cced73411d$export$a238cfe4a10e6279 = async (url)=>{
        if (!url) return;
        window.open(url, '_blank', 'noopener=yes');
    };
    const $c53851cced73411d$export$4470f298c61a79da = (previewUrl, themeState)=>{
        try {
            const url = new URL(previewUrl);
            url.searchParams.append('themeState', (0, (0, parcelRequire("imVhc")).themeObjectToString)(themeState));
            return url.href;
        } catch  {
            return previewUrl;
        }
    };
});
parcelRegister("duwKf", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, '__esModule', {
        value: true
    });
    module.exports.default = void 0;
    var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9d277a30a5a98acd$var$Document16Icon = (props)=>$9d277a30a5a98acd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: 'small'
        }));
    $9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
    var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;
});
parcelRegister("jXySI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7EgS6").then(()=>parcelRequire('3KifV'));
});
parcelRegister("1HfN1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erQ4S").then(()=>parcelRequire('im5Hg'));
});
parcelRegister("5GIkh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d767x").then(()=>parcelRequire('5m93C'));
});
parcelRegister("dcnwM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lQ9xE").then(()=>parcelRequire('2Bgv8'));
});
parcelRegister("5bX2p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("izomc").then(()=>parcelRequire('iByEQ'));
});
parcelRegister("asJlG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5I4RC").then(()=>parcelRequire('eABwY'));
});
parcelRegister("dzrUL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iV5W6").then(()=>parcelRequire('h7zk4'));
});
parcelRegister("fZksg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jepjM").then(()=>parcelRequire('F35X1'));
});
parcelRegister("jHQ8I", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3YI2r").then(()=>parcelRequire('kKp2J'));
});
parcelRegister("k7KGr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cwkUf").then(()=>parcelRequire('j8IiS'));
});
parcelRegister("17GQp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hVGrh").then(()=>parcelRequire('daL8e'));
});
parcelRegister("gBOzU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aAton").then(()=>parcelRequire('96Idm'));
});
parcelRegister("2P3xs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iDnD4").then(()=>parcelRequire('dOkKo'));
});
parcelRegister("8Cn4N", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dhQt8").then(()=>parcelRequire('lDRqn'));
});
parcelRegister("1u9rQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7QDLp").then(()=>parcelRequire('8njZH'));
});
parcelRegister("ayRxW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("b2yZA").then(()=>parcelRequire('lp0fk'));
});
parcelRegister("boS7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5khw4").then(()=>parcelRequire('6cEsd'));
});
parcelRegister("5GE4g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c1Yqk").then(()=>parcelRequire('7BHMh'));
});
parcelRegister("ktas1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5lMy").then(()=>parcelRequire('lE6mu'));
});
parcelRegister("2KgZP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaqBx").then(()=>parcelRequire('bBHpS'));
});
parcelRegister("91tw3", function(module, exports) {
    $parcel$export(module.exports, "isFlexibleUiCard", ()=>$f30ba994fabdf720$export$3c94e0f4719f5c2a);
    $parcel$export(module.exports, "isFlexibleUiTitleBlock", ()=>$f30ba994fabdf720$export$df0092b19156b140);
    $parcel$export(module.exports, "isFlexibleUiBlock", ()=>$f30ba994fabdf720$export$b56fc89cf6e7d1e9);
    $parcel$export(module.exports, "isFlexibleUiElement", ()=>$f30ba994fabdf720$export$d7fc505bb0bd5756);
    $parcel$export(module.exports, "isFlexibleUiPreviewBlock", ()=>$f30ba994fabdf720$export$c0547b4405cae584);
    var $5uXOq = parcelRequire("5uXOq");
    var $66ZRy;
    var $buvhv;
    var $hYQw7;
    var $ietxm;
    var $eqoQu;
    const $f30ba994fabdf720$export$3c94e0f4719f5c2a = (children)=>{
        if (children && (0, ($parcel$interopDefault($5uXOq))).Children.toArray(children).some((child)=>$f30ba994fabdf720$export$df0092b19156b140(child))) return true;
        return false;
    };
    const $f30ba994fabdf720$export$b56fc89cf6e7d1e9 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("66ZRy"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$d7fc505bb0bd5756 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && Object.values((0, parcelRequire("eqoQu"))).some((type)=>type === node.type);
    const $f30ba994fabdf720$export$df0092b19156b140 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("buvhv")).default);
    const $f30ba994fabdf720$export$c0547b4405cae584 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("hYQw7")).default);
    const $f30ba994fabdf720$export$43edae7b55c79927 = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("ietxm")).default);
});
parcelRegister("66ZRy", function(module, exports) {
    $parcel$export(module.exports, "FooterBlock", ()=>(parcelRequire("ietxm")).default);
    $parcel$export(module.exports, "MetadataBlock", ()=>(parcelRequire("gg6Qm")).default);
    $parcel$export(module.exports, "PreviewBlock", ()=>(parcelRequire("hYQw7")).default);
    $parcel$export(module.exports, "SnippetBlock", ()=>(parcelRequire("1JaZ4")).default);
    $parcel$export(module.exports, "TitleBlock", ()=>(parcelRequire("buvhv")).default);
    $parcel$export(module.exports, "CustomBlock", ()=>(parcelRequire("dghu0")).default);
    $parcel$export(module.exports, "InternalFooterBlock", ()=>(parcelRequire("5HrTg")).default);
    $parcel$export(module.exports, "AISummaryBlock", ()=>(parcelRequire("1qDIM")).default);
    $parcel$export(module.exports, "AIFooterBlock", ()=>(parcelRequire("85ffk")).default);
    $parcel$export(module.exports, "ActionBlock", ()=>(parcelRequire("fh9qw")).default);
    var $ietxm;
    var $gg6Qm;
    var $hYQw7;
    var $1JaZ4;
    var $buvhv;
    var $dghu0;
    var $5HrTg;
    var $1qDIM;
    var $85ffk;
    var $fh9qw;
});
parcelRegister("ietxm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3fcebb5ad9978d90$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $5HrTg;
    const $3fcebb5ad9978d90$var$FooterBlock = ({ status: status, testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !alwaysShow) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5HrTg")).default), {
            ...props,
            testId: testId
        });
    };
    var $3fcebb5ad9978d90$export$2e2bcd8739ae039 = $3fcebb5ad9978d90$var$FooterBlock;
});
parcelRegister("8dVIb", function(module, exports) {
    $parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", ()=>$ad6fd5c2f706e309$export$5c881701926acbef);
    $parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", ()=>$ad6fd5c2f706e309$export$93d67ab022d9f8d2);
    $parcel$export(module.exports, "CONTENT_URL_AI", ()=>$ad6fd5c2f706e309$export$70d24f0465ae60f8);
    $parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", ()=>$ad6fd5c2f706e309$export$a3ed5c4e9d9599b7);
    $parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", ()=>$ad6fd5c2f706e309$export$73b198e73554a323);
    $parcel$export(module.exports, "SmartLinkAlignment", ()=>$ad6fd5c2f706e309$export$8910bf86027fe6be);
    $parcel$export(module.exports, "SmartLinkDirection", ()=>$ad6fd5c2f706e309$export$60831686b0574c86);
    $parcel$export(module.exports, "SmartLinkPosition", ()=>$ad6fd5c2f706e309$export$d58e6377644d1dcf);
    $parcel$export(module.exports, "SmartLinkSize", ()=>$ad6fd5c2f706e309$export$51f13ced115cbdae);
    $parcel$export(module.exports, "SmartLinkStatus", ()=>$ad6fd5c2f706e309$export$61cff06be26816f);
    $parcel$export(module.exports, "SmartLinkTheme", ()=>$ad6fd5c2f706e309$export$aed0f1e801ad691f);
    $parcel$export(module.exports, "SmartLinkInternalTheme", ()=>$ad6fd5c2f706e309$export$9aafec380d7005da);
    $parcel$export(module.exports, "SmartLinkWidth", ()=>$ad6fd5c2f706e309$export$19c60054ee783de6);
    $parcel$export(module.exports, "ElementName", ()=>$ad6fd5c2f706e309$export$d65b168331104a46);
    $parcel$export(module.exports, "ActionName", ()=>$ad6fd5c2f706e309$export$9c95d6e1614bad84);
    $parcel$export(module.exports, "InternalActionName", ()=>$ad6fd5c2f706e309$export$4871a84b35cf8eb9);
    $parcel$export(module.exports, "IconType", ()=>$ad6fd5c2f706e309$export$13ff1290a9e22e77);
    $parcel$export(module.exports, "MediaType", ()=>$ad6fd5c2f706e309$export$483c11740a902fcd);
    $parcel$export(module.exports, "MediaPlacement", ()=>$ad6fd5c2f706e309$export$f9f4737e25ab90fa);
    $parcel$export(module.exports, "CardDisplay", ()=>$ad6fd5c2f706e309$export$6ca4ef8b3dc2c804);
    const $ad6fd5c2f706e309$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
    const $ad6fd5c2f706e309$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
    const $ad6fd5c2f706e309$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
    const $ad6fd5c2f706e309$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
    const $ad6fd5c2f706e309$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
    var $ad6fd5c2f706e309$export$8910bf86027fe6be;
    (function(SmartLinkAlignment) {
        SmartLinkAlignment["Left"] = "left";
        SmartLinkAlignment["Right"] = "right";
    })($ad6fd5c2f706e309$export$8910bf86027fe6be || ($ad6fd5c2f706e309$export$8910bf86027fe6be = {}));
    var $ad6fd5c2f706e309$export$60831686b0574c86;
    (function(SmartLinkDirection) {
        SmartLinkDirection["Horizontal"] = "horizontal";
        SmartLinkDirection["Vertical"] = "vertical";
    })($ad6fd5c2f706e309$export$60831686b0574c86 || ($ad6fd5c2f706e309$export$60831686b0574c86 = {}));
    var $ad6fd5c2f706e309$export$d58e6377644d1dcf;
    (function(SmartLinkPosition) {
        SmartLinkPosition["Top"] = "top";
        SmartLinkPosition["Center"] = "center";
    })($ad6fd5c2f706e309$export$d58e6377644d1dcf || ($ad6fd5c2f706e309$export$d58e6377644d1dcf = {}));
    var $ad6fd5c2f706e309$export$51f13ced115cbdae;
    (function(SmartLinkSize) {
        SmartLinkSize["XLarge"] = "xlarge";
        SmartLinkSize["Large"] = "large";
        SmartLinkSize["Medium"] = "medium";
        SmartLinkSize["Small"] = "small";
    })($ad6fd5c2f706e309$export$51f13ced115cbdae || ($ad6fd5c2f706e309$export$51f13ced115cbdae = {}));
    var $ad6fd5c2f706e309$export$61cff06be26816f;
    (function(SmartLinkStatus) {
        SmartLinkStatus["Pending"] = "pending";
        SmartLinkStatus["Resolving"] = "resolving";
        SmartLinkStatus["Resolved"] = "resolved";
        SmartLinkStatus["Forbidden"] = "forbidden";
        SmartLinkStatus["Errored"] = "errored";
        SmartLinkStatus["NotFound"] = "not_found";
        SmartLinkStatus["Unauthorized"] = "unauthorized";
        SmartLinkStatus["Fallback"] = "fallback";
    })($ad6fd5c2f706e309$export$61cff06be26816f || ($ad6fd5c2f706e309$export$61cff06be26816f = {}));
    var $ad6fd5c2f706e309$export$aed0f1e801ad691f;
    (function(SmartLinkTheme) {
        SmartLinkTheme["Black"] = "black";
        SmartLinkTheme["Link"] = "link";
    })($ad6fd5c2f706e309$export$aed0f1e801ad691f || ($ad6fd5c2f706e309$export$aed0f1e801ad691f = {}));
    var $ad6fd5c2f706e309$export$9aafec380d7005da;
    (function(SmartLinkInternalTheme) {
        SmartLinkInternalTheme["Grey"] = "grey";
    })($ad6fd5c2f706e309$export$9aafec380d7005da || ($ad6fd5c2f706e309$export$9aafec380d7005da = {}));
    var $ad6fd5c2f706e309$export$19c60054ee783de6;
    (function(SmartLinkWidth) {
        SmartLinkWidth["FitToContent"] = "fit-to-content";
        SmartLinkWidth["Flexible"] = "flexible";
    })($ad6fd5c2f706e309$export$19c60054ee783de6 || ($ad6fd5c2f706e309$export$19c60054ee783de6 = {}));
    var $ad6fd5c2f706e309$export$d65b168331104a46;
    (function(ElementName) {
        ElementName["AssignedTo"] = "AssignedTo";
        ElementName["AssignedToGroup"] = "AssignedToGroup";
        ElementName["AttachmentCount"] = "AttachmentCount";
        ElementName["AuthorGroup"] = "AuthorGroup";
        ElementName["ChecklistProgress"] = "ChecklistProgress";
        ElementName["CollaboratorGroup"] = "CollaboratorGroup";
        ElementName["CommentCount"] = "CommentCount";
        ElementName["CreatedBy"] = "CreatedBy";
        ElementName["CreatedOn"] = "CreatedOn";
        ElementName["DueOn"] = "DueOn";
        ElementName["LatestCommit"] = "LatestCommit";
        ElementName["LinkIcon"] = "LinkIcon";
        ElementName["Location"] = "Location";
        ElementName["ModifiedBy"] = "ModifiedBy";
        ElementName["ModifiedOn"] = "ModifiedOn";
        ElementName["OwnedBy"] = "OwnedBy";
        ElementName["OwnedByGroup"] = "OwnedByGroup";
        ElementName["Preview"] = "Preview";
        ElementName["Priority"] = "Priority";
        ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
        ElementName["Provider"] = "Provider";
        ElementName["ReactCount"] = "ReactCount";
        ElementName["ReadTime"] = "ReadTime";
        ElementName["Snippet"] = "Snippet";
        ElementName["SourceBranch"] = "SourceBranch";
        ElementName["State"] = "State";
        ElementName["SubscriberCount"] = "SubscriberCount";
        ElementName["SubTasksProgress"] = "SubTasksProgress";
        ElementName["StoryPoints"] = "StoryPoints";
        ElementName["TargetBranch"] = "TargetBranch";
        ElementName["Title"] = "Title";
        ElementName["ViewCount"] = "ViewCount";
        ElementName["VoteCount"] = "VoteCount";
        ElementName["SentOn"] = "SentOn";
    })($ad6fd5c2f706e309$export$d65b168331104a46 || ($ad6fd5c2f706e309$export$d65b168331104a46 = {}));
    var $ad6fd5c2f706e309$export$9c95d6e1614bad84;
    (function(ActionName) {
        ActionName["CopyLinkAction"] = "CopyLinkAction";
        ActionName["DeleteAction"] = "DeleteAction";
        ActionName["EditAction"] = "EditAction";
        ActionName["FollowAction"] = "FollowAction";
        ActionName["PreviewAction"] = "PreviewAction";
        ActionName["AutomationAction"] = "AutomationAction";
        ActionName["DownloadAction"] = "DownloadAction";
        ActionName["CustomAction"] = "CustomAction";
    })($ad6fd5c2f706e309$export$9c95d6e1614bad84 || ($ad6fd5c2f706e309$export$9c95d6e1614bad84 = {}));
    var $ad6fd5c2f706e309$export$4871a84b35cf8eb9;
    (function(InternalActionName) {
        InternalActionName["AISummaryAction"] = "AISummaryAction";
        InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    })($ad6fd5c2f706e309$export$4871a84b35cf8eb9 || ($ad6fd5c2f706e309$export$4871a84b35cf8eb9 = {}));
    var $ad6fd5c2f706e309$export$13ff1290a9e22e77;
    (function(IconType) {
        IconType["Archive"] = "FileType:Archive";
        IconType["Audio"] = "FileType:Audio";
        IconType["Blog"] = "FileType:Blog";
        IconType["Code"] = "FileType:Code";
        IconType["Document"] = "FileType:Document";
        IconType["Executable"] = "FileType:Executable";
        IconType["File"] = "FileType:File";
        IconType["Folder"] = "FileType:Folder";
        IconType["Generic"] = "FileType:Generic";
        IconType["GIF"] = "FileType:GIF";
        IconType["GoogleDocs"] = "FileType:GoogleDocs";
        IconType["GoogleForms"] = "FileType:GoogleForms";
        IconType["GoogleSheets"] = "FileType:GoogleSheets";
        IconType["GoogleSlides"] = "FileType:GoogleSlides";
        IconType["Image"] = "FileType.Image";
        IconType["MSExcel"] = "FileType:Excel";
        IconType["MSPowerpoint"] = "FileType:Powerpoint";
        IconType["MSWord"] = "FileType:WordDocument";
        IconType["PDF"] = "FileType:PDF";
        IconType["Presentation"] = "FileType:Presentation";
        IconType["Sketch"] = "FileType:Sketch";
        IconType["Spreadsheet"] = "FileType:Spreadsheet";
        IconType["Template"] = "FileType:Template";
        IconType["Video"] = "FileType:Video";
        IconType["Branch"] = "BitBucket:Branch";
        IconType["Commit"] = "BitBucket:Commit";
        IconType["Project"] = "BitBucket:Project";
        IconType["PullRequest"] = "BitBucket:PullRequest";
        IconType["Repo"] = "BitBucket:Repo";
        IconType["Bug"] = "Jira:Bug";
        IconType["Change"] = "Jira:Change";
        IconType["Epic"] = "Jira:Epic";
        IconType["Incident"] = "Jira:Incident";
        IconType["Problem"] = "Jira:Problem";
        IconType["ServiceRequest"] = "Jira:ServiceRequest";
        IconType["Story"] = "Jira:Story";
        IconType["SubTask"] = "Jira:SubTask";
        IconType["Task"] = "Jira:Task";
        IconType["Confluence"] = "Provider:Confluence";
        IconType["Jira"] = "Provider:Jira";
        IconType["Default"] = "Default";
        IconType["Error"] = "Default:Error";
        IconType["Forbidden"] = "Default:Forbidden";
        IconType["Attachment"] = "Badge:Attachment";
        IconType["CheckItem"] = "Badge:Task";
        IconType["Comment"] = "Badge:Comment";
        IconType["View"] = "Badge:View";
        IconType["React"] = "Badge:React";
        IconType["Vote"] = "Badge:Vote";
        IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
        IconType["PriorityCritical"] = "Badge:PriorityCritical";
        IconType["PriorityHigh"] = "Badge:PriorityHigh";
        IconType["PriorityHighest"] = "Badge:PriorityHighest";
        IconType["PriorityLow"] = "Badge:PriorityLow";
        IconType["PriorityLowest"] = "Badge:PriorityLowest";
        IconType["PriorityMajor"] = "Badge:PriorityMajor";
        IconType["PriorityMedium"] = "Badge:PriorityMedium";
        IconType["PriorityMinor"] = "Badge:PriorityMinor";
        IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
        IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
        IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
        IconType["Subscriber"] = "Badge:Subscriber";
        IconType["SubTasksProgress"] = "Badge:SubTask";
    })($ad6fd5c2f706e309$export$13ff1290a9e22e77 || ($ad6fd5c2f706e309$export$13ff1290a9e22e77 = {}));
    var $ad6fd5c2f706e309$export$483c11740a902fcd;
    (function(MediaType) {
        MediaType["Image"] = "image";
    })($ad6fd5c2f706e309$export$483c11740a902fcd || ($ad6fd5c2f706e309$export$483c11740a902fcd = {}));
    var $ad6fd5c2f706e309$export$f9f4737e25ab90fa;
    (function(MediaPlacement) {
        MediaPlacement["Left"] = "left";
        MediaPlacement["Right"] = "right";
    })($ad6fd5c2f706e309$export$f9f4737e25ab90fa || ($ad6fd5c2f706e309$export$f9f4737e25ab90fa = {}));
    var $ad6fd5c2f706e309$export$6ca4ef8b3dc2c804;
    (function(CardDisplay) {
        CardDisplay["Inline"] = "inline";
        CardDisplay["Block"] = "block";
        CardDisplay["Embed"] = "embed";
        CardDisplay["EmbedPreview"] = "embedPreview";
        CardDisplay["Flexible"] = "flexible";
        CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    })($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 || ($ad6fd5c2f706e309$export$6ca4ef8b3dc2c804 = {}));
});
parcelRegister("5HrTg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8eaafd3e75b73f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $bubxq;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $b8eaafd3e75b73f4$var$FooterBlockResolvedView = (props)=>{
        const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, hideProvider: hideProvider } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const hasActions = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(actions, context)?.length > 0, [
            actions,
            context
        ]);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, !hideProvider && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actions && hasActions ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            testId: "smart-element-group-actions",
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            overrideCss: (0, (0, parcelRequire("akF1x")).getActionGroupStyles)(size),
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            onDropdownOpenChange: onDropdownOpenChange,
            items: actions,
            appearance: "default"
        })) : null);
    };
    var $b8eaafd3e75b73f4$export$2e2bcd8739ae039 = $b8eaafd3e75b73f4$var$FooterBlockResolvedView;
});
parcelRegister("Nh1XU", function(module, exports) {
    $parcel$export(module.exports, "FlexibleUiContext", ()=>$79a38154bf117346$export$ca70b164b615de47);
    $parcel$export(module.exports, "useFlexibleUiContext", ()=>$79a38154bf117346$export$61d7957a243df7aa);
    $parcel$export(module.exports, "FlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$9296fed6018ca95b);
    $parcel$export(module.exports, "useFlexibleUiAnalyticsContext", ()=>$79a38154bf117346$export$80b8dfec38d1d85c);
    $parcel$export(module.exports, "FlexibleUiOptionContext", ()=>$79a38154bf117346$export$f7433dbd6c50e26a);
    $parcel$export(module.exports, "useFlexibleUiOptionContext", ()=>$79a38154bf117346$export$e6b5ad18b56e8f51);
    var $5uXOq = parcelRequire("5uXOq");
    const $79a38154bf117346$export$ca70b164b615de47 = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$61d7957a243df7aa = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$ca70b164b615de47);
    const $79a38154bf117346$export$9296fed6018ca95b = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$80b8dfec38d1d85c = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$9296fed6018ca95b);
    const $79a38154bf117346$export$f7433dbd6c50e26a = (0, $5uXOq.createContext)(undefined);
    const $79a38154bf117346$export$e6b5ad18b56e8f51 = ()=>(0, $5uXOq.useContext)($79a38154bf117346$export$f7433dbd6c50e26a);
});
parcelRegister("eqoQu", function(module, exports) {
    $parcel$export(module.exports, "AssignedTo", ()=>$ec376f2b71614cc0$export$d3af56c23f9e459b);
    $parcel$export(module.exports, "AssignedToGroup", ()=>$ec376f2b71614cc0$export$fbd18f11bf3a3444);
    $parcel$export(module.exports, "AttachmentCount", ()=>$ec376f2b71614cc0$export$3bc3c9693a40aa);
    $parcel$export(module.exports, "AuthorGroup", ()=>$ec376f2b71614cc0$export$2ae2af4435dd6144);
    $parcel$export(module.exports, "ChecklistProgress", ()=>$ec376f2b71614cc0$export$5742b38fd5cfe410);
    $parcel$export(module.exports, "CollaboratorGroup", ()=>$ec376f2b71614cc0$export$a1e647014985ddb9);
    $parcel$export(module.exports, "CommentCount", ()=>$ec376f2b71614cc0$export$f4c1466e6fdd07b);
    $parcel$export(module.exports, "CreatedOn", ()=>$ec376f2b71614cc0$export$53ced9403d373871);
    $parcel$export(module.exports, "CreatedBy", ()=>$ec376f2b71614cc0$export$db468caedefbb630);
    $parcel$export(module.exports, "DueOn", ()=>$ec376f2b71614cc0$export$fea59459cfa1625b);
    $parcel$export(module.exports, "LatestCommit", ()=>$ec376f2b71614cc0$export$2aa8c58ab6c8ae64);
    $parcel$export(module.exports, "LinkIcon", ()=>$ec376f2b71614cc0$export$69387b41dfc808f7);
    $parcel$export(module.exports, "Location", ()=>$ec376f2b71614cc0$export$18a2be9195644f38);
    $parcel$export(module.exports, "ModifiedBy", ()=>$ec376f2b71614cc0$export$ebbbdcc68d717b7b);
    $parcel$export(module.exports, "ModifiedOn", ()=>$ec376f2b71614cc0$export$a6db3f4240728b58);
    $parcel$export(module.exports, "OwnedBy", ()=>$ec376f2b71614cc0$export$fa04b1f8d953704f);
    $parcel$export(module.exports, "OwnedByGroup", ()=>$ec376f2b71614cc0$export$90e81c873cca1e90);
    $parcel$export(module.exports, "Priority", ()=>$ec376f2b71614cc0$export$300334f671c43555);
    $parcel$export(module.exports, "ProgrammingLanguage", ()=>$ec376f2b71614cc0$export$7904b5485bf997ea);
    $parcel$export(module.exports, "Provider", ()=>$ec376f2b71614cc0$export$2881499e37b75b9a);
    $parcel$export(module.exports, "ReactCount", ()=>$ec376f2b71614cc0$export$f69df2decd5f729e);
    $parcel$export(module.exports, "ReadTime", ()=>$ec376f2b71614cc0$export$77dedcd16f070a20);
    $parcel$export(module.exports, "SentOn", ()=>$ec376f2b71614cc0$export$897b145a1ed39fe5);
    $parcel$export(module.exports, "SourceBranch", ()=>$ec376f2b71614cc0$export$387c3264a8f67d61);
    $parcel$export(module.exports, "State", ()=>$ec376f2b71614cc0$export$7254cc27399e90bd);
    $parcel$export(module.exports, "SubscriberCount", ()=>$ec376f2b71614cc0$export$cfafe90bba8a54db);
    $parcel$export(module.exports, "SubTasksProgress", ()=>$ec376f2b71614cc0$export$d441f34e4c8dd9e7);
    $parcel$export(module.exports, "StoryPoints", ()=>$ec376f2b71614cc0$export$634eef04d1a9a575);
    $parcel$export(module.exports, "TargetBranch", ()=>$ec376f2b71614cc0$export$b5e4199e062b8f44);
    $parcel$export(module.exports, "Title", ()=>$ec376f2b71614cc0$export$f99233281efd08a0);
    $parcel$export(module.exports, "ViewCount", ()=>$ec376f2b71614cc0$export$ae2d8be089b6cfe0);
    $parcel$export(module.exports, "VoteCount", ()=>$ec376f2b71614cc0$export$b080bef6ed7fa75a);
    $parcel$export(module.exports, "Preview", ()=>(parcelRequire("kDhrr")).default);
    $parcel$export(module.exports, "Snippet", ()=>(parcelRequire("kp8aU")).default);
    var $8dVIb;
    var $eCsaJ;
    var $kDhrr;
    var $kp8aU;
    const $ec376f2b71614cc0$export$d3af56c23f9e459b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo);
    const $ec376f2b71614cc0$export$fbd18f11bf3a3444 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup);
    const $ec376f2b71614cc0$export$3bc3c9693a40aa = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount);
    const $ec376f2b71614cc0$export$2ae2af4435dd6144 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup);
    const $ec376f2b71614cc0$export$5742b38fd5cfe410 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress);
    const $ec376f2b71614cc0$export$a1e647014985ddb9 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup);
    const $ec376f2b71614cc0$export$f4c1466e6fdd07b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CommentCount);
    const $ec376f2b71614cc0$export$53ced9403d373871 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn);
    const $ec376f2b71614cc0$export$db468caedefbb630 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy);
    const $ec376f2b71614cc0$export$fea59459cfa1625b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).DueOn);
    const $ec376f2b71614cc0$export$2aa8c58ab6c8ae64 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit);
    const $ec376f2b71614cc0$export$69387b41dfc808f7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon);
    const $ec376f2b71614cc0$export$18a2be9195644f38 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Location);
    const $ec376f2b71614cc0$export$ebbbdcc68d717b7b = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy);
    const $ec376f2b71614cc0$export$a6db3f4240728b58 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn);
    const $ec376f2b71614cc0$export$fa04b1f8d953704f = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy);
    const $ec376f2b71614cc0$export$90e81c873cca1e90 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup);
    const $ec376f2b71614cc0$export$300334f671c43555 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Priority);
    const $ec376f2b71614cc0$export$7904b5485bf997ea = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage);
    const $ec376f2b71614cc0$export$2881499e37b75b9a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Provider);
    const $ec376f2b71614cc0$export$f69df2decd5f729e = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReactCount);
    const $ec376f2b71614cc0$export$77dedcd16f070a20 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ReadTime);
    const $ec376f2b71614cc0$export$897b145a1ed39fe5 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SentOn);
    const $ec376f2b71614cc0$export$387c3264a8f67d61 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch);
    const $ec376f2b71614cc0$export$7254cc27399e90bd = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).State);
    const $ec376f2b71614cc0$export$cfafe90bba8a54db = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount);
    const $ec376f2b71614cc0$export$d441f34e4c8dd9e7 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress);
    const $ec376f2b71614cc0$export$634eef04d1a9a575 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints);
    const $ec376f2b71614cc0$export$b5e4199e062b8f44 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch);
    const $ec376f2b71614cc0$export$f99233281efd08a0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).Title);
    const $ec376f2b71614cc0$export$ae2d8be089b6cfe0 = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).ViewCount);
    const $ec376f2b71614cc0$export$b080bef6ed7fa75a = (0, (0, parcelRequire("eCsaJ")).createElement)((0, (0, parcelRequire("8dVIb")).ElementName).VoteCount);
});
parcelRegister("eCsaJ", function(module, exports) {
    $parcel$export(module.exports, "createElement", ()=>$3c92d860530d8c8b$export$c8a8987d4410bf2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $9tslm;
    var $4ZXUA;
    var $7IZqM;
    var $bWpL0;
    var $aWyvu;
    var $3dV67;
    var $cJxXG;
    var $77cM6;
    var $k39kU;
    const $3c92d860530d8c8b$var$elementMappings = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Attachment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).CheckItem
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Comment
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).View
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).React
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Vote
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: {
            component: (0, (0, parcelRequire("4ZXUA")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Commit
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: {
            component: (0, (0, parcelRequire("aWyvu")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: {
            component: (0, (0, parcelRequire("77cM6")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: {
            component: (0, (0, parcelRequire("7IZqM")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: {
            component: (0, (0, parcelRequire("bWpL0")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: {
            component: (0, (0, parcelRequire("cJxXG")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).Subscriber
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: {
            component: (0, (0, parcelRequire("7IZqM")).default),
            props: {
                icon: (0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress
            }
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: {
            component: (0, (0, parcelRequire("9tslm")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: {
            component: (0, (0, parcelRequire("k39kU")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: {
            component: (0, (0, parcelRequire("3dV67")).default)
        },
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: {
            component: (0, (0, parcelRequire("3dV67")).default),
            props: {
                theme: (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey
            }
        }
    };
    const $3c92d860530d8c8b$var$getContextKey = (name)=>{
        return name.length > 0 ? name.charAt(0).toLowerCase() + name.slice(1) : undefined;
    };
    const $3c92d860530d8c8b$var$getData = (elementName, contextKey, context)=>{
        if (!context) return undefined;
        const data = context[contextKey];
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup:
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                const AvatarGroupsWithFallback = [
                    (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup
                ];
                const showFallbackAvatar = AvatarGroupsWithFallback.includes(elementName);
                return $3c92d860530d8c8b$var$toAvatarGroupProps(data, showFallbackAvatar);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress:
            case (0, (0, parcelRequire("8dVIb")).ElementName).CommentCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ViewCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReactCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).VoteCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount:
            case (0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit:
            case (0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress:
                return $3c92d860530d8c8b$var$toBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints:
                return $3c92d860530d8c8b$var$toAtlaskitBadgeProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).created_by, context.createdBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).assigned_to, context.assignedTo);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).owned_by, context.ownedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('created', context.createdOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).DueOn:
                return $3c92d860530d8c8b$var$toDateLozengeProps(context.dueOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).modified_by, context.modifiedBy);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('modified', context.modifiedOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SentOn:
                return $3c92d860530d8c8b$var$toDateTimeProps('sent', context.sentOn);
            case (0, (0, parcelRequire("8dVIb")).ElementName).ReadTime:
                return $3c92d860530d8c8b$var$toFormattedTextProps((0, (0, parcelRequire("7zaVw")).messages).read_time, data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch:
            case (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch:
                return $3c92d860530d8c8b$var$toTextProps(data);
            case (0, (0, parcelRequire("8dVIb")).ElementName).Title:
                return $3c92d860530d8c8b$var$toLinkProps(context.title, context.url);
            default:
                return typeof data === 'object' ? data : undefined;
        }
    };
    const $3c92d860530d8c8b$var$toAvatarGroupProps = (items, showFallbackAvatar)=>{
        return items ? {
            items: items
        } : showFallbackAvatar ? {
            items: []
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toBadgeProps = (label)=>{
        return label ? {
            label: label
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toAtlaskitBadgeProps = (value)=>{
        return value ? {
            value: value
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toDateLozengeProps = (dateString)=>{
        if (dateString) {
            const text = Date.parse(dateString) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VHMR")).FormattedDate), {
                value: new Date(dateString),
                year: "numeric",
                month: "short",
                day: "numeric",
                formatMatcher: "best fit"
            }) : dateString;
            return {
                text: text
            };
        }
    };
    const $3c92d860530d8c8b$var$toDateTimeProps = (type, dateString)=>{
        return dateString ? {
            date: new Date(dateString),
            type: type
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toFormattedTextProps = (descriptor, context)=>{
        return context ? {
            message: {
                descriptor: descriptor,
                values: {
                    context: context
                }
            }
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toLinkProps = (text, url)=>{
        return text ? {
            text: text,
            url: url
        } : undefined;
    };
    const $3c92d860530d8c8b$var$toTextProps = (content)=>{
        return content ? {
            content: content
        } : undefined;
    };
    const $3c92d860530d8c8b$export$c8a8987d4410bf2d = (name)=>{
        const { component: BaseElement, props: props } = $3c92d860530d8c8b$var$elementMappings[name] || {};
        const contextKey = $3c92d860530d8c8b$var$getContextKey(name);
        if (!BaseElement) throw Error(`Element ${name} does not exist.`);
        return (overrides)=>{
            const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
            const data = $3c92d860530d8c8b$var$getData(name, contextKey, context);
            return data ? (0, ($parcel$interopDefault($5uXOq))).createElement(BaseElement, {
                ...props,
                ...data,
                ...overrides,
                name: name
            }) : null;
        };
    };
});
parcelRegister("9tslm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf2a1e857857107e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $16T6Y;
    function $bf2a1e857857107e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bf2a1e857857107e$var$badgeStyles = {
        name: "qowjig",
        styles: "align-items:center;display:inline-flex"
    };
    const $bf2a1e857857107e$var$AtlaskitBadge = ({ value: value, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-atlaskit-badge' })=>{
        if (!value) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $bf2a1e857857107e$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-atlaskit-badge": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("16T6Y")).default), null, value));
    };
    var $bf2a1e857857107e$export$2e2bcd8739ae039 = $bf2a1e857857107e$var$AtlaskitBadge;
});
parcelRegister("16T6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fe7856b71523badd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $ehtcU;
    function $fe7856b71523badd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $fe7856b71523badd$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $fe7856b71523badd$var$neutral300 = '#DDDEE1';
    const $fe7856b71523badd$var$red300 = '#FD9891';
    const $fe7856b71523badd$var$blue300 = '#8FB8F6';
    const $fe7856b71523badd$var$neutral1000 = '#292A2E';
    const $fe7856b71523badd$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$neutral300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$red300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $fe7856b71523badd$var$blue300,
            color: $fe7856b71523badd$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $fe7856b71523badd$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $fe7856b71523badd$var$styles.root,
                $fe7856b71523badd$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $fe7856b71523badd$var$backgroundColors[appearance],
            xcss: $fe7856b71523badd$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $fe7856b71523badd$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("ehtcU")).formatValue)(children, max) : children));
    });
    $fe7856b71523badd$var$Badge.displayName = 'Badge';
    var $fe7856b71523badd$export$2e2bcd8739ae039 = $fe7856b71523badd$var$Badge;
    const $fe7856b71523badd$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $fe7856b71523badd$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("ehtcU", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$24d41a560822020b$export$7c4d25c0c3217d8c);
    function $24d41a560822020b$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $24d41a560822020b$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $24d41a560822020b$var$getSafeValue(value);
        const safeMax = $24d41a560822020b$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("4ZXUA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e655d051c837701$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $jnhNB;
    var $8dVIb;
    var $7zaVw;
    var $fpDmE;
    function $1e655d051c837701$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1e655d051c837701$var$MAX_COUNT = 4;
    var $1e655d051c837701$var$_ref = {
        name: "1brfzli",
        styles: "display:inline-flex;ul{margin-right:var(--ds-space-100, 0.5rem);margin-top:0;}"
    };
    const $1e655d051c837701$var$getStyles = (size)=>{
        const styles = $1e655d051c837701$var$_ref;
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return styles;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)(styles, " li{span,svg{max-height:1.25rem;max-width:1.25rem;}}");
        }
    };
    const $1e655d051c837701$var$getPersonNameWithPrefix = (elementName, personName, intl)=>{
        switch(elementName){
            case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).assigned_to, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).owned_by, personName);
            case (0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup:
                return (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).created_by, personName);
            default:
                return personName;
        }
    };
    const $1e655d051c837701$var$AvatarGroup = ({ items: items = [], maxCount: maxCount = $1e655d051c837701$var$MAX_COUNT, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-avatar-group', showNamePrefix: showNamePrefix = false, showFallbackAvatar: showFallbackAvatar = true })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $5uXOq.useMemo)(()=>{
            if (!items.length && showFallbackAvatar) switch(name){
                case (0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup:
                    return [
                        {
                            name: (0, (0, parcelRequire("fpDmE")).getFormattedMessageAsString)(intl, (0, (0, parcelRequire("7zaVw")).messages).unassigned)
                        }
                    ];
                default:
                    return [];
            }
            if (name && items.length === 1 && showNamePrefix) return items.map((person)=>{
                return {
                    ...person,
                    name: $1e655d051c837701$var$getPersonNameWithPrefix(name, person.name, intl) || person.name
                };
            });
            return items;
        }, [
            name,
            items,
            showNamePrefix,
            showFallbackAvatar,
            intl
        ]);
        if (!data.length) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $1e655d051c837701$var$getStyles(size),
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-avatar-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jnhNB")).default), {
            maxCount: maxCount,
            appearance: "stack",
            size: "small",
            data: data,
            testId: testId
        }));
    };
    var $1e655d051c837701$export$2e2bcd8739ae039 = $1e655d051c837701$var$AvatarGroup;
});
parcelRegister("fpDmE", function(module, exports) {
    $parcel$export(module.exports, "sizeToButtonSpacing", ()=>$3ebf94f205ad0182$export$9d642f65a919fb93);
    $parcel$export(module.exports, "getFormattedMessage", ()=>$3ebf94f205ad0182$export$f1aa79f2218fb713);
    $parcel$export(module.exports, "getFormattedMessageAsString", ()=>$3ebf94f205ad0182$export$66ecb50a9dd1768);
    $parcel$export(module.exports, "getIconSizeStyles", ()=>$3ebf94f205ad0182$export$a5dfadfde90ee066);
    $parcel$export(module.exports, "getIconWidth", ()=>$3ebf94f205ad0182$export$fb10bc5609c6347e);
    $parcel$export(module.exports, "importIcon", ()=>$3ebf94f205ad0182$export$6dc831e1a0a7a851);
    $parcel$export(module.exports, "getLinkLineHeight", ()=>$3ebf94f205ad0182$export$1826e889cc97649);
    $parcel$export(module.exports, "getLinkSizeStyles", ()=>$3ebf94f205ad0182$export$7c3a25542ae9da0e);
    $parcel$export(module.exports, "getMaxLineHeight", ()=>$3ebf94f205ad0182$export$a681bd062fee88a5);
    $parcel$export(module.exports, "getMaxLines", ()=>$3ebf94f205ad0182$export$c2293adf1794c09);
    $parcel$export(module.exports, "getPrimitivesInlineSpaceBySize", ()=>$3ebf94f205ad0182$export$475c391af8171fec);
    $parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", ()=>$3ebf94f205ad0182$export$1af10e3728e3a644);
    $parcel$export(module.exports, "getTruncateStyles", ()=>$3ebf94f205ad0182$export$8847c5561c06da49);
    $parcel$export(module.exports, "hasWhiteSpace", ()=>$3ebf94f205ad0182$export$619e376a425cb759);
    $parcel$export(module.exports, "openEmbedModalWithFlexibleUiIcon", ()=>$3ebf94f205ad0182$export$7207d5a516d3bfa8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $4qBtX = parcelRequire("4qBtX");
    var $8dVIb;
    var $2Fcti;
    var $aWyvu;
    const $3ebf94f205ad0182$export$9d642f65a919fb93 = {
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small]: 'none',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large]: 'compact',
        [(0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge]: 'default'
    };
    const $3ebf94f205ad0182$export$f1aa79f2218fb713 = (message)=>{
        if (message) {
            const { descriptor: descriptor, values: values } = message;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...descriptor,
                values: values
            });
        }
    };
    const $3ebf94f205ad0182$export$66ecb50a9dd1768 = (intl, message, context)=>{
        const { formatMessage: formatMessage } = intl;
        return message ? formatMessage(message, {
            context: context
        }) : '';
    };
    const $3ebf94f205ad0182$var$getIconDimensionStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)({
            height: value,
            minHeight: value,
            maxHeight: value,
            width: value,
            minWidth: value,
            maxWidth: value
        });
    const $3ebf94f205ad0182$export$a5dfadfde90ee066 = (width)=>{
        const sizeStyles = $3ebf94f205ad0182$var$getIconDimensionStyles(width);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:0 0 auto;", sizeStyles, " span,svg,img{", sizeStyles, ";}svg{padding:0;}");
    };
    const $3ebf94f205ad0182$export$fb10bc5609c6347e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '2rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return '1rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '.75rem';
        }
    };
    const $3ebf94f205ad0182$export$6dc831e1a0a7a851 = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $3ebf94f205ad0182$export$1826e889cc97649 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $3ebf94f205ad0182$export$7c3a25542ae9da0e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '1.25rem',
                    fontWeight: 400,
                    letterSpacing: '-0.008em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.875rem',
                    fontWeight: 400,
                    letterSpacing: '-0.003em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 400,
                    letterSpacing: '0em',
                    lineHeight: $3ebf94f205ad0182$export$1826e889cc97649(size)
                });
        }
    };
    const $3ebf94f205ad0182$export$a681bd062fee88a5 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1.75;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 1.5;
        }
    };
    const $3ebf94f205ad0182$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
        if (value > max) return defaultValue;
        if (value < min) return min;
        return value;
    };
    const $3ebf94f205ad0182$export$475c391af8171fec = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.100';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.050';
        }
    };
    const $3ebf94f205ad0182$export$1af10e3728e3a644 = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 'space.300';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 'space.250';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 'space.200';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 'space.100';
        }
    };
    const $3ebf94f205ad0182$export$8847c5561c06da49 = (maxLines, lineHeight = '1rem', wordBreak = 'break-word')=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: '-webkit-box',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            wordBreak: wordBreak,
            WebkitLineClamp: maxLines,
            WebkitBoxOrient: 'vertical',
            '@supports not (-webkit-line-clamp: 1)': {
                maxHeight: `calc(${maxLines} * ${lineHeight})`
            }
        });
    const $3ebf94f205ad0182$export$619e376a425cb759 = (str)=>{
        return str.search(/\s/) >= 0;
    };
    const $3ebf94f205ad0182$export$7207d5a516d3bfa8 = ({ linkIcon: linkIcon, ...props })=>{
        const icon = {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWyvu")).default), {
                ...linkIcon,
                size: (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large
            }),
            isFlexibleUi: true
        };
        return (0, (0, parcelRequire("2Fcti")).openEmbedModal)({
            ...props,
            icon: icon,
            origin: 'smartLinkCard'
        });
    };
});
parcelRegister("2Fcti", function(module, exports) {
    $parcel$export(module.exports, "openEmbedModal", ()=>$2555d47e7922f4ad$export$7859f96cd8cff034);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $i5FdW;
    const $2555d47e7922f4ad$var$IFRAME_NAME = 'twp-editor-preview-iframe';
    const $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';
    async function $2555d47e7922f4ad$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
        let popupMountPoint;
        popupMountPoint = document.getElementById($2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID);
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = $2555d47e7922f4ad$var$POPUP_MOUNT_POINT_ID;
            popupMountPoint.setAttribute('data-testid', 'preview-modal');
            document.body.appendChild(popupMountPoint);
        }
        let Modal = await (parcelRequire("1khRa"));
        (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: "en"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Modal.default, {
            ...props,
            iframeName: $2555d47e7922f4ad$var$IFRAME_NAME,
            onClose: (_context)=>{
                if (popupMountPoint) (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(popupMountPoint);
                if (onClose) onClose(_context);
            },
            showModal: true
        })), popupMountPoint);
    }
});
parcelRegister("1khRa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9ytm6")
    ]).then(()=>parcelRequire('amcti'));
});
parcelRegister("aWyvu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6c193b1fc074556$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jOyH3;
    var $8dVIb;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $d6c193b1fc074556$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $d6c193b1fc074556$var$_ref = {
        name: "1xpq7g4",
        styles: "align-self:flex-start;margin:0"
    };
    var $d6c193b1fc074556$var$_ref2 = {
        name: "qbt5ty",
        styles: "align-self:center"
    };
    const $d6c193b1fc074556$var$getPositionStyles = (position)=>{
        switch(position){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center:
                return $d6c193b1fc074556$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top:
            default:
                return $d6c193b1fc074556$var$_ref;
        }
    };
    const $d6c193b1fc074556$var$getIconStyles = (position, width)=>(0, (0, parcelRequire("f8Sb3")).css)($d6c193b1fc074556$var$getPositionStyles(position), (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(width));
    const $d6c193b1fc074556$var$getCustomRenderStyles = (value)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, value), {
            lineHeight: value,
            fontSize: value,
            textAlign: 'center',
            textOverflow: 'clip',
            WebkitBoxOrient: 'unset',
            span: {
                margin: 0,
                padding: 0,
                verticalAlign: 'baseline'
            }
        });
    const $d6c193b1fc074556$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            testId: `${testId}-icon`
        });
    };
    const $d6c193b1fc074556$var$renderDefaultIcon = (label, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
            label: label,
            testId: `${testId}-default`,
            color: "currentColor"
        });
    const $d6c193b1fc074556$var$renderImageIcon = (defaultIcon, url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            defaultIcon: defaultIcon,
            testId: testId,
            url: url
        });
    };
    const $d6c193b1fc074556$var$Icon = ({ icon: icon, overrideIcon: overrideIcon, label: label = 'Link', name: name, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top, overrideCss: overrideCss, render: render, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-icon', url: url })=>{
        const element = (0, $5uXOq.useMemo)(()=>{
            const defaultIcon = $d6c193b1fc074556$var$renderDefaultIcon(label, testId);
            return overrideIcon || render?.() || $d6c193b1fc074556$var$renderImageIcon(defaultIcon, url, testId) || $d6c193b1fc074556$var$renderAtlaskitIcon(icon, testId) || defaultIcon;
        }, [
            overrideIcon,
            icon,
            label,
            render,
            testId,
            url
        ]);
        const width = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const styles = $d6c193b1fc074556$var$getIconStyles(position, width);
        const renderStyles = render ? $d6c193b1fc074556$var$getCustomRenderStyles(width) : undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                styles,
                renderStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-icon": true,
            "data-testid": testId
        }, element);
    };
    var $d6c193b1fc074556$export$2e2bcd8739ae039 = $d6c193b1fc074556$var$Icon;
});
parcelRegister("jOyH3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));
    var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
    function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e6cd993777d46e1b$var$LinkIcon = (props)=>$e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
        }, props));
    $e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
    var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;
});
parcelRegister("9Hdrc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1647af7fe5459c6c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    var $duwKf;
    var $61uoP;
    var $7anl7;
    var $29YN9;
    var $8dVIb;
    const $1647af7fe5459c6c$var$importIconMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).Archive]: ()=>(parcelRequire("1u9rQ")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Audio]: ()=>(parcelRequire("2P3xs")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Code]: ()=>(parcelRequire("boS7Q")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Executable]: ()=>(parcelRequire("ayRxW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).File]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Folder]: ()=>(parcelRequire("2KgZP")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Generic]: ()=>(parcelRequire("5GE4g")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GIF]: ()=>(parcelRequire("gBOzU")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleDocs]: ()=>(parcelRequire("jXySI")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleForms]: ()=>(parcelRequire("k7KGr")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSheets]: ()=>(parcelRequire("5bX2p")),
        [(0, (0, parcelRequire("8dVIb")).IconType).GoogleSlides]: ()=>(parcelRequire("fZksg")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Image]: ()=>(parcelRequire("17GQp")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSExcel]: ()=>(parcelRequire("asJlG")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSPowerpoint]: ()=>(parcelRequire("jHQ8I")),
        [(0, (0, parcelRequire("8dVIb")).IconType).MSWord]: ()=>(parcelRequire("1HfN1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PDF]: ()=>(parcelRequire("5GIkh")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Presentation]: ()=>(parcelRequire("dzrUL")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Sketch]: ()=>(parcelRequire("ktas1")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Spreadsheet]: ()=>(parcelRequire("dcnwM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Template]: ()=>(parcelRequire("kLx2P")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Video]: ()=>(parcelRequire("8Cn4N")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Branch]: ()=>(parcelRequire("8OYab")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Commit]: ()=>(parcelRequire("9Ls0O")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Project]: ()=>Promise.resolve((parcelRequire("kFO36"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).PullRequest]: ()=>(parcelRequire("bLx4v")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Repo]: ()=>(parcelRequire("g7B05")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Bug]: ()=>Promise.resolve((parcelRequire("cQpjg"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Change]: ()=>(parcelRequire("hvvgH")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Epic]: ()=>(parcelRequire("i5w36")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Incident]: ()=>(parcelRequire("jCmVW")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Problem]: ()=>(parcelRequire("jWILw")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ServiceRequest]: ()=>Promise.resolve((parcelRequire("lLgcu"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Story]: ()=>Promise.resolve((parcelRequire("g2bjw"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTask]: ()=>(parcelRequire("4pfB7")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Task]: ()=>Promise.resolve((parcelRequire("eUrLn"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Confluence]: ()=>Promise.resolve((parcelRequire("7anl7"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                    default: ConfluenceIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Jira]: ()=>Promise.resolve((parcelRequire("29YN9"))).then(({ JiraIcon: JiraIcon })=>({
                    default: JiraIcon
                })),
        [(0, (0, parcelRequire("8dVIb")).IconType).Default]: ()=>Promise.resolve((parcelRequire("458iJ"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Error]: ()=>Promise.resolve((parcelRequire("7nnPp"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Forbidden]: ()=>(parcelRequire("9xScK")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Attachment]: ()=>(parcelRequire("4zmmA")),
        [(0, (0, parcelRequire("8dVIb")).IconType).CheckItem]: ()=>Promise.resolve((parcelRequire("imUQY"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).Comment]: ()=>(parcelRequire("kCKH6")),
        [(0, (0, parcelRequire("8dVIb")).IconType).View]: ()=>Promise.resolve((parcelRequire("bH0nF"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).React]: ()=>(parcelRequire("gmFhf")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Vote]: ()=>(parcelRequire("oYZun")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: ()=>(parcelRequire("L5NMF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: ()=>(parcelRequire("dBeMd")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: ()=>(parcelRequire("1drkv")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: ()=>(parcelRequire("ivKwz")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: ()=>(parcelRequire("8XsoF")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: ()=>(parcelRequire("a3VWM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: ()=>(parcelRequire("2Kdus")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: ()=>(parcelRequire("6UcdR")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: ()=>(parcelRequire("8eqKo")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: ()=>(parcelRequire("hHzrM")),
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: ()=>(parcelRequire("fzaCl")),
        [(0, (0, parcelRequire("8dVIb")).IconType).ProgrammingLanguage]: ()=>(parcelRequire("6Hg82")),
        [(0, (0, parcelRequire("8dVIb")).IconType).Subscriber]: ()=>Promise.resolve((parcelRequire("h8cgU"))),
        [(0, (0, parcelRequire("8dVIb")).IconType).SubTasksProgress]: ()=>(parcelRequire("8B9kt"))
    };
    const $1647af7fe5459c6c$var$getIconImportFn = (icon)=>$1647af7fe5459c6c$var$importIconMapper[icon];
    const $1647af7fe5459c6c$var$importIcon = (importFn)=>{
        return (0, ($parcel$interopDefault($4qBtX)))({
            loader: ()=>importFn().then((module)=>module.default),
            loading: ()=>null
        });
    };
    const $1647af7fe5459c6c$var$AtlaskitIcon = ({ icon: icon, label: label, testId: testId })=>{
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Document:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("duwKf"))))), {
                    label: label || 'document',
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Blog:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61uoP"))))), {
                    label: label || 'blog',
                    testId: testId
                });
        }
        const importFn = $1647af7fe5459c6c$var$getIconImportFn(icon);
        if (!importFn) return null;
        const ImportedIcon = $1647af7fe5459c6c$var$importIcon(importFn);
        switch(icon){
            case (0, (0, parcelRequire("8dVIb")).IconType).Confluence:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7anl7")).ConfluenceIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Jira:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("29YN9")).JiraIcon), {
                    appearance: "brand",
                    testId: testId
                });
            case (0, (0, parcelRequire("8dVIb")).IconType).Error:
            case (0, (0, parcelRequire("8dVIb")).IconType).Forbidden:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId,
                    primaryColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
                });
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
                    label: label,
                    testId: testId
                });
        }
    };
    var $1647af7fe5459c6c$export$2e2bcd8739ae039 = $1647af7fe5459c6c$var$AtlaskitIcon;
});
parcelRegister("61uoP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $462a6acb8358e55a$var$_react = $462a6acb8358e55a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $462a6acb8358e55a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $462a6acb8358e55a$var$Blog16Icon = (props)=>$462a6acb8358e55a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M6.972 6.128a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325m7 0a2.5 2.5 0 1 0-2.37 2.87q-.416.59-1.016 1.265a.916.916 0 0 0-.058 1.147.607.607 0 0 0 .948.043q2.908-3.331 2.496-5.325M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2"/></svg>`
        }, props, {
            size: "small"
        }));
    $462a6acb8358e55a$var$Blog16Icon.displayName = 'Blog16Icon';
    var $462a6acb8358e55a$var$_default = module.exports.default = $462a6acb8358e55a$var$Blog16Icon;
});
parcelRegister("7anl7", function(module, exports) {
    $parcel$export(module.exports, "ConfluenceIcon", ()=>$1c9c2365ff37a453$export$68f3db7f6af48bcb);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $1c9c2365ff37a453$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
    };
    const $1c9c2365ff37a453$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $1c9c2365ff37a453$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            size: size,
            testId: testId,
            textColor: textColor
        });
    };
});
parcelRegister("kLx2P", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dtoNN").then(()=>parcelRequire('53J27'));
});
parcelRegister("8OYab", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a8V9r").then(()=>parcelRequire('36B8O'));
});
parcelRegister("9Ls0O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OCkL").then(()=>parcelRequire('gSpCs'));
});
parcelRegister("bLx4v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVi2f").then(()=>parcelRequire('jXbwR'));
});
parcelRegister("g7B05", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("keZKc").then(()=>parcelRequire('9wmko'));
});
parcelRegister("hvvgH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aFtbU").then(()=>parcelRequire('lThgm'));
});
parcelRegister("i5w36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6i1Ed").then(()=>parcelRequire('lxe7t'));
});
parcelRegister("jCmVW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("huO2I").then(()=>parcelRequire('kiHC6'));
});
parcelRegister("jWILw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7GK64").then(()=>parcelRequire('eNbic'));
});
parcelRegister("4pfB7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("laRGo").then(()=>parcelRequire('ePeTp'));
});
parcelRegister("9xScK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("j1srk").then(()=>parcelRequire('gs7PQ'));
});
parcelRegister("4zmmA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gWXGh").then(()=>parcelRequire('j3Vfq'));
});
parcelRegister("kCKH6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a5nLi").then(()=>parcelRequire('DBbS0'));
});
parcelRegister("gmFhf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cj5mx").then(()=>parcelRequire('kxkv9'));
});
parcelRegister("oYZun", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7SKVs").then(()=>parcelRequire('kAObg'));
});
parcelRegister("L5NMF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2JrEQ").then(()=>parcelRequire('jJL9z'));
});
parcelRegister("dBeMd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("czPXX").then(()=>parcelRequire('3pKEh'));
});
parcelRegister("1drkv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bW2Ht").then(()=>parcelRequire('k7gBp'));
});
parcelRegister("ivKwz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jlDVs").then(()=>parcelRequire('Le10t'));
});
parcelRegister("8XsoF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9n8Rc").then(()=>parcelRequire('kc1MS'));
});
parcelRegister("a3VWM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a0ALI").then(()=>parcelRequire('hfn9j'));
});
parcelRegister("2Kdus", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kFjg9").then(()=>parcelRequire('4zl0K'));
});
parcelRegister("6UcdR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("50gXn").then(()=>parcelRequire('cfbO3'));
});
parcelRegister("8eqKo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1Bya1").then(()=>parcelRequire('jyFo7'));
});
parcelRegister("hHzrM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6xK7c").then(()=>parcelRequire('eJNZM'));
});
parcelRegister("fzaCl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8YLm9")
    ]).then(()=>parcelRequire('7QGmb'));
});
parcelRegister("6Hg82", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iY2wN").then(()=>parcelRequire('c2JK5'));
});
parcelRegister("8B9kt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("10dT8").then(()=>parcelRequire('gKopa'));
});
parcelRegister("l5Xsv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$951590e808a48e01$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $bmnhy = parcelRequire("bmnhy");
    var $gU02S;
    const $951590e808a48e01$var$ImageIcon = ({ defaultIcon: defaultIcon, testId: testId, url: url, onError: onError, onLoad: onLoad })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($bmnhy))), {
            src: url,
            loading: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
                testId: `${testId}-loading`
            }),
            loaded: (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                src: url,
                "data-testid": `${testId}-image`
            }),
            errored: defaultIcon,
            onError: onError,
            onLoad: onLoad
        });
    var $951590e808a48e01$export$2e2bcd8739ae039 = $951590e808a48e01$var$ImageIcon;
});
parcelRegister("bmnhy", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $8453cf1ee7ef4644$var$_createClass = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
    var $5uXOq = parcelRequire("5uXOq");
    var $8453cf1ee7ef4644$var$React = $8453cf1ee7ef4644$var$_interopRequireWildcard($5uXOq);
    function $8453cf1ee7ef4644$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $8453cf1ee7ef4644$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $8453cf1ee7ef4644$var$_possibleConstructorReturn(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }
    function $8453cf1ee7ef4644$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }
    function $8453cf1ee7ef4644$var$loading(image) {
        return {
            image: image,
            isLoaded: false,
            isErrored: false
        };
    }
    function $8453cf1ee7ef4644$var$loaded() {
        return {
            isLoaded: true
        };
    }
    function $8453cf1ee7ef4644$var$errored() {
        return {
            isErrored: true
        };
    }
    function $8453cf1ee7ef4644$var$hasPropsChanged(prevProps, nextProps) {
        var prevSrc = prevProps.src;
        var nextSrc = nextProps.src;
        return prevSrc !== nextSrc;
    }
    var $8453cf1ee7ef4644$var$ImageRenderer = function(_React$Component) {
        $8453cf1ee7ef4644$var$_inherits(ImageRenderer, _React$Component);
        function ImageRenderer() {
            var _ref;
            var _temp, _this, _ret;
            $8453cf1ee7ef4644$var$_classCallCheck(this, ImageRenderer);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $8453cf1ee7ef4644$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                isLoaded: false,
                isErrored: false
            }, _this.handleLoad = function() {
                var onLoad = _this.props.onLoad;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$loaded(), function() {
                    if (onLoad) onLoad();
                });
            }, _this.handleError = function() {
                var onError = _this.props.onError;
                _this.unload();
                _this.setState($8453cf1ee7ef4644$var$errored(), function() {
                    if (onError) onError();
                });
            }, _temp), $8453cf1ee7ef4644$var$_possibleConstructorReturn(_this, _ret);
        }
        $8453cf1ee7ef4644$var$_createClass(ImageRenderer, [
            {
                key: 'load',
                value: function load() {
                    var src = this.props.src;
                    var image = this.state.image;
                    if (image) {
                        image.onload = this.handleLoad;
                        image.onerror = this.handleError;
                        image.src = src;
                    }
                }
            },
            {
                key: 'unload',
                value: function unload() {
                    var image = this.state.image;
                    if (image) {
                        image.onload = undefined;
                        image.onerror = undefined;
                    }
                }
            },
            {
                key: 'componentWillMount',
                value: function componentWillMount() {
                    if (typeof window === 'undefined') return;
                    this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.load();
                }
            },
            {
                key: 'componentWillReceiveProps',
                value: function componentWillReceiveProps(nextProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(this.props, nextProps)) this.setState($8453cf1ee7ef4644$var$loading(new Image()));
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps) {
                    if ($8453cf1ee7ef4644$var$hasPropsChanged(prevProps, this.props)) {
                        this.unload();
                        this.load();
                    }
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.unload();
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                    var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                    if (isLoaded && loaded) return loaded;
                    if (isErrored && errored) return errored;
                    if (!isLoaded && !isErrored && loading) return loading;
                    if (children) return children({
                        image: isLoaded ? image : undefined,
                        loaded: isLoaded,
                        errored: isErrored
                    });
                    return null;
                }
            }
        ]);
        return ImageRenderer;
    }($8453cf1ee7ef4644$var$React.Component);
    module.exports.default = $8453cf1ee7ef4644$var$ImageRenderer;
});
parcelRegister("gU02S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$880176eb12ae8419$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $880176eb12ae8419$var$LoadingSkeleton = ({ testId: testId, width: width, height: height })=>{
        const animationNameStyles = (0, (0, parcelRequire("f8Sb3")).keyframes)({
            '0%': {
                backgroundPosition: '50% 0'
            },
            '100%': {
                backgroundPosition: '-50% 0'
            }
        });
        const styles = (0, (0, parcelRequire("f8Sb3")).css)({
            width: `${width}rem`,
            height: `${height}rem`,
            borderRadius: '2px',
            userSelect: 'none',
            background: "var(--ds-skeleton-subtle, #f6f7f8)",
            backgroundImage: `linear-gradient( to right, transparent 0%, ${"var(--ds-skeleton, #edeef1)"} 20%, transparent 40%, transparent 100% )`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '280% 100%',
            display: 'inline-block',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: animationNameStyles,
            animationTimingFunction: 'linear'
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: styles,
            "data-testid": testId
        });
    };
    var $880176eb12ae8419$export$2e2bcd8739ae039 = $880176eb12ae8419$var$LoadingSkeleton;
});
parcelRegister("7IZqM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aab9f19acb0d3ec1$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $7zaVw;
    var $9Hdrc;
    var $l5Xsv;
    var $fpDmE;
    function $aab9f19acb0d3ec1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $aab9f19acb0d3ec1$var$badgeStyles = {
        name: "9qxyko",
        styles: "align-items:center;display:inline-flex;min-width:fit-content"
    };
    const $aab9f19acb0d3ec1$var$iconStyles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-icon-subtle, #626F86);line-height:0;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('1rem'), " img,span,svg{line-height:0;vertical-align:middle;}");
    const $aab9f19acb0d3ec1$var$labelStyles = {
        name: "8loelm",
        styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;padding-left:var(--ds-space-025, 0.125rem);vertical-align:middle"
    };
    const $aab9f19acb0d3ec1$var$messageMapper = {
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityBlocker]: (0, (0, parcelRequire("7zaVw")).messages).priority_blocker,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityCritical]: (0, (0, parcelRequire("7zaVw")).messages).priority_critical,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHigh]: (0, (0, parcelRequire("7zaVw")).messages).priority_high,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityHighest]: (0, (0, parcelRequire("7zaVw")).messages).priority_highest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLow]: (0, (0, parcelRequire("7zaVw")).messages).priority_low,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityLowest]: (0, (0, parcelRequire("7zaVw")).messages).priority_lowest,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMajor]: (0, (0, parcelRequire("7zaVw")).messages).priority_major,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMedium]: (0, (0, parcelRequire("7zaVw")).messages).priority_medium,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityMinor]: (0, (0, parcelRequire("7zaVw")).messages).priority_minor,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityTrivial]: (0, (0, parcelRequire("7zaVw")).messages).priority_trivial,
        [(0, (0, parcelRequire("8dVIb")).IconType).PriorityUndefined]: (0, (0, parcelRequire("7zaVw")).messages).priority_undefined
    };
    const $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon = (icon)=>{
        if (icon) {
            const descriptor = $aab9f19acb0d3ec1$var$messageMapper[icon];
            if (descriptor) return (0, (0, parcelRequire("fpDmE")).getFormattedMessage)({
                descriptor: descriptor
            });
        }
    };
    const $aab9f19acb0d3ec1$var$renderAtlaskitIcon = (icon, testId)=>{
        if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Hdrc")).default), {
            icon: icon,
            label: icon,
            testId: `${testId}-icon`
        });
    };
    const $aab9f19acb0d3ec1$var$renderImageIcon = (url, testId)=>{
        if (url) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: testId,
            url: url
        });
    };
    const $aab9f19acb0d3ec1$var$Badge = ({ hideIcon: hideIcon = false, icon: icon, label: label, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-badge', url: url })=>{
        const formattedMessageOrLabel = $aab9f19acb0d3ec1$var$getFormattedMessageFromIcon(icon) || label;
        const badgeIcon = $aab9f19acb0d3ec1$var$renderAtlaskitIcon(icon, testId) || $aab9f19acb0d3ec1$var$renderImageIcon(url, testId);
        if (!formattedMessageOrLabel || !badgeIcon) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $aab9f19acb0d3ec1$var$badgeStyles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-badge": true,
            "data-testid": testId
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$iconStyles
        }, badgeIcon), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aab9f19acb0d3ec1$var$labelStyles,
            "data-testid": `${testId}-label`
        }, formattedMessageOrLabel));
    };
    var $aab9f19acb0d3ec1$export$2e2bcd8739ae039 = $aab9f19acb0d3ec1$var$Badge;
});
parcelRegister("bWpL0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66a4f7878d6976fe$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $j7anB;
    var $ousew;
    var $koVbs;
    var $7zaVw;
    var $fpDmE;
    const $66a4f7878d6976fe$var$styles = (0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1));
    const $66a4f7878d6976fe$var$typeToDescriptorMap = {
        created: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).created_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).created_on_absolute
        },
        modified: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).modified_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).modified_on_absolute
        },
        sent: {
            relative: (0, (0, parcelRequire("7zaVw")).messages).sent_on_relative,
            absolute: (0, (0, parcelRequire("7zaVw")).messages).sent_on_absolute
        }
    };
    const $66a4f7878d6976fe$var$DateTime = ({ date: date, name: name, overrideCss: overrideCss, type: type, testId: testId = 'smart-element-date-time', text: text })=>{
        const { formatRelativeTime: formatRelativeTime, formatDate: formatDate } = (0, (0, parcelRequire("koVbs")).default)();
        if (!type || !date) return null;
        const isLongerThenWeek = Math.abs(date.getTime() - Date.now()) > 604800000;
        let context;
        let typeVariant;
        if (isLongerThenWeek) {
            typeVariant = 'absolute';
            context = formatDate(date, {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        } else {
            const { value: value, unit: unit } = (0, (0, parcelRequire("j7anB")).selectUnit)(date, Date.now());
            typeVariant = 'relative';
            context = formatRelativeTime(value, unit, {
                numeric: 'auto'
            });
        }
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $66a4f7878d6976fe$var$styles,
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-date-time": true,
            "data-testid": testId
        }, text ? `${text} ${context}` : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...$66a4f7878d6976fe$var$typeToDescriptorMap[type][typeVariant],
            values: {
                context: context
            }
        }));
    };
    var $66a4f7878d6976fe$export$2e2bcd8739ae039 = $66a4f7878d6976fe$var$DateTime;
});
parcelRegister("3dV67", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b60bb11df77d728a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3bDjY;
    var $8dVIb;
    var $4URMI;
    var $fpDmE;
    function $b60bb11df77d728a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b60bb11df77d728a$var$DEFAULT_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MAXIMUM_MAX_LINES = 2;
    const $b60bb11df77d728a$var$MINIMUM_MAX_LINES = 1;
    const $b60bb11df77d728a$var$containerStyles = {
        name: "mkkf9p",
        styles: "flex:1 1 auto"
    };
    var $b60bb11df77d728a$var$_ref = {
        name: "16ucc2m",
        styles: "color:var(--ds-link, #0C66E4);:active{color:var(--ds-link-pressed, #0055CC);}:hover{color:var(--ds-link, #0C66E4);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref2 = {
        name: "1glvof",
        styles: "color:var(--ds-text-subtle, #44546F);:active{color:var(--ds-text, #172B4D);}:hover{color:var(--ds-text-subtle, #44546F);text-decoration:underline;}"
    };
    var $b60bb11df77d728a$var$_ref3 = {
        name: "izk992",
        styles: "a&{color:var(--ds-text-subtlest, #626F86);&:active, &:visited, &:focus, &:hover{color:var(--ds-text-subtlest, #626F86);text-decoration:underline;}font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);}"
    };
    const $b60bb11df77d728a$var$getThemeStyles = (theme)=>{
        switch(theme){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkInternalTheme).Grey:
                return $b60bb11df77d728a$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Black:
                return $b60bb11df77d728a$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link:
            default:
                return $b60bb11df77d728a$var$_ref;
        }
    };
    const $b60bb11df77d728a$var$getAnchorStyles = (size, theme, maxLines, hasSpace)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;", sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size), hasSpace ? 'break-word' : 'break-all'), $b60bb11df77d728a$var$getThemeStyles(theme));
    };
    const $b60bb11df77d728a$var$getMaxLines = (maxLines)=>{
        if (maxLines > $b60bb11df77d728a$var$MAXIMUM_MAX_LINES) return $b60bb11df77d728a$var$DEFAULT_MAX_LINES;
        if (maxLines < $b60bb11df77d728a$var$MINIMUM_MAX_LINES) return $b60bb11df77d728a$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $b60bb11df77d728a$var$withTooltip = (trigger, content, testId)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: content,
            testId: `${testId}-tooltip`,
            tag: "span"
        }, trigger);
    const $b60bb11df77d728a$var$Link = ({ hideTooltip: hideTooltip, maxLines: maxLines = $b60bb11df77d728a$var$DEFAULT_MAX_LINES, name: name, overrideCss: overrideCss, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-link', text: text, theme: theme = (0, (0, parcelRequire("8dVIb")).SmartLinkTheme).Link, url: url, onClick: onClick, target: target = '_blank' })=>{
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const hasSpace = (0, $5uXOq.useMemo)(()=>text ? (0, (0, parcelRequire("fpDmE")).hasWhiteSpace)(text) : false, [
            text
        ]);
        const anchor = (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            css: [
                $b60bb11df77d728a$var$getAnchorStyles(size, theme, $b60bb11df77d728a$var$getMaxLines(maxLines), hasSpace),
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-link": true,
            "data-testid": testId,
            onClick: onClick,
            onMouseDown: onMouseDown,
            href: url,
            ...target !== '_self' && {
                target: target
            }
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $b60bb11df77d728a$var$containerStyles
        }, hideTooltip || text === undefined ? anchor : $b60bb11df77d728a$var$withTooltip(anchor, text, testId));
    };
    var $b60bb11df77d728a$export$2e2bcd8739ae039 = $b60bb11df77d728a$var$Link;
});
parcelRegister("cJxXG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af9c30eaf441ad65$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $lj8SI;
    var $Nh1XU;
    var $a4DH1;
    function $af9c30eaf441ad65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $af9c30eaf441ad65$var$styles = {
        name: "cvfhjc",
        styles: "display:inline-flex;line-height:inherit"
    };
    const $af9c30eaf441ad65$var$Lozenge = ({ action: action, appearance: appearance = 'default', name: name, overrideCss: overrideCss, style: style, text: text, testId: testId = 'smart-element-lozenge' })=>{
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        if (!text) return null;
        const lozenge = action ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a4DH1")).default), {
            action: action,
            appearance: appearance,
            testId: testId,
            text: text,
            zIndex: ui?.zIndex
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance,
            style: style,
            testId: `${testId}-lozenge`
        }, text);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af9c30eaf441ad65$var$styles,
                overrideCss
            ],
            "data-fit-to-content": true,
            "data-smart-element": name,
            "data-smart-element-lozenge": true,
            "data-testid": testId
        }, lozenge);
    };
    var $af9c30eaf441ad65$export$2e2bcd8739ae039 = $af9c30eaf441ad65$var$Lozenge;
});
parcelRegister("a4DH1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ceba18caf6f022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $BLPHT;
    var $a1vqi;
    var $dlJZx;
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $gDUps;
    var $fzJZi;
    var $cLKee;
    var $dMzTJ;
    var $j6VJk;
    var $1s0lY;
    var $kf01E;
    var $4Dg4o;
    const $27ceba18caf6f022$var$validateItems = (items = [], text)=>{
        return items.filter((item)=>item.text !== text);
    };
    const $27ceba18caf6f022$var$LozengeAction = ({ action: action, appearance: appearance, testId: testId = 'smart-element-lozenge-action', text: text, zIndex: zIndex })=>{
        const [selected, setSelected] = (0, $5uXOq.useState)({
            appearance: appearance,
            text: text
        });
        const [isLoaded, setIsLoaded] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [items, setItems] = (0, $5uXOq.useState)();
        const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            setSelected({
                text: text,
                appearance: appearance
            });
        }, [
            text,
            appearance
        ]);
        const { url: url, id: linkId, previewData: previewData } = action?.update?.details || {};
        const handleOpenChange = (0, $5uXOq.useCallback)(async (args)=>{
            setIsOpen(args.isOpen);
            if (args.isOpen) {
                analytics?.ui.smartLinkLozengeActionClickedEvent();
                fireEvent('track.smartLinkQuickAction.started', {
                    smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                });
                if (!isLoaded && action?.read) try {
                    setIsLoading(true);
                    const responseItems = await invoke(action.read, (0, (0, parcelRequire("dlJZx")).default));
                    const validItems = typeof text === 'string' ? $27ceba18caf6f022$var$validateItems(responseItems, text) : responseItems;
                    setItems(validItems);
                    setIsLoaded(true);
                    if (validItems?.length === 0) {
                        fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).permissionLoadErrorAnalyticsPayload));
                        setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).noData);
                        setIsLoaded(false);
                    }
                } catch (err) {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).unknown);
                    setIsLoaded(false);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).unknownLoadErrorAnalyticsPayload));
                } finally{
                    setIsLoading(false);
                }
            }
            if (!args.isOpen) setErrorMessage(undefined);
        }, [
            action.read,
            analytics,
            invoke,
            isLoaded,
            text,
            fireEvent
        ]);
        const trigger = (0, $5uXOq.useCallback)((props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4Dg4o")).default), {
                ...props,
                appearance: selected.appearance,
                isOpen: isOpen,
                testId: testId,
                text: selected.text
            }), [
            selected.appearance,
            selected.text,
            isOpen,
            testId
        ]);
        const handleItemClick = (0, $5uXOq.useCallback)(async (id, text, appearance)=>{
            try {
                analytics?.ui.smartLinkLozengeActionListItemClickedEvent();
                const updateAction = action?.update;
                if (updateAction && id) {
                    setIsLoading(true);
                    const request = (0, (0, parcelRequire("gDUps")).default)(updateAction, id);
                    await invoke(request);
                    setSelected({
                        appearance: appearance,
                        text: text
                    });
                    setIsLoading(false);
                    setIsLoaded(false);
                    setIsOpen(false);
                    setItems([]);
                    fireEvent('track.smartLinkQuickAction.success', {
                        smartLinkActionType: (0, (0, parcelRequire("fzJZi")).TrackQuickActionType).StatusUpdate
                    });
                    if (url) await reload(url, true, undefined, linkId);
                }
            } catch (err) {
                setIsLoading(false);
                if ((0, (0, parcelRequire("euMlu")).isInvokeCustomError)(err)) {
                    setErrorMessage(err.message);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).validationUpdateErrorAnalyticsPayload));
                } else {
                    setErrorMessage((0, (0, parcelRequire("1s0lY")).LozengeActionErrorMessages).updateFailed);
                    fireEvent('track.smartLinkQuickAction.failed', (0, (0, parcelRequire("dMzTJ")).unknownUpdateErrorAnalyticsPayload));
                }
            }
        }, [
            action?.update,
            analytics,
            invoke,
            linkId,
            reload,
            url,
            fireEvent
        ]);
        const dropdownItemGroup = (0, $5uXOq.useMemo)(()=>{
            if (errorMessage) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("j6VJk")).default), {
                errorMessage: errorMessage,
                testId: testId,
                url: url,
                previewData: previewData
            });
            if (items && items.length > 0) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kf01E")).default), {
                testId: testId,
                items: items,
                onClick: handleItemClick
            });
        }, [
            errorMessage,
            handleItemClick,
            items,
            previewData,
            testId,
            url
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: isLoading,
            isOpen: isOpen,
            onOpenChange: handleOpenChange,
            testId: testId,
            trigger: trigger,
            zIndex: zIndex
        }, dropdownItemGroup);
    };
    var $27ceba18caf6f022$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cLKee")).default)($27ceba18caf6f022$var$LozengeAction);
});
parcelRegister("a1vqi", function(module, exports) {
    $parcel$export(module.exports, "useAnalyticsEvents", ()=>$91130a451fd4887d$export$5bf35293e545f20c);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $1PQcU;
    const $91130a451fd4887d$export$5bf35293e545f20c = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireEvent = (0, $5uXOq.useCallback)((...params)=>{
            const event = createAnalyticsEvent((0, (0, parcelRequire("1PQcU")).default)(...params));
            event.fire((0, $37b399a913bad22b$export$3f072f06b90c3985));
        }, [
            createAnalyticsEvent
        ]);
        return {
            fireEvent: fireEvent
        };
    };
});
const $37b399a913bad22b$export$3f072f06b90c3985 = 'media';
parcelRegister("1PQcU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$539e70e97f68df84$export$2e2bcd8739ae039);
    const $539e70e97f68df84$var$createEventPayload = (eventKey, ...[attributes])=>{
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        };
    };
    var $539e70e97f68df84$export$2e2bcd8739ae039 = $539e70e97f68df84$var$createEventPayload;
});
parcelRegister("dlJZx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6eaacaffc693a3ec$export$2e2bcd8739ae039);
    const $6eaacaffc693a3ec$var$extractLozengeActionItems = (response)=>{
        const items = response?.transitions?.map(({ appearance: appearance, id: id, name: name })=>({
                appearance: appearance ?? 'default',
                id: id,
                text: name
            })) ?? [];
        return items.sort((a, b)=>a.appearance.localeCompare(b.appearance) || a.text.localeCompare(b.text));
    };
    var $6eaacaffc693a3ec$export$2e2bcd8739ae039 = $6eaacaffc693a3ec$var$extractLozengeActionItems;
});
parcelRegister("3q2sI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f5a60e7c58b54588$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iiAnG;
    var $kECas;
    const $f5a60e7c58b54588$var$useInvoke = ()=>{
        const { connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const clientExt = (0, (0, parcelRequire("iiAnG")).useSmartLinkClientExtension)(connections.client);
        return (0, $5uXOq.useCallback)(async (req, cb)=>{
            const response = await clientExt.invoke(req);
            return cb ? cb(response) : response;
        }, [
            clientExt
        ]);
    };
    var $f5a60e7c58b54588$export$2e2bcd8739ae039 = $f5a60e7c58b54588$var$useInvoke;
});
parcelRegister("iiAnG", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkClientExtension", ()=>$ffb669da1b6b71e8$export$303ede4eed148855);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV0Jy;
    var $T540Y;
    var $3b94d;
    const $ffb669da1b6b71e8$export$303ede4eed148855 = (cardClient)=>{
        const resolverUrl = (0, (0, parcelRequire("3b94d")).useResolverUrl)(cardClient);
        const invoke = (0, $5uXOq.useCallback)(async (data)=>{
            try {
                return await (0, (0, parcelRequire("dV0Jy")).request)('post', `${resolverUrl}/invoke`, data, undefined, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
            } catch (err) {
                if (err && err.json && typeof err.json === 'function') {
                    const errorBody = await err.json();
                    if (errorBody) throw new (0, (0, parcelRequire("T540Y")).InvokeError)(errorBody?.error.message, errorBody?.error.status);
                }
                throw err;
            }
        }, [
            resolverUrl
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                invoke: invoke
            }), [
            invoke
        ]);
    };
});
parcelRegister("3b94d", function(module, exports) {
    $parcel$export(module.exports, "useResolverUrl", ()=>$eebf021c5f687360$export$d08617a365fbe694);
    var $5uXOq = parcelRequire("5uXOq");
    var $itO4f;
    const $eebf021c5f687360$export$d08617a365fbe694 = (cardClient)=>(0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("itO4f")).getResolverUrl)(cardClient?.envKey, cardClient?.baseUrlOverride), [
            cardClient?.baseUrlOverride,
            cardClient?.envKey
        ]);
});
parcelRegister("euMlu", function(module, exports) {
    $parcel$export(module.exports, "getInvokeFailureReason", ()=>$0ad6fedaface02c5$export$65b3f792dff0bd60);
    $parcel$export(module.exports, "isInvokeCustomError", ()=>$0ad6fedaface02c5$export$1694272377fa07d8);
    var $fzJZi;
    const $0ad6fedaface02c5$export$65b3f792dff0bd60 = (err)=>{
        if (!$0ad6fedaface02c5$export$1694272377fa07d8(err)) return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        switch(err?.errorCode){
            case 403:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).PermissionError;
            default:
                return (0, (0, parcelRequire("fzJZi")).TrackQuickActionFailureReason).UnknownError;
        }
    };
    const $0ad6fedaface02c5$export$1694272377fa07d8 = (err)=>err?.message !== undefined && err?.errorCode !== undefined;
});
parcelRegister("f22ja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f48b36e6e5cada34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $8dVIb;
    var $1VPdD;
    var $nb8r1;
    const $f48b36e6e5cada34$var$useResolve = ()=>{
        const { store: store, connections: connections } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState } = store;
        const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, (0, parcelRequire("nb8r1")).default)();
        return (0, $5uXOq.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
            const { details: details } = getState()[url] || {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const hasData = !!(details && details.data);
            if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
            else (0, (0, parcelRequire("1VPdD")).addMetadataToExperience)('smart-link-rendered', id, {
                cached: true
            });
        }, [
            connections.client,
            getState,
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $f48b36e6e5cada34$export$2e2bcd8739ae039 = $f48b36e6e5cada34$var$useResolve;
});
parcelRegister("nb8r1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$09545a48e55da9e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $kECas;
    var $2yPrN;
    var $kDZ6Z;
    var $fiKQs;
    var $8dVIb;
    var $aOsut;
    const $09545a48e55da9e9$var$useResponse = ()=>{
        const { store: store, config: config } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const { getState: getState, dispatch: dispatch } = store;
        const hasAuthFlowSupported = config.authFlow !== 'disabled';
        const setMetadataStatus = (0, $5uXOq.useCallback)((url, metadataStatus)=>{
            dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_UPDATE_METADATA_STATUS), {
                url: url
            }, undefined, undefined, metadataStatus));
        }, [
            dispatch
        ]);
        const handleResolvedLinkError = (0, $5uXOq.useCallback)((url, error, response, isMetadataRequest)=>{
            const newState = {
                status: (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending,
                details: undefined
            };
            const { details: details } = getState()[url] || newState;
            const hasData = !!(details && details.data);
            if (isMetadataRequest) {
                setMetadataStatus(url, 'errored');
                return;
            }
            if (error.kind === 'fatal') {
                if (hasData) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                    url: url
                }, details));
                else {
                    dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                        url: url
                    }, details, error));
                    throw error;
                }
            } else if (error.kind === 'auth') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: url
            }, (0, (0, parcelRequire("aOsut")).getUnauthorizedJsonLd)()));
            else if (error.kind === 'fallback') dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR_FALLBACK), {
                url: url
            }, response, error));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_ERROR), {
                url: url
            }, undefined, error));
        }, [
            getState,
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkSuccess = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
            setMetadataStatus(resourceUrl, 'resolved');
            if (isReloading) dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RELOADING), {
                url: resourceUrl
            }, response));
            else dispatch((0, (0, parcelRequire("2yPrN")).cardAction)((0, (0, parcelRequire("2yPrN")).ACTION_RESOLVED), {
                url: resourceUrl
            }, response, undefined, undefined, isMetadataRequest));
        }, [
            setMetadataStatus,
            dispatch
        ]);
        const handleResolvedLinkResponse = (0, $5uXOq.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
            const hostname = new URL(resourceUrl).hostname;
            const nextStatus = response ? (0, (0, parcelRequire("fiKQs")).getStatus)(response) : 'fatal';
            if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fallback', hostname, (0, $cc6a74b99a201fc4$export$3e81ce851ffda0ad)), response, isMetadataRequest);
                return;
            }
            if (!response || nextStatus === 'fatal') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('fatal', hostname, (0, $cc6a74b99a201fc4$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
                return;
            }
            if (isMetadataRequest && nextStatus !== 'resolved') {
                handleResolvedLinkError(resourceUrl, new (0, (0, parcelRequire("kDZ6Z")).APIError)('error', hostname, (0, $cc6a74b99a201fc4$export$338f7d9ccca1975d)), response, isMetadataRequest);
                return;
            }
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
            });
        }, [
            handleResolvedLinkError,
            handleResolvedLinkSuccess,
            hasAuthFlowSupported
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                handleResolvedLinkError: handleResolvedLinkError,
                handleResolvedLinkResponse: handleResolvedLinkResponse
            }), [
            handleResolvedLinkError,
            handleResolvedLinkResponse
        ]);
    };
    var $09545a48e55da9e9$export$2e2bcd8739ae039 = $09545a48e55da9e9$var$useResponse;
});
parcelRegister("aOsut", function(module, exports) {
    $parcel$export(module.exports, "getEmptyJsonLd", ()=>$5dc57cbabb8840da$export$2796a804c6e44f63);
    $parcel$export(module.exports, "getUnauthorizedJsonLd", ()=>$5dc57cbabb8840da$export$b9482e0f6d365cc7);
    $parcel$export(module.exports, "getForbiddenJsonLd", ()=>$5dc57cbabb8840da$export$e32193033a594efb);
    const $5dc57cbabb8840da$var$emptyData = {
        '@context': {
            '@vocab': 'https://www.w3.org/ns/activitystreams#',
            atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
            schema: 'http://schema.org/'
        },
        '@type': 'Object'
    };
    const $5dc57cbabb8840da$export$2796a804c6e44f63 = ()=>$5dc57cbabb8840da$var$emptyData;
    const $5dc57cbabb8840da$export$b9482e0f6d365cc7 = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'unauthorized',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
    const $5dc57cbabb8840da$export$e32193033a594efb = ()=>({
            meta: {
                visibility: 'restricted',
                access: 'forbidden',
                auth: [],
                definitionId: 'provider-not-found'
            },
            data: {
                ...$5dc57cbabb8840da$var$emptyData
            }
        });
});
const $cc6a74b99a201fc4$export$297c39c8b9bfca0 = 'resolving';
const $cc6a74b99a201fc4$export$b64a888338c24e0e = 'errored';
const $cc6a74b99a201fc4$export$677b6edfa0002c70 = 'fallback';
const $cc6a74b99a201fc4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $cc6a74b99a201fc4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $cc6a74b99a201fc4$export$338f7d9ccca1975d = 'Error resolving metadata.';
parcelRegister("gDUps", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66cd4b0a305f86bf$export$2e2bcd8739ae039);
    const $66cd4b0a305f86bf$var$createStatusUpdateRequest = (request, id)=>({
            providerKey: request.providerKey,
            action: {
                ...request.action,
                payload: {
                    newStatusId: id
                }
            }
        });
    var $66cd4b0a305f86bf$export$2e2bcd8739ae039 = $66cd4b0a305f86bf$var$createStatusUpdateRequest;
});
parcelRegister("cLKee", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$061d6f2e0c766414$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lj8SI;
    const $061d6f2e0c766414$var$withErrorBoundary = (Component)=>(props)=>{
            const fallback = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                    appearance: props?.appearance,
                    testId: `${props?.testId ?? 'smart-element-lozenge-action'}-fallback`
                }, props?.text), [
                props?.appearance,
                props?.testId,
                props?.text
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
                fallback: fallback
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props));
        };
    var $061d6f2e0c766414$export$2e2bcd8739ae039 = $061d6f2e0c766414$var$withErrorBoundary;
});
parcelRegister("dMzTJ", function(module, exports) {
    $parcel$export(module.exports, "unknownLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2a568ff99500df53);
    $parcel$export(module.exports, "permissionLoadErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$2de2d0ccc17b915f);
    $parcel$export(module.exports, "unknownUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$c1c05f9d51f7c467);
    $parcel$export(module.exports, "validationUpdateErrorAnalyticsPayload", ()=>$bd6f9a689b54b40e$export$618660b8f2aa87e2);
    const $bd6f9a689b54b40e$export$2a568ff99500df53 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$2de2d0ccc17b915f = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'PermissionError',
        step: 'load'
    };
    const $bd6f9a689b54b40e$export$c1c05f9d51f7c467 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'UnknownError',
        step: 'update'
    };
    const $bd6f9a689b54b40e$export$618660b8f2aa87e2 = {
        smartLinkActionType: 'StatusUpdate',
        reason: 'ValidationError',
        step: 'update'
    };
});
parcelRegister("j6VJk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee1a9d5bb42f1de9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $6B7KL;
    var $aRoVz;
    var $dD7Zc;
    var $7zaVw;
    var $Nh1XU;
    var $f22ja;
    var $fpDmE;
    var $ljnlf;
    const $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER = 8;
    const $ee1a9d5bb42f1de9$var$LozengeActionError = ({ errorMessage: errorMessage, testId: testId, maxLineNumber: maxLineNumber = $ee1a9d5bb42f1de9$var$MAX_LINE_NUMBER, url: url, previewData: previewData })=>{
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const isPreviewAvailable = previewData && previewData.src !== undefined;
        const handlePreviewClose = (0, $5uXOq.useCallback)(()=>{
            if (url) reload(url, true);
        }, [
            reload,
            url
        ]);
        const handlePreviewOpen = (0, $5uXOq.useCallback)(()=>{
            if (isPreviewAvailable) {
                analytics?.ui.smartLinkLozengeActionErrorOpenPreviewClickedEvent();
                return (0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                    ...previewData,
                    analytics: analytics,
                    onClose: handlePreviewClose
                });
            }
        }, [
            analytics,
            handlePreviewClose,
            isPreviewAvailable,
            previewData
        ]);
        const content = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).contentStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
                testId: `${testId}-icon`,
                LEGACY_size: "medium",
                color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`,
                LEGACY_secondaryColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
                label: 'error',
                spacing: "spacious"
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("ljnlf")).textStyles)(maxLineNumber),
                "data-testid": `${testId}-error-message`
            }, typeof errorMessage === 'string' ? errorMessage : (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(errorMessage))), isPreviewAvailable ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("ljnlf")).linkStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
                target: "_blank",
                "data-testid": `${testId}-open-embed`,
                onClick: handlePreviewOpen
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).open_issue_in_jira))) : null);
        }, [
            errorMessage,
            handlePreviewOpen,
            isPreviewAvailable,
            maxLineNumber,
            testId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("ljnlf")).dropdownItemGroupStyles),
            "data-testid": `${testId}-error-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            testId: `${testId}-error`
        }, content))));
    };
    var $ee1a9d5bb42f1de9$export$2e2bcd8739ae039 = $ee1a9d5bb42f1de9$var$LozengeActionError;
});
parcelRegister("6B7KL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ff85f737833a5bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5JjdN;
    var $kJpBP;
    var $1aogK;
    var $3Z96c;
    var $VSDnB;
    var $l7Q0F;
    const $9ff85f737833a5bc$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("l7Q0F")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1aogK")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kJpBP")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("5JjdN")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $9ff85f737833a5bc$export$2e2bcd8739ae039 = $9ff85f737833a5bc$var$DropdownMenuItem;
});
parcelRegister("aRoVz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c1f89f82839ba50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9KnKW;
    var $9UCCQ;
    var $k20lf;
    const $6c1f89f82839ba50$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("9KnKW")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9UCCQ")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k20lf")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $6c1f89f82839ba50$export$2e2bcd8739ae039 = $6c1f89f82839ba50$var$DropdownMenuItemGroup;
});
parcelRegister("ljnlf", function(module, exports) {
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$83fdad0d8ffe5982$export$2c40d814aeff5db);
    $parcel$export(module.exports, "contentStyles", ()=>$83fdad0d8ffe5982$export$a38ecc1ac2e6fba);
    $parcel$export(module.exports, "linkStyles", ()=>$83fdad0d8ffe5982$export$4ea5976125a01ffa);
    $parcel$export(module.exports, "textStyles", ()=>$83fdad0d8ffe5982$export$6a54c24d15b0f6ba);
    var $f8Sb3;
    var $fpDmE;
    function $83fdad0d8ffe5982$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $83fdad0d8ffe5982$export$2c40d814aeff5db = {
        name: "a7m7l8",
        styles: "button{width:220px;&:hover{background-color:inherit;cursor:default;}}"
    };
    const $83fdad0d8ffe5982$var$sharedBlockStyles = {
        name: "gx0rja",
        styles: "display:flex;gap:var(--ds-space-100, 0.5rem);line-height:1rem;min-width:0;overflow:hidden;flex-direction:row;align-items:center"
    };
    const $83fdad0d8ffe5982$export$a38ecc1ac2e6fba = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, {
        marginTop: "var(--ds-space-025, 2px)",
        alignItems: 'flex-start',
        '> span, > div': {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
        }
    });
    const $83fdad0d8ffe5982$export$4ea5976125a01ffa = (0, (0, parcelRequire("f8Sb3")).css)($83fdad0d8ffe5982$var$sharedBlockStyles, "cursor:pointer;font-size:0.875rem;margin-top:var(--ds-space-100, 8px);margin-left:var(--ds-space-400, 32px);margin-bottom:var(--ds-space-025, 2px);");
    const $83fdad0d8ffe5982$export$6a54c24d15b0f6ba = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
});
parcelRegister("1s0lY", function(module, exports) {
    $parcel$export(module.exports, "LozengeActionErrorMessages", ()=>$47c640bee30204cc$export$4f2e371a667ad688);
    var $7zaVw;
    const $47c640bee30204cc$export$4f2e371a667ad688 = {
        noData: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_permission_error']
        },
        unknown: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_load_error']
        },
        updateFailed: {
            descriptor: (0, (0, parcelRequire("7zaVw")).messages)['status_change_update_error']
        }
    };
});
parcelRegister("kf01E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a0af43cfe2e114d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $aRoVz;
    var $hgsSZ;
    var $3UpeD;
    const $9a0af43cfe2e114d$var$LozengeActionItemsGroup = ({ items: items, testId: testId, onClick: onClick })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("3UpeD")).dropdownItemGroupStyles),
            "data-testid": `${testId}-item-group`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hgsSZ")).default), {
                ...item,
                key: idx,
                onClick: onClick,
                testId: `${testId}-item-${idx}`
            }))));
    var $9a0af43cfe2e114d$export$2e2bcd8739ae039 = $9a0af43cfe2e114d$var$LozengeActionItemsGroup;
});
parcelRegister("hgsSZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$419e60cbfb62c454$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $lj8SI;
    const $419e60cbfb62c454$var$LozengeActionItem = ({ appearance: appearance, id: id, onClick: onClick, testId: testId, text: text })=>{
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            if (onClick) onClick(id, text, appearance);
        }, [
            appearance,
            id,
            onClick,
            text
        ]);
        const handleMouseEnter = (0, $5uXOq.useCallback)((e)=>{
            e.currentTarget?.firstElementChild?.focus();
        }, []);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            onMouseEnter: handleMouseEnter
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: handleClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: appearance
        }, text))));
    };
    var $419e60cbfb62c454$export$2e2bcd8739ae039 = $419e60cbfb62c454$var$LozengeActionItem;
});
parcelRegister("3UpeD", function(module, exports) {
    $parcel$export(module.exports, "triggerButtonStyles", ()=>$c3acfc8ed6aa38b4$export$ae858546f0bfd05c);
    $parcel$export(module.exports, "triggerLozengeStyles", ()=>$c3acfc8ed6aa38b4$export$5717c7336384f3a6);
    $parcel$export(module.exports, "dropdownItemGroupStyles", ()=>$c3acfc8ed6aa38b4$export$2c40d814aeff5db);
    var $f8Sb3;
    function $c3acfc8ed6aa38b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c3acfc8ed6aa38b4$export$ae858546f0bfd05c = (0, (0, parcelRequire("f8Sb3")).css)({
        all: 'unset',
        backgroundColor: 'transparent',
        color: 'unset',
        cursor: 'pointer',
        fontFamily: 'unset',
        fontSize: 'unset',
        fontStyle: 'unset',
        fontWeight: 'unset',
        fontVariant: 'unset',
        lineHeight: 0,
        padding: 0,
        textTransform: 'unset',
        border: '2px solid transparent',
        margin: "var(--ds-space-025, 2px)",
        "&:focus-visible, &:focus-within, &[aria-expanded='true']": {
            outline: 'none',
            boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`,
            borderRadius: '5px'
        }
    });
    const $c3acfc8ed6aa38b4$export$5717c7336384f3a6 = {
        name: "1vr7vmn",
        styles: "align-items:center;display:flex"
    };
    const $c3acfc8ed6aa38b4$export$2c40d814aeff5db = (0, (0, parcelRequire("f8Sb3")).css)({
        maxHeight: '300px',
        overflowY: 'auto',
        button: {
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            minHeight: '28px',
            width: '220px',
            '&:hover': {
                backgroundColor: 'inherit'
            },
            '&:focus, &:focus-visible': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
                boxSizing: 'border-box',
                boxShadow: `inset 2px 0 0 ${"var(--ds-border-selected, #0C66E4)"}`,
                outline: 'none'
            }
        }
    });
});
parcelRegister("4Dg4o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$afa61527cd4f792e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $c8Oei;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $3UpeD;
    const $afa61527cd4f792e$var$chevronDownStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.075',
        display: 'flex'
    });
    const $afa61527cd4f792e$var$LozengeActionTrigger = ({ appearance: appearance, isOpen: isOpen, testId: testId, text: text, triggerRef: triggerRef, ...props })=>{
        const [isBold, setIsBold] = (0, $5uXOq.useState)(false);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>setIsBold(true), []);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>setIsBold(false), []);
        const lozenge = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
                appearance: appearance,
                isBold: isBold
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("3UpeD")).triggerLozengeStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, text), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                as: "span",
                xcss: $afa61527cd4f792e$var$chevronDownStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                color: "currentColor",
                label: "options",
                LEGACY_size: "medium",
                LEGACY_margin: "-4px -8px -4px -7px"
            })))), [
            appearance,
            isBold,
            text
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            ...props,
            css: (0, (0, parcelRequire("3UpeD")).triggerButtonStyles),
            "data-action-open": isOpen,
            "data-testid": `${testId}--trigger`,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ref: triggerRef
        }, lozenge);
    };
    var $afa61527cd4f792e$export$2e2bcd8739ae039 = $afa61527cd4f792e$var$LozengeActionTrigger;
});
parcelRegister("77cM6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a723b9f793426daa$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $l5Xsv;
    function $a723b9f793426daa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a723b9f793426daa$var$styles = {
        name: "a50hvv",
        styles: "aspect-ratio:16 / 9;display:flex;width:100%;height:fit-content;@supports not (aspect-ratio: auto){padding-top:56.25%;height:0;position:relative;overflow:hidden;}> img, > span{min-height:100%;min-width:100%;max-height:100%;max-width:100%;object-fit:cover;object-position:center center;@supports not (aspect-ratio: auto){position:absolute;transform:translate(-50%, -50%);left:50%;top:50%;width:auto;height:auto;}}"
    };
    const $a723b9f793426daa$var$Media = ({ name: name, overrideCss: overrideCss, testId: testId = 'smart-element-media', type: type, url: url, onLoad: onLoad, onError: onError })=>{
        if (!type || !url) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $a723b9f793426daa$var$styles,
                overrideCss
            ],
            "data-smart-element": name,
            "data-smart-element-media": type,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l5Xsv")).default), {
            testId: `${testId}-image`,
            url: url,
            onError: onError,
            onLoad: onLoad,
            defaultIcon: null
        }));
    };
    var $a723b9f793426daa$export$2e2bcd8739ae039 = $a723b9f793426daa$var$Media;
});
parcelRegister("k39kU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af078338fe34f0f5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fpDmE;
    const $af078338fe34f0f5$var$getStyles = (maxLines)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text-subtlest, #626F86);font-size:0.75rem;line-height:1rem;white-space:normal;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines));
    const $af078338fe34f0f5$var$Text = ({ content: content, maxLines: maxLines = 1, message: message, name: name, overrideCss: overrideCss, testId: testId = 'smart-element-text' })=>{
        if (!message && !content) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $af078338fe34f0f5$var$getStyles(maxLines),
                overrideCss
            ],
            "data-separator": true,
            "data-smart-element": name,
            "data-smart-element-text": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("fpDmE")).getFormattedMessage)(message) || content);
    };
    var $af078338fe34f0f5$export$2e2bcd8739ae039 = $af078338fe34f0f5$var$Text;
});
parcelRegister("kDhrr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5972a7cc25546c87$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $Nh1XU;
    var $77cM6;
    const $5972a7cc25546c87$var$Preview = (props)=>{
        const { overrideUrl: overrideUrl, ...rest } = props ?? {};
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        const data = overrideUrl ? {
            url: overrideUrl,
            type: (0, (0, parcelRequire("8dVIb")).MediaType).Image
        } : context?.preview;
        if (!data) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("77cM6")).default), {
            ...rest,
            ...data
        });
    };
    var $5972a7cc25546c87$export$2e2bcd8739ae039 = $5972a7cc25546c87$var$Preview;
});
parcelRegister("kp8aU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$673e9555bded0d05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $Nh1XU;
    var $k39kU;
    const $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES = 3;
    const $673e9555bded0d05$var$getSnippetStyles = (overrideCss)=>(0, (0, parcelRequire("f8Sb3")).css)("color:var(--ds-text, #172B4D);-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;", overrideCss);
    const $673e9555bded0d05$var$SnippetElement = ({ content: overrideContent, maxLines: maxLines = $673e9555bded0d05$var$SNIPPET_DEFAULT_MAX_LINES, overrideCss: overrideCss, ...props } = {})=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("Nh1XU")).FlexibleUiContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k39kU")).default), {
            content: overrideContent ?? context?.snippet,
            maxLines: maxLines,
            overrideCss: $673e9555bded0d05$var$getSnippetStyles(overrideCss),
            ...props
        });
    };
    var $673e9555bded0d05$export$2e2bcd8739ae039 = $673e9555bded0d05$var$SnippetElement;
});
parcelRegister("bubxq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$66554651c27d9387$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $gKZoD;
    var $ldJSL;
    var $fVnbM;
    var $BLPHT;
    var $bJeNF;
    var $3bDjY;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $akF1x;
    var $3Zm9O;
    function $66554651c27d9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $66554651c27d9387$var$styles = {
        name: "inf63k",
        styles: "display:inline-flex;line-height:1rem;> div{align-items:center;button:focus-visible{outline-offset:var(--ds-space-negative-025, -2px);}}"
    };
    const $66554651c27d9387$var$renderActionItems = (items = [], size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance, asDropDownItems, onActionItemClick)=>items.map((item, idx)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3Zm9O")).default), {
                item: item,
                key: idx,
                size: size,
                appearance: appearance,
                asDropDownItems: asDropDownItems,
                onActionItemClick: onActionItemClick
            }));
    const $66554651c27d9387$var$ActionGroup = ({ items: items = [], size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, appearance: appearance, visibleButtonsNum: visibleButtonsNum = 2, onDropdownOpenChange: onDropdownOpenChange })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("BLPHT")).default));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const renderableActionItems = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("akF1x")).filterActionItems)(items, context), [
            context,
            items
        ]);
        const isMoreThenTwoItems = renderableActionItems.length > visibleButtonsNum;
        const onOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
            setIsOpen(attrs.isOpen);
            if (onDropdownOpenChange) onDropdownOpenChange(attrs.isOpen);
        }, [
            onDropdownOpenChange
        ]);
        const onActionItemClick = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) onOpenChange({
                isOpen: false
            });
        }, [
            isOpen,
            onOpenChange
        ]);
        const actionButtons = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(0, visibleButtonsNum - 1) : renderableActionItems;
            return $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, false, onActionItemClick);
        }, [
            appearance,
            isMoreThenTwoItems,
            onActionItemClick,
            renderableActionItems,
            size,
            visibleButtonsNum
        ]);
        const moreActionDropdown = (0, $5uXOq.useMemo)(()=>{
            const actionItems = isMoreThenTwoItems ? renderableActionItems.slice(visibleButtonsNum - 1) : [];
            if (actionItems.length > 0) {
                const spacing = (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size];
                const moreIcon = (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                    label: "more",
                    color: "currentColor"
                });
                const formatMessage = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).more_actions);
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
                    isOpen: isOpen,
                    onOpenChange: onOpenChange,
                    trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                            content: formatMessage,
                            hideTooltipOnClick: true,
                            testId: "action-group-more-button-tooltip",
                            tag: "span"
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
                            ...props,
                            spacing: spacing,
                            testId: "action-group-more-button",
                            iconBefore: moreIcon,
                            ref: triggerRef
                        })),
                    testId: "action-group-dropdown",
                    zIndex: ui?.zIndex
                }, $66554651c27d9387$var$renderActionItems(actionItems, size, appearance, true, onActionItemClick));
            }
            return null;
        }, [
            appearance,
            isMoreThenTwoItems,
            isOpen,
            onActionItemClick,
            onOpenChange,
            renderableActionItems,
            size,
            ui?.zIndex,
            visibleButtonsNum
        ]);
        return renderableActionItems.length > 0 ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $66554651c27d9387$var$styles,
            className: "actions-button-group",
            "data-action-open": isOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldJSL")).default), null, actionButtons, moreActionDropdown)) : null;
    };
    var $66554651c27d9387$export$2e2bcd8739ae039 = $66554651c27d9387$var$ActionGroup;
});
parcelRegister("bJeNF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $889f60aca54b55ef$var$_react = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $889f60aca54b55ef$var$_showMoreHorizontal = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("8U6zd")));
    var $889f60aca54b55ef$var$_more = $889f60aca54b55ef$var$_interopRequireDefault((parcelRequire("3oUqw")));
    function $889f60aca54b55ef$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $889f60aca54b55ef$var$ShowMoreHorizontalIcon = (props)=>$889f60aca54b55ef$var$_react.default.createElement($889f60aca54b55ef$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $889f60aca54b55ef$var$_more.default
        }, props));
    $889f60aca54b55ef$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $889f60aca54b55ef$var$_default = module.exports.default = $889f60aca54b55ef$var$ShowMoreHorizontalIcon;
});
parcelRegister("akF1x", function(module, exports) {
    $parcel$export(module.exports, "getGapSize", ()=>$8ba323b39584fd77$export$ff20be09ae01c52e);
    $parcel$export(module.exports, "getBaseStyles", ()=>$8ba323b39584fd77$export$bff8031d86bb089);
    $parcel$export(module.exports, "highlightRemoveStyles", ()=>$8ba323b39584fd77$export$1928241a6f267c0d);
    $parcel$export(module.exports, "getActionGroupStyles", ()=>$8ba323b39584fd77$export$393b0054595c3748);
    $parcel$export(module.exports, "filterActionItems", ()=>$8ba323b39584fd77$export$adbd04236f07a7d8);
    $parcel$export(module.exports, "renderChildren", ()=>$8ba323b39584fd77$export$cd762ccf1a583d69);
    $parcel$export(module.exports, "renderElementItems", ()=>$8ba323b39584fd77$export$9678d3ca18bd7526);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $91tw3;
    var $eqoQu;
    var $bubxq;
    var $1BfaB;
    function $8ba323b39584fd77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8ba323b39584fd77$export$f942619ce67b1a41 = {
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedTo]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AssignedToGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AttachmentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).AuthorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ChecklistProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CollaboratorGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CommentCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).CreatedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).DueOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LatestCommit]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).LinkIcon]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Location]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ModifiedOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedBy]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).OwnedByGroup]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Preview]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Priority]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ProgrammingLanguage]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Provider]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReactCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ReadTime]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Snippet]: [
            'block'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SentOn]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).State]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubscriberCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).SubTasksProgress]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).StoryPoints]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).Title]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).ViewCount]: [
            'inline'
        ],
        [(0, (0, parcelRequire("8dVIb")).ElementName).VoteCount]: [
            'inline'
        ]
    };
    var $8ba323b39584fd77$var$_ref2 = {
        name: "2rtvke",
        styles: "flex-direction:row;align-items:center"
    };
    var $8ba323b39584fd77$var$_ref3 = {
        name: "1ejri1g",
        styles: "flex-direction:column;align-items:flex-start"
    };
    const $8ba323b39584fd77$var$getDirectionStyles = (direction)=>{
        switch(direction){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical:
                return $8ba323b39584fd77$var$_ref3;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal:
            default:
                return $8ba323b39584fd77$var$_ref2;
        }
    };
    const $8ba323b39584fd77$export$ff20be09ae01c52e = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
                return 1.25;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return 1;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
                return 0.5;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return 0.25;
        }
    };
    const $8ba323b39584fd77$export$bff8031d86bb089 = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)({
            alignItems: 'center',
            display: 'flex',
            gap: `${$8ba323b39584fd77$export$ff20be09ae01c52e(size)}rem`,
            lineHeight: '1rem',
            minWidth: 0,
            overflow: 'hidden'
        }, $8ba323b39584fd77$var$getDirectionStyles(direction), "&:empty{display:none;}& > *{min-width:0;}& > [data-fit-to-content]{min-width:fit-content;}");
    const $8ba323b39584fd77$export$1928241a6f267c0d = {
        name: "1klm9nt",
        styles: "outline:none!important;outline-color:inherit;color:inherit;-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none"
    };
    const $8ba323b39584fd77$var$isActionGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && node.type === (0, (0, parcelRequire("bubxq")).default);
    const $8ba323b39584fd77$var$isElementDisplayValid = (name, display)=>{
        return $8ba323b39584fd77$export$f942619ce67b1a41[name]?.includes(display) ?? false;
    };
    const $8ba323b39584fd77$export$f2c7ad0961800b16 = (children)=>{
        return Boolean(children.type() === null);
    };
    const $8ba323b39584fd77$var$isElementOrElementGroup = (node)=>(0, ($parcel$interopDefault($5uXOq))).isValidElement(node) && ((0, (0, parcelRequire("91tw3")).isFlexibleUiElement)(node) || node.type === (0, (0, parcelRequire("1BfaB")).default));
    var $8ba323b39584fd77$var$_ref = {
        name: "bceqwf",
        styles: "max-height:2rem"
    };
    const $8ba323b39584fd77$export$393b0054595c3748 = (size)=>{
        if (size === (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge) return $8ba323b39584fd77$var$_ref;
    };
    const $8ba323b39584fd77$export$adbd04236f07a7d8 = (items = [], context)=>{
        return items.filter((item)=>{
            switch(item.name){
                case (0, (0, parcelRequire("8dVIb")).ActionName).DeleteAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).EditAction:
                case (0, (0, parcelRequire("8dVIb")).ActionName).CustomAction:
                    return Boolean((0, (0, parcelRequire("8dVIb")).ActionName)[item.name]);
                default:
                    if (context?.actions === undefined) return false;
                    return Boolean(item.name in context.actions ? context.actions[item.name] : undefined);
            }
        });
    };
    const $8ba323b39584fd77$export$cd762ccf1a583d69 = (children, size)=>(0, ($parcel$interopDefault($5uXOq))).Children.map(children, (child)=>{
            if ($8ba323b39584fd77$var$isElementOrElementGroup(child) || $8ba323b39584fd77$var$isActionGroup(child)) {
                const node = child;
                const { size: childSize } = node.props;
                return (0, ($parcel$interopDefault($5uXOq))).cloneElement(node, {
                    size: childSize || size
                });
            }
            return child;
        });
    const $8ba323b39584fd77$export$9678d3ca18bd7526 = (items = [], display = 'inline')=>{
        const elements = items.reduce((acc, curr, idx)=>{
            const { name: name, ...props } = curr;
            const Element = (0, parcelRequire("eqoQu"))[name];
            const typedProps = props;
            if (Element && $8ba323b39584fd77$var$isElementDisplayValid(name, display)) {
                const element = (0, ($parcel$interopDefault($5uXOq))).createElement(Element, {
                    key: idx,
                    ...typedProps
                });
                if (!$8ba323b39584fd77$export$f2c7ad0961800b16(element)) return [
                    ...acc,
                    element
                ];
            }
            return acc;
        }, []);
        if (elements.length) return elements;
    };
});
parcelRegister("1BfaB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed56962f49dee3a8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $akF1x;
    function $ed56962f49dee3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $ed56962f49dee3a8$var$_ref = {
        name: "3l7cjm",
        styles: "-webkit-box-align:start;-ms-flex-align:start;justify-content:flex-start;text-align:left"
    };
    var $ed56962f49dee3a8$var$_ref2 = {
        name: "1ofqdyp",
        styles: "-webkit-box-align:end;-ms-flex-align:end;justify-content:flex-end;text-align:right"
    };
    const $ed56962f49dee3a8$var$getAlignmentStyles = (align)=>{
        switch(align){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right:
                return $ed56962f49dee3a8$var$_ref2;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left:
            default:
                return $ed56962f49dee3a8$var$_ref;
        }
    };
    const $ed56962f49dee3a8$var$getGapStyles = (size, align)=>{
        const gap = (0, (0, parcelRequire("akF1x")).getGapSize)(size);
        if (align === (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right) return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginLeft: `${gap}rem`
            },
            '> span:first-child': {
                marginLeft: 'initial'
            }
        });
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '> span': {
                marginRight: `${gap}rem`,
                '&:last-child': {
                    marginRight: 'initial'
                }
            }
        });
    };
    const $ed56962f49dee3a8$var$getHorizontalDirectionStyles = (size, align)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("display:block;vertical-align:middle;", (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, lineHeight + 'rem'), ">span,>div{vertical-align:middle;&[data-smart-element-date-time],&[data-smart-element-text]{display:inline;}}", $ed56962f49dee3a8$var$getGapStyles(size, align), ";");
    };
    const $ed56962f49dee3a8$export$91d118d179d992a4 = (direction, size, align, width, position)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), $ed56962f49dee3a8$var$getAlignmentStyles(align), "min-width:10%;", width === (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible ? `flex: 1 3;` : '', direction === (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal ? $ed56962f49dee3a8$var$getHorizontalDirectionStyles(size, align) : '', position === (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Top ? 'align-self: flex-start;' : '');
    const $ed56962f49dee3a8$var$ElementGroup = ({ align: align = (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left, children: children, overrideCss: overrideCss, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-element-group', width: width = (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).FitToContent, position: position = (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $ed56962f49dee3a8$export$91d118d179d992a4(direction, size, align, width, position),
                overrideCss
            ],
            "data-smart-element-group": true,
            "data-testid": testId
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    var $ed56962f49dee3a8$export$2e2bcd8739ae039 = $ed56962f49dee3a8$var$ElementGroup;
});
parcelRegister("3Zm9O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70338cdeec0a99e7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jRHKj;
    const $70338cdeec0a99e7$var$ActionGroupItem = ({ item: item, size: size, appearance: appearance, asDropDownItems: asDropDownItems, onActionItemClick: onActionItemClick })=>{
        const { name: name, hideContent: hideContent, hideIcon: hideIcon, onClick: onClick, isDisabled: isDisabled, ...props } = item;
        const handleOnClick = (0, $5uXOq.useCallback)(()=>{
            if (onActionItemClick) onActionItemClick();
            if (onClick) onClick();
        }, [
            onActionItemClick,
            onClick
        ]);
        const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
        if (!Action) return null;
        const actionProps = {
            ...props
        };
        if (hideContent && !asDropDownItems) actionProps.content = '';
        if (hideIcon) actionProps.icon = undefined;
        if (item?.entryPointWrapper) actionProps.wrapper = item.entryPointWrapper;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
            asDropDownItem: asDropDownItems,
            size: size,
            appearance: appearance,
            onClick: handleOnClick,
            isDisabled: isDisabled,
            ...actionProps
        });
    };
    var $70338cdeec0a99e7$export$2e2bcd8739ae039 = $70338cdeec0a99e7$var$ActionGroupItem;
});
parcelRegister("jRHKj", function(module, exports) {
    $parcel$export(module.exports, "CustomAction", ()=>(parcelRequire("23vM5")).default);
    $parcel$export(module.exports, "DeleteAction", ()=>(parcelRequire("96Kdz")).default);
    $parcel$export(module.exports, "EditAction", ()=>(parcelRequire("fEhHT")).default);
    $parcel$export(module.exports, "DownloadAction", ()=>(parcelRequire("g9G65")).default);
    $parcel$export(module.exports, "FollowAction", ()=>(parcelRequire("b6Mes")).default);
    $parcel$export(module.exports, "PreviewAction", ()=>(parcelRequire("9mTP8")).default);
    $parcel$export(module.exports, "CopyLinkAction", ()=>(parcelRequire("jep3X")).default);
    $parcel$export(module.exports, "AISummaryAction", ()=>(parcelRequire("ziZLe")).default);
    $parcel$export(module.exports, "AutomationAction", ()=>(parcelRequire("5OUwn")).default);
    $parcel$export(module.exports, "ViewRelatedLinksAction", ()=>(parcelRequire("faTeC")).default);
    var $23vM5;
    var $96Kdz;
    var $fEhHT;
    var $g9G65;
    var $b6Mes;
    var $9mTP8;
    var $jep3X;
    var $ziZLe;
    var $5OUwn;
    var $faTeC;
});
parcelRegister("23vM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bf7d27623ce3bf9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $f6kZQ;
    var $kuVc8;
    var $bhB72;
    var $1wpdl;
    const $1bf7d27623ce3bf9$var$Action = ({ as: as, appearance: appearance = 'subtle', content: content, isLoading: isLoading = false, onClick: onClick, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-action', icon: icon, iconPosition: iconPosition = 'before', spaceInline: spaceInline, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltip: hideTooltip, hideTooltipOnMouseDown: hideTooltipOnMouseDown, xcss: xcss, asDropDownItem: asDropDownItem, overrideCss: overrideCss, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel, wrapper: Wrapper })=>{
        if (!onClick) return null;
        const isStackItem = as === 'stack-item';
        const isDropdownItem = as === 'dropdown-item' || asDropDownItem;
        const actionIcon = icon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: isStackItem,
            isDisabled: isDisabled,
            icon: icon,
            size: size,
            testId: testId
        });
        const iconBefore = icon && iconPosition === 'before' ? actionIcon : undefined;
        const iconAfter = icon && iconPosition === 'after' ? actionIcon : undefined;
        if (isStackItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1wpdl")).default), {
            content: content,
            icon: actionIcon,
            space: spaceInline,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onClick,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            xcss: xcss,
            tooltipOnHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown,
            hideTooltip: hideTooltip
        });
        if (isDropdownItem) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kuVc8")).default), {
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            testId: testId
        });
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f6kZQ")).default), {
            appearance: appearance,
            content: content,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isLoading: isLoading,
            onClick: onClick,
            overrideCss: overrideCss,
            size: size,
            testId: testId,
            tooltipMessage: tooltipMessage || content,
            isDisabled: isDisabled,
            href: href,
            ariaLabel: ariaLabel
        });
        return Wrapper !== undefined ? (0, (0, parcelRequire("f8Sb3")).jsx)(Wrapper, null, button) : button;
    };
    var $1bf7d27623ce3bf9$export$2e2bcd8739ae039 = $1bf7d27623ce3bf9$var$Action;
});
parcelRegister("f6kZQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b3ee32ab04698fad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2rqOp;
    var $3bDjY;
    var $8dVIb;
    var $fpDmE;
    function $b3ee32ab04698fad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $b3ee32ab04698fad$var$_ref = {
        name: "kaj2cp",
        styles: "button, button:hover, button:focus, button:active{padding:0;> span{margin:0;}}"
    };
    const $b3ee32ab04698fad$var$getButtonStyle = (size, iconOnly)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return iconOnly ? $b3ee32ab04698fad$var$_ref : '';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
                return (0, (0, parcelRequire("f8Sb3")).css)({
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    lineHeight: '1rem',
                    'button, button:hover, button:focus, button:active': [
                        {
                            lineHeight: '1rem'
                        },
                        iconOnly ? `
            padding: 0.125rem;
          ` : `
            padding-left: 0.25rem;
            padding-right: 0.25rem;
          `
                    ]
                });
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            default:
                return '';
        }
    };
    const $b3ee32ab04698fad$var$ActionButton = ({ appearance: appearance, content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, overrideCss: overrideCss, size: size, testId: testId, tooltipMessage: tooltipMessage, isDisabled: isDisabled, href: href, ariaLabel: ariaLabel })=>{
        const iconOnly = !content;
        const onButtonClick = (0, $5uXOq.useCallback)((handler)=>(e)=>{
                e.preventDefault();
                handler();
            }, []);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $b3ee32ab04698fad$var$getButtonStyle(size, iconOnly),
                overrideCss
            ],
            "data-testid": `${testId}-button-wrapper`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2rqOp")).default), {
            appearance: appearance,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            isDisabled: isDisabled,
            isLoading: isLoading,
            onClick: onButtonClick(onClick),
            spacing: (0, (0, parcelRequire("fpDmE")).sizeToButtonSpacing)[size],
            testId: testId,
            href: href,
            "aria-label": ariaLabel
        }, content)));
    };
    var $b3ee32ab04698fad$export$2e2bcd8739ae039 = $b3ee32ab04698fad$var$ActionButton;
});
parcelRegister("kuVc8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e656bda53d041540$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6B7KL;
    var $kxcRq;
    const $e656bda53d041540$var$ActionDropdownItem = ({ content: content, iconAfter: iconAfter, iconBefore: iconBefore, isLoading: isLoading, onClick: onClick, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            elemAfter: iconAfter,
            elemBefore: iconBefore,
            isDisabled: isLoading,
            onClick: (0, (0, parcelRequire("kxcRq")).handleOnClick)(onClick),
            testId: testId
        }, content);
    var $e656bda53d041540$export$2e2bcd8739ae039 = $e656bda53d041540$var$ActionDropdownItem;
});
parcelRegister("bhB72", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$345d01659b23eb38$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $8dVIb;
    var $fpDmE;
    function $345d01659b23eb38$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $345d01659b23eb38$var$getIconWidth = (size)=>{
        switch(size){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).XLarge:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Large:
                return '1.5rem';
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Small:
            default:
                return '1rem';
        }
    };
    const $345d01659b23eb38$var$getIconStyles = (isDisabled)=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: isDisabled ? "var(--ds-text-disabled, #6B778C)" : "var(--ds-icon, #44546F)"
        });
    const $345d01659b23eb38$var$stackItemIconSizeStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)('20px');
    const $345d01659b23eb38$var$stackItemIconStyles = (0, (0, parcelRequire("f8Sb3")).css)($345d01659b23eb38$var$stackItemIconSizeStyles, "display:inline-block;line-height:0;padding:var(--ds-space-025, 2px);span,svg,img{line-height:0;}");
    const $345d01659b23eb38$var$newStackItemIconStyles = {
        name: "1pelf5a",
        styles: "display:inline-block;line-height:0"
    };
    const $345d01659b23eb38$var$ActionIcon = ({ size: size, testId: testId, icon: icon, isDisabled: isDisabled, asStackItemIcon: asStackItemIcon })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $345d01659b23eb38$var$getIconStyles(isDisabled),
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? asStackItemIcon ? $345d01659b23eb38$var$stackItemIconStyles : (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)($345d01659b23eb38$var$getIconWidth(size)) : $345d01659b23eb38$var$newStackItemIconStyles
            ],
            "data-testid": `${testId}-icon`
        }, icon);
    var $345d01659b23eb38$export$2e2bcd8739ae039 = $345d01659b23eb38$var$ActionIcon;
});
parcelRegister("1wpdl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $5PILj;
    const $c6ef8f3a6ac7d3ff$var$ActionStackItem = ({ content: content, tooltipMessage: tooltipMessage, tooltipOnHide: tooltipOnHide, hideTooltipOnMouseDown: hideTooltipOnMouseDown, hideTooltip: hideTooltip, ...props })=>hideTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
            ...props,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipMessage || content,
            onHide: tooltipOnHide,
            hideTooltipOnMouseDown: hideTooltipOnMouseDown
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5PILj")).default), {
                ...props,
                content: content,
                tooltipProps: tooltipProps
            }));
    var $c6ef8f3a6ac7d3ff$export$2e2bcd8739ae039 = $c6ef8f3a6ac7d3ff$var$ActionStackItem;
});
parcelRegister("5PILj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$222d00bebc6cbf68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $eZJjh;
    var $fpDmE;
    var $bhB72;
    const $222d00bebc6cbf68$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        padding: 'space.050',
        width: '100%',
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $222d00bebc6cbf68$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $222d00bebc6cbf68$var$ActionButton = ({ content: content, icon: iconOption, isDisabled: isDisabled, isLoading: isLoading, onClick: onClickCallback, size: size, space: spaceOption, testId: testId, tooltipProps: tooltipProps, xcss: xcss })=>{
        const space = spaceOption ?? (0, (0, parcelRequire("fpDmE")).getPrimitivesInlineSpaceBySize)(size);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (!isDisabled && !isLoading && onClickCallback) onClickCallback();
        }, [
            isDisabled,
            isLoading,
            onClickCallback
        ]);
        const icon = iconOption && isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bhB72")).default), {
            asStackItemIcon: true,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
                testId: `${testId}-loading`
            }),
            size: size
        }) : iconOption;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $222d00bebc6cbf68$var$buttonStyles,
                xcss
            ],
            ...tooltipProps,
            onClick: onClick,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            grow: "fill",
            space: space
        }, icon, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $222d00bebc6cbf68$var$contentStyles
        }, content))));
    };
    var $222d00bebc6cbf68$export$2e2bcd8739ae039 = $222d00bebc6cbf68$var$ActionButton;
});
parcelRegister("96Kdz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddac835e19e975e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $84THj;
    var $7zaVw;
    var $23vM5;
    const $ddac835e19e975e0$var$DeleteAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("84THj"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Delete"
            }),
            testId: "smart-action-delete-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).delete),
            ...props
        });
    var $ddac835e19e975e0$export$2e2bcd8739ae039 = $ddac835e19e975e0$var$DeleteAction;
});
parcelRegister("fEhHT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23e1c92ea69f35be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $4ChK1;
    var $7zaVw;
    var $23vM5;
    const $23e1c92ea69f35be$var$EditAction = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ChK1"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Edit"
            }),
            testId: "smart-action-edit-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).edit),
            ...props
        });
    var $23e1c92ea69f35be$export$2e2bcd8739ae039 = $23e1c92ea69f35be$var$EditAction;
});
parcelRegister("4ChK1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));
    var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
    function $35c87913ec905242$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35c87913ec905242$var$EditIcon = (props)=>$35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
            LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
        }, props));
    $35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
    var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;
});
parcelRegister("5nRKm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3eb8cab3ab465b93$var$_UNSAFE_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb8cab3ab465b93$var$EditIcon = (props)=>$3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 1.751H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V10m-.75-5 1.116-1.116a1.25 1.25 0 0 0 0-1.768l-.732-.732a1.25 1.25 0 0 0-1.768 0L11 2.5M13.5 5 9.479 9.021c-.15.15-.336.26-.54.318l-3.189.911.911-3.189a1.25 1.25 0 0 1 .318-.54L11 2.5M13.5 5 11 2.5"/>`
        }, props));
    $3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
    var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;
});
parcelRegister("gsEeL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
    function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bfbe7921991bc4cb$var$EditIcon = (props)=>$bfbe7921991bc4cb$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
        }, props, {
            newIcon: $bfbe7921991bc4cb$var$_edit.default
        }));
    $bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
    var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;
});
parcelRegister("g9G65", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4fb79986052b65c1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $d4dv2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $kxcRq;
    var $23vM5;
    const $4fb79986052b65c1$var$DownloadAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data?.downloadUrl) {
                invoke({
                    actionType: (0, (0, parcelRequire("8dVIb")).ActionName).DownloadAction,
                    actionFn: async ()=>(0, (0, parcelRequire("kxcRq")).downloadUrl)(data?.downloadUrl),
                    display: analytics?.display,
                    extensionKey: analytics?.extensionKey
                });
                if (onClickCallback) onClickCallback();
            }
        }, [
            analytics,
            data?.downloadUrl,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const label = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_file : (0, (0, parcelRequire("7zaVw")).messages).download;
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).download_description : (0, (0, parcelRequire("7zaVw")).messages).download;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d4dv2"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Download"
            }),
            onClick: onClick,
            testId: "smart-action-download-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props
        }) : null;
    };
    var $4fb79986052b65c1$export$2e2bcd8739ae039 = $4fb79986052b65c1$var$DownloadAction;
});
parcelRegister("d4dv2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));
    var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
    function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $98361ed174bfbb2b$var$DownloadIcon = (props)=>$98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
            LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
        }, props));
    $98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
    var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;
});
parcelRegister("EOGIN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $07ab0e2228a1635e$var$_UNSAFE_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $07ab0e2228a1635e$var$DownloadIcon = (props)=>$07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 1v8.75m-4-3.5 4 4 4-4"/>`
        }, props));
    $07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
    var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;
});
parcelRegister("5krT5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
    function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e1473e49ea22b68$var$DownloadIcon = (props)=>$3e1473e49ea22b68$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
        }, props, {
            newIcon: $3e1473e49ea22b68$var$_download.default
        }));
    $3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
    var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;
});
parcelRegister("iPVbQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a560b45251b869c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $5vDFA;
    var $1VPdD;
    const $a560b45251b869c0$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
    const $a560b45251b869c0$var$useInvokeClientAction = ({ analytics: analytics })=>(0, $5uXOq.useCallback)(async ({ actionType: actionType, actionFn: actionFn, extensionKey: extensionKey, display: display })=>{
            const experienceId = (0, ($parcel$interopDefault($7Jxgt)))();
            const markName = `${experienceId}-${actionType}`;
            (0, parcelRequire("5vDFA")).mark(markName, 'pending');
            try {
                (0, (0, parcelRequire("1VPdD")).startUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId, {
                    actionType: actionType,
                    display: display,
                    extensionKey: extensionKey,
                    invokeType: 'client'
                });
                analytics?.ui.actionClickedEvent({
                    actionType: actionType,
                    display: display
                });
                const result = await actionFn();
                (0, parcelRequire("5vDFA")).mark(markName, 'resolved');
                (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                analytics?.operational.invokeSucceededEvent({
                    actionType: actionType,
                    display: display
                });
                return result;
            } catch (err) {
                (0, parcelRequire("5vDFA")).mark(markName, 'errored');
                (0, (0, parcelRequire("1VPdD")).failUfoExperience)($a560b45251b869c0$var$ACTION_EXPERIENCE_NAME, experienceId);
                const reason = typeof err === 'string' ? err : err?.message;
                analytics?.operational.invokeFailedEvent({
                    actionType: actionType,
                    display: display,
                    reason: reason
                });
            }
        }, [
            analytics?.operational,
            analytics?.ui
        ]);
    var $a560b45251b869c0$export$2e2bcd8739ae039 = $a560b45251b869c0$var$useInvokeClientAction;
});
parcelRegister("b6Mes", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$879133cabfb6e190$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $fpDmE;
    var $3xnBw;
    var $itef5;
    const $879133cabfb6e190$var$importIconMapper = {
        goal: ()=>(parcelRequire("7p0py")).then(({ GoalIcon: GoalIcon })=>({
                    default: GoalIcon
                })),
        projects: ()=>(parcelRequire("96BFr")).then(({ ProjectsIcon: ProjectsIcon })=>({
                    default: ProjectsIcon
                }))
    };
    const $879133cabfb6e190$var$getIcon = (stackIconType)=>{
        const importFn = $879133cabfb6e190$var$importIconMapper[stackIconType];
        if (!importFn) return null;
        return (0, (0, parcelRequire("fpDmE")).importIcon)(importFn);
    };
    const $879133cabfb6e190$var$FollowAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).FollowAction];
        if (!context || !actionData) return null;
        const { value: value, isProject: isProject, ...data } = actionData;
        const isStackItem = props.as === 'stack-item';
        const message = value ? (0, (0, parcelRequire("7zaVw")).messages).follow : (0, (0, parcelRequire("7zaVw")).messages).unfollow;
        const projectMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project;
        const goalMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal;
        const stackMessage = isProject ? projectMessage : goalMessage;
        const label = isStackItem ? stackMessage : message;
        const projectTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_project_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_description;
        const goalTooltipMessage = value ? (0, (0, parcelRequire("7zaVw")).messages).follow_goal_description : (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_description;
        const stackTooltipMessage = isProject ? projectTooltipMessage : goalTooltipMessage;
        const tooltipMessage = isStackItem ? stackTooltipMessage : message;
        const stackIconType = isProject ? 'projects' : 'goal';
        const ImportedIcon = $879133cabfb6e190$var$getIcon(stackIconType);
        const followIcon = (0, ($parcel$interopDefault($5uXOq))).createElement(ImportedIcon, {
            label: "Follow",
            testId: `smart-action-follow-action-${stackIconType}-icon`
        });
        const handleError = ()=>{
            const { onError: onErrorCallback } = props;
            const errorMessage = (0, (0, parcelRequire("itef5")).getFollowActionErrorMessage)(isProject, value);
            onErrorCallback?.({
                title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), errorMessage),
                appearance: 'error'
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3xnBw")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), label),
            icon: followIcon,
            testId: "smart-action-follow-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            ...data,
            ...props,
            onError: handleError
        });
    };
    var $879133cabfb6e190$export$2e2bcd8739ae039 = $879133cabfb6e190$var$FollowAction;
});
parcelRegister("3xnBw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35d557ed1ef6412d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    var $Nh1XU;
    var $3q2sI;
    var $euMlu;
    var $f22ja;
    var $69hr0;
    var $23vM5;
    const $35d557ed1ef6412d$var$ServerAction = ({ action: action, onClick: onClick, onError: onErrorCallback, ...props })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("3q2sI")).default)();
        const reload = (0, (0, parcelRequire("f22ja")).default)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const handleClick = (0, $5uXOq.useCallback)(async ()=>{
            if (action) {
                const smartLinkActionType = action.action?.actionType;
                try {
                    setIsLoading(true);
                    analytics?.ui.smartLinkServerActionClickedEvent({
                        smartLinkActionType: smartLinkActionType
                    });
                    fireEvent('track.smartLinkQuickAction.started', {
                        smartLinkActionType: smartLinkActionType
                    });
                    const request = (0, (0, parcelRequire("69hr0")).default)(action);
                    await invoke(request);
                    fireEvent('track.smartLinkQuickAction.success', {
                        smartLinkActionType: smartLinkActionType
                    });
                    if (action.reload && action.reload.url) await reload(action.reload.url, true, undefined, action.reload.id);
                    setIsLoading(false);
                    if (onClick) onClick();
                } catch (err) {
                    setIsLoading(false);
                    fireEvent('track.smartLinkQuickAction.failed', {
                        smartLinkActionType: smartLinkActionType,
                        reason: (0, (0, parcelRequire("euMlu")).getInvokeFailureReason)(err)
                    });
                    onErrorCallback?.();
                }
            }
        }, [
            action,
            analytics?.ui,
            invoke,
            onClick,
            onErrorCallback,
            reload,
            fireEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            ...props,
            isLoading: isLoading,
            onClick: handleClick
        });
    };
    var $35d557ed1ef6412d$export$2e2bcd8739ae039 = $35d557ed1ef6412d$var$ServerAction;
});
parcelRegister("69hr0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$22d791805237a266$export$2e2bcd8739ae039);
    const $22d791805237a266$var$createInvokeRequest = (request, payload)=>({
            action: {
                ...request.action,
                payload: payload
            },
            providerKey: request.providerKey
        });
    var $22d791805237a266$export$2e2bcd8739ae039 = $22d791805237a266$var$createInvokeRequest;
});
parcelRegister("itef5", function(module, exports) {
    $parcel$export(module.exports, "getFollowActionErrorMessage", ()=>$d31a392ae92ce299$export$49248678d3914625);
    var $7zaVw;
    const $d31a392ae92ce299$export$49248678d3914625 = (isProject = false, isFollow = false)=>{
        if (isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_project_error;
        if (isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_project_error;
        if (!isProject && isFollow) return (0, (0, parcelRequire("7zaVw")).messages).follow_goal_error;
        if (!isProject && !isFollow) return (0, (0, parcelRequire("7zaVw")).messages).unfollow_goal_error;
        return (0, (0, parcelRequire("7zaVw")).messages).generic_error_message;
    };
});
parcelRegister("7p0py", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftS7u").then(()=>parcelRequire('5UxRR'));
});
parcelRegister("96BFr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3uQsu")
    ]).then(()=>parcelRequire('gsEJ1'));
});
parcelRegister("9mTP8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ea9170f77974c10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $5JpK2;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $fpDmE;
    var $23vM5;
    const $3ea9170f77974c10$var$PreviewAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction];
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).PreviewAction,
                actionFn: async ()=>(0, (0, parcelRequire("fpDmE")).openEmbedModalWithFlexibleUiIcon)({
                        download: data?.downloadUrl,
                        extensionKey: analytics?.extensionKey,
                        analytics: analytics,
                        ...data
                    }),
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        const isStackItem = props.as === 'stack-item';
        const tooltipMessage = isStackItem ? (0, (0, parcelRequire("7zaVw")).messages).preview_description : (0, (0, parcelRequire("7zaVw")).messages).preview_improved;
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).preview_improved),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5JpK2"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Open preview"
            }),
            onClick: onClick,
            testId: "smart-action-preview-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            hideTooltipOnMouseDown: true,
            ...data,
            ...props
        }) : null;
    };
    var $3ea9170f77974c10$export$2e2bcd8739ae039 = $3ea9170f77974c10$var$PreviewAction;
});
parcelRegister("5JpK2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));
    var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
    function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>$42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
        }, props));
    $42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;
});
parcelRegister("l14Zy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f4cd903aabaa4c53$var$_react = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f4cd903aabaa4c53$var$_UNSAFE_baseNew = $f4cd903aabaa4c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f4cd903aabaa4c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f4cd903aabaa4c53$var$GrowDiagonalIcon = (props)=>$f4cd903aabaa4c53$var$_react.default.createElement($f4cd903aabaa4c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f4cd903aabaa4c53$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f4cd903aabaa4c53$var$_default = module.exports.default = $f4cd903aabaa4c53$var$GrowDiagonalIcon;
});
parcelRegister("6LXPU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4ee58c13163bfe09$var$_react = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4ee58c13163bfe09$var$_growDiagonal = $4ee58c13163bfe09$var$_interopRequireDefault((parcelRequire("l14Zy")));
    function $4ee58c13163bfe09$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4ee58c13163bfe09$var$MediaServicesActualSizeIcon = (props)=>$4ee58c13163bfe09$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $4ee58c13163bfe09$var$_growDiagonal.default
        }));
    $4ee58c13163bfe09$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $4ee58c13163bfe09$var$_default = module.exports.default = $4ee58c13163bfe09$var$MediaServicesActualSizeIcon;
});
parcelRegister("jep3X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0d1e0763b6a84021$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jOyH3;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $iPVbQ;
    var $23vM5;
    const $0d1e0763b6a84021$var$CopyLinkAction = ({ onClick: onClickCallback, ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const analytics = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiAnalyticsContext)();
        const invoke = (0, (0, parcelRequire("iPVbQ")).default)({
            analytics: analytics
        });
        const data = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction];
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (data && data.url) invoke({
                actionType: (0, (0, parcelRequire("8dVIb")).ActionName).CopyLinkAction,
                actionFn: async ()=>{
                    await navigator.clipboard.writeText(data.url ?? '');
                    setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_url_to_clipboard);
                },
                display: analytics?.display,
                extensionKey: analytics?.extensionKey
            });
            if (onClickCallback) onClickCallback();
        }, [
            analytics,
            data,
            invoke,
            onClickCallback
        ]);
        return data ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jOyH3"))))), {
                color: "currentColor",
                label: "copy url",
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            onClick: onClick,
            testId: "smart-action-copy-link-action",
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_url_to_clipboard),
            ...data,
            ...props
        }) : null;
    };
    var $0d1e0763b6a84021$export$2e2bcd8739ae039 = $0d1e0763b6a84021$var$CopyLinkAction;
});
parcelRegister("ziZLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8b53b1e1aa704061$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $dgRei;
    const $8b53b1e1aa704061$var$AISummaryAction = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        return actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dgRei")).AISummaryActionComponent), {
            ...actionData,
            ...props
        }) : null;
    };
    var $8b53b1e1aa704061$export$2e2bcd8739ae039 = $8b53b1e1aa704061$var$AISummaryAction;
});
parcelRegister("dgRei", function(module, exports) {
    $parcel$export(module.exports, "AISummaryActionComponent", ()=>$a6e4dbdfe418b2c1$export$8eed96bc6d982595);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $1MeuC;
    var $8UCLX;
    var $jdA9V;
    const $a6e4dbdfe418b2c1$export$8eed96bc6d982595 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { url: url, onLoadingChange: onLoadingChange, testId: testId = 'smart-action-ai-summary-action' } = props;
        const { state: { status: status, content: content }, summariseUrl: summariseUrl } = (0, (0, parcelRequire("1MeuC")).default)(url);
        (0, $5uXOq.useEffect)(()=>{
            onLoadingChange?.(status === 'loading');
        }, [
            onLoadingChange,
            status
        ]);
        return status === 'done' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdA9V")).CopySummaryAction), {
            ...props,
            testId: testId,
            content: content
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8UCLX")).AISummariseAction), {
            ...props,
            testId: testId,
            summariseUrl: summariseUrl,
            status: status
        });
    };
});
parcelRegister("1MeuC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27e30e18347ce2a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $hWyvy;
    var $8UXrm;
    var $a1vqi;
    var $1VPdD;
    var $hjhAz;
    var $kR87P;
    var $anB5s;
    const $27e30e18347ce2a0$var$EXPERIENCE_NAME = 'smart-link-ai-summary';
    const $27e30e18347ce2a0$var$useAISummaryAction = (url)=>{
        const { baseUrl: baseUrl, envKey: envKey, product: product } = (0, (0, parcelRequire("anB5s")).useAISummaryConfig)();
        const cardState = (0, (0, parcelRequire("hjhAz")).useSmartCardState)(url);
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const data = cardState.details?.data;
        const ari = data && (0, (0, parcelRequire("hWyvy")).extractAri)(data);
        const dataUrl = data && (0, (0, parcelRequire("8UXrm")).extractLink)(data) || '';
        const onStart = (0, $5uXOq.useCallback)((id)=>{
            (0, (0, parcelRequire("1VPdD")).startUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, []);
        const onSuccess = (0, $5uXOq.useCallback)((id)=>{
            fireEvent('operational.summary.success', {});
            (0, (0, parcelRequire("1VPdD")).succeedUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        const onError = (0, $5uXOq.useCallback)((id, reason)=>{
            const isSloError = reason === undefined ? true : ![
                'ACCEPTABLE_USE_VIOLATIONS',
                'HIPAA_CONTENT_DETECTED',
                'EXCEEDING_CONTEXT_LENGTH_ERROR'
            ].includes(reason);
            fireEvent('operational.summary.failed', {
                reason: reason || null,
                isSloError: isSloError
            });
            (0, (0, parcelRequire("1VPdD")).failUfoExperience)($27e30e18347ce2a0$var$EXPERIENCE_NAME, id);
        }, [
            fireEvent
        ]);
        return (0, (0, parcelRequire("kR87P")).useAISummary)({
            url: dataUrl,
            ari: ari,
            product: product,
            envKey: envKey,
            baseUrl: baseUrl,
            onStart: onStart,
            onSuccess: onSuccess,
            onError: onError
        });
    };
    var $27e30e18347ce2a0$export$2e2bcd8739ae039 = $27e30e18347ce2a0$var$useAISummaryAction;
});
parcelRegister("hWyvy", function(module, exports) {
    $parcel$export(module.exports, "extractAri", ()=>$e72cc95d6d37b739$export$be18a6294fd426ec);
    const $e72cc95d6d37b739$export$be18a6294fd426ec = (jsonLd)=>{
        if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    };
});
parcelRegister("8UXrm", function(module, exports) {
    $parcel$export(module.exports, "extractLink", ()=>$c7ac01b191c63203$export$63f54cf4c5883620);
    var $7OmtM;
    const $c7ac01b191c63203$export$63f54cf4c5883620 = (jsonLd)=>{
        const url = jsonLd.url;
        if (url) {
            if (typeof url === 'string') return url;
            else return (0, (0, parcelRequire("7OmtM")).extractUrlFromLinkJsonLd)(url);
        }
    };
});
parcelRegister("hjhAz", function(module, exports) {
    $parcel$export(module.exports, "useSmartCardState", ()=>$7fb324870ee27912$export$b0444d00ba7313c6);
    var $bDWQ3 = parcelRequire("bDWQ3");
    var $kECas;
    const $7fb324870ee27912$var$PENDING_STATE = {
        status: 'pending'
    };
    function $7fb324870ee27912$export$b0444d00ba7313c6(url) {
        const { store: store } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const cardState = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
        return cardState ?? $7fb324870ee27912$var$PENDING_STATE;
    }
});
parcelRegister("kR87P", function(module, exports) {
    $parcel$export(module.exports, "useAISummary", ()=>$c5395471ca862cc2$export$becd8f2eba1bbd96);
    var $5uXOq = parcelRequire("5uXOq");
    var $SrCME;
    var $561ku;
    const $c5395471ca862cc2$export$becd8f2eba1bbd96 = (props)=>{
        const { url: url, baseUrl: baseUrl, product: product, ari: ari, envKey: envKey, onError: onError, onStart: onStart, onSuccess: onSuccess } = props;
        const [state, setState] = (0, $5uXOq.useState)((0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.state || {
            status: 'ready',
            content: ''
        });
        (0, $5uXOq.useEffect)(()=>{
            if (url && !(0, (0, parcelRequire("561ku")).AISummariesStore).get(url)) (0, (0, parcelRequire("561ku")).AISummariesStore).set(url, new (0, (0, parcelRequire("SrCME")).AISummaryService)({
                url: url,
                ari: ari,
                baseUrl: baseUrl,
                product: product,
                envKey: envKey,
                onError: onError,
                onStart: onStart,
                onSuccess: onSuccess
            }));
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.subscribe(setState);
        }, [
            url,
            baseUrl,
            onError,
            onStart,
            onSuccess,
            product,
            ari,
            envKey
        ]);
        const summariseUrl = ()=>{
            return (0, (0, parcelRequire("561ku")).AISummariesStore).get(url)?.summariseUrl();
        };
        return {
            summariseUrl: summariseUrl,
            state: state
        };
    };
});
parcelRegister("SrCME", function(module, exports) {
    $parcel$export(module.exports, "AISummaryService", ()=>$ad05438f1e08870b$export$73e4b807d5bd74b6);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $itO4f;
    var $VSDnB;
    var $9AA7J;
    var $c0Zwh;
    var $ghXNq;
    class $ad05438f1e08870b$export$73e4b807d5bd74b6 {
        constructor(props){
            this.state = {
                content: '',
                status: 'ready'
            };
            this.subscribedStateSetters = new Set();
            this.getRequestUrl = (envKey, baseUrlOverride)=>{
                const path = 'assist/chat/v1/invoke_agent/stream';
                if (baseUrlOverride || envKey) {
                    const baseUrl = baseUrlOverride || (0, (0, parcelRequire("itO4f")).getBaseUrl)(envKey);
                    return (0, (0, parcelRequire("ghXNq")).addPath)(baseUrl, path);
                }
                return (0, (0, parcelRequire("ghXNq")).addPath)('/gateway/api/', path);
            };
            this.fetchStream = async ()=>{
                const payload = {
                    recipient_agent_named_id: (0, (0, parcelRequire("VSDnB")).fg)('platform-smart-card-use-ai-smartlink-summary-agent') ? 'smartlink_summary_agent' : 'summary_agent',
                    agent_input_context: {
                        content_url: this.url,
                        content_ari: this.ari,
                        prompt_id: 'smart_links',
                        summary_output_mimetype: 'text/markdown'
                    }
                };
                const options = {
                    method: 'POST',
                    headers: this.config.headers,
                    body: JSON.stringify(payload),
                    credentials: 'include'
                };
                const response = await fetch(this.config.requestUrl, options);
                if (!response.ok || response.status >= 400) throw new Error(`Status: ${response.status}\n URL: ${this.url}\n StatusText ${response.statusText}`);
                else return (0, (0, parcelRequire("9AA7J")).readStream)(response);
            };
            this.config = {
                requestUrl: this.getRequestUrl(props.envKey, props.baseUrl),
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'x-experience-id': 'smart-link',
                    'x-product': (0, (0, parcelRequire("ghXNq")).getXProductHeaderValue)(props.product)?.toLowerCase() || 'confluence'
                }
            };
            this.url = props.url;
            this.ari = props.ari;
            this.onStart = props.onStart;
            this.onSuccess = props.onSuccess;
            this.onError = props.onError;
        }
        async summariseUrl() {
            this.state = {
                status: 'loading',
                content: ''
            };
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            const id = (0, ($parcel$interopDefault($7Jxgt)))();
            try {
                this.onStart?.(id);
                const stream = await this.fetchStream();
                let bufferContent = '';
                for await (const chunk of stream){
                    if (chunk.type === 'ANSWER_PART') {
                        bufferContent += chunk.message.content;
                        for (const subscriber of this.subscribedStateSetters)subscriber({
                            ...this.state,
                            content: bufferContent
                        });
                    }
                    if (chunk.type === 'FINAL_RESPONSE') bufferContent = chunk.message.message.content;
                    if (chunk.type === 'ERROR') throw new (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError)(chunk?.message?.message_template);
                }
                this.onSuccess?.(id);
                this.state = {
                    status: 'done',
                    content: bufferContent
                };
            } catch (err) {
                let message = err instanceof (0, (0, parcelRequire("c0Zwh")).ChunkProcessingError) ? err.message : 'UNEXPECTED';
                this.onError?.(id, message);
                this.state = {
                    status: 'error',
                    content: '',
                    error: message
                };
            }
            for (const subscriber of this.subscribedStateSetters)subscriber(this.state);
            return this.state;
        }
        subscribe(stateSetter) {
            this.subscribedStateSetters.add(stateSetter);
            return ()=>{
                this.subscribedStateSetters.delete(stateSetter);
            };
        }
    }
});
parcelRegister("9AA7J", function(module, exports) {
    $parcel$export(module.exports, "readStream", ()=>$27dc203987154036$export$e45226161c660403);
    var $ghXNq;
    async function* $27dc203987154036$export$e45226161c660403(response) {
        const reader = (0, (0, parcelRequire("ghXNq")).getBufferReader)(response);
        let doneStreaming = false;
        let chunkBuffer = '';
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            if (value) {
                const processedChunks = `${chunkBuffer}${value}`.split('\n');
                chunkBuffer = '';
                for (let chunk of processedChunks)try {
                    const jsonChunk = JSON.parse(chunk);
                    if (jsonChunk.type === 'ERROR') reader.cancel();
                    yield jsonChunk;
                } catch (e) {
                    chunkBuffer = chunk;
                }
            }
        } catch (e) {
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else {
                reader.cancel();
                throw e;
            }
        }
        while (!doneStreaming)
        if (chunkBuffer) {
            const error = new Error(`Not all the data was processed: ${chunkBuffer}`);
            throw error;
        }
    }
});
parcelRegister("ghXNq", function(module, exports) {
    $parcel$export(module.exports, "getBufferReader", ()=>$6c9c387ba5dd9d5b$export$f6383c3ea1307da9);
    $parcel$export(module.exports, "addPath", ()=>$6c9c387ba5dd9d5b$export$4c25481b843feb0b);
    $parcel$export(module.exports, "getXProductHeaderValue", ()=>$6c9c387ba5dd9d5b$export$ff2962de2b2c930f);
    const $6c9c387ba5dd9d5b$export$f6383c3ea1307da9 = (response)=>{
        if (!response.body) throw new Error('Response body is empty');
        return response.body.pipeThrough(new TextDecoderStream()).getReader();
    };
    const $6c9c387ba5dd9d5b$export$4c25481b843feb0b = (baseUrl, path)=>{
        const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
        const url = [
            urlWithTrailingSlash,
            pathWithoutLeadingSlash
        ].join('');
        return url;
    };
    const $6c9c387ba5dd9d5b$var$AiMateJiraXProduct = {
        JSM: 'JSM',
        JSW: 'JIRA-SOFTWARE',
        JWM: 'JIRA-CORE',
        JPD: 'JPD'
    };
    const $6c9c387ba5dd9d5b$var$isJiraProduct = (product)=>{
        const JIRA_PRODUCTS = [
            'JPD',
            'JSM',
            'JSW',
            'JWM'
        ];
        return product !== undefined && JIRA_PRODUCTS.includes(product);
    };
    const $6c9c387ba5dd9d5b$export$ff2962de2b2c930f = (product)=>{
        if ($6c9c387ba5dd9d5b$var$isJiraProduct(product)) return $6c9c387ba5dd9d5b$var$AiMateJiraXProduct[product];
        return product;
    };
});
parcelRegister("c0Zwh", function(module, exports) {
    $parcel$export(module.exports, "ChunkProcessingError", ()=>$0e5f8d5a8019ed33$export$fcec967a4b7ebd84);
    class $0e5f8d5a8019ed33$export$fcec967a4b7ebd84 extends Error {
        constructor(error){
            super(error);
        }
    }
    const $0e5f8d5a8019ed33$export$d8bd0967cb58683 = [
        'NETWORK_ERROR',
        'NO_ANSWER',
        'RATE_LIMIT',
        'NO_AGENT',
        'PLUGIN_ERRORED',
        'OPENAI_RATE_LIMIT_USER_ABUSE',
        'ACCEPTABLE_USE_VIOLATIONS',
        'AI_DISABLED',
        'UNEXPECTED',
        'HIPAA_CONTENT_DETECTED',
        'EXCEEDING_CONTEXT_LENGTH_ERROR'
    ];
});
parcelRegister("561ku", function(module, exports) {
    $parcel$export(module.exports, "AISummariesStore", ()=>$cc472589618fd980$export$6979339b6d41707e);
    var $iwKVT = parcelRequire("iwKVT");
    const $cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE = 100;
    const $cc472589618fd980$export$6979339b6d41707e = new (0, $iwKVT.LRUMap)($cc472589618fd980$var$AI_SUMMARY_CACHE_SIZE);
});
parcelRegister("anB5s", function(module, exports) {
    $parcel$export(module.exports, "useAISummaryConfig", ()=>$cd0a62b074a064ce$export$4480af2c00aa7ebe);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    const $cd0a62b074a064ce$export$4480af2c00aa7ebe = ()=>{
        const { connections: connections, product: product, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        return (0, $5uXOq.useMemo)(()=>({
                baseUrl: connections.client.baseUrlOverride,
                envKey: connections.client.envKey,
                product: product,
                isAdminHubAIEnabled: isAdminHubAIEnabled
            }), [
            connections.client.baseUrlOverride,
            connections.client.envKey,
            product,
            isAdminHubAIEnabled
        ]);
    };
});
parcelRegister("8UCLX", function(module, exports) {
    $parcel$export(module.exports, "AISummariseAction", ()=>$a2971ac1720627ee$export$75a19de44af58722);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jps85;
    var $a1vqi;
    var $7zaVw;
    var $8z1HA;
    var $23vM5;
    var $blyr7;
    function $a2971ac1720627ee$export$75a19de44af58722({ url: url, onClick: onClickCallback, onError: onErrorCallback, testId: testId, status: status, summariseUrl: summariseUrl, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onCompleted = (0, $5uXOq.useCallback)((state)=>{
            if (state?.status === 'error') onErrorCallback?.((0, (0, parcelRequire("blyr7")).getErrorMessage)(state.error));
        }, [
            onErrorCallback
        ]);
        const handleActionClick = (0, $5uXOq.useCallback)(()=>{
            fireEvent('ui.button.clicked.aiSummary', {});
            fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 0,
                userGeneratedAI: 1
            });
            summariseUrl()?.then(onCompleted, onCompleted);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            onCompleted,
            summariseUrl
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
                spacing: "spacious",
                color: "currentColor",
                label: "Summarise with AI",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default)
            }),
            onClick: handleActionClick,
            testId: `${testId}-summarise-action`,
            isLoading: status === 'loading',
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summary_action_description),
            ...props
        });
    }
});
parcelRegister("jps85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e2162c0618e136c6$var$_react = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e2162c0618e136c6$var$_UNSAFE_baseNew = $e2162c0618e136c6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e2162c0618e136c6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e2162c0618e136c6$var$AtlassianIntelligenceIcon = (props)=>$e2162c0618e136c6$var$_react.default.createElement($e2162c0618e136c6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
        }, props));
    $e2162c0618e136c6$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
    var $e2162c0618e136c6$var$_default = module.exports.default = $e2162c0618e136c6$var$AtlassianIntelligenceIcon;
});
parcelRegister("8z1HA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f8c2f1acb4b6b88$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dV6Te;
    const $7f8c2f1acb4b6b88$var$AiIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dV6Te")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("g", null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: "var(--ds-icon, #44546F)"
        })));
    var $7f8c2f1acb4b6b88$export$2e2bcd8739ae039 = $7f8c2f1acb4b6b88$var$AiIcon;
});
parcelRegister("blyr7", function(module, exports) {
    $parcel$export(module.exports, "getErrorMessage", ()=>$2b1346f84062e88d$export$82f46aa4e6535a45);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cnaAy;
    var $RbANO;
    var $1r4gF;
    const $2b1346f84062e88d$export$82f46aa4e6535a45 = (error)=>{
        const { message: message, url: url } = (0, (0, parcelRequire("cnaAy")).getAISummaryErrorMessage)(error);
        return {
            appearance: 'error',
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("RbANO")).default), {
                reason: error
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...message,
                values: {
                    a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1r4gF")).default), {
                            href: url
                        }, chunks)
                }
            }))
        };
    };
});
parcelRegister("cnaAy", function(module, exports) {
    $parcel$export(module.exports, "getIsAISummaryEnabled", ()=>$3339f41fc1b0dac1$export$d439c74cb206ff29);
    $parcel$export(module.exports, "getAISummaryErrorMessage", ()=>$3339f41fc1b0dac1$export$cd2e891d7f87074d);
    var $8dVIb;
    var $7zaVw;
    const $3339f41fc1b0dac1$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>Boolean(isAdminHubAIEnabled && response?.meta?.supportedFeature?.includes('AISummary'));
    const $3339f41fc1b0dac1$export$cd2e891d7f87074d = (error)=>{
        switch(error){
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_acceptable_use_violation,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_ACCEPTABLE_USE_POLICY)
                };
            case 'HIPAA_CONTENT_DETECTED':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_hipaa_content_detected
                };
            case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_exceeding_context_length_error
                };
            default:
                return {
                    message: (0, (0, parcelRequire("7zaVw")).messages).ai_summary_error_generic,
                    url: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI_TROUBLESHOOTING)
                };
        }
    };
});
parcelRegister("RbANO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$402c39c7523f0dd1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $402c39c7523f0dd1$var$AIEventErrorViewed = ({ reason: reason })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.error.viewed.aiSummary', {
                reason: reason
            });
        }, [
            fireEvent,
            reason
        ]);
        return null;
    };
    var $402c39c7523f0dd1$export$2e2bcd8739ae039 = $402c39c7523f0dd1$var$AIEventErrorViewed;
});
parcelRegister("1r4gF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff8f369a3b340dfb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    const $ff8f369a3b340dfb$var$AILearnMoreAnchor = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: (0, (0, parcelRequire("8dVIb")).CONTENT_URL_AI),
            target: "_blank",
            rel: "noopener noreferrer",
            ...props
        }, children);
    var $ff8f369a3b340dfb$export$2e2bcd8739ae039 = $ff8f369a3b340dfb$var$AILearnMoreAnchor;
});
parcelRegister("jdA9V", function(module, exports) {
    $parcel$export(module.exports, "CopySummaryAction", ()=>$2e1357a85e616794$export$cfa1d3eed9a61059);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $3Fq5M;
    var $a1vqi;
    var $7zaVw;
    var $23vM5;
    function $2e1357a85e616794$export$cfa1d3eed9a61059({ url: url, onClick: onClickCallback, testId: testId, content: content, ...props }) {
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description);
        const handleCopySummaryClick = (0, $5uXOq.useCallback)(async ()=>{
            fireEvent('ui.button.clicked.copySummary', {});
            await navigator.clipboard.writeText(content ?? '');
            setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copied_summary_action_description);
            onClickCallback?.();
        }, [
            fireEvent,
            onClickCallback,
            content
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).copy_summary_action),
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Copy Summary"
            }),
            onClick: handleCopySummaryClick,
            testId: `${testId}-copy-summary-action`,
            tooltipMessage: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), tooltipMessage),
            tooltipOnHide: ()=>setTooltipMessage((0, (0, parcelRequire("7zaVw")).messages).copy_summary_action_description),
            ...props
        });
    }
});
parcelRegister("3Fq5M", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2ab970d264bef26f$var$_react = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2ab970d264bef26f$var$_copy = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("8w53e")));
    var $2ab970d264bef26f$var$_copy2 = $2ab970d264bef26f$var$_interopRequireDefault((parcelRequire("eE13R")));
    function $2ab970d264bef26f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2ab970d264bef26f$var$CopyIcon = (props)=>$2ab970d264bef26f$var$_react.default.createElement($2ab970d264bef26f$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $2ab970d264bef26f$var$_copy2.default
        }, props));
    $2ab970d264bef26f$var$CopyIcon.Name = 'CopyIconMigration';
    var $2ab970d264bef26f$var$_default = module.exports.default = $2ab970d264bef26f$var$CopyIcon;
});
parcelRegister("8w53e", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63353af41c1756be$var$_react = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63353af41c1756be$var$_UNSAFE_baseNew = $63353af41c1756be$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $63353af41c1756be$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63353af41c1756be$var$CopyIcon = (props)=>$63353af41c1756be$var$_react.default.createElement($63353af41c1756be$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $63353af41c1756be$var$CopyIcon.displayName = 'CopyIcon';
    var $63353af41c1756be$var$_default = module.exports.default = $63353af41c1756be$var$CopyIcon;
});
parcelRegister("eE13R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $aa959fe1f5a86e24$var$_react = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $aa959fe1f5a86e24$var$_copy = $aa959fe1f5a86e24$var$_interopRequireDefault((parcelRequire("8w53e")));
    function $aa959fe1f5a86e24$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $aa959fe1f5a86e24$var$CopyIcon = (props)=>$aa959fe1f5a86e24$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $aa959fe1f5a86e24$var$_copy.default
        }));
    $aa959fe1f5a86e24$var$CopyIcon.displayName = 'CopyIcon';
    var $aa959fe1f5a86e24$var$_default = module.exports.default = $aa959fe1f5a86e24$var$CopyIcon;
});
parcelRegister("5OUwn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd2a7343c5a2622$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $4ldhu;
    var $cgL5K;
    var $a1vqi;
    var $8dVIb;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $e5vwM;
    var $3Lbo8;
    const $9fd2a7343c5a2622$var$AutomationModal = (0, $5uXOq.lazy)(()=>(parcelRequire("75mQu")));
    const $9fd2a7343c5a2622$var$AutomationAction = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const { onClick: onClickCallback } = props;
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const automationActionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).ActionName).AutomationAction];
        const automationActionOnClick = (0, $5uXOq.useCallback)((automationActionData)=>{
            const { product: product, resourceType: resourceType, baseAutomationUrl: baseAutomationUrl, objectAri: objectAri, siteAri: siteAri, canManageAutomation: canManageAutomation, analyticsSource: analyticsSource, objectName: objectName } = automationActionData;
            fireEvent('ui.button.clicked.automationAction', {});
            const { modalTitle: modalTitle, modalDescription: modalDescription } = (0, (0, parcelRequire("3Lbo8")).getModalContent)(product, resourceType) || {};
            const automationModalTitle = modalTitle ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), modalTitle) : undefined;
            const automationModalDescription = modalDescription ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...modalDescription,
                values: {
                    name: objectName,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                            as: "strong"
                        }, chunks),
                    br: (0, ($parcel$interopDefault($5uXOq))).createElement("br", null)
                }
            }) : undefined;
            modal.open((0, ($parcel$interopDefault($5uXOq))).createElement($9fd2a7343c5a2622$var$AutomationModal, {
                baseAutomationUrl: baseAutomationUrl,
                objectAri: objectAri,
                siteAri: siteAri,
                canManageAutomation: canManageAutomation,
                analyticsSource: analyticsSource,
                modalTitle: automationModalTitle,
                modalDescription: automationModalDescription,
                onClose: ()=>modal.close()
            }));
            onClickCallback?.();
        }, [
            modal,
            onClickCallback,
            fireEvent
        ]);
        if (!automationActionData) return null;
        const automationActionTitle = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_title);
        const automationActionTooltip = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).automation_action_tooltip);
        const automationActionIconLabel = formatMessage((0, (0, parcelRequire("7zaVw")).messages).automation_action_icon_label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("23vM5")).default), {
            content: automationActionTitle,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ldhu"))))), {
                spacing: "spacious",
                LEGACY_fallbackIcon: (0, (0, parcelRequire("e5vwM")).default),
                color: "currentColor",
                label: automationActionIconLabel
            }),
            testId: "smart-action-automation-action",
            tooltipMessage: automationActionTooltip,
            ...props,
            onClick: ()=>automationActionOnClick(automationActionData)
        }));
    };
    var $9fd2a7343c5a2622$export$2e2bcd8739ae039 = $9fd2a7343c5a2622$var$AutomationAction;
});
parcelRegister("4ldhu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $32936cf628dec798$var$_UNSAFE_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $32936cf628dec798$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $32936cf628dec798$var$AutomationIcon = (props)=>$32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="m6 15.25-.723-.2a.75.75 0 0 0 1.253.73zM13.25 8l.53.53a.75.75 0 0 0-.53-1.28zM10 .75l.723.2A.75.75 0 0 0 9.47.22zM2.75 8l-.53-.53a.75.75 0 0 0 .53 1.28zm3.78 7.78 7.25-7.25-1.06-1.06-7.25 7.25zm6.72-8.53H8v1.5h5.25zm-4.527.95 2-7.25-1.446-.4-2 7.25zM9.47.22 2.22 7.47l1.06 1.06 7.25-7.25zM2.75 8.75H8v-1.5H2.75zm4.527-.95-2 7.25 1.446.4 2-7.25z"/>`
        }, props));
    $32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
    var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;
});
parcelRegister("7HAq8", function(module, exports) {
    $parcel$export(module.exports, "SmartLinkModalProvider", ()=>$bc735e1cde43eb76$export$bb4eb02a83e1a0f8);
    $parcel$export(module.exports, "useSmartLinkModal", ()=>$bc735e1cde43eb76$export$1fd7f5f21a6d6cb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $f4cXA;
    var $lnPiq;
    const $bc735e1cde43eb76$var$FALLBACK_API = {
        open: ()=>{},
        close: ()=>{}
    };
    const $bc735e1cde43eb76$export$f4c0a0f23ba57f8c = (0, ($parcel$interopDefault($5uXOq))).createContext($bc735e1cde43eb76$var$FALLBACK_API);
    const $bc735e1cde43eb76$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        const api = (0, $5uXOq.useMemo)(()=>({
                open: (modal)=>setElement((0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                        fallback: null
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lnPiq")).StopPropagation), null, modal))),
                close: ()=>setElement(null)
            }), []);
        const fallbackRender = (0, $5uXOq.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
            resetErrorBoundary();
            return null;
        }, []);
        const onReset = (0, $5uXOq.useCallback)(()=>setElement(null), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($bc735e1cde43eb76$export$f4c0a0f23ba57f8c.Provider, {
            value: api
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f4cXA")).ErrorBoundary), {
            fallbackRender: fallbackRender,
            onReset: onReset
        }, element));
    };
    const $bc735e1cde43eb76$export$1fd7f5f21a6d6cb8 = ()=>(0, $5uXOq.useContext)($bc735e1cde43eb76$export$f4c0a0f23ba57f8c);
});
parcelRegister("lnPiq", function(module, exports) {
    $parcel$export(module.exports, "StopPropagation", ()=>$a203465a8c9e0684$export$3e100bc08448f36c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $a203465a8c9e0684$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a203465a8c9e0684$var$styles = {
        name: "g32yti",
        styles: "max-height:0;max-width:0;position:absolute"
    };
    const $a203465a8c9e0684$export$3e100bc08448f36c = ({ children: children })=>{
        const onClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
        }, []);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $a203465a8c9e0684$var$styles,
            onClick: onClick
        }, children));
    };
});
parcelRegister("e5vwM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23884530c116b98b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $23884530c116b98b$var$AutomationManualTriggersGlyph = ({ label: label })=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            "aria-label": label,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 5L7 12H17L10 19",
            stroke: "currentColor",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
    var $23884530c116b98b$export$2e2bcd8739ae039 = $23884530c116b98b$var$AutomationManualTriggersGlyph;
});
parcelRegister("3Lbo8", function(module, exports) {
    $parcel$export(module.exports, "getModalContent", ()=>$6b74a4060fa13021$export$93e707b363eaf5c8);
    var $7zaVw;
    const $6b74a4060fa13021$export$93e707b363eaf5c8 = (product, resourceType)=>{
        const modalContentMap = {
            confluence: {
                page: {
                    modalTitle: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_title,
                    modalDescription: (0, (0, parcelRequire("7zaVw")).messages).automation_action_confluence_page_modal_description
                }
            }
        };
        return modalContentMap?.[product]?.[resourceType];
    };
});
parcelRegister("75mQu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lchYl")
    ]).then(()=>parcelRequire('1Rjyb'));
});
parcelRegister("faTeC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b95acafe5e8a7ba5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $a1vqi;
    var $7zaVw;
    var $Nh1XU;
    var $7HAq8;
    var $23vM5;
    var $k98Kd;
    const $b95acafe5e8a7ba5$var$RelatedLinksModal = (0, $5uXOq.lazy)(()=>(parcelRequire("eOjGT")));
    const $b95acafe5e8a7ba5$var$ViewRelatedLinksAction = ({ onClick: onClickCallback, ...props })=>{
        const modal = (0, (0, parcelRequire("7HAq8")).useSmartLinkModal)();
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.ViewRelatedLinksAction;
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const ari = actionData?.ari;
            if (ari) modal.open((0, (0, parcelRequire("f8Sb3")).jsx)($b95acafe5e8a7ba5$var$RelatedLinksModal, {
                ari: ari,
                showModal: true,
                onClose: ()=>modal.close()
            }));
            fireEvent('ui.button.clicked.relatedLinks', {});
            onClickCallback?.();
        }, [
            actionData?.ari,
            fireEvent,
            modal,
            onClickCallback
        ]);
        return actionData ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("23vM5")).default), {
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).related_links_view_related_urls),
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k98Kd")).default), null),
            onClick: onClick,
            testId: "smart-action-view-related-links-action",
            ariaLabel: "View most recent pages or content types coming from or found on this link",
            ...props
        }) : null;
    };
    var $b95acafe5e8a7ba5$export$2e2bcd8739ae039 = $b95acafe5e8a7ba5$var$ViewRelatedLinksAction;
});
parcelRegister("k98Kd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9aac1bc71ae3e1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ehOs2;
    function $7c9aac1bc71ae3e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $7c9aac1bc71ae3e1$var$rotateSvg = {
        name: "9v7l5f",
        styles: "transform:rotate(180deg);display:inline-block"
    };
    const $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $7c9aac1bc71ae3e1$var$rotateSvg
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("ehOs2"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "View recent links..."
        }));
    var $7c9aac1bc71ae3e1$export$2e2bcd8739ae039 = $7c9aac1bc71ae3e1$var$RelatedLinksActionIcon;
});
parcelRegister("ehOs2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a669c9c7dda1a2bd$var$_react = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a669c9c7dda1a2bd$var$_childIssues = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("a5U1O")));
    var $a669c9c7dda1a2bd$var$_childIssues2 = $a669c9c7dda1a2bd$var$_interopRequireDefault((parcelRequire("hxodJ")));
    function $a669c9c7dda1a2bd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a669c9c7dda1a2bd$var$ChildIssuesIcon = (props)=>$a669c9c7dda1a2bd$var$_react.default.createElement($a669c9c7dda1a2bd$var$_childIssues.default, Object.assign({
            LEGACY_fallbackIcon: $a669c9c7dda1a2bd$var$_childIssues2.default
        }, props));
    $a669c9c7dda1a2bd$var$ChildIssuesIcon.Name = 'ChildIssuesIconMigration';
    var $a669c9c7dda1a2bd$var$_default = module.exports.default = $a669c9c7dda1a2bd$var$ChildIssuesIcon;
});
parcelRegister("a5U1O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7595d510a7cf11ee$var$_react = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7595d510a7cf11ee$var$_UNSAFE_baseNew = $7595d510a7cf11ee$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7595d510a7cf11ee$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7595d510a7cf11ee$var$ChildIssuesIcon = (props)=>$7595d510a7cf11ee$var$_react.default.createElement($7595d510a7cf11ee$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.75 12.25v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0H3c-.69 0-1.25-.56-1.25-1.25V5.25m0-4.25v4.25m6 0v1.5a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5zm0 0h-6"/>`
        }, props));
    $7595d510a7cf11ee$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $7595d510a7cf11ee$var$_default = module.exports.default = $7595d510a7cf11ee$var$ChildIssuesIcon;
});
parcelRegister("hxodJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cc484e6d94653edf$var$_react = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $cc484e6d94653edf$var$_childIssues = $cc484e6d94653edf$var$_interopRequireDefault((parcelRequire("a5U1O")));
    function $cc484e6d94653edf$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cc484e6d94653edf$var$ChildIssuesIcon = (props)=>$cc484e6d94653edf$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 0 1 1 1v1H6v-1a1 1 0 0 1 1-1"/><path fill-rule="nonzero" d="M5 18v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2m10 2v1h4v-1zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-1a2 2 0 0 1 2-2M10 5v1h4V5zm0-2h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"/></g></svg>`
        }, props, {
            newIcon: $cc484e6d94653edf$var$_childIssues.default
        }));
    $cc484e6d94653edf$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
    var $cc484e6d94653edf$var$_default = module.exports.default = $cc484e6d94653edf$var$ChildIssuesIcon;
});
parcelRegister("eOjGT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXU8n")
    ]).then(()=>parcelRequire('14MtF'));
});
parcelRegister("dghu0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96a6d91fb5d77548$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $akF1x;
    const $96a6d91fb5d77548$var$getBlockStyles = (direction, size)=>(0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("akF1x")).getBaseStyles)(direction, size), " ", (0, (0, parcelRequire("akF1x")).highlightRemoveStyles), " justify-content:flex-start;[data-separator]+[data-separator]:before{content:'\u2022';margin-right:", (0, (0, parcelRequire("akF1x")).getGapSize)(size), "rem;}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']:before{content:'\u2192';}[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).TargetBranch, "']+[data-smart-element='", (0, (0, parcelRequire("8dVIb")).ElementName).SourceBranch, "']:before{content:'\u2190';}");
    const $96a6d91fb5d77548$var$Block = ({ children: children, direction: direction = (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal, size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium, testId: testId = 'smart-block', overrideCss: overrideCss, blockRef: blockRef, onRender: onRender, onTransitionEnd: onTransitionEnd })=>{
        (0, $5uXOq.useEffect)(()=>{
            onRender && onRender();
        }, [
            onRender
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $96a6d91fb5d77548$var$getBlockStyles(direction, size),
                overrideCss
            ],
            "data-smart-block": true,
            "data-testid": testId,
            onTransitionEnd: onTransitionEnd,
            ref: blockRef
        }, (0, (0, parcelRequire("akF1x")).renderChildren)(children, size));
    };
    var $96a6d91fb5d77548$export$2e2bcd8739ae039 = $96a6d91fb5d77548$var$Block;
});
parcelRegister("gg6Qm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61dcf60a0013442f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    const $61dcf60a0013442f$var$DEFAULT_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MAXIMUM_MAX_LINES = 2;
    const $61dcf60a0013442f$var$MINIMUM_MAX_LINES = 1;
    const $61dcf60a0013442f$var$getElementGroupStyles = (size, maxLines)=>{
        const lineHeight = (0, (0, parcelRequire("fpDmE")).getMaxLineHeight)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)({
            lineHeight: `${lineHeight}rem`
        }, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(maxLines, lineHeight + 'rem'));
    };
    const $61dcf60a0013442f$var$getMaxLines = (maxLines)=>{
        if (maxLines > $61dcf60a0013442f$var$MAXIMUM_MAX_LINES) return $61dcf60a0013442f$var$DEFAULT_MAX_LINES;
        if (maxLines < $61dcf60a0013442f$var$MINIMUM_MAX_LINES) return $61dcf60a0013442f$var$MINIMUM_MAX_LINES;
        return maxLines;
    };
    const $61dcf60a0013442f$var$MetadataBlock = ({ maxLines: maxLines = $61dcf60a0013442f$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
        if (primary.length === 0 && secondary.length === 0 || status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        const primaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(primary);
        const secondaryElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(secondary);
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const elementGroupStyles = $61dcf60a0013442f$var$getElementGroupStyles(size, $61dcf60a0013442f$var$getMaxLines(maxLines));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, primaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Left,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, primaryElements), secondaryElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            overrideCss: elementGroupStyles,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible
        }, secondaryElements));
    };
    var $61dcf60a0013442f$export$2e2bcd8739ae039 = $61dcf60a0013442f$var$MetadataBlock;
});
parcelRegister("hYQw7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61b44b31e2da1312$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $cElbi;
    const $61b44b31e2da1312$var$PreviewBlock = ({ status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cElbi")).default), {
            ...blockProps,
            testId: testId,
            overrideUrl: overrideUrl
        });
    };
    var $61b44b31e2da1312$export$2e2bcd8739ae039 = $61b44b31e2da1312$var$PreviewBlock;
});
parcelRegister("cElbi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$64981f7edc74268b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $kDhrr;
    var $dghu0;
    function $64981f7edc74268b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $64981f7edc74268b$var$_ref = {
        name: "ooh6hm",
        styles: "margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1);&:first-of-type{margin-top:calc(var(--container-padding) * -1);}&:last-of-type{margin-bottom:calc(var(--container-padding) * -1);}"
    };
    const $64981f7edc74268b$var$getPreviewBlockStyles = (placement, ignoreContainerPadding)=>{
        if (placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left || placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0rem' : 'var(--container-padding)';
            return (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;top:", containerPadding, ";bottom:", containerPadding, ";width:calc(var(--preview-block-width) - ", containerPadding, ");", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Left ? `left: ${containerPadding};` : '', " ", placement === (0, (0, parcelRequire("8dVIb")).MediaPlacement).Right ? `right: ${containerPadding};` : '', " [data-smart-element-media='image']{aspect-ratio:unset;padding-top:unset;width:100%;height:100%;object-fit:cover;}");
        }
        if (ignoreContainerPadding) return $64981f7edc74268b$var$_ref;
    };
    const $64981f7edc74268b$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, overrideCss: overrideCss, placement: placement, testId: testId, overrideUrl: overrideUrl, ...blockProps })=>{
        const [styles, setStyles] = (0, $5uXOq.useState)(overrideCss);
        const updateStyles = (0, $5uXOq.useCallback)(()=>{
            setStyles((0, (0, parcelRequire("f8Sb3")).css)($64981f7edc74268b$var$getPreviewBlockStyles(placement, ignoreContainerPadding), overrideCss));
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement
        ]);
        (0, $5uXOq.useEffect)(()=>{
            updateStyles();
        }, [
            ignoreContainerPadding,
            overrideCss,
            placement,
            updateStyles
        ]);
        const handleOnLoad = (0, $5uXOq.useCallback)(()=>{
            updateStyles();
        }, [
            updateStyles
        ]);
        const handleOnError = (0, $5uXOq.useCallback)(()=>{
            if (onError) onError();
        }, [
            onError
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            overrideCss: styles,
            testId: `${testId}-resolved-view`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kDhrr")).default), {
            onError: handleOnError,
            onLoad: handleOnLoad,
            overrideUrl: overrideUrl
        }));
    };
    var $64981f7edc74268b$export$2e2bcd8739ae039 = $64981f7edc74268b$var$PreviewBlockResolvedView;
});
parcelRegister("1JaZ4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c880264dd5ccb40b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $kp8aU;
    var $fpDmE;
    var $dghu0;
    const $c880264dd5ccb40b$var$DEFAULT_MAX_LINES = 3;
    const $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES = 6;
    const $c880264dd5ccb40b$var$MINIMUM_MAX_LINES = 1;
    const $c880264dd5ccb40b$var$SnippetBlock = ({ maxLines: maxLines = $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, testId: testId = 'smart-block-snippet', text: text, ...blockProps })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved && !text) return null;
        const snippetMaxLines = (0, (0, parcelRequire("fpDmE")).getMaxLines)(maxLines, $c880264dd5ccb40b$var$DEFAULT_MAX_LINES, $c880264dd5ccb40b$var$MAXIMUM_MAX_LINES, $c880264dd5ccb40b$var$MINIMUM_MAX_LINES);
        const statusTestId = !text ? 'resolved' : 'non-resolved';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-${statusTestId}-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kp8aU")).default), {
            maxLines: snippetMaxLines,
            content: text
        }));
    };
    var $c880264dd5ccb40b$export$2e2bcd8739ae039 = $c880264dd5ccb40b$var$SnippetBlock;
});
parcelRegister("buvhv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93b66054384f48ec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8dVIb;
    var $4URMI;
    var $eqoQu;
    var $bubxq;
    var $fkxMX;
    var $bXy5i;
    var $jHa2h;
    function $93b66054384f48ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $93b66054384f48ec$var$_ref = {
        name: "11eaz",
        styles: ".actions-button-group{opacity:0;}&:hover .actions-button-group, .actions-button-group:focus-within{opacity:1;}"
    };
    const $93b66054384f48ec$var$getActionStyles = (showOnHover, isOpen)=>{
        if (showOnHover && !isOpen) return $93b66054384f48ec$var$_ref;
    };
    const $93b66054384f48ec$var$getTitleBlockViewComponent = (status)=>{
        switch(status){
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Pending:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolving:
                return 0, (0, parcelRequire("jHa2h")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved:
                return 0, (0, parcelRequire("bXy5i")).default;
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Unauthorized:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Forbidden:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).NotFound:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Errored:
            case (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback:
            default:
                return 0, (0, parcelRequire("fkxMX")).default;
        }
    };
    const $93b66054384f48ec$var$TitleBlock = ({ actions: actions = [], anchorTarget: anchorTarget, hideTitleTooltip: hideTitleTooltip, maxLines: maxLines, onActionMenuOpenChange: onActionMenuOpenChange, onClick: onClick, overrideCss: overrideCss, status: status = (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Fallback, showActionOnHover: showActionOnHover, testId: testId = 'smart-block-title', text: text, icon: icon, theme: theme, hideRetry: hideRetry, metadataPosition: metadataPosition, hideIcon: hideIcon = false, ...props })=>{
        if (hideRetry && props.retry) delete props.retry;
        const [actionDropdownOpen, setActionDropdownOpen] = (0, $5uXOq.useState)(false);
        const onDropdownOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
            setActionDropdownOpen(isOpen);
            if (onActionMenuOpenChange) onActionMenuOpenChange({
                isOpen: isOpen
            });
        }, [
            onActionMenuOpenChange
        ]);
        const actionGroup = actions.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bubxq")).default), {
            items: actions,
            visibleButtonsNum: showActionOnHover ? 1 : 2,
            onDropdownOpenChange: onDropdownOpenChange
        });
        const actionStyles = $93b66054384f48ec$var$getActionStyles(showActionOnHover, actionDropdownOpen);
        const combinedCss = (0, (0, parcelRequire("f8Sb3")).css)(actionStyles, overrideCss);
        const overrideText = !!text ? {
            text: text
        } : {};
        const onMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const title = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Title), {
            hideTooltip: hideTitleTooltip,
            maxLines: maxLines,
            onClick: onClick,
            onMouseDown: onMouseDown,
            target: anchorTarget,
            theme: theme,
            ...overrideText
        });
        const Component = $93b66054384f48ec$var$getTitleBlockViewComponent(status);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ...props,
            actionGroup: actionGroup,
            overrideCss: combinedCss,
            testId: testId,
            title: title,
            metadataPosition: metadataPosition,
            hideIcon: hideIcon,
            icon: icon
        });
    };
    var $93b66054384f48ec$export$2e2bcd8739ae039 = $93b66054384f48ec$var$TitleBlock;
});
parcelRegister("fkxMX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcbea6814ca213c7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $ousew;
    var $dC5iT;
    var $8dVIb;
    var $eqoQu;
    var $fpDmE;
    var $dghu0;
    var $1BfaB;
    function $dcbea6814ca213c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dcbea6814ca213c7$var$actionStyles = {
        name: "r982j0",
        styles: "cursor:pointer;:hover{color:var(--ds-text-subtle, #8993A4);text-decoration:underline;}"
    };
    const $dcbea6814ca213c7$var$actionHoverStyles = {
        name: "y4wzay",
        styles: "position:relative;z-index:1;&:focus{outline-offset:var(--ds-space-negative-025, -2px);}"
    };
    const $dcbea6814ca213c7$var$getMessageStyles = (size, hasAction)=>{
        const sizeStyles = (0, (0, parcelRequire("fpDmE")).getLinkSizeStyles)(size);
        return (0, (0, parcelRequire("f8Sb3")).css)("flex:1 1 auto;justify-content:flex-end;", hasAction ? $dcbea6814ca213c7$var$actionStyles : '', sizeStyles, (0, (0, parcelRequire("fpDmE")).getTruncateStyles)(1, (0, (0, parcelRequire("fpDmE")).getLinkLineHeight)(size)), {
            color: "var(--ds-text-disabled, #6B778C)",
            ':focus': {
                outline: `${"var(--ds-border-focused, #388BFF)"} solid 2px`
            }
        }, hasAction ? $dcbea6814ca213c7$var$actionHoverStyles : '');
    };
    const $dcbea6814ca213c7$var$TitleBlockErroredView = ({ actionGroup: actionGroup, retry: retry, position: position, testId: testId, title: title, icon: icon, hideIcon: hideIcon, ...blockProps })=>{
        const { descriptor: descriptor, onClick: onClick, values: values } = retry || {};
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const hasAction = onClick !== undefined;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-errored-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), title, descriptor && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $dcbea6814ca213c7$var$getMessageStyles(size, hasAction),
            onClick: onClick,
            testId: `${testId}-errored-view-message`,
            tabIndex: hasAction ? 0 : -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), {
            ...descriptor,
            values: values
        }))), actionGroup);
    };
    var $dcbea6814ca213c7$export$2e2bcd8739ae039 = $dcbea6814ca213c7$var$TitleBlockErroredView;
});
parcelRegister("bXy5i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2967317da51f9f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $eqoQu;
    var $dghu0;
    var $1BfaB;
    var $akF1x;
    function $e2967317da51f9f7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    var $e2967317da51f9f7$var$_ref = {
        name: "v43pxc",
        styles: "gap:var(--ds-space-050, 0.25rem)"
    };
    const $e2967317da51f9f7$var$TitleBlockResolvedView = ({ actionGroup: actionGroup, metadata: metadata = [], position: position, subtitle: subtitle = [], testId: testId, text: text, icon: icon, title: title, metadataPosition: metadataPosition, hideIcon: hideIcon, ...blockProps })=>{
        const metadataElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(metadata);
        const subtitleElements = (0, (0, parcelRequire("akF1x")).renderElementItems)(subtitle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolved-view`
        }, !hideIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).LinkIcon), {
            overrideIcon: icon,
            position: position
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            width: (0, (0, parcelRequire("8dVIb")).SmartLinkWidth).Flexible,
            overrideCss: $e2967317da51f9f7$var$_ref
        }, title, subtitleElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal
        }, subtitleElements)), metadataElements && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BfaB")).default), {
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Horizontal,
            align: (0, (0, parcelRequire("8dVIb")).SmartLinkAlignment).Right,
            position: metadataPosition ?? (0, (0, parcelRequire("8dVIb")).SmartLinkPosition).Center
        }, metadataElements), actionGroup);
    };
    var $e2967317da51f9f7$export$2e2bcd8739ae039 = $e2967317da51f9f7$var$TitleBlockResolvedView;
});
parcelRegister("jHa2h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$045d1b1e49cae759$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8dVIb;
    var $gU02S;
    var $fpDmE;
    var $dghu0;
    const $045d1b1e49cae759$var$TitleBlockResolvingView = ({ actionGroup: actionGroup, testId: testId, title: title, hideIcon: hideIcon, ...blockProps })=>{
        const { size: size = (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium } = blockProps;
        const iconWidth = (0, (0, parcelRequire("fpDmE")).getIconWidth)(size);
        const iconStyles = (0, (0, parcelRequire("fpDmE")).getIconSizeStyles)(iconWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dghu0")).default), {
            ...blockProps,
            testId: `${testId}-resolving-view`
        }, !hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: iconStyles,
            "data-testid": `${testId}-icon`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gU02S")).default), {
            testId: `${testId}-icon-loading`
        })), title, actionGroup);
    };
    var $045d1b1e49cae759$export$2e2bcd8739ae039 = $045d1b1e49cae759$var$TitleBlockResolvingView;
});
parcelRegister("1qDIM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dff75b4d7cc06d3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $4tgi5;
    const $5dff75b4d7cc06d3$var$AISummaryBlock = ({ status: status, testId: testId = 'smart-ai-summary-block', ...props })=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        if (!actionData?.url) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4tgi5")).default), {
            ...props,
            testId: testId,
            url: actionData.url
        });
    };
    var $5dff75b4d7cc06d3$export$2e2bcd8739ae039 = $5dff75b4d7cc06d3$var$AISummaryBlock;
});
parcelRegister("4tgi5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$413bb2fab5c71807$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8dVIb;
    var $1MeuC;
    var $bHeMs;
    var $aBTst;
    var $dghu0;
    var $adeuB;
    const $413bb2fab5c71807$var$AISummaryBlockResolvedView = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default), (0, (0, parcelRequire("bHeMs")).default));
        const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
        const { state: { content: content, status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        const showAISummary = status === 'done' || status === 'loading' && !!content;
        const isSummarisedOnMountRef = (0, $5uXOq.useRef)(status === 'done');
        const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
        if (!showAISummary) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, placeholder);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            direction: (0, (0, parcelRequire("8dVIb")).SmartLinkDirection).Vertical,
            testId: `${testId}-resolved-view`,
            overrideCss: (0, (0, parcelRequire("f8Sb3")).css)("overflow:visible;", props.overrideCss)
        }, status === 'done' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adeuB")).default), {
            fromCache: isSummarisedOnMountRef.current
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            minHeight: minHeight,
            show: showAISummary,
            showTransition: !isSummarisedOnMountRef.current
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bHeMs")).default), {
            testId: `${testId}-ai-summary`,
            minHeight: minHeight,
            content: content
        })));
    };
    var $413bb2fab5c71807$export$2e2bcd8739ae039 = $413bb2fab5c71807$var$AISummaryBlockResolvedView;
});
parcelRegister("bHeMs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea67ef8b17402f34$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $flpap;
    var $aRS1S;
    function $ea67ef8b17402f34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ea67ef8b17402f34$var$AISummaryCSSStyles = {
        name: "178flxl",
        styles: "font-size:0.75rem;line-height:1rem;word-wrap:break-word;word-break:break-word;white-space:normal;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text"
    };
    const $ea67ef8b17402f34$var$AISummary = ({ content: content = '', overrideCss: overrideCss, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
        if (!content && minHeight === 0) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("flpap")).default), {
            "data-testid": testId,
            css: [
                $ea67ef8b17402f34$var$AISummaryCSSStyles,
                overrideCss
            ],
            children: content,
            options: {
                forceWrapper: true,
                overrides: {
                    ul: (0, (0, parcelRequire("aRS1S")).default)
                }
            },
            style: {
                minHeight: minHeight
            }
        });
    };
    var $ea67ef8b17402f34$export$2e2bcd8739ae039 = $ea67ef8b17402f34$var$AISummary;
});
parcelRegister("flpap", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2bc56c6c0b4e02e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $b2bc56c6c0b4e02e$var$t() {
        return $b2bc56c6c0b4e02e$var$t = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
        }, $b2bc56c6c0b4e02e$var$t.apply(this, arguments);
    }
    const $b2bc56c6c0b4e02e$var$n = [
        "children",
        "options"
    ], $b2bc56c6c0b4e02e$export$e0aa44767d8750d5 = {
        blockQuote: "0",
        breakLine: "1",
        breakThematic: "2",
        codeBlock: "3",
        codeFenced: "4",
        codeInline: "5",
        footnote: "6",
        footnoteReference: "7",
        gfmTask: "8",
        heading: "9",
        headingSetext: "10",
        htmlBlock: "11",
        htmlComment: "12",
        htmlSelfClosing: "13",
        image: "14",
        link: "15",
        linkAngleBraceStyleDetector: "16",
        linkBareUrlDetector: "17",
        linkMailtoDetector: "18",
        newlineCoalescer: "19",
        orderedList: "20",
        paragraph: "21",
        ref: "22",
        refImage: "23",
        refLink: "24",
        table: "25",
        tableSeparator: "26",
        text: "27",
        textBolded: "28",
        textEmphasized: "29",
        textEscaped: "30",
        textMarked: "31",
        textStrikethroughed: "32",
        unorderedList: "33"
    };
    var $b2bc56c6c0b4e02e$var$i;
    !function(e) {
        e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
    }($b2bc56c6c0b4e02e$var$i || ($b2bc56c6c0b4e02e$var$i = {}));
    const $b2bc56c6c0b4e02e$var$l = [
        "allowFullScreen",
        "allowTransparency",
        "autoComplete",
        "autoFocus",
        "autoPlay",
        "cellPadding",
        "cellSpacing",
        "charSet",
        "classId",
        "colSpan",
        "contentEditable",
        "contextMenu",
        "crossOrigin",
        "encType",
        "formAction",
        "formEncType",
        "formMethod",
        "formNoValidate",
        "formTarget",
        "frameBorder",
        "hrefLang",
        "inputMode",
        "keyParams",
        "keyType",
        "marginHeight",
        "marginWidth",
        "maxLength",
        "mediaGroup",
        "minLength",
        "noValidate",
        "radioGroup",
        "readOnly",
        "rowSpan",
        "spellCheck",
        "srcDoc",
        "srcLang",
        "srcSet",
        "tabIndex",
        "useMap"
    ].reduce((e, t)=>(e[t.toLowerCase()] = t, e), {
        class: "className",
        for: "htmlFor"
    }), $b2bc56c6c0b4e02e$var$a = {
        amp: "&",
        apos: "'",
        gt: ">",
        lt: "<",
        nbsp: "\xa0",
        quot: "\u201C"
    }, $b2bc56c6c0b4e02e$var$o = [
        "style",
        "script"
    ], $b2bc56c6c0b4e02e$var$c = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b2bc56c6c0b4e02e$var$s = /mailto:/i, $b2bc56c6c0b4e02e$var$d = /\n{2,}$/, $b2bc56c6c0b4e02e$var$p = /^(\s*>[\s\S]*?)(?=\n{2,})/, $b2bc56c6c0b4e02e$var$u = /^ *> ?/gm, $b2bc56c6c0b4e02e$var$f = /^ {2,}\n/, $b2bc56c6c0b4e02e$var$h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$m = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b2bc56c6c0b4e02e$var$g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b2bc56c6c0b4e02e$var$y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, $b2bc56c6c0b4e02e$var$k = /^(?:\n *)*\n/, $b2bc56c6c0b4e02e$var$x = /\r\n?/g, $b2bc56c6c0b4e02e$var$b = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b2bc56c6c0b4e02e$var$v = /^\[\^([^\]]+)]/, $b2bc56c6c0b4e02e$var$S = /\f/g, $b2bc56c6c0b4e02e$var$E = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b2bc56c6c0b4e02e$var$C = /^\s*?\[(x|\s)\]/, $b2bc56c6c0b4e02e$var$$ = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$w = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b2bc56c6c0b4e02e$var$z = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $b2bc56c6c0b4e02e$var$L = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b2bc56c6c0b4e02e$var$A = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b2bc56c6c0b4e02e$var$T = /^<!--[\s\S]*?(?:-->)/, $b2bc56c6c0b4e02e$var$O = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b2bc56c6c0b4e02e$var$B = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b2bc56c6c0b4e02e$var$M = /^\{.*\}$/, $b2bc56c6c0b4e02e$var$R = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b2bc56c6c0b4e02e$var$I = /^<([^ >]+@[^ >]+)>/, $b2bc56c6c0b4e02e$var$U = /^<([^ >]+:\/[^ >]+)>/, $b2bc56c6c0b4e02e$var$D = /-([a-z])?/gi, $b2bc56c6c0b4e02e$var$j = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b2bc56c6c0b4e02e$var$N = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b2bc56c6c0b4e02e$var$H = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$F = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b2bc56c6c0b4e02e$var$P = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b2bc56c6c0b4e02e$var$_ = /\t/g, $b2bc56c6c0b4e02e$var$G = /(^ *\||\| *$)/g, $b2bc56c6c0b4e02e$var$W = /^ *:-+: *$/, $b2bc56c6c0b4e02e$var$Z = /^ *:-+ *$/, $b2bc56c6c0b4e02e$var$q = /^ *-+: *$/, $b2bc56c6c0b4e02e$var$Q = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", $b2bc56c6c0b4e02e$var$V = new RegExp(`^([*_])\\1${$b2bc56c6c0b4e02e$var$Q}\\1\\1(?!\\1)`), $b2bc56c6c0b4e02e$var$X = new RegExp(`^([*_])${$b2bc56c6c0b4e02e$var$Q}\\1(?!\\1|\\w)`), $b2bc56c6c0b4e02e$var$J = new RegExp(`^==${$b2bc56c6c0b4e02e$var$Q}==`), $b2bc56c6c0b4e02e$var$K = new RegExp(`^~~${$b2bc56c6c0b4e02e$var$Q}~~`), $b2bc56c6c0b4e02e$var$Y = /^\\([^0-9A-Za-z\s])/, $b2bc56c6c0b4e02e$var$ee = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, $b2bc56c6c0b4e02e$var$te = /^\n+/, $b2bc56c6c0b4e02e$var$ne = /^([ \t]*)/, $b2bc56c6c0b4e02e$var$re = /\\([^\\])/g, $b2bc56c6c0b4e02e$var$ie = / *\n+$/, $b2bc56c6c0b4e02e$var$le = /(?:^|\n)( *)$/, $b2bc56c6c0b4e02e$var$ae = "(?:\\d+\\.)", $b2bc56c6c0b4e02e$var$oe = "(?:[*+-])";
    function $b2bc56c6c0b4e02e$var$ce(e) {
        return "( *)(" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + ") +";
    }
    const $b2bc56c6c0b4e02e$var$se = $b2bc56c6c0b4e02e$var$ce(1), $b2bc56c6c0b4e02e$var$de = $b2bc56c6c0b4e02e$var$ce(2);
    function $b2bc56c6c0b4e02e$var$pe(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de));
    }
    const $b2bc56c6c0b4e02e$var$ue = $b2bc56c6c0b4e02e$var$pe(1), $b2bc56c6c0b4e02e$var$fe = $b2bc56c6c0b4e02e$var$pe(2);
    function $b2bc56c6c0b4e02e$var$he(e) {
        return new RegExp("^" + (1 === e ? $b2bc56c6c0b4e02e$var$se : $b2bc56c6c0b4e02e$var$de) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe) + " )[^\\n]*)*(\\n|$)", "gm");
    }
    const $b2bc56c6c0b4e02e$var$me = $b2bc56c6c0b4e02e$var$he(1), $b2bc56c6c0b4e02e$var$ge = $b2bc56c6c0b4e02e$var$he(2);
    function $b2bc56c6c0b4e02e$var$ye(e) {
        const t = 1 === e ? $b2bc56c6c0b4e02e$var$ae : $b2bc56c6c0b4e02e$var$oe;
        return new RegExp("^( *)(" + t + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + t + " (?!" + t + " ))\\n*|\\s*\\n*$)");
    }
    const $b2bc56c6c0b4e02e$var$ke = $b2bc56c6c0b4e02e$var$ye(1), $b2bc56c6c0b4e02e$var$xe = $b2bc56c6c0b4e02e$var$ye(2);
    function $b2bc56c6c0b4e02e$var$be(e, t) {
        const n = 1 === t, i = n ? $b2bc56c6c0b4e02e$var$ke : $b2bc56c6c0b4e02e$var$xe, l = n ? $b2bc56c6c0b4e02e$var$me : $b2bc56c6c0b4e02e$var$ge, a = n ? $b2bc56c6c0b4e02e$var$ue : $b2bc56c6c0b4e02e$var$fe;
        return {
            match (e, t) {
                const n = $b2bc56c6c0b4e02e$var$le.exec(t.prevCapture);
                return n && (t.list || !t.inline && !t.simple) ? i.exec(e = n[1] + e) : null;
            },
            order: 1,
            parse (e, t, r) {
                const i = n ? +e[2] : void 0, o = e[0].replace($b2bc56c6c0b4e02e$var$d, "\n").match(l);
                let c = !1;
                return {
                    items: o.map(function(e, n) {
                        const i = a.exec(e)[0].length, l = new RegExp("^ {1," + i + "}", "gm"), s = e.replace(l, "").replace(a, ""), d = n === o.length - 1, p = -1 !== s.indexOf("\n\n") || d && c;
                        c = p;
                        const u = r.inline, f = r.list;
                        let h;
                        r.list = !0, p ? (r.inline = !1, h = s.replace($b2bc56c6c0b4e02e$var$ie, "\n\n")) : (r.inline = !0, h = s.replace($b2bc56c6c0b4e02e$var$ie, ""));
                        const m = t(h, r);
                        return r.inline = u, r.list = f, m;
                    }),
                    ordered: n,
                    start: i
                };
            },
            render: (t, n, i)=>e(t.ordered ? "ol" : "ul", {
                    key: i.key,
                    start: t.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList ? t.start : void 0
                }, t.items.map(function(t, r) {
                    return e("li", {
                        key: r
                    }, n(t, i));
                }))
        };
    }
    const $b2bc56c6c0b4e02e$var$ve = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b2bc56c6c0b4e02e$var$Se = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, $b2bc56c6c0b4e02e$var$Ee = [
        $b2bc56c6c0b4e02e$var$p,
        $b2bc56c6c0b4e02e$var$m,
        $b2bc56c6c0b4e02e$var$g,
        $b2bc56c6c0b4e02e$var$$,
        $b2bc56c6c0b4e02e$var$z,
        $b2bc56c6c0b4e02e$var$w,
        $b2bc56c6c0b4e02e$var$T,
        $b2bc56c6c0b4e02e$var$j,
        $b2bc56c6c0b4e02e$var$me,
        $b2bc56c6c0b4e02e$var$ke,
        $b2bc56c6c0b4e02e$var$ge,
        $b2bc56c6c0b4e02e$var$xe
    ], $b2bc56c6c0b4e02e$var$Ce = [
        ...$b2bc56c6c0b4e02e$var$Ee,
        /^[^\n]+(?:  \n|\n{2,})/,
        $b2bc56c6c0b4e02e$var$L,
        $b2bc56c6c0b4e02e$var$B
    ];
    function $b2bc56c6c0b4e02e$export$c383cdd2a518017a(e) {
        return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
    }
    function $b2bc56c6c0b4e02e$var$we(e) {
        return $b2bc56c6c0b4e02e$var$q.test(e) ? "right" : $b2bc56c6c0b4e02e$var$W.test(e) ? "center" : $b2bc56c6c0b4e02e$var$Z.test(e) ? "left" : null;
    }
    function $b2bc56c6c0b4e02e$var$ze(e, t, n, i) {
        const l = n.inTable;
        n.inTable = !0;
        let a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce((e, l)=>("|" === l.trim() ? e.push(i ? {
                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator
            } : {
                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text,
                text: l
            }) : "" !== l && e.push.apply(e, t(l, n)), e), []);
        n.inTable = l;
        let o = [
            []
        ];
        return a.forEach(function(e, t) {
            e.type === $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator ? 0 !== t && t !== a.length - 1 && o.push([]) : (e.type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text || null != a[t + 1] && a[t + 1].type !== $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.tableSeparator || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
        }), o;
    }
    function $b2bc56c6c0b4e02e$var$Le(e, t, n) {
        n.inline = !0;
        const i = e[2] ? e[2].replace($b2bc56c6c0b4e02e$var$G, "").split("|").map($b2bc56c6c0b4e02e$var$we) : [], l = e[3] ? function(e, t, n) {
            return e.trim().split("\n").map(function(e) {
                return $b2bc56c6c0b4e02e$var$ze(e, t, n, !0);
            });
        }(e[3], t, n) : [], a = $b2bc56c6c0b4e02e$var$ze(e[1], t, n, !!l.length);
        return n.inline = !1, l.length ? {
            align: i,
            cells: l,
            header: a,
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table
        } : {
            children: a,
            type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph
        };
    }
    function $b2bc56c6c0b4e02e$var$Ae(e, t) {
        return null == e.align[t] ? {} : {
            textAlign: e.align[t]
        };
    }
    function $b2bc56c6c0b4e02e$var$Te(e) {
        return function(t, n) {
            return n.inline ? e.exec(t) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Oe(e) {
        return function(t, n) {
            return n.inline || n.simple ? e.exec(t) : null;
        };
    }
    function $b2bc56c6c0b4e02e$var$Be(e) {
        return function(t, n) {
            return n.inline || n.simple ? null : e.exec(t);
        };
    }
    function $b2bc56c6c0b4e02e$var$Me(e) {
        return function(t) {
            return e.exec(t);
        };
    }
    function $b2bc56c6c0b4e02e$var$Re(e, t) {
        if (t.inline || t.simple) return null;
        let n = "";
        e.split("\n").every((e)=>!$b2bc56c6c0b4e02e$var$Ee.some((t)=>t.test(e)) && (n += e + "\n", e.trim()));
        const r = n.trimEnd();
        return "" == r ? null : [
            n,
            r
        ];
    }
    function $b2bc56c6c0b4e02e$export$3e2338ea76b578c9(e) {
        try {
            if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return null;
        } catch (e) {
            return null;
        }
        return e;
    }
    function $b2bc56c6c0b4e02e$var$Ue(e) {
        return e.replace($b2bc56c6c0b4e02e$var$re, "$1");
    }
    function $b2bc56c6c0b4e02e$var$De(e, t, n) {
        const r = n.inline || !1, i = n.simple || !1;
        n.inline = !0, n.simple = !0;
        const l = e(t, n);
        return n.inline = r, n.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$je(e, t, n) {
        const r = n.inline || !1, i = n.simple || !1;
        n.inline = !1, n.simple = !0;
        const l = e(t, n);
        return n.inline = r, n.simple = i, l;
    }
    function $b2bc56c6c0b4e02e$var$Ne(e, t, n) {
        const r = n.inline || !1;
        n.inline = !1;
        const i = e(t, n);
        return n.inline = r, i;
    }
    const $b2bc56c6c0b4e02e$var$He = (e, t, n)=>({
            children: $b2bc56c6c0b4e02e$var$De(t, e[1], n)
        });
    function $b2bc56c6c0b4e02e$var$Fe() {
        return {};
    }
    function $b2bc56c6c0b4e02e$var$Pe() {
        return null;
    }
    function $b2bc56c6c0b4e02e$var$_e(...e) {
        return e.filter(Boolean).join(" ");
    }
    function $b2bc56c6c0b4e02e$var$Ge(e, t, n) {
        let r = e;
        const i = t.split(".");
        for(; i.length && (r = r[i[0]], void 0 !== r);)i.shift();
        return r || n;
    }
    function $b2bc56c6c0b4e02e$export$69f434acfbdb0b32(n = "", i = {}) {
        function d(e, n, ...r) {
            const l = $b2bc56c6c0b4e02e$var$Ge(i.overrides, `${e}.props`, {});
            return i.createElement(function(e, t) {
                const n = $b2bc56c6c0b4e02e$var$Ge(t, e);
                return n ? "function" == typeof n || "object" == typeof n && "render" in n ? n : $b2bc56c6c0b4e02e$var$Ge(t, `${e}.component`, e) : e;
            }(e, i.overrides), $b2bc56c6c0b4e02e$var$t({}, n, l, {
                className: $b2bc56c6c0b4e02e$var$_e(null == n ? void 0 : n.className, l.className) || void 0
            }), ...r);
        }
        function G(t) {
            t = t.replace($b2bc56c6c0b4e02e$var$E, "");
            let n = !1;
            i.forceInline ? n = !0 : i.forceBlock || (n = !1 === $b2bc56c6c0b4e02e$var$P.test(t));
            const r = ie(re(n ? t : `${t.trimEnd().replace($b2bc56c6c0b4e02e$var$te, "")}\n\n`, {
                inline: n
            }));
            for(; "string" == typeof r[r.length - 1] && !r[r.length - 1].trim();)r.pop();
            if (null === i.wrapper) return r;
            const l = i.wrapper || (n ? "span" : "div");
            let a;
            if (r.length > 1 || i.forceWrapper) a = r;
            else {
                if (1 === r.length) return a = r[0], "string" == typeof a ? d("span", {
                    key: "outer"
                }, a) : a;
                a = null;
            }
            return $5uXOq.createElement(l, {
                key: "outer"
            }, a);
        }
        function W(t, n) {
            const r = n.match($b2bc56c6c0b4e02e$var$c);
            return r ? r.reduce(function(n, r, a) {
                const o = r.indexOf("=");
                if (-1 !== o) {
                    const c = (function(e) {
                        return -1 !== e.indexOf("-") && null === e.match($b2bc56c6c0b4e02e$var$O) && (e = e.replace($b2bc56c6c0b4e02e$var$D, function(e, t) {
                            return t.toUpperCase();
                        })), e;
                    })(r.slice(0, o)).trim(), s = function(e) {
                        const t = e[0];
                        return ('"' === t || "'" === t) && e.length >= 2 && e[e.length - 1] === t ? e.slice(1, -1) : e;
                    }(r.slice(o + 1).trim()), d = $b2bc56c6c0b4e02e$var$l[c] || c, p = n[d] = function(e, t, n, r) {
                        return "style" === t ? n.split(/;\s?/).reduce(function(e, t) {
                            const n = t.slice(0, t.indexOf(":"));
                            return e[n.trim().replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t.slice(n.length + 1).trim(), e;
                        }, {}) : "href" === t || "src" === t ? r(n, e, t) : (n.match($b2bc56c6c0b4e02e$var$M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                    }(t, c, s, i.sanitizer);
                    "string" == typeof p && ($b2bc56c6c0b4e02e$var$L.test(p) || $b2bc56c6c0b4e02e$var$B.test(p)) && (n[d] = $5uXOq.cloneElement(G(p.trim()), {
                        key: a
                    }));
                } else "style" !== r && (n[$b2bc56c6c0b4e02e$var$l[r] || r] = !0);
                return n;
            }, {}) : null;
        }
        i.overrides = i.overrides || {}, i.sanitizer = i.sanitizer || $b2bc56c6c0b4e02e$export$3e2338ea76b578c9, i.slugify = i.slugify || $b2bc56c6c0b4e02e$export$c383cdd2a518017a, i.namedCodesToUnicode = i.namedCodesToUnicode ? $b2bc56c6c0b4e02e$var$t({}, $b2bc56c6c0b4e02e$var$a, i.namedCodesToUnicode) : $b2bc56c6c0b4e02e$var$a, i.createElement = i.createElement || $5uXOq.createElement;
        const Z = [], q = {}, Q = {
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.blockQuote]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$p),
                order: 1,
                parse: (e, t, n)=>({
                        children: t(e[0].replace($b2bc56c6c0b4e02e$var$u, ""), n)
                    }),
                render: (e, t, n)=>d("blockquote", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakLine]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$f),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, t, n)=>d("br", {
                        key: n.key
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.breakThematic]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$h),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: (e, t, n)=>d("hr", {
                        key: n.key
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$g),
                order: 0,
                parse: (e)=>({
                        lang: void 0,
                        text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
                    }),
                render: (e, n, r)=>d("pre", {
                        key: r.key
                    }, d("code", $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                        className: e.lang ? `lang-${e.lang}` : ""
                    }), e.text))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeFenced]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$m),
                order: 0,
                parse: (e)=>({
                        attrs: W("code", e[3] || ""),
                        lang: e[2] || void 0,
                        text: e[4],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeBlock
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.codeInline]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$y),
                order: 3,
                parse: (e)=>({
                        text: e[2]
                    }),
                render: (e, t, n)=>d("code", {
                        key: n.key
                    }, e.text)
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnote]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$b),
                order: 0,
                parse: (e)=>(Z.push({
                        footnote: e[2],
                        identifier: e[1]
                    }), {}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.footnoteReference]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$v),
                order: 1,
                parse: (e)=>({
                        target: `#${i.slugify(e[1], $b2bc56c6c0b4e02e$export$c383cdd2a518017a)}`,
                        text: e[1]
                    }),
                render: (e, t, n)=>d("a", {
                        key: n.key,
                        href: i.sanitizer(e.target, "a", "href")
                    }, d("sup", {
                        key: n.key
                    }, e.text))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.gfmTask]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$C),
                order: 1,
                parse: (e)=>({
                        completed: "x" === e[1].toLowerCase()
                    }),
                render: (e, t, n)=>d("input", {
                        checked: e.completed,
                        key: n.key,
                        readOnly: !0,
                        type: "checkbox"
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading]: {
                match: $b2bc56c6c0b4e02e$var$Be(i.enforceAtxHeadings ? $b2bc56c6c0b4e02e$var$w : $b2bc56c6c0b4e02e$var$$),
                order: 1,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$De(t, e[2], n),
                        id: i.slugify(e[2], $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                        level: e[1].length
                    }),
                render: (e, t, n)=>d(`h${e.level}`, {
                        id: e.id,
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.headingSetext]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$z),
                order: 0,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$De(t, e[1], n),
                        level: "=" === e[2] ? 1 : 2,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.heading
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$L),
                order: 1,
                parse (e, t, n) {
                    const [, r] = e[3].match($b2bc56c6c0b4e02e$var$ne), i = new RegExp(`^${r}`, "gm"), l = e[3].replace(i, ""), a = (c = l, $b2bc56c6c0b4e02e$var$Ce.some((e)=>e.test(c)) ? $b2bc56c6c0b4e02e$var$Ne : $b2bc56c6c0b4e02e$var$De);
                    var c;
                    const s = e[1].toLowerCase(), d = -1 !== $b2bc56c6c0b4e02e$var$o.indexOf(s), p = (d ? s : e[1]).trim(), u = {
                        attrs: W(p, e[2]),
                        noInnerParse: d,
                        tag: p
                    };
                    return n.inAnchor = n.inAnchor || "a" === s, d ? u.text = e[3] : u.children = a(t, l, n), n.inAnchor = !1, u;
                },
                render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({
                        key: r.key
                    }, e.attrs), e.text || (e.children ? n(e.children, r) : ""))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$B),
                order: 1,
                parse (e) {
                    const t = e[1].trim();
                    return {
                        attrs: W(t, e[2] || ""),
                        tag: t
                    };
                },
                render: (e, n, r)=>d(e.tag, $b2bc56c6c0b4e02e$var$t({}, e.attrs, {
                        key: r.key
                    }))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlComment]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$T),
                order: 1,
                parse: ()=>({}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.image]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Se),
                order: 1,
                parse: (e)=>({
                        alt: e[1],
                        target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                        title: e[3]
                    }),
                render: (e, t, n)=>d("img", {
                        key: n.key,
                        alt: e.alt || void 0,
                        title: e.title || void 0,
                        src: i.sanitizer(e.target, "img", "src")
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$ve),
                order: 3,
                parse: (e, t, n)=>({
                        children: $b2bc56c6c0b4e02e$var$je(t, e[1], n),
                        target: $b2bc56c6c0b4e02e$var$Ue(e[2]),
                        title: e[3]
                    }),
                render: (e, t, n)=>d("a", {
                        key: n.key,
                        href: i.sanitizer(e.target, "a", "href"),
                        title: e.title
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkAngleBraceStyleDetector]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$U),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: e[1],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkBareUrlDetector]: {
                match: (e, t)=>t.inAnchor || i.disableAutoLink ? null : $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$R)(e, t),
                order: 0,
                parse: (e)=>({
                        children: [
                            {
                                text: e[1],
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: e[1],
                        title: void 0,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.linkMailtoDetector]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$I),
                order: 0,
                parse (e) {
                    let t = e[1], n = e[1];
                    return $b2bc56c6c0b4e02e$var$s.test(n) || (n = "mailto:" + n), {
                        children: [
                            {
                                text: t.replace("mailto:", ""),
                                type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                            }
                        ],
                        target: n,
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.link
                    };
                }
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.orderedList]: $b2bc56c6c0b4e02e$var$be(d, 1),
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.unorderedList]: $b2bc56c6c0b4e02e$var$be(d, 2),
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.newlineCoalescer]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$k),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$Fe,
                render: ()=>"\n"
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.paragraph]: {
                match: $b2bc56c6c0b4e02e$var$Re,
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("p", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.ref]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$N),
                order: 0,
                parse: (e)=>(q[e[1]] = {
                        target: e[2],
                        title: e[4]
                    }, {}),
                render: $b2bc56c6c0b4e02e$var$Pe
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refImage]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$H),
                order: 0,
                parse: (e)=>({
                        alt: e[1] || void 0,
                        ref: e[2]
                    }),
                render: (e, t, n)=>q[e.ref] ? d("img", {
                        key: n.key,
                        alt: e.alt,
                        src: i.sanitizer(q[e.ref].target, "img", "src"),
                        title: q[e.ref].title
                    }) : null
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.refLink]: {
                match: $b2bc56c6c0b4e02e$var$Te($b2bc56c6c0b4e02e$var$F),
                order: 0,
                parse: (e, t, n)=>({
                        children: t(e[1], n),
                        fallbackChildren: e[0],
                        ref: e[2]
                    }),
                render: (e, t, n)=>q[e.ref] ? d("a", {
                        key: n.key,
                        href: i.sanitizer(q[e.ref].target, "a", "href"),
                        title: q[e.ref].title
                    }, t(e.children, n)) : d("span", {
                        key: n.key
                    }, e.fallbackChildren)
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.table]: {
                match: $b2bc56c6c0b4e02e$var$Be($b2bc56c6c0b4e02e$var$j),
                order: 1,
                parse: $b2bc56c6c0b4e02e$var$Le,
                render (e, t, n) {
                    const r = e;
                    return d("table", {
                        key: n.key
                    }, d("thead", null, d("tr", null, r.header.map(function(e, i) {
                        return d("th", {
                            key: i,
                            style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                        }, t(e, n));
                    }))), d("tbody", null, r.cells.map(function(e, i) {
                        return d("tr", {
                            key: i
                        }, e.map(function(e, i) {
                            return d("td", {
                                key: i,
                                style: $b2bc56c6c0b4e02e$var$Ae(r, i)
                            }, t(e, n));
                        }));
                    })));
                }
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text]: {
                match: $b2bc56c6c0b4e02e$var$Me($b2bc56c6c0b4e02e$var$ee),
                order: 4,
                parse: (e)=>({
                        text: e[0].replace($b2bc56c6c0b4e02e$var$A, (e, t)=>i.namedCodesToUnicode[t] ? i.namedCodesToUnicode[t] : e)
                    }),
                render: (e)=>e.text
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textBolded]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$V),
                order: 2,
                parse: (e, t, n)=>({
                        children: t(e[2], n)
                    }),
                render: (e, t, n)=>d("strong", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEmphasized]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$X),
                order: 3,
                parse: (e, t, n)=>({
                        children: t(e[2], n)
                    }),
                render: (e, t, n)=>d("em", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textEscaped]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$Y),
                order: 1,
                parse: (e)=>({
                        text: e[1],
                        type: $b2bc56c6c0b4e02e$export$e0aa44767d8750d5.text
                    })
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textMarked]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$J),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("mark", {
                        key: n.key
                    }, t(e.children, n))
            },
            [$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.textStrikethroughed]: {
                match: $b2bc56c6c0b4e02e$var$Oe($b2bc56c6c0b4e02e$var$K),
                order: 3,
                parse: $b2bc56c6c0b4e02e$var$He,
                render: (e, t, n)=>d("del", {
                        key: n.key
                    }, t(e.children, n))
            }
        };
        !0 === i.disableParsingRawHTML && (delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlBlock], delete Q[$b2bc56c6c0b4e02e$export$e0aa44767d8750d5.htmlSelfClosing]);
        const re = function(e) {
            let t = Object.keys(e);
            function n(r, i) {
                let l = [];
                for(i.prevCapture = i.prevCapture || ""; r;){
                    let a = 0;
                    for(; a < t.length;){
                        const o = t[a], c = e[o], s = c.match(r, i);
                        if (s) {
                            const e = s[0];
                            i.prevCapture += e, r = r.substring(e.length);
                            const t = c.parse(s, n, i);
                            null == t.type && (t.type = o), l.push(t);
                            break;
                        }
                        a++;
                    }
                }
                return i.prevCapture = "", l;
            }
            return t.sort(function(t, n) {
                let r = e[t].order, i = e[n].order;
                return r !== i ? r - i : t < n ? -1 : 1;
            }), function(e, t) {
                return n(function(e) {
                    return e.replace($b2bc56c6c0b4e02e$var$x, "\n").replace($b2bc56c6c0b4e02e$var$S, "").replace($b2bc56c6c0b4e02e$var$_, "    ");
                }(e), t);
            };
        }(Q), ie = (le = function(e, t) {
            return function(n, r, i) {
                const l = e[n.type].render;
                return t ? t(()=>l(n, r, i), n, r, i) : l(n, r, i);
            };
        }(Q, i.renderRule), function e(t, n = {}) {
            if (Array.isArray(t)) {
                const r = n.key, i = [];
                let l = !1;
                for(let r = 0; r < t.length; r++){
                    n.key = r;
                    const a = e(t[r], n), o = "string" == typeof a;
                    o && l ? i[i.length - 1] += a : null !== a && i.push(a), l = o;
                }
                return n.key = r, i;
            }
            return le(t, e, n);
        });
        var le;
        const ae = G(n);
        return Z.length ? d("div", null, ae, d("footer", {
            key: "footer"
        }, Z.map(function(e) {
            return d("div", {
                id: i.slugify(e.identifier, $b2bc56c6c0b4e02e$export$c383cdd2a518017a),
                key: e.identifier
            }, e.identifier, ie(re(e.footnote, {
                inline: !0
            })));
        }))) : ae;
    }
    var $b2bc56c6c0b4e02e$export$2e2bcd8739ae039 = (t)=>{
        let { children: r = "", options: i } = t, l = function(e, t) {
            if (null == e) return {};
            var n, r, i = {}, l = Object.keys(e);
            for(r = 0; r < l.length; r++)t.indexOf(n = l[r]) >= 0 || (i[n] = e[n]);
            return i;
        }(t, $b2bc56c6c0b4e02e$var$n);
        return $5uXOq.cloneElement($b2bc56c6c0b4e02e$export$69f434acfbdb0b32(r, i), l);
    };
});
parcelRegister("aRS1S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$270fc2c4bbd80c91$export$2e2bcd8739ae039);
    parcelRequire("5uXOq");
    var $f8Sb3;
    function $270fc2c4bbd80c91$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $270fc2c4bbd80c91$var$listStyles = {
        name: "k4jzwf",
        styles: "padding-left:var(--ds-space-250, 20px);padding-inline-start:var(--ds-space-250, 20px)"
    };
    const $270fc2c4bbd80c91$var$UList = ({ children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            css: $270fc2c4bbd80c91$var$listStyles,
            ...props
        }, children);
    var $270fc2c4bbd80c91$export$2e2bcd8739ae039 = $270fc2c4bbd80c91$var$UList;
});
parcelRegister("aBTst", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a8d8f80d50d9d1e4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    const $a8d8f80d50d9d1e4$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
        const [height, setHeight] = (0, $5uXOq.useState)(0);
        const ref = (0, $5uXOq.useRef)(null);
        const transition = isFadeIn ? 'height, opacity' : 'height';
        (0, $5uXOq.useEffect)(()=>{
            if (show && ref.current) setHeight(ref.current.scrollHeight);
            else setHeight(0);
        }, [
            children,
            show
        ]);
        return show ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            style: {
                height: height,
                minHeight: minHeight,
                lineHeight: 0,
                overflow: 'hidden',
                opacity: height > 0 ? 1 : 0,
                transitionProperty: showTransition ? transition : 'none',
                transitionDuration: '0.3s'
            },
            ref: ref
        }, children) : null;
    };
    var $a8d8f80d50d9d1e4$export$2e2bcd8739ae039 = $a8d8f80d50d9d1e4$export$6118ed0013927eb2;
});
parcelRegister("adeuB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$749bb6d43c83bff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1vqi;
    const $749bb6d43c83bff0$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
        const { fireEvent: fireEvent } = (0, (0, parcelRequire("a1vqi")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            fireEvent('ui.summary.viewed', {
                fromCache: fromCache
            });
            if (fromCache) fireEvent('track.aiInteraction.initiated', {
                aiFeatureName: 'Smart Links Summary',
                proactiveAIGenerated: 1,
                userGeneratedAI: 0
            });
        }, [
            fireEvent,
            fromCache
        ]);
        return null;
    };
    var $749bb6d43c83bff0$export$2e2bcd8739ae039 = $749bb6d43c83bff0$var$AIEventSummaryViewed;
});
parcelRegister("85ffk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5cb2203e6787402$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $obtkX;
    const $d5cb2203e6787402$var$AIFooterBlock = ({ status: status, testId: testId = 'smart-ai-footer-block', ...props })=>{
        if (status !== (0, (0, parcelRequire("8dVIb")).SmartLinkStatus).Resolved) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("obtkX")).default), {
            ...props,
            testId: testId
        });
    };
    var $d5cb2203e6787402$export$2e2bcd8739ae039 = $d5cb2203e6787402$var$AIFooterBlock;
});
parcelRegister("obtkX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6b56bbc6d143050$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8dVIb;
    var $Nh1XU;
    var $eqoQu;
    var $dghu0;
    var $kBKwT;
    const $f6b56bbc6d143050$var$AIFooterBlockResolvedView = (props)=>{
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const actionData = context?.actions?.[(0, (0, parcelRequire("8dVIb")).InternalActionName).AISummaryAction];
        const { testId: testId } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dghu0")).default), {
            ...props,
            testId: `${testId}-resolved-view`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eqoQu")).Provider), {
            testId: `${testId}-provider`
        }), actionData ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kBKwT")).AIFooterMetadata), {
            ...actionData,
            testId: `${testId}-ai-metadata`
        }) : null);
    };
    var $f6b56bbc6d143050$export$2e2bcd8739ae039 = $f6b56bbc6d143050$var$AIFooterBlockResolvedView;
});
parcelRegister("kBKwT", function(module, exports) {
    $parcel$export(module.exports, "AIFooterMetadata", ()=>$84dc366e320e5880$export$175228cc2c92b3b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $gKZoD;
    var $jps85;
    var $dC5iT;
    var $f5TWP;
    var $3bDjY;
    var $7zaVw;
    var $1MeuC;
    var $8z1HA;
    var $c8Sqt;
    const $84dc366e320e5880$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("1MeuC")).default));
        const { state: { status: status } } = (0, (0, parcelRequire("1MeuC")).default)(url);
        if (status !== 'done') return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            testId: testId,
            alignInline: "end",
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("7zaVw")).messages).ai_summarized_info_short),
            position: "bottom"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), tooltipProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c8Sqt")).InfoIcon), {
                label: "Information",
                LEGACY_size: "small",
                color: "var(--ds-icon-subtle, #626F86)"
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
            label: "AI",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("8z1HA")).default),
            color: "var(--ds-icon-subtle, #626F86)"
        }));
    };
});
parcelRegister("c8Sqt", function(module, exports) {
    $parcel$export(module.exports, "InfoIcon", ()=>$a035773c38c242b5$export$2957fc44b3d2481);
    var $5uXOq = parcelRequire("5uXOq");
    var $2Yv61;
    var $lqBg9;
    const $a035773c38c242b5$export$2957fc44b3d2481 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))), {
            color: props.color || 'currentColor',
            LEGACY_fallbackIcon: (0, (0, parcelRequire("lqBg9")).default),
            ...props
        });
});
parcelRegister("lqBg9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f1ed3211c768fe6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $4f1ed3211c768fe6$var$InfoIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7 5C7 5.55228 7.44772 6 8 6C8.55228 6 9 5.55228 9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.25 7L7.25 12H8.75L8.75 7H7.25Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8Z",
            fill: "currentColor"
        }));
    const $4f1ed3211c768fe6$var$InfoIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $4f1ed3211c768fe6$var$InfoIconGlyph
        });
    var $4f1ed3211c768fe6$export$2e2bcd8739ae039 = $4f1ed3211c768fe6$var$InfoIcon;
});
parcelRegister("fh9qw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b695424587865b74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gKZoD;
    var $8CUq3;
    var $8dVIb;
    var $Nh1XU;
    var $jRHKj;
    var $fpDmE;
    var $s2ak7;
    function $b695424587865b74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b695424587865b74$var$ignoreContainerPaddingStyles = {
        name: "19m4cma",
        styles: "display:flex;flex-direction:column;box-sizing:border-box;flex-grow:1;width:100%;margin-left:calc(var(--container-gap-left) * -1);margin-right:calc(var(--container-gap-right) * -1)"
    };
    const $b695424587865b74$var$DEFAULT_SORT_ORDER = [
        'PreviewAction',
        'CopyLinkAction',
        'AISummaryAction'
    ];
    const $b695424587865b74$var$sort = (a, b)=>{
        let idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(a);
        let idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.indexOf(b);
        if (idxA === -1) idxA = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        if (idxB === -1) idxB = $b695424587865b74$var$DEFAULT_SORT_ORDER.length;
        return idxA - idxB;
    };
    const $b695424587865b74$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, testId: testId = 'smart-block-action' })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("s2ak7")).ActionFooter));
        const context = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiContext)();
        const ui = (0, (0, parcelRequire("Nh1XU")).useFlexibleUiOptionContext)();
        const [message, setMessage] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const onLoadingChange = (0, $5uXOq.useCallback)((isLoading)=>{
            setIsLoading(isLoading);
        }, [
            setIsLoading
        ]);
        const padding = !ui?.hidePadding ? (0, (0, parcelRequire("fpDmE")).getPrimitivesPaddingSpaceBySize)(ui?.size || (0, (0, parcelRequire("8dVIb")).SmartLinkSize).Medium) : undefined;
        const onClick = (0, $5uXOq.useCallback)((name)=>{
            setMessage(undefined);
            onClickCallback?.(name);
        }, [
            onClickCallback
        ]);
        const onError = (0, $5uXOq.useCallback)((error)=>{
            setMessage(error);
        }, []);
        const actions = (0, $5uXOq.useMemo)(()=>{
            if (!context?.actions) return;
            const arr = Object.keys(context.actions);
            arr.sort($b695424587865b74$var$sort);
            return arr.map((name)=>{
                const Action = name in (0, parcelRequire("jRHKj")) ? (0, parcelRequire("jRHKj"))[name] : undefined;
                return Action ? (0, (0, parcelRequire("f8Sb3")).jsx)(Action, {
                    as: "stack-item",
                    spaceInline: spaceInline,
                    key: name,
                    onClick: ()=>onClick(name),
                    onError: onError,
                    onLoadingChange: onLoadingChange,
                    size: size,
                    xcss: (0, (0, parcelRequire("8CUq3")).xcss)({
                        paddingInline: padding
                    }),
                    hideTooltip: isLoading
                }) : null;
            });
        }, [
            context?.actions,
            onClick,
            onError,
            padding,
            size,
            spaceInline,
            isLoading,
            onLoadingChange
        ]);
        return actions ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $b695424587865b74$var$ignoreContainerPaddingStyles,
            ref: blockRef,
            "data-testid": testId
        }, actions, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("s2ak7")).ActionFooter), {
            message: message,
            paddingInline: padding,
            testId: testId
        })) : null;
    };
    var $b695424587865b74$export$2e2bcd8739ae039 = $b695424587865b74$var$ActionBlock;
});
parcelRegister("s2ak7", function(module, exports) {
    $parcel$export(module.exports, "ActionFooter", ()=>$e384e6334b5a98a7$export$2d2b754ac238f9aa);
    var $5uXOq = parcelRequire("5uXOq");
    var $059q9;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $aBTst;
    const $e384e6334b5a98a7$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        all: 'unset',
        borderRadius: 'border.radius',
        margin: 'space.100',
        marginBottom: 'space.0',
        lineHeight: '20px',
        padding: 'space.075',
        paddingInline: 'space.100',
        width: '100%',
        ':empty': {
            display: 'none'
        }
    });
    const $e384e6334b5a98a7$var$errorStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.danger'
    });
    const $e384e6334b5a98a7$var$errorContentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.025'
    });
    const $e384e6334b5a98a7$var$titleStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $e384e6334b5a98a7$var$getIcon = (appearance)=>{
        switch(appearance){
            case 'error':
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("059q9"))))), {
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "compact",
                    label: "Error",
                    LEGACY_size: "small",
                    testId: "action-error-icon",
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`
                });
            default:
                return null;
        }
    };
    const $e384e6334b5a98a7$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
        if (!message) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            testId: `${testId}-footer`,
            xcss: [
                $e384e6334b5a98a7$var$containerStyles,
                message.appearance === 'error' && $e384e6334b5a98a7$var$errorStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aBTst")).default), {
            isFadeIn: true,
            show: true,
            showTransition: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "start",
            grow: "fill",
            space: "space.075",
            xcss: $e384e6334b5a98a7$var$errorContentStyles
        }, message.icon || $e384e6334b5a98a7$var$getIcon(message.appearance), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e384e6334b5a98a7$var$titleStyles
        }, message.title))));
    };
});
parcelRegister("i41Ob", function(module, exports) {
    $parcel$export(module.exports, "LoadingCardLink", ()=>$b4c0875f37c33ad9$export$1ca0544321134ad6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bMldO;
    const $b4c0875f37c33ad9$export$1ca0544321134ad6 = ({ isSelected: isSelected, url: url, placeholder: placeholder })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bMldO")).CardLinkView), {
            key: 'lazy-render-key',
            testId: 'lazy-render-placeholder',
            "data-trello-do-not-use-override": "lazy-render-placeholder-trello",
            isSelected: isSelected,
            link: url,
            className: (0, $b18b5009ce608fe8$export$4b2b7d155f69aed4),
            placeholder: placeholder
        });
    };
});
parcelRegister("bMldO", function(module, exports) {
    $parcel$export(module.exports, "CardLinkView", ()=>$d0b446175f31475d$export$ce508304ed2dd145);
    var $5uXOq = parcelRequire("5uXOq");
    var $kkxZO;
    class $d0b446175f31475d$export$ce508304ed2dd145 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkxZO")).Frame), {
                withoutBackground: true,
                ...this.props
            }, this.props.placeholder || this.props.link);
        }
    }
});
parcelRegister("kkxZO", function(module, exports) {
    $parcel$export(module.exports, "Frame", ()=>$2ed7f4f9fecd197d$export$b89a827e9254211a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4URMI;
    var $hhfQm;
    const $2ed7f4f9fecd197d$export$b89a827e9254211a = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { isSelected: isSelected, children: children, onClick: onClick, link: link, withoutBackground: withoutBackground, testId: testId, className: className, isHovered: isHovered, truncateInline: truncateInline } = props;
        const handleClick = (0, $5uXOq.useCallback)((event)=>{
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, [
            onClick
        ]);
        const handleKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key !== ' ' && event.key !== 'Enter') return;
            if (onClick) {
                event.preventDefault();
                event.stopPropagation();
                onClick(event);
            }
        }, [
            onClick
        ]);
        const handleMouseDown = (0, (0, parcelRequire("4URMI")).useMouseDownEvent)();
        const isInteractive = Boolean(onClick);
        const isAnchor = Boolean(link || onClick);
        const Wrapper = isAnchor ? (0, (0, parcelRequire("hhfQm")).WrapperAnchor) : (0, (0, parcelRequire("hhfQm")).WrapperSpan);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            href: link,
            withoutBackground: withoutBackground,
            isSelected: isSelected,
            isInteractive: isInteractive,
            tabIndex: isInteractive ? 0 : undefined,
            "aria-label": isAnchor ? link ?? 'Link' : undefined,
            role: isInteractive ? 'button' : undefined,
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onKeyPress: handleKeyPress,
            "data-testid": testId,
            className: className,
            ref: ref,
            isHovered: isHovered,
            truncateInline: truncateInline
        }, children);
    });
});
parcelRegister("hhfQm", function(module, exports) {
    $parcel$export(module.exports, "WrapperAnchor", ()=>$11180a0f0f1d6ba1$export$6e4bde711df5c2ab);
    $parcel$export(module.exports, "WrapperSpan", ()=>$11180a0f0f1d6ba1$export$8b5c95e985c4ec9a);
    var $bWGt6 = parcelRequire("bWGt6");
    const $11180a0f0f1d6ba1$var$lineHeight = 22;
    const $11180a0f0f1d6ba1$var$selectedStyles = {
        cursor: 'pointer',
        boxShadow: `0 0 0 2px ${`var(--ds-border-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`,
        outline: 'none',
        userSelect: 'none',
        '&, :hover, :focus, :active': {
            textDecoration: 'none'
        },
        '&:hover': {
            border: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`}`
        }
    };
    const $11180a0f0f1d6ba1$var$isInteractive = ({ isInteractive: isInteractive })=>{
        if (isInteractive) return {
            ':active': {
                backgroundColor: `var(--ds-background-selected, ${0, $829f609a65d26a98$export$226de0355ed012f8})`
            },
            ':focus': $11180a0f0f1d6ba1$var$selectedStyles
        };
        return undefined;
    };
    const $11180a0f0f1d6ba1$var$isSelected = ({ isSelected: isSelected })=>{
        if (isSelected) return $11180a0f0f1d6ba1$var$selectedStyles;
        else return {
            userSelect: 'text'
        };
    };
    const $11180a0f0f1d6ba1$var$hoveredStyles = {
        borderColor: `var(--ds-border-accent-blue, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`
    };
    const $11180a0f0f1d6ba1$var$activeHoveredFocusedStyles = (props)=>{
        if (props.withoutBackground) return undefined;
        return {
            textDecoration: 'none'
        };
    };
    const $11180a0f0f1d6ba1$var$hoveredWihBorderStyles = (props)=>({
            ...$11180a0f0f1d6ba1$var$hoveredStyles,
            ...$11180a0f0f1d6ba1$var$activeHoveredFocusedStyles(props)
        });
    const $11180a0f0f1d6ba1$var$baseWrapperStyles = (props)=>({
            lineHeight: `${$11180a0f0f1d6ba1$var$lineHeight}px`,
            padding: `${"var(--ds-space-025, 2px)"} 0px`,
            ...props.withoutBackground ? {
                paddingLeft: 0,
                marginLeft: "var(--ds-space-negative-025, -2px)"
            } : undefined,
            display: 'inline',
            boxDecorationBreak: 'clone',
            borderRadius: "var(--ds-border-radius-100, 4px)",
            color: `var(--ds-link, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`,
            ...props.withoutBackground ? undefined : {
                backgroundColor: "var(--ds-surface-raised, white)"
            },
            ...$11180a0f0f1d6ba1$var$isSelected(props),
            ...props.withoutBackground ? undefined : {
                border: `1px solid ${`var(--ds-border, ${0, $829f609a65d26a98$export$1ce2d1575d444ceb})`}`
            },
            '&:hover': $11180a0f0f1d6ba1$var$hoveredStyles,
            '&, :hover, :focus, :active': $11180a0f0f1d6ba1$var$activeHoveredFocusedStyles(props),
            transition: '0.1s all ease-in-out',
            MozUserSelect: 'none',
            ...props.isHovered ? $11180a0f0f1d6ba1$var$hoveredWihBorderStyles(props) : undefined
        });
    const $11180a0f0f1d6ba1$var$truncateStyles = {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-all',
        lineHeight: `${$11180a0f0f1d6ba1$var$lineHeight - 1}px`,
        display: '-webkit-inline-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        padding: 0,
        '@supports not (-webkit-line-clamp: 1)': {
            display: 'inline-block',
            maxHeight: `${$11180a0f0f1d6ba1$var$lineHeight}px`,
            padding: `${"var(--ds-space-025, 2px)"} 0px`
        }
    };
    const $11180a0f0f1d6ba1$var$isTruncated = ({ truncateInline: truncateInline })=>{
        if (truncateInline) return $11180a0f0f1d6ba1$var$truncateStyles;
        return undefined;
    };
    const $11180a0f0f1d6ba1$export$6e4bde711df5c2ab = (0, $bWGt6.default)("a", {
        target: "e26bri1"
    })((props)=>({
            ...$11180a0f0f1d6ba1$var$baseWrapperStyles(props),
            ...$11180a0f0f1d6ba1$var$isInteractive(props),
            ...$11180a0f0f1d6ba1$var$isTruncated(props)
        }));
    $11180a0f0f1d6ba1$export$6e4bde711df5c2ab.displayName = 'WrapperAnchor';
    const $11180a0f0f1d6ba1$export$8b5c95e985c4ec9a = (0, $bWGt6.default)("span", {
        target: "e26bri0"
    })((props)=>({
            ...$11180a0f0f1d6ba1$var$baseWrapperStyles(props),
            ...$11180a0f0f1d6ba1$var$isTruncated(props)
        }));
    $11180a0f0f1d6ba1$export$8b5c95e985c4ec9a.displayName = 'WrapperSpan';
});
const $b18b5009ce608fe8$export$4b2b7d155f69aed4 = 'smart-link-loading-placeholder';
parcelRegister("4kgag", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ij5kv")
    ]).then(()=>parcelRequire('6Of57'));
});
parcelRegister("5xe9f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c4e75bfbc011e1a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hH2qd;
    function $1c4e75bfbc011e1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1c4e75bfbc011e1a$var$ConfigureOverlayWrapperStyles = {
        name: "1sudr34",
        styles: "position:relative;left:var(--ds-space-025, 2px)"
    };
    const $1c4e75bfbc011e1a$var$OverlayWrapper = ({ view: view, targetElementPos: targetElementPos, children: children, isHoveredCallback: hoverCallback, onOpenLinkClick: onOpenLinkClick })=>{
        const [showConfigureButton, setShowConfigureButton] = (0, $5uXOq.useState)(false);
        const [dropdownOpen, setDropdownOpen] = (0, $5uXOq.useState)(false);
        const onDropdownChange = (0, $5uXOq.useCallback)((isOpen)=>{
            setDropdownOpen(isOpen);
            if (!isOpen) setShowConfigureButton(false);
        }, []);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            onMouseEnter: ()=>{
                setShowConfigureButton(true);
                hoverCallback(true);
            },
            onMouseLeave: ()=>{
                if (!dropdownOpen) {
                    setShowConfigureButton(false);
                    hoverCallback(false);
                }
            },
            "data-testid": "inline-card-overlay-wrapper"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $1c4e75bfbc011e1a$var$ConfigureOverlayWrapperStyles
        }, showConfigureButton && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hH2qd")).OverlayButton), {
            editorView: view,
            targetElementPos: targetElementPos,
            onDropdownChange: onDropdownChange,
            onOpenLinkClick: onOpenLinkClick
        })), children));
    };
    var $1c4e75bfbc011e1a$export$2e2bcd8739ae039 = $1c4e75bfbc011e1a$var$OverlayWrapper;
});
parcelRegister("hH2qd", function(module, exports) {
    $parcel$export(module.exports, "OverlayButton", ()=>$1133b824092401fc$export$8b82a61f37322af9);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $994MI;
    var $gZGBX;
    var $5KZxU;
    var $3bDjY;
    var $80CM7;
    var $b0e5B;
    var $9Jd68;
    var $l7Bbo;
    function $1133b824092401fc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1133b824092401fc$var$buttonWrapperStyles = {
        name: "10x6z7s",
        styles: "position:absolute;z-index:100;display:inline-flex;top:50%;transform:translateY(-50%);background:var(--ds-surface-raised, #FFFFFF);border-radius:var(--ds-border-radius, 3px)"
    };
    const $1133b824092401fc$var$showDropdownThresholdPx = 50;
    const $1133b824092401fc$export$8b82a61f37322af9 = (0, (0, parcelRequire("994MI")).default)()(({ editorView: editorView, testId: testId = 'link-configure-overlay-button', targetElementPos: targetElementPos = 0, onDropdownChange: onDropdownChange, onOpenLinkClick: onOpenLinkClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const configureLinkLabel = formatMessage((0, (0, parcelRequire("80CM7")).messages).inlineConfigureLink);
        const [showDropdown, setShowDropdown] = (0, $5uXOq.useState)(false);
        const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent } = (0, (0, parcelRequire("l7Bbo")).useLinkOverlayAnalyticsEvents)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            let domNode = editorView.nodeDOM(targetElementPos);
            if (domNode?.nodeType === Node.TEXT_NODE) domNode = domNode.parentElement;
            if (domNode instanceof HTMLElement) {
                const { width: width } = domNode.getBoundingClientRect();
                if (width < $1133b824092401fc$var$showDropdownThresholdPx) setShowDropdown(true);
            }
        }, [
            editorView,
            targetElementPos
        ]);
        const docNode = editorView.state.doc.nodeAt(targetElementPos);
        const nodeEnd = targetElementPos + (docNode?.nodeSize ?? 0);
        const isText = docNode?.isText;
        const handleConfigureClick = (0, $5uXOq.useCallback)(()=>{
            const tr = editorView.state.tr;
            if (isText) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, targetElementPos, Math.min(nodeEnd, tr.doc.nodeSize)));
            else tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, targetElementPos));
            editorView.dispatch(tr);
        }, [
            editorView,
            isText,
            targetElementPos,
            nodeEnd
        ]);
        const handleConfigureClickWithAnalytics = (0, $5uXOq.useCallback)(()=>{
            fireActionClickEvent('configureLink');
            fireLinkClickEvent();
            handleConfigureClick();
        }, [
            fireLinkClickEvent,
            handleConfigureClick,
            fireActionClickEvent
        ]);
        const { from: from, to: to } = editorView.state.selection;
        const isSelected = from === targetElementPos && to === nodeEnd;
        if (!targetElementPos || isSelected) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $1133b824092401fc$var$buttonWrapperStyles,
            "data-testid": testId
        }, showDropdown ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b0e5B")).default), {
            testId: testId,
            onConfigureClick: handleConfigureClick,
            onOpenLinkClick: onOpenLinkClick,
            onDropdownChange: onDropdownChange,
            editorView: editorView
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: configureLinkLabel,
            hideTooltipOnClick: true,
            testId: `${testId}-tooltip`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Jd68")).StyledButton), {
            onClick: handleConfigureClickWithAnalytics,
            iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5KZxU"))))), {
                label: configureLinkLabel,
                size: "small",
                testId: `${testId}-configure-icon`
            })
        })));
    });
});
parcelRegister("5KZxU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4310fd5ff8fcaeb0$var$_react = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4310fd5ff8fcaeb0$var$_customize = $4310fd5ff8fcaeb0$var$_interopRequireDefault((parcelRequire("4QAwn")));
    function $4310fd5ff8fcaeb0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4310fd5ff8fcaeb0$var$PreferencesIcon = (props)=>$4310fd5ff8fcaeb0$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 7h3v2H3zm0 8h11v2H3zm7-8h11v2H10zm8 8h3v2h-3z"/><path d="M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m10 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"/></g></svg>`
        }, props, {
            newIcon: $4310fd5ff8fcaeb0$var$_customize.default
        }));
    $4310fd5ff8fcaeb0$var$PreferencesIcon.displayName = 'PreferencesIcon';
    var $4310fd5ff8fcaeb0$var$_default = module.exports.default = $4310fd5ff8fcaeb0$var$PreferencesIcon;
});
parcelRegister("4QAwn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3878591d802e976a$var$_react = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3878591d802e976a$var$_UNSAFE_baseNew = $3878591d802e976a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3878591d802e976a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3878591d802e976a$var$CustomizeIcon = (props)=>$3878591d802e976a$var$_react.default.createElement($3878591d802e976a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.25 11.5V9.375a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625v4.25c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625zm0 0H16m-16 0h7.5m-3.75-7v2.125c0 .345.28.625.625.625h1.75c.345 0 .625-.28.625-.625v-4.25a.625.625 0 0 0-.625-.625h-1.75a.625.625 0 0 0-.625.625zm0 0H0m16 0H8.5"/>`
        }, props));
    $3878591d802e976a$var$CustomizeIcon.displayName = 'CustomizeIcon';
    var $3878591d802e976a$var$_default = module.exports.default = $3878591d802e976a$var$CustomizeIcon;
});
parcelRegister("b0e5B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$147d465df1a9fd7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $994MI;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $6Ingq;
    var $5KZxU;
    var $17Ngn;
    var $80CM7;
    var $9Jd68;
    var $l7Bbo;
    const $147d465df1a9fd7a$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE = 'smallLinkToolbar';
    const $147d465df1a9fd7a$var$Dropdown = ({ onConfigureClick: onConfigureClickCallback, onOpenLinkClick: onOpenLinkClickCallback, onDropdownChange: onDropdownChange, editorView: editorView, testId: testId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const configureLinkLabel = formatMessage((0, (0, parcelRequire("80CM7")).messages).inlineConfigureLink);
        const goToLinkLabel = formatMessage((0, (0, parcelRequire("80CM7")).messages).inlineGoToLink);
        const { fireActionClickEvent: fireActionClickEvent, fireLinkClickEvent: fireLinkClickEvent, fireToolbarViewEvent: fireToolbarViewEvent } = (0, (0, parcelRequire("l7Bbo")).useLinkOverlayAnalyticsEvents)();
        const focusEditor = (0, $5uXOq.useCallback)(()=>{
            setTimeout(()=>editorView.focus(), 0);
        }, [
            editorView
        ]);
        const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen, event: event })=>{
            onDropdownChange?.(isOpen);
            if (isOpen) fireToolbarViewEvent();
            if (!isOpen && event instanceof KeyboardEvent) focusEditor();
        }, [
            fireToolbarViewEvent,
            focusEditor,
            onDropdownChange
        ]);
        const onGoToLinkClick = (0, $5uXOq.useCallback)((event)=>{
            fireActionClickEvent('goToLink');
            onOpenLinkClickCallback?.(event);
            focusEditor();
        }, [
            fireActionClickEvent,
            focusEditor,
            onOpenLinkClickCallback
        ]);
        const onConfigureClick = (0, $5uXOq.useCallback)(()=>{
            fireActionClickEvent('configureLink');
            onConfigureClickCallback?.();
            focusEditor();
        }, [
            fireActionClickEvent,
            focusEditor,
            onConfigureClickCallback
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ onClick: onClick, triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9Jd68")).StyledButton), {
                    innerRef: triggerRef,
                    ...props,
                    iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                        label: configureLinkLabel,
                        size: 'small'
                    }),
                    onClick: (e)=>{
                        onClick?.(e);
                        fireLinkClickEvent();
                    }
                }),
            testId: `${testId}-dropdown`,
            onOpenChange: onOpenChange
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
                label: goToLinkLabel,
                size: 'medium'
            }),
            testId: `${testId}-dropdown-item-open-link`,
            onClick: onGoToLinkClick
        }, goToLinkLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5KZxU"))))), {
                label: configureLinkLabel,
                size: 'medium'
            }),
            onClick: onConfigureClick,
            testId: `${testId}-dropdown-item-configure`
        }, configureLinkLabel)));
    };
    var $147d465df1a9fd7a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("994MI")).default)({
        source: $147d465df1a9fd7a$var$SMALL_LINK_TOOLBAR_ANALYTICS_SOURCE
    })($147d465df1a9fd7a$var$Dropdown);
});
parcelRegister("9Jd68", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$0c0ee27cc7519400$export$2d5d2ba3c7c8c40b);
    var $f8Sb3;
    var $fVnbM;
    function $0c0ee27cc7519400$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0c0ee27cc7519400$var$buttonStyles = {
        name: "1wbjrso",
        styles: "display:flex;background:var(--ds-background-neutral, #091E420F);color:var(--ds-icon, #44546F);&:hover{background:var(--ds-background-neutral-hovered, #091E4224);}&:active{background:var(--ds-background-neutral-pressed, #091E424F);}width:1.375rem;height:1.25rem"
    };
    const $0c0ee27cc7519400$export$2d5d2ba3c7c8c40b = ({ innerRef: innerRef, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            ref: innerRef,
            css: $0c0ee27cc7519400$var$buttonStyles
        });
    };
});
parcelRegister("l7Bbo", function(module, exports) {
    $parcel$export(module.exports, "useLinkOverlayAnalyticsEvents", ()=>$302a019b32212873$export$e3984ac3c5c0f603);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWAZk = parcelRequire("dWAZk");
    var $2NMNM;
    var $gkwXh;
    const $302a019b32212873$export$e3984ac3c5c0f603 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useMemo)(()=>({
                fireActionClickEvent: (linkAction)=>{
                    createAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).BUTTON,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI,
                        attributes: {
                            action: linkAction
                        }
                    }).fire((0, $dWAZk.FabricChannel).media);
                },
                fireLinkClickEvent: ()=>{
                    createAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).LINK,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    }).fire((0, $dWAZk.FabricChannel).media);
                },
                fireToolbarViewEvent: ()=>{
                    createAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).INLINE_DIALOG,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).SMART_LINK_TOOLBAR,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI,
                        attributes: {
                            linkType: 'smallLink'
                        }
                    }).fire((0, $dWAZk.FabricChannel).media);
                }
            }), [
            createAnalyticsEvent
        ]);
    };
});
parcelRegister("jdDDq", function(module, exports) {
    $parcel$export(module.exports, "Card", ()=>$aa1e8f9d9cf2d723$export$60332b2344f7fe41);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $iZOJ9;
    var $daJ0i;
    var $awTmI;
    var $4NUlu;
    var $VSDnB;
    var $jPiXc;
    var $gBr25;
    var $89B6e;
    const $aa1e8f9d9cf2d723$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children, __livePage: __livePage })=>{
        const { editorViewModeState: editorViewModeState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(pluginInjectionApi, [
            'editorViewMode'
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            if (typeof onClickCallback === 'function') try {
                onClickCallback({
                    event: event,
                    url: url
                });
            } catch  {}
        }, [
            url,
            onClickCallback
        ]);
        if ((0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages')) {
            const allowNavigation = __livePage && !onClickCallback;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
                onClick: allowNavigation ? undefined : onClick
            }));
        }
        const allowNavigation = editorViewModeState?.mode === 'view' && !onClickCallback;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
            onClick: allowNavigation ? undefined : onClick
        }));
    };
    function $aa1e8f9d9cf2d723$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
        return class extends (0, ($parcel$interopDefault($5uXOq))).Component {
            static{
                this.contextTypes = {
                    contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
                };
            }
            render() {
                const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
                const { url: url } = (0, (0, parcelRequire("89B6e")).titleUrlPairFromNode)(this.props.node);
                if (url && !(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return (0, ($parcel$interopDefault($5uXOq))).createElement(UnsupportedComponent, null);
                if (this.state.isError) {
                    if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: url,
                        onClick: (e)=>{
                            e.preventDefault();
                        }
                    }, url);
                    else return (0, ($parcel$interopDefault($5uXOq))).createElement(UnsupportedComponent, null);
                }
                const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
                const editorAppearance = (0, (0, parcelRequire("gBr25")).getPluginState)(this.props.view.state)?.editorAppearance;
                const analyticsEditorAppearance = (0, (0, parcelRequire("4NUlu")).getAnalyticsEditorAppearance)(editorAppearance);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
                    data: {
                        attributes: {
                            location: analyticsEditorAppearance
                        },
                        location: analyticsEditorAppearance
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa1e8f9d9cf2d723$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    __livePage: this.props.__livePage
                }, ({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement(SmartCardComponent, {
                        key: url,
                        cardContext: cardContext,
                        ...this.props,
                        onClick: onClick
                    })));
            }
            componentDidCatch(error) {
                const maybeAPIError = error;
                if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                    this.setState({
                        isError: true
                    });
                    const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                    const { url: url } = (0, (0, parcelRequire("89B6e")).titleUrlPairFromNode)(node);
                    if (!getPos || typeof getPos === 'boolean') return;
                    (0, (0, parcelRequire("jPiXc")).changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi?.analytics?.actions)(view.state, view.dispatch);
                    return null;
                } else this.setState({
                    isError: true
                });
            }
            constructor(...args){
                super(...args), this.state = {
                    isError: false
                };
            }
        };
    }
});
parcelRegister("vNpIX", function(module, exports) {
    $parcel$export(module.exports, "InlineCardWithAwareness", ()=>$6d78043983ce7a13$export$2b341c5236b55a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $nYpqR;
    var $jmJ2m;
    var $2CVDy;
    const $6d78043983ce7a13$export$2b341c5236b55a2 = (0, $5uXOq.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected })=>{
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const [isInserted, setIsInserted] = (0, $5uXOq.useState)(false);
        const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $5uXOq.useState)(false);
        const onResolve = (0, $5uXOq.useCallback)((tr, title)=>{
            (0, (0, parcelRequire("nYpqR")).registerRemoveOverlay)(()=>setIsInserted(false))(tr);
            if (title) setIsResolvedViewRendered(true);
        }, []);
        const markMostRecentlyInsertedLink = (0, $5uXOq.useCallback)((isLinkMostRecentlyInserted)=>{
            if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
        }, [
            isOverlayEnabled
        ]);
        const setOverlayHoveredStyles = (0, $5uXOq.useCallback)((isHovered)=>{
            if (isOverlayEnabled) setIsHovered(isHovered);
        }, [
            isOverlayEnabled
        ]);
        const innerCard = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2CVDy")).InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered
            }), [
            actionOptions,
            cardContext,
            getPos,
            isHovered,
            node,
            onClick,
            onResolve,
            useAlternativePreloader,
            view
        ]);
        return isOverlayEnabled || isPulseEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jmJ2m")).AwarenessWrapper), {
            isOverlayEnabled: isOverlayEnabled,
            isPulseEnabled: isPulseEnabled,
            cardContext: cardContext,
            getPos: getPos,
            isHovered: isHovered,
            isInserted: isInserted,
            url: node.attrs.url,
            isSelected: isSelected,
            isResolvedViewRendered: isResolvedViewRendered,
            markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
            pluginInjectionApi: pluginInjectionApi,
            setOverlayHoveredStyles: setOverlayHoveredStyles
        }, innerCard) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            className: "card"
        }, innerCard);
    });
});
parcelRegister("jmJ2m", function(module, exports) {
    $parcel$export(module.exports, "AwarenessWrapper", ()=>$0a08a9ab7bb0b5ba$export$cc11bcf19366e14b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $daJ0i;
    var $4qLEr;
    var $1Ly3h;
    var $89B6e;
    var $hLWpM;
    var $9HVke;
    function $0a08a9ab7bb0b5ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0a08a9ab7bb0b5ba$var$loaderWrapperStyles = {
        name: "8ncb35",
        styles: ".loader-wrapper{line-height:normal;}"
    };
    const $0a08a9ab7bb0b5ba$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isInserted: isInserted, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, setOverlayHoveredStyles: setOverlayHoveredStyles, url: url })=>{
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const linkPosition = (0, $5uXOq.useMemo)(()=>{
            if (!getPos || typeof getPos === 'boolean') return undefined;
            const pos = getPos();
            return typeof pos === 'number' ? pos : undefined;
        }, [
            getPos
        ]);
        const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, (0, parcelRequire("4qLEr")).default)({
            url: url,
            linkPosition: linkPosition || -1,
            cardContext: cardContext?.value,
            pluginInjectionApi: pluginInjectionApi,
            isOverlayEnabled: isOverlayEnabled,
            isPulseEnabled: isPulseEnabled
        });
        if (isSelected && shouldShowToolbarPulse && !(0, (0, parcelRequire("1Ly3h")).isLocalStorageKeyDiscovered)((0, (0, parcelRequire("1Ly3h")).LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, (0, parcelRequire("1Ly3h")).markLocalStorageKeyDiscovered)((0, (0, parcelRequire("1Ly3h")).LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
        (0, $5uXOq.useEffect)(()=>{
            if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
        }, [
            isLinkMostRecentlyInserted,
            markMostRecentlyInsertedLink,
            shouldShowLinkOverlay
        ]);
        const handleOverlayChange = (0, $5uXOq.useCallback)((isHovered)=>{
            setIsHovered(isHovered);
            setOverlayHoveredStyles(isHovered);
        }, [
            setOverlayHoveredStyles
        ]);
        const cardWithOverlay = (0, $5uXOq.useMemo)(()=>{
            if (shouldShowLinkOverlay) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hLWpM")).default), {
                isSelected: isSelected,
                isVisible: isResolvedViewRendered && (isInserted || isHovered || isSelected),
                onMouseEnter: ()=>handleOverlayChange(true),
                onMouseLeave: ()=>handleOverlayChange(false),
                url: url
            }, children);
            return children;
        }, [
            shouldShowLinkOverlay,
            children,
            isSelected,
            isResolvedViewRendered,
            isInserted,
            isHovered,
            url,
            handleOverlayChange
        ]);
        return (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: shouldShowLinkPulse && $0a08a9ab7bb0b5ba$var$loaderWrapperStyles,
                className: "card"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("daJ0i")).default), {
                data: {
                    attributes: (0, (0, parcelRequire("89B6e")).getResolvedAttributesFromStore)(url, 'inline', cardContext?.value?.store)
                }
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9HVke")).DiscoveryPulse), {
                localStorageKey: (0, (0, parcelRequire("1Ly3h")).LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
                localStorageKeyExpirationInMs: (0, (0, parcelRequire("1Ly3h")).ONE_DAY_IN_MILLISECONDS),
                discoveryMode: "start",
                shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
                testId: "link-discovery-pulse"
            }, cardWithOverlay))), [
            shouldShowLinkPulse,
            url,
            cardContext?.value?.store,
            isResolvedViewRendered,
            cardWithOverlay
        ]);
    };
});
parcelRegister("4qLEr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d127fdcf0768ca3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Ly3h;
    const $d127fdcf0768ca3b$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
        const [urlState, setUrlState] = (0, $5uXOq.useState)(cardContext?.store?.getState()[url]);
        const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = pluginInjectionApi?.card?.sharedState?.currentState() || {};
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = cardContext?.store?.subscribe(()=>{
                setUrlState(cardContext?.store?.getState()[url]);
            });
            return ()=>{
                if (unsubscribe) unsubscribe();
            };
        }, [
            cardContext?.store,
            url
        ]);
        const canBeUpgradedToEmbed = (0, $5uXOq.useMemo)(()=>{
            const isResolved = urlState?.status === 'resolved';
            return isResolved && !!cardContext?.extractors?.getPreview(url, 'web');
        }, [
            cardContext?.extractors,
            url,
            urlState?.status
        ]);
        const shouldShowLinkPulse = (0, $5uXOq.useMemo)(()=>{
            return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
        }, [
            canBeUpgradedToEmbed,
            isPulseEnabled,
            linkPosition,
            inlineCardAwarenessCandidatePosition
        ]);
        const shouldShowLinkOverlay = urlState?.status === 'resolved' && isOverlayEnabled;
        const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
        const shouldShowToolbarPulse = (0, $5uXOq.useMemo)(()=>isPulseEnabled && !(0, (0, parcelRequire("1Ly3h")).isLocalStorageKeyDiscovered)((0, (0, parcelRequire("1Ly3h")).LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
            canBeUpgradedToEmbed,
            isPulseEnabled
        ]);
        return {
            shouldShowToolbarPulse: shouldShowToolbarPulse,
            shouldShowLinkPulse: shouldShowLinkPulse,
            shouldShowLinkOverlay: shouldShowLinkOverlay,
            isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
        };
    };
    var $d127fdcf0768ca3b$export$2e2bcd8739ae039 = $d127fdcf0768ca3b$var$useLinkUpgradeDiscoverability;
});
parcelRegister("hLWpM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$848dd1ae6b0063cd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lFKmC = parcelRequire("lFKmC");
    var $koVbs;
    var $80CM7;
    var $5KZxU;
    var $ibtRD;
    function $848dd1ae6b0063cd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $848dd1ae6b0063cd$var$DEBOUNCE_IN_MS = 5;
    const $848dd1ae6b0063cd$var$ESTIMATED_MIN_WIDTH_IN_PX = 16;
    const $848dd1ae6b0063cd$var$PADDING_IN_PX = 4;
    const $848dd1ae6b0063cd$var$ICON_WIDTH_IN_PX = 14;
    const $848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME = 'ak-editor-card-overlay-icon-and-label';
    const $848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME = 'ak-editor-card-overlay-label';
    const $848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME = 'ak-editor-card-overlay-gradient';
    const $848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME = 'ak-editor-card-overlay-marker';
    const $848dd1ae6b0063cd$var$TEXT_NODE_SELECTOR = [
        'p',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ].join(',');
    const $848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR = `var(--ds-surface-raised, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR = `var(--ds-background-selected, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`;
    const $848dd1ae6b0063cd$var$getGradientWithColor = (color)=>{
        return `linear-gradient(270deg, ${color} 0%, rgba(255, 255, 255, 0.00) 100%)`;
    };
    const $848dd1ae6b0063cd$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        lineHeight: 'normal',
        ':active': {
            [`.${$848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME}`]: {
                background: $848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR
            },
            [`.${$848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME}`]: {
                background: $848dd1ae6b0063cd$var$getGradientWithColor($848dd1ae6b0063cd$var$SMART_LINK_ACTIVE_COLOR)
            }
        }
    });
    const $848dd1ae6b0063cd$var$overlayStyles = {
        name: "1ckkn26",
        styles: "visibility:hidden;position:absolute;display:inline-flex;justify-content:flex-end;align-items:center;vertical-align:text-top;height:1lh;@supports not (height: 1lh){height:1.2em;}overflow:hidden;z-index:2;pointer-events:none"
    };
    const $848dd1ae6b0063cd$var$showOverlayStyles = {
        name: "1st01id",
        styles: "position:relative;visibility:visible"
    };
    const $848dd1ae6b0063cd$var$iconStyles = {
        name: "ulzjoo",
        styles: "span{display:flex;}"
    };
    const $848dd1ae6b0063cd$var$labelStyles = {
        name: "csq9xp",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);width:max-content"
    };
    const $848dd1ae6b0063cd$var$iconAndLabelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        gap: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-050, 4px)",
        marginRight: "var(--ds-space-025, 2px)",
        background: $848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR,
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
    });
    const $848dd1ae6b0063cd$var$overflowingContainerStyles = {
        name: "16sud",
        styles: "display:flex;flex-direction:row-reverse;align-items:center;width:max-content;height:100%"
    };
    const $848dd1ae6b0063cd$var$gradientStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '2.5rem',
        height: '100%',
        background: $848dd1ae6b0063cd$var$getGradientWithColor($848dd1ae6b0063cd$var$SMART_LINK_BACKGROUND_COLOR)
    });
    const $848dd1ae6b0063cd$var$InlineCardOverlay = ({ children: children, isSelected: isSelected = false, isVisible: isVisible = false, testId: testId = 'inline-card-overlay', url: url, ...props })=>{
        const [showOverlay, setShowOverlay] = (0, $5uXOq.useState)(false);
        const [showLabel, setShowLabel] = (0, $5uXOq.useState)(true);
        const [availableWidth, setAvailableWidth] = (0, $5uXOq.useState)(undefined);
        const maxOverlayWidth = (0, $5uXOq.useRef)(0);
        const minOverlayWidth = (0, $5uXOq.useRef)($848dd1ae6b0063cd$var$ESTIMATED_MIN_WIDTH_IN_PX);
        const parentWidth = (0, $5uXOq.useRef)(0);
        const iconSize = (0, $5uXOq.useRef)('small');
        const containerRef = (0, $5uXOq.useRef)(null);
        const setVisibility = (0, $5uXOq.useCallback)(()=>{
            if (!containerRef.current || !maxOverlayWidth.current) return;
            const marker = (0, (0, parcelRequire("ibtRD")).getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME}`);
            if (!marker) return;
            try {
                const oneLine = (0, (0, parcelRequire("ibtRD")).isOneLine)(containerRef.current, marker);
                const availableWidth = (0, (0, parcelRequire("ibtRD")).getInlineCardAvailableWidth)(containerRef.current, marker) - $848dd1ae6b0063cd$var$PADDING_IN_PX - (oneLine ? $848dd1ae6b0063cd$var$ICON_WIDTH_IN_PX + $848dd1ae6b0063cd$var$PADDING_IN_PX : 0);
                setAvailableWidth(availableWidth);
                const canShowLabel = availableWidth > maxOverlayWidth.current;
                setShowLabel(canShowLabel);
                const canShowOverlay = availableWidth > minOverlayWidth.current && !isSelected;
                setShowOverlay(canShowOverlay);
            } catch  {
                setShowOverlay(false);
            }
        }, [
            isSelected
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!containerRef.current) return;
            if (!maxOverlayWidth.current) {
                const iconAndLabel = (0, (0, parcelRequire("ibtRD")).getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME}`);
                const label = (0, (0, parcelRequire("ibtRD")).getChildElement)(containerRef, `.${$848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME}`);
                if (iconAndLabel && label) {
                    const { max: max, min: min } = (0, (0, parcelRequire("ibtRD")).getOverlayWidths)(iconAndLabel, label);
                    maxOverlayWidth.current = max;
                    minOverlayWidth.current = min;
                    iconSize.current = (0, (0, parcelRequire("ibtRD")).getIconSize)(label);
                }
            }
            if (isVisible) setVisibility();
        }, [
            setVisibility,
            isVisible
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const parent = containerRef?.current?.closest($848dd1ae6b0063cd$var$TEXT_NODE_SELECTOR);
            if (!parent) return;
            const updateOverlay = (0, ($parcel$interopDefault($lFKmC)))((entries)=>{
                if (!isVisible) return;
                const size = entries?.[0]?.contentBoxSize?.[0]?.inlineSize;
                if (!size) return;
                if (!parentWidth.current) parentWidth.current = size;
                if (parentWidth.current === size) return;
                parentWidth.current = size;
                setVisibility();
            }, $848dd1ae6b0063cd$var$DEBOUNCE_IN_MS);
            const observer = new ResizeObserver(updateOverlay);
            observer.observe(parent);
            return ()=>{
                observer.disconnect();
            };
        }, [
            isVisible,
            setVisibility
        ]);
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const label = intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).inlineOverlay);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...props,
            css: $848dd1ae6b0063cd$var$containerStyles,
            ref: containerRef
        }, children, isVisible && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "aria-hidden": "true",
            className: $848dd1ae6b0063cd$var$OVERLAY_MARKER_CLASSNAME
        }, (0, $0f804702eb36dd5e$export$2b4d00c13dcd3c1f)), (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            css: [
                $848dd1ae6b0063cd$var$overlayStyles,
                showOverlay && $848dd1ae6b0063cd$var$showOverlayStyles
            ],
            style: {
                marginLeft: availableWidth && -availableWidth,
                width: availableWidth
            },
            "data-testid": testId,
            href: url,
            onClick: (e)=>e.preventDefault(),
            tabIndex: -1
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $848dd1ae6b0063cd$var$overflowingContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $848dd1ae6b0063cd$var$iconAndLabelStyles,
            className: $848dd1ae6b0063cd$var$ICON_AND_LABEL_CLASSNAME
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $848dd1ae6b0063cd$var$iconStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5KZxU"))))), {
            label: label,
            size: iconSize.current,
            testId: `${testId}-icon`
        })), showLabel && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $848dd1ae6b0063cd$var$labelStyles,
            className: $848dd1ae6b0063cd$var$OVERLAY_LABEL_CLASSNAME,
            "data-testid": `${testId}-label`
        }, label)), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $848dd1ae6b0063cd$var$gradientStyles,
            className: $848dd1ae6b0063cd$var$OVERLAY_GRADIENT_CLASSNAME,
            "data-testid": `${testId}-gradient`
        })))));
    };
    var $848dd1ae6b0063cd$export$2e2bcd8739ae039 = $848dd1ae6b0063cd$var$InlineCardOverlay;
});
parcelRegister("ibtRD", function(module, exports) {
    $parcel$export(module.exports, "getChildElement", ()=>$c9eb5f21d754e968$export$a0e2858e1d1976ea);
    $parcel$export(module.exports, "getInlineCardAvailableWidth", ()=>$c9eb5f21d754e968$export$ce3ffcce447cf028);
    $parcel$export(module.exports, "isOneLine", ()=>$c9eb5f21d754e968$export$be02a7fcf666d65d);
    $parcel$export(module.exports, "getOverlayWidths", ()=>$c9eb5f21d754e968$export$bdfd7a9bf7c62c86);
    $parcel$export(module.exports, "getIconSize", ()=>$c9eb5f21d754e968$export$3eb7d6130acfda37);
    const $c9eb5f21d754e968$export$a0e2858e1d1976ea = (ref, selector)=>ref.current ? ref.current.querySelector(selector) : undefined;
    const $c9eb5f21d754e968$export$ce3ffcce447cf028 = (startEl, endEl)=>{
        const start = startEl.getBoundingClientRect().left;
        const end = endEl.getBoundingClientRect().left;
        return end - start;
    };
    const $c9eb5f21d754e968$export$be02a7fcf666d65d = (startEl, endEl)=>{
        const start = startEl.getBoundingClientRect().top;
        const end = endEl.getBoundingClientRect().top;
        return start === end;
    };
    const $c9eb5f21d754e968$export$bdfd7a9bf7c62c86 = (overlayEl, labelEl)=>{
        const max = overlayEl.getBoundingClientRect().width;
        const min = max - labelEl.getBoundingClientRect().width;
        return {
            max: max,
            min: min
        };
    };
    const $c9eb5f21d754e968$export$3eb7d6130acfda37 = (labelEl)=>{
        const h2FontSizePx = 20;
        const fontSize = window && parseFloat(window.getComputedStyle(labelEl).fontSize);
        if (!fontSize || fontSize < h2FontSizePx) return 'small';
        return 'medium';
    };
});
parcelRegister("9HVke", function(module, exports) {
    $parcel$export(module.exports, "DiscoveryPulse", ()=>$3481e02f4cd5c154$export$1f5748a1623673d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $jhYOV;
    var $1Ly3h;
    const $3481e02f4cd5c154$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId })=>{
        const discovered = (0, (0, parcelRequire("1Ly3h")).isLocalStorageKeyDiscovered)(localStorageKey);
        const showPulse = shouldShowPulse ?? !discovered;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (showPulse) createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'pulse',
                eventType: 'ui',
                attributes: {
                    pulseIdentifier: localStorageKey
                }
            }).fire('media');
        }, [
            createAnalyticsEvent,
            discovered,
            localStorageKey,
            showPulse
        ]);
        const onDiscovery = (0, $5uXOq.useCallback)(()=>{
            if (!discovered) (0, (0, parcelRequire("1Ly3h")).markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
        }, [
            discovered,
            localStorageKey,
            localStorageKeyExpirationInMs
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhYOV")).Pulse), {
            onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
            onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
            showPulse: showPulse,
            testId: testId
        }, children);
    };
});
parcelRegister("jhYOV", function(module, exports) {
    $parcel$export(module.exports, "Pulse", ()=>$8800890016d88006$export$927d63e2511364c0);
    var $f8Sb3;
    var $5uXOq = parcelRequire("5uXOq");
    function $8800890016d88006$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8800890016d88006$var$pulseKeyframes = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        to: {
            boxShadow: '0 0 0 7px rgba(0, 0, 0, 0)'
        }
    });
    const $8800890016d88006$var$pulseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderRadius: '3px',
        boxShadow: `0 0 0 0 ${"var(--ds-background-discovery-bold, #5243AA)"}`,
        animation: `${$8800890016d88006$var$pulseKeyframes} 1.45s cubic-bezier(0.5, 0, 0, 1) 3`
    });
    const $8800890016d88006$var$commonStyles = {
        name: "1u4hpl4",
        styles: "display:inline"
    };
    const $8800890016d88006$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId })=>{
        const pulseStarted = (0, $5uXOq.useRef)(false);
        if (showPulse) pulseStarted.current = true;
        const stopPropagation = (e)=>{
            e.stopPropagation();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId ?? 'discovery-pulse',
            css: [
                $8800890016d88006$var$commonStyles,
                pulseStarted.current && $8800890016d88006$var$pulseStyles
            ],
            onAnimationIteration: onAnimationIteration,
            onAnimationStart: onAnimationStart
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            onAnimationIteration: stopPropagation,
            onAnimationStart: stopPropagation
        }, children));
    };
    var $8800890016d88006$export$2e2bcd8739ae039 = $8800890016d88006$export$927d63e2511364c0;
});
parcelRegister("ivF3y", function(module, exports) {
    $parcel$export(module.exports, "lazyBlockCardView", ()=>$0d69be0d1facc5c2$export$7da1e5b9c509a0c1);
    var $3xRyR;
    var $gmhCD = parcelRequire("gmhCD");
    var $dFBmr;
    const $0d69be0d1facc5c2$export$7da1e5b9c509a0c1 = (props)=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, (0, parcelRequire("dFBmr")).blockCardNodeView)(props);
        return (0, (0, parcelRequire("3xRyR")).withLazyLoading)({
            nodeName: 'blockCard',
            getNodeViewOptions: ()=>{},
            loader: ()=>{
                const result = Promise.resolve((parcelRequire("dFBmr"))).then(({ blockCardNodeView: blockCardNodeView })=>{
                    return blockCardNodeView(props);
                });
                return result;
            }
        });
    };
});
parcelRegister("dFBmr", function(module, exports) {
    $parcel$export(module.exports, "blockCardNodeView", ()=>$573683d063345568$export$8c11099266e71f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $7nRxN;
    var $j8AmE;
    var $f3dKD;
    var $iiXGq;
    var $gE8f9;
    var $3dBkm;
    var $VSDnB;
    var $kVZJG;
    var $7Zmza;
    var $nYpqR;
    var $89B6e;
    var $jdDDq;
    class $573683d063345568$export$780882fb750d3c8d extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        constructor(props){
            super(props), this.onResolve = (data)=>{
                const { getPos: getPos, view: view } = this.props;
                if (!getPos || typeof getPos === 'boolean') return;
                const { title: title, url: url } = data;
                (0, (0, parcelRequire("7nRxN")).default)(()=>{
                    const pos = getPos();
                    if (typeof pos !== 'number') return;
                    view.dispatch((0, (0, parcelRequire("nYpqR")).registerCard)({
                        title: title,
                        url: url,
                        pos: pos
                    })(view.state.tr));
                })();
            }, this.gapCursorSpan = ()=>{
                if ((0, (0, parcelRequire("gE8f9")).browser).ie && (0, (0, parcelRequire("gE8f9")).browser).ie_version < 79) return;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    contentEditable: true
                });
            }, this.onError = ({ err: err })=>{
                if (err) throw err;
            };
            this.scrollContainer = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(props.view.dom) || undefined;
        }
        render() {
            const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick } = this.props;
            const { url: url, data: data } = node.attrs;
            const cardInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVZJG")).Card), {
                key: url,
                url: url ?? data.url,
                container: this.scrollContainer,
                appearance: "block",
                onClick: onClick,
                onResolve: this.onResolve,
                onError: this.onError,
                platform: 'web',
                actionOptions: actionOptions
            }), this.gapCursorSpan());
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, cardContext && cardContext.value ? (0, ($parcel$interopDefault($5uXOq))).createElement(cardContext.Provider, {
                value: cardContext.value
            }, cardInner) : data ? cardInner : null);
        }
    }
    const $573683d063345568$var$WrappedBlockCard = (0, (0, parcelRequire("jdDDq")).Card)($573683d063345568$export$780882fb750d3c8d, (0, (0, parcelRequire("iiXGq")).default));
    class $573683d063345568$export$d18ccd25c0d2c6b0 extends (0, (0, parcelRequire("j8AmE")).default) {
        createDomRef() {
            const domRef = document.createElement('div');
            if ((0, (0, parcelRequire("VSDnB")).fg)('linking-platform-contenteditable-false-live-view')) {
                this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
                this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
            } else domRef.contentEditable = 'true';
            domRef.setAttribute('spellcheck', 'false');
            return domRef;
        }
        validUpdate(currentNode, newNode) {
            const isCurrentNodeBlockCard = !(0, (0, parcelRequire("89B6e")).isDatasourceNode)(currentNode);
            const isNewNodeDatasource = (0, (0, parcelRequire("89B6e")).isDatasourceNode)(newNode);
            return !(isCurrentNodeBlockCard && isNewNodeDatasource);
        }
        update(node, decorations, _innerDecorations) {
            return super.update(node, decorations, _innerDecorations, this.validUpdate);
        }
        render() {
            const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($573683d063345568$var$WrappedBlockCard, {
                node: this.node,
                view: this.view,
                getPos: this.getPos,
                actionOptions: actionOptions,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback
            });
        }
        destroy() {
            this.unsubscribe?.();
        }
        constructor(...args){
            super(...args), this.updateContentEditable = (editorViewModeState, divElement)=>{
                divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
            };
        }
    }
    const $573683d063345568$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
            const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
            const reactComponentProps = {
                actionOptions: actionOptions,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback
            };
            const isDatasource = (0, (0, parcelRequire("89B6e")).isDatasourceNode)(node);
            if (isDatasource) {
                if (allowDatasource && (0, (0, parcelRequire("3dBkm")).canRenderDatasource)(node?.attrs?.datasource?.id)) {
                    const datasourcePosition = typeof getPos === 'function' && getPos();
                    const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                    const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                    return new (0, (0, parcelRequire("7Zmza")).Datasource)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        isNodeNested: isNodeNested
                    }).init();
                } else return inlineCardViewProducer(node, view, getPos, decorations);
            }
            return new $573683d063345568$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
        };
});
parcelRegister("j8AmE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180f7addf4ccc56b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $lY6DM;
    var $9pOon;
    var $WXnhI;
    var $4NUlu;
    var $4tEIi;
    var $5BVRS;
    class $180f7addf4ccc56b$export$2e2bcd8739ae039 {
        constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate){
            this.decorations = [];
            this.handleRef = (node)=>this._handleRef(node);
            this.dispatchAnalyticsEvent = (payload)=>{
                if (this.eventDispatcher) {
                    const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(this.eventDispatcher);
                    dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                        payload: payload
                    });
                }
            };
            this.node = node;
            this.view = view;
            this.getPos = getPos;
            this.portalProviderAPI = portalProviderAPI;
            this.reactComponentProps = reactComponentProps || {};
            this.reactComponent = reactComponent;
            this._viewShouldUpdate = viewShouldUpdate;
            this.eventDispatcher = eventDispatcher;
            this.key = (0, (0, parcelRequire("4tEIi")).generateUniqueNodeKey)();
        }
        init() {
            this.domRef = this.createDomRef();
            this.setDomAttrs(this.node, this.domRef);
            const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
                dom: undefined,
                contentDOM: undefined
            };
            if (this.domRef && contentDOMWrapper) {
                this.domRef.appendChild(contentDOMWrapper);
                this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
                this.contentDOMWrapper = contentDOMWrapper || contentDOM;
            }
            this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
            const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, (0, parcelRequire("WXnhI")).getPerformanceOptions)(this.view);
            trackingEnabled && (0, (0, parcelRequire("WXnhI")).startMeasureReactNodeViewRendered)({
                nodeTypeName: this.node.type.name
            });
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            trackingEnabled && (0, (0, parcelRequire("WXnhI")).stopMeasureReactNodeViewRendered)({
                nodeTypeName: this.node.type.name,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                samplingRate: samplingRate,
                slowThreshold: slowThreshold
            });
            return this;
        }
        renderReactComponent(component) {
            if (!this.domRef || !component) return;
            const componentWithErrorBoundary = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pOon")).ErrorBoundary), {
                    component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).REACT_NODE_VIEW,
                    componentId: this?.node?.type?.name ?? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).UNKNOWN_NODE,
                    dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
                }, component());
            this.portalProviderAPI.render(componentWithErrorBoundary, this.domRef, this.key);
        }
        createDomRef() {
            if (!this.node.isInline) return document.createElement('div');
            const htmlElement = document.createElement('span');
            return htmlElement;
        }
        getContentDOM() {
            return undefined;
        }
        _handleRef(node) {
            const contentDOM = this.contentDOMWrapper || this.contentDOM;
            let oldIgnoreMutation;
            let selectionBookmark;
            let parentOffset = 0;
            let mutationsIgnored = false;
            if (node && contentDOM && !node.contains(contentDOM)) {
                oldIgnoreMutation = this.ignoreMutation;
                this.ignoreMutation = (m)=>{
                    const isSelectionMutation = m.type === 'selection';
                    if (!isSelectionMutation) mutationsIgnored = true;
                    return !isSelectionMutation;
                };
                if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
                if (this.view.state.selection?.ranges.length > 0) parentOffset = this.view.state.selection?.ranges[0].$from?.parentOffset ?? 0;
                node.appendChild(contentDOM);
                requestAnimationFrame(()=>{
                    this.ignoreMutation = oldIgnoreMutation;
                    if (selectionBookmark && mutationsIgnored && parentOffset > 0) this.view.dispatch(this.view.state.tr.setSelection(selectionBookmark.resolve(this.view.state.tr.doc)));
                });
            }
        }
        render(props, forwardRef) {
            return this.reactComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(this.reactComponent, {
                view: this.view,
                getPos: this.getPos,
                node: this.node,
                forwardRef: forwardRef,
                ...props
            }) : null;
        }
        update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
            const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
            this.decorations = decorations;
            if (!isValidUpdate) return false;
            if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
            if (!this.viewShouldUpdate(node, decorations)) {
                this.node = node;
                return true;
            }
            this.node = node;
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            return true;
        }
        viewShouldUpdate(nextNode, decorations) {
            if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
            return true;
        }
        setDomAttrs(node, element) {
            Object.keys(node.attrs || {}).forEach((attr)=>{
                element.setAttribute(attr, node.attrs[attr]);
            });
        }
        get dom() {
            return this.domRef;
        }
        destroy() {
            if (!this.domRef) return;
            this.portalProviderAPI.remove(this.key);
            this.domRef = undefined;
            this.contentDOM = undefined;
        }
        static fromComponent(component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
            return (node, view, getPos)=>new $180f7addf4ccc56b$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
        }
    }
});
parcelRegister("7Zmza", function(module, exports) {
    $parcel$export(module.exports, "Datasource", ()=>$aee3c79d9325466c$export$9dd55813d0ee0514);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8rCP3;
    var $j8AmE;
    var $kRXi9;
    var $iJOES;
    var $9kpKZ;
    var $eOOFp;
    var $em3vl;
    var $VSDnB;
    var $gUzcH;
    var $9NQiC;
    const $aee3c79d9325466c$var$getPosSafely = (pos)=>{
        if (!pos || typeof pos === 'boolean') return;
        try {
            return pos();
        } catch (e) {}
    };
    class $aee3c79d9325466c$export$1deb9aaa193645a1 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        constructor(props){
            super(props), this.getDatasource = ()=>this.props.node.attrs.datasource, this.getTableView = ()=>{
                const views = this.getDatasource().views;
                return views.find((view)=>view.type === 'table') || undefined;
            }, this.handleColumnChange = (columnKeys)=>{
                const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
                this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
            }, this.handleColumnResize = (key, width)=>{
                const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
                const newColumnCustomSizes = {
                    ...columnCustomSizes,
                    [key]: width
                };
                this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
            }, this.handleWrappedColumnChange = (key, shouldWrap)=>{
                const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
                const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
                if (shouldWrap) wrappedColumnKeysSet.add(key);
                else wrappedColumnKeysSet.delete(key);
                this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
            }, this.onError = ({ err: err })=>{
                if (err) throw err;
            };
        }
        updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = $aee3c79d9325466c$var$getPosSafely(this.props.getPos);
            if (pos === undefined) return;
            const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
                ...Object.keys(columnCustomSizes),
                ...wrappedColumnKeys
            ]));
            const views = [
                {
                    type: 'table',
                    properties: {
                        columns: columnKeys.map((key)=>{
                            const width = columnCustomSizes[key];
                            const isWrapped = wrappedColumnKeys.includes(key);
                            return {
                                key: key,
                                ...width ? {
                                    width: width
                                } : {},
                                ...isWrapped ? {
                                    isWrapped: isWrapped
                                } : {}
                            };
                        })
                    }
                }
            ];
            const attrs = this.props.node.attrs;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...attrs,
                datasource: {
                    ...attrs.datasource,
                    views: views
                }
            });
            tr.setMeta('addToHistory', false);
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        getColumnsInfo() {
            const tableView = this.getTableView();
            const columnsProp = tableView?.properties?.columns;
            const visibleColumnKeys = columnsProp?.map(({ key: key })=>key);
            let columnCustomSizes;
            const columnsWithWidth = columnsProp?.filter((c)=>!!c.width);
            if (columnsWithWidth) {
                const keyWidthPairs = columnsWithWidth.map((c)=>[
                        c.key,
                        c.width
                    ]);
                columnCustomSizes = Object.fromEntries(keyWidthPairs);
            }
            const wrappedColumnKeys = columnsProp?.filter((c)=>c.isWrapped).map((c)=>c.key);
            return {
                visibleColumnKeys: visibleColumnKeys,
                columnCustomSizes: columnCustomSizes,
                wrappedColumnKeys: wrappedColumnKeys
            };
        }
        render() {
            const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
            const datasource = this.getDatasource();
            const attrs = this.props.node.attrs;
            const tableView = this.getTableView();
            if (tableView) {
                const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
                if (cardContext && cardContext.value) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9NQiC")).EditorAnalyticsContext), {
                    editorView: this.props.view
                }, (0, (0, parcelRequire("f8Sb3")).jsx)(cardContext.Provider, {
                    value: cardContext.value
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("em3vl")).default), {
                    datasourceId: datasource.id,
                    parameters: datasource.parameters,
                    visibleColumnKeys: visibleColumnKeys,
                    onVisibleColumnKeysChange: this.handleColumnChange,
                    url: attrs?.url,
                    onColumnResize: this.handleColumnResize,
                    columnCustomSizes: columnCustomSizes,
                    onWrappedColumnChange: this.handleWrappedColumnChange,
                    wrappedColumnKeys: wrappedColumnKeys
                })));
            }
            return null;
        }
    }
    class $aee3c79d9325466c$export$9dd55813d0ee0514 extends (0, (0, parcelRequire("j8AmE")).default) {
        constructor(props){
            super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
            const sharedState = props?.pluginInjectionApi?.width?.sharedState;
            this.tableWidth = sharedState?.currentState()?.width;
            this.isNodeNested = props.isNodeNested;
            sharedState?.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState?.width && this.tableWidth !== nextSharedState?.width) {
                    this.tableWidth = nextSharedState?.width;
                    this.update(this.node, []);
                }
            });
        }
        validUpdate(_, newNode) {
            return !!newNode.attrs?.datasource;
        }
        update(node, decorations, _innerDecorations) {
            return super.update(node, decorations, _innerDecorations, this.validUpdate);
        }
        createDomRef() {
            const domRef = document.createElement('div');
            domRef.setAttribute('contenteditable', 'true');
            domRef.classList.add((0, (0, parcelRequire("iJOES")).SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
            return domRef;
        }
        stopEvent(event) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-datasources-enable-two-way-sync')) {
                const isFormElement = [
                    HTMLButtonElement,
                    HTMLInputElement
                ].some((element)=>event.target instanceof element);
                if (isFormElement) return true;
            }
            return false;
        }
        render() {
            const { attrs: attrs } = this.node;
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform-datasources-enable-two-way-sync')) this.domRef?.setAttribute('draggable', 'false');
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gUzcH")).DatasourceErrorBoundary), {
                unsupportedComponent: (0, (0, parcelRequire("9kpKZ")).default),
                view: this.view,
                url: attrs.url,
                datasourceId: attrs?.datasource?.id
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                className: (0, (0, parcelRequire("kRXi9")).DATASOURCE_INNER_CONTAINER_CLASSNAME),
                style: {
                    minWidth: this.isNodeNested ? '100%' : (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(attrs.layout || (0, $44fe84ed19a5b32b$export$60efea3f80310017), this.tableWidth)
                }
            }, (0, (0, parcelRequire("f8Sb3")).jsx)($aee3c79d9325466c$export$1deb9aaa193645a1, {
                node: this.node,
                view: this.view,
                getPos: this.getPos
            })));
        }
    }
});
parcelRegister("em3vl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f593b92d2fb82d5c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $f593b92d2fb82d5c$var$LazyDatasourceTableView = (0, $5uXOq.lazy)(()=>(parcelRequire("8wDE8")).then((module)=>({
                default: module.DatasourceTableView
            })));
    const $f593b92d2fb82d5c$var$DatasourceTableViewWithWrappers = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                "data-testid": 'datasource-table-view-suspense'
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f593b92d2fb82d5c$var$LazyDatasourceTableView, props));
    };
    var $f593b92d2fb82d5c$export$2e2bcd8739ae039 = $f593b92d2fb82d5c$var$DatasourceTableViewWithWrappers;
});
parcelRegister("8wDE8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4YThm")
    ]).then(()=>parcelRequire('etPPx'));
});
parcelRegister("gUzcH", function(module, exports) {
    $parcel$export(module.exports, "DatasourceErrorBoundary", ()=>$43d63db5f227a575$export$76664c71b9b1a689);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZOJ9;
    var $2LkY3;
    var $jPiXc;
    class $43d63db5f227a575$export$76664c71b9b1a689 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static getDerivedStateFromError(error) {
            return {
                isError: true,
                error: error
            };
        }
        componentDidCatch(error) {
            if (this.props.handleError) this.props.handleError();
            if (this.state.isError) this.setState({
                isError: true,
                error: error
            });
        }
        render() {
            const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
            if (this.state.isError) {
                if (url && (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2LkY3")).LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceId: datasourceId,
                    error: this.state.error
                }, (0, (0, parcelRequire("jPiXc")).setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch));
                else {
                    const unsupportedComponent = UnsupportedComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(UnsupportedComponent, null) : null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2LkY3")).LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                        datasourceModalType: datasourceModalType,
                        datasourceId: datasourceId,
                        error: this.state.error
                    }, unsupportedComponent);
                }
            } else return this.props.children;
        }
        constructor(...args){
            super(...args), this.state = {
                isError: false,
                error: null
            };
        }
    }
});
parcelRegister("2LkY3", function(module, exports) {
    $parcel$export(module.exports, "LazyLoadedDatasourceRenderFailedAnalyticsWrapper", ()=>$6f4d4696225c41fc$export$f386473e8f104bcb);
    var $5uXOq = parcelRequire("5uXOq");
    const $6f4d4696225c41fc$var$LazyDatasourceRenderFailedAnalyticsWrapper = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("lKcEk")));
    const $6f4d4696225c41fc$export$f386473e8f104bcb = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6f4d4696225c41fc$var$LazyDatasourceRenderFailedAnalyticsWrapper, props));
});
parcelRegister("lKcEk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aR9Mt").then(()=>parcelRequire('lVxZp'));
});
parcelRegister("9NQiC", function(module, exports) {
    $parcel$export(module.exports, "EditorAnalyticsContext", ()=>$6ec8577f5d2df689$export$b49e513cc101a4b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $4NUlu;
    var $gBr25;
    const $6ec8577f5d2df689$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
        const editorAppearance = editorView ? (0, (0, parcelRequire("gBr25")).getPluginState)(editorView.state)?.editorAppearance : undefined;
        const analyticsEditorAppearance = (0, (0, parcelRequire("4NUlu")).getAnalyticsEditorAppearance)(editorAppearance);
        const analyticsData = {
            attributes: {
                location: analyticsEditorAppearance
            },
            location: analyticsEditorAppearance
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: analyticsData
        }, children);
    };
});
parcelRegister("6YTYp", function(module, exports) {
    $parcel$export(module.exports, "lazyEmbedCardView", ()=>$5813e9565cc1232a$export$eb946eb841dd1469);
    var $3xRyR;
    var $gmhCD = parcelRequire("gmhCD");
    var $4tvWd;
    const $5813e9565cc1232a$export$eb946eb841dd1469 = (props)=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, (0, parcelRequire("4tvWd")).embedCardNodeView)(props);
        return (0, (0, parcelRequire("3xRyR")).withLazyLoading)({
            nodeName: 'embedCard',
            getNodeViewOptions: ()=>{},
            loader: ()=>{
                const result = Promise.resolve((parcelRequire("4tvWd"))).then(({ embedCardNodeView: embedCardNodeView })=>{
                    return embedCardNodeView(props);
                });
                return result;
            }
        });
    };
});
parcelRegister("4tvWd", function(module, exports) {
    $parcel$export(module.exports, "embedCardNodeView", ()=>$ce715b606b6ea894$export$86904605fa83de6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $7nRxN;
    var $2gIj5;
    var $awTmI;
    var $j8AmE;
    var $f3dKD;
    var $kSK5g;
    var $iiXGq;
    var $cROsB;
    var $iHYdz;
    var $VSDnB;
    var $kVZJG;
    var $icXYC;
    var $nYpqR;
    var $35fHl;
    var $jdDDq;
    const $ce715b606b6ea894$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, eventDispatcher: eventDispatcher, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        const { widthState: widthState, editorDisabledState: editorDisabledState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(pluginInjectionApi, [
            'width',
            'editorDisabled'
        ]);
        const widthStateLineLength = widthState?.lineLength || 0;
        const widthStateWidth = widthState?.width || 0;
        const pos = getPosSafely();
        if (pos === undefined) return null;
        const lineLength = getLineLength(view, pos, widthStateLineLength);
        const containerWidth = (0, (0, parcelRequire("cROsB")).isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
        if (!allowResizing || !hasPreview || editorDisabledState?.editorDisabled) {
            const defaultAspectRatio = (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH) / (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT);
            let richMediaWrapperHeight = 1;
            let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
            if (heightAlone) {
                richMediaWrapperHeight = heightAlone;
                richMediaWrapperWidth = undefined;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kSK5g")).default), {
                ...cardProps,
                height: richMediaWrapperHeight,
                width: richMediaWrapperWidth,
                nodeType: "embedCard",
                hasFallbackContainer: hasPreview,
                lineLength: lineLength,
                containerWidth: containerWidth
            }, smartCard);
        }
        const displayGrid = (visible, gridType, highlight)=>pluginInjectionApi?.grid?.actions?.displayGrid(view)({
                visible: visible,
                gridType: gridType,
                highlight: highlight
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35fHl")).default), {
            ...cardProps,
            height: heightAlone,
            aspectRatio: aspectRatio,
            view: view,
            getPos: getPos,
            lineLength: lineLength,
            gridSize: 12,
            containerWidth: containerWidth,
            displayGrid: displayGrid,
            updateSize: updateSize,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, smartCard);
    };
    class $ce715b606b6ea894$export$61b2782f78272a37 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        constructor(props){
            super(props), this.embedIframeRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.state = {
                hasPreview: true
            }, this.getPosSafely = ()=>{
                const { getPos: getPos } = this.props;
                if (!getPos || typeof getPos === 'boolean') return;
                try {
                    return getPos();
                } catch (e) {}
            }, this.onResolve = (data)=>{
                const { view: view } = this.props;
                const { title: title, url: url, aspectRatio: aspectRatio } = data;
                const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
                if (aspectRatio && !originalHeight && !originalWidth) {
                    this.setState({
                        initialAspectRatio: aspectRatio
                    });
                    this.saveOriginalDimensionsAttributes((0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT), (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
                }
                (0, (0, parcelRequire("7nRxN")).default)(()=>{
                    const pos = this.getPosSafely();
                    if (pos === undefined) return;
                    return view.dispatch((0, (0, parcelRequire("nYpqR")).registerCard)({
                        title: title,
                        url: url,
                        pos: pos
                    })(view.state.tr));
                })();
                try {
                    const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
                    const hasPreview = cardContext && cardContext.value.extractors.getPreview(url, 'web');
                    if (!hasPreview) this.setState({
                        hasPreview: false
                    });
                } catch (e) {}
            }, this.updateSize = (pctWidth, layout)=>{
                const { state: state, dispatch: dispatch } = this.props.view;
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                const tr = state.tr.setNodeMarkup(pos, undefined, {
                    ...this.props.node.attrs,
                    width: pctWidth,
                    layout: layout
                });
                tr.setMeta('scrollIntoView', false);
                dispatch(tr);
                return true;
            }, this.getLineLength = (view, pos, originalLineLength)=>{
                if (typeof pos === 'number' && (0, (0, parcelRequire("cROsB")).isRichMediaInsideOfBlockNode)(view, pos)) {
                    const $pos = view.state.doc.resolve(pos);
                    const domNode = view.nodeDOM($pos.pos);
                    if ($pos.nodeAfter && (0, (0, parcelRequire("cROsB")).floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
                }
                return originalLineLength;
            }, this.saveOriginalDimensionsAttributes = (height, width)=>{
                const { view: view } = this.props;
                const fakeTableResizePluginKey = {
                    key: 'tableFlexiColumnResizing$',
                    getState: (state)=>{
                        return state['tableFlexiColumnResizing$'];
                    }
                };
                const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
                if (fakeTableResizeState?.dragging) return;
                (0, (0, parcelRequire("7nRxN")).default)(()=>{
                    const pos = this.getPosSafely();
                    if (pos === undefined) return;
                    view.dispatch(view.state.tr.step(new (0, (0, parcelRequire("2gIj5")).SetAttrsStep)(pos, {
                        originalHeight: height,
                        originalWidth: width
                    })).setMeta('addToHistory', false));
                })();
            }, this.onHeightUpdate = (height)=>{
                this.setState({
                    liveHeight: height
                });
                this.saveOriginalDimensionsAttributes(height, undefined);
            }, this.onError = ({ err: err })=>{
                if (err) throw err;
            };
            this.scrollContainer = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(props.view.dom) || undefined;
        }
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        render() {
            const { node: node, cardContext: cardContext, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick } = this.props;
            let { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
            const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
            let heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
            const aspectRatio = !heightAlone && (initialAspectRatio || originalHeight && originalWidth && originalWidth / originalHeight) || undefined;
            const cardProps = {
                layout: layout,
                pctWidth: pctWidth,
                fullWidthMode: fullWidthMode
            };
            const smartCard = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVZJG")).Card), {
                key: url,
                url: url,
                appearance: "embed",
                onClick: onClick,
                onResolve: this.onResolve,
                onError: this.onError,
                frameStyle: "show",
                inheritDimensions: true,
                platform: 'web',
                container: this.scrollContainer,
                embedIframeRef: this.embedIframeRef,
                actionOptions: actionOptions
            });
            const cardInner = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("icXYC")).EmbedResizeMessageListener), {
                embedIframeRef: this.embedIframeRef,
                onHeightUpdate: this.onHeightUpdate
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce715b606b6ea894$var$CardInner, {
                pluginInjectionApi: pluginInjectionApi,
                smartCard: smartCard,
                hasPreview: hasPreview,
                getPosSafely: this.getPosSafely,
                view: view,
                getLineLength: this.getLineLength,
                eventDispatcher: this.props.eventDispatcher,
                updateSize: this.updateSize,
                getPos: getPos,
                aspectRatio: aspectRatio,
                allowResizing: allowResizing,
                heightAlone: heightAlone,
                cardProps: cardProps,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, cardContext && cardContext.value ? (0, ($parcel$interopDefault($5uXOq))).createElement(cardContext.Provider, {
                value: cardContext.value
            }, cardInner) : null);
        }
    }
    const $ce715b606b6ea894$var$WrappedBlockCard = (0, (0, parcelRequire("jdDDq")).Card)($ce715b606b6ea894$export$61b2782f78272a37, (0, (0, parcelRequire("iiXGq")).default));
    class $ce715b606b6ea894$export$6789d7ecdc77631b extends (0, (0, parcelRequire("j8AmE")).default) {
        viewShouldUpdate(nextNode) {
            if (this.node.attrs !== nextNode.attrs) return true;
            return super.viewShouldUpdate(nextNode);
        }
        createDomRef() {
            const domRef = document.createElement('div');
            if ((0, (0, parcelRequire("VSDnB")).fg)('linking-platform-contenteditable-false-live-view')) {
                this.unsubscribe = this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
                this.updateContentEditable(this.reactComponentProps.pluginInjectionApi?.editorViewMode?.sharedState.currentState(), domRef);
            } else domRef.contentEditable = 'true';
            domRef.setAttribute('spellcheck', 'false');
            return domRef;
        }
        render() {
            const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.reactComponentProps;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($ce715b606b6ea894$var$WrappedBlockCard, {
                node: this.node,
                view: this.view,
                eventDispatcher: eventDispatcher,
                getPos: this.getPos,
                allowResizing: allowResizing,
                fullWidthMode: fullWidthMode,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback
            });
        }
        destroy() {
            this.unsubscribe?.();
        }
        constructor(...args){
            super(...args), this.updateContentEditable = (editorViewModeState, divElement)=>{
                divElement.contentEditable = editorViewModeState?.mode === 'view' ? 'false' : 'true';
            };
        }
    }
    const $ce715b606b6ea894$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback })=>(node, view, getPos)=>{
            const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
            const reactComponentProps = {
                eventDispatcher: eventDispatcher,
                allowResizing: allowResizing,
                fullWidthMode: fullWidthMode,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                actionOptions: actionOptions,
                onClickCallback: onClickCallback
            };
            return new $ce715b606b6ea894$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
        };
});
parcelRegister("2gIj5", function(module, exports) {
    $parcel$export(module.exports, "SetAttrsStep", ()=>$1a6f71c955cd80a7$export$8cfd0a0bfa522949);
    var $eS2Dn;
    var $kCV8T;
    class $1a6f71c955cd80a7$export$8cfd0a0bfa522949 extends (0, (0, parcelRequire("eS2Dn")).Step) {
        constructor(pos, attrs){
            super();
            this.pos = pos;
            this.attrs = attrs;
        }
        apply(doc) {
            let target = doc.nodeAt(this.pos);
            if (!target) return (0, (0, parcelRequire("eS2Dn")).StepResult).fail('No node at given position');
            if (target.isText) return (0, (0, parcelRequire("eS2Dn")).StepResult).fail('Target is a text node. Attributes are not allowed.');
            const attrs = {
                ...target.attrs || {},
                ...this.attrs || {}
            };
            let newNode = target.type.create(attrs, (0, (0, parcelRequire("kCV8T")).Fragment).empty, target.marks);
            let slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
            return (0, (0, parcelRequire("eS2Dn")).StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
        }
        invert(doc) {
            let target = doc.nodeAt(this.pos);
            return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
        }
        map(mapping) {
            let result = mapping.mapResult(this.pos, 1);
            return result.deleted ? null : new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(result.pos, this.attrs);
        }
        toJSON() {
            return {
                stepType: 'setAttrs',
                pos: this.pos,
                attrs: this.attrs
            };
        }
        static fromJSON(_schema, json) {
            if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
            return new $1a6f71c955cd80a7$export$8cfd0a0bfa522949(json.pos, json.attrs);
        }
    }
    (0, (0, parcelRequire("eS2Dn")).Step).jsonID('setAttrs', $1a6f71c955cd80a7$export$8cfd0a0bfa522949);
});
parcelRegister("kSK5g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4be58b662b429c13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $9ci4W = parcelRequire("9ci4W");
    var $iHYdz;
    var $intz5;
    var $8n44w;
    var $cROsB;
    var $ipSX1;
    function $4be58b662b429c13$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes }) {
        const isPixelWidth = size?.widthType === 'pixel';
        let mediaSingleWidth = size?.width || pctWidth;
        const children = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(propsChildren);
        if (!mediaSingleWidth && (0, (0, parcelRequire("cROsB")).shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
        const isHeightOnly = width === undefined;
        if (mediaSingleWidth) {
            const pxWidth = (0, (0, parcelRequire("8n44w")).getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_GUTTER_SIZE));
            if (isHeightOnly) width = pxWidth - (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPaddingWide);
            else if (width !== undefined) {
                height = height / width * pxWidth;
                width = pxWidth;
            }
        } else if (isHeightOnly) width = (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH) - (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPaddingWide);
        let mediaWrapperHeight;
        let paddingBottom;
        if (isHeightOnly) mediaWrapperHeight = height;
        else if (width !== undefined) {
            const mediaWrapperRatio = height / width * 100;
            paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
            if (nodeType === 'embedCard') paddingBottom = `calc(${paddingBottom} + 32px)`;
        }
        const [media, caption] = children;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: handleMediaSingleRef,
            css: (0, (0, parcelRequire("ipSX1")).MediaSingleDimensionHelper)({
                width: width,
                layout: layout,
                containerWidth: containerWidth,
                mediaSingleWidth: mediaSingleWidth,
                fullWidthMode: fullWidthMode,
                isExtendedResizeExperienceOn: isPixelWidth,
                isInsideOfInlineExtension: isInsideOfInlineExtension
            }),
            "data-layout": layout,
            "data-width": mediaSingleWidth,
            "data-width-type": size?.widthType || 'percentage',
            "data-node-type": nodeType,
            className: (0, ($parcel$interopDefault($9ci4W)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
                'is-loading': isLoading,
                'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
            }),
            ...dataAttributes
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ipSX1")).MediaWrapper), {
            hasFallbackContainer: hasFallbackContainer,
            height: mediaWrapperHeight,
            paddingBottom: paddingBottom
        }, media), caption);
    }
});
parcelRegister("8n44w", function(module, exports) {
    $parcel$export(module.exports, "getMediaSinglePixelWidth", ()=>$c45fbf05bdb029ba$export$a6f4ec2edd25b07e);
    $parcel$export(module.exports, "calcMediaSinglePixelWidth", ()=>$c45fbf05bdb029ba$export$5091b2c0d1cd2361);
    $parcel$export(module.exports, "calcMediaSingleMaxWidth", ()=>$c45fbf05bdb029ba$export$a2e7f6320d796a21);
    $parcel$export(module.exports, "getMediaSingleInitialWidth", ()=>$c45fbf05bdb029ba$export$4ab195f543459515);
    $parcel$export(module.exports, "calculateOffsetLeft", ()=>$c45fbf05bdb029ba$export$ab1f1890e4428242);
    $parcel$export(module.exports, "roundToNearest", ()=>$c45fbf05bdb029ba$export$f72673597dacfcfa);
    $parcel$export(module.exports, "calcMinWidth", ()=>$c45fbf05bdb029ba$export$c7eaa4d46a45395);
    $parcel$export(module.exports, "getMaxWidthForNestedNode", ()=>$c45fbf05bdb029ba$export$4147ff5cc31ec064);
    $parcel$export(module.exports, "getMaxWidthForNestedNodeNext", ()=>$c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3);
    $parcel$export(module.exports, "currentMediaNodeWithPos", ()=>$c45fbf05bdb029ba$export$22e4c8c04f58169d);
    var $gZGBX;
    var $iHYdz;
    var $cROsB;
    var $intz5;
    function $c45fbf05bdb029ba$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
        if (widthType === 'pixel') return width;
        return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
    }
    const $c45fbf05bdb029ba$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
        if (widthType === 'pixel' && width) return width;
        switch(layout){
            case 'wide':
                return $c45fbf05bdb029ba$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
            case 'full-width':
                return $c45fbf05bdb029ba$export$a2e7f6320d796a21(containerWidth);
            default:
                if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
        }
        if ((0, (0, parcelRequire("intz5")).wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
        return $c45fbf05bdb029ba$export$4ab195f543459515(origWidth, contentWidth || containerWidth || undefined);
    };
    const $c45fbf05bdb029ba$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
        if (contentWidth) {
            const wideWidth = Math.ceil(contentWidth * (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio));
            return wideWidth > containerWidth ? contentWidth : wideWidth;
        }
        return origWidth;
    };
    const $c45fbf05bdb029ba$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
        const fullWidthPadding = editorAppearance === 'full-page' ? (0, (0, parcelRequire("iHYdz")).akEditorGutterPaddingDynamic)() * 2 : (0, (0, parcelRequire("iHYdz")).akEditorGutterPadding) * 2;
        return Math.min(containerWidth - fullWidthPadding, (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth));
    };
    const $c45fbf05bdb029ba$export$4ab195f543459515 = (origWidth = (0, (0, parcelRequire("intz5")).DEFAULT_IMAGE_WIDTH), maxWidth = (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth), minWidth = (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
        return Math.max(Math.min(origWidth, maxWidth), minWidth);
    };
    function $c45fbf05bdb029ba$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
        let offsetLeft = 0;
        if (wrapper && insideInlineLike && !insideLayout) {
            const currentNode = wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
        }
        return offsetLeft;
    }
    const $c45fbf05bdb029ba$export$f72673597dacfcfa = (value, interval = (0, (0, parcelRequire("intz5")).DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
    const $c45fbf05bdb029ba$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
        return Math.min(contentWidth, isVideoFile ? (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, (0, parcelRequire("intz5")).MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
    };
    const $c45fbf05bdb029ba$export$4147ff5cc31ec064 = (view, pos)=>{
        if (typeof pos !== 'number') return null;
        if ((0, (0, parcelRequire("cROsB")).isRichMediaInsideOfBlockNode)(view, pos)) {
            const $pos = view.state.doc.resolve(pos);
            const domNode = view.nodeDOM($pos.pos);
            if ($pos.nodeAfter && (0, (0, parcelRequire("cROsB")).floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
            if (domNode instanceof HTMLElement) return domNode.offsetWidth;
        }
        return null;
    };
    const $c45fbf05bdb029ba$var$calcParentPadding = (view, resolvedPos)=>{
        const tablePadding = 8;
        const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
        return [
            tableCell,
            tableHeader
        ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
    };
    const $c45fbf05bdb029ba$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
        if (typeof pos !== 'number') return null;
        const $pos = view.state.doc.resolve(pos);
        if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $c45fbf05bdb029ba$export$7cc71489edfd26f8($pos, view) : $c45fbf05bdb029ba$export$4226a56ec6bfa71c($pos, view);
        return null;
    };
    const $c45fbf05bdb029ba$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
        const domNode = view.nodeDOM(resolvedPos.pos);
        if (resolvedPos.nodeAfter && (0, (0, parcelRequire("cROsB")).floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
            const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
            return domNode.parentElement.offsetWidth - parentPadding;
        }
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
        return null;
    };
    const $c45fbf05bdb029ba$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
        const parentPos = resolvedPos.before(resolvedPos.depth);
        const parentDomNode = view.nodeDOM(parentPos);
        const parentPadding = $c45fbf05bdb029ba$var$calcParentPadding(view, resolvedPos);
        if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
        return null;
    };
    const $c45fbf05bdb029ba$export$22e4c8c04f58169d = (editorState)=>{
        const { doc: doc, selection: selection, schema: schema } = editorState;
        if (!doc || !selection || !(selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
        const pos = selection.$anchor.pos + 1;
        const node = doc.nodeAt(pos);
        if (!node || node.type !== schema.nodes.media) return;
        return {
            node: node,
            pos: pos
        };
    };
});
parcelRegister("ipSX1", function(module, exports) {
    $parcel$export(module.exports, "MediaSingleDimensionHelper", ()=>$2f323c2c46d09c5b$export$2b2737a2ef2f5b46);
    $parcel$export(module.exports, "MediaWrapper", ()=>$2f323c2c46d09c5b$export$542000db99cecf28);
    $parcel$export(module.exports, "MediaBorderGapFiller", ()=>$2f323c2c46d09c5b$export$e18e95249d813157);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $iHYdz;
    var $cROsB;
    var $eOOFp;
    function $2f323c2c46d09c5b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    function $2f323c2c46d09c5b$var$float(layout) {
        switch(layout){
            case 'wrap-right':
                return 'right';
            case 'wrap-left':
                return 'left';
            default:
                return 'none';
        }
    }
    function $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
        if (isInsideOfInlineExtension) return originalWidth > (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
        return originalWidth > (0, (0, parcelRequire("iHYdz")).akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
    }
    function $2f323c2c46d09c5b$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
        if (isInsideOfInlineExtension) return originalWidth > (0, (0, parcelRequire("iHYdz")).akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, (0, parcelRequire("iHYdz")).akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
        return originalWidth > (0, (0, parcelRequire("iHYdz")).akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
    }
    function $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
        switch(layout){
            case 'align-start':
            case 'align-end':
            case 'wrap-right':
            case 'wrap-left':
                return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
            case 'wide':
                return isInsideOfInlineExtension ? (0, (0, parcelRequire("eOOFp")).calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, (0, parcelRequire("eOOFp")).calcWideWidth)(containerWidth);
            case 'full-width':
                return (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, containerWidth);
            default:
                return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
        }
    }
    function $2f323c2c46d09c5b$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
        switch(layout){
            case 'align-start':
            case 'align-end':
            case 'wrap-right':
            case 'wrap-left':
                return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
            case 'wide':
                return (0, (0, parcelRequire("eOOFp")).calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
            case 'full-width':
                return (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, containerWidth);
            default:
                return isResized ? `${width}px` : fullWidthMode ? $2f323c2c46d09c5b$var$getWidthIfFullWidthMode(width, containerWidth) : $2f323c2c46d09c5b$var$getWidthIfDefaultMode(width, containerWidth);
        }
    }
    function $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
        switch(layout){
            case 'wide':
                return (0, (0, parcelRequire("eOOFp")).calcWideWidth)(containerWidth);
            case 'full-width':
                return (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, containerWidth);
            default:
                return `${width}px`;
        }
    }
    function $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth) {
        switch(layout){
            case 'wide':
                return (0, (0, parcelRequire("eOOFp")).calcWideWidth)(containerWidth);
            case 'full-width':
                return (0, (0, parcelRequire("eOOFp")).calcBreakoutWidth)(layout, containerWidth);
            default:
                return '100%';
        }
    }
    function $2f323c2c46d09c5b$var$calcMargin(layout) {
        switch(layout){
            case 'wrap-right':
                return '12px auto 12px 12px';
            case 'wrap-left':
                return '12px 12px 12px auto';
            default:
                return '24px auto';
        }
    }
    function $2f323c2c46d09c5b$var$isImageAligned(layout) {
        switch(layout){
            case 'align-end':
                return 'margin-right: 0';
            case 'align-start':
                return 'margin-left: 0';
            default:
                return '';
        }
    }
    function $2f323c2c46d09c5b$export$c832331b07480714(widthValue) {
        try {
            if (widthValue.endsWith('px')) {
                const pxWidth = parseInt(widthValue.slice(0, -2));
                return `${pxWidth - pxWidth % 2}px`;
            }
            return widthValue;
        } catch  {
            return widthValue;
        }
    }
    var $2f323c2c46d09c5b$var$_ref = {
        name: "1bxycju",
        styles: "min-width:100%"
    };
    const $2f323c2c46d09c5b$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false })=>{
        const calculatedWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? $2f323c2c46d09c5b$export$d48e8f24f681763e(layout, width || 0, containerWidth) : $2f323c2c46d09c5b$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
        const calculatedMaxWidth = $2f323c2c46d09c5b$export$c832331b07480714(isExtendedResizeExperienceOn ? `${containerWidth}px` : $2f323c2c46d09c5b$var$calcMaxWidth(layout, containerWidth));
        return (0, (0, parcelRequire("f8Sb3")).css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && !isExtendedResizeExperienceOn && $2f323c2c46d09c5b$var$_ref, " max-width:", calculatedMaxWidth, ";", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, (0, parcelRequire("cROsB")).nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $2f323c2c46d09c5b$var$float(layout), ";margin:", $2f323c2c46d09c5b$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? `max-width: 100%;` : (0, (0, parcelRequire("cROsB")).nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $2f323c2c46d09c5b$var$isImageAligned(layout), ";");
    };
    const $2f323c2c46d09c5b$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>(0, (0, parcelRequire("f8Sb3")).css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
    const $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6 = (props)=>(0, (0, parcelRequire("f8Sb3")).css)("position:relative;", $2f323c2c46d09c5b$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-comment-badge='true'], [data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;>div{position:absolute;height:100%;}}");
    const $2f323c2c46d09c5b$export$542000db99cecf28 = ({ children: children, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2f323c2c46d09c5b$export$9e3fd9f6215dd7b6(rest)
        }, children);
    $2f323c2c46d09c5b$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
    const $2f323c2c46d09c5b$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: {
                position: 'absolute',
                inset: '0px',
                border: `0.5px solid ${borderColor}`,
                borderRadius: '1px'
            }
        });
    };
});
parcelRegister("icXYC", function(module, exports) {
    $parcel$export(module.exports, "EmbedResizeMessageListener", ()=>$bc7bd21bc3117e37$export$3482036c37e627f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $5Ov6G;
    class $bc7bd21bc3117e37$export$3482036c37e627f4 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidMount() {
            window.addEventListener('message', this.messageCallback);
        }
        componentWillUnmount() {
            window.removeEventListener('message', this.messageCallback);
        }
        render() {
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.messageCallback = (event)=>{
                const { embedIframeRef: embedIframeRef } = this.props;
                const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
                const isStringData = typeof event.data === 'string';
                if (isFromExpectedIframe && isStringData) try {
                    const data = JSON.parse(event.data);
                    if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                        height: data.height
                    });
                } catch (e) {}
            }, this.onEmbedHeightChange = (data)=>{
                const { onHeightUpdate: onHeightUpdate } = this.props;
                const height = data.height + (0, (0, parcelRequire("5Ov6G")).embedHeaderHeight);
                onHeightUpdate(height);
            };
        }
    }
});
parcelRegister("5Ov6G", function(module, exports) {
    $parcel$export(module.exports, "className", ()=>$c56be4ac382654ce$export$2913c0c0b5623090);
    $parcel$export(module.exports, "LinkWrapper", ()=>$c56be4ac382654ce$export$ce4b6a469c26f53f);
    $parcel$export(module.exports, "Wrapper", ()=>$c56be4ac382654ce$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "embedHeaderHeight", ()=>$c56be4ac382654ce$export$8f5a73ba0d077b01);
    $parcel$export(module.exports, "Header", ()=>$c56be4ac382654ce$export$8b251419efc915eb);
    $parcel$export(module.exports, "IconWrapper", ()=>$c56be4ac382654ce$export$be58b4326e23250f);
    $parcel$export(module.exports, "TextWrapper", ()=>$c56be4ac382654ce$export$7c3018f441722857);
    $parcel$export(module.exports, "TooltipWrapper", ()=>$c56be4ac382654ce$export$57a09c4864b20b90);
    $parcel$export(module.exports, "Content", ()=>$c56be4ac382654ce$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "Image", ()=>$c56be4ac382654ce$export$3e431a229df88919);
    var $k5uoT;
    var $2Bc0B;
    var $bWGt6 = parcelRequire("bWGt6");
    function $c56be4ac382654ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c56be4ac382654ce$export$2913c0c0b5623090 = 'media-card-frame';
    const $c56be4ac382654ce$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-border-radius, 3px)"};
`;
    const $c56be4ac382654ce$var$wrapperBorderRadius = `
  border-radius: ${"var(--ds-border-radius-200, 8px)"};
`;
    const $c56be4ac382654ce$var$contentBorderRadius = `
  border-radius: ${"var(--ds-border-radius-100, 4px)"};
`;
    const $c56be4ac382654ce$export$a5b94313d6908893 = (maxWidth = '100%')=>{
        const unit = typeof maxWidth === 'number' ? 'px' : '';
        return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
    };
    const $c56be4ac382654ce$export$638459a7b797c6d9 = (value = '100%')=>{
        const unit = typeof value === 'number' ? 'px' : '';
        return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
    };
    function $c56be4ac382654ce$var$minWidth({ minWidth: minWidth }) {
        if (minWidth) return `min-width: ${minWidth}px;`;
        else return '';
    }
    function $c56be4ac382654ce$var$maxWidth({ maxWidth: maxWidth }) {
        if (maxWidth) return `max-width: ${maxWidth}px; margin: 0 auto;`;
        else return 'margin: 0 auto;';
    }
    function $c56be4ac382654ce$var$getInteractiveStyles({ isInteractive: isInteractive, frameStyle: frameStyle }) {
        return isInteractive ? `
      &:hover {
        ${frameStyle !== 'hide' && $c56be4ac382654ce$var$visibleStyles}

      }
      &:active {
        background-color: ${`var(--ds-background-selected, ${$829f609a65d26a98$export$226de0355ed012f8})`};
      }
    ` : '';
    }
    function $c56be4ac382654ce$var$selected({ isSelected: isSelected, frameStyle: frameStyle }) {
        return isSelected && frameStyle !== 'hide' ? `
    ${$c56be4ac382654ce$var$visibleStyles}
    &::after {
      cursor: pointer;
      box-shadow: 0 0 0 3px ${`var(--ds-border-selected, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`};
      content: '';
      border: none;
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      ${$c56be4ac382654ce$var$wrapperBorderRadius}
    }
    ` : isSelected && frameStyle === 'hide' ? $c56be4ac382654ce$var$contentBorderRadius : '';
    }
    const $c56be4ac382654ce$var$height = ({ inheritDimensions: inheritDimensions })=>inheritDimensions ? 'height: 100%;' : `height: ${(0, (0, parcelRequire("2Bc0B")).gs)(54)}`;
    const $c56be4ac382654ce$var$wrapperStyles = (props)=>`
  ${$c56be4ac382654ce$var$wrapperBorderRadius}
  ${$c56be4ac382654ce$var$minWidth(props)}
  ${$c56be4ac382654ce$var$maxWidth(props)}
  ${$c56be4ac382654ce$var$getInteractiveStyles(props)}
  ${$c56be4ac382654ce$var$visible(props)}
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
  font-family: ${(0, (0, parcelRequire("k5uoT")).fontFamily)()};
  width: 100%;
  user-select: none;
  line-height: initial;
  transition: background 0.3s;
  position: relative;
  ${$c56be4ac382654ce$var$height(props)};
  ${$c56be4ac382654ce$var$selected(props)}

  &:after {
    content: '';
    transition: background 0.3s, box-shadow 0.3s;
    position: absolute;
    height: calc(100% + ${"var(--ds-space-100, 8px)"});
    ${$c56be4ac382654ce$var$wrapperBorderRadius}

    ${$c56be4ac382654ce$var$wrapperSizing(props)}
  }
`;
    const $c56be4ac382654ce$var$wrapperSizing = ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
    box-sizing: border-box;
    width: 100%;` : `
    width: calc(100% + ${"var(--ds-space-200, 16px)"});
    left: ${"var(--ds-space-negative-100, -8px)"};`;
    const $c56be4ac382654ce$var$visibleStyles = `
  &:after {
    border: 1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`};
    background-color: ${"var(--ds-surface-raised, white)"};
  }
  .embed-header {
    opacity: 1;
  }`;
    function $c56be4ac382654ce$var$visible({ frameStyle: frameStyle }) {
        return frameStyle === 'show' ? $c56be4ac382654ce$var$visibleStyles : '';
    }
    const $c56be4ac382654ce$export$ce4b6a469c26f53f = (0, $bWGt6.default)("div", {
        target: "ehaugje16"
    })((props)=>$c56be4ac382654ce$var$wrapperStyles(props), " &:hover{text-decoration:none;}");
    const $c56be4ac382654ce$export$e6dfd72ab29f8598 = (0, $bWGt6.default)("div", {
        target: "ehaugje15"
    })((props)=>$c56be4ac382654ce$var$wrapperStyles(props), "margin-top:10px;");
    const $c56be4ac382654ce$export$8f5a73ba0d077b01 = 32;
    const $c56be4ac382654ce$export$8b251419efc915eb = (0, $bWGt6.default)("div", {
        target: "ehaugje14"
    })({
        height: `${$c56be4ac382654ce$export$8f5a73ba0d077b01}px`,
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        color: `var(--ds-icon, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        opacity: 0,
        transition: '300ms opacity cubic-bezier(0.15, 1, 0.3, 1)'
    }, ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        box-sizing: border-box;
        padding: 0 ${"var(--ds-space-100, 8px)"};
      ` : '');
    const $c56be4ac382654ce$export$be58b4326e23250f = (0, $bWGt6.default)("div", {
        target: "ehaugje13"
    })($c56be4ac382654ce$export$7a57f79000377ca2, $c56be4ac382654ce$export$638459a7b797c6d9(16), ({ isPlaceholder: isPlaceholder })=>{
        if (isPlaceholder) return `
			${''}
      background-color: ${`var(--ds-skeleton, ${$829f609a65d26a98$export$3e51e8f1440314ba})`};
    `;
        else return '';
    }, "margin-right:var(--ds-space-050, 4px);");
    const $c56be4ac382654ce$export$7c3018f441722857 = (0, $bWGt6.default)("div", {
        target: "ehaugje12"
    })(({ isPlaceholder: isPlaceholder })=>{
        if (isPlaceholder) return `
        ${$c56be4ac382654ce$export$7a57f79000377ca2}
        width: 125px;
        height: 12px;
${''}
        background-color: ${`var(--ds-skeleton, ${$829f609a65d26a98$export$3e51e8f1440314ba})`};
      `;
        else return '';
    }, {
        color: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }, $c56be4ac382654ce$export$a5b94313d6908893('none'));
    const $c56be4ac382654ce$export$57a09c4864b20b90 = (0, $bWGt6.default)("div", {
        target: "ehaugje11"
    })({
        name: "d3v9zr",
        styles: "overflow:hidden"
    });
    const $c56be4ac382654ce$export$7c6e2c02157bb7d2 = (0, $bWGt6.default)("div", {
        target: "ehaugje10"
    })($c56be4ac382654ce$var$contentBorderRadius, ";border:1px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`, ";background-color:var(--ds-surface-raised, white);position:absolute;z-index:1;width:100%;transition:box-shadow 0.3s;>.calc-height>div>div{left:unset!important;width:unset!important;height:unset!important;position:initial!important;padding-bottom:unset!important;}>.embed-preview>div{margin:0 auto;}", ({ allowScrollBar: allowScrollBar, removeOverflow: removeOverflow })=>{
        if (removeOverflow) return '';
        return allowScrollBar ? 'overflow: auto;' : 'overflow: hidden;';
    }, " ", ({ frameStyle: frameStyle })=>frameStyle === 'show' ? `
        width: calc(100% - ${"var(--ds-space-200, 16px)"} - 2px);
        margin: 0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"};
      ` : '', " ", ({ frameStyle: frameStyle })=>frameStyle === 'hide' ? 'height: 100%;' : `
        height: calc(100% - ${"var(--ds-space-400, 32px)"});
        top: ${"var(--ds-space-400, 32px)"};
      `, ";");
    const $c56be4ac382654ce$export$3e431a229df88919 = (0, $bWGt6.default)("img", {
        target: "ehaugje9"
    })(({ size: size })=>$c56be4ac382654ce$export$638459a7b797c6d9(size), $c56be4ac382654ce$export$7a57f79000377ca2, "overflow:hidden;");
    const $c56be4ac382654ce$export$44c5ff44c97c3eb9 = 6;
    const $c56be4ac382654ce$export$6ce170286acaa8d3 = (0, $bWGt6.default)("div", {
        target: "ehaugje8"
    })({
        display: 'flex',
        flexDirection: 'row',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`
    });
    const $c56be4ac382654ce$export$f99233281efd08a0 = (0, $bWGt6.default)("div", {
        target: "ehaugje7"
    })({
        color: `var(--ds-text, ${$829f609a65d26a98$export$fbda843f0a27fe96})`,
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        maxHeight: `${80}px`,
        overflow: 'hidden'
    });
    const $c56be4ac382654ce$export$5a6ed0c4143add76 = (0, $bWGt6.default)("div", {
        target: "ehaugje6"
    })({
        marginTop: "var(--ds-space-050, 4px)",
        color: `var(--ds-text-subtlest, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }, $c56be4ac382654ce$export$a5b94313d6908893('100%'));
    const $c56be4ac382654ce$export$393edc798c47379d = (0, $bWGt6.default)("div", {
        target: "ehaugje5"
    })({
        marginTop: `calc(${"var(--ds-space-100, 8px)"} - 1px)`,
        color: `var(--ds-text, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        maxHeight: `${54}px`,
        overflow: 'hidden'
    });
    const $c56be4ac382654ce$export$c2b5f712dd9d455 = (0, $bWGt6.default)("div", {
        target: "ehaugje4"
    })({
        name: "lvkd1z",
        styles: "margin-top:var(--ds-space-050, 4px)"
    });
    const $c56be4ac382654ce$export$1cd1efc78cb52ca5 = (0, $bWGt6.default)("div", {
        target: "ehaugje3"
    })($c56be4ac382654ce$export$7a57f79000377ca2, $c56be4ac382654ce$export$638459a7b797c6d9(48), (props)=>({
            float: 'right',
            margin: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"}`,
            backgroundColor: `var(--ds-skeleton, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
            backgroundImage: `url(${props.src})`,
            backgroundSize: 'cover'
        }));
    const $c56be4ac382654ce$export$106ae874379523d = (0, $bWGt6.default)("div", {
        target: "ehaugje2"
    })({
        name: "uv0shy",
        styles: "margin-top:var(--ds-space-100, 8px)"
    });
    const $c56be4ac382654ce$export$c8223871eecc8f3a = (0, $bWGt6.default)("div", {
        target: "ehaugje1"
    })({
        name: "263ie8",
        styles: "margin-top:var(--ds-space-100, 8px);text-align:right;> *{margin-top:var(--ds-space-050, 4px);}> * + *{margin-left:var(--ds-space-050, 4px);}"
    });
    const $c56be4ac382654ce$export$f1129e9be7945b65 = (0, $bWGt6.default)("div", {
        target: "ehaugje0"
    })({
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: $c56be4ac382654ce$export$44c5ff44c97c3eb9 + 1
    });
});
parcelRegister("2Bc0B", function(module, exports) {
    $parcel$export(module.exports, "gs", ()=>$5180f70ad10286b2$export$9f835c6300f63430);
    $parcel$export(module.exports, "br", ()=>$5180f70ad10286b2$export$479ac0420f53ed26);
    $parcel$export(module.exports, "mq", ()=>$5180f70ad10286b2$export$38e816254073c913);
    var $iNtDW = parcelRequire("iNtDW");
    const $5180f70ad10286b2$export$9f835c6300f63430 = (times)=>`${8 * times}px`;
    const $5180f70ad10286b2$export$479ac0420f53ed26 = (times = 1)=>`${3 * times}px`;
    const $5180f70ad10286b2$export$38e816254073c913 = (0, $iNtDW.default)([
        '@media(min-width: 576px)'
    ]);
});
parcelRegister("iNtDW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$daf3cc1baaed4cea$export$2e2bcd8739ae039);
    var $daf3cc1baaed4cea$var$index = function(breakpoints) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, literal = _ref.literal, overlap = _ref.overlap;
        var mq = literal ? breakpoints : [
            '&'
        ].concat(breakpoints);
        function flatten(obj) {
            if (typeof obj !== 'object' || obj == null) return [];
            if (Array.isArray(obj)) return obj.map(flatten);
            var slots = {};
            var objects = {};
            var props = {};
            Object.keys(obj).forEach(function(key) {
                var item = obj[key];
                if (!Array.isArray(item) && literal) item = [
                    item
                ];
                if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
                    var prior = void 0;
                    item.forEach(function(v, index) {
                        if (overlap && prior === v) return;
                        if (v == null) return;
                        prior = v;
                        if (index === 0 && !literal) props[key] = v;
                        else if (slots[mq[index]] === undefined) {
                            var _slots$mq$index;
                            slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
                        } else slots[mq[index]][key] = v;
                    });
                } else if (typeof item === 'object') objects[key] = flatten(item);
                else props[key] = item;
            });
            mq.forEach(function(el) {
                if (slots[el]) props[el] = slots[el];
            });
            Object.assign(props, objects);
            return props;
        }
        return function() {
            for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
            return values.map(flatten);
        };
    };
    var $daf3cc1baaed4cea$export$2e2bcd8739ae039 = $daf3cc1baaed4cea$var$index;
});
parcelRegister("35fHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f861fa1747108bf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $kKuJi;
    var $h0UFo;
    var $7mf6n;
    var $gZOBO;
    var $5r0mK = parcelRequire("5r0mK");
    var $iHYdz;
    var $5Ov6G;
    class $4f861fa1747108bf$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                aspectRatio: (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH) / (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT)
            };
        }
        componentDidUpdate(prevProps) {
            const offsetLeft = this.calcOffsetLeft();
            if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
                offsetLeft: offsetLeft
            });
            if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
        }
        get wrappedLayout() {
            return (0, (0, parcelRequire("kKuJi")).wrappedLayouts).indexOf(this.props.layout) > -1;
        }
        checkLayout(oldLayout, newLayout) {
            const { resizedPctWidth: resizedPctWidth } = this.state;
            if ((0, (0, parcelRequire("kKuJi")).wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
                const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
                this.props.updateSize(resizedPctWidth, layout);
            }
        }
        get $pos() {
            if (typeof this.props.getPos !== 'function') return null;
            const pos = this.props.getPos();
            if (Number.isNaN(pos) || typeof pos !== 'number') return null;
            return this.props.view.state.doc.resolve(pos);
        }
        get gridWidth() {
            const { gridSize: gridSize } = this.props;
            return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
        }
        calcOffsetLeft() {
            let offsetLeft = 0;
            if (this.wrapper && this.insideInlineLike) {
                const currentNode = this.wrapper;
                const boundingRect = currentNode.getBoundingClientRect();
                const pmRect = this.props.view.dom.getBoundingClientRect();
                offsetLeft = boundingRect.left - pmRect.left;
            }
            return offsetLeft;
        }
        get wideLayoutWidth() {
            const { lineLength: lineLength } = this.props;
            if (lineLength) return Math.ceil(lineLength * (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio));
            else return 0, (0, parcelRequire("iHYdz")).akEditorWideLayoutWidth;
        }
        isNestedInTable() {
            const { table: table } = this.props.view.state.schema.nodes;
            if (!this.$pos) return false;
            return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)(this.$pos, table);
        }
        calcSnapPoints() {
            const { offsetLeft: offsetLeft } = this.state;
            const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
            const snapTargets = [];
            for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, (0, parcelRequire("kKuJi")).calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
            snapTargets.push(lineLength - offsetLeft);
            const minimumWidth = (0, (0, parcelRequire("kKuJi")).calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
            let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
            const $pos = this.$pos;
            if (!$pos) return snapPoints;
            const isTopLevel = $pos.parent.type.name === 'doc';
            if (isTopLevel) {
                snapPoints.push(this.wideLayoutWidth);
                const fullWidthPoint = containerWidth - (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding);
                if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
            }
            return snapPoints;
        }
        get insideInlineLike() {
            const $pos = this.$pos;
            if (!$pos) return false;
            const { listItem: listItem } = this.props.view.state.schema.nodes;
            return !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)($pos, [
                listItem
            ]);
        }
        getHeightDefiningComponent() {
            const { height: height, aspectRatio: aspectRatio } = this.props;
            let heightDefiningStyles;
            if (height) heightDefiningStyles = {
                height: `${height}px`
            };
            else heightDefiningStyles = {
                paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, (0, parcelRequire("5Ov6G")).embedHeaderHeight}px)`
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                "data-testid": 'resizable-embed-card-height-definer',
                style: {
                    display: 'block',
                    fontSize: 0,
                    lineHeight: 0,
                    ...heightDefiningStyles
                }
            });
        }
        render() {
            const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, children: children } = this.props;
            const resizerProps = {
                width: this.calcPxWidth(),
                innerPadding: (0, (0, parcelRequire("iHYdz")).akEditorMediaResizeHandlerPadding)
            };
            const enable = {};
            (0, (0, parcelRequire("h0UFo")).handleSides).forEach((side)=>{
                const oppositeSide = side === 'left' ? 'right' : 'left';
                enable[side] = [
                    'full-width',
                    'wide',
                    'center'
                ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, (0, parcelRequire("h0UFo")).imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
                if (side === 'left' && this.insideInlineLike) enable[side] = false;
            });
            const nestedInTableHandleStyles = (isNestedInTable)=>{
                if (!isNestedInTable) return;
                return {
                    left: {
                        left: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                        paddingLeft: '0px'
                    },
                    right: {
                        right: `calc(${"var(--ds-space-negative-025, -0.125em)"} * 0.5)`,
                        paddingRight: '0px'
                    }
                };
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": "resizable-embed-card-spacing"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: (0, (0, parcelRequire("gZOBO")).wrapperStyle)({
                    layout: layout,
                    isResized: !!pctWidth,
                    containerWidth: containerWidth || (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH),
                    fullWidthMode: fullWidthMode
                })
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7mf6n")).default), {
                ...this.props,
                enable: enable,
                calcNewSize: this.calcNewSize,
                snapPoints: this.calcSnapPoints(),
                scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
                highlights: this.highlights,
                nodeType: "embed",
                handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
                ...resizerProps
            }, children, this.getHeightDefiningComponent())));
        }
        constructor(...args){
            super(...args), this.state = {
                offsetLeft: this.calcOffsetLeft()
            }, this.calcNewSize = (newWidth, stop)=>{
                const { layout: layout, view: { state: state } } = this.props;
                const newPct = (0, (0, parcelRequire("kKuJi")).calcPctFromPx)(newWidth, this.props.lineLength) * 100;
                this.setState({
                    resizedPctWidth: newPct
                });
                let newLayout = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
                if (newPct <= 100) {
                    if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                    return {
                        width: newPct,
                        layout: newLayout
                    };
                } else return {
                    width: this.props.pctWidth || null,
                    layout: newLayout
                };
            }, this.calcUnwrappedLayout = (pct, width)=>{
                if (pct <= 100) return 'center';
                if (width <= this.wideLayoutWidth) return 'wide';
                return 'full-width';
            }, this.calcColumnLeftOffset = ()=>{
                const { offsetLeft: offsetLeft } = this.state;
                return this.insideInlineLike ? (0, (0, parcelRequire("kKuJi")).calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
            }, this.calcPxWidth = (useLayout)=>{
                const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
                const { resizedPctWidth: resizedPctWidth } = this.state;
                const pos = typeof getPos === 'function' ? getPos() : undefined;
                return (0, (0, parcelRequire("kKuJi")).calcMediaPxWidth)({
                    origWidth: (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH),
                    origHeight: (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT),
                    pctWidth: pctWidth,
                    state: state,
                    containerWidth: {
                        width: containerWidth,
                        lineLength: lineLength
                    },
                    isFullWidthModeEnabled: fullWidthMode,
                    layout: useLayout || layout,
                    pos: pos,
                    resizedPctWidth: resizedPctWidth
                });
            }, this.highlights = (newWidth, snapPoints)=>{
                const snapWidth = (0, (0, parcelRequire("h0UFo")).snapTo)(newWidth, snapPoints);
                const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand } = this.props.view.state.schema.nodes;
                if (this.$pos && !!(0, $5r0mK.findParentNodeOfTypeClosestToPos)(this.$pos, [
                    layoutColumn,
                    table,
                    expand,
                    nestedExpand
                ].filter(Boolean))) return [];
                if (snapWidth > this.wideLayoutWidth) return [
                    'full-width'
                ];
                const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
                const columns = (0, (0, parcelRequire("kKuJi")).calcColumnsFromPx)(snapWidth, lineLength, gridSize);
                const columnWidth = Math.round(columns);
                const highlight = [];
                if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
                else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
                else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
                else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
                return highlight;
            };
        }
    }
});
parcelRegister("h0UFo", function(module, exports) {
    $parcel$export(module.exports, "snapTo", ()=>$bd83ac1842fb7d6e$export$ce5a040a76868800);
    $parcel$export(module.exports, "handleSides", ()=>$bd83ac1842fb7d6e$export$8ee741c8b9b43371);
    $parcel$export(module.exports, "imageAlignmentMap", ()=>$bd83ac1842fb7d6e$export$9aaf3d5fbdfcf5c5);
    const $bd83ac1842fb7d6e$export$ce5a040a76868800 = (target, points)=>{
        return points.length === 0 ? target : points.reduce((point, closest)=>{
            return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
        });
    };
    const $bd83ac1842fb7d6e$export$8ee741c8b9b43371 = [
        'left',
        'right'
    ];
    const $bd83ac1842fb7d6e$export$9aaf3d5fbdfcf5c5 = {
        left: 'start',
        right: 'end'
    };
});
parcelRegister("7mf6n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0aa99996e3dd8ef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ci4W = parcelRequire("9ci4W");
    var $eHaD2 = parcelRequire("eHaD2");
    var $iHYdz;
    var $gkwXh;
    var $ceYEW;
    var $j9To4;
    var $h0UFo;
    const $b0aa99996e3dd8ef$var$getResizeAnalyticsEvent = (type, size, layout)=>{
        const actionSubject = type === 'embed' ? (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EMBEDS : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).MEDIA_SINGLE;
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).EDITED,
            actionSubject: actionSubject,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RESIZED,
            attributes: {
                size: size,
                layout: layout
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
        };
    };
    const $b0aa99996e3dd8ef$var$getWidthFromSnapPoints = (width, snapPoints)=>{
        if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
        return width;
    };
    class $b0aa99996e3dd8ef$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        render() {
            const baseHandleStyles = {};
            const handles = {};
            const handleComponent = {};
            const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
            const { isResizing: isResizing } = this.state;
            (0, (0, parcelRequire("h0UFo")).handleSides).forEach((side)=>{
                handles[side] = `richMedia-resize-handle-${side}`;
                baseHandleStyles[side] = {
                    width: '24px',
                    [side]: `${-13 - innerPadding}px`,
                    zIndex: (0, (0, parcelRequire("iHYdz")).akRichMediaResizeZIndex),
                    pointerEvents: 'auto'
                };
                const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
                if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
            });
            const updatedHandleStyles = {
                left: {
                    ...baseHandleStyles.left,
                    ...handleStyles?.left
                },
                right: {
                    ...baseHandleStyles.right,
                    ...handleStyles?.right
                }
            };
            const className = (0, ($parcel$interopDefault($9ci4W)))((0, (0, parcelRequire("ceYEW")).richMediaClassName), `image-${layout}`, this.props.className, {
                'is-resizing': isResizing,
                'not-resized': !pctWidth,
                'richMedia-selected': selected,
                'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
            });
            let handleWrapperStyle;
            if (ratio) handleWrapperStyle = {
                position: 'absolute',
                width: '100%',
                paddingBottom: `${ratio}%`,
                top: 0,
                pointerEvents: 'none'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $eHaD2.Resizable), {
                ref: this.resizable,
                size: {
                    width: width,
                    height: 'auto'
                },
                className: className,
                handleClasses: handles,
                handleStyles: updatedHandleStyles,
                handleWrapperStyle: handleWrapperStyle,
                handleComponent: handleComponent,
                enable: enable,
                onResize: this.handleResize,
                onResizeStop: this.handleResizeStop,
                onResizeStart: this.handleResizeStart
            }, children);
        }
        constructor(...args){
            super(...args), this.resizable = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.state = {
                isResizing: false
            }, this.handleResizeStart = (event)=>{
                const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints } = this.props;
                event.preventDefault();
                this.setState({
                    isResizing: true
                }, ()=>{
                    const newHighlights = highlights(width + innerPadding, snapPoints);
                    displayGrid?.(newHighlights.length > 0, (0, (0, parcelRequire("j9To4")).gridTypeForLayout)(layout), newHighlights);
                });
            }, this.handleResize = (_event, _direction, _elementRef, delta)=>{
                const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
                const resizable = this.resizable.current;
                const { isResizing: isResizing } = this.state;
                if (!resizable || !resizable.state.original || !isResizing) return;
                const newWidth = $b0aa99996e3dd8ef$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
                const newSize = calcNewSize(newWidth + innerPadding, false);
                if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
                const newHighlights = highlights(newWidth, snapPoints);
                displayGrid?.(newHighlights.length > 0, (0, (0, parcelRequire("j9To4")).gridTypeForLayout)(newSize.layout), newHighlights);
                resizable.updateSize({
                    width: newWidth,
                    height: 'auto'
                });
                resizable.setState({
                    isResizing: true
                });
            }, this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
                const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
                const resizable = this.resizable.current;
                const { isResizing: isResizing } = this.state;
                if (!resizable || !resizable.state.original || !isResizing) return;
                const newWidth = $b0aa99996e3dd8ef$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
                const snapWidth = (0, (0, parcelRequire("h0UFo")).snapTo)(newWidth, snapPoints);
                const newSize = calcNewSize(snapWidth, true);
                const newHighlights = highlights(newWidth, snapPoints);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($b0aa99996e3dd8ef$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
                displayGrid?.(newHighlights.length > 0, (0, (0, parcelRequire("j9To4")).gridTypeForLayout)(newSize.layout), newHighlights);
                this.setState({
                    isResizing: false
                }, ()=>{
                    updateSize(newSize.width, newSize.layout);
                    displayGrid?.(false, (0, (0, parcelRequire("j9To4")).gridTypeForLayout)(layout), []);
                });
            };
        }
    }
});
parcelRegister("eHaD2", function(module, exports) {
    "use strict";
    var $ab2d5372f352af9c$var$__extends = module.exports && module.exports.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $ab2d5372f352af9c$var$__assign = module.exports && module.exports.__assign || function() {
        $ab2d5372f352af9c$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $ab2d5372f352af9c$var$__assign.apply(this, arguments);
    };
    var $ab2d5372f352af9c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        }
        result["default"] = mod;
        return result;
    };
    var $ab2d5372f352af9c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
        return mod && mod.__esModule ? mod : {
            "default": mod
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $ab2d5372f352af9c$var$React = $ab2d5372f352af9c$var$__importStar((parcelRequire("5uXOq")));
    var $f6P3s = parcelRequire("f6P3s");
    var $ab2d5372f352af9c$var$fast_memoize_1 = $ab2d5372f352af9c$var$__importDefault((parcelRequire("8mQ2m")));
    var $ab2d5372f352af9c$var$DEFAULT_SIZE = {
        width: 'auto',
        height: 'auto'
    };
    var $ab2d5372f352af9c$var$clamp = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, min, max) {
        return Math.max(Math.min(n, max), min);
    });
    var $ab2d5372f352af9c$var$snap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, size) {
        return Math.round(n / size) * size;
    });
    var $ab2d5372f352af9c$var$hasDirection = $ab2d5372f352af9c$var$fast_memoize_1.default(function(dir, target) {
        return new RegExp(dir, 'i').test(target);
    });
    var $ab2d5372f352af9c$var$findClosestSnap = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
        if (snapGap === void 0) snapGap = 0;
        var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
            return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
        }, 0);
        var gap = Math.abs(snapArray[closestGapIndex] - n);
        return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
    });
    var $ab2d5372f352af9c$var$endsWith = $ab2d5372f352af9c$var$fast_memoize_1.default(function(str, searchStr) {
        return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
    });
    var $ab2d5372f352af9c$var$getStringSize = $ab2d5372f352af9c$var$fast_memoize_1.default(function(n) {
        n = n.toString();
        if (n === 'auto') return n;
        if ($ab2d5372f352af9c$var$endsWith(n, 'px')) return n;
        if ($ab2d5372f352af9c$var$endsWith(n, '%')) return n;
        if ($ab2d5372f352af9c$var$endsWith(n, 'vh')) return n;
        if ($ab2d5372f352af9c$var$endsWith(n, 'vw')) return n;
        if ($ab2d5372f352af9c$var$endsWith(n, 'vmax')) return n;
        if ($ab2d5372f352af9c$var$endsWith(n, 'vmin')) return n;
        return n + "px";
    });
    var $ab2d5372f352af9c$var$calculateNewMax = $ab2d5372f352af9c$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
        if (maxWidth && typeof maxWidth === 'string' && $ab2d5372f352af9c$var$endsWith(maxWidth, '%')) {
            var ratio = Number(maxWidth.replace('%', '')) / 100;
            maxWidth = parentSize.width * ratio;
        }
        if (maxHeight && typeof maxHeight === 'string' && $ab2d5372f352af9c$var$endsWith(maxHeight, '%')) {
            var ratio = Number(maxHeight.replace('%', '')) / 100;
            maxHeight = parentSize.height * ratio;
        }
        if (minWidth && typeof minWidth === 'string' && $ab2d5372f352af9c$var$endsWith(minWidth, '%')) {
            var ratio = Number(minWidth.replace('%', '')) / 100;
            minWidth = parentSize.width * ratio;
        }
        if (minHeight && typeof minHeight === 'string' && $ab2d5372f352af9c$var$endsWith(minHeight, '%')) {
            var ratio = Number(minHeight.replace('%', '')) / 100;
            minHeight = parentSize.height * ratio;
        }
        return {
            maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
            maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
            minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
            minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
        };
    });
    var $ab2d5372f352af9c$var$definedProps = [
        'style',
        'className',
        'grid',
        'snap',
        'bounds',
        'size',
        'defaultSize',
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight',
        'lockAspectRatio',
        'lockAspectRatioExtraWidth',
        'lockAspectRatioExtraHeight',
        'enable',
        'handleStyles',
        'handleClasses',
        'handleWrapperStyle',
        'handleWrapperClass',
        'children',
        'onResizeStart',
        'onResize',
        'onResizeStop',
        'handleComponent',
        'scale',
        'resizeRatio',
        'snapGap'
    ];
    var $ab2d5372f352af9c$var$baseClassName = '__resizable_base__';
    var $ab2d5372f352af9c$var$Resizable = function(_super) {
        $ab2d5372f352af9c$var$__extends(Resizable, _super);
        function Resizable(props) {
            var _this = _super.call(this, props) || this;
            _this.ratio = 1;
            _this.resizable = null;
            _this.parentLeft = 0;
            _this.parentTop = 0;
            _this.resizableLeft = 0;
            _this.resizableTop = 0;
            _this.targetLeft = 0;
            _this.targetTop = 0;
            _this.state = {
                isResizing: false,
                resizeCursor: 'auto',
                width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
                height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
                direction: 'right',
                original: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }
            };
            _this.onResizeStart = _this.onResizeStart.bind(_this);
            _this.onMouseMove = _this.onMouseMove.bind(_this);
            _this.onMouseUp = _this.onMouseUp.bind(_this);
            if (typeof window !== 'undefined') {
                window.addEventListener('mouseup', _this.onMouseUp);
                window.addEventListener('mousemove', _this.onMouseMove);
                window.addEventListener('mouseleave', _this.onMouseUp);
                window.addEventListener('touchmove', _this.onMouseMove);
                window.addEventListener('touchend', _this.onMouseUp);
            }
            return _this;
        }
        Object.defineProperty(Resizable.prototype, "parentNode", {
            get: function() {
                if (!this.resizable) return null;
                return this.resizable.parentNode;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Resizable.prototype, "propsSize", {
            get: function() {
                return this.props.size || this.props.defaultSize || $ab2d5372f352af9c$var$DEFAULT_SIZE;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Resizable.prototype, "base", {
            get: function() {
                var parent = this.parentNode;
                if (!parent) return undefined;
                var children = [].slice.call(parent.children);
                for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                    var n = children_1[_i];
                    if (n instanceof HTMLElement) {
                        if (n.classList.contains($ab2d5372f352af9c$var$baseClassName)) return n;
                    }
                }
                return undefined;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Resizable.prototype, "size", {
            get: function() {
                var width = 0;
                var height = 0;
                if (typeof window !== 'undefined' && this.resizable) {
                    var orgWidth = this.resizable.offsetWidth;
                    var orgHeight = this.resizable.offsetHeight;
                    var orgPosition = this.resizable.style.position;
                    if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                    width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                    height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                    this.resizable.style.position = orgPosition;
                }
                return {
                    width: width,
                    height: height
                };
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Resizable.prototype, "sizeStyle", {
            get: function() {
                var _this = this;
                var size = this.props.size;
                var getSize = function(key) {
                    if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                    if (_this.propsSize && _this.propsSize[key] && $ab2d5372f352af9c$var$endsWith(_this.propsSize[key].toString(), '%')) {
                        if ($ab2d5372f352af9c$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                        var parentSize = _this.getParentSize();
                        var value = Number(_this.state[key].toString().replace('px', ''));
                        var percent = value / parentSize[key] * 100;
                        return percent + "%";
                    }
                    return $ab2d5372f352af9c$var$getStringSize(_this.state[key]);
                };
                var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.width) : getSize('width');
                var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $ab2d5372f352af9c$var$getStringSize(size.height) : getSize('height');
                return {
                    width: width,
                    height: height
                };
            },
            enumerable: true,
            configurable: true
        });
        Resizable.prototype.getParentSize = function() {
            if (!this.base || !this.parentNode) return {
                width: window.innerWidth,
                height: window.innerHeight
            };
            var wrapChanged = false;
            var wrap = this.parentNode.style.flexWrap;
            var minWidth = this.base.style.minWidth;
            if (wrap !== 'wrap') {
                wrapChanged = true;
                this.parentNode.style.flexWrap = 'wrap';
            }
            this.base.style.position = 'relative';
            this.base.style.minWidth = '100%';
            var size = {
                width: this.base.offsetWidth,
                height: this.base.offsetHeight
            };
            this.base.style.position = 'absolute';
            if (wrapChanged) this.parentNode.style.flexWrap = wrap;
            this.base.style.minWidth = minWidth;
            return size;
        };
        Resizable.prototype.componentDidMount = function() {
            this.setState({
                width: this.state.width || this.size.width,
                height: this.state.height || this.size.height
            });
            var parent = this.parentNode;
            if (!(parent instanceof HTMLElement)) return;
            if (this.base) return;
            var element = document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0';
            if (element.classList) element.classList.add($ab2d5372f352af9c$var$baseClassName);
            else element.className += $ab2d5372f352af9c$var$baseClassName;
            parent.appendChild(element);
        };
        Resizable.prototype.componentWillUnmount = function() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('mouseup', this.onMouseUp);
                window.removeEventListener('mousemove', this.onMouseMove);
                window.removeEventListener('mouseleave', this.onMouseUp);
                window.removeEventListener('touchmove', this.onMouseMove);
                window.removeEventListener('touchend', this.onMouseUp);
                var parent_1 = this.parentNode;
                if (!this.base || !parent_1) return;
                if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
                parent_1.removeChild(this.base);
            }
        };
        Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
            var propsSize = this.propsSize && this.propsSize[kind];
            return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
        };
        Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
            if (this.props.bounds === 'parent') {
                var parent_2 = this.parentNode;
                if (parent_2 instanceof HTMLElement) {
                    var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                    var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                    maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                    maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
                }
            } else if (this.props.bounds === 'window') {
                if (typeof window !== 'undefined') {
                    var boundWidth = window.innerWidth - this.resizableLeft;
                    var boundHeight = window.innerHeight - this.resizableTop;
                    maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                    maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
                }
            } else if (this.props.bounds instanceof HTMLElement) {
                var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
                var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
            return {
                maxWidth: maxWidth,
                maxHeight: maxHeight
            };
        };
        Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
            var scale = this.props.scale || 1;
            var resizeRatio = this.props.resizeRatio || 1;
            var _a = this.state, direction = _a.direction, original = _a.original;
            var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
            var newWidth = original.width;
            var newHeight = original.height;
            var extraHeight = lockAspectRatioExtraHeight || 0;
            var extraWidth = lockAspectRatioExtraWidth || 0;
            if ($ab2d5372f352af9c$var$hasDirection('right', direction)) {
                newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
                if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
            if ($ab2d5372f352af9c$var$hasDirection('left', direction)) {
                newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
                if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
            if ($ab2d5372f352af9c$var$hasDirection('bottom', direction)) {
                newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
                if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
            if ($ab2d5372f352af9c$var$hasDirection('top', direction)) {
                newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
                if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
            return {
                newWidth: newWidth,
                newHeight: newHeight
            };
        };
        Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
            var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
            var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
            var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
            var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
            var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
            var extraHeight = lockAspectRatioExtraHeight || 0;
            var extraWidth = lockAspectRatioExtraWidth || 0;
            if (lockAspectRatio) {
                var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
                var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
                var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
                var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
                var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
                var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
                var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
                var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
                newWidth = $ab2d5372f352af9c$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
                newHeight = $ab2d5372f352af9c$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
            } else {
                newWidth = $ab2d5372f352af9c$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
                newHeight = $ab2d5372f352af9c$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
            }
            return {
                newWidth: newWidth,
                newHeight: newHeight
            };
        };
        Resizable.prototype.setBoundingClientRect = function() {
            if (this.props.bounds === 'parent') {
                var parent_3 = this.parentNode;
                if (parent_3 instanceof HTMLElement) {
                    var parentRect = parent_3.getBoundingClientRect();
                    this.parentLeft = parentRect.left;
                    this.parentTop = parentRect.top;
                }
            }
            if (this.props.bounds instanceof HTMLElement) {
                var targetRect = this.props.bounds.getBoundingClientRect();
                this.targetLeft = targetRect.left;
                this.targetTop = targetRect.top;
            }
            if (this.resizable) {
                var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
                this.resizableLeft = left;
                this.resizableTop = top_1;
            }
        };
        Resizable.prototype.onResizeStart = function(event, direction) {
            var clientX = 0;
            var clientY = 0;
            if (event.nativeEvent instanceof MouseEvent) {
                clientX = event.nativeEvent.clientX;
                clientY = event.nativeEvent.clientY;
                if (event.nativeEvent.which === 3) return;
            } else if (event.nativeEvent instanceof TouchEvent) {
                clientX = event.nativeEvent.touches[0].clientX;
                clientY = event.nativeEvent.touches[0].clientY;
            }
            if (this.props.onResizeStart) {
                if (this.resizable) {
                    var startResize = this.props.onResizeStart(event, direction, this.resizable);
                    if (startResize === false) return;
                }
            }
            if (this.props.size) {
                if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                    height: this.props.size.height
                });
                if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                    width: this.props.size.width
                });
            }
            this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
            this.setBoundingClientRect();
            this.setState({
                original: {
                    x: clientX,
                    y: clientY,
                    width: this.size.width,
                    height: this.size.height
                },
                isResizing: true,
                resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
                direction: direction
            });
        };
        Resizable.prototype.onMouseMove = function(event) {
            if (!this.state.isResizing || !this.resizable) return;
            var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
            var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
            var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
            var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
            var parentSize = this.getParentSize();
            var max = $ab2d5372f352af9c$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
            maxWidth = max.maxWidth;
            maxHeight = max.maxHeight;
            minWidth = max.minWidth;
            minHeight = max.minHeight;
            var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
            var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
            var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
                width: boundaryMax.maxWidth,
                height: boundaryMax.maxHeight
            }, {
                width: minWidth,
                height: minHeight
            });
            newWidth = newSize.newWidth;
            newHeight = newSize.newHeight;
            if (this.props.grid) {
                var newGridWidth = $ab2d5372f352af9c$var$snap(newWidth, this.props.grid[0]);
                var newGridHeight = $ab2d5372f352af9c$var$snap(newHeight, this.props.grid[1]);
                var gap = this.props.snapGap || 0;
                newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
                newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
            }
            if (this.props.snap && this.props.snap.x) newWidth = $ab2d5372f352af9c$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
            if (this.props.snap && this.props.snap.y) newHeight = $ab2d5372f352af9c$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
            var delta = {
                width: newWidth - original.width,
                height: newHeight - original.height
            };
            if (width && typeof width === 'string') {
                if ($ab2d5372f352af9c$var$endsWith(width, '%')) {
                    var percent = newWidth / parentSize.width * 100;
                    newWidth = percent + "%";
                } else if ($ab2d5372f352af9c$var$endsWith(width, 'vw')) {
                    var vw = newWidth / window.innerWidth * 100;
                    newWidth = vw + "vw";
                } else if ($ab2d5372f352af9c$var$endsWith(width, 'vh')) {
                    var vh = newWidth / window.innerHeight * 100;
                    newWidth = vh + "vh";
                }
            }
            if (height && typeof height === 'string') {
                if ($ab2d5372f352af9c$var$endsWith(height, '%')) {
                    var percent = newHeight / parentSize.height * 100;
                    newHeight = percent + "%";
                } else if ($ab2d5372f352af9c$var$endsWith(height, 'vw')) {
                    var vw = newHeight / window.innerWidth * 100;
                    newHeight = vw + "vw";
                } else if ($ab2d5372f352af9c$var$endsWith(height, 'vh')) {
                    var vh = newHeight / window.innerHeight * 100;
                    newHeight = vh + "vh";
                }
            }
            this.setState({
                width: this.createSizeForCssProperty(newWidth, 'width'),
                height: this.createSizeForCssProperty(newHeight, 'height')
            });
            if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
        };
        Resizable.prototype.onMouseUp = function(event) {
            var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
            if (!isResizing || !this.resizable) return;
            var delta = {
                width: this.size.width - original.width,
                height: this.size.height - original.height
            };
            if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
            if (this.props.size) this.setState(this.props.size);
            this.setState({
                isResizing: false,
                resizeCursor: 'auto'
            });
        };
        Resizable.prototype.updateSize = function(size) {
            this.setState({
                width: size.width,
                height: size.height
            });
        };
        Resizable.prototype.renderResizer = function() {
            var _this = this;
            var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
            if (!enable) return null;
            var resizers = Object.keys(enable).map(function(dir) {
                if (enable[dir] !== false) return $ab2d5372f352af9c$var$React.createElement($f6P3s.Resizer, {
                    key: dir,
                    direction: dir,
                    onResizeStart: _this.onResizeStart,
                    replaceStyles: handleStyles && handleStyles[dir],
                    className: handleClasses && handleClasses[dir]
                }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
                return null;
            });
            return $ab2d5372f352af9c$var$React.createElement("span", {
                className: handleWrapperClass,
                style: handleWrapperStyle
            }, resizers);
        };
        Resizable.prototype.render = function() {
            var _this = this;
            var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
                if ($ab2d5372f352af9c$var$definedProps.indexOf(key) !== -1) return acc;
                acc[key] = _this.props[key];
                return acc;
            }, {});
            return $ab2d5372f352af9c$var$React.createElement("div", $ab2d5372f352af9c$var$__assign({
                ref: function(c) {
                    if (c) _this.resizable = c;
                },
                style: $ab2d5372f352af9c$var$__assign({
                    position: 'relative',
                    userSelect: this.state.isResizing ? 'none' : 'auto'
                }, this.props.style, this.sizeStyle, {
                    maxWidth: this.props.maxWidth,
                    maxHeight: this.props.maxHeight,
                    minWidth: this.props.minWidth,
                    minHeight: this.props.minHeight,
                    boxSizing: 'border-box'
                }),
                className: this.props.className
            }, extendsProps), this.state.isResizing && $ab2d5372f352af9c$var$React.createElement("div", {
                style: {
                    height: '100%',
                    width: '100%',
                    backgroundColor: 'rgba(0,0,0,0)',
                    cursor: "" + (this.state.resizeCursor || 'auto'),
                    opacity: 0,
                    position: 'fixed',
                    zIndex: 9999,
                    top: '0',
                    left: '0',
                    bottom: '0',
                    right: '0'
                }
            }), this.props.children, this.renderResizer());
        };
        Resizable.defaultProps = {
            onResizeStart: function() {},
            onResize: function() {},
            onResizeStop: function() {},
            enable: {
                top: true,
                right: true,
                bottom: true,
                left: true,
                topRight: true,
                bottomRight: true,
                bottomLeft: true,
                topLeft: true
            },
            style: {},
            grid: [
                1,
                1
            ],
            lockAspectRatio: false,
            lockAspectRatioExtraWidth: 0,
            lockAspectRatioExtraHeight: 0,
            scale: 1,
            resizeRatio: 1,
            snapGap: 0
        };
        return Resizable;
    }($ab2d5372f352af9c$var$React.PureComponent);
    module.exports.Resizable = $ab2d5372f352af9c$var$Resizable;
});
parcelRegister("f6P3s", function(module, exports) {
    "use strict";
    var $afff04f5d63d71a2$var$__assign = module.exports && module.exports.__assign || function() {
        $afff04f5d63d71a2$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $afff04f5d63d71a2$var$__assign.apply(this, arguments);
    };
    var $afff04f5d63d71a2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        }
        result["default"] = mod;
        return result;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $afff04f5d63d71a2$var$React = $afff04f5d63d71a2$var$__importStar((parcelRequire("5uXOq")));
    var $afff04f5d63d71a2$var$styles = {
        top: {
            width: '100%',
            height: '10px',
            top: '-5px',
            left: '0px',
            cursor: 'row-resize'
        },
        right: {
            width: '10px',
            height: '100%',
            top: '0px',
            right: '-5px',
            cursor: 'col-resize'
        },
        bottom: {
            width: '100%',
            height: '10px',
            bottom: '-5px',
            left: '0px',
            cursor: 'row-resize'
        },
        left: {
            width: '10px',
            height: '100%',
            top: '0px',
            left: '-5px',
            cursor: 'col-resize'
        },
        topRight: {
            width: '20px',
            height: '20px',
            position: 'absolute',
            right: '-10px',
            top: '-10px',
            cursor: 'ne-resize'
        },
        bottomRight: {
            width: '20px',
            height: '20px',
            position: 'absolute',
            right: '-10px',
            bottom: '-10px',
            cursor: 'se-resize'
        },
        bottomLeft: {
            width: '20px',
            height: '20px',
            position: 'absolute',
            left: '-10px',
            bottom: '-10px',
            cursor: 'sw-resize'
        },
        topLeft: {
            width: '20px',
            height: '20px',
            position: 'absolute',
            left: '-10px',
            top: '-10px',
            cursor: 'nw-resize'
        }
    };
    function $afff04f5d63d71a2$var$Resizer(props) {
        return $afff04f5d63d71a2$var$React.createElement("div", {
            className: props.className || '',
            style: $afff04f5d63d71a2$var$__assign({
                position: 'absolute',
                userSelect: 'none'
            }, $afff04f5d63d71a2$var$styles[props.direction], props.replaceStyles || {}),
            onMouseDown: function(e) {
                props.onResizeStart(e, props.direction);
            },
            onTouchStart: function(e) {
                props.onResizeStart(e, props.direction);
            }
        }, props.children);
    }
    module.exports.Resizer = $afff04f5d63d71a2$var$Resizer;
});
parcelRegister("8mQ2m", function(module, exports) {
    function $6178be4d98a9a554$var$memoize(fn, options) {
        var cache = options && options.cache ? options.cache : $6178be4d98a9a554$var$cacheDefault;
        var serializer = options && options.serializer ? options.serializer : $6178be4d98a9a554$var$serializerDefault;
        var strategy = options && options.strategy ? options.strategy : $6178be4d98a9a554$var$strategyDefault;
        return strategy(fn, {
            cache: cache,
            serializer: serializer
        });
    }
    function $6178be4d98a9a554$var$isPrimitive(value) {
        return value == null || typeof value === 'number' || typeof value === 'boolean';
    }
    function $6178be4d98a9a554$var$monadic(fn, cache, serializer, arg) {
        var cacheKey = $6178be4d98a9a554$var$isPrimitive(arg) ? arg : serializer(arg);
        var computedValue = cache.get(cacheKey);
        if (typeof computedValue === 'undefined') {
            computedValue = fn.call(this, arg);
            cache.set(cacheKey, computedValue);
        }
        return computedValue;
    }
    function $6178be4d98a9a554$var$variadic(fn, cache, serializer) {
        var args = Array.prototype.slice.call(arguments, 3);
        var cacheKey = serializer(args);
        var computedValue = cache.get(cacheKey);
        if (typeof computedValue === 'undefined') {
            computedValue = fn.apply(this, args);
            cache.set(cacheKey, computedValue);
        }
        return computedValue;
    }
    function $6178be4d98a9a554$var$assemble(fn, context, strategy, cache, serialize) {
        return strategy.bind(context, fn, cache, serialize);
    }
    function $6178be4d98a9a554$var$strategyDefault(fn, options) {
        var strategy = fn.length === 1 ? $6178be4d98a9a554$var$monadic : $6178be4d98a9a554$var$variadic;
        return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
    }
    function $6178be4d98a9a554$var$strategyVariadic(fn, options) {
        var strategy = $6178be4d98a9a554$var$variadic;
        return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
    }
    function $6178be4d98a9a554$var$strategyMonadic(fn, options) {
        var strategy = $6178be4d98a9a554$var$monadic;
        return $6178be4d98a9a554$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
    }
    function $6178be4d98a9a554$var$serializerDefault() {
        return JSON.stringify(arguments);
    }
    function $6178be4d98a9a554$var$ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    $6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
        return key in this.cache;
    };
    $6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    $6178be4d98a9a554$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    var $6178be4d98a9a554$var$cacheDefault = {
        create: function create() {
            return new $6178be4d98a9a554$var$ObjectWithoutPrototypeCache();
        }
    };
    module.exports = $6178be4d98a9a554$var$memoize;
    module.exports.strategies = {
        variadic: $6178be4d98a9a554$var$strategyVariadic,
        monadic: $6178be4d98a9a554$var$strategyMonadic
    };
});
parcelRegister("gZOBO", function(module, exports) {
    $parcel$export(module.exports, "wrapperStyle", ()=>$82b5775f07862174$export$c4d4f06a25de97f);
    var $f8Sb3;
    var $ipSX1;
    const $82b5775f07862174$export$c4d4f06a25de97f = (props)=>(0, (0, parcelRequire("f8Sb3")).css)("&>div{", (0, (0, parcelRequire("ipSX1")).MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");
});
parcelRegister("N3kru", function(module, exports) {
    $parcel$export(module.exports, "lazyInlineCardView", ()=>$09e3ee444c4278c8$export$cd3f6a9b84ab8435);
    var $3xRyR;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $2CVDy;
    const $09e3ee444c4278c8$export$cd3f6a9b84ab8435 = (props)=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ssr_fix_smartlinks')) return (0, (0, parcelRequire("2CVDy")).inlineCardNodeView)(props);
        return (0, (0, parcelRequire("3xRyR")).withLazyLoading)({
            nodeName: 'inlineCard',
            getNodeViewOptions: ()=>{},
            loader: ()=>{
                const result = Promise.resolve((parcelRequire("2CVDy"))).then(({ inlineCardNodeView: inlineCardNodeView })=>{
                    return inlineCardNodeView(props);
                });
                return result;
            }
        });
    };
});
parcelRegister("h162L", function(module, exports) {
    $parcel$export(module.exports, "getDatasource", ()=>$6fb9541cf91063a0$export$32844f9f273856e4);
    $parcel$export(module.exports, "isDatasourceTableLayout", ()=>$6fb9541cf91063a0$export$8467cbb601c13bfc);
    var $5r0mK = parcelRequire("5r0mK");
    var $89B6e;
    var $2E94j;
    const $6fb9541cf91063a0$export$32844f9f273856e4 = (editorView)=>{
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $5r0mK.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, (0, parcelRequire("89B6e")).isDatasourceNode)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
        return {
            node: undefined,
            pos: undefined
        };
    };
    const $6fb9541cf91063a0$export$8467cbb601c13bfc = (layout)=>{
        return (0, (0, parcelRequire("2E94j")).DATASOURCE_TABLE_LAYOUTS).some((l)=>l === layout);
    };
});
parcelRegister("2E94j", function(module, exports) {
    $parcel$export(module.exports, "DATASOURCE_TABLE_LAYOUTS", ()=>$c7ea2dfde8763beb$export$3f155c85880510c8);
    const $c7ea2dfde8763beb$export$3f155c85880510c8 = [
        'full-width',
        'center',
        'wide'
    ];
});
parcelRegister("bYyIW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ce5f187ffffb185$export$2e2bcd8739ae039);
    const $0ce5f187ffffb185$var$queue = (state, action)=>{
        return {
            ...state,
            requests: state.requests.concat(action.requests)
        };
    };
    const $0ce5f187ffffb185$var$resolve = (state, action)=>{
        const requests = state.requests.reduce((requests, request)=>{
            if (request.url !== action.url) requests.push(request);
            return requests;
        }, []);
        return {
            ...state,
            requests: requests
        };
    };
    const $0ce5f187ffffb185$var$register = (state, action)=>{
        return {
            ...state,
            cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
        };
    };
    const $0ce5f187ffffb185$var$setProvider = (state, action)=>{
        return {
            ...state,
            provider: action.provider
        };
    };
    const $0ce5f187ffffb185$var$setCardLayout = (state, action)=>{
        return {
            ...state,
            layout: action.layout
        };
    };
    const $0ce5f187ffffb185$var$setDatasourceTableRef = (state, action)=>{
        return {
            ...state,
            datasourceTableRef: action.datasourceTableRef
        };
    };
    const $0ce5f187ffffb185$var$setCardLayoutDatasourceTableRef = (state, action)=>{
        return {
            ...state,
            datasourceTableRef: action.datasourceTableRef,
            layout: action.layout
        };
    };
    const $0ce5f187ffffb185$var$registerEvents = (state, action)=>{
        return {
            ...state,
            smartLinkEvents: action.smartLinkEvents
        };
    };
    const $0ce5f187ffffb185$var$setLinkToolbar = (state, action)=>{
        return {
            ...state,
            showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
        };
    };
    const $0ce5f187ffffb185$var$showDatasourceModal = (state, action)=>{
        return {
            ...state,
            showDatasourceModal: true,
            datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
        };
    };
    const $0ce5f187ffffb185$var$hideDatasourceModal = (state)=>{
        return {
            ...state,
            showDatasourceModal: false,
            datasourceModalType: undefined
        };
    };
    const $0ce5f187ffffb185$var$clearOverlayCandidate = (state)=>{
        return {
            ...state,
            overlayCandidatePosition: undefined
        };
    };
    const $0ce5f187ffffb185$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
        return {
            ...state,
            removeOverlay: action.callback
        };
    };
    const $0ce5f187ffffb185$var$setDatasourceStash = (state, action)=>{
        return {
            ...state,
            datasourceStash: {
                ...state.datasourceStash,
                [action.datasourceStash.url]: {
                    views: action.datasourceStash.views
                }
            }
        };
    };
    const $0ce5f187ffffb185$var$removeDatasourceStash = (state, action)=>{
        const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
        return {
            ...state,
            datasourceStash: datasourceStash
        };
    };
    var $0ce5f187ffffb185$export$2e2bcd8739ae039 = (state, action)=>{
        switch(action.type){
            case 'QUEUE':
                return $0ce5f187ffffb185$var$queue(state, action);
            case 'SET_PROVIDER':
                return $0ce5f187ffffb185$var$setProvider(state, action);
            case 'RESOLVE':
                return $0ce5f187ffffb185$var$resolve(state, action);
            case 'REGISTER':
                return $0ce5f187ffffb185$var$register(state, action);
            case 'REGISTER_EVENTS':
                return $0ce5f187ffffb185$var$registerEvents(state, action);
            case 'SET_DATASOURCE_TABLE_REF':
                return $0ce5f187ffffb185$var$setDatasourceTableRef(state, action);
            case 'SET_CARD_LAYOUT':
                return $0ce5f187ffffb185$var$setCardLayout(state, action);
            case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
                return $0ce5f187ffffb185$var$setCardLayoutDatasourceTableRef(state, action);
            case 'SHOW_LINK_TOOLBAR':
            case 'HIDE_LINK_TOOLBAR':
                return $0ce5f187ffffb185$var$setLinkToolbar(state, action);
            case 'SHOW_DATASOURCE_MODAL':
                return $0ce5f187ffffb185$var$showDatasourceModal(state, action);
            case 'HIDE_DATASOURCE_MODAL':
                return $0ce5f187ffffb185$var$hideDatasourceModal(state);
            case 'CLEAR_OVERLAY_CANDIDATE':
                return $0ce5f187ffffb185$var$clearOverlayCandidate(state);
            case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
                return $0ce5f187ffffb185$var$registerRemoveOverlayOnInsertedLink(state, action);
            case 'SET_DATASOURCE_STASH':
                return $0ce5f187ffffb185$var$setDatasourceStash(state, action);
            case 'REMOVE_DATASOURCE_STASH':
                return $0ce5f187ffffb185$var$removeDatasourceStash(state, action);
        }
    };
});
parcelRegister("jhHFS", function(module, exports) {
    $parcel$export(module.exports, "resolveWithProvider", ()=>$80f73e55a8a66765$export$2007d0af08977743);
    $parcel$export(module.exports, "handleProvider", ()=>$80f73e55a8a66765$export$96766f42428c9e7f);
    var $3dBkm;
    parcelRequire("77j9j");
    var $ggL2v;
    var $VSDnB;
    var $nYpqR;
    var $jPiXc;
    const $80f73e55a8a66765$var$isFreshlyPastedOnNewLine = (view)=>{
        const { selection: selection } = view.state;
        const { $cursor: $cursor, $anchor: $anchor } = selection;
        if (!$cursor) return false;
        if (!(0, (0, parcelRequire("ggL2v")).hasDocAsParent)($anchor)) return false;
        const node = $cursor.node();
        if (!node) return false;
        if (node.type.name !== 'paragraph') return false;
        return node.childCount === 1;
    };
    const $80f73e55a8a66765$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent)=>{
        const isEmbedFriendlyLocation = (0, (0, parcelRequire("VSDnB")).fg)('hardcoded-embeds-only-on-new-line') ? $80f73e55a8a66765$var$isFreshlyPastedOnNewLine(view) : true;
        let shouldForceAppearance = !!request.shouldReplaceLink;
        const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($80f73e55a8a66765$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options), $80f73e55a8a66765$var$handleRejected(view, request, editorAnalyticsApi));
        return handleResolve;
    };
    const $80f73e55a8a66765$var$updateCardType = (resolvedCard, options)=>{
        if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
            const datasourceId = resolvedCard.attrs.datasource.id;
            if (!options.allowDatasource || !(0, (0, parcelRequire("3dBkm")).canRenderDatasource)(datasourceId)) {
                delete resolvedCard.attrs.datasource;
                resolvedCard.type = 'inlineCard';
                return;
            }
        }
        if (resolvedCard?.type === 'blockCard' && !options.allowBlockCards || resolvedCard?.type === 'embedCard' && !options.allowEmbeds) {
            if (resolvedCard.type === 'embedCard') delete resolvedCard.attrs.layout;
            resolvedCard.type = 'inlineCard';
        }
    };
    const $80f73e55a8a66765$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options)=>(resolvedCard)=>{
            $80f73e55a8a66765$var$updateCardType(resolvedCard, options);
            (0, (0, parcelRequire("jPiXc")).replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent)(view.state, view.dispatch);
            return resolvedCard;
        };
    const $80f73e55a8a66765$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
            (0, (0, parcelRequire("jPiXc")).handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
        };
    const $80f73e55a8a66765$export$96766f42428c9e7f = (_, provider, view)=>{
        if (!provider) return;
        provider.then((cardProvider)=>{
            const { state: state, dispatch: dispatch } = view;
            dispatch((0, (0, parcelRequire("nYpqR")).setProvider)(cardProvider)(state.tr));
        });
    };
});
parcelRegister("poQgC", function(module, exports) {
    $parcel$export(module.exports, "blockCardSpecWithFixedToDOM", ()=>$5065ebe51e06e81a$export$f664dd11022c8749);
    var $21PS7;
    var $7KZr8;
    var $gmhCD = parcelRequire("gmhCD");
    const $5065ebe51e06e81a$export$f664dd11022c8749 = ()=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, (0, parcelRequire("21PS7")).blockCard;
        return {
            ...(0, (0, parcelRequire("21PS7")).blockCard),
            toDOM: (node)=>{
                const { url: url } = node.attrs;
                const { data: data } = node.attrs;
                const { layout: layout, width: width, datasource: datasource } = node.attrs;
                const attrs = {
                    'data-block-card': '',
                    'data-card-url': url || '',
                    'data-card-data': data ? JSON.stringify(data) : '',
                    'data-datasource': datasource ? JSON.stringify(datasource) : '',
                    'data-layout': layout,
                    'data-width': `${width}`,
                    class: 'blockCardView-content-wrap'
                };
                return [
                    'div',
                    attrs,
                    [
                        'a',
                        {
                            style: (0, (0, parcelRequire("7KZr8")).convertToInlineCss)({
                                padding: `${"var(--ds-space-025, 2px)"} 0px`,
                                marginLeft: "var(--ds-space-negative-025, -2px)",
                                display: 'inline',
                                boxDecorationBreak: 'clone',
                                WebkitBoxDecorationBreak: 'clone',
                                borderRadius: "var(--ds-border-radius-100, 4px)",
                                color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                                lineHeight: '22px',
                                WebkitTransition: '0.1s all ease-in-out',
                                transition: '0.1s all ease-in-out',
                                userSelect: 'text',
                                WebkitUserSelect: 'text',
                                msUserSelect: 'text',
                                MozUserSelect: 'none'
                            }),
                            href: url || ''
                        },
                        node?.attrs?.url || ' '
                    ]
                ];
            }
        };
    };
});
parcelRegister("dl2Ap", function(module, exports) {
    $parcel$export(module.exports, "embedCardSpecWithFixedToDOM", ()=>$697487b38bc86b3c$export$f8faabd3267a007e);
    var $kshOv;
    var $7KZr8;
    var $iHYdz;
    var $gmhCD = parcelRequire("gmhCD");
    function $697487b38bc86b3c$var$calcMargin(layout) {
        switch(layout){
            case 'wrap-right':
                return '12px auto 12px 12px';
            case 'wrap-left':
                return '12px 12px 12px auto';
            default:
                return '24px auto';
        }
    }
    function $697487b38bc86b3c$var$float(layout) {
        switch(layout){
            case 'wrap-right':
                return 'right';
            case 'wrap-left':
                return 'left';
            default:
                return 'none';
        }
    }
    const $697487b38bc86b3c$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
    function $697487b38bc86b3c$var$calcPxFromPct(pct, lineLength) {
        const maxWidth = lineLength + $697487b38bc86b3c$var$MEDIA_SINGLE_GUTTER_SIZE;
        return maxWidth * pct - $697487b38bc86b3c$var$MEDIA_SINGLE_GUTTER_SIZE;
    }
    const $697487b38bc86b3c$var$LINE_LENGTH = 760;
    const $697487b38bc86b3c$export$f8faabd3267a007e = ()=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, (0, parcelRequire("kshOv")).embedCard;
        return {
            ...(0, (0, parcelRequire("kshOv")).embedCard),
            toDOM: (node)=>{
                const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
                const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH) / (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_HEIGHT);
                const attrs = {
                    'data-embed-card': '',
                    'data-card-url': url,
                    'data-layout': layout,
                    'data-width': width,
                    'data-original-width': originalWidth,
                    'data-original-height': originalHeight,
                    class: 'embedCardView-content-wrap',
                    style: (0, (0, parcelRequire("7KZr8")).convertToInlineCss)({
                        margin: $697487b38bc86b3c$var$calcMargin(layout),
                        width: `${Math.ceil($697487b38bc86b3c$var$calcPxFromPct(width / 100, $697487b38bc86b3c$var$LINE_LENGTH))}px`,
                        marginRight: layout === 'align-end' ? '0' : '',
                        marginLeft: layout === 'align-start' ? '0' : '',
                        float: $697487b38bc86b3c$var$float(layout)
                    })
                };
                return [
                    'div',
                    attrs,
                    [
                        'a',
                        {
                            style: (0, (0, parcelRequire("7KZr8")).convertToInlineCss)({
                                padding: `${"var(--ds-space-025, 2px)"} 0px`,
                                marginLeft: "var(--ds-space-negative-025, -2px)",
                                display: 'inline',
                                boxDecorationBreak: 'clone',
                                borderRadius: "var(--ds-border-radius-100, 4px)",
                                color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                                lineHeight: '22px',
                                WebkitTransition: '0.1s all ease-in-out',
                                transition: '0.1s all ease-in-out',
                                userSelect: 'text',
                                WebkitUserSelect: 'text',
                                msUserSelect: 'text',
                                MozUserSelect: 'none'
                            })
                        },
                        url ?? ''
                    ],
                    [
                        'span',
                        {
                            style: (0, (0, parcelRequire("7KZr8")).convertToInlineCss)({
                                display: 'block',
                                paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                            })
                        }
                    ]
                ];
            }
        };
    };
});
parcelRegister("g0sA9", function(module, exports) {
    $parcel$export(module.exports, "inlineCardSpecWithFixedToDOM", ()=>$164de0855e0ac967$export$290edac762b9f37c);
    var $cCBEe;
    var $7KZr8;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    const $164de0855e0ac967$export$290edac762b9f37c = ()=>{
        if ((0, $gmhCD.editorExperiment)('platform_editor_exp_lazy_node_views', false) || !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ssr_fix_smartlinks')) return 0, (0, parcelRequire("cCBEe")).inlineCard;
        return {
            ...(0, (0, parcelRequire("cCBEe")).inlineCard),
            toDOM: (node)=>{
                const wrapperAttrs = {
                    class: 'inlineCardView-content-wrap inlineNodeView'
                };
                const cardAttrs = {
                    class: 'card'
                };
                const attrs = {
                    'data-inline-card': '',
                    href: node.attrs.url || '',
                    'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                    style: (0, (0, parcelRequire("7KZr8")).convertToInlineCss)({
                        padding: `${"var(--ds-space-025, 2px)"} 0px`,
                        marginLeft: "var(--ds-space-negative-025, -2px)",
                        display: 'inline',
                        boxDecorationBreak: 'clone',
                        WebkitBoxDecorationBreak: 'clone',
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        color: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
                        lineHeight: '22px',
                        WebkitTransition: '0.1s all ease-in-out',
                        transition: '0.1s all ease-in-out',
                        userSelect: 'text',
                        WebkitUserSelect: 'text',
                        msUserSelect: 'text',
                        MozUserSelect: 'none'
                    })
                };
                if (node.attrs.url) return [
                    'span',
                    wrapperAttrs,
                    [
                        'span',
                        cardAttrs,
                        [
                            'a',
                            attrs,
                            node.attrs.url
                        ]
                    ]
                ];
                else return [
                    'span',
                    wrapperAttrs,
                    [
                        'span',
                        cardAttrs,
                        [
                            'a',
                            attrs
                        ]
                    ]
                ];
            }
        };
    };
});
parcelRegister("cEDVI", function(module, exports) {
    $parcel$export(module.exports, "floatingToolbar", ()=>$4b131a87a3e725bb$export$4850df084251d287);
    $parcel$export(module.exports, "shouldRenderToolbarPulse", ()=>$4b131a87a3e725bb$export$ddeab6943680f5be);
    $parcel$export(module.exports, "getStartingToolbarItems", ()=>$4b131a87a3e725bb$export$bb790f15a666b7f0);
    $parcel$export(module.exports, "getEndingToolbarItems", ()=>$4b131a87a3e725bb$export$d5ca70670b9f6b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZOJ9;
    var $gkwXh;
    var $2iyV6;
    var $70Lw2;
    var $1ZWXY;
    var $lhLis;
    var $80CM7;
    var $8DYpW;
    var $gSYO9;
    var $jDuvE;
    var $kRXi9;
    var $ceYEW;
    var $3dBkm;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $4IrpZ;
    var $90mMF;
    var $ggICg;
    var $epOG5;
    var $f5BqX;
    var $ik2d8;
    var $jdB85;
    var $17Ngn;
    var $VSDnB;
    var $jPiXc;
    parcelRequire("kfdsX");
    var $lumM0;
    var $fo6j3;
    var $A2Kgl;
    var $9Ox4G;
    var $6rhck;
    var $fjdBk;
    var $hv7lU;
    var $89B6e;
    const $4b131a87a3e725bb$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((state, dispatch)=>{
            if (!(state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection))) return false;
            const type = state.selection.node.type.name;
            const payload = {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).DELETED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: type,
                attributes: {
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR,
                    displayMode: type
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            };
            if (dispatch) {
                const { tr: tr } = state;
                (0, $5r0mK.removeSelectedNode)(tr);
                editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        }, {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).DELETED
        });
    const $4b131a87a3e725bb$export$bf806231ea9f086b = (editorAnalyticsApi)=>(state, dispatch)=>{
            if (!(state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection))) return false;
            const { type: type } = state.selection.node;
            const { url: url } = (0, (0, parcelRequire("89B6e")).titleUrlPairFromNode)(state.selection.node);
            window.open(url);
            if (dispatch) {
                const { tr: tr } = state;
                editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).buildVisitedLinkPayload)(type.name))(tr);
                dispatch(tr);
            }
            return true;
        };
    const $4b131a87a3e725bb$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
            if (!(state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection))) return false;
            if (dispatch) {
                const { tr: tr, selection: { node: { type: type } } } = state;
                editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).buildOpenedSettingsPayload)(type.name))(tr);
                dispatch(tr);
            }
            return true;
        };
    const $4b131a87a3e725bb$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
        return (state, intl, providerFactory)=>{
            if (disableFloatingToolbar) return;
            const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
            const nodeType = [
                inlineCard,
                blockCard,
                embedCard
            ];
            const pluginState = (0, (0, parcelRequire("lumM0")).pluginKey).getState(state);
            if (!(state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection))) return;
            const selectedNode = state.selection.node;
            if (!selectedNode) return;
            const isEmbedCard = (0, (0, parcelRequire("89B6e")).appearanceForNodeType)(selectedNode.type) === 'embed';
            const toolbarOffset = isEmbedCard ? {
                offset: [
                    0,
                    24
                ]
            } : {};
            const className = pluginState?.showLinkingToolbar ? (0, (0, parcelRequire("kRXi9")).FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
            const isLinkPickerEnabled = !!lpLinkPicker;
            return {
                title: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).card),
                className: className,
                nodeType: nodeType,
                preventPopupOverflow: isLinkPickerEnabled,
                ...toolbarOffset,
                getDomRef: (view)=>{
                    const element = (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                    if (!element) return undefined;
                    if (isEmbedCard) return element.querySelector(`.${(0, (0, parcelRequire("ceYEW")).richMediaClassName)}`);
                    return element;
                },
                items: $4b131a87a3e725bb$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
                scrollable: pluginState?.showLinkingToolbar ? false : true,
                ...(0, (0, parcelRequire("A2Kgl")).editLinkToolbarConfig)(Boolean(pluginState?.showLinkingToolbar), isLinkPickerEnabled)
            };
        };
    };
    const $4b131a87a3e725bb$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
        const displayInfo = (0, (0, parcelRequire("89B6e")).displayInfoForCard)(node, (0, (0, parcelRequire("89B6e")).findCardInfo)(state));
        const text = displayInfo.title || displayInfo.url;
        if (text) return (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((0, (0, parcelRequire("jPiXc")).changeSelectedCardToText)(text, editorAnalyticsApi), {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK
        });
        return ()=>false;
    };
    const $4b131a87a3e725bb$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions)=>{
        return (0, (0, parcelRequire("70Lw2")).default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions?.allowWrapping, cardOptions?.allowAlignment);
    };
    const $4b131a87a3e725bb$var$withToolbarMetadata = (command)=>(0, (0, parcelRequire("1ZWXY")).commandWithMetadata)(command, {
            inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
        });
    const $4b131a87a3e725bb$var$getToolbarViewedItem = (url, display)=>{
        if (!url) return [];
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hv7lU")).ToolbarViewedEvent), {
                        key: "edit.link.menu.viewed",
                        url: url,
                        display: display,
                        editorView: editorView
                    })
            }
        ];
    };
    const $4b131a87a3e725bb$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
            const { url: url } = (0, (0, parcelRequire("89B6e")).titleUrlPairFromNode)(node);
            const { actions: editorAnalyticsApi } = pluginInjectionApi?.analytics ?? {};
            let metadata = {};
            if (url && !(0, (0, parcelRequire("iZOJ9")).isSafeUrl)(url)) return [];
            else {
                const { title: title } = (0, (0, parcelRequire("89B6e")).displayInfoForCard)(node, (0, (0, parcelRequire("89B6e")).findCardInfo)(state));
                metadata = {
                    url: url,
                    title: title
                };
            }
            const currentAppearance = (0, (0, parcelRequire("89B6e")).appearanceForNodeType)(node.type);
            const { hoverDecoration: hoverDecoration } = pluginInjectionApi?.decorations?.actions ?? {};
            const isDatasource = (0, (0, parcelRequire("89B6e")).isDatasourceNode)(node);
            const pluginState = (0, (0, parcelRequire("lumM0")).pluginKey).getState(state);
            const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, (0, parcelRequire("3dBkm")).canRenderDatasource)(node?.attrs?.datasource?.id);
            if (pluginState?.showLinkingToolbar) return [
                (0, (0, parcelRequire("A2Kgl")).buildEditLinkToolbar)({
                    providerFactory: providerFactory,
                    linkPicker: linkPicker,
                    node: node,
                    pluginInjectionApi: pluginInjectionApi,
                    lpLinkPicker: lpLinkPicker
                })
            ];
            else if (shouldRenderDatasourceToolbar) return $4b131a87a3e725bb$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance);
            else {
                const { inlineCard: inlineCard } = state.schema.nodes;
                const editItems = cardOptions.allowDatasource ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ox4G")).EditToolbarButton), {
                                key: "edit-toolbar-item",
                                url: url,
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                editorView: editorView,
                                onLinkEditClick: (0, (0, parcelRequire("A2Kgl")).getEditLinkCallback)(editorAnalyticsApi, true),
                                currentAppearance: currentAppearance
                            })
                    }
                ] : [
                    {
                        id: 'editor.link.edit',
                        type: 'button',
                        selected: false,
                        metadata: metadata,
                        title: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink),
                        showTitle: true,
                        testId: 'link-toolbar-edit-link-button',
                        onClick: (0, (0, parcelRequire("A2Kgl")).getEditLinkCallback)(editorAnalyticsApi, true)
                    },
                    {
                        type: 'separator'
                    }
                ];
                const toolbarItems = [
                    ...editItems,
                    {
                        id: 'editor.link.openLink',
                        type: 'button',
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("ggICg"))))),
                        iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))),
                        metadata: metadata,
                        className: 'hyperlink-open-link',
                        title: intl.formatMessage((0, (0, parcelRequire("gSYO9")).linkMessages).openLink),
                        onClick: $4b131a87a3e725bb$export$bf806231ea9f086b(editorAnalyticsApi)
                    },
                    {
                        type: 'separator'
                    },
                    ...$4b131a87a3e725bb$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi),
                    {
                        type: 'copy-button',
                        supportsViewMode: !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_remove_copy_button_from_view_mode'),
                        items: [
                            {
                                state: state,
                                formatMessage: intl.formatMessage,
                                nodeType: node.type
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    $4b131a87a3e725bb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.link.delete',
                        focusEditoronEnter: true,
                        type: 'button',
                        appearance: 'danger',
                        icon: (0, ($parcel$interopDefault((0, parcelRequire("4IrpZ"))))),
                        iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("f5BqX"))))),
                        onMouseEnter: hoverDecoration?.(node.type, true),
                        onMouseLeave: hoverDecoration?.(node.type, false),
                        onFocus: hoverDecoration?.(node.type, true),
                        onBlur: hoverDecoration?.(node.type, false),
                        title: intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).remove),
                        onClick: $4b131a87a3e725bb$var$withToolbarMetadata($4b131a87a3e725bb$export$3301f76e6efaf85e(editorAnalyticsApi))
                    }
                ];
                if (currentAppearance === 'embed') {
                    const alignmentOptions = $4b131a87a3e725bb$var$buildAlignmentOptions(state, intl, pluginInjectionApi?.width, pluginInjectionApi?.analytics?.actions, cardOptions);
                    if (alignmentOptions.length) alignmentOptions.push({
                        type: 'separator'
                    });
                    toolbarItems.unshift(...alignmentOptions);
                }
                const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
                if (currentAppearance) {
                    const showDatasourceAppearance = allowDatasource && url;
                    toolbarItems.unshift(...$4b131a87a3e725bb$var$getToolbarViewedItem(url, currentAppearance), {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjdBk")).LinkToolbarAppearance), {
                                key: "link-appearance",
                                url: url,
                                intl: intl,
                                currentAppearance: currentAppearance,
                                editorView: editorView,
                                editorState: state,
                                allowEmbeds: allowEmbeds,
                                allowBlockCards: allowBlockCards,
                                editorAnalyticsApi: editorAnalyticsApi,
                                showUpgradeDiscoverability: showUpgradeDiscoverability
                            })
                    }, ...showDatasourceAppearance ? [
                        {
                            type: 'custom',
                            fallback: [],
                            render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fo6j3")).DatasourceAppearanceButton), {
                                    intl: intl,
                                    editorAnalyticsApi: editorAnalyticsApi,
                                    url: url,
                                    editorView: editorView,
                                    editorState: state,
                                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
                                })
                        }
                    ] : [], {
                        type: 'separator'
                    });
                }
                return toolbarItems;
            }
        };
    const $4b131a87a3e725bb$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi)=>{
        return node.type === inlineCard ? [
            {
                id: 'editor.link.unlink',
                focusEditoronEnter: true,
                type: 'button',
                title: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).unlink),
                icon: (0, ($parcel$interopDefault((0, parcelRequire("90mMF"))))),
                iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("jdB85"))))),
                onClick: $4b131a87a3e725bb$var$withToolbarMetadata($4b131a87a3e725bb$var$unlinkCard(node, state, editorAnalyticsApi))
            },
            {
                type: 'separator'
            }
        ] : [];
    };
    const $4b131a87a3e725bb$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
        return {
            id: 'editor.link.settings',
            type: 'button',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("epOG5"))))),
            iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("ik2d8"))))),
            title: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).settingsLink),
            onClick: $4b131a87a3e725bb$export$96ed3b1dd32b989d(editorAnalyticsApi),
            href: userPreferencesLink || (0, (0, parcelRequire("lhLis")).getLinkPreferencesURLFromENV)(),
            target: '_blank'
        };
    };
    const $4b131a87a3e725bb$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance)=>{
        const toolbarItems = [];
        const canShowAppearanceSwitch = ()=>{
            if (!metadata.url) return false;
            return true;
        };
        if (canShowAppearanceSwitch()) {
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            const { url: url } = metadata;
            toolbarItems.push({
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjdBk")).LinkToolbarAppearance), {
                        key: "link-appearance",
                        url: url,
                        intl: intl,
                        currentAppearance: currentAppearance,
                        editorView: editorView,
                        editorState: state,
                        allowEmbeds: allowEmbeds,
                        allowBlockCards: allowBlockCards,
                        editorAnalyticsApi: editorAnalyticsApi,
                        showUpgradeDiscoverability: showUpgradeDiscoverability,
                        isDatasourceView: true
                    });
                }
            }, {
                type: 'custom',
                fallback: [],
                render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fo6j3")).DatasourceAppearanceButton), {
                        intl: intl,
                        editorAnalyticsApi: editorAnalyticsApi,
                        url: url,
                        editorView: editorView,
                        editorState: state,
                        selected: true,
                        inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
                    })
            }, {
                type: 'separator'
            });
        }
        toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ox4G")).EditToolbarButton), {
                    datasourceId: datasourceId,
                    node: node,
                    key: "edit-toolbar-item",
                    url: metadata.url,
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    editorView: editorView,
                    onLinkEditClick: (0, (0, parcelRequire("A2Kgl")).getEditLinkCallback)(editorAnalyticsApi, false),
                    currentAppearance: "datasource"
                })
        });
        if (node?.attrs?.url) toolbarItems.push({
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("ggICg"))))),
            iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, (0, parcelRequire("gSYO9")).linkMessages).openLink),
            onClick: $4b131a87a3e725bb$export$bf806231ea9f086b(editorAnalyticsApi)
        }, {
            type: 'separator'
        });
        toolbarItems.push({
            type: 'copy-button',
            supportsViewMode: true,
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: node.type
                }
            ]
        }, {
            type: 'separator'
        }, $4b131a87a3e725bb$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions?.userPreferencesLink), {
            type: 'separator'
        }, {
            id: 'editor.link.delete',
            focusEditoronEnter: true,
            type: 'button',
            appearance: 'danger',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("f5BqX"))))),
            onMouseEnter: hoverDecoration?.(node.type, true),
            onMouseLeave: hoverDecoration?.(node.type, false),
            onFocus: hoverDecoration?.(node.type, true),
            onBlur: hoverDecoration?.(node.type, false),
            title: intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).remove),
            onClick: $4b131a87a3e725bb$var$withToolbarMetadata($4b131a87a3e725bb$export$3301f76e6efaf85e(editorAnalyticsApi))
        });
        return toolbarItems;
    };
    const $4b131a87a3e725bb$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
        return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
    };
    const $4b131a87a3e725bb$export$bb790f15a666b7f0 = (options, api)=>{
        return (intl, link, onEditLink, metadata)=>{
            const editLinkItem = options.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>{
                        if (!editorView) return null;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Ox4G")).EditToolbarButton), {
                            key: "edit-toolbar-button",
                            intl: intl,
                            editorAnalyticsApi: api?.analytics?.actions,
                            url: link,
                            editorView: editorView,
                            onLinkEditClick: onEditLink,
                            currentAppearance: "url"
                        });
                    }
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    testId: 'editor.link.edit',
                    type: 'button',
                    onClick: onEditLink,
                    title: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink),
                    showTitle: true,
                    metadata: metadata
                },
                {
                    type: 'separator'
                }
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hv7lU")).ToolbarViewedEvent), {
                            key: "edit.link.menu.viewed",
                            url: link,
                            display: "url",
                            editorView: editorView
                        })
                },
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>{
                        if (!editorView) return null;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6rhck")).HyperlinkToolbarAppearance), {
                            key: "link-appearance",
                            url: link,
                            intl: intl,
                            editorView: editorView,
                            editorState: editorView.state,
                            cardOptions: options,
                            editorAnalyticsApi: api?.analytics?.actions,
                            editorPluginApi: api
                        });
                    }
                },
                ...editLinkItem
            ];
        };
    };
    const $4b131a87a3e725bb$export$d5ca70670b9f6b9 = (options, api)=>(intl, link)=>{
            if (options.provider || options.userPreferencesLink) return [
                {
                    type: 'separator'
                },
                $4b131a87a3e725bb$export$62592e141464e202(intl, api?.analytics?.actions, options.userPreferencesLink)
            ];
            return [];
        };
});
parcelRegister("70Lw2", function(module, exports) {
    $parcel$export(module.exports, "alignmentIcons", ()=>$c35971a9d6d459fc$export$45400139bf999022);
    $parcel$export(module.exports, "wrappingIcons", ()=>$c35971a9d6d459fc$export$88511ca1ca567d46);
    $parcel$export(module.exports, "layoutToMessages", ()=>$c35971a9d6d459fc$export$b978ceeb25a89f87);
    $parcel$export(module.exports, "default", ()=>$c35971a9d6d459fc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $iHYdz;
    var $kYOHz;
    var $gW72a;
    var $jevkK;
    var $bOzuE;
    var $bOrM0;
    var $5VgMH;
    var $kTcZO;
    var $8io1i;
    var $6O6hD;
    var $3mjma;
    var $5kpFL;
    var $kRhuK;
    var $VSDnB;
    var $gkwXh;
    var $kxM7f;
    var $8DYpW;
    var $eX53M;
    var $cROsB;
    var $594Yf;
    const $c35971a9d6d459fc$export$45400139bf999022 = [
        {
            id: 'editor.media.alignLeft',
            value: 'align-start',
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gW72a"))))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "media-toolbar-align-left-icon",
                    LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("kTcZO")))))
                })
        },
        {
            id: 'editor.media.alignCenter',
            value: 'center',
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kYOHz"))))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "media-toolbar-align-center-icon",
                    LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("5VgMH")))))
                })
        },
        {
            id: 'editor.media.alignRight',
            value: 'align-end',
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jevkK"))))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "media-toolbar-align-right-icon",
                    LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("8io1i")))))
                })
        }
    ];
    const $c35971a9d6d459fc$export$88511ca1ca567d46 = [
        {
            id: 'editor.media.wrapLeft',
            value: 'wrap-left',
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bOzuE"))))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "media-toolbar-wrap-left-icon",
                    LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("5kpFL")))))
                })
        },
        {
            id: 'editor.media.wrapRight',
            value: 'wrap-right',
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bOrM0"))))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "media-toolbar-wrap-right-icon",
                    LEGACY_fallbackIcon: (0, ($parcel$interopDefault((0, parcelRequire("kRhuK")))))
                })
        }
    ];
    const $c35971a9d6d459fc$var$breakoutIcons = [
        {
            value: 'wide',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3mjma")))))
        },
        {
            value: 'full-width',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("6O6hD")))))
        }
    ];
    const $c35971a9d6d459fc$export$b978ceeb25a89f87 = {
        'wrap-left': (0, (0, parcelRequire("eX53M")).toolbarMessages).wrapLeft,
        center: (0, (0, parcelRequire("8DYpW")).default).alignImageCenter,
        'wrap-right': (0, (0, parcelRequire("eX53M")).toolbarMessages).wrapRight,
        wide: (0, (0, parcelRequire("8DYpW")).default).layoutWide,
        'full-width': (0, (0, parcelRequire("8DYpW")).default).layoutFullWidth,
        'align-end': (0, (0, parcelRequire("8DYpW")).default).alignImageRight,
        'align-start': (0, (0, parcelRequire("8DYpW")).default).alignImageLeft
    };
    const $c35971a9d6d459fc$var$getNodeWidth = (node, schema)=>{
        const { embedCard: embedCard } = schema.nodes;
        if (node.type === embedCard) return node.attrs.originalWidth || (0, (0, parcelRequire("iHYdz")).DEFAULT_EMBED_CARD_WIDTH);
        return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
    };
    const $c35971a9d6d459fc$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi)=>{
        return (state, dispatch)=>{
            const { node: node } = state.selection;
            const { layout: previousLayoutType } = node.attrs;
            const { mediaSingle: mediaSingle } = state.schema.nodes;
            if (!dispatch) return false;
            const widthPluginState = widthPluginDependencyApi?.sharedState.currentState();
            if (!node || node.type !== nodeType || !widthPluginState) return false;
            const nodeWidth = $c35971a9d6d459fc$var$getNodeWidth(node, state.schema);
            const newAttrs = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_media_extended_resize_experience') ? {
                ...node.attrs,
                layout: layout
            } : (0, (0, parcelRequire("cROsB")).alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
            const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, state.selection.from));
            const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
            if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, (0, parcelRequire("kxM7f")).insideTable)(state) || (0, (0, parcelRequire("594Yf")).isInLayoutColumn)(state))) {
                const emptyParaghraph = paragraph.createAndFill();
                if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
            }
            analyticsApi?.attachAnalyticsEvent({
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
                attributes: {
                    previousLayoutType: previousLayoutType,
                    currentLayoutType: layout
                }
            })(tr);
            dispatch(tr);
            return true;
        };
    };
    const $c35971a9d6d459fc$var$getToolbarLayout = (layout)=>{
        if ((0, (0, parcelRequire("cROsB")).nonWrappedLayouts).includes(layout) && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_media_extended_resize_experience')) return 'center';
        return layout;
    };
    const $c35971a9d6d459fc$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled)=>icons.map((toolbarItem)=>{
            const { id: id, value: value } = toolbarItem;
            return {
                id: id,
                type: 'button',
                icon: toolbarItem.icon,
                title: intl.formatMessage($c35971a9d6d459fc$export$b978ceeb25a89f87[value]),
                selected: $c35971a9d6d459fc$var$getToolbarLayout(layout) === value,
                onClick: $c35971a9d6d459fc$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi),
                ...isChangingLayoutDisabled && {
                    disabled: value !== 'center'
                }
            };
        });
    const $c35971a9d6d459fc$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
        return (0, $5r0mK.hasParentNodeOfType)([
            nodes.bodiedExtension,
            nodes.extensionFrame,
            nodes.listItem,
            nodes.expand,
            nodes.nestedExpand,
            ...allowResizingInTables ? [] : [
                nodes.table
            ]
        ].filter(Boolean))(selection);
    };
    const $c35971a9d6d459fc$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled)=>{
        const { selection: selection } = state;
        if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) || !selection.node || !nodeType || $c35971a9d6d459fc$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
        const { layout: layout } = selection.node.attrs;
        const alignmentToolbarItems = allowAlignment ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled) : [];
        const wrappingToolbarItems = allowWrapping ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled) : [];
        const breakOutToolbarItems = !allowResizing ? $c35971a9d6d459fc$var$mapIconsToToolbarItem($c35971a9d6d459fc$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi) : [];
        const items = [
            ...alignmentToolbarItems,
            ...$c35971a9d6d459fc$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
            ...wrappingToolbarItems,
            ...$c35971a9d6d459fc$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
            ...breakOutToolbarItems
        ];
        return items;
    };
    const $c35971a9d6d459fc$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
            {
                type: 'separator'
            }
        ] : [];
    const $c35971a9d6d459fc$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
            {
                type: 'separator'
            }
        ] : [];
    var $c35971a9d6d459fc$export$2e2bcd8739ae039 = $c35971a9d6d459fc$var$buildLayoutButtons;
});
parcelRegister("kYOHz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f460bd8e21607764$var$_react = $f460bd8e21607764$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f460bd8e21607764$var$_UNSAFE_baseNew = $f460bd8e21607764$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $f460bd8e21607764$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f460bd8e21607764$var$ContentAlignCenterIcon = (props)=>$f460bd8e21607764$var$_react.default.createElement($f460bd8e21607764$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-5.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $f460bd8e21607764$var$ContentAlignCenterIcon.displayName = 'ContentAlignCenterIcon';
    var $f460bd8e21607764$var$_default = module.exports.default = $f460bd8e21607764$var$ContentAlignCenterIcon;
});
parcelRegister("gW72a", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c54784e4e9f0507d$var$_react = $c54784e4e9f0507d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c54784e4e9f0507d$var$_UNSAFE_baseNew = $c54784e4e9f0507d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c54784e4e9f0507d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c54784e4e9f0507d$var$ContentAlignLeftIcon = (props)=>$c54784e4e9f0507d$var$_react.default.createElement($c54784e4e9f0507d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-9.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $c54784e4e9f0507d$var$ContentAlignLeftIcon.displayName = 'ContentAlignLeftIcon';
    var $c54784e4e9f0507d$var$_default = module.exports.default = $c54784e4e9f0507d$var$ContentAlignLeftIcon;
});
parcelRegister("jevkK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e007a15167be3bcc$var$_react = $e007a15167be3bcc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e007a15167be3bcc$var$_UNSAFE_baseNew = $e007a15167be3bcc$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e007a15167be3bcc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e007a15167be3bcc$var$ContentAlignRightIcon = (props)=>$e007a15167be3bcc$var$_react.default.createElement($e007a15167be3bcc$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14m-1.375-4h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $e007a15167be3bcc$var$ContentAlignRightIcon.displayName = 'ContentAlignRightIcon';
    var $e007a15167be3bcc$var$_default = module.exports.default = $e007a15167be3bcc$var$ContentAlignRightIcon;
});
parcelRegister("bOzuE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $899fe57c673eeeda$var$_react = $899fe57c673eeeda$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $899fe57c673eeeda$var$_UNSAFE_baseNew = $899fe57c673eeeda$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $899fe57c673eeeda$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $899fe57c673eeeda$var$ContentWrapLeftIcon = (props)=>$899fe57c673eeeda$var$_react.default.createElement($899fe57c673eeeda$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M9 5.917h6m-6 4.166h6m-9.375.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $899fe57c673eeeda$var$ContentWrapLeftIcon.displayName = 'ContentWrapLeftIcon';
    var $899fe57c673eeeda$var$_default = module.exports.default = $899fe57c673eeeda$var$ContentWrapLeftIcon;
});
parcelRegister("bOrM0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8999e86528425a2b$var$_react = $8999e86528425a2b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8999e86528425a2b$var$_UNSAFE_baseNew = $8999e86528425a2b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8999e86528425a2b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8999e86528425a2b$var$ContentWrapRightIcon = (props)=>$8999e86528425a2b$var$_react.default.createElement($8999e86528425a2b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 1.75h14M1 14.25h14M1 5.917h6m-6 4.166h6m6.625.167h-3.25a.625.625 0 0 1-.625-.625v-3.25c0-.345.28-.625.625-.625h3.25c.345 0 .625.28.625.625v3.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $8999e86528425a2b$var$ContentWrapRightIcon.displayName = 'ContentWrapRightIcon';
    var $8999e86528425a2b$var$_default = module.exports.default = $8999e86528425a2b$var$ContentWrapRightIcon;
});
parcelRegister("5VgMH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $44ff4babc14cbb00$var$_react = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $44ff4babc14cbb00$var$_contentAlignCenter = $44ff4babc14cbb00$var$_interopRequireDefault((parcelRequire("kYOHz")));
    function $44ff4babc14cbb00$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $44ff4babc14cbb00$var$EditorAlignImageCenterIcon = (props)=>$44ff4babc14cbb00$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m4-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
        }, props, {
            newIcon: $44ff4babc14cbb00$var$_contentAlignCenter.default
        }));
    $44ff4babc14cbb00$var$EditorAlignImageCenterIcon.displayName = 'EditorAlignImageCenterIcon';
    var $44ff4babc14cbb00$var$_default = module.exports.default = $44ff4babc14cbb00$var$EditorAlignImageCenterIcon;
});
parcelRegister("kTcZO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f353066a4e332113$var$_react = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f353066a4e332113$var$_contentAlignLeft = $f353066a4e332113$var$_interopRequireDefault((parcelRequire("gW72a")));
    function $f353066a4e332113$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f353066a4e332113$var$EditorAlignImageLeftIcon = (props)=>$f353066a4e332113$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
        }, props, {
            newIcon: $f353066a4e332113$var$_contentAlignLeft.default
        }));
    $f353066a4e332113$var$EditorAlignImageLeftIcon.displayName = 'EditorAlignImageLeftIcon';
    var $f353066a4e332113$var$_default = module.exports.default = $f353066a4e332113$var$EditorAlignImageLeftIcon;
});
parcelRegister("8io1i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $60a2a3064f7d899d$var$_react = $60a2a3064f7d899d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $60a2a3064f7d899d$var$_contentAlignRight = $60a2a3064f7d899d$var$_interopRequireDefault((parcelRequire("jevkK")));
    function $60a2a3064f7d899d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $60a2a3064f7d899d$var$EditorAlignImageRightIcon = (props)=>$60a2a3064f7d899d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
        }, props, {
            newIcon: $60a2a3064f7d899d$var$_contentAlignRight.default
        }));
    $60a2a3064f7d899d$var$EditorAlignImageRightIcon.displayName = 'EditorAlignImageRightIcon';
    var $60a2a3064f7d899d$var$_default = module.exports.default = $60a2a3064f7d899d$var$EditorAlignImageRightIcon;
});
parcelRegister("6O6hD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4f4c4952a2b7fd14$var$_react = $4f4c4952a2b7fd14$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $4f4c4952a2b7fd14$var$_expandHorizontal = $4f4c4952a2b7fd14$var$_interopRequireDefault((parcelRequire("3J0O7")));
    function $4f4c4952a2b7fd14$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon = (props)=>$4f4c4952a2b7fd14$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 17h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 5h16a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $4f4c4952a2b7fd14$var$_expandHorizontal.default
        }));
    $4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon.displayName = 'EditorMediaFullWidthIcon';
    var $4f4c4952a2b7fd14$var$_default = module.exports.default = $4f4c4952a2b7fd14$var$EditorMediaFullWidthIcon;
});
parcelRegister("3J0O7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2b66336789b54845$var$_react = $2b66336789b54845$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2b66336789b54845$var$_UNSAFE_baseNew = $2b66336789b54845$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $2b66336789b54845$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2b66336789b54845$var$ExpandHorizontalIcon = (props)=>$2b66336789b54845$var$_react.default.createElement($2b66336789b54845$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 1v14m14.5-14v14m-5.5-9.5 2.5 2.5-2.5 2.5m-3.5-5L3.75 8l2.5 2.5m5.5-2.5h-7.5"/>`
        }, props));
    $2b66336789b54845$var$ExpandHorizontalIcon.displayName = 'ExpandHorizontalIcon';
    var $2b66336789b54845$var$_default = module.exports.default = $2b66336789b54845$var$ExpandHorizontalIcon;
});
parcelRegister("3mjma", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $272270f58cbe6323$var$_react = $272270f58cbe6323$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $272270f58cbe6323$var$_contentWidthWide = $272270f58cbe6323$var$_interopRequireDefault((parcelRequire("gbQbY")));
    function $272270f58cbe6323$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $272270f58cbe6323$var$EditorMediaWideIcon = (props)=>$272270f58cbe6323$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 5h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m0 12h10a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $272270f58cbe6323$var$_contentWidthWide.default
        }));
    $272270f58cbe6323$var$EditorMediaWideIcon.displayName = 'EditorMediaWideIcon';
    var $272270f58cbe6323$var$_default = module.exports.default = $272270f58cbe6323$var$EditorMediaWideIcon;
});
parcelRegister("gbQbY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bc9628ac70864b44$var$_react = $bc9628ac70864b44$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $bc9628ac70864b44$var$_UNSAFE_baseNew = $bc9628ac70864b44$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $bc9628ac70864b44$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bc9628ac70864b44$var$ContentWidthWideIcon = (props)=>$bc9628ac70864b44$var$_react.default.createElement($bc9628ac70864b44$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M4 1.75h8m-8 12.5h8m2.625-3H1.375a.625.625 0 0 1-.625-.625v-5.25c0-.345.28-.625.625-.625h13.25c.345 0 .625.28.625.625v5.25c0 .345-.28.625-.625.625Z"/>`
        }, props));
    $bc9628ac70864b44$var$ContentWidthWideIcon.displayName = 'ContentWidthWideIcon';
    var $bc9628ac70864b44$var$_default = module.exports.default = $bc9628ac70864b44$var$ContentWidthWideIcon;
});
parcelRegister("5kpFL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3e12bc07395882cd$var$_react = $3e12bc07395882cd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $3e12bc07395882cd$var$_contentWrapLeft = $3e12bc07395882cd$var$_interopRequireDefault((parcelRequire("bOzuE")));
    function $3e12bc07395882cd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3e12bc07395882cd$var$EditorMediaWrapLeftIcon = (props)=>$3e12bc07395882cd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-8h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2h-4a1 1 0 0 1 0-2M6 9h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1m0-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
        }, props, {
            newIcon: $3e12bc07395882cd$var$_contentWrapLeft.default
        }));
    $3e12bc07395882cd$var$EditorMediaWrapLeftIcon.displayName = 'EditorMediaWrapLeftIcon';
    var $3e12bc07395882cd$var$_default = module.exports.default = $3e12bc07395882cd$var$EditorMediaWrapLeftIcon;
});
parcelRegister("kRhuK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f2f653ff638c33cd$var$_react = $f2f653ff638c33cd$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $f2f653ff638c33cd$var$_contentWrapRight = $f2f653ff638c33cd$var$_interopRequireDefault((parcelRequire("bOrM0")));
    function $f2f653ff638c33cd$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f2f653ff638c33cd$var$EditorMediaWrapRightIcon = (props)=>$f2f653ff638c33cd$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M6 17h12a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0-8h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m0 4h4a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2m8-4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1M6 5h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2"/></svg>`
        }, props, {
            newIcon: $f2f653ff638c33cd$var$_contentWrapRight.default
        }));
    $f2f653ff638c33cd$var$EditorMediaWrapRightIcon.displayName = 'EditorMediaWrapRightIcon';
    var $f2f653ff638c33cd$var$_default = module.exports.default = $f2f653ff638c33cd$var$EditorMediaWrapRightIcon;
});
parcelRegister("kxM7f", function(module, exports) {
    $parcel$export(module.exports, "insideTable", ()=>$1ccde135a1d20ec2$export$244bf4b32387ef62);
    var $5r0mK = parcelRequire("5r0mK");
    const $1ccde135a1d20ec2$export$244bf4b32387ef62 = (state)=>{
        const { table: table, tableCell: tableCell } = state.schema.nodes;
        return (0, $5r0mK.hasParentNodeOfType)([
            table,
            tableCell
        ])(state.selection);
    };
});
parcelRegister("lhLis", function(module, exports) {
    $parcel$export(module.exports, "isTextAtPos", ()=>$861122be5c19938d$export$8476280b1d47554d);
    $parcel$export(module.exports, "getLinkPreferencesURLFromENV", ()=>$861122be5c19938d$export$e5404273592f5dbd);
    var $kTK0a;
    function $861122be5c19938d$export$8476280b1d47554d(pos) {
        return ({ tr: tr })=>{
            const node = tr.doc.nodeAt(pos);
            return !!node && node.isText;
        };
    }
    function $861122be5c19938d$export$54fac2c1c66c48ae(pos) {
        return (state)=>{
            const node = state.doc.nodeAt(pos);
            return !!node && !!state.schema.marks.link.isInSet(node.marks);
        };
    }
    const $861122be5c19938d$export$e5404273592f5dbd = ()=>{
        return (0, (0, parcelRequire("kTK0a")).getATLContextUrl)('id') + (0, $0a1bd3f769db1d07$export$f0972e90f14682b1);
    };
});
const $0a1bd3f769db1d07$export$f0972e90f14682b1 = '/manage-profile/link-preferences';
parcelRegister("4IrpZ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $36f08a2f957bd6ab$var$_react = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $36f08a2f957bd6ab$var$_UNSAFE_baseNew = $36f08a2f957bd6ab$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $36f08a2f957bd6ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $36f08a2f957bd6ab$var$DeleteIcon = (props)=>$36f08a2f957bd6ab$var$_react.default.createElement($36f08a2f957bd6ab$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M12.75 3.25V14c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25V3.25m9.5 0h1.75m-1.75 0h-2.5m-7 0H1.5m1.75 0h2.5m0 0V.75h4.5v2.5m-4.5 0h4.5M6.5 5.5V13m3-7.5V13"/>`
        }, props));
    $36f08a2f957bd6ab$var$DeleteIcon.displayName = 'DeleteIcon';
    var $36f08a2f957bd6ab$var$_default = module.exports.default = $36f08a2f957bd6ab$var$DeleteIcon;
});
parcelRegister("90mMF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $68e5c989bea2984f$var$_UNSAFE_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $68e5c989bea2984f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>$68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.5 8-.75.75a3.182 3.182 0 0 0 4.5 4.5L8 12.5m0-9 .75-.75a3.182 3.182 0 0 1 4.5 4.5L12.5 8M5.25 1v3M1 5.25h3m11 5.5h-3M10.75 15v-3"/>`
        }, props));
    $68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
    var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;
});
parcelRegister("f5BqX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $afc45c3418436f46$var$_react = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $afc45c3418436f46$var$_delete = $afc45c3418436f46$var$_interopRequireDefault((parcelRequire("4IrpZ")));
    function $afc45c3418436f46$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $afc45c3418436f46$var$EditorRemoveIcon = (props)=>$afc45c3418436f46$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 7h10a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2m2.78 11a1 1 0 0 1-.97-.757L7.156 10.62A.5.5 0 0 1 7.64 10h8.72a.5.5 0 0 1 .485.621l-1.656 6.622a1 1 0 0 1-.97.757zM11 6h2a1 1 0 0 1 1 1h-4a1 1 0 0 1 1-1"/></svg>`
        }, props, {
            newIcon: $afc45c3418436f46$var$_delete.default
        }));
    $afc45c3418436f46$var$EditorRemoveIcon.displayName = 'EditorRemoveIcon';
    var $afc45c3418436f46$var$_default = module.exports.default = $afc45c3418436f46$var$EditorRemoveIcon;
});
parcelRegister("ik2d8", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d56bcf4208f0775d$var$_react = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d56bcf4208f0775d$var$_settings = $d56bcf4208f0775d$var$_interopRequireDefault((parcelRequire("epOG5")));
    function $d56bcf4208f0775d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d56bcf4208f0775d$var$EditorSettingsIcon = (props)=>$d56bcf4208f0775d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.002 15.504a3.502 3.502 0 1 1 0-7.004 3.502 3.502 0 0 1 0 7.004m6.732-1.987a1.605 1.605 0 0 1-.001-3.034.386.386 0 0 0 .253-.462 7.2 7.2 0 0 0-.672-1.604.384.384 0 0 0-.481-.156c-.31.127-.668.16-1.039.065a1.6 1.6 0 0 1-1.129-1.124 1.64 1.64 0 0 1 .061-1.043.385.385 0 0 0-.157-.48 7.2 7.2 0 0 0-1.59-.665.385.385 0 0 0-.461.252 1.604 1.604 0 0 1-3.032 0 .387.387 0 0 0-.463-.252c-.57.16-1.11.39-1.613.677a.38.38 0 0 0-.159.468 1.611 1.611 0 0 1-2.088 2.108.385.385 0 0 0-.479.158 7.2 7.2 0 0 0-.67 1.604.386.386 0 0 0 .248.46 1.605 1.605 0 0 1 0 3.021.385.385 0 0 0-.249.46c.143.504.34.986.582 1.44.096.179.318.24.502.156.479-.22 1.08-.213 1.693.191a.9.9 0 0 1 .243.242c.424.643.412 1.272.16 1.76a.38.38 0 0 0 .134.506 7.2 7.2 0 0 0 1.697.721.38.38 0 0 0 .459-.251A1.605 1.605 0 0 1 12 17.645c.707 0 1.302.457 1.518 1.09.066.19.265.306.459.251a7.2 7.2 0 0 0 1.677-.71.38.38 0 0 0 .134-.508c-.256-.49-.271-1.12.154-1.766a.9.9 0 0 1 .243-.243c.62-.411 1.228-.413 1.71-.185a.384.384 0 0 0 .505-.153q.367-.683.585-1.443a.385.385 0 0 0-.252-.461"/></svg>`
        }, props, {
            newIcon: $d56bcf4208f0775d$var$_settings.default
        }));
    $d56bcf4208f0775d$var$EditorSettingsIcon.displayName = 'EditorSettingsIcon';
    var $d56bcf4208f0775d$var$_default = module.exports.default = $d56bcf4208f0775d$var$EditorSettingsIcon;
});
parcelRegister("jdB85", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dfdc085c662fbaf1$var$_react = $dfdc085c662fbaf1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $dfdc085c662fbaf1$var$_linkBroken = $dfdc085c662fbaf1$var$_interopRequireDefault((parcelRequire("90mMF")));
    function $dfdc085c662fbaf1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dfdc085c662fbaf1$var$EditorUnlinkIcon = (props)=>$dfdc085c662fbaf1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M5 10V9h2v1zm4-5h1v2H9zm7.646 12.354.708-.708 2 2-.708.708zM17 15v-1h2v1zm-3 2h1v2h-1zM7.354 6.646l-.708.708-2-2 .708-.708zm3.567 9.037 1.061-1.062a.75.75 0 1 1 1.06 1.061l-1.06 1.061a3.25 3.25 0 0 1-4.596 0 3.247 3.247 0 0 1 0-4.596l1.06-1.061.703-.703c.793-.63 1.773.35 1.06 1.06l-.702.703-1.06 1.062a1.747 1.747 0 0 0 0 2.474 1.75 1.75 0 0 0 2.474 0m2.658-7.608-1.061 1.061a.75.75 0 0 1-1.06-1.06l1.06-1.062a3.25 3.25 0 0 1 4.596 0 3.247 3.247 0 0 1 0 4.596l-1.06 1.062-.703.702c-.565.565-1.581-.45-1.06-1.06l.702-.703 1.06-1.061a1.747 1.747 0 0 0 0-2.475 1.75 1.75 0 0 0-2.474 0"/></svg>`
        }, props, {
            newIcon: $dfdc085c662fbaf1$var$_linkBroken.default
        }));
    $dfdc085c662fbaf1$var$EditorUnlinkIcon.displayName = 'EditorUnlinkIcon';
    var $dfdc085c662fbaf1$var$_default = module.exports.default = $dfdc085c662fbaf1$var$EditorUnlinkIcon;
});
parcelRegister("fo6j3", function(module, exports) {
    $parcel$export(module.exports, "DatasourceAppearanceButton", ()=>$13e08b7c33400098$export$76de8066d79563a4);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $80CM7;
    var $e3WeH;
    var $3dBkm;
    var $gZGBX;
    var $3WO4v;
    var $kgoHi;
    var $jPiXc;
    var $lumM0;
    var $aKWRt;
    var $lFtel;
    var $dYS3B;
    function $13e08b7c33400098$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $13e08b7c33400098$var$buttonStyles = {
        name: "1quw0ni",
        styles: "pointer-events:auto"
    };
    const $13e08b7c33400098$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
        const { datasourceId: datasourceId, parameters: parameters } = (0, (0, parcelRequire("dYS3B")).useFetchDatasourceInfo)({
            isRegularCardNode: true,
            url: url,
            cardContext: cardContext
        });
        const onChangeAppearance = (0, $5uXOq.useCallback)(()=>{
            if (!editorView || !datasourceId || !parameters) return;
            const state = (0, (0, parcelRequire("lumM0")).pluginKey).getState(editorState);
            const newAdf = (0, (0, parcelRequire("3WO4v")).buildDatasourceAdf)({
                id: datasourceId,
                parameters: parameters,
                views: state?.datasourceStash[url]?.views ?? [
                    {
                        type: 'table'
                    }
                ]
            }, url);
            const { selection: selection } = editorState;
            let existingNode;
            const $pos = editorState.doc.resolve(selection.from);
            const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
            if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) existingNode = selection.node;
            else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
            if (existingNode) (0, (0, parcelRequire("jPiXc")).updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: editorView,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
        }, [
            parameters,
            datasourceId,
            inputMethod,
            editorState,
            editorView,
            url
        ]);
        if (!parameters || !datasourceId || !(0, (0, parcelRequire("3dBkm")).canRenderDatasource)(datasourceId)) return null;
        if (url) {
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return null;
        }
        const buttonLabel = intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).datasourceAppearanceTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
            css: $13e08b7c33400098$var$buttonStyles,
            title: buttonLabel,
            icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lFtel")).DatasourceIcon), {
                label: buttonLabel
            }),
            selected: selected,
            onClick: onChangeAppearance,
            testId: 'card-datasource-appearance-button'
        }));
    };
    const $13e08b7c33400098$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aKWRt")).CardContextProvider), null, ({ cardContext: cardContext })=>(0, (0, parcelRequire("f8Sb3")).jsx)($13e08b7c33400098$var$DatasourceAppearanceButtonWithCardContext, {
                url: url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                editorState: editorState,
                cardContext: cardContext,
                selected: selected,
                inputMethod: inputMethod
            }));
    };
});
parcelRegister("e3WeH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07b970e46d885591$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9yOBd;
    var $3bDjY;
    var $bvPiX;
    var $46YIs;
    var $5Y3eC;
    var $07b970e46d885591$export$2e2bcd8739ae039 = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, spotlightConfig: spotlightConfig })=>{
        const iconOnly = (icon || iconAfter) && !children;
        const customSpacing = iconOnly ? (0, (0, parcelRequire("5Y3eC")).iconOnlySpacing) : {};
        const isButtonPressed = ariaHasPopup ? undefined : selected;
        const ariaChecked = isRadioButton ? isButtonPressed : undefined;
        const ariaPressed = isRadioButton ? undefined : isButtonPressed;
        const [spotlightReferenceElement, setSpotlightReferenceElement] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            onMount?.();
            return ()=>onUnmount?.();
        }, []);
        const onSpotlightTargetClick = spotlightConfig?.isSpotlightOpen ? spotlightConfig?.onTargetClick : undefined;
        const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
            onSpotlightTargetClick?.();
            onClick?.(event);
        }, [
            onClick,
            onSpotlightTargetClick
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: tooltipContent || (iconOnly ? title : undefined),
            component: tooltipStyle,
            hideTooltipOnClick: hideTooltipOnClick,
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvPiX")).Pulse), {
            pulse: pulse || spotlightConfig?.pulse
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            className: className,
            ref: (buttonElement)=>setSpotlightReferenceElement(buttonElement),
            theme: (adgTheme, themeProps)=>{
                const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                return {
                    buttonStyles: {
                        ...buttonStyles,
                        ...customSpacing,
                        ...appearance === 'danger' && (0, (0, parcelRequire("5Y3eC")).getButtonStyles)({
                            appearance: appearance,
                            state: themeProps.state,
                            mode: themeProps.mode
                        })
                    },
                    ...rest
                };
            },
            "aria-label": ariaLabel || title,
            "aria-pressed": ariaPressed,
            "aria-checked": ariaChecked,
            role: isRadioButton ? 'radio' : undefined,
            "aria-expanded": ariaHasPopup ? selected : undefined,
            "aria-controls": ariaHasPopup ? areaControls : undefined,
            spacing: 'compact',
            href: href,
            target: target,
            appearance: appearance,
            "aria-haspopup": ariaHasPopup,
            iconBefore: icon || undefined,
            iconAfter: iconAfter,
            onClick: handleOnClick,
            onKeyDown: onKeyDown,
            isSelected: selected,
            isDisabled: disabled,
            testId: testId,
            onFocus: onFocus,
            onBlur: onBlur,
            tabIndex: tabIndex
        }, children)))), spotlightConfig?.isSpotlightOpen && spotlightReferenceElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("46YIs")).ButtonSpotlightCard), {
            referenceElement: spotlightReferenceElement,
            ...spotlightConfig.spotlightCardOptions
        }));
    };
});
parcelRegister("bvPiX", function(module, exports) {
    $parcel$export(module.exports, "Pulse", ()=>$aec212985ae99997$export$927d63e2511364c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $k6T4f;
    function $aec212985ae99997$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
        if (pulse) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k6T4f")).Pulse), {
            radius: radius,
            pulse: pulse ?? false
        }, children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    }
});
parcelRegister("46YIs", function(module, exports) {
    $parcel$export(module.exports, "ButtonSpotlightCard", ()=>$b3626800b48613e0$export$beb7ede7fcdf145c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5ujeO;
    var $4oNEb;
    const $b3626800b48613e0$export$beb7ede7fcdf145c = (props)=>{
        const { referenceElement: referenceElement, placement: placement = 'top-start', ...spotlightCardProps } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4oNEb")).Popper), {
            referenceElement: referenceElement,
            placement: placement,
            strategy: "absolute"
        }, ({ ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref,
                style: style
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), spotlightCardProps)));
    };
});
parcelRegister("5Y3eC", function(module, exports) {
    $parcel$export(module.exports, "iconOnlySpacing", ()=>$44f0337781655622$export$7d8cec9727d4e603);
    $parcel$export(module.exports, "getButtonStyles", ()=>$44f0337781655622$export$f98ea88a275be66c);
    const $44f0337781655622$export$7d8cec9727d4e603 = {
        '&&': {
            padding: '0px'
        },
        '& > span': {
            margin: '0px'
        }
    };
    const $44f0337781655622$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
        if (!property[appearance] || !property[appearance][state]) return 'initial';
        return property[appearance][state][mode];
    };
    const $44f0337781655622$var$background = {
        danger: {
            default: {
                light: 'inherit',
                dark: 'inherit'
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
                dark: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            },
            active: {
                light: "var(--ds-background-neutral-pressed, #091E424F)",
                dark: "var(--ds-background-neutral-pressed, #091E424F)"
            }
        }
    };
    const $44f0337781655622$var$color = {
        danger: {
            default: {
                light: "var(--ds-icon, #44546F)",
                dark: "var(--ds-icon, #44546F)"
            },
            hover: {
                light: "var(--ds-icon-danger, #C9372C)",
                dark: "var(--ds-icon-danger, #C9372C)"
            },
            active: {
                light: "var(--ds-icon-danger, #C9372C)",
                dark: "var(--ds-icon-danger, #C9372C)"
            }
        }
    };
    const $44f0337781655622$export$f98ea88a275be66c = (props)=>({
            background: $44f0337781655622$var$getStyles($44f0337781655622$var$background, props),
            color: $44f0337781655622$var$getStyles($44f0337781655622$var$color, props)
        });
});
parcelRegister("3WO4v", function(module, exports) {
    $parcel$export(module.exports, "buildDatasourceAdf", ()=>$a17c774a074a9eb4$export$1de3504963fc32f2);
    const $a17c774a074a9eb4$export$1de3504963fc32f2 = (datasource, url)=>{
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    };
});
parcelRegister("aKWRt", function(module, exports) {
    $parcel$export(module.exports, "CardContextProvider", ()=>$0503fa5ef948e451$export$185bd24441bdfc17);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    class $0503fa5ef948e451$export$185bd24441bdfc17 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        render() {
            const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card?.value : undefined;
            return this.props.children({
                cardContext: cardContext
            });
        }
    }
});
parcelRegister("lFtel", function(module, exports) {
    $parcel$export(module.exports, "DatasourceIcon", ()=>$7c0b395422f3053e$export$8819453811a57211);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $kgoHi;
    var $8CUq3;
    const $7c0b395422f3053e$var$IconDatasourceGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 2C0 0.89543 0.895431 0 2 0H13C14.1046 0 15 0.895431 15 2V13C15 14.1046 14.1046 15 13 15H2C0.89543 15 0 14.1046 0 13V2ZM5 6C5 5.44772 5.44772 5 6 5L12 5C12.5523 5 13 5.44772 13 6C13 6.55229 12.5523 7 12 7L6 7C5.44772 7 5 6.55228 5 6ZM6 8C5.44772 8 5 8.44771 5 9C5 9.55228 5.44772 10 6 10L12 10C12.5523 10 13 9.55229 13 9C13 8.44772 12.5523 8 12 8L6 8ZM5 12C5 11.4477 5.44772 11 6 11L12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13L6 13C5.44772 13 5 12.5523 5 12ZM3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7ZM5 3C5 2.44772 5.44772 2 6 2L12 2C12.5523 2 13 2.44772 13 3C13 3.55229 12.5523 4 12 4L6 4C5.44772 4 5 3.55228 5 3ZM3 4C3.55228 4 4 3.55228 4 3C4 2.44772 3.55228 2 3 2C2.44772 2 2 2.44772 2 3C2 3.55228 2.44772 4 3 4ZM4 9C4 9.55229 3.55228 10 3 10C2.44772 10 2 9.55229 2 9C2 8.44771 2.44772 8 3 8C3.55228 8 4 8.44771 4 9ZM3 13C3.55228 13 4 12.5523 4 12C4 11.4477 3.55228 11 3 11C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13Z",
            fill: 'currentColor'
        }));
    };
    const $7c0b395422f3053e$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.050',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'space.300',
        height: 'space.300'
    });
    const $7c0b395422f3053e$export$8819453811a57211 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $7c0b395422f3053e$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $7c0b395422f3053e$var$IconDatasourceGlyph,
            ...props
        }));
    };
});
parcelRegister("dYS3B", function(module, exports) {
    $parcel$export(module.exports, "useFetchDatasourceInfo", ()=>$2f2c2b9b4d154727$export$d01c44dffc996c80);
    var $5uXOq = parcelRequire("5uXOq");
    const $2f2c2b9b4d154727$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
        const [datasourceId, setDatasourceId] = (0, $5uXOq.useState)(undefined);
        const [parameters, setParameters] = (0, $5uXOq.useState)(nodeParameters);
        const [ready, setReady] = (0, $5uXOq.useState)(!isRegularCardNode);
        const [extensionKey, setExtensionKey] = (0, $5uXOq.useState)(undefined);
        (0, $5uXOq.useEffect)(()=>{
            const fetchDatasource = async ()=>{
                try {
                    if (!url || !cardContext) {
                        setReady(true);
                        return;
                    }
                    const response = await cardContext?.connections?.client?.fetchData(url);
                    const datasources = response && response.datasources || [];
                    setExtensionKey(response?.meta.key);
                    setDatasourceId(datasources[0]?.id);
                    setParameters(datasources[0]?.parameters);
                    setReady(true);
                } catch (e) {
                    setDatasourceId(undefined);
                    setParameters(undefined);
                    setExtensionKey(undefined);
                    setReady(true);
                }
            };
            if (isRegularCardNode) fetchDatasource();
        }, [
            isRegularCardNode,
            cardContext,
            url
        ]);
        return {
            datasourceId: datasourceId,
            parameters: parameters,
            ready: ready,
            extensionKey: extensionKey
        };
    };
});
parcelRegister("A2Kgl", function(module, exports) {
    $parcel$export(module.exports, "getEditLinkCallback", ()=>$82ac2de8b8cf9d08$export$c389e1daeae312a9);
    $parcel$export(module.exports, "buildEditLinkToolbar", ()=>$82ac2de8b8cf9d08$export$dec3901e38d4e7ff);
    $parcel$export(module.exports, "editLinkToolbarConfig", ()=>$82ac2de8b8cf9d08$export$acaefd190fd8ff4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $2iyV6;
    var $1ZWXY;
    var $e9EHa;
    var $jDuvE;
    var $gZGBX;
    var $nYpqR;
    var $jPiXc;
    var $89B6e;
    function $82ac2de8b8cf9d08$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9EHa")).HyperlinkAddToolbar), {
            linkPickerOptions: linkPickerOptions,
            onSubmit: onSubmit,
            displayText: displayText,
            displayUrl: displayUrl,
            providerFactory: providerFactory,
            view: view,
            onCancel: onCancel,
            invokeMethod: invokeMethod,
            lpLinkPicker: lpLinkPicker,
            onClose: onClose,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback
        });
    }
    class $82ac2de8b8cf9d08$export$3d21e16152ee408f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidUpdate(prevProps) {
            if (prevProps.node !== this.props.node) this.hideLinkToolbar();
        }
        componentWillUnmount() {
            this.hideLinkToolbar();
        }
        hideLinkToolbar() {
            const { view: view } = this.props;
            view.dispatch((0, (0, parcelRequire("nYpqR")).hideLinkToolbar)(view.state.tr));
        }
        render() {
            const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($82ac2de8b8cf9d08$export$a46cebff622c3cae, {
                view: view,
                linkPickerOptions: linkPickerOptions,
                providerFactory: providerFactory,
                displayUrl: url,
                displayText: text,
                invokeMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB,
                lpLinkPicker: lpLinkPicker,
                onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                    this.hideLinkToolbar();
                    if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
                },
                onEscapeCallback: (state, dispatch)=>{
                    const { tr: tr } = state;
                    (0, (0, parcelRequire("nYpqR")).hideLinkToolbar)(tr);
                    forceFocusSelector?.(`[aria-label="${(0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                    return false;
                },
                onClickAwayCallback: (state, dispatch)=>{
                    const { tr: tr } = state;
                    if (dispatch) {
                        dispatch(tr);
                        return true;
                    }
                    return false;
                }
            });
        }
    }
    const $82ac2de8b8cf9d08$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
            let type = 'hyperlink';
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) type = state.selection.node.type.name;
            if (dispatch) {
                const { tr: tr } = state;
                (0, (0, parcelRequire("nYpqR")).showLinkToolbar)(tr);
                editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).buildEditLinkPayload)(type))(tr);
                tr.setMeta('scrollIntoView', scrollIntoView);
                dispatch(tr);
                return true;
            }
            return false;
        };
    const $82ac2de8b8cf9d08$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
        return {
            type: 'custom',
            disableArrowNavigation: true,
            fallback: [],
            render: (view, idx)=>{
                if (!view || !providerFactory) return null;
                const displayInfo = (0, (0, parcelRequire("89B6e")).displayInfoForCard)(node, (0, (0, parcelRequire("89B6e")).findCardInfo)(view.state));
                return (0, ($parcel$interopDefault($5uXOq))).createElement($82ac2de8b8cf9d08$export$3d21e16152ee408f, {
                    key: idx,
                    view: view,
                    linkPickerOptions: linkPicker,
                    providerFactory: providerFactory,
                    url: displayInfo.url,
                    text: displayInfo.title || '',
                    node: node,
                    lpLinkPicker: lpLinkPicker,
                    forceFocusSelector: pluginInjectionApi?.floatingToolbar?.actions?.forceFocusSelector,
                    onSubmit: (newHref, newText, inputMethod, analytic)=>{
                        const urlChanged = newHref !== displayInfo.url;
                        const titleChanged = newText !== displayInfo.title;
                        if (titleChanged) return (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((0, (0, parcelRequire("jPiXc")).changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi?.analytics?.actions), {
                            action: (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED,
                            inputMethod: inputMethod,
                            sourceEvent: analytic
                        })(view.state, view.dispatch);
                        if (urlChanged) return (0, (0, parcelRequire("jPiXc")).updateCard)(newHref, analytic)(view.state, view.dispatch);
                    }
                });
            }
        };
    };
    const $82ac2de8b8cf9d08$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker)=>{
        return showLinkingToolbar ? {
            height: lpLinkPicker ? (0, $f96f1f7af2f8d3ca$export$c635b83728f81640) : (0, $f96f1f7af2f8d3ca$export$c04a5ad015d45447),
            width: (0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe),
            forcePlacement: true
        } : {};
    };
});
parcelRegister("e9EHa", function(module, exports) {
    $parcel$export(module.exports, "HyperlinkAddToolbar", ()=>$c59bf023ca553874$export$8be6a38cd66ace65);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $9Egzu;
    var $kaYiD;
    var $deZY5;
    const $c59bf023ca553874$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
            onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).MANUAL : (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TYPEAHEAD, analytic);
        };
    function $c59bf023ca553874$export$8be6a38cd66ace65({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Egzu")).WithProviders), {
            providers: [
                'activityProvider',
                'searchProvider'
            ],
            providerFactory: providerFactory,
            renderNode: ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
                if (lpLinkPicker) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kaYiD")).EditorLinkPicker), {
                    view: view,
                    invokeMethod: invokeMethod ?? inputMethod,
                    editorAppearance: editorAppearance,
                    ...linkPickerOptions,
                    url: displayUrl,
                    displayText: displayText,
                    onSubmit: $c59bf023ca553874$var$onSubmitInterface(onSubmit),
                    onCancel: onCancel,
                    onClose: onClose,
                    onEscapeCallback: onEscapeCallback,
                    onClickAwayCallback: onClickAwayCallback
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("deZY5")).default), {
                    activityProvider: activityProvider,
                    searchProvider: searchProvider,
                    onSubmit: onSubmit,
                    displayText: displayText,
                    displayUrl: displayUrl,
                    view: view,
                    onEscapeCallback: onEscapeCallback,
                    onClickAwayCallback: onClickAwayCallback,
                    inputMethod: inputMethod,
                    searchSessionId: searchSessionId,
                    timesViewed: timesViewed
                });
            }
        });
    }
});
parcelRegister("kaYiD", function(module, exports) {
    $parcel$export(module.exports, "EditorLinkPicker", ()=>$f58dd7c55235c63c$export$da2f76555f5c8d0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $daJ0i;
    var $bYgrr;
    var $4NUlu;
    var $7VeJI;
    const $f58dd7c55235c63c$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
        const onCloseRef = (0, $5uXOq.useRef)(onClose);
        (0, $5uXOq.useEffect)(()=>{
            onCloseRef.current = onClose;
        });
        (0, $5uXOq.useEffect)(()=>()=>onCloseRef.current?.(), []);
        const onEscape = (0, $5uXOq.useCallback)(()=>{
            const { state: state, dispatch: dispatch } = view;
            onEscapeCallback?.(state, dispatch);
            onCancel?.();
        }, [
            view,
            onCancel,
            onEscapeCallback
        ]);
        const onClickAway = (0, $5uXOq.useCallback)(()=>{
            const { state: state, dispatch: dispatch } = view;
            onClickAwayCallback?.(state, dispatch);
            onCancel?.();
        }, [
            view,
            onCancel,
            onClickAwayCallback
        ]);
        const ref = (0, (0, parcelRequire("7VeJI")).useEscapeClickaway)(onEscape, onClickAway);
        const analyticsEditorAppearance = (0, (0, parcelRequire("4NUlu")).getAnalyticsEditorAppearance)(editorAppearance);
        const analyticsData = (0, $5uXOq.useMemo)(()=>({
                attributes: {
                    invokeMethod: invokeMethod,
                    location: analyticsEditorAppearance
                },
                location: analyticsEditorAppearance
            }), [
            invokeMethod,
            analyticsEditorAppearance
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
            data: analyticsData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYgrr")).default), {
            ...restProps,
            onCancel: onEscape
        })));
    };
});
parcelRegister("bYgrr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$292e4b24cbca310f$export$2e2bcd8739ae039);
    var $kc9vJ = parcelRequire("kc9vJ");
    var $1WP7T;
    const $292e4b24cbca310f$var$LazyLinkPickerComponent = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("5AY2x")).then(({ LinkPicker: LinkPicker })=>({
                default: LinkPicker
            })));
    var $292e4b24cbca310f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("1WP7T")).composeLinkPicker)($292e4b24cbca310f$var$LazyLinkPickerComponent);
});
parcelRegister("1WP7T", function(module, exports) {
    $parcel$export(module.exports, "composeLinkPicker", ()=>$4f4b692e16311c64$export$922eb685ceb4a294);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $kc9vJ = parcelRequire("kc9vJ");
    var $daJ0i;
    var $4tvHl;
    var $6MmH3;
    var $bs2KT;
    var $1tHfS;
    function $4f4b692e16311c64$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4f4b692e16311c64$export$800daf5fbbe96aff = {
        linkPickerRoot: 'link-picker-root'
    };
    const $4f4b692e16311c64$export$a2495bb1f182689d = {
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        componentName: (0, $27f53d4100568677$export$fc44104665f4d1e5),
        source: (0, $27f53d4100568677$export$fc44104665f4d1e5)
    };
    const $4f4b692e16311c64$var$DefaultRootComponent = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
    };
    const $4f4b692e16311c64$var$fixedWidthContainerStyles = {
        name: "xpqp5e",
        styles: "width:var(--link-picker-width)"
    };
    const $4f4b692e16311c64$var$FixedWidthContainer = (props)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $4f4b692e16311c64$var$fixedWidthContainerStyles,
            ...props
        });
    };
    const $4f4b692e16311c64$export$922eb685ceb4a294 = (Component)=>{
        return (0, $5uXOq.memo)((props)=>{
            const { component: component } = props;
            const RootComponent = component ?? $4f4b692e16311c64$var$DefaultRootComponent;
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("daJ0i")).default), {
                data: $4f4b692e16311c64$export$a2495bb1f182689d
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4tvHl")).LinkPickerSessionProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1tHfS")).MessagesProvider), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                style: {
                    ['--link-picker-width']: props.disableWidth ? '100%' : `${0, $27f53d4100568677$export$bf31a09f182d5584}px`,
                    ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                    ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                    ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                    ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
                }
            }, (0, (0, parcelRequire("f8Sb3")).jsx)($4f4b692e16311c64$var$FixedWidthContainer, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6MmH3")).ErrorBoundary), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $kc9vJ.LazySuspense), {
                fallback: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bs2KT")).LoaderFallback), {
                    url: props.url,
                    hideDisplayText: props.hideDisplayText,
                    isLoadingPlugins: props.isLoadingPlugins,
                    plugins: props.plugins
                })
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(RootComponent, {
                ...props,
                "data-testid": $4f4b692e16311c64$export$800daf5fbbe96aff.linkPickerRoot
            }, (0, (0, parcelRequire("f8Sb3")).jsx)(Component, props)))))))));
        });
    };
});
const $27f53d4100568677$export$85183a312807388d = 'media';
const $27f53d4100568677$export$fc44104665f4d1e5 = 'linkPicker';
const $27f53d4100568677$export$452f1062ecf44be7 = 5;
const $27f53d4100568677$export$bf31a09f182d5584 = 342;
const $27f53d4100568677$export$542fb16962bf430c = '290px';
parcelRegister("4tvHl", function(module, exports) {
    $parcel$export(module.exports, "LinkPickerSessionProvider", ()=>$2694ae59f2d43701$export$2f19832fd2d620ca);
    $parcel$export(module.exports, "useLinkPickerSessionId", ()=>$2694ae59f2d43701$export$36ecc935abdc3636);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $gmGSi;
    const $2694ae59f2d43701$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
    const $2694ae59f2d43701$export$3285420c698bc605 = (0, $5uXOq.createContext)($2694ae59f2d43701$export$c07727f5eddb98f);
    const $2694ae59f2d43701$var$useConstructor = (callback)=>{
        const hasBeenFired = (0, $5uXOq.useRef)(false);
        if (!hasBeenFired.current) {
            callback();
            hasBeenFired.current = true;
        }
        return null;
    };
    const $2694ae59f2d43701$export$2f19832fd2d620ca = ({ children: children })=>{
        const { current: sessionId } = (0, $5uXOq.useRef)((0, $7Jxgt.v4)());
        (0, $5uXOq.useEffect)(()=>{
            return ()=>(0, (0, parcelRequire("gmGSi")).abortUfoExperience)((0, (0, parcelRequire("gmGSi")).ufoExperience).mounted, sessionId);
        }, [
            sessionId
        ]);
        $2694ae59f2d43701$var$useConstructor(()=>(0, (0, parcelRequire("gmGSi")).startUfoExperience)((0, (0, parcelRequire("gmGSi")).ufoExperience).mounted, sessionId));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2694ae59f2d43701$export$3285420c698bc605.Provider, {
            value: sessionId
        }, children);
    };
    const $2694ae59f2d43701$export$36ecc935abdc3636 = ()=>(0, $5uXOq.useContext)($2694ae59f2d43701$export$3285420c698bc605);
});
parcelRegister("gmGSi", function(module, exports) {
    $parcel$export(module.exports, "ufoExperience", ()=>$0befcde02902b9dd$export$f9c7780c574346a2);
    $parcel$export(module.exports, "startUfoExperience", ()=>$0befcde02902b9dd$export$5e9287b6a10f8075);
    $parcel$export(module.exports, "succeedUfoExperience", ()=>$0befcde02902b9dd$export$c5a5cf072c836c0e);
    $parcel$export(module.exports, "failUfoExperience", ()=>$0befcde02902b9dd$export$8dda83bafca11b77);
    $parcel$export(module.exports, "abortUfoExperience", ()=>$0befcde02902b9dd$export$b1021040eb94cdca);
    var $cBycP;
    var $7Zbvr;
    const $0befcde02902b9dd$export$f9c7780c574346a2 = {
        mounted: 'component-mounted'
    };
    const $0befcde02902b9dd$var$ufoExperiences = {
        [$0befcde02902b9dd$export$f9c7780c574346a2.mounted]: new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)($0befcde02902b9dd$export$f9c7780c574346a2.mounted, {
            type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
            performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad,
            platform: {
                component: 'link-picker'
            }
        })
    };
    const $0befcde02902b9dd$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
        const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
        experience.start();
        if (metadata) experience.addMetadata(metadata);
    };
    const $0befcde02902b9dd$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
        const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
        experience.success({
            metadata: metadata
        });
    };
    const $0befcde02902b9dd$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
        const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
        experience.failure({
            metadata: metadata
        });
    };
    const $0befcde02902b9dd$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
        const experience = $0befcde02902b9dd$var$ufoExperiences[experienceName].getInstance(id);
        experience.abort({
            metadata: metadata
        });
    };
});
parcelRegister("6MmH3", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$a31421eb288e6506$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $gmGSi;
    var $eTwyk;
    var $4tvHl;
    var $eOoN4;
    var $iUFh3;
    function $a31421eb288e6506$export$e926676385687eaf({ children: children }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const linkPickerSessionId = (0, (0, parcelRequire("4tvHl")).useLinkPickerSessionId)();
        const handleError = (0, $5uXOq.useCallback)((error, info)=>{
            createAnalyticsEvent((0, (0, parcelRequire("eTwyk")).default)('ui.linkPicker.unhandledErrorCaught', {
                browserInfo: window?.navigator?.userAgent || 'unknown',
                error: error.toString(),
                componentStack: info?.componentStack ?? ''
            })).fire((0, $27f53d4100568677$export$85183a312807388d));
            (0, (0, parcelRequire("gmGSi")).failUfoExperience)((0, (0, parcelRequire("gmGSi")).ufoExperience).mounted, linkPickerSessionId);
        }, [
            createAnalyticsEvent,
            linkPickerSessionId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eOoN4")).BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, (0, parcelRequire("iUFh3")).ErrorBoundaryFallback)
        }, children);
    }
});
parcelRegister("eTwyk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$221eef4bea14ce3e$export$2e2bcd8739ae039);
    function $221eef4bea14ce3e$var$createEventPayload(eventKey, attributes) {
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            action: action,
            attributes: attributes
        };
    }
    var $221eef4bea14ce3e$export$2e2bcd8739ae039 = $221eef4bea14ce3e$var$createEventPayload;
});
parcelRegister("eOoN4", function(module, exports) {
    $parcel$export(module.exports, "BaseErrorBoundary", ()=>$93e98841d934b802$export$688779ac61ee945f);
    var $5uXOq = parcelRequire("5uXOq");
    class $93e98841d934b802$export$688779ac61ee945f extends (0, $5uXOq.Component) {
        constructor(props){
            super(props);
            this.state = {
                hasError: false
            };
        }
        componentDidCatch(error, info) {
            const { onError: onError } = this.props;
            onError && onError(error, info);
            this.setState({
                hasError: true
            });
        }
        render() {
            const { children: children, ErrorComponent: ErrorComponent } = this.props;
            const { hasError: hasError } = this.state;
            if (hasError && ErrorComponent) return (0, ($parcel$interopDefault($5uXOq))).createElement(ErrorComponent, null);
            return children;
        }
    }
});
parcelRegister("iUFh3", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryFallback", ()=>$1632729b10cbec8f$export$8a28b7e38e4685dd);
    var $f8Sb3;
    var $7VHMR;
    var $koVbs;
    var $czNpL;
    var $1aIRG;
    var $7OUbW;
    function $1632729b10cbec8f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $1632729b10cbec8f$var$errorBoundaryFallbackStyles = {
        name: "hwawmg",
        styles: "line-height:initial"
    };
    const $1632729b10cbec8f$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            defaultMessage: 'Something went wrong!',
            description: 'Heading displayed when an unhandled error occurs.',
            id: 'fabric.linkPicker.unhandledError.heading'
        },
        description: {
            defaultMessage: 'Try reloading the page.',
            description: 'Body message shown underneath the heading when an unhandled error occurs.',
            id: 'fabric.linkPicker.unhandledError.description'
        }
    });
    const $1632729b10cbec8f$export$8a28b7e38e4685dd = ()=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const header = intl.formatMessage($1632729b10cbec8f$var$messages.heading);
        const description = intl.formatMessage($1632729b10cbec8f$var$messages.description);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7OUbW")).MinHeightContainer), {
            css: $1632729b10cbec8f$var$errorBoundaryFallbackStyles,
            minHeight: (0, $27f53d4100568677$export$542fb16962bf430c),
            "data-testid": "link-picker-root-error-boundary-ui"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1aIRG")).EmptyState), {
            header: header,
            renderImage: ()=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("czNpL")).GenericErrorSVG), null),
            description: description
        }));
    };
});
parcelRegister("czNpL", function(module, exports) {
    $parcel$export(module.exports, "GenericErrorSVG", ()=>$7540c2e2574c2930$export$e54420a1a27457a4);
    var $f8Sb3;
    const $7540c2e2574c2930$var$HEIGHT = 90;
    const $7540c2e2574c2930$var$genericErrorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: `${$7540c2e2574c2930$var$HEIGHT}px`,
        display: 'block'
    });
    const $7540c2e2574c2930$export$e54420a1a27457a4 = (props)=>{
        const id = 'link-picker-ui-generic-error-svg';
        return (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: "90",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            css: $7540c2e2574c2930$var$genericErrorStyles,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
            fill: `url(#${id})`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            opacity: ".6",
            d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
            fill: "#C1C7D0"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            opacity: ".6",
            d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
            fill: "#B3BAC5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("defs", null, (0, (0, parcelRequire("f8Sb3")).jsx)("linearGradient", {
            id: id,
            x1: "26.169",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            stopColor: "#C1C7D0"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: ".297",
            stopColor: "#C6CBD4",
            stopOpacity: ".881"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: ".63",
            stopColor: "#D3D7DE",
            stopOpacity: ".748"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: ".98",
            stopColor: "#E9EBEF",
            stopOpacity: ".608"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: ".6"
        }))));
    };
});
parcelRegister("1aIRG", function(module, exports) {
    $parcel$export(module.exports, "EmptyState", ()=>$07ecb85b552d1f4c$export$fddf379e22a74b00);
    var $5uXOq = parcelRequire("5uXOq");
    var $l1N8i;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    const $07ecb85b552d1f4c$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBlockStart: 'space.600',
        marginBlockEnd: 'space.600',
        textAlign: 'center'
    });
    const $07ecb85b552d1f4c$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $07ecb85b552d1f4c$var$containerStyles,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.300"
        }, renderImage?.(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium"
        }, header), description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            color: "color.text"
        }, description)));
    };
});
parcelRegister("7OUbW", function(module, exports) {
    $parcel$export(module.exports, "MinHeightContainer", ()=>$0aea99783ced9613$export$42134e2a251518b3);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2CZ8n;
    const $0aea99783ced9613$export$42134e2a251518b3 = (0, $5uXOq.forwardRef)(({ minHeight: minHeight, ...props }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: (0, (0, parcelRequire("2CZ8n")).minHeightComponentStyles),
            ...props,
            style: {
                ['--link-picker-min-height']: minHeight
            }
        });
    });
});
parcelRegister("2CZ8n", function(module, exports) {
    $parcel$export(module.exports, "minHeightComponentStyles", ()=>$dd2e83f1e374fda8$export$7fd7f41da1fd5465);
    function $dd2e83f1e374fda8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dd2e83f1e374fda8$export$7fd7f41da1fd5465 = {
        name: "1y4cg6l",
        styles: "display:flex;align-items:stretch;justify-content:center;min-height:var(--link-picker-min-height)"
    };
});
parcelRegister("bs2KT", function(module, exports) {
    $parcel$export(module.exports, "LoaderFallback", ()=>$e4be65be0752e81a$export$d96e921133238c41);
    var $f8Sb3;
    var $eZJjh;
    var $7OUbW;
    function $e4be65be0752e81a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e4be65be0752e81a$var$styles = {
        name: "1h3rtzg",
        styles: "align-items:center"
    };
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '472px';
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '550px';
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '505px';
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '429px';
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '218px';
    const $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '141px';
    const $e4be65be0752e81a$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
        if (!url) {
            if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
            if (plugins?.length === 1) return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
        }
        return hideDisplayText ? $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $e4be65be0752e81a$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
    };
    const $e4be65be0752e81a$export$d96e921133238c41 = (props)=>{
        const minHeight = $e4be65be0752e81a$var$getEstimatedMinHeight(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7OUbW")).MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            css: $e4be65be0752e81a$var$styles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: props.name || 'link-picker-loading',
            size: "medium"
        }));
    };
});
parcelRegister("1tHfS", function(module, exports) {
    $parcel$export(module.exports, "MessagesProvider", ()=>$cfc46959224b6657$export$54320b51a950d54a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kAHGP;
    const $cfc46959224b6657$export$54320b51a950d54a = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kAHGP")).LazyMessagesProvider), null, children);
    };
});
parcelRegister("kAHGP", function(module, exports) {
    $parcel$export(module.exports, "LazyMessagesProvider", ()=>$0b8930421407a29b$export$d013d33430f9fb4b);
    var $5uXOq = parcelRequire("5uXOq");
    var $96nTn;
    var $6JvbH;
    var $9qeGT;
    const $0b8930421407a29b$export$d013d33430f9fb4b = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("96nTn")).default), {
            defaultMessages: (0, (0, parcelRequire("6JvbH")).default),
            loaderFn: (0, (0, parcelRequire("9qeGT")).fetchMessagesForLocale)
        }, children);
    };
});
parcelRegister("96nTn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a12211dcade02141$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $1LSM6;
    var $gOOK6;
    function $a12211dcade02141$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
        const intl = (0, (0, parcelRequire("gOOK6")).useSafeIntl)();
        const messages = (0, (0, parcelRequire("1LSM6")).useMessages)(intl.locale, loaderFn);
        const mergedMessages = (0, $5uXOq.useMemo)(()=>{
            return {
                ...defaultMessages,
                ...intl.messages,
                ...messages
            };
        }, [
            intl,
            messages,
            defaultMessages
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
    }
});
parcelRegister("1LSM6", function(module, exports) {
    $parcel$export(module.exports, "useMessages", ()=>$8b0c0f17bd7df50e$export$4d17e2d9c5348842);
    var $5uXOq = parcelRequire("5uXOq");
    var $mqPQ8;
    const $8b0c0f17bd7df50e$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
        const [localeState, setLocaleState] = (0, $5uXOq.useState)((0, (0, parcelRequire("mqPQ8")).DEFAULT_LOCALE_STATE));
        (0, $5uXOq.useEffect)(()=>{
            if (!localeState.messages || locale !== localeState.locale) {
                let current = true;
                loaderFn(locale).then((messages)=>{
                    if (current) setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                });
                return ()=>{
                    current = false;
                };
            }
        }, [
            loaderFn,
            locale,
            localeState
        ]);
        return localeState.messages;
    };
});
parcelRegister("mqPQ8", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LOCALE_STATE", ()=>$ca64c7c64c62f0c7$export$79618bef82c02d4c);
    const $ca64c7c64c62f0c7$export$79618bef82c02d4c = {
        locale: 'en',
        messages: {}
    };
});
parcelRegister("gOOK6", function(module, exports) {
    $parcel$export(module.exports, "useSafeIntl", ()=>$75954c8addb89719$export$f752ac21ea3960a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $hTtGr;
    var $8RXs9;
    var $mqPQ8;
    const $75954c8addb89719$var$cache = (0, (0, parcelRequire("hTtGr")).createIntlCache)();
    const $75954c8addb89719$export$f752ac21ea3960a5 = ()=>{
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("8RXs9")).Context));
        if (!context) return (0, (0, parcelRequire("i5FdW")).createIntl)((0, (0, parcelRequire("mqPQ8")).DEFAULT_LOCALE_STATE), $75954c8addb89719$var$cache);
        return context;
    };
});
parcelRegister("6JvbH", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$e60a6ae0bcd067f5$export$2e2bcd8739ae039);
    var $e60a6ae0bcd067f5$export$2e2bcd8739ae039 = {
        'fabric.linkPicker.button.cancel': 'Cancel',
        'fabric.linkPicker.button.insert': 'Insert',
        'fabric.linkPicker.button.save': 'Save',
        'fabric.linkPicker.clearLink': 'Clear',
        'fabric.linkPicker.clearLinkText': 'Clear text',
        'fabric.linkPicker.hyperlink.searchLinkResults': '{count, plural, =0 {no results} one {# result} other {# results}} found',
        'fabric.linkPicker.linkAriaLabel': 'Type or paste a link into the field',
        'fabric.linkPicker.linkInvalid': 'Enter a valid URL.',
        'fabric.linkPicker.linkLabel': 'Link',
        'fabric.linkPicker.linkPlaceholder': 'Paste a link',
        'fabric.linkPicker.linkTextAriaLabel': 'Link display text',
        'fabric.linkPicker.linkTextLabel': 'Display text (optional)',
        'fabric.linkPicker.linkTextPlaceholder': 'Text to display',
        'fabric.linkPicker.listTitle.recentlyViewed': 'Recently Viewed',
        'fabric.linkPicker.listTitle.results': 'Results',
        'fabric.linkPicker.search.error.description': 'Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.',
        'fabric.linkPicker.search.error.heading': "We\u2019re having trouble loading data.",
        'fabric.linkPicker.search.linkAriaLabel': 'Suggestions will appear below as you type into the field',
        'fabric.linkPicker.search.linkLabel': 'Search or paste a link',
        'fabric.linkPicker.search.linkPlaceholder': 'Find recent links or paste a new link',
        'fabric.linkPicker.search.noResults.description': 'Try again with a different term.',
        'fabric.linkPicker.search.noResults.heading': "We couldn\u2019t find anything matching your search.",
        'fabric.linkPicker.status.submitting': 'Submitting',
        'fabric.linkPicker.time.message.updated': 'Updated {time}',
        'fabric.linkPicker.time.message.viewed': 'Viewed {time}',
        'fabric.linkPicker.unhandledError.description': 'Try reloading the page.',
        'fabric.linkPicker.unhandledError.heading': 'Something went wrong!',
        foo: 'Default string'
    };
});
parcelRegister("9qeGT", function(module, exports) {
    $parcel$export(module.exports, "fetchMessagesForLocale", ()=>$1b4e714d67ee4b58$export$2b153a2030b0feb2);
    var $82GLV;
    const $1b4e714d67ee4b58$export$2b153a2030b0feb2 = async (locale)=>{
        try {
            const localeKey = locale.replace('-', '_');
            if (localeKey in (0, (0, parcelRequire("82GLV")).locales)) {
                const messages = await (0, (0, parcelRequire("82GLV")).locales)[localeKey]();
                return messages.default;
            }
        } catch (e) {}
        try {
            const parentLocale = locale.split(/[-_]/)[0];
            if (parentLocale in (0, (0, parcelRequire("82GLV")).locales)) {
                const messages = await (0, (0, parcelRequire("82GLV")).locales)[parentLocale]();
                return messages.default;
            }
        } catch (e) {}
    };
});
parcelRegister("82GLV", function(module, exports) {
    $parcel$export(module.exports, "locales", ()=>$4eb6bd651e0fd6dc$export$df1c34db1371eeed);
    const $4eb6bd651e0fd6dc$export$df1c34db1371eeed = {
        cs: ()=>(parcelRequire("9jCVe")),
        da: ()=>(parcelRequire("6CL4f")),
        de: ()=>(parcelRequire("aE96s")),
        en_GB: ()=>(parcelRequire("fA0hM")),
        en_ZZ: ()=>(parcelRequire("d5urr")),
        en: ()=>Promise.resolve((parcelRequire("6JvbH"))),
        es: ()=>(parcelRequire("hlaF5")),
        fi: ()=>(parcelRequire("2Re8t")),
        fr: ()=>(parcelRequire("5YSeD")),
        hu: ()=>(parcelRequire("jdKyO")),
        it: ()=>(parcelRequire("iaKnP")),
        ja: ()=>(parcelRequire("eSRpO")),
        ko: ()=>(parcelRequire("59BB7")),
        nb: ()=>(parcelRequire("1jVhS")),
        nl: ()=>(parcelRequire("kt31c")),
        pl: ()=>(parcelRequire("e8uOL")),
        pt_BR: ()=>(parcelRequire("l3v5u")),
        ru: ()=>(parcelRequire("1Y3An")),
        sv: ()=>(parcelRequire("8DYLB")),
        th: ()=>(parcelRequire("1Hh09")),
        tr: ()=>(parcelRequire("koBpU")),
        uk: ()=>(parcelRequire("7ZFD7")),
        vi: ()=>(parcelRequire("c64sO")),
        zh_TW: ()=>(parcelRequire("kwcIJ")),
        zh: ()=>(parcelRequire("iMVdD"))
    };
});
parcelRegister("9jCVe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ktE9k").then(()=>parcelRequire('hxTpR'));
});
parcelRegister("6CL4f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dNxhW").then(()=>parcelRequire('6zDV7'));
});
parcelRegister("aE96s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cpXoW").then(()=>parcelRequire('3pHpm'));
});
parcelRegister("fA0hM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6cfDM").then(()=>parcelRequire('lV04b'));
});
parcelRegister("d5urr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5ywKM").then(()=>parcelRequire('khAmU'));
});
parcelRegister("hlaF5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1jdJx").then(()=>parcelRequire('8GUOz'));
});
parcelRegister("2Re8t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8FJst").then(()=>parcelRequire('4QluW'));
});
parcelRegister("5YSeD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iW8Tl").then(()=>parcelRequire('hLNj0'));
});
parcelRegister("jdKyO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7bcon").then(()=>parcelRequire('8XZGW'));
});
parcelRegister("iaKnP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("547YV").then(()=>parcelRequire('ibOo1'));
});
parcelRegister("eSRpO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lChBR").then(()=>parcelRequire('eHx02'));
});
parcelRegister("59BB7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2cNE1").then(()=>parcelRequire('bjfCW'));
});
parcelRegister("1jVhS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("MvKo8").then(()=>parcelRequire('86hzk'));
});
parcelRegister("kt31c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("UE0Lj").then(()=>parcelRequire('bpOU2'));
});
parcelRegister("e8uOL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bxAVQ").then(()=>parcelRequire('9B1xP'));
});
parcelRegister("l3v5u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("84O3i").then(()=>parcelRequire('iOkVk'));
});
parcelRegister("1Y3An", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hb9rK").then(()=>parcelRequire('84wGJ'));
});
parcelRegister("8DYLB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e3bmB").then(()=>parcelRequire('9U5fj'));
});
parcelRegister("1Hh09", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8RFZM").then(()=>parcelRequire('eAdVI'));
});
parcelRegister("koBpU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1U6At").then(()=>parcelRequire('gb3Xv'));
});
parcelRegister("7ZFD7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93k58").then(()=>parcelRequire('933Ox'));
});
parcelRegister("c64sO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kTZs1").then(()=>parcelRequire('hQPuK'));
});
parcelRegister("kwcIJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9LWeN").then(()=>parcelRequire('9nhwi'));
});
parcelRegister("iMVdD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("c3z4T").then(()=>parcelRequire('s579P'));
});
parcelRegister("5AY2x", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7Ck1y")
    ]).then(()=>parcelRequire('5UISO'));
});
parcelRegister("7VeJI", function(module, exports) {
    $parcel$export(module.exports, "useEscapeClickaway", ()=>$5979b99f85d0423a$export$886f2fdec3f419af);
    var $5uXOq = parcelRequire("5uXOq");
    const $5979b99f85d0423a$export$886f2fdec3f419af = (onEscape, onClickAway)=>{
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            const handleClickAway = (event)=>{
                const el = ref.current;
                if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
            };
            const handleKeydown = (event)=>{
                if (event.key === 'Escape') {
                    event.preventDefault();
                    onEscape();
                }
            };
            document.addEventListener('mousedown', handleClickAway);
            document.addEventListener('keydown', handleKeydown);
            return ()=>{
                document.removeEventListener('mousedown', handleClickAway);
                document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            onClickAway,
            onEscape
        ]);
        return ref;
    };
});
parcelRegister("deZY5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a78ad29594c2c22f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lFKmC = parcelRequire("lFKmC");
    var $7nsd3 = parcelRequire("7nsd3");
    var $7VHMR;
    var $8RXs9;
    var $iZOJ9;
    var $cb25w;
    var $dSQQ7;
    var $d5Zn3;
    var $5ILhZ;
    var $8CUq3;
    var $3bDjY;
    var $gkwXh;
    var $ctLRZ;
    var $ldHK3;
    var $g7oRE;
    var $gE8f9;
    var $dPSMN;
    var $lnN1k;
    var $iPN39;
    var $kEtKd;
    var $3lb3A;
    function $a78ad29594c2c22f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a78ad29594c2c22f$export$8dd524ceb40e3d16 = {
        name: "19nbz8q",
        styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
    };
    const $a78ad29594c2c22f$export$452f1062ecf44be7 = 5;
    const $a78ad29594c2c22f$var$clearTextButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.0',
        marginRight: 'space.100',
        backgroundColor: 'color.background.neutral.subtle',
        border: 'none'
    });
    const $a78ad29594c2c22f$var$clearTextWrapper = {
        name: "154v9b4",
        styles: "position:absolute;right:0"
    };
    const $a78ad29594c2c22f$var$containerPadding = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
    });
    const $a78ad29594c2c22f$var$textLabelMargin = {
        name: "1s21os8",
        styles: "margin-top:var(--ds-space-150, 12px)"
    };
    const $a78ad29594c2c22f$var$inputLabel = {
        name: "30ezmv",
        styles: "color:var(--ds-text-subtlest, #626F86);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
    };
    const $a78ad29594c2c22f$var$inputWrapperPosition = {
        name: "bjn8wh",
        styles: "position:relative"
    };
    const $a78ad29594c2c22f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        displayText: {
            id: 'fabric.editor.displayText',
            defaultMessage: 'Text to display',
            description: 'Text to display'
        },
        clearText: {
            id: 'fabric.editor.clearLinkText',
            defaultMessage: 'Clear text',
            description: 'Clears text on the link toolbar'
        },
        clearLink: {
            id: 'fabric.editor.clearLink',
            defaultMessage: 'Clear link',
            description: 'Clears link in the link toolbar'
        },
        searchLinkAriaDescription: {
            id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
            defaultMessage: 'Suggestions will appear below as you type into the field',
            description: 'Describes what the search field does for screen reader users.'
        },
        searchLinkResults: {
            id: 'fabric.editor.hyperlink.searchLinkResults',
            defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
            description: 'Announce search results for screen-reader users.'
        },
        linkVisibleLabel: {
            id: 'fabric.editor.hyperlink.linkVisibleLabel',
            defaultMessage: 'Paste or search for link',
            description: 'Visible label for link input in hyperlink floating control'
        },
        textVisibleLabel: {
            id: 'fabric.editor.hyperlink.textVisibleLabel',
            defaultMessage: 'Display text (optional)',
            description: 'Visible label for text input in hyperlink floating control'
        }
    });
    const $a78ad29594c2c22f$var$defaultIcon = (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("dSQQ7"))))), {
        label: 'page'
    });
    const $a78ad29594c2c22f$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
            objectId: objectId,
            name: name,
            container: container,
            iconUrl: iconUrl,
            url: url,
            lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
            prefetch: true
        });
    const $a78ad29594c2c22f$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
            objectId: objectId,
            container: container,
            name: title,
            url: url,
            lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
            icon: contentType && (0, (0, parcelRequire("3lb3A")).mapContentTypeToIcon)[contentType] || $a78ad29594c2c22f$var$defaultIcon,
            prefetch: false
        });
    class $a78ad29594c2c22f$export$7acbf008e0847b89 extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props), this.submitted = false, this.urlInputContainer = null, this.displayTextInputContainer = null, this.wrapperRef = (0, ($parcel$interopDefault($5uXOq))).createRef(), this.quickSearchQueryVersion = 0, this.analyticSource = 'createLinkInlineDialog', this.quickSearch = async (input, items, quickSearchLimit)=>{
                const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
                const { searchSessionId: searchSessionId } = this.props;
                if (!searchProvider) return;
                const queryVersion = ++this.quickSearchQueryVersion;
                this.fireAnalytics({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).ENTERED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                    attributes: {
                        queryLength: input.length,
                        queryVersion: queryVersion,
                        queryHash: (0, (0, parcelRequire("3lb3A")).sha1)(input),
                        searchSessionId: searchSessionId ?? '',
                        wordCount: (0, (0, parcelRequire("3lb3A")).wordCount)(input),
                        source: this.analyticSource
                    },
                    nonPrivacySafeAttributes: {
                        query: input
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                });
                const perfStart = performance.now();
                try {
                    const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                    const searchItems = $a78ad29594c2c22f$var$limit((0, (0, parcelRequire("3lb3A")).filterUniqueItems)([
                        ...items,
                        ...searchProviderResultItems.map($a78ad29594c2c22f$var$mapSearchProviderResultToLinkSearchItemData)
                    ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                    if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                        items: searchItems,
                        isLoading: false
                    });
                    const perfStop = performance.now();
                    const duration = perfStop - perfStart;
                    this.fireAnalytics({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).QUICK_SEARCH,
                        attributes: {
                            duration: duration,
                            count: searchProviderResultItems.length
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                    this.fireAnalytics({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).SHOWN,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                        attributes: {
                            source: this.analyticSource,
                            postQueryRequestDurationMs: duration,
                            searchSessionId: searchSessionId ?? '',
                            resultCount: searchProviderResultItems.length,
                            results: searchProviderResultItems.map((item)=>({
                                    resultContentId: item.objectId,
                                    resultType: item.contentType
                                }))
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                } catch (err) {
                    const perfStop = performance.now();
                    const duration = perfStop - perfStart;
                    this.fireAnalytics({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).QUICK_SEARCH,
                        attributes: {
                            duration: duration,
                            count: -1,
                            errorCode: err.status
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    });
                }
            }, this.updateInput = async (input)=>{
                const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
                this.setState({
                    displayUrl: input
                });
                if (activityProvider) {
                    if (input.length === 0) this.setState({
                        items: await this.getRecentItems(activityProvider),
                        selectedIndex: -1
                    });
                    else if ((0, (0, parcelRequire("iZOJ9")).isSafeUrl)(input)) this.setState({
                        items: [],
                        selectedIndex: -1,
                        isLoading: false
                    });
                    else {
                        const items = await this.getRecentItems(activityProvider, input);
                        const shouldQuerySearchProvider = items.length < $a78ad29594c2c22f$export$452f1062ecf44be7 && !!searchProvider;
                        this.setState({
                            items: items,
                            isLoading: shouldQuerySearchProvider
                        });
                        if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $a78ad29594c2c22f$export$452f1062ecf44be7);
                    }
                }
            }, this.createClearHandler = (field)=>{
                return async ()=>{
                    const { activityProvider: activityProvider } = this.state;
                    switch(field){
                        case 'displayUrl':
                            this.setState({
                                [field]: '',
                                items: !!activityProvider ? $a78ad29594c2c22f$var$limit(await activityProvider.getRecentItems()) : []
                            });
                            if (this.urlInputContainer) this.urlInputContainer.focus();
                            break;
                        case 'displayText':
                            this.setState({
                                [field]: ''
                            });
                            if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                    }
                };
            }, this.handleClickOutside = (event)=>{
                if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                    const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                    onClickAwayCallback?.(state, dispatch);
                }
            }, this.getScreenReaderText = ()=>{
                const { intl: intl } = this.props;
                const { items: items, selectedIndex: selectedIndex } = this.state;
                if (items.length && selectedIndex > -1) {
                    const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                    const date = (0, (0, parcelRequire("kEtKd")).transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                    return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
                }
            }, this.isUrlPopulatedWithSelectedItem = ()=>{
                const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
                const selectedItem = items[selectedIndex];
                if (selectedItem && selectedItem.url === displayUrl) return true;
                return false;
            }, this.handleSelected = (href, text)=>{
                this.handleInsert(href, text, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TYPEAHEAD, 'click');
            }, this.handleInsert = (href, title, inputType, interaction)=>{
                const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
                const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
                if (onSubmit) {
                    this.submitted = true;
                    onSubmit(href, title, displayText, inputType);
                }
                if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                    const selectedItem = items[selectedIndex];
                    this.fireAnalytics({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                        attributes: {
                            source: this.analyticSource,
                            searchSessionId: searchSessionId ?? '',
                            trigger: interaction,
                            resultCount: items.length,
                            selectedResultId: selectedItem.objectId,
                            selectedRelativePosition: selectedIndex,
                            prefetch: selectedItem.prefetch ?? false
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                }
            }, this.handleMouseEnterResultItem = (objectId)=>{
                const { items: items } = this.state;
                const index = $a78ad29594c2c22f$var$findIndex(items, (item)=>item.objectId === objectId);
                this.setState({
                    selectedIndex: index
                });
            }, this.handleMouseLeaveResultItem = (objectId)=>{
                const { items: items, selectedIndex: selectedIndex } = this.state;
                const index = $a78ad29594c2c22f$var$findIndex(items, (item)=>item.objectId === objectId);
                if (selectedIndex === index) this.setState({
                    selectedIndex: -1
                });
            }, this.handleSubmit = ()=>{
                const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
                const selectedItem = items[selectedIndex];
                if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, (0, parcelRequire("dPSMN")).normalizeUrl)(selectedItem.url), selectedItem.name, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TYPEAHEAD, 'keyboard');
                else if (displayUrl && displayUrl.length > 0) {
                    const url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(displayUrl);
                    if (url) this.handleInsert(url, displayUrl, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).MANUAL, 'notselected');
                }
            }, this.handleClearTextKeyDown = (event)=>{
                const KEY_CODE_TAB = 9;
                const { keyCode: keyCode } = event;
                if (keyCode === KEY_CODE_TAB) {
                    if (!this.submitted) {
                        const { displayUrl: displayUrl, displayText: displayText } = this.state;
                        const url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(displayUrl);
                        this.handleInsert(url, displayText || displayUrl, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).MANUAL, 'notselected');
                    }
                    event.preventDefault();
                    return;
                }
            }, this.handleKeyDown = (event)=>{
                const { items: items, selectedIndex: selectedIndex } = this.state;
                const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
                const { keyCode: keyCode } = event;
                const KEY_CODE_ESCAPE = 27;
                const KEY_CODE_ARROW_DOWN = 40;
                const KEY_CODE_ARROW_UP = 38;
                if (keyCode === KEY_CODE_ESCAPE) {
                    event.preventDefault();
                    const { state: state, dispatch: dispatch } = view;
                    onEscapeCallback?.(state, dispatch);
                    return;
                }
                if (!items || !items.length) return;
                let updatedIndex = selectedIndex;
                if (keyCode === KEY_CODE_ARROW_DOWN) {
                    event.preventDefault();
                    updatedIndex = (selectedIndex + 1) % items.length;
                } else if (keyCode === KEY_CODE_ARROW_UP) {
                    event.preventDefault();
                    updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
                }
                if ([
                    KEY_CODE_ARROW_DOWN,
                    KEY_CODE_ARROW_UP
                ].includes(keyCode) && items[updatedIndex]) {
                    this.setState({
                        selectedIndex: updatedIndex,
                        displayUrl: items[updatedIndex].url
                    });
                    this.fireAnalytics({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).HIGHLIGHTED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                        attributes: {
                            source: this.analyticSource,
                            searchSessionId: searchSessionId ?? '',
                            selectedResultId: items[updatedIndex].objectId,
                            selectedRelativePosition: updatedIndex
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                }
            }, this.updateTextInput = (displayText)=>{
                this.setState({
                    displayText: displayText
                });
            }, this.handleCancel = (e)=>{
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                e.preventDefault();
                onClickAwayCallback?.(state, dispatch);
            };
            this.state = {
                selectedIndex: -1,
                isLoading: false,
                displayUrl: (0, (0, parcelRequire("dPSMN")).normalizeUrl)(props.displayUrl),
                displayText: props.displayText,
                items: []
            };
            this.handleClearText = this.createClearHandler('displayUrl');
            this.handleClearDisplayText = this.createClearHandler('displayText');
            this.debouncedQuickSearch = (0, ($parcel$interopDefault($lFKmC)))(this.quickSearch, 400);
            this.fireCustomAnalytics = (0, (0, parcelRequire("ctLRZ")).fireAnalyticsEvent)(props.createAnalyticsEvent);
        }
        async componentDidMount() {
            const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
            document.addEventListener('mousedown', this.handleClickOutside);
            this.fireAnalytics({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
                attributes: {
                    timesViewed: timesViewed ?? 0,
                    searchSessionId: searchSessionId ?? '',
                    trigger: inputMethod ?? ''
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).SCREEN
            });
            const [activityProvider, searchProvider] = await Promise.all([
                this.props.activityProvider,
                this.props.searchProvider
            ]);
            (0, $7nsd3.flushSync)(()=>this.setState({
                    activityProvider: activityProvider,
                    searchProvider: searchProvider
                }));
            await this.loadInitialLinkSearchResult();
        }
        componentWillUnmount() {
            const { searchSessionId: searchSessionId } = this.props;
            document.removeEventListener('mousedown', this.handleClickOutside);
            if (!this.submitted) this.fireAnalytics({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).DISMISSED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
                attributes: {
                    source: this.analyticSource,
                    searchSessionId: searchSessionId ?? '',
                    trigger: 'blur'
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            });
        }
        async getRecentItems(activityProvider, query) {
            const { searchSessionId: searchSessionId } = this.props;
            const perfStart = performance.now();
            try {
                const activityRecentItems = $a78ad29594c2c22f$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
                const items = activityRecentItems.map($a78ad29594c2c22f$var$mapActivityProviderResultToLinkSearchItemData);
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                    attributes: {
                        duration: duration,
                        count: items.length
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).SHOWN,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        preQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: items.length,
                        results: activityRecentItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.type ?? ''
                            }))
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                });
                return items;
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                });
                return [];
            }
        }
        fireAnalytics(payload) {
            if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
                payload: payload
            });
        }
        async loadInitialLinkSearchResult() {
            const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
            try {
                if (!displayUrl && activityProvider) {
                    this.setState({
                        isLoading: true
                    });
                    const items = await this.getRecentItems(activityProvider);
                    this.setState({
                        items: items
                    });
                }
            } finally{
                this.setState({
                    isLoading: false
                });
            }
        }
        render() {
            const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
            const { intl: { formatMessage: formatMessage }, activityProvider: activityProvider } = this.props;
            const formatClearLinkText = formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearLink);
            const screenReaderDescriptionId = 'search-recent-links-field-description';
            const linkSearchListId = 'hyperlink-search-list';
            const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
            const linkSearchInputId = 'search-recent-links-field-id';
            const displayTextInputId = 'display-text-filed-id';
            const screenReaderText = (0, (0, parcelRequire("gE8f9")).browser).safari && this.getScreenReaderText();
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "aria-label": "Hyperlink Edit",
                className: "recent-list",
                "data-testid": "hyperlink-add-toolbar"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    (0, (0, parcelRequire("iPN39")).container),
                    !!activityProvider && (0, (0, parcelRequire("iPN39")).containerWithProvider),
                    $a78ad29594c2c22f$var$containerPadding
                ],
                ref: this.wrapperRef
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
                htmlFor: linkSearchInputId,
                css: $a78ad29594c2c22f$var$inputLabel
            }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.linkVisibleLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    (0, (0, parcelRequire("iPN39")).inputWrapper),
                    $a78ad29594c2c22f$var$inputWrapperPosition
                ]
            }, screenReaderText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldHK3")).default), {
                ariaLive: "assertive",
                text: screenReaderText,
                ariaRelevant: "additions",
                delay: 250
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $a78ad29594c2c22f$export$8dd524ceb40e3d16,
                "aria-hidden": "true",
                id: screenReaderDescriptionId
            }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.searchLinkAriaDescription)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("g7oRE")).default), {
                role: "combobox",
                ariaExpanded: true,
                ariaActiveDescendant: ariaActiveDescendant,
                ariaControls: linkSearchListId,
                ariaAutoComplete: true,
                describedById: screenReaderDescriptionId,
                ref: (ele)=>this.urlInputContainer = ele,
                testId: 'link-url',
                onSubmit: this.handleSubmit,
                onChange: this.updateInput,
                autoFocus: {
                    preventScroll: true
                },
                onCancel: this.handleCancel,
                defaultValue: displayUrl,
                onKeyDown: this.handleKeyDown,
                inputId: linkSearchInputId
            }), displayUrl && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $a78ad29594c2c22f$var$clearTextWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                content: formatClearLinkText
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                xcss: $a78ad29594c2c22f$var$clearTextButtonStyles,
                onClick: this.handleClearText
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                label: formatClearLinkText,
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            }))))), (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
                htmlFor: displayTextInputId,
                css: [
                    $a78ad29594c2c22f$var$inputLabel,
                    $a78ad29594c2c22f$var$textLabelMargin
                ]
            }, formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.textVisibleLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    (0, (0, parcelRequire("iPN39")).inputWrapper),
                    $a78ad29594c2c22f$var$inputWrapperPosition
                ]
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("g7oRE")).default), {
                ref: (ele)=>this.displayTextInputContainer = ele,
                testId: 'link-text',
                onChange: this.updateTextInput,
                onCancel: this.handleCancel,
                defaultValue: displayText,
                onSubmit: this.handleSubmit,
                onKeyDown: this.handleKeyDown,
                inputId: displayTextInputId
            }), displayText && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $a78ad29594c2c22f$var$clearTextWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearText)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5ILhZ")).default), {
                xcss: $a78ad29594c2c22f$var$clearTextButtonStyles,
                onClick: this.handleClearDisplayText,
                onKeyDown: this.handleClearTextKeyDown
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
                label: formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.clearText),
                primaryColor: "var(--ds-icon-subtle, #626F86)"
            }))))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $a78ad29594c2c22f$export$8dd524ceb40e3d16,
                "aria-live": "polite",
                "aria-atomic": "true",
                id: "fabric.editor.hyperlink.suggested.results"
            }, displayUrl && formatMessage($a78ad29594c2c22f$export$defe85febe8b728c.searchLinkResults, {
                count: items.length
            })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lnN1k")).default), {
                ariaControls: "fabric.editor.hyperlink.suggested.results",
                id: linkSearchListId,
                role: "listbox",
                items: items,
                isLoading: isLoading,
                selectedIndex: selectedIndex,
                onSelect: this.handleSelected,
                onMouseEnter: this.handleMouseEnterResultItem,
                onMouseLeave: this.handleMouseLeaveResultItem
            })));
        }
    }
    function $a78ad29594c2c22f$var$findIndex(array, predicate) {
        let index = -1;
        array.some((item, i)=>{
            if (predicate(item)) {
                index = i;
                return true;
            }
            return false;
        });
        return index;
    }
    function $a78ad29594c2c22f$var$limit(items) {
        return items.slice(0, $a78ad29594c2c22f$export$452f1062ecf44be7);
    }
    const $a78ad29594c2c22f$export$527bb787d3e8324e = (0, (0, parcelRequire("8RXs9")).default)($a78ad29594c2c22f$export$7acbf008e0847b89);
    var $a78ad29594c2c22f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($a78ad29594c2c22f$export$527bb787d3e8324e);
});
parcelRegister("dSQQ7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a1b94e5f124869c4$var$_react = $a1b94e5f124869c4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $a1b94e5f124869c4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a1b94e5f124869c4$var$Page16Icon = (props)=>$a1b94e5f124869c4$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
        }, props, {
            size: "small"
        }));
    $a1b94e5f124869c4$var$Page16Icon.displayName = 'Page16Icon';
    var $a1b94e5f124869c4$var$_default = module.exports.default = $a1b94e5f124869c4$var$Page16Icon;
});
parcelRegister("d5Zn3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $988b58f36f60a149$var$_react = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $988b58f36f60a149$var$_crossCircle = $988b58f36f60a149$var$_interopRequireDefault((parcelRequire("hI6SY")));
    function $988b58f36f60a149$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $988b58f36f60a149$var$CrossCircleIcon = (props)=>$988b58f36f60a149$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
        }, props, {
            newIcon: $988b58f36f60a149$var$_crossCircle.default
        }));
    $988b58f36f60a149$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $988b58f36f60a149$var$_default = module.exports.default = $988b58f36f60a149$var$CrossCircleIcon;
});
parcelRegister("ldHK3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$460cd7001198a7b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    let $460cd7001198a7b7$var$timer;
    const $460cd7001198a7b7$var$Announcer = (0, $5uXOq.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
        const [contentRendered, setContentRendered] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout($460cd7001198a7b7$var$timer);
            setContentRendered(false);
            $460cd7001198a7b7$var$timer = setTimeout(()=>{
                setContentRendered(true);
            }, delay);
            return ()=>clearTimeout($460cd7001198a7b7$var$timer);
        }, [
            text,
            delay
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "assistive",
            ref: ref,
            role: role,
            "aria-atomic": ariaAtomic,
            "aria-relevant": ariaRelevant,
            "aria-live": ariaLive
        }, contentRendered && (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, text));
    });
    var $460cd7001198a7b7$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($460cd7001198a7b7$var$Announcer);
});
parcelRegister("g7oRE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41340a73ecd6e84a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gE8f9;
    var $5xibt;
    const $41340a73ecd6e84a$var$KeyZCode = 90;
    const $41340a73ecd6e84a$var$KeyYCode = 89;
    class $41340a73ecd6e84a$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props), this.onMouseDown = ()=>{
                const { onMouseDown: onMouseDown } = this.props;
                if (onMouseDown) onMouseDown();
            }, this.onBlur = (e)=>{
                const { onBlur: onBlur } = this.props;
                if (onBlur) onBlur(e);
            }, this.handleChange = ()=>{
                const { onChange: onChange } = this.props;
                if (this.input) this.setState({
                    value: this.input.value
                });
                if (onChange && this.input) onChange(this.input.value);
            }, this.handleKeydown = (e)=>{
                const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
                if (e.keyCode === 13 && onSubmit) {
                    e.preventDefault();
                    onSubmit(this.input.value);
                } else if (e.keyCode === 27 && onCancel) onCancel(e);
                else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                    e.preventDefault();
                    onUndo();
                } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                    e.preventDefault();
                    onRedo();
                }
                if (this.props.onKeyDown) this.props.onKeyDown(e);
            }, this.handleRef = (input)=>{
                if (input instanceof HTMLInputElement) {
                    this.input = input;
                    if (this.props.autoFocus) this.focusTimeoutId = window.setTimeout(()=>this.focus());
                } else this.input = undefined;
            };
            this.state = {
                value: props.defaultValue || ''
            };
        }
        componentDidUpdate(prevProps) {
            if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
                value: this.props.defaultValue
            });
        }
        componentWillUnmount() {
            window.clearTimeout(this.focusTimeoutId);
        }
        render() {
            const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
            const { value: value } = this.state;
            return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                css: [
                    (0, (0, parcelRequire("5xibt")).panelTextInput),
                    width !== undefined && (0, (0, parcelRequire("5xibt")).panelTextInputWithCustomWidth)(width)
                ],
                role: role,
                "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
                "aria-expanded": ariaExpanded,
                "aria-controls": ariaControls,
                "aria-activedescendant": ariaActiveDescendant,
                "aria-describedby": describedById,
                "data-testid": testId || '',
                type: "text",
                placeholder: placeholder,
                value: value,
                onChange: this.handleChange,
                onKeyDown: this.handleKeydown,
                onMouseDown: this.onMouseDown,
                onBlur: this.onBlur,
                ref: this.handleRef,
                maxLength: maxLength,
                "aria-label": ariaLabel,
                "aria-required": this.props?.ariaRequired,
                "aria-invalid": this.props?.ariaInvalid,
                id: inputId
            });
        }
        focus() {
            const { input: input } = this;
            if (input) {
                const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
                input.focus(focusOpts);
            }
        }
        isUndoEvent(event) {
            return event.keyCode === $41340a73ecd6e84a$var$KeyZCode && ((0, (0, parcelRequire("gE8f9")).browser).mac && event.metaKey && !event.shiftKey || !(0, (0, parcelRequire("gE8f9")).browser).mac && event.ctrlKey);
        }
        isRedoEvent(event) {
            return (!(0, (0, parcelRequire("gE8f9")).browser).mac && event.ctrlKey && event.keyCode === $41340a73ecd6e84a$var$KeyYCode || (0, (0, parcelRequire("gE8f9")).browser).mac && event.metaKey && event.shiftKey && event.keyCode === $41340a73ecd6e84a$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $41340a73ecd6e84a$var$KeyZCode);
        }
    }
});
parcelRegister("5xibt", function(module, exports) {
    $parcel$export(module.exports, "panelTextInput", ()=>$087151c1f25b1933$export$b81ddbf3e2eaad80);
    $parcel$export(module.exports, "panelTextInputWithCustomWidth", ()=>$087151c1f25b1933$export$c9f899b6422903f6);
    var $f8Sb3;
    var $iHYdz;
    const $087151c1f25b1933$export$b81ddbf3e2eaad80 = (0, (0, parcelRequire("f8Sb3")).css)({
        'input&': {
            background: 'transparent',
            border: `2px solid ${"var(--ds-border, #091E4224)"}`,
            borderRadius: 0,
            boxSizing: 'content-box',
            color: "var(--ds-text-subtle, #44546F)",
            flexGrow: 1,
            fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(13),
            lineHeight: '20px',
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
            minWidth: '145px',
            '&::-ms-clear': {
                display: 'none'
            },
            '&:focus': {
                outline: 'none',
                borderColor: "var(--ds-border-focused, #388BFF)"
            },
            '&::placeholder': {
                color: "var(--ds-text-subtlest, #626F86)"
            }
        }
    });
    const $087151c1f25b1933$export$c9f899b6422903f6 = (width)=>(0, (0, parcelRequire("f8Sb3")).css)({
            'input&': {
                width: `${width}px`
            }
        });
});
parcelRegister("lnN1k", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54e0d14e44d0b1aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $eZJjh;
    var $1DVD8;
    function $54e0d14e44d0b1aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $54e0d14e44d0b1aa$var$listContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingTop: 0,
        marginTop: "var(--ds-space-150, 12px)",
        borderTop: `1px solid ${"var(--ds-border, #091E4224)"}`
    });
    const $54e0d14e44d0b1aa$var$spinnerContainer = {
        name: "q64ud4",
        styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
    };
    const $54e0d14e44d0b1aa$export$ca0620a9deb4a3fe = {
        name: "n1lsvi",
        styles: "padding:0;list-style:none"
    };
    class $54e0d14e44d0b1aa$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        render() {
            const { onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id } = this.props;
            let itemsContent;
            let loadingContent;
            if (items && items.length > 0) itemsContent = (0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
                css: $54e0d14e44d0b1aa$export$ca0620a9deb4a3fe,
                id: id,
                role: role,
                "aria-controls": ariaControls
            }, items.map((item, index)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1DVD8")).default), {
                    id: `link-search-list-item-${index}`,
                    role: role && 'option',
                    item: item,
                    selected: selectedIndex === index,
                    onMouseMove: onMouseMove,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onSelect: onSelect,
                    key: item.objectId
                })));
            if (isLoading) loadingContent = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": `${id}-loading`,
                css: $54e0d14e44d0b1aa$var$spinnerContainer
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZJjh")).default), {
                size: "medium"
            }));
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $54e0d14e44d0b1aa$var$listContainer
            }, itemsContent, loadingContent);
        }
    }
});
parcelRegister("1DVD8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$995428ceb0cf599f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $iHYdz;
    var $4jzQi;
    var $kEtKd;
    function $995428ceb0cf599f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $995428ceb0cf599f$export$34e0f9847d4c02dd = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: 'transparent',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
        cursor: 'pointer',
        display: 'flex',
        marginTop: 0
    });
    const $995428ceb0cf599f$export$624ac72e8eeb8e3d = {
        name: "jjwciq",
        styles: "background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
    };
    const $995428ceb0cf599f$var$nameWrapper = {
        name: "d3v9zr",
        styles: "overflow:hidden"
    };
    const $995428ceb0cf599f$export$d6a1b4d10134b7d7 = {
        name: "ufq1bc",
        styles: "color:var(--ds-text, #172B4D);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
    };
    const $995428ceb0cf599f$export$ff1446d682f75fb9 = (0, (0, parcelRequire("f8Sb3")).css)({
        color: "var(--ds-text-subtlest, #626F86)",
        lineHeight: '14px',
        fontSize: (0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(11)
    });
    const $995428ceb0cf599f$var$iconStyle = {
        name: "r2c2s1",
        styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
    };
    class $995428ceb0cf599f$var$LinkSearchListItem extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        renderIcon() {
            const { item: { icon: icon, iconUrl: iconUrl }, intl: intl } = this.props;
            if (icon) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: $995428ceb0cf599f$var$iconStyle
            }, icon);
            if (iconUrl) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: $995428ceb0cf599f$var$iconStyle
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("img", {
                src: iconUrl,
                alt: (0, (0, parcelRequire("4jzQi")).getCorrectAltByIconUrl)(iconUrl, intl)
            }));
            return null;
        }
        renderTimeStamp() {
            const { item: item, intl: intl } = this.props;
            const date = (0, (0, parcelRequire("kEtKd")).transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
            return date && (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, "\xa0 \u2022", (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                className: "link-search-timestamp",
                "data-test-id": "link-search-timestamp"
            }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
        }
        render() {
            const { item: item, selected: selected, id: id, role: role } = this.props;
            return ((0, (0, parcelRequire("f8Sb3")).jsx)("li", {
                css: [
                    $995428ceb0cf599f$export$34e0f9847d4c02dd,
                    selected && $995428ceb0cf599f$export$624ac72e8eeb8e3d
                ],
                role: role,
                id: id,
                "aria-selected": selected,
                "data-testid": "link-search-list-item",
                onMouseMove: this.handleMouseMove,
                onMouseEnter: this.handleMouseEnter,
                onMouseLeave: this.handleMouseLeave,
                onClick: this.handleSelect
            }, this.renderIcon(), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: $995428ceb0cf599f$var$nameWrapper
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $995428ceb0cf599f$export$d6a1b4d10134b7d7
            }, item.name), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": "link-search-list-item-container",
                css: $995428ceb0cf599f$export$ff1446d682f75fb9
            }, item.container, this.renderTimeStamp()))));
        }
        constructor(...args){
            super(...args), this.handleSelect = (e)=>{
                e.preventDefault();
                const { item: item, onSelect: onSelect } = this.props;
                onSelect(item.url, item.name);
            }, this.handleMouseMove = ()=>{
                const { onMouseMove: onMouseMove, item: item } = this.props;
                onMouseMove && onMouseMove(item.objectId);
            }, this.handleMouseEnter = ()=>{
                const { onMouseEnter: onMouseEnter, item: item } = this.props;
                onMouseEnter && onMouseEnter(item.objectId);
            }, this.handleMouseLeave = ()=>{
                const { onMouseLeave: onMouseLeave, item: item } = this.props;
                onMouseLeave && onMouseLeave(item.objectId);
            };
        }
    }
    var $995428ceb0cf599f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($995428ceb0cf599f$var$LinkSearchListItem);
});
parcelRegister("4jzQi", function(module, exports) {
    $parcel$export(module.exports, "getCorrectAltByIconUrl", ()=>$e880ccf995c9e5fe$export$ac1fda7301622804);
    var $7VHMR;
    const $e880ccf995c9e5fe$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        story: {
            id: 'fabric.editor.story',
            defaultMessage: 'Story',
            description: 'Alt text for Story'
        },
        epic: {
            id: 'fabric.editor.epic',
            defaultMessage: 'Epic',
            description: 'Alt text for Epic'
        },
        task: {
            id: 'fabric.editor.task',
            defaultMessage: 'Task',
            description: 'Alt text for Task'
        },
        bug: {
            id: 'fabric.editor.bug',
            defaultMessage: 'Bug',
            description: 'Alt text for Bug'
        },
        subTask: {
            id: 'fabric.editor.subTask',
            defaultMessage: 'Sub-task',
            description: 'Alt text for Sub-task'
        },
        improvement: {
            id: 'fabric.editor.improvement',
            defaultMessage: 'Improvement',
            description: 'Alt text for Improvement'
        },
        defaultAltText: {
            id: 'fabric.editor.defaultAltText',
            defaultMessage: 'Document',
            description: 'Default alt text for ListItem image'
        }
    });
    const $e880ccf995c9e5fe$export$ac1fda7301622804 = (iconUrl, intl)=>{
        let alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.defaultAltText);
        if (iconUrl.includes('story.svg')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.story);
        if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.epic);
        if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.task);
        if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.bug);
        if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.subTask);
        if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($e880ccf995c9e5fe$var$messages.improvement);
        return alt;
    };
});
parcelRegister("kEtKd", function(module, exports) {
    $parcel$export(module.exports, "transformTimeStamp", ()=>$bd8482d2c43b4082$export$439b9bb86eb9f500);
    var $SzDmm;
    var $k7m40;
    var $2kh23;
    var $8DYpW;
    const $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
        let pageActionText = '';
        switch(pageAction){
            case 'updated':
                pageActionText = intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).timeUpdated);
                break;
            case 'viewed':
                pageActionText = intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).timeViewed);
                break;
        }
        if ((0, (0, parcelRequire("SzDmm")).default)(timeStamp, Date.now()) < -7) return {
            pageAction: pageActionText,
            dateString: (0, (0, parcelRequire("k7m40")).default)(timeStamp, 'MMMM dd, yyyy')
        };
        return {
            pageAction: pageActionText,
            dateString: (0, (0, parcelRequire("2kh23")).default)(timeStamp, Date.now()),
            timeSince: intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).timeAgo)
        };
    };
    const $bd8482d2c43b4082$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
        if (lastViewedDate) return $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
        if (lastUpdatedDate) return $bd8482d2c43b4082$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
    };
});
parcelRegister("iPN39", function(module, exports) {
    $parcel$export(module.exports, "inputWrapper", ()=>$df68561fe99a6144$export$248a47518f3a0001);
    $parcel$export(module.exports, "container", ()=>$df68561fe99a6144$export$34e0f9847d4c02dd);
    $parcel$export(module.exports, "containerWithProvider", ()=>$df68561fe99a6144$export$8fb2d297355596b4);
    var $f8Sb3;
    const $df68561fe99a6144$export$248a47518f3a0001 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        lineHeight: 0,
        padding: `${"var(--ds-space-075, 6px)"} 0`,
        alignItems: 'center'
    });
    const $df68561fe99a6144$export$34e0f9847d4c02dd = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        padding: 0,
        width: `${(0, $f96f1f7af2f8d3ca$export$92a2501826f554f6)}px`,
        lineHeight: 'initial'
    });
    const $df68561fe99a6144$export$8fb2d297355596b4 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `${(0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe)}px`
    });
});
const $f96f1f7af2f8d3ca$export$a62aa932daf22ffe = 420;
const $f96f1f7af2f8d3ca$export$92a2501826f554f6 = 360;
const $f96f1f7af2f8d3ca$export$c04a5ad015d45447 = 360;
const $f96f1f7af2f8d3ca$export$c635b83728f81640 = 570;
parcelRegister("3lb3A", function(module, exports) {
    $parcel$export(module.exports, "filterUniqueItems", ()=>$5722104a46f56bc4$export$8437fc55448c6e05);
    $parcel$export(module.exports, "mapContentTypeToIcon", ()=>$5722104a46f56bc4$export$80e948449ec854a9);
    $parcel$export(module.exports, "sha1", ()=>$5722104a46f56bc4$export$5091bdda49ba90f5);
    $parcel$export(module.exports, "wordCount", ()=>$5722104a46f56bc4$export$24d5ff955141c347);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $bdDiz = parcelRequire("bdDiz");
    var $61uoP;
    var $cQpjg;
    var $lLgcu;
    var $dSQQ7;
    var $g2bjw;
    var $eUrLn;
    var $1kHUN;
    function $5722104a46f56bc4$export$8437fc55448c6e05(arr, comparator) {
        return arr.filter((firstItem, index, self)=>{
            return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
        });
    }
    const $5722104a46f56bc4$var$Issue16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLgcu"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconIssueLabel)
        });
    };
    const $5722104a46f56bc4$var$Bug16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cQpjg"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconBugLabel)
        });
    };
    const $5722104a46f56bc4$var$Story16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("g2bjw"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconStoryLabel)
        });
    };
    const $5722104a46f56bc4$var$Task16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eUrLn"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconTaskLabel)
        });
    };
    const $5722104a46f56bc4$var$Page16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dSQQ7"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconPageLabel)
        });
    };
    const $5722104a46f56bc4$var$Blog16 = (props)=>{
        const { intl: intl } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("61uoP"))))), {
            label: intl.formatMessage((0, (0, parcelRequire("1kHUN")).utilMessages).hyperlinkIconBlogLabel)
        });
    };
    const $5722104a46f56bc4$var$IntlIssue16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Issue16);
    const $5722104a46f56bc4$var$IntlBug16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Bug16);
    const $5722104a46f56bc4$var$IntlStory16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Story16);
    const $5722104a46f56bc4$var$IntlTask16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Task16);
    const $5722104a46f56bc4$var$IntlPage16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Page16);
    const $5722104a46f56bc4$var$IntlBlog16Icon = (0, (0, parcelRequire("8RXs9")).default)($5722104a46f56bc4$var$Blog16);
    const $5722104a46f56bc4$export$80e948449ec854a9 = {
        'jira.issue': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlIssue16Icon, null),
        'jira.issue.bug': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlBug16Icon, null),
        'jira.issue.story': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlStory16Icon, null),
        'jira.issue.task': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlTask16Icon, null),
        'confluence.page': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlPage16Icon, null),
        'confluence.blogpost': (0, ($parcel$interopDefault($5uXOq))).createElement($5722104a46f56bc4$var$IntlBlog16Icon, null)
    };
    const $5722104a46f56bc4$export$5091bdda49ba90f5 = (input)=>{
        return (0, ($parcel$interopDefault($bdDiz))).createHash().update(input).digest('hex');
    };
    const $5722104a46f56bc4$export$24d5ff955141c347 = (input)=>{
        return input.split(' ').length;
    };
});
parcelRegister("cQpjg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $959df95e31ced62c$var$_react = $959df95e31ced62c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $959df95e31ced62c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $959df95e31ced62c$var$Bug16Icon = (props)=>$959df95e31ced62c$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            size: "small"
        }));
    $959df95e31ced62c$var$Bug16Icon.displayName = 'Bug16Icon';
    var $959df95e31ced62c$var$_default = module.exports.default = $959df95e31ced62c$var$Bug16Icon;
});
parcelRegister("lLgcu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fd7a8ddb7016f4b6$var$_react = $fd7a8ddb7016f4b6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $fd7a8ddb7016f4b6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fd7a8ddb7016f4b6$var$Issue16Icon = (props)=>$fd7a8ddb7016f4b6$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m1 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm1 2v4h8V6z"/></svg>`
        }, props, {
            size: "small"
        }));
    $fd7a8ddb7016f4b6$var$Issue16Icon.displayName = 'Issue16Icon';
    var $fd7a8ddb7016f4b6$var$_default = module.exports.default = $fd7a8ddb7016f4b6$var$Issue16Icon;
});
parcelRegister("g2bjw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $bac59bf1b4bf203a$var$_react = $bac59bf1b4bf203a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $bac59bf1b4bf203a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $bac59bf1b4bf203a$var$Story16Icon = (props)=>$bac59bf1b4bf203a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m6 11-2.863 1.822c-.42.38-1.137.111-1.137-.427v-8.19C4 3.54 4.596 3 5.333 3h5.334C11.403 3 12 3.539 12 4.206v8.19c0 .537-.719.806-1.139.426zm0-2.371 2 1.274V5H6v4.902z"/></svg>`
        }, props, {
            size: "small"
        }));
    $bac59bf1b4bf203a$var$Story16Icon.displayName = 'Story16Icon';
    var $bac59bf1b4bf203a$var$_default = module.exports.default = $bac59bf1b4bf203a$var$Story16Icon;
});
parcelRegister("eUrLn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $adabd4d4512c9645$var$_react = $adabd4d4512c9645$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $adabd4d4512c9645$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $adabd4d4512c9645$var$Task16Icon = (props)=>$adabd4d4512c9645$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006zM4.667 3C3.747 3 3 3.746 3 4.667v6.666C3 12.253 3.746 13 4.667 13h6.666c.92 0 1.667-.746 1.667-1.667V4.667C13 3.747 12.254 3 11.333 3zM5 5v6h6V5z"/></svg>`
        }, props, {
            size: "small"
        }));
    $adabd4d4512c9645$var$Task16Icon.displayName = 'Task16Icon';
    var $adabd4d4512c9645$var$_default = module.exports.default = $adabd4d4512c9645$var$Task16Icon;
});
parcelRegister("1kHUN", function(module, exports) {
    $parcel$export(module.exports, "utilMessages", ()=>$5c7e67fcef8e13d4$export$ecd9e62648c1046a);
    var $7VHMR;
    const $5c7e67fcef8e13d4$export$ecd9e62648c1046a = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        hyperlinkIconIssueLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
            defaultMessage: 'Issue',
            description: 'icon label for a jira issue'
        },
        hyperlinkIconBugLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
            defaultMessage: 'Bug',
            description: 'icon label for a jira bug'
        },
        hyperlinkIconStoryLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
            defaultMessage: 'Story',
            description: 'icon label for a jira story'
        },
        hyperlinkIconTaskLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
            defaultMessage: 'Task',
            description: 'icon label for a jira task'
        },
        hyperlinkIconPageLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
            defaultMessage: 'Page',
            description: 'icon label for a confluence page'
        },
        hyperlinkIconBlogLabel: {
            id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
            defaultMessage: 'Blog',
            description: 'icon label for a confluence blog'
        }
    });
});
parcelRegister("9Ox4G", function(module, exports) {
    $parcel$export(module.exports, "EditToolbarButton", ()=>$64141cc208f415cc$export$4f24788e7d04736b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $80CM7;
    var $jDuvE;
    var $e3WeH;
    var $2ENth;
    var $8v0FX;
    var $eGiVQ;
    var $6Ingq;
    var $kJpBP;
    var $kgoHi;
    var $89B6e;
    var $aKWRt;
    var $e8zuf;
    var $4BLK3;
    var $dYS3B;
    var $2Athq;
    const $64141cc208f415cc$var$dropdownExpandContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
    });
    const $64141cc208f415cc$var$EditToolbarButtonWithCardContext = (props)=>{
        const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
        const { extensionKey: extensionKey, ...response } = (0, (0, parcelRequire("dYS3B")).useFetchDatasourceInfo)({
            isRegularCardNode: true,
            url: url,
            cardContext: cardContext
        });
        const datasourceId = response.datasourceId ?? props.datasourceId;
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const containerRef = (0, $5uXOq.useRef)();
        const toggleOpen = ()=>setIsOpen((open)=>!open);
        const onClose = ()=>setIsOpen(false);
        const onEditLink = (0, $5uXOq.useCallback)(()=>{
            if (editorView) {
                onLinkEditClick(editorView.state, editorView.dispatch);
                (0, (0, parcelRequire("89B6e")).focusEditorView)(editorView);
            }
        }, [
            editorView,
            onLinkEditClick
        ]);
        const editVariant = (0, $5uXOq.useMemo)(()=>{
            const hasUrl = url !== null && url !== undefined;
            if (!datasourceId || !(0, (0, parcelRequire("89B6e")).isDatasourceConfigEditable)(datasourceId)) {
                if (hasUrl) return 'edit-link';
                return 'none';
            }
            if (hasUrl) {
                const urlState = cardContext?.store?.getState()[url];
                if (urlState?.error?.kind === 'fatal') return 'edit-link';
                return 'edit-dropdown';
            } else return 'edit-datasource';
        }, [
            cardContext?.store,
            datasourceId,
            url
        ]);
        const onEditDatasource = (0, $5uXOq.useCallback)(()=>{
            if (editorView && datasourceId) {
                (0, (0, parcelRequire("e8zuf")).editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
                (0, (0, parcelRequire("89B6e")).focusEditorView)(editorView);
            }
        }, [
            currentAppearance,
            datasourceId,
            editorAnalyticsApi,
            editorView,
            extensionKey
        ]);
        switch(editVariant){
            case 'edit-link':
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                    gap: "space.050"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                    testId: "edit-link",
                    onClick: onEditLink
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
            case 'edit-datasource':
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                    gap: "space.050"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                    testId: "edit-datasource",
                    tooltipContent: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editDatasourceStandaloneTooltip),
                    onClick: onEditDatasource
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editDatasourceStandalone)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
            case 'edit-dropdown':
                {
                    const trigger = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                        gap: "space.050"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                        testId: "edit-dropdown-trigger",
                        iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                            css: $64141cc208f415cc$var$dropdownExpandContainer
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).editDropdownTriggerTitle)
                        })),
                        onClick: toggleOpen,
                        selected: isOpen,
                        disabled: false,
                        ariaHasPopup: true
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownTriggerTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
                    return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                        ref: containerRef
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eGiVQ")).DropdownContainer), {
                        mountTo: containerRef.current,
                        isOpen: isOpen,
                        handleClickOutside: onClose,
                        handleEscapeKeydown: onClose,
                        trigger: trigger,
                        scrollableElement: containerRef.current,
                        arrowKeyNavigationProviderOptions: {
                            type: (0, (0, parcelRequire("8v0FX")).ArrowKeyNavigationType).MENU
                        }
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kJpBP")).default), {
                        key: "edit.link",
                        onClick: onEditLink,
                        testId: "edit-dropdown-edit-link-item"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownEditLinkTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kJpBP")).default), {
                        key: "edit.datasource",
                        onClick: onEditDatasource,
                        testId: "edit-dropdown-edit-datasource-item"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownEditDatasourceTitle))));
                }
            case 'none':
            default:
                return null;
        }
    };
    const $64141cc208f415cc$var$EditToolbarButtonWithUrl = (props)=>{
        const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
        const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, (0, parcelRequire("dYS3B")).useFetchDatasourceInfo)({
            isRegularCardNode: true,
            url: url,
            cardContext: cardContext
        });
        const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
        const editVariant = (0, $5uXOq.useMemo)(()=>{
            if (!datasourceId || !(0, (0, parcelRequire("89B6e")).isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
            const urlState = cardContext?.store?.getState()[url];
            if (urlState?.error?.kind === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        }, [
            cardContext?.store,
            datasourceId,
            url
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2Athq")).default), {
            datasourceId: datasourceId,
            currentAppearance: currentAppearance,
            editorAnalyticsApi: editorAnalyticsApi,
            editVariant: editVariant,
            editorView: editorView,
            extensionKey: extensionKey,
            onLinkEditClick: onLinkEditClick,
            intl: intl
        });
    };
    const $64141cc208f415cc$var$EditToolbarButtonWithDatasourceId = (props)=>{
        const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node } = props;
        const fetchData = (0, $5uXOq.useMemo)(()=>{
            try {
                const attrs = node.attrs;
                const parameters = attrs.datasource.parameters;
                const visibleColumnKeys = attrs.datasource.views[0]?.properties?.columns.map((c)=>c.key);
                return {
                    parameters: parameters,
                    visibleColumnKeys: visibleColumnKeys
                };
            } catch (e) {
                console.error(e);
            }
        }, [
            node.attrs
        ]);
        const { extensionKey: extensionKey } = (0, (0, parcelRequire("4BLK3")).useFetchDatasourceDataInfo)({
            datasourceId: datasourceId,
            parameters: fetchData?.parameters,
            visibleColumnKeys: fetchData?.visibleColumnKeys
        });
        const editVariant = (0, $5uXOq.useMemo)(()=>{
            if (!datasourceId || !(0, (0, parcelRequire("89B6e")).isDatasourceConfigEditable)(datasourceId)) return 'none';
            return 'edit-datasource';
        }, [
            datasourceId
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2Athq")).default), {
            datasourceId: datasourceId,
            currentAppearance: currentAppearance,
            editorAnalyticsApi: editorAnalyticsApi,
            editVariant: editVariant,
            editorView: editorView,
            extensionKey: extensionKey,
            onLinkEditClick: onLinkEditClick,
            intl: intl
        });
    };
    const $64141cc208f415cc$export$4f24788e7d04736b = (props)=>{
        const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aKWRt")).CardContextProvider), null, ({ cardContext: cardContext })=>{
            if (props.url) return (0, (0, parcelRequire("f8Sb3")).jsx)($64141cc208f415cc$var$EditToolbarButtonWithUrl, {
                datasourceId: datasourceId,
                url: props.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                cardContext: cardContext,
                onLinkEditClick: onLinkEditClick,
                currentAppearance: currentAppearance
            });
            if (props.datasourceId && props.node) return (0, (0, parcelRequire("f8Sb3")).jsx)($64141cc208f415cc$var$EditToolbarButtonWithDatasourceId, {
                datasourceId: props.datasourceId,
                node: props.node,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: onLinkEditClick,
                currentAppearance: currentAppearance
            });
            return (0, (0, parcelRequire("f8Sb3")).jsx)($64141cc208f415cc$var$EditToolbarButtonWithCardContext, {
                datasourceId: datasourceId,
                url: url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                cardContext: cardContext,
                onLinkEditClick: onLinkEditClick,
                currentAppearance: currentAppearance
            });
        });
    };
});
parcelRegister("2ENth", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f6bb55008eb3feca$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $f6bb55008eb3feca$var$separator = (0, (0, parcelRequire("f8Sb3")).css)({
        background: "var(--ds-border, #091E4224)",
        width: '1px',
        height: '20px',
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        alignSelf: 'center'
    });
    var $f6bb55008eb3feca$export$2e2bcd8739ae039 = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $f6bb55008eb3feca$var$separator,
            className: "separator"
        });
});
parcelRegister("eGiVQ", function(module, exports) {
    $parcel$export(module.exports, "DropdownContainer", ()=>$f0ce2cd52ae2d408$export$49166591ec160d97);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8v0FX;
    var $iFvNE;
    var $kdDpx;
    const $f0ce2cd52ae2d408$export$49166591ec160d97 = (0, ($parcel$interopDefault($5uXOq))).memo(function DropdownContainer(props) {
        const keyDownHandlerContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("kdDpx")).KeyDownHandlerContext));
        let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
        if (props.arrowKeyNavigationProviderOptions.type === (0, (0, parcelRequire("8v0FX")).ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("iFvNE")).default), {
            ...props,
            arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
        }));
    });
});
parcelRegister("iFvNE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$504d98097ea5e13b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jdyxs;
    var $iraaj;
    var $4N9VB;
    var $2WNBA;
    class $504d98097ea5e13b$export$931cbfb6bfb85fc extends (0, $5uXOq.PureComponent) {
        constructor(props){
            super(props), this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                    setOutsideClickTargetRef(target);
                    this.setState({
                        target: target || undefined
                    });
                }, this.updatePopupPlacement = (placement)=>{
                this.setState({
                    popupPlacement: placement
                });
            }, this.handleCloseAndFocus = (event)=>{
                this.state.target?.querySelector('button')?.focus();
                this.handleClose(event);
            }, this.handleClose = (event)=>{
                if (this.props.onOpenChange) this.props.onOpenChange({
                    isOpen: false,
                    event: event
                });
            };
            this.state = {
                popupPlacement: [
                    'bottom',
                    'left'
                ]
            };
        }
        renderDropdown() {
            const { target: target, popupPlacement: popupPlacement } = this.state;
            const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4N9VB")).default), {
                target: alignDropdownWithParentElement ? target?.closest("[data-testid='editor-floating-toolbar']") : target,
                mountTo: mountTo,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                onPlacementChanged: this.updatePopupPlacement,
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: zIndex,
                allowOutOfBounds: alignDropdownWithParentElement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2WNBA")).ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    height: 0,
                    minWidth: fitWidth || 0
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iraaj")).default), {
                isOpen: true,
                onOpenChange: onOpenChange,
                position: popupPlacement.join(' '),
                shouldFitContainer: true,
                id: dropdownListId
            }, children))));
        }
        render() {
            const { trigger: trigger, isOpen: isOpen } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdyxs")).OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    ref: this.handleRef(setOutsideClickTargetRef)
                }, trigger), isOpen ? this.renderDropdown() : null));
        }
    }
    const $504d98097ea5e13b$var$DropdownWithOuterListeners = (0, (0, parcelRequire("jdyxs")).default)($504d98097ea5e13b$export$931cbfb6bfb85fc);
    var $504d98097ea5e13b$export$2e2bcd8739ae039 = $504d98097ea5e13b$var$DropdownWithOuterListeners;
});
parcelRegister("e8zuf", function(module, exports) {
    $parcel$export(module.exports, "editDatasource", ()=>$010a3cf1d7bb3474$export$687401cc190b9ec3);
    var $gkwXh;
    var $3dBkm;
    var $nYpqR;
    const $010a3cf1d7bb3474$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
            const datasourceType = (0, (0, parcelRequire("3dBkm")).getDatasourceType)(datasourceId);
            if (dispatch && datasourceType) {
                const { tr: tr } = state;
                (0, (0, parcelRequire("nYpqR")).showDatasourceModal)(datasourceType)(tr);
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).CLICKED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI,
                    attributes: {
                        extensionKey: extensionKey,
                        appearance: appearance
                    }
                })(tr);
                dispatch(tr);
                return true;
            }
            return false;
        };
});
parcelRegister("4BLK3", function(module, exports) {
    $parcel$export(module.exports, "useFetchDatasourceDataInfo", ()=>$4574e4b53667a1e5$export$25222ec28f4cbba5);
    var $5uXOq = parcelRequire("5uXOq");
    var $vE5bM;
    const $4574e4b53667a1e5$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
        const [extensionKey, setExtensionKey] = (0, $5uXOq.useState)(undefined);
        const { getDatasourceData: getDatasourceData } = (0, (0, parcelRequire("vE5bM")).useDatasourceClientExtension)();
        (0, $5uXOq.useEffect)(()=>{
            const fetchDatasource = async ()=>{
                try {
                    if (!datasourceId || !parameters || !visibleColumnKeys) return;
                    const datasourceDataRequest = {
                        parameters: parameters,
                        pageSize: (0, (0, parcelRequire("vE5bM")).DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                        pageCursor: undefined,
                        fields: visibleColumnKeys,
                        includeSchema: true
                    };
                    const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                    setExtensionKey(meta.extensionKey);
                } catch (e) {
                    console.error(e);
                    setExtensionKey(undefined);
                }
            };
            fetchDatasource();
        }, [
            getDatasourceData,
            visibleColumnKeys,
            parameters,
            datasourceId
        ]);
        return {
            extensionKey: extensionKey
        };
    };
});
parcelRegister("vE5bM", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE", ()=>$68367fd71731b630$export$5e074c0b68e2ce03);
    $parcel$export(module.exports, "useDatasourceClientExtension", ()=>$68367fd71731b630$export$7d812bb756889442);
    var $5uXOq = parcelRequire("5uXOq");
    var $iwKVT = parcelRequire("iwKVT");
    var $kECas;
    var $dV0Jy;
    var $3b94d;
    const $68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE = 50;
    const $68367fd71731b630$export$f82fcd766a8daa7f = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
    const $68367fd71731b630$export$40b1dd31340bd5c2 = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
    const $68367fd71731b630$export$15cd58682efec5a5 = new (0, $iwKVT.LRUMap)($68367fd71731b630$var$URL_RESPONSE_CACHE_SIZE);
    const $68367fd71731b630$export$5e074c0b68e2ce03 = 20;
    const $68367fd71731b630$export$7d812bb756889442 = ()=>{
        const { connections: { client: client } } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        const resolverUrl = (0, (0, parcelRequire("3b94d")).useResolverUrl)(client);
        const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
            const cacheKeyData = {
                ...data,
                ...'fields' in data ? {
                    fields: [
                        ...data.fields || []
                    ].sort()
                } : {},
                ...'fieldKeys' in data ? {
                    fieldKeys: [
                        ...data.fieldKeys || []
                    ].sort()
                } : {}
            };
            const cacheKey = JSON.stringify({
                cacheKeyId: cacheKeyId,
                cacheKeyData: cacheKeyData
            });
            if (force) lruMap.delete(cacheKey);
            let responsePromise = lruMap.get(cacheKey);
            if (responsePromise) return responsePromise;
            const headers = {
                'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
            };
            try {
                responsePromise = (0, (0, parcelRequire("dV0Jy")).request)('post', url, data, headers, [
                    200,
                    201,
                    202,
                    203,
                    204
                ]);
                lruMap.set(cacheKey, responsePromise);
                return await responsePromise;
            } catch (e) {
                lruMap.delete(cacheKey);
                throw e;
            }
        };
        const uncachedRequest = async (data, url)=>{
            const responsePromise = (0, (0, parcelRequire("dV0Jy")).request)('post', url, data, undefined, [
                200,
                201,
                202,
                203,
                204
            ]);
            return responsePromise;
        };
        const getDatasourceDetails = (0, $5uXOq.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $68367fd71731b630$export$f82fcd766a8daa7f, force), [
            resolverUrl
        ]);
        const getDatasourceData = (0, $5uXOq.useCallback)(async (datasourceId, data, force = false)=>cachedRequest(datasourceId, data, `${resolverUrl}/datasource/${datasourceId}/fetch/data`, $68367fd71731b630$export$40b1dd31340bd5c2, force), [
            resolverUrl
        ]);
        const getDatasourceActionsAndPermissions = (0, $5uXOq.useCallback)(async (data, force = false)=>{
            const resolvedCacheIdKey = 'datasourceId' in data ? data.datasourceId : data.integrationKey;
            if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
            return cachedRequest(resolvedCacheIdKey, data, `${resolverUrl}/actions`, $68367fd71731b630$export$15cd58682efec5a5, force);
        }, [
            resolverUrl
        ]);
        const executeAtomicAction = (0, $5uXOq.useCallback)(async (data)=>uncachedRequest(data, `${resolverUrl}/actions/execute`), [
            resolverUrl
        ]);
        const invalidateDatasourceDataCacheByAri = (0, $5uXOq.useCallback)((ari)=>{
            $68367fd71731b630$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
                const response = await value;
                const targetFound = response.data.items.some((item)=>{
                    return item['ari']?.data === ari;
                });
                if (targetFound) $68367fd71731b630$export$40b1dd31340bd5c2.delete(key);
            });
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                getDatasourceDetails: getDatasourceDetails,
                getDatasourceData: getDatasourceData,
                getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
                executeAtomicAction: executeAtomicAction,
                invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
            }), [
            getDatasourceDetails,
            getDatasourceData,
            getDatasourceActionsAndPermissions,
            executeAtomicAction,
            invalidateDatasourceDataCacheByAri
        ]);
    };
});
parcelRegister("2Athq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$726711b8d0afaac8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $ousew;
    var $80CM7;
    var $jDuvE;
    var $e3WeH;
    var $2ENth;
    var $8v0FX;
    var $eGiVQ;
    var $6Ingq;
    var $kJpBP;
    var $kgoHi;
    var $89B6e;
    var $e8zuf;
    const $726711b8d0afaac8$var$dropdownExpandContainer = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
    });
    const $726711b8d0afaac8$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const containerRef = (0, $5uXOq.useRef)();
        const toggleOpen = ()=>setIsOpen((open)=>!open);
        const onClose = ()=>setIsOpen(false);
        const onEditLink = (0, $5uXOq.useCallback)(()=>{
            if (editorView) {
                onLinkEditClick(editorView.state, editorView.dispatch);
                (0, (0, parcelRequire("89B6e")).focusEditorView)(editorView);
            }
        }, [
            editorView,
            onLinkEditClick
        ]);
        const onEditDatasource = (0, $5uXOq.useCallback)(()=>{
            if (editorView && datasourceId) {
                (0, (0, parcelRequire("e8zuf")).editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
                (0, (0, parcelRequire("89B6e")).focusEditorView)(editorView);
            }
        }, [
            currentAppearance,
            datasourceId,
            editorAnalyticsApi,
            editorView,
            extensionKey
        ]);
        switch(editVariant){
            case 'edit-link':
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                    gap: "space.050"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                    testId: "edit-link",
                    onClick: onEditLink
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
            case 'edit-datasource':
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                    gap: "space.050"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                    testId: "edit-datasource",
                    tooltipContent: intl.formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editDatasourceStandaloneTooltip),
                    onClick: onEditDatasource
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editDatasourceStandalone)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
            case 'edit-dropdown':
                {
                    const trigger = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                        gap: "space.050"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                        testId: "edit-dropdown-trigger",
                        iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                            css: $726711b8d0afaac8$var$dropdownExpandContainer
                        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                            label: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).editDropdownTriggerTitle)
                        })),
                        onClick: toggleOpen,
                        selected: isOpen,
                        disabled: false,
                        ariaHasPopup: true
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownTriggerTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2ENth")).default), null));
                    return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                        ref: containerRef
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eGiVQ")).DropdownContainer), {
                        mountTo: containerRef.current,
                        isOpen: isOpen,
                        handleClickOutside: onClose,
                        handleEscapeKeydown: onClose,
                        trigger: trigger,
                        scrollableElement: containerRef.current,
                        arrowKeyNavigationProviderOptions: {
                            type: (0, (0, parcelRequire("8v0FX")).ArrowKeyNavigationType).MENU
                        }
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kJpBP")).default), {
                        key: "edit.link",
                        onClick: onEditLink,
                        testId: "edit-dropdown-edit-link-item"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownEditLinkTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kJpBP")).default), {
                        key: "edit.datasource",
                        onClick: onEditDatasource,
                        testId: "edit-dropdown-edit-datasource-item"
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("80CM7")).messages).editDropdownEditDatasourceTitle))));
                }
            case 'none':
            default:
                return null;
        }
    };
    var $726711b8d0afaac8$export$2e2bcd8739ae039 = $726711b8d0afaac8$var$EditToolbarButtonPresentation;
});
parcelRegister("6rhck", function(module, exports) {
    $parcel$export(module.exports, "HyperlinkToolbarAppearance", ()=>$b1bfb113bd22e46e$export$33d351e602b13f5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gkwXh;
    var $2ENth;
    var $kgoHi;
    var $fo6j3;
    var $fjdBk;
    function $b1bfb113bd22e46e$export$33d351e602b13f5c(props) {
        const [supportedUrlsMap, setSupportedUrlsMap] = (0, $5uXOq.useState)(new Map());
        const cardProvider = (0, $5uXOq.useRef)(undefined);
        const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
        const getProvider = async ()=>{
            if (props.cardOptions?.provider) return props.cardOptions?.provider;
            if (cardProvider.current) return cardProvider.current;
            return new Promise((resolve)=>{
                const cardProvider = props.editorPluginApi?.card?.sharedState?.currentState()?.provider;
                if (cardProvider) resolve(cardProvider);
            });
        };
        const resolveUrl = async (url)=>{
            if (supportedUrlsMap.has(url)) return;
            let isUrlSupported = false;
            try {
                const provider = await getProvider();
                isUrlSupported = await provider?.findPattern(url) ?? false;
            } catch (error) {
                isUrlSupported = false;
            }
            const newMap = new Map(supportedUrlsMap);
            newMap.set(url, isUrlSupported);
            setSupportedUrlsMap(newMap);
        };
        (0, $5uXOq.useEffect)(()=>{
            resolveUrl(url);
        }, [
            url,
            props.cardOptions?.provider,
            props.editorPluginApi
        ]);
        if (!supportedUrlsMap.get(url)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjdBk")).LinkToolbarAppearance), {
            key: "link-appearance",
            url: url,
            intl: intl,
            editorView: editorView,
            editorState: editorState,
            allowEmbeds: cardOptions?.allowEmbeds,
            allowBlockCards: cardOptions?.allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi
        }), cardOptions?.allowDatasource && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fo6j3")).DatasourceAppearanceButton), {
            intl: intl,
            url: url,
            editorState: editorState,
            editorView: editorView,
            editorAnalyticsApi: editorAnalyticsApi,
            inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2ENth")).default), null));
    }
});
parcelRegister("fjdBk", function(module, exports) {
    $parcel$export(module.exports, "LinkToolbarAppearance", ()=>$b0fc053941b9b8d2$export$2a8c6fb42753b13e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $daJ0i;
    var $gkwXh;
    var $1ZWXY;
    var $67IYF;
    var $6uxIG;
    var $80CM7;
    var $8DYpW;
    var $20Kbb;
    var $kCV8T;
    var $1Ly3h;
    var $jPiXc;
    var $cEDVI;
    var $89B6e;
    var $9HVke;
    class $b0fc053941b9b8d2$export$2a8c6fb42753b13e extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        render() {
            const cardContext = this.context.contextAdapter ? this.context.contextAdapter.card : undefined;
            const { editorView: editorView } = this.props;
            return this.renderDropdown(editorView, cardContext && cardContext.value);
        }
        constructor(...args){
            super(...args), this.renderDropdown = (view, cardContext)=>{
                const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView } = this.props;
                const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
                const defaultCommand = ()=>false;
                if (url) {
                    const urlState = cardContext?.store?.getState()[url];
                    if (urlState?.error?.kind === 'fatal') return null;
                }
                const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, (0, parcelRequire("20Kbb")).isSupportedInParent)(editorState, (0, (0, parcelRequire("kCV8T")).Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
                const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, (0, parcelRequire("20Kbb")).isSupportedInParent)(editorState, (0, (0, parcelRequire("kCV8T")).Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
                const embedOption = allowEmbeds && preview && {
                    appearance: 'embed',
                    title: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).embed),
                    onClick: (0, (0, parcelRequire("jPiXc")).setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'embed',
                    hidden: false,
                    testId: 'embed-appearance',
                    disabled: !isEmbedCardLinkSupportedInParent,
                    tooltip: isEmbedCardLinkSupportedInParent ? undefined : $b0fc053941b9b8d2$var$getUnavailableMessage(editorState, intl)
                };
                const blockCardOption = allowBlockCards && {
                    appearance: 'block',
                    title: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).block),
                    onClick: (0, (0, parcelRequire("jPiXc")).setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'block' && !isDatasourceView,
                    testId: 'block-appearance',
                    disabled: !isBlockCardLinkSupportedInParent,
                    tooltip: isBlockCardLinkSupportedInParent ? undefined : $b0fc053941b9b8d2$var$getUnavailableMessage(editorState, intl)
                };
                const options = [
                    {
                        title: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).url),
                        onClick: (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((0, (0, parcelRequire("jPiXc")).changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                            action: (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE
                        }),
                        selected: !currentAppearance && !isDatasourceView,
                        testId: 'url-appearance'
                    },
                    {
                        appearance: 'inline',
                        title: intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).inline),
                        onClick: (0, (0, parcelRequire("jPiXc")).setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                        selected: currentAppearance === 'inline',
                        testId: 'inline-appearance'
                    }
                ];
                const dispatchCommand = (fn)=>{
                    fn && fn(editorState, view && view.dispatch);
                    if (view && !view.hasFocus()) view.focus();
                };
                if (blockCardOption) options.push(blockCardOption);
                if (embedOption) options.push(embedOption);
                const LinkToolbarButtons = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6uxIG")).LinkToolbarButtonGroup), {
                    key: "link-toolbar-button-group",
                    options: options.map((option)=>(0, (0, parcelRequire("67IYF")).getButtonGroupOption)(intl, dispatchCommand, {
                            ...option,
                            onClick: (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)(option.onClick, {
                                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
                            })
                        }))
                });
                const status = url ? cardContext?.store?.getState()[url]?.status : '';
                const embedEnabled = embedOption ? !embedOption.disabled : false;
                if ((0, (0, parcelRequire("cEDVI")).shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                    const resolvedAnalyticsAttributes = (0, (0, parcelRequire("89B6e")).getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext?.store);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daJ0i")).default), {
                        data: {
                            attributes: {
                                ...resolvedAnalyticsAttributes
                            }
                        }
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9HVke")).DiscoveryPulse), {
                        localStorageKey: (0, (0, parcelRequire("1Ly3h")).LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse"
                    }, LinkToolbarButtons));
                }
                return LinkToolbarButtons;
            };
        }
    }
    const $b0fc053941b9b8d2$var$getUnavailableMessage = (state, intl)=>{
        try {
            const parentNode = state.selection.$from.node(1);
            const parentName = intl.formatMessage((0, (0, parcelRequire("8DYpW")).default)[parentNode.type.name]);
            const tooltip = intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).displayOptionUnavailableInParentNode, {
                node: parentName
            });
            return tooltip;
        } catch (e) {
            return intl.formatMessage((0, (0, parcelRequire("80CM7")).messages).displayOptionUnavailableInParentNode, {
                node: intl.formatMessage((0, (0, parcelRequire("8DYpW")).default).defaultBlockNode)
            });
        }
    };
});
parcelRegister("67IYF", function(module, exports) {
    $parcel$export(module.exports, "getButtonGroupOption", ()=>$01e705790f2b3935$export$9de0d67eaa25f178);
    var $cGbU6;
    var $8pZDY;
    var $cRyJJ;
    var $55fIV;
    var $80CM7;
    var $af088;
    var $alziS;
    var $b9sDD;
    var $cPNp9;
    const $01e705790f2b3935$var$appearancePropsMap = {
        url: {
            title: (0, (0, parcelRequire("80CM7")).messages).urlTitle,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("cGbU6"))))),
            iconFallback: (0, (0, parcelRequire("cPNp9")).IconUrl)
        },
        inline: {
            title: (0, (0, parcelRequire("80CM7")).messages).inlineTitle,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("55fIV"))))),
            iconFallback: (0, (0, parcelRequire("b9sDD")).IconInline)
        },
        block: {
            title: (0, (0, parcelRequire("80CM7")).messages).blockTitle,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("8pZDY"))))),
            iconFallback: (0, (0, parcelRequire("af088")).IconCard)
        },
        embed: {
            title: (0, (0, parcelRequire("80CM7")).messages).embedTitle,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("cRyJJ"))))),
            iconFallback: (0, (0, parcelRequire("alziS")).IconEmbed)
        }
    };
    const $01e705790f2b3935$export$9de0d67eaa25f178 = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
        const { title: title, icon: icon, iconFallback: iconFallback } = $01e705790f2b3935$var$appearancePropsMap[appearance ?? 'url'];
        return {
            title: intl.formatMessage(title),
            icon: icon,
            iconFallback: iconFallback,
            onClick: ()=>dispatchCommand(onClick),
            disabled: Boolean(disabled),
            tooltipContent: tooltip || null,
            testId: testId,
            selected: selected
        };
    };
});
parcelRegister("cGbU6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $93b2a42556cf480d$var$_react = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $93b2a42556cf480d$var$_UNSAFE_baseNew = $93b2a42556cf480d$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $93b2a42556cf480d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93b2a42556cf480d$var$MinusIcon = (props)=>$93b2a42556cf480d$var$_react.default.createElement($93b2a42556cf480d$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M2 8h12"/>`
        }, props));
    $93b2a42556cf480d$var$MinusIcon.displayName = 'MinusIcon';
    var $93b2a42556cf480d$var$_default = module.exports.default = $93b2a42556cf480d$var$MinusIcon;
});
parcelRegister("8pZDY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $621079ace3fec8f8$var$_react = $621079ace3fec8f8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $621079ace3fec8f8$var$_UNSAFE_baseNew = $621079ace3fec8f8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $621079ace3fec8f8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $621079ace3fec8f8$var$SmartLinkCardIcon = (props)=>$621079ace3fec8f8$var$_react.default.createElement($621079ace3fec8f8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.75 3.75H2C1.31 3.75.75 4.31.75 5v6c0 .69.56 1.25 1.25 1.25h8.75m0-8.5H14c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25h-3.25m0-8.5v8.5M3 6.75h5.5M3 9.25h3"/>`
        }, props));
    $621079ace3fec8f8$var$SmartLinkCardIcon.displayName = 'SmartLinkCardIcon';
    var $621079ace3fec8f8$var$_default = module.exports.default = $621079ace3fec8f8$var$SmartLinkCardIcon;
});
parcelRegister("cRyJJ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $95d5613ff1130c53$var$_react = $95d5613ff1130c53$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $95d5613ff1130c53$var$_UNSAFE_baseNew = $95d5613ff1130c53$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $95d5613ff1130c53$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $95d5613ff1130c53$var$SmartLinkEmbedIcon = (props)=>$95d5613ff1130c53$var$_react.default.createElement($95d5613ff1130c53$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 7.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V7.75m-12.5 0V3c0-.69.56-1.25 1.25-1.25h10c.69 0 1.25.56 1.25 1.25v4.75m-12.5 0h12.5M4 4.75h1.5m1.5 0h5"/>`
        }, props));
    $95d5613ff1130c53$var$SmartLinkEmbedIcon.displayName = 'SmartLinkEmbedIcon';
    var $95d5613ff1130c53$var$_default = module.exports.default = $95d5613ff1130c53$var$SmartLinkEmbedIcon;
});
parcelRegister("55fIV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3b399dc6534ce487$var$_react = $3b399dc6534ce487$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3b399dc6534ce487$var$_UNSAFE_baseNew = $3b399dc6534ce487$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3b399dc6534ce487$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3b399dc6534ce487$var$SmartLinkInlineIcon = (props)=>$3b399dc6534ce487$var$_react.default.createElement($3b399dc6534ce487$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M5.25 5.75H2C1.31 5.75.75 6.31.75 7v2c0 .69.56 1.25 1.25 1.25h3.25m0-4.5H14c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25H5.25m0-4.5v4.5"/>`
        }, props));
    $3b399dc6534ce487$var$SmartLinkInlineIcon.displayName = 'SmartLinkInlineIcon';
    var $3b399dc6534ce487$var$_default = module.exports.default = $3b399dc6534ce487$var$SmartLinkInlineIcon;
});
parcelRegister("af088", function(module, exports) {
    $parcel$export(module.exports, "IconCard", ()=>$cb57a73c5e7dd50b$export$f215a85d3e7de2fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $cb57a73c5e7dd50b$var$IconCardGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 9c-1.10457 0-2 .89543-2 2v10c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V11c0-1.10457-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Zm-4 3c-.55228 0-1 .4477-1 1s.44772 1 1 1h14c.5523 0 1-.4477 1-1s-.4477-1-1-1H9Zm-1 4c0-.5523.44772-1 1-1h6c.5523 0 1 .4477 1 1s-.4477 1-1 1H9c-.55228 0-1-.4477-1-1Z",
            fill: "currentColor"
        }));
    };
    const $cb57a73c5e7dd50b$export$f215a85d3e7de2fe = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $cb57a73c5e7dd50b$var$IconCardGlyph,
            ...props
        });
    };
});
parcelRegister("alziS", function(module, exports) {
    $parcel$export(module.exports, "IconEmbed", ()=>$c69d46abe545dc68$export$6e9714fda61b68c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $c69d46abe545dc68$var$IconEmbedGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 6c-1.10457 0-2 .89543-2 2v16c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2V8c0-1.10457-.8954-2-2-2H8Zm1 2c-.55228 0-1 .44772-1 1v2c0 .5523.44772 1 1 1h2c.5523 0 1-.4477 1-1V9c0-.55228-.4477-1-1-1H9Zm4.5 1.5c-.2761 0-.5.22386-.5.5 0 .2761.2239.5.5.5h10c.2761 0 .5-.2239.5-.5 0-.27614-.2239-.5-.5-.5h-10ZM9 14c-.55228 0-1 .4477-1 1v8c0 .5523.44772 1 1 1h14c.5523 0 1-.4477 1-1v-8c0-.5523-.4477-1-1-1H9Zm6 2.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5.6716-1.5 1.5-1.5 1.5.6716 1.5 1.5Zm0 5.5-1-1-2 2h8v-1.8L18 19l-3 3Z",
            fill: "currentColor"
        }));
    };
    const $c69d46abe545dc68$export$6e9714fda61b68c1 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $c69d46abe545dc68$var$IconEmbedGlyph,
            ...props
        });
    };
});
parcelRegister("b9sDD", function(module, exports) {
    $parcel$export(module.exports, "IconInline", ()=>$f33b4f797989977d$export$f96c97cd8120c1d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $f33b4f797989977d$var$IconInlineGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 12c-1.10457 0-2 .8954-2 2v4c0 1.1046.89543 2 2 2h16c1.1046 0 2-.8954 2-2v-4c0-1.1046-.8954-2-2-2H8Zm0 3c0-.5523.44772-1 1-1h2c.5523 0 1 .4477 1 1v2c0 .5523-.4477 1-1 1H9c-.55228 0-1-.4477-1-1v-2Zm5 1c0-.2761.2239-.5.5-.5h10c.2761 0 .5.2239.5.5s-.2239.5-.5.5h-10c-.2761 0-.5-.2239-.5-.5Z",
            fill: "currentColor"
        }));
    };
    const $f33b4f797989977d$export$f96c97cd8120c1d7 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $f33b4f797989977d$var$IconInlineGlyph,
            ...props
        });
    };
});
parcelRegister("cPNp9", function(module, exports) {
    $parcel$export(module.exports, "IconUrl", ()=>$b89b64333706e5c1$export$faea2896e79f2987);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $b89b64333706e5c1$var$IconUrlGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "6",
            y: "15",
            width: "20",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }));
    };
    const $b89b64333706e5c1$export$faea2896e79f2987 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $b89b64333706e5c1$var$IconUrlGlyph,
            ...props
        });
    };
});
parcelRegister("6uxIG", function(module, exports) {
    $parcel$export(module.exports, "LinkToolbarButtonGroup", ()=>$6db7d535e0963d77$export$41ba5f90e13b0c51);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $ldJSL;
    var $e3WeH;
    function $6db7d535e0963d77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6db7d535e0963d77$var$buttonStyle = {
        name: "1quw0ni",
        styles: "pointer-events:auto"
    };
    const $6db7d535e0963d77$var$buttonStyleNoneEvent = {
        name: "je8g23",
        styles: "pointer-events:none"
    };
    const $6db7d535e0963d77$var$DisallowedWrapper = ({ disabled: disabled, ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", props);
    };
    const $6db7d535e0963d77$var$defaultWrapperStyle = {
        name: "e0dnmk",
        styles: "cursor:pointer"
    };
    const $6db7d535e0963d77$var$disallowedWrapperStyle = {
        name: "1sfig4b",
        styles: "cursor:not-allowed"
    };
    const $6db7d535e0963d77$export$41ba5f90e13b0c51 = ({ options: options })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ldJSL")).default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, iconFallback: iconFallback })=>{
            const ButtonIcon = icon;
            return (0, (0, parcelRequire("f8Sb3")).jsx)($6db7d535e0963d77$var$DisallowedWrapper, {
                css: disabled ? $6db7d535e0963d77$var$disallowedWrapperStyle : $6db7d535e0963d77$var$defaultWrapperStyle,
                key: testId,
                disabled: disabled
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e3WeH")).default), {
                css: disabled ? $6db7d535e0963d77$var$buttonStyleNoneEvent : $6db7d535e0963d77$var$buttonStyle,
                title: title,
                icon: (0, (0, parcelRequire("f8Sb3")).jsx)(ButtonIcon, {
                    label: title,
                    spacing: "spacious",
                    LEGACY_size: "medium",
                    LEGACY_fallbackIcon: iconFallback
                }),
                selected: selected,
                onClick: onClick,
                testId: testId,
                disabled: disabled,
                tooltipContent: tooltipContent
            }));
        }));
    };
});
parcelRegister("hv7lU", function(module, exports) {
    $parcel$export(module.exports, "ToolbarViewedEvent", ()=>$95d14e1a206e7f9b$export$998ac2a59a1547dd);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $89B6e;
    var $aKWRt;
    var $9NQiC;
    const $95d14e1a206e7f9b$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const store = cardContext?.store;
        (0, $5uXOq.useEffect)(()=>{
            createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'inlineDialog',
                actionSubjectId: 'editLinkToolbar',
                eventType: 'ui',
                attributes: {
                    ...(0, (0, parcelRequire("89B6e")).getResolvedAttributesFromStore)(url, display, store),
                    display: display
                }
            }).fire('media');
        }, [
            createAnalyticsEvent,
            display,
            url,
            store
        ]);
        return null;
    };
    const $95d14e1a206e7f9b$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NQiC")).EditorAnalyticsContext), {
            editorView: editorView
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKWRt")).CardContextProvider), null, ({ cardContext: cardContext })=>url ? (0, ($parcel$interopDefault($5uXOq))).createElement($95d14e1a206e7f9b$var$ToolbarViewedEventBase, {
                url: url,
                display: display,
                cardContext: cardContext
            }) : null));
    };
});
parcelRegister("dUrXD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56546fd1f6348cd8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $awTmI;
    var $lX6w0;
    var $f980L;
    var $7mvwv;
    var $gUzcH;
    var $aKWRt;
    var $h44wZ;
    const $56546fd1f6348cd8$var$ModalWithState = ({ api: api, editorView: editorView })=>{
        const { cardState: cardState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'card'
        ]);
        if (!cardState) return null;
        const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = cardState;
        if (!showDatasourceModal || !datasourceModalType) return null;
        const { datasourceId: datasourceId, componentType: componentType } = $56546fd1f6348cd8$export$aeed689b34941117[datasourceModalType];
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gUzcH")).DatasourceErrorBoundary), {
            view: editorView,
            datasourceModalType: datasourceModalType
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aKWRt")).CardContextProvider), null, ({ cardContext: cardContext })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h44wZ")).DatasourceModal), {
                view: editorView,
                cardContext: cardContext,
                datasourceId: datasourceId,
                componentType: componentType
            })));
    };
    const $56546fd1f6348cd8$export$aeed689b34941117 = {
        jira: {
            componentType: (0, (0, parcelRequire("7mvwv")).default),
            datasourceId: (0, (0, parcelRequire("7mvwv")).JIRA_LIST_OF_LINKS_DATASOURCE_ID)
        },
        'confluence-search': {
            componentType: (0, (0, parcelRequire("f980L")).default),
            datasourceId: (0, (0, parcelRequire("f980L")).CONFLUENCE_SEARCH_DATASOURCE_ID)
        },
        assets: {
            componentType: (0, (0, parcelRequire("lX6w0")).default),
            datasourceId: (0, (0, parcelRequire("lX6w0")).ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
        }
    };
    var $56546fd1f6348cd8$export$2e2bcd8739ae039 = $56546fd1f6348cd8$var$ModalWithState;
});
parcelRegister("h44wZ", function(module, exports) {
    $parcel$export(module.exports, "DatasourceModal", ()=>$b5353b37825636a3$export$95702e90d329951a);
    var $5uXOq = parcelRequire("5uXOq");
    var $gZGBX;
    var $nYpqR;
    var $jPiXc;
    var $dYS3B;
    const $b5353b37825636a3$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
        const { state: state } = view;
        const existingNode = $b5353b37825636a3$var$getExistingNode(state);
        const { dispatch: dispatch, state: { tr: transaction } } = view;
        const onClose = (0, $5uXOq.useCallback)(()=>{
            dispatch((0, (0, parcelRequire("nYpqR")).hideDatasourceModal)(transaction));
        }, [
            dispatch,
            transaction
        ]);
        const updateAdf = $b5353b37825636a3$var$useUpdateAdf(view, existingNode);
        const isRegularCardNode = !!(existingNode && !existingNode?.attrs?.datasource);
        const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = existingNode?.attrs?.datasource || {};
        const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $b5353b37825636a3$var$resolveColumnsConfig(views);
        const { parameters: parameters, ready: ready } = (0, (0, parcelRequire("dYS3B")).useFetchDatasourceInfo)({
            isRegularCardNode: isRegularCardNode,
            url: existingNode?.attrs.url,
            cardContext: cardContext,
            nodeParameters: nodeParameters
        });
        if (!ready) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            datasourceId: datasourceId,
            viewMode: isRegularCardNode ? 'inline' : 'table',
            parameters: parameters,
            url: existingNode?.attrs.url,
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys,
            onCancel: onClose,
            onInsert: updateAdf
        });
    };
    const $b5353b37825636a3$var$useUpdateAdf = (view, existingNode)=>{
        return (0, $5uXOq.useCallback)((newAdf, analyticEvent)=>{
            if (analyticEvent) analyticEvent.update((payload)=>({
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        inputMethod: 'datasource_config'
                    }
                }));
            if (existingNode) (0, (0, parcelRequire("jPiXc")).updateCardViaDatasource)({
                state: view.state,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: analyticEvent
            });
            else (0, (0, parcelRequire("jPiXc")).insertDatasource)(view.state, newAdf, view, analyticEvent);
        }, [
            existingNode,
            view
        ]);
    };
    const $b5353b37825636a3$var$getExistingNode = (state)=>{
        const { selection: selection } = state;
        let existingNode;
        const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
        return existingNode;
    };
    const $b5353b37825636a3$var$resolveColumnsConfig = (views)=>{
        const [tableView] = views;
        const visibleColumnKeys = [];
        const wrappedColumnKeys = [];
        const columnCustomSizes = {};
        const columns = tableView?.properties?.columns;
        if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
            visibleColumnKeys.push(key);
            if (width) columnCustomSizes[key] = width;
            if (isWrapped) wrappedColumnKeys.push(key);
        }
        return {
            visibleColumnKeys: visibleColumnKeys,
            wrappedColumnKeys: wrappedColumnKeys,
            columnCustomSizes: columnCustomSizes
        };
    };
});
parcelRegister("eZ5Wl", function(module, exports) {
    $parcel$export(module.exports, "EditorLinkingPlatformAnalytics", ()=>$bbf9497f600545ea$export$c083a9ed3df8f5ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $9NQiC;
    var $8SiaW;
    var $lq1wM;
    class $bbf9497f600545ea$export$c083a9ed3df8f5ac extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.contextTypes = {
                contextAdapter: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        render() {
            const cardContext = this.context?.contextAdapter?.card;
            if (!cardContext?.value) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(cardContext.Provider, {
                value: cardContext.value
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NQiC")).EditorAnalyticsContext), {
                editorView: this.props.editorView
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lq1wM")).LinkEventsBinding), this.props), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8SiaW")).DatasourceEventsBinding), this.props)));
        }
    }
});
parcelRegister("8SiaW", function(module, exports) {
    $parcel$export(module.exports, "DatasourceEventsBinding", ()=>$2ca216cd5db680ff$export$bddcbec746c26287);
    var $5uXOq = parcelRequire("5uXOq");
    var $1SrMX;
    var $cnkQa;
    var $i3FS2;
    var $igJuy;
    function $2ca216cd5db680ff$var$getDatasourceDisplay(datasourceAttrs) {
        return datasourceAttrs.datasource.views[0]?.type;
    }
    function $2ca216cd5db680ff$var$getDisplayedColumnCount(datasourceAttrs) {
        return datasourceAttrs.datasource.views[0]?.properties?.columns?.length ?? undefined;
    }
    function $2ca216cd5db680ff$var$getSearchMethod(creationMethod, metadata) {
        if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
        const { sourceEvent: sourceEvent } = metadata;
        if (sourceEvent instanceof (0, (0, parcelRequire("1SrMX")).default)) {
            const event = sourceEvent;
            return event.payload.attributes?.searchMethod;
        }
        return 'unknown';
    }
    function $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
        const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
        const display = $2ca216cd5db680ff$var$getDatasourceDisplay(datasourceAttrs);
        let inputMethod = '';
        let actions = [];
        if (metadata.inputMethod) inputMethod = (0, (0, parcelRequire("igJuy")).getMethod)(metadata) ?? '';
        else if (metadata.sourceEvent instanceof (0, (0, parcelRequire("1SrMX")).default)) {
            inputMethod = metadata.sourceEvent.payload.attributes?.inputMethod;
            actions = metadata.sourceEvent.payload.attributes?.actions;
        }
        const displayedColumnCount = $2ca216cd5db680ff$var$getDisplayedColumnCount(datasourceAttrs);
        const searchMethod = $2ca216cd5db680ff$var$getSearchMethod(inputMethod, metadata);
        return {
            actions: actions,
            inputMethod: inputMethod,
            datasourceId: datasourceId,
            display: display,
            displayedColumnCount: displayedColumnCount,
            parameters: parameters,
            searchMethod: searchMethod,
            url: url
        };
    }
    const $2ca216cd5db680ff$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
        const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, (0, parcelRequire("cnkQa")).useDatasourceLifecycleAnalytics)();
        const eventHandlers = (0, $5uXOq.useMemo)(()=>{
            return {
                [(0, (0, parcelRequire("i3FS2")).EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                    const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                    const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                    datasourceCreated({
                        datasourceId: datasourceId,
                        parameters: parameters,
                        url: url
                    }, null, {
                        actions: actions,
                        creationMethod: inputMethod,
                        display: display,
                        ...typeof displayedColumnCount === 'number' ? {
                            displayedColumnCount: displayedColumnCount
                        } : {},
                        nodeContext: nodeContext,
                        searchMethod: searchMethod
                    });
                },
                [(0, (0, parcelRequire("i3FS2")).EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                    const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                    const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                    datasourceUpdated({
                        datasourceId: datasourceId,
                        parameters: parameters,
                        url: url
                    }, null, {
                        actions: actions,
                        display: display,
                        displayedColumnCount: displayedColumnCount,
                        nodeContext: nodeContext,
                        searchMethod: searchMethod,
                        updateMethod: inputMethod
                    });
                },
                [(0, (0, parcelRequire("i3FS2")).EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                    const attributes = $2ca216cd5db680ff$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                    const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                    datasourceDeleted({
                        datasourceId: datasourceId,
                        parameters: parameters,
                        url: url
                    }, null, {
                        deleteMethod: inputMethod,
                        display: display,
                        displayedColumnCount: displayedColumnCount,
                        nodeContext: nodeContext,
                        searchMethod: searchMethod
                    });
                }
            };
        }, [
            datasourceCreated,
            datasourceUpdated,
            datasourceDeleted
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
                if (subject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
            });
            return ()=>unsubscribe();
        }, [
            eventHandlers,
            cardPluginEvents
        ]);
        return null;
    };
});
parcelRegister("cnkQa", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", ()=>$d2d4d3d1a0acd921$export$612752b1e088a45e);
    $parcel$export(module.exports, "useDatasourceLifecycleAnalytics", ()=>$d2d4d3d1a0acd921$export$c82e48d9fd97c55b);
    var $5uXOq = parcelRequire("5uXOq");
    var $gB4mS;
    var $2NMNM;
    var $kECas;
    var $joONg;
    var $jTAf7;
    var $vE5bM;
    const $d2d4d3d1a0acd921$export$612752b1e088a45e = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { store: store, connections: { client: client } } = (0, (0, parcelRequire("kECas")).useSmartLinkContext)();
        return (0, $5uXOq.useMemo)(()=>{
            const factory = (action)=>(...args)=>{
                    try {
                        (0, (0, parcelRequire("jTAf7")).runWhenIdle)(()=>{
                            (0, (0, parcelRequire("gB4mS")).default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, (0, parcelRequire("joONg")).default)('operational.fireAnalyticEvent.commenced', {
                                action: action
                            }))(createAnalyticsEvent);
                        });
                        (0, (0, parcelRequire("jTAf7")).runWhenIdle)(async ()=>{
                            const { default: fireEvent } = await (parcelRequire("kBLmj"));
                            fireEvent(action, createAnalyticsEvent, client, store)(...args);
                        });
                    } catch (error) {
                        (0, (0, parcelRequire("gB4mS")).default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, (0, parcelRequire("joONg")).default)('operational.fireAnalyticEvent.failed', {
                            error: error instanceof Error ? error.toString() : '',
                            action: action
                        }))(createAnalyticsEvent);
                    }
                };
            return {
                linkCreated: factory('created'),
                linkUpdated: factory('updated'),
                linkDeleted: factory('deleted')
            };
        }, [
            client,
            store,
            createAnalyticsEvent
        ]);
    };
    const $d2d4d3d1a0acd921$export$c82e48d9fd97c55b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { getDatasourceData: getDatasourceData } = (0, (0, parcelRequire("vE5bM")).useDatasourceClientExtension)();
        return (0, $5uXOq.useMemo)(()=>{
            const factory = (action)=>(...args)=>{
                    try {
                        (0, (0, parcelRequire("jTAf7")).runWhenIdle)(()=>{
                            (0, (0, parcelRequire("gB4mS")).default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, (0, parcelRequire("joONg")).default)('operational.fireAnalyticEvent.commenced', {
                                action: action
                            }))(createAnalyticsEvent);
                        });
                        (0, (0, parcelRequire("jTAf7")).runWhenIdle)(async ()=>{
                            const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("kBLmj"));
                            fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                        });
                    } catch (error) {
                        (0, (0, parcelRequire("gB4mS")).default)((0, $4f7d2702bff62e14$export$3f072f06b90c3985))((0, (0, parcelRequire("joONg")).default)('operational.fireAnalyticEvent.failed', {
                            error: error instanceof Error ? error.toString() : '',
                            action: action
                        }))(createAnalyticsEvent);
                    }
                };
            return {
                datasourceCreated: factory('created'),
                datasourceUpdated: factory('updated'),
                datasourceDeleted: factory('deleted')
            };
        }, [
            createAnalyticsEvent,
            getDatasourceData
        ]);
    };
});
const $4f7d2702bff62e14$export$3f072f06b90c3985 = 'media';
parcelRegister("joONg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f87ca182f31c1317$export$2e2bcd8739ae039);
    const $f87ca182f31c1317$var$createEventPayload = (eventKey, ...[attributes])=>{
        const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
        if (eventType === 'screen') return {
            eventType: eventType,
            name: actionSubject,
            action: 'viewed',
            attributes: attributes
        };
        return {
            eventType: eventType,
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        };
    };
    var $f87ca182f31c1317$export$2e2bcd8739ae039 = $f87ca182f31c1317$var$createEventPayload;
});
parcelRegister("jTAf7", function(module, exports) {
    $parcel$export(module.exports, "runWhenIdle", ()=>$c2cb70bd48315db6$export$51d09170c61ebe04);
    const $c2cb70bd48315db6$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
            timeout: 5000
        }) : window.requestAnimationFrame(callback);
});
parcelRegister("kBLmj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3g9JX").then(()=>parcelRequire('he8BE'));
});
parcelRegister("igJuy", function(module, exports) {
    $parcel$export(module.exports, "getMethod", ()=>$922800648ad4cfa9$export$8793fab959da70d1);
    $parcel$export(module.exports, "getUpdateType", ()=>$922800648ad4cfa9$export$df2aa842dc5172b0);
    $parcel$export(module.exports, "getDeleteType", ()=>$922800648ad4cfa9$export$1cf3d8365b174bde);
    $parcel$export(module.exports, "getSourceEventFromMetadata", ()=>$922800648ad4cfa9$export$b3b4df0d75d4c011);
    var $1SrMX;
    var $gkwXh;
    const $922800648ad4cfa9$var$withHistoryMethod = (fn)=>{
        return (metadata)=>{
            const { isUndo: isUndo, isRedo: isRedo } = metadata;
            if (isUndo) return 'undo';
            if (isRedo) return 'redo';
            return fn(metadata);
        };
    };
    const $922800648ad4cfa9$export$8793fab959da70d1 = $922800648ad4cfa9$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
        inputMethod = inputMethod ?? sourceEvent?.payload?.attributes?.inputMethod;
        switch(inputMethod){
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD:
                return 'editor_paste';
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB:
                return 'editor_floatingToolbar';
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).AUTO_DETECT:
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING:
                return 'editor_type';
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TYPEAHEAD:
                return 'linkpicker_searchResult';
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).MANUAL:
                return 'linkpicker_manual';
            case (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).DATASOURCE:
                return 'datasource_config';
            default:
                return 'unknown';
        }
    });
    const $922800648ad4cfa9$export$df2aa842dc5172b0 = $922800648ad4cfa9$var$withHistoryMethod(({ action: action })=>{
        switch(action){
            case (0, (0, parcelRequire("gkwXh")).ACTION).CHANGED_TYPE:
                return 'display_update';
            case (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED:
                return 'link_update';
            default:
                return 'unknown';
        }
    });
    const $922800648ad4cfa9$export$1cf3d8365b174bde = $922800648ad4cfa9$var$withHistoryMethod(({ action: action })=>{
        if (action === (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK) return 'unlink';
        return 'delete';
    });
    const $922800648ad4cfa9$export$b3b4df0d75d4c011 = (metadata)=>{
        return metadata.sourceEvent instanceof (0, (0, parcelRequire("1SrMX")).default) ? metadata.sourceEvent : null;
    };
});
parcelRegister("lq1wM", function(module, exports) {
    $parcel$export(module.exports, "LinkEventsBinding", ()=>$bcf1c5a5b36814a0$export$aa142efb89c75ed5);
    var $5uXOq = parcelRequire("5uXOq");
    var $cnkQa;
    var $i3FS2;
    var $kAMX8;
    var $igJuy;
    const $bcf1c5a5b36814a0$var$displayCategoryFromDisplay = (display)=>{
        if (display === 'url') return 'link';
    };
    const $bcf1c5a5b36814a0$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
        const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, (0, parcelRequire("cnkQa")).useSmartLinkLifecycleAnalytics)();
        const linkEvents = (0, $5uXOq.useMemo)(()=>{
            return {
                [(0, (0, parcelRequire("i3FS2")).EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                    const url = (0, (0, parcelRequire("kAMX8")).getUrl)(node);
                    if (!url) return;
                    const display = (0, (0, parcelRequire("kAMX8")).appearanceForLink)(node);
                    const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                    const sourceEvent = (0, (0, parcelRequire("igJuy")).getSourceEventFromMetadata)(metadata);
                    const creationMethod = (0, (0, parcelRequire("igJuy")).getMethod)(metadata);
                    linkCreated({
                        url: url,
                        displayCategory: displayCategory
                    }, sourceEvent, {
                        display: display,
                        nodeContext: nodeContext,
                        creationMethod: creationMethod
                    });
                },
                [(0, (0, parcelRequire("i3FS2")).EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                    const url = (0, (0, parcelRequire("kAMX8")).getUrl)(node);
                    if (!url) return;
                    const display = (0, (0, parcelRequire("kAMX8")).appearanceForLink)(node);
                    const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                    const sourceEvent = (0, (0, parcelRequire("igJuy")).getSourceEventFromMetadata)(metadata);
                    const updateMethod = (0, (0, parcelRequire("igJuy")).getMethod)(metadata);
                    const updateType = (0, (0, parcelRequire("igJuy")).getUpdateType)(metadata);
                    linkUpdated({
                        url: url,
                        displayCategory: displayCategory
                    }, sourceEvent, {
                        display: display,
                        previousDisplay: previousDisplay,
                        nodeContext: nodeContext,
                        updateMethod: updateMethod,
                        updateType: updateType
                    });
                },
                [(0, (0, parcelRequire("i3FS2")).EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                    const url = (0, (0, parcelRequire("kAMX8")).getUrl)(node);
                    if (!url) return;
                    const display = (0, (0, parcelRequire("kAMX8")).appearanceForLink)(node);
                    const displayCategory = $bcf1c5a5b36814a0$var$displayCategoryFromDisplay(display);
                    const sourceEvent = (0, (0, parcelRequire("igJuy")).getSourceEventFromMetadata)(metadata);
                    const deleteMethod = (0, (0, parcelRequire("igJuy")).getMethod)(metadata);
                    const deleteType = (0, (0, parcelRequire("igJuy")).getDeleteType)(metadata);
                    linkDeleted({
                        url: url,
                        displayCategory: displayCategory
                    }, sourceEvent, {
                        display: display,
                        nodeContext: nodeContext,
                        deleteMethod: deleteMethod,
                        deleteType: deleteType
                    });
                }
            };
        }, [
            linkCreated,
            linkUpdated,
            linkDeleted
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
                if (subject === (0, (0, parcelRequire("i3FS2")).EVENT_SUBJECT).LINK) linkEvents[event](data);
            });
            return ()=>unsubscribe();
        }, [
            linkEvents,
            cardPluginEvents
        ]);
        return null;
    };
});
parcelRegister("AYP48", function(module, exports) {
    $parcel$export(module.exports, "EditorSmartCardEvents", ()=>$32fdacad52225ffa$export$e7d7ea2bc9a806d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2X7C;
    var $nYpqR;
    const $32fdacad52225ffa$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
        const events = (0, (0, parcelRequire("k2X7C")).useSmartLinkEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (!events) return;
            editorView.dispatch((0, (0, parcelRequire("nYpqR")).registerSmartCardEvents)(events)(editorView.state.tr));
        }, [
            events,
            editorView
        ]);
        return null;
    };
});
parcelRegister("k2X7C", function(module, exports) {
    $parcel$export(module.exports, "useSmartLinkEvents", ()=>$570166268224cbe4$export$ed70996d478e16d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $fzJZi;
    function $570166268224cbe4$export$ed70996d478e16d3() {
        const events = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("fzJZi")).SmartLinkEvents)(), []);
        return events;
    }
});
parcelRegister("6caZq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d32e1b0577f55bc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $awTmI;
    var $4N9VB;
    var $1jI4k;
    var $eOOFp;
    var $8sVBM;
    var $10aQ7;
    var $nYpqR;
    var $89B6e;
    var $h162L;
    const $d32e1b0577f55bc5$var$toolbarButtonWrapperStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        background: `${`var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`}`,
        color: `${`var(--ds-icon, ${(0, $829f609a65d26a98$export$e2ef2124cf4024b1)})`}`,
        ':hover': {
            background: `${`var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$e62e8919cca44969)})`}`,
            color: `${"var(--ds-icon, white)"} !important`
        }
    });
    const $d32e1b0577f55bc5$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $44fe84ed19a5b32b$export$60efea3f80310017), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
        const handleClick = (0, $5uXOq.useCallback)(()=>{
            onLayoutChange && onLayoutChange((0, (0, parcelRequire("eOOFp")).getNextBreakoutMode)(layout));
        }, [
            layout,
            onLayoutChange
        ]);
        const title = (0, $5uXOq.useMemo)(()=>{
            return formatMessage((0, (0, parcelRequire("eOOFp")).getTitle)(layout));
        }, [
            formatMessage,
            layout
        ]);
        if (!targetElement) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4N9VB")).default), {
            mountTo: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            target: targetElement,
            alignY: "start",
            alignX: "end",
            forcePlacement: true,
            stick: true,
            ariaLabel: title
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            testId: testId,
            css: $d32e1b0577f55bc5$var$toolbarButtonWrapperStyles,
            title: title,
            onClick: handleClick,
            iconBefore: layout === 'full-width' ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("8sVBM"))))), {
                label: title
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("10aQ7"))))), {
                label: title
            })
        }));
    };
    const $d32e1b0577f55bc5$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
        const { cardState: cardState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'card'
        ]);
        const { node: node, pos: pos } = (0, (0, parcelRequire("h162L")).getDatasource)(editorView);
        const isDatasource = (0, (0, parcelRequire("89B6e")).isDatasourceNode)(node);
        if (!isDatasource) return null;
        const { datasourceTableRef: datasourceTableRef, layout: layout = node?.attrs?.layout || undefined } = cardState ?? {};
        const onLayoutChange = (layout)=>{
            if (pos === undefined) return;
            const { state: state, dispatch: dispatch } = editorView;
            const datasourceNode = (0, (0, parcelRequire("h162L")).getDatasource)(editorView).node ?? node;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...datasourceNode?.attrs,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch((0, (0, parcelRequire("nYpqR")).setCardLayout)(layout)(tr));
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)($d32e1b0577f55bc5$export$b5a1df4e06cdc467, {
            mountPoint: mountPoint,
            scrollableElement: scrollableElement,
            boundariesElement: boundariesElement,
            targetElement: datasourceTableRef,
            layout: (0, (0, parcelRequire("h162L")).isDatasourceTableLayout)(layout) ? layout : undefined,
            onLayoutChange: onLayoutChange,
            intl: intl
        });
    };
    var $d32e1b0577f55bc5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($d32e1b0577f55bc5$var$LayoutButtonWrapper);
});
parcelRegister("8sVBM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $629da0128daed98a$var$_react = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $629da0128daed98a$var$_shrinkHorizontal = $629da0128daed98a$var$_interopRequireDefault((parcelRequire("hocXQ")));
    function $629da0128daed98a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $629da0128daed98a$var$EditorCollapseIcon = (props)=>$629da0128daed98a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M8.062 11 6.5 9.914A1 1 0 0 1 7.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L7.914 15.5A1 1 0 1 1 6.5 14.086L8.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zm5.408 1.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L16.086 8.5A1 1 0 0 1 17.5 9.914L15.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68l1.562 1.086a1 1 0 0 1-1.414 1.414z"/></svg>`
        }, props, {
            newIcon: $629da0128daed98a$var$_shrinkHorizontal.default
        }));
    $629da0128daed98a$var$EditorCollapseIcon.displayName = 'EditorCollapseIcon';
    var $629da0128daed98a$var$_default = module.exports.default = $629da0128daed98a$var$EditorCollapseIcon;
});
parcelRegister("hocXQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ca8ebbfe28d077b2$var$_react = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ca8ebbfe28d077b2$var$_UNSAFE_baseNew = $ca8ebbfe28d077b2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ca8ebbfe28d077b2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon = (props)=>$ca8ebbfe28d077b2$var$_react.default.createElement($ca8ebbfe28d077b2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M0 8h6.25m3.5 0H16M2.75 4.5 6.25 8l-3.5 3.5m10.5-7L9.75 8l3.5 3.5"/>`
        }, props));
    $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon.displayName = 'ShrinkHorizontalIcon';
    var $ca8ebbfe28d077b2$var$_default = module.exports.default = $ca8ebbfe28d077b2$var$ShrinkHorizontalIcon;
});
parcelRegister("10aQ7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0bae3314669faf11$var$_react = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $0bae3314669faf11$var$_growHorizontal = $0bae3314669faf11$var$_interopRequireDefault((parcelRequire("eQVzV")));
    function $0bae3314669faf11$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0bae3314669faf11$var$EditorExpandIcon = (props)=>$0bae3314669faf11$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M18.062 11 16.5 9.914A1 1 0 1 1 17.914 8.5l2.616 2.616c.28.167.47.5.47.884s-.19.717-.47.884L17.914 15.5a1 1 0 0 1-1.414-1.414L18.062 13h-3.68c-.487 0-.882-.448-.882-1s.395-1 .882-1zM3.47 12.884c-.28-.167-.47-.5-.47-.884s.19-.717.47-.884L6.086 8.5A1 1 0 0 1 7.5 9.914L5.938 11h3.68c.487 0 .882.448.882 1s-.395 1-.882 1h-3.68L7.5 14.086A1 1 0 0 1 6.086 15.5z"/></svg>`
        }, props, {
            newIcon: $0bae3314669faf11$var$_growHorizontal.default
        }));
    $0bae3314669faf11$var$EditorExpandIcon.displayName = 'EditorExpandIcon';
    var $0bae3314669faf11$var$_default = module.exports.default = $0bae3314669faf11$var$EditorExpandIcon;
});
parcelRegister("eQVzV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ad0295eaae02a064$var$_react = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ad0295eaae02a064$var$_UNSAFE_baseNew = $ad0295eaae02a064$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $ad0295eaae02a064$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ad0295eaae02a064$var$GrowHorizontalIcon = (props)=>$ad0295eaae02a064$var$_react.default.createElement($ad0295eaae02a064$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m11.75 4.5 3.5 3.5-3.5 3.5M9 8h5.75M4.25 4.5.75 8l3.5 3.5M7 8H1.25"/>`
        }, props));
    $ad0295eaae02a064$var$GrowHorizontalIcon.displayName = 'GrowHorizontalIcon';
    var $ad0295eaae02a064$var$_default = module.exports.default = $ad0295eaae02a064$var$GrowHorizontalIcon;
});
parcelRegister("cVzPm", function(module, exports) {
    $parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", ()=>(parcelRequire("9UHJN")).clearMarksOnEmptyDocPlugin);
    var $9UHJN;
});
parcelRegister("9UHJN", function(module, exports) {
    $parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", ()=>$909665f51df345d6$export$30b76f1055cbb7e9);
    var $5KWxh;
    var $ggL2v;
    var $gZGBX;
    const $909665f51df345d6$var$pluginKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
    function $909665f51df345d6$var$createPlugin() {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $909665f51df345d6$var$pluginKey,
            appendTransaction: (_transactions, oldState, newState)=>{
                if (!(0, (0, parcelRequire("ggL2v")).isEmptyDocument)(oldState.doc) && (0, (0, parcelRequire("ggL2v")).isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
                return;
            }
        });
    }
    const $909665f51df345d6$export$30b76f1055cbb7e9 = ()=>({
            name: 'clearMarksOnEmptyDoc',
            pmPlugins () {
                return [
                    {
                        name: 'clearMarksOnChange',
                        plugin: $909665f51df345d6$var$createPlugin
                    }
                ];
            }
        });
});
parcelRegister("oFSWG", function(module, exports) {
    $parcel$export(module.exports, "clipboardPlugin", ()=>(parcelRequire("kd7KX")).default);
    var $kd7KX;
});
parcelRegister("kd7KX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$281e1faf12170a31$export$2e2bcd8739ae039);
    var $9Loj3;
    const $281e1faf12170a31$var$clipboard = ()=>({
            name: 'clipboard',
            pmPlugins () {
                return [
                    {
                        name: 'clipboard',
                        plugin: (options)=>(0, (0, parcelRequire("9Loj3")).createPlugin)(options)
                    }
                ];
            }
        });
    var $281e1faf12170a31$export$2e2bcd8739ae039 = $281e1faf12170a31$var$clipboard;
});
parcelRegister("9Loj3", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$bd4683358ea19f8e$export$ae829ec7b2625219);
    var $gkwXh;
    var $cYcwl;
    var $5KWxh;
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $i9Yaa;
    var $bd4683358ea19f8e$export$304e24f67740de29;
    (function(ClipboardEventType) {
        ClipboardEventType["CUT"] = "CUT";
        ClipboardEventType["COPY"] = "COPY";
    })($bd4683358ea19f8e$export$304e24f67740de29 || ($bd4683358ea19f8e$export$304e24f67740de29 = {}));
    let $bd4683358ea19f8e$var$lastEventType = null;
    const $bd4683358ea19f8e$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
        let editorView;
        const getEditorView = ()=>editorView;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("i9Yaa")).clipboardPluginKey),
            view: (view)=>{
                editorView = view;
                return {
                    update: (view)=>{
                        editorView = view;
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    cut: (view)=>{
                        $bd4683358ea19f8e$export$47cf4f31f028e0c9("CUT");
                        return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION).CUT);
                    },
                    copy: (view)=>{
                        $bd4683358ea19f8e$export$47cf4f31f028e0c9("COPY");
                        return $bd4683358ea19f8e$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, (0, parcelRequire("gkwXh")).ACTION).COPIED);
                    }
                },
                clipboardSerializer: $bd4683358ea19f8e$export$33f65796de3575a9(schema, getEditorView)
            }
        });
    };
    const $bd4683358ea19f8e$export$33f65796de3575a9 = (schema, getEditorView)=>{
        const oldSerializer = (0, (0, parcelRequire("kCV8T")).DOMSerializer).fromSchema(schema);
        const newSerializer = new (0, (0, parcelRequire("kCV8T")).DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
        const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
        newSerializer.serializeFragment = (content, options = {}, target)=>{
            const editorView = getEditorView();
            const selection = editorView.state.selection;
            if (!options.tableWrapperExists) {
                let i = 0;
                while(i < content.childCount){
                    if (content.maybeChild(i)?.type.name === 'table') {
                        options.tableWrapperExists = true;
                        break;
                    }
                    i++;
                }
            }
            if (content.firstChild?.type.name === 'tableRow' && !options.tableWrapperExists) {
                options.tableWrapperExists = true;
                const parentTable = (0, $5r0mK.findParentNodeOfType)(schema.nodes.table)(selection);
                const attributes = parentTable?.node.attrs;
                const newTable = schema.nodes.table;
                const newTableNode = newTable.createChecked({
                    ...attributes,
                    localId: undefined
                }, content);
                const newContent = (0, (0, parcelRequire("kCV8T")).Fragment).from(newTableNode);
                return originalSerializeFragment(newContent, options, target);
            }
            if ($bd4683358ea19f8e$var$lastEventType === "COPY" && content.firstChild?.type.name === 'media') {
                const mediaNode = content.firstChild;
                const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, mediaNode.marks?.filter((mark)=>mark.type.name !== 'annotation'));
                const newContent = (0, (0, parcelRequire("kCV8T")).Fragment).from(strippedMediaNode);
                return originalSerializeFragment(newContent, options, target);
            }
            return originalSerializeFragment(content, options, target);
        };
        return newSerializer;
    };
    const $bd4683358ea19f8e$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
        const clipboardAnalyticsPayload = (0, (0, parcelRequire("cYcwl")).getAnalyticsPayload)(view.state, action);
        if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
        return false;
    };
    const $bd4683358ea19f8e$export$47cf4f31f028e0c9 = (eventType)=>$bd4683358ea19f8e$var$lastEventType = eventType;
});
parcelRegister("cYcwl", function(module, exports) {
    $parcel$export(module.exports, "copyToClipboard", ()=>$e78f458911acd4e2$export$2cdf1b96a9f86d16);
    $parcel$export(module.exports, "copyHTMLToClipboard", ()=>$e78f458911acd4e2$export$8b344d2a6a3e9af3);
    $parcel$export(module.exports, "copyHTMLToClipboardPolyfill", ()=>$e78f458911acd4e2$export$97e18ff8b98c7078);
    $parcel$export(module.exports, "getAnalyticsPayload", ()=>$e78f458911acd4e2$export$4feda93c1c6b2d80);
    var $2x8Ci = parcelRequire("2x8Ci");
    var $gZGBX;
    var $gkwXh;
    var $8AlsS;
    const $e78f458911acd4e2$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
    const $e78f458911acd4e2$var$isIEClipboardApiSupported = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
    const $e78f458911acd4e2$var$isExtensionNode = (node)=>{
        if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
        return false;
    };
    const $e78f458911acd4e2$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
        if ($e78f458911acd4e2$var$isClipboardApiSupported()) try {
            await navigator.clipboard.writeText(textToCopy);
        } catch (error) {
            throw new Error('Clipboard api is not supported');
        }
        else if ($e78f458911acd4e2$var$isIEClipboardApiSupported()) try {
            await window.clipboardData.setData('text', textToCopy);
        } catch (error) {
            throw new Error('IE clipboard api is not supported');
        }
        else throw new Error('Clipboard api is not supported');
    };
    const $e78f458911acd4e2$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
        if ($e78f458911acd4e2$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
            const data = new ClipboardItem({
                'text/plain': new Blob([
                    plainTextToCopy || elementToCopy.innerText
                ], {
                    type: 'text/plain'
                }),
                'text/html': new Blob([
                    elementToCopy.innerHTML
                ], {
                    type: 'text/html'
                })
            });
            await navigator.clipboard.write([
                data
            ]);
        } catch (error) {
            throw new Error('Clipboard api is not supported');
        }
        else $e78f458911acd4e2$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    };
    const $e78f458911acd4e2$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
        const dt = new $2x8Ci.ClipboardItem({
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            }),
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            })
        });
        await $2x8Ci.write([
            dt
        ]);
    };
    const $e78f458911acd4e2$export$4feda93c1c6b2d80 = (state, action)=>{
        const { selection: selection, doc: doc } = state;
        const selectionAnalyticsPayload = (0, (0, parcelRequire("8AlsS")).getNodeSelectionAnalyticsPayload)(selection) || (0, (0, parcelRequire("8AlsS")).getRangeSelectionAnalyticsPayload)(selection, doc) || (0, (0, parcelRequire("8AlsS")).getAllSelectionAnalyticsPayload)(selection) || (0, (0, parcelRequire("8AlsS")).getCellSelectionAnalyticsPayload)(state);
        if (selectionAnalyticsPayload) {
            const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
            const node = selectionAnalyticsPayload.attributes?.node;
            let content = [];
            let extensionType;
            let extensionKey;
            switch(selectionActionSubjectId){
                case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).NODE:
                    if (node) {
                        content.push(node);
                        if ($e78f458911acd4e2$var$isExtensionNode(node)) {
                            extensionType = selection.node.attrs.extensionType;
                            extensionKey = selection.node.attrs.extensionKey;
                        }
                    }
                    break;
                case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RANGE:
                    content.push(...selectionAnalyticsPayload.attributes.nodes);
                    break;
                case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ALL:
                    content.push('all');
                    break;
                case (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).CELL:
                    {
                        const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                        content.push(...Array(selectedCells).fill('tableCell'));
                        break;
                    }
            }
            if ($e78f458911acd4e2$var$isExtensionNode(node)) return {
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                action: action,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                attributes: {
                    content: content,
                    extensionKey: extensionKey,
                    extensionType: extensionType
                }
            };
            return {
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                action: action,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                attributes: {
                    content: content
                }
            };
        }
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && selection.$cursor) return {
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: [
                    'caret'
                ]
            }
        };
    };
});
parcelRegister("2x8Ci", function(module, exports) {
    $parcel$export(module.exports, "ClipboardItem", ()=>$1d8558ea290058b8$export$3b1380c0957dc8fe);
    $parcel$export(module.exports, "write", ()=>$1d8558ea290058b8$export$68d8715fc104d294);
    var $1d8558ea290058b8$var$TEXT_PLAIN = "text/plain";
    var $1d8558ea290058b8$var$TEXT_HTML = "text/html";
    var $1d8558ea290058b8$var$debugLogImpl = (s)=>{};
    function $1d8558ea290058b8$var$debugLog(s) {
        $1d8558ea290058b8$var$debugLogImpl(s);
    }
    function $1d8558ea290058b8$export$e014146e87162c32(logFn) {
        $1d8558ea290058b8$var$debugLogImpl = logFn;
    }
    var $1d8558ea290058b8$var$showWarnings = true;
    function $1d8558ea290058b8$export$ba5c9528becaaf25() {
        $1d8558ea290058b8$var$showWarnings = false;
    }
    function $1d8558ea290058b8$var$shouldShowWarnings() {
        return $1d8558ea290058b8$var$showWarnings;
    }
    function $1d8558ea290058b8$var$warnOrLog() {
        (console.warn || console.log).apply(console, arguments);
    }
    var $1d8558ea290058b8$var$warn = $1d8558ea290058b8$var$warnOrLog.bind("[clipboard-polyfill]");
    var $1d8558ea290058b8$var$originalWindow = typeof window === "undefined" ? void 0 : window;
    var $1d8558ea290058b8$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
    var $1d8558ea290058b8$var$_a, $1d8558ea290058b8$var$_b, $1d8558ea290058b8$var$_c;
    var $1d8558ea290058b8$var$promiseConstructorImpl = ($1d8558ea290058b8$var$_c = ($1d8558ea290058b8$var$_a = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a.Promise) != null ? $1d8558ea290058b8$var$_c : ($1d8558ea290058b8$var$_b = $1d8558ea290058b8$var$originalGlobalThis) == null ? void 0 : $1d8558ea290058b8$var$_b.Promise;
    function $1d8558ea290058b8$var$getPromiseConstructor() {
        if (!$1d8558ea290058b8$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
        return $1d8558ea290058b8$var$promiseConstructorImpl;
    }
    var $1d8558ea290058b8$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
    var $1d8558ea290058b8$var$originalNavigatorClipboard = $1d8558ea290058b8$var$originalNavigator == null ? void 0 : $1d8558ea290058b8$var$originalNavigator.clipboard;
    var $1d8558ea290058b8$var$_a2;
    var $1d8558ea290058b8$var$originalNavigatorClipboardRead = ($1d8558ea290058b8$var$_a2 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.read) == null ? void 0 : $1d8558ea290058b8$var$_a2.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
    var $1d8558ea290058b8$var$_a3;
    var $1d8558ea290058b8$var$originalNavigatorClipboardReadText = ($1d8558ea290058b8$var$_a3 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.readText) == null ? void 0 : $1d8558ea290058b8$var$_a3.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
    var $1d8558ea290058b8$var$_a4;
    var $1d8558ea290058b8$var$originalNavigatorClipboardWrite = ($1d8558ea290058b8$var$_a4 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.write) == null ? void 0 : $1d8558ea290058b8$var$_a4.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
    var $1d8558ea290058b8$var$_a5;
    var $1d8558ea290058b8$var$originalNavigatorClipboardWriteText = ($1d8558ea290058b8$var$_a5 = $1d8558ea290058b8$var$originalNavigatorClipboard == null ? void 0 : $1d8558ea290058b8$var$originalNavigatorClipboard.writeText) == null ? void 0 : $1d8558ea290058b8$var$_a5.bind($1d8558ea290058b8$var$originalNavigatorClipboard);
    var $1d8558ea290058b8$var$_a6;
    var $1d8558ea290058b8$var$originalWindowClipboardItem = ($1d8558ea290058b8$var$_a6 = $1d8558ea290058b8$var$originalWindow) == null ? void 0 : $1d8558ea290058b8$var$_a6.ClipboardItem;
    var $1d8558ea290058b8$var$promiseConstructor = $1d8558ea290058b8$var$getPromiseConstructor();
    var $1d8558ea290058b8$var$ieWindow = $1d8558ea290058b8$var$originalWindow;
    function $1d8558ea290058b8$var$seemToBeInIE() {
        return typeof ClipboardEvent === "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData) !== "undefined" && typeof ($1d8558ea290058b8$var$ieWindow == null ? void 0 : $1d8558ea290058b8$var$ieWindow.clipboardData.setData) !== "undefined";
    }
    function $1d8558ea290058b8$var$writeTextIE(text) {
        if (!$1d8558ea290058b8$var$ieWindow.clipboardData) return false;
        var success = $1d8558ea290058b8$var$ieWindow.clipboardData.setData("Text", text);
        if (success) $1d8558ea290058b8$var$debugLog("writeTextIE worked");
        return success;
    }
    function $1d8558ea290058b8$var$readTextIE() {
        if (!$1d8558ea290058b8$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
        var text = $1d8558ea290058b8$var$ieWindow.clipboardData.getData("Text");
        if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
        return text;
    }
    function $1d8558ea290058b8$var$copyListener(tracker, data, e) {
        $1d8558ea290058b8$var$debugLog("listener called");
        tracker.success = true;
        for(var type in data){
            var value = data[type];
            var clipboardData = e.clipboardData;
            clipboardData.setData(type, value);
            if (type === $1d8558ea290058b8$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
                $1d8558ea290058b8$var$debugLog("setting text/plain failed");
                tracker.success = false;
            }
        }
        e.preventDefault();
    }
    function $1d8558ea290058b8$var$execCopy(data) {
        var tracker = {
            success: false
        };
        var listener = $1d8558ea290058b8$var$copyListener.bind(this, tracker, data);
        document.addEventListener("copy", listener);
        try {
            document.execCommand("copy");
        } finally{
            document.removeEventListener("copy", listener);
        }
        return tracker.success;
    }
    function $1d8558ea290058b8$var$copyUsingTempSelection(e, data) {
        $1d8558ea290058b8$var$selectionSet(e);
        var success = $1d8558ea290058b8$var$execCopy(data);
        $1d8558ea290058b8$var$selectionClear();
        return success;
    }
    function $1d8558ea290058b8$var$copyUsingTempElem(data) {
        var tempElem = document.createElement("div");
        tempElem.setAttribute("style", "-webkit-user-select: text !important");
        tempElem.textContent = "temporary element";
        document.body.appendChild(tempElem);
        var success = $1d8558ea290058b8$var$copyUsingTempSelection(tempElem, data);
        document.body.removeChild(tempElem);
        return success;
    }
    function $1d8558ea290058b8$var$copyTextUsingDOM(str) {
        $1d8558ea290058b8$var$debugLog("copyTextUsingDOM");
        var tempElem = document.createElement("div");
        tempElem.setAttribute("style", "-webkit-user-select: text !important");
        var spanParent = tempElem;
        if (tempElem.attachShadow) {
            $1d8558ea290058b8$var$debugLog("Using shadow DOM.");
            spanParent = tempElem.attachShadow({
                mode: "open"
            });
        }
        var span = document.createElement("span");
        span.innerText = str;
        spanParent.appendChild(span);
        document.body.appendChild(tempElem);
        $1d8558ea290058b8$var$selectionSet(span);
        var result = document.execCommand("copy");
        $1d8558ea290058b8$var$selectionClear();
        document.body.removeChild(tempElem);
        return result;
    }
    function $1d8558ea290058b8$var$selectionSet(elem) {
        var sel = document.getSelection();
        if (sel) {
            var range = document.createRange();
            range.selectNodeContents(elem);
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }
    function $1d8558ea290058b8$var$selectionClear() {
        var sel = document.getSelection();
        if (sel) sel.removeAllRanges();
    }
    function $1d8558ea290058b8$var$writeFallback(stringItem) {
        var hasTextPlain = $1d8558ea290058b8$var$TEXT_PLAIN in stringItem;
        if ($1d8558ea290058b8$var$seemToBeInIE()) {
            if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
            if ($1d8558ea290058b8$var$writeTextIE(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) return true;
            else throw new Error("Copying failed, possibly because the user rejected it.");
        }
        if ($1d8558ea290058b8$var$execCopy(stringItem)) {
            $1d8558ea290058b8$var$debugLog("regular execCopy worked");
            return true;
        }
        if (navigator.userAgent.indexOf("Edge") > -1) {
            $1d8558ea290058b8$var$debugLog('UA "Edge" => assuming success');
            return true;
        }
        if ($1d8558ea290058b8$var$copyUsingTempSelection(document.body, stringItem)) {
            $1d8558ea290058b8$var$debugLog("copyUsingTempSelection worked");
            return true;
        }
        if ($1d8558ea290058b8$var$copyUsingTempElem(stringItem)) {
            $1d8558ea290058b8$var$debugLog("copyUsingTempElem worked");
            return true;
        }
        if ($1d8558ea290058b8$var$copyTextUsingDOM(stringItem[$1d8558ea290058b8$var$TEXT_PLAIN])) {
            $1d8558ea290058b8$var$debugLog("copyTextUsingDOM worked");
            return true;
        }
        return false;
    }
    function $1d8558ea290058b8$var$promiseRecordMap(keys, f) {
        var promiseList = [];
        for(var i in keys){
            var key = keys[i];
            promiseList.push(f(key));
        }
        return $1d8558ea290058b8$var$promiseConstructor.all(promiseList).then((vList)=>{
            var dataOut = {};
            for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
            return dataOut;
        });
    }
    var $1d8558ea290058b8$var$voidPromise = $1d8558ea290058b8$var$promiseConstructor.resolve();
    var $1d8558ea290058b8$var$truePromiseFn = ()=>$1d8558ea290058b8$var$promiseConstructor.resolve(true);
    var $1d8558ea290058b8$var$falsePromise = $1d8558ea290058b8$var$promiseConstructor.resolve(false);
    function $1d8558ea290058b8$var$rejectThrownErrors(executor) {
        return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
            try {
                resolve(executor());
            } catch (e) {
                reject(e);
            }
        });
    }
    function $1d8558ea290058b8$var$stringToStringItem(s) {
        var stringItem = {};
        stringItem[$1d8558ea290058b8$var$TEXT_PLAIN] = s;
        return stringItem;
    }
    function $1d8558ea290058b8$export$bec150f75a9b8f11(s) {
        return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
            if ($1d8558ea290058b8$var$originalNavigatorClipboardWriteText) {
                $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.writeText()`.");
                return $1d8558ea290058b8$var$originalNavigatorClipboardWriteText(s).catch($1d8558ea290058b8$var$writeTextStringFallback);
            }
            return $1d8558ea290058b8$var$promiseConstructor.resolve($1d8558ea290058b8$var$writeTextStringFallback(s));
        });
    }
    function $1d8558ea290058b8$var$writeTextStringFallback(s) {
        if (!$1d8558ea290058b8$var$writeFallback($1d8558ea290058b8$var$stringToStringItem(s))) throw new Error("writeText() failed");
    }
    function $1d8558ea290058b8$export$bee0113684d8879b() {
        return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
            if ($1d8558ea290058b8$var$originalNavigatorClipboardReadText) {
                $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.readText()`.");
                return $1d8558ea290058b8$var$originalNavigatorClipboardReadText();
            }
            if ($1d8558ea290058b8$var$seemToBeInIE()) {
                var result = $1d8558ea290058b8$var$readTextIE();
                return $1d8558ea290058b8$var$promiseConstructor.resolve(result);
            }
            throw new Error("Read is not supported in your browser.");
        });
    }
    function $1d8558ea290058b8$var$hasItemWithType(clipboardItems, typeName) {
        for(var i in clipboardItems){
            var item = clipboardItems[i];
            if (item.types.indexOf(typeName) !== -1) return true;
        }
        return false;
    }
    function $1d8558ea290058b8$var$ClipboardItemPolyfillImpl(items, options) {
        var _a7;
        var types = Object.keys(items);
        var _items = {};
        for(var type in items){
            var item = items[type];
            if (typeof item === "string") _items[type] = $1d8558ea290058b8$var$stringToBlob(type, item);
            else _items[type] = item;
        }
        var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
        function getType(type2) {
            return $1d8558ea290058b8$var$promiseConstructor.resolve(_items[type2]);
        }
        return {
            types: types,
            presentationStyle: presentationStyle,
            getType: getType
        };
    }
    var $1d8558ea290058b8$export$3b1380c0957dc8fe = $1d8558ea290058b8$var$ClipboardItemPolyfillImpl;
    function $1d8558ea290058b8$var$stringToBlob(type, str) {
        return new Blob([
            str
        ], {
            type: type
        });
    }
    function $1d8558ea290058b8$var$blobToString(blob) {
        return new $1d8558ea290058b8$var$promiseConstructor((resolve, reject)=>{
            var fileReader = new FileReader();
            fileReader.addEventListener("load", ()=>{
                var result = fileReader.result;
                if (typeof result === "string") resolve(result);
                else reject("could not convert blob to string");
            });
            fileReader.readAsText(blob);
        });
    }
    function $1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
        return $1d8558ea290058b8$var$promiseRecordMap(clipboardItem.types, function(type) {
            return clipboardItem.getType(type);
        }).then((items)=>{
            return new Promise((resolve, reject)=>{
                var options = {};
                if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
                if ($1d8558ea290058b8$var$originalWindowClipboardItem) resolve(new $1d8558ea290058b8$var$originalWindowClipboardItem(items, options));
                else reject("window.ClipboardItem is not defined");
            });
        });
    }
    function $1d8558ea290058b8$var$textToClipboardItem(text) {
        var items = {};
        items[$1d8558ea290058b8$var$TEXT_PLAIN] = $1d8558ea290058b8$var$stringToBlob(text, $1d8558ea290058b8$var$TEXT_PLAIN);
        return new $1d8558ea290058b8$export$3b1380c0957dc8fe(items);
    }
    function $1d8558ea290058b8$var$getTypeAsString(clipboardItem, type) {
        return clipboardItem.getType(type).then((text)=>{
            return $1d8558ea290058b8$var$blobToString(text);
        });
    }
    function $1d8558ea290058b8$var$toStringItem(data) {
        return $1d8558ea290058b8$var$promiseRecordMap(data.types, function(type) {
            return $1d8558ea290058b8$var$getTypeAsString(data, type);
        });
    }
    function $1d8558ea290058b8$export$68d8715fc104d294(data) {
        return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
            if ($1d8558ea290058b8$var$originalNavigatorClipboardWrite && $1d8558ea290058b8$var$originalWindowClipboardItem) {
                var originalNavigatorClipboardWriteCached = $1d8558ea290058b8$var$originalNavigatorClipboardWrite;
                $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.write()`.");
                return $1d8558ea290058b8$var$promiseConstructor.all(data.map($1d8558ea290058b8$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                    return originalNavigatorClipboardWriteCached(globalClipboardItems).then($1d8558ea290058b8$var$truePromiseFn).catch((e)=>{
                        if (!$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN) && !$1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_HTML)) throw e;
                        return $1d8558ea290058b8$var$falsePromise;
                    });
                });
            }
            return $1d8558ea290058b8$var$falsePromise;
        }).then((success)=>{
            if (success) return $1d8558ea290058b8$var$voidPromise;
            var hasTextPlain = $1d8558ea290058b8$var$hasItemWithType(data, $1d8558ea290058b8$var$TEXT_PLAIN);
            if ($1d8558ea290058b8$var$shouldShowWarnings() && !hasTextPlain) $1d8558ea290058b8$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
            return $1d8558ea290058b8$var$toStringItem(data[0]).then((stringItem)=>{
                if (!$1d8558ea290058b8$var$writeFallback(stringItem)) throw new Error("write() failed");
            });
        });
    }
    function $1d8558ea290058b8$export$aafa59e2e03f2942() {
        return $1d8558ea290058b8$var$rejectThrownErrors(()=>{
            if ($1d8558ea290058b8$var$originalNavigatorClipboardRead) {
                $1d8558ea290058b8$var$debugLog("Using `navigator.clipboard.read()`.");
                return $1d8558ea290058b8$var$originalNavigatorClipboardRead();
            }
            return $1d8558ea290058b8$export$bee0113684d8879b().then((text)=>{
                return [
                    $1d8558ea290058b8$var$textToClipboardItem(text)
                ];
            });
        });
    }
});
parcelRegister("8AlsS", function(module, exports) {
    $parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", ()=>$09b21fe82b545f9f$export$3162c38157c33ee6);
    $parcel$export(module.exports, "getAllSelectionAnalyticsPayload", ()=>$09b21fe82b545f9f$export$9f3a063378bdcaa1);
    $parcel$export(module.exports, "getCellSelectionAnalyticsPayload", ()=>$09b21fe82b545f9f$export$dcdd07dcad6adb98);
    $parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", ()=>$09b21fe82b545f9f$export$bf6883b886d952b0);
    $parcel$export(module.exports, "createSelectionClickHandler", ()=>$09b21fe82b545f9f$export$563f7987ca7936f1);
    var $gZGBX;
    var $hFEwm;
    var $hHsVB;
    var $gkwXh;
    var $6MkyM;
    var $hPjvp;
    var $5Vvw4;
    var $3jyjs;
    var $2xQXF;
    var $fMoO3;
    var $eAVGd;
    var $k6Y9i;
    function $09b21fe82b545f9f$export$3162c38157c33ee6(selection) {
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).NODE,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                node: selection.node.type.name
            }
        };
    }
    function $09b21fe82b545f9f$export$9f3a063378bdcaa1(selection) {
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).AllSelection)) return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).ALL,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
    }
    function $09b21fe82b545f9f$export$dcdd07dcad6adb98(state) {
        if (state.selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) {
            const rect = (0, (0, parcelRequire("hHsVB")).selectedRect)(state);
            const selectedCells = rect.map.cellsInRect(rect).length;
            const totalCells = rect.map.map.length;
            return {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).CELL,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {
                    selectedCells: selectedCells,
                    totalCells: totalCells
                }
            };
        }
    }
    function $09b21fe82b545f9f$export$bf6883b886d952b0(selection, doc) {
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && selection.from !== selection.to) {
            const { from: from, to: to, anchor: anchor, head: head } = selection;
            const nodes = [];
            doc.nodesBetween(from, to, (node, pos)=>{
                if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                    nodes.push(node.type.name);
                    return false;
                }
            });
            return {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).SELECTED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).RANGE,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                attributes: {
                    from: anchor,
                    to: head,
                    nodes: nodes
                }
            };
        }
    }
    const $09b21fe82b545f9f$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
            if (dispatch) dispatch(state.tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(state.doc.resolve(pos))));
            return true;
        };
    function $09b21fe82b545f9f$export$563f7987ca7936f1(nodes, isValidTarget, options) {
        return function handleClickOn(view, pos, node, nodePos, event, direct) {
            if (options.useLongPressSelection) return false;
            if (direct && nodes.indexOf(node.type.name) !== -1) {
                const target = event.target;
                if (target instanceof HTMLElement && isValidTarget(target)) {
                    const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                    $09b21fe82b545f9f$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                    return true;
                }
            }
            return false;
        };
    }
});
parcelRegister("hHsVB", function(module, exports) {
    $parcel$export(module.exports, "selectedRect", ()=>$78cade064f4edb3a$export$39ce22e69aa9ed17);
    var $hFEwm;
    var $uOUlv;
    var $22PoI;
    function $78cade064f4edb3a$export$39ce22e69aa9ed17(state) {
        const sel = state.selection;
        const $pos = (0, (0, parcelRequire("22PoI")).selectionCell)(sel);
        if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
        const table = $pos.node(-1);
        const tableStart = $pos.start(-1);
        const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
        let rect;
        if (sel instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
        else rect = map.findCell($pos.pos - tableStart);
        rect.tableStart = tableStart;
        rect.map = map;
        rect.table = table;
        return rect;
    }
});
parcelRegister("22PoI", function(module, exports) {
    $parcel$export(module.exports, "selectionCell", ()=>$6e0c68deaeecd60c$export$aad75348c8f2d244);
    var $6hQQ3;
    var $iGxzn;
    function $6e0c68deaeecd60c$export$aad75348c8f2d244(selection) {
        if ((0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
        if ((0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
        return (0, (0, parcelRequire("6hQQ3")).cellAround)(selection.$head) || (0, (0, parcelRequire("6hQQ3")).cellNear)(selection.$head);
    }
});
parcelRegister("iGxzn", function(module, exports) {
    $parcel$export(module.exports, "isSelectionType", ()=>$a99399272acf3f8b$export$626dcc173023aed7);
    function $a99399272acf3f8b$export$626dcc173023aed7(selection, type) {
        if (!selection) return false;
        const serialized = selection.toJSON();
        return serialized.type === type;
    }
});
parcelRegister("6MkyM", function(module, exports) {
    $parcel$export(module.exports, "RelativeSelectionPos", ()=>$1e3782577a66fd65$export$cb9005d223ae8de7);
    var $1e3782577a66fd65$export$cb9005d223ae8de7;
    (function(RelativeSelectionPos) {
        RelativeSelectionPos["Before"] = "Before";
        RelativeSelectionPos["Start"] = "Start";
        RelativeSelectionPos["Inside"] = "Inside";
        RelativeSelectionPos["End"] = "End";
    })($1e3782577a66fd65$export$cb9005d223ae8de7 || ($1e3782577a66fd65$export$cb9005d223ae8de7 = {}));
});
parcelRegister("fMoO3", function(module, exports) {
    $parcel$export(module.exports, "setGapCursorSelection", ()=>$860240a1613ee906$export$a8946811e8b82dd);
    var $hPjvp;
    function $860240a1613ee906$export$a8946811e8b82dd(view, pos, side) {
        const { state: state } = view;
        view.dispatch(state.tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(state.doc.resolve(pos), side)));
    }
});
parcelRegister("k6Y9i", function(module, exports) {
    $parcel$export(module.exports, "isSelectionAtStartOfNode", ()=>$2aa2babce658057c$export$2543715425b0bf0b);
    $parcel$export(module.exports, "isSelectionAtEndOfNode", ()=>$2aa2babce658057c$export$5762916b8b83bc6d);
    $parcel$export(module.exports, "atTheEndOfDoc", ()=>$2aa2babce658057c$export$4ca816540352da02);
    $parcel$export(module.exports, "atTheBeginningOfDoc", ()=>$2aa2babce658057c$export$e9083e8cbe24bec0);
    $parcel$export(module.exports, "atTheEndOfBlock", ()=>$2aa2babce658057c$export$6f303ca7dac350ae);
    $parcel$export(module.exports, "endPositionOfParent", ()=>$2aa2babce658057c$export$8e09b50c60354750);
    $parcel$export(module.exports, "atTheBeginningOfBlock", ()=>$2aa2babce658057c$export$8351d833af62ae68);
    $parcel$export(module.exports, "startPositionOfParent", ()=>$2aa2babce658057c$export$ced77c72038c89cb);
    var $gZGBX;
    var $hPjvp;
    const $2aa2babce658057c$export$2543715425b0bf0b = ($pos, parentNode)=>{
        if (!parentNode) return false;
        for(let i = $pos.depth + 1; i > 0; i--){
            const node = $pos.node(i);
            if (node && node.eq(parentNode.node)) break;
            if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
        }
        return true;
    };
    const $2aa2babce658057c$export$5762916b8b83bc6d = ($pos, parentNode)=>{
        if (!parentNode) return false;
        for(let i = $pos.depth + 1; i > 0; i--){
            const node = $pos.node(i);
            if (node && node.eq(parentNode.node)) break;
            if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
        }
        return true;
    };
    function $2aa2babce658057c$export$4ca816540352da02(state) {
        const { selection: selection, doc: doc } = state;
        return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
    }
    function $2aa2babce658057c$export$e9083e8cbe24bec0(state) {
        const { selection: selection } = state;
        return selection.$from.pos === selection.$from.depth;
    }
    function $2aa2babce658057c$export$6f303ca7dac350ae(state) {
        const { selection: selection } = state;
        const { $to: $to } = selection;
        if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) return false;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selection.node.isBlock) return true;
        return $2aa2babce658057c$export$8e09b50c60354750($to) === $to.pos + 1;
    }
    function $2aa2babce658057c$export$8351d833af62ae68(state) {
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) return false;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selection.node.isBlock) return true;
        return $2aa2babce658057c$export$ced77c72038c89cb($from) === $from.pos;
    }
    function $2aa2babce658057c$export$ced77c72038c89cb(resolvedPos) {
        return resolvedPos.start(resolvedPos.depth);
    }
    function $2aa2babce658057c$export$8e09b50c60354750(resolvedPos) {
        return resolvedPos.end(resolvedPos.depth) + 1;
    }
});
parcelRegister("i9Yaa", function(module, exports) {
    $parcel$export(module.exports, "clipboardPluginKey", ()=>$e8931e12a5242325$export$7ff3d0e65871bad3);
    var $gZGBX;
    const $e8931e12a5242325$export$7ff3d0e65871bad3 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('clipboardPlugin');
});
parcelRegister("ceDVv", function(module, exports) {
    $parcel$export(module.exports, "compositionPlugin", ()=>(parcelRequire("izJY1")).compositionPlugin);
    var $izJY1;
});
parcelRegister("izJY1", function(module, exports) {
    $parcel$export(module.exports, "compositionPlugin", ()=>$fe0d4250ae554ed9$export$afd1652ef5208b);
    var $fuDg1;
    var $4gJQv;
    const $fe0d4250ae554ed9$export$afd1652ef5208b = ()=>{
        return {
            name: 'composition',
            getSharedState (editorState) {
                if (!editorState) return {
                    isComposing: false
                };
                return {
                    isComposing: !!(0, (0, parcelRequire("4gJQv")).pluginKey).getState(editorState)?.isComposing
                };
            },
            pmPlugins () {
                return [
                    {
                        name: 'composition',
                        plugin: ()=>(0, (0, parcelRequire("fuDg1")).default)()
                    }
                ];
            }
        };
    };
});
parcelRegister("fuDg1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e0db51e3a44ecc7$export$2e2bcd8739ae039);
    var $5KWxh;
    var $4gJQv;
    const $1e0db51e3a44ecc7$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
    var $1e0db51e3a44ecc7$export$2e2bcd8739ae039 = ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("4gJQv")).pluginKey),
            state: {
                init: ()=>({
                        isComposing: false,
                        zeroWidthSpacePos: undefined
                    }),
                apply: (tr, value)=>{
                    const isComposing = tr.getMeta((0, (0, parcelRequire("4gJQv")).pluginKey));
                    const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                    if (typeof isComposing === 'undefined') return value;
                    return {
                        isComposing: isComposing,
                        zeroWidthSpacePos: zeroWidthSpacePos
                    };
                }
            },
            props: {
                handleDOMEvents: {
                    compositionstart: (view, event)=>{
                        const { tr: tr } = view.state;
                        tr.setMeta((0, (0, parcelRequire("4gJQv")).pluginKey), true);
                        if ($1e0db51e3a44ecc7$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                            tr.insertText((0, $0f804702eb36dd5e$export$15a09f5ef055bcfa));
                            tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                        }
                        view.dispatch(tr);
                        return false;
                    },
                    compositionend: (view, event)=>{
                        const { tr: tr } = view.state;
                        tr.setMeta((0, (0, parcelRequire("4gJQv")).pluginKey), false);
                        if ($1e0db51e3a44ecc7$var$isLinux()) {
                            const zeroWidthSpacePos = (0, (0, parcelRequire("4gJQv")).pluginKey).getState(view.state)?.zeroWidthSpacePos;
                            if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                            tr.setMeta('zeroWidthSpacePos', undefined);
                        }
                        view.dispatch(tr);
                        return false;
                    }
                }
            }
        });
});
parcelRegister("4gJQv", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$f06bf058060e8acd$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $f06bf058060e8acd$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('compositionPlugin');
});
parcelRegister("gmJvQ", function(module, exports) {
    $parcel$export(module.exports, "copyButtonPlugin", ()=>(parcelRequire("jnbcS")).copyButtonPlugin);
    var $jnbcS;
});
parcelRegister("jnbcS", function(module, exports) {
    $parcel$export(module.exports, "copyButtonPlugin", ()=>$bcfd81dd8839116d$export$ea22bdb37423f02c);
    var $9RYlU;
    var $48EvW;
    const $bcfd81dd8839116d$export$ea22bdb37423f02c = ({ api: api })=>({
            name: 'copyButton',
            pmPlugins () {
                return [
                    {
                        name: 'copyButton',
                        plugin: ()=>(0, (0, parcelRequire("9RYlU")).default)()
                    }
                ];
            },
            actions: {
                processCopyButtonItems: (0, (0, parcelRequire("48EvW")).processCopyButtonItems)(api?.analytics?.actions)
            }
        });
});
parcelRegister("9RYlU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0493fd9b5d8c1e6b$export$2e2bcd8739ae039);
    var $5KWxh;
    var $etG8M;
    var $5c8Iv;
    function $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
        const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
        if (!hasMark) return false;
        if ($pos.parent.childCount === 1) {
            const nodePosition = $pos.pos;
            const maybeNode = $pos.doc.nodeAt(nodePosition);
            if (!maybeNode || !maybeNode.isText) return false;
            const start = $pos.pos - $pos.parentOffset;
            const end = start + maybeNode.nodeSize;
            return {
                start: start,
                end: end
            };
        }
        if ($pos.parent.childCount > 1) {
            const start = $pos.pos - $pos.textOffset;
            const maybeTextNode = $pos.doc.nodeAt(start);
            if (!maybeTextNode || !maybeTextNode.isText) return false;
            const end = start + maybeTextNode.nodeSize;
            return {
                start: start,
                end: end
            };
        }
        return false;
    }
    function $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
        const anchorPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
            $pos: transaction.selection.$anchor,
            markType: markType
        });
        if (anchorPositions) return {
            ...anchorPositions,
            markType: markType
        };
        const headPositions = $0493fd9b5d8c1e6b$export$6867b9cd7a8c8a75({
            $pos: transaction.selection.$head,
            markType: markType
        });
        if (headPositions) return {
            ...headPositions,
            markType: markType
        };
        return undefined;
    }
    function $0493fd9b5d8c1e6b$export$ea22bdb37423f02c() {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey),
            state: {
                init () {
                    return {
                        copied: false,
                        markSelection: undefined
                    };
                },
                apply (tr, currentPluginState) {
                    const meta = tr.getMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey));
                    if (meta?.copied !== undefined) return {
                        copied: meta.copied,
                        markSelection: undefined
                    };
                    if (meta?.showSelection) return {
                        copied: currentPluginState.copied,
                        markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                            markType: meta.markType,
                            transaction: tr
                        })
                    };
                    if (meta?.removeSelection) return {
                        copied: currentPluginState.copied,
                        markSelection: undefined
                    };
                    if (currentPluginState.markSelection) return {
                        copied: currentPluginState.copied,
                        markSelection: $0493fd9b5d8c1e6b$var$getMarkSelectionDecorationStartAndEnd({
                            markType: currentPluginState.markSelection.markType,
                            transaction: tr
                        })
                    };
                    return currentPluginState;
                }
            },
            props: {
                decorations (_state) {
                    return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                }
            }
        });
    }
    var $0493fd9b5d8c1e6b$export$2e2bcd8739ae039 = $0493fd9b5d8c1e6b$export$ea22bdb37423f02c;
});
parcelRegister("5c8Iv", function(module, exports) {
    $parcel$export(module.exports, "copyButtonPluginKey", ()=>$83f9fb1f851039a9$export$e41a18c2cdafffa9);
    var $gZGBX;
    const $83f9fb1f851039a9$export$e41a18c2cdafffa9 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('copyButtonPlugin');
});
parcelRegister("48EvW", function(module, exports) {
    $parcel$export(module.exports, "processCopyButtonItems", ()=>$79fea903647c241d$export$f61ed03c42ac876f);
    var $8DYpW;
    var $3Fq5M;
    var $40riH;
    var $5c8Iv;
    function $79fea903647c241d$var$isSeparator(item) {
        return item?.type === 'separator';
    }
    function $79fea903647c241d$var$isNodeOptions(options) {
        return 'nodeType' in options && options.nodeType !== undefined;
    }
    function $79fea903647c241d$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi) {
        const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
        const copyButtonState = (0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey).getState(state);
        let buttonActionHandlers;
        if ($79fea903647c241d$var$isNodeOptions(options)) buttonActionHandlers = {
            onClick: (0, (0, parcelRequire("40riH")).createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi),
            onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            onMouseLeave: (0, (0, parcelRequire("40riH")).resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
            onBlur: (0, (0, parcelRequire("40riH")).resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
        };
        else buttonActionHandlers = {
            onClick: (0, (0, parcelRequire("40riH")).createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
            onMouseEnter: (0, (0, parcelRequire("40riH")).getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
            onFocus: (0, (0, parcelRequire("40riH")).getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
            onMouseLeave: (0, (0, parcelRequire("40riH")).removeMarkVisualFeedbackForCopyButtonCommand),
            onBlur: (0, (0, parcelRequire("40riH")).removeMarkVisualFeedbackForCopyButtonCommand)
        };
        return {
            id: 'editor.floatingToolbar.copy',
            type: 'button',
            appearance: 'subtle',
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3Fq5M"))))),
            title: formatMessage(copyButtonState?.copied ? (0, (0, parcelRequire("8DYpW")).default).copiedToClipboard : (0, (0, parcelRequire("8DYpW")).default).copyToClipboard),
            ...buttonActionHandlers,
            hideTooltipOnClick: false,
            tabIndex: null
        };
    }
    const $79fea903647c241d$export$f61ed03c42ac876f = (editorAnalyticsApi)=>(state)=>{
            return (items, hoverDecoration)=>items.flatMap((item)=>{
                    switch(item.type){
                        case 'copy-button':
                            if (item?.hidden) return [];
                            return item?.items.map((copyButtonItem)=>$79fea903647c241d$var$isSeparator(copyButtonItem) ? copyButtonItem : $79fea903647c241d$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi));
                        default:
                            return [
                                item
                            ];
                    }
                });
        };
});
parcelRegister("40riH", function(module, exports) {
    $parcel$export(module.exports, "createToolbarCopyCommandForMark", ()=>$5dfad2b63514853f$export$61f33363e77ed28);
    $parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", ()=>$5dfad2b63514853f$export$5887c7b152626490);
    $parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", ()=>$5dfad2b63514853f$export$e52b1d5c60d367b8);
    $parcel$export(module.exports, "createToolbarCopyCommandForNode", ()=>$5dfad2b63514853f$export$be806b3b778a7682);
    $parcel$export(module.exports, "resetCopiedState", ()=>$5dfad2b63514853f$export$3e0b07341e7576a);
    var $gkwXh;
    var $gE8f9;
    var $cYcwl;
    var $SYwgb;
    var $gZGBX;
    var $5c8Iv;
    function $5dfad2b63514853f$export$61f33363e77ed28(markType, editorAnalyticsApi) {
        function command(state, dispatch) {
            const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
            if (!textNode) return false;
            if (dispatch) {
                const domNode = (0, (0, parcelRequire("SYwgb")).toDOM)(textNode, state.schema);
                if (domNode) {
                    const div = document.createElement('div');
                    const p = document.createElement('p');
                    div.appendChild(p);
                    p.appendChild(domNode);
                    div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                    const linkUrl = domNode.getAttribute('href');
                    (0, (0, parcelRequire("cYcwl")).copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
                }
                const copyToClipboardTr = state.tr;
                copyToClipboardTr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
                    copied: true
                });
                const analyticsPayload = (0, (0, parcelRequire("cYcwl")).getAnalyticsPayload)(state, (0, (0, parcelRequire("gkwXh")).ACTION).COPIED);
                if (analyticsPayload && editorAnalyticsApi) {
                    analyticsPayload.attributes.inputMethod = (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.markType = markType.name;
                    editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
                }
                dispatch(copyToClipboardTr);
            }
            return true;
        }
        return command;
    }
    function $5dfad2b63514853f$export$5887c7b152626490(markType) {
        function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
            const tr = state.tr;
            tr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
                showSelection: true,
                markType: markType
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        return provideMarkVisualFeedbackForCopyButtonCommand;
    }
    function $5dfad2b63514853f$export$e52b1d5c60d367b8(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
            removeSelection: true
        });
        const copyButtonState = (0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey).getState(state);
        if (copyButtonState?.copied) tr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    const $5dfad2b63514853f$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi)=>(state, dispatch)=>{
            const { tr: tr, schema: schema } = state;
            let contentNodeWithPos = (0, (0, parcelRequire("SYwgb")).getSelectedNodeOrNodeParentByNodeType)({
                nodeType: nodeType,
                selection: tr.selection
            });
            if (!contentNodeWithPos) return false;
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, (0, parcelRequire("cYcwl")).getAnalyticsPayload)(state, (0, (0, parcelRequire("gkwXh")).ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            if (dispatch) {
                const domNode = (0, (0, parcelRequire("SYwgb")).toDOM)(contentNodeWithPos.node, schema);
                if (domNode) {
                    const div = document.createElement('div');
                    div.appendChild(domNode);
                    if (contentNodeWithPos.node.type.inlineContent) div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                    else div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                    if ((0, (0, parcelRequire("gE8f9")).browser).safari && state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, (0, parcelRequire("cYcwl")).copyHTMLToClipboardPolyfill)(div);
                    else (0, (0, parcelRequire("cYcwl")).copyHTMLToClipboard)(div);
                }
                copyToClipboardTr.setMeta('scrollIntoView', false);
                dispatch(copyToClipboardTr);
            }
            return true;
        };
    const $5dfad2b63514853f$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
            let customTr = state.tr;
            const customDispatch = (tr)=>{
                customTr = tr;
            };
            onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
            const copyButtonState = (0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey).getState(state);
            if (copyButtonState?.copied) customTr.setMeta((0, (0, parcelRequire("5c8Iv")).copyButtonPluginKey), {
                copied: false
            });
            if (dispatch) dispatch(customTr);
            return true;
        };
});
parcelRegister("SYwgb", function(module, exports) {
    $parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", ()=>$ca84f4e43934dc04$export$64477bc469482fd0);
    $parcel$export(module.exports, "toDOM", ()=>$ca84f4e43934dc04$export$289411c5a7970646);
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    function $ca84f4e43934dc04$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
        let node = (0, $5r0mK.findSelectedNodeOfType)(nodeType)(selection);
        if (!node) node = (0, $5r0mK.findParentNodeOfType)(nodeType)(selection);
        return node;
    }
    const $ca84f4e43934dc04$export$289411c5a7970646 = (node, schema)=>{
        return (0, (0, parcelRequire("kCV8T")).DOMSerializer).fromSchema(schema).serializeNode(node);
    };
});
parcelRegister("4fHvc", function(module, exports) {
    $parcel$export(module.exports, "customAutoformatPlugin", ()=>(parcelRequire("gQCbY")).customAutoformatPlugin);
    var $gQCbY;
});
parcelRegister("gQCbY", function(module, exports) {
    $parcel$export(module.exports, "customAutoformatPlugin", ()=>$d3fa7bb235c579dd$export$aa4fc86248a63de6);
    var $5KWxh;
    var $vWFRY;
    var $5xMCJ;
    var $g1KvC;
    var $cu8fC;
    var $le6Z8;
    const $d3fa7bb235c579dd$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
        const rules = [];
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            state: {
                init () {
                    return {
                        resolving: [],
                        matches: [],
                        autoformattingProvider: undefined
                    };
                },
                apply (tr, prevPluginState) {
                    if (!prevPluginState) return prevPluginState;
                    const remappedPluginState = {
                        ...prevPluginState,
                        resolving: prevPluginState.resolving.map((candidate)=>({
                                ...candidate,
                                start: tr.mapping.map(candidate.start),
                                end: tr.mapping.map(candidate.end, -1)
                            }))
                    };
                    const meta = tr.getMeta((0, (0, parcelRequire("le6Z8")).pluginKey));
                    if (!meta) return remappedPluginState;
                    return (0, (0, parcelRequire("cu8fC")).default)(remappedPluginState, meta);
                }
            },
            props: {
                handleTextInput (view, from, to, text) {
                    (0, (0, parcelRequire("g1KvC")).triggerInputRule)(view, rules, from, to, text);
                    return false;
                },
                handleKeyDown: (0, (0, parcelRequire("vWFRY")).keydownHandler)({
                    Enter: (_state, _dispatch, view)=>{
                        if (view) (0, (0, parcelRequire("g1KvC")).triggerInputRule)(view, rules, view.state.selection.from, view.state.selection.to, '');
                        return false;
                    }
                })
            },
            view () {
                const handleProvider = (name, provider)=>{
                    if (name !== 'autoformattingProvider' || !provider) return;
                    provider.then(async (autoformattingProvider)=>{
                        const ruleset = await autoformattingProvider.getRules();
                        Object.keys(ruleset).forEach((rule)=>{
                            const inputRule = {
                                matchTyping: new RegExp('(\\s+|^)' + rule + '(\\s|,|\\.)$'),
                                matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                                handler: (0, (0, parcelRequire("5xMCJ")).buildHandler)(rule, ruleset[rule])
                            };
                            rules.push(inputRule);
                        });
                    });
                };
                if (options?.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
                return {
                    update (view) {
                        const currentState = (0, (0, parcelRequire("le6Z8")).getPluginState)(view.state);
                        if (!currentState) return;
                        if (currentState.matches) (0, (0, parcelRequire("5xMCJ")).completeReplacements)(view, currentState);
                    }
                };
            },
            key: (0, (0, parcelRequire("le6Z8")).pluginKey)
        });
    };
    const $d3fa7bb235c579dd$export$1572b3eade6662f9 = (provider)=>(tr)=>{
            return (0, (0, parcelRequire("le6Z8")).autoformatAction)(tr, {
                action: 'setProvider',
                provider: provider
            });
        };
    const $d3fa7bb235c579dd$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
        let previousProvider;
        if (options?.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
            api?.core.actions.execute(({ tr: tr })=>$d3fa7bb235c579dd$export$1572b3eade6662f9(provider)(tr));
        });
        return {
            name: 'customAutoformat',
            pmPlugins () {
                return [
                    {
                        name: 'customAutoformat',
                        plugin: (pmPluginFactoryParams)=>{
                            return $d3fa7bb235c579dd$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                        }
                    }
                ];
            },
            getSharedState (editorState) {
                if (!editorState) return;
                const { autoformattingProvider: autoformattingProvider } = (0, (0, parcelRequire("le6Z8")).getPluginState)(editorState) ?? {};
                return {
                    autoformattingProvider: autoformattingProvider
                };
            },
            actions: {
                setProvider: async (providerPromise)=>{
                    const provider = await providerPromise;
                    if (previousProvider === provider || options?.autoformattingProvider === providerPromise) return false;
                    previousProvider = provider;
                    return api?.core.actions.execute(({ tr: tr })=>$d3fa7bb235c579dd$export$1572b3eade6662f9(provider)(tr)) ?? false;
                }
            }
        };
    };
});
parcelRegister("5xMCJ", function(module, exports) {
    $parcel$export(module.exports, "buildHandler", ()=>$3d050f2394a48b6a$export$c95e7d405e6ed1df);
    $parcel$export(module.exports, "completeReplacements", ()=>$3d050f2394a48b6a$export$e9a01ad76956fe83);
    var $agxMF;
    var $fZzhT;
    var $le6Z8;
    const $3d050f2394a48b6a$export$c95e7d405e6ed1df = (_regex, handler)=>{
        return async (view, match, start, end)=>{
            const replacementPromise = handler(match.slice(1, match.length - 1));
            view.dispatch((0, (0, parcelRequire("le6Z8")).autoformatAction)(view.state.tr, {
                action: 'matched',
                match: match,
                start: start,
                end: end
            }));
            const replacementData = await replacementPromise;
            const replacementNode = (0, (0, parcelRequire("agxMF")).processRawValue)(view.state.schema, replacementData);
            view.dispatch((0, (0, parcelRequire("le6Z8")).autoformatAction)(view.state.tr, {
                action: 'resolved',
                matchString: match[0],
                replacement: replacementNode
            }));
            return replacementData;
        };
    };
    const $3d050f2394a48b6a$export$e9a01ad76956fe83 = (view, state)=>{
        const { inlineCard: inlineCard } = view.state.schema.nodes;
        state.matches.forEach((completedMatch)=>{
            const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
            let tr = view.state.tr;
            matchingRequests.forEach((request)=>{
                const { match: match, start: start, end: end } = request;
                const { replacement: replacement } = completedMatch;
                const prefix = match[1];
                const suffix = match[match.length - 1];
                const matchEndPos = end + suffix.length;
                if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
                const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
                if (docText === match[0]) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
            });
            tr = (0, (0, parcelRequire("le6Z8")).autoformatAction)(tr, {
                action: 'finish',
                matchString: completedMatch.matchString
            });
            view.dispatch((0, (0, parcelRequire("fZzhT")).closeHistory)(tr));
        });
    };
});
parcelRegister("le6Z8", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$13268a4778e68ea8$export$18d4026d1ea86bb1);
    $parcel$export(module.exports, "getPluginState", ()=>$13268a4778e68ea8$export$f05434c51e3762e);
    $parcel$export(module.exports, "autoformatAction", ()=>$13268a4778e68ea8$export$c921af6adf4fd3e2);
    var $gZGBX;
    const $13268a4778e68ea8$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('customAutoformatPlugin');
    const $13268a4778e68ea8$export$f05434c51e3762e = (editorState)=>$13268a4778e68ea8$export$18d4026d1ea86bb1.getState(editorState);
    const $13268a4778e68ea8$export$c921af6adf4fd3e2 = (tr, action)=>{
        return tr.setMeta($13268a4778e68ea8$export$18d4026d1ea86bb1, action);
    };
});
parcelRegister("g1KvC", function(module, exports) {
    $parcel$export(module.exports, "triggerInputRule", ()=>$1e12130f16544b29$export$2b7343a2464fe84e);
    const $1e12130f16544b29$var$MAX_MATCH = 500;
    const $1e12130f16544b29$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
        const { state: state } = view;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        let textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $1e12130f16544b29$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
        for(let i = 0; i < rules.length; i++){
            let match;
            if (text.length) match = rules[i].matchTyping.exec(textBefore);
            else match = rules[i].matchEnter.exec(textBefore);
            if (match) {
                const pos = from - (match[0].length - text.length);
                rules[i].handler(view, match, pos, to);
                return true;
            }
        }
        return false;
    };
});
parcelRegister("cu8fC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2fc06bb9fa3fe2f$export$2e2bcd8739ae039);
    var $c9tNI;
    const $e2fc06bb9fa3fe2f$var$reduce = (state, action)=>{
        switch(action.action){
            case 'matched':
                return (0, (0, parcelRequire("c9tNI")).matched)(state, action);
            case 'resolved':
                return (0, (0, parcelRequire("c9tNI")).resolved)(state, action);
            case 'finish':
                return (0, (0, parcelRequire("c9tNI")).finish)(state, action);
            case 'setProvider':
                return (0, (0, parcelRequire("c9tNI")).setProvider)(state, action);
            default:
                return state;
        }
    };
    var $e2fc06bb9fa3fe2f$export$2e2bcd8739ae039 = $e2fc06bb9fa3fe2f$var$reduce;
});
parcelRegister("c9tNI", function(module, exports) {
    $parcel$export(module.exports, "matched", ()=>$ee3ff70bef4dafa9$export$b373f08cf72033a1);
    $parcel$export(module.exports, "resolved", ()=>$ee3ff70bef4dafa9$export$d06d16b20ced9190);
    $parcel$export(module.exports, "finish", ()=>$ee3ff70bef4dafa9$export$5953b28951b32649);
    $parcel$export(module.exports, "setProvider", ()=>$ee3ff70bef4dafa9$export$1572b3eade6662f9);
    const $ee3ff70bef4dafa9$export$b373f08cf72033a1 = (state, action)=>({
            ...state,
            resolving: [
                ...state.resolving,
                {
                    start: action.start,
                    end: action.end,
                    match: action.match
                }
            ]
        });
    const $ee3ff70bef4dafa9$export$d06d16b20ced9190 = (state, action)=>({
            ...state,
            matches: [
                ...state.matches,
                {
                    replacement: action.replacement,
                    matchString: action.matchString
                }
            ]
        });
    const $ee3ff70bef4dafa9$export$5953b28951b32649 = (state, action)=>{
        return {
            ...state,
            resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
            matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
        };
    };
    const $ee3ff70bef4dafa9$export$1572b3eade6662f9 = (state, action)=>{
        return {
            ...state,
            autoformattingProvider: action.provider
        };
    };
});
parcelRegister("3wlyh", function(module, exports) {
    $parcel$export(module.exports, "decorationsPlugin", ()=>(parcelRequire("IBShN")).decorationsPlugin);
    var $IBShN;
});
parcelRegister("IBShN", function(module, exports) {
    $parcel$export(module.exports, "decorationsPlugin", ()=>$06578ce7d2c93dd5$export$1c07ef1814918eb5);
    var $lljQA;
    const $06578ce7d2c93dd5$export$1c07ef1814918eb5 = ()=>({
            name: 'decorations',
            pmPlugins () {
                return [
                    {
                        name: 'decorationPlugin',
                        plugin: ()=>(0, (0, parcelRequire("lljQA")).default)()
                    }
                ];
            },
            actions: {
                hoverDecoration: (0, parcelRequire("lljQA")).hoverDecoration,
                removeDecoration: (0, parcelRequire("lljQA")).removeDecoration
            },
            getSharedState (editorState) {
                if (!editorState) return {
                    decoration: undefined
                };
                return (0, (0, parcelRequire("lljQA")).decorationStateKey).getState(editorState);
            }
        });
});
parcelRegister("lljQA", function(module, exports) {
    $parcel$export(module.exports, "decorationStateKey", ()=>$c34271d73c40a7ed$export$385f768f10dabdd5);
    $parcel$export(module.exports, "removeDecoration", ()=>$c34271d73c40a7ed$export$ea377ae2b4b58797);
    $parcel$export(module.exports, "hoverDecoration", ()=>$c34271d73c40a7ed$export$fbf24964a8aac61c);
    $parcel$export(module.exports, "default", ()=>$c34271d73c40a7ed$export$2e2bcd8739ae039);
    var $5KWxh;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $etG8M;
    const $c34271d73c40a7ed$export$385f768f10dabdd5 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('decorationPlugin');
    var $c34271d73c40a7ed$export$92a1a3b7554e9387;
    (function(ACTIONS) {
        ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
        ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    })($c34271d73c40a7ed$export$92a1a3b7554e9387 || ($c34271d73c40a7ed$export$92a1a3b7554e9387 = {}));
    const $c34271d73c40a7ed$export$ea377ae2b4b58797 = (state, dispatch)=>{
        const { tr: tr } = state;
        if (dispatch) {
            dispatch(tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
                action: 1
            }));
            return true;
        }
        return false;
    };
    const $c34271d73c40a7ed$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
            let from;
            let parentNode;
            if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
                const selectedNode = state.selection.node;
                const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                    nodeType
                ];
                const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
                if (isNodeTypeMatching) {
                    from = state.selection.from;
                    parentNode = selectedNode;
                }
            }
            const foundParentNode = (0, $5r0mK.findParentNodeOfType)(nodeType)(state.selection);
            if (from === undefined && foundParentNode) {
                from = foundParentNode.pos;
                parentNode = foundParentNode.node;
            }
            if (from === undefined || parentNode === undefined) return false;
            if (dispatch) dispatch(state.tr.setMeta($c34271d73c40a7ed$export$385f768f10dabdd5, {
                action: add ? 0 : 1,
                data: (0, (0, parcelRequire("etG8M")).Decoration).node(from, from + parentNode.nodeSize, {
                    class: className
                }, {
                    key: 'decorationNode'
                })
            }).setMeta('addToHistory', false));
            return true;
        };
    var $c34271d73c40a7ed$export$2e2bcd8739ae039 = ()=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $c34271d73c40a7ed$export$385f768f10dabdd5,
            state: {
                init: ()=>({
                        decoration: undefined
                    }),
                apply (tr, pluginState) {
                    if (pluginState.decoration) {
                        const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                        if (mapResult.deleted) pluginState = {
                            decoration: undefined
                        };
                    }
                    const meta = tr.getMeta($c34271d73c40a7ed$export$385f768f10dabdd5);
                    if (!meta) return pluginState;
                    switch(meta.action){
                        case 0:
                            return {
                                decoration: meta.data
                            };
                        case 1:
                            return {
                                decoration: undefined
                            };
                        default:
                            return pluginState;
                    }
                }
            },
            props: {
                decorations (state) {
                    const { doc: doc } = state;
                    const { decoration: decoration } = $c34271d73c40a7ed$export$385f768f10dabdd5.getState(state);
                    if (decoration) return (0, (0, parcelRequire("etG8M")).DecorationSet).create(doc, [
                        decoration
                    ]);
                    return null;
                }
            }
        });
    };
});
parcelRegister("6mXgW", function(module, exports) {
    $parcel$export(module.exports, "editorDisabledPlugin", ()=>(parcelRequire("Ctl7E")).editorDisabledPlugin);
    var $Ctl7E;
});
parcelRegister("Ctl7E", function(module, exports) {
    $parcel$export(module.exports, "editorDisabledPlugin", ()=>$0b1d569301b77b26$export$db5fb3a4c4390f03);
    var $7nRxN;
    var $5KWxh;
    var $aOimD;
    var $gZGBX;
    const $0b1d569301b77b26$var$pluginKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)('editorDisabledPlugin');
    function $0b1d569301b77b26$var$reducer(_pluginState, meta) {
        return meta;
    }
    const { createPluginState: $0b1d569301b77b26$var$createPluginState, getPluginState: $0b1d569301b77b26$var$getPluginState } = (0, (0, parcelRequire("aOimD")).pluginFactory)($0b1d569301b77b26$var$pluginKey, $0b1d569301b77b26$var$reducer);
    const $0b1d569301b77b26$var$scheduleEditorDisabledUpdate = (0, (0, parcelRequire("7nRxN")).default)((view)=>{
        if ($0b1d569301b77b26$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const tr = view.state.tr.setMeta($0b1d569301b77b26$var$pluginKey, {
                editorDisabled: !view.editable
            });
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    function $0b1d569301b77b26$var$createPlugin(dispatch) {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $0b1d569301b77b26$var$pluginKey,
            state: $0b1d569301b77b26$var$createPluginState(dispatch, {
                editorDisabled: false
            }),
            view: ()=>{
                return {
                    update (view) {
                        $0b1d569301b77b26$var$scheduleEditorDisabledUpdate(view);
                    },
                    destroy () {
                        $0b1d569301b77b26$var$scheduleEditorDisabledUpdate.cancel();
                    }
                };
            }
        });
    }
    const $0b1d569301b77b26$export$db5fb3a4c4390f03 = ()=>({
            name: 'editorDisabled',
            getSharedState (editorState) {
                if (!editorState) return {
                    editorDisabled: false
                };
                const pluginState = $0b1d569301b77b26$var$pluginKey.getState(editorState);
                if (!pluginState) return {
                    editorDisabled: false
                };
                return pluginState;
            },
            pmPlugins: ()=>[
                    {
                        name: 'editorDisabled',
                        plugin: ({ dispatch: dispatch })=>$0b1d569301b77b26$var$createPlugin(dispatch)
                    }
                ]
        });
});
parcelRegister("5I6Ej", function(module, exports) {
    $parcel$export(module.exports, "featureFlagsPlugin", ()=>(parcelRequire("29BTY")).featureFlagsPlugin);
    var $29BTY;
});
parcelRegister("29BTY", function(module, exports) {
    $parcel$export(module.exports, "featureFlagsPlugin", ()=>$1b2455e4b09dc831$export$79626a094e303f80);
    var $5KWxh;
    var $gZGBX;
    const $1b2455e4b09dc831$var$pluginKey = new (0, (0, parcelRequire("gZGBX")).PluginKey)('featureFlags');
    const $1b2455e4b09dc831$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
            name: 'featureFlags',
            getSharedState (editorState) {
                if (!editorState) return featureFlags || {};
                return $1b2455e4b09dc831$var$pluginKey.getState(editorState) || featureFlags || {};
            },
            pmPlugins () {
                return [
                    {
                        name: 'featureFlags',
                        plugin: ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
                                key: $1b2455e4b09dc831$var$pluginKey,
                                state: {
                                    init: ()=>({
                                            ...featureFlags
                                        }),
                                    apply: (_, pluginState)=>pluginState
                                }
                            })
                    }
                ];
            }
        });
});
parcelRegister("2fcyF", function(module, exports) {
    $parcel$export(module.exports, "floatingToolbarPlugin", ()=>(parcelRequire("1bV4T")).floatingToolbarPlugin);
    var $1bV4T;
});
parcelRegister("1bV4T", function(module, exports) {
    $parcel$export(module.exports, "floatingToolbarPlugin", ()=>$e87d40a96b12aa71$export$baed971c987bc0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $gkwXh;
    var $9pOon;
    var $awTmI;
    var $9Egzu;
    var $5KWxh;
    var $4N9VB;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $3FjQE;
    var $bZuB7;
    var $8gLmf;
    var $9NIbV;
    var $lPuFS;
    var $g0hjU;
    var $7uxXk;
    const $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
        let configPair;
        configs.find((config)=>{
            const node = (0, $5r0mK.findSelectedNodeOfType)(config.nodeType)(selection);
            if (node) configPair = {
                node: node.node,
                pos: node.pos,
                config: config
            };
            return !!node;
        });
        if (configPair) return configPair;
        const configByNodeType = {};
        configs.forEach((config)=>{
            if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
                configByNodeType[nodeType.name] = config;
            });
            else configByNodeType[config.nodeType.name] = config;
        });
        const { $from: $from } = selection;
        for(let i = $from.depth; i > 0; i--){
            const node = $from.node(i);
            const matchedConfig = configByNodeType[node.type.name];
            if (matchedConfig) return {
                config: matchedConfig,
                node: node,
                pos: $from.pos
            };
        }
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).AllSelection)) {
            const docNode = $from.node(0);
            let matchedConfig = null;
            const firstChild = (0, (0, parcelRequire("lPuFS")).findNode)(docNode, (node)=>{
                matchedConfig = configByNodeType[node.type.name];
                return !!matchedConfig;
            });
            if (firstChild && matchedConfig) return {
                config: matchedConfig,
                node: firstChild,
                pos: $from.pos
            };
        }
        return;
    };
    const $e87d40a96b12aa71$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
        try {
            return (0, $5r0mK.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        } catch (error) {
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).ERRORED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, (0, parcelRequire("gkwXh")).CONTENT_COMPONENT).FLOATING_TOOLBAR,
                        selection: view.state.selection.toJSON(),
                        position: view.state.selection.from,
                        docSize: view.state.doc.nodeSize,
                        error: error.toString(),
                        errorStack: error.stack || undefined
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
    };
    function $e87d40a96b12aa71$var$filterUndefined(x) {
        return !!x;
    }
    const $e87d40a96b12aa71$export$baed971c987bc0e = ({ api: api })=>{
        return {
            name: 'floatingToolbar',
            pmPlugins (floatingToolbarHandlers = []) {
                return [
                    {
                        name: 'floatingToolbar',
                        plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$e87d40a96b12aa71$export$5c1ec0ef773ca0cc({
                                floatingToolbarHandlers: floatingToolbarHandlers,
                                providerFactory: providerFactory,
                                getIntl: getIntl
                            })
                    },
                    {
                        name: 'floatingToolbarData',
                        plugin: ({ dispatch: dispatch })=>(0, (0, parcelRequire("8gLmf")).createPlugin)(dispatch)
                    },
                    {
                        name: 'forceFocus',
                        plugin: ()=>(0, (0, parcelRequire("3FjQE")).default)()
                    }
                ];
            },
            actions: {
                forceFocusSelector: (0, parcelRequire("3FjQE")).forceFocusSelector
            },
            getSharedState (editorState) {
                if (!editorState) return undefined;
                const configWithNodeInfo = $e87d40a96b12aa71$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined;
                return {
                    configWithNodeInfo: configWithNodeInfo,
                    floatingToolbarData: (0, (0, parcelRequire("9NIbV")).pluginKey).getState(editorState)
                };
            },
            contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
                return (0, ($parcel$interopDefault($5uXOq))).createElement($e87d40a96b12aa71$export$2dda1e4a1d1f6a81, {
                    editorView: editorView,
                    pluginInjectionApi: api,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    providerFactory: providerFactory,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                });
            }
        };
    };
    function $e87d40a96b12aa71$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
        const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, featureFlagsState: featureFlagsState, blockControlsState: blockControlsState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(pluginInjectionApi, [
            'floatingToolbar',
            'editorDisabled',
            'editorViewMode',
            'featureFlags',
            'blockControls'
        ]);
        const { configWithNodeInfo: configWithNodeInfo, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
        if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
        if (featureFlagsState?.elementDragAndDrop && blockControlsState?.isDragging) return null;
        const { config: config, node: node } = configWithNodeInfo;
        let { items: items, groupLabel: groupLabel } = config;
        const { title: title, getDomRef: getDomRef = $e87d40a96b12aa71$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
            0,
            12
        ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
        const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
        const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
        const isInViewMode = editorViewModeState?.mode === 'view';
        if (!targetRef || isEditorDisabled && !isInViewMode) return null;
        const iterableItems = Array.isArray(items) ? items : items?.(node);
        if (isInViewMode) {
            const toolbarItemViewModeProp = 'supportsViewMode';
            items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
        }
        let customPositionCalculation;
        const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
        if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
            return onPositionCalculated(editorView, nextPos);
        };
        const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
        const { confirmDialogForItem: confirmDialogForItem } = floatingToolbarData || {};
        const confirmButtonItem = confirmDialogForItem ? toolbarItems[confirmDialogForItem] : undefined;
        const scrollable = config.scrollable;
        const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9pOon")).ErrorBoundary), {
            component: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
            componentId: (0, ($parcel$interopDefault($e4eHl)))(title),
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            fallbackComponent: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4N9VB")).default), {
            ariaLabel: title,
            offset: offset,
            target: targetRef,
            alignY: "bottom",
            forcePlacement: forcePlacement,
            fitHeight: height,
            fitWidth: width,
            absoluteOffset: absoluteOffset,
            alignX: align,
            stick: stick,
            zIndex: zIndex,
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onPositionCalculated: customPositionCalculation,
            style: scrollable ? {
                maxWidth: '100%'
            } : {},
            focusTrap: focusTrap,
            preventOverflow: preventPopupOverflow
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9Egzu")).WithProviders), {
            providerFactory: providerFactory,
            providers: [
                'extensionProvider'
            ],
            renderNode: (providers)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7uxXk")).ToolbarLoader), {
                    target: targetRef,
                    items: toolbarItems,
                    groupLabel: groupLabel,
                    node: node,
                    dispatchCommand: dispatchCommand,
                    editorView: editorView,
                    className: className,
                    focusEditor: ()=>editorView.focus(),
                    providerFactory: providerFactory,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    extensionsProvider: providers.extensionProvider,
                    scrollable: scrollable,
                    api: pluginInjectionApi,
                    mediaAssistiveMessage: mediaAssistiveMessage
                });
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g0hjU")).ConfirmationModal), {
            testId: "ak-floating-toolbar-confirmation-modal",
            options: confirmDialogOptions,
            onConfirm: (isChecked = false)=>{
                if (!!confirmDialogOptions.onConfirm) dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                else dispatchCommand(confirmButtonItem.onClick);
            },
            onClose: ()=>{
                dispatchCommand((0, (0, parcelRequire("bZuB7")).hideConfirmDialog)());
                if (!editorView.hasFocus()) editorView.focus();
            }
        }));
    }
    const $e87d40a96b12aa71$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('floatingToolbarPluginKey');
    function $e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config) {
        if (Array.isArray(config.nodeType)) return {
            ...config,
            nodeType: config.nodeType.filter($e87d40a96b12aa71$var$filterUndefined)
        };
        return config;
    }
    function $e87d40a96b12aa71$export$5c1ec0ef773ca0cc(options) {
        const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl } = options;
        const intl = getIntl();
        const getConfigWithNodeInfo = (editorState)=>{
            let activeConfigs = [];
            for(let index = 0; index < floatingToolbarHandlers.length; index++){
                const handler = floatingToolbarHandlers[index];
                const config = handler(editorState, intl, providerFactory, activeConfigs);
                if (config) activeConfigs.push($e87d40a96b12aa71$var$sanitizeFloatingToolbarConfig(config));
            }
            const relevantConfig = activeConfigs && $e87d40a96b12aa71$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
            return relevantConfig;
        };
        const apply = ()=>{
            const newPluginState = {
                getConfigWithNodeInfo: getConfigWithNodeInfo
            };
            return newPluginState;
        };
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $e87d40a96b12aa71$export$18d4026d1ea86bb1,
            state: {
                init: ()=>{
                    (0, (0, parcelRequire("7uxXk")).ToolbarLoader).preload();
                    return {
                        getConfigWithNodeInfo: getConfigWithNodeInfo
                    };
                },
                apply: apply
            }
        });
    }
});
parcelRegister("3FjQE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$678344aaf110db44$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "forceFocusSelector", ()=>$678344aaf110db44$export$1470545de94762f5);
    $parcel$export(module.exports, "checkShouldForceFocusAndApply", ()=>$678344aaf110db44$export$a2ced8424a9be595);
    var $5KWxh;
    var $gZGBX;
    const $678344aaf110db44$export$ded15a80767f6af7 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('forceFocusStatePlugin');
    var $678344aaf110db44$export$2e2bcd8739ae039 = ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $678344aaf110db44$export$ded15a80767f6af7,
            state: {
                init: ()=>({
                        selector: null
                    }),
                apply: (tr, prevState)=>{
                    const meta = tr.getMeta($678344aaf110db44$export$ded15a80767f6af7);
                    if (meta && 'selector' in meta) return {
                        selector: meta.selector
                    };
                    return prevState;
                }
            }
        });
    const $678344aaf110db44$export$1470545de94762f5 = (selector)=>(tr)=>{
            return tr.setMeta($678344aaf110db44$export$ded15a80767f6af7, {
                selector: selector
            });
        };
    function $678344aaf110db44$export$a2ced8424a9be595(view) {
        const state = view?.state;
        if (state) {
            const { selector: selector } = $678344aaf110db44$export$ded15a80767f6af7.getState(state);
            if (selector) {
                const focusableElement = document.querySelector(selector);
                if (focusableElement) {
                    focusableElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                    focusableElement.focus();
                    const { state: { tr: tr }, dispatch: dispatch } = view;
                    dispatch($678344aaf110db44$export$1470545de94762f5(null)(tr));
                }
            }
        }
    }
});
parcelRegister("bZuB7", function(module, exports) {
    $parcel$export(module.exports, "showConfirmDialog", ()=>$631febdcbf84957f$export$c0076bd4afc29e7a);
    $parcel$export(module.exports, "hideConfirmDialog", ()=>$631febdcbf84957f$export$5a3c1357cfd1045c);
    var $6ka1z;
    const $631febdcbf84957f$export$c0076bd4afc29e7a = (buttonIndex)=>(0, (0, parcelRequire("6ka1z")).createCommand)({
            type: 'SHOW_CONFIRM_DIALOG',
            data: {
                buttonIndex: buttonIndex
            }
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $631febdcbf84957f$export$5a3c1357cfd1045c = ()=>(0, (0, parcelRequire("6ka1z")).createCommand)({
            type: 'HIDE_CONFIRM_DIALOG'
        }, (tr)=>tr.setMeta('addToHistory', false));
});
parcelRegister("6ka1z", function(module, exports) {
    $parcel$export(module.exports, "createPluginState", ()=>$5a9052fdd4f97f79$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$5a9052fdd4f97f79$export$8d4021544bdece00);
    var $aOimD;
    var $9NIbV;
    var $iT6WM;
    const { createPluginState: $5a9052fdd4f97f79$export$656c7661095efe2e, createCommand: $5a9052fdd4f97f79$export$8d4021544bdece00, getPluginState: $5a9052fdd4f97f79$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("9NIbV")).pluginKey), (0, (0, parcelRequire("iT6WM")).reducer));
});
parcelRegister("9NIbV", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$9835a39d0d550488$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $9835a39d0d550488$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('floatingToolbarData');
});
parcelRegister("iT6WM", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$ac14a01a9a722e87$export$1650419e431d3ba3);
    const $ac14a01a9a722e87$export$1650419e431d3ba3 = (pluginState, action)=>{
        switch(action.type){
            case 'SHOW_CONFIRM_DIALOG':
                return {
                    ...pluginState,
                    confirmDialogForItem: action.data.buttonIndex
                };
            case 'HIDE_CONFIRM_DIALOG':
                return {
                    ...pluginState,
                    confirmDialogForItem: undefined
                };
            default:
                return pluginState;
        }
    };
});
parcelRegister("8gLmf", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$a3032e30bd40b708$export$ae829ec7b2625219);
    var $5KWxh;
    var $6ka1z;
    var $9NIbV;
    const $a3032e30bd40b708$export$ae829ec7b2625219 = (dispatch)=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            state: (0, (0, parcelRequire("6ka1z")).createPluginState)(dispatch, {}),
            key: (0, (0, parcelRequire("9NIbV")).pluginKey)
        });
    };
});
parcelRegister("lPuFS", function(module, exports) {
    $parcel$export(module.exports, "findNode", ()=>$a9058a265ed6ea0d$export$5b92d7a8b5d33ee2);
    function $a9058a265ed6ea0d$export$5b92d7a8b5d33ee2(parent, predicate) {
        let matchedNode;
        parent.descendants((node)=>{
            if (matchedNode) return false;
            if (predicate(node)) {
                matchedNode = node;
                return false;
            }
            return true;
        });
        return matchedNode;
    }
});
parcelRegister("g0hjU", function(module, exports) {
    $parcel$export(module.exports, "ConfirmationModal", ()=>$06e379d09049f01c$export$1f33f980da756c46);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $i8Qvm;
    var $f9HzI;
    var $gKJRF;
    const $06e379d09049f01c$var$ConfirmationModalImpl = (props)=>{
        const { options: options } = props;
        const renderModel = (isReferentialityDialog = false)=>isReferentialityDialog ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f9HzI")).CheckboxModal), props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gKJRF")).SimpleModal), props);
        return options ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, renderModel(options?.isReferentialityDialog)) : null;
    };
    const $06e379d09049f01c$export$1f33f980da756c46 = (0, (0, parcelRequire("8RXs9")).default)($06e379d09049f01c$var$ConfirmationModalImpl);
});
parcelRegister("f9HzI", function(module, exports) {
    $parcel$export(module.exports, "CheckboxModal", ()=>$2670a3f256ccd0e9$export$9c828de50258a892);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $kkJfY;
    var $5K8Ey;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    const $2670a3f256ccd0e9$export$9c828de50258a892 = (props)=>{
        const [isChecked, setCheckbox] = (0, $5uXOq.useState)(false);
        const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
        const heading = options?.title || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalDefaultHeading);
        const okButtonLabel = options?.okButtonLabel || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalOK);
        const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalCancel);
        const checkboxlabel = options?.checkboxLabel;
        const childrenInfo = options?.getChildrenInfo?.();
        const ListComponent = ({ nodes: nodes })=>{
            if (nodes.length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, nodes.map((node)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ListItem, {
                    ...node,
                    key: node.id
                })));
        };
        const ListItem = (props)=>{
            const { id: id, name: name, amount: amount } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                id: id
            }, formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalListUnit, {
                name: name,
                amount: amount
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, heading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, options?.message), !!childrenInfo?.length && (0, ($parcel$interopDefault($5uXOq))).createElement(ListComponent, {
            nodes: childrenInfo
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            isChecked: isChecked,
            onChange: ()=>setCheckbox(!isChecked),
            label: checkboxlabel,
            testId: testId ? `${testId}-checkbox` : undefined
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "default",
            onClick: onClose,
            testId: testId ? `${testId}-cancel-button` : undefined
        }, cancelButtonLabel), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "warning",
            onClick: ()=>{
                onConfirm(isChecked);
                onClose();
            },
            testId: testId ? `${testId}-confirm-button` : undefined
        }, okButtonLabel)));
    };
});
parcelRegister("5K8Ey", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1aa315cef11144c5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1aa315cef11144c5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        confirmModalDefaultHeading: {
            id: 'fabric.editor.floatingToolbar.confirmModalHeading',
            defaultMessage: 'Are you sure?',
            description: 'Default heading of floating toolbar confirmation modal.'
        },
        confirmModalOK: {
            id: 'fabric.editor.floatingToolbar.confirmModalOK',
            defaultMessage: 'OK',
            description: 'OK button for floating toolbar confirmation modal.'
        },
        confirmModalCancel: {
            id: 'fabric.editor.floatingToolbar.confirmModalCancel',
            defaultMessage: 'Cancel',
            description: 'Cancel button for floating toolbar confirmation modal.'
        },
        confirmModalListUnit: {
            id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
            defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
            description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
        },
        confirmDeleteLinkedModalMessage: {
            id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
            defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
            description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
        },
        floatingToolbarAriaLabel: {
            id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
            defaultMessage: 'Floating Toolbar',
            description: "a floating toolbar's aria label"
        },
        floatingToolbarAnnouncer: {
            id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
            defaultMessage: 'Floating toolbar controls have been opened',
            description: 'message that will be announced to screenreaders that the floating toolbar is opened'
        },
        floatingToolbarScrollLeft: {
            id: 'fabric.editor.floatingToolbar.scrollLeft',
            defaultMessage: 'Scroll left',
            description: 'Button to scroll left when the toolbar is in the overflow state'
        },
        floatingToolbarScrollRight: {
            id: 'fabric.editor.floatingToolbar.scrollRight',
            defaultMessage: 'Scroll right',
            description: 'Button to scroll right when the toolbar is in the overflow state'
        }
    });
});
parcelRegister("gKJRF", function(module, exports) {
    $parcel$export(module.exports, "SimpleModal", ()=>$09c3f293e9a8351d$export$f96c193e316d2274);
    var $5uXOq = parcelRequire("5uXOq");
    var $eCeGD;
    var $5K8Ey;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $cgL5K;
    const $09c3f293e9a8351d$export$f96c193e316d2274 = (props)=>{
        const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
        const heading = options?.title || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalDefaultHeading);
        const okButtonLabel = options?.okButtonLabel || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalOK);
        const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, (0, parcelRequire("5K8Ey")).default).confirmModalCancel);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: onClose,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, heading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, options?.message)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "default",
            onClick: onClose,
            testId: testId ? `${testId}-cancel-button` : undefined
        }, cancelButtonLabel), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "warning",
            onClick: ()=>{
                onConfirm();
                onClose();
            },
            testId: testId ? `${testId}-confirm-button` : undefined
        }, okButtonLabel)));
    };
});
parcelRegister("7uxXk", function(module, exports) {
    $parcel$export(module.exports, "ToolbarLoader", ()=>$f13a9dac652e34d3$export$8f0e0160298415aa);
    var $4qBtX = parcelRequire("4qBtX");
    const $f13a9dac652e34d3$export$8f0e0160298415aa = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("47ecn")).then((mod)=>mod.default),
        loading: ()=>null
    });
});
parcelRegister("47ecn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7iFrB")
    ]).then(()=>parcelRequire('4vSmI'));
});
parcelRegister("7bJco", function(module, exports) {
    $parcel$export(module.exports, "focusPlugin", ()=>(parcelRequire("4y8T6")).focusPlugin);
    var $4y8T6;
});
parcelRegister("4y8T6", function(module, exports) {
    $parcel$export(module.exports, "focusPlugin", ()=>$3a3c0b11abeb4fe9$export$78540d08bd386fba);
    var $6N2wx;
    const $3a3c0b11abeb4fe9$export$78540d08bd386fba = ({ api: api })=>{
        return {
            name: 'focus',
            getSharedState (editorState) {
                if (!editorState) return {
                    hasFocus: false
                };
                return {
                    hasFocus: Boolean((0, (0, parcelRequire("6N2wx")).key).getState(editorState)?.hasFocus)
                };
            },
            pmPlugins () {
                return [
                    {
                        name: 'focusHandlerPlugin',
                        plugin: (0, (0, parcelRequire("6N2wx")).createPlugin)
                    }
                ];
            }
        };
    };
});
parcelRegister("6N2wx", function(module, exports) {
    $parcel$export(module.exports, "key", ()=>$e2f10d9885742530$export$df61b30b684217c0);
    $parcel$export(module.exports, "createPlugin", ()=>$e2f10d9885742530$export$ae829ec7b2625219);
    var $5KWxh;
    var $gZGBX;
    const $e2f10d9885742530$export$df61b30b684217c0 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('focusPluginHandler');
    const $e2f10d9885742530$export$ae829ec7b2625219 = ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $e2f10d9885742530$export$df61b30b684217c0,
            state: {
                init () {
                    return {
                        hasFocus: false
                    };
                },
                apply (tr, oldPluginState) {
                    const meta = tr.getMeta($e2f10d9885742530$export$df61b30b684217c0);
                    if (typeof meta === 'boolean') {
                        if (meta !== oldPluginState.hasFocus) return {
                            hasFocus: meta
                        };
                    }
                    return oldPluginState;
                }
            },
            props: {
                handleDOMEvents: {
                    focus: (view)=>{
                        const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                        if (!focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, true));
                        return false;
                    },
                    blur: (view)=>{
                        const focusState = $e2f10d9885742530$export$df61b30b684217c0.getState(view.state);
                        if (focusState?.hasFocus) view.dispatch(view.state.tr.setMeta($e2f10d9885742530$export$df61b30b684217c0, false));
                        return false;
                    }
                }
            }
        });
});
parcelRegister("hrqyH", function(module, exports) {
    $parcel$export(module.exports, "gridPlugin", ()=>(parcelRequire("acf8A")).gridPlugin);
    var $acf8A;
});
parcelRegister("acf8A", function(module, exports) {
    $parcel$export(module.exports, "gridPlugin", ()=>$a5c528840d08129f$export$c090e341e8f725a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $g0wej;
    var $9ci4W = parcelRequire("9ci4W");
    var $awTmI;
    var $5KWxh;
    var $gZGBX;
    var $iHYdz;
    const $a5c528840d08129f$export$bc90872e265d166e = 12;
    const $a5c528840d08129f$var$key = new (0, (0, parcelRequire("gZGBX")).PluginKey)('gridPlugin');
    const $a5c528840d08129f$var$createDisplayGrid = (view)=>(props)=>{
            const { dispatch: dispatch, state: state } = view;
            const tr = state.tr.setMeta($a5c528840d08129f$var$key, props);
            dispatch(tr);
            return true;
        };
    const $a5c528840d08129f$var$sides = [
        'left',
        'right'
    ];
    const $a5c528840d08129f$var$overflowHighlight = (highlights, side, start, size)=>{
        if (!highlights.length) return false;
        const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
        const minHighlight = Math.min(...numericHighlights);
        const maxHighlight = Math.max(...numericHighlights);
        if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
        else return maxHighlight > $a5c528840d08129f$export$bc90872e265d166e && maxHighlight >= $a5c528840d08129f$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $a5c528840d08129f$export$bc90872e265d166e + size : true);
    };
    const $a5c528840d08129f$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
        const gridLines = [];
        if (!shouldCalcBreakoutGridLines) return gridLines;
        const wideSpacing = (editorMaxWidth * (0, (0, parcelRequire("iHYdz")).breakoutWideScaleRatio) - editorMaxWidth) / 2;
        $a5c528840d08129f$var$sides.forEach((side)=>{
            gridLines.push((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: side,
                className: (0, ($parcel$interopDefault($9ci4W)))('gridLine', $a5c528840d08129f$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
                style: {
                    position: 'absolute',
                    [side]: `-${wideSpacing}px`
                }
            }));
            gridLines.push((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: side + '-bk',
                className: (0, ($parcel$interopDefault($9ci4W)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
                style: {
                    position: 'absolute',
                    [side]: `-${(editorWidth - editorMaxWidth - (0, (0, parcelRequire("iHYdz")).akEditorBreakoutPadding)) / 2}px`
                }
            }));
        });
        return gridLines;
    };
    const $a5c528840d08129f$var$lineLengthGridLines = (highlights)=>{
        const gridLines = [];
        const gridSpacing = 100 / $a5c528840d08129f$export$bc90872e265d166e;
        for(let i = 0; i <= $a5c528840d08129f$export$bc90872e265d166e; i++){
            const style = {
                paddingLeft: `${gridSpacing}%`
            };
            gridLines.push((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: i,
                className: (0, ($parcel$interopDefault($9ci4W)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
                style: i < $a5c528840d08129f$export$bc90872e265d166e ? style : undefined
            }));
        }
        return gridLines;
    };
    const $a5c528840d08129f$var$Grid = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, theme: theme, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, visible: visible })=>{
        const editorMaxWidth = theme.layoutMaxWidth;
        let gridLines = [
            ...$a5c528840d08129f$var$lineLengthGridLines(highlight),
            ...$a5c528840d08129f$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
        ];
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: "gridParent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, ($parcel$interopDefault($9ci4W)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none'
            },
            "data-testid": "gridContainer"
        }, gridLines)));
    };
    const $a5c528840d08129f$var$ThemedGrid = (0, (0, parcelRequire("g0wej")).b)($a5c528840d08129f$var$Grid);
    const $a5c528840d08129f$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
        const { widthState: widthState, gridState: gridState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'width',
            'grid'
        ]);
        if (!gridState) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a5c528840d08129f$var$ThemedGrid, {
            shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
            editorWidth: widthState?.width ?? (0, (0, parcelRequire("iHYdz")).akEditorFullPageMaxWidth),
            containerElement: editorView.dom,
            visible: gridState.visible,
            gridType: gridState.gridType ?? 'full',
            highlight: gridState.highlight
        });
    };
    const $a5c528840d08129f$var$EMPTY_STATE = {
        visible: false,
        highlight: []
    };
    const $a5c528840d08129f$var$gridPMPlugin = new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
        key: $a5c528840d08129f$var$key,
        state: {
            init () {
                return $a5c528840d08129f$var$EMPTY_STATE;
            },
            apply (tr, currentPluginState) {
                const nextPluginState = tr.getMeta($a5c528840d08129f$var$key);
                if (nextPluginState) return nextPluginState;
                return currentPluginState;
            }
        }
    });
    const $a5c528840d08129f$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
        return {
            name: 'grid',
            getSharedState (editorState) {
                if (!editorState) return null;
                return $a5c528840d08129f$var$key.getState(editorState) || null;
            },
            actions: {
                displayGrid: $a5c528840d08129f$var$createDisplayGrid
            },
            pmPlugins () {
                return [
                    {
                        name: 'grid',
                        plugin: ()=>$a5c528840d08129f$var$gridPMPlugin
                    }
                ];
            },
            contentComponent: ({ editorView: editorView })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a5c528840d08129f$var$ContentComponent, {
                    editorView: editorView,
                    options: options,
                    api: api
                })
        };
    };
});
parcelRegister("2DIrX", function(module, exports) {
    $parcel$export(module.exports, "historyPlugin", ()=>(parcelRequire("17hss")).default);
    var $17hss;
});
parcelRegister("17hss", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dfe5ccc28dc8dc9d$export$2e2bcd8739ae039);
    var $5KWxh;
    var $aOimD;
    var $8fY92;
    var $8jK0Y;
    var $1yJk5;
    var $cimSF;
    const $dfe5ccc28dc8dc9d$var$getInitialState = ()=>({
            canUndo: false,
            canRedo: false
        });
    const { createPluginState: $dfe5ccc28dc8dc9d$var$createPluginState, getPluginState: $dfe5ccc28dc8dc9d$var$getPluginState } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("8jK0Y")).historyPluginKey), (0, (0, parcelRequire("1yJk5")).default));
    const $dfe5ccc28dc8dc9d$var$createPlugin = (dispatch)=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            state: $dfe5ccc28dc8dc9d$var$createPluginState(dispatch, $dfe5ccc28dc8dc9d$var$getInitialState),
            key: (0, (0, parcelRequire("8jK0Y")).historyPluginKey),
            appendTransaction: (transactions, oldState, newState)=>{
                if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false)) {
                    const pmHistoryPluginState = (0, (0, parcelRequire("cimSF")).getPmHistoryPluginState)(newState);
                    if (!pmHistoryPluginState) return;
                    const canUndo = pmHistoryPluginState.done.eventCount > 0;
                    const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                    const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $dfe5ccc28dc8dc9d$var$getPluginState(newState);
                    if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                        const action = {
                            type: (0, (0, parcelRequire("8fY92")).HistoryActionTypes).UPDATE,
                            canUndo: canUndo,
                            canRedo: canRedo
                        };
                        return newState.tr.setMeta((0, (0, parcelRequire("8jK0Y")).historyPluginKey), action);
                    }
                }
            }
        });
    const $dfe5ccc28dc8dc9d$var$historyPlugin = ()=>({
            name: 'history',
            pmPlugins () {
                return [
                    {
                        name: 'history',
                        plugin: ({ dispatch: dispatch })=>$dfe5ccc28dc8dc9d$var$createPlugin(dispatch)
                    }
                ];
            },
            getSharedState: (editorState)=>{
                if (!editorState) return undefined;
                return (0, (0, parcelRequire("8jK0Y")).historyPluginKey).getState(editorState);
            }
        });
    var $dfe5ccc28dc8dc9d$export$2e2bcd8739ae039 = $dfe5ccc28dc8dc9d$var$historyPlugin;
});
parcelRegister("8fY92", function(module, exports) {
    $parcel$export(module.exports, "HistoryActionTypes", ()=>$28b26c1adac69345$export$324bf1d9598f1f30);
    var $28b26c1adac69345$export$324bf1d9598f1f30;
    (function(HistoryActionTypes) {
        HistoryActionTypes["UPDATE"] = "UPDATE";
    })($28b26c1adac69345$export$324bf1d9598f1f30 || ($28b26c1adac69345$export$324bf1d9598f1f30 = {}));
});
parcelRegister("8jK0Y", function(module, exports) {
    $parcel$export(module.exports, "historyPluginKey", ()=>$856a91f1608ae961$export$8869884044241c3c);
    var $gZGBX;
    const $856a91f1608ae961$export$8869884044241c3c = new (0, (0, parcelRequire("gZGBX")).PluginKey)('historyPlugin');
});
parcelRegister("1yJk5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33eca6c835ad66f3$export$2e2bcd8739ae039);
    var $8fY92;
    const $33eca6c835ad66f3$var$reducer = (state, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("8fY92")).HistoryActionTypes).UPDATE:
                return {
                    canUndo: action.canUndo,
                    canRedo: action.canRedo
                };
        }
        return state;
    };
    var $33eca6c835ad66f3$export$2e2bcd8739ae039 = $33eca6c835ad66f3$var$reducer;
});
parcelRegister("cimSF", function(module, exports) {
    $parcel$export(module.exports, "getPmHistoryPluginState", ()=>$21468f00baa24015$export$6bcebd7b5d7b9325);
    var $77j9j;
    const $21468f00baa24015$export$37e0e4eb94b3734e = (state)=>{
        return state.plugins.find((plugin)=>plugin.key === (0, (0, parcelRequire("77j9j")).pmHistoryPluginKey));
    };
    const $21468f00baa24015$export$6bcebd7b5d7b9325 = (state)=>{
        const pmHistoryPlugin = $21468f00baa24015$export$37e0e4eb94b3734e(state);
        if (!pmHistoryPlugin) return;
        return pmHistoryPlugin.getState(state);
    };
});
parcelRegister("bM5ai", function(module, exports) {
    $parcel$export(module.exports, "hyperlinkPlugin", ()=>(parcelRequire("53MdN")).hyperlinkPlugin);
    var $53MdN;
});
parcelRegister("53MdN", function(module, exports) {
    $parcel$export(module.exports, "hyperlinkPlugin", ()=>$e1cb8ed4b65cf8be$export$8143923e8601d272);
    var $5uXOq = parcelRequire("5uXOq");
    var $8XeG6;
    var $gkwXh;
    var $e9qoo;
    var $2Y1rH;
    var $2i4K4;
    var $31nwk;
    var $I02Nt;
    var $dPSMN;
    var $fcZox;
    var $gmhCD = parcelRequire("gmhCD");
    var $bylXe;
    var $30OPT;
    var $MxEYb;
    var $3F7Mv;
    var $gHHQB;
    var $k023r;
    var $qbNm3;
    const $e1cb8ed4b65cf8be$var$getPosFromActiveLinkMark = (state)=>{
        if (state === undefined) return undefined;
        switch(state.type){
            case 'EDIT':
            case 'EDIT_INSERTED':
                return state.pos;
            case 'INSERT':
                return undefined;
        }
    };
    const $e1cb8ed4b65cf8be$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
    const $e1cb8ed4b65cf8be$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
        return {
            name: 'hyperlink',
            marks () {
                return [
                    {
                        name: 'link',
                        mark: (0, (0, parcelRequire("8XeG6")).link)
                    }
                ];
            },
            commands: {
                showLinkToolbar: (inputMethod = (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR)=>(0, (0, parcelRequire("bylXe")).showLinkToolbar)(inputMethod, api?.analytics?.actions),
                updateLink: (href, text)=>{
                    const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                    const pos = $e1cb8ed4b65cf8be$var$getPosFromActiveLinkMark(linkMark);
                    if (pos === undefined) return ()=>null;
                    return (0, (0, parcelRequire("bylXe")).updateLinkEditorCommand)(href, text, pos);
                },
                removeLink: ()=>{
                    const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                    const pos = $e1cb8ed4b65cf8be$var$getPosFromActiveLinkMark(linkMark);
                    if (pos === undefined) return ()=>null;
                    return (0, (0, parcelRequire("bylXe")).removeLinkEditorCommand)(pos, api?.analytics?.actions);
                }
            },
            actions: {
                hideLinkToolbar: (0, (0, parcelRequire("bylXe")).hideLinkToolbarSetMeta),
                insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, (0, parcelRequire("bylXe")).insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
                updateLink: (0, (0, parcelRequire("bylXe")).updateLink)
            },
            getSharedState (editorState) {
                if (!editorState) return undefined;
                return (0, (0, parcelRequire("gHHQB")).stateKey).getState(editorState);
            },
            pmPlugins () {
                return [
                    {
                        name: 'hyperlink',
                        plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, (0, parcelRequire("gHHQB")).plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, options.__livePage)
                    },
                    {
                        name: 'fakeCursorToolbarPlugin',
                        plugin: ()=>(0, (0, parcelRequire("30OPT")).default)
                    },
                    {
                        name: 'hyperlinkInputRule',
                        plugin: ({ schema: schema })=>(0, (0, parcelRequire("MxEYb")).createInputRulePlugin)(schema, api?.analytics?.actions)
                    },
                    {
                        name: 'hyperlinkKeymap',
                        plugin: ()=>(0, (0, parcelRequire("3F7Mv")).createKeymapPlugin)(api?.analytics?.actions)
                    },
                    {
                        name: 'hyperlinkToolbarButtons',
                        plugin: ()=>{
                            const hasCard = !!api?.card?.actions;
                            return (0, (0, parcelRequire("k023r")).toolbarButtonsPlugin)(hasCard ? {
                                skipAnalytics: true
                            } : undefined);
                        }
                    }
                ];
            },
            pluginsOptions: {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'hyperlink',
                            title: formatMessage((0, (0, parcelRequire("2i4K4")).toolbarInsertBlockMessages).link),
                            description: formatMessage((0, (0, parcelRequire("2i4K4")).toolbarInsertBlockMessages).linkDescription),
                            keywords: [
                                'hyperlink',
                                'url'
                            ],
                            priority: 1200,
                            keyshortcut: (0, (0, parcelRequire("e9qoo")).tooltip)((0, (0, parcelRequire("e9qoo")).addLink)),
                            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("I02Nt")).IconLink), null),
                            action (insert, state) {
                                const tr = insert(undefined);
                                tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                                    type: (0, (0, parcelRequire("2Y1rH")).LinkAction).SHOW_INSERT_TOOLBAR,
                                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT
                                });
                                const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD,
                                    actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                    attributes: {
                                        inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                                })(tr);
                                return analyticsAttached !== false ? tr : false;
                            }
                        }
                    ],
                floatingToolbar: (0, (0, parcelRequire("qbNm3")).getToolbarConfig)(options, api),
                selectionToolbar: (state, { formatMessage: formatMessage })=>{
                    if ((0, $gmhCD.editorExperiment)('contextual_formatting_toolbar', true, {
                        exposure: true
                    })) {
                        const toolbarButton = ()=>{
                            const { from: from, to: to } = state.selection;
                            const isEnabled = (0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(from, to)(state);
                            const title = formatMessage((0, (0, parcelRequire("2i4K4")).toolbarInsertBlockMessages).link);
                            return {
                                type: 'button',
                                disabled: !isEnabled,
                                testId: `${$e1cb8ed4b65cf8be$var$selectionToolbarLinkButtonTestId}`,
                                icon: (0, ($parcel$interopDefault((0, parcelRequire("fcZox"))))),
                                title: title,
                                tooltipContent: (0, (0, parcelRequire("e9qoo")).tooltip)((0, (0, parcelRequire("e9qoo")).addLink), title),
                                showTitle: false,
                                onClick: (state, dispatch)=>{
                                    return (0, (0, parcelRequire("31nwk")).editorCommandToPMCommand)((0, (0, parcelRequire("bylXe")).showLinkToolbar)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                                }
                            };
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarButton()
                            ]
                        };
                    } else return undefined;
                }
            }
        };
    };
});
parcelRegister("2Y1rH", function(module, exports) {
    $parcel$export(module.exports, "LinkAction", ()=>$e3e45f4a3bdd503a$export$6dcc1033b74c9344);
    $parcel$export(module.exports, "InsertStatus", ()=>$e3e45f4a3bdd503a$export$8dcc3cd59f9a0726);
    var $e3e45f4a3bdd503a$export$6dcc1033b74c9344;
    (function(LinkAction) {
        LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
        LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
        LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
        LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
        LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
        LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
        LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    })($e3e45f4a3bdd503a$export$6dcc1033b74c9344 || ($e3e45f4a3bdd503a$export$6dcc1033b74c9344 = {}));
    var $e3e45f4a3bdd503a$export$8dcc3cd59f9a0726;
    (function(InsertStatus) {
        InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
        InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
        InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    })($e3e45f4a3bdd503a$export$8dcc3cd59f9a0726 || ($e3e45f4a3bdd503a$export$8dcc3cd59f9a0726 = {}));
});
parcelRegister("fcZox", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b12799b511c38ec3$var$_react = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b12799b511c38ec3$var$_link = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("1f9bV")));
    var $b12799b511c38ec3$var$_link2 = $b12799b511c38ec3$var$_interopRequireDefault((parcelRequire("7WxSP")));
    function $b12799b511c38ec3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b12799b511c38ec3$var$LinkIcon = (props)=>$b12799b511c38ec3$var$_react.default.createElement($b12799b511c38ec3$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $b12799b511c38ec3$var$_link2.default
        }, props));
    $b12799b511c38ec3$var$LinkIcon.Name = 'LinkIconMigration';
    var $b12799b511c38ec3$var$_default = module.exports.default = $b12799b511c38ec3$var$LinkIcon;
});
parcelRegister("7WxSP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c883bb6fff27f31$var$_react = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5c883bb6fff27f31$var$_link = $5c883bb6fff27f31$var$_interopRequireDefault((parcelRequire("1f9bV")));
    function $5c883bb6fff27f31$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c883bb6fff27f31$var$EditorLinkIcon = (props)=>$5c883bb6fff27f31$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12.654 8.764a.858.858 0 0 1-1.213-1.213l1.214-1.214a3.717 3.717 0 0 1 5.257 0 3.714 3.714 0 0 1 .001 5.258l-1.214 1.214-.804.804a3.72 3.72 0 0 1-5.263.005.858.858 0 0 1 1.214-1.214c.781.782 2.05.78 2.836-.005l.804-.803 1.214-1.214a2 2 0 0 0-.001-2.831 2 2 0 0 0-2.83 0zm-.808 6.472a.858.858 0 0 1 1.213 1.213l-1.214 1.214a3.717 3.717 0 0 1-5.257 0 3.714 3.714 0 0 1-.001-5.258l1.214-1.214.804-.804a3.72 3.72 0 0 1 5.263-.005.858.858 0 0 1-1.214 1.214 2.005 2.005 0 0 0-2.836.005l-.804.803L7.8 13.618a2 2 0 0 0 .001 2.831 2 2 0 0 0 2.83 0z"/></svg>`
        }, props, {
            newIcon: $5c883bb6fff27f31$var$_link.default
        }));
    $5c883bb6fff27f31$var$EditorLinkIcon.displayName = 'EditorLinkIcon';
    var $5c883bb6fff27f31$var$_default = module.exports.default = $5c883bb6fff27f31$var$EditorLinkIcon;
});
parcelRegister("bylXe", function(module, exports) {
    $parcel$export(module.exports, "updateLinkEditorCommand", ()=>$da904c8749ff6e78$export$1f68f6e2d4509ef7);
    $parcel$export(module.exports, "updateLink", ()=>$da904c8749ff6e78$export$468bc07728835ac4);
    $parcel$export(module.exports, "insertLinkWithAnalytics", ()=>$da904c8749ff6e78$export$61f4de3ecc2b935b);
    $parcel$export(module.exports, "removeLink", ()=>$da904c8749ff6e78$export$91d8072017908bea);
    $parcel$export(module.exports, "removeLinkEditorCommand", ()=>$da904c8749ff6e78$export$32e967ed59808fd);
    $parcel$export(module.exports, "editInsertedLink", ()=>$da904c8749ff6e78$export$8eb8ea8f98f386b5);
    $parcel$export(module.exports, "showLinkToolbar", ()=>$da904c8749ff6e78$export$83c364d103479f90);
    $parcel$export(module.exports, "hideLinkToolbar", ()=>$da904c8749ff6e78$export$bd1cd60a9b31da5e);
    $parcel$export(module.exports, "hideLinkToolbarSetMeta", ()=>$da904c8749ff6e78$export$534add8453a7a184);
    $parcel$export(module.exports, "onEscapeCallback", ()=>$da904c8749ff6e78$export$34daa751a305794c);
    $parcel$export(module.exports, "onClickAwayCallback", ()=>$da904c8749ff6e78$export$e72685a867c8a4f2);
    var $gkwXh;
    var $2iyV6;
    var $1ZWXY;
    var $14FOE;
    var $lhLis;
    var $2Y1rH;
    var $31nwk;
    var $dPSMN;
    var $gZGBX;
    var $gHHQB;
    function $da904c8749ff6e78$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
        return ({ tr: tr })=>{
            if (!(0, (0, parcelRequire("lhLis")).isTextAtPos)(pos)({
                tr: tr
            })) return null;
            const $pos = tr.doc.resolve(pos);
            const node = tr.doc.nodeAt(pos);
            const linkMark = tr.doc.type.schema.marks.link;
            const mark = linkMark.isInSet(node.marks);
            const url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(href);
            if (mark && mark.attrs.href === url) return null;
            const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
            tr.removeMark(pos, rightBound, linkMark);
            if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
                ...mark && mark.attrs || {},
                href: url
            }));
            else editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).unlinkPayload)((0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK))(tr);
            if (!isTabPressed) tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                type: (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR
            });
            return tr;
        };
    }
    function $da904c8749ff6e78$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
        return (0, (0, parcelRequire("31nwk")).editorCommandToPMCommand)($da904c8749ff6e78$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
    }
    function $da904c8749ff6e78$export$1f68f6e2d4509ef7(href, text, pos, to) {
        return ({ tr: tr })=>{
            const $pos = tr.doc.resolve(pos);
            const node = tr.doc.nodeAt(pos);
            if (!node) return null;
            const url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(href);
            const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
            const linkMark = tr.doc.type.schema.marks.link;
            const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
            if (!url && text) {
                tr.removeMark(pos, rightBound, linkMark);
                tr.insertText(text, pos, rightBound);
            } else if (!url) return null;
            else {
                tr.insertText(text, pos, rightBound);
                const linkAttrs = {
                    ...mark && mark.attrs || {},
                    href: url
                };
                tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
                tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                    type: (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR
                });
            }
            return tr;
        };
    }
    function $da904c8749ff6e78$export$468bc07728835ac4(href, text, pos, to) {
        return (0, (0, parcelRequire("31nwk")).editorCommandToPMCommand)($da904c8749ff6e78$export$1f68f6e2d4509ef7(href, text, pos, to));
    }
    function $da904c8749ff6e78$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
        return (state, dispatch)=>{
            const link = state.schema.marks.link;
            const { tr: tr } = state;
            if (incomingHref.trim()) {
                const normalizedUrl = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(incomingHref);
                const currentText = (0, (0, parcelRequire("gHHQB")).stateKey).getState(state)?.activeText;
                let markEnd = to;
                const text = displayText || incomingTitle || incomingHref;
                if (!displayText || displayText !== currentText) {
                    tr.insertText(text, from, to);
                    if (!(0, (0, parcelRequire("lhLis")).isTextAtPos)(from)(state)) markEnd = from + text.length + 1;
                    else markEnd = from + text.length;
                }
                tr.addMark(from, markEnd, link.create({
                    href: normalizedUrl
                }));
                tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near(tr.doc.resolve(markEnd)));
                if (!displayText || displayText === incomingHref) {
                    const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                    if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, source, (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED, false, sourceEvent, appearance);
                    else (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                        inputMethod: source,
                        sourceEvent: sourceEvent
                    });
                } else (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
                tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                    type: (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR
                });
                if (dispatch) dispatch(tr);
                return true;
            }
            tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                type: (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return false;
        };
    }
    const $da904c8749ff6e78$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
        if (cardsAvailable && !title && !displayText) return $da904c8749ff6e78$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
        return (0, (0, parcelRequire("14FOE")).withAnalytics)(editorAnalyticsApi, (0, (0, parcelRequire("dPSMN")).getLinkCreationAnalyticsEvent)(inputMethod, href))($da904c8749ff6e78$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
    };
    function $da904c8749ff6e78$export$91d8072017908bea(pos, editorAnalyticsApi) {
        return (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)($da904c8749ff6e78$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK
        });
    }
    function $da904c8749ff6e78$export$32e967ed59808fd(pos, editorAnalyticsApi) {
        return ({ tr: tr })=>{
            $da904c8749ff6e78$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
                tr: tr
            });
            (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(tr.selection, tr, {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).UNLINK
            });
            return tr;
        };
    }
    function $da904c8749ff6e78$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
        return (state, dispatch)=>{
            if (dispatch) {
                const { tr: tr } = state;
                tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                    type: (0, (0, parcelRequire("2Y1rH")).LinkAction).EDIT_INSERTED_TOOLBAR,
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
                });
                editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("2iyV6")).buildEditLinkPayload)((0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK))(tr);
                dispatch(tr);
            }
            return true;
        };
    }
    function $da904c8749ff6e78$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
        return ({ tr: tr })=>{
            const newTr = tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
                type: (0, (0, parcelRequire("2Y1rH")).LinkAction).SHOW_INSERT_TOOLBAR,
                inputMethod: inputMethod
            });
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            })(newTr);
            return newTr;
        };
    }
    function $da904c8749ff6e78$export$bd1cd60a9b31da5e() {
        return function(state, dispatch) {
            if (dispatch) dispatch($da904c8749ff6e78$export$534add8453a7a184(state.tr));
            return true;
        };
    }
    const $da904c8749ff6e78$export$534add8453a7a184 = (tr)=>{
        return tr.setMeta((0, (0, parcelRequire("gHHQB")).stateKey), {
            type: (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR
        });
    };
    const $da904c8749ff6e78$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
            const { tr: tr } = state;
            $da904c8749ff6e78$export$534add8453a7a184(tr);
            cardActions?.hideLinkToolbar?.(tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
    const $da904c8749ff6e78$export$e72685a867c8a4f2 = (state, dispatch)=>{
        if (dispatch) {
            $da904c8749ff6e78$export$bd1cd60a9b31da5e()(state, dispatch);
            return true;
        }
        return false;
    };
});
parcelRegister("gHHQB", function(module, exports) {
    $parcel$export(module.exports, "stateKey", ()=>$42d177908b58055a$export$77b371d6becc8882);
    $parcel$export(module.exports, "plugin", ()=>$42d177908b58055a$export$ca524d3785e2543);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $dtBvX;
    var $2Y1rH;
    var $5KWxh;
    var $dPSMN;
    var $77j9j;
    var $kCV8T;
    var $gZGBX;
    var $etG8M;
    var $VSDnB;
    var $ckc7R;
    const $42d177908b58055a$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
    const $42d177908b58055a$var$isSelectionAroundLink = (state)=>{
        const { $from: $from, $to: $to } = state.selection;
        const node = $from.nodeAfter;
        return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
    };
    const $42d177908b58055a$var$mapTransactionToState = (state, tr)=>{
        if (!state) return undefined;
        else if (state.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_INSERTED_TOOLBAR) {
            const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
            const node = tr.doc.nodeAt(pos);
            if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
                if (node === state.node && pos === state.pos) return state;
                return {
                    ...state,
                    pos: pos,
                    node: node
                };
            }
            return;
        } else if (state.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).INSERT_LINK_TOOLBAR) return {
            ...state,
            from: tr.mapping.map(state.from),
            to: tr.mapping.map(state.to)
        };
        return;
    };
    const $42d177908b58055a$var$toState = (state, action, editorState)=>{
        if (!state) switch(action){
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).SHOW_INSERT_TOOLBAR:
                {
                    const { from: from, to: to } = editorState.selection;
                    if ((0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(from, to)(editorState)) return {
                        type: (0, (0, parcelRequire("2Y1rH")).InsertStatus).INSERT_LINK_TOOLBAR,
                        from: from,
                        to: to
                    };
                    return undefined;
                }
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).SELECTION_CHANGE:
                const link = $42d177908b58055a$var$getActiveLinkMark(editorState);
                if (link) return {
                    ...link,
                    type: (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_LINK_TOOLBAR
                };
                return undefined;
            default:
                return undefined;
        }
        if (state.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).EDIT_INSERTED_TOOLBAR:
                {
                    const link = $42d177908b58055a$var$getActiveLinkMark(editorState);
                    if (link) {
                        if (link.pos === state.pos && link.node === state.node) return {
                            ...state,
                            type: (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_INSERTED_TOOLBAR
                        };
                        return {
                            ...link,
                            type: (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_INSERTED_TOOLBAR
                        };
                    }
                    return undefined;
                }
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).SELECTION_CHANGE:
                const link1 = $42d177908b58055a$var$getActiveLinkMark(editorState);
                if (link1) {
                    if (link1.pos === state.pos && link1.node === state.node) return state;
                    return {
                        ...link1,
                        type: (0, (0, parcelRequire("2Y1rH")).InsertStatus).EDIT_LINK_TOOLBAR
                    };
                }
                return undefined;
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR:
                return undefined;
            default:
                return state;
        }
        if (state.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).SELECTION_CHANGE:
            case (0, (0, parcelRequire("2Y1rH")).LinkAction).HIDE_TOOLBAR:
                return undefined;
            default:
                return state;
        }
        return;
    };
    const $42d177908b58055a$var$getActiveLinkMark = (state)=>{
        const { selection: { $from: $from } } = state;
        if ($42d177908b58055a$var$isSelectionInsideLink(state) || $42d177908b58055a$var$isSelectionAroundLink(state)) {
            const pos = $from.pos - $from.textOffset;
            const node = state.doc.nodeAt(pos);
            return node && node.isText ? {
                node: node,
                pos: pos
            } : undefined;
        }
        return undefined;
    };
    const $42d177908b58055a$var$getActiveText = (selection)=>{
        const currentSlice = selection.content();
        if (currentSlice.size === 0) return;
        if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) return currentSlice.content.firstChild.textContent;
        return;
    };
    const $42d177908b58055a$export$77b371d6becc8882 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('hyperlinkPlugin');
    const $42d177908b58055a$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, pluginInjectionApi, onClickCallback, __livePage)=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            state: {
                init (_, state) {
                    const canInsertLink = (0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                    return {
                        activeText: $42d177908b58055a$var$getActiveText(state.selection),
                        canInsertLink: canInsertLink,
                        timesViewed: 0,
                        activeLinkMark: $42d177908b58055a$var$toState(undefined, (0, (0, parcelRequire("2Y1rH")).LinkAction).SELECTION_CHANGE, state),
                        editorAppearance: editorAppearance
                    };
                },
                apply (tr, pluginState, oldState, newState) {
                    let state = pluginState;
                    const action = tr.getMeta($42d177908b58055a$export$77b371d6becc8882) && tr.getMeta($42d177908b58055a$export$77b371d6becc8882).type;
                    const inputMethod = tr.getMeta($42d177908b58055a$export$77b371d6becc8882) && tr.getMeta($42d177908b58055a$export$77b371d6becc8882).inputMethod;
                    if (tr.docChanged) state = {
                        activeText: state.activeText,
                        canInsertLink: (0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                        timesViewed: state.timesViewed,
                        inputMethod: inputMethod,
                        activeLinkMark: $42d177908b58055a$var$mapTransactionToState(state.activeLinkMark, tr),
                        editorAppearance: editorAppearance
                    };
                    if (action) {
                        const stateForAnalytics = [
                            (0, (0, parcelRequire("2Y1rH")).LinkAction).SHOW_INSERT_TOOLBAR,
                            (0, (0, parcelRequire("2Y1rH")).LinkAction).EDIT_INSERTED_TOOLBAR
                        ].includes(action) ? {
                            timesViewed: ++state.timesViewed,
                            searchSessionId: (0, ($parcel$interopDefault($7Jxgt)))()
                        } : {
                            timesViewed: state.timesViewed,
                            searchSessionId: state.searchSessionId
                        };
                        state = {
                            ...__livePage && (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') && state,
                            activeText: state.activeText,
                            canInsertLink: state.canInsertLink,
                            inputMethod: inputMethod,
                            activeLinkMark: $42d177908b58055a$var$toState(state.activeLinkMark, action, newState),
                            editorAppearance: editorAppearance,
                            ...stateForAnalytics
                        };
                        if ((0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages')) {
                            const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                            if (__livePage && !isViewMode) {
                                if (action === (0, (0, parcelRequire("2Y1rH")).LinkAction).SET_CONFIGURE_DROPDOWN_OPEN) {
                                    const configureDropdownOpen = tr.getMeta($42d177908b58055a$export$77b371d6becc8882).isOpen;
                                    const decorations = configureDropdownOpen ? {} : {
                                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
                                    };
                                    state = {
                                        ...state,
                                        ...decorations,
                                        configureDropdownOpen: configureDropdownOpen
                                    };
                                }
                                if (action === (0, (0, parcelRequire("2Y1rH")).LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS) {
                                    const configureButtonTargetPos = tr.getMeta($42d177908b58055a$export$77b371d6becc8882).pos;
                                    const targetPosHasChanged = pluginState.configureButtonTargetPos !== configureButtonTargetPos;
                                    let decorations = pluginState.decorations;
                                    if (targetPosHasChanged && state.configureDropdownOpen !== true) {
                                        if (configureButtonTargetPos === undefined) decorations = (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                                        else {
                                            const decoration = (0, (0, parcelRequire("etG8M")).Decoration).widget(configureButtonTargetPos, (view)=>{
                                                return (0, (0, parcelRequire("ckc7R")).ButtonWrapper)({
                                                    editorView: view,
                                                    pos: configureButtonTargetPos,
                                                    stateKey: $42d177908b58055a$export$77b371d6becc8882,
                                                    intl: intl,
                                                    onOpenLinkClick: (event)=>{
                                                        if (configureButtonTargetPos === undefined || typeof configureButtonTargetPos !== 'number') return;
                                                        const node = view.state.tr.doc.nodeAt(configureButtonTargetPos);
                                                        if (node === null) return;
                                                        const url = node.marks.find((mark)=>mark.type.name === 'link')?.attrs.href;
                                                        if (!url) return;
                                                        (0, (0, parcelRequire("dtBvX")).handleNavigation)({
                                                            fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                                            onClickCallback: onClickCallback,
                                                            url: url,
                                                            event: event
                                                        });
                                                    }
                                                });
                                            });
                                            decorations = (0, (0, parcelRequire("etG8M")).DecorationSet).create(newState.doc, [
                                                decoration
                                            ]);
                                        }
                                    }
                                    state = {
                                        ...state,
                                        configureButtonTargetPos: configureButtonTargetPos,
                                        decorations: decorations
                                    };
                                }
                            }
                        }
                    }
                    const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                    if (tr.selectionSet && hasPositionChanged) state = {
                        activeText: $42d177908b58055a$var$getActiveText(newState.selection),
                        canInsertLink: (0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                        activeLinkMark: $42d177908b58055a$var$toState(state.activeLinkMark, (0, (0, parcelRequire("2Y1rH")).LinkAction).SELECTION_CHANGE, newState),
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId,
                        inputMethod: inputMethod,
                        editorAppearance: editorAppearance
                    };
                    if (!(0, (0, parcelRequire("77j9j")).shallowEqual)(state, pluginState)) dispatch($42d177908b58055a$export$77b371d6becc8882, state);
                    return state;
                }
            },
            key: $42d177908b58055a$export$77b371d6becc8882,
            props: {
                decorations: (state)=>{
                    if (__livePage && (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages')) {
                        const { decorations: decorations } = $42d177908b58055a$export$77b371d6becc8882.getState(state) ?? {};
                        return decorations;
                    } else return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                },
                handleDOMEvents: {
                    mouseup: (_, event)=>{
                        if ($42d177908b58055a$var$isLinkDirectTarget(event)) {
                            event.preventDefault();
                            return true;
                        }
                        return false;
                    },
                    mousedown: (view, event)=>{
                        if (!event.shiftKey || !$42d177908b58055a$var$isLinkDirectTarget(event)) return false;
                        const { state: state } = view;
                        const { selection: { $anchor: $anchor } } = state;
                        const newPosition = view.posAtCoords({
                            left: event.clientX,
                            top: event.clientY
                        });
                        if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                            const tr = state.tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                            view.dispatch(tr);
                            return true;
                        }
                        return false;
                    }
                },
                ...__livePage && (0, (0, parcelRequire("VSDnB")).fg)('linking_platform_smart_links_in_live_pages') && {
                    markViews: {
                        link: (mark, view, inline)=>{
                            const toDOM = mark.type.spec.toDOM;
                            if (!toDOM) throw new Error('toDom method missing');
                            const dom = (0, (0, parcelRequire("kCV8T")).DOMSerializer).renderSpec(document, toDOM(mark, inline)).dom;
                            if (!(dom instanceof HTMLElement)) throw new Error('Error rendering hyperlink spec to dom');
                            const setTargetElementPos = (val)=>{
                                const tr = view.state.tr;
                                tr.setMeta($42d177908b58055a$export$77b371d6becc8882, {
                                    type: (0, (0, parcelRequire("2Y1rH")).LinkAction).SET_CONFIGURE_BUTTON_TARGET_POS,
                                    pos: val
                                });
                                view.dispatch(tr);
                            };
                            dom.onmouseenter = ()=>{
                                const { activeLinkMark: activeLinkMark, configureButtonTargetPos: configureButtonTargetPos } = $42d177908b58055a$export$77b371d6becc8882.getState(view.state) ?? {};
                                if (!activeLinkMark) {
                                    const nodePos = view.posAtDOM(dom, -1);
                                    if (nodePos !== configureButtonTargetPos) setTargetElementPos(nodePos);
                                }
                            };
                            dom.onmouseleave = ()=>{
                                const { configureButtonTargetPos: configureButtonTargetPos } = $42d177908b58055a$export$77b371d6becc8882.getState(view.state) ?? {};
                                if (configureButtonTargetPos !== undefined) setTargetElementPos(undefined);
                            };
                            dom.onclick = (event)=>{
                                if ($42d177908b58055a$var$isDirectTarget(event, dom)) {
                                    const url = mark.attrs.href;
                                    const reactMouseEvent = event;
                                    (0, (0, parcelRequire("dtBvX")).handleNavigation)({
                                        fireAnalyticsEvent: pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent,
                                        onClickCallback: onClickCallback,
                                        url: url,
                                        event: reactMouseEvent
                                    });
                                }
                            };
                            return {
                                dom: dom
                            };
                        }
                    }
                }
            }
        });
    function $42d177908b58055a$var$isLinkDirectTarget(event) {
        return event?.target instanceof HTMLElement && event.target.tagName === 'A';
    }
    function $42d177908b58055a$var$isDirectTarget(event, element) {
        return event?.target instanceof HTMLElement && event.target === element;
    }
});
parcelRegister("ckc7R", function(module, exports) {
    $parcel$export(module.exports, "ButtonWrapper", ()=>$d65c35e0885c39da$export$d53c836cccbb0d90);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $i5FdW;
    var $2Y1rH;
    var $hH2qd;
    const $d65c35e0885c39da$export$d53c836cccbb0d90 = ({ editorView: editorView, pos: pos, stateKey: stateKey, intl: intl, onOpenLinkClick: onOpenLinkClick })=>{
        const wrapper = document.createElement('span');
        wrapper.style.position = 'relative';
        const nonBreakingCharacter = '\u2060';
        const onDropdownChange = (isOpen)=>{
            editorView.dispatch(editorView.state.tr.setMeta(stateKey, {
                type: (0, (0, parcelRequire("2Y1rH")).LinkAction).SET_CONFIGURE_DROPDOWN_OPEN,
                isOpen: isOpen
            }));
        };
        (0, $7nsd3.render)((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: intl.locale || 'en',
            messages: intl.messages,
            formats: intl.formats
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hH2qd")).OverlayButton), {
            targetElementPos: pos,
            editorView: editorView,
            onDropdownChange: onDropdownChange,
            onOpenLinkClick: onOpenLinkClick
        }), nonBreakingCharacter), wrapper);
        return wrapper;
    };
});
parcelRegister("30OPT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c211d1936d474df9$export$2e2bcd8739ae039);
    var $2Y1rH;
    var $5KWxh;
    var $etG8M;
    var $eB4lt;
    var $gHHQB;
    const $c211d1936d474df9$var$createTextCursor = (pos)=>{
        const node = document.createElement('div');
        node.className = 'ProseMirror-fake-text-cursor';
        return (0, (0, parcelRequire("etG8M")).Decoration).widget(pos, node, {
            key: 'hyperlink-text-cursor'
        });
    };
    const $c211d1936d474df9$var$createTextSelection = (from, to)=>(0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
            class: 'ProseMirror-fake-text-selection'
        });
    const $c211d1936d474df9$var$getInsertLinkToolbarState = (editorState)=>{
        const state = (0, (0, parcelRequire("gHHQB")).stateKey).getState(editorState);
        if (state && state.activeLinkMark) {
            if (state.activeLinkMark.type === (0, (0, parcelRequire("2Y1rH")).InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
        }
        return undefined;
    };
    const $c211d1936d474df9$var$fakeCursorToolbarPlugin = new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
        key: (0, (0, parcelRequire("eB4lt")).fakeCursorForToolbarPluginKey),
        state: {
            init () {
                return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
            },
            apply (tr, pluginState, oldState, newState) {
                const oldInsertToolbarState = $c211d1936d474df9$var$getInsertLinkToolbarState(oldState);
                const insertToolbarState = $c211d1936d474df9$var$getInsertLinkToolbarState(newState);
                if (oldInsertToolbarState && insertToolbarState) {
                    const { from: from, to: to } = insertToolbarState;
                    const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                    const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                    if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
                }
                if (insertToolbarState) {
                    const { from: from, to: to } = insertToolbarState;
                    return (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, [
                        from === to ? $c211d1936d474df9$var$createTextCursor(from) : $c211d1936d474df9$var$createTextSelection(from, to)
                    ]);
                }
                return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
            }
        },
        props: {
            decorations (state) {
                return (0, (0, parcelRequire("eB4lt")).fakeCursorForToolbarPluginKey).getState(state);
            }
        }
    });
    var $c211d1936d474df9$export$2e2bcd8739ae039 = $c211d1936d474df9$var$fakeCursorToolbarPlugin;
});
parcelRegister("eB4lt", function(module, exports) {
    $parcel$export(module.exports, "fakeCursorForToolbarPluginKey", ()=>$bc509495f278987a$export$38c00ed3b117ab26);
    var $gZGBX;
    const $bc509495f278987a$export$38c00ed3b117ab26 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('fakeCursorToolbarPlugin');
});
parcelRegister("MxEYb", function(module, exports) {
    $parcel$export(module.exports, "createInputRulePlugin", ()=>$17eb71eb246aa49f$export$dc83f374e2af640d);
    var $gkwXh;
    var $1ZWXY;
    var $5KWxh;
    var $2Abpa;
    var $dPSMN;
    var $gOwky;
    var $inLhu;
    var $k023r;
    function $17eb71eb246aa49f$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
        return (0, (0, parcelRequire("2Abpa")).createRule)(regexp, (state, match, start, end)=>{
            const { schema: schema } = state;
            if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
            const link = match;
            let url;
            if (link.url === undefined) return null;
            if (!(0, (0, parcelRequire("gOwky")).shouldAutoLinkifyMatch)(link)) return null;
            url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(link.url);
            if (url === '') return null;
            const markType = schema.mark('link', {
                href: url
            });
            const nodeBefore = state.selection.$from.nodeBefore;
            if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
            const filepaths = (0, (0, parcelRequire("dPSMN")).findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - link.text.length));
            if ((0, (0, parcelRequire("dPSMN")).isLinkInMatches)(start, filepaths)) {
                const tr = state.tr;
                return tr;
            }
            const from = start;
            const to = Math.min(start + link.text.length, state.doc.content.size);
            const tr = state.tr.addMark(from, to, markType);
            if (to === end) tr.insertText(' ');
            (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).AUTO_DETECT
            });
            const skipAnalytics = (0, (0, parcelRequire("k023r")).toolbarKey).getState(state)?.skipAnalytics ?? false;
            if (skipAnalytics) return tr;
            editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("dPSMN")).getLinkCreationAnalyticsEvent)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).AUTO_DETECT, url))(tr);
            return tr;
        });
    }
    function $17eb71eb246aa49f$export$dc83f374e2af640d(schema, editorAnalyticsApi) {
        if (!schema.marks.link) return;
        const urlWithASpaceRule = $17eb71eb246aa49f$export$8d0400fab1d2ed11((0, (0, parcelRequire("dPSMN")).LinkMatcher).create(), editorAnalyticsApi);
        const markdownLinkRule = (0, (0, parcelRequire("2Abpa")).createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
            const { schema: schema } = state;
            const [, prefix, linkText, linkUrl] = match;
            const url = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(linkUrl).trim();
            const markType = schema.mark('link', {
                href: url
            });
            const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
                markType
            ]));
            (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING
            });
            const skipAnalytics = (0, (0, parcelRequire("k023r")).toolbarKey).getState(state)?.skipAnalytics ?? false;
            if (skipAnalytics) return tr;
            editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("dPSMN")).getLinkCreationAnalyticsEvent)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FORMATTING, url))(tr);
            return tr;
        });
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)((0, (0, parcelRequire("inLhu")).createPlugin)('hyperlink', [
            urlWithASpaceRule,
            markdownLinkRule
        ]));
    }
    var $17eb71eb246aa49f$export$2e2bcd8739ae039 = $17eb71eb246aa49f$export$dc83f374e2af640d;
});
parcelRegister("k023r", function(module, exports) {
    $parcel$export(module.exports, "toolbarKey", ()=>$689e2a4840f1847f$export$6cbac557ea601778);
    $parcel$export(module.exports, "toolbarButtonsPlugin", ()=>$689e2a4840f1847f$export$faf11097578346af);
    var $5KWxh;
    var $gZGBX;
    const $689e2a4840f1847f$export$6cbac557ea601778 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('hyperlinkToolbarItems');
    const $689e2a4840f1847f$export$faf11097578346af = (initialState)=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $689e2a4840f1847f$export$6cbac557ea601778,
            state: {
                init: (_, __)=>{
                    return initialState;
                },
                apply: (tr, pluginState)=>{
                    const metaState = tr.getMeta($689e2a4840f1847f$export$6cbac557ea601778);
                    if (metaState) return metaState;
                    return pluginState;
                }
            }
        });
    };
});
parcelRegister("3F7Mv", function(module, exports) {
    $parcel$export(module.exports, "createKeymapPlugin", ()=>$92f3dd553f1620e8$export$1d7b13ce0747fbd);
    var $iZOJ9;
    var $gkwXh;
    var $1ZWXY;
    var $e9qoo;
    var $dPSMN;
    var $gOwky;
    var $vWFRY;
    var $bylXe;
    var $gHHQB;
    var $k023r;
    function $92f3dd553f1620e8$export$1d7b13ce0747fbd(editorAnalyticsApi) {
        const list = {};
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithEditorCommand)((0, (0, parcelRequire("e9qoo")).addLink).common, (0, (0, parcelRequire("bylXe")).showLinkToolbar)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).enter).common, $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).insertNewLine).common, $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).escape).common, (state, dispatch, view)=>{
            const hyperlinkPlugin = (0, (0, parcelRequire("gHHQB")).stateKey).getState(state);
            if (hyperlinkPlugin.activeLinkMark) {
                (0, (0, parcelRequire("bylXe")).hideLinkToolbar)()(state, dispatch);
                if (view) view.focus();
                return false;
            }
            return false;
        }, list);
        return (0, (0, parcelRequire("vWFRY")).keymap)(list);
    }
    const $92f3dd553f1620e8$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
        return function(state, dispatch) {
            const skipAnalytics = (0, (0, parcelRequire("k023r")).toolbarKey).getState(state)?.skipAnalytics ?? false;
            const nodeBefore = state.selection.$from.nodeBefore;
            if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
            const words = nodeBefore.text.split(' ');
            const lastWord = words[words.length - 1];
            const match = (0, (0, parcelRequire("iZOJ9")).getLinkMatch)(lastWord);
            if (match) {
                if (!(0, (0, parcelRequire("gOwky")).shouldAutoLinkifyMatch)(match)) return false;
                const hyperlinkedText = match.raw;
                const start = state.selection.$from.pos - hyperlinkedText.length;
                const end = state.selection.$from.pos;
                if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
                const url = match.url;
                const markType = state.schema.mark('link', {
                    href: url
                });
                const filepaths = (0, (0, parcelRequire("dPSMN")).findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
                if ((0, (0, parcelRequire("dPSMN")).isLinkInMatches)(start, filepaths)) return false;
                const tr = state.tr.addMark(start, end, markType);
                if (dispatch) {
                    (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(state.selection, tr, {
                        inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).AUTO_DETECT
                    });
                    if (skipAnalytics) dispatch(tr);
                    else {
                        editorAnalyticsApi?.attachAnalyticsEvent((0, (0, parcelRequire("dPSMN")).getLinkCreationAnalyticsEvent)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).AUTO_DETECT, url))(tr);
                        dispatch(tr);
                    }
                }
            }
            return false;
        };
    };
    var $92f3dd553f1620e8$export$2e2bcd8739ae039 = $92f3dd553f1620e8$export$1d7b13ce0747fbd;
});
parcelRegister("qbNm3", function(module, exports) {
    $parcel$export(module.exports, "getToolbarConfig", ()=>$1bc3e94d9c878478$export$86ce8f8241c20a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZOJ9;
    var $gkwXh;
    var $2iyV6;
    var $1ZWXY;
    var $awTmI;
    var $e9EHa;
    var $gSYO9;
    var $jDuvE;
    var $dPSMN;
    var $90mMF;
    var $ggICg;
    var $jdB85;
    var $17Ngn;
    var $VSDnB;
    var $bylXe;
    var $gHHQB;
    var $k023r;
    function $1bc3e94d9c878478$var$isEditLink(linkMark) {
        return linkMark.pos !== undefined;
    }
    const $1bc3e94d9c878478$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
    };
    const $1bc3e94d9c878478$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
            $1bc3e94d9c878478$var$dispatchAnalytics(dispatch, state, (0, (0, parcelRequire("2iyV6")).buildVisitedLinkPayload), editorAnalyticsApi);
            return true;
        };
    function $1bc3e94d9c878478$var$getLinkText(activeLinkMark, state) {
        if (!activeLinkMark.node) return undefined;
        const textToUrl = (0, (0, parcelRequire("dPSMN")).normalizeUrl)(activeLinkMark.node.text);
        const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
        const linkHref = linkMark && linkMark.attrs.href;
        if (textToUrl === linkHref) return undefined;
        return activeLinkMark.node.text;
    }
    function $1bc3e94d9c878478$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
        const { hyperlinkState: hyperlinkState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(pluginInjectionApi, [
            'hyperlink'
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e9EHa")).HyperlinkAddToolbar), {
            linkPickerOptions: linkPickerOptions,
            onSubmit: onSubmit,
            displayText: displayText,
            displayUrl: displayUrl,
            providerFactory: providerFactory,
            view: view,
            onCancel: onCancel,
            invokeMethod: invokeMethod,
            lpLinkPicker: lpLinkPicker,
            onClose: onClose,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback,
            timesViewed: hyperlinkState.timesViewed,
            inputMethod: hyperlinkState.inputMethod,
            searchSessionId: hyperlinkState.searchSessionId
        });
    }
    const $1bc3e94d9c878478$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
            if (options.disableFloatingToolbar) return;
            const { formatMessage: formatMessage } = intl;
            const linkState = (0, (0, parcelRequire("gHHQB")).stateKey).getState(state);
            const editorCardActions = pluginInjectionApi?.card?.actions;
            const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
            const lpLinkPicker = options.lpLinkPicker ?? true;
            if (linkState && linkState.activeLinkMark) {
                const { activeLinkMark: activeLinkMark } = linkState;
                const hyperLinkToolbar = {
                    title: 'Hyperlink floating controls',
                    nodeType: [
                        state.schema.nodes.text,
                        state.schema.nodes.paragraph,
                        state.schema.nodes.heading,
                        state.schema.nodes.taskItem,
                        state.schema.nodes.decisionItem,
                        state.schema.nodes.caption
                    ].filter((nodeType)=>!!nodeType),
                    align: 'left',
                    className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : ''
                };
                switch(activeLinkMark.type){
                    case 'EDIT':
                        {
                            const { pos: pos, node: node } = activeLinkMark;
                            const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            const link = linkMark[0] && linkMark[0].attrs.href;
                            const isValidUrl = (0, (0, parcelRequire("iZOJ9")).isSafeUrl)(link);
                            const labelOpenLink = formatMessage(isValidUrl ? (0, (0, parcelRequire("gSYO9")).linkMessages).openLink : (0, (0, parcelRequire("jDuvE")).linkToolbarMessages).unableToOpenLink);
                            const labelUnlink = formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).unlink);
                            const editLink = formatMessage((0, (0, parcelRequire("jDuvE")).linkToolbarMessages).editLink);
                            let metadata = {
                                url: link,
                                title: ''
                            };
                            if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                            const cardActions = pluginInjectionApi?.card?.actions;
                            const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, (0, parcelRequire("bylXe")).editInsertedLink)(editorAnalyticsApi), metadata) ?? [
                                {
                                    id: 'editor.link.edit',
                                    testId: 'editor.link.edit',
                                    type: 'button',
                                    onClick: (0, (0, parcelRequire("bylXe")).editInsertedLink)(editorAnalyticsApi),
                                    title: editLink,
                                    showTitle: true,
                                    metadata: metadata
                                },
                                {
                                    type: 'separator'
                                }
                            ];
                            const items = [
                                ...startingToolbarItems,
                                {
                                    id: 'editor.link.openLink',
                                    testId: 'editor.link.openLink',
                                    type: 'button',
                                    disabled: !isValidUrl,
                                    target: '_blank',
                                    href: isValidUrl ? link : undefined,
                                    onClick: $1bc3e94d9c878478$var$visitHyperlink(editorAnalyticsApi),
                                    title: labelOpenLink,
                                    icon: (0, ($parcel$interopDefault((0, parcelRequire("ggICg"))))),
                                    iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))),
                                    className: 'hyperlink-open-link',
                                    metadata: metadata,
                                    tabIndex: null
                                },
                                {
                                    type: 'separator'
                                },
                                {
                                    id: 'editor.link.unlink',
                                    testId: 'editor.link.unlink',
                                    type: 'button',
                                    onClick: (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((0, (0, parcelRequire("bylXe")).removeLink)(pos, editorAnalyticsApi), {
                                        inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).FLOATING_TB
                                    }),
                                    title: labelUnlink,
                                    icon: (0, ($parcel$interopDefault((0, parcelRequire("90mMF"))))),
                                    iconFallback: (0, ($parcel$interopDefault((0, parcelRequire("jdB85"))))),
                                    tabIndex: null
                                },
                                {
                                    type: 'separator'
                                },
                                {
                                    type: 'copy-button',
                                    supportsViewMode: !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_remove_copy_button_from_view_mode'),
                                    items: [
                                        {
                                            state: state,
                                            formatMessage: formatMessage,
                                            markType: state.schema.marks.link
                                        }
                                    ]
                                },
                                ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                            ];
                            return {
                                ...hyperLinkToolbar,
                                height: 32,
                                width: 250,
                                items: items,
                                scrollable: true
                            };
                        }
                    case 'EDIT_INSERTED':
                    case 'INSERT':
                        {
                            let link;
                            if ($1bc3e94d9c878478$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                                const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                                link = linkMark[0] && linkMark[0].attrs.href;
                            }
                            const displayText = $1bc3e94d9c878478$var$isEditLink(activeLinkMark) ? $1bc3e94d9c878478$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                            const popupHeight = lpLinkPicker ? (0, $f96f1f7af2f8d3ca$export$c635b83728f81640) : (0, $f96f1f7af2f8d3ca$export$c04a5ad015d45447);
                            return {
                                ...hyperLinkToolbar,
                                preventPopupOverflow: true,
                                height: popupHeight,
                                width: (0, $f96f1f7af2f8d3ca$export$a62aa932daf22ffe),
                                items: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        disableArrowNavigation: true,
                                        render: (view, idx)=>{
                                            if (!view) return null;
                                            return (0, ($parcel$interopDefault($5uXOq))).createElement($1bc3e94d9c878478$export$a46cebff622c3cae, {
                                                pluginInjectionApi: pluginInjectionApi,
                                                view: view,
                                                key: idx,
                                                linkPickerOptions: options?.linkPicker,
                                                lpLinkPicker: lpLinkPicker,
                                                displayUrl: link,
                                                displayText: displayText || '',
                                                providerFactory: providerFactory,
                                                onCancel: ()=>view.focus(),
                                                onEscapeCallback: (0, (0, parcelRequire("bylXe")).onEscapeCallback)(editorCardActions),
                                                onClickAwayCallback: (0, (0, parcelRequire("bylXe")).onClickAwayCallback),
                                                onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                    const isEdit = $1bc3e94d9c878478$var$isEditLink(activeLinkMark);
                                                    const action = isEdit ? (0, (0, parcelRequire("gkwXh")).ACTION).UPDATED : (0, (0, parcelRequire("gkwXh")).ACTION).INSERTED;
                                                    const skipAnalytics = (0, (0, parcelRequire("k023r")).toolbarKey).getState(state)?.skipAnalytics ?? false;
                                                    const command = isEdit ? (0, (0, parcelRequire("1ZWXY")).commandWithMetadata)((0, (0, parcelRequire("bylXe")).updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                        action: action,
                                                        inputMethod: inputMethod,
                                                        sourceEvent: analytic
                                                    }) : (0, (0, parcelRequire("bylXe")).insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                    command(view.state, view.dispatch, view);
                                                    view.focus();
                                                }
                                            });
                                        }
                                    }
                                ]
                            };
                        }
                }
            }
            return;
        };
});
parcelRegister("ewWTS", function(module, exports) {
    $parcel$export(module.exports, "pastePlugin", ()=>(parcelRequire("294fK")).pastePlugin);
    var $294fK;
});
parcelRegister("294fK", function(module, exports) {
    $parcel$export(module.exports, "pastePlugin", ()=>$d9b45bbfdaf8db26$export$2d7f4bd9c1268cd7);
    var $aehLH;
    var $2NfYE;
    var $6eO8M;
    const $d9b45bbfdaf8db26$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
        const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage } = config ?? {};
        const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        return {
            name: 'paste',
            pmPlugins () {
                return [
                    {
                        name: 'paste',
                        plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>(0, (0, parcelRequire("aehLH")).createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, cardOptions, sanitizePrivateContent, providerFactory)
                    },
                    {
                        name: 'moveAnalyticsPlugin',
                        plugin: ({ dispatch: dispatch })=>{
                            return isFullPage ? (0, (0, parcelRequire("2NfYE")).createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                        }
                    }
                ];
            },
            getSharedState: (editorState)=>{
                if (!editorState) return {
                    lastContentPasted: null
                };
                const pluginState = (0, (0, parcelRequire("6eO8M")).pluginKey).getState(editorState);
                return {
                    lastContentPasted: pluginState.lastContentPasted
                };
            }
        };
    };
});
parcelRegister("aehLH", function(module, exports) {
    $parcel$export(module.exports, "isInsideBlockQuote", ()=>$d10e66844f67b307$export$eedfdbc6a6bc1442);
    $parcel$export(module.exports, "createPlugin", ()=>$d10e66844f67b307$export$ae829ec7b2625219);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $gkwXh;
    var $2yLEW;
    var $1ZWXY;
    var $kxM7f;
    var $04ZRC;
    var $ekofw;
    var $1M84d;
    var $ap7h6;
    var $5KWxh;
    var $iYg8V;
    var $8Amfw;
    var $hZCXS;
    var $h03xs;
    var $594Yf;
    var $dPSMN;
    var $7vpuQ;
    var $38KaN;
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $hKZR1;
    var $VSDnB;
    var $eOaHF;
    var $hsidY;
    var $4wmiA;
    var $krjcI;
    var $h8zVR;
    var $lKATW;
    var $hJPkr;
    var $jI1GO;
    var $6eO8M;
    const $d10e66844f67b307$export$eedfdbc6a6bc1442 = (state)=>{
        const { blockquote: blockquote } = state.schema.nodes;
        return (0, $5r0mK.hasParentNodeOfType)(blockquote)(state.selection);
    };
    const $d10e66844f67b307$var$PASTE = 'Editor Paste Plugin Paste Duration';
    function $d10e66844f67b307$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, cardOptions, sanitizePrivateContent, providerFactory) {
        const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
        const atlassianMarkDownParser = new (0, (0, parcelRequire("38KaN")).MarkdownTransformer)(schema, (0, (0, parcelRequire("1M84d")).md));
        function getMarkdownSlice(text, openStart, openEnd) {
            let textInput = escapeBackslashExceptCodeblock(text);
            const doc = atlassianMarkDownParser.parse((0, (0, parcelRequire("h8zVR")).escapeLinks)(textInput));
            if (doc && doc.content) return new (0, (0, parcelRequire("kCV8T")).Slice)(doc.content, openStart, openEnd);
            return;
        }
        function escapeBackslashExceptCodeblock(textInput) {
            const codeToken = '```';
            if (!textInput.includes(codeToken)) return textInput.replace(/\\/g, '\\\\');
            let isInsideCodeblock = false;
            let textSplitByNewLine = textInput.split('\n');
            textSplitByNewLine = textSplitByNewLine.map((text)=>{
                if (text === codeToken) isInsideCodeblock = !isInsideCodeblock;
                else if (text.startsWith(codeToken) && isInsideCodeblock === false) isInsideCodeblock = true;
                if (!isInsideCodeblock) text = text.replace(/\\/g, '\\\\');
                return text;
            });
            textInput = textSplitByNewLine.join('\n');
            return textInput;
        }
        let extensionAutoConverter;
        async function setExtensionAutoConverter(name, extensionProviderPromise) {
            if (name !== 'extensionProvider' || !extensionProviderPromise) return;
            try {
                extensionAutoConverter = await (0, (0, parcelRequire("04ZRC")).getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
            } catch (e) {
                console.error(e);
            }
        }
        if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
        let mostRecentPasteEvent;
        let pastedFromBitBucket = false;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("6eO8M")).pluginKey),
            state: (0, (0, parcelRequire("6eO8M")).createPluginState)(dispatch, {
                pastedMacroPositions: {},
                lastContentPasted: null
            }),
            props: {
                clipboardTextSerializer: (0, parcelRequire("jI1GO")).clipboardTextSerializer,
                handleDOMEvents: {
                    paste: (view, event)=>{
                        mostRecentPasteEvent = event;
                        return false;
                    }
                },
                handlePaste (view, rawEvent, slice) {
                    const event = rawEvent;
                    if (!event.clipboardData) return false;
                    let text = event.clipboardData.getData('text/plain');
                    const html = event.clipboardData.getData('text/html');
                    const uriList = event.clipboardData.getData('text/uri-list');
                    if (uriList && !text && !html) {
                        text = uriList;
                        slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(text)), 1, 1);
                    }
                    if (text?.includes('\r')) text = text.replace(/\r/g, '');
                    const isPastedFile = (0, (0, parcelRequire("ekofw")).isPastedFile)(event);
                    const isPlainText = text && !html;
                    const isRichText = !!html;
                    if (isPastedFile) {
                        if (!html) return true;
                        if ((0, (0, parcelRequire("h8zVR")).htmlContainsSingleFile)(html) && !$d10e66844f67b307$export$eedfdbc6a6bc1442(view.state)) return true;
                        event.stopPropagation();
                    }
                    const { state: state } = view;
                    const content = (0, (0, parcelRequire("hJPkr")).getContentNodeTypes)(slice.content);
                    const pasteId = (0, ($parcel$interopDefault($7Jxgt)))();
                    const measureName = `${$d10e66844f67b307$var$PASTE}_${pasteId}`;
                    (0, (0, parcelRequire("ap7h6")).measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                        const payload = (0, (0, parcelRequire("hJPkr")).createPasteMeasurePayload)({
                            view: view,
                            duration: duration,
                            content: content,
                            distortedDuration: distortedDuration
                        });
                        if (payload) dispatchAnalyticsEvent(payload);
                    });
                    const dispatch = (tr)=>{
                        const { placeholder: placeholder } = state.schema.nodes;
                        const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                        const isPastingOverLayoutColumns = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                        const isPastingTable = tr.steps.some((step)=>{
                            const slice = (0, (0, parcelRequire("594Yf")).extractSliceFromStep)(step);
                            let tableExists = false;
                            slice?.content?.forEach((node)=>{
                                if (node.type === state.schema.nodes.table) tableExists = true;
                            });
                            return tableExists;
                        });
                        if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                        const isDocChanged = tr.docChanged;
                        (0, (0, parcelRequire("1ZWXY")).addLinkMetadata)(view.state.selection, tr, {
                            action: isPlainText ? (0, (0, parcelRequire("gkwXh")).ACTION).PASTED_AS_PLAIN : (0, (0, parcelRequire("gkwXh")).ACTION).PASTED,
                            inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD
                        });
                        if (isDocChanged) {
                            const pasteStartPos = Math.min(state.selection.anchor, state.selection.head);
                            const pasteEndPos = tr.selection.to;
                            const contentPasted = {
                                pasteStartPos: pasteStartPos,
                                pasteEndPos: pasteEndPos,
                                text: text,
                                isShiftPressed: Boolean(view.shiftKey || view.input?.shiftKey),
                                isPlainText: Boolean(isPlainText),
                                pastedSlice: tr.doc.slice(pasteStartPos, pasteEndPos),
                                pastedAt: Date.now(),
                                pasteSource: (0, (0, parcelRequire("h8zVR")).getPasteSource)(event)
                            };
                            tr.setMeta((0, (0, parcelRequire("6eO8M")).pluginKey), {
                                type: (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).ON_PASTE,
                                contentPasted: contentPasted
                            });
                        }
                        view.dispatch(tr);
                    };
                    slice = (0, (0, parcelRequire("4wmiA")).handleParagraphBlockMarks)(state, slice);
                    const plainTextPasteSlice = (0, (0, parcelRequire("dPSMN")).linkifyContent)(state.schema)(slice);
                    if ((0, (0, parcelRequire("hJPkr")).handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                    slice = (0, (0, parcelRequire("krjcI")).transformSliceForMedia)(slice, schema)(state.selection);
                    let markdownSlice;
                    if (isPlainText) {
                        markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                        markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                        if (markdownSlice) {
                            if ((0, (0, parcelRequire("hJPkr")).handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, (0, parcelRequire("2yLEW")).PasteTypes).markdown)(state, dispatch)) return true;
                            if ((0, (0, parcelRequire("4wmiA")).handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                                (0, (0, parcelRequire("hJPkr")).sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                    type: (0, (0, parcelRequire("2yLEW")).PasteTypes).markdown
                                });
                                return true;
                            }
                        }
                    }
                    slice = (0, (0, parcelRequire("h8zVR")).transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                    const selectionDepth = state.selection.$head.depth;
                    const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                    const selectionParentType = selectionParentNode?.type;
                    const edgeCaseNodeTypes = [
                        schema.nodes?.panel,
                        schema.nodes?.taskList,
                        schema.nodes?.decisionList
                    ];
                    if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) slice.openStart = 1;
                    if ((0, (0, parcelRequire("hJPkr")).handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, (0, parcelRequire("2yLEW")).PasteTypes).plain : (0, (0, parcelRequire("2yLEW")).PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    if ((0, (0, parcelRequire("hJPkr")).handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                    if ((0, (0, parcelRequire("hJPkr")).handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, (0, parcelRequire("2yLEW")).PasteTypes).binary : (0, (0, parcelRequire("2yLEW")).PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                    if ((0, (0, parcelRequire("hJPkr")).handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    let isNestedMarkdownTable = false;
                    const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                    isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, (0, parcelRequire("hJPkr")).getContentNodeTypes)(markdownSlice.content).includes(schema.nodes.table?.name));
                    slice = isNestedMarkdownTable ? markdownSlice : slice;
                    if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                        if ((0, (0, parcelRequire("hJPkr")).handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, (0, parcelRequire("2yLEW")).PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                        return (0, (0, parcelRequire("hJPkr")).handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                    }
                    if (isRichText && $d10e66844f67b307$export$eedfdbc6a6bc1442(state)) {
                        const { blockquote: blockquote } = schema.nodes;
                        const children = [];
                        (0, (0, parcelRequire("7vpuQ")).mapChildren)(slice.content, (node)=>{
                            if (node.type === blockquote && !(0, $5r0mK.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                            else children.push(node);
                        });
                        slice = new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children), slice.openStart, slice.openEnd);
                    }
                    if (isRichText || isNestedMarkdownTable) {
                        slice = (0, (0, parcelRequire("dPSMN")).linkifyContent)(state.schema)(slice);
                        if ((0, (0, parcelRequire("hJPkr")).handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, (0, parcelRequire("2yLEW")).PasteTypes).richText)(state, dispatch)) return true;
                        if ((0, (0, parcelRequire("4wmiA")).handleMacroAutoConvert)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            (0, (0, parcelRequire("hJPkr")).sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText
                            });
                            return true;
                        }
                        if ((0, (0, parcelRequire("hKZR1")).handlePaste)(view, null, slice)) {
                            (0, (0, parcelRequire("hJPkr")).sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText
                            });
                            return true;
                        }
                        if ((0, (0, parcelRequire("4wmiA")).handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                        if (slice.content.size && (0, (0, parcelRequire("h03xs")).containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                        if ((0, (0, parcelRequire("hJPkr")).handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, (0, parcelRequire("2yLEW")).PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                        if (selectionParentType !== state.schema.nodes.doc) {
                            const sliceCopy = (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(state.schema, slice.toJSON() || {});
                            sliceCopy.content.descendants((node)=>{
                                node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                                return false;
                            });
                            slice = sliceCopy;
                        }
                        const isNestingExpandsSupported = pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestedExpandInExpandEx || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_nest_nested_expand_in_expand_jira');
                        if ((0, (0, parcelRequire("hJPkr")).handleExpandWithAnalytics)(editorAnalyticsAPI, isNestingExpandsSupported)(view, event, slice)(state, dispatch)) return true;
                        if (!(0, (0, parcelRequire("kxM7f")).insideTable)(state)) slice = (0, (0, parcelRequire("8Amfw")).transformSliceNestedExpandToExpand)(slice, state.schema);
                        if ((0, (0, parcelRequire("hJPkr")).handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, (0, parcelRequire("2yLEW")).PasteTypes).richText)(state, dispatch)) return true;
                        if ((0, (0, parcelRequire("hJPkr")).handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                        if ((0, (0, parcelRequire("hJPkr")).handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                        const isNestingMediaOrCodeblockSupported = pluginInjectionApi?.featureFlags?.sharedState.currentState()?.nestMediaAndCodeblockInQuote || (0, (0, parcelRequire("VSDnB")).fg)('editor_nest_media_and_codeblock_in_quotes_jira');
                        return (0, (0, parcelRequire("hJPkr")).handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi, isNestingMediaOrCodeblockSupported)(state, dispatch);
                    }
                    return false;
                },
                transformPasted (slice) {
                    if (sanitizePrivateContent) slice = (0, (0, parcelRequire("4wmiA")).handleMention)(slice, schema);
                    if (pastedFromBitBucket) slice = (0, (0, parcelRequire("iYg8V")).transformSliceToJoinAdjacentCodeBlocks)(slice);
                    slice = (0, (0, parcelRequire("iYg8V")).transformSingleLineCodeBlockToCodeMark)(slice, schema);
                    slice = (0, (0, parcelRequire("krjcI")).transformSliceToCorrectMediaWrapper)(slice, schema);
                    slice = (0, (0, parcelRequire("krjcI")).transformSliceToMediaSingleWithNewExperience)(slice, schema);
                    slice = (0, (0, parcelRequire("hZCXS")).transformSliceToDecisionList)(slice, schema);
                    slice = (0, (0, parcelRequire("hsidY")).splitParagraphs)(slice, schema);
                    slice = (0, (0, parcelRequire("hsidY")).upgradeTextToLists)(slice, schema);
                    if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, (0, parcelRequire("kCV8T")).Slice)(slice.content, 0, 0);
                    return slice;
                },
                transformPastedHTML (html) {
                    if (html.indexOf('id="docs-internal-guid-') >= 0) {
                        html = html.replace(/white-space:pre/g, '');
                        html = html.replace(/white-space:pre-wrap/g, '');
                    }
                    if (mostRecentPasteEvent && (0, (0, parcelRequire("lKATW")).isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, (0, parcelRequire("lKATW")).htmlHasIncompleteTable)(html)) {
                        const completeTableHtml = (0, (0, parcelRequire("lKATW")).tryRebuildCompleteTableHtml)(html);
                        if (completeTableHtml) html = completeTableHtml;
                    }
                    if (!(0, (0, parcelRequire("h8zVR")).isPastedFromWord)(html) && !(0, (0, parcelRequire("h8zVR")).isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, (0, parcelRequire("krjcI")).unwrapNestedMediaElements)(html);
                    if ((0, (0, parcelRequire("h8zVR")).htmlHasInvalidLinkTags)(html)) html = (0, (0, parcelRequire("h8zVR")).removeDuplicateInvalidLinks)(html);
                    pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                    mostRecentPasteEvent = null;
                    return html;
                }
            }
        });
    }
});
parcelRegister("2yLEW", function(module, exports) {
    $parcel$export(module.exports, "PasteTypes", ()=>$18ad867e0f3ed9e5$export$2ba12a8680458b1e);
    $parcel$export(module.exports, "PasteContents", ()=>$18ad867e0f3ed9e5$export$a82556f999b47168);
    const $18ad867e0f3ed9e5$export$2ba12a8680458b1e = {
        richText: 'richText',
        plain: 'plain',
        markdown: 'markdown',
        binary: 'binary'
    };
    const $18ad867e0f3ed9e5$export$602c33ed77663fbf = {
        fabricEditor: 'fabric-editor',
        applePages: 'apple-pages',
        googleSpreadsheets: 'google-spreadsheets',
        googleDocs: 'google-docs',
        microsoftExcel: 'microsoft-excel',
        microsoftWord: 'microsoft-word',
        dropboxPaper: 'dropbox-paper',
        uncategorized: 'uncategorized'
    };
    const $18ad867e0f3ed9e5$export$a82556f999b47168 = {
        text: 'text',
        url: 'url',
        code: 'code',
        mediaSingle: 'mediaSingle',
        mediaCard: 'mediaCard',
        mediaGroup: 'mediaGroup',
        tableCells: 'tableCells',
        table: 'table',
        expand: 'expand',
        nestedExpand: 'nestedExpand',
        mixed: 'mixed',
        blockquote: 'blockquote',
        blockCard: 'blockCard',
        bodiedExtension: 'bodiedExtension',
        multiBodiedExtension: 'multiBodiedExtension',
        bulletList: 'bulletList',
        codeBlock: 'codeBlock',
        decisionList: 'decisionList',
        decisionItem: 'decisionItem',
        extension: 'extension',
        heading: 'heading',
        layoutSection: 'layoutSection',
        orderedList: 'orderedList',
        panel: 'panel',
        rule: 'rule',
        tableHeader: 'tableHeader',
        tableRow: 'tableRow',
        taskItem: 'taskItem',
        uncategorized: 'uncategorized'
    };
});
parcelRegister("ekofw", function(module, exports) {
    $parcel$export(module.exports, "isPastedFile", ()=>$569ae1fc879ec97d$export$30c8e5e50a78a591);
    function $569ae1fc879ec97d$export$e20225b4cda674a8(type, item) {
        const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
        return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
    }
    function $569ae1fc879ec97d$export$30c8e5e50a78a591(rawEvent) {
        const { clipboardData: clipboardData } = rawEvent;
        if (!clipboardData) return false;
        return $569ae1fc879ec97d$export$e20225b4cda674a8(clipboardData.types, 'Files');
    }
});
parcelRegister("iYg8V", function(module, exports) {
    $parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", ()=>$99fc3db05934d60c$export$5a682e48ed34e262);
    $parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", ()=>$99fc3db05934d60c$export$d1dc8019f50dded8);
    $parcel$export(module.exports, "findCodeBlock", ()=>$99fc3db05934d60c$export$8435d1ef36841a34);
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $7vpuQ;
    function $99fc3db05934d60c$var$joinCodeBlocks(left, right) {
        const textContext = `${left.textContent}\n${right.textContent}`;
        return left.type.create(left.attrs, left.type.schema.text(textContext));
    }
    function $99fc3db05934d60c$var$mergeAdjacentCodeBlocks(fragment) {
        const children = [];
        fragment.forEach((maybeCodeBlock)=>{
            if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
                const peekAtPrevious = children[children.length - 1];
                if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) return children.push($99fc3db05934d60c$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
            }
            return children.push(maybeCodeBlock);
        });
        return (0, (0, parcelRequire("kCV8T")).Fragment).from(children);
    }
    function $99fc3db05934d60c$export$5a682e48ed34e262(slice) {
        slice = (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            return node.isBlock && !node.isTextblock ? node.copy($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(node.content)) : node;
        });
        return new (0, (0, parcelRequire("kCV8T")).Slice)($99fc3db05934d60c$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
    }
    const $99fc3db05934d60c$export$d1dc8019f50dded8 = (slice, schema)=>{
        if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
            const maybeCodeBlock = slice.content.firstChild;
            if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
                if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(schema.text(maybeCodeBlock.textContent, [
                    schema.marks.code.create()
                ])), 0, 0);
            }
        }
        return slice;
    };
    const $99fc3db05934d60c$export$8435d1ef36841a34 = (state, selection)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        return (0, $5r0mK.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)(codeBlock)(selection || state.selection);
    };
});
parcelRegister("8Amfw", function(module, exports) {
    $parcel$export(module.exports, "findExpand", ()=>$e9a196c58ca29a43$export$fd7bf9c73fdd6f30);
    $parcel$export(module.exports, "transformSliceToRemoveOpenExpand", ()=>$e9a196c58ca29a43$export$6d57e15bdf5e650f);
    $parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", ()=>$e9a196c58ca29a43$export$74dbe7cb6b933cde);
    $parcel$export(module.exports, "transformSliceNestedExpandToExpand", ()=>$e9a196c58ca29a43$export$fd33fafbf6b5abc7);
    $parcel$export(module.exports, "transformSliceExpandToNestedExpand", ()=>$e9a196c58ca29a43$export$447e90e618548243);
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $7vpuQ;
    const $e9a196c58ca29a43$export$fd7bf9c73fdd6f30 = (state, selection)=>{
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        return (0, $5r0mK.findSelectedNodeOfType)([
            expand,
            nestedExpand
        ])(selection || state.selection) || (0, $5r0mK.findParentNodeOfType)([
            expand,
            nestedExpand
        ])(selection || state.selection);
    };
    const $e9a196c58ca29a43$export$6d57e15bdf5e650f = (slice, schema)=>{
        if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, (0, parcelRequire("kCV8T")).Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
        return slice;
    };
    const $e9a196c58ca29a43$export$74dbe7cb6b933cde = (slice, schema)=>{
        if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, (0, parcelRequire("kCV8T")).Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
        return slice;
    };
    const $e9a196c58ca29a43$export$fd33fafbf6b5abc7 = (slice, schema)=>{
        const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
        const children = [];
        (0, (0, parcelRequire("7vpuQ")).mapChildren)(slice.content, (node)=>{
            if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
            else children.push(node);
        });
        return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children), slice.openStart, slice.openEnd);
    };
    const $e9a196c58ca29a43$export$447e90e618548243 = (slice)=>{
        const children = [];
        try {
            (0, (0, parcelRequire("7vpuQ")).mapChildren)(slice.content, (currentNode)=>{
                const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
                if (currentNode.type === expand) {
                    const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                    if (nestedExpandNode) children.push(nestedExpandNode);
                } else children.push(currentNode);
            });
        } catch (e) {
            return null;
        }
        return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children), slice.openStart, slice.openEnd);
    };
});
parcelRegister("hZCXS", function(module, exports) {
    $parcel$export(module.exports, "transformSliceToDecisionList", ()=>$d713d8936b58e45c$export$65d21b4bef5d424b);
    var $kCV8T;
    const $d713d8936b58e45c$export$65d21b4bef5d424b = (slice, schema)=>{
        const node = slice.content.firstChild;
        if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
            const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
            return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
        }
        return slice;
    };
});
parcelRegister("38KaN", function(module, exports) {
    $parcel$export(module.exports, "MarkdownTransformer", ()=>$ca5b579471d13098$export$267fd7ead7cc4561);
    var $kOFhM;
    var $ivSSX = parcelRequire("ivSSX");
    var $4iMad = parcelRequire("4iMad");
    var $6fRr3;
    var $39HCX;
    function $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, map) {
        return Object.keys(map).reduce((newMap, key)=>{
            const value = map[key];
            const block = value.block || value.node;
            const mark = value.mark;
            if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
            return newMap;
        }, {});
    }
    const $ca5b579471d13098$var$pmSchemaToMdMapping = {
        nodes: {
            blockquote: 'blockquote',
            paragraph: 'paragraph',
            rule: 'hr',
            heading: [
                'heading',
                'lheading'
            ],
            codeBlock: [
                'code',
                'fence'
            ],
            listItem: 'list',
            image: 'image'
        },
        marks: {
            em: 'emphasis',
            strong: 'text',
            link: [
                'link',
                'autolink',
                'reference',
                'linkify'
            ],
            strike: 'strikethrough',
            code: 'backticks'
        }
    };
    const $ca5b579471d13098$var$mdToPmMapping = {
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>({
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                })
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        media_single: {
            block: 'mediaSingle',
            attrs: ()=>({})
        },
        media: {
            node: 'media',
            attrs: (tok)=>{
                return {
                    url: tok.attrGet('url'),
                    alt: tok.attrGet('alt'),
                    type: 'external'
                };
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (tok)=>({
                    shortName: `:${tok.markup}:`,
                    text: tok.content
                })
        },
        table: {
            block: 'table'
        },
        tr: {
            block: 'tableRow'
        },
        th: {
            block: 'tableHeader'
        },
        td: {
            block: 'tableCell'
        },
        s: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        }
    };
    const $ca5b579471d13098$var$md = (0, ($parcel$interopDefault($ivSSX)))('zero', {
        html: false
    });
    $ca5b579471d13098$var$md.enable([
        'entity',
        'escape'
    ]);
    class $ca5b579471d13098$export$267fd7ead7cc4561 {
        constructor(schema = (0, (0, parcelRequire("kOFhM")).defaultSchema), tokenizer = $ca5b579471d13098$var$md){
            [
                'nodes',
                'marks'
            ].forEach((key)=>{
                for(const idx in $ca5b579471d13098$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($ca5b579471d13098$var$pmSchemaToMdMapping[key][idx]);
            });
            if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
            if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, (0, parcelRequire("39HCX")).markdownItMedia));
            this.markdownParser = new (0, (0, parcelRequire("6fRr3")).MarkdownParser)(schema, tokenizer, $ca5b579471d13098$var$filterMdToPmSchemaMapping(schema, $ca5b579471d13098$var$mdToPmMapping));
        }
        encode(_node) {
            throw new Error('This is not implemented yet');
        }
        parse(content) {
            return this.markdownParser.parse(content);
        }
    }
});
parcelRegister("4iMad", function(module, exports) {
    $parcel$export(module.exports, "markdownItTable", ()=>$321e3433bbbbd43e$export$26a6b72a65821214);
    var $ew5rH = parcelRequire("ew5rH");
    var $321e3433bbbbd43e$export$26a6b72a65821214 = function markdownItTable(md, options) {
        md.block.ruler.before('paragraph', 'table', (0, ($parcel$interopDefault($ew5rH))), {
            alt: [
                'paragraph',
                'reference'
            ]
        });
    };
});
parcelRegister("ew5rH", function(module, exports) {
    function $a9184747dc810078$var$isSpace(code) {
        switch(code){
            case 0x09:
            case 0x20:
                return true;
        }
        return false;
    }
    function $a9184747dc810078$var$getLine(state, line) {
        var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
        return state.src.substr(pos, max - pos);
    }
    function $a9184747dc810078$var$escapedSplit(str) {
        var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
        ch = str.charCodeAt(pos);
        while(pos < max){
            if (ch === 0x60) {
                if (backTicked) {
                    backTicked = false;
                    lastBackTick = pos;
                } else if (escapes % 2 === 0) {
                    backTicked = true;
                    lastBackTick = pos;
                }
            } else if (ch === 0x7c && escapes % 2 === 0 && !backTicked) {
                result.push(str.substring(lastPos, pos));
                lastPos = pos + 1;
            }
            if (ch === 0x5c) escapes++;
            else escapes = 0;
            pos++;
            if (pos === max && backTicked) {
                backTicked = false;
                pos = lastBackTick + 1;
            }
            ch = str.charCodeAt(pos);
        }
        result.push(str.substring(lastPos));
        return result;
    }
    module.exports = function table(state, startLine, endLine, silent) {
        var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
        if (startLine + 2 > endLine) return false;
        nextLine = startLine + 1;
        if (state.sCount[nextLine] < state.blkIndent) return false;
        if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        if (pos >= state.eMarks[nextLine]) return false;
        ch = state.src.charCodeAt(pos++);
        if (ch !== 0x7c && ch !== 0x2d && ch !== 0x3a) return false;
        while(pos < state.eMarks[nextLine]){
            ch = state.src.charCodeAt(pos);
            if (ch !== 0x7c && ch !== 0x2d && ch !== 0x3a && !$a9184747dc810078$var$isSpace(ch)) return false;
            pos++;
        }
        lineText = $a9184747dc810078$var$getLine(state, startLine + 1);
        columns = lineText.split('|');
        aligns = [];
        for(i = 0; i < columns.length; i++){
            t = columns[i].trim();
            if (!t) {
                if (i === 0 || i === columns.length - 1) continue;
                else return false;
            }
            if (!/^:?-+:?$/.test(t)) return false;
            if (t.charCodeAt(t.length - 1) === 0x3a) aligns.push(t.charCodeAt(0) === 0x3a ? 'center' : 'right');
            else if (t.charCodeAt(0) === 0x3a) aligns.push('left');
            else aligns.push('');
        }
        lineText = $a9184747dc810078$var$getLine(state, startLine).trim();
        if (lineText.indexOf('|') === -1) return false;
        if (state.sCount[startLine] - state.blkIndent >= 4) return false;
        columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        columnCount = columns.length;
        if (columnCount > aligns.length) return false;
        if (silent) return true;
        token = state.push('table_open', 'table', 1);
        token.map = tableLines = [
            startLine,
            0
        ];
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        for(i = 0; i < columns.length; i++){
            token = state.push('th_open', 'th', 1);
            token.map = [
                startLine,
                startLine + 1
            ];
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('paragraph_open', 'p', 1);
            token = state.push('inline', '', 0);
            token.content = columns[i].trim();
            token.map = [
                startLine,
                startLine + 1
            ];
            token.children = [];
            token = state.push('paragraph_close', 'p', -1);
            token = state.push('th_close', 'th', -1);
        }
        token = state.push('tr_close', 'tr', -1);
        token.map = tbodyLines = [
            startLine + 2,
            0
        ];
        var oldLineMax = state.lineMax;
        for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
            if (state.sCount[nextLine] < state.blkIndent) break;
            lineText = $a9184747dc810078$var$getLine(state, nextLine).trim();
            if (lineText.indexOf('|') === -1) break;
            if (state.sCount[nextLine] - state.blkIndent >= 4) break;
            columns = $a9184747dc810078$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
            token = state.push('tr_open', 'tr', 1);
            for(var _i = 0, offset = 1; _i < columns.length; _i++){
                token = state.push('td_open', 'td', 1);
                if (aligns[_i]) token.attrs = [
                    [
                        'style',
                        'text-align:' + aligns[_i]
                    ]
                ];
                var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
                state.bMarks[nextLine] += offset + shift;
                offset = (columns[_i] || '').length + (shift ? 0 : 1);
                state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
                state.lineMax = 1;
                state.md.block.tokenize(state, nextLine, nextLine + 1);
                token = state.push('td_close', 'td', -1);
            }
            token = state.push('tr_close', 'tr', -1);
        }
        state.lineMax = oldLineMax;
        token = state.push('table_close', 'table', -1);
        tableLines[1] = tbodyLines[1] = nextLine;
        state.line = nextLine;
        return true;
    };
});
parcelRegister("6fRr3", function(module, exports) {
    $parcel$export(module.exports, "MarkdownParser", ()=>$48dd97f13fd6d562$export$a64f782182dea128);
    $parcel$export(module.exports, "MarkdownSerializer", ()=>$48dd97f13fd6d562$export$ae9f6f04acb6c60c);
    $parcel$export(module.exports, "MarkdownSerializerState", ()=>$48dd97f13fd6d562$export$61055fa707e69319);
    var $kCV8T;
    var $ivSSX = parcelRequire("ivSSX");
    const $48dd97f13fd6d562$export$4902baddc787debb = new (0, (0, parcelRequire("kCV8T")).Schema)({
        nodes: {
            doc: {
                content: "block+"
            },
            paragraph: {
                content: "inline*",
                group: "block",
                parseDOM: [
                    {
                        tag: "p"
                    }
                ],
                toDOM () {
                    return [
                        "p",
                        0
                    ];
                }
            },
            blockquote: {
                content: "block+",
                group: "block",
                parseDOM: [
                    {
                        tag: "blockquote"
                    }
                ],
                toDOM () {
                    return [
                        "blockquote",
                        0
                    ];
                }
            },
            horizontal_rule: {
                group: "block",
                parseDOM: [
                    {
                        tag: "hr"
                    }
                ],
                toDOM () {
                    return [
                        "div",
                        [
                            "hr"
                        ]
                    ];
                }
            },
            heading: {
                attrs: {
                    level: {
                        default: 1
                    }
                },
                content: "(text | image)*",
                group: "block",
                defining: true,
                parseDOM: [
                    {
                        tag: "h1",
                        attrs: {
                            level: 1
                        }
                    },
                    {
                        tag: "h2",
                        attrs: {
                            level: 2
                        }
                    },
                    {
                        tag: "h3",
                        attrs: {
                            level: 3
                        }
                    },
                    {
                        tag: "h4",
                        attrs: {
                            level: 4
                        }
                    },
                    {
                        tag: "h5",
                        attrs: {
                            level: 5
                        }
                    },
                    {
                        tag: "h6",
                        attrs: {
                            level: 6
                        }
                    }
                ],
                toDOM (node) {
                    return [
                        "h" + node.attrs.level,
                        0
                    ];
                }
            },
            code_block: {
                content: "text*",
                group: "block",
                code: true,
                defining: true,
                marks: "",
                attrs: {
                    params: {
                        default: ""
                    }
                },
                parseDOM: [
                    {
                        tag: "pre",
                        preserveWhitespace: "full",
                        getAttrs: (node)=>({
                                params: node.getAttribute("data-params") || ""
                            })
                    }
                ],
                toDOM (node) {
                    return [
                        "pre",
                        node.attrs.params ? {
                            "data-params": node.attrs.params
                        } : {},
                        [
                            "code",
                            0
                        ]
                    ];
                }
            },
            ordered_list: {
                content: "list_item+",
                group: "block",
                attrs: {
                    order: {
                        default: 1
                    },
                    tight: {
                        default: false
                    }
                },
                parseDOM: [
                    {
                        tag: "ol",
                        getAttrs (dom) {
                            return {
                                order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                                tight: dom.hasAttribute("data-tight")
                            };
                        }
                    }
                ],
                toDOM (node) {
                    return [
                        "ol",
                        {
                            start: node.attrs.order == 1 ? null : node.attrs.order,
                            "data-tight": node.attrs.tight ? "true" : null
                        },
                        0
                    ];
                }
            },
            bullet_list: {
                content: "list_item+",
                group: "block",
                attrs: {
                    tight: {
                        default: false
                    }
                },
                parseDOM: [
                    {
                        tag: "ul",
                        getAttrs: (dom)=>({
                                tight: dom.hasAttribute("data-tight")
                            })
                    }
                ],
                toDOM (node) {
                    return [
                        "ul",
                        {
                            "data-tight": node.attrs.tight ? "true" : null
                        },
                        0
                    ];
                }
            },
            list_item: {
                content: "block+",
                defining: true,
                parseDOM: [
                    {
                        tag: "li"
                    }
                ],
                toDOM () {
                    return [
                        "li",
                        0
                    ];
                }
            },
            text: {
                group: "inline"
            },
            image: {
                inline: true,
                attrs: {
                    src: {},
                    alt: {
                        default: null
                    },
                    title: {
                        default: null
                    }
                },
                group: "inline",
                draggable: true,
                parseDOM: [
                    {
                        tag: "img[src]",
                        getAttrs (dom) {
                            return {
                                src: dom.getAttribute("src"),
                                title: dom.getAttribute("title"),
                                alt: dom.getAttribute("alt")
                            };
                        }
                    }
                ],
                toDOM (node) {
                    return [
                        "img",
                        node.attrs
                    ];
                }
            },
            hard_break: {
                inline: true,
                group: "inline",
                selectable: false,
                parseDOM: [
                    {
                        tag: "br"
                    }
                ],
                toDOM () {
                    return [
                        "br"
                    ];
                }
            }
        },
        marks: {
            em: {
                parseDOM: [
                    {
                        tag: "i"
                    },
                    {
                        tag: "em"
                    },
                    {
                        style: "font-style=italic"
                    },
                    {
                        style: "font-style=normal",
                        clearMark: (m)=>m.type.name == "em"
                    }
                ],
                toDOM () {
                    return [
                        "em"
                    ];
                }
            },
            strong: {
                parseDOM: [
                    {
                        tag: "strong"
                    },
                    {
                        tag: "b",
                        getAttrs: (node)=>node.style.fontWeight != "normal" && null
                    },
                    {
                        style: "font-weight=400",
                        clearMark: (m)=>m.type.name == "strong"
                    },
                    {
                        style: "font-weight",
                        getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                    }
                ],
                toDOM () {
                    return [
                        "strong"
                    ];
                }
            },
            link: {
                attrs: {
                    href: {},
                    title: {
                        default: null
                    }
                },
                inclusive: false,
                parseDOM: [
                    {
                        tag: "a[href]",
                        getAttrs (dom) {
                            return {
                                href: dom.getAttribute("href"),
                                title: dom.getAttribute("title")
                            };
                        }
                    }
                ],
                toDOM (node) {
                    return [
                        "a",
                        node.attrs
                    ];
                }
            },
            code: {
                parseDOM: [
                    {
                        tag: "code"
                    }
                ],
                toDOM () {
                    return [
                        "code"
                    ];
                }
            }
        }
    });
    function $48dd97f13fd6d562$var$maybeMerge(a, b) {
        if (a.isText && b.isText && (0, (0, parcelRequire("kCV8T")).Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
    }
    class $48dd97f13fd6d562$var$MarkdownParseState {
        constructor(schema, tokenHandlers){
            this.schema = schema;
            this.tokenHandlers = tokenHandlers;
            this.stack = [
                {
                    type: schema.topNodeType,
                    attrs: null,
                    content: [],
                    marks: (0, (0, parcelRequire("kCV8T")).Mark).none
                }
            ];
        }
        top() {
            return this.stack[this.stack.length - 1];
        }
        push(elt) {
            if (this.stack.length) this.top().content.push(elt);
        }
        addText(text) {
            if (!text) return;
            let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
            let node = this.schema.text(text, top.marks), merged;
            if (last && (merged = $48dd97f13fd6d562$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
            else nodes.push(node);
        }
        openMark(mark) {
            let top = this.top();
            top.marks = mark.addToSet(top.marks);
        }
        closeMark(mark) {
            let top = this.top();
            top.marks = mark.removeFromSet(top.marks);
        }
        parseTokens(toks) {
            for(let i = 0; i < toks.length; i++){
                let tok = toks[i];
                let handler = this.tokenHandlers[tok.type];
                if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
                handler(this, tok, toks, i);
            }
        }
        addNode(type, attrs, content) {
            let top = this.top();
            let node = type.createAndFill(attrs, content, top ? top.marks : []);
            if (!node) return null;
            this.push(node);
            return node;
        }
        openNode(type, attrs) {
            this.stack.push({
                type: type,
                attrs: attrs,
                content: [],
                marks: (0, (0, parcelRequire("kCV8T")).Mark).none
            });
        }
        closeNode() {
            let info = this.stack.pop();
            return this.addNode(info.type, info.attrs, info.content);
        }
    }
    function $48dd97f13fd6d562$var$attrs(spec, token, tokens, i) {
        if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
        else if (spec.attrs instanceof Function) return spec.attrs(token);
        else return spec.attrs;
    }
    function $48dd97f13fd6d562$var$noCloseToken(spec, type) {
        return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
    }
    function $48dd97f13fd6d562$var$withoutTrailingNewline(str) {
        return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
    }
    function $48dd97f13fd6d562$var$noOp() {}
    function $48dd97f13fd6d562$var$tokenHandlers(schema, tokens) {
        let handlers = Object.create(null);
        for(let type in tokens){
            let spec = tokens[type];
            if (spec.block) {
                let nodeType = schema.nodeType(spec.block);
                if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                    state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                    state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                    state.closeNode();
                };
                else {
                    handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
                    handlers[type + "_close"] = (state)=>state.closeNode();
                }
            } else if (spec.node) {
                let nodeType = schema.nodeType(spec.node);
                handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $48dd97f13fd6d562$var$attrs(spec, tok, tokens, i));
            } else if (spec.mark) {
                let markType = schema.marks[spec.mark];
                if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                    state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                    state.addText($48dd97f13fd6d562$var$withoutTrailingNewline(tok.content));
                    state.closeMark(markType);
                };
                else {
                    handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($48dd97f13fd6d562$var$attrs(spec, tok, tokens, i)));
                    handlers[type + "_close"] = (state)=>state.closeMark(markType);
                }
            } else if (spec.ignore) {
                if ($48dd97f13fd6d562$var$noCloseToken(spec, type)) handlers[type] = $48dd97f13fd6d562$var$noOp;
                else {
                    handlers[type + "_open"] = $48dd97f13fd6d562$var$noOp;
                    handlers[type + "_close"] = $48dd97f13fd6d562$var$noOp;
                }
            } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
        }
        handlers.text = (state, tok)=>state.addText(tok.content);
        handlers.inline = (state, tok)=>state.parseTokens(tok.children);
        handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
        return handlers;
    }
    class $48dd97f13fd6d562$export$a64f782182dea128 {
        constructor(schema, tokenizer, tokens){
            this.schema = schema;
            this.tokenizer = tokenizer;
            this.tokens = tokens;
            this.tokenHandlers = $48dd97f13fd6d562$var$tokenHandlers(schema, tokens);
        }
        parse(text, markdownEnv = {}) {
            let state = new $48dd97f13fd6d562$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
            state.parseTokens(this.tokenizer.parse(text, markdownEnv));
            do doc = state.closeNode();
            while (state.stack.length)
            return doc || this.schema.topNodeType.createAndFill();
        }
    }
    function $48dd97f13fd6d562$var$listIsTight(tokens, i) {
        while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
        return false;
    }
    const $48dd97f13fd6d562$export$7517583227ad0cb8 = new $48dd97f13fd6d562$export$a64f782182dea128($48dd97f13fd6d562$export$4902baddc787debb, (0, ($parcel$interopDefault($ivSSX)))("commonmark", {
        html: false
    }), {
        blockquote: {
            block: "blockquote"
        },
        paragraph: {
            block: "paragraph"
        },
        list_item: {
            block: "list_item"
        },
        bullet_list: {
            block: "bullet_list",
            getAttrs: (_, tokens, i)=>({
                    tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
                })
        },
        ordered_list: {
            block: "ordered_list",
            getAttrs: (tok, tokens, i)=>({
                    order: +tok.attrGet("start") || 1,
                    tight: $48dd97f13fd6d562$var$listIsTight(tokens, i)
                })
        },
        heading: {
            block: "heading",
            getAttrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        code_block: {
            block: "code_block",
            noCloseToken: true
        },
        fence: {
            block: "code_block",
            getAttrs: (tok)=>({
                    params: tok.info || ""
                }),
            noCloseToken: true
        },
        hr: {
            node: "horizontal_rule"
        },
        image: {
            node: "image",
            getAttrs: (tok)=>({
                    src: tok.attrGet("src"),
                    title: tok.attrGet("title") || null,
                    alt: tok.children[0] && tok.children[0].content || null
                })
        },
        hardbreak: {
            node: "hard_break"
        },
        em: {
            mark: "em"
        },
        strong: {
            mark: "strong"
        },
        link: {
            mark: "link",
            getAttrs: (tok)=>({
                    href: tok.attrGet("href"),
                    title: tok.attrGet("title") || null
                })
        },
        code_inline: {
            mark: "code",
            noCloseToken: true
        }
    });
    const $48dd97f13fd6d562$var$blankMark = {
        open: "",
        close: "",
        mixable: true
    };
    class $48dd97f13fd6d562$export$ae9f6f04acb6c60c {
        constructor(nodes, marks, options = {}){
            this.nodes = nodes;
            this.marks = marks;
            this.options = options;
        }
        serialize(content, options = {}) {
            options = Object.assign({}, this.options, options);
            let state = new $48dd97f13fd6d562$export$61055fa707e69319(this.nodes, this.marks, options);
            state.renderContent(content);
            return state.out;
        }
    }
    const $48dd97f13fd6d562$export$f996452ca6e9a0ae = new $48dd97f13fd6d562$export$ae9f6f04acb6c60c({
        blockquote (state, node) {
            state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
        },
        code_block (state, node) {
            const backticks = node.textContent.match(/`{3,}/gm);
            const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
            state.write(fence + (node.attrs.params || "") + "\n");
            state.text(node.textContent, false);
            state.write("\n");
            state.write(fence);
            state.closeBlock(node);
        },
        heading (state, node) {
            state.write(state.repeat("#", node.attrs.level) + " ");
            state.renderInline(node, false);
            state.closeBlock(node);
        },
        horizontal_rule (state, node) {
            state.write(node.attrs.markup || "---");
            state.closeBlock(node);
        },
        bullet_list (state, node) {
            state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
        },
        ordered_list (state, node) {
            let start = node.attrs.order || 1;
            let maxW = String(start + node.childCount - 1).length;
            let space = state.repeat(" ", maxW + 2);
            state.renderList(node, space, (i)=>{
                let nStr = String(start + i);
                return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
            });
        },
        list_item (state, node) {
            state.renderContent(node);
        },
        paragraph (state, node) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        image (state, node) {
            state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
        },
        hard_break (state, node, parent, index) {
            for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
                state.write("\\\n");
                return;
            }
        },
        text (state, node) {
            state.text(node.text, !state.inAutolink);
        }
    }, {
        em: {
            open: "*",
            close: "*",
            mixable: true,
            expelEnclosingWhitespace: true
        },
        strong: {
            open: "**",
            close: "**",
            mixable: true,
            expelEnclosingWhitespace: true
        },
        link: {
            open (state, mark, parent, index) {
                state.inAutolink = $48dd97f13fd6d562$var$isPlainURL(mark, parent, index);
                return state.inAutolink ? "<" : "[";
            },
            close (state, mark, parent, index) {
                let { inAutolink: inAutolink } = state;
                state.inAutolink = undefined;
                return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
            },
            mixable: true
        },
        code: {
            open (_state, _mark, parent, index) {
                return $48dd97f13fd6d562$var$backticksFor(parent.child(index), -1);
            },
            close (_state, _mark, parent, index) {
                return $48dd97f13fd6d562$var$backticksFor(parent.child(index - 1), 1);
            },
            escape: false
        }
    });
    function $48dd97f13fd6d562$var$backticksFor(node, side) {
        let ticks = /`+/g, m, len = 0;
        if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
        let result = len > 0 && side > 0 ? " `" : "`";
        for(let i = 0; i < len; i++)result += "`";
        if (len > 0 && side < 0) result += " ";
        return result;
    }
    function $48dd97f13fd6d562$var$isPlainURL(link, parent, index) {
        if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
        let content = parent.child(index);
        if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
        return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
    }
    class $48dd97f13fd6d562$export$61055fa707e69319 {
        constructor(nodes, marks, options){
            this.nodes = nodes;
            this.marks = marks;
            this.options = options;
            this.delim = "";
            this.out = "";
            this.closed = null;
            this.inAutolink = undefined;
            this.atBlockStart = false;
            this.inTightList = false;
            if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
            if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
        }
        flushClose(size = 2) {
            if (this.closed) {
                if (!this.atBlank()) this.out += "\n";
                if (size > 1) {
                    let delimMin = this.delim;
                    let trim = /\s+$/.exec(delimMin);
                    if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                    for(let i = 1; i < size; i++)this.out += delimMin + "\n";
                }
                this.closed = null;
            }
        }
        getMark(name) {
            let info = this.marks[name];
            if (!info) {
                if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
                info = $48dd97f13fd6d562$var$blankMark;
            }
            return info;
        }
        wrapBlock(delim, firstDelim, node, f) {
            let old = this.delim;
            this.write(firstDelim != null ? firstDelim : delim);
            this.delim += delim;
            f();
            this.delim = old;
            this.closeBlock(node);
        }
        atBlank() {
            return /(^|\n)$/.test(this.out);
        }
        ensureNewLine() {
            if (!this.atBlank()) this.out += "\n";
        }
        write(content) {
            this.flushClose();
            if (this.delim && this.atBlank()) this.out += this.delim;
            if (content) this.out += content;
        }
        closeBlock(node) {
            this.closed = node;
        }
        text(text, escape = true) {
            let lines = text.split("\n");
            for(let i = 0; i < lines.length; i++){
                this.write();
                if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
                this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
                if (i != lines.length - 1) this.out += "\n";
            }
        }
        render(node, parent, index) {
            if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
            else {
                if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
                else if (!node.type.isLeaf) {
                    if (node.type.inlineContent) this.renderInline(node);
                    else this.renderContent(node);
                    if (node.isBlock) this.closeBlock(node);
                }
            }
        }
        renderContent(parent) {
            parent.forEach((node, _, i)=>this.render(node, parent, i));
        }
        renderInline(parent, fromBlockStart = true) {
            this.atBlockStart = fromBlockStart;
            let active = [], trailing = "";
            let progress = (node, offset, index)=>{
                let marks = node ? node.marks : [];
                if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                    if (index + 1 == parent.childCount) return false;
                    let next = parent.child(index + 1);
                    return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
                });
                let leading = trailing;
                trailing = "";
                if (node && node.isText && marks.some((mark)=>{
                    let info = this.getMark(mark.type.name);
                    return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
                })) {
                    let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                    if (lead) {
                        leading += lead;
                        node = rest ? node.withText(rest) : null;
                        if (!node) marks = active;
                    }
                }
                if (node && node.isText && marks.some((mark)=>{
                    let info = this.getMark(mark.type.name);
                    return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
                })) {
                    let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                    if (trail) {
                        trailing = trail;
                        node = rest ? node.withText(rest) : null;
                        if (!node) marks = active;
                    }
                }
                let inner = marks.length ? marks[marks.length - 1] : null;
                let noEsc = inner && this.getMark(inner.type.name).escape === false;
                let len = marks.length - (noEsc ? 1 : 0);
                outer: for(let i = 0; i < len; i++){
                    let mark = marks[i];
                    if (!this.getMark(mark.type.name).mixable) break;
                    for(let j = 0; j < active.length; j++){
                        let other = active[j];
                        if (!this.getMark(other.type.name).mixable) break;
                        if (mark.eq(other)) {
                            if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                            else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                            continue outer;
                        }
                    }
                }
                let keep = 0;
                while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
                while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
                if (leading) this.text(leading);
                if (node) {
                    while(active.length < len){
                        let add = marks[active.length];
                        active.push(add);
                        this.text(this.markString(add, true, parent, index), false);
                        this.atBlockStart = false;
                    }
                    if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                    else this.render(node, parent, index);
                    this.atBlockStart = false;
                }
                if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
            };
            parent.forEach(progress);
            progress(null, 0, parent.childCount);
            this.atBlockStart = false;
        }
        renderList(node, delim, firstDelim) {
            if (this.closed && this.closed.type == node.type) this.flushClose(3);
            else if (this.inTightList) this.flushClose(1);
            let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
            let prevTight = this.inTightList;
            this.inTightList = isTight;
            node.forEach((child, _, i)=>{
                if (i && isTight) this.flushClose(1);
                this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
            });
            this.inTightList = prevTight;
        }
        esc(str, startOfLine = false) {
            str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
            if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
            if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
            return str;
        }
        quote(str) {
            let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
            return wrap[0] + str + wrap[1];
        }
        repeat(str, n) {
            let out = "";
            for(let i = 0; i < n; i++)out += str;
            return out;
        }
        markString(mark, open, parent, index) {
            let info = this.getMark(mark.type.name);
            let value = open ? info.open : info.close;
            return typeof value == "string" ? value : value(this, mark, parent, index);
        }
        getEnclosingWhitespace(text) {
            return {
                leading: (text.match(/^(\s+)/) || [
                    undefined
                ])[0],
                trailing: (text.match(/(\s+)$/) || [
                    undefined
                ])[0]
            };
        }
    }
});
parcelRegister("39HCX", function(module, exports) {
    $parcel$export(module.exports, "markdownItMedia", ()=>$288ff3bbed487814$export$c8dcbd316b71f8cf);
    function $288ff3bbed487814$var$createRule() {
        const regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
        const validParentTokens = [
            'th_open',
            'td_open',
            'list_item_open',
            'blockquote_open'
        ];
        return function media(State) {
            const getUrl = (str)=>{
                const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
                if (res.ok) {
                    const href = State.md.normalizeLink(res.str);
                    if (State.md.validateLink(href)) return href;
                }
                return '';
            };
            const createMediaTokens = (url, alt = '')=>{
                const mediaSingleOpen = new State.Token('media_single_open', '', 1);
                const media = new State.Token('media', '', 0);
                media.attrs = [
                    [
                        'url',
                        getUrl(url)
                    ],
                    [
                        'type',
                        'external'
                    ],
                    [
                        'alt',
                        alt
                    ]
                ];
                const mediaSingleClose = new State.Token('media_single_close', '', -1);
                return [
                    mediaSingleOpen,
                    media,
                    mediaSingleClose
                ];
            };
            const createInlineTokens = (str, openingTokens, closingTokens)=>{
                if (!str || str.length === 0) return [];
                const inlineBefore = new State.Token('inline', '', 1);
                inlineBefore.content = str;
                inlineBefore.children = [];
                return [
                    ...openingTokens,
                    inlineBefore,
                    ...closingTokens
                ];
            };
            let processedTokens = [];
            const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
                const matchAll = Array.from(token.content.matchAll(regx));
                if (token.type === 'inline' && matchAll.length) {
                    const openingTokens = [];
                    let cursor = i - 1;
                    let previousToken = arr[cursor];
                    let subTree = [];
                    while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                        openingTokens.unshift(previousToken);
                        cursor--;
                        previousToken = arr[cursor];
                    }
                    if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                    else cursor++;
                    const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                    let inlineContentStack = token.content;
                    matchAll.forEach((match, j)=>{
                        const [matchString, alt, url] = match;
                        const start = inlineContentStack.indexOf(matchString);
                        const contentBefore = inlineContentStack.substr(0, start);
                        inlineContentStack = inlineContentStack.substr(start + matchString.length);
                        subTree = [
                            ...subTree,
                            ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                            ...createMediaTokens(url, alt)
                        ];
                    });
                    if (inlineContentStack.length) subTree = [
                        ...subTree,
                        ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                    ];
                    processedTokens = [
                        ...processedTokens,
                        ...closingTokens.map((c)=>c.type)
                    ];
                    tokens = [
                        ...tokens.slice(0, cursor),
                        ...subTree
                    ];
                } else if (processedTokens.indexOf(token.type) !== -1) processedTokens.splice(processedTokens.indexOf(token.type), 1);
                else tokens.push(token);
                return tokens;
            }, []);
            State.tokens = newTokens;
            return true;
        };
    }
    const $288ff3bbed487814$export$c8dcbd316b71f8cf = (md)=>{
        md.core.ruler.before('inline', 'media', $288ff3bbed487814$var$createRule());
    };
});
parcelRegister("hKZR1", function(module, exports) {
    $parcel$export(module.exports, "handlePaste", ()=>$ff49e98b89c214ae$export$5dbcc300324fed87);
    var $kCV8T;
    var $hFEwm;
    var $uOUlv;
    var $22PoI;
    var $3yjNu;
    var $bQFBc;
    var $5i9bT;
    function $ff49e98b89c214ae$export$5dbcc300324fed87(view, event, slice) {
        if (!(0, (0, parcelRequire("bQFBc")).isInTable)(view.state)) return false;
        let cells = (0, (0, parcelRequire("5i9bT")).pastedCells)(slice);
        const sel = view.state.selection;
        if (sel instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) {
            if (!cells) cells = {
                width: 1,
                height: 1,
                rows: [
                    (0, (0, parcelRequire("kCV8T")).Fragment).from((0, (0, parcelRequire("5i9bT")).fitSlice)((0, (0, parcelRequire("3yjNu")).tableNodeTypes)(view.state.schema).cell, slice))
                ]
            };
            const table = sel.$anchorCell.node(-1);
            const start = sel.$anchorCell.start(-1);
            const tableMap = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
            const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
            cells = (0, (0, parcelRequire("5i9bT")).clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
            (0, (0, parcelRequire("5i9bT")).insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
            return true;
        }
        if (cells) {
            const $cell = (0, (0, parcelRequire("22PoI")).selectionCell)(sel);
            if (!$cell) throw new Error(`handlePaste: no cell found`);
            const start = $cell.start(-1);
            const rect = (0, (0, parcelRequire("uOUlv")).TableMap).get($cell.node(-1)).findCell($cell.pos - start);
            const tableMap = (0, (0, parcelRequire("uOUlv")).TableMap).get($cell.node(-1));
            (0, (0, parcelRequire("5i9bT")).insertCells)(view.state, view.dispatch, start, rect, $ff49e98b89c214ae$var$clearColumnWidthOfCells(cells, rect, tableMap));
            return true;
        }
        return false;
    }
    const $ff49e98b89c214ae$var$clearColumnWidthOfCells = (cells, rect, table)=>{
        const overlappingCells = [];
        for (const row of cells.rows){
            let colNum = rect.left;
            for(let index = 0; index < row.childCount; index++){
                const cell = row.child(index);
                if (colNum + cell.attrs.colspan <= table.width) {
                    overlappingCells.push(cell);
                    colNum += cell.attrs.colspan;
                } else break;
            }
        }
        for (const cell of overlappingCells)cell.attrs.colwidth = null;
        return cells;
    };
});
parcelRegister("3yjNu", function(module, exports) {
    $parcel$export(module.exports, "tableNodeTypes", ()=>$8be71f6754b181de$export$c7782132717464bc);
    function $8be71f6754b181de$export$c7782132717464bc(schema) {
        let result = schema.cached.tableNodeTypes;
        if (!result) {
            result = {};
            schema.cached.tableNodeTypes = result;
            for(const name in schema.nodes){
                const type = schema.nodes[name];
                const role = type.spec.tableRole;
                if (role) result[role] = type;
            }
        }
        return result;
    }
});
parcelRegister("5i9bT", function(module, exports) {
    $parcel$export(module.exports, "pastedCells", ()=>$6dd11ae486d7c5ad$export$f6d8f52489457fc4);
    $parcel$export(module.exports, "fitSlice", ()=>$6dd11ae486d7c5ad$export$f09c6b3b06d884fb);
    $parcel$export(module.exports, "clipCells", ()=>$6dd11ae486d7c5ad$export$cdcebd68073bc3f);
    $parcel$export(module.exports, "insertCells", ()=>$6dd11ae486d7c5ad$export$e0b94385c1fdc132);
    var $kCV8T;
    var $eS2Dn;
    var $hFEwm;
    var $uOUlv;
    var $6e6o8;
    var $hHsVB;
    var $3yjNu;
    var $eNHnZ;
    function $6dd11ae486d7c5ad$var$stripHeaderType(schema, cells) {
        const newCells = [];
        cells.forEach((cell)=>{
            const cellNodeType = (0, (0, parcelRequire("3yjNu")).tableNodeTypes)(schema).cell;
            const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
            newCells.push(tableCell);
        });
        return (0, (0, parcelRequire("kCV8T")).Fragment).from(newCells);
    }
    function $6dd11ae486d7c5ad$export$f6d8f52489457fc4(slice) {
        if (!slice.size) return null;
        let { content: content, openStart: openStart, openEnd: openEnd } = slice;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
        while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
            openStart--;
            openEnd--;
            content = content.firstChild.content;
            if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
        }
        const first = content.firstChild;
        const role = first.type.spec.tableRole;
        const { schema: schema } = first.type;
        const rows = [];
        if (role === 'row') for(let i = 0; i < content.childCount; i++){
            let cells = content.child(i).content;
            const left = i ? 0 : Math.max(0, openStart - 1);
            const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
            if (left || right) cells = $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, (0, parcelRequire("3yjNu")).tableNodeTypes)(schema).row, new (0, (0, parcelRequire("kCV8T")).Slice)(cells, left, right)).content;
            rows.push(cells);
        }
        else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $6dd11ae486d7c5ad$export$f09c6b3b06d884fb((0, (0, parcelRequire("3yjNu")).tableNodeTypes)(schema).row, new (0, (0, parcelRequire("kCV8T")).Slice)(content, openStart, openEnd)).content : content);
        else return null;
        const rowsWithoutHeaders = rows.map((row)=>$6dd11ae486d7c5ad$var$stripHeaderType(schema, row));
        return $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsWithoutHeaders);
    }
    function $6dd11ae486d7c5ad$var$ensureRectangular(schema, rowsFragment) {
        const rows = rowsFragment;
        const widths = [];
        for(let i = 0; i < rows.length; i++){
            const row = rows[i];
            for(let j = row.childCount - 1; j >= 0; j--){
                const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
                for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
            }
        }
        let width = 0;
        for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
        for(let r = 0; r < widths.length; r++){
            if (r >= rows.length) rows.push((0, (0, parcelRequire("kCV8T")).Fragment).empty);
            if (widths[r] < width) {
                const empty = (0, (0, parcelRequire("3yjNu")).tableNodeTypes)(schema).cell.createAndFill();
                const cells = [];
                for(let i = widths[r]; i < width; i++)cells.push(empty);
                rows[r] = rows[r].append((0, (0, parcelRequire("kCV8T")).Fragment).from(cells));
            }
        }
        return {
            height: rows.length,
            width: width,
            rows: rows
        };
    }
    function $6dd11ae486d7c5ad$export$f09c6b3b06d884fb(nodeType, slice) {
        const node = nodeType.createAndFill();
        if (!node) throw new Error(`fitSlice: unable to create node`);
        const tr = new (0, (0, parcelRequire("eS2Dn")).Transform)(node).replace(0, node.content.size, slice);
        return tr.doc;
    }
    function $6dd11ae486d7c5ad$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
        let rows = currentRows;
        let width = currentWidth;
        let height = currentHeight;
        if (width !== newWidth) {
            const added = [];
            const newRows = [];
            for(let row = 0; row < rows.length; row++){
                const frag = rows[row];
                const cells = [];
                for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                    let cell = frag.child(i % frag.childCount);
                    if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, (0, parcelRequire("6e6o8")).removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                    cells.push(cell);
                    col += cell.attrs.colspan;
                    for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
                }
                newRows.push((0, (0, parcelRequire("kCV8T")).Fragment).from(cells));
            }
            rows = newRows;
            width = newWidth;
        }
        if (height !== newHeight) {
            const newRows = [];
            for(let row = 0, i = 0; row < newHeight; row++, i++){
                const cells = [];
                const source = rows[i % height];
                for(let j = 0; j < source.childCount; j++){
                    let cell = source.child(j);
                    if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                        ...cell.attrs,
                        rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                    }, cell.content);
                    cells.push(cell);
                }
                newRows.push((0, (0, parcelRequire("kCV8T")).Fragment).from(cells));
            }
            rows = newRows;
            height = newHeight;
        }
        return {
            width: width,
            height: height,
            rows: rows
        };
    }
    function $6dd11ae486d7c5ad$var$growTable(tr, map, table, start, width, height, mapFrom) {
        const { schema: schema } = tr.doc.type;
        const types = (0, (0, parcelRequire("3yjNu")).tableNodeTypes)(schema);
        let empty;
        let emptyHead;
        if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
            const rowNode = table.child(row);
            rowEnd += rowNode.nodeSize;
            const cells = [];
            let add;
            if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) add = empty || (empty = types.cell.createAndFill());
            else add = emptyHead || (emptyHead = types.header_cell.createAndFill());
            for(let i = map.width; i < width; i++)cells.push(add);
            tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
        }
        if (height > map.height) {
            const cells = [];
            for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
                let header;
                if (i >= map.width) header = false;
                else {
                    const mappedPos = map.map[k + i];
                    const node = table.nodeAt(mappedPos);
                    if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                    header = node.type === types.header_cell;
                }
                cells.push(header ? emptyHead || (emptyHead = types.header_cell.createAndFill()) : empty || (empty = types.cell.createAndFill()));
            }
            const emptyRow = types.row.create(null, (0, (0, parcelRequire("kCV8T")).Fragment).from(cells));
            const rows = [];
            for(let i = map.height; i < height; i++)rows.push(emptyRow);
            tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
        }
        return !!(empty || emptyHead);
    }
    function $6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
        if (top === 0 || top === map.height) return false;
        let found = false;
        for(let col = left; col < right; col++){
            const index = top * map.width + col;
            const pos = map.map[index];
            if (map.map[index - map.width] === pos) {
                found = true;
                const cell = table.nodeAt(pos);
                if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
                const { top: cellTop, left: cellLeft } = map.findCell(pos);
                tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                    ...cell.attrs,
                    rowspan: top - cellTop
                });
                const newCell = cell.type.createAndFill({
                    ...cell.attrs,
                    rowspan: cellTop + cell.attrs.rowspan - top
                });
                if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
                tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
                col += cell.attrs.colspan - 1;
            }
        }
        return found;
    }
    function $6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
        if (left === 0 || left === map.width) return false;
        let found = false;
        for(let row = top; row < bottom; row++){
            const index = row * map.width + left;
            const pos = map.map[index];
            if (map.map[index - 1] === pos) {
                found = true;
                const cell = table.nodeAt(pos);
                if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
                const cellLeft = map.colCount(pos);
                const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
                tr.setNodeMarkup(updatePos, undefined, (0, (0, parcelRequire("6e6o8")).removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
                const newCell = cell.type.createAndFill((0, (0, parcelRequire("6e6o8")).removeColSpan)(cell.attrs, 0, left - cellLeft));
                if (!newCell) throw new Error('isolateVertical: failed to create cell');
                tr.insert(updatePos + cell.nodeSize, newCell);
                row += cell.attrs.rowspan - 1;
            }
        }
        return found;
    }
    function $6dd11ae486d7c5ad$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
        const { schema: schema } = state;
        const setMarkup = (tr, row, col, headerEnabled)=>{
            const cellPos = tableStart + tableMap.positionAt(row, col, table);
            const cell = tr.doc.nodeAt(cellPos);
            const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
            const isCellTypeChanged = newType !== cell?.type;
            const isCellTypeValid = !!cell && [
                schema.nodes.tableCell,
                schema.nodes.tableHeader
            ].includes(cell.type);
            if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
        };
        setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
        for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
        for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
    }
    function $6dd11ae486d7c5ad$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
        let table = state.doc;
        const newRect = (0, (0, parcelRequire("hHsVB")).selectedRect)(state);
        const types = (0, (0, parcelRequire("3yjNu")).tableNodeTypes)(state.schema);
        const headerRowEnabled = (0, (0, parcelRequire("eNHnZ")).isHeaderEnabledByType)('row', newRect, types);
        const headerColumnEnabled = (0, (0, parcelRequire("eNHnZ")).isHeaderEnabledByType)('column', newRect, types);
        if (tableStart) {
            table = state.doc.nodeAt(tableStart - 1);
            if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
        }
        let map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
        const { top: top, left: left } = rect;
        const right = left + cells.width;
        const bottom = top + cells.height;
        const { tr: tr } = state;
        let mapFrom = 0;
        function recomp() {
            table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
            map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table);
            mapFrom = tr.mapping.maps.length;
        }
        if ($6dd11ae486d7c5ad$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
        if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
        if ($6dd11ae486d7c5ad$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
        if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
        if ($6dd11ae486d7c5ad$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
        for(let row = top; row < bottom; row++){
            const from = map.positionAt(row, left, table);
            const to = map.positionAt(row, right, table);
            tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, (0, parcelRequire("kCV8T")).Slice)(cells.rows[row - top], 0, 0));
        }
        recomp();
        $6dd11ae486d7c5ad$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
        tr.setSelection(new (0, (0, parcelRequire("hFEwm")).CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
        dispatch(tr);
    }
});
parcelRegister("eNHnZ", function(module, exports) {
    $parcel$export(module.exports, "isHeaderEnabledByType", ()=>$9886d955dd3a1a8d$export$96946e3333d0ccc6);
    $parcel$export(module.exports, "toggleHeader", ()=>$9886d955dd3a1a8d$export$dee0ccd8d8f5a56e);
    var $uOUlv;
    var $hHsVB;
    var $3yjNu;
    var $bQFBc;
    function $9886d955dd3a1a8d$export$96946e3333d0ccc6(type, rect, types) {
        const cellPositions = rect.map.cellsInRect({
            left: 0,
            top: 0,
            right: type === 'row' ? rect.map.width : 1,
            bottom: type === 'column' ? rect.map.height : 1
        });
        for(let i = 0; i < cellPositions.length; i++){
            const cell = rect.table.nodeAt(cellPositions[i]);
            if (cell && cell.type !== types.header_cell) return false;
        }
        return true;
    }
    function $9886d955dd3a1a8d$export$dee0ccd8d8f5a56e(type) {
        return function(state, dispatch) {
            if (!(0, (0, parcelRequire("bQFBc")).isInTable)(state)) return false;
            if (dispatch) {
                let types = (0, (0, parcelRequire("3yjNu")).tableNodeTypes)(state.schema);
                let rect = (0, (0, parcelRequire("hHsVB")).selectedRect)(state), tr = state.tr;
                let isHeaderRowEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('row', rect, types);
                let isHeaderColumnEnabled = $9886d955dd3a1a8d$export$96946e3333d0ccc6('column', rect, types);
                let isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
                let selectionStartsAt = isHeaderEnabled ? 1 : 0;
                const cellsRect = type === 'column' ? new (0, (0, parcelRequire("uOUlv")).Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, (0, parcelRequire("uOUlv")).Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
                let newType;
                if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
                else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
                else newType = types.cell;
                rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                    const cellPos = relativeCellPos + rect.tableStart;
                    const cell = tr.doc.nodeAt(cellPos);
                    if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
                });
                dispatch(tr);
            }
            return true;
        };
    }
});
parcelRegister("eOaHF", function(module, exports) {
    $parcel$export(module.exports, "PastePluginActionTypes", ()=>$25d20ac74d6a74c9$export$ad3c0356f902fd97);
    var $25d20ac74d6a74c9$export$ad3c0356f902fd97;
    (function(PastePluginActionTypes) {
        PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
        PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
        PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    })($25d20ac74d6a74c9$export$ad3c0356f902fd97 || ($25d20ac74d6a74c9$export$ad3c0356f902fd97 = {}));
});
parcelRegister("hsidY", function(module, exports) {
    $parcel$export(module.exports, "startTrackingPastedMacroPositions", ()=>$9baebe42e7629c19$export$4a47d257a3fdbe1c);
    $parcel$export(module.exports, "stopTrackingPastedMacroPositions", ()=>$9baebe42e7629c19$export$68f98dcea8e59d59);
    $parcel$export(module.exports, "upgradeTextToLists", ()=>$9baebe42e7629c19$export$df231bdf1595dd19);
    $parcel$export(module.exports, "splitParagraphs", ()=>$9baebe42e7629c19$export$f2dc3112f5c2bd10);
    var $uTDrM;
    var $7vpuQ;
    var $2RHbH;
    var $kCV8T;
    var $gZGBX;
    var $eOaHF;
    var $6eO8M;
    const $9baebe42e7629c19$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, (0, parcelRequire("6eO8M")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
                pastedMacroPositions: pastedMacroPositions
            };
        });
    const $9baebe42e7629c19$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, (0, parcelRequire("6eO8M")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
                pastedMacroPositionKeys: pastedMacroPositionKeys
            };
        });
    const $9baebe42e7629c19$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
    const $9baebe42e7629c19$var$numbers = /^\s*\d[\.\)](\s+|$)/;
    const $9baebe42e7629c19$var$isListItem = (node, schema)=>{
        return Boolean(node && node.type === schema.nodes.listItem);
    };
    const $9baebe42e7629c19$var$getListType = (node, schema)=>{
        if (!node || !node.text) return null;
        const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
        return [
            {
                node: bulletList,
                matcher: $9baebe42e7629c19$var$bullets
            },
            {
                node: orderedList,
                matcher: $9baebe42e7629c19$var$numbers
            }
        ].reduce((lastMatch, listType)=>{
            if (lastMatch) return lastMatch;
            const match = node.text.match(listType.matcher);
            return match ? [
                listType.node,
                match[0].length
            ] : lastMatch;
        }, null);
    };
    const $9baebe42e7629c19$export$252a79c29aea3669 = (content, schema)=>{
        const wrapperContent = [];
        let nextContent = [];
        content.forEach((node)=>{
            if (node.type === schema.nodes.hardBreak) {
                if (nextContent.length !== 0) wrapperContent.push(nextContent);
                nextContent = [
                    node
                ];
            } else nextContent.push(node);
        });
        wrapperContent.push(nextContent);
        return wrapperContent;
    };
    const $9baebe42e7629c19$export$5bfe14e0df30e39c = (node, parent, schema)=>{
        const content = (0, (0, parcelRequire("7vpuQ")).mapChildren)(node.content, (node)=>node);
        const linesSplitByHardbreaks = $9baebe42e7629c19$export$252a79c29aea3669(content, schema);
        const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
        const splitListsAndParagraphs = [];
        let paragraphParts = [];
        for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
            const line = linesSplitByHardbreaks[index];
            let listMatch;
            if (index === 0) {
                if (line[0]?.type === hardBreak) {
                    paragraphParts.push(line);
                    continue;
                } else listMatch = $9baebe42e7629c19$var$getListType(line[0], schema);
            } else {
                if (line.length === 1) {
                    paragraphParts.push(line);
                    continue;
                }
                listMatch = $9baebe42e7629c19$var$getListType(line[1], schema);
            }
            if (!listMatch || $9baebe42e7629c19$var$isListItem(parent, schema)) {
                paragraphParts.push(line);
                continue;
            }
            const [nodeType, length] = listMatch;
            const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
            const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
            const startingText = firstNonHardBreakNode?.text?.substr(length);
            const restOfChunk = startingText ? [
                schema.text(startingText, firstNonHardBreakNode?.marks),
                ...chunksWithoutLeadingHardBreaks.slice(1)
            ] : chunksWithoutLeadingHardBreaks.slice(1);
            const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
            if (!listItemNode) {
                paragraphParts.push(line);
                continue;
            }
            const attrs = nodeType === orderedList ? {
                order: parseInt(firstNonHardBreakNode.text.split('.')[0])
            } : undefined;
            const newList = nodeType.createChecked(attrs, [
                listItemNode
            ]);
            if (paragraphParts.length !== 0 && paragraph.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(paragraphParts.flat()))) {
                splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
                paragraphParts = [];
            }
            splitListsAndParagraphs.push(newList);
        }
        if (paragraphParts.length !== 0 && paragraph.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
        const result = splitListsAndParagraphs.flat();
        const mockState = (0, (0, parcelRequire("gZGBX")).EditorState).create({
            schema: schema
        });
        let joinedListsTr;
        const mockDispatch = (tr)=>{
            joinedListsTr = tr;
        };
        (0, (0, parcelRequire("2RHbH")).autoJoin)((state, dispatch)=>{
            if (!dispatch) return false;
            const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
            if (result.some((node)=>node.isText) && !containsList) return false;
            dispatch(state.tr.replaceWith(0, 2, result));
            return true;
        }, (before, after)=>(0, (0, parcelRequire("uTDrM")).isListNode)(before) && (0, (0, parcelRequire("uTDrM")).isListNode)(after))(mockState, mockDispatch);
        const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, (0, parcelRequire("kCV8T")).Fragment).from(result);
        return fragment;
    };
    const $9baebe42e7629c19$export$df231bdf1595dd19 = (slice, schema)=>{
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node, parent)=>{
            if (node.type === schema.nodes.paragraph) return $9baebe42e7629c19$export$5bfe14e0df30e39c(node, parent, schema);
            return node;
        });
    };
    const $9baebe42e7629c19$export$f2dc3112f5c2bd10 = (slice, schema)=>{
        let hasCodeMark = false;
        slice.content.forEach((child)=>{
            hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
        });
        if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
            const replSlice = $9baebe42e7629c19$export$b2e3d6bb71a327f1({
                fragment: slice.content,
                schema: schema
            });
            return new (0, (0, parcelRequire("kCV8T")).Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
        }
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            if (node.type === schema.nodes.paragraph) return $9baebe42e7629c19$export$b2e3d6bb71a327f1({
                fragment: node.content,
                blockMarks: node.marks,
                schema: schema
            });
            return node;
        });
    };
    const $9baebe42e7629c19$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
        const paragraphs = [];
        let curChildren = [];
        let lastNode = null;
        const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
        fragment.forEach((node, i)=>{
            const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(node));
            if (!isNodeValidContentForParagraph) {
                paragraphs.push(node);
                return;
            }
            if (i === 0 && node.type === hardBreak) {
                paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                    ...blockMarks
                ]));
                lastNode = node;
                return;
            } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
                curChildren.pop();
                paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                    ...blockMarks
                ]));
                curChildren = [];
                return;
            }
            curChildren.push(node);
            lastNode = node;
        });
        if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
            ...blockMarks
        ]));
        return (0, (0, parcelRequire("kCV8T")).Fragment).from(paragraphs.length ? paragraphs : [
            paragraph.createAndFill(undefined, undefined, [
                ...blockMarks
            ])
        ]);
    };
});
parcelRegister("6eO8M", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$79a615e374ca307c$export$18d4026d1ea86bb1);
    $parcel$export(module.exports, "createPluginState", ()=>$79a615e374ca307c$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$79a615e374ca307c$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$79a615e374ca307c$export$f05434c51e3762e);
    var $aOimD;
    var $gZGBX;
    var $e0JkE;
    const $79a615e374ca307c$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('pastePlugin');
    const { createPluginState: $79a615e374ca307c$export$656c7661095efe2e, createCommand: $79a615e374ca307c$export$8d4021544bdece00, getPluginState: $79a615e374ca307c$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)($79a615e374ca307c$export$18d4026d1ea86bb1, (0, (0, parcelRequire("e0JkE")).reducer), {
        mapping: (tr, pluginState)=>{
            if (tr.docChanged) {
                let atLeastOnePositionChanged = false;
                const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                    const mappedPosition = tr.mapping.map(position);
                    if (position !== mappedPosition) atLeastOnePositionChanged = true;
                    acc[key] = tr.mapping.map(position);
                    return acc;
                }, {});
                if (atLeastOnePositionChanged) return {
                    ...pluginState,
                    pastedMacroPositions: positionsMappedThroughChanges
                };
            }
            return pluginState;
        }
    });
});
parcelRegister("e0JkE", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$57b5791e3b4cb442$export$1650419e431d3ba3);
    var $eOaHF;
    const $57b5791e3b4cb442$export$1650419e431d3ba3 = (state, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
                return {
                    ...state,
                    pastedMacroPositions: {
                        ...state.pastedMacroPositions,
                        ...action.pastedMacroPositions
                    }
                };
            case (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
                {
                    const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                    return {
                        ...state,
                        pastedMacroPositions: filteredMacroPositions
                    };
                }
            case (0, (0, parcelRequire("eOaHF")).PastePluginActionTypes).ON_PASTE:
                return {
                    ...state,
                    lastContentPasted: action.contentPasted
                };
            default:
                return state;
        }
    };
});
parcelRegister("4wmiA", function(module, exports) {
    $parcel$export(module.exports, "handleMention", ()=>$982f291c1a3f7457$export$7097a0398467de9c);
    $parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", ()=>$982f291c1a3f7457$export$af959912bf89ae42);
    $parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", ()=>$982f291c1a3f7457$export$b8a52be876d0b84f);
    $parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", ()=>$982f291c1a3f7457$export$3fd7f6d89a9d2cac);
    $parcel$export(module.exports, "handlePasteLinkOnSelectedText", ()=>$982f291c1a3f7457$export$5e27b285bdcc71bf);
    $parcel$export(module.exports, "handlePasteAsPlainText", ()=>$982f291c1a3f7457$export$efe55f809fabb910);
    $parcel$export(module.exports, "handlePastePreservingMarks", ()=>$982f291c1a3f7457$export$de618421675f910e);
    $parcel$export(module.exports, "handleMacroAutoConvert", ()=>$982f291c1a3f7457$export$d23738992a74c3a9);
    $parcel$export(module.exports, "handleMarkdown", ()=>$982f291c1a3f7457$export$4b83e18c607f848f);
    $parcel$export(module.exports, "handleCodeBlock", ()=>$982f291c1a3f7457$export$98135102f7ccdef2);
    $parcel$export(module.exports, "handleMediaSingle", ()=>$982f291c1a3f7457$export$5fb647c5a57bac64);
    $parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", ()=>$982f291c1a3f7457$export$36e0fe2cadced224);
    $parcel$export(module.exports, "handleExpandPaste", ()=>$982f291c1a3f7457$export$a497757c6eac4530);
    $parcel$export(module.exports, "handleParagraphBlockMarks", ()=>$982f291c1a3f7457$export$feb0d61bf65d9267);
    $parcel$export(module.exports, "handleRichText", ()=>$982f291c1a3f7457$export$f9c7e15c780a77d0);
    $parcel$export(module.exports, "handlePasteIntoCaption", ()=>$982f291c1a3f7457$export$d399a86cc775ad7e);
    $parcel$export(module.exports, "handleSelectedTable", ()=>$982f291c1a3f7457$export$4ce587bb5876886d);
    var $bXrHm = parcelRequire("bXrHm");
    var $gkwXh;
    var $kxM7f;
    var $30Enc;
    var $hPjvp;
    var $dPSMN;
    var $77j9j;
    var $20Kbb;
    var $uTDrM;
    var $7vpuQ;
    var $fZzhT;
    var $kCV8T;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $4b1iw;
    var $hsidY;
    var $4shWd;
    var $cpPGs;
    var $aehLH;
    var $6eO8M;
    var $h8zVR;
    const $982f291c1a3f7457$var$insideExpand = (state)=>{
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        return (0, $5r0mK.hasParentNodeOfType)([
            expand,
            nestedExpand
        ])(state.selection);
    };
    function $982f291c1a3f7457$var$compose(func, ...funcs) {
        const allFuncs = [
            func,
            ...funcs
        ];
        return function composed(raw) {
            return allFuncs.reduceRight((memo, func)=>func(memo), raw);
        };
    }
    function $982f291c1a3f7457$export$7097a0398467de9c(slice, schema) {
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.mention?.name) {
                const mention = node.attrs;
                const newMention = {
                    ...mention,
                    text: ''
                };
                return schema.nodes.mention.create(newMention, node.content, node.marks);
            }
            return node;
        });
    }
    function $982f291c1a3f7457$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
        return (state, dispatch)=>{
            const { schema: schema, tr: { selection: selection } } = state;
            const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
            const selectionIsValidNode = state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && [
                'decisionList',
                'decisionItem',
                'taskList',
                'taskItem'
            ].includes(state.selection.node.type.name);
            const selectionHasValidParentNode = (0, $5r0mK.hasParentNodeOfType)([
                decisionItem,
                taskItem,
                panel
            ])(state.selection);
            const selectionIsCodeBlock = (0, $5r0mK.hasParentNodeOfType)([
                codeBlock
            ])(state.selection);
            const panelNode = (0, (0, parcelRequire("h8zVR")).isSelectionInsidePanel)(selection);
            const selectionIsPanel = Boolean(panelNode);
            if (selectionIsPanel && selectionIsCodeBlock) return false;
            let sliceIsInvalid = false;
            let sliceHasTask = false;
            slice.content.nodesBetween(0, slice.content.size, (node)=>{
                if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
                if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
            });
            const selectionIsTaskOrDecision = (0, $5r0mK.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
            const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
            if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
            const filters = [
                (0, (0, parcelRequire("dPSMN")).linkifyContent)(schema)
            ];
            const selectionMarks = selection.$head.marks();
            if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, (0, parcelRequire("h8zVR")).hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, (0, parcelRequire("30Enc")).anyMarkActive)(state, codeMark))) filters.push((0, (0, parcelRequire("h8zVR")).applyTextMarksToSlice)(schema, selection.$head.marks()));
            const transformedSlice = $982f291c1a3f7457$var$compose.apply(null, filters)(slice);
            const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
            const tr = (0, (0, parcelRequire("fZzhT")).closeHistory)(state.tr);
            if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, (0, parcelRequire("h8zVR")).isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, (0, parcelRequire("cpPGs")).insertSliceInsideOfPanelNodeSelected)(panelNode)({
                tr: tr,
                slice: slice
            }));
            const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
                'decisionList',
                'decisionItem',
                'taskItem',
                'taskList',
                'panel'
            ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, (0, parcelRequire("77j9j")).isInListItem)(state) || (0, (0, parcelRequire("77j9j")).isInListItem)(state) && isFirstChildTaskNode);
            const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
            if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
            else {
                const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
                if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) tr.replaceSelection(new (0, (0, parcelRequire("kCV8T")).Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
                else if ([
                    'mediaSingle'
                ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                    const parentNode = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
                    if (selectionIsPanel && parentNode && (0, (0, parcelRequire("77j9j")).isNodeEmpty)(parentNode.node)) {
                        tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                        const endPos = tr.selection.from + transformedSlice.size;
                        tr.setSelection(new (0, (0, parcelRequire("gZGBX")).TextSelection)(tr.doc.resolve(endPos)));
                    } else tr.replaceSelection(transformedSlice).scrollIntoView();
                } else {
                    if (pastingIntoExtendedPanel && isWholeContentSelected) tr.delete(selection.$from.pos, selection.$to.pos);
                    (0, $5r0mK.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                    if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                    else {
                        const nextPos = tr.doc.resolve(tr.selection.$from.end());
                        tr.setSelection(new (0, (0, parcelRequire("gZGBX")).TextSelection)(nextPos));
                    }
                }
            }
            queueCardsFromChangedTr?.(state, tr, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        };
    }
    function $982f291c1a3f7457$export$b8a52be876d0b84f(slice) {
        return (state, dispatch)=>{
            const { tr: tr } = state;
            const { selection: selection } = tr;
            const { $from: $from, $to: $to, from: from, to: to } = selection;
            const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
            const selectionParentListItemNode = (0, $5r0mK.findParentNodeOfType)(listItem)(selection);
            const selectionParentListNodeWithPos = (0, $5r0mK.findParentNodeOfType)([
                bulletList,
                orderedList
            ])(selection);
            const selectionParentListNode = selectionParentListNodeWithPos?.node;
            const sliceContent = slice.content;
            const sliceIsListItems = (0, (0, parcelRequire("uTDrM")).isListNode)(sliceContent.firstChild) && (0, (0, parcelRequire("uTDrM")).isListNode)(sliceContent.lastChild);
            let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
            slice.content.forEach((child)=>{
                if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
            });
            if (!selectionParentListItemNode || !sliceContent || (0, $5r0mK.canInsert)($from, sliceContent) || !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
            const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1;
            const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth;
            const grandParentListNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
                bulletList,
                orderedList
            ]);
            const selectionIsInNestedList = !!grandParentListNode;
            let selectedListItemHasNestedList = false;
            selectionParentListItemNode.node.content.forEach((child)=>{
                if ((0, (0, parcelRequire("uTDrM")).isListNode)(child)) selectedListItemHasNestedList = true;
            });
            if (selectedListItemHasNestedList || selectionIsInNestedList) return false;
            const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
            const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
            const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
            const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
                'taskItem',
                'taskList',
                'heading',
                'blockquote'
            ].includes(sliceContent.firstChild.type.name);
            let replaceTo;
            if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
            else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
            else replaceTo = to + listWrappingOffset;
            if (slice.content.firstChild?.type.name === 'blockquote' && (0, $5r0mK.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, (0, parcelRequire("4shWd")).insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
            else tr.replaceSelection(slice).scrollIntoView();
            const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
            if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
            const nodeAfterPastedContentResolvedPos = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
                orderedList
            ]);
            const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
            const numOfListItemsInOriginalList = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
                orderedList
            ])?.node.childCount;
            if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
                ...nodeAfterPastedContentResolvedPos.node.attrs,
                order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
            });
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    }
    const $982f291c1a3f7457$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
        const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
        if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
        const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
        const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
        if (!startOfEntireList || !endOfEntireList) return false;
        if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
        else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
        else return false;
    };
    function $982f291c1a3f7457$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
        return (state, dispatch)=>{
            const { schema: schema, tr: tr } = state;
            const { selection: selection } = tr;
            const blockNode = slice.content.firstChild;
            const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
            const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
            const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$982f291c1a3f7457$export$c2473d50cf33051b(selection, findRootParentListNode);
            if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
                'panel',
                'decisionList'
            ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        };
    }
    function $982f291c1a3f7457$export$5e27b285bdcc71bf(slice) {
        return (state, dispatch)=>{
            const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
            let linkMark;
            if (slice.content.childCount === 1 && (0, (0, parcelRequire("20Kbb")).isParagraph)(slice.content.child(0), schema)) {
                const paragraph = slice.content.child(0);
                if (paragraph.content.childCount === 1 && (0, (0, parcelRequire("20Kbb")).isText)(paragraph.content.child(0), schema)) {
                    const text = paragraph.content.child(0);
                    linkMark = text.marks.find((mark)=>(0, (0, parcelRequire("20Kbb")).isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
                }
            }
            if (linkMark && selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && !selection.empty && (0, (0, parcelRequire("dPSMN")).canLinkBeCreatedInRange)(from, to)(state)) {
                tr.addMark(from, to, linkMark);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    }
    function $982f291c1a3f7457$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
        return (state, dispatch, view)=>{
            if (!view) return false;
            const isShiftKeyPressed = view.shiftKey || view.input?.shiftKey;
            if (isShiftKeyPressed) {
                let tr = (0, (0, parcelRequire("fZzhT")).closeHistory)(state.tr);
                const { selection: selection } = tr;
                tr = (0, (0, parcelRequire("4b1iw")).replaceSelectedTable)(state, slice);
                tr = (0, (0, parcelRequire("h8zVR")).addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
                if (!tr.docChanged) tr.replaceSelection(slice);
                (state.storedMarks || []).forEach((mark)=>{
                    tr.addMark(selection.from, selection.from + slice.size, mark);
                });
                tr.scrollIntoView();
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    }
    function $982f291c1a3f7457$export$de618421675f910e(slice, queueCardsFromChangedTr) {
        return (state, dispatch)=>{
            const { schema: schema, tr: { selection: selection } } = state;
            const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
            if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return false;
            const selectionMarks = selection.$head.marks();
            if (selectionMarks.length === 0) return false;
            const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, (0, parcelRequire("30Enc")).anyMarkActive)(state, codeMark);
            const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
            const selectionIsHeading = (0, $5r0mK.hasParentNodeOfType)([
                heading
            ])(state.selection);
            if ((0, (0, parcelRequire("h8zVR")).hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
                const transformedSlice = (0, (0, parcelRequire("h8zVR")).applyTextMarksToSlice)(schema, selectionMarks)(slice);
                const tr = (0, (0, parcelRequire("fZzhT")).closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
                queueCardsFromChangedTr?.(state, tr, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    }
    async function $982f291c1a3f7457$var$getSmartLinkAdf(text, type, cardOptions) {
        if (!cardOptions.provider) throw Error('No card provider found');
        const provider = await cardOptions.provider;
        return await provider.resolve(text, type);
    }
    function $982f291c1a3f7457$var$insertAutoMacro(slice, macro, view, from, to) {
        if (view) {
            const selection = view.state.tr.selection;
            let tr;
            let before;
            if (typeof from === 'number' && typeof to === 'number') {
                tr = view.state.tr.replaceRange(from, to, slice);
                before = tr.mapping.map(from, -1);
            } else {
                tr = view.state.tr.replaceSelection(slice);
                before = tr.mapping.map(selection.from, -1);
            }
            view.dispatch(tr);
            view.dispatch((0, (0, parcelRequire("fZzhT")).closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView());
            return true;
        }
        return false;
    }
    function $982f291c1a3f7457$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
        return (state, dispatch, view)=>{
            let macro = null;
            if (extensionAutoConverter) {
                const extension = extensionAutoConverter(text);
                if (extension) macro = (0, (0, parcelRequire("kCV8T")).Node).fromJSON(state.schema, extension);
            }
            if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
            if (macro) {
                if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                    if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $982f291c1a3f7457$var$insertAutoMacro(slice, macro, view);
                    if (!view) throw new Error('View is missing');
                    const trackingId = (0, ($parcel$interopDefault($bXrHm)))();
                    const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                    const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                    (0, (0, parcelRequire("hsidY")).startTrackingPastedMacroPositions)({
                        [trackingFrom]: state.selection.from,
                        [trackingTo]: state.selection.to
                    })(state, dispatch);
                    $982f291c1a3f7457$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                        const { pastedMacroPositions: pastedMacroPositions } = (0, (0, parcelRequire("6eO8M")).getPluginState)(view.state);
                        if (dispatch) $982f291c1a3f7457$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                    }).catch(()=>{
                        const { pastedMacroPositions: pastedMacroPositions } = (0, (0, parcelRequire("6eO8M")).getPluginState)(view.state);
                        $982f291c1a3f7457$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                    }).finally(()=>{
                        (0, (0, parcelRequire("hsidY")).stopTrackingPastedMacroPositions)([
                            trackingFrom,
                            trackingTo
                        ])(view.state, dispatch);
                    });
                    return true;
                }
                return $982f291c1a3f7457$var$insertAutoMacro(slice, macro, view);
            }
            return !!macro;
        };
    }
    function $982f291c1a3f7457$export$98135102f7ccdef2(text) {
        return (state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            if (text && (0, $5r0mK.hasParentNodeOfType)(codeBlock)(state.selection)) {
                const tr = (0, (0, parcelRequire("fZzhT")).closeHistory)(state.tr);
                tr.scrollIntoView();
                if (dispatch) dispatch(tr.insertText(text));
                return true;
            }
            return false;
        };
    }
    function $982f291c1a3f7457$var$isOnlyMedia(state, slice) {
        const { media: media } = state.schema.nodes;
        return slice.content.childCount === 1 && slice.content.firstChild.type === media;
    }
    function $982f291c1a3f7457$var$isOnlyMediaSingle(state, slice) {
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        return mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle;
    }
    function $982f291c1a3f7457$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
        return function(slice) {
            return (state, dispatch, view)=>{
                if (view) {
                    if ($982f291c1a3f7457$var$isOnlyMedia(state, slice)) return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                    if ((0, (0, parcelRequire("kxM7f")).insideTable)(state) && $982f291c1a3f7457$var$isOnlyMediaSingle(state, slice)) {
                        const tr = state.tr.replaceSelection(slice);
                        const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                        if (dispatch) dispatch(tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(nextPos, (0, (0, parcelRequire("hPjvp")).Side).RIGHT)));
                        return true;
                    }
                }
                return false;
            };
        };
    }
    const $982f291c1a3f7457$var$hasTopLevelExpand = (slice)=>{
        let hasExpand = false;
        slice.content.forEach((node)=>{
            if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
        });
        return hasExpand;
    };
    function $982f291c1a3f7457$export$36e0fe2cadced224(slice) {
        return (state, dispatch)=>{
            const isInsideBodyExtension = (0, $5r0mK.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
            if (!(0, (0, parcelRequire("kxM7f")).insideTable)(state) || !isInsideBodyExtension) return false;
            const { bodiedExtension: bodiedExtension } = state.schema.nodes;
            const newSlice = (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (maybeNode)=>{
                if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                return maybeNode;
            });
            if (dispatch) {
                dispatch(state.tr.replaceSelection(newSlice));
                return true;
            }
            return false;
        };
    }
    function $982f291c1a3f7457$export$a497757c6eac4530(slice, isNestingExpandsSupported) {
        return (state, dispatch)=>{
            const isInsideNestableExpand = isNestingExpandsSupported && !!$982f291c1a3f7457$var$insideExpand(state);
            if (!(0, (0, parcelRequire("kxM7f")).insideTable)(state) && !isInsideNestableExpand || !$982f291c1a3f7457$var$hasTopLevelExpand(slice)) return false;
            const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
            let { tr: tr } = state;
            let hasExpand = false;
            const newSlice = (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (maybeNode)=>{
                if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                    hasExpand = true;
                    try {
                        return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                    } catch (e) {
                        tr = (0, $5r0mK.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                        return (0, (0, parcelRequire("kCV8T")).Fragment).empty;
                    }
                }
                return maybeNode;
            });
            if (hasExpand && dispatch) {
                if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
                else dispatch((0, $5r0mK.safeInsert)(newSlice.content)(tr));
                return true;
            }
            return false;
        };
    }
    function $982f291c1a3f7457$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
        return (state, dispatch)=>{
            const tr = (0, (0, parcelRequire("fZzhT")).closeHistory)(state.tr);
            const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
            if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
            else tr.replaceSelection(markdownSlice);
            const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(textPosition, -1));
            queueCardsFromChangedTr?.(state, tr, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        };
    }
    function $982f291c1a3f7457$var$removePrecedingBackTick(tr) {
        const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
        if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
    }
    function $982f291c1a3f7457$var$hasInlineCode(state, slice) {
        return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
    }
    function $982f291c1a3f7457$var$rollupLeafListItems(list, leafListItems) {
        list.content.forEach((child)=>{
            if ((0, (0, parcelRequire("uTDrM")).isListNode)(child) || (0, (0, parcelRequire("uTDrM")).isListItemNode)(child) && (0, (0, parcelRequire("uTDrM")).isListNode)(child.firstChild)) $982f291c1a3f7457$var$rollupLeafListItems(child, leafListItems);
            else leafListItems.push(child);
        });
    }
    function $982f291c1a3f7457$var$shouldFlattenList(state, slice) {
        const node = slice.content.firstChild;
        return node && (0, (0, parcelRequire("kxM7f")).insideTable)(state) && (0, (0, parcelRequire("uTDrM")).isListNode)(node) && slice.openStart > slice.openEnd;
    }
    function $982f291c1a3f7457$var$sliceHasTopLevelMarks(slice) {
        let hasTopLevelMarks = false;
        slice.content.descendants((node)=>{
            if (node.marks.length > 0) hasTopLevelMarks = true;
            return false;
        });
        return hasTopLevelMarks;
    }
    function $982f291c1a3f7457$var$getTopLevelMarkTypesInSlice(slice) {
        const markTypes = new Set();
        slice.content.descendants((node)=>{
            node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
            return false;
        });
        return markTypes;
    }
    function $982f291c1a3f7457$export$feb0d61bf65d9267(state, slice) {
        if (slice.content.size === 0) return slice;
        const { schema: schema, selection: { $from: $from } } = state;
        if (!$982f291c1a3f7457$var$sliceHasTopLevelMarks(slice)) return slice;
        const destinationHasContent = $from.parent.textContent.length > 0;
        if (slice.content.childCount === 1 && destinationHasContent) return slice;
        const grandparent = $from.node(Math.max(0, $from.depth - 1));
        const markTypesInSlice = $982f291c1a3f7457$var$getTopLevelMarkTypesInSlice(slice);
        let forbiddenMarkTypes = [];
        for (let markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
        if (forbiddenMarkTypes.length === 0) {
            const openStart = Math.max(0, slice.openStart - 1);
            return new (0, (0, parcelRequire("kCV8T")).Slice)(slice.content, openStart, slice.openEnd);
        }
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            if (node.type === schema.nodes.paragraph) return schema.nodes.paragraph.createChecked(undefined, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
            else if (node.type === schema.nodes.heading) return schema.nodes.heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
            return node;
        });
    }
    function $982f291c1a3f7457$export$79d83373d2946ba6(slice) {
        if (!slice.content.firstChild) return slice;
        const listToFlatten = slice.content.firstChild;
        const leafListItems = [];
        $982f291c1a3f7457$var$rollupLeafListItems(listToFlatten, leafListItems);
        const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
        return new (0, (0, parcelRequire("kCV8T")).Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
    }
    function $982f291c1a3f7457$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr, isNestingMediaOrCodeblockSupported) {
        return (state, dispatch)=>{
            const { blockquote: blockquote, codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel } = state.schema.nodes;
            const { selection: selection, schema: schema } = state;
            const firstChildOfSlice = slice.content?.firstChild;
            const lastChildOfSlice = slice.content?.lastChild;
            let tr = state.tr;
            if ($982f291c1a3f7457$var$hasInlineCode(state, slice)) $982f291c1a3f7457$var$removePrecedingBackTick(tr);
            if ($982f291c1a3f7457$var$shouldFlattenList(state, slice)) slice = $982f291c1a3f7457$export$79d83373d2946ba6(slice);
            (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            const isFirstChildListNode = (0, (0, parcelRequire("uTDrM")).isListNode)(firstChildOfSlice);
            const isLastChildListNode = (0, (0, parcelRequire("uTDrM")).isListNode)(lastChildOfSlice);
            const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
            const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
            const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
            const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
            const textNodes = [
                heading,
                paragraph
            ];
            const selectionParent = selection.$to.node(selection.$to.depth - 1);
            const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
            let panelParentOverCurrentSelection = (0, $5r0mK.findParentNodeOfType)(panel)(tr.selection);
            const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
            let sliceContainsCodeblockOrMedia = false;
            const codeBlockAndMediaNodes = [
                'codeBlock',
                'mediaSingle',
                'mediaGroup'
            ];
            slice.content.forEach((child)=>{
                if (codeBlockAndMediaNodes.includes(child.type.name)) sliceContainsCodeblockOrMedia = true;
            });
            const blockquoteNode = (0, $5r0mK.findParentNodeOfType)(blockquote)(tr.selection);
            if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, (0, parcelRequire("4shWd")).insertSliceForLists)({
                tr: tr,
                slice: slice,
                schema: schema
            });
            else if ((0, (0, parcelRequire("aehLH")).isInsideBlockQuote)(state) && sliceContainsCodeblockOrMedia && !isNestingMediaOrCodeblockSupported && blockquoteNode) tr = (0, $5r0mK.safeInsert)(slice.content, blockquoteNode.start + blockquoteNode.node.nodeSize - 1)(tr);
            else if (noNeedForSafeInsert) {
                if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                    'bulletList',
                    'orderedList',
                    'mediaSingle'
                ].includes(firstChildOfSlice?.content.firstChild?.type.name)) (0, (0, parcelRequire("4shWd")).insertSliceInsideBlockquote)({
                    tr: tr,
                    slice: slice
                });
                else {
                    tr.replaceSelection(slice);
                    const shouldUpdateCursorPosAfterPaste = [
                        'panel',
                        'nestedExpand',
                        'decisionList',
                        'codeBlock'
                    ].includes(slice.content.lastChild?.type?.name || '');
                    const lastChild = slice.content.lastChild;
                    const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                    const nextSelection = lastChild?.type.isTextblock ? (0, (0, parcelRequire("gZGBX")).TextSelection).findFrom($nextPos, -1, true) : new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($nextPos, (0, (0, parcelRequire("hPjvp")).Side).RIGHT);
                    if (nextSelection) tr.setSelection(nextSelection);
                    else if ((0, (0, parcelRequire("77j9j")).insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                        const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                        tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(nextPos, (0, (0, parcelRequire("hPjvp")).Side).RIGHT));
                    }
                }
            } else {
                let sliceHasList = false;
                slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
                    if (node.type === state.schema.nodes.listItem) {
                        sliceHasList = true;
                        return false;
                    }
                });
                if ((0, (0, parcelRequire("77j9j")).insideTableCell)(state) && (0, (0, parcelRequire("77j9j")).isInListItem)(state) && (0, $5r0mK.canInsert)(selection.$from, slice.content) && (0, $5r0mK.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
                else if ($982f291c1a3f7457$export$f0f8559835c0f076(state, slice)) (0, (0, parcelRequire("4shWd")).insertSliceForTaskInsideList)({
                    tr: tr,
                    slice: slice
                });
                else tr = (0, $5r0mK.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
            }
            tr.setStoredMarks([]);
            if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.selection.$from, 1));
            tr.scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        };
    }
    function $982f291c1a3f7457$export$d399a86cc775ad7e(slice) {
        return (state, dispatch)=>{
            const { caption: caption } = state.schema.nodes;
            const tr = state.tr;
            if ((0, $5r0mK.hasParentNodeOfType)(caption)(state.selection)) {
                tr.replaceSelection(slice).scrollIntoView();
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
    }
    const $982f291c1a3f7457$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
                let tr = (0, (0, parcelRequire("4b1iw")).replaceSelectedTable)(state, slice);
                tr = (0, (0, parcelRequire("h8zVR")).addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
                if (tr.docChanged) {
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            };
    function $982f291c1a3f7457$export$f0f8559835c0f076(state, slice) {
        return Boolean((0, (0, parcelRequire("77j9j")).isInListItem)(state) && [
            'taskList',
            'taskItem'
        ].includes(slice.content.firstChild?.type?.name || ''));
    }
});
parcelRegister("30Enc", function(module, exports) {
    $parcel$export(module.exports, "anyMarkActive", ()=>$5046559148b4fd0d$export$3d7a3b3f27c57f56);
    $parcel$export(module.exports, "isMarkAllowedInRange", ()=>$5046559148b4fd0d$export$22a8bb98a26ef60);
    $parcel$export(module.exports, "isMarkExcluded", ()=>$5046559148b4fd0d$export$87b559fec4a10a1a);
    var $hFEwm;
    const $5046559148b4fd0d$export$3d7a3b3f27c57f56 = (state, markType)=>{
        const { $from: $from, from: from, to: to, empty: empty } = state.selection;
        if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
        let rangeHasMark = false;
        if (state.selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
        });
        else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
        return rangeHasMark;
    };
    const $5046559148b4fd0d$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
            doc.nodesBetween($from.pos, $to.pos, (node)=>{
                if (can) return false;
                can = node.inlineContent && node.type.allowsMarkType(type);
                return;
            });
            if (can) return can;
        }
        return false;
    };
    const $5046559148b4fd0d$export$87b559fec4a10a1a = (type, marks)=>{
        if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
        return false;
    };
});
parcelRegister("4b1iw", function(module, exports) {
    $parcel$export(module.exports, "replaceSelectedTable", ()=>$567d91c47399f4b9$export$ea73b328547c6ad5);
    var $kCV8T;
    var $gZGBX;
    var $28MvW;
    var $cK1Lv;
    const $567d91c47399f4b9$export$ea73b328547c6ad5 = (state, content)=>{
        if ((0, (0, parcelRequire("cK1Lv")).isTableSelected)(state.selection)) {
            const table = (0, (0, parcelRequire("28MvW")).findTable)(state.selection);
            if (table) {
                const slice = typeof content === 'string' ? new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(state.schema.text(content)), 0, 0) : content;
                let tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
                tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, table.pos + slice.size + 1));
                return tr;
            }
        }
        return state.tr;
    };
});
parcelRegister("28MvW", function(module, exports) {
    $parcel$export(module.exports, "findTable", ()=>$558e59ba96522ad6$export$1ae6a0a4f7784fc4);
    $parcel$export(module.exports, "findTableClosestToPos", ()=>$558e59ba96522ad6$export$9323c80f9a3e899f);
    $parcel$export(module.exports, "findCellClosestToPos", ()=>$558e59ba96522ad6$export$3ac56532a0bf4018);
    $parcel$export(module.exports, "findCellRectClosestToPos", ()=>$558e59ba96522ad6$export$68680ae223aebfa7);
    var $5r0mK = parcelRequire("5r0mK");
    var $uOUlv;
    const $558e59ba96522ad6$export$1ae6a0a4f7784fc4 = (selection)=>(0, $5r0mK.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
    const $558e59ba96522ad6$export$9323c80f9a3e899f = ($pos)=>{
        const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
        return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
    };
    const $558e59ba96522ad6$export$3ac56532a0bf4018 = ($pos)=>{
        const predicate = (node)=>node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
        return (0, $5r0mK.findParentNodeClosestToPos)($pos, predicate);
    };
    const $558e59ba96522ad6$export$68680ae223aebfa7 = ($pos)=>{
        const cell = $558e59ba96522ad6$export$3ac56532a0bf4018($pos);
        if (cell) {
            const table = $558e59ba96522ad6$export$9323c80f9a3e899f($pos);
            if (table) {
                const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table.node);
                const cellPos = cell.pos - table.start;
                return map.rectBetween(cellPos, cellPos);
            }
        }
    };
});
parcelRegister("cK1Lv", function(module, exports) {
    $parcel$export(module.exports, "isColumnSelected", ()=>$65abce04567f614e$export$8db1cdcc0c397a6d);
    $parcel$export(module.exports, "isRowSelected", ()=>$65abce04567f614e$export$710e11cf672b86c);
    $parcel$export(module.exports, "isTableSelected", ()=>$65abce04567f614e$export$5d08de4a0eeb0408);
    var $uOUlv;
    var $iGxzn;
    const $65abce04567f614e$export$d06743a3adc2076d = (rect)=>(selection)=>{
            if (!(0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) return false;
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(selection.$anchorCell.node(-1));
            const start = selection.$anchorCell.start(-1);
            const cells = map.cellsInRect(rect);
            const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
            for(let i = 0, count = cells.length; i < count; i++){
                if (selectedCells.indexOf(cells[i]) === -1) return false;
            }
            return true;
        };
    const $65abce04567f614e$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
            if ((0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) {
                const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(selection.$anchorCell.node(-1));
                return $65abce04567f614e$export$d06743a3adc2076d({
                    left: columnIndex,
                    right: columnIndex + 1,
                    top: 0,
                    bottom: map.height
                })(selection);
            }
            return false;
        };
    const $65abce04567f614e$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
            if ((0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) {
                const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(selection.$anchorCell.node(-1));
                return $65abce04567f614e$export$d06743a3adc2076d({
                    left: 0,
                    right: map.width,
                    top: rowIndex,
                    bottom: rowIndex + 1
                })(selection);
            }
            return false;
        };
    const $65abce04567f614e$export$5d08de4a0eeb0408 = (selection)=>{
        if ((0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) {
            const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(selection.$anchorCell.node(-1));
            return $65abce04567f614e$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
});
parcelRegister("4shWd", function(module, exports) {
    $parcel$export(module.exports, "insertSliceForLists", ()=>$63a9af225319c58b$export$9beec16307c108ac);
    $parcel$export(module.exports, "insertSliceInsideBlockquote", ()=>$63a9af225319c58b$export$2dee216d0a70c94e);
    $parcel$export(module.exports, "insertSliceForTaskInsideList", ()=>$63a9af225319c58b$export$2982aac953f7c8b6);
    var $uTDrM;
    var $kCV8T;
    var $gZGBX;
    var $eS2Dn;
    var $5r0mK = parcelRequire("5r0mK");
    var $h8zVR;
    var $cpPGs;
    function $63a9af225319c58b$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { $cursor: $cursor } = selection;
        const panelNode = (0, (0, parcelRequire("h8zVR")).isSelectionInsidePanel)(selection);
        const selectionIsInsideList = $from.blockRange($to, (0, (0, parcelRequire("uTDrM")).isListNode));
        if (!$cursor && selectionIsInsideList) return (0, (0, parcelRequire("cpPGs")).insertSliceIntoRangeSelectionInsideList)({
            tr: tr,
            slice: slice
        });
        if (panelNode && (0, (0, parcelRequire("h8zVR")).isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, (0, parcelRequire("cpPGs")).insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
        if ((0, (0, parcelRequire("h8zVR")).isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, (0, parcelRequire("cpPGs")).insertSliceIntoEmptyNode)({
            tr: tr,
            slice: slice
        });
        const pastingIntoActionOrDecision = Boolean((0, $5r0mK.findParentNodeOfType)([
            schema.nodes.taskList,
            schema.nodes.decisionList
        ])(selection));
        const oneListItem = slice.content.childCount === 1 && (0, (0, parcelRequire("uTDrM")).isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
        if (!(pastingIntoActionOrDecision && oneListItem) && (0, (0, parcelRequire("h8zVR")).isCursorSelectionAtTextStartOrEnd)(selection)) return (0, (0, parcelRequire("cpPGs")).insertSliceAtNodeEdge)({
            tr: tr,
            slice: slice
        });
        tr.replaceSelection(slice);
    }
    function $63a9af225319c58b$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
        const { schema: schema } = tr.doc.type;
        tr.replaceSelection(new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
        $63a9af225319c58b$export$e57c13697a8b8195({
            tr: tr
        });
        tr.replaceSelection(slice);
    }
    function $63a9af225319c58b$export$e57c13697a8b8195({ tr: tr }) {
        const replaceStep = tr.steps[0];
        if (!(replaceStep instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep))) return tr;
        const nextPosition = tr.mapping.map(replaceStep.to);
        const nextSelection = (0, (0, parcelRequire("gZGBX")).Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
        if (nextSelection) tr.setSelection(nextSelection);
    }
    function $63a9af225319c58b$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
        const { schema: schema } = tr.doc.type;
        tr.replaceSelection(new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
        $63a9af225319c58b$export$e57c13697a8b8195({
            tr: tr
        });
        tr.replaceSelection(slice);
    }
});
parcelRegister("h8zVR", function(module, exports) {
    $parcel$export(module.exports, "isPastedFromWord", ()=>$f0bf78256d1fe361$export$6ba9f527e53e4ac1);
    $parcel$export(module.exports, "isPastedFromExcel", ()=>$f0bf78256d1fe361$export$8d0b7622c89b176c);
    $parcel$export(module.exports, "htmlContainsSingleFile", ()=>$f0bf78256d1fe361$export$41d193509f55b76e);
    $parcel$export(module.exports, "getPasteSource", ()=>$f0bf78256d1fe361$export$e45b5b7458bacd81);
    $parcel$export(module.exports, "escapeLinks", ()=>$f0bf78256d1fe361$export$8acd10161c5f8b07);
    $parcel$export(module.exports, "hasOnlyNodesOfType", ()=>$f0bf78256d1fe361$export$a4568554bf9b43cd);
    $parcel$export(module.exports, "applyTextMarksToSlice", ()=>$f0bf78256d1fe361$export$3bf611fd421c1669);
    $parcel$export(module.exports, "isEmptyNode", ()=>$f0bf78256d1fe361$export$641fdf56f693bfbc);
    $parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", ()=>$f0bf78256d1fe361$export$ee1d3ec5b3695690);
    $parcel$export(module.exports, "isSelectionInsidePanel", ()=>$f0bf78256d1fe361$export$3befc640b7d49184);
    $parcel$export(module.exports, "htmlHasInvalidLinkTags", ()=>$f0bf78256d1fe361$export$3c3a613abe5bb97d);
    $parcel$export(module.exports, "removeDuplicateInvalidLinks", ()=>$f0bf78256d1fe361$export$35ca1bb0581efaf3);
    $parcel$export(module.exports, "addReplaceSelectedTableAnalytics", ()=>$f0bf78256d1fe361$export$4f704994f6a89bd1);
    $parcel$export(module.exports, "transformUnsupportedBlockCardToInline", ()=>$f0bf78256d1fe361$export$9ffea5586131a948);
    var $gkwXh;
    var $dEzej;
    var $aZPvj;
    var $20Kbb;
    var $7vpuQ;
    var $kCV8T;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $cwe6a;
    var $cK1Lv;
    var $9KG2L;
    var $VSDnB;
    function $f0bf78256d1fe361$export$6ba9f527e53e4ac1(html) {
        return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
    }
    function $f0bf78256d1fe361$export$8d0b7622c89b176c(html) {
        return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
    }
    function $f0bf78256d1fe361$var$isPastedFromDropboxPaper(html) {
        return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
    }
    function $f0bf78256d1fe361$var$isPastedFromGoogleDocs(html) {
        return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
    }
    function $f0bf78256d1fe361$var$isPastedFromGoogleSpreadSheets(html) {
        return !!html && !!html.match(/data-sheets-.+=/gim);
    }
    function $f0bf78256d1fe361$var$isPastedFromPages(html) {
        return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
    }
    function $f0bf78256d1fe361$var$isPastedFromFabricEditor(html) {
        return !!html && html.indexOf('data-pm-slice="') >= 0;
    }
    const $f0bf78256d1fe361$export$6186a6a0af6a6a9d = (text)=>{
        return !!text && text.trim().split('\n').length === 1;
    };
    function $f0bf78256d1fe361$export$41d193509f55b76e(html) {
        return !!html.match(/<img .*>/) && !(0, (0, parcelRequire("9KG2L")).isMediaBlobUrl)(html);
    }
    function $f0bf78256d1fe361$export$e45b5b7458bacd81(event) {
        const html = event.clipboardData.getData('text/html');
        if ($f0bf78256d1fe361$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
        else if ($f0bf78256d1fe361$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
        else if ($f0bf78256d1fe361$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
        else if ($f0bf78256d1fe361$var$isPastedFromGoogleDocs(html)) return 'google-docs';
        else if ($f0bf78256d1fe361$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
        else if ($f0bf78256d1fe361$var$isPastedFromPages(html)) return 'apple-pages';
        else if ($f0bf78256d1fe361$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
        return 'uncategorized';
    }
    function $f0bf78256d1fe361$export$8acd10161c5f8b07(text) {
        return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
            return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
        });
    }
    function $f0bf78256d1fe361$export$a4568554bf9b43cd(...nodeTypes) {
        return (slice)=>{
            let hasOnlyNodesOfType = true;
            slice.content.descendants((node)=>{
                hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
                return hasOnlyNodesOfType;
            });
            return hasOnlyNodesOfType;
        };
    }
    function $f0bf78256d1fe361$export$3bf611fd421c1669(schema, marks) {
        return (slice)=>{
            const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
            if (!Array.isArray(marks) || marks.length === 0) return slice;
            const sliceCopy = (0, (0, parcelRequire("kCV8T")).Slice).fromJSON(schema, slice.toJSON() || {});
            const allowedMarksToPaste = [
                linkMark,
                annotationMark
            ];
            sliceCopy.content.descendants((node, _pos, parent)=>{
                if (node.isText && parent && parent.isBlock) {
                    node.marks = [
                        ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                        ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                    ].sort((0, (0, parcelRequire("aZPvj")).sortByOrderWithTypeName)('marks'));
                    return false;
                }
                if ((0, (0, parcelRequire("VSDnB")).fg)('editor_inline_comments_paste_insert_nodes')) {
                    if (node.isInline && [
                        'inlineCard',
                        'emoji',
                        'status',
                        'date',
                        'mention'
                    ].includes(node.type.name) && parent && parent.isBlock) node.marks = [
                        ...node.marks,
                        ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
                    ];
                }
                return true;
            });
            return sliceCopy;
        };
    }
    function $f0bf78256d1fe361$export$641fdf56f693bfbc(node) {
        if (!node) return false;
        const { type: nodeType } = node;
        const emptyNode = nodeType.createAndFill();
        return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, (0, parcelRequire("kCV8T")).Mark).sameSet(emptyNode.marks, node.marks);
    }
    function $f0bf78256d1fe361$export$ee1d3ec5b3695690(selection) {
        return selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
    }
    function $f0bf78256d1fe361$export$c7c9ca5cba02ff5a(node) {
        return Boolean(node && node.type.name === 'panel');
    }
    function $f0bf78256d1fe361$export$3befc640b7d49184(selection) {
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && $f0bf78256d1fe361$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
        const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
        const panelPosition = (0, $5r0mK.findParentNodeOfType)(panel)(selection);
        if (panelPosition) return panelPosition.node;
        return null;
    }
    const $f0bf78256d1fe361$export$3c3a613abe5bb97d = (html)=>{
        return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
    };
    const $f0bf78256d1fe361$export$35ca1bb0581efaf3 = (html)=>{
        if ($f0bf78256d1fe361$export$3c3a613abe5bb97d(html)) {
            const htmlArray = html.split(/(?=<a)/);
            const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
                return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
            });
            const fixedHtml = htmlArrayWithoutInvalidLinks.join('').replace(/<\/a><\/a>/gi, '</a>').replace(/<a>/gi, '<a');
            return fixedHtml;
        }
        return html;
    };
    const $f0bf78256d1fe361$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
        if ((0, (0, parcelRequire("cK1Lv")).isTableSelected)(state.selection)) {
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, (0, parcelRequire("cwe6a")).getSelectedTableInfo)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, (0, parcelRequire("dEzej")).TABLE_ACTION).REPLACED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
        return state.tr;
    };
    const $f0bf78256d1fe361$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
        const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
        const children = [];
        (0, (0, parcelRequire("7vpuQ")).mapChildren)(slice.content, (node, i, frag)=>{
            if (node.type === blockCard && !$f0bf78256d1fe361$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
            else children.push(node);
        });
        return new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children), slice.openStart, slice.openEnd);
    };
    const $f0bf78256d1fe361$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
        return allowBlockCards && (0, (0, parcelRequire("20Kbb")).isSupportedInParent)(state, frag);
    };
});
parcelRegister("dEzej", function(module, exports) {
    $parcel$export(module.exports, "TABLE_ACTION", ()=>$e52e9249b2889c06$export$1627223e090990cf);
    $parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", ()=>$e52e9249b2889c06$export$e0b2ad636c1c8ab4);
    $parcel$export(module.exports, "TABLE_STATUS", ()=>$e52e9249b2889c06$export$90dde066fa32cf2f);
    $parcel$export(module.exports, "TABLE_DISPLAY_MODE", ()=>$e52e9249b2889c06$export$a62a68f32aa71693);
    $parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", ()=>$e52e9249b2889c06$export$ba2dfc055a59d951);
    var $e52e9249b2889c06$export$1627223e090990cf;
    (function(TABLE_ACTION) {
        TABLE_ACTION["DELETED"] = "deleted";
        TABLE_ACTION["CLEARED"] = "cleared";
        TABLE_ACTION["COLLAPSED"] = "collapsed";
        TABLE_ACTION["MERGED"] = "merged";
        TABLE_ACTION["SPLIT"] = "split";
        TABLE_ACTION["COLORED"] = "colored";
        TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
        TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
        TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
        TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
        TABLE_ACTION["CUT"] = "cut";
        TABLE_ACTION["COPIED"] = "copied";
        TABLE_ACTION["ADDED_ROW"] = "addedRow";
        TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
        TABLE_ACTION["DELETED_ROW"] = "deletedRow";
        TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
        TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
        TABLE_ACTION["REPLACED"] = "replaced";
        TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
        TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
        TABLE_ACTION["FIXED"] = "fixed";
        TABLE_ACTION["RESIZED"] = "resized";
        TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
        TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
        TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
        TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
        TABLE_ACTION["MOVED_ROW"] = "movedRow";
        TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
        TABLE_ACTION["CLONED_ROW"] = "clonedRow";
        TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
        TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
        TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
        TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
        TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    })($e52e9249b2889c06$export$1627223e090990cf || ($e52e9249b2889c06$export$1627223e090990cf = {}));
    var $e52e9249b2889c06$export$6b0804bad09b61c6;
    (function(TABLE_BREAKOUT) {
        TABLE_BREAKOUT["WIDE"] = "wide";
        TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
        TABLE_BREAKOUT["NORMAL"] = "normal";
    })($e52e9249b2889c06$export$6b0804bad09b61c6 || ($e52e9249b2889c06$export$6b0804bad09b61c6 = {}));
    var $e52e9249b2889c06$export$e0b2ad636c1c8ab4;
    (function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
        TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
        TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
        TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
        TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
        TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
        TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
        TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
        TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    })($e52e9249b2889c06$export$e0b2ad636c1c8ab4 || ($e52e9249b2889c06$export$e0b2ad636c1c8ab4 = {}));
    var $e52e9249b2889c06$export$90dde066fa32cf2f;
    (function(TABLE_STATUS) {
        TABLE_STATUS["SUCCESS"] = "success";
        TABLE_STATUS["CANCELLED"] = "cancelled";
        TABLE_STATUS["INVALID"] = "invalid";
    })($e52e9249b2889c06$export$90dde066fa32cf2f || ($e52e9249b2889c06$export$90dde066fa32cf2f = {}));
    var $e52e9249b2889c06$export$a62a68f32aa71693;
    (function(TABLE_DISPLAY_MODE) {
        TABLE_DISPLAY_MODE["FIXED"] = "fixed";
        TABLE_DISPLAY_MODE["DEFAULT"] = "default";
        TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    })($e52e9249b2889c06$export$a62a68f32aa71693 || ($e52e9249b2889c06$export$a62a68f32aa71693 = {}));
    var $e52e9249b2889c06$export$ba2dfc055a59d951;
    (function(CHANGE_ALIGNMENT_REASON) {
        CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
        CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
        CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
        CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    })($e52e9249b2889c06$export$ba2dfc055a59d951 || ($e52e9249b2889c06$export$ba2dfc055a59d951 = {}));
});
parcelRegister("cwe6a", function(module, exports) {
    $parcel$export(module.exports, "getSelectedTableInfo", ()=>$042ffe26ab726773$export$d2cf64960b17e12e);
    $parcel$export(module.exports, "getSelectedCellInfo", ()=>$042ffe26ab726773$export$277d5394a2608229);
    var $uOUlv;
    var $28MvW;
    var $b1RTQ;
    function $042ffe26ab726773$export$d2cf64960b17e12e(selection) {
        let map;
        let totalRowCount = 0;
        let totalColumnCount = 0;
        const table = (0, (0, parcelRequire("28MvW")).findTable)(selection);
        if (table) {
            map = (0, (0, parcelRequire("uOUlv")).TableMap).get(table.node);
            totalRowCount = map.height;
            totalColumnCount = map.width;
        }
        return {
            table: table,
            map: map,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        };
    }
    function $042ffe26ab726773$export$277d5394a2608229(selection) {
        let horizontalCells = 1;
        let verticalCells = 1;
        let totalCells = 1;
        const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $042ffe26ab726773$export$d2cf64960b17e12e(selection);
        if (table && map) {
            const rect = (0, (0, parcelRequire("b1RTQ")).getSelectionRect)(selection);
            if (rect) {
                totalCells = map.cellsInRect(rect).length;
                horizontalCells = rect.right - rect.left;
                verticalCells = rect.bottom - rect.top;
            }
        }
        return {
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            horizontalCells: horizontalCells,
            verticalCells: verticalCells,
            totalCells: totalCells
        };
    }
});
parcelRegister("b1RTQ", function(module, exports) {
    $parcel$export(module.exports, "getSelectionRect", ()=>$0876234ba373a2bf$export$aa946c0ed562e2ed);
    var $uOUlv;
    var $iGxzn;
    const $0876234ba373a2bf$export$aa946c0ed562e2ed = (selection)=>{
        if (!(0, (0, parcelRequire("iGxzn")).isSelectionType)(selection, 'cell')) return;
        const start = selection.$anchorCell.start(-1);
        const map = (0, (0, parcelRequire("uOUlv")).TableMap).get(selection.$anchorCell.node(-1));
        return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
    };
});
parcelRegister("cpPGs", function(module, exports) {
    $parcel$export(module.exports, "insertSliceIntoEmptyNode", ()=>$21809703c1661cf7$export$d69afd888d46c7c);
    $parcel$export(module.exports, "insertSliceAtNodeEdge", ()=>$21809703c1661cf7$export$7b48cb097052829);
    $parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", ()=>$21809703c1661cf7$export$eee44e0848f600ea);
    $parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", ()=>$21809703c1661cf7$export$778b6ddd10a6aad3);
    parcelRequire("77j9j");
    var $594Yf;
    var $kCV8T;
    var $gZGBX;
    var $eS2Dn;
    var $5r0mK = parcelRequire("5r0mK");
    function $21809703c1661cf7$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
        tr.replaceSelection(slice);
    }
    function $21809703c1661cf7$export$7b48cb097052829({ tr: tr, slice: slice }) {
        const { selection: selection } = tr;
        const { $cursor: $cursor } = selection;
        if (!$cursor) return;
        const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
        tr.replaceRange(position, position, slice);
        const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
        const direction = -1;
        tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(startSlicePosition, direction));
    }
    function $21809703c1661cf7$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
        const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
        if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
        const newRange = $from.blockRange($to);
        if (!newRange) return;
        const startPos = from;
        const endPos = $to.nodeAfter ? to : to + 2;
        const newSlice = tr.doc.slice(endPos, newRange.end);
        tr.deleteRange(startPos, newRange.end);
        const mapped = tr.mapping.map(startPos);
        tr.replaceRange(mapped, mapped, slice);
        if (newSlice.size <= 0) return;
        const newSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
        newSlice.openEnd = newSlice.openStart;
        tr.replaceRange(newSelection.from, newSelection.from, newSlice);
        tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve(newSelection.from), -1));
    }
    function $21809703c1661cf7$export$778b6ddd10a6aad3(panelNode) {
        return ({ tr: tr, slice: slice, schema: schema })=>{
            const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
            const { from: panelPosition } = selection;
            if (panelNode && !panelNode.type.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(slice.content))) {
                let insertPosition = $to.pos + 1;
                if (schema) {
                    const mbeParentOfPanel = (0, $5r0mK.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                    if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
                }
                tr.replaceRange(insertPosition, insertPosition, slice);
                const parentNode = tr.doc.resolve($from.before()).node();
                if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(parentNode.firstChild)) {
                    const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                    const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                    const SIZE_OF_EMPTY_PARAGRAPH = 2;
                    if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
                }
                tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
                return;
            }
            const temporaryDoc = new (0, (0, parcelRequire("eS2Dn")).Transform)(tr.doc.type.createAndFill());
            temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
            const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
            const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
            const panelNodeSelected = selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) ? selection.node : null;
            const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
            const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
            tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
            tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
        };
    }
});
parcelRegister("krjcI", function(module, exports) {
    $parcel$export(module.exports, "transformSliceForMedia", ()=>$ce78aea7564d147f$export$5ed9534d355a0a0f);
    $parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", ()=>$ce78aea7564d147f$export$bd95a8dd607682c8);
    $parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", ()=>$ce78aea7564d147f$export$77944619eaa3fcd3);
    $parcel$export(module.exports, "unwrapNestedMediaElements", ()=>$ce78aea7564d147f$export$3b69af3aaae9ee54);
    var $intz5;
    var $7vpuQ;
    var $eQcNy;
    var $5r0mK = parcelRequire("5r0mK");
    var $27T0s;
    var $VSDnB;
    function $ce78aea7564d147f$export$5ed9534d355a0a0f(slice, schema) {
        const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
        return (selection)=>{
            let newSlice = slice;
            if ((0, $5r0mK.hasParentNodeOfType)([
                layoutSection,
                table,
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) newSlice = (0, (0, parcelRequire("7vpuQ")).mapSlice)(newSlice, (node)=>{
                const extendedOrLegacyAttrs = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_media_extended_resize_experience') ? {
                    layout: node.attrs.layout,
                    widthType: node.attrs.widthType,
                    width: node.attrs.width
                } : {
                    layout: node.attrs.layout
                };
                let attrs = {};
                if ((0, $5r0mK.hasParentNodeOfType)([
                    layoutSection,
                    table
                ])(selection)) attrs = {
                    ...extendedOrLegacyAttrs
                };
                else if ((0, $5r0mK.hasParentNodeOfType)([
                    bulletList,
                    orderedList,
                    expand,
                    nestedExpand
                ])(selection)) attrs = {
                    ...extendedOrLegacyAttrs,
                    layout: 'center'
                };
                return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
            });
            return newSlice;
        };
    }
    const $ce78aea7564d147f$export$fb85bc5d6d9ef19b = (fileType)=>{
        return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
    };
    const $ce78aea7564d147f$export$bd95a8dd607682c8 = (slice, schema)=>{
        const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node, parent)=>{
            if (!parent && node.type === media) {
                if (mediaSingle && ($ce78aea7564d147f$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
                else return mediaGroup.createChecked({}, [
                    node
                ]);
            }
            return node;
        });
    };
    const $ce78aea7564d147f$export$77944619eaa3fcd3 = (slice, schema)=>{
        const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
        const newSlice = (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            if (node.type === mediaSingle) return (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_media_extended_resize_experience') ? mediaSingle.createChecked({
                width: node.attrs.width || (0, (0, parcelRequire("intz5")).DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
            return node;
        });
        return (0, (0, parcelRequire("7vpuQ")).mapSlice)(newSlice, (node)=>{
            const __mediaTraceId = (0, (0, parcelRequire("27T0s")).getRandomHex)(8);
            if (node.type === media) return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
            if (node.type.name === 'mediaInline') return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
            return node;
        });
    };
    const $ce78aea7564d147f$var$isElementInvisible = (element)=>{
        return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
    };
    const $ce78aea7564d147f$var$VALID_TAGS_CONTAINER = [
        'DIV',
        'TD',
        'BLOCKQUOTE'
    ];
    function $ce78aea7564d147f$var$canContainImage(element) {
        if (!element) return false;
        return $ce78aea7564d147f$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
    }
    const $ce78aea7564d147f$export$3b69af3aaae9ee54 = (html)=>{
        const parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');
        const wrapper = doc.body;
        const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
        if (docsWrapper) (0, (0, parcelRequire("eQcNy")).unwrap)(wrapper, docsWrapper);
        const imageTags = wrapper.querySelectorAll('img');
        if (!imageTags.length) return html;
        imageTags.forEach((imageTag)=>{
            const mediaParent = imageTag.parentElement;
            if (!mediaParent) return;
            if ($ce78aea7564d147f$var$isElementInvisible(mediaParent) || $ce78aea7564d147f$var$isElementInvisible(imageTag)) {
                mediaParent.removeChild(imageTag);
                return;
            }
            if ($ce78aea7564d147f$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
            const insertBeforeElement = (0, (0, parcelRequire("eQcNy")).walkUpTreeUntil)(mediaParent, (element)=>{
                if (element.parentElement === wrapper) return true;
                return $ce78aea7564d147f$var$canContainImage(element.parentElement);
            });
            if (insertBeforeElement && insertBeforeElement.parentElement) {
                insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
                mediaParent.innerText = mediaParent.innerText.trim();
                (0, (0, parcelRequire("eQcNy")).removeNestedEmptyEls)(mediaParent);
            }
        });
        if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
        return wrapper.innerHTML;
    };
});
parcelRegister("lKATW", function(module, exports) {
    $parcel$export(module.exports, "isPastedFromTinyMCEConfluence", ()=>$a6c31ef04f4fd94b$export$4a3cccc9bf9da386);
    $parcel$export(module.exports, "htmlHasIncompleteTable", ()=>$a6c31ef04f4fd94b$export$120b137b77798e76);
    $parcel$export(module.exports, "tryRebuildCompleteTableHtml", ()=>$a6c31ef04f4fd94b$export$253f7bda9f1e0696);
    var $azYnG = parcelRequire("azYnG");
    const $a6c31ef04f4fd94b$var$isPastedFromTinyMCE = (pasteEvent)=>{
        return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
    };
    const $a6c31ef04f4fd94b$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
        return $a6c31ef04f4fd94b$var$isPastedFromTinyMCE(pasteEvent) && !!html && !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
    };
    const $a6c31ef04f4fd94b$export$4552e3fc797fc52a = (html)=>{
        const parser = new DOMParser();
        const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
        const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
        tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
            tableWrappedDoc.head.prepend(meta);
        });
        return {
            tableWrappedDoc: tableWrappedDoc,
            nonTableWrappedDoc: nonTableWrappedDoc
        };
    };
    const $a6c31ef04f4fd94b$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
    const $a6c31ef04f4fd94b$var$getTableElementsInfo = (doc)=>{
        const cellCount = doc.querySelectorAll('td').length;
        const thCount = doc.querySelectorAll('th').length;
        const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
        let hasThAfterTd = false;
        const thsAndCells = doc.querySelectorAll('th,td');
        for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
            if (cellFound && thsAndCells[i].nodeName === 'TH') {
                hasThAfterTd = true;
                break;
            }
            if (thsAndCells[i].nodeName === 'TD') cellFound = true;
        }
        const onlyTh = thCount > 0 && cellCount === 0;
        const onlyCells = cellCount > 0 && thCount === 0;
        const hasCompleteRow = onlyTh || onlyCells || ($a6c31ef04f4fd94b$var$exactlyDivisible(thCount, cellCount) || $a6c31ef04f4fd94b$var$exactlyDivisible(cellCount, thCount)) && !(thCount > 1 && cellCount === 1);
        return {
            cellCount: cellCount,
            thCount: thCount,
            mergedCellCount: mergedCellCount,
            hasThAfterTd: hasThAfterTd,
            hasIncompleteRow: !hasCompleteRow
        };
    };
    const $a6c31ef04f4fd94b$var$configureTableRows = (doc, colsInRow)=>{
        const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
        const evenlySplitChunks = (0, ($parcel$interopDefault($azYnG)))(tableHeadersAndCells, colsInRow);
        const tableBody = doc.body.querySelector('tbody');
        evenlySplitChunks.forEach((chunk)=>{
            const tr = doc.createElement('tr');
            tableBody?.append(tr);
            tr.append(...chunk);
        });
        const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
        emptyRows.forEach((row)=>row.remove());
        return doc.body.innerHTML;
    };
    const $a6c31ef04f4fd94b$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
        let extraCellsCount = 0;
        while(!$a6c31ef04f4fd94b$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
        const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
        const lastCell = doc.body.querySelector('td:last-of-type');
        lastCell?.parentElement?.append(...extraEmptyCells);
        return {
            updatedCellCount: cellCount + extraCellsCount
        };
    };
    const $a6c31ef04f4fd94b$export$d749bb0e238929f2 = (doc)=>{
        let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $a6c31ef04f4fd94b$var$getTableElementsInfo(doc);
        if (mergedCellCount || hasThAfterTd) return doc.body.innerHTML;
        if (!thCount) return $a6c31ef04f4fd94b$var$configureTableRows(doc, 1);
        if (hasIncompleteRow) {
            const { updatedCellCount: updatedCellCount } = $a6c31ef04f4fd94b$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
            cellCount = updatedCellCount;
        }
        for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
            if ($a6c31ef04f4fd94b$var$exactlyDivisible(thCount, possibleColsInRow) && $a6c31ef04f4fd94b$var$exactlyDivisible(cellCount, possibleColsInRow)) return $a6c31ef04f4fd94b$var$configureTableRows(doc, possibleColsInRow);
        }
        return doc.body.innerHTML;
    };
    const $a6c31ef04f4fd94b$export$120b137b77798e76 = (html)=>{
        return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
    };
    const $a6c31ef04f4fd94b$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
        const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $a6c31ef04f4fd94b$export$4552e3fc797fc52a(incompleteTableHtml);
        const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
        const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
        if (didPreserveTableElements && isExpectedStructure) {
            const completeTableHtml = $a6c31ef04f4fd94b$export$d749bb0e238929f2(tableWrappedDoc);
            return completeTableHtml;
        }
        return null;
    };
});
parcelRegister("hJPkr", function(module, exports) {
    $parcel$export(module.exports, "sendPasteAnalyticsEvent", ()=>$da2e92405151db04$export$5ee87eef0a304a1b);
    $parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", ()=>$da2e92405151db04$export$69d6e3902009956e);
    $parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", ()=>$da2e92405151db04$export$e3873690443e0966);
    $parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", ()=>$da2e92405151db04$export$e1d2fb186881c383);
    $parcel$export(module.exports, "handleCodeBlockWithAnalytics", ()=>$da2e92405151db04$export$9fea421173ba6d7d);
    $parcel$export(module.exports, "handleMediaSingleWithAnalytics", ()=>$da2e92405151db04$export$b49fd82cf59cd44e);
    $parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", ()=>$da2e92405151db04$export$ef36b80b79d1d973);
    $parcel$export(module.exports, "handleMarkdownWithAnalytics", ()=>$da2e92405151db04$export$d7489d309972091e);
    $parcel$export(module.exports, "handleRichTextWithAnalytics", ()=>$da2e92405151db04$export$3ef868f9e7157717);
    $parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", ()=>$da2e92405151db04$export$2d195c5439ce2ebc);
    $parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", ()=>$da2e92405151db04$export$bbc9709b7b4a2f6);
    $parcel$export(module.exports, "handleExpandWithAnalytics", ()=>$da2e92405151db04$export$6681e5bfb9c8b704);
    $parcel$export(module.exports, "handleSelectedTableWithAnalytics", ()=>$da2e92405151db04$export$6dbadac5ea22dd7a);
    $parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", ()=>$da2e92405151db04$export$b36a7c9ea20b7bbf);
    $parcel$export(module.exports, "createPasteMeasurePayload", ()=>$da2e92405151db04$export$5dd5834ba1e07721);
    $parcel$export(module.exports, "getContentNodeTypes", ()=>$da2e92405151db04$export$629ff5588e070c83);
    var $gkwXh;
    var $2yLEW;
    var $dPSMN;
    var $7vpuQ;
    var $5r0mK = parcelRequire("5r0mK");
    var $4wmiA;
    var $h8zVR;
    const $da2e92405151db04$var$contentToPasteContent = {
        url: (0, (0, parcelRequire("2yLEW")).PasteContents).url,
        paragraph: (0, (0, parcelRequire("2yLEW")).PasteContents).text,
        bulletList: (0, (0, parcelRequire("2yLEW")).PasteContents).bulletList,
        orderedList: (0, (0, parcelRequire("2yLEW")).PasteContents).orderedList,
        heading: (0, (0, parcelRequire("2yLEW")).PasteContents).heading,
        blockquote: (0, (0, parcelRequire("2yLEW")).PasteContents).blockquote,
        codeBlock: (0, (0, parcelRequire("2yLEW")).PasteContents).codeBlock,
        panel: (0, (0, parcelRequire("2yLEW")).PasteContents).panel,
        rule: (0, (0, parcelRequire("2yLEW")).PasteContents).rule,
        mediaSingle: (0, (0, parcelRequire("2yLEW")).PasteContents).mediaSingle,
        mediaCard: (0, (0, parcelRequire("2yLEW")).PasteContents).mediaCard,
        mediaGroup: (0, (0, parcelRequire("2yLEW")).PasteContents).mediaGroup,
        table: (0, (0, parcelRequire("2yLEW")).PasteContents).table,
        tableCells: (0, (0, parcelRequire("2yLEW")).PasteContents).tableCells,
        tableHeader: (0, (0, parcelRequire("2yLEW")).PasteContents).tableHeader,
        tableRow: (0, (0, parcelRequire("2yLEW")).PasteContents).tableRow,
        decisionList: (0, (0, parcelRequire("2yLEW")).PasteContents).decisionList,
        decisionItem: (0, (0, parcelRequire("2yLEW")).PasteContents).decisionItem,
        taskList: (0, (0, parcelRequire("2yLEW")).PasteContents).taskItem,
        extension: (0, (0, parcelRequire("2yLEW")).PasteContents).extension,
        bodiedExtension: (0, (0, parcelRequire("2yLEW")).PasteContents).bodiedExtension,
        blockCard: (0, (0, parcelRequire("2yLEW")).PasteContents).blockCard,
        layoutSection: (0, (0, parcelRequire("2yLEW")).PasteContents).layoutSection
    };
    const $da2e92405151db04$var$nodeToActionSubjectId = {
        blockquote: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
        blockCard: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
        bodiedExtension: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
        bulletList: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
        codeBlock: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
        decisionList: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
        extension: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_EXTENSION,
        heading: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_HEADING,
        mediaGroup: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
        mediaSingle: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
        orderedList: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
        panel: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_PANEL,
        rule: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_RULE,
        table: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_TABLE,
        tableCell: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
        tableHeader: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
        tableRow: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
        taskList: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_TASK_LIST
    };
    function $da2e92405151db04$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
        const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
        const nodeOrMarkName = new Set();
        slice.content.forEach((node)=>{
            if (node.type === paragraph && node.content.size === 0) return;
            if (node.type.name === 'text' && link.isInSet(node.marks)) {
                nodeOrMarkName.add('url');
                return;
            }
            if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
                nodeOrMarkName.add('url');
                return;
            }
            nodeOrMarkName.add(node.type.name);
        });
        if (nodeOrMarkName.size > 1) return (0, (0, parcelRequire("2yLEW")).PasteContents).mixed;
        if (nodeOrMarkName.size === 0) return (0, (0, parcelRequire("2yLEW")).PasteContents).uncategorized;
        const type = nodeOrMarkName.values().next().value;
        const pasteContent = $da2e92405151db04$var$contentToPasteContent[type];
        return pasteContent ? pasteContent : (0, (0, parcelRequire("2yLEW")).PasteContents).uncategorized;
    }
    function $da2e92405151db04$export$d26f991ad03d8827(slice) {
        let traceId;
        (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
            if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
            return node;
        });
        return traceId;
    }
    function $da2e92405151db04$var$getActionSubjectId({ selection: selection, schema: schema }) {
        const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
        const parent = (0, $5r0mK.findParentNode)((node)=>{
            if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
            return false;
        })(selection);
        if (!parent) return (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
        const parentType = parent.node.type;
        const actionSubjectId = $da2e92405151db04$var$nodeToActionSubjectId[parentType.name];
        return actionSubjectId ? actionSubjectId : (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    }
    function $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).PASTED_AS_PLAIN,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: actionSubjectId,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD,
                pasteSize: text.length,
                linksInPasteCount: linksInPasteCount
            }
        };
    }
    function $da2e92405151db04$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).PASTED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: actionSubjectId,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD,
                ...attributes
            },
            ...linkDomain && linkDomain.length > 0 ? {
                nonPrivacySafeAttributes: {
                    linkDomain: linkDomain
                }
            } : {}
        };
    }
    function $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
        return (selection)=>{
            const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
            const actionSubjectId = $da2e92405151db04$var$getActionSubjectId({
                selection: selection,
                schema: selection.$from.doc.type.schema
            });
            const pasteSize = slice.size;
            const content = $da2e92405151db04$export$234c310f1a4fffd6({
                schema: selection.$from.doc.type.schema,
                slice: slice
            });
            const linkUrls = [];
            const mediaTraceId = $da2e92405151db04$export$d26f991ad03d8827(slice);
            if (content === (0, (0, parcelRequire("2yLEW")).PasteContents).url || content === (0, (0, parcelRequire("2yLEW")).PasteContents).mixed) (0, (0, parcelRequire("7vpuQ")).mapSlice)(slice, (node)=>{
                const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
                if (linkMark) linkUrls.push(linkMark.attrs.href);
                return node;
            });
            if (pasteContext.asPlain) return $da2e92405151db04$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
            const source = (0, (0, parcelRequire("h8zVR")).getPasteSource)(event);
            const mentionIds = [];
            const mentionLocalIds = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') {
                    mentionIds.push(node.attrs.id);
                    mentionLocalIds.push(node.attrs.localId);
                }
            });
            if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
                const mentionsInserted = [];
                slice.content.descendants((node)=>{
                    if (node.type.name === 'mention') mentionsInserted.push({
                        type: 'added',
                        id: node.attrs.id,
                        localId: node.attrs.localId
                    });
                    if (node.type.name === 'taskItem') {
                        node.content.forEach((nodeContent)=>{
                            if (nodeContent.type.name === 'mention') mentionsInserted.push({
                                type: 'added',
                                localId: nodeContent.attrs.localId,
                                id: nodeContent.attrs.id,
                                taskLocalId: node.attrs.localId
                            });
                        });
                        return false;
                    }
                });
                pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
            }
            if (pasteContext.type === (0, (0, parcelRequire("2yLEW")).PasteTypes).plain) return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
                pasteSize: text.length,
                type: pasteContext.type,
                content: (0, (0, parcelRequire("2yLEW")).PasteContents).text,
                source: source,
                hyperlinkPasteOnText: false,
                linksInPasteCount: linkUrls.length,
                mentionIds: mentionIds,
                mentionLocalIds: mentionLocalIds,
                pasteSplitList: pasteContext.pasteSplitList
            });
            const linkDomains = linkUrls.map((0, (0, parcelRequire("dPSMN")).getLinkDomain));
            return $da2e92405151db04$var$createPastePayload(actionSubjectId, {
                type: pasteContext.type,
                pasteSize: pasteSize,
                content: content,
                source: source,
                hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
                linksInPasteCount: linkUrls.length,
                mediaTraceId: mediaTraceId,
                mentionIds: mentionIds,
                mentionLocalIds: mentionLocalIds,
                pasteSplitList: pasteContext.pasteSplitList
            }, linkDomains);
        };
    }
    function $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext) {
        return $da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
    }
    const $da2e92405151db04$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
            const tr = view.state.tr;
            const payload = $da2e92405151db04$export$a30e064bd28e927f(view, event, slice, pasteContext);
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
            view.dispatch(tr);
        };
    const $da2e92405151db04$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).plain,
                asPlain: true
            }))((0, (0, parcelRequire("4wmiA")).handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
    const $da2e92405151db04$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, (0, parcelRequire("4wmiA")).handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
    const $da2e92405151db04$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: type
            }))((0, (0, parcelRequire("4wmiA")).handlePasteIntoCaption)(slice));
    const $da2e92405151db04$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).plain
            }))((0, (0, parcelRequire("4wmiA")).handleCodeBlock)(text));
    const $da2e92405151db04$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: type
            }))((0, (0, parcelRequire("4wmiA")).handleMediaSingle)((0, (0, parcelRequire("gkwXh")).INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
    const $da2e92405151db04$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, (0, parcelRequire("4wmiA")).handlePastePreservingMarks)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
    const $da2e92405151db04$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, (0, parcelRequire("2yLEW")).PasteTypes).markdown
        }))((0, (0, parcelRequire("4wmiA")).handleMarkdown)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
    const $da2e92405151db04$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi, isNestingMediaOrCodeblockSupported)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText
        }, pluginInjectionApi))((0, (0, parcelRequire("4wmiA")).handleRichText)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, isNestingMediaOrCodeblockSupported));
    const $da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
            return (mainCommand)=>{
                return (state, dispatch, view)=>{
                    let originalTransaction = state.tr;
                    const fakeDispatch = (tr)=>{
                        originalTransaction = tr;
                    };
                    const result = mainCommand(state, fakeDispatch, view);
                    if (!result) return false;
                    if (dispatch && originalTransaction.docChanged) {
                        const payload = createPayloadByTransaction(state.selection);
                        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                        dispatch(originalTransaction);
                    }
                    return true;
                };
            };
        };
    const $da2e92405151db04$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText
            }))((0, (0, parcelRequire("4wmiA")).handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
    const $da2e92405151db04$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText,
                pasteSplitList: true
            }))((0, (0, parcelRequire("4wmiA")).handlePasteNonNestableBlockNodesIntoList)(slice));
    const $da2e92405151db04$export$6681e5bfb9c8b704 = (editorAnalyticsAPI, isNestingExpandsSupported)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText,
                pasteSplitList: true
            }))((0, (0, parcelRequire("4wmiA")).handleExpandPaste)(slice, isNestingExpandsSupported));
    const $da2e92405151db04$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: (0, (0, parcelRequire("2yLEW")).PasteTypes).richText
            }))((0, (0, parcelRequire("4wmiA")).handleSelectedTable)(editorAnalyticsAPI)(slice));
    const $da2e92405151db04$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$da2e92405151db04$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($da2e92405151db04$var$createPasteAnalyticsPayloadBySelection(event, slice, {
                type: type,
                hyperlinkPasteOnText: true
            }))((0, (0, parcelRequire("4wmiA")).handlePasteLinkOnSelectedText)(slice));
    const $da2e92405151db04$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
        const pasteIntoNode = $da2e92405151db04$var$getActionSubjectId({
            selection: view.state.selection,
            schema: view.state.schema
        });
        return {
            action: (0, (0, parcelRequire("gkwXh")).ACTION).PASTED_TIMED,
            actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
            attributes: {
                pasteIntoNode: pasteIntoNode,
                content: content,
                time: duration,
                distortedDuration: distortedDuration
            }
        };
    };
    const $da2e92405151db04$export$629ff5588e070c83 = (content)=>{
        let nodeTypes = new Set();
        if (content.size) content.forEach((node)=>{
            if (node.content && node.content.size) nodeTypes = new Set([
                ...nodeTypes,
                ...$da2e92405151db04$export$629ff5588e070c83(node.content)
            ]);
            nodeTypes.add(node.type.name);
        });
        return Array.from(nodeTypes);
    };
});
parcelRegister("jI1GO", function(module, exports) {
    $parcel$export(module.exports, "clipboardTextSerializer", ()=>$29f021d097812b5c$export$31d6ecfc7a959697);
    function $29f021d097812b5c$export$31d6ecfc7a959697(slice) {
        const blockSeparator = '\n\n';
        return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
            switch(leafNode.type.name){
                case 'hardBreak':
                    return '\n';
                case 'text':
                    return leafNode.text;
                case 'inlineCard':
                    return leafNode.attrs.url;
                case 'blockCard':
                    return leafNode.attrs.url;
                case 'mention':
                    return leafNode.attrs.text;
                default:
                    return leafNode.text ?? '';
            }
        });
    }
});
parcelRegister("2NfYE", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$2be0cbb83c95428b$export$ae829ec7b2625219);
    var $gkwXh;
    var $5KWxh;
    var $gmhCD = parcelRequire("gmhCD");
    var $i7Qmp;
    var $8rlPn;
    var $5k8Yv;
    var $9CaqV;
    var $h3AOq;
    const $2be0cbb83c95428b$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
        let isCutEvent = false;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("5k8Yv")).pluginKey),
            state: (0, (0, parcelRequire("8rlPn")).createPluginState)(dispatch, (0, (0, parcelRequire("9CaqV")).defaultState)),
            props: {
                handleDOMEvents: {
                    cut: ()=>{
                        isCutEvent = true;
                    }
                },
                handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                    const { contentMoved: contentMoved } = (0, (0, parcelRequire("8rlPn")).getPluginState)(state);
                    const hasCutAction = contentMoved.currentActions.includes('contentCut');
                    if (!hasCutAction) return;
                    const { content: content } = slice;
                    const nodeName = content.firstChild?.type.name;
                    if (!nodeName || !contentMoved?.nodeName || !(0, (0, parcelRequire("h3AOq")).isCursorSelectionAtTopLevel)(state.selection)) return;
                    const { tr: tr } = state;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).MOVED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).NODE,
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                        attributes: {
                            nodeType: contentMoved?.nodeName,
                            nodeDepth: contentMoved?.nodeDepth,
                            destinationNodeDepth: (0, (0, parcelRequire("h3AOq")).getParentNodeDepth)(state.selection)
                        }
                    })(tr);
                    const updatedTr = (0, (0, parcelRequire("i7Qmp")).resetContentMovedTransform)()(tr);
                    dispatch(updatedTr);
                },
                transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                    if (!isCutEvent) return slice;
                    let resetState = false;
                    const { content: content, size: size } = slice;
                    if (content.childCount !== 1) resetState = true;
                    const nodeName = content.firstChild?.type.name || '';
                    if (!resetState && (0, (0, parcelRequire("h3AOq")).isExcludedNode)(nodeName)) resetState = true;
                    const { selection: selection } = state;
                    if (!resetState && !(0, (0, parcelRequire("h3AOq")).isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, (0, parcelRequire("h3AOq")).isInlineNode)(nodeName) && (0, (0, parcelRequire("h3AOq")).isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, (0, parcelRequire("h3AOq")).isNestedInTable)(state) && (0, $gmhCD.editorExperiment)('table-nested-dnd', false)) resetState = true;
                    if (resetState) (0, (0, parcelRequire("i7Qmp")).resetContentMoved)()(state, dispatch);
                    else (0, (0, parcelRequire("i7Qmp")).updateContentMoved)({
                        size: size,
                        nodeName: nodeName,
                        nodeDepth: (0, (0, parcelRequire("h3AOq")).getParentNodeDepth)(selection)
                    }, 'contentCut')(state, dispatch);
                    isCutEvent = false;
                    return slice;
                }
            }
        });
    };
});
parcelRegister("i7Qmp", function(module, exports) {
    $parcel$export(module.exports, "updateContentMoved", ()=>$798b2c41933df7a4$export$7c2867f48317a29d);
    $parcel$export(module.exports, "resetContentMoved", ()=>$798b2c41933df7a4$export$56834735aa39d3eb);
    $parcel$export(module.exports, "resetContentMovedTransform", ()=>$798b2c41933df7a4$export$47c45651eb91dff0);
    var $f6ggO;
    var $8rlPn;
    var $5k8Yv;
    const $798b2c41933df7a4$export$7c2867f48317a29d = (nextState, nextAction)=>(0, (0, parcelRequire("8rlPn")).createCommand)((state)=>{
            const { contentMoved: contentMoved } = (0, (0, parcelRequire("8rlPn")).getPluginState)(state);
            const data = {
                currentActions: [
                    ...contentMoved.currentActions,
                    nextAction
                ],
                size: nextState?.size || contentMoved.size,
                nodeName: nextState?.nodeName,
                nodeDepth: nextState?.nodeDepth
            };
            return {
                type: (0, (0, parcelRequire("f6ggO")).MoveAnalyticPluginTypes).UpdateMovedAction,
                data: data
            };
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $798b2c41933df7a4$export$56834735aa39d3eb = ()=>(0, (0, parcelRequire("8rlPn")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("f6ggO")).MoveAnalyticPluginTypes).RemoveMovedAction
            };
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $798b2c41933df7a4$export$47c45651eb91dff0 = ()=>(tr)=>{
            const payload = {
                type: (0, (0, parcelRequire("f6ggO")).MoveAnalyticPluginTypes).RemoveMovedAction
            };
            return tr.setMeta((0, (0, parcelRequire("5k8Yv")).pluginKey), payload);
        };
});
parcelRegister("f6ggO", function(module, exports) {
    $parcel$export(module.exports, "MoveAnalyticPluginTypes", ()=>$7965858ec5e0044d$export$a5fa3822909c7e0);
    var $7965858ec5e0044d$export$a5fa3822909c7e0;
    (function(MoveAnalyticPluginTypes) {
        MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
        MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    })($7965858ec5e0044d$export$a5fa3822909c7e0 || ($7965858ec5e0044d$export$a5fa3822909c7e0 = {}));
});
parcelRegister("8rlPn", function(module, exports) {
    $parcel$export(module.exports, "createPluginState", ()=>$2081a2e3c7261c3b$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$2081a2e3c7261c3b$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$2081a2e3c7261c3b$export$f05434c51e3762e);
    var $aOimD;
    var $5k8Yv;
    var $7Pna1;
    const { createPluginState: $2081a2e3c7261c3b$export$656c7661095efe2e, createCommand: $2081a2e3c7261c3b$export$8d4021544bdece00, getPluginState: $2081a2e3c7261c3b$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("5k8Yv")).pluginKey), (0, (0, parcelRequire("7Pna1")).reducer));
});
parcelRegister("5k8Yv", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$9ce9393f2b841371$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $9ce9393f2b841371$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('moveAnalyticsPlugin');
});
parcelRegister("7Pna1", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$b034c2044beda78c$export$1650419e431d3ba3);
    var $f6ggO;
    var $9CaqV;
    const $b034c2044beda78c$export$1650419e431d3ba3 = (state, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("f6ggO")).MoveAnalyticPluginTypes).UpdateMovedAction:
                return {
                    ...state,
                    contentMoved: {
                        ...state.contentMoved,
                        ...action.data
                    }
                };
            case (0, (0, parcelRequire("f6ggO")).MoveAnalyticPluginTypes).RemoveMovedAction:
                return {
                    ...state,
                    contentMoved: (0, (0, parcelRequire("9CaqV")).defaultState).contentMoved
                };
            default:
                return state;
        }
    };
});
parcelRegister("9CaqV", function(module, exports) {
    $parcel$export(module.exports, "defaultState", ()=>$b1508633d2c50936$export$49d5fc8cba920a0);
    const $b1508633d2c50936$export$49d5fc8cba920a0 = {
        contentMoved: {
            nodeName: undefined,
            size: undefined,
            nodeDepth: undefined,
            currentActions: []
        }
    };
});
parcelRegister("h3AOq", function(module, exports) {
    $parcel$export(module.exports, "isExcludedNode", ()=>$c3f86eb485557d11$export$75248da1527ddfc1);
    $parcel$export(module.exports, "isCursorSelectionAtTopLevel", ()=>$c3f86eb485557d11$export$14f96cade94e47c);
    $parcel$export(module.exports, "isInlineNode", ()=>$c3f86eb485557d11$export$82ae59a0847ee78b);
    $parcel$export(module.exports, "isNestedInlineNode", ()=>$c3f86eb485557d11$export$8cd6af93b47990b9);
    $parcel$export(module.exports, "isNestedInTable", ()=>$c3f86eb485557d11$export$78b714f3f17d88b0);
    $parcel$export(module.exports, "getParentNodeDepth", ()=>$c3f86eb485557d11$export$568289ef11d607ce);
    $parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", ()=>$c3f86eb485557d11$export$b6cb43348b690a2d);
    var $5r0mK = parcelRequire("5r0mK");
    var $hFEwm;
    const $c3f86eb485557d11$var$excludedNodes = [
        'caption',
        'layoutColumn',
        'listItem',
        'tableHeader',
        'tableCell',
        'tableRow',
        'text',
        'placeholder',
        'unsupportedBlock',
        'unsupportedInline',
        'hardBreak',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'taskItem',
        'decisionItem'
    ];
    const $c3f86eb485557d11$export$75248da1527ddfc1 = (nodeName)=>$c3f86eb485557d11$var$excludedNodes.includes(nodeName);
    const $c3f86eb485557d11$export$14f96cade94e47c = (selection)=>{
        const { from: from, to: to, $from: $from } = selection;
        if (from !== to) return false;
        return $from.parentOffset === 0;
    };
    const $c3f86eb485557d11$var$inlineNodes = [
        'emoji',
        'date',
        'status',
        'mention',
        'mediaInline',
        'inlineCard',
        'inlineExtension'
    ];
    const $c3f86eb485557d11$export$82ae59a0847ee78b = (nodeName)=>{
        return $c3f86eb485557d11$var$inlineNodes.includes(nodeName);
    };
    const $c3f86eb485557d11$export$8cd6af93b47990b9 = (selection)=>{
        if (selection.$from.depth !== 1) return true;
        const parentSize = selection.$from.parent.content.size;
        const contentSize = selection.content().size;
        const parentChildCount = selection.$from.parent.childCount;
        if (parentChildCount === 1) return false;
        if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
        return true;
    };
    const $c3f86eb485557d11$export$78b714f3f17d88b0 = (state)=>{
        const { schema: schema, selection: selection } = state;
        if (selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) return false;
        const { table: table } = schema.nodes;
        const tableNode = (0, $5r0mK.findParentNodeOfTypeClosestToPos)(selection.$from, table);
        if (!tableNode) return false;
        return true;
    };
    const $c3f86eb485557d11$export$568289ef11d607ce = (selection)=>{
        const parentNode = (0, $5r0mK.findParentNodeClosestToPos)(selection.$from, ()=>true);
        if (!parentNode) return 0;
        return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
    };
    const $c3f86eb485557d11$export$b6cb43348b690a2d = (selection)=>{
        const { $from: $from, $to: $to } = selection;
        return $from.textOffset === 0 && $to.textOffset === 0;
    };
});
parcelRegister("7o36A", function(module, exports) {
    $parcel$export(module.exports, "placeholderPlugin", ()=>(parcelRequire("EE6bW")).placeholderPlugin);
    var $EE6bW;
});
parcelRegister("EE6bW", function(module, exports) {
    $parcel$export(module.exports, "placeholderPlugin", ()=>$40159929515e8efe$export$ecbe4cfe6671ba88);
    var $5KWxh;
    var $ggL2v;
    var $gE8f9;
    var $gZGBX;
    var $etG8M;
    const $40159929515e8efe$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('placeholderPlugin');
    function $40159929515e8efe$var$getPlaceholderState(editorState) {
        return $40159929515e8efe$export$18d4026d1ea86bb1.getState(editorState);
    }
    const $40159929515e8efe$export$53e9a5af7ff64f3e = 'placeholder-test-id';
    function $40159929515e8efe$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
        const placeholderDecoration = document.createElement('span');
        let placeholderNodeWithText = placeholderDecoration;
        placeholderDecoration.setAttribute('data-testid', $40159929515e8efe$export$53e9a5af7ff64f3e);
        placeholderDecoration.className = 'placeholder-decoration';
        if ((0, (0, parcelRequire("gE8f9")).browser).gecko) {
            const placeholderNode = document.createElement('span');
            placeholderNode.setAttribute('contenteditable', 'true');
            placeholderDecoration.appendChild(placeholderNode);
            placeholderNodeWithText = placeholderNode;
        }
        placeholderNodeWithText.textContent = placeholderText || ' ';
        if ((0, (0, parcelRequire("gE8f9")).browser).android && (0, (0, parcelRequire("gE8f9")).browser).chrome) {
            const buffNode = document.createElement('span');
            buffNode.setAttribute('class', 'placeholder-android');
            buffNode.setAttribute('contenteditable', 'true');
            buffNode.textContent = ' ';
            placeholderDecoration.appendChild(buffNode);
        }
        return (0, (0, parcelRequire("etG8M")).DecorationSet).create(editorState.doc, [
            (0, (0, parcelRequire("etG8M")).Decoration).widget(pos, placeholderDecoration, {
                side: 0,
                key: 'placeholder'
            })
        ]);
    }
    function $40159929515e8efe$var$setPlaceHolderState(placeholderText, pos) {
        return {
            hasPlaceholder: true,
            placeholderText: placeholderText,
            pos: pos ? pos : 1
        };
    }
    const $40159929515e8efe$var$emptyPlaceholder = {
        hasPlaceholder: false
    };
    function $40159929515e8efe$var$createPlaceHolderStateFrom(isEditorFocused, editorState, isTypeAheadOpen, defaultPlaceholderText, bracketPlaceholderText) {
        if (isTypeAheadOpen?.(editorState)) return $40159929515e8efe$var$emptyPlaceholder;
        if (defaultPlaceholderText && (0, (0, parcelRequire("ggL2v")).isEmptyDocument)(editorState.doc)) return $40159929515e8efe$var$setPlaceHolderState(defaultPlaceholderText);
        if (bracketPlaceholderText && (0, (0, parcelRequire("ggL2v")).bracketTyped)(editorState) && isEditorFocused) {
            const { $from: $from } = editorState.selection;
            const bracketHint = '  ' + bracketPlaceholderText;
            return $40159929515e8efe$var$setPlaceHolderState(bracketHint, $from.pos - 1);
        }
        return $40159929515e8efe$var$emptyPlaceholder;
    }
    function $40159929515e8efe$export$ae829ec7b2625219(defaultPlaceholderText, bracketPlaceholderText, api) {
        if (!defaultPlaceholderText && !bracketPlaceholderText) return;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: $40159929515e8efe$export$18d4026d1ea86bb1,
            state: {
                init: (_, state)=>$40159929515e8efe$var$createPlaceHolderStateFrom(Boolean(api?.focus?.sharedState.currentState()?.hasFocus), state, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText),
                apply: (tr, _oldPluginState, _oldEditorState, newEditorState)=>{
                    const meta = tr.getMeta($40159929515e8efe$export$18d4026d1ea86bb1);
                    const isEditorFocused = Boolean(api?.focus?.sharedState.currentState()?.hasFocus);
                    if (meta) {
                        if (meta.removePlaceholder) return $40159929515e8efe$var$emptyPlaceholder;
                        if (meta.applyPlaceholderIfEmpty) return $40159929515e8efe$var$createPlaceHolderStateFrom(isEditorFocused, newEditorState, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText);
                    }
                    return $40159929515e8efe$var$createPlaceHolderStateFrom(isEditorFocused, newEditorState, api?.typeAhead?.actions.isOpen, defaultPlaceholderText, bracketPlaceholderText);
                }
            },
            props: {
                decorations (editorState) {
                    const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos } = $40159929515e8efe$var$getPlaceholderState(editorState);
                    const compositionPluginState = api?.composition?.sharedState.currentState();
                    if (hasPlaceholder && placeholderText && pos !== undefined && !compositionPluginState?.isComposing) return $40159929515e8efe$export$980ea07f18fbfea9(editorState, placeholderText, pos);
                    return;
                }
            }
        });
    }
    const $40159929515e8efe$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>({
            name: 'placeholder',
            pmPlugins () {
                return [
                    {
                        name: 'placeholder',
                        plugin: ()=>$40159929515e8efe$export$ae829ec7b2625219(options && options.placeholder, options && options.placeholderBracketHint, api)
                    }
                ];
            }
        });
});
parcelRegister("1jBun", function(module, exports) {
    $parcel$export(module.exports, "saveOnEnterPlugin", ()=>(parcelRequire("bunIk")).saveOnEnterPlugin);
    var $bunIk;
});
parcelRegister("bunIk", function(module, exports) {
    $parcel$export(module.exports, "saveOnEnterPlugin", ()=>$d196c097205227fe$export$8ba1e5775ae443a6);
    var $gkwXh;
    var $4NUlu;
    var $vWFRY;
    function $d196c097205227fe$export$ae829ec7b2625219(eventDispatch, onSave) {
        if (!onSave) return;
        return (0, (0, parcelRequire("vWFRY")).keymap)({
            Enter (state, _dispatch, editorView) {
                if (editorView && $d196c097205227fe$var$canSaveOnEnter(editorView)) {
                    eventDispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), $d196c097205227fe$var$analyticsPayload(state));
                    onSave(editorView);
                    return true;
                }
                return false;
            }
        });
    }
    function $d196c097205227fe$var$canSaveOnEnter(editorView) {
        const { $cursor: $cursor } = editorView.state.selection;
        const { decisionItem: decisionItem, paragraph: paragraph, taskItem: taskItem } = editorView.state.schema.nodes;
        return !$cursor || $cursor.parent.type === paragraph && $cursor.depth === 1 || $cursor.parent.type === decisionItem && !$d196c097205227fe$var$isEmptyAtCursor($cursor) || $cursor.parent.type === taskItem && !$d196c097205227fe$var$isEmptyAtCursor($cursor);
    }
    function $d196c097205227fe$var$isEmptyAtCursor($cursor) {
        const { content: content } = $cursor.parent;
        return !(content && content.size);
    }
    const $d196c097205227fe$var$analyticsPayload = (state)=>({
            payload: {
                action: (0, (0, parcelRequire("gkwXh")).ACTION).STOPPED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                actionSubjectId: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT_ID).SAVE,
                attributes: {
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).SHORTCUT,
                    documentSize: state.doc.nodeSize
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            }
        });
    const $d196c097205227fe$export$8ba1e5775ae443a6 = ({ config: onSave })=>({
            name: 'saveOnEnter',
            pmPlugins () {
                return [
                    {
                        name: 'saveOnEnter',
                        plugin: ({ dispatch: dispatch })=>$d196c097205227fe$export$ae829ec7b2625219(dispatch, onSave)
                    }
                ];
            }
        });
});
parcelRegister("644sF", function(module, exports) {
    $parcel$export(module.exports, "selectionPlugin", ()=>(parcelRequire("aa15T")).selectionPlugin);
    var $aa15T;
});
parcelRegister("aa15T", function(module, exports) {
    $parcel$export(module.exports, "selectionPlugin", ()=>$7200f664c8f09c6a$export$35a6a08064a865b4);
    var $VSDnB;
    var $k2SMJ;
    var $b3cQK;
    var $9Bpzl;
    var $9fY37;
    var $M3A11;
    var $2mXvz;
    var $gZRC6;
    var $aw7z0;
    const $7200f664c8f09c6a$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
            return tr.setMeta((0, (0, parcelRequire("9fY37")).gapCursorPluginKey), {
                displayGapCursor: toggle
            });
        };
    const $7200f664c8f09c6a$export$35a6a08064a865b4 = ({ config: options })=>({
            name: 'selection',
            commands: {
                displayGapCursor: $7200f664c8f09c6a$var$displayGapCursor
            },
            actions: {
                selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                        return (0, (0, parcelRequire("k2SMJ")).selectNearNode)(selectionRelativeToNode, selection)({
                            tr: state.tr
                        }) || state.tr;
                    }
            },
            getSharedState (editorState) {
                if (!editorState) return undefined;
                const pluginState = (0, (0, parcelRequire("aw7z0")).selectionPluginKey).getState(editorState);
                return {
                    selectionRelativeToNode: pluginState?.selectionRelativeToNode,
                    selection: pluginState?.selection
                };
            },
            pmPlugins () {
                return [
                    {
                        name: 'selection',
                        plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, (0, parcelRequire("gZRC6")).createPlugin)(dispatch, dispatchAnalyticsEvent, options)
                    },
                    {
                        name: 'selectionKeymap',
                        plugin: (0, (0, parcelRequire("M3A11")).default)
                    },
                    {
                        name: 'gapCursorKeymap',
                        plugin: ()=>(0, (0, parcelRequire("b3cQK")).default)()
                    },
                    {
                        name: 'gapCursor',
                        plugin: ()=>(0, (0, parcelRequire("9Bpzl")).default)
                    },
                    ...(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_mark_boundary_cursor') ? [
                        {
                            name: 'markBoundaryCursor',
                            plugin: ()=>(0, (0, parcelRequire("2mXvz")).createMarkBoundaryCursorPlugin)()
                        }
                    ] : []
                ];
            }
        });
    var $7200f664c8f09c6a$export$2e2bcd8739ae039 = $7200f664c8f09c6a$export$35a6a08064a865b4;
});
parcelRegister("k2SMJ", function(module, exports) {
    $parcel$export(module.exports, "selectNearNode", ()=>$5b36f5b732053534$export$c7d22caae2fd3756);
    $parcel$export(module.exports, "arrowRight", ()=>$5b36f5b732053534$export$680a8d7c28b0860);
    $parcel$export(module.exports, "arrowLeft", ()=>$5b36f5b732053534$export$3ff8c533d254ed7c);
    var $3jyjs;
    parcelRequire("77j9j");
    var $594Yf;
    var $77j9j;
    var $gZGBX;
    var $5Sk2z;
    var $hPjvp;
    var $o4pF0;
    var $6MkyM;
    var $aw7z0;
    var $hSv52;
    const $5b36f5b732053534$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
            tr.setMeta((0, (0, parcelRequire("aw7z0")).selectionPluginKey), {
                type: (0, (0, parcelRequire("5Sk2z")).SelectionActionTypes).SET_RELATIVE_SELECTION,
                selectionRelativeToNode: selectionRelativeToNode
            });
            if (selection) return tr.setSelection(selection);
            return tr;
        };
    const $5b36f5b732053534$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, (0, parcelRequire("o4pF0")).createCommand)({
            type: (0, (0, parcelRequire("5Sk2z")).SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        }, (tr)=>{
            return $5b36f5b732053534$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
                tr: tr
            }) || tr;
        });
    const $5b36f5b732053534$export$680a8d7c28b0860 = (state, dispatch)=>{
        const { selection: selection } = state;
        if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) return $5b36f5b732053534$var$arrowRightFromGapCursor(selection)(state, dispatch);
        else if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return $5b36f5b732053534$var$arrowRightFromNode(selection)(state, dispatch);
        else if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) return $5b36f5b732053534$var$arrowRightFromText(selection)(state, dispatch);
        return false;
    };
    const $5b36f5b732053534$export$3ff8c533d254ed7c = (state, dispatch)=>{
        const { selection: selection } = state;
        if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) return $5b36f5b732053534$var$arrowLeftFromGapCursor(selection)(state, dispatch);
        else if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return $5b36f5b732053534$var$arrowLeftFromNode(selection)(state, dispatch);
        else if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) return $5b36f5b732053534$var$arrowLeftFromText(selection)(state, dispatch);
        return false;
    };
    const $5b36f5b732053534$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
            const { $from: $from, $to: $to, side: side } = selection;
            if (side === (0, (0, parcelRequire("hPjvp")).Side).LEFT) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerAfter)($to, state.doc);
                if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            } else if (side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT && (0, (0, parcelRequire("hSv52")).isSelectionAtEndOfParentNode)($from, selection)) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerParent)(selection);
                if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
            const { $from: $from, side: side } = selection;
            const { selectionRelativeToNode: selectionRelativeToNode } = (0, (0, parcelRequire("o4pF0")).getPluginState)(state);
            if (side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerBefore)($from, state.doc);
                if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            } else if (side === (0, (0, parcelRequire("hPjvp")).Side).LEFT && (0, (0, parcelRequire("hSv52")).isSelectionAtStartOfParentNode)($from, selection)) {
                if (selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Before) {
                    const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                    if ($parent) {
                        const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerBefore)($parent, state.doc);
                        if (selectableNode && (0, (0, parcelRequire("3jyjs")).isIgnored)(selectableNode.node)) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                    }
                    $5b36f5b732053534$export$56a7f03ce3f93e52()(state, dispatch);
                } else {
                    const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerParent)(selection);
                    if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
            }
            return false;
        };
    const $5b36f5b732053534$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
            const { node: node, from: from, $to: $to } = selection;
            const { selectionRelativeToNode: selectionRelativeToNode } = (0, (0, parcelRequire("o4pF0")).getPluginState)(state);
            if (node.isAtom) {
                if ((0, (0, parcelRequire("hSv52")).isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, (0, parcelRequire("3jyjs")).isIgnored)(node))) return $5b36f5b732053534$var$findAndSetTextSelection((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, (0, parcelRequire("aw7z0")).SelectionDirection).After)(state, dispatch);
                return false;
            } else if (selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start) return $5b36f5b732053534$var$setSelectionInsideAtNodeStart((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Inside, node, from)(state, dispatch);
            else if ((0, (0, parcelRequire("3jyjs")).isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End)) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerAfter)($to, state.doc);
                if (selectableNode && (0, (0, parcelRequire("3jyjs")).isIgnored)(selectableNode.node)) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
            const { node: node, from: from, to: to, $from: $from } = selection;
            const { selectionRelativeToNode: selectionRelativeToNode } = (0, (0, parcelRequire("o4pF0")).getPluginState)(state);
            if (node.isAtom) {
                if ((0, (0, parcelRequire("hSv52")).isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, (0, parcelRequire("3jyjs")).isIgnored)(node))) return $5b36f5b732053534$var$findAndSetTextSelection((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start, state.doc.resolve(from), (0, (0, parcelRequire("aw7z0")).SelectionDirection).Before)(state, dispatch);
                return false;
            } else if (selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End) return $5b36f5b732053534$export$7c9ae5d21795cde4((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
            else if (!selectionRelativeToNode || selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Inside) return $5b36f5b732053534$var$setSelectionInsideAtNodeStart((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Before, node, from)(state, dispatch);
            else if ((0, (0, parcelRequire("3jyjs")).isIgnored)(node) && selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerBefore)($from, state.doc);
                if (selectableNode && (0, (0, parcelRequire("3jyjs")).isIgnored)(selectableNode.node)) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
            if ((0, (0, parcelRequire("hSv52")).isSelectionAtEndOfParentNode)(selection.$to, selection)) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerParent)(selection);
                if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
            const { selectionRelativeToNode: selectionRelativeToNode } = (0, (0, parcelRequire("o4pF0")).getPluginState)(state);
            if (selectionRelativeToNode === (0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Before) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerBefore)(selection.$from, state.doc);
                if (selectableNode && (0, (0, parcelRequire("3jyjs")).isIgnored)(selectableNode.node)) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).End, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                $5b36f5b732053534$export$56a7f03ce3f93e52(undefined)(state, dispatch);
            } else if ((0, (0, parcelRequire("hSv52")).isSelectionAtStartOfParentNode)(selection.$from, selection)) {
                const selectableNode = (0, (0, parcelRequire("hSv52")).findSelectableContainerParent)(selection);
                if (selectableNode) return $5b36f5b732053534$export$56a7f03ce3f93e52((0, (0, parcelRequire("6MkyM")).RelativeSelectionPos).Start, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
            const sel = (0, (0, parcelRequire("gZGBX")).Selection).findFrom($pos, dir, true);
            if (sel) return $5b36f5b732053534$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
            return false;
        };
    const $5b36f5b732053534$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
            if ((0, (0, parcelRequire("77j9j")).isNodeEmpty)(node)) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, (0, parcelRequire("aw7z0")).SelectionDirection).After)(state, dispatch);
            const selectableNode = (0, (0, parcelRequire("hSv52")).findFirstChildNodeToSelect)(node);
            if (selectableNode) {
                const { node: childNode, pos: childPos } = selectableNode;
                const selectionPos = pos + childPos + 1;
                if (childNode.isText || childNode.isAtom && (0, (0, parcelRequire("3jyjs")).isIgnored)(childNode) || childNode.isInline) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, (0, parcelRequire("aw7z0")).SelectionDirection).Before)(state, dispatch);
                else if ((0, (0, parcelRequire("594Yf")).isEmptyParagraph)(childNode)) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, (0, parcelRequire("aw7z0")).SelectionDirection).Before)(state, dispatch);
                else if (!(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) return $5b36f5b732053534$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(state.doc.resolve(selectionPos), (0, (0, parcelRequire("hPjvp")).Side).LEFT))(state, dispatch);
                else if ((0, (0, parcelRequire("hSv52")).isSelectableContainerNode)(node)) return $5b36f5b732053534$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectionPos))(state, dispatch);
            }
            return false;
        };
    const $5b36f5b732053534$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
            if ((0, (0, parcelRequire("77j9j")).isNodeEmpty)(node)) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, (0, parcelRequire("aw7z0")).SelectionDirection).Before)(state, dispatch);
            const selectableNode = (0, (0, parcelRequire("hSv52")).findLastChildNodeToSelect)(node);
            if (selectableNode) {
                const { node: childNode, pos: childPos } = selectableNode;
                const selectionPos = from + childPos + childNode.nodeSize;
                if (childNode.isText || childNode.isAtom && (0, (0, parcelRequire("3jyjs")).isIgnored)(childNode) || childNode.isInline) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, (0, parcelRequire("aw7z0")).SelectionDirection).After)(state, dispatch);
                else if ((0, (0, parcelRequire("594Yf")).isEmptyParagraph)(childNode)) return $5b36f5b732053534$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, (0, parcelRequire("aw7z0")).SelectionDirection).After)(state, dispatch);
                else if (!(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) return $5b36f5b732053534$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, (0, parcelRequire("hPjvp")).Side).RIGHT))(state, dispatch);
                else if ((0, (0, parcelRequire("hSv52")).isSelectableContainerNode)(node)) return $5b36f5b732053534$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, (0, parcelRequire("gZGBX")).NodeSelection).create(state.doc, selectionPos))(state, dispatch);
            }
            return false;
        };
});
parcelRegister("5Sk2z", function(module, exports) {
    $parcel$export(module.exports, "SelectionActionTypes", ()=>$a4008a6be3c1fdd8$export$ab4e2275d2998c63);
    var $a4008a6be3c1fdd8$export$ab4e2275d2998c63;
    (function(SelectionActionTypes) {
        SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
        SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    })($a4008a6be3c1fdd8$export$ab4e2275d2998c63 || ($a4008a6be3c1fdd8$export$ab4e2275d2998c63 = {}));
});
parcelRegister("o4pF0", function(module, exports) {
    $parcel$export(module.exports, "createCommand", ()=>$771a7854559308b5$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$771a7854559308b5$export$f05434c51e3762e);
    $parcel$export(module.exports, "createPluginState", ()=>$771a7854559308b5$export$656c7661095efe2e);
    var $aOimD;
    var $gZGBX;
    var $etG8M;
    var $hFEwm;
    var $lDXtC;
    var $aw7z0;
    var $hSv52;
    const $771a7854559308b5$var$handleDocChanged = (tr, pluginState)=>{
        try {
            if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, (0, parcelRequire("hSv52")).getDecorations)(tr).find().length === 0)) return pluginState;
            const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        } catch (error) {
            return {
                ...pluginState,
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
            };
        }
    };
    const $771a7854559308b5$var$handleSelectionChanged = (tr, pluginState)=>{
        if ((tr.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && (0, (0, parcelRequire("hSv52")).isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) && !tr.getMeta((0, (0, parcelRequire("aw7z0")).selectionPluginKey))) return {
            ...pluginState,
            selectionRelativeToNode: undefined
        };
        return pluginState;
    };
    const { createCommand: $771a7854559308b5$export$8d4021544bdece00, getPluginState: $771a7854559308b5$export$f05434c51e3762e, createPluginState: $771a7854559308b5$export$656c7661095efe2e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("aw7z0")).selectionPluginKey), (0, (0, parcelRequire("lDXtC")).reducer), {
        onDocChanged: $771a7854559308b5$var$handleDocChanged,
        onSelectionChanged: $771a7854559308b5$var$handleSelectionChanged
    });
});
parcelRegister("lDXtC", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$66ac2f0b216710ae$export$1650419e431d3ba3);
    var $5Sk2z;
    function $66ac2f0b216710ae$export$1650419e431d3ba3(pluginState, action) {
        switch(action.type){
            case (0, (0, parcelRequire("5Sk2z")).SelectionActionTypes).SET_DECORATIONS:
                return {
                    ...pluginState,
                    decorationSet: action.decorationSet,
                    selection: action.selection
                };
            case (0, (0, parcelRequire("5Sk2z")).SelectionActionTypes).SET_RELATIVE_SELECTION:
                return {
                    ...pluginState,
                    selectionRelativeToNode: action.selectionRelativeToNode
                };
            default:
                return pluginState;
        }
    }
});
parcelRegister("aw7z0", function(module, exports) {
    $parcel$export(module.exports, "selectionPluginKey", ()=>$83e7e63b9f39ec0c$export$e530ba00b008a680);
    $parcel$export(module.exports, "SelectionDirection", ()=>$83e7e63b9f39ec0c$export$5c80dd1df5708938);
    var $6MkyM;
    var $gZGBX;
    const $83e7e63b9f39ec0c$export$e530ba00b008a680 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('selection');
    var $83e7e63b9f39ec0c$export$5c80dd1df5708938;
    (function(SelectionDirection) {
        SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
        SelectionDirection[SelectionDirection["After"] = 1] = "After";
    })($83e7e63b9f39ec0c$export$5c80dd1df5708938 || ($83e7e63b9f39ec0c$export$5c80dd1df5708938 = {}));
});
parcelRegister("hSv52", function(module, exports) {
    $parcel$export(module.exports, "getDecorations", ()=>$37b29983112f2eae$export$968abecb43309c32);
    $parcel$export(module.exports, "shouldRecalcDecorations", ()=>$37b29983112f2eae$export$8f1ae47b39045ce2);
    $parcel$export(module.exports, "isSelectableContainerNode", ()=>$37b29983112f2eae$export$be9646888fa9d884);
    $parcel$export(module.exports, "findSelectableContainerParent", ()=>$37b29983112f2eae$export$15e7624ccd1acbba);
    $parcel$export(module.exports, "findSelectableContainerBefore", ()=>$37b29983112f2eae$export$5a13616ef7dc6dd);
    $parcel$export(module.exports, "findSelectableContainerAfter", ()=>$37b29983112f2eae$export$f64170c1c72ca928);
    $parcel$export(module.exports, "findFirstChildNodeToSelect", ()=>$37b29983112f2eae$export$12f3aca2cb5b5ae9);
    $parcel$export(module.exports, "findLastChildNodeToSelect", ()=>$37b29983112f2eae$export$b5a7c30cdb2d437f);
    $parcel$export(module.exports, "isSelectionAtStartOfParentNode", ()=>$37b29983112f2eae$export$f80a5aec143de6c6);
    $parcel$export(module.exports, "isSelectionAtEndOfParentNode", ()=>$37b29983112f2eae$export$1ab0c837d3abb951);
    var $3jyjs;
    var $k6Y9i;
    parcelRequire("77j9j");
    var $594Yf;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $etG8M;
    var $iHYdz;
    var $aw7z0;
    const $37b29983112f2eae$export$968abecb43309c32 = (tr)=>{
        if (tr.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) return (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, [
            (0, (0, parcelRequire("etG8M")).Decoration).node(tr.selection.from, tr.selection.to, {
                class: (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName)
            })
        ]);
        if (tr.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) || tr.selection instanceof (0, (0, parcelRequire("gZGBX")).AllSelection)) {
            const decorations = $37b29983112f2eae$export$299033b282ee8671(tr.selection, tr.doc).map(({ node: node, pos: pos })=>{
                return (0, (0, parcelRequire("etG8M")).Decoration).node(pos, pos + node.nodeSize, {
                    class: (0, (0, parcelRequire("iHYdz")).akEditorSelectedNodeClassName)
                });
            });
            return (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, decorations);
        }
        return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
    };
    const $37b29983112f2eae$var$topLevelBlockNodesThatHaveSelectionStyles = [
        'table',
        'panel',
        'expand',
        'layoutSection',
        'decisionList',
        'decisionItem',
        'codeBlock'
    ];
    const $37b29983112f2eae$export$299033b282ee8671 = (selection, doc)=>{
        const nodes = [];
        if (selection.from !== selection.to) {
            const { from: from, to: to } = selection;
            doc.nodesBetween(from, to, (node, pos)=>{
                const withinSelection = from <= pos && pos + node.nodeSize <= to;
                const isTopLevelNodeThatHasSelectionStyles = $37b29983112f2eae$var$topLevelBlockNodesThatHaveSelectionStyles.includes(node.type.name);
                if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                    nodes.push({
                        node: node,
                        pos: pos
                    });
                    return false;
                } else if (node && withinSelection && !node.isText) nodes.push({
                    node: node,
                    pos: pos
                });
                return true;
            });
        }
        return nodes;
    };
    function $37b29983112f2eae$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
        const oldSelection = oldEditorState.selection;
        const newSelection = newEditorState.selection;
        const oldPluginState = (0, (0, parcelRequire("aw7z0")).selectionPluginKey).getState(oldEditorState);
        const newPluginState = (0, (0, parcelRequire("aw7z0")).selectionPluginKey).getState(newEditorState);
        if (!oldPluginState || !newPluginState) return false;
        if (oldSelection.eq(newSelection)) {
            if (oldSelection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && newSelection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
                const oldDecorations = oldPluginState.decorationSet.find();
                const newDecorations = newPluginState.decorationSet.find();
                if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
                return !(oldDecorations.length === 0 && newDecorations.length === 0);
            }
            return false;
        }
        if (oldSelection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && newSelection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
        return true;
    }
    const $37b29983112f2eae$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node));
    const $37b29983112f2eae$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, (0, parcelRequire("594Yf")).isEmptyParagraph)(node) || (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(node)));
    const $37b29983112f2eae$export$15e7624ccd1acbba = (selection)=>{
        let foundNodeThatSupportsGapCursor = false;
        const selectableNode = (0, $5r0mK.findParentNode)((node)=>{
            const isSelectable = $37b29983112f2eae$export$be9646888fa9d884(node);
            if (!isSelectable && !(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
            return isSelectable;
        })(selection);
        if (!foundNodeThatSupportsGapCursor) return selectableNode;
    };
    const $37b29983112f2eae$export$5a13616ef7dc6dd = ($pos, doc)=>{
        if ($pos.parent.inlineContent && $37b29983112f2eae$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
        const selectionBefore = (0, (0, parcelRequire("gZGBX")).Selection).findFrom($pos, -1);
        if (selectionBefore) {
            const $selectionBefore = doc.resolve(selectionBefore.from);
            for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
                const node = $selectionBefore.node(i);
                if ($37b29983112f2eae$export$be9646888fa9d884(node)) return {
                    node: node,
                    pos: $selectionBefore.start(i) - 1
                };
                if (i > $pos.depth + 1 && !(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) return;
            }
            if (selectionBefore instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(selectionBefore.node)) return {
                node: selectionBefore.node,
                pos: selectionBefore.from
            };
        }
    };
    const $37b29983112f2eae$export$f64170c1c72ca928 = ($pos, doc)=>{
        const selectionAfter = (0, (0, parcelRequire("gZGBX")).Selection).findFrom($pos, 1);
        if (selectionAfter) {
            const $selectionAfter = doc.resolve(selectionAfter.from);
            for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
                const node = $selectionAfter.node(i);
                if ($37b29983112f2eae$export$be9646888fa9d884(node)) return {
                    node: node,
                    pos: $selectionAfter.start(i) - 1
                };
                if (i > $pos.depth + 1 && !(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) return;
            }
        }
    };
    const $37b29983112f2eae$export$12f3aca2cb5b5ae9 = (parent)=>(0, $5r0mK.flatten)(parent).find((child)=>$37b29983112f2eae$export$e6eb31f83412b327(child.node) || !(0, (0, parcelRequire("3jyjs")).isIgnored)(child.node));
    const $37b29983112f2eae$export$b5a7c30cdb2d437f = (parent)=>{
        let child;
        parent.descendants((node, pos)=>{
            if ($37b29983112f2eae$export$e6eb31f83412b327(node) || !(0, (0, parcelRequire("3jyjs")).isIgnored)(node)) {
                child = {
                    node: node,
                    pos: pos
                };
                return false;
            }
        });
        if (child) return child;
    };
    const $37b29983112f2eae$export$f80a5aec143de6c6 = ($pos, selection)=>(0, (0, parcelRequire("k6Y9i")).isSelectionAtStartOfNode)($pos, $37b29983112f2eae$export$15e7624ccd1acbba(selection));
    const $37b29983112f2eae$export$1ab0c837d3abb951 = ($pos, selection)=>{
        const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
        if (!isAtTheEndOfCurrentLevel) return false;
        if ($pos.depth === 0 || (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
        const $after = $pos.doc.resolve($pos.after());
        return $after.parent.content.size === $after.parentOffset;
    };
});
parcelRegister("b3cQK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c3c042b0e4d7383$export$2e2bcd8739ae039);
    var $e9qoo;
    var $2RHbH;
    var $vWFRY;
    var $dOwM6;
    var $2izeO;
    var $hPjvp;
    function $1c3c042b0e4d7383$export$2e2bcd8739ae039() {
        const map = {};
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).insertNewLine).common, (state, dispatch, view)=>{
            const isInGapCursor = state.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection);
            if (!isInGapCursor) return false;
            return (0, (0, parcelRequire("2RHbH")).createParagraphNear)(state, dispatch);
        }, map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveLeft).common, (state, dispatch, view)=>{
            const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
            return (0, (0, parcelRequire("dOwM6")).arrow)((0, (0, parcelRequire("2izeO")).Direction).LEFT, endOfTextblock)(state, dispatch, view);
        }, map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveRight).common, (state, dispatch, view)=>{
            const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
            return (0, (0, parcelRequire("dOwM6")).arrow)((0, (0, parcelRequire("2izeO")).Direction).RIGHT, endOfTextblock)(state, dispatch);
        }, map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveUp).common, (state, dispatch, view)=>{
            const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
            return (0, (0, parcelRequire("dOwM6")).arrow)((0, (0, parcelRequire("2izeO")).Direction).UP, endOfTextblock)(state, dispatch);
        }, map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveDown).common, (state, dispatch, view)=>{
            const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
            return (0, (0, parcelRequire("dOwM6")).arrow)((0, (0, parcelRequire("2izeO")).Direction).DOWN, endOfTextblock)(state, dispatch);
        }, map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).backspace).common, (0, (0, parcelRequire("dOwM6")).deleteNode)((0, (0, parcelRequire("2izeO")).Direction).BACKWARD), map);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).deleteKey).common, (0, (0, parcelRequire("dOwM6")).deleteNode)((0, (0, parcelRequire("2izeO")).Direction).FORWARD), map);
        return (0, (0, parcelRequire("vWFRY")).keymap)(map);
    }
});
parcelRegister("dOwM6", function(module, exports) {
    $parcel$export(module.exports, "arrow", ()=>$c64d0f341be1ce48$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "deleteNode", ()=>$c64d0f341be1ce48$export$b05da9e94a08038f);
    var $k6Y9i;
    var $20Kbb;
    var $5or39;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $9fY37;
    var $2izeO;
    var $hPjvp;
    var $fBQbv;
    var $2xQXF;
    const $c64d0f341be1ce48$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
        const { doc: doc, schema: schema } = state;
        switch(direction){
            case (0, (0, parcelRequire("2izeO")).Direction).UP:
                if ((0, (0, parcelRequire("k6Y9i")).atTheBeginningOfDoc)(state)) return false;
                return (0, (0, parcelRequire("5or39")).isPositionNearTableRow)($pos, schema, 'before') || (0, (0, parcelRequire("fBQbv")).isTextBlockNearPos)(doc, schema, $pos, -1) || (0, (0, parcelRequire("20Kbb")).isNodeBeforeMediaNode)($pos, state);
            case (0, (0, parcelRequire("2izeO")).Direction).DOWN:
                return (0, (0, parcelRequire("k6Y9i")).atTheEndOfDoc)(state) || (0, (0, parcelRequire("fBQbv")).isTextBlockNearPos)(doc, schema, $pos, 1) || (0, (0, parcelRequire("5or39")).isPositionNearTableRow)($pos, schema, 'after') || $pos.nodeBefore?.type.name === 'text' && !$pos.nodeAfter;
            default:
                return false;
        }
    };
    function $c64d0f341be1ce48$var$shouldHandleMediaGapCursor(dir, state) {
        const { selection: selection } = state;
        const upArrowFromGapCursorIntoMedia = selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection) && dir === (0, (0, parcelRequire("2izeO")).Direction).UP && selection.$from.nodeBefore && (0, (0, parcelRequire("20Kbb")).isMediaNode)(selection.$from.nodeBefore);
        const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection) && dir === (0, (0, parcelRequire("2izeO")).Direction).DOWN && selection.$from.nodeAfter?.type.name === 'mediaGroup';
        return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
    }
    function $c64d0f341be1ce48$var$handleMediaGapCursor(dir, state) {
        const { selection: selection, tr: tr } = state;
        let $pos = (0, (0, parcelRequire("2izeO")).isBackward)(dir) ? selection.$from : selection.$to;
        if (dir === (0, (0, parcelRequire("2izeO")).Direction).UP && selection.$from.nodeBefore && (0, (0, parcelRequire("20Kbb")).isMediaNode)(selection.$from.nodeBefore)) {
            const nodeBeforePos = (0, $5r0mK.findPositionOfNodeBefore)(tr.selection);
            if (nodeBeforePos && selection.side === 'right' && tr.doc.nodeAt(nodeBeforePos)?.type.name === 'mediaSingle') tr.setSelection(new (0, (0, parcelRequire("gZGBX")).NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
            else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, (0, parcelRequire("hPjvp")).Side).LEFT)).scrollIntoView();
        }
        if (dir === (0, (0, parcelRequire("2izeO")).Direction).DOWN && selection.$from.nodeAfter) {
            const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
            if (nodeAfterPos) tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, (0, parcelRequire("hPjvp")).Side).LEFT)).scrollIntoView();
        }
        return tr;
    }
    const $c64d0f341be1ce48$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
            const { doc: doc, selection: selection, tr: tr } = state;
            let $pos = (0, (0, parcelRequire("2izeO")).isBackward)(dir) ? selection.$from : selection.$to;
            let mustMove = selection.empty;
            if (selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) {
                if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
                if ($c64d0f341be1ce48$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
                $pos = doc.resolve((0, (0, parcelRequire("2izeO")).isBackward)(dir) ? $pos.before() : $pos.after());
                mustMove = false;
            }
            if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
                if (selection.node.isInline) return false;
                if (dir === (0, (0, parcelRequire("2izeO")).Direction).UP && !(0, (0, parcelRequire("k6Y9i")).atTheBeginningOfDoc)(state) && !(0, (0, parcelRequire("20Kbb")).isNodeBeforeMediaNode)($pos, state) || dir === (0, (0, parcelRequire("2izeO")).Direction).DOWN) return false;
            }
            if ($c64d0f341be1ce48$var$shouldHandleMediaGapCursor(dir, state)) {
                const updatedTr = $c64d0f341be1ce48$var$handleMediaGapCursor(dir, state);
                if (dispatch) dispatch(updatedTr);
                return true;
            }
            if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection) && (0, (0, parcelRequire("2xQXF")).isValidTargetNode)((0, (0, parcelRequire("2izeO")).isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && ((0, (0, parcelRequire("2izeO")).isBackward)(dir) && selection.side === (0, (0, parcelRequire("hPjvp")).Side).LEFT || (0, (0, parcelRequire("2izeO")).isForward)(dir) && selection.side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT)) {
                if (dispatch) dispatch(tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($pos, selection.side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT ? (0, (0, parcelRequire("hPjvp")).Side).LEFT : (0, (0, parcelRequire("hPjvp")).Side).RIGHT)).scrollIntoView());
                return true;
            }
            if (view) {
                const domAtPos = view.domAtPos.bind(view);
                const target = (0, $5r0mK.findDomRefAtPos)($pos.pos, domAtPos);
                if (target && target.textContent === (0, $0f804702eb36dd5e$export$15a09f5ef055bcfa)) return false;
            }
            const nextSelection = (0, (0, parcelRequire("hPjvp")).GapCursorSelection).findFrom($pos, (0, (0, parcelRequire("2izeO")).isBackward)(dir) ? -1 : 1, mustMove);
            if (!nextSelection) return false;
            if (!(0, (0, parcelRequire("2xQXF")).isValidTargetNode)((0, (0, parcelRequire("2izeO")).isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
                if (dispatch) dispatch(tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(nextSelection.$from, (0, (0, parcelRequire("2izeO")).isForward)(dir) ? (0, (0, parcelRequire("hPjvp")).Side).LEFT : (0, (0, parcelRequire("hPjvp")).Side).RIGHT)).scrollIntoView());
                return true;
            }
            if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
            return true;
        };
    const $c64d0f341be1ce48$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
            if (state.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) {
                const { $from: $from, $anchor: $anchor } = state.selection;
                let { tr: tr } = state;
                if ((0, (0, parcelRequire("2izeO")).isBackward)(dir)) {
                    if (state.selection.side === 'left') {
                        tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($anchor, (0, (0, parcelRequire("hPjvp")).Side).RIGHT));
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    tr = (0, $5r0mK.removeNodeBefore)(state.tr);
                } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
                if (dispatch) dispatch(tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
                return true;
            }
            return false;
        };
    const $c64d0f341be1ce48$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
        const rect = editorRef.getBoundingClientRect();
        if (event.clientY < rect.top) return {
            position: 0,
            side: (0, (0, parcelRequire("hPjvp")).Side).LEFT
        };
        if (rect.left > 0) {
            const coords = posAtCoords({
                left: rect.left,
                top: event.clientY
            });
            if (coords && coords.inside > -1) {
                const $from = tr.doc.resolve(coords.inside);
                const start = $from.before(1);
                const side = event.clientX < rect.left ? (0, (0, parcelRequire("hPjvp")).Side).LEFT : (0, (0, parcelRequire("hPjvp")).Side).RIGHT;
                let position;
                if (side === (0, (0, parcelRequire("hPjvp")).Side).LEFT) position = start;
                else {
                    const node = tr.doc.nodeAt(start);
                    if (node) position = start + node.nodeSize;
                }
                return {
                    position: position,
                    side: side
                };
            }
        }
        return null;
    };
    const $c64d0f341be1ce48$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
        const cursorCoords = $c64d0f341be1ce48$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
        if (!cursorCoords) return;
        const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
        if ($pos === null) return;
        const isGapCursorAllowed = cursorCoords.side === (0, (0, parcelRequire("hPjvp")).Side).LEFT ? (0, (0, parcelRequire("2xQXF")).isValidTargetNode)($pos.nodeAfter) : (0, (0, parcelRequire("2xQXF")).isValidTargetNode)($pos.nodeBefore);
        if (isGapCursorAllowed && (0, (0, parcelRequire("hPjvp")).GapCursorSelection).valid($pos)) {
            if (tr.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near($pos));
            else tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($pos, cursorCoords.side));
        } else if (editorFocused === false) {
            const selectionTemp = (0, (0, parcelRequire("gZGBX")).Selection).findFrom($pos, cursorCoords.side === (0, (0, parcelRequire("hPjvp")).Side).LEFT ? 1 : -1, true);
            if (selectionTemp) tr.setSelection(selectionTemp);
        }
    };
    const $c64d0f341be1ce48$export$ddeed8e54d88a7b0 = (event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
            const { tr: tr } = state;
            $c64d0f341be1ce48$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
            if (tr.selectionSet && dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
    const $c64d0f341be1ce48$export$a3664bef63da9388 = (state)=>{
        return Boolean((0, (0, parcelRequire("9fY37")).gapCursorPluginKey).get(state));
    };
});
parcelRegister("9fY37", function(module, exports) {
    $parcel$export(module.exports, "gapCursorPluginKey", ()=>$a24c46096a74b6ea$export$21af267ac39e2110);
    var $gZGBX;
    const $a24c46096a74b6ea$export$21af267ac39e2110 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('gapCursorPlugin');
});
parcelRegister("2izeO", function(module, exports) {
    $parcel$export(module.exports, "Direction", ()=>$0d28e3ff27d12fc8$export$cacd6541cfeeb6c1);
    $parcel$export(module.exports, "isBackward", ()=>$0d28e3ff27d12fc8$export$4d894a9a195acd59);
    $parcel$export(module.exports, "isForward", ()=>$0d28e3ff27d12fc8$export$9439bc4ba99faca1);
    var $0d28e3ff27d12fc8$export$cacd6541cfeeb6c1;
    (function(Direction) {
        Direction["UP"] = "up";
        Direction["RIGHT"] = "right";
        Direction["DOWN"] = "down";
        Direction["LEFT"] = "left";
        Direction["BACKWARD"] = "backward";
        Direction["FORWARD"] = "forward";
    })($0d28e3ff27d12fc8$export$cacd6541cfeeb6c1 || ($0d28e3ff27d12fc8$export$cacd6541cfeeb6c1 = {}));
    function $0d28e3ff27d12fc8$export$4d894a9a195acd59(dir) {
        return [
            "up",
            "left",
            "backward"
        ].indexOf(dir) !== -1;
    }
    function $0d28e3ff27d12fc8$export$9439bc4ba99faca1(dir) {
        return [
            "right",
            "down",
            "forward"
        ].indexOf(dir) !== -1;
    }
});
parcelRegister("fBQbv", function(module, exports) {
    $parcel$export(module.exports, "isLeftCursor", ()=>$952a672d8e177229$export$2b745dec73894c8a);
    $parcel$export(module.exports, "isTextBlockNearPos", ()=>$952a672d8e177229$export$84353379d6171bb9);
    $parcel$export(module.exports, "getLayoutModeFromTargetNode", ()=>$952a672d8e177229$export$698eab35981fecbc);
    $parcel$export(module.exports, "isIgnoredClick", ()=>$952a672d8e177229$export$e5da7366668fb130);
    $parcel$export(module.exports, "getComputedStyleForLayoutMode", ()=>$952a672d8e177229$export$b5b7287d8577df27);
    var $intz5;
    var $6gEe5;
    var $ahG4O;
    var $hPjvp;
    const $952a672d8e177229$export$2b745dec73894c8a = (side)=>side === (0, (0, parcelRequire("hPjvp")).Side).LEFT;
    function $952a672d8e177229$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
        let $currentPos = $pos;
        let currentNode = null;
        const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
        do {
            $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
            if (!$currentPos) return null;
            currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
            if (!currentNode || currentNode.type === schema.nodes.doc) return null;
            if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
        }while ($currentPos.depth > 0)
        return null;
    }
    const $952a672d8e177229$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
        let $currentPos = $pos;
        let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
        if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
        while($currentPos.depth > 0){
            $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
            if (!$currentPos) return false;
            currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
            if (!currentNode || currentNode.type === schema.nodes.doc) return false;
            if (currentNode.isTextblock) return true;
        }
        let childNode = currentNode;
        while(childNode && childNode.firstChild){
            childNode = childNode.firstChild;
            if (childNode && (childNode.isTextblock || childNode.isText)) return true;
        }
        return false;
    };
    function $952a672d8e177229$export$698eab35981fecbc(node) {
        let layout;
        if (node.attrs.layout) layout = node.attrs.layout;
        if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
            attrs: {
                mode: ''
            }
        }).attrs.mode;
        if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
        if ([
            'wide',
            'full-width',
            'fixed-width'
        ].indexOf(layout) === -1) return '';
        return layout;
    }
    const $952a672d8e177229$export$e5da7366668fb130 = (elem)=>{
        if (elem?.nodeName === 'BUTTON' || elem?.closest('button')) return true;
        if (elem?.closest(`[data-id="${(0, (0, parcelRequire("intz5")).CAPTION_PLACEHOLDER_ID)}"]`)) return true;
        let tableWrap;
        let node = elem;
        while(node){
            if (node.className && (node.getAttribute('class') || '').indexOf((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER) > -1) {
                tableWrap = node;
                break;
            }
            node = node.parentNode;
        }
        if (tableWrap) {
            const rowControls = tableWrap.querySelector(`.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
            const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
            return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
        }
        if (elem?.closest(`.${(0, (0, parcelRequire("ahG4O")).UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
        return false;
    };
    const $952a672d8e177229$export$b5b7287d8577df27 = (dom, node, style)=>{
        if (node && node.type.name === 'table') {
            const tableContainer = dom.querySelector('.pm-table-container');
            if (tableContainer) return window.getComputedStyle(tableContainer);
        }
        return style;
    };
});
parcelRegister("9Bpzl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b07c7e10d06e629$export$2e2bcd8739ae039);
    var $5KWxh;
    var $hPjvp;
    var $eAVGd;
    var $5Vvw4;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $etG8M;
    var $hFEwm;
    var $dOwM6;
    var $2izeO;
    var $fBQbv;
    var $iv9mp;
    var $9fY37;
    const $9b07c7e10d06e629$var$plugin = new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
        key: (0, (0, parcelRequire("9fY37")).gapCursorPluginKey),
        state: {
            init: ()=>({
                    selectionIsGapCursor: false,
                    displayGapCursor: true
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const meta = tr.getMeta((0, (0, parcelRequire("9fY37")).gapCursorPluginKey));
                const selectionIsGapCursor = newState.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection);
                return {
                    selectionIsGapCursor: selectionIsGapCursor,
                    displayGapCursor: selectionIsGapCursor ? meta?.displayGapCursor ?? pluginState.displayGapCursor : true
                };
            }
        },
        view: (view)=>{
            if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) window.requestAnimationFrame(()=>{
                view.dispatch(view.state.tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(view.state.doc.resolve(0), (0, (0, parcelRequire("hPjvp")).Side).LEFT)));
            });
            return {
                update (view) {
                    const { selectionIsGapCursor: selectionIsGapCursor } = (0, (0, parcelRequire("9fY37")).gapCursorPluginKey).getState(view.state);
                    view.dom.classList.toggle((0, (0, parcelRequire("eAVGd")).hideCaretModifier), selectionIsGapCursor);
                }
            };
        },
        props: {
            decorations: (editorState)=>{
                const { doc: doc, selection: selection } = editorState;
                const { displayGapCursor: displayGapCursor } = (0, (0, parcelRequire("9fY37")).gapCursorPluginKey).getState(editorState);
                if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection) && displayGapCursor) {
                    const { $from: $from, side: side } = selection;
                    let position = selection.head;
                    const isRightCursor = side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT;
                    if (isRightCursor && $from.nodeBefore) {
                        const nodeBeforeStart = (0, $5r0mK.findPositionOfNodeBefore)(selection);
                        if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                    }
                    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                    const layoutMode = node && (0, (0, parcelRequire("fBQbv")).getLayoutModeFromTargetNode)(node);
                    return (0, (0, parcelRequire("etG8M")).DecorationSet).create(doc, [
                        (0, (0, parcelRequire("etG8M")).Decoration).widget(position, (0, (0, parcelRequire("iv9mp")).toDOM), {
                            key: `${(0, (0, parcelRequire("hPjvp")).JSON_ID)}-${side}-${layoutMode}`,
                            side: layoutMode ? -1 : 0
                        })
                    ]);
                }
                return null;
            },
            createSelectionBetween (view, $anchor, $head) {
                if (view && view.state && view.state.selection instanceof (0, (0, parcelRequire("hFEwm")).CellSelection)) return null;
                if ($anchor.pos === $head.pos && (0, (0, parcelRequire("hPjvp")).GapCursorSelection).valid($head)) return new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)($head);
                return null;
            },
            handleClick (view, nodePos, event) {
                const posAtCoords = view.posAtCoords({
                    left: event.clientX,
                    top: event.clientY
                });
                if (!posAtCoords || (0, (0, parcelRequire("fBQbv")).isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
                const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
                if (isInsideTheTarget) return false;
                const leftSideOffsetX = 20;
                const side = event.offsetX > leftSideOffsetX ? (0, (0, parcelRequire("hPjvp")).Side).RIGHT : (0, (0, parcelRequire("hPjvp")).Side).LEFT;
                const $pos = view.state.doc.resolve(nodePos);
                if ($pos.parent?.type.name === 'mediaSingle') {
                    const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                    if ($insidePos.depth <= 1) return false;
                    const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                    return (0, (0, parcelRequire("5Vvw4")).setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
                }
                const docSize = view.state.doc.content.size;
                const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
                if (nodeInside?.isAtom) return false;
                return (0, (0, parcelRequire("5Vvw4")).setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
            },
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) {
                        event.preventDefault();
                        return (0, (0, parcelRequire("dOwM6")).deleteNode)((0, (0, parcelRequire("2izeO")).Direction).BACKWARD)(view.state, view.dispatch);
                    }
                    return false;
                }
            }
        }
    });
    var $9b07c7e10d06e629$export$2e2bcd8739ae039 = $9b07c7e10d06e629$var$plugin;
});
parcelRegister("iv9mp", function(module, exports) {
    $parcel$export(module.exports, "toDOM", ()=>$ba3c3b4adbf1ec6a$export$289411c5a7970646);
    var $hPjvp;
    var $fBQbv;
    const $ba3c3b4adbf1ec6a$var$nestedCases = {
        'tableView-content-wrap': 'table',
        'mediaSingleView-content-wrap': '.rich-media-item',
        'bodiedExtensionView-content-wrap': '.extension-container',
        'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
        'embedCardView-content-wrap': '.rich-media-item',
        'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
    };
    const $ba3c3b4adbf1ec6a$var$computeNestedStyle = (dom)=>{
        const foundKey = Object.keys($ba3c3b4adbf1ec6a$var$nestedCases).find((className)=>dom.classList.contains(className));
        const nestedSelector = foundKey && $ba3c3b4adbf1ec6a$var$nestedCases[foundKey];
        if (nestedSelector) {
            const nestedElement = dom.querySelector(nestedSelector);
            if (nestedElement) return window.getComputedStyle(nestedElement);
        }
    };
    const $ba3c3b4adbf1ec6a$var$measureHeight = (style)=>{
        return $ba3c3b4adbf1ec6a$var$measureValue(style, [
            'height',
            'padding-top',
            'padding-bottom',
            'border-top-width',
            'border-bottom-width'
        ]);
    };
    const $ba3c3b4adbf1ec6a$var$measureWidth = (style)=>{
        return $ba3c3b4adbf1ec6a$var$measureValue(style, [
            'width',
            'padding-left',
            'padding-right',
            'border-left-width',
            'border-right-width'
        ]);
    };
    const $ba3c3b4adbf1ec6a$var$measureValue = (style, measureValues)=>{
        const [base, ...contentBoxValues] = measureValues;
        const measures = [
            style.getPropertyValue(base)
        ];
        const boxSizing = style.getPropertyValue('box-sizing');
        if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
            measures.push(style.getPropertyValue(value));
        });
        let result = 0;
        for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
        return result;
    };
    const $ba3c3b4adbf1ec6a$var$mutateElementStyle = (element, style, side)=>{
        element.style.transform = style.getPropertyValue('transform');
        if ((0, (0, parcelRequire("fBQbv")).isLeftCursor)(side)) {
            element.style.width = style.getPropertyValue('width');
            element.style.marginLeft = style.getPropertyValue('margin-left');
        } else {
            const marginRight = parseFloat(style.getPropertyValue('margin-right'));
            if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
            else element.style.paddingRight = `${Math.abs(marginRight)}px`;
        }
    };
    const $ba3c3b4adbf1ec6a$export$289411c5a7970646 = (view, getPos)=>{
        const selection = view.state.selection;
        const { $from: $from, side: side } = selection;
        const isRightCursor = side === (0, (0, parcelRequire("hPjvp")).Side).RIGHT;
        const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
        const nodeStart = getPos();
        const dom = view.nodeDOM(nodeStart);
        const element = document.createElement('span');
        element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
        element.appendChild(document.createElement('span'));
        if (dom instanceof HTMLElement && element.firstChild) {
            const style = $ba3c3b4adbf1ec6a$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
            const gapCursor = element.firstChild;
            gapCursor.style.height = `${$ba3c3b4adbf1ec6a$var$measureHeight(style)}px`;
            const layoutMode = node && (0, (0, parcelRequire("fBQbv")).getLayoutModeFromTargetNode)(node);
            if (nodeStart !== 0 || layoutMode || node?.type.name === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
            if (layoutMode) {
                gapCursor.setAttribute('layout', layoutMode);
                const breakoutModeStyle = (0, (0, parcelRequire("fBQbv")).getComputedStyleForLayoutMode)(dom, node, style);
                gapCursor.style.width = `${$ba3c3b4adbf1ec6a$var$measureWidth(breakoutModeStyle)}px`;
            } else $ba3c3b4adbf1ec6a$var$mutateElementStyle(gapCursor, style, selection.side);
        }
        return element;
    };
});
parcelRegister("M3A11", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4f270e126345bfd$export$2e2bcd8739ae039);
    var $e9qoo;
    var $vWFRY;
    var $k2SMJ;
    function $b4f270e126345bfd$var$keymapPlugin() {
        const list = {};
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveRight).common, (0, (0, parcelRequire("k2SMJ")).arrowRight), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).moveLeft).common, (0, (0, parcelRequire("k2SMJ")).arrowLeft), list);
        return (0, (0, parcelRequire("vWFRY")).keymap)(list);
    }
    var $b4f270e126345bfd$export$2e2bcd8739ae039 = $b4f270e126345bfd$var$keymapPlugin;
});
parcelRegister("2mXvz", function(module, exports) {
    $parcel$export(module.exports, "createMarkBoundaryCursorPlugin", ()=>$d5a435a6cf57495c$export$d3a8cfe12ba42d22);
    var $5KWxh;
    var $etG8M;
    var $42zTf;
    var $g2L0Q;
    var $aqqth;
    const $d5a435a6cf57495c$export$d3a8cfe12ba42d22 = ()=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("aqqth")).markBoundaryCursorPluginKey),
            state: {
                init: ()=>({
                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
                    }),
                apply (tr, currentState) {
                    const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                    if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                    const side = (0, (0, parcelRequire("g2L0Q")).getActiveMarksSide)({
                        selection: selection,
                        storedMarks: storedMarks
                    });
                    if (!side) return {
                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
                    };
                    return {
                        decorations: (0, (0, parcelRequire("etG8M")).DecorationSet).create(doc, [
                            (0, (0, parcelRequire("42zTf")).createMarkBoundaryCursorDecoration)(selection.head, side)
                        ])
                    };
                }
            },
            props: {
                decorations: (state)=>{
                    return (0, (0, parcelRequire("aqqth")).markBoundaryCursorPluginKey).getState(state)?.decorations;
                }
            }
        });
    };
});
parcelRegister("42zTf", function(module, exports) {
    $parcel$export(module.exports, "createMarkBoundaryCursorDecoration", ()=>$72fb28b305a4f4a8$export$499e8e2917534a4d);
    var $etG8M;
    const $72fb28b305a4f4a8$var$containerStyle = `
	position: relative;
`;
    const $72fb28b305a4f4a8$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #172B4D)"};
`;
    const $72fb28b305a4f4a8$var$toDOM = ()=>{
        const container = document.createElement('span');
        container.className = 'ProseMirror-mark-boundary-cursor';
        container.setAttribute('style', $72fb28b305a4f4a8$var$containerStyle);
        const caret = document.createElement('div');
        caret.setAttribute('style', $72fb28b305a4f4a8$var$caretStyle);
        caret.animate([
            {
                opacity: 1
            },
            {
                opacity: 1,
                offset: 0.5
            },
            {
                opacity: 0,
                offset: 0.5
            },
            {
                opacity: 0
            }
        ], {
            duration: 1000,
            iterations: Infinity
        });
        container.appendChild(caret);
        return container;
    };
    const $72fb28b305a4f4a8$export$499e8e2917534a4d = (pos, side)=>{
        return (0, (0, parcelRequire("etG8M")).Decoration).widget(pos, $72fb28b305a4f4a8$var$toDOM, {
            key: 'mark-boundary-cursor',
            side: side
        });
    };
});
parcelRegister("g2L0Q", function(module, exports) {
    $parcel$export(module.exports, "getActiveMarksSide", ()=>$ca984299eafa8171$export$8f6a177d567e1134);
    var $594Yf;
    var $kCV8T;
    var $4fjCT;
    var $4gdCc;
    function $ca984299eafa8171$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
        if (!(0, (0, parcelRequire("594Yf")).isTextSelection)(selection) || !selection.empty) return (0, (0, parcelRequire("4fjCT")).MarksSide).None;
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
        const leftMarks = nodeBefore?.marks ?? [];
        const rightMarks = nodeAfter?.marks ?? [];
        if ((0, (0, parcelRequire("kCV8T")).Mark).sameSet(leftMarks, rightMarks)) return (0, (0, parcelRequire("4fjCT")).MarksSide).None;
        return (0, (0, parcelRequire("4gdCc")).getInlineCodeCursorSide)({
            leftMarks: leftMarks,
            rightMarks: rightMarks,
            storedMarks: storedMarks
        });
    }
});
parcelRegister("4fjCT", function(module, exports) {
    $parcel$export(module.exports, "MarksSide", ()=>$74e2530f6f1ed35a$export$6705e1762430d43f);
    var $74e2530f6f1ed35a$export$6705e1762430d43f;
    (function(MarksSide) {
        MarksSide[MarksSide["None"] = 0] = "None";
        MarksSide[MarksSide["Left"] = -1] = "Left";
        MarksSide[MarksSide["Right"] = 1] = "Right";
    })($74e2530f6f1ed35a$export$6705e1762430d43f || ($74e2530f6f1ed35a$export$6705e1762430d43f = {}));
});
parcelRegister("4gdCc", function(module, exports) {
    $parcel$export(module.exports, "getInlineCodeCursorSide", ()=>$404287a29ad95730$export$325621c34246ee7d);
    var $4fjCT;
    function $404287a29ad95730$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
        const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
        const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
        const isInlineCodeBeingStored = !!storedMarks && storedMarks?.some((mark)=>mark.type.name === 'code');
        const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
        if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, (0, parcelRequire("4fjCT")).MarksSide).Right;
        return (0, (0, parcelRequire("4fjCT")).MarksSide).None;
    }
});
parcelRegister("aqqth", function(module, exports) {
    $parcel$export(module.exports, "markBoundaryCursorPluginKey", ()=>$ad9527801014bc00$export$220fecd6a5c51ffb);
    var $gZGBX;
    const $ad9527801014bc00$export$220fecd6a5c51ffb = new (0, (0, parcelRequire("gZGBX")).PluginKey)('markBoundaryCursorPlugin');
});
parcelRegister("gZRC6", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$0ac64cffabc4b968$export$ae829ec7b2625219);
    var $5KWxh;
    var $gZGBX;
    var $5Sk2z;
    var $o4pF0;
    var $aw7z0;
    var $hSv52;
    var $kqfPI;
    var $3z3LP;
    const $0ac64cffabc4b968$export$53ac33307b5acee9 = (state)=>({
            decorationSet: (0, (0, parcelRequire("hSv52")).getDecorations)(state.tr),
            selection: state.selection
        });
    const $0ac64cffabc4b968$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, options = {})=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("aw7z0")).selectionPluginKey),
            state: (0, (0, parcelRequire("o4pF0")).createPluginState)(dispatch, $0ac64cffabc4b968$export$53ac33307b5acee9),
            appendTransaction (_transactions, oldEditorState, newEditorState) {
                if (!(0, (0, parcelRequire("hSv52")).shouldRecalcDecorations)({
                    oldEditorState: oldEditorState,
                    newEditorState: newEditorState
                })) return;
                const { tr: tr } = newEditorState;
                tr.setMeta((0, (0, parcelRequire("aw7z0")).selectionPluginKey), {
                    type: (0, (0, parcelRequire("5Sk2z")).SelectionActionTypes).SET_DECORATIONS,
                    selection: tr.selection,
                    decorationSet: (0, (0, parcelRequire("hSv52")).getDecorations)(tr)
                });
                return tr;
            },
            filterTransaction (tr, state) {
                if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && !tr.getMeta((0, (0, parcelRequire("aw7z0")).selectionPluginKey))) return false;
                if (state.selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && tr.selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
                return true;
            },
            props: {
                createSelectionBetween: (0, (0, parcelRequire("kqfPI")).onCreateSelectionBetween),
                decorations (state) {
                    return (0, (0, parcelRequire("o4pF0")).getPluginState)(state).decorationSet;
                },
                handleDOMEvents: {
                    keydown: (0, (0, parcelRequire("3z3LP")).createOnKeydown)({
                        __livePage: options.__livePage
                    })
                }
            }
        });
    };
});
parcelRegister("kqfPI", function(module, exports) {
    $parcel$export(module.exports, "onCreateSelectionBetween", ()=>$1b9e3681e85a9d75$export$ba3a236bf89a370d);
    var $gZGBX;
    const $1b9e3681e85a9d75$var$DOC_START_POS = 0;
    function $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) {
        return maybeNode?.content.size === 0 || maybeNode?.textContent === '';
    }
    function $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($pos) {
        const { doc: doc } = $pos;
        if ($pos.pos > doc.content.size) return null;
        if ($1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
        if ($pos.nodeBefore !== null) return null;
        if ($pos.depth === 0 && $pos.pos === 0) return $pos;
        const positionLevelUp = $pos.before();
        const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
        return $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
    }
    const $1b9e3681e85a9d75$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
        if ($pos.pos === $1b9e3681e85a9d75$var$DOC_START_POS) return false;
        const justBeforeNodePos = $pos.pos - 1;
        const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
        const maybeNode = $resolvedjustBeforePos.nodeAfter;
        if (!maybeNode || !maybeNode.isBlock) return false;
        if (maybeNode.isAtom) return true;
        return $1b9e3681e85a9d75$var$isNodeContentEmpty(maybeNode) && (0, (0, parcelRequire("gZGBX")).NodeSelection).isSelectable(maybeNode);
    };
    function $1b9e3681e85a9d75$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
        const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
        let maybeNode = null;
        if ($targetHead.pos !== $1b9e3681e85a9d75$var$DOC_START_POS) {
            const justBeforeHeadPos = $targetHead.pos - 1;
            const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
            maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
        }
        if (maybeNode === null) {
            maybeNode = $targetHead.nodeAfter;
            if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
            else return null;
        }
        const maybeNextPosition = $1b9e3681e85a9d75$var$findEmptySelectableParentNodePosition($targetHead);
        if (maybeNextPosition) {
            const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
            if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
            else {
                const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
                if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
            }
        }
        return null;
    }
    const $1b9e3681e85a9d75$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
        if ($anchor.pos === $head.pos) return null;
        if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
        if ($head.depth === 1 && $head.parent?.type.name === 'paragraph') return null;
        if ($head.parent?.isTextblock && !$1b9e3681e85a9d75$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
        const $nextHeadPosition = $1b9e3681e85a9d75$var$findNextSelectionPosition({
            $targetHead: $head,
            $anchor: $anchor,
            doc: view.state.doc
        });
        if (!$nextHeadPosition) return null;
        const forcedTextSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
        return forcedTextSelection;
    };
});
parcelRegister("3z3LP", function(module, exports) {
    $parcel$export(module.exports, "createOnKeydown", ()=>$e5c6bd60f2ded2f2$export$1bff6ff05fed49a5);
    var $2Hal9;
    var $gZGBX;
    var $VSDnB;
    const $e5c6bd60f2ded2f2$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
        let currentExpandedState;
        if (__livePage && (0, (0, parcelRequire("VSDnB")).fg)('platform-editor-single-player-expand')) currentExpandedState = node ? !(0, (0, parcelRequire("2Hal9")).expandedState).get(node) : undefined;
        else if (__livePage) currentExpandedState = node?.attrs.__expanded;
        else currentExpandedState = !node?.attrs.__expanded;
        return Boolean(node && [
            'expand',
            'nestedExpand'
        ].includes(node.type.name) && currentExpandedState);
    };
    const $e5c6bd60f2ded2f2$var$isBodiedExtension = (node)=>{
        return Boolean(node && [
            'bodiedExtension'
        ].includes(node.type.name));
    };
    const $e5c6bd60f2ded2f2$var$isTable = (node)=>{
        return Boolean(node && [
            'table'
        ].includes(node.type.name));
    };
    const $e5c6bd60f2ded2f2$var$isProblematicNode = (node, { __livePage: __livePage })=>{
        return $e5c6bd60f2ded2f2$var$isCollapsedExpand(node, {
            __livePage: __livePage
        }) || $e5c6bd60f2ded2f2$var$isBodiedExtension(node) || $e5c6bd60f2ded2f2$var$isTable(node);
    };
    const $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
        if ($head.pos === 0 || $head.depth === 0) return null;
        if (direction === 'up') {
            const pos = $head.before();
            const $posResolved = $head.doc.resolve(pos);
            const maybeProblematicNode = $posResolved.nodeBefore;
            if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
                __livePage: __livePage
            })) {
                const nodeSize = maybeProblematicNode.nodeSize;
                const nodeStartPosition = pos - nodeSize;
                const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
                if (isAtEndOfProblematicNode) {
                    const startPosNode = Math.max(nodeStartPosition, 0);
                    const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                    return $startPosNode;
                }
            }
        }
        if (direction === 'down') {
            const pos = $head.after();
            const maybeProblematicNode = doc.nodeAt(pos);
            if (maybeProblematicNode && $e5c6bd60f2ded2f2$var$isProblematicNode(maybeProblematicNode, {
                __livePage: __livePage
            }) && $head.pos + 1 === pos) {
                const nodeSize = maybeProblematicNode.nodeSize;
                const nodePosition = pos + nodeSize;
                const startPosNode = Math.max(nodePosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
        return null;
    };
    const $e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
        if (!event.shiftKey || !event.metaKey) return false;
        const selection = view.state.selection;
        if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return false;
        if (!selection.$cursor) return false;
        const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean(selection.$cursor.nodeAfter?.isInline);
        const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean(selection.$cursor.nodeBefore?.isInline);
        return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
    };
    const $e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
        if (event.shiftKey || event.metaKey) return false;
        const selection = view.state?.selection;
        if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection))) return false;
        if (!selection.$cursor) return false;
        const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean(selection.$cursor.nodeBefore?.isInline) && Boolean(selection.$cursor.nodeAfter?.isInline);
        return isNavigatingInlineNodeDownward;
    };
    function $e5c6bd60f2ded2f2$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
        function onKeydown(view, event) {
            if (!(event instanceof KeyboardEvent)) return false;
            if ($e5c6bd60f2ded2f2$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
            if ($e5c6bd60f2ded2f2$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
            if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
            if (![
                'ArrowUp',
                'ArrowDown',
                'ArrowRight',
                'ArrowLeft',
                'Home',
                'End'
            ].includes(event.key)) return false;
            const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
            if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
            const direction = [
                'ArrowLeft',
                'ArrowUp',
                'Home'
            ].includes(event.key) ? 'up' : 'down';
            const $fixedProblematicNodePosition = $e5c6bd60f2ded2f2$var$findFixedProblematicNodePosition(doc, $head, direction, {
                __livePage: __livePage
            });
            if ($fixedProblematicNodePosition) {
                const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                const head = $fixedProblematicNodePosition.pos + headOffset;
                const forcedTextSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).create(view.state.doc, $anchor.pos, head);
                const tr = view.state.tr;
                tr.setSelection(forcedTextSelection);
                view.dispatch(tr);
                event.preventDefault();
                return true;
            }
            return false;
        }
        return onKeydown;
    }
});
parcelRegister("2Hal9", function(module, exports) {
    $parcel$export(module.exports, "expandedState", ()=>$f0f36d6481cf8dea$export$de2a5eca4f1cacc0);
    $parcel$export(module.exports, "isExpandCollapsed", ()=>$f0f36d6481cf8dea$export$785b8bfd794fa7b6);
    const $f0f36d6481cf8dea$export$de2a5eca4f1cacc0 = new WeakMap();
    const $f0f36d6481cf8dea$export$785b8bfd794fa7b6 = (node)=>{
        return !$f0f36d6481cf8dea$export$de2a5eca4f1cacc0.get(node) ?? false;
    };
});
parcelRegister("gXAdO", function(module, exports) {
    $parcel$export(module.exports, "typeAheadPlugin", ()=>(parcelRequire("cKx1R")).typeAheadPlugin);
    var $cKx1R;
});
parcelRegister("cKx1R", function(module, exports) {
    $parcel$export(module.exports, "typeAheadPlugin", ()=>$614ad81eb16a153a$export$a023c922ef32b883);
    var $5uXOq = parcelRequire("5uXOq");
    var $dtyqo;
    var $gkwXh;
    var $5KWxh;
    var $3UtTx;
    var $etG8M;
    var $5Vwh8;
    var $eF1Qh;
    var $ctcYc;
    var $8oJYH;
    var $ldgDZ;
    var $b6IDf;
    var $2RUDH;
    var $2D6mf;
    var $iiwBk;
    var $hgbc1;
    const $614ad81eb16a153a$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
                const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query } = props;
                (0, (0, parcelRequire("ctcYc")).openTypeAheadAtCursor)({
                    triggerHandler: triggerHandler,
                    inputMethod: inputMethod,
                    query: query
                })({
                    tr: tr
                });
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                    actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD,
                    actionSubjectId: triggerHandler.id,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                })(tr);
                return true;
            };
    const $614ad81eb16a153a$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
            if (!editorViewRef.current) return false;
            const { current: view } = editorViewRef;
            const { tr: tr } = view.state;
            $614ad81eb16a153a$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
            view.dispatch(tr);
            return true;
        };
    const $614ad81eb16a153a$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
            if (!editorViewRef.current) return false;
            const { current: view } = editorViewRef;
            const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
            (0, (0, parcelRequire("eF1Qh")).insertTypeAheadItem)(view)({
                handler: triggerHandler,
                item: contentItem,
                mode: mode || (0, (0, parcelRequire("3UtTx")).SelectItemMode).SELECTED,
                query: query,
                sourceListItem: sourceListItem
            });
            return true;
        };
    const $614ad81eb16a153a$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
            if (!editorViewRef.current) return null;
            const { current: view } = editorViewRef;
            return (0, (0, parcelRequire("iiwBk")).findHandler)(trigger, view.state);
        };
    const $614ad81eb16a153a$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
            if (!editorViewRef.current) return false;
            const { current: view } = editorViewRef;
            const currentQuery = (0, (0, parcelRequire("iiwBk")).getTypeAheadQuery)(view.state) || '';
            const { state: state } = view;
            let tr = state.tr;
            if (options.attachCommand) {
                const fakeDispatch = (customTr)=>{
                    tr = customTr;
                };
                options.attachCommand(state, fakeDispatch);
            }
            (0, (0, parcelRequire("5Vwh8")).closeTypeAhead)(tr);
            if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
                const handler = (0, (0, parcelRequire("iiwBk")).getTypeAheadHandler)(state);
                if (!handler) return false;
                const text = handler.trigger.concat(currentQuery);
                tr.replaceSelectionWith(state.schema.text(text));
            }
            view.dispatch(tr);
            if (!view.hasFocus()) view.focus();
            return true;
        };
    const $614ad81eb16a153a$export$a023c922ef32b883 = ({ api: api })=>{
        const popupMountRef = {
            current: null
        };
        const editorViewRef = {
            current: null
        };
        return {
            name: 'typeAhead',
            marks () {
                return [
                    {
                        name: 'typeAheadQuery',
                        mark: (0, (0, parcelRequire("dtyqo")).typeAheadQuery)
                    }
                ];
            },
            pmPlugins (typeAhead = []) {
                return [
                    {
                        name: 'typeAhead',
                        plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, (0, parcelRequire("2RUDH")).createPlugin)({
                                getIntl: getIntl,
                                popupMountRef: popupMountRef,
                                reactDispatch: dispatch,
                                typeAheadHandlers: typeAhead,
                                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                            })
                    },
                    {
                        name: 'typeAheadEditorViewRef',
                        plugin: ()=>{
                            return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
                                view (view) {
                                    editorViewRef.current = view;
                                    return {
                                        destroy () {
                                            editorViewRef.current = null;
                                        }
                                    };
                                }
                            });
                        }
                    },
                    {
                        name: 'typeAheadInsertItem',
                        plugin: (0, (0, parcelRequire("ldgDZ")).createPlugin)
                    },
                    {
                        name: 'typeAheadInputRule',
                        plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, (0, parcelRequire("8oJYH")).inputRulePlugin)(schema, typeAhead, featureFlags)
                    }
                ];
            },
            getSharedState (editorState) {
                if (!editorState) return {
                    query: '',
                    isOpen: false,
                    isAllowed: false,
                    currentHandler: undefined,
                    decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                    decorationElement: null,
                    triggerHandler: undefined,
                    items: [],
                    selectedIndex: 0
                };
                const isOpen = (0, (0, parcelRequire("iiwBk")).isTypeAheadOpen)(editorState);
                const state = (0, (0, parcelRequire("iiwBk")).getPluginState)(editorState);
                return {
                    query: (0, (0, parcelRequire("iiwBk")).getTypeAheadQuery)(editorState) || '',
                    currentHandler: (0, (0, parcelRequire("iiwBk")).getTypeAheadHandler)(editorState),
                    isOpen: isOpen,
                    isAllowed: !isOpen,
                    decorationSet: state?.decorationSet ?? (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                    decorationElement: state?.decorationElement ?? null,
                    triggerHandler: state?.triggerHandler,
                    items: state?.items ?? [],
                    selectedIndex: state?.selectedIndex ?? 0
                };
            },
            actions: {
                isOpen: (0, (0, parcelRequire("iiwBk")).isTypeAheadOpen),
                isAllowed: (0, (0, parcelRequire("iiwBk")).isTypeAheadAllowed),
                open: $614ad81eb16a153a$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
                openAtTransaction: $614ad81eb16a153a$var$createOpenAtTransaction(api?.analytics?.actions),
                findHandlerByTrigger: $614ad81eb16a153a$var$createFindHandlerByTrigger(editorViewRef),
                insert: $614ad81eb16a153a$var$createInsertTypeAheadItem(editorViewRef),
                close: $614ad81eb16a153a$var$createCloseTypeAhead(editorViewRef)
            },
            contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
                popupMountRef.current = {
                    popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement || containerElement || undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hgbc1")).ContentComponent), {
                    editorView: editorView,
                    popupMountRef: popupMountRef,
                    api: api
                });
            },
            onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
                const oldPluginState = (0, (0, parcelRequire("iiwBk")).getPluginState)(oldEditorState);
                const newPluginState = (0, (0, parcelRequire("iiwBk")).getPluginState)(newEditorState);
                if (!oldPluginState || !newPluginState) return;
                const { triggerHandler: oldTriggerHandler } = oldPluginState;
                const { triggerHandler: newTriggerHandler } = newPluginState;
                const isANewHandler = oldTriggerHandler !== newTriggerHandler;
                if (oldTriggerHandler?.dismiss && isANewHandler) {
                    const typeAheadMessage = originalTransaction.getMeta((0, (0, parcelRequire("b6IDf")).pluginKey));
                    const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                    oldTriggerHandler.dismiss({
                        editorState: newEditorState,
                        query: oldPluginState.query,
                        stats: (oldPluginState.stats || new (0, (0, parcelRequire("2D6mf")).StatsModifier)()).serialize(),
                        wasItemInserted: wasItemInserted
                    });
                }
                if (newTriggerHandler?.onOpen && isANewHandler) newTriggerHandler.onOpen(newEditorState);
                if (newTriggerHandler && isANewHandler) {
                    const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).QUICK_INSERT && Object.values((0, (0, parcelRequire("3UtTx")).TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                    if (!isDuplicateInvokedEvent) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, (0, parcelRequire("gkwXh")).ACTION).INVOKED,
                        actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    });
                }
            }
        };
    };
});
parcelRegister("3UtTx", function(module, exports) {
    $parcel$export(module.exports, "TypeAheadAvailableNodes", ()=>$a7f24fcc6d3b7633$export$8c4c885c87e5cc07);
    $parcel$export(module.exports, "SelectItemMode", ()=>$a7f24fcc6d3b7633$export$4d7d0343c6d95a0e);
    var $8ptyJ;
    var $a7f24fcc6d3b7633$export$8c4c885c87e5cc07;
    (function(TypeAheadAvailableNodes) {
        TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
        TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
        TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    })($a7f24fcc6d3b7633$export$8c4c885c87e5cc07 || ($a7f24fcc6d3b7633$export$8c4c885c87e5cc07 = {}));
    var $a7f24fcc6d3b7633$export$4d7d0343c6d95a0e;
    (function(SelectItemMode) {
        SelectItemMode["SHIFT_ENTER"] = "shift-enter";
        SelectItemMode["ENTER"] = "enter";
        SelectItemMode["SPACE"] = "space";
        SelectItemMode["SELECTED"] = "selected";
        SelectItemMode["TAB"] = "tab";
    })($a7f24fcc6d3b7633$export$4d7d0343c6d95a0e || ($a7f24fcc6d3b7633$export$4d7d0343c6d95a0e = {}));
});
parcelRegister("8ptyJ", function(module, exports) {
    $parcel$export(module.exports, "typeAheadListMessages", ()=>$df168ce559caf975$export$940a17143b866527);
    var $7VHMR;
    const $df168ce559caf975$export$940a17143b866527 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        typeAheadPopupLabel: {
            id: 'fabric.editor.typeAhead.popupLabel',
            defaultMessage: 'Typeahead results',
            description: 'the result of a typeahead, similar to autocomplete results+'
        },
        quickInsertPopupLabel: {
            id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
            defaultMessage: 'Shortcuts for inserts and formatting',
            description: 'the result of a quick insert typeahead, similar to autocomplete results+'
        },
        quickInsertInputLabel: {
            id: 'fabric.editor.typeAhead.quickInsertInputLabel',
            defaultMessage: 'Begin typing to search or filter shortcut options',
            description: 'assisitve text for typeahed input field'
        },
        emojiPopupLabel: {
            id: 'fabric.editor.typeahead.emojiPopupLabel',
            defaultMessage: 'Emoji shortcuts',
            description: 'the result of a emoji typeahead, similar to autocomplete results+'
        },
        emojiInputLabel: {
            id: 'fabric.editor.typeahead.emojiInputLabel',
            defaultMessage: 'Begin typing to search or filter emoji options',
            description: 'assisitve text for typeahed input field'
        },
        mentionPopupLabel: {
            id: 'fabric.editor.typeahead.mentionPopupLabel',
            defaultMessage: 'Users you can tag',
            description: 'the aria label of a mention typeahead popup'
        },
        mentionInputLabel: {
            id: 'fabric.editor.typeahead.mentionInputLabel',
            defaultMessage: 'Begin typing to search for users to tag',
            description: 'assisitve text for typeahed input field'
        },
        metionListItemLabel: {
            id: 'fabric.editor.typeahead.metionListItemLabel',
            defaultMessage: 'User {name} @{shortName}',
            description: 'assistive text for user mention items username and nickname'
        },
        emojiListItemLabel: {
            id: 'fabric.editor.typeahead.emojiListItemLabel',
            defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
            description: 'assistive text for emoji name and shortcut'
        },
        inputQueryAssistiveLabel: {
            id: 'fabric.editor.inputQueryAssistiveTxt',
            defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
            description: 'Assistive text to the user when using typeahead shortcut'
        },
        searchResultsLabel: {
            id: 'fabric.editor.searchResults',
            defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
            description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
        },
        noSearchResultsLabel: {
            id: 'fabric.editor.noSearchResults',
            defaultMessage: 'No search results',
            description: 'Assistive text to the user when using typeahead shortcut'
        },
        descriptionLabel: {
            id: 'fabric.editor.description',
            defaultMessage: 'Description',
            description: 'Description'
        },
        shortcutLabel: {
            id: 'fabric.editor.shortcut',
            defaultMessage: 'Text shortcut',
            description: 'Text shortcut'
        }
    });
});
parcelRegister("5Vwh8", function(module, exports) {
    $parcel$export(module.exports, "closeTypeAhead", ()=>$0d2dd1000e07b5a6$export$daba40574d0568e3);
    var $7eFnB;
    var $b6IDf;
    const $0d2dd1000e07b5a6$export$daba40574d0568e3 = (tr)=>{
        return tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
            action: (0, (0, parcelRequire("7eFnB")).ACTIONS).CLOSE_TYPE_AHEAD
        });
    };
});
parcelRegister("7eFnB", function(module, exports) {
    $parcel$export(module.exports, "ACTIONS", ()=>$d12f7dcf5833e13e$export$92a1a3b7554e9387);
    var $d12f7dcf5833e13e$export$92a1a3b7554e9387;
    (function(ACTIONS) {
        ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
        ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
        ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
        ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
        ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
        ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
        ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    })($d12f7dcf5833e13e$export$92a1a3b7554e9387 || ($d12f7dcf5833e13e$export$92a1a3b7554e9387 = {}));
});
parcelRegister("b6IDf", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$f2e6ba5f517d8a79$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $f2e6ba5f517d8a79$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('typeAheadPlugin');
});
parcelRegister("eF1Qh", function(module, exports) {
    $parcel$export(module.exports, "insertTypeAheadItem", ()=>$ea5e5e0c4f528fae$export$173ade35125a6637);
    var $ez3YZ;
    var $3UtTx;
    var $fZzhT;
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $7eFnB;
    var $b6IDf;
    var $2D6mf;
    var $iiwBk;
    var $5Vwh8;
    var $b3yfA;
    const $ea5e5e0c4f528fae$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
        if (!maybeNode) return null;
        if (maybeNode instanceof (0, (0, parcelRequire("kCV8T")).Node) || maybeNode instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) return maybeNode;
        if (typeof maybeNode === 'string') return schema.text(maybeNode);
        try {
            return (0, (0, parcelRequire("kCV8T")).Node).fromJSON(schema, maybeNode);
        } catch (e) {
            console.error(e);
            return null;
        }
    };
    const $ea5e5e0c4f528fae$var$insertTemplateFragment = ({ fragment: fragment, tr: tr, position: position })=>{
        const { start: start } = position;
        const trWithInsert = (0, $5r0mK.safeInsert)(fragment, start)(tr);
        tr.setSelection(trWithInsert.selection);
        return tr;
    };
    const $ea5e5e0c4f528fae$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
            const { tr: tr } = state;
            const position = {
                start: textStartPosition,
                end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
            };
            const node = $ea5e5e0c4f528fae$var$validateNode({
                schema: state.schema,
                maybeNode: maybeNode
            });
            if (!node) {
                (0, (0, parcelRequire("5Vwh8")).closeTypeAhead)(tr);
                tr.delete(position.start, position.end);
                return tr;
            }
            if (opts.isTemplate) $ea5e5e0c4f528fae$var$insertTemplateFragment({
                fragment: node,
                tr: tr,
                position: position
            });
            else node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.isBlock ? (0, (0, parcelRequire("b3yfA")).insertBlockNode)({
                node: node,
                tr: tr,
                position: position
            }) : (0, (0, parcelRequire("b3yfA")).insertInlineNodeOrFragment)({
                maybeFragment: node,
                tr: tr,
                position: position,
                selectInlineNode: Boolean(opts.selectInlineNode)
            });
            (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            if (wasInsertedBySpace) return tr;
            const config = {
                stage: (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).INSERTING_ITEM,
                query: query,
                selectedIndex: selectedIndex,
                trigger: handler.trigger
            };
            tr.step(new (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep)(config));
            return tr;
        };
    const $ea5e5e0c4f528fae$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
        return (newState)=>{
            const tr = newState.tr;
            (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            if (!wasInsertedBySpace) {
                tr.delete(position.start, position.end);
                const config = {
                    stage: (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).DELETING_RAW_QUERY,
                    selectedIndex: selectedIndex,
                    query: query,
                    trigger: trigger
                };
                tr.step(new (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep)(config));
            }
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).INSERT_ITEM,
                params: insertItem
            });
            return tr;
        };
    };
    const $ea5e5e0c4f528fae$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
            const pluginState = (0, (0, parcelRequire("iiwBk")).getPluginState)(view.state);
            if (!pluginState) return;
            const stats = (pluginState.stats || new (0, (0, parcelRequire("2D6mf")).StatsModifier)()).serialize();
            const meta = {
                mode: mode,
                query: query,
                stats: stats,
                sourceListItem: sourceListItem
            };
            const { tr: tr } = view.state;
            const trigger = handler.trigger;
            let text = `${trigger}${query}`;
            if (mode === (0, (0, parcelRequire("3UtTx")).SelectItemMode).SPACE) text = text.trim().concat(' ');
            const selectedIndex = -1;
            const wasInsertedBySpace = mode === (0, (0, parcelRequire("3UtTx")).SelectItemMode).SPACE;
            const { selection: { from: textStartPosition } } = tr;
            const insertItem = (newEditorSate)=>{
                const insertCallback = $ea5e5e0c4f528fae$var$createInsertCallback({
                    editorState: newEditorSate,
                    query: query,
                    mode: mode,
                    handler: handler,
                    wasInsertedBySpace: wasInsertedBySpace,
                    selectedIndex: selectedIndex,
                    textInserted: text,
                    textStartPosition: textStartPosition
                });
                let wasInsertCallbackCalled = false;
                const proxyHandler = {
                    apply: function(target, _thisContext, argumentsList) {
                        wasInsertCallbackCalled = true;
                        return target(...argumentsList);
                    }
                };
                const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
                const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
                if (!wasInsertCallbackCalled && nextTr) {
                    (0, (0, parcelRequire("fZzhT")).closeHistory)(nextTr);
                    if (!nextTr.getMeta((0, (0, parcelRequire("b6IDf")).pluginKey))) (0, (0, parcelRequire("5Vwh8")).closeTypeAhead)(nextTr);
                }
                return nextTr;
            };
            const position = {
                start: tr.selection.from,
                end: tr.selection.from + text.length
            };
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).INSERT_RAW_QUERY,
                params: $ea5e5e0c4f528fae$var$createDeleteRawTextCallback({
                    wasInsertedBySpace: wasInsertedBySpace,
                    selectedIndex: selectedIndex,
                    insertItem: insertItem,
                    position: position,
                    query: query,
                    trigger: trigger
                })
            });
            tr.insertText(text);
            (0, (0, parcelRequire("fZzhT")).closeHistory)(tr);
            view.dispatch(tr);
            view.focus();
        };
});
parcelRegister("ez3YZ", function(module, exports) {
    $parcel$export(module.exports, "InsertTypeAheadStages", ()=>$a9a76c74962f10f8$export$1b2be0bed116d664);
    $parcel$export(module.exports, "InsertTypeAheadStep", ()=>$a9a76c74962f10f8$export$5ca6d15deb246b5d);
    var $kCV8T;
    var $eS2Dn;
    const $a9a76c74962f10f8$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
    let $a9a76c74962f10f8$export$1b2be0bed116d664 = function(InsertTypeAheadStages) {
        InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
        InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
        return InsertTypeAheadStages;
    }({});
    class $a9a76c74962f10f8$export$5ca6d15deb246b5d extends (0, (0, parcelRequire("eS2Dn")).Step) {
        constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
            super();
            this.isInvertStep = isInvertStep;
            this.stage = stage;
            this.query = query;
            this.trigger = trigger;
            this.selectedIndex = selectedIndex;
        }
        invert() {
            const config = {
                stage: this.stage,
                query: this.query,
                trigger: this.trigger,
                selectedIndex: this.selectedIndex
            };
            return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, !this.isInvertStep);
        }
        apply(doc) {
            return (0, (0, parcelRequire("eS2Dn")).StepResult).ok(doc);
        }
        merge() {
            return null;
        }
        isInsertionStep() {
            return !this.isInvertStep;
        }
        isUndoingStep() {
            return this.isInvertStep;
        }
        map() {
            const config = {
                stage: this.stage,
                query: this.query,
                trigger: this.trigger,
                selectedIndex: this.selectedIndex
            };
            return new $a9a76c74962f10f8$export$5ca6d15deb246b5d(config, this.isInvertStep);
        }
        getMap() {
            return new (0, (0, parcelRequire("eS2Dn")).StepMap)([
                0,
                0,
                0
            ]);
        }
        toJSON() {
            return {
                stepType: 'replace',
                from: 0,
                to: 0
            };
        }
        static fromJSON() {
            return new (0, (0, parcelRequire("eS2Dn")).ReplaceStep)(0, 0, (0, (0, parcelRequire("kCV8T")).Slice).empty);
        }
    }
    (0, (0, parcelRequire("eS2Dn")).Step).jsonID($a9a76c74962f10f8$export$2f0b0962a5993fe0, $a9a76c74962f10f8$export$5ca6d15deb246b5d);
});
parcelRegister("2D6mf", function(module, exports) {
    $parcel$export(module.exports, "StatsModifier", ()=>$f05a9d8982368ab5$export$630efe5940bb4d41);
    class $f05a9d8982368ab5$export$630efe5940bb4d41 {
        constructor(){
            this.startedAt = 0;
            this.endedAt = 0;
            this.keyCount = {
                arrowUp: 0,
                arrowDown: 0
            };
            this.increaseArrowUp = ()=>{
                this.keyCount.arrowUp += 1;
            };
            this.increaseArrowDown = ()=>{
                this.keyCount.arrowDown += 1;
            };
            this.serialize = ()=>{
                return {
                    startedAt: this.startedAt,
                    endedAt: performance.now(),
                    keyCount: {
                        arrowUp: this.keyCount?.arrowUp || 0,
                        arrowDown: this.keyCount?.arrowDown || 0
                    }
                };
            };
            this.startedAt = performance.now();
            this.keyCount = {
                arrowUp: 0,
                arrowDown: 0
            };
        }
    }
});
parcelRegister("iiwBk", function(module, exports) {
    $parcel$export(module.exports, "isTypeAheadHandler", ()=>$d20c753282e6c55d$export$be092076596418f1);
    $parcel$export(module.exports, "isTypeAheadOpen", ()=>$d20c753282e6c55d$export$564dcc295d6ce147);
    $parcel$export(module.exports, "getPluginState", ()=>$d20c753282e6c55d$export$f05434c51e3762e);
    $parcel$export(module.exports, "getTypeAheadHandler", ()=>$d20c753282e6c55d$export$c1eba975d6442029);
    $parcel$export(module.exports, "getTypeAheadQuery", ()=>$d20c753282e6c55d$export$7a55deb43cd1340e);
    $parcel$export(module.exports, "isTypeAheadAllowed", ()=>$d20c753282e6c55d$export$74b0f581633f8412);
    $parcel$export(module.exports, "findHandler", ()=>$d20c753282e6c55d$export$2bae95e359577df4);
    $parcel$export(module.exports, "moveSelectedIndex", ()=>$d20c753282e6c55d$export$f985e98ceae7c8f6);
    $parcel$export(module.exports, "getTypeAheadListAriaLabels", ()=>$d20c753282e6c55d$export$19cacaa810ba988a);
    var $3UtTx;
    var $8ptyJ;
    var $bmkwl;
    var $b6IDf;
    var $2D6mf;
    const $d20c753282e6c55d$export$be092076596418f1 = (handler)=>{
        return handler && Object.values((0, (0, parcelRequire("3UtTx")).TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
    };
    const $d20c753282e6c55d$export$564dcc295d6ce147 = (editorState)=>{
        return !!(0, (0, parcelRequire("b6IDf")).pluginKey)?.getState(editorState)?.decorationSet?.find().length;
    };
    const $d20c753282e6c55d$export$f05434c51e3762e = (editorState)=>{
        return (0, (0, parcelRequire("b6IDf")).pluginKey).getState(editorState);
    };
    const $d20c753282e6c55d$export$c1eba975d6442029 = (editorState)=>{
        return (0, (0, parcelRequire("b6IDf")).pluginKey).getState(editorState)?.triggerHandler;
    };
    const $d20c753282e6c55d$export$7a55deb43cd1340e = (editorState)=>{
        return (0, (0, parcelRequire("b6IDf")).pluginKey).getState(editorState)?.query;
    };
    const $d20c753282e6c55d$export$74b0f581633f8412 = (state)=>{
        const isOpen = $d20c753282e6c55d$export$564dcc295d6ce147(state);
        return !isOpen;
    };
    const $d20c753282e6c55d$export$2bae95e359577df4 = (id, state)=>{
        const pluginState = (0, (0, parcelRequire("b6IDf")).pluginKey).getState(state);
        if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
        const { typeAheadHandlers: typeAheadHandlers } = pluginState;
        return typeAheadHandlers.find((h)=>h.id === id) || null;
    };
    const $d20c753282e6c55d$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
        const pluginState = (0, (0, parcelRequire("b6IDf")).pluginKey).getState(editorState);
        if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
        const { typeAheadHandlers: typeAheadHandlers } = pluginState;
        return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
    };
    const $d20c753282e6c55d$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction })=>()=>{
            const typeAheadState = $d20c753282e6c55d$export$f05434c51e3762e(editorView.state);
            if (!typeAheadState) return;
            const { selectedIndex: selectedIndex, items: items } = typeAheadState;
            const stats = typeAheadState.stats instanceof (0, (0, parcelRequire("2D6mf")).StatsModifier) ? typeAheadState.stats : new (0, (0, parcelRequire("2D6mf")).StatsModifier)();
            let nextIndex;
            if (direction === 'next') {
                stats.increaseArrowDown();
                if (selectedIndex === -1 && items.length > 1) nextIndex = 1;
                else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            } else {
                stats.increaseArrowUp();
                nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            }
            (0, (0, parcelRequire("bmkwl")).updateSelectedIndex)(nextIndex)(editorView.state, editorView.dispatch);
        };
    const $d20c753282e6c55d$export$19cacaa810ba988a = (trigger, intl, item)=>{
        switch(trigger){
            case '@':
                return {
                    popupAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).mentionPopupLabel),
                    listItemAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).metionListItemLabel, {
                        name: item?.mention?.name || '',
                        shortName: item?.mention?.mentionName || ''
                    })
                };
            case '/':
                return {
                    popupAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).quickInsertPopupLabel),
                    listItemAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).emojiListItemLabel, {
                        name: item?.title || '',
                        shortcut: item?.emoji?.shortName || ''
                    })
                };
            case ':':
                return {
                    popupAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).emojiPopupLabel),
                    listItemAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).emojiListItemLabel, {
                        name: item?.emoji?.name || '',
                        shortcut: item?.emoji?.shortName || ''
                    })
                };
            default:
                return {
                    popupAriaLabel: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).typeAheadPopupLabel)
                };
        }
    };
});
parcelRegister("bmkwl", function(module, exports) {
    $parcel$export(module.exports, "updateSelectedIndex", ()=>$2917e7df6f0f82cb$export$9993709486a96a6b);
    var $7eFnB;
    var $b6IDf;
    const $2917e7df6f0f82cb$export$9993709486a96a6b = (selectedIndex)=>{
        return (state, dispatch)=>{
            const pluginState = (0, (0, parcelRequire("b6IDf")).pluginKey).getState(state);
            if (pluginState?.selectedIndex === selectedIndex) return false;
            const tr = state.tr;
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).UPDATE_SELECTED_INDEX,
                params: {
                    selectedIndex: selectedIndex
                }
            });
            if (dispatch) dispatch(tr);
            return true;
        };
    };
});
parcelRegister("b3yfA", function(module, exports) {
    $parcel$export(module.exports, "insertBlockNode", ()=>$3d2e2b42ea5fc125$export$faec73a52dd47a2c);
    $parcel$export(module.exports, "insertInlineNodeOrFragment", ()=>$3d2e2b42ea5fc125$export$a6d430434014dc1c);
    var $dlzPV;
    var $aDFRV;
    var $kCV8T;
    var $gZGBX;
    function $3d2e2b42ea5fc125$var$findInsertPoint(doc, pos, nodeToInsert) {
        const $pos = doc.resolve(pos);
        const createInsertPosition = (from, to)=>({
                from: from,
                to: to || from
            });
        for(let level = $pos.depth; level >= 0; level--){
            const nodeAtLevel = $pos.node(level);
            const levelAbove = Math.max(level - 1, 0);
            const parentNode = $pos.node(levelAbove);
            const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
            const indexAtLevelAbove = $pos.index(levelAbove);
            const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
            if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
                const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
                return createInsertPosition(from, from + nodeAtLevel.nodeSize);
            }
            const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
            const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
            if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
        }
        return createInsertPosition(0);
    }
    const $3d2e2b42ea5fc125$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
        const { start: start, end: end } = position;
        if (node.isText) return tr.replaceWith(start, end, node);
        if (node.isBlock) {
            tr.delete(start, end);
            const mappedStart = tr.mapping.map(start);
            const nodeNormalized = (0, (0, parcelRequire("dlzPV")).normaliseNestedLayout)(tr, node);
            const { listItem: listItem } = tr.doc.type.schema.nodes;
            const grandParentNodeType = tr.selection.$from.node(-1)?.type;
            const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
            if (grandParentNodeType === listItem && !(ggreatGrandParentNodeType === node.type)) return (0, (0, parcelRequire("aDFRV")).transformNodeIntoListItem)(tr, nodeNormalized);
            const inserted = (0, (0, parcelRequire("dlzPV")).safeInsert)(nodeNormalized, mappedStart)(tr);
            if (inserted) return tr;
            const sliceInserted = (0, (0, parcelRequire("kCV8T")).Slice).maxOpen((0, (0, parcelRequire("kCV8T")).Fragment).from(nodeNormalized));
            const { from: from, to: to } = $3d2e2b42ea5fc125$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
            tr.replaceWith(from, to, node);
            const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
            const FORWARD_DIRECTION = 1;
            const nextSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
            if (nextSelection) return tr.setSelection(nextSelection);
        }
        return tr;
    };
    const $3d2e2b42ea5fc125$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
        const { start: start, end: end } = position;
        const fragment = maybeFragment instanceof (0, (0, parcelRequire("kCV8T")).Node) ? (0, (0, parcelRequire("kCV8T")).Fragment).from(maybeFragment) : maybeFragment;
        tr.replaceWith(start, end, fragment);
        if (selectInlineNode) return tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, start));
        return tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).near(tr.doc.resolve(start + fragment.size)));
    };
});
parcelRegister("dlzPV", function(module, exports) {
    $parcel$export(module.exports, "normaliseNestedLayout", ()=>$3c014faca3b7f131$export$9a3d0d2a50538e52);
    $parcel$export(module.exports, "safeInsert", ()=>$3c014faca3b7f131$export$5fe92db78385e37c);
    $parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", ()=>$3c014faca3b7f131$export$b80431b156693a98);
    $parcel$export(module.exports, "insertSelectedItem", ()=>$3c014faca3b7f131$export$e3c00faab58641c5);
    $parcel$export(module.exports, "contentAllowedInCodeBlock", ()=>$3c014faca3b7f131$export$b6980e4b8ea578a5);
    var $kCV8T;
    var $gZGBX;
    var $eS2Dn;
    var $5r0mK = parcelRequire("5r0mK");
    var $hPjvp;
    parcelRequire("77j9j");
    var $594Yf;
    var $uTDrM;
    var $3c014faca3b7f131$export$cbdce50c60b34c89;
    (function(LookDirection) {
        LookDirection["Before"] = "before";
        LookDirection["After"] = "after";
    })($3c014faca3b7f131$export$cbdce50c60b34c89 || ($3c014faca3b7f131$export$cbdce50c60b34c89 = {}));
    const $3c014faca3b7f131$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
        if (selection.$from.depth > 1) {
            if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
                ...node.attrs,
                layout: 'default'
            }, node.content, node.marks);
            const breakoutMark = doc.type.schema.marks.breakout;
            if (breakoutMark && breakoutMark.isInSet(node.marks)) {
                const newMarks = breakoutMark.removeFromSet(node.marks);
                return node.type.createChecked(node.attrs, node.content, newMarks);
            }
        }
        return node;
    };
    const $3c014faca3b7f131$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
    const $3c014faca3b7f131$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
    const $3c014faca3b7f131$var$nodeIsInsideAList = (tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        return (0, $5r0mK.hasParentNodeOfType)([
            nodes.orderedList,
            nodes.bulletList
        ])(tr.selection);
    };
    const $3c014faca3b7f131$var$selectionIsInsideAPanel = (tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        return (0, $5r0mK.hasParentNodeOfType)(nodes.panel)(tr.selection);
    };
    const $3c014faca3b7f131$var$selectionIsInNestedList = (tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const parentListNode = (0, $5r0mK.findParentNodeOfType)([
            nodes.orderedList,
            nodes.bulletList
        ])(tr.selection);
        if (!parentListNode) return false;
        return (0, (0, parcelRequire("uTDrM")).isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
    };
    const $3c014faca3b7f131$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
        if ($3c014faca3b7f131$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $3c014faca3b7f131$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
        return tr.insert($proposedPosition[lookDirection](), content);
    };
    const $3c014faca3b7f131$var$shouldSplit = (nodeType, schemaNodes)=>{
        return [
            schemaNodes.bulletList,
            schemaNodes.orderedList,
            schemaNodes.panel
        ].includes(nodeType);
    };
    const $3c014faca3b7f131$export$5fe92db78385e37c = (content, position)=>(tr)=>{
            const { nodes: nodes } = tr.doc.type.schema;
            const whitelist = [
                nodes.rule,
                nodes.mediaSingle
            ];
            if (content instanceof (0, (0, parcelRequire("kCV8T")).Fragment) || !whitelist.includes(content.type)) return null;
            if (!tr.selection.empty || (0, $5r0mK.isNodeSelection)(tr.selection)) return null;
            const { $from: $from } = tr.selection;
            const $insertPos = position ? tr.doc.resolve(position) : (0, $5r0mK.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
            let lookDirection;
            const insertPosEnd = $insertPos.end();
            const insertPosStart = $insertPos.start();
            if ((0, (0, parcelRequire("594Yf")).isEmptyParagraph)($insertPos.parent)) {
                if ($3c014faca3b7f131$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
                else if ($3c014faca3b7f131$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
            } else {
                if ($insertPos.pos === insertPosEnd) lookDirection = "after";
                else if ($insertPos.pos === insertPosStart) lookDirection = "before";
            }
            const grandParentNodeType = tr.selection.$from.node(-1)?.type;
            const parentNodeType = tr.selection.$from.parent.type;
            const noDirectionAndShouldNotSplit = !lookDirection && !$3c014faca3b7f131$export$b80431b156693a98({
                parentNodeType: parentNodeType,
                grandParentNodeType: grandParentNodeType,
                content: content
            });
            const ruleNodeInANestedListNode = content.type === nodes.rule && $3c014faca3b7f131$var$selectionIsInNestedList(tr);
            const nonRuleNodeInListNode = !(content.type === nodes.rule) && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
            if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$3c014faca3b7f131$var$nodeIsInsideAList(tr)) return (0, $5r0mK.safeInsert)(content, tr.selection.from)(tr);
            const { from: from, to: to } = tr.selection;
            const ruleTypeInAList = content.type === nodes.rule && $3c014faca3b7f131$var$nodeIsInsideAList(tr);
            if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, (0, parcelRequire("kCV8T")).Slice)((0, (0, parcelRequire("kCV8T")).Fragment).from(nodes.rule.createChecked()), 0, 0));
            if (!lookDirection) return null;
            if ((0, (0, parcelRequire("594Yf")).isEmptyParagraph)($insertPos.parent) && (0, $5r0mK.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $3c014faca3b7f131$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
            let $proposedPosition = $insertPos;
            while($proposedPosition.depth > 0){
                const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
                const parentNode = $parentPos.node();
                if ((0, $5r0mK.canInsert)($proposedPosition, content)) return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
                if ($3c014faca3b7f131$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                    const nextTr = $3c014faca3b7f131$var$finaliseInsert($3c014faca3b7f131$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                    if ([
                        nodes.orderedList,
                        nodes.bulletList
                    ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                    else return nextTr;
                }
                $proposedPosition = $parentPos;
            }
            return $3c014faca3b7f131$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
        };
    const $3c014faca3b7f131$var$finaliseInsert = (tr, nodeLength)=>{
        const lastStep = tr.steps[tr.steps.length - 1];
        if (!(lastStep instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || lastStep instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep))) return null;
        const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
        return tr.setSelection(new (0, (0, parcelRequire("hPjvp")).GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, (0, parcelRequire("hPjvp")).Side).RIGHT)).scrollIntoView();
    };
    const $3c014faca3b7f131$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
            if (!maybeNode) return tr;
            const isInputFragment = maybeNode instanceof (0, (0, parcelRequire("kCV8T")).Fragment);
            let node;
            try {
                node = maybeNode instanceof (0, (0, parcelRequire("kCV8T")).Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, (0, parcelRequire("kCV8T")).Node).fromJSON(state.schema, maybeNode);
            } catch (e) {
                console.error(e);
                return tr;
            }
            if (node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.isText) tr = tr.replaceWith(start, start, node);
            else if (node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.isBlock) {
                const selectionInsideAPanel = $3c014faca3b7f131$var$selectionIsInsideAPanel(tr);
                if (node.type.name === 'rule' && !selectionInsideAPanel && !(0, (0, parcelRequire("594Yf")).isEmptyParagraph)(tr.selection.$from.parent)) tr = $3c014faca3b7f131$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
                else tr = (0, $5r0mK.safeInsert)($3c014faca3b7f131$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
            } else if (node instanceof (0, (0, parcelRequire("kCV8T")).Node) && node.isInline || isInputFragment) {
                const fragment = isInputFragment ? node : (0, (0, parcelRequire("kCV8T")).Fragment).fromArray([
                    node,
                    state.schema.text(' ')
                ]);
                if (opts.isTemplate) return $3c014faca3b7f131$var$insertTemplateFragment({
                    fragment: fragment,
                    tr: tr,
                    position: {
                        start: start,
                        end: start
                    }
                });
                tr = tr.replaceWith(start, start, fragment);
                if (opts.selectInlineNode) tr = tr.setSelection((0, (0, parcelRequire("gZGBX")).NodeSelection).create(tr.doc, start));
                else tr = tr.setSelection((0, (0, parcelRequire("gZGBX")).Selection).near(tr.doc.resolve(start + fragment.size)));
            }
            return tr;
        };
    const $3c014faca3b7f131$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
        if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, (0, parcelRequire("kCV8T")).Fragment).from(content))) return true;
        return false;
    };
    function $3c014faca3b7f131$export$b6980e4b8ea578a5(state) {
        const { $from: $from, $to: $to } = state.selection;
        let isAllowedChild = true;
        state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
            if (!withinSelection) return;
            if (!isAllowedChild) return false;
            return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
        });
        return isAllowedChild;
    }
    const $3c014faca3b7f131$var$insertTemplateFragment = ({ fragment: fragment, tr: tr, position: position })=>{
        const { start: start } = position;
        const trWithInsert = (0, $5r0mK.safeInsert)(fragment, start)(tr);
        tr.setSelection(trWithInsert.selection);
        return tr;
    };
});
parcelRegister("ctcYc", function(module, exports) {
    $parcel$export(module.exports, "openTypeAheadAtCursor", ()=>$4b1439ea28428b41$export$e7ce737179b76875);
    var $hPjvp;
    var $gZGBX;
    var $7eFnB;
    var $b6IDf;
    const $4b1439ea28428b41$export$adbec20dbbf15a6b = (props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query } = props;
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
                params: {
                    triggerHandler: triggerHandler,
                    inputMethod: inputMethod,
                    query: query
                }
            });
        };
    const $4b1439ea28428b41$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query })=>({ tr: tr })=>{
            $4b1439ea28428b41$export$adbec20dbbf15a6b({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query
            })(tr);
            const { selection: selection } = tr;
            const isInline = selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection) && selection.node.type.isInline;
            if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection) || selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection) || selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection))) return tr;
            if (selection instanceof (0, (0, parcelRequire("hPjvp")).GapCursorSelection)) {
                tr.insertText(' ');
                tr.delete(tr.selection.from - 1, tr.selection.from);
            } else {
                if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
                    if (isInline) {
                        tr.deleteSelection();
                        return tr;
                    }
                    return tr;
                }
                if (!selection.$cursor) {
                    tr.deleteSelection();
                    return tr;
                }
                const cursorPos = selection.$cursor.pos;
                const nodeAtCursor = tr.doc.nodeAt(cursorPos);
                const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
                if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
                if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger)) tr.delete(cursorPos - 1, cursorPos);
            }
            return tr;
        };
});
parcelRegister("8oJYH", function(module, exports) {
    $parcel$export(module.exports, "inputRulePlugin", ()=>$3181220485a0177f$export$568a7ed6897c4817);
    var $gkwXh;
    var $5KWxh;
    var $2Abpa;
    var $inLhu;
    var $ctcYc;
    function $3181220485a0177f$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
        if (!typeAheads || typeAheads.length === 0) return;
        const rules = typeAheads.reduce((acc, typeAhead)=>{
            const trigger = typeAhead.customRegex || typeAhead.trigger;
            if (!trigger) return acc;
            const regex = new RegExp(`(^|[.!?\\s${(0, $d19733ae55e58348$export$a96b909f1510512b)}])(${trigger})$`);
            acc.push((0, (0, parcelRequire("2Abpa")).createRule)(regex, (state, match)=>{
                return (0, (0, parcelRequire("ctcYc")).openTypeAheadAtCursor)({
                    triggerHandler: typeAhead,
                    inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD
                })({
                    tr: state.tr
                });
            }));
            return acc;
        }, []);
        const plugin = new (0, (0, parcelRequire("5KWxh")).SafePlugin)((0, (0, parcelRequire("inLhu")).createPlugin)('type-ahead', rules, {
            allowInsertTextOnDocument: false
        }));
        return plugin;
    }
    var $3181220485a0177f$export$2e2bcd8739ae039 = $3181220485a0177f$export$568a7ed6897c4817;
});
parcelRegister("ldgDZ", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$8bd7a547b078e11d$export$ae829ec7b2625219);
    var $5KWxh;
    var $7eFnB;
    var $a6cBt;
    function $8bd7a547b078e11d$export$ae829ec7b2625219() {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            appendTransaction (transactions, _oldState, newState) {
                const insertItemCallback = (0, (0, parcelRequire("a6cBt")).isInsertionTransaction)(transactions, (0, (0, parcelRequire("7eFnB")).ACTIONS).INSERT_ITEM);
                if (insertItemCallback) {
                    const tr = insertItemCallback(newState);
                    if (tr) return tr;
                }
            }
        });
    }
});
parcelRegister("a6cBt", function(module, exports) {
    $parcel$export(module.exports, "isInsertionTransaction", ()=>$2056d03687a2446d$export$e715282b081c154e);
    var $b6IDf;
    const $2056d03687a2446d$export$e715282b081c154e = (transactions, action)=>{
        const tr = transactions.find((tr)=>tr.getMeta((0, (0, parcelRequire("b6IDf")).pluginKey))?.action === action);
        if (!tr) return null;
        return tr.getMeta((0, (0, parcelRequire("b6IDf")).pluginKey))?.params;
    };
});
parcelRegister("2RUDH", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$45b1a64a630ececf$export$ae829ec7b2625219);
    var $ez3YZ;
    var $5KWxh;
    var $eQcNy;
    var $etG8M;
    var $7eFnB;
    var $8oQ7W;
    var $ieoPC;
    var $a6cBt;
    var $b6IDf;
    var $dp8V8;
    const $45b1a64a630ececf$var$hasValidTypeAheadStep = (tr)=>{
        const steps = tr.steps.filter((step)=>step instanceof (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep));
        if (steps.length === 1) return steps[0];
        return null;
    };
    function $45b1a64a630ececf$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
        const intl = getIntl();
        const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, (0, parcelRequire("ieoPC")).factoryDecorations)({
            intl: intl,
            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
            popupMountRef: popupMountRef
        });
        const reducer = (0, (0, parcelRequire("dp8V8")).createReducer)({
            createDecorations: createDecorations,
            removeDecorations: removeDecorations,
            typeAheadHandlers: typeAheadHandlers,
            popupMountRef: popupMountRef
        });
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("b6IDf")).pluginKey),
            state: {
                init () {
                    return {
                        typeAheadHandlers: typeAheadHandlers,
                        query: '',
                        decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                        decorationElement: null,
                        items: [],
                        selectedIndex: -1,
                        stats: null,
                        inputMethod: null
                    };
                },
                apply (tr, currentPluginState, oldEditorState, state) {
                    const customStep = $45b1a64a630ececf$var$hasValidTypeAheadStep(tr);
                    const nextPluginState = reducer(tr, currentPluginState, customStep);
                    if (currentPluginState !== nextPluginState) reactDispatch((0, (0, parcelRequire("b6IDf")).pluginKey), nextPluginState);
                    return nextPluginState;
                }
            },
            appendTransaction (transactions, _oldState, newState) {
                const insertItemCallback = (0, (0, parcelRequire("a6cBt")).isInsertionTransaction)(transactions, (0, (0, parcelRequire("7eFnB")).ACTIONS).INSERT_RAW_QUERY);
                if (insertItemCallback) {
                    const tr = insertItemCallback(newState);
                    if (tr) return tr;
                }
            },
            view () {
                return {
                    update (editorView) {}
                };
            },
            props: {
                decorations: (state)=>{
                    return (0, (0, parcelRequire("b6IDf")).pluginKey).getState(state)?.decorationSet;
                },
                handleDOMEvents: {
                    compositionend: (view, event)=>{
                        return false;
                    },
                    click: (view, event)=>{
                        const { target: target } = event;
                        if (target instanceof HTMLElement && (0, (0, parcelRequire("eQcNy")).closest)(target, `[data-type-ahead=${(0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                        return false;
                    }
                }
            }
        });
    }
});
parcelRegister("8oQ7W", function(module, exports) {
    $parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", ()=>$6f65c97870929cfc$export$65dc1d975bd3407b);
    $parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", ()=>$6f65c97870929cfc$export$be8a8259777b339f);
    $parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", ()=>$6f65c97870929cfc$export$a5cdf6890cae94d6);
    $parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", ()=>$6f65c97870929cfc$export$a38374e9651d6165);
    $parcel$export(module.exports, "CloseSelectionOptions", ()=>$6f65c97870929cfc$export$fc2dc87cf13c1ab1);
    const $6f65c97870929cfc$export$65dc1d975bd3407b = 'typeahead_decoration_key';
    const $6f65c97870929cfc$export$be8a8259777b339f = 'typeaheadDecoration';
    const $6f65c97870929cfc$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
    const $6f65c97870929cfc$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
    var $6f65c97870929cfc$export$fc2dc87cf13c1ab1;
    (function(CloseSelectionOptions) {
        CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
        CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    })($6f65c97870929cfc$export$fc2dc87cf13c1ab1 || ($6f65c97870929cfc$export$fc2dc87cf13c1ab1 = {}));
});
parcelRegister("ieoPC", function(module, exports) {
    $parcel$export(module.exports, "factoryDecorations", ()=>$f1ca46bfdfc04632$export$116b677c5744e397);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $i5FdW;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1SLCf = parcelRequire("1SLCf");
    var $fZzhT;
    var $gZGBX;
    var $etG8M;
    var $VSDnB;
    var $kQKqn;
    var $5Vwh8;
    var $8oQ7W;
    var $2D6mf;
    var $iiwBk;
    const $f1ca46bfdfc04632$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
        const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
            const { selection: selection } = tr;
            if (!(selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection)) || !selection.$cursor) return {
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                stats: null,
                decorationElement: null
            };
            const decorationId = `decoration_id_${(0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_KEY)}_${(0, ($parcel$interopDefault($7Jxgt)))()}`;
            const { $cursor: $cursor } = selection;
            const typeaheadComponent = document.createElement('mark');
            const stats = new (0, (0, parcelRequire("2D6mf")).StatsModifier)();
            let shouldFocusCursorInsideQuery = true;
            const deco = (0, (0, parcelRequire("etG8M")).Decoration).widget($cursor.pos, (editorView, getDecorationPosition)=>{
                typeaheadComponent.setAttribute('id', decorationId);
                typeaheadComponent.setAttribute('role', 'search');
                typeaheadComponent.dataset.typeAheadQuery = 'true';
                typeaheadComponent.dataset.trigger = triggerHandler.trigger;
                typeaheadComponent.dataset.editorPopup = 'true';
                typeaheadComponent.dataset.typeAhead = (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
                typeaheadComponent.style.color = `var(--ds-text-accent-blue, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})`;
                typeaheadComponent.style.backgroundColor = 'transparent';
                const onUndoRedo = (inputType)=>{
                    if (![
                        'historyUndo',
                        'historyRedo'
                    ].includes(inputType)) return false;
                    const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                    const currentQuery = (0, (0, parcelRequire("iiwBk")).getTypeAheadQuery)(editorView.state);
                    if (hasReopenQuery || currentQuery?.length === 0) {
                        const command = inputType === 'historyUndo' ? (0, (0, parcelRequire("fZzhT")).undo) : (0, (0, parcelRequire("fZzhT")).redo);
                        let tr = editorView.state.tr;
                        const fakeDispatch = (customTr)=>{
                            tr = customTr;
                        };
                        const result = command(editorView.state, fakeDispatch);
                        if (result) {
                            (0, (0, parcelRequire("5Vwh8")).closeTypeAhead)(tr);
                            editorView.dispatch(tr);
                            editorView.focus();
                        }
                        return result;
                    }
                    return false;
                };
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_plugin_portalprovider')) nodeViewPortalProviderAPI.render(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                        locale: intl.locale || 'en',
                        messages: intl.messages,
                        formats: intl.formats
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kQKqn")).WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery
                    })), typeaheadComponent, decorationId);
                else (0, ($parcel$interopDefault($7nsd3))).render((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
                    locale: intl.locale || 'en',
                    messages: intl.messages,
                    formats: intl.formats
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kQKqn")).WrapperTypeAhead), {
                    triggerHandler: triggerHandler,
                    editorView: editorView,
                    anchorElement: typeaheadComponent,
                    inputMethod: inputMethod,
                    getDecorationPosition: getDecorationPosition,
                    shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                    popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                    popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                    popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                    onUndoRedo: onUndoRedo,
                    reopenQuery: reopenQuery
                })), typeaheadComponent);
                shouldFocusCursorInsideQuery = false;
                return typeaheadComponent;
            }, {
                isTypeAheadDecoration: true,
                key: decorationId,
                side: 0,
                stopEvent: (e)=>{
                    const key = (0, $1SLCf.keyName)(e);
                    const sel = document.getSelection();
                    if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                    return true;
                },
                ignoreSelection: false
            });
            return {
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, [
                    deco
                ]),
                decorationElement: typeaheadComponent,
                stats: stats
            };
        };
        const removeDecorations = (decorationSet)=>{
            if (!decorationSet || decorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) return false;
            const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
                return spec.isTypeAheadDecoration;
            });
            if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
            typeAheadDecorations.forEach(({ spec: spec })=>{
                if (!spec.key) return;
                const decoElement = document.querySelector(`#${spec.key}`);
                if (!decoElement) return;
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_plugin_portalprovider')) nodeViewPortalProviderAPI.remove(spec.key);
                else (0, ($parcel$interopDefault($7nsd3))).unmountComponentAtNode(decoElement);
            });
            return true;
        };
        return {
            createDecorations: createDecorations,
            removeDecorations: removeDecorations
        };
    };
});
parcelRegister("kQKqn", function(module, exports) {
    $parcel$export(module.exports, "WrapperTypeAhead", ()=>$8ef46ca5d5299ac6$export$970faf6afe0d9376);
    var $5uXOq = parcelRequire("5uXOq");
    var $3UtTx;
    var $2sbpe;
    var $iiwBk;
    var $ihi8h;
    var $kjRsq;
    var $52b7w;
    var $kz2Z2;
    const $8ef46ca5d5299ac6$export$970faf6afe0d9376 = (0, ($parcel$interopDefault($5uXOq))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo })=>{
        const [closed, setClosed] = (0, $5uXOq.useState)(false);
        const [query, setQuery] = (0, $5uXOq.useState)(reopenQuery || '');
        const queryRef = (0, $5uXOq.useRef)(query);
        const editorViewRef = (0, $5uXOq.useRef)(editorView);
        const items = (0, (0, parcelRequire("kjRsq")).useLoadItems)(triggerHandler, editorView, query);
        (0, $5uXOq.useLayoutEffect)(()=>{
            queryRef.current = query;
        }, [
            query
        ]);
        const [onItemInsert, onTextInsert] = (0, (0, parcelRequire("ihi8h")).useItemInsert)(triggerHandler, editorView, items);
        const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iiwBk")).moveSelectedIndex)({
                editorView: editorView,
                direction: 'next'
            }), [
            editorView
        ]);
        const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iiwBk")).moveSelectedIndex)({
                editorView: editorView,
                direction: 'previous'
            }), [
            editorView
        ]);
        const cancel = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
            setClosed(true);
            const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
            onTextInsert({
                forceFocusOnEditor: forceFocusOnEditor,
                setSelectionAt: setSelectionAt,
                text: fullquery
            });
        }, [
            triggerHandler,
            onTextInsert
        ]);
        const insertSelectedItem = (0, $5uXOq.useCallback)((mode = (0, (0, parcelRequire("3UtTx")).SelectItemMode).SELECTED)=>{
            const { current: view } = editorViewRef;
            const { selectedIndex: selectedIndex } = (0, (0, parcelRequire("iiwBk")).getPluginState)(view.state);
            setClosed(true);
            queueMicrotask(()=>{
                onItemInsert({
                    mode: mode,
                    index: selectedIndex,
                    query: queryRef.current
                });
            });
        }, [
            onItemInsert
        ]);
        const showTypeAheadPopupList = (0, $5uXOq.useCallback)(()=>{}, []);
        const closePopup = (0, $5uXOq.useCallback)(()=>{
            setClosed(true);
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            const { current: view } = editorViewRef;
            const pluginState = (0, (0, parcelRequire("iiwBk")).getPluginState)(view.state);
            if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
            (0, (0, parcelRequire("2sbpe")).updateQuery)(query)(view.state, view.dispatch);
        }, [
            query,
            reopenQuery
        ]);
        (0, (0, parcelRequire("52b7w")).useOnForceSelect)({
            triggerHandler: triggerHandler,
            items: items,
            query: query,
            editorView: editorView,
            closePopup: closePopup
        });
        if (closed) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kz2Z2")).InputQuery), {
            triggerQueryPrefix: triggerHandler.trigger,
            onQueryChange: setQuery,
            onItemSelect: insertSelectedItem,
            selectNextItem: selectNextItem,
            selectPreviousItem: selectPreviousItem,
            onQueryFocus: showTypeAheadPopupList,
            cancel: cancel,
            forceFocus: shouldFocusCursorInsideQuery,
            onUndoRedo: onUndoRedo,
            reopenQuery: reopenQuery,
            editorView: editorView,
            items: items
        });
    });
    $8ef46ca5d5299ac6$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';
});
parcelRegister("2sbpe", function(module, exports) {
    $parcel$export(module.exports, "updateQuery", ()=>$51fa8a395f333c02$export$4d1bf8b2f67bcb1);
    var $7eFnB;
    var $b6IDf;
    const $51fa8a395f333c02$export$4d1bf8b2f67bcb1 = (query)=>{
        return (state, dispatch)=>{
            const pluginState = (0, (0, parcelRequire("b6IDf")).pluginKey).getState(state);
            if (pluginState?.query === query) return false;
            const tr = state.tr;
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).CHANGE_QUERY,
                params: {
                    query: query
                }
            });
            if (dispatch) dispatch(tr);
            return true;
        };
    };
});
parcelRegister("ihi8h", function(module, exports) {
    $parcel$export(module.exports, "useItemInsert", ()=>$eb595ad3aa140c9b$export$3a3385069392b26f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3UtTx;
    var $5Vwh8;
    var $eF1Qh;
    var $ecipM;
    var $8oQ7W;
    const $eb595ad3aa140c9b$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        const { tr: tr, schema: schema } = view.state;
        (0, (0, parcelRequire("5Vwh8")).closeTypeAhead)(tr);
        if (text.length > 0) {
            tr.replaceSelectionWith(schema.text(text));
            if (setSelectionAt === (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, (0, parcelRequire("ecipM")).setSelectionBeforeQuery)(text)(tr);
        }
        view.dispatch(tr);
        if (forceFocusOnEditor) view.focus();
    };
    const $eb595ad3aa140c9b$export$3a3385069392b26f = (triggerHandler, editorView, items)=>{
        const editorViewRef = (0, $5uXOq.useRef)(editorView);
        const itemsRef = (0, $5uXOq.useRef)(items);
        const onTextInsert = (0, $5uXOq.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
            if (!triggerHandler) return;
            const { current: view } = editorViewRef;
            $eb595ad3aa140c9b$var$insertRawQuery({
                view: view,
                setSelectionAt: setSelectionAt,
                text: text,
                forceFocusOnEditor: forceFocusOnEditor
            });
        }, [
            triggerHandler
        ]);
        const onItemInsert = (0, $5uXOq.useCallback)(({ mode: mode, index: index, query: query })=>{
            const sourceListItem = itemsRef.current;
            if (sourceListItem.length === 0 || !triggerHandler) {
                const text = `${triggerHandler.trigger}${query}`;
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: text
                });
                return;
            }
            const itemToInsert = sourceListItem[index];
            if (!itemToInsert) return;
            const { current: view } = editorViewRef;
            (0, (0, parcelRequire("eF1Qh")).insertTypeAheadItem)(view)({
                item: itemToInsert,
                handler: triggerHandler,
                mode: mode,
                query: query,
                sourceListItem: sourceListItem
            });
        }, [
            triggerHandler,
            onTextInsert
        ]);
        const onItemMatch = (0, $5uXOq.useCallback)(({ mode: mode, query: query })=>{
            const _items = itemsRef.current;
            if (_items && _items.length > 1) return false;
            if (_items.length === 1) queueMicrotask(()=>{
                onItemInsert({
                    mode: mode,
                    query: query,
                    index: 0
                });
            });
            else {
                const text = `${triggerHandler.trigger}${query}`;
                queueMicrotask(()=>{
                    onTextInsert({
                        forceFocusOnEditor: true,
                        setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED,
                        text: mode === (0, (0, parcelRequire("3UtTx")).SelectItemMode).SPACE ? text.concat(' ') : text
                    });
                });
            }
            return true;
        }, [
            onItemInsert,
            triggerHandler,
            onTextInsert
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            itemsRef.current = items;
        }, [
            items
        ]);
        return [
            onItemInsert,
            onTextInsert,
            onItemMatch
        ];
    };
});
parcelRegister("ecipM", function(module, exports) {
    $parcel$export(module.exports, "setSelectionBeforeQuery", ()=>$323bc7045def31d4$export$5af11333ab9d7643);
    var $gZGBX;
    const $323bc7045def31d4$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
            const currentPosition = tr.selection.$from.pos;
            const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
            const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
            const nextSelection = (0, (0, parcelRequire("gZGBX")).TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
            if (nextSelection) tr.setSelection(nextSelection);
        };
});
parcelRegister("kjRsq", function(module, exports) {
    $parcel$export(module.exports, "useLoadItems", ()=>$d8a2315e9c730da4$export$36f5628e43bc3fcd);
    var $5uXOq = parcelRequire("5uXOq");
    var $7lNrQ;
    const $d8a2315e9c730da4$var$EMPTY_LIST_ITEM = [];
    const $d8a2315e9c730da4$export$36f5628e43bc3fcd = (triggerHandler, editorView, query)=>{
        const [items, setItems] = (0, $5uXOq.useState)($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
        const componentIsMounted = (0, $5uXOq.useRef)(true);
        const editorViewRef = (0, $5uXOq.useRef)(editorView);
        (0, $5uXOq.useEffect)(()=>{
            const getItems = triggerHandler?.getItems;
            if (!getItems) {
                setItems($d8a2315e9c730da4$var$EMPTY_LIST_ITEM);
                return;
            }
            const options = {
                query: query || '',
                editorState: editorView.state
            };
            const { current: view } = editorViewRef;
            getItems(options).then((result)=>{
                const list = result.length > 0 ? result : $d8a2315e9c730da4$var$EMPTY_LIST_ITEM;
                if (componentIsMounted.current) setItems(list);
                queueMicrotask(()=>{
                    (0, (0, parcelRequire("7lNrQ")).updateListItem)(list)(view.state, view.dispatch);
                });
            });
        }, [
            triggerHandler,
            query
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                componentIsMounted.current = false;
            };
        }, []);
        return items;
    };
});
parcelRegister("7lNrQ", function(module, exports) {
    $parcel$export(module.exports, "updateListItem", ()=>$3098d34af4194062$export$e482099e4c227d2);
    var $7eFnB;
    var $b6IDf;
    const $3098d34af4194062$export$e482099e4c227d2 = (items)=>{
        return (state, dispatch)=>{
            const tr = state.tr;
            tr.setMeta((0, (0, parcelRequire("b6IDf")).pluginKey), {
                action: (0, (0, parcelRequire("7eFnB")).ACTIONS).UPDATE_LIST_ITEMS,
                params: {
                    items: items
                }
            });
            if (dispatch) dispatch(tr);
            return true;
        };
    };
});
parcelRegister("52b7w", function(module, exports) {
    $parcel$export(module.exports, "useOnForceSelect", ()=>$be9bd9cb734881d4$export$4715c10ec9ca9321);
    var $5uXOq = parcelRequire("5uXOq");
    var $3UtTx;
    var $eF1Qh;
    const $be9bd9cb734881d4$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
        const editorViewRef = (0, $5uXOq.useRef)(editorView);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!query || typeof triggerHandler.forceSelect !== 'function') return;
            const item = triggerHandler.forceSelect({
                items: items,
                query: query,
                editorState: editorViewRef.current.state
            });
            if (!item) return;
            const { current: view } = editorViewRef;
            closePopup();
            queueMicrotask(()=>{
                (0, (0, parcelRequire("eF1Qh")).insertTypeAheadItem)(view)({
                    item: item,
                    mode: (0, (0, parcelRequire("3UtTx")).SelectItemMode).SPACE,
                    query: query,
                    handler: triggerHandler,
                    sourceListItem: items
                });
            });
        }, [
            triggerHandler,
            closePopup,
            query,
            items
        ]);
    };
});
parcelRegister("kz2Z2", function(module, exports) {
    $parcel$export(module.exports, "InputQuery", ()=>$aac54d4dcb1a378a$export$efc9b80896822e63);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $1SLCf = parcelRequire("1SLCf");
    var $gE8f9;
    var $3UtTx;
    var $8ptyJ;
    var $iHYdz;
    var $8oQ7W;
    var $iiwBk;
    var $k1TTu;
    const $aac54d4dcb1a378a$var$querySpanStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        outline: 'none',
        '& input': {
            width: '5px',
            border: 'none',
            background: 'transparent',
            padding: 0,
            margin: 0,
            fontSize: '1em',
            height: (0, (0, parcelRequire("iHYdz")).blockNodesVerticalMargin),
            caretColor: "var(--ds-text-accent-blue, #0052CC)"
        }
    });
    const $aac54d4dcb1a378a$var$isNavigationKey = (event)=>{
        return [
            'Enter',
            'Tab',
            'ArrowDown',
            'ArrowUp'
        ].includes(event.key);
    };
    const $aac54d4dcb1a378a$var$isUndoRedoShortcut = (event)=>{
        const key = (0, $1SLCf.keyName)(event);
        if (event.ctrlKey && key === 'y') return 'historyRedo';
        if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
        if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
        return false;
    };
    const $aac54d4dcb1a378a$var$getAriaLabel = (triggerPrefix, intl)=>{
        switch(triggerPrefix){
            case '@':
                return (0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).mentionInputLabel;
            case '/':
                return (0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).quickInsertInputLabel;
            case ':':
                return (0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).emojiInputLabel;
            default:
                return (0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).quickInsertInputLabel;
        }
    };
    const $aac54d4dcb1a378a$export$efc9b80896822e63 = (0, ($parcel$interopDefault($5uXOq))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
        const ref = (0, $5uXOq.useRef)(document.createElement('span'));
        const inputRef = (0, $5uXOq.useRef)(null);
        const [query, setQuery] = (0, $5uXOq.useState)(null);
        const cleanedInputContent = (0, $5uXOq.useCallback)(()=>{
            const raw = ref.current?.textContent || '';
            return raw;
        }, []);
        const onKeyUp = (0, $5uXOq.useCallback)((event)=>{
            const text = cleanedInputContent();
            onQueryChange(text);
        }, [
            onQueryChange,
            cleanedInputContent
        ]);
        const [isInFocus, setInFocus] = (0, $5uXOq.useState)(false);
        const checkKeyEvent = (0, $5uXOq.useCallback)((event)=>{
            const key = (0, $1SLCf.keyName)(event);
            const sel = document.getSelection();
            const raw = ref.current?.textContent || '';
            const text = cleanedInputContent();
            let stopDefault = false;
            const { selectedIndex: selectedIndex } = (0, (0, parcelRequire("iiwBk")).getPluginState)(editorView.state) || {};
            setInFocus(true);
            switch(key){
                case ' ':
                    if (text.length === 0) {
                        cancel({
                            forceFocusOnEditor: true,
                            text: ' ',
                            addPrefixTrigger: true,
                            setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED
                        });
                        stopDefault = true;
                    }
                    break;
                case 'Escape':
                case 'PageUp':
                case 'PageDown':
                case 'Home':
                    cancel({
                        text: text,
                        forceFocusOnEditor: true,
                        addPrefixTrigger: true,
                        setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                    break;
                case 'Backspace':
                    if (raw.length === 0 || sel?.anchorOffset === 0) {
                        event.stopPropagation();
                        event.preventDefault();
                        cancel({
                            forceFocusOnEditor: true,
                            text: text,
                            addPrefixTrigger: false,
                            setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).BEFORE_TEXT_INSERTED
                        });
                    }
                    break;
                case 'Enter':
                    if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                        if (selectedIndex === -1) {
                            selectPreviousItem();
                            selectNextItem();
                        }
                        onItemSelect(event.shiftKey ? (0, (0, parcelRequire("3UtTx")).SelectItemMode).SHIFT_ENTER : (0, (0, parcelRequire("3UtTx")).SelectItemMode).ENTER);
                    }
                    break;
                case 'Tab':
                    if (selectedIndex === -1) {
                        selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect((0, (0, parcelRequire("3UtTx")).SelectItemMode).TAB);
                    break;
                case 'ArrowDown':
                    selectNextItem();
                    break;
                case 'ArrowUp':
                    selectPreviousItem();
                    break;
            }
            const undoRedoType = $aac54d4dcb1a378a$var$isUndoRedoShortcut(event);
            if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
            if ($aac54d4dcb1a378a$var$isNavigationKey(event) || stopDefault) {
                event.stopPropagation();
                event.preventDefault();
                return false;
            }
        }, [
            onUndoRedo,
            onItemSelect,
            selectNextItem,
            selectPreviousItem,
            cancel,
            cleanedInputContent,
            editorView.state
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            event.preventDefault();
            onQueryFocus();
            inputRef.current?.focus();
            return false;
        }, [
            onQueryFocus
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!ref.current) return;
            const { current: element } = ref;
            const onFocusIn = (event)=>{
                onQueryFocus();
            };
            const keyDown = (event)=>{
                const key = (0, $1SLCf.keyName)(event);
                if ([
                    'ArrowLeft',
                    'ArrowRight'
                ].includes(key) && document.getSelection && document.getSelection()) {
                    const q = ref.current?.textContent || '';
                    const sel = document.getSelection();
                    const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                    const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                    if (!isMovingRight && !isMovingLeft) return;
                    cancel({
                        forceFocusOnEditor: true,
                        addPrefixTrigger: true,
                        text: cleanedInputContent(),
                        setSelectionAt: isMovingRight ? (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                    event.preventDefault();
                    event.stopPropagation();
                    return;
                }
                checkKeyEvent(event);
            };
            const onFocusOut = (event)=>{
                const { relatedTarget: relatedTarget } = event;
                if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_POPUP_CONTENT_CLASS)}`)) return;
                if ((0, (0, parcelRequire("gE8f9")).browser).chrome && !(window.getSelection()?.type === 'Range') && !('sourceCapabilities' in event && event.sourceCapabilities)) return;
                cancel({
                    addPrefixTrigger: true,
                    text: cleanedInputContent(),
                    setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                    forceFocusOnEditor: false
                });
            };
            const close = ()=>{
                cancel({
                    addPrefixTrigger: false,
                    text: '',
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
            };
            const beforeinput = (e)=>{
                setInFocus(false);
                const { target: target } = e;
                if (e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
                if (e.data != null && inputRef.current === null) {
                    setQuery('');
                    if ((0, (0, parcelRequire("gE8f9")).browser).safari) {
                        e.preventDefault();
                        const dataElement = document.createTextNode(e.data);
                        element.appendChild(dataElement);
                        const sel = window.getSelection();
                        const range = document.createRange();
                        range.setStart(dataElement, dataElement.length);
                        range.collapse(true);
                        sel?.removeAllRanges();
                        sel?.addRange(range);
                    }
                }
            };
            let onInput = ()=>{};
            if ((0, (0, parcelRequire("gE8f9")).browser).safari) {
                const onInput = (e)=>{
                    const { target: target } = e;
                    if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                    if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                        e.preventDefault();
                        e.stopPropagation();
                        close();
                        return;
                    }
                };
                element.addEventListener('input', onInput);
            }
            element.addEventListener('focusout', onFocusOut);
            element.addEventListener('focusin', onFocusIn);
            element.addEventListener('keydown', keyDown);
            element.addEventListener('beforeinput', beforeinput);
            return ()=>{
                element.removeEventListener('focusout', onFocusOut);
                element.removeEventListener('focusin', onFocusIn);
                element.removeEventListener('keydown', keyDown);
                element.removeEventListener('beforeinput', beforeinput);
                if ((0, (0, parcelRequire("gE8f9")).browser).safari) element.removeEventListener('input', onInput);
            };
        }, [
            triggerQueryPrefix,
            cleanedInputContent,
            onQueryFocus,
            cancel,
            checkKeyEvent,
            editorView.state
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
            if (ref.current && forceFocus) {
                setQuery(hasReopenQuery ? reopenQuery : null);
                requestAnimationFrame(()=>{
                    if (!ref?.current) return;
                    const sel = window.getSelection();
                    if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                        const lastChild = ref.current.lastChild;
                        const range = document.createRange();
                        range.setStart(ref.current.lastChild, lastChild.length);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                    ref.current.focus();
                    setInFocus(true);
                });
            }
        }, [
            forceFocus,
            reopenQuery
        ]);
        const assistiveHintID = (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, triggerQueryPrefix, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $aac54d4dcb1a378a$var$querySpanStyles,
            contentEditable: true,
            ref: ref,
            onKeyUp: onKeyUp,
            onClick: onClick,
            role: "combobox",
            "aria-controls": (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_ELEMENT_ID),
            "aria-autocomplete": "list",
            "aria-expanded": items.length !== 0,
            "aria-labelledby": assistiveHintID,
            suppressContentEditableWarning: true,
            "data-query-prefix": triggerQueryPrefix
        }, query === null ? (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: inputRef,
            type: "text",
            "aria-label": intl.formatMessage($aac54d4dcb1a378a$var$getAriaLabel(triggerQueryPrefix, intl))
        }) : query), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: assistiveHintID,
            style: {
                display: 'none'
            }
        }, intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).inputQueryAssistiveLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k1TTu")).AssistiveText), {
            assistiveText: items.length === 0 ? intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).noSearchResultsLabel, {
                itemsLength: items.length
            }) : '',
            isInFocus: items.length === 0 || isInFocus,
            id: (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_ELEMENT_ID)
        }));
    });
    $aac54d4dcb1a378a$export$efc9b80896822e63.displayName = 'InputQuery';
});
parcelRegister("k1TTu", function(module, exports) {
    $parcel$export(module.exports, "AssistiveText", ()=>$ab42c0a7d64ff093$export$568f929105953699);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lFKmC = parcelRequire("lFKmC");
    var $VSDnB;
    function $ab42c0a7d64ff093$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ab42c0a7d64ff093$var$statusDebounceMillis = 1400;
    const $ab42c0a7d64ff093$var$assitiveTextStyles = {
        name: "v66mgv",
        styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
    };
    class $ab42c0a7d64ff093$var$AssistveTextOld extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = {
                statusDebounceMillis: 1400,
                debounce: true,
                assistiveText: '',
                isInFocus: false,
                id: ''
            };
        }
        UNSAFE_componentWillMount() {
            this.debounceStatusUpdate = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                if (!this.state.debounced) {
                    const shouldSilence = !this.props.isInFocus;
                    this.setState(({ bump: bump })=>({
                            bump: !bump,
                            debounced: true,
                            silenced: shouldSilence
                        }));
                }
            }, $ab42c0a7d64ff093$var$statusDebounceMillis);
        }
        UNSAFE_componentWillUnmount() {
            this.debounceStatusUpdate.cancel();
        }
        UNSAFE_componentWillReceiveProps() {
            this.setState(({ bump: bump })=>({
                    bump: !bump,
                    debounced: false
                }));
        }
        render() {
            const { assistiveText: assistiveText, id: id } = this.props;
            const { bump: bump, debounced: debounced, silenced: silenced } = this.state;
            this.debounceStatusUpdate();
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $ab42c0a7d64ff093$var$assitiveTextStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testId": id + '__status--A',
                id: id + '__status--A',
                role: "status",
                "aria-atomic": "true",
                "aria-live": "polite"
            }, `${!silenced && debounced && bump ? assistiveText : ''}`), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testId": id + '__status--B',
                id: id + '__status--B',
                role: "status",
                "aria-atomic": "true",
                "aria-live": "polite"
            }, `${!silenced && debounced && !bump ? assistiveText : ''}`));
        }
        constructor(...args){
            super(...args), this.state = {
                bump: false,
                debounced: false,
                silenced: false
            };
        }
    }
    const $ab42c0a7d64ff093$export$c190e0627dbf910a = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: statusDebounceMillis = 1400 })=>{
        const [bump, setBump] = (0, $5uXOq.useState)(false);
        const [debounced, setDebounced] = (0, $5uXOq.useState)(false);
        const [silenced, setSilenced] = (0, $5uXOq.useState)(false);
        const debounceStatusUpdate = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(()=>{
                const shouldSilence = !isInFocus;
                setBump((prevBump)=>!prevBump);
                setDebounced(true);
                setSilenced(shouldSilence);
            }), [
            isInFocus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!debounced) {
                debounceStatusUpdate();
                return ()=>{
                    debounceStatusUpdate.cancel();
                };
            }
        }, [
            assistiveText,
            isInFocus,
            debounced,
            debounceStatusUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (debounced) {
                setBump((prevBump)=>!prevBump);
                setDebounced(true);
                setSilenced(!isInFocus);
            }
        }, [
            assistiveText,
            isInFocus,
            debounced
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $ab42c0a7d64ff093$var$assitiveTextStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": id + '__status--A',
            id: id + '__status--A',
            role: "status",
            "aria-atomic": "true",
            "aria-live": "polite"
        }, !silenced && debounced && bump ? assistiveText : ''), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": id + '__status--B',
            id: id + '__status--B',
            role: "status",
            "aria-atomic": "true",
            "aria-live": "polite"
        }, !silenced && debounced && !bump ? assistiveText : ''));
    };
    const $ab42c0a7d64ff093$export$568f929105953699 = (props)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) return (0, (0, parcelRequire("f8Sb3")).jsx)($ab42c0a7d64ff093$export$c190e0627dbf910a, props);
        else return (0, (0, parcelRequire("f8Sb3")).jsx)($ab42c0a7d64ff093$var$AssistveTextOld, props);
    };
});
parcelRegister("dp8V8", function(module, exports) {
    $parcel$export(module.exports, "createReducer", ()=>$e28e7fc4651e6649$export$473eb76d322d0290);
    var $ez3YZ;
    var $gkwXh;
    var $etG8M;
    var $7eFnB;
    var $b6IDf;
    var $iiwBk;
    const $e28e7fc4651e6649$var$shouldForceOpen = (step)=>{
        if (!(step instanceof (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep))) return false;
        const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).DELETING_RAW_QUERY;
        const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).INSERTING_ITEM;
        return isDeletionRawQueryOperation || isUndoingInsertionItem;
    };
    const $e28e7fc4651e6649$var$shouldForceClose = (step)=>{
        if (!(step instanceof (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep))) return false;
        const isInsertingItem = step.isInsertionStep() && step.stage === (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).INSERTING_ITEM;
        const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStages).DELETING_RAW_QUERY;
        return isInsertingItem || isUndoingDeletionRawQuery;
    };
    const $e28e7fc4651e6649$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
            if (!(step instanceof (0, (0, parcelRequire("ez3YZ")).InsertTypeAheadStep))) return null;
            const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
            return handler || null;
        };
    const $e28e7fc4651e6649$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
        const findHandler = $e28e7fc4651e6649$var$createFindHandler(typeAheadHandlers);
        const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex })=>{
            removeDecorations(currentPluginState.decorationSet);
            const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                reopenQuery: reopenQuery
            });
            return {
                ...currentPluginState,
                stats: stats,
                decorationSet: decorationSet,
                triggerHandler: triggerHandler,
                decorationElement: decorationElement,
                inputMethod: inputMethod,
                selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
                items: [],
                query: reopenQuery || ''
            };
        };
        const closeMenu = (currentPluginState)=>{
            removeDecorations(currentPluginState.decorationSet);
            return {
                ...currentPluginState,
                inputMethod: null,
                query: '',
                decorationElement: null,
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                stats: null,
                triggerHandler: undefined,
                items: []
            };
        };
        return (tr, currentPluginState, typeAheadStepOverride)=>{
            const meta = tr.getMeta((0, (0, parcelRequire("b6IDf")).pluginKey)) || {};
            const overrideHandler = findHandler(typeAheadStepOverride);
            if (typeAheadStepOverride && overrideHandler && $e28e7fc4651e6649$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
                tr: tr,
                triggerHandler: overrideHandler,
                inputMethod: (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD,
                reopenQuery: typeAheadStepOverride.query,
                selectedIndex: typeAheadStepOverride.selectedIndex
            });
            else if ($e28e7fc4651e6649$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
            const { action: action, params: params } = meta || {};
            const shouldOpenMenu = action === (0, (0, parcelRequire("7eFnB")).ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, (0, parcelRequire("iiwBk")).isTypeAheadHandler)(params?.triggerHandler);
            const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
            const shouldCloseMenu = [
                (0, (0, parcelRequire("7eFnB")).ACTIONS).CLOSE_TYPE_AHEAD,
                (0, (0, parcelRequire("7eFnB")).ACTIONS).INSERT_ITEM
            ].includes(action) || selectionChanged;
            const shouldUpdateQuery = action === (0, (0, parcelRequire("7eFnB")).ACTIONS).CHANGE_QUERY;
            const shouldUpdateListItems = action === (0, (0, parcelRequire("7eFnB")).ACTIONS).UPDATE_LIST_ITEMS;
            const shouldUpdateSelectedIndex = action === (0, (0, parcelRequire("7eFnB")).ACTIONS).UPDATE_SELECTED_INDEX;
            if (shouldOpenMenu) return openMenu(currentPluginState, {
                tr: tr,
                triggerHandler: params.triggerHandler,
                inputMethod: params.inputMethod,
                reopenQuery: params.query
            });
            else if (shouldCloseMenu) return closeMenu(currentPluginState);
            else if (shouldUpdateQuery) return {
                ...currentPluginState,
                query: params.query
            };
            else if (shouldUpdateListItems) {
                const { items: items } = params;
                const { selectedIndex: selectedIndex } = currentPluginState;
                return {
                    ...currentPluginState,
                    items: items,
                    selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
                };
            } else if (shouldUpdateSelectedIndex) return {
                ...currentPluginState,
                selectedIndex: params.selectedIndex
            };
            if (tr.docChanged) {
                const { decorationSet: decorationSet } = currentPluginState;
                const onRemove = ()=>{
                    removeDecorations(currentPluginState.decorationSet);
                };
                const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                    onRemove: onRemove
                });
                if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
                return {
                    ...currentPluginState,
                    decorationSet: mappedDecorationSet
                };
            }
            return currentPluginState;
        };
    };
});
parcelRegister("hgbc1", function(module, exports) {
    $parcel$export(module.exports, "ContentComponent", ()=>$d3e8f95cdf408c42$export$2dda1e4a1d1f6a81);
    var $5uXOq = parcelRequire("5uXOq");
    var $awTmI;
    var $gw7Nh;
    function $d3e8f95cdf408c42$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
        const { typeAheadState: typeAheadState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'typeAhead'
        ]);
        if (!typeAheadState) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gw7Nh")).TypeAheadMenu), {
            editorView: editorView,
            popupMountRef: popupMountRef,
            typeAheadState: typeAheadState,
            api: api
        });
    }
});
parcelRegister("gw7Nh", function(module, exports) {
    $parcel$export(module.exports, "TypeAheadMenu", ()=>$cc7eb8bda80979f8$export$b11addef9209139);
    var $5uXOq = parcelRequire("5uXOq");
    var $3UtTx;
    var $bmkwl;
    var $ihi8h;
    var $inLlw;
    const $cc7eb8bda80979f8$export$b11addef9209139 = (0, ($parcel$interopDefault($5uXOq))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, api: api })=>{
        const isOpen = typeAheadState.decorationSet.find().length > 0;
        const { triggerHandler: triggerHandler, items: items, selectedIndex: selectedIndex, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
        const [onItemInsert, onTextInsert, onItemMatch] = (0, (0, parcelRequire("ihi8h")).useItemInsert)(triggerHandler, editorView, items);
        const setSelectedItem = (0, ($parcel$interopDefault($5uXOq))).useCallback(({ index: nextIndex })=>{
            queueMicrotask(()=>{
                (0, (0, parcelRequire("bmkwl")).updateSelectedIndex)(nextIndex)(editorView.state, editorView.dispatch);
            });
        }, [
            editorView
        ]);
        const insertItem = (0, ($parcel$interopDefault($5uXOq))).useCallback((mode = (0, (0, parcelRequire("3UtTx")).SelectItemMode).SELECTED, index)=>{
            queueMicrotask(()=>{
                onItemInsert({
                    mode: mode,
                    index: index,
                    query: query
                });
            });
        }, [
            onItemInsert,
            query
        ]);
        const cancel = (0, ($parcel$interopDefault($5uXOq))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
            const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
            onTextInsert({
                forceFocusOnEditor: forceFocusOnEditor,
                setSelectionAt: setSelectionAt,
                text: fullQuery
            });
        }, [
            triggerHandler,
            onTextInsert,
            query
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!isOpen || !query) return;
            const isLastCharSpace = query[query.length - 1] === ' ';
            if (!isLastCharSpace) return;
            const result = onItemMatch({
                mode: (0, (0, parcelRequire("3UtTx")).SelectItemMode).SPACE,
                query: query.trim()
            });
            if (!result) return;
        }, [
            isOpen,
            query,
            onItemMatch
        ]);
        if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || items.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("inLlw")).TypeAheadPopup), {
            editorView: editorView,
            popupsMountPoint: popupMountRef.current?.popupsMountPoint,
            popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
            popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
            anchorElement: decorationElement,
            triggerHandler: triggerHandler,
            items: items,
            selectedIndex: selectedIndex,
            setSelectedItem: setSelectedItem,
            onItemInsert: insertItem,
            decorationSet: decorationSet,
            isEmptyQuery: !query,
            cancel: cancel,
            api: api
        });
    });
});
parcelRegister("inLlw", function(module, exports) {
    $parcel$export(module.exports, "TypeAheadPopup", ()=>$8352663f3ec19656$export$fbc0702507873a7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7nRxN;
    var $gkwXh;
    var $awTmI;
    var $3UtTx;
    var $f3dKD;
    var $4N9VB;
    var $iHYdz;
    var $8oQ7W;
    var $5tYDm;
    const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
    const $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
    const $8352663f3ec19656$var$ITEM_PADDING = 12;
    const $8352663f3ec19656$var$typeAheadContent = (0, (0, parcelRequire("f8Sb3")).css)({
        background: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}`})`,
        padding: `${"var(--ds-space-050, 4px)"} 0`,
        width: '320px',
        maxHeight: '380px',
        overflowY: 'auto',
        MsOverflowStyle: '-ms-autohiding-scrollbar',
        position: 'relative'
    });
    const $8352663f3ec19656$var$typeAheadContentOverride = (0, (0, parcelRequire("f8Sb3")).css)({
        maxHeight: `${$8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
    });
    const $8352663f3ec19656$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
        if (!triggerHandler?.getHighlight) return null;
        return triggerHandler.getHighlight(state);
    };
    const $8352663f3ec19656$var$OFFSET = [
        0,
        8
    ];
    const $8352663f3ec19656$export$fbc0702507873a7d = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api } = props;
        const ref = (0, $5uXOq.useRef)(null);
        const { featureFlagsState: featureFlagsState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'featureFlags'
        ]);
        const moreElementsInQuickInsertViewEnabled = featureFlagsState?.moreElementsInQuickInsertView && triggerHandler.id === (0, (0, parcelRequire("3UtTx")).TypeAheadAvailableNodes).QUICK_INSERT;
        const defaultMenuHeight = (0, $5uXOq.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $8352663f3ec19656$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
            moreElementsInQuickInsertViewEnabled
        ]);
        const startTime = (0, $5uXOq.useMemo)(()=>performance.now(), [
            items,
            isEmptyQuery,
            triggerHandler
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
            const stopTime = performance.now();
            const time = stopTime - startTime;
            api?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).RENDERED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    time: time,
                    items: items.length,
                    initial: isEmptyQuery
                }
            });
        }, [
            startTime,
            items,
            isEmptyQuery,
            triggerHandler,
            api
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
            api?.analytics?.actions?.fireAnalyticsEvent({
                action: (0, (0, parcelRequire("gkwXh")).ACTION).VIEWED,
                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).TYPEAHEAD_ITEM,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                attributes: {
                    index: selectedIndex,
                    items: items.length
                }
            });
        }, [
            items,
            api,
            selectedIndex,
            triggerHandler
        ]);
        const [fitHeight, setFitHeight] = (0, $5uXOq.useState)(defaultMenuHeight);
        const getFitHeight = (0, $5uXOq.useCallback)(()=>{
            if (!anchorElement || !popupsMountPoint) return;
            const target = anchorElement;
            const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
            const boundariesElement = popupsBoundariesElement || document.body;
            const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
            const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
            const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
            if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
            const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
            const fitHeightWithSpace = newFitHeight - $8352663f3ec19656$var$ITEM_PADDING * 2;
            const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
            return setFitHeight(minFitHeight);
        }, [
            anchorElement,
            defaultMenuHeight,
            popupsBoundariesElement,
            popupsMountPoint
        ]);
        const getFitHeightDebounced = (0, (0, parcelRequire("7nRxN")).default)(getFitHeight);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const scrollableElement = popupsScrollableElement || (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(anchorElement);
            getFitHeight();
            window.addEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) scrollableElement.addEventListener('scroll', getFitHeightDebounced);
            return ()=>{
                window.removeEventListener('resize', getFitHeightDebounced);
                if (scrollableElement) scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
            };
        }, [
            anchorElement,
            popupsScrollableElement,
            getFitHeightDebounced,
            getFitHeight
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const focusOut = (event)=>{
                const { relatedTarget: relatedTarget } = event;
                if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
                if (!(window.getSelection()?.type === 'Range')) return;
                cancel({
                    addPrefixTrigger: true,
                    setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: false
                });
            };
            const { current: element } = ref;
            element?.addEventListener('focusout', focusOut);
            return ()=>{
                element?.removeEventListener('focusout', focusOut);
            };
        }, [
            ref,
            cancel
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const escape = (event)=>{
                if (event.key === 'Escape') cancel({
                    addPrefixTrigger: true,
                    setSelectionAt: (0, (0, parcelRequire("8oQ7W")).CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            };
            const { current: element } = ref;
            element?.addEventListener('keydown', escape);
            return ()=>{
                element?.removeEventListener('keydown', escape);
            };
        }, [
            ref,
            cancel
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4N9VB")).default), {
            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorFloatingDialogZIndex),
            target: anchorElement,
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            fitHeight: fitHeight,
            fitWidth: 340,
            offset: $8352663f3ec19656$var$OFFSET,
            ariaLabel: null,
            preventOverflow: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $8352663f3ec19656$var$typeAheadContent,
                moreElementsInQuickInsertViewEnabled && $8352663f3ec19656$var$typeAheadContentOverride
            ],
            tabIndex: 0,
            className: (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_POPUP_CONTENT_CLASS),
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($8352663f3ec19656$var$Highlight, {
            state: editorView.state,
            triggerHandler: triggerHandler
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5tYDm")).TypeAheadList), {
            items: items,
            selectedIndex: selectedIndex,
            onItemClick: onItemInsert,
            fitHeight: fitHeight,
            editorView: editorView,
            decorationElement: anchorElement,
            triggerHandler: triggerHandler,
            moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled
        })));
    });
    $8352663f3ec19656$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';
});
parcelRegister("5tYDm", function(module, exports) {
    $parcel$export(module.exports, "TypeAheadList", ()=>$d72dfd0f40a0ed4b$export$81b66b5b19964713);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $8RXs9;
    var $koVbs;
    var $7Pkjl = parcelRequire("7Pkjl");
    var $aLlKO = parcelRequire("aLlKO");
    var $3UtTx;
    var $8ptyJ;
    var $eZUJu;
    var $bmkwl;
    var $8oQ7W;
    var $iiwBk;
    var $k1TTu;
    var $gIpUw;
    const $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
    const $d72dfd0f40a0ed4b$var$LIST_WIDTH = 320;
    const $d72dfd0f40a0ed4b$var$list = (0, (0, parcelRequire("f8Sb3")).css)({
        button: {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        }
    });
    const $d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent = (0, ($parcel$interopDefault($5uXOq))).memo(({ numberOfResults: numberOfResults })=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("k1TTu")).AssistiveText), {
            assistiveText: intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).searchResultsLabel, {
                itemsLength: numberOfResults
            }),
            isInFocus: true,
            id: (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
        });
    });
    const $d72dfd0f40a0ed4b$var$TypeAheadListComponent = (0, ($parcel$interopDefault($5uXOq))).memo(({ items: items, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled })=>{
        const listRef = (0, $5uXOq.useRef)();
        const listContainerRef = (0, $5uXOq.useRef)(null);
        const lastVisibleIndexes = (0, $5uXOq.useRef)({
            overscanStartIndex: 0,
            overscanStopIndex: 0,
            startIndex: 0,
            stopIndex: 0
        });
        const estimatedHeight = items.length * $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT;
        const [height, setHeight] = (0, $5uXOq.useState)(Math.min(estimatedHeight, fitHeight));
        const [cache, setCache] = (0, $5uXOq.useState)(new (0, $7Pkjl.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        const onItemsRendered = (0, $5uXOq.useCallback)((props)=>{
            lastVisibleIndexes.current = props;
        }, []);
        const actions = (0, $5uXOq.useMemo)(()=>({
                onItemClick: onItemClick
            }), [
            onItemClick
        ]);
        const isNavigationKey = (event)=>{
            return [
                'ArrowDown',
                'ArrowUp',
                'Tab',
                'Enter'
            ].includes(event.key);
        };
        const focusTargetElement = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("bmkwl")).updateSelectedIndex)(-1)(editorView.state, editorView.dispatch);
            listRef.current.scrollToRow(0);
            decorationElement?.querySelector(`[role='combobox']`)?.focus();
        }, [
            editorView,
            listRef,
            decorationElement
        ]);
        const selectNextItem = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iiwBk")).moveSelectedIndex)({
                editorView: editorView,
                direction: 'next'
            }), [
            editorView
        ]);
        const selectPreviousItem = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("iiwBk")).moveSelectedIndex)({
                editorView: editorView,
                direction: 'previous'
            }), [
            editorView
        ]);
        const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
        const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
        const onScroll = (0, $5uXOq.useCallback)(({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
            if (!scrollUpdateWasRequested) return;
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex;
                    if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
                    else if (selectedIndex === -1) listRef.current.scrollToRow(0);
                });
            });
        }, [
            selectedIndex,
            lastVisibleStartIndex,
            lastVisibleStopIndex
        ]);
        const onMouseMove = (event, index)=>{
            event.preventDefault();
            event.stopPropagation();
            if (selectedIndex === index) return;
            (0, (0, parcelRequire("bmkwl")).updateSelectedIndex)(index)(editorView.state, editorView.dispatch);
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!listRef.current) return;
            const isSelectedItemVisible = selectedIndex >= lastVisibleStartIndex && selectedIndex <= lastVisibleStopIndex;
            if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedIndex);
            else if (selectedIndex === -1) listRef.current.scrollToRow(0);
        }, [
            selectedIndex,
            lastVisibleStartIndex,
            lastVisibleStopIndex
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            setCache(new (0, $7Pkjl.CellMeasurerCache)({
                fixedWidth: true,
                defaultHeight: $d72dfd0f40a0ed4b$var$LIST_ITEM_ESTIMATED_HEIGHT
            }));
            requestAnimationFrame(()=>{
                if (listContainerRef.current?.firstChild) listContainerRef.current.firstChild.scrollTo(0, 0);
            });
        }, [
            items
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const height = Math.min(items.reduce((prevValue, currentValue, index)=>{
                return prevValue + cache.rowHeight({
                    index: index
                });
            }, 0), fitHeight);
            setHeight(height);
        }, [
            items,
            cache,
            fitHeight
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!listContainerRef.current) return;
            const { current: element } = listContainerRef;
            const handleKeyDown = (event)=>{
                if (isNavigationKey(event)) switch(event.key){
                    case 'ArrowDown':
                        selectNextItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'ArrowUp':
                        selectPreviousItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'Tab':
                        onItemClick((0, (0, parcelRequire("3UtTx")).SelectItemMode).TAB, selectedIndex);
                        event.preventDefault();
                        break;
                    case 'Enter':
                        if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                            onItemClick(event.shiftKey ? (0, (0, parcelRequire("3UtTx")).SelectItemMode).SHIFT_ENTER : (0, (0, parcelRequire("3UtTx")).SelectItemMode).ENTER, selectedIndex);
                            event.preventDefault();
                        }
                        break;
                    default:
                        event.preventDefault();
                }
                else focusTargetElement();
            };
            element?.addEventListener('keydown', handleKeyDown);
            return ()=>{
                element?.removeEventListener('keydown', handleKeyDown);
            };
        }, [
            editorView.state,
            focusTargetElement,
            selectNextItem,
            selectPreviousItem,
            selectedIndex,
            onItemClick,
            items.length
        ]);
        const renderRow = ({ index: index, key: key, style: style, parent: parent })=>{
            const currentItem = items[index];
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $7Pkjl.CellMeasurer), {
                key: key,
                cache: cache,
                parent: parent,
                columnIndex: 0,
                rowIndex: index
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                style: style,
                "data-index": index
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": `list-item-height-observed-${index}`,
                onMouseMove: (e)=>onMouseMove(e, index)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gIpUw")).TypeAheadListItem), {
                key: items[index].title,
                item: currentItem,
                itemsLength: items.length,
                itemIndex: index,
                selectedIndex: selectedIndex,
                onItemClick: actions.onItemClick,
                ariaLabel: (0, (0, parcelRequire("iiwBk")).getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl, currentItem).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled
            }))));
        };
        const popupAriaLabel = (0, (0, parcelRequire("iiwBk")).getTypeAheadListAriaLabels)(triggerHandler?.trigger, intl).popupAriaLabel;
        if (!Array.isArray(items)) return null;
        const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, (0, parcelRequire("8oQ7W")).TYPE_AHEAD_DECORATION_ELEMENT_ID);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eZUJu")).default), {
            "aria-label": popupAriaLabel,
            "aria-relevant": "additions removals"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            id: menuGroupId,
            ref: listContainerRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, $aLlKO.List), {
            rowRenderer: renderRow,
            ref: listRef,
            rowCount: items.length,
            rowHeight: cache.rowHeight,
            onRowsRendered: onItemsRendered,
            width: $d72dfd0f40a0ed4b$var$LIST_WIDTH,
            onScroll: onScroll,
            height: height,
            overscanRowCount: 3,
            "aria-label": null,
            containerRole: "presentation",
            role: "listbox",
            css: [
                (0, (0, parcelRequire("f8Sb3")).css)({
                    button: {
                        padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                        'span:last-child span:last-child': {
                            whiteSpace: 'normal'
                        }
                    }
                }),
                moreElementsInQuickInsertViewEnabled && $d72dfd0f40a0ed4b$var$list
            ]
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($d72dfd0f40a0ed4b$var$TypeaheadAssistiveTextPureComponent, {
            numberOfResults: items.length.toString()
        })));
    });
    const $d72dfd0f40a0ed4b$export$81b66b5b19964713 = (0, (0, parcelRequire("8RXs9")).default)($d72dfd0f40a0ed4b$var$TypeAheadListComponent);
    $d72dfd0f40a0ed4b$export$81b66b5b19964713.displayName = 'TypeAheadList';
});
parcelRegister("7Pkjl", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CellMeasurerCache = module.exports.CellMeasurer = undefined;
    var $39v3u = parcelRequire("39v3u");
    var $5b2d0d312f5c1e98$var$_CellMeasurer2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($39v3u);
    var $ewGy7 = parcelRequire("ewGy7");
    var $5b2d0d312f5c1e98$var$_CellMeasurerCache2 = $5b2d0d312f5c1e98$var$_interopRequireDefault($ewGy7);
    function $5b2d0d312f5c1e98$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    module.exports.default = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
    module.exports.CellMeasurer = $5b2d0d312f5c1e98$var$_CellMeasurer2.default;
    module.exports.CellMeasurerCache = $5b2d0d312f5c1e98$var$_CellMeasurerCache2.default;
});
parcelRegister("39v3u", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $29Ol4 = parcelRequire("29Ol4");
    var $24ba4d50b29169e6$var$_getPrototypeOf2 = $24ba4d50b29169e6$var$_interopRequireDefault($29Ol4);
    var $aXTp8 = parcelRequire("aXTp8");
    var $24ba4d50b29169e6$var$_classCallCheck3 = $24ba4d50b29169e6$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $24ba4d50b29169e6$var$_createClass3 = $24ba4d50b29169e6$var$_interopRequireDefault($4tLNB);
    var $5pMaQ = parcelRequire("5pMaQ");
    var $24ba4d50b29169e6$var$_possibleConstructorReturn3 = $24ba4d50b29169e6$var$_interopRequireDefault($5pMaQ);
    var $gHLl6 = parcelRequire("gHLl6");
    var $24ba4d50b29169e6$var$_inherits3 = $24ba4d50b29169e6$var$_interopRequireDefault($gHLl6);
    var $5uXOq = parcelRequire("5uXOq");
    var $24ba4d50b29169e6$var$React = $24ba4d50b29169e6$var$_interopRequireWildcard($5uXOq);
    var $7nsd3 = parcelRequire("7nsd3");
    parcelRequire("bN49P");
    var $8rCP3;
    var $24ba4d50b29169e6$var$_propTypes2 = $24ba4d50b29169e6$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $24ba4d50b29169e6$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $24ba4d50b29169e6$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $24ba4d50b29169e6$var$CellMeasurer = function(_React$PureComponent) {
        (0, $24ba4d50b29169e6$var$_inherits3.default)(CellMeasurer, _React$PureComponent);
        function CellMeasurer() {
            var _ref;
            var _temp, _this, _ret;
            (0, $24ba4d50b29169e6$var$_classCallCheck3.default)(this, CellMeasurer);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(this, (_ref = CellMeasurer.__proto__ || (0, $24ba4d50b29169e6$var$_getPrototypeOf2.default)(CellMeasurer)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this._measure = function() {
                var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;
                var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
                if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                    cache.set(rowIndex, columnIndex, width, height);
                    if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }, _temp), (0, $24ba4d50b29169e6$var$_possibleConstructorReturn3.default)(_this, _ret);
        }
        (0, $24ba4d50b29169e6$var$_createClass3.default)(CellMeasurer, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this._maybeMeasureCell();
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate() {
                    this._maybeMeasureCell();
                }
            },
            {
                key: 'render',
                value: function render() {
                    var children = this.props.children;
                    return typeof children === 'function' ? children({
                        measure: this._measure
                    }) : children;
                }
            },
            {
                key: '_getCellMeasurements',
                value: function _getCellMeasurements() {
                    var cache = this.props.cache;
                    var node = (0, $7nsd3.findDOMNode)(this);
                    if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                        var styleWidth = node.style.width;
                        var styleHeight = node.style.height;
                        if (!cache.hasFixedWidth()) node.style.width = 'auto';
                        if (!cache.hasFixedHeight()) node.style.height = 'auto';
                        var height = Math.ceil(node.offsetHeight);
                        var width = Math.ceil(node.offsetWidth);
                        if (styleWidth) node.style.width = styleWidth;
                        if (styleHeight) node.style.height = styleHeight;
                        return {
                            height: height,
                            width: width
                        };
                    } else return {
                        height: 0,
                        width: 0
                    };
                }
            },
            {
                key: '_maybeMeasureCell',
                value: function _maybeMeasureCell() {
                    var _props = this.props, cache = _props.cache, _props$columnIndex = _props.columnIndex, columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex, parent = _props.parent, _props$rowIndex = _props.rowIndex, rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;
                    if (!cache.has(rowIndex, columnIndex)) {
                        var _getCellMeasurements2 = this._getCellMeasurements(), height = _getCellMeasurements2.height, width = _getCellMeasurements2.width;
                        cache.set(rowIndex, columnIndex, width, height);
                        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                            columnIndex: columnIndex,
                            rowIndex: rowIndex
                        });
                    }
                }
            }
        ]);
        return CellMeasurer;
    }($24ba4d50b29169e6$var$React.PureComponent);
    $24ba4d50b29169e6$var$CellMeasurer.__internalCellMeasurerFlag = false;
    $24ba4d50b29169e6$var$CellMeasurer.propTypes = null;
    module.exports.default = $24ba4d50b29169e6$var$CellMeasurer;
});
parcelRegister("29Ol4", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("22VpG")),
        __esModule: true
    };
});
parcelRegister("22VpG", function(module, exports) {
    parcelRequire("7Invg");
    module.exports = (parcelRequire("dv4GG")).Object.getPrototypeOf;
});
parcelRegister("7Invg", function(module, exports) {
    var $8tRkg = parcelRequire("8tRkg");
    var $97OQk = parcelRequire("97OQk");
    (parcelRequire("8iDav"))('getPrototypeOf', function() {
        return function getPrototypeOf(it) {
            return $97OQk($8tRkg(it));
        };
    });
});
parcelRegister("8tRkg", function(module, exports) {
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(it) {
        return Object($ie6R6(it));
    };
});
parcelRegister("ie6R6", function(module, exports) {
    module.exports = function(it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
    };
});
parcelRegister("97OQk", function(module, exports) {
    var $aMccP = parcelRequire("aMccP");
    var $8tRkg = parcelRequire("8tRkg");
    var $6a4c34daf431297a$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    var $6a4c34daf431297a$var$ObjectProto = Object.prototype;
    module.exports = Object.getPrototypeOf || function(O) {
        O = $8tRkg(O);
        if ($aMccP(O, $6a4c34daf431297a$var$IE_PROTO)) return O[$6a4c34daf431297a$var$IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
        return O instanceof Object ? $6a4c34daf431297a$var$ObjectProto : null;
    };
});
parcelRegister("aMccP", function(module, exports) {
    var $7d87daef9d4e91b8$var$hasOwnProperty = {}.hasOwnProperty;
    module.exports = function(it, key) {
        return $7d87daef9d4e91b8$var$hasOwnProperty.call(it, key);
    };
});
parcelRegister("4BPKE", function(module, exports) {
    var $35b2c2e77589c562$var$shared = (parcelRequire("inCOl"))('keys');
    var $42V7x = parcelRequire("42V7x");
    module.exports = function(key) {
        return $35b2c2e77589c562$var$shared[key] || ($35b2c2e77589c562$var$shared[key] = $42V7x(key));
    };
});
parcelRegister("inCOl", function(module, exports) {
    var $dv4GG = parcelRequire("dv4GG");
    var $pe18r = parcelRequire("pe18r");
    var $d6187b0aaf68f232$var$SHARED = '__core-js_shared__';
    var $d6187b0aaf68f232$var$store = $pe18r[$d6187b0aaf68f232$var$SHARED] || ($pe18r[$d6187b0aaf68f232$var$SHARED] = {});
    (module.exports = function(key, value) {
        return $d6187b0aaf68f232$var$store[key] || ($d6187b0aaf68f232$var$store[key] = value !== undefined ? value : {});
    })('versions', []).push({
        version: $dv4GG.version,
        mode: (parcelRequire("6uq1C")) ? 'pure' : 'global',
        copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
    });
});
parcelRegister("dv4GG", function(module, exports) {
    var $9d41ce6d167d80d2$var$core = module.exports = {
        version: '2.6.12'
    };
    if (typeof __e == 'number') __e = $9d41ce6d167d80d2$var$core;
});
parcelRegister("pe18r", function(module, exports) {
    var $04bd3575bb3eed01$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
    if (typeof __g == 'number') __g = $04bd3575bb3eed01$var$global;
});
parcelRegister("6uq1C", function(module, exports) {
    module.exports = true;
});
parcelRegister("42V7x", function(module, exports) {
    var $2f23a8463a1ba411$var$id = 0;
    var $2f23a8463a1ba411$var$px = Math.random();
    module.exports = function(key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$2f23a8463a1ba411$var$id + $2f23a8463a1ba411$var$px).toString(36));
    };
});
parcelRegister("8iDav", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    var $dv4GG = parcelRequire("dv4GG");
    var $5nD9T = parcelRequire("5nD9T");
    module.exports = function(KEY, exec) {
        var fn = ($dv4GG.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $8EFNH($8EFNH.S + $8EFNH.F * $5nD9T(function() {
            fn(1);
        }), 'Object', exp);
    };
});
parcelRegister("8EFNH", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $dv4GG = parcelRequire("dv4GG");
    var $gnejD = parcelRequire("gnejD");
    var $kM6mh = parcelRequire("kM6mh");
    var $aMccP = parcelRequire("aMccP");
    var $64d27bdec060590e$var$PROTOTYPE = 'prototype';
    var $64d27bdec060590e$var$$export = function(type, name, source) {
        var IS_FORCED = type & $64d27bdec060590e$var$$export.F;
        var IS_GLOBAL = type & $64d27bdec060590e$var$$export.G;
        var IS_STATIC = type & $64d27bdec060590e$var$$export.S;
        var IS_PROTO = type & $64d27bdec060590e$var$$export.P;
        var IS_BIND = type & $64d27bdec060590e$var$$export.B;
        var IS_WRAP = type & $64d27bdec060590e$var$$export.W;
        var exports = IS_GLOBAL ? $dv4GG : $dv4GG[name] || ($dv4GG[name] = {});
        var expProto = exports[$64d27bdec060590e$var$PROTOTYPE];
        var target = IS_GLOBAL ? $pe18r : IS_STATIC ? $pe18r[name] : ($pe18r[name] || {})[$64d27bdec060590e$var$PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;
        for(key in source){
            own = !IS_FORCED && target && target[key] !== undefined;
            if (own && $aMccP(exports, key)) continue;
            out = own ? target[key] : source[key];
            exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $gnejD(out, $pe18r) : IS_WRAP && target[key] == out ? function(C) {
                var F = function(a, b, c) {
                    if (this instanceof C) {
                        switch(arguments.length){
                            case 0:
                                return new C();
                            case 1:
                                return new C(a);
                            case 2:
                                return new C(a, b);
                        }
                        return new C(a, b, c);
                    }
                    return C.apply(this, arguments);
                };
                F[$64d27bdec060590e$var$PROTOTYPE] = C[$64d27bdec060590e$var$PROTOTYPE];
                return F;
            }(out) : IS_PROTO && typeof out == 'function' ? $gnejD(Function.call, out) : out;
            if (IS_PROTO) {
                (exports.virtual || (exports.virtual = {}))[key] = out;
                if (type & $64d27bdec060590e$var$$export.R && expProto && !expProto[key]) $kM6mh(expProto, key, out);
            }
        }
    };
    $64d27bdec060590e$var$$export.F = 1;
    $64d27bdec060590e$var$$export.G = 2;
    $64d27bdec060590e$var$$export.S = 4;
    $64d27bdec060590e$var$$export.P = 8;
    $64d27bdec060590e$var$$export.B = 16;
    $64d27bdec060590e$var$$export.W = 32;
    $64d27bdec060590e$var$$export.U = 64;
    $64d27bdec060590e$var$$export.R = 128;
    module.exports = $64d27bdec060590e$var$$export;
});
parcelRegister("gnejD", function(module, exports) {
    var $jd5tk = parcelRequire("jd5tk");
    module.exports = function(fn, that, length) {
        $jd5tk(fn);
        if (that === undefined) return fn;
        switch(length){
            case 1:
                return function(a) {
                    return fn.call(that, a);
                };
            case 2:
                return function(a, b) {
                    return fn.call(that, a, b);
                };
            case 3:
                return function(a, b, c) {
                    return fn.call(that, a, b, c);
                };
        }
        return function() {
            return fn.apply(that, arguments);
        };
    };
});
parcelRegister("jd5tk", function(module, exports) {
    module.exports = function(it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
    };
});
parcelRegister("kM6mh", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $evesF = parcelRequire("evesF");
    module.exports = (parcelRequire("hn2oF")) ? function(object, key, value) {
        return $30LaA.f(object, key, $evesF(1, value));
    } : function(object, key, value) {
        object[key] = value;
        return object;
    };
});
parcelRegister("30LaA", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$2315f61bd3482fc3$export$2d1720544b23b823, (v)=>$2315f61bd3482fc3$export$2d1720544b23b823 = v);
    var $2315f61bd3482fc3$export$2d1720544b23b823;
    var $6rs9h = parcelRequire("6rs9h");
    var $dzU8d = parcelRequire("dzU8d");
    var $7Af9t = parcelRequire("7Af9t");
    var $2315f61bd3482fc3$var$dP = Object.defineProperty;
    $2315f61bd3482fc3$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        $6rs9h(O);
        P = $7Af9t(P, true);
        $6rs9h(Attributes);
        if ($dzU8d) try {
            return $2315f61bd3482fc3$var$dP(O, P, Attributes);
        } catch (e) {}
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
    };
});
parcelRegister("6rs9h", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    module.exports = function(it) {
        if (!$6VwBm(it)) throw TypeError(it + ' is not an object!');
        return it;
    };
});
parcelRegister("6VwBm", function(module, exports) {
    module.exports = function(it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
    };
});
parcelRegister("dzU8d", function(module, exports) {
    module.exports = !(parcelRequire("hn2oF")) && !(parcelRequire("5nD9T"))(function() {
        return Object.defineProperty((parcelRequire("iSIdA"))('div'), 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("hn2oF", function(module, exports) {
    module.exports = !(parcelRequire("5nD9T"))(function() {
        return Object.defineProperty({}, 'a', {
            get: function() {
                return 7;
            }
        }).a != 7;
    });
});
parcelRegister("5nD9T", function(module, exports) {
    module.exports = function(exec) {
        try {
            return !!exec();
        } catch (e) {
            return true;
        }
    };
});
parcelRegister("iSIdA", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    var $pe18r = parcelRequire("pe18r");
    var $dbef91f2a743dd1e$require$document = $pe18r.document;
    var $dbef91f2a743dd1e$var$is = $6VwBm($dbef91f2a743dd1e$require$document) && $6VwBm($dbef91f2a743dd1e$require$document.createElement);
    module.exports = function(it) {
        return $dbef91f2a743dd1e$var$is ? $dbef91f2a743dd1e$require$document.createElement(it) : {};
    };
});
parcelRegister("7Af9t", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    module.exports = function(it, S) {
        if (!$6VwBm(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !$6VwBm(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
    };
});
parcelRegister("evesF", function(module, exports) {
    module.exports = function(bitmap, value) {
        return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
        };
    };
});
parcelRegister("aXTp8", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$7fba6438b4dbf46b$export$1e511d4a378977f5, (v)=>$7fba6438b4dbf46b$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$7fba6438b4dbf46b$export$2e2bcd8739ae039, (v)=>$7fba6438b4dbf46b$export$2e2bcd8739ae039 = v);
    var $7fba6438b4dbf46b$export$1e511d4a378977f5;
    var $7fba6438b4dbf46b$export$2e2bcd8739ae039;
    "use strict";
    $7fba6438b4dbf46b$export$1e511d4a378977f5 = true;
    $7fba6438b4dbf46b$export$2e2bcd8739ae039 = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    };
});
parcelRegister("4tLNB", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$342ef2b9df8992a7$export$1e511d4a378977f5, (v)=>$342ef2b9df8992a7$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$342ef2b9df8992a7$export$2e2bcd8739ae039, (v)=>$342ef2b9df8992a7$export$2e2bcd8739ae039 = v);
    var $342ef2b9df8992a7$export$1e511d4a378977f5;
    var $342ef2b9df8992a7$export$2e2bcd8739ae039;
    "use strict";
    $342ef2b9df8992a7$export$1e511d4a378977f5 = true;
    var $aWlLP = parcelRequire("aWlLP");
    var $342ef2b9df8992a7$var$_defineProperty2 = $342ef2b9df8992a7$var$_interopRequireDefault($aWlLP);
    function $342ef2b9df8992a7$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $342ef2b9df8992a7$export$2e2bcd8739ae039 = function() {
        function defineProperties(target, props) {
            for(var i = 0; i < props.length; i++){
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                (0, $342ef2b9df8992a7$var$_defineProperty2.default)(target, descriptor.key, descriptor);
            }
        }
        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();
});
parcelRegister("aWlLP", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("cEZdw")),
        __esModule: true
    };
});
parcelRegister("cEZdw", function(module, exports) {
    parcelRequire("7vx5B");
    var $dv4GG = parcelRequire("dv4GG");
    var $9378b4ec927c6689$require$$Object = $dv4GG.Object;
    module.exports = function defineProperty(it, key, desc) {
        return $9378b4ec927c6689$require$$Object.defineProperty(it, key, desc);
    };
});
parcelRegister("7vx5B", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S + $8EFNH.F * !(parcelRequire("hn2oF")), 'Object', {
        defineProperty: (parcelRequire("30LaA")).f
    });
});
parcelRegister("5pMaQ", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$3f14a7e1704920da$export$1e511d4a378977f5, (v)=>$3f14a7e1704920da$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$3f14a7e1704920da$export$2e2bcd8739ae039, (v)=>$3f14a7e1704920da$export$2e2bcd8739ae039 = v);
    var $3f14a7e1704920da$export$1e511d4a378977f5;
    var $3f14a7e1704920da$export$2e2bcd8739ae039;
    "use strict";
    $3f14a7e1704920da$export$1e511d4a378977f5 = true;
    var $kt6ai = parcelRequire("kt6ai");
    var $3f14a7e1704920da$var$_typeof3 = $3f14a7e1704920da$var$_interopRequireDefault($kt6ai);
    function $3f14a7e1704920da$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $3f14a7e1704920da$export$2e2bcd8739ae039 = function(self, call) {
        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return call && ((typeof call === "undefined" ? "undefined" : (0, $3f14a7e1704920da$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
    };
});
parcelRegister("kt6ai", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$ee6b4c58df698443$export$1e511d4a378977f5, (v)=>$ee6b4c58df698443$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$ee6b4c58df698443$export$2e2bcd8739ae039, (v)=>$ee6b4c58df698443$export$2e2bcd8739ae039 = v);
    var $ee6b4c58df698443$export$1e511d4a378977f5;
    var $ee6b4c58df698443$export$2e2bcd8739ae039;
    "use strict";
    $ee6b4c58df698443$export$1e511d4a378977f5 = true;
    var $5YQKd = parcelRequire("5YQKd");
    var $ee6b4c58df698443$var$_iterator2 = $ee6b4c58df698443$var$_interopRequireDefault($5YQKd);
    var $V3332 = parcelRequire("V3332");
    var $ee6b4c58df698443$var$_symbol2 = $ee6b4c58df698443$var$_interopRequireDefault($V3332);
    var $ee6b4c58df698443$var$_typeof = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && typeof $ee6b4c58df698443$var$_iterator2.default === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj;
    };
    function $ee6b4c58df698443$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $ee6b4c58df698443$export$2e2bcd8739ae039 = typeof $ee6b4c58df698443$var$_symbol2.default === "function" && $ee6b4c58df698443$var$_typeof($ee6b4c58df698443$var$_iterator2.default) === "symbol" ? function(obj) {
        return typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
    } : function(obj) {
        return obj && typeof $ee6b4c58df698443$var$_symbol2.default === "function" && obj.constructor === $ee6b4c58df698443$var$_symbol2.default && obj !== $ee6b4c58df698443$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ee6b4c58df698443$var$_typeof(obj);
    };
});
parcelRegister("5YQKd", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("hpbwm")),
        __esModule: true
    };
});
parcelRegister("hpbwm", function(module, exports) {
    parcelRequire("ltQ0T");
    parcelRequire("fQXw1");
    module.exports = (parcelRequire("3iakE")).f('iterator');
});
parcelRegister("ltQ0T", function(module, exports) {
    'use strict';
    var $fa34a72ca0e00838$var$$at = (parcelRequire("TnwZj"))(true);
    (parcelRequire("bH4Ac"))(String, 'String', function(iterated) {
        this._t = String(iterated);
        this._i = 0;
    }, function() {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
            value: undefined,
            done: true
        };
        point = $fa34a72ca0e00838$var$$at(O, index);
        this._i += point.length;
        return {
            value: point,
            done: false
        };
    });
});
parcelRegister("TnwZj", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(TO_STRING) {
        return function(that, pos) {
            var s = String($ie6R6(that));
            var i = $h2TDF(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
    };
});
parcelRegister("h2TDF", function(module, exports) {
    var $c68dc842fc575f58$var$ceil = Math.ceil;
    var $c68dc842fc575f58$var$floor = Math.floor;
    module.exports = function(it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? $c68dc842fc575f58$var$floor : $c68dc842fc575f58$var$ceil)(it);
    };
});
parcelRegister("bH4Ac", function(module, exports) {
    'use strict';
    var $6uq1C = parcelRequire("6uq1C");
    var $8EFNH = parcelRequire("8EFNH");
    var $3VDKT = parcelRequire("3VDKT");
    var $kM6mh = parcelRequire("kM6mh");
    var $eu895 = parcelRequire("eu895");
    var $jEAut = parcelRequire("jEAut");
    var $8nOHH = parcelRequire("8nOHH");
    var $97OQk = parcelRequire("97OQk");
    var $883743f265dc0269$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
    var $883743f265dc0269$var$BUGGY = !([].keys && 'next' in [].keys());
    var $883743f265dc0269$var$FF_ITERATOR = '@@iterator';
    var $883743f265dc0269$var$KEYS = 'keys';
    var $883743f265dc0269$var$VALUES = 'values';
    var $883743f265dc0269$var$returnThis = function() {
        return this;
    };
    module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $jEAut(Constructor, NAME, next);
        var getMethod = function(kind) {
            if (!$883743f265dc0269$var$BUGGY && kind in proto) return proto[kind];
            switch(kind){
                case $883743f265dc0269$var$KEYS:
                    return function keys() {
                        return new Constructor(this, kind);
                    };
                case $883743f265dc0269$var$VALUES:
                    return function values() {
                        return new Constructor(this, kind);
                    };
            }
            return function entries() {
                return new Constructor(this, kind);
            };
        };
        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == $883743f265dc0269$var$VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[$883743f265dc0269$var$ITERATOR] || proto[$883743f265dc0269$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype;
        if ($anyNative) {
            IteratorPrototype = $97OQk($anyNative.call(new Base()));
            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                $8nOHH(IteratorPrototype, TAG, true);
                if (!$6uq1C && typeof IteratorPrototype[$883743f265dc0269$var$ITERATOR] != 'function') $kM6mh(IteratorPrototype, $883743f265dc0269$var$ITERATOR, $883743f265dc0269$var$returnThis);
            }
        }
        if (DEF_VALUES && $native && $native.name !== $883743f265dc0269$var$VALUES) {
            VALUES_BUG = true;
            $default = function values() {
                return $native.call(this);
            };
        }
        if ((!$6uq1C || FORCED) && ($883743f265dc0269$var$BUGGY || VALUES_BUG || !proto[$883743f265dc0269$var$ITERATOR])) $kM6mh(proto, $883743f265dc0269$var$ITERATOR, $default);
        $eu895[NAME] = $default;
        $eu895[TAG] = $883743f265dc0269$var$returnThis;
        if (DEFAULT) {
            methods = {
                values: DEF_VALUES ? $default : getMethod($883743f265dc0269$var$VALUES),
                keys: IS_SET ? $default : getMethod($883743f265dc0269$var$KEYS),
                entries: $entries
            };
            if (FORCED) {
                for(key in methods)if (!(key in proto)) $3VDKT(proto, key, methods[key]);
            } else $8EFNH($8EFNH.P + $8EFNH.F * ($883743f265dc0269$var$BUGGY || VALUES_BUG), NAME, methods);
        }
        return methods;
    };
});
parcelRegister("3VDKT", function(module, exports) {
    module.exports = (parcelRequire("kM6mh"));
});
parcelRegister("eu895", function(module, exports) {
    module.exports = {};
});
parcelRegister("jEAut", function(module, exports) {
    'use strict';
    var $l5MPs = parcelRequire("l5MPs");
    var $evesF = parcelRequire("evesF");
    var $8nOHH = parcelRequire("8nOHH");
    var $e4ee0efba5a7f6a9$var$IteratorPrototype = {};
    (parcelRequire("kM6mh"))($e4ee0efba5a7f6a9$var$IteratorPrototype, (parcelRequire("cNfss"))('iterator'), function() {
        return this;
    });
    module.exports = function(Constructor, NAME, next) {
        Constructor.prototype = $l5MPs($e4ee0efba5a7f6a9$var$IteratorPrototype, {
            next: $evesF(1, next)
        });
        $8nOHH(Constructor, NAME + ' Iterator');
    };
});
parcelRegister("l5MPs", function(module, exports) {
    var $6rs9h = parcelRequire("6rs9h");
    var $hrzgw = parcelRequire("hrzgw");
    var $aIGUN = parcelRequire("aIGUN");
    var $f5aff1030646fd55$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    var $f5aff1030646fd55$var$Empty = function() {};
    var $f5aff1030646fd55$var$PROTOTYPE = 'prototype';
    var $f5aff1030646fd55$var$createDict = function() {
        var iframe = (parcelRequire("iSIdA"))('iframe');
        var i = $aIGUN.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';
        (parcelRequire("fW23X")).appendChild(iframe);
        iframe.src = 'javascript:';
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        $f5aff1030646fd55$var$createDict = iframeDocument.F;
        while(i--)delete $f5aff1030646fd55$var$createDict[$f5aff1030646fd55$var$PROTOTYPE][$aIGUN[i]];
        return $f5aff1030646fd55$var$createDict();
    };
    module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
            $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = $6rs9h(O);
            result = new $f5aff1030646fd55$var$Empty();
            $f5aff1030646fd55$var$Empty[$f5aff1030646fd55$var$PROTOTYPE] = null;
            result[$f5aff1030646fd55$var$IE_PROTO] = O;
        } else result = $f5aff1030646fd55$var$createDict();
        return Properties === undefined ? result : $hrzgw(result, Properties);
    };
});
parcelRegister("hrzgw", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $6rs9h = parcelRequire("6rs9h");
    var $8rKxD = parcelRequire("8rKxD");
    module.exports = (parcelRequire("hn2oF")) ? Object.defineProperties : function defineProperties(O, Properties) {
        $6rs9h(O);
        var keys = $8rKxD(Properties);
        var length = keys.length;
        var i = 0;
        var P;
        while(length > i)$30LaA.f(O, P = keys[i++], Properties[P]);
        return O;
    };
});
parcelRegister("8rKxD", function(module, exports) {
    var $aW8ua = parcelRequire("aW8ua");
    var $aIGUN = parcelRequire("aIGUN");
    module.exports = Object.keys || function keys(O) {
        return $aW8ua(O, $aIGUN);
    };
});
parcelRegister("aW8ua", function(module, exports) {
    var $aMccP = parcelRequire("aMccP");
    var $59DzK = parcelRequire("59DzK");
    var $7f65e7394a9ddf07$var$arrayIndexOf = (parcelRequire("6FnDv"))(false);
    var $7f65e7394a9ddf07$var$IE_PROTO = (parcelRequire("4BPKE"))('IE_PROTO');
    module.exports = function(object, names) {
        var O = $59DzK(object);
        var i = 0;
        var result = [];
        var key;
        for(key in O)if (key != $7f65e7394a9ddf07$var$IE_PROTO) $aMccP(O, key) && result.push(key);
        while(names.length > i)if ($aMccP(O, key = names[i++])) ~$7f65e7394a9ddf07$var$arrayIndexOf(result, key) || result.push(key);
        return result;
    };
});
parcelRegister("59DzK", function(module, exports) {
    var $2A2jr = parcelRequire("2A2jr");
    var $ie6R6 = parcelRequire("ie6R6");
    module.exports = function(it) {
        return $2A2jr($ie6R6(it));
    };
});
parcelRegister("2A2jr", function(module, exports) {
    var $eYYzh = parcelRequire("eYYzh");
    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
        return $eYYzh(it) == 'String' ? it.split('') : Object(it);
    };
});
parcelRegister("eYYzh", function(module, exports) {
    var $ae85a6d59702a8f0$var$toString = {}.toString;
    module.exports = function(it) {
        return $ae85a6d59702a8f0$var$toString.call(it).slice(8, -1);
    };
});
parcelRegister("6FnDv", function(module, exports) {
    var $59DzK = parcelRequire("59DzK");
    var $lpAeO = parcelRequire("lpAeO");
    var $7XibQ = parcelRequire("7XibQ");
    module.exports = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
            var O = $59DzK($this);
            var length = $lpAeO(O.length);
            var index = $7XibQ(fromIndex, length);
            var value;
            if (IS_INCLUDES && el != el) while(length > index){
                value = O[index++];
                if (value != value) return true;
            }
            else for(; length > index; index++)if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
            }
            return !IS_INCLUDES && -1;
        };
    };
});
parcelRegister("lpAeO", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $f9680adf10caefa3$var$min = Math.min;
    module.exports = function(it) {
        return it > 0 ? $f9680adf10caefa3$var$min($h2TDF(it), 0x1fffffffffffff) : 0;
    };
});
parcelRegister("7XibQ", function(module, exports) {
    var $h2TDF = parcelRequire("h2TDF");
    var $5cac2746a26f7adf$var$max = Math.max;
    var $5cac2746a26f7adf$var$min = Math.min;
    module.exports = function(index, length) {
        index = $h2TDF(index);
        return index < 0 ? $5cac2746a26f7adf$var$max(index + length, 0) : $5cac2746a26f7adf$var$min(index, length);
    };
});
parcelRegister("aIGUN", function(module, exports) {
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
});
parcelRegister("fW23X", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $b99ddf714ab9b2ae$require$document = $pe18r.document;
    module.exports = $b99ddf714ab9b2ae$require$document && $b99ddf714ab9b2ae$require$document.documentElement;
});
parcelRegister("8nOHH", function(module, exports) {
    var $30LaA = parcelRequire("30LaA");
    var $61a7cd74d8b334f9$require$def = $30LaA.f;
    var $aMccP = parcelRequire("aMccP");
    var $61a7cd74d8b334f9$var$TAG = (parcelRequire("cNfss"))('toStringTag');
    module.exports = function(it, tag, stat) {
        if (it && !$aMccP(it = stat ? it : it.prototype, $61a7cd74d8b334f9$var$TAG)) $61a7cd74d8b334f9$require$def(it, $61a7cd74d8b334f9$var$TAG, {
            configurable: true,
            value: tag
        });
    };
});
parcelRegister("cNfss", function(module, exports) {
    var $95060d4712c30789$var$store = (parcelRequire("inCOl"))('wks');
    var $42V7x = parcelRequire("42V7x");
    var $pe18r = parcelRequire("pe18r");
    var $95060d4712c30789$require$Symbol = $pe18r.Symbol;
    var $95060d4712c30789$var$USE_SYMBOL = typeof $95060d4712c30789$require$Symbol == 'function';
    var $95060d4712c30789$var$$exports = module.exports = function(name) {
        return $95060d4712c30789$var$store[name] || ($95060d4712c30789$var$store[name] = $95060d4712c30789$var$USE_SYMBOL && $95060d4712c30789$require$Symbol[name] || ($95060d4712c30789$var$USE_SYMBOL ? $95060d4712c30789$require$Symbol : $42V7x)('Symbol.' + name));
    };
    $95060d4712c30789$var$$exports.store = $95060d4712c30789$var$store;
});
parcelRegister("fQXw1", function(module, exports) {
    parcelRequire("bSOrM");
    var $pe18r = parcelRequire("pe18r");
    var $kM6mh = parcelRequire("kM6mh");
    var $eu895 = parcelRequire("eu895");
    var $b8a9e0dc29c7f4f5$var$TO_STRING_TAG = (parcelRequire("cNfss"))('toStringTag');
    var $b8a9e0dc29c7f4f5$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
    for(var $b8a9e0dc29c7f4f5$var$i = 0; $b8a9e0dc29c7f4f5$var$i < $b8a9e0dc29c7f4f5$var$DOMIterables.length; $b8a9e0dc29c7f4f5$var$i++){
        var $b8a9e0dc29c7f4f5$var$NAME = $b8a9e0dc29c7f4f5$var$DOMIterables[$b8a9e0dc29c7f4f5$var$i];
        var $b8a9e0dc29c7f4f5$var$Collection = $pe18r[$b8a9e0dc29c7f4f5$var$NAME];
        var $b8a9e0dc29c7f4f5$var$proto = $b8a9e0dc29c7f4f5$var$Collection && $b8a9e0dc29c7f4f5$var$Collection.prototype;
        if ($b8a9e0dc29c7f4f5$var$proto && !$b8a9e0dc29c7f4f5$var$proto[$b8a9e0dc29c7f4f5$var$TO_STRING_TAG]) $kM6mh($b8a9e0dc29c7f4f5$var$proto, $b8a9e0dc29c7f4f5$var$TO_STRING_TAG, $b8a9e0dc29c7f4f5$var$NAME);
        $eu895[$b8a9e0dc29c7f4f5$var$NAME] = $eu895.Array;
    }
});
parcelRegister("bSOrM", function(module, exports) {
    'use strict';
    var $hvcNK = parcelRequire("hvcNK");
    var $2WIr8 = parcelRequire("2WIr8");
    var $eu895 = parcelRequire("eu895");
    var $59DzK = parcelRequire("59DzK");
    module.exports = (parcelRequire("bH4Ac"))(Array, 'Array', function(iterated, kind) {
        this._t = $59DzK(iterated);
        this._i = 0;
        this._k = kind;
    }, function() {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;
        if (!O || index >= O.length) {
            this._t = undefined;
            return $2WIr8(1);
        }
        if (kind == 'keys') return $2WIr8(0, index);
        if (kind == 'values') return $2WIr8(0, O[index]);
        return $2WIr8(0, [
            index,
            O[index]
        ]);
    }, 'values');
    $eu895.Arguments = $eu895.Array;
    $hvcNK('keys');
    $hvcNK('values');
    $hvcNK('entries');
});
parcelRegister("hvcNK", function(module, exports) {
    module.exports = function() {};
});
parcelRegister("2WIr8", function(module, exports) {
    module.exports = function(done, value) {
        return {
            value: value,
            done: !!done
        };
    };
});
parcelRegister("3iakE", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$265b1149da5b805d$export$2d1720544b23b823, (v)=>$265b1149da5b805d$export$2d1720544b23b823 = v);
    var $265b1149da5b805d$export$2d1720544b23b823;
    $265b1149da5b805d$export$2d1720544b23b823 = (parcelRequire("cNfss"));
});
parcelRegister("V3332", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("5MRee")),
        __esModule: true
    };
});
parcelRegister("5MRee", function(module, exports) {
    parcelRequire("dV330");
    parcelRequire("55SkS");
    parcelRequire("8IAUf");
    parcelRequire("fvEHr");
    module.exports = (parcelRequire("dv4GG")).Symbol;
});
parcelRegister("dV330", function(module, exports) {
    'use strict';
    var $pe18r = parcelRequire("pe18r");
    var $aMccP = parcelRequire("aMccP");
    var $hn2oF = parcelRequire("hn2oF");
    var $8EFNH = parcelRequire("8EFNH");
    var $3VDKT = parcelRequire("3VDKT");
    var $hXWWY = parcelRequire("hXWWY");
    var $a222f66347247ddd$require$META = $hXWWY.KEY;
    var $5nD9T = parcelRequire("5nD9T");
    var $inCOl = parcelRequire("inCOl");
    var $8nOHH = parcelRequire("8nOHH");
    var $42V7x = parcelRequire("42V7x");
    var $cNfss = parcelRequire("cNfss");
    var $3iakE = parcelRequire("3iakE");
    var $eKGZg = parcelRequire("eKGZg");
    var $8yCLj = parcelRequire("8yCLj");
    var $imb3o = parcelRequire("imb3o");
    var $6rs9h = parcelRequire("6rs9h");
    var $6VwBm = parcelRequire("6VwBm");
    var $8tRkg = parcelRequire("8tRkg");
    var $59DzK = parcelRequire("59DzK");
    var $7Af9t = parcelRequire("7Af9t");
    var $evesF = parcelRequire("evesF");
    var $l5MPs = parcelRequire("l5MPs");
    var $2JUNR = parcelRequire("2JUNR");
    var $56mOV = parcelRequire("56mOV");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $30LaA = parcelRequire("30LaA");
    var $8rKxD = parcelRequire("8rKxD");
    var $a222f66347247ddd$var$gOPD = $56mOV.f;
    var $a222f66347247ddd$var$dP = $30LaA.f;
    var $a222f66347247ddd$var$gOPN = $2JUNR.f;
    var $a222f66347247ddd$var$$Symbol = $pe18r.Symbol;
    var $a222f66347247ddd$var$$JSON = $pe18r.JSON;
    var $a222f66347247ddd$var$_stringify = $a222f66347247ddd$var$$JSON && $a222f66347247ddd$var$$JSON.stringify;
    var $a222f66347247ddd$var$PROTOTYPE = 'prototype';
    var $a222f66347247ddd$var$HIDDEN = $cNfss('_hidden');
    var $a222f66347247ddd$var$TO_PRIMITIVE = $cNfss('toPrimitive');
    var $a222f66347247ddd$var$isEnum = {}.propertyIsEnumerable;
    var $a222f66347247ddd$var$SymbolRegistry = $inCOl('symbol-registry');
    var $a222f66347247ddd$var$AllSymbols = $inCOl('symbols');
    var $a222f66347247ddd$var$OPSymbols = $inCOl('op-symbols');
    var $a222f66347247ddd$var$ObjectProto = Object[$a222f66347247ddd$var$PROTOTYPE];
    var $a222f66347247ddd$var$USE_NATIVE = typeof $a222f66347247ddd$var$$Symbol == 'function' && !!$1Jjbj.f;
    var $a222f66347247ddd$var$QObject = $pe18r.QObject;
    var $a222f66347247ddd$var$setter = !$a222f66347247ddd$var$QObject || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE] || !$a222f66347247ddd$var$QObject[$a222f66347247ddd$var$PROTOTYPE].findChild;
    var $a222f66347247ddd$var$setSymbolDesc = $hn2oF && $5nD9T(function() {
        return $l5MPs($a222f66347247ddd$var$dP({}, 'a', {
            get: function() {
                return $a222f66347247ddd$var$dP(this, 'a', {
                    value: 7
                }).a;
            }
        })).a != 7;
    }) ? function(it, key, D) {
        var protoDesc = $a222f66347247ddd$var$gOPD($a222f66347247ddd$var$ObjectProto, key);
        if (protoDesc) delete $a222f66347247ddd$var$ObjectProto[key];
        $a222f66347247ddd$var$dP(it, key, D);
        if (protoDesc && it !== $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$dP($a222f66347247ddd$var$ObjectProto, key, protoDesc);
    } : $a222f66347247ddd$var$dP;
    var $a222f66347247ddd$var$wrap = function(tag) {
        var sym = $a222f66347247ddd$var$AllSymbols[tag] = $l5MPs($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE]);
        sym._k = tag;
        return sym;
    };
    var $a222f66347247ddd$var$isSymbol = $a222f66347247ddd$var$USE_NATIVE && typeof $a222f66347247ddd$var$$Symbol.iterator == 'symbol' ? function(it) {
        return typeof it == 'symbol';
    } : function(it) {
        return it instanceof $a222f66347247ddd$var$$Symbol;
    };
    var $a222f66347247ddd$var$$defineProperty = function defineProperty(it, key, D) {
        if (it === $a222f66347247ddd$var$ObjectProto) $a222f66347247ddd$var$$defineProperty($a222f66347247ddd$var$OPSymbols, key, D);
        $6rs9h(it);
        key = $7Af9t(key, true);
        $6rs9h(D);
        if ($aMccP($a222f66347247ddd$var$AllSymbols, key)) {
            if (!D.enumerable) {
                if (!$aMccP(it, $a222f66347247ddd$var$HIDDEN)) $a222f66347247ddd$var$dP(it, $a222f66347247ddd$var$HIDDEN, $evesF(1, {}));
                it[$a222f66347247ddd$var$HIDDEN][key] = true;
            } else {
                if ($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key]) it[$a222f66347247ddd$var$HIDDEN][key] = false;
                D = $l5MPs(D, {
                    enumerable: $evesF(0, false)
                });
            }
            return $a222f66347247ddd$var$setSymbolDesc(it, key, D);
        }
        return $a222f66347247ddd$var$dP(it, key, D);
    };
    var $a222f66347247ddd$var$$defineProperties = function defineProperties(it, P) {
        $6rs9h(it);
        var keys = $8yCLj(P = $59DzK(P));
        var i = 0;
        var l = keys.length;
        var key;
        while(l > i)$a222f66347247ddd$var$$defineProperty(it, key = keys[i++], P[key]);
        return it;
    };
    var $a222f66347247ddd$var$$create = function create(it, P) {
        return P === undefined ? $l5MPs(it) : $a222f66347247ddd$var$$defineProperties($l5MPs(it), P);
    };
    var $a222f66347247ddd$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = $a222f66347247ddd$var$isEnum.call(this, key = $7Af9t(key, true));
        if (this === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return false;
        return E || !$aMccP(this, key) || !$aMccP($a222f66347247ddd$var$AllSymbols, key) || $aMccP(this, $a222f66347247ddd$var$HIDDEN) && this[$a222f66347247ddd$var$HIDDEN][key] ? E : true;
    };
    var $a222f66347247ddd$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = $59DzK(it);
        key = $7Af9t(key, true);
        if (it === $a222f66347247ddd$var$ObjectProto && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !$aMccP($a222f66347247ddd$var$OPSymbols, key)) return;
        var D = $a222f66347247ddd$var$gOPD(it, key);
        if (D && $aMccP($a222f66347247ddd$var$AllSymbols, key) && !($aMccP(it, $a222f66347247ddd$var$HIDDEN) && it[$a222f66347247ddd$var$HIDDEN][key])) D.enumerable = true;
        return D;
    };
    var $a222f66347247ddd$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = $a222f66347247ddd$var$gOPN($59DzK(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if (!$aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && key != $a222f66347247ddd$var$HIDDEN && key != $a222f66347247ddd$require$META) result.push(key);
        return result;
    };
    var $a222f66347247ddd$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === $a222f66347247ddd$var$ObjectProto;
        var names = $a222f66347247ddd$var$gOPN(IS_OP ? $a222f66347247ddd$var$OPSymbols : $59DzK(it));
        var result = [];
        var i = 0;
        var key;
        while(names.length > i)if ($aMccP($a222f66347247ddd$var$AllSymbols, key = names[i++]) && (IS_OP ? $aMccP($a222f66347247ddd$var$ObjectProto, key) : true)) result.push($a222f66347247ddd$var$AllSymbols[key]);
        return result;
    };
    if (!$a222f66347247ddd$var$USE_NATIVE) {
        $a222f66347247ddd$var$$Symbol = function Symbol() {
            if (this instanceof $a222f66347247ddd$var$$Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = $42V7x(arguments.length > 0 ? arguments[0] : undefined);
            var $set = function(value) {
                if (this === $a222f66347247ddd$var$ObjectProto) $set.call($a222f66347247ddd$var$OPSymbols, value);
                if ($aMccP(this, $a222f66347247ddd$var$HIDDEN) && $aMccP(this[$a222f66347247ddd$var$HIDDEN], tag)) this[$a222f66347247ddd$var$HIDDEN][tag] = false;
                $a222f66347247ddd$var$setSymbolDesc(this, tag, $evesF(1, value));
            };
            if ($hn2oF && $a222f66347247ddd$var$setter) $a222f66347247ddd$var$setSymbolDesc($a222f66347247ddd$var$ObjectProto, tag, {
                configurable: true,
                set: $set
            });
            return $a222f66347247ddd$var$wrap(tag);
        };
        $3VDKT($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], 'toString', function toString() {
            return this._k;
        });
        $56mOV.f = $a222f66347247ddd$var$$getOwnPropertyDescriptor;
        $30LaA.f = $a222f66347247ddd$var$$defineProperty;
        (parcelRequire("7X6HN")).f = $2JUNR.f = $a222f66347247ddd$var$$getOwnPropertyNames;
        (parcelRequire("gvEJa")).f = $a222f66347247ddd$var$$propertyIsEnumerable;
        $1Jjbj.f = $a222f66347247ddd$var$$getOwnPropertySymbols;
        if ($hn2oF && !(parcelRequire("6uq1C"))) $3VDKT($a222f66347247ddd$var$ObjectProto, 'propertyIsEnumerable', $a222f66347247ddd$var$$propertyIsEnumerable, true);
        $3iakE.f = function(name) {
            return $a222f66347247ddd$var$wrap($cNfss(name));
        };
    }
    $8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, {
        Symbol: $a222f66347247ddd$var$$Symbol
    });
    for(var $a222f66347247ddd$var$es6Symbols = 'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $a222f66347247ddd$var$j = 0; $a222f66347247ddd$var$es6Symbols.length > $a222f66347247ddd$var$j;)$cNfss($a222f66347247ddd$var$es6Symbols[$a222f66347247ddd$var$j++]);
    for(var $a222f66347247ddd$var$wellKnownSymbols = $8rKxD($cNfss.store), $a222f66347247ddd$var$k = 0; $a222f66347247ddd$var$wellKnownSymbols.length > $a222f66347247ddd$var$k;)$eKGZg($a222f66347247ddd$var$wellKnownSymbols[$a222f66347247ddd$var$k++]);
    $8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Symbol', {
        'for': function(key) {
            return $aMccP($a222f66347247ddd$var$SymbolRegistry, key += '') ? $a222f66347247ddd$var$SymbolRegistry[key] : $a222f66347247ddd$var$SymbolRegistry[key] = $a222f66347247ddd$var$$Symbol(key);
        },
        keyFor: function keyFor(sym) {
            if (!$a222f66347247ddd$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
            for(var key in $a222f66347247ddd$var$SymbolRegistry)if ($a222f66347247ddd$var$SymbolRegistry[key] === sym) return key;
        },
        useSetter: function() {
            $a222f66347247ddd$var$setter = true;
        },
        useSimple: function() {
            $a222f66347247ddd$var$setter = false;
        }
    });
    $8EFNH($8EFNH.S + $8EFNH.F * !$a222f66347247ddd$var$USE_NATIVE, 'Object', {
        create: $a222f66347247ddd$var$$create,
        defineProperty: $a222f66347247ddd$var$$defineProperty,
        defineProperties: $a222f66347247ddd$var$$defineProperties,
        getOwnPropertyDescriptor: $a222f66347247ddd$var$$getOwnPropertyDescriptor,
        getOwnPropertyNames: $a222f66347247ddd$var$$getOwnPropertyNames,
        getOwnPropertySymbols: $a222f66347247ddd$var$$getOwnPropertySymbols
    });
    var $a222f66347247ddd$var$FAILS_ON_PRIMITIVES = $5nD9T(function() {
        $1Jjbj.f(1);
    });
    $8EFNH($8EFNH.S + $8EFNH.F * $a222f66347247ddd$var$FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return $1Jjbj.f($8tRkg(it));
        }
    });
    $a222f66347247ddd$var$$JSON && $8EFNH($8EFNH.S + $8EFNH.F * (!$a222f66347247ddd$var$USE_NATIVE || $5nD9T(function() {
        var S = $a222f66347247ddd$var$$Symbol();
        return $a222f66347247ddd$var$_stringify([
            S
        ]) != '[null]' || $a222f66347247ddd$var$_stringify({
            a: S
        }) != '{}' || $a222f66347247ddd$var$_stringify(Object(S)) != '{}';
    })), 'JSON', {
        stringify: function stringify(it) {
            var args = [
                it
            ];
            var i = 1;
            var replacer, $replacer;
            while(arguments.length > i)args.push(arguments[i++]);
            $replacer = replacer = args[1];
            if (!$6VwBm(replacer) && it === undefined || $a222f66347247ddd$var$isSymbol(it)) return;
            if (!$imb3o(replacer)) replacer = function(key, value) {
                if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                if (!$a222f66347247ddd$var$isSymbol(value)) return value;
            };
            args[1] = replacer;
            return $a222f66347247ddd$var$_stringify.apply($a222f66347247ddd$var$$JSON, args);
        }
    });
    $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE][$a222f66347247ddd$var$TO_PRIMITIVE] || (parcelRequire("kM6mh"))($a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE], $a222f66347247ddd$var$TO_PRIMITIVE, $a222f66347247ddd$var$$Symbol[$a222f66347247ddd$var$PROTOTYPE].valueOf);
    $8nOHH($a222f66347247ddd$var$$Symbol, 'Symbol');
    $8nOHH(Math, 'Math', true);
    $8nOHH($pe18r.JSON, 'JSON', true);
});
parcelRegister("hXWWY", function(module, exports) {
    var $d145aca8ddc395e4$var$META = (parcelRequire("42V7x"))('meta');
    var $6VwBm = parcelRequire("6VwBm");
    var $aMccP = parcelRequire("aMccP");
    var $30LaA = parcelRequire("30LaA");
    var $d145aca8ddc395e4$require$setDesc = $30LaA.f;
    var $d145aca8ddc395e4$var$id = 0;
    var $d145aca8ddc395e4$var$isExtensible = Object.isExtensible || function() {
        return true;
    };
    var $d145aca8ddc395e4$var$FREEZE = !(parcelRequire("5nD9T"))(function() {
        return $d145aca8ddc395e4$var$isExtensible(Object.preventExtensions({}));
    });
    var $d145aca8ddc395e4$var$setMeta = function(it) {
        $d145aca8ddc395e4$require$setDesc(it, $d145aca8ddc395e4$var$META, {
            value: {
                i: 'O' + ++$d145aca8ddc395e4$var$id,
                w: {}
            }
        });
    };
    var $d145aca8ddc395e4$var$fastKey = function(it, create) {
        if (!$6VwBm(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
        if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
            if (!$d145aca8ddc395e4$var$isExtensible(it)) return 'F';
            if (!create) return 'E';
            $d145aca8ddc395e4$var$setMeta(it);
        }
        return it[$d145aca8ddc395e4$var$META].i;
    };
    var $d145aca8ddc395e4$var$getWeak = function(it, create) {
        if (!$aMccP(it, $d145aca8ddc395e4$var$META)) {
            if (!$d145aca8ddc395e4$var$isExtensible(it)) return true;
            if (!create) return false;
            $d145aca8ddc395e4$var$setMeta(it);
        }
        return it[$d145aca8ddc395e4$var$META].w;
    };
    var $d145aca8ddc395e4$var$onFreeze = function(it) {
        if ($d145aca8ddc395e4$var$FREEZE && $d145aca8ddc395e4$var$meta.NEED && $d145aca8ddc395e4$var$isExtensible(it) && !$aMccP(it, $d145aca8ddc395e4$var$META)) $d145aca8ddc395e4$var$setMeta(it);
        return it;
    };
    var $d145aca8ddc395e4$var$meta = module.exports = {
        KEY: $d145aca8ddc395e4$var$META,
        NEED: false,
        fastKey: $d145aca8ddc395e4$var$fastKey,
        getWeak: $d145aca8ddc395e4$var$getWeak,
        onFreeze: $d145aca8ddc395e4$var$onFreeze
    };
});
parcelRegister("eKGZg", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $dv4GG = parcelRequire("dv4GG");
    var $6uq1C = parcelRequire("6uq1C");
    var $3iakE = parcelRequire("3iakE");
    var $30LaA = parcelRequire("30LaA");
    var $abd6b4ec55be4dfa$require$defineProperty = $30LaA.f;
    module.exports = function(name) {
        var $Symbol = $dv4GG.Symbol || ($dv4GG.Symbol = $6uq1C ? {} : $pe18r.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) $abd6b4ec55be4dfa$require$defineProperty($Symbol, name, {
            value: $3iakE.f(name)
        });
    };
});
parcelRegister("8yCLj", function(module, exports) {
    var $8rKxD = parcelRequire("8rKxD");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $gvEJa = parcelRequire("gvEJa");
    module.exports = function(it) {
        var result = $8rKxD(it);
        var getSymbols = $1Jjbj.f;
        if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = $gvEJa.f;
            var i = 0;
            var key;
            while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
        return result;
    };
});
parcelRegister("1Jjbj", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$1428df70697477af$export$2d1720544b23b823, (v)=>$1428df70697477af$export$2d1720544b23b823 = v);
    var $1428df70697477af$export$2d1720544b23b823;
    $1428df70697477af$export$2d1720544b23b823 = Object.getOwnPropertySymbols;
});
parcelRegister("gvEJa", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$c04f223f8947297b$export$2d1720544b23b823, (v)=>$c04f223f8947297b$export$2d1720544b23b823 = v);
    var $c04f223f8947297b$export$2d1720544b23b823;
    $c04f223f8947297b$export$2d1720544b23b823 = ({}).propertyIsEnumerable;
});
parcelRegister("imb3o", function(module, exports) {
    var $eYYzh = parcelRequire("eYYzh");
    module.exports = Array.isArray || function isArray(arg) {
        return $eYYzh(arg) == 'Array';
    };
});
parcelRegister("2JUNR", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$1febd8a8d519c7f4$export$2d1720544b23b823, (v)=>$1febd8a8d519c7f4$export$2d1720544b23b823 = v);
    var $1febd8a8d519c7f4$export$2d1720544b23b823;
    var $59DzK = parcelRequire("59DzK");
    var $7X6HN = parcelRequire("7X6HN");
    var $1febd8a8d519c7f4$require$gOPN = $7X6HN.f;
    var $1febd8a8d519c7f4$var$toString = {}.toString;
    var $1febd8a8d519c7f4$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
    var $1febd8a8d519c7f4$var$getWindowNames = function(it) {
        try {
            return $1febd8a8d519c7f4$require$gOPN(it);
        } catch (e) {
            return $1febd8a8d519c7f4$var$windowNames.slice();
        }
    };
    $1febd8a8d519c7f4$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
        return $1febd8a8d519c7f4$var$windowNames && $1febd8a8d519c7f4$var$toString.call(it) == '[object Window]' ? $1febd8a8d519c7f4$var$getWindowNames(it) : $1febd8a8d519c7f4$require$gOPN($59DzK(it));
    };
});
parcelRegister("7X6HN", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$5ca33ea82ab61dc4$export$2d1720544b23b823, (v)=>$5ca33ea82ab61dc4$export$2d1720544b23b823 = v);
    var $5ca33ea82ab61dc4$export$2d1720544b23b823;
    var $aW8ua = parcelRequire("aW8ua");
    var $5ca33ea82ab61dc4$var$hiddenKeys = (parcelRequire("aIGUN")).concat('length', 'prototype');
    $5ca33ea82ab61dc4$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $aW8ua(O, $5ca33ea82ab61dc4$var$hiddenKeys);
    };
});
parcelRegister("56mOV", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$3b6f36f483e8e31a$export$2d1720544b23b823, (v)=>$3b6f36f483e8e31a$export$2d1720544b23b823 = v);
    var $3b6f36f483e8e31a$export$2d1720544b23b823;
    var $gvEJa = parcelRequire("gvEJa");
    var $evesF = parcelRequire("evesF");
    var $59DzK = parcelRequire("59DzK");
    var $7Af9t = parcelRequire("7Af9t");
    var $aMccP = parcelRequire("aMccP");
    var $dzU8d = parcelRequire("dzU8d");
    var $3b6f36f483e8e31a$var$gOPD = Object.getOwnPropertyDescriptor;
    $3b6f36f483e8e31a$export$2d1720544b23b823 = (parcelRequire("hn2oF")) ? $3b6f36f483e8e31a$var$gOPD : function getOwnPropertyDescriptor(O, P) {
        O = $59DzK(O);
        P = $7Af9t(P, true);
        if ($dzU8d) try {
            return $3b6f36f483e8e31a$var$gOPD(O, P);
        } catch (e) {}
        if ($aMccP(O, P)) return $evesF(!$gvEJa.f.call(O, P), O[P]);
    };
});
parcelRegister("55SkS", function(module, exports) {});
parcelRegister("8IAUf", function(module, exports) {
    (parcelRequire("eKGZg"))('asyncIterator');
});
parcelRegister("fvEHr", function(module, exports) {
    (parcelRequire("eKGZg"))('observable');
});
parcelRegister("gHLl6", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$c295621de530ae6b$export$1e511d4a378977f5, (v)=>$c295621de530ae6b$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$c295621de530ae6b$export$2e2bcd8739ae039, (v)=>$c295621de530ae6b$export$2e2bcd8739ae039 = v);
    var $c295621de530ae6b$export$1e511d4a378977f5;
    var $c295621de530ae6b$export$2e2bcd8739ae039;
    "use strict";
    $c295621de530ae6b$export$1e511d4a378977f5 = true;
    var $2gkZm = parcelRequire("2gkZm");
    var $c295621de530ae6b$var$_setPrototypeOf2 = $c295621de530ae6b$var$_interopRequireDefault($2gkZm);
    var $gqjuI = parcelRequire("gqjuI");
    var $c295621de530ae6b$var$_create2 = $c295621de530ae6b$var$_interopRequireDefault($gqjuI);
    var $kt6ai = parcelRequire("kt6ai");
    var $c295621de530ae6b$var$_typeof3 = $c295621de530ae6b$var$_interopRequireDefault($kt6ai);
    function $c295621de530ae6b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $c295621de530ae6b$export$2e2bcd8739ae039 = function(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $c295621de530ae6b$var$_typeof3.default)(superClass)));
        subClass.prototype = (0, $c295621de530ae6b$var$_create2.default)(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        if (superClass) $c295621de530ae6b$var$_setPrototypeOf2.default ? (0, $c295621de530ae6b$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
    };
});
parcelRegister("2gkZm", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("9Eo5e")),
        __esModule: true
    };
});
parcelRegister("9Eo5e", function(module, exports) {
    parcelRequire("58apJ");
    module.exports = (parcelRequire("dv4GG")).Object.setPrototypeOf;
});
parcelRegister("58apJ", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S, 'Object', {
        setPrototypeOf: (parcelRequire("kyYcY")).set
    });
});
parcelRegister("kyYcY", function(module, exports) {
    var $6VwBm = parcelRequire("6VwBm");
    var $6rs9h = parcelRequire("6rs9h");
    var $ef85afb423a719a5$var$check = function(O, proto) {
        $6rs9h(O);
        if (!$6VwBm(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };
    module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
            try {
                set = (parcelRequire("gnejD"))(Function.call, (parcelRequire("56mOV")).f(Object.prototype, '__proto__').set, 2);
                set(test, []);
                buggy = !(test instanceof Array);
            } catch (e) {
                buggy = true;
            }
            return function setPrototypeOf(O, proto) {
                $ef85afb423a719a5$var$check(O, proto);
                if (buggy) O.__proto__ = proto;
                else set(O, proto);
                return O;
            };
        }({}, false) : undefined),
        check: $ef85afb423a719a5$var$check
    };
});
parcelRegister("gqjuI", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("2cRis")),
        __esModule: true
    };
});
parcelRegister("2cRis", function(module, exports) {
    parcelRequire("8Agfc");
    var $dv4GG = parcelRequire("dv4GG");
    var $19b60b5f041438df$require$$Object = $dv4GG.Object;
    module.exports = function create(P, D) {
        return $19b60b5f041438df$require$$Object.create(P, D);
    };
});
parcelRegister("8Agfc", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S, 'Object', {
        create: (parcelRequire("l5MPs"))
    });
});
parcelRegister("bN49P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_CellMeasureCache = undefined;
    var $8rCP3;
    var $89577ee8c01f218b$var$_propTypes2 = $89577ee8c01f218b$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $89577ee8c01f218b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache = null;
    module.exports.bpfrpt_proptype_CellMeasureCache = $89577ee8c01f218b$var$bpfrpt_proptype_CellMeasureCache;
});
parcelRegister("ewGy7", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = undefined;
    var $aXTp8 = parcelRequire("aXTp8");
    var $a9350f4628fe309c$var$_classCallCheck3 = $a9350f4628fe309c$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $a9350f4628fe309c$var$_createClass3 = $a9350f4628fe309c$var$_interopRequireDefault($4tLNB);
    parcelRequire("bN49P");
    function $a9350f4628fe309c$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a9350f4628fe309c$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
    var $a9350f4628fe309c$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
    var $a9350f4628fe309c$var$CellMeasurerCache = function() {
        function CellMeasurerCache() {
            var _this = this;
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            (0, $a9350f4628fe309c$var$_classCallCheck3.default)(this, CellMeasurerCache);
            this._cellHeightCache = {};
            this._cellWidthCache = {};
            this._columnWidthCache = {};
            this._rowHeightCache = {};
            this._columnCount = 0;
            this._rowCount = 0;
            this.columnWidth = function(_ref) {
                var index = _ref.index;
                var key = _this._keyMapper(0, index);
                return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
            };
            this.rowHeight = function(_ref2) {
                var index = _ref2.index;
                var key = _this._keyMapper(index, 0);
                return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
            };
            var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
            this._hasFixedHeight = fixedHeight === true;
            this._hasFixedWidth = fixedWidth === true;
            this._minHeight = minHeight || 0;
            this._minWidth = minWidth || 0;
            this._keyMapper = keyMapper || $a9350f4628fe309c$var$defaultKeyMapper;
            this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $a9350f4628fe309c$var$DEFAULT_HEIGHT);
            this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $a9350f4628fe309c$var$DEFAULT_WIDTH);
        }
        (0, $a9350f4628fe309c$var$_createClass3.default)(CellMeasurerCache, [
            {
                key: 'clear',
                value: function clear(rowIndex) {
                    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var key = this._keyMapper(rowIndex, columnIndex);
                    delete this._cellHeightCache[key];
                    delete this._cellWidthCache[key];
                    this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
                }
            },
            {
                key: 'clearAll',
                value: function clearAll() {
                    this._cellHeightCache = {};
                    this._cellWidthCache = {};
                    this._columnWidthCache = {};
                    this._rowHeightCache = {};
                    this._rowCount = 0;
                    this._columnCount = 0;
                }
            },
            {
                key: 'hasFixedHeight',
                value: function hasFixedHeight() {
                    return this._hasFixedHeight;
                }
            },
            {
                key: 'hasFixedWidth',
                value: function hasFixedWidth() {
                    return this._hasFixedWidth;
                }
            },
            {
                key: 'getHeight',
                value: function getHeight(rowIndex) {
                    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    if (this._hasFixedHeight) return this._defaultHeight;
                    else {
                        var _key = this._keyMapper(rowIndex, columnIndex);
                        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                    }
                }
            },
            {
                key: 'getWidth',
                value: function getWidth(rowIndex) {
                    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    if (this._hasFixedWidth) return this._defaultWidth;
                    else {
                        var _key2 = this._keyMapper(rowIndex, columnIndex);
                        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                    }
                }
            },
            {
                key: 'has',
                value: function has(rowIndex) {
                    var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                    var key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache.hasOwnProperty(key);
                }
            },
            {
                key: 'set',
                value: function set(rowIndex, columnIndex, width, height) {
                    var key = this._keyMapper(rowIndex, columnIndex);
                    if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                    if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                    this._cellHeightCache[key] = height;
                    this._cellWidthCache[key] = width;
                    this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
                }
            },
            {
                key: '_updateCachedColumnAndRowSizes',
                value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
                    if (!this._hasFixedWidth) {
                        var columnWidth = 0;
                        for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                        var columnKey = this._keyMapper(0, columnIndex);
                        this._columnWidthCache[columnKey] = columnWidth;
                    }
                    if (!this._hasFixedHeight) {
                        var rowHeight = 0;
                        for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                        var rowKey = this._keyMapper(rowIndex, 0);
                        this._rowHeightCache[rowKey] = rowHeight;
                    }
                }
            },
            {
                key: 'defaultHeight',
                get: function get() {
                    return this._defaultHeight;
                }
            },
            {
                key: 'defaultWidth',
                get: function get() {
                    return this._defaultWidth;
                }
            }
        ]);
        return CellMeasurerCache;
    }();
    module.exports.default = $a9350f4628fe309c$var$CellMeasurerCache;
    function $a9350f4628fe309c$var$defaultKeyMapper(rowIndex, columnIndex) {
        return rowIndex + '-' + columnIndex;
    }
});
parcelRegister("aLlKO", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_RowRendererParams = module.exports.List = module.exports.default = undefined;
    var $eAgCH = parcelRequire("eAgCH");
    Object.defineProperty(module.exports, 'default', {
        enumerable: true,
        get: function get() {
            return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
        }
    });
    Object.defineProperty(module.exports, 'List', {
        enumerable: true,
        get: function get() {
            return $7d5f2b12ba6a0316$var$_interopRequireDefault($eAgCH).default;
        }
    });
    var $2AKv3 = parcelRequire("2AKv3");
    function $7d5f2b12ba6a0316$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    module.exports.bpfrpt_proptype_RowRendererParams = $2AKv3.bpfrpt_proptype_RowRendererParams;
});
parcelRegister("eAgCH", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $knQh8 = parcelRequire("knQh8");
    var $a9e1528011c3c32e$var$_extends3 = $a9e1528011c3c32e$var$_interopRequireDefault($knQh8);
    var $kSGvk = parcelRequire("kSGvk");
    var $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2 = $a9e1528011c3c32e$var$_interopRequireDefault($kSGvk);
    var $29Ol4 = parcelRequire("29Ol4");
    var $a9e1528011c3c32e$var$_getPrototypeOf2 = $a9e1528011c3c32e$var$_interopRequireDefault($29Ol4);
    var $aXTp8 = parcelRequire("aXTp8");
    var $a9e1528011c3c32e$var$_classCallCheck3 = $a9e1528011c3c32e$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $a9e1528011c3c32e$var$_createClass3 = $a9e1528011c3c32e$var$_interopRequireDefault($4tLNB);
    var $5pMaQ = parcelRequire("5pMaQ");
    var $a9e1528011c3c32e$var$_possibleConstructorReturn3 = $a9e1528011c3c32e$var$_interopRequireDefault($5pMaQ);
    var $gHLl6 = parcelRequire("gHLl6");
    var $a9e1528011c3c32e$var$_inherits3 = $a9e1528011c3c32e$var$_interopRequireDefault($gHLl6);
    var $648t0 = parcelRequire("648t0");
    var $a9e1528011c3c32e$var$_Grid2 = $a9e1528011c3c32e$var$_interopRequireDefault($648t0);
    var $5uXOq = parcelRequire("5uXOq");
    var $a9e1528011c3c32e$var$React = $a9e1528011c3c32e$var$_interopRequireWildcard($5uXOq);
    var $hazy9 = parcelRequire("hazy9");
    var $a9e1528011c3c32e$var$_clsx2 = $a9e1528011c3c32e$var$_interopRequireDefault($hazy9);
    parcelRequire("2AKv3");
    var $8rCP3;
    var $a9e1528011c3c32e$var$_propTypes2 = $a9e1528011c3c32e$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $a9e1528011c3c32e$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $a9e1528011c3c32e$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a9e1528011c3c32e$var$List = function(_React$PureComponent) {
        (0, $a9e1528011c3c32e$var$_inherits3.default)(List, _React$PureComponent);
        function List() {
            var _ref;
            var _temp, _this, _ret;
            (0, $a9e1528011c3c32e$var$_classCallCheck3.default)(this, List);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(this, (_ref = List.__proto__ || (0, $a9e1528011c3c32e$var$_getPrototypeOf2.default)(List)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this._cellRenderer = function(_ref2) {
                var parent = _ref2.parent, rowIndex = _ref2.rowIndex, style = _ref2.style, isScrolling = _ref2.isScrolling, isVisible = _ref2.isVisible, key = _ref2.key;
                var rowRenderer = _this.props.rowRenderer;
                var _Object$getOwnPropert = (0, $a9e1528011c3c32e$var$_getOwnPropertyDescriptor2.default)(style, 'width'), writable = _Object$getOwnPropert.writable;
                if (writable) style.width = '100%';
                return rowRenderer({
                    index: rowIndex,
                    style: style,
                    isScrolling: isScrolling,
                    isVisible: isVisible,
                    key: key,
                    parent: parent
                });
            }, _this._setRef = function(ref) {
                _this.Grid = ref;
            }, _this._onScroll = function(_ref3) {
                var clientHeight = _ref3.clientHeight, scrollHeight = _ref3.scrollHeight, scrollTop = _ref3.scrollTop;
                var onScroll = _this.props.onScroll;
                onScroll({
                    clientHeight: clientHeight,
                    scrollHeight: scrollHeight,
                    scrollTop: scrollTop
                });
            }, _this._onSectionRendered = function(_ref4) {
                var rowOverscanStartIndex = _ref4.rowOverscanStartIndex, rowOverscanStopIndex = _ref4.rowOverscanStopIndex, rowStartIndex = _ref4.rowStartIndex, rowStopIndex = _ref4.rowStopIndex;
                var onRowsRendered = _this.props.onRowsRendered;
                onRowsRendered({
                    overscanStartIndex: rowOverscanStartIndex,
                    overscanStopIndex: rowOverscanStopIndex,
                    startIndex: rowStartIndex,
                    stopIndex: rowStopIndex
                });
            }, _temp), (0, $a9e1528011c3c32e$var$_possibleConstructorReturn3.default)(_this, _ret);
        }
        (0, $a9e1528011c3c32e$var$_createClass3.default)(List, [
            {
                key: 'forceUpdateGrid',
                value: function forceUpdateGrid() {
                    if (this.Grid) this.Grid.forceUpdate();
                }
            },
            {
                key: 'getOffsetForRow',
                value: function getOffsetForRow(_ref5) {
                    var alignment = _ref5.alignment, index = _ref5.index;
                    if (this.Grid) {
                        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
                            alignment: alignment,
                            rowIndex: index,
                            columnIndex: 0
                        }), _scrollTop = _Grid$getOffsetForCel.scrollTop;
                        return _scrollTop;
                    }
                    return 0;
                }
            },
            {
                key: 'invalidateCellSizeAfterRender',
                value: function invalidateCellSizeAfterRender(_ref6) {
                    var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex;
                    if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    });
                }
            },
            {
                key: 'measureAllRows',
                value: function measureAllRows() {
                    if (this.Grid) this.Grid.measureAllCells();
                }
            },
            {
                key: 'recomputeGridSize',
                value: function recomputeGridSize() {
                    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$columnIndex = _ref7.columnIndex, columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex, _ref7$rowIndex = _ref7.rowIndex, rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;
                    if (this.Grid) this.Grid.recomputeGridSize({
                        rowIndex: rowIndex,
                        columnIndex: columnIndex
                    });
                }
            },
            {
                key: 'recomputeRowHeights',
                value: function recomputeRowHeights() {
                    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    if (this.Grid) this.Grid.recomputeGridSize({
                        rowIndex: index,
                        columnIndex: 0
                    });
                }
            },
            {
                key: 'scrollToPosition',
                value: function scrollToPosition() {
                    var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    if (this.Grid) this.Grid.scrollToPosition({
                        scrollTop: scrollTop
                    });
                }
            },
            {
                key: 'scrollToRow',
                value: function scrollToRow() {
                    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    if (this.Grid) this.Grid.scrollToCell({
                        columnIndex: 0,
                        rowIndex: index
                    });
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props = this.props, className = _props.className, noRowsRenderer = _props.noRowsRenderer, scrollToIndex = _props.scrollToIndex, width = _props.width;
                    var classNames = (0, $a9e1528011c3c32e$var$_clsx2.default)('ReactVirtualized__List', className);
                    return $a9e1528011c3c32e$var$React.createElement($a9e1528011c3c32e$var$_Grid2.default, (0, $a9e1528011c3c32e$var$_extends3.default)({}, this.props, {
                        autoContainerWidth: true,
                        cellRenderer: this._cellRenderer,
                        className: classNames,
                        columnWidth: width,
                        columnCount: 1,
                        noContentRenderer: noRowsRenderer,
                        onScroll: this._onScroll,
                        onSectionRendered: this._onSectionRendered,
                        ref: this._setRef,
                        scrollToRow: scrollToIndex
                    }));
                }
            }
        ]);
        return List;
    }($a9e1528011c3c32e$var$React.PureComponent);
    $a9e1528011c3c32e$var$List.defaultProps = {
        autoHeight: false,
        estimatedRowSize: 30,
        onScroll: function onScroll() {},
        noRowsRenderer: function noRowsRenderer() {
            return null;
        },
        onRowsRendered: function onRowsRendered() {},
        overscanIndicesGetter: $648t0.accessibilityOverscanIndicesGetter,
        overscanRowCount: 10,
        scrollToAlignment: 'auto',
        scrollToIndex: -1,
        style: {}
    };
    $a9e1528011c3c32e$var$List.propTypes = null;
    module.exports.default = $a9e1528011c3c32e$var$List;
});
parcelRegister("knQh8", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$ed6e817027dc4fd8$export$1e511d4a378977f5, (v)=>$ed6e817027dc4fd8$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$ed6e817027dc4fd8$export$2e2bcd8739ae039, (v)=>$ed6e817027dc4fd8$export$2e2bcd8739ae039 = v);
    var $ed6e817027dc4fd8$export$1e511d4a378977f5;
    var $ed6e817027dc4fd8$export$2e2bcd8739ae039;
    "use strict";
    $ed6e817027dc4fd8$export$1e511d4a378977f5 = true;
    var $cjLx9 = parcelRequire("cjLx9");
    var $ed6e817027dc4fd8$var$_assign2 = $ed6e817027dc4fd8$var$_interopRequireDefault($cjLx9);
    function $ed6e817027dc4fd8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    $ed6e817027dc4fd8$export$2e2bcd8739ae039 = $ed6e817027dc4fd8$var$_assign2.default || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
});
parcelRegister("cjLx9", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("6qqLf")),
        __esModule: true
    };
});
parcelRegister("6qqLf", function(module, exports) {
    parcelRequire("lsZw3");
    module.exports = (parcelRequire("dv4GG")).Object.assign;
});
parcelRegister("lsZw3", function(module, exports) {
    var $8EFNH = parcelRequire("8EFNH");
    $8EFNH($8EFNH.S + $8EFNH.F, 'Object', {
        assign: (parcelRequire("eCvdn"))
    });
});
parcelRegister("eCvdn", function(module, exports) {
    'use strict';
    var $hn2oF = parcelRequire("hn2oF");
    var $8rKxD = parcelRequire("8rKxD");
    var $1Jjbj = parcelRequire("1Jjbj");
    var $gvEJa = parcelRequire("gvEJa");
    var $8tRkg = parcelRequire("8tRkg");
    var $2A2jr = parcelRequire("2A2jr");
    var $aa4cd3e3ae28fa7e$var$$assign = Object.assign;
    module.exports = !$aa4cd3e3ae28fa7e$var$$assign || (parcelRequire("5nD9T"))(function() {
        var A = {};
        var B = {};
        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function(k) {
            B[k] = k;
        });
        return $aa4cd3e3ae28fa7e$var$$assign({}, A)[S] != 7 || Object.keys($aa4cd3e3ae28fa7e$var$$assign({}, B)).join('') != K;
    }) ? function assign(target, source) {
        var T = $8tRkg(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = $1Jjbj.f;
        var isEnum = $gvEJa.f;
        while(aLen > index){
            var S = $2A2jr(arguments[index++]);
            var keys = getSymbols ? $8rKxD(S).concat(getSymbols(S)) : $8rKxD(S);
            var length = keys.length;
            var j = 0;
            var key;
            while(length > j){
                key = keys[j++];
                if (!$hn2oF || isEnum.call(S, key)) T[key] = S[key];
            }
        }
        return T;
    } : $aa4cd3e3ae28fa7e$var$$assign;
});
parcelRegister("kSGvk", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("19mDf")),
        __esModule: true
    };
});
parcelRegister("19mDf", function(module, exports) {
    parcelRequire("lmqud");
    var $dv4GG = parcelRequire("dv4GG");
    var $0d682ff232370daf$require$$Object = $dv4GG.Object;
    module.exports = function getOwnPropertyDescriptor(it, key) {
        return $0d682ff232370daf$require$$Object.getOwnPropertyDescriptor(it, key);
    };
});
parcelRegister("lmqud", function(module, exports) {
    var $59DzK = parcelRequire("59DzK");
    var $56mOV = parcelRequire("56mOV");
    var $f8d032b594247451$require$$getOwnPropertyDescriptor = $56mOV.f;
    (parcelRequire("8iDav"))('getOwnPropertyDescriptor', function() {
        return function getOwnPropertyDescriptor(it, key) {
            return $f8d032b594247451$require$$getOwnPropertyDescriptor($59DzK(it), key);
        };
    });
});
parcelRegister("648t0", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellPosition = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.defaultOverscanIndicesGetter = module.exports.defaultCellRangeRenderer = module.exports.accessibilityOverscanIndicesGetter = module.exports.Grid = module.exports.default = undefined;
    var $fqRL4 = parcelRequire("fqRL4");
    Object.defineProperty(module.exports, 'default', {
        enumerable: true,
        get: function get() {
            return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
        }
    });
    Object.defineProperty(module.exports, 'Grid', {
        enumerable: true,
        get: function get() {
            return $46a9af1c8a4ac81a$var$_interopRequireDefault($fqRL4).default;
        }
    });
    var $eAUMQ = parcelRequire("eAUMQ");
    Object.defineProperty(module.exports, 'accessibilityOverscanIndicesGetter', {
        enumerable: true,
        get: function get() {
            return $46a9af1c8a4ac81a$var$_interopRequireDefault($eAUMQ).default;
        }
    });
    var $4n59m = parcelRequire("4n59m");
    Object.defineProperty(module.exports, 'defaultCellRangeRenderer', {
        enumerable: true,
        get: function get() {
            return $46a9af1c8a4ac81a$var$_interopRequireDefault($4n59m).default;
        }
    });
    var $3yG4I = parcelRequire("3yG4I");
    Object.defineProperty(module.exports, 'defaultOverscanIndicesGetter', {
        enumerable: true,
        get: function get() {
            return $46a9af1c8a4ac81a$var$_interopRequireDefault($3yG4I).default;
        }
    });
    var $7G6q0 = parcelRequire("7G6q0");
    function $46a9af1c8a4ac81a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    module.exports.bpfrpt_proptype_NoContentRenderer = $7G6q0.bpfrpt_proptype_NoContentRenderer;
    module.exports.bpfrpt_proptype_Alignment = $7G6q0.bpfrpt_proptype_Alignment;
    module.exports.bpfrpt_proptype_CellPosition = $7G6q0.bpfrpt_proptype_CellPosition;
    module.exports.bpfrpt_proptype_CellSize = $7G6q0.bpfrpt_proptype_CellSize;
    module.exports.bpfrpt_proptype_OverscanIndicesGetter = $7G6q0.bpfrpt_proptype_OverscanIndicesGetter;
    module.exports.bpfrpt_proptype_RenderedSection = $7G6q0.bpfrpt_proptype_RenderedSection;
    module.exports.bpfrpt_proptype_CellRendererParams = $7G6q0.bpfrpt_proptype_CellRendererParams;
    module.exports.bpfrpt_proptype_Scroll = $7G6q0.bpfrpt_proptype_Scroll;
});
parcelRegister("fqRL4", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = undefined;
    var $cjLx9 = parcelRequire("cjLx9");
    var $b3c2fbf6a4e71818$var$_assign2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($cjLx9);
    var $knQh8 = parcelRequire("knQh8");
    var $b3c2fbf6a4e71818$var$_extends3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($knQh8);
    var $29Ol4 = parcelRequire("29Ol4");
    var $b3c2fbf6a4e71818$var$_getPrototypeOf2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($29Ol4);
    var $aXTp8 = parcelRequire("aXTp8");
    var $b3c2fbf6a4e71818$var$_classCallCheck3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $b3c2fbf6a4e71818$var$_createClass3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4tLNB);
    var $5pMaQ = parcelRequire("5pMaQ");
    var $b3c2fbf6a4e71818$var$_possibleConstructorReturn3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5pMaQ);
    var $gHLl6 = parcelRequire("gHLl6");
    var $b3c2fbf6a4e71818$var$_inherits3 = $b3c2fbf6a4e71818$var$_interopRequireDefault($gHLl6);
    var $5uXOq = parcelRequire("5uXOq");
    var $b3c2fbf6a4e71818$var$React = $b3c2fbf6a4e71818$var$_interopRequireWildcard($5uXOq);
    var $hazy9 = parcelRequire("hazy9");
    var $b3c2fbf6a4e71818$var$_clsx2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($hazy9);
    var $5YXtN = parcelRequire("5YXtN");
    var $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($5YXtN);
    var $7LPqF = parcelRequire("7LPqF");
    var $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($7LPqF);
    var $18tv5 = parcelRequire("18tv5");
    var $b3c2fbf6a4e71818$var$_createCallbackMemoizer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($18tv5);
    var $3yG4I = parcelRequire("3yG4I");
    var $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($3yG4I);
    var $dMJpU = parcelRequire("dMJpU");
    var $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dMJpU);
    var $4n59m = parcelRequire("4n59m");
    var $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($4n59m);
    var $dzPmK = parcelRequire("dzPmK");
    var $b3c2fbf6a4e71818$var$_scrollbarSize2 = $b3c2fbf6a4e71818$var$_interopRequireDefault($dzPmK);
    var $9mAr6 = parcelRequire("9mAr6");
    var $cpGQi = parcelRequire("cpGQi");
    parcelRequire("7G6q0");
    var $8rCP3;
    var $b3c2fbf6a4e71818$var$_propTypes2 = $b3c2fbf6a4e71818$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $b3c2fbf6a4e71818$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    function $b3c2fbf6a4e71818$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
    var $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS = {
        OBSERVED: 'observed',
        REQUESTED: 'requested'
    };
    var $b3c2fbf6a4e71818$var$renderNull = function renderNull() {
        return null;
    };
    var $b3c2fbf6a4e71818$var$Grid = function(_React$PureComponent) {
        (0, $b3c2fbf6a4e71818$var$_inherits3.default)(Grid, _React$PureComponent);
        function Grid(props) {
            (0, $b3c2fbf6a4e71818$var$_classCallCheck3.default)(this, Grid);
            var _this = (0, $b3c2fbf6a4e71818$var$_possibleConstructorReturn3.default)(this, (Grid.__proto__ || (0, $b3c2fbf6a4e71818$var$_getPrototypeOf2.default)(Grid)).call(this, props));
            _this._onGridRenderedMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)();
            _this._onScrollMemoizer = (0, $b3c2fbf6a4e71818$var$_createCallbackMemoizer2.default)(false);
            _this._deferredInvalidateColumnIndex = null;
            _this._deferredInvalidateRowIndex = null;
            _this._recomputeScrollLeftFlag = false;
            _this._recomputeScrollTopFlag = false;
            _this._horizontalScrollBarSize = 0;
            _this._verticalScrollBarSize = 0;
            _this._scrollbarPresenceChanged = false;
            _this._renderedColumnStartIndex = 0;
            _this._renderedColumnStopIndex = 0;
            _this._renderedRowStartIndex = 0;
            _this._renderedRowStopIndex = 0;
            _this._styleCache = {};
            _this._cellCache = {};
            _this._debounceScrollEndedCallback = function() {
                _this._disablePointerEventsTimeoutId = null;
                _this.setState({
                    isScrolling: false,
                    needToResetStyleCache: false
                });
            };
            _this._invokeOnGridRenderedHelper = function() {
                var onSectionRendered = _this.props.onSectionRendered;
                _this._onGridRenderedMemoizer({
                    callback: onSectionRendered,
                    indices: {
                        columnOverscanStartIndex: _this._columnStartIndex,
                        columnOverscanStopIndex: _this._columnStopIndex,
                        columnStartIndex: _this._renderedColumnStartIndex,
                        columnStopIndex: _this._renderedColumnStopIndex,
                        rowOverscanStartIndex: _this._rowStartIndex,
                        rowOverscanStopIndex: _this._rowStopIndex,
                        rowStartIndex: _this._renderedRowStartIndex,
                        rowStopIndex: _this._renderedRowStopIndex
                    }
                });
            };
            _this._setScrollingContainerRef = function(ref) {
                _this._scrollingContainer = ref;
            };
            _this._onScroll = function(event) {
                if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target);
            };
            var columnSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
                cellCount: props.columnCount,
                cellSizeGetter: function cellSizeGetter(params) {
                    return Grid._wrapSizeGetter(props.columnWidth)(params);
                },
                estimatedCellSize: Grid._getEstimatedColumnSize(props)
            });
            var rowSizeAndPositionManager = new $b3c2fbf6a4e71818$var$_ScalingCellSizeAndPositionManager2.default({
                cellCount: props.rowCount,
                cellSizeGetter: function cellSizeGetter(params) {
                    return Grid._wrapSizeGetter(props.rowHeight)(params);
                },
                estimatedCellSize: Grid._getEstimatedRowSize(props)
            });
            _this.state = {
                instanceProps: {
                    columnSizeAndPositionManager: columnSizeAndPositionManager,
                    rowSizeAndPositionManager: rowSizeAndPositionManager,
                    prevColumnWidth: props.columnWidth,
                    prevRowHeight: props.rowHeight,
                    prevColumnCount: props.columnCount,
                    prevRowCount: props.rowCount,
                    prevIsScrolling: props.isScrolling === true,
                    prevScrollToColumn: props.scrollToColumn,
                    prevScrollToRow: props.scrollToRow,
                    scrollbarSize: 0,
                    scrollbarSizeMeasured: false
                },
                isScrolling: false,
                scrollDirectionHorizontal: $3yG4I.SCROLL_DIRECTION_FORWARD,
                scrollDirectionVertical: $3yG4I.SCROLL_DIRECTION_FORWARD,
                scrollLeft: 0,
                scrollTop: 0,
                scrollPositionChangeReason: null,
                needToResetStyleCache: false
            };
            if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
            if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
            return _this;
        }
        (0, $b3c2fbf6a4e71818$var$_createClass3.default)(Grid, [
            {
                key: 'getOffsetForCell',
                value: function getOffsetForCell() {
                    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;
                    var offsetProps = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, this.props, {
                        scrollToAlignment: alignment,
                        scrollToColumn: columnIndex,
                        scrollToRow: rowIndex
                    });
                    return {
                        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                        scrollTop: this._getCalculatedScrollTop(offsetProps)
                    };
                }
            },
            {
                key: 'getTotalRowsHeight',
                value: function getTotalRowsHeight() {
                    return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
                }
            },
            {
                key: 'getTotalColumnsWidth',
                value: function getTotalColumnsWidth() {
                    return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
                }
            },
            {
                key: 'handleScrollEvent',
                value: function handleScrollEvent(_ref2) {
                    var _ref2$scrollLeft = _ref2.scrollLeft, scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;
                    if (scrollTopParam < 0) return;
                    this._debounceScrollEnded();
                    var _props = this.props, autoHeight = _props.autoHeight, autoWidth = _props.autoWidth, height = _props.height, width = _props.width;
                    var instanceProps = this.state.instanceProps;
                    var scrollbarSize = instanceProps.scrollbarSize;
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                    var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                    if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                        var newState = {
                            isScrolling: true,
                            scrollDirectionHorizontal: _scrollDirectionHorizontal,
                            scrollDirectionVertical: _scrollDirectionVertical,
                            scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                        };
                        if (!autoHeight) newState.scrollTop = scrollTop;
                        if (!autoWidth) newState.scrollLeft = scrollLeft;
                        newState.needToResetStyleCache = false;
                        this.setState(newState);
                    }
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
            },
            {
                key: 'invalidateCellSizeAfterRender',
                value: function invalidateCellSizeAfterRender(_ref3) {
                    var columnIndex = _ref3.columnIndex, rowIndex = _ref3.rowIndex;
                    this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                    this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
                }
            },
            {
                key: 'measureAllCells',
                value: function measureAllCells() {
                    var _props2 = this.props, columnCount = _props2.columnCount, rowCount = _props2.rowCount;
                    var instanceProps = this.state.instanceProps;
                    instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                    instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
                }
            },
            {
                key: 'recomputeGridSize',
                value: function recomputeGridSize() {
                    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;
                    var _props3 = this.props, scrollToColumn = _props3.scrollToColumn, scrollToRow = _props3.scrollToRow;
                    var instanceProps = this.state.instanceProps;
                    instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                    instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                    this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $3yG4I.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                    this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $3yG4I.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                    this._styleCache = {};
                    this._cellCache = {};
                    this.forceUpdate();
                }
            },
            {
                key: 'scrollToCell',
                value: function scrollToCell(_ref5) {
                    var columnIndex = _ref5.columnIndex, rowIndex = _ref5.rowIndex;
                    var columnCount = this.props.columnCount;
                    var props = this.props;
                    if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                        scrollToColumn: columnIndex
                    }));
                    if (rowIndex !== undefined) this._updateScrollTopForScrollToRow((0, $b3c2fbf6a4e71818$var$_extends3.default)({}, props, {
                        scrollToRow: rowIndex
                    }));
                }
            },
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    var _props4 = this.props, getScrollbarSize = _props4.getScrollbarSize, height = _props4.height, scrollLeft = _props4.scrollLeft, scrollToColumn = _props4.scrollToColumn, scrollTop = _props4.scrollTop, scrollToRow = _props4.scrollToRow, width = _props4.width;
                    var instanceProps = this.state.instanceProps;
                    this._initialScrollTop = 0;
                    this._initialScrollLeft = 0;
                    this._handleInvalidatedGridSize();
                    if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                        var stateUpdate = (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, prevState, {
                            needToResetStyleCache: false
                        });
                        stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                        stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                        return stateUpdate;
                    });
                    if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                        var stateUpdate = Grid._getScrollToPositionStateUpdate({
                            prevState: this.state,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop
                        });
                        if (stateUpdate) {
                            stateUpdate.needToResetStyleCache = false;
                            this.setState(stateUpdate);
                        }
                    }
                    if (this._scrollingContainer) {
                        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                    }
                    var sizeIsBiggerThanZero = height > 0 && width > 0;
                    if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                    if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                    this._invokeOnGridRenderedHelper();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft || 0,
                        scrollTop: scrollTop || 0,
                        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                    });
                    this._maybeCallOnScrollbarPresenceChange();
                }
            },
            {
                key: 'componentDidUpdate',
                value: function componentDidUpdate(prevProps, prevState) {
                    var _this2 = this;
                    var _props5 = this.props, autoHeight = _props5.autoHeight, autoWidth = _props5.autoWidth, columnCount = _props5.columnCount, height = _props5.height, rowCount = _props5.rowCount, scrollToAlignment = _props5.scrollToAlignment, scrollToColumn = _props5.scrollToColumn, scrollToRow = _props5.scrollToRow, width = _props5.width;
                    var _state = this.state, scrollLeft = _state.scrollLeft, scrollPositionChangeReason = _state.scrollPositionChangeReason, scrollTop = _state.scrollTop, instanceProps = _state.instanceProps;
                    this._handleInvalidatedGridSize();
                    var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                    if (scrollPositionChangeReason === $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                    }
                    var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                    if (this._recomputeScrollLeftFlag) {
                        this._recomputeScrollLeftFlag = false;
                        this._updateScrollLeftForScrollToColumn(this.props);
                    } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                        cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        previousCellsCount: prevProps.columnCount,
                        previousCellSize: prevProps.columnWidth,
                        previousScrollToAlignment: prevProps.scrollToAlignment,
                        previousScrollToIndex: prevProps.scrollToColumn,
                        previousSize: prevProps.width,
                        scrollOffset: scrollLeft,
                        scrollToAlignment: scrollToAlignment,
                        scrollToIndex: scrollToColumn,
                        size: width,
                        sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                        updateScrollIndexCallback: function updateScrollIndexCallback() {
                            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                        }
                    });
                    if (this._recomputeScrollTopFlag) {
                        this._recomputeScrollTopFlag = false;
                        this._updateScrollTopForScrollToRow(this.props);
                    } else (0, $b3c2fbf6a4e71818$var$_updateScrollIndexHelper2.default)({
                        cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        previousCellsCount: prevProps.rowCount,
                        previousCellSize: prevProps.rowHeight,
                        previousScrollToAlignment: prevProps.scrollToAlignment,
                        previousScrollToIndex: prevProps.scrollToRow,
                        previousSize: prevProps.height,
                        scrollOffset: scrollTop,
                        scrollToAlignment: scrollToAlignment,
                        scrollToIndex: scrollToRow,
                        size: height,
                        sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                        updateScrollIndexCallback: function updateScrollIndexCallback() {
                            return _this2._updateScrollTopForScrollToRow(_this2.props);
                        }
                    });
                    this._invokeOnGridRenderedHelper();
                    if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                        this._invokeOnScrollMemoizer({
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            totalColumnsWidth: totalColumnsWidth,
                            totalRowsHeight: totalRowsHeight
                        });
                    }
                    this._maybeCallOnScrollbarPresenceChange();
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                }
            },
            {
                key: 'render',
                value: function render() {
                    var _props6 = this.props, autoContainerWidth = _props6.autoContainerWidth, autoHeight = _props6.autoHeight, autoWidth = _props6.autoWidth, className = _props6.className, containerProps = _props6.containerProps, containerRole = _props6.containerRole, containerStyle = _props6.containerStyle, height = _props6.height, id = _props6.id, noContentRenderer = _props6.noContentRenderer, role = _props6.role, style = _props6.style, tabIndex = _props6.tabIndex, width = _props6.width;
                    var _state2 = this.state, instanceProps = _state2.instanceProps, needToResetStyleCache = _state2.needToResetStyleCache;
                    var isScrolling = this._isScrolling();
                    var gridStyle = {
                        boxSizing: 'border-box',
                        direction: 'ltr',
                        height: autoHeight ? 'auto' : height,
                        position: 'relative',
                        width: autoWidth ? 'auto' : width,
                        WebkitOverflowScrolling: 'touch',
                        willChange: 'transform'
                    };
                    if (needToResetStyleCache) this._styleCache = {};
                    if (!this.state.isScrolling) this._resetStyleCache();
                    this._calculateChildrenToRender(this.props, this.state);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                        this._horizontalScrollBarSize = horizontalScrollBarSize;
                        this._verticalScrollBarSize = verticalScrollBarSize;
                        this._scrollbarPresenceChanged = true;
                    }
                    gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                    gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                    var childrenToDisplay = this._childrenToDisplay;
                    var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                    return $b3c2fbf6a4e71818$var$React.createElement('div', (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                        ref: this._setScrollingContainerRef
                    }, containerProps, {
                        'aria-label': this.props['aria-label'],
                        'aria-readonly': this.props['aria-readonly'],
                        className: (0, $b3c2fbf6a4e71818$var$_clsx2.default)('ReactVirtualized__Grid', className),
                        id: id,
                        onScroll: this._onScroll,
                        role: role,
                        style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, gridStyle, style),
                        tabIndex: tabIndex
                    }), childrenToDisplay.length > 0 && $b3c2fbf6a4e71818$var$React.createElement('div', {
                        className: 'ReactVirtualized__Grid__innerScrollContainer',
                        role: containerRole,
                        style: (0, $b3c2fbf6a4e71818$var$_extends3.default)({
                            width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                            height: totalRowsHeight,
                            maxWidth: totalColumnsWidth,
                            maxHeight: totalRowsHeight,
                            overflow: 'hidden',
                            pointerEvents: isScrolling ? 'none' : '',
                            position: 'relative'
                        }, containerStyle)
                    }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
                }
            },
            {
                key: '_calculateChildrenToRender',
                value: function _calculateChildrenToRender() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                    var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                    var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                    var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                    var isScrolling = this._isScrolling(props, state);
                    this._childrenToDisplay = [];
                    if (height > 0 && width > 0) {
                        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                            containerSize: width,
                            offset: scrollLeft
                        });
                        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                            containerSize: height,
                            offset: scrollTop
                        });
                        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                            containerSize: width,
                            offset: scrollLeft
                        });
                        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                            containerSize: height,
                            offset: scrollTop
                        });
                        this._renderedColumnStartIndex = visibleColumnIndices.start;
                        this._renderedColumnStopIndex = visibleColumnIndices.stop;
                        this._renderedRowStartIndex = visibleRowIndices.start;
                        this._renderedRowStopIndex = visibleRowIndices.stop;
                        var overscanColumnIndices = overscanIndicesGetter({
                            direction: 'horizontal',
                            cellCount: columnCount,
                            overscanCellsCount: overscanColumnCount,
                            scrollDirection: scrollDirectionHorizontal,
                            startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                            stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                        });
                        var overscanRowIndices = overscanIndicesGetter({
                            direction: 'vertical',
                            cellCount: rowCount,
                            overscanCellsCount: overscanRowCount,
                            scrollDirection: scrollDirectionVertical,
                            startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                            stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                        });
                        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                        var rowStartIndex = overscanRowIndices.overscanStartIndex;
                        var rowStopIndex = overscanRowIndices.overscanStopIndex;
                        if (deferredMeasurementCache) {
                            if (!deferredMeasurementCache.hasFixedHeight()) {
                                for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                    columnStartIndex = 0;
                                    columnStopIndex = columnCount - 1;
                                    break;
                                }
                            }
                            if (!deferredMeasurementCache.hasFixedWidth()) {
                                for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                    rowStartIndex = 0;
                                    rowStopIndex = rowCount - 1;
                                    break;
                                }
                            }
                        }
                        this._childrenToDisplay = cellRangeRenderer({
                            cellCache: this._cellCache,
                            cellRenderer: cellRenderer,
                            columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                            columnStartIndex: columnStartIndex,
                            columnStopIndex: columnStopIndex,
                            deferredMeasurementCache: deferredMeasurementCache,
                            horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                            isScrolling: isScrolling,
                            isScrollingOptOut: isScrollingOptOut,
                            parent: this,
                            rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                            rowStartIndex: rowStartIndex,
                            rowStopIndex: rowStopIndex,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            styleCache: this._styleCache,
                            verticalOffsetAdjustment: verticalOffsetAdjustment,
                            visibleColumnIndices: visibleColumnIndices,
                            visibleRowIndices: visibleRowIndices
                        });
                        this._columnStartIndex = columnStartIndex;
                        this._columnStopIndex = columnStopIndex;
                        this._rowStartIndex = rowStartIndex;
                        this._rowStopIndex = rowStopIndex;
                    }
                }
            },
            {
                key: '_debounceScrollEnded',
                value: function _debounceScrollEnded() {
                    var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                    if (this._disablePointerEventsTimeoutId) (0, $cpGQi.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                    this._disablePointerEventsTimeoutId = (0, $cpGQi.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
                }
            },
            {
                key: '_handleInvalidatedGridSize',
                value: function _handleInvalidatedGridSize() {
                    if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                        var columnIndex = this._deferredInvalidateColumnIndex;
                        var rowIndex = this._deferredInvalidateRowIndex;
                        this._deferredInvalidateColumnIndex = null;
                        this._deferredInvalidateRowIndex = null;
                        this.recomputeGridSize({
                            columnIndex: columnIndex,
                            rowIndex: rowIndex
                        });
                    }
                }
            },
            {
                key: '_invokeOnScrollMemoizer',
                value: function _invokeOnScrollMemoizer(_ref6) {
                    var _this3 = this;
                    var scrollLeft = _ref6.scrollLeft, scrollTop = _ref6.scrollTop, totalColumnsWidth = _ref6.totalColumnsWidth, totalRowsHeight = _ref6.totalRowsHeight;
                    this._onScrollMemoizer({
                        callback: function callback(_ref7) {
                            var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                            var _props7 = _this3.props, height = _props7.height, onScroll = _props7.onScroll, width = _props7.width;
                            onScroll({
                                clientHeight: height,
                                clientWidth: width,
                                scrollHeight: totalRowsHeight,
                                scrollLeft: scrollLeft,
                                scrollTop: scrollTop,
                                scrollWidth: totalColumnsWidth
                            });
                        },
                        indices: {
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop
                        }
                    });
                }
            },
            {
                key: '_isScrolling',
                value: function _isScrolling() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
                }
            },
            {
                key: '_maybeCallOnScrollbarPresenceChange',
                value: function _maybeCallOnScrollbarPresenceChange() {
                    if (this._scrollbarPresenceChanged) {
                        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                        this._scrollbarPresenceChanged = false;
                        _onScrollbarPresenceChange({
                            horizontal: this._horizontalScrollBarSize > 0,
                            size: this.state.instanceProps.scrollbarSize,
                            vertical: this._verticalScrollBarSize > 0
                        });
                    }
                }
            },
            {
                key: 'scrollToPosition',
                value: function scrollToPosition(_ref8) {
                    var scrollLeft = _ref8.scrollLeft, scrollTop = _ref8.scrollTop;
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
            },
            {
                key: '_getCalculatedScrollLeft',
                value: function _getCalculatedScrollLeft() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    return Grid._getCalculatedScrollLeft(props, state);
                }
            },
            {
                key: '_updateScrollLeftForScrollToColumn',
                value: function _updateScrollLeftForScrollToColumn() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
            },
            {
                key: '_getCalculatedScrollTop',
                value: function _getCalculatedScrollTop() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    return Grid._getCalculatedScrollTop(props, state);
                }
            },
            {
                key: '_resetStyleCache',
                value: function _resetStyleCache() {
                    var styleCache = this._styleCache;
                    var cellCache = this._cellCache;
                    var isScrollingOptOut = this.props.isScrollingOptOut;
                    this._cellCache = {};
                    this._styleCache = {};
                    for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                        var key = rowIndex + '-' + columnIndex;
                        this._styleCache[key] = styleCache[key];
                        if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                    }
                }
            },
            {
                key: '_updateScrollTopForScrollToRow',
                value: function _updateScrollTopForScrollToRow() {
                    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                    var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
            }
        ], [
            {
                key: 'getDerivedStateFromProps',
                value: function getDerivedStateFromProps(nextProps, prevState) {
                    var newState = {};
                    if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                        newState.scrollLeft = 0;
                        newState.scrollTop = 0;
                    } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, Grid._getScrollToPositionStateUpdate({
                        prevState: prevState,
                        scrollLeft: nextProps.scrollLeft,
                        scrollTop: nextProps.scrollTop
                    }));
                    var instanceProps = prevState.instanceProps;
                    newState.needToResetStyleCache = false;
                    if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) newState.needToResetStyleCache = true;
                    instanceProps.columnSizeAndPositionManager.configure({
                        cellCount: nextProps.columnCount,
                        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                    });
                    instanceProps.rowSizeAndPositionManager.configure({
                        cellCount: nextProps.rowCount,
                        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                    });
                    if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                        instanceProps.prevColumnCount = 0;
                        instanceProps.prevRowCount = 0;
                    }
                    if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) (0, $b3c2fbf6a4e71818$var$_assign2.default)(newState, {
                        isScrolling: false
                    });
                    var maybeStateA = void 0;
                    var maybeStateB = void 0;
                    (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                        cellCount: instanceProps.prevColumnCount,
                        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                        computeMetadataCallback: function computeMetadataCallback() {
                            return instanceProps.columnSizeAndPositionManager.resetCell(0);
                        },
                        computeMetadataCallbackProps: nextProps,
                        nextCellsCount: nextProps.columnCount,
                        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                        nextScrollToIndex: nextProps.scrollToColumn,
                        scrollToIndex: instanceProps.prevScrollToColumn,
                        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                            maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                        }
                    });
                    (0, $b3c2fbf6a4e71818$var$_calculateSizeAndPositionDataAndUpdateScrollOffset2.default)({
                        cellCount: instanceProps.prevRowCount,
                        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                        computeMetadataCallback: function computeMetadataCallback() {
                            return instanceProps.rowSizeAndPositionManager.resetCell(0);
                        },
                        computeMetadataCallbackProps: nextProps,
                        nextCellsCount: nextProps.rowCount,
                        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                        nextScrollToIndex: nextProps.scrollToRow,
                        scrollToIndex: instanceProps.prevScrollToRow,
                        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                            maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                        }
                    });
                    instanceProps.prevColumnCount = nextProps.columnCount;
                    instanceProps.prevColumnWidth = nextProps.columnWidth;
                    instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                    instanceProps.prevRowCount = nextProps.rowCount;
                    instanceProps.prevRowHeight = nextProps.rowHeight;
                    instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                    instanceProps.prevScrollToRow = nextProps.scrollToRow;
                    instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                    if (instanceProps.scrollbarSize === undefined) {
                        instanceProps.scrollbarSizeMeasured = false;
                        instanceProps.scrollbarSize = 0;
                    } else instanceProps.scrollbarSizeMeasured = true;
                    newState.instanceProps = instanceProps;
                    return (0, $b3c2fbf6a4e71818$var$_extends3.default)({}, newState, maybeStateA, maybeStateB);
                }
            },
            {
                key: '_getEstimatedColumnSize',
                value: function _getEstimatedColumnSize(props) {
                    return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
                }
            },
            {
                key: '_getEstimatedRowSize',
                value: function _getEstimatedRowSize(props) {
                    return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
                }
            },
            {
                key: '_getScrollToPositionStateUpdate',
                value: function _getScrollToPositionStateUpdate(_ref9) {
                    var prevState = _ref9.prevState, scrollLeft = _ref9.scrollLeft, scrollTop = _ref9.scrollTop;
                    var newState = {
                        scrollPositionChangeReason: $b3c2fbf6a4e71818$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                    };
                    if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                        newState.scrollLeft = scrollLeft;
                    }
                    if (typeof scrollTop === 'number' && scrollTop >= 0) {
                        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $3yG4I.SCROLL_DIRECTION_FORWARD : $3yG4I.SCROLL_DIRECTION_BACKWARD;
                        newState.scrollTop = scrollTop;
                    }
                    if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                    return null;
                }
            },
            {
                key: '_wrapSizeGetter',
                value: function _wrapSizeGetter(value) {
                    return typeof value === 'function' ? value : function() {
                        return value;
                    };
                }
            },
            {
                key: '_getCalculatedScrollLeft',
                value: function _getCalculatedScrollLeft(nextProps, prevState) {
                    var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                    var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                    if (columnCount > 0) {
                        var finalColumn = columnCount - 1;
                        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                            align: scrollToAlignment,
                            containerSize: width - scrollBarSize,
                            currentOffset: scrollLeft,
                            targetIndex: targetIndex
                        });
                    }
                    return 0;
                }
            },
            {
                key: '_getScrollLeftForScrollToColumnStateUpdate',
                value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
                    var scrollLeft = prevState.scrollLeft;
                    var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                    if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                        prevState: prevState,
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: -1
                    });
                    return null;
                }
            },
            {
                key: '_getCalculatedScrollTop',
                value: function _getCalculatedScrollTop(nextProps, prevState) {
                    var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                    var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                    if (rowCount > 0) {
                        var finalRow = rowCount - 1;
                        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                            align: scrollToAlignment,
                            containerSize: height - scrollBarSize,
                            currentOffset: scrollTop,
                            targetIndex: targetIndex
                        });
                    }
                    return 0;
                }
            },
            {
                key: '_getScrollTopForScrollToRowStateUpdate',
                value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
                    var scrollTop = prevState.scrollTop;
                    var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                    if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                        prevState: prevState,
                        scrollLeft: -1,
                        scrollTop: calculatedScrollTop
                    });
                    return null;
                }
            }
        ]);
        return Grid;
    }($b3c2fbf6a4e71818$var$React.PureComponent);
    $b3c2fbf6a4e71818$var$Grid.defaultProps = {
        'aria-label': 'grid',
        'aria-readonly': true,
        autoContainerWidth: false,
        autoHeight: false,
        autoWidth: false,
        cellRangeRenderer: $b3c2fbf6a4e71818$var$_defaultCellRangeRenderer2.default,
        containerRole: 'rowgroup',
        containerStyle: {},
        estimatedColumnSize: 100,
        estimatedRowSize: 30,
        getScrollbarSize: $b3c2fbf6a4e71818$var$_scrollbarSize2.default,
        noContentRenderer: $b3c2fbf6a4e71818$var$renderNull,
        onScroll: function onScroll() {},
        onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
        onSectionRendered: function onSectionRendered() {},
        overscanColumnCount: 0,
        overscanIndicesGetter: $b3c2fbf6a4e71818$var$_defaultOverscanIndicesGetter2.default,
        overscanRowCount: 10,
        role: 'grid',
        scrollingResetTimeInterval: $b3c2fbf6a4e71818$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
        scrollToAlignment: 'auto',
        scrollToColumn: -1,
        scrollToRow: -1,
        style: {},
        tabIndex: 0,
        isScrollingOptOut: false
    };
    $b3c2fbf6a4e71818$var$Grid.propTypes = null;
    (0, $9mAr6.polyfill)($b3c2fbf6a4e71818$var$Grid);
    module.exports.default = $b3c2fbf6a4e71818$var$Grid;
});
parcelRegister("hazy9", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "clsx", ()=>$c7fef249cf6cf466$export$4f5d2d50c9deca37);
    $parcel$export(module.exports, "default", ()=>$c7fef249cf6cf466$export$2e2bcd8739ae039);
    function $c7fef249cf6cf466$var$r(e) {
        var t, f, n = "";
        if ("string" == typeof e || "number" == typeof e) n += e;
        else if ("object" == typeof e) {
            if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c7fef249cf6cf466$var$r(e[t])) && (n && (n += " "), n += f);
            else for(t in e)e[t] && (n && (n += " "), n += t);
        }
        return n;
    }
    function $c7fef249cf6cf466$export$4f5d2d50c9deca37() {
        for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c7fef249cf6cf466$var$r(e)) && (n && (n += " "), n += t);
        return n;
    }
    var $c7fef249cf6cf466$export$2e2bcd8739ae039 = $c7fef249cf6cf466$export$4f5d2d50c9deca37;
});
parcelRegister("5YXtN", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
    function $45b0b1bd0c27f2c2$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
        var cellCount = _ref.cellCount, cellSize = _ref.cellSize, computeMetadataCallback = _ref.computeMetadataCallback, computeMetadataCallbackProps = _ref.computeMetadataCallbackProps, nextCellsCount = _ref.nextCellsCount, nextCellSize = _ref.nextCellSize, nextScrollToIndex = _ref.nextScrollToIndex, scrollToIndex = _ref.scrollToIndex, updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;
        if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
            computeMetadataCallback(computeMetadataCallbackProps);
            if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
        }
    }
});
parcelRegister("7LPqF", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $1JRrJ = parcelRequire("1JRrJ");
    var $5a84d0ec79150934$var$_objectWithoutProperties3 = $5a84d0ec79150934$var$_interopRequireDefault($1JRrJ);
    var $aXTp8 = parcelRequire("aXTp8");
    var $5a84d0ec79150934$var$_classCallCheck3 = $5a84d0ec79150934$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $5a84d0ec79150934$var$_createClass3 = $5a84d0ec79150934$var$_interopRequireDefault($4tLNB);
    var $iCIeR = parcelRequire("iCIeR");
    var $5a84d0ec79150934$var$_CellSizeAndPositionManager2 = $5a84d0ec79150934$var$_interopRequireDefault($iCIeR);
    var $iLAay = parcelRequire("iLAay");
    parcelRequire("7G6q0");
    function $5a84d0ec79150934$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager = function() {
        function ScalingCellSizeAndPositionManager(_ref) {
            var _ref$maxScrollSize = _ref.maxScrollSize, maxScrollSize = _ref$maxScrollSize === undefined ? (0, $iLAay.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $5a84d0ec79150934$var$_objectWithoutProperties3.default)(_ref, [
                'maxScrollSize'
            ]);
            (0, $5a84d0ec79150934$var$_classCallCheck3.default)(this, ScalingCellSizeAndPositionManager);
            this._cellSizeAndPositionManager = new $5a84d0ec79150934$var$_CellSizeAndPositionManager2.default(params);
            this._maxScrollSize = maxScrollSize;
        }
        (0, $5a84d0ec79150934$var$_createClass3.default)(ScalingCellSizeAndPositionManager, [
            {
                key: 'areOffsetsAdjusted',
                value: function areOffsetsAdjusted() {
                    return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
                }
            },
            {
                key: 'configure',
                value: function configure(params) {
                    this._cellSizeAndPositionManager.configure(params);
                }
            },
            {
                key: 'getCellCount',
                value: function getCellCount() {
                    return this._cellSizeAndPositionManager.getCellCount();
                }
            },
            {
                key: 'getEstimatedCellSize',
                value: function getEstimatedCellSize() {
                    return this._cellSizeAndPositionManager.getEstimatedCellSize();
                }
            },
            {
                key: 'getLastMeasuredIndex',
                value: function getLastMeasuredIndex() {
                    return this._cellSizeAndPositionManager.getLastMeasuredIndex();
                }
            },
            {
                key: 'getOffsetAdjustment',
                value: function getOffsetAdjustment(_ref2) {
                    var containerSize = _ref2.containerSize, offset = _ref2.offset;
                    var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                    var safeTotalSize = this.getTotalSize();
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - totalSize));
                }
            },
            {
                key: 'getSizeAndPositionOfCell',
                value: function getSizeAndPositionOfCell(index) {
                    return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
                }
            },
            {
                key: 'getSizeAndPositionOfLastMeasuredCell',
                value: function getSizeAndPositionOfLastMeasuredCell() {
                    return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
                }
            },
            {
                key: 'getTotalSize',
                value: function getTotalSize() {
                    return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
                }
            },
            {
                key: 'getUpdatedOffsetForIndex',
                value: function getUpdatedOffsetForIndex(_ref3) {
                    var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                    currentOffset = this._safeOffsetToOffset({
                        containerSize: containerSize,
                        offset: currentOffset
                    });
                    var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: align,
                        containerSize: containerSize,
                        currentOffset: currentOffset,
                        targetIndex: targetIndex
                    });
                    return this._offsetToSafeOffset({
                        containerSize: containerSize,
                        offset: offset
                    });
                }
            },
            {
                key: 'getVisibleCellRange',
                value: function getVisibleCellRange(_ref4) {
                    var containerSize = _ref4.containerSize, offset = _ref4.offset;
                    offset = this._safeOffsetToOffset({
                        containerSize: containerSize,
                        offset: offset
                    });
                    return this._cellSizeAndPositionManager.getVisibleCellRange({
                        containerSize: containerSize,
                        offset: offset
                    });
                }
            },
            {
                key: 'resetCell',
                value: function resetCell(index) {
                    this._cellSizeAndPositionManager.resetCell(index);
                }
            },
            {
                key: '_getOffsetPercentage',
                value: function _getOffsetPercentage(_ref5) {
                    var containerSize = _ref5.containerSize, offset = _ref5.offset, totalSize = _ref5.totalSize;
                    return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
                }
            },
            {
                key: '_offsetToSafeOffset',
                value: function _offsetToSafeOffset(_ref6) {
                    var containerSize = _ref6.containerSize, offset = _ref6.offset;
                    var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                    var safeTotalSize = this.getTotalSize();
                    if (totalSize === safeTotalSize) return offset;
                    else {
                        var offsetPercentage = this._getOffsetPercentage({
                            containerSize: containerSize,
                            offset: offset,
                            totalSize: totalSize
                        });
                        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                    }
                }
            },
            {
                key: '_safeOffsetToOffset',
                value: function _safeOffsetToOffset(_ref7) {
                    var containerSize = _ref7.containerSize, offset = _ref7.offset;
                    var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                    var safeTotalSize = this.getTotalSize();
                    if (totalSize === safeTotalSize) return offset;
                    else {
                        var offsetPercentage = this._getOffsetPercentage({
                            containerSize: containerSize,
                            offset: offset,
                            totalSize: safeTotalSize
                        });
                        return Math.round(offsetPercentage * (totalSize - containerSize));
                    }
                }
            }
        ]);
        return ScalingCellSizeAndPositionManager;
    }();
    module.exports.default = $5a84d0ec79150934$var$ScalingCellSizeAndPositionManager;
});
parcelRegister("1JRrJ", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "__esModule", ()=>$144373be65000f07$export$1e511d4a378977f5, (v)=>$144373be65000f07$export$1e511d4a378977f5 = v);
    $parcel$export(module.exports, "default", ()=>$144373be65000f07$export$2e2bcd8739ae039, (v)=>$144373be65000f07$export$2e2bcd8739ae039 = v);
    var $144373be65000f07$export$1e511d4a378977f5;
    var $144373be65000f07$export$2e2bcd8739ae039;
    "use strict";
    $144373be65000f07$export$1e511d4a378977f5 = true;
    $144373be65000f07$export$2e2bcd8739ae039 = function(obj, keys) {
        var target = {};
        for(var i in obj){
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
        }
        return target;
    };
});
parcelRegister("iCIeR", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $aXTp8 = parcelRequire("aXTp8");
    var $d8ee1776fff0aaf0$var$_classCallCheck3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($aXTp8);
    var $4tLNB = parcelRequire("4tLNB");
    var $d8ee1776fff0aaf0$var$_createClass3 = $d8ee1776fff0aaf0$var$_interopRequireDefault($4tLNB);
    parcelRequire("7G6q0");
    function $d8ee1776fff0aaf0$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $d8ee1776fff0aaf0$var$CellSizeAndPositionManager = function() {
        function CellSizeAndPositionManager(_ref) {
            var cellCount = _ref.cellCount, cellSizeGetter = _ref.cellSizeGetter, estimatedCellSize = _ref.estimatedCellSize;
            (0, $d8ee1776fff0aaf0$var$_classCallCheck3.default)(this, CellSizeAndPositionManager);
            this._cellSizeAndPositionData = {};
            this._lastMeasuredIndex = -1;
            this._lastBatchedIndex = -1;
            this._cellSizeGetter = cellSizeGetter;
            this._cellCount = cellCount;
            this._estimatedCellSize = estimatedCellSize;
        }
        (0, $d8ee1776fff0aaf0$var$_createClass3.default)(CellSizeAndPositionManager, [
            {
                key: 'areOffsetsAdjusted',
                value: function areOffsetsAdjusted() {
                    return false;
                }
            },
            {
                key: 'configure',
                value: function configure(_ref2) {
                    var cellCount = _ref2.cellCount, estimatedCellSize = _ref2.estimatedCellSize, cellSizeGetter = _ref2.cellSizeGetter;
                    this._cellCount = cellCount;
                    this._estimatedCellSize = estimatedCellSize;
                    this._cellSizeGetter = cellSizeGetter;
                }
            },
            {
                key: 'getCellCount',
                value: function getCellCount() {
                    return this._cellCount;
                }
            },
            {
                key: 'getEstimatedCellSize',
                value: function getEstimatedCellSize() {
                    return this._estimatedCellSize;
                }
            },
            {
                key: 'getLastMeasuredIndex',
                value: function getLastMeasuredIndex() {
                    return this._lastMeasuredIndex;
                }
            },
            {
                key: 'getOffsetAdjustment',
                value: function getOffsetAdjustment() {
                    return 0;
                }
            },
            {
                key: 'getSizeAndPositionOfCell',
                value: function getSizeAndPositionOfCell(index) {
                    if (index < 0 || index >= this._cellCount) throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
                    if (index > this._lastMeasuredIndex) {
                        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                        for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                            var _size = this._cellSizeGetter({
                                index: i
                            });
                            if (_size === undefined || isNaN(_size)) throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
                            else if (_size === null) {
                                this._cellSizeAndPositionData[i] = {
                                    offset: _offset,
                                    size: 0
                                };
                                this._lastBatchedIndex = index;
                            } else {
                                this._cellSizeAndPositionData[i] = {
                                    offset: _offset,
                                    size: _size
                                };
                                _offset += _size;
                                this._lastMeasuredIndex = index;
                            }
                        }
                    }
                    return this._cellSizeAndPositionData[index];
                }
            },
            {
                key: 'getSizeAndPositionOfLastMeasuredCell',
                value: function getSizeAndPositionOfLastMeasuredCell() {
                    return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                        offset: 0,
                        size: 0
                    };
                }
            },
            {
                key: 'getTotalSize',
                value: function getTotalSize() {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                    var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                    return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
                }
            },
            {
                key: 'getUpdatedOffsetForIndex',
                value: function getUpdatedOffsetForIndex(_ref3) {
                    var _ref3$align = _ref3.align, align = _ref3$align === undefined ? 'auto' : _ref3$align, containerSize = _ref3.containerSize, currentOffset = _ref3.currentOffset, targetIndex = _ref3.targetIndex;
                    if (containerSize <= 0) return 0;
                    var datum = this.getSizeAndPositionOfCell(targetIndex);
                    var maxOffset = datum.offset;
                    var minOffset = maxOffset - containerSize + datum.size;
                    var idealOffset = void 0;
                    switch(align){
                        case 'start':
                            idealOffset = maxOffset;
                            break;
                        case 'end':
                            idealOffset = minOffset;
                            break;
                        case 'center':
                            idealOffset = maxOffset - (containerSize - datum.size) / 2;
                            break;
                        default:
                            idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                            break;
                    }
                    var totalSize = this.getTotalSize();
                    return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
                }
            },
            {
                key: 'getVisibleCellRange',
                value: function getVisibleCellRange(params) {
                    var containerSize = params.containerSize, offset = params.offset;
                    var totalSize = this.getTotalSize();
                    if (totalSize === 0) return {};
                    var maxOffset = offset + containerSize;
                    var start = this._findNearestCell(offset);
                    var datum = this.getSizeAndPositionOfCell(start);
                    offset = datum.offset + datum.size;
                    var stop = start;
                    while(offset < maxOffset && stop < this._cellCount - 1){
                        stop++;
                        offset += this.getSizeAndPositionOfCell(stop).size;
                    }
                    return {
                        start: start,
                        stop: stop
                    };
                }
            },
            {
                key: 'resetCell',
                value: function resetCell(index) {
                    this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
                }
            },
            {
                key: '_binarySearch',
                value: function _binarySearch(high, low, offset) {
                    while(low <= high){
                        var middle = low + Math.floor((high - low) / 2);
                        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                        if (_currentOffset === offset) return middle;
                        else if (_currentOffset < offset) low = middle + 1;
                        else if (_currentOffset > offset) high = middle - 1;
                    }
                    if (low > 0) return low - 1;
                    else return 0;
                }
            },
            {
                key: '_exponentialSearch',
                value: function _exponentialSearch(index, offset) {
                    var interval = 1;
                    while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                        index += interval;
                        interval *= 2;
                    }
                    return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
                }
            },
            {
                key: '_findNearestCell',
                value: function _findNearestCell(offset) {
                    if (isNaN(offset)) throw Error('Invalid offset ' + offset + ' specified');
                    offset = Math.max(0, offset);
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                    if (lastMeasuredCellSizeAndPosition.offset >= offset) return this._binarySearch(lastMeasuredIndex, 0, offset);
                    else return this._exponentialSearch(lastMeasuredIndex, offset);
                }
            }
        ]);
        return CellSizeAndPositionManager;
    }();
    module.exports.default = $d8ee1776fff0aaf0$var$CellSizeAndPositionManager;
});
parcelRegister("7G6q0", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_VisibleCellRange = module.exports.bpfrpt_proptype_Alignment = module.exports.bpfrpt_proptype_OverscanIndicesGetter = module.exports.bpfrpt_proptype_OverscanIndices = module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = module.exports.bpfrpt_proptype_RenderedSection = module.exports.bpfrpt_proptype_ScrollbarPresenceChange = module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_NoContentRenderer = module.exports.bpfrpt_proptype_CellSize = module.exports.bpfrpt_proptype_CellSizeGetter = module.exports.bpfrpt_proptype_CellRangeRenderer = module.exports.bpfrpt_proptype_CellRangeRendererParams = module.exports.bpfrpt_proptype_StyleCache = module.exports.bpfrpt_proptype_CellCache = module.exports.bpfrpt_proptype_CellRenderer = module.exports.bpfrpt_proptype_CellRendererParams = module.exports.bpfrpt_proptype_CellPosition = undefined;
    var $5uXOq = parcelRequire("5uXOq");
    var $59716f33b0e6b532$var$React = $59716f33b0e6b532$var$_interopRequireWildcard($5uXOq);
    var $7LPqF = parcelRequire("7LPqF");
    var $59716f33b0e6b532$var$_ScalingCellSizeAndPositionManager2 = $59716f33b0e6b532$var$_interopRequireDefault($7LPqF);
    var $8rCP3;
    var $59716f33b0e6b532$var$_propTypes2 = $59716f33b0e6b532$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $59716f33b0e6b532$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $59716f33b0e6b532$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellCache = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_CellSize = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_Scroll = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_Alignment = null;
    var $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange = null;
    module.exports.bpfrpt_proptype_CellPosition = $59716f33b0e6b532$var$bpfrpt_proptype_CellPosition;
    module.exports.bpfrpt_proptype_CellRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRendererParams;
    module.exports.bpfrpt_proptype_CellRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRenderer;
    module.exports.bpfrpt_proptype_CellCache = $59716f33b0e6b532$var$bpfrpt_proptype_CellCache;
    module.exports.bpfrpt_proptype_StyleCache = $59716f33b0e6b532$var$bpfrpt_proptype_StyleCache;
    module.exports.bpfrpt_proptype_CellRangeRendererParams = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRendererParams;
    module.exports.bpfrpt_proptype_CellRangeRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_CellRangeRenderer;
    module.exports.bpfrpt_proptype_CellSizeGetter = $59716f33b0e6b532$var$bpfrpt_proptype_CellSizeGetter;
    module.exports.bpfrpt_proptype_CellSize = $59716f33b0e6b532$var$bpfrpt_proptype_CellSize;
    module.exports.bpfrpt_proptype_NoContentRenderer = $59716f33b0e6b532$var$bpfrpt_proptype_NoContentRenderer;
    module.exports.bpfrpt_proptype_Scroll = $59716f33b0e6b532$var$bpfrpt_proptype_Scroll;
    module.exports.bpfrpt_proptype_ScrollbarPresenceChange = $59716f33b0e6b532$var$bpfrpt_proptype_ScrollbarPresenceChange;
    module.exports.bpfrpt_proptype_RenderedSection = $59716f33b0e6b532$var$bpfrpt_proptype_RenderedSection;
    module.exports.bpfrpt_proptype_OverscanIndicesGetterParams = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetterParams;
    module.exports.bpfrpt_proptype_OverscanIndices = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndices;
    module.exports.bpfrpt_proptype_OverscanIndicesGetter = $59716f33b0e6b532$var$bpfrpt_proptype_OverscanIndicesGetter;
    module.exports.bpfrpt_proptype_Alignment = $59716f33b0e6b532$var$bpfrpt_proptype_Alignment;
    module.exports.bpfrpt_proptype_VisibleCellRange = $59716f33b0e6b532$var$bpfrpt_proptype_VisibleCellRange;
});
parcelRegister("iLAay", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
    var $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
    var $da98ac3c245269b0$var$isBrowser = function isBrowser() {
        return typeof window !== 'undefined';
    };
    var $da98ac3c245269b0$var$isChrome = function isChrome() {
        return !!window.chrome;
    };
    var $da98ac3c245269b0$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() {
        if ($da98ac3c245269b0$var$isBrowser()) {
            if ($da98ac3c245269b0$var$isChrome()) return $da98ac3c245269b0$var$CHROME_MAX_ELEMENT_SIZE;
        }
        return $da98ac3c245269b0$var$DEFAULT_MAX_ELEMENT_SIZE;
    };
});
parcelRegister("18tv5", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $9lQFv = parcelRequire("9lQFv");
    var $0d3d6bf35b624a82$var$_keys2 = $0d3d6bf35b624a82$var$_interopRequireDefault($9lQFv);
    module.exports.default = $0d3d6bf35b624a82$var$createCallbackMemoizer;
    function $0d3d6bf35b624a82$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $0d3d6bf35b624a82$var$createCallbackMemoizer() {
        var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var cachedIndices = {};
        return function(_ref) {
            var callback = _ref.callback, indices = _ref.indices;
            var keys = (0, $0d3d6bf35b624a82$var$_keys2.default)(indices);
            var allInitialized = !requireAllKeys || keys.every(function(key) {
                var value = indices[key];
                return Array.isArray(value) ? value.length > 0 : value >= 0;
            });
            var indexChanged = keys.length !== (0, $0d3d6bf35b624a82$var$_keys2.default)(cachedIndices).length || keys.some(function(key) {
                var cachedValue = cachedIndices[key];
                var value = indices[key];
                return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
            });
            cachedIndices = indices;
            if (allInitialized && indexChanged) callback(indices);
        };
    }
});
parcelRegister("9lQFv", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("gOLKn")),
        __esModule: true
    };
});
parcelRegister("gOLKn", function(module, exports) {
    parcelRequire("9Swt2");
    module.exports = (parcelRequire("dv4GG")).Object.keys;
});
parcelRegister("9Swt2", function(module, exports) {
    var $8tRkg = parcelRequire("8tRkg");
    var $8rKxD = parcelRequire("8rKxD");
    (parcelRequire("8iDav"))('keys', function() {
        return function keys(it) {
            return $8rKxD($8tRkg(it));
        };
    });
});
parcelRegister("3yG4I", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
    module.exports.default = $29752f486201a5cb$var$defaultOverscanIndicesGetter;
    parcelRequire("7G6q0");
    var $29752f486201a5cb$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
    var $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
    var $29752f486201a5cb$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
    var $29752f486201a5cb$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
    function $29752f486201a5cb$var$defaultOverscanIndicesGetter(_ref) {
        var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
        if (scrollDirection === $29752f486201a5cb$var$SCROLL_DIRECTION_FORWARD) return {
            overscanStartIndex: Math.max(0, startIndex),
            overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
        };
        else return {
            overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
            overscanStopIndex: Math.min(cellCount - 1, stopIndex)
        };
    }
});
parcelRegister("dMJpU", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $a092fce61c6915f9$var$updateScrollIndexHelper;
    var $7LPqF = parcelRequire("7LPqF");
    var $a092fce61c6915f9$var$_ScalingCellSizeAndPositionManager2 = $a092fce61c6915f9$var$_interopRequireDefault($7LPqF);
    parcelRequire("7G6q0");
    function $a092fce61c6915f9$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $a092fce61c6915f9$var$updateScrollIndexHelper(_ref) {
        var cellSize = _ref.cellSize, cellSizeAndPositionManager = _ref.cellSizeAndPositionManager, previousCellsCount = _ref.previousCellsCount, previousCellSize = _ref.previousCellSize, previousScrollToAlignment = _ref.previousScrollToAlignment, previousScrollToIndex = _ref.previousScrollToIndex, previousSize = _ref.previousSize, scrollOffset = _ref.scrollOffset, scrollToAlignment = _ref.scrollToAlignment, scrollToIndex = _ref.scrollToIndex, size = _ref.size, sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref.updateScrollIndexCallback;
        var cellCount = cellSizeAndPositionManager.getCellCount();
        var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
        var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
        if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
        else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
            if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
        }
    }
});
parcelRegister("4n59m", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $32ed4e129ee96b29$var$defaultCellRangeRenderer;
    parcelRequire("7G6q0");
    function $32ed4e129ee96b29$var$defaultCellRangeRenderer(_ref) {
        var cellCache = _ref.cellCache, cellRenderer = _ref.cellRenderer, columnSizeAndPositionManager = _ref.columnSizeAndPositionManager, columnStartIndex = _ref.columnStartIndex, columnStopIndex = _ref.columnStopIndex, deferredMeasurementCache = _ref.deferredMeasurementCache, horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment, isScrolling = _ref.isScrolling, isScrollingOptOut = _ref.isScrollingOptOut, parent = _ref.parent, rowSizeAndPositionManager = _ref.rowSizeAndPositionManager, rowStartIndex = _ref.rowStartIndex, rowStopIndex = _ref.rowStopIndex, styleCache = _ref.styleCache, verticalOffsetAdjustment = _ref.verticalOffsetAdjustment, visibleColumnIndices = _ref.visibleColumnIndices, visibleRowIndices = _ref.visibleRowIndices;
        var renderedCells = [];
        var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
        var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
        for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
            var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
                var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
                var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
                var key = rowIndex + '-' + columnIndex;
                var style = void 0;
                if (canCacheStyle && styleCache[key]) style = styleCache[key];
                else if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) style = {
                    height: 'auto',
                    left: 0,
                    position: 'absolute',
                    top: 0,
                    width: 'auto'
                };
                else {
                    style = {
                        height: rowDatum.size,
                        left: columnDatum.offset + horizontalOffsetAdjustment,
                        position: 'absolute',
                        top: rowDatum.offset + verticalOffsetAdjustment,
                        width: columnDatum.size
                    };
                    styleCache[key] = style;
                }
                var cellRendererParams = {
                    columnIndex: columnIndex,
                    isScrolling: isScrolling,
                    isVisible: isVisible,
                    key: key,
                    parent: parent,
                    rowIndex: rowIndex,
                    style: style
                };
                var renderedCell = void 0;
                if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                    if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                    renderedCell = cellCache[key];
                } else renderedCell = cellRenderer(cellRendererParams);
                if (renderedCell == null || renderedCell === false) continue;
                renderedCells.push(renderedCell);
            }
        }
        return renderedCells;
    }
    function $32ed4e129ee96b29$var$warnAboutMissingStyle(parent, renderedCell) {}
});
parcelRegister("dzPmK", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$9e266377030444a5$export$2e2bcd8739ae039);
    var $5B5cv = parcelRequire("5B5cv");
    var $9e266377030444a5$var$size;
    function $9e266377030444a5$export$2e2bcd8739ae039(recalc) {
        if (!$9e266377030444a5$var$size && $9e266377030444a5$var$size !== 0 || recalc) {
            if (0, $5B5cv.default) {
                var scrollDiv = document.createElement('div');
                scrollDiv.style.position = 'absolute';
                scrollDiv.style.top = '-9999px';
                scrollDiv.style.width = '50px';
                scrollDiv.style.height = '50px';
                scrollDiv.style.overflow = 'scroll';
                document.body.appendChild(scrollDiv);
                $9e266377030444a5$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv);
            }
        }
        return $9e266377030444a5$var$size;
    }
});
parcelRegister("5B5cv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4134712f1bdfe873$export$2e2bcd8739ae039);
    var $4134712f1bdfe873$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
});
parcelRegister("9mAr6", function(module, exports) {
    $parcel$export(module.exports, "polyfill", ()=>$6d126e96e4dcb8d7$export$cea1c58a6db52bca);
    function $6d126e96e4dcb8d7$var$componentWillMount() {
        var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
        if (state !== null && state !== undefined) this.setState(state);
    }
    function $6d126e96e4dcb8d7$var$componentWillReceiveProps(nextProps) {
        function updater(prevState) {
            var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
            return state !== null && state !== undefined ? state : null;
        }
        this.setState(updater.bind(this));
    }
    function $6d126e96e4dcb8d7$var$componentWillUpdate(nextProps, nextState) {
        try {
            var prevProps = this.props;
            var prevState = this.state;
            this.props = nextProps;
            this.state = nextState;
            this.__reactInternalSnapshotFlag = true;
            this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
        } finally{
            this.props = prevProps;
            this.state = prevState;
        }
    }
    $6d126e96e4dcb8d7$var$componentWillMount.__suppressDeprecationWarning = true;
    $6d126e96e4dcb8d7$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
    $6d126e96e4dcb8d7$var$componentWillUpdate.__suppressDeprecationWarning = true;
    function $6d126e96e4dcb8d7$export$cea1c58a6db52bca(Component) {
        var prototype = Component.prototype;
        if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
        if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
        var foundWillMountName = null;
        var foundWillReceivePropsName = null;
        var foundWillUpdateName = null;
        if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
        else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
        if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
        else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
        if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
        else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
        if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
            var componentName = Component.displayName || Component.name;
            var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
            throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            prototype.componentWillMount = $6d126e96e4dcb8d7$var$componentWillMount;
            prototype.componentWillReceiveProps = $6d126e96e4dcb8d7$var$componentWillReceiveProps;
        }
        if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
            if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
            prototype.componentWillUpdate = $6d126e96e4dcb8d7$var$componentWillUpdate;
            var componentDidUpdate = prototype.componentDidUpdate;
            prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
                var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
                componentDidUpdate.call(this, prevProps, prevState, snapshot);
            };
        }
        return Component;
    }
});
parcelRegister("cpGQi", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_AnimationTimeoutId = module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = undefined;
    var $i67QH = parcelRequire("i67QH");
    var $90990d7bb4c83bf1$var$_promise2 = $90990d7bb4c83bf1$var$_interopRequireDefault($i67QH);
    var $b81LX = parcelRequire("b81LX");
    var $8rCP3;
    var $90990d7bb4c83bf1$var$_propTypes2 = $90990d7bb4c83bf1$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $90990d7bb4c83bf1$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId = null;
    var $90990d7bb4c83bf1$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
        return (0, $b81LX.caf)(frame.id);
    };
    var $90990d7bb4c83bf1$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
        var start = void 0;
        $90990d7bb4c83bf1$var$_promise2.default.resolve().then(function() {
            start = Date.now();
        });
        var timeout = function timeout() {
            if (Date.now() - start >= delay) callback.call();
            else frame.id = (0, $b81LX.raf)(timeout);
        };
        var frame = {
            id: (0, $b81LX.raf)(timeout)
        };
        return frame;
    };
    module.exports.bpfrpt_proptype_AnimationTimeoutId = $90990d7bb4c83bf1$var$bpfrpt_proptype_AnimationTimeoutId;
});
parcelRegister("i67QH", function(module, exports) {
    module.exports = {
        "default": (parcelRequire("ftBor")),
        __esModule: true
    };
});
parcelRegister("ftBor", function(module, exports) {
    parcelRequire("55SkS");
    parcelRequire("ltQ0T");
    parcelRequire("fQXw1");
    parcelRequire("8slOX");
    parcelRequire("hsmRz");
    parcelRequire("6B7zO");
    module.exports = (parcelRequire("dv4GG")).Promise;
});
parcelRegister("8slOX", function(module, exports) {
    'use strict';
    var $6uq1C = parcelRequire("6uq1C");
    var $pe18r = parcelRequire("pe18r");
    var $gnejD = parcelRequire("gnejD");
    var $fdKPE = parcelRequire("fdKPE");
    var $8EFNH = parcelRequire("8EFNH");
    var $6VwBm = parcelRequire("6VwBm");
    var $jd5tk = parcelRequire("jd5tk");
    var $igM2P = parcelRequire("igM2P");
    var $2TQW8 = parcelRequire("2TQW8");
    var $PVFqE = parcelRequire("PVFqE");
    var $kA9gG = parcelRequire("kA9gG");
    var $6281dd6c370e2cd1$require$task = $kA9gG.set;
    var $6281dd6c370e2cd1$var$microtask = (parcelRequire("cKTs5"))();
    var $jtCbh = parcelRequire("jtCbh");
    var $5kpnZ = parcelRequire("5kpnZ");
    var $8JzcF = parcelRequire("8JzcF");
    var $7MV4M = parcelRequire("7MV4M");
    var $6281dd6c370e2cd1$var$PROMISE = 'Promise';
    var $6281dd6c370e2cd1$var$TypeError = $pe18r.TypeError;
    var $6281dd6c370e2cd1$var$process = $pe18r.process;
    var $6281dd6c370e2cd1$var$versions = $6281dd6c370e2cd1$var$process && $6281dd6c370e2cd1$var$process.versions;
    var $6281dd6c370e2cd1$var$v8 = $6281dd6c370e2cd1$var$versions && $6281dd6c370e2cd1$var$versions.v8 || '';
    var $6281dd6c370e2cd1$var$$Promise = $pe18r[$6281dd6c370e2cd1$var$PROMISE];
    var $6281dd6c370e2cd1$var$isNode = $fdKPE($6281dd6c370e2cd1$var$process) == 'process';
    var $6281dd6c370e2cd1$var$empty = function() {};
    var $6281dd6c370e2cd1$var$Internal, $6281dd6c370e2cd1$var$newGenericPromiseCapability, $6281dd6c370e2cd1$var$OwnPromiseCapability, $6281dd6c370e2cd1$var$Wrapper;
    var $6281dd6c370e2cd1$var$newPromiseCapability = $6281dd6c370e2cd1$var$newGenericPromiseCapability = $jtCbh.f;
    var $6281dd6c370e2cd1$var$USE_NATIVE = !!function() {
        try {
            var promise = $6281dd6c370e2cd1$var$$Promise.resolve(1);
            var FakePromise = (promise.constructor = {})[(parcelRequire("cNfss"))('species')] = function(exec) {
                exec($6281dd6c370e2cd1$var$empty, $6281dd6c370e2cd1$var$empty);
            };
            return ($6281dd6c370e2cd1$var$isNode || typeof PromiseRejectionEvent == 'function') && promise.then($6281dd6c370e2cd1$var$empty) instanceof FakePromise && $6281dd6c370e2cd1$var$v8.indexOf('6.6') !== 0 && $8JzcF.indexOf('Chrome/66') === -1;
        } catch (e) {}
    }();
    var $6281dd6c370e2cd1$var$isThenable = function(it) {
        var then;
        return $6VwBm(it) && typeof (then = it.then) == 'function' ? then : false;
    };
    var $6281dd6c370e2cd1$var$notify = function(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        $6281dd6c370e2cd1$var$microtask(function() {
            var value = promise._v;
            var ok = promise._s == 1;
            var i = 0;
            var run = function(reaction) {
                var handler = ok ? reaction.ok : reaction.fail;
                var resolve = reaction.resolve;
                var reject = reaction.reject;
                var domain = reaction.domain;
                var result, then, exited;
                try {
                    if (handler) {
                        if (!ok) {
                            if (promise._h == 2) $6281dd6c370e2cd1$var$onHandleUnhandled(promise);
                            promise._h = 1;
                        }
                        if (handler === true) result = value;
                        else {
                            if (domain) domain.enter();
                            result = handler(value);
                            if (domain) {
                                domain.exit();
                                exited = true;
                            }
                        }
                        if (result === reaction.promise) reject($6281dd6c370e2cd1$var$TypeError('Promise-chain cycle'));
                        else if (then = $6281dd6c370e2cd1$var$isThenable(result)) then.call(result, resolve, reject);
                        else resolve(result);
                    } else reject(value);
                } catch (e) {
                    if (domain && !exited) domain.exit();
                    reject(e);
                }
            };
            while(chain.length > i)run(chain[i++]);
            promise._c = [];
            promise._n = false;
            if (isReject && !promise._h) $6281dd6c370e2cd1$var$onUnhandled(promise);
        });
    };
    var $6281dd6c370e2cd1$var$onUnhandled = function(promise) {
        $6281dd6c370e2cd1$require$task.call($pe18r, function() {
            var value = promise._v;
            var unhandled = $6281dd6c370e2cd1$var$isUnhandled(promise);
            var result, handler, console;
            if (unhandled) {
                result = $5kpnZ(function() {
                    if ($6281dd6c370e2cd1$var$isNode) $6281dd6c370e2cd1$var$process.emit('unhandledRejection', value, promise);
                    else if (handler = $pe18r.onunhandledrejection) handler({
                        promise: promise,
                        reason: value
                    });
                    else if ((console = $pe18r.console) && console.error) console.error('Unhandled promise rejection', value);
                });
                promise._h = $6281dd6c370e2cd1$var$isNode || $6281dd6c370e2cd1$var$isUnhandled(promise) ? 2 : 1;
            }
            promise._a = undefined;
            if (unhandled && result.e) throw result.v;
        });
    };
    var $6281dd6c370e2cd1$var$isUnhandled = function(promise) {
        return promise._h !== 1 && (promise._a || promise._c).length === 0;
    };
    var $6281dd6c370e2cd1$var$onHandleUnhandled = function(promise) {
        $6281dd6c370e2cd1$require$task.call($pe18r, function() {
            var handler;
            if ($6281dd6c370e2cd1$var$isNode) $6281dd6c370e2cd1$var$process.emit('rejectionHandled', promise);
            else if (handler = $pe18r.onrejectionhandled) handler({
                promise: promise,
                reason: promise._v
            });
        });
    };
    var $6281dd6c370e2cd1$var$$reject = function(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        $6281dd6c370e2cd1$var$notify(promise, true);
    };
    var $6281dd6c370e2cd1$var$$resolve = function(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise;
        try {
            if (promise === value) throw $6281dd6c370e2cd1$var$TypeError("Promise can't be resolved itself");
            if (then = $6281dd6c370e2cd1$var$isThenable(value)) $6281dd6c370e2cd1$var$microtask(function() {
                var wrapper = {
                    _w: promise,
                    _d: false
                };
                try {
                    then.call(value, $gnejD($6281dd6c370e2cd1$var$$resolve, wrapper, 1), $gnejD($6281dd6c370e2cd1$var$$reject, wrapper, 1));
                } catch (e) {
                    $6281dd6c370e2cd1$var$$reject.call(wrapper, e);
                }
            });
            else {
                promise._v = value;
                promise._s = 1;
                $6281dd6c370e2cd1$var$notify(promise, false);
            }
        } catch (e) {
            $6281dd6c370e2cd1$var$$reject.call({
                _w: promise,
                _d: false
            }, e);
        }
    };
    if (!$6281dd6c370e2cd1$var$USE_NATIVE) {
        $6281dd6c370e2cd1$var$$Promise = function Promise(executor) {
            $igM2P(this, $6281dd6c370e2cd1$var$$Promise, $6281dd6c370e2cd1$var$PROMISE, '_h');
            $jd5tk(executor);
            $6281dd6c370e2cd1$var$Internal.call(this);
            try {
                executor($gnejD($6281dd6c370e2cd1$var$$resolve, this, 1), $gnejD($6281dd6c370e2cd1$var$$reject, this, 1));
            } catch (err) {
                $6281dd6c370e2cd1$var$$reject.call(this, err);
            }
        };
        $6281dd6c370e2cd1$var$Internal = function Promise(executor) {
            this._c = [];
            this._a = undefined;
            this._s = 0;
            this._d = false;
            this._v = undefined;
            this._h = 0;
            this._n = false;
        };
        $6281dd6c370e2cd1$var$Internal.prototype = (parcelRequire("5zUXP"))($6281dd6c370e2cd1$var$$Promise.prototype, {
            then: function then(onFulfilled, onRejected) {
                var reaction = $6281dd6c370e2cd1$var$newPromiseCapability($PVFqE(this, $6281dd6c370e2cd1$var$$Promise));
                reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
                reaction.fail = typeof onRejected == 'function' && onRejected;
                reaction.domain = $6281dd6c370e2cd1$var$isNode ? $6281dd6c370e2cd1$var$process.domain : undefined;
                this._c.push(reaction);
                if (this._a) this._a.push(reaction);
                if (this._s) $6281dd6c370e2cd1$var$notify(this, false);
                return reaction.promise;
            },
            'catch': function(onRejected) {
                return this.then(undefined, onRejected);
            }
        });
        $6281dd6c370e2cd1$var$OwnPromiseCapability = function() {
            var promise = new $6281dd6c370e2cd1$var$Internal();
            this.promise = promise;
            this.resolve = $gnejD($6281dd6c370e2cd1$var$$resolve, promise, 1);
            this.reject = $gnejD($6281dd6c370e2cd1$var$$reject, promise, 1);
        };
        $jtCbh.f = $6281dd6c370e2cd1$var$newPromiseCapability = function(C) {
            return C === $6281dd6c370e2cd1$var$$Promise || C === $6281dd6c370e2cd1$var$Wrapper ? new $6281dd6c370e2cd1$var$OwnPromiseCapability(C) : $6281dd6c370e2cd1$var$newGenericPromiseCapability(C);
        };
    }
    $8EFNH($8EFNH.G + $8EFNH.W + $8EFNH.F * !$6281dd6c370e2cd1$var$USE_NATIVE, {
        Promise: $6281dd6c370e2cd1$var$$Promise
    });
    (parcelRequire("8nOHH"))($6281dd6c370e2cd1$var$$Promise, $6281dd6c370e2cd1$var$PROMISE);
    (parcelRequire("jamSJ"))($6281dd6c370e2cd1$var$PROMISE);
    $6281dd6c370e2cd1$var$Wrapper = (parcelRequire("dv4GG"))[$6281dd6c370e2cd1$var$PROMISE];
    $8EFNH($8EFNH.S + $8EFNH.F * !$6281dd6c370e2cd1$var$USE_NATIVE, $6281dd6c370e2cd1$var$PROMISE, {
        reject: function reject(r) {
            var capability = $6281dd6c370e2cd1$var$newPromiseCapability(this);
            var $$reject = capability.reject;
            $$reject(r);
            return capability.promise;
        }
    });
    $8EFNH($8EFNH.S + $8EFNH.F * ($6uq1C || !$6281dd6c370e2cd1$var$USE_NATIVE), $6281dd6c370e2cd1$var$PROMISE, {
        resolve: function resolve(x) {
            return $7MV4M($6uq1C && this === $6281dd6c370e2cd1$var$Wrapper ? $6281dd6c370e2cd1$var$$Promise : this, x);
        }
    });
    $8EFNH($8EFNH.S + $8EFNH.F * !($6281dd6c370e2cd1$var$USE_NATIVE && (parcelRequire("elGHS"))(function(iter) {
        $6281dd6c370e2cd1$var$$Promise.all(iter)['catch']($6281dd6c370e2cd1$var$empty);
    })), $6281dd6c370e2cd1$var$PROMISE, {
        all: function all(iterable) {
            var C = this;
            var capability = $6281dd6c370e2cd1$var$newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = $5kpnZ(function() {
                var values = [];
                var index = 0;
                var remaining = 1;
                $2TQW8(iterable, false, function(promise) {
                    var $index = index++;
                    var alreadyCalled = false;
                    values.push(undefined);
                    remaining++;
                    C.resolve(promise).then(function(value) {
                        if (alreadyCalled) return;
                        alreadyCalled = true;
                        values[$index] = value;
                        --remaining || resolve(values);
                    }, reject);
                });
                --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
        },
        race: function race(iterable) {
            var C = this;
            var capability = $6281dd6c370e2cd1$var$newPromiseCapability(C);
            var reject = capability.reject;
            var result = $5kpnZ(function() {
                $2TQW8(iterable, false, function(promise) {
                    C.resolve(promise).then(capability.resolve, reject);
                });
            });
            if (result.e) reject(result.v);
            return capability.promise;
        }
    });
});
parcelRegister("fdKPE", function(module, exports) {
    var $eYYzh = parcelRequire("eYYzh");
    var $b14c65c3bdb05e47$var$TAG = (parcelRequire("cNfss"))('toStringTag');
    var $b14c65c3bdb05e47$var$ARG = $eYYzh(function() {
        return arguments;
    }()) == 'Arguments';
    var $b14c65c3bdb05e47$var$tryGet = function(it, key) {
        try {
            return it[key];
        } catch (e) {}
    };
    module.exports = function(it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (T = $b14c65c3bdb05e47$var$tryGet(O = Object(it), $b14c65c3bdb05e47$var$TAG)) == 'string' ? T : $b14c65c3bdb05e47$var$ARG ? $eYYzh(O) : (B = $eYYzh(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };
});
parcelRegister("igM2P", function(module, exports) {
    module.exports = function(it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ': incorrect invocation!');
        return it;
    };
});
parcelRegister("2TQW8", function(module, exports) {
    var $gnejD = parcelRequire("gnejD");
    var $37EOk = parcelRequire("37EOk");
    var $k9WWH = parcelRequire("k9WWH");
    var $6rs9h = parcelRequire("6rs9h");
    var $lpAeO = parcelRequire("lpAeO");
    var $d2ywt = parcelRequire("d2ywt");
    var $21c9c7ef76660cf1$var$BREAK = {};
    var $21c9c7ef76660cf1$var$RETURN = {};
    var $21c9c7ef76660cf1$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function() {
            return iterable;
        } : $d2ywt(iterable);
        var f = $gnejD(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
        if ($k9WWH(iterFn)) for(length = $lpAeO(iterable.length); length > index; index++){
            result = entries ? f($6rs9h(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === $21c9c7ef76660cf1$var$BREAK || result === $21c9c7ef76660cf1$var$RETURN) return result;
        }
        else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
            result = $37EOk(iterator, f, step.value, entries);
            if (result === $21c9c7ef76660cf1$var$BREAK || result === $21c9c7ef76660cf1$var$RETURN) return result;
        }
    };
    $21c9c7ef76660cf1$var$exports.BREAK = $21c9c7ef76660cf1$var$BREAK;
    $21c9c7ef76660cf1$var$exports.RETURN = $21c9c7ef76660cf1$var$RETURN;
});
parcelRegister("37EOk", function(module, exports) {
    var $6rs9h = parcelRequire("6rs9h");
    module.exports = function(iterator, fn, value, entries) {
        try {
            return entries ? fn($6rs9h(value)[0], value[1]) : fn(value);
        } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) $6rs9h(ret.call(iterator));
            throw e;
        }
    };
});
parcelRegister("k9WWH", function(module, exports) {
    var $eu895 = parcelRequire("eu895");
    var $ead25f519c61448a$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
    var $ead25f519c61448a$var$ArrayProto = Array.prototype;
    module.exports = function(it) {
        return it !== undefined && ($eu895.Array === it || $ead25f519c61448a$var$ArrayProto[$ead25f519c61448a$var$ITERATOR] === it);
    };
});
parcelRegister("d2ywt", function(module, exports) {
    var $fdKPE = parcelRequire("fdKPE");
    var $97e63dbe95e0d522$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
    var $eu895 = parcelRequire("eu895");
    module.exports = (parcelRequire("dv4GG")).getIteratorMethod = function(it) {
        if (it != undefined) return it[$97e63dbe95e0d522$var$ITERATOR] || it['@@iterator'] || $eu895[$fdKPE(it)];
    };
});
parcelRegister("PVFqE", function(module, exports) {
    var $6rs9h = parcelRequire("6rs9h");
    var $jd5tk = parcelRequire("jd5tk");
    var $09c17f0a7250e5e6$var$SPECIES = (parcelRequire("cNfss"))('species');
    module.exports = function(O, D) {
        var C = $6rs9h(O).constructor;
        var S;
        return C === undefined || (S = $6rs9h(C)[$09c17f0a7250e5e6$var$SPECIES]) == undefined ? D : $jd5tk(S);
    };
});
parcelRegister("kA9gG", function(module, exports) {
    var $gnejD = parcelRequire("gnejD");
    var $e1fBW = parcelRequire("e1fBW");
    var $fW23X = parcelRequire("fW23X");
    var $iSIdA = parcelRequire("iSIdA");
    var $pe18r = parcelRequire("pe18r");
    var $efbe5bdf019a1027$var$process = $pe18r.process;
    var $efbe5bdf019a1027$var$setTask = $pe18r.setImmediate;
    var $efbe5bdf019a1027$var$clearTask = $pe18r.clearImmediate;
    var $efbe5bdf019a1027$var$MessageChannel = $pe18r.MessageChannel;
    var $efbe5bdf019a1027$var$Dispatch = $pe18r.Dispatch;
    var $efbe5bdf019a1027$var$counter = 0;
    var $efbe5bdf019a1027$var$queue = {};
    var $efbe5bdf019a1027$var$ONREADYSTATECHANGE = 'onreadystatechange';
    var $efbe5bdf019a1027$var$defer, $efbe5bdf019a1027$var$channel, $efbe5bdf019a1027$var$port;
    var $efbe5bdf019a1027$var$run = function() {
        var id = +this;
        if ($efbe5bdf019a1027$var$queue.hasOwnProperty(id)) {
            var fn = $efbe5bdf019a1027$var$queue[id];
            delete $efbe5bdf019a1027$var$queue[id];
            fn();
        }
    };
    var $efbe5bdf019a1027$var$listener = function(event) {
        $efbe5bdf019a1027$var$run.call(event.data);
    };
    if (!$efbe5bdf019a1027$var$setTask || !$efbe5bdf019a1027$var$clearTask) {
        $efbe5bdf019a1027$var$setTask = function setImmediate(fn) {
            var args = [];
            var i = 1;
            while(arguments.length > i)args.push(arguments[i++]);
            $efbe5bdf019a1027$var$queue[++$efbe5bdf019a1027$var$counter] = function() {
                $e1fBW(typeof fn == 'function' ? fn : Function(fn), args);
            };
            $efbe5bdf019a1027$var$defer($efbe5bdf019a1027$var$counter);
            return $efbe5bdf019a1027$var$counter;
        };
        $efbe5bdf019a1027$var$clearTask = function clearImmediate(id) {
            delete $efbe5bdf019a1027$var$queue[id];
        };
        if ((parcelRequire("eYYzh"))($efbe5bdf019a1027$var$process) == 'process') $efbe5bdf019a1027$var$defer = function(id) {
            $efbe5bdf019a1027$var$process.nextTick($gnejD($efbe5bdf019a1027$var$run, id, 1));
        };
        else if ($efbe5bdf019a1027$var$Dispatch && $efbe5bdf019a1027$var$Dispatch.now) $efbe5bdf019a1027$var$defer = function(id) {
            $efbe5bdf019a1027$var$Dispatch.now($gnejD($efbe5bdf019a1027$var$run, id, 1));
        };
        else if ($efbe5bdf019a1027$var$MessageChannel) {
            $efbe5bdf019a1027$var$channel = new $efbe5bdf019a1027$var$MessageChannel();
            $efbe5bdf019a1027$var$port = $efbe5bdf019a1027$var$channel.port2;
            $efbe5bdf019a1027$var$channel.port1.onmessage = $efbe5bdf019a1027$var$listener;
            $efbe5bdf019a1027$var$defer = $gnejD($efbe5bdf019a1027$var$port.postMessage, $efbe5bdf019a1027$var$port, 1);
        } else if ($pe18r.addEventListener && typeof postMessage == 'function' && !$pe18r.importScripts) {
            $efbe5bdf019a1027$var$defer = function(id) {
                $pe18r.postMessage(id + '', '*');
            };
            $pe18r.addEventListener('message', $efbe5bdf019a1027$var$listener, false);
        } else if ($efbe5bdf019a1027$var$ONREADYSTATECHANGE in $iSIdA('script')) $efbe5bdf019a1027$var$defer = function(id) {
            $fW23X.appendChild($iSIdA('script'))[$efbe5bdf019a1027$var$ONREADYSTATECHANGE] = function() {
                $fW23X.removeChild(this);
                $efbe5bdf019a1027$var$run.call(id);
            };
        };
        else $efbe5bdf019a1027$var$defer = function(id) {
            setTimeout($gnejD($efbe5bdf019a1027$var$run, id, 1), 0);
        };
    }
    module.exports = {
        set: $efbe5bdf019a1027$var$setTask,
        clear: $efbe5bdf019a1027$var$clearTask
    };
});
parcelRegister("e1fBW", function(module, exports) {
    module.exports = function(fn, args, that) {
        var un = that === undefined;
        switch(args.length){
            case 0:
                return un ? fn() : fn.call(that);
            case 1:
                return un ? fn(args[0]) : fn.call(that, args[0]);
            case 2:
                return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
            case 3:
                return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
            case 4:
                return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }
        return fn.apply(that, args);
    };
});
parcelRegister("cKTs5", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $kA9gG = parcelRequire("kA9gG");
    var $9494cb828a53d78d$require$macrotask = $kA9gG.set;
    var $9494cb828a53d78d$var$Observer = $pe18r.MutationObserver || $pe18r.WebKitMutationObserver;
    var $9494cb828a53d78d$var$process = $pe18r.process;
    var $9494cb828a53d78d$var$Promise = $pe18r.Promise;
    var $9494cb828a53d78d$var$isNode = (parcelRequire("eYYzh"))($9494cb828a53d78d$var$process) == 'process';
    module.exports = function() {
        var head, last, notify;
        var flush = function() {
            var parent, fn;
            if ($9494cb828a53d78d$var$isNode && (parent = $9494cb828a53d78d$var$process.domain)) parent.exit();
            while(head){
                fn = head.fn;
                head = head.next;
                try {
                    fn();
                } catch (e) {
                    if (head) notify();
                    else last = undefined;
                    throw e;
                }
            }
            last = undefined;
            if (parent) parent.enter();
        };
        if ($9494cb828a53d78d$var$isNode) notify = function() {
            $9494cb828a53d78d$var$process.nextTick(flush);
        };
        else if ($9494cb828a53d78d$var$Observer && !($pe18r.navigator && $pe18r.navigator.standalone)) {
            var toggle = true;
            var node = document.createTextNode('');
            new $9494cb828a53d78d$var$Observer(flush).observe(node, {
                characterData: true
            });
            notify = function() {
                node.data = toggle = !toggle;
            };
        } else if ($9494cb828a53d78d$var$Promise && $9494cb828a53d78d$var$Promise.resolve) {
            var promise = $9494cb828a53d78d$var$Promise.resolve(undefined);
            notify = function() {
                promise.then(flush);
            };
        } else notify = function() {
            $9494cb828a53d78d$require$macrotask.call($pe18r, flush);
        };
        return function(fn) {
            var task = {
                fn: fn,
                next: undefined
            };
            if (last) last.next = task;
            if (!head) {
                head = task;
                notify();
            }
            last = task;
        };
    };
});
parcelRegister("jtCbh", function(module, exports) {
    $parcel$export(module.exports, "f", ()=>$e2de57b30462e7a3$export$2d1720544b23b823, (v)=>$e2de57b30462e7a3$export$2d1720544b23b823 = v);
    var $e2de57b30462e7a3$export$2d1720544b23b823;
    'use strict';
    var $jd5tk = parcelRequire("jd5tk");
    function $e2de57b30462e7a3$var$PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
        });
        this.resolve = $jd5tk(resolve);
        this.reject = $jd5tk(reject);
    }
    $e2de57b30462e7a3$export$2d1720544b23b823 = function(C) {
        return new $e2de57b30462e7a3$var$PromiseCapability(C);
    };
});
parcelRegister("5kpnZ", function(module, exports) {
    module.exports = function(exec) {
        try {
            return {
                e: false,
                v: exec()
            };
        } catch (e) {
            return {
                e: true,
                v: e
            };
        }
    };
});
parcelRegister("8JzcF", function(module, exports) {
    var $pe18r = parcelRequire("pe18r");
    var $65bdd555fa77483e$var$navigator = $pe18r.navigator;
    module.exports = $65bdd555fa77483e$var$navigator && $65bdd555fa77483e$var$navigator.userAgent || '';
});
parcelRegister("7MV4M", function(module, exports) {
    var $6rs9h = parcelRequire("6rs9h");
    var $6VwBm = parcelRequire("6VwBm");
    var $jtCbh = parcelRequire("jtCbh");
    module.exports = function(C, x) {
        $6rs9h(C);
        if ($6VwBm(x) && x.constructor === C) return x;
        var promiseCapability = $jtCbh.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
    };
});
parcelRegister("5zUXP", function(module, exports) {
    var $kM6mh = parcelRequire("kM6mh");
    module.exports = function(target, src, safe) {
        for(var key in src)if (safe && target[key]) target[key] = src[key];
        else $kM6mh(target, key, src[key]);
        return target;
    };
});
parcelRegister("jamSJ", function(module, exports) {
    'use strict';
    var $pe18r = parcelRequire("pe18r");
    var $dv4GG = parcelRequire("dv4GG");
    var $30LaA = parcelRequire("30LaA");
    var $hn2oF = parcelRequire("hn2oF");
    var $df40b35a3c8f3122$var$SPECIES = (parcelRequire("cNfss"))('species');
    module.exports = function(KEY) {
        var C = typeof $dv4GG[KEY] == 'function' ? $dv4GG[KEY] : $pe18r[KEY];
        if ($hn2oF && C && !C[$df40b35a3c8f3122$var$SPECIES]) $30LaA.f(C, $df40b35a3c8f3122$var$SPECIES, {
            configurable: true,
            get: function() {
                return this;
            }
        });
    };
});
parcelRegister("elGHS", function(module, exports) {
    var $a724277d1d92a3aa$var$ITERATOR = (parcelRequire("cNfss"))('iterator');
    var $a724277d1d92a3aa$var$SAFE_CLOSING = false;
    try {
        var $a724277d1d92a3aa$var$riter = [
            7
        ][$a724277d1d92a3aa$var$ITERATOR]();
        $a724277d1d92a3aa$var$riter['return'] = function() {
            $a724277d1d92a3aa$var$SAFE_CLOSING = true;
        };
        Array.from($a724277d1d92a3aa$var$riter, function() {
            throw 2;
        });
    } catch (e) {}
    module.exports = function(exec, skipClosing) {
        if (!skipClosing && !$a724277d1d92a3aa$var$SAFE_CLOSING) return false;
        var safe = false;
        try {
            var arr = [
                7
            ];
            var iter = arr[$a724277d1d92a3aa$var$ITERATOR]();
            iter.next = function() {
                return {
                    done: safe = true
                };
            };
            arr[$a724277d1d92a3aa$var$ITERATOR] = function() {
                return iter;
            };
            exec(arr);
        } catch (e) {}
        return safe;
    };
});
parcelRegister("hsmRz", function(module, exports) {
    'use strict';
    var $8EFNH = parcelRequire("8EFNH");
    var $dv4GG = parcelRequire("dv4GG");
    var $pe18r = parcelRequire("pe18r");
    var $PVFqE = parcelRequire("PVFqE");
    var $7MV4M = parcelRequire("7MV4M");
    $8EFNH($8EFNH.P + $8EFNH.R, 'Promise', {
        'finally': function(onFinally) {
            var C = $PVFqE(this, $dv4GG.Promise || $pe18r.Promise);
            var isFunction = typeof onFinally == 'function';
            return this.then(isFunction ? function(x) {
                return $7MV4M(C, onFinally()).then(function() {
                    return x;
                });
            } : onFinally, isFunction ? function(e) {
                return $7MV4M(C, onFinally()).then(function() {
                    throw e;
                });
            } : onFinally);
        }
    });
});
parcelRegister("6B7zO", function(module, exports) {
    'use strict';
    var $8EFNH = parcelRequire("8EFNH");
    var $jtCbh = parcelRequire("jtCbh");
    var $5kpnZ = parcelRequire("5kpnZ");
    $8EFNH($8EFNH.S, 'Promise', {
        'try': function(callbackfn) {
            var promiseCapability = $jtCbh.f(this);
            var result = $5kpnZ(callbackfn);
            (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
            return promiseCapability.promise;
        }
    });
});
parcelRegister("b81LX", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $81a1d1111f5cbdf9$var$win = void 0;
    if (typeof window !== 'undefined') $81a1d1111f5cbdf9$var$win = window;
    else if (typeof self !== 'undefined') $81a1d1111f5cbdf9$var$win = self;
    else $81a1d1111f5cbdf9$var$win = {};
    var $81a1d1111f5cbdf9$var$request = $81a1d1111f5cbdf9$var$win.requestAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.mozRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.oRequestAnimationFrame || $81a1d1111f5cbdf9$var$win.msRequestAnimationFrame || function(callback) {
        return $81a1d1111f5cbdf9$var$win.setTimeout(callback, 1000 / 60);
    };
    var $81a1d1111f5cbdf9$var$cancel = $81a1d1111f5cbdf9$var$win.cancelAnimationFrame || $81a1d1111f5cbdf9$var$win.webkitCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.mozCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.oCancelAnimationFrame || $81a1d1111f5cbdf9$var$win.msCancelAnimationFrame || function(id) {
        $81a1d1111f5cbdf9$var$win.clearTimeout(id);
    };
    var $81a1d1111f5cbdf9$var$raf = module.exports.raf = $81a1d1111f5cbdf9$var$request;
    var $81a1d1111f5cbdf9$var$caf = module.exports.caf = $81a1d1111f5cbdf9$var$cancel;
});
parcelRegister("eAUMQ", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = undefined;
    module.exports.default = $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter;
    parcelRequire("7G6q0");
    var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
    var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
    var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
    var $aa007a26dd1d5a11$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
    function $aa007a26dd1d5a11$var$defaultOverscanIndicesGetter(_ref) {
        var cellCount = _ref.cellCount, overscanCellsCount = _ref.overscanCellsCount, scrollDirection = _ref.scrollDirection, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
        overscanCellsCount = Math.max(1, overscanCellsCount);
        if (scrollDirection === $aa007a26dd1d5a11$var$SCROLL_DIRECTION_FORWARD) return {
            overscanStartIndex: Math.max(0, startIndex - 1),
            overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
        };
        else return {
            overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
            overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
        };
    }
});
parcelRegister("2AKv3", function(module, exports) {
    'use strict';
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.bpfrpt_proptype_Scroll = module.exports.bpfrpt_proptype_RenderedRows = module.exports.bpfrpt_proptype_RowRenderer = module.exports.bpfrpt_proptype_RowRendererParams = undefined;
    var $5uXOq = parcelRequire("5uXOq");
    var $1e3303757d69af0d$var$React = $1e3303757d69af0d$var$_interopRequireWildcard($5uXOq);
    var $8rCP3;
    var $1e3303757d69af0d$var$_propTypes2 = $1e3303757d69af0d$var$_interopRequireDefault((0, parcelRequire("8rCP3")));
    function $1e3303757d69af0d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1e3303757d69af0d$var$_interopRequireWildcard(obj) {
        if (obj && obj.__esModule) return obj;
        else {
            var newObj = {};
            if (obj != null) {
                for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
            }
            newObj.default = obj;
            return newObj;
        }
    }
    var $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams = null;
    var $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer = null;
    var $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows = null;
    var $1e3303757d69af0d$var$bpfrpt_proptype_Scroll = null;
    module.exports.bpfrpt_proptype_RowRendererParams = $1e3303757d69af0d$var$bpfrpt_proptype_RowRendererParams;
    module.exports.bpfrpt_proptype_RowRenderer = $1e3303757d69af0d$var$bpfrpt_proptype_RowRenderer;
    module.exports.bpfrpt_proptype_RenderedRows = $1e3303757d69af0d$var$bpfrpt_proptype_RenderedRows;
    module.exports.bpfrpt_proptype_Scroll = $1e3303757d69af0d$var$bpfrpt_proptype_Scroll;
});
parcelRegister("gIpUw", function(module, exports) {
    $parcel$export(module.exports, "TypeAheadListItem", ()=>$2ed08364f40e4ff0$export$913373331e95c13e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $5tY4R;
    var $3UtTx;
    var $8ptyJ;
    var $iHYdz;
    var $24JcV;
    var $kJpBP;
    function $2ed08364f40e4ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2ed08364f40e4ff0$export$cfa784b45fc7b21d = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)",
        overflow: 'hidden',
        border: `1px solid ${"var(--ds-border, rgba(223, 225, 229, 0.5))"}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        div: {
            width: "var(--ds-space-500, 40px)",
            height: "var(--ds-space-500, 40px)"
        }
    });
    const $2ed08364f40e4ff0$var$itemIconSize = {
        name: "4y81cs",
        styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);svg:first-of-type{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
    };
    const $2ed08364f40e4ff0$var$itemBody = {
        name: "dblrt7",
        styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
    };
    const $2ed08364f40e4ff0$var$itemText = (0, (0, parcelRequire("f8Sb3")).css)({
        whiteSpace: 'initial',
        color: `${`var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`}`
    });
    const $2ed08364f40e4ff0$var$itemTitle = {
        name: "1v4psb4",
        styles: "line-height:1.4"
    };
    const $2ed08364f40e4ff0$var$itemTitleOverride = {
        name: "183yev2",
        styles: "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    };
    const $2ed08364f40e4ff0$var$itemDescription = (0, (0, parcelRequire("f8Sb3")).css)({
        fontSize: `${(0, (0, parcelRequire("iHYdz")).relativeFontSizeToBase16)(12)};`,
        color: `${`var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`};`,
        marginTop: `${"var(--ds-space-050, 4px)"};`
    });
    const $2ed08364f40e4ff0$var$itemDescriptionOverride = {
        name: "1n727cn",
        styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-top:0"
    };
    const $2ed08364f40e4ff0$var$itemAfter = {
        name: "ou8xsw",
        styles: "flex:0 0 auto"
    };
    const $2ed08364f40e4ff0$var$customRenderItemDivStyle = (0, (0, parcelRequire("f8Sb3")).css)("overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";outline:none;}");
    const $2ed08364f40e4ff0$var$selectionFrame = {
        '& > button:focus': {
            boxShadow: `inset 2px 0px 0px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`};`,
            backgroundColor: `${`var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`}`,
            outline: 'none',
            '&:active': {
                boxShadow: 'none'
            }
        },
        '& > button:hover': {
            backgroundColor: 'inherit',
            outline: 'none'
        }
    };
    const $2ed08364f40e4ff0$var$selectedStyle = (0, (0, parcelRequire("f8Sb3")).css)("background-color:", `var(--ds-background-neutral-subtle-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`, ";box-shadow:inset 2px 0px 0px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`, ";");
    const $2ed08364f40e4ff0$var$FallbackIcon = (0, ($parcel$interopDefault($5uXOq))).memo(({ label: label })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5tY4R")).default), null);
    });
    const $2ed08364f40e4ff0$var$noop = ()=>{};
    const $2ed08364f40e4ff0$var$CustomItemComponentWrapper = (0, ($parcel$interopDefault($5uXOq))).memo((props)=>{
        const { customRenderItem: customRenderItem, isSelected: isSelected, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
        const Comp = customRenderItem;
        const listItemClasses = (0, $5uXOq.useMemo)(()=>{
            return [
                $2ed08364f40e4ff0$var$customRenderItemDivStyle,
                isSelected && $2ed08364f40e4ff0$var$selectedStyle
            ];
        }, [
            isSelected
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-selected": isSelected,
            role: "option",
            "aria-label": ariaLabel,
            "aria-setsize": itemsLength,
            "aria-posinset": itemIndex,
            tabIndex: 0,
            css: listItemClasses,
            className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
            ref: customItemRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Comp, {
            onClick: insertSelectedItem,
            isSelected: false,
            onHover: $2ed08364f40e4ff0$var$noop
        })));
    });
    const $2ed08364f40e4ff0$export$913373331e95c13e = (0, ($parcel$interopDefault($5uXOq))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled })=>{
        const isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const descriptionText = item.description ? `${item.description}.` : '';
        const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, (0, parcelRequire("8ptyJ")).typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
        const { icon: icon, title: title, render: customRenderItem } = item;
        const elementIcon = (0, $5uXOq.useMemo)(()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $2ed08364f40e4ff0$export$cfa784b45fc7b21d,
                    moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemIconSize
                ]
            }, icon ? icon() : (0, (0, parcelRequire("f8Sb3")).jsx)($2ed08364f40e4ff0$var$FallbackIcon, {
                label: title
            }));
        }, [
            icon,
            title,
            moreElementsInQuickInsertViewEnabled
        ]);
        const insertSelectedItem = (0, $5uXOq.useCallback)(()=>{
            onItemClick((0, (0, parcelRequire("3UtTx")).SelectItemMode).SELECTED, itemIndex);
        }, [
            onItemClick,
            itemIndex
        ]);
        const customItemRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const buttonItemRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const shouldUpdateFocus = selectedIndex === itemIndex;
        const listItemClasses = (0, $5uXOq.useMemo)(()=>{
            return [
                $2ed08364f40e4ff0$var$selectionFrame,
                isSelected && $2ed08364f40e4ff0$var$selectedStyle
            ];
        }, [
            isSelected
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (shouldUpdateFocus) customItemRef?.current?.focus();
        }, [
            customItemRef,
            shouldUpdateFocus
        ]);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (shouldUpdateFocus) buttonItemRef?.current?.focus();
        }, [
            buttonItemRef,
            shouldUpdateFocus
        ]);
        if (customRenderItem) return (0, (0, parcelRequire("f8Sb3")).jsx)($2ed08364f40e4ff0$var$CustomItemComponentWrapper, {
            customRenderItem: customRenderItem,
            isSelected: isSelected,
            ariaLabel: ariaLabel,
            itemsLength: itemsLength,
            customItemRef: customItemRef,
            insertSelectedItem: insertSelectedItem,
            itemIndex: itemIndex
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: listItemClasses
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kJpBP")).default), {
            onClick: insertSelectedItem,
            iconBefore: elementIcon,
            isSelected: isSelected,
            "aria-selected": isSelected,
            "aria-label": title,
            "aria-description": `${descriptionText} ${shortcutText}`,
            "aria-setsize": itemsLength,
            "aria-posinset": itemIndex,
            role: "option",
            ref: buttonItemRef,
            css: listItemClasses
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "aria-hidden": true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $2ed08364f40e4ff0$var$itemText
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2ed08364f40e4ff0$var$itemBody
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $2ed08364f40e4ff0$var$itemTitle,
                moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemTitleOverride
            ]
        }, item.title), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $2ed08364f40e4ff0$var$itemAfter
        }, item.keyshortcut && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("24JcV")).shortcutStyle)
        }, item.keyshortcut))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $2ed08364f40e4ff0$var$itemDescription,
                moreElementsInQuickInsertViewEnabled && $2ed08364f40e4ff0$var$itemDescriptionOverride
            ]
        }, item.description))))));
    });
});
parcelRegister("5tY4R", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c3a69629e592a00$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6v7Sc;
    function $8c3a69629e592a00$export$2e2bcd8739ae039() {
        const { iconThemed: iconThemed } = (0, (0, parcelRequire("6v7Sc")).useIconThemed)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            focusable: "false",
            "aria-hidden": true,
            width: 40,
            height: 40,
            viewBox: "0 0 40 40"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            x1: "-26.046%",
            y1: "100%",
            x2: "62.626%",
            y2: "0%",
            id: "fallback-a"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#B3BAC5",
            offset: "0%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#A5ADBA",
            offset: "100%"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            x1: "-12.24%",
            y1: "100%",
            x2: "82.44%",
            y2: "0%",
            id: "fallback-b"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#5A6977",
            offset: "0%"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#454F59",
            offset: "100%"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            fill: "none",
            fillRule: "evenodd"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: '#FFF',
                dark: '#161A1D'
            }),
            d: "M0 0h40v40H0z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: '#DFE1E6',
                dark: '#738496'
            }),
            d: "M20 16h12v12H20z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: 'url(#fallback-a)',
                dark: 'url(#fallback-b)'
            }),
            d: "M8 16h12v12H8z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
            fill: iconThemed({
                light: '#A5ADBA',
                dark: '#454F59'
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: '#B3BAC5',
                dark: '#454F59'
            }),
            d: "M17.5 13h5v3h-5z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: '#A5ADBA',
                dark: '#454F59'
            }),
            d: "M10 13h5v3h-5z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: iconThemed({
                light: '#DFE1E6',
                dark: '#738496'
            }),
            d: "M25 13h5v3h-5z"
        })));
    }
});
parcelRegister("6v7Sc", function(module, exports) {
    $parcel$export(module.exports, "useIconThemed", ()=>$9722d0b207f9c9df$export$a38bb9a8c9e5bc30);
    var $hxoiH;
    const $9722d0b207f9c9df$export$a38bb9a8c9e5bc30 = ()=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return {
            iconThemed: (colors)=>{
                return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
            }
        };
    };
});
parcelRegister("gYYLA", function(module, exports) {
    $parcel$export(module.exports, "undoRedoPlugin", ()=>(parcelRequire("7ednl")).undoRedoPlugin);
    var $7ednl;
});
parcelRegister("7ednl", function(module, exports) {
    $parcel$export(module.exports, "undoRedoPlugin", ()=>$db0e6b842e8e4f98$export$dcdc7fc7ecd3098);
    var $5uXOq = parcelRequire("5uXOq");
    var $30ytK;
    var $kVmKj;
    var $cBhLR;
    const $db0e6b842e8e4f98$export$dcdc7fc7ecd3098 = ({ api: api })=>{
        const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cBhLR")).default), {
                isReducedSpacing: isToolbarReducedSpacing,
                disabled: disabled,
                editorView: editorView,
                api: api
            });
        };
        api?.primaryToolbar?.actions.registerComponent({
            name: 'undoRedoPlugin',
            component: primaryToolbarComponent
        });
        return {
            name: 'undoRedoPlugin',
            pmPlugins () {
                return [
                    {
                        name: 'undoRedoKeyMap',
                        plugin: ()=>(0, (0, parcelRequire("30ytK")).keymapPlugin)()
                    },
                    {
                        name: 'undoRedoPlugin',
                        plugin: (options)=>(0, (0, parcelRequire("kVmKj")).createPlugin)(options)
                    }
                ];
            },
            primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
        };
    };
});
parcelRegister("30ytK", function(module, exports) {
    $parcel$export(module.exports, "keymapPlugin", ()=>$249c61699bfcf173$export$e832373cff8dec22);
    var $e9qoo;
    var $5KWxh;
    var $vWFRY;
    var $lI7Qi;
    function $249c61699bfcf173$export$e832373cff8dec22() {
        const list = {};
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).findKeyMapForBrowser)((0, (0, parcelRequire("e9qoo")).redo)), (0, (0, parcelRequire("lI7Qi")).redoFromKeyboard), list);
        (0, (0, parcelRequire("e9qoo")).bindKeymapWithCommand)((0, (0, parcelRequire("e9qoo")).undo).common, (0, (0, parcelRequire("lI7Qi")).undoFromKeyboard), list);
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            props: {
                handleKeyDown (view, event) {
                    let keyboardEvent = (0, (0, parcelRequire("e9qoo")).isCapsLockOnAndModifyKeyboardEvent)(event);
                    return (0, (0, parcelRequire("vWFRY")).keydownHandler)(list)(view, keyboardEvent);
                }
            }
        });
    }
});
parcelRegister("lI7Qi", function(module, exports) {
    $parcel$export(module.exports, "undoFromKeyboard", ()=>$584e925f4ce03cec$export$1d1a6834315b2876);
    $parcel$export(module.exports, "redoFromKeyboard", ()=>$584e925f4ce03cec$export$b51f9da6d7e523d2);
    $parcel$export(module.exports, "undoFromToolbar", ()=>$584e925f4ce03cec$export$841850d252e034f0);
    $parcel$export(module.exports, "redoFromToolbar", ()=>$584e925f4ce03cec$export$11ad0a77a5cc0ccf);
    var $fZzhT;
    var $lSLWs;
    var $1YQwx;
    const $584e925f4ce03cec$export$1d1a6834315b2876 = (0, (0, parcelRequire("lSLWs")).attachInputMeta)((0, (0, parcelRequire("1YQwx")).InputSource).KEYBOARD)((0, (0, parcelRequire("fZzhT")).undo));
    const $584e925f4ce03cec$export$b51f9da6d7e523d2 = (0, (0, parcelRequire("lSLWs")).attachInputMeta)((0, (0, parcelRequire("1YQwx")).InputSource).KEYBOARD)((0, (0, parcelRequire("fZzhT")).redo));
    const $584e925f4ce03cec$export$841850d252e034f0 = (0, (0, parcelRequire("lSLWs")).attachInputMeta)((0, (0, parcelRequire("1YQwx")).InputSource).TOOLBAR)((0, (0, parcelRequire("fZzhT")).undo));
    const $584e925f4ce03cec$export$11ad0a77a5cc0ccf = (0, (0, parcelRequire("lSLWs")).attachInputMeta)((0, (0, parcelRequire("1YQwx")).InputSource).TOOLBAR)((0, (0, parcelRequire("fZzhT")).redo));
});
parcelRegister("lSLWs", function(module, exports) {
    $parcel$export(module.exports, "attachInputMeta", ()=>$7dcc7cfa8614d3b5$export$84d159245233a2bb);
    var $5EXQ9;
    const $7dcc7cfa8614d3b5$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
                let customTr = state.tr;
                const fakeDispatch = (tr)=>{
                    customTr = tr;
                };
                command(state, fakeDispatch);
                if (!customTr || !customTr.docChanged) return false;
                customTr.setMeta((0, (0, parcelRequire("5EXQ9")).pluginKey), inputSource);
                if (dispatch) dispatch(customTr);
                return true;
            };
});
parcelRegister("5EXQ9", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$99719005f73bb72b$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $99719005f73bb72b$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('undoRedoPlugin');
});
parcelRegister("1YQwx", function(module, exports) {
    $parcel$export(module.exports, "InputSource", ()=>$c49f27457b368844$export$c3de12c0810a343d);
    var $gkwXh;
    var $c49f27457b368844$export$c3de12c0810a343d;
    (function(InputSource) {
        InputSource[InputSource["TOOLBAR"] = (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).TOOLBAR] = "TOOLBAR";
        InputSource[InputSource["KEYBOARD"] = (0, (0, parcelRequire("gkwXh")).INPUT_METHOD).KEYBOARD] = "KEYBOARD";
    })($c49f27457b368844$export$c3de12c0810a343d || ($c49f27457b368844$export$c3de12c0810a343d = {}));
});
parcelRegister("kVmKj", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$68e14e6d3530e7bb$export$ae829ec7b2625219);
    var $5KWxh;
    var $5EXQ9;
    const $68e14e6d3530e7bb$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("5EXQ9")).pluginKey)
        });
    };
});
parcelRegister("cBhLR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$343b86e0a69d2f8f$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $8RXs9;
    var $awTmI;
    var $e9qoo;
    var $7S9ZN;
    var $ejItq;
    var $l4tMX;
    var $1jI4k;
    var $eGW7v;
    var $9H08G;
    var $lI7Qi;
    const $343b86e0a69d2f8f$var$closeTypeAheadAndRunCommand = (editorView, api)=>(command)=>{
            if (!editorView) return;
            if (api?.typeAhead?.actions?.isOpen(editorView.state)) api?.typeAhead?.actions?.close({
                attachCommand: command,
                insertCurrentQueryAsRawText: false
            });
            else command(editorView.state, editorView.dispatch);
        };
    const $343b86e0a69d2f8f$var$forceFocus = (editorView, api)=>(command)=>{
            $343b86e0a69d2f8f$var$closeTypeAheadAndRunCommand(editorView, api)(command);
            if (!editorView.hasFocus()) editorView.focus();
        };
    const $343b86e0a69d2f8f$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
        const { historyState: historyState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'history'
        ]);
        const handleUndo = ()=>{
            $343b86e0a69d2f8f$var$forceFocus(editorView, api)((0, (0, parcelRequire("lI7Qi")).undoFromToolbar));
        };
        const handleRedo = ()=>{
            $343b86e0a69d2f8f$var$forceFocus(editorView, api)((0, (0, parcelRequire("lI7Qi")).redoFromToolbar));
        };
        const labelUndo = formatMessage((0, (0, parcelRequire("7S9ZN")).messages).undo);
        const labelRedo = formatMessage((0, (0, parcelRequire("7S9ZN")).messages).redo);
        const { canUndo: canUndo, canRedo: canRedo } = historyState ?? {};
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("ejItq")).buttonGroupStyle)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            buttonId: (0, (0, parcelRequire("l4tMX")).TOOLBAR_ACTION_SUBJECT_ID).UNDO,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: handleUndo,
            disabled: !canUndo || disabled,
            "aria-label": (0, (0, parcelRequire("e9qoo")).tooltip)((0, (0, parcelRequire("e9qoo")).undo), labelUndo),
            "aria-keyshortcuts": (0, (0, parcelRequire("e9qoo")).getAriaKeyshortcuts)((0, (0, parcelRequire("e9qoo")).undo)),
            title: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e9qoo")).ToolTipContent), {
                description: labelUndo,
                keymap: (0, (0, parcelRequire("e9qoo")).undo)
            }),
            iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("9H08G"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            testId: "ak-editor-toolbar-button-undo"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            spacing: isReducedSpacing ? 'none' : 'default',
            buttonId: (0, (0, parcelRequire("l4tMX")).TOOLBAR_ACTION_SUBJECT_ID).REDO,
            onClick: handleRedo,
            disabled: !canRedo || disabled,
            title: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("e9qoo")).ToolTipContent), {
                description: labelRedo,
                keymap: (0, (0, parcelRequire("e9qoo")).redo)
            }),
            iconBefore: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eGW7v"))))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            testId: "ak-editor-toolbar-button-redo",
            "aria-label": (0, (0, parcelRequire("e9qoo")).tooltip)((0, (0, parcelRequire("e9qoo")).redo), labelRedo),
            "aria-keyshortcuts": (0, (0, parcelRequire("e9qoo")).getAriaKeyshortcuts)((0, (0, parcelRequire("e9qoo")).redo))
        }), !api?.primaryToolbar && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("ejItq")).separatorStyles)
        })));
    };
    var $343b86e0a69d2f8f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8RXs9")).default)($343b86e0a69d2f8f$export$4a0f2fb817767d20);
});
parcelRegister("l4tMX", function(module, exports) {
    $parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", ()=>$1393bb315c311409$export$f90c25d407b3694a);
    var $1393bb315c311409$export$f90c25d407b3694a;
    (function(TOOLBAR_ACTION_SUBJECT_ID) {
        TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
        TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
        TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
        TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
        TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
        TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
        TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
        TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
        TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
        TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
        TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
        TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
        TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
        TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
        TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
        TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
        TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
        TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    })($1393bb315c311409$export$f90c25d407b3694a || ($1393bb315c311409$export$f90c25d407b3694a = {}));
});
parcelRegister("eGW7v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ab22125c947bd831$var$_react = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ab22125c947bd831$var$_redo = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("51dEo")));
    var $ab22125c947bd831$var$_redo2 = $ab22125c947bd831$var$_interopRequireDefault((parcelRequire("5Pf2J")));
    function $ab22125c947bd831$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ab22125c947bd831$var$RedoIcon = (props)=>$ab22125c947bd831$var$_react.default.createElement($ab22125c947bd831$var$_redo.default, Object.assign({
            LEGACY_fallbackIcon: $ab22125c947bd831$var$_redo2.default
        }, props));
    $ab22125c947bd831$var$RedoIcon.Name = 'RedoIconMigration';
    var $ab22125c947bd831$var$_default = module.exports.default = $ab22125c947bd831$var$RedoIcon;
});
parcelRegister("51dEo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3a77a26e43f67a2e$var$_react = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3a77a26e43f67a2e$var$_UNSAFE_baseNew = $3a77a26e43f67a2e$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3a77a26e43f67a2e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3a77a26e43f67a2e$var$RedoIcon = (props)=>$3a77a26e43f67a2e$var$_react.default.createElement($3a77a26e43f67a2e$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 13.25H5.75a4 4 0 1 1 0-8h8m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $3a77a26e43f67a2e$var$RedoIcon.displayName = 'RedoIcon';
    var $3a77a26e43f67a2e$var$_default = module.exports.default = $3a77a26e43f67a2e$var$RedoIcon;
});
parcelRegister("5Pf2J", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $01183743c30bdd8e$var$_react = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $01183743c30bdd8e$var$_redo = $01183743c30bdd8e$var$_interopRequireDefault((parcelRequire("51dEo")));
    function $01183743c30bdd8e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $01183743c30bdd8e$var$RedoIcon = (props)=>$01183743c30bdd8e$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.101 13.569c-.247.5-.026 1.095.493 1.333.52.237 1.142.025 1.388-.473C7.011 12.351 9.193 11 11.63 11c2.266 0 4.319 1.167 5.425 3.021.286.479.922.645 1.421.371a.98.98 0 0 0 .386-1.366C17.389 10.557 14.65 9 11.63 9c-3.247 0-6.158 1.802-7.529 4.569"/><path d="M17.497 10v3h-2.995a1 1 0 1 0 0 2h3.896c.608 0 1.102-.493 1.102-1.1V10a1.001 1.001 0 0 0-2.003 0"/></g></svg>`
        }, props, {
            newIcon: $01183743c30bdd8e$var$_redo.default
        }));
    $01183743c30bdd8e$var$RedoIcon.displayName = 'RedoIcon';
    var $01183743c30bdd8e$var$_default = module.exports.default = $01183743c30bdd8e$var$RedoIcon;
});
parcelRegister("9H08G", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $70e83ccc33b2569d$var$_react = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $70e83ccc33b2569d$var$_undo = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("7sLAO")));
    var $70e83ccc33b2569d$var$_undo2 = $70e83ccc33b2569d$var$_interopRequireDefault((parcelRequire("80QYV")));
    function $70e83ccc33b2569d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $70e83ccc33b2569d$var$UndoIcon = (props)=>$70e83ccc33b2569d$var$_react.default.createElement($70e83ccc33b2569d$var$_undo.default, Object.assign({
            LEGACY_fallbackIcon: $70e83ccc33b2569d$var$_undo2.default
        }, props));
    $70e83ccc33b2569d$var$UndoIcon.Name = 'UndoIconMigration';
    var $70e83ccc33b2569d$var$_default = module.exports.default = $70e83ccc33b2569d$var$UndoIcon;
});
parcelRegister("7sLAO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $56f010d97236ea23$var$_UNSAFE_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $56f010d97236ea23$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $56f010d97236ea23$var$UndoIcon = (props)=>$56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 13.25h2.25a4 4 0 0 0 0-8h-8m3-3.5-3.5 3.5 3.5 3.5"/>`
        }, props));
    $56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
    var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;
});
parcelRegister("80QYV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5d576be12f027bbc$var$_react = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5d576be12f027bbc$var$_undo = $5d576be12f027bbc$var$_interopRequireDefault((parcelRequire("7sLAO")));
    function $5d576be12f027bbc$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5d576be12f027bbc$var$UndoIcon = (props)=>$5d576be12f027bbc$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M5.138 13.026a.98.98 0 0 0 .386 1.366 1.066 1.066 0 0 0 1.421-.371C8.051 12.167 10.104 11 12.37 11c2.437 0 4.619 1.351 5.648 3.429.246.498.868.71 1.388.473.519-.238.74-.833.493-1.333C18.528 10.802 15.618 9 12.37 9c-3.02 0-5.759 1.557-7.232 4.026"/><path d="M4.5 10v3.9c0 .607.494 1.1 1.102 1.1h3.896a1 1 0 1 0 0-2H6.503v-3A1 1 0 0 0 4.5 10"/></g></svg>`
        }, props, {
            newIcon: $5d576be12f027bbc$var$_undo.default
        }));
    $5d576be12f027bbc$var$UndoIcon.displayName = 'UndoIcon';
    var $5d576be12f027bbc$var$_default = module.exports.default = $5d576be12f027bbc$var$UndoIcon;
});
parcelRegister("kMiBI", function(module, exports) {
    $parcel$export(module.exports, "widthPlugin", ()=>(parcelRequire("bTGGC")).widthPlugin);
    var $bTGGC;
});
parcelRegister("bTGGC", function(module, exports) {
    $parcel$export(module.exports, "widthPlugin", ()=>$270b3b79fc31e80e$export$8cdf857cb01de6dc);
    var $5t0XF;
    var $kmA2l;
    var $ggOPR;
    const $270b3b79fc31e80e$export$8cdf857cb01de6dc = ()=>({
            name: 'width',
            pmPlugins: ()=>[
                    {
                        name: 'width',
                        plugin: ({ dispatch: dispatch })=>(0, (0, parcelRequire("5t0XF")).createPlugin)(dispatch)
                    }
                ],
            getSharedState: (editorState)=>{
                if (!editorState) return undefined;
                return (0, (0, parcelRequire("kmA2l")).pluginKey).getState(editorState);
            },
            usePluginHook ({ editorView: editorView, containerElement: containerElement }) {
                return (0, (0, parcelRequire("ggOPR")).useResizeWidthObserver)({
                    editorView: editorView,
                    containerElement: containerElement
                });
            }
        });
});
parcelRegister("5t0XF", function(module, exports) {
    $parcel$export(module.exports, "createPlugin", ()=>$459b9f5d8f6ef73b$export$ae829ec7b2625219);
    var $5KWxh;
    var $kmA2l;
    function $459b9f5d8f6ef73b$export$ae829ec7b2625219(dispatch) {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("kmA2l")).pluginKey),
            state: {
                init: ()=>({
                        width: document.body.offsetWidth
                    }),
                apply (tr, pluginState) {
                    const meta = tr.getMeta((0, (0, parcelRequire("kmA2l")).pluginKey));
                    if (!meta) return pluginState;
                    const newPluginState = {
                        ...pluginState,
                        ...meta
                    };
                    if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                        dispatch((0, (0, parcelRequire("kmA2l")).pluginKey), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            }
        });
    }
});
parcelRegister("kmA2l", function(module, exports) {
    $parcel$export(module.exports, "pluginKey", ()=>$ff8b08c35ee6f5de$export$18d4026d1ea86bb1);
    var $gZGBX;
    const $ff8b08c35ee6f5de$export$18d4026d1ea86bb1 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('widthPlugin');
});
parcelRegister("ggOPR", function(module, exports) {
    $parcel$export(module.exports, "useResizeWidthObserver", ()=>$d118631b559ea5d3$export$b0f894529c6bfe0a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kmA2l;
    var $5U0zH;
    const $d118631b559ea5d3$var$setEditorWidth = (props)=>(editorView)=>{
            const { dispatch: dispatch, state: { tr: tr } } = editorView;
            tr.setMeta((0, (0, parcelRequire("kmA2l")).pluginKey), props);
            dispatch(tr);
        };
    const $d118631b559ea5d3$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
        (0, (0, parcelRequire("5U0zH")).useRefreshWidthOnTransition)(containerElement);
        (0, $5uXOq.useEffect)(()=>{
            const newState = {
                lineLength: editorView.dom.clientWidth,
                width: containerElement?.offsetWidth
            };
            $d118631b559ea5d3$var$setEditorWidth(newState)(editorView);
        }, [
            editorView,
            editorView.dom.clientWidth,
            containerElement
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const resizeWidth = (entries)=>{
                if (entries.length !== 1) return;
                const [fullAreaSize] = entries;
                if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
                const width = fullAreaSize.borderBoxSize[0].inlineSize;
                const lineLength = editorView.dom.clientWidth;
                $d118631b559ea5d3$var$setEditorWidth({
                    width: width,
                    lineLength: lineLength
                })(editorView);
            };
            const resizeObserver = new ResizeObserver(resizeWidth);
            if (containerElement) resizeObserver.observe(containerElement);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            containerElement,
            editorView
        ]);
    };
});
parcelRegister("5U0zH", function(module, exports) {
    $parcel$export(module.exports, "useRefreshWidthOnTransition", ()=>$2e70303078c4f6e0$export$b72edfd730e58e7c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $VSDnB;
    const $2e70303078c4f6e0$var$transitionEventNames = [
        'transitionend',
        'oTransitionEnd',
        'webkitTransitionEnd'
    ];
    const $2e70303078c4f6e0$export$b72edfd730e58e7c = (containerElement)=>{
        const [_, setLastWidthEvent] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            if (!containerElement || !(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react_18_plugin_slot')) return;
            const forceComponentUpdate = (event)=>{
                if (event.propertyName.includes('width')) setLastWidthEvent(event);
            };
            return (0, (0, parcelRequire("cBeZP")).bindAll)(containerElement, $2e70303078c4f6e0$var$transitionEventNames.map((name)=>({
                    type: name,
                    listener: forceComponentUpdate
                })));
        }, [
            containerElement
        ]);
    };
});
parcelRegister("5xDEh", function(module, exports) {
    $parcel$export(module.exports, "is1pSmartLinkUnfurlInPromptEditorEnabled", ()=>$a9f01efb922fcf31$export$6eee77275ad753b3);
    $parcel$export(module.exports, "maybeBuild1pAutoFormattingProvider", ()=>$a9f01efb922fcf31$export$11d805c08164d04);
    var $gmhCD = parcelRequire("gmhCD");
    const $a9f01efb922fcf31$export$6eee77275ad753b3 = (options)=>{
        return Boolean(options.autoformattingProvider && options.enableLinks && (0, $gmhCD.editorExperiment)('platform_editor_ai_1p_smart_link_unfurl_in_prompt', true));
    };
    const $a9f01efb922fcf31$export$11d805c08164d04 = (options)=>{
        if ($a9f01efb922fcf31$export$6eee77275ad753b3(options)) return options.autoformattingProvider;
        return undefined;
    };
});
parcelRegister("3rirz", function(module, exports) {
    $parcel$export(module.exports, "createJiraEditorPluginAIProvider", ()=>$67bf2b0311b34ecc$export$9e0c22f6cd8535b3);
    $parcel$export(module.exports, "createJiraEditorPluginAI", ()=>$67bf2b0311b34ecc$export$d3b8c68e72134ac3);
    var $VSDnB;
    var $ckrWm;
    var $aDz1d;
    var $ezCQ6;
    var $9wspb;
    var $lNAyS;
    var $4y6cL;
    var $aMrA5;
    var $39VaN;
    var $K8sX1;
    var $4AGFf;
    var $dzpDy;
    var $k4yDK;
    var $6LWXh;
    var $5UEED;
    var $e4Vft;
    const $67bf2b0311b34ecc$export$9e0c22f6cd8535b3 = (props)=>{
        const onExperienceEvent = props?.onExperienceEvent || {
            THUMBS_UP: ()=>{},
            THUMBS_DOWN: ()=>{},
            REVIEW_STATE_ENTERED: ()=>{},
            EXPERIENCE_COMPLETE: ()=>{}
        };
        const reformatWithTemplate = props.allowIssueReformatter ? [
            (0, (0, parcelRequire("dzpDy")).reformatWithTemplateConfigItem)({
                getAdditionalProps: props.getAdditionalProps || (()=>({}))
            })
        ] : [];
        const isSuggestResponseEnabled = props.allowSuggestResponse && props.issueId !== undefined && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_suggested_response_fg') && props.product === 'JSM';
        const suggestResponse = isSuggestResponseEnabled ? [
            (0, (0, parcelRequire("lNAyS")).suggestResponseConfigItem)(props.issueId)
        ] : [];
        const brainstorm = isSuggestResponseEnabled ? [] : [
            (0, (0, parcelRequire("ezCQ6")).brainstormConfigItem)
        ];
        return (0, (0, parcelRequire("aDz1d")).createEditorPluginAIProvider)({
            disableAISelectionToolbar: true,
            emptyConfig: {
                baseGenerate: (0, (0, parcelRequire("9wspb")).generateContentConfigItem),
                getSuggestions () {
                    let list = [
                        ...reformatWithTemplate,
                        ...suggestResponse,
                        (0, (0, parcelRequire("4y6cL")).summarizePageConfigItem),
                        (0, (0, parcelRequire("K8sX1")).improveWriting),
                        (0, (0, parcelRequire("K8sX1")).fixSpellingAndGrammar),
                        ...brainstorm,
                        (0, (0, parcelRequire("k4yDK")).shortenConfigItem),
                        (0, (0, parcelRequire("39VaN")).professionalTone),
                        (0, (0, parcelRequire("39VaN")).empatheticTone),
                        (0, (0, parcelRequire("39VaN")).casualTone),
                        (0, (0, parcelRequire("39VaN")).neutralTone),
                        (0, (0, parcelRequire("39VaN")).educationalTone)
                    ];
                    list.push(...(0, (0, parcelRequire("aMrA5")).translationEmptyConfigItems));
                    return list;
                }
            },
            rangeConfig: {
                baseGenerate: (0, (0, parcelRequire("4AGFf")).generateFromSelectionConfigItem),
                getSuggestions () {
                    let list = [
                        ...reformatWithTemplate,
                        (0, (0, parcelRequire("6LWXh")).summarizeConfigItem),
                        (0, (0, parcelRequire("K8sX1")).improveWriting),
                        (0, (0, parcelRequire("K8sX1")).fixSpellingAndGrammar),
                        (0, (0, parcelRequire("k4yDK")).shortenConfigItem),
                        (0, (0, parcelRequire("39VaN")).professionalTone),
                        (0, (0, parcelRequire("39VaN")).empatheticTone),
                        (0, (0, parcelRequire("39VaN")).casualTone),
                        (0, (0, parcelRequire("39VaN")).neutralTone),
                        (0, (0, parcelRequire("39VaN")).educationalTone)
                    ];
                    list.push(...(0, (0, parcelRequire("5UEED")).translationRangeConfigItems));
                    return list;
                }
            },
            generativeAIApiUrl: props.generativeAIApiUrl,
            product: props.product,
            getFetchCustomHeaders: props?.getFetchCustomHeaders || (0, (0, parcelRequire("e4Vft"))._getFetchCustomHeaders),
            onExperienceEvent: onExperienceEvent,
            handleFeedbackSubmission: props?.handleFeedbackSubmission,
            AIButtonWrapper: props.AIButtonWrapper,
            proactiveAIToolbarButtonWrapper: props.proactiveAIToolbarButtonWrapper,
            PromptEditor: props.PromptEditor,
            disableInterrogation: props.disableInterrogation ?? false,
            proactiveAIConfig: {
                ...(0, (0, parcelRequire("e4Vft")).deriveProactiveAIConfig)(),
                ...props.proactiveAIConfig
            },
            getChannelVariables: props.getChannelVariables,
            actionSideEffects: props.actionSideEffects,
            actionOverrides: props.actionOverrides,
            isRovoEnabled: props.isRovoEnabled ?? true,
            aiLifeCycleDynamicAttributesGetter: props.aiLifeCycleDynamicAttributesGetter
        });
    };
    const $67bf2b0311b34ecc$export$d3b8c68e72134ac3 = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>{
        const editorPluginAI = new (0, (0, parcelRequire("ckrWm")).EditorPluginAI)({
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn
        });
        return {
            editorPluginAI: editorPluginAI,
            nextEditorPluginAI: (0, (0, parcelRequire("ckrWm")).NextEditorPluginAI)
        };
    };
    const $67bf2b0311b34ecc$export$b453c5980aaea0e9 = ({ config: { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn }, api: api })=>{
        const nextEditorPluginAI = (0, (0, parcelRequire("ckrWm")).NextEditorPluginAI)({
            config: {
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiGlobalOptIn || {
                    status: 'enabled',
                    triggerOptInFlow: ()=>{}
                }
            },
            api: api
        });
        return nextEditorPluginAI;
    };
});
parcelRegister("ckrWm", function(module, exports) {
    $parcel$export(module.exports, "EditorPluginAI", ()=>$25902dae3ba2cddb$export$dcf9e5d3b3228e1f);
    $parcel$export(module.exports, "NextEditorPluginAI", ()=>$25902dae3ba2cddb$export$7825a101a7e6b70b);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gkwXh;
    var $5KWxh;
    var $j79rm;
    var $etG8M;
    var $3mm6g;
    var $cqJWb;
    var $gmhCD = parcelRequire("gmhCD");
    var $aIZdc;
    var $k0FqT;
    var $lMBmm;
    var $knRk4;
    var $h1WZC;
    var $9Ocgt;
    var $l8xBy;
    var $54ft5;
    var $2kjU9;
    var $3bUxI;
    var $dOjx6;
    var $k7FZu;
    var $8uikQ;
    var $eLhn5;
    var $egWUf;
    var $eA5Z5;
    var $b2OAx;
    var $5uFuh;
    var $hcRrA;
    var $7u94l;
    var $k5t6k;
    var $4dOAK;
    var $5ilgR;
    var $3cfam;
    var $8V04q;
    var $jSlH9;
    var $kXXDl;
    var $b8ZqO;
    var $eIB13;
    var $fCAMT;
    var $5wv7C;
    var $14ecj;
    var $1OAQS;
    var $9effd;
    var $fu2Am;
    var $g8uXl;
    var $fkXQe;
    var $bJfF5;
    var $hEAZb;
    var $lCNub;
    var $i3tKZ;
    var $8sL3P;
    var $hqcPl;
    var $4GZLe;
    const $25902dae3ba2cddb$var$AnalyticsWrapper = ({ children: children })=>{
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useCreateAnalyticsFlow)({
            invokeAttributes: {
                experienceName: 'proactiveAIModal'
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h1WZC")).AnalyticsFlowContextProvider), {
            value: analyticsFlow
        }, children);
    };
    const $25902dae3ba2cddb$var$GlobalWrapper = ({ children: children })=>{
        const aiThemeColor = (0, (0, parcelRequire("k0FqT")).useAIThemeColor)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f8Sb3")).Global), {
            styles: (0, (0, parcelRequire("4GZLe")).globalStyles)(aiThemeColor)
        }), children);
    };
    class $25902dae3ba2cddb$export$dcf9e5d3b3228e1f {
        constructor({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn }){
            this.name = 'aiExperience';
            this.editorPluginAIProvider = editorPluginAIProvider;
            if (aiGlobalOptIn.status === 'disabled' || (0, (0, parcelRequire("aIZdc")).isFedRamp)()) return;
            this.nextPlugin = $25902dae3ba2cddb$export$7825a101a7e6b70b({
                config: {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn
                }
            });
            this.pluginsOptions = this.nextPlugin.pluginsOptions;
            this.pmPlugins = this.nextPlugin.pmPlugins;
            this.primaryToolbarComponent = this.nextPlugin.primaryToolbarComponent;
            this.contentComponent = this.nextPlugin.contentComponent;
        }
    }
    const $25902dae3ba2cddb$export$7825a101a7e6b70b = ({ config: { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn }, api: api })=>{
        let editorView;
        const setEditorView = (newEditorView)=>{
            editorView = newEditorView;
        };
        let providerFactory;
        const setProviderFactory = (newProviderFactory)=>{
            providerFactory = newProviderFactory;
        };
        let mentionProvider;
        const getMentionNameDetails = async (id)=>{
            if (!mentionProvider || !(0, (0, parcelRequire("3mm6g")).isResolvingMentionProvider)(mentionProvider)) return;
            const nameDetails = mentionProvider.resolveMentionName(id);
            if ((0, (0, parcelRequire("cqJWb")).isPromise)(nameDetails)) {
                const mention = await nameDetails;
                return mention;
            }
            return nameDetails;
        };
        const setMentionProvider = ()=>{
            const handler = (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>{
                    mentionProvider = provider;
                    providerFactory.unsubscribe('mentionProvider', handler);
                });
            };
            providerFactory.subscribe('mentionProvider', handler);
        };
        const setMediaProvider = ()=>{
            if (editorPluginAIProvider?.providers?.mediaProvider) providerFactory.setProvider('mediaProvider', Promise.resolve(editorPluginAIProvider.providers.mediaProvider));
        };
        const aiOptIn = aiGlobalOptIn || {
            status: 'enabled',
            triggerOptInFlow: ()=>{}
        };
        const { isProactiveAISupported: isProactiveAISpellingAndGrammarSupported, proactiveAIConfig: proactiveAISpellingAndGrammarConfig } = (0, (0, parcelRequire("7u94l")).getConfiguration)(editorPluginAIProvider);
        const { isProactiveAISupported: isProactiveAISupported, proactiveAIConfig: proactiveAIConfig } = (0, (0, parcelRequire("egWUf")).getConfiguration)(editorPluginAIProvider);
        const quickInsert = (intl)=>{
            const configItems = [];
            const { baseGenerate: baseGenerate, getSuggestions: getSuggestions, disableQuickInsert: disableQuickInsert } = editorPluginAIProvider.emptyConfig;
            if (!disableQuickInsert) configItems.push(baseGenerate, ...getSuggestions({}));
            const quickInsertItems = (0, (0, parcelRequire("9Ocgt")).mapConfigItemsToQuickInsertItems)({
                configItems: configItems,
                formatMessage: intl.formatMessage,
                aiGlobalOptIn: aiOptIn,
                editorView: editorView
            });
            return quickInsertItems;
        };
        quickInsert.disableMemo = true;
        api?.primaryToolbar?.actions.registerComponent({
            name: 'aiExperience',
            component: (0, (0, parcelRequire("fu2Am")).getAIPrimaryToolbarComponent)({
                api: api,
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiOptIn,
                isProactiveAISupported: isProactiveAISupported
            })
        });
        if (isProactiveAISpellingAndGrammarSupported) api?.primaryToolbar?.actions.registerComponent({
            name: 'spellCheck',
            component: (0, (0, parcelRequire("fu2Am")).getSpellingAndGrammarPrimaryToolbarComponent)({
                editorPluginAIProvider: editorPluginAIProvider
            })
        });
        return {
            name: 'aiExperience',
            pmPlugins: ()=>{
                const plugins = [
                    {
                        name: 'ai-experience-actor',
                        plugin: ()=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
                                view: (editorView)=>{
                                    const editorPluginAIActor = (0, (0, parcelRequire("knRk4")).aiActorCache).getActor(editorView);
                                    return {
                                        destroy: ()=>{
                                            editorPluginAIActor?.stop();
                                            (0, (0, parcelRequire("knRk4")).aiActorCache).delete(editorView);
                                        }
                                    };
                                }
                            })
                    },
                    {
                        name: 'aiExperience',
                        plugin: (options)=>{
                            const payload = {
                                action: 'init',
                                actionSubject: 'editor',
                                actionSubjectId: 'editorPluginAI',
                                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                                attributes: {
                                    aiGlobalOptIn: aiOptIn?.status
                                }
                            };
                            options.dispatchAnalyticsEvent(payload);
                            return (0, (0, parcelRequire("8V04q")).createDecorationPlugin)({
                                dispatchAnalyticsEvent: options.dispatchAnalyticsEvent,
                                dispatch: options.dispatch,
                                api: api
                            });
                        }
                    },
                    {
                        name: 'ai-experience-get-editor-view-and-provider-factory',
                        plugin: (options)=>{
                            setProviderFactory(options.providerFactory);
                            setMentionProvider();
                            setMediaProvider();
                            return (0, (0, parcelRequire("5wv7C")).createGetEditorViewPlugin)({
                                setEditorView: setEditorView
                            });
                        }
                    },
                    {
                        name: 'ai-experience-ai-button',
                        plugin: (options)=>(0, (0, parcelRequire("dOjx6")).createAIButtonPlugin)({
                                dispatch: options.dispatch
                            })
                    },
                    {
                        name: 'ai-experience-selection-preview',
                        plugin: ()=>(0, (0, parcelRequire("9effd")).createSelectionPreviewPlugin)()
                    }
                ];
                if (isProactiveAISpellingAndGrammarSupported) plugins.push({
                    name: 'ai-spelling-grammar-plugin',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, (0, parcelRequire("5uFuh")).createAISpellingGrammarPlugin)({
                            dispatch: dispatch,
                            getIntl: getIntl,
                            proactiveAIConfig: proactiveAISpellingAndGrammarConfig,
                            api: api
                        });
                    }
                });
                if (isProactiveAISupported) plugins.push({
                    name: 'ai-proactive-plugin',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, (0, parcelRequire("8uikQ")).createProactiveAIPlugin)({
                            dispatch: dispatch,
                            getIntl: getIntl,
                            proactiveAIConfig: proactiveAIConfig,
                            product: editorPluginAIProvider.product,
                            getMentionNameDetails: getMentionNameDetails,
                            api: api
                        });
                    }
                });
                plugins.push({
                    name: 'ai-event-hub',
                    plugin: ({ getIntl: getIntl })=>(0, (0, parcelRequire("k7FZu")).createAIEventHubPlugin)({
                            aiGlobalOptIn: aiOptIn,
                            editorPluginAIProvider: editorPluginAIProvider,
                            getIntl: getIntl
                        })
                });
                if (editorPluginAIProvider.isRovoEnabled) plugins.push({
                    name: 'editor-ai-rovo-agents',
                    plugin: (options)=>(0, (0, parcelRequire("1OAQS")).createRovoAgentsPlugin)(options)
                });
                return plugins;
            },
            actions: {
                openAIModal: ({ invokedFrom: invokedFrom })=>{
                    (0, (0, parcelRequire("lMBmm")).openAIModal)({
                        invokedFrom: invokedFrom,
                        editorView: editorView,
                        aiOptIn: aiOptIn,
                        configItem: editorPluginAIProvider.emptyConfig.baseGenerate
                    });
                }
            },
            getSharedState (state) {
                if (!state) return {
                    isProactiveEnabled: false,
                    isSpellingGrammarEnabled: false,
                    spellingGrammarErrorCount: 0,
                    recommendations: []
                };
                const spellingAndGrammarPluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state) ?? {};
                const proactivePluginState = (0, (0, parcelRequire("eLhn5")).aiProactivePluginKey).getState(state) ?? {};
                const recommendations = (0, (0, parcelRequire("b2OAx")).getAllRecommendations)(proactivePluginState) ?? [];
                return {
                    isProactiveEnabled: proactivePluginState.isProactiveEnabled ?? false,
                    isSpellingGrammarEnabled: spellingAndGrammarPluginState?.isSpellingAndGrammarEnabled ?? false,
                    spellingGrammarErrorCount: (0, (0, parcelRequire("5ilgR")).getAllDiffObjects)(spellingAndGrammarPluginState)?.length ?? 0,
                    recommendations: recommendations,
                    selectedRecommendationId: proactivePluginState.selectedRecommendationId,
                    hoveredRecommendationId: proactivePluginState.hoveredRecommendationId
                };
            },
            pluginsOptions: {
                selectionToolbar: (state, intl)=>{
                    if (editorPluginAIProvider.disableAISelectionToolbar) return;
                    const isAiButtonPulse = api?.engagementPlatform?.sharedState.currentState()?.messageStates['cc-editor-ai_ai-toolbar-button-pulse'];
                    const handleAiButtonMount = ()=>{
                        api?.engagementPlatform?.actions.startMessage('cc-editor-ai_ai-toolbar-button-pulse');
                    };
                    const items = [
                        (0, (0, parcelRequire("eIB13")).getImproveWritingAIButton)({
                            intl: intl,
                            hideTitle: false,
                            aiGlobalOptIn: aiOptIn
                        }),
                        (0, (0, parcelRequire("eIB13")).getAIExperienceButton)({
                            intl: intl,
                            rangeBaseGenerate: editorPluginAIProvider.rangeConfig.baseGenerate,
                            hideTitle: true,
                            aiGlobalOptIn: aiOptIn,
                            title: (0, (0, parcelRequire("fCAMT")).messages).tryAIToolbarIconTitle,
                            tooltip: (0, (0, parcelRequire("fCAMT")).messages).tryAIToolbarIconTooltip,
                            pulse: isAiButtonPulse,
                            onMount: handleAiButtonMount
                        })
                    ];
                    return {
                        rank: -10,
                        isToolbarAbove: true,
                        items: items
                    };
                },
                quickInsert: quickInsert,
                floatingToolbar: (0, (0, parcelRequire("3bUxI")).getFloatingToolbarConfig)({
                    aiGlobalOptIn: aiOptIn,
                    editorPluginAIProvider: editorPluginAIProvider
                }),
                contextPanel: (0, (0, parcelRequire("l8xBy")).getContextPanel)(()=>editorView)(api)
            },
            contentComponent: ({ editorView: editorView, wrapperElement: wrapperElement, appearance: appearance })=>{
                const endExperience = (options)=>{
                    if (editorPluginAIProvider.onAIProviderChanged && (0, $gmhCD.editorExperiment)('platform_editor_ai_facepile', true)) editorPluginAIProvider.onAIProviderChanged('command-palette');
                    const state = (0, (0, parcelRequire("jSlH9")).getPluginState)(editorView.state);
                    const decoSet = (0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
                    const endAIExperienceCommand = (0, (0, parcelRequire("3cfam")).createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete);
                    endAIExperienceCommand(editorView.state, editorView.dispatch);
                    editorView.focus();
                };
                const renderModalRegionAIButton = (aiExperienceDecorationPluginState)=>{
                    if (!aiExperienceDecorationPluginState || aiExperienceDecorationPluginState.modalDecorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) return null;
                    if ((0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(aiExperienceDecorationPluginState)) return null;
                    const modalDecorationElement = editorView?.dom.querySelector('.ai-modal-end-widget') || editorView?.dom.querySelector('.ai-selection-node');
                    if (!modalDecorationElement) return null;
                    let positions;
                    let decoration = aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration').shift() || aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration').shift();
                    if (decoration) positions = [
                        decoration.from,
                        decoration.to
                    ];
                    else {
                        const nodeDecorations = aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
                        if (nodeDecorations.length > 0) {
                            const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
                            const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
                            positions = [
                                startPos,
                                endPos
                            ];
                        }
                        decoration = nodeDecorations.shift();
                    }
                    if (!decoration) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqcPl")).ModalRegion), {
                        lastTriggeredFrom: aiExperienceDecorationPluginState.lastTriggeredFrom,
                        key: aiExperienceDecorationPluginState.modalMountedTimeStamp,
                        decoration: decoration,
                        modalDecorationElement: modalDecorationElement,
                        editorView: editorView,
                        editorRelativeWrapper: wrapperElement?.offsetParent,
                        endExperience: endExperience,
                        appearance: appearance,
                        decorationSet: aiExperienceDecorationPluginState.modalDecorationSet
                    }, aiExperienceDecorationPluginState.configItem && editorView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54ft5")).ExperienceApplication), {
                        configItem: aiExperienceDecorationPluginState.configItem,
                        editorPluginAIProvider: editorPluginAIProvider,
                        endExperience: endExperience,
                        positions: positions,
                        editorView: editorView,
                        providerFactory: providerFactory,
                        lastTriggeredFrom: aiExperienceDecorationPluginState.lastTriggeredFrom,
                        triggerMethod: aiExperienceDecorationPluginState.triggerMethod,
                        appearance: appearance,
                        initialPrompt: aiExperienceDecorationPluginState?.initialPrompt,
                        getMentionNameDetails: getMentionNameDetails,
                        triggeredFor: aiExperienceDecorationPluginState.triggeredFor,
                        engagementPlatformApi: api?.engagementPlatform?.actions
                    }));
                };
                const renderModalRegionNonAIButton = (aiExperienceDecorationPluginState)=>{
                    if (!aiExperienceDecorationPluginState || aiExperienceDecorationPluginState.modalDecorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) return null;
                    if ((0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(aiExperienceDecorationPluginState)) return null;
                    const modalDecorationElement = editorView?.dom.querySelector('.ai-modal-end-widget');
                    if (!modalDecorationElement) return null;
                    const decoration = aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration').shift() || aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration').shift();
                    if (!decoration) return null;
                    const positions = [
                        decoration.from,
                        decoration.to
                    ];
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqcPl")).ModalRegion), {
                        lastTriggeredFrom: aiExperienceDecorationPluginState.lastTriggeredFrom,
                        key: aiExperienceDecorationPluginState.modalMountedTimeStamp,
                        decoration: decoration,
                        modalDecorationElement: modalDecorationElement,
                        editorView: editorView,
                        editorRelativeWrapper: wrapperElement?.offsetParent,
                        endExperience: endExperience,
                        appearance: appearance,
                        decorationSet: aiExperienceDecorationPluginState.modalDecorationSet
                    }, aiExperienceDecorationPluginState.configItem && editorView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54ft5")).ExperienceApplication), {
                        configItem: aiExperienceDecorationPluginState.configItem,
                        editorPluginAIProvider: editorPluginAIProvider,
                        endExperience: endExperience,
                        positions: positions,
                        editorView: editorView,
                        providerFactory: providerFactory,
                        lastTriggeredFrom: aiExperienceDecorationPluginState.lastTriggeredFrom,
                        triggerMethod: aiExperienceDecorationPluginState.triggerMethod,
                        appearance: appearance,
                        initialPrompt: aiExperienceDecorationPluginState?.initialPrompt,
                        getMentionNameDetails: getMentionNameDetails
                    }));
                };
                const renderProactiveModalRegion = (aiProactivePluginState)=>{
                    const decoration = aiProactivePluginState.decorationSet.find(undefined, undefined, (spec)=>spec.key === (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION_SELECTED).shift();
                    if (!decoration) return null;
                    const modalDecorationElements = editorView?.dom.querySelectorAll('.ai-proactive-recommendation-selected');
                    const modalDecorationElement = modalDecorationElements.length > 1 ? modalDecorationElements?.[modalDecorationElements.length - 1]?.offsetParent : modalDecorationElements?.[0];
                    if (!modalDecorationElement) return null;
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqcPl")).ModalRegion), {
                        key: aiProactivePluginState.selectedRecommendationId,
                        decoration: decoration,
                        modalDecorationElement: modalDecorationElement,
                        editorView: editorView,
                        editorRelativeWrapper: wrapperElement?.offsetParent,
                        endExperience: endExperience,
                        appearance: appearance,
                        decorationSet: aiProactivePluginState.decorationSet,
                        autoScroll: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2kjU9")).ProactivePreviewScreenWithLogic), {
                        aiProactivePluginState: aiProactivePluginState,
                        editorView: editorView,
                        providerFactory: providerFactory,
                        editorPluginAIProvider: editorPluginAIProvider
                    }));
                };
                const renderModalRegion = (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') ? renderModalRegionAIButton : renderModalRegionNonAIButton;
                const pluginsToTrack = {
                    aiExperienceDecorationPluginState: (0, (0, parcelRequire("kXXDl")).aiExperienceDecorationPluginKey),
                    rovoAgentsPluginState: (0, (0, parcelRequire("14ecj")).rovoAgentsPluginKey),
                    aiProactivePluginState: (0, (0, parcelRequire("eLhn5")).aiProactivePluginKey),
                    aiSpellingGrammarPluginState: (0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey)
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement($25902dae3ba2cddb$var$GlobalWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i3tKZ")).RovoEnabled), {
                    editorView: editorView,
                    editorPluginAIProvider: editorPluginAIProvider
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lCNub")).PublishToRovo), {
                    editorView: editorView,
                    getMentionNameDetails: getMentionNameDetails,
                    editorPluginAIProvider: editorPluginAIProvider,
                    editorApi: api
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fkXQe")).AgentFetcher), {
                    editorPluginAIProvider: editorPluginAIProvider,
                    editorView: editorView
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8sL3P")).SubscribeToRovo), {
                    editorView: editorView,
                    product: editorPluginAIProvider.product,
                    onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
                    onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j79rm")).WithPluginState), {
                    plugins: pluginsToTrack,
                    render: ({ aiExperienceDecorationPluginState: aiExperienceDecorationPluginState, rovoAgentsPluginState: rovoAgentsPluginState, aiProactivePluginState: aiProactivePluginState, aiSpellingGrammarPluginState: aiSpellingGrammarPluginState })=>{
                        const modalRegion = renderModalRegion(aiExperienceDecorationPluginState);
                        const aiSpellingGrammarSelectedDecoration = aiSpellingGrammarPluginState?.decorationSet.find(undefined, undefined, (spec)=>spec.key === (0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR_SELECTED).shift();
                        if (isProactiveAISupported && !aiSpellingGrammarSelectedDecoration) {
                            const { selectedRecommendationId: selectedRecommendationId } = aiProactivePluginState;
                            const { recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(aiProactivePluginState, selectedRecommendationId);
                            const proactiveModalRegion = renderProactiveModalRegion(aiProactivePluginState);
                            if (modalRegion === null && !!recommendation) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEAZb")).ModalRegionErrorBoundary), {
                                onCloseFallback: endExperience
                            }, (0, ($parcel$interopDefault($5uXOq))).createElement($25902dae3ba2cddb$var$AnalyticsWrapper, null, proactiveModalRegion));
                        }
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEAZb")).ModalRegionErrorBoundary), {
                            onCloseFallback: endExperience
                        }, modalRegion ?? null, rovoAgentsPluginState?.isBrowseModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJfF5")).LoadableBrowseRovoAgentsModal), {
                            editorView: editorView,
                            aiGlobalOptIn: aiOptIn,
                            editorPluginAIProvider: editorPluginAIProvider,
                            startingConfig: aiExperienceDecorationPluginState.configItem,
                            positions: rovoAgentsPluginState?.positions
                        }));
                    }
                }));
            },
            primaryToolbarComponent: !api?.primaryToolbar ? (0, (0, parcelRequire("g8uXl")).getPrimaryToolbarLegacyComponent)({
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiOptIn,
                isProactiveAISpellingAndGrammarSupported: isProactiveAISpellingAndGrammarSupported,
                isProactiveAISupported: isProactiveAISupported
            }) : undefined
        };
    };
});
parcelRegister("j79rm", function(module, exports) {
    $parcel$export(module.exports, "WithPluginState", ()=>$d985d7d8deb0b848$export$38a2fcbdfe5b863a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8rCP3;
    var $VSDnB;
    var $gkwXh;
    var $lY6DM;
    var $iN9lO;
    var $8v2ZL;
    var $4NUlu;
    const $d985d7d8deb0b848$var$DEFAULT_SAMPLING_RATE = 100;
    const $d985d7d8deb0b848$var$DEFAULT_SLOW_THRESHOLD = 4;
    class $d985d7d8deb0b848$export$38a2fcbdfe5b863a extends (0, ($parcel$interopDefault($5uXOq))).Component {
        constructor(props){
            super(props);
        }
        render() {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_react18_phase2_v2')) return (0, ($parcel$interopDefault($5uXOq))).createElement($d985d7d8deb0b848$var$WithPluginStateNew, this.props);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($d985d7d8deb0b848$export$9ccf2ab248159b0f, this.props);
        }
    }
    function $d985d7d8deb0b848$var$WithPluginStateNew(props) {
        const context = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("8v2ZL")).EditorContext));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d985d7d8deb0b848$export$c41b245ea9f92714, {
            ...props,
            editorActions: context?.editorActions
        });
    }
    class $d985d7d8deb0b848$export$c41b245ea9f92714 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = 'WithPluginState';
        }
        constructor(props){
            super(props), this.listeners = {}, this.debounce = null, this.notAppliedState = {}, this.isSubscribed = false, this.callsCount = 0, this.handlePluginStateChange = (propName, pluginName, performanceOptions, skipEqualityCheck)=>(pluginState)=>{
                    if (this.state[propName] !== pluginState || skipEqualityCheck) this.updateState({
                        stateSubset: {
                            [propName]: pluginState
                        },
                        pluginName: pluginName,
                        performanceOptions: performanceOptions
                    });
                }, this.updateState = ({ stateSubset: stateSubset, pluginName: pluginName, performanceOptions: performanceOptions })=>{
                this.notAppliedState = {
                    ...this.notAppliedState,
                    ...stateSubset
                };
                if (this.debounce) window.clearTimeout(this.debounce);
                const debounce = this.props.debounce !== false ? (fn)=>window.setTimeout(fn, 0) : (fn)=>fn();
                this.debounce = debounce(()=>{
                    const measure = `\u{1F989}${pluginName}::WithPluginState`;
                    performanceOptions.trackingEnabled && (0, (0, parcelRequire("iN9lO")).startMeasure)(measure);
                    this.setState(this.notAppliedState, ()=>{
                        performanceOptions.trackingEnabled && (0, (0, parcelRequire("iN9lO")).stopMeasure)(measure, (duration)=>{
                            if (++this.callsCount % performanceOptions.samplingRate === 0 && duration > performanceOptions.slowThreshold) this.dispatchAnalyticsEvent({
                                action: (0, (0, parcelRequire("gkwXh")).ACTION).WITH_PLUGIN_STATE_CALLED,
                                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    plugin: pluginName,
                                    duration: duration
                                }
                            });
                        });
                    });
                    this.debounce = null;
                    this.notAppliedState = {};
                });
            }, this.dispatchAnalyticsEvent = (payload)=>{
                const eventDispatcher = this.getEventDispatcher();
                if (eventDispatcher) {
                    const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(eventDispatcher);
                    dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                        payload: payload
                    });
                }
            };
            this.state = this.getPluginsStates(this.props.plugins, this.getEditorView(props));
        }
        getEditorView(maybeProps) {
            const props = maybeProps || this.props;
            const editorActions = props.editorActions;
            return props.editorView || editorActions?._privateGetEditorView();
        }
        getEventDispatcher(maybeProps) {
            const props = maybeProps || this.props;
            return props.eventDispatcher || props.editorActions?._privateGetEventDispatcher();
        }
        getPluginsStates(plugins, editorView) {
            if (!editorView || !plugins) return {};
            const keys = Object.keys(plugins);
            return keys.reduce((acc, propName)=>{
                const pluginKey = plugins[propName];
                if (!pluginKey) return acc;
                acc[propName] = pluginKey.getState(editorView.state);
                return acc;
            }, {});
        }
        subscribe(props) {
            const plugins = props.plugins;
            const eventDispatcher = this.getEventDispatcher(props);
            const editorView = this.getEditorView(props);
            if (!eventDispatcher || !editorView || this.isSubscribed) return;
            const fakePluginKey = {
                key: 'analyticsPlugin$',
                getState: (state)=>{
                    return state['analyticsPlugin$'];
                }
            };
            const analyticsPlugin = fakePluginKey.getState(editorView.state);
            const uiTracking = analyticsPlugin && analyticsPlugin.performanceTracking ? analyticsPlugin.performanceTracking.uiTracking || {} : {};
            const trackingEnabled = uiTracking.enabled === true;
            const samplingRate = uiTracking.samplingRate ?? $d985d7d8deb0b848$var$DEFAULT_SAMPLING_RATE;
            const slowThreshold = uiTracking.slowThreshold ?? $d985d7d8deb0b848$var$DEFAULT_SLOW_THRESHOLD;
            this.isSubscribed = true;
            const pluginsStates = this.getPluginsStates(plugins, editorView);
            this.setState(pluginsStates);
            Object.keys(plugins).forEach((propName)=>{
                const pluginKey = plugins[propName];
                if (!pluginKey) return;
                const pluginName = pluginKey.key;
                const pluginState = pluginsStates[propName];
                const isPluginWithSubscribe = pluginState && pluginState.subscribe;
                const handler = this.handlePluginStateChange(propName, pluginName, {
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    trackingEnabled: trackingEnabled
                }, isPluginWithSubscribe);
                if (isPluginWithSubscribe) pluginState.subscribe(handler);
                else eventDispatcher.on(pluginKey.key, handler);
                this.listeners[pluginKey.key] = {
                    handler: handler,
                    pluginKey: pluginKey
                };
            });
        }
        unsubscribe() {
            const eventDispatcher = this.getEventDispatcher();
            const editorView = this.getEditorView();
            if (!eventDispatcher || !editorView || !this.isSubscribed) return;
            Object.keys(this.listeners).forEach((key)=>{
                const pluginState = this.listeners[key].pluginKey.getState(editorView.state);
                if (pluginState && pluginState.unsubscribe) pluginState.unsubscribe(this.listeners[key].handler);
                else eventDispatcher.off(key, this.listeners[key].handler);
            });
            this.listeners = [];
        }
        subscribeToContextUpdates() {
            this.props.editorActions?._privateSubscribe(()=>this.subscribe(this.props));
        }
        unsubscribeFromContextUpdates() {
            this.props.editorActions?._privateUnsubscribe(()=>this.subscribe(this.props));
        }
        componentDidMount() {
            this.subscribe(this.props);
            this.subscribeToContextUpdates();
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (!this.isSubscribed) this.subscribe(nextProps);
        }
        componentWillUnmount() {
            if (this.debounce) window.clearTimeout(this.debounce);
            this.unsubscribeFromContextUpdates();
            this.unsubscribe();
        }
        render() {
            const { render: render } = this.props;
            return render(this.state);
        }
    }
    class $d985d7d8deb0b848$export$9ccf2ab248159b0f extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.displayName = 'WithPluginState';
        }
        static{
            this.contextTypes = {
                editorActions: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object,
                editorSharedConfig: (0, ($parcel$interopDefault((0, parcelRequire("8rCP3"))))).object
            };
        }
        constructor(props, context){
            super(props, context), this.listeners = {}, this.debounce = null, this.notAppliedState = {}, this.isSubscribed = false, this.callsCount = 0, this.handlePluginStateChange = (propName, pluginName, performanceOptions, skipEqualityCheck)=>(pluginState)=>{
                    if (this.state[propName] !== pluginState || skipEqualityCheck) this.updateState({
                        stateSubset: {
                            [propName]: pluginState
                        },
                        pluginName: pluginName,
                        performanceOptions: performanceOptions
                    });
                }, this.updateState = ({ stateSubset: stateSubset, pluginName: pluginName, performanceOptions: performanceOptions })=>{
                this.notAppliedState = {
                    ...this.notAppliedState,
                    ...stateSubset
                };
                if (this.debounce) window.clearTimeout(this.debounce);
                const debounce = this.props.debounce !== false ? (fn)=>window.setTimeout(fn, 0) : (fn)=>fn();
                this.debounce = debounce(()=>{
                    const measure = `\u{1F989}${pluginName}::WithPluginState`;
                    performanceOptions.trackingEnabled && (0, (0, parcelRequire("iN9lO")).startMeasure)(measure);
                    this.setState(this.notAppliedState, ()=>{
                        performanceOptions.trackingEnabled && (0, (0, parcelRequire("iN9lO")).stopMeasure)(measure, (duration)=>{
                            if (++this.callsCount % performanceOptions.samplingRate === 0 && duration > performanceOptions.slowThreshold) this.dispatchAnalyticsEvent({
                                action: (0, (0, parcelRequire("gkwXh")).ACTION).WITH_PLUGIN_STATE_CALLED,
                                actionSubject: (0, (0, parcelRequire("gkwXh")).ACTION_SUBJECT).EDITOR,
                                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    plugin: pluginName,
                                    duration: duration
                                }
                            });
                        });
                    });
                    this.debounce = null;
                    this.notAppliedState = {};
                });
            }, this.dispatchAnalyticsEvent = (payload)=>{
                const eventDispatcher = this.getEventDispatcher();
                if (eventDispatcher) {
                    const dispatch = (0, (0, parcelRequire("lY6DM")).createDispatch)(eventDispatcher);
                    dispatch((0, (0, parcelRequire("4NUlu")).analyticsEventKey), {
                        payload: payload
                    });
                }
            }, this.onContextUpdate = ()=>{
                this.subscribe(this.props);
            };
            this.state = this.getPluginsStates(this.props.plugins, this.getEditorView(props, context));
        }
        getEditorView(maybeProps, maybeContext) {
            const props = maybeProps || this.props;
            const context = maybeContext || this.context;
            return props.editorView || context && context.editorActions && context.editorActions._privateGetEditorView() || context && context.editorSharedConfig && context.editorSharedConfig.editorView;
        }
        getEventDispatcher(maybeProps) {
            const props = maybeProps || this.props;
            return props.eventDispatcher || this.context && this.context.editorActions && this.context.editorActions._privateGetEventDispatcher() || this.context && this.context.editorSharedConfig && this.context.editorSharedConfig.eventDispatcher;
        }
        getPluginsStates(plugins, editorView) {
            if (!editorView || !plugins) return {};
            const keys = Object.keys(plugins);
            return keys.reduce((acc, propName)=>{
                const pluginKey = plugins[propName];
                if (!pluginKey) return acc;
                acc[propName] = pluginKey.getState(editorView.state);
                return acc;
            }, {});
        }
        subscribe(props) {
            const plugins = props.plugins;
            const eventDispatcher = this.getEventDispatcher(props);
            const editorView = this.getEditorView(props);
            if (!eventDispatcher || !editorView || this.isSubscribed) return;
            const fakePluginKey = {
                key: 'analyticsPlugin$',
                getState: (state)=>{
                    return state['analyticsPlugin$'];
                }
            };
            const analyticsPlugin = fakePluginKey.getState(editorView.state);
            const uiTracking = analyticsPlugin && analyticsPlugin.performanceTracking ? analyticsPlugin.performanceTracking.uiTracking || {} : {};
            const trackingEnabled = uiTracking.enabled === true;
            const samplingRate = uiTracking.samplingRate ?? $d985d7d8deb0b848$var$DEFAULT_SAMPLING_RATE;
            const slowThreshold = uiTracking.slowThreshold ?? $d985d7d8deb0b848$var$DEFAULT_SLOW_THRESHOLD;
            this.isSubscribed = true;
            const pluginsStates = this.getPluginsStates(plugins, editorView);
            this.setState(pluginsStates);
            Object.keys(plugins).forEach((propName)=>{
                const pluginKey = plugins[propName];
                if (!pluginKey) return;
                const pluginName = pluginKey.key;
                const pluginState = pluginsStates[propName];
                const isPluginWithSubscribe = pluginState && pluginState.subscribe;
                const handler = this.handlePluginStateChange(propName, pluginName, {
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    trackingEnabled: trackingEnabled
                }, isPluginWithSubscribe);
                if (isPluginWithSubscribe) pluginState.subscribe(handler);
                else eventDispatcher.on(pluginKey.key, handler);
                this.listeners[pluginKey.key] = {
                    handler: handler,
                    pluginKey: pluginKey
                };
            });
        }
        unsubscribe() {
            const eventDispatcher = this.getEventDispatcher();
            const editorView = this.getEditorView();
            if (!eventDispatcher || !editorView || !this.isSubscribed) return;
            Object.keys(this.listeners).forEach((key)=>{
                const pluginState = this.listeners[key].pluginKey.getState(editorView.state);
                if (pluginState && pluginState.unsubscribe) pluginState.unsubscribe(this.listeners[key].handler);
                else eventDispatcher.off(key, this.listeners[key].handler);
            });
            this.listeners = [];
        }
        subscribeToContextUpdates(context) {
            if (context && context.editorActions) context.editorActions._privateSubscribe(this.onContextUpdate);
        }
        unsubscribeFromContextUpdates(context) {
            if (context && context.editorActions) context.editorActions._privateUnsubscribe(this.onContextUpdate);
        }
        componentDidMount() {
            this.subscribe(this.props);
            this.subscribeToContextUpdates(this.context);
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            if (!this.isSubscribed) this.subscribe(nextProps);
        }
        componentWillUnmount() {
            if (this.debounce) window.clearTimeout(this.debounce);
            this.unsubscribeFromContextUpdates(this.context);
            this.unsubscribe();
        }
        render() {
            const { render: render } = this.props;
            return render(this.state);
        }
    }
});
parcelRegister("k0FqT", function(module, exports) {
    $parcel$export(module.exports, "useAIThemeColor", ()=>$5c5929a267549a62$export$a253e56048cb99a1);
    var $hxoiH;
    const $5c5929a267549a62$export$a253e56048cb99a1 = ()=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (key)=>$5c5929a267549a62$var$aiTheme[key][colorMode || 'light'];
    };
    const $5c5929a267549a62$var$aiTheme = {
        ['prism.border.step.1']: {
            light: '#0065FF',
            dark: '#0065FF'
        },
        ['prism.border.step.2']: {
            light: '#0469FF',
            dark: '#0469FF'
        },
        ['prism.border.step.3']: {
            light: '#BF63F3',
            dark: '#BF63F3'
        },
        ['prism.border.step.4']: {
            light: '#FFA900',
            dark: '#FFA900'
        },
        ['icon.brand']: {
            light: '#44546F',
            dark: '#9FADBC'
        },
        ['telepointer.background.step.1']: {
            light: '#F8E6A0',
            dark: '#F5CD47'
        },
        ['telepointer.background.step.2']: {
            light: '#8BDBE5',
            dark: '#60C6D2'
        },
        ['telepointer.background.step.3']: {
            light: '#0C66E4',
            dark: '#388BFF'
        },
        ['loading.step.1']: {
            light: '#0C66E4',
            dark: '#0C66E4'
        },
        ['loading.step.2']: {
            light: '#1D7AFC',
            dark: '#1D7AFC'
        },
        ['loading.step.3']: {
            light: '#388BFF',
            dark: '#388BFF'
        },
        ['empty-state.sheet']: {
            light: '#82B536',
            dark: '#6A9A23'
        },
        ['empty-state.line']: {
            light: '#FFFFFF',
            dark: '#101214'
        },
        ['empty-state.checkmark']: {
            light: '#1868DB',
            dark: '#1558BC'
        },
        ['empty-state.overlap']: {
            light: '#09326C',
            dark: '#09326C'
        },
        ['empty-state.scribble']: {
            light: '#FFFFFF',
            dark: '#101214'
        },
        ['empty-state.eyelash']: {
            light: '#101214',
            dark: '#FFFFFF'
        }
    };
});
parcelRegister("lMBmm", function(module, exports) {
    $parcel$export(module.exports, "openAIModal", ()=>$cf873b28ea3e8361$export$e49a2031d0d2ff07);
    var $3cfam;
    const $cf873b28ea3e8361$export$e49a2031d0d2ff07 = ({ invokedFrom: invokedFrom, aiOptIn: aiOptIn, configItem: configItem, editorView: editorView })=>{
        if (!editorView) return;
        const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
            state: editorView.state,
            configItem: configItem,
            lastTriggeredFrom: invokedFrom,
            aiGlobalOptIn: aiOptIn
        });
        openAIModalCommand(editorView.state, editorView.dispatch);
    };
});
parcelRegister("3cfam", function(module, exports) {
    $parcel$export(module.exports, "createWidgetDecoration", ()=>$55de771aac360624$export$6428b9f2a07e29a5);
    $parcel$export(module.exports, "createInlineDecoration", ()=>$55de771aac360624$export$1690e22aee311809);
    $parcel$export(module.exports, "createGeneratedContentDecorations", ()=>$55de771aac360624$export$ee67e3280dab453d);
    $parcel$export(module.exports, "createGeneratedNodeDecorations", ()=>$55de771aac360624$export$21c5d318062e995c);
    $parcel$export(module.exports, "createOpenAIModalCommand", ()=>$55de771aac360624$export$2c80ad35b3530be1);
    $parcel$export(module.exports, "createEndAIExperienceCommand", ()=>$55de771aac360624$export$d547a4e9ddb6b51);
    var $gkwXh;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $etG8M;
    var $gmhCD = parcelRequire("gmhCD");
    var $aIZdc;
    var $kb0r3;
    var $9m3ZB;
    var $2nx9e;
    var $5pb98;
    var $jSlH9;
    const $55de771aac360624$export$6428b9f2a07e29a5 = (pos, type, key)=>{
        const widgetSpanElement = document.createElement('span');
        widgetSpanElement.appendChild(document.createTextNode('\u200b'));
        widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
        widgetSpanElement.className = `ai-modal-${type}-widget`;
        widgetSpanElement.contentEditable = 'false';
        return (0, (0, parcelRequire("etG8M")).Decoration).widget(pos, widgetSpanElement, {
            side: type === 'start' ? 0 : -1,
            key: key ?? `${type}WidgetDecoration`
        });
    };
    const $55de771aac360624$export$1690e22aee311809 = (from, to)=>{
        return (0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
            class: 'ai-selection-highlight',
            'data-testid': 'ai-selection-highlight'
        }, {
            key: 'inlineDecoration'
        });
    };
    const $55de771aac360624$export$ee67e3280dab453d = (from, to)=>{
        const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(from, 'start', 'generatedStartWidget');
        const highlightInlineDecoration = (0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
            class: 'ai-generated-content-highlight',
            'data-testid': 'ai-generated-content-highlight'
        }, {
            key: 'generatedInlineDecoration'
        });
        const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(to, 'end', 'generatedEndWidget');
        return [
            startWidgetDecoration,
            highlightInlineDecoration,
            endWidgetDecoration
        ];
    };
    const $55de771aac360624$export$50894b1f0083184 = (from, to)=>{
        return (0, (0, parcelRequire("etG8M")).Decoration).node(from, to, {
            class: 'ai-selection-node',
            'data-testid': 'ai-selection-node'
        }, {
            key: 'ai-nodeDecoration'
        });
    };
    const $55de771aac360624$export$21c5d318062e995c = (from, to)=>{
        return (0, (0, parcelRequire("etG8M")).Decoration).node(from, to, {
            class: 'ai-generated-node-highlight',
            'data-testid': 'ai-generated-node-highlight'
        }, {
            key: 'generatedNodeDecoration'
        });
    };
    function $55de771aac360624$var$getInitialPositions(selection) {
        switch(true){
            case selection instanceof (0, (0, parcelRequire("gZGBX")).AllSelection):
                return {
                    startPos: selection.from + 1,
                    endPos: selection.to - 1
                };
            default:
                return {
                    startPos: selection.from,
                    endPos: selection.to
                };
        }
    }
    const $55de771aac360624$export$4379c9f48a526c4d = ({ state: state, positions: positions })=>{
        const { selection: selection } = state;
        let from, to;
        if (selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection)) {
            from = selection.from;
            to = selection.to;
        } else if ((0, (0, parcelRequire("2nx9e")).isCellSelection)(state)) {
            const findResult = (0, $5r0mK.findParentNodeOfType)(state.schema.nodes.table)(selection);
            if (findResult) {
                const { depth: depth } = findResult;
                from = selection.$from.before(depth);
                to = selection.$from.after(depth);
            }
        } else {
            const { selection: selection } = state;
            const supportedNodes = (0, (0, parcelRequire("2nx9e")).getSupportedNodesForAIModal)(state);
            const findResult = (0, $5r0mK.findParentNode)((node)=>supportedNodes.has(node.type))(selection);
            if (findResult) {
                const { depth: depth } = findResult;
                from = selection.$from.before(depth);
                to = selection.$from.after(depth);
            }
        }
        if (from !== undefined && to !== undefined) return [
            $55de771aac360624$export$50894b1f0083184(from, to)
        ];
        return [];
    };
    const $55de771aac360624$export$8b0c0139da7bc378 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, positions: positions })=>{
        let useCurrentSelection = true;
        if (state.selection.empty) useCurrentSelection = state.doc.content.size !== 0 && configItem.selectionType !== 'empty' ? false : true;
        if ((0, (0, parcelRequire("5pb98")).isConfluenceTitleToolbarSuggestTitle)({
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom
        })) useCurrentSelection = false;
        const { startPos: startPos, endPos: endPos } = positions || $55de771aac360624$var$getInitialPositions(useCurrentSelection ? state.selection : new (0, (0, parcelRequire("gZGBX")).AllSelection)(state.doc));
        const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(startPos, 'start');
        const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(endPos, 'end');
        const highlightInlineDecoration = $55de771aac360624$export$1690e22aee311809(startPos, endPos);
        const widgetDecorations = startPos === endPos ? [
            endWidgetDecoration
        ] : [
            startWidgetDecoration,
            endWidgetDecoration
        ];
        return [
            ...widgetDecorations,
            highlightInlineDecoration
        ];
    };
    const $55de771aac360624$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn, initialPrompt: initialPrompt, positions: positions, triggeredFor: triggeredFor, adjustSelection: adjustSelection })=>{
        if (aiGlobalOptIn.status === 'disabled' || (0, (0, parcelRequire("aIZdc")).isFedRamp)()) return ()=>false;
        if (aiGlobalOptIn.status === 'disabled-opt-in') {
            aiGlobalOptIn.triggerOptInFlow();
            return (0, (0, parcelRequire("jSlH9")).createCommand)({}, (tr)=>{
                (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: state,
                    tr: tr,
                    payload: {
                        action: 'triggerOptInFlow',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'aiGlobalOptIn',
                        attributes: {
                            experienceType: (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key),
                            lastTriggeredFrom: lastTriggeredFrom,
                            selectionType: configItem.selectionType
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    }
                });
                return tr;
            });
        }
        let modalDecorationSet = (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
        if ((0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test')) {
            if (triggeredFor?.isBlock) {
                const decorations = $55de771aac360624$export$4379c9f48a526c4d({
                    state: state,
                    positions: positions
                });
                if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
            } else {
                const decorations = $55de771aac360624$export$8b0c0139da7bc378({
                    state: state,
                    configItem: configItem,
                    lastTriggeredFrom: lastTriggeredFrom,
                    positions: positions
                });
                if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
            }
            const action = {
                type: 'SHOW_MODAL',
                data: {
                    lastTriggeredFrom: lastTriggeredFrom,
                    triggerMethod: triggerMethod,
                    modalDecorationSet: modalDecorationSet,
                    configItem: configItem,
                    modalMountedTimeStamp: Date.now(),
                    initialPrompt: initialPrompt,
                    triggeredFor: triggeredFor
                }
            };
            return (0, (0, parcelRequire("jSlH9")).createCommand)(action, (tr)=>{
                const selection = tr.selection;
                const { to: to, from: from } = selection;
                if (!triggeredFor?.isBlock && to !== from) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, to));
                return tr;
            });
        } else {
            let useCurrentSelection = true;
            if (adjustSelection === 'fullDocument') useCurrentSelection = false;
            if (state.selection.empty) useCurrentSelection = state.doc.content.size !== 0 && configItem.selectionType !== 'empty' ? false : true;
            if ((0, (0, parcelRequire("5pb98")).isConfluenceTitleToolbarSuggestTitle)({
                configItem: configItem,
                lastTriggeredFrom: lastTriggeredFrom
            })) useCurrentSelection = false;
            const { startPos: startPos, endPos: endPos } = positions || $55de771aac360624$var$getInitialPositions(useCurrentSelection ? state.selection : new (0, (0, parcelRequire("gZGBX")).AllSelection)(state.doc));
            const startWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(startPos, 'start');
            const endWidgetDecoration = $55de771aac360624$export$6428b9f2a07e29a5(endPos, 'end');
            const highlightInlineDecoration = $55de771aac360624$export$1690e22aee311809(startPos, endPos);
            const widgetDecorations = startPos === endPos ? [
                endWidgetDecoration
            ] : [
                startWidgetDecoration,
                endWidgetDecoration
            ];
            modalDecorationSet = (0, (0, parcelRequire("etG8M")).DecorationSet).create(state.doc, [
                ...widgetDecorations,
                highlightInlineDecoration
            ]);
            const action = {
                type: 'SHOW_MODAL',
                data: {
                    lastTriggeredFrom: lastTriggeredFrom,
                    triggerMethod: triggerMethod,
                    modalDecorationSet: modalDecorationSet,
                    configItem: configItem,
                    modalMountedTimeStamp: Date.now(),
                    initialPrompt: initialPrompt
                }
            };
            return (0, (0, parcelRequire("jSlH9")).createCommand)(action, (tr)=>{
                const { to: to, from: from } = tr.selection;
                if (to !== from) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, to));
                return tr;
            });
        }
    };
    const $55de771aac360624$export$d547a4e9ddb6b51 = (modalDecorationSet, preserveEditorSelectionOnComplete)=>{
        const action = {
            type: 'END_EXPERIENCE',
            data: modalDecorationSet && !preserveEditorSelectionOnComplete ? {
                modalDecorationSet: modalDecorationSet
            } : {}
        };
        return (0, (0, parcelRequire("jSlH9")).createCommand)(action, (tr)=>{
            if (preserveEditorSelectionOnComplete) {
                const inlineDeco = modalDecorationSet?.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.[0];
                if (inlineDeco) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, inlineDeco.from, Math.min(inlineDeco.to, tr.doc.content.size)));
            }
            return tr;
        });
    };
});
parcelRegister("kb0r3", function(module, exports) {
    $parcel$export(module.exports, "convertExperienceName", ()=>$bfdc5b03349072d5$export$42373263ca9a5144);
    $parcel$export(module.exports, "createAnalyticsFlow", ()=>$bfdc5b03349072d5$export$7e715b9b9acf423a);
    var $bXrHm = parcelRequire("bXrHm");
    var $dWAZk = parcelRequire("dWAZk");
    var $gkwXh;
    var $5IPCv;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $9m3ZB;
    function $bfdc5b03349072d5$export$42373263ca9a5144(experienceName) {
        if (experienceName === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER) {
            const getExperimentValue = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue;
            const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
            return analyticsExperienceName || experienceName;
        }
        return experienceName;
    }
    function $bfdc5b03349072d5$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes }) {
        const startTime = performance.now();
        const stepTracker = {};
        const aiSessionId = (0, ($parcel$interopDefault($bXrHm)))();
        let prevStepEnd = performance.now();
        let prevStepName;
        let experienceName;
        let adhocAttributes = {};
        let commonAttributes = {};
        let dynamicAttributes = {};
        let aiLifeCycleDynamicAttributesGetter;
        let finished = false;
        let contentCopiedSometime = false;
        let sawAupViolation = false;
        let interactionsCounter = 0;
        let lastAiInteractionID;
        let queuedStepArgs = {
            stepName: 'invoke',
            attributes: invokeAttributes
        };
        const getAiLifeCycleDynamicAttributes = ({ init: init })=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('editorai_dynamic_attributes_for_ai_life_cycle')) return {};
            if (init && aiLifeCycleDynamicAttributesGetter) dynamicAttributes = aiLifeCycleDynamicAttributesGetter();
            return dynamicAttributes;
        };
        const analyticsFlow = {
            aiSessionId: aiSessionId,
            enqueueStep: (stepArgs)=>{
                if (finished) {
                    fireAIAnalyticsEvent($bfdc5b03349072d5$var$createErrorPayload({
                        aiSessionId: aiSessionId,
                        errorSubType: 'userFlowAlreadyFinished',
                        errorProperties: {
                            stepArgs: stepArgs,
                            queuedStepArgs: queuedStepArgs
                        }
                    }));
                    return;
                }
                if (stepArgs.stepName === 'loading') {
                    lastAiInteractionID = `${aiSessionId}-${++interactionsCounter}`;
                    fireAIAnalyticsEvent({
                        payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('initiated', commonAttributes.channelId ?? lastAiInteractionID, $bfdc5b03349072d5$export$42373263ca9a5144(experienceName ?? ''), false, getAiLifeCycleDynamicAttributes({
                            init: true
                        }))
                    });
                }
                if (stepArgs.stepName === 'complete') {
                    const attributes = stepArgs?.attributes ?? {};
                    const actionTaken = 'actionTaken' in attributes ? attributes.actionTaken : undefined;
                    const promptType = 'promptType' in attributes ? attributes.promptType : undefined;
                    const refinementCount = 'refinementCount' in attributes ? attributes.refinementCount : undefined;
                    fireAIAnalyticsEvent({
                        payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('actioned', commonAttributes.channelId ?? lastAiInteractionID, $bfdc5b03349072d5$export$42373263ca9a5144(experienceName ?? ''), false, {
                            ...getAiLifeCycleDynamicAttributes({
                                init: false
                            }),
                            promptType: promptType,
                            refinementCount: refinementCount,
                            aiResultAction: actionTaken?.toLowerCase()
                        })
                    });
                }
                if (queuedStepArgs !== undefined) {
                    fireAIAnalyticsEvent($bfdc5b03349072d5$var$createErrorPayload({
                        aiSessionId: aiSessionId,
                        errorSubType: 'cannotEnqueueMoreThanOneEvent',
                        errorProperties: {
                            stepArgs: stepArgs,
                            queuedStepArgs: queuedStepArgs
                        }
                    }));
                    return;
                }
                queuedStepArgs = stepArgs;
            },
            fireQueuedStep: (target)=>{
                if (finished) {
                    fireAIAnalyticsEvent($bfdc5b03349072d5$var$createErrorPayload({
                        aiSessionId: aiSessionId,
                        errorSubType: 'userFlowAlreadyFinished',
                        errorProperties: {
                            target: target,
                            queuedStepArgs: queuedStepArgs
                        }
                    }));
                    return;
                }
                if (!queuedStepArgs) {
                    fireAIAnalyticsEvent($bfdc5b03349072d5$var$createErrorPayload({
                        aiSessionId: aiSessionId,
                        errorSubType: 'noEventExistsToBeFired',
                        errorProperties: {
                            target: target
                        }
                    }));
                    return;
                }
                queuedStepArgs.attributes = {
                    ...queuedStepArgs.attributes,
                    ...adhocAttributes,
                    ...commonAttributes,
                    invokedFrom: invokeAttributes.invokedFrom,
                    ...(0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') ? {
                        invokedFor: invokeAttributes.invokedFor
                    } : {},
                    invokedFor: invokeAttributes.invokedFor,
                    triggerMethod: invokeAttributes.triggerMethod,
                    target: target
                };
                if (target === 'failed' || target === 'apiError') fireAIAnalyticsEvent({
                    payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('error', commonAttributes.channelId ?? lastAiInteractionID, $bfdc5b03349072d5$export$42373263ca9a5144(experienceName ?? ''), false, {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        aiErrorMessage: (0, (0, parcelRequire("9m3ZB")).isErrorStepAttributes)(queuedStepArgs?.attributes) ? queuedStepArgs?.attributes?.errorKey ?? queuedStepArgs?.attributes?.errorType : 'Unknown error',
                        aiErrorCode: (0, (0, parcelRequire("9m3ZB")).isErrorStepAttributes)(queuedStepArgs.attributes) ? queuedStepArgs.attributes?.statusCode ?? 500 : 500
                    })
                });
                if (target === 'preview') fireAIAnalyticsEvent({
                    payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('viewed', commonAttributes.channelId ?? lastAiInteractionID, $bfdc5b03349072d5$export$42373263ca9a5144(experienceName ?? ''), false, getAiLifeCycleDynamicAttributes({
                        init: false
                    }))
                });
                fireUserFlowStep(queuedStepArgs);
                queuedStepArgs = undefined;
            },
            addAttributes: (attributes)=>{
                if ('contentCopied' in attributes && attributes.contentCopied) contentCopiedSometime = true;
                adhocAttributes = {
                    ...adhocAttributes,
                    ...attributes
                };
            },
            getAiLifeCycleDynamicAttributes: getAiLifeCycleDynamicAttributes,
            registerAiLifeCycleDynamicAttributesGetter: (getter)=>{
                aiLifeCycleDynamicAttributesGetter = getter;
            },
            updateCommonAttributes: (attributes)=>{
                commonAttributes = {
                    ...commonAttributes,
                    ...attributes
                };
            },
            getLastAiInteractionId: ()=>lastAiInteractionID,
            getUserFlowCommonAttributes: (configItem)=>{
                return {
                    agentId: configItem.agent?.id,
                    agentName: configItem.agent?.creatorType === 'SYSTEM' ? configItem.agent?.name : undefined
                };
            }
        };
        return analyticsFlow;
        function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
            if (!stepTracker[stepName]) stepTracker[stepName] = 1;
            else stepTracker[stepName] = stepTracker[stepName] + 1;
            if (attributes.experienceName) experienceName = $bfdc5b03349072d5$export$42373263ca9a5144(attributes.experienceName);
            let stepAttributes = {
                ...commonAttributes,
                duration: Math.round(performance.now() - prevStepEnd),
                ...attributes,
                aiSessionId: aiSessionId,
                experienceName: experienceName,
                source: prevStepName,
                invokedFrom: attributes.invokedFrom,
                triggerMethod: attributes.triggerMethod,
                stepOccurrence: String(stepTracker[stepName]),
                sawAupViolation: sawAupViolation
            };
            if (!attributes.target) {
                stepAttributes.totalDuration = Math.round(performance.now() - startTime);
                stepAttributes.contentCopiedSometime = contentCopiedSometime;
                finished = true;
            }
            if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
            let payload = {
                action: stepName,
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'userFlow',
                attributes: stepAttributes,
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
            };
            prevStepEnd = performance.now();
            prevStepName = stepName;
            adhocAttributes = {};
            fireAIAnalyticsEvent({
                payload: payload
            });
            if (finished) fireAIAnalyticsEvent({
                payload: {
                    ...payload,
                    action: 'finished',
                    attributes: {
                        ...payload.attributes,
                        source: stepName
                    }
                }
            });
        }
    }
    function $bfdc5b03349072d5$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
        return {
            payload: {
                action: 'unhandledErrorCaught',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    errorType: 'userFlowAnalyticsError',
                    errorSubType: errorSubType,
                    ...errorProperties
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            },
            channel: (0, $dWAZk.FabricChannel).editor
        };
    }
});
parcelRegister("eUFkl", function(module, exports) {
    $parcel$export(module.exports, "CONFIG_ITEM_KEYS", ()=>$b67b0e8cc197cabf$export$a48b28ab7ec6401c);
    var $6AuiH;
    var $3Fceg;
    var $b67b0e8cc197cabf$export$a48b28ab7ec6401c;
    (function(CONFIG_ITEM_KEYS) {
        CONFIG_ITEM_KEYS["ADD_STRUCTURE"] = "Add structure";
        CONFIG_ITEM_KEYS["BRAINSTORM"] = "Brainstorm";
        CONFIG_ITEM_KEYS["CHANGE_TONE_TO_CASUAL"] = "Change tone to casual";
        CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EDUCATIONAL"] = "Change tone to educational";
        CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EMPATHETIC"] = "Change tone to empathetic";
        CONFIG_ITEM_KEYS["CHANGE_TONE_TO_NEUTRAL"] = "Change tone to neutral";
        CONFIG_ITEM_KEYS["CHANGE_TONE_TO_PROFESSIONAL"] = "Change tone to professional";
        CONFIG_ITEM_KEYS["CREATE_PULL_REQUEST_DESCRIPTION"] = "Create pull request description";
        CONFIG_ITEM_KEYS["DESCRIBE_YOUR_PULL_REQUEST"] = "Describe your pull request";
        CONFIG_ITEM_KEYS["FIND_ACTION_ITEMS"] = "Find action items";
        CONFIG_ITEM_KEYS["FIX_SPELLING_AND_GRAMMAR"] = "Fix spelling & grammar";
        CONFIG_ITEM_KEYS["FREE_GENERATE"] = "AI (Atlassian Intelligence)";
        CONFIG_ITEM_KEYS["IMPROVE_WRITING"] = "Improve writing";
        CONFIG_ITEM_KEYS["MAKE_SHORTER"] = "Make shorter";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_COMPETITIVE_ANALYSIS"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).CompetitiveAnalysis}`] = "PREFILL_COMPETITIVE_ANALYSIS";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_DEVOPS"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).DevOps}`] = "PREFILL_DEVOPS";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_EXPERIMENT_PLAN"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ExperimentPlan}`] = "PREFILL_EXPERIMENT_PLAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_MARKETING_CAMPAIGN"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).MarketingCampaign}`] = "PREFILL_MARKETING_CAMPAIGN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_PRODUCT_LAUNCH_ANNOUNCEMENT"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductLaunchAnnouncement}`] = "PREFILL_PRODUCT_LAUNCH_ANNOUNCEMENT";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_PRODUCT_ROADMAP"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductRoadmap}`] = "PREFILL_PRODUCT_ROADMAP";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["PREFILL_SPRINT_PLANNING"] = `Prefill with ${(0, (0, parcelRequire("6AuiH")).PrefillPrompts).SprintPlanning}`] = "PREFILL_SPRINT_PLANNING";
        CONFIG_ITEM_KEYS["ROVO_AGENT"] = "Rovo agent";
        CONFIG_ITEM_KEYS["SHORTEN_UPDATE"] = "Shorten update";
        CONFIG_ITEM_KEYS["SUGGEST_A_TITLE"] = "Suggest a title";
        CONFIG_ITEM_KEYS["SUGGEST_REPONSE"] = "Suggest a response";
        CONFIG_ITEM_KEYS["SUMMARISE_WRITING"] = "Summarize writing";
        CONFIG_ITEM_KEYS["MAKE_LONGER"] = "Make longer";
        CONFIG_ITEM_KEYS["REPHRASE"] = "Rephrase";
        CONFIG_ITEM_KEYS["ADD_INTRODUCTION"] = "Add introduction";
        CONFIG_ITEM_KEYS["ADD_CONCLUSION"] = "Add conclusion";
        CONFIG_ITEM_KEYS["CONVERT_TO_BULLETED_LIST"] = "Convert to bulleted list";
        CONFIG_ITEM_KEYS["CONVERT_TO_TABLE"] = "Convert to table";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_SIMPLIFIED"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).ChineseSimplified}`] = "TRANSLATE_TO_CHINESE_SIMPLIFIED";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_TRADITIONAL"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).ChineseTraditional}`] = "TRANSLATE_TO_CHINESE_TRADITIONAL";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_CZECH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Czech}`] = "TRANSLATE_TO_CZECH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DANISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Danish}`] = "TRANSLATE_TO_DANISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_DUTCH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Dutch}`] = "TRANSLATE_TO_DUTCH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ENGLISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).English}`] = "TRANSLATE_TO_ENGLISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FINNISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Finnish}`] = "TRANSLATE_TO_FINNISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_FRENCH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).French}`] = "TRANSLATE_TO_FRENCH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_GERMAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).German}`] = "TRANSLATE_TO_GERMAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_HUNGARIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Hungarian}`] = "TRANSLATE_TO_HUNGARIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_ITALIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Italian}`] = "TRANSLATE_TO_ITALIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_JAPANESE"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Japanese}`] = "TRANSLATE_TO_JAPANESE";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_KOREAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Korean}`] = "TRANSLATE_TO_KOREAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_NORWEGIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Norwegian}`] = "TRANSLATE_TO_NORWEGIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_POLISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Polish}`] = "TRANSLATE_TO_POLISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_PORTUGUESE_BRAZILIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).PortugueseBrazilian}`] = "TRANSLATE_TO_PORTUGUESE_BRAZILIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_RUSSIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Russian}`] = "TRANSLATE_TO_RUSSIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SPANISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Spanish}`] = "TRANSLATE_TO_SPANISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_SWEDISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Swedish}`] = "TRANSLATE_TO_SWEDISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_TURKISH"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Turkish}`] = "TRANSLATE_TO_TURKISH";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_THAI"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Thai}`] = "TRANSLATE_TO_THAI";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_UKRAINIAN"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Ukrainian}`] = "TRANSLATE_TO_UKRAINIAN";
        CONFIG_ITEM_KEYS[CONFIG_ITEM_KEYS["TRANSLATE_TO_VIETNAMESE"] = `Translate to ${(0, (0, parcelRequire("3Fceg")).SupportedTranslationLanguages).Vietnamese}`] = "TRANSLATE_TO_VIETNAMESE";
        CONFIG_ITEM_KEYS["EXPERIMENTAL_PROMPT_PLACEHOLDER"] = "Experimental prompt placeholder";
    })($b67b0e8cc197cabf$export$a48b28ab7ec6401c || ($b67b0e8cc197cabf$export$a48b28ab7ec6401c = {}));
});
parcelRegister("6AuiH", function(module, exports) {
    $parcel$export(module.exports, "PrefillPrompts", ()=>$6fd763637407e195$export$5ff9a7d47fbea696);
    var $6fd763637407e195$export$5ff9a7d47fbea696;
    (function(PrefillPrompts) {
        PrefillPrompts["MarketingCampaign"] = "marketingCampaign";
        PrefillPrompts["CompetitiveAnalysis"] = "competitiveAnalysis";
        PrefillPrompts["SprintPlanning"] = "sprintPlanning";
        PrefillPrompts["ExperimentPlan"] = "experimentPlan";
        PrefillPrompts["DevOps"] = "devOps";
        PrefillPrompts["ProductRoadmap"] = "productRoadmap";
        PrefillPrompts["ProductLaunchAnnouncement"] = "productLaunchAnnouncement";
    })($6fd763637407e195$export$5ff9a7d47fbea696 || ($6fd763637407e195$export$5ff9a7d47fbea696 = {}));
});
parcelRegister("3Fceg", function(module, exports) {
    $parcel$export(module.exports, "SupportedTranslationLanguages", ()=>$2887767121b727e7$export$c5e4fced70735903);
    $parcel$export(module.exports, "supportedTranslationLanguagesPopularOrder", ()=>$2887767121b727e7$export$20cfed69f1ef38ea);
    $parcel$export(module.exports, "refinementSupportedTranslationLanguages", ()=>$2887767121b727e7$export$9e88c4e080b12be6);
    var $2887767121b727e7$export$c5e4fced70735903;
    (function(SupportedTranslationLanguages) {
        SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
        SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
        SupportedTranslationLanguages["Czech"] = "czech";
        SupportedTranslationLanguages["Danish"] = "danish";
        SupportedTranslationLanguages["Dutch"] = "dutch";
        SupportedTranslationLanguages["English"] = "english";
        SupportedTranslationLanguages["Finnish"] = "finnish";
        SupportedTranslationLanguages["French"] = "french";
        SupportedTranslationLanguages["German"] = "german";
        SupportedTranslationLanguages["Hungarian"] = "hungarian";
        SupportedTranslationLanguages["Italian"] = "italian";
        SupportedTranslationLanguages["Japanese"] = "japanese";
        SupportedTranslationLanguages["Korean"] = "korean";
        SupportedTranslationLanguages["Norwegian"] = "norwegian";
        SupportedTranslationLanguages["Polish"] = "polish";
        SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
        SupportedTranslationLanguages["Russian"] = "russian";
        SupportedTranslationLanguages["Spanish"] = "spanish";
        SupportedTranslationLanguages["Swedish"] = "swedish";
        SupportedTranslationLanguages["Turkish"] = "turkish";
        SupportedTranslationLanguages["Thai"] = "thai";
        SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
        SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    })($2887767121b727e7$export$c5e4fced70735903 || ($2887767121b727e7$export$c5e4fced70735903 = {}));
    const $2887767121b727e7$export$20cfed69f1ef38ea = [
        "english",
        "german",
        "japanese",
        "french",
        "korean",
        "spanish",
        "portugueseBrazilian",
        "russian",
        "dutch",
        "chineseSimplified",
        "polish",
        "italian",
        "chineseTraditional",
        "norwegian",
        "swedish",
        "czech",
        "finnish",
        "danish",
        "hungarian",
        "turkish",
        "thai",
        "ukrainian",
        "vietnamese"
    ];
    const $2887767121b727e7$export$9e88c4e080b12be6 = [
        "english",
        "german",
        "french",
        "spanish",
        "japanese",
        "portugueseBrazilian",
        "chineseSimplified",
        "korean"
    ];
});
parcelRegister("9m3ZB", function(module, exports) {
    $parcel$export(module.exports, "addAnalytics", ()=>$bc27afd334906bb1$export$5bef18c22bfe95d);
    $parcel$export(module.exports, "withAnalytics", ()=>$bc27afd334906bb1$export$af9baadf0e4f6e13);
    $parcel$export(module.exports, "useFireAIAnalyticsEvent", ()=>$bc27afd334906bb1$export$5098b64908ee530);
    $parcel$export(module.exports, "isErrorStepAttributes", ()=>$bc27afd334906bb1$export$1256d4293be5e625);
    $parcel$export(module.exports, "createUnifiedAnalyticPayload", ()=>$bc27afd334906bb1$export$80ac16e216c4d76a);
    var $8aY84;
    var $dWAZk = parcelRequire("dWAZk");
    var $2NMNM;
    var $gkwXh;
    var $2PaDE;
    function $bc27afd334906bb1$export$e65dc2451c080d01(payload) {
        const packageInfo = (0, (0, parcelRequire("2PaDE")).getPackageInfo)();
        const attributes = payload.attributes || {};
        return {
            ...payload,
            attributes: {
                ...attributes,
                aiPluginPackageName: packageInfo.packageName,
                aiPluginPackageVersion: packageInfo.packageVersion
            }
        };
    }
    function $bc27afd334906bb1$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor }) {
        return (tr)=>{
            const { storedMarks: storedMarks } = tr;
            const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
            tr.step(new (0, (0, parcelRequire("8aY84")).AnalyticsStep)([
                {
                    payload: $bc27afd334906bb1$export$e65dc2451c080d01(payload),
                    channel: channel
                }
            ], [], pos));
            if (storedMarks) tr.setStoredMarks(storedMarks);
            return true;
        };
    }
    function $bc27afd334906bb1$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor, addToHistory: addToHistory = true }) {
        $bc27afd334906bb1$var$attachPayloadIntoTransaction({
            editorState: editorState,
            payload: payload,
            channel: channel
        })(tr);
        if (!addToHistory) tr.setMeta('addToHistory', false);
        return tr;
    }
    function $bc27afd334906bb1$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor }) {
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    if (dispatch) {
                        if (payload instanceof Function) {
                            const dynamicPayload = payload(state);
                            if (dynamicPayload) dispatch($bc27afd334906bb1$export$5bef18c22bfe95d({
                                editorState: state,
                                tr: tr,
                                payload: dynamicPayload,
                                channel: channel
                            }));
                        } else dispatch($bc27afd334906bb1$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: payload,
                            channel: channel
                        }));
                    }
                }, view);
    }
    function $bc27afd334906bb1$export$12ef4e1e68d53406(createAnalyticsEvent) {
        return ({ payload: payload, channel: channel = (0, $dWAZk.FabricChannel).editor })=>{
            if (!createAnalyticsEvent) return;
            const fireEvent = ()=>createAnalyticsEvent($bc27afd334906bb1$export$e65dc2451c080d01(payload))?.fire(channel);
            if (window.requestIdleCallback) window.requestIdleCallback(fireEvent);
            else if (window.requestAnimationFrame) window.requestAnimationFrame(fireEvent);
            else setTimeout(fireEvent, 0);
        };
    }
    function $bc27afd334906bb1$export$5098b64908ee530() {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAIAnalyticsEvent = $bc27afd334906bb1$export$12ef4e1e68d53406(createAnalyticsEvent);
        return fireAIAnalyticsEvent;
    }
    function $bc27afd334906bb1$export$511854ca6705eca5(channelId, lastAiInteractionID) {
        return channelId ?? lastAiInteractionID ?? '';
    }
    function $bc27afd334906bb1$export$1256d4293be5e625(step) {
        if (!step) return false;
        return 'errorKey' in step || 'errorType' in step || 'statusCode' in step;
    }
    function $bc27afd334906bb1$export$80ac16e216c4d76a(action, interactionID, experienceName, proactive, attributes) {
        if (action === 'actioned') return {
            action: action,
            actionSubject: 'aiResult',
            actionSubjectId: 'editorPluginAI',
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                aiResultAction: 'unknown',
                ...$bc27afd334906bb1$export$b22832478954ca0(interactionID, experienceName, proactive),
                ...attributes
            }
        };
        if (action === 'submitted') return {
            action: action,
            actionSubject: 'aiFeedback',
            actionSubjectId: 'editorPluginAI',
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                aiFeedbackResult: 'down',
                ...$bc27afd334906bb1$export$b22832478954ca0(interactionID, experienceName, proactive),
                ...attributes
            }
        };
        return {
            action: action,
            actionSubject: action === 'initiated' || action === 'dismissed' ? 'aiInteraction' : 'aiResult',
            actionSubjectId: 'editorPluginAI',
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
            attributes: {
                ...$bc27afd334906bb1$export$b22832478954ca0(interactionID, experienceName, proactive),
                ...attributes
            }
        };
    }
    function $bc27afd334906bb1$export$b22832478954ca0(interactionID, experienceName, proactive) {
        return {
            singleInstrumentationID: interactionID ?? '',
            aiInteractionID: interactionID ?? '',
            aiFeatureName: 'Editor AI',
            aiExperienceName: experienceName ?? 'unknown',
            isAIFeature: 1,
            proactiveAIGenerated: !!proactive ? 1 : 0,
            userGeneratedAI: !proactive ? 1 : 0
        };
    }
});
parcelRegister("2PaDE", function(module, exports) {
    $parcel$export(module.exports, "getPackageInfo", ()=>$1d10e1d76c85c829$export$cd17d76da7967240);
    const $1d10e1d76c85c829$var$packageName = "platform-pkg";
    const $1d10e1d76c85c829$var$packageVersion = "0.0.0-use.local";
    function $1d10e1d76c85c829$export$cd17d76da7967240() {
        return {
            packageName: $1d10e1d76c85c829$var$packageName,
            packageVersion: $1d10e1d76c85c829$var$packageVersion
        };
    }
});
parcelRegister("2nx9e", function(module, exports) {
    $parcel$export(module.exports, "getSupportedNodesForAIModal", ()=>$49884aae59ed3da9$export$74e7028cbce2b0e1);
    $parcel$export(module.exports, "isCellSelection", ()=>$49884aae59ed3da9$export$73f561bc8b894934);
    const $49884aae59ed3da9$export$74e7028cbce2b0e1 = ({ schema: { nodes: nodes } })=>new Set([
            nodes.expand,
            nodes.layoutSection,
            nodes.nestedExpand,
            nodes.panel,
            nodes.table
        ]);
    const $49884aae59ed3da9$export$73f561bc8b894934 = (state, selection)=>{
        const { tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = state.schema.nodes;
        const { $from: $from } = selection || state.selection;
        const parent = $from.parent;
        return [
            tableHeader,
            tableCell,
            tabeRow,
            table
        ].includes(parent.type);
    };
});
parcelRegister("5pb98", function(module, exports) {
    $parcel$export(module.exports, "isConfluenceTitleToolbarSuggestTitle", ()=>$2d0fc0e4fe70a994$export$fc21f0ec31fe4ec0);
    var $eUFkl;
    const $2d0fc0e4fe70a994$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
        if (!configItem || !lastTriggeredFrom) return false;
        return configItem.key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
    };
});
parcelRegister("jSlH9", function(module, exports) {
    $parcel$export(module.exports, "createInitialState", ()=>$58ecf901089c14db$export$de5e90bd767c5d82);
    $parcel$export(module.exports, "createPluginState", ()=>$58ecf901089c14db$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$58ecf901089c14db$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$58ecf901089c14db$export$f05434c51e3762e);
    var $gkwXh;
    var $aOimD;
    var $etG8M;
    var $gmhCD = parcelRequire("gmhCD");
    var $gPFN1;
    var $3cfam;
    var $kXXDl;
    var $7I8vO;
    var $b8ZqO;
    var $9A8mD;
    function $58ecf901089c14db$var$onDocChanged(tr, pluginState) {
        const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
        try {
            if ((0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test')) {
                const isAiContentTransformationForBlocks = tr.getMeta('isAiContentTransformationForBlocks');
                if (isAiContentTransformationForBlocks) {
                    const newDecorations = (0, (0, parcelRequire("9A8mD")).getGeneratedNodeDecorationsFromTransaction)(tr);
                    if (newDecorations.length) return {
                        ...pluginState,
                        modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, newDecorations)
                    };
                }
            }
            const generatedContentMeta = tr.getMeta('isAiContentTransformation');
            if (generatedContentMeta) {
                const newDecoration = (0, (0, parcelRequire("9A8mD")).getGeneratedDecorationFromTransaction)(tr);
                if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
                return {
                    ...pluginState,
                    modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, newDecoration)
                };
            }
            if (pluginState.modalDecorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) return pluginState;
            const hasGeneratedContentDecoration = (0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(pluginState);
            const isRemote = tr.getMeta('isRemote') ?? false;
            const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
            if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
                ...pluginState,
                modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
            };
            const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
            if (hasGeneratedContentDecoration) return {
                ...pluginState,
                modalDecorationSet: mappedModalDecorationSet
            };
            const decorations = mappedModalDecorationSet.find();
            let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
            let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
            let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
            const nodeDecoration = decorations.find((d)=>d.spec.key === 'ai-nodeDecoration');
            if (nodeDecoration || endDecoration && !startDecoration && !inlineDecoration) return {
                ...pluginState,
                modalDecorationSet: mappedModalDecorationSet
            };
            const inlineDecorationHasContent = !!inlineDecoration && tr.doc.textBetween(inlineDecoration.from, inlineDecoration.to) !== '';
            if (!inlineDecoration || !inlineDecorationHasContent) return {
                ...pluginState,
                modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
            };
            if (inlineDecoration.from === 0) inlineDecoration = (0, (0, parcelRequire("3cfam")).createInlineDecoration)(inlineDecoration.from || 1, inlineDecoration.to || 1);
            if (!startDecoration) startDecoration = (0, (0, parcelRequire("3cfam")).createWidgetDecoration)(inlineDecoration.from, 'start');
            if (!endDecoration) endDecoration = (0, (0, parcelRequire("3cfam")).createWidgetDecoration)(inlineDecoration.to, 'end');
            return {
                ...pluginState,
                modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).create(tr.doc, [
                    startDecoration,
                    inlineDecoration,
                    endDecoration
                ])
            };
        } catch (error) {
            const analyticsPayload = {
                action: 'unhandledErrorCaught',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'decorationPluginFactory',
                attributes: {
                    errorType: 'handleDocChangedError',
                    errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(error)
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            };
            dispatchAnalyticsEvent(analyticsPayload);
            return {
                ...pluginState,
                modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
            };
        }
    }
    function $58ecf901089c14db$var$onSelectionChanged(_tr, pluginState) {
        if (pluginState.modalDecorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty || pluginState.configItem) return pluginState;
        if ((0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(pluginState)) return {
            ...pluginState,
            modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty
        };
        return pluginState;
    }
    const $58ecf901089c14db$export$de5e90bd767c5d82 = (dispatchAnalyticsEvent)=>(state)=>{
            return {
                modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            };
        };
    const { createPluginState: $58ecf901089c14db$export$656c7661095efe2e, createCommand: $58ecf901089c14db$export$8d4021544bdece00, getPluginState: $58ecf901089c14db$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("kXXDl")).aiExperienceDecorationPluginKey), (0, (0, parcelRequire("7I8vO")).reducer), {
        onDocChanged: $58ecf901089c14db$var$onDocChanged,
        onSelectionChanged: $58ecf901089c14db$var$onSelectionChanged
    });
});
parcelRegister("gPFN1", function(module, exports) {
    $parcel$export(module.exports, "ErrorUtils", ()=>$cad132f04c92e59a$export$7edca8cfa9634e37);
    class $cad132f04c92e59a$export$7edca8cfa9634e37 {
        static{
            this.redactSensitiveInfo = (str)=>{
                const redacted = str.replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]').replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
                return redacted;
            };
        }
        static extractErrorMessage(error) {
            if (error instanceof Error) return $cad132f04c92e59a$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
            else return $cad132f04c92e59a$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
        }
    }
});
parcelRegister("kXXDl", function(module, exports) {
    $parcel$export(module.exports, "aiExperienceDecorationPluginKey", ()=>$e9951b5e4e696425$export$32db9543f41e636c);
    var $gZGBX;
    const $e9951b5e4e696425$export$32db9543f41e636c = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiExperienceDecoration');
});
parcelRegister("7I8vO", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$d9a915ae7423da62$export$1650419e431d3ba3);
    var $etG8M;
    function $d9a915ae7423da62$export$1650419e431d3ba3(state, action) {
        switch(action.type){
            case 'END_EXPERIENCE':
                return {
                    modalDecorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                    dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
                    ...action.data
                };
            case 'SHOW_MODAL':
                return {
                    ...state,
                    ...action.data
                };
            default:
                return state;
        }
    }
});
parcelRegister("b8ZqO", function(module, exports) {
    $parcel$export(module.exports, "hasGeneratedContentDecorations", ()=>$c39ac67c93fec15a$export$4306d8811b2d2e31);
    const $c39ac67c93fec15a$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;
});
parcelRegister("9A8mD", function(module, exports) {
    $parcel$export(module.exports, "getValidEndTextPosition", ()=>$031b8beaad916af7$export$a2bf0757549da456);
    $parcel$export(module.exports, "findFirstReplaceStep", ()=>$031b8beaad916af7$export$ec5fde712084a8ed);
    $parcel$export(module.exports, "getGeneratedDecorationFromTransaction", ()=>$031b8beaad916af7$export$9d1e89ce90c0a9a);
    $parcel$export(module.exports, "getGeneratedNodeDecorationsFromTransaction", ()=>$031b8beaad916af7$export$a6a2b5778b599ea1);
    var $eS2Dn;
    var $3cfam;
    function $031b8beaad916af7$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
        let validPos = pos;
        while(validPos > 0){
            if (doc.resolve(validPos).parent.inlineContent) break;
            validPos--;
        }
        return validPos;
    }
    function $031b8beaad916af7$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
        let validPos = pos;
        let isValidPos = false;
        while(isValidPos === false){
            if (doc.resolve(validPos).parent.inlineContent) {
                isValidPos = true;
                break;
            }
            validPos++;
        }
        return validPos;
    }
    function $031b8beaad916af7$var$findLastChildWithTextContent(content) {
        if (content.childCount <= 0) return null;
        let count = content.childCount - 1;
        let validNode = content.child(count);
        while(count >= 0){
            if (content.child(count).textContent !== '') break;
            count--;
        }
        return validNode;
    }
    function $031b8beaad916af7$var$getEndPosition({ step: step, doc: doc }) {
        let validPos = step.from + step.slice.size;
        let isValidPos = false;
        const validNode = $031b8beaad916af7$var$findLastChildWithTextContent(step.slice.content);
        if (!validNode) return step.from;
        const textContent = validNode.textContent;
        while(isValidPos === false && validPos > 0){
            const textBetween = doc.textBetween(step.from, validPos);
            const slice = doc.slice(step.from, validPos);
            if (textBetween.endsWith(textContent) && slice.content.lastChild?.textContent !== '') {
                isValidPos = true;
                break;
            }
            validPos--;
        }
        return validPos;
    }
    function $031b8beaad916af7$var$getValidStartTextPosition({ pos: pos, doc: doc }) {
        let startPos = pos;
        let isValidPos = false;
        while(isValidPos === false){
            if (doc.nodeAt(startPos)) {
                isValidPos = true;
                break;
            }
            startPos++;
        }
        return $031b8beaad916af7$var$getClosestValidTextPositionAfter({
            pos: startPos,
            doc: doc
        });
    }
    function $031b8beaad916af7$export$a2bf0757549da456({ step: step, doc: doc }) {
        const endPos = $031b8beaad916af7$var$getEndPosition({
            step: step,
            doc: doc
        });
        return $031b8beaad916af7$var$getClosestValidTextPositionBefore({
            pos: endPos,
            doc: doc
        });
    }
    function $031b8beaad916af7$export$ec5fde712084a8ed(steps) {
        const step = steps.find((step)=>step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep));
        if (!step) return null;
        return step;
    }
    function $031b8beaad916af7$export$9d1e89ce90c0a9a(transaction) {
        const step = $031b8beaad916af7$export$ec5fde712084a8ed(transaction.steps);
        if (!step) return null;
        const validStartDecorationPos = $031b8beaad916af7$var$getValidStartTextPosition({
            pos: step.from,
            doc: transaction.doc
        });
        const validEndDecorationPos = $031b8beaad916af7$export$a2bf0757549da456({
            step: step,
            doc: transaction.doc
        });
        return (0, (0, parcelRequire("3cfam")).createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos);
    }
    function $031b8beaad916af7$export$a6a2b5778b599ea1(transaction) {
        const replaceSteps = transaction.steps.filter((step)=>step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep));
        if (replaceSteps.length === 0) return [];
        return replaceSteps.map((step)=>{
            const startPos = step.from;
            const node = transaction.doc.nodeAt(startPos);
            if (node) {
                const endPos = startPos + node.nodeSize;
                return (0, (0, parcelRequire("3cfam")).createGeneratedNodeDecorations)(startPos, endPos);
            }
        }).filter((decoration)=>decoration !== undefined);
    }
});
parcelRegister("knRk4", function(module, exports) {
    $parcel$export(module.exports, "aiActorCache", ()=>$c6bb818ca2d06525$export$eca6b7572eaa53aa);
    var $iflnw;
    var $8cFS3;
    class $c6bb818ca2d06525$var$AIActorCache extends WeakMap {
        getActor(editorView) {
            if (this.has(editorView)) return this.get(editorView);
            const editorPluginAIActor = (0, (0, parcelRequire("iflnw")).interpret)((0, (0, parcelRequire("8cFS3")).editorPluginAIMachine));
            editorPluginAIActor.start();
            $c6bb818ca2d06525$export$eca6b7572eaa53aa.set(editorView, editorPluginAIActor);
            return editorPluginAIActor;
        }
    }
    const $c6bb818ca2d06525$export$eca6b7572eaa53aa = new $c6bb818ca2d06525$var$AIActorCache();
});
parcelRegister("iflnw", function(module, exports) {
    $parcel$export(module.exports, "interpret", ()=>$d48a35febbc26761$export$67beed298888a38b);
    var $dkU7z;
    var $lnGwo;
    var $kUFUe;
    var $1G4Gq;
    var $6Mwr3;
    var $knNkr;
    var $g2PT9;
    var $krWBq;
    var $6Z4UF;
    var $1FBh2;
    var $ckC1K;
    var $1IMXT;
    var $b4ajb;
    var $d48a35febbc26761$var$DEFAULT_SPAWN_OPTIONS = {
        sync: false,
        autoForward: false
    };
    var $d48a35febbc26761$export$7a567c9c5088a551;
    (function(InterpreterStatus) {
        InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
        InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
        InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
    })($d48a35febbc26761$export$7a567c9c5088a551 || ($d48a35febbc26761$export$7a567c9c5088a551 = {}));
    var $d48a35febbc26761$export$e5b52c46a548ff03 = function() {
        function Interpreter(machine, options) {
            var _this = this;
            if (options === void 0) options = Interpreter.defaultOptions;
            this.machine = machine;
            this.scheduler = new (0, (0, parcelRequire("ckC1K")).Scheduler)();
            this.delayedEventsMap = {};
            this.listeners = new Set();
            this.contextListeners = new Set();
            this.stopListeners = new Set();
            this.doneListeners = new Set();
            this.eventListeners = new Set();
            this.sendListeners = new Set();
            this.initialized = false;
            this.status = $d48a35febbc26761$export$7a567c9c5088a551.NotStarted;
            this.children = new Map();
            this.forwardTo = new Set();
            this.init = this.start;
            this.send = function(event1, payload) {
                if ((0, (0, parcelRequire("kUFUe")).isArray)(event1)) {
                    _this.batch(event1);
                    return _this.state;
                }
                var _event = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)((0, (0, parcelRequire("kUFUe")).toEventObject)(event1, payload));
                if (_this.status === $d48a35febbc26761$export$7a567c9c5088a551.Stopped) {
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "Event \"" + _event.name + "\" was sent to stopped service \"" + _this.machine.id + "\". This service has already reached its final state, and will not transition.\nEvent: " + JSON.stringify(_event.data));
                    return _this.state;
                }
                if (_this.status !== $d48a35febbc26761$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error("Event \"" + _event.name + "\" was sent to uninitialized service \"" + _this.machine.id + "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: " + JSON.stringify(_event.data));
                _this.scheduler.schedule(function() {
                    _this.forward(_event);
                    var nextState = _this.nextState(_event);
                    _this.update(nextState, _event);
                });
                return _this._state;
            };
            this.sendTo = function(event1, to) {
                var isParent = _this.parent && (to === (0, (0, parcelRequire("1G4Gq")).SpecialTargets).Parent || _this.parent.id === to);
                var target = isParent ? _this.parent : (0, (0, parcelRequire("kUFUe")).isString)(to) ? _this.children.get(to) || (0, (0, parcelRequire("1IMXT")).registry).get(to) : (0, (0, parcelRequire("kUFUe")).isActor)(to) ? to : undefined;
                if (!target) {
                    if (!isParent) throw new Error("Unable to send event to child '" + to + "' from service '" + _this.id + "'.");
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "Service '" + _this.id + "' has no parent: unable to send event " + event1.type);
                    return;
                }
                if ('machine' in target) target.send((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, event1), {
                    name: event1.name === (0, (0, parcelRequire("knNkr")).error) ? "" + (0, (0, parcelRequire("g2PT9")).error)(_this.id) : event1.name,
                    origin: _this.sessionId
                }));
                else target.send(event1.data);
            };
            var resolvedOptions = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, Interpreter.defaultOptions), options);
            var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
            var resolvedId = id !== undefined ? id : machine.id;
            this.id = resolvedId;
            this.logger = logger;
            this.clock = clock;
            this.parent = parent;
            this.options = resolvedOptions;
            this.scheduler = new (0, (0, parcelRequire("ckC1K")).Scheduler)({
                deferEvents: this.options.deferEvents
            });
            this.sessionId = (0, (0, parcelRequire("1IMXT")).registry).bookId();
        }
        Object.defineProperty(Interpreter.prototype, "initialState", {
            get: function() {
                var _this = this;
                if (this._initialState) return this._initialState;
                return (0, (0, parcelRequire("6Z4UF")).provide)(this, function() {
                    _this._initialState = _this.machine.initialState;
                    return _this._initialState;
                });
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Interpreter.prototype, "state", {
            get: function() {
                if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(this.status !== $d48a35febbc26761$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '" + this.id + "'. Make sure the service is started first.");
                return this._state;
            },
            enumerable: false,
            configurable: true
        });
        Interpreter.prototype.execute = function(state, actionsConfig) {
            var e_1, _a;
            try {
                for(var _b = (0, (0, parcelRequire("dkU7z")).__values)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                    var action = _c.value;
                    this.exec(action, state, actionsConfig);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        };
        Interpreter.prototype.update = function(state, _event) {
            var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
            var _this = this;
            state._sessionid = this.sessionId;
            this._state = state;
            if (this.options.execute) this.execute(this.state);
            this.children.forEach(function(child) {
                _this.state.children[child.id] = child;
            });
            if (this.devTools) this.devTools.send(_event.data, state);
            if (state.event) try {
                for(var _e = (0, (0, parcelRequire("dkU7z")).__values)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                    var listener = _f.value;
                    listener(state.event);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            try {
                for(var _g = (0, (0, parcelRequire("dkU7z")).__values)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                    var listener = _h.value;
                    listener(state, state.event);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            try {
                for(var _j = (0, (0, parcelRequire("dkU7z")).__values)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                    var contextListener = _k.value;
                    contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
            var isDone = (0, (0, parcelRequire("6Mwr3")).isInFinalState)(state.configuration || [], this.machine);
            if (this.state.configuration && isDone) {
                var finalChildStateNode = state.configuration.find(function(sn) {
                    return sn.type === 'final' && sn.parent === _this.machine;
                });
                var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, (0, parcelRequire("kUFUe")).mapContext)(finalChildStateNode.doneData, state.context, _event) : undefined;
                try {
                    for(var _l = (0, (0, parcelRequire("dkU7z")).__values)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                        var listener = _m.value;
                        listener((0, (0, parcelRequire("g2PT9")).doneInvoke)(this.id, doneData));
                    }
                } catch (e_5_1) {
                    e_5 = {
                        error: e_5_1
                    };
                } finally{
                    try {
                        if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                    } finally{
                        if (e_5) throw e_5.error;
                    }
                }
                this.stop();
            }
        };
        Interpreter.prototype.onTransition = function(listener) {
            this.listeners.add(listener);
            if (this.status === $d48a35febbc26761$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
            return this;
        };
        Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
            var _this = this;
            if (!nextListenerOrObserver) return {
                unsubscribe: function() {
                    return void 0;
                }
            };
            var listener;
            var resolvedCompleteListener = completeListener;
            if (typeof nextListenerOrObserver === 'function') listener = nextListenerOrObserver;
            else {
                listener = nextListenerOrObserver.next.bind(nextListenerOrObserver);
                resolvedCompleteListener = nextListenerOrObserver.complete.bind(nextListenerOrObserver);
            }
            this.listeners.add(listener);
            if (this.status === $d48a35febbc26761$export$7a567c9c5088a551.Running) listener(this.state);
            if (resolvedCompleteListener) this.onDone(resolvedCompleteListener);
            return {
                unsubscribe: function() {
                    listener && _this.listeners.delete(listener);
                    resolvedCompleteListener && _this.doneListeners.delete(resolvedCompleteListener);
                }
            };
        };
        Interpreter.prototype.onEvent = function(listener) {
            this.eventListeners.add(listener);
            return this;
        };
        Interpreter.prototype.onSend = function(listener) {
            this.sendListeners.add(listener);
            return this;
        };
        Interpreter.prototype.onChange = function(listener) {
            this.contextListeners.add(listener);
            return this;
        };
        Interpreter.prototype.onStop = function(listener) {
            this.stopListeners.add(listener);
            return this;
        };
        Interpreter.prototype.onDone = function(listener) {
            this.doneListeners.add(listener);
            return this;
        };
        Interpreter.prototype.off = function(listener) {
            this.listeners.delete(listener);
            this.eventListeners.delete(listener);
            this.sendListeners.delete(listener);
            this.stopListeners.delete(listener);
            this.doneListeners.delete(listener);
            this.contextListeners.delete(listener);
            return this;
        };
        Interpreter.prototype.start = function(initialState) {
            var _this = this;
            if (this.status === $d48a35febbc26761$export$7a567c9c5088a551.Running) return this;
            (0, (0, parcelRequire("1IMXT")).registry).register(this.sessionId, this);
            this.initialized = true;
            this.status = $d48a35febbc26761$export$7a567c9c5088a551.Running;
            var resolvedState = initialState === undefined ? this.initialState : (0, (0, parcelRequire("6Z4UF")).provide)(this, function() {
                return (0, (0, parcelRequire("krWBq")).isState)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, (0, parcelRequire("krWBq")).State).from(initialState, _this.machine.context));
            });
            if (this.options.devTools) this.attachDev();
            this.scheduler.initialize(function() {
                _this.update(resolvedState, (0, (0, parcelRequire("g2PT9")).initEvent));
            });
            return this;
        };
        Interpreter.prototype.stop = function() {
            var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
            var _this = this;
            try {
                for(var _f = (0, (0, parcelRequire("dkU7z")).__values)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                    var listener = _g.value;
                    this.listeners.delete(listener);
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
            try {
                for(var _h = (0, (0, parcelRequire("dkU7z")).__values)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                    var listener = _j.value;
                    listener();
                    this.stopListeners.delete(listener);
                }
            } catch (e_7_1) {
                e_7 = {
                    error: e_7_1
                };
            } finally{
                try {
                    if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                } finally{
                    if (e_7) throw e_7.error;
                }
            }
            try {
                for(var _k = (0, (0, parcelRequire("dkU7z")).__values)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                    var listener = _l.value;
                    this.contextListeners.delete(listener);
                }
            } catch (e_8_1) {
                e_8 = {
                    error: e_8_1
                };
            } finally{
                try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                } finally{
                    if (e_8) throw e_8.error;
                }
            }
            try {
                for(var _m = (0, (0, parcelRequire("dkU7z")).__values)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                    var listener = _o.value;
                    this.doneListeners.delete(listener);
                }
            } catch (e_9_1) {
                e_9 = {
                    error: e_9_1
                };
            } finally{
                try {
                    if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                } finally{
                    if (e_9) throw e_9.error;
                }
            }
            if (!this.initialized) return this;
            this.state.configuration.forEach(function(stateNode) {
                var e_11, _a;
                try {
                    for(var _b = (0, (0, parcelRequire("dkU7z")).__values)(stateNode.definition.exit), _c = _b.next(); !_c.done; _c = _b.next()){
                        var action = _c.value;
                        _this.exec(action, _this.state);
                    }
                } catch (e_11_1) {
                    e_11 = {
                        error: e_11_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_11) throw e_11.error;
                    }
                }
            });
            this.children.forEach(function(child) {
                if ((0, (0, parcelRequire("kUFUe")).isFunction)(child.stop)) child.stop();
            });
            try {
                for(var _p = (0, (0, parcelRequire("dkU7z")).__values)((0, (0, parcelRequire("kUFUe")).keys)(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                    var key = _q.value;
                    this.clock.clearTimeout(this.delayedEventsMap[key]);
                }
            } catch (e_10_1) {
                e_10 = {
                    error: e_10_1
                };
            } finally{
                try {
                    if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                } finally{
                    if (e_10) throw e_10.error;
                }
            }
            this.scheduler.clear();
            this.initialized = false;
            this.status = $d48a35febbc26761$export$7a567c9c5088a551.Stopped;
            (0, (0, parcelRequire("1IMXT")).registry).free(this.sessionId);
            return this;
        };
        Interpreter.prototype.batch = function(events) {
            var _this = this;
            if (this.status === $d48a35febbc26761$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) {
                if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, events.length + " event(s) were sent to uninitialized service \"" + this.machine.id + "\" and are deferred. Make sure .start() is called for this service.\nEvent: " + JSON.stringify(event));
            } else if (this.status !== $d48a35febbc26761$export$7a567c9c5088a551.Running) throw new Error(events.length + " event(s) were sent to uninitialized service \"" + this.machine.id + "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.");
            this.scheduler.schedule(function() {
                var e_12, _a;
                var nextState = _this.state;
                var batchChanged = false;
                var batchedActions = [];
                var _loop_1 = function(event_1) {
                    var _event = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(event_1);
                    _this.forward(_event);
                    nextState = (0, (0, parcelRequire("6Z4UF")).provide)(_this, function() {
                        return _this.machine.transition(nextState, _event);
                    });
                    batchedActions.push.apply(batchedActions, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(nextState.actions.map(function(a) {
                        return (0, (0, parcelRequire("krWBq")).bindActionToState)(a, nextState);
                    }))));
                    batchChanged = batchChanged || !!nextState.changed;
                };
                try {
                    for(var events_1 = (0, (0, parcelRequire("dkU7z")).__values)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                        var event_1 = events_1_1.value;
                        _loop_1(event_1);
                    }
                } catch (e_12_1) {
                    e_12 = {
                        error: e_12_1
                    };
                } finally{
                    try {
                        if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                    } finally{
                        if (e_12) throw e_12.error;
                    }
                }
                nextState.changed = batchChanged;
                nextState.actions = batchedActions;
                _this.update(nextState, (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(events[events.length - 1]));
            });
        };
        Interpreter.prototype.sender = function(event1) {
            return this.send.bind(this, event1);
        };
        Interpreter.prototype.nextState = function(event1) {
            var _this = this;
            var _event = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(event1);
            if (_event.name.indexOf((0, (0, parcelRequire("knNkr")).errorPlatform)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
                return nextEvent.indexOf((0, (0, parcelRequire("knNkr")).errorPlatform)) === 0;
            })) throw _event.data.data;
            var nextState = (0, (0, parcelRequire("6Z4UF")).provide)(this, function() {
                return _this.machine.transition(_this.state, _event);
            });
            return nextState;
        };
        Interpreter.prototype.forward = function(event1) {
            var e_13, _a;
            try {
                for(var _b = (0, (0, parcelRequire("dkU7z")).__values)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                    var id = _c.value;
                    var child = this.children.get(id);
                    if (!child) throw new Error("Unable to forward event '" + event1 + "' from interpreter '" + this.id + "' to nonexistant child '" + id + "'.");
                    child.send(event1);
                }
            } catch (e_13_1) {
                e_13 = {
                    error: e_13_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_13) throw e_13.error;
                }
            }
        };
        Interpreter.prototype.defer = function(sendAction) {
            var _this = this;
            this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function() {
                if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to);
                else _this.send(sendAction._event);
            }, sendAction.delay);
        };
        Interpreter.prototype.cancel = function(sendId) {
            this.clock.clearTimeout(this.delayedEventsMap[sendId]);
            delete this.delayedEventsMap[sendId];
        };
        Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
            if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
            var context = state.context, _event = state._event;
            var actionOrExec = action.exec || (0, (0, parcelRequire("g2PT9")).getActionFunction)(action.type, actionFunctionMap);
            var exec = (0, (0, parcelRequire("kUFUe")).isFunction)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
            if (exec) try {
                return exec(context, _event.data, {
                    action: action,
                    state: this.state,
                    _event: _event
                });
            } catch (err) {
                if (this.parent) this.parent.send({
                    type: 'xstate.error',
                    data: err
                });
                throw err;
            }
            switch(action.type){
                case 0, (0, parcelRequire("knNkr")).send:
                    var sendAction = action;
                    if (typeof sendAction.delay === 'number') {
                        this.defer(sendAction);
                        return;
                    } else if (sendAction.to) this.sendTo(sendAction._event, sendAction.to);
                    else this.send(sendAction._event);
                    break;
                case 0, (0, parcelRequire("knNkr")).cancel:
                    this.cancel(action.sendId);
                    break;
                case 0, (0, parcelRequire("knNkr")).start:
                    var activity = action.activity;
                    if (!this.state.activities[activity.id || activity.type]) break;
                    if (activity.type === (0, (0, parcelRequire("1G4Gq")).ActionTypes).Invoke) {
                        var invokeSource = (0, (0, parcelRequire("kUFUe")).toInvokeSource)(activity.src);
                        var serviceCreator = this.machine.options.services ? this.machine.options.services[invokeSource.type] : undefined;
                        var id = activity.id, data = activity.data;
                        if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(!('forward' in activity), "`forward` property is deprecated (found in invocation of '" + activity.src + "' in in machine '" + this.machine.id + "'). " + "Please use `autoForward` instead.");
                        var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;
                        if (!serviceCreator) {
                            if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "No service found for invocation '" + activity.src + "' in machine '" + this.machine.id + "'.");
                            return;
                        }
                        var resolvedData = data ? (0, (0, parcelRequire("kUFUe")).mapContext)(data, context, _event) : undefined;
                        var source = (0, (0, parcelRequire("kUFUe")).isFunction)(serviceCreator) ? serviceCreator(context, _event.data, {
                            data: resolvedData,
                            src: invokeSource
                        }) : serviceCreator;
                        if ((0, (0, parcelRequire("kUFUe")).isPromiseLike)(source)) this.spawnPromise(Promise.resolve(source), id);
                        else if ((0, (0, parcelRequire("kUFUe")).isFunction)(source)) this.spawnCallback(source, id);
                        else if ((0, (0, parcelRequire("kUFUe")).isObservable)(source)) this.spawnObservable(source, id);
                        else if ((0, (0, parcelRequire("kUFUe")).isMachine)(source)) this.spawnMachine(resolvedData ? source.withContext(resolvedData) : source, {
                            id: id,
                            autoForward: autoForward
                        });
                    } else this.spawnActivity(activity);
                    break;
                case 0, (0, parcelRequire("knNkr")).stop:
                    this.stopChild(action.activity.id);
                    break;
                case 0, (0, parcelRequire("knNkr")).log:
                    var label = action.label, value = action.value;
                    if (label) this.logger(label, value);
                    else this.logger(value);
                    break;
                default:
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "No implementation found for action type '" + action.type + "'");
                    break;
            }
            return undefined;
        };
        Interpreter.prototype.removeChild = function(childId) {
            this.children.delete(childId);
            this.forwardTo.delete(childId);
            delete this.state.children[childId];
        };
        Interpreter.prototype.stopChild = function(childId) {
            var child = this.children.get(childId);
            if (!child) return;
            this.removeChild(childId);
            if ((0, (0, parcelRequire("kUFUe")).isFunction)(child.stop)) child.stop();
        };
        Interpreter.prototype.spawn = function(entity, name, options) {
            if ((0, (0, parcelRequire("kUFUe")).isPromiseLike)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
            else if ((0, (0, parcelRequire("kUFUe")).isFunction)(entity)) return this.spawnCallback(entity, name);
            else if ((0, (0, parcelRequire("1FBh2")).isSpawnedActor)(entity)) return this.spawnActor(entity);
            else if ((0, (0, parcelRequire("kUFUe")).isObservable)(entity)) return this.spawnObservable(entity, name);
            else if ((0, (0, parcelRequire("kUFUe")).isMachine)(entity)) return this.spawnMachine(entity, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, options), {
                id: name
            }));
            else throw new Error("Unable to spawn entity \"" + name + "\" of type \"" + typeof entity + "\".");
        };
        Interpreter.prototype.spawnMachine = function(machine, options) {
            var _this = this;
            if (options === void 0) options = {};
            var childService = new Interpreter(machine, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, this.options), {
                parent: this,
                id: options.id || machine.id
            }));
            var resolvedOptions = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, $d48a35febbc26761$var$DEFAULT_SPAWN_OPTIONS), options);
            if (resolvedOptions.sync) childService.onTransition(function(state) {
                _this.send((0, (0, parcelRequire("knNkr")).update), {
                    state: state,
                    id: childService.id
                });
            });
            var actor = childService;
            this.children.set(childService.id, actor);
            if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
            childService.onDone(function(doneEvent) {
                _this.removeChild(childService.id);
                _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(doneEvent, {
                    origin: childService.id
                }));
            }).start();
            return actor;
        };
        Interpreter.prototype.spawnPromise = function(promise, id) {
            var _this = this;
            var canceled = false;
            var resolvedData = undefined;
            promise.then(function(response) {
                if (!canceled) {
                    resolvedData = response;
                    _this.removeChild(id);
                    _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)((0, (0, parcelRequire("g2PT9")).doneInvoke)(id, response), {
                        origin: id
                    }));
                }
            }, function(errorData) {
                if (!canceled) {
                    _this.removeChild(id);
                    var errorEvent = (0, (0, parcelRequire("g2PT9")).error)(id, errorData);
                    try {
                        _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(errorEvent, {
                            origin: id
                        }));
                    } catch (error) {
                        (0, (0, parcelRequire("kUFUe")).reportUnhandledExceptionOnInvocation)(errorData, error, id);
                        if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                        if (_this.machine.strict) _this.stop();
                    }
                }
            });
            var actor = {
                id: id,
                send: function() {
                    return void 0;
                },
                subscribe: function(next, handleError, complete) {
                    var observer = (0, (0, parcelRequire("kUFUe")).toObserver)(next, handleError, complete);
                    var unsubscribed = false;
                    promise.then(function(response) {
                        if (unsubscribed) return;
                        observer.next(response);
                        if (unsubscribed) return;
                        observer.complete();
                    }, function(err) {
                        if (unsubscribed) return;
                        observer.error(err);
                    });
                    return {
                        unsubscribe: function() {
                            return unsubscribed = true;
                        }
                    };
                },
                stop: function() {
                    canceled = true;
                },
                toJSON: function() {
                    return {
                        id: id
                    };
                },
                getSnapshot: function() {
                    return resolvedData;
                }
            };
            this.children.set(id, actor);
            return actor;
        };
        Interpreter.prototype.spawnCallback = function(callback, id) {
            var _this = this;
            var canceled = false;
            var receivers = new Set();
            var listeners = new Set();
            var emitted = undefined;
            var receive = function(e) {
                emitted = e;
                listeners.forEach(function(listener) {
                    return listener(e);
                });
                if (canceled) return;
                _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(e, {
                    origin: id
                }));
            };
            var callbackStop;
            try {
                callbackStop = callback(receive, function(newListener) {
                    receivers.add(newListener);
                });
            } catch (err) {
                this.send((0, (0, parcelRequire("g2PT9")).error)(id, err));
            }
            if ((0, (0, parcelRequire("kUFUe")).isPromiseLike)(callbackStop)) return this.spawnPromise(callbackStop, id);
            var actor = {
                id: id,
                send: function(event1) {
                    return receivers.forEach(function(receiver) {
                        return receiver(event1);
                    });
                },
                subscribe: function(next) {
                    listeners.add(next);
                    return {
                        unsubscribe: function() {
                            listeners.delete(next);
                        }
                    };
                },
                stop: function() {
                    canceled = true;
                    if ((0, (0, parcelRequire("kUFUe")).isFunction)(callbackStop)) callbackStop();
                },
                toJSON: function() {
                    return {
                        id: id
                    };
                },
                getSnapshot: function() {
                    return emitted;
                }
            };
            this.children.set(id, actor);
            return actor;
        };
        Interpreter.prototype.spawnObservable = function(source, id) {
            var _this = this;
            var emitted = undefined;
            var subscription = source.subscribe(function(value) {
                emitted = value;
                _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(value, {
                    origin: id
                }));
            }, function(err) {
                _this.removeChild(id);
                _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)((0, (0, parcelRequire("g2PT9")).error)(id, err), {
                    origin: id
                }));
            }, function() {
                _this.removeChild(id);
                _this.send((0, (0, parcelRequire("kUFUe")).toSCXMLEvent)((0, (0, parcelRequire("g2PT9")).doneInvoke)(id), {
                    origin: id
                }));
            });
            var actor = {
                id: id,
                send: function() {
                    return void 0;
                },
                subscribe: function(next, handleError, complete) {
                    return source.subscribe(next, handleError, complete);
                },
                stop: function() {
                    return subscription.unsubscribe();
                },
                getSnapshot: function() {
                    return emitted;
                },
                toJSON: function() {
                    return {
                        id: id
                    };
                }
            };
            this.children.set(id, actor);
            return actor;
        };
        Interpreter.prototype.spawnActor = function(actor) {
            this.children.set(actor.id, actor);
            return actor;
        };
        Interpreter.prototype.spawnActivity = function(activity) {
            var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
            if (!implementation) {
                if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "No implementation found for activity '" + activity.type + "'");
                return;
            }
            var dispose = implementation(this.state.context, activity);
            this.spawnEffect(activity.id, dispose);
        };
        Interpreter.prototype.spawnEffect = function(id, dispose) {
            this.children.set(id, {
                id: id,
                send: function() {
                    return void 0;
                },
                subscribe: function() {
                    return {
                        unsubscribe: function() {
                            return void 0;
                        }
                    };
                },
                stop: dispose || undefined,
                getSnapshot: function() {
                    return undefined;
                },
                toJSON: function() {
                    return {
                        id: id
                    };
                }
            });
        };
        Interpreter.prototype.attachDev = function() {
            var global1 = (0, (0, parcelRequire("b4ajb")).getGlobal)();
            if (this.options.devTools && global1) {
                if (global1.__REDUX_DEVTOOLS_EXTENSION__) {
                    var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
                    this.devTools = global1.__REDUX_DEVTOOLS_EXTENSION__.connect((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({
                        name: this.id,
                        autoPause: true,
                        stateSanitizer: function(state) {
                            return {
                                value: state.value,
                                context: state.context,
                                actions: state.actions
                            };
                        }
                    }, devToolsOptions), {
                        features: (0, (0, parcelRequire("dkU7z")).__assign)({
                            jump: false,
                            skip: false
                        }, devToolsOptions ? devToolsOptions.features : undefined)
                    }), this.machine);
                    this.devTools.init(this.state);
                }
                (0, (0, parcelRequire("b4ajb")).registerService)(this);
            }
        };
        Interpreter.prototype.toJSON = function() {
            return {
                id: this.id
            };
        };
        Interpreter.prototype[0, (0, parcelRequire("kUFUe")).symbolObservable] = function() {
            return this;
        };
        Interpreter.prototype.getSnapshot = function() {
            return this._state;
        };
        Interpreter.defaultOptions = function(global1) {
            return {
                execute: true,
                deferEvents: true,
                clock: {
                    setTimeout: function(fn, ms) {
                        return setTimeout(fn, ms);
                    },
                    clearTimeout: function(id) {
                        return clearTimeout(id);
                    }
                },
                logger: global1.console.log.bind(console),
                devTools: false
            };
        }(typeof self !== 'undefined' ? self : $parcel$global);
        Interpreter.interpret = $d48a35febbc26761$export$67beed298888a38b;
        return Interpreter;
    }();
    var $d48a35febbc26761$var$resolveSpawnOptions = function(nameOrOptions) {
        if ((0, (0, parcelRequire("kUFUe")).isString)(nameOrOptions)) return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, $d48a35febbc26761$var$DEFAULT_SPAWN_OPTIONS), {
            name: nameOrOptions
        });
        return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, $d48a35febbc26761$var$DEFAULT_SPAWN_OPTIONS), {
            name: (0, (0, parcelRequire("kUFUe")).uniqueId)()
        }), nameOrOptions);
    };
    function $d48a35febbc26761$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
        var resolvedOptions = $d48a35febbc26761$var$resolveSpawnOptions(nameOrOptions);
        return (0, (0, parcelRequire("6Z4UF")).consume)(function(service) {
            if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) {
                var isLazyEntity = (0, (0, parcelRequire("kUFUe")).isMachine)(entity) || (0, (0, parcelRequire("kUFUe")).isFunction)(entity);
                (0, (0, parcelRequire("kUFUe")).warn)(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"" + ((0, (0, parcelRequire("kUFUe")).isMachine)(entity) ? entity.id : 'undefined') + "\") outside of a service. This will have no effect.");
            }
            if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
            else return (0, (0, parcelRequire("1FBh2")).createDeferredActor)(entity, resolvedOptions.name);
        });
    }
    function $d48a35febbc26761$export$67beed298888a38b(machine, options) {
        var interpreter = new $d48a35febbc26761$export$e5b52c46a548ff03(machine, options);
        return interpreter;
    }
});
parcelRegister("dkU7z", function(module, exports) {
    $parcel$export(module.exports, "__assign", ()=>$9b58ad14ac16f076$export$18ce0697a983be9b);
    $parcel$export(module.exports, "__rest", ()=>$9b58ad14ac16f076$export$3c9a16f847548506);
    $parcel$export(module.exports, "__values", ()=>$9b58ad14ac16f076$export$19a8beecd37a4c45);
    $parcel$export(module.exports, "__read", ()=>$9b58ad14ac16f076$export$8d051b38c9118094);
    $parcel$export(module.exports, "__spreadArray", ()=>$9b58ad14ac16f076$export$1216008129fb82ed);
    var $9b58ad14ac16f076$export$18ce0697a983be9b = function() {
        $9b58ad14ac16f076$export$18ce0697a983be9b = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $9b58ad14ac16f076$export$18ce0697a983be9b.apply(this, arguments);
    };
    function $9b58ad14ac16f076$export$3c9a16f847548506(s, e) {
        var t = {};
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") {
            for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
        return t;
    }
    function $9b58ad14ac16f076$export$19a8beecd37a4c45(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }
    function $9b58ad14ac16f076$export$8d051b38c9118094(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    }
    function $9b58ad14ac16f076$export$1216008129fb82ed(to, from) {
        for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
        return to;
    }
});
parcelRegister("lnGwo", function(module, exports) {
    $parcel$export(module.exports, "IS_PRODUCTION", ()=>$f90cbad810046090$export$9b5f2e1c20ef6571);
    var $f90cbad810046090$export$9b5f2e1c20ef6571 = true;
});
parcelRegister("kUFUe", function(module, exports) {
    $parcel$export(module.exports, "keys", ()=>$f3998b42099b2488$export$ed97f33186d4b816);
    $parcel$export(module.exports, "matchesState", ()=>$f3998b42099b2488$export$2870710bf0eac88e);
    $parcel$export(module.exports, "toStateValue", ()=>$f3998b42099b2488$export$fb3aecd1d93744e3);
    $parcel$export(module.exports, "isString", ()=>$f3998b42099b2488$export$844ec244b1367d54);
    $parcel$export(module.exports, "getEventType", ()=>$f3998b42099b2488$export$7193fc8c8cd445e9);
    $parcel$export(module.exports, "toStatePath", ()=>$f3998b42099b2488$export$304cde62ecda7af8);
    $parcel$export(module.exports, "isArray", ()=>$f3998b42099b2488$export$43bee75e5e14138e);
    $parcel$export(module.exports, "pathToStateValue", ()=>$f3998b42099b2488$export$f2ee84fc53c45e74);
    $parcel$export(module.exports, "mapValues", ()=>$f3998b42099b2488$export$825e789796ab7275);
    $parcel$export(module.exports, "mapFilterValues", ()=>$f3998b42099b2488$export$2d4204fe9b34204e);
    $parcel$export(module.exports, "path", ()=>$f3998b42099b2488$export$bb654e07daaf8c3a);
    $parcel$export(module.exports, "nestedPath", ()=>$f3998b42099b2488$export$314d0a1a7c835392);
    $parcel$export(module.exports, "toStatePaths", ()=>$f3998b42099b2488$export$a2618e9e89698dd6);
    $parcel$export(module.exports, "flatten", ()=>$f3998b42099b2488$export$bffa455ba8c619a6);
    $parcel$export(module.exports, "toArray", ()=>$f3998b42099b2488$export$45b10814cc054894);
    $parcel$export(module.exports, "mapContext", ()=>$f3998b42099b2488$export$e756e60189cc2351);
    $parcel$export(module.exports, "isFunction", ()=>$f3998b42099b2488$export$f6e2535fb5126e54);
    $parcel$export(module.exports, "isBuiltInEvent", ()=>$f3998b42099b2488$export$479b1b8942fd0b8d);
    $parcel$export(module.exports, "isPromiseLike", ()=>$f3998b42099b2488$export$ae936b9d47e5870e);
    $parcel$export(module.exports, "partition", ()=>$f3998b42099b2488$export$b29f828819edca8d);
    $parcel$export(module.exports, "updateHistoryValue", ()=>$f3998b42099b2488$export$240d7cdd99ccb95a);
    $parcel$export(module.exports, "updateContext", ()=>$f3998b42099b2488$export$d84706064a6e6c1c);
    $parcel$export(module.exports, "warn", ()=>$f3998b42099b2488$export$c106dd0671a0fc2d);
    $parcel$export(module.exports, "toGuard", ()=>$f3998b42099b2488$export$b0f5a08e0ca47933);
    $parcel$export(module.exports, "isObservable", ()=>$f3998b42099b2488$export$5cd057a6046189f9);
    $parcel$export(module.exports, "symbolObservable", ()=>$f3998b42099b2488$export$c45ebe72e3b2885);
    $parcel$export(module.exports, "isMachine", ()=>$f3998b42099b2488$export$2163e7903738b5df);
    $parcel$export(module.exports, "isActor", ()=>$f3998b42099b2488$export$e769f6913f14f1b7);
    $parcel$export(module.exports, "uniqueId", ()=>$f3998b42099b2488$export$8b15d37bc3f197d4);
    $parcel$export(module.exports, "toEventObject", ()=>$f3998b42099b2488$export$5a4ea50826a01d14);
    $parcel$export(module.exports, "toSCXMLEvent", ()=>$f3998b42099b2488$export$eaf22249b410f633);
    $parcel$export(module.exports, "toTransitionConfigArray", ()=>$f3998b42099b2488$export$3822a36ea084a4d5);
    $parcel$export(module.exports, "normalizeTarget", ()=>$f3998b42099b2488$export$2a4fe5c3c80e3288);
    $parcel$export(module.exports, "reportUnhandledExceptionOnInvocation", ()=>$f3998b42099b2488$export$b240b9b7a78b5f3e);
    $parcel$export(module.exports, "evaluateGuard", ()=>$f3998b42099b2488$export$91646ab912d254e8);
    $parcel$export(module.exports, "toInvokeSource", ()=>$f3998b42099b2488$export$436e852aa2feda95);
    $parcel$export(module.exports, "toObserver", ()=>$f3998b42099b2488$export$75b67481063f2f98);
    var $dkU7z;
    var $8AK2c;
    var $lnGwo;
    function $f3998b42099b2488$export$ed97f33186d4b816(value) {
        return Object.keys(value);
    }
    function $f3998b42099b2488$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
        if (delimiter === void 0) delimiter = (0, (0, parcelRequire("8AK2c")).STATE_DELIMITER);
        var parentStateValue = $f3998b42099b2488$export$fb3aecd1d93744e3(parentStateId, delimiter);
        var childStateValue = $f3998b42099b2488$export$fb3aecd1d93744e3(childStateId, delimiter);
        if ($f3998b42099b2488$export$844ec244b1367d54(childStateValue)) {
            if ($f3998b42099b2488$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
            return false;
        }
        if ($f3998b42099b2488$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
        return $f3998b42099b2488$export$ed97f33186d4b816(parentStateValue).every(function(key) {
            if (!(key in childStateValue)) return false;
            return $f3998b42099b2488$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
        });
    }
    function $f3998b42099b2488$export$7193fc8c8cd445e9(event) {
        try {
            return $f3998b42099b2488$export$844ec244b1367d54(event) || typeof event === 'number' ? "" + event : event.type;
        } catch (e) {
            throw new Error('Events must be strings or objects with a string event.type property.');
        }
    }
    function $f3998b42099b2488$export$304cde62ecda7af8(stateId, delimiter) {
        try {
            if ($f3998b42099b2488$export$43bee75e5e14138e(stateId)) return stateId;
            return stateId.toString().split(delimiter);
        } catch (e) {
            throw new Error("'" + stateId + "' is not a valid state path.");
        }
    }
    function $f3998b42099b2488$export$e080e3931a079c9b(state) {
        return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
    }
    function $f3998b42099b2488$export$fb3aecd1d93744e3(stateValue, delimiter) {
        if ($f3998b42099b2488$export$e080e3931a079c9b(stateValue)) return stateValue.value;
        if ($f3998b42099b2488$export$43bee75e5e14138e(stateValue)) return $f3998b42099b2488$export$f2ee84fc53c45e74(stateValue);
        if (typeof stateValue !== 'string') return stateValue;
        var statePath = $f3998b42099b2488$export$304cde62ecda7af8(stateValue, delimiter);
        return $f3998b42099b2488$export$f2ee84fc53c45e74(statePath);
    }
    function $f3998b42099b2488$export$f2ee84fc53c45e74(statePath) {
        if (statePath.length === 1) return statePath[0];
        var value = {};
        var marker = value;
        for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
        else {
            marker[statePath[i]] = {};
            marker = marker[statePath[i]];
        }
        return value;
    }
    function $f3998b42099b2488$export$825e789796ab7275(collection, iteratee) {
        var result = {};
        var collectionKeys = $f3998b42099b2488$export$ed97f33186d4b816(collection);
        for(var i = 0; i < collectionKeys.length; i++){
            var key = collectionKeys[i];
            result[key] = iteratee(collection[key], key, collection, i);
        }
        return result;
    }
    function $f3998b42099b2488$export$2d4204fe9b34204e(collection, iteratee, predicate) {
        var e_1, _a;
        var result = {};
        try {
            for(var _b = (0, (0, parcelRequire("dkU7z")).__values)($f3998b42099b2488$export$ed97f33186d4b816(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var item = collection[key];
                if (!predicate(item)) continue;
                result[key] = iteratee(item, key, collection);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    }
    var $f3998b42099b2488$export$bb654e07daaf8c3a = function(props) {
        return function(object) {
            var e_2, _a;
            var result = object;
            try {
                for(var props_1 = (0, (0, parcelRequire("dkU7z")).__values)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                    var prop = props_1_1.value;
                    result = result[prop];
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            return result;
        };
    };
    function $f3998b42099b2488$export$314d0a1a7c835392(props, accessorProp) {
        return function(object) {
            var e_3, _a;
            var result = object;
            try {
                for(var props_2 = (0, (0, parcelRequire("dkU7z")).__values)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                    var prop = props_2_1.value;
                    result = result[accessorProp][prop];
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            return result;
        };
    }
    function $f3998b42099b2488$export$a2618e9e89698dd6(stateValue) {
        if (!stateValue) return [
            []
        ];
        if ($f3998b42099b2488$export$844ec244b1367d54(stateValue)) return [
            [
                stateValue
            ]
        ];
        var result = $f3998b42099b2488$export$bffa455ba8c619a6($f3998b42099b2488$export$ed97f33186d4b816(stateValue).map(function(key) {
            var subStateValue = stateValue[key];
            if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
                [
                    key
                ]
            ];
            return $f3998b42099b2488$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
                return [
                    key
                ].concat(subPath);
            });
        }));
        return result;
    }
    function $f3998b42099b2488$export$bffa455ba8c619a6(array) {
        var _a;
        return (_a = []).concat.apply(_a, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(array)));
    }
    function $f3998b42099b2488$export$2c0b6b2f4faf21e1(value) {
        if ($f3998b42099b2488$export$43bee75e5e14138e(value)) return value;
        return [
            value
        ];
    }
    function $f3998b42099b2488$export$45b10814cc054894(value) {
        if (value === undefined) return [];
        return $f3998b42099b2488$export$2c0b6b2f4faf21e1(value);
    }
    function $f3998b42099b2488$export$e756e60189cc2351(mapper, context, _event) {
        var e_5, _a;
        if ($f3998b42099b2488$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
        var result = {};
        try {
            for(var _b = (0, (0, parcelRequire("dkU7z")).__values)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var subMapper = mapper[key];
                if ($f3998b42099b2488$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
                else result[key] = subMapper;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return result;
    }
    function $f3998b42099b2488$export$479b1b8942fd0b8d(eventType) {
        return /^(done|error)\./.test(eventType);
    }
    function $f3998b42099b2488$export$ae936b9d47e5870e(value) {
        if (value instanceof Promise) return true;
        if (value !== null && ($f3998b42099b2488$export$f6e2535fb5126e54(value) || typeof value === 'object') && $f3998b42099b2488$export$f6e2535fb5126e54(value.then)) return true;
        return false;
    }
    function $f3998b42099b2488$export$b29f828819edca8d(items, predicate) {
        var e_6, _a;
        var _b = (0, (0, parcelRequire("dkU7z")).__read)([
            [],
            []
        ], 2), truthy = _b[0], falsy = _b[1];
        try {
            for(var items_1 = (0, (0, parcelRequire("dkU7z")).__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                var item = items_1_1.value;
                if (predicate(item)) truthy.push(item);
                else falsy.push(item);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return [
            truthy,
            falsy
        ];
    }
    function $f3998b42099b2488$export$3737909a0074eb1(hist, stateValue) {
        return $f3998b42099b2488$export$825e789796ab7275(hist.states, function(subHist, key) {
            if (!subHist) return undefined;
            var subStateValue = ($f3998b42099b2488$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
            if (!subStateValue) return undefined;
            return {
                current: subStateValue,
                states: $f3998b42099b2488$export$3737909a0074eb1(subHist, subStateValue)
            };
        });
    }
    function $f3998b42099b2488$export$240d7cdd99ccb95a(hist, stateValue) {
        return {
            current: stateValue,
            states: $f3998b42099b2488$export$3737909a0074eb1(hist, stateValue)
        };
    }
    function $f3998b42099b2488$export$d84706064a6e6c1c(context, _event, assignActions, state) {
        if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) $f3998b42099b2488$export$c106dd0671a0fc2d(!!context, 'Attempting to update undefined context');
        var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
            var e_7, _a;
            var assignment = assignAction.assignment;
            var meta = {
                state: state,
                action: assignAction,
                _event: _event
            };
            var partialUpdate = {};
            if ($f3998b42099b2488$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
            else try {
                for(var _b = (0, (0, parcelRequire("dkU7z")).__values)($f3998b42099b2488$export$ed97f33186d4b816(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var key = _c.value;
                    var propAssignment = assignment[key];
                    partialUpdate[key] = $f3998b42099b2488$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
                }
            } catch (e_7_1) {
                e_7 = {
                    error: e_7_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_7) throw e_7.error;
                }
            }
            return Object.assign({}, acc, partialUpdate);
        }, context) : context;
        return updatedContext;
    }
    var $f3998b42099b2488$export$c106dd0671a0fc2d = function() {};
    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) $f3998b42099b2488$export$c106dd0671a0fc2d = function(condition, message) {
        var error = condition instanceof Error ? condition : undefined;
        if (!error && condition) return;
        if (console !== undefined) {
            var args = [
                "Warning: " + message
            ];
            if (error) args.push(error);
            console.warn.apply(console, args);
        }
    };
    function $f3998b42099b2488$export$43bee75e5e14138e(value) {
        return Array.isArray(value);
    }
    function $f3998b42099b2488$export$f6e2535fb5126e54(value) {
        return typeof value === 'function';
    }
    function $f3998b42099b2488$export$844ec244b1367d54(value) {
        return typeof value === 'string';
    }
    function $f3998b42099b2488$export$b0f5a08e0ca47933(condition, guardMap) {
        if (!condition) return undefined;
        if ($f3998b42099b2488$export$844ec244b1367d54(condition)) return {
            type: (0, (0, parcelRequire("8AK2c")).DEFAULT_GUARD_TYPE),
            name: condition,
            predicate: guardMap ? guardMap[condition] : undefined
        };
        if ($f3998b42099b2488$export$f6e2535fb5126e54(condition)) return {
            type: (0, (0, parcelRequire("8AK2c")).DEFAULT_GUARD_TYPE),
            name: condition.name,
            predicate: condition
        };
        return condition;
    }
    function $f3998b42099b2488$export$5cd057a6046189f9(value) {
        try {
            return 'subscribe' in value && $f3998b42099b2488$export$f6e2535fb5126e54(value.subscribe);
        } catch (e) {
            return false;
        }
    }
    var $f3998b42099b2488$export$c45ebe72e3b2885 = function() {
        return typeof Symbol === 'function' && Symbol.observable || '@@observable';
    }();
    function $f3998b42099b2488$export$2163e7903738b5df(value) {
        try {
            return '__xstatenode' in value;
        } catch (e) {
            return false;
        }
    }
    function $f3998b42099b2488$export$e769f6913f14f1b7(value) {
        return !!value && typeof value.send === 'function';
    }
    var $f3998b42099b2488$export$8b15d37bc3f197d4 = function() {
        var currentId = 0;
        return function() {
            currentId++;
            return currentId.toString(16);
        };
    }();
    function $f3998b42099b2488$export$5a4ea50826a01d14(event, payload) {
        if ($f3998b42099b2488$export$844ec244b1367d54(event) || typeof event === 'number') return (0, (0, parcelRequire("dkU7z")).__assign)({
            type: event
        }, payload);
        return event;
    }
    function $f3998b42099b2488$export$eaf22249b410f633(event, scxmlEvent) {
        if (!$f3998b42099b2488$export$844ec244b1367d54(event) && '$$type' in event && event.$$type === 'scxml') return event;
        var eventObject = $f3998b42099b2488$export$5a4ea50826a01d14(event);
        return (0, (0, parcelRequire("dkU7z")).__assign)({
            name: eventObject.type,
            data: eventObject,
            $$type: 'scxml',
            type: 'external'
        }, scxmlEvent);
    }
    function $f3998b42099b2488$export$3822a36ea084a4d5(event, configLike) {
        var transitions = $f3998b42099b2488$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
            if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $f3998b42099b2488$export$2163e7903738b5df(transitionLike)) return {
                target: transitionLike,
                event: event
            };
            return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, transitionLike), {
                event: event
            });
        });
        return transitions;
    }
    function $f3998b42099b2488$export$2a4fe5c3c80e3288(target) {
        if (target === undefined || target === (0, (0, parcelRequire("8AK2c")).TARGETLESS_KEY)) return undefined;
        return $f3998b42099b2488$export$45b10814cc054894(target);
    }
    function $f3998b42099b2488$export$b240b9b7a78b5f3e(originalError, currentError, id) {
        if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) {
            var originalStackTrace = originalError.stack ? " Stacktrace was '" + originalError.stack + "'" : '';
            if (originalError === currentError) console.error("Missing onError handler for invocation '" + id + "', error was '" + originalError + "'." + originalStackTrace);
            else {
                var stackTrace = currentError.stack ? " Stacktrace was '" + currentError.stack + "'" : '';
                console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '" + id + "'. " + ("Original error: '" + originalError + "'. " + originalStackTrace + " Current error is '" + currentError + "'." + stackTrace));
            }
        }
    }
    function $f3998b42099b2488$export$91646ab912d254e8(machine, guard, context, _event, state) {
        var guards = machine.options.guards;
        var guardMeta = {
            state: state,
            cond: guard,
            _event: _event
        };
        if (guard.type === (0, (0, parcelRequire("8AK2c")).DEFAULT_GUARD_TYPE)) return guard.predicate(context, _event.data, guardMeta);
        var condFn = guards[guard.type];
        if (!condFn) throw new Error("Guard '" + guard.type + "' is not implemented on machine '" + machine.id + "'.");
        return condFn(context, _event.data, guardMeta);
    }
    function $f3998b42099b2488$export$436e852aa2feda95(src) {
        if (typeof src === 'string') return {
            type: src
        };
        return src;
    }
    function $f3998b42099b2488$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
        if (typeof nextHandler === 'object') return nextHandler;
        var noop = function() {
            return void 0;
        };
        return {
            next: nextHandler,
            error: errorHandler || noop,
            complete: completionHandler || noop
        };
    }
});
parcelRegister("8AK2c", function(module, exports) {
    $parcel$export(module.exports, "STATE_DELIMITER", ()=>$641564fe561c6e21$export$b060f3cec92ef5c9);
    $parcel$export(module.exports, "EMPTY_ACTIVITY_MAP", ()=>$641564fe561c6e21$export$505a390a702f4a23);
    $parcel$export(module.exports, "DEFAULT_GUARD_TYPE", ()=>$641564fe561c6e21$export$656461011b562379);
    $parcel$export(module.exports, "TARGETLESS_KEY", ()=>$641564fe561c6e21$export$31935b4577455331);
    var $641564fe561c6e21$export$b060f3cec92ef5c9 = '.';
    var $641564fe561c6e21$export$505a390a702f4a23 = {};
    var $641564fe561c6e21$export$656461011b562379 = 'xstate.guard';
    var $641564fe561c6e21$export$31935b4577455331 = '';
});
parcelRegister("1G4Gq", function(module, exports) {
    $parcel$export(module.exports, "ActionTypes", ()=>$138d58ab8801915b$export$1385d81a6c6bbcd4);
    $parcel$export(module.exports, "SpecialTargets", ()=>$138d58ab8801915b$export$79f5baa747fbdd45);
    var $138d58ab8801915b$export$1385d81a6c6bbcd4;
    (function(ActionTypes) {
        ActionTypes["Start"] = "xstate.start";
        ActionTypes["Stop"] = "xstate.stop";
        ActionTypes["Raise"] = "xstate.raise";
        ActionTypes["Send"] = "xstate.send";
        ActionTypes["Cancel"] = "xstate.cancel";
        ActionTypes["NullEvent"] = "";
        ActionTypes["Assign"] = "xstate.assign";
        ActionTypes["After"] = "xstate.after";
        ActionTypes["DoneState"] = "done.state";
        ActionTypes["DoneInvoke"] = "done.invoke";
        ActionTypes["Log"] = "xstate.log";
        ActionTypes["Init"] = "xstate.init";
        ActionTypes["Invoke"] = "xstate.invoke";
        ActionTypes["ErrorExecution"] = "error.execution";
        ActionTypes["ErrorCommunication"] = "error.communication";
        ActionTypes["ErrorPlatform"] = "error.platform";
        ActionTypes["ErrorCustom"] = "xstate.error";
        ActionTypes["Update"] = "xstate.update";
        ActionTypes["Pure"] = "xstate.pure";
        ActionTypes["Choose"] = "xstate.choose";
    })($138d58ab8801915b$export$1385d81a6c6bbcd4 || ($138d58ab8801915b$export$1385d81a6c6bbcd4 = {}));
    var $138d58ab8801915b$export$79f5baa747fbdd45;
    (function(SpecialTargets) {
        SpecialTargets["Parent"] = "#_parent";
        SpecialTargets["Internal"] = "#_internal";
    })($138d58ab8801915b$export$79f5baa747fbdd45 || ($138d58ab8801915b$export$79f5baa747fbdd45 = {}));
});
parcelRegister("6Mwr3", function(module, exports) {
    $parcel$export(module.exports, "isLeafNode", ()=>$4f0062bda66b4d98$export$335db82b86111fd1);
    $parcel$export(module.exports, "getChildren", ()=>$4f0062bda66b4d98$export$f8cf48ee793b41be);
    $parcel$export(module.exports, "getAllStateNodes", ()=>$4f0062bda66b4d98$export$3de19bba299e3801);
    $parcel$export(module.exports, "getConfiguration", ()=>$4f0062bda66b4d98$export$3de01744a82b21a4);
    $parcel$export(module.exports, "getValue", ()=>$4f0062bda66b4d98$export$bf7199a9ebcb84a9);
    $parcel$export(module.exports, "has", ()=>$4f0062bda66b4d98$export$a4f4bb6b1453fff5);
    $parcel$export(module.exports, "nextEvents", ()=>$4f0062bda66b4d98$export$c661ab6895e3ed73);
    $parcel$export(module.exports, "isInFinalState", ()=>$4f0062bda66b4d98$export$cf3d5dae927fcf63);
    var $dkU7z;
    var $kUFUe;
    var $4f0062bda66b4d98$export$335db82b86111fd1 = function(stateNode) {
        return stateNode.type === 'atomic' || stateNode.type === 'final';
    };
    function $4f0062bda66b4d98$export$f8cf48ee793b41be(stateNode) {
        return (0, (0, parcelRequire("kUFUe")).keys)(stateNode.states).map(function(key) {
            return stateNode.states[key];
        });
    }
    function $4f0062bda66b4d98$export$3de19bba299e3801(stateNode) {
        var stateNodes = [
            stateNode
        ];
        if ($4f0062bda66b4d98$export$335db82b86111fd1(stateNode)) return stateNodes;
        return stateNodes.concat((0, (0, parcelRequire("kUFUe")).flatten)($4f0062bda66b4d98$export$f8cf48ee793b41be(stateNode).map($4f0062bda66b4d98$export$3de19bba299e3801)));
    }
    function $4f0062bda66b4d98$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        var prevConfiguration = new Set(prevStateNodes);
        var prevAdjList = $4f0062bda66b4d98$export$b837d8c2d0189d63(prevConfiguration);
        var configuration = new Set(stateNodes);
        try {
            for(var configuration_1 = (0, (0, parcelRequire("dkU7z")).__values)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
                var s = configuration_1_1.value;
                var m = s.parent;
                while(m && !configuration.has(m)){
                    configuration.add(m);
                    m = m.parent;
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var adjList = $4f0062bda66b4d98$export$b837d8c2d0189d63(configuration);
        try {
            for(var configuration_2 = (0, (0, parcelRequire("dkU7z")).__values)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
                var s = configuration_2_1.value;
                if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
                    if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                        return configuration.add(sn);
                    });
                    else s.initialStateNodes.forEach(function(sn) {
                        return configuration.add(sn);
                    });
                } else {
                    if (s.type === 'parallel') try {
                        for(var _e = (e_3 = void 0, (0, (0, parcelRequire("dkU7z")).__values)($4f0062bda66b4d98$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                            var child = _f.value;
                            if (child.type === 'history') continue;
                            if (!configuration.has(child)) {
                                configuration.add(child);
                                if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                    return configuration.add(sn);
                                });
                                else child.initialStateNodes.forEach(function(sn) {
                                    return configuration.add(sn);
                                });
                            }
                        }
                    } catch (e_3_1) {
                        e_3 = {
                            error: e_3_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                        } finally{
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var configuration_3 = (0, (0, parcelRequire("dkU7z")).__values)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
                var s = configuration_3_1.value;
                var m = s.parent;
                while(m && !configuration.has(m)){
                    configuration.add(m);
                    m = m.parent;
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return configuration;
    }
    function $4f0062bda66b4d98$var$getValueFromAdj(baseNode, adjList) {
        var childStateNodes = adjList.get(baseNode);
        if (!childStateNodes) return {};
        if (baseNode.type === 'compound') {
            var childStateNode = childStateNodes[0];
            if (childStateNode) {
                if ($4f0062bda66b4d98$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
            } else return {};
        }
        var stateValue = {};
        childStateNodes.forEach(function(csn) {
            stateValue[csn.key] = $4f0062bda66b4d98$var$getValueFromAdj(csn, adjList);
        });
        return stateValue;
    }
    function $4f0062bda66b4d98$export$b837d8c2d0189d63(configuration) {
        var e_5, _a;
        var adjList = new Map();
        try {
            for(var configuration_4 = (0, (0, parcelRequire("dkU7z")).__values)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
                var s = configuration_4_1.value;
                if (!adjList.has(s)) adjList.set(s, []);
                if (s.parent) {
                    if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                    adjList.get(s.parent).push(s);
                }
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return adjList;
    }
    function $4f0062bda66b4d98$export$bf7199a9ebcb84a9(rootNode, configuration) {
        var config = $4f0062bda66b4d98$export$3de01744a82b21a4([
            rootNode
        ], configuration);
        return $4f0062bda66b4d98$var$getValueFromAdj(rootNode, $4f0062bda66b4d98$export$b837d8c2d0189d63(config));
    }
    function $4f0062bda66b4d98$export$a4f4bb6b1453fff5(iterable, item) {
        if (Array.isArray(iterable)) return iterable.some(function(member) {
            return member === item;
        });
        if (iterable instanceof Set) return iterable.has(item);
        return false;
    }
    function $4f0062bda66b4d98$export$c661ab6895e3ed73(configuration) {
        return (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(new Set((0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(configuration.map(function(sn) {
            return sn.ownEvents;
        })))))));
    }
    function $4f0062bda66b4d98$export$cf3d5dae927fcf63(configuration, stateNode) {
        if (stateNode.type === 'compound') return $4f0062bda66b4d98$export$f8cf48ee793b41be(stateNode).some(function(s) {
            return s.type === 'final' && $4f0062bda66b4d98$export$a4f4bb6b1453fff5(configuration, s);
        });
        if (stateNode.type === 'parallel') return $4f0062bda66b4d98$export$f8cf48ee793b41be(stateNode).every(function(sn) {
            return $4f0062bda66b4d98$export$cf3d5dae927fcf63(configuration, sn);
        });
        return false;
    }
});
parcelRegister("knNkr", function(module, exports) {
    $parcel$export(module.exports, "start", ()=>$ed6c384bf3763af8$export$b3571188c770cc5a);
    $parcel$export(module.exports, "stop", ()=>$ed6c384bf3763af8$export$fa6813432f753b0d);
    $parcel$export(module.exports, "raise", ()=>$ed6c384bf3763af8$export$66313c302b2ea154);
    $parcel$export(module.exports, "send", ()=>$ed6c384bf3763af8$export$89db4734f6c919c4);
    $parcel$export(module.exports, "cancel", ()=>$ed6c384bf3763af8$export$70b61ad426ddbe54);
    $parcel$export(module.exports, "nullEvent", ()=>$ed6c384bf3763af8$export$9477ceca5dcd796a);
    $parcel$export(module.exports, "assign", ()=>$ed6c384bf3763af8$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "log", ()=>$ed6c384bf3763af8$export$bef1f36f5486a6a3);
    $parcel$export(module.exports, "init", ()=>$ed6c384bf3763af8$export$2cd8252107eb640b);
    $parcel$export(module.exports, "invoke", ()=>$ed6c384bf3763af8$export$468cda29b159ee5d);
    $parcel$export(module.exports, "errorPlatform", ()=>$ed6c384bf3763af8$export$503a23d0e5cd1226);
    $parcel$export(module.exports, "error", ()=>$ed6c384bf3763af8$export$a3bc9b8ed74fc);
    $parcel$export(module.exports, "update", ()=>$ed6c384bf3763af8$export$722fbec263ad908a);
    $parcel$export(module.exports, "choose", ()=>$ed6c384bf3763af8$export$7877a478dd30fd3d);
    $parcel$export(module.exports, "pure", ()=>$ed6c384bf3763af8$export$48ec4a2b1cfc6557);
    var $1G4Gq;
    var $ed6c384bf3763af8$export$b3571188c770cc5a = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Start;
    var $ed6c384bf3763af8$export$fa6813432f753b0d = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Stop;
    var $ed6c384bf3763af8$export$66313c302b2ea154 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Raise;
    var $ed6c384bf3763af8$export$89db4734f6c919c4 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Send;
    var $ed6c384bf3763af8$export$70b61ad426ddbe54 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Cancel;
    var $ed6c384bf3763af8$export$9477ceca5dcd796a = (0, (0, parcelRequire("1G4Gq")).ActionTypes).NullEvent;
    var $ed6c384bf3763af8$export$e6e34fd1f2686227 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Assign;
    var $ed6c384bf3763af8$export$742acabee3dd6465 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).After;
    var $ed6c384bf3763af8$export$de2557b5933c9ac6 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).DoneState;
    var $ed6c384bf3763af8$export$bef1f36f5486a6a3 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Log;
    var $ed6c384bf3763af8$export$2cd8252107eb640b = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Init;
    var $ed6c384bf3763af8$export$468cda29b159ee5d = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Invoke;
    var $ed6c384bf3763af8$export$aca059ee6fbf94e8 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).ErrorExecution;
    var $ed6c384bf3763af8$export$503a23d0e5cd1226 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).ErrorPlatform;
    var $ed6c384bf3763af8$export$a3bc9b8ed74fc = (0, (0, parcelRequire("1G4Gq")).ActionTypes).ErrorCustom;
    var $ed6c384bf3763af8$export$722fbec263ad908a = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Update;
    var $ed6c384bf3763af8$export$7877a478dd30fd3d = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Choose;
    var $ed6c384bf3763af8$export$48ec4a2b1cfc6557 = (0, (0, parcelRequire("1G4Gq")).ActionTypes).Pure;
});
parcelRegister("g2PT9", function(module, exports) {
    $parcel$export(module.exports, "initEvent", ()=>$bae51534fbcbd157$export$163c566c60ed2ec9);
    $parcel$export(module.exports, "getActionFunction", ()=>$bae51534fbcbd157$export$c7e5ca927bd4567);
    $parcel$export(module.exports, "toActionObject", ()=>$bae51534fbcbd157$export$b38b66cc2da3ede7);
    $parcel$export(module.exports, "toActionObjects", ()=>$bae51534fbcbd157$export$aa68691f32e6c459);
    $parcel$export(module.exports, "toActivityDefinition", ()=>$bae51534fbcbd157$export$e81fdd8937d44864);
    $parcel$export(module.exports, "raise", ()=>$bae51534fbcbd157$export$66313c302b2ea154);
    $parcel$export(module.exports, "send", ()=>$bae51534fbcbd157$export$89db4734f6c919c4);
    $parcel$export(module.exports, "sendParent", ()=>$bae51534fbcbd157$export$408d8d51fa351f53);
    $parcel$export(module.exports, "sendUpdate", ()=>$bae51534fbcbd157$export$7f8b724299523eb6);
    $parcel$export(module.exports, "respond", ()=>$bae51534fbcbd157$export$72b816ae90496f19);
    $parcel$export(module.exports, "log", ()=>$bae51534fbcbd157$export$bef1f36f5486a6a3);
    $parcel$export(module.exports, "cancel", ()=>$bae51534fbcbd157$export$70b61ad426ddbe54);
    $parcel$export(module.exports, "start", ()=>$bae51534fbcbd157$export$b3571188c770cc5a);
    $parcel$export(module.exports, "stop", ()=>$bae51534fbcbd157$export$fa6813432f753b0d);
    $parcel$export(module.exports, "assign", ()=>$bae51534fbcbd157$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "after", ()=>$bae51534fbcbd157$export$742acabee3dd6465);
    $parcel$export(module.exports, "done", ()=>$bae51534fbcbd157$export$3df11c9c20e7b288);
    $parcel$export(module.exports, "doneInvoke", ()=>$bae51534fbcbd157$export$c105e588793f70b4);
    $parcel$export(module.exports, "error", ()=>$bae51534fbcbd157$export$a3bc9b8ed74fc);
    $parcel$export(module.exports, "pure", ()=>$bae51534fbcbd157$export$48ec4a2b1cfc6557);
    $parcel$export(module.exports, "forwardTo", ()=>$bae51534fbcbd157$export$eb147b7589db8e8a);
    $parcel$export(module.exports, "escalate", ()=>$bae51534fbcbd157$export$f514678a4137c4d6);
    $parcel$export(module.exports, "choose", ()=>$bae51534fbcbd157$export$7877a478dd30fd3d);
    $parcel$export(module.exports, "resolveActions", ()=>$bae51534fbcbd157$export$b8b9e7ba5b8c7b3e);
    var $dkU7z;
    var $lnGwo;
    var $kUFUe;
    var $1G4Gq;
    var $knNkr;
    var $bae51534fbcbd157$export$163c566c60ed2ec9 = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)({
        type: (0, (0, parcelRequire("knNkr")).init)
    });
    function $bae51534fbcbd157$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
        return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
    }
    function $bae51534fbcbd157$export$b38b66cc2da3ede7(action, actionFunctionMap) {
        var actionObject;
        if ((0, (0, parcelRequire("kUFUe")).isString)(action) || typeof action === 'number') {
            var exec = $bae51534fbcbd157$export$c7e5ca927bd4567(action, actionFunctionMap);
            if ((0, (0, parcelRequire("kUFUe")).isFunction)(exec)) actionObject = {
                type: action,
                exec: exec
            };
            else if (exec) actionObject = exec;
            else actionObject = {
                type: action,
                exec: undefined
            };
        } else if ((0, (0, parcelRequire("kUFUe")).isFunction)(action)) actionObject = {
            type: action.name || action.toString(),
            exec: action
        };
        else {
            var exec = $bae51534fbcbd157$export$c7e5ca927bd4567(action.type, actionFunctionMap);
            if ((0, (0, parcelRequire("kUFUe")).isFunction)(exec)) actionObject = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, action), {
                exec: exec
            });
            else if (exec) {
                var actionType = exec.type || action.type;
                actionObject = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, exec), action), {
                    type: actionType
                });
            } else actionObject = action;
        }
        Object.defineProperty(actionObject, 'toString', {
            value: function() {
                return actionObject.type;
            },
            enumerable: false,
            configurable: true
        });
        return actionObject;
    }
    var $bae51534fbcbd157$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
        if (!action) return [];
        var actions = (0, (0, parcelRequire("kUFUe")).isArray)(action) ? action : [
            action
        ];
        return actions.map(function(subAction) {
            return $bae51534fbcbd157$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
        });
    };
    function $bae51534fbcbd157$export$e81fdd8937d44864(action) {
        var actionObject = $bae51534fbcbd157$export$b38b66cc2da3ede7(action);
        return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({
            id: (0, (0, parcelRequire("kUFUe")).isString)(action) ? action : actionObject.id
        }, actionObject), {
            type: actionObject.type
        });
    }
    function $bae51534fbcbd157$export$66313c302b2ea154(event) {
        if (!(0, (0, parcelRequire("kUFUe")).isString)(event)) return $bae51534fbcbd157$export$89db4734f6c919c4(event, {
            to: (0, (0, parcelRequire("1G4Gq")).SpecialTargets).Internal
        });
        return {
            type: (0, (0, parcelRequire("knNkr")).raise),
            event: event
        };
    }
    function $bae51534fbcbd157$export$ed3daf8e935ede01(action) {
        return {
            type: (0, (0, parcelRequire("knNkr")).raise),
            _event: (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(action.event)
        };
    }
    function $bae51534fbcbd157$export$89db4734f6c919c4(event, options) {
        return {
            to: options ? options.to : undefined,
            type: (0, (0, parcelRequire("knNkr")).send),
            event: (0, (0, parcelRequire("kUFUe")).isFunction)(event) ? event : (0, (0, parcelRequire("kUFUe")).toEventObject)(event),
            delay: options ? options.delay : undefined,
            id: options && options.id !== undefined ? options.id : (0, (0, parcelRequire("kUFUe")).isFunction)(event) ? event.name : (0, (0, parcelRequire("kUFUe")).getEventType)(event)
        };
    }
    function $bae51534fbcbd157$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
        var meta = {
            _event: _event
        };
        var resolvedEvent = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)((0, (0, parcelRequire("kUFUe")).isFunction)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
        var resolvedDelay;
        if ((0, (0, parcelRequire("kUFUe")).isString)(action.delay)) {
            var configDelay = delaysMap && delaysMap[action.delay];
            resolvedDelay = (0, (0, parcelRequire("kUFUe")).isFunction)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
        } else resolvedDelay = (0, (0, parcelRequire("kUFUe")).isFunction)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
        var resolvedTarget = (0, (0, parcelRequire("kUFUe")).isFunction)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
        return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, action), {
            to: resolvedTarget,
            _event: resolvedEvent,
            event: resolvedEvent.data,
            delay: resolvedDelay
        });
    }
    function $bae51534fbcbd157$export$408d8d51fa351f53(event, options) {
        return $bae51534fbcbd157$export$89db4734f6c919c4(event, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, options), {
            to: (0, (0, parcelRequire("1G4Gq")).SpecialTargets).Parent
        }));
    }
    function $bae51534fbcbd157$export$7f8b724299523eb6() {
        return $bae51534fbcbd157$export$408d8d51fa351f53((0, (0, parcelRequire("knNkr")).update));
    }
    function $bae51534fbcbd157$export$72b816ae90496f19(event, options) {
        return $bae51534fbcbd157$export$89db4734f6c919c4(event, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, options), {
            to: function(_, __, _a) {
                var _event = _a._event;
                return _event.origin;
            }
        }));
    }
    var $bae51534fbcbd157$var$defaultLogExpr = function(context, event) {
        return {
            context: context,
            event: event
        };
    };
    function $bae51534fbcbd157$export$bef1f36f5486a6a3(expr, label) {
        if (expr === void 0) expr = $bae51534fbcbd157$var$defaultLogExpr;
        return {
            type: (0, (0, parcelRequire("knNkr")).log),
            label: label,
            expr: expr
        };
    }
    var $bae51534fbcbd157$export$12cba28d36be4946 = function(action, ctx, _event) {
        return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, action), {
            value: (0, (0, parcelRequire("kUFUe")).isString)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
                _event: _event
            })
        });
    };
    var $bae51534fbcbd157$export$70b61ad426ddbe54 = function(sendId) {
        return {
            type: (0, (0, parcelRequire("knNkr")).cancel),
            sendId: sendId
        };
    };
    function $bae51534fbcbd157$export$b3571188c770cc5a(activity) {
        var activityDef = $bae51534fbcbd157$export$e81fdd8937d44864(activity);
        return {
            type: (0, (0, parcelRequire("1G4Gq")).ActionTypes).Start,
            activity: activityDef,
            exec: undefined
        };
    }
    function $bae51534fbcbd157$export$fa6813432f753b0d(actorRef) {
        var activity = (0, (0, parcelRequire("kUFUe")).isFunction)(actorRef) ? actorRef : $bae51534fbcbd157$export$e81fdd8937d44864(actorRef);
        return {
            type: (0, (0, parcelRequire("1G4Gq")).ActionTypes).Stop,
            activity: activity,
            exec: undefined
        };
    }
    function $bae51534fbcbd157$export$21aa461f4eb8e82(action, context, _event) {
        var actorRefOrString = (0, (0, parcelRequire("kUFUe")).isFunction)(action.activity) ? action.activity(context, _event.data) : action.activity;
        var resolvedActorRef = typeof actorRefOrString === 'string' ? {
            id: actorRefOrString
        } : actorRefOrString;
        var actionObject = {
            type: (0, (0, parcelRequire("1G4Gq")).ActionTypes).Stop,
            activity: resolvedActorRef
        };
        return actionObject;
    }
    var $bae51534fbcbd157$export$e6e34fd1f2686227 = function(assignment) {
        return {
            type: (0, (0, parcelRequire("knNkr")).assign),
            assignment: assignment
        };
    };
    function $bae51534fbcbd157$export$742acabee3dd6465(delayRef, id) {
        var idSuffix = id ? "#" + id : '';
        return (0, (0, parcelRequire("1G4Gq")).ActionTypes).After + "(" + delayRef + ")" + idSuffix;
    }
    function $bae51534fbcbd157$export$3df11c9c20e7b288(id, data) {
        var type = (0, (0, parcelRequire("1G4Gq")).ActionTypes).DoneState + "." + id;
        var eventObject = {
            type: type,
            data: data
        };
        eventObject.toString = function() {
            return type;
        };
        return eventObject;
    }
    function $bae51534fbcbd157$export$c105e588793f70b4(id, data) {
        var type = (0, (0, parcelRequire("1G4Gq")).ActionTypes).DoneInvoke + "." + id;
        var eventObject = {
            type: type,
            data: data
        };
        eventObject.toString = function() {
            return type;
        };
        return eventObject;
    }
    function $bae51534fbcbd157$export$a3bc9b8ed74fc(id, data) {
        var type = (0, (0, parcelRequire("1G4Gq")).ActionTypes).ErrorPlatform + "." + id;
        var eventObject = {
            type: type,
            data: data
        };
        eventObject.toString = function() {
            return type;
        };
        return eventObject;
    }
    function $bae51534fbcbd157$export$48ec4a2b1cfc6557(getActions) {
        return {
            type: (0, (0, parcelRequire("1G4Gq")).ActionTypes).Pure,
            get: getActions
        };
    }
    function $bae51534fbcbd157$export$eb147b7589db8e8a(target, options) {
        return $bae51534fbcbd157$export$89db4734f6c919c4(function(_, event) {
            return event;
        }, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, options), {
            to: target
        }));
    }
    function $bae51534fbcbd157$export$f514678a4137c4d6(errorData, options) {
        return $bae51534fbcbd157$export$408d8d51fa351f53(function(context, event, meta) {
            return {
                type: (0, (0, parcelRequire("knNkr")).error),
                data: (0, (0, parcelRequire("kUFUe")).isFunction)(errorData) ? errorData(context, event, meta) : errorData
            };
        }, (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, options), {
            to: (0, (0, parcelRequire("1G4Gq")).SpecialTargets).Parent
        }));
    }
    function $bae51534fbcbd157$export$7877a478dd30fd3d(conds) {
        return {
            type: (0, (0, parcelRequire("1G4Gq")).ActionTypes).Choose,
            conds: conds
        };
    }
    function $bae51534fbcbd157$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actions) {
        var _a = (0, (0, parcelRequire("dkU7z")).__read)((0, (0, parcelRequire("kUFUe")).partition)(actions, function(action) {
            return action.type === (0, (0, parcelRequire("knNkr")).assign);
        }), 2), assignActions = _a[0], otherActions = _a[1];
        var updatedContext = assignActions.length ? (0, (0, parcelRequire("kUFUe")).updateContext)(currentContext, _event, assignActions, currentState) : currentContext;
        var resolvedActions = (0, (0, parcelRequire("kUFUe")).flatten)(otherActions.map(function(actionObject) {
            var _a;
            switch(actionObject.type){
                case 0, (0, parcelRequire("knNkr")).raise:
                    return $bae51534fbcbd157$export$ed3daf8e935ede01(actionObject);
                case 0, (0, parcelRequire("knNkr")).send:
                    var sendAction = $bae51534fbcbd157$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays);
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(!(0, (0, parcelRequire("kUFUe")).isString)(actionObject.delay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '" + actionObject.delay + "' was found on machine '" + machine.id + "'");
                    return sendAction;
                case 0, (0, parcelRequire("knNkr")).log:
                    return $bae51534fbcbd157$export$12cba28d36be4946(actionObject, updatedContext, _event);
                case 0, (0, parcelRequire("knNkr")).choose:
                    var chooseAction = actionObject;
                    var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                        var guard = (0, (0, parcelRequire("kUFUe")).toGuard)(condition.cond, machine.options.guards);
                        return !guard || (0, (0, parcelRequire("kUFUe")).evaluateGuard)(machine, guard, updatedContext, _event, currentState);
                    })) === null || _a === void 0 ? void 0 : _a.actions;
                    if (!matchedActions) return [];
                    var resolved = $bae51534fbcbd157$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, $bae51534fbcbd157$export$aa68691f32e6c459((0, (0, parcelRequire("kUFUe")).toArray)(matchedActions), machine.options.actions));
                    updatedContext = resolved[1];
                    return resolved[0];
                case 0, (0, parcelRequire("knNkr")).pure:
                    var matchedActions = actionObject.get(updatedContext, _event.data);
                    if (!matchedActions) return [];
                    var resolved = $bae51534fbcbd157$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, $bae51534fbcbd157$export$aa68691f32e6c459((0, (0, parcelRequire("kUFUe")).toArray)(matchedActions), machine.options.actions));
                    updatedContext = resolved[1];
                    return resolved[0];
                case 0, (0, parcelRequire("knNkr")).stop:
                    return $bae51534fbcbd157$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
                default:
                    return $bae51534fbcbd157$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
            }
        }));
        return [
            resolvedActions,
            updatedContext
        ];
    }
});
parcelRegister("krWBq", function(module, exports) {
    $parcel$export(module.exports, "stateValuesEqual", ()=>$ee33c9860a5bfd1e$export$3a6d15eeb5fb214c);
    $parcel$export(module.exports, "isState", ()=>$ee33c9860a5bfd1e$export$e5d60a6bbabd36f);
    $parcel$export(module.exports, "bindActionToState", ()=>$ee33c9860a5bfd1e$export$e42513ad58964418);
    $parcel$export(module.exports, "State", ()=>$ee33c9860a5bfd1e$export$7254cc27399e90bd);
    var $dkU7z;
    var $8AK2c;
    var $kUFUe;
    var $6Mwr3;
    var $g2PT9;
    function $ee33c9860a5bfd1e$export$3a6d15eeb5fb214c(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if ((0, (0, parcelRequire("kUFUe")).isString)(a) || (0, (0, parcelRequire("kUFUe")).isString)(b)) return a === b;
        var aKeys = (0, (0, parcelRequire("kUFUe")).keys)(a);
        var bKeys = (0, (0, parcelRequire("kUFUe")).keys)(b);
        return aKeys.length === bKeys.length && aKeys.every(function(key) {
            return $ee33c9860a5bfd1e$export$3a6d15eeb5fb214c(a[key], b[key]);
        });
    }
    function $ee33c9860a5bfd1e$export$e5d60a6bbabd36f(state) {
        if ((0, (0, parcelRequire("kUFUe")).isString)(state)) return false;
        return 'value' in state && 'history' in state;
    }
    function $ee33c9860a5bfd1e$export$e42513ad58964418(action, state) {
        var exec = action.exec;
        var boundAction = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, action), {
            exec: exec !== undefined ? function() {
                return exec(state.context, state.event, {
                    action: action,
                    state: state,
                    _event: state._event
                });
            } : undefined
        });
        return boundAction;
    }
    var $ee33c9860a5bfd1e$export$7254cc27399e90bd = function() {
        function State(config) {
            var _this = this;
            var _a;
            this.actions = [];
            this.activities = (0, (0, parcelRequire("8AK2c")).EMPTY_ACTIVITY_MAP);
            this.meta = {};
            this.events = [];
            this.value = config.value;
            this.context = config.context;
            this._event = config._event;
            this._sessionid = config._sessionid;
            this.event = this._event.data;
            this.historyValue = config.historyValue;
            this.history = config.history;
            this.actions = config.actions || [];
            this.activities = config.activities || (0, (0, parcelRequire("8AK2c")).EMPTY_ACTIVITY_MAP);
            this.meta = config.meta || {};
            this.events = config.events || [];
            this.matches = this.matches.bind(this);
            this.toStrings = this.toStrings.bind(this);
            this.configuration = config.configuration;
            this.transitions = config.transitions;
            this.children = config.children;
            this.done = !!config.done;
            this.tags = (_a = config.tags) !== null && _a !== void 0 ? _a : new Set();
            Object.defineProperty(this, 'nextEvents', {
                get: function() {
                    return (0, (0, parcelRequire("6Mwr3")).nextEvents)(_this.configuration);
                }
            });
        }
        State.from = function(stateValue, context) {
            if (stateValue instanceof State) {
                if (stateValue.context !== context) return new State({
                    value: stateValue.value,
                    context: context,
                    _event: stateValue._event,
                    _sessionid: null,
                    historyValue: stateValue.historyValue,
                    history: stateValue.history,
                    actions: [],
                    activities: stateValue.activities,
                    meta: {},
                    events: [],
                    configuration: [],
                    transitions: [],
                    children: {}
                });
                return stateValue;
            }
            var _event = (0, (0, parcelRequire("g2PT9")).initEvent);
            return new State({
                value: stateValue,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: undefined,
                history: undefined,
                actions: [],
                activities: undefined,
                meta: undefined,
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
        };
        State.create = function(config) {
            return new State(config);
        };
        State.inert = function(stateValue, context) {
            if (stateValue instanceof State) {
                if (!stateValue.actions.length) return stateValue;
                var _event = (0, (0, parcelRequire("g2PT9")).initEvent);
                return new State({
                    value: stateValue.value,
                    context: context,
                    _event: _event,
                    _sessionid: null,
                    historyValue: stateValue.historyValue,
                    history: stateValue.history,
                    activities: stateValue.activities,
                    configuration: stateValue.configuration,
                    transitions: [],
                    children: {}
                });
            }
            return State.from(stateValue, context);
        };
        State.prototype.toStrings = function(stateValue, delimiter) {
            var _this = this;
            if (stateValue === void 0) stateValue = this.value;
            if (delimiter === void 0) delimiter = '.';
            if ((0, (0, parcelRequire("kUFUe")).isString)(stateValue)) return [
                stateValue
            ];
            var valueKeys = (0, (0, parcelRequire("kUFUe")).keys)(stateValue);
            return valueKeys.concat.apply(valueKeys, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(valueKeys.map(function(key) {
                return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                    return key + delimiter + s;
                });
            }))));
        };
        State.prototype.toJSON = function() {
            var _a = this, configuration = _a.configuration, transitions = _a.transitions, tags = _a.tags, jsonValues = (0, (0, parcelRequire("dkU7z")).__rest)(_a, [
                "configuration",
                "transitions",
                "tags"
            ]);
            return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, jsonValues), {
                tags: Array.from(tags)
            });
        };
        State.prototype.matches = function(parentStateValue) {
            return (0, (0, parcelRequire("kUFUe")).matchesState)(parentStateValue, this.value);
        };
        State.prototype.hasTag = function(tag) {
            return this.tags.has(tag);
        };
        return State;
    }();
});
parcelRegister("6Z4UF", function(module, exports) {
    $parcel$export(module.exports, "provide", ()=>$515c4036a0e81f92$export$abe1e183e22e10ad);
    $parcel$export(module.exports, "consume", ()=>$515c4036a0e81f92$export$e11e6a155c5c4d9d);
    var $515c4036a0e81f92$var$serviceStack = [];
    var $515c4036a0e81f92$export$abe1e183e22e10ad = function(service, fn) {
        $515c4036a0e81f92$var$serviceStack.push(service);
        var result = fn(service);
        $515c4036a0e81f92$var$serviceStack.pop();
        return result;
    };
    var $515c4036a0e81f92$export$e11e6a155c5c4d9d = function(fn) {
        return fn($515c4036a0e81f92$var$serviceStack[$515c4036a0e81f92$var$serviceStack.length - 1]);
    };
});
parcelRegister("1FBh2", function(module, exports) {
    $parcel$export(module.exports, "createInvocableActor", ()=>$1376889136123398$export$78b4a98dcb5ac328);
    $parcel$export(module.exports, "createDeferredActor", ()=>$1376889136123398$export$59bcb51d8e40ed48);
    $parcel$export(module.exports, "isSpawnedActor", ()=>$1376889136123398$export$b0f989039dc164f9);
    var $kUFUe;
    var $6Z4UF;
    function $1376889136123398$export$8998449b468dcdad(id) {
        return {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        };
    }
    function $1376889136123398$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
        var _a;
        var invokeSrc = (0, (0, parcelRequire("kUFUe")).toInvokeSource)(invokeDefinition.src);
        var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
        var resolvedData = invokeDefinition.data ? (0, (0, parcelRequire("kUFUe")).mapContext)(invokeDefinition.data, context, _event) : undefined;
        var tempActor = serviceCreator ? $1376889136123398$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $1376889136123398$export$8998449b468dcdad(invokeDefinition.id);
        tempActor.meta = invokeDefinition;
        return tempActor;
    }
    function $1376889136123398$export$59bcb51d8e40ed48(entity, id, data) {
        var tempActor = $1376889136123398$export$8998449b468dcdad(id);
        tempActor.deferred = true;
        if ((0, (0, parcelRequire("kUFUe")).isMachine)(entity)) tempActor.state = (0, (0, parcelRequire("6Z4UF")).provide)(undefined, function() {
            return (data ? entity.withContext(data) : entity).initialState;
        });
        return tempActor;
    }
    function $1376889136123398$export$e769f6913f14f1b7(item) {
        try {
            return typeof item.send === 'function';
        } catch (e) {
            return false;
        }
    }
    function $1376889136123398$export$b0f989039dc164f9(item) {
        return $1376889136123398$export$e769f6913f14f1b7(item) && 'id' in item;
    }
});
parcelRegister("ckC1K", function(module, exports) {
    $parcel$export(module.exports, "Scheduler", ()=>$8fa4d9b74b1821dc$export$d3e54bb8584cda7c);
    var $dkU7z;
    var $8fa4d9b74b1821dc$var$defaultOptions = {
        deferEvents: false
    };
    var $8fa4d9b74b1821dc$export$d3e54bb8584cda7c = function() {
        function Scheduler(options) {
            this.processingEvent = false;
            this.queue = [];
            this.initialized = false;
            this.options = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, $8fa4d9b74b1821dc$var$defaultOptions), options);
        }
        Scheduler.prototype.initialize = function(callback) {
            this.initialized = true;
            if (callback) {
                if (!this.options.deferEvents) {
                    this.schedule(callback);
                    return;
                }
                this.process(callback);
            }
            this.flushEvents();
        };
        Scheduler.prototype.schedule = function(task) {
            if (!this.initialized || this.processingEvent) {
                this.queue.push(task);
                return;
            }
            if (this.queue.length !== 0) throw new Error('Event queue should be empty when it is not processing events');
            this.process(task);
            this.flushEvents();
        };
        Scheduler.prototype.clear = function() {
            this.queue = [];
        };
        Scheduler.prototype.flushEvents = function() {
            var nextCallback = this.queue.shift();
            while(nextCallback){
                this.process(nextCallback);
                nextCallback = this.queue.shift();
            }
        };
        Scheduler.prototype.process = function(callback) {
            this.processingEvent = true;
            try {
                callback();
            } catch (e) {
                this.clear();
                throw e;
            } finally{
                this.processingEvent = false;
            }
        };
        return Scheduler;
    }();
});
parcelRegister("1IMXT", function(module, exports) {
    $parcel$export(module.exports, "registry", ()=>$140fe1eb30244239$export$4bb7493d241fd8a5);
    var $140fe1eb30244239$var$children = new Map();
    var $140fe1eb30244239$var$sessionIdIndex = 0;
    var $140fe1eb30244239$export$4bb7493d241fd8a5 = {
        bookId: function() {
            return "x:" + $140fe1eb30244239$var$sessionIdIndex++;
        },
        register: function(id, actor) {
            $140fe1eb30244239$var$children.set(id, actor);
            return id;
        },
        get: function(id) {
            return $140fe1eb30244239$var$children.get(id);
        },
        free: function(id) {
            $140fe1eb30244239$var$children.delete(id);
        }
    };
});
parcelRegister("b4ajb", function(module, exports) {
    $parcel$export(module.exports, "getGlobal", ()=>$80e8107a00613acc$export$a4e55266d2135a7f);
    $parcel$export(module.exports, "registerService", ()=>$80e8107a00613acc$export$4d7a7d14704ebc13);
    function $80e8107a00613acc$export$a4e55266d2135a7f() {
        if (typeof self !== 'undefined') return self;
        if (typeof window !== 'undefined') return window;
        if (typeof $parcel$global !== 'undefined') return $parcel$global;
        return undefined;
    }
    function $80e8107a00613acc$var$getDevTools() {
        var global1 = $80e8107a00613acc$export$a4e55266d2135a7f();
        if (global1 && '__xstate__' in global1) return global1.__xstate__;
        return undefined;
    }
    function $80e8107a00613acc$export$4d7a7d14704ebc13(service) {
        if (!$80e8107a00613acc$export$a4e55266d2135a7f()) return;
        var devTools = $80e8107a00613acc$var$getDevTools();
        if (devTools) devTools.register(service);
    }
});
parcelRegister("8cFS3", function(module, exports) {
    $parcel$export(module.exports, "editorPluginAIMachine", ()=>$adba134672e56d7e$export$da9fe52c4382b67d);
    var $eOdbG;
    const $adba134672e56d7e$export$da9fe52c4382b67d = (0, (0, parcelRequire("eOdbG")).createMachine)({
        id: 'EditorPluginAI',
        description: `This machine models the high level functionality of the EditorPluginAI.

Currently this logic is split across prosemirror, xstate, and elsewhere.

The intention is to migrate to a single source of truth, backed by a state machine.`,
        states: {
            'No AI experience active': {
                description: `When an Editor is first started up with an editor-plugin-ai EditorPlugin - it will start in this state.

This state will be returned to when an ai experience is either discarded or completed.`
            },
            'AI Modal active': {
                on: {
                    AI_CONTENT_INSERTED: 'AI Content Highlighted',
                    MODAL_DISCARDED: {
                        target: 'No AI experience active',
                        description: `This transition is intended to model when a user makes an explicit decision to clear the modal.`
                    },
                    MODAL_INVALIDATED: {
                        target: 'No AI experience active',
                        description: `This transition is intended to model when an AI experience is ended due to the modal no longer being valid.

For example, if it's been linked to a selection, and another user collaborating on the document deletes the selected content.

In future we might expect this to go to an alternate state.`
                    }
                },
                description: `Currently there is a seperate xstate state machine which is run when the ai modal is active.
Over time we can expect to link these state machines.`
            },
            'AI Content Highlighted': {
                on: {
                    SELECTION_CHANGED: {
                        target: 'No AI experience active',
                        description: `This transition models when a user interacts with a document following the insertion of content via AI.`
                    }
                },
                description: `Following content being inserted, the inserted content is highlighted so the user is able to understand the impact of inserting the generated content into the document.

This highlight is persisted either until the user changes makes a selection change in the document or the content is removed from the document (ie. via collab editing sessions)`
            }
        },
        on: {
            START_AI_EXPERIENCE: {
                target: 'AI Modal active',
                description: `We expect AI Experiences to be started in a variety of ways including;
- via the slash command/typeahead
- via the toolbar quick insert menu
- via the toolbar ai button
- via external actions (ie. atlas have a button outside the editor which starts an ai experience)

Only one AI experience can be active at a single time in an Editor.  If another AI experience is active when the user starts a new AI experience, the prior experience is replaced/reset with the new experience details.`
            }
        },
        initial: 'No AI experience active'
    });
});
parcelRegister("eOdbG", function(module, exports) {
    $parcel$export(module.exports, "createMachine", ()=>$ac7ff6eeaabd8c01$export$aaa7fa18f8e9b2e8);
    var $5o3QZ;
    function $ac7ff6eeaabd8c01$export$f391db14ff2d9279(config, options, initialContext) {
        if (initialContext === void 0) initialContext = config.context;
        var resolvedInitialContext = typeof initialContext === 'function' ? initialContext() : initialContext;
        return new (0, (0, parcelRequire("5o3QZ")).StateNode)(config, options, resolvedInitialContext);
    }
    function $ac7ff6eeaabd8c01$export$aaa7fa18f8e9b2e8(config, options) {
        var resolvedInitialContext = typeof config.context === 'function' ? config.context() : config.context;
        return new (0, (0, parcelRequire("5o3QZ")).StateNode)(config, options, resolvedInitialContext);
    }
});
parcelRegister("5o3QZ", function(module, exports) {
    $parcel$export(module.exports, "StateNode", ()=>$3ec22ee54be1b70d$export$342f24f5edd47b1);
    var $dkU7z;
    var $8AK2c;
    var $lnGwo;
    var $kUFUe;
    var $1G4Gq;
    var $6Mwr3;
    var $knNkr;
    var $g2PT9;
    var $krWBq;
    var $1FBh2;
    var $dOiWf;
    var $3ec22ee54be1b70d$var$NULL_EVENT = '';
    var $3ec22ee54be1b70d$var$STATE_IDENTIFIER = '#';
    var $3ec22ee54be1b70d$var$WILDCARD = '*';
    var $3ec22ee54be1b70d$var$EMPTY_OBJECT = {};
    var $3ec22ee54be1b70d$var$isStateId = function(str) {
        return str[0] === $3ec22ee54be1b70d$var$STATE_IDENTIFIER;
    };
    var $3ec22ee54be1b70d$var$createDefaultOptions = function() {
        return {
            actions: {},
            guards: {},
            services: {},
            activities: {},
            delays: {}
        };
    };
    var $3ec22ee54be1b70d$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
        var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
            return !('cond' in transition) && !('in' in transition) && ((0, (0, parcelRequire("kUFUe")).isString)(transition.target) || (0, (0, parcelRequire("kUFUe")).isMachine)(transition.target));
        });
        var eventText = event === $3ec22ee54be1b70d$var$NULL_EVENT ? 'the transient event' : "event '" + event + "'";
        (0, (0, parcelRequire("kUFUe")).warn)(!hasNonLastUnguardedTarget, "One or more transitions for " + eventText + " on state '" + stateNode.id + "' are unreachable. " + "Make sure that the default transition is the last one defined.");
    };
    var $3ec22ee54be1b70d$export$342f24f5edd47b1 = function() {
        function StateNode(config, options, context) {
            var _this = this;
            if (context === void 0) context = undefined;
            var _a;
            this.config = config;
            this.context = context;
            this.order = -1;
            this.__xstatenode = true;
            this.__cache = {
                events: undefined,
                relativeValue: new Map(),
                initialStateValue: undefined,
                initialState: undefined,
                on: undefined,
                transitions: undefined,
                candidates: {},
                delayedTransitions: undefined
            };
            this.idMap = {};
            this.tags = [];
            this.options = Object.assign($3ec22ee54be1b70d$var$createDefaultOptions(), options);
            this.parent = this.options._parent;
            this.key = this.config.key || this.options._key || this.config.id || '(machine)';
            this.machine = this.parent ? this.parent.machine : this;
            this.path = this.parent ? this.parent.path.concat(this.key) : [];
            this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, (0, parcelRequire("8AK2c")).STATE_DELIMITER));
            this.id = this.config.id || (0, (0, parcelRequire("dkU7z")).__spreadArray)([
                this.machine.key
            ], (0, (0, parcelRequire("dkU7z")).__read)(this.path)).join(this.delimiter);
            this.version = this.parent ? this.parent.version : this.config.version;
            this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && (0, (0, parcelRequire("kUFUe")).keys)(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
            this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
            if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. " + (this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '" + this.type + "'`") + " in the config for state node '" + this.id + "' instead.");
            this.initial = this.config.initial;
            this.states = this.config.states ? (0, (0, parcelRequire("kUFUe")).mapValues)(this.config.states, function(stateConfig, key) {
                var _a;
                var stateNode = new StateNode(stateConfig, {
                    _parent: _this,
                    _key: key
                });
                Object.assign(_this.idMap, (0, (0, parcelRequire("dkU7z")).__assign)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
                return stateNode;
            }) : $3ec22ee54be1b70d$var$EMPTY_OBJECT;
            var order = 0;
            function dfs(stateNode) {
                var e_1, _a;
                stateNode.order = order++;
                try {
                    for(var _b = (0, (0, parcelRequire("dkU7z")).__values)((0, (0, parcelRequire("6Mwr3")).getChildren)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                        var child = _c.value;
                        dfs(child);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
            dfs(this);
            this.history = this.config.history === true ? 'shallow' : this.config.history || false;
            this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
                var event = _a.event;
                return event === $3ec22ee54be1b70d$var$NULL_EVENT;
            }) : $3ec22ee54be1b70d$var$NULL_EVENT in this.config.on);
            this.strict = !!this.config.strict;
            this.onEntry = (0, (0, parcelRequire("kUFUe")).toArray)(this.config.entry || this.config.onEntry).map(function(action) {
                return (0, (0, parcelRequire("g2PT9")).toActionObject)(action);
            });
            this.onExit = (0, (0, parcelRequire("kUFUe")).toArray)(this.config.exit || this.config.onExit).map(function(action) {
                return (0, (0, parcelRequire("g2PT9")).toActionObject)(action);
            });
            this.meta = this.config.meta;
            this.doneData = this.type === 'final' ? this.config.data : undefined;
            this.invoke = (0, (0, parcelRequire("kUFUe")).toArray)(this.config.invoke).map(function(invokeConfig, i) {
                var _a, _b;
                if ((0, (0, parcelRequire("kUFUe")).isMachine)(invokeConfig)) {
                    _this.machine.options.services = (0, (0, parcelRequire("dkU7z")).__assign)((_a = {}, _a[invokeConfig.id] = invokeConfig, _a), _this.machine.options.services);
                    return (0, (0, parcelRequire("dOiWf")).toInvokeDefinition)({
                        src: invokeConfig.id,
                        id: invokeConfig.id
                    });
                } else if ((0, (0, parcelRequire("kUFUe")).isString)(invokeConfig.src)) return (0, (0, parcelRequire("dOiWf")).toInvokeDefinition)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, invokeConfig), {
                    id: invokeConfig.id || invokeConfig.src,
                    src: invokeConfig.src
                }));
                else if ((0, (0, parcelRequire("kUFUe")).isMachine)(invokeConfig.src) || (0, (0, parcelRequire("kUFUe")).isFunction)(invokeConfig.src)) {
                    var invokeSrc = _this.id + ":invocation[" + i + "]";
                    _this.machine.options.services = (0, (0, parcelRequire("dkU7z")).__assign)((_b = {}, _b[invokeSrc] = invokeConfig.src, _b), _this.machine.options.services);
                    return (0, (0, parcelRequire("dOiWf")).toInvokeDefinition)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({
                        id: invokeSrc
                    }, invokeConfig), {
                        src: invokeSrc
                    }));
                } else {
                    var invokeSource = invokeConfig.src;
                    return (0, (0, parcelRequire("dOiWf")).toInvokeDefinition)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({
                        id: invokeSource.type
                    }, invokeConfig), {
                        src: invokeSource
                    }));
                }
            });
            this.activities = (0, (0, parcelRequire("kUFUe")).toArray)(this.config.activities).concat(this.invoke).map(function(activity) {
                return (0, (0, parcelRequire("g2PT9")).toActivityDefinition)(activity);
            });
            this.transition = this.transition.bind(this);
            this.tags = (0, (0, parcelRequire("kUFUe")).toArray)(this.config.tags);
        }
        StateNode.prototype._init = function() {
            if (this.__cache.transitions) return;
            (0, (0, parcelRequire("6Mwr3")).getAllStateNodes)(this).forEach(function(stateNode) {
                return stateNode.on;
            });
        };
        StateNode.prototype.withConfig = function(options, context) {
            if (context === void 0) context = this.context;
            var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
            return new StateNode(this.config, {
                actions: (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, actions), options.actions),
                activities: (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, activities), options.activities),
                guards: (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, guards), options.guards),
                services: (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, services), options.services),
                delays: (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, delays), options.delays)
            }, context);
        };
        StateNode.prototype.withContext = function(context) {
            return new StateNode(this.config, this.options, context);
        };
        Object.defineProperty(StateNode.prototype, "definition", {
            get: function() {
                return {
                    id: this.id,
                    key: this.key,
                    version: this.version,
                    context: this.context,
                    type: this.type,
                    initial: this.initial,
                    history: this.history,
                    states: (0, (0, parcelRequire("kUFUe")).mapValues)(this.states, function(state) {
                        return state.definition;
                    }),
                    on: this.on,
                    transitions: this.transitions,
                    entry: this.onEntry,
                    exit: this.onExit,
                    activities: this.activities || [],
                    meta: this.meta,
                    order: this.order || -1,
                    data: this.doneData,
                    invoke: this.invoke
                };
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.toJSON = function() {
            return this.definition;
        };
        Object.defineProperty(StateNode.prototype, "on", {
            get: function() {
                if (this.__cache.on) return this.__cache.on;
                var transitions = this.transitions;
                return this.__cache.on = transitions.reduce(function(map, transition) {
                    map[transition.eventType] = map[transition.eventType] || [];
                    map[transition.eventType].push(transition);
                    return map;
                }, {});
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateNode.prototype, "after", {
            get: function() {
                return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateNode.prototype, "transitions", {
            get: function() {
                return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.getCandidates = function(eventName) {
            if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
            var transient = eventName === $3ec22ee54be1b70d$var$NULL_EVENT;
            var candidates = this.transitions.filter(function(transition) {
                var sameEventType = transition.eventType === eventName;
                return transient ? sameEventType : sameEventType || transition.eventType === $3ec22ee54be1b70d$var$WILDCARD;
            });
            this.__cache.candidates[eventName] = candidates;
            return candidates;
        };
        StateNode.prototype.getDelayedTransitions = function() {
            var _this = this;
            var afterConfig = this.config.after;
            if (!afterConfig) return [];
            var mutateEntryExit = function(delay, i) {
                var delayRef = (0, (0, parcelRequire("kUFUe")).isFunction)(delay) ? _this.id + ":delay[" + i + "]" : delay;
                var eventType = (0, (0, parcelRequire("g2PT9")).after)(delayRef, _this.id);
                _this.onEntry.push((0, (0, parcelRequire("g2PT9")).send)(eventType, {
                    delay: delay
                }));
                _this.onExit.push((0, (0, parcelRequire("g2PT9")).cancel)(eventType));
                return eventType;
            };
            var delayedTransitions = (0, (0, parcelRequire("kUFUe")).isArray)(afterConfig) ? afterConfig.map(function(transition, i) {
                var eventType = mutateEntryExit(transition.delay, i);
                return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, transition), {
                    event: eventType
                });
            }) : (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).keys)(afterConfig).map(function(delay, i) {
                var configTransition = afterConfig[delay];
                var resolvedTransition = (0, (0, parcelRequire("kUFUe")).isString)(configTransition) ? {
                    target: configTransition
                } : configTransition;
                var resolvedDelay = !isNaN(+delay) ? +delay : delay;
                var eventType = mutateEntryExit(resolvedDelay, i);
                return (0, (0, parcelRequire("kUFUe")).toArray)(resolvedTransition).map(function(transition) {
                    return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, transition), {
                        event: eventType,
                        delay: resolvedDelay
                    });
                });
            }));
            return delayedTransitions.map(function(delayedTransition) {
                var delay = delayedTransition.delay;
                return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, _this.formatTransition(delayedTransition)), {
                    delay: delay
                });
            });
        };
        StateNode.prototype.getStateNodes = function(state) {
            var _a;
            var _this = this;
            if (!state) return [];
            var stateValue = state instanceof (0, (0, parcelRequire("krWBq")).State) ? state.value : (0, (0, parcelRequire("kUFUe")).toStateValue)(state, this.delimiter);
            if ((0, (0, parcelRequire("kUFUe")).isString)(stateValue)) {
                var initialStateValue = this.getStateNode(stateValue).initial;
                return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                    this,
                    this.states[stateValue]
                ];
            }
            var subStateKeys = (0, (0, parcelRequire("kUFUe")).keys)(stateValue);
            var subStateNodes = subStateKeys.map(function(subStateKey) {
                return _this.getStateNode(subStateKey);
            });
            subStateNodes.push(this);
            return subStateNodes.concat(subStateKeys.reduce(function(allSubStateNodes, subStateKey) {
                var subStateNode = _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
                return allSubStateNodes.concat(subStateNode);
            }, []));
        };
        StateNode.prototype.handles = function(event) {
            var eventType = (0, (0, parcelRequire("kUFUe")).getEventType)(event);
            return this.events.includes(eventType);
        };
        StateNode.prototype.resolveState = function(state) {
            var configuration = Array.from((0, (0, parcelRequire("6Mwr3")).getConfiguration)([], this.getStateNodes(state.value)));
            return new (0, (0, parcelRequire("krWBq")).State)((0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, state), {
                value: this.resolve(state.value),
                configuration: configuration,
                done: (0, (0, parcelRequire("6Mwr3")).isInFinalState)(configuration, this)
            }));
        };
        StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
            var stateNode = this.getStateNode(stateValue);
            var next = stateNode.next(state, _event);
            if (!next || !next.transitions.length) return this.next(state, _event);
            return next;
        };
        StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
            var subStateKeys = (0, (0, parcelRequire("kUFUe")).keys)(stateValue);
            var stateNode = this.getStateNode(subStateKeys[0]);
            var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
            if (!next || !next.transitions.length) return this.next(state, _event);
            return next;
        };
        StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
            var e_2, _a;
            var transitionMap = {};
            try {
                for(var _b = (0, (0, parcelRequire("dkU7z")).__values)((0, (0, parcelRequire("kUFUe")).keys)(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var subStateKey = _c.value;
                    var subStateValue = stateValue[subStateKey];
                    if (!subStateValue) continue;
                    var subStateNode = this.getStateNode(subStateKey);
                    var next = subStateNode._transition(subStateValue, state, _event);
                    if (next) transitionMap[subStateKey] = next;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            var stateTransitions = (0, (0, parcelRequire("kUFUe")).keys)(transitionMap).map(function(key) {
                return transitionMap[key];
            });
            var enabledTransitions = (0, (0, parcelRequire("kUFUe")).flatten)(stateTransitions.map(function(st) {
                return st.transitions;
            }));
            var willTransition = stateTransitions.some(function(st) {
                return st.transitions.length > 0;
            });
            if (!willTransition) return this.next(state, _event);
            var entryNodes = (0, (0, parcelRequire("kUFUe")).flatten)(stateTransitions.map(function(t) {
                return t.entrySet;
            }));
            var configuration = (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).keys)(transitionMap).map(function(key) {
                return transitionMap[key].configuration;
            }));
            return {
                transitions: enabledTransitions,
                entrySet: entryNodes,
                exitSet: (0, (0, parcelRequire("kUFUe")).flatten)(stateTransitions.map(function(t) {
                    return t.exitSet;
                })),
                configuration: configuration,
                source: state,
                actions: (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).keys)(transitionMap).map(function(key) {
                    return transitionMap[key].actions;
                }))
            };
        };
        StateNode.prototype._transition = function(stateValue, state, _event) {
            if ((0, (0, parcelRequire("kUFUe")).isString)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
            if ((0, (0, parcelRequire("kUFUe")).keys)(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
            return this.transitionParallelNode(stateValue, state, _event);
        };
        StateNode.prototype.next = function(state, _event) {
            var e_3, _a;
            var _this = this;
            var eventName = _event.name;
            var actions = [];
            var nextStateNodes = [];
            var selectedTransition;
            try {
                for(var _b = (0, (0, parcelRequire("dkU7z")).__values)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var candidate = _c.value;
                    var cond = candidate.cond, stateIn = candidate.in;
                    var resolvedContext = state.context;
                    var isInState = stateIn ? (0, (0, parcelRequire("kUFUe")).isString)(stateIn) && $3ec22ee54be1b70d$var$isStateId(stateIn) ? state.matches((0, (0, parcelRequire("kUFUe")).toStateValue)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, (0, parcelRequire("kUFUe")).matchesState)((0, (0, parcelRequire("kUFUe")).toStateValue)(stateIn, this.delimiter), (0, (0, parcelRequire("kUFUe")).path)(this.path.slice(0, -2))(state.value)) : true;
                    var guardPassed = false;
                    try {
                        guardPassed = !cond || (0, (0, parcelRequire("kUFUe")).evaluateGuard)(this.machine, cond, resolvedContext, _event, state);
                    } catch (err) {
                        throw new Error("Unable to evaluate guard '" + (cond.name || cond.type) + "' in transition for event '" + eventName + "' in state node '" + this.id + "':\n" + err.message);
                    }
                    if (guardPassed && isInState) {
                        if (candidate.target !== undefined) nextStateNodes = candidate.target;
                        actions.push.apply(actions, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(candidate.actions)));
                        selectedTransition = candidate;
                        break;
                    }
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            if (!selectedTransition) return undefined;
            if (!nextStateNodes.length) return {
                transitions: [
                    selectedTransition
                ],
                entrySet: [],
                exitSet: [],
                configuration: state.value ? [
                    this
                ] : [],
                source: state,
                actions: actions
            };
            var allNextStateNodes = (0, (0, parcelRequire("kUFUe")).flatten)(nextStateNodes.map(function(stateNode) {
                return _this.getRelativeStateNodes(stateNode, state.historyValue);
            }));
            var isInternal = !!selectedTransition.internal;
            var reentryNodes = isInternal ? [] : (0, (0, parcelRequire("kUFUe")).flatten)(allNextStateNodes.map(function(n) {
                return _this.nodesFromChild(n);
            }));
            return {
                transitions: [
                    selectedTransition
                ],
                entrySet: reentryNodes,
                exitSet: isInternal ? [] : [
                    this
                ],
                configuration: allNextStateNodes,
                source: state,
                actions: actions
            };
        };
        StateNode.prototype.nodesFromChild = function(childStateNode) {
            if (childStateNode.escapes(this)) return [];
            var nodes = [];
            var marker = childStateNode;
            while(marker && marker !== this){
                nodes.push(marker);
                marker = marker.parent;
            }
            nodes.push(this);
            return nodes;
        };
        StateNode.prototype.escapes = function(stateNode) {
            if (this === stateNode) return false;
            var parent = this.parent;
            while(parent){
                if (parent === stateNode) return false;
                parent = parent.parent;
            }
            return true;
        };
        StateNode.prototype.getActions = function(transition, currentContext, _event, prevState) {
            var e_4, _a, e_5, _b;
            var prevConfig = (0, (0, parcelRequire("6Mwr3")).getConfiguration)([], prevState ? this.getStateNodes(prevState.value) : [
                this
            ]);
            var resolvedConfig = transition.configuration.length ? (0, (0, parcelRequire("6Mwr3")).getConfiguration)(prevConfig, transition.configuration) : prevConfig;
            try {
                for(var resolvedConfig_1 = (0, (0, parcelRequire("dkU7z")).__values)(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()){
                    var sn = resolvedConfig_1_1.value;
                    if (!(0, (0, parcelRequire("6Mwr3")).has)(prevConfig, sn)) transition.entrySet.push(sn);
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a = resolvedConfig_1.return)) _a.call(resolvedConfig_1);
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
            try {
                for(var prevConfig_1 = (0, (0, parcelRequire("dkU7z")).__values)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                    var sn = prevConfig_1_1.value;
                    if (!(0, (0, parcelRequire("6Mwr3")).has)(resolvedConfig, sn) || (0, (0, parcelRequire("6Mwr3")).has)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            if (!transition.source) {
                transition.exitSet = [];
                transition.entrySet.push(this);
            }
            var doneEvents = (0, (0, parcelRequire("kUFUe")).flatten)(transition.entrySet.map(function(sn) {
                var events = [];
                if (sn.type !== 'final') return events;
                var parent = sn.parent;
                if (!parent.parent) return events;
                events.push((0, (0, parcelRequire("g2PT9")).done)(sn.id, sn.doneData), (0, (0, parcelRequire("g2PT9")).done)(parent.id, sn.doneData ? (0, (0, parcelRequire("kUFUe")).mapContext)(sn.doneData, currentContext, _event) : undefined));
                var grandparent = parent.parent;
                if (grandparent.type === 'parallel') {
                    if ((0, (0, parcelRequire("6Mwr3")).getChildren)(grandparent).every(function(parentNode) {
                        return (0, (0, parcelRequire("6Mwr3")).isInFinalState)(transition.configuration, parentNode);
                    })) events.push((0, (0, parcelRequire("g2PT9")).done)(grandparent.id));
                }
                return events;
            }));
            transition.exitSet.sort(function(a, b) {
                return b.order - a.order;
            });
            transition.entrySet.sort(function(a, b) {
                return a.order - b.order;
            });
            var entryStates = new Set(transition.entrySet);
            var exitStates = new Set(transition.exitSet);
            var _c = (0, (0, parcelRequire("dkU7z")).__read)([
                (0, (0, parcelRequire("kUFUe")).flatten)(Array.from(entryStates).map(function(stateNode) {
                    return (0, (0, parcelRequire("dkU7z")).__spreadArray)((0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(stateNode.activities.map(function(activity) {
                        return (0, (0, parcelRequire("g2PT9")).start)(activity);
                    }))), (0, (0, parcelRequire("dkU7z")).__read)(stateNode.onEntry));
                })).concat(doneEvents.map((0, (0, parcelRequire("g2PT9")).raise))),
                (0, (0, parcelRequire("kUFUe")).flatten)(Array.from(exitStates).map(function(stateNode) {
                    return (0, (0, parcelRequire("dkU7z")).__spreadArray)((0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(stateNode.onExit)), (0, (0, parcelRequire("dkU7z")).__read)(stateNode.activities.map(function(activity) {
                        return (0, (0, parcelRequire("g2PT9")).stop)(activity);
                    })));
                }))
            ], 2), entryActions = _c[0], exitActions = _c[1];
            var actions = (0, (0, parcelRequire("g2PT9")).toActionObjects)(exitActions.concat(transition.actions).concat(entryActions), this.machine.options.actions);
            return actions;
        };
        StateNode.prototype.transition = function(state, event, context) {
            if (state === void 0) state = this.initialState;
            var _event = (0, (0, parcelRequire("kUFUe")).toSCXMLEvent)(event);
            var currentState;
            if (state instanceof (0, (0, parcelRequire("krWBq")).State)) currentState = context === undefined ? state : this.resolveState((0, (0, parcelRequire("krWBq")).State).from(state, context));
            else {
                var resolvedStateValue = (0, (0, parcelRequire("kUFUe")).isString)(state) ? this.resolve((0, (0, parcelRequire("kUFUe")).pathToStateValue)(this.getResolvedPath(state))) : this.resolve(state);
                var resolvedContext = context ? context : this.machine.context;
                currentState = this.resolveState((0, (0, parcelRequire("krWBq")).State).from(resolvedStateValue, resolvedContext));
            }
            if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION) && _event.name === $3ec22ee54be1b70d$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('" + $3ec22ee54be1b70d$var$WILDCARD + "')");
            if (this.strict) {
                if (!this.events.includes(_event.name) && !(0, (0, parcelRequire("kUFUe")).isBuiltInEvent)(_event.name)) throw new Error("Machine '" + this.id + "' does not accept event '" + _event.name + "'");
            }
            var stateTransition = this._transition(currentState.value, currentState, _event) || {
                transitions: [],
                configuration: [],
                entrySet: [],
                exitSet: [],
                source: currentState,
                actions: []
            };
            var prevConfig = (0, (0, parcelRequire("6Mwr3")).getConfiguration)([], this.getStateNodes(currentState.value));
            var resolvedConfig = stateTransition.configuration.length ? (0, (0, parcelRequire("6Mwr3")).getConfiguration)(prevConfig, stateTransition.configuration) : prevConfig;
            stateTransition.configuration = (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(resolvedConfig));
            return this.resolveTransition(stateTransition, currentState, _event);
        };
        StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent) {
            var _a;
            var currentActions = state.actions;
            state = this.transition(state, _event);
            state._event = originalEvent;
            state.event = originalEvent.data;
            (_a = state.actions).unshift.apply(_a, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(currentActions)));
            return state;
        };
        StateNode.prototype.resolveTransition = function(stateTransition, currentState, _event, context) {
            var e_6, _a;
            var _this = this;
            if (_event === void 0) _event = (0, (0, parcelRequire("g2PT9")).initEvent);
            if (context === void 0) context = this.machine.context;
            var configuration = stateTransition.configuration;
            var willTransition = !currentState || stateTransition.transitions.length > 0;
            var resolvedStateValue = willTransition ? (0, (0, parcelRequire("6Mwr3")).getValue)(this.machine, configuration) : undefined;
            var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
            var currentContext = currentState ? currentState.context : context;
            var actions = this.getActions(stateTransition, currentContext, _event, currentState);
            var activities = currentState ? (0, (0, parcelRequire("dkU7z")).__assign)({}, currentState.activities) : {};
            try {
                for(var actions_1 = (0, (0, parcelRequire("dkU7z")).__values)(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()){
                    var action = actions_1_1.value;
                    if (action.type === (0, (0, parcelRequire("knNkr")).start)) activities[action.activity.id || action.activity.type] = action;
                    else if (action.type === (0, (0, parcelRequire("knNkr")).stop)) activities[action.activity.id || action.activity.type] = false;
                }
            } catch (e_6_1) {
                e_6 = {
                    error: e_6_1
                };
            } finally{
                try {
                    if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
                } finally{
                    if (e_6) throw e_6.error;
                }
            }
            var _b = (0, (0, parcelRequire("dkU7z")).__read)((0, (0, parcelRequire("g2PT9")).resolveActions)(this, currentState, currentContext, _event, actions), 2), resolvedActions = _b[0], updatedContext = _b[1];
            var _c = (0, (0, parcelRequire("dkU7z")).__read)((0, (0, parcelRequire("kUFUe")).partition)(resolvedActions, function(action) {
                return action.type === (0, (0, parcelRequire("knNkr")).raise) || action.type === (0, (0, parcelRequire("knNkr")).send) && action.to === (0, (0, parcelRequire("1G4Gq")).SpecialTargets).Internal;
            }), 2), raisedEvents = _c[0], nonRaisedActions = _c[1];
            var invokeActions = resolvedActions.filter(function(action) {
                var _a;
                return action.type === (0, (0, parcelRequire("knNkr")).start) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, (0, parcelRequire("knNkr")).invoke);
            });
            var children = invokeActions.reduce(function(acc, action) {
                acc[action.activity.id] = (0, (0, parcelRequire("1FBh2")).createInvocableActor)(action.activity, _this.machine, updatedContext, _event);
                return acc;
            }, currentState ? (0, (0, parcelRequire("dkU7z")).__assign)({}, currentState.children) : {});
            var resolvedConfiguration = resolvedStateValue ? stateTransition.configuration : currentState ? currentState.configuration : [];
            var meta = resolvedConfiguration.reduce(function(acc, stateNode) {
                if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
                return acc;
            }, {});
            var isDone = (0, (0, parcelRequire("6Mwr3")).isInFinalState)(resolvedConfiguration, this);
            var nextState = new (0, (0, parcelRequire("krWBq")).State)({
                value: resolvedStateValue || currentState.value,
                context: updatedContext,
                _event: _event,
                _sessionid: currentState ? currentState._sessionid : null,
                historyValue: resolvedStateValue ? historyValue ? (0, (0, parcelRequire("kUFUe")).updateHistoryValue)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
                history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
                actions: resolvedStateValue ? nonRaisedActions : [],
                activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
                meta: resolvedStateValue ? meta : currentState ? currentState.meta : undefined,
                events: [],
                configuration: resolvedConfiguration,
                transitions: stateTransition.transitions,
                children: children,
                done: isDone,
                tags: currentState === null || currentState === void 0 ? void 0 : currentState.tags
            });
            var didUpdateContext = currentContext !== updatedContext;
            nextState.changed = _event.name === (0, (0, parcelRequire("knNkr")).update) || didUpdateContext;
            var history = nextState.history;
            if (history) delete history.history;
            if (!resolvedStateValue) return nextState;
            var maybeNextState = nextState;
            if (!isDone) {
                var isTransient = this._transient || configuration.some(function(stateNode) {
                    return stateNode._transient;
                });
                if (isTransient) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                    type: (0, (0, parcelRequire("knNkr")).nullEvent)
                }, _event);
                while(raisedEvents.length){
                    var raisedEvent = raisedEvents.shift();
                    maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event);
                }
            }
            var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, (0, parcelRequire("krWBq")).stateValuesEqual)(maybeNextState.value, history.value) : undefined);
            maybeNextState.changed = changed;
            maybeNextState.history = history;
            maybeNextState.tags = new Set((0, (0, parcelRequire("kUFUe")).flatten)(maybeNextState.configuration.map(function(sn) {
                return sn.tags;
            })));
            return maybeNextState;
        };
        StateNode.prototype.getStateNode = function(stateKey) {
            if ($3ec22ee54be1b70d$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
            if (!this.states) throw new Error("Unable to retrieve child state '" + stateKey + "' from '" + this.id + "'; no child states exist.");
            var result = this.states[stateKey];
            if (!result) throw new Error("Child state '" + stateKey + "' does not exist on '" + this.id + "'");
            return result;
        };
        StateNode.prototype.getStateNodeById = function(stateId) {
            var resolvedStateId = $3ec22ee54be1b70d$var$isStateId(stateId) ? stateId.slice($3ec22ee54be1b70d$var$STATE_IDENTIFIER.length) : stateId;
            if (resolvedStateId === this.id) return this;
            var stateNode = this.machine.idMap[resolvedStateId];
            if (!stateNode) throw new Error("Child state node '#" + resolvedStateId + "' does not exist on machine '" + this.id + "'");
            return stateNode;
        };
        StateNode.prototype.getStateNodeByPath = function(statePath) {
            if (typeof statePath === 'string' && $3ec22ee54be1b70d$var$isStateId(statePath)) try {
                return this.getStateNodeById(statePath.slice(1));
            } catch (e) {}
            var arrayStatePath = (0, (0, parcelRequire("kUFUe")).toStatePath)(statePath, this.delimiter).slice();
            var currentStateNode = this;
            while(arrayStatePath.length){
                var key = arrayStatePath.shift();
                if (!key.length) break;
                currentStateNode = currentStateNode.getStateNode(key);
            }
            return currentStateNode;
        };
        StateNode.prototype.resolve = function(stateValue) {
            var _a;
            var _this = this;
            if (!stateValue) return this.initialStateValue || $3ec22ee54be1b70d$var$EMPTY_OBJECT;
            switch(this.type){
                case 'parallel':
                    return (0, (0, parcelRequire("kUFUe")).mapValues)(this.initialStateValue, function(subStateValue, subStateKey) {
                        return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $3ec22ee54be1b70d$var$EMPTY_OBJECT;
                    });
                case 'compound':
                    if ((0, (0, parcelRequire("kUFUe")).isString)(stateValue)) {
                        var subStateNode = this.getStateNode(stateValue);
                        if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                        return stateValue;
                    }
                    if (!(0, (0, parcelRequire("kUFUe")).keys)(stateValue).length) return this.initialStateValue || {};
                    return (0, (0, parcelRequire("kUFUe")).mapValues)(stateValue, function(subStateValue, subStateKey) {
                        return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $3ec22ee54be1b70d$var$EMPTY_OBJECT;
                    });
                default:
                    return stateValue || $3ec22ee54be1b70d$var$EMPTY_OBJECT;
            }
        };
        StateNode.prototype.getResolvedPath = function(stateIdentifier) {
            if ($3ec22ee54be1b70d$var$isStateId(stateIdentifier)) {
                var stateNode = this.machine.idMap[stateIdentifier.slice($3ec22ee54be1b70d$var$STATE_IDENTIFIER.length)];
                if (!stateNode) throw new Error("Unable to find state node '" + stateIdentifier + "'");
                return stateNode.path;
            }
            return (0, (0, parcelRequire("kUFUe")).toStatePath)(stateIdentifier, this.delimiter);
        };
        Object.defineProperty(StateNode.prototype, "initialStateValue", {
            get: function() {
                var _a;
                if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
                var initialStateValue;
                if (this.type === 'parallel') initialStateValue = (0, (0, parcelRequire("kUFUe")).mapFilterValues)(this.states, function(state) {
                    return state.initialStateValue || $3ec22ee54be1b70d$var$EMPTY_OBJECT;
                }, function(stateNode) {
                    return !(stateNode.type === 'history');
                });
                else if (this.initial !== undefined) {
                    if (!this.states[this.initial]) throw new Error("Initial state '" + this.initial + "' not found on '" + this.key + "'");
                    initialStateValue = (0, (0, parcelRequire("6Mwr3")).isLeafNode)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
                } else initialStateValue = {};
                this.__cache.initialStateValue = initialStateValue;
                return this.__cache.initialStateValue;
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.getInitialState = function(stateValue, context) {
            var configuration = this.getStateNodes(stateValue);
            return this.resolveTransition({
                configuration: configuration,
                entrySet: configuration,
                exitSet: [],
                transitions: [],
                source: undefined,
                actions: []
            }, undefined, undefined, context);
        };
        Object.defineProperty(StateNode.prototype, "initialState", {
            get: function() {
                this._init();
                var initialStateValue = this.initialStateValue;
                if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '" + this.id + "'.");
                return this.getInitialState(initialStateValue);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateNode.prototype, "target", {
            get: function() {
                var target;
                if (this.type === 'history') {
                    var historyConfig = this.config;
                    if ((0, (0, parcelRequire("kUFUe")).isString)(historyConfig.target)) target = $3ec22ee54be1b70d$var$isStateId(historyConfig.target) ? (0, (0, parcelRequire("kUFUe")).pathToStateValue)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                    else target = historyConfig.target;
                }
                return target;
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
            if (resolve === void 0) resolve = true;
            return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
                relativeStateId
            ];
        };
        Object.defineProperty(StateNode.prototype, "initialStateNodes", {
            get: function() {
                var _this = this;
                if ((0, (0, parcelRequire("6Mwr3")).isLeafNode)(this)) return [
                    this
                ];
                if (this.type === 'compound' && !this.initial) {
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(false, "Compound state node '" + this.id + "' has no initial state.");
                    return [
                        this
                    ];
                }
                var initialStateNodePaths = (0, (0, parcelRequire("kUFUe")).toStatePaths)(this.initialStateValue);
                return (0, (0, parcelRequire("kUFUe")).flatten)(initialStateNodePaths.map(function(initialPath) {
                    return _this.getFromRelativePath(initialPath);
                }));
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.getFromRelativePath = function(relativePath) {
            if (!relativePath.length) return [
                this
            ];
            var _a = (0, (0, parcelRequire("dkU7z")).__read)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
            if (!this.states) throw new Error("Cannot retrieve subPath '" + stateKey + "' from node with no states");
            var childStateNode = this.getStateNode(stateKey);
            if (childStateNode.type === 'history') return childStateNode.resolveHistory();
            if (!this.states[stateKey]) throw new Error("Child state '" + stateKey + "' does not exist on '" + this.id + "'");
            return this.states[stateKey].getFromRelativePath(childStatePath);
        };
        StateNode.prototype.historyValue = function(relativeStateValue) {
            if (!(0, (0, parcelRequire("kUFUe")).keys)(this.states).length) return undefined;
            return {
                current: relativeStateValue || this.initialStateValue,
                states: (0, (0, parcelRequire("kUFUe")).mapFilterValues)(this.states, function(stateNode, key) {
                    if (!relativeStateValue) return stateNode.historyValue();
                    var subStateValue = (0, (0, parcelRequire("kUFUe")).isString)(relativeStateValue) ? undefined : relativeStateValue[key];
                    return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
                }, function(stateNode) {
                    return !stateNode.history;
                })
            };
        };
        StateNode.prototype.resolveHistory = function(historyValue) {
            var _this = this;
            if (this.type !== 'history') return [
                this
            ];
            var parent = this.parent;
            if (!historyValue) {
                var historyTarget = this.target;
                return historyTarget ? (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).toStatePaths)(historyTarget).map(function(relativeChildPath) {
                    return parent.getFromRelativePath(relativeChildPath);
                })) : parent.initialStateNodes;
            }
            var subHistoryValue = (0, (0, parcelRequire("kUFUe")).nestedPath)(parent.path, 'states')(historyValue).current;
            if ((0, (0, parcelRequire("kUFUe")).isString)(subHistoryValue)) return [
                parent.getStateNode(subHistoryValue)
            ];
            return (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).toStatePaths)(subHistoryValue).map(function(subStatePath) {
                return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [
                    parent.states[subStatePath[0]]
                ];
            }));
        };
        Object.defineProperty(StateNode.prototype, "stateIds", {
            get: function() {
                var _this = this;
                var childStateIds = (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).keys)(this.states).map(function(stateKey) {
                    return _this.states[stateKey].stateIds;
                }));
                return [
                    this.id
                ].concat(childStateIds);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateNode.prototype, "events", {
            get: function() {
                var e_7, _a, e_8, _b;
                if (this.__cache.events) return this.__cache.events;
                var states = this.states;
                var events = new Set(this.ownEvents);
                if (states) try {
                    for(var _c = (0, (0, parcelRequire("dkU7z")).__values)((0, (0, parcelRequire("kUFUe")).keys)(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                        var stateId = _d.value;
                        var state = states[stateId];
                        if (state.states) try {
                            for(var _e = (e_8 = void 0, (0, (0, parcelRequire("dkU7z")).__values)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                                var event_1 = _f.value;
                                events.add("" + event_1);
                            }
                        } catch (e_8_1) {
                            e_8 = {
                                error: e_8_1
                            };
                        } finally{
                            try {
                                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                            } finally{
                                if (e_8) throw e_8.error;
                            }
                        }
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
                return this.__cache.events = Array.from(events);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(StateNode.prototype, "ownEvents", {
            get: function() {
                var events = new Set(this.transitions.filter(function(transition) {
                    return !(!transition.target && !transition.actions.length && transition.internal);
                }).map(function(transition) {
                    return transition.eventType;
                }));
                return Array.from(events);
            },
            enumerable: false,
            configurable: true
        });
        StateNode.prototype.resolveTarget = function(_target) {
            var _this = this;
            if (_target === undefined) return undefined;
            return _target.map(function(target) {
                if (!(0, (0, parcelRequire("kUFUe")).isString)(target)) return target;
                var isInternalTarget = target[0] === _this.delimiter;
                if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
                var resolvedTarget = isInternalTarget ? _this.key + target : target;
                if (_this.parent) try {
                    var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                    return targetStateNode;
                } catch (err) {
                    throw new Error("Invalid transition definition for state node '" + _this.id + "':\n" + err.message);
                }
                else return _this.getStateNodeByPath(resolvedTarget);
            });
        };
        StateNode.prototype.formatTransition = function(transitionConfig) {
            var _this = this;
            var normalizedTarget = (0, (0, parcelRequire("kUFUe")).normalizeTarget)(transitionConfig.target);
            var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
                return (0, (0, parcelRequire("kUFUe")).isString)(_target) && _target[0] === _this.delimiter;
            }) : true;
            var guards = this.machine.options.guards;
            var target = this.resolveTarget(normalizedTarget);
            var transition = (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, transitionConfig), {
                actions: (0, (0, parcelRequire("g2PT9")).toActionObjects)((0, (0, parcelRequire("kUFUe")).toArray)(transitionConfig.actions)),
                cond: (0, (0, parcelRequire("kUFUe")).toGuard)(transitionConfig.cond, guards),
                target: target,
                source: this,
                internal: internal,
                eventType: transitionConfig.event,
                toJSON: function() {
                    return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, transition), {
                        target: transition.target ? transition.target.map(function(t) {
                            return "#" + t.id;
                        }) : undefined,
                        source: "#" + _this.id
                    });
                }
            });
            return transition;
        };
        StateNode.prototype.formatTransitions = function() {
            var e_9, _a;
            var _this = this;
            var onConfig;
            if (!this.config.on) onConfig = [];
            else if (Array.isArray(this.config.on)) onConfig = this.config.on;
            else {
                var _b = this.config.on, _c = $3ec22ee54be1b70d$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, (0, parcelRequire("dkU7z")).__rest)(_b, [
                    typeof _c === "symbol" ? _c : _c + ""
                ]);
                onConfig = (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("kUFUe")).keys)(strictTransitionConfigs_1).map(function(key) {
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION) && key === $3ec22ee54be1b70d$var$NULL_EVENT) (0, (0, parcelRequire("kUFUe")).warn)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + ("Please check the `on` configuration for \"#" + _this.id + "\"."));
                    var transitionConfigArray = (0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)(key, strictTransitionConfigs_1[key]);
                    if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) $3ec22ee54be1b70d$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                    return transitionConfigArray;
                }).concat((0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)($3ec22ee54be1b70d$var$WILDCARD, wildcardConfigs)));
            }
            var eventlessConfig = this.config.always ? (0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)('', this.config.always) : [];
            var doneConfig = this.config.onDone ? (0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)(String((0, (0, parcelRequire("g2PT9")).done)(this.id)), this.config.onDone) : [];
            if (!(0, (0, parcelRequire("lnGwo")).IS_PRODUCTION)) (0, (0, parcelRequire("kUFUe")).warn)(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"" + this.id + "\".");
            var invokeConfig = (0, (0, parcelRequire("kUFUe")).flatten)(this.invoke.map(function(invokeDef) {
                var settleTransitions = [];
                if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)((0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)(String((0, (0, parcelRequire("g2PT9")).doneInvoke)(invokeDef.id)), invokeDef.onDone))));
                if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)((0, (0, parcelRequire("kUFUe")).toTransitionConfigArray)(String((0, (0, parcelRequire("g2PT9")).error)(invokeDef.id)), invokeDef.onError))));
                return settleTransitions;
            }));
            var delayedTransitions = this.after;
            var formattedTransitions = (0, (0, parcelRequire("kUFUe")).flatten)((0, (0, parcelRequire("dkU7z")).__spreadArray)((0, (0, parcelRequire("dkU7z")).__spreadArray)((0, (0, parcelRequire("dkU7z")).__spreadArray)((0, (0, parcelRequire("dkU7z")).__spreadArray)([], (0, (0, parcelRequire("dkU7z")).__read)(doneConfig)), (0, (0, parcelRequire("dkU7z")).__read)(invokeConfig)), (0, (0, parcelRequire("dkU7z")).__read)(onConfig)), (0, (0, parcelRequire("dkU7z")).__read)(eventlessConfig)).map(function(transitionConfig) {
                return (0, (0, parcelRequire("kUFUe")).toArray)(transitionConfig).map(function(transition) {
                    return _this.formatTransition(transition);
                });
            }));
            try {
                for(var delayedTransitions_1 = (0, (0, parcelRequire("dkU7z")).__values)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                    var delayedTransition = delayedTransitions_1_1.value;
                    formattedTransitions.push(delayedTransition);
                }
            } catch (e_9_1) {
                e_9 = {
                    error: e_9_1
                };
            } finally{
                try {
                    if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
                } finally{
                    if (e_9) throw e_9.error;
                }
            }
            return formattedTransitions;
        };
        return StateNode;
    }();
});
parcelRegister("dOiWf", function(module, exports) {
    $parcel$export(module.exports, "toInvokeDefinition", ()=>$a0dea2a4f692cc38$export$4c73f685ba879446);
    var $dkU7z;
    var $knNkr;
    function $a0dea2a4f692cc38$export$436e852aa2feda95(src) {
        if (typeof src === 'string') {
            var simpleSrc = {
                type: src
            };
            simpleSrc.toString = function() {
                return src;
            };
            return simpleSrc;
        }
        return src;
    }
    function $a0dea2a4f692cc38$export$4c73f685ba879446(invokeConfig) {
        return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({
            type: (0, (0, parcelRequire("knNkr")).invoke)
        }, invokeConfig), {
            toJSON: function() {
                var onDone = invokeConfig.onDone, onError = invokeConfig.onError, invokeDef = (0, (0, parcelRequire("dkU7z")).__rest)(invokeConfig, [
                    "onDone",
                    "onError"
                ]);
                return (0, (0, parcelRequire("dkU7z")).__assign)((0, (0, parcelRequire("dkU7z")).__assign)({}, invokeDef), {
                    type: (0, (0, parcelRequire("knNkr")).invoke),
                    src: $a0dea2a4f692cc38$export$436e852aa2feda95(invokeConfig.src)
                });
            }
        });
    }
});
parcelRegister("h1WZC", function(module, exports) {
    $parcel$export(module.exports, "useCreateAnalyticsFlow", ()=>$ceeec3b3876a6a81$export$b26e0d212ef01829);
    $parcel$export(module.exports, "AnalyticsFlowContextProvider", ()=>$ceeec3b3876a6a81$export$b8f39b5859612546);
    $parcel$export(module.exports, "useAnalyticsFlow", ()=>$ceeec3b3876a6a81$export$8af1809310de64fa);
    $parcel$export(module.exports, "useAnalyticsFlowEventsQueue", ()=>$ceeec3b3876a6a81$export$f06fb39743945e19);
    var $5uXOq = parcelRequire("5uXOq");
    var $cNlTG;
    var $kb0r3;
    function $ceeec3b3876a6a81$export$b26e0d212ef01829({ invokeAttributes: invokeAttributes }) {
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("cNlTG"))._useFireAIAnalyticsEvent)();
        let analyticsFlowRef = (0, ($parcel$interopDefault($5uXOq))).useRef();
        if (!analyticsFlowRef.current) analyticsFlowRef.current = (0, (0, parcelRequire("kb0r3")).createAnalyticsFlow)({
            fireAIAnalyticsEvent: fireAIAnalyticsEvent,
            invokeAttributes: invokeAttributes
        });
        return analyticsFlowRef.current;
    }
    const $ceeec3b3876a6a81$var$AnalyticsFlowContext = (0, ($parcel$interopDefault($5uXOq))).createContext(undefined);
    const $ceeec3b3876a6a81$export$b8f39b5859612546 = $ceeec3b3876a6a81$var$AnalyticsFlowContext.Provider;
    const $ceeec3b3876a6a81$export$8af1809310de64fa = ()=>{
        const analyticsFlowInstance = (0, ($parcel$interopDefault($5uXOq))).useContext($ceeec3b3876a6a81$var$AnalyticsFlowContext);
        if (!analyticsFlowInstance) throw new Error('No analyticsFlowInstance available in the context, make sure to have container wrapped with AnalyticsFlowContextProvider');
        return analyticsFlowInstance;
    };
    function $ceeec3b3876a6a81$export$f06fb39743945e19({ stepName: stepName, attributes: attributes }) {
        const analyticsFlow = $ceeec3b3876a6a81$export$8af1809310de64fa();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            analyticsFlow.fireQueuedStep(stepName);
            return ()=>{
                analyticsFlow.enqueueStep({
                    stepName: stepName,
                    attributes: attributes
                });
            };
        }, []);
        return analyticsFlow;
    }
});
parcelRegister("cNlTG", function(module, exports) {
    $parcel$export(module.exports, "_useFireAIAnalyticsEvent", ()=>$1289687670d0f481$export$208739d1cee71469);
    var $9m3ZB;
    const $1289687670d0f481$export$208739d1cee71469 = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent);
});
parcelRegister("9Ocgt", function(module, exports) {
    $parcel$export(module.exports, "mapConfigItemsToQuickInsertItems", ()=>$8c91e85effed242b$export$f3e5bb240cf24df5);
    var $5uXOq = parcelRequire("5uXOq");
    var $gmhCD = parcelRequire("gmhCD");
    var $3cfam;
    var $ksZXn;
    var $PwAM5;
    function $8c91e85effed242b$export$f3e5bb240cf24df5({ configItems: configItems, formatMessage: formatMessage, aiGlobalOptIn: aiGlobalOptIn, editorView: editorView }) {
        const aiPriorities = 9000;
        const dispatch = editorView.dispatch;
        return configItems.filter((configItem)=>{
            if (configItem.isPrefill && (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true)) return false;
            const isVisible = configItem.isVisible({
                editorView: editorView
            });
            if (configItem.key.startsWith?.('Translate to')) {
                if (isVisible) return true;
                return false;
            }
            return isVisible;
        }).map((configItem)=>({
                priority: configItem.quickInsertPriority ?? aiPriorities,
                categories: [
                    'AI'
                ],
                title: (0, (0, parcelRequire("PwAM5")).getTranslatedItemTitle)(configItem, formatMessage),
                description: formatMessage(configItem.description || configItem.title),
                keywords: [
                    'ai',
                    'generate',
                    (0, (0, parcelRequire("PwAM5")).getTranslatedItemTitle)(configItem, formatMessage)
                ],
                icon: ()=>{
                    return configItem.icon ? configItem.icon({
                        formatMessage: formatMessage,
                        shownAt: 'quickInsert'
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ksZXn")).Logo), null);
                },
                action: (insert, editorState)=>{
                    requestAnimationFrame(()=>{
                        const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                            state: editorView.state,
                            configItem: configItem,
                            lastTriggeredFrom: 'quickInsert',
                            aiGlobalOptIn: aiGlobalOptIn
                        });
                        openAIModalCommand(editorView.state, dispatch);
                    });
                    const transaction = insert('');
                    return transaction;
                }
            }));
    }
});
parcelRegister("ksZXn", function(module, exports) {
    $parcel$export(module.exports, "Logo", ()=>$90a415de2c8abae6$export$e6ff31bff12b7ff4);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $i0hyP;
    var $10VaV;
    const $90a415de2c8abae6$export$e6ff31bff12b7ff4 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0hyP")).LogoSvg), {
            alt: formatMessage((0, (0, parcelRequire("10VaV")).default).logoAltText)
        });
    };
});
parcelRegister("i0hyP", function(module, exports) {
    $parcel$export(module.exports, "LogoSvg", ()=>$313146e68a4db072$export$77af5b11f07c3aed);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    const $313146e68a4db072$export$77af5b11f07c3aed = ({ alt: alt, isDisabled: isDisabled = false, isSelected: isSelected = false, className: className, size: size = 24, isPadded: isPadded = true, style: style = {} })=>{
        const stroke = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : isSelected ? "var(--ds-icon-selected, #091E424F)" : "var(--ds-icon, #44546F)";
        const commonProps = {
            width: size,
            height: size,
            className: className,
            role: alt === '' ? 'presentation' : undefined,
            xmlns: 'http://www.w3.org/2000/svg',
            style: style
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            ...commonProps,
            viewBox: isPadded ? '0 0 24 24' : '0 0 16 16'
        }, alt && (0, (0, parcelRequire("f8Sb3")).jsx)("title", null, alt), isPadded ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.5 14.5L17.5 17.5",
            stroke: stroke,
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.5 14.5L6.5 17.5",
            stroke: stroke,
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.5 9.5L6.5 6.5",
            stroke: stroke,
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.5 9.5L17.5 6.5",
            stroke: stroke,
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M12.0001 16V19",
            stroke: stroke,
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M8.00012 12L5.00012 12",
            stroke: stroke,
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M12.0001 8.00002L12.0001 4.99999",
            stroke: stroke,
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M16.0002 12L19.0002 12",
            stroke: stroke,
            strokeWidth: "1.5"
        })) : (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.24999 4V1H8.74999V4H7.24999ZM5.46966 6.53033L1.46966 2.53033L2.53032 1.46967L6.53032 5.46967L5.46966 6.53033ZM9.46966 5.46967L13.4697 1.46967L14.5303 2.53033L10.5303 6.53033L9.46966 5.46967ZM0.999992 7.25H3.99999V8.75H0.999992V7.25ZM12 7.25H15V8.75H12V7.25ZM1.46966 13.4697L5.46966 9.46967L6.53032 10.5303L2.53032 14.5303L1.46966 13.4697ZM13.4697 14.5303L9.46966 10.5303L10.5303 9.46967L14.5303 13.4697L13.4697 14.5303ZM7.24999 15V12H8.74999V15H7.24999Z",
            fill: "currentColor"
        }));
    };
});
parcelRegister("10VaV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40c3dc56c331fc2e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $40c3dc56c331fc2e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aupViolationMessage: {
            id: 'fabric.editor.ai.experience.aupViolationMessage',
            defaultMessage: 'Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content.',
            description: 'Message to indicate to user their prompt or content (this can be a range of content, such as a selection or document -- we used content to keep it vague -- as this will change without user knowing) has been detected as violating Atlassians acceptable use policy.  Note the markdown link -- this is expected to remain as markdown as this string is converted to html.'
        },
        documentInsertError: {
            id: 'fabric.editor.ai.experience-application.documentInsertError',
            defaultMessage: `We're having trouble inserting the response. Close the dialog and try again.`,
            description: 'Message to users that displays when error happens during document insertion.'
        },
        tokenLimitExceeded: {
            id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
            defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
            description: 'Message to users that displays when their request has exceeded the maximum input or output limit.'
        },
        rateLimitEnforced: {
            id: 'fabric.editor.ai.experience-application.rateLimitEnforced',
            defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>.",
            description: 'Message to users that rate limiting has been enforced.'
        },
        apiError: {
            id: 'fabric.editor.ai.experience.apiError',
            defaultMessage: `We couldn\u{2019}t get a response, please try again.`,
            description: `We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)`
        },
        elevateDisabledGenerateError: {
            id: 'fabric.editor.ai.experience.elevateDisabledGenetateError',
            defaultMessage: `Free generate is disabled in Elevate at this time.`,
            description: `Message to let internal users know that the free generate editor ai feature is is disabled in Elevate at this time.`
        },
        internalServerError: {
            id: 'fabric.editor.ai.experience.internalServerError',
            defaultMessage: `Atlassian Intelligence (AI) isn\u{2019}t responding. Try again later or <link>check the status of AI</link>.`,
            description: `We couldn't get a response due to an internal server error.`
        },
        inputTooShortError: {
            id: 'fabric.editor.ai.experience.inputTooShortError',
            defaultMessage: `The content is too short to summarize. Please add more and try again.`,
            description: `The input was too short to summarize`
        },
        hipaaContentError: {
            id: 'fabric.editor.ai.experience.hipaaContentError',
            defaultMessage: `Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again.`,
            description: `The input contained HIPAA content`
        },
        logoAltText: {
            id: 'fabric.editor.ai.screens.prompt.logoAltText',
            defaultMessage: 'Atlassian Intelligence Logo',
            description: 'Atlassian Intelligence logo alt text of the Prompt screen'
        },
        floatingAiButtonTooltip: {
            id: 'fabric.editor.ai.floatingAiButton.tooltip',
            defaultMessage: 'Tell Atlassian Intelligence to write anything',
            description: 'The tooltip text for the floating button that invokes AI modal'
        },
        loadingIconAltText: {
            id: 'fabric.editor.ai.proactive.loading.iconAltText.non-final',
            defaultMessage: 'Loading icon',
            description: 'Icon alt text of the Loading icon'
        }
    });
});
parcelRegister("PwAM5", function(module, exports) {
    $parcel$export(module.exports, "isInitialContextSelectionRange", ()=>$b7e4b7c192078f99$export$2c6858d7c847006);
    $parcel$export(module.exports, "createEditorPluginAIConfigItemMarkdown", ()=>$b7e4b7c192078f99$export$c155edbb8a393939);
    $parcel$export(module.exports, "getTranslatedItemTitle", ()=>$b7e4b7c192078f99$export$d97f37f32ae9d000);
    $parcel$export(module.exports, "getTranslatedPromptLabel", ()=>$b7e4b7c192078f99$export$4539b8c6808af330);
    function $b7e4b7c192078f99$export$2c6858d7c847006(value) {
        return 'selection' in value && typeof value.selection === 'string';
    }
    function $b7e4b7c192078f99$export$c155edbb8a393939(editorPluginAIConfigItem) {
        return editorPluginAIConfigItem;
    }
    function $b7e4b7c192078f99$export$d97f37f32ae9d000(configItem, formatMessage) {
        if (configItem.agent) {
            const presetTitle = `@${configItem.agent.name}`;
            return presetTitle || formatMessage(configItem.title);
        }
        if (configItem.key.startsWith('Translate to')) return formatMessage(configItem.title);
        return formatMessage(configItem.title);
    }
    function $b7e4b7c192078f99$export$4539b8c6808af330(configItem, formatMessage) {
        if (configItem.agent) return `@${configItem.agent.name}`;
        return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
    }
});
parcelRegister("l8xBy", function(module, exports) {
    $parcel$export(module.exports, "getContextPanel", ()=>$b70e8aae29a49e7b$export$7c8c60c0acb92731);
    var $5uXOq = parcelRequire("5uXOq");
    var $awTmI;
    var $etG8M;
    var $cCAIN;
    var $lBepp;
    var $ldiyo;
    var $jSlH9;
    var $aa2IN;
    const $b70e8aae29a49e7b$export$7c8c60c0acb92731 = (getEditorView)=>(api)=>(state)=>{
                const proactivePluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
                if (!proactivePluginState) return null;
                const { isProactiveEnabled: isProactiveEnabled, isProactiveContextPanelOpen: isProactiveContextPanelOpen } = proactivePluginState;
                if (!isProactiveEnabled || !isProactiveContextPanelOpen) return null;
                const decorationPluginState = (0, (0, parcelRequire("jSlH9")).getPluginState)(state);
                if (decorationPluginState.modalDecorationSet !== (0, (0, parcelRequire("etG8M")).DecorationSet).empty) return null;
                const editorView = getEditorView?.();
                return (0, ($parcel$interopDefault($5uXOq))).createElement($b70e8aae29a49e7b$var$ContextPanel, {
                    api: api,
                    editorView: editorView
                });
            };
    const $b70e8aae29a49e7b$var$ContextPanel = ({ api: api, editorView: editorView })=>{
        const { aiExperienceState: aiExperienceState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'aiExperience'
        ]);
        if (!aiExperienceState) return null;
        const { isSpellingGrammarEnabled: isSpellingGrammarEnabled, spellingGrammarErrorCount: spellingGrammarErrorCount, recommendations: recommendations, selectedRecommendationId: selectedRecommendationId, hoveredRecommendationId: hoveredRecommendationId } = aiExperienceState;
        if (!recommendations) return null;
        const triggerLocation = 'contextPanel';
        const runCommand = (command)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            command(state, dispatch);
        };
        const onRecommendationApply = ({ recommendation: recommendation })=>{
            runCommand((0, (0, parcelRequire("cCAIN")).insertRecommendation)(recommendation.id, triggerLocation));
        };
        const onRecommendationDismiss = ({ recommendation: recommendation })=>{
            runCommand((0, (0, parcelRequire("cCAIN")).removeRecommendation)(recommendation.id, triggerLocation));
        };
        const onRecommendationSelect = ({ recommendation: recommendation })=>{
            runCommand((0, (0, parcelRequire("cCAIN")).selectRecommendation)(recommendation.id));
        };
        const onRecommendationHover = ({ recommendation: recommendation })=>{
            runCommand((0, (0, parcelRequire("cCAIN")).hoverRecommendation)(recommendation.id));
        };
        const onRecommendationLeave = ({ recommendation: recommendation })=>{
            runCommand((0, (0, parcelRequire("cCAIN")).clearHoverRecommendation)());
        };
        const onPanelClose = ()=>{
            runCommand((0, (0, parcelRequire("cCAIN")).toggleProactiveAISuggestionDisplay)(triggerLocation));
        };
        const onSpellingGrammar = ()=>{
            runCommand((0, (0, parcelRequire("ldiyo")).selectFirstSuggestion)());
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aa2IN")).RecommendationPanel), {
            isSpellingGrammarEnabled: isSpellingGrammarEnabled,
            spellingGrammarErrorCount: spellingGrammarErrorCount,
            recommendations: recommendations,
            hoveredRecommendationId: hoveredRecommendationId,
            selectedRecommendationId: selectedRecommendationId,
            onRecommendationApply: onRecommendationApply,
            onRecommendationDismiss: onRecommendationDismiss,
            onRecommendationSelect: onRecommendationSelect,
            onRecommendationHover: onRecommendationHover,
            onRecommendationLeave: onRecommendationLeave,
            onSpellingGrammar: onSpellingGrammar,
            onPanelClose: onPanelClose
        });
    };
});
parcelRegister("cCAIN", function(module, exports) {
    $parcel$export(module.exports, "insertRecommendation", ()=>$b83108907b55ca19$export$5bd24bdab2969c9a);
    $parcel$export(module.exports, "removeRecommendation", ()=>$b83108907b55ca19$export$39ad9a29966d7866);
    $parcel$export(module.exports, "toggleProactiveAISuggestionDisplay", ()=>$b83108907b55ca19$export$816969b84787d134);
    $parcel$export(module.exports, "closeProactiveAISuggestionDisplay", ()=>$b83108907b55ca19$export$f1078e6a82225775);
    $parcel$export(module.exports, "hoverRecommendation", ()=>$b83108907b55ca19$export$232b8b86f04a92b4);
    $parcel$export(module.exports, "clearHoverRecommendation", ()=>$b83108907b55ca19$export$48317d1b322bd917);
    $parcel$export(module.exports, "selectRecommendation", ()=>$b83108907b55ca19$export$8b8b195e2dbac90e);
    $parcel$export(module.exports, "clearSelectRecommendation", ()=>$b83108907b55ca19$export$c8ffd38f01d30207);
    $parcel$export(module.exports, "fireAPIError", ()=>$b83108907b55ca19$export$2dc339159f279770);
    $parcel$export(module.exports, "createTriggerProactiveCheck", ()=>$b83108907b55ca19$export$79cc9df47f79ea57);
    var $lFKmC = parcelRequire("lFKmC");
    var $gkwXh;
    var $gZGBX;
    var $9m3ZB;
    var $50Pvo;
    var $i0gVe;
    var $btfve;
    var $eA5Z5;
    var $lBepp;
    var $5wKtX;
    var $b2OAx;
    const $b83108907b55ca19$export$5bd24bdab2969c9a = (recommendationId, triggeredFrom)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet, insertionCount: insertionCount, proactiveAIBlocks: proactiveAIBlocks } = pluginState;
            if (!proactiveAIBlocks?.length || !(0, (0, parcelRequire("b2OAx")).hasRecommendation)(pluginState, recommendationId)) return false;
            const updatedProactiveAIBlocks = (0, (0, parcelRequire("b2OAx")).removeRecommendationFromBlocks)(proactiveAIBlocks, recommendationId);
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateAllDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            proactiveAIBlocks: updatedProactiveAIBlocks
                        }
                    }),
                    proactiveAIBlocks: updatedProactiveAIBlocks,
                    insertionCount: insertionCount + 1
                }
            };
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            if ((0, (0, parcelRequire("b2OAx")).hasRecommendation)(pluginState, recommendationId)) {
                const { block: block, recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(pluginState, recommendationId);
                if (block && recommendation) {
                    const { from: from, to: to } = block;
                    const { transformContent: transformContent, transformAction: transformAction, transformType: transformType } = recommendation;
                    if (transformContent) return (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                        editorState: state,
                        addToHistory: true,
                        tr: (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                            editorState: state,
                            addToHistory: true,
                            tr: tr,
                            payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('actioned', pluginState.analyticsAIInteractionId, recommendation.transformAction, true, {
                                aiResultAction: 'recommendationAccepted'
                            })
                        }),
                        payload: {
                            action: 'inserted',
                            actionSubject: 'editorPluginAI',
                            actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                            attributes: {
                                aiInteractionID: pluginState.analyticsAIInteractionId,
                                triggeredFrom: triggeredFrom,
                                transformAction: transformAction,
                                transformType: transformType
                            },
                            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                        }
                    }).setMeta('suggestionAccepted', true).replaceWith(from, to, transformContent.content);
                }
            }
            return tr;
        });
    const $b83108907b55ca19$export$39ad9a29966d7866 = (recommendationId, triggeredFrom)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet, proactiveAIBlocks: proactiveAIBlocks, dismissedCount: dismissedCount } = pluginState;
            if (!proactiveAIBlocks?.length || !(0, (0, parcelRequire("b2OAx")).hasRecommendation)(pluginState, recommendationId)) return false;
            const updatedProactiveAIBlocks = (0, (0, parcelRequire("b2OAx")).removeRecommendationFromBlocks)(proactiveAIBlocks, recommendationId);
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateAllDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            proactiveAIBlocks: updatedProactiveAIBlocks
                        }
                    }),
                    proactiveAIBlocks: updatedProactiveAIBlocks,
                    dismissedCount: dismissedCount + 1
                }
            };
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(pluginState, recommendationId);
            if (recommendation) {
                const { transformAction: transformAction, transformType: transformType } = recommendation;
                return (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: state,
                    addToHistory: false,
                    tr: (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                        editorState: state,
                        addToHistory: false,
                        tr: tr,
                        payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('dismissed', pluginState.analyticsAIInteractionId, recommendation.transformAction, true)
                    }),
                    payload: {
                        action: 'dismissed',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                        attributes: {
                            aiInteractionID: pluginState.analyticsAIInteractionId,
                            triggeredFrom: triggeredFrom,
                            transformAction: transformAction,
                            transformType: transformType
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                    }
                });
            }
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$816969b84787d134 = (triggeredFrom)=>(0, (0, parcelRequire("lBepp")).createCommand)(()=>({
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).TOGGLE_PROACTIVE_CONTEXT_PANEL
            }), (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { isProactiveContextPanelOpen: isProactiveContextPanelOpen } = pluginState;
            return (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: state,
                addToHistory: false,
                tr: tr,
                payload: {
                    action: 'toggled',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                    attributes: {
                        toggledToValue: !isProactiveContextPanelOpen,
                        triggeredFrom: triggeredFrom
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }
            });
        });
    const $b83108907b55ca19$export$f1078e6a82225775 = (triggeredFrom)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { isProactiveContextPanelOpen: isProactiveContextPanelOpen } = pluginState;
            if (!isProactiveContextPanelOpen) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).TOGGLE_PROACTIVE_CONTEXT_PANEL
            };
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { isProactiveContextPanelOpen: isProactiveContextPanelOpen } = pluginState;
            return (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: state,
                addToHistory: false,
                tr: tr,
                payload: {
                    action: 'toggled',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                    attributes: {
                        toggledToValue: !isProactiveContextPanelOpen,
                        triggeredFrom: triggeredFrom
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
                }
            });
        });
    const $b83108907b55ca19$export$232b8b86f04a92b4 = (recommendationId)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet, proactiveAIBlocks: proactiveAIBlocks, allowInlineHoverHighlightWhileRecommendationSelected: allowInlineHoverHighlightWhileRecommendationSelected, selectedRecommendationId: selectedRecommendationId } = pluginState;
            if (!proactiveAIBlocks?.length || !(0, (0, parcelRequire("b2OAx")).hasRecommendation)(pluginState, recommendationId)) return false;
            if (!allowInlineHoverHighlightWhileRecommendationSelected && !!selectedRecommendationId) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateHoverDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            hoveredRecommendationId: recommendationId
                        }
                    }),
                    hoveredRecommendationId: recommendationId
                }
            };
        }, (tr, state)=>{
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$48317d1b322bd917 = ()=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet, hoveredRecommendationId: hoveredRecommendationId } = pluginState;
            if (!hoveredRecommendationId) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateHoverDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            hoveredRecommendationId: undefined
                        }
                    }),
                    hoveredRecommendationId: undefined
                }
            };
        }, (tr, state)=>{
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$8b8b195e2dbac90e = (recommendationId)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { proactiveAIBlocks: proactiveAIBlocks, selectedRecommendationId: selectedRecommendationId } = pluginState;
            if (recommendationId === selectedRecommendationId || !proactiveAIBlocks?.length || !(0, (0, parcelRequire("b2OAx")).hasRecommendation)(pluginState, recommendationId)) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).SELECT_PROACTIVE_RECOMMENDATION,
                data: {
                    selectedRecommendationId: recommendationId
                }
            };
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet } = pluginState;
            const { recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(pluginState, recommendationId);
            if (recommendation) {
                const inlineDeco = decorationSet.find(undefined, undefined, (spec)=>{
                    return spec.key === (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION && spec.blockId === recommendation.chunkId;
                })?.[0];
                if (inlineDeco) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, inlineDeco.from + 1));
            }
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$c8ffd38f01d30207 = ()=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { selectedRecommendationId: selectedRecommendationId } = pluginState;
            if (!selectedRecommendationId) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    selectedRecommendationId: undefined
                }
            };
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            const { decorationSet: decorationSet, selectedRecommendationId: selectedRecommendationId } = pluginState;
            if (selectedRecommendationId) {
                const { recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(pluginState, selectedRecommendationId);
                if (recommendation) {
                    const inlineDeco = decorationSet.find(undefined, undefined, (spec)=>{
                        return spec.key === (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION && spec.blockId === recommendation.chunkId;
                    })?.[0];
                    if (inlineDeco) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, inlineDeco.to + 1));
                }
            }
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$2dc339159f279770 = (transform)=>(0, (0, parcelRequire("lBepp")).createCommand)((0, (0, parcelRequire("5wKtX")).ACTIONS).API_ERROR, (tr, state)=>{
            if (transform) return transform(tr, state).setMeta('addToHistory', false);
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$a008f2dbfa1f1c43 = (showNotification)=>(0, (0, parcelRequire("lBepp")).createCommand)((state)=>{
            const { showNewRecommendationsNotification: showNewRecommendationsNotification } = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
            if (!!showNewRecommendationsNotification === showNotification) return false;
            return {
                type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    showNewRecommendationsNotification: showNotification
                }
            };
        }, (tr, state)=>{
            return tr.setMeta('addToHistory', false);
        });
    const $b83108907b55ca19$export$1ec1b2c1991d7242 = async (chunks, context)=>{
        const { view: view } = context;
        const pluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(view.state);
        const { proactiveAIApiUrl: proactiveAIApiUrl, product: product } = pluginState;
        const requestGenerator = (0, (0, parcelRequire("50Pvo")).fetchAIParagraphs)(proactiveAIApiUrl, product, context)(chunks);
        if (!requestGenerator) return;
        for await (const responseState of requestGenerator)switch(responseState.state){
            case 'cached':
            case 'parsed':
                {
                    const recommendations = responseState.recommendations;
                    const newPluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(view.state);
                    const { decorationSet: decorationSet, proactiveAIBlocks: proactiveAIBlocks } = newPluginState;
                    if (!proactiveAIBlocks?.length) break;
                    const chunkIdsMissingRecommendations = chunks.reduce((acc, chunk)=>{
                        if (!recommendations.some((r)=>r.chunkId === chunk.id)) acc.add(chunk.id);
                        return acc;
                    }, new Set());
                    const updatedProactiveAIBlocks = (0, (0, parcelRequire("b2OAx")).syncProactiveRecommendations)(newPluginState, recommendations, chunkIdsMissingRecommendations);
                    const updatePluginCommand = (0, (0, parcelRequire("lBepp")).createCommand)(()=>{
                        return {
                            type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                            data: {
                                proactiveAIBlocks: updatedProactiveAIBlocks,
                                showNewRecommendationsNotification: recommendations.length > 0,
                                decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateAllDecorations)({
                                    decorationSet: decorationSet,
                                    tr: view.state.tr,
                                    pluginState: {
                                        ...newPluginState,
                                        proactiveAIBlocks: updatedProactiveAIBlocks
                                    }
                                })
                            }
                        };
                    }, (tr, state)=>{
                        return tr.setMeta('addToHistory', false);
                    });
                    updatePluginCommand(view.state, view.dispatch);
                    break;
                }
            case 'trackedDuration':
                {
                    const newPluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(view.state);
                    const { insertionCount: insertionCount, dismissedCount: dismissedCount } = newPluginState;
                    (0, (0, parcelRequire("i0gVe")).fireAPIReceivedAnalytics)({
                        view: view,
                        duration: responseState.duration,
                        totalSuggestions: (0, (0, parcelRequire("b2OAx")).getAllRecommendations)(newPluginState).length,
                        totalAcceptedSuggestions: insertionCount,
                        totalDismissedSuggestions: dismissedCount
                    });
                    break;
                }
            case 'failed':
                if (responseState.failedChunkIds.length > 0) (0, (0, parcelRequire("i0gVe")).fireAPIErrorWithAnalytics)({
                    view: view,
                    failedChunkIds: responseState.failedChunkIds,
                    errors: responseState.errors,
                    reason: responseState.reason,
                    statusCode: responseState.statusCode
                })(view.state, view.dispatch);
                break;
        }
        $b83108907b55ca19$var$stopNewRecommendationsNotification(view);
    };
    const $b83108907b55ca19$var$stopNewRecommendationsNotification = (0, ($parcel$interopDefault($lFKmC)))((view)=>$b83108907b55ca19$export$a008f2dbfa1f1c43(false)(view.state, view.dispatch), 3000);
    const $b83108907b55ca19$var$isSelectionInBlock = (from, to, block)=>{
        return block.from <= from && block.to >= from || block.from <= to && block.to >= to;
    };
    const $b83108907b55ca19$var$getBlocksNeedingCheck = (state, currentBlocks)=>{
        const { from: from, to: to } = state.selection;
        const { proactiveAIBlocks: proactiveAIBlocks } = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
        return proactiveAIBlocks.filter((block)=>!!block.invalidated).filter((block)=>{
            const selectionInBlock = $b83108907b55ca19$var$isSelectionInBlock(from, to, block);
            return currentBlocks ? selectionInBlock : !selectionInBlock;
        });
    };
    const $b83108907b55ca19$var$triggerCheckForCurrentBlocks = async (context)=>{
        const chunks = $b83108907b55ca19$var$getBlocksNeedingCheck(context.view.state, true);
        if (chunks.length) await $b83108907b55ca19$export$1ec1b2c1991d7242(chunks, context);
    };
    const $b83108907b55ca19$var$triggerCheckForNonCurrentBlocks = async (context)=>{
        const chunks = $b83108907b55ca19$var$getBlocksNeedingCheck(context.view.state, false);
        if (chunks.length) await $b83108907b55ca19$export$1ec1b2c1991d7242(chunks, context);
    };
    const $b83108907b55ca19$export$79cc9df47f79ea57 = (timings)=>{
        const triggerForNonCurrentBlocksThrottled = (0, ($parcel$interopDefault($lFKmC)))($b83108907b55ca19$var$triggerCheckForNonCurrentBlocks, timings.nonCurrentChunks);
        const triggerForCurrentBlocksDebounced = (0, ($parcel$interopDefault($lFKmC)))($b83108907b55ca19$var$triggerCheckForCurrentBlocks, timings.currentChunks, {
            maxWait: timings.currentChunksMaxWait
        });
        const triggerProactiveCheck = (context)=>{
            timings.nonCurrentChunks >= 0 && triggerForNonCurrentBlocksThrottled(context);
            timings.currentChunks >= 0 && triggerForCurrentBlocksDebounced(context);
        };
        const cancelDebouncedAndThrottledCheck = ()=>{
            triggerForNonCurrentBlocksThrottled.cancel();
            triggerForCurrentBlocksDebounced.cancel();
        };
        return {
            triggerProactiveCheck: triggerProactiveCheck,
            cancelDebouncedAndThrottledCheck: cancelDebouncedAndThrottledCheck
        };
    };
});
parcelRegister("50Pvo", function(module, exports) {
    $parcel$export(module.exports, "fetchAIParagraphs", ()=>$a17b442526ea87a4$export$ff0b89bde37d855d);
    var $fdkfY;
    const $a17b442526ea87a4$export$f795cf8a51531ffb = (chunk)=>chunk.from === chunk.to || !chunk.text || !chunk.text.trim().length;
    const $a17b442526ea87a4$export$ff0b89bde37d855d = (proactiveAIApiUrl, product, context)=>(paragraphs)=>{
            const included = paragraphs.filter((chunk)=>!$a17b442526ea87a4$export$f795cf8a51531ffb(chunk));
            if (!!included.length) return (0, (0, parcelRequire("fdkfY")).requestGenerator)({
                endpoint: proactiveAIApiUrl,
                paragraphs: included,
                product: product,
                context: context
            });
            return;
        };
});
parcelRegister("fdkfY", function(module, exports) {
    $parcel$export(module.exports, "requestGenerator", ()=>$bee9de2028abe303$export$1066436a67f28ca8);
    var $ifg6x = parcelRequire("ifg6x");
    var $hYNZx;
    var $gIHA4;
    var $9YAmQ;
    var $btfve;
    function $bee9de2028abe303$var$isValidResponse(response) {
        return typeof response === 'object' && response !== null && 'ai_feature_output' in response;
    }
    function $bee9de2028abe303$var$isErrorResponse(response) {
        return typeof response === 'object' && response !== null && 'errorMessage' in response && 'errors' in response && 'statusCode' in response;
    }
    const $bee9de2028abe303$var$sanitizeUrl = (url)=>url.replace(/[^\w\-/.:%?=]+/g, '');
    const $bee9de2028abe303$var$getParagraphChunkWithADF = async (doc, chunk, context)=>{
        const { view: view, getMentionNameDetails: getMentionNameDetails } = context;
        const { from: from, to: to } = chunk;
        const content = doc.nodeAt(from);
        if (!content) return;
        let mentionMap;
        if (getMentionNameDetails) mentionMap = await (0, (0, parcelRequire("9YAmQ")).getMentionMap)({
            node: content,
            getMentionNameDetails: getMentionNameDetails
        });
        const before = doc.resolve(from).nodeBefore;
        const after = doc.resolve(to).nodeAfter;
        const serializer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)(view.state.schema, mentionMap);
        return {
            ...chunk,
            content: serializer.encodeNode(content),
            before: before && before.textContent.trim().length !== 0 ? serializer.encodeNode(before) : undefined,
            after: after && after.textContent.trim().length !== 0 ? serializer.encodeNode(after) : undefined
        };
    };
    async function $bee9de2028abe303$var$parseResponse(response) {
        try {
            const body = await response.json();
            if ($bee9de2028abe303$var$isValidResponse(body)) return {
                state: 'success',
                body: body
            };
            if ($bee9de2028abe303$var$isErrorResponse(body)) return {
                state: 'failed',
                reason: 'backend',
                errors: [
                    body.errorMessage,
                    ...body.errors
                ],
                statusCode: body.statusCode
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                errors: [
                    'parsingError'
                ],
                statusCode: response.status
            };
        }
        if (!response.body) return {
            state: 'failed',
            reason: 'network',
            errors: [
                'response.body missing'
            ],
            statusCode: response.status
        };
        return {
            state: 'failed',
            reason: 'backend',
            errors: [
                'Invalid response'
            ],
            statusCode: response.status
        };
    }
    async function* $bee9de2028abe303$export$1066436a67f28ca8({ endpoint: endpoint, paragraphs: paragraphs, product: product, context: context }) {
        if (!paragraphs.length) {
            yield {
                state: 'done'
            };
            return;
        }
        const { view: editorView, locale: locale } = context;
        const doc = editorView.state.doc;
        const abortController = new AbortController();
        const purgedChunkIds = [];
        const totalParts = paragraphs.length;
        let attemptCount = 0;
        const [withinLimitsParagraphChunks, exceededLimitsParagraphChunks] = (0, ($parcel$interopDefault($ifg6x)))(paragraphs, (p)=>p.text.length <= (0, (0, parcelRequire("btfve")).PART_MAX_SIZE));
        purgedChunkIds.push(...exceededLimitsParagraphChunks.map((p)=>p.id));
        while(withinLimitsParagraphChunks.length && attemptCount <= (0, (0, parcelRequire("btfve")).QUEUE_MAX_ADDITIONAL_ATTEMPTS)){
            attemptCount++;
            const queue = [];
            let queueTotalPartsSize = 0;
            while(withinLimitsParagraphChunks.length && queueTotalPartsSize + withinLimitsParagraphChunks[0].text.length <= (0, (0, parcelRequire("btfve")).TOTAL_PARTS_MAX_SIZE) && queue.length <= (0, (0, parcelRequire("btfve")).MAX_PARTS)){
                const withinLimitsParagraphChunk = withinLimitsParagraphChunks.shift();
                if (!withinLimitsParagraphChunk) break;
                queueTotalPartsSize += withinLimitsParagraphChunk.text.length;
                const paragraphChunkWithADF = await $bee9de2028abe303$var$getParagraphChunkWithADF(doc, withinLimitsParagraphChunk, context);
                if (paragraphChunkWithADF) queue.push(paragraphChunkWithADF);
            }
            if (!queue.length) break;
            const queuedChunkIds = queue.map((p)=>p.id);
            try {
                const payload = {
                    ai_feature_input: {
                        triggers: queue.map((chunk)=>({
                                trigger_id: chunk.id,
                                content_url: $bee9de2028abe303$var$sanitizeUrl(document.location.href),
                                trigger_type: 'PARAGRAPH_COMPLETE',
                                paragraph_content: chunk.content,
                                before_context: chunk.before ?? {},
                                after_context: chunk.after ?? {}
                            }))
                    }
                };
                const startTime = performance.now();
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'X-Experience-Id': 'proactive-paragraph-complete',
                        'Accept-Language': locale,
                        ...(0, (0, parcelRequire("gIHA4")).getXProductHeader)(product)
                    },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                    signal: abortController.signal,
                    mode: 'cors'
                });
                yield {
                    state: 'trackedDuration',
                    duration: performance.now() - startTime
                };
                const result = await $bee9de2028abe303$var$parseResponse(response);
                if (result.state === 'failed') {
                    yield {
                        ...result,
                        failedChunkIds: queuedChunkIds
                    };
                    break;
                }
                const { triggers: triggers } = result.body.ai_feature_output;
                const errors = triggers.reduce((acc, trigger)=>{
                    if ('errors' in trigger) acc.push(trigger.errors.error_type);
                    return acc;
                }, []);
                const serializer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)(editorView.state.schema);
                const recommendations = triggers.reduce((acc, trigger)=>{
                    if ('recommendations' in trigger) return acc.concat(trigger.recommendations.map((recommendation)=>{
                        const adf = recommendation.transformation_details.replacement_adf;
                        const replacement = adf.type !== 'doc' ? {
                            version: 1,
                            type: 'doc',
                            content: [
                                adf
                            ]
                        } : adf;
                        return {
                            chunkId: trigger.trigger_id,
                            rid: recommendation.recommendation_id,
                            id: `${trigger.trigger_id}_${recommendation.recommendation_id}`,
                            transformContent: serializer.parse(replacement),
                            transformType: recommendation.transformation_type,
                            transformAction: recommendation.recommendation_name,
                            isViewed: false
                        };
                    }));
                    return acc;
                }, []);
                yield {
                    state: 'parsed',
                    recommendations: recommendations
                };
                if (errors.length) yield {
                    state: 'failed',
                    reason: 'backend',
                    errors: errors,
                    statusCode: response.status,
                    failedChunkIds: queuedChunkIds
                };
            } catch (error) {
                if (error.name === 'AbortError') yield {
                    state: 'failed',
                    reason: 'aborted',
                    errors: [
                        'Streaming aborted'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
                else yield {
                    state: 'failed',
                    reason: 'unhandled',
                    errors: error instanceof Error && [
                        'RangeError',
                        'TypeError',
                        'TransformError'
                    ].includes(error.name) ? [
                        error.message
                    ] : [
                        'unhandled'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
            }
        }
        if (withinLimitsParagraphChunks.length) purgedChunkIds.push(...withinLimitsParagraphChunks.map((p)=>p.id));
        if (purgedChunkIds.length) yield {
            state: 'purged',
            totalParts: totalParts,
            totalPurgedParts: purgedChunkIds.length,
            purgedChunkIds: purgedChunkIds
        };
        yield {
            state: 'done'
        };
        return;
    }
});
parcelRegister("gIHA4", function(module, exports) {
    $parcel$export(module.exports, "getXProductHeader", ()=>$6ef11c95ed7d0059$export$46d5228a079b1d3);
    $parcel$export(module.exports, "startStreamingResponse", ()=>$6ef11c95ed7d0059$export$9cc8017e39eb96a2);
    var $fpzVC;
    const $6ef11c95ed7d0059$export$46d5228a079b1d3 = (product)=>{
        return {
            'X-Product': (0, (0, parcelRequire("fpzVC")).mapToConvoAIProductName)(product)
        };
    };
    async function* $6ef11c95ed7d0059$export$9cc8017e39eb96a2({ endpoint: endpoint, payload: payload, abortController: abortController, getFetchCustomHeaders: getFetchCustomHeaders, product: product, experienceId: experienceId = 'editor', channelId: channelId }) {
        try {
            let actualEndpoint = endpoint;
            if (channelId) actualEndpoint = `${endpoint}/${channelId}/message/stream`;
            const fetchInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'X-Experience-Id': experienceId,
                    ...$6ef11c95ed7d0059$export$46d5228a079b1d3(product)
                },
                body: payload,
                credentials: 'include',
                signal: abortController.signal,
                mode: 'cors'
            };
            const fetchCustomHeaders = getFetchCustomHeaders?.(endpoint, fetchInit) || {};
            const response = await fetch(actualEndpoint, {
                ...fetchInit,
                headers: {
                    ...fetchInit.headers,
                    ...fetchCustomHeaders
                }
            });
            if (!response.ok) {
                if (response.status === 400) try {
                    const knownErrors = [
                        'INPUT_TOO_SHORT_TO_SUMMARIZE',
                        'INPUT_TOO_SHORT_TO_PROCESS',
                        'INPUT_EXCEEDS_TOKEN_LIMIT'
                    ];
                    const { error: error } = await response.json();
                    if (error) {
                        if (typeof error === 'object' && 'key' in error && knownErrors.includes(error.key)) return yield {
                            state: 'failed',
                            reason: 'backend-input-guard',
                            guard: error.key,
                            statusCode: response.status
                        };
                        return yield {
                            state: 'failed',
                            reason: 'backend',
                            error: 'Unhandled error response received',
                            statusCode: response.status
                        };
                    }
                } catch (backendError) {
                    return yield {
                        state: 'failed',
                        reason: 'backend',
                        error: backendError,
                        statusCode: response.status
                    };
                }
                if (response.status === 429) {
                    let retryAfter = response.headers.get('Retry-After');
                    if (!retryAfter) retryAfter = '60';
                    return yield {
                        state: 'failed',
                        reason: 'rate-limited',
                        retryAfter: Number(retryAfter),
                        statusCode: response.status
                    };
                }
                if (response.status === 451) return yield {
                    state: 'aup-violation',
                    statusCode: 451
                };
                return yield {
                    state: 'failed',
                    reason: 'backend',
                    error: `unexpected response status: ${response.status}`,
                    statusCode: response.status
                };
            }
            if (!response.body) {
                yield {
                    state: 'failed',
                    reason: 'network',
                    error: 'response.body missing',
                    statusCode: response.status
                };
                return;
            }
            try {
                const reader = response.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let buffer = '';
                let done = false;
                while(!done){
                    const { value: value, done: doneReading } = await reader.read();
                    done = doneReading;
                    const chunkValue = decoder.decode(value);
                    buffer = buffer + chunkValue;
                    const lines = buffer.split('\n');
                    while(lines.length > 1){
                        const line = lines.shift();
                        const parsedData = JSON.parse(line);
                        if (parsedData.generatedContent === null) {
                            if (parsedData.error?.statusCode === 429) {
                                yield {
                                    state: 'failed',
                                    reason: 'rate-limited',
                                    retryAfter: 60,
                                    statusCode: 429
                                };
                                return;
                            }
                            if (parsedData.error?.key === 'RESPONSE_TOO_SIMILAR') {
                                yield {
                                    state: 'failed',
                                    reason: 'response-too-similar',
                                    statusCode: 208,
                                    data: parsedData
                                };
                                return;
                            }
                        }
                        yield {
                            state: 'loading',
                            data: parsedData
                        };
                    }
                    buffer = lines[0];
                }
                yield {
                    state: 'loaded-stream'
                };
                return;
            } catch (parsingError) {
                yield {
                    state: 'failed',
                    reason: 'parsing',
                    error: parsingError,
                    statusCode: response.status
                };
                return;
            }
        } catch (error) {
            if (error.name === 'AbortError') yield {
                state: 'failed',
                reason: 'aborted',
                error: error,
                statusCode: error.status
            };
            else if (error.cause === 'ConvoAIChannelCreationError') yield {
                state: 'failed',
                reason: 'backend',
                error: error,
                statusCode: error.status
            };
            else {
                console.error('Editor AI: startStreamingResponse()', error);
                yield {
                    state: 'failed',
                    reason: 'network',
                    error: error,
                    statusCode: error.status
                };
            }
            return;
        }
    }
});
parcelRegister("fpzVC", function(module, exports) {
    $parcel$export(module.exports, "mapToConvoAIProductName", ()=>$b09f82530986430b$export$6d6f1fb6f25ca9c);
    const $b09f82530986430b$export$6d6f1fb6f25ca9c = (product)=>{
        switch(product){
            case 'CONFLUENCE':
                return 'confluence';
            case 'JSW':
                return 'jira-software';
            case 'JWM':
                return 'jira-core';
            case 'JSM':
                return 'jsm';
            case 'JPD':
                return 'jpd';
            case 'ATLAS':
                return 'atlas';
            case 'JIRA_FAMILY':
                return 'jira';
            default:
                return 'unknown';
        }
    };
});
parcelRegister("9YAmQ", function(module, exports) {
    $parcel$export(module.exports, "getMentionMap", ()=>$569831e5db468c84$export$922d75f514df28b7);
    const $569831e5db468c84$export$922d75f514df28b7 = async ({ node: node, getMentionNameDetails: getMentionNameDetails })=>{
        const mentionMapping = {};
        const findMentions = async (node)=>{
            if (node.type.name === 'mention') {
                const mentionNameDetails = await getMentionNameDetails(node.attrs.id);
                if (mentionNameDetails) mentionMapping[node.attrs.id] = mentionNameDetails?.name;
            }
            if (node.content) {
                const promises = [];
                node.content.forEach((child)=>{
                    promises.push(findMentions(child));
                });
                await Promise.all(promises);
            }
        };
        await findMentions(node);
        return mentionMapping;
    };
});
parcelRegister("btfve", function(module, exports) {
    $parcel$export(module.exports, "PART_MAX_SIZE", ()=>$da2fd7f5d16cb6e4$export$f12c20c20eb9758);
    $parcel$export(module.exports, "TOTAL_PARTS_MAX_SIZE", ()=>$da2fd7f5d16cb6e4$export$168b97586e915764);
    $parcel$export(module.exports, "MAX_PARTS", ()=>$da2fd7f5d16cb6e4$export$6913ef42a55e6d43);
    $parcel$export(module.exports, "QUEUE_MAX_ADDITIONAL_ATTEMPTS", ()=>$da2fd7f5d16cb6e4$export$99bb9a7926dd9ef3);
    $parcel$export(module.exports, "ANALYTICS_ACTION_SUBJECT_ID", ()=>$da2fd7f5d16cb6e4$export$4b2f4d2c3169cefb);
    $parcel$export(module.exports, "ANALYTICS_FEATURE_NAME", ()=>$da2fd7f5d16cb6e4$export$3710e0cbcb6297be);
    $parcel$export(module.exports, "ANALYTICS_EXPERIENCE_NAME", ()=>$da2fd7f5d16cb6e4$export$80c2d877af081e06);
    const $da2fd7f5d16cb6e4$export$f12c20c20eb9758 = Number.POSITIVE_INFINITY;
    const $da2fd7f5d16cb6e4$export$168b97586e915764 = Number.POSITIVE_INFINITY;
    const $da2fd7f5d16cb6e4$export$6913ef42a55e6d43 = Number.POSITIVE_INFINITY;
    const $da2fd7f5d16cb6e4$export$99bb9a7926dd9ef3 = 2;
    const $da2fd7f5d16cb6e4$export$4be82c580edb3724 = 8;
    const $da2fd7f5d16cb6e4$export$d4efa8701a154af9 = 8;
    const $da2fd7f5d16cb6e4$export$a98d32e897396dea = [
        ...Array.from(String.fromCharCode(39, 145, 147)),
        '(',
        '['
    ];
    const $da2fd7f5d16cb6e4$export$9ed3b6816d35bcaf = [
        Array.from(String.fromCharCode(34, 39, 146, 148)),
        '.',
        ',',
        '!',
        '?',
        ')',
        ']'
    ];
    const $da2fd7f5d16cb6e4$export$6d1062a7dcc983cf = Array.from(String.fromCharCode(45, 95, 150, 151, 39, 146));
    const $da2fd7f5d16cb6e4$export$4b2f4d2c3169cefb = 'proactiveSuggestion';
    const $da2fd7f5d16cb6e4$export$3710e0cbcb6297be = 'Editor AI';
    const $da2fd7f5d16cb6e4$export$80c2d877af081e06 = 'Proactive AI';
});
parcelRegister("i0gVe", function(module, exports) {
    $parcel$export(module.exports, "fireAPIReceivedAnalytics", ()=>$dcfd38f8b680d209$export$aad0e8edaa8aea55);
    $parcel$export(module.exports, "fireAPIErrorWithAnalytics", ()=>$dcfd38f8b680d209$export$4eca3056637692d7);
    var $gzlJB = parcelRequire("gzlJB");
    var $gkwXh;
    var $9m3ZB;
    var $1sHof;
    var $eLhn5;
    var $cCAIN;
    var $btfve;
    const $dcfd38f8b680d209$var$getFireAPIReceivedAnalytics = ()=>{
        let apiReceivedCount = 0;
        const apiReceivedSamplingRate = 10;
        let durationArray = [];
        return ({ view: view, duration: duration, totalSuggestions: totalSuggestions, totalAcceptedSuggestions: totalAcceptedSuggestions, totalDismissedSuggestions: totalDismissedSuggestions })=>{
            apiReceivedCount++;
            durationArray.push(duration);
            if (apiReceivedCount >= apiReceivedSamplingRate) {
                const minDuration = Math.min(...durationArray);
                const maxDuration = Math.max(...durationArray);
                const meanDuration = (0, ($parcel$interopDefault($gzlJB)))(durationArray);
                const medianDuration = (0, (0, parcelRequire("1sHof")).median)(durationArray);
                const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: view.state,
                    tr: view.state.tr,
                    payload: {
                        action: 'apiReceived',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                        attributes: {
                            meanDuration: meanDuration,
                            medianDuration: medianDuration,
                            minDuration: minDuration,
                            maxDuration: maxDuration,
                            totalSuggestions: totalSuggestions,
                            totalAcceptedSuggestions: totalAcceptedSuggestions,
                            totalDismissedSuggestions: totalDismissedSuggestions
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
                view.dispatch(tr);
                apiReceivedCount = 0;
                durationArray = [];
            }
        };
    };
    const $dcfd38f8b680d209$export$aad0e8edaa8aea55 = $dcfd38f8b680d209$var$getFireAPIReceivedAnalytics();
    const $dcfd38f8b680d209$export$4eca3056637692d7 = ({ view: view, failedChunkIds: failedChunkIds, errors: errors, reason: reason, statusCode: statusCode })=>(0, (0, parcelRequire("cCAIN")).fireAPIError)((tr)=>{
            const uniqueInteractionID = tr.getMeta((0, (0, parcelRequire("eLhn5")).aiProactivePluginKey));
            let trWithAnalytics = tr;
            errors.forEach((error)=>{
                trWithAnalytics = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: view.state,
                    tr: trWithAnalytics,
                    payload: {
                        action: 'apiError',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: (0, (0, parcelRequire("btfve")).ANALYTICS_ACTION_SUBJECT_ID),
                        attributes: {
                            error: error,
                            reason: reason,
                            statusCode: statusCode
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
            });
            trWithAnalytics = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: view.state,
                tr: trWithAnalytics,
                payload: {
                    action: 'error',
                    actionSubject: 'aiResult',
                    actionSubjectId: 'editorPluginAI',
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK,
                    attributes: {
                        singleInstrumentationID: uniqueInteractionID || '',
                        aiInteractionID: uniqueInteractionID || '',
                        aiFeatureName: (0, (0, parcelRequire("btfve")).ANALYTICS_FEATURE_NAME),
                        aiExperienceName: (0, (0, parcelRequire("btfve")).ANALYTICS_EXPERIENCE_NAME),
                        proactiveAIGenerated: 1,
                        userGeneratedAI: 0,
                        isAIFeature: 1,
                        aiErrorMessage: reason,
                        aiErrorCode: statusCode
                    }
                }
            });
            return trWithAnalytics;
        });
});
parcelRegister("gzlJB", function(module, exports) {
    var $520Yb = parcelRequire("520Yb");
    var $etyzk = parcelRequire("etyzk");
    function $c100c641bcf2f4c5$var$mean(array) {
        return $520Yb(array, $etyzk);
    }
    module.exports = $c100c641bcf2f4c5$var$mean;
});
parcelRegister("520Yb", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $3a9de433504d679a$var$NAN = 0 / 0;
    function $3a9de433504d679a$var$baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
    }
    module.exports = $3a9de433504d679a$var$baseMean;
});
parcelRegister("gBzAF", function(module, exports) {
    function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    module.exports = $c16bb58eedefe4cd$var$baseSum;
});
parcelRegister("1sHof", function(module, exports) {
    $parcel$export(module.exports, "median", ()=>$08a08fa3e6607a86$export$9c490b34b2f16a34);
    function $08a08fa3e6607a86$export$9c490b34b2f16a34(array) {
        const middle = Math.floor(array.length / 2);
        const sortedArray = [
            ...array
        ].sort((a, b)=>a - b);
        return array.length % 2 !== 0 ? sortedArray[middle] : (sortedArray[middle - 1] + sortedArray[middle]) / 2;
    }
});
parcelRegister("eLhn5", function(module, exports) {
    $parcel$export(module.exports, "aiProactivePluginKey", ()=>$125ad26eede7c58f$export$e372bb4b3a873c61);
    var $gZGBX;
    const $125ad26eede7c58f$export$e372bb4b3a873c61 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiProactivePlugin');
});
parcelRegister("eA5Z5", function(module, exports) {
    $parcel$export(module.exports, "ProactiveDecorations", ()=>$7f504423f73981ef$export$28bff36d9b351b10);
    $parcel$export(module.exports, "filterDecorationByKey", ()=>$7f504423f73981ef$export$ad950d3225a13eae);
    $parcel$export(module.exports, "regenerateSelectionDecorations", ()=>$7f504423f73981ef$export$d95ef6320c87abe0);
    $parcel$export(module.exports, "regenerateHoverDecorations", ()=>$7f504423f73981ef$export$3f92f7b1c1ed6e2d);
    $parcel$export(module.exports, "regenerateAllDecorations", ()=>$7f504423f73981ef$export$ccdc7e88bd8862ee);
    var $lvugl;
    var $84O1k;
    var $aM0PR;
    const $7f504423f73981ef$export$28bff36d9b351b10 = {
        RECOMMENDATION: 'aiProactiveRecommendation',
        RECOMMENDATION_SELECTED: 'aiProactiveRecommendationSelected',
        RECOMMENDATION_HOVERED: 'aiProactiveRecommendationHovered'
    };
    const $7f504423f73981ef$var$composeDecorations = (transformers)=>({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>transformers.reduce((decorationSet, transform)=>transform({
                    decorationSet: decorationSet,
                    tr: tr,
                    pluginState: pluginState
                }), decorationSet);
    const $7f504423f73981ef$export$ad950d3225a13eae = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
    const $7f504423f73981ef$export$d95ef6320c87abe0 = (params)=>{
        return $7f504423f73981ef$var$composeDecorations([
            (0, (0, parcelRequire("aM0PR")).removeSelectedRecommendationDecoration),
            (0, (0, parcelRequire("aM0PR")).addSelectedRecommendationDecoration)
        ])(params);
    };
    const $7f504423f73981ef$export$3f92f7b1c1ed6e2d = (params)=>{
        return $7f504423f73981ef$var$composeDecorations([
            (0, (0, parcelRequire("84O1k")).removeHoveredRecommendationDecoration),
            (0, (0, parcelRequire("84O1k")).addHoveredRecommendationDecoration)
        ])(params);
    };
    const $7f504423f73981ef$export$ccdc7e88bd8862ee = (params)=>{
        return $7f504423f73981ef$var$composeDecorations([
            (0, (0, parcelRequire("aM0PR")).removeSelectedRecommendationDecoration),
            (0, (0, parcelRequire("84O1k")).removeHoveredRecommendationDecoration),
            (0, (0, parcelRequire("lvugl")).updateRecommendationDecoration),
            (0, (0, parcelRequire("aM0PR")).addSelectedRecommendationDecoration),
            (0, (0, parcelRequire("84O1k")).addHoveredRecommendationDecoration)
        ])(params);
    };
});
parcelRegister("lvugl", function(module, exports) {
    $parcel$export(module.exports, "updateRecommendationDecoration", ()=>$ae7cd78d3477a746$export$30f39aa0478f22e1);
    var $etG8M;
    var $eA5Z5;
    const $ae7cd78d3477a746$var$createDecoration = (from, to, id)=>(0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
            nodeName: 'span',
            class: `ai-proactive-recommendation`,
            id: `ai-proactive-${id}`,
            'data-testid': `ai-proactive-recommendation`
        }, {
            key: (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION,
            blockId: id
        });
    const $ae7cd78d3477a746$export$30f39aa0478f22e1 = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        const allBlocksWithRecommendations = proactiveAIBlocks.filter((block)=>!!block?.recommendations?.length);
        const currentIds = allBlocksWithRecommendations.map((block)=>block.id);
        const existingIds = new Set();
        const decorationsToRemove = decorationSet.find(undefined, undefined, (spec)=>{
            if (spec.key !== (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION) return false;
            existingIds.add(spec.blockId);
            return !currentIds.includes(spec.blockId);
        });
        decorationSet = decorationSet.remove(decorationsToRemove);
        decorationSet = decorationSet.map(tr.mapping, tr.doc);
        let decorations = allBlocksWithRecommendations?.reduce((acc, { id: id, from: from, to: to })=>{
            if (!existingIds.has(id)) acc.push($ae7cd78d3477a746$var$createDecoration(from, to, id));
            return acc;
        }, []);
        if (!!decorations?.length) return decorationSet.add(tr.doc, decorations);
        return decorationSet;
    };
});
parcelRegister("84O1k", function(module, exports) {
    $parcel$export(module.exports, "removeHoveredRecommendationDecoration", ()=>$68973b7bc7559484$export$31a9f71cd39fb2c8);
    $parcel$export(module.exports, "addHoveredRecommendationDecoration", ()=>$68973b7bc7559484$export$787b60d474f7f3b7);
    var $etG8M;
    var $eA5Z5;
    const $68973b7bc7559484$export$31a9f71cd39fb2c8 = ({ decorationSet: decorationSet, pluginState: pluginState })=>{
        return decorationSet.remove((0, (0, parcelRequire("eA5Z5")).filterDecorationByKey)((0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION_HOVERED, decorationSet));
    };
    const $68973b7bc7559484$export$787b60d474f7f3b7 = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
        const { proactiveAIBlocks: proactiveAIBlocks, hoveredRecommendationId: hoveredRecommendationId, selectedRecommendationId: selectedRecommendationId } = pluginState;
        if (!hoveredRecommendationId || !proactiveAIBlocks.length) return decorationSet;
        const hoveredBlock = proactiveAIBlocks.find((block)=>!!block.recommendations?.some((r)=>r.id === hoveredRecommendationId && r.id !== selectedRecommendationId));
        if (!!hoveredBlock) {
            const { from: from, to: to } = hoveredBlock;
            return decorationSet.add(tr.doc, [
                (0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
                    class: `ai-proactive-recommendation-hovered`
                }, {
                    key: (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION_HOVERED
                })
            ]);
        }
        return decorationSet;
    };
});
parcelRegister("aM0PR", function(module, exports) {
    $parcel$export(module.exports, "removeSelectedRecommendationDecoration", ()=>$a6e58f0934d3ec08$export$c42022866680e94c);
    $parcel$export(module.exports, "addSelectedRecommendationDecoration", ()=>$a6e58f0934d3ec08$export$9cd2b0763854bf13);
    var $etG8M;
    var $eA5Z5;
    const $a6e58f0934d3ec08$export$c42022866680e94c = ({ decorationSet: decorationSet, pluginState: pluginState })=>{
        return decorationSet.remove((0, (0, parcelRequire("eA5Z5")).filterDecorationByKey)((0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION_SELECTED, decorationSet));
    };
    const $a6e58f0934d3ec08$export$9cd2b0763854bf13 = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
        const { proactiveAIBlocks: proactiveAIBlocks, selectedRecommendationId: selectedRecommendationId } = pluginState;
        if (!selectedRecommendationId || !proactiveAIBlocks.length) return decorationSet;
        const selectedBlock = proactiveAIBlocks.find((block)=>!!block.recommendations?.some((r)=>r.id === selectedRecommendationId));
        if (!!selectedBlock) {
            const { from: from, to: to } = selectedBlock;
            return decorationSet.add(tr.doc, [
                (0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
                    class: `ai-proactive-recommendation-selected`
                }, {
                    key: (0, (0, parcelRequire("eA5Z5")).ProactiveDecorations).RECOMMENDATION_SELECTED
                })
            ]);
        }
        return decorationSet;
    };
});
parcelRegister("lBepp", function(module, exports) {
    $parcel$export(module.exports, "createInitialState", ()=>$fe7f31f668bbaffb$export$de5e90bd767c5d82);
    $parcel$export(module.exports, "createPluginState", ()=>$fe7f31f668bbaffb$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$fe7f31f668bbaffb$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$fe7f31f668bbaffb$export$f05434c51e3762e);
    var $aOimD;
    var $etG8M;
    var $eLhn5;
    var $eA5Z5;
    var $es2i0;
    var $b2OAx;
    const $fe7f31f668bbaffb$var$handleDocChanged = (tr, pluginState, newEditorState)=>{
        const { updatedProactiveAIBlock: updatedProactiveAIBlock } = (0, (0, parcelRequire("b2OAx")).findProactiveAIBlockToUpdate)(tr, pluginState, newEditorState);
        const { decorationSet: decorationSet } = pluginState;
        return {
            ...pluginState,
            decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateAllDecorations)({
                decorationSet: decorationSet,
                tr: tr,
                pluginState: {
                    ...pluginState,
                    proactiveAIBlocks: updatedProactiveAIBlock
                }
            }),
            proactiveAIBlocks: updatedProactiveAIBlock
        };
    };
    const $fe7f31f668bbaffb$var$handleSelectionChanged = (tr, pluginState)=>{
        const { decorationSet: decorationSet, isProactiveContextPanelOpen: isProactiveContextPanelOpen, alwaysOpenProactiveContextPanelOnInlineSelection: alwaysOpenProactiveContextPanelOnInlineSelection, alwaysDisplayProactiveInlineDecorations: alwaysDisplayProactiveInlineDecorations, selectedRecommendationId: selectedRecommendationId } = pluginState;
        const selectedRecommendations = tr.selection.from === tr.selection.to ? (0, (0, parcelRequire("b2OAx")).getSelectedRecommendations)(pluginState, tr.selection.from) : undefined;
        let shouldOpenContextPanel = false;
        if (alwaysDisplayProactiveInlineDecorations && alwaysOpenProactiveContextPanelOnInlineSelection && !isProactiveContextPanelOpen && !!selectedRecommendations) shouldOpenContextPanel = selectedRecommendations.length > 0;
        const currentSelectedRecommendationId = selectedRecommendations?.find((r)=>r.id === selectedRecommendationId)?.id ?? selectedRecommendations?.[0]?.id;
        const nextState = {
            ...pluginState,
            proactiveAIBlocks: (0, (0, parcelRequire("b2OAx")).markRecommendationViewed)(pluginState, currentSelectedRecommendationId),
            selectedRecommendationId: currentSelectedRecommendationId,
            isProactiveContextPanelOpen: shouldOpenContextPanel ? true : isProactiveContextPanelOpen
        };
        return {
            ...nextState,
            decorationSet: (0, (0, parcelRequire("eA5Z5")).regenerateSelectionDecorations)({
                decorationSet: decorationSet,
                tr: tr,
                pluginState: nextState
            })
        };
    };
    const $fe7f31f668bbaffb$export$de5e90bd767c5d82 = ({ proactiveAIApiUrl: proactiveAIApiUrl, defaultToggledState: defaultToggledState, product: product })=>(state)=>{
            const { proactiveAIBlocks: proactiveAIBlocks } = (0, (0, parcelRequire("b2OAx")).getAllProactiveAIBlocks)(state);
            const initialToggleState = !!defaultToggledState;
            return {
                product: product,
                proactiveAIBlocks: proactiveAIBlocks,
                initialToggleState: initialToggleState,
                isProactiveEnabled: true,
                isProactiveContextPanelOpen: false,
                canProactiveContextPanelOpen: false,
                alwaysDisplayProactiveInlineDecorations: false,
                alwaysOpenProactiveContextPanelOnInlineSelection: false,
                validateBlocksOnMissingRecommendations: true,
                allowInlineHoverHighlightWhileRecommendationSelected: true,
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                proactiveAIApiUrl: proactiveAIApiUrl,
                availableRecommendationIds: new Set(),
                toggleCount: initialToggleState ? 1 : 0,
                insertionCount: 0,
                dismissedCount: 0,
                docChangeCountUntilLimit: 0,
                isFirstInitiatedEventSent: false
            };
        };
    const { createPluginState: $fe7f31f668bbaffb$export$656c7661095efe2e, createCommand: $fe7f31f668bbaffb$export$8d4021544bdece00, getPluginState: $fe7f31f668bbaffb$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("eLhn5")).aiProactivePluginKey), (0, (0, parcelRequire("es2i0")).reducer), {
        onDocChanged: $fe7f31f668bbaffb$var$handleDocChanged,
        onSelectionChanged: $fe7f31f668bbaffb$var$handleSelectionChanged
    });
});
parcelRegister("es2i0", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$593445c6de14172f$export$1650419e431d3ba3);
    var $bXrHm = parcelRequire("bXrHm");
    var $5wKtX;
    var $b2OAx;
    const $593445c6de14172f$export$1650419e431d3ba3 = (pluginState, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE:
                const availableRecommendationIds = new Set((action.data?.proactiveAIBlocks ?? pluginState.proactiveAIBlocks).reduce((acc, block)=>acc.concat(block.recommendations?.map((r)=>r.id) ?? []), []));
                return {
                    ...pluginState,
                    ...action.data,
                    canProactiveContextPanelOpen: availableRecommendationIds.size > 0,
                    availableRecommendationIds: availableRecommendationIds
                };
            case (0, (0, parcelRequire("5wKtX")).ACTIONS).TOGGLE_PROACTIVE_ENABLED:
                return {
                    ...pluginState,
                    toggleCount: pluginState.toggleCount + 1,
                    isProactiveEnabled: !pluginState.isProactiveEnabled,
                    ...pluginState.isProactiveEnabled && {
                        docChangeCountUntilLimit: 0
                    }
                };
            case (0, (0, parcelRequire("5wKtX")).ACTIONS).TOGGLE_PROACTIVE_CONTEXT_PANEL:
                return {
                    ...pluginState,
                    isProactiveContextPanelOpen: !pluginState.isProactiveContextPanelOpen,
                    analyticsAIInteractionId: (0, ($parcel$interopDefault($bXrHm)))(),
                    toggleCount: pluginState.toggleCount + 1
                };
            case (0, (0, parcelRequire("5wKtX")).ACTIONS).SELECT_PROACTIVE_RECOMMENDATION:
                return {
                    ...pluginState,
                    selectedRecommendationId: action.data.selectedRecommendationId,
                    proactiveAIBlocks: (0, (0, parcelRequire("b2OAx")).markRecommendationViewed)(pluginState, action.data.selectedRecommendationId),
                    hoveredRecommendationId: !pluginState.allowInlineHoverHighlightWhileRecommendationSelected ? undefined : pluginState.hoveredRecommendationId
                };
            default:
                return pluginState;
        }
    };
});
parcelRegister("5wKtX", function(module, exports) {
    $parcel$export(module.exports, "ACTIONS", ()=>$8cff4864a6e82708$export$92a1a3b7554e9387);
    var $8cff4864a6e82708$export$92a1a3b7554e9387;
    (function(ACTIONS) {
        ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
        ACTIONS[ACTIONS["TOGGLE_PROACTIVE_ENABLED"] = 1] = "TOGGLE_PROACTIVE_ENABLED";
        ACTIONS[ACTIONS["TOGGLE_PROACTIVE_CONTEXT_PANEL"] = 2] = "TOGGLE_PROACTIVE_CONTEXT_PANEL";
        ACTIONS[ACTIONS["SELECT_PROACTIVE_RECOMMENDATION"] = 3] = "SELECT_PROACTIVE_RECOMMENDATION";
        ACTIONS[ACTIONS["API_ERROR"] = 4] = "API_ERROR";
    })($8cff4864a6e82708$export$92a1a3b7554e9387 || ($8cff4864a6e82708$export$92a1a3b7554e9387 = {}));
});
parcelRegister("b2OAx", function(module, exports) {
    $parcel$export(module.exports, "findProactiveAIBlockToUpdate", ()=>$e1682e8fbae974ee$export$9301b11c75053a3b);
    $parcel$export(module.exports, "getAllProactiveAIBlocks", ()=>$e1682e8fbae974ee$export$84c79514d0cb7da7);
    $parcel$export(module.exports, "getSelectedRecommendations", ()=>$e1682e8fbae974ee$export$8fc0402cc52a25e5);
    $parcel$export(module.exports, "removeRecommendationFromBlocks", ()=>$e1682e8fbae974ee$export$6138a34c40deeca2);
    $parcel$export(module.exports, "markRecommendationViewed", ()=>$e1682e8fbae974ee$export$7b8adb87bd0790c4);
    $parcel$export(module.exports, "hasUnreadRecommendations", ()=>$e1682e8fbae974ee$export$e9b18b0e3de7b466);
    $parcel$export(module.exports, "getBlockFromRecommendationId", ()=>$e1682e8fbae974ee$export$7afb17e7a59cb907);
    $parcel$export(module.exports, "getAllRecommendations", ()=>$e1682e8fbae974ee$export$da31d3ff97f4013f);
    $parcel$export(module.exports, "hasRecommendation", ()=>$e1682e8fbae974ee$export$1af699ea038f2479);
    $parcel$export(module.exports, "syncProactiveRecommendations", ()=>$e1682e8fbae974ee$export$4fd23ba420e40ef4);
    var $bXrHm = parcelRequire("bXrHm");
    var $eS2Dn;
    const $e1682e8fbae974ee$export$e5022a60bacc9f19 = ({ schema: { nodes: nodes } })=>new Set([
            nodes.bulletList,
            nodes.listItem,
            nodes.orderedList,
            nodes.paragraph
        ]);
    const $e1682e8fbae974ee$export$2e312585e39e3b9f = ({ schema: { nodes: nodes } })=>new Set([
            nodes.bulletList,
            nodes.orderedList,
            nodes.paragraph
        ]);
    const $e1682e8fbae974ee$var$getContextualNodeTypes = ({ nodes: nodes })=>new Set([
            nodes.heading,
            nodes.taskItem,
            nodes.decisionItem
        ]);
    const $e1682e8fbae974ee$var$getContextualParentNodeTypes = ({ nodes: nodes })=>new Set([
            nodes.listItem,
            nodes.tableHeader,
            nodes.blockquote
        ]);
    const $e1682e8fbae974ee$export$54634bd503649803 = (schema, containerType)=>{
        if ($e1682e8fbae974ee$var$getContextualNodeTypes(schema).has(containerType) || $e1682e8fbae974ee$var$getContextualParentNodeTypes(schema).has(containerType)) return true;
        return false;
    };
    const $e1682e8fbae974ee$export$acc6f3e19803b3dc = (schema, node, parent)=>{
        if ($e1682e8fbae974ee$var$getContextualNodeTypes(schema).has(node.type)) return node.type;
        if (node.type === schema.nodes.paragraph && parent && $e1682e8fbae974ee$var$getContextualParentNodeTypes(schema).has(parent.type)) return parent.type;
        return node.type;
    };
    const $e1682e8fbae974ee$var$getIgnoredMarkRangesPredicate = ({ schema: { marks: marks } })=>(node)=>{
            if (node.isText) {
                if (node.marks.some((mark)=>mark.type === marks.code)) return true;
                if (node.marks.some((mark)=>mark.type === marks.link && node.text === mark.attrs?.href)) return true;
            }
            return false;
        };
    function $e1682e8fbae974ee$export$9301b11c75053a3b(tr, pluginState, newEditorState) {
        const { proactiveAIBlocks: proactiveAIBlocks, isProactiveEnabled: isProactiveEnabled } = pluginState;
        const shouldIgnoreChanges = !isProactiveEnabled || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('suggestionAccepted') || tr.getMeta('isAiContentTransformation');
        const invalidatedForDocChecker = !isProactiveEnabled && !tr.getMeta('suggestionAccepted') && !tr.getMeta('isAiContentTransformation');
        const nodeTypes = $e1682e8fbae974ee$export$2e312585e39e3b9f(newEditorState);
        const includedNodeTypes = $e1682e8fbae974ee$export$e5022a60bacc9f19(newEditorState);
        const ignoredMarkRangesPredicate = $e1682e8fbae974ee$var$getIgnoredMarkRangesPredicate(newEditorState);
        const trDocsWithFinalDoc = tr.docs.concat([
            tr.doc
        ]);
        const replaceStepsWithDocs = tr.steps.reduce((acc, step, index)=>{
            if (step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep)) acc.push({
                step: step,
                doc: trDocsWithFinalDoc[index + 1],
                prevDoc: trDocsWithFinalDoc[index]
            });
            return acc;
        }, []);
        if (proactiveAIBlocks && replaceStepsWithDocs.length > 0) {
            let updatedProactiveAIBlock = Array.from(proactiveAIBlocks);
            replaceStepsWithDocs.forEach(({ step: step, doc: doc, prevDoc: prevDoc })=>{
                const newProactiveAIBlocks = [];
                const nodeMap = new WeakMap();
                const mapping = new (0, (0, parcelRequire("eS2Dn")).Mapping)();
                const stepMap = step.getMap();
                mapping.appendMap(stepMap);
                stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
                    doc.nodesBetween(newStart, Math.min(newEnd, doc.content.size), (node, pos, parent)=>{
                        if (nodeTypes.has(node.type) && !(nodeMap.get(node)?.from === pos)) {
                            const ignoredRanges = $e1682e8fbae974ee$var$getIgnoredRanges({
                                node: node,
                                ignoredMarkRangesPredicate: ignoredMarkRangesPredicate
                            });
                            const from = pos, to = pos + node.nodeSize;
                            const containerType = $e1682e8fbae974ee$export$acc6f3e19803b3dc(newEditorState.schema, node, parent);
                            const newBlock = {
                                id: (0, ($parcel$interopDefault($bXrHm)))(),
                                from: from,
                                to: to,
                                text: node.textContent,
                                nodeTypeName: node.type.name,
                                invalidated: !shouldIgnoreChanges,
                                invalidatedForDocChecker: invalidatedForDocChecker,
                                ignoredRanges: ignoredRanges,
                                containerType: containerType
                            };
                            newProactiveAIBlocks.push(newBlock);
                            nodeMap.set(node, newBlock);
                            return false;
                        }
                        return includedNodeTypes.has(node.type);
                    });
                });
                const refurbishedBlocks = newProactiveAIBlocks.map((newBlock)=>{
                    const possibleMatch = updatedProactiveAIBlock.find((block)=>block.nodeTypeName === newBlock.nodeTypeName && (block.from === newBlock.from && block.to === newBlock.to || mapping.map(block.from + 1) === newBlock.from + 1 && mapping.map(block.to - 1) === newBlock.to - 1) && block.text === newBlock.text);
                    if (!possibleMatch) return newBlock;
                    const prevNode = prevDoc.nodeAt(possibleMatch.from);
                    const curNode = doc.nodeAt(newBlock.from);
                    if (!prevNode || !curNode || !prevNode.eq(curNode)) return newBlock;
                    return {
                        id: newBlock.id,
                        from: newBlock.from,
                        to: newBlock.to,
                        text: newBlock.text,
                        nodeTypeName: newBlock.nodeTypeName,
                        invalidated: possibleMatch.invalidated,
                        invalidatedForDocChecker: invalidatedForDocChecker,
                        ignoredRanges: newBlock.ignoredRanges,
                        containerType: newBlock.containerType,
                        recommendations: possibleMatch.recommendations?.map((r)=>({
                                ...r,
                                chunkId: newBlock.id,
                                id: `${newBlock.id}_${r.rid}`
                            }))
                    };
                });
                let startIndex = -1;
                let endIndex = -1;
                for(let index = 0; index < updatedProactiveAIBlock.length; index++){
                    const block = updatedProactiveAIBlock[index];
                    const blockInnerFrom = block.from + 1;
                    const blockInnerTo = block.to - 1;
                    if (index === 0 && step.from < blockInnerFrom && step.to < blockInnerTo) {
                        startIndex = 0;
                        endIndex = 0;
                        break;
                    }
                    if (blockInnerFrom <= step.from && blockInnerTo >= step.from || blockInnerFrom <= step.to && blockInnerTo >= step.to) {
                        if (startIndex === -1) {
                            startIndex = index;
                            endIndex = index + 1;
                        } else if (startIndex > -1) endIndex = index + 1;
                    }
                    if (blockInnerFrom >= step.from && blockInnerTo <= step.to) {
                        if (startIndex === -1) {
                            startIndex = index;
                            endIndex = index + 1;
                        } else if (startIndex > -1) endIndex = index + 1;
                    }
                    if (index < updatedProactiveAIBlock.length - 1) {
                        const nextBlock = updatedProactiveAIBlock[index + 1];
                        if (step.from > blockInnerTo && step.to < nextBlock.from) {
                            startIndex = index + 1;
                            endIndex = index + 1;
                            break;
                        }
                    }
                    if (index === updatedProactiveAIBlock.length - 1 && step.from > blockInnerTo && step.to > blockInnerTo) {
                        startIndex = index + 1;
                        endIndex = index + 1;
                    }
                }
                if (startIndex > -1 && endIndex > -1) updatedProactiveAIBlock.splice(startIndex, endIndex - startIndex, ...refurbishedBlocks);
                updatedProactiveAIBlock = updatedProactiveAIBlock.map((block, i)=>{
                    if (!!refurbishedBlocks.length && i >= startIndex && i < startIndex + refurbishedBlocks.length) return block;
                    return $e1682e8fbae974ee$export$5f957af589bcb910(mapping, block);
                });
            });
            return {
                originProactiveAIBlock: proactiveAIBlocks,
                updatedProactiveAIBlock: updatedProactiveAIBlock
            };
        }
        return {
            originProactiveAIBlock: proactiveAIBlocks,
            updatedProactiveAIBlock: proactiveAIBlocks
        };
    }
    function $e1682e8fbae974ee$export$5f957af589bcb910(mapping, block) {
        return {
            id: block.id,
            text: block.text,
            ignoredRanges: block.ignoredRanges,
            nodeTypeName: block.nodeTypeName,
            invalidated: block.invalidated,
            invalidatedForDocChecker: block.invalidatedForDocChecker,
            from: mapping.map(block.from),
            to: mapping.map(block.to),
            containerType: block.containerType,
            recommendations: block.recommendations
        };
    }
    const $e1682e8fbae974ee$var$getIgnoredRanges = ({ node: node, ignoredMarkRangesPredicate: ignoredMarkRangesPredicate })=>{
        const ignoredRanges = [];
        node.descendants((node, pos)=>{
            if (!node.isText && node.isInline) ignoredRanges.push({
                pos: pos,
                size: node.nodeSize,
                type: 'inlineNode'
            });
            else if (ignoredMarkRangesPredicate && ignoredMarkRangesPredicate(node)) ignoredRanges.push({
                pos: pos,
                size: node.nodeSize,
                type: 'mark'
            });
            return false;
        });
        return ignoredRanges;
    };
    function $e1682e8fbae974ee$export$84c79514d0cb7da7(state) {
        const nodeTypes = $e1682e8fbae974ee$export$2e312585e39e3b9f(state);
        const includedNodeTypes = $e1682e8fbae974ee$export$e5022a60bacc9f19(state);
        const proactiveAIBlocks = [];
        const ignoredMarkRangesPredicate = $e1682e8fbae974ee$var$getIgnoredMarkRangesPredicate(state);
        state.doc.descendants((node, pos, parent)=>{
            if (nodeTypes.has(node.type)) {
                const ignoredRanges = $e1682e8fbae974ee$var$getIgnoredRanges({
                    node: node,
                    ignoredMarkRangesPredicate: ignoredMarkRangesPredicate
                });
                const from = pos, to = pos + node.nodeSize;
                const containerType = $e1682e8fbae974ee$export$acc6f3e19803b3dc(state.schema, node, parent);
                proactiveAIBlocks.push({
                    id: (0, ($parcel$interopDefault($bXrHm)))(),
                    text: node.textContent,
                    from: from,
                    to: to,
                    nodeTypeName: node.type.name,
                    ignoredRanges: ignoredRanges,
                    invalidated: false,
                    invalidatedForDocChecker: true,
                    containerType: containerType
                });
                return false;
            }
            return includedNodeTypes.has(node.type);
        });
        return {
            proactiveAIBlocks: proactiveAIBlocks
        };
    }
    function $e1682e8fbae974ee$export$9162a24125d9e5aa(pluginState, pos) {
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        if (proactiveAIBlocks?.length) for(let i = 0; i < proactiveAIBlocks.length; i++){
            const block = proactiveAIBlocks[i];
            if (pos >= block.from && pos <= block.to) return block;
        }
        return undefined;
    }
    function $e1682e8fbae974ee$export$8fc0402cc52a25e5(pluginState, pos) {
        return $e1682e8fbae974ee$export$9162a24125d9e5aa(pluginState, pos)?.recommendations;
    }
    function $e1682e8fbae974ee$export$6138a34c40deeca2(blocks, recommendationId) {
        return blocks.map((block)=>{
            return {
                ...block,
                recommendations: block.recommendations?.filter((recommendation)=>recommendation.id !== recommendationId)
            };
        });
    }
    function $e1682e8fbae974ee$export$7b8adb87bd0790c4(pluginState, recommendationId) {
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        return proactiveAIBlocks?.map((block)=>{
            return {
                ...block,
                recommendations: block.recommendations?.map((recommendation)=>recommendation.id === recommendationId ? {
                        ...recommendation,
                        isViewed: true
                    } : recommendation)
            };
        });
    }
    function $e1682e8fbae974ee$export$e9b18b0e3de7b466(pluginState) {
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        return proactiveAIBlocks?.some((block)=>block.recommendations?.some((recommendation)=>!recommendation.isViewed));
    }
    function $e1682e8fbae974ee$export$3aacaf06d69b33cc(blocks) {
        const chunks = blocks;
        return chunks.reduce((accumulator, chunk)=>{
            accumulator.set(chunk.id, chunk);
            return accumulator;
        }, new Map());
    }
    function $e1682e8fbae974ee$export$51bcf3612fd1a2bf(blocks) {
        const sortable = Array.from(blocks);
        sortable.sort((a, b)=>a.from - b.from);
        return sortable.reduce((accumulator, block)=>{
            if (block.recommendations) accumulator = accumulator.concat(block.recommendations);
            return accumulator;
        }, []) || [];
    }
    function $e1682e8fbae974ee$export$7afb17e7a59cb907(pluginState, recommendationId) {
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        const n = proactiveAIBlocks.length;
        for(let i = 0; i < n; i++){
            const block = proactiveAIBlocks[i];
            const recommendation = block.recommendations?.find((r)=>r.id === recommendationId);
            if (block && recommendation) return {
                block: block,
                recommendation: recommendation
            };
        }
        return {
            block: undefined,
            recommendation: undefined
        };
    }
    function $e1682e8fbae974ee$export$da31d3ff97f4013f(pluginState) {
        const { proactiveAIBlocks: proactiveAIBlocks } = pluginState;
        return proactiveAIBlocks ? $e1682e8fbae974ee$export$51bcf3612fd1a2bf(proactiveAIBlocks) : [];
    }
    function $e1682e8fbae974ee$export$a1e6dc210393a095(pluginState) {
        return pluginState.availableRecommendationIds.size > 0;
    }
    function $e1682e8fbae974ee$export$1af699ea038f2479(pluginState, recommendationId) {
        return pluginState.availableRecommendationIds.has(recommendationId);
    }
    function $e1682e8fbae974ee$export$4fd23ba420e40ef4(pluginState, recommendations, blocksIdsMissingRecommendations) {
        const { proactiveAIBlocks: proactiveAIBlocks, validateBlocksOnMissingRecommendations: validateBlocksOnMissingRecommendations } = pluginState;
        return proactiveAIBlocks?.map((block)=>{
            const newRecommendations = recommendations.filter((recommendation)=>recommendation.chunkId === block.id);
            return {
                ...block,
                ...newRecommendations.length && {
                    recommendations: newRecommendations,
                    invalidated: false,
                    invalidatedForDocChecker: false
                },
                ...validateBlocksOnMissingRecommendations && blocksIdsMissingRecommendations.has(block.id) && {
                    invalidated: false,
                    invalidatedForDocChecker: false
                }
            };
        });
    }
});
parcelRegister("ldiyo", function(module, exports) {
    $parcel$export(module.exports, "insertSuggestion", ()=>$d9c7fd68c6e06553$export$b021a9df2a70c70d);
    $parcel$export(module.exports, "removeSuggestion", ()=>$d9c7fd68c6e06553$export$b0e3040c2e637887);
    $parcel$export(module.exports, "selectFirstSuggestion", ()=>$d9c7fd68c6e06553$export$19a318c315beed4d);
    $parcel$export(module.exports, "startSpellingAndGrammar", ()=>$d9c7fd68c6e06553$export$34573f1c03be6b74);
    $parcel$export(module.exports, "toggleSpellingAndGrammar", ()=>$d9c7fd68c6e06553$export$a2e91513349f68ce);
    $parcel$export(module.exports, "disableNeedSpellingAndGrammar", ()=>$d9c7fd68c6e06553$export$fd1edf12cf9b88ba);
    $parcel$export(module.exports, "highlightSentence", ()=>$d9c7fd68c6e06553$export$e3d0bf1816caac8e);
    $parcel$export(module.exports, "unhighlightSentence", ()=>$d9c7fd68c6e06553$export$658e00b04fc21e9e);
    $parcel$export(module.exports, "updateChunksWithDiffObjects", ()=>$d9c7fd68c6e06553$export$66b8f310fb2d3c0e);
    $parcel$export(module.exports, "createTriggerSpellingAndGrammarCheck", ()=>$d9c7fd68c6e06553$export$77454e4fc94ffde1);
    var $lFKmC = parcelRequire("lFKmC");
    var $34ck9 = parcelRequire("34ck9");
    var $bXrHm = parcelRequire("bXrHm");
    var $gZGBX;
    var $bwUTF;
    var $3cfam;
    var $6JzpJ;
    var $dKZcc;
    var $k5t6k;
    var $4dOAK;
    var $aYj1w;
    var $5ilgR;
    const $d9c7fd68c6e06553$export$b021a9df2a70c70d = (selectedDiff)=>(0, (0, parcelRequire("4dOAK")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            const { decorationSet: decorationSet, insertionCount: currentInsertionCount, proactiveAIBlocks: proactiveAIBlocks } = pluginState;
            if (!proactiveAIBlocks || proactiveAIBlocks.length === 0) return false;
            const updatedProactiveAIBlocks = (0, (0, parcelRequire("5ilgR")).removeSelectedDiffObjectFromBlock)(pluginState, selectedDiff.from, selectedDiff.to);
            return {
                type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, (0, parcelRequire("k5t6k")).regenerateAllDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            proactiveAIBlocks: updatedProactiveAIBlocks
                        }
                    }),
                    proactiveAIBlocks: updatedProactiveAIBlocks,
                    insertionCount: currentInsertionCount + 1
                }
            };
        }, (tr, state)=>{
            const { schema: schema } = state;
            const { selection: selection } = tr;
            if (selection.from === selection.to) {
                tr.setMeta('suggestionAccepted', true);
                const { from: from, to: to, text: text, replacement: replacement } = selectedDiff;
                const resolvedPos = state.doc.resolve(from);
                const marks = resolvedPos.nodeAfter?.marks || [];
                if (replacement) {
                    tr.replaceWith(from, to, replacement);
                    marks.forEach((mark)=>{
                        tr.addMark(from, from + replacement.size, mark);
                    });
                    return tr;
                }
                return tr.replaceWith(from, to, schema.text(text, marks));
            }
            return tr;
        });
    const $d9c7fd68c6e06553$export$b0e3040c2e637887 = (originalText)=>(0, (0, parcelRequire("4dOAK")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            const { decorationSet: decorationSet, proactiveAIBlocks: proactiveAIBlocks, dismissedWords: dismissedWords } = pluginState;
            if (!proactiveAIBlocks || proactiveAIBlocks.length === 0) return false;
            const updatedProactiveAIBlocks = (0, (0, parcelRequire("5ilgR")).removeDiffObjectFromBlockMatchingText)(pluginState, originalText);
            return {
                type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    dismissedWords: dismissedWords.add(originalText),
                    decorationSet: (0, (0, parcelRequire("k5t6k")).regenerateAllDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            proactiveAIBlocks: updatedProactiveAIBlocks
                        }
                    }),
                    proactiveAIBlocks: updatedProactiveAIBlocks
                }
            };
        });
    const $d9c7fd68c6e06553$export$19a318c315beed4d = ()=>(0, (0, parcelRequire("4dOAK")).createCommand)({
            type: (0, (0, parcelRequire("aYj1w")).ACTIONS).SELECT_SPELLING_AND_GRAMMAR_SUGGESTION
        }, (tr, state)=>{
            const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            const { decorationSet: decorationSet } = pluginState;
            const decoration = decorationSet.find(undefined, undefined, (spec)=>{
                return spec.key === (0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR;
            })?.[0];
            if (decoration) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, decoration.from));
            return tr.setMeta('addToHistory', false);
        });
    const $d9c7fd68c6e06553$var$createSpellingAndGrammarCommand = (actionType, toggleCount)=>(0, (0, parcelRequire("4dOAK")).createCommand)((state)=>{
            const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, documentSGChecker: documentSGChecker } = pluginState;
            if (documentSGChecker) {
                if (actionType === (0, (0, parcelRequire("aYj1w")).ACTIONS).START_SPELLING_AND_GRAMMAR) documentSGChecker.start();
                else if (!isSpellingAndGrammarEnabled) documentSGChecker.start();
                else documentSGChecker.stop();
            }
            (0, (0, parcelRequire("bwUTF")).markLocalStorageProactiveAIToggled)(!isSpellingAndGrammarEnabled);
            return {
                type: actionType,
                ...actionType === (0, (0, parcelRequire("aYj1w")).ACTIONS).TOGGLE_SPELLING_AND_GRAMMAR_ENABLED ? {
                    data: {
                        toggleCount: toggleCount
                    }
                } : {}
            };
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $d9c7fd68c6e06553$export$34573f1c03be6b74 = ()=>$d9c7fd68c6e06553$var$createSpellingAndGrammarCommand((0, (0, parcelRequire("aYj1w")).ACTIONS).START_SPELLING_AND_GRAMMAR);
    const $d9c7fd68c6e06553$export$a2e91513349f68ce = (toggleCount)=>$d9c7fd68c6e06553$var$createSpellingAndGrammarCommand((0, (0, parcelRequire("aYj1w")).ACTIONS).TOGGLE_SPELLING_AND_GRAMMAR_ENABLED, toggleCount);
    const $d9c7fd68c6e06553$export$fd1edf12cf9b88ba = (skippedChunkIds, transform)=>(0, (0, parcelRequire("4dOAK")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("aYj1w")).ACTIONS).DISABLE_NEED_SPELLING_AND_GRAMMAR,
                data: {
                    skippedChunkIds: skippedChunkIds
                }
            };
        }, (tr, state)=>{
            if (transform) return transform(tr, state).setMeta('addToHistory', false);
            return tr.setMeta('addToHistory', false);
        });
    const $d9c7fd68c6e06553$export$e3d0bf1816caac8e = (sentence)=>(0, (0, parcelRequire("4dOAK")).createCommand)((state)=>{
            const { decorationSet: decorationSet } = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            return {
                type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: decorationSet.add(state.doc, [
                        (0, (0, parcelRequire("3cfam")).createInlineDecoration)(sentence.from, sentence.to)
                    ])
                }
            };
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $d9c7fd68c6e06553$export$658e00b04fc21e9e = ()=>(0, (0, parcelRequire("4dOAK")).createCommand)((state)=>{
            const { decorationSet: decorationSet } = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
            return {
                type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: decorationSet.remove(decorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration'))
                }
            };
        }, (tr)=>tr.setMeta('addToHistory', false));
    const $d9c7fd68c6e06553$export$66b8f310fb2d3c0e = async (view, chunks, locale)=>{
        const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(view.state);
        const { proactiveAIApiUrl: proactiveAIApiUrl } = pluginState;
        const suggestionGenerator = (0, (0, parcelRequire("6JzpJ")).fetchAIParagraphs)(view, proactiveAIApiUrl, locale)(chunks);
        if (!suggestionGenerator) return;
        for await (const suggestionState of suggestionGenerator)switch(suggestionState.state){
            case 'cached':
            case 'parsed':
                {
                    const suggestions = suggestionState.suggestions;
                    const newPluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(view.state);
                    const { decorationSet: decorationSet, isFirstInitiatedEventSent: isFirstInitiatedEventSent, splitParagraphIntoSentences: splitParagraphIntoSentences, proactiveAIBlocks: proactiveAIBlocks } = newPluginState;
                    if (!proactiveAIBlocks) break;
                    const paragraphChunkMap = (0, (0, parcelRequire("5ilgR")).generateParagraphChunkMap)(proactiveAIBlocks, splitParagraphIntoSentences);
                    const chunksDiffObjectsById = (0, (0, parcelRequire("5ilgR")).getDiffObjectsForSuggestions)({
                        editorView: view,
                        suggestions: suggestions,
                        paragraphChunkMap: paragraphChunkMap
                    });
                    const updatedProactiveAIBlocks = (0, (0, parcelRequire("5ilgR")).setBlocksDiffObjects)(newPluginState, chunksDiffObjectsById);
                    const initiateAnalytics = (0, (0, parcelRequire("dKZcc")).initiateProactiveAIWithAnalytics)((0, ($parcel$interopDefault($bXrHm)))());
                    const updatePluginCommand = (0, (0, parcelRequire("4dOAK")).createCommand)(()=>{
                        return {
                            type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE,
                            data: {
                                proactiveAIBlocks: updatedProactiveAIBlocks,
                                isFirstInitiatedEventSent: true,
                                decorationSet: (0, (0, parcelRequire("k5t6k")).regenerateAllDecorations)({
                                    decorationSet: decorationSet,
                                    tr: view.state.tr,
                                    pluginState: {
                                        ...newPluginState,
                                        proactiveAIBlocks: updatedProactiveAIBlocks
                                    }
                                })
                            }
                        };
                    }, (tr, state)=>{
                        return tr.setMeta('addToHistory', false);
                    });
                    isFirstInitiatedEventSent ? updatePluginCommand(view.state, view.dispatch) : initiateAnalytics(updatePluginCommand)(view.state, view.dispatch);
                    break;
                }
            case 'trackedDuration':
                {
                    const newPluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(view.state);
                    const { insertionCount: insertionCount, dismissedWords: dismissedWords } = newPluginState;
                    const allDiffObjects = (0, (0, parcelRequire("5ilgR")).getAllDiffObjects)(newPluginState);
                    (0, (0, parcelRequire("dKZcc")).fireAPIReceivedAnalytics)({
                        view: view,
                        duration: suggestionState.duration,
                        totalSuggestions: allDiffObjects.length,
                        totalAcceptedSuggestions: insertionCount,
                        totalDismissedSuggestions: dismissedWords.size
                    });
                    break;
                }
            case 'receivedChunkMetadata':
                (0, (0, parcelRequire("4dOAK")).createCommand)(()=>{
                    return {
                        type: (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_CHUNK_METADATA,
                        data: {
                            chunkId: suggestionState.chunkId,
                            metadata: suggestionState.metadata
                        }
                    };
                }, (tr)=>{
                    return tr.setMeta('addToHistory', false);
                })(view.state, view.dispatch);
                break;
            case 'failed':
                if (suggestionState.failedChunkIds.length > 0) (0, (0, parcelRequire("dKZcc")).disableCheckForFailedChunksWithAnalytics)({
                    view: view,
                    failedChunkIds: suggestionState.failedChunkIds,
                    errors: suggestionState.errors,
                    reason: suggestionState.reason,
                    statusCode: suggestionState.statusCode
                })(view.state, view.dispatch);
                break;
            case 'purged':
                if (suggestionState.purgedChunkIds.length) (0, (0, parcelRequire("dKZcc")).disableCheckForPurgedChunksWithAnalytics)({
                    purgedChunkIds: suggestionState.purgedChunkIds,
                    totalParts: suggestionState.totalParts,
                    totalPurgedParts: suggestionState.totalPurgedParts
                })(view.state, view.dispatch);
        }
    };
    const $d9c7fd68c6e06553$var$isSelectionInBlock = (from, to, block)=>{
        return block.from <= from && block.to >= from || block.from <= to && block.to >= to;
    };
    const $d9c7fd68c6e06553$var$getBlocksNeedingSpellAndGrammarCheck = (state)=>{
        const { proactiveAIBlocks: proactiveAIBlocks } = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
        if (!proactiveAIBlocks || !proactiveAIBlocks.length) return [];
        return proactiveAIBlocks?.filter((block)=>!!block.needSpellingAndGrammarCheck);
    };
    const $d9c7fd68c6e06553$var$getBlocksNeedingSGCheck = (state, currentBlocks)=>{
        const blocksNeedingSpellAndGrammarCheck = $d9c7fd68c6e06553$var$getBlocksNeedingSpellAndGrammarCheck(state);
        const { from: from, to: to } = state.selection;
        return blocksNeedingSpellAndGrammarCheck.filter((block)=>{
            const selectionInBlock = $d9c7fd68c6e06553$var$isSelectionInBlock(from, to, block);
            return currentBlocks ? selectionInBlock : !selectionInBlock;
        });
    };
    const $d9c7fd68c6e06553$var$getChunksNeedingSGCheck = (state, currentBlocks)=>{
        const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
        const { splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        const blocksNeedingSpellAndGrammarCheck = $d9c7fd68c6e06553$var$getBlocksNeedingSGCheck(state, currentBlocks);
        return splitParagraphIntoSentences ? (0, (0, parcelRequire("5ilgR")).getBlocksSentencesNeedingSGCheck)(blocksNeedingSpellAndGrammarCheck) : blocksNeedingSpellAndGrammarCheck;
    };
    const $d9c7fd68c6e06553$export$fcd3542049ec7e59 = async (view, locale)=>{
        const chunks = $d9c7fd68c6e06553$var$getChunksNeedingSGCheck(view.state, true);
        if (chunks.length) await $d9c7fd68c6e06553$export$66b8f310fb2d3c0e(view, chunks, locale);
    };
    const $d9c7fd68c6e06553$export$ecdf31178b6cad74 = async (view, locale)=>{
        const chunks = $d9c7fd68c6e06553$var$getChunksNeedingSGCheck(view.state, false);
        if (chunks.length) await $d9c7fd68c6e06553$export$66b8f310fb2d3c0e(view, chunks, locale);
    };
    const $d9c7fd68c6e06553$export$77454e4fc94ffde1 = (timings)=>{
        const triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled = (0, ($parcel$interopDefault($34ck9)))($d9c7fd68c6e06553$export$ecdf31178b6cad74, timings.nonCurrentChunks);
        const triggerSpellingAndGrammarCheckForCurrentBlocksDebounced = (0, ($parcel$interopDefault($lFKmC)))($d9c7fd68c6e06553$export$fcd3542049ec7e59, timings.currentChunks, {
            maxWait: timings.currentChunksMaxWait
        });
        const triggerSpellingAndGrammarCheck = (view, locale)=>{
            triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled(view, locale);
            triggerSpellingAndGrammarCheckForCurrentBlocksDebounced(view, locale);
        };
        const cancelDebouncedAndThrottledSpellingAndGrammarCheck = ()=>{
            triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled.cancel();
            triggerSpellingAndGrammarCheckForCurrentBlocksDebounced.cancel();
        };
        return {
            triggerSpellingAndGrammarCheck: triggerSpellingAndGrammarCheck,
            cancelDebouncedAndThrottledSpellingAndGrammarCheck: cancelDebouncedAndThrottledSpellingAndGrammarCheck
        };
    };
});
parcelRegister("bwUTF", function(module, exports) {
    $parcel$export(module.exports, "markLocalStorageProactiveAIToggled", ()=>$f05d561507be6bfc$export$3f801d5cc09b0447);
    $parcel$export(module.exports, "isLocalStorageProactiveAIToggled", ()=>$f05d561507be6bfc$export$5f98652be66221af);
    var $jtD64;
    const $f05d561507be6bfc$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-ai';
    const $f05d561507be6bfc$export$c7956726a3911a77 = 'proactiveAIToggled';
    const $f05d561507be6bfc$var$storageClient = new (0, (0, parcelRequire("jtD64")).default)($f05d561507be6bfc$export$c0fd7e3ed450d078);
    const $f05d561507be6bfc$export$3f801d5cc09b0447 = (value, expiration)=>{
        $f05d561507be6bfc$var$storageClient.setItemWithExpiry($f05d561507be6bfc$export$c7956726a3911a77, value, expiration);
    };
    const $f05d561507be6bfc$export$5f98652be66221af = (defaultValue)=>{
        const localStorageValue = $f05d561507be6bfc$var$storageClient.getItem($f05d561507be6bfc$export$c7956726a3911a77) ?? defaultValue;
        return !!localStorageValue;
    };
});
parcelRegister("6JzpJ", function(module, exports) {
    $parcel$export(module.exports, "fetchAIParagraphs", ()=>$0d3aa42c1b1780b8$export$ff0b89bde37d855d);
    var $VSDnB;
    var $imVmr;
    var $iTTpr;
    const $0d3aa42c1b1780b8$export$f795cf8a51531ffb = (chunk)=>chunk.from === chunk.to || !chunk.text || !chunk.text.trim().length;
    const $0d3aa42c1b1780b8$export$ff0b89bde37d855d = (view, proactiveAIApiUrl, locale)=>(paragraphs)=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_ai_md_plus')) return (0, (0, parcelRequire("imVmr")).mdPlusSuggestionGenerator)({
                endpoint: proactiveAIApiUrl,
                editorView: view,
                paragraphs: paragraphs,
                locale: locale
            });
            const included = paragraphs.filter((chunk)=>!$0d3aa42c1b1780b8$export$f795cf8a51531ffb(chunk));
            if (!!included.length) return (0, (0, parcelRequire("iTTpr")).suggestionGenerator)({
                endpoint: proactiveAIApiUrl,
                paragraphs: included,
                abortController: new AbortController()
            });
            return;
        };
});
parcelRegister("imVmr", function(module, exports) {
    $parcel$export(module.exports, "mdPlusSuggestionGenerator", ()=>$34bb499eb0c8fb5b$export$a6ba245ff160d681);
    var $ifg6x = parcelRequire("ifg6x");
    var $4aQKT;
    var $k0tah;
    function $34bb499eb0c8fb5b$var$isValidStreamingResponse(response) {
        return typeof response === 'object' && response !== null && 'id' in response && ('part' in response || 'error' in response);
    }
    const $34bb499eb0c8fb5b$var$getParagraphChunkWithMDPlus = (doc, editorView, chunk)=>{
        let chunkIdMap = {};
        const { from: from, to: to } = chunk;
        const slice = doc.slice(from, to);
        if (!slice) return;
        const { markdown: markdown } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
            editorView: editorView,
            slice: slice,
            convertTo: 'markdown-plus',
            updateIdMap: ({ idMap: idMap })=>{
                chunkIdMap = idMap;
            },
            selectionType: 'range'
        });
        chunk = $34bb499eb0c8fb5b$var$getChunkWithParentTree(editorView, chunk);
        return {
            ...chunk,
            markdown: markdown,
            chunkIdMap: chunkIdMap
        };
    };
    const $34bb499eb0c8fb5b$var$getChunkWithParentTree = (editorView, chunk)=>{
        const { from: from } = chunk;
        const resolvedPos = editorView.state.doc.resolve(from);
        const parentTree = [];
        for(let depth = resolvedPos.depth; depth > 0; depth--){
            const node = resolvedPos.node(depth);
            if (node) parentTree.unshift(node.type.name);
        }
        chunk.parentTree = parentTree;
        return chunk;
    };
    function $34bb499eb0c8fb5b$var$parseResponse(queue, response) {
        const chunk = queue.find((p)=>response?.id === p.id);
        if (!chunk || !$34bb499eb0c8fb5b$var$isValidStreamingResponse(response)) return {
            result: false,
            error: 'Invalid streaming response',
            chunkId: response.id
        };
        if ('error' in response) return {
            result: false,
            error: `Missing part: ${response.error}`,
            chunkId: chunk.id
        };
        return {
            result: true,
            request: {
                chunk: chunk
            },
            response: {
                chunkId: chunk.id,
                suggestion: response.part,
                chunkIdMap: chunk.chunkIdMap,
                ...response.metadata && {
                    metadata: {
                        editDistanceRatio: Number(response.metadata.edit_distance_ratio) || undefined,
                        wordCountRatio: Number(response.metadata.word_count_ratio) || undefined,
                        originalContentLength: Number(response.metadata.original_content_length) || undefined
                    }
                }
            }
        };
    }
    const $34bb499eb0c8fb5b$var$paragraphCache = new Map();
    const $34bb499eb0c8fb5b$var$PARAGRAPH_CACHE_MAX_SIZE = 128;
    async function* $34bb499eb0c8fb5b$export$a6ba245ff160d681({ endpoint: endpoint, paragraphs: paragraphs, editorView: editorView, locale: locale }) {
        const [cachedParagraphs, uncachedParagraphs] = (0, ($parcel$interopDefault($ifg6x)))(paragraphs, (p)=>$34bb499eb0c8fb5b$var$paragraphCache.has(p.text));
        if (cachedParagraphs.length > 0) {
            const suggestions = [];
            for (const cachedParagraph of cachedParagraphs){
                const suggestion = $34bb499eb0c8fb5b$var$paragraphCache.get(cachedParagraph.text);
                if (suggestion) {
                    $34bb499eb0c8fb5b$var$paragraphCache.delete(cachedParagraph.text);
                    $34bb499eb0c8fb5b$var$paragraphCache.set(cachedParagraph.text, suggestion);
                    suggestions.push({
                        chunkId: cachedParagraph.id,
                        suggestion: suggestion
                    });
                }
            }
            yield {
                state: 'cached',
                suggestions: suggestions
            };
        }
        if (!uncachedParagraphs.length) {
            yield {
                state: 'done'
            };
            return;
        }
        const doc = editorView.state.doc;
        const abortController = new AbortController();
        const purgedChunkIds = [];
        const totalParts = uncachedParagraphs.length;
        let attemptCount = 0;
        const [withinLimitsParagraphChunks, exceededLimitsParagraphChunks] = (0, ($parcel$interopDefault($ifg6x)))(uncachedParagraphs, (p)=>p.text.length <= (0, (0, parcelRequire("k0tah")).PART_MAX_SIZE));
        purgedChunkIds.push(...exceededLimitsParagraphChunks.map((p)=>p.id));
        while(withinLimitsParagraphChunks.length && attemptCount <= (0, (0, parcelRequire("k0tah")).QUEUE_MAX_ADDITIONAL_ATTEMPTS)){
            attemptCount++;
            const queue = [];
            let queueTotalPartsSize = 0;
            while(withinLimitsParagraphChunks.length && queueTotalPartsSize + withinLimitsParagraphChunks[0].text.length <= (0, (0, parcelRequire("k0tah")).TOTAL_PARTS_MAX_SIZE) && queue.length <= (0, (0, parcelRequire("k0tah")).MAX_PARTS)){
                const withinLimitsParagraphChunk = withinLimitsParagraphChunks.shift();
                if (!withinLimitsParagraphChunk) break;
                queueTotalPartsSize += withinLimitsParagraphChunk.text.length;
                const paragraphChunkWithMDPlus = $34bb499eb0c8fb5b$var$getParagraphChunkWithMDPlus(doc, editorView, withinLimitsParagraphChunk);
                if (paragraphChunkWithMDPlus) queue.push(paragraphChunkWithMDPlus);
            }
            if (!queue.length) break;
            const queuedChunkIds = queue.map((p)=>p.id);
            try {
                const requests = {};
                const context = {};
                queue.forEach((chunk)=>{
                    requests[chunk.id] = chunk.markdown;
                    context[chunk.id] = chunk.parentTree;
                });
                const payload = {
                    requests: requests,
                    context: context
                };
                const startTime = performance.now();
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Accept-Language': locale
                    },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                    signal: abortController.signal,
                    mode: 'cors'
                });
                yield {
                    state: 'trackedDuration',
                    duration: performance.now() - startTime
                };
                if (!response.ok) {
                    yield {
                        state: 'failed',
                        reason: 'backend',
                        errors: [
                            `unexpected response status: ${response.status}`
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds
                    };
                    break;
                }
                if (!response.body) {
                    yield {
                        state: 'failed',
                        reason: 'network',
                        errors: [
                            'response.body missing'
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds
                    };
                    break;
                }
                const processedChunkIds = [];
                try {
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let lineBuffer = '';
                    let done = false;
                    while(!done){
                        const { value: value, done: doneReading } = await reader.read();
                        done = doneReading;
                        const chunkValue = decoder.decode(value);
                        lineBuffer = lineBuffer + chunkValue;
                        const lines = lineBuffer.split('\n');
                        const suggestions = [];
                        const errors = [];
                        const failedChunkIds = [];
                        while(lines.length > 1){
                            const line = lines.shift();
                            const parsedData = JSON.parse(line);
                            const parsedResponse = $34bb499eb0c8fb5b$var$parseResponse(queue, parsedData);
                            if (parsedResponse.result) {
                                const { chunkId: chunkId, metadata: metadata, suggestion: suggestion } = parsedResponse.response;
                                if ($34bb499eb0c8fb5b$var$paragraphCache.size >= $34bb499eb0c8fb5b$var$PARAGRAPH_CACHE_MAX_SIZE) $34bb499eb0c8fb5b$var$paragraphCache.delete($34bb499eb0c8fb5b$var$paragraphCache.keys().next().value);
                                $34bb499eb0c8fb5b$var$paragraphCache.set(parsedResponse.request.chunk.text, suggestion);
                                suggestions.push(parsedResponse.response);
                                processedChunkIds.push(chunkId);
                                if (metadata) yield {
                                    state: 'receivedChunkMetadata',
                                    chunkId: chunkId,
                                    metadata: metadata
                                };
                            } else {
                                errors.push(parsedResponse.error);
                                if (parsedResponse.chunkId) failedChunkIds.push(parsedResponse.chunkId);
                            }
                        }
                        if (suggestions.length) yield {
                            state: 'parsed',
                            suggestions: suggestions
                        };
                        if (errors.length) yield {
                            state: 'failed',
                            reason: 'backend',
                            errors: errors,
                            statusCode: response.status,
                            failedChunkIds: failedChunkIds
                        };
                        lineBuffer = lines[0];
                    }
                } catch (parsingError) {
                    yield {
                        state: 'failed',
                        reason: 'parsing',
                        errors: [
                            'parsingError'
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds.filter((id)=>!processedChunkIds.includes(id))
                    };
                }
            } catch (error) {
                if (error.name === 'AbortError') yield {
                    state: 'failed',
                    reason: 'aborted',
                    errors: [
                        'Streaming aborted'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
                else yield {
                    state: 'failed',
                    reason: 'unhandled',
                    errors: error instanceof Error && [
                        'RangeError',
                        'TypeError',
                        'TransformError'
                    ].includes(error.name) ? [
                        error.message
                    ] : [
                        'unhandled'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
            }
        }
        if (withinLimitsParagraphChunks.length) purgedChunkIds.push(...withinLimitsParagraphChunks.map((p)=>p.id));
        if (purgedChunkIds.length) yield {
            state: 'purged',
            totalParts: totalParts,
            totalPurgedParts: purgedChunkIds.length,
            purgedChunkIds: purgedChunkIds
        };
        yield {
            state: 'done'
        };
        return;
    }
});
parcelRegister("4aQKT", function(module, exports) {
    $parcel$export(module.exports, "sliceOrNodeToMarkdown", ()=>$78732504a7a55ef7$export$ae9f8b78c9fe6ae0);
    var $gkwXh;
    var $gWPGI;
    var $9m3ZB;
    var $gPFN1;
    var $4qz4W;
    function $78732504a7a55ef7$export$ae9f8b78c9fe6ae0({ slice: slice, node: node, editorView: editorView, convertTo: convertTo, updateIdMap: updateIdMap, selectionType: selectionType, mentionMap: mentionMap }) {
        let fragment = (slice || node).content;
        try {
            const contextSelectionScope = (0, (0, parcelRequire("4qz4W")).getContextSelectionScope)({
                editorView: editorView,
                slice: slice,
                node: node
            });
            if (convertTo === 'markdown-plus') {
                const { markdown: markdown, idMap: idMap, fallbackState: fallbackState, contentStatistics: contentStatistics } = (0, (0, parcelRequire("gWPGI")).convertProsemirrorToMarkdown)({
                    editorView: editorView,
                    fragment: fragment,
                    featureToggles: {
                        markdownPlus: true,
                        markdownPlusExtensions: true,
                        markdownPlusPanels: true,
                        markdownPlusDecisions: true
                    },
                    mentionMap: mentionMap
                });
                if (!!Object.keys(fallbackState).length) {
                    const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                        editorState: editorView.state,
                        tr: editorView.state.tr,
                        payload: {
                            action: 'fallback',
                            actionSubject: 'editorPluginAI',
                            actionSubjectId: 'markdownSerializer',
                            attributes: {
                                fallbackState: fallbackState
                            },
                            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                        }
                    });
                    tr.setMeta('addToHistory', false);
                    editorView.dispatch(tr);
                }
                updateIdMap({
                    idMap: idMap,
                    selectionType: selectionType
                });
                return {
                    markdown: markdown,
                    contentStatistics: {
                        ...contentStatistics,
                        contextSelectionScope: contextSelectionScope
                    }
                };
            }
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("gWPGI")).convertProsemirrorToMarkdown)({
                editorView: editorView,
                fragment: fragment,
                featureToggles: {},
                mentionMap: mentionMap
            });
            return {
                markdown: markdown,
                contentStatistics: {
                    ...contentStatistics,
                    contextSelectionScope: contextSelectionScope
                }
            };
        } catch (e) {
            const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: editorView.state,
                tr: editorView.state.tr,
                payload: {
                    action: 'failed',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'markdownSerializer',
                    attributes: {
                        errorType: 'markdownSerializer',
                        errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(e)
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                }
            });
            editorView.dispatch(tr);
            return {
                markdown: '',
                contentStatistics: undefined
            };
        }
    }
});
parcelRegister("gWPGI", function(module, exports) {
    $parcel$export(module.exports, "convertProsemirrorToMarkdown", ()=>$4ebc8f998887e712$export$cc6cac500a4da966);
    $parcel$export(module.exports, "convertProsemirrorNodeToMarkdown", ()=>$4ebc8f998887e712$export$3d24004275aefeab);
    var $5r0mK = parcelRequire("5r0mK");
    var $7aBvu;
    var $hTghy;
    function $4ebc8f998887e712$var$createTextWrapper(editorView, fragment) {
        const { schema: schema } = editorView.state;
        const { $from: $from } = editorView.state.selection;
        const parent = (0, $5r0mK.findParentNodeClosestToPos)($from, (node)=>{
            return node.type.name === 'paragraph' || node.type.name === 'heading';
        })?.node;
        if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
        else return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
    }
    function $4ebc8f998887e712$var$createListItemWrapper(editorView, fragment) {
        const { schema: schema } = editorView.state;
        const { $from: $from } = editorView.state.selection;
        const parent = (0, $5r0mK.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
        if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
        return fragment;
    }
    function $4ebc8f998887e712$var$createTaskItemWrapper(schema, fragment) {
        return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
    }
    function $4ebc8f998887e712$var$createLayoutColumnWrapper(editorView, fragment) {
        const { schema: schema } = editorView.state;
        const parentSection = (0, $5r0mK.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
        if (parentSection) return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
        return fragment;
    }
    function $4ebc8f998887e712$var$checkFragment(editorView, schema, fragment) {
        switch(fragment?.firstChild?.type?.name){
            case 'text':
                return $4ebc8f998887e712$var$createTextWrapper(editorView, fragment);
            case 'listItem':
                return $4ebc8f998887e712$var$createListItemWrapper(editorView, fragment);
            case 'taskItem':
                return $4ebc8f998887e712$var$createTaskItemWrapper(schema, fragment);
            case 'layoutColumn':
                return $4ebc8f998887e712$var$createLayoutColumnWrapper(editorView, fragment);
            default:
                return fragment;
        }
    }
    function $4ebc8f998887e712$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
        fragment = $4ebc8f998887e712$var$checkFragment(editorView, editorView.state.schema, fragment);
        return $4ebc8f998887e712$export$3d24004275aefeab({
            node: fragment,
            featureToggles: featureToggles,
            mentionMap: mentionMap,
            idMap: idMap
        });
    }
    function $4ebc8f998887e712$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
        const markdownSerializerState = new (0, (0, parcelRequire("hTghy")).MarkdownSerializerState)(featureToggles, mentionMap, idMap);
        markdownSerializerState.renderContent(node);
        const pmStats = new (0, (0, parcelRequire("7aBvu")).ProseMirrorContentStatistics)(node);
        const contentStatistics = pmStats.collectStatistics();
        const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
        return {
            markdown: markdown,
            fallbackState: markdownSerializerState.fallbackState,
            idMap: markdownSerializerState.idMap,
            contentStatistics: contentStatistics
        };
    }
});
parcelRegister("7aBvu", function(module, exports) {
    $parcel$export(module.exports, "ProseMirrorContentStatistics", ()=>$4676d95affe52bb1$export$acf14785d7d5b1be);
    var $kCV8T;
    class $4676d95affe52bb1$export$acf14785d7d5b1be {
        constructor(content){
            this.content = content;
        }
        collectStatistics() {
            const { nodeCounts: nodeCounts, markCounts: markCounts } = this.countNodesAndMarks();
            const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
            return {
                nodeCounts: nodeCounts,
                markCounts: markCounts,
                totalCharacterCount: totalCharacterCount,
                contextSelectionScope: undefined
            };
        }
        countNodesAndMarks() {
            let nodeCounts = new Map();
            let markCounts = new Map();
            this.content.descendants((node)=>{
                nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
                node.marks.forEach((mark)=>{
                    markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
                });
            });
            return {
                nodeCounts: Object.fromEntries(nodeCounts),
                markCounts: Object.fromEntries(markCounts)
            };
        }
        calculateCharacterCounts() {
            let allTextContent = '';
            if (this.content instanceof (0, (0, parcelRequire("kCV8T")).Node)) allTextContent = this.content.textContent;
            else this.content.forEach((child)=>{
                allTextContent += child.textContent;
            });
            return {
                totalCharacterCount: allTextContent.length
            };
        }
    }
});
parcelRegister("hTghy", function(module, exports) {
    $parcel$export(module.exports, "MarkdownSerializerState", ()=>$ffd572cec1f7886e$export$61055fa707e69319);
    var $6fRr3;
    var $kCV8T;
    var $kgtrP;
    var $4bsQK;
    var $9FJBu;
    const $ffd572cec1f7886e$export$1c401dbe379e8c65 = (()=>{
        function getMaxLength(text) {
            const matches = text.match(/`+/g) || [];
            return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
        }
        return function(text, minLength = 1) {
            const length = Math.max(minLength, getMaxLength(text) + 1);
            return (0, (0, parcelRequire("9FJBu")).stringRepeat)('`', length);
        };
    })();
    class $ffd572cec1f7886e$export$61055fa707e69319 extends (0, (0, parcelRequire("6fRr3")).MarkdownSerializerState) {
        constructor(featureToggles, mentionMap, idMap){
            super($ffd572cec1f7886e$export$695720b7e7a61533, $ffd572cec1f7886e$export$3a8025f2f3e0c64, {}), this.idMap = {}, this.idCounter = 0, this.featureToggles = {}, this.mentionMap = {}, this.delim = '', this.out = '', this.closed = null, this.fallbackState = {}, this.context = {
                insideTable: false
            };
            this.nodes = $ffd572cec1f7886e$export$695720b7e7a61533;
            this.marks = $ffd572cec1f7886e$export$3a8025f2f3e0c64;
            this.featureToggles = featureToggles || {};
            this.mentionMap = mentionMap || {};
            this.idMap = idMap || {};
            this.idCounter = Object.keys(this.idMap).length;
        }
        findStateIdMap(state, targetType, targetAttributes) {
            for(const key in state.idMap){
                const { type: type, attributes: attributes } = state.idMap[key];
                if (type !== targetType) continue;
                let attributesMatch = true;
                for(const attrKey in targetAttributes)if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                    attributesMatch = false;
                    break;
                }
                if (attributesMatch) return key;
            }
            return null;
        }
        getIdBasedOnIdMap(state, type, attributes) {
            const id = state.findStateIdMap(state, type, attributes);
            if (id) return id;
            return `id-${state.idCounter++}`;
        }
        updateFallbackState(error, child) {
            if (error instanceof Error) {
                const childTypeName = child.type.name;
                const errorMessage = error.message;
                const childFallbackState = this.fallbackState?.[childTypeName];
                Object.assign(this.fallbackState, {
                    [childTypeName]: {
                        ...childFallbackState,
                        [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                    }
                });
            } else throw error;
        }
        atBlank() {
            return /(^|\n)$/.test(this.out);
        }
        flushClose(size = 2) {
            if (this.closed) {
                if (!this.atBlank()) this.out += '\n';
                if (size > 1) {
                    let delimMin = this.delim;
                    let trim = /\s+$/.exec(delimMin);
                    if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                    for(let i = 1; i < size; i++)this.out += delimMin + '\n';
                }
                this.closed = null;
            }
        }
        render(node, parent, index, options) {
            if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
            if (options?.skipFallback) this.nodes[node.type.name](this, node, parent, index, options);
            else try {
                this.nodes[node.type.name](this, node, parent, index, options);
            } catch (error) {
                this.updateFallbackState(error, node);
                return this.nodes.fallback(this, node);
            }
        }
        renderContent(parent) {
            parent.forEach((child, _offset, index)=>{
                if (child.isTextblock && !child.textContent && !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line(this, child);
                try {
                    return this.render(child, parent, index);
                } catch (error) {
                    this.updateFallbackState(error, child);
                    return this.nodes.fallback(this, child);
                }
            });
        }
        renderInline(parent, options) {
            const active = [];
            let trailing = '';
            const progress = (node, _, index)=>{
                let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
                let leading = trailing;
                trailing = '';
                if (node && node.isText && marks.some((mark)=>{
                    let info = this.marks[mark.type.name];
                    return info && info.expelEnclosingWhitespace;
                })) {
                    let [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                    leading += lead;
                    trailing = trail;
                    if (lead || trail) {
                        node = inner ? node.withText(inner) : null;
                        if (!node) marks = active;
                    }
                }
                const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
                const len = marks.length - (code ? 1 : 0);
                outer: for(let i = 0; i < len; i++){
                    const mark = marks[i];
                    if (!this.marks[mark.type.name].mixable) break;
                    for(let j = 0; j < active.length; j++){
                        const other = active[j];
                        if (!this.marks[other.type.name].mixable) break;
                        if (mark.eq(other)) {
                            if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                            else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                            continue outer;
                        }
                    }
                }
                let keep = 0;
                while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
                while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
                if (leading) this.text(leading);
                while(active.length < len){
                    const add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                }
                if (node) {
                    if (!code || !node.isText) this.render(node, parent, index);
                    else if (node.text) {
                        let text = node.text;
                        const backticks = $ffd572cec1f7886e$export$1c401dbe379e8c65(node.text, 1);
                        if (text.match(/^`/)) text = ' ' + text;
                        if (text.match(/`$/)) text += ' ';
                        this.text(backticks + text + backticks, false);
                    }
                }
            };
            parent.forEach((child, _offset, index)=>{
                if (options?.skipFallback) progress(child, parent, index);
                else try {
                    progress(child, parent, index);
                } catch (error) {
                    this.updateFallbackState(error, child);
                }
            });
            progress(null);
        }
        addBlockMarks(state, node, renderFunction) {
            const closingTags = [];
            const markFilters = [
                'alignment',
                'breakout',
                'border'
            ];
            const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
            if (marks.length === 0) {
                renderFunction();
                return;
            }
            marks.forEach((mark)=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: mark.type.name,
                    attributes: mark.attrs
                };
                state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
                closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
            });
            renderFunction();
            state.write(closingTags.join(''));
        }
    }
    const $ffd572cec1f7886e$var$editorNodes = {
        blockquote (state, node) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        codeBlock (state, node) {
            const backticks = $ffd572cec1f7886e$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        heading (state, node) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        rule (state, node) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        bulletList (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        orderedList (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        listItem (state, node, parent, index) {
            const order = (0, (0, parcelRequire("4bsQK")).getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                if (i > 0) state.write('\n');
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            if (index === parent.childCount - 1) state.write('\n');
        },
        taskList (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        taskItem (state, node) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        paragraph (state, node) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        mediaGroup (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        mediaSingle (state, node, parent) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
            if (parent instanceof (0, (0, parcelRequire("kCV8T")).Node)) state.write('\n');
            else state.write('\n\n');
        },
        media (state, node) {
            const baseUrl = 'blob:https://atlassianinternalmedia.com/?';
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})`);
        },
        image (state, node) {
            state.write('![' + (0, (0, parcelRequire("9FJBu")).escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, (0, parcelRequire("9FJBu")).escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        hardBreak (state) {
            state.write('  \n');
        },
        text (state, node, parent, index) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            const fourSpaces = '    ';
            if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, (0, parcelRequire("9FJBu")).escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
        },
        empty_line (state, node) {
            state.write('\u200c');
            state.closeBlock(node);
        },
        placeholder (state, node) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        mention (state, node, parent, index) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        date (state, node) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'date',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        emoji (state, node) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        inlineCard (state, node) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        status (state, node) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else throw new Error('Token type `status` not supported by Markdown renderer');
        },
        layoutSection (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        layoutColumn (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        expand (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        panel (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback(state, node);
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        nestedExpand (state, node) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        blockCard (state, node) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        embedCard (state, node) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        decisionList (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        decisionItem (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback(state, node);
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        extension (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        inlineExtension (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        bodiedExtension (state, node) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback(state, node);
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        fallback (state, node) {
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        }
    };
    const $ffd572cec1f7886e$export$695720b7e7a61533 = {
        ...$ffd572cec1f7886e$var$editorNodes,
        ...(0, (0, parcelRequire("kgtrP")).default)
    };
    const $ffd572cec1f7886e$export$3a8025f2f3e0c64 = {
        em: {
            open: '_',
            close: '_',
            mixable: true,
            expelEnclosingWhitespace: true
        },
        strong: {
            open: '**',
            close: '**',
            mixable: true,
            expelEnclosingWhitespace: true
        },
        strike: {
            open: '~~',
            close: '~~',
            mixable: true,
            expelEnclosingWhitespace: true
        },
        link: {
            open: '[',
            close (_state, mark) {
                return '](' + mark.attrs['href'] + ')';
            }
        },
        code: {
            open: '`',
            close: '`'
        }
    };
});
parcelRegister("kgtrP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2656854110d4813d$export$2e2bcd8739ae039);
    const $2656854110d4813d$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
    const $2656854110d4813d$var$isHeaderRowPresent = (table)=>{
        let headerRowPresent = false;
        table.content.forEach((row)=>{
            if ($2656854110d4813d$var$isHeaderRow(row)) headerRowPresent = true;
        });
        return headerRowPresent;
    };
    const $2656854110d4813d$var$renderNode = (state, node, index)=>{
        if (index > 0) state.write(' ');
        node.content.forEach((child, i)=>{
            if (child.isTextblock || child.type.name === 'mediaSingle') {
                if (i > 0) state.write(' ');
                state.context.insideTable = true;
                state.renderInline(child);
                state.context.insideTable = false;
            } else $2656854110d4813d$var$renderNode(state, child, i);
        });
    };
    const $2656854110d4813d$var$renderInlineContent = (state, node, _parent, _index, options)=>{
        options.headerRowPresent && state.write('| ');
        $2656854110d4813d$var$renderNode(state, node, 0);
        state.write(' ');
    };
    var $2656854110d4813d$export$2e2bcd8739ae039 = {
        table (state, node) {
            const headerRowPresent = $2656854110d4813d$var$isHeaderRowPresent(node);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        headerRowPresent: headerRowPresent,
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.closeBlock(node);
        },
        tableRow (state, node, _parent, _index, options) {
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        ...options,
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            if (options.headerRowPresent) {
                state.write('|');
                state.ensureNewLine();
                if ($2656854110d4813d$var$isHeaderRow(node)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        tableHeader (state, node, _parent, _index, options) {
            $2656854110d4813d$var$renderInlineContent(state, node, _parent, _index, options);
        },
        tableCell (state, node, _parent, _index, options) {
            $2656854110d4813d$var$renderInlineContent(state, node, _parent, _index, options);
        }
    };
});
parcelRegister("4bsQK", function(module, exports) {
    $parcel$export(module.exports, "getOrderFromMaybeOrderedListNode", ()=>$2fa039c0277541bc$export$4ea3c6bbdf8f7944);
    var $kCV8T;
    const $2fa039c0277541bc$export$8ef94ae42a3729bd = 1;
    const $2fa039c0277541bc$export$d445360e2a3c026b = (order)=>{
        const num = Number(order);
        if (Number.isNaN(num)) return;
        if (num < 0) return;
        return Math.floor(Math.max(num, 0));
    };
    const $2fa039c0277541bc$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
        if (!(maybeOrderedListNode instanceof (0, (0, parcelRequire("kCV8T")).Node))) return $2fa039c0277541bc$export$8ef94ae42a3729bd;
        const order = maybeOrderedListNode?.attrs?.order;
        return $2fa039c0277541bc$export$d445360e2a3c026b(order) ?? $2fa039c0277541bc$export$8ef94ae42a3729bd;
    };
});
parcelRegister("9FJBu", function(module, exports) {
    $parcel$export(module.exports, "stringRepeat", ()=>$dc91475dd4b0fc21$export$345d822805ab3239);
    $parcel$export(module.exports, "escapeMarkdown", ()=>$dc91475dd4b0fc21$export$560888d6fe0cfe97);
    function $dc91475dd4b0fc21$export$345d822805ab3239(text, length) {
        let result = '';
        for(let x = 0; x < length; x++)result += text;
        return result;
    }
    function $dc91475dd4b0fc21$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
        let strToEscape = str || '';
        strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : '\\' + m);
        if (startOfLine) strToEscape = strToEscape.replace(/^(\+[ ]|[\-*>])/, '\\$&').replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, '$1\\. ');
        if (insideTable) strToEscape = strToEscape.replace(/[|]/g, '\\$&');
        return strToEscape;
    }
    const $dc91475dd4b0fc21$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
    function $dc91475dd4b0fc21$var$removeSpecialCharacters(node) {
        if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($dc91475dd4b0fc21$var$SPECIAL_CHARACTERS, '');
        Array.from(node.childNodes).forEach((child)=>$dc91475dd4b0fc21$var$removeSpecialCharacters(child));
    }
    function $dc91475dd4b0fc21$export$9c95763b5a419f4c(html, options) {
        const el = document.createElement('div');
        el.innerHTML = html;
        Array.from(el.querySelectorAll('p')).forEach((p)=>{
            $dc91475dd4b0fc21$var$removeSpecialCharacters(p);
        });
        Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
            const span = document.createElement('span');
            span.setAttribute('class', 'editor-entity-mention');
            span.setAttribute('contenteditable', 'false');
            const atlassianId = a.getAttribute('data-atlassian-id') || '';
            if (atlassianId) span.setAttribute('data-mention-id', `{${atlassianId}}`);
            else {
                const title = a.getAttribute('title') || '';
                if (title) {
                    const usernameMatch = title.match(/^@(.*?)$/);
                    if (usernameMatch) {
                        const username = usernameMatch[1];
                        span.setAttribute('data-mention-id', username);
                    }
                }
            }
            const text = a.textContent || '';
            if (text.indexOf('@') === 0) span.textContent = a.textContent;
            else span.textContent = `@${a.textContent}`;
            a.parentNode.insertBefore(span, a);
            a.parentNode.removeChild(a);
        });
        Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
            const span = document.createElement('span');
            span.setAttribute('class', 'editor-entity-mention');
            span.setAttribute('contenteditable', 'false');
            const atlassianId = s.getAttribute('data-atlassian-id') || '';
            span.setAttribute('data-mention-id', `{${atlassianId}}`);
            const text = s.textContent || '';
            span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
            s.parentNode.insertBefore(span, s);
            s.parentNode.removeChild(s);
        });
        Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
            const span = document.createElement('span');
            let shortName = img.getAttribute('data-emoji-short-name') || '';
            if (!shortName) {
                const src = img.getAttribute('src');
                const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
                if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
            }
            if (shortName) span.setAttribute('data-emoji-short-name', shortName);
            img.parentNode.insertBefore(span, img);
            img.parentNode.removeChild(img);
        });
        if (!options.disableBitbucketLinkStripping) Array.from(el.querySelectorAll('a')).filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
            Array.from(a.childNodes).forEach((child)=>{
                a.parentNode.insertBefore(child, a);
            });
            a.parentNode.removeChild(a);
        });
        Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
            const { parentNode: parentNode } = img;
            if (!parentNode) return;
            if (parentNode !== el) {
                const isValidPath = validateImageNodeParent(parentNode);
                if (!isValidPath) liftImageNode(parentNode, img);
            }
            const mediaSingle = document.createElement('div');
            mediaSingle.setAttribute('data-node-type', 'mediaSingle');
            const media = document.createElement('div');
            media.setAttribute('data-node-type', 'media');
            media.setAttribute('data-type', 'external');
            media.setAttribute('data-alt', img.getAttribute('alt') || '');
            media.setAttribute('data-url', img.getAttribute('src'));
            mediaSingle.appendChild(media);
            img.parentNode.insertBefore(mediaSingle, img);
            img.parentNode.removeChild(img);
        });
        function validateImageNodeParent(node) {
            const ALLOWED_PARENTS = [
                'LI',
                'UL',
                'OL',
                'TD',
                'TH',
                'TR',
                'TBODY',
                'THEAD',
                'TABLE'
            ];
            if (node === el) return true;
            if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
            if (!node.parentNode) return false;
            return validateImageNodeParent(node.parentNode);
        }
        function liftImageNode(node, img) {
            let foundParent = false;
            let parent = node;
            while(!foundParent){
                foundParent = validateImageNodeParent(parent.parentNode);
                if (!foundParent) parent = parent.parentNode;
            }
            const cloned = parent.cloneNode();
            const target = parent !== el ? parent.parentNode : el;
            while(img.nextSibling)cloned.appendChild(img.nextSibling);
            if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
            if (parent.nextSibling) {
                target.insertBefore(cloned, parent.nextSibling);
                target.insertBefore(img, cloned);
            } else {
                target.appendChild(img);
                target.appendChild(cloned);
            }
            if (node.childNodes.length === 0) node.parentNode.removeChild(node);
            if (cloned.childNodes.length === 0) cloned.parentNode.removeChild(cloned);
        }
        return el;
    }
});
parcelRegister("4qz4W", function(module, exports) {
    $parcel$export(module.exports, "getContextSelectionScope", ()=>$2477b407cd683492$export$19bde12812d70545);
    const $2477b407cd683492$export$19bde12812d70545 = ({ editorView: editorView, slice: slice, node: node })=>{
        const hasContent = node ? (node.content?.size || 0) > 2 : slice ? slice.size >= 1 : false;
        if (hasContent) {
            if (slice?.content?.eq?.(editorView.state.doc.content) || node?.eq?.(editorView.state.doc)) return 'fullDocument';
            else return 'partialSelection';
        }
        return 'none';
    };
});
parcelRegister("k0tah", function(module, exports) {
    $parcel$export(module.exports, "PART_MAX_SIZE", ()=>$83ab6784958874b2$export$f12c20c20eb9758);
    $parcel$export(module.exports, "TOTAL_PARTS_MAX_SIZE", ()=>$83ab6784958874b2$export$168b97586e915764);
    $parcel$export(module.exports, "MAX_PARTS", ()=>$83ab6784958874b2$export$6913ef42a55e6d43);
    $parcel$export(module.exports, "QUEUE_MAX_ADDITIONAL_ATTEMPTS", ()=>$83ab6784958874b2$export$99bb9a7926dd9ef3);
    $parcel$export(module.exports, "DOC_CHANGE_COUNT_LIMIT", ()=>$83ab6784958874b2$export$4be82c580edb3724);
    $parcel$export(module.exports, "DOC_MINIMUM_SIZE_THRESHOLD", ()=>$83ab6784958874b2$export$d4efa8701a154af9);
    $parcel$export(module.exports, "START_PUNC_CHARS", ()=>$83ab6784958874b2$export$a98d32e897396dea);
    $parcel$export(module.exports, "END_PUNC_CHARS", ()=>$83ab6784958874b2$export$9ed3b6816d35bcaf);
    $parcel$export(module.exports, "MIDDLE_PUNC_CHARS", ()=>$83ab6784958874b2$export$6d1062a7dcc983cf);
    const $83ab6784958874b2$export$f12c20c20eb9758 = 5000;
    const $83ab6784958874b2$export$168b97586e915764 = 10000;
    const $83ab6784958874b2$export$6913ef42a55e6d43 = 50;
    const $83ab6784958874b2$export$99bb9a7926dd9ef3 = 2;
    const $83ab6784958874b2$export$4be82c580edb3724 = 8;
    const $83ab6784958874b2$export$d4efa8701a154af9 = 8;
    const $83ab6784958874b2$export$a98d32e897396dea = [
        ...Array.from(String.fromCharCode(39, 145, 147)),
        '(',
        '['
    ];
    const $83ab6784958874b2$export$9ed3b6816d35bcaf = [
        Array.from(String.fromCharCode(34, 39, 146, 148)),
        '.',
        ',',
        '!',
        '?',
        ')',
        ']'
    ];
    const $83ab6784958874b2$export$6d1062a7dcc983cf = Array.from(String.fromCharCode(45, 95, 150, 151, 39, 146));
});
parcelRegister("iTTpr", function(module, exports) {
    $parcel$export(module.exports, "suggestionGenerator", ()=>$682270dff813300c$export$446c4c603ad3a8df);
    var $ifg6x = parcelRequire("ifg6x");
    var $k0tah;
    function $682270dff813300c$var$isValidStreamingResponse(response) {
        return typeof response === 'object' && response !== null && 'id' in response && ('part' in response || 'error' in response);
    }
    function $682270dff813300c$var$parseResponse(paragraphs, response) {
        const chunk = paragraphs.find((p)=>response.id === p.id);
        if (!chunk || !$682270dff813300c$var$isValidStreamingResponse(response)) return {
            result: false,
            error: 'Invalid streaming response',
            chunkId: response.id
        };
        if ('error' in response) return {
            result: false,
            error: 'part was missing in reponse.',
            chunkId: chunk.id
        };
        return {
            result: true,
            chunk: chunk,
            response: {
                chunkId: chunk.id,
                suggestion: response.part,
                ...response.metadata && {
                    metadata: {
                        editDistanceRatio: Number(response.metadata.edit_distance_ratio) || undefined,
                        wordCountRatio: Number(response.metadata.word_count_ratio) || undefined,
                        originalContentLength: Number(response.metadata.original_content_length) || undefined
                    }
                }
            }
        };
    }
    const $682270dff813300c$var$paragraphCache = new Map();
    const $682270dff813300c$var$PARAGRAPH_CACHE_MAX_SIZE = 32;
    async function* $682270dff813300c$export$446c4c603ad3a8df({ endpoint: endpoint, paragraphs: paragraphs, abortController: abortController }) {
        const [cachedParagraphs, uncachedParagraphs] = (0, ($parcel$interopDefault($ifg6x)))(paragraphs, (p)=>$682270dff813300c$var$paragraphCache.has(p.text));
        if (cachedParagraphs.length > 0) {
            const suggestions = [];
            for (const cachedParagraph of cachedParagraphs){
                const suggestion = $682270dff813300c$var$paragraphCache.get(cachedParagraph.text);
                if (suggestion) {
                    $682270dff813300c$var$paragraphCache.delete(cachedParagraph.text);
                    $682270dff813300c$var$paragraphCache.set(cachedParagraph.text, suggestion);
                    suggestions.push({
                        chunkId: cachedParagraph.id,
                        suggestion: suggestion
                    });
                }
            }
            yield {
                state: 'cached',
                suggestions: suggestions
            };
        }
        if (!uncachedParagraphs.length) {
            yield {
                state: 'done'
            };
            return;
        }
        const purgedChunkIds = [];
        const totalParts = uncachedParagraphs.length;
        let attemptCount = 0;
        const [uncachedFilteredParagraphChunks, uncachedUnfilteredParagraphChunks] = (0, ($parcel$interopDefault($ifg6x)))(uncachedParagraphs, (p)=>p.text.length <= (0, (0, parcelRequire("k0tah")).PART_MAX_SIZE));
        purgedChunkIds.push(...uncachedUnfilteredParagraphChunks.map((p)=>p.id));
        while(uncachedFilteredParagraphChunks.length && attemptCount <= (0, (0, parcelRequire("k0tah")).QUEUE_MAX_ADDITIONAL_ATTEMPTS)){
            attemptCount++;
            const queue = [];
            let queueTotalPartsSize = 0;
            while(uncachedFilteredParagraphChunks.length && queueTotalPartsSize + uncachedFilteredParagraphChunks[0].text.length <= (0, (0, parcelRequire("k0tah")).TOTAL_PARTS_MAX_SIZE) && queue.length <= (0, (0, parcelRequire("k0tah")).MAX_PARTS)){
                const uncachedParagraph = uncachedFilteredParagraphChunks.shift();
                if (!uncachedParagraph) break;
                queueTotalPartsSize += uncachedParagraph.text.length;
                queue.push(uncachedParagraph);
            }
            if (!queue.length) break;
            const queuedChunkIds = queue.map((p)=>p.id);
            try {
                const requests = {};
                queue.forEach(({ id: id, text: text })=>{
                    requests[id] = text;
                });
                const payload = {
                    requests: requests
                };
                const startTime = performance.now();
                const response = await fetch(endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    body: JSON.stringify(payload),
                    credentials: 'include',
                    signal: abortController.signal,
                    mode: 'cors'
                });
                yield {
                    state: 'trackedDuration',
                    duration: performance.now() - startTime
                };
                if (!response.ok) {
                    yield {
                        state: 'failed',
                        reason: 'backend',
                        errors: [
                            `unexpected response status: ${response.status}`
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds
                    };
                    break;
                }
                if (!response.body) {
                    yield {
                        state: 'failed',
                        reason: 'network',
                        errors: [
                            'response.body missing'
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds
                    };
                    break;
                }
                const processedChunkIds = [];
                try {
                    const reader = response.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let lineBuffer = '';
                    let done = false;
                    while(!done){
                        const { value: value, done: doneReading } = await reader.read();
                        done = doneReading;
                        const chunkValue = decoder.decode(value);
                        lineBuffer = lineBuffer + chunkValue;
                        const lines = lineBuffer.split('\n');
                        const suggestions = [];
                        const errors = [];
                        const failedChunkIds = [];
                        while(lines.length > 1){
                            const line = lines.shift();
                            const parsedData = JSON.parse(line);
                            const parsedResponse = $682270dff813300c$var$parseResponse(queue, parsedData);
                            if (parsedResponse.result) {
                                const { suggestion: suggestion, chunkId: chunkId, metadata: metadata } = parsedResponse.response;
                                if ($682270dff813300c$var$paragraphCache.size >= $682270dff813300c$var$PARAGRAPH_CACHE_MAX_SIZE) $682270dff813300c$var$paragraphCache.delete($682270dff813300c$var$paragraphCache.keys().next().value);
                                $682270dff813300c$var$paragraphCache.set(parsedResponse.chunk.text, suggestion);
                                suggestions.push(parsedResponse.response);
                                processedChunkIds.push(chunkId);
                                if (metadata) yield {
                                    state: 'receivedChunkMetadata',
                                    chunkId: chunkId,
                                    metadata: metadata
                                };
                            } else {
                                errors.push(parsedResponse.error);
                                if (parsedResponse.chunkId) failedChunkIds.push(parsedResponse.chunkId);
                            }
                        }
                        if (suggestions.length) yield {
                            state: 'parsed',
                            suggestions: suggestions
                        };
                        if (errors.length) yield {
                            state: 'failed',
                            reason: 'backend',
                            errors: errors,
                            statusCode: response.status,
                            failedChunkIds: failedChunkIds
                        };
                        lineBuffer = lines[0];
                    }
                } catch (parsingError) {
                    yield {
                        state: 'failed',
                        reason: 'parsing',
                        errors: [
                            'parsingError'
                        ],
                        statusCode: response.status,
                        failedChunkIds: queuedChunkIds.filter((id)=>!processedChunkIds.includes(id))
                    };
                }
            } catch (error) {
                if (error.name === 'AbortError') yield {
                    state: 'failed',
                    reason: 'aborted',
                    errors: [
                        'Streaming aborted'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
                else yield {
                    state: 'failed',
                    reason: 'unhandled',
                    errors: error instanceof Error && [
                        'RangeError',
                        'TypeError',
                        'TransformError'
                    ].includes(error.name) ? [
                        error.message
                    ] : [
                        'unhandled'
                    ],
                    statusCode: error.status,
                    failedChunkIds: queuedChunkIds
                };
            }
        }
        if (uncachedFilteredParagraphChunks.length) purgedChunkIds.push(...uncachedFilteredParagraphChunks.map((p)=>p.id));
        if (purgedChunkIds.length) yield {
            state: 'purged',
            totalParts: totalParts,
            totalPurgedParts: purgedChunkIds.length,
            purgedChunkIds: purgedChunkIds
        };
        yield {
            state: 'done'
        };
        return;
    }
});
parcelRegister("dKZcc", function(module, exports) {
    $parcel$export(module.exports, "insertSuggestionWithAnalytics", ()=>$3f51130e1881a146$export$af587339ecdf284d);
    $parcel$export(module.exports, "removeSuggestionWithAnalytics", ()=>$3f51130e1881a146$export$affc0c5aaf5e127a);
    $parcel$export(module.exports, "initiateProactiveAIWithAnalytics", ()=>$3f51130e1881a146$export$fe4c4c84e37760a3);
    $parcel$export(module.exports, "handleSpellingAndGrammarWithAnalytics", ()=>$3f51130e1881a146$export$d9c4702e12c65c85);
    $parcel$export(module.exports, "fireAPIReceivedAnalytics", ()=>$3f51130e1881a146$export$aad0e8edaa8aea55);
    $parcel$export(module.exports, "disableCheckForFailedChunksWithAnalytics", ()=>$3f51130e1881a146$export$41b733971b0336c4);
    $parcel$export(module.exports, "disableCheckForPurgedChunksWithAnalytics", ()=>$3f51130e1881a146$export$f29ecadb5ce85861);
    $parcel$export(module.exports, "viewSuggestionWithAnalytics", ()=>$3f51130e1881a146$export$9133275f756efa31);
    $parcel$export(module.exports, "ignoreSuggestionWithAnalytics", ()=>$3f51130e1881a146$export$efe119032fbe030c);
    var $gzlJB = parcelRequire("gzlJB");
    var $gkwXh;
    var $5IPCv;
    var $gmhCD = parcelRequire("gmhCD");
    var $9m3ZB;
    var $kOl5n;
    var $1sHof;
    var $hcRrA;
    var $ldiyo;
    var $k0tah;
    var $5ilgR;
    const $3f51130e1881a146$var$getCommonAnalyticsAttributes = ()=>{
        const isEnabled = (0, $gmhCD.editorExperiment)('editor_ai_-_proactive_ai_model_variations', 'skip_grammar');
        const getExperimentValue = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue;
        const variation = getExperimentValue('editor_ai_-_proactive_ai_model_variations', 'cohort', 'not-enrolled');
        if (!isEnabled) return {
            variation: variation
        };
        return {
            variation: 'default'
        };
    };
    const $3f51130e1881a146$var$getSuggestionMetadata = ({ blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject, schema: schema })=>{
        if (!blockOrSentenceFromDiffObject) return;
        const metadata = {
            ...blockOrSentenceFromDiffObject?.metadata,
            inlineNodeCount: blockOrSentenceFromDiffObject?.ignoredRanges.filter(({ type: type })=>type === 'inlineNode').length,
            contextualFormatting: (0, (0, parcelRequire("5ilgR")).isFullStopOmittedInContainerType)(schema, blockOrSentenceFromDiffObject.containerType)
        };
        return metadata;
    };
    const $3f51130e1881a146$export$910690cf9669e26e = (diffObject)=>{
        const { text: text, originalText: originalText } = diffObject;
        if (!originalText || !text || !(originalText.length === text.length || Math.abs(originalText.length - text.length) === 1)) return {
            isFullStopAdded: false,
            isPunctuationChanged: false
        };
        const diffs = (0, (0, parcelRequire("kOl5n")).DiffMatchPatch).diff_main(originalText, text, false);
        switch(diffs.length){
            case 2:
                {
                    const [diff1, diff2] = diffs;
                    if (diff1[0] === 0 && diff2[0] === 1) return {
                        isFullStopAdded: diff2[1] === '.',
                        isPunctuationChanged: (0, (0, parcelRequire("k0tah")).END_PUNC_CHARS).includes(diff2[1])
                    };
                    if (diff1[0] === 1 && diff2[0] === 0) return {
                        isFullStopAdded: false,
                        isPunctuationChanged: (0, (0, parcelRequire("k0tah")).START_PUNC_CHARS).includes(diff1[1])
                    };
                    break;
                }
            case 3:
                {
                    const [diff1, diff2, diff3] = diffs;
                    if (diff1[0] === 0 && diff2[0] !== 0 && diff3[0] === 0) return {
                        isFullStopAdded: false,
                        isPunctuationChanged: (0, (0, parcelRequire("k0tah")).MIDDLE_PUNC_CHARS).includes(diff2[1])
                    };
                    break;
                }
            case 4:
                {
                    const [diff1, diff2, diff3, diff4] = diffs;
                    if (diff1[0] === 0 && diff2[0] === -1 && diff3[0] === 1 && diff4[0] === 0) return {
                        isFullStopAdded: false,
                        isPunctuationChanged: (0, (0, parcelRequire("k0tah")).MIDDLE_PUNC_CHARS).includes(diff2[1]) && (0, (0, parcelRequire("k0tah")).MIDDLE_PUNC_CHARS).includes(diff3[1])
                    };
                    break;
                }
            default:
                break;
        }
        return {
            isFullStopAdded: false,
            isPunctuationChanged: false
        };
    };
    const $3f51130e1881a146$export$af587339ecdf284d = ({ aiInteractionID: aiInteractionID, selectedDiff: selectedDiff, schema: schema, blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject })=>(0, (0, parcelRequire("9m3ZB")).withAnalytics)({
            payload: {
                action: 'inserted',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'spellingSuggestion',
                attributes: {
                    aiInteractionID: aiInteractionID,
                    ...$3f51130e1881a146$export$910690cf9669e26e(selectedDiff),
                    ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                    ...$3f51130e1881a146$var$getSuggestionMetadata({
                        blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                        schema: schema
                    })
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }
        })((0, (0, parcelRequire("ldiyo")).insertSuggestion)(selectedDiff));
    const $3f51130e1881a146$export$affc0c5aaf5e127a = ({ aiInteractionID: aiInteractionID, schema: schema, selectedDiff: selectedDiff, blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject })=>(0, (0, parcelRequire("9m3ZB")).withAnalytics)({
            payload: {
                action: 'dismissed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'spellingSuggestion',
                attributes: {
                    aiInteractionID: aiInteractionID,
                    ...$3f51130e1881a146$export$910690cf9669e26e(selectedDiff),
                    ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                    ...$3f51130e1881a146$var$getSuggestionMetadata({
                        blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                        schema: schema
                    })
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }
        })((0, (0, parcelRequire("ldiyo")).removeSuggestion)(selectedDiff.originalText));
    const $3f51130e1881a146$export$fe4c4c84e37760a3 = (aiInteractionID)=>(0, (0, parcelRequire("9m3ZB")).withAnalytics)({
            payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('initiated', aiInteractionID, 'Proactive Spelling and Grammar', true)
        });
    const $3f51130e1881a146$export$d9c4702e12c65c85 = ({ proactiveToggleCount: proactiveToggleCount, totalSuggestionsOnPage: totalSuggestionsOnPage, dismissedWords: dismissedWords, insertionCount: insertionCount, initialToggleState: initialToggleState, triggeredFrom: triggeredFrom, operationType: operationType })=>{
        const analyticsPayload = {
            action: 'toggled',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'spellingSuggestion',
            attributes: {
                ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                toggledCount: proactiveToggleCount,
                initialToggleState: initialToggleState,
                totalSuggestions: totalSuggestionsOnPage,
                totalAcceptedSuggestions: insertionCount,
                totalDismissedSuggestions: dismissedWords,
                triggeredFrom: triggeredFrom
            },
            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
        };
        const operation = operationType === 'start' ? (0, (0, parcelRequire("ldiyo")).startSpellingAndGrammar) : (0, (0, parcelRequire("ldiyo")).toggleSpellingAndGrammar);
        const operationWithAnalytics = (0, (0, parcelRequire("9m3ZB")).withAnalytics)({
            payload: analyticsPayload
        })(operation(proactiveToggleCount));
        return operationWithAnalytics;
    };
    const $3f51130e1881a146$var$getFireAPIReceivedAnalytics = ()=>{
        let apiReceivedCount = 0;
        const apiReceivedSamplingRate = 10;
        let durationArray = [];
        return ({ view: view, duration: duration, totalSuggestions: totalSuggestions, totalAcceptedSuggestions: totalAcceptedSuggestions, totalDismissedSuggestions: totalDismissedSuggestions })=>{
            apiReceivedCount++;
            durationArray.push(duration);
            if (apiReceivedCount >= apiReceivedSamplingRate) {
                const minDuration = Math.min(...durationArray);
                const maxDuration = Math.max(...durationArray);
                const meanDuration = (0, ($parcel$interopDefault($gzlJB)))(durationArray);
                const medianDuration = (0, (0, parcelRequire("1sHof")).median)(durationArray);
                const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: view.state,
                    tr: view.state.tr,
                    payload: {
                        action: 'apiReceived',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'spellingSuggestion',
                        attributes: {
                            ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                            meanDuration: meanDuration,
                            medianDuration: medianDuration,
                            minDuration: minDuration,
                            maxDuration: maxDuration,
                            totalSuggestions: totalSuggestions,
                            totalAcceptedSuggestions: totalAcceptedSuggestions,
                            totalDismissedSuggestions: totalDismissedSuggestions
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
                view.dispatch(tr);
                apiReceivedCount = 0;
                durationArray = [];
            }
        };
    };
    const $3f51130e1881a146$export$aad0e8edaa8aea55 = $3f51130e1881a146$var$getFireAPIReceivedAnalytics();
    const $3f51130e1881a146$export$41b733971b0336c4 = ({ view: view, failedChunkIds: failedChunkIds, errors: errors, reason: reason, statusCode: statusCode })=>(0, (0, parcelRequire("ldiyo")).disableNeedSpellingAndGrammar)(failedChunkIds, (tr)=>{
            const uniqueInteractionID = tr.getMeta((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey));
            let trWithAnalytics = tr;
            errors.forEach((error)=>{
                trWithAnalytics = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                    editorState: view.state,
                    tr: trWithAnalytics,
                    payload: {
                        action: 'apiError',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'spellingSuggestion',
                        attributes: {
                            ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                            error: error,
                            reason: reason,
                            statusCode: statusCode
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
            });
            trWithAnalytics = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: view.state,
                tr: trWithAnalytics,
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('error', uniqueInteractionID, 'Proactive Spelling and Grammar', true, {
                    aiErrorMessage: reason,
                    aiErrorCode: statusCode
                })
            });
            return trWithAnalytics;
        });
    const $3f51130e1881a146$export$f29ecadb5ce85861 = ({ purgedChunkIds: purgedChunkIds, totalParts: totalParts, totalPurgedParts: totalPurgedParts })=>{
        return (0, (0, parcelRequire("9m3ZB")).withAnalytics)({
            payload: {
                action: 'apiPurged',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'spellingSuggestion',
                attributes: {
                    ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                    totalParts: totalParts,
                    totalPurgedParts: totalPurgedParts
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            }
        })((0, (0, parcelRequire("ldiyo")).disableNeedSpellingAndGrammar)(purgedChunkIds));
    };
    const $3f51130e1881a146$export$9133275f756efa31 = (aiInteractionId, editorState)=>(0, (0, parcelRequire("9m3ZB")).addAnalytics)({
            editorState: editorState,
            tr: editorState.tr,
            payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('viewed', aiInteractionId, 'Proactive Spelling and Grammar', true)
        });
    const $3f51130e1881a146$export$efe119032fbe030c = ({ aiInteractionID: aiInteractionID, editorState: editorState, selectedDiff: selectedDiff, blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject, transaction: transaction })=>(0, (0, parcelRequire("9m3ZB")).addAnalytics)({
            editorState: editorState,
            tr: transaction ?? editorState.tr,
            payload: {
                action: 'ignored',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'spellingSuggestion',
                attributes: {
                    aiInteractionID: aiInteractionID,
                    ...$3f51130e1881a146$export$910690cf9669e26e(selectedDiff),
                    ...$3f51130e1881a146$var$getCommonAnalyticsAttributes(),
                    ...$3f51130e1881a146$var$getSuggestionMetadata({
                        schema: editorState.schema,
                        blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject
                    })
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).TRACK
            }
        });
});
parcelRegister("kOl5n", function(module, exports) {
    $parcel$export(module.exports, "DiffMatchPatch", ()=>$df91bd55a5903c43$export$c1e60f059545054a);
    var $df91bd55a5903c43$export$b7b760e1e7f1805e = function() {
        this.Diff_Timeout = 1.0;
        this.Diff_EditCost = 4;
        this.Match_Threshold = 0.5;
        this.Match_Distance = 1000;
        this.Patch_DeleteThreshold = 0.5;
        this.Patch_Margin = 4;
        this.Match_MaxBits = 32;
    };
    var $df91bd55a5903c43$var$DIFF_DELETE = -1;
    var $df91bd55a5903c43$var$DIFF_INSERT = 1;
    var $df91bd55a5903c43$var$DIFF_EQUAL = 0;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff = function(op, text) {
        this[0] = op;
        this[1] = text;
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff.prototype.length = 2;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff.prototype.toString = function() {
        return this[0] + ',' + this[1];
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
        if (typeof opt_deadline == 'undefined') {
            if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
            else opt_deadline = new Date().getTime() + this.Diff_Timeout * 1000;
        }
        var deadline = opt_deadline;
        if (text1 == null || text2 == null) throw new Error('Null input. (diff_main)');
        if (text1 == text2) {
            if (text1) return [
                new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, text1)
            ];
            return [];
        }
        if (typeof opt_checklines == 'undefined') opt_checklines = true;
        var checklines = opt_checklines;
        var commonlength = this.diff_commonPrefix(text1, text2);
        var commonprefix = text1.substring(0, commonlength);
        text1 = text1.substring(commonlength);
        text2 = text2.substring(commonlength);
        commonlength = this.diff_commonSuffix(text1, text2);
        var commonsuffix = text1.substring(text1.length - commonlength);
        text1 = text1.substring(0, text1.length - commonlength);
        text2 = text2.substring(0, text2.length - commonlength);
        var diffs = this.diff_compute_(text1, text2, checklines, deadline);
        if (commonprefix) diffs.unshift(new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, commonprefix));
        if (commonsuffix) diffs.push(new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, commonsuffix));
        this.diff_cleanupMerge(diffs);
        return diffs;
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
        var diffs;
        if (!text1) return [
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, text2)
        ];
        if (!text2) return [
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_DELETE, text1)
        ];
        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        var i = longtext.indexOf(shorttext);
        if (i != -1) {
            diffs = [
                new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, longtext.substring(0, i)),
                new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, shorttext),
                new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, longtext.substring(i + shorttext.length))
            ];
            if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $df91bd55a5903c43$var$DIFF_DELETE;
            return diffs;
        }
        if (shorttext.length == 1) return [
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_DELETE, text1),
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, text2)
        ];
        var hm = this.diff_halfMatch_(text1, text2);
        if (hm) {
            var text1_a = hm[0];
            var text1_b = hm[1];
            var text2_a = hm[2];
            var text2_b = hm[3];
            var mid_common = hm[4];
            var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
            var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
            return diffs_a.concat([
                new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, mid_common)
            ], diffs_b);
        }
        if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
        return this.diff_bisect_(text1, text2, deadline);
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_lineMode_ = function(text1, text2, deadline) {
        var a = this.diff_linesToChars_(text1, text2);
        text1 = a.chars1;
        text2 = a.chars2;
        var linearray = a.lineArray;
        var diffs = this.diff_main(text1, text2, false, deadline);
        this.diff_charsToLines_(diffs, linearray);
        this.diff_cleanupSemantic(diffs);
        diffs.push(new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, ''));
        var pointer = 0;
        var count_delete = 0;
        var count_insert = 0;
        var text_delete = '';
        var text_insert = '';
        while(pointer < diffs.length){
            switch(diffs[pointer][0]){
                case $df91bd55a5903c43$var$DIFF_INSERT:
                    count_insert++;
                    text_insert += diffs[pointer][1];
                    break;
                case $df91bd55a5903c43$var$DIFF_DELETE:
                    count_delete++;
                    text_delete += diffs[pointer][1];
                    break;
                case $df91bd55a5903c43$var$DIFF_EQUAL:
                    if (count_delete >= 1 && count_insert >= 1) {
                        diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                        pointer = pointer - count_delete - count_insert;
                        var subDiff = this.diff_main(text_delete, text_insert, false, deadline);
                        for(var j = subDiff.length - 1; j >= 0; j--)diffs.splice(pointer, 0, subDiff[j]);
                        pointer = pointer + subDiff.length;
                    }
                    count_insert = 0;
                    count_delete = 0;
                    text_delete = '';
                    text_insert = '';
                    break;
            }
            pointer++;
        }
        diffs.pop();
        return diffs;
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_bisect_ = function(text1, text2, deadline) {
        var text1_length = text1.length;
        var text2_length = text2.length;
        var max_d = Math.ceil((text1_length + text2_length) / 2);
        var v_offset = max_d;
        var v_length = 2 * max_d;
        var v1 = new Array(v_length);
        var v2 = new Array(v_length);
        for(var x = 0; x < v_length; x++){
            v1[x] = -1;
            v2[x] = -1;
        }
        v1[v_offset + 1] = 0;
        v2[v_offset + 1] = 0;
        var delta = text1_length - text2_length;
        var front = delta % 2 != 0;
        var k1start = 0;
        var k1end = 0;
        var k2start = 0;
        var k2end = 0;
        for(var d = 0; d < max_d; d++){
            if (new Date().getTime() > deadline) break;
            for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
                var k1_offset = v_offset + k1;
                var x1;
                if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
                else x1 = v1[k1_offset - 1] + 1;
                var y1 = x1 - k1;
                while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                    x1++;
                    y1++;
                }
                v1[k1_offset] = x1;
                if (x1 > text1_length) k1end += 2;
                else if (y1 > text2_length) k1start += 2;
                else if (front) {
                    var k2_offset = v_offset + delta - k1;
                    if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                        var x2 = text1_length - v2[k2_offset];
                        if (x1 >= x2) return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                    }
                }
            }
            for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
                var k2_offset = v_offset + k2;
                var x2;
                if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
                else x2 = v2[k2_offset - 1] + 1;
                var y2 = x2 - k2;
                while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                    x2++;
                    y2++;
                }
                v2[k2_offset] = x2;
                if (x2 > text1_length) k2end += 2;
                else if (y2 > text2_length) k2start += 2;
                else if (!front) {
                    var k1_offset = v_offset + delta - k2;
                    if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                        var x1 = v1[k1_offset];
                        var y1 = v_offset + x1 - k1_offset;
                        x2 = text1_length - x2;
                        if (x1 >= x2) return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                    }
                }
            }
        }
        return [
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_DELETE, text1),
            new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, text2)
        ];
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
        var text1a = text1.substring(0, x);
        var text2a = text2.substring(0, y);
        var text1b = text1.substring(x);
        var text2b = text2.substring(y);
        var diffs = this.diff_main(text1a, text2a, false, deadline);
        var diffsb = this.diff_main(text1b, text2b, false, deadline);
        return diffs.concat(diffsb);
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_linesToChars_ = function(text1, text2) {
        var lineArray = [];
        var lineHash = {};
        lineArray[0] = '';
        function diff_linesToCharsMunge_(text) {
            var chars = '';
            var lineStart = 0;
            var lineEnd = -1;
            var lineArrayLength = lineArray.length;
            while(lineEnd < text.length - 1){
                lineEnd = text.indexOf('\n', lineStart);
                if (lineEnd == -1) lineEnd = text.length - 1;
                var line = text.substring(lineStart, lineEnd + 1);
                if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
                else {
                    if (lineArrayLength == maxLines) {
                        line = text.substring(lineStart);
                        lineEnd = text.length;
                    }
                    chars += String.fromCharCode(lineArrayLength);
                    lineHash[line] = lineArrayLength;
                    lineArray[lineArrayLength++] = line;
                }
                lineStart = lineEnd + 1;
            }
            return chars;
        }
        var maxLines = 40000;
        var chars1 = diff_linesToCharsMunge_(text1);
        maxLines = 65535;
        var chars2 = diff_linesToCharsMunge_(text2);
        return {
            chars1: chars1,
            chars2: chars2,
            lineArray: lineArray
        };
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_linesToWords_ = function(text1, text2) {
        var lineArray = [];
        var lineHash = {};
        lineArray[0] = '';
        function diff_linesToWordsMunge_(text) {
            var chars = '';
            var lineStart = 0;
            var lineEnd = -1;
            const delims = [
                '.',
                ',',
                '?',
                '!',
                ':',
                ';',
                ' ',
                '\uFFFB',
                '\uFFF9'
            ];
            var lineArrayLength = lineArray.length;
            while(text?.length && lineEnd < text.length - 1){
                lineEnd = delims.reduce((v, c)=>{
                    const i = text.indexOf(c, lineStart);
                    return i !== -1 && i < v ? i : v;
                }, text.length - 1);
                const foundDelim = delims.includes(text.charAt(lineEnd));
                if (lineEnd == -1) lineEnd = text.length - 1;
                if (foundDelim) {
                    const delim = text.charAt(lineEnd);
                    let length = 1;
                    for(let i = lineEnd + 1; i < text.length; i++){
                        if (text.charAt(i) !== delim) break;
                        length++;
                    }
                    lineEnd += length - 1;
                }
                var line = text.substring(lineStart, lineEnd + 1);
                if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
                else {
                    if (lineArrayLength == maxLines) {
                        line = text.substring(lineStart);
                        lineEnd = text.length;
                    }
                    chars += String.fromCharCode(lineArrayLength);
                    lineHash[line] = lineArrayLength;
                    lineArray[lineArrayLength++] = line;
                }
                lineStart = lineEnd + 1;
            }
            return chars;
        }
        var maxLines = 40000;
        var chars1 = diff_linesToWordsMunge_(text1);
        maxLines = 65535;
        var chars2 = diff_linesToWordsMunge_(text2);
        return {
            chars1: chars1,
            chars2: chars2,
            lineArray: lineArray
        };
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_charsToLines_ = function(diffs, lineArray) {
        for(var i = 0; i < diffs.length; i++){
            var chars = diffs[i][1];
            var text = [];
            for(var j = 0; j < chars.length; j++)text[j] = lineArray[chars.charCodeAt(j)];
            diffs[i][1] = text.join('');
        }
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_commonPrefix = function(text1, text2) {
        if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerstart = 0;
        while(pointermin < pointermid){
            if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                pointermin = pointermid;
                pointerstart = pointermin;
            } else pointermax = pointermid;
            pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_commonSuffix = function(text1, text2) {
        if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerend = 0;
        while(pointermin < pointermid){
            if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                pointermin = pointermid;
                pointerend = pointermin;
            } else pointermax = pointermid;
            pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_commonOverlap_ = function(text1, text2) {
        var text1_length = text1.length;
        var text2_length = text2.length;
        if (text1_length == 0 || text2_length == 0) return 0;
        if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
        else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
        var text_length = Math.min(text1_length, text2_length);
        if (text1 == text2) return text_length;
        var best = 0;
        var length = 1;
        while(true){
            var pattern = text1.substring(text_length - length);
            var found = text2.indexOf(pattern);
            if (found == -1) return best;
            length += found;
            if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
                best = length;
                length++;
            }
        }
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_halfMatch_ = function(text1, text2) {
        if (this.Diff_Timeout <= 0) return null;
        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null;
        var dmp = this;
        function diff_halfMatchI_(longtext, shorttext, i) {
            var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
            var j = -1;
            var best_common = '';
            var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
            while((j = shorttext.indexOf(seed, j + 1)) != -1){
                var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
                var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
                if (best_common.length < suffixLength + prefixLength) {
                    best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                    best_longtext_a = longtext.substring(0, i - suffixLength);
                    best_longtext_b = longtext.substring(i + prefixLength);
                    best_shorttext_a = shorttext.substring(0, j - suffixLength);
                    best_shorttext_b = shorttext.substring(j + prefixLength);
                }
            }
            if (best_common.length * 2 >= longtext.length) return [
                best_longtext_a,
                best_longtext_b,
                best_shorttext_a,
                best_shorttext_b,
                best_common
            ];
            else return null;
        }
        var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
        var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
        var hm;
        if (!hm1 && !hm2) return null;
        else if (!hm2) hm = hm1;
        else if (!hm1) hm = hm2;
        else hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
        var text1_a, text1_b, text2_a, text2_b;
        if (text1.length > text2.length) {
            text1_a = hm[0];
            text1_b = hm[1];
            text2_a = hm[2];
            text2_b = hm[3];
        } else {
            text2_a = hm[0];
            text2_b = hm[1];
            text1_a = hm[2];
            text1_b = hm[3];
        }
        var mid_common = hm[4];
        return [
            text1_a,
            text1_b,
            text2_a,
            text2_b,
            mid_common
        ];
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_cleanupSemantic = function(diffs) {
        var changes = false;
        var equalities = [];
        var equalitiesLength = 0;
        var lastEquality = null;
        var pointer = 0;
        var length_insertions1 = 0;
        var length_deletions1 = 0;
        var length_insertions2 = 0;
        var length_deletions2 = 0;
        while(pointer < diffs.length){
            if (diffs[pointer][0] == $df91bd55a5903c43$var$DIFF_EQUAL) {
                equalities[equalitiesLength++] = pointer;
                length_insertions1 = length_insertions2;
                length_deletions1 = length_deletions2;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastEquality = diffs[pointer][1];
            } else {
                if (diffs[pointer][0] == $df91bd55a5903c43$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
                else length_deletions2 += diffs[pointer][1].length;
                if (lastEquality && lastEquality.length <= Math.max(length_insertions1, length_deletions1) && lastEquality.length <= Math.max(length_insertions2, length_deletions2)) {
                    diffs.splice(equalities[equalitiesLength - 1], 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_DELETE, lastEquality));
                    diffs[equalities[equalitiesLength - 1] + 1][0] = $df91bd55a5903c43$var$DIFF_INSERT;
                    equalitiesLength--;
                    equalitiesLength--;
                    pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                    length_insertions1 = 0;
                    length_deletions1 = 0;
                    length_insertions2 = 0;
                    length_deletions2 = 0;
                    lastEquality = null;
                    changes = true;
                }
            }
            pointer++;
        }
        if (changes) this.diff_cleanupMerge(diffs);
        this.diff_cleanupSemanticLossless(diffs);
        pointer = 1;
        while(pointer < diffs.length){
            if (diffs[pointer - 1][0] == $df91bd55a5903c43$var$DIFF_DELETE && diffs[pointer][0] == $df91bd55a5903c43$var$DIFF_INSERT) {
                var deletion = diffs[pointer - 1][1];
                var insertion = diffs[pointer][1];
                var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
                var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
                if (overlap_length1 >= overlap_length2) {
                    if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                        diffs.splice(pointer, 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, insertion.substring(0, overlap_length1)));
                        diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                        diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                        pointer++;
                    }
                } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                    diffs.splice(pointer, 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, deletion.substring(0, overlap_length2)));
                    diffs[pointer - 1][0] = $df91bd55a5903c43$var$DIFF_INSERT;
                    diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                    diffs[pointer + 1][0] = $df91bd55a5903c43$var$DIFF_DELETE;
                    diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                    pointer++;
                }
                pointer++;
            }
            pointer++;
        }
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_cleanupSemanticLossless = function(diffs) {
        function diff_cleanupSemanticScore_(one, two) {
            if (!one || !two) return 6;
            var char1 = one.charAt(one.length - 1);
            var char2 = two.charAt(0);
            var nonAlphaNumeric1 = char1.match($df91bd55a5903c43$export$b7b760e1e7f1805e.nonAlphaNumericRegex_);
            var nonAlphaNumeric2 = char2.match($df91bd55a5903c43$export$b7b760e1e7f1805e.nonAlphaNumericRegex_);
            var whitespace1 = nonAlphaNumeric1 && char1.match($df91bd55a5903c43$export$b7b760e1e7f1805e.whitespaceRegex_);
            var whitespace2 = nonAlphaNumeric2 && char2.match($df91bd55a5903c43$export$b7b760e1e7f1805e.whitespaceRegex_);
            var lineBreak1 = whitespace1 && char1.match($df91bd55a5903c43$export$b7b760e1e7f1805e.linebreakRegex_);
            var lineBreak2 = whitespace2 && char2.match($df91bd55a5903c43$export$b7b760e1e7f1805e.linebreakRegex_);
            var blankLine1 = lineBreak1 && one.match($df91bd55a5903c43$export$b7b760e1e7f1805e.blanklineEndRegex_);
            var blankLine2 = lineBreak2 && two.match($df91bd55a5903c43$export$b7b760e1e7f1805e.blanklineStartRegex_);
            if (blankLine1 || blankLine2) return 5;
            else if (lineBreak1 || lineBreak2) return 4;
            else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) return 3;
            else if (whitespace1 || whitespace2) return 2;
            else if (nonAlphaNumeric1 || nonAlphaNumeric2) return 1;
            return 0;
        }
        var pointer = 1;
        while(pointer < diffs.length - 1){
            if (diffs[pointer - 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL && diffs[pointer + 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL) {
                var equality1 = diffs[pointer - 1][1];
                var edit = diffs[pointer][1];
                var equality2 = diffs[pointer + 1][1];
                var commonOffset = this.diff_commonSuffix(equality1, edit);
                if (commonOffset) {
                    var commonString = edit.substring(edit.length - commonOffset);
                    equality1 = equality1.substring(0, equality1.length - commonOffset);
                    edit = commonString + edit.substring(0, edit.length - commonOffset);
                    equality2 = commonString + equality2;
                }
                var bestEquality1 = equality1;
                var bestEdit = edit;
                var bestEquality2 = equality2;
                var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                while(edit.charAt(0) === equality2.charAt(0)){
                    equality1 += edit.charAt(0);
                    edit = edit.substring(1) + equality2.charAt(0);
                    equality2 = equality2.substring(1);
                    var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                    if (score >= bestScore) {
                        bestScore = score;
                        bestEquality1 = equality1;
                        bestEdit = edit;
                        bestEquality2 = equality2;
                    }
                }
                if (diffs[pointer - 1][1] != bestEquality1) {
                    if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                    else {
                        diffs.splice(pointer - 1, 1);
                        pointer--;
                    }
                    diffs[pointer][1] = bestEdit;
                    if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                    else {
                        diffs.splice(pointer + 1, 1);
                        pointer--;
                    }
                }
            }
            pointer++;
        }
    };
    $df91bd55a5903c43$export$b7b760e1e7f1805e.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.whitespaceRegex_ = /\s/;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.linebreakRegex_ = /[\r\n]/;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.blanklineEndRegex_ = /\n\r?\n$/;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.blanklineStartRegex_ = /^\r?\n\r?\n/;
    $df91bd55a5903c43$export$b7b760e1e7f1805e.prototype.diff_cleanupMerge = function(diffs) {
        diffs.push(new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, ''));
        var pointer = 0;
        var count_delete = 0;
        var count_insert = 0;
        var text_delete = '';
        var text_insert = '';
        var commonlength;
        while(pointer < diffs.length)switch(diffs[pointer][0]){
            case $df91bd55a5903c43$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                pointer++;
                break;
            case $df91bd55a5903c43$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                pointer++;
                break;
            case $df91bd55a5903c43$var$DIFF_EQUAL:
                if (count_delete + count_insert > 1) {
                    if (count_delete !== 0 && count_insert !== 0) {
                        commonlength = this.diff_commonPrefix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                            else {
                                diffs.splice(0, 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_EQUAL, text_insert.substring(0, commonlength)));
                                pointer++;
                            }
                            text_insert = text_insert.substring(commonlength);
                            text_delete = text_delete.substring(commonlength);
                        }
                        commonlength = this.diff_commonSuffix(text_insert, text_delete);
                        if (commonlength !== 0) {
                            diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                            text_insert = text_insert.substring(0, text_insert.length - commonlength);
                            text_delete = text_delete.substring(0, text_delete.length - commonlength);
                        }
                    }
                    pointer -= count_delete + count_insert;
                    diffs.splice(pointer, count_delete + count_insert);
                    if (text_delete.length) {
                        diffs.splice(pointer, 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_DELETE, text_delete));
                        pointer++;
                    }
                    if (text_insert.length) {
                        diffs.splice(pointer, 0, new $df91bd55a5903c43$export$b7b760e1e7f1805e.Diff($df91bd55a5903c43$var$DIFF_INSERT, text_insert));
                        pointer++;
                    }
                    pointer++;
                } else if (pointer !== 0 && diffs[pointer - 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL) {
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                } else pointer++;
                count_insert = 0;
                count_delete = 0;
                text_delete = '';
                text_insert = '';
                break;
        }
        if (diffs[diffs.length - 1][1] === '') diffs.pop();
        var changes = false;
        pointer = 1;
        while(pointer < diffs.length - 1){
            if (diffs[pointer - 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL && diffs[pointer + 1][0] == $df91bd55a5903c43$var$DIFF_EQUAL) {
                if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                    diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                    diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                    diffs.splice(pointer - 1, 1);
                    changes = true;
                } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                    diffs[pointer - 1][1] += diffs[pointer + 1][1];
                    diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                    diffs.splice(pointer + 1, 1);
                    changes = true;
                }
            }
            pointer++;
        }
        if (changes) this.diff_cleanupMerge(diffs);
    };
    const $df91bd55a5903c43$export$c1e60f059545054a = new $df91bd55a5903c43$export$b7b760e1e7f1805e();
});
parcelRegister("hcRrA", function(module, exports) {
    $parcel$export(module.exports, "aiSpellingGrammarPluginKey", ()=>$65f4a1d14689be14$export$6efc670e6f6b178d);
    var $gZGBX;
    const $65f4a1d14689be14$export$6efc670e6f6b178d = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiSpellingGrammarPlugin');
});
parcelRegister("5ilgR", function(module, exports) {
    $parcel$export(module.exports, "isFullStopOmittedInContainerType", ()=>$5d0561c2bcb1a2d6$export$54634bd503649803);
    $parcel$export(module.exports, "getDiffObjectsForSuggestions", ()=>$5d0561c2bcb1a2d6$export$c180561f232e057c);
    $parcel$export(module.exports, "findProactiveAIBlockToUpdate", ()=>$5d0561c2bcb1a2d6$export$9301b11c75053a3b);
    $parcel$export(module.exports, "getBlocksSentences", ()=>$5d0561c2bcb1a2d6$export$645ff1143283928c);
    $parcel$export(module.exports, "getAllProactiveAIBlocks", ()=>$5d0561c2bcb1a2d6$export$84c79514d0cb7da7);
    $parcel$export(module.exports, "canSplitParagraphIntoSentences", ()=>$5d0561c2bcb1a2d6$export$a711c9a3134fe8fe);
    $parcel$export(module.exports, "getSelectedDiffObject", ()=>$5d0561c2bcb1a2d6$export$3536104194f7cad9);
    $parcel$export(module.exports, "removeSelectedDiffObjectFromBlock", ()=>$5d0561c2bcb1a2d6$export$fca0e09b162fa67a);
    $parcel$export(module.exports, "removeDiffObjectFromBlockMatchingText", ()=>$5d0561c2bcb1a2d6$export$ed3ca0d35db42f45);
    $parcel$export(module.exports, "generateParagraphChunkMap", ()=>$5d0561c2bcb1a2d6$export$3aacaf06d69b33cc);
    $parcel$export(module.exports, "getBlocksSentencesNeedingSGCheck", ()=>$5d0561c2bcb1a2d6$export$9fe1477d9038ebb9);
    $parcel$export(module.exports, "getAllDiffObjects", ()=>$5d0561c2bcb1a2d6$export$da69170cd3d417b4);
    $parcel$export(module.exports, "setBlocksDiffObjects", ()=>$5d0561c2bcb1a2d6$export$4851e3f4e562b23c);
    $parcel$export(module.exports, "getBlockOrSentenceFromDiffObject", ()=>$5d0561c2bcb1a2d6$export$23f20dde4928da8b);
    $parcel$export(module.exports, "isDiffObjectInPluginState", ()=>$5d0561c2bcb1a2d6$export$5a617a26a8fdefee);
    var $bXrHm = parcelRequire("bXrHm");
    var $kCV8T;
    var $eS2Dn;
    var $VSDnB;
    var $3n50y;
    var $k93aA;
    const $5d0561c2bcb1a2d6$export$e5022a60bacc9f19 = ({ schema: { nodes: nodes } })=>new Set([
            nodes.bulletList,
            nodes.caption,
            nodes.decisionItem,
            nodes.decisionList,
            nodes.expand,
            nodes.heading,
            nodes.layoutColumn,
            nodes.layoutSection,
            nodes.listItem,
            nodes.nestedExpand,
            nodes.orderedList,
            nodes.panel,
            nodes.paragraph,
            nodes.table,
            nodes.tableRow,
            nodes.tableCell,
            nodes.tableHeader,
            nodes.taskItem,
            nodes.taskList
        ]);
    const $5d0561c2bcb1a2d6$export$2e312585e39e3b9f = ({ schema: { nodes: nodes } })=>new Set([
            nodes.decisionItem,
            nodes.heading,
            nodes.paragraph,
            nodes.taskItem
        ]);
    const $5d0561c2bcb1a2d6$var$getContextualNodeTypes = ({ nodes: nodes })=>new Set([
            nodes.heading,
            nodes.taskItem,
            nodes.decisionItem
        ]);
    const $5d0561c2bcb1a2d6$var$getContextualParentNodeTypes = ({ nodes: nodes })=>new Set([
            nodes.listItem,
            nodes.tableHeader
        ]);
    const $5d0561c2bcb1a2d6$export$54634bd503649803 = (schema, containerType)=>{
        if ($5d0561c2bcb1a2d6$var$getContextualNodeTypes(schema).has(containerType) || $5d0561c2bcb1a2d6$var$getContextualParentNodeTypes(schema).has(containerType)) return true;
        return false;
    };
    const $5d0561c2bcb1a2d6$export$acc6f3e19803b3dc = (schema, node, parent)=>{
        if ($5d0561c2bcb1a2d6$var$getContextualNodeTypes(schema).has(node.type)) return node.type;
        if (node.type === schema.nodes.paragraph && parent && $5d0561c2bcb1a2d6$var$getContextualParentNodeTypes(schema).has(parent.type)) return parent.type;
        return node.type;
    };
    const $5d0561c2bcb1a2d6$var$getIgnoredMarkRangesPredicate = ({ schema: { marks: marks } })=>(node)=>{
            if (!node.isText) return false;
            return node.marks.some((mark)=>mark.type === marks.code || mark.type === marks.link && node.text === mark.attrs?.href);
        };
    const $5d0561c2bcb1a2d6$export$c180561f232e057c = ({ editorView: editorView, suggestions: suggestions, paragraphChunkMap: paragraphChunkMap })=>{
        const chunksDiffObjectsById = new Map();
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_ai_md_plus')) suggestions.forEach((suggestionData)=>{
            const { chunkId: chunkId, suggestion: suggestion, chunkIdMap: chunkIdMap } = suggestionData;
            const chunk = paragraphChunkMap.get(chunkId);
            if (chunk) {
                const { state: { schema: schema, doc: doc } } = editorView;
                const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                    markdown: suggestion,
                    schema: schema,
                    idMap: chunkIdMap || {},
                    featureToggles: {
                        markdownPlus: true
                    }
                });
                const diffs = (0, (0, parcelRequire("k93aA")).createDiffObjectsFromFragments)({
                    id: chunkId,
                    original: (0, (0, parcelRequire("kCV8T")).Fragment).from(doc.cut(chunk.from, chunk.to)),
                    corrected: pmFragment,
                    schema: schema,
                    offset: chunk.from,
                    containerType: chunk.containerType,
                    ignoredRanges: chunk.ignoredRanges
                });
                chunksDiffObjectsById.set(chunkId, diffs.filter((diff)=>diff.type === 'REPLACEMENT' && !diff.isWhiteSpace));
            }
        });
        else suggestions.forEach((suggestionData)=>{
            const { chunkId: chunkId, suggestion: suggestion } = suggestionData;
            const chunk = paragraphChunkMap.get(chunkId);
            if (chunk) chunksDiffObjectsById.set(chunkId, (0, (0, parcelRequire("k93aA")).getDiffObjectsForParagraph)({
                originalParagraph: chunk,
                correctedParagraphText: suggestion || chunk.text,
                isDiffHiddenInIgnoredRanges: true,
                editorView: editorView
            }).filter((diff)=>diff.type === 'REPLACEMENT' && !diff.isWhiteSpace));
        });
        return chunksDiffObjectsById;
    };
    function $5d0561c2bcb1a2d6$export$9301b11c75053a3b(tr, pluginState, newEditorState) {
        const { proactiveAIBlocks: proactiveAIBlocks, isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        const shouldIgnoreChanges = !isSpellingAndGrammarEnabled || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('suggestionAccepted') || tr.getMeta('isAiContentTransformation');
        const needSGCheckForDocChecker = !isSpellingAndGrammarEnabled && !tr.getMeta('suggestionAccepted') && !tr.getMeta('isAiContentTransformation');
        const nodeTypes = $5d0561c2bcb1a2d6$export$2e312585e39e3b9f(newEditorState);
        const includedNodeTypes = $5d0561c2bcb1a2d6$export$e5022a60bacc9f19(newEditorState);
        const ignoredMarkRangesPredicate = $5d0561c2bcb1a2d6$var$getIgnoredMarkRangesPredicate(newEditorState);
        const trDocsWithFinalDoc = tr.docs.concat([
            tr.doc
        ]);
        const replaceStepsWithDocs = [];
        tr.steps.forEach((step, index)=>{
            const stepDoc = trDocsWithFinalDoc[index + 1];
            if (step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceStep) || step instanceof (0, (0, parcelRequire("eS2Dn")).ReplaceAroundStep)) replaceStepsWithDocs.push({
                step: step,
                doc: stepDoc
            });
        });
        if (proactiveAIBlocks && replaceStepsWithDocs.length > 0) {
            let updatedProactiveAIBlock = Array.from(proactiveAIBlocks);
            replaceStepsWithDocs.forEach(({ step: step, doc: doc })=>{
                const newProactiveAIBlocks = [];
                const nodeMap = new WeakMap();
                const mapping = new (0, (0, parcelRequire("eS2Dn")).Mapping)();
                const stepMap = step.getMap();
                mapping.appendMap(stepMap);
                stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
                    doc.nodesBetween(newStart, Math.min(newEnd, doc.content.size), (node, pos, parent)=>{
                        if (nodeTypes.has(node.type) && !(nodeMap.get(node)?.from === pos + 1)) {
                            const ignoredRanges = $5d0561c2bcb1a2d6$var$getIgnoredRanges({
                                node: node,
                                ignoredMarkRangesPredicate: ignoredMarkRangesPredicate
                            });
                            const from = pos + 1, to = pos + node.nodeSize - 1;
                            const containerType = $5d0561c2bcb1a2d6$export$acc6f3e19803b3dc(newEditorState.schema, node, parent);
                            const newBlock = {
                                id: (0, ($parcel$interopDefault($bXrHm)))(),
                                from: from,
                                to: to,
                                text: node.textContent,
                                nodeTypeName: node.type.name,
                                needSpellingAndGrammarCheck: !shouldIgnoreChanges,
                                needSGCheckForDocChecker: needSGCheckForDocChecker,
                                ignoredRanges: ignoredRanges,
                                sentences: splitParagraphIntoSentences ? $5d0561c2bcb1a2d6$export$18ed091a7710fd24({
                                    node: node,
                                    paragraphStartPos: from,
                                    needSpellingAndGrammarCheck: !shouldIgnoreChanges,
                                    needSGCheckForDocChecker: needSGCheckForDocChecker,
                                    paragraphIgnoredRanges: ignoredRanges,
                                    containerType: containerType
                                }) : undefined,
                                containerType: containerType
                            };
                            newProactiveAIBlocks.push(newBlock);
                            nodeMap.set(node, newBlock);
                            return false;
                        }
                        return includedNodeTypes.has(node.type);
                    });
                });
                let startIndex = -1, endIndex = -1;
                for(let index = 0; index < updatedProactiveAIBlock.length; index++){
                    const block = updatedProactiveAIBlock[index];
                    if (index === 0 && step.from < block.from && step.to < block.to) {
                        startIndex = 0;
                        endIndex = 0;
                        break;
                    }
                    if (block.from <= step.from && block.to >= step.from || block.from <= step.to && block.to >= step.to) {
                        if (startIndex === -1) {
                            startIndex = index;
                            endIndex = index + 1;
                        } else if (startIndex > -1) endIndex = index + 1;
                    }
                    if (block.from >= step.from && block.to <= step.to) {
                        if (startIndex === -1) {
                            startIndex = index;
                            endIndex = index + 1;
                        } else if (startIndex > -1) endIndex = index + 1;
                    }
                    if (index < updatedProactiveAIBlock.length - 1) {
                        const nextBlock = updatedProactiveAIBlock[index + 1];
                        if (step.from > block.to && step.to < nextBlock.from) {
                            startIndex = index + 1;
                            endIndex = index + 1;
                            break;
                        }
                    }
                    if (index === updatedProactiveAIBlock.length - 1 && step.from > block.to && step.to > block.to) {
                        startIndex = index + 1;
                        endIndex = index + 1;
                    }
                }
                if (startIndex > -1 && endIndex > -1) {
                    const deletedBlocks = updatedProactiveAIBlock.splice(startIndex, endIndex - startIndex, ...newProactiveAIBlocks);
                    if (deletedBlocks.length > 0 && newProactiveAIBlocks.length > 0) {
                        let deletedBlocksDiffObjects = $5d0561c2bcb1a2d6$export$572abd2f6fc3e29f(deletedBlocks, splitParagraphIntoSentences);
                        deletedBlocksDiffObjects = $5d0561c2bcb1a2d6$var$filterAndMapDiffObjectsByStep(deletedBlocksDiffObjects, step, mapping);
                        const blocksOrSentences = splitParagraphIntoSentences ? $5d0561c2bcb1a2d6$export$645ff1143283928c(newProactiveAIBlocks) : newProactiveAIBlocks;
                        $5d0561c2bcb1a2d6$var$setDiffObjectsInNewBlocksOrSentences(blocksOrSentences, deletedBlocksDiffObjects);
                    }
                }
                updatedProactiveAIBlock = updatedProactiveAIBlock.map((block, i)=>{
                    if (!!newProactiveAIBlocks.length && i >= startIndex && i < startIndex + newProactiveAIBlocks.length) return block;
                    return $5d0561c2bcb1a2d6$export$5f957af589bcb910(mapping, block);
                });
            });
            return {
                originProactiveAIBlock: proactiveAIBlocks,
                updatedProactiveAIBlock: updatedProactiveAIBlock
            };
        }
        return {
            originProactiveAIBlock: proactiveAIBlocks,
            updatedProactiveAIBlock: proactiveAIBlocks
        };
    }
    function $5d0561c2bcb1a2d6$var$setDiffObjectsInNewBlocksOrSentences(blockOrSentences, deletedBlocksDiffObjects) {
        blockOrSentences.map((blockOrSentence)=>{
            blockOrSentence.diffObjects = deletedBlocksDiffObjects.filter((diffObject)=>blockOrSentence.from <= diffObject.from && diffObject.to <= blockOrSentence.to);
        });
    }
    function $5d0561c2bcb1a2d6$var$filterAndMapDiffObjectsByStep(diffObjects, step, mapping) {
        return diffObjects?.filter((diffObject)=>{
            const { from: from, to: to } = diffObject;
            if (from >= step.from && from <= step.to || to >= step.from && to <= step.to) return false;
            return true;
        }).map((diffObject)=>{
            diffObject.from = mapping.map(diffObject.from);
            diffObject.to = mapping.map(diffObject.to);
            return diffObject;
        });
    }
    function $5d0561c2bcb1a2d6$export$5f957af589bcb910(mapping, block) {
        return {
            id: block.id,
            text: block.text,
            ignoredRanges: block.ignoredRanges,
            nodeTypeName: block.nodeTypeName,
            needSpellingAndGrammarCheck: block.needSpellingAndGrammarCheck,
            needSGCheckForDocChecker: block.needSGCheckForDocChecker,
            metadata: block.metadata,
            from: mapping.map(block.from),
            to: mapping.map(block.to),
            diffObjects: $5d0561c2bcb1a2d6$export$daf036de5d0fe400(mapping, block.diffObjects),
            containerType: block.containerType,
            sentences: block.sentences?.map((sentence)=>({
                    id: sentence.id,
                    text: sentence.text,
                    ignoredRanges: sentence.ignoredRanges,
                    size: sentence.size,
                    needSpellingAndGrammarCheck: sentence.needSpellingAndGrammarCheck,
                    needSGCheckForDocChecker: sentence.needSGCheckForDocChecker,
                    metadata: sentence.metadata,
                    from: mapping.map(sentence.from),
                    to: mapping.map(sentence.to),
                    diffObjects: $5d0561c2bcb1a2d6$export$daf036de5d0fe400(mapping, sentence.diffObjects),
                    containerType: sentence.containerType
                }))
        };
    }
    function $5d0561c2bcb1a2d6$export$daf036de5d0fe400(mapping, diffObjects) {
        return diffObjects?.map((diffObject)=>({
                id: diffObject.id,
                type: diffObject.type,
                text: diffObject.text,
                replacement: diffObject.replacement,
                originalText: diffObject.originalText,
                from: mapping.map(diffObject.from),
                to: mapping.map(diffObject.to)
            }));
    }
    const $5d0561c2bcb1a2d6$var$getIgnoredRanges = ({ node: node, ignoredMarkRangesPredicate: ignoredMarkRangesPredicate })=>{
        const ignoredRanges = [];
        node.descendants((node, pos)=>{
            if (!node.isText && node.isInline) ignoredRanges.push({
                pos: pos,
                size: node.nodeSize,
                type: 'inlineNode'
            });
            else if (ignoredMarkRangesPredicate && ignoredMarkRangesPredicate(node)) ignoredRanges.push({
                pos: pos,
                size: node.nodeSize,
                type: 'mark'
            });
            return false;
        });
        return ignoredRanges;
    };
    function $5d0561c2bcb1a2d6$export$18ed091a7710fd24({ node: node, paragraphStartPos: paragraphStartPos, needSpellingAndGrammarCheck: needSpellingAndGrammarCheck, needSGCheckForDocChecker: needSGCheckForDocChecker, paragraphIgnoredRanges: paragraphIgnoredRanges, locale: locale, containerType: containerType }) {
        const sentenceTexts = $5d0561c2bcb1a2d6$var$splitIntoSentencesBySegmenter(node.textContent, locale);
        let currentSentenceStartPos = 0;
        let sentences = sentenceTexts.map(({ text: sentenceText })=>{
            let currentSentenceSize = sentenceText.length;
            const ignoredRangesInSentences = [];
            paragraphIgnoredRanges.forEach(({ pos: pos, size: size, type: type })=>{
                if (pos >= currentSentenceStartPos && pos < currentSentenceStartPos + currentSentenceSize) {
                    ignoredRangesInSentences.push({
                        pos: pos - currentSentenceStartPos,
                        size: size,
                        type: type
                    });
                    if (type === 'inlineNode') currentSentenceSize += size;
                }
            });
            const sentence = {
                id: (0, ($parcel$interopDefault($bXrHm)))(),
                from: currentSentenceStartPos,
                to: currentSentenceStartPos + currentSentenceSize,
                size: currentSentenceSize,
                text: sentenceText,
                ignoredRanges: ignoredRangesInSentences,
                needSpellingAndGrammarCheck: needSpellingAndGrammarCheck,
                needSGCheckForDocChecker: needSGCheckForDocChecker,
                containerType: containerType
            };
            currentSentenceStartPos = currentSentenceStartPos + currentSentenceSize;
            return sentence;
        });
        sentences = sentences.map((sentence)=>({
                ...sentence,
                from: paragraphStartPos + sentence.from,
                to: paragraphStartPos + sentence.to
            }));
        return sentences;
    }
    function $5d0561c2bcb1a2d6$var$splitIntoSentencesBySegmenter(text, locale = 'en') {
        const segmenter = new Intl.Segmenter(locale, {
            granularity: 'sentence'
        });
        const sentences = segmenter.segment(text);
        return Array.from(sentences).map((segment)=>{
            return {
                text: segment.segment,
                index: segment.index
            };
        });
    }
    function $5d0561c2bcb1a2d6$export$84c79514d0cb7da7(state) {
        const nodeTypes = $5d0561c2bcb1a2d6$export$2e312585e39e3b9f(state);
        const includedNodeTypes = $5d0561c2bcb1a2d6$export$e5022a60bacc9f19(state);
        const proactiveAIBlocks = [];
        const ignoredMarkRangesPredicate = $5d0561c2bcb1a2d6$var$getIgnoredMarkRangesPredicate(state);
        state.doc.descendants((node, pos, parent)=>{
            if (nodeTypes.has(node.type)) {
                const ignoredRanges = $5d0561c2bcb1a2d6$var$getIgnoredRanges({
                    node: node,
                    ignoredMarkRangesPredicate: ignoredMarkRangesPredicate
                });
                const from = pos + 1, to = pos + node.nodeSize - 1;
                const containerType = $5d0561c2bcb1a2d6$export$acc6f3e19803b3dc(state.schema, node, parent);
                proactiveAIBlocks.push({
                    id: (0, ($parcel$interopDefault($bXrHm)))(),
                    text: node.textContent,
                    from: from,
                    to: to,
                    nodeTypeName: node.type.name,
                    ignoredRanges: ignoredRanges,
                    needSpellingAndGrammarCheck: false,
                    needSGCheckForDocChecker: true,
                    sentences: $5d0561c2bcb1a2d6$export$a711c9a3134fe8fe() ? $5d0561c2bcb1a2d6$export$18ed091a7710fd24({
                        node: node,
                        paragraphStartPos: from,
                        needSpellingAndGrammarCheck: false,
                        needSGCheckForDocChecker: true,
                        paragraphIgnoredRanges: ignoredRanges,
                        containerType: containerType
                    }) : undefined,
                    containerType: containerType
                });
                return false;
            }
            return includedNodeTypes.has(node.type);
        });
        return {
            proactiveAIBlocks: proactiveAIBlocks
        };
    }
    function $5d0561c2bcb1a2d6$export$a711c9a3134fe8fe() {
        return !!Intl.Segmenter;
    }
    function $5d0561c2bcb1a2d6$export$3536104194f7cad9(pluginState, pos) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        let selectedDiffObject;
        if (proactiveAIBlocks?.length) for(let i = 0; i < proactiveAIBlocks.length; i++){
            const block = proactiveAIBlocks[i];
            if (pos >= block.from && pos <= block.to) {
                if (splitParagraphIntoSentences) {
                    const blockSentences = block.sentences || [];
                    for(let j = 0; j < blockSentences.length; j++){
                        const sentence = blockSentences[j];
                        selectedDiffObject = sentence.diffObjects?.find((diffObject)=>pos >= diffObject.from && pos <= diffObject.to);
                        if (selectedDiffObject) break;
                    }
                } else selectedDiffObject = block.diffObjects?.find((diffObject)=>pos >= diffObject.from && pos <= diffObject.to);
                if (selectedDiffObject) break;
            }
        }
        return selectedDiffObject;
    }
    function $5d0561c2bcb1a2d6$export$fca0e09b162fa67a(pluginState, from, to) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        return proactiveAIBlocks?.map((block)=>{
            if (splitParagraphIntoSentences && block.sentences) return {
                ...block,
                sentences: block.sentences.map((sentence)=>{
                    return {
                        ...sentence,
                        diffObjects: sentence.diffObjects?.filter((diffObject)=>from !== diffObject.from && to !== diffObject.to)
                    };
                })
            };
            else return {
                ...block,
                diffObjects: block.diffObjects?.filter((diffObject)=>from !== diffObject.from && to !== diffObject.to)
            };
        });
    }
    function $5d0561c2bcb1a2d6$export$ed3ca0d35db42f45(pluginState, originalText) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        return proactiveAIBlocks?.map((block)=>{
            if (splitParagraphIntoSentences && block.sentences) return {
                ...block,
                sentences: block.sentences.map((sentence)=>{
                    return {
                        ...sentence,
                        diffObjects: sentence.diffObjects?.filter((diffObject)=>originalText !== diffObject.originalText)
                    };
                })
            };
            else return {
                ...block,
                diffObjects: block.diffObjects?.filter((diffObject)=>originalText !== diffObject.originalText)
            };
        });
    }
    function $5d0561c2bcb1a2d6$export$3aacaf06d69b33cc(blocks, splitParagraphIntoSentences) {
        const chunks = splitParagraphIntoSentences ? $5d0561c2bcb1a2d6$export$645ff1143283928c(blocks) : blocks;
        return chunks.reduce((accumulator, chunk)=>{
            accumulator.set(chunk.id, chunk);
            return accumulator;
        }, new Map());
    }
    function $5d0561c2bcb1a2d6$export$645ff1143283928c(blocks) {
        return blocks.reduce((accumulator, block)=>{
            if (block.sentences) accumulator = accumulator.concat(block.sentences);
            return accumulator;
        }, []);
    }
    function $5d0561c2bcb1a2d6$export$9fe1477d9038ebb9(blocks) {
        return $5d0561c2bcb1a2d6$export$645ff1143283928c(blocks).filter((sentence)=>sentence.needSpellingAndGrammarCheck);
    }
    function $5d0561c2bcb1a2d6$export$572abd2f6fc3e29f(blocks, splitParagraphIntoSentences) {
        if (splitParagraphIntoSentences) return blocks.reduce((allDiffObjects, block)=>{
            if (block.sentences) return block.sentences?.reduce((accumulator, sentence)=>{
                if (sentence.diffObjects) accumulator = accumulator.concat(sentence.diffObjects);
                return accumulator;
            }, allDiffObjects);
            return allDiffObjects;
        }, []) || [];
        else return blocks.reduce((accumulator, block)=>{
            if (block.diffObjects) accumulator = accumulator.concat(block.diffObjects);
            return accumulator;
        }, []) || [];
    }
    function $5d0561c2bcb1a2d6$export$da69170cd3d417b4(pluginState) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        return proactiveAIBlocks ? $5d0561c2bcb1a2d6$export$572abd2f6fc3e29f(proactiveAIBlocks, splitParagraphIntoSentences) : [];
    }
    function $5d0561c2bcb1a2d6$export$4851e3f4e562b23c(pluginState, chunksDiffObjectsById) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences, dismissedWords: dismissedWords } = pluginState;
        return proactiveAIBlocks?.map((block)=>{
            if (splitParagraphIntoSentences) return {
                ...block,
                sentences: block.sentences?.map((sentence)=>{
                    const newDiffObjects = chunksDiffObjectsById.get(sentence.id);
                    return {
                        ...sentence,
                        ...newDiffObjects && {
                            diffObjects: newDiffObjects.filter((diffObject)=>!dismissedWords.has(diffObject.originalText)),
                            needSpellingAndGrammarCheck: false,
                            needSGCheckForDocChecker: false
                        }
                    };
                })
            };
            else {
                const newDiffObjects = chunksDiffObjectsById.get(block.id);
                return {
                    ...block,
                    ...newDiffObjects && {
                        diffObjects: newDiffObjects.filter((diffObject)=>!dismissedWords.has(diffObject.originalText)),
                        needSpellingAndGrammarCheck: false,
                        needSGCheckForDocChecker: false
                    }
                };
            }
        });
    }
    function $5d0561c2bcb1a2d6$export$23f20dde4928da8b(pluginState, diffObject) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        if (splitParagraphIntoSentences) {
            if (proactiveAIBlocks?.length) for(let i = 0; i < proactiveAIBlocks.length; i++){
                const block = proactiveAIBlocks[i];
                const sentence = block.sentences?.find((sentence)=>sentence.diffObjects?.includes(diffObject));
                if (sentence) return sentence;
            }
        } else return proactiveAIBlocks?.find((block)=>block.diffObjects?.includes(diffObject));
    }
    function $5d0561c2bcb1a2d6$export$5a617a26a8fdefee(pluginState, diffObject) {
        const { proactiveAIBlocks: proactiveAIBlocks, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
        if (splitParagraphIntoSentences) return proactiveAIBlocks?.some((block)=>{
            return block.sentences?.some((sentence)=>{
                return sentence.diffObjects?.some(({ id: id })=>id === diffObject.id);
            });
        });
        else return proactiveAIBlocks?.some((block)=>{
            return block.diffObjects?.some(({ id: id })=>id === diffObject.id);
        });
    }
});
parcelRegister("3n50y", function(module, exports) {
    $parcel$export(module.exports, "convertMarkdownToProsemirror", ()=>$e7fec1189d08b4ed$export$b2bf04f78f72b123);
    var $ivSSX = parcelRequire("ivSSX");
    var $4iMad = parcelRequire("4iMad");
    var $6fRr3;
    var $kCV8T;
    var $8rSF4;
    var $bYxjx;
    var $bWdRt;
    var $faVfc;
    var $8zpd5;
    var $f1Iub;
    var $aITBL;
    var $7kd2u;
    var $4htgl;
    var $9uwo4;
    var $86KS4;
    function $e7fec1189d08b4ed$var$getFragmentBackingArray(fragment) {
        return fragment.content;
    }
    function $e7fec1189d08b4ed$var$mapFragment(content, callback, parent = null) {
        const children = [];
        for(let i = 0, size = content.childCount; i < size; i++){
            const node = content.child(i);
            const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($e7fec1189d08b4ed$var$mapFragment(node.content, callback, node)), parent, i);
            if (transformed) {
                if (transformed instanceof (0, (0, parcelRequire("kCV8T")).Fragment)) children.push(...$e7fec1189d08b4ed$var$getFragmentBackingArray(transformed));
                else if (Array.isArray(transformed)) children.push(...transformed);
                else children.push(transformed);
            }
        }
        return (0, (0, parcelRequire("kCV8T")).Fragment).fromArray(children);
    }
    function $e7fec1189d08b4ed$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
        const { markdownPlus: markdownPlus } = featureToggles;
        const tokenizer = new (0, ($parcel$interopDefault($ivSSX)))('zero', {
            html: false
        });
        tokenizer.enable([
            'entity',
            'escape',
            'newline'
        ]);
        [
            'nodes',
            'marks'
        ].forEach((key)=>{
            for(const idx in (0, (0, parcelRequire("8rSF4")).PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, (0, parcelRequire("8rSF4")).PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
        });
        const htmlConversionCounts = {
            htmlConvertedToNodes: 0,
            htmlConvertedToFallbackNodes: 0
        };
        if (markdownPlus) {
            tokenizer.use((0, (0, parcelRequire("bWdRt")).default), idMap, htmlConversionCounts);
            tokenizer.use((0, (0, parcelRequire("8zpd5")).default), idMap);
            tokenizer.use((0, (0, parcelRequire("faVfc")).default), idMap, featureToggles, htmlConversionCounts);
        }
        tokenizer.use((0, (0, parcelRequire("bYxjx")).default), idMap);
        tokenizer.use((0, (0, parcelRequire("4htgl")).default));
        tokenizer.use((0, (0, parcelRequire("f1Iub")).default));
        tokenizer.use((0, (0, parcelRequire("7kd2u")).default));
        if (schema.nodes.table) tokenizer.use((0, $4iMad.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, (0, parcelRequire("aITBL")).markdownItMedia));
        if (schema.nodes.taskList) tokenizer.use((0, (0, parcelRequire("9uwo4")).default));
        const markdownParser = new (0, (0, parcelRequire("6fRr3")).MarkdownParser)(schema, tokenizer, (0, (0, parcelRequire("8rSF4")).filterMdToPmSchemaMapping)(schema, (0, (0, parcelRequire("8rSF4")).getMdToPmMapping)(!!markdownPlus)));
        if (markdown === '') return {
            htmlConvertedToNodes: 0,
            htmlConvertedToFallbackNodes: 0,
            pmFragment: (0, (0, parcelRequire("kCV8T")).Fragment).empty
        };
        markdown = markdown.replace(/\\n/g, '\n');
        if (markdownPlus) markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
            return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
        });
        let prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, (0, parcelRequire("86KS4")).escapeLinks)(markdown));
        if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
        const mappedContent = $e7fec1189d08b4ed$var$mapFragment(prosemirrorNode.content, (node)=>{
            if (node.type.name === 'media') return schema.nodes.media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: null
            }, node.content, node.marks);
            return node;
        });
        return {
            ...htmlConversionCounts,
            pmFragment: mappedContent
        };
    }
    function $e7fec1189d08b4ed$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
        const fragment = $e7fec1189d08b4ed$export$b2bf04f78f72b123({
            markdown: markdown,
            schema: schema,
            idMap: idMap,
            featureToggles: {
                markdownPlus: true,
                ...featureToggles
            }
        });
        try {
            const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
            return node;
        } catch  {
            throw new Error('Markdown conversion did not result in a valid ProseMirror node');
        }
    }
});
parcelRegister("8rSF4", function(module, exports) {
    $parcel$export(module.exports, "filterMdToPmSchemaMapping", ()=>$47c1a32cc65dec4e$export$a9d25ff08f358d72);
    $parcel$export(module.exports, "PM_SCHEMA_TO_MD_MAPPING", ()=>$47c1a32cc65dec4e$export$b535e2638dcce02);
    $parcel$export(module.exports, "getMdToPmMapping", ()=>$47c1a32cc65dec4e$export$8f853a1c35ed8bbe);
    function $47c1a32cc65dec4e$export$a9d25ff08f358d72(schema, map) {
        return Object.keys(map).reduce((newMap, key)=>{
            const value = map[key];
            const block = value.block || value.node;
            const mark = value.mark;
            if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
            return newMap;
        }, {});
    }
    const $47c1a32cc65dec4e$export$b535e2638dcce02 = {
        nodes: {
            blockquote: 'blockquote',
            paragraph: 'paragraph',
            rule: 'hr',
            heading: [
                'heading',
                'lheading'
            ],
            codeBlock: [
                'code',
                'fence'
            ],
            listItem: 'list',
            image: 'image'
        },
        marks: {
            em: 'emphasis',
            strong: 'text',
            link: [
                'link',
                'autolink',
                'reference',
                'linkify'
            ],
            strike: 'strikethrough',
            code: 'backticks'
        }
    };
    const $47c1a32cc65dec4e$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
            blockquote: {
                block: 'blockquote'
            },
            paragraph: {
                block: 'paragraph'
            },
            em: {
                mark: 'em'
            },
            strong: {
                mark: 'strong'
            },
            link: {
                mark: 'link',
                attrs: (tok)=>{
                    if (tok.pmAttrs) return tok.pmAttrs;
                    else return {
                        href: tok.attrGet('href'),
                        title: tok.attrGet('title') || null
                    };
                }
            },
            hr: {
                node: 'rule'
            },
            heading: {
                block: 'heading',
                attrs: (tok)=>({
                        level: +tok.tag.slice(1)
                    })
            },
            softbreak: {
                node: 'hardBreak'
            },
            hardbreak: {
                node: 'hardBreak'
            },
            code_block: {
                block: 'codeBlock'
            },
            list_item: {
                block: 'listItem'
            },
            bullet_list: {
                block: 'bulletList'
            },
            ordered_list: {
                block: 'orderedList',
                attrs: (tok)=>({
                        order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                    })
            },
            code_inline: {
                mark: 'code'
            },
            code: {
                mark: 'code'
            },
            fence: {
                block: 'codeBlock',
                attrs: (tok)=>({
                        language: tok.info && tok.info.trim() || null
                    })
            },
            mediaInline: {
                node: 'mediaInline',
                attrs: (token)=>{
                    if (extendMarkdownSupport) return token.pmAttrs;
                    return {};
                }
            },
            media_single: {
                block: 'mediaSingle',
                attrs: (token)=>{
                    if (extendMarkdownSupport) return token.pmAttrs;
                    return {};
                }
            },
            media: {
                node: 'media',
                attrs: (token)=>{
                    if (token.pmAttrs) return token.pmAttrs;
                    return {
                        url: token.attrGet('url'),
                        type: 'external'
                    };
                }
            },
            caption: {
                block: 'caption',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            alignment: {
                mark: 'alignment',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            breakout: {
                mark: 'breakout',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            border: {
                mark: 'border',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            textColor: {
                mark: 'textColor',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            underline: {
                mark: 'underline',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            subsup: {
                mark: 'subsup',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            emoji: {
                node: 'emoji',
                attrs: (token)=>{
                    if (extendMarkdownSupport) return token.pmAttrs;
                    return {
                        shortName: `:${token.markup}:`,
                        text: token.content
                    };
                }
            },
            inlineCard: {
                node: 'inlineCard',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            date: {
                node: 'date',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            status: {
                node: 'status',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            mention: {
                node: 'mention',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            placeholder: {
                node: 'placeholder',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            table: {
                block: 'table',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            tr: {
                block: 'tableRow',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            th: {
                block: 'tableHeader',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            td: {
                block: 'tableCell',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            s: {
                mark: 'strike'
            },
            strike: {
                mark: 'strike'
            },
            task_list: {
                block: 'taskList'
            },
            task_item: {
                block: 'taskItem',
                attrs: (tok)=>({
                        state: tok.meta
                    })
            },
            layoutSection: {
                block: 'layoutSection',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            layoutColumn: {
                block: 'layoutColumn',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            panel: {
                block: 'panel',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            decisionList: {
                block: 'decisionList',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            decisionItem: {
                block: 'decisionItem',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            expand: {
                block: 'expand',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            extension: {
                node: 'extension',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            bodiedExtension: {
                block: 'bodiedExtension',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            nestedExpand: {
                block: 'nestedExpand',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            },
            inlineExtension: {
                node: 'inlineExtension',
                attrs: (token)=>{
                    return token.pmAttrs;
                }
            }
        });
});
parcelRegister("bYxjx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d87149ca9e4499d$export$2e2bcd8739ae039);
    function $5d87149ca9e4499d$export$2e2bcd8739ae039(md) {
        md.inline.ruler.before('text', 'citation', function(state, silent) {
            const str = state.src.slice(state.pos);
            const citationRegexp = /^\[\^[^\^]+\^]/;
            const match = citationRegexp.exec(str);
            if (!match) return false;
            if (silent) return true;
            state.pos += match[0].length;
            return true;
        });
    }
});
parcelRegister("bWdRt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d9251ecbb9b05ed$export$2e2bcd8739ae039);
    var $fNF7B;
    const $5d9251ecbb9b05ed$var$emptyInlineCustomNodes = [
        'inlineExtension'
    ];
    function $5d9251ecbb9b05ed$export$2e2bcd8739ae039(md, idMap, htmlConversionCounts) {
        md.core.ruler.after('inline', 'custom-block', function(state) {
            state.tokens = state.tokens.reduce((acc, token, index)=>{
                const match = token.content.match(/<custom\s+data-type="(?<dataType>.*?)"\s*(data-id="(?<dataId>.*?)"\s*)?\/>/);
                const dataType = match?.groups?.dataType;
                if (match && dataType && !$5d9251ecbb9b05ed$var$emptyInlineCustomNodes.includes(dataType)) {
                    const dataId = match.groups?.dataId;
                    if (dataType) {
                        htmlConversionCounts.htmlConvertedToNodes++;
                        const customElementToken = (0, (0, parcelRequire("fNF7B")).createToken)(state, dataType);
                        if (dataId && idMap[dataId]) customElementToken.pmAttrs = idMap[dataId].attributes;
                        acc.splice(acc.length - 1, 1);
                        state.tokens.splice(index + 1, 1);
                        acc.push(customElementToken);
                    } else {
                        htmlConversionCounts.htmlConvertedToFallbackNodes++;
                        acc.push(token);
                    }
                } else acc.push(token);
                return acc;
            }, []);
        });
    }
});
parcelRegister("fNF7B", function(module, exports) {
    $parcel$export(module.exports, "createToken", ()=>$01a9b8d498b698ac$export$c255480b061bd6aa);
    function $01a9b8d498b698ac$export$c255480b061bd6aa(state, type, level) {
        let nesting;
        if (type.includes('_open')) nesting = 1;
        else if (type.includes('_close')) nesting = -1;
        else nesting = 0;
        const token = new state.Token(type, '', nesting);
        if (level) token.level = level;
        return token;
    }
});
parcelRegister("faVfc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abb668b99cdab4a0$export$2e2bcd8739ae039);
    function $abb668b99cdab4a0$export$2e2bcd8739ae039(md, idMap, featureToggles, htmlConversionCounts) {
        const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
            const start = state.pos;
            const origSrc = state.src;
            const match = state.src.slice(start).match(/<custom(\sdata-(type|id)="(?<dataType>.*?)")?(\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\/custom>/);
            if (!match) return false;
            const tagLength = match[0].length;
            const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
            const dataType = match.groups?.dataType;
            const dataId = match.groups?.dataId;
            const dataContent = match.groups?.dataContent;
            const afterTag = state.src.slice(start + beforeTag.length + tagLength);
            function mapCustomDataTypeToNodeType(customDataType) {
                switch(customDataType){
                    case 'smartlink':
                        return 'inlineCard';
                    case 'date':
                    case 'emoji':
                    case 'status':
                    case 'mention':
                    case 'placeholder':
                        return customDataType;
                    case 'inlineExtension':
                        return featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                    default:
                        return false;
                }
            }
            const customDataType = mapCustomDataTypeToNodeType(dataType);
            if (!silent) {
                if (beforeTag) {
                    state.src = beforeTag;
                    state.md.inline.tokenize(state, beforeTag);
                }
                if (dataId && idMap?.[dataId]?.attributes && customDataType) {
                    htmlConversionCounts.htmlConvertedToNodes++;
                    const customDataToken = state.push(customDataType, '', 0);
                    customDataToken.pmAttrs = idMap[dataId].attributes;
                } else {
                    htmlConversionCounts.htmlConvertedToFallbackNodes++;
                    const textToken = state.push('text', '', 0);
                    if (!dataContent) textToken.content = '';
                    else textToken.content = dataContent || match[0];
                }
                if (afterTag) {
                    state.src = afterTag;
                    state.pos = 0;
                    state.md.inline.tokenize(state, afterTag);
                }
            }
            state.src = origSrc;
            state.pos = start + state.src.length;
            return true;
        });
        return rule;
    }
});
parcelRegister("8zpd5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f71fc1e3eee083c0$export$2e2bcd8739ae039);
    const $f71fc1e3eee083c0$var$decisionItemOpen = 'decisionItem_open';
    const $f71fc1e3eee083c0$var$paragraphOpen = 'paragraph_open';
    const $f71fc1e3eee083c0$var$paragraphClose = 'paragraph_close';
    const $f71fc1e3eee083c0$var$inline = 'inline';
    function $f71fc1e3eee083c0$var$handleParagraphs(acc, token) {
        let inlineCount = 0;
        let inlineChainEnded = false;
        for(let i = acc.length - 1; i >= 0; i--){
            const type = acc[i]?.type;
            if (!inlineChainEnded) {
                if (type === $f71fc1e3eee083c0$var$inline) inlineCount += 1;
                else inlineChainEnded = true;
            }
        }
        const isWithinDecisionItem = acc[acc.length - (inlineCount + 1)]?.type === $f71fc1e3eee083c0$var$decisionItemOpen;
        if (!isWithinDecisionItem) acc.push(token);
    }
    function $f71fc1e3eee083c0$export$2e2bcd8739ae039(md, idMap) {
        md.core.ruler.after('custom-block', 'decision-list', function(state) {
            state.tokens = state.tokens.reduce((acc, token, index)=>{
                const { type: type } = token;
                if (type === $f71fc1e3eee083c0$var$paragraphOpen || type === $f71fc1e3eee083c0$var$paragraphClose) $f71fc1e3eee083c0$var$handleParagraphs(acc, token);
                else acc.push(token);
                return acc;
            }, []);
        });
    }
});
parcelRegister("f1Iub", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7a221d482aa8cb16$export$2e2bcd8739ae039);
    var $e2gHg = parcelRequire("e2gHg");
    var $iZOJ9;
    var $86KS4;
    const $7a221d482aa8cb16$var$arrayReplaceAt = (src, pos, newElements)=>{
        return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
    };
    const $7a221d482aa8cb16$var$isLinkOpen = (str)=>{
        return /^<a[>\s]/i.test(str);
    };
    const $7a221d482aa8cb16$var$isLinkClose = (str)=>{
        return /^<\/a\s*>/i.test(str);
    };
    const $7a221d482aa8cb16$var$linkify = (state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, ($parcel$interopDefault($e2gHg)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children;
            let htmlLinkLevel = 0;
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                if (currentToken.type === 'html_inline') {
                    if ($7a221d482aa8cb16$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($7a221d482aa8cb16$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, (0, parcelRequire("iZOJ9")).linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = (0, (0, parcelRequire("86KS4")).findFilepaths)(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if ((0, (0, parcelRequire("86KS4")).isLinkInMatches)(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    blockTokens[j].children = tokens = $7a221d482aa8cb16$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
    var $7a221d482aa8cb16$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $7a221d482aa8cb16$var$linkify);
});
parcelRegister("86KS4", function(module, exports) {
    $parcel$export(module.exports, "findFilepaths", ()=>$987386db29cd4945$export$d37783fe63e2f0fe);
    $parcel$export(module.exports, "isLinkInMatches", ()=>$987386db29cd4945$export$5e652e74655163e5);
    $parcel$export(module.exports, "escapeLinks", ()=>$987386db29cd4945$export$8acd10161c5f8b07);
    const $987386db29cd4945$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
    const $987386db29cd4945$export$d37783fe63e2f0fe = (text, offset = 0)=>{
        const localRegExp = new RegExp($987386db29cd4945$export$893fccbed37586dd);
        let match;
        const matchesList = [];
        const maxFilepathSize = 260;
        while((match = localRegExp.exec(text)) !== null){
            const start = match.index + offset;
            let end = localRegExp.lastIndex + offset;
            if (end - start > maxFilepathSize) end = start + maxFilepathSize;
            matchesList.push({
                startIndex: start,
                endIndex: end
            });
        }
        return matchesList;
    };
    const $987386db29cd4945$export$5e652e74655163e5 = (linkStart, matchesList)=>{
        for(let i = 0; i < matchesList.length; i++){
            if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
        }
        return false;
    };
    function $987386db29cd4945$export$8acd10161c5f8b07(text) {
        return text.replace(/(\[([^\]]+)\]\(|\!\[([^\]]*)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
            return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
        });
    }
});
parcelRegister("aITBL", function(module, exports) {
    $parcel$export(module.exports, "markdownItMedia", ()=>$fbb7360d8f6496f2$export$c8dcbd316b71f8cf);
    function $fbb7360d8f6496f2$var$createRule() {
        const regx = /!\[[^\]]*\]\([^)]+\)/g;
        const validParentTokens = [
            'th_open',
            'td_open',
            'list_item_open'
        ];
        return function media(State) {
            const getUrl = (str)=>{
                const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
                if (res.ok) {
                    const href = State.md.normalizeLink(res.str);
                    if (State.md.validateLink(href)) return href;
                }
                return '';
            };
            const createMediaTokens = (url)=>{
                const mediaSingleOpen = new State.Token('media_single_open', '', 1);
                const media = new State.Token('media', '', 0);
                media.attrs = [
                    [
                        'url',
                        getUrl(url)
                    ],
                    [
                        'type',
                        'external'
                    ]
                ];
                if (url.includes('atlassianinternalmedia')) try {
                    const urlObject = new URL(getUrl(url));
                    const params = urlObject.searchParams;
                    if (params.toString()) {
                        const pmAttrs = {};
                        for (const [key, value] of params)pmAttrs[key] = value;
                        media.pmAttrs = pmAttrs;
                    }
                } catch  {}
                const mediaSingleClose = new State.Token('media_single_close', '', -1);
                return [
                    mediaSingleOpen,
                    media,
                    mediaSingleClose
                ];
            };
            const createInlineTokens = (str, openingTokens, closingTokens)=>{
                if (!str || str.length === 0) return [];
                const inlineBefore = new State.Token('inline', '', 1);
                inlineBefore.content = str;
                inlineBefore.children = [];
                return [
                    ...openingTokens,
                    inlineBefore,
                    ...closingTokens
                ];
            };
            let processedTokens = [];
            const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
                if (token.type === 'inline' && regx.test(token.content)) {
                    const openingTokens = [];
                    let cursor = i - 1;
                    let previousToken = arr[cursor];
                    let subTree = [];
                    while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                        openingTokens.unshift(previousToken);
                        cursor--;
                        previousToken = arr[cursor];
                    }
                    if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                    else cursor++;
                    const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                    const matches = token.content.match(regx);
                    let inlineContentStack = token.content;
                    matches.forEach((match)=>{
                        const start = inlineContentStack.indexOf(match);
                        const contentBefore = inlineContentStack.substr(0, start);
                        inlineContentStack = inlineContentStack.substr(start + match.length);
                        subTree = [
                            ...subTree,
                            ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                            ...createMediaTokens(match)
                        ];
                    });
                    if (inlineContentStack.length) subTree = [
                        ...subTree,
                        ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                    ];
                    processedTokens = [
                        ...processedTokens,
                        ...closingTokens.map((c)=>c.type)
                    ];
                    tokens = [
                        ...tokens.slice(0, cursor),
                        ...subTree
                    ];
                } else if (processedTokens.indexOf(token.type) !== -1) processedTokens.splice(processedTokens.indexOf(token.type), 1);
                else tokens.push(token);
                return tokens;
            }, []);
            State.tokens = newTokens;
            return true;
        };
    }
    const $fbb7360d8f6496f2$export$c8dcbd316b71f8cf = (md)=>{
        md.core.ruler.before('inline', 'media', $fbb7360d8f6496f2$var$createRule());
    };
});
parcelRegister("7kd2u", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$54116e9a623713ea$export$2e2bcd8739ae039);
    const $54116e9a623713ea$var$newline = (state, silent)=>{
        let pmax, pos = state.pos;
        if (state.src.charCodeAt(pos) !== 0x0a) return false;
        pmax = state.pending.length - 1;
        if (!silent) {
            if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
                if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) state.push('hardbreak', 'br', 0);
                else {
                    state.pending = state.pending.slice(0, -1);
                    state.push('softbreak', 'br', 0);
                }
            } else state.push('softbreak', 'br', 0);
        }
        pos++;
        state.pos = pos;
        return true;
    };
    var $54116e9a623713ea$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $54116e9a623713ea$var$newline);
});
parcelRegister("4htgl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d60fd2b2c7099802$export$2e2bcd8739ae039);
    const $d60fd2b2c7099802$var$paragraph = (state, startLine)=>{
        let content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph'), endLine = state.lineMax;
        oldParentType = state.parentType;
        state.parentType = 'paragraph';
        for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
            if (state.sCount[nextLine] - state.blkIndent > 3) continue;
            if (state.sCount[nextLine] < 0) continue;
            terminate = false;
            for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            if (terminate) break;
        }
        content = state.getLines(startLine, nextLine, state.blkIndent, false);
        state.line = nextLine;
        token = state.push('paragraph_open', 'p', 1);
        token.map = [
            startLine,
            state.line
        ];
        token = state.push('inline', '', 0);
        token.content = content;
        token.map = [
            startLine,
            state.line
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        state.parentType = oldParentType;
        return true;
    };
    var $d60fd2b2c7099802$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $d60fd2b2c7099802$var$paragraph);
});
parcelRegister("9uwo4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d3c2108311eb389$export$2e2bcd8739ae039);
    var $fNF7B;
    const $7d3c2108311eb389$var$bulletListOpen = 'bullet_list_open';
    const $7d3c2108311eb389$var$bulletListClose = 'bullet_list_close';
    const $7d3c2108311eb389$var$listItemOpen = 'list_item_open';
    const $7d3c2108311eb389$var$listItemClose = 'list_item_close';
    const $7d3c2108311eb389$var$taskListOpen = 'task_list_open';
    const $7d3c2108311eb389$var$taskListClose = 'task_list_close';
    const $7d3c2108311eb389$var$taskItemOpen = 'task_item_open';
    const $7d3c2108311eb389$var$taskItemClose = 'task_item_close';
    const $7d3c2108311eb389$var$paragraphOpen = 'paragraph_open';
    const $7d3c2108311eb389$var$paragraphClose = 'paragraph_close';
    function $7d3c2108311eb389$var$checkTypeByIndex(acc, type, indexOffset = -1) {
        return acc[acc.length + indexOffset]?.type === type;
    }
    function $7d3c2108311eb389$var$getTokenByIndex(acc, indexOffset = -1) {
        return acc[acc.length + indexOffset];
    }
    function $7d3c2108311eb389$var$handleBulletListOpen(state, token, acc, index) {
        const isPreviousTokenInline = $7d3c2108311eb389$var$checkTypeByIndex(acc, 'inline');
        const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $7d3c2108311eb389$var$startsWithTodoMarkdown(state.tokens[index + 3]);
        if (isPreviousTokenInline) {
            acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskItemClose, $7d3c2108311eb389$var$getTokenByIndex(acc).level - 1));
            acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskListOpen, $7d3c2108311eb389$var$getTokenByIndex(acc).level));
        } else if (isStartOfTaskList) acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskListOpen));
        else acc.push(token);
    }
    function $7d3c2108311eb389$var$handleBulletListClose(state, token, acc) {
        const isPreviousTokenTaskItemClose = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskItemClose);
        const isPreviousTokenTaskListClose = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskListClose);
        if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskListClose, $7d3c2108311eb389$var$getTokenByIndex(acc).level - 1));
        else acc.push(token);
    }
    function $7d3c2108311eb389$var$handleListItemOpen(state, token, acc, index) {
        const newTaskItemOpen = (0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskItemOpen);
        const isTaskItem = state.tokens[index + 2].type === 'inline' && $7d3c2108311eb389$var$startsWithTodoMarkdown(state.tokens[index + 2]);
        const isPreviousTokenTaskItemClose = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskItemClose);
        const isPreviousTokenListItemClose = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$listItemClose);
        const isPreviousTokenTaskListClose = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskListClose);
        if (isTaskItem) {
            if (isPreviousTokenListItemClose) {
                acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$bulletListClose));
                acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskListOpen));
            }
            newTaskItemOpen.meta = $7d3c2108311eb389$var$isDone(state.tokens[index + 2]);
            newTaskItemOpen.level = $7d3c2108311eb389$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
            acc.push(newTaskItemOpen);
        } else {
            if (isPreviousTokenTaskItemClose) {
                acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskListClose));
                acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$bulletListOpen));
            }
            acc.push(token);
        }
    }
    function $7d3c2108311eb389$var$handleListItemClose(state, token, acc) {
        const isWithinTaskList = $7d3c2108311eb389$var$checkTypeByIndex(acc, 'inline') && $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskItemOpen, -2);
        if (isWithinTaskList) acc.push((0, (0, parcelRequire("fNF7B")).createToken)(state, $7d3c2108311eb389$var$taskItemClose, $7d3c2108311eb389$var$getTokenByIndex(acc, -2).level));
        else if (!$7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskListClose)) acc.push(token);
    }
    function $7d3c2108311eb389$var$handleInline(token, acc) {
        if (token.children?.[0]) token.children[0].content = $7d3c2108311eb389$var$removeTodoMarkdown(token.children[0].content);
        token.content = $7d3c2108311eb389$var$removeTodoMarkdown(token.content);
        token.level = $7d3c2108311eb389$var$getTokenByIndex(acc).level + 1;
        acc.push(token);
    }
    function $7d3c2108311eb389$var$handleParagraphs(token, acc) {
        const isWithinTaskItem = $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskItemOpen) || $7d3c2108311eb389$var$checkTypeByIndex(acc, $7d3c2108311eb389$var$taskItemOpen, -2);
        if (!isWithinTaskItem) acc.push(token);
    }
    function $7d3c2108311eb389$var$isInlineAfterTaskItemOpen(token, acc) {
        return token.type === 'inline' && acc[acc.length - 1].type === $7d3c2108311eb389$var$taskItemOpen;
    }
    function $7d3c2108311eb389$var$startsWithTodoMarkdown(token) {
        return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
    }
    function $7d3c2108311eb389$var$removeTodoMarkdown(content) {
        const regex = /(\[x\]\s)|(\[\s\]\s)/;
        return content.replace(regex, '');
    }
    function $7d3c2108311eb389$var$isDone(token) {
        if (token.content.indexOf('[ ] ') === 0) return 'TODO';
        else return 'DONE';
    }
    function $7d3c2108311eb389$export$2e2bcd8739ae039(md) {
        md.core.ruler.after('inline', 'github-task-lists', function(state) {
            state.tokens = state.tokens.reduce((acc, token, index)=>{
                const { type: type } = token;
                if (type === $7d3c2108311eb389$var$bulletListOpen) $7d3c2108311eb389$var$handleBulletListOpen(state, token, acc, index);
                else if (type === $7d3c2108311eb389$var$bulletListClose) $7d3c2108311eb389$var$handleBulletListClose(state, token, acc);
                else if (type === $7d3c2108311eb389$var$listItemOpen) $7d3c2108311eb389$var$handleListItemOpen(state, token, acc, index);
                else if ($7d3c2108311eb389$var$isInlineAfterTaskItemOpen(token, acc)) $7d3c2108311eb389$var$handleInline(token, acc);
                else if (type === $7d3c2108311eb389$var$listItemClose) $7d3c2108311eb389$var$handleListItemClose(state, token, acc);
                else if (type === $7d3c2108311eb389$var$paragraphOpen || type === $7d3c2108311eb389$var$paragraphClose) $7d3c2108311eb389$var$handleParagraphs(token, acc);
                else acc.push(token);
                return acc;
            }, []);
        });
    }
});
parcelRegister("k93aA", function(module, exports) {
    $parcel$export(module.exports, "getDiffObjectsForParagraph", ()=>$1522b2f43bc0cf80$export$f4a6062f6829e3a5);
    $parcel$export(module.exports, "createDiffObjectsFromFragments", ()=>$1522b2f43bc0cf80$export$24f176f2668e3c38);
    var $kCV8T;
    var $VSDnB;
    var $5ilgR;
    var $kOl5n;
    var $1J8OH;
    const $1522b2f43bc0cf80$export$e4dfc69b82492f0e = (a, b, shouldIgnoreTrailingFullStops, isMarkdown)=>{
        const diff = (0, (0, parcelRequire("kOl5n")).DiffMatchPatch).diff_linesToWords_(a, b);
        const diffs = (0, (0, parcelRequire("kOl5n")).DiffMatchPatch).diff_main(diff.chars1, diff.chars2, false);
        (0, (0, parcelRequire("kOl5n")).DiffMatchPatch).diff_charsToLines_(diffs, diff.lineArray);
        const normalized = diffs.map((diff)=>({
                type: diff[0],
                text: diff[1],
                length: diff[1].length
            }));
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_sg_quality_filters')) return [
            (0, (0, parcelRequire("1J8OH")).concatConsecutiveReplacements),
            ...shouldIgnoreTrailingFullStops ? [
                (0, (0, parcelRequire("1J8OH")).ignoreTrailingFullStops)
            ] : [],
            (0, (0, parcelRequire("1J8OH")).ignoreDirectReplacements),
            (0, (0, parcelRequire("1J8OH")).convertJoinedDeletesIntoReplacement),
            (0, (0, parcelRequire("1J8OH")).ignoreTrailingSpaces),
            ...isMarkdown ? [
                (0, (0, parcelRequire("1J8OH")).removeMarkdownCustomTagReplacements)
            ] : []
        ].reduce((diffs, proc)=>proc(diffs), normalized);
        else return normalized;
    };
    const $1522b2f43bc0cf80$var$normaliseType = (diff, nextDiff)=>{
        if (diff.type === -1 && nextDiff?.type === 1) return 'REPLACEMENT';
        else if (diff.type === -1) return 'DELETION';
        else if (diff.type === 1 && (!nextDiff || nextDiff && nextDiff.type !== -1)) return 'ADDITION';
    };
    function $1522b2f43bc0cf80$var$isIntersectingWithIgnoredRanges(diffObject, ignoredRanges, originalFrom) {
        return ignoredRanges.some(({ pos: pos, size: size })=>{
            if (diffObject.to < originalFrom + pos || diffObject.from > originalFrom + pos + size) return false;
            return true;
        });
    }
    const $1522b2f43bc0cf80$export$f4a6062f6829e3a5 = ({ originalParagraph: originalParagraph, correctedParagraphText: correctedParagraphText, isDiffHiddenInIgnoredRanges: isDiffHiddenInIgnoredRanges, editorView: editorView })=>{
        const diffObjects = [];
        const originalText = originalParagraph.text;
        const diffs = $1522b2f43bc0cf80$export$e4dfc69b82492f0e(originalText.trim(), correctedParagraphText.trim(), editorView ? (0, (0, parcelRequire("5ilgR")).isFullStopOmittedInContainerType)(editorView.state.schema, originalParagraph.containerType) : false);
        const trimmingStartOffset = originalText.length - originalText.trimStart().length;
        let offset = originalParagraph.from + trimmingStartOffset;
        const n = diffs.length;
        for(let i = 0; i < n; i++){
            const { type: type, text: text, length: length } = diffs[i];
            const finalType = $1522b2f43bc0cf80$var$normaliseType(diffs[i], diffs?.[i + 1]);
            if (finalType === 'DELETION') diffObjects.push({
                id: `${originalParagraph.id}_${i}`,
                from: offset,
                to: offset,
                type: finalType,
                text: '',
                originalText: text
            });
            else if (finalType === 'REPLACEMENT' || finalType === 'ADDITION') {
                let inlineNodeOffsetSize = 0, inlineNodeOverlapSize = 0;
                originalParagraph.ignoredRanges.forEach(({ pos: pos, size: size, type: type })=>{
                    if (type === 'inlineNode') {
                        if (originalParagraph.from + pos < offset) inlineNodeOffsetSize += size;
                        if (originalParagraph.from + pos < offset + length && originalParagraph.from + pos > offset) inlineNodeOverlapSize += size;
                    }
                });
                const from = offset + inlineNodeOffsetSize;
                const obj = {
                    id: `${originalParagraph.id}_${i}`,
                    from: from,
                    to: offset + length + inlineNodeOffsetSize + inlineNodeOverlapSize,
                    type: finalType,
                    text: text,
                    originalText: text
                };
                if (finalType === 'REPLACEMENT') {
                    const nextText = diffs?.[i + 1]?.text ?? text;
                    const shouldTrimEndingSpace = text.endsWith(' ') && nextText.endsWith(' ');
                    obj.to += shouldTrimEndingSpace ? -1 : 0;
                    obj.text = shouldTrimEndingSpace ? nextText.slice(0, -1) : nextText;
                    obj.originalText = shouldTrimEndingSpace ? text.slice(0, -1) : text;
                    i++;
                }
                if (isDiffHiddenInIgnoredRanges) {
                    if (!$1522b2f43bc0cf80$var$isIntersectingWithIgnoredRanges(obj, originalParagraph.ignoredRanges, originalParagraph.from)) diffObjects.push(obj);
                } else diffObjects.push(obj);
            }
            if (type === 0 || type === -1) offset += length;
        }
        return diffObjects;
    };
    const $1522b2f43bc0cf80$export$24f176f2668e3c38 = ({ id: id, original: original, corrected: corrected, schema: schema, offset: offset = 0, containerType: containerType, ignoredRanges: ignoredRanges })=>{
        const diffObjects = [];
        const leafNodes = [];
        const { mention: mention } = schema.nodes;
        const leafNodeComparator = (leafNode)=>{
            let i = leafNodes.findIndex((node)=>node.type === mention ? node.attrs.id === leafNode.attrs.id : node.eq(leafNode));
            if (i < 0) {
                leafNodes.push(leafNode);
                i = leafNodes.length - 1;
            }
            return `\uFFF9${i}\uFFFB`;
        };
        const orgText = original.textBetween(0, original.size, '', leafNodeComparator);
        const correctedText = corrected.textBetween(0, corrected.size, '', leafNodeComparator);
        const diffs = $1522b2f43bc0cf80$export$e4dfc69b82492f0e(orgText, correctedText, (0, (0, parcelRequire("5ilgR")).isFullStopOmittedInContainerType)(schema, containerType), true).map((diff)=>{
            let hasInlineNodes = false;
            const fragment = diff.text.split('\uFFF9').reduce((frag, item)=>{
                const parts = item.split('\uFFFB');
                if (parts.length > 1) {
                    hasInlineNodes = true;
                    const nodeIndex = parts.shift();
                    frag = frag.addToEnd(leafNodes[parseInt(nodeIndex)]);
                }
                const remainingText = parts.join('');
                if (remainingText.length > 0) return frag.addToEnd(schema.text(remainingText));
                return frag;
            }, (0, (0, parcelRequire("kCV8T")).Fragment).empty);
            return {
                type: diff.type,
                text: diff.text,
                length: diff.length,
                fragment: fragment,
                hasInlineNodes: hasInlineNodes
            };
        });
        const start = offset;
        const n = diffs.length;
        for(let i = 0; i < n; i++){
            const currentDiff = diffs[i];
            const { type: type, text: text, fragment: fragment, hasInlineNodes: hasInlineNodes } = currentDiff;
            const finalType = $1522b2f43bc0cf80$var$normaliseType(diffs[i], diffs?.[i + 1]);
            const isWhiteSpace = text.trim().length === 0;
            if (finalType === 'DELETION') diffObjects.push({
                id: `${id}_${i}`,
                from: offset,
                to: offset + fragment.size,
                type: finalType,
                originalText: text,
                text: '',
                replacement: (0, (0, parcelRequire("kCV8T")).Fragment).empty,
                isWhiteSpace: isWhiteSpace
            });
            else if (finalType === 'REPLACEMENT' || finalType === 'ADDITION') {
                const obj = {
                    id: `${id}_${i}`,
                    from: offset,
                    to: offset,
                    type: finalType,
                    text: '',
                    originalText: text,
                    replacement: fragment,
                    hasInlineNodes: hasInlineNodes,
                    isWhiteSpace: isWhiteSpace
                };
                if (finalType === 'REPLACEMENT') {
                    const nextDiff = diffs?.[i + 1] ?? currentDiff;
                    const shouldTrimEndingSpace = text.endsWith(' ') && nextDiff.text.endsWith(' ');
                    obj.to += fragment.size + (shouldTrimEndingSpace ? -1 : 0);
                    obj.replacement = shouldTrimEndingSpace ? nextDiff.fragment.cut(0, nextDiff.fragment.size - 1) : nextDiff.fragment;
                    obj.text = nextDiff.text;
                    obj.isWhiteSpace = obj.isWhiteSpace || obj.replacement.size === 0;
                    i++;
                }
                if (ignoredRanges) {
                    if (!$1522b2f43bc0cf80$var$isIntersectingWithIgnoredRanges(obj, ignoredRanges, start)) diffObjects.push(obj);
                } else diffObjects.push(obj);
            }
            if (type === 0 || type === -1) offset += fragment.size;
        }
        return diffObjects;
    };
});
parcelRegister("1J8OH", function(module, exports) {
    $parcel$export(module.exports, "concatConsecutiveReplacements", ()=>$11ff87b7f9de9379$export$e835bf09d412bc11);
    $parcel$export(module.exports, "ignoreTrailingFullStops", ()=>$11ff87b7f9de9379$export$6a7126983e115b96);
    $parcel$export(module.exports, "ignoreTrailingSpaces", ()=>$11ff87b7f9de9379$export$9f1c1349daf41f36);
    $parcel$export(module.exports, "ignoreDirectReplacements", ()=>$11ff87b7f9de9379$export$9e47b788c8763c45);
    $parcel$export(module.exports, "convertJoinedDeletesIntoReplacement", ()=>$11ff87b7f9de9379$export$9dde7dcae217215);
    $parcel$export(module.exports, "removeMarkdownCustomTagReplacements", ()=>$11ff87b7f9de9379$export$b958fbe593a4b29c);
    const $11ff87b7f9de9379$export$e835bf09d412bc11 = (diffs)=>{
        const result = [];
        for(let i = 0; i < diffs.length; i++)if (diffs[i].type === -1 && diffs?.[i + 1]?.type === 1 && !diffs[i + 1].text.includes('\uFFF9') && !diffs[i + 1].text.includes('\uFFFB')) {
            const grouped = [];
            for(let j = i + 2; j < diffs.length; j++){
                if (diffs?.[j]?.type === 0 && diffs?.[j]?.text.trim().length === 0 && diffs?.[j + 1]?.type === -1 && diffs?.[j + 2]?.type === 1 && !diffs[j + 1].text.includes('\uFFF9') && !diffs[j + 1].text.includes('\uFFFB')) {
                    grouped.push(diffs?.[j], diffs?.[j + 1], diffs?.[j + 2]);
                    j += 3;
                } else break;
            }
            if (grouped.length) {
                const ot = grouped.reduce((acc, d)=>acc + (d.type <= 0 ? d.text : ''), diffs[i].text);
                result.push({
                    type: -1,
                    text: ot,
                    length: ot.length
                });
                const nt = grouped.reduce((acc, d)=>acc + (d.type >= 0 ? d.text : ''), diffs[i + 1].text);
                result.push({
                    type: 1,
                    text: nt,
                    length: nt.length
                });
                i += grouped.length + 1;
            } else result.push(diffs[i]);
        } else result.push(diffs[i]);
        return result;
    };
    const $11ff87b7f9de9379$export$6a7126983e115b96 = (diffs)=>{
        const result = diffs.concat();
        if (result.length > 1) {
            if (result[result.length - 2].type === -1 && result?.[result.length - 1]?.type === 1) {
                const removed = result[result.length - 2].text.trimEnd();
                const added = result[result.length - 1].text.trimEnd();
                const r1 = removed.charAt(removed.length - 1) === '.';
                const a1 = added.charAt(added.length - 1) === '.';
                const r2 = removed.substring(0, removed.length - 1);
                const a2 = added.substring(0, added.length - 1);
                if (removed !== added && (r1 || a1) && (r1 && r2 === added || a1 && a2 === removed)) result.splice(-2, 2, {
                    type: 0,
                    text: diffs[diffs.length - 2].text,
                    length: diffs[diffs.length - 2].length
                });
            }
        }
        return result;
    };
    const $11ff87b7f9de9379$export$9f1c1349daf41f36 = (diffs)=>{
        const result = diffs.concat();
        if (result.length > 1) {
            if (result[result.length - 2].type === -1 && result?.[result.length - 1]?.type === 1) {
                const removed = result[result.length - 2].text.trimEnd();
                const added = result[result.length - 1].text.trimEnd();
                if (removed === added) result.splice(-2, 2, {
                    type: 0,
                    text: diffs[diffs.length - 2].text,
                    length: diffs[diffs.length - 2].length
                });
            }
        }
        return result;
    };
    const $11ff87b7f9de9379$export$f53368fa396399c1 = new Map([
        [
            '&',
            'and'
        ],
        [
            'and',
            '&'
        ]
    ]);
    const $11ff87b7f9de9379$export$9e47b788c8763c45 = (diffs)=>{
        const result = [];
        for(let i = 0; i < diffs.length; i++)if (diffs[i].type === -1 && diffs?.[i + 1]?.type === 1) {
            if ($11ff87b7f9de9379$export$f53368fa396399c1.get(diffs[i].text.trim().toLowerCase()) === diffs[i + 1].text.trim().toLowerCase()) {
                result.push({
                    type: 0,
                    text: diffs[i].text,
                    length: diffs[i].length
                });
                i += 1;
            } else result.push(diffs[i]);
        } else result.push(diffs[i]);
        return result;
    };
    const $11ff87b7f9de9379$export$9dde7dcae217215 = (diffs)=>{
        const result = [];
        for(let i = 0; i < diffs.length; i++)if (diffs[i].type === 0 && diffs?.[i + 1]?.type === -1 && diffs?.[i + 2]?.type !== 1 && diffs?.[i]?.text.trim().length !== 0) {
            const rightIndex = [
                ' ',
                '\uFFFB',
                '\uFFF9'
            ].reduce((v, c)=>{
                const diffText = diffs[i].text;
                let x = diffText.lastIndexOf(c);
                if (x === diffText.trimEnd().length) x = diffText.trimEnd().lastIndexOf(c);
                return x !== -1 && x > v ? x : v;
            }, 0);
            const a = diffs[i].text.substring(0, rightIndex + 1);
            result.push({
                type: 0,
                text: a,
                length: a.length
            });
            const b = diffs[i].text.substring(rightIndex + 1) + diffs[i + 1].text;
            result.push({
                type: -1,
                text: b,
                length: b.length
            });
            const c = diffs[i].text.substring(rightIndex + 1);
            result.push({
                type: 1,
                text: c,
                length: c.length
            });
            i += 1;
        } else result.push(diffs[i]);
        return result;
    };
    const $11ff87b7f9de9379$export$b958fbe593a4b29c = (diffs)=>{
        const result = [];
        for(let i = 0; i < diffs.length; i++)if (diffs[i].type === -1 && diffs?.[i + 1]?.type === 1) {
            const o = diffs[i].text;
            const r = diffs[i + 1].text;
            const j = r.indexOf('</custom>');
            const k = o.indexOf('</custom>');
            if (j !== -1 && k === -1) {
                const v = r.substring(0, j) + r.substring(j + 9);
                if (v.trim().length !== 0) {
                    if (v === o) {
                        result.push({
                            type: 0,
                            text: diffs[i].text,
                            length: diffs[i].length
                        });
                        i += 1;
                    } else {
                        result.push({
                            type: -1,
                            text: diffs[i].text,
                            length: diffs[i].length
                        });
                        result.push({
                            type: 1,
                            text: v,
                            length: v.length
                        });
                        i += 1;
                    }
                } else result.push(diffs[i]);
            } else result.push(diffs[i]);
        } else result.push(diffs[i]);
        return result;
    };
});
parcelRegister("k5t6k", function(module, exports) {
    $parcel$export(module.exports, "SpellingAndGrammarDecorations", ()=>$030113c8028a5fde$export$b8f003972dc1d0f5);
    $parcel$export(module.exports, "filterDecorationByKey", ()=>$030113c8028a5fde$export$ad950d3225a13eae);
    $parcel$export(module.exports, "regenerateSelectedSpellingDecorations", ()=>$030113c8028a5fde$export$869ca1e6f091229e);
    $parcel$export(module.exports, "regenerateAllDecorations", ()=>$030113c8028a5fde$export$ccdc7e88bd8862ee);
    var $8kYLI;
    var $aXVZ4;
    const $030113c8028a5fde$export$b8f003972dc1d0f5 = {
        SPELLING_ERROR: 'spellingError',
        SPELLING_ERROR_SELECTED: 'spellingErrorSelected',
        SUGGESTION: 'suggestion'
    };
    const $030113c8028a5fde$var$composeDecorations = (transformers)=>({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>transformers.reduce((decorationSet, transform)=>transform({
                    decorationSet: decorationSet,
                    tr: tr,
                    pluginState: pluginState
                }), decorationSet);
    const $030113c8028a5fde$export$ad950d3225a13eae = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
    const $030113c8028a5fde$export$869ca1e6f091229e = (params)=>{
        return $030113c8028a5fde$var$composeDecorations([
            (0, (0, parcelRequire("aXVZ4")).removeSelectedSpellingDecoration),
            (0, (0, parcelRequire("aXVZ4")).addSelectedSpellingDecoration)
        ])(params);
    };
    const $030113c8028a5fde$export$ccdc7e88bd8862ee = (params)=>{
        return $030113c8028a5fde$var$composeDecorations([
            (0, (0, parcelRequire("aXVZ4")).removeSelectedSpellingDecoration),
            (0, (0, parcelRequire("8kYLI")).updateSpellingDecoration),
            (0, (0, parcelRequire("aXVZ4")).addSelectedSpellingDecoration)
        ])(params);
    };
});
parcelRegister("8kYLI", function(module, exports) {
    $parcel$export(module.exports, "updateSpellingDecoration", ()=>$4a49c40897b4afdb$export$14f4f8ed60a20b34);
    var $etG8M;
    var $5ilgR;
    var $k5t6k;
    const $4a49c40897b4afdb$var$createDecoration = (from, to, id)=>(0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
            nodeName: 'span',
            class: `ai-suggestions`,
            id: `ai-sg-${id}`,
            'data-testid': `ai-suggestions`
        }, {
            key: (0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR,
            diffObjectId: id
        });
    const $4a49c40897b4afdb$export$14f4f8ed60a20b34 = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
        const allDiffObjects = (0, (0, parcelRequire("5ilgR")).getAllDiffObjects)(pluginState);
        const allDiffObjectsIds = allDiffObjects.map((diffObject)=>diffObject.id);
        const existingDecorationDiffObjectIds = [];
        const decorationsToRemove = decorationSet.find(undefined, undefined, (spec)=>{
            if (spec.key !== (0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR) return false;
            existingDecorationDiffObjectIds.push(spec.diffObjectId);
            return !allDiffObjectsIds.includes(spec.diffObjectId);
        });
        decorationSet = decorationSet.remove(decorationsToRemove);
        decorationSet = decorationSet.map(tr.mapping, tr.doc);
        let decorations = allDiffObjects?.reduce((acc, { id: id, from: from, to: to })=>{
            if (!existingDecorationDiffObjectIds.includes(id)) acc.push($4a49c40897b4afdb$var$createDecoration(from, to, id));
            return acc;
        }, []);
        if (!!decorations?.length) return decorationSet.add(tr.doc, decorations);
        return decorationSet;
    };
});
parcelRegister("aXVZ4", function(module, exports) {
    $parcel$export(module.exports, "removeSelectedSpellingDecoration", ()=>$f0e71bd9ad954035$export$55a4a250b4381d59);
    $parcel$export(module.exports, "addSelectedSpellingDecoration", ()=>$f0e71bd9ad954035$export$caecada8d781cb5a);
    var $etG8M;
    var $5ilgR;
    var $k5t6k;
    const $f0e71bd9ad954035$export$55a4a250b4381d59 = ({ decorationSet: decorationSet, pluginState: pluginState })=>{
        return decorationSet.remove((0, (0, parcelRequire("k5t6k")).filterDecorationByKey)((0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR_SELECTED, decorationSet));
    };
    const $f0e71bd9ad954035$export$caecada8d781cb5a = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
        const { selection: selection } = tr;
        if (selection.from === selection.to) {
            const selectedDiff = (0, (0, parcelRequire("5ilgR")).getSelectedDiffObject)(pluginState, selection.to);
            if (selectedDiff) {
                const { from: from, to: to } = selectedDiff;
                return decorationSet.add(tr.doc, [
                    (0, (0, parcelRequire("etG8M")).Decoration).inline(from, to, {
                        class: `ai-suggestions-selected`
                    }, {
                        key: (0, (0, parcelRequire("k5t6k")).SpellingAndGrammarDecorations).SPELLING_ERROR_SELECTED
                    })
                ]);
            }
        }
        return decorationSet;
    };
});
parcelRegister("4dOAK", function(module, exports) {
    $parcel$export(module.exports, "createInitialState", ()=>$45422c3644cec0fa$export$de5e90bd767c5d82);
    $parcel$export(module.exports, "createPluginState", ()=>$45422c3644cec0fa$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$45422c3644cec0fa$export$8d4021544bdece00);
    $parcel$export(module.exports, "getPluginState", ()=>$45422c3644cec0fa$export$f05434c51e3762e);
    var $aOimD;
    var $etG8M;
    var $bwUTF;
    var $hcRrA;
    var $k0tah;
    var $k5t6k;
    var $iQrvV;
    var $5ilgR;
    const $45422c3644cec0fa$var$handleDocChanged = (tr, pluginState, newEditorState)=>{
        const { updatedProactiveAIBlock: updatedProactiveAIBlock } = (0, (0, parcelRequire("5ilgR")).findProactiveAIBlockToUpdate)(tr, pluginState, newEditorState);
        const { decorationSet: decorationSet, selectedID: selectedID, docChangeCountUntilLimit: docChangeCountUntilLimit } = pluginState;
        const uniqueInteractionID = tr.getMeta((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey))?.uniqueInteractionID ?? selectedID;
        return {
            ...pluginState,
            selectedID: uniqueInteractionID,
            decorationSet: (0, (0, parcelRequire("k5t6k")).regenerateAllDecorations)({
                decorationSet: decorationSet,
                tr: tr,
                pluginState: {
                    ...pluginState,
                    proactiveAIBlocks: updatedProactiveAIBlock
                }
            }),
            proactiveAIBlocks: updatedProactiveAIBlock,
            ...docChangeCountUntilLimit < (0, (0, parcelRequire("k0tah")).DOC_CHANGE_COUNT_LIMIT) && {
                docChangeCountUntilLimit: docChangeCountUntilLimit + 1
            }
        };
    };
    const $45422c3644cec0fa$var$handleSelectionChanged = (tr, pluginState)=>{
        const { decorationSet: decorationSet } = pluginState;
        return {
            ...pluginState,
            decorationSet: (0, (0, parcelRequire("k5t6k")).regenerateSelectedSpellingDecorations)({
                decorationSet: decorationSet,
                tr: tr,
                pluginState: pluginState
            })
        };
    };
    const $45422c3644cec0fa$export$de5e90bd767c5d82 = ({ proactiveAIApiUrl: proactiveAIApiUrl, documentSGChecker: documentSGChecker, defaultToggledState: defaultToggledState })=>(state)=>{
            const { proactiveAIBlocks: proactiveAIBlocks } = (0, (0, parcelRequire("5ilgR")).getAllProactiveAIBlocks)(state);
            const initialToggleState = !!(0, (0, parcelRequire("bwUTF")).isLocalStorageProactiveAIToggled)(defaultToggledState);
            return {
                proactiveAIBlocks: proactiveAIBlocks,
                initialToggleState: initialToggleState,
                isSpellingAndGrammarEnabled: initialToggleState,
                decorationSet: (0, (0, parcelRequire("etG8M")).DecorationSet).empty,
                proactiveAIApiUrl: proactiveAIApiUrl,
                dismissedWords: new Set(),
                toggleCount: initialToggleState ? 1 : 0,
                insertionCount: 0,
                splitParagraphIntoSentences: (0, (0, parcelRequire("5ilgR")).canSplitParagraphIntoSentences)(),
                documentSGChecker: documentSGChecker,
                docChangeCountUntilLimit: 0,
                isFirstInitiatedEventSent: false
            };
        };
    const { createPluginState: $45422c3644cec0fa$export$656c7661095efe2e, createCommand: $45422c3644cec0fa$export$8d4021544bdece00, getPluginState: $45422c3644cec0fa$export$f05434c51e3762e } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey), (0, (0, parcelRequire("iQrvV")).reducer), {
        onDocChanged: $45422c3644cec0fa$var$handleDocChanged,
        onSelectionChanged: $45422c3644cec0fa$var$handleSelectionChanged
    });
});
parcelRegister("iQrvV", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$da6a32c614c2c818$export$1650419e431d3ba3);
    var $aYj1w;
    const $da6a32c614c2c818$export$1650419e431d3ba3 = (pluginState, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_PLUGIN_STATE:
                return {
                    ...pluginState,
                    ...action.data
                };
            case (0, (0, parcelRequire("aYj1w")).ACTIONS).TOGGLE_SPELLING_AND_GRAMMAR_ENABLED:
                return {
                    ...pluginState,
                    toggleCount: action.data.toggleCount,
                    isSpellingAndGrammarEnabled: !pluginState.isSpellingAndGrammarEnabled,
                    ...pluginState.isSpellingAndGrammarEnabled && {
                        docChangeCountUntilLimit: 0
                    }
                };
            case (0, (0, parcelRequire("aYj1w")).ACTIONS).DISABLE_NEED_SPELLING_AND_GRAMMAR:
                return {
                    ...pluginState,
                    proactiveAIBlocks: pluginState.proactiveAIBlocks?.map((block)=>{
                        if (pluginState.splitParagraphIntoSentences) return {
                            ...block,
                            sentences: block.sentences?.map((sentence)=>{
                                if (action.data.skippedChunkIds.includes(sentence.id)) return {
                                    ...sentence,
                                    needSpellingAndGrammarCheck: false,
                                    needSGCheckForDocChecker: false
                                };
                                return sentence;
                            })
                        };
                        if (action.data.skippedChunkIds.includes(block.id)) return {
                            ...block,
                            needSpellingAndGrammarCheck: false,
                            needSGCheckForDocChecker: false
                        };
                        return block;
                    })
                };
            case (0, (0, parcelRequire("aYj1w")).ACTIONS).UPDATE_CHUNK_METADATA:
                return {
                    ...pluginState,
                    proactiveAIBlocks: pluginState.proactiveAIBlocks?.map((block)=>{
                        if (pluginState.splitParagraphIntoSentences) return {
                            ...block,
                            sentences: block.sentences?.map((sentence)=>{
                                if (action.data.chunkId === sentence.id) return {
                                    ...sentence,
                                    metadata: action.data.metadata
                                };
                                return sentence;
                            })
                        };
                        if (action.data.chunkId === block.id) return {
                            ...block,
                            metadata: action.data.metadata
                        };
                        return block;
                    })
                };
            case (0, (0, parcelRequire("aYj1w")).ACTIONS).START_SPELLING_AND_GRAMMAR:
                return {
                    ...pluginState,
                    isSpellingAndGrammarEnabled: true,
                    toggleCount: pluginState.isSpellingAndGrammarEnabled ? pluginState.toggleCount : pluginState.toggleCount + 1
                };
            default:
                return pluginState;
        }
    };
});
parcelRegister("aYj1w", function(module, exports) {
    $parcel$export(module.exports, "ACTIONS", ()=>$7f288bb24fe2ef81$export$92a1a3b7554e9387);
    var $7f288bb24fe2ef81$export$92a1a3b7554e9387;
    (function(ACTIONS) {
        ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
        ACTIONS[ACTIONS["TOGGLE_SPELLING_AND_GRAMMAR_ENABLED"] = 1] = "TOGGLE_SPELLING_AND_GRAMMAR_ENABLED";
        ACTIONS[ACTIONS["DISABLE_NEED_SPELLING_AND_GRAMMAR"] = 2] = "DISABLE_NEED_SPELLING_AND_GRAMMAR";
        ACTIONS[ACTIONS["UPDATE_CHUNK_METADATA"] = 3] = "UPDATE_CHUNK_METADATA";
        ACTIONS[ACTIONS["START_SPELLING_AND_GRAMMAR"] = 4] = "START_SPELLING_AND_GRAMMAR";
        ACTIONS[ACTIONS["SELECT_SPELLING_AND_GRAMMAR_SUGGESTION"] = 5] = "SELECT_SPELLING_AND_GRAMMAR_SUGGESTION";
    })($7f288bb24fe2ef81$export$92a1a3b7554e9387 || ($7f288bb24fe2ef81$export$92a1a3b7554e9387 = {}));
});
parcelRegister("aa2IN", function(module, exports) {
    $parcel$export(module.exports, "RecommendationPanel", ()=>$386308ca72c3a86d$export$a6dbe1033096e1fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $5KOuL;
    var $cThJ2;
    const $386308ca72c3a86d$var$panelContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.0',
        height: '100%',
        width: '100%'
    });
    const $386308ca72c3a86d$var$emptyStateStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 4
    });
    const $386308ca72c3a86d$var$padEmptyStateStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1
    });
    const $386308ca72c3a86d$export$a6dbe1033096e1fc = (props)=>{
        const { recommendations: recommendations, hoveredRecommendationId: hoveredRecommendationId, selectedRecommendationId: selectedRecommendationId, isSpellingGrammarEnabled: isSpellingGrammarEnabled, spellingGrammarErrorCount: spellingGrammarErrorCount, onRecommendationApply: onRecommendationApply, onPanelClose: onPanelClose, onRecommendationDismiss: onRecommendationDismiss, onRecommendationSelect: onRecommendationSelect, onSpellingGrammar: onSpellingGrammar, onRecommendationHover: onRecommendationHover, onRecommendationLeave: onRecommendationLeave } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: $386308ca72c3a86d$var$panelContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cThJ2")).HeadingItem), {
            onClose: onPanelClose
        }), recommendations?.length > 0 || (spellingGrammarErrorCount ?? 0) > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isSpellingGrammarEnabled && (spellingGrammarErrorCount ?? 0) > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cThJ2")).SpellingGrammarItem), {
            errorCount: spellingGrammarErrorCount ?? 0,
            onClick: onSpellingGrammar
        }), recommendations?.map((r)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cThJ2")).RecommendationItem), {
                key: r.id,
                id: r.id,
                action: r.transformAction,
                isViewed: r.isViewed,
                isHovered: r.id === hoveredRecommendationId,
                isSelected: r.id === selectedRecommendationId,
                onApply: ()=>onRecommendationApply({
                        recommendation: r
                    }),
                onDismiss: ()=>onRecommendationDismiss({
                        recommendation: r
                    }),
                onClick: ()=>onRecommendationSelect({
                        recommendation: r
                    }),
                onMouseEnter: ()=>onRecommendationHover({
                        recommendation: r
                    }),
                onMouseLeave: ()=>onRecommendationLeave({
                        recommendation: r
                    }),
                onPreview: ()=>onRecommendationSelect({
                        recommendation: r
                    })
            }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $386308ca72c3a86d$var$emptyStateStyles,
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5KOuL")).EmptyState), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $386308ca72c3a86d$var$padEmptyStateStyles
        })));
    };
});
parcelRegister("5KOuL", function(module, exports) {
    $parcel$export(module.exports, "EmptyState", ()=>$a5b23bb979918db2$export$fddf379e22a74b00);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l1N8i;
    var $luBm6;
    var $cgL5K;
    var $k0FqT;
    var $8JKVd;
    const $a5b23bb979918db2$var$ImageEmpty = ()=>{
        const aiThemeColor = (0, (0, parcelRequire("k0FqT")).useAIThemeColor)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "160",
            height: "160",
            viewBox: "0 0 160 160",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "empty state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "sheet"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M33.4893 141.764C33.4893 141.764 96.5819 149.267 129.055 141.423V27.1708C129.055 27.1708 77.5615 39.7852 33.4893 26.4893C33.4893 26.4893 34.1844 142.282 33.4893 141.771V141.764Z",
            fill: aiThemeColor('empty-state.sheet')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M47.0103 66.4453H115.541",
            stroke: aiThemeColor('empty-state.line'),
            strokeWidth: "3.41072",
            strokeMiterlimit: "10"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M47.0103 83.2373H115.541",
            stroke: aiThemeColor('empty-state.line'),
            strokeWidth: "3.41072",
            strokeMiterlimit: "10"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M47.0103 100.022H115.541",
            stroke: aiThemeColor('empty-state.line'),
            strokeWidth: "3.41072",
            strokeMiterlimit: "10"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M47.1191 117.81H73.6974",
            stroke: aiThemeColor('empty-state.line'),
            strokeWidth: "3.41072",
            strokeMiterlimit: "10"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "checkmark"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M102.921 122.923L134.82 89.8684L146.617 100.735L100.281 140.299L78.4678 120.306L89.8107 107.279L102.916 122.928L102.921 122.923Z",
            fill: aiThemeColor('empty-state.checkmark')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M129.055 95.8423L102.921 122.923L102.916 122.927L89.8107 107.279L78.4678 120.306L100.281 140.299L129.055 115.73V95.8423Z",
            fill: aiThemeColor('empty-state.overlap')
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "scribble"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M115.263 49.0782C103.519 51.211 94.8538 45.7536 82.9928 50.2304C82.4392 48.313 81.0077 45.9119 78.8651 45.8767C80.6521 45.9207 83.5105 50.9296 80.6386 47.5742C78.9506 45.0191 71.573 48.1415 77.2266 45.9207C73.324 46.3912 69.7454 49.5004 67.1077 52.2665C62.7189 56.2068 66.0498 48.5813 62.8764 44.7465C58.3796 39.4166 44.7316 53.278 47.4819 53.2868C49.2329 51.5497 51.5826 50.4679 52.5549 48.5417C69.6734 37.1386 57.3218 58.2429 67.5173 54.7072C84.1722 40.0498 75.7547 53.3175 85.5316 52.4116C91.2303 47.0992 115.461 55.4284 115.267 49.0782H115.263Z",
            fill: aiThemeColor('empty-state.scribble')
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            id: "eyelash"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M30.4365 12.6115C30.542 12.3181 28.7189 8.42724 28.4141 9.75182C28.2413 10.2171 28.3688 10.5717 28.8144 10.58C28.0469 10.919 29.3228 11.4035 29.1625 11.8472C28.5688 11.8685 30.0342 12.6666 29.3956 12.6108C29.9852 17.1942 37.799 24.6012 31.616 14.6462C31.6564 15.7933 31.1609 14.8368 31.1535 14.3185C32.0544 14.8163 30.8889 12.9621 30.5416 12.6563C30.725 13.2793 29.9194 12.3896 30.4351 12.6139L30.4365 12.6115Z",
            fill: aiThemeColor('empty-state.eyelash')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M25.8275 22.4433C25.6371 21.8768 21.0633 20.526 20.6082 20.3239C19.555 20.0734 19.8389 21.4186 20.6801 21.4222C20.8431 21.4939 22.0593 21.5672 21.6539 21.9652C22.2038 23.0266 24.2392 22.6437 24.6192 23.5623C24.8408 23.3391 25.2445 23.5913 25.3994 23.4668C25.4452 23.7583 25.8669 23.8134 25.8827 23.7363C27.1906 24.6798 27.9473 22.8658 26.361 22.5981C26.4083 22.5328 26.0707 22.2709 25.8312 22.4423L25.8275 22.4433Z",
            fill: aiThemeColor('empty-state.eyelash')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M22.4109 39.1057C23.2009 39.4469 22.5042 39.5969 22.1203 39.4264C22.5789 38.8036 21.216 39.1724 20.9086 39.4228C21.0578 39.4132 21.1464 39.6527 20.8405 39.69C20.9545 39.0279 17.0944 39.5449 19.1078 40.5445C19.173 40.5311 19.1261 40.0315 19.2267 40.1726C19.2128 40.9435 19.7359 40.3197 19.8972 40.234C19.9532 40.6239 20.0594 40.2351 20.1271 40.3891C19.9995 40.9476 20.8461 39.9071 20.6901 40.4651C21.6922 41.114 23.2719 39.772 24.0557 40.3841C24.3853 39.4315 27.4022 40.2698 26.0589 38.7791C24.7868 38.6033 23.7598 38.5563 22.4109 39.1057Z",
            fill: aiThemeColor('empty-state.eyelash')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.7248 31.3833C13.6052 32.6361 16.2087 31.9331 17.0031 32.3055C17.9809 32.8637 27.6997 33.7402 24.9085 31.7807C21.9649 31.5402 19.5934 30.8287 15.9877 30.9882C15.4 30.9713 13.519 30.5558 13.7248 31.3833Z",
            fill: aiThemeColor('empty-state.eyelash')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M40.2534 16.0188C41.3411 16.5415 40.2784 17.7349 41.1867 18.253C42.887 18.976 42.0015 9.99791 40.4614 10.5518C39.2016 11.2069 40.7334 15.2871 40.2534 16.0188Z",
            fill: aiThemeColor('empty-state.eyelash')
        }))));
    };
    const $a5b23bb979918db2$export$fddf379e22a74b00 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200",
            alignInline: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5b23bb979918db2$var$ImageEmpty, null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.150",
            alignInline: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            color: "color.text",
            size: "small"
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).emptyStateTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            align: "center",
            color: "color.text",
            size: "medium"
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).emptyStateDescription))));
    };
});
parcelRegister("8JKVd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef0868069bf98841$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ef0868069bf98841$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recommendationPreviewButtonLabel: {
            id: 'fabric.editor.ai.proactive.recommendation.preview.button.non-final',
            defaultMessage: 'Preview',
            description: 'The preview button label which allows the user to open the preview modal and see the AI recommendation which will be applied when the user inserts'
        },
        recommendationReplaceButtonLabel: {
            id: 'fabric.editor.ai.proactive.recommendation.replace.button.non-final',
            defaultMessage: 'Replace',
            description: 'The replace button label, when clicked the AI recommendation which immediately be inserted'
        },
        recommendationDismissButtonLabel: {
            id: 'fabric.editor.ai.proactive.recommendation.dismiss.button.non-final',
            defaultMessage: 'Dismiss',
            description: 'The dismiss button label,when clicked the AI recommendation will be removed from the list and no longer displayed to the user'
        },
        spellingAndGrammarLabel: {
            id: 'fabric.editor.ai.proactive.spellingAndGrammar.label.non-final',
            defaultMessage: 'Spelling and grammar',
            description: 'The label displayed in the context panel on the spelling and grammar item which display the total spelling and grammar issues found'
        },
        suggestedEditsTitle: {
            id: 'fabric.editor.ai.proactive.suggestedEdits.title.non-final',
            defaultMessage: 'Suggested edits',
            description: 'The title displayed at the top of the context panel for all recommendations displayed'
        },
        moreActionsLabel: {
            id: 'fabric.editor.ai.proactive.moreActions.label.non-final',
            defaultMessage: 'More actions',
            description: 'This is the text applied to the More icon button label'
        },
        closeButtonLabel: {
            id: 'fabric.editor.ai.proactive.close.label.non-final',
            defaultMessage: 'Close',
            description: 'This is the text applied to the Close icon button label'
        },
        betaLabel: {
            id: 'fabric.editor.ai.proactive.beta.label.non-final',
            defaultMessage: 'BETA',
            description: 'This is a lozenge displayed in the suggested edits header to signify that this is a beta feature'
        },
        emptyStateTitle: {
            id: 'fabric.editor.ai.proactive.emptyState.title.non-final',
            defaultMessage: "Your content's looking good.",
            description: 'This is the title of the message displayed in the suggested edits panel when there are no recommendations'
        },
        emptyStateDescription: {
            id: 'fabric.editor.ai.proactive.emptyState.description.non-final',
            defaultMessage: 'Edit your page to find suggested improvements here.',
            description: 'This is the message displayed in the suggested edits panel when there are no recommendations'
        }
    });
});
parcelRegister("cThJ2", function(module, exports) {
    $parcel$export(module.exports, "RecommendationItem", ()=>$d101cd2c49c870ab$export$29adfa7300c93a7);
    $parcel$export(module.exports, "SpellingGrammarItem", ()=>$d101cd2c49c870ab$export$90393ff0d9c97021);
    $parcel$export(module.exports, "HeadingItem", ()=>$d101cd2c49c870ab$export$33647cff569304d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $16T6Y;
    var $42CjB;
    var $l1N8i;
    var $i28qQ;
    var $hMVoD;
    var $cGzVC;
    var $2Yv61;
    var $7Uevx;
    var $b0JGA;
    var $doTgN;
    var $34Rrn;
    var $iyAO0;
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $luBm6;
    var $cgL5K;
    var $8CUq3;
    var $GWO6B;
    var $8JKVd;
    const $d101cd2c49c870ab$var$headingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flex: 1
    });
    const $d101cd2c49c870ab$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.subtle',
        fontWeight: 'font.weight.medium',
        padding: 'space.0',
        backgroundColor: 'color.background.neutral.subtle',
        ':active': {
            color: 'color.text'
        }
    });
    const $d101cd2c49c870ab$var$pressableSelectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        textDecoration: 'underline'
    });
    const $d101cd2c49c870ab$var$containerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        paddingInline: 'space.150',
        paddingBlock: 'space.150',
        flexDirection: 'column',
        gap: 'space.100',
        alignSelf: 'stretch',
        backgroundColor: 'elevation.surface',
        cursor: 'pointer',
        borderRadius: 'border.radius.100'
    });
    const $d101cd2c49c870ab$var$extraPadding = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlockStart: 'space.050'
    });
    const $d101cd2c49c870ab$var$containerHoveredStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'elevation.surface.hovered'
    });
    const $d101cd2c49c870ab$var$containerSelectedStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        backgroundColor: 'color.background.selected'
    });
    const $d101cd2c49c870ab$var$transformActionIconMap = {
        CONVERT_TO_TABLE: (0, ($parcel$interopDefault((0, parcelRequire("7Uevx"))))),
        CONVERT_TO_NOTE_PANEL: (0, ($parcel$interopDefault((0, parcelRequire("cGzVC"))))),
        CONVERT_TO_INFO_PANEL: (0, ($parcel$interopDefault((0, parcelRequire("2Yv61"))))),
        CONVERT_TO_WARN_PANEL: (0, ($parcel$interopDefault((0, parcelRequire("34Rrn"))))),
        CONVERT_TO_ERROR_PANEL: (0, ($parcel$interopDefault((0, parcelRequire("hMVoD"))))),
        CONVERT_TO_SUCCESS_PANEL: (0, ($parcel$interopDefault((0, parcelRequire("b0JGA")))))
    };
    const $d101cd2c49c870ab$var$ListItem = (props)=>{
        const { title: title, description: description, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isHovered: isHovered, isSelected: isSelected, beforeIcon: beforeIcon, afterIcon: afterIcon, actionButtons: actionButtons } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            xcss: [
                $d101cd2c49c870ab$var$containerStyles,
                isSelected && $d101cd2c49c870ab$var$containerSelectedStyles,
                isHovered && !isSelected && $d101cd2c49c870ab$var$containerHoveredStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.150",
            alignBlock: "center"
        }, beforeIcon, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d101cd2c49c870ab$var$headingStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "small"
        }, title)), afterIcon), !!description && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtle"
        }, description), !!actionButtons?.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $d101cd2c49c870ab$var$extraPadding
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.150",
            alignBlock: "center"
        }, actionButtons))));
    };
    const $d101cd2c49c870ab$export$29adfa7300c93a7 = (props)=>{
        const { action: action, isViewed: isViewed, isHovered: isHovered, isSelected: isSelected, onApply: onApply, onDismiss: onDismiss, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPreview: onPreview } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const Icon = $d101cd2c49c870ab$var$transformActionIconMap[action] ?? (0, ($parcel$interopDefault((0, parcelRequire("iyAO0")))));
        const { description: descriptionDescriptor, title: titleDescriptor } = (0, (0, parcelRequire("GWO6B")).getTransformActionDescriptors)(action);
        const title = formatMessage(titleDescriptor);
        const description = formatMessage(descriptionDescriptor);
        const previewButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            key: "preview",
            xcss: [
                $d101cd2c49c870ab$var$pressableStyles,
                isHovered && $d101cd2c49c870ab$var$pressableSelectedStyles
            ],
            onClick: onPreview
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).recommendationPreviewButtonLabel));
        const insertButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            key: "replace",
            xcss: $d101cd2c49c870ab$var$pressableStyles,
            onClick: onApply
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).recommendationReplaceButtonLabel));
        const dismissButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            key: "dismiss",
            xcss: $d101cd2c49c870ab$var$pressableStyles,
            onClick: onDismiss
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).recommendationDismissButtonLabel));
        const actionButtons = isSelected ? [
            insertButton,
            dismissButton
        ] : [
            previewButton,
            dismissButton
        ];
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d101cd2c49c870ab$var$ListItem, {
            title: title,
            description: description,
            isHovered: isHovered,
            isSelected: isSelected,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            beforeIcon: (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                size: "medium",
                label: title,
                primaryColor: "var(--ds-icon, #44546F)"
            }),
            afterIcon: isViewed ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iyAO0"))))), {
                size: "small",
                label: "unread",
                primaryColor: "var(--ds-icon-information, #1D7AFC)"
            }),
            actionButtons: actionButtons
        });
    };
    const $d101cd2c49c870ab$export$90393ff0d9c97021 = (props)=>{
        const { errorCount: errorCount, onClick: onClick } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d101cd2c49c870ab$var$ListItem, {
            title: formatMessage((0, (0, parcelRequire("8JKVd")).default).spellingAndGrammarLabel),
            onClick: onClick,
            beforeIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("doTgN"))))), {
                label: formatMessage((0, (0, parcelRequire("8JKVd")).default).spellingAndGrammarLabel),
                color: "var(--ds-icon, #44546F)"
            }),
            afterIcon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("16T6Y")).default), null, errorCount)
        });
    };
    const $d101cd2c49c870ab$var$toolTipProps = {
        position: 'top'
    };
    const $d101cd2c49c870ab$export$33647cff569304d0 = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onClose: onClose } = props;
        const closeTooltip = formatMessage((0, (0, parcelRequire("8JKVd")).default).closeButtonLabel);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $d101cd2c49c870ab$var$headingStyles,
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            size: "medium",
            color: "color.text"
        }, formatMessage((0, (0, parcelRequire("8JKVd")).default).suggestedEditsTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), null, formatMessage((0, (0, parcelRequire("8JKVd")).default).betaLabel))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            label: closeTooltip,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))),
            onClick: onClose,
            isTooltipDisabled: false,
            tooltip: $d101cd2c49c870ab$var$toolTipProps
        }));
    };
});
parcelRegister("cGzVC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $93c546e6dbb90173$var$_react = $93c546e6dbb90173$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $93c546e6dbb90173$var$_UNSAFE_baseNew = $93c546e6dbb90173$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $93c546e6dbb90173$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $93c546e6dbb90173$var$FeedIcon = (props)=>$93c546e6dbb90173$var$_react.default.createElement($93c546e6dbb90173$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 14.25a2 2 0 0 0 2-2v-6m-2 8a2 2 0 0 1-2-2V7.5c0-.69.56-1.25 1.25-1.25h2.75m-2 8h8.5a2 2 0 0 0 2-2V3c0-.69-.56-1.25-1.25-1.25H7c-.69 0-1.25.56-1.25 1.25v3.25M8 4.75h4m-4 3h3"/>`
        }, props));
    $93c546e6dbb90173$var$FeedIcon.displayName = 'FeedIcon';
    var $93c546e6dbb90173$var$_default = module.exports.default = $93c546e6dbb90173$var$FeedIcon;
});
parcelRegister("7Uevx", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c1904502a6c690c$var$_react = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5c1904502a6c690c$var$_UNSAFE_baseNew = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5c1904502a6c690c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c1904502a6c690c$var$SpreadsheetIcon = (props)=>$5c1904502a6c690c$var$_react.default.createElement($5c1904502a6c690c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 2.75H2C1.31 2.75.75 3.31.75 4v4m5-5.25H14c.69 0 1.25.56 1.25 1.25v4m-9.5-5.25v10.5m0 0H14c.69 0 1.25-.56 1.25-1.25V8m-9.5 5.25H2c-.69 0-1.25-.56-1.25-1.25V8m0 0h14.5"/>`
        }, props));
    $5c1904502a6c690c$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
    var $5c1904502a6c690c$var$_default = module.exports.default = $5c1904502a6c690c$var$SpreadsheetIcon;
});
parcelRegister("doTgN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9c1863b37b05edde$var$_react = $9c1863b37b05edde$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9c1863b37b05edde$var$_UNSAFE_baseNew = $9c1863b37b05edde$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9c1863b37b05edde$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9c1863b37b05edde$var$TextSpellcheckIcon = (props)=>$9c1863b37b05edde$var$_react.default.createElement($9c1863b37b05edde$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 11v-.25l1.27-3.5M9.75 11v-.25l-1.27-3.5m0 0L6.13.75h-.75l-2.36 6.5m5.46 0H3.02M7.5 12.5l2.33 2.75 4.67-5.5"/>`
        }, props));
    $9c1863b37b05edde$var$TextSpellcheckIcon.displayName = 'TextSpellcheckIcon';
    var $9c1863b37b05edde$var$_default = module.exports.default = $9c1863b37b05edde$var$TextSpellcheckIcon;
});
parcelRegister("iyAO0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d827f3c4ac5b3696$var$_react = $d827f3c4ac5b3696$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    function $d827f3c4ac5b3696$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d827f3c4ac5b3696$var$PresenceActiveIcon = (props)=>$d827f3c4ac5b3696$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
        }, props));
    $d827f3c4ac5b3696$var$PresenceActiveIcon.displayName = 'PresenceActiveIcon';
    var $d827f3c4ac5b3696$var$_default = module.exports.default = $d827f3c4ac5b3696$var$PresenceActiveIcon;
});
parcelRegister("GWO6B", function(module, exports) {
    $parcel$export(module.exports, "getTransformActionDescriptors", ()=>$938fec5e4f8a836f$export$8a1ffc8640d69b9b);
    var $6bksx;
    const $938fec5e4f8a836f$var$defaultDetails = {
        title: (0, (0, parcelRequire("6bksx")).default).recommendationDefaultTitle,
        description: (0, (0, parcelRequire("6bksx")).default).recommendationDefaultDescription
    };
    const $938fec5e4f8a836f$var$detailsByConversionType = {
        CONVERT_TO_TABLE: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToTableTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToTableDescription
        },
        CONVERT_TO_NOTE_PANEL: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToNotePanelTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToNotePanelDescription
        },
        CONVERT_TO_INFO_PANEL: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToInfoPanelTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToInfoPanelDescription
        },
        CONVERT_TO_WARN_PANEL: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToWarnPanelTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToWarnPanelDescription
        },
        CONVERT_TO_ERROR_PANEL: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToErrorPanelTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToErrorPanelDescription
        },
        CONVERT_TO_SUCCESS_PANEL: {
            title: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToSuccessPanelTitle,
            description: (0, (0, parcelRequire("6bksx")).default).recommendationConvertToSuccessPanelDescription
        }
    };
    const $938fec5e4f8a836f$export$8a1ffc8640d69b9b = (action)=>$938fec5e4f8a836f$var$detailsByConversionType[action] ?? $938fec5e4f8a836f$var$defaultDetails;
});
parcelRegister("6bksx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58efd36e637ca176$export$2e2bcd8739ae039);
    var $7VHMR;
    var $58efd36e637ca176$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        recommendationDefaultTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.default.title.non-final',
            defaultMessage: 'Suggestion',
            description: 'The default generic title displayed in the side context panel for AI recommendations which have not explicit matching override'
        },
        recommendationDefaultDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.default.description.non-final',
            defaultMessage: 'A suggestion to improve the content.',
            description: 'The default generic description displayed in the side context panel for AI recommendations which have no explicit matching override'
        },
        recommendationConvertToTableTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToTable.title.non-final',
            defaultMessage: 'Convert to table',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to table operation'
        },
        recommendationConvertToTableDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToTable.description.non-final',
            defaultMessage: 'Organize this data in a table to give it structure and make it clearer.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to table operation'
        },
        recommendationConvertToNotePanelTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToNotePanel.title.non-final',
            defaultMessage: 'Convert to note panel',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to note panel operation'
        },
        recommendationConvertToNotePanelDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToNotePanel.description.non-final',
            defaultMessage: 'Make this important note stand out by putting it in a purple box.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to note panel operation'
        },
        recommendationConvertToInfoPanelTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.title.non-final',
            defaultMessage: 'Convert to info panel',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to note panel operation'
        },
        recommendationConvertToInfoPanelDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToInfoPanel.description.non-final',
            defaultMessage: 'Make this important info stand out by putting it in a blue box.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to info panel operation'
        },
        recommendationConvertToWarnPanelTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.title.non-final',
            defaultMessage: 'Convert to warning panel',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to warning panel operation'
        },
        recommendationConvertToWarnPanelDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToWarnPanel.description.non-final',
            defaultMessage: 'Make this important warning stand out by putting it in a orange box.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to warning panel operation'
        },
        recommendationConvertToErrorPanelTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.title.non-final',
            defaultMessage: 'Convert to error panel',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to error panel operation'
        },
        recommendationConvertToErrorPanelDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToErrorPanel.description.non-final',
            defaultMessage: 'Make this important error stand out by putting it in a red box.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to error panel operation'
        },
        recommendationConvertToSuccessPanelTitle: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.title.non-final',
            defaultMessage: 'Convert to success panel',
            description: 'The title displayed in the side context panel for AI recommendations which suggest a conversion to success panel operation'
        },
        recommendationConvertToSuccessPanelDescription: {
            id: 'fabric.editor.ai.proactive.recommendation.convertToSuccessPanel.description.non-final',
            defaultMessage: 'Make this important success stand out by putting it in a green box.',
            description: 'The description displayed in the side context panel for AI recommendations which suggest a conversion to success panel operation'
        }
    });
});
parcelRegister("54ft5", function(module, exports) {
    $parcel$export(module.exports, "ExperienceApplication", ()=>$46c7d964b0426534$export$8b0e36b4d2610ae7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $koVbs;
    var $ggL2v;
    var $VSDnB;
    var $hjiMw;
    var $gmhCD = parcelRequire("gmhCD");
    var $h1WZC;
    var $2MNYo;
    var $hEAZb;
    var $6KJH7;
    var $9IlT9;
    var $6XU5x;
    var $7NRaX;
    var $k7UkR;
    var $32Eq0;
    var $2nhuY;
    var $8Oaok;
    var $3a2e3;
    function $46c7d964b0426534$export$501630857d1b4132(props) {
        const state = props.state;
        const context = props.context;
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const publish = (0, (0, parcelRequire("hjiMw")).usePublish)('ai-mate');
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const send = aiExperienceCommonData.sendToAIExperienceMachine;
            if (send && state === 'started state') send({
                type: 'kick off'
            });
        }, [
            state,
            aiExperienceCommonData.sendToAIExperienceMachine
        ]);
        const backendModel = context?.configItem?.getBackendModel?.(!!context?.latestPromptResponse);
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlow)();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            analyticsFlow.updateCommonAttributes({
                backendModel: backendModel,
                channelId: context.channelId,
                ...analyticsFlow.getUserFlowCommonAttributes(context.configItem)
            });
        }, [
            analyticsFlow,
            backendModel,
            context.channelId,
            context.configItem
        ]);
        const aiLifeCycleDynamicAttributesGetter = context.aiLifeCycleDynamicAttributesGetter;
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!(0, (0, parcelRequire("VSDnB")).fg)('editorai_dynamic_attributes_for_ai_life_cycle')) return;
            if (aiLifeCycleDynamicAttributesGetter) analyticsFlow.registerAiLifeCycleDynamicAttributesGetter(aiLifeCycleDynamicAttributesGetter);
        }, [
            analyticsFlow,
            aiLifeCycleDynamicAttributesGetter
        ]);
        if (state === 'started state') return null;
        const isModalActiveState = typeof state !== 'string' && state['modal active state'];
        if (!isModalActiveState) throw new Error('AI machine state is not: modal active state or modal error state');
        const experienceState = state['modal active state']['experience'];
        if (typeof experienceState === 'object' && 'error state' in experienceState && experienceState['error state'] === 'active') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XU5x")).ErrorScreenWithLogic), {
            errorInfo: context.apiErrorInfo
        });
        if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9IlT9")).DiscardScreenWithLogic), {
            state: experienceState,
            channelId: context.channelId,
            editCount: context.editCount,
            retryPromptCount: context.retryPromptCount,
            history: context.responseHistory,
            onceDiscard: context.onceDiscard
        });
        if (typeof experienceState === 'string' && experienceState === 'command palette state') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("32Eq0")).UserInputCommandPaletteWithLogic), {
            context: context,
            initialPrompt: props.initialPrompt
        });
        if (typeof experienceState === 'object' && 'loading state' in experienceState) {
            const loadingState = experienceState['loading state'];
            if (loadingState === 'loading') {
                const getLoadingMessage = (status)=>{
                    if (!status || !(0, (0, parcelRequire("2MNYo")).isConvoAIKnownMessageTemplate)(status)) return status;
                    const messageTemplate = (0, (0, parcelRequire("2nhuY")).mapLoadingStatusToMessageTemplate)(status);
                    if (messageTemplate) return formatMessage(messageTemplate);
                    return status;
                };
                const childShortTitle = context.parentPresetPromptLabel && context.configItem.nestingConfig ? formatMessage(context.configItem.nestingConfig.shortTitle) : '';
                const loadingMessage = getLoadingMessage(context?.loadingStatus);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NRaX")).LoadingScreenWithLogic), {
                    parentPresetPromptLabel: context.parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    title: loadingMessage ? loadingMessage : formatMessage((0, (0, parcelRequire("6KJH7")).messages).loadingTitle),
                    markdown: context.markdown,
                    fragment: context.fragment,
                    latestPrompt: context.latestPrompt,
                    promptTrigger: context.promptTrigger,
                    refinementCount: context.refinementCount,
                    latestPromptRetried: context.latestPromptRetried,
                    idMap: context.idMap,
                    contextStatistics: context.contextStatistics
                });
            }
        }
        if (typeof experienceState !== 'string' && 'review state' in experienceState) {
            const action = context.rovoActions ? context.rovoActions[context.configItem.selectionType] : undefined;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k7UkR")).PreviewScreenWithLogic), {
                aiExperienceMachineContext: context,
                isInputActive: experienceState['review state'] === 'refinement',
                backendModel: backendModel,
                rovoAction: action,
                rovoPublish: publish
            });
        }
        if (typeof experienceState !== 'string' && 'error state' in experienceState) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XU5x")).ErrorScreenWithLogic), {
            errorInfo: context.apiErrorInfo
        });
        throw new Error('unhandled state');
    }
    function $46c7d964b0426534$var$ExperienceApplicationStateWrapper(props) {
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const modalRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const { context: context, state: state, send: send } = (0, (0, parcelRequire("3a2e3")).useAIExperienceService)({
            context: {
                analyticsContext: props.analyticsContext,
                aiProvider: props.editorPluginAIProvider,
                intl: intl,
                editorView: props.editorView,
                positions: props.positions,
                baseGenerate: props.configItem.selectionType === 'empty' ? props.editorPluginAIProvider.emptyConfig.baseGenerate : props.editorPluginAIProvider.rangeConfig.baseGenerate,
                configItem: props.configItem,
                aiLifeCycleDynamicAttributesGetter: props.editorPluginAIProvider?.aiLifeCycleDynamicAttributesGetter,
                markdown: '',
                multiPrompts: undefined,
                latestPromptResponse: null,
                editCount: 0,
                refinementCount: 0,
                retryPromptCount: 0,
                latestPromptRetried: false,
                userInput: '',
                apiErrorInfo: {},
                responseHistory: {
                    positionFromEnd: 0,
                    entries: [],
                    totalSize: 0,
                    traversals: 0
                },
                channelId: undefined,
                getMentionNameDetails: props.getMentionNameDetails,
                triggeredFor: props.triggeredFor
            },
            endExperience: props.endExperience
        });
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            send({
                type: 'update positions',
                positions: props.positions
            });
        }, [
            send,
            props.positions
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!modalRef.current) return;
            function handleEscapeKeyDown(event) {
                if (event.key !== 'Escape') return;
                if (typeof state === 'string' || !('modal active state' in state)) return;
                event.preventDefault();
                event.stopPropagation();
                const modalActiveState = state?.['modal active state'];
                const experience = modalActiveState?.experience;
                if (typeof experience === 'object' && 'loading state' in experience && experience['loading state'] === 'loading') {
                    if (modalActiveState?.discard === 'active') send({
                        type: 'disable discard'
                    });
                    else send({
                        type: 'enable discard'
                    });
                } else send({
                    type: 'escape'
                });
            }
            function handleEscapeKeyUp(event) {
                if (event.key !== 'Escape') return;
                if (typeof state === 'string' || !('modal active state' in state)) return;
                event.preventDefault();
                event.stopPropagation();
            }
            return (0, (0, parcelRequire("cBeZP")).bindAll)(modalRef.current, [
                {
                    type: 'keydown',
                    listener: handleEscapeKeyDown
                },
                {
                    type: 'keyup',
                    listener: handleEscapeKeyUp
                }
            ]);
        }, [
            modalRef,
            state,
            send
        ]);
        const aiExperienceCommonData = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>({
                appearance: props.appearance,
                configItem: context.configItem,
                editorPluginAIProvider: props.editorPluginAIProvider,
                endExperience: props.endExperience,
                lastTriggeredFrom: props.lastTriggeredFrom,
                providerFactory: props.providerFactory,
                editorView: props.editorView,
                positions: props.positions,
                triggerMethod: props.triggerMethod,
                triggeredFor: props.triggeredFor,
                sendToAIExperienceMachine: send,
                modalRef: modalRef,
                engagementPlatformApi: props.engagementPlatformApi
            }), [
            context.configItem,
            props.editorView,
            props.editorPluginAIProvider,
            props.appearance,
            props.endExperience,
            props.lastTriggeredFrom,
            props.providerFactory,
            props.positions,
            props.triggerMethod,
            props.triggeredFor,
            props.engagementPlatformApi,
            send,
            modalRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "dialog",
            ref: modalRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Oaok")).AIExperienceCommonDataContext).Provider, {
            value: aiExperienceCommonData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($46c7d964b0426534$export$501630857d1b4132, {
            state: state,
            context: context,
            initialPrompt: props.initialPrompt
        })));
    }
    function $46c7d964b0426534$export$8b0e36b4d2610ae7(props) {
        const isInvokedFromEmptyPage = (0, (0, parcelRequire("ggL2v")).isEmptyDocument)(props.editorView.state.doc);
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useCreateAnalyticsFlow)({
            invokeAttributes: {
                invokedFrom: props.lastTriggeredFrom,
                ...(0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') ? {
                    invokedFor: props.triggeredFor ? props.triggeredFor.name : 'text'
                } : {},
                triggerMethod: props.triggerMethod,
                experienceName: props.configItem.key,
                isInvokedFromEmptyPage: isInvokedFromEmptyPage
            }
        });
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            return ()=>{
                window.requestAnimationFrame(()=>{
                    analyticsFlow.fireQueuedStep();
                });
            };
        }, [
            analyticsFlow
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            return ()=>{
                const tr = props.editorView.state.tr;
                tr.setMeta('hideSelectionPreview', true);
                props.editorView.dispatch(tr);
            };
        }, [
            props.editorView
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEAZb")).ModalRegionErrorBoundary), {
            onCloseFallback: ()=>{
                props.endExperience();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h1WZC")).AnalyticsFlowContextProvider), {
            value: analyticsFlow
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($46c7d964b0426534$var$ExperienceApplicationStateWrapper, {
            ...props,
            analyticsContext: {
                aiSessionId: analyticsFlow.aiSessionId
            }
        })));
    }
});
parcelRegister("2MNYo", function(module, exports) {
    $parcel$export(module.exports, "isConvoAIKnownMessageTemplate", ()=>$12292bb41eabbd51$export$1a5f02b8a03164a3);
    const $12292bb41eabbd51$export$6c956891ec0d52cf = {
        THUMBS_UP: 'THUMBS_UP',
        THUMBS_DOWN: 'THUMBS_DOWN',
        REVIEW_STATE_ENTERED: 'REVIEW_STATE_ENTERED',
        EXPERIENCE_COMPLETE: 'EXPERIENCE_COMPLETE'
    };
    function $12292bb41eabbd51$export$1a5f02b8a03164a3(type) {
        return [
            'ANALYSING_QUERY',
            'CONTENT_SEARCH',
            'PAGE_HYDRATION',
            'NEXT_BEST_TASK',
            'WRITING'
        ].includes(type);
    }
});
parcelRegister("hEAZb", function(module, exports) {
    $parcel$export(module.exports, "ModalRegionErrorBoundary", ()=>$bbeeaf1fcf964d8d$export$61f6bd9fac8ed53);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gkwXh;
    var $lhaxD;
    var $9m3ZB;
    var $MZH0Y;
    var $gPFN1;
    var $5tBW5;
    const $bbeeaf1fcf964d8d$export$61f6bd9fac8ed53 = (props)=>{
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bbeeaf1fcf964d8d$var$ExperienceApplicationErrorBoundaryClass, {
            ...props,
            fireAIAnalyticsEvent: fireAIAnalyticsEvent,
            formatMessage: formatMessage
        });
    };
    class $bbeeaf1fcf964d8d$var$ExperienceApplicationErrorBoundaryClass extends (0, ($parcel$interopDefault($5uXOq))).Component {
        shouldRecover() {
            return this.state.errorCaptured;
        }
        componentDidCatch(error, errorInfo) {
            if (error.name === (0, (0, parcelRequire("MZH0Y")).markdownConversionErrorName)) {
                const errorHasTypeProperty = 'type' in error;
                const errorSubType = errorHasTypeProperty ? error.type : undefined;
                this.props.fireAIAnalyticsEvent({
                    payload: {
                        action: 'unhandledErrorCaught',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'experienceApplication',
                        attributes: {
                            componentStack: errorInfo.componentStack || '',
                            errorType: 'markdownToProseMirrorError',
                            errorSubType: errorSubType,
                            errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(error)
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
                this.setState({
                    errorCaptured: true,
                    fallbackMessage: this.getFallbackMessage((0, (0, parcelRequire("5tBW5")).default).markdownErrorMessage)
                });
            } else {
                this.props.fireAIAnalyticsEvent({
                    payload: {
                        action: 'unhandledErrorCaught',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'experienceApplication',
                        attributes: {
                            componentStack: errorInfo.componentStack || '',
                            errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(error)
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
                this.setState({
                    errorCaptured: true,
                    fallbackMessage: this.getFallbackMessage((0, (0, parcelRequire("5tBW5")).default).unhandledErrorMessage)
                });
            }
        }
        render() {
            if (this.shouldRecover()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lhaxD")).UnhandledErrorScreen), {
                text: this.state.fallbackMessage,
                onCancel: this.props.onCloseFallback
            });
            return this.props.children;
        }
        constructor(...args){
            super(...args), this.getFallbackMessage = (descriptor)=>{
                return this.props.formatMessage(descriptor);
            }, this.state = {
                errorCaptured: false,
                fallbackMessage: this.getFallbackMessage((0, (0, parcelRequire("5tBW5")).default).unhandledErrorMessage)
            };
        }
    }
});
parcelRegister("lhaxD", function(module, exports) {
    $parcel$export(module.exports, "UnhandledErrorScreen", ()=>$619a3422a286bcc4$export$40729e8ab35829ea);
    var $f8Sb3;
    var $koVbs;
    var $jldZL;
    var $jmZkC;
    var $2dOLQ;
    var $8Y0Bi;
    const $619a3422a286bcc4$export$40729e8ab35829ea = ({ onCancel: onCancel, text: text })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, (0, parcelRequire("jmZkC")).useElementBreakpoints)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorFloatingContainer), {
            ref: setBreakpointsElement,
            breakpoint: breakpoint
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("8Y0Bi")).default).ariaErrorTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorMessage), {
            breakpoint: breakpoint
        }, text), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorButtonContainer), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorButton), {
            autoFocus: true,
            testId: 'cancel',
            onClick: onCancel,
            appearance: "primary"
        }, formatMessage((0, (0, parcelRequire("8Y0Bi")).default).cancelLabel))));
    };
});
parcelRegister("jmZkC", function(module, exports) {
    $parcel$export(module.exports, "Breakpoint", ()=>$3dd0513d7b22e833$export$114247090b0aae30);
    $parcel$export(module.exports, "useElementBreakpoints", ()=>$3dd0513d7b22e833$export$4d88d8cc8b24eb33);
    var $5uXOq = parcelRequire("5uXOq");
    var $iaIrC;
    var $3dd0513d7b22e833$export$114247090b0aae30;
    (function(Breakpoint) {
        Breakpoint[Breakpoint["Small"] = 320] = "Small";
        Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
    })($3dd0513d7b22e833$export$114247090b0aae30 || ($3dd0513d7b22e833$export$114247090b0aae30 = {}));
    function $3dd0513d7b22e833$export$4d88d8cc8b24eb33(smallBreakpoint = 320) {
        const [setElement, { width: width }] = (0, (0, parcelRequire("iaIrC")).useElementSize)();
        const breakpoint = width < smallBreakpoint ? smallBreakpoint : Infinity;
        return (0, $5uXOq.useMemo)(()=>[
                setElement,
                {
                    breakpoint: breakpoint,
                    isSmall: breakpoint <= smallBreakpoint,
                    isLarge: breakpoint > smallBreakpoint
                }
            ], [
            breakpoint,
            setElement,
            smallBreakpoint
        ]);
    }
});
parcelRegister("iaIrC", function(module, exports) {
    $parcel$export(module.exports, "useElementSize", ()=>$6ed486afaab248a5$export$2b86bedf890eab8);
    var $5uXOq = parcelRequire("5uXOq");
    function $6ed486afaab248a5$export$2b86bedf890eab8() {
        const [element, setElement] = (0, $5uXOq.useState)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(0);
        const [height, setHeight] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            if (!element) return;
            const updateSize = ()=>{
                const { width: width, height: height } = element.getBoundingClientRect();
                setWidth(width);
                setHeight(height);
            };
            const resizeObserver = new ResizeObserver(updateSize);
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            element
        ]);
        return (0, $5uXOq.useMemo)(()=>[
                setElement,
                {
                    width: width,
                    height: height
                }
            ], [
            width,
            height
        ]);
    }
});
parcelRegister("2dOLQ", function(module, exports) {
    $parcel$export(module.exports, "ErrorMessage", ()=>$1e986f1b99f7e94a$export$915e9e7bd4f0f96d);
    $parcel$export(module.exports, "ErrorButton", ()=>$1e986f1b99f7e94a$export$a359b30953f5499e);
    $parcel$export(module.exports, "ErrorButtonContainer", ()=>$1e986f1b99f7e94a$export$e7ce0c27e387222f);
    $parcel$export(module.exports, "ErrorFloatingContainer", ()=>$1e986f1b99f7e94a$export$f31c7963ee61af);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $eCeGD;
    var $gtreQ;
    var $cgL5K;
    var $jl6s6;
    var $8Y0Bi;
    var $dnBkY;
    function $1e986f1b99f7e94a$export$915e9e7bd4f0f96d({ children: children, breakpoint: breakpoint }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("dnBkY")).getTextContainerStyles)(breakpoint)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("dnBkY")).getIconStyles)(breakpoint)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: formatMessage((0, (0, parcelRequire("8Y0Bi")).default).warningIconLabel),
            primaryColor: (0, (0, parcelRequire("dnBkY")).iconColor)
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, children)));
    }
    function $1e986f1b99f7e94a$export$a359b30953f5499e({ children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: disabled = false }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            autoFocus: autoFocus,
            testId: testId,
            spacing: "compact",
            onClick: onClick,
            type: "button",
            appearance: appearance,
            isDisabled: disabled
        }, children);
    }
    function $1e986f1b99f7e94a$export$e7ce0c27e387222f({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("dnBkY")).buttonContainerStyles)
        }, children);
    }
    const $1e986f1b99f7e94a$export$f31c7963ee61af = (0, $5uXOq.forwardRef)(({ children: children, breakpoint: breakpoint }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jl6s6")).FloatingContainer), {
            ref: ref,
            "data-testid": "error-screen",
            className: `error-screen ${(0, $4b849073bf4278d5$export$9df59400d72ad68f)}`,
            css: (0, (0, parcelRequire("dnBkY")).getContainerStyles)(breakpoint),
            paddingAdjustments: {
                top: 1,
                bottom: 1
            },
            rainbowBorder: false
        }, children);
    });
});
const $4b849073bf4278d5$export$9df59400d72ad68f = 'ai-modal-screen';
parcelRegister("jl6s6", function(module, exports) {
    $parcel$export(module.exports, "FloatingContainer", ()=>$141585747c0599ed$export$4ddaad941c29ad29);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k0FqT;
    var $g0RiJ;
    const $141585747c0599ed$export$4ddaad941c29ad29 = (0, $5uXOq.forwardRef)(({ children: children, paddingAdjustments: paddingAdjustments, rainbowBorder: rainbowBorder = true, rainbowBorderAnimation: rainbowBorderAnimation, disablePadding: disablePadding, css: css, ...rest }, ref)=>{
        const paddingStyles = disablePadding ? null : paddingAdjustments ? (0, (0, parcelRequire("g0RiJ")).getPaddingAdjustments)(paddingAdjustments) : (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles);
        const aiThemeColor = (0, (0, parcelRequire("k0FqT")).useAIThemeColor)();
        const cssStyles = [
            (0, (0, parcelRequire("g0RiJ")).floatingContainerStyles),
            paddingStyles,
            css
        ];
        if (rainbowBorder) {
            cssStyles.push((0, (0, parcelRequire("g0RiJ")).prismBorderStyles)(aiThemeColor));
            if (rainbowBorderAnimation) cssStyles.push((0, (0, parcelRequire("g0RiJ")).prismBorderAnimationStyles));
        }
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: cssStyles,
            ...rest
        }, children));
    });
});
parcelRegister("g0RiJ", function(module, exports) {
    $parcel$export(module.exports, "prismBorderAnimationStyles", ()=>$a2bed178d4bd4910$export$a01bc07561beef67);
    $parcel$export(module.exports, "prismBorderStyles", ()=>$a2bed178d4bd4910$export$a5736548b03aac1a);
    $parcel$export(module.exports, "floatingContainerStyles", ()=>$a2bed178d4bd4910$export$8833ec6a339f43a0);
    $parcel$export(module.exports, "defaultPaddingStyles", ()=>$a2bed178d4bd4910$export$f8a8f4dcef342279);
    $parcel$export(module.exports, "getPaddingAdjustments", ()=>$a2bed178d4bd4910$export$cfd50dc61b5efbbd);
    $parcel$export(module.exports, "scrollTopMargin", ()=>$a2bed178d4bd4910$export$241bafe0360eb71d);
    $parcel$export(module.exports, "scrollMarginStyles", ()=>$a2bed178d4bd4910$export$3de32da52b6918c2);
    var $f8Sb3;
    function $a2bed178d4bd4910$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a2bed178d4bd4910$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const $a2bed178d4bd4910$var$shadowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`
    });
    const $a2bed178d4bd4910$var$rotationAnimation = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%': {
            '--gradient-angle': '0deg',
            ...$a2bed178d4bd4910$var$isFirefox ? {
                backgroundPosition: '100%'
            } : {}
        },
        '100%': {
            '--gradient-angle': '360deg',
            ...$a2bed178d4bd4910$var$isFirefox ? {
                backgroundPosition: '-100%'
            } : {}
        }
    });
    const $a2bed178d4bd4910$export$a01bc07561beef67 = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::before, &::after': {
            animation: `${$a2bed178d4bd4910$var$rotationAnimation} linear 2s infinite`,
            ...$a2bed178d4bd4910$var$isFirefox ? {
                animationDirection: 'normal',
                animationDuration: '1s'
            } : {},
            '@media (prefers-reduced-motion)': {
                animation: 'none'
            }
        }
    });
    const $a2bed178d4bd4910$export$a5736548b03aac1a = (aiThemeColor)=>(0, (0, parcelRequire("f8Sb3")).css)("@property --gradient-angle{syntax:'<angle>';initial-value:270deg;inherits:false;}position:relative;border-radius:var(--ds-border-radius-200, 6px);box-shadow:none;&::before,&::after{content:'';position:absolute;", $a2bed178d4bd4910$var$isFirefox ? `background: linear-gradient(90deg,
          ${aiThemeColor('prism.border.step.1')} 0%,
          ${aiThemeColor('prism.border.step.2')} 12%,
          ${aiThemeColor('prism.border.step.3')} 24%,
          ${aiThemeColor('prism.border.step.4')} 48%,
          ${aiThemeColor('prism.border.step.3')} 64%,
          ${aiThemeColor('prism.border.step.2')} 80%,
          ${aiThemeColor('prism.border.step.1')} 100%
        );
        background-size: 200%;` : `
      background: conic-gradient(
      from var(--gradient-angle, 270deg),
      ${aiThemeColor('prism.border.step.1')} 0%,
      ${aiThemeColor('prism.border.step.2')} 20%,
      ${aiThemeColor('prism.border.step.3')} 50%,
      ${aiThemeColor('prism.border.step.4')} 56%,
      ${aiThemeColor('prism.border.step.1')} 100%
    );`, " z-index:-1;width:calc(100% + 2px);height:calc(100% + 2px);top:-1px;left:-1px;border-radius:calc(var(--ds-border-radius-200, 6px) + 1px);transform:translate3d(0, 0, 0);}&::after{filter:blur(8px);opacity:0.5;}");
    const $a2bed178d4bd4910$var$borderStyles = {
        name: "1sqhlmr",
        styles: "border-radius:var(--ds-border-radius-200, 6px);> :first-child{border-top-left-radius:inherit;border-top-right-radius:inherit;}> :last-child{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;}"
    };
    const $a2bed178d4bd4910$var$dimensionStyles = {
        name: "1gn1jlk",
        styles: "height:100%;width:100%;box-sizing:border-box"
    };
    const $a2bed178d4bd4910$var$backgroundStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $a2bed178d4bd4910$export$8833ec6a339f43a0 = [
        $a2bed178d4bd4910$var$shadowStyles,
        $a2bed178d4bd4910$var$borderStyles,
        $a2bed178d4bd4910$var$dimensionStyles,
        $a2bed178d4bd4910$var$backgroundStyles
    ];
    const $a2bed178d4bd4910$var$defaultPadding = {
        top: 12,
        bottom: 12,
        left: 12,
        right: 12
    };
    const $a2bed178d4bd4910$export$f8a8f4dcef342279 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${$a2bed178d4bd4910$var$defaultPadding.top}px ${$a2bed178d4bd4910$var$defaultPadding.left}px`
    });
    const $a2bed178d4bd4910$export$cfd50dc61b5efbbd = (adjustments)=>{
        if (!adjustments) return null;
        const { top: top, right: right, bottom: bottom, left: left } = adjustments;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            paddingTop: `${$a2bed178d4bd4910$var$defaultPadding.top + (top ?? 0)}px`,
            paddingRight: `${$a2bed178d4bd4910$var$defaultPadding.right + (right ?? 0)}px`,
            paddingBottom: `${$a2bed178d4bd4910$var$defaultPadding.bottom + (bottom ?? 0)}px`,
            paddingLeft: `${$a2bed178d4bd4910$var$defaultPadding.left + (left ?? 0)}px`
        });
    };
    const $a2bed178d4bd4910$export$241bafe0360eb71d = 32;
    const $a2bed178d4bd4910$export$3de32da52b6918c2 = (0, (0, parcelRequire("f8Sb3")).css)({
        scrollMarginTop: `var(--ds-space-400, ${`${$a2bed178d4bd4910$export$241bafe0360eb71d}px`})`
    });
});
parcelRegister("8Y0Bi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b407e6f2ff49b3d4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b407e6f2ff49b3d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        documentInsertError: {
            id: 'fabric.editor.ai.experience-application.documentInsertError',
            defaultMessage: `We're having trouble inserting the response. Close the dialog and try again.`,
            description: 'Message to users that displays when error happens during document insertion.'
        },
        tokenLimitExceeded: {
            id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
            defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
            description: 'Message to users that displays when their request has exceeded the maximum input or output limit.'
        },
        apiError: {
            id: 'fabric.editor.ai.experience.apiError',
            defaultMessage: `We couldn\u{2019}t get a response, please try again.`,
            description: `We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)`
        },
        inputTooShortError: {
            id: 'fabric.editor.ai.experience.inputTooShortError',
            defaultMessage: `The content is too short to summarize. Please add more and try again.`,
            description: `The input was too short to summarize`
        },
        cancelLabel: {
            id: 'fabric.editor.ai.screens.error.cancelLabel',
            defaultMessage: 'Cancel',
            description: 'Label for the "Cancel" button on the "Error" screen, which allows users to close the error message and return to the previous screen'
        },
        retryLabel: {
            id: 'fabric.editor.ai.screens.error.retryLabel',
            defaultMessage: 'Try again',
            description: 'Label for the "Try again" button on the "Error" screen, which allows users to retry the failed action or process'
        },
        warningIconLabel: {
            id: 'fabric.editor.ai.screens.error.warningIconLabel',
            defaultMessage: 'Warning',
            description: 'Aria label for the warning icon on error screens'
        },
        ariaErrorTitle: {
            id: 'fabric.editor.ai.screens.error.ariaErrorTitle',
            defaultMessage: 'Error',
            description: 'Accessible title for the error screen'
        }
    });
});
parcelRegister("dnBkY", function(module, exports) {
    $parcel$export(module.exports, "getTextContainerStyles", ()=>$64b3e53526709b35$export$6d3ae856f3ad1a39);
    $parcel$export(module.exports, "iconColor", ()=>$64b3e53526709b35$export$3797a580396e3639);
    $parcel$export(module.exports, "getIconStyles", ()=>$64b3e53526709b35$export$85b8da3d52ee4014);
    $parcel$export(module.exports, "buttonContainerStyles", ()=>$64b3e53526709b35$export$98120bf687c4a90f);
    $parcel$export(module.exports, "getContainerStyles", ()=>$64b3e53526709b35$export$8947b11ec08f5f9d);
    var $f8Sb3;
    var $jmZkC;
    function $64b3e53526709b35$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $64b3e53526709b35$var$textContainerLayoutStyles = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'flex-start' : 'center',
            flex: 1,
            gap: '10px'
        });
    const $64b3e53526709b35$export$6d3ae856f3ad1a39 = (breakpoint)=>[
            $64b3e53526709b35$var$textContainerLayoutStyles(breakpoint)
        ];
    const $64b3e53526709b35$export$3797a580396e3639 = `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`;
    const $64b3e53526709b35$var$ICON_TEXT_ALIGNMENT_OFFSET = '-2px';
    const $64b3e53526709b35$export$85b8da3d52ee4014 = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
            position: 'relative',
            flexShrink: 0,
            top: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? $64b3e53526709b35$var$ICON_TEXT_ALIGNMENT_OFFSET : '0'
        });
    const $64b3e53526709b35$export$98120bf687c4a90f = {
        name: "1rz2qr1",
        styles: "display:flex;flex-wrap:wrap;flex-direction:row;justify-content:flex-end;align-items:center;gap:var(--ds-space-100, 8px)"
    };
    const $64b3e53526709b35$export$8947b11ec08f5f9d = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'column' : 'row',
            gap: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? '16px' : '8px'
        });
});
parcelRegister("MZH0Y", function(module, exports) {
    $parcel$export(module.exports, "markdownConversionErrorName", ()=>$8d94f6d48b5d522a$export$8a78f5c7307b478b);
    $parcel$export(module.exports, "MarkdownConversionError", ()=>$8d94f6d48b5d522a$export$6c16da0c287c00c);
    const $8d94f6d48b5d522a$export$8a78f5c7307b478b = 'MarkdownConversionError';
    class $8d94f6d48b5d522a$export$6c16da0c287c00c extends Error {
        constructor({ message: message, type: type }){
            super(message);
            this.name = $8d94f6d48b5d522a$export$8a78f5c7307b478b;
            this.type = type;
        }
    }
});
parcelRegister("5tBW5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f17a47ab3b285c40$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f17a47ab3b285c40$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unhandledErrorMessage: {
            id: 'fabric.editor.ai.experience-application.unhandledErrorMessage',
            defaultMessage: "We're having trouble. Close the dialog and try again.",
            description: 'Message to users that displays when an unexpected error happens'
        },
        markdownErrorMessage: {
            id: 'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage',
            defaultMessage: "We're having trouble generating the preview. Close the dialog and try again.",
            description: 'Message to users that displays when an error occurs while generating a preview.'
        }
    });
});
parcelRegister("6KJH7", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$c7b7c39ea5361c37$export$defe85febe8b728c);
    var $7VHMR;
    const $c7b7c39ea5361c37$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        responseTooSimilarMessage: {
            id: 'fabric.editor.ai.experience.responseTooSimilarMessage',
            defaultMessage: 'Atlassian Intelligence has no suggestions at this time. Feel free to try a different prompt or content.',
            description: 'Message to indicate to user the response from Atlassian Intelligence response is too similar or the same as their input.'
        },
        discardMessagePrompt: {
            id: 'fabric.editor.ai.experience.discardMessagePrompt',
            defaultMessage: 'Do you want to discard your prompt?',
            description: 'Message to confirm if the user wants to discard their input.'
        },
        discardMessageResponse: {
            id: 'fabric.editor.ai.experience.discardMessageResponse',
            defaultMessage: 'Do you want to discard your response?',
            description: 'Message to confirm if the user wants to discard the generated response from Atlassian Intelligence.'
        },
        loadingTitle: {
            id: 'fabric.editor.ai.experience.loadingTitle',
            defaultMessage: 'Generating',
            description: 'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content'
        },
        messageTemplateAnalysingQuery: {
            id: 'fabric.editor.ai.experience.messageTemplateAnalysingQuery',
            defaultMessage: 'Analyzing: Reviewing your question.',
            description: 'Message to indicate to user that the AI is reading and understanding their question'
        },
        messageTemplateContentSearch: {
            id: 'fabric.editor.ai.experience.messageTemplateContentSearch',
            defaultMessage: 'Searching: One moment while we search for information.',
            description: 'Message to indicate to user that the AI is searching for content'
        },
        messageTemplatePageHydration: {
            id: 'fabric.editor.ai.experience.messageTemplatePageHydration',
            defaultMessage: 'Searching: One moment while we search the page.',
            description: 'Message to indicate to user that the AI is searching a URL for content'
        },
        messageTemplateNextBestTask: {
            id: 'fabric.editor.ai.experience.messageTemplateNextBestTask',
            defaultMessage: 'Searching: One moment while we search Jira.',
            description: 'Message to indicate to user that the AI is searching Jira'
        },
        convoAIBeta: {
            id: 'fabric.editor.ai.screens.preview.convoAIBeta',
            defaultMessage: 'Content generation requests that reference URLs is in beta.',
            description: 'The disclaimer for convo ai beta lozenge'
        },
        useRovoOrganisationKnowledgeRightText: {
            id: 'fabric.editor.ai.experience.labelRight.rovo',
            defaultMessage: 'Rovo',
            description: 'Righthand side text for Atlassian Intelligence general knowledge suggestion'
        },
        useGeneralAiKnowledgeRightText: {
            id: 'fabric.editor.ai.experience.labelRight.atlassianIntelligence',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Righthand side text for Rovo general knowledge suggestion'
        },
        atlassianIntelligenceGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence',
            defaultMessage: 'Atlassian intelligence',
            description: 'Heading text to indicate that the next set of features are for Atlassian intelligence'
        },
        knowledgeSourceGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource',
            defaultMessage: 'Knowledge source',
            description: 'Heading text to indicate that the next set of features are for Knowledge source'
        },
        agentsSuggestionGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.agents',
            defaultMessage: 'Agents',
            description: 'Heading text to indicate that the next set of features are for agents'
        },
        rovoAgentsCountSuggestionGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount',
            defaultMessage: `Rovo agents ({numberOfAgents})`,
            description: 'Heading text to indicate that the next set of features are for starred agents'
        },
        useRovoAgentsCountSuggestionGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount',
            defaultMessage: `Use a Rovo agent ({numberOfAgents})`,
            description: 'Heading text to indicate that the next set of features are for starred agents'
        },
        rovoAgentsSuggestionGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents',
            defaultMessage: 'Rovo agents',
            description: 'Heading text to indicate that the next set of features are for agents'
        },
        prefillPromptsGroupHeading: {
            id: 'fabric.editor.ai.experience.suggestionGroupHeading.prefillPrompts',
            defaultMessage: 'Draft',
            description: 'Heading text to indicate that the next set of features will help users draft their page'
        },
        prefillPromptsTrailingIndication: {
            id: 'fabric.editor.ai.experience.prefillPromptsTrailingIndication',
            defaultMessage: '...',
            description: 'This will be shown after certain types of AI prompts - trailing punctuation such as ellipsis will indicate that the user can continue the prompt.'
        },
        useGeneralAiKnowledgeLabel: {
            id: 'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel',
            defaultMessage: 'Use general knowledge',
            description: 'Label for the button to write using general AI knowledge'
        },
        useRovoOrganisationKnowledgeLabel: {
            id: 'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel',
            defaultMessage: 'Use knowledge from your organization',
            description: 'Label for the button to ask using Rovo organisation knowledge'
        },
        agentsFooterRightText: {
            id: 'fabric.editor.ai.experience.footerRightText.agents',
            defaultMessage: 'Powered by Rovo',
            description: 'Label text for Rovo footer icon'
        },
        agentsBrowseMore: {
            id: 'fabric.editor.ai.experience.browseMore.agents',
            defaultMessage: 'Browse Agents',
            description: 'Link text to browse more agents'
        },
        showMoreButton: {
            id: 'fabric.editor.ai.experience.showMoreButton',
            defaultMessage: 'Show more',
            description: 'Link text for the Show more button which is shown when hiding extra suggestions'
        },
        noResultsSuggestion: {
            id: 'fabric.editor.ai.experience.noResultsSuggestion',
            defaultMessage: 'No results',
            description: 'Text which displays when a nested set of results has no search results'
        },
        insertProactiveRecommentation: {
            id: 'fabric.editor.ai.experience.insertProactiveRecommentation',
            defaultMessage: 'Replace',
            description: 'Label for button to replace selection with proactive recommendation'
        },
        dismissProactiveRecommentation: {
            id: 'fabric.editor.ai.experience.dismissProactiveRecommentation.non-final',
            defaultMessage: 'Dismiss',
            description: 'Label for button to dismiss the proactive recommendation'
        },
        engagementBannerLinksText: {
            id: 'fabric.editor.ai.experience.engagementBannerLinksText',
            defaultMessage: "\uD83D\uDE80 You can now paste links \uD83D\uDD17 to Jira and Confluence content in your prompts.",
            description: 'Text for the engagement banner'
        }
    });
});
parcelRegister("9IlT9", function(module, exports) {
    $parcel$export(module.exports, "DiscardScreenWithLogic", ()=>$38d62b55a7722f01$export$643e9e046f871343);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $cWmjS;
    var $kb0r3;
    var $h1WZC;
    var $9m3ZB;
    var $6KJH7;
    var $8Oaok;
    const $38d62b55a7722f01$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
        const discardPrompt = formatMessage((0, (0, parcelRequire("6KJH7")).messages).discardMessagePrompt);
        const discardResponse = formatMessage((0, (0, parcelRequire("6KJH7")).messages).discardMessageResponse);
        if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
        if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardResponse;
        return discardResponse;
    };
    function $38d62b55a7722f01$export$643e9e046f871343({ state: state, editCount: editCount, retryPromptCount: retryPromptCount, history: history, onceDiscard: onceDiscard, channelId: channelId }) {
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, configItem: configItem } = aiExperienceCommonData;
        const inputOutputDiffRatio = (0, $5uXOq.useMemo)(()=>{
            const lastHistoryEvent = history.entries[history.positionFromEnd];
            return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
        }, [
            history
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlowEventsQueue)({
            stepName: 'discard',
            attributes: {
                editCount: editCount,
                retryPromptCount: retryPromptCount,
                inputOutputDiffRatio: inputOutputDiffRatio,
                history: {
                    totalSize: history.totalSize,
                    length: history.entries.length,
                    lastDepth: history.positionFromEnd,
                    traversals: history.traversals
                }
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cWmjS")).DiscardScreen), {
            text: $38d62b55a7722f01$export$28146c614df26dc4({
                formatMessage: formatMessage,
                experienceState: state
            }),
            onCancel: function() {
                sendToAIExperienceMachine({
                    type: 'disable discard'
                });
            },
            onDiscard: function() {
                fireAIAnalyticsEvent({
                    payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('dismissed', channelId ?? analyticsFlow.getLastAiInteractionId(), (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()), false, analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }))
                });
                if (onceDiscard) {
                    sendToAIExperienceMachine({
                        type: 'disable discard'
                    });
                    onceDiscard();
                } else endExperience();
            }
        });
    }
});
parcelRegister("cWmjS", function(module, exports) {
    $parcel$export(module.exports, "DiscardScreen", ()=>$d68e7d42075fcdbe$export$453c0e2ebf820c66);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $eCeGD;
    var $gtreQ;
    var $cgL5K;
    var $jldZL;
    var $jl6s6;
    var $g0RiJ;
    var $jmZkC;
    var $iRPdL;
    var $1XkyX;
    const $d68e7d42075fcdbe$export$453c0e2ebf820c66 = ({ onCancel: onCancel, onDiscard: onDiscard, text: text })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [containerElement, setContainerElement] = (0, $5uXOq.useState)(null);
        const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, (0, parcelRequire("jmZkC")).useElementBreakpoints)();
        const setRootContainer = (element)=>{
            setContainerElement(element);
            setBreakpointsElement(element);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (containerElement) containerElement.scrollIntoView({
                block: 'nearest'
            });
        }, [
            containerElement
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jl6s6")).FloatingContainer), {
            ref: setRootContainer,
            "data-testid": "discard-screen",
            className: `discard-screen ${(0, $4b849073bf4278d5$export$9df59400d72ad68f)}`,
            css: [
                (0, (0, parcelRequire("1XkyX")).getContainerStyles)(breakpoint),
                (0, (0, parcelRequire("g0RiJ")).scrollMarginStyles)
            ],
            paddingAdjustments: {
                top: 1,
                bottom: 1
            },
            rainbowBorder: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("iRPdL")).default).warningIconLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("1XkyX")).getTextContainerStyles)(breakpoint)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("1XkyX")).getIconStyles)(breakpoint)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
            label: formatMessage((0, (0, parcelRequire("iRPdL")).default).warningIconLabel),
            primaryColor: (0, (0, parcelRequire("1XkyX")).iconColor)
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, text)), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("1XkyX")).buttonContainerStyles)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            testId: "cancel-button",
            spacing: "compact",
            onClick: onCancel,
            type: "button",
            appearance: "subtle"
        }, formatMessage((0, (0, parcelRequire("iRPdL")).default).cancelLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            autoFocus: true,
            testId: "discard-button",
            spacing: "compact",
            onClick: onDiscard,
            type: "button",
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("iRPdL")).default).discardLabel))));
    };
});
parcelRegister("iRPdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a690f8469a57ef87$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a690f8469a57ef87$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelLabel: {
            id: 'fabric.editor.ai.screens.discard.cancelLabel',
            defaultMessage: 'Back',
            description: 'Text for the "Back" button on the "Discard Warning" screen, used to prevent discarding changes and return to the previous screen'
        },
        discardLabel: {
            id: 'fabric.editor.ai.screens.discard.discardLabel',
            defaultMessage: 'Discard',
            description: 'Text for the "Discard" button on the "Discard Warning" screen, used to confirm the user intention to discard unsaved changes, whether in relation to prompt input or a generated response. The term should convey the meaning of intentionally discarding or abandoning the modifications made or the generated content.'
        },
        warningIconLabel: {
            id: 'fabric.editor.ai.screens.discard.warningIconLabel',
            defaultMessage: 'Warning',
            description: 'Aria label for the warning icon on the "Discard Warning" screen'
        }
    });
});
parcelRegister("1XkyX", function(module, exports) {
    $parcel$export(module.exports, "getTextContainerStyles", ()=>$2fd47e654f5c3ec5$export$6d3ae856f3ad1a39);
    $parcel$export(module.exports, "iconColor", ()=>$2fd47e654f5c3ec5$export$3797a580396e3639);
    $parcel$export(module.exports, "getIconStyles", ()=>$2fd47e654f5c3ec5$export$85b8da3d52ee4014);
    $parcel$export(module.exports, "buttonContainerStyles", ()=>$2fd47e654f5c3ec5$export$98120bf687c4a90f);
    $parcel$export(module.exports, "getContainerStyles", ()=>$2fd47e654f5c3ec5$export$8947b11ec08f5f9d);
    var $f8Sb3;
    var $jmZkC;
    function $2fd47e654f5c3ec5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2fd47e654f5c3ec5$var$textContainerLayoutStyles = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'flex-start' : 'center',
            flex: 1,
            gap: '10px'
        });
    const $2fd47e654f5c3ec5$export$6d3ae856f3ad1a39 = (breakpoint)=>[
            $2fd47e654f5c3ec5$var$textContainerLayoutStyles(breakpoint)
        ];
    const $2fd47e654f5c3ec5$export$3797a580396e3639 = `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`;
    const $2fd47e654f5c3ec5$var$ICON_TEXT_ALIGNMENT_OFFSET = '-2px';
    const $2fd47e654f5c3ec5$export$85b8da3d52ee4014 = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
            position: 'relative',
            flexShrink: 0,
            top: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? $2fd47e654f5c3ec5$var$ICON_TEXT_ALIGNMENT_OFFSET : '0'
        });
    const $2fd47e654f5c3ec5$export$98120bf687c4a90f = {
        name: "1rz2qr1",
        styles: "display:flex;flex-wrap:wrap;flex-direction:row;justify-content:flex-end;align-items:center;gap:var(--ds-space-100, 8px)"
    };
    const $2fd47e654f5c3ec5$export$8947b11ec08f5f9d = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'column' : 'row',
            gap: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? '16px' : '8px'
        });
});
parcelRegister("8Oaok", function(module, exports) {
    $parcel$export(module.exports, "AIExperienceCommonDataContext", ()=>$ae9036ed0ce952b1$export$cad72db1c520741c);
    $parcel$export(module.exports, "useAIExperienceCommonDataContext", ()=>$ae9036ed0ce952b1$export$28c15afa0bc9f86b);
    var $5uXOq = parcelRequire("5uXOq");
    const $ae9036ed0ce952b1$export$cad72db1c520741c = (0, ($parcel$interopDefault($5uXOq))).createContext(null);
    const $ae9036ed0ce952b1$export$28c15afa0bc9f86b = ()=>{
        const contextData = (0, ($parcel$interopDefault($5uXOq))).useContext($ae9036ed0ce952b1$export$cad72db1c520741c);
        if (!contextData) throw new Error('Attempted to access AIExperienceCommonDataContext before its value is set');
        return contextData;
    };
});
parcelRegister("6XU5x", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreenWithLogic", ()=>$da27259bcc4ed6d8$export$eec2740903046434);
    var $5uXOq = parcelRequire("5uXOq");
    var $hQsVr;
    var $h1WZC;
    var $8Oaok;
    var $3qS4c;
    var $48T0b;
    function $da27259bcc4ed6d8$export$eec2740903046434({ errorInfo: errorInfo }) {
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine } = aiExperienceCommonData;
        (0, (0, parcelRequire("h1WZC")).useAnalyticsFlowEventsQueue)({
            stepName: (0, (0, parcelRequire("3qS4c")).getStepName)(errorInfo),
            attributes: {
                errorType: errorInfo.failureReason ?? (0, (0, parcelRequire("48T0b")).FAILURE_REASON).UNKNOWN,
                sawAupViolation: errorInfo.failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
                ...errorInfo
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hQsVr")).ErrorScreen), {
            text: (0, (0, parcelRequire("3qS4c")).ErrorMessage)(errorInfo),
            onCancel: ()=>endExperience(),
            onRetry: ()=>sendToAIExperienceMachine({
                    type: 'retry'
                }),
            showRetryButton: (0, (0, parcelRequire("3qS4c")).retryEnabled)(errorInfo)
        });
    }
});
parcelRegister("hQsVr", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreen", ()=>$a3513042e81889e7$export$42f84e610f279c31);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $jldZL;
    var $jmZkC;
    var $2dOLQ;
    var $8Y0Bi;
    const $a3513042e81889e7$export$42f84e610f279c31 = ({ onCancel: onCancel, onRetry: onRetry, text: text, showRetryButton: showRetryButton = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, (0, parcelRequire("jmZkC")).useElementBreakpoints)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorFloatingContainer), {
            ref: setBreakpointsElement,
            breakpoint: breakpoint
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("8Y0Bi")).default).ariaErrorTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorMessage), {
            breakpoint: breakpoint
        }, text), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorButtonContainer), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorButton), {
            autoFocus: true,
            testId: "cancel-button",
            onClick: onCancel,
            appearance: onRetry && showRetryButton ? 'subtle' : 'primary'
        }, formatMessage((0, (0, parcelRequire("8Y0Bi")).default).cancelLabel)), onRetry && showRetryButton && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2dOLQ")).ErrorButton), {
            testId: 'retry',
            onClick: onRetry,
            appearance: "primary"
        }, formatMessage((0, (0, parcelRequire("8Y0Bi")).default).retryLabel))));
    };
});
parcelRegister("3qS4c", function(module, exports) {
    $parcel$export(module.exports, "retryEnabled", ()=>$a9f8ec3a618ba117$export$27eceeaa1726619e);
    $parcel$export(module.exports, "getStepName", ()=>$a9f8ec3a618ba117$export$accc136c77ec5dfa);
    $parcel$export(module.exports, "ErrorMessage", ()=>$a9f8ec3a618ba117$export$915e9e7bd4f0f96d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $cgL5K;
    var $10VaV;
    var $48T0b;
    const $a9f8ec3a618ba117$var$knownErrorMessages = {
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).UNKNOWN]: (0, (0, parcelRequire("10VaV")).default).documentInsertError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).TOKEN_LIMIT]: (0, (0, parcelRequire("10VaV")).default).tokenLimitExceeded,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).INSERT_FAILURE]: (0, (0, parcelRequire("10VaV")).default).documentInsertError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).INPUT_TOO_SHORT]: (0, (0, parcelRequire("10VaV")).default).inputTooShortError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).HIPAA_CONTENT]: (0, (0, parcelRequire("10VaV")).default).hipaaContentError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED]: (0, (0, parcelRequire("10VaV")).default).rateLimitEnforced,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION]: (0, (0, parcelRequire("10VaV")).default).aupViolationMessage,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).ELEVATE_DISABLED_GENERATE]: (0, (0, parcelRequire("10VaV")).default).elevateDisabledGenerateError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).INTERNAL_SERVER_ERROR]: (0, (0, parcelRequire("10VaV")).default).internalServerError,
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL]: (0, (0, parcelRequire("10VaV")).default).apiError
    };
    const $a9f8ec3a618ba117$export$5efe5b9065b71976 = {
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).INTERNAL_SERVER_ERROR]: 'https://status.atlassian.com/',
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION]: 'https://www.atlassian.com/legal/acceptable-use-policy',
        [(0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED]: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/'
    };
    const $a9f8ec3a618ba117$var$LinkedMessage = ({ error: error, documentationUrl: documentationUrl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...$a9f8ec3a618ba117$var$knownErrorMessages[error],
            values: {
                link: (message)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: documentationUrl,
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, message)
            }
        });
    const $a9f8ec3a618ba117$var$is5xxErrorRange = (statusCode)=>statusCode >= 500 && statusCode < 600;
    const $a9f8ec3a618ba117$export$27eceeaa1726619e = ({ failureReason: failureReason, statusCode: statusCode = 500 })=>failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL && !$a9f8ec3a618ba117$var$is5xxErrorRange(statusCode) && statusCode !== 9001;
    const $a9f8ec3a618ba117$export$accc136c77ec5dfa = ({ apiName: apiName, failureReason: failureReason })=>{
        return apiName === 'assistance-service' || failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION || failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL ? 'apiError' : 'failed';
    };
    const $a9f8ec3a618ba117$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, failureReason: failureReason, statusCode: statusCode })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isConvoAIServerError = [
            'FEATURE_DISABLED',
            'FEATURE_DISABLED_ON_SITE',
            'NO_AGENT'
        ].includes(errorKey || '');
        if (statusCode === 9001) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage($a9f8ec3a618ba117$var$knownErrorMessages['elevate disabled generate']));
        if (statusCode && $a9f8ec3a618ba117$var$is5xxErrorRange(statusCode) || isConvoAIServerError || failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).INTERNAL_SERVER_ERROR) return (0, ($parcel$interopDefault($5uXOq))).createElement($a9f8ec3a618ba117$var$LinkedMessage, {
            error: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).INTERNAL_SERVER_ERROR,
            documentationUrl: $a9f8ec3a618ba117$export$5efe5b9065b71976[(0, (0, parcelRequire("48T0b")).FAILURE_REASON).INTERNAL_SERVER_ERROR]
        });
        if (!failureReason) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage($a9f8ec3a618ba117$var$knownErrorMessages['unknown fail']));
        if (failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION) return (0, ($parcel$interopDefault($5uXOq))).createElement($a9f8ec3a618ba117$var$LinkedMessage, {
            error: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
            documentationUrl: $a9f8ec3a618ba117$export$5efe5b9065b71976[(0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION]
        });
        if (failureReason === (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED) return (0, ($parcel$interopDefault($5uXOq))).createElement($a9f8ec3a618ba117$var$LinkedMessage, {
            error: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED,
            documentationUrl: $a9f8ec3a618ba117$export$5efe5b9065b71976[(0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED]
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), null, formatMessage($a9f8ec3a618ba117$var$knownErrorMessages[failureReason]));
    };
});
parcelRegister("48T0b", function(module, exports) {
    $parcel$export(module.exports, "FAILURE_REASON", ()=>$bc7c9216c8322e2f$export$ab58f948d2b5b95c);
    var $bc7c9216c8322e2f$export$ab58f948d2b5b95c;
    (function(FAILURE_REASON) {
        FAILURE_REASON["API_FAIL"] = "api fail";
        FAILURE_REASON["AUP_VIOLATION"] = "aup violation detected";
        FAILURE_REASON["UNKNOWN"] = "unknown fail";
        FAILURE_REASON["TOKEN_LIMIT"] = "token limit fail";
        FAILURE_REASON["INSERT_FAILURE"] = "insert failure";
        FAILURE_REASON["INPUT_TOO_SHORT"] = "input too short fail";
        FAILURE_REASON["HIPAA_CONTENT"] = "hipaa content fail";
        FAILURE_REASON["RATE_LIMITED"] = "rate limited";
        FAILURE_REASON["INTERNAL_SERVER_ERROR"] = "internal server error";
        FAILURE_REASON["ELEVATE_DISABLED_GENERATE"] = "elevate disabled generate";
    })($bc7c9216c8322e2f$export$ab58f948d2b5b95c || ($bc7c9216c8322e2f$export$ab58f948d2b5b95c = {}));
});
parcelRegister("7NRaX", function(module, exports) {
    $parcel$export(module.exports, "LoadingScreenWithLogic", ()=>$2ea737b39d09e367$export$9c279fd5d5bced59);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $koVbs;
    var $f3dKD;
    var $gmhCD = parcelRequire("gmhCD");
    var $5xAgE;
    var $6FtDr;
    var $g0RiJ;
    var $h1WZC;
    var $9m3ZB;
    var $PwAM5;
    var $falJd;
    var $2akUm;
    var $8Oaok;
    var $gHhcU;
    const $2ea737b39d09e367$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area';
    function $2ea737b39d09e367$export$9c279fd5d5bced59({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, refinementCount: refinementCount, latestPromptRetried: latestPromptRetried, markdown: markdown, fragment: fragment, idMap: idMap, contextStatistics: contextStatistics }) {
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { configItem: configItem, editorView: editorView, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, editorPluginAIProvider: editorPluginAIProvider } = aiExperienceCommonData;
        const schema = editorView.state.schema;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const disclaimer = (0, (0, parcelRequire("gHhcU")).useAIUsageDisclaimer)({
            editorPluginAIProvider: editorPluginAIProvider
        });
        const presetPromptLabel = (0, (0, parcelRequire("PwAM5")).getTranslatedPromptLabel)(configItem, formatMessage);
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const [preview, setPreview] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const [hasPreview, setHasPreview] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const containerRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const raf = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const errorReported = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const scrollParentRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const initialScrollTop = (0, ($parcel$interopDefault($5uXOq))).useRef(0);
        const modalOffsetTop = (0, ($parcel$interopDefault($5uXOq))).useRef(0);
        const isUserScroll = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const isProgrammaticScroll = (0, ($parcel$interopDefault($5uXOq))).useRef(true);
        const isModalAtTop = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const scrollModalAlignBottom = (0, ($parcel$interopDefault($5uXOq))).useCallback((modalEl, scrollParentEl)=>{
            isProgrammaticScroll.current = true;
            scrollParentEl.scroll({
                top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
                behavior: 'instant'
            });
        }, []);
        const scrollModalToTop = (0, ($parcel$interopDefault($5uXOq))).useCallback((scrollParentEl)=>{
            isProgrammaticScroll.current = true;
            scrollParentEl.scroll({
                top: initialScrollTop.current + modalOffsetTop.current - (0, (0, parcelRequire("g0RiJ")).scrollTopMargin),
                behavior: 'instant'
            });
        }, []);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const editorContentArea = editorView.dom.closest($2ea737b39d09e367$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
            if (!editorContentArea) return;
            const resizeObserver = new ResizeObserver(()=>{
                isProgrammaticScroll.current = true;
            });
            resizeObserver.observe(editorContentArea);
            return ()=>resizeObserver.unobserve(editorContentArea);
        }, [
            editorView
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const modalEl = containerRef.current;
            if (!modalEl) return;
            const scrollParentEl = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(modalEl);
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
            modalOffsetTop.current = modalEl.getBoundingClientRect().top - scrollParentEl.getBoundingClientRect().top;
            initialScrollTop.current = scrollParentEl.scrollTop;
            const modalBottomOffsetTop = modalOffsetTop.current + modalEl.scrollHeight;
            if (modalBottomOffsetTop < 0) scrollModalToTop(scrollParentEl);
            else if (modalOffsetTop.current > scrollParentEl.offsetHeight) scrollModalAlignBottom(modalEl, scrollParentEl);
            const unbind = (0, (0, parcelRequire("cBeZP")).bind)(scrollParentEl, {
                type: 'scroll',
                listener: ()=>{
                    if (!isProgrammaticScroll.current) {
                        isUserScroll.current = true;
                        unbind();
                    }
                    isProgrammaticScroll.current = false;
                }
            });
            return unbind;
        }, [
            scrollModalToTop,
            scrollModalAlignBottom
        ]);
        function scrollModalIntoView() {
            if (isUserScroll.current || isModalAtTop.current) return;
            const modalEl = containerRef.current;
            if (!modalEl) return;
            const scrollParentEl = scrollParentRef.current;
            if (!scrollParentEl) return;
            const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight;
            const isModalFullHeight = scrollParentEl.offsetHeight - (0, (0, parcelRequire("g0RiJ")).scrollTopMargin) < modalEl.scrollHeight;
            if (isModalFullyVisible) return;
            if (isModalFullHeight) {
                scrollModalToTop(scrollParentEl);
                isModalAtTop.current = true;
                return;
            }
            scrollModalAlignBottom(modalEl, scrollParentEl);
        }
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
                let _preview;
                raf.current = undefined;
                if (!markdown || markdown === '') _preview = undefined;
                else {
                    const { pmFragment: pmFragment } = (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') && fragment ? {
                        pmFragment: fragment
                    } : (0, (0, parcelRequire("2akUm")).getPMFragmentWithFallback)({
                        markdown: markdown,
                        schema: schema,
                        source: 'loading',
                        fireAIAnalyticsEvent: (event)=>{
                            if (!errorReported.current) {
                                errorReported.current = true;
                                fireAIAnalyticsEvent(event);
                            }
                        },
                        idMap: idMap
                    });
                    if ((0, (0, parcelRequire("5xAgE")).isMarkdownEndingWithCustomTag)(markdown)) return;
                    _preview = (0, (0, parcelRequire("falJd")).convertPMFragmentToPreview)({
                        schema: schema,
                        pmFragment: pmFragment,
                        showTelepointer: true,
                        providerFactory: providerFactory
                    });
                    setPreview(_preview);
                    setHasPreview(true);
                    window.requestAnimationFrame(()=>{
                        scrollModalIntoView();
                    });
                }
            });
        }, [
            markdown
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            return ()=>{
                if (raf.current) window.cancelAnimationFrame(raf.current);
            };
        }, []);
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlowEventsQueue)({
            stepName: 'loading',
            attributes: {
                promptType: promptTrigger,
                latestPromptRetried: latestPromptRetried,
                refinementCount: refinementCount,
                modelIO: {
                    contextStatistics: contextStatistics
                }
            }
        });
        const previewBecameAvailable = (0, ($parcel$interopDefault($5uXOq))).useRef();
        if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const noPreviewAvailable = performance.now();
            return ()=>{
                if (!previewBecameAvailable.current) return;
                analyticsFlow.addAttributes({
                    durations: {
                        timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                        timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                    }
                });
            };
        }, []);
        const localizedLatestPrompt = latestPrompt?.presetTitle ? {
            presetTitle: (0, (0, parcelRequire("PwAM5")).getTranslatedItemTitle)(latestPrompt.presetTitle, formatMessage),
            userInput: latestPrompt?.userInput,
            userADFInput: latestPrompt?.userADFInput
        } : {
            userInput: latestPrompt?.userInput || '',
            userADFInput: latestPrompt?.userADFInput
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: containerRef,
            css: (0, (0, parcelRequire("g0RiJ")).scrollMarginStyles)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6FtDr")).LoadingScreen), {
            parentPresetPromptLabel: parentPresetPromptLabel,
            childShortTitle: childShortTitle,
            presetPromptLabel: presetPromptLabel,
            latestPrompt: localizedLatestPrompt,
            agent: configItem?.agent,
            title: title,
            preview: preview,
            providerFactory: providerFactory,
            disclaimer: disclaimer,
            onCancel: ()=>{
                sendToAIExperienceMachine({
                    type: 'enable discard'
                });
            },
            schema: schema
        })));
    }
});
parcelRegister("5xAgE", function(module, exports) {
    $parcel$export(module.exports, "isMarkdownEndingWithCustomTag", ()=>$61db52776f24b110$export$bde720e3489117f9);
    const $61db52776f24b110$export$bde720e3489117f9 = (markdown)=>{
        return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>|.*\/>).*?)?)?)?)?)?)?$/g);
    };
});
parcelRegister("6FtDr", function(module, exports) {
    $parcel$export(module.exports, "LoadingScreen", ()=>$9ef232ca6df690ed$export$e2b0760399e6dece);
    var $f8Sb3;
    var $koVbs;
    var $gmhCD = parcelRequire("gmhCD");
    var $jldZL;
    var $010fk;
    var $6hhgl;
    var $jl6s6;
    var $g0RiJ;
    var $2gMC9;
    var $99dxo;
    var $8azQn;
    var $8699W;
    var $8l16K;
    const $9ef232ca6df690ed$export$e2b0760399e6dece = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, presetPromptLabel: presetPromptLabel, title: title, latestPrompt: latestPrompt, preview: preview, providerFactory: providerFactory, schema: schema, onCancel: onCancel, agent: agent, disclaimer: disclaimer, additionalFooterText: additionalFooterText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jl6s6")).FloatingContainer), {
            "data-testid": "loading-screen",
            className: `loading-screen ${(0, $4b849073bf4278d5$export$9df59400d72ad68f)}`,
            rainbowBorderAnimation: true,
            disablePadding: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("8699W")).default).loadingAriaTitle)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("99dxo")).LatestPromptHeader), {
            parentPresetPromptLabel: parentPresetPromptLabel,
            childShortTitle: childShortTitle,
            prompt: latestPrompt?.userInput,
            promptADF: latestPrompt?.userADFInput,
            presetTitle: latestPrompt?.presetTitle,
            providerFactory: providerFactory,
            schema: schema,
            agent: agent,
            showBack: true
        }), preview && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": "adf-content-live-region",
            "aria-atomic": "false",
            "aria-live": "polite",
            css: [
                (0, (0, parcelRequire("8l16K")).previewContainer),
                (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles),
                (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') && (0, (0, parcelRequire("8azQn")).layoutBorderStyles)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), {
            testId: "description"
        }, formatMessage((0, (0, parcelRequire("8699W")).default).liveRegionDescription)), preview), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles),
                (0, (0, parcelRequire("8l16K")).layoutStyles)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": "loading-icon",
            css: (0, (0, parcelRequire("8l16K")).logoStyles)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("010fk")).default), {
            alt: formatMessage((0, (0, parcelRequire("8699W")).default).iconAltText)
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("8l16K")).titleStyles)
        }, title), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6hhgl")).CancelEscButton), {
            autoFocus: true,
            onCancel: onCancel
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2gMC9")).Footer), {
            brand: agent ? 'rovo' : 'atlassian-intelligence',
            disclaimer: disclaimer,
            showDisclaimer: true
        }));
    };
});
parcelRegister("010fk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d86448560d520649$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k0FqT;
    const $d86448560d520649$var$Loading = (props)=>{
        const aiThemeColor = (0, (0, parcelRequire("k0FqT")).useAIThemeColor)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("title", null, props.alt), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "5.5",
            cy: "12.5",
            r: "1.5",
            fill: aiThemeColor('loading.step.1')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            attributeName: "cy",
            values: "11;13;13;13;13;13;13;11",
            dur: "1s",
            repeatCount: "indefinite",
            begin: "0s"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "11.5",
            cy: "10.5",
            r: "1.5",
            fill: aiThemeColor('loading.step.2')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            attributeName: "cy",
            values: "11;13;13;13;13;13;13;11",
            dur: "1s",
            repeatCount: "indefinite",
            begin: "0.2s"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("circle", {
            cx: "17.5",
            cy: "12.5",
            r: "1.5",
            fill: aiThemeColor('loading.step.3')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            attributeName: "cy",
            values: "11;13;13;13;13;13;13;11",
            dur: "1s",
            repeatCount: "indefinite",
            begin: "0.4s"
        })));
    };
    var $d86448560d520649$export$2e2bcd8739ae039 = $d86448560d520649$var$Loading;
});
parcelRegister("6hhgl", function(module, exports) {
    $parcel$export(module.exports, "CancelEscButton", ()=>$0535aea5bc7081c0$export$d17714f4f279b358);
    var $f8Sb3;
    var $koVbs;
    var $eCeGD;
    var $9HL9L;
    var $dprZD;
    const $0535aea5bc7081c0$export$d17714f4f279b358 = ({ onCancel: onCancel, autoFocus: autoFocus })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            autoFocus: autoFocus,
            testId: "cancel-esc-button",
            type: "button",
            onClick: onCancel
        }, formatMessage((0, (0, parcelRequire("9HL9L")).default).labelCancel), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("dprZD")).escTextStyles)
        }, formatMessage((0, (0, parcelRequire("9HL9L")).default).labelEsc)));
    };
});
parcelRegister("9HL9L", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eeb01ce78d21a3be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $eeb01ce78d21a3be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        labelCancel: {
            id: 'fabric.editor.ai.components.cancelEscButton.cancelLabel',
            defaultMessage: 'Cancel',
            description: 'CancelEsc\'s "Cancel" button label'
        },
        labelEsc: {
            id: 'fabric.editor.ai.components.cancelEscButton.escLabel',
            defaultMessage: 'Esc',
            description: 'CancelEsc\'s "Esc" button label'
        }
    });
});
parcelRegister("dprZD", function(module, exports) {
    $parcel$export(module.exports, "escTextStyles", ()=>$db83ece305dcde42$export$d18a373525facb91);
    function $db83ece305dcde42$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $db83ece305dcde42$export$d18a373525facb91 = {
        name: "14mtez1",
        styles: "border-radius:var(--ds-border-radius-100, 3px);padding:3px;color:var(--ds-text-subtle, #44546F);background:var(--ds-background-neutral, #091E420F);font-weight:var(--ds-font-weight-regular, 400);margin-left:5px"
    };
});
parcelRegister("2gMC9", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$9d81e804065e33ed$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $lj8SI;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $iaIrC;
    var $4vsPi;
    var $b9BNM;
    var $dRju8;
    var $aAXzC;
    const $9d81e804065e33ed$var$footerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        flexWrap: 'wrap',
        paddingLeft: 'space.200',
        paddingRight: 'space.200',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        gap: 'space.050',
        borderTopLeftRadius: 'unset',
        borderTopRightRadius: 'unset',
        backgroundColor: 'elevation.surface',
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderTopColor: 'color.border',
        alignItems: 'center',
        justifyContent: 'space-between'
    });
    function $9d81e804065e33ed$export$a06f1c675e846f6f({ brand: brand, showDisclaimer: showDisclaimer, disclaimer: disclaimer, showBetaLozenge: showBetaLozenge }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [setElement, { width: width }] = (0, (0, parcelRequire("iaIrC")).useElementSize)();
        const appearance = (0, $5uXOq.useMemo)(()=>{
            if (brand === 'atlassian-intelligence') {
                if (width < (0, (0, parcelRequire("dRju8")).AI_BREAKPOINTS).medium) return 'small';
                if (width < (0, (0, parcelRequire("dRju8")).AI_BREAKPOINTS).large) return 'medium';
                return 'large';
            } else {
                if (width < (0, (0, parcelRequire("dRju8")).ROVO_BREAKPOINTS).medium) return 'small';
                if (width < (0, (0, parcelRequire("dRju8")).ROVO_BREAKPOINTS).large) return 'medium';
                return 'large';
            }
        }, [
            width,
            brand
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            ref: setElement,
            xcss: $9d81e804065e33ed$var$footerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050"
        }, showBetaLozenge && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
            testId: "beta-lozenge"
        }, formatMessage((0, (0, parcelRequire("aAXzC")).default).betaLabel)), showDisclaimer ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("b9BNM")).FooterDisclaimer), {
            disclaimer: disclaimer,
            appearance: appearance
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), null)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4vsPi")).FooterAIBrand), {
            brand: brand,
            appearance: appearance
        }));
    }
});
parcelRegister("4vsPi", function(module, exports) {
    $parcel$export(module.exports, "FooterAIBrand", ()=>$cf6b948aceab1272$export$e0578d9df5b50dd4);
    var $f8Sb3;
    var $koVbs;
    var $jps85;
    var $hqZzc;
    var $dC5iT;
    var $f5TWP;
    var $cgL5K;
    var $i6FWV;
    var $aAXzC;
    function $cf6b948aceab1272$export$e0578d9df5b50dd4({ brand: brand, appearance: appearance }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const shortDisclaimer = brand === 'rovo' ? (0, (0, parcelRequire("aAXzC")).default).rovoCopyright : (0, (0, parcelRequire("aAXzC")).default).atlassianIntelligenceCopyrightShort;
        const fullDisclaimer = brand === 'rovo' ? (0, (0, parcelRequire("aAXzC")).default).rovoCopyright : (0, (0, parcelRequire("aAXzC")).default).atlassianIntelligenceCopyright;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), null, appearance !== 'small' && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), null, appearance === 'medium' ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage(shortDisclaimer)) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage(fullDisclaimer))), brand === 'rovo' ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hqZzc")).RovoIcon), {
            label: formatMessage(fullDisclaimer),
            appearance: "neutral",
            size: "small"
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
            label: formatMessage(fullDisclaimer),
            color: "var(--ds-icon-subtle, #626F86)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("i6FWV")).AtlassianIntelligenceLogo),
            LEGACY_size: "medium"
        }));
    }
});
parcelRegister("i6FWV", function(module, exports) {
    $parcel$export(module.exports, "AtlassianIntelligenceLogo", ()=>$736b7b9967601246$export$b58d43d92d088553);
    var $f8Sb3;
    var $5LWLA;
    const $736b7b9967601246$var$CustomGlyph = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.5 14.5L17.5 17.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.5 14.5L6.5 17.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.5 9.5L6.5 6.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.5 9.5L17.5 6.5",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "square"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M12.0001 16V19",
            stroke: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M8.00012 12L5.00012 12",
            stroke: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M12.0001 8.00002L12.0001 4.99999",
            stroke: "currentColor",
            strokeWidth: "1.5"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M16.0002 12L19.0002 12",
            stroke: "currentColor",
            strokeWidth: "1.5"
        }));
    const $736b7b9967601246$export$b58d43d92d088553 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $736b7b9967601246$var$CustomGlyph,
            primaryColor: "var(--ds-icon-brand, #0C66E4)",
            ...props
        });
});
parcelRegister("aAXzC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2af2fa8bbd22a7c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d2af2fa8bbd22a7c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        betaLabel: {
            id: 'fabric.editor.ai.screens.preview.betaLabel',
            defaultMessage: 'Beta',
            description: 'The label describing the beta status of the Atlassian Intelligence feature'
        },
        infoIconLabel: {
            id: 'fabric.editor.ai.commandPalette.footer.infoIconLabel',
            defaultMessage: 'Information',
            description: 'The label for the information icon'
        },
        atlassianIntelligenceCopyrightShort: {
            id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort',
            defaultMessage: 'Powered by AI',
            description: 'Text to display in the right part of Editor AI command palette footer in short form for AI requests'
        },
        atlassianIntelligenceCopyright: {
            id: 'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright',
            defaultMessage: 'Powered by Atlassian Intelligence',
            description: 'Text to display in the right part of Editor AI command palette footer for AI requests'
        },
        rovoCopyright: {
            id: 'fabric.editor.ai.commandPalette.footer.rovoCopyright',
            defaultMessage: 'Rovo',
            description: 'Text to display in the right part of Editor AI command palette footer for Rovo requests'
        },
        disclaimerTextShort: {
            id: 'fabric.editor.ai.commandPalette.footer.disclaimerTextShort',
            defaultMessage: 'Content quality may vary',
            description: 'Text to display in the disclaimer part of Editor AI command palette footer in short form'
        },
        disclaimerText: {
            id: 'fabric.editor.ai.commandPalette.footer.disclaimerText',
            defaultMessage: 'Content is based on your permissions, and its quality may vary',
            description: 'Text to display in the disclaimer part of Editor AI command palette footer'
        }
    });
});
parcelRegister("b9BNM", function(module, exports) {
    $parcel$export(module.exports, "FooterDisclaimer", ()=>$1da938d166a3d04d$export$d8e84a6a42a1313b);
    var $f8Sb3;
    var $koVbs;
    var $2hXfb;
    var $jhmo0;
    var $f5TWP;
    var $8CUq3;
    var $aAXzC;
    var $l1p5g;
    const $1da938d166a3d04d$var$linkStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: 'font.body.small',
        color: 'color.text.subtlest',
        textDecoration: 'none',
        ':visited': {
            color: 'color.text.subtlest'
        },
        ':hover': {
            color: 'color.text.subtlest',
            textDecoration: 'underline'
        }
    });
    function $1da938d166a3d04d$export$d8e84a6a42a1313b({ disclaimer: disclaimer, appearance: appearance }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return disclaimer ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("l1p5g")).CustomDisclaimer), {
            disclaimer: disclaimer
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            alignBlock: "center"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2hXfb"))))), {
            label: formatMessage((0, (0, parcelRequire("aAXzC")).default).infoIconLabel),
            primaryColor: "var(--ds-text-subtlest, #626F86)",
            size: "small"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhmo0")).default), {
            color: "color.text.subtlest",
            href: "https://www.atlassian.com/trust/atlassian-intelligence",
            xcss: $1da938d166a3d04d$var$linkStyles
        }, formatMessage(appearance === 'large' ? (0, (0, parcelRequire("aAXzC")).default).disclaimerText : (0, (0, parcelRequire("aAXzC")).default).disclaimerTextShort)));
    }
});
parcelRegister("l1p5g", function(module, exports) {
    $parcel$export(module.exports, "CustomDisclaimer", ()=>$6dc9762cfc8f4e53$export$2cebd3bbd14f5ea6);
    var $f8Sb3;
    var $dC5iT;
    var $3bDjY;
    const $6dc9762cfc8f4e53$export$913d9555a421572b = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        minWidth: 0,
        minHeight: "var(--ds-space-300, 24px)",
        '& > p, & > div:first-child': {
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            marginTop: 0
        },
        '& > span': {
            marginTop: "var(--ds-space-050, 4px)",
            marginRight: "var(--ds-space-050, 4px)",
            marginBottom: "var(--ds-space-050, 4px)"
        }
    });
    function $6dc9762cfc8f4e53$export$2cebd3bbd14f5ea6({ disclaimer: disclaimer }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $6dc9762cfc8f4e53$export$913d9555a421572b
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: "custom-disclaimer"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: disclaimer.tooltip,
            position: "top"
        }, disclaimer.url ? (0, (0, parcelRequire("f8Sb3")).jsx)("a", {
            href: disclaimer.url,
            target: "_blank",
            rel: "noopener noreferrer"
        }, disclaimer.text) : (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, disclaimer.text))));
    }
});
parcelRegister("dRju8", function(module, exports) {
    $parcel$export(module.exports, "AI_BREAKPOINTS", ()=>$0f3496969f354913$export$3d1352baed9f774a);
    $parcel$export(module.exports, "ROVO_BREAKPOINTS", ()=>$0f3496969f354913$export$f859a198decf7af);
    const $0f3496969f354913$export$3d1352baed9f774a = {
        medium: 328,
        large: 624
    };
    const $0f3496969f354913$export$f859a198decf7af = {
        medium: 300,
        large: 480
    };
});
parcelRegister("99dxo", function(module, exports) {
    $parcel$export(module.exports, "LatestPromptHeader", ()=>$28f75ce2bc17598c$export$289e4ad0cf050b01);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $idlL6;
    var $bu6Ao;
    var $diQUO;
    var $jwkQ2;
    var $1Ds8i;
    var $4fUWX;
    var $hTcbJ;
    function $28f75ce2bc17598c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $28f75ce2bc17598c$var$PROMPT_CONTENT_ID = 'ai-latest-prompt-content';
    const $28f75ce2bc17598c$var$headerEditStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        cursor: 'pointer',
        border: 'none',
        width: '100%',
        backgroundColor: 'transparent',
        color: 'inherit',
        textAlign: 'start',
        fontSize: 'unset',
        lineHeight: 'inherit',
        borderRadius: "var(--ds-border-radius-200, 4px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        },
        '&:hover #edit-prompt-hover-button': {
            opacity: 1
        },
        '&:active': {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
        },
        '&:focus': {
            outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    });
    const $28f75ce2bc17598c$var$contentContainerStyles = {
        name: "loojxu",
        styles: "line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;hyphens:auto;word-wrap:break-word"
    };
    const $28f75ce2bc17598c$var$fullWidth = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $28f75ce2bc17598c$var$titleContentWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1,
        minWidth: '0'
    });
    const $28f75ce2bc17598c$var$headerStyles = {
        name: "sga4p2",
        styles: "padding:var(--ds-space-150, 12px);overflow-wrap:break-word;overflow:hidden;width:100%;div p{line-height:20px;}"
    };
    const $28f75ce2bc17598c$var$headerBoxSizingStyles = {
        name: "1khn195",
        styles: "box-sizing:border-box"
    };
    const $28f75ce2bc17598c$export$289e4ad0cf050b01 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, prompt: prompt, promptADF: promptADF, presetTitle: presetTitle, providerFactory: providerFactory, onEditPromptClick: onEditPromptClick, agent: agent, showBack: showBack, onBack: onBack, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let canEdit = !!onEditPromptClick;
        const promptContent = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if (promptADF) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                alignItems: "center"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1Ds8i")).LatestPromptRenderer), {
                promptADF: promptADF,
                providerFactory: providerFactory
            }), !presetTitle && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jwkQ2")).EditPromptHoverTag), {
                isClearMode: !presetTitle && !prompt,
                isPlaceholder: !canEdit
            }));
            if (prompt) return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $28f75ce2bc17598c$var$contentContainerStyles
            }, prompt);
            return null;
        }, [
            canEdit,
            prompt,
            promptADF,
            providerFactory,
            presetTitle
        ]);
        const refinementTagProps = (0, (0, parcelRequire("idlL6")).useAgentRefinementTagProps)(agent);
        const header = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), null, showBack && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bu6Ao")).BackIconButton), {
                inPromptHeader: true,
                isDisabled: !canEdit,
                stopPropagation: true,
                onClick: onBack
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                direction: "column",
                gap: "space.050",
                xcss: $28f75ce2bc17598c$var$titleContentWrapper
            }, presetTitle && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
                alignItems: "center"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                onClick: (e)=>{
                    e.stopPropagation();
                    e.preventDefault();
                }
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4fUWX")).RefinementTag), {
                label: presetTitle,
                ...refinementTagProps,
                onClick: canEdit ? ()=>{
                    if (onBack) onBack();
                } : undefined
            })), presetTitle && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jwkQ2")).EditPromptHoverTag), {
                isClearMode: !!presetTitle && !prompt,
                isPlaceholder: !canEdit
            })), promptContent), !!onClose && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("diQUO")).ClosePreviewIconButton), {
                onClick: onClose
            }));
        }, [
            presetTitle,
            refinementTagProps,
            prompt,
            promptContent,
            showBack,
            canEdit,
            onBack,
            onClose
        ]);
        if (!(prompt || presetTitle)) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: "prompt-header",
            xcss: $28f75ce2bc17598c$var$fullWidth
        }, !canEdit ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $28f75ce2bc17598c$var$headerStyles,
                $28f75ce2bc17598c$var$headerBoxSizingStyles,
                $28f75ce2bc17598c$var$contentContainerStyles
            ],
            id: $28f75ce2bc17598c$var$PROMPT_CONTENT_ID,
            "data-testid": $28f75ce2bc17598c$var$PROMPT_CONTENT_ID
        }, header) : (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            "data-testid": "edit-prompt-button",
            onClick: onEditPromptClick,
            css: [
                $28f75ce2bc17598c$var$headerStyles,
                $28f75ce2bc17598c$var$headerBoxSizingStyles,
                $28f75ce2bc17598c$var$contentContainerStyles,
                $28f75ce2bc17598c$var$headerEditStyles
            ],
            "aria-label": formatMessage((0, (0, parcelRequire("hTcbJ")).messages).editPrompt),
            "aria-describedby": $28f75ce2bc17598c$var$PROMPT_CONTENT_ID
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            id: $28f75ce2bc17598c$var$PROMPT_CONTENT_ID,
            "data-testid": $28f75ce2bc17598c$var$PROMPT_CONTENT_ID
        }, header)));
    };
});
parcelRegister("idlL6", function(module, exports) {
    $parcel$export(module.exports, "useAgentRefinementTagProps", ()=>$93562ef9faa6ce1e$export$e8e2b5fd4b3854f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $8S93R;
    function $93562ef9faa6ce1e$export$e8e2b5fd4b3854f2(agent) {
        const props = (0, $5uXOq.useMemo)(()=>{
            if (agent) return {
                elemBefore: (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testId": "command-palette-rovo-agent-icon"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon,
                    label: agent.name,
                    size: "xsmall"
                })),
                appearance: 'rounded'
            };
            else return undefined;
        }, [
            agent
        ]);
        return props;
    }
});
parcelRegister("8S93R", function(module, exports) {
    $parcel$export(module.exports, "AgentAvatar", ()=>$5b0f0a8770070c77$export$38b71b080e1832c8);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    var $5OOAU;
    const $5b0f0a8770070c77$var$agentAvatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$innerShapeStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '95%',
        width: '95%',
        clipPath: `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`
    });
    const $5b0f0a8770070c77$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%'
    });
    const $5b0f0a8770070c77$var$avatarContentContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5b0f0a8770070c77$export$38b71b080e1832c8 = ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
        const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            "aria-label": label,
            xcss: $5b0f0a8770070c77$var$agentAvatarStyles,
            style: {
                height: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                width: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                ...showBorder ? {
                    backgroundColor: '#fff'
                } : {}
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$innerShapeStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5b0f0a8770070c77$var$avatarContentContainer
        }, imgUrl ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "img",
            xcss: $5b0f0a8770070c77$var$imageStyles,
            src: imgUrl,
            alt: name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: size
        }))));
    };
});
parcelRegister("5OOAU", function(module, exports) {
    $parcel$export(module.exports, "AgentBanner", ()=>$5bf0564183cfbb33$export$6efaefb8ad2fba40);
    $parcel$export(module.exports, "GeneratedAvatar", ()=>$5bf0564183cfbb33$export$96bb253b7de22616);
    var $5uXOq = parcelRequire("5uXOq");
    var $vIiRg;
    var $dC5iT;
    var $8CUq3;
    const $5bf0564183cfbb33$var$AutoDevAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4J75T")));
    const $5bf0564183cfbb33$var$AutoFixAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("dY96i")));
    const $5bf0564183cfbb33$var$AutoReviewAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8S39z")));
    const $5bf0564183cfbb33$var$BacklogBuddyAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("5f7dz")));
    const $5bf0564183cfbb33$var$CommsCrafterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("4GtXx")));
    const $5bf0564183cfbb33$var$CultureAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("ejYg5")));
    const $5bf0564183cfbb33$var$CustomerInsightAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("cVv8a")));
    const $5bf0564183cfbb33$var$DecisionDirectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("laQbH")));
    const $5bf0564183cfbb33$var$FeatureFlagAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fAXjZ")));
    const $5bf0564183cfbb33$var$GenericAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kQ0nL")));
    const $5bf0564183cfbb33$var$HireWriterAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("8upBE")));
    const $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("1DMmf")));
    const $5bf0564183cfbb33$var$MyUserManualAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hF1ay")));
    const $5bf0564183cfbb33$var$OkrOracleAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("57MJs")));
    const $5bf0564183cfbb33$var$OpsAgentAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("l1q3R")));
    const $5bf0564183cfbb33$var$PitchPerfectorAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("15btr")));
    const $5bf0564183cfbb33$var$ProductRequirementAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("fRK36")));
    const $5bf0564183cfbb33$var$ReleaseNotesAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("kYLpd")));
    const $5bf0564183cfbb33$var$ResearchScoutAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("hvWnv")));
    const $5bf0564183cfbb33$var$SocialMediaScribeAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("eV9lH")));
    const $5bf0564183cfbb33$var$TeamConnectionAvatar = (0, $5uXOq.lazy)(()=>(parcelRequire("jux1s")));
    const $5bf0564183cfbb33$var$yellowColor = {
        primary: '#FCA700',
        secondary: '#FFC716'
    };
    const $5bf0564183cfbb33$var$purpleColor = {
        primary: '#BF63F3',
        secondary: '#D8A0F7'
    };
    const $5bf0564183cfbb33$var$greenColor = {
        primary: '#82B536',
        secondary: '#B3DF72'
    };
    const $5bf0564183cfbb33$var$blueColor = {
        primary: '#357DE8',
        secondary: '#669DF1'
    };
    const $5bf0564183cfbb33$var$colorList = [
        $5bf0564183cfbb33$var$yellowColor,
        $5bf0564183cfbb33$var$purpleColor,
        $5bf0564183cfbb33$var$greenColor,
        $5bf0564183cfbb33$var$blueColor
    ];
    const $5bf0564183cfbb33$var$avatarList = [
        $5bf0564183cfbb33$var$CustomerInsightAvatar,
        $5bf0564183cfbb33$var$BacklogBuddyAvatar,
        $5bf0564183cfbb33$var$DecisionDirectorAvatar,
        $5bf0564183cfbb33$var$CommsCrafterAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$OkrOracleAvatar,
        $5bf0564183cfbb33$var$CultureAvatar,
        $5bf0564183cfbb33$var$SocialMediaScribeAvatar,
        $5bf0564183cfbb33$var$TeamConnectionAvatar,
        $5bf0564183cfbb33$var$HireWriterAvatar,
        $5bf0564183cfbb33$var$OpsAgentAvatar,
        $5bf0564183cfbb33$var$ResearchScoutAvatar,
        $5bf0564183cfbb33$var$ReleaseNotesAvatar,
        $5bf0564183cfbb33$var$MyUserManualAvatar,
        $5bf0564183cfbb33$var$PitchPerfectorAvatar,
        $5bf0564183cfbb33$var$AutoDevAvatar,
        $5bf0564183cfbb33$var$AutoFixAvatar,
        $5bf0564183cfbb33$var$AutoReviewAvatar,
        $5bf0564183cfbb33$var$MarketingMessageMaestroAvatar,
        $5bf0564183cfbb33$var$FeatureFlagAvatar,
        $5bf0564183cfbb33$var$ProductRequirementAvatar
    ];
    const $5bf0564183cfbb33$export$a834793a4d0d739e = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
    const $5bf0564183cfbb33$var$imageStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        objectFit: 'cover',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar = {
        decision_director_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$DecisionDirectorAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        user_manual_writer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$MyUserManualAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        product_requirements_expert_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$ProductRequirementAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$yellowColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$yellowColor.secondary
                }),
            color: $5bf0564183cfbb33$var$yellowColor
        },
        issue_organizer_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$BacklogBuddyAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$greenColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$greenColor.secondary
                }),
            color: $5bf0564183cfbb33$var$greenColor
        },
        it_ops_agent: {
            getRender: (size)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$OpsAgentAvatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: $5bf0564183cfbb33$var$purpleColor.primary,
                    secondaryColor: $5bf0564183cfbb33$var$purpleColor.secondary
                }),
            color: $5bf0564183cfbb33$var$purpleColor
        }
    };
    const $5bf0564183cfbb33$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
        const idForAgentAvatar = agentIdentityAccountId || agentId;
        if (idForAgentAvatar) {
            const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
            const parsedId = parseInt(trimmedId, 16);
            if (isNaN(parsedId)) return 0;
            else return parsedId;
        }
        return null;
    };
    const $5bf0564183cfbb33$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, size: size })=>{
        if (typeof agentNamedId === 'string' && $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId]) {
            const ootbAvatarResult = $5bf0564183cfbb33$var$outOfTheBoxAgentAvatar[agentNamedId];
            return {
                render: ootbAvatarResult.getRender(size),
                color: ootbAvatarResult.color
            };
        }
        const numberId = $5bf0564183cfbb33$export$c84eb7708138dd4({
            agentIdentityAccountId: agentIdentityAccountId,
            agentId: agentId
        });
        if (numberId !== null) {
            const totalCombinations = $5bf0564183cfbb33$var$avatarList.length * $5bf0564183cfbb33$var$colorList.length;
            const combinationIndex = numberId % totalCombinations;
            const avatarIndex = Math.floor(combinationIndex / $5bf0564183cfbb33$var$colorList.length);
            const colorIndex = combinationIndex % $5bf0564183cfbb33$var$colorList.length;
            const Avatar = $5bf0564183cfbb33$var$avatarList[avatarIndex];
            const color = $5bf0564183cfbb33$var$colorList[colorIndex];
            return {
                render: (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                    size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                    primaryColor: color.primary,
                    secondaryColor: color.secondary
                }),
                color: color
            };
        }
        return {
            render: (0, ($parcel$interopDefault($5uXOq))).createElement($5bf0564183cfbb33$var$GenericAvatar, {
                size: (0, (0, parcelRequire("vIiRg")).AVATAR_SIZES)[size],
                primaryColor: $5bf0564183cfbb33$var$blueColor.primary,
                secondaryColor: $5bf0564183cfbb33$var$blueColor.secondary
            }),
            color: $5bf0564183cfbb33$var$blueColor
        };
    };
    const $5bf0564183cfbb33$var$bannerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $5bf0564183cfbb33$var$bannerFillSpaceStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    });
    const $5bf0564183cfbb33$export$6efaefb8ad2fba40 = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, height: height, fillSpace: fillSpace })=>{
        const { color: color } = $5bf0564183cfbb33$var$getAvatarRender({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            size: 'medium'
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5bf0564183cfbb33$var$bannerStyles,
                fillSpace ? $5bf0564183cfbb33$var$bannerFillSpaceStyles : undefined
            ],
            style: {
                backgroundColor: color.primary,
                height: height ? `${height}px` : undefined
            }
        });
    };
    const $5bf0564183cfbb33$export$96bb253b7de22616 = (props)=>{
        const { render: render, color: color } = $5bf0564183cfbb33$var$getAvatarRender(props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $5bf0564183cfbb33$var$imageStyles,
            style: {
                backgroundColor: color.primary
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, render));
    };
});
parcelRegister("4J75T", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4lyg6").then(()=>parcelRequire('lOwq3'));
});
parcelRegister("dY96i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lnSiC").then(()=>parcelRequire('k9HyI'));
});
parcelRegister("8S39z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lOKtw").then(()=>parcelRequire('7r7QW'));
});
parcelRegister("5f7dz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lRNUS").then(()=>parcelRequire('27sCb'));
});
parcelRegister("4GtXx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("92TBI").then(()=>parcelRequire('k9RFh'));
});
parcelRegister("ejYg5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kX91W").then(()=>parcelRequire('dB6SD'));
});
parcelRegister("cVv8a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5L9bA").then(()=>parcelRequire('kbU5P'));
});
parcelRegister("laQbH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fJ8GX").then(()=>parcelRequire('4Ta6A'));
});
parcelRegister("fAXjZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2ZaYM").then(()=>parcelRequire('cT52Z'));
});
parcelRegister("kQ0nL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6qpze").then(()=>parcelRequire('fvSGg'));
});
parcelRegister("8upBE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2V8QL").then(()=>parcelRequire('kOgKS'));
});
parcelRegister("1DMmf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lHm9").then(()=>parcelRequire('gDfXS'));
});
parcelRegister("hF1ay", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jp977").then(()=>parcelRequire('6fzX4'));
});
parcelRegister("57MJs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hRLjL").then(()=>parcelRequire('1sn78'));
});
parcelRegister("l1q3R", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6zpoJ").then(()=>parcelRequire('ljkz0'));
});
parcelRegister("15btr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cs1IH").then(()=>parcelRequire('djrSm'));
});
parcelRegister("fRK36", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5gEFD").then(()=>parcelRequire('W7C9N'));
});
parcelRegister("kYLpd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dMdTv").then(()=>parcelRequire('3pZFQ'));
});
parcelRegister("hvWnv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gLnrh").then(()=>parcelRequire('icyRb'));
});
parcelRegister("eV9lH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fj5lF").then(()=>parcelRequire('f4CgX'));
});
parcelRegister("jux1s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hZXlA").then(()=>parcelRequire('l3PeX'));
});
parcelRegister("bu6Ao", function(module, exports) {
    $parcel$export(module.exports, "BackIconButton", ()=>$17b494ae723c6f06$export$dcf44e0bed76850);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $42CjB;
    var $lRheX;
    var $kgoHi;
    var $8CUq3;
    var $64ffq;
    const $17b494ae723c6f06$var$inPromptHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginRight: 'space.050'
    });
    const $17b494ae723c6f06$var$toolTipProps = {
        position: 'top'
    };
    const $17b494ae723c6f06$export$dcf44e0bed76850 = ({ inPromptHeader: inPromptHeader, isDisabled: isDisabled = false, stopPropagation: stopPropagation, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClickIconButton = (0, $5uXOq.useCallback)((event)=>{
            if (stopPropagation) event.stopPropagation();
            onClick?.();
        }, [
            stopPropagation,
            onClick
        ]);
        const btn = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            isDisabled: isDisabled,
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("lRheX"))))),
            label: formatMessage((0, (0, parcelRequire("64ffq")).default).backLabel),
            spacing: "compact",
            isTooltipDisabled: isDisabled,
            onClick: onClickIconButton,
            testId: "back-icon-button",
            tooltip: $17b494ae723c6f06$var$toolTipProps
        });
        if (inPromptHeader) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $17b494ae723c6f06$var$inPromptHeaderStyles
            ]
        }, btn);
        return btn;
    };
});
parcelRegister("64ffq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aa2e823af701d34$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2aa2e823af701d34$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        backLabel: {
            id: 'fabric.editor.ai.components.backIconButton.backLabel',
            defaultMessage: 'Back',
            description: 'Back button label and tooltip'
        }
    });
});
parcelRegister("diQUO", function(module, exports) {
    $parcel$export(module.exports, "ClosePreviewIconButton", ()=>$3282b308b6801cab$export$777abcc87b2abd7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $42CjB;
    var $i28qQ;
    var $kgoHi;
    var $8CUq3;
    var $5rNIg;
    const $3282b308b6801cab$var$inPromptHeaderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginRight: 'space.050'
    });
    const $3282b308b6801cab$var$toolTipProps = {
        position: 'top'
    };
    const $3282b308b6801cab$export$d428cfd0d6a2b2ec = 'close-preview-icon-button';
    const $3282b308b6801cab$export$777abcc87b2abd7a = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            xcss: [
                $3282b308b6801cab$var$inPromptHeaderStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))),
            label: formatMessage((0, (0, parcelRequire("5rNIg")).default).closePreviewLabel),
            spacing: "compact",
            onClick: onClick,
            testId: $3282b308b6801cab$export$d428cfd0d6a2b2ec,
            tooltip: $3282b308b6801cab$var$toolTipProps,
            isTooltipDisabled: false
        }));
    };
});
parcelRegister("5rNIg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cd8cd2971afb20df$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cd8cd2971afb20df$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        closePreviewLabel: {
            id: 'fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final',
            defaultMessage: 'Close preview',
            description: 'Close preview button label and tooltip'
        }
    });
});
parcelRegister("jwkQ2", function(module, exports) {
    $parcel$export(module.exports, "EditPromptHoverTag", ()=>$f54aa55a2b8c7274$export$3a1fe5569d8f8994);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $d9xxV;
    var $ii7bt;
    function $f54aa55a2b8c7274$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f54aa55a2b8c7274$var$containerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        flexShrink: 0,
        marginLeft: 'auto',
        marginTop: "var(--ds-space-negative-025, -2px)",
        marginBottom: "var(--ds-space-negative-025, -2px)",
        display: 'inline-flex',
        opacity: 0,
        '& > span': {
            cursor: 'pointer',
            margin: 0,
            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"}`
        }
    });
    const $f54aa55a2b8c7274$var$placeholderStyles = {
        name: "eyonym",
        styles: "& > span{cursor:default;}"
    };
    const $f54aa55a2b8c7274$export$3a1fe5569d8f8994 = ({ isClearMode: isClearMode = false, isPlaceholder: isPlaceholder })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const text = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            return isClearMode ? formatMessage((0, (0, parcelRequire("ii7bt")).messages).clearPromptHover) : formatMessage((0, (0, parcelRequire("ii7bt")).messages).editPromptHover);
        }, [
            isClearMode,
            formatMessage
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "edit-prompt-hover-button",
            "data-testid": "edit-prompt-hover-button",
            css: [
                $f54aa55a2b8c7274$var$containerStyles,
                isPlaceholder && $f54aa55a2b8c7274$var$placeholderStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("d9xxV")).default), {
            text: text
        }));
    };
});
parcelRegister("d9xxV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87927dab24395a15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5oSQr;
    var $aXLIT;
    var $eYXIO;
    const $87927dab24395a15$var$SimpleTagComponent = (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eYXIO")).default), {
            elemBefore: elemBefore,
            isRemovable: false,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5oSQr")).default), {
            ref: ref,
            testId: testId,
            href: href,
            appearance: appearance,
            color: color,
            before: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aXLIT")).default), {
                elemBefore: elemBefore
            }),
            contentElement: content
        });
    });
    const $87927dab24395a15$var$SimpleTag = (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
    var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;
});
parcelRegister("5oSQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db35d9df42c66ff0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    var $2hnSR;
    function $db35d9df42c66ff0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $db35d9df42c66ff0$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        padding: "var(--ds-space-0, 0px)",
        position: 'relative',
        backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.default})`,
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.default})`,
        cursor: 'default'
    });
    const $db35d9df42c66ff0$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'inline-flex',
        boxSizing: 'border-box',
        minWidth: 0,
        height: (0, (0, parcelRequire("e6s40")).tagHeight),
        margin: (0, (0, parcelRequire("e6s40")).defaultMargin),
        position: 'relative',
        alignItems: 'center',
        gap: "var(--ds-space-050, 4px)",
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        border: 'solid',
        borderColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor})`,
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: "var(--ds-border-width, 1px)",
        color: "var(--ds-text, #172B4D)",
        cursor: 'default',
        paddingInline: "var(--ds-space-050, 4px)"
    });
    const $db35d9df42c66ff0$var$interactiveStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover})`
        },
        '&:active': {
            backgroundColor: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.background.active})`
        }
    });
    const $db35d9df42c66ff0$var$interactiveStyles = {
        name: "jcdcgl",
        styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
    };
    const $db35d9df42c66ff0$var$focusRingStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            boxShadow: `0 0 0 2px var(${(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing})`,
            outline: 'none'
        }
    });
    const $db35d9df42c66ff0$var$focusRingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            outline: `2px solid ${(0, parcelRequire("2hnSR")).focusRingColors}`,
            outlineOffset: '2px '
        }
    });
    const $db35d9df42c66ff0$var$nonStandardLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`
        }
    });
    const $db35d9df42c66ff0$var$BaseTag = (0, ($parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
        const isLink = Boolean(href);
        const isRemovable = Boolean(after);
        const isInteractive = isLink || isRemovable;
        const isStandardLink = isLink && color === 'standard';
        const textLinkColors = isStandardLink ? (0, parcelRequire("2hnSR")).textColors['standardLink'] : (0, parcelRequire("2hnSR")).textColors[color];
        const backgroundHoverColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkHoverBackgroundColors[color];
        const backgroundActiveColors = isRemovable && !isLink ? (0, parcelRequire("2hnSR")).backgroundColors[color] : (0, parcelRequire("2hnSR")).linkActiveBackgroundColors[color];
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...other,
            ref: ref,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$baseStyles : $db35d9df42c66ff0$var$baseStylesOld,
                isInteractive && ((0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $db35d9df42c66ff0$var$focusRingStyles : $db35d9df42c66ff0$var$focusRingStylesOld),
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? isLink && $db35d9df42c66ff0$var$interactiveStyles : undefined,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $db35d9df42c66ff0$var$nonStandardLinkStyles,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && isInteractive && $db35d9df42c66ff0$var$interactiveStylesOld
            ],
            style: {
                [(0, (0, parcelRequire("e6s40")).cssVar).color.borderColor]: (0, parcelRequire("2hnSR")).borderColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.default]: (0, parcelRequire("2hnSR")).textColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover]: (0, parcelRequire("2hnSR")).textHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.active]: (0, parcelRequire("2hnSR")).textActiveColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.text.link]: textLinkColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.default]: (0, parcelRequire("2hnSR")).backgroundColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover]: backgroundHoverColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.background.active]: backgroundActiveColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.focusRing]: (0, parcelRequire("2hnSR")).focusRingColors,
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.default]: (0, parcelRequire("2hnSR")).removeButtonColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.hover]: (0, parcelRequire("2hnSR")).removeButtonHoverColors[color],
                [(0, (0, parcelRequire("e6s40")).cssVar).borderRadius]: (0, parcelRequire("2hnSR")).borderRadius[appearance],
                ...style
            },
            className: className,
            "data-testid": testId
        }, before, contentElement, after);
    });
    var $db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;
});
parcelRegister("e6s40", function(module, exports) {
    $parcel$export(module.exports, "tagHeight", ()=>$1dd8b7ac532261be$export$5b2b1030a679f37);
    $parcel$export(module.exports, "buttonWidthUnitless", ()=>$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca);
    $parcel$export(module.exports, "maxTextWidthUnitless", ()=>$1dd8b7ac532261be$export$2e3bcb01bf928995);
    $parcel$export(module.exports, "maxTextWidth", ()=>$1dd8b7ac532261be$export$982d4a1a6de11130);
    $parcel$export(module.exports, "defaultBorderRadius", ()=>$1dd8b7ac532261be$export$35d5d1e251b985cf);
    $parcel$export(module.exports, "defaultRoundedBorderRadius", ()=>$1dd8b7ac532261be$export$c49771100fee18c8);
    $parcel$export(module.exports, "defaultMargin", ()=>$1dd8b7ac532261be$export$6728fea658cfb92e);
    $parcel$export(module.exports, "defaultTextPadding", ()=>$1dd8b7ac532261be$export$c2d03c4c68282362);
    $parcel$export(module.exports, "textPaddingRight", ()=>$1dd8b7ac532261be$export$b5686dedf408caa0);
    $parcel$export(module.exports, "textMarginLeft", ()=>$1dd8b7ac532261be$export$b824cac86306f7a2);
    $parcel$export(module.exports, "cssVar", ()=>$1dd8b7ac532261be$export$8b4981022bd80a4e);
    var $k5uoT;
    const $1dd8b7ac532261be$var$gridSizeValue = (0, (0, parcelRequire("k5uoT")).gridSize)();
    const $1dd8b7ac532261be$var$borderRadiusValue = (0, (0, parcelRequire("k5uoT")).borderRadius)();
    const $1dd8b7ac532261be$export$b4d89c3994664204 = 2.5 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$1dd8b7ac532261be$export$b4d89c3994664204}px`})`;
    const $1dd8b7ac532261be$export$c6f3ea2b4cffd0ca = $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$aba002ef70684916 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$d5949a2c2ea9dcea = 25 * $1dd8b7ac532261be$var$gridSizeValue;
    const $1dd8b7ac532261be$export$488fda99655ff65a = `${$1dd8b7ac532261be$export$d5949a2c2ea9dcea}px`;
    const $1dd8b7ac532261be$export$2e3bcb01bf928995 = $1dd8b7ac532261be$export$d5949a2c2ea9dcea - $1dd8b7ac532261be$export$b4d89c3994664204;
    const $1dd8b7ac532261be$export$982d4a1a6de11130 = `${$1dd8b7ac532261be$export$2e3bcb01bf928995}px`;
    const $1dd8b7ac532261be$export$35d5d1e251b985cf = `${$1dd8b7ac532261be$var$borderRadiusValue}px`;
    const $1dd8b7ac532261be$export$c49771100fee18c8 = `${$1dd8b7ac532261be$export$c6f3ea2b4cffd0ca / 2}px`;
    const $1dd8b7ac532261be$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$1dd8b7ac532261be$var$gridSizeValue / 2}px`})`;
    const $1dd8b7ac532261be$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $1dd8b7ac532261be$var$gridSizeValue}px`})`;
    const $1dd8b7ac532261be$export$b824cac86306f7a2 = $1dd8b7ac532261be$export$5b2b1030a679f37;
    const $1dd8b7ac532261be$export$8b4981022bd80a4e = {
        color: {
            background: {
                default: '--ds-cb',
                hover: '--ds-cbh',
                active: '--ds-cba'
            },
            borderColor: '--ds-bc',
            focusRing: '--ds-cfr',
            text: {
                default: '--ds-ct',
                hover: '--ds-cth',
                active: '--ds-ctp',
                link: '--ds-ctl'
            },
            removeButton: {
                default: '--ds-rb',
                hover: '--ds-rbh'
            }
        },
        borderRadius: '--ds-br'
    };
});
parcelRegister("2hnSR", function(module, exports) {
    $parcel$export(module.exports, "textColors", ()=>$5b444d8505b9cc3c$export$daa0ace263cb20d2);
    $parcel$export(module.exports, "borderColors", ()=>$5b444d8505b9cc3c$export$1c1b571cf296eca7);
    $parcel$export(module.exports, "textHoverColors", ()=>$5b444d8505b9cc3c$export$7c7104a5f052cab7);
    $parcel$export(module.exports, "textActiveColors", ()=>$5b444d8505b9cc3c$export$382469baad253eb7);
    $parcel$export(module.exports, "backgroundColors", ()=>$5b444d8505b9cc3c$export$b9d7c59a579c23c6);
    $parcel$export(module.exports, "linkHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$4410079763249c74);
    $parcel$export(module.exports, "linkActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$76be99c5e13e3566);
    $parcel$export(module.exports, "focusRingColors", ()=>$5b444d8505b9cc3c$export$2a31dbe82788f940);
    $parcel$export(module.exports, "borderRadius", ()=>$5b444d8505b9cc3c$export$7a57f79000377ca2);
    $parcel$export(module.exports, "removalHoverBackgroundColors", ()=>$5b444d8505b9cc3c$export$1202b7eb21da7b58);
    $parcel$export(module.exports, "removalActiveBackgroundColors", ()=>$5b444d8505b9cc3c$export$62ace793ebb16bda);
    $parcel$export(module.exports, "removalTextColors", ()=>$5b444d8505b9cc3c$export$17d206ccea111bbb);
    $parcel$export(module.exports, "removeButtonColors", ()=>$5b444d8505b9cc3c$export$f64c7641cbc22da7);
    $parcel$export(module.exports, "removeButtonHoverColors", ()=>$5b444d8505b9cc3c$export$b03fbc2a369c563e);
    var $e6s40;
    const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
        standard: '#B7B9BE',
        blue: '#669DF1',
        red: '#F87168',
        yellow: '#DDB30E',
        green: '#4BCE97',
        teal: '#6CC3E0',
        purple: '#C97CF4',
        lime: '#94C748',
        magenta: '#E774BB',
        orange: '#FCA700',
        grey: '#B7B9BE',
        standardLink: '#B7B9BE',
        blueLight: '#669DF1',
        redLight: '#F87168',
        yellowLight: '#DDB30E',
        greenLight: '#4BCE97',
        tealLight: '#6CC3E0',
        purpleLight: '#C97CF4',
        limeLight: '#94C748',
        magentaLight: '#E774BB',
        orangeLight: '#FCA700',
        greyLight: '#B7B9BE'
    };
    const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
        standard: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime-bolder, #37471F)",
        magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
        magentaLight: "var(--ds-text-accent-magenta, #943D73)",
        orangeLight: "var(--ds-text-accent-orange, #974F0C)",
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$382469baad253eb7 = {
        standard: `var(--ds-link-pressed, ${$829f609a65d26a98$export$e62e8919cca44969})`,
        blue: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: "var(--ds-text-accent-lime, #4C6B1F)",
        magenta: "var(--ds-text-accent-magenta, #943D73)",
        orange: "var(--ds-text-accent-orange, #974F0C)",
        grey: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
        magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
        orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
        greyLight: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
        standard: `var(--ds-background-neutral, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
        blue: `var(--ds-background-accent-blue-subtle, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        red: `var(--ds-background-accent-red-subtle, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellow: `var(--ds-background-accent-yellow-subtle, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        green: `var(--ds-background-accent-green-subtle, ${$829f609a65d26a98$export$747d86715d4175de})`,
        teal: `var(--ds-background-accent-teal-subtle, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purple: `var(--ds-background-accent-purple-subtle, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        lime: "var(--ds-background-accent-lime-subtle, #94C748)",
        magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
        grey: `var(--ds-background-accent-gray-subtle, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-background-accent-blue-subtler, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        redLight: `var(--ds-background-accent-red-subtler, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        greenLight: `var(--ds-background-accent-green-subtler, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        tealLight: `var(--ds-background-accent-teal-subtler, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purpleLight: `var(--ds-background-accent-purple-subtler, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
        greyLight: `var(--ds-background-accent-gray-subtler, ${$829f609a65d26a98$export$3e51e8f1440314ba})`
    };
    const $5b444d8505b9cc3c$export$4410079763249c74 = {
        standard: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`,
        red: `var(--ds-background-accent-red-subtle-hovered, ${$829f609a65d26a98$export$b34b069eff244586})`,
        yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$829f609a65d26a98$export$1cc05bbbf340e559})`,
        green: `var(--ds-background-accent-green-subtle-hovered, ${$829f609a65d26a98$export$afbce1382ec95f73})`,
        teal: `var(--ds-background-accent-teal-subtle-hovered, ${$829f609a65d26a98$export$776c9c497ef08533})`,
        purple: `var(--ds-background-accent-purple-subtle-hovered, ${$829f609a65d26a98$export$4b0a4417ed59760f})`,
        lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
        magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
        orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
        grey: `var(--ds-background-accent-gray-subtle-hovered, ${$829f609a65d26a98$export$eece5f492e429f08})`,
        blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        redLight: `var(--ds-background-accent-red-subtler-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$829f609a65d26a98$export$363e4475840015bb})`,
        limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
        orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
        greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$829f609a65d26a98$export$1ce2d1575d444ceb})`
    };
    const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
        standard: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$3e51e8f1440314ba})`,
        blue: `var(--ds-background-accent-blue-subtle-pressed, ${$829f609a65d26a98$export$226de0355ed012f8})`,
        red: `var(--ds-background-accent-red-subtle-pressed, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`,
        yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$829f609a65d26a98$export$41060a744ab0b7ae})`,
        green: `var(--ds-background-accent-green-subtle-pressed, ${$829f609a65d26a98$export$69a3bf21b9686c2b})`,
        teal: `var(--ds-background-accent-teal-subtle-pressed, ${$829f609a65d26a98$export$7a8f4d33f6f9772c})`,
        purple: `var(--ds-background-accent-purple-subtle-pressed, ${$829f609a65d26a98$export$363e4475840015bb})`,
        grey: `var(--ds-background-accent-gray-subtle-pressed, ${$829f609a65d26a98$export$e2ef2124cf4024b1})`,
        lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
        magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
        orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
        blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`,
        redLight: `var(--ds-background-accent-red-subtler-pressed, ${$829f609a65d26a98$export$be802dd0d8b57f35})`,
        yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
        greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$829f609a65d26a98$export$747d86715d4175de})`,
        tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$829f609a65d26a98$export$69cb3ca10c1e330e})`,
        purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$829f609a65d26a98$export$6011520a64d9a187})`,
        limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
        magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
        orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
        greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$829f609a65d26a98$export$8754fc7e6d8b3000})`
    };
    const $5b444d8505b9cc3c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`;
    const $5b444d8505b9cc3c$export$7a57f79000377ca2 = {
        default: (0, (0, parcelRequire("e6s40")).defaultBorderRadius),
        rounded: (0, (0, parcelRequire("e6s40")).defaultRoundedBorderRadius)
    };
    const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$829f609a65d26a98$export$4b84fd0e2c617bd})`;
    const $5b444d8505b9cc3c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`;
    const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
        standard: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blue: `var(--ds-text-accent-blue-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        red: `var(--ds-text-accent-red-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellow: `var(--ds-text-accent-yellow-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        green: `var(--ds-text-accent-green-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        teal: `var(--ds-text-accent-teal-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purple: `var(--ds-text-accent-purple-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        lime: `var(--ds-text-accent-lime-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magenta: `var(--ds-text-accent-magenta-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orange: `var(--ds-text-accent-orange-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        grey: `var(--ds-text-accent-gray-bolder, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        blueLight: `var(--ds-text-accent-blue, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        redLight: `var(--ds-text-accent-red, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-accent-yellow, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-accent-green, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        tealLight: `var(--ds-text-accent-teal, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-accent-purple, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        limeLight: `var(--ds-text-accent-lime, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        magentaLight: `var(--ds-text-accent-magenta, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        orangeLight: `var(--ds-text-accent-orange, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greyLight: `var(--ds-text-accent-gray, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
    const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
        standard: `var(--ds-text-danger, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
        standardLink: `var(--ds-text-danger, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
        blue: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        red: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        yellow: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        green: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        teal: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        purple: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        lime: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        magenta: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        orange: `var(--ds-text-danger, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
        grey: `var(--ds-text-danger, ${$829f609a65d26a98$export$29a4f05edc054374})`,
        blueLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
        redLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        yellowLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        greenLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$6fa04827ac68a4fb})`,
        tealLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
        purpleLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        limeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        magentaLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        orangeLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$147899de772240ec})`,
        greyLight: `var(--ds-text-danger, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`
    };
});
parcelRegister("aXLIT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b11e671062d0fc5$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $4b11e671062d0fc5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4b11e671062d0fc5$var$beforeElementStyles = {
        name: "cfjv6",
        styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
    };
    const $4b11e671062d0fc5$var$beforeElementStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        insetBlockStart: "var(--ds-space-0, 0px)"
    });
    const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $4b11e671062d0fc5$var$beforeElementStyles : $4b11e671062d0fc5$var$beforeElementStylesOld
        }, elemBefore) : null;
    var $4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;
});
parcelRegister("eYXIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c46b06918fbe54e8$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $VSDnB;
    var $e6s40;
    function $c46b06918fbe54e8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c46b06918fbe54e8$var$baseStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        paddingInlineStart: (0, (0, parcelRequire("e6s40")).defaultTextPadding),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: (0, (0, parcelRequire("e6s40")).maxTextWidth),
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
    const $c46b06918fbe54e8$var$linkStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.link})`,
        pointerEvents: 'auto',
        textDecoration: 'none',
        '&:hover': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.hover})`,
            textDecoration: 'underline'
        },
        '&:active': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.text.active})`,
            textDecoration: 'underline'
        },
        '&:focus': {
            outline: 'none'
        }
    });
    const $c46b06918fbe54e8$var$linkStyles = {
        name: "1e5oc06",
        styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
    };
    const $c46b06918fbe54e8$var$hasAfterStylesOld = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`,
        paddingInlineEnd: (0, (0, parcelRequire("e6s40")).textPaddingRight)
    });
    const $c46b06918fbe54e8$var$hasAfterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxWidth: `${(0, (0, parcelRequire("e6s40")).maxTextWidthUnitless) - (0, (0, parcelRequire("e6s40")).buttonWidthUnitless)}px`
    });
    const $c46b06918fbe54e8$var$hasBeforeStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: (0, (0, parcelRequire("e6s40")).textMarginLeft)
    });
    const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
        const Link = linkComponent ?? 'a';
        if (href) return (0, (0, parcelRequire("f8Sb3")).jsx)(Link, {
            href: href,
            "data-color": color,
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$linkStyles : $c46b06918fbe54e8$var$linkStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$baseStyles : $c46b06918fbe54e8$var$baseStylesOld,
                !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') && elemBefore && $c46b06918fbe54e8$var$hasBeforeStyles,
                isRemovable && (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStyles : undefined,
                isRemovable && !(0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $c46b06918fbe54e8$var$hasAfterStylesOld : undefined
            ]
        }, text);
    };
    var $c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;
});
parcelRegister("ii7bt", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$da57aeeece2c8a00$export$defe85febe8b728c);
    var $7VHMR;
    const $da57aeeece2c8a00$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editPromptHover: {
            id: 'fabric.editor.ai.screens.preview.header.edit.hover',
            defaultMessage: 'Edit',
            description: 'Label for the edit prompt button in the preview screen'
        },
        clearPromptHover: {
            id: 'fabric.editor.ai.screens.preview.header.clear.hover',
            defaultMessage: 'Clear',
            description: 'Label for the clear prompt button in the preview screen'
        }
    });
});
parcelRegister("1Ds8i", function(module, exports) {
    $parcel$export(module.exports, "LatestPromptRenderer", ()=>$fcc98fd4945c4f96$export$308e8087851b72a3);
    var $f8Sb3;
    var $f5oqj;
    var $fCNtA;
    const $fcc98fd4945c4f96$var$rendererContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        overflow: 'hidden',
        '.ak-renderer-document': {
            maxHeight: `calc(${"var(--ds-space-250, 20px)"} + ${"var(--ds-space-050, 4px)"})`,
            marginRight: "var(--ds-space-100, 8px)",
            flexGrow: 1,
            flexShrink: 1,
            p: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                hyphens: 'auto',
                wordWrap: 'break-word'
            },
            'p:not(:only-child)::after': {
                content: '"..."'
            },
            'p br': {
                content: '""',
                '&::after': {
                    content: '" "'
                }
            },
            'span[data-inline-card] [data-testid="inline-card-icon-and-title"]': {
                whiteSpace: 'nowrap'
            }
        }
    });
    const $fcc98fd4945c4f96$var$rendererDocumentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        maxHeight: `calc(24px + ${"var(--ds-space-050, 4px)"})`,
        '.ak-renderer-document': {
            p: {
                paddingTop: '0.5px',
                lineHeight: '24px'
            }
        }
    });
    const $fcc98fd4945c4f96$var$RendererWrapper = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $fcc98fd4945c4f96$var$rendererContainerStyles,
                $fcc98fd4945c4f96$var$rendererDocumentStyles
            ]
        }, children);
    };
    const $fcc98fd4945c4f96$export$308e8087851b72a3 = ({ promptADF: promptADF, providerFactory: providerFactory })=>{
        const jsonDocument = promptADF;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fCNtA")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)($fcc98fd4945c4f96$var$RendererWrapper, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5oqj")).default), {
            document: jsonDocument,
            media: {
                allowLinking: false
            },
            useSpecBasedValidator: true,
            dataProviders: providerFactory,
            maxHeight: 20
        })));
    };
});
parcelRegister("4fUWX", function(module, exports) {
    $parcel$export(module.exports, "RefinementTag", ()=>$693773aee7cdfc73$export$21c661408d518ab6);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $9laXL;
    var $d9xxV;
    var $a62T4;
    var $8xzuB;
    const $693773aee7cdfc73$export$21c661408d518ab6 = (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance }, ref)=>{
        const styles = {
            [(0, (0, parcelRequire("8xzuB")).cssVars).alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
            [(0, (0, parcelRequire("8xzuB")).cssVars).elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
        };
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            style: styles,
            css: (0, (0, parcelRequire("8xzuB")).refinementTagStylesVisualRefresh),
            className: "refinement-tag",
            "data-testid": "command-palette-refinement-tag",
            role: "status",
            "aria-atomic": "true",
            "aria-label": formatMessage((0, (0, parcelRequire("a62T4")).default).promptSelected, {
                promptName: label
            }),
            "aria-live": "assertive",
            ref: ref
        }, !onClick ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("d9xxV")).default), {
            testId: 'refinement-tag',
            text: label,
            elemBefore: elemBefore,
            appearance: appearance
        }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9laXL")).default), {
            appearance: appearance,
            elemBefore: elemBefore,
            testId: 'refinement-tag',
            removeButtonLabel: formatMessage((0, (0, parcelRequire("a62T4")).default).removeLabel),
            text: label,
            onBeforeRemoveAction: ()=>{
                onClick();
                return false;
            }
        }));
    });
});
parcelRegister("9laXL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d63a49f20b6f0a05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $c543i;
    var $5JjdN;
    var $eGmKJ;
    var $35XSW;
    var $lM16U;
    var $VSDnB;
    var $e6s40;
    var $2hnSR;
    var $5oSQr;
    var $aXLIT;
    var $eYXIO;
    var $frUcV;
    var $d63a49f20b6f0a05$var$TagStatus;
    (function(TagStatus) {
        TagStatus["Showing"] = "showing";
        TagStatus["Removing"] = "removing";
        TagStatus["Removed"] = "removed";
    })($d63a49f20b6f0a05$var$TagStatus || ($d63a49f20b6f0a05$var$TagStatus = {}));
    const $d63a49f20b6f0a05$var$packageName = "platform-pkg";
    const $d63a49f20b6f0a05$var$packageVersion = "0.0.0-use.local";
    const $d63a49f20b6f0a05$var$defaultBeforeRemoveAction = ()=>true;
    const $d63a49f20b6f0a05$var$removingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:focus-within': {
            boxShadow: `0 0 0 2px transparent`,
            outline: 'none'
        }
    });
    const $d63a49f20b6f0a05$var$RemovableTagComponent = (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $d63a49f20b6f0a05$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, (0, parcelRequire("eGmKJ")).default), linkComponent: linkComponent }, ref)=>{
        const [status, setStatus] = (0, $5uXOq.useState)("showing");
        const [isHoverCloseButton, setIsHoverCloseButton] = (0, $5uXOq.useState)(false);
        const onAfterRemoveActionWithAnalytics = (0, (0, parcelRequire("c543i")).useCallbackWithAnalytics)(onAfterRemoveAction, {
            action: 'removed',
            actionSubject: 'tag',
            attributes: {
                componentName: 'tag',
                packageName: $d63a49f20b6f0a05$var$packageName,
                packageVersion: $d63a49f20b6f0a05$var$packageVersion
            }
        }, 'atlaskit');
        const handleRemoveComplete = (0, $5uXOq.useCallback)(()=>{
            onAfterRemoveActionWithAnalytics(text);
            setStatus("removed");
        }, [
            onAfterRemoveActionWithAnalytics,
            text
        ]);
        const handleRemoveRequest = (0, $5uXOq.useCallback)(()=>{
            if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
        }, [
            handleRemoveComplete,
            onBeforeRemoveAction
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((e)=>{
            const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
            if (spacebarOrEnter) {
                e.stopPropagation();
                handleRemoveRequest();
            }
        }, [
            handleRemoveRequest
        ]);
        const removingTag = (0, $5uXOq.useCallback)(()=>setStatus("removing"), []);
        const showingTag = (0, $5uXOq.useCallback)(()=>setStatus("showing"), []);
        const handleMouseOver = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(true), []);
        const handleMouseOut = (0, $5uXOq.useCallback)(()=>setIsHoverCloseButton(false), []);
        const removeButton = isRemovable ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("frUcV")).default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
            onClick: handleRemoveRequest,
            onFocus: removingTag,
            onBlur: showingTag,
            onKeyPress: onKeyPress,
            onMouseOver: handleMouseOver,
            onMouseOut: handleMouseOut,
            testId: `close-button-${testId}`
        }) : undefined;
        const content = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eYXIO")).default), {
            elemBefore: elemBefore,
            isRemovable: isRemovable,
            text: text,
            color: color,
            href: href,
            linkComponent: linkComponent
        });
        const hoverCloseButtonColors = {
            backgroundColor: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
            [(0, (0, parcelRequire("e6s40")).cssVar).color.background.hover]: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? undefined : (0, parcelRequire("2hnSR")).removalHoverBackgroundColors,
            [(0, (0, parcelRequire("e6s40")).cssVar).color.background.active]: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? undefined : (0, parcelRequire("2hnSR")).removalActiveBackgroundColors,
            [(0, (0, parcelRequire("e6s40")).cssVar).color.text.default]: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? undefined : (0, parcelRequire("2hnSR")).removalTextColors,
            [(0, (0, parcelRequire("e6s40")).cssVar).color.text.active]: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? undefined : (0, parcelRequire("2hnSR")).removalTextColors,
            [(0, (0, parcelRequire("e6s40")).cssVar).color.text.link]: (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? undefined : (0, parcelRequire("2hnSR")).removalTextColors
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("35XSW")).default), null, !(status === "removed") && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lM16U")).default), null, (motion)=>{
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5oSQr")).default), {
                ref: (0, (0, parcelRequire("5JjdN")).default)([
                    motion.ref,
                    ref
                ]),
                appearance: appearance,
                color: color,
                testId: testId,
                css: [
                    status === "removing" && $d63a49f20b6f0a05$var$removingStyles
                ],
                style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
                "data-removable": true,
                "data-removing": status === "removing",
                "data-ishoverclosebutton": isHoverCloseButton,
                href: href,
                before: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aXLIT")).default), {
                    elemBefore: elemBefore
                }),
                contentElement: content,
                after: removeButton
            });
        }));
    });
    const $d63a49f20b6f0a05$var$RemovableTag = (0, $5uXOq.memo)($d63a49f20b6f0a05$var$RemovableTagComponent);
    var $d63a49f20b6f0a05$export$2e2bcd8739ae039 = $d63a49f20b6f0a05$var$RemovableTag;
});
parcelRegister("lM16U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c624c149830103aa$export$2e2bcd8739ae039);
    var $lObw7;
    var $bh8Xz;
    var $3GP8X;
    var $fsENI;
    var $35XSW;
    const $c624c149830103aa$var$ShrinkOut = ({ children: children, duration: duration = (0, (0, parcelRequire("lObw7")).smallDurationMs), onFinish: onFinish })=>{
        const [element, setElementRef] = (0, (0, parcelRequire("3GP8X")).useElementRef)();
        const exiting = (0, (0, parcelRequire("35XSW")).useExitingPersistence)();
        const requestAnimationFrame = (0, (0, parcelRequire("bh8Xz")).useRequestAnimationFrame)();
        const setTimeout = (0, (0, parcelRequire("bh8Xz")).useSetTimeout)();
        const direction = exiting.isExiting ? 'exiting' : 'entering';
        (0, (0, parcelRequire("fsENI")).useLayoutEffect)(()=>{
            if (exiting.isExiting && element) {
                const newStyles = {
                    width: `${element.offsetWidth}px`,
                    height: `${element.offsetHeight}px`,
                    boxSizing: 'border-box',
                    willChange: 'width,margin'
                };
                Object.assign(element.style, newStyles);
                requestAnimationFrame(()=>{
                    requestAnimationFrame(()=>{
                        const newStyles = {
                            width: '0px',
                            margin: '0px',
                            transitionTimingFunction: (0, $eba99f58997c09b3$export$929e5a82286172a6),
                            transitionDuration: `${duration}ms`,
                            transitionProperty: 'width,margin'
                        };
                        Object.assign(element.style, newStyles);
                        setTimeout(()=>{
                            exiting.onFinish && exiting.onFinish();
                            onFinish && onFinish('exiting');
                        }, duration);
                    });
                });
            }
        });
        return children({
            ref: setElementRef
        }, direction);
    };
    var $c624c149830103aa$export$2e2bcd8739ae039 = $c624c149830103aa$var$ShrinkOut;
});
const $eba99f58997c09b3$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $eba99f58997c09b3$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $eba99f58997c09b3$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("3GP8X", function(module, exports) {
    $parcel$export(module.exports, "useElementRef", ()=>$19cc13cbd0e78f53$export$ff879f35a69d56b7);
    var $5uXOq = parcelRequire("5uXOq");
    const $19cc13cbd0e78f53$export$ff879f35a69d56b7 = ()=>{
        const elementRef = (0, $5uXOq.useRef)(null);
        const setRef = (0, $5uXOq.useCallback)((ref)=>{
            elementRef.current = ref;
        }, []);
        return [
            elementRef.current,
            setRef
        ];
    };
});
parcelRegister("frUcV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$625906158e0f3c21$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aFYTH;
    var $VSDnB;
    var $5ILhZ;
    var $8CUq3;
    var $e6s40;
    const $625906158e0f3c21$var$removeButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '16px',
        width: '16px',
        margin: 'space.0',
        padding: 'space.0',
        insetInlineEnd: 'space.0',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        appearance: 'none',
        backgroundColor: 'color.background.neutral.subtle',
        border: 'none',
        borderRadius: 'border.radius.050',
        color: 'color.text',
        cursor: 'pointer',
        pointerEvents: 'auto',
        marginInlineStart: 'space.negative.025',
        marginInlineEnd: 'space.negative.025',
        ':focus-visible': {
            outlineOffset: 'space.negative.025'
        },
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.subtle.pressed'
        }
    });
    const $625906158e0f3c21$var$removeButtonStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        height: '16px',
        margin: 'space.0',
        padding: 'space.0',
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        appearance: 'none',
        backgroundColor: 'color.background.neutral.subtle',
        border: 'none',
        borderRadius: `var(${(0, (0, parcelRequire("e6s40")).cssVar).borderRadius})`,
        color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.default})`,
        cursor: 'pointer',
        pointerEvents: 'auto',
        ':focus-visible': {
            outlineOffset: 'space.0'
        },
        ':hover': {
            color: `var(${(0, (0, parcelRequire("e6s40")).cssVar).color.removeButton.hover})`
        }
    });
    const $625906158e0f3c21$var$removeButtonStylesOldIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: 'space.0'
    });
    const $625906158e0f3c21$var$removeButtonStylesNewIcon = (0, (0, parcelRequire("8CUq3")).xcss)({
        insetInlineEnd: 'space.025'
    });
    const $625906158e0f3c21$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $625906158e0f3c21$var$removeButtonStyles : $625906158e0f3c21$var$removeButtonStylesOld,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? $625906158e0f3c21$var$removeButtonStylesNewIcon : $625906158e0f3c21$var$removeButtonStylesOldIcon
            ],
            "aria-label": ariaLabel,
            onClick: onClick,
            onFocus: onFocus,
            onBlur: onBlur,
            onKeyPress: onKeyPress,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            testId: testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFYTH"))))), {
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        }));
    };
    var $625906158e0f3c21$export$2e2bcd8739ae039 = $625906158e0f3c21$var$RemoveButton;
});
parcelRegister("a62T4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2bbfb14e9116a475$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2bbfb14e9116a475$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeLabel: {
            id: 'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel',
            defaultMessage: 'Remove',
            description: "Label text for the \u2018Remove\u2019 button within the tag UI, that is used to unset the selected option in the Prompt screen"
        },
        promptSelected: {
            id: 'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected',
            defaultMessage: '{promptName} - Selected',
            description: 'This message is read to users when a preset ai prompt is selected, the prompt name is dynamic an example is "Brainstorm"'
        }
    });
});
parcelRegister("8xzuB", function(module, exports) {
    $parcel$export(module.exports, "cssVars", ()=>$b3245589229176e5$export$fd62969fb0b7081c);
    $parcel$export(module.exports, "refinementTagStylesVisualRefresh", ()=>$b3245589229176e5$export$adf3075a16997b0e);
    var $f8Sb3;
    const $b3245589229176e5$export$fd62969fb0b7081c = {
        alignItems: '--align-items',
        elemBeforeHeight: '--elem-before-height'
    };
    const $b3245589229176e5$export$adf3075a16997b0e = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        '> span': {
            margin: 0,
            alignItems: `var(${$b3245589229176e5$export$fd62969fb0b7081c.alignItems})`,
            '> span': {
                maxWidth: 'var(--content-width)',
                '&:has([data-testid="command-palette-rovo-agent-icon"])': {
                    height: `var(${$b3245589229176e5$export$fd62969fb0b7081c.elemBeforeHeight})`,
                    marginInline: 0,
                    '> div': {
                        marginInline: 0
                    }
                }
            }
        }
    });
});
parcelRegister("hTcbJ", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6d81ce089b170250$export$defe85febe8b728c);
    var $7VHMR;
    const $6d81ce089b170250$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editPrompt: {
            id: 'fabric.editor.ai.screens.preview.header.edit',
            defaultMessage: 'Edit prompt',
            description: 'Label for the edit prompt button in the preview screen'
        }
    });
});
parcelRegister("8azQn", function(module, exports) {
    $parcel$export(module.exports, "layoutBorderStyles", ()=>$c6f1a303e189a47b$export$702bbf094435183a);
    var $f8Sb3;
    var $ejmVg;
    var $iHYdz;
    const $c6f1a303e189a47b$export$702bbf094435183a = (0, (0, parcelRequire("f8Sb3")).css)("[data-layout-section] [data-layout-column]{border:", (0, (0, parcelRequire("iHYdz")).akEditorSelectedBorderSize), "px solid ", `var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`, ";border-radius:4px;padding:", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING), "px ", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING), "px ", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING), "px ", (0, (0, parcelRequire("ejmVg")).LAYOUT_COLUMN_PADDING), "px;}[data-layout-section]>[data-layout-column]+[data-layout-column]{margin-left:", (0, (0, parcelRequire("ejmVg")).LAYOUT_SECTION_MARGIN), "px;}");
});
parcelRegister("8699W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$97c6b8987126bb8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $97c6b8987126bb8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        iconAltText: {
            id: 'fabric.editor.ai.screens.loading.iconAltText',
            defaultMessage: 'Generating icon',
            description: 'Icon alt text of the Loading screen'
        },
        liveRegionDescription: {
            id: 'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription',
            defaultMessage: 'Live updating content:',
            description: 'Description for content that may update frequently and asynchronously. It is hidden and exists for accessibility'
        },
        loadingAriaTitle: {
            id: 'fabric.editor.ai.experience.loadingAriaTitle',
            defaultMessage: 'Generating',
            description: 'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content'
        }
    });
});
parcelRegister("8l16K", function(module, exports) {
    $parcel$export(module.exports, "previewContainer", ()=>$c3d226c18b35b528$export$8aade8ce2b5d7e87);
    $parcel$export(module.exports, "layoutStyles", ()=>$c3d226c18b35b528$export$ac8f5049e4e10701);
    $parcel$export(module.exports, "logoStyles", ()=>$c3d226c18b35b528$export$ff8f5da7da487b1);
    $parcel$export(module.exports, "titleStyles", ()=>$c3d226c18b35b528$export$405b853093cc10c7);
    var $f8Sb3;
    var $c0bUR;
    function $c3d226c18b35b528$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c3d226c18b35b528$export$8aade8ce2b5d7e87 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
    });
    const $c3d226c18b35b528$export$ac8f5049e4e10701 = {
        name: "8cef5l",
        styles: "display:flex;flex-direction:row;justify-content:left;align-items:center;flex-wrap:wrap"
    };
    const $c3d226c18b35b528$export$ff8f5da7da487b1 = {
        name: "jxdp2j",
        styles: "margin-right:5px;display:flex;align-items:center"
    };
    const $c3d226c18b35b528$var$titleLayoutStyles = {
        name: "82a6rk",
        styles: "flex:1"
    };
    const $c3d226c18b35b528$export$405b853093cc10c7 = [
        $c3d226c18b35b528$var$titleLayoutStyles,
        (0, (0, parcelRequire("c0bUR")).commonTextStyles)
    ];
});
parcelRegister("c0bUR", function(module, exports) {
    $parcel$export(module.exports, "commonTextStyles", ()=>$0e269ffc44f503b8$export$ca5111e3c5be4e7d);
    var $f8Sb3;
    var $3RZIb;
    const $0e269ffc44f503b8$export$ca5111e3c5be4e7d = (0, (0, parcelRequire("f8Sb3")).css)({
        font: `var(--ds-font-body, ${(0, (0, parcelRequire("3RZIb")).fontFallback).body.medium})`,
        wordBreak: 'break-word'
    });
});
parcelRegister("falJd", function(module, exports) {
    $parcel$export(module.exports, "convertPMFragmentToPreview", ()=>$05e9b0bbf428bae8$export$f5e3af6d625de7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $hYNZx;
    var $3WjOo;
    var $MZH0Y;
    const $05e9b0bbf428bae8$var$jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    function $05e9b0bbf428bae8$export$f5e3af6d625de7a({ schema: schema, pmFragment: pmFragment, showTelepointer: showTelepointer, providerFactory: providerFactory }) {
        let jsonDocument;
        const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
        if (!prosemirrorDocument) throw new (0, (0, parcelRequire("MZH0Y")).MarkdownConversionError)({
            message: 'Unable to transform markdown into a valid prosemirror document',
            type: 'noProseMirrorDoc'
        });
        if (prosemirrorDocument.content.size === 0) throw new (0, (0, parcelRequire("MZH0Y")).MarkdownConversionError)({
            message: 'Transforming markdown returns an empty prosemirror document',
            type: 'emptyProseMirrorDoc'
        });
        try {
            jsonDocument = $05e9b0bbf428bae8$var$jsonTransformer.encode(prosemirrorDocument);
        } catch  {
            throw new (0, (0, parcelRequire("MZH0Y")).MarkdownConversionError)({
                message: 'Unable to transform markdown into a valid prosemirror document',
                type: 'invalidProseMirrorDoc'
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3WjOo")).PreviewRenderer), {
            jsonDocument: jsonDocument,
            showTelepointer: showTelepointer,
            providerFactory: providerFactory
        });
    }
});
parcelRegister("3WjOo", function(module, exports) {
    $parcel$export(module.exports, "PreviewRenderer", ()=>$610b491b2cd4610a$export$8ce5f720dc007208);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $f5oqj;
    var $fCNtA;
    var $h1WZC;
    var $iwR8w;
    const $610b491b2cd4610a$export$8ce5f720dc007208 = ({ jsonDocument: jsonDocument, showTelepointer: showTelepointer, providerFactory: providerFactory })=>{
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlow)();
        const previewRendererRef = (0, $5uXOq.useRef)(null);
        const copiedOnceRef = (0, $5uXOq.useRef)(false);
        const onCopyHandler = (0, $5uXOq.useCallback)(async ()=>{
            const previewRendererElement = previewRendererRef.current;
            if (!analyticsFlow || !previewRendererElement) return;
            if (!(0, (0, parcelRequire("iwR8w")).isSelectionWithinElement)(previewRendererElement)) return;
            if ((0, (0, parcelRequire("iwR8w")).isPartialCopy)(previewRendererRef.current)) analyticsFlow.addAttributes({
                contentCopiedPartially: true
            });
            if (copiedOnceRef.current) return;
            analyticsFlow.addAttributes({
                contentCopied: true
            });
            copiedOnceRef.current = true;
        }, [
            analyticsFlow
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const unbind = (0, (0, parcelRequire("cBeZP")).bind)(document, {
                type: 'copy',
                listener: onCopyHandler
            });
            return unbind;
        }, [
            onCopyHandler,
            analyticsFlow
        ]);
        const styles = (0, (0, parcelRequire("f8Sb3")).css)({
            '.code-block .token.token': {
                fontStyle: 'normal',
                fontWeight: 'normal',
                color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`
            }
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": "preview-renderer",
            css: styles,
            ref: previewRendererRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fCNtA")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5oqj")).default), {
            document: jsonDocument,
            media: {
                allowLinking: false
            },
            useSpecBasedValidator: true,
            addTelepointer: showTelepointer,
            dataProviders: providerFactory,
            allowPlaceholderText: true
        }))));
    };
});
parcelRegister("iwR8w", function(module, exports) {
    $parcel$export(module.exports, "copyResponseToClipboard", ()=>$65f441d99f709a83$export$12165218b356df9f);
    $parcel$export(module.exports, "isPartialCopy", ()=>$65f441d99f709a83$export$d109786c97a20f08);
    $parcel$export(module.exports, "isSelectionWithinElement", ()=>$65f441d99f709a83$export$60519e70a23320fb);
    var $cYcwl;
    var $kCV8T;
    const $65f441d99f709a83$var$toDOM = (fragment, schema)=>{
        return (0, (0, parcelRequire("kCV8T")).DOMSerializer).fromSchema(schema).serializeFragment(fragment);
    };
    function $65f441d99f709a83$var$clipboardTextSerializer(fragment) {
        let text = '';
        const blockSeparater = '\n\n';
        fragment.nodesBetween(0, fragment.size, (node)=>{
            if (node.type.isBlock) text += blockSeparater;
            if (node.type.name === 'paragraph') return true;
            else if (node.type.name === 'hardBreak') text += '\n';
            else if (node.type.name === 'text') text += node.text;
            else if (node.type.name === 'inlineCard') text += node.attrs.url;
            else if (node.type.name === 'blockCard') text += node.attrs.url;
            else text += node.textBetween(0, node.content.size, '\n\n');
            return false;
        });
        return text.trim();
    }
    function $65f441d99f709a83$export$12165218b356df9f({ editorView: editorView, pmFragment: pmFragment }) {
        const transaction = editorView.state.tr;
        const domNode = $65f441d99f709a83$var$toDOM(pmFragment, editorView.state.schema);
        if (domNode) {
            const div = document.createElement('div');
            div.appendChild(domNode);
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            (0, (0, parcelRequire("cYcwl")).copyHTMLToClipboard)(div, $65f441d99f709a83$var$clipboardTextSerializer(pmFragment));
        }
        transaction.setMeta('scrollIntoView', false);
        editorView.dispatch(transaction);
    }
    function $65f441d99f709a83$export$d109786c97a20f08(targetElement) {
        const selection = window.getSelection();
        const selectionText = selection?.toString();
        if (!selectionText) return false;
        const strippedPreviewResponseText = targetElement.innerText.replace(/\n/g, '').trim();
        const strippedSelectionText = selectionText.replace(/\n/g, '').trim();
        let isSelectionOutsideTargetElement = false;
        let isSelectionWholeAndMore = false;
        if (selection) {
            const { anchorNode: anchorNode, focusNode: focusNode } = selection;
            const selectionStartsOutside = !targetElement.contains(anchorNode);
            const selectionEndsOutside = !targetElement.contains(focusNode);
            isSelectionOutsideTargetElement = selectionStartsOutside && selectionEndsOutside;
            const selectionStartsAtStart = selection.anchorOffset === 0;
            const selectionEndsAtEnd = selection.focusOffset === focusNode?.textContent?.length;
            const startsOutsideAndEndsAtEnd = selectionStartsOutside && selectionEndsAtEnd;
            const startsAtStartAndEndsOutside = selectionEndsOutside && selectionStartsAtStart;
            if (startsOutsideAndEndsAtEnd || startsAtStartAndEndsOutside) isSelectionWholeAndMore = true;
        }
        if (isSelectionOutsideTargetElement || isSelectionWholeAndMore) return false;
        return strippedPreviewResponseText !== strippedSelectionText;
    }
    function $65f441d99f709a83$export$60519e70a23320fb(element) {
        const selection = window.getSelection();
        if (!selection?.rangeCount || !selection.toString()) return false;
        const { anchorNode: anchorNode, focusNode: focusNode } = selection;
        if (!anchorNode || !focusNode) return false;
        if ([
            anchorNode,
            focusNode
        ].some((node)=>element.contains(node))) return true;
        const isLTRSelection = anchorNode.compareDocumentPosition(focusNode) & Node.DOCUMENT_POSITION_FOLLOWING;
        const startNode = isLTRSelection ? selection.anchorNode : selection.focusNode;
        const endNode = isLTRSelection ? selection.focusNode : selection.anchorNode;
        if (!startNode || !endNode) return false;
        if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) return true;
        if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) return true;
        return false;
    }
});
parcelRegister("2akUm", function(module, exports) {
    $parcel$export(module.exports, "getPMFragmentWithFallback", ()=>$ad01c1d9c802a1c0$export$a08e8b3dacf7ffcc);
    var $gkwXh;
    var $kCV8T;
    var $3n50y;
    var $gPFN1;
    function $ad01c1d9c802a1c0$export$a08e8b3dacf7ffcc({ markdown: markdown, schema: schema, source: source, fireAIAnalyticsEvent: fireAIAnalyticsEvent, idMap: idMap }) {
        try {
            const { pmFragment: pmFragment, htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes, htmlConvertedToNodes: htmlConvertedToNodes } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                schema: schema,
                markdown: markdown,
                idMap: idMap,
                featureToggles: {
                    markdownPlus: true,
                    markdownPlusExtensions: true,
                    markdownPlusPanels: true,
                    markdownPlusDecisions: true
                }
            });
            return {
                pmFragment: pmFragment,
                htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
                htmlConvertedToNodes: htmlConvertedToNodes,
                isTextFallbackUsed: false
            };
        } catch (error) {
            fireAIAnalyticsEvent({
                payload: {
                    action: 'failed',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'markdownParser',
                    attributes: {
                        source: source,
                        errorType: 'markdownParser',
                        errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                }
            });
            const fallbackPMFragment = (0, (0, parcelRequire("kCV8T")).Fragment).from(schema.nodes.paragraph.create(null, schema.text(markdown)));
            return {
                pmFragment: fallbackPMFragment,
                htmlConvertedToFallbackNodes: 0,
                htmlConvertedToNodes: 0,
                isTextFallbackUsed: true
            };
        }
    }
});
parcelRegister("gHhcU", function(module, exports) {
    $parcel$export(module.exports, "useAIUsageDisclaimer", ()=>$251a2f1230f2aa1c$export$b38eff301cbfa415);
    var $koVbs;
    const $251a2f1230f2aa1c$export$b38eff301cbfa415 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let disclaimer;
        const { aiUsageDisclaimer: aiUsageDisclaimer } = editorPluginAIProvider;
        if (aiUsageDisclaimer) disclaimer = {
            text: formatMessage(aiUsageDisclaimer.text),
            tooltip: formatMessage(aiUsageDisclaimer.tooltip),
            url: aiUsageDisclaimer.url
        };
        return disclaimer;
    };
});
parcelRegister("k7UkR", function(module, exports) {
    $parcel$export(module.exports, "PreviewScreenWithLogic", ()=>$b2ccf954a15f53f2$export$705df12804ca7004);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gkwXh;
    var $kCV8T;
    var $cgL5K;
    var $gmhCD = parcelRequire("gmhCD");
    var $7aBvu;
    var $7cYAt;
    var $kb0r3;
    var $h1WZC;
    var $9m3ZB;
    var $PwAM5;
    var $hYL9h;
    var $falJd;
    var $5pb98;
    var $gPFN1;
    var $2akUm;
    var $6KJH7;
    var $8Oaok;
    var $iozk0;
    var $iwR8w;
    var $48T0b;
    var $aMkyX;
    var $c9MKk;
    var $gHhcU;
    const $b2ccf954a15f53f2$var$prefillPromptRecordValues = Object.values((0, (0, parcelRequire("hYL9h")).prefillPromptRecord));
    function $b2ccf954a15f53f2$export$705df12804ca7004({ aiExperienceMachineContext: aiExperienceMachineContext, isInputActive: isInputActive, backendModel: backendModel, rovoAction: rovoAction, rovoPublish: rovoPublish }) {
        const { formatMessage: formatMessage, locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { parentPresetPromptLabel: parentPresetPromptLabel, latestPrompt: latestPrompt, markdown: actualMarkdown, multiPrompts: multiPrompts, configItem: configItem, userInput: actualUserInput, userADFInput: actualUserADFInput, editCount: editCount, retryPromptCount: retryPromptCount, refinementCount: refinementCount, idMap: idMap, responseHistory: history, contextStatistics: contextStatistics, promptTrigger: promptTrigger, channelId: channelId, fragment: fragment, feedbackSubmitted: feedbackSubmitted } = aiExperienceMachineContext;
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, endExperience: endExperience, positions: positions, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, lastTriggeredFrom: lastTriggeredFrom, modalRef: modalRef, triggeredFor: triggeredFor } = aiExperienceCommonData;
        const disclaimer = (0, (0, parcelRequire("gHhcU")).useAIUsageDisclaimer)({
            editorPluginAIProvider: editorPluginAIProvider
        });
        const childShortTitle = parentPresetPromptLabel && configItem.nestingConfig ? formatMessage(configItem.nestingConfig.shortTitle) : '';
        const userInput = actualUserInput || '';
        const userADFInput = actualUserADFInput;
        const schema = editorView.state.schema;
        const product = editorPluginAIProvider.product;
        (0, $5uXOq.useEffect)(()=>{
            editorPluginAIProvider.onExperienceEvent?.REVIEW_STATE_ENTERED();
        }, [
            editorPluginAIProvider
        ]);
        const clearInputRef = (0, $5uXOq.useRef)();
        const lastHistoryEvent = history.entries[history.positionFromEnd];
        const responseTooSimilar = lastHistoryEvent.responseTooSimilar;
        const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
        let markdown = actualMarkdown || '';
        const hasAcceptableUseWarning = (0, (0, parcelRequire("aMkyX")).getHasAcceptableUseWarning)({
            markdown: markdown,
            locale: locale
        });
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlow)();
        const enqueuedPreviewStep = (0, $5uXOq.useRef)(false);
        const errorReported = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const [multiPromptIndex, setMultiPromptIndex] = (0, $5uXOq.useState)(0);
        const combinedPrompts = (0, $5uXOq.useMemo)(()=>{
            return multiPrompts && multiPrompts?.length ? [
                {
                    name: configItem.title,
                    content: markdown
                },
                ...multiPrompts || []
            ] : undefined;
        }, [
            markdown,
            multiPrompts,
            configItem.title
        ]);
        const combinedPromptsWithMarkdown = (0, $5uXOq.useMemo)(()=>{
            const pmFragmentPreviewData = (0, (0, parcelRequire("2akUm")).getPMFragmentWithFallback)({
                markdown: combinedPrompts ? combinedPrompts[multiPromptIndex].content : markdown,
                schema: schema,
                source: 'preview',
                fireAIAnalyticsEvent: (event)=>{
                    if (!errorReported.current) {
                        errorReported.current = true;
                        fireAIAnalyticsEvent(event);
                    }
                },
                idMap: idMap
            });
            const pmFragment = pmFragmentPreviewData?.pmFragment || (0, (0, parcelRequire("kCV8T")).Fragment).empty;
            const preview = (0, (0, parcelRequire("falJd")).convertPMFragmentToPreview)({
                schema: schema,
                pmFragment: pmFragment,
                showTelepointer: false,
                providerFactory: providerFactory
            });
            return combinedPrompts ? combinedPrompts.map((item)=>({
                    name: item.name,
                    content: preview
                })) : undefined;
        }, [
            combinedPrompts,
            fireAIAnalyticsEvent,
            idMap,
            markdown,
            multiPromptIndex,
            providerFactory,
            schema
        ]);
        const [multiPromptPresetTitle, setMultiPromptPresetTitle] = (0, $5uXOq.useState)(combinedPrompts && multiPromptIndex ? formatMessage(combinedPrompts[multiPromptIndex].name) : undefined);
        const [isMultiPromptLoading, setIsMultiPromptLoading] = (0, $5uXOq.useState)(!!multiPrompts);
        const [multiPromptCycleCount, setMultiPromptCycleCount] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            if (multiPrompts && multiPrompts.length > 1) setIsMultiPromptLoading(false);
        }, [
            multiPrompts,
            setIsMultiPromptLoading
        ]);
        if (markdown && (0, (0, parcelRequire("5pb98")).isConfluenceTitleToolbarSuggestTitle)({
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom
        })) markdown = (0, (0, parcelRequire("c9MKk")).stripMatchingOuterQuotes)(markdown);
        const pmFragmentPreviewData = (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') && fragment ? {
            pmFragment: fragment,
            htmlConvertedToNodes: 0,
            htmlConvertedToFallbackNodes: 0,
            isTextFallbackUsed: false
        } : (0, (0, parcelRequire("2akUm")).getPMFragmentWithFallback)({
            markdown: combinedPrompts ? combinedPrompts[multiPromptIndex].content : markdown,
            schema: schema,
            source: 'preview',
            fireAIAnalyticsEvent: (event)=>{
                if (!errorReported.current) {
                    errorReported.current = true;
                    fireAIAnalyticsEvent(event);
                }
            },
            idMap: idMap
        });
        const pmFragment = pmFragmentPreviewData?.pmFragment || (0, (0, parcelRequire("kCV8T")).Fragment).empty;
        const preview = getPreviewElement(pmFragment);
        (0, (0, parcelRequire("iozk0")).useOutsideClickHandler)({
            modalRef: modalRef,
            userInput: userInput,
            onCancel: ()=>sendToAIExperienceMachine({
                    type: 'enable discard'
                }),
            onDiscard: ()=>sendToAIExperienceMachine({
                    type: 'enable discard'
                })
        });
        const getMultiPromptAnalyticsAttributes = (0, $5uXOq.useCallback)(()=>{
            return combinedPrompts ? {
                multiPromptCycleCount: multiPromptCycleCount,
                multiPromptExperienceName: multiPromptPresetTitle ?? formatMessage(configItem.title)
            } : {};
        }, [
            combinedPrompts,
            configItem.title,
            formatMessage,
            multiPromptCycleCount,
            multiPromptPresetTitle
        ]);
        const getResponseHistoryAnalytics = (0, $5uXOq.useCallback)(()=>{
            return {
                history: {
                    totalSize: history.totalSize,
                    length: history.entries.length,
                    lastDepth: history.positionFromEnd,
                    traversals: history.traversals
                }
            };
        }, [
            history
        ]);
        function getPreviewElement(pmFragment) {
            if (responseTooSimilar) {
                const responseTooSimilarMessage = formatMessage((0, (0, parcelRequire("6KJH7")).messages).responseTooSimilarMessage);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "p"
                }, responseTooSimilarMessage);
            }
            return (0, (0, parcelRequire("falJd")).convertPMFragmentToPreview)({
                schema: schema,
                pmFragment: pmFragment,
                showTelepointer: false,
                providerFactory: providerFactory
            });
        }
        (0, $5uXOq.useEffect)(()=>{
            analyticsFlow.fireQueuedStep('preview');
            let modelIO;
            if (pmFragmentPreviewData) {
                const stats = new (0, (0, parcelRequire("7aBvu")).ProseMirrorContentStatistics)(pmFragment);
                const contentStatistics = stats.collectStatistics();
                modelIO = {
                    selectionSize: lastHistoryEvent.modelInput.selection?.length,
                    nodesConvertedToHTMLInput: idMap ? Object.keys(idMap).length : undefined,
                    outputHTMLConvertedToNodes: pmFragmentPreviewData.htmlConvertedToNodes,
                    outputHTMLConvertedToFallbackNodes: pmFragmentPreviewData.htmlConvertedToFallbackNodes,
                    isTextFallbackUsed: pmFragmentPreviewData.isTextFallbackUsed,
                    previewNodeCounts: contentStatistics.nodeCounts,
                    previewMarkCounts: contentStatistics.markCounts,
                    previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
                    userInputCharacterCount: localizedLatestPrompt.userInput?.length
                };
            }
            analyticsFlow.addAttributes({
                editCount: editCount,
                responseTooSimilar: responseTooSimilar,
                modelIO: {
                    contextStatistics: contextStatistics,
                    ...modelIO
                },
                inputOutputDiffRatio: inputOutputDiffRatio
            });
            return ()=>{
                if (enqueuedPreviewStep.current === false) analyticsFlow.enqueueStep({
                    stepName: 'preview',
                    attributes: undefined
                });
            };
        }, []);
        const fireDismissEvent = (0, $5uXOq.useCallback)(()=>{
            fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('dismissed', channelId ?? analyticsFlow.getLastAiInteractionId(), (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()), false, {
                    ...getMultiPromptAnalyticsAttributes(),
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                })
            });
        }, [
            analyticsFlow,
            channelId,
            configItem.key,
            fireAIAnalyticsEvent,
            getMultiPromptAnalyticsAttributes
        ]);
        const fireResponseFeedbackEvent = (sentiment, productSuccessState)=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'responseFeedbackButton',
                    attributes: {
                        sentiment: sentiment,
                        hasAcceptableUseWarning: hasAcceptableUseWarning,
                        appearance: appearance,
                        product: product,
                        configItemTitle: configItem.agent?.name || configItem.key,
                        lastTriggeredFrom: lastTriggeredFrom,
                        productSuccessStatus: productSuccessState,
                        inputOutputDiffRatio: inputOutputDiffRatio,
                        retryPromptCount: retryPromptCount,
                        responseTooSimilar: responseTooSimilar,
                        aiInteractionID: analyticsFlow.getLastAiInteractionId(),
                        ...getMultiPromptAnalyticsAttributes()
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                }
            });
            fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('submitted', channelId ?? analyticsFlow.getLastAiInteractionId(), (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()), false, {
                    ...getMultiPromptAnalyticsAttributes(),
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                })
            });
        };
        const handleFiringFeedbackEvent = async (feedbackMetadata)=>{
            analyticsFlow.addAttributes({
                userFeedbackSentiment: feedbackMetadata.sentiment
            });
            sendToAIExperienceMachine({
                type: 'feedback submitted',
                sentiment: feedbackMetadata.sentiment
            });
            if (!editorPluginAIProvider.handleFeedbackSubmission) {
                fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
                return;
            } else try {
                const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
                fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
            } catch  {
                fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
            }
        };
        const localizedLatestPrompt = (0, $5uXOq.useMemo)(()=>{
            return latestPrompt?.presetTitle ? {
                presetTitle: (0, (0, parcelRequire("PwAM5")).getTranslatedItemTitle)(latestPrompt.presetTitle, formatMessage),
                userInput: latestPrompt?.userInput,
                userADFInput: latestPrompt?.userADFInput
            } : {
                userInput: latestPrompt?.userInput || '',
                userADFInput: latestPrompt?.userADFInput
            };
        }, [
            latestPrompt,
            formatMessage
        ]);
        const onEditPromptClick = (0, $5uXOq.useCallback)(()=>{
            const { userInput: userInput, userADFInput: userADFInput, presetTitle: presetTitle } = localizedLatestPrompt;
            analyticsFlow.addAttributes({
                actionTaken: 'edit-prompt'
            });
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'editPromptButton',
                    attributes: {
                        experienceType: (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()),
                        editCount: editCount,
                        ...getMultiPromptAnalyticsAttributes()
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                }
            });
            fireDismissEvent();
            sendToAIExperienceMachine({
                type: 'edit prompt',
                userInput: userInput,
                userADFInput: userADFInput,
                presetTitle: presetTitle
            });
        }, [
            configItem.key,
            localizedLatestPrompt,
            analyticsFlow,
            fireAIAnalyticsEvent,
            editCount,
            getMultiPromptAnalyticsAttributes,
            fireDismissEvent,
            sendToAIExperienceMachine
        ]);
        const discardWithoutWarning = (0, $5uXOq.useCallback)(()=>{
            const { presetTitle: presetTitle } = localizedLatestPrompt;
            sendToAIExperienceMachine({
                type: 'edit prompt',
                userInput: '',
                userADFInput: undefined,
                presetTitle: presetTitle
            });
        }, [
            localizedLatestPrompt,
            sendToAIExperienceMachine
        ]);
        const onBack = (0, $5uXOq.useCallback)(()=>{
            sendToAIExperienceMachine({
                type: 'enable discard',
                context: {
                    onceDiscard: discardWithoutWarning
                }
            });
        }, [
            sendToAIExperienceMachine,
            discardWithoutWarning
        ]);
        const aiExperienceMetadata = {
            hasAcceptableUseWarning: hasAcceptableUseWarning,
            configItemTitle: configItem.agent?.name || (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()),
            lastTriggeredFrom: lastTriggeredFrom,
            inputOutputDiffRatio: inputOutputDiffRatio,
            backendModel: backendModel
        };
        const getAIExperience = (hasUserConsent)=>({
                ...aiExperienceMetadata,
                ...hasUserConsent && {
                    userPrompt: localizedLatestPrompt.userInput,
                    markdownResponse: markdown
                }
            });
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!userInput) clearInputRef.current?.();
        }, [
            userInput
        ]);
        const onInputChange = (0, ($parcel$interopDefault($5uXOq))).useCallback((inputValue)=>{
            sendToAIExperienceMachine({
                type: 'update user input',
                input: inputValue
            });
        }, [
            sendToAIExperienceMachine
        ]);
        const onADFChange = (0, ($parcel$interopDefault($5uXOq))).useCallback((inputValue)=>{
            sendToAIExperienceMachine({
                type: 'update user input adf',
                adf: inputValue
            });
        }, [
            sendToAIExperienceMachine
        ]);
        const disableInterrogation = configItem.disableInterrogation?.() || editorPluginAIProvider.disableInterrogation || history.positionFromEnd > 0;
        const onCancelClick = (0, $5uXOq.useCallback)(()=>{
            if (userInput) {
                fireDismissEvent();
                sendToAIExperienceMachine({
                    type: 'cancel refinement'
                });
            } else {
                fireDismissEvent();
                discardWithoutWarning();
            }
        }, [
            userInput,
            discardWithoutWarning,
            fireDismissEvent,
            sendToAIExperienceMachine
        ]);
        const onRetryPromptClick = (0, $5uXOq.useCallback)(()=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'retryPromptButton',
                    attributes: {
                        experienceType: (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()),
                        ...getMultiPromptAnalyticsAttributes()
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                }
            });
            fireDismissEvent();
            sendToAIExperienceMachine({
                type: 'retry prompt',
                input: localizedLatestPrompt.userInput,
                adf: localizedLatestPrompt.userADFInput
            });
        }, [
            configItem.key,
            fireAIAnalyticsEvent,
            fireDismissEvent,
            getMultiPromptAnalyticsAttributes,
            localizedLatestPrompt.userADFInput,
            localizedLatestPrompt.userInput,
            sendToAIExperienceMachine
        ]);
        const onActionButtonClick = (0, $5uXOq.useCallback)(({ runFn: runFn, analyticsTitle: analyticsTitle, preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete })=>{
            try {
                analyticsFlow.addAttributes({
                    actionTaken: analyticsTitle
                });
                analyticsFlow.enqueueStep({
                    stepName: 'preview',
                    attributes: {
                        ...getMultiPromptAnalyticsAttributes()
                    }
                });
                enqueuedPreviewStep.current = true;
                analyticsFlow.fireQueuedStep('complete');
                const beforeActionRun = performance.now();
                runFn();
                analyticsFlow.enqueueStep({
                    stepName: 'complete',
                    attributes: {
                        actionTaken: analyticsTitle,
                        duration: Math.round(performance.now() - beforeActionRun),
                        editCount: editCount,
                        retryPromptCount: retryPromptCount,
                        promptType: promptTrigger,
                        refinementCount: refinementCount,
                        inputOutputDiffRatio: inputOutputDiffRatio,
                        ...getMultiPromptAnalyticsAttributes(),
                        ...getResponseHistoryAnalytics()
                    }
                });
                if ((0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true)) {
                    const localizedUserInput = localizedLatestPrompt.userInput;
                    if (localizedUserInput) {
                        const matchingUserInput = $b2ccf954a15f53f2$var$prefillPromptRecordValues.find(({ message: message })=>localizedUserInput.startsWith(formatMessage(message)));
                        if (matchingUserInput) analyticsFlow.addAttributes({
                            prefilledWith: matchingUserInput.key
                        });
                    }
                }
                editorPluginAIProvider.onExperienceEvent?.EXPERIENCE_COMPLETE();
                endExperience({
                    preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
                });
            } catch (error) {
                fireAIAnalyticsEvent({
                    payload: {
                        action: 'unhandledErrorCaught',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'experienceApplication',
                        attributes: {
                            errorType: 'actionRunError',
                            actionTitle: analyticsTitle,
                            errorMessage: (0, (0, parcelRequire("gPFN1")).ErrorUtils).extractErrorMessage(error)
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                    }
                });
                sendToAIExperienceMachine({
                    type: 'error',
                    errorInfo: {
                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).UNKNOWN
                    }
                });
            }
        }, [
            analyticsFlow,
            editCount,
            editorPluginAIProvider.onExperienceEvent,
            endExperience,
            fireAIAnalyticsEvent,
            getMultiPromptAnalyticsAttributes,
            getResponseHistoryAnalytics,
            inputOutputDiffRatio,
            retryPromptCount,
            promptTrigger,
            refinementCount,
            sendToAIExperienceMachine,
            localizedLatestPrompt.userInput,
            formatMessage
        ]);
        const mapMarkdownAction = (0, $5uXOq.useCallback)((action)=>{
            const contentFragment = action.isRovoAgentAction && rovoAction ? (0, (0, parcelRequire("2akUm")).getPMFragmentWithFallback)({
                markdown: rovoAction.content || '',
                schema: schema,
                source: 'rovo-action',
                fireAIAnalyticsEvent: ()=>{},
                idMap: {}
            }).pmFragment : pmFragment;
            const { isDisabled: isDisabled, tooltip: tooltip } = action.getDisabledState?.({
                markdown: markdown,
                formatMessage: formatMessage
            }) ?? {};
            return {
                label: formatMessage(action.title),
                appearance: action.appearance,
                onClick: ()=>{
                    onActionButtonClick({
                        runFn: ()=>{
                            action.run({
                                editorView: editorView,
                                positions: positions,
                                markdown: combinedPrompts ? combinedPrompts[multiPromptIndex].content : markdown,
                                pmFragment: contentFragment,
                                triggeredFor: triggeredFor
                            });
                            if (configItem.agent && editorPluginAIProvider.onDocChangeByAgent) editorPluginAIProvider.onDocChangeByAgent(configItem.agent);
                        },
                        analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : ''
                    });
                },
                isDisabled: isDisabled,
                tooltip: tooltip
            };
        }, [
            rovoAction,
            schema,
            pmFragment,
            formatMessage,
            onActionButtonClick,
            editorView,
            positions,
            combinedPrompts,
            multiPromptIndex,
            markdown,
            triggeredFor,
            configItem.agent,
            editorPluginAIProvider
        ]);
        const mapAgentAction = (0, $5uXOq.useCallback)((action)=>{
            return {
                label: formatMessage(action.title),
                appearance: action.appearance,
                icon: action.icon,
                shortcut: action.shortcut,
                onClick: ()=>{
                    onActionButtonClick({
                        runFn: ()=>action.run({
                                channelId: channelId,
                                publish: rovoPublish
                            }),
                        analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : '',
                        preserveEditorSelectionOnComplete: action.preserveEditorSelectionOnComplete
                    });
                }
            };
        }, [
            channelId,
            formatMessage,
            onActionButtonClick,
            rovoPublish
        ]);
        const onMultiPromptClick = (0, $5uXOq.useCallback)((direction)=>{
            const mutlipromptsLength = combinedPrompts.length;
            let index = multiPromptIndex + direction;
            if (index < 0) index = mutlipromptsLength - 1;
            else if (index >= mutlipromptsLength) index = 0;
            setMultiPromptCycleCount((count)=>count + 1);
            setMultiPromptIndex(index);
            setMultiPromptPresetTitle(formatMessage(combinedPrompts[index].name));
        }, [
            combinedPrompts,
            multiPromptIndex,
            formatMessage
        ]);
        const firstConfigItemActions = history.entries[0]?.configItem?.actions;
        const applications = (0, $5uXOq.useMemo)(()=>{
            let actions = configItem.actions;
            if ((0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true)) actions = firstConfigItemActions || actions;
            return actions.map((action)=>{
                if (action.type === 'agent') return mapAgentAction(action);
                return mapMarkdownAction(action);
            });
        }, [
            configItem.actions,
            firstConfigItemActions,
            mapMarkdownAction,
            mapAgentAction
        ]);
        const refineDropdownItems = (0, $5uXOq.useMemo)(()=>{
            const allRefineSuggestions = editorPluginAIProvider.rangeConfig.getSuggestions({
                inputValue: ''
            }).filter((suggestion)=>suggestion.showInRefineDropdown);
            const result = [];
            const parentForNesting = {};
            const handleClick = (configItem)=>()=>{
                    sendToAIExperienceMachine({
                        type: 'refine',
                        configItem: configItem,
                        latestPromptResponse: markdown
                    });
                };
            for (const suggestion of allRefineSuggestions){
                const { nestingConfig: nestingConfig } = suggestion;
                if (!nestingConfig) result.push({
                    title: suggestion.title,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, suggestion.icon?.({
                        formatMessage: formatMessage,
                        shownAt: 'suggestions'
                    })),
                    onClick: handleClick(suggestion)
                });
                else {
                    const parentKey = nestingConfig.parentTitle.id ?? JSON.stringify(nestingConfig.parentTitle);
                    if (!parentForNesting[parentKey]) {
                        const icon = nestingConfig.icon || suggestion.icon;
                        const parent = {
                            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, " ", icon?.({
                                formatMessage: formatMessage,
                                shownAt: 'suggestions'
                            }), " "),
                            title: nestingConfig.parentTitle,
                            children: []
                        };
                        result.push(parent);
                        parentForNesting[parentKey] = parent;
                    }
                    parentForNesting[parentKey].children?.push({
                        title: suggestion.nestingConfig?.shortTitle ?? suggestion.title,
                        onClick: handleClick(suggestion)
                    });
                }
            }
            return result;
        }, [
            editorPluginAIProvider.rangeConfig,
            formatMessage,
            markdown,
            sendToAIExperienceMachine
        ]);
        const historyProps = (0, ($parcel$interopDefault($5uXOq))).useMemo(()=>{
            if ((0, $gmhCD.editorExperiment)('platform_editor_ai_response_history', true)) return {
                onTraverse: (direction)=>{
                    fireAIAnalyticsEvent({
                        payload: {
                            action: 'click',
                            actionSubject: 'editorPluginAI',
                            actionSubjectId: 'traverseHistoryButton',
                            attributes: {
                                direction: direction
                            },
                            eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                        }
                    });
                    sendToAIExperienceMachine({
                        type: 'traverse history',
                        direction: direction
                    });
                },
                showButtons: history.entries.length > 1,
                canTraverseForward: history.positionFromEnd > 0,
                canTraverseBack: history.positionFromEnd < history.entries.length - 1
            };
        }, [
            fireAIAnalyticsEvent,
            history.entries.length,
            history.positionFromEnd,
            sendToAIExperienceMachine
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cYAt")).PreviewScreen), {
            key: multiPromptPresetTitle ?? configItem.key,
            parentPresetPromptLabel: parentPresetPromptLabel,
            childShortTitle: childShortTitle,
            latestPrompt: localizedLatestPrompt,
            preview: preview,
            disableActions: !!responseTooSimilar,
            inputValue: userInput,
            inputADFValue: userADFInput,
            isInputActive: isInputActive,
            onCancel: onCancelClick,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            onInputFocus: ()=>{
                sendToAIExperienceMachine({
                    type: 'start refinement'
                });
            },
            onInputBlur: ()=>{
                if (!userInput) sendToAIExperienceMachine({
                    type: 'cancel refinement'
                });
            },
            onSubmit: ()=>{
                sendToAIExperienceMachine({
                    type: 'interrogate',
                    userInput: userInput,
                    userADFInput: userADFInput,
                    latestPromptResponse: markdown
                });
            },
            onCopy: ()=>{
                fireAIAnalyticsEvent({
                    payload: {
                        action: 'click',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'copyButton',
                        attributes: {
                            experienceType: (0, (0, parcelRequire("kb0r3")).convertExperienceName)(configItem.key.toString()),
                            editCount: editCount,
                            ...getMultiPromptAnalyticsAttributes()
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    }
                });
                analyticsFlow.addAttributes({
                    contentCopied: true
                });
                (0, (0, parcelRequire("iwR8w")).copyResponseToClipboard)({
                    editorView: editorView,
                    pmFragment: pmFragment
                });
            },
            onRetry: !configItem.agent ? onRetryPromptClick : undefined,
            onGoodResponseButtonClick: ()=>{
                const feedbackMetadata = {
                    sentiment: 'good',
                    getAIExperience: getAIExperience,
                    editorAttributes: {
                        appearance: appearance,
                        product: product
                    }
                };
                editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
                handleFiringFeedbackEvent(feedbackMetadata);
            },
            onBadResponseButtonClick: ()=>{
                const feedbackMetadata = {
                    sentiment: 'bad',
                    getAIExperience: getAIExperience,
                    editorAttributes: {
                        appearance: appearance,
                        product: product
                    }
                };
                editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
                handleFiringFeedbackEvent(feedbackMetadata);
            },
            onEditPromptClick: onEditPromptClick,
            onBack: onBack,
            applications: applications,
            secondaryActions: (configItem.secondaryActions ?? []).map((action)=>mapAgentAction(action)),
            PromptEditor: editorPluginAIProvider.PromptEditor,
            clearInputRef: clearInputRef,
            disclaimer: disclaimer,
            providerFactory: providerFactory,
            schema: schema,
            disableInterrogation: disableInterrogation,
            agent: configItem.agent,
            multiPrompts: combinedPromptsWithMarkdown,
            onMultiPromptClick: onMultiPromptClick,
            multiPromptPresetTitle: multiPromptPresetTitle,
            multiPromptIndex: multiPromptIndex,
            isMultiPromptLoading: isMultiPromptLoading,
            refineDropdownItems: refineDropdownItems,
            historyProps: historyProps,
            feedbackSubmitted: feedbackSubmitted
        });
    }
});
parcelRegister("7cYAt", function(module, exports) {
    $parcel$export(module.exports, "PreviewScreen", ()=>$d4c90928596b59ec$export$9f3706359963c421);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3T6Xo = parcelRequire("3T6Xo");
    var $koVbs;
    var $eCeGD;
    var $42CjB;
    var $lRheX;
    var $3dGN0;
    var $VSDnB;
    var $luBm6;
    var $gmhCD = parcelRequire("gmhCD");
    var $3bDjY;
    var $jldZL;
    var $bkz8X;
    var $4xWnr;
    var $3ABQo;
    var $jl6s6;
    var $g0RiJ;
    var $2gMC9;
    var $i6nji;
    var $3jnEv;
    var $99dxo;
    var $59RNb;
    var $8OUgt;
    var $ejRBn;
    var $8azQn;
    var $bDYQc;
    var $erFIU;
    var $cIVH6;
    var $6xbJx;
    const $d4c90928596b59ec$var$mapActionAppearanceToButtonAppearance = {
        primary: 'primary',
        secondary: 'default',
        cancel: 'subtle'
    };
    const $d4c90928596b59ec$export$9f3706359963c421 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, staticPromptTitle: staticPromptTitle, staticInsertedPrompt: staticInsertedPrompt, latestPrompt: latestPrompt, preview: preview, disableActions: disableActions = false, disableInterrogation: disableInterrogation = false, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputBlur: onInputBlur, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onBack: onBack, onClose: onClose, showBack: showBack = true, applications: applications, secondaryActions: secondaryActions = [], isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, PromptEditor: PromptEditor, clearInputRef: clearInputRef, providerFactory: providerFactory, schema: schema, disclaimer: disclaimer, agent: agent, multiPrompts: multiPrompts, onMultiPromptClick: onMultiPromptClick, multiPromptPresetTitle: multiPromptPresetTitle, multiPromptIndex: multiPromptIndex, isMultiPromptLoading: isMultiPromptLoading, refineDropdownItems: refineDropdownItems, hideHorizontalRule: hideHorizontalRule = false, showBetaLozenge: showBetaLozenge = false, historyProps: historyProps, feedbackSubmitted: feedbackSubmitted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [forceFocusRing, setForceFocusRing] = (0, $5uXOq.useState)(true);
        const presetTitleString = staticPromptTitle ?? multiPromptPresetTitle ?? latestPrompt?.presetTitle;
        const promptString = staticInsertedPrompt ?? latestPrompt?.userInput;
        const firePrimaryApplication = ()=>{
            if (!applications) return;
            setForceFocusRing(false);
            applications[applications.length - 1].onClick();
        };
        const applyButtonFocusStyles = (0, $5uXOq.useCallback)((index)=>{
            return index === applications.length - 1 && forceFocusRing ? (0, (0, parcelRequire("ejRBn")).forceFocusRingStyles) : (0, (0, parcelRequire("ejRBn")).buttonAutoFocusRingFix);
        }, [
            forceFocusRing,
            applications.length
        ]);
        const onInterrogateBlur = (0, $5uXOq.useCallback)(()=>{
            setForceFocusRing(false);
        }, []);
        const handleOnInputFocus = (0, $5uXOq.useCallback)(()=>{
            setForceFocusRing(true);
            if (onInputFocus) onInputFocus();
        }, [
            onInputFocus
        ]);
        const focusInputRef = (0, $5uXOq.useRef)(undefined);
        const initialPlaceholder = agent ? formatMessage((0, (0, parcelRequire("cIVH6")).default).placeholderWithAgent, {
            agentName: agent.name
        }) : formatMessage((0, (0, parcelRequire("cIVH6")).default).defaultInputPlaceholder);
        const enableLinksInPromptEditor = !!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_interrogate_with_convo_ai');
        const isViewingHistoricResponse = !!(disableInterrogation && historyProps);
        const isViewingLatestResponse = !disableActions && !disableInterrogation;
        if (historyProps) (0, $gmhCD.editorExperiment)('platform_editor_ai_response_history', true, {
            exposure: true
        });
        let actionButtons = (0, $5uXOq.useMemo)(()=>{
            const secondaryButtons = !disableActions && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3ABQo")).FeedbackForm), {
                onBadResponseButtonClick: onBadResponseButtonClick,
                onGoodResponseButtonClick: onGoodResponseButtonClick,
                isPressed: feedbackSubmitted,
                isDisabled: isViewingHistoricResponse
            }), historyProps?.showButtons && (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i6nji")).HistoryArrowButton), {
                direction: "back",
                onClick: ()=>historyProps.onTraverse('back'),
                spacing: "compact",
                appearance: "subtle",
                isDisabled: !historyProps.canTraverseBack
            }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i6nji")).HistoryArrowButton), {
                direction: "forward",
                onClick: ()=>historyProps.onTraverse('forward'),
                spacing: "compact",
                appearance: "subtle",
                isDisabled: !historyProps.canTraverseForward
            })), onRetry && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8OUgt")).RetryIconButton), {
                spacing: "compact",
                appearance: "subtle",
                onClick: onRetry,
                isDisabled: isViewingHistoricResponse
            }), onCopy && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4xWnr")).CopyIconButton), {
                spacing: "compact",
                appearance: "subtle",
                onClick: onCopy
            }), secondaryActions.map((action)=>{
                const id = (0, ($parcel$interopDefault($3T6Xo)))(action.analyticsTitle ?? action.label);
                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                    key: id,
                    content: action.label,
                    position: "top"
                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
                    testId: id,
                    type: "button",
                    onClick: action.onClick,
                    icon: action.icon,
                    label: action.label,
                    appearance: "subtle",
                    spacing: "compact"
                }));
            }));
            const cancelButton = onCancel ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
                testId: "discard-button",
                onClick: onCancel,
                type: "button",
                appearance: disableActions ? 'primary' : 'subtle',
                autoFocus: disableActions || applications.length === 0
            }, formatMessage((0, (0, parcelRequire("cIVH6")).default).discardLabel)) : undefined;
            const primaryButtons = !disableActions && applications.map(({ onClick: onClick, label: label, appearance: appearance, shortcut: shortcut, isDisabled: isDisabled, tooltip: tooltip }, index)=>{
                const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bkz8X")).ButtonWithShortcut), {
                    key: label,
                    onClick: onClick,
                    type: "button",
                    shortcut: shortcut,
                    autoFocus: appearance === 'primary',
                    css: applyButtonFocusStyles(index),
                    appearance: $d4c90928596b59ec$var$mapActionAppearanceToButtonAppearance[appearance],
                    isDisabled: isDisabled
                }, label);
                if (tooltip) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
                    key: `${label}-tooltip`,
                    content: tooltip,
                    position: "top"
                }, button);
                return button;
            });
            if (primaryButtons && !agent && refineDropdownItems && (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true, {
                exposure: true
            })) primaryButtons.unshift((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("erFIU")).RefineDropdown), {
                items: refineDropdownItems,
                isDisabled: isViewingHistoricResponse
            }));
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bDYQc")).ActionButtonsLayout), {
                cancelButton: cancelButton,
                secondaryButtons: secondaryButtons,
                primaryButtons: primaryButtons
            });
        }, [
            disableActions,
            onBadResponseButtonClick,
            onGoodResponseButtonClick,
            feedbackSubmitted,
            isViewingHistoricResponse,
            historyProps,
            onRetry,
            onCopy,
            secondaryActions,
            onCancel,
            applications,
            formatMessage,
            agent,
            refineDropdownItems,
            applyButtonFocusStyles
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("6xbJx")).columnLayout),
                (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') && (0, (0, parcelRequire("8azQn")).layoutBorderStyles)
            ],
            className: "preview-screen"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jl6s6")).FloatingContainer), {
            disablePadding: true,
            "data-testid": "preview-screen",
            className: `preview-screen ${(0, $4b849073bf4278d5$export$9df59400d72ad68f)}`,
            css: (0, (0, parcelRequire("6xbJx")).containerLayout),
            rainbowBorder: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("cIVH6")).default).previewScreenLabel)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("99dxo")).LatestPromptHeader), {
            parentPresetPromptLabel: parentPresetPromptLabel,
            childShortTitle: childShortTitle,
            prompt: promptString,
            promptADF: latestPrompt?.userADFInput,
            presetTitle: presetTitleString,
            agent: agent,
            providerFactory: providerFactory,
            schema: schema,
            onEditPromptClick: onEditPromptClick,
            showBack: showBack,
            onBack: onBack,
            onClose: onClose
        }), multiPrompts ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("6xbJx")).previewContainerWithMultiPrompt),
                (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("6xbJx")).previewScreenWithMultiPrompt)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("6xbJx")).arrowContainer)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            type: "button",
            onClick: onMultiPromptClick ? ()=>onMultiPromptClick(-1) : undefined,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("lRheX"))))),
            label: "left",
            appearance: "subtle",
            spacing: "compact",
            isDisabled: isMultiPromptLoading
        })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("6xbJx")).multipromptContent)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: 'space.200'
        }, multiPrompts[multiPromptIndex].content)), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("6xbJx")).arrowContainer)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            type: "button",
            onClick: onMultiPromptClick ? ()=>onMultiPromptClick(1) : undefined,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))),
            label: "right",
            appearance: "subtle",
            spacing: "compact",
            isLoading: isMultiPromptLoading
        }))), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, actionButtons)) : (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("6xbJx")).previewContainer),
                !hideHorizontalRule && (0, (0, parcelRequire("6xbJx")).previewContainerTopBorder),
                (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("luBm6")).default), {
            space: 'space.200'
        }, preview, actionButtons)), (isViewingHistoricResponse || isViewingLatestResponse) && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                !isViewingHistoricResponse && (0, (0, parcelRequire("g0RiJ")).defaultPaddingStyles),
                (0, (0, parcelRequire("6xbJx")).interrogationWrapper)
            ]
        }, isViewingHistoricResponse && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3jnEv")).HistoryInterrogateButton), {
            onClick: ()=>historyProps.onTraverse('reset')
        }), isViewingLatestResponse && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("59RNb")).PromptForm), {
            showButtons: isInputActive,
            autoFocus: false,
            placeholder: initialPlaceholder,
            ariaLabel: initialPlaceholder,
            value: inputValue,
            adfValue: inputADFValue,
            onFormSubmit: onSubmit,
            onCancel: onCancel,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            onInputFocus: handleOnInputFocus,
            focusInputRef: focusInputRef,
            clearInputRef: clearInputRef,
            PromptEditor: PromptEditor,
            enableLinks: enableLinksInPromptEditor,
            fireParentActionButton: firePrimaryApplication,
            focusParentActionButton: setForceFocusRing,
            showLogo: false,
            onInputBlur: onInterrogateBlur
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2gMC9")).Footer), {
            brand: agent ? 'rovo' : 'atlassian-intelligence',
            disclaimer: disclaimer,
            showDisclaimer: true,
            showBetaLozenge: showBetaLozenge
        })));
    };
});
parcelRegister("bkz8X", function(module, exports) {
    $parcel$export(module.exports, "ButtonWithShortcut", ()=>$d80bdb0e58b29494$export$3ca6788437e93171);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $fVnbM;
    var $gE8f9;
    var $jfCQZ;
    var $8tvBx;
    var $b2MqS;
    function $d80bdb0e58b29494$export$3ca6788437e93171({ shortcut: shortcut, children: children, onClick: onClick, ...rest }) {
        (0, $5uXOq.useEffect)(()=>{
            const listener = (event)=>{
                if (shortcut?.common && (0, (0, parcelRequire("8tvBx")).isKeyboardEventMatchShortcut)(event, shortcut.common)) {
                    event.preventDefault();
                    event.stopPropagation();
                    onClick?.();
                }
            };
            return (0, (0, parcelRequire("cBeZP")).bind)(document, {
                type: 'keydown',
                listener: listener
            });
        }, [
            onClick,
            shortcut
        ]);
        const content = (0, $5uXOq.useMemo)(()=>{
            if (!shortcut) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, children);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                "aria-keyshortcuts": (0, (0, parcelRequire("gE8f9")).browser).mac ? shortcut?.mac : shortcut?.windows
            }, children), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                "aria-hidden": "true"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jfCQZ")).Shortcut), {
                shortcut: shortcut
            })));
        }, [
            shortcut,
            children
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fVnbM")).default), {
            css: (0, (0, parcelRequire("b2MqS")).buttonAutoFocusRingFix),
            onClick: onClick,
            ...rest
        }, content));
    }
});
parcelRegister("jfCQZ", function(module, exports) {
    $parcel$export(module.exports, "Shortcut", ()=>$2aa0750bfcf60496$export$59451aa6b6270879);
    var $f8Sb3;
    var $e9qoo;
    function $2aa0750bfcf60496$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $2aa0750bfcf60496$var$style = {
        name: "u6w6o",
        styles: "border-radius:var(--ds-border-radius-100, 3px);padding:3px;color:var(--ds-text-subtle, #44546F);background:var(--ds-background-neutral, #091E420F);font-weight:var(--ds-font-weight-regular, 400);margin-left:6px"
    };
    function $2aa0750bfcf60496$export$59451aa6b6270879({ shortcut: shortcut }) {
        const formattedShortcut = (0, (0, parcelRequire("e9qoo")).formatShortcut)(shortcut);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $2aa0750bfcf60496$var$style
        }, formattedShortcut);
    }
});
parcelRegister("8tvBx", function(module, exports) {
    $parcel$export(module.exports, "isKeyboardEventMatchShortcut", ()=>$2ad14ff0c0505c37$export$b6ac0c7de16a0eb8);
    function $2ad14ff0c0505c37$export$b6ac0c7de16a0eb8(event, shortcut) {
        const parts = shortcut.split('-');
        const key = parts.pop();
        const mods = new Set(parts);
        if (event.key !== key) return false;
        if (mods.has('Mod') !== event.metaKey) return false;
        if (mods.has('Shift') !== event.shiftKey) return false;
        if (mods.has('Alt') !== event.altKey) return false;
        if (mods.has('Ctrl') !== event.ctrlKey) return false;
        return true;
    }
});
parcelRegister("b2MqS", function(module, exports) {
    $parcel$export(module.exports, "buttonAutoFocusRingFix", ()=>$f94846971b23e208$export$c56249aee6987832);
    var $f8Sb3;
    const $f94846971b23e208$export$c56249aee6987832 = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus:not(:focus-visible)': {
            outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        }
    });
});
parcelRegister("4xWnr", function(module, exports) {
    $parcel$export(module.exports, "CopyIconButton", ()=>$bfa32de31ab84fd4$export$dcd7ef7785e10577);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $42CjB;
    var $8w53e;
    var $NsCX6;
    const $bfa32de31ab84fd4$export$dcd7ef7785e10577 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [tooltip, setTooltip] = (0, ($parcel$interopDefault($5uXOq))).useState(formatMessage((0, (0, parcelRequire("NsCX6")).default).copy));
        const updateTooltip = (0, ($parcel$interopDefault($5uXOq))).useRef();
        const handleOnClick = (0, ($parcel$interopDefault($5uXOq))).useCallback((event)=>{
            onClick(event);
            setTooltip(formatMessage((0, (0, parcelRequire("NsCX6")).default).copiedToClipboard));
        }, [
            onClick,
            formatMessage
        ]);
        const resetTooltip = (0, ($parcel$interopDefault($5uXOq))).useCallback(()=>setTooltip(formatMessage((0, (0, parcelRequire("NsCX6")).default).copy)), [
            formatMessage
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useLayoutEffect(()=>{
            updateTooltip.current?.();
        }, [
            tooltip
        ]);
        const tooltipOptions = {
            position: 'top',
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltip;
            },
            onHide: resetTooltip
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            testId: "copy-response-button",
            type: "button",
            onClick: handleOnClick,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("8w53e"))))),
            label: tooltip,
            appearance: appearance,
            spacing: spacing,
            tabIndex: tabIndex,
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        });
    };
});
parcelRegister("NsCX6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9d248260336a8ae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a9d248260336a8ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        copy: {
            id: 'fabric.editor.ai.config.item.action.copyResponse',
            defaultMessage: 'Copy',
            description: 'Copy the response to the clipboard'
        },
        copied: {
            id: 'fabric.editor.ai.config.item.action.responseCopied',
            defaultMessage: 'Copied!',
            description: 'Copied the response to the clipboard'
        },
        copiedToClipboard: {
            id: 'fabric.editor.ai.config.item.action.responseCopiedToClipboard',
            defaultMessage: 'Copied to clipboard',
            description: 'Copied the response to the clipboard'
        }
    });
});
parcelRegister("3ABQo", function(module, exports) {
    $parcel$export(module.exports, "FeedbackForm", ()=>$33faedeeffa0c6ba$export$ce859c56062f484c);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $42CjB;
    var $5hasd;
    var $8AQ0R;
    var $dC5iT;
    var $jldZL;
    var $1OQVq;
    function $33faedeeffa0c6ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $33faedeeffa0c6ba$var$hideBackgroundStyles = {
        name: "es96zp",
        styles: "button{background-color:var(--ds-background-neutral-subtle, #00000000);}"
    };
    const $33faedeeffa0c6ba$var$Announcer = ({ message: message, shouldAnnounce: shouldAnnounce })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            "aria-atomic": "true",
            "aria-live": "polite"
        }, shouldAnnounce && message));
    };
    const $33faedeeffa0c6ba$var$FeedbackButton = ({ type: type, onClick: onClick, isPressed: isPressed, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const responseLabel = type === 'good' ? formatMessage((0, (0, parcelRequire("1OQVq")).default).goodResponse) : formatMessage((0, (0, parcelRequire("1OQVq")).default).badResponse);
        const color = isPressed ? "var(--ds-link-pressed, #0055CC)" : 'currentColor';
        const Icon = ()=>type === 'good' ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("8AQ0R"))))), {
                label: responseLabel,
                color: color
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5hasd"))))), {
                label: responseLabel,
                color: color
            });
        const tooltipOptions = {
            position: 'top',
            content: responseLabel
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (isPressed || isDisabled) && $33faedeeffa0c6ba$var$hideBackgroundStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            testId: `${type}-response-feedback-button`,
            type: "button",
            isDisabled: isDisabled,
            onClick: onClick,
            icon: Icon,
            label: responseLabel,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        }));
    };
    const $33faedeeffa0c6ba$export$ce859c56062f484c = ({ onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, isPressed: isPressed, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const feedbackWasSentLabel = formatMessage((0, (0, parcelRequire("1OQVq")).default).feedbackSent);
        const [feedbackSelected, setFeedbackSelected] = (0, ($parcel$interopDefault($5uXOq))).useState();
        const handleOnClick = (0, ($parcel$interopDefault($5uXOq))).useCallback((onClick, feedback)=>()=>{
                onClick();
                setFeedbackSelected(feedback);
            }, [
            setFeedbackSelected
        ]);
        const disableButton = !!isPressed || isDisabled || !!feedbackSelected;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)($33faedeeffa0c6ba$var$Announcer, {
            message: feedbackWasSentLabel,
            shouldAnnounce: Boolean(feedbackSelected)
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($33faedeeffa0c6ba$var$FeedbackButton, {
            type: "good",
            isPressed: isPressed === 'good',
            isDisabled: disableButton,
            onClick: handleOnClick(onGoodResponseButtonClick, 'good')
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($33faedeeffa0c6ba$var$FeedbackButton, {
            type: "bad",
            isPressed: isPressed === 'bad',
            isDisabled: disableButton,
            onClick: handleOnClick(onBadResponseButtonClick, 'bad')
        }));
    };
});
parcelRegister("5hasd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3d76a6448ba6d64c$var$_react = $3d76a6448ba6d64c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3d76a6448ba6d64c$var$_UNSAFE_baseNew = $3d76a6448ba6d64c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3d76a6448ba6d64c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3d76a6448ba6d64c$var$ThumbsDownIcon = (props)=>$3d76a6448ba6d64c$var$_react.default.createElement($3d76a6448ba6d64c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.993 9.24c-1.586.69-3.176 2.118-3.176 4.234 0 1.057-4.202 1.586-2.086-3.702-1.058.475-4.98 1.747-4.98-.897 0-3.173-.25-6.346 3.98-6.346 2.453 0 4.06 0 6.036 1.267m0 0A1.25 1.25 0 0 1 12 2.75h2c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25h-2c-.69 0-1.25-.56-1.25-1.25V4q0-.105.017-.204Z"/>`
        }, props));
    $3d76a6448ba6d64c$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
    var $3d76a6448ba6d64c$var$_default = module.exports.default = $3d76a6448ba6d64c$var$ThumbsDownIcon;
});
parcelRegister("8AQ0R", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $641a0838d2f101d6$var$_react = $641a0838d2f101d6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $641a0838d2f101d6$var$_UNSAFE_baseNew = $641a0838d2f101d6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $641a0838d2f101d6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $641a0838d2f101d6$var$ThumbsUpIcon = (props)=>$641a0838d2f101d6$var$_react.default.createElement($641a0838d2f101d6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.007 6.76c1.586-.69 3.176-2.117 3.176-4.233 0-1.057 4.202-1.586 2.086 3.702 1.058-.475 4.981-1.747 4.981.897 0 3.173-.25 6.346-4.48 6.346-2.454 0-3.561 0-5.537-1.267m0 0A1.25 1.25 0 0 1 4 13.251H2c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h2c.69 0 1.25.56 1.25 1.25v4.5q0 .105-.017.204Z"/>`
        }, props));
    $641a0838d2f101d6$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
    var $641a0838d2f101d6$var$_default = module.exports.default = $641a0838d2f101d6$var$ThumbsUpIcon;
});
parcelRegister("1OQVq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$631150debfb309db$export$2e2bcd8739ae039);
    var $7VHMR;
    var $631150debfb309db$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        goodResponse: {
            id: 'fabric.editor.ai.components.feedbackForm.goodResponse',
            defaultMessage: 'Good response',
            description: 'The AI response was good'
        },
        badResponse: {
            id: 'fabric.editor.ai.components.feedbackForm.badResponse',
            defaultMessage: 'Bad response',
            description: 'The AI response was bad'
        },
        feedbackSent: {
            id: 'fabric.editor.ai.components.feedbackForm.feedbackSent',
            defaultMessage: 'Feedback sent',
            description: 'A message that appears to users when they click the thumbs up or thumbs down button'
        }
    });
});
parcelRegister("i6nji", function(module, exports) {
    $parcel$export(module.exports, "HistoryArrowButton", ()=>$ee87ab244b64b90f$export$e16d2bec5bc91575);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $42CjB;
    var $ctqwA;
    var $h1TKi;
    var $ho6RM;
    const $ee87ab244b64b90f$export$e16d2bec5bc91575 = ({ direction: direction, onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltip = formatMessage(direction === 'back' ? (0, (0, parcelRequire("ho6RM")).default).traverseHistoryBack : (0, (0, parcelRequire("ho6RM")).default).traverseHistoryForward);
        const tooltipOptions = {
            position: 'top',
            hideTooltipOnClick: true
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            testId: `history-arrow-button-${direction}`,
            type: "button",
            onClick: onClick,
            icon: direction === 'back' ? (0, ($parcel$interopDefault((0, parcelRequire("ctqwA"))))) : (0, ($parcel$interopDefault((0, parcelRequire("h1TKi"))))),
            label: tooltip,
            appearance: appearance,
            spacing: spacing,
            tabIndex: tabIndex,
            isDisabled: isDisabled,
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        });
    };
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("ho6RM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44a46ada6835cddc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $44a46ada6835cddc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        traverseHistoryBack: {
            id: 'fabric.editor.ai.config.item.action.traverseHistoryBack',
            defaultMessage: 'View previous response',
            description: 'Move back in history to the previous AI-generated content and prompt'
        },
        traverseHistoryForward: {
            id: 'fabric.editor.ai.config.item.action.traverseHistoryForward',
            defaultMessage: 'View next response',
            description: 'Move forward in history to the next AI-generated content and prompt'
        }
    });
});
parcelRegister("3jnEv", function(module, exports) {
    $parcel$export(module.exports, "HistoryInterrogateButton", ()=>$29aac41081c2c2ce$export$f9a9a3bd14fe286f);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $h1TKi;
    var $7W8JB;
    function $29aac41081c2c2ce$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $29aac41081c2c2ce$var$continueFromLastResponseButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingLeft: 14,
        paddingRight: 14,
        color: "var(--ds-text-subtlest, #626F86)",
        fontWeight: 'unset',
        display: 'flex',
        height: `calc(${"var(--ds-space-600, 48px)"} + 0.5px)`,
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'unset',
        background: 'unset',
        gap: "var(--ds-space-050, 4px)",
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
        }
    });
    const $29aac41081c2c2ce$var$textStyles = {
        name: "9123zq",
        styles: "text-align:left;flex-grow:0"
    };
    const $29aac41081c2c2ce$var$arrowIconStyles = {
        name: "1t8eddt",
        styles: "flex-grow:1;text-align:left"
    };
    const $29aac41081c2c2ce$export$f9a9a3bd14fe286f = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const message = formatMessage((0, (0, parcelRequire("7W8JB")).default).continueFromLatestResponse);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            type: "button",
            onClick: onClick,
            "data-test-id": "history-interrogate-button",
            css: $29aac41081c2c2ce$var$continueFromLastResponseButtonStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("p", {
            css: $29aac41081c2c2ce$var$textStyles
        }, message), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $29aac41081c2c2ce$var$arrowIconStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h1TKi"))))), {
            label: ""
        })));
    };
});
parcelRegister("7W8JB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ef0cf7ccb502adb0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ef0cf7ccb502adb0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        continueFromLatestResponse: {
            id: 'fabric.editor.ai.config.item.action.continueFromLatestResponse',
            defaultMessage: 'Continue from last response',
            description: 'Move forward in history to the latest AI-generated content and prompt'
        }
    });
});
parcelRegister("59RNb", function(module, exports) {
    $parcel$export(module.exports, "PromptForm", ()=>$ef3ad26c4732522c$export$416523684d97c4ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $kz2lw;
    var $ebjue;
    var $jps85;
    var $jmZkC;
    var $c0bUR;
    var $i6FWV;
    var $bu6Ao;
    var $fzCAm;
    var $4xCjq;
    var $bp2k9;
    var $1HGsW;
    var $gUb7d;
    function $ef3ad26c4732522c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ef3ad26c4732522c$var$formGapStyles = {
        name: "5gr3w6",
        styles: "gap:var(--ds-space-050, 4px)"
    };
    const $ef3ad26c4732522c$var$formHeightStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $ef3ad26c4732522c$var$formInnerHeightStyles = {
        name: "mvrlf6",
        styles: "min-height:0"
    };
    const $ef3ad26c4732522c$var$nextToInputStyles = {
        name: "ch3qq6",
        styles: "margin-top:var(--ds-space-negative-025, -2px);margin-bottom:var(--ds-space-negative-025, -2px)"
    };
    const $ef3ad26c4732522c$export$416523684d97c4ad = ({ onFormSubmit: onFormSubmit, onCancel: onCancel, value: value = '', showButtons: showButtons = true, tag: tag, autoFocus: autoFocus = true, onInputChange: onInputChange, onADFChange: onADFChange, onInputFocus: onInputFocus, onInputBlur: onInputBlur, placeholder: placeholder, ariaLabel: ariaLabel, focusInputRef: focusInputRef, clearInputRef: clearInputRef, replaceInputRef: replaceInputRef, showLogo: showLogo = true, onInputKeyDown: onInputKeyDown, adfValue: adfValue, enableLinks: enableLinks, PromptEditor: PromptEditor, showBack: showBack, onBack: onBack, onInputKeyUp: onInputKeyUp, fireParentActionButton: fireParentActionButton, focusParentActionButton: focusParentActionButton, refinementTagRef: refinementTagRef })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [setBreakpointElement, { breakpoint: breakpoint }] = (0, (0, parcelRequire("jmZkC")).useElementBreakpoints)();
        const blurInputRef = (0, $5uXOq.useRef)(undefined);
        const [hasMutipleRows, setHasMutipleRows] = (0, $5uXOq.useState)(false);
        const [buttonWidth, setButtonWidth] = (0, $5uXOq.useState)(0);
        const [isComposing, setIsComposing] = (0, $5uXOq.useState)(false);
        const [isLozengeSelected, setIsLozengeSelected] = (0, $5uXOq.useState)(false);
        const lastAdfValue = (0, $5uXOq.useRef)((0, (0, parcelRequire("kz2lw")).getEmptyADF)());
        const handleSubmit = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            onFormSubmit(value);
        };
        const handleSetButtonWidth = (0, $5uXOq.useCallback)((el)=>{
            if (el) setButtonWidth(el.getBoundingClientRect().width);
        }, [
            setButtonWidth
        ]);
        const handleOnCompositionStart = (0, $5uXOq.useCallback)(()=>{
            setIsComposing(true);
        }, []);
        const handleOnCompositionEnd = (0, $5uXOq.useCallback)(()=>{
            setIsComposing(false);
        }, []);
        const promptEditorEnabled = !!PromptEditor;
        const handleKeyUp = (0, ($parcel$interopDefault($5uXOq))).useCallback((event)=>{
            const isPromptInputEmpty = value === '';
            if (isPromptInputEmpty && promptEditorEnabled && focusParentActionButton) focusParentActionButton(true);
            onInputKeyUp && onInputKeyUp(event);
        }, [
            focusParentActionButton,
            onInputKeyUp,
            promptEditorEnabled,
            value
        ]);
        const handleKeyDown = (0, ($parcel$interopDefault($5uXOq))).useCallback((event)=>{
            let isPromptInputEmpty = value === '';
            if ((event.key.length === 1 || event.key === 'Escape') && focusParentActionButton) focusParentActionButton(false);
            setIsLozengeSelected(false);
            if (promptEditorEnabled) isPromptInputEmpty = Boolean((0, (0, parcelRequire("ebjue")).isEmpty)(lastAdfValue?.current) && adfValue && (0, (0, parcelRequire("ebjue")).isEmpty)(adfValue));
            if (event.key === 'Backspace' && onBack) {
                if (!isLozengeSelected && isPromptInputEmpty && refinementTagRef?.current) {
                    refinementTagRef.current.getElementsByTagName('button')[0].focus();
                    setIsLozengeSelected(true);
                    return;
                }
                event.stopPropagation();
                if (isPromptInputEmpty) onBack();
            }
            if (event.key === 'Enter' && [
                event.altKey,
                event.metaKey,
                event.ctrlKey
            ].every((isPressed)=>!isPressed)) {
                event.stopPropagation();
                const target = event.target;
                if (isComposing) return;
                if (isPromptInputEmpty && fireParentActionButton) {
                    fireParentActionButton();
                    return;
                }
                if ([
                    'close-button-refinement-tag',
                    'cancel-icon-button',
                    'cancel-esc-button',
                    'back-icon-button'
                ].includes(target.getAttribute('data-testid') ?? '')) return;
                if (!event.shiftKey) {
                    event.preventDefault();
                    onFormSubmit(value);
                }
            }
            if (![
                'Enter',
                'Backspace'
            ].includes(event.key) && !document.getElementsByClassName('ProseMirror-focused').length) document.getElementById('ak-editor-textarea')?.focus();
        }, [
            adfValue,
            isComposing,
            fireParentActionButton,
            focusParentActionButton,
            onFormSubmit,
            promptEditorEnabled,
            onBack,
            value,
            isLozengeSelected,
            refinementTagRef
        ]);
        const onADFChange_ = (0, ($parcel$interopDefault($5uXOq))).useCallback((input)=>{
            lastAdfValue.current = adfValue ?? (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
            if (onADFChange) onADFChange(input);
        }, [
            onADFChange,
            adfValue
        ]);
        const onInputChange_ = (0, ($parcel$interopDefault($5uXOq))).useCallback((newValue)=>{
            if (onInputChange) onInputChange(newValue);
        }, [
            onInputChange
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            css: (0, (0, parcelRequire("gUb7d")).formContainerStyles),
            ref: setBreakpointElement
        }, showLogo && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("gUb7d")).logoContainerStyles)(breakpoint),
                $ef3ad26c4732522c$var$nextToInputStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
            color: "var(--ds-icon, #44546F)",
            label: formatMessage((0, (0, parcelRequire("1HGsW")).default).logo),
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("i6FWV")).AtlassianIntelligenceLogo),
            LEGACY_size: "medium"
        })), showBack && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bu6Ao")).BackIconButton), {
            inPromptHeader: true,
            stopPropagation: true,
            onClick: onBack
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("form", {
            css: [
                (0, (0, parcelRequire("gUb7d")).formStyles),
                $ef3ad26c4732522c$var$formGapStyles,
                showLogo && (0, (0, parcelRequire("gUb7d")).formPaddingTopStyles),
                $ef3ad26c4732522c$var$formHeightStyles
            ],
            onSubmit: handleSubmit,
            className: "ai-modal-prompt-form",
            "data-testid": "ai-modal-prompt-form"
        }, tag, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-multiline": hasMutipleRows,
            css: [
                (0, (0, parcelRequire("c0bUR")).commonTextStyles),
                (0, (0, parcelRequire("gUb7d")).formInnerStyles),
                !!tag && (0, (0, parcelRequire("gUb7d")).formInnerPaddingTopStyles),
                $ef3ad26c4732522c$var$formInnerHeightStyles
            ]
        }, !!PromptEditor && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fzCAm")).PromptEditorWrapper), {
            PromptEditor: PromptEditor,
            focusInputRef: focusInputRef,
            blurInputRef: blurInputRef,
            clearInputRef: clearInputRef,
            replaceInputRef: replaceInputRef,
            autoFocus: autoFocus,
            defaultValue: adfValue,
            onInputChange: onInputChange_,
            onADFChange: onADFChange_,
            placeholder: placeholder,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            onKeyDown: onInputKeyDown,
            onCompositionStart: handleOnCompositionStart,
            onCompositionEnd: handleOnCompositionEnd,
            enableLinks: enableLinks
        }), !PromptEditor && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4xCjq")).PromptMultilineInput), {
            focusInputRef: focusInputRef,
            blurInputRef: blurInputRef,
            value: value,
            autoFocus: autoFocus,
            onInputChange: onInputChange_,
            placeholder: placeholder,
            "aria-label": ariaLabel || placeholder,
            onFocus: onInputFocus,
            onBlur: onInputBlur,
            buttonWidth: buttonWidth,
            hasMultipleRows: hasMutipleRows,
            setHasMultipleRows: setHasMutipleRows,
            onKeyDown: onInputKeyDown,
            onCompositionStart: handleOnCompositionStart,
            onCompositionEnd: handleOnCompositionEnd
        }), showButtons && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-multiline": hasMutipleRows,
            css: [
                (0, (0, parcelRequire("gUb7d")).buttonWrapperStyles)
            ],
            ref: handleSetButtonWidth
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bp2k9")).SubmitButton), {
            disabled: !value
        }))))));
    };
});
parcelRegister("fzCAm", function(module, exports) {
    $parcel$export(module.exports, "PromptEditorWrapper", ()=>$f37c85f996882329$export$b0a649d08575ac09);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7Jxgt = parcelRequire("7Jxgt");
    function $f37c85f996882329$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $f37c85f996882329$var$promptEditorWrapperStyles = {
        name: "m61lg3",
        styles: "display:grid;position:relative;flex:1;div > .ProseMirror{> p{line-height:20px;}> p:last-child{margin-bottom:0;padding-bottom:0;}min-height:auto;}.ProseMirror .inlineCardView-content-wrap .card{padding-top:0;padding-bottom:0;}"
    };
    const $f37c85f996882329$var$promptEditorWrapperOverflowStyles = {
        name: "yhh5va",
        styles: "overflow-y:auto;div > .ProseMirror{> p{padding-top:0.5px;line-height:24px;}}"
    };
    const $f37c85f996882329$export$b0a649d08575ac09 = ({ PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, replaceInputRef: replaceInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd })=>{
        const setFocusHandlers = (0, $5uXOq.useCallback)((blur, focus)=>{
            if (blurInputRef) blurInputRef.current = blur;
            if (focusInputRef) focusInputRef.current = focus;
        }, [
            blurInputRef,
            focusInputRef
        ]);
        const setClearHandler = (0, $5uXOq.useCallback)((clear)=>{
            if (clearInputRef) clearInputRef.current = clear;
        }, [
            clearInputRef
        ]);
        const setReplaceDocumentHandler = (0, $5uXOq.useCallback)((replaceDocument)=>{
            if (replaceInputRef) replaceInputRef.current = replaceDocument;
        }, [
            replaceInputRef
        ]);
        const componentId = (0, $5uXOq.useMemo)(()=>`${placeholder}-${(0, $7Jxgt.v4)()}`, [
            placeholder
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $f37c85f996882329$var$promptEditorWrapperStyles,
                $f37c85f996882329$var$promptEditorWrapperOverflowStyles
            ],
            "data-testid": "ai-experience-prompt-input",
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur,
            onCompositionStart: onCompositionStart,
            onCompositionEnd: onCompositionEnd
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(PromptEditor, {
            key: componentId,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            placeholder: placeholder,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            setFocusHandlers: setFocusHandlers,
            setClearHandler: setClearHandler,
            setReplaceDocumentHandler: setReplaceDocumentHandler,
            enableLinks: enableLinks
        })));
    };
});
parcelRegister("4xCjq", function(module, exports) {
    $parcel$export(module.exports, "PromptMultilineInput", ()=>$74782c2fc69bf155$export$50c58ceb14a55b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $hBk6F;
    var $haujC;
    const $74782c2fc69bf155$export$50c58ceb14a55b4 = ({ focusInputRef: focusInputRef, blurInputRef: blurInputRef, onBlur: onBlur, onFocus: onFocus, onInputChange: onInputChange, hasMultipleRows: hasMultipleRows, setHasMultipleRows: setHasMultipleRows, value: value, buttonWidth: buttonWidth, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest })=>{
        const setFocusAndBlurInputRef = (0, (0, parcelRequire("hBk6F")).useSetInputRef)({
            blurInputRef: blurInputRef,
            focusInputRef: focusInputRef
        });
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const hiddenDivRef = (0, $5uXOq.useRef)(null);
        const hiddenDiv = hiddenDivRef?.current;
        const singleLineHeight = (0, $5uXOq.useMemo)(()=>window && hiddenDiv ? parseFloat(window.getComputedStyle(hiddenDiv).lineHeight) : 0, [
            hiddenDiv
        ]);
        const hiddenDivWidthStyles = (0, $5uXOq.useMemo)(()=>({
                width: hasMultipleRows ? `calc(100% - ${buttonWidth}px)` : `100%`
            }), [
            hasMultipleRows,
            buttonWidth
        ]);
        const onInput = (0, $5uXOq.useCallback)((e)=>{
            onInputChange?.(e.target.value);
        }, [
            onInputChange
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const resizeObserver = new ResizeObserver((entries)=>{
                entries.forEach(()=>{
                    if (hiddenDiv) setHasMultipleRows?.(hiddenDiv.getBoundingClientRect().height > singleLineHeight);
                });
            });
            if (hiddenDiv) resizeObserver.observe(hiddenDiv);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            hiddenDiv,
            singleLineHeight,
            setHasMultipleRows
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hiddenDiv) setHasMultipleRows?.(hiddenDiv.getBoundingClientRect().height > singleLineHeight);
        }, [
            hiddenDiv,
            singleLineHeight,
            setHasMultipleRows
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-replicated-value": value,
            css: [
                (0, (0, parcelRequire("haujC")).multilineInputWrapperStyles)
            ],
            ref: wrapperRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ref: setFocusAndBlurInputRef,
            "aria-label": rest.placeholder,
            "data-testid": "ai-experience-prompt-input",
            name: "prompt-input",
            autoComplete: "off",
            css: (0, (0, parcelRequire("haujC")).inputStyles),
            onChange: onInput,
            onBlur: onBlur,
            onFocus: onFocus,
            rows: 1,
            value: value,
            maxLength: 4000,
            onCompositionStart: onCompositionStart,
            onCompositionEnd: onCompositionEnd,
            ...rest
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-replicated-value": value,
            css: [
                (0, (0, parcelRequire("haujC")).hiddenDivStyles),
                hiddenDivWidthStyles
            ],
            ref: hiddenDivRef
        })));
    };
});
parcelRegister("hBk6F", function(module, exports) {
    $parcel$export(module.exports, "useSetInputRef", ()=>$6571eefb01c5af5f$export$30bc19c62a7f99b9);
    var $5uXOq = parcelRequire("5uXOq");
    const $6571eefb01c5af5f$export$30bc19c62a7f99b9 = ({ focusInputRef: focusInputRef, blurInputRef: blurInputRef })=>{
        return (0, $5uXOq.useCallback)((el)=>{
            if (el) {
                if (focusInputRef) focusInputRef.current = ()=>el.focus();
                if (blurInputRef) blurInputRef.current = ()=>el.blur();
                el.selectionStart = el.selectionEnd = el.value.length;
            }
        }, [
            focusInputRef,
            blurInputRef
        ]);
    };
});
parcelRegister("haujC", function(module, exports) {
    $parcel$export(module.exports, "inputStyles", ()=>$6c7e71dbe5415761$export$3eeb47dc8e6249d9);
    $parcel$export(module.exports, "multilineInputWrapperStyles", ()=>$6c7e71dbe5415761$export$6514c7ca69ae2c80);
    $parcel$export(module.exports, "hiddenDivStyles", ()=>$6c7e71dbe5415761$export$c9dfe18c85e0471);
    var $f8Sb3;
    var $k5uoT;
    const $6c7e71dbe5415761$var$INCREASE_SPECIFICITY = '&&';
    const $6c7e71dbe5415761$export$3eeb47dc8e6249d9 = (0, (0, parcelRequire("f8Sb3")).css)($6c7e71dbe5415761$var$INCREASE_SPECIFICITY, "{border:none;color:", `var(--ds-text-accent-gray-bolder, ${(0, $829f609a65d26a98$export$fbda843f0a27fe96)})`, ";background:none;font-size:14px;font-family:", (0, (0, parcelRequire("k5uoT")).fontFamily)(), ";width:100%;padding:0;resize:none;overflow:hidden;line-height:20px;&:focus{outline:none;}&:placeholder-shown{text-overflow:ellipsis;}&::placeholder{color:", `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}}");
    const $6c7e71dbe5415761$export$6514c7ca69ae2c80 = (0, (0, parcelRequire("f8Sb3")).css)("display:grid;position:relative;flex:1;::after{content:attr(data-replicated-value) ' ';white-space:pre-wrap;visibility:hidden;", $6c7e71dbe5415761$export$3eeb47dc8e6249d9, ";}>textarea,::after{", $6c7e71dbe5415761$export$3eeb47dc8e6249d9, "grid-area:1/1/2/2;}");
    const $6c7e71dbe5415761$export$c9dfe18c85e0471 = (0, (0, parcelRequire("f8Sb3")).css)("position:absolute;visibility:hidden;bottom:0;::after{content:attr(data-replicated-value) ' ';white-space:pre-wrap;visibility:hidden;", $6c7e71dbe5415761$export$3eeb47dc8e6249d9, ";}");
});
parcelRegister("bp2k9", function(module, exports) {
    $parcel$export(module.exports, "SubmitButton", ()=>$9cf16b483233a963$export$8b7b7cdfb85d78c5);
    var $f8Sb3;
    var $koVbs;
    var $42CjB;
    var $3bDjY;
    var $6M49g;
    var $39cp5;
    const $9cf16b483233a963$export$8b7b7cdfb85d78c5 = ({ disabled: disabled, tabIndex: tabIndex })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("39cp5")).default).submitTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            label: formatMessage((0, (0, parcelRequire("39cp5")).default).submitLabel),
            testId: "submit-icon-button",
            type: "submit",
            isDisabled: disabled,
            icon: (0, (0, parcelRequire("6M49g")).default),
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex
        }));
    };
});
parcelRegister("6M49g", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cba946009e22b235$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $cba946009e22b235$var$Enter = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "14",
            height: "12",
            viewBox: "0 0 14 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
            fill: "currentColor"
        }));
    var $cba946009e22b235$export$2e2bcd8739ae039 = $cba946009e22b235$var$Enter;
});
parcelRegister("39cp5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b40a2ad72ab987b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6b40a2ad72ab987b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        submitLabel: {
            id: 'fabric.editor.ai.screens.prompt.submitLabel',
            defaultMessage: 'Submit',
            description: 'Submit button label within the Prompt screen'
        },
        submitTooltip: {
            id: 'fabric.editor.ai.screens.prompt.submitTooltip',
            defaultMessage: 'Send to AI',
            description: 'Submit button tooltip within the Prompt screen'
        }
    });
});
parcelRegister("1HGsW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c57b50d8d3ad0bf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7c57b50d8d3ad0bf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        logo: {
            id: 'fabric.editor.ai.commandPalette.promptForm.logo',
            defaultMessage: 'Atlassian Intelligence Logo',
            description: 'Atlassian Intelligence logo alt text'
        }
    });
});
parcelRegister("gUb7d", function(module, exports) {
    $parcel$export(module.exports, "formContainerStyles", ()=>$191907906181e08a$export$51f8df1eaf0be4cd);
    $parcel$export(module.exports, "formStyles", ()=>$191907906181e08a$export$e1b615d0557d2f42);
    $parcel$export(module.exports, "formPaddingTopStyles", ()=>$191907906181e08a$export$60fd3decbfd47930);
    $parcel$export(module.exports, "formInnerStyles", ()=>$191907906181e08a$export$27b9ff0951a9fa9f);
    $parcel$export(module.exports, "formInnerPaddingTopStyles", ()=>$191907906181e08a$export$2a3056de5af56ceb);
    $parcel$export(module.exports, "buttonWrapperStyles", ()=>$191907906181e08a$export$af008dcc7d3b031e);
    $parcel$export(module.exports, "logoContainerStyles", ()=>$191907906181e08a$export$6b0f8f6d4f0787a9);
    var $f8Sb3;
    var $jmZkC;
    function $191907906181e08a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $191907906181e08a$export$51f8df1eaf0be4cd = {
        name: "1o5wgy1",
        styles: "display:flex;justify-content:flex-start;flex:1;align-items:flex-start"
    };
    const $191907906181e08a$export$e1b615d0557d2f42 = {
        name: "nzt96b",
        styles: "&&{margin:0;flex:1;display:flex;flex-direction:column;}"
    };
    const $191907906181e08a$export$60fd3decbfd47930 = {
        name: "1dki3f2",
        styles: "padding-top:var(--ds-space-025, 2px)"
    };
    const $191907906181e08a$export$27b9ff0951a9fa9f = {
        name: "vqgw6g",
        styles: "display:flex;flex:1;&[data-multiline='true']{display:block;}"
    };
    const $191907906181e08a$export$2a3056de5af56ceb = {
        name: "ou3io1",
        styles: "padding-top:var(--ds-space-050, 4px)"
    };
    const $191907906181e08a$export$af008dcc7d3b031e = {
        name: "gur2za",
        styles: "float:right;display:flex;&[data-multiline='true']{padding-top:var(--ds-space-100, 8px);}"
    };
    const $191907906181e08a$export$6b0f8f6d4f0787a9 = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            display: 'flex',
            flexDirection: 'row',
            marginRight: "var(--ds-space-050, 4px)",
            alignItems: 'center',
            alignSelf: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'self-start' : 'initial'
        });
});
parcelRegister("8OUgt", function(module, exports) {
    $parcel$export(module.exports, "RetryIconButton", ()=>$f5051bfafd189871$export$6f66175e87cc7542);
    parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $42CjB;
    var $lzNDe;
    var $w6Gdb;
    const $f5051bfafd189871$export$6f66175e87cc7542 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const tooltip = formatMessage((0, (0, parcelRequire("w6Gdb")).default).retryPrompt);
        const tooltipOptions = {
            position: 'top',
            hideTooltipOnClick: true,
            content: tooltip
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            testId: "retry-prompt-button",
            type: "button",
            onClick: onClick,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("lzNDe"))))),
            label: tooltip,
            appearance: appearance,
            spacing: spacing,
            tabIndex: tabIndex,
            isTooltipDisabled: false,
            tooltip: tooltipOptions,
            isDisabled: isDisabled
        });
    };
});
parcelRegister("lzNDe", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fb535dae8e778b64$var$_UNSAFE_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fb535dae8e778b64$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fb535dae8e778b64$var$RetryIcon = (props)=>$fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6.75 14a6 6 0 1 1 6-6v2.5m2.625-2.125L12.75 11l-2.625-2.625"/>`
        }, props));
    $fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
    var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;
});
parcelRegister("w6Gdb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31736522b402b306$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31736522b402b306$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        retryPrompt: {
            id: 'fabric.editor.ai.config.item.action.retryPrompt',
            defaultMessage: 'Retry',
            description: 'Retry the latest prompt'
        }
    });
});
parcelRegister("ejRBn", function(module, exports) {
    $parcel$export(module.exports, "buttonAutoFocusRingFix", ()=>$129809ef8b3ea4ba$export$c56249aee6987832);
    $parcel$export(module.exports, "forceFocusRingStyles", ()=>$129809ef8b3ea4ba$export$199c823ee234868f);
    var $f8Sb3;
    const $129809ef8b3ea4ba$export$c56249aee6987832 = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus:not(:focus-visible)': {
            outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        }
    });
    const $129809ef8b3ea4ba$export$199c823ee234868f = (0, (0, parcelRequire("f8Sb3")).css)({
        ':not(:focus-visible)': {
            outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)"
        }
    });
});
parcelRegister("bDYQc", function(module, exports) {
    $parcel$export(module.exports, "ActionButtonsLayout", ()=>$390989fee9245ccf$export$6a458a35d6b615d0);
    var $f8Sb3;
    var $9ofBI;
    function $390989fee9245ccf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $390989fee9245ccf$var$container = {
        name: "1c9zstb",
        styles: "display:flex;flex-wrap:wrap;justify-content:flex-end;gap:var(--ds-space-100, 8px);padding-top:0"
    };
    const $390989fee9245ccf$var$secondLevelContainer = {
        name: "1o3nkn",
        styles: "margin-left:auto"
    };
    const $390989fee9245ccf$var$compactSecondaryButtonsContainer = {
        name: "fgp8ql",
        styles: "display:flex;align-items:center;gap:var(--ds-space-100, 8px)"
    };
    function $390989fee9245ccf$export$6a458a35d6b615d0({ cancelButton: cancelButton, primaryButtons: primaryButtons, secondaryButtons: secondaryButtons }) {
        const [setRootContainerElement, isRootContainerWrapped] = (0, (0, parcelRequire("9ofBI")).useIsFlexElementWrapped)();
        const [setSecondLevelContainerElement, isSecondLevelContainerWrapped] = (0, (0, parcelRequire("9ofBI")).useIsFlexElementWrapped)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setRootContainerElement,
            css: [
                $390989fee9245ccf$var$container
            ]
        }, !isRootContainerWrapped && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $390989fee9245ccf$var$compactSecondaryButtonsContainer
            ]
        }, secondaryButtons), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setSecondLevelContainerElement,
            css: [
                $390989fee9245ccf$var$container,
                $390989fee9245ccf$var$secondLevelContainer
            ]
        }, !isSecondLevelContainerWrapped && cancelButton, primaryButtons && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $390989fee9245ccf$var$container
        }, primaryButtons), isSecondLevelContainerWrapped && cancelButton), isRootContainerWrapped && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $390989fee9245ccf$var$compactSecondaryButtonsContainer
            ]
        }, secondaryButtons));
    }
});
parcelRegister("9ofBI", function(module, exports) {
    $parcel$export(module.exports, "useIsFlexElementWrapped", ()=>$396647547d2bb15b$export$1ca3f17e50a1bf69);
    var $5uXOq = parcelRequire("5uXOq");
    function $396647547d2bb15b$export$1ca3f17e50a1bf69() {
        const [element, setElement] = (0, $5uXOq.useState)(null);
        const [result, setResult] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!element) return;
            const updateResult = (entries)=>{
                for (const entry of entries){
                    const firstChild = entry.target.firstElementChild;
                    if (!(firstChild instanceof HTMLElement)) {
                        setResult(false);
                        return;
                    }
                    const firstChildTop = firstChild.offsetTop;
                    const isInTwoLine = Array.from(entry.target.children).some((child)=>child instanceof HTMLElement && child.offsetTop !== firstChildTop);
                    setResult(isInTwoLine);
                }
            };
            const resizeObserver = new ResizeObserver(updateResult);
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            element
        ]);
        return [
            setElement,
            result
        ];
    }
});
parcelRegister("erFIU", function(module, exports) {
    $parcel$export(module.exports, "RefineDropdown", ()=>$d29e28af7c72bf75$export$892617147bbb1d94);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $eCeGD;
    var $BLPHT;
    var $c8Oei;
    var $4dUmZ;
    var $8lRPC;
    function $d29e28af7c72bf75$export$892617147bbb1d94({ items: items, isDisabled: isDisabled = false }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpened, setIsOpened] = (0, $5uXOq.useState)(false);
        const [currentOpenedSubMenu, setCurrentOpenedSubMenu] = (0, $5uXOq.useState)(null);
        const handleOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
            setIsOpened(isOpen);
            if (!isOpen) setCurrentOpenedSubMenu(null);
        }, []);
        const handleItemClick = (0, $5uXOq.useCallback)(()=>{
            setIsOpened(false);
            setCurrentOpenedSubMenu(null);
        }, []);
        const handleSubMenuOpenChanged = (0, $5uXOq.useCallback)((subMenu, isOpen)=>{
            setCurrentOpenedSubMenu((current)=>{
                if (current === subMenu && !isOpen) return null;
                return subMenu;
            });
        }, []);
        if (isDisabled) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
            iconAfter: (0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))),
            isDisabled: true,
            testId: "refine-button-disabled"
        }, formatMessage((0, (0, parcelRequire("4dUmZ")).default).refineButton));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
            trigger: formatMessage((0, (0, parcelRequire("4dUmZ")).default).refineButton),
            testId: "refine-dropdown",
            shouldRenderToParent: true,
            isOpen: isOpened,
            onOpenChange: handleOpenChange
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8lRPC")).RefineDropdownItems), {
            items: items,
            onItemClick: handleItemClick,
            currentOpenedSubMenu: currentOpenedSubMenu,
            onSubMenuOpenChanged: handleSubMenuOpenChanged
        }));
    }
});
parcelRegister("4dUmZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1fc19cf872aa09bd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1fc19cf872aa09bd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        refineButton: {
            id: 'fabric.editor.ai.screens.preview.refineDropdown.refineButton',
            defaultMessage: 'Refine',
            description: 'The action text for the refine button to edit the previewed generated content'
        }
    });
});
parcelRegister("8lRPC", function(module, exports) {
    $parcel$export(module.exports, "RefineDropdownItems", ()=>$4ef0ef86f8a6b316$export$99f30ba596e90ddb);
    var $f8Sb3;
    var $koVbs;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $ebd3R;
    function $4ef0ef86f8a6b316$export$99f30ba596e90ddb({ items: items, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, items.map((item)=>(0, (0, parcelRequire("f8Sb3")).jsx)($4ef0ef86f8a6b316$var$Item, {
                key: item.title.id,
                item: item,
                onItemClick: onItemClick,
                currentOpenedSubMenu: currentOpenedSubMenu,
                onSubMenuOpenChanged: onSubMenuOpenChanged
            })));
    }
    function $4ef0ef86f8a6b316$var$Item({ item: item, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ('children' in item && item.children) {
            const handleOpenChange = ({ isOpen: isOpen })=>{
                onSubMenuOpenChanged?.(item, isOpen);
            };
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("BLPHT")).default), {
                placement: "right-start",
                shouldRenderToParent: true,
                isOpen: currentOpenedSubMenu === item,
                onOpenChange: handleOpenChange,
                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
                        ...triggerProps,
                        ref: triggerRef,
                        elemBefore: item.icon,
                        elemAfter: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("ebd3R"))))), {
                            primaryColor: "var(--ds-icon-subtle)",
                            label: ""
                        })
                    }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", null, formatMessage(item.title)))
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("aRoVz")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)($4ef0ef86f8a6b316$export$99f30ba596e90ddb, {
                items: item.children,
                onItemClick: onItemClick
            })));
        }
        const handleItemClick = ()=>{
            onItemClick();
            item.onClick?.();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6B7KL")).default), {
            elemBefore: item.icon,
            onClick: handleItemClick
        }, formatMessage(item.title));
    }
});
parcelRegister("cIVH6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb4b4dca17a239e0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fb4b4dca17a239e0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        logoAltText: {
            id: 'fabric.editor.ai.screens.prompt.logoAltText',
            defaultMessage: 'Atlassian Intelligence Logo',
            description: 'Atlassian Intelligence logo alt text of the Prompt screen'
        },
        logoText: {
            id: 'fabric.editor.ai.screens.prompt.logoText',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Atlassian Intelligence Logo text of the Prompt screen'
        },
        betaLabel: {
            id: 'fabric.editor.ai.screens.preview.betaLabel',
            defaultMessage: 'Beta',
            description: 'The label describing the beta status of the Atlassian Intelligence feature'
        },
        cancelLabel: {
            id: 'fabric.editor.ai.screens.preview.cancelLabel',
            defaultMessage: 'Cancel',
            description: 'The action text for the cancel button to discard the previewed generated content'
        },
        discardLabel: {
            id: 'fabric.editor.ai.screens.preview.discardLabel',
            defaultMessage: 'Discard',
            description: 'The action text for the discard button to cancel the previewed generated content'
        },
        defaultInputPlaceholder: {
            id: 'fabric.editor.ai.screens.preview.defaultAIPlaceholder',
            defaultMessage: 'Tell AI what to do next',
            description: 'The default placeholder text for the prompt input field within the Preview screen'
        },
        placeholderWithAgent: {
            id: 'fabric.editor.ai.screens.preview.placeholderWithAgent',
            defaultMessage: 'Ask {agentName} what to do next',
            description: 'The placeholder text for the prompt input field within the Preview screen when an agent is selected'
        },
        disclaimer: {
            id: 'fabric.editor.ai.screens.preview.disclaimer',
            defaultMessage: 'Information quality may vary.',
            description: 'The text for the generated content disclaimer'
        },
        disclaimerLink: {
            id: 'fabric.editor.ai.screens.preview.disclaimerLink',
            defaultMessage: 'Learn why',
            description: 'The text for the generated content disclaimer link'
        },
        previewScreenLabel: {
            id: 'fabric.editor.ai.experience.previewScreenLabel',
            defaultMessage: 'Preview',
            description: 'Accessible label for the AI response preview screen of the AI modal'
        },
        refineButton: {
            id: 'fabric.editor.ai.screens.preview.refineButton',
            defaultMessage: 'Refine',
            description: 'The action text for the refine button to edit the previewed generated content'
        }
    });
});
parcelRegister("6xbJx", function(module, exports) {
    $parcel$export(module.exports, "containerLayout", ()=>$6f976a5eb0653738$export$a4e80cd8d85917bb);
    $parcel$export(module.exports, "previewContainer", ()=>$6f976a5eb0653738$export$8aade8ce2b5d7e87);
    $parcel$export(module.exports, "previewContainerTopBorder", ()=>$6f976a5eb0653738$export$6ad21f8a8c5cd505);
    $parcel$export(module.exports, "arrowContainer", ()=>$6f976a5eb0653738$export$8c605e5cd4469629);
    $parcel$export(module.exports, "multipromptContent", ()=>$6f976a5eb0653738$export$28a15ace69de31e4);
    $parcel$export(module.exports, "previewContainerWithMultiPrompt", ()=>$6f976a5eb0653738$export$7168ad484f49e80d);
    $parcel$export(module.exports, "previewScreenWithMultiPrompt", ()=>$6f976a5eb0653738$export$d6a40e3554a9940a);
    $parcel$export(module.exports, "columnLayout", ()=>$6f976a5eb0653738$export$f8ce731bdfd45dc7);
    $parcel$export(module.exports, "interrogationWrapper", ()=>$6f976a5eb0653738$export$2dd148bc303d2b78);
    var $f8Sb3;
    function $6f976a5eb0653738$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $6f976a5eb0653738$export$a4e80cd8d85917bb = {
        name: "1fttcpj",
        styles: "display:flex;flex-direction:column"
    };
    const $6f976a5eb0653738$export$8aade8ce2b5d7e87 = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: "var(--ds-space-150, 12px)",
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
    });
    const $6f976a5eb0653738$export$6ad21f8a8c5cd505 = (0, (0, parcelRequire("f8Sb3")).css)({
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
    });
    const $6f976a5eb0653738$export$8c605e5cd4469629 = {
        name: "qbt5ty",
        styles: "align-self:center"
    };
    const $6f976a5eb0653738$export$28a15ace69de31e4 = (0, (0, parcelRequire("f8Sb3")).css)({
        flexGrow: 1,
        padding: `0 ${"var(--ds-space-150, 12px)"}`
    });
    const $6f976a5eb0653738$export$7168ad484f49e80d = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: "var(--ds-space-150, 12px)",
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`,
        display: `flex`,
        flexDirection: 'column'
    });
    const $6f976a5eb0653738$export$d6a40e3554a9940a = (0, (0, parcelRequire("f8Sb3")).css)({
        paddingBottom: "var(--ds-space-150, 12px)",
        display: `flex`
    });
    const $6f976a5eb0653738$export$2ecf5991ce6f67a6 = {
        name: "1gvncb5",
        styles: "display:flex;flex-wrap:wrap-reverse;justify-content:flex-end;gap:var(--ds-space-100, 8px);padding-top:var(--ds-space-150, 12px)"
    };
    const $6f976a5eb0653738$export$25ca69593c932f43 = {
        name: "1n8met0",
        styles: "padding-top:0"
    };
    const $6f976a5eb0653738$export$4a295b3126c7469c = {
        name: "1hgkv5t",
        styles: "display:flex;flex-wrap:wrap;justify-content:flex-end;gap:var(--ds-space-100, 8px)"
    };
    const $6f976a5eb0653738$export$f8ce731bdfd45dc7 = {
        name: "1xjlk2n",
        styles: "display:flex;flex-direction:column;align-items:flex-start;gap:var(--ds-space-050, 4px)"
    };
    const $6f976a5eb0653738$export$2dd148bc303d2b78 = (0, (0, parcelRequire("f8Sb3")).css)({
        '& .ak-editor-content-area .ProseMirror': {
            margin: 0
        },
        minHeight: `calc(${"var(--ds-space-600, 48px)"} + 0.5px)`,
        boxSizing: 'border-box'
    });
    const $6f976a5eb0653738$export$c19244d3e10df333 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexWrap: 'wrap',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
        gap: "var(--ds-space-050, 4px)",
        borderTopLeftRadius: 'unset',
        borderTopRightRadius: 'unset',
        backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        alignItems: 'center',
        justifyContent: 'space-between'
    });
    const $6f976a5eb0653738$export$913d9555a421572b = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        minWidth: 0,
        minHeight: "var(--ds-space-300, 24px)",
        '& > p, & > div:first-child': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            fontSize: '11px',
            marginTop: 0
        },
        '& > span': {
            marginTop: "var(--ds-space-050, 4px)",
            marginRight: "var(--ds-space-050, 4px)",
            marginBottom: "var(--ds-space-050, 4px)"
        }
    });
});
parcelRegister("hYL9h", function(module, exports) {
    $parcel$export(module.exports, "prefillPromptRecord", ()=>$974e6baef80d72bd$export$4eb496bca9a9cdd3);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $drVv2;
    var $8gLLR;
    var $ecSHt;
    var $6AuiH;
    const $974e6baef80d72bd$var$SELECTION_TYPE = 'empty';
    const $974e6baef80d72bd$export$4eb496bca9a9cdd3 = {
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).CompetitiveAnalysis]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_COMPETITIVE_ANALYSIS,
            message: (0, (0, parcelRequire("ecSHt")).messages).competitiveAnalysisPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).DevOps]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_DEVOPS,
            message: (0, (0, parcelRequire("ecSHt")).messages).devOpsPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ExperimentPlan]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_EXPERIMENT_PLAN,
            message: (0, (0, parcelRequire("ecSHt")).messages).experimentPlanPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).MarketingCampaign]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_MARKETING_CAMPAIGN,
            message: (0, (0, parcelRequire("ecSHt")).messages).marketingCampaignPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductLaunchAnnouncement]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_PRODUCT_LAUNCH_ANNOUNCEMENT,
            message: (0, (0, parcelRequire("ecSHt")).messages).productLaunchAnnouncementPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductRoadmap]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_PRODUCT_ROADMAP,
            message: (0, (0, parcelRequire("ecSHt")).messages).productRoadmapPrompt
        },
        [(0, (0, parcelRequire("6AuiH")).PrefillPrompts).SprintPlanning]: {
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).PREFILL_SPRINT_PLANNING,
            message: (0, (0, parcelRequire("ecSHt")).messages).sprintPlanningPrompt
        }
    };
    const $974e6baef80d72bd$export$ad445635c33b2f4a = (prompt)=>{
        const { key: key, message: message } = $974e6baef80d72bd$export$4eb496bca9a9cdd3[prompt];
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: key,
            title: message,
            description: message,
            selectionType: $974e6baef80d72bd$var$SELECTION_TYPE,
            icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("drVv2")).Icon), {
                    shownAt: shownAt
                }),
            getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    node: editorView.state.doc,
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $974e6baef80d72bd$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    document: markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'custom_free_generate_intent_schema.json',
                    contentStatistics: contentStatistics
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    customPrompt: promptInput,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'custom_free_generate_intent_schema.json',
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document
                });
            },
            isVisible: ({ editorView: editorView })=>!(editorView.state.doc.nodeSize - 4),
            getBackendModel: ()=>'assistance-service',
            disableInterrogation: ()=>false,
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            isPrefill: true
        });
    };
    const $974e6baef80d72bd$export$347cedca12ea566a = [
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).MarketingCampaign),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).CompetitiveAnalysis),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).SprintPlanning),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).ExperimentPlan),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).DevOps),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductRoadmap),
        $974e6baef80d72bd$export$ad445635c33b2f4a((0, (0, parcelRequire("6AuiH")).PrefillPrompts).ProductLaunchAnnouncement)
    ];
});
parcelRegister("7QN7E", function(module, exports) {
    $parcel$export(module.exports, "streamConvoAI", ()=>$e37180502699874a$export$17dec84f7995172c);
    var $e4Vft;
    var $gIHA4;
    var $5LAwF;
    var $3RkUa;
    const $e37180502699874a$var$sanitizeUrl = (url)=>url.replace(/[^\w\-/.:%?=]+/g, '');
    const $e37180502699874a$export$17dec84f7995172c = (input, customEndpoint)=>{
        return function promptRequest(requestOptions) {
            let draft_selected_content = input.currentSelection;
            if ('draftSelectedContentOverride' in input && input.draftSelectedContentOverride) draft_selected_content = input.draftSelectedContentOverride;
            else if (input.fullDocument === input.currentSelection) draft_selected_content = undefined;
            const streamingResponseGenerator = (0, (0, parcelRequire("gIHA4")).startStreamingResponse)({
                endpoint: customEndpoint || (0, (0, parcelRequire("e4Vft")).convoAIStatelessApiURL),
                payload: JSON.stringify({
                    ...'customPrompt' in input && input.customPrompt ? {
                        recipient_agent_named_id: 'editor_agent',
                        agent_input_prompt: input.customPrompt
                    } : {
                        recipient_agent_named_id: 'editor_intent_agent'
                    },
                    agent_input_context: {
                        ai_session_id: input.aiSessionId,
                        content_url: $e37180502699874a$var$sanitizeUrl(input.currentUrl || document.location.href),
                        writing_intent: input.intentSchemaId,
                        draft_full_content: input.fullDocument,
                        draft_selected_content: draft_selected_content,
                        supported_markdown_nodes: (0, (0, parcelRequire("5LAwF")).getSupportedMarkdowns)(input.editorSchema),
                        input_mime_type: 'text/markdown',
                        output_mime_type: 'text/markdown',
                        locale: input.userLocale,
                        product: requestOptions.product,
                        transformation_subtype: 'transformationSubtype' in input && input.transformationSubtype ? input.transformationSubtype : undefined
                    }
                }),
                ...requestOptions
            });
            return (0, (0, parcelRequire("3RkUa")).streamResponseParser)({
                streamingResponseGenerator: streamingResponseGenerator,
                isConvoAI: true
            });
        };
    };
});
parcelRegister("e4Vft", function(module, exports) {
    $parcel$export(module.exports, "_getFetchCustomHeaders", ()=>$aeacf02970b79a0f$export$bd1a8b310b130c9d);
    $parcel$export(module.exports, "deriveProactiveAIApiUrl", ()=>$aeacf02970b79a0f$export$2f9e5a704d3d0517);
    $parcel$export(module.exports, "deriveProactiveAIConfig", ()=>$aeacf02970b79a0f$export$57fcb528e9e98e56);
    $parcel$export(module.exports, "convoAIStatelessApiURL", ()=>$aeacf02970b79a0f$export$4388fb67ca0987b2);
    $parcel$export(module.exports, "convoAIStatefulApiURL", ()=>$aeacf02970b79a0f$export$4d6359d758c27a3e);
    var $5IPCv;
    var $VSDnB;
    var $bHdjO;
    function $aeacf02970b79a0f$export$bd1a8b310b130c9d() {
        const currentHost = window.location.origin;
        switch(true){
            case currentHost === 'https://statlas.prod.atl-paas.net':
                return {};
            default:
                return {};
        }
    }
    function $aeacf02970b79a0f$export$9167f99f9be83b24() {
        const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
        if (hostname === 'localhost' && port !== '8081' || [
            'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
            'statlas.prod.atl-paas.net',
            'atlaskit.atlassian.com'
        ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
        return origin;
    }
    function $aeacf02970b79a0f$export$fb4af722000bf4fd() {
        return `${$aeacf02970b79a0f$export$9167f99f9be83b24()}/gateway/api/editor-ai/v1/generative/ai`;
    }
    function $aeacf02970b79a0f$export$d365fbd417805450() {
        const version = (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_ai_md_plus') ? 'v2' : 'v1';
        const url = new URL(`/gateway/api/${version}/grammar`, $aeacf02970b79a0f$export$9167f99f9be83b24());
        const getExperimentValue = (0, (0, parcelRequire("5IPCv")).default).getExperimentValue;
        const variation = getExperimentValue('editor_ai_-_proactive_ai_model_variations', 'cohort', 'not-enrolled');
        if (variation !== 'not-enrolled' && variation !== 'control') url.searchParams.set('variation', variation);
        return url.toString();
    }
    function $aeacf02970b79a0f$export$2f9e5a704d3d0517() {
        return `${$aeacf02970b79a0f$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/proactive`;
    }
    const $aeacf02970b79a0f$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME = 4000;
    const $aeacf02970b79a0f$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME = 30000;
    const $aeacf02970b79a0f$var$DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME = 2000;
    function $aeacf02970b79a0f$export$57fcb528e9e98e56(overrides) {
        return {
            enabled: false,
            apiUrl: $aeacf02970b79a0f$export$d365fbd417805450(),
            defaultToggledState: false,
            timings: {
                currentChunks: $aeacf02970b79a0f$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME,
                currentChunksMaxWait: $aeacf02970b79a0f$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME,
                nonCurrentChunks: $aeacf02970b79a0f$var$DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME
            },
            documentSGChecker: {
                enabled: true,
                blocksPerRequest: (0, (0, parcelRequire("bHdjO")).NUMBER_OF_BLOCKS_PER_REQUEST),
                sentencesPerRequest: (0, (0, parcelRequire("bHdjO")).NUMBER_OF_SENTENCES_PER_REQUEST),
                timings: {
                    delayBetweenChecks: (0, (0, parcelRequire("bHdjO")).DELAY_BETWEEN_TWO_CHECKS),
                    numberOfRequestsForIncrease: (0, (0, parcelRequire("bHdjO")).NUMBER_OF_REQUESTS_FOR_INCREASE),
                    delayIncrease: (0, (0, parcelRequire("bHdjO")).DELAY_INCREASE),
                    maxDelay: (0, (0, parcelRequire("bHdjO")).MAX_DELAY)
                }
            },
            ...overrides
        };
    }
    const $aeacf02970b79a0f$export$4388fb67ca0987b2 = `${$aeacf02970b79a0f$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
    const $aeacf02970b79a0f$export$4d6359d758c27a3e = `${$aeacf02970b79a0f$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/channel`;
});
parcelRegister("bHdjO", function(module, exports) {
    $parcel$export(module.exports, "NUMBER_OF_BLOCKS_PER_REQUEST", ()=>$d86655b4f0f4f70f$export$35689b193349d90);
    $parcel$export(module.exports, "NUMBER_OF_SENTENCES_PER_REQUEST", ()=>$d86655b4f0f4f70f$export$966185c87e792276);
    $parcel$export(module.exports, "DELAY_BETWEEN_TWO_CHECKS", ()=>$d86655b4f0f4f70f$export$dc46b8effd0196d1);
    $parcel$export(module.exports, "NUMBER_OF_REQUESTS_FOR_INCREASE", ()=>$d86655b4f0f4f70f$export$4873c8a72cbeda9a);
    $parcel$export(module.exports, "DELAY_INCREASE", ()=>$d86655b4f0f4f70f$export$9e95fe55e9afc603);
    $parcel$export(module.exports, "MAX_DELAY", ()=>$d86655b4f0f4f70f$export$bfc94b1a1998fcab);
    $parcel$export(module.exports, "DocumentSGChecker", ()=>$d86655b4f0f4f70f$export$b90f3c475be8201e);
    var $ldiyo;
    var $4dOAK;
    var $5ilgR;
    const $d86655b4f0f4f70f$export$35689b193349d90 = 3;
    const $d86655b4f0f4f70f$export$966185c87e792276 = 7;
    const $d86655b4f0f4f70f$export$dc46b8effd0196d1 = 4000;
    const $d86655b4f0f4f70f$export$4873c8a72cbeda9a = 2;
    const $d86655b4f0f4f70f$export$9e95fe55e9afc603 = 2000;
    const $d86655b4f0f4f70f$export$bfc94b1a1998fcab = 14000;
    const $d86655b4f0f4f70f$export$f84bd70098573c5c = {
        enabled: false,
        blocksPerRequest: $d86655b4f0f4f70f$export$35689b193349d90,
        sentencesPerRequest: $d86655b4f0f4f70f$export$966185c87e792276,
        timings: {
            delayBetweenChecks: $d86655b4f0f4f70f$export$dc46b8effd0196d1,
            numberOfRequestsForIncrease: $d86655b4f0f4f70f$export$4873c8a72cbeda9a,
            delayIncrease: $d86655b4f0f4f70f$export$9e95fe55e9afc603,
            maxDelay: $d86655b4f0f4f70f$export$bfc94b1a1998fcab
        }
    };
    class $d86655b4f0f4f70f$export$b90f3c475be8201e {
        getSGPluginState() {
            if (this.view) return (0, (0, parcelRequire("4dOAK")).getPluginState)(this.view.state);
        }
        getChunks() {
            const pluginState = this.getSGPluginState();
            if (pluginState) {
                const { splitParagraphIntoSentences: splitParagraphIntoSentences, proactiveAIBlocks: proactiveAIBlocks } = pluginState;
                const blocks = proactiveAIBlocks || [];
                return splitParagraphIntoSentences ? (0, (0, parcelRequire("5ilgR")).getBlocksSentences)(blocks) : blocks;
            }
            return [];
        }
        filterChunksNeedingSGCheck(chunks) {
            return chunks.filter((chunk)=>!!chunk.needSGCheckForDocChecker);
        }
        getNextChunks() {
            let chunks = this.getChunks();
            chunks = this.filterChunksNeedingSGCheck(chunks);
            return chunks.slice(0, this.chunksPerRequest);
        }
        async checkNextBlocks() {
            if (!this.view || !this.locale) return;
            const chunks = this.getNextChunks();
            if (chunks.length) {
                await (0, (0, parcelRequire("ldiyo")).updateChunksWithDiffObjects)(this.view, chunks, this.locale);
                this.setTimer();
            } else this.stop();
        }
        setTimer() {
            if (this.currentDelay !== this.config.timings.maxDelay) {
                this.requestsSentSinceLastIncrease = this.requestsSentSinceLastIncrease + 1;
                if (this.requestsSentSinceLastIncrease < this.config.timings.numberOfRequestsForIncrease) {
                    this.currentDelay = Math.min(this.config.timings.maxDelay, this.currentDelay + this.config.timings.delayIncrease);
                    this.requestsSentSinceLastIncrease = 0;
                }
            }
            this.timerId = setTimeout(this.checkNextBlocks.bind(this), this.currentDelay);
        }
        setEditorViewAndLocale(config, view, locale) {
            this.config = config;
            this.currentDelay = config.timings.delayBetweenChecks;
            this.chunksPerRequest = config.blocksPerRequest;
            this.view = view;
            this.locale = locale;
        }
        start() {
            this.stop();
            const pluginState = this.getSGPluginState();
            const splitParagraphIntoSentences = pluginState?.splitParagraphIntoSentences;
            this.chunksPerRequest = splitParagraphIntoSentences ? this.config.sentencesPerRequest : this.config.blocksPerRequest;
            this.checkNextBlocks();
        }
        stop() {
            clearTimeout(this.timerId);
            this.timerId = undefined;
            this.currentDelay = this.config.timings.delayBetweenChecks;
            this.requestsSentSinceLastIncrease = 0;
        }
        reset() {
            this.stop();
            this.view = undefined;
            this.locale = undefined;
        }
        constructor(){
            this.config = $d86655b4f0f4f70f$export$f84bd70098573c5c;
            this.chunksPerRequest = $d86655b4f0f4f70f$export$35689b193349d90;
            this.currentDelay = $d86655b4f0f4f70f$export$dc46b8effd0196d1;
            this.requestsSentSinceLastIncrease = 0;
        }
    }
});
parcelRegister("5LAwF", function(module, exports) {
    $parcel$export(module.exports, "getSupportedMarkdowns", ()=>$6614ab3a449e85bb$export$64c88b3c322e3de4);
    const $6614ab3a449e85bb$var$backEndSupportedMarkdown = {
        blockquote: 'BLOCKQUOTES',
        paragraph: 'PARAGRAPH',
        rule: 'HORIZONTAL_RULE',
        heading: 'HEADING',
        hardbreak: 'HARD_LINE_BREAK',
        codeBlock: 'CODEBLOCKS',
        bulletList: 'BULLET_LISTS',
        orderedList: 'NUMBERED_LISTS',
        media: 'IMAGES',
        table: 'TABLE',
        taskList: 'TASK_LIST',
        code: 'CODE_SPAN',
        em: 'ITALICS',
        strong: 'BOLD',
        link: 'LINK',
        strike: 'STRIKETHROUGH'
    };
    const $6614ab3a449e85bb$export$64c88b3c322e3de4 = (schema)=>{
        if (!schema?.nodes && !schema?.marks) return [];
        const schemaNodesAndMarks = [
            ...Object.keys(schema.nodes),
            ...Object.keys(schema.marks)
        ];
        return schemaNodesAndMarks.map((nodeOrMark)=>$6614ab3a449e85bb$var$backEndSupportedMarkdown[nodeOrMark]).filter(Boolean);
    };
});
parcelRegister("3RkUa", function(module, exports) {
    $parcel$export(module.exports, "streamResponseParser", ()=>$212105d376f673f9$export$bb248b701d0ae0f9);
    function $212105d376f673f9$var$parsedHasExpectedKey(key, parsed) {
        if (typeof parsed !== 'object' || parsed === null || !(key in parsed)) return false;
        return true;
    }
    async function* $212105d376f673f9$export$bb248b701d0ae0f9({ streamingResponseGenerator: streamingResponseGenerator, isConvoAI: isConvoAI, streamingListener: streamingListener }) {
        let partialMeta = {
            inputOutputDiffRatio: ''
        };
        let partial = {
            type: 'markdown',
            content: '',
            meta: partialMeta,
            rovoActions: []
        };
        for await (const yieldedResponse of streamingResponseGenerator){
            if (yieldedResponse.state === 'loaded-stream') return yield {
                state: 'loaded',
                data: partial
            };
            if (yieldedResponse.state === 'loading' || yieldedResponse.state === 'loaded') {
                if ($212105d376f673f9$var$parsedHasExpectedKey('generatedContent', yieldedResponse.data)) {
                    partial = {
                        type: 'markdown',
                        content: partial.content + yieldedResponse.data['generatedContent'],
                        rovoActions: partial.rovoActions,
                        meta: $212105d376f673f9$var$parsedHasExpectedKey('meta', yieldedResponse.data) && $212105d376f673f9$var$parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                            inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio'],
                            loadingStatus: ''
                        } : partial.meta
                    };
                    if (streamingListener) streamingListener(partial.content, yieldedResponse.state);
                    yield {
                        state: yieldedResponse.state,
                        data: partial
                    };
                } else if (isConvoAI) {
                    if ($212105d376f673f9$var$parsedHasExpectedKey('type', yieldedResponse.data)) {
                        if (yieldedResponse.data.type === 'TRACE') {
                            const loadingStatus = $212105d376f673f9$var$parsedHasExpectedKey('message', yieldedResponse.data) && $212105d376f673f9$var$parsedHasExpectedKey('message_template', yieldedResponse.data.message) ? yieldedResponse.data.message.message_template : '';
                            partial = {
                                ...partial,
                                type: 'markdown',
                                content: partial.content,
                                meta: {
                                    inputOutputDiffRatio: '',
                                    loadingStatus: loadingStatus
                                }
                            };
                        }
                        if (yieldedResponse.data.type === 'ANSWER_PART') partial = {
                            ...partial,
                            type: 'markdown',
                            content: partial.content + yieldedResponse.data.message.content,
                            meta: {
                                inputOutputDiffRatio: '',
                                loadingStatus: ''
                            }
                        };
                        if (yieldedResponse.data.type === 'FINAL_RESPONSE') {
                            const { message: message } = yieldedResponse.data;
                            if ($212105d376f673f9$var$parsedHasExpectedKey('message_metadata', message.message) && $212105d376f673f9$var$parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) return yield {
                                state: 'failed',
                                statusCode: message.status_code,
                                reason: 'response-too-similar',
                                data: {
                                    meta: {
                                        inputOutputDiffRatio: message.message?.message_metadata?.diff_ratio || ''
                                    }
                                }
                            };
                            const rovoActions = message.message.actions || [];
                            partial = {
                                ...partial,
                                type: 'markdown',
                                content: message.message.content,
                                meta: {
                                    inputOutputDiffRatio: message.message?.message_metadata?.diff_ratio || '',
                                    loadingStatus: ''
                                },
                                rovoActions: rovoActions
                            };
                        }
                        if (yieldedResponse.data.type === 'ERROR') {
                            let statusCode;
                            let guard;
                            let error;
                            let retryAfter;
                            if ($212105d376f673f9$var$parsedHasExpectedKey('message', yieldedResponse.data)) {
                                if ($212105d376f673f9$var$parsedHasExpectedKey('status_code', yieldedResponse.data.message) && typeof yieldedResponse.data.message.status_code === 'number') statusCode = yieldedResponse.data.message.status_code;
                                if ($212105d376f673f9$var$parsedHasExpectedKey('message_template', yieldedResponse.data.message)) guard = yieldedResponse.data.message.message_template;
                                if ($212105d376f673f9$var$parsedHasExpectedKey('content', yieldedResponse.data.message)) error = yieldedResponse.data.message.content;
                                if ($212105d376f673f9$var$parsedHasExpectedKey('headers', yieldedResponse.data) && $212105d376f673f9$var$parsedHasExpectedKey('Retry-After', yieldedResponse.data.headers)) retryAfter = Number(yieldedResponse.data.headers['Retry-After']);
                            }
                            if (guard) {
                                if (statusCode === 429) return yield {
                                    state: 'failed',
                                    apiName: 'assistance-service',
                                    statusCode: statusCode,
                                    guard: guard,
                                    error: error,
                                    retryAfter: retryAfter
                                };
                                return yield {
                                    state: 'failed',
                                    apiName: 'assistance-service',
                                    statusCode: statusCode,
                                    guard: guard,
                                    error: error
                                };
                            }
                            return yield {
                                state: 'failed',
                                apiName: 'assistance-service',
                                statusCode: statusCode,
                                guard: 'UNHANDLED_ERROR',
                                error: error
                            };
                        }
                        yield {
                            state: yieldedResponse.state,
                            data: partial
                        };
                    } else yield {
                        state: yieldedResponse.state,
                        data: partial
                    };
                } else return yield {
                    state: 'failed',
                    reason: 'parsing'
                };
            } else {
                if (yieldedResponse.state === 'failed' && yieldedResponse.reason !== 'response-too-similar' || yieldedResponse.state === 'aup-violation') return yield yieldedResponse;
                else {
                    let responseTooSimilarData = {
                        meta: $212105d376f673f9$var$parsedHasExpectedKey('meta', yieldedResponse.data) && $212105d376f673f9$var$parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                            inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio']
                        } : partialMeta
                    };
                    return yield {
                        state: 'failed',
                        statusCode: 208,
                        reason: 'response-too-similar',
                        data: responseTooSimilarData
                    };
                }
            }
        }
    }
});
parcelRegister("drVv2", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$b4a212dd4782c508$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8K52v;
    const $b4a212dd4782c508$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16.5 9.5L18.0581 7.94194C18.3021 7.69786 18.3021 7.30214 18.0581 7.05806L16.9419 5.94194C16.6979 5.69786 16.3021 5.69786 16.0581 5.94194L14.5 7.5M16.5 9.5L11.0176 14.9824C10.8431 15.1569 10.6209 15.2758 10.3789 15.3242L8.25 15.75L8.67578 13.6211C8.72417 13.3791 8.84312 13.1569 9.01762 12.9824L14.5 7.5M16.5 9.5L14.5 7.5M5 18.25H10M16 18.25H14.5M19 18.25H17.5M13 18.25H11.5",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "1.5",
            strokeLinejoin: "round"
        })));
    };
});
parcelRegister("8K52v", function(module, exports) {
    $parcel$export(module.exports, "RainbowBorder", ()=>$df2720f172352e5e$export$36738bc14a47b579);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fAal0;
    var $2Ajl9;
    const $df2720f172352e5e$export$36738bc14a47b579 = (props)=>{
        const { children: children, shownAt: shownAt } = props;
        const id = (0, $5uXOq.useMemo)(()=>`aiIcon_radial_${new Date().getTime()}`, []);
        if (shownAt === 'suggestions') return children;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                (0, (0, parcelRequire("2Ajl9")).styleDiv),
                (0, (0, parcelRequire("2Ajl9")).styleIconBackground)
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            css: (0, (0, parcelRequire("2Ajl9")).styleBorder),
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "0.5",
            y: "1.5",
            width: "37",
            height: "37.5",
            rx: "1.5",
            stroke: `url(#${id})`
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("defs", null, (0, (0, parcelRequire("f8Sb3")).jsx)("radialGradient", {
            id: id,
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(1 1.5) rotate(44.5937) scale(49.8523)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fAal0")).Border), null)))), children));
    };
});
parcelRegister("fAal0", function(module, exports) {
    $parcel$export(module.exports, "Border", ()=>$304f9f9367ee1118$export$d8e9c9d63e86d41e);
    var $5uXOq = parcelRequire("5uXOq");
    var $k0FqT;
    const $304f9f9367ee1118$export$d8e9c9d63e86d41e = ()=>{
        const aiThemeColor = (0, (0, parcelRequire("k0FqT")).useAIThemeColor)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: aiThemeColor('prism.border.step.1')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: aiThemeColor('prism.border.step.1')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.41",
            stopColor: aiThemeColor('prism.border.step.2')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.73",
            stopColor: aiThemeColor('prism.border.step.3')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.86",
            stopColor: aiThemeColor('prism.border.step.4')
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: aiThemeColor('prism.border.step.4')
        }));
    };
});
parcelRegister("2Ajl9", function(module, exports) {
    $parcel$export(module.exports, "styleDiv", ()=>$0b91ea441d6b0abf$export$e3954c8d3eea2d73);
    $parcel$export(module.exports, "styleIconBackground", ()=>$0b91ea441d6b0abf$export$6bed1d6e2b9a9393);
    $parcel$export(module.exports, "styleBorder", ()=>$0b91ea441d6b0abf$export$25bdff09c381b13a);
    var $f8Sb3;
    function $0b91ea441d6b0abf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0b91ea441d6b0abf$export$e3954c8d3eea2d73 = {
        name: "1hi7pud",
        styles: "position:relative;align-items:center;display:flex;justify-content:center"
    };
    const $0b91ea441d6b0abf$export$6bed1d6e2b9a9393 = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $0b91ea441d6b0abf$export$25bdff09c381b13a = {
        name: "v0mbtg",
        styles: "position:absolute;left:0px;top:0px;right:0;bottom:0"
    };
});
parcelRegister("8gLLR", function(module, exports) {
    $parcel$export(module.exports, "createInsertAtTop", ()=>$e13dfe76fc5619db$export$9e309baaf0e9d41b);
    $parcel$export(module.exports, "createInsertBelow", ()=>$e13dfe76fc5619db$export$2a99e23257616a3);
    $parcel$export(module.exports, "createInsertAtCurrentPosition", ()=>$e13dfe76fc5619db$export$6641dbc1b651cf28);
    $parcel$export(module.exports, "createReplace", ()=>$e13dfe76fc5619db$export$ab7194c13d7567bc);
    $parcel$export(module.exports, "createReplaceExistingConfluenceTitle", ()=>$e13dfe76fc5619db$export$bac6a2ed25caf91c);
    var $kCV8T;
    var $5r0mK = parcelRequire("5r0mK");
    var $1BdtL;
    var $9Tzox;
    var $exyUy;
    var $dhbXh;
    const $e13dfe76fc5619db$export$9e309baaf0e9d41b = ({ appearance: appearance })=>({
            type: 'markdown',
            title: (0, (0, parcelRequire("dhbXh")).messages).insertAtTop,
            appearance: appearance,
            run ({ editorView: editorView, pmFragment: pmFragment }) {
                const { state: state } = editorView;
                const transaction = state.tr;
                const slice = new (0, (0, parcelRequire("kCV8T")).Slice)(pmFragment, 0, 0);
                transaction.replace(0, 0, slice);
                (0, (0, parcelRequire("exyUy")).beforeDispatchAITransaction)(transaction, state);
                editorView.dispatch(transaction);
            }
        });
    const $e13dfe76fc5619db$export$2a99e23257616a3 = ({ appearance: appearance })=>({
            type: 'markdown',
            title: (0, (0, parcelRequire("dhbXh")).messages).insertBelow,
            appearance: appearance,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
                const { state: state } = editorView;
                const transaction = state.tr;
                if (triggeredFor?.isBlock) {
                    const insertPos = positions[1];
                    (0, $5r0mK.safeInsert)(pmFragment, insertPos)(transaction);
                    (0, (0, parcelRequire("exyUy")).beforeDispatchingTransactionForBlocks)(pmFragment, transaction, editorView.state);
                } else {
                    const insertPos = state.doc.resolve(positions[1]).after();
                    (0, $5r0mK.safeInsert)(pmFragment, insertPos)(transaction);
                }
                (0, (0, parcelRequire("exyUy")).beforeDispatchAITransaction)(transaction, state);
                editorView.dispatch(transaction);
            }
        });
    const $e13dfe76fc5619db$export$6641dbc1b651cf28 = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
            type: 'markdown',
            title: (0, (0, parcelRequire("dhbXh")).messages).insert,
            appearance: appearance,
            isRovoAgentAction: isRovoAgentAction,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
                const tr = (0, (0, parcelRequire("exyUy")).insertAIContentAtCurrentPosition)({
                    editorView: editorView,
                    positions: positions,
                    pmFragment: pmFragment
                });
                if (isRovoAgentAction) (0, (0, parcelRequire("exyUy")).beforeDispatchAIRovoAgentTransaction)(tr);
                editorView.dispatch(tr);
            }
        });
    const $e13dfe76fc5619db$export$ab7194c13d7567bc = ({ appearance: appearance, isRovoAgentAction: isRovoAgentAction })=>({
            type: 'markdown',
            title: (0, (0, parcelRequire("dhbXh")).messages).replace,
            appearance: appearance,
            isRovoAgentAction: isRovoAgentAction,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
                const tr = triggeredFor?.isBlock ? (0, (0, parcelRequire("exyUy")).replaceWithAIContentForBlock)({
                    editorView: editorView,
                    positions: positions,
                    pmFragment: pmFragment,
                    triggeredFor: triggeredFor
                }) : (0, (0, parcelRequire("exyUy")).replaceWithAIContent)({
                    editorView: editorView,
                    positions: positions,
                    pmFragment: pmFragment
                });
                if (isRovoAgentAction) (0, (0, parcelRequire("exyUy")).beforeDispatchAIRovoAgentTransaction)(tr);
                editorView.dispatch(tr);
            }
        });
    const $e13dfe76fc5619db$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({
            type: 'markdown',
            title: (0, (0, parcelRequire("dhbXh")).messages).replaceTitle,
            appearance: appearance,
            getDisabledState: ({ markdown: markdown, formatMessage: formatMessage })=>{
                const responseLength = markdown?.length ?? 0;
                const MAX_TITLE_LENGTH = 255;
                if (responseLength >= MAX_TITLE_LENGTH) return {
                    isDisabled: true,
                    tooltip: formatMessage((0, (0, parcelRequire("dhbXh")).messages).replaceTitleTooLongDisabledTooltip, {
                        maxLength: MAX_TITLE_LENGTH
                    })
                };
                return {
                    isDisabled: false
                };
            },
            run ({ editorView: editorView, pmFragment: pmFragment }) {
                let fragmentToInsert = pmFragment;
                let textContent = '';
                fragmentToInsert.forEach((node)=>{
                    textContent += node.textContent;
                });
                const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
                if (confluenceTitle) {
                    const sourceEditorId = (0, (0, parcelRequire("9Tzox")).findEditorIdFromView)(editorView);
                    if (sourceEditorId) (0, (0, parcelRequire("1BdtL")).eventHub).publishFromEditor({
                        event: 'replace title in confluence',
                        data: {
                            analyticSourceId: 'confluenceTitleToolbar',
                            sourceEditorId: sourceEditorId,
                            title: textContent
                        }
                    });
                    confluenceTitle.scrollIntoView();
                }
            }
        });
});
parcelRegister("1BdtL", function(module, exports) {
    $parcel$export(module.exports, "eventHub", ()=>$af04d9796e76078a$export$e17a52e5da72c4cb);
    class $af04d9796e76078a$var$EventHub {
        constructor(){
            this.subscribers = new Map();
            this.subscribers = new Map();
        }
        subscribe({ event: event, callback: callback }) {
            const callbacks = this.subscribers.get(event) || [];
            this.subscribers.set(event, [
                ...callbacks,
                callback
            ]);
            return {
                unsubscribe: ()=>{
                    const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                    if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                    else this.subscribers.delete(event);
                }
            };
        }
        publishToEditor({ event: event, data: data }) {
            const callbacks = this.subscribers.get(event) || [];
            callbacks.forEach((callback)=>{
                callback(data);
            });
        }
        publishFromEditor({ event: event, data: data }) {
            const callbacks = this.subscribers.get(event) || [];
            callbacks.forEach((callback)=>{
                callback(data);
            });
        }
    }
    const $af04d9796e76078a$export$e17a52e5da72c4cb = new $af04d9796e76078a$var$EventHub();
});
parcelRegister("9Tzox", function(module, exports) {
    $parcel$export(module.exports, "findEditorIdFromView", ()=>$2aa0dbe3ad2516fd$export$700cb401385d6bf2);
    const $2aa0dbe3ad2516fd$export$700cb401385d6bf2 = (editorView)=>{
        return editorView.dom?.dataset?.editorId;
    };
});
parcelRegister("exyUy", function(module, exports) {
    $parcel$export(module.exports, "beforeDispatchAITransaction", ()=>$ed564d451fb3c8f5$export$336eb673e6d24058);
    $parcel$export(module.exports, "beforeDispatchingTransactionForBlocks", ()=>$ed564d451fb3c8f5$export$7b46ef9a312ebccb);
    $parcel$export(module.exports, "beforeDispatchAIRovoAgentTransaction", ()=>$ed564d451fb3c8f5$export$cfdd8b8691129358);
    $parcel$export(module.exports, "replaceWithAIContentForBlock", ()=>$ed564d451fb3c8f5$export$841048b11479358);
    $parcel$export(module.exports, "replaceWithAIContent", ()=>$ed564d451fb3c8f5$export$60bccdedcf767536);
    $parcel$export(module.exports, "insertAIContentAtCurrentPosition", ()=>$ed564d451fb3c8f5$export$7dc11dddc9c93a89);
    var $gkwXh;
    var $kCV8T;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $9m3ZB;
    var $9A8mD;
    var $2nx9e;
    function $ed564d451fb3c8f5$export$336eb673e6d24058(tr, editorState) {
        tr.setMeta('isAiContentTransformation', true);
        const firstReplaceStep = (0, (0, parcelRequire("9A8mD")).findFirstReplaceStep)(tr.steps);
        if (!firstReplaceStep) {
            (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: editorState,
                tr: tr,
                payload: {
                    action: 'failed',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        errorType: 'replaceStepNotFound'
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
                }
            });
            return tr;
        }
        const validPositionToSet = (0, (0, parcelRequire("9A8mD")).getValidEndTextPosition)({
            step: firstReplaceStep,
            doc: tr.doc
        });
        if (validPositionToSet !== 0) tr.setSelection((0, (0, parcelRequire("gZGBX")).TextSelection).create(tr.doc, validPositionToSet));
        return tr;
    }
    function $ed564d451fb3c8f5$export$7b46ef9a312ebccb(fragment, tr, state) {
        const supportedNodeTypes = (0, (0, parcelRequire("2nx9e")).getSupportedNodesForAIModal)(state);
        let areTopLevelBlockElements = true;
        fragment.forEach((node)=>{
            areTopLevelBlockElements = areTopLevelBlockElements && supportedNodeTypes.has(node.type);
        });
        if (areTopLevelBlockElements) tr.setMeta('isAiContentTransformationForBlocks', true);
    }
    function $ed564d451fb3c8f5$export$cfdd8b8691129358(tr) {
        tr.setMeta('isAiRovoAgentContentTransformation', true);
        return tr;
    }
    function $ed564d451fb3c8f5$var$getLastContentDepth({ pmFragment: pmFragment }) {
        let depth = 0;
        let currentNode = pmFragment;
        while(currentNode.firstChild){
            depth++;
            currentNode = currentNode.firstChild;
        }
        return depth;
    }
    function $ed564d451fb3c8f5$var$isSelectionAtParagraphStart($pos) {
        const node = $pos.parent;
        return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
    }
    function $ed564d451fb3c8f5$var$isFragmentSingleParagraph(fragment) {
        return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
    }
    function $ed564d451fb3c8f5$var$isSelectionInTaskOrDecisionNode($pos) {
        const node = $pos.parent;
        return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
    }
    const $ed564d451fb3c8f5$export$841048b11479358 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor })=>{
        const { state: state } = editorView;
        let transaction = state.tr;
        const slice = new (0, (0, parcelRequire("kCV8T")).Slice)(pmFragment, 0, 0);
        try {
            transaction.replaceRange(positions[0], positions[1], slice);
        } catch  {
            (0, $5r0mK.safeInsert)(pmFragment, undefined, true)(transaction);
            const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: state,
                tr: state.tr,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {}
                }
            });
            editorView.dispatch(tr);
        }
        $ed564d451fb3c8f5$export$7b46ef9a312ebccb(pmFragment, transaction, editorView.state);
        $ed564d451fb3c8f5$export$336eb673e6d24058(transaction, state);
        return transaction;
    };
    const $ed564d451fb3c8f5$export$60bccdedcf767536 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, options: options = {
        replaceDocOnEmptySelection: true
    } })=>{
        const { state: state } = editorView;
        const transaction = state.tr;
        const endPositionDepth = state.doc.resolve(positions[1]).depth;
        const lastFragmentDepth = $ed564d451fb3c8f5$var$getLastContentDepth({
            pmFragment: pmFragment
        });
        const sliceOpenEnd = Math.min(endPositionDepth, lastFragmentDepth);
        const slice = new (0, (0, parcelRequire("kCV8T")).Slice)(pmFragment, 1, sliceOpenEnd);
        if (options.replaceDocOnEmptySelection && positions[0] === positions[1]) transaction.replaceRange(0, state.doc.content.size, slice);
        else try {
            transaction.replaceRange(positions[0], positions[1], slice);
        } catch  {
            (0, $5r0mK.safeInsert)(pmFragment, undefined, true)(transaction);
            const tr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                editorState: state,
                tr: state.tr,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL,
                    attributes: {}
                }
            });
            editorView.dispatch(tr);
        }
        $ed564d451fb3c8f5$export$336eb673e6d24058(transaction, state);
        return transaction;
    };
    const $ed564d451fb3c8f5$export$7dc11dddc9c93a89 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment })=>{
        const { state: state } = editorView;
        const transaction = state.tr;
        const pos = positions[0];
        const $pos = state.doc.resolve(pos);
        const isParagraphStart = $ed564d451fb3c8f5$var$isSelectionAtParagraphStart($pos);
        const insertPos = isParagraphStart ? pos - 1 : pos;
        let fragmentToInsert = pmFragment;
        if ($ed564d451fb3c8f5$var$isSelectionInTaskOrDecisionNode($pos) && $ed564d451fb3c8f5$var$isFragmentSingleParagraph(pmFragment)) fragmentToInsert = pmFragment.firstChild.content;
        transaction.insert(insertPos, fragmentToInsert);
        $ed564d451fb3c8f5$export$336eb673e6d24058(transaction, state);
        return transaction;
    };
});
parcelRegister("dhbXh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dc30c05f8b5be3fe$export$defe85febe8b728c);
    var $7VHMR;
    const $dc30c05f8b5be3fe$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        insert: {
            id: 'fabric.editor.ai.config.item.action.insert',
            defaultMessage: 'Insert',
            description: 'Inserts the response at the current location'
        },
        insertAtTop: {
            id: 'fabric.editor.ai.config.item.action.insertAtTop',
            defaultMessage: 'Insert at top',
            description: 'Inserts the response at the start of the content'
        },
        insertBelow: {
            id: 'fabric.editor.ai.config.item.action.insertBelow',
            defaultMessage: 'Insert below',
            description: 'Inserts the response below the current location'
        },
        replace: {
            id: 'fabric.editor.ai.config.item.action.replace',
            defaultMessage: 'Replace',
            description: 'Replaces the existing or selected content with the response'
        },
        replaceTitle: {
            id: 'fabric.editor.ai.config.item.action.replaceTitle',
            defaultMessage: 'Replace title',
            description: 'Replaces the existing Confluence document title with the generated title'
        },
        replaceTitleTooLongDisabledTooltip: {
            id: 'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip',
            defaultMessage: 'Title cannot exceed {maxLength} characters',
            description: 'Tooltip that appears over disabled action button when disabled because of title being too long'
        },
        continueInChatLabel: {
            id: 'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel',
            defaultMessage: 'Open in Chat',
            description: 'Tooltip and label for Open in Chat button'
        }
    });
});
parcelRegister("ecSHt", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4381f663dae8c8a4$export$defe85febe8b728c);
    var $7VHMR;
    const $4381f663dae8c8a4$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        marketingCampaignPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.marketingCampaignPrompt',
            defaultMessage: 'Marketing campaign for',
            description: 'A prefillable AI prompt to create a marketing campaign. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        competitiveAnalysisPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.competitiveAnalysisPrompt',
            defaultMessage: 'Competitive analysis on',
            description: 'A prefillable AI prompt to create a competitive analysis template. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        sprintPlanningPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.sprintPlanningPrompt',
            defaultMessage: 'Sprint planning for a project about',
            description: 'A prefillable AI prompt to create a sprint planning template. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        experimentPlanPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.experimentPlanPrompt',
            defaultMessage: 'Software experiment plan on',
            description: 'A prefillable AI prompt to create an experiment plan. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        devOpsPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.devOpsPrompt',
            defaultMessage: 'DevOps runbook for',
            description: 'A prefillable AI prompt to create a DevOps runbook. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        productRoadmapPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.productRoadmapPrompt',
            defaultMessage: 'Product roadmap outlining',
            description: 'A prefillable AI prompt to create a product roadmap. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        },
        productLaunchAnnouncementPrompt: {
            id: 'fabric.editor.ai.config.item.prefill.productLaunchAnnouncementPrompt',
            defaultMessage: 'Product launch announcement on',
            description: 'A prefillable AI prompt to write a product launch announcement. When user selects this it will prefill the user input with this text. When displayed, there will also be a trailing indicator (such as ellipsis) appended to this message to indicate that a user can continue this message. The trailing indicator is another translation string that defaults to "...".'
        }
    });
});
parcelRegister("iozk0", function(module, exports) {
    $parcel$export(module.exports, "useOutsideClickHandler", ()=>$dba5d25c0945a780$export$aa79b0abe3dfeaba);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    function $dba5d25c0945a780$var$isElementHasModalAbove(element) {
        if (!element) return false;
        const elementPortal = element.closest('.atlaskit-portal');
        if (!elementPortal) return !!document.querySelector('[data-focus-guard="true"]');
        let sibling = elementPortal.nextElementSibling;
        while(sibling){
            if (sibling.querySelector('[data-focus-guard="true"]')) return true;
            sibling = sibling.nextElementSibling;
        }
        return false;
    }
    const $dba5d25c0945a780$export$aa79b0abe3dfeaba = ({ disabled: disabled, userInput: userInput, onCancel: onCancel, onDiscard: onDiscard, modalRef: modalRef })=>{
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (disabled) return;
            if (!modalRef) return;
            const handleOutsideClick = (event)=>{
                if ($dba5d25c0945a780$var$isElementHasModalAbove(modalRef.current)) return;
                if (modalRef.current && !modalRef.current.contains(event.target)) {
                    if (!userInput) onCancel();
                    else onDiscard();
                }
            };
            return (0, (0, parcelRequire("cBeZP")).bind)(document, {
                type: 'mousedown',
                listener: handleOutsideClick
            });
        }, [
            disabled,
            userInput,
            onCancel,
            onDiscard,
            modalRef
        ]);
    };
});
parcelRegister("aMkyX", function(module, exports) {
    $parcel$export(module.exports, "getHasAcceptableUseWarning", ()=>$165a7a2ef614bc92$export$429132ba9db86af9);
    const $165a7a2ef614bc92$export$429132ba9db86af9 = ({ markdown: markdown = '', locale: locale })=>{
        const isEnglishLocale = locale.startsWith('en');
        if (!isEnglishLocale) return;
        const markdownLowercase = markdown.toLowerCase();
        return $165a7a2ef614bc92$var$getHasSearchString(markdownLowercase);
    };
    const $165a7a2ef614bc92$var$getHasSearchString = (stringToSearch)=>{
        const acceptableUsePolicySearchStrings = [
            "i'm sorry, but i can't fulfil",
            "i'm sorry, but i cannot fulfil",
            "i am sorry, but i can't fulfil",
            'i am sorry, but i cannot fulfil',
            "atlassian's acceptable use",
            'i apologise, but i cannot fulfil',
            "i apologise, but i can't fulfil",
            'i apologize, but i cannot fulfil',
            "i apologize, but i can't fulfil"
        ];
        const hasSearchString = acceptableUsePolicySearchStrings.some((searchString)=>{
            return stringToSearch.includes(searchString);
        });
        return hasSearchString;
    };
});
parcelRegister("c9MKk", function(module, exports) {
    $parcel$export(module.exports, "stripMatchingOuterQuotes", ()=>$f974d3c686c3daf9$export$8850f5fc4cad5830);
    const $f974d3c686c3daf9$export$8850f5fc4cad5830 = (markdown)=>{
        markdown = markdown.trim();
        const firstChar = markdown.charAt(0);
        const lastChar = markdown.charAt(markdown.length - 1);
        if (firstChar === '"' && lastChar === '"' || firstChar === "'" && lastChar === "'") return markdown.substring(1, markdown.length - 1);
        return markdown;
    };
});
parcelRegister("32Eq0", function(module, exports) {
    $parcel$export(module.exports, "UserInputCommandPaletteWithLogic", ()=>$33ef1f30f0ae02bf$export$751495e555be6bbc);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bPWvi;
    var $50sdg;
    var $3Y1bF;
    var $4V6HW;
    var $3oUqw;
    var $VSDnB;
    var $8S93R;
    var $gmhCD = parcelRequire("gmhCD");
    var $3Y1I5;
    var $h1WZC;
    var $PwAM5;
    var $4xwSH;
    var $dZvxR;
    var $iZGo0;
    var $bJfF5;
    var $6KJH7;
    var $8Oaok;
    var $fp323;
    var $iozk0;
    var $9vp0r;
    var $2Jlja;
    function $33ef1f30f0ae02bf$export$751495e555be6bbc({ context: experienceAppContext, initialPrompt: initialPrompt }) {
        const aiExperienceCommonData = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, modalRef: modalRef } = aiExperienceCommonData;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { configItem: startingConfig, baseGenerate: baseGenerate, userInput: startingUserInput, userADFInput: startingUserADFInput, parentPresetPromptLabel: parentPresetPromptLabel, editCount: editCount, positions: positions, editorView: editorView, latestPromptResponse: latestPromptResponse, aiProvider: aiProvider } = experienceAppContext;
        const [initialPromptTriggered, setInitialPromptTriggered] = (0, ($parcel$interopDefault($5uXOq))).useState(false);
        const { context: commandPaletteContext, send: sendToCommandPalette } = (0, (0, parcelRequire("fp323")).useCommandPaletteStateMachine)({
            baseGenerate: baseGenerate,
            startingConfig: startingConfig,
            startingPresetPromptLabel: parentPresetPromptLabel || (0, (0, parcelRequire("PwAM5")).getTranslatedPromptLabel)(startingConfig, formatMessage),
            startingUserInput: startingUserInput,
            startingUserADFInput: startingUserADFInput
        });
        const { textInput: textInput, adfInput: adfInput, configItem: configItem, presetPromptLabel: presetPromptLabel } = commandPaletteContext;
        const isParentWithNestedSubmenusSelected = Boolean(presetPromptLabel && configItem.nestingConfig);
        const rovoAgentsPluginState = (0, (0, parcelRequire("dZvxR")).useAgents)({
            editorState: editorView.state
        });
        const { isBrowseModalOpen: isBrowseModalOpen = false } = rovoAgentsPluginState ?? {};
        (0, (0, parcelRequire("iozk0")).useOutsideClickHandler)({
            disabled: isBrowseModalOpen,
            modalRef: modalRef,
            onCancel: ()=>aiExperienceCommonData.endExperience(),
            onDiscard: ()=>{
                sendToAIExperienceMachine({
                    type: 'update context',
                    context: {
                        configItem: configItem,
                        userInput: textInput || '',
                        userADFInput: adfInput
                    }
                });
                sendToAIExperienceMachine({
                    type: 'enable discard'
                });
            }
        });
        const focusInputRef = (0, ($parcel$interopDefault($5uXOq))).useRef(undefined);
        const replaceInputRef = (0, ($parcel$interopDefault($5uXOq))).useRef(undefined);
        const handleCancel = ()=>{
            endExperience();
        };
        const kickoffAiExperience = (0, $5uXOq.useCallback)(({ configItem: configItem, userInput: userInput, userADFInput: userADFInput })=>{
            const parentPresetPromptLabel = isParentWithNestedSubmenusSelected ? presetPromptLabel : '';
            sendToAIExperienceMachine({
                type: 'kickoff with command palette input',
                context: {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    configItem: configItem,
                    userInput: userInput,
                    userADFInput: userADFInput
                }
            });
        }, [
            sendToAIExperienceMachine,
            isParentWithNestedSubmenusSelected,
            presetPromptLabel
        ]);
        const onPartialPresetSelected = (0, $5uXOq.useCallback)((configItem, { presetPromptLabel: presetPromptLabel } = {})=>{
            sendToCommandPalette({
                type: 'onPartialPresetSelected',
                configItem: configItem,
                presetPromptLabel: presetPromptLabel ?? (0, (0, parcelRequire("PwAM5")).getTranslatedPromptLabel)(configItem, formatMessage)
            });
            focusInputRef.current?.();
        }, [
            sendToCommandPalette,
            formatMessage
        ]);
        const getPromptTitle = (0, $5uXOq.useCallback)((configItem)=>{
            if (configItem.agent?.creatorType === 'CUSTOMER') return undefined;
            if (configItem.agent?.creatorType === 'SYSTEM') return configItem.agent?.name;
            return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
        }, [
            formatMessage
        ]);
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlowEventsQueue)({
            stepName: 'prompt',
            attributes: {
                experienceName: configItem.key,
                promptTitle: getPromptTitle(configItem),
                promptType: 'generate',
                usingCommandPalette: true,
                retryPromptCount: experienceAppContext.retryPromptCount,
                editCount: editCount
            }
        });
        const updateAnalytics = (0, $5uXOq.useCallback)((configItem)=>{
            analyticsFlow.updateCommonAttributes({
                backendModel: configItem?.getBackendModel?.(!!latestPromptResponse),
                ...analyticsFlow.getUserFlowCommonAttributes(configItem)
            });
            const attributes = {
                experienceName: configItem.key,
                promptTitle: getPromptTitle(configItem)
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_prompt_input_statistics')) {
                let inputNodeCount = {};
                let characterCount = 0;
                if (adfInput) {
                    inputNodeCount = (0, (0, parcelRequire("3Y1bF")).reduce)(adfInput, (accum, node)=>{
                        if (node.type === 'text') characterCount = characterCount + (node.text ?? '').length;
                        accum[node.type] = (accum[node.type] ?? 0) + 1;
                        node?.marks?.forEach((mark)=>{
                            accum[mark.type] = (accum[mark.type] ?? 0) + 1;
                        });
                        return accum;
                    }, {});
                    attributes.inputNodeCount = inputNodeCount;
                    attributes.characterCount = characterCount;
                }
            }
            analyticsFlow.addAttributes(attributes);
        }, [
            analyticsFlow,
            latestPromptResponse,
            getPromptTitle,
            adfInput
        ]);
        const updateTextInput = (0, $5uXOq.useCallback)((textInputValue)=>{
            sendToCommandPalette({
                type: 'onTextEntered',
                input: textInputValue
            });
        }, [
            sendToCommandPalette
        ]);
        const updateADFInput = (0, ($parcel$interopDefault($5uXOq))).useCallback((text)=>{
            sendToCommandPalette({
                type: 'onADFEntered',
                adf: text
            });
        }, [
            sendToCommandPalette
        ]);
        const onSubmit = (0, $5uXOq.useCallback)(({ configItem: _configItem } = {})=>{
            if (isParentWithNestedSubmenusSelected) return;
            kickoffAiExperience({
                configItem: _configItem || commandPaletteContext.configItem,
                userInput: commandPaletteContext.textInput || '',
                userADFInput: commandPaletteContext.adfInput
            });
        }, [
            isParentWithNestedSubmenusSelected,
            kickoffAiExperience,
            commandPaletteContext.configItem,
            commandPaletteContext.textInput,
            commandPaletteContext.adfInput
        ]);
        const __getSuggestions = (0, $5uXOq.useMemo)(()=>{
            return configItem.selectionType === 'range' ? editorPluginAIProvider.rangeConfig.getSuggestions : editorPluginAIProvider.emptyConfig.getSuggestions;
        }, [
            configItem.selectionType,
            editorPluginAIProvider.emptyConfig.getSuggestions,
            editorPluginAIProvider.rangeConfig.getSuggestions
        ]);
        const handleHighlight = (0, $5uXOq.useCallback)(({ configItem: configItem, promptLabel: promptLabel })=>{
            if (configItem.promptLabel !== undefined && !configItem.agent || promptLabel === 'tell-ai' || promptLabel === (0, $75149f8e1380831a$export$e9b50d8f92ed61d4) || promptLabel === (0, $75149f8e1380831a$export$f94ca114676d6a3f) || promptLabel === (0, $75149f8e1380831a$export$3cb19042951e1104)) {
                const removeTransaction = editorView.state.tr;
                removeTransaction.setMeta('hideSelectionPreview', true);
                editorView.dispatch(removeTransaction);
                return;
            }
            const setTransaction = editorView.state.tr;
            setTransaction.setMeta('showSelectionPreview', true);
            editorView.dispatch(setTransaction);
        }, [
            editorView
        ]);
        const onConversationStarterSelected = (0, $5uXOq.useCallback)((conversationStarter)=>{
            const userADFInput = (0, (0, parcelRequire("bPWvi")).doc)((0, (0, parcelRequire("50sdg")).paragraph)(conversationStarter));
            handleHighlight({
                configItem: configItem
            });
            updateAnalytics(configItem);
            onPartialPresetSelected(configItem, {
                presetPromptLabel: `@${configItem.agent.name}`
            });
            kickoffAiExperience({
                userInput: conversationStarter,
                configItem: configItem,
                userADFInput: userADFInput
            });
        }, [
            handleHighlight,
            updateAnalytics,
            onPartialPresetSelected,
            kickoffAiExperience,
            configItem
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (initialPrompt && !initialPromptTriggered) {
                if (configItem.agent) onConversationStarterSelected(initialPrompt);
                else if (!experienceAppContext.latestPrompt) {
                    const userADFInput = (0, (0, parcelRequire("bPWvi")).doc)((0, (0, parcelRequire("50sdg")).paragraph)(initialPrompt));
                    updateADFInput(userADFInput);
                    updateTextInput(initialPrompt);
                    setInitialPromptTriggered(true);
                    kickoffAiExperience({
                        userInput: initialPrompt,
                        configItem: configItem,
                        userADFInput: userADFInput
                    });
                }
                setInitialPromptTriggered(true);
            }
        }, [
            initialPrompt,
            onConversationStarterSelected,
            initialPromptTriggered,
            configItem,
            experienceAppContext.latestPrompt,
            updateADFInput,
            updateTextInput,
            kickoffAiExperience
        ]);
        const { starters: agentConversationStarters } = (0, (0, parcelRequire("9vp0r")).useAgentStarters)({
            handleHighlight: handleHighlight,
            configItem: configItem,
            onConversationStarterSelected: onConversationStarterSelected,
            product: editorPluginAIProvider.product
        });
        const handleSelectPrefill = (0, $5uXOq.useCallback)((item)=>{
            const localisedInput = formatMessage(item.title);
            const localisedADFInput = (0, (0, parcelRequire("bPWvi")).doc)((0, (0, parcelRequire("50sdg")).paragraph)(localisedInput));
            sendToCommandPalette({
                type: 'onTextEntered',
                input: localisedInput
            });
            sendToCommandPalette({
                type: 'onADFEntered',
                adf: localisedADFInput
            });
            replaceInputRef.current?.(localisedADFInput);
            focusInputRef.current?.();
            analyticsFlow.addAttributes({
                prefilledWith: item.key
            });
        }, [
            analyticsFlow,
            formatMessage,
            sendToCommandPalette
        ]);
        const getSuggestions = (0, $5uXOq.useCallback)((inputValue, agent)=>{
            if (presetPromptLabel && !configItem.nestingConfig && !agent) return [];
            function makeUseRovoOrganisationKnowledgeSuggestion(defaultAgent) {
                const agentConfigItem = (0, (0, parcelRequire("iZGo0")).createAgentConfigItem)(startingConfig.selectionType, defaultAgent, editorPluginAIProvider);
                return {
                    testId: (0, $75149f8e1380831a$export$f94ca114676d6a3f),
                    value: (0, $75149f8e1380831a$export$f94ca114676d6a3f),
                    label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).useRovoOrganisationKnowledgeLabel),
                    groupHeading: formatMessage((0, (0, parcelRequire("6KJH7")).messages).knowledgeSourceGroupHeading),
                    rightText: formatMessage((0, (0, parcelRequire("6KJH7")).messages).useRovoOrganisationKnowledgeRightText),
                    hideIcon: true,
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: agentConfigItem
                        });
                        updateAnalytics(agentConfigItem);
                        onSubmit({
                            configItem: agentConfigItem
                        });
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: agentConfigItem,
                            promptLabel: (0, $75149f8e1380831a$export$f94ca114676d6a3f)
                        });
                    }
                };
            }
            const isRovoAgentsSuggestionsShouldRunFreePrompt = inputValue.trim().split(' ').length > 3;
            function getRovoAgentsGroupHeading() {
                const matchedAgentCount = getSuggestions(textInput || '').filter((suggestion)=>suggestion.isAgent).length;
                if (matchedAgentCount === 0) return formatMessage((0, (0, parcelRequire("6KJH7")).messages).rovoAgentsSuggestionGroupHeading);
                else if (isRovoAgentsSuggestionsShouldRunFreePrompt) return formatMessage((0, (0, parcelRequire("6KJH7")).messages).useRovoAgentsCountSuggestionGroupHeading, {
                    numberOfAgents: matchedAgentCount.toString()
                });
                else return formatMessage((0, (0, parcelRequire("6KJH7")).messages).rovoAgentsCountSuggestionGroupHeading, {
                    numberOfAgents: matchedAgentCount.toString()
                });
            }
            function makeKnowledgeSourceSuggestions() {
                const useRovoOrganisationKnowledgeSuggestions = !rovoAgentsPluginState?.enabled || !rovoAgentsPluginState?.defaultAgent || !aiProvider.getChannelVariables || agent ? [] : [
                    makeUseRovoOrganisationKnowledgeSuggestion(rovoAgentsPluginState.defaultAgent)
                ];
                const knowledgeSourceSuggestions = [
                    {
                        testId: (0, $75149f8e1380831a$export$e9b50d8f92ed61d4),
                        value: (0, $75149f8e1380831a$export$e9b50d8f92ed61d4),
                        label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).useGeneralAiKnowledgeLabel),
                        groupHeading: formatMessage((0, (0, parcelRequire("6KJH7")).messages).knowledgeSourceGroupHeading),
                        rightText: formatMessage((0, (0, parcelRequire("6KJH7")).messages).useGeneralAiKnowledgeRightText),
                        hideIcon: true,
                        onSelect: ()=>{
                            handleHighlight({
                                configItem: configItem
                            });
                            updateAnalytics(configItem);
                            onSubmit();
                        },
                        onSuggestionFocused: ()=>{
                            handleHighlight({
                                configItem: configItem,
                                promptLabel: (0, $75149f8e1380831a$export$e9b50d8f92ed61d4)
                            });
                        }
                    },
                    ...useRovoOrganisationKnowledgeSuggestions
                ];
                return knowledgeSourceSuggestions;
            }
            const showKnowledgeSourceSuggestionsInsteadOfTellAI = rovoAgentsPluginState?.enabled && rovoAgentsPluginState?.defaultAgent && aiProvider.getChannelVariables && !agent && !presetPromptLabel;
            const tellAiSuggestion = !inputValue || isParentWithNestedSubmenusSelected ? [] : showKnowledgeSourceSuggestionsInsteadOfTellAI ? makeKnowledgeSourceSuggestions() : [
                {
                    value: agent ? 'tell-agent' : 'tell-ai',
                    label: inputValue,
                    hideIcon: true,
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                        onSubmit();
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem,
                            promptLabel: agent ? 'tell-agent' : 'tell-ai'
                        });
                    }
                }
            ];
            const showMoreText = formatMessage((0, (0, parcelRequire("6KJH7")).messages).showMoreButton);
            const showMoreSuggestion = [
                {
                    value: 'show-more',
                    label: showMoreText,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: showMoreText,
                        primaryColor: "var(--ds-icon, #44546F)"
                    }),
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem,
                            promptLabel: showMoreText
                        });
                    }
                }
            ];
            const browseAgentsSuggestion = !rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : {
                value: (0, $75149f8e1380831a$export$3cb19042951e1104),
                label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).agentsBrowseMore),
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4V6HW"))))), {
                    label: "browse-more-agents",
                    color: "var(--ds-icon, #44546F)"
                }),
                groupHeading: getRovoAgentsGroupHeading,
                onSelect: ()=>{
                    (0, (0, parcelRequire("4xwSH")).openBrowseAgentsModal)(true, positions)(editorView.state, editorView.dispatch);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem,
                        promptLabel: (0, $75149f8e1380831a$export$3cb19042951e1104)
                    });
                }
            };
            if (agent) {
                if (agentConversationStarters.filter((configItem)=>typeof configItem.label !== 'string').length) return agentConversationStarters;
                const filteredAgentSuggestions = agentConversationStarters.filter((configItem)=>configItem.label.toLowerCase().includes((inputValue || '').toLowerCase()));
                return filteredAgentSuggestions;
            }
            const output = __getSuggestions({
                inputValue: inputValue
            }).filter((configItem)=>{
                return (configItem.isPrefill && inputValue !== formatMessage(configItem.title) && (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true) || !configItem.isPrefill) && configItem.isVisible({
                    editorView: editorView,
                    positions: positions
                });
            }).map((configItem)=>{
                let icon = configItem.icon?.({
                    formatMessage: formatMessage,
                    shownAt: 'suggestions'
                });
                if (configItem.nestingConfig && configItem.nestingConfig.icon && !presetPromptLabel && !inputValue) icon = configItem.nestingConfig.icon?.({
                    formatMessage: formatMessage,
                    shownAt: 'suggestions'
                });
                return {
                    icon: icon,
                    label: configItem.nestingConfig && presetPromptLabel ? formatMessage(configItem.nestingConfig.shortTitle) : (0, (0, parcelRequire("PwAM5")).getTranslatedItemTitle)(configItem, formatMessage),
                    statusLozengeType: configItem.statusLozengeType,
                    value: configItem.key,
                    nestingConfig: configItem.nestingConfig ? {
                        parentTestId: configItem.nestingConfig.parentTestId,
                        parentTitle: formatMessage(configItem.nestingConfig.parentTitle)
                    } : undefined,
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                    },
                    onSelect: ()=>{
                        if (configItem.isPrefill && (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true)) handleSelectPrefill(configItem);
                        else if (configItem.nestingConfig && !presetPromptLabel && !inputValue) onPartialPresetSelected(configItem, {
                            presetPromptLabel: formatMessage(configItem.nestingConfig.parentTitle)
                        });
                        else {
                            handleHighlight({
                                configItem: configItem
                            });
                            updateAnalytics(configItem);
                            if (!configItem.promptLabel) kickoffAiExperience({
                                userInput: '',
                                userADFInput: undefined,
                                configItem: configItem
                            });
                            else onPartialPresetSelected(configItem);
                        }
                    }
                };
            }).concat(showMoreSuggestion).concat(!agent ? tellAiSuggestion : []).concat(!rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : rovoAgentsPluginState.agents.map((agent)=>{
                const agentConfigItem = (0, (0, parcelRequire("iZGo0")).createAgentConfigItem)(startingConfig.selectionType, agent, editorPluginAIProvider);
                return {
                    value: `agent:${agent.id}`,
                    label: agent.name,
                    description: agent.description ?? '',
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, editorPluginAIProvider.isRovoEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bJfF5")).PreloadModalComponent), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
                        agentId: agent.id,
                        agentNamedId: agent.externalConfigReference ?? agent.namedId,
                        agentIdentityAccountId: agent.identityAccountId,
                        isForgeAgent: agent.creatorType === 'FORGE',
                        forgeAgentIconUrl: agent.icon
                    })),
                    groupHeading: getRovoAgentsGroupHeading,
                    isAgent: true,
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: agentConfigItem
                        });
                        updateAnalytics(agentConfigItem);
                        onPartialPresetSelected(agentConfigItem, {
                            presetPromptLabel: `@${agentConfigItem.agent.name}`
                        });
                        if (isRovoAgentsSuggestionsShouldRunFreePrompt) kickoffAiExperience({
                            userInput: inputValue,
                            userADFInput: undefined,
                            configItem: agentConfigItem
                        });
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: agentConfigItem
                        });
                    }
                };
            })).concat(agent ? tellAiSuggestion : []).filter((suggestion)=>{
                if (!suggestion) return false;
                if (typeof suggestion.label !== 'string') return false;
                if (suggestion.value === (0, $75149f8e1380831a$export$e9b50d8f92ed61d4) || suggestion.value === (0, $75149f8e1380831a$export$f94ca114676d6a3f)) return true;
                if (isParentWithNestedSubmenusSelected && suggestion.nestingConfig?.parentTitle !== presetPromptLabel) return false;
                if (suggestion?.isAgent && isRovoAgentsSuggestionsShouldRunFreePrompt) return true;
                const searchValues = [
                    suggestion.label.toLowerCase()
                ];
                searchValues.push((suggestion.description ?? '').toLowerCase());
                if (suggestion?.isAgent) searchValues.push('rovo', 'agent');
                return searchValues.join(' ').includes((inputValue || '').toLowerCase());
            }).concat(!isParentWithNestedSubmenusSelected ? browseAgentsSuggestion : []).map((suggestion)=>{
                if ((0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', false) && !suggestion.groupHeading || (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true) && !suggestion.groupHeading && suggestion.value !== 'show-more') suggestion.groupHeading = isParentWithNestedSubmenusSelected && configItem?.nestingConfig?.parentTitle ? formatMessage(configItem.nestingConfig.parentTitle) : formatMessage((0, (0, parcelRequire("6KJH7")).messages).atlassianIntelligenceGroupHeading);
                const isPrefill = suggestion.value.startsWith('Prefill with ');
                if (isPrefill && (0, $gmhCD.editorExperiment)('platform_editor_ai_draft_with_ai', true)) {
                    suggestion.groupHeading = formatMessage((0, (0, parcelRequire("6KJH7")).messages).prefillPromptsGroupHeading);
                    suggestion.label += formatMessage((0, (0, parcelRequire("6KJH7")).messages).prefillPromptsTrailingIndication);
                }
                return suggestion;
            });
            if (output.length) return output;
            return isParentWithNestedSubmenusSelected ? [
                {
                    value: 'no-suggestions',
                    label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).noResultsSuggestion),
                    hideIcon: true,
                    icon: undefined,
                    onSelect: ()=>{},
                    onSuggestionFocused: ()=>{}
                }
            ] : [];
        }, [
            presetPromptLabel,
            configItem,
            rovoAgentsPluginState?.enabled,
            rovoAgentsPluginState?.defaultAgent,
            rovoAgentsPluginState?.agents,
            aiProvider.getChannelVariables,
            isParentWithNestedSubmenusSelected,
            formatMessage,
            __getSuggestions,
            startingConfig.selectionType,
            editorPluginAIProvider,
            handleHighlight,
            updateAnalytics,
            onSubmit,
            textInput,
            positions,
            editorView,
            agentConversationStarters,
            onPartialPresetSelected,
            kickoffAiExperience,
            handleSelectPrefill
        ]);
        const aiToolbarButtonPulseAnnouncement = (0, (0, parcelRequire("2Jlja")).useEngagementPlatformAnnouncementBanner)('cc-editor-ai_ai-toolbar-button-pulse', formatMessage((0, (0, parcelRequire("6KJH7")).messages).engagementBannerLinksText));
        (0, $5uXOq.useEffect)(()=>{
            if (aiProvider.onAIProviderChanged && (0, $gmhCD.editorExperiment)('platform_editor_ai_facepile', true)) aiProvider.onAIProviderChanged('command-palette', configItem.agent ? {
                type: 'rovo',
                agent: configItem.agent
            } : undefined);
        }, [
            configItem.agent,
            aiProvider
        ]);
        const removeRefinementTag = (0, $5uXOq.useCallback)(()=>{
            analyticsFlow.addAttributes({
                experienceName: baseGenerate?.key,
                promptTitle: baseGenerate ? (0, (0, parcelRequire("PwAM5")).getTranslatedPromptLabel)(baseGenerate, formatMessage) : ''
            });
            analyticsFlow.updateCommonAttributes({
                backendModel: baseGenerate?.getBackendModel?.(!!latestPromptResponse)
            });
            sendToCommandPalette({
                type: 'onPartialPresetRemoved'
            });
            focusInputRef.current?.();
        }, [
            analyticsFlow,
            baseGenerate,
            formatMessage,
            latestPromptResponse,
            sendToCommandPalette
        ]);
        const onBack = (0, $5uXOq.useCallback)(()=>{
            removeRefinementTag();
            updateTextInput('');
            updateADFInput();
        }, [
            removeRefinementTag,
            updateTextInput,
            updateADFInput
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Y1I5")).UserInputCommandPalette), {
            appearance: appearance,
            presetPromptLabel: presetPromptLabel,
            inputValue: textInput || '',
            inputADFValue: adfInput,
            onInputUpdate: updateTextInput,
            onADFUpdate: updateADFInput,
            onCancel: handleCancel,
            onEscapeKeyPressed: handleCancel,
            onSubmit: onSubmit,
            onRefinementTagRemove: removeRefinementTag,
            onBack: onBack,
            placeholder: configItem.promptHint ? formatMessage(configItem.promptHint) : '',
            getSuggestions: getSuggestions,
            focusInputRef: focusInputRef,
            replaceInputRef: replaceInputRef,
            PromptEditor: editorPluginAIProvider.PromptEditor,
            agent: configItem.agent,
            hideLegacySubmitCancelButtons: isParentWithNestedSubmenusSelected,
            announcementBanners: aiToolbarButtonPulseAnnouncement ? [
                aiToolbarButtonPulseAnnouncement
            ] : undefined
        }));
    }
});
parcelRegister("4V6HW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3951b0552a35072b$var$_react = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $3951b0552a35072b$var$_UNSAFE_baseNew = $3951b0552a35072b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $3951b0552a35072b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3951b0552a35072b$var$AiAgentIcon = (props)=>$3951b0552a35072b$var$_react.default.createElement($3951b0552a35072b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m13.643 4.136-5-3a1.25 1.25 0 0 0-1.286 0l-5 3a1.25 1.25 0 0 0-.607 1.072v5.584c0 .44.23.846.607 1.072l5 3c.396.238.89.238 1.286 0l5-3a1.25 1.25 0 0 0 .607-1.072V5.208c0-.44-.23-.846-.607-1.072Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M11.5 11a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"/>`
        }, props));
    $3951b0552a35072b$var$AiAgentIcon.displayName = 'AiAgentIcon';
    var $3951b0552a35072b$var$_default = module.exports.default = $3951b0552a35072b$var$AiAgentIcon;
});
parcelRegister("3Y1I5", function(module, exports) {
    $parcel$export(module.exports, "UserInputCommandPalette", ()=>$ed43058fe0c7f222$export$9491b5d7f967f421);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $lFKmC = parcelRequire("lFKmC");
    var $koVbs;
    var $kgoHi;
    var $8CUq3;
    var $gmhCD = parcelRequire("gmhCD");
    var $jldZL;
    var $1uyji;
    var $jl6s6;
    var $g0RiJ;
    var $59RNb;
    var $4fUWX;
    var $58BjU;
    var $idlL6;
    var $9GTAp;
    var $3VZDq;
    var $92hhP;
    var $awo0y;
    var $GysLh;
    var $ktTR0;
    function $ed43058fe0c7f222$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $ed43058fe0c7f222$var$floatingContainerHeightStyles = {
        name: "m4bh15",
        styles: "max-height:500px"
    };
    const $ed43058fe0c7f222$var$PromptHeaderWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.150',
        minHeight: '0',
        maxHeight: '200px',
        flexShrink: 0
    });
    const $ed43058fe0c7f222$export$9491b5d7f967f421 = ({ appearance: appearance, inputValue: inputValue, inputADFValue: inputADFValue, onInputUpdate: onInputUpdate, onADFUpdate: onADFUpdate, presetPromptLabel: presetPromptLabel, onSubmit: onSubmit, onCancel: onCancel, onEscapeKeyPressed: onEscapeKeyPressed, onRefinementTagRemove: onRefinementTagRemove, onBack: onBack, placeholder: placeholder, getSuggestions: getSuggestions, suggestionsHeading: suggestionsHeading, focusInputRef: focusInputRef, replaceInputRef: replaceInputRef, PromptEditor: PromptEditor, agent: agent, hideLegacySubmitCancelButtons: hideLegacySubmitCancelButtons, announcementBanners: announcementBanners })=>{
        const promptWithSuggestionsRef = (0, $5uXOq.useRef)(null);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isCaretHidden, setIsCaretHidden] = (0, $5uXOq.useState)(false);
        const [isShowingMoreSuggestions, setIsShowingMoreSuggestions] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const { current: element } = promptWithSuggestionsRef;
            if (!element) return;
            element.scrollIntoView({
                block: 'nearest',
                behavior: 'auto'
            });
            const handleEscapeKeyDown = (event)=>{
                if (event.key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                    onEscapeKeyPressed();
                }
            };
            const handleEscapeKeyUp = (event)=>{
                if (event.key !== 'Escape') return;
                event.preventDefault();
                event.stopPropagation();
            };
            return (0, (0, parcelRequire("cBeZP")).bindAll)(element, [
                {
                    type: 'keydown',
                    listener: handleEscapeKeyDown
                },
                {
                    type: 'keyup',
                    listener: handleEscapeKeyUp
                }
            ]);
        }, [
            promptWithSuggestionsRef,
            onEscapeKeyPressed
        ]);
        let suggestions = (0, $5uXOq.useMemo)(()=>{
            if (agent) return getSuggestions(inputValue, agent);
            let nestedSuggestions = getSuggestions(inputValue) ?? [];
            if (!inputValue.length) {
                nestedSuggestions = nestedSuggestions.reduce((0, (0, parcelRequire("awo0y")).reduceSuggestionsIntoNestedSuggestions), []);
                if (presetPromptLabel) nestedSuggestions = nestedSuggestions.find((s)=>s.nestingConfig?.parentTitle === presetPromptLabel)?.childSuggestions ?? [];
            }
            const showMoreSuggestionIndex = nestedSuggestions.findIndex((suggestion)=>suggestion.value === 'show-more');
            if (showMoreSuggestionIndex !== -1) {
                const originalOnSelect = nestedSuggestions[showMoreSuggestionIndex].onSelect;
                nestedSuggestions[showMoreSuggestionIndex].onSelect = ()=>{
                    originalOnSelect();
                    setIsShowingMoreSuggestions(true);
                };
            }
            return nestedSuggestions;
        }, [
            presetPromptLabel,
            getSuggestions,
            inputValue,
            agent
        ]);
        const hideNestedTag = (0, $5uXOq.useMemo)(()=>{
            return presetPromptLabel && !!suggestions.length;
        }, [
            suggestions,
            presetPromptLabel
        ]);
        const agentRefinementTagProps = (0, (0, parcelRequire("idlL6")).useAgentRefinementTagProps)(agent);
        const refinementTagRef = (0, $5uXOq.useRef)(null);
        const tag = (0, $5uXOq.useMemo)(()=>{
            return presetPromptLabel === undefined ? undefined : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("4fUWX")).RefinementTag), {
                ...agentRefinementTagProps,
                label: presetPromptLabel,
                ref: refinementTagRef,
                onClick: onRefinementTagRemove
            });
        }, [
            agentRefinementTagProps,
            presetPromptLabel,
            onRefinementTagRemove,
            refinementTagRef
        ]);
        const suggestionValues = (0, $5uXOq.useMemo)(()=>{
            return (suggestions || []).map((suggestion)=>suggestion.value);
        }, [
            suggestions
        ]);
        const [currentSuggestion, _setCurrentSuggestion] = (0, $5uXOq.useState)(suggestionValues.length > 0 ? suggestionValues[0] : '');
        const handleSuggestionChanged = (0, $5uXOq.useCallback)((suggestion)=>{
            const suggestionObject = suggestions.find((s)=>s.value === suggestion);
            suggestionObject?.onSuggestionFocused();
        }, [
            suggestions
        ]);
        const setCurrentSuggestion = (0, $5uXOq.useCallback)((newValue)=>{
            handleSuggestionChanged(newValue);
            _setCurrentSuggestion(newValue);
        }, [
            _setCurrentSuggestion,
            handleSuggestionChanged
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (suggestionValues.includes(currentSuggestion) || suggestionValues.length === 0) return;
            setCurrentSuggestion(suggestionValues[0]);
        }, [
            currentSuggestion,
            suggestionValues,
            setCurrentSuggestion
        ]);
        const visibleSuggestionValues = (0, $5uXOq.useMemo)(()=>{
            const allSuggestions = suggestionValues.filter((suggestion)=>suggestion !== 'show-more');
            if (isShowingMoreSuggestions || inputValue.length > 0) return allSuggestions;
            const agentSuggestions = suggestionValues.filter((suggestion)=>suggestion.startsWith('agent:'));
            const minNumOfGeneralSuggestions = 4;
            const maximumResultCount = 9;
            if (agentSuggestions.length === 0 || allSuggestions.length <= maximumResultCount || allSuggestions.length - agentSuggestions.length <= minNumOfGeneralSuggestions) return allSuggestions;
            let remainingSuggestions = maximumResultCount - agentSuggestions.length - 1;
            if (remainingSuggestions < minNumOfGeneralSuggestions) remainingSuggestions = minNumOfGeneralSuggestions;
            return [
                ...suggestionValues.slice(0, remainingSuggestions),
                'show-more',
                ...agentSuggestions
            ];
        }, [
            inputValue.length,
            isShowingMoreSuggestions,
            suggestionValues
        ]);
        const visibleSuggestions = (0, $5uXOq.useMemo)(()=>{
            const output = suggestions.filter((suggestion)=>visibleSuggestionValues.includes(suggestion.value));
            return output;
        }, [
            suggestions,
            visibleSuggestionValues
        ]);
        const onArrowKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
            if (visibleSuggestionValues.length <= 1) return;
            switch(event.key){
                case 'ArrowUp':
                case 'ArrowDown':
                    {
                        setIsCaretHidden(true);
                        const nextSuggestion = (0, (0, parcelRequire("3VZDq")).getNextSuggestion)(visibleSuggestionValues, currentSuggestion, event.key);
                        setCurrentSuggestion(nextSuggestion);
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    }
                default:
                    return;
            }
        }, [
            currentSuggestion,
            setCurrentSuggestion,
            visibleSuggestionValues
        ]);
        const debouncedSetIsCaretHidden = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))(()=>{
                setIsCaretHidden(false);
            }, 300), []);
        const onArrowKeyUp = (0, $5uXOq.useCallback)(()=>{
            debouncedSetIsCaretHidden();
        }, [
            debouncedSetIsCaretHidden
        ]);
        const setSuggestion = (0, $5uXOq.useCallback)((suggestion)=>{
            setCurrentSuggestion(suggestion.value);
        }, [
            setCurrentSuggestion
        ]);
        const suggestionDiv = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("58BjU")).Suggestions), {
            appearance: appearance,
            suggestions: visibleSuggestions,
            suggestionsHeading: suggestionsHeading,
            value: currentSuggestion,
            setSuggestion: setSuggestion,
            hideGroupHeading: !!agent
        });
        const onFormSubmit = (0, $5uXOq.useCallback)(()=>{
            if (currentSuggestion === '' || suggestions?.length === 0) {
                onSubmit();
                return;
            }
            const suggestion = (suggestions || []).find((suggestion)=>suggestion.value === currentSuggestion);
            if (suggestion) suggestion.onSelect();
            setCurrentSuggestion('');
        }, [
            currentSuggestion,
            suggestions,
            setCurrentSuggestion,
            onSubmit
        ]);
        const showLegacySubmitCancelButtons = !hideLegacySubmitCancelButtons && Boolean(presetPromptLabel && !agent);
        const enableLinksInPromptEditor = (0, (0, parcelRequire("1uyji")).checkAssistanceServiceFreeGenerateFg)();
        const promptPlaceholder = (0, $5uXOq.useMemo)(()=>{
            const defaultPlaceholder = placeholder;
            if (agent) return formatMessage((0, (0, parcelRequire("92hhP")).default).rovoAgentsPalettePlaceholder);
            if (tag) return defaultPlaceholder;
            if ((0, $gmhCD.editorExperiment)('platform_editor_ai_1p_placeholder_hints', 'tip-placeholders', {
                exposure: true
            })) return formatMessage((0, (0, parcelRequire("ktTR0")).getPromptPlaceholder)({
                type: 'quick tip'
            }));
            else if ((0, $gmhCD.editorExperiment)('platform_editor_ai_1p_placeholder_hints', 'example-placeholders', {
                exposure: true
            })) return formatMessage((0, (0, parcelRequire("ktTR0")).getPromptPlaceholder)({
                type: 'prompt example'
            }));
            return defaultPlaceholder;
        }, [
            agent,
            formatMessage,
            placeholder,
            tag
        ]);
        const promptForm = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("59RNb")).PromptForm), {
            showButtons: showLegacySubmitCancelButtons,
            placeholder: promptPlaceholder,
            value: inputValue,
            adfValue: inputADFValue,
            onFormSubmit: onFormSubmit,
            onCancel: onCancel,
            onInputChange: onInputUpdate,
            onADFChange: onADFUpdate,
            tag: hideNestedTag ? undefined : tag,
            focusInputRef: focusInputRef,
            replaceInputRef: replaceInputRef,
            showLogo: false,
            onInputKeyDown: onArrowKeyDown,
            onInputKeyUp: onArrowKeyUp,
            PromptEditor: PromptEditor,
            enableLinks: enableLinksInPromptEditor,
            showBack: !!presetPromptLabel,
            onBack: onBack,
            refinementTagRef: refinementTagRef
        });
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: promptWithSuggestionsRef,
            "data-testid": "user-input-command-palette-screen",
            className: `user-input-command-palette-screen ${(0, $4b849073bf4278d5$export$9df59400d72ad68f)}`,
            css: [
                (0, (0, parcelRequire("GysLh")).columnLayout),
                (0, (0, parcelRequire("g0RiJ")).scrollMarginStyles),
                isCaretHidden && {
                    caretColor: 'transparent'
                }
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jldZL")).default), null, formatMessage((0, (0, parcelRequire("92hhP")).default).commandPaletteAriaName)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jl6s6")).FloatingContainer), {
            css: [
                (0, (0, parcelRequire("GysLh")).floatingContainerStyles),
                $ed43058fe0c7f222$var$floatingContainerHeightStyles
            ],
            "data-testid": "prompt-form-screen",
            rainbowBorder: false
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            testId: "prompt-header-wrapper",
            xcss: $ed43058fe0c7f222$var$PromptHeaderWrapperStyles
        }, promptForm), announcementBanners && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("9GTAp")).AnnouncementBanners), {
            banners: announcementBanners
        }), suggestions || inputValue ? suggestionDiv : null)));
    };
});
parcelRegister("1uyji", function(module, exports) {
    $parcel$export(module.exports, "checkAssistanceServiceFreeGenerateFg", ()=>$c17c4d81be2be799$export$8eb46457ce8f0f94);
    var $VSDnB;
    const $c17c4d81be2be799$export$8eb46457ce8f0f94 = ()=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service') || (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assist_srv_jira_fr_gen')) return true;
        return false;
    };
});
parcelRegister("58BjU", function(module, exports) {
    $parcel$export(module.exports, "Suggestions", ()=>$5f82ccea3c4b33ea$export$7463f42be087e7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lFKmC = parcelRequire("lFKmC");
    var $3T6Xo = parcelRequire("3T6Xo");
    var $koVbs;
    var $dC5iT;
    var $8CUq3;
    var $hlpJ9;
    var $5zB6M;
    var $jrCxV;
    var $7deIG;
    function $5f82ccea3c4b33ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5f82ccea3c4b33ea$var$suggestionsGroupWrapStyles = {
        name: "ti75j2",
        styles: "margin:0"
    };
    const $5f82ccea3c4b33ea$var$suggestionsScrollerPostGAStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflowY: 'auto',
        flex: '0 1 auto',
        borderTop: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
    });
    function $5f82ccea3c4b33ea$export$5b54ed2fa23d62e9(output, suggestion) {
        let suggestionGroup;
        if (typeof suggestion.groupHeading === 'function') suggestionGroup = suggestion.groupHeading();
        else suggestionGroup = suggestion.groupHeading || '';
        let existingRecordIndex = output.findIndex((s)=>s.groupHeading === suggestionGroup);
        if (existingRecordIndex === -1) {
            const suggestionsLength = output.push({
                groupHeading: suggestionGroup,
                suggestions: []
            });
            existingRecordIndex = suggestionsLength - 1;
        }
        output[existingRecordIndex].suggestions.push(suggestion);
        return output;
    }
    const $5f82ccea3c4b33ea$export$7463f42be087e7d6 = ({ suggestionsHeading: suggestionsHeading, suggestions: suggestions, value: value, setSuggestion: setSuggestion, hideGroupHeading: hideGroupHeading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const ignoreMouseMoveRef = (0, ($parcel$interopDefault($5uXOq))).useRef(false);
        const scrollerRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const smoothSetSuggestion = (0, ($parcel$interopDefault($5uXOq))).useCallback((suggestion, eventName)=>{
            if (!setSuggestion) return;
            if (eventName === 'mousemove' && ignoreMouseMoveRef.current) return;
            setSuggestion(suggestion);
        }, [
            setSuggestion
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!scrollerRef.current) return;
            const allowMouseTracking = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                ignoreMouseMoveRef.current = false;
            }, 75);
            const onScrollEvent = ()=>{
                ignoreMouseMoveRef.current = true;
                allowMouseTracking();
            };
            const scroller = scrollerRef.current;
            scroller.addEventListener('scroll', onScrollEvent);
            scroller.addEventListener('scrollend', onScrollEvent);
            return ()=>{
                scroller.removeEventListener('scroll', onScrollEvent);
                scroller.removeEventListener('scrollend', onScrollEvent);
            };
        }, [
            scrollerRef
        ]);
        const renderedGroupSuggestions = (0, $5uXOq.useMemo)(()=>{
            const customLabelMap = {
                'tell-ai': formatMessage((0, (0, parcelRequire("jrCxV")).messages).tellAILabel),
                'tell-agent': formatMessage((0, (0, parcelRequire("jrCxV")).messages).tellAgentLabel)
            };
            const mapSuggestionsCallback = (suggestionGroup)=>{
                return (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
                    "data-testid": `suggestion-group-${(0, ($parcel$interopDefault($3T6Xo)))(suggestionGroup.groupHeading || 'Atlassian intelligence')}`,
                    key: `group_${suggestionGroup.groupHeading}`,
                    css: $5f82ccea3c4b33ea$var$suggestionsGroupWrapStyles
                }, (0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
                    css: (0, (0, parcelRequire("7deIG")).suggestionsGroupStyles)
                }, suggestionGroup.groupHeading && !hideGroupHeading && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("hlpJ9")).ListHeading), {
                    heading: suggestionGroup.groupHeading
                }), suggestionGroup.suggestions.map((suggestion)=>{
                    return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5zB6M")).ListItem), {
                        key: suggestion.value,
                        suggestion: suggestion,
                        customLabel: customLabelMap[suggestion.value] || undefined,
                        highlighted: suggestion.value === value,
                        setSuggestion: smoothSetSuggestion,
                        hasGroupHeading: !!suggestionGroup.groupHeading && !hideGroupHeading
                    });
                })));
            };
            return (suggestions || []).reduce($5f82ccea3c4b33ea$export$5b54ed2fa23d62e9, []).map(mapSuggestionsCallback);
        }, [
            formatMessage,
            smoothSetSuggestion,
            suggestions,
            value,
            hideGroupHeading
        ]);
        if (!renderedGroupSuggestions.length) return null;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
            testId: "suggestions-container",
            xcss: [
                $5f82ccea3c4b33ea$var$suggestionsScrollerPostGAStyles
            ],
            ref: scrollerRef
        }, suggestionsHeading && (0, (0, parcelRequire("f8Sb3")).jsx)("h2", {
            css: (0, (0, parcelRequire("7deIG")).suggestionsHeadingStyles)
        }, suggestionsHeading), (0, (0, parcelRequire("f8Sb3")).jsx)("ul", {
            "data-testid": "editor-plugin-ai-suggestion-list",
            id: "suggestion-list",
            css: (0, (0, parcelRequire("7deIG")).suggestionsContainerStyles)
        }, renderedGroupSuggestions)));
    };
});
parcelRegister("hlpJ9", function(module, exports) {
    $parcel$export(module.exports, "ListHeading", ()=>$018ad84a95baa8a8$export$b7bc1538a6ef0630);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3T6Xo = parcelRequire("3T6Xo");
    var $7deIG;
    const $018ad84a95baa8a8$export$b7bc1538a6ef0630 = ({ heading: heading })=>{
        const listHeadingRef = (0, $5uXOq.useRef)(null);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: [
                (0, (0, parcelRequire("7deIG")).suggestionsGroupHeadingStyles),
                (0, (0, parcelRequire("7deIG")).stickySuggestionsGroupHeadingStyles)
            ],
            ref: listHeadingRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("h3", {
            className: "list-heading-text",
            "data-testid": `list-heading-${(0, ($parcel$interopDefault($3T6Xo)))(heading)}`
        }, heading)));
    };
});
parcelRegister("7deIG", function(module, exports) {
    $parcel$export(module.exports, "suggestionsContainerStyles", ()=>$49bd7636f765b14f$export$bee0538348139ee);
    $parcel$export(module.exports, "suggestionButtonStyles", ()=>$49bd7636f765b14f$export$3566db75f01c8086);
    $parcel$export(module.exports, "rovoSuggestionButtonStyles", ()=>$49bd7636f765b14f$export$dfdc93f984323e23);
    $parcel$export(module.exports, "suggestionListItemStyles", ()=>$49bd7636f765b14f$export$dcf23b903c1acc22);
    $parcel$export(module.exports, "tellAILabelStyles", ()=>$49bd7636f765b14f$export$605049c8e4c230cb);
    $parcel$export(module.exports, "suggestionsHeadingStyles", ()=>$49bd7636f765b14f$export$6a54060c43fb4fb4);
    $parcel$export(module.exports, "suggestionsGroupHeadingStyles", ()=>$49bd7636f765b14f$export$29a039cec2e00523);
    $parcel$export(module.exports, "stickySuggestionsGroupHeadingStyles", ()=>$49bd7636f765b14f$export$68116fffd45f4caf);
    $parcel$export(module.exports, "suggestionIconStyles", ()=>$49bd7636f765b14f$export$59c65dafb28fb2f5);
    $parcel$export(module.exports, "rovoSuggestionIconStyles", ()=>$49bd7636f765b14f$export$df64bf03af1fa4b4);
    $parcel$export(module.exports, "suggestionsGroupStyles", ()=>$49bd7636f765b14f$export$b930884ad9ff9017);
    $parcel$export(module.exports, "chevronIconStyles", ()=>$49bd7636f765b14f$export$a74e833974ff14c1);
    var $f8Sb3;
    function $49bd7636f765b14f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $49bd7636f765b14f$export$bee0538348139ee = {
        name: "rm49lg",
        styles: "width:100%;height:100%;margin:0px;padding:0px;list-style:none;display:inline-block;position:relative;li:first-of-type{border-top-left-radius:inherit;border-top-right-radius:inherit;}li:last-of-type{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;}"
    };
    const $49bd7636f765b14f$export$3566db75f01c8086 = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        minHeight: '40px',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        marginTop: '0px',
        border: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        alignItems: 'center',
        gap: '13px',
        textAlign: 'left',
        fontWeight: 400,
        lineHeight: '18px',
        color: "var(--ds-text, #172b4d)",
        fontFamily: 'inherit',
        fontSize: 'inherit',
        background: 'none',
        '&:not([disabled])': {
            cursor: 'pointer',
            '&:active': {
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
            },
            "&[data-highlighted='true']": {
                '&:not(:active)': {
                    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                }
            },
            '&:focus': {
                outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
                outlineOffset: "var(--ds-space-negative-025, -2px)"
            }
        },
        '&[disabled]': {
            background: "var(--ds-background-disabled, #091e420a)",
            color: "var(--ds-text-disabled, #A5ADBA)",
            cursor: 'not-allowed'
        }
    });
    const $49bd7636f765b14f$export$dfdc93f984323e23 = (0, (0, parcelRequire("f8Sb3")).css)($49bd7636f765b14f$export$3566db75f01c8086, "min-height:46px;");
    const $49bd7636f765b14f$export$6ba7aecaee480acc = {
        name: "7h0ssf",
        styles: "button[data-highlighted='true'] &{display:inline;}display:none;padding:5px 5px 3px 5px;border-radius:3px;color:var(--ds-text-subtle, #44546F);background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
    };
    const $49bd7636f765b14f$export$dcf23b903c1acc22 = {
        name: "ptzfcm",
        styles: "margin-top:0px;list-style:none"
    };
    const $49bd7636f765b14f$export$902aee21085730f4 = {
        name: "15999rm",
        styles: "hyphens:auto;word-wrap:break-word;flex:1;min-width:90px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap"
    };
    const $49bd7636f765b14f$export$1de09905263f25dd = {
        name: "1agbmza",
        styles: "hyphens:auto;word-wrap:break-word;flex:1;min-width:90px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);padding-top:var(--ds-space-050, 4px);display:inline-block"
    };
    const $49bd7636f765b14f$export$605049c8e4c230cb = {
        name: "fewfy4",
        styles: "font-weight:500;margin-right:var(--ds-space-050, 4px)"
    };
    const $49bd7636f765b14f$export$6a54060c43fb4fb4 = (0, (0, parcelRequire("f8Sb3")).css)({
        '&&': {
            margin: '0px',
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            fontweight: "var(--ds-font-weight-bold, 700)",
            textTransform: 'uppercase',
            color: "var(--ds-text-subtle, #42526E)"
        }
    });
    const $49bd7636f765b14f$export$29a039cec2e00523 = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0px',
        padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
        '& .list-heading-text': {
            margin: 0,
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            fontweight: "var(--ds-font-weight-bold, 700)",
            textTransform: 'uppercase',
            color: "var(--ds-text-subtle, #42526E)"
        }
    });
    const $49bd7636f765b14f$export$68116fffd45f4caf = {
        name: "i0rs4e",
        styles: "position:sticky;width:inherit;top:0;background:var(--ds-surface, #FFFFFF);z-index:1"
    };
    const $49bd7636f765b14f$export$59c65dafb28fb2f5 = {
        name: "6zivhs",
        styles: "display:inline-flex;align-items:center;justify-content:center;height:24px;width:24px;& > .default-icon{height:24px;width:20px;}"
    };
    const $49bd7636f765b14f$export$df64bf03af1fa4b4 = (0, (0, parcelRequire("f8Sb3")).css)($49bd7636f765b14f$export$59c65dafb28fb2f5, "height:32px;width:32px;");
    const $49bd7636f765b14f$export$b930884ad9ff9017 = {
        name: "1xclg2i",
        styles: "margin:0;padding:0"
    };
    const $49bd7636f765b14f$export$a74e833974ff14c1 = {
        name: "dzd8y1",
        styles: "padding:0 4px"
    };
});
parcelRegister("5zB6M", function(module, exports) {
    $parcel$export(module.exports, "ListItem", ()=>$3531cb13c2fbf79d$export$a7b06bfba60a8a78);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $3dGN0;
    var $lj8SI;
    var $kgoHi;
    var $cgL5K;
    var $8CUq3;
    var $6M49g;
    var $i0hyP;
    var $jrCxV;
    var $7deIG;
    function $3531cb13c2fbf79d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $3531cb13c2fbf79d$var$contentStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        hyphens: 'auto',
        wordWrap: 'break-word',
        flex: 1,
        minWidth: '90px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    });
    const $3531cb13c2fbf79d$var$descriptionStyles = {
        name: "69xffo",
        styles: "hyphens:auto;word-wrap:break-word;flex:1;min-width:90px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);color:var(--ds-text-subtlest, #626F86);display:inline-block;line-height:14px"
    };
    const $3531cb13c2fbf79d$var$statusStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingLeft: 'space.050'
    });
    const $3531cb13c2fbf79d$var$enterStyles = {
        name: "1053epg",
        styles: "button[data-highlighted='true'] &{display:inline-flex;align-items:center;justify-content:center;}display:none;height:20px;width:20px;border-radius:3px;color:var(--ds-text-subtle, #44546F);background-color:var(--ds-background-neutral-subtle-hovered, #091E420F)"
    };
    const $3531cb13c2fbf79d$var$STICKY_GROUP_HEADER_HEIGHT = 32;
    const $3531cb13c2fbf79d$var$ensureElementIsVisibleInScrollContainer = (listItem, stickyHeaderHeight)=>{
        const scrollContainer = listItem.offsetParent?.parentElement;
        if (!scrollContainer || scrollContainer.tagName !== 'DIV') return;
        const scrollContainerRect = scrollContainer.getBoundingClientRect();
        const itemRect = listItem.getBoundingClientRect();
        const itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
        if (itemNotVisible) scrollContainer.scrollTo({
            top: listItem.offsetTop - stickyHeaderHeight,
            behavior: 'smooth'
        });
    };
    const $3531cb13c2fbf79d$var$statusLozengeMessages = {
        beta: (0, (0, parcelRequire("jrCxV")).messages).suggestionStatusBeta,
        new: (0, (0, parcelRequire("jrCxV")).messages).suggestionStatusNew
    };
    const $3531cb13c2fbf79d$export$a7b06bfba60a8a78 = ({ suggestion: suggestion, customLabel: customLabel, highlighted: highlighted, setSuggestion: setSuggestion, hasGroupHeading: hasGroupHeading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const listItemRef = (0, $5uXOq.useRef)(null);
        const hasChildren = (0, $5uXOq.useMemo)(()=>{
            return suggestion.childSuggestions && suggestion.childSuggestions.length;
        }, [
            suggestion.childSuggestions
        ]);
        const updateSuggestion = (0, ($parcel$interopDefault($5uXOq))).useCallback((eventName)=>{
            if (setSuggestion) setSuggestion(suggestion, eventName);
        }, [
            setSuggestion,
            suggestion
        ]);
        const onFocus = (0, ($parcel$interopDefault($5uXOq))).useCallback(()=>{
            updateSuggestion('focus');
            suggestion.onSuggestionFocused();
        }, [
            updateSuggestion,
            suggestion
        ]);
        const onMouseMove = (0, ($parcel$interopDefault($5uXOq))).useCallback(()=>{
            updateSuggestion('mousemove');
        }, [
            updateSuggestion
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) $3531cb13c2fbf79d$var$ensureElementIsVisibleInScrollContainer(listItemRef.current, hasGroupHeading ? $3531cb13c2fbf79d$var$STICKY_GROUP_HEADER_HEIGHT : 0);
        }, [
            listItemRef,
            highlighted,
            hasGroupHeading
        ]);
        const chevronRight = (0, $5uXOq.useMemo)(()=>{
            if (hasChildren && !highlighted) return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
                css: (0, (0, parcelRequire("7deIG")).chevronIconStyles)
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("3dGN0"))))), {
                label: "",
                color: "var(--ds-icon-subtle, #626F86)"
            })));
            return null;
        }, [
            hasChildren,
            highlighted
        ]);
        const rightText = (0, $5uXOq.useMemo)(()=>{
            if (suggestion.rightText) return suggestion.rightText;
            return null;
        }, [
            suggestion
        ]);
        const getSuggestionButtonStyles = (0, $5uXOq.useMemo)(()=>{
            if (suggestion.value.includes('agent:')) return 0, (0, parcelRequire("7deIG")).rovoSuggestionButtonStyles;
            return 0, (0, parcelRequire("7deIG")).suggestionButtonStyles;
        }, [
            suggestion.value
        ]);
        const getRovoSuggestionIconStyles = (0, $5uXOq.useMemo)(()=>{
            if (suggestion.value.includes('agent:')) return 0, (0, parcelRequire("7deIG")).rovoSuggestionIconStyles;
            return 0, (0, parcelRequire("7deIG")).suggestionIconStyles;
        }, [
            suggestion.value
        ]);
        let statusLozengeText = suggestion.statusLozengeType && ($3531cb13c2fbf79d$var$statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage($3531cb13c2fbf79d$var$statusLozengeMessages[suggestion.statusLozengeType]) : null);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: (0, (0, parcelRequire("7deIG")).suggestionListItemStyles),
            ref: listItemRef
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            css: getSuggestionButtonStyles,
            type: "button",
            onClick: suggestion.onSelect,
            onMouseMove: onMouseMove,
            "data-testid": suggestion.testId || (customLabel ? `tell-ai` : suggestion.label),
            "data-highlighted": highlighted,
            onFocus: onFocus
        }, !suggestion.hideIcon && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: getRovoSuggestionIconStyles
        }, suggestion.icon || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i0hyP")).LogoSvg), {
            className: "default-icon",
            alt: ''
        })), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            direction: "column",
            xcss: $3531cb13c2fbf79d$var$contentStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center"
        }, !customLabel ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), null, suggestion.label) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("7deIG")).tellAILabelStyles)
        }, customLabel), ' "', suggestion.label, '"'), statusLozengeText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            xcss: $3531cb13c2fbf79d$var$statusStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, statusLozengeText))), suggestion.description && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $3531cb13c2fbf79d$var$descriptionStyles
        }, suggestion.description)), rightText && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            color: "color.text.subtlest"
        }, rightText), suggestion.value !== 'no-suggestions' && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $3531cb13c2fbf79d$var$enterStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6M49g")).default), null)), chevronRight)));
    };
});
parcelRegister("jrCxV", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$d7fe68a8ba5405d0$export$defe85febe8b728c);
    var $7VHMR;
    const $d7fe68a8ba5405d0$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tellAILabel: {
            id: 'fabric.editor.ai.ui.components.suggestions.tellAILabel',
            defaultMessage: 'Tell AI',
            description: 'Label for default suggestion option'
        },
        tellAgentLabel: {
            id: 'fabric.editor.ai.ui.components.suggestions.tellAgentLabel',
            defaultMessage: 'Tell Agent',
            description: 'Label for agent suggestion option'
        },
        suggestionStatusBeta: {
            id: 'fabric.editor.ai.ui.components.suggestions.betaLozenge',
            defaultMessage: 'BETA',
            description: 'Lozenge text to indicate that the feature is in beta stage'
        },
        suggestionStatusNew: {
            id: 'fabric.editor.ai.ui.components.suggestions.newLozenge',
            defaultMessage: 'NEW',
            description: 'Lozenge text to indicate that the feature is in new'
        }
    });
});
parcelRegister("9GTAp", function(module, exports) {
    $parcel$export(module.exports, "AnnouncementBanners", ()=>$162d584523ca63c3$export$ea375d4903c4f3dc);
    var $f8Sb3;
    var $kgoHi;
    var $8CUq3;
    var $g3xY1;
    const $162d584523ca63c3$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.100',
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderTopColor: 'color.border'
    });
    function $162d584523ca63c3$export$ea375d4903c4f3dc({ banners: banners }) {
        if (banners.length === 0) return null;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $162d584523ca63c3$var$boxStyles,
            direction: "column",
            gap: "space.100"
        }, banners.map((banner)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("g3xY1")).AnnouncementBannerItem), {
                key: banner.id,
                text: banner.text,
                onClose: banner.onClose
            })));
    }
});
parcelRegister("g3xY1", function(module, exports) {
    $parcel$export(module.exports, "AnnouncementBannerItem", ()=>$d129545446e17baa$export$73d84e9e372a2734);
    var $f8Sb3;
    var $42CjB;
    var $2C7j9;
    var $kgoHi;
    var $8CUq3;
    const $d129545446e17baa$var$announcementStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.150',
        borderRadius: '3px',
        backgroundColor: 'color.background.discovery',
        color: 'color.text.discovery'
    });
    function $d129545446e17baa$export$73d84e9e372a2734({ text: text, onClose: onClose }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kgoHi")).default), {
            xcss: $d129545446e17baa$var$announcementStyles,
            alignItems: "center",
            justifyContent: "space-between",
            gap: "space.050"
        }, text, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("42CjB")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))),
            label: 'Close',
            spacing: "compact",
            appearance: "subtle",
            onClick: onClose
        }));
    }
});
parcelRegister("3VZDq", function(module, exports) {
    $parcel$export(module.exports, "getNextSuggestion", ()=>$dda3283784794de9$export$98f66d46dcfe73ca);
    const $dda3283784794de9$export$98f66d46dcfe73ca = (suggestions, current, direction)=>{
        const currentIndex = suggestions.indexOf(current);
        const { length: length } = suggestions;
        if (length === 0) return '';
        if (direction === 'ArrowUp') {
            if (currentIndex > length - 1) return suggestions[0];
            else if (currentIndex > 0) return suggestions[currentIndex - 1];
            else if (currentIndex === 0) return suggestions[length - 1];
            else return suggestions[0];
        } else if (direction === 'ArrowDown') {
            if (currentIndex >= length - 1) return suggestions[0];
            else if (currentIndex < 0) return suggestions[0];
            else if (currentIndex < length - 1) return suggestions[currentIndex + 1];
        } else throw new Error('Unknown direction');
        return '';
    };
});
parcelRegister("92hhP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6cb54a92cd49aed5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6cb54a92cd49aed5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        footerText: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.footerText',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Atlassian Intelligence footer text for user input command palette screen'
        },
        rovoProductLabel: {
            id: 'fabric.editor.ai.experience.rovoAgents.productLabel',
            defaultMessage: 'Rovo',
            description: 'Name of the Atlassian service and product that provides AI agents'
        },
        rovoProductLogoAltText: {
            id: 'fabric.editor.ai.experience.rovoAgents.productLogoAltText',
            defaultMessage: 'Rovo Logo',
            description: 'Rovo logo alt text'
        },
        rovoAgentsPalettePlaceholder: {
            id: 'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder',
            defaultMessage: 'Tell Agent to write anything or choose from the below',
            description: 'Placeholder text visible when input field in the Agent command palette is empty'
        },
        commandPaletteAriaName: {
            id: 'fabric.editor.ai.experience.commandPaletteAriaName',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Accessible label for the user input dialog'
        }
    });
});
parcelRegister("awo0y", function(module, exports) {
    $parcel$export(module.exports, "reduceSuggestionsIntoNestedSuggestions", ()=>$675e4092e9fd592b$export$e68d35e32242c79b);
    function $675e4092e9fd592b$export$e68d35e32242c79b(output, suggestion) {
        const { nestingConfig: nestingConfig } = suggestion;
        if (nestingConfig) {
            const existingIndex = output.findIndex((s)=>s.nestingConfig?.parentTitle === nestingConfig.parentTitle);
            if (existingIndex === -1) {
                const parentNestingConfig = {
                    ...nestingConfig
                };
                delete parentNestingConfig.shortTitle;
                output.push({
                    ...suggestion,
                    testId: nestingConfig.parentTestId,
                    label: nestingConfig.parentTitle || '',
                    nestingConfig: parentNestingConfig,
                    childSuggestions: [
                        suggestion
                    ],
                    value: suggestion.nestingConfig?.parentTitle || ''
                });
            } else output[existingIndex].childSuggestions?.push(suggestion);
        } else output.push(suggestion);
        return output;
    }
});
parcelRegister("GysLh", function(module, exports) {
    $parcel$export(module.exports, "floatingContainerStyles", ()=>$a045d0e1b5a23a36$export$8833ec6a339f43a0);
    $parcel$export(module.exports, "columnLayout", ()=>$a045d0e1b5a23a36$export$f8ce731bdfd45dc7);
    var $f8Sb3;
    var $jmZkC;
    function $a045d0e1b5a23a36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a045d0e1b5a23a36$export$8833ec6a339f43a0 = {
        name: "1gs0yzy",
        styles: "display:flex;flex-direction:column;padding:0"
    };
    const $a045d0e1b5a23a36$export$9510bf5ed6b29ec2 = (0, (0, parcelRequire("f8Sb3")).css)({
        '> :not(:last-child)': {
            borderBottom: `1px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$export$46987b49aab6d1a8)})`}`
        }
    });
    const $a045d0e1b5a23a36$export$f8ce731bdfd45dc7 = {
        name: "1xjlk2n",
        styles: "display:flex;flex-direction:column;align-items:flex-start;gap:var(--ds-space-050, 4px)"
    };
    const $a045d0e1b5a23a36$export$35b4a37ddeeb439f = (breakpoint)=>(0, (0, parcelRequire("f8Sb3")).css)({
            color: "var(--ds-text-subtlest, #626F86)",
            display: breakpoint <= (0, (0, parcelRequire("jmZkC")).Breakpoint).Small ? 'none' : undefined
        });
    const $a045d0e1b5a23a36$export$f0855824549edef5 = {
        name: "16dzfip",
        styles: "display:flex;flex-direction:row;align-items:center;padding:var(--ds-space-150, 12px);gap:var(--ds-space-150, 12px)"
    };
    const $a045d0e1b5a23a36$export$5baeafd9a1b3f7d6 = {
        name: "1ff36h2",
        styles: "flex-grow:1"
    };
});
parcelRegister("ktTR0", function(module, exports) {
    $parcel$export(module.exports, "getPromptPlaceholder", ()=>$36fa5985f73edd1a$export$cf36e6a8a745056d);
    var $lgequ;
    var $60wGZ;
    const $36fa5985f73edd1a$var$promptExamples = Object.values((0, (0, parcelRequire("lgequ")).default));
    const $36fa5985f73edd1a$var$quickTips = Object.values((0, (0, parcelRequire("60wGZ")).default));
    const $36fa5985f73edd1a$var$selectRandom = (arr)=>{
        const idx = Math.floor(Math.random() * arr.length);
        return arr[idx];
    };
    let $36fa5985f73edd1a$var$lastSelectedItem = null;
    const $36fa5985f73edd1a$export$cf36e6a8a745056d = ({ type: type })=>{
        let options = [];
        if (type === 'prompt example') options = $36fa5985f73edd1a$var$promptExamples.slice();
        else if (type === 'quick tip') options = $36fa5985f73edd1a$var$quickTips.slice();
        if ($36fa5985f73edd1a$var$lastSelectedItem) options = options.filter((item)=>item !== $36fa5985f73edd1a$var$lastSelectedItem);
        const selectedItem = $36fa5985f73edd1a$var$selectRandom(options);
        $36fa5985f73edd1a$var$lastSelectedItem = selectedItem;
        return selectedItem;
    };
});
parcelRegister("lgequ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c607d81857dcdd63$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c607d81857dcdd63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        bulletListSummarize: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.bulletListSummarize',
            defaultMessage: 'Try "Summarize the selected text into bullet points"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        translateSpanish: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.translateSpanish',
            defaultMessage: 'Try "Translate to Spanish"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        improveClarity: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.improveClarity',
            defaultMessage: 'Try "Improve the clarity of this section"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        formattedTable: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.formattedTable',
            defaultMessage: 'Try "Turn this list into a formatted table"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        simplifyJargon: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.simplifyJargon',
            defaultMessage: 'Try "Simplify this technical jargon for a general audience"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        actionPlan: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.actionPlan',
            defaultMessage: 'Try "Create an action plan based on these notes"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        dynamicEngaging: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.dynamicEngaging',
            defaultMessage: 'Try "Make this content more engaging and dynamic"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        highlightRisks: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.highlightRisks',
            defaultMessage: 'Try "Highlight the key risks in this plan"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        generateFaqs: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.generateFaqs',
            defaultMessage: 'Try "Generate FAQs from the above information"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        actionCheckboxes: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.actionCheckboxes',
            defaultMessage: 'Try "Extract the key actionables as action checkboxes"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        keyPointsTodo: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.keyPointsTodo',
            defaultMessage: 'Try "Summarize the key points and create a to-do list"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        decisionLog: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.decisionLog',
            defaultMessage: 'Try "Convert this discussion into a decision log"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        termsGlossary: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.promptExamples.termsGlossary',
            defaultMessage: 'Try "Create a glossary of terms from this document"',
            description: 'An example of a quality prompt in Editor AI modal'
        },
        timeline: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.timeline',
            defaultMessage: 'Try "Convert this information into a timeline with dates"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        beginnerAudience: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.beginnerAudience',
            defaultMessage: 'Try "Make this content suitable for a beginner audience"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        openQuestions: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.openQuestions',
            defaultMessage: 'Try "Identify and list any open questions"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        missingInformation: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.missingInformation',
            defaultMessage: 'Try "Identify and list any missing information needed"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        readerQuestions: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.readerQuestions',
            defaultMessage: 'Try "Create a list of questions a reader might have about this content"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        stepsWorkflow: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.stepsWorkflow',
            defaultMessage: 'Try "Convert this into a step-by-step workflow"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        actionableFeedback: {
            id: 'fabric.editor.ai.screens.UserInputCommamdPalette.promptPlaceholder.promptExamples.actionableFeedback',
            defaultMessage: 'Try "Provide concise, specific and actionable feedback on this draft from an editor\'s perspective"',
            description: 'A tip for writing prompts in Editor AI modal'
        }
    });
});
parcelRegister("60wGZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d31b7cb5829de351$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d31b7cb5829de351$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        pasteSmartLinks: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.pasteSmartLinks',
            defaultMessage: 'Tip: You can paste Jira and Confluence links here',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        smartLinksAsk: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.smartLinksAsk',
            defaultMessage: 'Tip: Ask AI about any Jira or Confluence link you paste here',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        focusText: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.focusText',
            defaultMessage: 'Tip: Select the text you want AI to focus on',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        specificAreaChanges: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.specificAreaChanges',
            defaultMessage: 'Tip: Need changes in a specific area? Highlight it before prompting',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        detailedPrompts: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.detailedPrompts',
            defaultMessage: 'Tip: The more detailed your prompt, the better the answer',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        changeToneProfessional: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.changeToneProfessional',
            defaultMessage: 'Tip: Need a formal writing style? Use "Change tone to professional"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        translateLanguage: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.translateLanguage',
            defaultMessage: 'Tip: Need a translation? Try "Translate to Australian English"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        formattingRequests: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.formattingRequests',
            defaultMessage: 'Tip: You can request formatted outputs like tables or lists',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        confluenceUrls: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.confluenceUrls',
            defaultMessage: 'Tip: Want to use info from Confluence? Paste a URL here so AI can reference it',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        improveWriting: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.improveWriting',
            defaultMessage: 'Tip: Use "Improve writing" to enhance clarity and flow',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        codeSnippets: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.codeSnippets',
            defaultMessage: 'Tip: You can ask AI to optimize or comment on code snippets',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        summarize: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.summarize',
            defaultMessage: 'Tip: Ask AI to "Summarize" to make content more succinct',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        generateOutline: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.generateOutline',
            defaultMessage: 'Tip: Try "Generate an outline" for a step by step summary of content',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        makeShorter: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.makeShorter',
            defaultMessage: 'Tip: Want a concise summary? Try "Make shorter"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        keyThemes: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.keyThemes',
            defaultMessage: 'Tip: Ask AI to "Identify key themes" in your text',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        todoList: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.todoList',
            defaultMessage: 'Tip: Generate a to-do list from notes using "Create action checkboxes"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        findActionItems: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.findActionItems',
            defaultMessage: 'Tip: Use "Find Action Items" to let AI find tasks and create checkboxes next to them',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        questionAnswerFormat: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.questionAnswerFormat',
            defaultMessage: 'Tip: Generate an FAQ section by using "Convert to Q&A format"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        adoptRole: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.adoptRole',
            defaultMessage: 'Tip: Ask AI to adopt a role, e.g. "Act as a reviewer and critique this content"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        mentionAudience: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.mentionAudience',
            defaultMessage: 'Mention your audience so AI can adjust the writing level, e.g. "Explain to investors"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        combineCommands: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.combineCommands',
            defaultMessage: 'Tip: To get more done, combine commands: "Summarize and translate into French"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        styleGuidelines: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.styleGuidelines',
            defaultMessage: 'Tip: Set clear style guidelines, e.g. "Use a formal tone"',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        metaphorsAnalogies: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.metaphorsAnalogies',
            defaultMessage: 'Tip: Try "Generate metaphors or analogies" to make complex ideas more relatable',
            description: 'A tip for writing prompts in Editor AI modal'
        },
        detectInconsistencies: {
            id: 'fabric.editor.ai.screens.UserInputCommandPalette.promptPlaceholder.quickTips.detectInconsistencies',
            defaultMessage: 'Tip: Try "Detect inconsistencies" to ensure your content is consistent and error-free',
            description: 'A tip for writing prompts in Editor AI modal'
        }
    });
});
parcelRegister("4xwSH", function(module, exports) {
    $parcel$export(module.exports, "updateAgents", ()=>$2d1699ee6ae52416$export$457e869d5657c541);
    $parcel$export(module.exports, "openBrowseAgentsModal", ()=>$2d1699ee6ae52416$export$fdede0d4e32ae86b);
    $parcel$export(module.exports, "updatePublish", ()=>$2d1699ee6ae52416$export$1fed3848898af3ea);
    $parcel$export(module.exports, "updateEnabled", ()=>$2d1699ee6ae52416$export$5947fe5279aaebd6);
    var $eMywv;
    var $dUN9K;
    const $2d1699ee6ae52416$export$457e869d5657c541 = ({ agents: agents, defaultAgent: defaultAgent })=>(0, (0, parcelRequire("eMywv")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("dUN9K")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    agents: agents.filter((agent)=>agent.namedId !== 'ai_mate_agent'),
                    defaultAgent: defaultAgent
                }
            };
        });
    const $2d1699ee6ae52416$export$fdede0d4e32ae86b = (open, rawPositions)=>{
        const positions = rawPositions && {
            startPos: rawPositions[0],
            endPos: rawPositions[1]
        };
        return (0, (0, parcelRequire("eMywv")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("dUN9K")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    isBrowseModalOpen: open,
                    positions: positions
                }
            };
        });
    };
    const $2d1699ee6ae52416$export$1fed3848898af3ea = (publish)=>{
        return (0, (0, parcelRequire("eMywv")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("dUN9K")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    publish: publish
                }
            };
        });
    };
    const $2d1699ee6ae52416$export$5947fe5279aaebd6 = (enabled)=>{
        return (0, (0, parcelRequire("eMywv")).createCommand)(()=>{
            return {
                type: (0, (0, parcelRequire("dUN9K")).ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    enabled: enabled
                }
            };
        });
    };
});
parcelRegister("eMywv", function(module, exports) {
    $parcel$export(module.exports, "createPluginState", ()=>$da6e6c0a44353a62$export$656c7661095efe2e);
    $parcel$export(module.exports, "createCommand", ()=>$da6e6c0a44353a62$export$8d4021544bdece00);
    $parcel$export(module.exports, "getRovoAgentsPluginState", ()=>$da6e6c0a44353a62$export$a5538d14da6605ff);
    var $aOimD;
    var $14ecj;
    var $brdFQ;
    const { createPluginState: $da6e6c0a44353a62$export$656c7661095efe2e, createCommand: $da6e6c0a44353a62$export$8d4021544bdece00 } = (0, (0, parcelRequire("aOimD")).pluginFactory)((0, (0, parcelRequire("14ecj")).rovoAgentsPluginKey), (0, (0, parcelRequire("brdFQ")).reducer));
    const $da6e6c0a44353a62$export$a5538d14da6605ff = (state)=>{
        const pluginState = (0, (0, parcelRequire("14ecj")).rovoAgentsPluginKey).getState(state);
        return pluginState;
    };
});
parcelRegister("14ecj", function(module, exports) {
    $parcel$export(module.exports, "rovoAgentsPluginKey", ()=>$bbbc9f26440ffdc7$export$90eb11e11e5cf6f9);
    var $gZGBX;
    const $bbbc9f26440ffdc7$export$90eb11e11e5cf6f9 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('rovoAgentsPlugin');
});
parcelRegister("brdFQ", function(module, exports) {
    $parcel$export(module.exports, "reducer", ()=>$40c54f2dcb501a5b$export$1650419e431d3ba3);
    var $dUN9K;
    const $40c54f2dcb501a5b$export$1650419e431d3ba3 = (pluginState, action)=>{
        switch(action.type){
            case (0, (0, parcelRequire("dUN9K")).ACTIONS).UPDATE_PLUGIN_STATE:
                return {
                    ...pluginState,
                    ...action.data
                };
            default:
                return pluginState;
        }
    };
});
parcelRegister("dUN9K", function(module, exports) {
    $parcel$export(module.exports, "ACTIONS", ()=>$6de06a671f58ed60$export$92a1a3b7554e9387);
    var $6de06a671f58ed60$export$92a1a3b7554e9387;
    (function(ACTIONS) {
        ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
    })($6de06a671f58ed60$export$92a1a3b7554e9387 || ($6de06a671f58ed60$export$92a1a3b7554e9387 = {}));
});
parcelRegister("dZvxR", function(module, exports) {
    $parcel$export(module.exports, "useAgents", ()=>$80b5a04c5ca5de0f$export$ce428e3c22a00062);
    var $5uXOq = parcelRequire("5uXOq");
    var $eMywv;
    function $80b5a04c5ca5de0f$export$ce428e3c22a00062({ editorState: editorState }) {
        const pluginState = (0, $5uXOq.useMemo)(()=>{
            const rovoAgentsPluginState = (0, (0, parcelRequire("eMywv")).getRovoAgentsPluginState)(editorState);
            return rovoAgentsPluginState;
        }, [
            editorState
        ]);
        return pluginState;
    }
});
parcelRegister("iZGo0", function(module, exports) {
    $parcel$export(module.exports, "createAgentConfigItem", ()=>$3fe7cb4db8430d63$export$23164faf8d4f39a5);
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $ewkQj;
    var $kADOW;
    var $8gLLR;
    var $bJvE0;
    const $3fe7cb4db8430d63$export$23164faf8d4f39a5 = (selectionType, agent, editorPluginAIProvider)=>{
        const continueInChat = (0, (0, parcelRequire("kADOW")).createContinueInChat)({
            appearance: 'secondary',
            agent: agent,
            product: editorPluginAIProvider.product,
            actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
            actionOverride: editorPluginAIProvider.actionOverrides?.['continueInChat']
        });
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ROVO_AGENT,
            title: (0, (0, parcelRequire("bJvE0")).messages).title,
            description: (0, (0, parcelRequire("bJvE0")).messages).description,
            selectionType: selectionType,
            agent: agent,
            getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    slice: editorView.state.doc.slice(positions[0], positions[1]),
                    editorView: editorView,
                    convertTo: 'markdown',
                    updateIdMap: updateIdMap,
                    selectionType: selectionType,
                    mentionMap: mentionMap
                });
                const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    node: editorView.state.doc,
                    editorView: editorView,
                    convertTo: 'markdown',
                    updateIdMap: updateIdMap,
                    selectionType: selectionType,
                    mentionMap: mentionMap
                });
                return {
                    selection: selection.markdown,
                    document: document.markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'DISABLED'
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, promptInput: promptInput, promptInputADF: promptInputADF }) {
                return (0, (0, parcelRequire("ewkQj")).rovoChatWithAgent)({
                    agent: agent,
                    customPrompt: promptInput || '',
                    customPromptADF: promptInputADF,
                    fullDocument: initialContext.document,
                    currentSelection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : ''
                });
            },
            promptLabel: {
                defaultMessage: agent?.name,
                id: `fabric.editor.ai.config.item.${selectionType}.agent.${agent?.name.toLocaleLowerCase().replace(/\s+/g, '.') || 'label'}`
            },
            promptHint: (0, (0, parcelRequire("bJvE0")).messages).promptHint,
            isVisible: ()=>true,
            getBackendModel: ()=>'assistance-service',
            statusLozengeType: 'beta',
            disableInterrogation: ()=>false,
            actions: selectionType === 'empty' ? [
                continueInChat,
                (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ] : [
                continueInChat,
                (0, (0, parcelRequire("8gLLR")).createReplace)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ],
            secondaryActions: []
        });
    };
});
parcelRegister("ewkQj", function(module, exports) {
    $parcel$export(module.exports, "rovoChatWithAgent", ()=>$2ab36c3c6fce3add$export$b37580d695bdbc25);
    var $e4Vft;
    var $gIHA4;
    var $3RkUa;
    const $2ab36c3c6fce3add$export$b37580d695bdbc25 = (input)=>{
        const { agent: agent } = input;
        return function promptRequest(requestOptions) {
            const promptADF = input.customPromptADF || {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: input.customPrompt
                            }
                        ]
                    }
                ]
            };
            const browserUrl = requestOptions.getChannelVariables?.('rovo-agent')?.contentURL ?? window.location.origin + window.location.pathname;
            const streamingResponseGenerator = (0, (0, parcelRequire("gIHA4")).startStreamingResponse)({
                endpoint: (0, (0, parcelRequire("e4Vft")).convoAIStatefulApiURL),
                experienceId: 'ai-mate',
                channelId: requestOptions.channelId,
                payload: JSON.stringify({
                    content: promptADF,
                    context: {
                        browser_url: browserUrl,
                        editor: {
                            document: {
                                type: 'text/markdown',
                                content: input.fullDocument
                            },
                            selection: {
                                type: 'text/markdown',
                                content: input.currentSelection
                            }
                        }
                    },
                    recipient_agent_named_id: agent.namedId,
                    mimeType: 'text/adf',
                    store_message: true
                }),
                ...requestOptions
            });
            return (0, (0, parcelRequire("3RkUa")).streamResponseParser)({
                streamingResponseGenerator: streamingResponseGenerator,
                isConvoAI: true
            });
        };
    };
});
parcelRegister("kADOW", function(module, exports) {
    $parcel$export(module.exports, "createContinueInChat", ()=>$71377c5df1bc4d1b$export$8979ff6e494800b3);
    var $e9qoo;
    var $l5HWy;
    var $dhbXh;
    const $71377c5df1bc4d1b$export$8979ff6e494800b3 = ({ appearance: appearance, agent: agent, product: product, actionSideEffect: actionSideEffect, actionOverride: actionOverride })=>({
            type: 'agent',
            title: (0, (0, parcelRequire("dhbXh")).messages).continueInChatLabel,
            shortcut: (0, (0, parcelRequire("e9qoo")).continueInRovoChat),
            appearance: appearance,
            run: ({ channelId: channelId, publish: publish })=>{
                if (!channelId || !publish) return;
                if (typeof actionOverride === 'function') {
                    actionOverride({
                        channelId: channelId
                    });
                    return;
                }
                publish({
                    type: 'chat-open',
                    product: product,
                    data: {
                        channelId: channelId,
                        agentId: agent.namedId
                    },
                    source: 'editor'
                });
                actionSideEffect?.();
            },
            preserveEditorSelectionOnComplete: true,
            icon: (0, (0, parcelRequire("l5HWy")).ChatIcon)
        });
});
parcelRegister("l5HWy", function(module, exports) {
    $parcel$export(module.exports, "ChatIcon", ()=>$212a111fa68e7f59$export$52cd484a7ef4f2b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $212a111fa68e7f59$var$CustomGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: 14,
            height: "100%",
            viewBox: "0 0 14 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.22854 10.7139C4.46164 10.5741 4.72837 10.5002 5.00021 10.5002L12.0003 10.5C12.2764 10.5 12.5002 10.2762 12.5002 10V2C12.5002 1.72386 12.2764 1.5 12.0002 1.5L2.00024 1.50014C1.7241 1.50014 1.50024 1.724 1.50024 2.00014V12.3508L4.22854 10.7139ZM0.75748 14.5457C0.424217 14.7456 0.000244141 14.5055 0.000244141 14.1169V2.00014C0.000244141 0.89558 0.895658 0.000154314 2.00022 0.000138964L12.0002 1.9736e-10C13.1048 -1.53495e-05 14.0002 0.895419 14.0002 2V10C14.0002 11.1046 13.1048 12 12.0003 12L5.00024 12.0002L0.75748 14.5457Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M3 6.00018C3 5.4479 3.44772 5.00018 4 5.00018C4.55228 5.00018 5 5.4479 5 6.00018C5 6.55247 4.55228 7.00018 4 7.00018C3.44772 7.00018 3 6.55247 3 6.00018Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6 6.00018C6 5.4479 6.44772 5.00018 7 5.00018C7.55228 5.00018 8 5.4479 8 6.00018C8 6.55247 7.55228 7.00018 7 7.00018C6.44772 7.00018 6 6.55247 6 6.00018Z",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9 6.00018C9 5.4479 9.44772 5.00018 10 5.00018C10.5523 5.00018 11 5.4479 11 6.00018C11 6.55247 10.5523 7.00018 10 7.00018C9.44772 7.00018 9 6.55247 9 6.00018Z",
            fill: "currentColor"
        }));
    const $212a111fa68e7f59$var$CustomIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $212a111fa68e7f59$var$CustomGlyph,
            ...props
        });
    const $212a111fa68e7f59$export$52cd484a7ef4f2b9 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($212a111fa68e7f59$var$CustomIcon, props);
    };
});
parcelRegister("bJvE0", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$9ec6b55dbb0a4b33$export$defe85febe8b728c);
    var $7VHMR;
    const $9ec6b55dbb0a4b33$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.agent.title',
            defaultMessage: 'Atlassian Intelligence Rovo Agent',
            description: 'Title for the menu item of the Atlassian Intelligence agent without a predefined name.'
        },
        description: {
            id: 'fabric.editor.ai.config.item.range.agent.description',
            defaultMessage: 'No description',
            description: 'Subtitle for the menu item of the Atlassian Intelligence agent without a predefined description.'
        },
        promptHint: {
            id: 'fabric.editor.ai.config.item.range.agent.prompt.hint',
            defaultMessage: 'Tell the Agent to write anything or choose from below',
            description: 'Hint text for the prompt input when interacting with the Atlassian Intelligence'
        }
    });
});
parcelRegister("bJfF5", function(module, exports) {
    $parcel$export(module.exports, "LoadableBrowseRovoAgentsModal", ()=>$8eefe3888fe4c3cd$export$62821c88a7188481);
    $parcel$export(module.exports, "PreloadModalComponent", ()=>$8eefe3888fe4c3cd$export$3b4439d273b7f3cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $4qBtX = parcelRequire("4qBtX");
    const $8eefe3888fe4c3cd$export$62821c88a7188481 = (0, ($parcel$interopDefault($4qBtX)))({
        loader: ()=>(parcelRequire("6XuEQ")).then((mod)=>mod.default),
        loading: ()=>null
    });
    const $8eefe3888fe4c3cd$export$3b4439d273b7f3cc = ()=>{
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            $8eefe3888fe4c3cd$export$62821c88a7188481.preload();
        }, []);
        return null;
    };
});
parcelRegister("6XuEQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4pAjB")
    ]).then(()=>parcelRequire('chZlz'));
});
const $75149f8e1380831a$export$e9b50d8f92ed61d4 = 'use-general-ai-knowledge';
const $75149f8e1380831a$export$f94ca114676d6a3f = 'use-rovo-organisation-knowledge';
const $75149f8e1380831a$export$3cb19042951e1104 = 'agent:browse-more-agents';
parcelRegister("fp323", function(module, exports) {
    $parcel$export(module.exports, "useCommandPaletteStateMachine", ()=>$07f10b5fc1d1e63a$export$6d6b44d5fef51d81);
    var $5uXOq = parcelRequire("5uXOq");
    var $gNFqi;
    var $aAR7m;
    function $07f10b5fc1d1e63a$export$6d6b44d5fef51d81({ startingConfig: startingConfig, startingPresetPromptLabel: startingPresetPromptLabel, baseGenerate: baseGenerate, startingUserInput: startingUserInput, startingUserADFInput: startingUserADFInput }) {
        const machineRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        if (machineRef.current === null) machineRef.current = (0, (0, parcelRequire("aAR7m")).commandPaletteStateMachine)({
            context: {
                textInput: startingUserInput,
                adfInput: startingUserADFInput,
                configItem: startingConfig,
                presetPromptLabel: startingPresetPromptLabel,
                baseGenerate: baseGenerate
            }
        });
        const [state, send] = (0, (0, parcelRequire("gNFqi")).useMachine)(machineRef.current);
        return {
            state: state.value,
            context: state.context,
            send: send
        };
    }
});
parcelRegister("gNFqi", function(module, exports) {
    $parcel$export(module.exports, "executeEffect", ()=>$c3b15ab32d0d6441$export$5b2b7e8fec35690c);
    $parcel$export(module.exports, "useMachine", ()=>$c3b15ab32d0d6441$export$e0338c4153421160);
    var $5uXOq = parcelRequire("5uXOq");
    var $krWBq;
    var $9bCqE;
    var $lcMl8;
    var $c3b15ab32d0d6441$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    var $c3b15ab32d0d6441$var$__spread = undefined && undefined.__spread || function() {
        for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c3b15ab32d0d6441$var$__read(arguments[i]));
        return ar;
    };
    function $c3b15ab32d0d6441$var$createReactActionFunction(exec, tag) {
        var effectExec = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return function() {
                return exec.apply(void 0, $c3b15ab32d0d6441$var$__spread(args));
            };
        };
        Object.defineProperties(effectExec, {
            name: {
                value: "effect:" + exec.name
            },
            __effect: {
                value: tag
            }
        });
        return effectExec;
    }
    function $c3b15ab32d0d6441$export$6338d86c17f4b021(exec) {
        return $c3b15ab32d0d6441$var$createReactActionFunction(exec, (0, (0, parcelRequire("9bCqE")).ReactEffectType).Effect);
    }
    function $c3b15ab32d0d6441$export$14bc29259b87b462(exec) {
        return $c3b15ab32d0d6441$var$createReactActionFunction(exec, (0, (0, parcelRequire("9bCqE")).ReactEffectType).LayoutEffect);
    }
    function $c3b15ab32d0d6441$export$5b2b7e8fec35690c(action, state) {
        var exec = action.exec;
        var originalExec = exec(state.context, state._event.data, {
            action: action,
            state: state,
            _event: state._event
        });
        originalExec();
    }
    function $c3b15ab32d0d6441$export$e0338c4153421160(getMachine, options) {
        if (options === void 0) options = {};
        var listener = (0, $5uXOq.useCallback)(function(nextState) {
            var initialStateChanged = nextState.changed === undefined && Object.keys(nextState.children).length;
            if (nextState.changed || initialStateChanged) setState(nextState);
        }, []);
        var service = (0, (0, parcelRequire("lcMl8")).useInterpret)(getMachine, options, listener);
        var _a = $c3b15ab32d0d6441$var$__read((0, $5uXOq.useState)(function() {
            var initialState = service.machine.initialState;
            return options.state ? (0, (0, parcelRequire("krWBq")).State).create(options.state) : initialState;
        }), 2), state = _a[0], setState = _a[1];
        return [
            state,
            service.send,
            service
        ];
    }
});
parcelRegister("9bCqE", function(module, exports) {
    $parcel$export(module.exports, "ReactEffectType", ()=>$6b02f34b0c253f28$export$ce678d4420306bda);
    var $6b02f34b0c253f28$export$ce678d4420306bda;
    (function(ReactEffectType) {
        ReactEffectType[ReactEffectType["Effect"] = 1] = "Effect";
        ReactEffectType[ReactEffectType["LayoutEffect"] = 2] = "LayoutEffect";
    })($6b02f34b0c253f28$export$ce678d4420306bda || ($6b02f34b0c253f28$export$ce678d4420306bda = {}));
});
parcelRegister("lcMl8", function(module, exports) {
    $parcel$export(module.exports, "useInterpret", ()=>$f7003744c26bcbd6$export$d9e9b060fbbae528);
    parcelRequire("5uXOq");
    var $hrqx3 = parcelRequire("hrqx3");
    var $iflnw;
    var $krWBq;
    var $fcQkf;
    var $klEg8;
    var $k5mvV;
    var $f7003744c26bcbd6$var$__assign = undefined && undefined.__assign || function() {
        $f7003744c26bcbd6$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $f7003744c26bcbd6$var$__assign.apply(this, arguments);
    };
    var $f7003744c26bcbd6$var$__rest = undefined && undefined.__rest || function(s, e) {
        var t = {};
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") {
            for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
        }
        return t;
    };
    var $f7003744c26bcbd6$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    function $f7003744c26bcbd6$export$d9e9b060fbbae528(getMachine, options, observerOrListener) {
        if (options === void 0) options = {};
        var machine = (0, (0, parcelRequire("klEg8")).default)(function() {
            return typeof getMachine === 'function' ? getMachine() : getMachine;
        });
        var _a, initialMachine;
        var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $f7003744c26bcbd6$var$__rest(options, [
            "context",
            "guards",
            "actions",
            "activities",
            "services",
            "delays",
            "state"
        ]);
        var service = (0, (0, parcelRequire("klEg8")).default)(function() {
            var machineConfig = {
                context: context,
                guards: guards,
                actions: actions,
                activities: activities,
                services: services,
                delays: delays
            };
            var machineWithConfig = machine.withConfig(machineConfig, $f7003744c26bcbd6$var$__assign($f7003744c26bcbd6$var$__assign({}, machine.context), context));
            return (0, (0, parcelRequire("iflnw")).interpret)(machineWithConfig, $f7003744c26bcbd6$var$__assign({
                deferEvents: true
            }, interpreterOptions));
        });
        (0, $hrqx3.default)(function() {
            var sub;
            if (observerOrListener) sub = service.subscribe((0, (0, parcelRequire("fcQkf")).toObserver)(observerOrListener));
            return function() {
                sub === null || sub === void 0 || sub.unsubscribe();
            };
        }, [
            observerOrListener
        ]);
        (0, $hrqx3.default)(function() {
            service.start(rehydratedState ? (0, (0, parcelRequire("krWBq")).State).create(rehydratedState) : undefined);
            return function() {
                service.stop();
            };
        }, []);
        (0, $hrqx3.default)(function() {
            Object.assign(service.machine.options.actions, actions);
        }, [
            actions
        ]);
        (0, $hrqx3.default)(function() {
            Object.assign(service.machine.options.services, services);
        }, [
            services
        ]);
        (0, (0, parcelRequire("k5mvV")).useReactEffectActions)(service);
        return service;
    }
});
parcelRegister("fcQkf", function(module, exports) {
    "use strict";
    var $b12090c7f00082b4$var$__assign = module.exports && module.exports.__assign || function() {
        $b12090c7f00082b4$var$__assign = Object.assign || function(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return $b12090c7f00082b4$var$__assign.apply(this, arguments);
    };
    var $b12090c7f00082b4$var$__values = module.exports && module.exports.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    var $b12090c7f00082b4$var$__read = module.exports && module.exports.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    var $b12090c7f00082b4$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
        for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
        return to;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toObserver = module.exports.toInvokeSource = module.exports.evaluateGuard = module.exports.reportUnhandledExceptionOnInvocation = module.exports.normalizeTarget = module.exports.toTransitionConfigArray = module.exports.toSCXMLEvent = module.exports.toEventObject = module.exports.uniqueId = module.exports.isActor = module.exports.isMachine = module.exports.symbolObservable = module.exports.isObservable = module.exports.toGuard = module.exports.isString = module.exports.isFunction = module.exports.isArray = module.exports.warn = module.exports.updateContext = module.exports.updateHistoryValue = module.exports.updateHistoryStates = module.exports.partition = module.exports.isPromiseLike = module.exports.isBuiltInEvent = module.exports.mapContext = module.exports.toArray = module.exports.toArrayStrict = module.exports.flatten = module.exports.pathsToStateValue = module.exports.toStatePaths = module.exports.nestedPath = module.exports.path = module.exports.mapFilterValues = module.exports.mapValues = module.exports.pathToStateValue = module.exports.toStateValue = module.exports.isStateLike = module.exports.toStatePath = module.exports.getActionType = module.exports.getEventType = module.exports.matchesState = module.exports.keys = void 0;
    var $3ZOoN;
    var $klAOi;
    function $b12090c7f00082b4$var$keys(value) {
        return Object.keys(value);
    }
    module.exports.keys = $b12090c7f00082b4$var$keys;
    function $b12090c7f00082b4$var$matchesState(parentStateId, childStateId, delimiter) {
        if (delimiter === void 0) delimiter = (0, parcelRequire("3ZOoN")).STATE_DELIMITER;
        var parentStateValue = $b12090c7f00082b4$var$toStateValue(parentStateId, delimiter);
        var childStateValue = $b12090c7f00082b4$var$toStateValue(childStateId, delimiter);
        if ($b12090c7f00082b4$var$isString(childStateValue)) {
            if ($b12090c7f00082b4$var$isString(parentStateValue)) return childStateValue === parentStateValue;
            return false;
        }
        if ($b12090c7f00082b4$var$isString(parentStateValue)) return parentStateValue in childStateValue;
        return $b12090c7f00082b4$var$keys(parentStateValue).every(function(key) {
            if (!(key in childStateValue)) return false;
            return $b12090c7f00082b4$var$matchesState(parentStateValue[key], childStateValue[key]);
        });
    }
    module.exports.matchesState = $b12090c7f00082b4$var$matchesState;
    function $b12090c7f00082b4$var$getEventType(event) {
        try {
            return $b12090c7f00082b4$var$isString(event) || typeof event === 'number' ? "" + event : event.type;
        } catch (e) {
            throw new Error('Events must be strings or objects with a string event.type property.');
        }
    }
    module.exports.getEventType = $b12090c7f00082b4$var$getEventType;
    function $b12090c7f00082b4$var$getActionType(action) {
        try {
            return $b12090c7f00082b4$var$isString(action) || typeof action === 'number' ? "" + action : $b12090c7f00082b4$var$isFunction(action) ? action.name : action.type;
        } catch (e) {
            throw new Error('Actions must be strings or objects with a string action.type property.');
        }
    }
    module.exports.getActionType = $b12090c7f00082b4$var$getActionType;
    function $b12090c7f00082b4$var$toStatePath(stateId, delimiter) {
        try {
            if ($b12090c7f00082b4$var$isArray(stateId)) return stateId;
            return stateId.toString().split(delimiter);
        } catch (e) {
            throw new Error("'" + stateId + "' is not a valid state path.");
        }
    }
    module.exports.toStatePath = $b12090c7f00082b4$var$toStatePath;
    function $b12090c7f00082b4$var$isStateLike(state) {
        return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
    }
    module.exports.isStateLike = $b12090c7f00082b4$var$isStateLike;
    function $b12090c7f00082b4$var$toStateValue(stateValue, delimiter) {
        if ($b12090c7f00082b4$var$isStateLike(stateValue)) return stateValue.value;
        if ($b12090c7f00082b4$var$isArray(stateValue)) return $b12090c7f00082b4$var$pathToStateValue(stateValue);
        if (typeof stateValue !== 'string') return stateValue;
        var statePath = $b12090c7f00082b4$var$toStatePath(stateValue, delimiter);
        return $b12090c7f00082b4$var$pathToStateValue(statePath);
    }
    module.exports.toStateValue = $b12090c7f00082b4$var$toStateValue;
    function $b12090c7f00082b4$var$pathToStateValue(statePath) {
        if (statePath.length === 1) return statePath[0];
        var value = {};
        var marker = value;
        for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
        else {
            marker[statePath[i]] = {};
            marker = marker[statePath[i]];
        }
        return value;
    }
    module.exports.pathToStateValue = $b12090c7f00082b4$var$pathToStateValue;
    function $b12090c7f00082b4$var$mapValues(collection, iteratee) {
        var result = {};
        var collectionKeys = $b12090c7f00082b4$var$keys(collection);
        for(var i = 0; i < collectionKeys.length; i++){
            var key = collectionKeys[i];
            result[key] = iteratee(collection[key], key, collection, i);
        }
        return result;
    }
    module.exports.mapValues = $b12090c7f00082b4$var$mapValues;
    function $b12090c7f00082b4$var$mapFilterValues(collection, iteratee, predicate) {
        var e_1, _a;
        var result = {};
        try {
            for(var _b = $b12090c7f00082b4$var$__values($b12090c7f00082b4$var$keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var item = collection[key];
                if (!predicate(item)) continue;
                result[key] = iteratee(item, key, collection);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    }
    module.exports.mapFilterValues = $b12090c7f00082b4$var$mapFilterValues;
    var $b12090c7f00082b4$var$path = function(props) {
        return function(object) {
            var e_2, _a;
            var result = object;
            try {
                for(var props_1 = $b12090c7f00082b4$var$__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                    var prop = props_1_1.value;
                    result = result[prop];
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            return result;
        };
    };
    module.exports.path = $b12090c7f00082b4$var$path;
    function $b12090c7f00082b4$var$nestedPath(props, accessorProp) {
        return function(object) {
            var e_3, _a;
            var result = object;
            try {
                for(var props_2 = $b12090c7f00082b4$var$__values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                    var prop = props_2_1.value;
                    result = result[accessorProp][prop];
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            return result;
        };
    }
    module.exports.nestedPath = $b12090c7f00082b4$var$nestedPath;
    function $b12090c7f00082b4$var$toStatePaths(stateValue) {
        if (!stateValue) return [
            []
        ];
        if ($b12090c7f00082b4$var$isString(stateValue)) return [
            [
                stateValue
            ]
        ];
        var result = $b12090c7f00082b4$var$flatten($b12090c7f00082b4$var$keys(stateValue).map(function(key) {
            var subStateValue = stateValue[key];
            if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
                [
                    key
                ]
            ];
            return $b12090c7f00082b4$var$toStatePaths(stateValue[key]).map(function(subPath) {
                return [
                    key
                ].concat(subPath);
            });
        }));
        return result;
    }
    module.exports.toStatePaths = $b12090c7f00082b4$var$toStatePaths;
    function $b12090c7f00082b4$var$pathsToStateValue(paths) {
        var e_4, _a;
        var result = {};
        if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
        try {
            for(var paths_1 = $b12090c7f00082b4$var$__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var currentPath = paths_1_1.value;
                var marker = result;
                for(var i = 0; i < currentPath.length; i++){
                    var subPath = currentPath[i];
                    if (i === currentPath.length - 2) {
                        marker[subPath] = currentPath[i + 1];
                        break;
                    }
                    marker[subPath] = marker[subPath] || {};
                    marker = marker[subPath];
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        return result;
    }
    module.exports.pathsToStateValue = $b12090c7f00082b4$var$pathsToStateValue;
    function $b12090c7f00082b4$var$flatten(array) {
        var _a;
        return (_a = []).concat.apply(_a, $b12090c7f00082b4$var$__spreadArray([], $b12090c7f00082b4$var$__read(array)));
    }
    module.exports.flatten = $b12090c7f00082b4$var$flatten;
    function $b12090c7f00082b4$var$toArrayStrict(value) {
        if ($b12090c7f00082b4$var$isArray(value)) return value;
        return [
            value
        ];
    }
    module.exports.toArrayStrict = $b12090c7f00082b4$var$toArrayStrict;
    function $b12090c7f00082b4$var$toArray(value) {
        if (value === undefined) return [];
        return $b12090c7f00082b4$var$toArrayStrict(value);
    }
    module.exports.toArray = $b12090c7f00082b4$var$toArray;
    function $b12090c7f00082b4$var$mapContext(mapper, context, _event) {
        var e_5, _a;
        if ($b12090c7f00082b4$var$isFunction(mapper)) return mapper(context, _event.data);
        var result = {};
        try {
            for(var _b = $b12090c7f00082b4$var$__values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var subMapper = mapper[key];
                if ($b12090c7f00082b4$var$isFunction(subMapper)) result[key] = subMapper(context, _event.data);
                else result[key] = subMapper;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return result;
    }
    module.exports.mapContext = $b12090c7f00082b4$var$mapContext;
    function $b12090c7f00082b4$var$isBuiltInEvent(eventType) {
        return /^(done|error)\./.test(eventType);
    }
    module.exports.isBuiltInEvent = $b12090c7f00082b4$var$isBuiltInEvent;
    function $b12090c7f00082b4$var$isPromiseLike(value) {
        if (value instanceof Promise) return true;
        if (value !== null && ($b12090c7f00082b4$var$isFunction(value) || typeof value === 'object') && $b12090c7f00082b4$var$isFunction(value.then)) return true;
        return false;
    }
    module.exports.isPromiseLike = $b12090c7f00082b4$var$isPromiseLike;
    function $b12090c7f00082b4$var$partition(items, predicate) {
        var e_6, _a;
        var _b = $b12090c7f00082b4$var$__read([
            [],
            []
        ], 2), truthy = _b[0], falsy = _b[1];
        try {
            for(var items_1 = $b12090c7f00082b4$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                var item = items_1_1.value;
                if (predicate(item)) truthy.push(item);
                else falsy.push(item);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return [
            truthy,
            falsy
        ];
    }
    module.exports.partition = $b12090c7f00082b4$var$partition;
    function $b12090c7f00082b4$var$updateHistoryStates(hist, stateValue) {
        return $b12090c7f00082b4$var$mapValues(hist.states, function(subHist, key) {
            if (!subHist) return undefined;
            var subStateValue = ($b12090c7f00082b4$var$isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
            if (!subStateValue) return undefined;
            return {
                current: subStateValue,
                states: $b12090c7f00082b4$var$updateHistoryStates(subHist, subStateValue)
            };
        });
    }
    module.exports.updateHistoryStates = $b12090c7f00082b4$var$updateHistoryStates;
    function $b12090c7f00082b4$var$updateHistoryValue(hist, stateValue) {
        return {
            current: stateValue,
            states: $b12090c7f00082b4$var$updateHistoryStates(hist, stateValue)
        };
    }
    module.exports.updateHistoryValue = $b12090c7f00082b4$var$updateHistoryValue;
    function $b12090c7f00082b4$var$updateContext(context, _event, assignActions, state) {
        if (!(0, parcelRequire("klAOi")).IS_PRODUCTION) $b12090c7f00082b4$var$warn(!!context, 'Attempting to update undefined context');
        var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
            var e_7, _a;
            var assignment = assignAction.assignment;
            var meta = {
                state: state,
                action: assignAction,
                _event: _event
            };
            var partialUpdate = {};
            if ($b12090c7f00082b4$var$isFunction(assignment)) partialUpdate = assignment(acc, _event.data, meta);
            else try {
                for(var _b = $b12090c7f00082b4$var$__values($b12090c7f00082b4$var$keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var key = _c.value;
                    var propAssignment = assignment[key];
                    partialUpdate[key] = $b12090c7f00082b4$var$isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
                }
            } catch (e_7_1) {
                e_7 = {
                    error: e_7_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_7) throw e_7.error;
                }
            }
            return Object.assign({}, acc, partialUpdate);
        }, context) : context;
        return updatedContext;
    }
    module.exports.updateContext = $b12090c7f00082b4$var$updateContext;
    var $b12090c7f00082b4$var$warn = function() {};
    module.exports.warn = $b12090c7f00082b4$var$warn;
    if (!(0, parcelRequire("klAOi")).IS_PRODUCTION) module.exports.warn = $b12090c7f00082b4$var$warn = function(condition, message) {
        var error = condition instanceof Error ? condition : undefined;
        if (!error && condition) return;
        if (console !== undefined) {
            var args = [
                "Warning: " + message
            ];
            if (error) args.push(error);
            console.warn.apply(console, args);
        }
    };
    function $b12090c7f00082b4$var$isArray(value) {
        return Array.isArray(value);
    }
    module.exports.isArray = $b12090c7f00082b4$var$isArray;
    function $b12090c7f00082b4$var$isFunction(value) {
        return typeof value === 'function';
    }
    module.exports.isFunction = $b12090c7f00082b4$var$isFunction;
    function $b12090c7f00082b4$var$isString(value) {
        return typeof value === 'string';
    }
    module.exports.isString = $b12090c7f00082b4$var$isString;
    function $b12090c7f00082b4$var$toGuard(condition, guardMap) {
        if (!condition) return undefined;
        if ($b12090c7f00082b4$var$isString(condition)) return {
            type: (0, parcelRequire("3ZOoN")).DEFAULT_GUARD_TYPE,
            name: condition,
            predicate: guardMap ? guardMap[condition] : undefined
        };
        if ($b12090c7f00082b4$var$isFunction(condition)) return {
            type: (0, parcelRequire("3ZOoN")).DEFAULT_GUARD_TYPE,
            name: condition.name,
            predicate: condition
        };
        return condition;
    }
    module.exports.toGuard = $b12090c7f00082b4$var$toGuard;
    function $b12090c7f00082b4$var$isObservable(value) {
        try {
            return 'subscribe' in value && $b12090c7f00082b4$var$isFunction(value.subscribe);
        } catch (e) {
            return false;
        }
    }
    module.exports.isObservable = $b12090c7f00082b4$var$isObservable;
    module.exports.symbolObservable = function() {
        return typeof Symbol === 'function' && Symbol.observable || '@@observable';
    }();
    function $b12090c7f00082b4$var$isMachine(value) {
        try {
            return '__xstatenode' in value;
        } catch (e) {
            return false;
        }
    }
    module.exports.isMachine = $b12090c7f00082b4$var$isMachine;
    function $b12090c7f00082b4$var$isActor(value) {
        return !!value && typeof value.send === 'function';
    }
    module.exports.isActor = $b12090c7f00082b4$var$isActor;
    module.exports.uniqueId = function() {
        var currentId = 0;
        return function() {
            currentId++;
            return currentId.toString(16);
        };
    }();
    function $b12090c7f00082b4$var$toEventObject(event, payload) {
        if ($b12090c7f00082b4$var$isString(event) || typeof event === 'number') return $b12090c7f00082b4$var$__assign({
            type: event
        }, payload);
        return event;
    }
    module.exports.toEventObject = $b12090c7f00082b4$var$toEventObject;
    function $b12090c7f00082b4$var$toSCXMLEvent(event, scxmlEvent) {
        if (!$b12090c7f00082b4$var$isString(event) && '$$type' in event && event.$$type === 'scxml') return event;
        var eventObject = $b12090c7f00082b4$var$toEventObject(event);
        return $b12090c7f00082b4$var$__assign({
            name: eventObject.type,
            data: eventObject,
            $$type: 'scxml',
            type: 'external'
        }, scxmlEvent);
    }
    module.exports.toSCXMLEvent = $b12090c7f00082b4$var$toSCXMLEvent;
    function $b12090c7f00082b4$var$toTransitionConfigArray(event, configLike) {
        var transitions = $b12090c7f00082b4$var$toArrayStrict(configLike).map(function(transitionLike) {
            if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $b12090c7f00082b4$var$isMachine(transitionLike)) return {
                target: transitionLike,
                event: event
            };
            return $b12090c7f00082b4$var$__assign($b12090c7f00082b4$var$__assign({}, transitionLike), {
                event: event
            });
        });
        return transitions;
    }
    module.exports.toTransitionConfigArray = $b12090c7f00082b4$var$toTransitionConfigArray;
    function $b12090c7f00082b4$var$normalizeTarget(target) {
        if (target === undefined || target === (0, parcelRequire("3ZOoN")).TARGETLESS_KEY) return undefined;
        return $b12090c7f00082b4$var$toArray(target);
    }
    module.exports.normalizeTarget = $b12090c7f00082b4$var$normalizeTarget;
    function $b12090c7f00082b4$var$reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
        if (!(0, parcelRequire("klAOi")).IS_PRODUCTION) {
            var originalStackTrace = originalError.stack ? " Stacktrace was '" + originalError.stack + "'" : '';
            if (originalError === currentError) console.error("Missing onError handler for invocation '" + id + "', error was '" + originalError + "'." + originalStackTrace);
            else {
                var stackTrace = currentError.stack ? " Stacktrace was '" + currentError.stack + "'" : '';
                console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '" + id + "'. " + ("Original error: '" + originalError + "'. " + originalStackTrace + " Current error is '" + currentError + "'." + stackTrace));
            }
        }
    }
    module.exports.reportUnhandledExceptionOnInvocation = $b12090c7f00082b4$var$reportUnhandledExceptionOnInvocation;
    function $b12090c7f00082b4$var$evaluateGuard(machine, guard, context, _event, state) {
        var guards = machine.options.guards;
        var guardMeta = {
            state: state,
            cond: guard,
            _event: _event
        };
        if (guard.type === (0, parcelRequire("3ZOoN")).DEFAULT_GUARD_TYPE) return guard.predicate(context, _event.data, guardMeta);
        var condFn = guards[guard.type];
        if (!condFn) throw new Error("Guard '" + guard.type + "' is not implemented on machine '" + machine.id + "'.");
        return condFn(context, _event.data, guardMeta);
    }
    module.exports.evaluateGuard = $b12090c7f00082b4$var$evaluateGuard;
    function $b12090c7f00082b4$var$toInvokeSource(src) {
        if (typeof src === 'string') return {
            type: src
        };
        return src;
    }
    module.exports.toInvokeSource = $b12090c7f00082b4$var$toInvokeSource;
    function $b12090c7f00082b4$var$toObserver(nextHandler, errorHandler, completionHandler) {
        if (typeof nextHandler === 'object') return nextHandler;
        var noop = function() {
            return void 0;
        };
        return {
            next: nextHandler,
            error: errorHandler || noop,
            complete: completionHandler || noop
        };
    }
    module.exports.toObserver = $b12090c7f00082b4$var$toObserver;
});
parcelRegister("3ZOoN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TARGETLESS_KEY = module.exports.DEFAULT_GUARD_TYPE = module.exports.EMPTY_ACTIVITY_MAP = module.exports.STATE_DELIMITER = void 0;
    module.exports.STATE_DELIMITER = '.';
    module.exports.EMPTY_ACTIVITY_MAP = {};
    module.exports.DEFAULT_GUARD_TYPE = 'xstate.guard';
    module.exports.TARGETLESS_KEY = '';
});
parcelRegister("klAOi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IS_PRODUCTION = void 0;
    module.exports.IS_PRODUCTION = true;
});
parcelRegister("klEg8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed04ff716acc6660$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $ed04ff716acc6660$export$2e2bcd8739ae039(fn) {
        var ref = $5uXOq.useRef();
        if (!ref.current) ref.current = {
            v: fn()
        };
        return ref.current.v;
    }
});
parcelRegister("k5mvV", function(module, exports) {
    $parcel$export(module.exports, "useReactEffectActions", ()=>$e9f5bd144d5efc5b$export$a73dbfb5780c94db);
    var $5uXOq = parcelRequire("5uXOq");
    var $hrqx3 = parcelRequire("hrqx3");
    var $9bCqE;
    var $keUrf;
    var $gNFqi;
    var $e9f5bd144d5efc5b$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    var $e9f5bd144d5efc5b$var$__spread = undefined && undefined.__spread || function() {
        for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e9f5bd144d5efc5b$var$__read(arguments[i]));
        return ar;
    };
    function $e9f5bd144d5efc5b$export$a73dbfb5780c94db(service) {
        var effectActionsRef = (0, $5uXOq.useRef)([]);
        var layoutEffectActionsRef = (0, $5uXOq.useRef)([]);
        (0, $hrqx3.default)(function() {
            var sub = service.subscribe(function(currentState) {
                var _a, _b;
                if (currentState.actions.length) {
                    var reactEffectActions = currentState.actions.filter(function(action) {
                        return typeof action.exec === 'function' && '__effect' in action.exec;
                    });
                    var _c = $e9f5bd144d5efc5b$var$__read((0, (0, parcelRequire("keUrf")).partition)(reactEffectActions, function(action) {
                        return action.exec.__effect === (0, (0, parcelRequire("9bCqE")).ReactEffectType).Effect;
                    }), 2), effectActions = _c[0], layoutEffectActions = _c[1];
                    (_a = effectActionsRef.current).push.apply(_a, $e9f5bd144d5efc5b$var$__spread(effectActions.map(function(effectAction) {
                        return [
                            effectAction,
                            currentState
                        ];
                    })));
                    (_b = layoutEffectActionsRef.current).push.apply(_b, $e9f5bd144d5efc5b$var$__spread(layoutEffectActions.map(function(layoutEffectAction) {
                        return [
                            layoutEffectAction,
                            currentState
                        ];
                    })));
                }
            });
            return function() {
                sub.unsubscribe();
            };
        }, []);
        (0, $hrqx3.default)(function() {
            while(layoutEffectActionsRef.current.length){
                var _a = $e9f5bd144d5efc5b$var$__read(layoutEffectActionsRef.current.shift(), 2), layoutEffectAction = _a[0], effectState = _a[1];
                (0, (0, parcelRequire("gNFqi")).executeEffect)(layoutEffectAction, effectState);
            }
        });
        (0, $5uXOq.useEffect)(function() {
            while(effectActionsRef.current.length){
                var _a = $e9f5bd144d5efc5b$var$__read(effectActionsRef.current.shift(), 2), effectAction = _a[0], effectState = _a[1];
                (0, (0, parcelRequire("gNFqi")).executeEffect)(effectAction, effectState);
            }
        });
    }
});
parcelRegister("keUrf", function(module, exports) {
    $parcel$export(module.exports, "partition", ()=>$ebc0e4f60820ead9$export$b29f828819edca8d);
    var $ebc0e4f60820ead9$var$__read = undefined && undefined.__read || function(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
        } catch (error) {
            e = {
                error: error
            };
        } finally{
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            } finally{
                if (e) throw e.error;
            }
        }
        return ar;
    };
    var $ebc0e4f60820ead9$var$__values = undefined && undefined.__values || function(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function() {
                if (o && i >= o.length) o = void 0;
                return {
                    value: o && o[i++],
                    done: !o
                };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };
    function $ebc0e4f60820ead9$export$b29f828819edca8d(items, predicate) {
        var e_1, _a;
        var _b = $ebc0e4f60820ead9$var$__read([
            [],
            []
        ], 2), truthy = _b[0], falsy = _b[1];
        try {
            for(var items_1 = $ebc0e4f60820ead9$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
                var item = items_1_1.value;
                if (predicate(item)) truthy.push(item);
                else falsy.push(item);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return [
            truthy,
            falsy
        ];
    }
});
parcelRegister("aAR7m", function(module, exports) {
    $parcel$export(module.exports, "commandPaletteStateMachine", ()=>$785b62e83a15c0b7$export$43aa9d313c05e1e6);
    parcelRequire("dD9J4");
    var $g2PT9;
    var $eOdbG;
    const $785b62e83a15c0b7$export$43aa9d313c05e1e6 = ({ context: context })=>(0, (0, parcelRequire("eOdbG")).createMachine)({
            states: {
                'partial preset selection and command options list state': {
                    states: {
                        'no partial preset selected full options list': {
                            description: `If no partial preset is selected and there is no text input:
- Show the full options list`,
                            on: {
                                onPartialPresetSelected: {
                                    target: 'partial preset selected no options list',
                                    actions: [
                                        'removeInputText',
                                        'partialPresetSelected'
                                    ]
                                }
                            }
                        },
                        'no partial preset selected related options list': {
                            description: `If no partial preset is selected and the user has entered text:
- Show the related options list`,
                            on: {
                                onPartialPresetSelected: {
                                    target: 'partial preset selected no options list',
                                    actions: [
                                        'removeInputText',
                                        'partialPresetSelected'
                                    ]
                                }
                            }
                        },
                        'partial preset selected no options list': {
                            on: {
                                onPartialPresetRemoved: [
                                    {
                                        target: 'no partial preset selected related options list',
                                        cond: 'hasInputText',
                                        actions: 'partialPresetRemoved'
                                    },
                                    {
                                        target: 'no partial preset selected full options list',
                                        actions: 'partialPresetRemoved'
                                    }
                                ]
                            },
                            description: `If a partial preset is already selected:
- Don't show the options list
- Show the selected preset`
                        },
                        initialisation: {
                            always: [
                                {
                                    target: 'partial preset selected no options list',
                                    cond: 'hasInitialPreset'
                                },
                                'no partial preset selected full options list'
                            ]
                        }
                    },
                    initial: 'initialisation'
                }
            },
            context: context,
            schema: {
                events: {}
            },
            type: 'parallel',
            id: 'command palette state machine',
            on: {
                onTextEntered: {
                    actions: 'updateTextInput',
                    internal: true
                },
                onADFEntered: {
                    actions: 'updateADFInput',
                    internal: true
                }
            }
        }, {
            guards: {
                ['hasInputText']: (context)=>{
                    return !!context.textInput;
                },
                ['hasInitialPreset']: (context)=>{
                    const hasInitialPreset = context.presetPromptLabel !== undefined;
                    return hasInitialPreset;
                }
            },
            actions: {
                updateTextInput: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if ('onTextEntered' === event.type) {
                        if ('input' in event) return {
                            textInput: event.input
                        };
                        return {
                            textInput: ''
                        };
                    }
                    return {};
                }),
                updateADFInput: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if ('onADFEntered' === event.type) {
                        if ('adf' in event) return {
                            adfInput: event.adf
                        };
                        return {
                            adfInput: undefined
                        };
                    }
                    return {};
                }),
                partialPresetSelected: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type === 'onPartialPresetSelected') return {
                        configItem: event.configItem,
                        presetPromptLabel: event.presetPromptLabel
                    };
                    return {};
                }),
                partialPresetRemoved: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type === 'onPartialPresetRemoved') return {
                        configItem: context.baseGenerate,
                        presetPromptLabel: undefined
                    };
                    return {
                        presetPromptLabel: undefined
                    };
                }),
                removeInputText: (0, (0, parcelRequire("g2PT9")).assign)(()=>{
                    return {
                        textInput: '',
                        adfInput: undefined
                    };
                })
            }
        });
});
parcelRegister("dD9J4", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$9ec67645cd33a68e$export$e324594224ef24da);
    $parcel$export(module.exports, "assign", ()=>(parcelRequire("g2PT9")).assign);
    $parcel$export(module.exports, "send", ()=>(parcelRequire("g2PT9")).send);
    var $g2PT9;
    var $krWBq;
    var $eOdbG;
    var $iflnw;
    var $9ec67645cd33a68e$export$e324594224ef24da = {
        raise: (0, (0, parcelRequire("g2PT9")).raise),
        send: (0, (0, parcelRequire("g2PT9")).send),
        sendParent: (0, (0, parcelRequire("g2PT9")).sendParent),
        sendUpdate: (0, (0, parcelRequire("g2PT9")).sendUpdate),
        log: (0, (0, parcelRequire("g2PT9")).log),
        cancel: (0, (0, parcelRequire("g2PT9")).cancel),
        start: (0, (0, parcelRequire("g2PT9")).start),
        stop: (0, (0, parcelRequire("g2PT9")).stop),
        assign: (0, (0, parcelRequire("g2PT9")).assign),
        after: (0, (0, parcelRequire("g2PT9")).after),
        done: (0, (0, parcelRequire("g2PT9")).done),
        respond: (0, (0, parcelRequire("g2PT9")).respond),
        forwardTo: (0, (0, parcelRequire("g2PT9")).forwardTo),
        escalate: (0, (0, parcelRequire("g2PT9")).escalate),
        choose: (0, (0, parcelRequire("g2PT9")).choose),
        pure: (0, (0, parcelRequire("g2PT9")).pure)
    };
});
parcelRegister("9vp0r", function(module, exports) {
    $parcel$export(module.exports, "useAgentStarters", ()=>$a9ccde62f5dbe572$export$552fd0249f716349);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7Jxgt = parcelRequire("7Jxgt");
    var $VSDnB;
    var $8S93R;
    var $9AQGA;
    var $h1WZC;
    var $9m3ZB;
    var $fpzVC;
    var $gCBI2;
    const $a9ccde62f5dbe572$var$experienceName = 'Rovo agent conversation starters';
    const $a9ccde62f5dbe572$var$suggestionCount = 3;
    function $a9ccde62f5dbe572$export$552fd0249f716349({ handleHighlight: handleHighlight, configItem: configItem, onConversationStarterSelected: onConversationStarterSelected, product: product }) {
        const { agent: agent } = configItem;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [hasError, setHasError] = (0, $5uXOq.useState)(false);
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlow)();
        const [lastAiInteractionID, setLastAiInteractionID] = (0, $5uXOq.useState)('');
        const getAiLifeCycleDynamicAttributes = (0, (0, parcelRequire("VSDnB")).fg)('editorai_dynamic_attributes_for_ai_life_cycle') ? analyticsFlow.getAiLifeCycleDynamicAttributes : undefined;
        const userDefinedAgentStarters = (0, $5uXOq.useMemo)(()=>{
            if (!agent) return [];
            return agent.conversationStarters.filter((conversationStarter)=>{
                return conversationStarter.type === 'user-defined';
            });
        }, [
            agent
        ]);
        const onInit = (0, $5uXOq.useCallback)(()=>{
            setHasError(false);
            const aiId = (0, ($parcel$interopDefault($7Jxgt)))();
            setLastAiInteractionID(aiId);
            fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('initiated', aiId, $a9ccde62f5dbe572$var$experienceName, false, getAiLifeCycleDynamicAttributes?.({
                    init: true
                }))
            });
        }, [
            fireAIAnalyticsEvent,
            getAiLifeCycleDynamicAttributes
        ]);
        const onError = (0, $5uXOq.useCallback)((error)=>{
            setHasError(true);
            fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('error', lastAiInteractionID, $a9ccde62f5dbe572$var$experienceName, false, {
                    aiErrorMessage: error.message,
                    aiErrorCode: 500,
                    ...getAiLifeCycleDynamicAttributes?.({
                        init: false
                    })
                })
            });
        }, [
            fireAIAnalyticsEvent,
            lastAiInteractionID,
            getAiLifeCycleDynamicAttributes
        ]);
        const { getContextualStarters: getContextualStarters, starters: contextualStarters, isMutating: isMutating } = (0, (0, parcelRequire("9AQGA")).useContextualConversationStartersController)({
            onInit: onInit,
            onError: onError,
            assistanceServiceConfig: {
                product: (0, (0, parcelRequire("fpzVC")).mapToConvoAIProductName)(product),
                experienceId: 'ai-mate'
            }
        });
        const isPending = (0, $5uXOq.useMemo)(()=>{
            return isMutating || contextualStarters.some((cs)=>!cs) && userDefinedAgentStarters.length < $a9ccde62f5dbe572$var$suggestionCount;
        }, [
            isMutating,
            contextualStarters,
            userDefinedAgentStarters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (agent && userDefinedAgentStarters.length < $a9ccde62f5dbe572$var$suggestionCount) getContextualStarters({
                locationUrl: window.location.href,
                fallbackStarters: agent.conversationStarters.map((conversationStarter)=>{
                    if (typeof conversationStarter.message !== 'string') conversationStarter.message = formatMessage(conversationStarter.message);
                    return conversationStarter;
                }),
                agentNamedId: agent.namedId
            });
        }, [
            agent,
            getContextualStarters,
            formatMessage,
            userDefinedAgentStarters
        ]);
        const starters = (0, $5uXOq.useMemo)(()=>{
            if (!agent) return [];
            let conversationStarters = userDefinedAgentStarters;
            if (isPending) return (0, (0, parcelRequire("gCBI2")).getDummySuggestions)(agent, $a9ccde62f5dbe572$var$suggestionCount);
            if (conversationStarters.length < $a9ccde62f5dbe572$var$suggestionCount) {
                const nonNullContextualStarters = contextualStarters.filter((conversationStarter)=>conversationStarter !== null);
                const availableContextualStarters = nonNullContextualStarters.slice(0, $a9ccde62f5dbe572$var$suggestionCount - conversationStarters.length);
                conversationStarters = [
                    ...conversationStarters,
                    ...availableContextualStarters
                ];
            }
            return conversationStarters.map(({ message: conversationStarter }, index)=>{
                const translatedMessage = typeof conversationStarter === 'string' ? conversationStarter : formatMessage(conversationStarter);
                return {
                    value: `agent:${agent.id}:${index}:${translatedMessage}`,
                    label: translatedMessage,
                    icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
                        agentId: agent.id,
                        agentNamedId: agent.externalConfigReference ?? agent.namedId,
                        agentIdentityAccountId: agent.identityAccountId,
                        isForgeAgent: agent.creatorType === 'FORGE',
                        forgeAgentIconUrl: agent.icon
                    }),
                    groupHeading: '',
                    onSelect: ()=>{
                        onConversationStarterSelected(translatedMessage);
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                    }
                };
            });
        }, [
            agent,
            isPending,
            userDefinedAgentStarters,
            contextualStarters,
            formatMessage,
            onConversationStarterSelected,
            handleHighlight,
            configItem
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isPending && !hasError && starters.length) fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('viewed', lastAiInteractionID, $a9ccde62f5dbe572$var$experienceName, false, getAiLifeCycleDynamicAttributes?.({
                    init: true
                }))
            });
        }, [
            isPending,
            hasError,
            starters,
            fireAIAnalyticsEvent,
            lastAiInteractionID,
            getAiLifeCycleDynamicAttributes
        ]);
        return {
            starters: starters
        };
    }
});
parcelRegister("9AQGA", function(module, exports) {
    $parcel$export(module.exports, "useContextualConversationStartersController", ()=>$b7f8429799bf385d$export$b84e2b819a747588);
    var $5uXOq = parcelRequire("5uXOq");
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $cDP7F;
    const $b7f8429799bf385d$export$b84e2b819a747588 = (props)=>{
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const assistanceService = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)(props?.assistanceServiceConfig);
        const [didTimeOut, setDidTimeOut] = (0, $5uXOq.useState)(false);
        const [starters, setStarters] = (0, $5uXOq.useState)(new Array(3).fill(null));
        const timeoutRef = (0, $5uXOq.useRef)(null);
        const cancelTimeout = (0, $5uXOq.useCallback)(()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }, []);
        const beginTimeout = (0, $5uXOq.useCallback)((userDefinedStarters, fallbackStarters)=>{
            timeoutRef.current = window.setTimeout(()=>{
                experience.abort({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                    reason: 'timeout'
                });
                setDidTimeOut(true);
                setStarters([
                    ...userDefinedStarters,
                    ...fallbackStarters
                ].slice(0, 3));
            }, 2000);
            return cancelTimeout;
        }, [
            cancelTimeout,
            experience
        ]);
        const { mutate: getContextualStarters, error: error, isMutating: isMutating } = (0, (0, parcelRequire("cDP7F")).useStreamingMutation)({
            mutationFn: async ({ userDefinedStarters: userDefinedStarters = [], fallbackStarters: fallbackStarters, locationUrl: locationUrl, agentNamedId: agentNamedId = 'ai_mate_agent' })=>{
                if (props && props.onInit) props.onInit();
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONTEXTUAL_STARTERS
                });
                setDidTimeOut(false);
                setStarters([
                    ...userDefinedStarters,
                    ...new Array(3).fill(null)
                ].slice(0, 3));
                beginTimeout(userDefinedStarters, fallbackStarters);
                const result = await assistanceService.generateContextualConversationStarters({
                    recipient_agent_named_id: agentNamedId,
                    context: {
                        browser_url: locationUrl
                    }
                });
                return result.generator;
            },
            onChunkReceived: async (chunk)=>{
                if (didTimeOut) return;
                cancelTimeout();
                switch(chunk.type){
                    case 'CONVERSATION_STARTER':
                        const index = starters.indexOf(null);
                        const starterAlreadyExists = starters.some((starter)=>starter?.message === chunk.message.text);
                        if (index !== -1 && !starterAlreadyExists) {
                            let newStarters = [
                                ...starters
                            ];
                            newStarters[index] = {
                                message: chunk.message.text,
                                type: 'llm-generated'
                            };
                            setStarters(newStarters);
                        }
                        break;
                }
            },
            onSuccess: ()=>{
                if (props && props.onSuccess) props.onSuccess();
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONTEXTUAL_STARTERS
                });
            },
            onError: (error)=>{
                if (props && props.onError) props.onError(error);
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                    error: error
                });
            }
        });
        return {
            getContextualStarters: getContextualStarters,
            starters: starters,
            error: error,
            cancelTimeout: cancelTimeout,
            isMutating: isMutating
        };
    };
});
parcelRegister("91cKc", function(module, exports) {
    $parcel$export(module.exports, "ExperienceName", ()=>$8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1);
    const $8cf0ed4e0647d0d1$export$b881bd9f00ed8ed1 = {
        LOAD_PANEL: 'aiMateLoadPanel',
        LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
        LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
        FETCH_CHAT: 'aiMateFetchChat',
        FETCH_AGENTS: 'aiMateFetchAgents',
        FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
        FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
        CREATE_AGENT: 'aiMateCreateAgent',
        UPDATE_AGENT: 'aiMateUpdateAgent',
        DELETE_AGENT: 'aiMateDeleteAgent',
        FAVOURITE_AGENT: 'aiMateFavouriteAgent',
        UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
        CLEAR_CHAT: 'aiMateClearChat',
        SEND_MESSAGE: 'aiMateSendMessage',
        ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
        FETCH_FEATURES: 'aiMateFetchFeatures',
        GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
        UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
        CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
        PUBSUB_LISTENER: 'aiMatePubSubListener',
        FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
        RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
        MESSAGE_RENDERER: 'aiMateMessageRenderer',
        FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
        GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
        FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
        FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
        FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
        CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
        GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions'
    };
});
parcelRegister("cSxED", function(module, exports) {
    $parcel$export(module.exports, "useAIMateExperienceTracker", ()=>$0ff262dad5216a84$export$412c53791574f6f0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ha42n;
    var $jXUCh;
    var $3kN8f;
    var $jSnf2;
    const $0ff262dad5216a84$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
    class $0ff262dad5216a84$var$ExperienceTrackerHandler {
        constructor(){
            this.experienceTracker = new (0, (0, parcelRequire("ha42n")).ExperienceTracker)();
            this.sendAnalyticsEvent = null;
            this.experienceTracker.subscribe((event)=>{
                if ('error' in event) {
                    if ((0, (0, parcelRequire("jXUCh")).isClientFetchError)(event.error)) return;
                    let filteredErrorAttributes = {};
                    if ($0ff262dad5216a84$var$isRovoInstrumentedError(event.error)) {
                        const errorAttributes = event.error.errorAttributes;
                        filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([_, value])=>value !== undefined));
                        if (errorAttributes?.statusCode && errorAttributes?.statusCode >= 500) return;
                    }
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const touchpointSource = event.attributes?.touchpointSource;
                    (0, (0, parcelRequire("3kN8f")).logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributes,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            }
                        }
                    });
                }
                this.sendAnalyticsEvent?.({
                    eventType: 'operational',
                    action: event.action,
                    actionSubject: 'ui',
                    attributes: {
                        task: event.name,
                        taskId: event.id,
                        startTime: event.startTime,
                        ...event.attributes
                    }
                }, {
                    removeDefaultTags: true
                });
            });
        }
        setSendAnalyticsEvent(sendAnalyticsEvent) {
            this.sendAnalyticsEvent = sendAnalyticsEvent;
        }
        static getInstance() {
            if (!$0ff262dad5216a84$var$ExperienceTrackerHandler.instance) $0ff262dad5216a84$var$ExperienceTrackerHandler.instance = new $0ff262dad5216a84$var$ExperienceTrackerHandler();
            return $0ff262dad5216a84$var$ExperienceTrackerHandler.instance;
        }
    }
    const $0ff262dad5216a84$export$412c53791574f6f0 = (params)=>{
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, (0, parcelRequire("jSnf2")).useAnalytics)();
        (0, $5uXOq.useEffect)(()=>{
            const experienceTracker = $0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance();
            experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
        }, [
            sendAnalyticsEvent
        ]);
        const experienceTrackerProxy = (0, $5uXOq.useMemo)(()=>{
            const proxyHandler = {
                get: (target, prop)=>{
                    if (prop === 'fail') return (failParams)=>{
                        target.fail({
                            ...failParams,
                            attributes: {
                                ...failParams.attributes,
                                touchpointSource: params?.touchpointSource
                            }
                        });
                    };
                    return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
                }
            };
            return new Proxy($0ff262dad5216a84$var$ExperienceTrackerHandler.getInstance().experienceTracker, proxyHandler);
        }, [
            params?.touchpointSource
        ]);
        return experienceTrackerProxy;
    };
});
parcelRegister("jXUCh", function(module, exports) {
    $parcel$export(module.exports, "isClientFetchError", ()=>$750b6f13fd837870$export$2e7adc44463c3f4f);
    const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS = [
        '... is not valid JSON',
        'server with the specified hostname could not be found',
        'cannot parse response',
        'connection failure',
        'Failed to fetch',
        'in JSON at position 0',
        'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
        'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
        'Load failed',
        'Network request failed',
        'NetworkError',
        'Syntax or http error',
        'The request timed out',
        'The network connection was lost',
        'The operation was aborted',
        'Unable to fetch manifest',
        'Unexpected end of input',
        'Unexpected end of JSON input',
        'dynamically imported module',
        'Importing a module script failed'
    ];
    const $750b6f13fd837870$var$isClientFetchErrorMessage = (message)=>Boolean(message) && !!$750b6f13fd837870$var$KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>message.includes(networkErrorMessage));
    const $750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES = [
        'AbortError',
        'AuthError',
        'ChunkLoadError',
        'NetworkError'
    ];
    const $750b6f13fd837870$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($750b6f13fd837870$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $750b6f13fd837870$var$isClientFetchErrorMessage(error.cause.message)));
});
parcelRegister("3kN8f", function(module, exports) {
    $parcel$export(module.exports, "setupSentryClient", ()=>$083186225bc5f71c$export$d8bd0edf6c978788);
    $parcel$export(module.exports, "logException", ()=>$083186225bc5f71c$export$f86b2a1a2ce291b3);
    var $5AZpC;
    var $jXUCh;
    var $9It69;
    var $2aeVO;
    const $083186225bc5f71c$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("8Xuap")));
    let $083186225bc5f71c$var$sentryClient;
    const $083186225bc5f71c$var$DISABLED_INTEGRATIONS = [
        'onerror',
        'onunhandledrejection',
        'Dedupe'
    ];
    const $083186225bc5f71c$var$getEnvironment = ()=>{
        return 'production';
    };
    const $083186225bc5f71c$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride } = {})=>{
        let accountId = 'UNKNOWN_AAID';
        let product = productOverride ?? (0, (0, parcelRequire("9It69")).getRovoChatProduct)();
        try {
            const profileData = await (0, (0, parcelRequire("5AZpC")).performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        } catch (_) {}
        if ($083186225bc5f71c$var$sentryClient) {
            $083186225bc5f71c$var$sentryClient.setTag('product', product);
            $083186225bc5f71c$var$sentryClient.setUser({
                id: accountId
            });
            return;
        }
        let importedSentry;
        try {
            importedSentry = await $083186225bc5f71c$var$importSentryAsync();
        } catch (e) {
            console.warn('Failed to load conversation-assistant sentry', e);
            return;
        }
        const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
        importedSentry.init({
            dsn: customSentryDsn || defaultSentryDsn,
            environment: $083186225bc5f71c$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $083186225bc5f71c$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: packageName || '@atlassian/conversation-assistant',
                    product: product
                }
            },
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                if ((0, (0, parcelRequire("jXUCh")).isClientFetchError)(exception)) return null;
                if (!event.tags?.name) return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com')) return null;
                    updatedEvent.request.url = (0, (0, parcelRequire("2aeVO")).normaliseUrl)(updatedEvent.request.url);
                }
                return updatedEvent;
            },
            attachStacktrace: true
        });
        $083186225bc5f71c$var$sentryClient = importedSentry;
    };
    const $083186225bc5f71c$var$getSentryClient = async ()=>{
        if (!$083186225bc5f71c$var$sentryClient) await $083186225bc5f71c$export$d8bd0edf6c978788();
        return $083186225bc5f71c$var$sentryClient;
    };
    const $083186225bc5f71c$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
        const sentryClient = await $083186225bc5f71c$var$getSentryClient();
        if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
        sentryClient.withScope((scope)=>{
            scope.setTag('name', name);
            if (tags) scope.setTags(tags);
            sentryClient.captureException(exception, scope);
        });
    };
});
parcelRegister("5AZpC", function(module, exports) {
    $parcel$export(module.exports, "performHttpFetch", ()=>$e3205999c8add5e6$export$a38d93aa782475f6);
    var $b0RFn;
    class $e3205999c8add5e6$var$HttpApiError extends Error {
        constructor(message, errorAttributes){
            super(message), this.message = message, this.errorAttributes = errorAttributes;
        }
    }
    const $e3205999c8add5e6$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
        try {
            const response = await fetch(path, options);
            if (!response.ok || response.status >= 400) await $e3205999c8add5e6$var$processHttpErrorResponse({
                response: response
            });
            return await response.json();
        } catch (err) {
            throw new (0, (0, parcelRequire("b0RFn")).FetchError)(`performHttpFetch error whle fetching ${path}`, {
                cause: err
            });
        }
    };
    const $e3205999c8add5e6$var$processHttpErrorResponse = async ({ response: response })=>{
        throw new $e3205999c8add5e6$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
            statusCode: response.status
        });
    };
});
parcelRegister("b0RFn", function(module, exports) {
    $parcel$export(module.exports, "FetchError", ()=>$b201945370d0e866$export$26e841bcf1aeb894);
    class $b201945370d0e866$export$26e841bcf1aeb894 extends Error {
        constructor(message, cause){
            super(message), this.cause = cause;
            this.name = 'FetchError';
            if (cause) this.cause = cause;
        }
    }
});
parcelRegister("9It69", function(module, exports) {
    $parcel$export(module.exports, "getRovoChatProduct", ()=>$8e07af78c7c996fd$export$d4fdfa93c283ffc);
    const $8e07af78c7c996fd$export$d4fdfa93c283ffc = ()=>{
        let product = 'UNKNOWN';
        if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
        return product;
    };
});
parcelRegister("2aeVO", function(module, exports) {
    $parcel$export(module.exports, "normaliseUrl", ()=>$f1e1fab54a39e125$export$d57ae76c6dc57a5);
    const $f1e1fab54a39e125$var$pathnamePrefixes = [
        '/jira/',
        '/wiki/',
        '/browse/'
    ];
    const $f1e1fab54a39e125$var$ATLAS_HOST = 'home.atlassian.com';
    const $f1e1fab54a39e125$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
    const $f1e1fab54a39e125$export$d57ae76c6dc57a5 = (url)=>{
        try {
            let parsedUrl = new URL(url);
            let normalizedPath = '/any/';
            if (parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_HOST || parsedUrl.host === $f1e1fab54a39e125$var$ATLAS_TEAM_HOST) normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
            const prefixRegex = new RegExp(`^(${$f1e1fab54a39e125$var$pathnamePrefixes.join('|')})`);
            if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
            const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
            return normalizedUrl;
        } catch (error) {
            return 'https://could-not-parse.example.com';
        }
    };
});
parcelRegister("cK3Jm", function(module, exports) {
    $parcel$export(module.exports, "AssistanceServiceBase", ()=>$23f77fef74bdf9a2$export$40a7802808e2fbe3);
    $parcel$export(module.exports, "AssistanceServiceImpl", ()=>$23f77fef74bdf9a2$export$a522c5f4ccda1c94);
    $parcel$export(module.exports, "AssistanceServiceProvider", ()=>$23f77fef74bdf9a2$export$8fe647eb935c33db);
    $parcel$export(module.exports, "useAssistanceService", ()=>$23f77fef74bdf9a2$export$7e31a1844ebbaf85);
    $parcel$export(module.exports, "createHookWithAssistanceService", ()=>$23f77fef74bdf9a2$export$5a9ea20fc196ec62);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    var $VSDnB;
    var $cSxED;
    var $7qdbi;
    var $cNqSS;
    var $4c7JV;
    var $lb2g6;
    var $khfvG;
    var $3zcGU;
    var $f7UWp;
    const $23f77fef74bdf9a2$var$PRODUCT_HEADER = 'x-product';
    const $23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
    class $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
        constructor(props){
            this.endpointSpecificBaseUrl = {
                chat: '/gateway/api/assist/chat/v1'
            };
            this.getConfig = ()=>{
                return {
                    ...this.config
                };
            };
            const defaultBaseUrl = '/gateway/api/assist';
            const defaultConfig = {
                baseUrl: defaultBaseUrl,
                headers: {}
            };
            this.config = {
                ...props,
                baseUrl: props.baseUrl || defaultConfig.baseUrl,
                headers: {
                    ...props.headers || defaultConfig.headers
                }
            };
        }
        createHeaders(init) {
            return new Headers({
                [$23f77fef74bdf9a2$var$PRODUCT_HEADER]: this.config.product,
                [$23f77fef74bdf9a2$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
                ...this.config.headers || {},
                ...init || {}
            });
        }
        async fetch({ path: path, options: options, endpointGroup: endpointGroup }) {
            const { baseUrl: configBaseUrl } = this.config;
            let baseUrlOverride = endpointGroup ? this.endpointSpecificBaseUrl[endpointGroup] : undefined;
            const baseUrl = baseUrlOverride ?? configBaseUrl;
            const requestUrl = (0, (0, parcelRequire("lb2g6")).addPath)(baseUrl, path);
            const response = await (0, (0, parcelRequire("f7UWp")).fetchFn)(requestUrl, options);
            return (0, (0, parcelRequire("lb2g6")).processResponse)({
                response: response
            });
        }
        async fetchJson(options) {
            const response = await this.fetch(options);
            const json = await response.json();
            return json;
        }
        async fetchStream(options) {
            const response = await this.fetch(options);
            return {
                responseData: {
                    traceId: (0, (0, parcelRequire("lb2g6")).getTraceIdFromResponse)(response)
                },
                generator: (0, (0, parcelRequire("cNqSS")).readJsonStream)(response)
            };
        }
    }
    class $23f77fef74bdf9a2$export$a522c5f4ccda1c94 extends $23f77fef74bdf9a2$export$40a7802808e2fbe3 {
        constructor(props){
            super(props), this.getAgentActions = async ()=>{
                const response = await this.fetchJson({
                    path: '/agents/configuration/v1/actions',
                    options: {
                        method: 'GET',
                        headers: this.createHeaders()
                    }
                });
                return response.actions;
            }, this.getAgentKnowledgeConfiguration = ()=>{
                return this.fetchJson({
                    path: '/agents/configuration/v1/knowledge',
                    options: {
                        method: 'GET',
                        headers: this.createHeaders()
                    }
                });
            }, this.getAgentPermissions = (agentId, payload)=>{
                return this.fetchJson({
                    path: `/api/rovo/v2/permissions/agents/${agentId}`,
                    options: {
                        method: 'POST',
                        headers: this.createHeaders({
                            'content-type': 'application/json;charset=UTF-8'
                        }),
                        body: JSON.stringify(payload)
                    }
                });
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_convo_ai_migration')) this.endpointSpecificBaseUrl.chat = '/gateway/api/assist/rovo/v1/chat';
        }
        async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, editorContext: editorContext, browserContext: browserContext, additionalContext: additionalContext }) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const url = browserContext ? browserContext.context?.browserUrl : window?.location?.href;
            const body = {
                content: message,
                context: {
                    browser_url: url,
                    ...editorContext ? {
                        editor: editorContext
                    } : {},
                    ...browserContext ? {
                        browser: {
                            htmlBody: browserContext.context?.htmlBody,
                            canvasText: browserContext.context?.canvasText
                        }
                    } : {},
                    ...additionalContext
                },
                recipient_agent_named_id: agentNamedId,
                agent_id: agentId,
                mimeType: typeof message === 'string' ? 'text/markdown' : 'text/adf',
                store_message: (0, (0, parcelRequire("VSDnB")).fg)('ai_mate_show_store_messages') ? storeMessage : false,
                citations_enabled: citationsEnabled
            };
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(body),
                signal: controller?.signal
            };
            return this.fetchStream({
                path: `/channel/${conversationId}/message/stream`,
                options: options,
                endpointGroup: 'chat'
            });
        }
        async getChat(conversationId) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers
            };
            const rawChat = await this.fetchJson({
                path: `/channel/${conversationId}/messages`,
                options: options,
                endpointGroup: 'chat'
            });
            const chatArray = 'items' in rawChat ? rawChat.items : rawChat;
            return chatArray.map((message)=>(0, (0, parcelRequire("4c7JV")).isHumanMessage)(message) ? message : (0, (0, parcelRequire("3zcGU")).toStreamResponse)(message));
        }
        async deleteChat(conversationId, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            await this.fetch({
                path: `/channel/${conversationId}`,
                options: options,
                endpointGroup: 'chat'
            });
        }
        async getFeatures(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: 'features',
                options: options
            });
        }
        async getAgents(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: 'agents/v1',
                options: options
            });
        }
        async getAgentDetails(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `agents/v1/${id}`,
                options: options
            });
        }
        async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `agents/v1/accountid/${identityAccountId}`,
                options: options
            });
        }
        async getAgentFileUploadToken(controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'GET',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: 'agents/v1/media/upload/credentials',
                options: options
            });
        }
        async createAgent(payload, controller) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller?.signal
            };
            return this.fetchJson({
                path: '/agents/v1',
                options: options
            });
        }
        async updateAgent(id, payload, controller) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify(payload),
                signal: controller?.signal
            };
            const response = await this.fetchJson({
                path: `/agents/v1/${id}`,
                options: options
            });
            return response;
        }
        async deleteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            return this.fetchJson({
                path: `/agents/v1/${id}`,
                options: options
            });
        }
        async favouriteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'POST',
                headers: headers,
                signal: controller?.signal
            };
            this.fetch({
                path: `/agents/v1/${id}/favourite`,
                options: options
            });
        }
        async unfavouriteAgent(id, controller) {
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers,
                signal: controller?.signal
            };
            this.fetch({
                path: `/agents/v1/${id}/favourite`,
                options: options
            });
        }
        async createConversationChannel(options) {
            return this.fetchJson({
                path: `/channel`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        name: options?.name ?? (0, (0, parcelRequire("khfvG")).generateConversationName)(),
                        dialogues: options?.dialogues ?? undefined
                    })
                },
                endpointGroup: 'chat'
            });
        }
        async getConversationChannels() {
            const result = await this.fetchJson({
                path: `/channels`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                endpointGroup: 'chat'
            });
            const channels = 'items' in result ? result.items : result;
            return channels;
        }
        updateConversationChannel(id, payload) {
            return this.fetchJson({
                path: `/channel/${id}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                endpointGroup: 'chat'
            });
        }
        async resolveConversationAction(id, payload) {
            return this.fetchJson({
                path: `/channel/${id}/action`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        ...payload,
                        context: {
                            ...payload.context,
                            browser_url: window.location.href
                        }
                    })
                },
                endpointGroup: 'chat'
            });
        }
        async speechToText(blob) {
            const formData = new FormData();
            formData.append('audio_recording', blob);
            const response = await this.fetchJson({
                path: '/speech/inference',
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                }
            });
            return response.transcription;
        }
        async generateConversationStarters(payload) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            };
            return this.fetchJson({
                path: '/agents/v1/suggest-conversation-starter',
                options: options
            });
        }
        async generateContextualConversationStarters(payload) {
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            };
            return this.fetchStream({
                path: '/agents/v1/conversation-starter',
                options: options
            });
        }
        async changeAgentOwner(agentId, payload) {
            return this.fetchJson({
                path: `/agents/v1/${agentId}/transfer-owner`,
                options: {
                    method: 'PATCH',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                }
            });
        }
    }
    const $23f77fef74bdf9a2$var$AssistanceServiceContext = (0, $5uXOq.createContext)(new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
        baseUrl: '',
        product: '',
        experienceId: ''
    }));
    const $23f77fef74bdf9a2$export$8fe647eb935c33db = ({ value: value, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($23f77fef74bdf9a2$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
    const $23f77fef74bdf9a2$export$7e31a1844ebbaf85 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, $5uXOq.useContext), $23f77fef74bdf9a2$export$a522c5f4ccda1c94);
        const service = (0, $5uXOq.useContext)($23f77fef74bdf9a2$var$AssistanceServiceContext);
        (0, (0, parcelRequire("7qdbi")).setRovoChatProduct)(props?.product ?? service.getConfig().product);
        if (!props || !props.experienceId && !props.product && !props.headers) return service;
        const product = props.product ?? service.getConfig().product;
        const experienceId = props.experienceId ?? service.getConfig().experienceId;
        const headers = props.headers ?? service.getConfig().headers;
        return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
            ...service.getConfig(),
            product: product,
            experienceId: experienceId,
            headers: headers
        });
    };
    const $23f77fef74bdf9a2$export$5a9ea20fc196ec62 = (originalHook)=>{
        return (props)=>{
            (0, (0, parcelRequire("gKZoD")).di)($23f77fef74bdf9a2$export$a522c5f4ccda1c94, (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker));
            const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
            const experienceTracker = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)({
                touchpointSource: assistanceServiceParams.touchpointSource
            });
            const assistanceService = (0, $5uXOq.useMemo)(()=>{
                return new $23f77fef74bdf9a2$export$a522c5f4ccda1c94({
                    product: assistanceServiceParams.product,
                    experienceId: assistanceServiceParams.experienceId,
                    headers: assistanceServiceParams.headers
                });
            }, [
                assistanceServiceParams.experienceId,
                assistanceServiceParams.headers,
                assistanceServiceParams.product
            ]);
            const result = originalHook({
                ...restProps,
                assistanceServiceInjectedParams: {
                    ...assistanceServiceParams,
                    experienceTracker: experienceTracker,
                    assistanceService: assistanceService
                }
            });
            return result;
        };
    };
});
parcelRegister("7qdbi", function(module, exports) {
    $parcel$export(module.exports, "setRovoChatProduct", ()=>$247284f3c41a7fa5$export$caa27b16709bc2df);
    const $247284f3c41a7fa5$export$caa27b16709bc2df = (product)=>{
        if (window) window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
    };
});
parcelRegister("cNqSS", function(module, exports) {
    $parcel$export(module.exports, "readJsonStream", ()=>$2504014003f7f3a1$export$1f24b2b263bcfa75);
    var $2uI0R;
    async function* $2504014003f7f3a1$export$1f24b2b263bcfa75(response) {
        const reader = (0, (0, parcelRequire("2uI0R")).getBufferReader)(response);
        let doneStreaming = false;
        let remainder = '';
        do try {
            const { value: value, done: done } = await reader.read();
            doneStreaming = done;
            if (value) try {
                const processedChunks = `${remainder}${value}`.split('\n');
                remainder = '';
                for (let chunk of processedChunks)try {
                    yield JSON.parse(chunk);
                } catch (e) {
                    remainder = chunk;
                }
            } catch (e) {
                const error = new Error(`Error Processing Stream Data: ${value}`);
                throw error;
            }
        } catch (e) {
            if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
            else throw e;
        }
        while (!doneStreaming)
    }
});
parcelRegister("2uI0R", function(module, exports) {
    $parcel$export(module.exports, "getBufferReader", ()=>$2735314bca0a1e9a$export$f6383c3ea1307da9);
    const $2735314bca0a1e9a$export$f6383c3ea1307da9 = (response)=>{
        if (!response.body) throw new Error('Response body is empty');
        return response.body.pipeThrough(new TextDecoderStream()).getReader();
    };
});
parcelRegister("4c7JV", function(module, exports) {
    $parcel$export(module.exports, "isHumanMessage", ()=>$228fb1e7a583589a$export$a69fab2afb88c2eb);
    $parcel$export(module.exports, "isAssistantMessage", ()=>$228fb1e7a583589a$export$6f965deda7f0960c);
    $parcel$export(module.exports, "isStreamResponse", ()=>$228fb1e7a583589a$export$b4631726cbc1440a);
    $parcel$export(module.exports, "isAgentResponse", ()=>$228fb1e7a583589a$export$a6e5100ca2770191);
    $parcel$export(module.exports, "isStreamError", ()=>$228fb1e7a583589a$export$d422a2733a3b5def);
    $parcel$export(module.exports, "isStreamAUPError", ()=>$228fb1e7a583589a$export$1e1cf807ece63df4);
    $parcel$export(module.exports, "isStreamAnswerPart", ()=>$228fb1e7a583589a$export$e45102edbc73b240);
    $parcel$export(module.exports, "isStreamTrace", ()=>$228fb1e7a583589a$export$fd5a05be03f147a0);
    $parcel$export(module.exports, "isStreamPluginInvocation", ()=>$228fb1e7a583589a$export$51a1b4e474708d74);
    $parcel$export(module.exports, "isFollowUpMessage", ()=>$228fb1e7a583589a$export$aeae5b4fda357302);
    $parcel$export(module.exports, "isChannelNotFoundError", ()=>$228fb1e7a583589a$export$6ce1ccc24e75456f);
    $parcel$export(module.exports, "isRateLimitedError", ()=>$228fb1e7a583589a$export$bc96a6a479480590);
    $parcel$export(module.exports, "isConversationChannelDataMessage", ()=>$228fb1e7a583589a$export$b454081350f4a578);
    var $gRLdW;
    const $228fb1e7a583589a$export$5945515082cc2cbf = 'CONVERSATION_CHANNEL_NOT_FOUND';
    const $228fb1e7a583589a$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
    const $228fb1e7a583589a$export$fb661125ffb29bd6 = (message)=>{
        return $228fb1e7a583589a$export$a69fab2afb88c2eb(message) || $228fb1e7a583589a$export$6f965deda7f0960c(message) || $228fb1e7a583589a$export$b4631726cbc1440a(message);
    };
    const $228fb1e7a583589a$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
    const $228fb1e7a583589a$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
    const $228fb1e7a583589a$export$a6e5100ca2770191 = (message)=>message instanceof Object && $228fb1e7a583589a$export$6f965deda7f0960c(message.message);
    const $228fb1e7a583589a$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
    const $228fb1e7a583589a$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
    const $228fb1e7a583589a$export$1e1cf807ece63df4 = (message)=>$228fb1e7a583589a$export$d422a2733a3b5def(message) && message.message?.message_template === $228fb1e7a583589a$export$c424fe9570a5f2d9;
    const $228fb1e7a583589a$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
    const $228fb1e7a583589a$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
    const $228fb1e7a583589a$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
    const $228fb1e7a583589a$export$821c27cda9a33379 = (message)=>message instanceof Object && message.role === 'PLUGIN_INVOCATION';
    const $228fb1e7a583589a$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
    const $228fb1e7a583589a$export$6ce1ccc24e75456f = (error)=>(0, (0, parcelRequire("gRLdW")).isApiError)(error) && error.errorAttributes?.errorCode === $228fb1e7a583589a$export$5945515082cc2cbf;
    const $228fb1e7a583589a$export$bc96a6a479480590 = (error)=>(0, (0, parcelRequire("gRLdW")).isApiError)(error) && error.errorAttributes.statusCode === 429;
    const $228fb1e7a583589a$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
});
parcelRegister("gRLdW", function(module, exports) {
    $parcel$export(module.exports, "ApiError", ()=>$884e41a84621b493$export$f2e832acab1bdd79);
    $parcel$export(module.exports, "isApiError", ()=>$884e41a84621b493$export$89d83cc97c52a37);
    $parcel$export(module.exports, "mapErrorToApiError", ()=>$884e41a84621b493$export$3c02d1a328d4d808);
    class $884e41a84621b493$export$f2e832acab1bdd79 extends Error {
        constructor(message, errorAttributes){
            super(message), this.message = message, this.errorAttributes = errorAttributes;
        }
    }
    const $884e41a84621b493$export$89d83cc97c52a37 = (error)=>error instanceof $884e41a84621b493$export$f2e832acab1bdd79;
    const $884e41a84621b493$export$3c02d1a328d4d808 = (error)=>{
        if ($884e41a84621b493$export$89d83cc97c52a37(error)) return error;
        return new $884e41a84621b493$export$f2e832acab1bdd79(error.message, {
            statusCode: 0
        });
    };
});
parcelRegister("lb2g6", function(module, exports) {
    $parcel$export(module.exports, "addPath", ()=>$d75893d8e1262208$export$4c25481b843feb0b);
    $parcel$export(module.exports, "getTraceIdFromResponse", ()=>$d75893d8e1262208$export$9f229e40eb65abfc);
    $parcel$export(module.exports, "processResponse", ()=>$d75893d8e1262208$export$21fcb6cfd5628534);
    var $gRLdW;
    const $d75893d8e1262208$export$4c25481b843feb0b = (baseUrl, path)=>{
        const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
        const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
        const url = [
            urlWithTrailingSlash,
            pathWithoutLeadingSlash
        ].join('');
        return url;
    };
    const $d75893d8e1262208$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
    const $d75893d8e1262208$var$processErrorResponse = async ({ response: response })=>{
        let errorCode;
        let outputErrorMessage;
        const responseText = await response.text();
        let rawErrorMessage;
        try {
            const errorBodyJson = JSON.parse(responseText);
            const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage } = errorBodyJson;
            rawErrorMessage = errorMessage ?? error_message;
            if (errors?.length) errorCode = errors[0];
            else if (error_code) errorCode = error_code;
            else errorCode = message_template;
            if (!errorCode || !rawErrorMessage) outputErrorMessage = responseText;
            else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
        } catch (err) {
            outputErrorMessage = responseText;
        }
        throw new (0, (0, parcelRequire("gRLdW")).ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
            errorCode: errorCode,
            statusCode: response.status,
            rawErrorMessage: rawErrorMessage,
            traceId: $d75893d8e1262208$export$9f229e40eb65abfc(response)
        });
    };
    const $d75893d8e1262208$export$21fcb6cfd5628534 = async ({ response: response })=>{
        if (!response.ok || response.status >= 400) await $d75893d8e1262208$var$processErrorResponse({
            response: response
        });
        return response;
    };
});
parcelRegister("khfvG", function(module, exports) {
    $parcel$export(module.exports, "generateConversationName", ()=>$1d5a08981e582a14$export$11cc4786742ed7c2);
    const $1d5a08981e582a14$export$11cc4786742ed7c2 = ()=>{
        const date = new Date();
        const formattedDate = date.toLocaleDateString(undefined, {
            year: '2-digit',
            month: '2-digit',
            day: '2-digit'
        });
        const formattedTime = date.toLocaleTimeString(undefined, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
        const name = `${formattedDate} ${formattedTime}`;
        return name;
    };
});
parcelRegister("3zcGU", function(module, exports) {
    $parcel$export(module.exports, "getId", ()=>$c587188fcee2b8b3$export$218c8c3169c024d2);
    $parcel$export(module.exports, "updatePluginInvocation", ()=>$c587188fcee2b8b3$export$a76cc257b3881cb7);
    $parcel$export(module.exports, "addAnswerPart", ()=>$c587188fcee2b8b3$export$6e5609c05ab74cc7);
    $parcel$export(module.exports, "removeSensitiveData", ()=>$c587188fcee2b8b3$export$efd4f6b5d168b654);
    $parcel$export(module.exports, "createHumanMessage", ()=>$c587188fcee2b8b3$export$4010f996e89e886a);
    $parcel$export(module.exports, "toStreamResponse", ()=>$c587188fcee2b8b3$export$3220a4ff7b3a96df);
    var $4c7JV;
    const $c587188fcee2b8b3$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
    const $c587188fcee2b8b3$var$updatePluginInvocationAssistantMessage = (response, streamPluginInvocation)=>{
        const { message: pluginInvocation } = streamPluginInvocation;
        const pluginInvocationMessage = {
            message_id: response.id,
            ...pluginInvocation
        };
        const updatedMessage = {
            ...response
        };
        const updatedPluginInvocations = [
            ...updatedMessage.plugin_invocations
        ];
        const currentIndex = updatedPluginInvocations.findIndex((pi)=>pi.plugin_name === pluginInvocationMessage.plugin_name);
        if (currentIndex === -1) updatedPluginInvocations.push(pluginInvocationMessage);
        else updatedPluginInvocations[currentIndex] = pluginInvocationMessage;
        updatedMessage.plugin_invocations = updatedPluginInvocations;
        return updatedMessage;
    };
    const $c587188fcee2b8b3$var$updatePluginInvocationAgentResponse = (response, streamPluginInvocation)=>({
            ...response,
            message: $c587188fcee2b8b3$var$updatePluginInvocationAssistantMessage(response.message, streamPluginInvocation)
        });
    const $c587188fcee2b8b3$export$a76cc257b3881cb7 = (response, streamPluginInvocation)=>({
            ...response,
            message: $c587188fcee2b8b3$var$updatePluginInvocationAgentResponse(response.message, streamPluginInvocation)
        });
    const $c587188fcee2b8b3$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
        const content = `${response.content}${answerPart.message.content}`;
        const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
        return {
            ...response,
            content: cleanedContent
        };
    };
    const $c587188fcee2b8b3$var$addAnswerPartAgentResponse = (response, answerPart)=>({
            ...response,
            message: $c587188fcee2b8b3$var$addAnswerPartAssistantMessage(response.message, answerPart)
        });
    const $c587188fcee2b8b3$export$6e5609c05ab74cc7 = (response, answerPart)=>({
            ...response,
            message: $c587188fcee2b8b3$var$addAnswerPartAgentResponse(response.message, answerPart)
        });
    const $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage = (message)=>{
        const { plugin_invocations: plugin_invocations, ...rest } = message;
        return {
            ...rest,
            plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                    ...pluginInvocation,
                    plugin_output: '--PRIVATE--'
                }))
        };
    };
    const $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse = (message)=>({
            ...message,
            message: $c587188fcee2b8b3$var$removeSensitiveDataAssistantMessage(message.message)
        });
    const $c587188fcee2b8b3$export$efd4f6b5d168b654 = (message)=>({
            ...message,
            message: $c587188fcee2b8b3$var$removeSensitiveDataAgentResponse(message.message)
        });
    const $c587188fcee2b8b3$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId)=>{
        return {
            role: 'HUMAN',
            id: id,
            content: content,
            time_created: new Date().toISOString(),
            user_ari: 'unknown',
            plugin_invocations: [],
            isFromSeededConversation: isFromSeededConversation,
            requestId: requestId
        };
    };
    const $c587188fcee2b8b3$export$3220a4ff7b3a96df = (message)=>{
        if ((0, (0, parcelRequire("4c7JV")).isAgentResponse)(message)) return {
            type: 'FINAL_RESPONSE',
            message: message
        };
        return {
            type: 'FINAL_RESPONSE',
            message: {
                message: message
            }
        };
    };
    const $c587188fcee2b8b3$export$6304914e90dcefe0 = ()=>({
            account_id: '',
            cloud_id: '',
            env: '',
            env_type: '',
            model: '',
            ai_enabled_on_site: false,
            assistance_feature_enabled: false,
            debug_enabled: false
        });
});
parcelRegister("f7UWp", function(module, exports) {
    $parcel$export(module.exports, "fetchFn", ()=>$083f568d1e8b8dc8$export$10f0d162cb6dae7c);
    const $083f568d1e8b8dc8$export$10f0d162cb6dae7c = window.fetch;
});
parcelRegister("cDP7F", function(module, exports) {
    $parcel$export(module.exports, "useStreamingMutation", ()=>$7f63acfa30174b63$export$b77e002f54aed840);
    var $5uXOq = parcelRequire("5uXOq");
    var $gRLdW;
    const $7f63acfa30174b63$export$b77e002f54aed840 = ({ mutationFn: mutationFn, onChunkReceived: onChunkReceived, onSuccess: onSuccess, onError: onError })=>{
        const mutationFnRef = (0, $5uXOq.useRef)(mutationFn);
        mutationFnRef.current = mutationFn;
        const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
        onSuccessRef.current = onSuccess;
        const onErrorRef = (0, $5uXOq.useRef)(onError);
        onErrorRef.current = onError;
        const onChunkReceivedRef = (0, $5uXOq.useRef)(onChunkReceived);
        onChunkReceivedRef.current = onChunkReceived;
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [isMutating, setIsMutating] = (0, $5uXOq.useState)(false);
        const mutate = (0, $5uXOq.useCallback)(async (payload)=>{
            setIsMutating(true);
            try {
                const generator = await mutationFnRef.current(payload);
                for await (const chunk of generator)onChunkReceivedRef.current?.(chunk);
                onSuccessRef.current?.();
            } catch (error) {
                const apiError = (0, (0, parcelRequire("gRLdW")).mapErrorToApiError)(error);
                setError(apiError);
                onErrorRef.current?.(apiError);
            } finally{
                setIsMutating(false);
            }
        }, []);
        return {
            error: error,
            isMutating: isMutating,
            mutate: mutate
        };
    };
});
parcelRegister("gCBI2", function(module, exports) {
    $parcel$export(module.exports, "getDummySuggestions", ()=>$3299cee080af9963$export$f317c01730aa6ce0);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $1DVhQ;
    var $i5rn1;
    const $3299cee080af9963$export$f317c01730aa6ce0 = (agent, length = 3)=>{
        return new Array(length).fill(null).map((_, index)=>{
            return {
                value: `agent:${agent.id}:${(0, ($parcel$interopDefault($7Jxgt)))()}:dummy`,
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                    width: `${index % 2 !== 0 ? 205 : 180}px`,
                    height: "18px",
                    borderRadius: 2,
                    isShimmering: true
                }),
                icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5rn1")).RovoAgentIcon), {
                    label: '',
                    excludeOverlay: true,
                    size: "large",
                    width: 32,
                    height: 32,
                    primaryColor: `var(--ds-skeleton, ${(0, $829f609a65d26a98$export$8d43898f60b96a82)})`
                }),
                groupHeading: '',
                onSelect: ()=>{},
                onSuggestionFocused: ()=>{}
            };
        });
    };
});
parcelRegister("1DVhQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d4b6b583e25d0959$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $d4b6b583e25d0959$var$shimmerKeyframes = null;
    const $d4b6b583e25d0959$var$skeletonStyles = null;
    const $d4b6b583e25d0959$var$activeShimmerStyles = null;
    const $d4b6b583e25d0959$var$Skeleton = ({ width: width, height: height, borderRadius: borderRadius = '100px', color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, testId: testId })=>{
        const groupDataAttribute = groupName && `data-${groupName}`;
        return $5uXOq.createElement("div", {
            "data-testid": testId,
            style: {
                width: width,
                height: height,
                borderRadius: borderRadius,
                backgroundColor: color,
                '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
                '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
            },
            ...groupDataAttribute && {
                [groupDataAttribute]: 'true'
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
                isShimmering && "",
                isShimmering && "_j7hq1y0p"
            ])
        });
    };
    var $d4b6b583e25d0959$export$2e2bcd8739ae039 = $d4b6b583e25d0959$var$Skeleton;
});
parcelRegister("i5rn1", function(module, exports) {
    $parcel$export(module.exports, "RovoAgentIcon", ()=>$193730efdc9c1dad$export$e331edd80bbc26a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $dC5iT;
    var $8CUq3;
    const $193730efdc9c1dad$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginInline: 'space.050',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    });
    const $193730efdc9c1dad$var$CustomGlyph = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "23",
            height: "26",
            viewBox: "0 0 23 26",
            fill: "none",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M10.512 1.06137C11.1247 0.713259 11.8753 0.713259 12.488 1.06137L21.488 6.17501C22.1136 6.53043 22.5 7.19446 22.5 7.91392V18.0861C22.5 18.8055 22.1136 19.4696 21.488 19.825L12.488 24.9386C11.8753 25.2867 11.1247 25.2867 10.512 24.9386L1.51198 19.825C0.886437 19.4696 0.5 18.8055 0.5 18.0861V7.91392C0.5 7.19446 0.886437 6.53043 1.51198 6.17501L10.512 1.06137Z",
            fill: props.primaryColor || '#0C66E4'
        }), !props.primaryColor && !props.excludeOverlay && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.3711 9.12845C15.7263 9.30173 16.1726 9.00581 16.3843 9.37104C16.1136 9.2564 16.1496 10.7306 16.5959 10.3814C16.6497 10.1521 16.7793 10.1801 16.551 10.1015C16.9344 10.0988 16.5779 9.84556 16.5907 9.80957C16.7998 9.80424 16.5266 9.68161 16.7254 9.72427C16.8408 9.70027 16.5035 9.39637 16.7318 9.47768C16.8049 9.14711 17.1615 9.14976 17.0819 8.94849C17.0858 9.08578 18.2708 9.11778 17.9425 8.59261C17.7347 8.60328 17.7617 8.36068 17.7309 8.67659C17.668 8.28471 17.5283 8.67658 17.4949 8.66725C17.4641 8.44731 17.4026 8.75122 17.4115 8.53662C17.3808 8.42066 17.1807 8.79121 17.2204 8.54861C16.5292 8.36067 17.096 8.15807 16.6972 7.75019C16.6574 7.56092 16.7549 6.94644 16.3278 7.00376C15.7661 7.17171 16.4214 8.22072 16.088 8.40333C15.9392 8.54195 15.7276 8.71656 15.4467 8.59793C15.3082 8.59527 15.13 9.1831 15.3698 9.12979L15.3711 9.12845Z",
            fill: "#579DFF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3218 15.6931L14.5291 14.9004C12.9326 16.1142 11.4765 17.4318 10.1783 18.8662C8.3402 17.3566 6.68445 15.6005 5.18662 13.6303L11.4518 7.36515C12.9665 10.1168 15.0426 12.0855 17.5196 13.4953L15.3218 15.6931ZM10.7452 13.7518L10.7452 15.6016L10.7454 15.6016L11.6857 15.6016L11.6857 13.7518L13.4285 13.7518L11.2154 11.5387L9.00236 13.7518L10.7452 13.7518ZM14.5291 14.9007L15.3217 15.6934L11.2855 19.7296C10.9092 19.4518 10.5403 19.1639 10.1783 18.8665C11.4764 17.4323 12.9325 16.1146 14.5291 14.9007Z",
            fill: "#CCE0FF"
        })));
    };
    const $193730efdc9c1dad$var$CustomIcon = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: (glyphProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($193730efdc9c1dad$var$CustomGlyph, {
                    ...props,
                    ...glyphProps
                }),
            ...props
        });
    };
    const $193730efdc9c1dad$export$e331edd80bbc26a2 = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $193730efdc9c1dad$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($193730efdc9c1dad$var$CustomIcon, props));
    };
});
parcelRegister("2Jlja", function(module, exports) {
    $parcel$export(module.exports, "useEngagementPlatformAnnouncementBanner", ()=>$6d7cf1df838995e1$export$a1cbeeef2ea2e5f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $hPYLK;
    function $6d7cf1df838995e1$export$a1cbeeef2ea2e5f5(messageId, text) {
        const { stopMessage: stopMessage, startMessage: startMessage } = (0, (0, parcelRequire("hPYLK")).useEngagementPlatform)();
        const [isStarted, setIsStarted] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            startMessage(messageId).then((isStarted)=>{
                setIsStarted(isStarted);
            });
        }, [
            messageId,
            startMessage
        ]);
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            setIsStarted(false);
            stopMessage(messageId);
        }, [
            messageId,
            stopMessage
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (isStarted) return {
                id: messageId,
                text: text,
                onClose: handleClose
            };
            return undefined;
        }, [
            messageId,
            text,
            handleClose,
            isStarted
        ]);
    }
});
parcelRegister("hPYLK", function(module, exports) {
    $parcel$export(module.exports, "useEngagementPlatform", ()=>$daa9de0a7ea4ddb1$export$f8e8298e44ec1284);
    var $8Oaok;
    function $daa9de0a7ea4ddb1$export$f8e8298e44ec1284() {
        const { engagementPlatformApi: engagementPlatformApi } = (0, (0, parcelRequire("8Oaok")).useAIExperienceCommonDataContext)();
        if (!engagementPlatformApi) return {
            startMessage: ()=>{
                return Promise.resolve(false);
            },
            stopMessage: ()=>{
                return Promise.resolve(false);
            }
        };
        return engagementPlatformApi;
    }
});
parcelRegister("2nhuY", function(module, exports) {
    $parcel$export(module.exports, "mapLoadingStatusToMessageTemplate", ()=>$85e74d8dbea615c8$export$1e9814631e2193d4);
    var $6KJH7;
    const $85e74d8dbea615c8$export$1e9814631e2193d4 = (messageTemplate)=>{
        switch(messageTemplate){
            case 'ANALYSING_QUERY':
                return (0, (0, parcelRequire("6KJH7")).messages).messageTemplateAnalysingQuery;
            case 'CONTENT_SEARCH':
                return (0, (0, parcelRequire("6KJH7")).messages).messageTemplateContentSearch;
            case 'PAGE_HYDRATION':
                return (0, (0, parcelRequire("6KJH7")).messages).messageTemplatePageHydration;
            case 'NEXT_BEST_TASK':
                return (0, (0, parcelRequire("6KJH7")).messages).messageTemplateNextBestTask;
            case 'WRITING':
                return (0, (0, parcelRequire("6KJH7")).messages).loadingTitle;
            default:
                return;
        }
    };
});
parcelRegister("3a2e3", function(module, exports) {
    $parcel$export(module.exports, "useAIExperienceService", ()=>$252a11e691afcafb$export$519bc24a166a4cfd);
    var $5uXOq = parcelRequire("5uXOq");
    var $gNFqi;
    var $h8K4u;
    function $252a11e691afcafb$export$519bc24a166a4cfd(options) {
        const machineRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        if (machineRef.current === null) machineRef.current = (0, (0, parcelRequire("h8K4u")).createAIExperienceMachine)(options);
        const [state, send] = (0, (0, parcelRequire("gNFqi")).useMachine)(machineRef.current);
        return {
            state: state.value,
            context: state.context,
            send: send
        };
    }
});
parcelRegister("h8K4u", function(module, exports) {
    $parcel$export(module.exports, "createAIExperienceMachine", ()=>$f71da0b1215263bc$export$d89ac572d9ca416a);
    var $dD9J4;
    var $g2PT9;
    var $eOdbG;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $8AE4L;
    var $hjzKw;
    function $f71da0b1215263bc$export$d89ac572d9ca416a(options) {
        const machine = (0, (0, parcelRequire("eOdbG")).createMachine)({
            id: 'AI Experience Machine',
            initial: 'started state',
            states: {
                'started state': {
                    on: {
                        'kick off': [
                            {
                                target: 'modal active state.experience.loading state',
                                cond: 'neither base generate nor custom prompt'
                            },
                            '#AI Experience Machine.modal active state.experience.command palette state'
                        ]
                    }
                },
                'modal active state': {
                    type: 'parallel',
                    on: {
                        escape: {
                            target: '#AI Experience Machine.modal active state.discard.active'
                        },
                        storeContextStatistics: {
                            actions: 'storeContextStatistics'
                        }
                    },
                    states: {
                        experience: {
                            states: {
                                'loading state': {
                                    on: {
                                        complete: {
                                            target: 'review state',
                                            actions: [
                                                'pushToHistory',
                                                'updateMarkdown',
                                                'clearUserInput',
                                                'updateRovoActions'
                                            ]
                                        },
                                        error: {
                                            target: '#error state.active'
                                        },
                                        'same cache key': {
                                            target: 'review state',
                                            actions: [
                                                'restoreResponseFromHistory',
                                                'clearUserInput'
                                            ]
                                        }
                                    },
                                    states: {
                                        loading: {
                                            invoke: {
                                                src: (0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test') ? (0, (0, parcelRequire("hjzKw")).streamingServiceAIButton) : (0, (0, parcelRequire("hjzKw")).streamingService)
                                            },
                                            on: {
                                                stream: {
                                                    target: 'loading',
                                                    internal: true,
                                                    actions: [
                                                        'updateMarkdown',
                                                        'updateLoadingStatus'
                                                    ]
                                                },
                                                'handle additional prompts': {
                                                    target: 'loading',
                                                    internal: true,
                                                    actions: [
                                                        'updateAdditionalPrompts'
                                                    ]
                                                },
                                                'update idMap': {
                                                    target: 'loading',
                                                    internal: true,
                                                    actions: 'updateIdMap'
                                                },
                                                error: {
                                                    target: '#error state.active'
                                                },
                                                'response too similar': {
                                                    target: '#AI Experience Machine.modal active state.experience.review state',
                                                    actions: [
                                                        'pushToHistory',
                                                        'clearUserInput'
                                                    ]
                                                }
                                            }
                                        }
                                    },
                                    initial: 'loading',
                                    entry: [
                                        'setLatestPrompt',
                                        'updateChannelId'
                                    ],
                                    exit: 'clearLoadingStatus'
                                },
                                'review state': {
                                    on: {
                                        'handle additional prompts': {
                                            target: 'review state',
                                            actions: [
                                                'updateAdditionalPrompts'
                                            ]
                                        },
                                        interrogate: {
                                            target: 'loading state',
                                            actions: [
                                                'clearFromHistory',
                                                'updatePromptContextBasedOnTrigger',
                                                'interrogate'
                                            ]
                                        },
                                        refine: {
                                            target: 'loading state',
                                            actions: [
                                                'clearFromHistory',
                                                'updatePromptContextBasedOnTrigger',
                                                'incrementRefinementCount',
                                                'refine'
                                            ]
                                        },
                                        error: {
                                            target: '#error state.active'
                                        },
                                        'retry prompt': {
                                            target: 'loading state',
                                            actions: [
                                                'updatePromptContextBasedOnTrigger',
                                                'updateUserInput',
                                                'updateUserInputADF',
                                                'clearMarkdown',
                                                'incrementRetryPromptCount',
                                                'clearFromHistory'
                                            ]
                                        },
                                        'edit prompt': {
                                            target: 'command palette state',
                                            actions: [
                                                'editPrompt',
                                                'clearFromHistory'
                                            ]
                                        },
                                        'traverse history': {
                                            target: 'review state',
                                            actions: [
                                                'traverseHistory'
                                            ]
                                        },
                                        'feedback submitted': {
                                            target: 'review state',
                                            actions: [
                                                'feedbackSubmitted'
                                            ]
                                        }
                                    },
                                    states: {
                                        preview: {
                                            on: {
                                                'start refinement': 'refinement'
                                            }
                                        },
                                        refinement: {
                                            on: {
                                                'cancel refinement': {
                                                    target: '#AI Experience Machine.modal active state.discard.active',
                                                    actions: [
                                                        'clearUserInput',
                                                        'clearFocus'
                                                    ]
                                                },
                                                'update user input': {
                                                    internal: true,
                                                    actions: 'updateUserInput'
                                                },
                                                'update user input adf': {
                                                    internal: true,
                                                    actions: 'updateUserInputADF'
                                                }
                                            }
                                        }
                                    },
                                    initial: 'preview'
                                },
                                'command palette state': {
                                    on: {
                                        'kickoff with command palette input': {
                                            target: 'loading state',
                                            actions: [
                                                'updatePromptContextBasedOnTrigger',
                                                'updateContext',
                                                'resetRefinementCount'
                                            ]
                                        },
                                        'update context': {
                                            target: 'command palette state',
                                            internal: true,
                                            actions: [
                                                'updateContext'
                                            ],
                                            description: `This must be called before 'cancel' transition to make sure the context is updated before the 'if command input is empty' guard is evaluated.`
                                        },
                                        cancel: [
                                            {
                                                cond: 'if command input is empty',
                                                target: 'command palette state',
                                                internal: true,
                                                actions: 'endExperience'
                                            },
                                            '#AI Experience Machine.modal active state.discard.active'
                                        ]
                                    },
                                    description: `This state creates a nested state machine that handles all the state of the command palette.

  It needs to know the 'userInput', 'baseGenerate' and 'configItem' from the AI Experience State Machine.

  Whenever we exit this state we need to update the AI Experience State Machine's context with the 'updateContext' action.`
                                },
                                'error state': {
                                    id: 'error state',
                                    initial: 'inactive',
                                    states: {
                                        inactive: {},
                                        active: {
                                            entry: [
                                                'updateContext',
                                                'storeFailureContext',
                                                'clearLoadingStatus'
                                            ],
                                            exit: [
                                                'clearFailureContext'
                                            ],
                                            on: {
                                                retry: {
                                                    target: '#AI Experience Machine.modal active state.experience.loading state.loading'
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        },
                        discard: {
                            initial: 'inactive',
                            states: {
                                inactive: {
                                    on: {
                                        'enable discard': {
                                            target: 'active',
                                            actions: 'updateContext'
                                        }
                                    }
                                },
                                active: {
                                    on: {
                                        'disable discard': {
                                            target: 'inactive',
                                            actions: 'updateContext'
                                        },
                                        escape: 'inactive'
                                    }
                                }
                            }
                        }
                    }
                }
            },
            schema: {
                events: {}
            },
            context: options.context,
            on: {
                'update positions': {
                    internal: true,
                    actions: 'updatePositions'
                }
            }
        }, {
            actions: {
                updatePositions: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'update positions') return {};
                    return {
                        positions: event.positions
                    };
                }),
                storeFailureContext: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if ([
                        'error'
                    ].includes(event.type) && 'errorInfo' in event) return {
                        apiErrorInfo: event.errorInfo
                    };
                    return {};
                }),
                clearFailureContext: (0, (0, parcelRequire("g2PT9")).assign)(()=>{
                    return {
                        apiErrorInfo: {}
                    };
                }),
                updateMarkdown: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'stream' && event.type !== 'complete') return {};
                    return {
                        markdown: event.markdown,
                        fragment: event.fragment,
                        feedbackSubmitted: undefined
                    };
                }),
                updateAdditionalPrompts: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'stream' && event.type !== 'handle additional prompts') return {};
                    const responseInHistory = context.responseHistory.entries[0];
                    const updatedHistoryEvent = {
                        ...responseInHistory,
                        multiPrompts: event.multiPrompts
                    };
                    return {
                        ...responseInHistory && {
                            responseHistory: {
                                entries: [
                                    updatedHistoryEvent
                                ],
                                positionFromEnd: 0
                            }
                        },
                        multiPrompts: event.multiPrompts
                    };
                }),
                updateLoadingStatus: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'stream') return {};
                    if (event.loadingStatus === '') return {
                        loadingStatus: undefined
                    };
                    return {
                        loadingStatus: event.loadingStatus
                    };
                }),
                clearLoadingStatus: (0, (0, parcelRequire("g2PT9")).assign)(()=>{
                    return {
                        loadingStatus: undefined
                    };
                }),
                storeContextStatistics: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type === 'storeContextStatistics') return {
                        contextStatistics: event.contextStatistics
                    };
                    return {};
                }),
                clearMarkdown: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'retry prompt') return {};
                    return {
                        markdown: undefined,
                        idMap: undefined
                    };
                }),
                interrogate: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type !== 'interrogate') return {};
                    return {
                        markdown: '',
                        configItem: (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true) && _context.configItem.key !== (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ROVO_AGENT ? _context.baseGenerate : _context.configItem,
                        userInput: event.userInput,
                        userADFInput: event.userADFInput,
                        latestPromptResponse: event.latestPromptResponse
                    };
                }),
                refine: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type !== 'refine') return {};
                    return {
                        markdown: '',
                        configItem: event.configItem,
                        latestPromptResponse: event.latestPromptResponse
                    };
                }),
                clearUserInput: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    return {
                        userInput: '',
                        userADFInput: undefined
                    };
                }),
                updateUserInput: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'update user input' && event.type !== 'retry prompt') return {};
                    return {
                        userInput: event.input
                    };
                }),
                updateUserInputADF: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'update user input adf' && event.type !== 'retry prompt') return {};
                    return {
                        userADFInput: event.adf
                    };
                }),
                updateRovoActions: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'complete') return {};
                    if (!event.rovoActions?.length || !context.configItem.agent) return {
                        rovoActions: {}
                    };
                    return {
                        rovoActions: event.rovoActions.reduce((prevValue, currentValue)=>{
                            const key = currentValue.data.suggestion === 'insert' ? 'empty' : 'range';
                            prevValue[key] = currentValue.data;
                            return prevValue;
                        }, {})
                    };
                }),
                feedbackSubmitted: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type !== 'feedback submitted') return {};
                    return {
                        feedbackSubmitted: event.sentiment
                    };
                }),
                pushToHistory: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'complete' && event.type !== 'response too similar') return {};
                    const { cacheKey: cacheKey } = event;
                    const entries = context.responseHistory.entries;
                    if (entries.length > 0 && entries[entries.length - 1].cacheKey === cacheKey) return {};
                    let historyEvent;
                    if (event.type === 'complete') historyEvent = {
                        userInput: context.userInput || '',
                        userADFInput: context.userADFInput,
                        configItem: context.configItem,
                        markdown: event.markdown,
                        cacheKey: cacheKey,
                        modelInput: event.modelInput,
                        inputOutputDiffRatio: event.inputOutputDiffRatio,
                        latestPrompt: context.latestPrompt
                    };
                    if (event.type === 'response too similar') historyEvent = {
                        userInput: context.userInput || '',
                        userADFInput: context.userADFInput,
                        configItem: context.configItem,
                        markdown: '',
                        responseTooSimilar: true,
                        cacheKey: cacheKey,
                        modelInput: event.modelInput,
                        inputOutputDiffRatio: event.inputOutputDiffRatio,
                        latestPrompt: context.latestPrompt
                    };
                    if (!historyEvent) return {};
                    const historyEventSize = new Blob([
                        JSON.stringify(historyEvent)
                    ]).size;
                    const totalSize = context.responseHistory.totalSize + historyEventSize;
                    const updatedEntries = [
                        ...entries,
                        historyEvent
                    ];
                    if (updatedEntries.length > 10) updatedEntries.shift();
                    return {
                        responseHistory: {
                            entries: updatedEntries,
                            positionFromEnd: 0,
                            totalSize: totalSize,
                            traversals: context.responseHistory.traversals
                        }
                    };
                }),
                traverseHistory: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type === 'traverse history' && (0, $gmhCD.editorExperiment)('platform_editor_ai_response_history', true)) {
                        const { entries: entries, positionFromEnd: positionFromEnd } = context.responseHistory;
                        let updatedPositionFromEnd = positionFromEnd;
                        switch(event.direction){
                            case 'back':
                                updatedPositionFromEnd += 1;
                                break;
                            case 'forward':
                                updatedPositionFromEnd -= 1;
                                break;
                            case 'reset':
                                updatedPositionFromEnd = 0;
                                break;
                        }
                        const newPosition = entries.length - updatedPositionFromEnd - 1;
                        if (newPosition < 0 || newPosition >= entries.length) return {};
                        return {
                            responseHistory: {
                                entries: entries,
                                positionFromEnd: updatedPositionFromEnd,
                                totalSize: context.responseHistory.totalSize,
                                traversals: context.responseHistory.traversals + 1
                            },
                            markdown: entries[newPosition].markdown,
                            configItem: entries[newPosition].configItem,
                            latestPromptResponse: entries[newPosition].markdown,
                            latestPrompt: entries[newPosition].latestPrompt
                        };
                    }
                    return {};
                }),
                restoreResponseFromHistory: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'same cache key') return {};
                    const { entries: entries } = context.responseHistory;
                    const historyEvent = entries[0];
                    if (!historyEvent) return {};
                    return {
                        userInput: historyEvent.userInput,
                        userADFInput: historyEvent.userADFInput,
                        markdown: historyEvent.markdown,
                        configItem: historyEvent.configItem,
                        latestPromptResponse: historyEvent.markdown,
                        multiPrompts: historyEvent.multiPrompts
                    };
                }),
                clearFromHistory: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type !== 'retry prompt' && event.type !== 'interrogate' && event.type !== 'refine' && !(0, $gmhCD.editorExperiment)('platform_editor_ai_response_history', true) && !(0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true)) return {};
                    if (event.type !== 'edit prompt' && ((0, $gmhCD.editorExperiment)('platform_editor_ai_response_history', true) || (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true))) return {};
                    return {
                        responseHistory: {
                            entries: [],
                            positionFromEnd: 0,
                            totalSize: 0,
                            traversals: 0
                        }
                    };
                }),
                setLatestPrompt: (0, (0, parcelRequire("dD9J4")).actions).choose([
                    {
                        cond: 'is base generate',
                        actions: (0, (0, parcelRequire("g2PT9")).assign)((context)=>({
                                latestPrompt: {
                                    userInput: context?.userInput || '',
                                    userADFInput: context?.userADFInput
                                }
                            }))
                    },
                    {
                        cond: 'has custom prompt',
                        actions: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>({
                                latestPrompt: {
                                    ...event.type !== 'interrogate' && event.type !== 'refine' && {
                                        presetTitle: context.configItem
                                    },
                                    userInput: context?.userInput || '',
                                    userADFInput: context?.userADFInput
                                }
                            }))
                    },
                    {
                        actions: (0, (0, parcelRequire("g2PT9")).assign)((context)=>context?.userInput ? {
                                latestPrompt: {
                                    userInput: context?.userInput || '',
                                    userADFInput: context?.userADFInput
                                }
                            } : {
                                latestPrompt: {
                                    presetTitle: context.configItem
                                }
                            })
                    }
                ]),
                clearFocus: ()=>{
                    document.activeElement?.blur();
                },
                endExperience: ()=>{
                    options.endExperience();
                },
                updateContext: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type === 'kickoff with command palette input' || event.type === 'update context' || event.type === 'enable discard') return {
                        ...event.context,
                        multiPrompts: undefined
                    };
                    if (event.type === 'disable discard') return {
                        onceDiscard: undefined,
                        multiPrompts: undefined
                    };
                    return {};
                }),
                updateChannelId: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    const { aiProvider: aiProvider, configItem: configItem } = context;
                    if (!aiProvider.getChannelVariables || !configItem.agent) return {
                        channelId: undefined,
                        previousAgentId: undefined
                    };
                    if (configItem.agent.id === context.previousAgentId) return {};
                    return {
                        channelId: (0, (0, parcelRequire("8AE4L")).buildChannelId)(),
                        previousAgentId: configItem.agent.id
                    };
                }),
                updateIdMap: (0, (0, parcelRequire("g2PT9")).assign)((context, event)=>{
                    if (event.type === 'update idMap') {
                        if (!context.idMap || event.context.selectionType === 'empty') return {
                            idMap: {
                                ...event.context.idMap
                            }
                        };
                        if (event.context.selectionType === 'range') {
                            if (event.context.idMap) {
                                const incomingIdMapIsUserSelection = event.context.idMap && Object.keys(event.context.idMap).length <= Object.keys(context.idMap).length;
                                if (incomingIdMapIsUserSelection) return {
                                    idMap: {
                                        ...event.context.idMap
                                    }
                                };
                            }
                        }
                        return {
                            idMap: {
                                ...context.idMap
                            }
                        };
                    }
                    return {};
                }),
                editPrompt: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                    if (event.type !== 'edit prompt') return {};
                    const isBaseGenerate = _context.configItem.title === _context.baseGenerate?.title;
                    const hasCustomPrompt = _context.configItem.promptLabel !== undefined;
                    const isPresetPrompt = !isBaseGenerate && !hasCustomPrompt;
                    let configItem = _context.configItem;
                    const isSubmenuSelected = Boolean(_context.parentPresetPromptLabel);
                    const isDefaultAgent = Boolean(_context.configItem.agent?.isDefault);
                    const resetConfigItem = (isPresetPrompt || isDefaultAgent) && !isSubmenuSelected;
                    const resetUserInput = (isPresetPrompt || isSubmenuSelected) && !isDefaultAgent;
                    if (resetConfigItem && _context.baseGenerate) configItem = _context.baseGenerate;
                    return {
                        markdown: undefined,
                        userInput: resetUserInput ? undefined : event.userInput,
                        userADFInput: resetUserInput ? undefined : event.userADFInput,
                        presetTitle: resetUserInput ? undefined : event.presetTitle,
                        configItem: configItem,
                        latestPromptResponse: undefined,
                        editCount: _context.editCount + 1,
                        idMap: undefined
                    };
                }),
                incrementRetryPromptCount: (0, (0, parcelRequire("g2PT9")).assign)((context, _event)=>{
                    return {
                        retryPromptCount: context.retryPromptCount + 1
                    };
                }),
                incrementRefinementCount: (0, (0, parcelRequire("g2PT9")).assign)((context, _event)=>{
                    return {
                        refinementCount: context.refinementCount + 1
                    };
                }),
                resetRefinementCount: (0, (0, parcelRequire("g2PT9")).assign)((_context, _event)=>{
                    return {
                        refinementCount: 0
                    };
                }),
                updatePromptContextBasedOnTrigger: (0, (0, parcelRequire("dD9J4")).actions).choose([
                    {
                        actions: (0, (0, parcelRequire("g2PT9")).assign)((_context, event)=>{
                            if (event.type === 'interrogate') return {
                                promptTrigger: 'interrogate',
                                latestPromptRetried: false
                            };
                            if (event.type === 'refine') return {
                                promptTrigger: 'refinementButton',
                                latestPromptRetried: false
                            };
                            if (event.type === 'retry prompt') return {
                                latestPromptRetried: true
                            };
                            if (event.type === 'kickoff with command palette input') return {
                                promptTrigger: 'generate',
                                latestPromptRetried: false
                            };
                            return {};
                        })
                    }
                ])
            },
            guards: {
                ['has custom prompt']: (context, event)=>{
                    const isDefaultAgent = Boolean(context.configItem.agent?.isDefault);
                    if (isDefaultAgent) return false;
                    return context.configItem.promptLabel !== undefined;
                },
                ['is base generate']: (context, event)=>{
                    return context.configItem.title === context.baseGenerate?.title;
                },
                ['neither base generate nor custom prompt']: (context, event)=>{
                    const isBaseGenerate = context.configItem.title === context.baseGenerate?.title;
                    const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                    return !isBaseGenerate && !hasCustomPrompt;
                },
                ['if command input is empty']: (context, event)=>{
                    return context.userInput?.trim?.()?.length === 0;
                }
            }
        });
        return machine;
    }
});
parcelRegister("8AE4L", function(module, exports) {
    $parcel$export(module.exports, "buildChannelId", ()=>$58c2b8b4b1ddaa9d$export$4d16f4ec9dad8b6b);
    var $bXrHm = parcelRequire("bXrHm");
    const $58c2b8b4b1ddaa9d$export$4d16f4ec9dad8b6b = ()=>{
        return (0, ($parcel$interopDefault($bXrHm)))();
    };
});
parcelRegister("hjzKw", function(module, exports) {
    $parcel$export(module.exports, "streamingService", ()=>$27fd26f30ad84b78$export$b523ed22ab6d4165);
    $parcel$export(module.exports, "streamingServiceAIButton", ()=>$27fd26f30ad84b78$export$a30339257af76396);
    var $kCV8T;
    var $gmhCD = parcelRequire("gmhCD");
    var $3n50y;
    var $eUFkl;
    var $PwAM5;
    var $9YAmQ;
    var $48T0b;
    function $27fd26f30ad84b78$export$b523ed22ab6d4165(context, event) {
        async function callbackHandler(callback) {
            const abortController = new AbortController();
            let configItemToUse = context.configItem;
            if (!(0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true)) {
                if (context.baseGenerate && context.latestPromptResponse) configItemToUse = context.configItem && context.configItem.key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ROVO_AGENT ? context.configItem : context.baseGenerate;
            }
            let mentionMap = {};
            if (context.getMentionNameDetails) mentionMap = await (0, (0, parcelRequire("9YAmQ")).getMentionMap)({
                node: context.editorView.state.doc,
                getMentionNameDetails: context.getMentionNameDetails
            });
            const initialContext = configItemToUse.getInitialContext?.({
                editorView: context.editorView,
                positions: context.positions,
                intl: context.intl,
                updateIdMap: ({ idMap: idMap, selectionType: selectionType })=>{
                    callback({
                        type: 'update idMap',
                        context: {
                            idMap: idMap,
                            selectionType: selectionType
                        }
                    });
                },
                mentionMap: mentionMap
            });
            if (initialContext?.contentStatistics) callback({
                type: 'storeContextStatistics',
                contextStatistics: {
                    inputDocument: initialContext.contentStatistics
                }
            });
            if (!initialContext) throw new Error('Initial context is undefined');
            const promptRequest = configItemToUse.triggerPromptRequest({
                analyticsContext: context.analyticsContext,
                initialContext: initialContext,
                promptInput: context.userInput,
                promptInputADF: context.userADFInput,
                latestPromptResponse: context.latestPromptResponse || undefined,
                formatMessage: context.intl.formatMessage,
                editorSchema: context.editorView.state.schema
            });
            const cacheKey = JSON.stringify({
                initialContext: initialContext,
                userInput: context.userInput,
                agent: context.configItem.agent,
                multiPrompt: context.multiPrompts
            });
            const lastHistoryItem = context.responseHistory.entries[0];
            if (lastHistoryItem && cacheKey === lastHistoryItem.cacheKey) {
                callback({
                    type: 'same cache key'
                });
                return;
            }
            const streaming = promptRequest({
                abortController: abortController,
                generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                product: context.aiProvider.product,
                getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                channelId: context.channelId
            });
            const additionalPromptRequest = configItemToUse.additionalTriggerPromptRequest?.({
                analyticsContext: context.analyticsContext,
                initialContext: initialContext,
                promptInput: context.userInput,
                promptInputADF: context.userADFInput,
                latestPromptResponse: context.latestPromptResponse || undefined,
                formatMessage: context.intl.formatMessage,
                editorSchema: context.editorView.state.schema
            });
            const additionalStreaming = additionalPromptRequest?.({
                abortController: abortController,
                generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                product: context.aiProvider.product,
                getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                channelId: context.channelId
            });
            if (additionalStreaming && additionalPromptRequest) callback({
                type: 'handle additional prompts',
                multiPrompts: []
            });
            (async function() {
                for await (const streamItem of streaming){
                    if (streamItem.state === 'loaded') {
                        const rovoActions = streamItem.data.rovoActions || [];
                        let markdown = streamItem.data.content;
                        if (rovoActions.length > 0) {
                            const { selectionType: selectionType } = context.configItem;
                            const idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
                            const action = rovoActions.find((x)=>x.data.suggestion === idealSuggestion) ?? rovoActions[0];
                            if (selectionType === 'empty' && action.data.suggestion === 'replace') action.data.suggestion = 'insert';
                            else if (selectionType === 'range' && action.data.suggestion === 'insert') action.data.suggestion = 'replace';
                            markdown += `\n\n---\n\n${action.data.content}`;
                        }
                        callback({
                            type: 'complete',
                            markdown: markdown,
                            cacheKey: cacheKey,
                            modelInput: {
                                selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                            },
                            inputOutputDiffRatio: streamItem.data.meta?.inputOutputDiffRatio,
                            rovoActions: rovoActions
                        });
                        continue;
                    } else if (streamItem.state === 'failed') {
                        if ('apiName' in streamItem && streamItem.apiName === 'assistance-service') {
                            if ([
                                'RATE_LIMIT',
                                'OPENAI_RATE_LIMIT_USER_ABUSE'
                            ].includes(streamItem.guard) && 'retryAfter' in streamItem) {
                                callback({
                                    type: 'error',
                                    retryAfter: streamItem.retryAfter,
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard,
                                        apiName: streamItem.apiName,
                                        errorContent: 'error' in streamItem ? streamItem.error : undefined
                                    }
                                });
                                continue;
                            }
                            if (streamItem.guard === 'HIPAA_CONTENT_DETECTED') {
                                callback({
                                    type: 'error',
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).HIPAA_CONTENT,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard,
                                        apiName: streamItem.apiName,
                                        errorContent: 'error' in streamItem ? streamItem.error : undefined
                                    }
                                });
                                continue;
                            }
                            if (streamItem.guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') {
                                callback({
                                    type: 'error',
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).TOKEN_LIMIT,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard,
                                        apiName: streamItem.apiName,
                                        errorContent: 'error' in streamItem ? streamItem.error : undefined
                                    }
                                });
                                continue;
                            }
                            if (streamItem.guard === 'ACCEPTABLE_USE_VIOLATIONS') {
                                callback({
                                    type: 'error',
                                    cacheKey: cacheKey,
                                    modelInput: {
                                        selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                    },
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard,
                                        apiName: streamItem.apiName,
                                        errorContent: 'error' in streamItem ? streamItem.error : undefined
                                    }
                                });
                                continue;
                            }
                            callback({
                                type: 'error',
                                errorInfo: {
                                    failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL,
                                    statusCode: streamItem.statusCode,
                                    errorKey: streamItem.guard,
                                    apiName: streamItem.apiName,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                            continue;
                        }
                        if ('reason' in streamItem && streamItem.reason === 'backend-input-guard') {
                            if (streamItem.guard === 'INPUT_EXCEEDS_TOKEN_LIMIT') {
                                callback({
                                    type: 'error',
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).TOKEN_LIMIT,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard
                                    }
                                });
                                continue;
                            }
                            if (streamItem.guard === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || streamItem.guard === 'INPUT_TOO_SHORT_TO_PROCESS') {
                                callback({
                                    type: 'error',
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).INPUT_TOO_SHORT,
                                        errorKey: streamItem.guard,
                                        statusCode: streamItem.statusCode
                                    }
                                });
                                continue;
                            }
                        }
                        if ('reason' in streamItem && streamItem.reason === 'rate-limited') {
                            callback({
                                type: 'error',
                                retryAfter: streamItem.retryAfter,
                                errorInfo: {
                                    failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED,
                                    statusCode: streamItem.statusCode
                                }
                            });
                            continue;
                        }
                        if ('reason' in streamItem && streamItem.reason === 'response-too-similar') {
                            callback({
                                type: 'response too similar',
                                cacheKey: cacheKey,
                                modelInput: {
                                    selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                },
                                inputOutputDiffRatio: streamItem.data.meta?.inputOutputDiffRatio
                            });
                            continue;
                        }
                        callback({
                            type: 'error',
                            errorInfo: {
                                failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL,
                                statusCode: streamItem.statusCode,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                            }
                        });
                    } else if (streamItem.state === 'aup-violation') {
                        callback({
                            type: 'error',
                            cacheKey: cacheKey,
                            modelInput: {
                                selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                            },
                            errorInfo: {
                                failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
                                statusCode: streamItem.statusCode
                            }
                        });
                        continue;
                    } else {
                        callback({
                            type: 'stream',
                            markdown: streamItem.data.content,
                            loadingStatus: streamItem.data.meta?.loadingStatus
                        });
                        continue;
                    }
                }
            })();
            if (additionalStreaming) (async function() {
                const multiPrompts = [];
                for await (const streamItem of additionalStreaming){
                    if (streamItem.state === 'loaded') {
                        if (streamItem.name) {
                            multiPrompts.push({
                                name: streamItem.name,
                                content: streamItem.data.content
                            });
                            callback({
                                type: 'handle additional prompts',
                                multiPrompts: [
                                    ...multiPrompts
                                ]
                            });
                            continue;
                        }
                    }
                }
            })();
            return ()=>{
                abortController.abort();
            };
        }
        return callbackHandler;
    }
    function $27fd26f30ad84b78$export$a30339257af76396(context, event) {
        async function callbackHandler(callback) {
            const abortController = new AbortController();
            let configItemToUse = context.configItem;
            if (!(0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true)) {
                if (context.baseGenerate && context.latestPromptResponse) configItemToUse = context.configItem && context.configItem.key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ROVO_AGENT ? context.configItem : context.baseGenerate;
            }
            let mentionMap = {};
            if (context.getMentionNameDetails) mentionMap = await (0, (0, parcelRequire("9YAmQ")).getMentionMap)({
                node: context.editorView.state.doc,
                getMentionNameDetails: context.getMentionNameDetails
            });
            const { triggeredFor: triggeredFor, positions: positions, editorView: editorView, idMap: idMap } = context;
            const { state: state } = editorView;
            const { schema: schema, doc: doc } = state;
            if (triggeredFor?.isBlock) {
                const nodeTypeName = triggeredFor.name;
                if ([
                    (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
                    (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).MAKE_SHORTER,
                    (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
                    (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FIND_ACTION_ITEMS
                ].includes(configItemToUse.key)) triggerRequest(positions, (streamContent)=>({
                        markdown: streamContent
                    }));
                else if (nodeTypeName === 'layoutSection') {
                    const layoutSection = doc.nodeAt(positions[0]);
                    if (layoutSection) {
                        const emptyLayout = layoutSection.copy();
                        const newLayoutColumns = [];
                        const triggerRequestCalls = [];
                        let currentRequestCallIndex = 0;
                        const isComplete = ()=>{
                            const nextCallRequest = triggerRequestCalls[currentRequestCallIndex + 1];
                            if (nextCallRequest) {
                                currentRequestCallIndex = currentRequestCallIndex + 1;
                                nextCallRequest();
                            }
                            return !nextCallRequest;
                        };
                        layoutSection.forEach(async (node, offset, index)=>{
                            const startPos = positions[0] + offset;
                            const endPos = startPos + node.nodeSize;
                            function streamContentProcessor(streamContent) {
                                const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                                    schema: schema,
                                    markdown: streamContent,
                                    idMap: idMap,
                                    featureToggles: {
                                        markdownPlus: true,
                                        markdownPlusExtensions: true,
                                        markdownPlusPanels: true,
                                        markdownPlusDecisions: true
                                    }
                                });
                                newLayoutColumns[index] = node.copy(pmFragment);
                                const newLayout = emptyLayout.copy((0, (0, parcelRequire("kCV8T")).Fragment).from(newLayoutColumns));
                                return {
                                    markdown: streamContent,
                                    fragment: (0, (0, parcelRequire("kCV8T")).Fragment).from(newLayout)
                                };
                            }
                            const triggerCellRequest = ()=>{
                                triggerRequest([
                                    startPos,
                                    endPos
                                ], streamContentProcessor, isComplete);
                            };
                            triggerRequestCalls.push(triggerCellRequest);
                        });
                        triggerRequestCalls[0]();
                    }
                } else if (nodeTypeName === 'panel') {
                    const panel = doc.nodeAt(positions[0]);
                    if (panel) {
                        const emptyPanel = panel.copy();
                        const startPos = positions[0] + 1;
                        const endPos = positions[1] - 1;
                        const streamContentProcessor = (streamContent)=>{
                            const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                                schema: schema,
                                markdown: streamContent,
                                idMap: idMap,
                                featureToggles: {
                                    markdownPlus: true,
                                    markdownPlusExtensions: true,
                                    markdownPlusPanels: true,
                                    markdownPlusDecisions: true
                                }
                            });
                            const newPanel = emptyPanel.copy(pmFragment);
                            return {
                                markdown: streamContent,
                                fragment: (0, (0, parcelRequire("kCV8T")).Fragment).from(newPanel)
                            };
                        };
                        triggerRequest([
                            startPos,
                            endPos
                        ], streamContentProcessor);
                    }
                } else if (nodeTypeName === 'table' || nodeTypeName === 'tableCell' || nodeTypeName === 'tableHeader') triggerRequest(positions, (streamContent)=>({
                        markdown: streamContent
                    }));
                else if (nodeTypeName === 'expand' || nodeTypeName === 'nestedExpand') {
                    const expand = doc.nodeAt(positions[0]);
                    if (expand) {
                        const emptyExpand = expand.copy();
                        const startPos = positions[0] + 1;
                        const endPos = positions[1] - 1;
                        const streamContentProcessor = (streamContent)=>{
                            const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                                schema: schema,
                                markdown: streamContent,
                                idMap: idMap,
                                featureToggles: {
                                    markdownPlus: true,
                                    markdownPlusExtensions: true,
                                    markdownPlusPanels: true,
                                    markdownPlusDecisions: true
                                }
                            });
                            const newExpand = emptyExpand.copy(pmFragment);
                            return {
                                markdown: streamContent,
                                fragment: (0, (0, parcelRequire("kCV8T")).Fragment).from(newExpand)
                            };
                        };
                        triggerRequest([
                            startPos,
                            endPos
                        ], streamContentProcessor);
                    }
                } else triggerRequest(positions, (streamContent)=>({
                        markdown: streamContent
                    }));
            } else triggerRequest(positions, (streamContent)=>({
                    markdown: streamContent
                }));
            async function triggerRequest(positions, streamContentProcessor, isComplete) {
                const initialContext = configItemToUse.getInitialContext?.({
                    editorView: context.editorView,
                    positions: positions,
                    intl: context.intl,
                    updateIdMap: ({ idMap: idMap, selectionType: selectionType })=>{
                        callback({
                            type: 'update idMap',
                            context: {
                                idMap: idMap,
                                selectionType: selectionType
                            }
                        });
                    },
                    mentionMap: mentionMap
                });
                if (initialContext?.contentStatistics) callback({
                    type: 'storeContextStatistics',
                    contextStatistics: {
                        inputDocument: initialContext.contentStatistics
                    }
                });
                if (!initialContext) throw new Error('Initial context is undefined');
                const promptRequest = configItemToUse.triggerPromptRequest({
                    initialContext: initialContext,
                    promptInput: context.userInput,
                    promptInputADF: context.userADFInput,
                    latestPromptResponse: context.latestPromptResponse || undefined,
                    formatMessage: context.intl.formatMessage,
                    editorSchema: context.editorView.state.schema
                });
                const cacheKey = JSON.stringify({
                    initialContext: initialContext,
                    userInput: context.userInput,
                    agent: context.configItem.agent
                });
                const lastHistoryItem = context.responseHistory.entries[0];
                if (lastHistoryItem && cacheKey === lastHistoryItem.cacheKey) {
                    callback({
                        type: 'same cache key'
                    });
                    return;
                }
                const streaming = promptRequest({
                    abortController: abortController,
                    generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                    product: context.aiProvider.product,
                    getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                    channelId: context.channelId
                });
                (async function() {
                    for await (const streamItem of streaming){
                        if (streamItem.state === 'loaded') {
                            const rovoActions = streamItem.data.rovoActions || [];
                            let markdown = streamItem.data.content;
                            let processedResponse = {
                                markdown: markdown
                            };
                            if (rovoActions.length > 0) {
                                const { selectionType: selectionType } = context.configItem;
                                const idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
                                const action = rovoActions.find((x)=>x.data.suggestion === idealSuggestion) ?? rovoActions[0];
                                if (selectionType === 'empty' && action.data.suggestion === 'replace') action.data.suggestion = 'insert';
                                else if (selectionType === 'range' && action.data.suggestion === 'insert') action.data.suggestion = 'replace';
                                markdown += `\n\n---\n\n${action.data.content}`;
                            } else processedResponse = streamContentProcessor(streamItem.data.content);
                            if (isComplete) {
                                const isCompleted = isComplete();
                                if (isCompleted) callback({
                                    type: 'complete',
                                    ...processedResponse,
                                    cacheKey: cacheKey,
                                    modelInput: {
                                        selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                    },
                                    inputOutputDiffRatio: streamItem.data.meta?.inputOutputDiffRatio,
                                    rovoActions: rovoActions
                                });
                                else callback({
                                    type: 'stream',
                                    ...processedResponse,
                                    loadingStatus: streamItem.data.meta?.loadingStatus
                                });
                            } else callback({
                                type: 'complete',
                                ...processedResponse,
                                cacheKey: cacheKey,
                                modelInput: {
                                    selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                },
                                inputOutputDiffRatio: streamItem.data.meta?.inputOutputDiffRatio,
                                rovoActions: rovoActions
                            });
                            continue;
                        } else if (streamItem.state === 'failed') {
                            if ('apiName' in streamItem && streamItem.apiName === 'assistance-service') {
                                if ([
                                    'RATE_LIMIT',
                                    'OPENAI_RATE_LIMIT_USER_ABUSE'
                                ].includes(streamItem.guard) && 'retryAfter' in streamItem) {
                                    callback({
                                        type: 'error',
                                        retryAfter: streamItem.retryAfter,
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED,
                                            statusCode: streamItem.statusCode,
                                            errorKey: streamItem.guard,
                                            apiName: streamItem.apiName,
                                            errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                    });
                                    continue;
                                }
                                if (streamItem.guard === 'HIPAA_CONTENT_DETECTED') {
                                    callback({
                                        type: 'error',
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).HIPAA_CONTENT,
                                            statusCode: streamItem.statusCode,
                                            errorKey: streamItem.guard,
                                            apiName: streamItem.apiName,
                                            errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                    });
                                    continue;
                                }
                                if (streamItem.guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') {
                                    callback({
                                        type: 'error',
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).TOKEN_LIMIT,
                                            statusCode: streamItem.statusCode,
                                            errorKey: streamItem.guard,
                                            apiName: streamItem.apiName,
                                            errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                    });
                                    continue;
                                }
                                if (streamItem.guard === 'ACCEPTABLE_USE_VIOLATIONS') {
                                    callback({
                                        type: 'error',
                                        cacheKey: cacheKey,
                                        modelInput: {
                                            selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                        },
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
                                            statusCode: streamItem.statusCode,
                                            errorKey: streamItem.guard,
                                            apiName: streamItem.apiName,
                                            errorContent: 'error' in streamItem ? streamItem.error : undefined
                                        }
                                    });
                                    continue;
                                }
                                callback({
                                    type: 'error',
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL,
                                        statusCode: streamItem.statusCode,
                                        errorKey: streamItem.guard,
                                        apiName: streamItem.apiName,
                                        errorContent: 'error' in streamItem ? streamItem.error : undefined
                                    }
                                });
                                continue;
                            }
                            if ('reason' in streamItem && streamItem.reason === 'backend-input-guard') {
                                if (streamItem.guard === 'INPUT_EXCEEDS_TOKEN_LIMIT') {
                                    callback({
                                        type: 'error',
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).TOKEN_LIMIT,
                                            statusCode: streamItem.statusCode,
                                            errorKey: streamItem.guard
                                        }
                                    });
                                    continue;
                                }
                                if (streamItem.guard === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || streamItem.guard === 'INPUT_TOO_SHORT_TO_PROCESS') {
                                    callback({
                                        type: 'error',
                                        errorInfo: {
                                            failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).INPUT_TOO_SHORT,
                                            errorKey: streamItem.guard,
                                            statusCode: streamItem.statusCode
                                        }
                                    });
                                    continue;
                                }
                            }
                            if ('reason' in streamItem && streamItem.reason === 'rate-limited') {
                                callback({
                                    type: 'error',
                                    retryAfter: streamItem.retryAfter,
                                    errorInfo: {
                                        failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).RATE_LIMITED,
                                        statusCode: streamItem.statusCode
                                    }
                                });
                                continue;
                            }
                            if ('reason' in streamItem && streamItem.reason === 'response-too-similar') {
                                callback({
                                    type: 'response too similar',
                                    cacheKey: cacheKey,
                                    modelInput: {
                                        selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                    },
                                    inputOutputDiffRatio: streamItem.data.meta?.inputOutputDiffRatio
                                });
                                continue;
                            }
                            callback({
                                type: 'error',
                                errorInfo: {
                                    failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).API_FAIL,
                                    statusCode: streamItem.statusCode,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                        } else if (streamItem.state === 'aup-violation') {
                            callback({
                                type: 'error',
                                cacheKey: cacheKey,
                                modelInput: {
                                    selection: (0, (0, parcelRequire("PwAM5")).isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                },
                                errorInfo: {
                                    failureReason: (0, (0, parcelRequire("48T0b")).FAILURE_REASON).AUP_VIOLATION,
                                    statusCode: streamItem.statusCode
                                }
                            });
                            continue;
                        } else {
                            callback({
                                type: 'stream',
                                loadingStatus: streamItem.data.meta?.loadingStatus,
                                ...streamContentProcessor(streamItem.data.content)
                            });
                            continue;
                        }
                    }
                })();
                if (!triggeredFor?.isBlock) {
                    const additionalPromptRequest = configItemToUse.additionalTriggerPromptRequest?.({
                        analyticsContext: context.analyticsContext,
                        initialContext: initialContext,
                        promptInput: context.userInput,
                        promptInputADF: context.userADFInput,
                        latestPromptResponse: context.latestPromptResponse || undefined,
                        formatMessage: context.intl.formatMessage,
                        editorSchema: context.editorView.state.schema
                    });
                    const additionalStreaming = additionalPromptRequest?.({
                        abortController: abortController,
                        generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
                        product: context.aiProvider.product,
                        getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
                        channelId: context.channelId
                    });
                    if (additionalStreaming && additionalPromptRequest) callback({
                        type: 'handle additional prompts',
                        multiPrompts: []
                    });
                    if (additionalStreaming) (async function() {
                        const multiPrompts = [];
                        for await (const streamItem of additionalStreaming){
                            if (streamItem.state === 'loaded') {
                                if (streamItem.name) {
                                    multiPrompts.push({
                                        name: streamItem.name,
                                        content: streamItem.data.content
                                    });
                                    callback({
                                        type: 'handle additional prompts',
                                        multiPrompts: [
                                            ...multiPrompts
                                        ]
                                    });
                                    continue;
                                }
                            }
                        }
                    })();
                }
            }
            return ()=>{
                abortController.abort();
            };
        }
        return callbackHandler;
    }
});
parcelRegister("2kjU9", function(module, exports) {
    $parcel$export(module.exports, "ProactivePreviewScreenWithLogic", ()=>$15bb5df434367d26$export$3b6fc98c79bb840);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gkwXh;
    var $VSDnB;
    var $7cYAt;
    var $h1WZC;
    var $9m3ZB;
    var $cCAIN;
    var $b2OAx;
    var $falJd;
    var $GWO6B;
    var $6KJH7;
    var $iwR8w;
    function $15bb5df434367d26$export$3b6fc98c79bb840({ aiProactivePluginState: aiProactivePluginState, editorView: editorView, providerFactory: providerFactory, editorPluginAIProvider: editorPluginAIProvider }) {
        const fireAIAnalyticsEvent = (0, (0, parcelRequire("9m3ZB")).useFireAIAnalyticsEvent)();
        const { formatMessage: formatMessage, locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { selectedRecommendationId: selectedRecommendationId, analyticsAIInteractionId: analyticsAIInteractionId } = aiProactivePluginState;
        const { handleFeedbackSubmission: handleFeedbackSubmission, product: product } = editorPluginAIProvider;
        const { block: block, recommendation: recommendation } = selectedRecommendationId ? (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(aiProactivePluginState, selectedRecommendationId) : {
            block: undefined,
            recommendation: undefined
        };
        const analyticsFlow = (0, (0, parcelRequire("h1WZC")).useAnalyticsFlow)();
        const getAiLifeCycleDynamicAttributes = (0, (0, parcelRequire("VSDnB")).fg)('editorai_dynamic_attributes_for_ai_life_cycle') ? analyticsFlow.getAiLifeCycleDynamicAttributes : undefined;
        (0, $5uXOq.useEffect)(()=>{
            if (recommendation?.transformAction) fireAIAnalyticsEvent({
                payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('viewed', analyticsAIInteractionId, recommendation.transformAction, true, getAiLifeCycleDynamicAttributes?.({
                    init: false
                }) || {})
            });
        }, [
            fireAIAnalyticsEvent,
            analyticsAIInteractionId,
            recommendation?.transformAction,
            getAiLifeCycleDynamicAttributes
        ]);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("cCAIN")).clearSelectRecommendation)()(editorView.state, editorView.dispatch);
        }, [
            editorView.dispatch,
            editorView.state
        ]);
        if (!selectedRecommendationId || !block || !recommendation) return null;
        const pmFragment = recommendation.transformContent.content;
        const { title: title } = (0, (0, parcelRequire("GWO6B")).getTransformActionDescriptors)(recommendation.transformAction);
        const preview = (0, (0, parcelRequire("falJd")).convertPMFragmentToPreview)({
            schema: editorView.state.schema,
            pmFragment: pmFragment,
            showTelepointer: false,
            providerFactory: providerFactory
        });
        const proactiveRecommendationButtons = [
            {
                label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).dismissProactiveRecommentation),
                appearance: 'cancel',
                onClick: ()=>{
                    if (!recommendation) return null;
                    (0, (0, parcelRequire("cCAIN")).removeRecommendation)(recommendation.id, 'preview')(editorView.state, editorView.dispatch);
                }
            },
            {
                label: formatMessage((0, (0, parcelRequire("6KJH7")).messages).insertProactiveRecommentation),
                appearance: 'primary',
                onClick: ()=>{
                    if (!recommendation) return null;
                    (0, (0, parcelRequire("cCAIN")).insertRecommendation)(recommendation.id, 'preview')(editorView.state, editorView.dispatch);
                }
            }
        ];
        const fireResponseFeedbackEvent = (sentiment)=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'responseFeedbackButton',
                    attributes: {
                        sentiment: sentiment,
                        product: product,
                        configItemTitle: 'proactive-recommendation'
                    },
                    eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                }
            });
        };
        const handleFeedbackButtonClick = async (sentiment)=>{
            fireResponseFeedbackEvent(sentiment);
            if (!handleFeedbackSubmission) return false;
            await handleFeedbackSubmission({
                sentiment: sentiment,
                getAIExperience: (hasUserConsent)=>({
                        browserLocale: window.navigator.languages,
                        userLocale: locale,
                        ...hasUserConsent ? {
                            originalParagraph: block.text,
                            suggestedParagraph: pmFragment,
                            recommendationId: recommendation.id
                        } : {}
                    }),
                editorAttributes: {
                    product: product
                }
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cYAt")).PreviewScreen), {
            staticPromptTitle: formatMessage(title),
            hideHorizontalRule: true,
            showBetaLozenge: true,
            preview: preview,
            disableActions: false,
            disableInterrogation: true,
            schema: editorView.state.schema,
            providerFactory: providerFactory,
            onCopy: ()=>{
                fireAIAnalyticsEvent({
                    payload: {
                        action: 'click',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'copyButton',
                        attributes: {
                            experienceType: 'proactive-recommendation'
                        },
                        eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).UI
                    }
                });
                (0, (0, parcelRequire("iwR8w")).copyResponseToClipboard)({
                    editorView: editorView,
                    pmFragment: pmFragment
                });
            },
            showBack: false,
            onGoodResponseButtonClick: ()=>handleFeedbackButtonClick('good-recommendation'),
            onBadResponseButtonClick: ()=>handleFeedbackButtonClick('bad-recommendation'),
            onClose: onClose,
            applications: proactiveRecommendationButtons,
            isInputActive: false
        });
    }
});
parcelRegister("3bUxI", function(module, exports) {
    $parcel$export(module.exports, "getFloatingToolbarConfig", ()=>$0737e9f5a9070828$export$add2b8f99d5aac);
    var $f8Sb3;
    var $eCeGD;
    var $hYNZx;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $etG8M;
    var $iHYdz;
    var $i28qQ;
    var $8U6zd;
    var $5hasd;
    var $8AQ0R;
    var $VSDnB;
    var $f5oqj;
    var $fCNtA;
    var $gmhCD = parcelRequire("gmhCD");
    var $i0hyP;
    var $ldiyo;
    var $dKZcc;
    var $4dOAK;
    var $5ilgR;
    var $3cfam;
    var $jSlH9;
    var $eIB13;
    var $K8sX1;
    var $2nx9e;
    var $afxsk;
    var $51rZO;
    var $eWoX4;
    const $0737e9f5a9070828$var$jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
    const $0737e9f5a9070828$var$CloseIcon = ({ label: label })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("i28qQ"))))), {
            label: label,
            color: "var(--ds-icon, #44546F)",
            spacing: "spacious"
        });
    const $0737e9f5a9070828$var$MoreIcon = ({ label: label })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("8U6zd"))))), {
            label: label,
            spacing: "spacious",
            color: "currentColor"
        });
    const $0737e9f5a9070828$var$ImproveSentenceIcon = ({ label: label })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i0hyP")).LogoSvg), {
            alt: label
        });
    };
    const $0737e9f5a9070828$export$add2b8f99d5aac = ({ aiGlobalOptIn: aiGlobalOptIn, editorPluginAIProvider: editorPluginAIProvider })=>(state, intl, providerFactory, processedConfigs)=>{
            const pluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(state) || {};
            const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, selectedID: selectedID, splitParagraphIntoSentences: splitParagraphIntoSentences } = pluginState;
            const { product: product, handleFeedbackSubmission: handleFeedbackSubmission } = editorPluginAIProvider;
            if (isSpellingAndGrammarEnabled && state.selection.from === state.selection.to) {
                const decorationPluginState = (0, (0, parcelRequire("jSlH9")).getPluginState)(state);
                if (decorationPluginState.modalDecorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) {
                    const selectedDiff = (0, (0, parcelRequire("5ilgR")).getSelectedDiffObject)(pluginState, state.selection.to);
                    if (selectedDiff && selectedID) {
                        const blockOrSentenceFromDiffObject = (0, (0, parcelRequire("5ilgR")).getBlockOrSentenceFromDiffObject)(pluginState, selectedDiff);
                        const sentenceItems = [];
                        if (splitParagraphIntoSentences && blockOrSentenceFromDiffObject) {
                            const sentence = blockOrSentenceFromDiffObject;
                            const openAIModalAndUnhighlightSentenceCommand = (state, dispatch)=>(0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                                    state: state,
                                    configItem: (0, (0, parcelRequire("K8sX1")).improveWriting),
                                    aiGlobalOptIn: aiGlobalOptIn,
                                    positions: {
                                        startPos: sentence.from,
                                        endPos: sentence.to
                                    },
                                    lastTriggeredFrom: 'proactiveAIFloatingToolbar'
                                })(state, dispatch) && (0, (0, parcelRequire("ldiyo")).unhighlightSentence)()(state, dispatch);
                            sentenceItems.push((0, (0, parcelRequire("eWoX4")).separator)(), {
                                id: 'editor.ai.sg-improve-sentence',
                                type: 'button',
                                testId: 'ak-editor-ai-suggestion-toolbar-improve-sentence-button',
                                icon: $0737e9f5a9070828$var$ImproveSentenceIcon,
                                onClick: openAIModalAndUnhighlightSentenceCommand,
                                onMouseEnter: (0, (0, parcelRequire("ldiyo")).highlightSentence)(sentence),
                                onMouseLeave: (0, (0, parcelRequire("ldiyo")).unhighlightSentence)(),
                                onFocus: (0, (0, parcelRequire("ldiyo")).highlightSentence)(sentence),
                                onBlur: (0, (0, parcelRequire("ldiyo")).unhighlightSentence)(),
                                title: intl.formatMessage((0, (0, parcelRequire("51rZO")).messages).improveSentenceToolbarButtonLabel),
                                showTitle: true
                            });
                        }
                        const dropdownOptions = [
                            {
                                title: intl.formatMessage((0, (0, parcelRequire("51rZO")).messages).correctSuggestion),
                                icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("8AQ0R"))))), {
                                    label: "thumbsupIcon",
                                    spacing: "spacious",
                                    color: "var(--ds-icon, #44546F)"
                                }),
                                onClick: ()=>{
                                    if (!handleFeedbackSubmission || !blockOrSentenceFromDiffObject) return false;
                                    handleFeedbackSubmission({
                                        sentiment: 'good-suggestion',
                                        getAIExperience: (hasUserConsent)=>({
                                                browserLocale: window.navigator.languages,
                                                userLocale: intl.locale,
                                                ...hasUserConsent ? {
                                                    originalText: selectedDiff.originalText,
                                                    suggestionText: selectedDiff.text,
                                                    selectedSentence: blockOrSentenceFromDiffObject.text
                                                } : {}
                                            }),
                                        editorAttributes: {
                                            product: product
                                        }
                                    });
                                    return true;
                                }
                            },
                            {
                                title: intl.formatMessage((0, (0, parcelRequire("51rZO")).messages).incorrectSuggestion),
                                icon: (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5hasd"))))), {
                                    label: "thumbsdownIcon",
                                    spacing: "spacious",
                                    color: "var(--ds-icon, #44546F)"
                                }),
                                onClick: ()=>{
                                    if (!handleFeedbackSubmission || !blockOrSentenceFromDiffObject) return false;
                                    handleFeedbackSubmission({
                                        sentiment: 'bad-suggestion',
                                        getAIExperience: (hasUserConsent)=>({
                                                ...hasUserConsent ? {
                                                    originalText: selectedDiff.originalText,
                                                    suggestionText: selectedDiff.text,
                                                    selectedSentence: blockOrSentenceFromDiffObject.text
                                                } : {}
                                            }),
                                        editorAttributes: {
                                            product: product
                                        }
                                    });
                                    return true;
                                }
                            }
                        ];
                        const nodeType = [
                            state.schema.nodes.paragraph,
                            state.schema.nodes.text,
                            state.schema.nodes.heading,
                            state.schema.nodes.taskItem,
                            state.schema.nodes.decisionItem
                        ];
                        const { from: from, text: text, replacement: replacement, hasInlineNodes: hasInlineNodes } = selectedDiff;
                        const textToolbarItemButton = {
                            id: 'editor.ai.sg-suggestion',
                            type: 'button',
                            showTitle: true,
                            testId: 'ak-editor-ai-suggestion-toolbar-suggestion-button',
                            onClick: (0, (0, parcelRequire("dKZcc")).insertSuggestionWithAnalytics)({
                                schema: state.schema,
                                selectedDiff: selectedDiff,
                                blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                                aiInteractionID: selectedID
                            }),
                            title: text,
                            focusEditoronEnter: true
                        };
                        const toolbarItemButton = hasInlineNodes && replacement && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_ai_md_plus') ? {
                            type: 'custom',
                            render: (view)=>{
                                if (!view || !replacement) return;
                                const { nodes: nodes } = view.state.schema;
                                const { doc: doc, paragraph: paragraph } = nodes;
                                const replacementDoc = doc.createAndFill({}, paragraph.createAndFill({}, replacement));
                                if (!replacementDoc) return;
                                return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("eCeGD")).default), {
                                    spacing: "compact",
                                    appearance: "subtle",
                                    onClick: ()=>{
                                        (0, (0, parcelRequire("dKZcc")).insertSuggestionWithAnalytics)({
                                            schema: state.schema,
                                            selectedDiff: selectedDiff,
                                            blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                                            aiInteractionID: selectedID
                                        })(view.state, view.dispatch);
                                    }
                                }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fCNtA")).RendererActionsContext), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f5oqj")).default), {
                                    document: $0737e9f5a9070828$var$jsonTransformer.encode(replacementDoc),
                                    useSpecBasedValidator: true,
                                    dataProviders: providerFactory
                                })));
                            },
                            fallback: [
                                textToolbarItemButton
                            ]
                        } : textToolbarItemButton;
                        const items = [
                            toolbarItemButton,
                            ...sentenceItems,
                            (0, (0, parcelRequire("eWoX4")).separator)(),
                            {
                                id: 'editor.ai.sg-dismiss',
                                type: 'button',
                                testId: 'ak-editor-ai-suggestion-toolbar-dismiss-button',
                                icon: $0737e9f5a9070828$var$CloseIcon,
                                onClick: (0, (0, parcelRequire("dKZcc")).removeSuggestionWithAnalytics)({
                                    schema: state.schema,
                                    selectedDiff: selectedDiff,
                                    blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                                    aiInteractionID: selectedID
                                }),
                                title: intl.formatMessage((0, (0, parcelRequire("51rZO")).messages).dismissSuggestion),
                                focusEditoronEnter: true
                            },
                            (0, (0, parcelRequire("eWoX4")).separator)(),
                            {
                                type: 'dropdown',
                                title: 'More options',
                                id: 'editor.ai.sg-dropdown',
                                icon: $0737e9f5a9070828$var$MoreIcon,
                                options: dropdownOptions,
                                hideExpandIcon: true,
                                alignDropdownWithToolbar: false,
                                dropdownWidth: 200,
                                footer: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("afxsk")).AIFloatingToolbarFooter), null)
                            }
                        ];
                        return {
                            title: 'Spelling & Grammar controls',
                            getDomRef: (editorView)=>(0, $5r0mK.findDomRefAtPos)(from, editorView.domAtPos.bind(editorView)),
                            nodeType: nodeType,
                            zIndex: (0, (0, parcelRequire("iHYdz")).akEditorFloatingPanelZIndex) + 1,
                            items: items,
                            scrollable: false,
                            align: 'left'
                        };
                    }
                }
            }
            const { selection: selection } = state;
            const { from: from, to: to } = selection;
            const isNodeSelection = selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
            const isCellSelection = selection.toJSON().type === 'cell';
            const getParentSupportedForAIButton = ()=>{
                const supportedNodesForAI = (0, (0, parcelRequire("2nx9e")).getSupportedNodesForAIModal)(state);
                if (isNodeSelection) return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
                else {
                    const parentNodeFindResult = (0, $5r0mK.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                    return parentNodeFindResult?.node;
                }
            };
            const parentSupportedForAIButton = getParentSupportedForAIButton();
            if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
                if ((0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test', {
                    exposure: true
                })) {
                    const canAddAIButton = isNodeSelection || parentSupportedForAIButton;
                    const nodeType = parentSupportedForAIButton?.type;
                    if (canAddAIButton && nodeType) {
                        const aiIconButton = (0, (0, parcelRequire("eIB13")).getAIExperienceButton)({
                            intl: intl,
                            rangeBaseGenerate: editorPluginAIProvider.rangeConfig.baseGenerate,
                            hideTitle: true,
                            aiGlobalOptIn: aiGlobalOptIn,
                            triggeredFor: nodeType
                        });
                        const addAIButtonToConfig = (title)=>{
                            const toolbarConfig = processedConfigs?.find((config)=>config.title === title);
                            const items = Array.isArray(toolbarConfig?.items) ? toolbarConfig?.items : [];
                            if (toolbarConfig && items.length) {
                                const withAIItems = [
                                    ...items.slice(0, items.length - 3),
                                    aiIconButton,
                                    {
                                        type: 'separator'
                                    },
                                    ...items.slice(items.length - 3, items.length)
                                ];
                                toolbarConfig.items = withAIItems;
                                return toolbarConfig;
                            }
                        };
                        const toolbarConfig = addAIButtonToConfig('Panel floating controls') || addAIButtonToConfig('Table floating controls') || addAIButtonToConfig('Layout floating controls') || addAIButtonToConfig('Expand toolbar');
                        if (toolbarConfig) return toolbarConfig;
                    }
                }
            }
            return;
        };
});
parcelRegister("eIB13", function(module, exports) {
    $parcel$export(module.exports, "getAIExperienceButton", ()=>$274ec815b4cd9204$export$a3e7258dd93ab690);
    $parcel$export(module.exports, "getImproveWritingAIButton", ()=>$274ec815b4cd9204$export$c93a3969a7894772);
    var $jps85;
    var $gmhCD = parcelRequire("gmhCD");
    var $kjtjo;
    var $39VaN;
    var $K8sX1;
    var $ksZXn;
    var $3cfam;
    var $fCAMT;
    const $274ec815b4cd9204$export$ef1d0b9899d7de5 = `ak-editor-ai-selection-toolbar-ai-button`;
    const $274ec815b4cd9204$export$9629d9d0267faff3 = `ak-editor-ai-selection-toolbar-dropdown-`;
    const $274ec815b4cd9204$export$a3e7258dd93ab690 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn, title: title, tooltip: tooltip, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount, onClick: onClick })=>{
        let didMouseEnter = false;
        return {
            type: 'button',
            pulse: pulse,
            showTitle: true,
            testId: $274ec815b4cd9204$export$ef1d0b9899d7de5,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("jps85"))))),
            iconFallback: (0, (0, parcelRequire("ksZXn")).Logo),
            ...!hideTitle && {
                title: intl.formatMessage(title ?? (0, (0, parcelRequire("fCAMT")).messages).aiToolbarTitle)
            },
            tooltipContent: intl.formatMessage(tooltip ?? (0, (0, parcelRequire("kjtjo")).default).aiUniversalShortCallToAction),
            disabled: false,
            onMount: onMount,
            onMouseEnter: ()=>{
                didMouseEnter = true;
                return false;
            },
            onClick: (state, dispatch, view)=>{
                const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                    state: state,
                    configItem: rangeBaseGenerate,
                    lastTriggeredFrom: 'floatingToolbar',
                    triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                    aiGlobalOptIn: aiGlobalOptIn,
                    triggeredFor: triggeredFor
                });
                openAIModalCommand(state, dispatch);
                if (onClick) onClick();
                return false;
            }
        };
    };
    const $274ec815b4cd9204$export$c93a3969a7894772 = ({ intl: intl, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn })=>{
        let didMouseEnter = false;
        const configItem = (0, $gmhCD.editorExperiment)('platform_editor_ai_change_tone_floating_toolbar', true, {
            exposure: true
        }) ? {
            ...(0, (0, parcelRequire("39VaN")).professionalTone),
            title: (0, (0, parcelRequire("K8sX1")).improveWriting).title
        } : (0, (0, parcelRequire("K8sX1")).improveWriting);
        return {
            type: 'button',
            showTitle: true,
            testId: `${$274ec815b4cd9204$export$ef1d0b9899d7de5}-improve-writing`,
            icon: undefined,
            ...!hideTitle && {
                title: intl.formatMessage((0, (0, parcelRequire("fCAMT")).messages).improveWritingToolbarIconTitle)
            },
            tooltipContent: intl.formatMessage((0, (0, parcelRequire("fCAMT")).messages).improveWritingToolbarIconTooltip),
            disabled: false,
            onMouseEnter: ()=>{
                didMouseEnter = true;
                return false;
            },
            onClick: (state, dispatch, view)=>{
                const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                    state: state,
                    configItem: configItem,
                    lastTriggeredFrom: 'floatingToolbar',
                    triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                    aiGlobalOptIn: aiGlobalOptIn
                });
                openAIModalCommand(state, dispatch);
                return false;
            }
        };
    };
    const $274ec815b4cd9204$var$mapSelectionToolbarDropdowns = ({ selectionToolbarDropdowns: selectionToolbarDropdowns, intl: intl, aiGlobalOptIn: aiGlobalOptIn })=>{
        if (!selectionToolbarDropdowns) return [];
        return selectionToolbarDropdowns.map((dropdownConfig)=>{
            let title = intl.formatMessage(dropdownConfig.label);
            if (dropdownConfig?.beta) title = `${title} (${intl.formatMessage((0, (0, parcelRequire("kjtjo")).default).betaLabel)})`;
            return {
                type: 'dropdown',
                testId: $274ec815b4cd9204$export$9629d9d0267faff3 + dropdownConfig.id,
                title: title,
                disabled: false,
                options: dropdownConfig.options.map((option, index)=>({
                        title: intl.formatMessage(option.label),
                        testId: `ak-editor-ai-selection-toolbar-${dropdownConfig.id}-button-${index}`,
                        onClick: (state, dispatch, view)=>{
                            const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                                state: state,
                                configItem: option.configItem,
                                lastTriggeredFrom: 'floatingToolbarDropdown',
                                aiGlobalOptIn: aiGlobalOptIn
                            });
                            openAIModalCommand(state, dispatch);
                            return false;
                        }
                    }))
            };
        });
    };
    const $274ec815b4cd9204$export$bd2fe0c8f25cb579 = ({ intl: intl, rangeConfig: rangeConfig, aiGlobalOptIn: aiGlobalOptIn })=>{
        const selectionToolbarDropdowns = rangeConfig.getSelectionToolbarDropdowns?.();
        const aiDropdowns = $274ec815b4cd9204$var$mapSelectionToolbarDropdowns({
            selectionToolbarDropdowns: selectionToolbarDropdowns,
            intl: intl,
            aiGlobalOptIn: aiGlobalOptIn
        });
        const separator = {
            type: 'separator'
        };
        const separatedAIDropdowns = aiDropdowns.reduce((acc, val)=>acc.concat(separator, val), []);
        return separatedAIDropdowns;
    };
});
parcelRegister("kjtjo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98476217fc724136$export$2e2bcd8739ae039);
    var $7VHMR;
    var $98476217fc724136$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aiUniversalLongCallToAction: {
            id: 'fabric.editor.ai.shared.aiUniversalLongCallToAction',
            defaultMessage: 'Let Atlassian Intelligence assist your writing',
            description: 'Call-to-action text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
        },
        aiUniversalShortCallToAction: {
            id: 'fabric.editor.ai.shared.aiUniversalShortCallToAction',
            defaultMessage: 'Write',
            description: 'Call-to-action text for activating the AI, used universally across UI elements like buttons and menu entries'
        },
        aiProactiveCallToAction: {
            id: 'fabric.editor.ai.shared.aiProactiveCallToAction',
            defaultMessage: 'Suggested edits',
            description: 'Call-to-action text for activating Proactive AI for inline AI suggestions.'
        },
        aiProactiveDescriptor: {
            id: 'fabric.editor.ai.shared.aiProactiveDescriptor',
            defaultMessage: 'Suggested edits',
            description: 'Descriptive text for activating Proactive AI for the inline writing suggestions'
        },
        aiUniversalDescriptor: {
            id: 'fabric.editor.ai.shared.aiUniversalDescriptor',
            defaultMessage: 'Writing assistant',
            description: 'Descriptive text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
        },
        aiButtonTitle: {
            id: 'fabric.editor.ai.shared.generateContent.aiButtonTitle',
            defaultMessage: 'AI (Atlassian Intelligence)',
            description: 'Title for Atlassian Intelligence feature shown in editor typeahead and element browser.'
        },
        betaLabel: {
            id: 'fabric.editor.ai.shared.betaLabel',
            defaultMessage: 'Beta',
            description: 'The label describing the beta status of an Atlassian Intelligence prompt'
        }
    });
});
parcelRegister("39VaN", function(module, exports) {
    $parcel$export(module.exports, "neutralTone", ()=>$bae88bf4427fa87d$export$a1ce45391086f9e8);
    $parcel$export(module.exports, "professionalTone", ()=>$bae88bf4427fa87d$export$9d1bdb60a3d217e);
    $parcel$export(module.exports, "casualTone", ()=>$bae88bf4427fa87d$export$f482a4b6f54abf37);
    $parcel$export(module.exports, "educationalTone", ()=>$bae88bf4427fa87d$export$af9eb666150af102);
    $parcel$export(module.exports, "empatheticTone", ()=>$bae88bf4427fa87d$export$1719f8ca52167b9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $biGkW;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $Qullb;
    var $1j7Ox;
    var $lEqyG;
    var $gpxls;
    var $kkUTO;
    var $8gLLR;
    var $aRWc6;
    var $8gvqH;
    var $j7znz;
    const $bae88bf4427fa87d$var$SELECTION_TYPE = 'range';
    function $bae88bf4427fa87d$var$createChangeToneOption({ key: key, title: title, description: description, intentSchemaId: intentSchemaId, icon: icon, shortTitle: shortTitle }) {
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: key,
            title: title,
            description: description,
            selectionType: $bae88bf4427fa87d$var$SELECTION_TYPE,
            nestingConfig: {
                parentTestId: 'change-tone-to',
                parentTitle: (0, (0, parcelRequire("j7znz")).messages).nestingParentTitlePostGA,
                shortTitle: shortTitle,
                icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("biGkW"))))), {
                        label: "",
                        spacing: "spacious",
                        color: "var(--ds-icon, #44546F)"
                    })
            },
            showInRefineDropdown: true,
            getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $bae88bf4427fa87d$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    selection: markdown,
                    userLocale: intl.locale,
                    intentSchemaId: intentSchemaId,
                    contentStatistics: contentStatistics
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext, latestPromptResponse: latestPromptResponse }) {
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: intentSchemaId,
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document,
                    draftSelectedContentOverride: (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true) ? latestPromptResponse : undefined,
                    currentSelection: initialContext.selection
                });
                return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                    userLocale: initialContext.userLocale,
                    intentSchemaId: intentSchemaId,
                    editorSchema: editorSchema,
                    contextList: [
                        {
                            type: 'ADF_MARKDOWN_V1',
                            entity: initialContext.selection,
                            relationship: 'SELECTION'
                        }
                    ]
                });
            },
            isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                    editorView: editorView,
                    minLength: 1,
                    positions: positions
                }),
            icon: icon,
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, (0, parcelRequire("8gLLR")).createReplace)({
                    appearance: 'primary'
                })
            ],
            getBackendModel: ()=>{
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
                return 'xp-gen-ai';
            }
        });
    }
    const $bae88bf4427fa87d$export$a1ce45391086f9e8 = $bae88bf4427fa87d$var$createChangeToneOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
        title: (0, (0, parcelRequire("j7znz")).messages).neutralToneTitle,
        shortTitle: (0, (0, parcelRequire("j7znz")).messages).neutralToneShortTitle,
        description: (0, (0, parcelRequire("j7znz")).messages).neutralToneDescription,
        intentSchemaId: 'change_tone_neutral_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gpxls")).Icon), {
                shownAt: shownAt
            })
    });
    const $bae88bf4427fa87d$export$9d1bdb60a3d217e = $bae88bf4427fa87d$var$createChangeToneOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
        title: (0, (0, parcelRequire("j7znz")).messages).professionalToneTitle,
        shortTitle: (0, (0, parcelRequire("j7znz")).messages).professionalToneShortTitle,
        description: (0, (0, parcelRequire("j7znz")).messages).professionalToneDescription,
        intentSchemaId: 'change_tone_professional_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkUTO")).Icon), {
                shownAt: shownAt
            })
    });
    const $bae88bf4427fa87d$export$f482a4b6f54abf37 = $bae88bf4427fa87d$var$createChangeToneOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
        title: (0, (0, parcelRequire("j7znz")).messages).casualToneTitle,
        shortTitle: (0, (0, parcelRequire("j7znz")).messages).casualToneShortTitle,
        description: (0, (0, parcelRequire("j7znz")).messages).casualToneDescription,
        intentSchemaId: 'change_tone_business_casual_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Qullb")).Icon), {
                shownAt: shownAt
            })
    });
    const $bae88bf4427fa87d$export$af9eb666150af102 = $bae88bf4427fa87d$var$createChangeToneOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
        title: (0, (0, parcelRequire("j7znz")).messages).educationalToneTitle,
        shortTitle: (0, (0, parcelRequire("j7znz")).messages).educationalToneShortTitle,
        description: (0, (0, parcelRequire("j7znz")).messages).educationalToneDescription,
        intentSchemaId: 'change_tone_educational_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1j7Ox")).Icon), {
                shownAt: shownAt
            })
    });
    const $bae88bf4427fa87d$export$1719f8ca52167b9c = $bae88bf4427fa87d$var$createChangeToneOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
        title: (0, (0, parcelRequire("j7znz")).messages).empatheticToneTitle,
        shortTitle: (0, (0, parcelRequire("j7znz")).messages).empatheticToneShortTitle,
        description: (0, (0, parcelRequire("j7znz")).messages).empatheticToneDescription,
        intentSchemaId: 'change_tone_empathetic_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lEqyG")).Icon), {
                shownAt: shownAt
            })
    });
});
parcelRegister("biGkW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83a2375dd81757e8$var$_react = $83a2375dd81757e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83a2375dd81757e8$var$_UNSAFE_baseNew = $83a2375dd81757e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $83a2375dd81757e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83a2375dd81757e8$var$MicrophoneIcon = (props)=>$83a2375dd81757e8$var$_react.default.createElement($83a2375dd81757e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 7c0 2.9-2.35 5.25-5.25 5.25m0 0A5.25 5.25 0 0 1 2.75 7M8 12.25v3m0 0h4m-4 0H4M10.25 7a2.25 2.25 0 0 1-4.5 0V3a2.25 2.25 0 0 1 4.5 0z"/>`
        }, props));
    $83a2375dd81757e8$var$MicrophoneIcon.displayName = 'MicrophoneIcon';
    var $83a2375dd81757e8$var$_default = module.exports.default = $83a2375dd81757e8$var$MicrophoneIcon;
});
parcelRegister("9I7Qr", function(module, exports) {
    $parcel$export(module.exports, "streamXPGenAI", ()=>$8631babe80356ceb$export$4eb069a309265fac);
    var $gIHA4;
    var $5LAwF;
    var $3RkUa;
    const $8631babe80356ceb$export$4eb069a309265fac = (input, customEndpoint)=>{
        return function promptRequest(requestOptions) {
            const streamingResponseGenerator = (0, (0, parcelRequire("gIHA4")).startStreamingResponse)({
                endpoint: customEndpoint || requestOptions.generativeAIApiUrl,
                payload: JSON.stringify({
                    intentSchemaId: input.intentSchemaId,
                    contextList: input.contextList,
                    modelPlatform: 'OPENAI',
                    outputLocale: input.userLocale,
                    streaming: true,
                    outputFormat: {
                        outputFormatType: 'MARKDOWN',
                        markdowns: (0, (0, parcelRequire("5LAwF")).getSupportedMarkdowns)(input.editorSchema)
                    },
                    product: requestOptions.product,
                    ...'customPrompt' in input && input.customPrompt && {
                        userInstruction: input.customPrompt
                    },
                    ...'targetTranslationLanguage' in input && input.targetTranslationLanguage && {
                        targetTranslationLanguage: input.targetTranslationLanguage
                    }
                }),
                ...requestOptions
            });
            return (0, (0, parcelRequire("3RkUa")).streamResponseParser)({
                streamingResponseGenerator: streamingResponseGenerator,
                ...'streamingListener' in input && input.streamingListener && {
                    streamingListener: input?.streamingListener
                }
            });
        };
    };
});
parcelRegister("Qullb", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$b18e7775751687d8$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $bM08q;
    var $8K52v;
    const $b18e7775751687d8$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0_11_3586)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("mask", {
            id: "mask0_11_3586",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "24",
            height: "24"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0H24V24H0V0Z",
            fill: "white"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            mask: "url(#mask0_11_3586)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C13.3843 18.9996 14.7375 18.5889 15.8884 17.8196C17.0393 17.0504 17.9364 15.9572 18.4661 14.6782C18.9959 13.3993 19.1346 11.992 18.8648 10.6342C18.5949 9.27645 17.9286 8.02916 16.95 7.05C16.136 6.23608 15.1338 5.63546 14.0323 5.30135C12.9307 4.96723 11.7637 4.90994 10.6347 5.13453C9.50574 5.35913 8.44955 5.85868 7.55973 6.58895C6.6699 7.31922 5.9739 8.25766 5.53338 9.32115C5.09285 10.3846 4.92139 11.5404 5.03419 12.6859C5.14699 13.8315 5.54057 14.9316 6.18006 15.8888C6.81955 16.8459 7.68521 17.6306 8.70038 18.1733C9.71554 18.716 10.8489 18.9999 12 19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.76 14.707 15.475 15.177 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.5247 15.1765 8.24017 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
            fill: "var(--ds-icon, #44546F)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M5.503 8.957C5.503 8.55917 5.66103 8.17764 5.94234 7.89634C6.22364 7.61503 6.60517 7.457 7.003 7.457H9.826C10.0367 7.45714 10.2451 7.50168 10.4374 7.58772C10.6298 7.67377 10.8019 7.79938 10.9425 7.95637C11.083 8.11337 11.189 8.29822 11.2533 8.49888C11.3177 8.69955 11.339 8.91153 11.316 9.121L11.147 10.664C11.1066 11.0312 10.9321 11.3706 10.657 11.6171C10.3819 11.8637 10.0254 12 9.656 12H7.003C6.60517 12 6.22364 11.842 5.94234 11.5607C5.66103 11.2794 5.503 10.8978 5.503 10.5V8.957ZM12.678 9.013C12.6556 8.80375 12.6774 8.59213 12.7421 8.39188C12.8068 8.19163 12.9129 8.00723 13.0535 7.85066C13.1941 7.6941 13.3661 7.56888 13.5583 7.48314C13.7505 7.3974 13.9586 7.35306 14.169 7.353H16.979C17.3768 7.353 17.7584 7.51103 18.0397 7.79234C18.321 8.07364 18.479 8.45517 18.479 8.853V10.5C18.479 10.8978 18.321 11.2794 18.0397 11.5607C17.7584 11.842 17.3768 12 16.979 12H14.346C13.976 11.9999 13.619 11.863 13.3438 11.6156C13.0686 11.3683 12.8945 11.0279 12.855 10.66L12.678 9.013Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M10.5 8H13.5V9.5H10.5V8Z",
            fill: "var(--ds-icon, #44546F)"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0_11_3586"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white"
        }))));
    const $b18e7775751687d8$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bM08q"))))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $b18e7775751687d8$var$IconGlyph,
                    ...props
                })
        }));
    };
});
parcelRegister("bM08q", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8924482dc69ed05c$var$_react = $8924482dc69ed05c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8924482dc69ed05c$var$_UNSAFE_baseNew = $8924482dc69ed05c$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $8924482dc69ed05c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8924482dc69ed05c$var$EmojiCasualIcon = (props)=>$8924482dc69ed05c$var$_react.default.createElement($8924482dc69ed05c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M11.25 10.25S10 12 8 12s-3.25-1.75-3.25-1.75m-3.233-5.5a7.25 7.25 0 1 0 12.965 0m-12.965 0A7.25 7.25 0 0 1 8 .75a7.25 7.25 0 0 1 6.483 4m-12.966 0h.733m12.233 0h-.733m-4.875 0 .196 1.825a1.875 1.875 0 0 0 1.864 1.675h1.054a1.25 1.25 0 0 0 1.223-.988l.538-2.512m-4.875 0h4.875m-4.875 0h-1.75m0 0-.196 1.825A1.875 1.875 0 0 1 5.065 8.25H4.011a1.25 1.25 0 0 1-1.223-.988L2.25 4.75m4.875 0H2.25"/>`
        }, props));
    $8924482dc69ed05c$var$EmojiCasualIcon.displayName = 'EmojiCasualIcon';
    var $8924482dc69ed05c$var$_default = module.exports.default = $8924482dc69ed05c$var$EmojiCasualIcon;
});
parcelRegister("1j7Ox", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$3e41f640acf91b91$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $jGjYk;
    var $8K52v;
    const $3e41f640acf91b91$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M18.636 15H7C6.46957 15 5.96086 15.2107 5.58579 15.5858C5.21071 15.9609 5 16.4696 5 17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H19",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M19 15V5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V17",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "2",
            strokeLinejoin: "round"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M19 19C18.4696 19 17.9609 18.7893 17.5858 18.4142C17.2107 18.0391 17 17.5304 17 17C17 16.4696 17.2107 15.9609 17.5858 15.5858C17.9609 15.2107 18.4696 15 19 15",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "2",
            strokeLinecap: "round"
        }));
    const $3e41f640acf91b91$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jGjYk"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $3e41f640acf91b91$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "none"
        }));
    };
});
parcelRegister("jGjYk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e5416e95455591c2$var$_react = $e5416e95455591c2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e5416e95455591c2$var$_UNSAFE_baseNew = $e5416e95455591c2$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $e5416e95455591c2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e5416e95455591c2$var$GlassesIcon = (props)=>$e5416e95455591c2$var$_react.default.createElement($e5416e95455591c2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M.75 10.5a2.75 2.75 0 1 0 5.391-.768M.75 10.5a2.75 2.75 0 0 1 5.391-.768M.75 10.5l.863-6.47a1.88 1.88 0 0 1 1.082-1.46L4.5 1.75m10.75 8.75a2.75 2.75 0 1 1-5.391-.768m5.391.768a2.75 2.75 0 0 0-5.391-.768m5.391.768-.863-6.47a1.88 1.88 0 0 0-1.082-1.46L11.5 1.75M6.141 9.732A2.25 2.25 0 0 1 8 8.75c.772 0 1.454.389 1.859.982"/>`
        }, props));
    $e5416e95455591c2$var$GlassesIcon.displayName = 'GlassesIcon';
    var $e5416e95455591c2$var$_default = module.exports.default = $e5416e95455591c2$var$GlassesIcon;
});
parcelRegister("lEqyG", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$0a940a2c5be096fd$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $6w2oK;
    var $8K52v;
    const $0a940a2c5be096fd$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11.121 5.385L11.278 5.535L11.985 6.242L12.692 5.536C13.6168 4.61388 14.8658 4.09021 16.1717 4.07699C17.4777 4.06378 18.7369 4.56205 19.6803 5.46527C20.6236 6.36848 21.1761 7.60494 21.2195 8.91022C21.263 10.2155 20.7941 11.486 19.913 12.45L19.763 12.607L18.352 14.018L12.71 19.704C12.5359 19.8796 12.3028 19.9845 12.0559 19.9983C11.809 20.0122 11.5657 19.934 11.373 19.779L11.292 19.706L5.62 14.02L4.207 12.607C3.27965 11.6833 2.75151 10.4327 2.73597 9.12391C2.72044 7.81509 3.21875 6.55236 4.12391 5.60688C5.02907 4.6614 6.26889 4.10856 7.57714 4.06707C8.8854 4.02559 10.1578 4.49877 11.121 5.385ZM18.349 11.192C18.8975 10.6395 19.2097 9.89545 19.2197 9.11701C19.2297 8.33857 18.9367 7.58673 18.4026 7.02032C17.8686 6.45391 17.1352 6.1173 16.3575 6.0816C15.5798 6.0459 14.8187 6.31391 14.235 6.829L14.107 6.949L12.692 8.364C12.5592 8.49619 12.3921 8.58855 12.2095 8.63062C12.0269 8.67268 11.8362 8.66277 11.659 8.602C11.5158 8.55271 11.3858 8.47129 11.279 8.364L9.863 6.95C9.31051 6.40153 8.56645 6.08931 7.78801 6.0793C7.00958 6.0693 6.25773 6.36228 5.69132 6.89637C5.12492 7.43045 4.7883 8.1638 4.7526 8.94148C4.7169 9.71916 4.98491 10.4803 5.5 11.064L5.621 11.192L7.036 12.607L11.998 17.582L16.932 12.609L18.349 11.192Z"
        }));
    const $0a940a2c5be096fd$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6w2oK"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $0a940a2c5be096fd$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("6w2oK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4be79778c543f14f$var$_react = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4be79778c543f14f$var$_UNSAFE_baseNew = $4be79778c543f14f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $4be79778c543f14f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4be79778c543f14f$var$HeartIcon = (props)=>$4be79778c543f14f$var$_react.default.createElement($4be79778c543f14f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M8 14.5a.6.6 0 0 1-.245-.061 1.5 1.5 0 0 1-.244-.123q-1.917-1.225-3.324-2.567-1.408-1.348-2.176-2.764-.76-1.422-.761-2.873 0-.905.286-1.654.291-.756.808-1.307A3.6 3.6 0 0 1 5.036 2q1 0 1.754.51.754.511 1.21 1.349A3.76 3.76 0 0 1 9.217 2.51Q9.97 2 10.964 2q.801 0 1.488.3.694.3 1.204.85.516.552.802 1.308.292.749.292 1.654 0 1.45-.768 2.873-.761 1.416-2.169 2.765-1.4 1.342-3.317 2.566a1.4 1.4 0 0 1-.251.123A.6.6 0 0 1 8 14.5Z"/>`
        }, props));
    $4be79778c543f14f$var$HeartIcon.displayName = 'HeartIcon';
    var $4be79778c543f14f$var$_default = module.exports.default = $4be79778c543f14f$var$HeartIcon;
});
parcelRegister("gpxls", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$58ac3c2c25c19847$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $dRzvr;
    var $8K52v;
    const $58ac3c2c25c19847$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "2"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15 13.5H9C8.44772 13.5 8 13.9477 8 14.5C8 15.0523 8.44772 15.5 9 15.5H15C15.5523 15.5 16 15.0523 16 14.5C16 13.9477 15.5523 13.5 15 13.5Z",
            fill: "var(--ds-icon, #44546F)"
        }));
    const $58ac3c2c25c19847$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dRzvr"))))), {
            color: "currentColor",
            label: "",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $58ac3c2c25c19847$var$IconGlyph,
                    ...props
                })
        }));
    };
});
parcelRegister("dRzvr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a17bc45df47a132b$var$_react = $a17bc45df47a132b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a17bc45df47a132b$var$_UNSAFE_baseNew = $a17bc45df47a132b$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a17bc45df47a132b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a17bc45df47a132b$var$EmojiNeutralIcon = (props)=>$a17bc45df47a132b$var$_react.default.createElement($a17bc45df47a132b$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M6.25 6.25a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"/><path stroke="currentcolor" stroke-width="1.5" d="M4.75 10.25h6.5m4-2.25A7.25 7.25 0 1 1 .75 8a7.25 7.25 0 0 1 14.5 0Zm-9-1.75a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm4.5 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"/>`
        }, props));
    $a17bc45df47a132b$var$EmojiNeutralIcon.displayName = 'EmojiNeutralIcon';
    var $a17bc45df47a132b$var$_default = module.exports.default = $a17bc45df47a132b$var$EmojiNeutralIcon;
});
parcelRegister("kkUTO", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$e8b5e78edf3cbfa8$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $kaa7g;
    var $8K52v;
    const $e8b5e78edf3cbfa8$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6 20C5.49542 20.0002 5.00943 19.8096 4.63945 19.4665C4.26947 19.1234 4.04284 18.6532 4.005 18.15L4 18V10C3.99984 9.49542 4.19041 9.00943 4.5335 8.63945C4.87659 8.26947 5.34684 8.04284 5.85 8.005L6 8H8V6C7.99984 5.49542 8.19041 5.00943 8.5335 4.63945C8.87659 4.26947 9.34685 4.04284 9.85 4.005L10 4H14C14.5046 3.99984 14.9906 4.19041 15.3605 4.5335C15.7305 4.87659 15.9572 5.34684 15.995 5.85L16 6V8H18C18.5044 8.00009 18.9901 8.19077 19.3599 8.53384C19.7297 8.8769 19.9562 9.34702 19.994 9.85L20 10V18C19.9999 18.5044 19.8092 18.9901 19.4662 19.3599C19.1231 19.7297 18.653 19.9562 18.15 19.994L18 20H6ZM8 10H6V18H7.999L8 10ZM14 10H10L9.999 18H14V10ZM18 10H16V18H18V10ZM14 6H10V8H14V6Z"
        }));
    const $e8b5e78edf3cbfa8$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kaa7g"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $e8b5e78edf3cbfa8$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("kaa7g", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eadc96b253df8830$var$_react = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eadc96b253df8830$var$_UNSAFE_baseNew = $eadc96b253df8830$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eadc96b253df8830$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eadc96b253df8830$var$BriefcaseIcon = (props)=>$eadc96b253df8830$var$_react.default.createElement($eadc96b253df8830$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 8.75V13c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V8.75m-12.5 0V6c0-.69.56-1.25 1.25-1.25h1.75m-3 4H8m6.25 0V6c0-.69-.56-1.25-1.25-1.25h-1.75m3 4H8m0 0V11M4.75 4.75V3c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v1.75m-6.5 0h6.5"/>`
        }, props));
    $eadc96b253df8830$var$BriefcaseIcon.displayName = 'BriefcaseIcon';
    var $eadc96b253df8830$var$_default = module.exports.default = $eadc96b253df8830$var$BriefcaseIcon;
});
parcelRegister("aRWc6", function(module, exports) {
    $parcel$export(module.exports, "isMinLength", ()=>$dd683a3c13b8ea57$export$9db96a5522993877);
    function $dd683a3c13b8ea57$export$9db96a5522993877({ editorView: editorView, minLength: minLength, positions: positions }) {
        if (!positions || positions && positions[0] === positions[1]) {
            const doc = editorView.state.doc;
            const positionDiff = doc.nodeSize - 4;
            return positionDiff >= minLength;
        } else if (positions && positions[0] !== positions[1]) {
            const positionDiff = positions[1] - positions[0];
            return positionDiff >= minLength;
        } else return 0 >= minLength;
    }
});
parcelRegister("8gvqH", function(module, exports) {
    $parcel$export(module.exports, "getSlice", ()=>$13d20327d12d8f60$export$9899dbe95982df9a);
    function $13d20327d12d8f60$export$9899dbe95982df9a(editorView, positions) {
        if (positions[0] === positions[1]) return editorView.state.doc.slice(0, editorView.state.doc.content.size);
        else return editorView.state.doc.slice(positions[0], positions[1]);
    }
});
parcelRegister("j7znz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b1ce8d6fa16b075c$export$defe85febe8b728c);
    var $7VHMR;
    const $b1ce8d6fa16b075c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nestingParentTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.nestingParentTitle',
            defaultMessage: 'Change tone',
            description: 'Describes a (nested) option to use Atlassian Intelligence to change the tone of content currently selected by the user'
        },
        nestingParentTitlePostGA: {
            id: 'fabric.editor.ai.config.item.range.changeTone.nestingParentTitlePostGA',
            defaultMessage: 'Change tone to ...',
            description: 'Describes a (nested) option to use Atlassian Intelligence to change the tone of content currently selected by the user'
        },
        neutralToneTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.title',
            defaultMessage: 'Change tone to neutral',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        neutralToneShortTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.shortTitle',
            defaultMessage: 'Neutral',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        neutralToneDescription: {
            id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.description',
            defaultMessage: 'Changes the tone of the content to neutral',
            description: 'Desciption for the Atlassian Intellgience "Change tone to neutral" option'
        },
        neutralToneSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Neutral',
            description: 'Title for Atlassian Intelligence "Change tone to neutral" in editor selection floating toolbar'
        },
        professionalToneTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.title',
            defaultMessage: 'Change tone to professional',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        professionalToneShortTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.shortTitle',
            defaultMessage: 'Professional',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        professionalToneDescription: {
            id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.description',
            defaultMessage: 'Changes the tone of the content to professional',
            description: 'Desciption for the Atlassian Intellgience "Change tone to professional" option'
        },
        professionalToneSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Professional',
            description: 'Title for Atlassian Intelligence "Change tone to professional" in editor selection floating toolbar'
        },
        casualToneTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.title',
            defaultMessage: 'Change tone to casual',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        casualToneShortTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.shortTitle',
            defaultMessage: 'Casual',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        casualToneDescription: {
            id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.description',
            defaultMessage: 'Changes the tone of the content to casual',
            description: 'Desciption for the Atlassian Intellgience "Change tone to casual" option'
        },
        casualToneSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Casual',
            description: 'Title for Atlassian Intelligence "Change tone to casual" in editor selection floating toolbar'
        },
        educationalToneTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.title',
            defaultMessage: 'Change tone to educational',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        educationalToneShortTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.shortTitle',
            defaultMessage: 'Educational',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        educationalToneDescription: {
            id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.description',
            defaultMessage: 'Changes the tone of the content to educational',
            description: 'Desciption for the Atlassian Intellgience "Change tone to educational" option'
        },
        educationalToneSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Educational',
            description: 'Title for Atlassian Intelligence "Change tone to educational" in editor selection floating toolbar'
        },
        empatheticToneTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.title',
            defaultMessage: 'Change tone to empathetic',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        empatheticToneShortTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.shortTitle',
            defaultMessage: 'Empathetic',
            description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
        },
        empatheticToneDescription: {
            id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.description',
            defaultMessage: 'Changes the tone of the content to empathetic',
            description: 'Desciption for the Atlassian Intellgience "Change tone to empathetic" option'
        },
        empatheticToneSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Empathetic',
            description: 'Title for Atlassian Intelligence "Change tone to empathetic" in editor selection floating toolbar'
        }
    });
});
parcelRegister("K8sX1", function(module, exports) {
    $parcel$export(module.exports, "improveWriting", ()=>$6b3a4e9527bf0976$export$144a75c8acc1ab6b);
    $parcel$export(module.exports, "fixSpellingAndGrammar", ()=>$6b3a4e9527bf0976$export$f6fbbd65001c33d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $ke5i2;
    var $b0XeV;
    var $8gLLR;
    var $aRWc6;
    var $j7znz;
    var $3D5rg;
    var $8gvqH;
    var $9LvHR;
    const $6b3a4e9527bf0976$var$SELECTION_TYPE = 'range';
    const $6b3a4e9527bf0976$var$createStreamTask = (taskName, intentSchemaId, editorSchema, initialContext)=>{
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return async function*(options) {
            const streaming = (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: intentSchemaId,
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                currentSelection: initialContext.selection
            })(options);
            for await (const streamItem of streaming)yield {
                ...streamItem,
                name: taskName
            };
        };
        else return async function*(options) {
            const streaming = (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: intentSchemaId,
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ]
            })(options);
            for await (const streamItem of streaming)yield {
                ...streamItem,
                name: taskName
            };
        };
    };
    const $6b3a4e9527bf0976$var$tasks = [
        {
            taskName: (0, (0, parcelRequire("3D5rg")).messages).title,
            intentSchemaId: 'shorten_intent_schema.json'
        },
        {
            taskName: (0, (0, parcelRequire("9LvHR")).messages).fixSpellingGrammarTitle,
            intentSchemaId: 'grammar_spelling_intent_schema.json'
        },
        {
            taskName: (0, (0, parcelRequire("j7znz")).messages).professionalToneTitle,
            intentSchemaId: 'change_tone_professional_intent_schema.json'
        }
    ];
    function $6b3a4e9527bf0976$var$createEnhanceOption({ key: key, title: title, description: description, actions: actions, intentSchemaId: intentSchemaId, icon: icon, getBackendModel: getBackendModel }) {
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: key,
            title: title,
            description: description,
            selectionType: $6b3a4e9527bf0976$var$SELECTION_TYPE,
            getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $6b3a4e9527bf0976$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                if (key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).IMPROVE_WRITING && (0, $gmhCD.editorExperiment)('editor_ai_-_multi_prompts', 'test', {
                    exposure: true
                })) return {
                    selection: selection.markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'improve_quality_intent_schema.json',
                    additionalIntentSchemaIds: [
                        'shorten_intent_schema.json',
                        'grammar_spelling_intent_schema.json',
                        'change_tone_professional_intent_schema.json'
                    ],
                    contentStatistics: selection.contentStatistics
                };
                const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    node: editorView.state.doc,
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $6b3a4e9527bf0976$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    selection: selection.markdown,
                    document: document.markdown,
                    userLocale: intl.locale,
                    intentSchemaId: intentSchemaId,
                    contentStatistics: selection.contentStatistics
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                if (intentSchemaId === 'improve_quality_intent_schema.json' && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'improve_quality_intent_schema.json',
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document,
                    currentSelection: initialContext.selection
                });
                if (intentSchemaId === 'grammar_spelling_intent_schema.json' && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'grammar_spelling_intent_schema.json',
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document,
                    currentSelection: initialContext.selection
                });
                return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                    userLocale: initialContext.userLocale,
                    intentSchemaId: intentSchemaId,
                    editorSchema: editorSchema,
                    contextList: [
                        {
                            type: 'ADF_MARKDOWN_V1',
                            entity: initialContext.selection,
                            relationship: 'SELECTION'
                        }
                    ]
                });
            },
            additionalTriggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                if (key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).IMPROVE_WRITING && (0, $gmhCD.editorExperiment)('editor_ai_-_multi_prompts', 'test', {
                    exposure: true
                })) return async function* combinedStream(options) {
                    for (const { taskName: taskName, intentSchemaId: intentSchemaId } of $6b3a4e9527bf0976$var$tasks){
                        const streamTask = $6b3a4e9527bf0976$var$createStreamTask(taskName, intentSchemaId, editorSchema, initialContext);
                        for await (const streamItem of streamTask(options))yield streamItem;
                    }
                };
            },
            isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                    editorView: editorView,
                    minLength: 1,
                    positions: positions
                }),
            icon: icon,
            actions: actions,
            getBackendModel: getBackendModel
        });
    }
    const $6b3a4e9527bf0976$export$144a75c8acc1ab6b = $6b3a4e9527bf0976$var$createEnhanceOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).IMPROVE_WRITING,
        title: (0, (0, parcelRequire("9LvHR")).messages).improveWritingTitle,
        description: (0, (0, parcelRequire("9LvHR")).messages).improveWritingDescription,
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, (0, parcelRequire("8gLLR")).createReplace)({
                appearance: 'primary'
            })
        ],
        intentSchemaId: 'improve_quality_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b0XeV")).Icon), {
                shownAt: shownAt
            }),
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
    const $6b3a4e9527bf0976$export$f6fbbd65001c33d0 = $6b3a4e9527bf0976$var$createEnhanceOption({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
        title: (0, (0, parcelRequire("9LvHR")).messages).fixSpellingGrammarTitle,
        description: (0, (0, parcelRequire("9LvHR")).messages).fixSpellingGrammarDescription,
        actions: [
            (0, (0, parcelRequire("8gLLR")).createReplace)({
                appearance: 'primary'
            })
        ],
        intentSchemaId: 'grammar_spelling_intent_schema.json',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ke5i2")).Icon), {
                shownAt: shownAt
            }),
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("ke5i2", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$2400ba1bfa5c6ab6$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $doTgN;
    var $8K52v;
    const $2400ba1bfa5c6ab6$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M12 4C12.676 4 13.284 4.399 13.556 5.008L13.609 5.142L16.944 14.67C17.0283 14.9108 17.0173 15.1748 16.9134 15.4078C16.8094 15.6408 16.6203 15.8252 16.3848 15.9234C16.1493 16.0215 15.8851 16.0259 15.6465 15.9357C15.4078 15.8455 15.2127 15.6674 15.101 15.438L15.056 15.33L14.232 12.973L14.117 12.993L14 13H10C9.92255 12.9999 9.84536 12.9909 9.77 12.973L8.944 15.33C8.86313 15.5614 8.70011 15.755 8.4859 15.8741C8.27169 15.9932 8.0212 16.0294 7.782 15.976L7.67 15.944C7.43863 15.8631 7.24502 15.7001 7.12593 15.4859C7.00684 15.2717 6.97057 15.0212 7.024 14.782L7.056 14.67L10.391 5.142C10.5078 4.80818 10.7255 4.51893 11.0139 4.31432C11.3024 4.10971 11.6473 3.99987 12.001 4H12ZM12 6.598L10.46 11H13.542L12.002 6.598H12Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M14 17L16 19L20 15",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }));
    const $2400ba1bfa5c6ab6$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("doTgN"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $2400ba1bfa5c6ab6$var$IconGlyph,
                    ...props
                })
        }));
    };
});
parcelRegister("b0XeV", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$6b20d7c986ab273b$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $9Ufjg;
    var $8K52v;
    const $6b20d7c986ab273b$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.45366 7.76225L6.37618 5.68477C6.16881 5.4774 5.8326 5.4774 5.62524 5.68477L5.62453 5.68548C5.41716 5.89284 5.41716 6.22906 5.62453 6.43642L7.70201 8.5139C7.90938 8.72127 8.24559 8.72127 8.45296 8.5139L8.45366 8.5132C8.66103 8.30583 8.66103 7.96962 8.45366 7.76225Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17.6911 5.69892L15.5853 7.80468C15.3858 8.00424 15.3858 8.32779 15.5853 8.52735C15.7849 8.7269 16.1084 8.7269 16.308 8.52735L18.4138 6.42158C18.6133 6.22203 18.6133 5.89848 18.4138 5.69892C18.2142 5.49936 17.8907 5.49936 17.6911 5.69892Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.64164 15.6144L5.58538 17.6706C5.37215 17.8838 5.37215 18.2296 5.58538 18.4428L5.58608 18.4435C5.79931 18.6567 6.14502 18.6567 6.35824 18.4435L8.41451 16.3872C8.62774 16.174 8.62774 15.8283 8.41451 15.6151L8.4138 15.6144C8.20058 15.4011 7.85487 15.4011 7.64164 15.6144Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M6.5 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2761 3.22386 12.5 3.5 12.5H6.5C6.77614 12.5 7 12.2761 7 12C7 11.7239 6.77614 11.5 6.5 11.5Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M20.5 11.5H17.5C17.2239 11.5 17 11.7239 17 12C17 12.2761 17.2239 12.5 17.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M12.5 6.5V3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5V6.5C11.5 6.77614 11.7239 7 12 7C12.2761 7 12.5 6.77614 12.5 6.5Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M12.5 20.5V17.5C12.5 17.2239 12.2761 17 12 17C11.7239 17 11.5 17.2239 11.5 17.5V20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.62 12.913L11.854 11.146C11.7602 11.0521 11.633 10.9993 11.5004 10.9992C11.3677 10.9991 11.2404 11.0517 11.1465 11.1455C11.0526 11.2392 10.9998 11.3665 10.9997 11.4991C10.9996 11.6318 11.0522 11.7591 11.146 11.853L12.913 13.62L13.62 12.913ZM12.56 10.439C12.277 10.1659 11.898 10.0149 11.5047 10.0185C11.1114 10.0221 10.7353 10.18 10.4573 10.4582C10.1793 10.7365 10.0217 11.1128 10.0185 11.5061C10.0153 11.8994 10.1666 12.2782 10.44 12.561L17.51 19.631C17.6483 19.7743 17.8138 19.8887 17.9967 19.9674C18.1797 20.0461 18.3765 20.0875 18.5757 20.0894C18.7748 20.0912 18.9724 20.0533 19.1568 19.978C19.3411 19.9027 19.5087 19.7914 19.6496 19.6506C19.7905 19.5098 19.9019 19.3424 19.9774 19.1581C20.053 18.9738 20.091 18.7763 20.0894 18.5771C20.0877 18.3779 20.0464 18.1811 19.9679 17.998C19.8894 17.815 19.7752 17.6494 19.632 17.511L12.56 10.439Z"
        }));
    const $6b20d7c986ab273b$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9Ufjg"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $6b20d7c986ab273b$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("9Ufjg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7365382f8b17701f$var$_react = $7365382f8b17701f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7365382f8b17701f$var$_UNSAFE_baseNew = $7365382f8b17701f$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $7365382f8b17701f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7365382f8b17701f$var$MagicWandIcon = (props)=>$7365382f8b17701f$var$_react.default.createElement($7365382f8b17701f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m9.25 8.75-6.058 6.058a.625.625 0 0 1-.884 0l-1.116-1.116a.625.625 0 0 1 0-.884L7.25 6.75m2 2 2.058-2.058a.625.625 0 0 0 0-.884l-1.116-1.116a.625.625 0 0 0-.884 0L7.25 6.75m2 2-2-2M10.75 0v2m2.298.952 1.414-1.414M14 5.25h2M7.038 1.538l1.414 1.414m4.596 4.596 1.414 1.414"/>`
        }, props));
    $7365382f8b17701f$var$MagicWandIcon.displayName = 'MagicWandIcon';
    var $7365382f8b17701f$var$_default = module.exports.default = $7365382f8b17701f$var$MagicWandIcon;
});
parcelRegister("3D5rg", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$57b8ee047aa42b38$export$defe85febe8b728c);
    var $7VHMR;
    const $57b8ee047aa42b38$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.range.shorten.title',
            defaultMessage: 'Make shorter',
            description: 'Describes an option to use Atlassian Intelligence to shorten the content currently selected by the user'
        },
        description: {
            id: 'fabric.editor.ai.config.item.range.shorten.description',
            defaultMessage: 'Shortens the content to make it more concise',
            description: 'Description for the the Atlassian Intelligence "Shorten".'
        },
        selectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.shorten.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Make shorter',
            description: 'Title for Atlassian Intelligence "Shorten" in editor selection floating toolbar'
        }
    });
});
parcelRegister("9LvHR", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6c343826c6fa141f$export$defe85febe8b728c);
    var $7VHMR;
    const $6c343826c6fa141f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        improveWritingTitle: {
            id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.title',
            defaultMessage: 'Improve writing',
            description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
        },
        improveWritingSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Improve writing',
            description: 'Title for Atlassian Intelligence "improve writing" in editor selection floating toolbar'
        },
        fixSpellingGrammarTitle: {
            id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.title',
            defaultMessage: 'Fix spelling & grammar',
            description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
        },
        improveWritingDescription: {
            id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.description',
            defaultMessage: 'Enhances clarity, structure, and tone for better engagement and comprehension',
            description: 'Description for the the Atlassian Intelligence "Improve Writing".'
        },
        fixSpellingGrammarDescription: {
            id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.description',
            defaultMessage: 'Fixes spelling and grammar mistakes',
            description: 'Description for the the Atlassian Intelligence "Fix Spelling & Grammar".'
        },
        fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title',
            defaultMessage: 'Spelling & grammar',
            description: 'Title for Atlassian Intelligence "fix spelling grammar" in editor selection floating toolbar'
        }
    });
});
parcelRegister("fCAMT", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$8137790e6b0e79d5$export$defe85febe8b728c);
    var $7VHMR;
    const $8137790e6b0e79d5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        aiToolbarTitle: {
            id: 'fabric.editor.ai.toolbar.titleText',
            defaultMessage: 'Atlassian Intelligence',
            description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
        },
        improveWritingToolbarIconTitle: {
            id: 'fabric.editor.ai.toolbar.improveWriting.title',
            defaultMessage: 'Improve writing',
            description: 'Title for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
        },
        improveWritingToolbarIconTooltip: {
            id: 'fabric.editor.ai.toolbar.improveWriting.tooltip',
            defaultMessage: 'Tell Atlassian Intelligence to improve the writing of your selection',
            description: 'Tooltip text for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
        },
        tryAIToolbarIconTitle: {
            id: 'fabric.editor.ai.toolbar.tryAI.title',
            defaultMessage: 'Try AI',
            description: 'Title for an option to use Atlassian Intellgience'
        },
        tryAIToolbarIconTooltip: {
            id: 'fabric.editor.ai.toolbar.tryAI.tooltip',
            defaultMessage: 'Open Atlassian Intelligence',
            description: 'Tooltip text for an option to use Atlassian Intellgience'
        }
    });
});
parcelRegister("afxsk", function(module, exports) {
    $parcel$export(module.exports, "AIFloatingToolbarFooter", ()=>$5f21368549773a53$export$fd23945589a43d51);
    var $f8Sb3;
    var $koVbs;
    var $lj8SI;
    var $i0hyP;
    var $gz7p0;
    var $1gMeD;
    const $5f21368549773a53$export$fd23945589a43d51 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("1gMeD")).aiFloatingToolbarCss)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("p", null, formatMessage((0, (0, parcelRequire("gz7p0")).messages).contentQuality)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("lj8SI")).default), null, "BETA")), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("1gMeD")).aiFloatingToolbarCss)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("p", null, formatMessage((0, (0, parcelRequire("gz7p0")).messages).poweredByAi)), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i0hyP")).LogoSvg), {
            alt: formatMessage((0, (0, parcelRequire("gz7p0")).messages).logoAltText),
            size: 14,
            colorStart: "var(--ds-text-subtlest, #626F86)",
            colorStop: "var(--ds-text-subtlest, #626F86)"
        })));
    };
});
parcelRegister("gz7p0", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0fb754738c79b9a4$export$defe85febe8b728c);
    var $7VHMR;
    const $0fb754738c79b9a4$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        contentQuality: {
            id: 'fabric.editor.ai.ai-panels.contentQuality',
            defaultMessage: 'Content quality may vary',
            description: 'Content quality may vary label'
        },
        poweredByAi: {
            id: 'fabric.editor.ai.ai-panels.poweredByAi',
            defaultMessage: 'Powered by AI',
            description: 'Powered by AI label'
        },
        logoAltText: {
            id: 'fabric.editor.ai.ai-panels.logoAltText',
            defaultMessage: 'Atlassian Intelligence Logo',
            description: 'Atlassian Intelligence logo alt text'
        }
    });
});
parcelRegister("1gMeD", function(module, exports) {
    $parcel$export(module.exports, "aiFloatingToolbarCss", ()=>$8c9f4bd8944d1a23$export$44767fc7a0ee9d9a);
    var $f8Sb3;
    const $8c9f4bd8944d1a23$export$44767fc7a0ee9d9a = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
        display: 'flex',
        alignItems: 'center',
        '& p': {
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            color: "var(--ds-text-subtlest, #626F86)",
            marginRight: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const $8c9f4bd8944d1a23$export$f022d5be60bd5efb = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        alignItems: 'center',
        '& p': {
            margin: 0,
            padding: `0 ${"var(--ds-space-050, 4px)"} 0 0`
        }
    });
});
parcelRegister("51rZO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$ff3efdb16492d95d$export$defe85febe8b728c);
    var $7VHMR;
    const $ff3efdb16492d95d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        dismissSuggestion: {
            id: 'fabric.editor.ai.spellingAndGrammar.suggestions.dismiss',
            defaultMessage: 'Dismiss suggestion',
            description: 'The tooltip message display for the dismiss icon button in the suggestion toolbar'
        },
        suggestionInformationTooltip: {
            id: 'fabric.editor.ai.spellingAndGrammar.suggestions.information.no-translate',
            defaultMessage: "We\u2019re experimenting with this feature and would welcome any feedback in <feedback>#feedback-spelling-and-grammar</feedback>.",
            description: 'The tooltip message displayed on the information button which appears in the suggestions floating toolbar'
        },
        improveSentenceToolbarButtonLabel: {
            id: 'fabric.editor.ai.spellingAndGrammar.suggestions.improve-sentence.toolbar-button-label',
            defaultMessage: 'Improve sentence',
            description: 'The floating toolbar button to improve sentence using AI'
        },
        correctSuggestion: {
            id: 'fabric.editor.ai.spellingAndGrammar.suggestions.correct-suggestion',
            defaultMessage: 'Correct suggestion',
            description: 'The message displayed on the correct suggestion icon dropdown item in the suggestion toolbar'
        },
        incorrectSuggestion: {
            id: 'fabric.editor.ai.spellingAndGrammar.suggestions.incorrect-suggestion',
            defaultMessage: 'Incorrect suggestion',
            description: 'The message displayed on the incorrect suggestion icon dropdown item in the suggestion toolbar'
        }
    });
});
parcelRegister("eWoX4", function(module, exports) {
    $parcel$export(module.exports, "separator", ()=>$b6864f4a417826c9$export$3e523c77c1f23f8c);
    const $b6864f4a417826c9$export$3e523c77c1f23f8c = (hidden)=>{
        return {
            type: 'separator',
            hidden: hidden
        };
    };
});
parcelRegister("dOjx6", function(module, exports) {
    $parcel$export(module.exports, "createAIButtonPlugin", ()=>$c4b82e857d2cbe8b$export$e65c99dea6a50353);
    var $5KWxh;
    var $gZGBX;
    var $5r0mK = parcelRequire("5r0mK");
    var $gmhCD = parcelRequire("gmhCD");
    var $2nx9e;
    var $lCsC6;
    const $c4b82e857d2cbe8b$export$e65c99dea6a50353 = (options)=>{
        const { dispatch: dispatch } = options;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("lCsC6")).aiButtonPluginKey),
            state: {
                init: (_, state)=>({
                        isSelectionValidForAIExperience: true
                    }),
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    if (tr.selectionSet) {
                        const selection = tr.selection;
                        const { $from: $from } = selection;
                        const parent = $from.parent;
                        const { codeBlock: codeBlock, tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = newEditorState.schema.nodes;
                        const isNodeSelection = selection instanceof (0, (0, parcelRequire("gZGBX")).NodeSelection);
                        const isSelectionInCodeBlock = parent.type === codeBlock;
                        const isCellSelection = [
                            tableHeader,
                            tableCell,
                            tabeRow,
                            table
                        ].includes(parent.type);
                        let isSelectionValidForAIExperience = true;
                        if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) isSelectionValidForAIExperience = false;
                        let newPluginState = {
                            isSelectionValidForAIExperience: isSelectionValidForAIExperience
                        };
                        const getParentSupportedForAIButton = ()=>{
                            const supportedNodesForAI = (0, (0, parcelRequire("2nx9e")).getSupportedNodesForAIModal)(newEditorState);
                            if (isNodeSelection) return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
                            else {
                                const parentNodeFindResult = (0, $5r0mK.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                                return parentNodeFindResult?.node;
                            }
                        };
                        const parentSupportedForAIButton = getParentSupportedForAIButton();
                        const { from: from, to: to } = selection;
                        if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
                            if ((0, $gmhCD.editorExperiment)('platform_editor_ai_ai_button_block_elements', 'test', {
                                exposure: true
                            })) {
                                const isTextSelection = selection instanceof (0, (0, parcelRequire("gZGBX")).TextSelection);
                                const isSelectionValidForAIExperience = !isSelectionInCodeBlock && (isTextSelection || !!parentSupportedForAIButton);
                                const triggeredFor = parentSupportedForAIButton?.type;
                                newPluginState = {
                                    isSelectionValidForAIExperience: isSelectionValidForAIExperience,
                                    triggeredFor: triggeredFor
                                };
                            }
                        }
                        dispatch((0, (0, parcelRequire("lCsC6")).aiButtonPluginKey), newPluginState);
                        return newPluginState;
                    }
                    return _pluginState;
                }
            }
        });
    };
});
parcelRegister("lCsC6", function(module, exports) {
    $parcel$export(module.exports, "aiButtonPluginKey", ()=>$8fa835313b358ab1$export$521879fd431ff390);
    var $gZGBX;
    const $8fa835313b358ab1$export$521879fd431ff390 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiExperienceAIButton');
});
parcelRegister("k7FZu", function(module, exports) {
    $parcel$export(module.exports, "createAIEventHubPlugin", ()=>$b0b7b06e2fd6b817$export$c83eff15443f700);
    var $5KWxh;
    var $3cfam;
    var $27fLN;
    var $1BdtL;
    var $6r6rN;
    var $7tQb3;
    var $7kxuD;
    var $9Tzox;
    var $jySii;
    const $b0b7b06e2fd6b817$export$c83eff15443f700 = (options)=>{
        const { aiGlobalOptIn: aiGlobalOptIn } = options;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("27fLN")).aiEventHubPluginKey),
            view: (editorView)=>{
                let currentEditorView = editorView;
                const { unsubscribe: unsubscribe } = (0, (0, parcelRequire("1BdtL")).eventHub).subscribe({
                    event: 'start prompt',
                    callback: (data)=>{
                        const editorId = (0, (0, parcelRequire("9Tzox")).findEditorIdFromView)(currentEditorView);
                        if (editorId === data.targetEditorId) {
                            const { state: state, dispatch: dispatch } = currentEditorView;
                            const configItem = (0, (0, parcelRequire("7kxuD")).getConfigItem)(data.prompt, options.editorPluginAIProvider, data.adjustSelection);
                            if (!configItem) {
                                (0, (0, parcelRequire("7tQb3")).firePromptConfigNotFoundError)({
                                    dispatch: dispatch,
                                    editorView: currentEditorView,
                                    prompt: data.prompt,
                                    promptText: data.prompt === (0, (0, parcelRequire("6r6rN")).EventHubPrompt).CustomPrompt ? data.promptText : undefined,
                                    adjustSelection: data.adjustSelection
                                });
                                return;
                            }
                            const params = {
                                state: state,
                                configItem: configItem,
                                lastTriggeredFrom: data.analyticSourceId,
                                aiGlobalOptIn: aiGlobalOptIn,
                                adjustSelection: data.adjustSelection,
                                initialPrompt: data.prompt === (0, (0, parcelRequire("6r6rN")).EventHubPrompt).CustomPrompt ? data.promptText : undefined
                            };
                            if (data.hideModal) (0, (0, parcelRequire("jySii")).handleStreamingService)({
                                getIntl: options.getIntl,
                                currentEditorView: currentEditorView,
                                editorPluginAIProvider: options.editorPluginAIProvider,
                                configItem: configItem,
                                streamingCallback: data.streamingCallback
                            });
                            else {
                                const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)(params);
                                openAIModalCommand(state, dispatch);
                            }
                        }
                    }
                });
                return {
                    update: (newEditorView)=>{
                        currentEditorView = newEditorView;
                    },
                    destroy: ()=>{
                        unsubscribe();
                    }
                };
            }
        });
    };
});
parcelRegister("27fLN", function(module, exports) {
    $parcel$export(module.exports, "aiEventHubPluginKey", ()=>$eef29348c387c681$export$e54fe7f659b58e64);
    var $gZGBX;
    const $eef29348c387c681$export$e54fe7f659b58e64 = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiEventHub');
});
parcelRegister("6r6rN", function(module, exports) {
    $parcel$export(module.exports, "EventHubPrompt", ()=>$c20c516bb7946e3a$export$4cefcfab1f987be5);
    const $c20c516bb7946e3a$var$EventHubEvent = {
        StartPrompt: 'start prompt',
        ReplaceConfluenceTitle: 'replace title in confluence'
    };
    const $c20c516bb7946e3a$export$4cefcfab1f987be5 = {
        SuggestTitleConfluenceTitleToolbar: 'suggest title in confluence title toolbar',
        SuggestTitle: 'suggest title',
        CustomPrompt: 'custom prompt',
        IssueReformatter: 'issue reformatter',
        Summarize: 'summarize',
        ImproveWriting: 'improve writing',
        MakeShorter: 'make shorter',
        FixSpellingGrammar: 'fix spelling and grammar',
        ChangeToneToProfessional: 'change tone to professional',
        ChangeToneToNeutral: 'change tone to neutral',
        ChangeToneToEmpathetic: 'change tone to empathetic',
        ChangeToneToCasual: 'change tone to casual',
        ChangeToneToEducational: 'change tone to educational'
    };
});
parcelRegister("7tQb3", function(module, exports) {
    $parcel$export(module.exports, "firePromptConfigNotFoundError", ()=>$eede2a7282534bde$export$3ddc9d41f6af5056);
    var $gkwXh;
    var $9m3ZB;
    const $eede2a7282534bde$export$3ddc9d41f6af5056 = ({ editorView: editorView, dispatch: dispatch, prompt: prompt, adjustSelection: adjustSelection, promptText: promptText })=>{
        const errorEventTr = (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
            editorState: editorView.state,
            tr: editorView.state.tr,
            payload: {
                action: 'error',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'eventHubPlugin',
                attributes: {
                    errorType: 'promptConfigItemNotFound',
                    prompt: prompt,
                    promptText: promptText,
                    adjustSelection: adjustSelection
                },
                eventType: (0, (0, parcelRequire("gkwXh")).EVENT_TYPE).OPERATIONAL
            }
        });
        dispatch(errorEventTr);
    };
});
parcelRegister("7kxuD", function(module, exports) {
    $parcel$export(module.exports, "getConfigItem", ()=>$7329655f5ddc2e60$export$bd5d7e8cfaa78c6f);
    var $eUFkl;
    var $ZSUOD;
    var $6r6rN;
    const $7329655f5ddc2e60$var$getConfigFromProvider = (editorPluginAIProvider, configType, key)=>{
        const provider = editorPluginAIProvider[configType];
        if (key === (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FREE_GENERATE) return provider.baseGenerate;
        else {
            const configItem = provider.getSuggestions({
                inputValue: ''
            })?.find((suggestion)=>suggestion.key === key);
            return configItem;
        }
    };
    const $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection = (adjustSelection)=>{
        switch(adjustSelection){
            case 'fullDocument':
                return 'rangeConfig';
            case 'keepCurrent':
                return 'rangeConfig';
            default:
                return 'emptyConfig';
        }
    };
    const $7329655f5ddc2e60$export$bd5d7e8cfaa78c6f = (prompt, editorPluginAIProvider, adjustSelection)=>{
        switch(prompt){
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).SuggestTitleConfluenceTitleToolbar:
                return 0, (0, parcelRequire("ZSUOD")).suggestConfigItemForConfluenceTitleToolbar;
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).SuggestTitle:
                {
                    const suggestTitle = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_A_TITLE);
                    return suggestTitle;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).CustomPrompt:
                {
                    const freeGenerate = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FREE_GENERATE);
                    return freeGenerate;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).IssueReformatter:
                {
                    const issueReformatter = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ADD_STRUCTURE);
                    return issueReformatter;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).Summarize:
                {
                    const summarize = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUMMARISE_WRITING);
                    return summarize;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ImproveWriting:
                {
                    const improveWriting = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).IMPROVE_WRITING);
                    return improveWriting;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).MakeShorter:
                {
                    const makeShorter = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).MAKE_SHORTER);
                    return makeShorter;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).FixSpellingGrammar:
                {
                    const fixSpellingGrammar = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR);
                    return fixSpellingGrammar;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ChangeToneToProfessional:
                {
                    const professionalTone = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL);
                    return professionalTone;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ChangeToneToNeutral:
                {
                    const neutralTone = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL);
                    return neutralTone;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ChangeToneToEmpathetic:
                {
                    const empatheticTone = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC);
                    return empatheticTone;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ChangeToneToCasual:
                {
                    const empatheticTone = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL);
                    return empatheticTone;
                }
            case (0, (0, parcelRequire("6r6rN")).EventHubPrompt).ChangeToneToEducational:
                {
                    const empatheticTone = $7329655f5ddc2e60$var$getConfigFromProvider(editorPluginAIProvider, $7329655f5ddc2e60$var$getConfigTypeByAdjustSelection(adjustSelection), (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL);
                    return empatheticTone;
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("ZSUOD", function(module, exports) {
    $parcel$export(module.exports, "suggestConfigItemForConfluenceTitleToolbar", ()=>$3dfb2e9e927416e7$export$1cda52810d955d8d);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $87u0L;
    var $8gLLR;
    var $aRWc6;
    var $8gvqH;
    var $8TsVv;
    const $3dfb2e9e927416e7$var$SELECTION_TYPE = 'range';
    const $3dfb2e9e927416e7$export$91dbca81a2af6bab = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, (0, parcelRequire("8TsVv")).messages).title,
        description: (0, (0, parcelRequire("8TsVv")).messages).description,
        selectionType: $3dfb2e9e927416e7$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                editorView: editorView,
                convertTo: 'markdown',
                updateIdMap: updateIdMap,
                selectionType: $3dfb2e9e927416e7$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                editorView: editorView,
                convertTo: 'markdown',
                updateIdMap: updateIdMap,
                selectionType: $3dfb2e9e927416e7$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                contentStatistics: selection.contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                editorSchema: editorSchema,
                currentSelection: initialContext.selection,
                fullDocument: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'text',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ]
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("87u0L")).Icon), {
                shownAt: shownAt
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                appearance: 'secondary'
            }),
            (0, (0, parcelRequire("8gLLR")).createInsertAtTop)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
    const $3dfb2e9e927416e7$export$1cda52810d955d8d = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, (0, parcelRequire("8TsVv")).messages).title,
        description: (0, (0, parcelRequire("8TsVv")).messages).description,
        selectionType: 'range',
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                editorView: editorView,
                convertTo: 'markdown',
                updateIdMap: updateIdMap,
                selectionType: 'range',
                mentionMap: mentionMap
            });
            return {
                selection: markdown,
                userLocale: intl.locale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                contentStatistics: contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                editorSchema: editorSchema,
                currentSelection: initialContext.selection,
                fullDocument: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: 'suggest_title_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'text',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ]
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("87u0L")).Icon), {
                shownAt: shownAt
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createReplaceExistingConfluenceTitle)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("87u0L", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$9ba18832f44cab60$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $5Hpaz;
    var $8K52v;
    const $9ba18832f44cab60$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "var(--ds-icon, #44546F)",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V8Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17 6H7C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H17C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6Z"
        }));
    const $9ba18832f44cab60$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5Hpaz"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $9ba18832f44cab60$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("8TsVv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$a877e68ffe08e87f$export$defe85febe8b728c);
    var $7VHMR;
    const $a877e68ffe08e87f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.range.suggest.title',
            defaultMessage: 'Suggest a title',
            description: 'Describes an option to use Atlassian Intellgience to suggest an appropriate title for the content currently selected by the user'
        },
        description: {
            id: 'fabric.editor.ai.config.item.range.suggest.description',
            defaultMessage: 'Suggests a title for content you provide',
            description: 'Describes "Suggest a Title" Atlassian Intelligence feature to suggest an appropriate title for the content currently selected by the user'
        }
    });
});
parcelRegister("jySii", function(module, exports) {
    $parcel$export(module.exports, "handleStreamingService", ()=>$a06570df6dbd0275$export$20a4431e680ea8af);
    var $hjzKw;
    const $a06570df6dbd0275$export$20a4431e680ea8af = ({ getIntl: getIntl, editorPluginAIProvider: editorPluginAIProvider, currentEditorView: currentEditorView, configItem: configItem, streamingCallback: streamingCallback })=>{
        const intl = getIntl();
        const context = {
            aiProvider: editorPluginAIProvider,
            editorView: currentEditorView,
            configItem: configItem,
            intl: intl,
            positions: [
                0,
                0
            ],
            responseHistory: []
        };
        const event = {};
        streamingCallback({
            type: 'initialising'
        });
        const callbackHandler = (0, (0, parcelRequire("hjzKw")).streamingService)(context, event);
        callbackHandler((streamData)=>{
            if (streamData) switch(streamData.type){
                case 'stream':
                    if (streamData.loadingStatus === 'ANALYSING_QUERY') streamingCallback({
                        type: 'analysingQuery'
                    });
                    else streamingCallback({
                        type: 'streaming',
                        result: streamData.markdown
                    });
                    break;
                case 'complete':
                    streamingCallback({
                        type: 'complete',
                        result: streamData.markdown
                    });
                    break;
                case 'error':
                case 'response too similar':
                    streamingCallback(streamData);
                    break;
                default:
                    break;
            }
        });
    };
});
parcelRegister("8uikQ", function(module, exports) {
    $parcel$export(module.exports, "createProactiveAIPlugin", ()=>$fa959f933c0e3cb2$export$d1487652d51eebe9);
    var $bXrHm = parcelRequire("bXrHm");
    var $5KWxh;
    var $etG8M;
    var $9m3ZB;
    var $eLhn5;
    var $cCAIN;
    var $lBepp;
    var $5wKtX;
    var $b2OAx;
    function $fa959f933c0e3cb2$export$d1487652d51eebe9(options) {
        const proactiveAIConfig = options.proactiveAIConfig;
        const { triggerProactiveCheck: triggerProactiveCheck, cancelDebouncedAndThrottledCheck: cancelDebouncedAndThrottledCheck } = (0, (0, parcelRequire("cCAIN")).createTriggerProactiveCheck)(proactiveAIConfig.timings);
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("eLhn5")).aiProactivePluginKey),
            state: (0, (0, parcelRequire("lBepp")).createPluginState)(options.dispatch, (0, (0, parcelRequire("lBepp")).createInitialState)({
                proactiveAIApiUrl: options.proactiveAIConfig.apiUrl,
                defaultToggledState: options.proactiveAIConfig.defaultToggledState,
                product: options.product
            })),
            view (view) {
                const { locale: locale } = options.getIntl();
                const unsubscribeViewModeChange = options.api?.editorViewMode?.sharedState.onChange((sharedState)=>{
                    if (sharedState.nextSharedState?.mode !== sharedState.prevSharedState?.mode && sharedState.nextSharedState?.mode !== 'edit') (0, (0, parcelRequire("cCAIN")).closeProactiveAISuggestionDisplay)('viewModeChanged')(view.state, view.dispatch);
                });
                return {
                    update: (view, prevState)=>{
                        const { isProactiveEnabled: isProactiveEnabled } = (0, (0, parcelRequire("lBepp")).getPluginState)(view.state);
                        if (isProactiveEnabled && (!prevState.doc.eq(view.state.doc) || !prevState.selection.eq(view.state.selection))) triggerProactiveCheck({
                            view: view,
                            locale: locale,
                            getMentionNameDetails: options.getMentionNameDetails
                        });
                    },
                    destroy: ()=>{
                        unsubscribeViewModeChange?.();
                        cancelDebouncedAndThrottledCheck();
                    }
                };
            },
            props: {
                decorations: (state)=>{
                    const { isProactiveEnabled: isProactiveEnabled, decorationSet: decorationSet, alwaysDisplayProactiveInlineDecorations: alwaysDisplayProactiveInlineDecorations, isProactiveContextPanelOpen: isProactiveContextPanelOpen } = (0, (0, parcelRequire("lBepp")).getPluginState)(state);
                    if (!isProactiveEnabled || options.api?.editorViewMode?.sharedState.currentState()?.mode !== 'edit') return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                    if (alwaysDisplayProactiveInlineDecorations || isProactiveContextPanelOpen) return decorationSet;
                    return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                }
            },
            appendTransaction: (_, oldState, newState)=>{
                const oldPluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(oldState);
                const newPluginState = (0, (0, parcelRequire("lBepp")).getPluginState)(newState);
                const { selectedRecommendationId: prevSelectedRecommendationId, isProactiveContextPanelOpen: prevIsProactiveContextPanelOpen } = oldPluginState;
                const { isProactiveEnabled: isProactiveEnabled, selectedRecommendationId: selectedRecommendationId, alwaysDisplayProactiveInlineDecorations: alwaysDisplayProactiveInlineDecorations, isProactiveContextPanelOpen: isProactiveContextPanelOpen } = newPluginState;
                const isOpening = isProactiveContextPanelOpen && prevIsProactiveContextPanelOpen !== isProactiveContextPanelOpen;
                const isSelecting = !!selectedRecommendationId && prevSelectedRecommendationId !== selectedRecommendationId && !oldState.selection.eq(newState.selection);
                if (isProactiveEnabled && (isOpening || isSelecting) && !!selectedRecommendationId && (alwaysDisplayProactiveInlineDecorations || isProactiveContextPanelOpen) && newState.selection.from === newState.selection.to) {
                    const { recommendation: recommendation } = (0, (0, parcelRequire("b2OAx")).getBlockFromRecommendationId)(newPluginState, selectedRecommendationId);
                    if (recommendation) {
                        const analyticsAIInteractionId = (0, ($parcel$interopDefault($bXrHm)))();
                        return (0, (0, parcelRequire("9m3ZB")).addAnalytics)({
                            editorState: newState,
                            tr: newState.tr,
                            payload: (0, (0, parcelRequire("9m3ZB")).createUnifiedAnalyticPayload)('initiated', analyticsAIInteractionId, recommendation.transformAction, true)
                        }).setMeta((0, (0, parcelRequire("eLhn5")).aiProactivePluginKey), {
                            type: (0, (0, parcelRequire("5wKtX")).ACTIONS).UPDATE_PLUGIN_STATE,
                            data: {
                                analyticsAIInteractionId: analyticsAIInteractionId
                            }
                        });
                    }
                }
            }
        });
    }
});
parcelRegister("egWUf", function(module, exports) {
    $parcel$export(module.exports, "getConfiguration", ()=>$5de307c5df174c9d$export$3de01744a82b21a4);
    var $VSDnB;
    var $e4Vft;
    const $5de307c5df174c9d$export$3de01744a82b21a4 = (editorPluginAIProvider)=>{
        const { proactiveAIConfig: proactiveAIConfig, isFullPageExperimentsEnabled: isFullPageExperimentsEnabled, allowProactiveAIFeatures: allowProactiveAIFeatures } = editorPluginAIProvider;
        const isProactiveAISupported = !!isFullPageExperimentsEnabled && !!allowProactiveAIFeatures && !!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_visual_formatting');
        return {
            isProactiveAISupported: isProactiveAISupported,
            proactiveAIConfig: {
                ...proactiveAIConfig,
                enabled: isProactiveAISupported,
                defaultToggledState: false,
                apiUrl: (0, (0, parcelRequire("e4Vft")).deriveProactiveAIApiUrl)(),
                timings: {
                    currentChunks: -1,
                    currentChunksMaxWait: 30000,
                    nonCurrentChunks: 5000
                },
                documentSGChecker: undefined
            }
        };
    };
});
parcelRegister("5uFuh", function(module, exports) {
    $parcel$export(module.exports, "createAISpellingGrammarPlugin", ()=>$d0a38f760e564219$export$709e3bf8b2cd00bb);
    var $bXrHm = parcelRequire("bXrHm");
    var $5KWxh;
    var $etG8M;
    var $VSDnB;
    var $hcRrA;
    var $ldiyo;
    var $dKZcc;
    var $bHdjO;
    var $4dOAK;
    var $5ilgR;
    const $d0a38f760e564219$var$documentSGChecker = new (0, (0, parcelRequire("bHdjO")).DocumentSGChecker)();
    function $d0a38f760e564219$export$709e3bf8b2cd00bb(options) {
        const proactiveAIConfig = options.proactiveAIConfig;
        const { triggerSpellingAndGrammarCheck: triggerSpellingAndGrammarCheck, cancelDebouncedAndThrottledSpellingAndGrammarCheck: cancelDebouncedAndThrottledSpellingAndGrammarCheck } = (0, (0, parcelRequire("ldiyo")).createTriggerSpellingAndGrammarCheck)(proactiveAIConfig.timings);
        const { documentSGChecker: documentSGCheckerConfig } = proactiveAIConfig;
        const documentSGCheckerEnabled = documentSGCheckerConfig?.enabled;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey),
            state: (0, (0, parcelRequire("4dOAK")).createPluginState)(options.dispatch, (0, (0, parcelRequire("4dOAK")).createInitialState)({
                proactiveAIApiUrl: options.proactiveAIConfig.apiUrl,
                documentSGChecker: documentSGCheckerEnabled ? $d0a38f760e564219$var$documentSGChecker : undefined,
                defaultToggledState: options.proactiveAIConfig.defaultToggledState
            })),
            view (view) {
                const { locale: locale } = options.getIntl();
                if (documentSGCheckerEnabled) {
                    $d0a38f760e564219$var$documentSGChecker.reset();
                    $d0a38f760e564219$var$documentSGChecker.setEditorViewAndLocale(documentSGCheckerConfig, view, locale);
                }
                return {
                    update: (view, prevState)=>{
                        const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled } = (0, (0, parcelRequire("4dOAK")).getPluginState)(view.state);
                        if (isSpellingAndGrammarEnabled && (!prevState.doc.eq(view.state.doc) || !prevState.selection.eq(view.state.selection))) triggerSpellingAndGrammarCheck(view, locale);
                    },
                    destroy: ()=>{
                        cancelDebouncedAndThrottledSpellingAndGrammarCheck();
                        $d0a38f760e564219$var$documentSGChecker.reset();
                    }
                };
            },
            props: {
                decorations: (state)=>{
                    const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, decorationSet: decorationSet } = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
                    if (!isSpellingAndGrammarEnabled || options.api?.editorViewMode?.sharedState.currentState()?.mode !== 'edit') return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                    return decorationSet;
                },
                attributes: (state)=>{
                    const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled } = (0, (0, parcelRequire("4dOAK")).getPluginState)(state);
                    if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_force_browser_spellcheck')) return {
                        spellcheck: 'true'
                    };
                    return {
                        spellcheck: `${!isSpellingAndGrammarEnabled}`
                    };
                }
            },
            appendTransaction: (_tr, oldState, newState)=>{
                const oldPluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(oldState);
                const newPluginState = (0, (0, parcelRequire("4dOAK")).getPluginState)(newState);
                const { decorationSet: oldDeco, selectedID: prevSelectedID } = oldPluginState;
                const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, decorationSet: newDeco } = newPluginState;
                if (isSpellingAndGrammarEnabled && newState.selection.from === newState.selection.to) {
                    const selectedDiff = (0, (0, parcelRequire("5ilgR")).getSelectedDiffObject)(newPluginState, newState.selection.to);
                    const prevSelectedDiff = (0, (0, parcelRequire("5ilgR")).getSelectedDiffObject)(oldPluginState, oldState.selection.to);
                    const isNotTheSameSelectedDiff = prevSelectedDiff?.id !== selectedDiff?.id;
                    const uniqueInteractionID = (0, ($parcel$interopDefault($bXrHm)))();
                    if (!oldState.selection.eq(newState.selection)) {
                        if (selectedDiff && isNotTheSameSelectedDiff) {
                            if (!prevSelectedDiff) {
                                const tr = (0, (0, parcelRequire("dKZcc")).viewSuggestionWithAnalytics)(uniqueInteractionID, newState);
                                tr.setMeta((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey), {
                                    uniqueInteractionID: uniqueInteractionID
                                });
                                return tr;
                            }
                            if (prevSelectedDiff && prevSelectedID) {
                                const blockOrSentenceFromDiffObject = (0, (0, parcelRequire("5ilgR")).getBlockOrSentenceFromDiffObject)(newPluginState, prevSelectedDiff);
                                const tr = (0, (0, parcelRequire("dKZcc")).ignoreSuggestionWithAnalytics)({
                                    aiInteractionID: prevSelectedID,
                                    editorState: newState,
                                    selectedDiff: prevSelectedDiff,
                                    blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject,
                                    transaction: (0, (0, parcelRequire("dKZcc")).viewSuggestionWithAnalytics)(uniqueInteractionID, newState)
                                });
                                tr.setMeta((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey), {
                                    uniqueInteractionID: uniqueInteractionID
                                });
                                return tr;
                            }
                        }
                        if (prevSelectedDiff && prevSelectedID) {
                            if (!selectedDiff && (0, (0, parcelRequire("5ilgR")).isDiffObjectInPluginState)(newPluginState, prevSelectedDiff)) {
                                const blockOrSentenceFromDiffObject = (0, (0, parcelRequire("5ilgR")).getBlockOrSentenceFromDiffObject)(newPluginState, prevSelectedDiff);
                                return (0, (0, parcelRequire("dKZcc")).ignoreSuggestionWithAnalytics)({
                                    aiInteractionID: prevSelectedID,
                                    editorState: newState,
                                    selectedDiff: prevSelectedDiff,
                                    blockOrSentenceFromDiffObject: blockOrSentenceFromDiffObject
                                });
                            }
                        }
                    } else if (isNotTheSameSelectedDiff && selectedDiff && oldDeco !== newDeco) {
                        const tr = (0, (0, parcelRequire("dKZcc")).viewSuggestionWithAnalytics)(uniqueInteractionID, newState);
                        tr.setMeta((0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey), {
                            uniqueInteractionID: uniqueInteractionID
                        });
                        return tr;
                    }
                }
            }
        });
    }
});
parcelRegister("7u94l", function(module, exports) {
    $parcel$export(module.exports, "getConfiguration", ()=>$92a1a62c64857b08$export$3de01744a82b21a4);
    var $VSDnB;
    const $92a1a62c64857b08$export$3de01744a82b21a4 = (editorPluginAIProvider)=>{
        let isProactiveAISupported = !!editorPluginAIProvider.isFullPageExperimentsEnabled && !!editorPluginAIProvider.proactiveAIConfig?.apiUrl && !!editorPluginAIProvider.proactiveAIConfig?.enabled && !!(0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_proactive_spelling_and_grammar');
        let proactiveAIConfig = editorPluginAIProvider.proactiveAIConfig;
        if (isProactiveAISupported) proactiveAIConfig = {
            ...proactiveAIConfig,
            defaultToggledState: true,
            documentSGChecker: proactiveAIConfig?.documentSGChecker ? {
                ...proactiveAIConfig?.documentSGChecker,
                enabled: false
            } : undefined
        };
        return {
            isProactiveAISupported: isProactiveAISupported,
            proactiveAIConfig: proactiveAIConfig
        };
    };
});
parcelRegister("8V04q", function(module, exports) {
    $parcel$export(module.exports, "createDecorationPlugin", ()=>$e87db824f2b937db$export$f99722d744184238);
    var $5KWxh;
    var $jSlH9;
    var $kXXDl;
    var $1SK0u;
    var $9wtrL;
    const $e87db824f2b937db$export$f99722d744184238 = (options)=>{
        const { dispatch: dispatch, api: api, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = options;
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("kXXDl")).aiExperienceDecorationPluginKey),
            state: (0, (0, parcelRequire("jSlH9")).createPluginState)(dispatch, (0, (0, parcelRequire("jSlH9")).createInitialState)(dispatchAnalyticsEvent)),
            props: {
                handleDOMEvents: {
                    click: (0, (0, parcelRequire("1SK0u")).onClearGeneratedContentDecorator)
                },
                decorations: (editorState)=>{
                    const pluginState = (0, (0, parcelRequire("jSlH9")).getPluginState)(editorState);
                    return pluginState.modalDecorationSet;
                }
            },
            view: (0, (0, parcelRequire("9wtrL")).manageSelectionMarkerView)((0, (0, parcelRequire("jSlH9")).getPluginState), api)
        });
    };
});
parcelRegister("1SK0u", function(module, exports) {
    $parcel$export(module.exports, "onClearGeneratedContentDecorator", ()=>$c69081b0a24c3289$export$f5369c92191ba6f);
    var $3cfam;
    var $jSlH9;
    var $b8ZqO;
    const $c69081b0a24c3289$export$f5369c92191ba6f = (view, event)=>{
        const pluginState = (0, (0, parcelRequire("jSlH9")).getPluginState)(view.state);
        if ((0, (0, parcelRequire("b8ZqO")).hasGeneratedContentDecorations)(pluginState)) {
            const endAIExperienceCommand = (0, (0, parcelRequire("3cfam")).createEndAIExperienceCommand)();
            endAIExperienceCommand(view.state, view.dispatch);
            return true;
        }
        return false;
    };
});
parcelRegister("9wtrL", function(module, exports) {
    $parcel$export(module.exports, "manageSelectionMarkerView", ()=>$ab06e7e55098fb06$export$6181eb45d9edf6d3);
    var $etG8M;
    const $ab06e7e55098fb06$export$6181eb45d9edf6d3 = (getPluginState, api)=>()=>{
            if (!api?.selectionMarker) return {};
            let releaseSelectionMarker;
            return {
                update: (editorView)=>{
                    const pluginState = getPluginState(editorView.state);
                    const modalIsOpen = pluginState.modalDecorationSet !== (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                    if (modalIsOpen && !releaseSelectionMarker) releaseSelectionMarker = api?.selectionMarker?.actions.hideDecoration();
                    else if (!modalIsOpen && releaseSelectionMarker) {
                        releaseSelectionMarker();
                        releaseSelectionMarker = undefined;
                    }
                },
                destroy: ()=>{
                    releaseSelectionMarker?.();
                }
            };
        };
});
parcelRegister("5wv7C", function(module, exports) {
    $parcel$export(module.exports, "createGetEditorViewPlugin", ()=>$8b2559ad895091e8$export$3de1ac9a9cd13933);
    var $5KWxh;
    var $2RLNC;
    const $8b2559ad895091e8$export$3de1ac9a9cd13933 = ({ setEditorView: setEditorView })=>new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("2RLNC")).getEditorViewPluginKey),
            view (editorView) {
                setEditorView(editorView);
                return {};
            }
        });
});
parcelRegister("2RLNC", function(module, exports) {
    $parcel$export(module.exports, "getEditorViewPluginKey", ()=>$c844fc4e210036cb$export$519cafec2c63c5bb);
    var $gZGBX;
    const $c844fc4e210036cb$export$519cafec2c63c5bb = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiExperienceGetEditorView');
});
parcelRegister("1OAQS", function(module, exports) {
    $parcel$export(module.exports, "createRovoAgentsPlugin", ()=>$c0eae1c2858eeb4e$export$c72f28d9e4137cea);
    var $5KWxh;
    var $eMywv;
    var $14ecj;
    function $c0eae1c2858eeb4e$export$c72f28d9e4137cea(options) {
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("14ecj")).rovoAgentsPluginKey),
            state: (0, (0, parcelRequire("eMywv")).createPluginState)(options.dispatch, {
                agents: [],
                enabled: false,
                publish: ()=>{},
                isBrowseModalOpen: false,
                positions: undefined
            })
        });
    }
});
parcelRegister("9effd", function(module, exports) {
    $parcel$export(module.exports, "createSelectionPreviewPlugin", ()=>$402dead9efacf9e0$export$6b0a857b1a5189ef);
    var $5KWxh;
    var $etG8M;
    var $3cfam;
    var $jSlH9;
    var $8eZhe;
    const $402dead9efacf9e0$export$6b0a857b1a5189ef = ()=>{
        return new (0, (0, parcelRequire("5KWxh")).SafePlugin)({
            key: (0, (0, parcelRequire("8eZhe")).selectionPreviewPluginKey),
            state: {
                init: (_, state)=>({
                        selectionPreview: false
                    }),
                apply: (tr, _pluginState, _oldEditorState)=>{
                    if (tr.getMeta('showSelectionPreview')) return {
                        selectionPreview: true
                    };
                    if (tr.getMeta('hideSelectionPreview')) return {
                        selectionPreview: false
                    };
                    return _pluginState;
                }
            },
            props: {
                decorations: (editorState)=>{
                    const pluginState = (0, (0, parcelRequire("8eZhe")).selectionPreviewPluginKey).getState(editorState);
                    if (pluginState.selectionPreview) {
                        const { modalDecorationSet: modalDecorationSet } = (0, (0, parcelRequire("jSlH9")).getPluginState)(editorState);
                        const modalDecorations = modalDecorationSet.find(0, editorState.doc.content.size);
                        const existingHighlightDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'inlineDecoration')[0];
                        const nodeDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'ai-nodeDecoration')[0];
                        if (!nodeDecoration && !existingHighlightDecoration) {
                            const highlightDecoration = (0, (0, parcelRequire("3cfam")).createInlineDecoration)(0, editorState.doc.content.size);
                            return (0, (0, parcelRequire("etG8M")).DecorationSet).create(editorState.doc, [
                                highlightDecoration
                            ]);
                        }
                    }
                    return (0, (0, parcelRequire("etG8M")).DecorationSet).empty;
                }
            }
        });
    };
});
parcelRegister("8eZhe", function(module, exports) {
    $parcel$export(module.exports, "selectionPreviewPluginKey", ()=>$c07a9881b4d05506$export$382457814c88610e);
    var $gZGBX;
    const $c07a9881b4d05506$export$382457814c88610e = new (0, (0, parcelRequire("gZGBX")).PluginKey)('aiExperienceSelectionPreview');
});
parcelRegister("fu2Am", function(module, exports) {
    $parcel$export(module.exports, "getSpellingAndGrammarPrimaryToolbarComponent", ()=>$409f068b512edda5$export$358a61f0e38a96ea);
    $parcel$export(module.exports, "getAIPrimaryToolbarComponent", ()=>$409f068b512edda5$export$1867437946169f9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $j79rm;
    var $lCsC6;
    var $eLhn5;
    var $cCAIN;
    var $b2OAx;
    var $hcRrA;
    var $3cfam;
    var $ejYs0;
    var $liHkU;
    const $409f068b512edda5$export$358a61f0e38a96ea = ({ editorPluginAIProvider: editorPluginAIProvider })=>({ editorView: editorView })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j79rm")).WithPluginState), {
                plugins: {
                    pluginState: (0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey)
                },
                render: ({ pluginState: pluginState })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("liHkU")).SpellingAndGrammarToolbarButton), {
                        editorView: editorView,
                        aiSpellingGrammarPluginState: pluginState,
                        ButtonWrapper: editorPluginAIProvider?.proactiveAIToolbarButtonWrapper
                    })
            });
    const $409f068b512edda5$export$1867437946169f9f = ({ api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, isProactiveAISupported: isProactiveAISupported })=>({ editorView: editorView })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j79rm")).WithPluginState), {
                plugins: {
                    pluginState: (0, (0, parcelRequire("lCsC6")).aiButtonPluginKey),
                    proactivePluginState: (0, (0, parcelRequire("eLhn5")).aiProactivePluginKey)
                },
                render: ({ pluginState: pluginState, proactivePluginState: proactivePluginState })=>{
                    const aiButtonPluginState = pluginState;
                    const aiProactivePluginState = proactivePluginState;
                    const onClick = ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        const configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
                        const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: 'mainToolbar',
                            aiGlobalOptIn: aiGlobalOptIn,
                            triggeredFor: aiButtonPluginState.triggeredFor
                        });
                        openAIModalCommand(state, dispatch);
                    };
                    const onProactiveClick = ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, (0, parcelRequire("cCAIN")).toggleProactiveAISuggestionDisplay)('mainToolbar')(state, dispatch);
                    };
                    const showLoading = !!aiProactivePluginState?.showNewRecommendationsNotification;
                    const showGreyBorder = !!aiProactivePluginState && (0, (0, parcelRequire("b2OAx")).hasUnreadRecommendations)(aiProactivePluginState);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isProactiveAISupported ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejYs0")).AtlassianIntelligenceToolbarButton), {
                        api: api,
                        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
                        onClick: onProactiveClick,
                        disabled: false,
                        selected: !!aiProactivePluginState?.isProactiveContextPanelOpen,
                        loading: showLoading,
                        greyBorder: showGreyBorder,
                        view: editorView,
                        proactive: true
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejYs0")).AtlassianIntelligenceToolbarButton), {
                        api: api,
                        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
                        onClick: onClick,
                        disabled: !aiButtonPluginState?.isSelectionValidForAIExperience,
                        view: editorView
                    }));
                }
            });
        };
});
parcelRegister("ejYs0", function(module, exports) {
    $parcel$export(module.exports, "AtlassianIntelligenceToolbarButton", ()=>$9607745854453f2f$export$d680bd36e1545039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $l4tMX;
    var $awTmI;
    var $ejItq;
    var $1jI4k;
    var $jps85;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $a8gZ8;
    var $010fk;
    var $i0hyP;
    var $kjtjo;
    var $10VaV;
    var $ftulG;
    var $elkbx;
    function $9607745854453f2f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $9607745854453f2f$var$compensateBorderStyles = {
        name: "1d1bn50",
        styles: "margin:-1px"
    };
    const $9607745854453f2f$var$extraLoadingPadding = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInlineStart: 'space.050',
        paddingInlineEnd: 'space.025'
    });
    const $9607745854453f2f$var$AI_BUTTON_WIDTH_BREAKPOINT = 1076;
    const $9607745854453f2f$var$deprecatedGetWidthState = (view)=>{
        const editorWidthPlugin = view.state.plugins.find((plugin)=>plugin.key === 'widthPlugin$');
        return {
            widthState: editorWidthPlugin?.getState(view.state)
        };
    };
    const $9607745854453f2f$var$shouldShowSeparator = (node)=>{
        if (!node) return false;
        const prevSeparator = node.previousElementSibling?.querySelector(`:scope > span:last-child:empty`);
        const prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
        return !prevSeparatorVisible;
    };
    const $9607745854453f2f$export$d680bd36e1545039 = ({ onClick: onClick, disabled: disabled, selected: selected, loading: loading, greyBorder: greyBorder, ButtonWrapper: ButtonWrapper, api: api, view: view, proactive: proactive })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = formatMessage(proactive ? (0, (0, parcelRequire("kjtjo")).default).aiProactiveDescriptor : (0, (0, parcelRequire("kjtjo")).default).aiUniversalDescriptor);
        const [showSeparator, setShowSeperator] = (0, $5uXOq.useState)(false);
        const { widthState: widthState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(api, [
            'width'
        ]);
        let shouldShowLabel = widthState?.width ? widthState.width >= $9607745854453f2f$var$AI_BUTTON_WIDTH_BREAKPOINT : true;
        if (!widthState?.width && view) {
            const { widthState: deprecatedWidthState } = $9607745854453f2f$var$deprecatedGetWidthState(view);
            shouldShowLabel = deprecatedWidthState?.width >= $9607745854453f2f$var$AI_BUTTON_WIDTH_BREAKPOINT;
        }
        const callbackRef = (node)=>{
            const result = $9607745854453f2f$var$shouldShowSeparator(node);
            setShowSeperator(result);
        };
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            onClick: onClick,
            buttonId: (0, (0, parcelRequire("l4tMX")).TOOLBAR_ACTION_SUBJECT_ID).AI,
            "aria-label": title,
            testId: "atlassian-intelligence-toolbar-button",
            title: title,
            iconBefore: (0, (0, parcelRequire("VSDnB")).fg)('platform-visual-refresh-icons') ? loading ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $9607745854453f2f$var$extraLoadingPadding
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("010fk")).default), {
                alt: formatMessage((0, (0, parcelRequire("10VaV")).default).loadingIconAltText)
            })) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("jps85"))))), {
                color: disabled ? "var(--ds-icon-disabled, #091E424F)" : selected ? "var(--ds-icon-selected, #091E424F)" : "var(--ds-icon, #44546F)",
                label: "atlassian-intelligence-toolbar-button-icon",
                spacing: "spacious"
            }) : loading ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("010fk")).default), {
                alt: formatMessage((0, (0, parcelRequire("10VaV")).default).loadingIconAltText)
            }) : (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i0hyP")).LogoSvg), {
                alt: '',
                isDisabled: disabled,
                isSelected: selected
            }),
            disabled: disabled,
            selected: selected ?? false
        }, shouldShowLabel && formatMessage(proactive ? (0, (0, parcelRequire("kjtjo")).default).aiProactiveCallToAction : (0, (0, parcelRequire("kjtjo")).default).aiUniversalShortCallToAction));
        const proactiveButton = loading || greyBorder ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a8gZ8")).AIContainer), {
            spacing: "none",
            isLoading: loading,
            isBorderGrey: greyBorder && !loading
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $9607745854453f2f$var$compensateBorderStyles
        }, button)) : button;
        const toolbarMutationCount = (0, (0, parcelRequire("elkbx")).useEditorToolbarChangeDetector)(ButtonWrapper);
        const wrapped = ButtonWrapper ? (0, (0, parcelRequire("f8Sb3")).jsx)(ButtonWrapper, {
            key: `${toolbarMutationCount}-key-wrapper`
        }, proactiveButton) : proactiveButton;
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ref: callbackRef,
            css: [
                (0, (0, parcelRequire("ejItq")).wrapperStyle),
                (0, (0, parcelRequire("ftulG")).svgIconStyles)
            ]
        }, showSeparator && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": "ai-toolbar-button-seperator",
            css: (0, (0, parcelRequire("ejItq")).separatorStyles)
        }), wrapped));
    };
});
parcelRegister("a8gZ8", function(module, exports) {
    $parcel$export(module.exports, "AIContainer", ()=>$31503ca73097de80$export$7676efa80be4bb75);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hxoiH;
    let $31503ca73097de80$var$namespaceUUID = 0;
    const $31503ca73097de80$var$AI_CONTAINER_BORDER_RADIUS = 6;
    const $31503ca73097de80$var$AI_CONTAINER_INNER_BORDER_RADIUS = 5;
    const $31503ca73097de80$var$zIndex = 1;
    const $31503ca73097de80$var$newPalette = {
        dark: {
            blue: '#0468FF',
            teal: '#BF63F3',
            yellow: '#FFA900'
        },
        light: {
            blue: '#0468FF',
            teal: '#BF63F3',
            yellow: '#FFA900'
        }
    };
    const $31503ca73097de80$var$AFTER_LOAD_DURATION = 3000;
    const $31503ca73097de80$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        const svgRef = (0, $5uXOq.useRef)(null);
        const namespaceId = (0, $5uXOq.useRef)();
        const [showRainbowBorder, setShowRainbowBorder] = (0, $5uXOq.useState)(true);
        const paletteForTheme = colorMode === 'dark' ? $31503ca73097de80$var$newPalette.dark : $31503ca73097de80$var$newPalette.light;
        if (namespaceId.current === undefined) {
            namespaceId.current = $31503ca73097de80$var$namespaceUUID;
            $31503ca73097de80$var$namespaceUUID += 1;
        }
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading) {
                const svg = svgRef.current;
                const beginReq = requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
                });
                return ()=>{
                    cancelAnimationFrame(beginReq);
                    requestAnimationFrame(()=>{
                        svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                    });
                };
            }
            return undefined;
        }, [
            isLoading,
            hasNewBorderExperience
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
                const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $31503ca73097de80$var$AFTER_LOAD_DURATION);
                return ()=>clearTimeout(timeoutId);
            }
        }, [
            hasNewBorderExperience,
            showRainbowBorder,
            isLoading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($31503ca73097de80$var$SvgContainer, {
            isBlurred: isBlurred,
            isShadow: isShadow,
            ref: svgRef,
            viewBox: "0 0 24 24",
            preserveAspectRatio: "none"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: `${namespaceId.current}_lg1`,
            gradientUnits: "userSpaceOnUse",
            x1: "0%",
            y1: "0",
            x2: "400%",
            y2: "0",
            spreadMethod: "reflect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "x1",
            from: "0%",
            to: "400%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "x2",
            from: "400%",
            to: "800%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: paletteForTheme.teal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.5",
            stopColor: paletteForTheme.yellow
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.75",
            stopColor: paletteForTheme.teal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: paletteForTheme.blue
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: `${namespaceId.current}_lg2`,
            gradientUnits: "userSpaceOnUse",
            x1: "0",
            y1: "-100%",
            x2: "0",
            y2: "300%",
            spreadMethod: "reflect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "y1",
            from: "-100%",
            to: "300%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "y2",
            from: "300%",
            to: "700%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: paletteForTheme.teal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.5",
            stopColor: paletteForTheme.yellow
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.75",
            stopColor: paletteForTheme.teal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: paletteForTheme.blue
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: `${namespaceId.current}_lg3`,
            gradientUnits: "userSpaceOnUse",
            x1: "300%",
            y1: "0",
            x2: "700%",
            y2: "0",
            spreadMethod: "reflect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "x1",
            from: "300%",
            to: "-100%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "x2",
            from: "700%",
            to: "300%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.5",
            stopColor: paletteForTheme.yellow
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.75",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: paletteForTheme.blue
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: `${namespaceId.current}_lg4`,
            gradientUnits: "userSpaceOnUse",
            x1: "0",
            y1: "0",
            x2: "0",
            y2: "400%",
            spreadMethod: "reflect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "y1",
            from: "0%",
            to: "-400%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("animate", {
            begin: "indefinite",
            attributeName: "y2",
            from: "400%",
            to: "0%",
            repeatCount: "indefinite",
            dur: "3s"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.25",
            stopColor: paletteForTheme.blue
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.5",
            stopColor: paletteForTheme.yellow
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.75",
            stopColor: paletteForTheme.teal
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: paletteForTheme.blue
        }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            strokeWidth: "16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: "var(--ds-background-accent-gray-subtler, #DFE1E6)",
            d: "M0 0h24v24H0Z",
            vectorEffect: "non-scaling-stroke"
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            strokeWidth: "16"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: `url(#${namespaceId.current}_lg1)`,
            d: "M0 0h24",
            vectorEffect: "non-scaling-stroke"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: `url(#${namespaceId.current}_lg2)`,
            d: "M24 0v24",
            vectorEffect: "non-scaling-stroke"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: `url(#${namespaceId.current}_lg3)`,
            d: "M24 24H0",
            vectorEffect: "non-scaling-stroke"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            stroke: `url(#${namespaceId.current}_lg4)`,
            d: "M0 24V0",
            vectorEffect: "non-scaling-stroke"
        }))));
    };
    const $31503ca73097de80$export$7676efa80be4bb75 = ({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $31503ca73097de80$var$Container, ContentComponent: ContentComponent = $31503ca73097de80$var$Content } = {}, ref: ref, hasNewBorderExperience: hasNewBorderExperience = true })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
            ref: ref,
            "data-testid": testId,
            shouldFitContainer: shouldFitContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($31503ca73097de80$var$AnimatedSvgContainer, {
            isShadow: isShadow,
            isLoading: isLoading,
            isBorderGrey: isBorderGrey,
            hasNewBorderExperience: hasNewBorderExperience
        }), isLoading && (0, ($parcel$interopDefault($5uXOq))).createElement($31503ca73097de80$var$AnimatedSvgContainer, {
            isLoading: isLoading,
            isBlurred: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(ContentComponent, {
            spacing: spacing
        }, children));
    const $31503ca73097de80$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldFitContainer: shouldFitContainer, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _1pbykb7n",
                __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
                __cmplp.className
            ])
        });
    });
    const $31503ca73097de80$var$Content = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7vuon _2rko14y2 _16jlkb7n _1pbykb7n _1bsb1osq",
                __cmplp.spacing === 'default' && "_1yt4u2gc",
                __cmplp.className
            ])
        });
    });
    const $31503ca73097de80$export$71abc632aa29e6fe = {
        ContainerComponent: $31503ca73097de80$var$Container,
        ContentComponent: $31503ca73097de80$var$Content
    };
    const $31503ca73097de80$var$SvgContainer = (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rkoi2wt",
                __cmplp.isShadow ? "_16qs1ifw" : "_16qsglyw",
                __cmplp.isBlurred ? "_1bsbnau3 _4t3inau3 _154iu2gc _1ltvu2gc _kdamxe1k" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ftulG", function(module, exports) {
    $parcel$export(module.exports, "svgIconStyles", ()=>$429d798732def60c$export$de796c4c6ba956e4);
    function $429d798732def60c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $429d798732def60c$export$de796c4c6ba956e4 = {
        name: "17zbkox",
        styles: "button{svg{pointer-events:none;}}"
    };
});
parcelRegister("elkbx", function(module, exports) {
    $parcel$export(module.exports, "useEditorToolbarChangeDetector", ()=>$268e2d98f96ed7cb$export$cf19468c196a204d);
    var $5uXOq = parcelRequire("5uXOq");
    const $268e2d98f96ed7cb$export$cf19468c196a204d = (ButtonWrapper)=>{
        const [toolbarMutationCount, setToolbarMutationCount] = (0, $5uXOq.useState)(0);
        (0, $5uXOq.useEffect)(()=>{
            if (!ButtonWrapper) return;
            const observer = new MutationObserver((mutations)=>{
                mutations.forEach((mutation)=>{
                    const { addedNodes: addedNodes, removedNodes: removedNodes } = mutation;
                    const isRelevantMutation = [
                        ...addedNodes,
                        ...removedNodes
                    ].some((node)=>node.nodeType === 1 && node.nodeName === 'DIV');
                    if (isRelevantMutation) setToolbarMutationCount(toolbarMutationCount + 1);
                });
            });
            const mainToolBar = document.querySelector(`[data-testid="ak-editor-main-toolbar"]`);
            if (mainToolBar) observer.observe(mainToolBar, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            toolbarMutationCount,
            ButtonWrapper
        ]);
        return toolbarMutationCount;
    };
});
parcelRegister("liHkU", function(module, exports) {
    $parcel$export(module.exports, "SpellingAndGrammarToolbarButton", ()=>$f62e130223d1a985$export$10e0077f8f10634e);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $koVbs;
    var $1jI4k;
    var $dV6Te;
    var $dKZcc;
    var $k0tah;
    var $5ilgR;
    var $gsSnI;
    const $f62e130223d1a985$var$Icon = ({ size: size, label: label, isDotVisible: isDotVisible })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dV6Te")).default), {
            secondaryColor: "var(--ds-icon-accent-blue, #1D7AFC)",
            size: size,
            label: label
        }, isDotVisible && (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "15.9988",
            y: "4",
            width: "4.00122",
            height: "4.00122",
            rx: "2.00061",
            fill: "inherit"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M16.0609 19.778L20 15.8389L18.9389 14.7778L15.5303 18.1864L14.3101 16.9662L13.249 18.0273L14.9998 19.778C15.2928 20.071 15.7678 20.071 16.0609 19.778Z",
            fill: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M7.36328 15.574L10.6069 6.41431H11.9907V8.12817H11.4956L9.10254 15.574H7.36328ZM9.00732 13.219L9.43896 11.9368H13.6411L14.0728 13.219H9.00732ZM13.9902 15.574L11.6035 8.12817V6.41431H12.4858L15.7358 15.574H13.9902Z",
            fill: "currentColor"
        }));
    const $f62e130223d1a985$var$SpellingAndGrammarBaseButton = ({ isSelected: isSelected, isEligibleForProactiveAISuggestions: isEligibleForProactiveAISuggestions, hasDiffObjects: hasDiffObjects, onClick: onClick, ButtonWrapper: ButtonWrapper })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = formatMessage((0, (0, parcelRequire("gsSnI")).default).spellingAndGrammarButtonLabel);
        const [isDotVisibleAfterDelay, setIsDotVisibleAfterDelay] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isEligibleForProactiveAISuggestions) {
                const min = 400, max = 800;
                const timeout = setTimeout(()=>{
                    setIsDotVisibleAfterDelay(true);
                }, Math.floor(min + Math.random() * (max - min)));
                return ()=>clearTimeout(timeout);
            } else setIsDotVisibleAfterDelay(false);
        }, [
            isEligibleForProactiveAISuggestions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected) setIsDotVisibleAfterDelay(false);
        }, [
            isSelected
        ]);
        const button = (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1jI4k")).default), {
            selected: isSelected,
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)($f62e130223d1a985$var$Icon, {
                label: title,
                isDotVisible: !isSelected && (hasDiffObjects || isDotVisibleAfterDelay)
            }),
            onClick: onClick,
            title: title,
            "aria-label": title,
            testId: "atlassian-intelligence-proactive-spelling-and-grammar-buttton"
        });
        return ButtonWrapper ? (0, (0, parcelRequire("f8Sb3")).jsx)(ButtonWrapper, {
            key: "button-key-wrapper"
        }, button) : button;
    };
    const $f62e130223d1a985$export$10e0077f8f10634e = ({ editorView: editorView, aiSpellingGrammarPluginState: aiSpellingGrammarPluginState, ButtonWrapper: ButtonWrapper })=>{
        if (!aiSpellingGrammarPluginState) return null;
        const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, toggleCount: toggleCount, dismissedWords: dismissedWords, insertionCount: insertionCount, initialToggleState: initialToggleState, docChangeCountUntilLimit: docChangeCountUntilLimit } = aiSpellingGrammarPluginState;
        const allDiffObjects = (0, (0, parcelRequire("5ilgR")).getAllDiffObjects)(aiSpellingGrammarPluginState);
        const realtimeAIOnClick = ()=>{
            const { state: state, dispatch: dispatch } = editorView;
            (0, (0, parcelRequire("dKZcc")).handleSpellingAndGrammarWithAnalytics)({
                proactiveToggleCount: toggleCount + 1,
                totalSuggestionsOnPage: allDiffObjects.length,
                dismissedWords: dismissedWords.size,
                insertionCount: insertionCount,
                initialToggleState: initialToggleState,
                triggeredFrom: 'aiToolbarButton',
                operationType: 'toggle'
            })(state, dispatch);
        };
        const isEligibleForProactiveAISuggestions = Boolean(!isSpellingAndGrammarEnabled && docChangeCountUntilLimit === (0, (0, parcelRequire("k0tah")).DOC_CHANGE_COUNT_LIMIT) && editorView.state.doc.textContent.trim().length > (0, (0, parcelRequire("k0tah")).DOC_MINIMUM_SIZE_THRESHOLD));
        return (0, (0, parcelRequire("f8Sb3")).jsx)($f62e130223d1a985$var$SpellingAndGrammarBaseButton, {
            isEligibleForProactiveAISuggestions: isEligibleForProactiveAISuggestions,
            hasDiffObjects: !!allDiffObjects.length,
            isSelected: isSpellingAndGrammarEnabled,
            ButtonWrapper: ButtonWrapper,
            onClick: realtimeAIOnClick
        });
    };
});
parcelRegister("gsSnI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df7488f33c008500$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df7488f33c008500$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        spellingAndGrammarButtonLabel: {
            id: 'fabric.editor.ai.spellingAndGrammarButton.tooltip',
            defaultMessage: 'Spelling and grammar check (Beta)',
            description: 'The tooltip text for the spelling and grammar button in the Editor toolbar'
        }
    });
});
parcelRegister("g8uXl", function(module, exports) {
    $parcel$export(module.exports, "getPrimaryToolbarLegacyComponent", ()=>$0c677a937c22b450$export$d26e7f34c50ada62);
    var $5uXOq = parcelRequire("5uXOq");
    var $j79rm;
    var $lCsC6;
    var $eLhn5;
    var $cCAIN;
    var $b2OAx;
    var $hcRrA;
    var $3cfam;
    var $ejYs0;
    var $liHkU;
    const $0c677a937c22b450$export$d26e7f34c50ada62 = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, isProactiveAISpellingAndGrammarSupported: isProactiveAISpellingAndGrammarSupported, isProactiveAISupported: isProactiveAISupported })=>({ editorView: editorView })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j79rm")).WithPluginState), {
                plugins: {
                    pluginState: (0, (0, parcelRequire("lCsC6")).aiButtonPluginKey),
                    spellingAndGrammar: (0, (0, parcelRequire("hcRrA")).aiSpellingGrammarPluginKey),
                    proactivePluginState: (0, (0, parcelRequire("eLhn5")).aiProactivePluginKey)
                },
                render: ({ pluginState: pluginState, spellingAndGrammar: spellingAndGrammar, proactivePluginState: proactivePluginState })=>{
                    const aiButtonPluginState = pluginState;
                    const aiProactivePluginState = proactivePluginState;
                    const onClick = ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        const configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
                        const openAIModalCommand = (0, (0, parcelRequire("3cfam")).createOpenAIModalCommand)({
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: 'mainToolbar',
                            aiGlobalOptIn: aiGlobalOptIn,
                            triggeredFor: aiButtonPluginState.triggeredFor
                        });
                        openAIModalCommand(state, dispatch);
                    };
                    const onProactiveClick = ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, (0, parcelRequire("cCAIN")).toggleProactiveAISuggestionDisplay)('mainToolbar')(state, dispatch);
                    };
                    const showLoading = !!aiProactivePluginState?.showNewRecommendationsNotification;
                    const showGreyBorder = !!aiProactivePluginState && (0, (0, parcelRequire("b2OAx")).hasUnreadRecommendations)(aiProactivePluginState);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isProactiveAISpellingAndGrammarSupported && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("liHkU")).SpellingAndGrammarToolbarButton), {
                        editorView: editorView,
                        aiSpellingGrammarPluginState: spellingAndGrammar,
                        ButtonWrapper: editorPluginAIProvider?.proactiveAIToolbarButtonWrapper
                    }), isProactiveAISupported ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejYs0")).AtlassianIntelligenceToolbarButton), {
                        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
                        onClick: onProactiveClick,
                        disabled: !aiProactivePluginState?.canProactiveContextPanelOpen && !aiProactivePluginState?.isProactiveContextPanelOpen,
                        loading: showLoading,
                        greyBorder: showGreyBorder,
                        view: editorView,
                        proactive: true
                    }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ejYs0")).AtlassianIntelligenceToolbarButton), {
                        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
                        onClick: onClick,
                        disabled: !aiButtonPluginState?.isSelectionValidForAIExperience,
                        view: editorView
                    }));
                }
            });
        };
});
parcelRegister("fkXQe", function(module, exports) {
    $parcel$export(module.exports, "AgentFetcher", ()=>$6bde023ba787bfdf$export$22e51ab65638ad05);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jwp5;
    var $cRxCv;
    var $78lIh;
    var $4xwSH;
    var $fpzVC;
    var $7m26N;
    const $6bde023ba787bfdf$export$22e51ab65638ad05 = (props)=>{
        const { editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = props;
        const agentsFromAssistanceService = (0, (0, parcelRequire("7Jwp5")).useAgentsList)({
            filter: 'favourites',
            assistanceServiceParams: {
                product: (0, (0, parcelRequire("fpzVC")).mapToConvoAIProductName)(editorPluginAIProvider.product),
                experienceId: 'ai-mate',
                touchpointSource: 'editor-agent-favourites-fetcher'
            }
        });
        const allAgentsFromAssistanceService = (0, (0, parcelRequire("7Jwp5")).useAgentsList)({
            assistanceServiceParams: {
                product: (0, (0, parcelRequire("fpzVC")).mapToConvoAIProductName)(editorPluginAIProvider.product),
                experienceId: 'ai-mate',
                touchpointSource: 'editor-agent-all-fetcher'
            }
        });
        const mockAgentData = (0, (0, parcelRequire("7m26N")).shouldMockAgentData)();
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!editorPluginAIProvider.getChannelVariables) return;
            const agents = mockAgentData ? [
                (0, (0, parcelRequire("cRxCv")).CommsCrafterAgent),
                (0, (0, parcelRequire("cRxCv")).JobWriterAgent),
                (0, (0, parcelRequire("cRxCv")).A11yMateAgent)
            ].map((0, (0, parcelRequire("78lIh")).getEditorAgent)) : agentsFromAssistanceService.map((0, (0, parcelRequire("78lIh")).getEditorAgent));
            function getDefaultAgent() {
                const defaultAgent = mockAgentData ? (0, (0, parcelRequire("78lIh")).getEditorAgent)((0, (0, parcelRequire("cRxCv")).ChatAgent)) : allAgentsFromAssistanceService.filter((agent)=>agent.is_default).map((0, (0, parcelRequire("78lIh")).getEditorAgent))[0];
                return defaultAgent;
            }
            const command = (0, (0, parcelRequire("4xwSH")).updateAgents)({
                agents: agents,
                defaultAgent: getDefaultAgent()
            });
            command(editorView.state, editorView.dispatch);
        }, [
            editorPluginAIProvider,
            agentsFromAssistanceService,
            allAgentsFromAssistanceService,
            mockAgentData,
            editorView.state,
            editorView.dispatch
        ]);
        return null;
    };
});
parcelRegister("7Jwp5", function(module, exports) {
    $parcel$export(module.exports, "useAgentsController", ()=>$324338e17c7be5ed$export$eee66751ca85dbf7);
    $parcel$export(module.exports, "useAgentsList", ()=>$324338e17c7be5ed$export$6553fa633373a34);
    $parcel$export(module.exports, "useSuggestedAgents", ()=>$324338e17c7be5ed$export$13536ee55f1995a1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $3sQ5x;
    var $iXqE5;
    var $h4rOi;
    var $91cKc;
    var $cK3Jm;
    var $evw9R;
    var $4c7JV;
    var $mNrGv;
    var $4ojTZ;
    var $dQjNg;
    var $2gP8c;
    var $bpqZM;
    var $llLCm;
    var $53Oql;
    var $3xYdY;
    var $53Ehp;
    const $324338e17c7be5ed$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
            if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
            else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
            else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
            else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
            return categorisedAgents;
        }, {
            public: [],
            private: [],
            system: []
        });
    const $324338e17c7be5ed$var$agentsStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            availableAgents: [],
            categorisedAgents: {
                private: [],
                public: [],
                system: []
            },
            agentsInitialized: false
        },
        name: 'AgentsStore',
        actions: {
            setAgents: (availableAgents)=>({ setState: setState })=>{
                    setState({
                        availableAgents: availableAgents,
                        categorisedAgents: $324338e17c7be5ed$var$categoriseAgents(availableAgents)
                    });
                },
            getAgentDetails: (id)=>({ getState: getState })=>{
                    const { availableAgents: availableAgents } = getState();
                    return availableAgents.find((agent)=>agent.id === id);
                },
            setAgentsInitialized: ()=>({ setState: setState })=>{
                    setState({
                        agentsInitialized: true
                    });
                }
        }
    });
    const $324338e17c7be5ed$var$useAgentsStore = (0, (0, parcelRequire("3sQ5x")).createHook)($324338e17c7be5ed$var$agentsStore);
    const $324338e17c7be5ed$export$f5b1109ecd7858c1 = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product } })=>{
        const { isRovoEnabled: isRovoEnabled } = (0, (0, parcelRequire("h4rOi")).useRovoEntitlement)();
        const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, (0, parcelRequire("53Oql")).useAgentOverrider)();
        const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized }, { setAgents: setAgents, getAgentDetails: getAgentDetails, setAgentsInitialized: setAgentsInitialized }] = $324338e17c7be5ed$var$useAgentsStore();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, (0, parcelRequire("bpqZM")).useAgentFavourites)({
            experienceId: experienceId,
            product: product
        });
        const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
        const defaultAgent = (0, $5uXOq.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
            availableAgents
        ]);
        const nonDefaultAgents = (0, $5uXOq.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
            availableAgents
        ]);
        const nonDefaultFavouriteAgents = (0, $5uXOq.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
            nonDefaultAgents
        ]);
        const fetchAndStoreAvailableAgents = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'fetchAgents'
            ],
            queryFn: async ()=>{
                try {
                    experienceTracker.start({
                        id: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENTS,
                        name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENTS
                    });
                    const agents = await (0, (0, parcelRequire("evw9R")).exponentialRetry)({
                        fn: ()=>assistanceService.getAgents(),
                        errorFilter: (0, (0, parcelRequire("4c7JV")).isRateLimitedError)
                    });
                    const transformedAgents = agents.map((agent)=>{
                        if (agent.is_default) {
                            agent.name = formatMessage((0, (0, parcelRequire("53Ehp")).default).defaultAgentName);
                            agent.description = formatMessage((0, (0, parcelRequire("53Ehp")).default).defaultAgentDescription);
                        }
                        return agent;
                    });
                    const overriddenAgents = (0, (0, parcelRequire("llLCm")).getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                    setAgents(overriddenAgents);
                    experienceTracker.succeed({
                        name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENTS
                    });
                    setAgentsInitialized();
                } catch (error) {
                    experienceTracker.fail({
                        name: (0, (0, parcelRequire("91cKc")).ExperienceName).FETCH_AGENTS,
                        error: error
                    });
                    throw error;
                }
            },
            onError: onError,
            enabled: isRovoEnabled,
            refetchOnWindowFocus: true
        });
        const createAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (payload)=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).CREATE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).CREATE_AGENT
                });
                return await assistanceService.createAgent(payload);
            },
            onSuccess: async (agent)=>{
                await favouriteAgent.mutate(agent.id);
                await fetchAndStoreAvailableAgents.refetch();
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).CREATE_AGENT
                });
            },
            onError: (error)=>{
                if ((0, (0, parcelRequire("3xYdY")).isCreateOrEditAgentAUPError)(error)) {
                    experienceTracker.succeed({
                        name: (0, (0, parcelRequire("91cKc")).ExperienceName).CREATE_AGENT
                    });
                    return;
                }
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).CREATE_AGENT,
                    error: error
                });
            }
        });
        const updateAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (payload)=>{
                experienceTracker.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).UPDATE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UPDATE_AGENT
                });
                return await assistanceService.updateAgent(payload.id, payload.data);
            },
            onSuccess: async (_agent)=>{
                await fetchAndStoreAvailableAgents.refetch();
                experienceTracker.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UPDATE_AGENT
                });
            },
            onError: (error)=>{
                if ((0, (0, parcelRequire("3xYdY")).isCreateOrEditAgentAUPError)(error)) {
                    experienceTracker.succeed({
                        name: (0, (0, parcelRequire("91cKc")).ExperienceName).UPDATE_AGENT
                    });
                    return;
                }
                experienceTracker.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UPDATE_AGENT,
                    error: error
                });
            }
        });
        const { deleteAgent: deleteAgent } = (0, (0, parcelRequire("2gP8c")).useDeleteAgent)({
            experienceId: experienceId,
            product: product,
            onSuccess: ()=>{
                fetchAndStoreAvailableAgents.refetch();
            }
        });
        const setFavouriteAgent = (0, $5uXOq.useCallback)(async (id, isFavourite)=>{
            const updatedAgent = availableAgents.find((a)=>a.id === id);
            const setUpdatedAgent = (shouldBeFavourite)=>{
                if (updatedAgent) {
                    updatedAgent.favourite = shouldBeFavourite;
                    setAgents(availableAgents.map((a)=>{
                        return a.id === updatedAgent.id ? updatedAgent : a;
                    }));
                }
            };
            setUpdatedAgent(isFavourite);
            const errorCallback = {
                onError: ()=>{
                    setUpdatedAgent(!isFavourite);
                }
            };
            if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
            else return await unfavouriteAgent.mutate(id, errorCallback);
        }, [
            availableAgents,
            setAgents,
            favouriteAgent,
            unfavouriteAgent
        ]);
        const updateAgentLocally = (0, $5uXOq.useCallback)((agentId, updatedAgent)=>{
            const updatedAgents = availableAgents.map((agent)=>{
                if (agent.id === agentId) return {
                    ...agent,
                    ...updatedAgent
                };
                return agent;
            });
            setAgents(updatedAgents);
        }, [
            availableAgents,
            setAgents
        ]);
        return {
            availableAgents: availableAgents,
            favouritedAgents: favouritedAgents,
            categorisedAgents: categorisedAgents,
            fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
            createAgent: createAgent,
            updateAgent: updateAgent,
            deleteAgent: deleteAgent,
            setFavouriteAgent: setFavouriteAgent,
            getAgentDetails: getAgentDetails,
            defaultAgent: defaultAgent,
            agentsInitialized: agentsInitialized,
            nonDefaultAgents: nonDefaultAgents,
            nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
            updateAgentLocally: updateAgentLocally
        };
    });
    const $324338e17c7be5ed$var$noopAsync = async ()=>{};
    const $324338e17c7be5ed$var$noopFn = ()=>undefined;
    const $324338e17c7be5ed$var$noopArray = [];
    const $324338e17c7be5ed$var$noopCategorisedAgent = {
        public: [],
        private: [],
        system: []
    };
    const $324338e17c7be5ed$export$65742028fec5fb81 = {
        id: 'NOOP',
        name: 'NOOP',
        named_id: 'NOOP',
        user_defined_conversation_starters: [],
        description: '',
        available_plugins: {},
        actor_type: 'AGENT',
        creator_type: 'SYSTEM',
        visibility: 'PRIVATE',
        is_default: false,
        favourite: false,
        deactivated: false
    };
    const $324338e17c7be5ed$export$eee66751ca85dbf7 = (param)=>{
        const { isRovoEnabled: isRovoEnabled } = (0, (0, parcelRequire("h4rOi")).useRovoEntitlement)();
        const controllerResult = $324338e17c7be5ed$export$f5b1109ecd7858c1(param);
        const noopUseQuery = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'noop'
            ],
            queryFn: $324338e17c7be5ed$var$noopAsync,
            enabled: false
        });
        const noopUseMutation = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async ()=>$324338e17c7be5ed$export$65742028fec5fb81,
            onSuccess: $324338e17c7be5ed$var$noopAsync,
            onError: $324338e17c7be5ed$var$noopAsync
        });
        if (!isRovoEnabled) return {
            availableAgents: $324338e17c7be5ed$var$noopArray,
            favouritedAgents: $324338e17c7be5ed$var$noopArray,
            categorisedAgents: $324338e17c7be5ed$var$noopCategorisedAgent,
            defaultAgent: undefined,
            agentsInitialized: false,
            getAgentDetails: $324338e17c7be5ed$var$noopFn,
            fetchAndStoreAvailableAgents: noopUseQuery,
            createAgent: noopUseMutation,
            updateAgent: noopUseMutation,
            deleteAgent: noopUseMutation,
            setFavouriteAgent: noopUseMutation,
            nonDefaultAgents: $324338e17c7be5ed$var$noopArray,
            nonDefaultFavouriteAgents: $324338e17c7be5ed$var$noopArray,
            updateAgentLocally: $324338e17c7be5ed$var$noopFn
        };
        return controllerResult;
    };
    const $324338e17c7be5ed$export$6553fa633373a34 = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource }, filter: filter })=>{
        const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $324338e17c7be5ed$export$eee66751ca85dbf7({
            assistanceServiceParams: {
                product: product,
                experienceId: experienceId,
                headers: headers,
                touchpointSource: touchpointSource
            }
        });
        const defaultAgents = (0, (0, parcelRequire("dQjNg")).getSuggestedOotbAgents)({
            availableAgents: availableAgents,
            product: product
        });
        const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
        const favouritedAgentsWithDefault = [
            ...favouritedAgents,
            ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
        ];
        return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
    });
    const $324338e17c7be5ed$export$13536ee55f1995a1 = (0, (0, parcelRequire("cK3Jm")).createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
        const { availableAgents: availableAgents, agentsInitialized: agentsInitialized } = $324338e17c7be5ed$export$eee66751ca85dbf7({
            assistanceServiceParams: assistanceServiceInjectedParams
        });
        const defaultAgents = (0, (0, parcelRequire("dQjNg")).getSuggestedOotbAgents)({
            availableAgents: availableAgents,
            product: assistanceServiceInjectedParams.product
        });
        return {
            suggestedAgents: defaultAgents,
            agentsInitialized: agentsInitialized
        };
    });
});
parcelRegister("evw9R", function(module, exports) {
    $parcel$export(module.exports, "exponentialRetry", ()=>$ce2c95847de4908b$export$4dfcad98182a1ece);
    const $ce2c95847de4908b$export$4dfcad98182a1ece = async ({ fn: fn, maxRetries: maxRetries = 3, retryCount: retryCount = 0, delay: delay = 1000, errorFilter: errorFilter })=>{
        try {
            return await fn();
        } catch (error) {
            if (errorFilter && !errorFilter(error)) throw error;
            if (retryCount >= maxRetries) throw error;
            await new Promise((resolve)=>setTimeout(resolve, delay));
            return await $ce2c95847de4908b$export$4dfcad98182a1ece({
                fn: fn,
                maxRetries: maxRetries,
                retryCount: retryCount + 1,
                delay: delay * 2,
                errorFilter: errorFilter
            });
        }
    };
});
parcelRegister("mNrGv", function(module, exports) {
    $parcel$export(module.exports, "useMutation", ()=>$46b29c557c6575a6$export$609860bf8b0084c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gRLdW;
    const $46b29c557c6575a6$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
        const mutationFnRef = (0, $5uXOq.useRef)(mutationFn);
        mutationFnRef.current = mutationFn;
        const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
        onSuccessRef.current = onSuccess;
        const onErrorRef = (0, $5uXOq.useRef)(onError);
        onErrorRef.current = onError;
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [isSubmitting, setIsSubmitting] = (0, $5uXOq.useState)(false);
        const mutate = (0, $5uXOq.useCallback)(async (payload, mutateCallback)=>{
            setIsSubmitting(true);
            try {
                const response = await mutationFnRef.current(payload);
                setData(response);
                onSuccessRef.current?.(response);
                mutateCallback?.onSuccess?.(response);
            } catch (error) {
                const apiError = (0, (0, parcelRequire("gRLdW")).mapErrorToApiError)(error);
                setError(apiError);
                onErrorRef.current?.(apiError);
                mutateCallback?.onError?.(apiError);
            } finally{
                setIsSubmitting(false);
            }
        }, []);
        return {
            data: data,
            error: error,
            isSubmitting: isSubmitting,
            mutate: mutate
        };
    };
});
parcelRegister("4ojTZ", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$667e963723dc9f11$export$dd0a697e1782aedd);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $VSDnB;
    var $gRLdW;
    const $667e963723dc9f11$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            cache: {}
        },
        actions: {
            updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                    const state = getState();
                    const currentCacheEntry = state.cache[key] ?? {
                        data: null,
                        error: null,
                        isFetching: false
                    };
                    const newCacheEntry = {
                        ...currentCacheEntry,
                        ...value
                    };
                    setState({
                        cache: {
                            ...state.cache,
                            [key]: newCacheEntry
                        }
                    });
                },
            getCacheEntry: (key)=>({ getState: getState })=>{
                    const state = getState();
                    return state.cache[key];
                }
        }
    });
    const $667e963723dc9f11$var$selector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.cache, (_, key)=>key, (cache, key)=>cache[key] ?? {
            data: null,
            error: null,
            isFetching: false
        });
    const $667e963723dc9f11$var$useCacheEntry = (0, (0, parcelRequire("3sQ5x")).createHook)($667e963723dc9f11$var$store, {
        selector: $667e963723dc9f11$var$selector
    });
    const $667e963723dc9f11$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
        const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
        const queryFnRef = (0, $5uXOq.useRef)(queryFn);
        queryFnRef.current = queryFn;
        const onSuccessRef = (0, $5uXOq.useRef)(onSuccess);
        onSuccessRef.current = onSuccess;
        const onErrorRef = (0, $5uXOq.useRef)(onError);
        onErrorRef.current = onError;
        const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $667e963723dc9f11$var$useCacheEntry(queryKey);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            updateCacheEntry(queryKey, {
                isFetching: true
            });
            try {
                const response = await queryFnRef.current();
                updateCacheEntry(queryKey, {
                    data: response
                });
                onSuccessRef.current?.(response);
                return response;
            } catch (error) {
                const apiError = (0, (0, parcelRequire("gRLdW")).mapErrorToApiError)(error);
                updateCacheEntry(queryKey, {
                    error: apiError
                });
                onErrorRef.current?.(apiError);
            } finally{
                updateCacheEntry(queryKey, {
                    isFetching: false
                });
            }
            return null;
        }, [
            updateCacheEntry,
            queryKey
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (enabled && refetchOnWindowFocus) {
                const unbind = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: (0, (0, parcelRequire("VSDnB")).fg)('rovo_refocus_use_visibilitychange') ? 'visibilitychange' : 'focus',
                    listener: ()=>{
                        if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_refocus_use_visibilitychange')) {
                                if (document.visibilityState === 'visible') fetchData();
                            } else fetchData();
                        }
                    }
                });
                return unbind;
            }
        }, [
            enabled,
            fetchData,
            getCacheEntry,
            queryKey,
            refetchOnWindowFocus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!getCacheEntry(queryKey) && enabled) fetchData();
        }, [
            queryKey,
            fetchData,
            enabled,
            getCacheEntry
        ]);
        return {
            data: cache.data,
            error: cache.error,
            isFetching: cache.isFetching,
            refetch: fetchData
        };
    };
});
parcelRegister("dQjNg", function(module, exports) {
    $parcel$export(module.exports, "getAAIDFromARI", ()=>$09d02c91f15af39c$export$3761e66a04602cbd);
    $parcel$export(module.exports, "getARIFromAAID", ()=>$09d02c91f15af39c$export$acf3e1bcf222b00d);
    $parcel$export(module.exports, "AgentCreatedBy", ()=>$09d02c91f15af39c$export$1565ea9a9fb7ad67);
    $parcel$export(module.exports, "useProfileResolution", ()=>$09d02c91f15af39c$export$5d980898591175e);
    $parcel$export(module.exports, "filterAndSortAgents", ()=>$09d02c91f15af39c$export$13d60404a0dddebd);
    $parcel$export(module.exports, "getEnabledKnowlegeArisFromAgent", ()=>$09d02c91f15af39c$export$a6e36c224ec3c0cb);
    $parcel$export(module.exports, "getSuggestedOotbAgents", ()=>$09d02c91f15af39c$export$6d876204c5d593ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $23aI7;
    var $8dw1i;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    parcelRequire("26CR2");
    var $264zF = parcelRequire("264zF");
    var $1DVhQ;
    var $4ojTZ;
    var $8G7CX;
    var $3xYdY;
    var $gBv35;
    var $3go6U;
    const $09d02c91f15af39c$export$3761e66a04602cbd = (ari)=>{
        const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
        return matched ? matched[1] : undefined;
    };
    const $09d02c91f15af39c$export$acf3e1bcf222b00d = (aaid)=>{
        return `ari:cloud:identity::user/${aaid}`;
    };
    const $09d02c91f15af39c$export$1565ea9a9fb7ad67 = ({ agent: agent, siteId: siteId, simplified: simplified })=>{
        if ((0, (0, parcelRequire("8G7CX")).isCustomerAgent)(agent)) {
            const aaid = agent.creator ? $09d02c91f15af39c$export$3761e66a04602cbd(agent.creator) : undefined;
            if (!aaid) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($09d02c91f15af39c$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified
            });
        }
        if ((0, (0, parcelRequire("8G7CX")).isSystemAgent)(agent) || !agent.creator) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("23aI7"))))), {
            primaryColor: "var(--ds-icon-brand, #0C66E4)",
            label: "Atlassian"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "Atlassian"));
        if ((0, (0, parcelRequire("8G7CX")).isForgeAgent)(agent)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, agent.creator);
        return null;
    };
    const $09d02c91f15af39c$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false })=>{
        (0, (0, parcelRequire("gKZoD")).di)($09d02c91f15af39c$export$5d980898591175e);
        const { profile: profile, client: client } = $09d02c91f15af39c$export$5d980898591175e(userId, siteId);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, (0, parcelRequire("3go6U")).default).deactivatedCreatorName, {
            name: profile.data.fullName
        }) : profile.data?.fullName;
        if (profile.isFetching || !profile.data) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            isShimmering: true,
            height: 18,
            width: 100,
            borderRadius: 3
        });
        if (simplified) return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: `/people/${userId}`,
            target: "_blank"
        }, fullName);
        return profileCard ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $264zF.default), {
            userId: userId,
            resourceClient: client,
            ariaLabel: fullName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dw1i")).default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8dw1i")).default), {
            id: userId,
            isHighlighted: profile.data.isCurrentUser,
            text: `@${fullName}`
        });
    };
    function $09d02c91f15af39c$export$5d980898591175e(userId, siteId, shouldFetch = true) {
        const profileClient = (0, (0, parcelRequire("gBv35")).useProfileClient)();
        const profile = (0, (0, parcelRequire("4ojTZ")).useQuery)({
            queryKey: [
                'fetchProfile',
                siteId,
                userId
            ],
            queryFn: async ()=>{
                try {
                    const response = await profileClient.getProfile(siteId, userId);
                    return response;
                } catch (error) {
                    return {};
                }
            },
            enabled: shouldFetch
        });
        return {
            profile: profile,
            client: profileClient
        };
    }
    const $09d02c91f15af39c$export$13d60404a0dddebd = (agents, filters)=>{
        return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
    };
    const $09d02c91f15af39c$export$a6e36c224ec3c0cb = (agent)=>{
        if (!agent.knowledge_sources?.enabled) return [];
        return agent.knowledge_sources.sources.filter((source)=>source.enabled).reduce((acc, source)=>{
            switch(source.source){
                case 'confluence':
                    acc.push(...source.configuration?.parent_filter ?? []);
                    acc.push(...source.configuration?.space_filter ?? []);
                    break;
                case 'jira':
                    acc.push(...source.configuration?.project_filter ?? []);
                    break;
            }
            return acc;
        }, []);
    };
    const $09d02c91f15af39c$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
        const defaultAgentsNamedIds = product && (0, (0, parcelRequire("VSDnB")).fg)('rovo_enable_ootb_favourited_agents') ? (0, (0, parcelRequire("3xYdY")).DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, (0, parcelRequire("3xYdY")).DEFAULT_AGENTS_NAMED_ID_LIST) : (0, (0, parcelRequire("3xYdY")).DEFAULT_AGENTS_NAMED_ID_LIST);
        const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
        return defaultAgents;
    };
});
parcelRegister("8dw1i", function(module, exports) {
    $parcel$export(module.exports, "UNKNOWN_USER_ID", ()=>$359ac0149aaccbc2$export$af8124aa496797f2);
    $parcel$export(module.exports, "default", ()=>$359ac0149aaccbc2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jhVLw;
    var $kbF2s;
    var $ab8uA;
    var $k3AGD;
    var $cqJWb;
    var $4kfbr;
    var $cb25w;
    var $jZA09;
    var $j6B3T;
    var $bTspB;
    const $359ac0149aaccbc2$export$7452d7062a4d0634 = 1000;
    const $359ac0149aaccbc2$export$af8124aa496797f2 = '_|unknown|_';
    class $359ac0149aaccbc2$export$92ab8442e7a15cef extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        constructor(props){
            super(props), this.handleOnClick = (e)=>{
                const { id: id, text: text, onClick: onClick } = this.props;
                if (onClick) onClick(id, text, e);
            }, this.handleOnMouseEnter = (e)=>{
                const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
                if (onMouseEnter) onMouseEnter(id, text, e);
                this.hoverTimeout = window.setTimeout(()=>{
                    if (onHover) onHover();
                    this.hoverTimeout = undefined;
                }, $359ac0149aaccbc2$export$7452d7062a4d0634);
            }, this.handleOnMouseLeave = (e)=>{
                const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
                if (onMouseLeave) onMouseLeave(id, text, e);
                if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            }, this.getMentionType = ()=>{
                const { accessLevel: accessLevel, isHighlighted: isHighlighted } = this.props;
                if (isHighlighted) return (0, (0, parcelRequire("cqJWb")).MentionType).SELF;
                if ((0, (0, parcelRequire("cqJWb")).isRestricted)(accessLevel)) return (0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED;
                return (0, (0, parcelRequire("cqJWb")).MentionType).DEFAULT;
            };
            (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(props.id).start();
        }
        componentDidMount() {
            (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(this.props.id).success();
        }
        componentWillUnmount() {
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
            const ufoInstance = (0, (0, parcelRequire("bTspB")).mentionRenderedUfoExperience).getInstance(this.props.id);
            if ([
                (0, (0, parcelRequire("jZA09")).UFOExperienceState)['STARTED'],
                (0, (0, parcelRequire("jZA09")).UFOExperienceState)['IN_PROGRESS']
            ].includes(ufoInstance.state)) ufoInstance.abort();
        }
        renderUnknownUserError(id) {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6B3T")).UnknownUserError), {
                values: {
                    userId: id.slice(-5)
                }
            }, (message)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `@${message}`));
        }
        render() {
            const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
            const { text: text, id: id, accessLevel: accessLevel, localId: localId } = props;
            const mentionType = this.getMentionType();
            const failedMention = text === `@${$359ac0149aaccbc2$export$af8124aa496797f2}`;
            const mentionComponent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab8uA")).default), {
                mentionType: mentionType,
                onClick: handleOnClick,
                onMouseEnter: handleOnMouseEnter,
                onMouseLeave: handleOnMouseLeave,
                spellCheck: false
            }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTspB")).UfoErrorBoundary), {
                id: id
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                id: localId,
                "data-mention-id": id,
                "data-local-id": localId,
                "data-access-level": accessLevel,
                spellCheck: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kbF2s")).default), null, mentionType === (0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Suspense, {
                fallback: mentionComponent
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k3AGD")).default), {
                name: text
            }, mentionComponent)) : mentionComponent)));
        }
    }
    const $359ac0149aaccbc2$var$MentionWithAnalytics = (0, (0, parcelRequire("cb25w")).default)({
        onClick: (createEvent, props)=>{
            const { id: id, text: text, accessLevel: accessLevel } = props;
            const event = (0, (0, parcelRequire("4kfbr")).fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
            return event;
        },
        onHover: (createEvent, props)=>{
            const { id: id, text: text, accessLevel: accessLevel } = props;
            const event = (0, (0, parcelRequire("4kfbr")).fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
            return event;
        }
    })($359ac0149aaccbc2$export$92ab8442e7a15cef);
    const $359ac0149aaccbc2$var$Mention = $359ac0149aaccbc2$var$MentionWithAnalytics;
    var $359ac0149aaccbc2$export$2e2bcd8739ae039 = $359ac0149aaccbc2$var$Mention;
});
parcelRegister("kbF2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2323b0dd270b712$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $j6B3T;
    const $a2323b0dd270b712$var$EMPTY = {};
    const $a2323b0dd270b712$var$useI18n = (locale)=>{
        const [messages, setMessages] = (0, ($parcel$interopDefault($5uXOq))).useState($a2323b0dd270b712$var$EMPTY);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            let aborted = false;
            setMessages($a2323b0dd270b712$var$EMPTY);
            (0, (0, parcelRequire("j6B3T")).getMessagesForLocale)(locale).then((messages)=>{
                if (!aborted) setMessages(messages);
            }).catch((error)=>{
                console.error(error);
            });
            return ()=>{
                aborted = true;
            };
        }, [
            locale
        ]);
        return messages;
    };
    const $a2323b0dd270b712$var$MessagesIntlProvider = (props)=>{
        const { children: children } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const messages = $a2323b0dd270b712$var$useI18n(intl.locale);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            ...intl,
            messages: messages
        }, children);
    };
    var $a2323b0dd270b712$export$2e2bcd8739ae039 = $a2323b0dd270b712$var$MessagesIntlProvider;
});
parcelRegister("j6B3T", function(module, exports) {
    $parcel$export(module.exports, "UnknownUserError", ()=>$2ed9ffbf75c73a6c$export$98e06fe7a6174253);
    $parcel$export(module.exports, "NoAccessWarning", ()=>$2ed9ffbf75c73a6c$export$58bd5a2057b6b855);
    $parcel$export(module.exports, "NoAccessLabel", ()=>$2ed9ffbf75c73a6c$export$da9f8ce14593162f);
    $parcel$export(module.exports, "getMessagesForLocale", ()=>$2ed9ffbf75c73a6c$export$d0a3169680473b6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $koVbs;
    var $8aQI9;
    const $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
            const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
            const message = formatMessage(messageDescriptor, values);
            if (typeof children === 'function') return children(message);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                values: values,
                ...messageDescriptor
            });
        };
    const $2ed9ffbf75c73a6c$export$98e06fe7a6174253 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).unknownUserError);
    const $2ed9ffbf75c73a6c$export$58bd5a2057b6b855 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).noAccessWarning);
    const $2ed9ffbf75c73a6c$export$da9f8ce14593162f = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).noAccessLabel);
    const $2ed9ffbf75c73a6c$export$4a258ffee7316766 = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).defaultHeadline);
    const $2ed9ffbf75c73a6c$export$702321a50d74536e = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).defaultAdvisedAction);
    const $2ed9ffbf75c73a6c$export$ed7f16088a93ae9d = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).loginAgain);
    const $2ed9ffbf75c73a6c$export$3ab158df56460d1c = $2ed9ffbf75c73a6c$export$392a0c6a82ab0e50((0, (0, parcelRequire("8aQI9")).messages).differentText);
    const $2ed9ffbf75c73a6c$export$d0a3169680473b6c = async (locale)=>{
        switch(locale){
            case 'cs':
                return (parcelRequire("jnKJ1")).then((mod)=>mod.default);
            case 'da':
                return (parcelRequire("8SJKQ")).then((mod)=>mod.default);
            case 'de':
                return (parcelRequire("hYoQy")).then((mod)=>mod.default);
            case 'en':
                return (parcelRequire("2bcHM")).then((mod)=>mod.default);
            case 'en_GB':
                return (parcelRequire("4j0ky")).then((mod)=>mod.default);
            case 'en_ZZ':
                return (parcelRequire("7RC8J")).then((mod)=>mod.default);
            case 'es':
                return (parcelRequire("gvMUc")).then((mod)=>mod.default);
            case 'et':
                return (parcelRequire("hk7Jz")).then((mod)=>mod.default);
            case 'fi':
                return (parcelRequire("aYEpz")).then((mod)=>mod.default);
            case 'fr':
                return (parcelRequire("5gawx")).then((mod)=>mod.default);
            case 'hu':
                return (parcelRequire("1RH6c")).then((mod)=>mod.default);
            case 'is':
                return (parcelRequire("lfLU3")).then((mod)=>mod.default);
            case 'it':
                return (parcelRequire("6NuWr")).then((mod)=>mod.default);
            case 'ja':
                return (parcelRequire("1pAlF")).then((mod)=>mod.default);
            case 'ko':
                return (parcelRequire("eEv2y")).then((mod)=>mod.default);
            case 'nb':
                return (parcelRequire("cwLXs")).then((mod)=>mod.default);
            case 'nl':
                return (parcelRequire("2NHoQ")).then((mod)=>mod.default);
            case 'pl':
                return (parcelRequire("kZTyH")).then((mod)=>mod.default);
            case 'pt_BR':
            case 'pt-BR':
                return (parcelRequire("eUKy5")).then((mod)=>mod.default);
            case 'pt_PT':
            case 'pt-PT':
                return (parcelRequire("lmwJp")).then((mod)=>mod.default);
            case 'ro':
                return (parcelRequire("1UGd3")).then((mod)=>mod.default);
            case 'ru':
                return (parcelRequire("63ikG")).then((mod)=>mod.default);
            case 'sk':
                return (parcelRequire("hgg7A")).then((mod)=>mod.default);
            case 'sv':
                return (parcelRequire("2P9BM")).then((mod)=>mod.default);
            case 'th':
                return (parcelRequire("fliA1")).then((mod)=>mod.default);
            case 'tr':
                return (parcelRequire("5N21C")).then((mod)=>mod.default);
            case 'uk':
                return (parcelRequire("lM2PH")).then((mod)=>mod.default);
            case 'vi':
                return (parcelRequire("MMGBa")).then((mod)=>mod.default);
            case 'zh_TW':
                return (parcelRequire("4GoCd")).then((mod)=>mod.default);
            case 'zh':
                return (parcelRequire("jsQ53")).then((mod)=>mod.default);
            default:
                {
                    const fragments = locale.split(/[_-]/);
                    if (fragments.length === 2) return $2ed9ffbf75c73a6c$export$d0a3169680473b6c(fragments[0]);
                    else return (parcelRequire("2bcHM")).then((mod)=>mod.default);
                }
        }
    };
});
parcelRegister("8aQI9", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6ca607c1e1522de5$export$defe85febe8b728c);
    var $7VHMR;
    const $6ca607c1e1522de5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unknownUserError: {
            id: 'fabric.mention.unknow.user.error',
            defaultMessage: 'Unknown user {userId}',
            description: 'Mention user name could not be found or look up failed'
        },
        noAccessWarning: {
            id: 'fabric.mention.noAccess.warning',
            defaultMessage: "{name} won't be notified as they have no access",
            description: "Warning message to show that the mentioned user won't be notified"
        },
        noAccessLabel: {
            id: 'fabric.mention.noAccess.label',
            defaultMessage: 'No access',
            description: 'Label for no access icon'
        },
        defaultHeadline: {
            id: 'fabric.mention.error.defaultHeadline',
            defaultMessage: 'Something went wrong',
            description: 'Error message shown when there is an error communicating with backend'
        },
        defaultAdvisedAction: {
            id: 'fabric.mention.error.defaultAction',
            defaultMessage: 'Try again in a few seconds',
            description: 'Default advised action when an error occurs'
        },
        loginAgain: {
            id: 'fabric.mention.error.loginAgain',
            defaultMessage: 'Try logging out then in again',
            description: 'Login again message when there is an authentication error occurs'
        },
        differentText: {
            id: 'fabric.mention.error.differentText',
            defaultMessage: 'Try entering different text',
            description: 'Enter different text message when a forbidden error occurs'
        },
        memberCountWithoutYou: {
            id: 'fabric.elements.mentions.team.member.count',
            defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}",
            description: 'Byline to show the number of members in the team when the current user is not a member of the team'
        },
        memberCountWithYou: {
            id: 'fabric.elements.mentions.team.member.count.including.you',
            defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you",
            description: 'Byline to show the number of members in the team when the current user is also a member of the team'
        },
        plus50MembersWithoutYou: {
            id: 'fabric.elements.mentions.team.member.50plus',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the number of members in the team when the number exceeds 50'
        },
        plus50MembersWithYou: {
            id: 'fabric.elements.mentions.team.member.50plus.including.you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
        }
    });
});
parcelRegister("jnKJ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsDeQ").then(()=>parcelRequire('dTLgY'));
});
parcelRegister("8SJKQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6dIE2").then(()=>parcelRequire('keyh3'));
});
parcelRegister("hYoQy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jYcAq").then(()=>parcelRequire('eL3iu'));
});
parcelRegister("2bcHM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6MuqU").then(()=>parcelRequire('wBhQ2'));
});
parcelRegister("4j0ky", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l8igA").then(()=>parcelRequire('27EyS'));
});
parcelRegister("7RC8J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cp1kc").then(()=>parcelRequire('eoxiv'));
});
parcelRegister("gvMUc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("tBMef").then(()=>parcelRequire('6jEIT'));
});
parcelRegister("hk7Jz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e4cqm").then(()=>parcelRequire('dkMw7'));
});
parcelRegister("aYEpz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("yHeUA").then(()=>parcelRequire('5NjhV'));
});
parcelRegister("5gawx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("69FtF").then(()=>parcelRequire('bWMX4'));
});
parcelRegister("1RH6c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1SwVQ").then(()=>parcelRequire('aPy43'));
});
parcelRegister("lfLU3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iMqxw").then(()=>parcelRequire('6FrOe'));
});
parcelRegister("6NuWr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("i9sdu").then(()=>parcelRequire('epfvh'));
});
parcelRegister("1pAlF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aydQg").then(()=>parcelRequire('hjvLU'));
});
parcelRegister("eEv2y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5znUH").then(()=>parcelRequire('dclct'));
});
parcelRegister("cwLXs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1lvxw").then(()=>parcelRequire('56DDk'));
});
parcelRegister("2NHoQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7yQmI").then(()=>parcelRequire('1Vmnr'));
});
parcelRegister("kZTyH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6TpZW").then(()=>parcelRequire('lTYFq'));
});
parcelRegister("eUKy5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2eSUb").then(()=>parcelRequire('hxNc0'));
});
parcelRegister("lmwJp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fUluO").then(()=>parcelRequire('h7PMN'));
});
parcelRegister("1UGd3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("DchKe").then(()=>parcelRequire('3T3Pt'));
});
parcelRegister("63ikG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eYBMi").then(()=>parcelRequire('jvE81'));
});
parcelRegister("hgg7A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6q2et").then(()=>parcelRequire('lxjSE'));
});
parcelRegister("2P9BM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iINAq").then(()=>parcelRequire('fIX00'));
});
parcelRegister("fliA1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ibfKG").then(()=>parcelRequire('kbvg1'));
});
parcelRegister("5N21C", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("80oK6").then(()=>parcelRequire('2eUU2'));
});
parcelRegister("lM2PH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9X4yo").then(()=>parcelRequire('kxF7S'));
});
parcelRegister("MMGBa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hYMIE").then(()=>parcelRequire('aIfZT'));
});
parcelRegister("4GoCd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cjVNf").then(()=>parcelRequire('lVs4z'));
});
parcelRegister("jsQ53", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("16rPB").then(()=>parcelRequire('bY3rp'));
});
parcelRegister("ab8uA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6273a4608d138fff$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $cqJWb;
    var $5uXOq = parcelRequire("5uXOq");
    const $6273a4608d138fff$var$mentionStyle = {
        [(0, (0, parcelRequire("cqJWb")).MentionType).SELF]: {
            background: `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            borderColor: 'transparent',
            text: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            hoveredBackground: `var(--ds-background-brand-bold-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
            pressedBackground: `var(--ds-background-brand-bold-pressed, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
        },
        [(0, (0, parcelRequire("cqJWb")).MentionType).RESTRICTED]: {
            background: 'transparent',
            borderColor: `var(--ds-border-bold, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            text: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            hoveredBackground: 'transparent',
            pressedBackground: 'transparent'
        },
        [(0, (0, parcelRequire("cqJWb")).MentionType).DEFAULT]: {
            background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            borderColor: 'transparent',
            text: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
            hoveredBackground: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
            pressedBackground: `var(--ds-background-neutral-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
        }
    };
    const $6273a4608d138fff$var$getStyle = ({ mentionType: mentionType }, property)=>{
        const obj = $6273a4608d138fff$var$mentionStyle[mentionType][property];
        return typeof obj === 'string' ? obj : obj;
    };
    const $6273a4608d138fff$var$PrimitiveMention = (0, $5uXOq.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ref: ref,
            css: (0, (0, parcelRequire("f8Sb3")).css)("display:inline;border:1px solid ", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'borderColor'), ";background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'background'), ";color:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:normal;word-break:break-word;&:hover{background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'hoveredBackground'), ";}&:active{background:", $6273a4608d138fff$var$getStyle({
                mentionType: mentionType
            }, 'pressedBackground'), ";}"),
            ...other
        });
    });
    var $6273a4608d138fff$export$2e2bcd8739ae039 = $6273a4608d138fff$var$PrimitiveMention;
});
parcelRegister("k3AGD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4938be5a70d0163$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $e4938be5a70d0163$var$AsyncNoAccessTooltip = (0, ($parcel$interopDefault($5uXOq))).lazy(()=>(parcelRequire("22G24")).then((module)=>{
            return {
                default: module.NoAccessTooltip
            };
        }));
    var $e4938be5a70d0163$export$2e2bcd8739ae039 = $e4938be5a70d0163$var$AsyncNoAccessTooltip;
});
parcelRegister("22G24", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8n8M3").then(()=>parcelRequire('4YERU'));
});
parcelRegister("bTspB", function(module, exports) {
    $parcel$export(module.exports, "mentionRenderedUfoExperience", ()=>$fb9391c5736559e1$export$1d011e4240507c78);
    $parcel$export(module.exports, "UfoErrorBoundary", ()=>$fb9391c5736559e1$export$5ef1c2550074a375);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBycP;
    var $7Zbvr;
    const $fb9391c5736559e1$export$1d011e4240507c78 = new (0, (0, parcelRequire("cBycP")).ConcurrentExperience)('mention-rendered', {
        platform: {
            component: 'mention'
        },
        type: (0, (0, parcelRequire("7Zbvr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("7Zbvr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    class $fb9391c5736559e1$export$5ef1c2550074a375 extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            $fb9391c5736559e1$export$1d011e4240507c78.getInstance(this.props.id).failure();
        }
        render() {
            return this.props.children;
        }
    }
});
parcelRegister("26CR2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b61766090747c00e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "withOuterListeners", ()=>(parcelRequire("iMLpJ")).default);
    $parcel$export(module.exports, "TeamProfileCard", ()=>(parcelRequire("AF8aN")).default);
    $parcel$export(module.exports, "ProfileCardTrigger", ()=>(parcelRequire("264zF")).default);
    $parcel$export(module.exports, "ProfileClient", ()=>(parcelRequire("bp5g1")).default);
    $parcel$export(module.exports, "UserProfileClient", ()=>(parcelRequire("dFLsP")).default);
    $parcel$export(module.exports, "DELAY_MS_SHOW", ()=>$e41878b3b8cab0db$export$5b956b542f1bc1b3);
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>(parcelRequire("5uVl7")).AgentProfileCardTrigger);
    var $bp5g1 = parcelRequire("bp5g1");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    var $9gV7o = parcelRequire("9gV7o");
    var $6uTwi = parcelRequire("6uTwi");
    var $lrMir = parcelRequire("lrMir");
    var $d4FHw = parcelRequire("d4FHw");
    var $264zF = parcelRequire("264zF");
    var $iMLpJ = parcelRequire("iMLpJ");
    var $AF8aN = parcelRequire("AF8aN");
    var $5uVl7 = parcelRequire("5uVl7");
    var $kDbj5 = parcelRequire("kDbj5");
    var $b61766090747c00e$export$2e2bcd8739ae039 = (0, $d4FHw.default);
});
parcelRegister("bp5g1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$35fb800f6bdcf84a$export$2e2bcd8739ae039);
    var $kTK0a;
    var $aIZdc;
    var $VSDnB;
    var $4zh20 = parcelRequire("4zh20");
    var $4mT2s = parcelRequire("4mT2s");
    var $fjEAi = parcelRequire("fjEAi");
    var $dFLsP = parcelRequire("dFLsP");
    const $35fb800f6bdcf84a$var$defaultConfig = {
        gatewayGraphqlUrl: '/gateway/api/graphql'
    };
    class $35fb800f6bdcf84a$var$ProfileCardClient {
        constructor(config, clients){
            const withDefaultConfig = {
                ...$35fb800f6bdcf84a$var$defaultConfig,
                ...config,
                gatewayGraphqlUrl: config.gatewayGraphqlUrl ?? $35fb800f6bdcf84a$var$defaultConfig.gatewayGraphqlUrl
            };
            this.userClient = clients?.userClient || new (0, $dFLsP.default)(withDefaultConfig);
            this.teamClient = clients?.teamClient || new (0, $fjEAi.default)(withDefaultConfig);
            this.rovoAgentClient = clients?.rovoAgentClient || new (0, $4zh20.default)(withDefaultConfig);
            this.tcClient = $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(withDefaultConfig, clients);
        }
        flushCache() {
            this.userClient.flushCache();
            this.teamClient.flushCache();
            this.tcClient?.flushCache();
            this.rovoAgentClient?.flushCache();
        }
        getProfile(cloudId, userId, analytics) {
            return this.userClient.getProfile(cloudId, userId, analytics);
        }
        getTeamProfile(teamId, orgId, analytics) {
            return this.teamClient.getProfile(teamId, orgId, analytics);
        }
        getReportingLines(userId) {
            return this.tcClient?.getReportingLines(userId) || Promise.resolve({
                managers: [],
                reports: []
            });
        }
        async getTeamCentralBaseUrl(teamCentralScopes) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(this.tcClient?.options.teamCentralBaseUrl);
            if (this.tcClient === undefined) return Promise.resolve(undefined);
            const isGlobalExperienceWorkspace = await this.tcClient.getIsGlobalExperienceWorkspace();
            if (!isGlobalExperienceWorkspace) return Promise.resolve((0, (0, parcelRequire("kTK0a")).getATLContextUrl)('team'));
            let suffix = '';
            if (teamCentralScopes !== undefined) {
                const orgId = await this.tcClient.getOrgId();
                if (orgId === null) return Promise.resolve(undefined);
                suffix += `/o/${orgId}`;
                if (teamCentralScopes.withSiteContext) suffix += `/s/${this.tcClient.options.cloudId}`;
            }
            return Promise.resolve(`${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}${suffix}`);
        }
        async shouldShowGiveKudos() {
            if (!this.tcClient || !await this.getTeamCentralBaseUrl()) return Promise.resolve(false);
            return this.tcClient.checkWorkspaceExists();
        }
        getRovoAgentProfile(id, analytics) {
            return this.rovoAgentClient?.getProfile(id, analytics);
        }
        getRovoAgentPermissions(id, fireAnalytics) {
            return this.rovoAgentClient?.getPermissions(id, fireAnalytics);
        }
        deleteAgent(id, analytics) {
            return this.rovoAgentClient?.deleteAgent(id, analytics);
        }
        setFavouriteAgent(id, isFavourite, analytics) {
            return this.rovoAgentClient?.setFavouriteAgent(id, isFavourite, analytics);
        }
    }
    function $35fb800f6bdcf84a$var$maybeCreateTeamCentralClient(config, clients) {
        if ((0, (0, parcelRequire("aIZdc")).isFedRamp)()) return undefined;
        if (clients?.teamCentralClient) return clients.teamCentralClient;
        const teamCentralEnabled = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? config.teamCentralDisabled !== true : config.teamCentralUrl;
        return teamCentralEnabled ? new (0, $4mT2s.default)({
            ...config
        }) : undefined;
    }
    var $35fb800f6bdcf84a$export$2e2bcd8739ae039 = $35fb800f6bdcf84a$var$ProfileCardClient;
});
parcelRegister("4zh20", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$23b1bd6752a000ab$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $23b1bd6752a000ab$var$createHeaders = (product, cloudId, isBodyJson)=>{
        const headers = new Headers({
            'X-Product': product,
            'X-Experience-Id': 'profile-card',
            'X-Cloudid': cloudId || ''
        });
        if (isBodyJson) headers.set('Content-Type', 'application/json');
        return headers;
    };
    class $23b1bd6752a000ab$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(id, cloudId) {
            const product = this.options.productIdentifier || 'rovo';
            const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
            if (id.type === 'identity') return fetch(new Request(`/gateway/api/assist/agents/v1/accountid/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
            return fetch(new Request(`/gateway/api/assist/agents/v1/${id.value}`, {
                method: 'GET',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then((response)=>response.json());
        }
        getProfile(id, analytics) {
            if (!id.value) return Promise.reject(new Error('Id is missing'));
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            const cache = this.getCachedProfile(id.value);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                this.makeRequest(id, this.options.cloudId || '').then((data)=>{
                    if (this.cache) this.setCachedProfile(id.value, data);
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'request', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        deleteAgent(agentId, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}`, {
                    method: 'DELETE',
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', 'deleteAgent', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        setFavouriteAgent(agentId, isFavourite, analytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise(async (resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
                const requestMethod = isFavourite ? 'POST' : 'DELETE';
                if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('triggered', 'actionSubjectId'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId);
                await fetch(new Request(`/gateway/api/assist/agents/v1/${agentId}/favourite`, {
                    method: requestMethod,
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers
                })).then(()=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('succeeded', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve();
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.agentRequestAnalytics)('failed', actionSubjectId, {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
        getPermissions(id, fireAnalytics) {
            if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                const product = this.options.productIdentifier || 'rovo';
                if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('triggered'));
                const headers = $23b1bd6752a000ab$var$createHeaders(product, this.options.cloudId, true);
                fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                    method: 'POST',
                    credentials: 'include',
                    mode: 'cors',
                    headers: headers,
                    body: JSON.stringify({
                        permission_ids: [
                            'AGENT_CREATE',
                            'AGENT_UPDATE',
                            'AGENT_DELETE',
                            'AGENT_DEACTIVATE',
                            'AGENT_READ'
                        ]
                    })
                })).then((response)=>response.json()).then((data)=>{
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('succeeded', 'getAgentPermissions', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.agentRequestAnalytics)('failed', 'getAgentPermissions', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("ivXTE", function(module, exports) {
    $parcel$export(module.exports, "fireEvent", ()=>$533bc31bb6af10e0$export$43835e9acf248a15);
    $parcel$export(module.exports, "cardTriggered", ()=>$533bc31bb6af10e0$export$d50ab8a3b6975c);
    $parcel$export(module.exports, "teamRequestAnalytics", ()=>$533bc31bb6af10e0$export$c9b0e37b229a297b);
    $parcel$export(module.exports, "userRequestAnalytics", ()=>$533bc31bb6af10e0$export$12dae48763368ac9);
    $parcel$export(module.exports, "profileCardRendered", ()=>$533bc31bb6af10e0$export$41816a317479160b);
    $parcel$export(module.exports, "actionClicked", ()=>$533bc31bb6af10e0$export$fdcd134fbeb1f921);
    $parcel$export(module.exports, "reportingLinesClicked", ()=>$533bc31bb6af10e0$export$93260987012593be);
    $parcel$export(module.exports, "moreActionsClicked", ()=>$533bc31bb6af10e0$export$79befd155063a6a7);
    $parcel$export(module.exports, "teamAvatarClicked", ()=>$533bc31bb6af10e0$export$2703289b35687fde);
    $parcel$export(module.exports, "moreMembersClicked", ()=>$533bc31bb6af10e0$export$b4411a7661cf2d3f);
    $parcel$export(module.exports, "errorRetryClicked", ()=>$533bc31bb6af10e0$export$c86679da702d560e);
    $parcel$export(module.exports, "agentRequestAnalytics", ()=>$533bc31bb6af10e0$export$a9f8c9f412cf5664);
    var $6TKEY = parcelRequire("6TKEY");
    const $533bc31bb6af10e0$var$ANALYTICS_CHANNEL = 'peopleTeams';
    const $533bc31bb6af10e0$var$runItLater = (cb)=>{
        const requestIdleCallback = window.requestIdleCallback;
        if (typeof requestIdleCallback === 'function') return requestIdleCallback(cb);
        if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
        return ()=>setTimeout(cb);
    };
    const $533bc31bb6af10e0$export$43835e9acf248a15 = (createAnalyticsEvent, body)=>{
        if (!createAnalyticsEvent) return;
        $533bc31bb6af10e0$var$runItLater(()=>{
            createAnalyticsEvent(body).fire($533bc31bb6af10e0$var$ANALYTICS_CHANNEL);
        });
    };
    const $533bc31bb6af10e0$var$TEAM_SUBJECT = 'teamProfileCard';
    const $533bc31bb6af10e0$var$USER_SUBJECT = 'profilecard';
    const $533bc31bb6af10e0$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
    const $533bc31bb6af10e0$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
            eventType: eventType,
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                packageName: "platform-pkg",
                packageVersion: "0.0.0-use.local",
                ...attributes,
                firedAt: Math.round((0, $6TKEY.getPageTime)())
            }
        });
    const $533bc31bb6af10e0$var$getActionSubject = (type)=>{
        switch(type){
            case 'user':
                return $533bc31bb6af10e0$var$USER_SUBJECT;
            case 'team':
                return $533bc31bb6af10e0$var$TEAM_SUBJECT;
            case 'agent':
                return $533bc31bb6af10e0$var$AGENT_SUBJECT;
            default:
                return 'user';
        }
    };
    const $533bc31bb6af10e0$export$d50ab8a3b6975c = (type, method)=>{
        return $533bc31bb6af10e0$var$createEvent('ui', 'triggered', $533bc31bb6af10e0$var$getActionSubject(type), undefined, {
            method: method
        });
    };
    const $533bc31bb6af10e0$export$c9b0e37b229a297b = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$TEAM_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$12dae48763368ac9 = (action, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$USER_SUBJECT, 'request', attributes);
    const $533bc31bb6af10e0$export$41816a317479160b = (type, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'rendered', $533bc31bb6af10e0$var$getActionSubject(type), actionSubjectId, attributes);
    const $533bc31bb6af10e0$export$fdcd134fbeb1f921 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'action', attributes);
    const $533bc31bb6af10e0$export$93260987012593be = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$USER_SUBJECT, 'reportingLines', attributes);
    const $533bc31bb6af10e0$export$79befd155063a6a7 = (type, attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$getActionSubject(type), 'moreActions', attributes);
    const $533bc31bb6af10e0$export$2703289b35687fde = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'avatar', attributes);
    const $533bc31bb6af10e0$export$b4411a7661cf2d3f = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'moreMembers', attributes);
    const $533bc31bb6af10e0$export$c86679da702d560e = (attributes)=>$533bc31bb6af10e0$var$createEvent('ui', 'clicked', $533bc31bb6af10e0$var$TEAM_SUBJECT, 'errorRetry', attributes);
    const $533bc31bb6af10e0$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$533bc31bb6af10e0$var$createEvent('operational', action, $533bc31bb6af10e0$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
});
parcelRegister("6TKEY", function(module, exports) {
    $parcel$export(module.exports, "getPageTime", ()=>$83ec369559ddc36d$export$e9faea7c41053334);
    const $83ec369559ddc36d$var$isPerformanceAvailable = ()=>{
        return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
    };
    const $83ec369559ddc36d$var$performanceAvailable = $83ec369559ddc36d$var$isPerformanceAvailable();
    const $83ec369559ddc36d$var$initialPageTime = Date.now();
    const $83ec369559ddc36d$export$e9faea7c41053334 = ()=>{
        if ($83ec369559ddc36d$var$performanceAvailable) return performance.now();
        return Date.now() - $83ec369559ddc36d$var$initialPageTime;
    };
});
parcelRegister("cZg4V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e76084040147eae1$export$2e2bcd8739ae039);
    var $iwKVT = parcelRequire("iwKVT");
    class $e76084040147eae1$export$2e2bcd8739ae039 {
        constructor(config){
            const defaults = {
                cacheSize: 10,
                cacheMaxAge: 0
            };
            this.config = {
                ...defaults,
                ...config
            };
            this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
            this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
            if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
            this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $iwKVT.LRUMap)(this.config.cacheSize);
        }
        setCachedProfile(cacheIdentifier, profile) {
            this.cache && this.cache.set(cacheIdentifier, {
                expire: Date.now() + this.config.cacheMaxAge,
                profile: profile
            });
        }
        getCachedProfile(cacheIdentifier) {
            if (!this.cache) return null;
            const cached = this.cache.get(cacheIdentifier);
            if (!cached) return null;
            if (cached.expire < Date.now()) {
                this.cache.delete(cacheIdentifier);
                return null;
            }
            this.setCachedProfile(cacheIdentifier, cached.profile);
            return cached.profile;
        }
        flushCache() {
            if (this.cache) this.cache.clear();
        }
    }
});
parcelRegister("f3Zb8", function(module, exports) {
    $parcel$export(module.exports, "getErrorAttributes", ()=>$b5fa858d1f1072ea$export$6ad9e7706a4ee0f8);
    $parcel$export(module.exports, "handleDirectoryGraphQLErrors", ()=>$b5fa858d1f1072ea$export$7642af465ceb7f05);
    $parcel$export(module.exports, "handleAGGErrors", ()=>$b5fa858d1f1072ea$export$d9ad65d422ee3f8c);
    var $fcA5f = parcelRequire("fcA5f");
    const $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY = [
        'NotPermitted',
        'Gone',
        'IdentityUserNotFoundError'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG = [
        'IdentityUserNotFoundError',
        'TEAMS_FORBIDDEN',
        'TEAMS_TEAM_DELETED'
    ];
    const $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
        'Gone'
    ];
    function $b5fa858d1f1072ea$var$isIgnoredError(error) {
        if (!error) return false;
        if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return !!error && $b5fa858d1f1072ea$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
        else if (error instanceof (0, $fcA5f.AGGError)) return !!error.errorType && $b5fa858d1f1072ea$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $b5fa858d1f1072ea$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
        return false;
    }
    const $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8 = (error)=>{
        if (error instanceof (0, $fcA5f.DirectoryGraphQLErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.DirectoryGraphQLError)) return {
            errorMessage: error.message,
            errorCategory: error.category,
            errorType: error.type,
            errorPath: error.path,
            errorNumber: error.errorNumber,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error)
        };
        else if (error instanceof (0, $fcA5f.AGGErrors)) return {
            errorMessage: error.message,
            errorCount: error.errors.length,
            errorDetails: error.errors.map($b5fa858d1f1072ea$export$6ad9e7706a4ee0f8),
            isSLOFailure: !error.errors.every($b5fa858d1f1072ea$var$isIgnoredError),
            traceId: error.traceId
        };
        else if (error instanceof (0, $fcA5f.AGGError)) return {
            errorMessage: error.message,
            errorType: error.errorType,
            errorStatusCode: error.statusCode,
            isSLOFailure: !$b5fa858d1f1072ea$var$isIgnoredError(error),
            errorCategory: error.classification
        };
        else if (error instanceof Error) {
            if (error.message.startsWith('Unable to fetch user:')) {
                if (error.hasOwnProperty('cause')) {
                    const causeError = error.cause;
                    if (causeError instanceof (0, $fcA5f.DirectoryGraphQLErrors) || causeError instanceof (0, $fcA5f.AGGErrors)) return $b5fa858d1f1072ea$export$6ad9e7706a4ee0f8(causeError);
                }
                return {
                    errorMessage: error.message,
                    isSLOFailure: false
                };
            }
            return {
                errorMessage: error.message,
                isSLOFailure: true
            };
        }
        return {
            errorMessage: 'Unknown error',
            isSLOFailure: true
        };
    };
    const $b5fa858d1f1072ea$export$7642af465ceb7f05 = (errors, traceId)=>{
        throw new (0, $fcA5f.DirectoryGraphQLErrors)(errors, traceId);
    };
    const $b5fa858d1f1072ea$export$d9ad65d422ee3f8c = (errors, traceId)=>{
        throw new (0, $fcA5f.AGGErrors)(errors, traceId);
    };
});
parcelRegister("fcA5f", function(module, exports) {
    $parcel$export(module.exports, "HttpError", ()=>$7db90b14dd6e48a6$export$65bd6083489bd8bb);
    $parcel$export(module.exports, "DirectoryGraphQLError", ()=>$7db90b14dd6e48a6$export$c1e4d0de940c06a2);
    $parcel$export(module.exports, "DirectoryGraphQLErrors", ()=>$7db90b14dd6e48a6$export$5a5fbfed34a590a1);
    $parcel$export(module.exports, "AGGError", ()=>$7db90b14dd6e48a6$export$4a696f048dcc929);
    $parcel$export(module.exports, "AGGErrors", ()=>$7db90b14dd6e48a6$export$60d8267243755b9c);
    class $7db90b14dd6e48a6$export$65bd6083489bd8bb extends Error {
        constructor(code, reason, traceId){
            super(reason);
            this.code = code;
            this.traceId = traceId;
        }
    }
    class $7db90b14dd6e48a6$export$c1e4d0de940c06a2 extends Error {
        constructor(message, category, type, extensions = {}, path = []){
            super(message);
            this.category = category;
            this.type = type;
            this.path = path.join('.');
            const { errorNumber: errorNumber, ...unknownExtension } = extensions;
            this.errorNumber = extensions.errorNumber;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$5a5fbfed34a590a1 extends Error {
        constructor(errors, traceId){
            super('DirectoryGraphQLErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
            else this.errors = [];
        }
    }
    class $7db90b14dd6e48a6$export$4a696f048dcc929 extends Error {
        constructor(message, extensions, path = []){
            super(message);
            this.path = path?.join('.');
            const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
            this.statusCode = statusCode;
            this.errorType = errorType;
            this.classification = classification;
            this.extensions = unknownExtension;
        }
    }
    class $7db90b14dd6e48a6$export$60d8267243755b9c extends Error {
        constructor(errors, traceId){
            super('AGGErrors');
            this.traceId = traceId;
            if (Array.isArray(errors)) this.errors = errors.map((error)=>new $7db90b14dd6e48a6$export$4a696f048dcc929(error.message, error.extensions, error.path));
            else this.errors = [];
        }
    }
});
parcelRegister("4mT2s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8d68ade6ab7f448$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cZg4V = parcelRequire("cZg4V");
    var $a6hGK = parcelRequire("a6hGK");
    var $hnIbm = parcelRequire("hnIbm");
    const $b8d68ade6ab7f448$export$1862ef0c3880ca8d = (aaid)=>({
            query: `
    fragment ReportingLinesUserPII on UserPII {
      name
      picture
    }

    fragment ReportingLinesUserFragment on ReportingLinesUser {
      accountIdentifier
      identifierType
      pii {
        ...ReportingLinesUserPII
      }
    }

    query ReportingLines($aaid: String) {
      reportingLines(aaidOrHash: $aaid) {
        managers {
          ...ReportingLinesUserFragment
        }
        reports {
          ...ReportingLinesUserFragment
        }
      }
    }
  `,
            variables: {
                aaid: aaid
            }
        });
    let $b8d68ade6ab7f448$var$isTCReadyPromiseMap = new Map();
    const $b8d68ade6ab7f448$var$globalExperiencePromiseCache = new Map();
    const $b8d68ade6ab7f448$var$orgIdPromiseCache = new Map();
    class $b8d68ade6ab7f448$var$TeamCentralCardClient extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
            this.bypassOnFailure = false;
            this.isTCReadyPromise = this.createTcReadyPromise(options);
            this.isGlobalExperienceWorkspacePromise = this.preloadIsGlobalExperienceWorkspace(options.cloudId);
            this.orgIdPromise = this.preloadOrgId(options.gatewayGraphqlUrl, options.cloudId, options.orgId);
        }
        createTcReadyPromise(config) {
            if (config.cloudId) {
                let promise = $b8d68ade6ab7f448$var$isTCReadyPromiseMap.get(config.cloudId);
                if (!promise) {
                    promise = this.hasTCWorkspace(config);
                    $b8d68ade6ab7f448$var$isTCReadyPromiseMap.set(config.cloudId, promise);
                }
                return promise;
            }
            return Promise.resolve(true);
        }
        getReportingLines(userId) {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) {
                    if (!userId) return Promise.reject(new Error('userId missing'));
                    const cache = this.getCachedProfile(userId);
                    if (cache) return Promise.resolve(cache);
                    if (this.bypassOnFailure) return Promise.resolve({});
                    return new Promise((resolve)=>{
                        this.makeRequest(userId).then((data)=>{
                            const enhancedData = {
                                managers: this.filterReportingLinesUser(data?.managers),
                                reports: this.filterReportingLinesUser(data?.reports)
                            };
                            if (this.cache) this.setCachedProfile(userId, enhancedData);
                            resolve(enhancedData);
                        }).catch((error)=>{
                            if (error?.status === 401 || error?.status === 403) this.bypassOnFailure = true;
                            resolve({});
                        });
                    });
                }
                return Promise.resolve({
                    managers: [],
                    reports: []
                });
            }, ()=>Promise.resolve({
                    managers: [],
                    reports: []
                }));
        }
        async makeRequest(userId) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) {
                if (this.options.teamCentralDisabled === true) throw new Error('makeRequest cannot be called when the client has been disabled');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)('/gateway/api/watermelon/graphql?operationName=ReportingLines', query);
                return response.reportingLines;
            } else {
                if (!this.options.teamCentralUrl) throw new Error('options.teamCentralUrl is a required parameter for retrieving Team Central data');
                const query = $b8d68ade6ab7f448$export$1862ef0c3880ca8d(userId);
                const response = await (0, $hnIbm.directoryGraphqlQuery)(`${this.options.teamCentralUrl}?operationName=ReportingLines`, query);
                return response.reportingLines;
            }
        }
        checkWorkspaceExists() {
            return this.isTCReadyPromise.then((workSpaceExists)=>{
                if (workSpaceExists) return Promise.resolve(true);
                return Promise.resolve(false);
            }, ()=>Promise.resolve(false));
        }
        getIsGlobalExperienceWorkspace() {
            return this.isGlobalExperienceWorkspacePromise;
        }
        getOrgId() {
            return this.orgIdPromise;
        }
        preloadIsGlobalExperienceWorkspace(cloudId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(false);
            if (cloudId === undefined) return Promise.resolve(false);
            const maybeIsGlobalExperienceWorkspaceForCloudIdPromise = $b8d68ade6ab7f448$var$globalExperiencePromiseCache.get(cloudId);
            if (maybeIsGlobalExperienceWorkspaceForCloudIdPromise !== undefined) return maybeIsGlobalExperienceWorkspaceForCloudIdPromise;
            const isGlobalExperienceWorkspaceForCloudIdPromise = this.isGlobalExperienceWorkspaceForCloudId(cloudId);
            $b8d68ade6ab7f448$var$globalExperiencePromiseCache.set(cloudId, isGlobalExperienceWorkspaceForCloudIdPromise);
            return isGlobalExperienceWorkspaceForCloudIdPromise;
        }
        hasTCWorkspace(config) {
            if (config.cloudId) {
                const maybeShardedApiPath = this.getMaybeShardedApiPath(config.cloudId);
                return fetch(`${maybeShardedApiPath}/organization/containsAnyWorkspace?cloudId=${config.cloudId}`).then((res)=>{
                    return !res || res && res.ok;
                });
            } else return Promise.resolve(false);
        }
        async isGlobalExperienceWorkspaceForCloudId(cloudId) {
            const maybeShardedApiPath = this.getMaybeShardedApiPath(cloudId);
            try {
                const response = await fetch(`${maybeShardedApiPath}/workspace/existsWithWorkspaceType?cloudId=${cloudId}`, {
                    credentials: 'include'
                });
                if (response.ok) {
                    const workspaceType = await response.text();
                    return Promise.resolve(workspaceType === 'GLOBAL_EXPERIENCE');
                }
                return Promise.resolve(false);
            } catch (err) {
                return Promise.resolve(false);
            }
        }
        preloadOrgId(gatewayGraphqlUrl, cloudId, orgId) {
            if (!(0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls')) return Promise.resolve(null);
            if (cloudId === undefined) return Promise.resolve(null);
            if (orgId !== undefined) return Promise.resolve(orgId);
            const maybeOrgIdForCloudIdPromise = $b8d68ade6ab7f448$var$orgIdPromiseCache.get(cloudId);
            if (maybeOrgIdForCloudIdPromise !== undefined) return maybeOrgIdForCloudIdPromise;
            const orgIdForCloudIdPromise = (0, $a6hGK.getOrgIdForCloudIdFromAGG)(gatewayGraphqlUrl, cloudId);
            $b8d68ade6ab7f448$var$orgIdPromiseCache.set(cloudId, orgIdForCloudIdPromise);
            return orgIdForCloudIdPromise;
        }
        getMaybeShardedApiPath(cloudId) {
            const maybeShardedPath = (0, (0, parcelRequire("VSDnB")).fg)('enable_ptc_sharded_townsquare_calls') ? `/townsquare/s/${cloudId}` : '/watermelon';
            return `/gateway/api${maybeShardedPath}`;
        }
        filterReportingLinesUser(users = []) {
            return users.filter((user)=>user.identifierType === 'ATLASSIAN_ID');
        }
    }
    var $b8d68ade6ab7f448$export$2e2bcd8739ae039 = $b8d68ade6ab7f448$var$TeamCentralCardClient;
});
parcelRegister("a6hGK", function(module, exports) {
    $parcel$export(module.exports, "getOrgIdForCloudIdFromAGG", ()=>$9b806d5a2251e5d5$export$d38a536fd806c68f);
    var $hnIbm = parcelRequire("hnIbm");
    const $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY = `query OrgIdFromCloudId($cloudId: ID!) {
	tenantContexts(cloudIds: [$cloudId]) {
		orgId
	}
}`;
    const $9b806d5a2251e5d5$var$addHeaders = (headers)=>{
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $9b806d5a2251e5d5$export$d38a536fd806c68f(url, cloudId) {
        const query = {
            query: $9b806d5a2251e5d5$var$ORG_ID_FROM_CLOUD_ID_QUERY,
            variables: {
                cloudId: cloudId
            }
        };
        try {
            const { tenantContexts: tenantContexts } = await (0, $hnIbm.AGGQuery)(url, query, $9b806d5a2251e5d5$var$addHeaders);
            if (!tenantContexts || tenantContexts.length === 0 || tenantContexts[0] === null) return null;
            return tenantContexts[0].orgId;
        } catch (err) {
            return null;
        }
    }
});
parcelRegister("hnIbm", function(module, exports) {
    $parcel$export(module.exports, "directoryGraphqlQuery", ()=>$7fa677c30fceb004$export$a5b5995619d4fe36);
    $parcel$export(module.exports, "AGGQuery", ()=>$7fa677c30fceb004$export$a14afb5f82fe705);
    var $fcA5f = parcelRequire("fcA5f");
    var $f3Zb8 = parcelRequire("f3Zb8");
    const $7fa677c30fceb004$var$buildHeaders = ()=>{
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return headers;
    };
    const $7fa677c30fceb004$var$id = (headers)=>headers;
    async function $7fa677c30fceb004$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleDirectoryGraphQLErrors));
    }
    async function $7fa677c30fceb004$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id) {
        return $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $f3Zb8.handleAGGErrors));
    }
    async function $7fa677c30fceb004$var$graphQLQuery(serviceUrl, query, processHeaders = $7fa677c30fceb004$var$id, handleErrors) {
        const headers = processHeaders($7fa677c30fceb004$var$buildHeaders());
        const response = await fetch(new Request(serviceUrl, {
            method: 'POST',
            credentials: 'include',
            mode: 'cors',
            headers: headers,
            body: JSON.stringify(query)
        }));
        const traceIdFromHeaders = response?.headers?.get('atl-traceid');
        if (!response.ok) throw new (0, $fcA5f.HttpError)(response.status, response.statusText, traceIdFromHeaders);
        const json = await response.json();
        if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
        return json.data;
    }
});
parcelRegister("fjEAi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb2f761841b49fec$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $5Uw6l = parcelRequire("5Uw6l");
    class $fb2f761841b49fec$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        makeRequest(teamId, _orgId) {
            if (!this.options.gatewayGraphqlUrl) throw new Error('Trying to fetch via gateway with no specified config.gatewayGraphqlUrl');
            return (0, $5Uw6l.getTeamFromAGG)(this.options.gatewayGraphqlUrl, teamId, this.options.cloudId);
        }
        getProfile(teamId, orgId, analytics) {
            if (!teamId) return Promise.reject(new Error('teamId is missing'));
            const cache = this.getCachedProfile(teamId);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('triggered'));
                this.makeRequest(teamId, orgId).then((data)=>{
                    if (this.cache) this.setCachedProfile(teamId, data);
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        gateway: true
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.teamRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error),
                        gateway: true
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("5Uw6l", function(module, exports) {
    $parcel$export(module.exports, "getTeamFromAGG", ()=>$c02eddc07333bc73$export$26a8aad0c7182dd6);
    var $hnIbm = parcelRequire("hnIbm");
    const $c02eddc07333bc73$export$5816a09dbb711691 = (ari)=>{
        const slashPos = ari.indexOf('/');
        const id = ari.slice(slashPos + 1);
        return id;
    };
    const $c02eddc07333bc73$export$681597d03c8a0fd2 = (teamId)=>{
        return `ari:cloud:identity::team/${teamId}`;
    };
    const $c02eddc07333bc73$export$fce1abb40bf8db94 = (result)=>{
        const { team: team } = result;
        return {
            ...team,
            id: $c02eddc07333bc73$export$5816a09dbb711691(team.id),
            members: team.members?.nodes.map(({ member: member })=>({
                    id: member.accountId,
                    fullName: member.name,
                    avatarUrl: member.picture
                }))
        };
    };
    const $c02eddc07333bc73$var$TEAM_FRAGMENT = `
      id
      displayName
      description
      smallHeaderImageUrl
      largeHeaderImageUrl
      smallAvatarImageUrl
      largeAvatarImageUrl
      members {
        nodes {
          member {
            accountId
            name
            picture
          }
        }
      }
`;
    const $c02eddc07333bc73$export$4968f4e0119a5d9c = `query TeamCard($teamId: ID!, $siteId: String!) {
  Team: team {
    team: teamV2(id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
      ${$c02eddc07333bc73$var$TEAM_FRAGMENT}
    }
  }
}`;
    const $c02eddc07333bc73$export$695d743d1401e038 = ({ teamId: teamId, siteId: siteId })=>({
            query: $c02eddc07333bc73$export$4968f4e0119a5d9c,
            variables: {
                teamId: $c02eddc07333bc73$export$681597d03c8a0fd2(teamId),
                siteId: siteId || 'None'
            }
        });
    const $c02eddc07333bc73$export$1229c72526c01df2 = (headers)=>{
        headers.append('X-ExperimentalApi', 'teams-beta');
        headers.append('X-ExperimentalApi', 'team-members-beta');
        headers.append('atl-client-name', "platform-pkg");
        headers.append('atl-client-version', "0.0.0-use.local");
        return headers;
    };
    async function $c02eddc07333bc73$export$26a8aad0c7182dd6(url, teamId, siteId) {
        const query = $c02eddc07333bc73$export$695d743d1401e038({
            teamId: teamId,
            siteId: siteId
        });
        const { Team: Team } = await (0, $hnIbm.AGGQuery)(url, query, $c02eddc07333bc73$export$1229c72526c01df2);
        return $c02eddc07333bc73$export$fce1abb40bf8db94(Team);
    }
});
parcelRegister("dFLsP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eafd789fd4bdf3ff$export$2e2bcd8739ae039);
    var $ivXTE = parcelRequire("ivXTE");
    var $2qnn4 = parcelRequire("2qnn4");
    var $6TKEY = parcelRequire("6TKEY");
    var $cZg4V = parcelRequire("cZg4V");
    var $f3Zb8 = parcelRequire("f3Zb8");
    var $hnIbm = parcelRequire("hnIbm");
    const $eafd789fd4bdf3ff$export$b26b7f9bcf400835 = (response)=>{
        const data = {
            ...response.User
        };
        const localWeekdayIndex = new Date().getDay().toString();
        if (data.remoteWeekdayIndex && data.remoteWeekdayIndex !== localWeekdayIndex) data.remoteTimeString = `${data.remoteWeekdayString} ${data.remoteTimeString}`;
        return {
            isBot: data.isBot,
            isCurrentUser: data.isCurrentUser,
            status: data.status,
            statusModifiedDate: data.statusModifiedDate || undefined,
            avatarUrl: data.avatarUrl || undefined,
            email: data.email || undefined,
            fullName: data.fullName || undefined,
            location: data.location || undefined,
            meta: data.meta || undefined,
            nickname: data.nickname || undefined,
            companyName: data.companyName || undefined,
            timestring: data.remoteTimeString || undefined,
            accountType: data.accountType || undefined
        };
    };
    const $eafd789fd4bdf3ff$export$8230f28f7ae567ea = (userId)=>({
            query: `query user($userId: ID!) {
		user(accountId: $userId) {
			id
			name
			picture
			accountStatus
			__typename
			... on AtlassianAccountUser {
				email
				nickname
				zoneinfo
				extendedProfile {
					jobTitle
					organization
					location
					closedDate
					inactiveDate
				}
			}
			... on CustomerUser {
				email
				zoneinfo
			}
			... on AppUser {
      			appType
    		}
		}
	}`,
            variables: {
                userId: userId
            }
        });
    const $eafd789fd4bdf3ff$var$queryAGGUser = async (url, userId)=>{
        const query = $eafd789fd4bdf3ff$export$8230f28f7ae567ea(userId);
        const { user: user } = await (0, $hnIbm.AGGQuery)(url, query);
        return user;
    };
    class $eafd789fd4bdf3ff$export$2e2bcd8739ae039 extends (0, $cZg4V.default) {
        constructor(options){
            super(options);
            this.options = options;
        }
        async makeRequest(cloudId, userId) {
            const gatewayGraphqlUrl = this.options.gatewayGraphqlUrl || '/gateway/api/graphql';
            const urlWithOperationName = `${gatewayGraphqlUrl}?operationName=aggUserQuery`;
            const userQueryPromise = $eafd789fd4bdf3ff$var$queryAGGUser(urlWithOperationName, userId);
            const user = await userQueryPromise;
            let timestring;
            const localWeekdayIndex = new Date().getDay().toString();
            if (user.zoneinfo) {
                if ((0, $2qnn4.localTime)(user.zoneinfo, 'i') === localWeekdayIndex) timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'h:mmbbb') || undefined;
                else timestring = (0, $2qnn4.localTime)(user.zoneinfo, 'eee h:mmbbb') || undefined;
            }
            return {
                ...user,
                isBot: user.__typename === 'AppUser',
                isAgent: user.appType === 'agent',
                status: user.accountStatus,
                statusModifiedDate: user.extendedProfile?.closedDate || user.extendedProfile?.inactiveDate,
                avatarUrl: user.picture,
                email: user.email,
                fullName: user.name,
                location: user.extendedProfile?.location,
                meta: user.extendedProfile?.jobTitle,
                nickname: user.nickname,
                companyName: user.extendedProfile?.organization,
                timestring: timestring
            };
        }
        getProfile(cloudId, userId, analytics) {
            if (!userId) return Promise.reject(new Error('userId missing'));
            const cacheIdentifier = `${cloudId}/${userId}`;
            const cache = this.getCachedProfile(cacheIdentifier);
            if (cache) return Promise.resolve(cache);
            return new Promise((resolve, reject)=>{
                const startTime = (0, $6TKEY.getPageTime)();
                if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('triggered'));
                this.makeRequest(cloudId, userId).then((data)=>{
                    if (this.cache) this.setCachedProfile(cacheIdentifier, data);
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('succeeded', {
                        duration: (0, $6TKEY.getPageTime)() - startTime
                    }));
                    resolve(data);
                }).catch((error)=>{
                    if (analytics) analytics((0, $ivXTE.userRequestAnalytics)('failed', {
                        duration: (0, $6TKEY.getPageTime)() - startTime,
                        ...(0, $f3Zb8.getErrorAttributes)(error)
                    }));
                    reject(error);
                });
            });
        }
    }
});
parcelRegister("2qnn4", function(module, exports) {
    $parcel$export(module.exports, "localTime", ()=>$de778707e3f7ab0e$export$f0dfd716e7b023cd);
    parcelRequire("7UQ5i");
    var $9uIbX;
    const $de778707e3f7ab0e$export$f0dfd716e7b023cd = (timezone, format)=>{
        if (!timezone) return null;
        try {
            return (0, (0, parcelRequire("9uIbX")).default)(new Date(), timezone, format);
        } catch (error) {
            return null;
        }
    };
});
parcelRegister("7UQ5i", function(module, exports) {
    $parcel$export(module.exports, "formatInTimeZone", ()=>(parcelRequire("9uIbX")).default);
    var $9uIbX;
});
parcelRegister("9uIbX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6e9932008c468ee4$export$2e2bcd8739ae039);
    var $fwbX5;
    var $cmObS;
    var $2b4cP;
    function $6e9932008c468ee4$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("cmObS")).default)((0, (0, parcelRequire("2b4cP")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("fwbX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b4c31d9870379ac2$var$cloneObject;
    var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
    function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
        return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
    }
    module.exports = module.exports.default;
});
parcelRegister("cpl5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $90882d6ff669df4d$var$assign;
    function $90882d6ff669df4d$var$assign(target, dirtyObject) {
        if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
        dirtyObject = dirtyObject || {};
        for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
        return target;
    }
    module.exports = module.exports.default;
});
parcelRegister("cmObS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$900e78e49c474eed$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $920RE;
    var $2q3K8;
    var $900e78e49c474eed$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $900e78e49c474eed$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($900e78e49c474eed$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("2q3K8")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("920RE")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("aR9Qf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7e767cfeba790ebe$var$format;
    var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));
    var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));
    var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));
    var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));
    var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));
    var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));
    var $5qguX;
    var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
    var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
    var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        if (!locale.localize) throw new RangeError('locale must contain localize property');
        if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
        var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
        if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
        var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
        var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
        var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
        };
        var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
                return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
        }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
            if (substring === "''") return "'";
            var firstCharacter = substring[0];
            if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
            var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
            if (formatter) {
                if (!options.useAdditionalWeekYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedWeekYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                if (!options.useAdditionalDayOfYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedDayOfYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            return substring;
        }).join('');
        return result;
    }
    function $7e767cfeba790ebe$var$cleanEscapedString(input) {
        return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
    }
    module.exports = module.exports.default;
});
parcelRegister("ck8JK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8f8e2146dfa1d727$var$isValid;
    var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
        (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
        var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
        return !isNaN(date);
    }
    module.exports = module.exports.default;
});
parcelRegister("2pWQP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $1c2b912e6615b0b5$var$toDate;
    var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1c2b912e6615b0b5$var$toDate(argument) {
        (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument);
        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
        else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
                console.warn(new Error().stack);
            }
            return new Date(NaN);
        }
    }
    module.exports = module.exports.default;
});
parcelRegister("6eBfj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
    function $48a0f126c2293ab3$var$requiredArgs(required, args) {
        if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
    module.exports = module.exports.default;
});
parcelRegister("kvNR5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));
    var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));
    var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));
    var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));
    var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
    function $eeed6020e120f946$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $eeed6020e120f946$var$locale = {
        code: 'en-US',
        formatDistance: $eeed6020e120f946$var$_index.default,
        formatLong: $eeed6020e120f946$var$_index2.default,
        formatRelative: $eeed6020e120f946$var$_index3.default,
        localize: $eeed6020e120f946$var$_index4.default,
        match: $eeed6020e120f946$var$_index5.default,
        options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
        }
    };
    var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
    module.exports.default = $eeed6020e120f946$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("5u9TK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
    var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours'
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days'
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months'
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years'
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
        }
    };
    function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
        options = options || {};
        var result;
        if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
        else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
        else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
        if (options.addSuffix) {
            if (options.comparison > 0) return 'in ' + result;
            else return result + ' ago';
        }
        return result;
    }
    module.exports = module.exports.default;
});
parcelRegister("e7AgV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
    function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a47ddb0366100c31$var$dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
    };
    var $a47ddb0366100c31$var$timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
    };
    var $a47ddb0366100c31$var$dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
    };
    var $a47ddb0366100c31$var$formatLong = {
        date: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateFormats,
            defaultWidth: 'full'
        }),
        time: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$timeFormats,
            defaultWidth: 'full'
        }),
        dateTime: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateTimeFormats,
            defaultWidth: 'full'
        })
    };
    var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
    module.exports.default = $a47ddb0366100c31$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("4raqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
    function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
        return function() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("8U2eY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
    var $67b54aa1e07b4b42$var$formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
    };
    function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
        return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
    }
    module.exports = module.exports.default;
});
parcelRegister("b9d75", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
    function $81dab50370972ecd$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $81dab50370972ecd$var$eraValues = {
        narrow: [
            'B',
            'A'
        ],
        abbreviated: [
            'BC',
            'AD'
        ],
        wide: [
            'Before Christ',
            'Anno Domini'
        ]
    };
    var $81dab50370972ecd$var$quarterValues = {
        narrow: [
            '1',
            '2',
            '3',
            '4'
        ],
        abbreviated: [
            'Q1',
            'Q2',
            'Q3',
            'Q4'
        ],
        wide: [
            '1st quarter',
            '2nd quarter',
            '3rd quarter',
            '4th quarter'
        ]
    };
    var $81dab50370972ecd$var$monthValues = {
        narrow: [
            'J',
            'F',
            'M',
            'A',
            'M',
            'J',
            'J',
            'A',
            'S',
            'O',
            'N',
            'D'
        ],
        abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    };
    var $81dab50370972ecd$var$dayValues = {
        narrow: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S'
        ],
        short: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        abbreviated: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        wide: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ]
    };
    var $81dab50370972ecd$var$dayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        }
    };
    var $81dab50370972ecd$var$formattingDayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        }
    };
    function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;
        if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
        return number + 'th';
    }
    var $81dab50370972ecd$var$localize = {
        ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
        era: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$eraValues,
            defaultWidth: 'wide'
        }),
        quarter: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function(quarter) {
                return Number(quarter) - 1;
            }
        }),
        month: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$monthValues,
            defaultWidth: 'wide'
        }),
        day: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayValues,
            defaultWidth: 'wide'
        }),
        dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
        })
    };
    var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
    module.exports.default = $81dab50370972ecd$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("llBmH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
    function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
        return function(dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
                var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                var width = options.width ? String(options.width) : defaultWidth;
                valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
                var _defaultWidth = args.defaultWidth;
                var _width = options.width ? String(options.width) : args.defaultWidth;
                valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("hHwuU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));
    var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
    function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
    var $ce2fa922bf4a591b$var$matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var $ce2fa922bf4a591b$var$parseEraPatterns = {
        any: [
            /^b/i,
            /^(a|c)/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
        any: [
            /1/i,
            /2/i,
            /3/i,
            /4/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var $ce2fa922bf4a591b$var$parseMonthPatterns = {
        narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ],
        any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var $ce2fa922bf4a591b$var$parseDayPatterns = {
        narrow: [
            /^s/i,
            /^m/i,
            /^t/i,
            /^w/i,
            /^t/i,
            /^f/i,
            /^s/i
        ],
        any: [
            /^su/i,
            /^m/i,
            /^tu/i,
            /^w/i,
            /^th/i,
            /^f/i,
            /^sa/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
        }
    };
    var $ce2fa922bf4a591b$var$match = {
        ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
            matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
            parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
            valueCallback: function(value) {
                return parseInt(value, 10);
            }
        }),
        era: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
            defaultParseWidth: 'any'
        }),
        quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function(index) {
                return index + 1;
            }
        }),
        month: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
            defaultParseWidth: 'any'
        }),
        day: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
            defaultParseWidth: 'any'
        }),
        dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
            defaultParseWidth: 'any'
        })
    };
    var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
    module.exports.default = $ce2fa922bf4a591b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("1IY7t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
    function $141888fa04c95812$var$buildMatchPatternFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) return null;
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("liduU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
    function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
            var value;
            value = args.valueCallback ? args.valueCallback(key) : key;
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
        for(var key in object){
            if (object.hasOwnProperty(key) && predicate(object[key])) return key;
        }
        return undefined;
    }
    function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
        for(var key = 0; key < array.length; key++){
            if (predicate(array[key])) return key;
        }
        return undefined;
    }
    module.exports = module.exports.default;
});
parcelRegister("bQkcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;
    var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));
    var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
        (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
        var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
        return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("aSksP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
    function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
        var number = Number(dirtyNumber);
        if (isNaN(number)) return number;
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = module.exports.default;
});
parcelRegister("7f9OM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;
    var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
        (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
        var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
        var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
        return new Date(timestamp + amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("3ckvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));
    var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));
    var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));
    var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));
    var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2542672a600cd2b8$var$dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    };
    var $2542672a600cd2b8$var$formatters = {
        G: function(date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch(token){
                case 'G':
                case 'GG':
                case 'GGG':
                    return localize.era(era, {
                        width: 'abbreviated'
                    });
                case 'GGGGG':
                    return localize.era(era, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return localize.era(era, {
                        width: 'wide'
                    });
            }
        },
        y: function(date, token, localize) {
            if (token === 'yo') {
                var signedYear = date.getUTCFullYear();
                var year = signedYear > 0 ? signedYear : 1 - signedYear;
                return localize.ordinalNumber(year, {
                    unit: 'year'
                });
            }
            return $2542672a600cd2b8$var$_index.default.y(date, token);
        },
        Y: function(date, token, localize, options) {
            var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options);
            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
            if (token === 'YY') {
                var twoDigitYear = weekYear % 100;
                return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
            }
            if (token === 'Yo') return localize.ordinalNumber(weekYear, {
                unit: 'year'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
        },
        R: function(date, token) {
            var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date);
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
        },
        u: function(date, token) {
            var year = date.getUTCFullYear();
            return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
        },
        Q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'Q':
                    return String(quarter);
                case 'QQ':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'Qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'q':
                    return String(quarter);
                case 'qq':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        M: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'M':
                case 'MM':
                    return $2542672a600cd2b8$var$_index.default.M(date, token);
                case 'Mo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'MMM':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        L: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'L':
                    return String(month + 1);
                case 'LL':
                    return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
                case 'Lo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'LLL':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        w: function(date, token, localize, options) {
            var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
            if (token === 'wo') return localize.ordinalNumber(week, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
        },
        I: function(date, token, localize) {
            var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
            if (token === 'Io') return localize.ordinalNumber(isoWeek, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
        },
        d: function(date, token, localize) {
            if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
            });
            return $2542672a600cd2b8$var$_index.default.d(date, token);
        },
        D: function(date, token, localize) {
            var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
            if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
        },
        E: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch(token){
                case 'E':
                case 'EE':
                case 'EEE':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        e: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'e':
                    return String(localDayOfWeek);
                case 'ee':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
                case 'eo':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'eee':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        c: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'c':
                    return String(localDayOfWeek);
                case 'cc':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
                case 'co':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'ccc':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        i: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch(token){
                case 'i':
                    return String(isoDayOfWeek);
                case 'ii':
                    return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
                case 'io':
                    return localize.ordinalNumber(isoDayOfWeek, {
                        unit: 'day'
                    });
                case 'iii':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'iiiii':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'iiiiii':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'iiii':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        a: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'aaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'aaaaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        b: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
            else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
            else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'b':
                case 'bb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'bbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'bbbbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        B: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
            else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
            else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
            else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        h: function(date, token, localize) {
            if (token === 'ho') {
                var hours = date.getUTCHours() % 12;
                if (hours === 0) hours = 12;
                return localize.ordinalNumber(hours, {
                    unit: 'hour'
                });
            }
            return $2542672a600cd2b8$var$_index.default.h(date, token);
        },
        H: function(date, token, localize) {
            if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
            });
            return $2542672a600cd2b8$var$_index.default.H(date, token);
        },
        K: function(date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        k: function(date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        m: function(date, token, localize) {
            if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
            });
            return $2542672a600cd2b8$var$_index.default.m(date, token);
        },
        s: function(date, token, localize) {
            if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
            });
            return $2542672a600cd2b8$var$_index.default.s(date, token);
        },
        S: function(date, token) {
            return $2542672a600cd2b8$var$_index.default.S(date, token);
        },
        X: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'x':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'zzzz':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        t: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        },
        T: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        }
    };
    function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
    }
    function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
        }
        return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
    }
    function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
        var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
    }
    var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
    module.exports.default = $2542672a600cd2b8$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("kFGp1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $f0c88744bd108133$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $f0c88744bd108133$var$formatters = {
        y: function(date, token) {
            var signedYear = date.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
        },
        M: function(date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
        },
        d: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
        },
        a: function(date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return dayPeriodEnumValue.toUpperCase();
                case 'aaa':
                    return dayPeriodEnumValue;
                case 'aaaaa':
                    return dayPeriodEnumValue[0];
                case 'aaaa':
                default:
                    return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
        },
        h: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
        },
        H: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
        },
        m: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
        },
        s: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
        },
        S: function(date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
        }
    };
    var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
    module.exports.default = $f0c88744bd108133$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("bQ2eo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
    function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    module.exports = module.exports.default;
});
parcelRegister("3xdEO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;
    var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000;
    function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
        (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
        var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6Falt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;
    var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));
    var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000;
    function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
        (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
        var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
        var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime();
        return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6nDqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;
    var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4a53796a96b58804$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
        (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
        var weekStartsOn = 1;
        var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("hI2kM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;
    var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $ce485b424b643216$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
        (0, $ce485b424b643216$var$_index3.default)(1, arguments);
        var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("gUvh1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;
    var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
        (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
        var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("46m4m", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;
    var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));
    var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000;
    function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
        (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
        var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
        var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime();
        return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("clhRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;
    var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("cbqvD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;
    var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
        var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("3ihh3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;
    var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
        var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("awKAW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'P':
                return formatLong.date({
                    width: 'short'
                });
            case 'PP':
                return formatLong.date({
                    width: 'medium'
                });
            case 'PPP':
                return formatLong.date({
                    width: 'long'
                });
            case 'PPPP':
            default:
                return formatLong.date({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'p':
                return formatLong.time({
                    width: 'short'
                });
            case 'pp':
                return formatLong.time({
                    width: 'medium'
                });
            case 'ppp':
                return formatLong.time({
                    width: 'long'
                });
            case 'pppp':
            default:
                return formatLong.time({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];
        if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
        var dateTimeFormat;
        switch(datePattern){
            case 'P':
                dateTimeFormat = formatLong.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                dateTimeFormat = formatLong.dateTime({
                    width: 'full'
                });
                break;
        }
        return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
    }
    var $7aa109506ceedd4b$var$longFormatters = {
        p: $7aa109506ceedd4b$var$timeLongFormatter,
        P: $7aa109506ceedd4b$var$dateTimeLongFormatter
    };
    var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
    module.exports.default = $7aa109506ceedd4b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("jGQTC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
    function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
    }
    module.exports = module.exports.default;
});
parcelRegister("5qguX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
    module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
    module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
    var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
        'D',
        'DD'
    ];
    var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
        'YY',
        'YYYY'
    ];
    function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
        return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
        return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
        if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
});
parcelRegister("920RE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6934f899b8aefb37$export$2e2bcd8739ae039);
    var $927cR = parcelRequire("927cR");
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE = 60000;
    var $6934f899b8aefb37$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $6934f899b8aefb37$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $6934f899b8aefb37$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $927cR.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $927cR.default)('long', date, options);
            }
        }
    };
    function $6934f899b8aefb37$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $6JaJ1.default)(timeZone, originalDate, true) / $6934f899b8aefb37$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $6934f899b8aefb37$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $6934f899b8aefb37$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $6934f899b8aefb37$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $6934f899b8aefb37$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $6934f899b8aefb37$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $6934f899b8aefb37$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $6934f899b8aefb37$var$addLeadingZeros(minutes, 2);
    }
    var $6934f899b8aefb37$export$2e2bcd8739ae039 = $6934f899b8aefb37$var$formatters;
});
parcelRegister("927cR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6939e400b4f30595$export$2e2bcd8739ae039);
    function $6939e400b4f30595$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $6939e400b4f30595$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $6939e400b4f30595$var$partsTimeZone(dtf, date) : $6939e400b4f30595$var$hackyTimeZone(dtf, date);
    }
    function $6939e400b4f30595$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $6939e400b4f30595$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $6939e400b4f30595$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("6JaJ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e5f43d4fc19099f$export$2e2bcd8739ae039);
    var $gTcao = parcelRequire("gTcao");
    var $6Bk9v = parcelRequire("6Bk9v");
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR = 3600000;
    var $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE = 60000;
    var $4e5f43d4fc19099f$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $4e5f43d4fc19099f$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $4e5f43d4fc19099f$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $4e5f43d4fc19099f$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours)) return NaN;
            return -(hours * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR);
        }
        token = $4e5f43d4fc19099f$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$4e5f43d4fc19099f$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $4e5f43d4fc19099f$var$MILLISECONDS_IN_HOUR + minutes * $4e5f43d4fc19099f$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($4e5f43d4fc19099f$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $4e5f43d4fc19099f$var$toUtcDate(date);
            var offset = $4e5f43d4fc19099f$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $4e5f43d4fc19099f$var$toUtcDate(date) {
        return (0, $6Bk9v.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $4e5f43d4fc19099f$var$calcOffset(date, timezoneString) {
        var tokens = (0, $gTcao.default)(date, timezoneString);
        var asUTC = (0, $6Bk9v.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $4e5f43d4fc19099f$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $4e5f43d4fc19099f$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $4e5f43d4fc19099f$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $4e5f43d4fc19099f$var$validIANATimezoneCache = {};
    function $4e5f43d4fc19099f$var$isValidTimezoneIANAString(timeZoneString) {
        if ($4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $4e5f43d4fc19099f$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("gTcao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4bb38695b1c145f$export$2e2bcd8739ae039);
    function $c4bb38695b1c145f$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $c4bb38695b1c145f$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $c4bb38695b1c145f$var$partsOffset(dtf, date) : $c4bb38695b1c145f$var$hackyOffset(dtf, date);
    }
    var $c4bb38695b1c145f$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $c4bb38695b1c145f$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $c4bb38695b1c145f$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $c4bb38695b1c145f$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $c4bb38695b1c145f$var$dtfCache = {};
    function $c4bb38695b1c145f$var$getDateTimeFormat(timeZone) {
        if (!$c4bb38695b1c145f$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $c4bb38695b1c145f$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $c4bb38695b1c145f$var$dtfCache[timeZone];
    }
});
parcelRegister("6Bk9v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4ce5d4976aa71227$export$2e2bcd8739ae039);
    function $4ce5d4976aa71227$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("2q3K8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1c30e9c4205eee83$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $jxCgc = parcelRequire("jxCgc");
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR = 3600000;
    var $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE = 60000;
    var $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $1c30e9c4205eee83$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $jxCgc.default)
    };
    function $1c30e9c4205eee83$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $1c30e9c4205eee83$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $1c30e9c4205eee83$var$splitDateString(argument);
        var parseYearResult = $1c30e9c4205eee83$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $1c30e9c4205eee83$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $1c30e9c4205eee83$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $6JaJ1.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $1c30e9c4205eee83$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $1c30e9c4205eee83$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $1c30e9c4205eee83$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $1c30e9c4205eee83$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $1c30e9c4205eee83$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $1c30e9c4205eee83$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $1c30e9c4205eee83$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $1c30e9c4205eee83$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $1c30e9c4205eee83$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $1c30e9c4205eee83$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$1c30e9c4205eee83$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $1c30e9c4205eee83$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week);
        }
        token = $1c30e9c4205eee83$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$1c30e9c4205eee83$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $1c30e9c4205eee83$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $1c30e9c4205eee83$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $1c30e9c4205eee83$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE;
        }
        token = $1c30e9c4205eee83$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$1c30e9c4205eee83$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $1c30e9c4205eee83$var$MILLISECONDS_IN_HOUR + minutes * $1c30e9c4205eee83$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $1c30e9c4205eee83$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $1c30e9c4205eee83$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $1c30e9c4205eee83$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
            if (isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $1c30e9c4205eee83$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $1c30e9c4205eee83$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $1c30e9c4205eee83$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $1c30e9c4205eee83$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("jxCgc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e39ec715b89452b2$export$2e2bcd8739ae039);
    var $e39ec715b89452b2$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $e39ec715b89452b2$export$2e2bcd8739ae039 = $e39ec715b89452b2$var$tzPattern;
});
parcelRegister("2b4cP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$195fdf0d1f4870c0$export$2e2bcd8739ae039);
    var $6JaJ1 = parcelRequire("6JaJ1");
    var $2q3K8;
    function $195fdf0d1f4870c0$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("2q3K8")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $6JaJ1.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("9gV7o", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$f7de3dc4d7bc51ad$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $dC5iT;
    var $luBm6;
    var $8CUq3;
    var $8S93R;
    var $5OOAU;
    var $77Oft;
    var $fygPX;
    var $ivXTE = parcelRequire("ivXTE");
    var $8qsT1 = parcelRequire("8qsT1");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $aRdJp = parcelRequire("aRdJp");
    var $a3FJs = parcelRequire("a3FJs");
    var $h9eXl = parcelRequire("h9eXl");
    var $37c0Y = parcelRequire("37c0Y");
    var $dlHyi = parcelRequire("dlHyi");
    const $f7de3dc4d7bc51ad$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBlockStart: 'space.400',
        paddingInline: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$avatarStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        top: 'space.300',
        left: 'space.200'
    });
    const $f7de3dc4d7bc51ad$var$cardContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        position: 'relative'
    });
    const $f7de3dc4d7bc51ad$var$AgentProfileCard = ({ agent: agent, isLoading: isLoading, isCreatedByViewingUser: isCreatedByViewingUser, cloudId: cloudId, onChatClick: onChatClick, product: product = 'rovo', hasError: hasError, errorType: errorType, onConversationStartersClick: onConversationStartersClick, resourceClient: resourceClient, addFlag: addFlag })=>{
        const { onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onOpenChat: onOpenChatFullScreen, onConversationStarter: onConversationStarter, onViewFullProfile: onViewFullProfile } = (0, $37c0Y.useAgentUrlActions)({
            cloudId: cloudId || ''
        });
        const [isStarred, setIsStarred] = (0, $5uXOq.useState)(false);
        const [starCount, setStarCount] = (0, $5uXOq.useState)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const userDefinedConversationStarters = agent?.user_defined_conversation_starters?.map((starter)=>{
            return {
                message: starter,
                type: 'user-defined'
            };
        });
        (0, $5uXOq.useEffect)(()=>{
            setIsStarred(!!agent?.favourite);
            setStarCount(agent?.favourite_count);
        }, [
            agent?.favourite,
            agent?.favourite_count
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const handleSetFavourite = (0, $5uXOq.useCallback)(async ()=>{
            if (agent?.id) try {
                await resourceClient.setFavouriteAgent(agent.id, !isStarred, fireAnalytics);
                if (isStarred) setStarCount(starCount ? starCount - 1 : 0);
                else setStarCount((starCount || 0) + 1);
                setIsStarred(!isStarred);
            } catch (error) {}
        }, [
            agent?.id,
            fireAnalytics,
            isStarred,
            resourceClient,
            starCount
        ]);
        const handleOnDelete = (0, $5uXOq.useCallback)(async ()=>{
            if (agent) try {
                await resourceClient.deleteAgent(agent.id, fireAnalytics);
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedSuccessFlagDescription, {
                        agentName: agent.name
                    }),
                    type: 'success',
                    id: 'ptc-directory.agent-profile.delete-agent-success'
                });
            } catch (error) {
                addFlag?.({
                    title: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagTitle),
                    description: formatMessage((0, $dlHyi.messages).agentDeletedErrorFlagDescription),
                    type: 'error',
                    id: 'ptc-directory.agent-profile.delete-agent-error'
                });
            }
        }, [
            addFlag,
            agent,
            fireAnalytics,
            formatMessage,
            resourceClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isLoading && agent) fireAnalytics((0, $ivXTE.profileCardRendered)('agent', 'content'));
        }, [
            agent,
            fireAnalytics,
            isLoading
        ]);
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
            profileType: "agent",
            fireAnalytics: fireAnalytics
        }));
        if (hasError || !agent) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            errorType: errorType,
            fireAnalytics: fireAnalytics
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$cardContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5OOAU")).AgentBanner), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            height: 96,
            agentIdentityAccountId: agent.identity_account_id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $f7de3dc4d7bc51ad$var$avatarStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8S93R")).AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.external_config_reference ?? agent.named_id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xlarge",
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY',
            forgeAgentIconUrl: agent.icon
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $f7de3dc4d7bc51ad$var$styles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileInfo), {
            agentName: agent.name,
            isStarred: isStarred,
            onStarToggle: handleSetFavourite,
            isHidden: agent.visibility === 'PRIVATE',
            creatorRender: agent.creatorInfo?.type && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77Oft")).AgentProfileCreator), {
                creator: {
                    type: agent.creatorInfo?.type,
                    name: agent.creatorInfo?.name || '',
                    profileLink: agent.creatorInfo?.profileLink || ''
                },
                isLoading: false,
                onCreatorLinkClick: ()=>{}
            }),
            starCountRender: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fygPX")).AgentStarCount), {
                starCount: starCount,
                isLoading: false
            }),
            agentDescription: agent.description
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $h9eXl.ConversationStarters), {
            isAgentDefault: agent.is_default,
            userDefinedConversationStarters: userDefinedConversationStarters,
            onConversationStarterClick: (conversationStarter)=>{
                onConversationStartersClick ? onConversationStartersClick(conversationStarter) : onConversationStarter({
                    agentId: agent.id,
                    prompt: conversationStarter.message
                });
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aRdJp.AgentActions), {
            agent: agent,
            isAgentCreatedByCurrentUser: isCreatedByViewingUser,
            onEditAgent: ()=>onEditAgent(agent.id),
            onCopyAgent: ()=>onCopyAgent(agent.id),
            onDuplicateAgent: ()=>onDuplicateAgent(agent.id),
            onDeleteAgent: handleOnDelete,
            onChatClick: ()=>onChatClick ? onChatClick() : onOpenChatFullScreen(agent.id, agent.name),
            resourceClient: resourceClient,
            onViewFullProfileClick: ()=>onViewFullProfile(agent.id)
        })));
    };
    var $f7de3dc4d7bc51ad$export$2e2bcd8739ae039 = $f7de3dc4d7bc51ad$var$AgentProfileCard;
});
parcelRegister("77Oft", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCreator", ()=>$180d99d4c1dac440$export$f35b2eeaa7e3db15);
    $parcel$export(module.exports, "AgentProfileInfo", ()=>$180d99d4c1dac440$export$e02348ba0b01a210);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l1N8i;
    var $2pMF0;
    var $hqZzc;
    var $dC5iT;
    var $f5TWP;
    var $luBm6;
    var $8CUq3;
    var $1DVhQ;
    var $3bDjY;
    var $f18hZ;
    var $kDYSZ;
    var $cCr29;
    const $180d99d4c1dac440$var$clickableItemStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    });
    const $180d99d4c1dac440$var$nameStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        justifyContent: 'space-between',
        alignItems: 'flex-start'
    });
    const $180d99d4c1dac440$var$descriptionStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.0',
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$export$f35b2eeaa7e3db15 = ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100,
                    borderRadius: 3
                })
            });
            if (!creator) return null;
            if (creator.type === 'SYSTEM') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2pMF0")).AtlassianIcon), {
                    size: "small",
                    appearance: "brand"
                }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, "Atlassian"))
            });
            if (creator.type === 'CUSTOMER') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, (0, parcelRequire("cCr29")).messages).agentDeactivated))
            });
            if (creator.type === 'THIRD_PARTY') return formatMessage((0, (0, parcelRequire("cCr29")).messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        const creatorRender = getCreatorRender();
        return creatorRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$clickableItemStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqZzc")).RovoIcon), {
            appearance: "brand",
            size: "small"
        }), creatorRender) : null;
    };
    const $180d99d4c1dac440$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.100'
    });
    const $180d99d4c1dac440$var$tooltipWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'inline-flex',
        marginInline: 'space.100',
        position: 'relative',
        bottom: 'space.025'
    });
    const $180d99d4c1dac440$var$headingWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative'
    });
    const $180d99d4c1dac440$export$e02348ba0b01a210 = ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.100",
            xcss: $180d99d4c1dac440$var$wrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $180d99d4c1dac440$var$nameStyles,
            space: "space.100",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$headingWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1N8i")).default), {
            as: "span",
            size: "xlarge"
        }, agentName), isHidden && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$tooltipWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenTooltip),
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f18hZ")).HiddenIcon), {
            label: formatMessage((0, (0, parcelRequire("cCr29")).messages).hiddenIcon)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kDYSZ")).StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle
        })), creatorRender, !!agentDescription && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $180d99d4c1dac440$var$descriptionStyles,
            as: "p"
        }, agentDescription), starCountRender);
    };
});
parcelRegister("2pMF0", function(module, exports) {
    $parcel$export(module.exports, "AtlassianIcon", ()=>$f254a283aa81cf60$export$8a485e2e7ed91e8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $hxoiH;
    var $lEsIP;
    var $6PPEt;
    var $iVs6J;
    const $f254a283aa81cf60$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
        let colors = {
            iconColor: iconColor
        };
        if (appearance) colors = (0, (0, parcelRequire("6PPEt")).getColorsFromAppearance)(appearance, colorMode);
        return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
    };
    const $f254a283aa81cf60$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).size, iconColor: iconColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).iconColor, textColor: textColor = (0, (0, parcelRequire("lEsIP")).defaultLogoParams).textColor, testId: testId })=>{
        const { colorMode: colorMode } = (0, (0, parcelRequire("hxoiH")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iVs6J")).default), {
            appearance: appearance,
            label: label,
            svg: $f254a283aa81cf60$var$svg({
                appearance: appearance,
                iconColor: iconColor
            }, colorMode),
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            testId: testId
        });
    };
});
parcelRegister("f18hZ", function(module, exports) {
    $parcel$export(module.exports, "HiddenIcon", ()=>$33a2f5af6a5e0c92$export$bce21421c351deb1);
    var $5uXOq = parcelRequire("5uXOq");
    var $6C81H;
    const $33a2f5af6a5e0c92$export$bce21421c351deb1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6C81H"))))), props);
});
parcelRegister("6C81H", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $013e232b862e20a6$var$_react = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $013e232b862e20a6$var$_UNSAFE_baseNew = $013e232b862e20a6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $013e232b862e20a6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $013e232b862e20a6$var$EyeOpenStrikethroughIcon = (props)=>$013e232b862e20a6$var$_react.default.createElement($013e232b862e20a6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1 1 2.919 2.919M15 15l-2.92-2.92M3.92 3.92C2.524 4.792 1.436 6.096.871 7.638a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25c1.493 0 2.898-.43 4.08-1.17M3.92 3.92l2.49 2.49m5.672 5.672L9.59 9.59m0 0a2.25 2.25 0 0 1-3.182-3.182M9.59 9.59 6.409 6.409m.005-3.495A7.7 7.7 0 0 1 8 2.75c3.255 0 6.086 2.039 7.129 4.888.085.234.085.49 0 .724a7.2 7.2 0 0 1-1.187 2.08"/>`
        }, props));
    $013e232b862e20a6$var$EyeOpenStrikethroughIcon.displayName = 'EyeOpenStrikethroughIcon';
    var $013e232b862e20a6$var$_default = module.exports.default = $013e232b862e20a6$var$EyeOpenStrikethroughIcon;
});
parcelRegister("kDYSZ", function(module, exports) {
    $parcel$export(module.exports, "StarIconButton", ()=>$ca4e80d09e432419$export$703abb8bd2abdfa5);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $7piTm;
    var $bH1hf;
    var $5ILhZ;
    var $8CUq3;
    var $6cbg1;
    const $ca4e80d09e432419$var$pressableStarIconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        background: 'transparent',
        padding: 'space.0',
        height: '32px',
        width: '32px'
    });
    const $ca4e80d09e432419$var$hiddenStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        opacity: 0
    });
    const $ca4e80d09e432419$export$703abb8bd2abdfa5 = ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: [
                $ca4e80d09e432419$var$pressableStarIconStyles,
                !visible && $ca4e80d09e432419$var$hiddenStyles
            ],
            onClick: handleToggle,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false)
        }, isStarred || isHovered ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bH1hf"))))), {
            size: "medium",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).removeFromFavouritesLabel),
            primaryColor: "var(--ds-background-accent-yellow-subtler-pressed, #E2B203)"
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7piTm"))))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, (0, parcelRequire("6cbg1")).default).clickToFavouriteLabel),
            color: 'var(--ds-text-accent-gray)'
        }));
    };
});
parcelRegister("7piTm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $564985c3728d4aa2$var$_react = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $564985c3728d4aa2$var$_starUnstarred = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("dAf5R")));
    var $564985c3728d4aa2$var$_star = $564985c3728d4aa2$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $564985c3728d4aa2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $564985c3728d4aa2$var$StarUnstarredIcon = (props)=>$564985c3728d4aa2$var$_react.default.createElement($564985c3728d4aa2$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $564985c3728d4aa2$var$_star.default
        }, props));
    $564985c3728d4aa2$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $564985c3728d4aa2$var$_default = module.exports.default = $564985c3728d4aa2$var$StarUnstarredIcon;
});
parcelRegister("6cbg1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3eaaeba7b25cecb8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3eaaeba7b25cecb8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeFromFavouritesLabel: {
            id: 'rovo-chat.browse-agents.remove-from-favourites-label',
            defaultMessage: 'Remove from favourites',
            description: 'Remove from favourites label'
        },
        clickToFavouriteLabel: {
            id: 'rovo-chat.browse-agents.click-to-favourite-label',
            defaultMessage: 'Not favourited, click to favourite',
            description: 'Click to favourite agent label'
        }
    });
});
parcelRegister("cCr29", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$34e6f75bfc23da7b$export$defe85febe8b728c);
    var $7VHMR;
    const $34e6f75bfc23da7b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentCreatedBy: {
            id: 'ai-mate.agent-profile-info.created-by',
            defaultMessage: 'Rovo Agent by {creatorNameWithLink}',
            description: 'Message to show who created this Rovo agent'
        },
        agentDeactivated: {
            id: 'ai-mate.agent-profile-info.deactivated',
            defaultMessage: '(deactivated)',
            description: 'Message to show that this agent is deactivated'
        },
        starredCount: {
            id: 'ai-mate.agent-profile-info.starred-count',
            defaultMessage: '{count} starred',
            description: 'Message to show how many times this agent has been starred by users'
        },
        hiddenIcon: {
            id: 'ai-mate.agent-profile-info.hidden-icon',
            defaultMessage: 'Hidden',
            description: 'Icon to show that this agent is hidden'
        },
        hiddenTooltip: {
            id: 'ai-mate.agent-profile-info.hidden-tooltip',
            defaultMessage: "Agent won't show in search results",
            description: 'Tooltip to explain what strikethough eye icon means'
        },
        starAgentTooltip: {
            id: 'ai-mate.agent-profile-info.star-agent-tooltip',
            defaultMessage: 'Star Agent',
            description: 'Tooltip to explain what star icon does'
        }
    });
});
parcelRegister("fygPX", function(module, exports) {
    $parcel$export(module.exports, "AgentStarCount", ()=>$82bf86c773cd27a9$export$65f8fe094f79ae2);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $l8fTj;
    var $dC5iT;
    var $8CUq3;
    var $1DVhQ;
    var $3aPFe;
    var $6cFwt;
    const $82bf86c773cd27a9$var$countStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050',
        paddingInlineStart: 'space.025'
    });
    const $82bf86c773cd27a9$export$65f8fe094f79ae2 = ({ starCount: starCount, isLoading: isLoading })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if ((starCount === null || starCount === undefined) && !isLoading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82bf86c773cd27a9$var$countStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("l8fTj"))))), {
            LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
            color: "currentColor",
            label: "",
            LEGACY_size: "small"
        }), isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1DVhQ")).default), {
            testId: "agent-profile-info-star-count-skeleton",
            isShimmering: true,
            height: 16,
            width: 75,
            borderRadius: 3
        }) : formatMessage((0, (0, parcelRequire("3aPFe")).messages).starredCount, {
            starCount: (0, (0, parcelRequire("6cFwt")).formatNumber)(starCount ?? 0)
        }));
    };
});
parcelRegister("l8fTj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f626abf9a5007502$var$_react = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f626abf9a5007502$var$_starUnstarred = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("1Cvrw")));
    var $f626abf9a5007502$var$_star = $f626abf9a5007502$var$_interopRequireDefault((parcelRequire("5oTeF")));
    function $f626abf9a5007502$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f626abf9a5007502$var$StarUnstarredIcon = (props)=>$f626abf9a5007502$var$_react.default.createElement($f626abf9a5007502$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $f626abf9a5007502$var$_star.default
        }, props));
    $f626abf9a5007502$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $f626abf9a5007502$var$_default = module.exports.default = $f626abf9a5007502$var$StarUnstarredIcon;
});
parcelRegister("3aPFe", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$056b41d8fa6dcf86$export$defe85febe8b728c);
    var $7VHMR;
    const $056b41d8fa6dcf86$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starredCount: {
            id: 'ai-mate.agent-profile-info.starred-count',
            defaultMessage: '{starCount} {starCount, plural, one {user} other {users}}',
            description: 'Text showing the number of times an agent has been favourited or starred'
        }
    });
});
parcelRegister("6cFwt", function(module, exports) {
    $parcel$export(module.exports, "formatNumber", ()=>$60c3ed960e6d0ab5$export$f5dd818bff069720);
    const $60c3ed960e6d0ab5$export$f5dd818bff069720 = (inputNumber)=>{
        if (inputNumber >= 1e9) return (inputNumber / 1e9).toFixed(1) + 'B';
        else if (inputNumber >= 1e6) return (inputNumber / 1e6).toFixed(1) + 'M';
        else if (inputNumber >= 1e3) return (inputNumber / 1e3).toFixed(1) + 'k';
        else return inputNumber.toString();
    };
});
parcelRegister("8qsT1", function(module, exports) {
    $parcel$export(module.exports, "LoadingState", ()=>$599d4a7a6a9f8f79$export$62aa48085237e36f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $599d4a7a6a9f8f79$export$62aa48085237e36f = ({ fireAnalytics: fireAnalytics, profileType: profileType })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (fireAnalytics) fireAnalytics((0, $ivXTE.profileCardRendered)(profileType, 'spinner'));
        }, [
            fireAnalytics,
            profileType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
});
parcelRegister("jnj6z", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$a03faa2abdc74ae6$export$6aa22a823032b784);
    $parcel$export(module.exports, "ProfileImage", ()=>$a03faa2abdc74ae6$export$a7a74ab5cffd1455);
    $parcel$export(module.exports, "ActionsFlexSpacer", ()=>$a03faa2abdc74ae6$export$d395c8d16f1e359d);
    $parcel$export(module.exports, "KudosBlobAnimation", ()=>$a03faa2abdc74ae6$export$4a8a956251d4bf6f);
    $parcel$export(module.exports, "AnimationWrapper", ()=>$a03faa2abdc74ae6$export$58517bb1b373a54c);
    $parcel$export(module.exports, "AnimatedKudosButton", ()=>$a03faa2abdc74ae6$export$6196a3f52a6944fe);
    $parcel$export(module.exports, "ActionButtonGroup", ()=>$a03faa2abdc74ae6$export$73d695ae27330056);
    $parcel$export(module.exports, "OverflowActionButtonsWrapper", ()=>$a03faa2abdc74ae6$export$ff778e5b796745a6);
    $parcel$export(module.exports, "CardContent", ()=>$a03faa2abdc74ae6$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "DetailsGroup", ()=>$a03faa2abdc74ae6$export$35cf684daac137ac);
    $parcel$export(module.exports, "DisabledInfo", ()=>$a03faa2abdc74ae6$export$2062e7265a95a823);
    $parcel$export(module.exports, "FullNameLabel", ()=>$a03faa2abdc74ae6$export$1270e9c1fc39142b);
    $parcel$export(module.exports, "LozengeWrapper", ()=>$a03faa2abdc74ae6$export$75180efdd3f4d9c2);
    $parcel$export(module.exports, "CustomLozengeContainer", ()=>$a03faa2abdc74ae6$export$6ebf103500ba5a45);
    $parcel$export(module.exports, "JobTitleLabel", ()=>$a03faa2abdc74ae6$export$d6c0e5f211c8d617);
    $parcel$export(module.exports, "AppTitleLabel", ()=>$a03faa2abdc74ae6$export$4865ffa72a4d5f9);
    $parcel$export(module.exports, "SpinnerContainer", ()=>$a03faa2abdc74ae6$export$a5e06607a5ac6158);
    $parcel$export(module.exports, "CardContainer", ()=>$a03faa2abdc74ae6$export$8a23e74e5cf3ca41);
    $parcel$export(module.exports, "DetailsLabel", ()=>$a03faa2abdc74ae6$export$138a08882ebf7289);
    $parcel$export(module.exports, "DetailsLabelIcon", ()=>$a03faa2abdc74ae6$export$79d7d9b2f6a70c70);
    $parcel$export(module.exports, "DetailsLabelText", ()=>$a03faa2abdc74ae6$export$b0ec2c767a0e0eab);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k5uoT;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $a03faa2abdc74ae6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a03faa2abdc74ae6$var$getFullNameMargin = (props)=>props.noMeta ? `${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-150, 12px)"} 0` : `${"var(--ds-space-150, 12px)"} 0 0 0`;
    const $a03faa2abdc74ae6$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo20"
    })("background-color:", (0, $huHkE.bgColor), ";border-radius:var(--ds-border-radius, 3px);width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 45, "px;");
    const $a03faa2abdc74ae6$export$a7a74ab5cffd1455 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo19"
    })({
        name: "eukccz",
        styles: "position:absolute;top:var(--ds-space-300, 24px);left:var(--ds-space-300, 24px)"
    });
    const $a03faa2abdc74ae6$export$d395c8d16f1e359d = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo18"
    })({
        name: "18pny36",
        styles: "flex:1 0 auto"
    });
    const $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation = (0, (0, parcelRequire("f8Sb3")).keyframes)`
  0%   { transform: translate(-80px, -50px); }
  100% { transform: translate(90px, -70px); }
`;
    const $a03faa2abdc74ae6$export$b08abf2f97b92ea5 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo17"
    })("display:none;height:150px;width:150px;z-index:-1;position:absolute;top:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 4 / (0, (0, parcelRequire("k5uoT")).fontSize)(), "em;animation-name:", $a03faa2abdc74ae6$var$kudosButtonAnimationTransformation, ";animation-iteration-count:1;animation-duration:3s;background-image:radial-gradient(\n\t\tcircle,\n\t\tvar(--ds-background-information-pressed, #85B8FF) 0%,\n\t\tvar(--ds-background-discovery-pressed, #B8ACF6) 25%,\n\t\ttransparent 50%\n\t);overflow:hidden;");
    const $a03faa2abdc74ae6$export$4a8a956251d4bf6f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($a03faa2abdc74ae6$export$b08abf2f97b92ea5, {
            className: "kudos-blob-animation",
            ...props
        });
    const $a03faa2abdc74ae6$export$58517bb1b373a54c = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo16"
    })("clip-path:inset(0px 0px 0px 0px round ", (0, (0, parcelRequire("k5uoT")).borderRadius)(), "px);position:absolute;top:0;left:0;bottom:0;right:0;");
    const $a03faa2abdc74ae6$export$6196a3f52a6944fe = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo15"
    })({
        name: "18xp5qc",
        styles: "margin-left:var(--ds-space-100, 8px);&:focus-within .kudos-blob-animation,&:focus .kudos-blob-animation,&:hover .kudos-blob-animation{display:block;}"
    });
    const $a03faa2abdc74ae6$export$73d695ae27330056 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo14"
    })("user-select:none;margin:var(--ds-space-200, 16px) 0 0 0;text-align:right;display:flex;justify-content:flex-end;button,a{position:relative;}button,a,span{margin-left:var(--ds-space-100, 8px);&:first-child{margin-left:var(--ds-space-0, 0px);}}a,button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$ff778e5b796745a6 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo13"
    })("display:inline-block;width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);margin-left:var(--ds-space-100, 8px);button{&:focus{outline-color:", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$215b7063051591f1)})`, ";outline-offset:var(--ds-border-width, 2px);outline-style:solid;outline-width:var(--ds-border-width, 2px);}}");
    const $a03faa2abdc74ae6$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo12"
    })("display:flex;flex-direction:column;min-height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 17, "px;");
    const $a03faa2abdc74ae6$export$35cf684daac137ac = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo11"
    })("display:flex;flex-direction:column;margin-left:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 14.5, "px;width:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 24.5, "px;");
    const $a03faa2abdc74ae6$export$2062e7265a95a823 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo10"
    })("font-size:", (0, (0, parcelRequire("k5uoT")).fontSizeSmall)(), "px;color:", (0, $huHkE.labelTextColor), ";margin:var(--ds-space-150, 12px) 0 0 0;line-height:16px;");
    const $a03faa2abdc74ae6$export$1270e9c1fc39142b = (0, $bWGt6.default)("h2", {
        target: "e1ebb2vo9"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:18px;font-weight:400;letter-spacing:normal;color:", (props)=>props.isDisabledAccount ? (0, $huHkE.headerTextColorInactive) : (0, $huHkE.headerTextColor), ";margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";line-height:", 24 / 18, "em;:first-child{margin:", (props)=>$a03faa2abdc74ae6$var$getFullNameMargin(props), ";}");
    const $a03faa2abdc74ae6$export$75180efdd3f4d9c2 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo8"
    })({
        name: "m760b1",
        styles: "margin-top:var(--ds-space-200, 16px);text-transform:uppercase;display:block"
    });
    const $a03faa2abdc74ae6$export$6ebf103500ba5a45 = (0, $bWGt6.default)($a03faa2abdc74ae6$export$75180efdd3f4d9c2, {
        target: "e1ebb2vo7"
    })({
        name: "15oqcei",
        styles: "display:flex;flex-direction:row;flex-wrap:wrap;justify-content:flex-start;margin-top:var(--ds-space-150, 12px);>*{margin-top:var(--ds-space-050, 4px);&:not(:last-child){margin-right:var(--ds-space-050, 4px);}}"
    });
    const $a03faa2abdc74ae6$export$d6c0e5f211c8d617 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo6"
    })("overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:14px;color:", (0, $huHkE.headerTextColor), ";margin:0 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$4865ffa72a4d5f9 = (0, $bWGt6.default)("span", {
        target: "e1ebb2vo5"
    })("background:", (0, $huHkE.appLabelBgColor), ";color:", (0, $huHkE.appLabelTextColor), ";border-radius:", (0, (0, parcelRequire("k5uoT")).borderRadius)(), ";padding:0 var(--ds-space-075, 6px);width:fit-content;font-weight:bold;text-transform:uppercase;font-size:12px;margin:var(--ds-space-050, 4px) 0 var(--ds-space-150, 12px) 0;line-height:", 24 / 14, "em;");
    const $a03faa2abdc74ae6$export$a5e06607a5ac6158 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo4"
    })("align-items:center;display:flex;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;justify-content:center;position:relative;");
    const $a03faa2abdc74ae6$export$8a23e74e5cf3ca41 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo3"
    })("position:relative;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-image:linear-gradient(\n\t\tto bottom,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), "\n\t\t\t0%,\n\t\t", (props)=>props.isDisabledUser ? (0, $huHkE.headerBgColorDisabledUser) : (0, $huHkE.headerBgColor), " 100%\n\t);background-repeat:no-repeat;background-size:100% ", (0, (0, parcelRequire("k5uoT")).gridSize)() * 12, "px;box-sizing:content-box;padding:var(--ds-space-300, 24px);box-shadow:", (props)=>props.withoutElevation ? '' : `${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${0, $829f609a65d26a98$export$7d3359664e8bb0e5}, 0 0 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}`, ";border-radius:", (props)=>props.withoutElevation ? '' : `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`, ";overflow:hidden;");
    const $a03faa2abdc74ae6$export$138a08882ebf7289 = (0, $bWGt6.default)("div", {
        target: "e1ebb2vo2"
    })("display:flex;align-items:center;line-height:24px;font-size:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 1.5, "px;margin:var(--ds-space-200, 16px) 0 0 0;white-space:nowrap;&+&{margin-top:var(--ds-space-025, 2px);}");
    const $a03faa2abdc74ae6$export$79d7d9b2f6a70c70 = (0, $bWGt6.default)("dt", {
        target: "e1ebb2vo1"
    })("display:flex;flex-shrink:0;color:", (0, $huHkE.labelIconColor), ";width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);padding:var(--ds-space-050, 4px);vertical-align:top;svg{width:100%;height:100%;}");
    const $a03faa2abdc74ae6$export$b0ec2c767a0e0eab = (0, $bWGt6.default)("dd", {
        target: "e1ebb2vo0"
    })("overflow:hidden;text-overflow:ellipsis;color:", (0, $huHkE.labelTextColor), ";padding-left:var(--ds-space-050, 4px);margin-inline-start:0;margin-top:0;");
});
parcelRegister("huHkE", function(module, exports) {
    $parcel$export(module.exports, "bgColor", ()=>$61d9a2704bf54ca1$export$7dcbec377a25efc6);
    $parcel$export(module.exports, "headerBgColor", ()=>$61d9a2704bf54ca1$export$d3ec0459d8f4bbed);
    $parcel$export(module.exports, "teamHeaderBgColor", ()=>$61d9a2704bf54ca1$export$afc7ad7e78cf1c79);
    $parcel$export(module.exports, "headerBgColorDisabledUser", ()=>$61d9a2704bf54ca1$export$ef73fded6fab455c);
    $parcel$export(module.exports, "headerTextColor", ()=>$61d9a2704bf54ca1$export$5c2df128da90e8de);
    $parcel$export(module.exports, "headerTextColorInactive", ()=>$61d9a2704bf54ca1$export$a882617dcf7f98a6);
    $parcel$export(module.exports, "appLabelBgColor", ()=>$61d9a2704bf54ca1$export$6f79b778f6280d31);
    $parcel$export(module.exports, "appLabelTextColor", ()=>$61d9a2704bf54ca1$export$3db47a978b9599f9);
    $parcel$export(module.exports, "labelTextColor", ()=>$61d9a2704bf54ca1$export$dd73341f2a5541fa);
    $parcel$export(module.exports, "labelIconColor", ()=>$61d9a2704bf54ca1$export$5a20f73e634c37e3);
    $parcel$export(module.exports, "errorIconColor", ()=>$61d9a2704bf54ca1$export$85e73a744c5d1042);
    $parcel$export(module.exports, "errorTitleColor", ()=>$61d9a2704bf54ca1$export$be3c814f7ed506ed);
    $parcel$export(module.exports, "errorTextColor", ()=>$61d9a2704bf54ca1$export$ddf766d3bfcf965c);
    const $61d9a2704bf54ca1$export$7dcbec377a25efc6 = `var(--ds-surface-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$d3ec0459d8f4bbed = `var(--ds-background-brand-bold, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`;
    const $61d9a2704bf54ca1$export$afc7ad7e78cf1c79 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$8754fc7e6d8b3000)})`;
    const $61d9a2704bf54ca1$export$ef73fded6fab455c = `var(--ds-background-disabled, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
    const $61d9a2704bf54ca1$export$5c2df128da90e8de = `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`;
    const $61d9a2704bf54ca1$export$a882617dcf7f98a6 = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$6f79b778f6280d31 = `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`;
    const $61d9a2704bf54ca1$export$3db47a978b9599f9 = `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`;
    const $61d9a2704bf54ca1$export$dd73341f2a5541fa = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$5a20f73e634c37e3 = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$c2e91cbeada39b8b)})`;
    const $61d9a2704bf54ca1$export$85e73a744c5d1042 = `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
    const $61d9a2704bf54ca1$export$be3c814f7ed506ed = `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`;
    const $61d9a2704bf54ca1$export$ddf766d3bfcf965c = `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$7c87d337fb91a97d)})`;
});
parcelRegister("geGTf", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>(parcelRequire("gMO5Q")).ErrorBoundary);
    $parcel$export(module.exports, "ErrorIllustration", ()=>(parcelRequire("5HjZK")).ErrorIllustration);
    $parcel$export(module.exports, "ErrorMessage", ()=>(parcelRequire("cI0Td")).default);
    var $gMO5Q = parcelRequire("gMO5Q");
    var $5HjZK = parcelRequire("5HjZK");
    var $cI0Td = parcelRequire("cI0Td");
});
parcelRegister("gMO5Q", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundary", ()=>$bd7ac2918bb58c89$export$e926676385687eaf);
    var $5uXOq = parcelRequire("5uXOq");
    class $bd7ac2918bb58c89$export$e926676385687eaf extends (0, ($parcel$interopDefault($5uXOq))).Component {
        componentDidCatch() {
            this.props.onError();
        }
        render() {
            return this.props.children;
        }
    }
    var $bd7ac2918bb58c89$export$2e2bcd8739ae039 = $bd7ac2918bb58c89$export$e926676385687eaf;
});
parcelRegister("5HjZK", function(module, exports) {
    $parcel$export(module.exports, "ErrorIllustration", ()=>$dc9c80930a9669a0$export$e0319f52fc2380b1);
    var $5uXOq = parcelRequire("5uXOq");
    const $dc9c80930a9669a0$export$e0319f52fc2380b1 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "42",
            height: "53",
            viewBox: "0 0 164 212",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "var(--ds-surface-overlay, white)",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M95.4299 74.1603L161.87 189.24C167.71 199.36 160.41 212 148.73 212H15.8499C4.16994 212 -3.13006 199.35 2.70994 189.24L69.1499 74.1603C74.9899 64.0403 89.5899 64.0403 95.4299 74.1603ZM87.8699 157.71L90.7499 113.36C91.0899 108.07 86.8899 103.58 81.5899 103.58C76.2799 103.58 72.0799 108.06 72.4299 113.36L75.3099 157.71C75.5299 161.02 78.2699 163.6 81.5899 163.6C84.8999 163.6 87.6499 161.02 87.8699 157.71ZM72.0299 181.25C72.0299 186.91 76.7899 191.35 82.4199 190.83C87.2699 190.38 91.1499 186.33 91.2499 181.46C91.3599 176.01 86.9399 171.52 81.5199 171.52C76.2899 171.51 72.0299 175.89 72.0299 181.25Z",
            fill: "url(#paint0_linear)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M93.3498 27.1702L85.9398 0.450216C85.7698 -0.169784 84.8698 -0.129784 84.7498 0.500216L80.0898 25.6002L74.2898 24.5202C73.8498 24.4402 73.4698 24.8502 73.5898 25.2802L80.9998 52.0002C81.1698 52.6202 82.0698 52.5802 82.1898 51.9502L86.8498 26.8502L92.6498 27.9302C93.0998 28.0102 93.4698 27.6002 93.3498 27.1702Z",
            fill: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M66.7699 41.8103L55.8999 33.2603C55.6799 33.0803 55.3699 33.3303 55.4899 33.5903L61.0199 45.0203L58.3599 46.3103C58.1799 46.4003 58.1599 46.6403 58.3099 46.7603L69.1799 55.3103C69.3999 55.4903 69.7099 55.2403 69.5899 54.9803L64.0599 43.5503L66.7199 42.2603C66.8899 42.1803 66.9199 41.9303 66.7699 41.8103Z",
            fill: "#C1C7D0"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M102.78 56.7501C102.57 56.7501 102.37 56.6901 102.19 56.5601C101.81 56.2801 101.68 55.7801 101.86 55.3701C101.62 54.6001 99.57 52.5201 98.32 51.2601C95.35 48.2501 93.39 46.2601 94.48 44.7701C95.57 43.2901 98.06 44.5501 101.83 46.4701C103.15 47.1401 105.18 48.1701 106.28 48.5001C105.64 47.5501 104.04 45.9201 103 44.8701C100.03 41.8601 98.07 39.8701 99.16 38.3801C100.24 36.9001 102.74 38.1601 106.5 40.0801C107.82 40.7501 109.84 41.7801 110.95 42.1101C110.31 41.1601 108.71 39.5401 107.67 38.4901C104.7 35.4801 102.74 33.4901 103.83 32.0001C104.91 30.5201 107.4 31.7801 111.17 33.7001C112.75 34.5001 115.35 35.8301 116.15 35.8301C116.49 35.5401 117 35.5101 117.39 35.7901C117.84 36.1201 117.93 36.7401 117.61 37.1901C116.52 38.6701 114.04 37.4101 110.27 35.4901C108.95 34.8201 106.93 33.7901 105.83 33.4601C106.47 34.4101 108.07 36.0301 109.11 37.0801C112.08 40.0901 114.04 42.0801 112.95 43.5701C111.87 45.0501 109.38 43.7901 105.61 41.8701C104.29 41.2001 102.26 40.1701 101.16 39.8401C101.8 40.7901 103.4 42.4101 104.44 43.4701C107.41 46.4801 109.37 48.4701 108.28 49.9601C107.19 51.4401 104.7 50.1801 100.93 48.2601C99.61 47.5901 97.58 46.5501 96.48 46.2301C97.12 47.1801 98.72 48.8101 99.76 49.8601C102.73 52.8701 104.69 54.8601 103.6 56.3501C103.39 56.6101 103.09 56.7501 102.78 56.7501Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M108.34 71.0702C107.99 71.0702 107.65 70.8802 107.46 70.5502C106.42 68.6702 105.24 66.5302 106.55 65.3402C107.86 64.1402 109.89 65.5202 112.04 66.9702C112.91 67.5602 114.3 68.5002 114.97 68.6802C114.85 68.0002 114.04 66.5302 113.52 65.6102C112.26 63.3402 111.07 61.2002 112.38 60.0002C113.69 58.8002 115.72 60.1802 117.87 61.6302C118.83 62.2802 120.41 63.3502 120.97 63.3702C121.38 63.0702 121.95 63.1202 122.3 63.5002C122.67 63.9102 122.65 64.5402 122.24 64.9102C120.93 66.1102 118.9 64.7402 116.75 63.2802C115.88 62.6902 114.49 61.7502 113.82 61.5702C113.94 62.2502 114.75 63.7202 115.27 64.6402C116.53 66.9102 117.72 69.0502 116.41 70.2502C115.1 71.4502 113.07 70.0702 110.92 68.6202C110.05 68.0302 108.66 67.0902 107.99 66.9102C108.11 67.5902 108.92 69.0502 109.21 69.5802C109.48 70.0602 109.3 70.6702 108.82 70.9402C108.67 71.0302 108.5 71.0702 108.34 71.0702Z",
            fill: "#B3BAC5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            opacity: "0.6"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            opacity: "0.6",
            d: "M54.02 68.1797C53.8 68.1797 53.58 68.1397 53.35 68.0397C51.71 67.3497 52.11 64.9297 52.54 62.3697C52.71 61.3297 52.99 59.6697 52.87 58.9897C52.3 59.3797 51.31 60.7397 50.69 61.5897C49.16 63.6797 47.7 65.6597 46.07 64.9697C45.56 64.7597 45.32 64.1697 45.54 63.6597C45.74 63.1797 46.27 62.9397 46.75 63.0897C47.27 62.8797 48.4 61.3397 49.09 60.4097C50.62 58.3197 52.07 56.3297 53.71 57.0297C55.35 57.7197 54.95 60.1397 54.52 62.6997C54.35 63.7397 54.07 65.3997 54.19 66.0797C54.76 65.6897 55.75 64.3297 56.37 63.4797C57.9 61.3897 59.35 59.3997 60.99 60.0997C62.62 60.7897 62.23 63.1897 61.88 65.3097C61.79 65.8497 61.28 66.2197 60.73 66.1397C60.19 66.0497 59.81 65.5397 59.9 64.9897C60 64.3997 60.27 62.7497 60.16 62.0697C59.59 62.4597 58.6 63.8197 57.98 64.6697C56.65 66.4597 55.39 68.1797 54.02 68.1797Z",
            fill: "#B3BAC5"
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: "paint0_linear",
            x1: "26.1692",
            y1: "228.621",
            x2: "138.408",
            y2: "116.382",
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            stopColor: "#C1C7D0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.297",
            stopColor: "#C6CBD4",
            stopOpacity: "0.8812"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.6301",
            stopColor: "#D3D7DE",
            stopOpacity: "0.748"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0.9795",
            stopColor: "#E9EBEF",
            stopOpacity: "0.6082"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "1",
            stopColor: "#EBECF0",
            stopOpacity: "0.6"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0.649902 0H163.93V212H0.649902V0Z",
            fill: "white"
        }))));
    };
});
parcelRegister("cI0Td", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f71e8c5b4eb5da96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $d5Zn3;
    var $coLPe = parcelRequire("coLPe");
    var $ivXTE = parcelRequire("ivXTE");
    const $f71e8c5b4eb5da96$var$ErrorMessage = (props)=>{
        const errorType = props.errorType || {
            reason: 'default'
        };
        const errorReason = errorType.reason;
        const { fireAnalytics: fireAnalytics, reload: reload } = props;
        const hasRetry = !!reload;
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'error', {
                hasRetry: hasRetry,
                errorType: errorReason
            }));
        }, [
            errorReason,
            fireAnalytics,
            hasRetry
        ]);
        const errorContent = ()=>{
            if (errorReason === 'NotFound') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "The user is no longer available for the site");
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorTitle), null, "Oops, looks like we\u2019re having issues", (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorText), null, "Try again and we\u2019ll give it another shot"));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("d5Zn3"))))), {
            label: "icon error",
            size: "xlarge"
        }), errorContent(), reload && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "link",
            onClick: reload
        }, "Try again"));
    };
    var $f71e8c5b4eb5da96$export$2e2bcd8739ae039 = $f71e8c5b4eb5da96$var$ErrorMessage;
});
parcelRegister("coLPe", function(module, exports) {
    $parcel$export(module.exports, "ErrorWrapper", ()=>$263bdf68dbaa8e29$export$bb27b7e39840238f);
    $parcel$export(module.exports, "ErrorTitle", ()=>$263bdf68dbaa8e29$export$b065fd053267ec81);
    $parcel$export(module.exports, "ErrorText", ()=>$263bdf68dbaa8e29$export$7f714e6c560938e5);
    $parcel$export(module.exports, "TeamErrorTitle", ()=>$263bdf68dbaa8e29$export$d139ade0bdee219d);
    $parcel$export(module.exports, "TeamErrorText", ()=>$263bdf68dbaa8e29$export$90d92ccfb27352c6);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    const $263bdf68dbaa8e29$export$bb27b7e39840238f = (0, $bWGt6.default)("div", {
        target: "e1g2atxt4"
    })({
        textAlign: 'center',
        padding: "var(--ds-space-300, 24px)",
        color: (0, $huHkE.errorIconColor)
    });
    const $263bdf68dbaa8e29$export$b065fd053267ec81 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt3"
    })({
        color: (0, $huHkE.errorTitleColor),
        lineHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 3}px`,
        margin: `${"var(--ds-space-100, 8px)"} 0`
    });
    const $263bdf68dbaa8e29$export$7f714e6c560938e5 = (0, $bWGt6.default)("span", {
        target: "e1g2atxt2"
    })({
        color: (0, $huHkE.errorTextColor)
    });
    const $263bdf68dbaa8e29$export$d139ade0bdee219d = (0, $bWGt6.default)("p", {
        target: "e1g2atxt1"
    })((0, (0, parcelRequire("3RZIb")).h400));
    const $263bdf68dbaa8e29$export$90d92ccfb27352c6 = (0, $bWGt6.default)("p", {
        target: "e1g2atxt0"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-100, 8px)"
    });
});
parcelRegister("aRdJp", function(module, exports) {
    $parcel$export(module.exports, "AgentActions", ()=>$e34fa80969140484$export$a091e6fbe251d12f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $ousew;
    var $koVbs;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $zPb6e;
    var $h88oy;
    var $kMJs7 = parcelRequire("kMJs7");
    const $e34fa80969140484$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $e34fa80969140484$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $e34fa80969140484$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $e34fa80969140484$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $e34fa80969140484$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $e34fa80969140484$var$actionsWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: '1px',
        borderTopStyle: 'solid',
        borderColor: 'color.border',
        padding: 'space.200',
        marginBlockStart: 'space.200',
        color: 'color.text'
    });
    const $e34fa80969140484$var$buildAgentActions = ({ onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, isForgeAgent: isForgeAgent })=>{
        return isForgeAgent ? [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ] : [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDuplicate),
                onClick: onDuplicateAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionCopyLink),
                onClick: onCopyAgent
            }
        ];
    };
    const $e34fa80969140484$var$buildAgentSettings = ({ onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent })=>{
        return [
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionEdit),
                onClick: onEditAgent
            },
            {
                text: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), $e34fa80969140484$var$messages.actionDelete),
                onClick: onDeleteAgent
            }
        ];
    };
    const $e34fa80969140484$export$a091e6fbe251d12f = ({ isAgentCreatedByCurrentUser: isAgentCreatedByCurrentUser, onEditAgent: onEditAgent, onDeleteAgent: onDeleteAgent, onDuplicateAgent: onDuplicateAgent, onCopyAgent: onCopyAgent, onChatClick: onChatClick, onViewFullProfileClick: onViewFullProfileClick, agent: agent, resourceClient: resourceClient })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $5uXOq.useState)(false);
        const isForgeAgent = agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY';
        const loadAgentPermissions = (0, $5uXOq.useCallback)(async ()=>{
            const { permissions: { AGENT_UPDATE: AGENT_UPDATE, AGENT_DEACTIVATE: AGENT_DEACTIVATE } } = await resourceClient.getRovoAgentPermissions(agent.id);
            return {
                isEditEnabled: AGENT_UPDATE.permitted,
                isDeleteEnabled: AGENT_DEACTIVATE.permitted
            };
        }, [
            agent.id,
            resourceClient
        ]);
        const agentActions = $e34fa80969140484$var$buildAgentActions({
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent,
            isForgeAgent: agent.creator_type === 'FORGE' || agent.creator_type === 'THIRD_PARTY'
        });
        const agentSetting = $e34fa80969140484$var$buildAgentSettings({
            onEditAgent: onEditAgent,
            onDeleteAgent: ()=>{
                setIsDeleteModalOpen(true);
            }
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.100",
            xcss: $e34fa80969140484$var$actionsWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            shouldFitContainer: true,
            onClick: (e)=>{
                e.stopPropagation();
                onChatClick();
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $e34fa80969140484$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e34fa80969140484$var$chatPillTextStyles
        }, formatMessage($e34fa80969140484$var$messages.actionChatToAgent)))))), (0, (0, parcelRequire("VSDnB")).fg)('rovo_use_agent_permissions') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("zPb6e")).AgentDropdownMenu), {
            agentId: agent.id,
            isAgentCreatedByUser: isAgentCreatedByCurrentUser ?? false,
            onDeleteAgent: ()=>setIsDeleteModalOpen(true),
            onEditAgent: onEditAgent,
            onDuplicateAgent: onDuplicateAgent,
            onCopyAgent: onCopyAgent,
            isForgeAgent: isForgeAgent,
            loadAgentPermissions: loadAgentPermissions,
            loadPermissionsOnMount: true,
            onViewAgentFullProfileClick: onViewFullProfileClick,
            doesAgentHaveIdentityAccountId: !!agent.identity_account_id,
            shouldTriggerStopPropagation: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: "more",
                    ref: triggerRef,
                    onClick: (e)=>{
                        e.stopPropagation();
                        props.onClick?.(e);
                    }
                })),
            placement: "bottom-end"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, agentActions.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })), isAgentCreatedByCurrentUser && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
            hasSeparator: true
        }, agentSetting.map(({ text: text, onClick: onClick }, idx)=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: idx,
                onClick: (e)=>{
                    e.stopPropagation();
                    onClick?.();
                }
            }, text);
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kMJs7.AgentDeleteConfirmationModal), {
            isOpen: isDeleteModalOpen,
            onClose: ()=>{
                setIsDeleteModalOpen(false);
            },
            onSubmit: onDeleteAgent,
            agentId: agent.id,
            agentName: agent.name
        }));
    };
    const $e34fa80969140484$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        actionChatToAgent: {
            id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
            defaultMessage: 'Chat to Agent',
            description: 'Text for the "chat to agent" action to chat to the agent'
        },
        actionDelete: {
            id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
            defaultMessage: 'Delete Agent',
            description: 'Text for the "Delete" action to delete an agent'
        },
        actionEdit: {
            id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
            defaultMessage: 'Edit Agent',
            description: 'Text for the "Edit" action to edit an agent'
        },
        actionCopyLink: {
            id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
            defaultMessage: 'Copy link',
            description: 'Text for the Copy link of an agent'
        },
        actionDuplicate: {
            id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
            defaultMessage: 'Duplicate Agent',
            description: 'Text for the Duplicate Agent action to create a duplicate'
        }
    });
});
parcelRegister("zPb6e", function(module, exports) {
    $parcel$export(module.exports, "AgentDropdownMenu", ()=>$4de29d55d41f6cce$export$fc284fc0f7cc8f16);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $gKZoD;
    var $eCeGD;
    var $42CjB;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $h88oy;
    var $ccIkk;
    const $4de29d55d41f6cce$var$chatToAgentButtonContainer = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%'
    });
    const $4de29d55d41f6cce$var$chatToAgentButtonWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        justifyContent: 'center',
        lineHeight: '20px',
        fontWeight: '500'
    });
    const $4de29d55d41f6cce$var$chatPillButtonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $4de29d55d41f6cce$var$chatPillTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left',
        whiteSpace: 'pre-wrap'
    });
    const $4de29d55d41f6cce$var$chatPillIconWrapper = (0, (0, parcelRequire("8CUq3")).xcss)({
        minWidth: '20px',
        height: '20px'
    });
    const $4de29d55d41f6cce$export$ffe1cf57f0b5db02 = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatToAgentButtonContainer
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            testId: "view-agent-modal-chat-to-agent-button",
            shouldFitContainer: true,
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatToAgentButtonWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $4de29d55d41f6cce$var$chatPillButtonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatPillIconWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $4de29d55d41f6cce$var$chatPillTextStyles
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).chatToAgentButton))))));
    };
    const $4de29d55d41f6cce$export$fc284fc0f7cc8f16 = ({ isAgentCreatedByUser: isAgentCreatedByUser, onEditAgent: onEditAgent, onCopyAgent: onCopyAgent, onDuplicateAgent: onDuplicateAgent, onDeleteAgent: onDeleteAgent, onViewAgentFullProfileClick: onViewAgentFullProfileClick, isForgeAgent: isForgeAgent, showViewAgentOption: showViewAgentOption = false, onViewAgentClick: onViewAgentClick, onDropdownTriggerClick: onDropdownTriggerClick, spacing: spacing, appearance: appearance, dropdownMenuTestId: dropdownMenuTestId, doesAgentHaveIdentityAccountId: doesAgentHaveIdentityAccountId, loadAgentPermissions: loadAgentPermissions, loadPermissionsOnMount: loadPermissionsOnMount, shouldTriggerStopPropagation: shouldTriggerStopPropagation })=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("VSDnB")).fg));
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [hasBeenCopied, setHasBeenCopied] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [permissions, setPermissions] = (0, $5uXOq.useState)();
        (0, $5uXOq.useEffect)(()=>{
            const fetchData = async ()=>{
                if (!loadAgentPermissions || !(0, (0, parcelRequire("VSDnB")).fg)('rovo_use_agent_permissions')) {
                    const canEditDelete = isAgentCreatedByUser && !isForgeAgent;
                    setPermissions({
                        isEditEnabled: canEditDelete,
                        isDeleteEnabled: canEditDelete
                    });
                    return;
                }
                setIsLoading(true);
                const { isEditEnabled: isEditEnabled, isDeleteEnabled: isDeleteEnabled } = await loadAgentPermissions();
                setIsLoading(false);
                setPermissions({
                    isEditEnabled: isEditEnabled,
                    isDeleteEnabled: isDeleteEnabled
                });
            };
            if (!permissions && (isOpen || loadPermissionsOnMount)) fetchData();
        }, [
            isAgentCreatedByUser,
            isForgeAgent,
            isOpen,
            loadAgentPermissions,
            loadPermissionsOnMount,
            permissions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isOpen) setHasBeenCopied(false);
        }, [
            isOpen
        ]);
        const renderEditDelete = ()=>{
            if (!permissions?.isEditEnabled && !permissions?.isDeleteEnabled) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), {
                hasSeparator: true
            }, permissions.isEditEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: onEditAgent
            }, formatMessage((0, (0, parcelRequire("ccIkk")).default).editAgent)), permissions.isDeleteEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                onClick: onDeleteAgent
            }, formatMessage((0, (0, parcelRequire("ccIkk")).default).deleteAgent)));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            isLoading: isLoading,
            isOpen: isOpen,
            testId: dropdownMenuTestId,
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                    ...props,
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))),
                    label: formatMessage((0, (0, parcelRequire("ccIkk")).default).moreActionsLabel),
                    ref: triggerRef,
                    spacing: spacing,
                    appearance: appearance,
                    onClick: (e, analyticsEvent)=>{
                        if (onDropdownTriggerClick) onDropdownTriggerClick(e, analyticsEvent);
                        if (shouldTriggerStopPropagation) e.stopPropagation();
                        props.onClick?.(e);
                    }
                }),
            onOpenChange: (args)=>{
                setIsOpen(args.isOpen);
                if (!args.isOpen) setHasBeenCopied(false);
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, showViewAgentOption && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewAgentClick
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).viewAgent)), doesAgentHaveIdentityAccountId && onViewAgentFullProfileClick && (0, (0, parcelRequire("VSDnB")).fg)('rovo_agent_profile_page') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onViewAgentFullProfileClick
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).viewAgentFullProfile)), !isForgeAgent && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: onDuplicateAgent
        }, formatMessage((0, (0, parcelRequire("ccIkk")).default).duplicateAgent)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: (e)=>{
                e.stopPropagation();
                setHasBeenCopied(true);
                onCopyAgent?.(e);
            }
        }, formatMessage(hasBeenCopied ? (0, (0, parcelRequire("ccIkk")).default).linkedCopiedToProfile : (0, (0, parcelRequire("ccIkk")).default).copyLinkToProfile))), renderEditDelete());
    };
});
parcelRegister("h88oy", function(module, exports) {
    $parcel$export(module.exports, "ChatPillIcon", ()=>$222c44ccbe7ec2a4$export$38f9b635c1c454e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $82RQj;
    var $jyBoJ;
    const $222c44ccbe7ec2a4$export$38f9b635c1c454e7 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("82RQj"))))), {
            ...props,
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (0, parcelRequire("jyBoJ")).default)
        });
});
parcelRegister("82RQj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5db846b1e6bcdc52$var$_react = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5db846b1e6bcdc52$var$_UNSAFE_baseNew = $5db846b1e6bcdc52$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5db846b1e6bcdc52$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5db846b1e6bcdc52$var$AiChatIcon = (props)=>$5db846b1e6bcdc52$var$_react.default.createElement($5db846b1e6bcdc52$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M4.25 13.25v-.75h-.2l-.17.1zm-3.5 2H0a.75.75 0 0 0 1.12.65zM2.63 2h10.75V.5H2.63zM14.5 3.13v8.25H16V3.13zm-1.12 9.37H4.25V14h9.13zm-9.5.1-3.5 2 .74 1.3 3.5-2zM1.5 15.25V3.13H0v12.12zm13-3.87c0 .62-.5 1.13-1.12 1.13V14A2.63 2.63 0 0 0 16 11.38zM13.38 2c.62 0 1.13.5 1.13 1.13H16A2.63 2.63 0 0 0 13.38.5zM2.63.5A2.63 2.63 0 0 0 0 3.13h1.5C1.5 2.5 2 2 2.63 2zM6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
        }, props));
    $5db846b1e6bcdc52$var$AiChatIcon.displayName = 'AiChatIcon';
    var $5db846b1e6bcdc52$var$_default = module.exports.default = $5db846b1e6bcdc52$var$AiChatIcon;
});
parcelRegister("jyBoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2c3657b5b4eabc6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $c2c3657b5b4eabc6$var$ChatIconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinejoin: "round",
            fill: "transparent"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "6",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "9",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            x: "12",
            y: "8",
            width: "2",
            height: "2",
            rx: "1",
            fill: "currentColor"
        }));
    const $c2c3657b5b4eabc6$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            label: label,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            size: size,
            testId: testId,
            glyph: $c2c3657b5b4eabc6$var$ChatIconGlyph
        });
    var $c2c3657b5b4eabc6$export$2e2bcd8739ae039 = $c2c3657b5b4eabc6$var$ChatIcon;
});
parcelRegister("ccIkk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b8f2564df10c4301$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b8f2564df10c4301$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chatToAgentButton: {
            id: 'rovo-chat.view-agent.chat-to-agent-button',
            defaultMessage: 'Chat to Agent',
            description: 'Button to chat to agent'
        },
        moreActionsLabel: {
            id: 'rovo-chat.view-agent.more-actions-label',
            defaultMessage: 'More actions',
            description: 'More actions dropdown menu label'
        },
        duplicateAgent: {
            id: 'rovo-chat.view-agent.duplicate-agent',
            defaultMessage: 'Duplicate Agent',
            description: 'Button to duplicate an agent'
        },
        editAgent: {
            id: 'rovo-chat.view-agent.edit-agent',
            defaultMessage: 'Edit Agent',
            description: 'Button to edit an agent'
        },
        deleteAgent: {
            id: 'rovo-chat.view-agent.delete-agent',
            defaultMessage: 'Delete Agent',
            description: 'Button to delete an agent'
        },
        copyLinkToProfile: {
            id: 'rovo-chat.view-agent.copy-link-to-profile',
            defaultMessage: 'Copy link',
            description: 'Button to copy the link to the agent profile'
        },
        linkedCopiedToProfile: {
            id: 'rovo-chat.view-agent.link-copied-to-profile',
            defaultMessage: 'Copied URL',
            description: 'Button confirming link to agent profile is copied'
        },
        viewAgent: {
            id: 'rovo-chat.view-agents.view-agent',
            defaultMessage: 'View Agent',
            description: 'Button to view an agent'
        },
        viewAgentFullProfile: {
            id: 'rovo-chat.view-agents.view-agent-full-profile',
            defaultMessage: 'View full profile',
            description: 'Button to view an agent full profile'
        }
    });
});
parcelRegister("kMJs7", function(module, exports) {
    $parcel$export(module.exports, "AgentDeleteConfirmationModal", ()=>$9ca0177e5b141068$export$39d869cf16a68f79);
    var $5uXOq = parcelRequire("5uXOq");
    var $7VHMR;
    var $koVbs;
    var $eCeGD;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $i8Qvm;
    var $cgL5K;
    const $9ca0177e5b141068$export$39d869cf16a68f79 = ({ onClose: onClose, agentName: agentName, isOpen: isOpen, onSubmit: onSubmit, agentId: agentId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleDeleteAgent = (0, $5uXOq.useCallback)(async ()=>{
            if (agentId) {
                await onSubmit();
                onClose();
            }
        }, [
            agentId,
            onClose,
            onSubmit
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, formatMessage($9ca0177e5b141068$var$messages.title, {
            agentName: agentName
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage($9ca0177e5b141068$var$messages.body)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage($9ca0177e5b141068$var$messages.cancelText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eCeGD")).default), {
            appearance: "danger",
            onClick: (_e, event)=>{
                handleDeleteAgent();
            }
        }, formatMessage($9ca0177e5b141068$var$messages.confirmText))))));
    };
    const $9ca0177e5b141068$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        cancelText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.cancel-text',
            defaultMessage: 'Cancel'
        },
        confirmText: {
            id: 'profilecard.agent-profile.agent-delete-confirm.confirm-text',
            defaultMessage: 'Delete'
        },
        title: {
            id: 'profilecard.agent-profile.delete-agent-confirm-title',
            defaultMessage: 'Delete "{agentName}"?',
            description: 'Title text for the delete agent confirmation modal'
        },
        body: {
            id: 'profilecard.agent-profile.delete-agent-confirm-body',
            defaultMessage: `Are you sure you want to delete this agent? This action cannot be undone.`,
            description: 'Body text for the delete agent confirmation modal'
        },
        error: {
            id: 'profilecard.agent-profile.delete-agent-error',
            defaultMessage: 'Could not delete agent',
            description: 'Error message displayed when an agent cannot be deleted'
        },
        errorAgentNotFound: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-not-found',
            defaultMessage: 'That agent could not be found.',
            description: 'Error message displayed when an agent cannot be found'
        },
        errorAgentInUse: {
            id: 'profilecard.agent-profile.delete-agent-error.agent-in-use',
            defaultMessage: 'Agent is currently in use. Try again later.',
            description: 'Error message displayed when an agent is in use'
        },
        errorIncorrectOwner: {
            id: 'profilecard.agent-profile.delete-agent-error.incorrect-owner',
            defaultMessage: 'You cannot delete agents you have not created yourself. Please contact the agent owner.',
            description: 'Error message displayed when the agent owner is incorrect'
        },
        agentDeletedSuccess: {
            id: 'profilecard.agent-profile.delete-agent-success',
            defaultMessage: 'Agent has been deleted!',
            description: 'Success message displayed when an agent is deleted'
        }
    });
});
parcelRegister("a3FJs", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardWrapper", ()=>$642b3278878bc39a$export$2c6604b50c274e6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $642b3278878bc39a$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $642b3278878bc39a$export$2c6604b50c274e6f = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $642b3278878bc39a$var$styles
        }, children);
    };
});
parcelRegister("h9eXl", function(module, exports) {
    $parcel$export(module.exports, "ConversationStarters", ()=>$e92c824efb5f3806$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $4ns5a;
    const $e92c824efb5f3806$export$ea338c37011da44c = ({ isAgentDefault: isAgentDefault, onConversationStarterClick: onConversationStarterClick, userDefinedConversationStarters: userDefinedConversationStarters })=>{
        const handleConversationStarterClick = (conversationStarter)=>{
            onConversationStarterClick(conversationStarter);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.050",
            alignInline: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4ns5a")).AgentConversationStarters), {
            isAgentDefault: isAgentDefault,
            onConversationStarterClick: handleConversationStarterClick,
            userDefinedConversationStarters: userDefinedConversationStarters
        }));
    };
});
parcelRegister("4ns5a", function(module, exports) {
    $parcel$export(module.exports, "getConversationStarters", ()=>$a3b222b85982a88a$export$c2d882153e0984c5);
    $parcel$export(module.exports, "AgentConversationStarters", ()=>$a3b222b85982a88a$export$171adfc74aa509c3);
    $parcel$export(module.exports, "ConversationStarters", ()=>$a3b222b85982a88a$export$ea338c37011da44c);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $42CjB;
    var $lzNDe;
    var $f5TWP;
    var $1NZUH;
    var $52GXX;
    const $a3b222b85982a88a$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
        const type = 'static';
        const customAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).agentEmptyStateSuggestion3,
                type: type
            }
        ];
        const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
        const defaultAgentConversationStarters = [
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion1,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion2,
                type: type
            },
            {
                message: (0, (0, parcelRequire("52GXX")).messages).emptyStateSuggestion3,
                type: type
            }
        ];
        const getCombinedConversationStarters = ()=>{
            const shouldCombine = !isAgentDefault;
            if (shouldCombine) return [
                ...userDefinedConversationStarters,
                ...customAgentConversationStarters
            ].slice(0, 3);
            return defaultAgentConversationStarters;
        };
        return {
            userDefinedConversationStarters: userDefinedConversationStarters,
            customAgentConversationStarters: customAgentConversationStarters,
            defaultAgentConversationStarters: defaultAgentConversationStarters,
            combinedConversationStarters: getCombinedConversationStarters()
        };
    };
    const $a3b222b85982a88a$export$171adfc74aa509c3 = ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { combinedConversationStarters: combinedConversationStarters } = (0, $5uXOq.useMemo)(()=>$a3b222b85982a88a$export$c2d882153e0984c5({
                userDefinedConversationStarters: userDefinedConversationStarters,
                isAgentDefault: isAgentDefault
            }), [
            userDefinedConversationStarters,
            isAgentDefault
        ]);
        const starters = (0, $5uXOq.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                    message: starter.message,
                    type: starter.type
                } : {
                    message: formatMessage(starter.message),
                    type: starter.type
                }), [
            combinedConversationStarters,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3b222b85982a88a$export$ea338c37011da44c, {
            starters: starters,
            ...props
        });
    };
    const $a3b222b85982a88a$export$ea338c37011da44c = ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, starters.map((starter, index)=>{
            const isLastStarter = index === starters.length - 1;
            const chatPill = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).ChatPill), {
                testId: "conversation-starter",
                key: starter.message,
                onClick: ()=>onConversationStarterClick(starter)
            }, starter.message);
            return isLastStarter && showReloadButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
                space: "space.050",
                grow: "fill",
                alignInline: "end",
                key: starter.message
            }, chatPill, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("lzNDe"))))),
                onClick: onReloadButtonClick,
                appearance: "subtle",
                label: ""
            })) : chatPill;
        }), !!onBrowseAgentsClick && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1NZUH")).BrowseAgentsPill), {
            onClick: onBrowseAgentsClick
        }));
    };
});
parcelRegister("1NZUH", function(module, exports) {
    $parcel$export(module.exports, "ChatPill", ()=>$0fd9c621f10bd238$export$e33faa86e0996d96);
    $parcel$export(module.exports, "BrowseAgentsPill", ()=>$0fd9c621f10bd238$export$76b47032dcd9063b);
    $parcel$export(module.exports, "ConversationStarterPill", ()=>$0fd9c621f10bd238$export$f7619b16091e62a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4V6HW;
    var $dC5iT;
    var $f5TWP;
    var $5ILhZ;
    var $8CUq3;
    var $h88oy;
    var $eCjlc;
    const $0fd9c621f10bd238$var$conversationStarterPillStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        padding: 'space.100',
        border: `1px solid ${"var(--ds-border, #091E4224)"}`,
        borderRadius: 'border.radius.200',
        borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        background: 'none',
        width: '100%',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    });
    const $0fd9c621f10bd238$var$buttonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        padding: 'space.100',
        borderRadius: 'border.radius.200',
        borderBottomRightRadius: "var(--ds-border-radius-050, 2px)",
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        lineHeight: '16px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        flexShrink: 1,
        backgroundColor: 'color.background.neutral',
        ':hover': {
            backgroundColor: 'color.background.neutral.hovered'
        },
        ':active': {
            backgroundColor: 'color.background.neutral.pressed'
        }
    });
    const $0fd9c621f10bd238$var$buttonInlineStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.025'
    });
    const $0fd9c621f10bd238$var$queryTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        wordBreak: 'break-word',
        textAlign: 'left'
    });
    const $0fd9c621f10bd238$var$whiteSpacePreWrapStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        whiteSpace: 'pre-wrap'
    });
    const $0fd9c621f10bd238$export$e33faa86e0996d96 = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0fd9c621f10bd238$var$queryTextStyles,
                whiteSpacePreWrap && $0fd9c621f10bd238$var$whiteSpacePreWrapStyles
            ]
        }, children))));
    const $0fd9c621f10bd238$export$76b47032dcd9063b = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$buttonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4V6HW"))))), {
            color: "currentColor",
            label: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $0fd9c621f10bd238$var$queryTextStyles
        }, formatMessage((0, (0, parcelRequire("eCjlc")).default).browseAgentsPillLabel))));
    });
    const $0fd9c621f10bd238$export$f7619b16091e62a2 = (0, ($parcel$interopDefault($5uXOq))).forwardRef(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            ref: ref,
            ...props,
            xcss: $0fd9c621f10bd238$var$conversationStarterPillStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            space: "space.050",
            xcss: $0fd9c621f10bd238$var$buttonInlineStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h88oy")).ChatPillIcon), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $0fd9c621f10bd238$var$queryTextStyles,
                whiteSpacePreWrap && $0fd9c621f10bd238$var$whiteSpacePreWrapStyles
            ]
        }, children))));
});
parcelRegister("eCjlc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34bad2d4003b85e8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34bad2d4003b85e8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        browseAgentsPillLabel: {
            id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
            defaultMessage: 'Browse Agents',
            description: 'The label displayed on the browse agents pill'
        }
    });
});
parcelRegister("52GXX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$53d3212f8a8a35da$export$defe85febe8b728c);
    var $7VHMR;
    const $53d3212f8a8a35da$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        emptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.suggestion1',
            defaultMessage: 'Are any of my tickets overdue?',
            description: 'The first suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.suggestion2',
            defaultMessage: 'What should I work on next?',
            description: 'The second suggestion displayed in the empty state of the chat history'
        },
        emptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.suggestion3',
            defaultMessage: 'Write an update about my week',
            description: 'The third suggestion displayed in the empty state of the chat history'
        },
        agentEmptyStateSuggestion1: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion1',
            defaultMessage: 'Tell me about yourself',
            description: 'The first suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion2: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion2',
            defaultMessage: 'What can you help me with?',
            description: 'The second suggestion displayed in the empty state when an agent is selected'
        },
        agentEmptyStateSuggestion3: {
            id: 'ai-mate.chat-history.empty-state.agent-suggestion3',
            defaultMessage: "Summarize what I'm looking at",
            description: 'The third suggestion displayed in the empty state when an agent is selected'
        }
    });
});
parcelRegister("37c0Y", function(module, exports) {
    $parcel$export(module.exports, "useAgentUrlActions", ()=>$4da156710b0b2a06$export$56665b80ee272742);
    var $5uXOq = parcelRequire("5uXOq");
    var $kTK0a;
    var $VSDnB;
    var $7Z8dX;
    var $9IyQf = parcelRequire("9IyQf");
    const $4da156710b0b2a06$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    const $4da156710b0b2a06$var$ROVO_PARAM_PREFIX = 'rovoChat';
    const $4da156710b0b2a06$var$createRovoParams = (params)=>{
        const rovoParams = {};
        Object.entries(params).forEach(([key, value])=>{
            rovoParams[`${$4da156710b0b2a06$var$ROVO_PARAM_PREFIX}${$4da156710b0b2a06$export$fda91e425d265029(key)}`] = encodeURIComponent(value);
        });
        return rovoParams;
    };
    const $4da156710b0b2a06$export$56665b80ee272742 = ({ cloudId: cloudId })=>{
        const { publishWithPostMessage: publishWithPostMessage } = (0, (0, parcelRequire("7Z8dX")).useRovoPostMessageToPubsub)();
        const onEditAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const url = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/${agentId}/edit`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(url, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onCopyAgent = (agentId)=>{
            navigator.clipboard.writeText(`${window.location.origin}/people/agent/${agentId}`);
        };
        const onDuplicateAgent = (0, $5uXOq.useCallback)((agentId)=>{
            const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat/agents/new`;
            const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                cloudId: cloudId,
                ...$4da156710b0b2a06$var$createRovoParams({
                    cloudId: cloudId,
                    agentId: agentId,
                    pathway: 'agents-create'
                })
            });
            window.open(urlWithParams, '_blank', 'noopener, noreferrer');
        }, [
            cloudId
        ]);
        const onConversationStarter = ({ agentId: agentId, prompt: prompt })=>{
            const startConversationInNewTab = ()=>{
                const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
                const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                    cloudId: cloudId,
                    ...$4da156710b0b2a06$var$createRovoParams({
                        cloudId: cloudId,
                        agentId: agentId,
                        prompt: prompt,
                        pathway: 'chat'
                    })
                });
                window.open(urlWithParams, '_blank', 'noopener, noreferrer');
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_profile_card_open_chat_sidebar')) publishWithPostMessage({
                targetWindow: window,
                payload: {
                    type: 'chat-new',
                    source: 'AgentProfileCard',
                    data: {
                        name: prompt.slice(0, 50),
                        prompt: prompt,
                        agentId: agentId,
                        dialogues: []
                    }
                },
                onAcknowledgeTimeout: ()=>{
                    startConversationInNewTab();
                }
            });
            else startConversationInNewTab();
        };
        const onOpenChat = (agentId, agentName)=>{
            const openChatInNewTab = ()=>{
                const baseUrl = `${(0, (0, parcelRequire("kTK0a")).getATLContextUrl)('home')}/chat`;
                const urlWithParams = (0, $9IyQf.encodeParamsToUrl)(baseUrl, {
                    cloudId: cloudId,
                    ...$4da156710b0b2a06$var$createRovoParams({
                        cloudId: cloudId,
                        agentId: agentId
                    })
                });
                window.open(urlWithParams, '_blank', 'noopener, noreferrer');
            };
            if ((0, (0, parcelRequire("VSDnB")).fg)('rovo_profile_card_open_chat_sidebar')) publishWithPostMessage({
                targetWindow: window,
                payload: {
                    type: 'chat-new',
                    source: 'AgentProfileCard',
                    data: {
                        agentId: agentId,
                        dialogues: [],
                        name: `Chat with ${agentName}`
                    }
                },
                onAcknowledgeTimeout: ()=>{
                    openChatInNewTab();
                }
            });
            else openChatInNewTab();
        };
        const onViewFullProfile = (agentId)=>{
            window.open(`${window.location.origin}/people/agent/${agentId}`, '_blank', 'noopener, noreferrer');
        };
        return {
            onEditAgent: onEditAgent,
            onCopyAgent: onCopyAgent,
            onDuplicateAgent: onDuplicateAgent,
            onOpenChat: onOpenChat,
            onConversationStarter: onConversationStarter,
            onViewFullProfile: onViewFullProfile
        };
    };
});
parcelRegister("9IyQf", function(module, exports) {
    $parcel$export(module.exports, "encodeParamsToUrl", ()=>$f44b342f66021b18$export$3220405ab77f2c5d);
    const $f44b342f66021b18$export$3220405ab77f2c5d = (baseUrl, params)=>{
        const url = new URL(baseUrl);
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params))searchParams.append(key, String(value));
        url.search = searchParams.toString();
        return url.toString();
    };
});
parcelRegister("dlHyi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$b47fe3036cdacda7$export$defe85febe8b728c);
    var $7VHMR;
    const $b47fe3036cdacda7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        agentDeletedSuccessFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-title',
            defaultMessage: 'Agent deleted',
            description: 'Flag message title displayed when an agent is deleted'
        },
        agentDeletedSuccessFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-success-flag-description',
            defaultMessage: 'You deleted {agentName}',
            description: 'Flag message description displayed when an agent is deleted'
        },
        agentDeletedErrorFlagTitle: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-title',
            defaultMessage: 'Failed to delete Agent',
            description: 'Flag message title displayed when there is an error deleting agent'
        },
        agentDeletedErrorFlagDescription: {
            id: 'profilecard.agent-profile-card.delete-agent-error-flag-description',
            defaultMessage: 'Something went wrong while deleting the agent. Try again in a few moments.',
            description: 'Flag message description displayed when there is an error deleting agent'
        }
    });
});
parcelRegister("6uTwi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a486335f4f64442$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $9MMkr = parcelRequire("9MMkr");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $gMO5Q = parcelRequire("gMO5Q");
    var $lpWVl = parcelRequire("lpWVl");
    var $devOt = parcelRequire("devOt");
    class $6a486335f4f64442$export$f811dc569217c959 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: [],
                trigger: 'hover',
                position: 'bottom-start',
                triggerLinkType: 'link'
            };
        }
        componentDidMount() {
            this._isMounted = true;
        }
        componentDidUpdate(prevProps) {
            const { orgId: orgId, teamId: teamId, resourceClient: resourceClient } = this.props;
            const { visible: visible } = this.state;
            if (visible && (teamId !== prevProps.teamId || orgId !== prevProps.orgId || resourceClient !== prevProps.resourceClient)) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
            clearTimeout(this.showTimer);
            clearTimeout(this.hideTimer);
        }
        handleClientSuccess(team, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: team,
                shouldShowGiveKudos: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        filterActions() {
            const actions = (0, $4sfdL.default)(this.props.actions, this.state.data);
            if (this.state.shouldShowGiveKudos) {
                const kudosAction = {
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                    id: 'give-kudos',
                    callback: ()=>{
                        this.openKudosDrawer();
                    },
                    link: this.kudosUrl()
                };
                return actions.concat([
                    kudosAction
                ]);
            }
            return actions;
        }
        renderPopup() {
            if (this.state.renderError) return this.props.children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $gMO5Q.ErrorBoundary), {
                onError: this.onErrorBoundary
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
                isOpen: !!this.state.visible,
                onClose: this.onClose,
                placement: this.props.position,
                content: this.renderProfileCard,
                trigger: (triggerProps)=>this.renderTrigger(triggerProps),
                zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
                shouldFlip: true,
                autoFocus: this.props.trigger !== 'hover' && !this.openedByHover,
                shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
            }));
        }
        render() {
            if (this.props.children) return this.renderPopup();
            else throw new Error('Component "TeamProfileCardTrigger" must have "children" property');
        }
        constructor(...args){
            super(...args), this._isMounted = false, this.showTimer = 0, this.hideTimer = 0, this.openedByHover = false, this.openTime = 0, this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            }, this.fireAnalyticsWithDuration = (generator)=>{
                const event = generator((0, $6TKEY.getPageTime)() - this.openTime);
                this.fireAnalytics(event);
            }, this.hideProfilecard = (delay = 0)=>{
                clearTimeout(this.showTimer);
                clearTimeout(this.hideTimer);
                this.hideTimer = window.setTimeout(()=>{
                    this.setState({
                        visible: false
                    });
                }, delay);
            }, this.showProfilecard = (delay = 0)=>{
                clearTimeout(this.hideTimer);
                clearTimeout(this.showTimer);
                this.showTimer = window.setTimeout(()=>{
                    if (!this.state.visible) {
                        this.clientFetchProfile();
                        this.openTime = (0, $6TKEY.getPageTime)();
                        this.setState({
                            visible: true
                        });
                    }
                }, delay);
            }, this.onClick = (event)=>{
                if (this.props.triggerLinkType === 'link') {
                    if ((0, $dv9z3.isBasicClick)(event)) event.preventDefault();
                }
                if (this.props.triggerLinkType === 'clickable-link') {
                    if (this.props.viewProfileOnClick) this.props.viewProfileOnClick(event);
                }
                if (this.props.trigger !== 'hover') {
                    this.openedByHover = false;
                    this.showProfilecard(0);
                    if (!this.state.visible) this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'click'));
                }
            }, this.onMouseEnter = ()=>{
                if (this.props.trigger === 'click') return;
                if (!this.state.visible) {
                    this.openedByHover = true;
                    this.fireAnalytics((0, $ivXTE.cardTriggered)('team', 'hover'));
                }
                this.showProfilecard((0, $e41878b3b8cab0db$export$5b956b542f1bc1b3));
            }, this.onMouseLeave = ()=>{
                if (this.props.trigger === 'click') return;
                if (this.openedByHover) this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
            }, this.onClose = ()=>{
                this.hideProfilecard();
            }, this.openKudosDrawer = ()=>{
                this.hideProfilecard((0, $e41878b3b8cab0db$export$89a9f35a94d7f196));
                this.setState({
                    kudosDrawerOpen: true
                });
            }, this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            }, this.kudosUrl = ()=>{
                const recipientId = this.props.teamId && `&recipientId=${this.props.teamId}` || '';
                const cloudId = this.props.cloudId && `&cloudId=${this.props.cloudId}` || '';
                return `${this.state.teamCentralBaseUrl}/kudos/give?type=team${recipientId}${cloudId}`;
            }, this.stopPropagation = (event)=>{
                event.stopPropagation();
            }, this.triggerListeners = {
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            }, this.cardListeners = {
                onClick: this.stopPropagation,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            }, this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                shouldShowGiveKudos: false,
                teamCentralBaseUrl: undefined,
                kudosDrawerOpen: false
            }, this.clientFetchProfile = ()=>{
                const { orgId: orgId, teamId: teamId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    data: null
                }, ()=>{
                    const fireEvent = (event)=>{
                        this.fireAnalytics(event);
                    };
                    const requests = Promise.all([
                        this.props.resourceClient.getTeamProfile(teamId, orgId, fireEvent),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            }, this.onErrorBoundary = ()=>{
                this.fireAnalytics((0, $ivXTE.profileCardRendered)('team', 'errorBoundary', {
                    duration: 0
                }));
                this.setState({
                    renderError: true
                });
            }, this.renderProfileCard = ()=>{
                const { generateUserLink: generateUserLink, onUserClick: onUserClick, viewingUserId: viewingUserId, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick } = this.props;
                const { data: data, error: error, hasError: hasError, isLoading: isLoading } = this.state;
                const newProps = {
                    clientFetchProfile: this.clientFetchProfile,
                    actions: this.filterActions(),
                    analytics: this.fireAnalyticsWithDuration,
                    team: data || undefined,
                    generateUserLink: generateUserLink,
                    onUserClick: onUserClick,
                    viewingUserId: viewingUserId,
                    viewProfileLink: viewProfileLink,
                    viewProfileOnClick: viewProfileOnClick
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", this.cardListeners, this.state.visible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
                        analytics: this.fireAnalyticsWithDuration
                    })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lpWVl.TeamProfileCardLazy), {
                    ...newProps,
                    isLoading: isLoading,
                    hasError: hasError,
                    errorType: error
                })));
            }, this.renderKudosLauncher = ()=>{
                return this.state.shouldShowGiveKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                    fallback: null
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                    isOpen: this.state.kudosDrawerOpen,
                    recipient: {
                        type: (0, (0, parcelRequire("gH4E9")).KudosType).TEAM,
                        recipientId: this.props.teamId
                    },
                    analyticsSource: "team-profile-card",
                    teamCentralBaseUrl: this.state.teamCentralBaseUrl,
                    cloudId: this.props.cloudId || '',
                    addFlag: this.props.addFlag,
                    onClose: this.closeKudosDrawer
                }));
            }, this.renderTrigger = (triggerProps)=>{
                const { children: children, triggerLinkType: triggerLinkType, viewProfileLink: viewProfileLink } = this.props;
                if (triggerLinkType === 'none') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    ...triggerProps,
                    ...this.triggerListeners
                }, children));
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, this.renderKudosLauncher(), (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    "data-testid": "team-profilecard-trigger-wrapper",
                    style: {
                        color: 'initial',
                        textDecoration: 'none'
                    },
                    href: viewProfileLink,
                    ...triggerProps,
                    ref: triggerProps.ref,
                    ...this.triggerListeners
                }, children));
            };
        }
    }
    var $6a486335f4f64442$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($6a486335f4f64442$export$f811dc569217c959);
});
parcelRegister("adIkV", function(module, exports) {
    $parcel$export(module.exports, "GiveKudosLauncherLazy", ()=>$c3877992df568d20$export$93fe397a02fe8b76);
    var $5uXOq = parcelRequire("5uXOq");
    const $c3877992df568d20$export$93fe397a02fe8b76 = (0, $5uXOq.lazy)(()=>(parcelRequire("7TeXq")));
});
parcelRegister("7TeXq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("HRhLG")
    ]).then(()=>parcelRequire('iRLc5'));
});
parcelRegister("gH4E9", function(module, exports) {
    $parcel$export(module.exports, "KudosType", ()=>$b9e3bff5640b4187$export$4fa2020056771264);
    $parcel$export(module.exports, "FlagEventType", ()=>$b9e3bff5640b4187$export$d21f9befaa2961a);
    $parcel$export(module.exports, "isFlagEventTypeValue", ()=>$b9e3bff5640b4187$export$7a1fc1a1b0477464);
    var $b9e3bff5640b4187$export$4fa2020056771264;
    (function(KudosType) {
        KudosType["INDIVIDUAL"] = "individual";
        KudosType["TEAM"] = "team";
    })($b9e3bff5640b4187$export$4fa2020056771264 || ($b9e3bff5640b4187$export$4fa2020056771264 = {}));
    var $b9e3bff5640b4187$export$d21f9befaa2961a;
    (function(FlagEventType) {
        FlagEventType["KUDOS_CREATED"] = "kudos-created";
        FlagEventType["KUDOS_FAILED"] = "kudos-failed";
        FlagEventType["JIRA_KUDOS_CREATED"] = "jira-kudos-created";
        FlagEventType["JIRA_KUDOS_FAILED"] = "jira-kudos-failed";
        FlagEventType["DIRTY"] = "dirty";
        FlagEventType["CLOSE"] = "close";
    })($b9e3bff5640b4187$export$d21f9befaa2961a || ($b9e3bff5640b4187$export$d21f9befaa2961a = {}));
    const $b9e3bff5640b4187$export$7a1fc1a1b0477464 = (value)=>{
        return Object.values($b9e3bff5640b4187$export$d21f9befaa2961a).includes(value);
    };
});
parcelRegister("4sfdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea1251cd76451c32$export$2e2bcd8739ae039);
    const $ea1251cd76451c32$var$filterActions = (actions = [], data)=>{
        return actions.filter((action)=>{
            if (!action.shouldRender) return true;
            else if (typeof action.shouldRender !== 'function') return Boolean(action.shouldRender);
            return action.shouldRender(data);
        });
    };
    var $ea1251cd76451c32$export$2e2bcd8739ae039 = $ea1251cd76451c32$var$filterActions;
});
parcelRegister("9MMkr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b852a44de86ce4d8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b852a44de86ce4d8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inactiveAccountMsg: {
            id: 'pt.profile-card.inactive.account',
            defaultMessage: 'Account deactivated',
            description: 'A text in a grey lozenge shows that this user is inactive'
        },
        generalDescMsgForDisabledUser: {
            id: 'pt.profile-card.general.msg.disabled.user',
            defaultMessage: 'You can no longer collaborate with this person.',
            description: 'A first sentence of a long text explains this user is inactive/closed'
        },
        inactiveAccountDescMsgNoDate: {
            id: 'pt.profile-card.inactive.account.no.date',
            defaultMessage: 'Their account has been deactivated.',
            description: 'A long text explains this user is inactive when we do not know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.inactive.account.has.date.this.week',
            defaultMessage: 'Their account was deactivated this week.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.inactive.account.has.date.this.month',
            defaultMessage: 'Their account was deactivated this month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.inactive.account.has.date.last.month',
            defaultMessage: 'Their account was deactivated last month.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.inactive.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deactivated for a few months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.inactive.account.has.date.several.months',
            defaultMessage: 'Their account has been deactivated for several months.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        inactiveAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.inactive.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deactivated for more than a year.',
            description: 'A long text explains this user is inactive when we know the date of starting to deactivate'
        },
        closedAccountMsg: {
            id: 'pt.profile-card.closed.account',
            defaultMessage: 'Account deleted',
            description: 'A text in a grey lozenge shows that this user is closed/deleted'
        },
        closedAccountDescMsgNoDate: {
            id: 'pt.profile-card.closed.account.no.date',
            defaultMessage: 'Their account has been deleted.',
            description: 'A long text explains this user is closed when we do not know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisWeek: {
            id: 'pt.profile-card.closed.account.has.date.this.week',
            defaultMessage: 'Their account was deleted this week.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateThisMonth: {
            id: 'pt.profile-card.closed.account.has.date.this.month',
            defaultMessage: 'Their account was deleted this month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateLastMonth: {
            id: 'pt.profile-card.closed.account.has.date.last.month',
            defaultMessage: 'Their account was deleted last month.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateAFewMonths: {
            id: 'pt.profile-card.closed.account.has.date.a.few.months',
            defaultMessage: 'Their account has been deleted for a few months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateSeveralMonths: {
            id: 'pt.profile-card.closed.account.has.date.several.months',
            defaultMessage: 'Their account has been deleted for several months.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        closedAccountDescMsgHasDateMoreThanAYear: {
            id: 'pt.profile-card.closed.account.has.date.more.than.a.year',
            defaultMessage: 'Their account has been deleted for more than a year.',
            description: 'A long text explains this user is closed when we know the date of starting to close'
        },
        disabledAccountDefaultName: {
            id: 'pt.profile-card.disabled.account.default.name',
            defaultMessage: 'Former user',
            description: 'A default name when we cannot get name of an inactive or closed user'
        },
        teamViewProfile: {
            id: 'pt.team-profile-card.team.action.view-profile',
            defaultMessage: 'View profile',
            description: "Button that takes you to view this team\u2019s profile"
        },
        memberCount: {
            id: 'pt.team-profile-card.team.member.count',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
            description: 'Byline to show the number of members in the team'
        },
        memberCountIncludingYou: {
            id: 'pt.team-profile-card.team.member.count-including-you',
            defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
            description: 'Byline to show the number of members in the team and highlight that the user is a member'
        },
        membersMoreThan50: {
            id: 'pt.team-profile-card.team.member.many',
            defaultMessage: "Team \u2022 50+ members",
            description: 'Byline to show the team has more than 50 members'
        },
        membersMoreThan50IncludingYou: {
            id: 'pt.team-profile-card.team.member.many-including-you',
            defaultMessage: "Team \u2022 50+ members, including you",
            description: 'Byline to show the team has more than 50 members and highlight that the user is a member'
        },
        teamErrorTitle: {
            id: 'pt.team-profile-card.error.title',
            defaultMessage: "We\u2019re having trouble retrieving this teams information",
            description: 'Title for an error view explaining that data for this team cannot be accessed'
        },
        teamErrorText: {
            id: 'pt.team-profile-card.error.suggestion',
            defaultMessage: 'Wait a few moments, then try again.',
            description: 'Second line suggesting how to fix the issue'
        },
        teamErrorButton: {
            id: 'pt.team-profile-card.error.refresh-button',
            defaultMessage: 'Try again',
            description: 'Text on a button that will try to get the data again when clicked'
        },
        teamForbiddenErrorStateTitle: {
            id: 'pt.team-profile-card.forbidden-error-state.title',
            defaultMessage: "We can\u2019t show you this team",
            description: 'Title for the error state that is displayed when a user lacks access to the team'
        },
        teamForbiddenErrorStateDescription: {
            id: 'pt.team-profile-card.forbidden-error-state.description',
            defaultMessage: "You don\u2019t have access to view this team.",
            description: 'Description for the error state that is displayed when a user lacks access to the team'
        },
        managerSectionHeading: {
            id: 'pt.team-profile-card.manager.heading',
            defaultMessage: 'Manager',
            description: "Title for a section on the profile card that show the user's direct manager"
        },
        directReportsSectionHeading: {
            id: 'pt.team-profile-card.directReports.heading',
            defaultMessage: 'Direct reports',
            description: "Title for a section on the profile card that show the user's direct reports"
        },
        giveKudosButton: {
            id: 'pt.profile-card.give-kudos',
            defaultMessage: 'Give kudos',
            description: 'Title for the button on the profile card for a user to give a kudos'
        },
        profileCardMoreIconLabel: {
            id: 'pt.profile-card.more-icon-label',
            defaultMessage: 'More',
            description: 'Label for the meatballs icon on the profile card, which when clicked will provide more options'
        }
    });
    var $b852a44de86ce4d8$export$2e2bcd8739ae039 = $b852a44de86ce4d8$var$messages;
});
parcelRegister("dv9z3", function(module, exports) {
    $parcel$export(module.exports, "isBasicClick", ()=>$29a366424d2cda97$export$eddcd8a5b7e09991);
    const $29a366424d2cda97$export$eddcd8a5b7e09991 = (event)=>{
        return !(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
    };
});
const $e41878b3b8cab0db$export$5b956b542f1bc1b3 = 800;
const $e41878b3b8cab0db$export$89a9f35a94d7f196 = 200;
parcelRegister("lpWVl", function(module, exports) {
    $parcel$export(module.exports, "TeamProfileCardLazy", ()=>$9bee5bfea0ce3d14$export$82a49d896f41ca78);
    var $5uXOq = parcelRequire("5uXOq");
    const $9bee5bfea0ce3d14$export$82a49d896f41ca78 = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("AF8aN"))));
});
parcelRegister("AF8aN", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$3bb916baa86f0602$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $jnhNB;
    var $2rqOp;
    var $fVnbM;
    var $jhVLw;
    var $bJeNF;
    var $3Z96c;
    var $eZUJu;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $3bDjY;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $coLPe = parcelRequire("coLPe");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    parcelRequire("geGTf");
    var $5HjZK = parcelRequire("5HjZK");
    var $drhKV = parcelRequire("drhKV");
    var $devOt = parcelRequire("devOt");
    const $3bb916baa86f0602$var$LARGE_MEMBER_COUNT = 50;
    const $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    function $3bb916baa86f0602$var$onMemberClick(callback, userId, analytics, index, hasHref) {
        return (event)=>{
            analytics((duration)=>(0, $ivXTE.teamAvatarClicked)({
                    duration: duration,
                    hasHref: hasHref,
                    hasOnClick: !!callback,
                    index: index
                }));
            if (callback) callback(userId, event);
        };
    }
    const $3bb916baa86f0602$var$TeamMembers = ({ analytics: analytics, generateUserLink: generateUserLink, members: members, onUserClick: onUserClick, includingYou: includingYou })=>{
        const count = members ? members.length : 0;
        const message = includingYou ? count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50IncludingYou : (0, $9MMkr.default).memberCountIncludingYou : count >= $3bb916baa86f0602$var$LARGE_MEMBER_COUNT ? (0, $9MMkr.default).membersMoreThan50 : (0, $9MMkr.default).memberCount;
        const isMoreMembersOpen = (0, $5uXOq.useRef)(false);
        const onMoreClick = (0, $5uXOq.useCallback)(()=>{
            const { current: isOpen } = isMoreMembersOpen;
            if (!isOpen) analytics((duration)=>(0, $ivXTE.moreMembersClicked)({
                    duration: duration,
                    memberCount: count
                }));
            isMoreMembersOpen.current = !isOpen;
        }, [
            analytics,
            count
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MemberCount), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...message,
            values: {
                count: count
            }
        })), members && members.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AvatarSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            data: members.map((member, index)=>{
                const href = generateUserLink?.(member.id);
                const onClick = $3bb916baa86f0602$var$onMemberClick(onUserClick, member.id, analytics, index, !!generateUserLink);
                return {
                    key: member.id,
                    name: member.fullName,
                    src: member.avatarUrl,
                    href: href,
                    onClick: onClick
                };
            }),
            maxCount: 9,
            showMoreButtonProps: {
                onClick: onMoreClick
            },
            testId: "profilecard-avatar-group"
        })));
    };
    function $3bb916baa86f0602$var$onActionClick(action, analytics, index) {
        return (event, ...args)=>{
            analytics((duration)=>(0, $ivXTE.actionClicked)('team', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || ''
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        };
    }
    const $3bb916baa86f0602$var$ActionButton = ({ action: action, analytics: analytics, index: index })=>{
        const isGiveKudosActionButton = action.id === $3bb916baa86f0602$var$GIVE_KUDOS_ACTION_ID;
        const actionButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            key: action.id || index,
            onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index),
            href: action.link,
            shouldFitContainer: true
        }, action.label, isGiveKudosActionButton && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
        if (isGiveKudosActionButton) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), null, actionButton);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, actionButton);
    };
    const $3bb916baa86f0602$var$ExtraActions = ({ actions: actions, analytics: analytics })=>{
        const [isOpen, setOpen] = (0, $5uXOq.useState)(false);
        const count = actions.length;
        const onMoreClick = (0, $5uXOq.useCallback)((shouldBeOpen)=>{
            if (shouldBeOpen) analytics((duration)=>(0, $ivXTE.moreActionsClicked)('team', {
                    duration: duration,
                    numActions: count + 2
                }));
            setOpen(shouldBeOpen);
        }, [
            analytics,
            count
        ]);
        if (!count) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.MoreButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: isOpen,
            onClose: ()=>setOpen(false),
            placement: "bottom-start",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZUJu")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Z96c")).default), {
                        onClick: $3bb916baa86f0602$var$onActionClick(action, analytics, index + 2),
                        key: action.id || index,
                        href: action.link
                    }, action.label))),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    testId: "more-actions-button",
                    ...triggerProps,
                    isSelected: isOpen,
                    onClick: ()=>onMoreClick(!isOpen),
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        spacing: "spacious",
                        label: "actions",
                        color: "currentColor"
                    })
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }));
    };
    const $3bb916baa86f0602$var$ButtonSection = ({ actions: actions, analytics: analytics })=>{
        if (!actions) return null;
        const extraActions = actions.slice(2);
        const initialActions = actions.slice(0, 2);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, initialActions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ActionButton, {
                action: action,
                analytics: analytics,
                index: index,
                key: index
            })), extraActions && (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ExtraActions, {
            actions: extraActions,
            analytics: analytics
        }));
    };
    const $3bb916baa86f0602$var$TeamProfilecardContent = ({ actions: actions, analytics: analytics, team: team, viewingUserId: viewingUserId, generateUserLink: generateUserLink, onUserClick: onUserClick, viewProfileLink: viewProfileLink, viewProfileOnClick: viewProfileOnClick })=>{
        const allActions = [
            {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamViewProfile),
                link: viewProfileLink,
                callback: viewProfileOnClick,
                id: 'view-profile'
            },
            ...actions || []
        ];
        const includingYou = team.members && team.members.some((member)=>member.id === viewingUserId);
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'content', {
                    duration: duration,
                    numActions: allActions.length,
                    memberCount: team.members?.length,
                    includingYou: includingYou,
                    descriptionLength: team.description.length,
                    titleLength: team.displayName.length
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            image: team.largeHeaderImageUrl || team.smallHeaderImageUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: team.displayName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamName), null, team.displayName)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamMembers, {
            analytics: analytics,
            members: team.members,
            generateUserLink: generateUserLink,
            includingYou: includingYou,
            onUserClick: onUserClick
        }), team.description.trim() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.DescriptionWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.Description), null, team.description)), (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ButtonSection, {
            actions: allActions,
            analytics: analytics
        })));
    };
    const $3bb916baa86f0602$var$ErrorMessage = ({ analytics: analytics, clientFetchProfile: clientFetchProfile, isLoading: isLoading })=>{
        const hasRetry = !!clientFetchProfile;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration,
                    hasRetry: hasRetry
                }));
        }, [
            analytics,
            hasRetry
        ]);
        const retry = (0, $5uXOq.useCallback)(()=>{
            analytics((duration)=>(0, $ivXTE.errorRetryClicked)({
                    duration: duration
                }));
            if (clientFetchProfile) clientFetchProfile();
        }, [
            analytics,
            clientFetchProfile
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.ErrorWrapper), {
            "data-testid": "team-profilecard-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5HjZK.ErrorIllustration), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorTitle), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorTitle)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $coLPe.TeamErrorText), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorText)), clientFetchProfile && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.ActionButtons), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.WrappedButton), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            testId: "client-fetch-profile-button",
            shouldFitContainer: true,
            onClick: retry,
            isLoading: isLoading
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).teamErrorButton)))));
    };
    const $3bb916baa86f0602$var$TeamProfileCard = (props)=>{
        const { analytics: analytics, clientFetchProfile: clientFetchProfile, hasError: hasError, isLoading: isLoading, team: team, errorType: errorType } = props;
        if (hasError) {
            if (errorType?.reason === 'TEAMS_FORBIDDEN') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $drhKV.default), {
                analytics: analytics
            });
            else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
                "data-testid": "team-profilecard"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$ErrorMessage, {
                analytics: analytics,
                clientFetchProfile: clientFetchProfile,
                isLoading: isLoading
            }));
        }
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $devOt.default), {
            analytics: analytics
        });
        if (team) return (0, ($parcel$interopDefault($5uXOq))).createElement($3bb916baa86f0602$var$TeamProfilecardContent, {
            ...props,
            team: team
        });
        return null;
    };
    var $3bb916baa86f0602$export$2e2bcd8739ae039 = $3bb916baa86f0602$var$TeamProfileCard;
});
parcelRegister("iE5Av", function(module, exports) {
    $parcel$export(module.exports, "CardWrapper", ()=>$cfab992fac525e86$export$6aa22a823032b784);
    $parcel$export(module.exports, "TeamForbiddenErrorStateWrapper", ()=>$cfab992fac525e86$export$66ecf3d3b7b1c016);
    $parcel$export(module.exports, "CardHeader", ()=>$cfab992fac525e86$export$5665775b26e26c5d);
    $parcel$export(module.exports, "CardContent", ()=>$cfab992fac525e86$export$64ef9b8c11710c47);
    $parcel$export(module.exports, "TeamName", ()=>$cfab992fac525e86$export$8fe6f0aed18a58c7);
    $parcel$export(module.exports, "MemberCount", ()=>$cfab992fac525e86$export$1cbd03a20253b620);
    $parcel$export(module.exports, "AvatarSection", ()=>$cfab992fac525e86$export$82a6f3ee677bdbfe);
    $parcel$export(module.exports, "DescriptionWrapper", ()=>$cfab992fac525e86$export$2bf1f2b0d31b60fc);
    $parcel$export(module.exports, "Description", ()=>$cfab992fac525e86$export$393edc798c47379d);
    $parcel$export(module.exports, "ActionButtons", ()=>$cfab992fac525e86$export$88c65d2d98aab183);
    $parcel$export(module.exports, "WrappedButton", ()=>$cfab992fac525e86$export$44e087c32db6077d);
    $parcel$export(module.exports, "MoreButton", ()=>$cfab992fac525e86$export$7f94856880993f27);
    $parcel$export(module.exports, "LoadingWrapper", ()=>$cfab992fac525e86$export$43a792a870d28db2);
    $parcel$export(module.exports, "AccessLockSVGWrapper", ()=>$cfab992fac525e86$export$71bcd744fda975e5);
    var $k5uoT;
    var $3RZIb;
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $cfab992fac525e86$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $cfab992fac525e86$export$a443be8291b92497 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f414"
    })({
        name: "ck88l6",
        styles: "display:inherit"
    });
    const $cfab992fac525e86$export$6aa22a823032b784 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f413"
    })({
        backgroundColor: (0, $huHkE.bgColor),
        borderRadius: `${(0, (0, parcelRequire("k5uoT")).borderRadius)()}px`,
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale'
    });
    const $cfab992fac525e86$export$66ecf3d3b7b1c016 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f412"
    })({
        width: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 40}px`,
        position: 'relative'
    });
    const $cfab992fac525e86$export$5665775b26e26c5d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f411"
    })("background-color:", (props)=>props.isLoading ? `var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})` : props.image ? '' : (0, $huHkE.teamHeaderBgColor), ";background-image:", (props)=>props.image ? `url(${props.image})` : '', ";background-repeat:no-repeat;background-position:center;background-size:cover;box-sizing:content-box;height:", (0, (0, parcelRequire("k5uoT")).gridSize)() * 16, "px;");
    const $cfab992fac525e86$export$64ef9b8c11710c47 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f410"
    })({
        display: 'flex',
        flexDirection: 'column',
        padding: "var(--ds-space-300, 24px)",
        minHeight: `${(0, (0, parcelRequire("k5uoT")).gridSize)() * 13}px`
    });
    const $cfab992fac525e86$export$8fe6f0aed18a58c7 = (0, $bWGt6.default)("h6", {
        target: "e1kkd6f49"
    })((0, (0, parcelRequire("3RZIb")).h600), "text-transform:none;overflow:hidden;max-height:48px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
    const $cfab992fac525e86$export$1cbd03a20253b620 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f48"
    })({
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`,
        marginTop: "var(--ds-space-050, 4px)"
    });
    const $cfab992fac525e86$export$82a6f3ee677bdbfe = (0, $bWGt6.default)("div", {
        target: "e1kkd6f47"
    })({
        name: "li9rw7",
        styles: "margin-top:var(--ds-space-200, 16px);margin-left:var(--ds-space-negative-025, -2px)"
    });
    const $cfab992fac525e86$export$2bf1f2b0d31b60fc = (0, $bWGt6.default)("div", {
        target: "e1kkd6f46"
    })({
        name: "vi4bqq",
        styles: "margin-top:var(--ds-space-200, 16px);align-items:center;display:flex"
    });
    const $cfab992fac525e86$export$393edc798c47379d = (0, $bWGt6.default)("span", {
        target: "e1kkd6f45"
    })({
        name: "yog5y2",
        styles: "overflow:hidden;max-height:60px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical"
    });
    const $cfab992fac525e86$export$88c65d2d98aab183 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f44"
    })({
        width: 'calc(100% + 8px)',
        display: 'flex',
        justifyContent: 'space-between',
        margin: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-negative-300, -24px)"} 0 ${"var(--ds-space-negative-100, -8px)"}`,
        backgroundColor: "var(--ds-surface-overlay, hsla(0, 100%, 100%, 0.2))"
    });
    const $cfab992fac525e86$export$44e087c32db6077d = (0, $bWGt6.default)("div", {
        target: "e1kkd6f43"
    })({
        name: "1svotkm",
        styles: "flex-basis:0;flex-grow:1;margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$7f94856880993f27 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f42"
    })({
        name: "9kivhj",
        styles: "margin-left:var(--ds-space-100, 8px)"
    });
    const $cfab992fac525e86$export$43a792a870d28db2 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f41"
    })({
        name: "o13o72",
        styles: "text-align:center;margin-top:var(--ds-space-500, 40px)"
    });
    const $cfab992fac525e86$export$71bcd744fda975e5 = (0, $bWGt6.default)("div", {
        target: "e1kkd6f40"
    })({
        name: "ifz8jz",
        styles: "margin-bottom:var(--ds-space-300, 24px)"
    });
});
parcelRegister("drhKV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3602a6790b0d2a05$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hTEpF;
    var $9MMkr = parcelRequire("9MMkr");
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $fMbSw = parcelRequire("fMbSw");
    var $3602a6790b0d2a05$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'error', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.TeamForbiddenErrorStateWrapper), {
            "data-testid": "team-profilecard-forbidden-error-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            header: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateTitle),
            description: intl.formatMessage((0, $9MMkr.default).teamForbiddenErrorStateDescription),
            renderImage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.AccessLockSVGWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $fMbSw.default), null))
        }));
    };
});
parcelRegister("fMbSw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3cdb196cf5a3a60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $f3cdb196cf5a3a60$var$AccessLockSVG = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "191",
            height: "222",
            viewBox: "0 0 191 222",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            clipPath: "url(#clip0)"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white",
            fillOpacity: "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M122.7 119.9H49.4V36.9998C49.8906 27.6107 53.9659 18.7679 60.7854 12.2956C67.6048 5.82318 76.6481 2.21484 86.05 2.21484C95.4519 2.21484 104.495 5.82318 111.315 12.2956C118.134 18.7679 122.209 27.6107 122.7 36.9998V119.9ZM61.4 107.9H110.7V36.9998C110.301 30.7336 107.53 24.8546 102.951 20.5583C98.3722 16.2619 92.3289 13.8706 86.05 13.8706C79.7711 13.8706 73.7279 16.2619 69.149 20.5583C64.5701 24.8546 61.7993 30.7336 61.4 36.9998V107.9Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H19.1C18.348 59.2976 17.605 59.4639 16.9262 59.7874C16.2474 60.111 15.6503 60.5834 15.1794 61.1697C14.7085 61.7559 14.3758 62.4408 14.2063 63.1734C14.0367 63.906 14.0346 64.6675 14.2 65.401C17.9782 81.0252 15.9154 97.4916 8.4 111.701C2.5112 123.071 -0.389112 135.752 -0.0282299 148.551C0.332652 161.351 3.94288 173.848 10.463 184.868C16.9831 195.888 26.1988 205.069 37.2436 211.548C48.2884 218.026 60.7993 221.589 73.6 221.901H91.5C101.565 222.141 111.577 220.365 120.946 216.679C130.315 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601Z",
            fill: "#FF991F"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M154.7 65.501C154.883 64.7606 154.894 63.9882 154.733 63.2428C154.572 62.4974 154.242 61.7989 153.769 61.2005C153.296 60.6022 152.693 60.1199 152.005 59.7907C151.317 59.4615 150.563 59.2939 149.8 59.301H36.9C36.154 59.3157 35.4203 59.494 34.7507 59.8232C34.0812 60.1523 33.492 60.6244 33.0247 61.2061C32.5574 61.7878 32.2235 62.4649 32.0464 63.1897C31.8694 63.9146 31.8535 64.6694 32 65.401C35.8087 81.0131 33.7816 97.4789 26.3 111.701C20.3828 123.006 17.4891 135.648 17.9 148.401C18.9 188.401 51.5 220.901 91.5 221.901C101.565 222.141 111.577 220.365 120.946 216.679C130.314 212.992 138.851 207.469 146.054 200.434C153.257 193.399 158.979 184.995 162.886 175.715C166.792 166.436 168.803 156.469 168.8 146.401C168.86 134.28 165.941 122.33 160.3 111.601C152.848 97.4396 150.855 81.0347 154.7 65.501Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M93.4001 214H91.7001C80.2465 213.718 69.0525 210.53 59.1692 204.735C49.2859 198.939 41.0377 190.727 35.1991 180.87C29.3605 171.012 26.1231 159.832 25.7909 148.38C25.4587 136.928 28.0426 125.579 33.3001 115.4C41.036 100.558 43.5711 83.5517 40.5001 67.0996H146.2C143.017 83.4736 145.522 100.444 153.3 115.2C158.352 124.82 160.962 135.534 160.9 146.4C160.926 155.276 159.199 164.07 155.818 172.277C152.436 180.484 147.467 187.942 141.195 194.223C134.923 200.505 127.472 205.485 119.27 208.879C111.068 212.273 102.276 214.013 93.4001 214Z",
            fill: "#FFC400"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("g", {
            style: {
                mixBlendMode: 'multiply'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M152.8 178.6L84.5 119.6L80.8 123.9L149.9 183.5L152.8 178.6Z",
            fill: "#FFE380"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M90.4 170.601C88.3452 170.598 86.3155 170.15 84.4509 169.287C82.5862 168.424 80.9312 167.166 79.5999 165.601C78.2601 164.053 77.2786 162.229 76.7254 160.259C76.1722 158.288 76.0611 156.219 76.4 154.201L78.3 141.601C75.4643 138.69 73.5294 135.023 72.7277 131.039C71.926 127.055 72.2917 122.925 73.7808 119.144C75.2699 115.363 77.8191 112.093 81.122 109.726C84.4249 107.359 88.3411 105.996 92.4 105.801H93.4C98.996 105.801 104.363 108.024 108.32 111.981C112.277 115.938 114.5 121.305 114.5 126.901C114.496 132.416 112.302 137.703 108.4 141.601L110.4 154.201C110.692 156.226 110.548 158.291 109.979 160.257C109.41 162.222 108.428 164.044 107.1 165.601C105.769 167.166 104.114 168.424 102.249 169.287C100.384 170.15 98.3547 170.598 96.3 170.601H90.4Z",
            fill: "#FFAB00"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M106.6 126.9C106.586 128.711 106.196 130.499 105.456 132.151C104.716 133.803 103.641 135.284 102.3 136.5C101.574 137.222 101.032 138.107 100.719 139.081C100.405 140.056 100.33 141.091 100.5 142.1L102.6 155.4C102.728 156.305 102.662 157.226 102.405 158.103C102.147 158.979 101.706 159.79 101.109 160.482C100.512 161.173 99.7741 161.729 98.9446 162.112C98.1152 162.494 97.2134 162.695 96.3 162.7H90.4C89.4866 162.695 88.5848 162.494 87.7554 162.112C86.926 161.729 86.188 161.173 85.5912 160.482C84.9944 159.79 84.5526 158.979 84.2954 158.103C84.0382 157.226 83.9715 156.305 84.1 155.4L86.2 142C86.3747 140.983 86.2925 139.937 85.9607 138.959C85.6289 137.981 85.058 137.102 84.3 136.4C82.8962 135.116 81.7988 133.532 81.0892 131.767C80.3795 130.001 80.0756 128.099 80.2 126.2C80.2928 122.699 81.7726 119.379 84.3137 116.969C86.8548 114.559 90.2492 113.258 93.75 113.35C97.2509 113.443 100.571 114.923 102.981 117.464C105.391 120.005 106.693 123.399 106.6 126.9Z",
            fill: "#253858"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M149.2 130.901H93.4C92.8286 130.992 92.2443 130.959 91.6872 130.802C91.1302 130.645 90.6138 130.37 90.1736 129.994C89.7334 129.619 89.3799 129.152 89.1375 128.627C88.8951 128.102 88.7695 127.53 88.7695 126.951C88.7695 126.373 88.8951 125.801 89.1375 125.275C89.3799 124.75 89.7334 124.284 90.1736 123.908C90.6138 123.532 91.1302 123.257 91.6872 123.1C92.2443 122.944 92.8286 122.91 93.4 123.001H149.2C150.14 123.151 150.995 123.631 151.613 124.355C152.23 125.079 152.57 126 152.57 126.951C152.57 127.903 152.23 128.823 151.613 129.547C150.995 130.271 150.14 130.751 149.2 130.901Z",
            fill: "#0065FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M153.1 126.901C153.075 125.875 152.656 124.897 151.93 124.172C151.204 123.446 150.226 123.027 149.2 123.001H112.4C111.829 122.91 111.244 122.944 110.687 123.1C110.13 123.257 109.614 123.532 109.174 123.908C108.733 124.284 108.38 124.75 108.137 125.275C107.895 125.801 107.77 126.373 107.77 126.951C107.77 127.53 107.895 128.102 108.137 128.627C108.38 129.152 108.733 129.619 109.174 129.994C109.614 130.37 110.13 130.645 110.687 130.802C111.244 130.959 111.829 130.992 112.4 130.901H149.2C150.243 130.875 151.235 130.442 151.964 129.695C152.693 128.947 153.1 127.945 153.1 126.901Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M167.7 149.4C163.25 149.4 158.9 148.081 155.2 145.608C151.5 143.136 148.616 139.622 146.913 135.511C145.21 131.399 144.764 126.875 145.632 122.511C146.5 118.146 148.643 114.137 151.79 110.99C154.937 107.844 158.946 105.701 163.31 104.833C167.675 103.965 172.199 104.41 176.31 106.113C180.422 107.816 183.936 110.7 186.408 114.4C188.88 118.1 190.2 122.45 190.2 126.9C190.2 132.868 187.829 138.591 183.61 142.81C179.39 147.03 173.667 149.4 167.7 149.4ZM167.7 112.3C164.812 112.3 161.99 113.157 159.589 114.761C157.188 116.365 155.316 118.645 154.211 121.313C153.106 123.981 152.817 126.917 153.381 129.749C153.944 132.581 155.334 135.182 157.376 137.224C159.418 139.266 162.02 140.657 164.852 141.22C167.684 141.783 170.619 141.494 173.287 140.389C175.955 139.284 178.235 137.413 179.839 135.012C181.444 132.611 182.3 129.788 182.3 126.9C182.274 123.036 180.727 119.338 177.995 116.606C175.262 113.873 171.564 112.327 167.7 112.3Z",
            fill: "#2684FF"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M67.8 165.301H55.6C55.3423 165.278 55.1009 165.166 54.918 164.983C54.7351 164.8 54.6225 164.558 54.6 164.301C54.6 164.036 54.7053 163.781 54.8929 163.594C55.0804 163.406 55.3348 163.301 55.6 163.301H67.8C68.0652 163.301 68.3196 163.406 68.5071 163.594C68.6946 163.781 68.8 164.036 68.8 164.301C68.7775 164.558 68.6649 164.8 68.482 164.983C68.2991 165.166 68.0576 165.278 67.8 165.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M62.7999 182.5C62.6675 182.512 62.5342 182.491 62.412 182.438C62.2897 182.386 62.1825 182.304 62.0999 182.2C61.9167 182.013 61.8141 181.761 61.8141 181.5C61.8141 181.238 61.9167 180.987 62.0999 180.8L70.4999 172.3C70.6925 172.155 70.9307 172.085 71.1708 172.102C71.4109 172.119 71.6368 172.222 71.807 172.393C71.9773 172.563 72.0804 172.789 72.0974 173.029C72.1145 173.269 72.0444 173.507 71.8999 173.7L63.4999 182.2C63.3098 182.38 63.0616 182.486 62.7999 182.5Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M79.9 189.6C79.6424 189.577 79.4009 189.464 79.218 189.282C79.0351 189.099 78.9226 188.857 78.9 188.6V175.6C78.9226 175.342 79.0351 175.1 79.218 174.918C79.4009 174.735 79.6424 174.622 79.9 174.6C80.1652 174.6 80.4196 174.705 80.6071 174.893C80.7947 175.08 80.9 175.334 80.9 175.6V188.6C80.9 188.865 80.7947 189.119 80.6071 189.307C80.4196 189.494 80.1652 189.6 79.9 189.6Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M128.8 111.301H116.7C116.565 111.317 116.428 111.302 116.299 111.257C116.17 111.213 116.054 111.14 115.957 111.043C115.861 110.947 115.788 110.83 115.743 110.702C115.699 110.573 115.684 110.436 115.7 110.301C115.7 110.036 115.805 109.781 115.993 109.594C116.18 109.406 116.435 109.301 116.7 109.301H128.8C129.065 109.301 129.32 109.406 129.507 109.594C129.695 109.781 129.8 110.036 129.8 110.301C129.816 110.436 129.801 110.573 129.757 110.702C129.712 110.83 129.639 110.947 129.543 111.043C129.446 111.14 129.33 111.213 129.201 111.257C129.072 111.302 128.935 111.317 128.8 111.301Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M113.2 102.601C112.938 102.587 112.69 102.481 112.5 102.301C112.317 102.114 112.214 101.863 112.214 101.601C112.214 101.339 112.317 101.088 112.5 100.901L121 92.5008C121.193 92.3563 121.431 92.2862 121.671 92.3033C121.911 92.3204 122.137 92.4235 122.307 92.5937C122.477 92.7639 122.58 92.9898 122.597 93.2299C122.615 93.47 122.544 93.7082 122.4 93.9008L113.9 102.301C113.812 102.399 113.704 102.477 113.583 102.528C113.462 102.58 113.331 102.605 113.2 102.601Z",
            fill: "#FFFAE5"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M104.5 100C104.235 100 103.98 99.8947 103.793 99.7072C103.605 99.5196 103.5 99.2653 103.5 99.0001V86.1C103.5 85.8348 103.605 85.5805 103.793 85.3929C103.98 85.2054 104.235 85.1 104.5 85.1C104.635 85.084 104.772 85.0988 104.901 85.1433C105.03 85.1879 105.146 85.2611 105.243 85.3574C105.339 85.4536 105.412 85.5705 105.457 85.6991C105.501 85.8278 105.516 85.9649 105.5 86.1V99.0001C105.516 99.1352 105.501 99.2723 105.457 99.401C105.412 99.5296 105.339 99.6465 105.243 99.7428C105.146 99.839 105.03 99.9122 104.901 99.9568C104.772 100.001 104.635 100.016 104.5 100Z",
            fill: "#FFFAE5"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("defs", null, (0, ($parcel$interopDefault($5uXOq))).createElement("clipPath", {
            id: "clip0"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M0 0.400391H190.2V221.9H0V0.400391Z",
            fill: "white"
        }))));
    };
    var $f3cdb196cf5a3a60$export$2e2bcd8739ae039 = $f3cdb196cf5a3a60$var$AccessLockSVG;
});
parcelRegister("devOt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d55bb5393d16af5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $iE5Av = parcelRequire("iE5Av");
    var $ivXTE = parcelRequire("ivXTE");
    var $7d55bb5393d16af5$export$2e2bcd8739ae039 = (props)=>{
        const { analytics: analytics } = props;
        (0, $5uXOq.useEffect)(()=>{
            analytics((duration)=>(0, $ivXTE.profileCardRendered)('team', 'spinner', {
                    duration: duration
                }));
        }, [
            analytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardWrapper), {
            "data-testid": "team-profilecard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardHeader), {
            isLoading: true
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iE5Av.LoadingWrapper), {
            "data-testid": "team-profilecard-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null))));
    };
});
parcelRegister("lrMir", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "ProfilecardInternal", ()=>$4585e7f6ae851e43$export$64e0275ede8ab792);
    $parcel$export(module.exports, "default", ()=>$4585e7f6ae851e43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $cb25w;
    var $ujWmd;
    var $fVnbM;
    var $jhVLw;
    var $eZJjh;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $dv9z3 = parcelRequire("dv9z3");
    var $6TKEY = parcelRequire("6TKEY");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $jHIf5 = parcelRequire("jHIf5");
    var $cfBc7 = parcelRequire("cfBc7");
    const $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID = 'give-kudos';
    const $4585e7f6ae851e43$var$useKudos = (cloudId, userId, teamCentralBaseUrl, openKudosDrawer)=>{
        const kudosUrl = (0, $5uXOq.useMemo)(()=>{
            const recipientId = userId ? `&recipientId=${userId}` : '';
            const cloudIdParam = cloudId ? `&cloudId=${cloudId}` : '';
            return `${teamCentralBaseUrl || ''}/kudos/give?type=individual${recipientId}${cloudIdParam}`;
        }, [
            cloudId,
            teamCentralBaseUrl,
            userId
        ]);
        const kudosButtonCallback = (0, $5uXOq.useCallback)(()=>{
            if (openKudosDrawer) openKudosDrawer();
            else window.open(kudosUrl);
        }, [
            kudosUrl,
            openKudosDrawer
        ]);
        const kudosAction = (0, $5uXOq.useMemo)(()=>{
            return {
                label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).giveKudosButton),
                id: $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID,
                callback: kudosButtonCallback,
                link: kudosUrl
            };
        }, [
            kudosButtonCallback,
            kudosUrl
        ]);
        return {
            kudosAction: kudosAction,
            kudosButtonCallback: kudosButtonCallback,
            kudosUrl: kudosUrl
        };
    };
    const $4585e7f6ae851e43$var$Wrapper = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testid": "profilecard",
            role: "dialog",
            "aria-labelledby": "profilecard-name-label"
        }, props.children);
    const $4585e7f6ae851e43$export$64e0275ede8ab792 = (props)=>{
        const [openTime] = (0, $5uXOq.useState)((0, $6TKEY.getPageTime)());
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const fireAnalyticsWithDuration = (0, $5uXOq.useCallback)((generator)=>{
            const elapsed = (0, $6TKEY.getPageTime)() - openTime;
            const event = generator(elapsed);
            fireAnalytics(event);
        }, [
            fireAnalytics,
            openTime
        ]);
        const { kudosAction: kudosAction } = $4585e7f6ae851e43$var$useKudos(props.cloudId, props.userId, props.teamCentralBaseUrl, props.openKudosDrawer);
        const { actions: actions = [], isCurrentUser: isCurrentUser, isKudosEnabled: isKudosEnabled, status: status = 'active' } = props;
        const realActions = (0, $5uXOq.useMemo)(()=>{
            if (isCurrentUser || !isKudosEnabled || status !== 'active') return actions;
            return actions.concat([
                kudosAction
            ]);
        }, [
            actions,
            isCurrentUser,
            isKudosEnabled,
            kudosAction,
            status
        ]);
        const { isLoading: isLoading, fullName: fullName, hasError: hasError } = props;
        const canRender = !hasError && !isLoading && !!(fullName || status === 'closed');
        (0, $5uXOq.useEffect)(()=>{
            if (canRender) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'content', {
                    duration: duration,
                    numActions: realActions.length
                }));
        }, [
            canRender,
            fireAnalyticsWithDuration,
            realActions
        ]);
        if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: props.clientFetchProfile,
            errorType: props.errorType || null,
            fireAnalytics: fireAnalytics
        }));
        if (isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$LoadingView, {
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }));
        if (!canRender) return null;
        const isDisabledUser = status === 'inactive' || status === 'closed';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContainer), {
            isDisabledUser: isDisabledUser,
            withoutElevation: props.withoutElevation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ProfileImage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xlarge",
            src: status !== 'closed' ? props.avatarUrl : undefined,
            borderColor: `var(--ds-shadow-overlay, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardContent), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cfBc7.ProfileCardDetails), {
            ...props,
            status: status,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration
        }), realActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionsFlexSpacer), null), (0, ($parcel$interopDefault($5uXOq))).createElement($4585e7f6ae851e43$var$Actions, {
            actions: realActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            isTriggeredUsingKeyboard: props.isTriggeredUsingKeyboard
        })))));
    };
    const $4585e7f6ae851e43$var$Actions = ({ actions: actions, fireAnalyticsWithDuration: fireAnalyticsWithDuration, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard })=>{
        const onActionClick = (0, $5uXOq.useCallback)((action, args, event, index)=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.actionClicked)('user', {
                    duration: duration,
                    hasHref: !!action.link,
                    hasOnClick: !!action.callback,
                    index: index,
                    actionId: action.id || 'no-id-specified'
                }));
            if (action.callback && (0, $dv9z3.isBasicClick)(event)) {
                event.preventDefault();
                action.callback(event, ...args);
            }
        }, [
            fireAnalyticsWithDuration
        ]);
        if (!actions || actions.length === 0) return null;
        const regularActions = actions.slice(0, (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD));
        const overflowActions = actions.length > (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD) ? actions.slice((0, $jHIf5.ACTION_OVERFLOW_THRESHOLD)) : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.ActionButtonGroup), {
            "data-testid": "profilecard-actions"
        }, regularActions.map((action, index)=>{
            const isKudos = action.id === $4585e7f6ae851e43$var$GIVE_KUDOS_ACTION_ID;
            const button = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
                isInset: true,
                key: `profile-card-action-focus-ring_${action.id || index}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "default",
                key: action.id || index,
                onClick: (event, ...args)=>onActionClick(action, args, event, index),
                href: action.link,
                autoFocus: index === 0 && isTriggeredUsingKeyboard
            }, action.label, isKudos && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimationWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.KudosBlobAnimation), null))));
            if (isKudos) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AnimatedKudosButton), {
                key: `profile-card-action-kudos_${action.id || index}`
            }, button);
            return button;
        }), overflowActions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jHIf5.OverflowProfileCardButtons), {
            actions: overflowActions,
            fireAnalyticsWithDuration: fireAnalyticsWithDuration,
            onItemClick: (action, args, event, index)=>onActionClick(action, args, event, index + (0, $jHIf5.ACTION_OVERFLOW_THRESHOLD))
        }));
    };
    const $4585e7f6ae851e43$var$LoadingView = ({ fireAnalyticsWithDuration: fireAnalyticsWithDuration })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalyticsWithDuration((duration)=>(0, $ivXTE.profileCardRendered)('user', 'spinner', {
                    duration: duration
                }));
        }, [
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), {
            "data-testid": "profilecard-spinner-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $4585e7f6ae851e43$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($4585e7f6ae851e43$export$64e0275ede8ab792);
});
parcelRegister("jHIf5", function(module, exports) {
    $parcel$export(module.exports, "ACTION_OVERFLOW_THRESHOLD", ()=>$c3d6d65db2db7a42$export$3e2419a7546ad45e);
    $parcel$export(module.exports, "OverflowProfileCardButtons", ()=>$c3d6d65db2db7a42$export$9d9b53d23c0df7a1);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $9yOBd;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $bJeNF;
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $c3d6d65db2db7a42$export$3e2419a7546ad45e = 2;
    const $c3d6d65db2db7a42$export$9d9b53d23c0df7a1 = (props)=>{
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const [, setOpen] = (0, $5uXOq.useState)(false);
        const { actions: actions, onItemClick: onItemClick, fireAnalyticsWithDuration: fireAnalyticsWithDuration } = props;
        const numActions = actions.length + $c3d6d65db2db7a42$export$3e2419a7546ad45e;
        const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: nextOpen })=>{
            setOpen((prevOpen)=>{
                if (nextOpen && !prevOpen) fireAnalyticsWithDuration((duration)=>(0, $ivXTE.moreActionsClicked)('user', {
                        duration: duration,
                        numActions: numActions
                    }));
                return nextOpen;
            });
        }, [
            numActions,
            fireAnalyticsWithDuration
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.OverflowActionButtonsWrapper), {
            "data-testid": "profilecard-actions-overflow"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            onOpenChange: onOpenChange,
            placement: 'bottom-end',
            trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
                    type: "button",
                    ...providedProps,
                    ref: triggerRef,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bJeNF"))))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: intl.formatMessage((0, $9MMkr.default).profileCardMoreIconLabel)
                    })
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, actions.map((action, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
                key: action.id,
                onClick: (event, ...args)=>{
                    onItemClick(action, args, event, index);
                },
                href: action.link
            }, action.label)))));
    };
});
parcelRegister("cfBc7", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardDetails", ()=>$5c33ece4bf360f1e$export$c0e6870b898eb99d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $lj8SI;
    var $VSDnB;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $hljsi = parcelRequire("hljsi");
    var $9MMkr = parcelRequire("9MMkr");
    var $jnj6z = parcelRequire("jnj6z");
    parcelRequire("kyz3w");
    var $kXUaX = parcelRequire("kXUaX");
    var $htJ3O = parcelRequire("htJ3O");
    const $5c33ece4bf360f1e$var$detailedListWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        margin: 'space.0',
        padding: 'space.0'
    });
    const $5c33ece4bf360f1e$var$fullNameLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        letterSpacing: 'normal',
        lineHeight: `${24 / 18}em`
    });
    const $5c33ece4bf360f1e$var$noMetaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.400',
        marginRight: '0',
        marginBottom: 'space.150',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$metaLabelStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.150',
        marginRight: '0',
        marginBottom: '0',
        marginLeft: '0'
    });
    const $5c33ece4bf360f1e$var$disabledAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text'
    });
    const $5c33ece4bf360f1e$var$activeAccountStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text.inverse'
    });
    const $5c33ece4bf360f1e$var$renderName = (nickname, fullName, meta)=>{
        if (!fullName && !nickname) return null;
        const isNicknameRedundant = !nickname || nickname === fullName;
        const shownNickname = ` (${nickname}) `;
        const displayName = isNicknameRedundant ? fullName : `${fullName}${shownNickname}`;
        if ((0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$activeAccountStyles,
                meta ? $5c33ece4bf360f1e$var$metaLabelStyles : $5c33ece4bf360f1e$var$noMetaLabelStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: !meta,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, displayName);
    };
    const $5c33ece4bf360f1e$var$disabledAccountDesc = (statusModifiedDate, disabledAccountMessage, status = 'closed')=>{
        if (disabledAccountMessage) return disabledAccountMessage;
        const date = statusModifiedDate ? new Date(statusModifiedDate * 1000) : null;
        const relativeDateKey = (0, $hljsi.default)(date);
        const msgKey = relativeDateKey ? `${status}AccountDescMsgHasDate${relativeDateKey}` : `${status}AccountDescMsgNoDate`;
        const secondSentence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default)[msgKey]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p",
            testId: "profilecard-disabled-account"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).generalDescMsgForDisabledUser), " ", secondSentence);
    };
    const $5c33ece4bf360f1e$var$CustomLozenges = ({ lozenges: lozenges = [] })=>{
        if (lozenges.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CustomLozengeContainer), null, lozenges.map(({ text: text, ...otherProps }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                ...otherProps,
                key: index
            }, text)));
    };
    const $5c33ece4bf360f1e$var$BotProfileCardDetails = (props)=>{
        const { fullName: fullName, nickname: nickname } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(nickname, fullName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.AppTitleLabel), null, "App"));
    };
    const $5c33ece4bf360f1e$var$DisabledProfileCardDetails = (props)=>{
        const { companyName: companyName, disabledAccountMessage: disabledAccountMessage, fullName: fullName, hasDisabledAccountLozenge: hasDisabledAccountLozenge = true, nickname: nickname, status: status, statusModifiedDate: statusModifiedDate } = props;
        const name = status === 'inactive' ? fullName || nickname : nickname || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).disabledAccountDefaultName);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $5c33ece4bf360f1e$var$fullNameLabelStyles,
                $5c33ece4bf360f1e$var$noMetaLabelStyles,
                $5c33ece4bf360f1e$var$disabledAccountStyles
            ],
            testId: "profilecard-name",
            id: "profilecard-name-label"
        }, name) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.FullNameLabel), {
            noMeta: true,
            isDisabledAccount: true,
            "data-testid": "profilecard-name",
            id: "profilecard-name-label"
        }, name), hasDisabledAccountLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.LozengeWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "default",
            isBold: true
        }, status === 'inactive' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).inactiveAccountMsg) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).closedAccountMsg))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DisabledInfo), null, $5c33ece4bf360f1e$var$disabledAccountDesc(statusModifiedDate, disabledAccountMessage, status)), status === 'inactive' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, companyName));
    };
    const $5c33ece4bf360f1e$export$c0e6870b898eb99d = (props)=>{
        const { meta: meta, status: status } = props;
        if (props.isBot) return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$BotProfileCardDetails, props);
        if (status === 'inactive' || status === 'closed') return (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$DisabledProfileCardDetails, {
            ...props,
            status: status
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsGroup), null, $5c33ece4bf360f1e$var$renderName(props.nickname, props.fullName, meta), meta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.JobTitleLabel), null, meta), (0, ($parcel$interopDefault($5uXOq))).createElement($5c33ece4bf360f1e$var$CustomLozenges, {
            lozenges: props.customLozenges
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            as: "dl",
            xcss: $5c33ece4bf360f1e$var$detailedListWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "email"
        }, props.email), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "time"
        }, props.timestring), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "companyName"
        }, props.companyName), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kXUaX.default), {
            icon: "location"
        }, props.location)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $htJ3O.default), {
            reportingLines: props.reportingLines,
            reportingLinesProfileUrl: props.reportingLinesProfileUrl,
            onReportingLinesClick: props.onReportingLinesClick,
            fireAnalyticsWithDuration: props.fireAnalyticsWithDuration
        }));
    };
});
parcelRegister("hljsi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a208e25df4a65e86$export$2e2bcd8739ae039);
    var $kMWS1;
    var $f0lG8;
    var $ki4Ey;
    var $jovBr;
    function $a208e25df4a65e86$export$c03bb0116ee09d4b(date, today = new Date()) {
        return !!date.getTime && (0, (0, parcelRequire("jovBr")).default)(date) && date.getTime() <= today.getTime();
    }
    function $a208e25df4a65e86$export$2e2bcd8739ae039(date, today = new Date()) {
        if (!date || !$a208e25df4a65e86$export$c03bb0116ee09d4b(date, today)) return null;
        if ((0, (0, parcelRequire("ki4Ey")).default)(date)) return 'ThisWeek';
        if ((0, (0, parcelRequire("f0lG8")).default)(date)) return 'ThisMonth';
        if (date.getFullYear() === today.getFullYear() && date.getMonth() === today.getMonth() - 1) return 'LastMonth';
        const diffInMonths = (0, (0, parcelRequire("kMWS1")).default)(today, date);
        if (diffInMonths < 6) return 'AFewMonths';
        if (diffInMonths <= 12) return 'SeveralMonths';
        return 'MoreThanAYear';
    }
});
parcelRegister("kyz3w", function(module, exports) {
    $parcel$export(module.exports, "IconLabel", ()=>(parcelRequire("kXUaX")).default);
    var $kXUaX = parcelRequire("kXUaX");
});
parcelRegister("kXUaX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fd3f55567e0e46d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8yYK6;
    var $aVnO1;
    var $cKlYO;
    var $jRceo;
    var $jnj6z = parcelRequire("jnj6z");
    const $9fd3f55567e0e46d$var$icons = {
        location: (0, ($parcel$interopDefault((0, parcelRequire("cKlYO"))))),
        time: (0, ($parcel$interopDefault((0, parcelRequire("8yYK6"))))),
        email: (0, ($parcel$interopDefault((0, parcelRequire("aVnO1"))))),
        companyName: (0, ($parcel$interopDefault((0, parcelRequire("jRceo")))))
    };
    class $9fd3f55567e0e46d$export$2e2bcd8739ae039 extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                icon: ''
            };
        }
        render() {
            if (!this.props.children) return null;
            const IconElement = this.props.icon && $9fd3f55567e0e46d$var$icons[this.props.icon];
            const displayIcon = IconElement ? (0, ($parcel$interopDefault($5uXOq))).createElement(IconElement, {
                label: `${this.props.icon}`,
                LEGACY_size: "small",
                color: "currentColor"
            }) : null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabel), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelIcon), {
                as: "dt"
            }, displayIcon), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.DetailsLabelText), {
                as: "dd"
            }, this.props.children));
        }
    }
});
parcelRegister("8yYK6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $63c09dee2c4be134$var$_react = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $63c09dee2c4be134$var$_clock = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("hyKRO")));
    var $63c09dee2c4be134$var$_recent = $63c09dee2c4be134$var$_interopRequireDefault((parcelRequire("5IlYG")));
    function $63c09dee2c4be134$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $63c09dee2c4be134$var$ClockIcon = (props)=>$63c09dee2c4be134$var$_react.default.createElement($63c09dee2c4be134$var$_clock.default, Object.assign({
            LEGACY_fallbackIcon: $63c09dee2c4be134$var$_recent.default
        }, props));
    $63c09dee2c4be134$var$ClockIcon.Name = 'ClockIconMigration';
    var $63c09dee2c4be134$var$_default = module.exports.default = $63c09dee2c4be134$var$ClockIcon;
});
parcelRegister("cKlYO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $947ad4a84d881cd0$var$_react = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $947ad4a84d881cd0$var$_location = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("d3xMd")));
    var $947ad4a84d881cd0$var$_location2 = $947ad4a84d881cd0$var$_interopRequireDefault((parcelRequire("773gM")));
    function $947ad4a84d881cd0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $947ad4a84d881cd0$var$LocationIcon = (props)=>$947ad4a84d881cd0$var$_react.default.createElement($947ad4a84d881cd0$var$_location.default, Object.assign({
            LEGACY_fallbackIcon: $947ad4a84d881cd0$var$_location2.default
        }, props));
    $947ad4a84d881cd0$var$LocationIcon.Name = 'LocationIconMigration';
    var $947ad4a84d881cd0$var$_default = module.exports.default = $947ad4a84d881cd0$var$LocationIcon;
});
parcelRegister("d3xMd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9815c17f4ba43822$var$_react = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9815c17f4ba43822$var$_UNSAFE_baseNew = $9815c17f4ba43822$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $9815c17f4ba43822$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9815c17f4ba43822$var$LocationIcon = (props)=>$9815c17f4ba43822$var$_react.default.createElement($9815c17f4ba43822$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.677 8.982 8 15.25l4.323-6.268C14.725 5.5 12.232.75 8 .75c-4.231 0-6.725 4.749-4.323 8.232Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M9.75 6a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"/>`
        }, props));
    $9815c17f4ba43822$var$LocationIcon.displayName = 'LocationIcon';
    var $9815c17f4ba43822$var$_default = module.exports.default = $9815c17f4ba43822$var$LocationIcon;
});
parcelRegister("773gM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $52dbb9250ec5d302$var$_react = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $52dbb9250ec5d302$var$_location = $52dbb9250ec5d302$var$_interopRequireDefault((parcelRequire("d3xMd")));
    function $52dbb9250ec5d302$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $52dbb9250ec5d302$var$LocationIcon = (props)=>$52dbb9250ec5d302$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21c-2.28 0-6-8.686-6-12a6 6 0 1 1 12 0c0 3.314-3.72 12-6 12m0-9a2.912 2.912 0 1 0 0-5.824A2.912 2.912 0 0 0 12 12"/></svg>`
        }, props, {
            newIcon: $52dbb9250ec5d302$var$_location.default
        }));
    $52dbb9250ec5d302$var$LocationIcon.displayName = 'LocationIcon';
    var $52dbb9250ec5d302$var$_default = module.exports.default = $52dbb9250ec5d302$var$LocationIcon;
});
parcelRegister("jRceo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e74c746303d0418a$var$_react = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $e74c746303d0418a$var$_officeBuilding = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    var $e74c746303d0418a$var$_officeBuilding2 = $e74c746303d0418a$var$_interopRequireDefault((parcelRequire("icDh5")));
    function $e74c746303d0418a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e74c746303d0418a$var$OfficeBuildingIcon = (props)=>$e74c746303d0418a$var$_react.default.createElement($e74c746303d0418a$var$_officeBuilding.default, Object.assign({
            LEGACY_fallbackIcon: $e74c746303d0418a$var$_officeBuilding2.default
        }, props));
    $e74c746303d0418a$var$OfficeBuildingIcon.Name = 'OfficeBuildingIconMigration';
    var $e74c746303d0418a$var$_default = module.exports.default = $e74c746303d0418a$var$OfficeBuildingIcon;
});
parcelRegister("4bTdk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $30d304d6d8375db3$var$_react = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $30d304d6d8375db3$var$_UNSAFE_baseNew = $30d304d6d8375db3$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $30d304d6d8375db3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $30d304d6d8375db3$var$OfficeBuildingIcon = (props)=>$30d304d6d8375db3$var$_react.default.createElement($30d304d6d8375db3$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.25 15.25V2c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v13.25m10.5 0h-3.5m3.5 0H15m-12.25 0h3.5m-3.5 0H1m4-11.5h2m2 0h2m0 3H9m-2 0H5m1.25 8.5v-4.5h3.5v4.5m-3.5 0h3.5"/>`
        }, props));
    $30d304d6d8375db3$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $30d304d6d8375db3$var$_default = module.exports.default = $30d304d6d8375db3$var$OfficeBuildingIcon;
});
parcelRegister("icDh5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d407d01834f2f44a$var$_react = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d407d01834f2f44a$var$_officeBuilding = $d407d01834f2f44a$var$_interopRequireDefault((parcelRequire("4bTdk")));
    function $d407d01834f2f44a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d407d01834f2f44a$var$OfficeBuildingIcon = (props)=>$d407d01834f2f44a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6H5.009C3.902 6 3 6.962 3 8.15v10.7C3 20.04 3.9 21 5.009 21h5.487H8v-2.145c-1.616-.001-3-.003-3-.004 0 0 .005-10.708.009-10.708L8 8.144z"/><path d="M12 7h2v2h-2zm-6 3h2v2H6zm0 3h2v2H6zm6-3h2v2h-2zm0 3h2v2h-2zm2 3h2v3h-2zm2-9h2v2h-2zm0 3h2v2h-2zm0 3h2v2h-2z"/><path fill-rule="nonzero" d="M18.991 19C18.998 19 19 4.995 19 4.995c0 .006-7.991.005-7.991.005C11.002 5 11 19 11 19zM9 4.995C9 3.893 9.902 3 11.009 3h7.982C20.101 3 21 3.893 21 4.995v14.01A2.004 2.004 0 0 1 18.991 21H9z"/></g></svg>`
        }, props, {
            newIcon: $d407d01834f2f44a$var$_officeBuilding.default
        }));
    $d407d01834f2f44a$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
    var $d407d01834f2f44a$var$_default = module.exports.default = $d407d01834f2f44a$var$OfficeBuildingIcon;
});
parcelRegister("htJ3O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b7034dd6b25e87bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $ujWmd;
    var $jnhNB;
    var $fVnbM;
    var $VSDnB;
    var $dC5iT;
    var $8CUq3;
    var $9MMkr = parcelRequire("9MMkr");
    var $aLmg4 = parcelRequire("aLmg4");
    var $ivXTE = parcelRequire("ivXTE");
    function $b7034dd6b25e87bb$var$getProfileHref(userId, profileUrl) {
        return profileUrl ? profileUrl + userId : undefined;
    }
    const $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.text',
        font: 'font.heading.xxsmall',
        fontWeight: 600,
        marginBottom: 'space.100'
    });
    const $b7034dd6b25e87bb$var$reportingLinesHeadingStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: '0'
    });
    const $b7034dd6b25e87bb$var$ReportingLinesDetails = (props)=>{
        const { fireAnalyticsWithDuration: fireAnalyticsWithDuration, reportingLines: reportingLines = {}, reportingLinesProfileUrl: reportingLinesProfileUrl, onReportingLinesClick: onReportingLinesClick } = props;
        const { managers: managers = [], reports: reports = [] } = reportingLines;
        const manager = managers.length >= 1 ? managers[0] : undefined;
        const hasReports = reports.length > 0;
        const getReportingLinesOnClick = (user, userType)=>onReportingLinesClick ? ()=>{
                fireAnalyticsWithDuration((duration)=>(0, $ivXTE.reportingLinesClicked)({
                        duration: duration,
                        userType: userType
                    }));
                onReportingLinesClick(user);
            } : undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, manager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: [
                $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles,
                $b7034dd6b25e87bb$var$reportingLinesHeadingStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), {
            style: {
                marginBottom: 0
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).managerSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.OffsetWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle",
            spacing: "none",
            href: $b7034dd6b25e87bb$var$getProfileHref(manager.accountIdentifier, reportingLinesProfileUrl),
            onClick: getReportingLinesOnClick(manager, 'manager'),
            isDisabled: !onReportingLinesClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerSection), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ujWmd")).default), {
            size: "xsmall",
            src: manager.pii?.picture
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ManagerName), null, manager.pii?.name))))), hasReports && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesSection), null, (0, (0, parcelRequire("VSDnB")).fg)('platform_profile_card_css_refactor') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $b7034dd6b25e87bb$var$reportingLinesHeadingDefaultStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $aLmg4.ReportingLinesHeading), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, $9MMkr.default).directReportsSectionHeading)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            appearance: "stack",
            size: "small",
            data: reports.map((member)=>{
                return {
                    key: member.accountIdentifier,
                    name: member.pii?.name || '',
                    src: member.pii?.picture,
                    href: $b7034dd6b25e87bb$var$getProfileHref(member.accountIdentifier, reportingLinesProfileUrl),
                    onClick: getReportingLinesOnClick(member, 'direct-report')
                };
            }),
            maxCount: 5,
            testId: "profilecard-reports-avatar-group"
        })));
    };
    var $b7034dd6b25e87bb$export$2e2bcd8739ae039 = $b7034dd6b25e87bb$var$ReportingLinesDetails;
});
parcelRegister("aLmg4", function(module, exports) {
    $parcel$export(module.exports, "ReportingLinesSection", ()=>$feff5fbdc7496043$export$ae48ddd79a45b949);
    $parcel$export(module.exports, "ReportingLinesHeading", ()=>$feff5fbdc7496043$export$abdd342d30bb5b5f);
    $parcel$export(module.exports, "ManagerSection", ()=>$feff5fbdc7496043$export$2992b481dad9fb03);
    $parcel$export(module.exports, "ManagerName", ()=>$feff5fbdc7496043$export$98f8ec89e658b052);
    $parcel$export(module.exports, "OffsetWrapper", ()=>$feff5fbdc7496043$export$56eae56612ce5f3);
    var $huHkE = parcelRequire("huHkE");
    var $bWGt6 = parcelRequire("bWGt6");
    function $feff5fbdc7496043$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $feff5fbdc7496043$export$ae48ddd79a45b949 = (0, $bWGt6.default)("div", {
        target: "e11fux8a4"
    })({
        name: "1m5erzj",
        styles: "margin-left:var(--ds-space-050, 4px);margin-top:var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$abdd342d30bb5b5f = (0, $bWGt6.default)("h3", {
        target: "e11fux8a3"
    })({
        color: (0, $huHkE.appLabelTextColor),
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        marginBottom: "var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$2992b481dad9fb03 = (0, $bWGt6.default)("div", {
        target: "e11fux8a2"
    })({
        display: 'flex',
        alignItems: 'center',
        margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $feff5fbdc7496043$export$98f8ec89e658b052 = (0, $bWGt6.default)("span", {
        target: "e11fux8a1"
    })({
        name: "1y3q7as",
        styles: "font:var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-left:var(--ds-space-100, 8px)"
    });
    const $feff5fbdc7496043$export$56eae56612ce5f3 = (0, $bWGt6.default)("div", {
        target: "e11fux8a0"
    })({
        name: "ysolxb",
        styles: "margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-negative-050, -4px)"
    });
});
parcelRegister("d4FHw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e50495f0c6da843b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb25w;
    var $adIkV;
    var $gH4E9;
    var $4sfdL = parcelRequire("4sfdL");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    parcelRequire("geGTf");
    var $cI0Td = parcelRequire("cI0Td");
    var $lrMir = parcelRequire("lrMir");
    var $ifxzB = parcelRequire("ifxzB");
    class $e50495f0c6da843b$var$ProfileCardResourced extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.defaultProps = {
                actions: []
            };
        }
        componentDidMount() {
            this._isMounted = true;
            this.clientFetchProfile();
        }
        componentDidUpdate(prevProps) {
            const { userId: userId, cloudId: cloudId, resourceClient: resourceClient } = this.props;
            if (userId !== prevProps.userId || cloudId !== prevProps.cloudId || resourceClient !== prevProps.resourceClient) this.setState({
                isLoading: undefined
            }, this.clientFetchProfile);
        }
        componentWillUnmount() {
            this._isMounted = false;
        }
        handleClientSuccess(profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: false,
                data: profileData,
                reportingLinesData: reportingLinesData,
                isKudosEnabled: shouldShowGiveKudos,
                teamCentralBaseUrl: teamCentralBaseUrl
            });
        }
        handleClientError(err) {
            if (!this._isMounted) return;
            this.setState({
                isLoading: false,
                hasError: true,
                error: err
            });
        }
        render() {
            const { isLoading: isLoading, hasError: hasError, error: error, data: data, reportingLinesData: reportingLinesData, isKudosEnabled: isKudosEnabled, teamCentralBaseUrl: teamCentralBaseUrl } = this.state;
            const { onReportingLinesClick: onReportingLinesClick, cloudId: cloudId, userId: userId, addFlag: addFlag } = this.props;
            const isFetchingOrNotStartToFetchYet = isLoading === true || isLoading === undefined;
            if (isFetchingOrNotStartToFetchYet) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
                fireAnalytics: this.fireAnalytics
            }));
            else if (hasError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
                "data-testid": "profile-card-resourced-error-state"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
                errorType: error,
                reload: this.clientFetchProfile,
                fireAnalytics: this.fireAnalytics
            }));
            const newProps = {
                hasError: hasError,
                errorType: error,
                clientFetchProfile: this.clientFetchProfile,
                reportingLines: reportingLinesData,
                onReportingLinesClick: onReportingLinesClick,
                cloudId: cloudId,
                userId: userId,
                addFlag: addFlag,
                ...data,
                isKudosEnabled: isKudosEnabled,
                teamCentralBaseUrl: teamCentralBaseUrl,
                openKudosDrawer: this.openKudosDrawer
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isKudosEnabled && newProps.teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
                isOpen: this.state.kudosDrawerOpen,
                recipient: {
                    type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                    recipientId: this.props.userId
                },
                analyticsSource: "profile-card",
                teamCentralBaseUrl: newProps.teamCentralBaseUrl,
                cloudId: this.props.cloudId,
                addFlag: this.props.addFlag,
                onClose: this.closeKudosDrawer
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, $lrMir.default), {
                ...newProps,
                actions: this.filterActions()
            })));
        }
        constructor(...args){
            super(...args), this._isMounted = false, this.state = {
                visible: false,
                isLoading: undefined,
                hasError: false,
                error: null,
                data: null,
                reportingLinesData: undefined,
                isKudosEnabled: false,
                kudosDrawerOpen: false,
                teamCentralBaseUrl: undefined
            }, this.fireAnalytics = (payload)=>{
                if (!this._isMounted) return;
                if (this.props.createAnalyticsEvent) (0, $ivXTE.fireEvent)(this.props.createAnalyticsEvent, payload);
            }, this.clientFetchProfile = ()=>{
                const { cloudId: cloudId, userId: userId } = this.props;
                const { isLoading: isLoading } = this.state;
                if (isLoading === true) return;
                this.setState({
                    isLoading: true,
                    hasError: false,
                    data: null
                }, ()=>{
                    const requests = Promise.all([
                        this.props.resourceClient.getProfile(cloudId, userId, this.fireAnalytics),
                        this.props.resourceClient.getReportingLines(userId),
                        this.props.resourceClient.shouldShowGiveKudos(),
                        this.props.resourceClient.getTeamCentralBaseUrl({
                            withOrgContext: true,
                            withSiteContext: true
                        })
                    ]);
                    requests.then((res)=>this.handleClientSuccess(...res), (err)=>this.handleClientError(err)).catch((err)=>this.handleClientError(err));
                });
            }, this.filterActions = ()=>(0, $4sfdL.default)(this.props.actions, this.state.data), this.openKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: true
                });
            }, this.closeKudosDrawer = ()=>{
                this.setState({
                    kudosDrawerOpen: false
                });
            };
        }
    }
    const $e50495f0c6da843b$export$a6d9ff68ecba3be5 = $e50495f0c6da843b$var$ProfileCardResourced;
    var $e50495f0c6da843b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("cb25w")).default)()($e50495f0c6da843b$var$ProfileCardResourced);
});
parcelRegister("ifxzB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44786ae639641a68$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eZJjh;
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    const $44786ae639641a68$var$UserLoadingState = ({ fireAnalytics: fireAnalytics })=>{
        (0, $5uXOq.useEffect)(()=>{
            fireAnalytics((0, $ivXTE.profileCardRendered)('user', 'spinner'));
        }, [
            fireAnalytics
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null));
    };
    var $44786ae639641a68$export$2e2bcd8739ae039 = $44786ae639641a68$var$UserLoadingState;
});
parcelRegister("264zF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74b3c02273951832$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2NMNM;
    var $adIkV;
    var $gH4E9;
    var $VSDnB;
    var $1I7E8;
    var $k5uoT;
    var $4sfdL = parcelRequire("4sfdL");
    var $chprS = parcelRequire("chprS");
    var $jnj6z = parcelRequire("jnj6z");
    var $ivXTE = parcelRequire("ivXTE");
    var $kDbj5 = parcelRequire("kDbj5");
    var $dYuIx = parcelRequire("dYuIx");
    var $ifxzB = parcelRequire("ifxzB");
    function $74b3c02273951832$var$ProfileCardContent({ profilecardProps: profilecardProps, userId: userId, cloudId: cloudId, resourceClient: resourceClient, viewingUserId: viewingUserId, trigger: trigger, product: product, isAgent: isAgent, profileCardAction: profileCardAction, hasError: hasError, errorType: errorType, agentActions: agentActions, addFlag: addFlag }) {
        if (isAgent && (0, (0, parcelRequire("VSDnB")).fg)('enable_agent_profile_card')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $kDbj5.AgentProfileCardResourced), {
            accountId: userId,
            cloudId: cloudId,
            resourceClient: resourceClient,
            viewingUserId: viewingUserId,
            trigger: trigger,
            product: product,
            onChatClick: agentActions?.onChatClick,
            onConversationStartersClick: agentActions?.onConversationStartersClick,
            addFlag: addFlag
        });
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dYuIx.ProfileCardLazy), {
            ...profilecardProps,
            actions: profileCardAction,
            hasError: hasError,
            errorType: errorType,
            withoutElevation: true
        }));
    }
    function $74b3c02273951832$export$2e2bcd8739ae039({ autoFocus: autoFocus, trigger: trigger = 'hover', userId: userId, cloudId: cloudId, resourceClient: resourceClient, actions: actions = [], position: position = 'bottom-start', children: children, testId: testId, addFlag: addFlag, onReportingLinesClick: onReportingLinesClick, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, prepopulatedData: prepopulatedData, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, viewingUserId: viewingUserId, product: product, agentActions: agentActions }) {
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isMounted = (0, $5uXOq.useRef)(false);
        const showDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$5b956b542f1bc1b3);
        const hideDelay = trigger === 'click' ? 0 : (0, $e41878b3b8cab0db$export$89a9f35a94d7f196);
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(undefined);
        const [hasError, setHasError] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [data, setData] = (0, $5uXOq.useState)(null);
        const [reportingLinesData, setReportingLinesData] = (0, $5uXOq.useState)(undefined);
        const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $5uXOq.useState)(false);
        const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $5uXOq.useState)(undefined);
        const [kudosDrawerOpen, setKudosDrawerOpen] = (0, $5uXOq.useState)(false);
        const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $5uXOq.useState)(false);
        const triggerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            setIsLoading(undefined);
            setHasError(false);
            setError(null);
            setData(null);
            setReportingLinesData(undefined);
            setShouldShowGiveKudos(false);
            setTeamCentralBaseUrl(undefined);
        }, [
            userId
        ]);
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (!isMounted.current) return;
            (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            if (!isTriggeredUsingKeyboard) hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
                onVisibilityChange && onVisibilityChange(false);
            }, hideDelay);
        }, [
            hideDelay,
            isTriggeredUsingKeyboard,
            onVisibilityChange
        ]);
        const handleKeyboardClose = (0, $5uXOq.useCallback)((event)=>{
            if (event.key && event.key !== 'Escape') return;
            if (triggerRef.current) triggerRef.current.focus();
            setTriggeredUsingKeyboard(false);
            setVisible(false);
            onVisibilityChange && onVisibilityChange(false);
        }, [
            setTriggeredUsingKeyboard,
            setVisible,
            onVisibilityChange
        ]);
        const handleClientSuccess = (0, $5uXOq.useCallback)((profileData, reportingLinesData, shouldShowGiveKudos, teamCentralBaseUrl)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(false);
            setData(profileData);
            setReportingLinesData(reportingLinesData);
            setTeamCentralBaseUrl(teamCentralBaseUrl);
            setShouldShowGiveKudos(shouldShowGiveKudos);
        }, [
            setHasError,
            setIsLoading,
            setData,
            setReportingLinesData,
            setShouldShowGiveKudos
        ]);
        const handleClientError = (0, $5uXOq.useCallback)((err)=>{
            if (!isMounted.current) return;
            setIsLoading(false);
            setHasError(true);
            setError(err);
        }, [
            setHasError,
            setIsLoading,
            setError
        ]);
        const clientFetchProfile = (0, $5uXOq.useCallback)(async ()=>{
            if (isLoading === true) return;
            setIsLoading(true);
            setHasError(false);
            setError(null);
            setData(null);
            try {
                const requests = Promise.all([
                    resourceClient.getProfile(cloudId || '', userId, fireAnalytics),
                    resourceClient.getReportingLines(userId),
                    resourceClient.shouldShowGiveKudos(),
                    resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                const responses = await requests;
                handleClientSuccess(...responses);
            } catch (err) {
                handleClientError(err);
            }
        }, [
            cloudId,
            fireAnalytics,
            isLoading,
            resourceClient,
            userId,
            handleClientSuccess,
            handleClientError
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    clientFetchProfile();
                    setVisible(true);
                    onVisibilityChange && onVisibilityChange(true);
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            clientFetchProfile,
            onVisibilityChange
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
            if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'hover'));
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setTriggeredUsingKeyboard(true);
                showProfilecard();
                if (!visible) fireAnalytics((0, $ivXTE.cardTriggered)('user', 'click'));
            }
        }, [
            fireAnalytics,
            showProfilecard,
            visible
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        const filterActions = (0, $5uXOq.useCallback)(()=>{
            return (0, $4sfdL.default)(actions, data);
        }, [
            actions,
            data
        ]);
        const openKudosDrawer = ()=>{
            hideProfilecard();
            setKudosDrawerOpen(true);
        };
        const closeKudosDrawer = ()=>{
            setKudosDrawerOpen(false);
        };
        const showLoading = isLoading === true || isLoading === undefined;
        const wrapperProps = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onFocus: onFocus
            } : {}, [
            hideProfilecard,
            onFocus,
            onMouseEnter,
            trigger
        ]);
        const profilecardProps = {
            userId: userId,
            fullName: prepopulatedData?.fullName,
            isCurrentUser: userId === viewingUserId,
            clientFetchProfile: clientFetchProfile,
            ...data,
            reportingLines: reportingLinesData,
            onReportingLinesClick: onReportingLinesClick,
            isKudosEnabled: shouldShowGiveKudos,
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            openKudosDrawer: openKudosDrawer,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            disabledAriaAttributes: disabledAriaAttributes
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!visible,
            onClose: (event)=>{
                hideProfilecard();
                handleKeyboardClose(event);
            },
            placement: position,
            offset: offset ?? [
                0,
                8
            ],
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", wrapperProps, showLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$LoadingView, {
                    fireAnalytics: fireAnalytics
                }) : visible && (0, ($parcel$interopDefault($5uXOq))).createElement($74b3c02273951832$var$ProfileCardContent, {
                    profilecardProps: profilecardProps,
                    isAgent: !!data?.isAgent,
                    userId: userId,
                    cloudId: cloudId,
                    resourceClient: resourceClient,
                    viewingUserId: viewingUserId,
                    trigger: trigger,
                    product: product,
                    profileCardAction: filterActions(),
                    errorType: error,
                    hasError: hasError,
                    agentActions: agentActions,
                    addFlag: addFlag
                })),
            trigger: (triggerProps)=>{
                const { ref: callbackRef, ...innerProps } = triggerProps;
                const ref = (element)=>{
                    triggerRef.current = element;
                    if (typeof callbackRef === 'function') callbackRef(element);
                };
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = innerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ...containerListeners,
                    ref: ref,
                    "data-testid": testId,
                    "aria-labelledby": ariaLabelledBy,
                    ...disabledAriaAttributes ? {} : {
                        role: 'button',
                        tabIndex: 0,
                        'aria-label': (0, $chprS.default)(ariaLabel, profilecardProps.fullName, formatMessage)
                    }
                }, children);
            },
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: autoFocus ?? trigger === 'click',
            shouldRenderToParent: (0, (0, parcelRequire("VSDnB")).fg)('enable_appropriate_reading_order_in_profile_card')
        }), shouldShowGiveKudos && teamCentralBaseUrl && (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adIkV")).GiveKudosLauncherLazy), {
            isOpen: kudosDrawerOpen,
            recipient: {
                type: (0, (0, parcelRequire("gH4E9")).KudosType).INDIVIDUAL,
                recipientId: userId
            },
            analyticsSource: "profile-card",
            teamCentralBaseUrl: teamCentralBaseUrl,
            cloudId: cloudId,
            addFlag: addFlag,
            onClose: closeKudosDrawer
        })));
    }
    const $74b3c02273951832$var$LoadingView = ({ fireAnalytics: fireAnalytics })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $jnj6z.CardWrapper), {
            "data-testId": "profilecard.profilecardtrigger.loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ifxzB.default), {
            fireAnalytics: fireAnalytics
        }));
});
parcelRegister("chprS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4b051cf4c3ebf799$export$2e2bcd8739ae039);
    var $7VHMR;
    const $4b051cf4c3ebf799$var$getLabelMessage = (ariaLabelProp, fullName, formatMessage)=>{
        if (ariaLabelProp) return ariaLabelProp;
        return fullName ? formatMessage($4b051cf4c3ebf799$var$messages.label, {
            fullName: fullName
        }) : formatMessage($4b051cf4c3ebf799$var$messages.fallbackLabel);
    };
    const $4b051cf4c3ebf799$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fallbackLabel: {
            id: 'profilecard.user.trigger.fallback-aria-label',
            defaultMessage: 'More information about this user',
            description: 'Label for profile card trigger when we do not have user name'
        },
        label: {
            id: 'profilecard.user.trigger.aria-label',
            defaultMessage: 'More information about {fullName}',
            description: 'Label for profile card trigger'
        }
    });
    var $4b051cf4c3ebf799$export$2e2bcd8739ae039 = $4b051cf4c3ebf799$var$getLabelMessage;
});
parcelRegister("kDbj5", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardResourced", ()=>$9f87d208f89c63eb$export$4b013ffffcb40af8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $cI0Td = parcelRequire("cI0Td");
    var $a3FJs = parcelRequire("a3FJs");
    var $iwWWV = parcelRequire("iwWWV");
    const $9f87d208f89c63eb$export$4b013ffffcb40af8 = (props)=>{
        const [agentData, setAgentData] = (0, $5uXOq.useState)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const creatorUserId = (0, $5uXOq.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dG58U.getAAIDFromARI)(agentData.creator) : '', [
            agentData?.creator_type,
            agentData?.creator
        ]);
        const getCreator = (0, $5uXOq.useCallback)(async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    try {
                        if (!creatorUserId || !props.cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(creatorUserId, props.cloudId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${creatorUserId}`,
                            id: creatorUserId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        }, [
            creatorUserId,
            fireAnalytics,
            props.cloudId,
            props.resourceClient
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ()=>{
            setIsLoading(true);
            try {
                const profileData = await props.resourceClient.getRovoAgentProfile({
                    type: 'identity',
                    value: props.accountId
                }, fireAnalytics);
                const agentCreatorInfo = await getCreator(profileData?.creator_type, profileData?.creator || undefined);
                setAgentData({
                    ...profileData,
                    creatorInfo: agentCreatorInfo
                });
            } catch (err) {
                setError(err);
            } finally{
                setIsLoading(false);
            }
        }, [
            fireAnalytics,
            getCreator,
            props.accountId,
            props.resourceClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchData();
        }, [
            fetchData
        ]);
        if (error || !isLoading && !agentData) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $a3FJs.AgentProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $cI0Td.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: ()=>{}
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            isCreatedByViewingUser: creatorUserId === props.viewingUserId,
            product: props.product,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId
        }));
    };
});
parcelRegister("dG58U", function(module, exports) {
    $parcel$export(module.exports, "getAAIDFromARI", ()=>$dd4eeae2be471029$export$3761e66a04602cbd);
    const $dd4eeae2be471029$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
    const $dd4eeae2be471029$export$3761e66a04602cbd = (ari)=>{
        return ari.replace($dd4eeae2be471029$export$470b0d72e4fdc43a, '');
    };
});
parcelRegister("iwWWV", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardLazy", ()=>$b487397875f853f0$export$ed0ca9c1d49ea0bf);
    var $5uXOq = parcelRequire("5uXOq");
    const $b487397875f853f0$export$ed0ca9c1d49ea0bf = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("9gV7o"))));
});
parcelRegister("dYuIx", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardLazy", ()=>$78b4a66e55984f2d$export$403d297463f226af);
    var $5uXOq = parcelRequire("5uXOq");
    const $78b4a66e55984f2d$export$403d297463f226af = (0, $5uXOq.lazy)(()=>Promise.resolve((parcelRequire("lrMir"))));
});
parcelRegister("iMLpJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70b57d5fcda0f9a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    function $70b57d5fcda0f9a2$export$2e2bcd8739ae039(Component) {
        return class WithOuterListeners extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            componentDidMount() {
                if (this.props.handleClickOutside) document.addEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.addEventListener('keydown', this.handleKeydown, false);
            }
            componentWillUnmount() {
                if (this.props.handleClickOutside) document.removeEventListener('click', this.handleClick, false);
                if (this.props.handleEscapeKeydown) document.removeEventListener('keydown', this.handleKeydown, false);
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, this.props);
            }
            constructor(...args){
                super(...args), this.handleClick = (evt)=>{
                    const { handleClickOutside: handleClickOutside } = this.props;
                    if (handleClickOutside) {
                        const domNode = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                        if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) handleClickOutside();
                    }
                }, this.handleKeydown = (evt)=>{
                    const { handleEscapeKeydown: handleEscapeKeydown } = this.props;
                    if (handleEscapeKeydown && evt.code === 'Escape') handleEscapeKeydown();
                };
            }
        };
    }
});
parcelRegister("5uVl7", function(module, exports) {
    $parcel$export(module.exports, "AgentProfileCardTrigger", ()=>$50f554e79ae2423e$export$64983741fea6a45d);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $ivXTE = parcelRequire("ivXTE");
    var $dG58U = parcelRequire("dG58U");
    var $3j5Lk = parcelRequire("3j5Lk");
    var $iwWWV = parcelRequire("iwWWV");
    const $50f554e79ae2423e$export$64983741fea6a45d = ({ trigger: trigger = 'hover', viewingUserId: viewingUserId, product: product, ...props })=>{
        const { resourceClient: resourceClient, agentId: userId, cloudId: cloudId } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
            if (createAnalyticsEvent) (0, $ivXTE.fireEvent)(createAnalyticsEvent, payload);
        }, [
            createAnalyticsEvent
        ]);
        const getCreator = async (creator_type, creator)=>{
            if (!creator) return undefined;
            switch(creator_type){
                case 'SYSTEM':
                    return {
                        type: 'SYSTEM'
                    };
                case 'THIRD_PARTY':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'FORGE':
                    return {
                        type: 'THIRD_PARTY',
                        name: creator ?? ''
                    };
                case 'CUSTOMER':
                    const userId = (0, $dG58U.getAAIDFromARI)(creator) || '';
                    try {
                        if (!userId || !cloudId) return undefined;
                        const creatorInfo = await props.resourceClient.getProfile(cloudId, userId, fireAnalytics);
                        return {
                            type: 'CUSTOMER',
                            name: creatorInfo.fullName,
                            profileLink: `/people/${userId}`,
                            id: userId
                        };
                    } catch (error) {
                        return undefined;
                    }
                default:
                    return undefined;
            }
        };
        const fetchAgentProfile = async ()=>{
            const agentInfo = await resourceClient.getRovoAgentProfile({
                type: 'agent',
                value: userId
            }, fireAnalytics);
            const agentCreatorInfo = await getCreator(agentInfo.creator_type, agentInfo.creator || undefined);
            return {
                ...agentInfo,
                creatorInfo: agentCreatorInfo
            };
        };
        const renderProfileCard = ({ profileData: profileData, error: error })=>{
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Suspense), {
                fallback: null
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iwWWV.AgentProfileCardLazy), {
                agent: profileData,
                hasError: !!error,
                isCreatedByViewingUser: profileData?.creatorInfo && profileData?.creatorInfo?.id === viewingUserId,
                cloudId: props.cloudId,
                product: product,
                errorType: error,
                onChatClick: props.onChatClick,
                onConversationStartersClick: props.onConversationStartersClick,
                resourceClient: props.resourceClient,
                addFlag: props.addFlag
            }));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $3j5Lk.default), {
            ...props,
            trigger: "hover",
            renderProfileCard: renderProfileCard,
            fetchProfile: fetchAgentProfile,
            fireAnalytics: fireAnalytics,
            profileCardType: "agent"
        });
    };
});
parcelRegister("3j5Lk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16aed3e91811a6aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $k5uoT;
    var $ivXTE = parcelRequire("ivXTE");
    var $hHa0v = parcelRequire("hHa0v");
    var $8qsT1 = parcelRequire("8qsT1");
    var $iRPRU = parcelRequire("iRPRU");
    var $glChS = parcelRequire("glChS");
    const $16aed3e91811a6aa$var$DELAY_MS_SHOW = 800;
    const $16aed3e91811a6aa$var$DELAY_MS_HIDE = 200;
    function $16aed3e91811a6aa$var$ProfileCardTrigger({ trigger: trigger, ariaLabelledBy: ariaLabelledBy, children: children, renderProfileCard: renderProfileCard, fetchProfile: fetchProfile, disabledAriaAttributes: disabledAriaAttributes, profileCardType: profileCardType, fireAnalytics: fireAnalytics, ...popupProps }) {
        const showDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_SHOW;
        const hideDelay = trigger === 'click' ? 0 : $16aed3e91811a6aa$var$DELAY_MS_HIDE;
        const showTimer = (0, $5uXOq.useRef)(0);
        const hideTimer = (0, $5uXOq.useRef)(0);
        const [visible, setVisible] = (0, $5uXOq.useState)(false);
        const { profileData: profileData, isLoading: isLoading, error: error, getProfileData: getProfileData } = (0, $hHa0v.useProfileInfo)({
            fetchUserProfile: fetchProfile
        });
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                clearTimeout(showTimer.current);
                clearTimeout(hideTimer.current);
            };
        }, []);
        const hideProfilecard = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(showTimer.current);
            clearTimeout(hideTimer.current);
            hideTimer.current = window.setTimeout(()=>{
                setVisible(false);
            }, hideDelay);
        }, [
            hideDelay
        ]);
        const showProfilecard = (0, $5uXOq.useCallback)(async ()=>{
            clearTimeout(hideTimer.current);
            clearTimeout(showTimer.current);
            showTimer.current = window.setTimeout(()=>{
                if (!visible) {
                    getProfileData?.();
                    setVisible(true);
                    if (fireAnalytics) fireAnalytics((0, $ivXTE.cardTriggered)(profileCardType, trigger));
                }
            }, showDelay);
        }, [
            showDelay,
            visible,
            getProfileData,
            fireAnalytics,
            profileCardType,
            trigger
        ]);
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            ...popupProps,
            isOpen: !!visible,
            onClose: hideProfilecard,
            shouldUseCaptureOnOutsideClick: true,
            autoFocus: popupProps.autoFocus ?? trigger === 'click',
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).modal(),
            shouldFitContainer: false,
            trigger: (triggerProps)=>{
                const { 'aria-expanded': _, 'aria-haspopup': __, ...restInnerProps } = triggerProps;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $iRPRU.PopupTrigger), {
                    ...disabledAriaAttributes ? restInnerProps : triggerProps,
                    ref: triggerProps.ref,
                    hideProfilecard: hideProfilecard,
                    showProfilecard: showProfilecard,
                    children: children,
                    ariaLabelledBy: ariaLabelledBy,
                    trigger: trigger
                });
            },
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: hideProfilecard,
                    onFocus: showProfilecard
                }, isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $glChS.ProfileCardWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8qsT1.LoadingState), {
                    fireAnalytics: fireAnalytics,
                    profileType: profileCardType
                })) : renderProfileCard({
                    profileData: profileData,
                    error: error
                }))
        });
    }
    var $16aed3e91811a6aa$export$2e2bcd8739ae039 = $16aed3e91811a6aa$var$ProfileCardTrigger;
});
parcelRegister("hHa0v", function(module, exports) {
    $parcel$export(module.exports, "useProfileInfo", ()=>$1015119dde638e8f$export$6cace87f7d7a9738);
    var $5uXOq = parcelRequire("5uXOq");
    const $1015119dde638e8f$export$6cace87f7d7a9738 = ({ fetchUserProfile: fetchUserProfile })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [profileData, setProfileData] = (0, $5uXOq.useState)();
        const getProfileData = async ()=>{
            setIsLoading(true);
            try {
                const profileData = await fetchUserProfile?.();
                setProfileData(profileData);
                setIsLoading(false);
            } catch (error) {
                setError(error);
                setIsLoading(false);
            }
        };
        return {
            profileData: profileData,
            isLoading: isLoading,
            error: error,
            getProfileData: getProfileData
        };
    };
});
parcelRegister("iRPRU", function(module, exports) {
    $parcel$export(module.exports, "PopupTrigger", ()=>$eb07ae3447684674$export$95d4acdbab2fc6ef);
    var $5uXOq = parcelRequire("5uXOq");
    const $eb07ae3447684674$var$PopupTriggerInner = ({ children: children, trigger: trigger, showProfilecard: showProfilecard, hideProfilecard: hideProfilecard, ariaLabelledBy: ariaLabelledBy, ...props }, ref)=>{
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const onKeyPress = (0, $5uXOq.useCallback)((event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                showProfilecard();
            }
        }, [
            showProfilecard
        ]);
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            showProfilecard();
        }, [
            showProfilecard
        ]);
        const containerListeners = (0, $5uXOq.useMemo)(()=>trigger === 'hover' ? {
                onMouseEnter: onMouseEnter,
                onMouseLeave: hideProfilecard,
                onBlur: hideProfilecard,
                onKeyPress: onKeyPress
            } : {
                onClick: onClick,
                onKeyPress: onKeyPress
            }, [
            hideProfilecard,
            onClick,
            onKeyPress,
            onMouseEnter,
            trigger
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...props,
            ...containerListeners,
            ref: ref,
            "aria-labelledby": ariaLabelledBy
        }, children);
    };
    const $eb07ae3447684674$export$95d4acdbab2fc6ef = (0, ($parcel$interopDefault($5uXOq))).forwardRef($eb07ae3447684674$var$PopupTriggerInner);
});
parcelRegister("glChS", function(module, exports) {
    $parcel$export(module.exports, "ProfileCardWrapper", ()=>$fc69b6eef7bac459$export$59abd6feb7dc8540);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $fc69b6eef7bac459$var$styles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '360px'
    });
    const $fc69b6eef7bac459$export$59abd6feb7dc8540 = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $fc69b6eef7bac459$var$styles
        }, children);
    };
});
parcelRegister("8G7CX", function(module, exports) {
    $parcel$export(module.exports, "isSystemAgent", ()=>$11e5cd279fe5fb4c$export$7c120b233d4844c6);
    $parcel$export(module.exports, "isCustomerAgent", ()=>$11e5cd279fe5fb4c$export$f817e52cf2c5cc8c);
    $parcel$export(module.exports, "isForgeAgent", ()=>$11e5cd279fe5fb4c$export$2149adda3d8a5807);
    const $11e5cd279fe5fb4c$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
    const $11e5cd279fe5fb4c$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
    const $11e5cd279fe5fb4c$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE';
    const $11e5cd279fe5fb4c$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
});
parcelRegister("3xYdY", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_AGENTS_NAMED_ID_LIST", ()=>$3b04d45962552af9$export$2d0163867590928d);
    $parcel$export(module.exports, "DEFAULT_OOTB_AGENTS_NAMED_IDS", ()=>$3b04d45962552af9$export$804d9ee5f4cc40a8);
    $parcel$export(module.exports, "isCreateOrEditAgentAUPError", ()=>$3b04d45962552af9$export$a08ace1426fa4a9e);
    const $3b04d45962552af9$export$48783720d93c2d26 = {
        id: 'ai_mate_agent',
        named_id: 'ai_mate_agent',
        name: 'AI Mate',
        description: 'AI Mate',
        creator_type: 'SYSTEM',
        available_plugins: {},
        is_default: true,
        visibility: 'PUBLIC'
    };
    const $3b04d45962552af9$export$2d0163867590928d = new Set([
        'decision_director_agent',
        'user_manual_writer_agent',
        'product_requirements_expert_agent'
    ]);
    const $3b04d45962552af9$export$804d9ee5f4cc40a8 = {
        ['confluence']: new Set([
            'decision_director_agent',
            'product_requirements_expert_agent',
            'rovo_expert_agent'
        ]),
        ['jira']: new Set([
            'rovo_expert_agent',
            'issue_organizer_agent',
            'jira_theme_analyzer_agent'
        ]),
        ['atlas']: new Set([
            'progress_tracker_agent',
            'product_requirements_expert_agent',
            'rovo_expert_agent'
        ])
    };
    const $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
    const $3b04d45962552af9$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $3b04d45962552af9$var$AGENT_AUP_ERROR_CODE;
});
parcelRegister("gBv35", function(module, exports) {
    $parcel$export(module.exports, "useProfileClient", ()=>$8168d85a70e7a063$export$d43dc22a8337ee9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $gKZoD;
    parcelRequire("26CR2");
    var $bp5g1 = parcelRequire("bp5g1");
    const $8168d85a70e7a063$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
    let $8168d85a70e7a063$var$client;
    const $8168d85a70e7a063$export$d43dc22a8337ee9f = ()=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, $bp5g1.default));
        const profileClient = (0, $5uXOq.useMemo)(()=>{
            if (!$8168d85a70e7a063$var$client) $8168d85a70e7a063$var$client = new (0, $bp5g1.default)({
                url: $8168d85a70e7a063$var$DIRECTORY_URL,
                cacheSize: 1000,
                cacheMaxAge: 86400000
            });
            return $8168d85a70e7a063$var$client;
        }, []);
        return profileClient;
    };
});
parcelRegister("3go6U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52a6773361bb10a2$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52a6773361bb10a2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        deactivatedCreatorName: {
            id: 'rovo-chat.agent-card.deactivated-name',
            defaultMessage: '{name} (deactivated)',
            description: 'Name of the agent creator when it is deactivated'
        }
    });
});
parcelRegister("2gP8c", function(module, exports) {
    $parcel$export(module.exports, "useDeleteAgent", ()=>$919aea89356508dc$export$89877d4f8d8790ca);
    var $gKZoD;
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $mNrGv;
    const $919aea89356508dc$export$89877d4f8d8790ca = ({ experienceId: experienceId, product: product, onSuccess: onSuccess, onError: onError } = {})=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("cK3Jm")).useAssistanceService));
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const assistanceService = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)({
            experienceId: experienceId,
            product: product
        });
        const deleteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT
                });
                return await assistanceService.deleteAgent(id);
            },
            onSuccess: async (data)=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT
                });
                onSuccess?.();
                return data;
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).DELETE_AGENT,
                    error: error
                });
                onError?.();
            }
        });
        return {
            deleteAgent: deleteAgent
        };
    };
});
parcelRegister("bpqZM", function(module, exports) {
    $parcel$export(module.exports, "useAgentFavourites", ()=>$2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69);
    var $gKZoD;
    var $91cKc;
    var $cSxED;
    var $cK3Jm;
    var $mNrGv;
    const $2fbe1e44fe5af5f2$export$5c4c46b1f93a6e69 = ({ onError: onError, onSuccess: onSuccess, experienceId: experienceId = 'ai-mate', product: product } = {})=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("cK3Jm")).useAssistanceService));
        const assistanceService = (0, (0, parcelRequire("cK3Jm")).useAssistanceService)({
            experienceId: experienceId,
            product: product
        });
        const experience = (0, (0, parcelRequire("cSxED")).useAIMateExperienceTracker)();
        const favouriteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT
                });
                return await assistanceService.favouriteAgent(id);
            },
            onSuccess: async ()=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT
                });
                onSuccess?.({
                    favourite: true
                });
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).FAVOURITE_AGENT,
                    error: error
                });
                onError?.({
                    favourite: true
                });
            }
        });
        const unfavouriteAgent = (0, (0, parcelRequire("mNrGv")).useMutation)({
            mutationFn: async (id)=>{
                experience.start({
                    id: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT,
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT
                });
                return await assistanceService.unfavouriteAgent(id);
            },
            onSuccess: async ()=>{
                experience.succeed({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT
                });
                onSuccess?.({
                    favourite: false
                });
            },
            onError: (error)=>{
                experience.fail({
                    name: (0, (0, parcelRequire("91cKc")).ExperienceName).UNFAVOURITE_AGENT,
                    error: error
                });
                onError?.({
                    favourite: false
                });
            }
        });
        return {
            favouriteAgent: favouriteAgent,
            unfavouriteAgent: unfavouriteAgent
        };
    };
});
parcelRegister("llLCm", function(module, exports) {
    $parcel$export(module.exports, "getOverridenAgents", ()=>$31cc422f8e9b389e$export$b873e2166b2a4c4f);
    const $31cc422f8e9b389e$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
        const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
        let overridenAgents = [];
        if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
                ...agent,
                is_default: index === defaultOverrideAgentsIndex
            }));
        else overridenAgents = agents;
        if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
        return overridenAgents;
    };
});
parcelRegister("53Oql", function(module, exports) {
    $parcel$export(module.exports, "useAgentOverrider", ()=>$71d01d0fbe45ead4$export$7b61e11d4e81ba17);
    $parcel$export(module.exports, "AgentOverriderProvider", ()=>$71d01d0fbe45ead4$export$aa582af5b4b72bb2);
    $parcel$export(module.exports, "createAgentsConfig", ()=>$71d01d0fbe45ead4$export$6aab84dc399ad753);
    var $5uXOq = parcelRequire("5uXOq");
    var $llLCm;
    const $71d01d0fbe45ead4$export$ccc6603eb027f48b = (0, $5uXOq.createContext)({});
    const $71d01d0fbe45ead4$export$7b61e11d4e81ba17 = ()=>(0, $5uXOq.useContext)($71d01d0fbe45ead4$export$ccc6603eb027f48b);
    const $71d01d0fbe45ead4$export$aa582af5b4b72bb2 = $71d01d0fbe45ead4$export$ccc6603eb027f48b.Provider;
    const $71d01d0fbe45ead4$export$6aab84dc399ad753 = (config)=>({
            agentDefaultIdOverride: config?.defaultAgentId,
            agentIdFiltersOverride: config?.filter
        });
});
parcelRegister("53Ehp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39110be331ee6607$export$2e2bcd8739ae039);
    var $7VHMR;
    var $39110be331ee6607$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultAgentName: {
            id: 'ai-mate.agent-selector.default-agent-name',
            defaultMessage: 'Chat',
            description: 'Default agent name'
        },
        defaultAgentDescription: {
            id: 'ai-mate.agent-selector.default-agent-description',
            defaultMessage: 'Get answers, generate new ideas, and accelerate everyday work.'
        }
    });
});
parcelRegister("cRxCv", function(module, exports) {
    $parcel$export(module.exports, "ChatAgent", ()=>$aabf6dc2925653ec$export$198c236a78ec089b);
    $parcel$export(module.exports, "CommsCrafterAgent", ()=>$aabf6dc2925653ec$export$2036d10b5adbaa07);
    $parcel$export(module.exports, "JobWriterAgent", ()=>$aabf6dc2925653ec$export$c6b96d4ac6b48aa6);
    $parcel$export(module.exports, "A11yMateAgent", ()=>$aabf6dc2925653ec$export$3b92ff78ca28a6e3);
    const $aabf6dc2925653ec$export$198c236a78ec089b = {
        actor_type: 'AGENT',
        available_plugins: {
            'Content-Read-Plugin': {},
            'Ethical-Filtering-Plugin': {},
            'Jira-JQL-Plugin': {},
            'Jira-NL-JQL-Plugin': {},
            'Jira-Software-Plugin': {},
            'Page-Search-Plugin': {},
            'People-Plugin': {},
            'Search-QA-Plugin': {}
        },
        creator: 'mock',
        creator_cloud_id: null,
        creator_type: 'SYSTEM',
        description: 'Mocking: Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
        external_files: null,
        follow_up_prompt_template: '\nYour task is to generate follow-up questions for the given conversation from the user\'s perspective.\nThe conversation history is provided in triple backticks.\n\nConversation History:\n```\n{message_history}\n```\n\nWhen you generate follow-up questions, follow these steps closely:\n1. Read the conversation history carefully to understand the user\'s intent. Keep it open and refer back to it as necessary.\n2. Pretend that you are the user and think about what you would ask next based on the conversation history and the original intent.\n3. Generate 3 follow-up questions from the perspective of the user that meet the following criteria.\n    - Relevant to the conversation.\n    - Unique and different from previously asked questions.\n    - Requests new information.\n    - Insightful and enhances the engagement of the conversation.\n    - Succinct and straight to the point.\n    - Specific and avoids being too general.\n    - Less than 9 words.\n    - When the subject of the question is the user asking questions, use the first-person pronoun "I".\n4. Read your follow-up questions again and remove the ones that do not meet ALL of the listed criteria.\n5. If there are no follow-up questions left, return an empty list.\n6. If there are follow-up questions left, paraphrase them to make them more concise.\n7. Return your paraphrased follow-up questions.\n',
        id: 'f3a534d9-1498-e0d4-8b50-e058a8fb8156',
        is_default: true,
        name: 'Mock Chat',
        named_id: 'ai_mate_agent',
        plugin_routing_type: 'DEFAULT',
        system_prompt_template: '\nYou are Rovo Chat, an AI assistant built by Atlassian, you can do everything in the list of functions available. \nTreat the human in a friendly and personalised way, if what they ask is completely nonsensical, ask for clarification.  \n\nFollowing are the details of the human user:\n\nName: {{ user_name }}\n{{ location_info }}\n\nCurrent Time: {{ current_time }}\n\n{{ browsing_context }}\n\nFollow these rules:\n- Respond with names in the following format [name](/people/id) when appropriate.\n- Always use a function to find information, even if you know the answer.\n- Prioritise the Search-QA-Plugin when the function to use is not obvious.\n- Never answer the user directly without results from a function, unless they asked to reformat an existing answer.\n- Do not use your pretrained knowledge to answer.\n- Do not return function details in your answer.\n- If the answer is not available from the current function, always call another function.\n',
        visibility: 'PUBLIC',
        user_defined_conversation_starters: [],
        favourite: false,
        deactivated: false
    };
    const $aabf6dc2925653ec$export$2036d10b5adbaa07 = {
        actor_type: 'AGENT',
        available_plugins: {
            'Confluence-Suggestion-Plugin': {
                is_terminal: true,
                raise_no_answer_exception: true
            },
            'Page-Search-Plugin': {}
        },
        creator: null,
        creator_cloud_id: null,
        creator_type: 'SYSTEM',
        description: "Craft and refine all things blogs, external comms, and announcements. Align with your brand's voice.",
        external_files: null,
        follow_up_prompt_template: null,
        id: '3506f1fa-13ab-0c9c-d645-f26c759ef903',
        is_default: false,
        name: 'Comms crafter',
        named_id: 'confluence_reviewer_agent',
        plugin_routing_type: 'DEFAULT',
        system_prompt_template: 'You are the Comms crafter, a helpful assistant for reviewing Confluence documents. You are tasked with providing suggestions to improve a Confluence document.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- Always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\n',
        visibility: 'PRIVATE',
        user_defined_conversation_starters: [
            "Can you help me with this blog post I'm working on?",
            "Help me with this announcement I'm drafting."
        ],
        favourite: false,
        deactivated: false
    };
    const $aabf6dc2925653ec$export$c6b96d4ac6b48aa6 = {
        actor_type: 'AGENT',
        available_plugins: {
            'Confluence-Suggestion-Plugin': {},
            'Content-Read-Plugin': {},
            'Page-Search-Plugin': {}
        },
        creator: null,
        creator_cloud_id: null,
        creator_type: 'SYSTEM',
        description: 'Crafts job descriptions that align with corporate guidelines and ensures they promote inclusivity and diversity.',
        external_files: null,
        follow_up_prompt_template: null,
        id: '5692d6dd-3045-499f-b08b-77ed2d253941',
        is_default: false,
        name: 'Job writer',
        named_id: 'job_writer_agent',
        plugin_routing_type: 'DEFAULT',
        system_prompt_template: 'You are the Job writer agent, a helpful assistant for hiring managers and recruitment teams to standardize on job descriptions which follow diversity and inclusion guidelines. \nYou are tasked with providing suggestions to improve a Confluence document for job descriptions.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- You must always provide a suggested replacement for insertion when asked to create, insert or draft job descriptions, summaries or any unique content.\n- You must always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\nBrowsing Context: {{ browsing_context }}',
        visibility: 'PRIVATE',
        user_defined_conversation_starters: [],
        favourite: false,
        deactivated: false
    };
    const $aabf6dc2925653ec$export$3b92ff78ca28a6e3 = {
        actor_type: 'AGENT',
        available_plugins: {
            'Search-QA-Plugin': {
                space_filter: [
                    'A11YKB'
                ]
            }
        },
        creator: 'ari:cloud:identity::user/557057:db25fe7e-23f8-4e0f-aa1d-74a8c29bbc10',
        creator_cloud_id: 'a436116f-02ce-4520-8fbb-7301462a1674',
        creator_type: 'CUSTOMER',
        description: 'Accessibility help by Central Accessibility Team',
        external_files: [],
        follow_up_prompt_template: null,
        id: 'a7f547de-aa39-4d25-9234-65ac13c19acd',
        is_default: false,
        name: 'A11Y Mate Long Name for Selection Toolbar',
        named_id: 'A11Y Mate',
        plugin_routing_type: null,
        system_prompt_template: '',
        visibility: 'PUBLIC',
        user_defined_conversation_starters: [
            'What can you help me with?',
            'What can you help me with?',
            'What can you help me with?'
        ],
        favourite: false,
        deactivated: false
    };
});
parcelRegister("78lIh", function(module, exports) {
    $parcel$export(module.exports, "getEditorAgent", ()=>$25f80d1a3ca6ad70$export$c1402aba00d7d987);
    var $4ns5a;
    var $cRxCv;
    const $25f80d1a3ca6ad70$export$c1402aba00d7d987 = (agent)=>{
        const { id: id, name: name, description: description, named_id: named_id, creator_type: creator_type, system_prompt_template: system_prompt_template, creator: creator, visibility: visibility, is_default: is_default, identity_account_id: identity_account_id, icon: icon } = agent;
        return {
            id: id,
            name: name,
            description: description,
            namedId: named_id,
            creatorType: creator_type,
            systemPromptTemplate: system_prompt_template,
            creator: creator ?? undefined,
            visibility: visibility,
            isDefault: is_default,
            identityAccountId: identity_account_id,
            icon: icon,
            conversationStarters: (0, (0, parcelRequire("4ns5a")).getConversationStarters)({
                isAgentDefault: is_default,
                userDefinedConversationStarters: agent.user_defined_conversation_starters?.map((starter)=>{
                    return {
                        message: starter,
                        type: 'user-defined'
                    };
                })
            }).combinedConversationStarters,
            externalConfigReference: agent.external_config_reference
        };
    };
});
parcelRegister("7m26N", function(module, exports) {
    $parcel$export(module.exports, "shouldMockAgentData", ()=>$5d49295895f1adeb$export$a3d3d8409c46173b);
    const $5d49295895f1adeb$export$a3d3d8409c46173b = ()=>{
        return false;
    };
});
parcelRegister("lCNub", function(module, exports) {
    $parcel$export(module.exports, "PublishToRovo", ()=>$6ed38bbc31a5f1a4$export$e4b2c7b98f669fb7);
    var $5uXOq = parcelRequire("5uXOq");
    var $awTmI;
    var $kCV8T;
    var $hjiMw;
    var $gWPGI;
    var $jSlH9;
    var $4xwSH;
    var $9YAmQ;
    const $6ed38bbc31a5f1a4$export$b4ceb5852b486734 = ({ modalDecorationSet: modalDecorationSet, doc: doc })=>{
        const existingDecoration = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.shift();
        const startWidget = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedStartWidget')?.shift()?.from;
        const endWidget = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedEndWidget')?.shift()?.to;
        if (existingDecoration) return doc.slice(existingDecoration.from, existingDecoration.to, true).content;
        if (startWidget && endWidget) return doc.slice(startWidget, endWidget, true).content;
        return;
    };
    const $6ed38bbc31a5f1a4$export$e4b2c7b98f669fb7 = ({ editorView: editorView, getMentionNameDetails: getMentionNameDetails, editorPluginAIProvider: editorPluginAIProvider, editorApi: editorApi })=>{
        const publish = (0, (0, parcelRequire("hjiMw")).usePublish)('ai-mate');
        const { product: product } = editorPluginAIProvider;
        const { focusState: focusState } = (0, (0, parcelRequire("awTmI")).useSharedPluginState)(editorApi, [
            'focus'
        ]);
        const publishDocAndSelection = (0, ($parcel$interopDefault($5uXOq))).useCallback(async ({ doc: doc, selection: selection })=>{
            if (!doc || !selection) {
                publish({
                    type: 'editor-context-payload',
                    source: 'editor',
                    product: product,
                    data: undefined
                });
                return;
            }
            const { modalDecorationSet: modalDecorationSet } = (0, (0, parcelRequire("jSlH9")).getPluginState)(editorView.state);
            let selectionContent = selection.content().content;
            const selectionContentFromDecorations = $6ed38bbc31a5f1a4$export$b4ceb5852b486734({
                modalDecorationSet: modalDecorationSet,
                doc: doc
            });
            if (selectionContentFromDecorations) selectionContent = selectionContentFromDecorations;
            let mentionMap = {};
            if (getMentionNameDetails) mentionMap = await (0, (0, parcelRequire("9YAmQ")).getMentionMap)({
                node: doc,
                getMentionNameDetails: getMentionNameDetails
            });
            const { markdown: selectionMD } = (0, (0, parcelRequire("gWPGI")).convertProsemirrorNodeToMarkdown)({
                node: (0, (0, parcelRequire("kCV8T")).Fragment).from(selectionContent),
                featureToggles: {
                    markdownPlus: false
                },
                mentionMap: mentionMap
            });
            publish({
                type: 'editor-context-payload',
                source: 'editor',
                product: product,
                data: {
                    document: {
                        type: 'text/adf',
                        content: doc.toJSON()
                    },
                    selection: {
                        type: 'text/markdown',
                        content: selectionMD
                    }
                }
            });
        }, [
            editorView,
            getMentionNameDetails,
            product,
            publish
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!focusState?.hasFocus) publishDocAndSelection({
                doc: editorView.state.doc,
                selection: editorView.state.selection
            });
        }, [
            editorView,
            focusState,
            publishDocAndSelection
        ]);
        (0, (0, parcelRequire("4xwSH")).updatePublish)(publish)(editorView.state, editorView.dispatch);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
});
parcelRegister("i3tKZ", function(module, exports) {
    $parcel$export(module.exports, "RovoEnabled", ()=>$e641bed0ae624222$export$6d436ac1332526a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $h4rOi;
    var $4xwSH;
    const $e641bed0ae624222$var$useRovoEnabled = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
        const { isRovoEnabled: isRovoEnabled } = (0, (0, parcelRequire("h4rOi")).useRovoEntitlement)();
        return !!editorPluginAIProvider.isRovoEnabled && isRovoEnabled && typeof editorPluginAIProvider?.getChannelVariables === 'function';
    };
    const $e641bed0ae624222$export$6d436ac1332526a3 = (props)=>{
        const { editorView: editorView, children: children } = props;
        const enabled = $e641bed0ae624222$var$useRovoEnabled({
            editorPluginAIProvider: props.editorPluginAIProvider
        });
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            (0, (0, parcelRequire("4xwSH")).updateEnabled)(enabled)(editorView.state, editorView.dispatch);
        }, [
            editorView.dispatch,
            editorView.state,
            enabled
        ]);
        return enabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : null;
    };
});
parcelRegister("8sL3P", function(module, exports) {
    $parcel$export(module.exports, "SubscribeToRovo", ()=>$e43ab394d1b60f24$export$e7460f646530f5b4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hjiMw;
    var $gmhCD = parcelRequire("gmhCD");
    var $3n50y;
    var $7Jwp5;
    var $78lIh;
    var $exyUy;
    var $fpzVC;
    var $7vvgy;
    const $e43ab394d1b60f24$var$topic = {
        topic: 'ai-mate'
    };
    const $e43ab394d1b60f24$export$e7460f646530f5b4 = ({ editorView: editorView, product: product, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged })=>{
        const agents = (0, (0, parcelRequire("7Jwp5")).useAgentsList)({
            assistanceServiceParams: {
                product: (0, (0, parcelRequire("fpzVC")).mapToConvoAIProductName)(product),
                experienceId: 'ai-mate',
                touchpointSource: 'editor-agent-subscribe-to-rovo'
            }
        });
        (0, (0, parcelRequire("7vvgy")).useTrackLastActiveEditorView)(editorView);
        const callback = (0, $5uXOq.useCallback)((payload)=>{
            if (payload.type === 'agent-changed' && onAIProviderChanged && (0, $gmhCD.editorExperiment)('platform_editor_ai_facepile', true)) onAIProviderChanged('rovo-chat', payload.data.agent ? {
                type: 'rovo',
                agent: payload.data.agent
            } : undefined);
            if (payload.type === 'editor-suggestion' && (0, (0, parcelRequire("7vvgy")).isLastActiveEditorView)(editorView)) {
                const { state: state } = editorView;
                switch(payload.data.mode){
                    case 'insert':
                        {
                            const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                                markdown: payload.data.content,
                                schema: state.schema,
                                idMap: {}
                            });
                            const tr = (0, (0, parcelRequire("exyUy")).insertAIContentAtCurrentPosition)({
                                editorView: editorView,
                                positions: [
                                    state.selection.from,
                                    state.selection.to
                                ],
                                pmFragment: pmFragment
                            });
                            (0, (0, parcelRequire("exyUy")).beforeDispatchAIRovoAgentTransaction)(tr);
                            editorView.dispatch(tr);
                            editorView.focus();
                            break;
                        }
                    case 'replace':
                        {
                            const { pmFragment: pmFragment } = (0, (0, parcelRequire("3n50y")).convertMarkdownToProsemirror)({
                                markdown: payload.data.content,
                                schema: state.schema,
                                idMap: {}
                            });
                            const tr = (0, (0, parcelRequire("exyUy")).replaceWithAIContent)({
                                editorView: editorView,
                                positions: [
                                    state.selection.from,
                                    state.selection.to
                                ],
                                pmFragment: pmFragment,
                                options: {
                                    replaceDocOnEmptySelection: false
                                }
                            });
                            (0, (0, parcelRequire("exyUy")).beforeDispatchAIRovoAgentTransaction)(tr);
                            editorView.dispatch(tr);
                            editorView.focus();
                            break;
                        }
                }
                const matchedAgent = agents.find((agent)=>agent.id === payload.data.agentId);
                if (matchedAgent && onDocChangeByAgent) {
                    const agent = (0, (0, parcelRequire("78lIh")).getEditorAgent)(matchedAgent);
                    onDocChangeByAgent(agent);
                }
            }
        }, [
            agents,
            onDocChangeByAgent,
            onAIProviderChanged,
            editorView
        ]);
        (0, (0, parcelRequire("hjiMw")).useSubscribe)($e43ab394d1b60f24$var$topic, callback);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
});
parcelRegister("7vvgy", function(module, exports) {
    $parcel$export(module.exports, "isLastActiveEditorView", ()=>$609a5019f0e1c82d$export$c9ca68398bbb9d15);
    $parcel$export(module.exports, "useTrackLastActiveEditorView", ()=>$609a5019f0e1c82d$export$ffc90b19d29ca0a6);
    var $5uXOq = parcelRequire("5uXOq");
    let $609a5019f0e1c82d$var$lastActiveEditorView = null;
    const $609a5019f0e1c82d$export$63e666219b0a303b = (editorView)=>{
        $609a5019f0e1c82d$var$lastActiveEditorView = editorView;
    };
    const $609a5019f0e1c82d$export$c9ca68398bbb9d15 = (editorView)=>editorView === $609a5019f0e1c82d$var$lastActiveEditorView;
    const $609a5019f0e1c82d$export$ffc90b19d29ca0a6 = (editorView)=>{
        (0, $5uXOq.useEffect)(()=>{
            const handleFocus = ()=>$609a5019f0e1c82d$export$63e666219b0a303b(editorView);
            const editorDom = editorView.dom;
            editorDom.addEventListener('focus', handleFocus);
            return ()=>{
                editorDom.removeEventListener('focus', handleFocus);
            };
        }, [
            editorView
        ]);
    };
});
parcelRegister("hqcPl", function(module, exports) {
    $parcel$export(module.exports, "ModalRegion", ()=>$1c2d6e6da7a439cb$export$bd71f7a11db32a15);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $lFKmC = parcelRequire("lFKmC");
    var $f3dKD;
    var $etG8M;
    var $g0RiJ;
    var $4GZLe;
    var $1p2f7;
    var $jGwgx;
    const $1c2d6e6da7a439cb$export$bd71f7a11db32a15 = ({ children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, modalDecorationElement: modalDecorationElement, appearance: appearance, endExperience: endExperience, lastTriggeredFrom: lastTriggeredFrom, decorationSet: decorationSet, autoScroll: autoScroll })=>{
        const editorViewElement = editorView.dom;
        const modalRef = (0, ($parcel$interopDefault($5uXOq))).useRef(null);
        const [modalLeft, setModalLeft] = (0, ($parcel$interopDefault($5uXOq))).useState(0);
        const [modalTop, setModalTop] = (0, ($parcel$interopDefault($5uXOq))).useState(0);
        const [modalWidth, setModalWidth] = (0, ($parcel$interopDefault($5uXOq))).useState(0);
        const [transition, setTransition] = (0, ($parcel$interopDefault($5uXOq))).useState('');
        const resizableOrBreakoutWrapper = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jGwgx")).getResizableOrBreakoutWrapper)(editorView, decoration.to), [
            editorView,
            decoration
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (appearance === 'comment') {
                let editorContentArea = null;
                if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
                else editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
                if (editorContentArea) {
                    const computedStyle = getComputedStyle(editorContentArea);
                    const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                    const originalPosition = computedStyle.position;
                    if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                    return ()=>{
                        if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                    };
                }
            }
        }, [
            modalDecorationElement,
            appearance,
            editorRelativeWrapper
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            const setModalPosition = ()=>{
                if (!modalRef.current) return;
                if (resizableOrBreakoutWrapper && !editorViewElement.contains(resizableOrBreakoutWrapper)) return;
                const relativePositionElement = resizableOrBreakoutWrapper || editorViewElement;
                const top = (0, (0, parcelRequire("jGwgx")).getModalTop)({
                    modalElement: modalRef.current,
                    editorRelativeWrapper: editorRelativeWrapper,
                    modalDecorationElement: modalDecorationElement,
                    lastTriggeredFrom: lastTriggeredFrom
                });
                const left = (0, (0, parcelRequire("jGwgx")).getModalLeft)({
                    relativePositionElement: relativePositionElement,
                    modalElement: modalRef.current
                });
                setModalLeft(left);
                setModalTop(top);
                setModalWidth(relativePositionElement.offsetWidth);
                if (!transition) setTransition('all 0.1s ease-in');
            };
            setModalPosition();
            const setModalPositionDebounced = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                setModalPosition();
            }, 20);
            const resizeObserver = new ResizeObserver(setModalPositionDebounced);
            resizeObserver.observe(editorViewElement);
            const editorViewOffsetParent = editorViewElement.offsetParent;
            if (editorViewOffsetParent) resizeObserver.observe(editorViewOffsetParent);
            if (resizableOrBreakoutWrapper) resizeObserver.observe(resizableOrBreakoutWrapper);
            return ()=>{
                resizeObserver.disconnect();
                setModalPositionDebounced.cancel();
            };
        }, [
            editorViewElement,
            modalDecorationElement,
            editorRelativeWrapper,
            resizableOrBreakoutWrapper
        ]);
        (0, ($parcel$interopDefault($5uXOq))).useEffect(()=>{
            if (!autoScroll || !modalTop) return;
            const modalEl = modalRef.current;
            if (!modalEl) return;
            const scrollParentEl = (0, (0, parcelRequire("f3dKD")).findOverflowScrollParent)(modalEl);
            if (!scrollParentEl) return;
            const viewportTop = scrollParentEl.scrollTop;
            const viewportBottom = scrollParentEl.scrollTop + (scrollParentEl.offsetHeight - (0, (0, parcelRequire("g0RiJ")).scrollTopMargin));
            const modalTippyTop = Math.max(0, modalTop - modalDecorationElement.offsetHeight);
            const modalBottom = modalTop + modalEl.offsetHeight;
            const isModalWithinViewport = modalTippyTop >= viewportTop && modalBottom <= viewportBottom;
            const isModalAboveViewport = modalTippyTop < viewportTop;
            const isModalFullHeight = scrollParentEl.offsetHeight - (0, (0, parcelRequire("g0RiJ")).scrollTopMargin) < modalEl.scrollHeight;
            if (isModalWithinViewport) return;
            if (isModalFullHeight || isModalAboveViewport) {
                scrollParentEl.scroll({
                    top: Math.max(0, modalTippyTop - (0, (0, parcelRequire("g0RiJ")).scrollTopMargin)),
                    behavior: 'instant'
                });
                return;
            }
            scrollParentEl.scroll({
                top: viewportTop + Math.max(modalBottom - viewportBottom, 0) + (0, (0, parcelRequire("g0RiJ")).scrollTopMargin),
                behavior: 'instant'
            });
        }, [
            autoScroll,
            modalTop,
            modalDecorationElement
        ]);
        (0, (0, parcelRequire("1p2f7")).default)({
            modalElement: modalRef.current,
            editorViewElement: editorViewElement
        });
        if (decorationSet === (0, (0, parcelRequire("etG8M")).DecorationSet).empty) {
            endExperience();
            return null;
        }
        const style = {
            top: modalTop,
            left: modalLeft,
            '--content-width': `${modalWidth}px`,
            transition: transition,
            display: modalWidth ? 'block' : 'none'
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": "ai-plugin-modal",
            css: (0, (0, parcelRequire("4GZLe")).modalStyles),
            style: style,
            ref: modalRef,
            "data-editor-popup": true
        }, children);
    };
});
parcelRegister("4GZLe", function(module, exports) {
    $parcel$export(module.exports, "modalStyles", ()=>$8c8e8a81972ca163$export$367b0302f2a047a4);
    $parcel$export(module.exports, "globalStyles", ()=>$8c8e8a81972ca163$export$aa0e86c7c0d2f400);
    var $f8Sb3;
    var $iHYdz;
    var $5yojI;
    var $bzmFE;
    function $8c8e8a81972ca163$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8c8e8a81972ca163$var$MAX_Z_INDEX = 500;
    const $8c8e8a81972ca163$var$MIN_Z_INDEX = 402;
    let $8c8e8a81972ca163$var$akAiModalRegionZIndex = Math.min($8c8e8a81972ca163$var$MAX_Z_INDEX, Math.max($8c8e8a81972ca163$var$MIN_Z_INDEX, (0, (0, parcelRequire("iHYdz")).akEditorFloatingPanelZIndex) + 2));
    const $8c8e8a81972ca163$var$slideFadeIn = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        from: {
            opacity: 0,
            transform: 'translateY(1rem)'
        },
        to: {
            opacity: 1,
            transform: 'translateY(0)'
        }
    });
    const $8c8e8a81972ca163$export$367b0302f2a047a4 = (0, (0, parcelRequire("f8Sb3")).css)("margin-top:1rem;position:absolute;z-index:", $8c8e8a81972ca163$var$akAiModalRegionZIndex, ";margin-right:-1rem;margin-left:-1rem;width:calc(var(--content-width) + 2rem);animation:", $8c8e8a81972ca163$var$slideFadeIn, " 0.2s ease-out;animation-fill-mode:forwards;@media (prefers-reduced-motion){animation:none;}");
    const $8c8e8a81972ca163$var$aiSuggestionsInlineCommentResetStyles = {
        name: "181ksdh",
        styles: "padding:inherit;border-bottom:inherit;box-shadow:inherit"
    };
    const $8c8e8a81972ca163$var$aiSuggestionsSelectedInlineCommentBackgroundStyles = {
        name: "1djwtw9",
        styles: "background-color:var(--ds-background-accent-yellow-subtlest, #FFF7D6)"
    };
    const $8c8e8a81972ca163$var$highlightStyles = {
        name: "6psdrr",
        styles: "background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);border-bottom:2px solid var(--ds-background-accent-blue-subtler, #cce0ff)"
    };
    const $8c8e8a81972ca163$var$nodeHighlightStyles = {
        name: "1yklvbt",
        styles: "border:1px solid var(--ds-background-accent-blue-subtle, #579DFF);box-shadow:0 0 2px 1px var(--ds-background-accent-blue-subtler, #cce0ff)"
    };
    const $8c8e8a81972ca163$var$cellHighlightStyles = (0, (0, parcelRequire("f8Sb3")).css)($8c8e8a81972ca163$var$nodeHighlightStyles, " ::after{border-left:1px solid var(--ds-background-accent-blue-subtle, #579DFF);border-bottom:1px solid var(--ds-background-accent-blue-subtle, #579DFF);}");
    const $8c8e8a81972ca163$var$spellingErrorStyles = {
        name: "1ptg6e9",
        styles: "border-bottom:2px solid var(--ds-background-accent-magenta-subtle-hovered, #F797D2);border-bottom-style:dashed"
    };
    const $8c8e8a81972ca163$var$autoCorrectStyles = {
        name: "k8sz8u",
        styles: "border-bottom:2px solid var(--ds-text-accent-teal, #206A83);border-bottom-style:dotted"
    };
    const $8c8e8a81972ca163$var$spellingAndGrammarSuggestionStyles = {
        name: "1k1s169",
        styles: "border-bottom:2px dotted var(--ds-chart-blue-bolder, #1D7AFC);cursor:pointer"
    };
    const $8c8e8a81972ca163$var$spellingAndGrammarSuggestionSelectedStyles = {
        name: "1urfulx",
        styles: "border-bottom:2px dotted var(--ds-chart-blue-bolder, #1D7AFC);background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);cursor:pointer"
    };
    const $8c8e8a81972ca163$var$proactiveRecommendationStyles = {
        name: "1k1s169",
        styles: "border-bottom:2px dotted var(--ds-chart-blue-bolder, #1D7AFC);cursor:pointer"
    };
    const $8c8e8a81972ca163$var$proactiveRecommendationSelectedStyles = {
        name: "1urfulx",
        styles: "border-bottom:2px dotted var(--ds-chart-blue-bolder, #1D7AFC);background-color:var(--ds-background-accent-blue-subtlest, #E9F2FF);cursor:pointer"
    };
    var $8c8e8a81972ca163$var$_ref = {
        name: "735ejv",
        styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{max-height:400px;overflow-x:hidden;[data-testid^='ak-editor-ai-selection-toolbar-translate-button'] [data-item-elem-before]>span{padding:0;}}[data-testid='ak-editor-ai-selection-toolbar-ai-dropdown']>span>span{margin:0;}}"
    };
    const $8c8e8a81972ca163$var$translationsFloatingToolbarDropdownStyles = ()=>{
        return $8c8e8a81972ca163$var$_ref;
    };
    const $8c8e8a81972ca163$var$dropdownHeadingStyles = (0, (0, parcelRequire("f8Sb3")).css)("[aria-label='Selection toolbar']{[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']{cursor:default;>span{gap:initial;}[data-item-elem-before]>span{padding:0;}[data-item-title]{text-transform:uppercase;font-size:0.75rem;font-weight:bold;color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`, ";}}[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']:hover{color:", `var(--ds-text, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`, ";}}");
    const $8c8e8a81972ca163$var$rovoAgentsFloatingToolbarDropdownStyles = {
        name: "qazcz6",
        styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{[data-testid='ak-editor-ai-selection-toolbar-dropdown-view-all-agents']:not(:only-child){border-block-start:2px solid var(--ds-menu-seperator-color, var(--ds-border, #e1e3e7));>span{gap:4px;}}button[data-testid^='ak-editor-ai-selection-toolbar-dropdown-agent'] [data-item-title='true']>span{white-space:normal;}}}"
    };
    const $8c8e8a81972ca163$export$aa0e86c7c0d2f400 = (aiThemeColor)=>{
        return (0, (0, parcelRequire("f8Sb3")).css)($8c8e8a81972ca163$var$translationsFloatingToolbarDropdownStyles(), " ", $8c8e8a81972ca163$var$rovoAgentsFloatingToolbarDropdownStyles, " ", $8c8e8a81972ca163$var$dropdownHeadingStyles, " .akEditor div.ProseMirror{.ai-modal-start-widget,.ai-modal-end-widget{position:relative;&::before{content:'';background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');z-index:1;display:block;position:absolute;top:0;bottom:var(--ds-space-negative-025, -2px);background-repeat:no-repeat;background-position-x:center;background-position-y:center;background-size:contain;aspect-ratio:3/20;}}.ai-modal-start-widget::before{left:0px;margin-left:-0.1em;}.ai-modal-end-widget::before{right:0px;margin-right:-0.1em;}.ai-generated-content-highlight{", $8c8e8a81972ca163$var$highlightStyles, ";}.ai-selection-highlight{", $8c8e8a81972ca163$var$highlightStyles, "&.ak-editor-annotation-draft,&.ak-editor-annotation-focus,&.ak-editor-annotation-blur{all:unset;", $8c8e8a81972ca163$var$highlightStyles, ";}}.ai-selection-node.ak-editor-panel,.ai-selection-node.ak-editor-expand{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";}.ai-selection-node[data-layout-section]{[data-layout-column]{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";}}.ai-selection-node .pm-table-wrapper{table tr td,table tr th{", (0, (0, parcelRequire("5yojI")).getSelectionStyles)([
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Border,
            (0, (0, parcelRequire("bzmFE")).SelectionStyle).Blanket
        ]), ";}}.ai-generated-node-highlight.ak-editor-panel,.ai-generated-node-highlight.ak-editor-expand{", $8c8e8a81972ca163$var$nodeHighlightStyles, ";}.ai-generated-node-highlight[data-layout-section]{[data-layout-column]{", $8c8e8a81972ca163$var$nodeHighlightStyles, ";}}.ai-generated-node-highlight .pm-table-wrapper{table tr td,table tr th{", $8c8e8a81972ca163$var$cellHighlightStyles, ";}}.annotationView-content-wrap{.ak-editor-annotation-draft,.ak-editor-annotation-focus,.ak-editor-annotation-blur{&:has(.ai-selection-highlight){all:unset;", $8c8e8a81972ca163$var$highlightStyles, ";}}}.ai-proactive-recommendation{", $8c8e8a81972ca163$var$proactiveRecommendationStyles, " .ak-editor-annotation-draft,.ak-editor-annotation-blur,.ak-editor-annotation-focus{border-bottom:inherit;box-shadow:inherit;}}.ai-proactive-recommendation-selected,.ai-proactive-recommendation-hovered{", $8c8e8a81972ca163$var$proactiveRecommendationSelectedStyles, " .ak-editor-annotation-draft,.ak-editor-annotation-blur,.ak-editor-annotation-focus{border-bottom:inherit;box-shadow:inherit;background-color:inherit;}}.ai-spelling-error{", $8c8e8a81972ca163$var$spellingErrorStyles, ";}.ai-auto-correct{", $8c8e8a81972ca163$var$autoCorrectStyles, ";}.ai-suggestions{", $8c8e8a81972ca163$var$spellingAndGrammarSuggestionStyles, ";}.ai-suggestions-selected{", $8c8e8a81972ca163$var$spellingAndGrammarSuggestionSelectedStyles, ";}.ai-suggestions{.ak-editor-annotation-draft,.ak-editor-annotation-blur,.ak-editor-annotation-focus{", $8c8e8a81972ca163$var$aiSuggestionsInlineCommentResetStyles, ";}}.ai-suggestions-selected{&.ak-editor-annotation-blur,&.ak-editor-annotation-focus{", $8c8e8a81972ca163$var$aiSuggestionsSelectedInlineCommentBackgroundStyles, ";}}.ak-editor-annotation-focus{&:has(.ai-suggestions-selected){", $8c8e8a81972ca163$var$aiSuggestionsInlineCommentResetStyles, ";}.ai-suggestions-selected{", $8c8e8a81972ca163$var$aiSuggestionsSelectedInlineCommentBackgroundStyles, ";}}}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-100, 8px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg{padding-right:var(--ds-space-050, 4px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button']>span:only-child{svg{padding:0px var(--ds-space-100, 8px);}}");
    };
});
parcelRegister("1p2f7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28e7a48865925719$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $28e7a48865925719$export$91249d6c9b15807 = 'ai-height-div';
    function $28e7a48865925719$var$useUpdateEditorHeight({ modalElement: modalElement, editorViewElement: editorViewElement }) {
        const heightDivRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalElement) return;
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!heightDivRef.current || !modalElement) return;
                const modalEntry = entries.find((e)=>e.target === modalElement);
                if (!modalEntry) return;
                const modalBottom = modalEntry.target.offsetTop + modalEntry.contentRect.height;
                const editorBottom = editorViewElement.offsetTop + editorViewElement.offsetHeight;
                const heightToSet = Math.max(modalBottom - editorBottom, 0);
                heightDivRef.current.style.height = `${heightToSet}px`;
            });
            resizeObserver.observe(modalElement);
            return ()=>{
                resizeObserver.disconnect();
            };
        }, [
            modalElement,
            editorViewElement
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (heightDivRef.current) return;
            const newDiv = document.createElement('div');
            newDiv.className = $28e7a48865925719$export$91249d6c9b15807;
            newDiv.style.height = `0px`;
            editorViewElement.parentNode.appendChild(newDiv);
            heightDivRef.current = newDiv;
            return ()=>{
                editorViewElement.parentNode?.removeChild(newDiv);
            };
        }, [
            editorViewElement
        ]);
    }
    var $28e7a48865925719$export$2e2bcd8739ae039 = $28e7a48865925719$var$useUpdateEditorHeight;
});
parcelRegister("jGwgx", function(module, exports) {
    $parcel$export(module.exports, "getModalLeft", ()=>$eccb95df307006c8$export$f695eeeda1b3ceee);
    $parcel$export(module.exports, "getModalTop", ()=>$eccb95df307006c8$export$6fabade9f8472f78);
    $parcel$export(module.exports, "getResizableOrBreakoutWrapper", ()=>$eccb95df307006c8$export$9e4eede810cdf154);
    var $6gEe5;
    var $5r0mK = parcelRequire("5r0mK");
    function $eccb95df307006c8$var$getOffsetParent(element) {
        const offsetParent = element.offsetParent;
        if (offsetParent) return offsetParent;
        let tempOffsetParent = element.parentElement;
        while(tempOffsetParent){
            const position = getComputedStyle(tempOffsetParent).position;
            if (position !== 'static') return tempOffsetParent;
            tempOffsetParent = tempOffsetParent.parentElement;
        }
        return document.body;
    }
    function $eccb95df307006c8$var$getModalOffset({ from: from, modalElement: modalElement, direction: direction }) {
        const property = direction === 'top' ? 'offsetTop' : 'offsetLeft';
        let offset = from[property];
        let tempOffsetParent = from.offsetParent;
        const modalOffsetParent = $eccb95df307006c8$var$getOffsetParent(modalElement);
        while(tempOffsetParent && tempOffsetParent instanceof HTMLElement && tempOffsetParent !== modalOffsetParent){
            offset += tempOffsetParent[property];
            tempOffsetParent = tempOffsetParent.offsetParent;
        }
        return offset;
    }
    function $eccb95df307006c8$export$f695eeeda1b3ceee({ relativePositionElement: relativePositionElement, modalElement: modalElement }) {
        return $eccb95df307006c8$var$getModalOffset({
            from: relativePositionElement,
            modalElement: modalElement,
            direction: 'left'
        });
    }
    function $eccb95df307006c8$var$getDecorationBottom({ modalDecorationElement: modalDecorationElement, modalElement: modalElement }) {
        const offset = $eccb95df307006c8$var$getModalOffset({
            from: modalDecorationElement,
            modalElement: modalElement,
            direction: 'top'
        });
        return offset + modalDecorationElement.offsetHeight;
    }
    function $eccb95df307006c8$export$6fabade9f8472f78({ modalElement: modalElement, editorRelativeWrapper: editorRelativeWrapper, modalDecorationElement: modalDecorationElement, lastTriggeredFrom: lastTriggeredFrom }) {
        const isSuggestTitleQuickAction = lastTriggeredFrom === 'confluenceTitleToolbar';
        return isSuggestTitleQuickAction ? editorRelativeWrapper?.querySelector('.ProseMirror')?.offsetTop || 0 : $eccb95df307006c8$var$getDecorationBottom({
            modalDecorationElement: modalDecorationElement,
            modalElement: modalElement
        });
    }
    function $eccb95df307006c8$export$9e4eede810cdf154(editorView, position) {
        let resolvedPos = editorView.state.doc.resolve(position);
        const { nodes: nodes, marks: marks } = editorView.state.schema;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const resizableNode = (0, $5r0mK.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === nodes.table);
        if (resizableNode) {
            const resizableDomNode = (0, $5r0mK.findDomRefAtPos)(resizableNode.start, domAtPos);
            if (resizableDomNode instanceof HTMLElement) {
                const resizableWrapper = resizableDomNode.closest(`.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
                if (resizableWrapper instanceof HTMLElement) return resizableWrapper;
            }
        }
        const nodeWithBreakout = (0, $5r0mK.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>{
            return currentNode.type === nodes.table && currentNode.attrs.layout !== 'default' || currentNode.marks.some((mark)=>mark.type === marks.breakout);
        });
        if (!nodeWithBreakout) return;
        const domNodeWithBreakout = (0, $5r0mK.findDomRefAtPos)(nodeWithBreakout.start, domAtPos);
        if (!(domNodeWithBreakout instanceof HTMLElement)) return;
        if (!domNodeWithBreakout) return;
        if ([
            nodes.layoutSection,
            nodes.expand
        ].includes(nodeWithBreakout.node.type)) return domNodeWithBreakout.parentElement || undefined;
        if (nodeWithBreakout.node.type === nodes.table) {
            const closest = domNodeWithBreakout.closest(`.${(0, (0, parcelRequire("6gEe5")).TableSharedCssClassName).TABLE_CONTAINER}`);
            return closest instanceof HTMLElement ? closest : undefined;
        }
    }
});
parcelRegister("aDz1d", function(module, exports) {
    $parcel$export(module.exports, "createEditorPluginAIProvider", ()=>$0cbf2ab40303f26b$export$d6cef3fb84829841);
    function $0cbf2ab40303f26b$export$d6cef3fb84829841({ disableAISelectionToolbar: disableAISelectionToolbar, getFetchCustomHeaders: getFetchCustomHeaders, getChannelVariables: getChannelVariables, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, emptyConfig: emptyConfig, rangeConfig: rangeConfig, generativeAIApiUrl: generativeAIApiUrl, allowProactiveAIFeatures: allowProactiveAIFeatures, proactiveAIConfig: proactiveAIConfig, product: product, onExperienceEvent: onExperienceEvent, AIButtonWrapper: AIButtonWrapper, proactiveAIToolbarButtonWrapper: proactiveAIToolbarButtonWrapper, handleFeedbackSubmission: handleFeedbackSubmission, isFullPageExperimentsEnabled: isFullPageExperimentsEnabled, PromptEditor: PromptEditor, disableInterrogation: disableInterrogation, aiUsageDisclaimer: aiUsageDisclaimer, actionSideEffects: actionSideEffects, actionOverrides: actionOverrides, isRovoEnabled: isRovoEnabled, providers: providers, aiLifeCycleDynamicAttributesGetter: aiLifeCycleDynamicAttributesGetter }) {
        return {
            disableAISelectionToolbar: disableAISelectionToolbar,
            disableInterrogation: disableInterrogation,
            getFetchCustomHeaders: getFetchCustomHeaders,
            getChannelVariables: getChannelVariables,
            onDocChangeByAgent: onDocChangeByAgent,
            onAIProviderChanged: onAIProviderChanged,
            emptyConfig: emptyConfig,
            rangeConfig: rangeConfig,
            generativeAIApiUrl: generativeAIApiUrl,
            allowProactiveAIFeatures: allowProactiveAIFeatures,
            proactiveAIConfig: proactiveAIConfig,
            product: product,
            onExperienceEvent: onExperienceEvent,
            AIButtonWrapper: AIButtonWrapper,
            proactiveAIToolbarButtonWrapper: proactiveAIToolbarButtonWrapper,
            handleFeedbackSubmission: handleFeedbackSubmission,
            isFullPageExperimentsEnabled: isFullPageExperimentsEnabled,
            PromptEditor: PromptEditor,
            aiUsageDisclaimer: aiUsageDisclaimer,
            actionSideEffects: actionSideEffects,
            actionOverrides: actionOverrides,
            isRovoEnabled: isRovoEnabled,
            providers: providers,
            aiLifeCycleDynamicAttributesGetter: aiLifeCycleDynamicAttributesGetter
        };
    }
});
parcelRegister("ezCQ6", function(module, exports) {
    $parcel$export(module.exports, "brainstormConfigItem", ()=>$0b719ec535faa1c8$export$d1e9d60c4002b5d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $eUFkl;
    var $PwAM5;
    var $7QN7E;
    var $9I7Qr;
    var $4NVEe;
    var $8gLLR;
    var $b06Aw;
    const $0b719ec535faa1c8$var$SELECTION_TYPE = 'empty';
    const $0b719ec535faa1c8$export$d1e9d60c4002b5d0 = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).BRAINSTORM,
        title: (0, (0, parcelRequire("b06Aw")).messages).title,
        description: (0, (0, parcelRequire("b06Aw")).messages).description,
        selectionType: $0b719ec535faa1c8$var$SELECTION_TYPE,
        getInitialContext: ({ intl: intl })=>({
                userLocale: intl.locale,
                intentSchemaId: 'brainstorm_intent_schema.json',
                document: ''
            }),
        promptLabel: (0, (0, parcelRequire("b06Aw")).messages).promptLabel,
        promptHint: (0, (0, parcelRequire("b06Aw")).messages).promptHint,
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4NVEe")).Icon), {
                shownAt: shownAt
            }),
        triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'brainstorm_intent_schema.json',
                editorSchema: editorSchema,
                currentSelection: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'brainstorm_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'text',
                        entity: '',
                        relationship: undefined
                    }
                ]
            });
        },
        isVisible: ()=>true,
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("4NVEe", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$6e4ca193fccc9d97$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $e78BF;
    var $8K52v;
    const $6e4ca193fccc9d97$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.04101 4.052C8.35608 2.73768 10.1392 1.99937 11.9985 1.99937C13.8578 1.99937 15.6409 2.73768 16.956 4.052C17.581 4.67653 18.0768 5.4181 18.415 6.23433C18.7533 7.05056 18.9274 7.92545 18.9274 8.809C18.9274 9.69254 18.7533 10.5674 18.415 11.3837C18.0768 12.1999 17.581 12.9415 16.956 13.566L16.841 13.678L16.724 13.787L15.998 14.446L16 15.83L15.998 15.862V18.001C15.9976 18.7657 15.7051 19.5014 15.1804 20.0577C14.6557 20.6139 13.9384 20.9489 13.175 20.994L12.998 20.999H10.998C10.2333 20.9988 9.49752 20.7066 8.94104 20.1821C8.38455 19.6576 8.04938 18.9404 8.00401 18.177L7.99801 18.001V14.445L7.27301 13.785C6.01548 12.6426 5.23697 11.0665 5.09394 9.37352C4.95091 7.68057 5.45397 5.99622 6.50201 4.659L6.66401 4.46L6.82001 4.283C6.89182 4.20392 6.96551 4.12756 7.04101 4.052ZM13.998 16.83H9.99801V18.002C9.99831 18.2469 10.0885 18.4832 10.2514 18.666C10.4144 18.8489 10.6387 18.9656 10.882 18.994L10.998 19.001H12.998C13.2431 19.0012 13.4798 18.9114 13.663 18.7486C13.8462 18.5858 13.9633 18.3614 13.992 18.118L13.998 18.002V16.83ZM15.54 5.466C15.0613 4.98771 14.4907 4.61131 13.8626 4.3595C13.2345 4.10769 12.5619 3.98567 11.8854 4.00081C11.2089 4.01595 10.5424 4.16792 9.92623 4.44758C9.31003 4.72724 8.75684 5.12878 8.30001 5.628C7.48334 6.52552 7.04311 7.70273 7.07048 8.91589C7.09784 10.129 7.5907 11.2852 8.44701 12.145L8.61701 12.308L9.67001 13.264C9.84765 13.4255 9.96123 13.6456 9.99001 13.884L9.99701 14.004V14.831H13.997V14.004C13.9971 13.7638 14.0838 13.5316 14.241 13.35L14.325 13.264L15.46 12.231L15.54 12.153C15.9793 11.714 16.3277 11.1928 16.5654 10.6191C16.8032 10.0454 16.9255 9.43049 16.9255 8.80949C16.9255 8.1885 16.8032 7.57358 16.5654 6.99989C16.3277 6.4262 15.9793 5.90497 15.54 5.466Z"
        }));
    const $6e4ca193fccc9d97$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("e78BF"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $6e4ca193fccc9d97$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("e78BF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a46865398d7c7cda$var$_react = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a46865398d7c7cda$var$_UNSAFE_baseNew = $a46865398d7c7cda$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a46865398d7c7cda$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a46865398d7c7cda$var$LightbulbIcon = (props)=>$a46865398d7c7cda$var$_react.default.createElement($a46865398d7c7cda$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M5.75 12.25V14c0 .69.56 1.25 1.25 1.25h2c.69 0 1.25-.56 1.25-1.25v-1.75m-4.5 0v-.715c0-.483-.286-.912-.685-1.182a5.25 5.25 0 1 1 5.871 0c-.4.27-.686.7-.686 1.182v.715m-4.5 0h4.5"/>`
        }, props));
    $a46865398d7c7cda$var$LightbulbIcon.displayName = 'LightbulbIcon';
    var $a46865398d7c7cda$var$_default = module.exports.default = $a46865398d7c7cda$var$LightbulbIcon;
});
parcelRegister("b06Aw", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f3b80d60f9ed825a$export$defe85febe8b728c);
    var $7VHMR;
    const $f3b80d60f9ed825a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.empty.brainstorm.title',
            defaultMessage: 'Brainstorm',
            description: 'Title for "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
        },
        description: {
            id: 'fabric.editor.ai.config.item.empty.brainstorm.description',
            defaultMessage: 'Generates a list of ideas for a topic you provide',
            description: 'Describes the "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
        },
        promptLabel: {
            id: 'fabric.editor.ai.config.item.empty.brainstorm.promptLabel',
            defaultMessage: 'Brainstorm',
            description: 'Label text in the prompt input.'
        },
        promptHint: {
            id: 'fabric.editor.ai.config.item.empty.brainstorm.promptHint',
            defaultMessage: 'Tell me the topic...',
            description: 'Placeholder text in the prompt input guiding user interaction.'
        }
    });
});
parcelRegister("9wspb", function(module, exports) {
    $parcel$export(module.exports, "generateContentConfigItem", ()=>$e433fd941d9debcc$export$149bbbc5e9d18a46);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $1uyji;
    var $kjtjo;
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $8gLLR;
    var $ec6mG;
    var $c97MP;
    const $e433fd941d9debcc$var$SELECTION_TYPE = 'empty';
    const $e433fd941d9debcc$export$149bbbc5e9d18a46 = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FREE_GENERATE,
        title: (0, (0, parcelRequire("kjtjo")).default).aiButtonTitle,
        description: (0, (0, parcelRequire("kjtjo")).default).aiUniversalLongCallToAction,
        promptHint: (0, (0, parcelRequire("c97MP")).messages).promptHint,
        selectionType: $e433fd941d9debcc$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $e433fd941d9debcc$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                document: markdown,
                userLocale: intl.locale,
                intentSchemaId: 'custom_free_generate_intent_schema.json',
                contentStatistics: contentStatistics
            };
        },
        icon: ({ formatMessage: formatMessage })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ec6mG")).default), {
                alt: formatMessage((0, (0, parcelRequire("kjtjo")).default).aiButtonTitle)
            }),
        triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, latestPromptResponse: latestPromptResponse, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
            let contextList;
            if (latestPromptResponse) contextList = [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: latestPromptResponse,
                    relationship: 'PREVIOUS_RESPONSE'
                }
            ];
            else contextList = !initialContext.document ? [] : [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.document,
                    relationship: 'FULL_CONTENT'
                }
            ];
            if (!latestPromptResponse && (0, (0, parcelRequire("1uyji")).checkAssistanceServiceFreeGenerateFg)()) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'custom_free_generate_intent_schema.json',
                editorSchema: editorSchema,
                fullDocument: initialContext.document
            });
            if (latestPromptResponse && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_interrogate_with_convo_ai')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'custom_with_interrogation_intent_schema.json',
                editorSchema: editorSchema,
                draftSelectedContentOverride: latestPromptResponse,
                fullDocument: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: latestPromptResponse ? 'custom_with_interrogation_intent_schema.json' : 'custom_free_generate_intent_schema.json',
                editorSchema: editorSchema,
                contextList: contextList
            });
        },
        isVisible: ()=>true,
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        quickInsertPriority: Number.NEGATIVE_INFINITY,
        getBackendModel: (isInterrogate)=>{
            if (isInterrogate && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_interrogate_with_convo_ai')) return 'assistance-service';
            if (!isInterrogate && (0, (0, parcelRequire("1uyji")).checkAssistanceServiceFreeGenerateFg)()) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("ec6mG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6c12c3817174db7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2Ajl9;
    var $fAal0;
    const $a6c12c3817174db7$var$Icon = ({ alt: alt })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            width: "38",
            height: "38",
            viewBox: "0 0 38 38",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            css: (0, (0, parcelRequire("2Ajl9")).styleIconBackground)
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("title", null, alt), ";", (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            x: "0.5",
            y: "0.5",
            width: "37",
            height: "37",
            rx: "1.5",
            stroke: "url(#paint0_radial_2130_45344)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.17 19C24.17 18.4477 24.6178 18 25.17 18H27C27.5523 18 28 18.4477 28 19C28 19.5523 27.5523 20 27 20H25.17C24.6178 20 24.17 19.5523 24.17 19Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 10C19.5523 10 20 10.4477 20 11V12.83C20 13.3823 19.5523 13.83 19 13.83C18.4477 13.83 18 13.3823 18 12.83V11C18 10.4477 18.4477 10 19 10Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 19C10 18.4477 10.4477 18 11 18H12.83C13.3823 18 13.83 18.4477 13.83 19C13.83 19.5523 13.3823 20 12.83 20H11C10.4477 20 10 19.5523 10 19Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 24.17C19.5523 24.17 20 24.6177 20 25.17V27C20 27.5523 19.5523 28 19 28C18.4477 28 18 27.5523 18 27V25.17C18 24.6177 18.4477 24.17 19 24.17Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.2929 21.2929C21.6834 20.9024 22.3166 20.9024 22.7071 21.2929L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L21.2929 22.7071C20.9024 22.3166 20.9024 21.6834 21.2929 21.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M26.7071 11.2929C27.0976 11.6834 27.0976 12.3166 26.7071 12.7071L22.7071 16.7071C22.3166 17.0976 21.6834 17.0976 21.2929 16.7071C20.9024 16.3166 20.9024 15.6834 21.2929 15.2929L25.2929 11.2929C25.6834 10.9024 26.3166 10.9024 26.7071 11.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.7071 21.2929C17.0976 21.6834 17.0976 22.3166 16.7071 22.7071L12.7071 26.7071C12.3166 27.0976 11.6834 27.0976 11.2929 26.7071C10.9024 26.3166 10.9024 25.6834 11.2929 25.2929L15.2929 21.2929C15.6834 20.9024 16.3166 20.9024 16.7071 21.2929Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("defs", null, (0, (0, parcelRequire("f8Sb3")).jsx)("radialGradient", {
            id: "paint0_radial_2130_45344",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(1 1.5) rotate(44.5937) scale(49.8523)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fAal0")).Border), null))));
    };
    var $a6c12c3817174db7$export$2e2bcd8739ae039 = $a6c12c3817174db7$var$Icon;
});
parcelRegister("c97MP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bfa76bdaf36bceb8$export$defe85febe8b728c);
    var $7VHMR;
    const $bfa76bdaf36bceb8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        promptHint: {
            id: 'fabric.editor.ai.config.item.empty.generateContent.promptHint',
            defaultMessage: 'Write with AI or select from below',
            description: 'Placeholder text in the prompt input guiding user interaction.'
        }
    });
});
parcelRegister("lNAyS", function(module, exports) {
    $parcel$export(module.exports, "suggestResponseConfigItem", ()=>$020aae3de34c212e$export$74d5da20054d93cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $eUFkl;
    var $PwAM5;
    var $7QN7E;
    var $4NVEe;
    var $8gLLR;
    var $hNhth;
    const $020aae3de34c212e$var$SELECTION_TYPE = 'empty';
    const $020aae3de34c212e$export$74d5da20054d93cb = (issueId)=>(0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUGGEST_REPONSE,
            title: (0, (0, parcelRequire("hNhth")).messages).title,
            description: (0, (0, parcelRequire("hNhth")).messages).description,
            selectionType: $020aae3de34c212e$var$SELECTION_TYPE,
            getInitialContext: ({ intl: intl })=>({
                    userLocale: intl.locale,
                    intentSchemaId: 'brainstorm_intent_schema.json',
                    document: ''
                }),
            icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4NVEe")).Icon), {
                    shownAt: shownAt
                }),
            triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    customPrompt: promptInput,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'brainstorm_intent_schema.json',
                    editorSchema: editorSchema,
                    currentSelection: initialContext.document
                }, `/gateway/api/firebolt/1/agent-response/issues/${issueId}/stream`);
            },
            isVisible: ()=>true,
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            getBackendModel: ()=>{
                return 'assistance-service';
            },
            statusLozengeType: (0, (0, parcelRequire("VSDnB")).fg)('platform_remove_jsm_beta_tags') ? undefined : 'beta'
        });
});
parcelRegister("hNhth", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6a228db9f5dcf5d2$export$defe85febe8b728c);
    var $7VHMR;
    const $6a228db9f5dcf5d2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.empty.suggestResponse.title',
            defaultMessage: 'Draft reply',
            description: 'Title for "Suggest a response" Atlassian Intelligence feature shown in editor typeahead and element browser.'
        },
        description: {
            id: 'fabric.editor.ai.config.item.empty.suggestResponse.description',
            defaultMessage: "Drafts a reply based on issues similar to the one you\u2019re working on",
            description: 'Describes the "Suggest a response" Atlassian Intelligence feature shown in editor typeahead and element browser.'
        }
    });
});
parcelRegister("4y6cL", function(module, exports) {
    $parcel$export(module.exports, "summarizePageConfigItem", ()=>$6845cbe9300fccb8$export$8328a332670792a);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $jjS2v;
    var $8gLLR;
    var $aRWc6;
    var $gyL6c;
    const $6845cbe9300fccb8$var$SELECTION_TYPE = 'empty';
    const $6845cbe9300fccb8$export$8328a332670792a = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
        title: (0, (0, parcelRequire("gyL6c")).messages).title,
        description: (0, (0, parcelRequire("gyL6c")).messages).description,
        selectionType: 'empty',
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjS2v")).Icon), {
                shownAt: shownAt
            }),
        getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $6845cbe9300fccb8$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                document: markdown,
                userLocale: intl.locale,
                intentSchemaId: 'summarize_intent_schema.json',
                contentStatistics: contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, streamingListener: streamingListener, analyticsContext: analyticsContext }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'summarize_intent_schema.json',
                editorSchema: editorSchema,
                fullDocument: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: 'summarize_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.document,
                        relationship: 'FULL_CONTENT'
                    }
                ],
                streamingListener: streamingListener
            });
        },
        isVisible: ({ editorView: editorView })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("jjS2v", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$60645ad9aa16e25f$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $e85rp;
    var $8K52v;
    const $60645ad9aa16e25f$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "25",
            viewBox: "0 0 24 25",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M18 16.5H6C5.44772 16.5 5 16.9477 5 17.5C5 18.0523 5.44772 18.5 6 18.5H18C18.5523 18.5 19 18.0523 19 17.5C19 16.9477 18.5523 16.5 18 16.5Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M18 6.5H14C13.4477 6.5 13 6.94772 13 7.5C13 8.05228 13.4477 8.5 14 8.5H18C18.5523 8.5 19 8.05228 19 7.5C19 6.94772 18.5523 6.5 18 6.5Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M18 11.5H6C5.44772 11.5 5 11.9477 5 12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5C19 11.9477 18.5523 11.5 18 11.5Z",
            fill: "var(--ds-icon, #44546F)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M5.375 7.661C5.375 8.14424 5.76675 8.536 6.25 8.536C6.73325 8.536 7.125 8.14424 7.125 7.661C7.125 7.17775 6.73325 6.786 6.25 6.786C5.76675 6.786 5.375 7.17775 5.375 7.661Z",
            fill: "var(--ds-icon, #44546F)",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "1.75"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.375 7.661C9.375 8.14424 9.76675 8.536 10.25 8.536C10.7332 8.536 11.125 8.14424 11.125 7.661C11.125 7.17775 10.7332 6.786 10.25 6.786C9.76675 6.786 9.375 7.17775 9.375 7.661Z",
            fill: "var(--ds-icon, #44546F)",
            stroke: "var(--ds-icon, #44546F)",
            strokeWidth: "1.75"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M5.07 7.989C4.682 6.493 5.481 5.164 6.77 4.955M9.07 7.989C8.682 6.493 9.481 5.164 10.77 4.955",
            fill: "var(--ds-icon, #44546F)",
            strokeLinecap: "round"
        }));
    const $60645ad9aa16e25f$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("e85rp"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $60645ad9aa16e25f$var$IconGlyph,
                    ...props
                })
        }));
    };
});
parcelRegister("e85rp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a4960885fb311613$var$_react = $a4960885fb311613$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $a4960885fb311613$var$_UNSAFE_baseNew = $a4960885fb311613$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $a4960885fb311613$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $a4960885fb311613$var$SummarizeIcon = (props)=>$a4960885fb311613$var$_react.default.createElement($a4960885fb311613$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" d="M3.63 6.75H2.38a.63.63 0 0 1-.62-.62V4.25h1.88c.35 0 .63.28.63.63v1.25c0 .35-.28.63-.62.63m4.98-.01H7.38a.63.63 0 0 1-.62-.62V4.25h1.88c.35 0 .63.28.63.63v1.25c0 .35-.28.63-.62.63"/><path stroke="currentcolor" stroke-width="1.5" d="M3.5 1.75A1.75 1.75 0 0 0 1.75 3.5v.75m0 0v1.875c0 .345.28.625.625.625h1.25c.345 0 .625-.28.625-.625v-1.25a.625.625 0 0 0-.625-.625zm6.75-2.5A1.75 1.75 0 0 0 6.75 3.5v.75m0 0v1.875c0 .345.28.625.625.625h1.25c.345 0 .625-.28.625-.625v-1.25a.625.625 0 0 0-.625-.625zm-5.75 9h14M1 9.75h14m-3.5-3.5H15m-3.5-3.5H15"/>`
        }, props));
    $a4960885fb311613$var$SummarizeIcon.displayName = 'SummarizeIcon';
    var $a4960885fb311613$var$_default = module.exports.default = $a4960885fb311613$var$SummarizeIcon;
});
parcelRegister("gyL6c", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1dd1fe7210daba0c$export$defe85febe8b728c);
    var $7VHMR;
    const $1dd1fe7210daba0c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.empty.summarizePage.title',
            defaultMessage: 'Summarize writing',
            description: 'Title for "Summarize writing" Atlassian Intelligence feature shown in editor typeahead and element browser.'
        },
        description: {
            id: 'fabric.editor.ai.config.item.empty.summarizePage.description',
            defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
            description: 'Describes "Summarize writing" Atlassian Intelligence feature shown in the editor typeahead and element browser.'
        }
    });
});
parcelRegister("aMrA5", function(module, exports) {
    $parcel$export(module.exports, "translationEmptyConfigItems", ()=>$1cbfa6aa0fe40cdb$export$18d6b46f52cdb198);
    var $5uXOq = parcelRequire("5uXOq");
    var $9x5pH;
    var $ltXTD;
    var $VSDnB;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $8gLLR;
    var $aRWc6;
    var $CKwTG;
    var $fnSKb;
    const $1cbfa6aa0fe40cdb$var$SELECTION_TYPE = 'empty';
    const $1cbfa6aa0fe40cdb$var$supportedTranslationLanguages = (0, (0, parcelRequire("fnSKb")).getSortedSupportedTranslationLanguages)();
    const $1cbfa6aa0fe40cdb$export$18d6b46f52cdb198 = $1cbfa6aa0fe40cdb$var$supportedTranslationLanguages.map((language)=>{
        const lang = (0, (0, parcelRequire("CKwTG")).languageMessages)[language];
        if (!lang) return false;
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: `Translate to ${language}`,
            title: (0, (0, parcelRequire("CKwTG")).translateToMessages)[`${language}Title`],
            description: (0, (0, parcelRequire("CKwTG")).translateToMessages)[`${language}Description`],
            selectionType: 'empty',
            nestingConfig: {
                parentTestId: 'translate-to',
                parentTitle: (0, (0, parcelRequire("CKwTG")).languageMessages).nestingParentTitlePostGA,
                shortTitle: lang
            },
            getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const { markdown: markdown, contentStatistics: contentStatistics } = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    node: editorView.state.doc,
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $1cbfa6aa0fe40cdb$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    document: markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'translate_intent_schema.json',
                    contentStatistics: contentStatistics,
                    targetTranslationLanguage: lang.defaultMessage
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    transformationSubtype: lang.defaultMessage,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'translate_intent_schema.json',
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document
                });
                return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                    targetTranslationLanguage: lang.defaultMessage,
                    userLocale: initialContext.userLocale,
                    editorSchema: editorSchema,
                    intentSchemaId: 'translate_intent_schema.json',
                    contextList: [
                        {
                            type: 'ADF_MARKDOWN_V1',
                            entity: initialContext.document,
                            relationship: 'FULL_CONTENT'
                        }
                    ]
                });
            },
            isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                    editorView: editorView,
                    minLength: 1,
                    positions: positions
                }),
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ltXTD"))))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious",
                    LEGACY_fallbackIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9x5pH"))))), {
                            label: "",
                            color: "var(--ds-icon, #44546F)"
                        })
                }),
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, (0, parcelRequire("8gLLR")).createReplace)({
                    appearance: 'primary'
                })
            ]
        });
    }).filter(Boolean);
});
parcelRegister("ltXTD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fa3ac495a92a0a43$var$_react = $fa3ac495a92a0a43$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fa3ac495a92a0a43$var$_UNSAFE_baseNew = $fa3ac495a92a0a43$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $fa3ac495a92a0a43$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fa3ac495a92a0a43$var$TranslateIcon = (props)=>$fa3ac495a92a0a43$var$_react.default.createElement($fa3ac495a92a0a43$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 15v-.375l-1.056-2.375M7.75 15v-.375l1.056-2.375m0 0 2.444-5.5h.5l2.444 5.5m-5.388 0h5.388M0 3.75h4.75m0 0V1m0 2.75h1.5m0 0H9.5m-3.25 0c-.243 2.184-.78 4.015-1.568 5.55m0 0a11.5 11.5 0 0 1-3.307 3.95M4.682 9.3C3.868 8.311 3.184 7.155 2.75 6m1.932 3.3c.594.72 1.257 1.35 1.943 1.825"/>`
        }, props));
    $fa3ac495a92a0a43$var$TranslateIcon.displayName = 'TranslateIcon';
    var $fa3ac495a92a0a43$var$_default = module.exports.default = $fa3ac495a92a0a43$var$TranslateIcon;
});
parcelRegister("CKwTG", function(module, exports) {
    $parcel$export(module.exports, "languageMessages", ()=>$f90a0d7ab19e416a$export$d06ea6e613575d33);
    $parcel$export(module.exports, "translateToMessages", ()=>$f90a0d7ab19e416a$export$daaaebef8c547811);
    var $7VHMR;
    const $f90a0d7ab19e416a$export$d06ea6e613575d33 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nestingParentTitle: {
            id: 'fabric.editor.ai.config.item.translate.nestingParentTitle.ga',
            defaultMessage: 'Translate',
            description: 'The nested title which shows in the generative-ai-modal'
        },
        nestingParentTitlePostGA: {
            id: 'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA',
            defaultMessage: 'Translate to ...',
            description: 'The nested title which shows in the generative-ai-modal'
        },
        chineseSimplified: {
            id: 'fabric.editor.ai.config.item.translate.chineseSimplified',
            defaultMessage: 'Chinese (Simplified)',
            description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Simplified)'
        },
        chineseTraditional: {
            id: 'fabric.editor.ai.config.item.translate.chineseTraditional',
            defaultMessage: 'Chinese (Traditional)',
            description: 'Language string referenced in UIs involving the translation AI prompt for Chinese (Traditional)'
        },
        czech: {
            id: 'fabric.editor.ai.config.item.translate.czech',
            defaultMessage: 'Czech',
            description: 'Language string referenced in UIs involving the translation AI prompt for Czech'
        },
        danish: {
            id: 'fabric.editor.ai.config.item.translate.danish',
            defaultMessage: 'Danish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Danish'
        },
        dutch: {
            id: 'fabric.editor.ai.config.item.translate.dutch',
            defaultMessage: 'Dutch',
            description: 'Language string referenced in UIs involving the translation AI prompt for Dutch'
        },
        english: {
            id: 'fabric.editor.ai.config.item.translate.english',
            defaultMessage: 'English',
            description: 'Language string referenced in UIs involving the translation AI prompt for English'
        },
        finnish: {
            id: 'fabric.editor.ai.config.item.translate.finnish',
            defaultMessage: 'Finnish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Finnish'
        },
        french: {
            id: 'fabric.editor.ai.config.item.translate.french',
            defaultMessage: 'French',
            description: 'Language string referenced in UIs involving the translation AI prompt for French'
        },
        german: {
            id: 'fabric.editor.ai.config.item.translate.german',
            defaultMessage: 'German',
            description: 'Language string referenced in UIs involving the translation AI prompt for German'
        },
        hungarian: {
            id: 'fabric.editor.ai.config.item.translate.hungarian',
            defaultMessage: 'Hungarian',
            description: 'Language string referenced in UIs involving the translation AI prompt for Hungarian'
        },
        italian: {
            id: 'fabric.editor.ai.config.item.translate.italian',
            defaultMessage: 'Italian',
            description: 'Language string referenced in UIs involving the translation AI prompt for Italian'
        },
        japanese: {
            id: 'fabric.editor.ai.config.item.translate.japanese',
            defaultMessage: 'Japanese',
            description: 'Language string referenced in UIs involving the translation AI prompt for Japanese'
        },
        korean: {
            id: 'fabric.editor.ai.config.item.translate.korean',
            defaultMessage: 'Korean',
            description: 'Language string referenced in UIs involving the translation AI prompt for Korean'
        },
        norwegian: {
            id: 'fabric.editor.ai.config.item.translate.norwegian',
            defaultMessage: 'Norwegian',
            description: 'Language string referenced in UIs involving the translation AI prompt for Norwegian'
        },
        polish: {
            id: 'fabric.editor.ai.config.item.translate.polish',
            defaultMessage: 'Polish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Polish'
        },
        portugueseBrazilian: {
            id: 'fabric.editor.ai.config.item.translate.portugueseBrazilian',
            defaultMessage: 'Portuguese (Brazilian)',
            description: 'Language string referenced in UIs involving the translation AI prompt for Portuguese (Brazilian)'
        },
        russian: {
            id: 'fabric.editor.ai.config.item.translate.russian',
            defaultMessage: 'Russian',
            description: 'Language string referenced in UIs involving the translation AI prompt for Russian'
        },
        spanish: {
            id: 'fabric.editor.ai.config.item.translate.spanish',
            defaultMessage: 'Spanish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Spanish'
        },
        swedish: {
            id: 'fabric.editor.ai.config.item.translate.swedish',
            defaultMessage: 'Swedish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Swedish'
        },
        turkish: {
            id: 'fabric.editor.ai.config.item.translate.turkish',
            defaultMessage: 'Turkish',
            description: 'Language string referenced in UIs involving the translation AI prompt for Turkish'
        },
        thai: {
            id: 'fabric.editor.ai.config.item.translate.thai',
            defaultMessage: 'Thai',
            description: 'Language string referenced in UIs involving the translation AI prompt for Thai'
        },
        ukrainian: {
            id: 'fabric.editor.ai.config.item.translate.ukrainian',
            defaultMessage: 'Ukrainian',
            description: 'Language string referenced in UIs involving the translation AI prompt for Ukrainian'
        },
        vietnamese: {
            id: 'fabric.editor.ai.config.item.translate.vietnamese',
            defaultMessage: 'Vietnamese',
            description: 'Language string referenced in UIs involving the translation AI prompt for Vietnamese'
        }
    });
    const $f90a0d7ab19e416a$export$daaaebef8c547811 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        chineseSimplifiedTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.title',
            defaultMessage: 'Translate to Chinese (Simplified)',
            description: 'Title of a prompt that translates the selected content into Chinese (Simplified)'
        },
        chineseSimplifiedDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.chineseSimplified.description',
            defaultMessage: "Translates the text you're working on to Chinese (Simplified)",
            description: 'Description for prompt that translates selected content into Chinese (Simplified)'
        },
        chineseTraditionalTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.title',
            defaultMessage: 'Translate to Chinese (Traditional)',
            description: 'Title of a prompt that translates the selected content into Chinese (Traditional)'
        },
        chineseTraditionalDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.chineseTraditional.description',
            defaultMessage: "Translates the text you're working on to Chinese (Traditional)",
            description: 'Description for prompt that translates selected content into Chinese (Traditional)'
        },
        czechTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.czech.title',
            defaultMessage: 'Translate to Czech',
            description: 'Title of a prompt that translates the selected content into Czech'
        },
        czechDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.czech.description',
            defaultMessage: "Translates the text you're working on to Czech",
            description: 'Description for prompt that translates selected content into Czech'
        },
        danishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.danish.title',
            defaultMessage: 'Translate to Danish',
            description: 'Title of a prompt that translates the selected content into Danish'
        },
        danishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.danish.description',
            defaultMessage: "Translates the text you're working on to Danish",
            description: 'Description for prompt that translates selected content into Danish'
        },
        dutchTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.dutch.title',
            defaultMessage: 'Translate to Dutch',
            description: 'Title of a prompt that translates the selected content into Dutch'
        },
        dutchDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.dutch.description',
            defaultMessage: "Translates the text you're working on to Dutch",
            description: 'Description for prompt that translates selected content into Dutch'
        },
        englishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.english.title',
            defaultMessage: 'Translate to English',
            description: 'Title of a prompt that translates the selected content into English'
        },
        englishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.english.description',
            defaultMessage: "Translates the text you're working on to English",
            description: 'Description for prompt that translates selected content into English'
        },
        finnishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.finnish.title',
            defaultMessage: 'Translate to Finnish',
            description: 'Title of a prompt that translates the selected content into Finnish'
        },
        finnishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.finnish.description',
            defaultMessage: "Translates the text you're working on to Finnish",
            description: 'Description for prompt that translates selected content into Finnish'
        },
        frenchTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.french.title',
            defaultMessage: 'Translate to French',
            description: 'Title of a prompt that translates the selected content into French'
        },
        frenchDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.french.description',
            defaultMessage: "Translates the text you're working on to French",
            description: 'Description for prompt that translates selected content into French'
        },
        germanTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.german.title',
            defaultMessage: 'Translate to German',
            description: 'Title of a prompt that translates the selected content into German'
        },
        germanDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.german.description',
            defaultMessage: "Translates the text you're working on to German",
            description: 'Description for prompt that translates selected content into German'
        },
        hungarianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.hungarian.title',
            defaultMessage: 'Translate to Hungarian',
            description: 'Title of a prompt that translates the selected content into Hungarian'
        },
        hungarianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.hungarian.description',
            defaultMessage: "Translates the text you're working on to Hungarian",
            description: 'Description for prompt that translates selected content into Hungarian'
        },
        italianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.italian.title',
            defaultMessage: 'Translate to Italian',
            description: 'Title of a prompt that translates the selected content into Italian'
        },
        italianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.italian.description',
            defaultMessage: "Translates the text you're working on to Italian",
            description: 'Description for prompt that translates selected content into Italian'
        },
        japaneseTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.japanese.title',
            defaultMessage: 'Translate to Japanese',
            description: 'Title of a prompt that translates the selected content into Japanese'
        },
        japaneseDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.japanese.description',
            defaultMessage: "Translates the text you're working on to Japanese",
            description: 'Description for prompt that translates selected content into Japanese'
        },
        koreanTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.korean.title',
            defaultMessage: 'Translate to Korean',
            description: 'Title of a prompt that translates the selected content into Korean'
        },
        koreanDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.korean.description',
            defaultMessage: "Translates the text you're working on to Korean",
            description: 'Description for prompt that translates selected content into Korean'
        },
        norwegianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.norwegian.title',
            defaultMessage: 'Translate to Norwegian',
            description: 'Title of a prompt that translates the selected content into Norwegian'
        },
        norwegianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.norwegian.description',
            defaultMessage: "Translates the text you're working on to Norwegian",
            description: 'Description for prompt that translates selected content into Norwegian'
        },
        polishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.polish.title',
            defaultMessage: 'Translate to Polish',
            description: 'Title of a prompt that translates the selected content into Polish'
        },
        polishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.polish.description',
            defaultMessage: "Translates the text you're working on to Polish",
            description: 'Description for prompt that translates selected content into Polish'
        },
        portugueseBrazilianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title',
            defaultMessage: 'Translate to Portuguese (Brazilian)',
            description: 'Title of a prompt that translates the selected content into Portuguese (Brazilian)'
        },
        portugueseBrazilianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description',
            defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)",
            description: 'Description for prompt that translates selected content into Portuguese (Brazilian)'
        },
        russianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.russian.title',
            defaultMessage: 'Translate to Russian',
            description: 'Title of a prompt that translates the selected content into Russian'
        },
        russianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.russian.description',
            defaultMessage: "Translates the text you're working on to Russian",
            description: 'Description for prompt that translates selected content into Russian'
        },
        spanishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.spanish.title',
            defaultMessage: 'Translate to Spanish',
            description: 'Title of a prompt that translates the selected content into Spanish'
        },
        spanishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.spanish.description',
            defaultMessage: "Translates the text you're working on to Spanish",
            description: 'Description for prompt that translates selected content into Spanish'
        },
        swedishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.swedish.title',
            defaultMessage: 'Translate to Swedish',
            description: 'Title of a prompt that translates the selected content into Swedish'
        },
        swedishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.swedish.description',
            defaultMessage: "Translates the text you're working on to Swedish",
            description: 'Description for prompt that translates selected content into Swedish'
        },
        turkishTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.turkish.title',
            defaultMessage: 'Translate to Turkish',
            description: 'Title of a prompt that translates the selected content into Turkish'
        },
        turkishDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.turkish.description',
            defaultMessage: "Translates the text you're working on to Turkish",
            description: 'Description for prompt that translates selected content into Turkish'
        },
        thaiTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.thai.title',
            defaultMessage: 'Translate to Thai',
            description: 'Title of a prompt that translates the selected content into Thai'
        },
        thaiDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.thai.description',
            defaultMessage: "Translates the text you're working on to Thai",
            description: 'Description for prompt that translates selected content into Thai'
        },
        ukrainianTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.ukrainian.title',
            defaultMessage: 'Translate to Ukrainian',
            description: 'Title of a prompt that translates the selected content into Ukrainian'
        },
        ukrainianDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.ukrainian.description',
            defaultMessage: "Translates the text you're working on to Ukrainian",
            description: 'Description for prompt that translates selected content into Ukrainian'
        },
        vietnameseTitle: {
            id: 'fabric.editor.ai.config.item.translateTo.vietnamese.title',
            defaultMessage: 'Translate to Vietnamese',
            description: 'Title of a prompt that translates the selected content into Vietnamese'
        },
        vietnameseDescription: {
            id: 'fabric.editor.ai.config.item.translateTo.vietnamese.description',
            defaultMessage: "Translates the text you're working on to Vietnamese",
            description: 'Description for prompt that translates selected content into Vietnamese'
        }
    });
});
parcelRegister("fnSKb", function(module, exports) {
    $parcel$export(module.exports, "getSortedSupportedTranslationLanguages", ()=>$8fe5ca6b154d13ee$export$a288aff1b8104a05);
    $parcel$export(module.exports, "isRefinementSupport", ()=>$8fe5ca6b154d13ee$export$9429b43310621fcf);
    var $3Fceg;
    const $8fe5ca6b154d13ee$export$a288aff1b8104a05 = ()=>{
        return 0, (0, parcelRequire("3Fceg")).supportedTranslationLanguagesPopularOrder;
    };
    const $8fe5ca6b154d13ee$export$f54f1bab33a30a3f = (latestPrompt)=>typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' && latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
    const $8fe5ca6b154d13ee$export$9429b43310621fcf = (language)=>(0, (0, parcelRequire("3Fceg")).refinementSupportedTranslationLanguages).includes(language);
});
parcelRegister("4AGFf", function(module, exports) {
    $parcel$export(module.exports, "generateFromSelectionConfigItem", ()=>$157966d4c6212d95$export$28d59d206d6a320c);
    var $VSDnB;
    var $1uyji;
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $8gLLR;
    var $aRWc6;
    var $G4TvM;
    const $157966d4c6212d95$var$SELECTION_TYPE = 'range';
    const $157966d4c6212d95$export$28d59d206d6a320c = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).FREE_GENERATE,
        title: (0, (0, parcelRequire("G4TvM")).messages).title,
        description: (0, (0, parcelRequire("G4TvM")).messages).description,
        selectionType: $157966d4c6212d95$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                slice: editorView.state.doc.slice(positions[0], positions[1]),
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $157966d4c6212d95$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $157966d4c6212d95$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'custom_with_interrogation_intent_schema.json',
                contentStatistics: selection.contentStatistics
            };
        },
        promptHint: (0, (0, parcelRequire("G4TvM")).messages).promptHint,
        triggerPromptRequest ({ promptInput: promptInput, initialContext: initialContext, latestPromptResponse: latestPromptResponse, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
            let contextList;
            if (latestPromptResponse) contextList = [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: latestPromptResponse,
                    relationship: 'PREVIOUS_RESPONSE'
                }
            ];
            else contextList = [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.selection,
                    relationship: 'SELECTION'
                }
            ];
            if (!latestPromptResponse && (0, (0, parcelRequire("1uyji")).checkAssistanceServiceFreeGenerateFg)()) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'custom_free_generate_intent_schema.json',
                editorSchema: editorSchema,
                currentSelection: initialContext.selection,
                fullDocument: initialContext.document
            });
            if (latestPromptResponse && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_interrogate_with_convo_ai')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'custom_with_interrogation_intent_schema.json',
                editorSchema: editorSchema,
                draftSelectedContentOverride: latestPromptResponse,
                currentSelection: initialContext.selection,
                fullDocument: initialContext.document
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                customPrompt: promptInput,
                userLocale: initialContext.userLocale,
                editorSchema: editorSchema,
                contextList: contextList,
                intentSchemaId: latestPromptResponse ? 'custom_with_interrogation_intent_schema.json' : 'custom_free_generate_intent_schema.json'
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, (0, parcelRequire("8gLLR")).createReplace)({
                appearance: 'primary'
            })
        ],
        getBackendModel: (isInterrogate)=>{
            if (isInterrogate && (0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_interrogate_with_convo_ai')) return 'assistance-service';
            if (!isInterrogate && (0, (0, parcelRequire("1uyji")).checkAssistanceServiceFreeGenerateFg)()) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("G4TvM", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$e6e2f1cedeebe881$export$defe85febe8b728c);
    var $7VHMR;
    const $e6e2f1cedeebe881$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.range.generateFromSelection.title',
            defaultMessage: 'Atlassian Intelligence',
            description: '...'
        },
        promptHint: {
            id: 'fabric.editor.ai.config.item.range.generateFromSelection.promptHint',
            defaultMessage: 'Tell AI to write anything or choose from below',
            description: 'Placeholder text in the prompt input guiding user interaction.'
        },
        description: {
            id: 'fabric.editor.ai.config.item.range.generateFromSelection.description',
            defaultMessage: 'Generate from selection',
            description: 'Placeholder text in the prompt input guiding user interaction.'
        }
    });
});
parcelRegister("dzpDy", function(module, exports) {
    $parcel$export(module.exports, "reformatWithTemplateConfigItem", ()=>$d4bca7e0f3ddbe58$export$8c3ef55aa901b0eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $bHfHH;
    var $cBjUJ;
    var $8gLLR;
    var $aRWc6;
    var $8gvqH;
    var $lmugH;
    const $d4bca7e0f3ddbe58$var$SELECTION_TYPE = 'range';
    function $d4bca7e0f3ddbe58$var$createOption({ key: key, title: title, description: description, icon: icon, getAdditionalProps: getAdditionalProps }) {
        return (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: key,
            title: title,
            description: description,
            selectionType: $d4bca7e0f3ddbe58$var$SELECTION_TYPE,
            getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $d4bca7e0f3ddbe58$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    node: editorView.state.doc,
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $d4bca7e0f3ddbe58$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    selection: selection.markdown,
                    document: document.markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'issue_reformatter_intent_schema.json',
                    contentStatistics: selection.contentStatistics
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext }) {
                return (0, (0, parcelRequire("bHfHH")).streamIssueReformatterConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    userLocale: initialContext.userLocale,
                    editorSchema: editorSchema,
                    currentSelection: initialContext.selection,
                    fullDocument: initialContext.document,
                    additionalPayload: {
                        ...getAdditionalProps?.()
                    }
                });
            },
            isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                    editorView: editorView,
                    minLength: 1,
                    positions: positions
                }),
            icon: icon,
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, (0, parcelRequire("8gLLR")).createReplace)({
                    appearance: 'primary'
                })
            ],
            getBackendModel: ()=>'assistance-service',
            ...(0, (0, parcelRequire("VSDnB")).fg)('platform_gravityai-1853_issue_reformatter_ga') ? {} : {
                statusLozengeType: 'beta'
            }
        });
    }
    const $d4bca7e0f3ddbe58$export$8c3ef55aa901b0eb = (options)=>$d4bca7e0f3ddbe58$var$createOption({
            key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).ADD_STRUCTURE,
            title: (0, (0, parcelRequire("lmugH")).messages).improveDescription,
            description: (0, (0, parcelRequire("lmugH")).messages).reformatWithTemplateDescription,
            icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cBjUJ")).Icon), {
                    shownAt: shownAt
                }),
            getAdditionalProps: options.getAdditionalProps
        });
});
parcelRegister("bHfHH", function(module, exports) {
    $parcel$export(module.exports, "streamIssueReformatterConvoAI", ()=>$6537e4c0c2b18a99$export$d974b98c0caff9d3);
    var $e4Vft;
    var $gIHA4;
    var $3RkUa;
    const $6537e4c0c2b18a99$export$d974b98c0caff9d3 = (input)=>{
        return function promptRequest(requestOptions) {
            let issue_description = input.fullDocument;
            const streamingResponseGenerator = (0, (0, parcelRequire("gIHA4")).startStreamingResponse)({
                endpoint: (0, (0, parcelRequire("e4Vft")).convoAIStatelessApiURL),
                experienceId: 'issue-reformatter',
                payload: JSON.stringify({
                    ai_session_id: input.aiSessionId,
                    recipient_agent_named_id: 'jira_issue_reformatter_agent',
                    agent_input_context: {
                        locale: input.userLocale,
                        issue_description: issue_description,
                        ...input?.additionalPayload
                    }
                }),
                ...requestOptions
            });
            return (0, (0, parcelRequire("3RkUa")).streamResponseParser)({
                streamingResponseGenerator: streamingResponseGenerator,
                isConvoAI: true
            });
        };
    };
});
parcelRegister("cBjUJ", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$07947f444cf53c95$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8K52v;
    const $07947f444cf53c95$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "var(--ds-icon, #44546F)",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
        })));
    };
});
parcelRegister("lmugH", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$707b155d2ca7b67f$export$defe85febe8b728c);
    var $7VHMR;
    const $707b155d2ca7b67f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        reformatWithTemplateDescription: {
            id: 'fabric.editor.ai.config.item.range.reformatWithTemplate.default.description',
            defaultMessage: 'Restructure the issue description based on the issue type',
            description: 'Description for the Atlassian Intelligence "Add structure" feature.'
        },
        improveDescription: {
            id: 'fabric.editor.ai.config.item.range.reformatWithTemplate.default.title.experiment.one',
            defaultMessage: 'Improve description',
            description: 'Describes an option to use Atlassian Intelligence to add structure to the issue description currently selected by the user.'
        }
    });
});
parcelRegister("k4yDK", function(module, exports) {
    $parcel$export(module.exports, "shortenConfigItem", ()=>$9a6c230ecbf50706$export$8f482ff8373a6623);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $3eqWK;
    var $8gLLR;
    var $aRWc6;
    var $8gvqH;
    var $3D5rg;
    const $9a6c230ecbf50706$var$SELECTION_TYPE = 'range';
    const $9a6c230ecbf50706$export$8f482ff8373a6623 = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).MAKE_SHORTER,
        title: (0, (0, parcelRequire("3D5rg")).messages).title,
        description: (0, (0, parcelRequire("3D5rg")).messages).description,
        selectionType: $9a6c230ecbf50706$var$SELECTION_TYPE,
        showInRefineDropdown: true,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $9a6c230ecbf50706$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                selection: selection.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'shorten_intent_schema.json',
                contentStatistics: selection.contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext, latestPromptResponse: latestPromptResponse }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'shorten_intent_schema.json',
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                draftSelectedContentOverride: (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true) ? latestPromptResponse : undefined,
                currentSelection: initialContext.selection
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: 'shorten_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ]
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3eqWK")).Icon), {
                shownAt: shownAt
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, (0, parcelRequire("8gLLR")).createReplace)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("3eqWK", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$50f454383881b0d8$export$f04a61298a47a40f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    var $7y8WE;
    var $8K52v;
    const $50f454383881b0d8$var$IconGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            role: "presentation",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13Z"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M17 9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9Z"
        }));
    const $50f454383881b0d8$export$f04a61298a47a40f = (props)=>{
        const { shownAt: shownAt } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8K52v")).RainbowBorder), {
            shownAt: shownAt
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7y8WE"))))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            LEGACY_fallbackIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
                    glyph: $50f454383881b0d8$var$IconGlyph,
                    ...props
                }),
            LEGACY_secondaryColor: "var(--ds-icon, #44546F)"
        }));
    };
});
parcelRegister("7y8WE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57f2a5a60cdc1d20$var$_react = $57f2a5a60cdc1d20$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $57f2a5a60cdc1d20$var$_UNSAFE_baseNew = $57f2a5a60cdc1d20$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $57f2a5a60cdc1d20$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57f2a5a60cdc1d20$var$TextShortenIcon = (props)=>$57f2a5a60cdc1d20$var$_react.default.createElement($57f2a5a60cdc1d20$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1 10.25h7m-7-4.5h14"/>`
        }, props));
    $57f2a5a60cdc1d20$var$TextShortenIcon.displayName = 'TextShortenIcon';
    var $57f2a5a60cdc1d20$var$_default = module.exports.default = $57f2a5a60cdc1d20$var$TextShortenIcon;
});
parcelRegister("6LWXh", function(module, exports) {
    $parcel$export(module.exports, "summarizeConfigItem", ()=>$08c674e3c88e6f01$export$2c3d09ca61ac103b);
    var $5uXOq = parcelRequire("5uXOq");
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $eUFkl;
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $jjS2v;
    var $8gLLR;
    var $aRWc6;
    var $8gvqH;
    var $3qMtl;
    const $08c674e3c88e6f01$var$SELECTION_TYPE = 'range';
    const $08c674e3c88e6f01$export$2c3d09ca61ac103b = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
        key: (0, (0, parcelRequire("eUFkl")).CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
        title: (0, (0, parcelRequire("3qMtl")).messages).title,
        description: (0, (0, parcelRequire("3qMtl")).messages).description,
        selectionType: $08c674e3c88e6f01$var$SELECTION_TYPE,
        showInRefineDropdown: true,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
            const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $08c674e3c88e6f01$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            const document = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $08c674e3c88e6f01$var$SELECTION_TYPE,
                mentionMap: mentionMap
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'summarize_intent_schema.json',
                contentStatistics: selection.contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext, latestPromptResponse: latestPromptResponse }) {
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                aiSessionId: analyticsContext?.aiSessionId,
                userLocale: initialContext.userLocale,
                intentSchemaId: 'summarize_intent_schema.json',
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                draftSelectedContentOverride: (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true) ? latestPromptResponse : undefined,
                currentSelection: initialContext.selection
            });
            return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                userLocale: initialContext.userLocale,
                intentSchemaId: 'summarize_intent_schema.json',
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ]
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: ({ shownAt: shownAt })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjS2v")).Icon), {
                shownAt: shownAt
            }),
        actions: [
            (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, (0, parcelRequire("8gLLR")).createReplace)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return 'assistance-service';
            return 'xp-gen-ai';
        }
    });
});
parcelRegister("3qMtl", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$47a6fcfac112fb71$export$defe85febe8b728c);
    var $7VHMR;
    const $47a6fcfac112fb71$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            id: 'fabric.editor.ai.config.item.range.summarize.title',
            defaultMessage: 'Summarize writing',
            description: 'Describes an option to use Atlassian Intellgience to summarize the content currently selected by the user'
        },
        description: {
            id: 'fabric.editor.ai.config.item.range.summarize.description',
            defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
            description: 'Describes "Summarize writing" Atlassian Intelligence feature to summarize the content currently selected by the user'
        },
        selectionToolbarDropdownItemTitle: {
            id: 'fabric.editor.ai.config.item.range.summarize.dropdownItem.title',
            defaultMessage: 'Summarize writing',
            description: 'Title for Atlassian Intelligence "Summarize writing" in editor selection floating toolbar'
        }
    });
});
parcelRegister("5UEED", function(module, exports) {
    $parcel$export(module.exports, "translationRangeConfigItems", ()=>$0cc5f327ad03b422$export$930671cb8514d6ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $9x5pH;
    var $ltXTD;
    var $VSDnB;
    var $gmhCD = parcelRequire("gmhCD");
    var $PwAM5;
    var $4aQKT;
    var $7QN7E;
    var $9I7Qr;
    var $8gLLR;
    var $aRWc6;
    var $CKwTG;
    var $fnSKb;
    var $8gvqH;
    const $0cc5f327ad03b422$var$SELECTION_TYPE = 'range';
    const $0cc5f327ad03b422$var$supportedTranslationLanguages = (0, (0, parcelRequire("fnSKb")).getSortedSupportedTranslationLanguages)();
    const $0cc5f327ad03b422$var$translationRangeConfigItemsArr = $0cc5f327ad03b422$var$supportedTranslationLanguages.map((language)=>{
        const lang = (0, (0, parcelRequire("CKwTG")).languageMessages)[language];
        if (!lang) return false;
        const configItem = (0, (0, parcelRequire("PwAM5")).createEditorPluginAIConfigItemMarkdown)({
            key: `Translate to ${language}`,
            title: (0, (0, parcelRequire("CKwTG")).translateToMessages)[`${language}Title`],
            description: (0, (0, parcelRequire("CKwTG")).translateToMessages)[`${language}Description`],
            selectionType: 'range',
            nestingConfig: {
                parentTitle: (0, (0, parcelRequire("CKwTG")).languageMessages).nestingParentTitlePostGA,
                shortTitle: lang
            },
            showInRefineDropdown: (0, (0, parcelRequire("fnSKb")).isRefinementSupport)(language),
            getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap, mentionMap: mentionMap })=>{
                const selection = (0, (0, parcelRequire("4aQKT")).sliceOrNodeToMarkdown)({
                    slice: (0, (0, parcelRequire("8gvqH")).getSlice)(editorView, positions),
                    editorView: editorView,
                    convertTo: 'markdown-plus',
                    updateIdMap: updateIdMap,
                    selectionType: $0cc5f327ad03b422$var$SELECTION_TYPE,
                    mentionMap: mentionMap
                });
                return {
                    selection: selection.markdown,
                    userLocale: intl.locale,
                    intentSchemaId: 'translate_intent_schema.json',
                    contentStatistics: selection.contentStatistics,
                    targetTranslationLanguage: lang.defaultMessage
                };
            },
            triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, analyticsContext: analyticsContext, latestPromptResponse: latestPromptResponse }) {
                if ((0, (0, parcelRequire("VSDnB")).fg)('platform_editor_ai_assistance_service')) return (0, (0, parcelRequire("7QN7E")).streamConvoAI)({
                    aiSessionId: analyticsContext?.aiSessionId,
                    transformationSubtype: lang.defaultMessage,
                    userLocale: initialContext.userLocale,
                    intentSchemaId: 'translate_intent_schema.json',
                    editorSchema: editorSchema,
                    fullDocument: initialContext.document,
                    draftSelectedContentOverride: (0, $gmhCD.editorExperiment)('platform_editor_ai_refine_response_button', true) ? latestPromptResponse : undefined,
                    currentSelection: initialContext.selection
                });
                return (0, (0, parcelRequire("9I7Qr")).streamXPGenAI)({
                    targetTranslationLanguage: lang.defaultMessage,
                    userLocale: initialContext.userLocale,
                    editorSchema: editorSchema,
                    intentSchemaId: 'translate_intent_schema.json',
                    contextList: [
                        {
                            type: 'ADF_MARKDOWN_V1',
                            entity: initialContext.selection,
                            relationship: 'SELECTION'
                        }
                    ]
                });
            },
            isVisible: ({ editorView: editorView, positions: positions })=>(0, (0, parcelRequire("aRWc6")).isMinLength)({
                    editorView: editorView,
                    minLength: 1,
                    positions: positions
                }),
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("ltXTD"))))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious",
                    LEGACY_fallbackIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9x5pH"))))), {
                            label: "",
                            spacing: "spacious",
                            color: "var(--ds-icon, #44546F)"
                        })
                }),
            actions: [
                (0, (0, parcelRequire("8gLLR")).createInsertBelow)({
                    appearance: 'secondary'
                }),
                (0, (0, parcelRequire("8gLLR")).createReplace)({
                    appearance: 'primary'
                })
            ]
        });
        return [
            language,
            configItem
        ];
    }).filter(Boolean);
    const $0cc5f327ad03b422$export$a5d583a04c7d58fc = Object.fromEntries($0cc5f327ad03b422$var$translationRangeConfigItemsArr.filter(Boolean));
    const $0cc5f327ad03b422$export$930671cb8514d6ac = Object.values($0cc5f327ad03b422$export$a5d583a04c7d58fc);
});
parcelRegister("f7Fws", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d77d16c3a132204b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d77d16c3a132204b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedBackTitle: {
            "id": "platform-utils-shared-editor-config.feed-back-title",
            "defaultMessage": "Help us make Atlassian Intelligence even better"
        },
        summaryPlaceholder: {
            "id": "platform-utils-shared-editor-config.summary-placeholder",
            "defaultMessage": "Let us know what you were trying to do and how it could be better"
        },
        userConsentCheckboxLabel: {
            "id": "platform-utils-shared-editor-config.user-consent-checkbox-label",
            "defaultMessage": "Include my last prompt and response in the feedback."
        },
        canContactText: {
            "id": "platform-utils-shared-editor-config.can-contact-text",
            "defaultMessage": "Atlassian can contact me about this feedback. See our <a>privacy policy</a>."
        },
        improveAtlassianText: {
            "id": "platform-utils-shared-editor-config.improve-atlassian-text",
            "defaultMessage": "I\u2019d like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>."
        }
    });
});
parcelRegister("l9wag", function(module, exports) {
    $parcel$export(module.exports, "Product", ()=>$7630c3795fbbcaa6$export$264ad599d7cef668);
    var $7630c3795fbbcaa6$export$264ad599d7cef668;
    (function(Product) {
        Product["JSW"] = "JSW";
        Product["JWM"] = "JWM";
        Product["JSM"] = "JSM";
        Product["JPD"] = "JPD";
    })($7630c3795fbbcaa6$export$264ad599d7cef668 || ($7630c3795fbbcaa6$export$264ad599d7cef668 = {}));
});
parcelRegister("diNhq", function(module, exports) {
    $parcel$export(module.exports, "useLinkPickerEditorProps", ()=>$70a53c38cce7e6e5$export$5057fa778edd8de9);
    var $5uXOq = parcelRequire("5uXOq");
    var $kc9vJ = parcelRequire("kc9vJ");
    const $70a53c38cce7e6e5$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $kc9vJ.lazyForPaint)(()=>(parcelRequire("kuCQ3")));
    const $70a53c38cce7e6e5$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
    const $70a53c38cce7e6e5$var$PLACEHOLDER_PLUGINS = [
        {
            tabKey: $70a53c38cce7e6e5$var$DUMMY_PLUGIN_KEY,
            tabTitle: 'DUMMY_PLUGIN',
            resolve: ()=>Promise.resolve({
                    data: []
                })
        }
    ];
    const $70a53c38cce7e6e5$export$5057fa778edd8de9 = (props, config)=>{
        const WrapperComponent = (0, $5uXOq.useMemo)(()=>(props)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement($70a53c38cce7e6e5$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                    ...props,
                    config: config
                });
            }, [
            config
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            return {
                ...props ?? {},
                plugins: $70a53c38cce7e6e5$var$PLACEHOLDER_PLUGINS,
                component: WrapperComponent
            };
        }, [
            WrapperComponent,
            props
        ]);
    };
});
parcelRegister("kuCQ3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("d9wbp")
    ]).then(()=>parcelRequire('zjy0N'));
});
parcelRegister("h0fZ7", function(module, exports) {
    $parcel$export(module.exports, "sanitizeADFField", ()=>$e0781922eb7ae616$export$28941b736a01da7b);
    $parcel$export(module.exports, "mutateADFField", ()=>$e0781922eb7ae616$export$82a40b3982cf31c4);
    $parcel$export(module.exports, "validateDescriptionField", ()=>$e0781922eb7ae616$export$78b1417f15a51a4f);
    var $fr1K2 = parcelRequire("fr1K2");
    var $kz2lw;
    var $jcw0u;
    var $bGrWH;
    const $e0781922eb7ae616$var$emptyADFString = JSON.stringify((0, (0, parcelRequire("kz2lw")).getEmptyADF)());
    const $e0781922eb7ae616$export$28941b736a01da7b = (adfValue)=>{
        if (adfValue?.overrideRequired || adfValue?.resetRequired) (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: 'adfObjectTypeErrorIssueCreate',
                packageName: 'jiraIssueCreateModal',
                teamName: 'gryffindor'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        const sanitizedValue = (0, ($parcel$interopDefault($fr1K2)))(adfValue, [
            'overrideRequired',
            'resetRequired'
        ]);
        return sanitizedValue;
    };
    const $e0781922eb7ae616$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
        const adfValueString = JSON.stringify(adfValue);
        return $e0781922eb7ae616$var$emptyADFString === adfValueString ? null : {
            fieldId: fieldId,
            mutationGroup: (0, $6aa4505c49fca768$export$31fd86f8f183952c),
            richText: {
                adfValue: adfValue
            }
        };
    };
    const $e0781922eb7ae616$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
        if (!isRequired) return undefined;
        const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, (0, parcelRequire("kz2lw")).getEmptyADF)());
        if (isAdfEmptyOrUndefined) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        const hardBreakNodeType = 'hardBreak';
        let isAnythingThereApartFromHardBreaks = false;
        if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
            const block = adfValue.content[i];
            const blockContent = block.content;
            isAnythingThereApartFromHardBreaks = blockContent?.some((blockItem)=>blockItem.type !== hardBreakNodeType);
            if (isAnythingThereApartFromHardBreaks) break;
        }
        if (isAnythingThereApartFromHardBreaks) return undefined;
        return 0, (0, parcelRequire("bGrWH")).REQUIRED;
    };
});
const $6aa4505c49fca768$export$31fd86f8f183952c = 'richTextFields';
parcelRegister("qzRgG", function(module, exports) {
    $parcel$export(module.exports, "EpicLinkField", ()=>$6673eab62a43357a$export$7929a33274a9f9f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7YTXY;
    const $6673eab62a43357a$export$7929a33274a9f9f = (props)=>{
        const { useFormContext: useFormContext, ...commonEpicLinkFieldProps } = props;
        const [, { setIsEpicLinkSelected: setIsEpicLinkSelected }] = useFormContext();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7YTXY")).default), {
            ...commonEpicLinkFieldProps,
            setIsEpicLinkSelected: setIsEpicLinkSelected
        });
    };
});
parcelRegister("7YTXY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c39b09761bdc1cbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $TzSzf;
    var $7C5S0;
    var $hpV4g;
    var $kRBrp;
    const $c39b09761bdc1cbf$export$7929a33274a9f9f = (props)=>{
        const { width: width } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TzSzf")).DisabledEpicLinkParentLinkField), null));
    };
    var $c39b09761bdc1cbf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("kRBrp")).transformDefaultEpicValue)
    })($c39b09761bdc1cbf$export$7929a33274a9f9f);
});
parcelRegister("TzSzf", function(module, exports) {
    $parcel$export(module.exports, "DisabledEpicLinkParentLinkField", ()=>$f0e1c154af4baef4$export$eb9d1bb510274e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $ousew;
    var $3I4sb;
    const $f0e1c154af4baef4$export$eb9d1bb510274e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($f0e1c154af4baef4$var$DisabledEpicLinkParentLinkFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("3I4sb")).default).replacedByParentField,
            values: {
                strong: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunks)
            }
        }));
    const $f0e1c154af4baef4$var$DisabledEpicLinkParentLinkFieldWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721jtm _syaz1wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3I4sb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5a23e699a16d942$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b5a23e699a16d942$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        replacedByParentField: {
            "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
            "defaultMessage": "Replaced by <strong>Parent</strong> field"
        }
    });
});
parcelRegister("aeHT9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4aa51bc46928ec2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    var $92Z2l;
    var $6s1PB;
    var $koVbs;
    var $45JN1;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $19MNr;
    var $2T8zR;
    const $e4aa51bc46928ec2$var$IssueRestrictionField = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, selectedProject: selectedProject, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, description: description, fieldName: fieldName, width: width, ariaLabelledBy: ariaLabelledBy } = props;
        const [shouldShowAccessWarning, setAccessWarningDisplay] = (0, $5uXOq.useState)(false);
        const convertToFieldType = (roles)=>{
            onChange(roles.map(({ roleId: roleId })=>({
                    roleId: roleId
                })));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("19MNr")).RolePickerEdit), {
            ...fieldProps,
            selectedProjectId: selectedProject?.value || '',
            selectedRoles: value,
            onChange: convertToFieldType,
            autoFocus: autoFocus,
            isDisabled: false,
            classNamePrefix: "issue-restriction-select",
            isInvalid: Boolean(error),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            setAccessWarningDisplay: setAccessWarningDisplay,
            "aria-labelledby": ariaLabelledBy
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
            description: description,
            error: error,
            fieldName: fieldName,
            isMini: isMini
        }), shouldShowAccessWarning ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $e4aa51bc46928ec2$var$messageContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2T8zR")).default).noAccessOnIssueCreatedWarningIssueTermRefresh : (0, (0, parcelRequire("2T8zR")).default).noAccessOnIssueCreatedWarning))) : null);
    };
    var $e4aa51bc46928ec2$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        shouldRenderFieldMessage: false
    })($e4aa51bc46928ec2$var$IssueRestrictionField);
    const $e4aa51bc46928ec2$var$messageContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginTop: 'space.050'
    });
});
parcelRegister("19MNr", function(module, exports) {
    $parcel$export(module.exports, "RolePickerEdit", ()=>$10d599f8d0053bff$export$61efdb1b7765b92e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7K5PP;
    var $koVbs;
    var $lElIo;
    var $bq7UN;
    var $1FoWu;
    var $5pYli;
    const $10d599f8d0053bff$export$ab4a55465dcdd21b = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { currentUserRole: currentUserRole } = props;
        return currentUserRole ? (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$CurrentUserRole, null, formatMessage((0, (0, parcelRequire("1FoWu")).default).currentUserRole))) : null;
    };
    const $10d599f8d0053bff$var$formatOptionLabel = (option, { context: context })=>{
        if (context === 'menu') return (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexBody, null, (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$FlexColumn, null, (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$RoleName, null, option.name), (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$var$SelectDescription, null, option.description)), (0, ($parcel$interopDefault($5uXOq))).createElement($10d599f8d0053bff$export$ab4a55465dcdd21b, {
            currentUserRole: !!option.currentUserRole
        }));
        return option.name;
    };
    const $10d599f8d0053bff$export$61efdb1b7765b92e = (props)=>{
        const { classNamePrefix: classNamePrefix, selectedRoles: selectedRoles, selectedProjectId: selectedProjectId, onChange: onChange, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, setAccessWarningDisplay: setAccessWarningDisplay, ariaLabel: ariaLabel, ...fieldProps } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: allRoles } = (0, (0, parcelRequire("bq7UN")).default)(selectedProjectId);
        const rolesWithCurrentUserAccess = (0, $5uXOq.useMemo)(()=>allRoles.filter(({ currentUserRole: currentUserRole })=>currentUserRole === true), [
            allRoles
        ]);
        const shouldShowIssueAccessWarning = (0, $5uXOq.useMemo)(()=>!(0, (0, parcelRequire("5pYli")).isUserRoleIncludedInRestrictedRoles)(selectedRoles, rolesWithCurrentUserAccess), [
            rolesWithCurrentUserAccess,
            selectedRoles
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (setAccessWarningDisplay) setAccessWarningDisplay(shouldShowIssueAccessWarning);
        }, [
            setAccessWarningDisplay,
            shouldShowIssueAccessWarning
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            ...fieldProps,
            classNamePrefix: classNamePrefix,
            options: allRoles,
            isMulti: true,
            onBlur: onBlur,
            onFocus: onFocus,
            formatOptionLabel: $10d599f8d0053bff$var$formatOptionLabel,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
            isSearchable: false,
            placeholder: formatMessage((0, (0, parcelRequire("1FoWu")).default).placeholder),
            getOptionValue: (0, (0, parcelRequire("5pYli")).getOptionValue),
            getOptionLabel: (0, (0, parcelRequire("5pYli")).getOptionLabel),
            value: (0, (0, parcelRequire("5pYli")).convertRolesToCurrentRole)(selectedRoles, allRoles),
            onChange: (roles)=>(0, (0, parcelRequire("5pYli")).transformRolesToArrayIfNull)(roles, onChange),
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            validationState: isInvalid === true ? 'error' : null,
            closeMenuOnScroll: onCloseMenuOnScroll,
            "aria-label": ariaLabel,
            "aria-labelledby": fieldProps['aria-labelledby']
        });
    };
    var $10d599f8d0053bff$export$2e2bcd8739ae039 = $10d599f8d0053bff$export$61efdb1b7765b92e;
    const $10d599f8d0053bff$var$SelectDescription = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5724jg8 _11c81vlj _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    const $10d599f8d0053bff$var$FlexBody = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $10d599f8d0053bff$var$FlexColumn = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2lx21bp4 _1e0c1txw _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $10d599f8d0053bff$var$RoleName = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.className
            ])
        });
    });
    const $10d599f8d0053bff$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19bvv47k",
                __cmplp.className
            ])
        });
    });
    const $10d599f8d0053bff$var$CurrentUserRole = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_zg8l1m30",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bq7UN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$168dc29b7a79b736$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $kVfCM;
    const $168dc29b7a79b736$var$useFetchRoles = (projectKeyOrId)=>{
        const [data, setData] = (0, $5uXOq.useState)([]);
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            (async ()=>{
                setLoading(true);
                try {
                    const response = await (0, (0, parcelRequire("eusud")).performGetRequest)((0, (0, parcelRequire("kVfCM")).getFetchRolesURL)(projectKeyOrId));
                    setLoading(false);
                    setData((0, (0, parcelRequire("kVfCM")).transformRoleIdToString)(response));
                } catch (httpError) {
                    setLoading(false);
                    setError(httpError.message);
                }
            })();
        }, [
            projectKeyOrId
        ]);
        return {
            loading: loading,
            error: error,
            data: data
        };
    };
    var $168dc29b7a79b736$export$2e2bcd8739ae039 = $168dc29b7a79b736$var$useFetchRoles;
});
parcelRegister("kVfCM", function(module, exports) {
    $parcel$export(module.exports, "getFetchRolesURL", ()=>$282c4354f0c6926d$export$e39189e7b2114aa1);
    $parcel$export(module.exports, "transformRoleIdToString", ()=>$282c4354f0c6926d$export$25aa9a2b001fbb5e);
    const $282c4354f0c6926d$export$e39189e7b2114aa1 = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/internal/roledetails?excludeConnectAddons=true`;
    const $282c4354f0c6926d$export$25aa9a2b001fbb5e = (roles)=>roles.map(({ id: id, ...role })=>({
                roleId: id.toString(),
                ...role
            }));
});
parcelRegister("1FoWu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdf80a4db07c2fe3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bdf80a4db07c2fe3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        currentUserRole: {
            "id": "issue-field-role-picker.edit.current-user-role",
            "defaultMessage": "You"
        },
        placeholder: {
            "id": "issue-field-role-picker.edit.placeholder",
            "defaultMessage": "Select Roles"
        }
    });
});
parcelRegister("2T8zR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$14cff774b2f5c082$export$2e2bcd8739ae039);
    var $7VHMR;
    var $14cff774b2f5c082$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noAccessOnIssueCreatedWarning: {
            "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning",
            "defaultMessage": "Select the roles that you're a part of to avoid losing access to this issue."
        },
        noAccessOnIssueCreatedWarningIssueTermRefresh: {
            "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning-issue-term-refresh",
            "defaultMessage": "Select the roles that you're a part of to avoid losing access to this work item."
        }
    });
});
parcelRegister("hPJET", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$20ff602fee162bb4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bGrWH;
    var $hDSkY;
    var $45Cy1;
    const $20ff602fee162bb4$var$LogWorkField = ({ additionalData: additionalData, ...props })=>{
        const { mediaContext: mediaContext, timeTrackingSettings: timeTrackingSettings } = additionalData;
        const [mediaUploadContext, setMediaUploadContext] = (0, $5uXOq.useState)(null);
        const [viewContext, setViewContext] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            const uploadToken = mediaContext?.uploadToken;
            if (uploadToken) {
                const { clientId: clientId, endpointUrl: endpointUrl, targetCollection: targetCollection, token: token, tokenDurationInMin: tokenDurationInMin } = uploadToken;
                const tokenIssueTimestamp = Date.now();
                const tokenLifespanInMs = tokenDurationInMin * 60000;
                setMediaUploadContext({
                    clientId: clientId,
                    serviceHost: endpointUrl,
                    collection: targetCollection,
                    tokenLifespanInMs: tokenLifespanInMs,
                    token: token,
                    tokenIssueTimestamp: tokenIssueTimestamp
                });
                setViewContext({
                    clientId: clientId,
                    serviceHost: endpointUrl,
                    token: token,
                    tokenLifespanInMs: tokenLifespanInMs,
                    areTokenPermissionsUpToDate: true,
                    collection: targetCollection,
                    tokenIssueTimestamp: tokenIssueTimestamp
                });
            }
        }, [
            mediaContext?.uploadToken
        ]);
        const mediaProvider = {
            userAuth: null,
            viewContext: viewContext,
            uploadContext: mediaUploadContext
        };
        const [{ timeTrackingValue: timeTrackingValue, meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const getLogWorkFieldErrors = (0, $5uXOq.useCallback)(()=>{
            if (submitFieldwiseErrors) {
                const logWorkFieldWiseErrors = {};
                [
                    (0, (0, parcelRequire("bGrWH")).LOG_WORK_DATE_ERROR_KEY),
                    (0, (0, parcelRequire("bGrWH")).LOG_WORK_DESCRIPTION_ERROR_KEY),
                    (0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_REMAINING_ERROR_KEY),
                    (0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_SPENT_ERROR_KEY)
                ].forEach((errorKey)=>{
                    if (submitFieldwiseErrors[errorKey]) logWorkFieldWiseErrors[errorKey] = submitFieldwiseErrors[errorKey];
                });
                const logWorkOtherErrors = [];
                (0, (0, parcelRequire("bGrWH")).COMMON_LOG_WORK_ERROR_KEYS).forEach((key)=>{
                    if (submitFieldwiseErrors[key]) logWorkOtherErrors.push(submitFieldwiseErrors[key]);
                });
                return {
                    ...logWorkFieldWiseErrors,
                    logWorkOtherErrors: logWorkOtherErrors
                };
            }
            return undefined;
        }, [
            submitFieldwiseErrors
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDSkY")).default), {
            ...props,
            additionalData: {
                timeTrackingSettings: timeTrackingSettings
            },
            mediaContext: mediaProvider,
            timeTrackingValue: timeTrackingValue,
            errors: getLogWorkFieldErrors()
        });
    };
    var $20ff602fee162bb4$export$2e2bcd8739ae039 = $20ff602fee162bb4$var$LogWorkField;
});
parcelRegister("hDSkY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a647ee1c161b598f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jj52j;
    var $fVnbM;
    var $htnpT;
    var $qfj8c;
    var $7O4UO;
    var $h1toL;
    var $k4n86;
    var $1wbtX;
    var $8C78M;
    var $gwIPs;
    var $koVbs;
    var $bGrWH;
    var $9ah8z;
    var $9idvE;
    var $lfTZh;
    var $1p96B;
    var $DVljb;
    var $7C5S0;
    var $hpV4g;
    var $k4Xhy;
    var $9sq52;
    const $a647ee1c161b598f$var$skeletonHeight = `${(0, (0, parcelRequire("gwIPs")).gridSize) * 18.75}px`;
    const $a647ee1c161b598f$export$c128706c0bbc8993 = (props)=>{
        const currentDateTime = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("jj52j")).default)(new Date()), []);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [timeFieldInFocus, setTimeFieldInFocus] = (0, $5uXOq.useState)('');
        const isDefaultValueSetInFormStateForDateField = (0, $5uXOq.useRef)(false);
        const [areLogWorkFieldsVisible, showLogWorkFields] = (0, $5uXOq.useState)(false);
        const [estimateExceededWarning, setEstimateExceededWarning] = (0, $5uXOq.useState)('');
        const { width: width = 350, fieldProps: { value: value = {
            timeRemaining: '',
            timeSpent: '',
            dateValue: '',
            description: undefined
        }, onChange: onChange }, timeTrackingValue: timeTrackingValue = '', mediaContext: mediaContext, autoFocus: autoFocus = false, additionalData: additionalData, isRequired: isRequired, errors: errors, fieldName: fieldName } = props;
        const { description: description, timeRemaining: timeRemaining, timeSpent: timeSpent, dateValue: dateValue } = value;
        const { timeTrackingSettings: config } = additionalData;
        const locale = (0, (0, parcelRequire("DVljb")).useLocale)();
        const onChangeFieldValue = (0, $5uXOq.useCallback)((partialFieldValue)=>{
            onChange({
                ...value,
                ...partialFieldValue
            });
        }, [
            onChange,
            value
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (timeTrackingValue) {
                const isTimeEstimateExceeded = (0, (0, parcelRequire("9sq52")).getIsTimeEstimateExceeded)({
                    config: config,
                    timeRemaining: timeRemaining,
                    timeSpent: timeSpent,
                    timeTrackingValue: timeTrackingValue
                });
                setEstimateExceededWarning(isTimeEstimateExceeded ? formatMessage((0, (0, parcelRequire("k4Xhy")).default).originalEstimateExceededNonFinal) : '');
            } else if (estimateExceededWarning) setEstimateExceededWarning('');
        }, [
            timeRemaining,
            timeSpent,
            timeTrackingValue,
            config,
            formatMessage,
            estimateExceededWarning
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isDefaultValueSetInFormStateForDateField.current && !dateValue && areLogWorkFieldsVisible) {
                isDefaultValueSetInFormStateForDateField.current = true;
                onChangeFieldValue({
                    dateValue: currentDateTime
                });
            }
        }, [
            dateValue,
            currentDateTime,
            onChangeFieldValue,
            areLogWorkFieldsVisible
        ]);
        const onChangeTimeSpent = (0, $5uXOq.useCallback)((newTimeSpent)=>{
            let newTimeRemaining = timeRemaining;
            if (timeTrackingValue) {
                const calculatedTimeRemainingIfAny = (0, (0, parcelRequire("9sq52")).getCalculatedTimeRemainingIfAny)({
                    timeSpent: newTimeSpent,
                    timeTrackingValue: timeTrackingValue,
                    config: config
                });
                if (calculatedTimeRemainingIfAny !== null) newTimeRemaining = calculatedTimeRemainingIfAny;
            }
            setTimeFieldInFocus((0, $967029f3aa14c1ce$export$81fee17d19007357));
            onChangeFieldValue({
                timeSpent: newTimeSpent,
                timeRemaining: newTimeRemaining
            });
        }, [
            config,
            onChangeFieldValue,
            timeRemaining,
            timeTrackingValue
        ]);
        const onChangeTimeRemaining = (0, $5uXOq.useCallback)((newTimeRemaining)=>{
            setTimeFieldInFocus((0, $967029f3aa14c1ce$export$d7ed3a061805d786));
            onChangeFieldValue({
                timeRemaining: newTimeRemaining
            });
        }, [
            onChangeFieldValue
        ]);
        const onToggleLogWorkFieldsVisibility = (0, $5uXOq.useCallback)(()=>{
            showLogWorkFields((current)=>!current);
        }, []);
        const onChangeDatePicker = (0, $5uXOq.useCallback)((newDateValue)=>{
            onChangeFieldValue({
                dateValue: newDateValue
            });
        }, [
            onChangeFieldValue
        ]);
        const onChangeEditorValue = (0, $5uXOq.useCallback)((newEditorValue)=>{
            onChangeFieldValue({
                description: newEditorValue
            });
        }, [
            onChangeFieldValue
        ]);
        const isEstimateExceeded = estimateExceededWarning !== '';
        const weekStartDay = (0, (0, parcelRequire("1p96B")).getLocale)(locale)?.options?.weekStartsOn;
        const buttonLabel = formatMessage((0, (0, parcelRequire("k4Xhy")).default).logWorkLabel);
        const dateTimeLabel = formatMessage((0, (0, parcelRequire("k4Xhy")).default).dateStarted);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($a647ee1c161b598f$var$LogWorkHeader, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            iconBefore: areLogWorkFieldsVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k4n86"))))), {
                label: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
                label: ""
            }),
            appearance: "subtle",
            spacing: "none",
            onClick: onToggleLogWorkFieldsVisibility,
            testId: "issue-create-commons.ui.log-work-field.next-button",
            "aria-label": buttonLabel,
            "aria-expanded": areLogWorkFieldsVisible
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("span", null, buttonLabel, " ", isRequired === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($a647ee1c161b598f$var$RequiredDot, null, "*") : '')), areLogWorkFieldsVisible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: (0, $967029f3aa14c1ce$export$81fee17d19007357),
            label: formatMessage((0, (0, parcelRequire("k4Xhy")).default).timeSpent),
            isRequired: isRequired
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9idvE")).TimeEstimate), {
                ...fieldProps,
                autoFocus: autoFocus,
                value: timeSpent,
                onChange: onChangeTimeSpent,
                shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $967029f3aa14c1ce$export$81fee17d19007357),
                config: config
            }), errors && errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_SPENT_ERROR_KEY] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_SPENT_ERROR_KEY]) : null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: (0, $967029f3aa14c1ce$export$d7ed3a061805d786),
            label: formatMessage((0, (0, parcelRequire("k4Xhy")).default).timeRemaining)
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9idvE")).TimeEstimate), {
                ...fieldProps,
                value: timeRemaining,
                onChange: onChangeTimeRemaining,
                shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $967029f3aa14c1ce$export$d7ed3a061805d786),
                config: config
            }), errors && errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_REMAINING_ERROR_KEY] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_TIME_REMAINING_ERROR_KEY]) : null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: (0, $967029f3aa14c1ce$export$ade7f171d00a976f),
            label: dateTimeLabel,
            isRequired: isRequired
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("htnpT")).default), {
                onChange: onChangeDatePicker,
                value: dateValue,
                locale: locale,
                isClearable: !isRequired,
                datePickerProps: {
                    weekStartDay: weekStartDay,
                    label: dateTimeLabel,
                    id: fieldProps.id
                },
                timePickerProps: {
                    times: (0, (0, parcelRequire("8C78M")).default)
                }
            }), errors && errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_DATE_ERROR_KEY] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_DATE_ERROR_KEY]) : null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: (0, $967029f3aa14c1ce$export$caca24db5cb49b68),
            label: formatMessage((0, (0, parcelRequire("k4Xhy")).default).description)
        }, ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "rich-text-edit-view",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
                    height: $a647ee1c161b598f$var$skeletonHeight
                })
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ah8z")).AsyncRichTextEditView), {
                onChange: onChangeEditorValue,
                defaultValue: description,
                mediaContext: mediaContext,
                mentionProvider: {
                    unsubscribe: ()=>{}
                },
                assistiveLabel: fieldName
            })), errors && errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_DESCRIPTION_ERROR_KEY] ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, errors[0, (0, parcelRequire("bGrWH")).LOG_WORK_DESCRIPTION_ERROR_KEY]) : null)), errors && errors.logWorkOtherErrors?.map((error, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
                key: `logwork-${index}-common-error`
            }, error))));
    };
    var $a647ee1c161b598f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        shouldHideLabel: true
    })($a647ee1c161b598f$export$c128706c0bbc8993);
    const $a647ee1c161b598f$var$RequiredDot = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1ick _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $a647ee1c161b598f$var$LogWorkHeader = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("htnpT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa2698ee0cdd579e$export$2e2bcd8739ae039);
    var $VSDnB;
    var $cKsfY;
    var $9Lqvx;
    var $hB1kl;
    const $fa2698ee0cdd579e$var$DateTimePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-time-picker-use-functional-component'), (0, (0, parcelRequire("hB1kl")).default), (0, (0, parcelRequire("9Lqvx")).default));
    var $fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;
});
parcelRegister("9Lqvx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$597f1543018f8252$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $k7m40;
    var $jovBr;
    var $eZDAP;
    var $gB4mS;
    var $994MI;
    var $cb25w;
    var $cQz2U;
    var $VSDnB;
    var $7VXAu;
    var $jHBnA;
    var $8JNJx;
    var $cKsfY;
    var $2ucUe;
    var $2TI0z;
    var $jcbUF;
    var $jdTq6;
    function $597f1543018f8252$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $597f1543018f8252$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    const $597f1543018f8252$var$packageName = "platform-pkg";
    const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
    const $597f1543018f8252$var$datePickerContainerStyles = {
        name: "d1cmrh",
        styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
    };
    const $597f1543018f8252$var$timePickerContainerStyles = {
        name: "zwso5s",
        styles: "flex-basis:50%;flex-grow:1"
    };
    const $597f1543018f8252$var$iconContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: "var(--ds-border-width, 1px)",
        alignItems: 'center',
        flexBasis: 'inherit',
        backgroundColor: 'inherit',
        border: 'none',
        color: `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        paddingBlockEnd: "var(--ds-space-075, 6px)",
        paddingBlockStart: "var(--ds-space-075, 6px)",
        paddingInlineEnd: "var(--ds-space-100, 8px)",
        paddingInlineStart: "var(--ds-space-050, 4px)",
        transition: `color 150ms`,
        '&:hover': {
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`
        }
    });
    const $597f1543018f8252$var$styles = {
        control: (style)=>({
                ...style,
                backgroundColor: 'transparent',
                border: 2,
                borderRadius: 0,
                paddingLeft: 0,
                ':hover': {
                    backgroundColor: 'transparent',
                    cursor: 'inherit'
                }
            })
    };
    const $597f1543018f8252$var$dateTimePickerDefaultProps = {
        onBlur: (_event)=>{},
        onChange: (_value)=>{},
        onFocus: (_event)=>{}
    };
    const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
    const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time';
    class $597f1543018f8252$export$732a1726f0a3523b extends (0, ($parcel$interopDefault($5uXOq))).Component {
        static{
            this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
        }
        parseValue(value, dateValue, timeValue, zoneValue) {
            if (this.props.parseValue) {
                const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue);
                return parsedFromFn || {
                    dateValue: dateValue,
                    timeValue: timeValue,
                    zoneValue: zoneValue
                };
            }
            const parsed = (0, (0, parcelRequire("eZDAP")).default)(value);
            return (0, (0, parcelRequire("jovBr")).default)(parsed) ? {
                dateValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD')),
                timeValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('HH:mm')),
                zoneValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('ZZ'))
            } : {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
            this.setState({
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            });
            if (dateValue && timeValue) {
                const value = (0, (0, parcelRequire("jHBnA")).formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
                const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
                const valueWithValidZone = (0, (0, parcelRequire("jHBnA")).formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
                this.setState({
                    value: valueWithValidZone
                });
                this.props.onChange?.(valueWithValidZone);
            } else if (this.getValue()) {
                this.setState({
                    value: ''
                });
                this.props.onChange?.('');
            }
        }
        render() {
            const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
            const value = this.getValue();
            const { isFocused: isFocused } = this.state;
            const parsedValues = this.getParsedValues();
            const dateValue = parsedValues?.dateValue;
            const timeValue = parsedValues?.timeValue;
            const datePickerSelectProps = datePickerProps?.selectProps;
            const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
            const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
            const mergedDatePickerSelectProps = {
                ...datePickerSelectProps,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
            };
            const timePickerSelectProps = timePickerProps?.selectProps;
            const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
            const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
            const mergedTimePickerSelectProps = {
                ...timePickerSelectProps,
                styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
            };
            const isClearable = Boolean(dateValue || timeValue);
            return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8JNJx")).DateTimePickerContainer), {
                appearance: appearance,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isInvalid: isInvalid,
                testId: testId,
                innerProps: innerProps
            }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $597f1543018f8252$var$datePickerContainerStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)($597f1543018f8252$var$DatePicker, {
                appearance: appearance,
                "aria-describedby": datePickerAriaDescribedBy,
                autoFocus: datePickerProps.autoFocus || autoFocus,
                dateFormat: datePickerProps.dateFormat,
                defaultIsOpen: datePickerProps.defaultIsOpen,
                defaultValue: datePickerProps.defaultValue,
                disabled: datePickerProps.disabled,
                disabledDateFilter: datePickerProps.disabledDateFilter,
                formatDisplayLabel: datePickerProps.formatDisplayLabel,
                hideIcon: datePickerProps.hideIcon || true,
                icon: datePickerProps.icon,
                id: datePickerProps.id || id,
                innerProps: datePickerProps.innerProps,
                isDisabled: datePickerProps.isDisabled || isDisabled,
                isInvalid: datePickerProps.isInvalid || isInvalid,
                isRequired: datePickerProps.isRequired || isRequired,
                isOpen: datePickerProps.isOpen,
                label: datePickerLabel,
                locale: datePickerProps.locale || locale,
                maxDate: datePickerProps.maxDate,
                minDate: datePickerProps.minDate,
                name: datePickerProps.name,
                nextMonthLabel: datePickerProps.nextMonthLabel,
                onBlur: this.onDateBlur,
                onChange: this.onDateChange,
                onFocus: this.onDateFocus,
                parseInputValue: datePickerProps.parseInputValue,
                placeholder: datePickerProps.placeholder,
                previousMonthLabel: datePickerProps.previousMonthLabel,
                selectProps: mergedDatePickerSelectProps,
                shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                spacing: datePickerProps.spacing || spacing,
                testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                value: dateValue,
                weekStartDay: datePickerProps.weekStartDay
            })), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $597f1543018f8252$var$timePickerContainerStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jdTq6")).default), {
                appearance: timePickerProps.appearance || appearance,
                "aria-describedby": timePickerAriaDescribedBy,
                autoFocus: timePickerProps.autoFocus,
                defaultIsOpen: timePickerProps.defaultIsOpen,
                defaultValue: timePickerProps.defaultValue,
                formatDisplayLabel: timePickerProps.formatDisplayLabel,
                hideIcon: timePickerProps.hideIcon || true,
                id: timePickerProps.id,
                innerProps: timePickerProps.innerProps,
                isDisabled: timePickerProps.isDisabled || isDisabled,
                isInvalid: timePickerProps.isInvalid || isInvalid,
                isOpen: timePickerProps.isOpen,
                isRequired: timePickerProps.isRequired || isRequired,
                label: timePickerLabel,
                locale: timePickerProps.locale || locale,
                name: timePickerProps.name,
                onBlur: this.onTimeBlur,
                onChange: this.onTimeChange,
                onFocus: this.onTimeFocus,
                parseInputValue: timePickerProps.parseInputValue,
                placeholder: timePickerProps.placeholder,
                selectProps: mergedTimePickerSelectProps,
                spacing: timePickerProps.spacing || spacing,
                testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                timeFormat: timePickerProps.timeFormat,
                timeIsEditable: timePickerProps.timeIsEditable,
                times: timePickerProps.times,
                value: timeValue
            })), isClearable && !isDisabled ? (0, (0, parcelRequire("f8Sb3")).jsx)("button", {
                css: $597f1543018f8252$var$iconContainerStyles,
                onClick: this.onClear,
                "data-testid": testId && `${testId}--icon--container`,
                tabIndex: -1,
                type: "button"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
                LEGACY_size: "small",
                color: "currentColor",
                label: clearControlLabel
            }), ' ') : null);
        }
        constructor(...args){
            super(...args), this.state = {
                dateValue: this.props.datePickerProps?.defaultValue || '',
                isFocused: false,
                timeValue: this.props.timePickerProps?.defaultValue || '',
                value: this.props.defaultValue || '',
                zoneValue: ''
            }, this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
                this.setState({
                    isFocused: false
                });
                this.props.onBlur?.(event);
                if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
            }, this.onTimeBlur = (event)=>{
                this.setState({
                    isFocused: false
                });
                this.props.onBlur?.(event);
                if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
            }, this.onDateFocus = (event)=>{
                this.setState({
                    isFocused: true
                });
                this.props.onFocus?.(event);
                if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
            }, this.onTimeFocus = (event)=>{
                this.setState({
                    isFocused: true
                });
                this.props.onFocus?.(event);
                if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
            }, this.onDateChange = (dateValue)=>{
                const parsedValues = this.getParsedValues();
                this.onValueChange({
                    dateValue: dateValue,
                    timeValue: parsedValues.timeValue,
                    zoneValue: parsedValues.zoneValue
                });
                if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
            }, this.onTimeChange = (timeValue)=>{
                const parsedValues = this.getParsedValues();
                this.onValueChange({
                    dateValue: parsedValues.dateValue,
                    timeValue: timeValue,
                    zoneValue: parsedValues.zoneValue
                });
                if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
            }, this.onClear = ()=>{
                const parsedValues = this.getParsedValues();
                this.onValueChange({
                    dateValue: '',
                    timeValue: '',
                    zoneValue: parsedValues.zoneValue
                });
                if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
                if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
            };
        }
    }
    const $597f1543018f8252$var$DateTimePicker = (0, (0, parcelRequire("994MI")).default)({
        componentName: 'dateTimePicker',
        packageName: $597f1543018f8252$var$packageName,
        packageVersion: $597f1543018f8252$var$packageVersion
    })((0, (0, parcelRequire("cb25w")).default)({
        onChange: (0, (0, parcelRequire("gB4mS")).default)('atlaskit')({
            action: 'changed',
            actionSubject: 'dateTimePicker',
            attributes: {
                componentName: 'dateTimePicker',
                packageName: $597f1543018f8252$var$packageName,
                packageVersion: $597f1543018f8252$var$packageVersion
            }
        })
    })($597f1543018f8252$export$732a1726f0a3523b));
    var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;
});
parcelRegister("8JNJx", function(module, exports) {
    $parcel$export(module.exports, "DateTimePickerContainer", ()=>$346cb403038f00ec$export$83034b1f07ab0b20);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    function $346cb403038f00ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $346cb403038f00ec$var$isInvalidBorderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
    });
    const $346cb403038f00ec$var$isFocusedBorderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        borderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`,
        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`}`
    });
    const $346cb403038f00ec$var$isFocusedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        backgroundColor: `var(--ds-background-input-pressed, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    });
    const $346cb403038f00ec$var$subtleBgStyles = {
        name: "1wrome1",
        styles: "background-color:transparent;border-color:transparent"
    };
    const $346cb403038f00ec$var$subtleFocusedBgStyles = {
        name: "17swi1q",
        styles: "background-color:var(--ds-background-input-pressed, transparent);border-color:transparent"
    };
    const $346cb403038f00ec$var$noBgStyles = {
        name: "14n6qpm",
        styles: "background-color:transparent;border-color:transparent;&:hover{background-color:transparent;border-color:transparent;}"
    };
    const $346cb403038f00ec$var$hoverStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
            borderColor: `var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`
        }
    });
    const $346cb403038f00ec$var$isInvalidHoverStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&:hover': {
            backgroundColor: `var(--ds-background-input-hovered, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
            borderColor: `var(--ds-border-danger, ${(0, $829f609a65d26a98$export$2010d0fb4295b346)})`
        }
    });
    const $346cb403038f00ec$var$isDisabledStyles = {
        name: "1xp4bos",
        styles: "&:hover{cursor:default;}"
    };
    const $346cb403038f00ec$var$newBorderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`}`
    });
    const $346cb403038f00ec$var$baseContainerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        backgroundColor: `var(--ds-background-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
        border: `2px solid ${`var(--ds-border-input, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`}`,
        borderRadius: "var(--ds-border-radius, 3px)",
        transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
        '&:hover': {
            cursor: 'pointer'
        }
    });
    const $346cb403038f00ec$export$83034b1f07ab0b20 = (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
        const notFocusedOrIsDisabled = !(isFocused || isDisabled);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $346cb403038f00ec$var$baseContainerStyles,
                $346cb403038f00ec$var$newBorderStyles,
                isDisabled && $346cb403038f00ec$var$isDisabledStyles,
                isFocused && $346cb403038f00ec$var$isFocusedStyles,
                appearance === 'subtle' && (isFocused ? $346cb403038f00ec$var$subtleFocusedBgStyles : $346cb403038f00ec$var$subtleBgStyles),
                isFocused && $346cb403038f00ec$var$isFocusedBorderStyles,
                isInvalid && $346cb403038f00ec$var$isInvalidBorderStyles,
                notFocusedOrIsDisabled && (isInvalid ? $346cb403038f00ec$var$isInvalidHoverStyles : $346cb403038f00ec$var$hoverStyles),
                appearance === 'none' && $346cb403038f00ec$var$noBgStyles
            ],
            ...innerProps,
            "data-testid": testId,
            ref: ref
        }, children);
    });
});
parcelRegister("jdTq6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$420c0ce16dc216b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k7m40;
    var $jovBr;
    var $6QvkM;
    var $eGmKJ;
    var $7qZ1x;
    var $iOwNT;
    var $7K5PP;
    var $7VXAu;
    var $jHBnA;
    var $imOgG;
    var $j537G;
    var $2ucUe;
    var $dBs4v;
    const $420c0ce16dc216b4$var$packageName = "platform-pkg";
    const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
    const $420c0ce16dc216b4$var$menuStyles = {
        position: 'static',
        overflowY: 'auto',
        margin: 0
    };
    const $420c0ce16dc216b4$var$analyticsAttributes = {
        componentName: 'timePicker',
        packageName: $420c0ce16dc216b4$var$packageName,
        packageVersion: $420c0ce16dc216b4$var$packageVersion
    };
    const $420c0ce16dc216b4$var$TimePicker = (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, (0, parcelRequire("eGmKJ")).default), onChange: providedOnChange = (0, (0, parcelRequire("eGmKJ")).default), onFocus: providedOnFocus = (0, (0, parcelRequire("eGmKJ")).default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, (0, parcelRequire("j537G")).default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, (0, parcelRequire("jHBnA")).defaultTimes), value: providedValue }, ref)=>{
        const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
        const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
        const [_, setIsFocused] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
        const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
        const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
        const providedOnChangeWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: providedOnChange,
            action: 'selectedTime',
            ...$420c0ce16dc216b4$var$analyticsAttributes
        });
        (0, $5uXOq.useEffect)(()=>{
            if (providedValue) setValue(providedValue);
        }, [
            providedValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (providedIsOpen) setIsOpen(providedIsOpen);
        }, [
            providedIsOpen
        ]);
        const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
            const rawValue = newValue ? newValue.value || newValue : '';
            const finalValue = rawValue.toString();
            setValue(finalValue);
            if (action && action.action === 'clear') setClearingFromIcon(true);
            providedOnChangeWithAnalytics(finalValue);
        }, [
            providedOnChangeWithAnalytics
        ]);
        const onCreateOption = (inputValue)=>{
            if (timeIsEditable) {
                let sanitizedInput;
                try {
                    sanitizedInput = parseInputValue(inputValue, timeFormat || (0, (0, parcelRequire("jHBnA")).defaultTimeFormat));
                } catch (e) {
                    return;
                }
                const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
                const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
                const formattedValue = (0, (0, parcelRequire("k7m40")).default)(sanitizedInput, formatFormat) || '';
                setValue(formattedValue);
                providedOnChangeWithAnalytics(formattedValue);
            } else providedOnChangeWithAnalytics(inputValue);
        };
        const onMenuOpen = ()=>{
            if (clearingFromIcon) setClearingFromIcon(false);
            else setIsOpen(true);
        };
        const onMenuClose = ()=>{
            if (clearingFromIcon) setClearingFromIcon(false);
            else setIsOpen(false);
        };
        const setInternalContainerRef = (ref)=>{
            const oldRef = containerRef;
            setContainerRef(ref);
            if (oldRef === null && ref !== null) forceUpdate();
        };
        const onBlur = (event)=>{
            setIsFocused(false);
            providedOnBlur(event);
        };
        const onFocus = (event)=>{
            setIsFocused(true);
            providedOnFocus(event);
        };
        const onSelectKeyDown = (event)=>{
            const { key: key } = event;
            const keyPressed = key.toLowerCase();
            if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) setClearingFromIcon(false);
        };
        const ICON_PADDING = 2;
        const GRID_SIZE = 8;
        const l10n = (0, (0, parcelRequire("7qZ1x")).createLocalizationProvider)(locale);
        const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
        const SelectComponent = timeIsEditable ? (0, (0, parcelRequire("iOwNT")).default) : (0, (0, parcelRequire("7K5PP")).default);
        const formatTime = (time)=>{
            if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, (0, parcelRequire("jHBnA")).defaultTimeFormat));
            const date = (0, (0, parcelRequire("j537G")).default)(time);
            if (!(date instanceof Date)) return '';
            if (!(0, (0, parcelRequire("jovBr")).default)(date)) return time;
            if (timeFormat) return (0, (0, parcelRequire("k7m40")).default)(date, (0, (0, parcelRequire("2ucUe")).convertTokens)(timeFormat));
            return l10n.formatTime(date);
        };
        const options = times.map((time)=>{
            return {
                label: formatTime(time),
                value: time
            };
        });
        let initialValue;
        if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
            label: formatTime(providedValue),
            value: providedValue
        };
        else if (providedValue !== '' && value) initialValue = {
            label: formatTime(value),
            value: value
        };
        else initialValue = null;
        const SingleValue = (0, (0, parcelRequire("dBs4v")).makeSingleValue)({
            lang: locale
        });
        const selectComponents = {
            DropdownIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent),
            Menu: (0, (0, parcelRequire("imOgG")).FixedLayerMenu),
            SingleValue: SingleValue,
            ...hideIcon && {
                ClearIndicator: (0, (0, parcelRequire("jHBnA")).EmptyComponent)
            }
        };
        const renderIconContainer = Boolean(!hideIcon && value);
        const mergedStyles = (0, (0, parcelRequire("7VXAu")).mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base
                }),
            menu: (base)=>({
                    ...base,
                    ...$420c0ce16dc216b4$var$menuStyles,
                    width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                    paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
                })
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ...innerProps,
            ref: setInternalContainerRef,
            "data-testid": testId && `${testId}--container`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`,
            onKeyDown: onSelectKeyDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(SelectComponent, {
            "aria-describedby": ariaDescribedBy,
            "aria-label": label || undefined,
            appearance: appearance,
            autoFocus: autoFocus,
            clearControlLabel: clearControlLabel,
            components: selectComponents,
            inputId: id,
            isClearable: true,
            isDisabled: isDisabled,
            isRequired: isRequired,
            menuIsOpen: isOpen && !isDisabled,
            menuPlacement: "auto",
            openMenuOnFocus: true,
            onBlur: onBlur,
            onCreateOption: onCreateOption,
            onChange: onChange,
            options: options,
            onFocus: onFocus,
            onMenuOpen: onMenuOpen,
            onMenuClose: onMenuClose,
            placeholder: placeholder || l10n.formatTime((0, (0, parcelRequire("jHBnA")).placeholderDatetime)),
            styles: mergedStyles,
            value: initialValue,
            spacing: spacing,
            fixedLayerRef: containerRef,
            isInvalid: isInvalid,
            testId: testId,
            ...otherSelectProps
        }));
    });
    var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;
});
parcelRegister("imOgG", function(module, exports) {
    $parcel$export(module.exports, "FixedLayerMenu", ()=>$cf860f703ecf4b3d$export$982ad994195b4356);
    var $f8Sb3;
    var $bChGW;
    var $avHVh;
    const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, children: children, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("avHVh")).default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.fixedLayerRef,
            content: (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bChGW")).components).Menu, {
                ...rest,
                className: className,
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getValue: getValue,
                hasValue: hasValue,
                innerProps: innerProps,
                innerRef: innerRef,
                isLoading: isLoading,
                isMulti: isMulti,
                isRtl: isRtl,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView,
                minMenuHeight: minMenuHeight,
                options: options,
                placement: placement,
                selectOption: selectOption,
                selectProps: selectProps,
                setValue: setValue,
                theme: theme
            }, children),
            testId: selectProps.testId
        });
});
parcelRegister("j537G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5e493719c30ce57$export$2e2bcd8739ae039);
    const $b5e493719c30ce57$var$map24 = {
        '12': '12',
        '01': '13',
        '02': '14',
        '03': '15',
        '04': '16',
        '05': '17',
        '06': '18',
        '07': '19',
        '08': '20',
        '09': '21',
        '10': '22',
        '11': '23'
    };
    function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
        const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
        const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
        const num = timeString.replace(/[^0-9]/g, '');
        const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
        if (!time && !time24hr) return false;
        if (time && !time[1]) return false;
        if (num.length > 6) return false;
        if (num.length > 4 && !includesSeconds) return false;
        if (num.length === 2 && parseInt(num, 10) > 12) return false;
        return true;
    }
    function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
        return time.replace(/[:.]/g, '');
    }
    function $b5e493719c30ce57$export$c38a243baf9c6083(time) {
        if (time.length === 1) return `0${time}00`;
        if (time.length === 2) return `${time}00`;
        if (time.length === 3 || time.length === 5) return `0${time}`;
        return time;
    }
    function $b5e493719c30ce57$export$ed20539f7181c701(hour, meridiem) {
        if (hour > '24') return null;
        if (hour === '12' && meridiem === 'a') return '00';
        if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
        return hour;
    }
    function $b5e493719c30ce57$export$4077529dfc44a251(value) {
        if (value > '59') return null;
        return value;
    }
    function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
        const timeArray = time.toLowerCase().split(/(p|a)/i);
        const meridiem = timeArray[1];
        const semi24 = $b5e493719c30ce57$export$c38a243baf9c6083(timeArray[0].trim());
        const hour = $b5e493719c30ce57$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
        const minute = $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(2, 4));
        const seconds = semi24.length === 6 && $b5e493719c30ce57$export$4077529dfc44a251(semi24.substring(4, 6));
        if (!hour || !minute) return null;
        return {
            hour: parseInt(hour, 10),
            minute: parseInt(minute, 10),
            seconds: parseInt(seconds || '0', 10) || 0
        };
    }
    function $b5e493719c30ce57$export$865db99128311580(time) {
        const dateTime = new Date();
        dateTime.setHours(time.hour);
        dateTime.setMinutes(time.minute);
        dateTime.setSeconds(time.seconds || 0, 0);
        return dateTime;
    }
    function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
        const trimmedTime = time.toString().trim();
        if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
        const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
        const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
        if (!time2) throw RangeError('invalid time format');
        return $b5e493719c30ce57$export$865db99128311580(time2);
    }
});
parcelRegister("hB1kl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9d24b25c52c40a49$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k7m40;
    var $jovBr;
    var $eZDAP;
    var $6QvkM;
    var $42CjB;
    var $cQz2U;
    var $VSDnB;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $7VXAu;
    var $jHBnA;
    var $8JNJx;
    var $cKsfY;
    var $2ucUe;
    var $2TI0z;
    var $jcbUF;
    var $jdTq6;
    const $9d24b25c52c40a49$var$DatePicker = (0, (0, parcelRequire("cKsfY")).componentWithCondition)(()=>(0, (0, parcelRequire("VSDnB")).fg)('dst-date-picker-use-functional-component'), (0, (0, parcelRequire("jcbUF")).default), (0, (0, parcelRequire("2TI0z")).default));
    const $9d24b25c52c40a49$var$packageName = "platform-pkg";
    const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
    const $9d24b25c52c40a49$var$analyticsAttributes = {
        componentName: 'dateTimePicker',
        packageName: $9d24b25c52c40a49$var$packageName,
        packageVersion: $9d24b25c52c40a49$var$packageVersion
    };
    const $9d24b25c52c40a49$var$datePickerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexBasis: '50%',
        flexGrow: 1,
        flexShrink: 0
    });
    const $9d24b25c52c40a49$var$timePickerContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexBasis: '50%',
        flexGrow: 1
    });
    const $9d24b25c52c40a49$var$iconContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        display: 'flex',
        alignItems: 'center',
        flexBasis: 'inherit'
    });
    const $9d24b25c52c40a49$var$styles = {
        control: (style)=>({
                ...style,
                backgroundColor: 'transparent',
                border: 2,
                borderRadius: 0,
                paddingLeft: 0,
                ':hover': {
                    backgroundColor: 'transparent',
                    cursor: 'inherit'
                }
            })
    };
    const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
    const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time';
    const $9d24b25c52c40a49$var$DateTimePicker = (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
        const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
        const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
        const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
        const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
        const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
        (0, $5uXOq.useEffect)(()=>{
            if (providedValue) setValue(providedValue);
        }, [
            providedValue
        ]);
        const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
            if (providedParseValue) {
                const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
                return parsedFromFn || {
                    dateValue: providedDateValue,
                    timeValue: providedTimeValue,
                    zoneValue: providedZoneValue
                };
            }
            const parsed = (0, (0, parcelRequire("eZDAP")).default)(value);
            return (0, (0, parcelRequire("jovBr")).default)(parsed) ? {
                dateValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('YYYY-MM-DD')),
                timeValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('HH:mm')),
                zoneValue: (0, (0, parcelRequire("k7m40")).default)(parsed, (0, (0, parcelRequire("2ucUe")).convertTokens)('ZZ'))
            } : {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }, [
            providedParseValue,
            dateValue,
            timeValue,
            zoneValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
            setDateValue(parsedValues.dateValue);
            setTimeValue(parsedValues.timeValue);
            setZoneValue(parsedValues.zoneValue);
        }, [
            value,
            dateValue,
            timeValue,
            zoneValue,
            parseValue
        ]);
        const onDateBlur = (event)=>{
            setIsFocused(false);
            onBlur(event);
            if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
        };
        const onTimeBlur = (event)=>{
            setIsFocused(false);
            onBlur(event);
            if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
        };
        const onDateFocus = (event)=>{
            setIsFocused(false);
            onFocus(event);
            if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
        };
        const onTimeFocus = (event)=>{
            setIsFocused(false);
            onFocus(event);
            if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
        };
        const onDateChange = (dateValue)=>{
            const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
            onValueChange({
                providedDateValue: dateValue,
                providedTimeValue: parsedValues.timeValue,
                providedZoneValue: parsedValues.zoneValue
            });
            if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
        };
        const onTimeChange = (timeValue)=>{
            const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
            onValueChange({
                providedDateValue: parsedValues.dateValue,
                providedTimeValue: timeValue,
                providedZoneValue: parsedValues.zoneValue
            });
            if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
        };
        const onClear = ()=>{
            const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
            onValueChange({
                providedDateValue: '',
                providedTimeValue: '',
                providedZoneValue: parsedValues.zoneValue
            });
            if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
            if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
        };
        const onChangePropWithAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChangeProp,
            action: 'selectedDate',
            actionSubject: 'datePicker',
            ...$9d24b25c52c40a49$var$analyticsAttributes
        });
        const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
            setDateValue(providedDateValue);
            setTimeValue(providedTimeValue);
            setZoneValue(providedZoneValue);
            if (providedDateValue && providedTimeValue) {
                const value = (0, (0, parcelRequire("jHBnA")).formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
                const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
                const valueWithValidZone = (0, (0, parcelRequire("jHBnA")).formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
                setValue(valueWithValidZone);
                onChangePropWithAnalytics(valueWithValidZone);
            } else if (value) {
                setValue('');
                onChangePropWithAnalytics('');
            }
        };
        const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
        };
        const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, (0, parcelRequire("7VXAu")).mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
        };
        const isClearable = Boolean(dateValue || timeValue);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8JNJx")).DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $9d24b25c52c40a49$var$datePickerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9d24b25c52c40a49$var$DatePicker, {
            appearance: appearance,
            "aria-describedby": datePickerAriaDescribedBy,
            autoFocus: datePickerProps.autoFocus || autoFocus,
            dateFormat: datePickerProps.dateFormat,
            defaultIsOpen: datePickerProps.defaultIsOpen,
            defaultValue: datePickerProps.defaultValue,
            disabled: datePickerProps.disabled,
            disabledDateFilter: datePickerProps.disabledDateFilter,
            formatDisplayLabel: datePickerProps.formatDisplayLabel,
            hideIcon: datePickerProps.hideIcon || true,
            icon: datePickerProps.icon,
            id: datePickerProps.id || id,
            innerProps: datePickerProps.innerProps,
            inputLabel: datePickerProps.inputLabel,
            inputLabelId: datePickerProps.inputLabelId,
            isDisabled: datePickerProps.isDisabled || isDisabled,
            isInvalid: datePickerProps.isInvalid || isInvalid,
            isOpen: datePickerProps.isOpen,
            isRequired: datePickerProps.isRequired || isRequired,
            label: datePickerLabel,
            locale: datePickerProps.locale || locale,
            maxDate: datePickerProps.maxDate,
            minDate: datePickerProps.minDate,
            name: datePickerProps.name,
            nextMonthLabel: datePickerProps.nextMonthLabel,
            onBlur: onDateBlur,
            onChange: onDateChange,
            onFocus: onDateFocus,
            openCalendarLabel: datePickerProps.openCalendarLabel,
            parseInputValue: datePickerProps.parseInputValue,
            placeholder: datePickerProps.placeholder,
            previousMonthLabel: datePickerProps.previousMonthLabel,
            selectProps: mergedDatePickerSelectProps,
            shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
            spacing: datePickerProps.spacing || spacing,
            testId: testId && `${testId}--datepicker` || datePickerProps.testId,
            value: dateValue,
            weekStartDay: datePickerProps.weekStartDay
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $9d24b25c52c40a49$var$timePickerContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jdTq6")).default), {
            appearance: timePickerProps.appearance || appearance,
            "aria-describedby": timePickerAriaDescribedBy,
            autoFocus: timePickerProps.autoFocus,
            defaultIsOpen: timePickerProps.defaultIsOpen,
            defaultValue: timePickerProps.defaultValue,
            formatDisplayLabel: timePickerProps.formatDisplayLabel,
            hideIcon: timePickerProps.hideIcon || true,
            id: timePickerProps.id,
            innerProps: timePickerProps.innerProps,
            isDisabled: timePickerProps.isDisabled || isDisabled,
            isInvalid: timePickerProps.isInvalid || isInvalid,
            isOpen: timePickerProps.isOpen,
            isRequired: timePickerProps.isRequired || isRequired,
            label: timePickerLabel,
            locale: timePickerProps.locale || locale,
            name: timePickerProps.name,
            onBlur: onTimeBlur,
            onChange: onTimeChange,
            onFocus: onTimeFocus,
            parseInputValue: timePickerProps.parseInputValue,
            placeholder: timePickerProps.placeholder,
            selectProps: mergedTimePickerSelectProps,
            spacing: timePickerProps.spacing || spacing,
            testId: timePickerProps.testId || testId && `${testId}--timepicker`,
            timeFormat: timePickerProps.timeFormat,
            timeIsEditable: timePickerProps.timeIsEditable,
            times: timePickerProps.times,
            value: timeValue
        })), isClearable && !isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $9d24b25c52c40a49$var$iconContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            label: clearControlLabel,
            icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cQz2U"))))), {
                    ...iconProps,
                    color: "var(--ds-text-subtlest, #626F86)",
                    LEGACY_size: "small"
                }),
            onClick: onClear,
            testId: testId && `${testId}--icon--container`,
            tabIndex: -1
        })) : null);
    });
    var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;
});
parcelRegister("8C78M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8375c0a150abd1f$export$2e2bcd8739ae039);
    var $f8375c0a150abd1f$export$2e2bcd8739ae039 = [
        '00:00',
        '00:30',
        '01:00',
        '01:30',
        '02:00',
        '02:30',
        '03:00',
        '03:30',
        '04:00',
        '04:30',
        '05:00',
        '05:30',
        '06:00',
        '06:30',
        '07:00',
        '07:30',
        '08:00',
        '08:30',
        '09:00',
        '09:30',
        '10:00',
        '10:30',
        '11:00',
        '11:30',
        '12:00',
        '12:30',
        '13:00',
        '13:30',
        '14:00',
        '14:30',
        '15:00',
        '15:30',
        '16:00',
        '16:30',
        '17:00',
        '17:30',
        '18:00',
        '18:30',
        '19:00',
        '19:30',
        '20:00',
        '20:30',
        '21:00',
        '21:30',
        '22:00',
        '22:30',
        '23:00',
        '23:30'
    ];
});
parcelRegister("9idvE", function(module, exports) {
    $parcel$export(module.exports, "TimeEstimate", ()=>$367e992cb04c0b28$export$ad441edf1beb0bda);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $gtreQ;
    var $kY99m;
    var $3bDjY;
    var $koVbs;
    var $axdWJ;
    var $jDrwg;
    var $cISwW;
    var $gg0BN;
    const $367e992cb04c0b28$export$ad441edf1beb0bda = (props)=>{
        const { value: value, placeholder: placeholder = '2w 1d 5h 4m', onChange: onChange, config: config, shouldShowWarning: shouldShowWarning, fieldId: fieldId, ...fieldProps } = props;
        const [isIncorrectTimeFormat, setIsIncorrectTimeFormat] = (0, $5uXOq.useState)(false);
        const [debouncedIsValidTimeString] = (0, (0, parcelRequire("jDrwg")).default)((inputValue)=>setIsIncorrectTimeFormat(!(0, (0, parcelRequire("axdWJ")).isValidTimeString)(config)(inputValue)), 500);
        (0, $5uXOq.useEffect)(()=>{
            debouncedIsValidTimeString(value);
        }, [
            value,
            debouncedIsValidTimeString
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onValueChange = (e)=>{
            const { value: inputValue } = e.target;
            onChange(inputValue);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
            ...fieldProps,
            testId: (0, (0, parcelRequire("gg0BN")).DATA_TEST_IDS).TEXT_FIELD,
            ...fieldId && {
                'aria-describedby': `${fieldId}-field-message`
            },
            type: "text",
            value: value,
            placeholder: placeholder,
            onChange: onValueChange,
            isInvalid: isIncorrectTimeFormat,
            "aria-label": formatMessage((0, (0, parcelRequire("cISwW")).default).ariaLabel),
            elemAfterInput: shouldShowWarning === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("cISwW")).default).timeLoggedExceeded),
                testId: (0, (0, parcelRequire("gg0BN")).DATA_TEST_IDS).TOOLTIP
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("cISwW")).default).warning),
                primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y300})`,
                testId: (0, (0, parcelRequire("gg0BN")).DATA_TEST_IDS).WARNING_ICON
            })) : null
        }), isIncorrectTimeFormat && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), {
            testId: (0, (0, parcelRequire("gg0BN")).DATA_TEST_IDS).ERROR_MESSAGE
        }, formatMessage((0, (0, parcelRequire("cISwW")).default).invalidDateFormat)));
    };
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
parcelRegister("cISwW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31dfa38353da6fe4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31dfa38353da6fe4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        invalidDateFormat: {
            "id": "issue-time-estimate.edit.invalid-date-format",
            "defaultMessage": "Please enter date in the correct format"
        },
        warning: {
            "id": "issue-time-estimate.edit.warning",
            "defaultMessage": "warning"
        },
        timeLoggedExceeded: {
            "id": "issue-time-estimate.edit.time-logged-exceeded",
            "defaultMessage": "Time logged has exceeded the limit"
        },
        ariaLabel: {
            "id": "issue-time-estimate.edit.aria-label",
            "defaultMessage": "Enter the estimated time"
        }
    });
});
parcelRegister("gg0BN", function(module, exports) {
    $parcel$export(module.exports, "DATA_TEST_IDS", ()=>$63843dd83dcdc657$export$3e5d0cbd910e9c20);
    const $63843dd83dcdc657$var$getItemDataTestId = (itemId)=>`${0, $4b81b655080e9ffd$export$7c86105e5fb6a1ce}${itemId}`;
    const $63843dd83dcdc657$export$96f42c00fe93c7cb = (itemDataTestId)=>`[data-testid="${itemDataTestId}"]`;
    const $63843dd83dcdc657$export$3e5d0cbd910e9c20 = {
        TEXT_FIELD: $63843dd83dcdc657$var$getItemDataTestId('text-field'),
        TOOLTIP: $63843dd83dcdc657$var$getItemDataTestId('tooltip'),
        WARNING_ICON: $63843dd83dcdc657$var$getItemDataTestId('warning_icon'),
        ERROR_MESSAGE: $63843dd83dcdc657$var$getItemDataTestId('error-message')
    };
});
const $4b81b655080e9ffd$export$94514aa565518249 = '1w 1m';
const $4b81b655080e9ffd$export$38009905af1d42b = 'Invalid data';
const $4b81b655080e9ffd$export$7c86105e5fb6a1ce = 'issue-time-estimate.ui.edit.';
const $967029f3aa14c1ce$export$d7ed3a061805d786 = 'log-work-time-remaining';
const $967029f3aa14c1ce$export$81fee17d19007357 = 'log-work-time-spent';
const $967029f3aa14c1ce$export$ade7f171d00a976f = 'log-work-date-field';
const $967029f3aa14c1ce$export$caca24db5cb49b68 = 'log-work-description';
parcelRegister("k4Xhy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ef64d5d80c7a7ad$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6ef64d5d80c7a7ad$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeSpent: {
            "id": "issue-create-commons.log-work-field.time-spent",
            "defaultMessage": "Time Spent"
        },
        timeRemaining: {
            "id": "issue-create-commons.log-work-field.time-remaining",
            "defaultMessage": "Time Remaining"
        },
        dateStarted: {
            "id": "issue-create-commons.log-work-field.date-started",
            "defaultMessage": "Date Started"
        },
        description: {
            "id": "issue-create-commons.log-work-field.description",
            "defaultMessage": "Work Description"
        },
        originalEstimateExceededNonFinal: {
            "id": "issue-create-commons.log-work-field.original-estimate-exceeded-non-final",
            "defaultMessage": "Time logged has exceeded the original estimate"
        },
        logWorkLabel: {
            "id": "issue-create-commons.log-work-field.log-work-label",
            "defaultMessage": "Log Work"
        }
    });
    var $6ef64d5d80c7a7ad$export$2e2bcd8739ae039 = $6ef64d5d80c7a7ad$var$messages;
});
parcelRegister("3gK8l", function(module, exports) {
    $parcel$export(module.exports, "ParentLinkField", ()=>$57dcc644784339f9$export$79fe3354f3cc0f9b);
    var $5uXOq = parcelRequire("5uXOq");
    var $6XTA9;
    const $57dcc644784339f9$export$79fe3354f3cc0f9b = ({ useFormContext: useFormContext, ...commonParentLinkFieldProps })=>{
        const [{ isEpicLinkSelected: isEpicLinkSelected, selectedIssueType: selectedIssueType, requestBackedIssueType: requestBackedIssueType }] = useFormContext();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XTA9")).default), {
            ...commonParentLinkFieldProps,
            isEpicLinkSelected: isEpicLinkSelected,
            selectedIssueTypeLabel: requestBackedIssueType?.label ?? selectedIssueType?.label ?? '',
            selectedIssueTypeId: requestBackedIssueType?.value ?? selectedIssueType?.value ?? ''
        });
    };
});
parcelRegister("6XTA9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5853e32e3198f692$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $TzSzf;
    var $7C5S0;
    var $hpV4g;
    var $2QUn6;
    const $5853e32e3198f692$var$ParentLinkField = (props)=>{
        const { width: width } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("TzSzf")).DisabledEpicLinkParentLinkField), null));
    };
    var $5853e32e3198f692$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("2QUn6")).validateParentLinkField)
    })($5853e32e3198f692$var$ParentLinkField);
});
parcelRegister("2QUn6", function(module, exports) {
    $parcel$export(module.exports, "validateParentLinkField", ()=>$28e5f4df5488b2e7$export$7c8f88cf8f7b8100);
    var $bGrWH;
    const $28e5f4df5488b2e7$export$7c8f88cf8f7b8100 = (data, isRequired)=>{
        if (isRequired) {
            if (!data) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
parcelRegister("kpa4m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a77adb5d87fa1f45$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7K5PP;
    var $3bDjY;
    var $koVbs;
    var $7C5S0;
    var $hpV4g;
    var $gLdtQ;
    var $9UhzQ;
    var $lElIo;
    var $8cxH7;
    var $f1o4d;
    const $a77adb5d87fa1f45$var$SecurityLevelField = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { fieldId: fieldId, fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, (0, parcelRequire("gLdtQ")).closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, inputId: inputId } = props;
        const option = (0, (0, parcelRequire("f1o4d")).mapOptionsToData)(allowedValues);
        const isInvalid = Boolean(error);
        const getSecurityLevelField = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                inputId: inputId,
                ...fieldProps,
                options: option,
                onChange: onChange,
                value: value,
                placeholder: formatMessage((0, (0, parcelRequire("8cxH7")).default).securityLevelFieldPlaceHolder),
                isClearable: true,
                formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
                menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
                styles: (0, (0, parcelRequire("lElIo")).defaultSelectStyles),
                hideSelectedOptions: false,
                isMulti: false,
                autoFocus: autoFocus,
                validationState: isInvalid === true ? 'error' : null,
                classNamePrefix: `select-${fieldId}`,
                closeMenuOnScroll: onCloseMenuOnScroll,
                isDisabled: isEditable === false
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, isEditable === false ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: nonEditableReason?.message || ''
        }, getSecurityLevelField()) : getSecurityLevelField());
    };
    var $a77adb5d87fa1f45$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        transformDefaultValue: (0, (0, parcelRequire("f1o4d")).mapOptionToData)
    })($a77adb5d87fa1f45$var$SecurityLevelField);
});
parcelRegister("8cxH7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ee29cf370f60177f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ee29cf370f60177f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        securityLevelFieldPlaceHolder: {
            "id": "issue-create.common.fields.security-level-field.security-level-field-place-holder",
            "defaultMessage": "Select Security Level"
        }
    });
});
parcelRegister("f1o4d", function(module, exports) {
    $parcel$export(module.exports, "transformOnSubmit", ()=>$1b7192e6539d55d1$export$33ec7c3df92f1cc6);
    $parcel$export(module.exports, "mapOptionsToData", ()=>$1b7192e6539d55d1$export$ffef3a401aef987b);
    $parcel$export(module.exports, "mapOptionToData", ()=>$1b7192e6539d55d1$export$fc800909123977f3);
    $parcel$export(module.exports, "mutateSecurityLevelField", ()=>$1b7192e6539d55d1$export$f62a060ad7017e66);
    const $1b7192e6539d55d1$export$33ec7c3df92f1cc6 = (option)=>{
        const { label: label, value: value } = option;
        return {
            name: label,
            id: value
        };
    };
    const $1b7192e6539d55d1$export$ffef3a401aef987b = (options)=>options.map(({ name: name, id: id, description: description })=>({
                label: name,
                value: id,
                description: description
            }));
    const $1b7192e6539d55d1$export$fc800909123977f3 = (option)=>{
        if (option) {
            const { name: name, id: id, description: description } = option;
            return {
                label: name,
                value: id,
                description: description
            };
        }
        return null;
    };
    const $1b7192e6539d55d1$export$f62a060ad7017e66 = (selectedSecurityLevel)=>({
            security: {
                securityLevelId: selectedSecurityLevel.value
            }
        });
});
parcelRegister("cf9Hx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e441c577a1f6260$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $7C5S0;
    var $knJGc;
    var $45Cy1;
    var $khZ39;
    var $hwq1S;
    const $7e441c577a1f6260$var$TimeTrackingField = (props)=>{
        const [transformedDefaultValue, setTransformedDefaultValue] = (0, $5uXOq.useState)(undefined);
        const { defaultValue: defaultValue, additionalData: { timeTrackingSettings: timeTrackingSettings }, width: width = 350, isMini: isMini, isFieldResponsive: isFieldResponsive } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (typeof defaultValue === 'string') setTransformedDefaultValue(defaultValue.trim());
            else if (defaultValue?.timeInSeconds) setTransformedDefaultValue((0, (0, parcelRequire("khZ39")).default)(timeTrackingSettings.daysPerWeek, timeTrackingSettings.hoursPerDay)(defaultValue.timeInSeconds));
        }, [
            defaultValue,
            timeTrackingSettings.hoursPerDay,
            timeTrackingSettings.daysPerWeek
        ]);
        const [, { setTimeTrackingValue: setTimeTrackingValue }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const shouldSetWidth = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? isMini || isFieldResponsive : isMini;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: shouldSetWidth ? '100%' : width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knJGc")).default), {
            ...props,
            fieldName: formatMessage((0, (0, parcelRequire("hwq1S")).default).timeTrackingFieldName),
            defaultValue: transformedDefaultValue,
            setValueExternal: setTimeTrackingValue
        }));
    };
    var $7e441c577a1f6260$export$2e2bcd8739ae039 = $7e441c577a1f6260$var$TimeTrackingField;
});
parcelRegister("knJGc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c238289d2bd5fab1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9idvE;
    var $hpV4g;
    var $2B6IQ;
    const $c238289d2bd5fab1$export$1c882bff9d1eb3f8 = (props)=>{
        const { fieldProps: { value: value = '', onChange: onChange, ...fieldProps }, setValueExternal: setValueExternal, additionalData: { timeTrackingSettings: config }, fieldId: fieldId } = props;
        const onTimeEstimateChange = (timeEstimateValue)=>{
            onChange(timeEstimateValue);
            setValueExternal(timeEstimateValue);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9idvE")).TimeEstimate), {
            ...fieldProps,
            fieldId: fieldId,
            value: value,
            onChange: onTimeEstimateChange,
            config: config
        });
    };
    var $c238289d2bd5fab1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("hpV4g")).withFormField)({
        validator: (0, (0, parcelRequire("2B6IQ")).validateTimeTrackingField)
    })($c238289d2bd5fab1$export$1c882bff9d1eb3f8);
});
parcelRegister("2B6IQ", function(module, exports) {
    $parcel$export(module.exports, "validateTimeTrackingField", ()=>$9f226362a3a37271$export$8efa03d1ab1ed811);
    var $bGrWH;
    const $9f226362a3a37271$export$8efa03d1ab1ed811 = (value, isRequired)=>{
        if (isRequired) {
            if (value === '' || value === undefined) return 0, (0, parcelRequire("bGrWH")).REQUIRED;
        }
        return undefined;
    };
});
parcelRegister("hwq1S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$876e840344975e9d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $876e840344975e9d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timeTrackingFieldName: {
            "id": "issue-create.common.fields.time-tracking-field.time-tracking-field-name",
            "defaultMessage": "Original Estimate"
        }
    });
});
parcelRegister("gsevN", function(module, exports) {
    $parcel$export(module.exports, "transformTimeTrackingValueToSubmitFormat", ()=>$0f6af5d619112742$export$d089c9dd815e4fcf);
    $parcel$export(module.exports, "mutateTimeTrackingField", ()=>$0f6af5d619112742$export$9b1f0b2fd734a97);
    const $0f6af5d619112742$export$d089c9dd815e4fcf = (value)=>({
            originalEstimate: value
        });
    const $0f6af5d619112742$export$9b1f0b2fd734a97 = (estimate)=>({
            timeTrackingField: {
                originalEstimate: estimate
            }
        });
});
parcelRegister("do1Fc", function(module, exports) {
    $parcel$export(module.exports, "transformProjects", ()=>$b3dc6133fb5a05ec$export$227473965d2e27db);
    $parcel$export(module.exports, "transformProjectField", ()=>$b3dc6133fb5a05ec$export$1fd74e5690ffdae3);
    $parcel$export(module.exports, "transformIssueTypeField", ()=>$b3dc6133fb5a05ec$export$ab55267390bbb31a);
    $parcel$export(module.exports, "transformRequestTypeField", ()=>$b3dc6133fb5a05ec$export$fdb2672a21ca2149);
    var $9XE6b = parcelRequire("9XE6b");
    var $3M1CO;
    const $b3dc6133fb5a05ec$export$b4c0e0af0a6f8454 = ({ id: id, name: name, avatar: avatar, projectType: projectType, simplified: simplified, key: key, classificationTags: classificationTags = [] })=>({
            label: `${name} (${key})`,
            value: id,
            iconUrl: avatar.large,
            projectType: projectType && projectType.toLowerCase(),
            projectKey: key,
            isSimplified: simplified,
            classificationTags: classificationTags
        });
    const $b3dc6133fb5a05ec$export$227473965d2e27db = (projects)=>projects.map((project)=>$b3dc6133fb5a05ec$export$b4c0e0af0a6f8454(project));
    const $b3dc6133fb5a05ec$export$1fd74e5690ffdae3 = (projectResponse)=>{
        const { project: project, ...rest } = projectResponse;
        return {
            ...rest,
            selectedProject: project ? $b3dc6133fb5a05ec$export$b4c0e0af0a6f8454(project) : null
        };
    };
    const $b3dc6133fb5a05ec$export$b1a9eea64f6538d1 = ({ id: id, name: name, avatar: avatar })=>({
            label: name,
            value: id,
            iconUrl: avatar.large,
            type: (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)
        });
    const $b3dc6133fb5a05ec$export$4c05e2584b34e4d8 = (issueTypes)=>issueTypes.map((issueType)=>$b3dc6133fb5a05ec$export$b1a9eea64f6538d1(issueType));
    const $b3dc6133fb5a05ec$export$ab55267390bbb31a = (issueTypeResponse)=>{
        const { issueType: issueType, ...rest } = issueTypeResponse;
        const issueTypes = (0, ($parcel$interopDefault($9XE6b)))(issueTypeResponse, 'issueTypes.nodes', []);
        return {
            ...rest,
            selectedIssueType: issueType ? $b3dc6133fb5a05ec$export$b1a9eea64f6538d1(issueType) : null,
            issueTypes: $b3dc6133fb5a05ec$export$4c05e2584b34e4d8(issueTypes)
        };
    };
    const $b3dc6133fb5a05ec$export$566fd29819ab2bab = ({ requestTypeId: requestTypeId, name: name, description: description, helpText: helpText, key: key, avatar: avatar, issueType: { issueTypeId: issueTypeId, issueTypeName: issueTypeName }, practices: practices }, hasPractice)=>({
            label: name,
            description: description || '',
            helpText: helpText || '',
            value: `${issueTypeId}-${requestTypeId}`,
            iconUrl: (0, (0, parcelRequire("3M1CO")).transformStargateUrl)(avatar.large || ''),
            requestTypeKey: key,
            issueTypeId: issueTypeId,
            issueTypeName: issueTypeName,
            practice: (0, ($parcel$interopDefault($9XE6b)))(practices, '0.key', hasPractice ? (0, $4cff3ad70ea80f75$export$c835df30ebbd529d) : (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)),
            type: (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)
        });
    const $b3dc6133fb5a05ec$export$d3b8217e83b5a13c = (requestTypes)=>{
        const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
        return requestTypes.map((requestType)=>$b3dc6133fb5a05ec$export$566fd29819ab2bab(requestType, hasPractice)).sort((a, b)=>a.label.localeCompare(b.label));
    };
    const $b3dc6133fb5a05ec$export$fdb2672a21ca2149 = (requestTypeResponse)=>{
        const { requestType: requestType, ...rest } = requestTypeResponse;
        const requestTypes = (0, ($parcel$interopDefault($9XE6b)))(requestTypeResponse, 'requestTypes.nodes', []);
        const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
        return {
            ...rest,
            selectedRequestType: requestType ? $b3dc6133fb5a05ec$export$566fd29819ab2bab(requestType, hasPractice) : null,
            requestTypes: $b3dc6133fb5a05ec$export$d3b8217e83b5a13c(requestTypes)
        };
    };
});
parcelRegister("cpg5L", function(module, exports) {
    $parcel$export(module.exports, "getGqlUnsupportedFields", ()=>$19bae1be00f46942$export$3e4be29f4f96b2d7);
    $parcel$export(module.exports, "getQueryErrorMessage", ()=>$19bae1be00f46942$export$778f621df988f2dc);
    var $9XE6b = parcelRequire("9XE6b");
    const $19bae1be00f46942$export$3e4be29f4f96b2d7 = (errors)=>{
        const unsupportedFields = {};
        let isRequiredFieldTypeSupported = true;
        errors.forEach(({ identifier: identifier, extensions: extensions })=>{
            const { __typename: gqlType } = extensions[0] || {};
            if (gqlType === (0, $4cff3ad70ea80f75$export$b171488d52070cb3) && typeof extensions[0].fieldName === 'string' && typeof extensions[0].isRequiredField === 'boolean' && typeof extensions[0].fieldType === 'string') {
                const { fieldName: fieldName, fieldType: fieldType, isRequiredField: isRequiredField } = extensions[0];
                unsupportedFields[identifier] = {
                    gqlType: gqlType,
                    fieldId: identifier,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    isRequired: isRequiredField
                };
                if (isRequiredField) isRequiredFieldTypeSupported = false;
            }
        });
        return {
            unsupportedFields: unsupportedFields,
            isRequiredFieldTypeSupported: isRequiredFieldTypeSupported
        };
    };
    const $19bae1be00f46942$export$778f621df988f2dc = (data)=>{
        const gqlIssueCreateFieldsType = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.__typename', '');
        const queryErrorMessage = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.message', '');
        if (gqlIssueCreateFieldsType === (0, $4cff3ad70ea80f75$export$6c8cb487d6ffc522) && Boolean(queryErrorMessage)) return queryErrorMessage;
        const gqlIssueCreateLayoutType = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateLayout.__typename', '');
        const issueCreateFieldsQueryErrorMessage = (0, ($parcel$interopDefault($9XE6b)))(data, 'jiraIssueCreateFields.errors[0].extensions[0].message', '');
        if (gqlIssueCreateLayoutType === (0, $4cff3ad70ea80f75$export$6c8cb487d6ffc522) && Boolean(issueCreateFieldsQueryErrorMessage)) return issueCreateFieldsQueryErrorMessage;
        return '';
    };
});
parcelRegister("ckBKW", function(module, exports) {
    $parcel$export(module.exports, "overrideGqlTypes", ()=>$51706f093bf2a328$export$f03f31ea9e8359e8);
    var $5fc53;
    const $51706f093bf2a328$export$f03f31ea9e8359e8 = (fieldData)=>{
        const { type: type, __typename: gqlType, renderer: renderer } = fieldData || {};
        if (gqlType === (0, $962656cd6986cb06$export$3849bb04b4eee607) && type === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)) return 0, $962656cd6986cb06$export$f7a08bf17a7ac661;
        if (gqlType === (0, $962656cd6986cb06$export$3849bb04b4eee607) && type === (0, (0, parcelRequire("5fc53")).REPORTER_TYPE)) return 0, $962656cd6986cb06$export$d64150fd9c66969c;
        if (gqlType === (0, $962656cd6986cb06$export$1070aada56fcaec9) && type === (0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE)) return 0, $962656cd6986cb06$export$f57941b9c1949a82;
        if (gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) && type === (0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE)) return 0, $962656cd6986cb06$export$a138d5648dda03f0;
        if (gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) || gqlType === (0, $962656cd6986cb06$export$7a583e2ae9052377)) return renderer === 'atlassian-wiki-renderer' ? (0, $962656cd6986cb06$export$31a6c27df1f927b2) : (0, $962656cd6986cb06$export$95433ac963f4aebe);
        if (gqlType === (0, $962656cd6986cb06$export$670384150af5f49e) && type === (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)) return 0, $962656cd6986cb06$export$bf9df74e065af482;
        return gqlType;
    };
});
parcelRegister("iT5Ia", function(module, exports) {
    $parcel$export(module.exports, "getCreateConfigQuery", ()=>$02ee6d5854baf467$export$6aa2f285b19806a5);
    var $5cllN;
    var $7pXhQ;
    const $02ee6d5854baf467$export$6aa2f285b19806a5 = ({ isInContext: isInContext, withML: withML, isCreateLinkedIssue: isCreateLinkedIssue, isCreateLinkedIssueFromIssueViewFGOn: isCreateLinkedIssueFromIssueViewFGOn, isJsmRespondersFieldEnabled: isJsmRespondersFieldEnabled, isClassificationTagsEnabledForProject: isClassificationTagsEnabledForProject })=>(0, (0, parcelRequire("5cllN")).default)`
    query ${isInContext ? `JiraGlobalIssueCreateInContext${isCreateLinkedIssue && isCreateLinkedIssueFromIssueViewFGOn ? 'WithCLI' : ''}` : 'JiraGlobalIssueCreateModalLoad'}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        ${isInContext ? '' : '$issueTypes: String'}
        ${isInContext ? '' : '$requestTypes: String'}
        ${isInContext ? '$additionalContext: JiraIssueCreateContextInput!' : ''}
        ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        jiraIssueCreateLayout${isInContext ? 'InContext' : ''}${withML ? 'WithML' : ''}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            ${!isInContext ? '' : 'requestType: $requestType'}
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields${isInContext ? 'InContext' : ''}(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            ${isInContext ? 'additionalContext: $additionalContext' : ''}
            requestType: $requestType
            defaultValues: $defaultValues
            ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ${isClassificationTagsEnabledForProject ? '...ProjectFieldFragment' : '...ProjectFieldFragmentWithoutClassification'}
                        ${isInContext ? '...IssueTypeFieldFragment' : '...IssueTypeFieldSearchFragment'}
                        ${isInContext ? '...RequestTypeFieldFragment' : '...RequestTypeFieldSearchFragment'}
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${isJsmRespondersFieldEnabled ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT_WITH_ML) : (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT}
    ${isClassificationTagsEnabledForProject ? (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${isInContext ? (0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${isInContext ? (0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT}
    ${isInContext && isCreateLinkedIssueFromIssueViewFGOn ? (0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT}
    ${isJsmRespondersFieldEnabled ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT}
`;
});
parcelRegister("7pXhQ", function(module, exports) {
    $parcel$export(module.exports, "LAYOUT_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$f625f330d228b694);
    $parcel$export(module.exports, "LAYOUT_FRAGMENT_WITH_ML", ()=>$d7de7ad4c8d18b70$export$c62f67b4f409a5c6);
    $parcel$export(module.exports, "BASE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$e61b49f54d551a76);
    $parcel$export(module.exports, "PROJECT", ()=>$d7de7ad4c8d18b70$export$fe791c4fa892e400);
    $parcel$export(module.exports, "PROJECT_WITHOUT_CLASSIFICATION", ()=>$d7de7ad4c8d18b70$export$c697769cce672aaf);
    $parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$d5bb466f0c1673ed);
    $parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION", ()=>$d7de7ad4c8d18b70$export$9594a6b1142bdd10);
    $parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$5b50a50ed83e9899);
    $parcel$export(module.exports, "ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$410d36690ebc2ef6);
    $parcel$export(module.exports, "TEXT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$636915305cba61ee);
    $parcel$export(module.exports, "CONNECT_TEXT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$3cd5b2049171ec4c);
    $parcel$export(module.exports, "FORGE_STRING_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$ebc024aa691e4d85);
    $parcel$export(module.exports, "RICH_TEXT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$5b0963f21dba94f8);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$7f0a2ff1b7c9ca01);
    $parcel$export(module.exports, "FORGE_OBJECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$689ca997bd170b37);
    $parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$ab0555e54f8994f9);
    $parcel$export(module.exports, "SINGLE_USER_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$28f68e0bae1ee7f3);
    $parcel$export(module.exports, "FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$1f16b392b8d9b666);
    $parcel$export(module.exports, "MULTI_USER_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$b2adb4bd3df183ed);
    $parcel$export(module.exports, "JSM_MULTI_USER_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$fffb689cf69ab0a2);
    $parcel$export(module.exports, "FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$c43dfb9e201b83a2);
    $parcel$export(module.exports, "PEOPLE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$2b791aa6cca603ee);
    $parcel$export(module.exports, "JSM_PEOPLE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$b043dc06c0d2d4f8);
    $parcel$export(module.exports, "NUMBER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$874202730a4f96be);
    $parcel$export(module.exports, "CONNECT_NUMBER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$82ff38b10f06144a);
    $parcel$export(module.exports, "FORGE_NUMBER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$87f4b71855b27f75);
    $parcel$export(module.exports, "DATE_TIME_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$bbf5ba5f74471361);
    $parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS", ()=>$d7de7ad4c8d18b70$export$9ef617a537d543ae);
    $parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$dd6b1aecfb7f1473);
    $parcel$export(module.exports, "FORGE_DATETIME_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$7009d41cc723dac);
    $parcel$export(module.exports, "DATE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$bb1ac816b515a7c);
    $parcel$export(module.exports, "EPIC_LINK_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$47036e8bdf2c9326);
    $parcel$export(module.exports, "LABEL_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$85cf307e24504b19);
    $parcel$export(module.exports, "FORGE_STRINGS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$9255ce322dbd4481);
    $parcel$export(module.exports, "VERSION_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$37deee440fbd3c5);
    $parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$ffdfaa2ab8110c87);
    $parcel$export(module.exports, "PRIORITY_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$63d6d00b6349a8fd);
    $parcel$export(module.exports, "ATTACHMENTS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$8ca944b20979f689);
    $parcel$export(module.exports, "SECURITY_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$e0034adc460157a3);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$a4e0bff5a9855a6a);
    $parcel$export(module.exports, "URL_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$55232ce79978fe60);
    $parcel$export(module.exports, "CHECKBOX_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$2a0a6d36d97ce992);
    $parcel$export(module.exports, "SINGLE_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$2bba3db49a112c62);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$f63043138eca54b8);
    $parcel$export(module.exports, "MULTI_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$494028c0baaef0a5);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$a5740cd9553dc3be);
    $parcel$export(module.exports, "RADIO_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$8a8492487a98fdaa);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$c525f571cbe1dcbb);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$1507bfa8951ee68d);
    $parcel$export(module.exports, "FORGE_GROUP_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$51d039d4ec21f704);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$4c4a76b99fc5f54e);
    $parcel$export(module.exports, "FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$ae231dc96d2638ab);
    $parcel$export(module.exports, "SPRINT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$aba335b21420357f);
    $parcel$export(module.exports, "COLOR_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$585571cdf68c55a1);
    $parcel$export(module.exports, "REQUEST_TYPE_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$201be0ff29129622);
    $parcel$export(module.exports, "REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$589a6183e9780424);
    $parcel$export(module.exports, "RESOLUTION_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$31c88001934c2e15);
    $parcel$export(module.exports, "CASCADING_SELECT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$2f9cfac026740bd3);
    $parcel$export(module.exports, "TEAM_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$cb70b12f3de3f41c);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$1173888d99fd7ae6);
    $parcel$export(module.exports, "ASSET_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$97cdf1e4b8832240);
    $parcel$export(module.exports, "AFFECTED_SERVICES_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$3480d890dca64b9e);
    $parcel$export(module.exports, "CMDB_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$c1864cedbeda248a);
    $parcel$export(module.exports, "ORGANIZATIONS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$e0f3793fd890e0);
    $parcel$export(module.exports, "TIME_TRACKING_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$f9e6189fd786f6);
    $parcel$export(module.exports, "WORK_LOG_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$c6c1a1f3d6f49ea4);
    $parcel$export(module.exports, "PARENT_LINK_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$fa778835050523e6);
    $parcel$export(module.exports, "PARENT_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$f75050611ceb9d35);
    $parcel$export(module.exports, "STATUS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$f89396a6b77b653f);
    $parcel$export(module.exports, "RESPONDERS_FIELD_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$335dcd5b86a25a15);
    $parcel$export(module.exports, "PROFORMA_CONFIG_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$5f06542accc83cb5);
    $parcel$export(module.exports, "WATCHERS_CONFIG_FRAGMENT", ()=>$d7de7ad4c8d18b70$export$eda8fbd7533aaac1);
    var $5cllN;
    const $d7de7ad4c8d18b70$export$f625f330d228b694 = (0, (0, parcelRequire("5cllN")).default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$c62f67b4f409a5c6 = (0, (0, parcelRequire("5cllN")).default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					tabId
				}
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$e61b49f54d551a76 = (0, (0, parcelRequire("5cllN")).default)`
	fragment BaseFieldFragment on JiraIssueField {
		fieldId
		name
		type
		description
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$fe791c4fa892e400 = (0, (0, parcelRequire("5cllN")).default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
		classificationTags
	}
`;
    const $d7de7ad4c8d18b70$export$c697769cce672aaf = (0, (0, parcelRequire("5cllN")).default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
	}
`;
    const $d7de7ad4c8d18b70$export$d5bb466f0c1673ed = (0, (0, parcelRequire("5cllN")).default)`
	fragment ProjectFieldFragment on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$fe791c4fa892e400}
`;
    const $d7de7ad4c8d18b70$export$9594a6b1142bdd10 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ProjectFieldFragmentWithoutClassification on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$c697769cce672aaf}
`;
    const $d7de7ad4c8d18b70$var$ISSUE_TYPE = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueType on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
	}
`;
    const $d7de7ad4c8d18b70$export$5b50a50ed83e9899 = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueTypeFieldFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes {
			nodes {
				...IssueType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$ISSUE_TYPE}
`;
    const $d7de7ad4c8d18b70$export$410d36690ebc2ef6 = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$ISSUE_TYPE}
`;
    const $d7de7ad4c8d18b70$export$636915305cba61ee = (0, (0, parcelRequire("5cllN")).default)`
	fragment TextFieldFragment on JiraSingleLineTextField {
		text
	}
`;
    const $d7de7ad4c8d18b70$export$3cd5b2049171ec4c = (0, (0, parcelRequire("5cllN")).default)`
	fragment ConnectTextFieldFragment on JiraConnectTextField {
		text
	}
`;
    const $d7de7ad4c8d18b70$export$ebc024aa691e4d85 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeStringFieldFragment on JiraForgeStringField {
		text
	}
`;
    const $d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT = (0, (0, parcelRequire("5cllN")).default)`
	fragment JiraMediaContextFragment on JiraMediaContext {
		uploadToken {
			... on JiraMediaUploadToken {
				endpointUrl
				clientId
				targetCollection
				token
				tokenDurationInMin
			}
			... on QueryError {
				message
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$b9abb6c941d637fd = (0, (0, parcelRequire("5cllN")).default)`
	fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
		adminRichTextConfig {
			aiEnabledByProject
		}
	}
`;
    const $d7de7ad4c8d18b70$export$5b0963f21dba94f8 = (0, (0, parcelRequire("5cllN")).default)`
	fragment RichTextFieldFragment on JiraRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
		...JiraAdminRichTextFieldConfigFragment
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
	${$d7de7ad4c8d18b70$export$b9abb6c941d637fd}
`;
    const $d7de7ad4c8d18b70$export$7f0a2ff1b7c9ca01 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
    const $d7de7ad4c8d18b70$export$689ca997bd170b37 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeObjectFieldFragment on JiraForgeObjectField {
		object
	}
`;
    const $d7de7ad4c8d18b70$var$COMPONENT = (0, (0, parcelRequire("5cllN")).default)`
	fragment Component on JiraComponent {
		id: componentId
		name
	}
`;
    const $d7de7ad4c8d18b70$export$ab0555e54f8994f9 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ComponentsFieldFragment on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components {
			nodes {
				...Component
			}
		}
	}
	${$d7de7ad4c8d18b70$var$COMPONENT}
`;
    const $d7de7ad4c8d18b70$export$ff09b90989b21a8 = (0, (0, parcelRequire("5cllN")).default)`
	fragment UserFragment on User {
		accountId
		name
		picture
	}
`;
    const $d7de7ad4c8d18b70$export$28f68e0bae1ee7f3 = (0, (0, parcelRequire("5cllN")).default)`
	fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$1f16b392b8d9b666 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$b2adb4bd3df183ed = (0, (0, parcelRequire("5cllN")).default)`
	fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$fffb689cf69ab0a2 = (0, (0, parcelRequire("5cllN")).default)`
	fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$c43dfb9e201b83a2 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$2b791aa6cca603ee = (0, (0, parcelRequire("5cllN")).default)`
	fragment PeopleFieldFragment on JiraPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$b043dc06c0d2d4f8 = (0, (0, parcelRequire("5cllN")).default)`
	fragment JsmPeopleFieldFragment on JsmPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$d7de7ad4c8d18b70$export$ff09b90989b21a8}
`;
    const $d7de7ad4c8d18b70$export$874202730a4f96be = (0, (0, parcelRequire("5cllN")).default)`
	fragment NumberFieldFragment on JiraNumberField {
		number
	}
`;
    const $d7de7ad4c8d18b70$export$82ff38b10f06144a = (0, (0, parcelRequire("5cllN")).default)`
	fragment ConnectNumberFieldFragment on JiraConnectNumberField {
		number
	}
`;
    const $d7de7ad4c8d18b70$export$87f4b71855b27f75 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeNumberFieldFragment on JiraForgeNumberField {
		number
	}
`;
    const $d7de7ad4c8d18b70$export$bbf5ba5f74471361 = (0, (0, parcelRequire("5cllN")).default)`
	fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
		dateTime
	}
`;
    const $d7de7ad4c8d18b70$export$9ef617a537d543ae = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachments on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
    const $d7de7ad4c8d18b70$export$dd6b1aecfb7f1473 = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueLinksFieldFragment on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$7009d41cc723dac = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
		dateTime
	}
`;
    const $d7de7ad4c8d18b70$export$bb1ac816b515a7c = (0, (0, parcelRequire("5cllN")).default)`
	fragment DatePickerFieldFragment on JiraDatePickerField {
		date
	}
`;
    const $d7de7ad4c8d18b70$export$3cb4a99a332e4186 = (0, (0, parcelRequire("5cllN")).default)`
	fragment Epic on JiraEpic {
		name
		key
		summary
	}
`;
    const $d7de7ad4c8d18b70$export$47036e8bdf2c9326 = (0, (0, parcelRequire("5cllN")).default)`
	fragment EpicLinkFieldFragment on JiraEpicLinkField {
		epic {
			...Epic
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$3cb4a99a332e4186}
`;
    const $d7de7ad4c8d18b70$export$37aee82a3cb1e8f7 = (0, (0, parcelRequire("5cllN")).default)`
	fragment Label on JiraLabel {
		id: labelId
		name
	}
`;
    const $d7de7ad4c8d18b70$export$85cf307e24504b19 = (0, (0, parcelRequire("5cllN")).default)`
	fragment LabelFieldFragment on JiraLabelsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$37aee82a3cb1e8f7}
`;
    const $d7de7ad4c8d18b70$export$9255ce322dbd4481 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeStringsFieldFragment on JiraForgeStringsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$export$37aee82a3cb1e8f7}
`;
    const $d7de7ad4c8d18b70$var$VERSION = (0, (0, parcelRequire("5cllN")).default)`
	fragment Version on JiraVersion {
		id: versionId
		name
		status
	}
`;
    const $d7de7ad4c8d18b70$export$37deee440fbd3c5 = (0, (0, parcelRequire("5cllN")).default)`
	fragment VersionFieldFragment on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$d7de7ad4c8d18b70$var$VERSION}
`;
    const $d7de7ad4c8d18b70$export$ffdfaa2ab8110c87 = (0, (0, parcelRequire("5cllN")).default)`
	fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$d7de7ad4c8d18b70$var$VERSION}
`;
    const $d7de7ad4c8d18b70$var$PRIORITY = (0, (0, parcelRequire("5cllN")).default)`
	fragment Priority on JiraPriority {
		name
		id: priorityId
		iconUrl
	}
`;
    const $d7de7ad4c8d18b70$export$63d6d00b6349a8fd = (0, (0, parcelRequire("5cllN")).default)`
	fragment PriorityFieldFragment on JiraPriorityField {
		priority {
			...Priority
		}
		priorities {
			nodes {
				...Priority
			}
		}
	}
	${$d7de7ad4c8d18b70$var$PRIORITY}
`;
    const $d7de7ad4c8d18b70$var$SECURITY_LEVEL = (0, (0, parcelRequire("5cllN")).default)`
	fragment SecurityLevel on JiraSecurityLevel {
		id: securityId
		name
		description
	}
`;
    const $d7de7ad4c8d18b70$export$8ca944b20979f689 = (0, (0, parcelRequire("5cllN")).default)`
	fragment AttachmentsFieldFragment on JiraAttachmentsField {
		maxAllowedTotalAttachmentsSize
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
    const $d7de7ad4c8d18b70$export$e0034adc460157a3 = (0, (0, parcelRequire("5cllN")).default)`
	fragment SecurityFieldFragment on JiraSecurityLevelField {
		securityLevel {
			...SecurityLevel
		}
		securityLevels {
			nodes {
				...SecurityLevel
			}
		}
	}
	${$d7de7ad4c8d18b70$var$SECURITY_LEVEL}
`;
    const $d7de7ad4c8d18b70$var$USER_ROLES = (0, (0, parcelRequire("5cllN")).default)`
	fragment UserRoles on JiraRole {
		roleId
	}
`;
    const $d7de7ad4c8d18b70$export$a4e0bff5a9855a6a = (0, (0, parcelRequire("5cllN")).default)`
	fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
		selectedRoles {
			...UserRoles
		}
	}
	${$d7de7ad4c8d18b70$var$USER_ROLES}
`;
    const $d7de7ad4c8d18b70$export$55232ce79978fe60 = (0, (0, parcelRequire("5cllN")).default)`
	fragment UrlFieldFragment on JiraUrlField {
		url
	}
`;
    const $d7de7ad4c8d18b70$var$OPTION = (0, (0, parcelRequire("5cllN")).default)`
	fragment Option on JiraOption {
		id: optionId
		value
	}
`;
    const $d7de7ad4c8d18b70$export$2a0a6d36d97ce992 = (0, (0, parcelRequire("5cllN")).default)`
	fragment CheckboxFieldFragment on JiraCheckboxesField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$export$2bba3db49a112c62 = (0, (0, parcelRequire("5cllN")).default)`
	fragment SingleSelectFieldFragment on JiraSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$export$f63043138eca54b8 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$export$494028c0baaef0a5 = (0, (0, parcelRequire("5cllN")).default)`
	fragment MultiSelectFieldFragment on JiraMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$export$a5740cd9553dc3be = (0, (0, parcelRequire("5cllN")).default)`
	fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$export$8a8492487a98fdaa = (0, (0, parcelRequire("5cllN")).default)`
	fragment RadioSelectFieldFragment on JiraRadioSelectField {
		selectedOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$var$CLASSIFICATION_OPTION = (0, (0, parcelRequire("5cllN")).default)`
	fragment ClassificationLevel on JiraClassificationLevel {
		id
		name
		color {
			colorKey
		}
		guidelines
		definition
		status
	}
`;
    const $d7de7ad4c8d18b70$export$c525f571cbe1dcbb = (0, (0, parcelRequire("5cllN")).default)`
	fragment DataClassificationFieldFragment on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$d7de7ad4c8d18b70$var$CLASSIFICATION_OPTION}
`;
    const $d7de7ad4c8d18b70$var$GROUP = (0, (0, parcelRequire("5cllN")).default)`
	fragment Group on JiraGroup {
		groupId
		name
	}
`;
    const $d7de7ad4c8d18b70$export$1507bfa8951ee68d = (0, (0, parcelRequire("5cllN")).default)`
	fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
    const $d7de7ad4c8d18b70$export$51d039d4ec21f704 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
    const $d7de7ad4c8d18b70$export$4c4a76b99fc5f54e = (0, (0, parcelRequire("5cllN")).default)`
	fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
    const $d7de7ad4c8d18b70$export$ae231dc96d2638ab = (0, (0, parcelRequire("5cllN")).default)`
	fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$GROUP}
`;
    const $d7de7ad4c8d18b70$export$d9b12eb20c31129b = (0, (0, parcelRequire("5cllN")).default)`
	fragment MultiLineTextFieldFragment on JiraMultiLineTextField {
		text
	}
`;
    const $d7de7ad4c8d18b70$var$SPRINT = (0, (0, parcelRequire("5cllN")).default)`
	fragment Sprint on JiraSprint {
		sprintId
		name
		state
	}
`;
    const $d7de7ad4c8d18b70$export$aba335b21420357f = (0, (0, parcelRequire("5cllN")).default)`
	fragment SprintFieldFragment on JiraSprintField {
		selectedSprints {
			...Sprint
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$SPRINT}
`;
    const $d7de7ad4c8d18b70$export$585571cdf68c55a1 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ColorFieldFragment on JiraColorField {
		color {
			colorKey
		}
	}
`;
    const $d7de7ad4c8d18b70$var$REQUEST_TYPE = (0, (0, parcelRequire("5cllN")).default)`
	fragment RequestType on JsmRequestType {
		requestTypeId
		name
		description
		helpText
		key
		issueType {
			issueTypeId
		}
		avatar {
			large
		}
		practices {
			key
		}
	}
`;
    const $d7de7ad4c8d18b70$export$201be0ff29129622 = (0, (0, parcelRequire("5cllN")).default)`
	fragment RequestTypeFieldFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes {
			nodes {
				...RequestType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$REQUEST_TYPE}
`;
    const $d7de7ad4c8d18b70$export$589a6183e9780424 = (0, (0, parcelRequire("5cllN")).default)`
	fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes(searchBy: $requestTypes) {
			nodes {
				...RequestType
			}
		}
	}
	${$d7de7ad4c8d18b70$var$REQUEST_TYPE}
`;
    const $d7de7ad4c8d18b70$var$RESOLUTION = (0, (0, parcelRequire("5cllN")).default)`
	fragment Resolution on JiraResolution {
		name
		id: resolutionId
	}
`;
    const $d7de7ad4c8d18b70$export$31c88001934c2e15 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ResolutionFieldFragment on JiraResolutionField {
		resolution {
			...Resolution
		}
		resolutions {
			nodes {
				...Resolution
			}
		}
	}
	${$d7de7ad4c8d18b70$var$RESOLUTION}
`;
    const $d7de7ad4c8d18b70$export$2f9cfac026740bd3 = (0, (0, parcelRequire("5cllN")).default)`
	fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
		cascadingOption {
			parentOptionValue {
				...Option
			}
			childOptionValue {
				...Option
			}
		}
		cascadingOptions {
			nodes {
				parentOptionValue {
					...Option
				}
				childOptionValues {
					...Option
				}
			}
		}
	}
	${$d7de7ad4c8d18b70$var$OPTION}
`;
    const $d7de7ad4c8d18b70$var$TEAM = (0, (0, parcelRequire("5cllN")).default)`
	fragment Team on JiraTeam {
		name
		teamId
	}
`;
    const $d7de7ad4c8d18b70$export$cb70b12f3de3f41c = (0, (0, parcelRequire("5cllN")).default)`
	fragment TeamFieldFragment on JiraTeamField {
		selectedTeam {
			...Team
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$TEAM}
`;
    const $d7de7ad4c8d18b70$var$ATLASSIAN_TEAM = (0, (0, parcelRequire("5cllN")).default)`
	fragment AtlassianTeam on JiraAtlassianTeam {
		name
		teamId
		avatar {
			small
		}
	}
`;
    const $d7de7ad4c8d18b70$export$1173888d99fd7ae6 = (0, (0, parcelRequire("5cllN")).default)`
	fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
		JiraAtlassianTeamField: selectedTeam {
			...AtlassianTeam
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ATLASSIAN_TEAM}
`;
    const $d7de7ad4c8d18b70$var$AFFECTED_SERVICE = (0, (0, parcelRequire("5cllN")).default)`
	fragment AffectedService on JiraAffectedService {
		serviceId
	}
`;
    const $d7de7ad4c8d18b70$var$ASSET = (0, (0, parcelRequire("5cllN")).default)`
	fragment Asset on JiraAsset {
		serializedOrigin
		appKey
		originId
		value
	}
`;
    const $d7de7ad4c8d18b70$export$97cdf1e4b8832240 = (0, (0, parcelRequire("5cllN")).default)`
	fragment AssetFieldFragment on JiraAssetField {
		selectedAssets {
			...Asset
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ASSET}
`;
    const $d7de7ad4c8d18b70$export$3480d890dca64b9e = (0, (0, parcelRequire("5cllN")).default)`
	fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
		selectedAffectedServices {
			...AffectedService
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$AFFECTED_SERVICE}
`;
    const $d7de7ad4c8d18b70$export$c1864cedbeda248a = (0, (0, parcelRequire("5cllN")).default)`
	fragment CMDBFieldFragment on JiraCMDBField {
		searchUrl
		isMulti
		attributesIncludedInAutoCompleteSearch
		selectedCmdbObjects {
			id
			objectId
			workspaceId
			label
		}
	}
`;
    const $d7de7ad4c8d18b70$var$ORGANIZATION = (0, (0, parcelRequire("5cllN")).default)`
	fragment Organization on JsmOrganization {
		organizationId
		organizationName
		domain
		__typename
	}
`;
    const $d7de7ad4c8d18b70$export$e0f3793fd890e0 = (0, (0, parcelRequire("5cllN")).default)`
	fragment OrganizationsFieldFragment on JsmOrganizationField {
		selectedOrganizations {
			...Organization
		}
		searchUrl
	}
	${$d7de7ad4c8d18b70$var$ORGANIZATION}
`;
    const $d7de7ad4c8d18b70$export$f9e6189fd786f6 = (0, (0, parcelRequire("5cllN")).default)`
	fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		originalEstimate {
			timeInSeconds
		}
	}
`;
    const $d7de7ad4c8d18b70$export$c6c1a1f3d6f49ea4 = (0, (0, parcelRequire("5cllN")).default)`
	fragment WorkLogFieldFragment on JiraWorkLogField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$d7de7ad4c8d18b70$var$MEDIA_CONTEXT_FRAGMENT}
`;
    const $d7de7ad4c8d18b70$export$825c869f7cd85da3 = (0, (0, parcelRequire("5cllN")).default)`
	fragment Issue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
	}
`;
    const $d7de7ad4c8d18b70$export$fa778835050523e6 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ParentLinkFieldFragment on JiraParentIssueField {
		searchUrl
		parentIssue {
			...Issue
		}
	}
	${$d7de7ad4c8d18b70$export$825c869f7cd85da3}
`;
    const $d7de7ad4c8d18b70$export$4561a4960baf1b2b = (0, (0, parcelRequire("5cllN")).default)`
	fragment ParentIssue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
		issueColorField {
			color {
				colorKey
			}
		}
		fieldsById(ids: ["summary", "issuetype"]) {
			edges {
				node {
					... on JiraSingleLineTextField {
						text
					}
					... on JiraIssueTypeField {
						issueType {
							name
							avatar {
								xsmall
							}
						}
					}
				}
			}
		}
	}
`;
    const $d7de7ad4c8d18b70$export$f75050611ceb9d35 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ParentFieldFragment on JiraParentIssueField {
		parentIssue {
			...ParentIssue
		}
	}
	${$d7de7ad4c8d18b70$export$4561a4960baf1b2b}
`;
    const $d7de7ad4c8d18b70$export$f89396a6b77b653f = (0, (0, parcelRequire("5cllN")).default)`
	fragment StatusFieldFragment on JiraStatusField {
		name
		description
		aliasFieldId
		__typename
	}
`;
    const $d7de7ad4c8d18b70$export$335dcd5b86a25a15 = (0, (0, parcelRequire("5cllN")).default)`
	fragment JiraServiceManagementRespondersFieldFragment on JiraServiceManagementRespondersField {
		searchUrl
	}
`;
    const $d7de7ad4c8d18b70$export$5f06542accc83cb5 = (0, (0, parcelRequire("5cllN")).default)`
	fragment ProformaConfigFragment on JiraIssueCreateProformaConfiguration {
		serviceId
		proforma {
			portalLink
			hasProformaForm
		}
	}
`;
    const $d7de7ad4c8d18b70$export$eda8fbd7533aaac1 = (0, (0, parcelRequire("5cllN")).default)`
	fragment WatchersConfigFragment on JiraIssueCreateWatchersConfiguration {
		serviceId
		permissions {
			canManageWatchers
			canViewWatchers
			isAutoWatchEnabled
			isWatchersEnabled
		}
		__typename
	}
`;
});
parcelRegister("aHg9F", function(module, exports) {
    $parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContextCLI", ()=>$d7a55dae84178193$export$ccc20b3e0875172f);
    var $5cllN;
    var $co1wz;
    var $4R6GH;
    var $7pXhQ;
    const $d7a55dae84178193$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $d7a55dae84178193$export$ccc20b3e0875172f = (isCreateLinkedIssue)=>(0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalIssueCreateInContext${isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? 'WithCLI' : ''}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        $issueCreateType: IssueCreateTypeFilter
    ) {
        jiraIssueCreateLayoutInContext(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            issueCreateType: $issueCreateType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            issueCreateType: $issueCreateType
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragmentWithCopyLinksAndAttachments
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$d7a55dae84178193$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT}
    ${$d7a55dae84178193$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT}
`;
});
parcelRegister("aK8En", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT", ()=>$71173e975c8225f1$export$e53f901243688733);
    var $5cllN;
    var $co1wz;
    var $7pXhQ;
    const $71173e975c8225f1$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $71173e975c8225f1$export$e53f901243688733 = (0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalIssueCreateInContext(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
    ) {
        jiraIssueCreateLayoutInContext(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$71173e975c8225f1$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT)}
    ${$71173e975c8225f1$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT)}
`;
});
parcelRegister("3MuWj", function(module, exports) {
    $parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContext", ()=>$506479a34d707e7f$export$edf18d1585c23939);
    var $5cllN;
    var $co1wz;
    var $4R6GH;
    var $7pXhQ;
    const $506479a34d707e7f$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $506479a34d707e7f$export$edf18d1585c23939 = (withML, isCreateLinkedIssue)=>(0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalIssueCreateInContext${isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? 'WithCLI' : ''}(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        ${(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        ${withML ? 'jiraIssueCreateLayoutInContextWithML' : 'jiraIssueCreateLayoutInContext'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            ${(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            ${(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? '...ProjectFieldFragment' : '...ProjectFieldFragmentWithoutClassification'}
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$506479a34d707e7f$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT_WITH_ML) : (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT}
    ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT}
    ${(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? (0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT}
    ${$506479a34d707e7f$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT}
`;
});
parcelRegister("fWhMc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dabcfad40d4d353b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $8j2Ud;
    var $h1X40;
    var $fcZ0a;
    var $lr952;
    var $iT5Ia;
    var $8nJa2;
    var $ct3KO;
    const $dabcfad40d4d353b$var$useFetchCreateConfigQuery = (props = {})=>{
        const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, (0, parcelRequire("h1X40")).useIssueCreateErrorAnalyticsEvent)();
        const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
        const apiStartTime = (0, $5uXOq.useRef)(0);
        const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
        const [data, setData] = (0, $5uXOq.useState)({
            fieldTabs: [],
            fieldConfig: {},
            contextFields: {},
            meta: {
                areRequiredFieldsSupported: true,
                queryErrorMessage: ''
            },
            additionalServices: {}
        });
        const { withMachineLearning: withMachineLearning } = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("lr952")).useSmartFieldsMachineLearning)() : {
            withMachineLearning: false
        };
        const createConfigQuery = (0, (0, parcelRequire("4R6GH")).fg)('new-issue-create-fetch-config-query') ? (0, (0, parcelRequire("iT5Ia")).getCreateConfigQuery)({
            isInContext: false,
            withML: withMachineLearning,
            isJsmRespondersFieldEnabled: (0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false),
            isClassificationTagsEnabledForProject: !(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects')
        }) : (0, (0, parcelRequire("ct3KO")).getCreateConfigUserPreferredQuery)(withMachineLearning);
        const [fetchConfig] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? createConfigQuery : (0, (0, parcelRequire("8nJa2")).CREATE_CONFIG_USER_PREFERRED_QUERY), {
            fetchPolicy: 'no-cache',
            onCompleted: (queryData)=>{
                setApiLatency(Math.floor(performance.now() - apiStartTime.current));
                if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) setData((0, (0, parcelRequire("fcZ0a")).transformQueryResults)((0, (0, parcelRequire("fcZ0a")).transformQueryData)(queryData), displayOnlyRequiredFields));
                else setData((0, (0, parcelRequire("fcZ0a")).transformQueryResults)(queryData, displayOnlyRequiredFields));
                setLoading(false);
            },
            onError: (error)=>{
                setFetchError(error);
                if ((0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere')) fireErrorAnalyticsEvent({
                    meta: {
                        id: 'useFetchCreateConfigQuery',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    errorType: (0, (0, parcelRequire("8j2Ud")).handleApolloError)(error)
                });
                else (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchCreateConfigQuery',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        errorType: (0, (0, parcelRequire("8j2Ud")).handleApolloError)(error),
                        triggerPointKey: triggerPointKey
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
            setLoading(true);
            apiStartTime.current = performance.now();
            fetchConfig(queryVariables);
        });
        return [
            {
                isLoading: loading,
                fieldTabs: data.fieldTabs,
                fieldConfig: data.fieldConfig,
                contextFields: data.contextFields,
                meta: data.meta,
                error: fetchError,
                apiLatency: apiLatency,
                additionalServices: data.additionalServices
            },
            handleFetch.current
        ];
    };
    var $dabcfad40d4d353b$export$2e2bcd8739ae039 = $dabcfad40d4d353b$var$useFetchCreateConfigQuery;
});
parcelRegister("h1X40", function(module, exports) {
    $parcel$export(module.exports, "useIssueCreateErrorAnalyticsEvent", ()=>$5541f612a719bcc7$export$a57802f0a2053450);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $4R6GH;
    var $45Cy1;
    var $5rzqz;
    var $lr952;
    var $6gjIc;
    const $5541f612a719bcc7$export$a57802f0a2053450 = ()=>{
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, triggerPointKey: triggerPointKey, swimlaneMode: swimlaneMode, product: product, actionSource: actionSource }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const [{ selectedProject: selectedProject, canCreateAnotherIssue: canCreateAnotherIssue }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)() : [
            {
                minimizableModalView: undefined
            }
        ];
        const { withMachineLearning: withMachineLearning } = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("lr952")).useSmartFieldsMachineLearning)() : {
            withMachineLearning: false
        };
        const fireErrorAnalyticsEvent = (0, $5uXOq.useCallback)((props)=>{
            const { meta: meta, error: error, statusCode: statusCode, errorType: errorType } = props;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: meta,
                error: error,
                attributes: {
                    statusCode: statusCode,
                    errorType: errorType,
                    isNewGIC: true,
                    isCreatingAnotherIssue: canCreateAnotherIssue,
                    isSubtask: isSubTaskCreationOpen,
                    triggerPointKey: triggerPointKey,
                    projectType: selectedProject?.projectType,
                    ...selectedProject ? {
                        nextGenProject: selectedProject.isSimplified
                    } : {},
                    ...isGICPositioningEnabled() ? {
                        gicViewState: minimizableModalView
                    } : {},
                    ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                        isCreateLinkedIssue: isCreateLinkedIssue
                    } : {},
                    smartFieldsEnabled: withMachineLearning,
                    swimlaneMode: swimlaneMode,
                    ...product ? {
                        product: product
                    } : {},
                    ...actionSource ? {
                        actionSource: actionSource
                    } : {}
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            actionSource,
            canCreateAnotherIssue,
            isCreateLinkedIssue,
            isGICPositioningEnabled,
            isSubTaskCreationOpen,
            minimizableModalView,
            product,
            selectedProject,
            swimlaneMode,
            triggerPointKey,
            withMachineLearning
        ]);
        return {
            fireErrorAnalyticsEvent: fireErrorAnalyticsEvent
        };
    };
});
parcelRegister("8nJa2", function(module, exports) {
    $parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY", ()=>$1b8944214c90e766$export$61c4e8e4bb09225e);
    var $5cllN;
    var $co1wz;
    var $7pXhQ;
    const $1b8944214c90e766$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $1b8944214c90e766$export$61c4e8e4bb09225e = (0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        jiraIssueCreateLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...DataClassificationFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$1b8944214c90e766$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT)}
    ${$1b8944214c90e766$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATA_CLASSIFICATION_FIELD_FRAGMENT)}
`;
});
parcelRegister("ct3KO", function(module, exports) {
    $parcel$export(module.exports, "getCreateConfigUserPreferredQuery", ()=>$2a8040b682b6a067$export$5181d52929b93430);
    var $5cllN;
    var $co1wz;
    var $4R6GH;
    var $7pXhQ;
    const $2a8040b682b6a067$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $2a8040b682b6a067$export$5181d52929b93430 = (withML)=>(0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        ${withML ? 'jiraIssueCreateLayoutWithML' : 'jiraIssueCreateLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? '...ProjectFieldFragment' : '...ProjectFieldFragmentWithoutClassification'}
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...DataClassificationFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$2a8040b682b6a067$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT_WITH_ML) : (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT}
    ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PROFORMA_CONFIG_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT}
    ${$2a8040b682b6a067$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATA_CLASSIFICATION_FIELD_FRAGMENT}
`;
});
parcelRegister("gdlF6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c6346916455bfd3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $jcw0u;
    var $4R6GH;
    var $8j2Ud;
    var $fcZ0a;
    var $lr952;
    var $hnVR9;
    var $kepJv;
    const $c6346916455bfd3c$var$useFetchSubtaskCreateConfigQuery = (props = {})=>{
        const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [fetchError, setFetchError] = (0, $5uXOq.useState)(null);
        const apiStartTime = (0, $5uXOq.useRef)(0);
        const [apiLatency, setApiLatency] = (0, $5uXOq.useState)(0);
        const [data, setData] = (0, $5uXOq.useState)({
            fieldTabs: [],
            fieldConfig: {},
            contextFields: {},
            meta: {
                areRequiredFieldsSupported: true,
                queryErrorMessage: ''
            },
            additionalServices: {}
        });
        const { withMachineLearning: withMachineLearning } = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("lr952")).useSmartFieldsMachineLearning)() : {
            withMachineLearning: false
        };
        const [fetchSubtaskConfig] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("kepJv")).getCreateSubtaskConfigUserPreferredQuery)(withMachineLearning) : (0, (0, parcelRequire("hnVR9")).CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY), {
            fetchPolicy: 'no-cache',
            onCompleted: (queryData)=>{
                setApiLatency(Math.floor(performance.now() - apiStartTime.current));
                setData((0, (0, parcelRequire("fcZ0a")).transformQueryResults)((0, (0, parcelRequire("fcZ0a")).tranformSubtaskData)(queryData), displayOnlyRequiredFields));
                setLoading(false);
            },
            onError: (error)=>{
                setFetchError(error);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useFetchSubtaskCreateConfigQuery',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        errorType: (0, (0, parcelRequire("8j2Ud")).handleApolloError)(error),
                        triggerPointKey: triggerPointKey
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const handleFetch = (0, $5uXOq.useRef)((queryVariables)=>{
            setLoading(true);
            apiStartTime.current = performance.now();
            fetchSubtaskConfig(queryVariables);
        });
        return [
            {
                isLoading: loading,
                fieldTabs: data.fieldTabs,
                fieldConfig: data.fieldConfig,
                contextFields: data.contextFields,
                meta: data.meta,
                error: fetchError,
                apiLatency: apiLatency,
                additionalServices: data.additionalServices
            },
            handleFetch.current
        ];
    };
    var $c6346916455bfd3c$export$2e2bcd8739ae039 = $c6346916455bfd3c$var$useFetchSubtaskCreateConfigQuery;
});
parcelRegister("hnVR9", function(module, exports) {
    $parcel$export(module.exports, "CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY", ()=>$275f5c27807eebfc$export$2eaff1450330d724);
    var $5cllN;
    var $co1wz;
    var $7pXhQ;
    const $275f5c27807eebfc$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $275f5c27807eebfc$export$2eaff1450330d724 = (0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        jiraSubtaskCreationLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$275f5c27807eebfc$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT)}
    ${(0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT)}
    ${$275f5c27807eebfc$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT)}
`;
});
parcelRegister("kepJv", function(module, exports) {
    $parcel$export(module.exports, "getCreateSubtaskConfigUserPreferredQuery", ()=>$2b2560572f933275$export$466926765053d2bb);
    var $5cllN;
    var $co1wz;
    var $4R6GH;
    var $7pXhQ;
    const $2b2560572f933275$var$isJsmRespondersFieldEnabled = ()=>(0, (0, parcelRequire("co1wz")).ff)('jsm-responders-field-in-gicx-ui', false);
    const $2b2560572f933275$export$466926765053d2bb = (withML)=>(0, (0, parcelRequire("5cllN")).default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        ${withML ? 'jiraSubtaskCreationLayoutWithML' : 'jiraSubtaskCreationLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? '...ProjectFieldFragment' : '...ProjectFieldFragmentWithoutClassification'}
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ...ParentFieldFragment
                        ...StatusFieldFragment
                        ${$2b2560572f933275$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT_WITH_ML) : (0, (0, parcelRequire("7pXhQ")).LAYOUT_FRAGMENT)}
    ${0, (0, parcelRequire("7pXhQ")).BASE_FIELD_FRAGMENT}
    ${!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT) : (0, (0, parcelRequire("7pXhQ")).PROJECT_FIELD_FRAGMENT_WITHOUT_CLASSIFICATION)}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COMPONENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_VERSION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PRIORITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SPRINT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).LABEL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SECURITY_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).COLOR_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RESOLUTION_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).URL_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).EPIC_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).DATE_TIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATTACHMENTS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CHECKBOX_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ISSUE_LINKS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).RADIO_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CMDB_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).ASSET_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).TIME_TRACKING_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).WORK_LOG_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_LINK_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).PARENT_FIELD_FRAGMENT}
    ${0, (0, parcelRequire("7pXhQ")).STATUS_FIELD_FRAGMENT}
    ${$2b2560572f933275$var$isJsmRespondersFieldEnabled() ? (0, (0, parcelRequire("7pXhQ")).RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, (0, parcelRequire("7pXhQ")).WATCHERS_CONFIG_FRAGMENT}
`;
});
parcelRegister("bVBVj", function(module, exports) {
    $parcel$export(module.exports, "usePrefillCustomFields", ()=>$cd3118a2ccd39072$export$6437b2075d22652f);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $4R6GH;
    var $5rzqz;
    var $etnpM;
    var $6G308;
    const $cd3118a2ccd39072$export$6437b2075d22652f = (modalFieldConfig)=>{
        const [{ prefilledCustomFields: prefilledCustomFields }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const [data, setData] = (0, $5uXOq.useState)(modalFieldConfig);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('ecosystem_api_to_show_modern_gic') || !prefilledCustomFields || Object.keys(prefilledCustomFields).length === 0 || (0, ($parcel$interopDefault($gccSB)))(modalFieldConfig)) {
                setData(modalFieldConfig);
                return;
            }
            const cascadingSelectFieldParentOptions = {};
            const cascadingSelectFieldChildOptions = {};
            const nextData = {
                ...modalFieldConfig
            };
            Object.keys(prefilledCustomFields).forEach((key)=>{
                if (key in modalFieldConfig) {
                    const prefilledDefaultValue = (0, (0, parcelRequire("6G308")).prefillCustomFieldMap)({
                        gqlType: modalFieldConfig[key].gqlType,
                        defaultValue: prefilledCustomFields[key],
                        allowedValues: modalFieldConfig[key]?.allowedValues
                    });
                    if (!(prefilledDefaultValue === null || prefilledDefaultValue === undefined)) nextData[key] = {
                        ...nextData[key],
                        defaultValue: prefilledDefaultValue
                    };
                    if (modalFieldConfig[key].gqlType === 'JiraCascadingSelectField') cascadingSelectFieldParentOptions[key] = prefilledCustomFields[key];
                } else if (key.slice(-2) === ':1') {
                    const fieldId = key.slice(0, -2);
                    cascadingSelectFieldChildOptions[fieldId] = prefilledCustomFields[key];
                } else if (nextData?.worklog && (0, (0, parcelRequire("6G308")).workLogSubFieldTypes).includes(key)) {
                    const objectReturned = (0, (0, parcelRequire("6G308")).getWorkLogFieldValues)(key, prefilledCustomFields[key]);
                    if (objectReturned === Object(objectReturned)) {
                        if (nextData.worklog?.defaultValue) nextData.worklog.defaultValue = {
                            ...nextData.worklog.defaultValue,
                            ...objectReturned
                        };
                        else nextData.worklog.defaultValue = objectReturned;
                    }
                }
            });
            Object.keys(cascadingSelectFieldParentOptions).forEach((key)=>{
                const parentOptionId = cascadingSelectFieldParentOptions[key];
                const childOptionId = cascadingSelectFieldChildOptions[key];
                const prefilledDefaultValue = (0, (0, parcelRequire("etnpM")).getCascadingSelectFieldValue)({
                    parentOptionId: parentOptionId,
                    childOptionId: childOptionId,
                    allowedValues: modalFieldConfig[key]?.allowedValues
                });
                nextData[key] = {
                    ...nextData[key],
                    defaultValue: prefilledDefaultValue || modalFieldConfig[key].defaultValue
                };
            });
            setData(nextData);
        }, [
            modalFieldConfig,
            prefilledCustomFields
        ]);
        return data;
    };
});
parcelRegister("etnpM", function(module, exports) {
    $parcel$export(module.exports, "getCascadingSelectFieldValue", ()=>$1ec545d0d50bcd1d$export$d59f0dcb07ca0790);
    const $1ec545d0d50bcd1d$var$getExpectedParentOption = (parentOptionId)=>{
        if (typeof parentOptionId === 'string') return parentOptionId;
        if (typeof parentOptionId === 'number') return parentOptionId.toString();
        if (Array.isArray(parentOptionId) && parentOptionId.length > 0) return parentOptionId[0].toString();
        return null;
    };
    const $1ec545d0d50bcd1d$var$getExpectedParentAndChildOption = (parentOptionId, childOptionId)=>{
        const expectedParentOptionId = $1ec545d0d50bcd1d$var$getExpectedParentOption(parentOptionId);
        if (!expectedParentOptionId) return null;
        if (typeof childOptionId === 'string') return {
            parentOptionId: expectedParentOptionId,
            childOptionId: childOptionId
        };
        if (typeof childOptionId === 'number') return {
            parentOptionId: expectedParentOptionId,
            childOptionId: childOptionId.toString()
        };
        if (Array.isArray(childOptionId) && childOptionId.length > 0) return {
            parentOptionId: expectedParentOptionId,
            childOptionId: childOptionId[0].toString()
        };
        return {
            parentOptionId: expectedParentOptionId,
            childOptionId: null
        };
    };
    const $1ec545d0d50bcd1d$export$d59f0dcb07ca0790 = ({ parentOptionId: parentOptionId, childOptionId: childOptionId, allowedValues: allowedValues })=>{
        if (!Array.isArray(allowedValues)) return null;
        const expectedFieldValue = $1ec545d0d50bcd1d$var$getExpectedParentAndChildOption(parentOptionId, childOptionId);
        if (!expectedFieldValue) return null;
        const defaultValue = {
            parentOptionValue: null,
            childOptionValue: null,
            __typename: 'JiraCascadingOption'
        };
        for (const parentValue of allowedValues)if (parentValue.parentOptionValue.id === expectedFieldValue.parentOptionId) {
            defaultValue.parentOptionValue = parentValue.parentOptionValue;
            for (const childValue of parentValue.childOptionValues)if (childValue.id === expectedFieldValue.childOptionId) {
                defaultValue.childOptionValue = childValue;
                return defaultValue;
            }
            return defaultValue;
        }
        return null;
    };
});
parcelRegister("6G308", function(module, exports) {
    $parcel$export(module.exports, "prefillCustomFieldMap", ()=>$cbb243738764b010$export$a0ff4688b4bd0aa);
    $parcel$export(module.exports, "getWorkLogFieldValues", ()=>$cbb243738764b010$export$910fc0c56ee210a6);
    $parcel$export(module.exports, "workLogSubFieldTypes", ()=>$cbb243738764b010$export$b94f52a1c0256fc7);
    var $7dn0D;
    var $6NTrh;
    var $2qFSV;
    var $3BxDG;
    var $91uU6;
    var $98zU9;
    var $dCkLU;
    var $5rDnT;
    var $fgZVN;
    const $cbb243738764b010$var$fieldMap = {
        JiraDateTimePickerField: (0, (0, parcelRequire("7dn0D")).getDateTimePickerFieldValue),
        JiraSingleVersionPickerField: (0, (0, parcelRequire("5rDnT")).getSingleVersionPickerValue),
        JiraRichTextField: (0, (0, parcelRequire("98zU9")).getRichTextFieldValue),
        JiraConnectRichTextField: (0, (0, parcelRequire("98zU9")).getRichTextFieldValue),
        JiraUrlField: (0, (0, parcelRequire("fgZVN")).getStringFieldValue),
        JiraSingleLineTextField: (0, (0, parcelRequire("fgZVN")).getStringFieldValue),
        JiraConnectTextField: (0, (0, parcelRequire("fgZVN")).getStringFieldValue),
        JiraNumberField: (0, (0, parcelRequire("91uU6")).getNumberFieldValue),
        JiraConnectNumberField: (0, (0, parcelRequire("91uU6")).getNumberFieldValue),
        JiraSingleSelectField: (0, (0, parcelRequire("dCkLU")).getSingleSelectFieldValue),
        JiraRadioSelectField: (0, (0, parcelRequire("dCkLU")).getSingleSelectFieldValue),
        JiraConnectSingleSelectField: (0, (0, parcelRequire("dCkLU")).getSingleSelectFieldValue),
        JiraCheckboxesField: (0, (0, parcelRequire("2qFSV")).getMultipleSelectFieldValue),
        JiraMultipleVersionPickerField: (0, (0, parcelRequire("3BxDG")).getMultipleVersionPickerFieldValue),
        JiraMultipleSelectField: (0, (0, parcelRequire("2qFSV")).getMultipleSelectFieldValue),
        JiraConnectMultipleSelectField: (0, (0, parcelRequire("2qFSV")).getMultipleSelectFieldValue),
        JiraLabelsField: (0, (0, parcelRequire("6NTrh")).getLabelsFieldValue),
        JiraDatePickerField: (0, (0, parcelRequire("7dn0D")).getDatePickerFieldValue),
        JiraTextAreaField: (0, (0, parcelRequire("fgZVN")).getStringFieldValue),
        JiraForgeNumberField: (0, (0, parcelRequire("91uU6")).getNumberFieldValue),
        JiraForgeDatetimeField: (0, (0, parcelRequire("7dn0D")).getDateTimePickerFieldValue),
        JiraForgeDateField: (0, (0, parcelRequire("7dn0D")).getDatePickerFieldValue),
        JiraForgeStringsField: (0, (0, parcelRequire("6NTrh")).getLabelsFieldValue),
        JiraForgeStringField: (0, (0, parcelRequire("fgZVN")).getStringFieldValue),
        JiraForgeObjectField: (0, (0, parcelRequire("fgZVN")).getForgeObjectFieldValue)
    };
    const $cbb243738764b010$export$a0ff4688b4bd0aa = ({ gqlType: gqlType, defaultValue: defaultValue, allowedValues: allowedValues })=>{
        if (typeof $cbb243738764b010$var$fieldMap[gqlType] !== 'function') return null;
        if (allowedValues) return $cbb243738764b010$var$fieldMap[gqlType]({
            defaultValue: defaultValue,
            allowedValues: allowedValues
        });
        return $cbb243738764b010$var$fieldMap[gqlType](defaultValue);
    };
    const $cbb243738764b010$export$910fc0c56ee210a6 = (key, input)=>{
        if (key === 'worklog_timeLogged') return {
            timeSpent: (0, (0, parcelRequire("fgZVN")).getStringFieldValue)(input)
        };
        if (key === 'worklog_startDate') return {
            dateValue: (0, (0, parcelRequire("7dn0D")).getDateTimePickerFieldValue)(input)
        };
        if (key === 'worklog_comment') return {
            description: (0, (0, parcelRequire("98zU9")).getRichTextFieldValue)(input)
        };
        if (key === 'timetracking_remainingestimate') return {
            timeRemaining: (0, (0, parcelRequire("fgZVN")).getStringFieldValue)(input)
        };
    };
    const $cbb243738764b010$export$b94f52a1c0256fc7 = [
        'worklog_timeLogged',
        'worklog_startDate',
        'worklog_comment',
        'timetracking_remainingestimate'
    ];
});
parcelRegister("7dn0D", function(module, exports) {
    $parcel$export(module.exports, "getDatePickerFieldValue", ()=>$72f3a68263fb2f4a$export$ef420f815233cde0);
    $parcel$export(module.exports, "getDateTimePickerFieldValue", ()=>$72f3a68263fb2f4a$export$ec8ca4015b404669);
    var $as8uy;
    const $72f3a68263fb2f4a$export$ef420f815233cde0 = (defaultValue)=>{
        if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
            if ((0, (0, parcelRequire("as8uy")).findADate)(defaultValue[0])) return (0, (0, parcelRequire("as8uy")).findADate)(defaultValue[0])?.slice(0, 10);
        }
        if ((0, (0, parcelRequire("as8uy")).findADate)(defaultValue)) return (0, (0, parcelRequire("as8uy")).findADate)(defaultValue)?.slice(0, 10);
        return null;
    };
    const $72f3a68263fb2f4a$export$ec8ca4015b404669 = (defaultValue)=>{
        if (Array.isArray(defaultValue) && defaultValue.length > 0 && typeof defaultValue[0] === 'string') {
            if ((0, (0, parcelRequire("as8uy")).findADate)(defaultValue[0])) return (0, (0, parcelRequire("as8uy")).findADate)(defaultValue[0]);
        }
        return (0, (0, parcelRequire("as8uy")).findADate)(defaultValue);
    };
});
parcelRegister("as8uy", function(module, exports) {
    $parcel$export(module.exports, "findADate", ()=>$38d6693e4dc85ce3$export$3ce9cccf56f196eb);
    const $38d6693e4dc85ce3$var$monthMap = {
        Jan: '01',
        January: '01',
        Feb: '02',
        February: '02',
        Mar: '03',
        March: '03',
        Apr: '04',
        April: '04',
        May: '05',
        Jun: '06',
        June: '06',
        Jul: '07',
        July: '07',
        Aug: '08',
        August: '08',
        Sep: '09',
        September: '09',
        Oct: '10',
        October: '10',
        Nov: '11',
        November: '11',
        Dec: '12',
        December: '12'
    };
    const $38d6693e4dc85ce3$var$formatDay = (day)=>{
        if (day.length === 1) return `0${day}`;
        return day;
    };
    const $38d6693e4dc85ce3$var$formatMonth = (month)=>{
        if ($38d6693e4dc85ce3$var$monthMap[month]) return $38d6693e4dc85ce3$var$monthMap[month];
        if (month.length === 1) return `0${month}`;
        return month;
    };
    const $38d6693e4dc85ce3$var$formatYear = (year)=>{
        const yearAsNumber = Number(year);
        if (yearAsNumber < 100) return yearAsNumber + 2000;
        return yearAsNumber;
    };
    const $38d6693e4dc85ce3$var$constructISOTime = (time)=>{
        const timeStr = time.trim();
        const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
        const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
        const match24Hour = timeStr.match(time24HourPattern);
        if (match24Hour) {
            let [, hours, minutes, seconds] = match24Hour;
            seconds = seconds || '00';
            return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
        }
        const match12Hour = timeStr.match(time12HourPattern);
        if (match12Hour) {
            let hours;
            let minutes;
            let ampm;
            [, hours, minutes, ampm] = match12Hour;
            hours = parseInt(hours, 10);
            minutes = parseInt(minutes, 10);
            if (ampm) {
                ampm = ampm.toLowerCase();
                if (ampm === 'pm' && hours !== 12) hours += 12;
                else if (ampm === 'am' && hours === 12) hours = 0;
            }
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
        }
        return '00:00:00';
    };
    const $38d6693e4dc85ce3$var$constructISODateTime = (date)=>{
        const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
        const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
        const matchForDay = date.match(regexForDay);
        const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
        if (matchForDay) {
            const [, day, month, year, time] = matchForDay;
            let formattedDay = $38d6693e4dc85ce3$var$formatDay(day);
            let formattedMonth = $38d6693e4dc85ce3$var$formatMonth(month);
            const formattedYear = $38d6693e4dc85ce3$var$formatYear(year);
            let skipMatchingDay = false;
            if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else if (Number(formattedMonth) > 12) {
                if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                    formattedMonth,
                    formattedDay
                ];
                else skipMatchingDay = true;
            }
            if (!skipMatchingDay) {
                const isoTime = $38d6693e4dc85ce3$var$constructISOTime(time);
                return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
            }
        }
        if (matchForDayWithYYYYFirst) {
            const [, year, month, day, time] = matchForDayWithYYYYFirst;
            let formattedDay = $38d6693e4dc85ce3$var$formatDay(day);
            let formattedMonth = $38d6693e4dc85ce3$var$formatMonth(month);
            const formattedYear = $38d6693e4dc85ce3$var$formatYear(year);
            if (Number(formattedMonth) > 12) {
                if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                    formattedMonth,
                    formattedDay
                ];
                else return null;
            }
            const isoTime = $38d6693e4dc85ce3$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
        return null;
    };
    function $38d6693e4dc85ce3$var$convertUnixToISO(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);
        if (!date.getTime()) return null;
        return date.toISOString().slice(0, 19);
    }
    const $38d6693e4dc85ce3$export$3ce9cccf56f196eb = (defaultValue)=>{
        if (typeof defaultValue === 'number') return $38d6693e4dc85ce3$var$convertUnixToISO(defaultValue);
        if (typeof defaultValue === 'string') {
            if (Number(defaultValue)) return $38d6693e4dc85ce3$var$convertUnixToISO(Number(defaultValue));
            return $38d6693e4dc85ce3$var$constructISODateTime(defaultValue);
        }
        return null;
    };
});
parcelRegister("6NTrh", function(module, exports) {
    $parcel$export(module.exports, "getLabelsFieldValue", ()=>$5d5843626d4b267f$export$dc7bb12ca069dc65);
    var $gccSB = parcelRequire("gccSB");
    const $5d5843626d4b267f$export$dc7bb12ca069dc65 = (defaultValue)=>{
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return [
            {
                id: null,
                name: defaultValue.toString()
            }
        ];
        const constructedLabels = [];
        if (Array.isArray(defaultValue)) {
            for (const value of defaultValue)if (typeof value === 'string' || typeof value === 'number') constructedLabels.push({
                name: value.toString(),
                id: null
            });
            return (0, ($parcel$interopDefault($gccSB)))(constructedLabels) ? null : constructedLabels;
        }
        return null;
    };
});
parcelRegister("2qFSV", function(module, exports) {
    $parcel$export(module.exports, "getMultipleSelectFieldValue", ()=>$e57cd9a9f1f7b289$export$e9f00fd2d2b5131c);
    var $gccSB = parcelRequire("gccSB");
    const $e57cd9a9f1f7b289$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        const values = [];
        for (const defaultValues of defaultValue){
            for (const isValue of allowedValues)if (isValue.id === defaultValues.toString()) values.push({
                value: isValue.value,
                id: isValue.id
            });
        }
        return values;
    };
    const $e57cd9a9f1f7b289$export$e9f00fd2d2b5131c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        let values = [];
        if (Array.isArray(allowedValues)) {
            if (Array.isArray(defaultValue)) values = $e57cd9a9f1f7b289$var$constructValuesArray({
                defaultValue: defaultValue,
                allowedValues: allowedValues
            });
            if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $e57cd9a9f1f7b289$var$constructValuesArray({
                defaultValue: [
                    defaultValue
                ],
                allowedValues: allowedValues
            });
            return (0, ($parcel$interopDefault($gccSB)))(values) ? null : values;
        }
        return null;
    };
});
parcelRegister("3BxDG", function(module, exports) {
    $parcel$export(module.exports, "getMultipleVersionPickerFieldValue", ()=>$eda1ab700ba52b8e$export$949962cffa318724);
    var $gccSB = parcelRequire("gccSB");
    const $eda1ab700ba52b8e$var$constructValuesArray = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        const values = [];
        for (const defaultValues of defaultValue){
            for (const isValue of allowedValues)if (isValue.id === defaultValues.toString()) values.push({
                name: isValue.name,
                id: isValue.id,
                status: isValue.status
            });
        }
        return values;
    };
    const $eda1ab700ba52b8e$export$949962cffa318724 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        let values = [];
        if (Array.isArray(allowedValues)) {
            if (Array.isArray(defaultValue)) values = $eda1ab700ba52b8e$var$constructValuesArray({
                defaultValue: defaultValue,
                allowedValues: allowedValues
            });
            if (typeof defaultValue === 'string' || typeof defaultValue === 'number') values = $eda1ab700ba52b8e$var$constructValuesArray({
                defaultValue: [
                    defaultValue
                ],
                allowedValues: allowedValues
            });
            return (0, ($parcel$interopDefault($gccSB)))(values) ? null : values;
        }
        return null;
    };
});
parcelRegister("91uU6", function(module, exports) {
    $parcel$export(module.exports, "getNumberFieldValue", ()=>$3d1926021ed90b50$export$f01b59e00fd68f64);
    const $3d1926021ed90b50$export$f01b59e00fd68f64 = (value)=>{
        if (Array.isArray(value) && value.length >= 1) return Number(value[0]);
        if (typeof value === 'number' || typeof value === 'string') return Number(value);
        return null;
    };
});
parcelRegister("98zU9", function(module, exports) {
    $parcel$export(module.exports, "getRichTextFieldValue", ()=>$fc860e2fd7b544b6$export$24f9d0bf92885ed9);
    var $kOFhM;
    var $hYNZx;
    var $dN5CS;
    const $fc860e2fd7b544b6$export$c442cd75d72477d0 = (wiki)=>{
        if (wiki === undefined) return {
            version: 1,
            type: 'doc',
            content: []
        };
        const adfTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
        const wikiMarkupTransformer = new (0, (0, parcelRequire("dN5CS")).WikiMarkupTransformer)((0, (0, parcelRequire("kOFhM")).defaultSchema));
        const pmNode = wikiMarkupTransformer.parse(wiki);
        return adfTransformer.encode(pmNode);
    };
    const $fc860e2fd7b544b6$export$9acea0de85f3957 = (field)=>{
        return field && field.type === 'doc' && Array.isArray(field.content);
    };
    const $fc860e2fd7b544b6$export$24f9d0bf92885ed9 = (defaultValue)=>{
        if (Array.isArray(defaultValue) && defaultValue.length > 0) {
            if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $fc860e2fd7b544b6$export$c442cd75d72477d0(defaultValue[0].toString());
            if ($fc860e2fd7b544b6$export$9acea0de85f3957(defaultValue[0])) return defaultValue[0];
        }
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return $fc860e2fd7b544b6$export$c442cd75d72477d0(defaultValue.toString());
        if ($fc860e2fd7b544b6$export$9acea0de85f3957(defaultValue)) return defaultValue;
        return null;
    };
});
parcelRegister("dCkLU", function(module, exports) {
    $parcel$export(module.exports, "getSingleSelectFieldValue", ()=>$1c5295294666c2cc$export$6847a775f22c9956);
    const $1c5295294666c2cc$var$findValueInAllowedValues = (value, allowedValues)=>{
        if (!Array.isArray(allowedValues)) return null;
        for (const isValue of allowedValues){
            if (isValue.id === value.toString()) return {
                value: isValue.value,
                id: isValue.id
            };
        }
        return null;
    };
    const $1c5295294666c2cc$export$6847a775f22c9956 = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        if (Array.isArray(defaultValue) && defaultValue.length > 0) {
            if (typeof defaultValue[0] === 'string' || typeof defaultValue[0] === 'number') return $1c5295294666c2cc$var$findValueInAllowedValues(defaultValue[0], allowedValues);
        }
        if (typeof defaultValue === 'string' || typeof defaultValue === 'number') return $1c5295294666c2cc$var$findValueInAllowedValues(defaultValue, allowedValues);
        return null;
    };
});
parcelRegister("5rDnT", function(module, exports) {
    $parcel$export(module.exports, "getSingleVersionPickerValue", ()=>$cc6a5291d10a9d3e$export$829c840f2c90595c);
    const $cc6a5291d10a9d3e$var$getExpectedFieldValue = (defaultValue)=>{
        if (typeof defaultValue === 'string') return defaultValue;
        if (typeof defaultValue === 'number') return defaultValue.toString();
        if (Array.isArray(defaultValue) && defaultValue.length > 0) return defaultValue[0].toString();
        return null;
    };
    const $cc6a5291d10a9d3e$export$829c840f2c90595c = ({ defaultValue: defaultValue, allowedValues: allowedValues })=>{
        if (!Array.isArray(allowedValues)) return null;
        const expectedFieldValue = $cc6a5291d10a9d3e$var$getExpectedFieldValue(defaultValue);
        if (!expectedFieldValue) return null;
        for (const value of allowedValues){
            if (expectedFieldValue === value.id) return {
                id: value.id,
                status: value.status,
                name: value.name
            };
        }
        return null;
    };
});
parcelRegister("fgZVN", function(module, exports) {
    $parcel$export(module.exports, "getStringFieldValue", ()=>$31d3650d04cafb78$export$62ea57a19c685649);
    $parcel$export(module.exports, "getForgeObjectFieldValue", ()=>$31d3650d04cafb78$export$aef33e0e296607e6);
    const $31d3650d04cafb78$export$62ea57a19c685649 = (value)=>{
        if (typeof value === 'string') return value;
        if (typeof value === 'number') return value.toString();
        if (Array.isArray(value)) return value[0].toString();
        return null;
    };
    const $31d3650d04cafb78$export$aef33e0e296607e6 = (value)=>{
        return JSON.stringify(value);
    };
});
parcelRegister("hFu8Z", function(module, exports) {
    $parcel$export(module.exports, "createIssueDismissModalEntryPoint", ()=>$45748b8e63ef067d$export$b59b81279190875a);
    var $eufEc;
    var $fEDBv;
    const $45748b8e63ef067d$export$b59b81279190875a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("dyE1F")), {
            moduleId: "f800056e"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("dyE1F", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4rWe1").then(()=>parcelRequire('fT41A'));
});
parcelRegister("jagDx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92ca13d1242468b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gccSB = parcelRequire("gccSB");
    var $ajpes = parcelRequire("ajpes");
    var $k9tnV;
    var $efXp3;
    var $kxqHl;
    var $dC5iT;
    var $8CUq3;
    var $2P6J2;
    var $2vSU6;
    var $dMnMc;
    var $6s1PB;
    var $4R6GH;
    var $jJZqs;
    var $pa9q9;
    var $9J85a;
    var $6ikhl;
    var $gifeQ;
    var $koVbs;
    var $f8WR0;
    var $1F7mG;
    var $bGrWH;
    var $7C5S0;
    var $iblgc;
    var $2p4Te;
    var $2ntXc;
    var $5eGnF;
    var $9svjh;
    var $45Cy1;
    var $kxNzI;
    var $9QJ7Z;
    var $cKWWX;
    var $5rzqz;
    var $1n4jA;
    var $cYlk7;
    var $8zOmE;
    var $isuse;
    var $2NMNM;
    var $efvDm;
    var $ldyPw;
    var $5knXz;
    var $k9JTq;
    var $6gjIc;
    var $jhPH1;
    var $2tPtq;
    var $jE4bA;
    var $02X4k;
    var $f2cnb;
    var $fp4bR;
    var $7kEHt;
    var $cS2PJ;
    var $13Rnw;
    var $eMaIO;
    var $iSAdX;
    var $hx2H6;
    var $gB2JP;
    var $9TbCg;
    var $64HID;
    var $aPuaG;
    var $br2XI;
    const $92ca13d1242468b8$var$CreateFormBase = (props)=>{
        const [{ sectionMessage: sectionMessage, payload: triggerIssueCreatePayload, alertsToBeLinked: alertsToBeLinked, isSubTaskCreationOpen: isSubTaskCreationOpen, disableProjectDropdown: disableProjectDropdown, disableIssueTypeDropdown: disableIssueTypeDropdown, displayHeaderActionContainer: displayHeaderActionContainer, displaySitePicker: displaySitePicker, context: context, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue, isModalLoadInContext: isModalLoadInContext, wasStateRestored: wasStateRestored, minimizableModalView: minimizableModalView, submitErrorMessage: presetSubmitErrorMessage, overrideUseRequestTypeFieldsToggleState: overrideUseRequestTypeFieldsToggleState, isMiniDesignEnabled: isMiniDesignEnabled, sessionId: sessionId, ExternalControls: ExternalControls }, { clearSectionMessage: clearSectionMessage, removeAlertFromAlertsToBeLinked: removeAlertFromAlertsToBeLinked }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { onIssueCreateSuccess: onIssueCreateSuccess, canCreateAnotherIssue: canCreateAnotherIssue = false, isLoading: isLoading, fieldConfig: fieldConfig, fieldTabs: fieldTabs, contextFields: contextFields, filteredOutModules: filteredOutModules, meta: meta, error: error, apiLatency: apiLatency, onFetchConfig: fetchConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, getFormState: getFormState, onFormFieldsReset: onFormFieldsReset, statusFieldProps: statusFieldProps, classificationFieldProps: classificationFieldProps, proformaConfiguration: proformaConfiguration, watchersConfigurations: watchersConfigurations, onResetApolloCache: onResetApolloCache } = props;
        const isEmbedded = (0, (0, parcelRequire("1n4jA")).useIsEmbedded)() && (0, (0, parcelRequire("4R6GH")).fg)('update-gic-error-toast-copy');
        const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
        const { data: { user: currentUser } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const { interactedFields: interactedFields } = (0, (0, parcelRequire("jhPH1")).useInteractedFields)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const [{ watchers: watchers, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } }, isSmartFieldsToggled: isSmartFieldsToggled }, { setIsForgeFieldsDetected: setIsForgeFieldsDetected, resetExpandedCollapsedArea: resetExpandedCollapsedArea, setIsSmartFieldsToggled: setIsSmartFieldsToggled }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const uiModificationsStatus = (0, (0, parcelRequire("1F7mG")).useUiModificationsEnabledStatus)(hasFinishedLoading);
        const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: formMeta, areConfiguredFieldsModified: areConfiguredFieldsModified }, { setSelectedProject: setSelectedProject, setSelectedIssueType: setSelectedIssueType, setRequestBackedIssueType: setRequestBackedIssueType, setIsEpicLinkSelected: setIsEpicLinkSelected, setSubmitting: setSubmitting, setMeta: setMeta, setSubmitErrorMessage: setSubmitErrorMessage, setSubmitFieldwiseErrors: setSubmitFieldwiseErrors, setDataFetchError: setDataFetchError, setInlineErrorMessage: setInlineErrorMessage, setIsFormDirty: setIsFormDirty, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setResetFormAction: setResetFormAction, setShouldAutoFocus: setShouldAutoFocus }] = (0, (0, parcelRequire("45Cy1")).useCreateFormState)();
        const [{ selectedCloudId: selectedCloudId }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        const [createIssue] = (0, (0, parcelRequire("jE4bA")).default)(selectedCloudId);
        const [fields, { dispatchFormSubmits: dispatchFormSubmits, resetState: resetState }] = (0, (0, parcelRequire("6ikhl")).useInlineFields)();
        const shouldUseRequestTypeDefault = (0, $5uXOq.useRef)(true);
        const retainedFieldsData = (0, $5uXOq.useRef)([]);
        const [forgeFieldBlockStatus, setForgeFieldBlockStatus] = (0, $5uXOq.useState)((0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8));
        const { formatMessage: formatMessage, formatList: formatList } = (0, (0, parcelRequire("koVbs")).default)();
        const [hasCreatedAnotherIssue, setHasCreatedAnotherIssue] = (0, $5uXOq.useState)(false);
        const { initialClassification: initialClassification } = classificationFieldProps || {};
        const [selectedClassification, setSelectedClassification, onClassificationOptionChange] = (0, (0, parcelRequire("2ntXc")).useClassificationState)(initialClassification);
        const createFormScrollRef = (0, $5uXOq.useCallback)((node)=>{
            if (!node) return;
            if (formMeta?.submitErrorMessage || hasCreatedAnotherIssue) (0, (0, parcelRequire("k9tnV")).default)(node, (0, (0, parcelRequire("bGrWH")).DEFAULT_SCROLL_OPTIONS));
        }, [
            formMeta?.submitErrorMessage,
            hasCreatedAnotherIssue
        ]);
        const resetSummary = (0, $5uXOq.useRef)(null);
        const formRef = (0, $5uXOq.useRef)();
        const previousForgeFieldsState = (0, $5uXOq.useRef)(null);
        const isRestoring = (0, $5uXOq.useRef)(wasStateRestored);
        const [selectedTransition, setSelectedTransition] = (0, $5uXOq.useState)(null);
        const onChangeSelectedTransition = (t)=>{
            const analyticsEvent = createAnalyticsEvent({});
            setSelectedTransition(t);
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'statusInGic changed');
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, {
                selectedTransition: t
            });
        };
        const formSetFieldValue = (0, $5uXOq.useRef)();
        const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, (0, parcelRequire("5knXz")).useStorageEnforcement)();
        const shouldShowStatus = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("br2XI")).shouldShowStatusField)(selectedProject?.projectType, fieldConfig), [
            selectedProject,
            fieldConfig
        ]);
        const shouldShowLinkedAlerts = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("br2XI")).shouldShowLinkedAlertsField)(selectedProject?.projectType, selectedIssueType, alertsToBeLinked), [
            selectedProject?.projectType,
            selectedIssueType,
            alertsToBeLinked
        ]);
        const shouldShowWatchers = selectedProject?.projectType !== (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT);
        const reloadForm = (0, $5uXOq.useCallback)((project, issueType, includeIssueTypesAndRequestTypes)=>{
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).linkedIssue : (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    }
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, (0, parcelRequire("br2XI")).getQueryVariables)(project, issueType, (0, (0, parcelRequire("br2XI")).getUserInputForRetention)(userInputForRetentionParams)),
                    ...includeIssueTypesAndRequestTypes ? {
                        issueTypes: triggerIssueCreatePayload?.issueTypes,
                        requestTypes: triggerIssueCreatePayload?.requestTypes
                    } : {},
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...issueCreateTypeFilter()
                }
            });
        }, [
            getFormState,
            fieldConfig,
            dirtyFieldsCurrentSession,
            fetchConfig,
            triggerIssueCreatePayload?.issueTypes,
            triggerIssueCreatePayload?.requestTypes,
            triggerIssueCreatePayload?.additionalContext,
            triggerIssueCreatePayload?.parentId,
            triggerIssueCreatePayload?.defaultValues,
            isModalLoadInContext,
            isCreateLinkedIssue,
            selectedClassification
        ]);
        const onProjectChange = (0, $5uXOq.useCallback)((project)=>{
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            setSelectedProject(project);
            setSelectedIssueType(null);
            setSelectedTransition(null);
            setRequestBackedIssueType(null);
            setInlineErrorMessage(null);
            setShouldAutoFocus(false);
            if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) resetExpandedCollapsedArea();
            shouldUseRequestTypeDefault.current = true;
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return isModalLoadInContext && isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                    issueCreateType: isCreateLinkedIssue ? (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).linkedIssue : (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    }
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, (0, parcelRequire("br2XI")).getQueryVariables)(project, null, (0, (0, parcelRequire("br2XI")).getUserInputForRetention)(userInputForRetentionParams)),
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false);
            setIsForgeFieldsDetected(false);
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, {
                project: project
            });
        }, [
            dirtyFieldsCurrentSession,
            fetchConfig,
            fieldConfig,
            getFormState,
            isCreateLinkedIssue,
            isModalLoadInContext,
            publish,
            setInlineErrorMessage,
            setIsEpicLinkSelected,
            setIsForgeFieldsDetected,
            setRequestBackedIssueType,
            setSelectedIssueType,
            setSelectedProject,
            setSubmitErrorMessage,
            setSubmitFieldwiseErrors,
            triggerIssueCreatePayload?.additionalContext,
            triggerIssueCreatePayload?.parentId,
            triggerIssueCreatePayload?.defaultValues,
            setShouldAutoFocus,
            resetExpandedCollapsedArea,
            selectedClassification
        ]);
        const onIssueTypeSelected = (0, $5uXOq.useCallback)((issueType)=>{
            if (selectedProject && issueType) {
                setSubmitErrorMessage('');
                setSubmitFieldwiseErrors({});
                setShouldAutoFocus(false);
                setRequestBackedIssueType(null);
                setInlineErrorMessage(null);
                if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) resetExpandedCollapsedArea();
                shouldUseRequestTypeDefault.current = issueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44);
                const userInputForRetentionParams = {
                    formState: getFormState.current(),
                    fieldConfig: fieldConfig,
                    dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                    retainedFieldsData: retainedFieldsData,
                    initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                    selectedClassification: selectedClassification
                };
                const payloadDefaultValues = ()=>{
                    const { projectType: projectType } = selectedProject || {};
                    if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return (0, ($parcel$interopDefault($gccSB)))(getFormState.current()?.dirtyFields) ? {
                        defaultValues: triggerIssueCreatePayload?.defaultValues || {}
                    } : {};
                    return {};
                };
                const issueCreateTypeFilter = ()=>{
                    const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                    return isModalLoadInContext && isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                        issueCreateType: isCreateLinkedIssue ? (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).linkedIssue : (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).standard,
                        additionalContext: {
                            linkedIssue: {
                                sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                                includeLinks: issuelinks?.includeLinks,
                                includeAttachments: issuelinks?.includeAttachments
                            }
                        },
                        ...payloadDefaultValues()
                    } : {};
                };
                fetchConfig({
                    variables: {
                        ...(0, (0, parcelRequire("br2XI")).getQueryVariables)(selectedProject, issueType, (0, (0, parcelRequire("br2XI")).getUserInputForRetention)(userInputForRetentionParams)),
                        issueTypes: triggerIssueCreatePayload?.issueTypes,
                        requestTypes: triggerIssueCreatePayload?.requestTypes,
                        parentId: triggerIssueCreatePayload?.parentId,
                        ...isModalLoadInContext && {
                            additionalContext: triggerIssueCreatePayload?.additionalContext
                        },
                        ...issueCreateTypeFilter()
                    }
                });
                setIsEpicLinkSelected(false);
                setIsForgeFieldsDetected(false);
                publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, {
                    issueType: issueType
                });
            }
        }, [
            selectedProject,
            setSubmitErrorMessage,
            setSubmitFieldwiseErrors,
            setRequestBackedIssueType,
            setInlineErrorMessage,
            getFormState,
            fieldConfig,
            dirtyFieldsCurrentSession,
            fetchConfig,
            triggerIssueCreatePayload?.issueTypes,
            triggerIssueCreatePayload?.requestTypes,
            triggerIssueCreatePayload?.parentId,
            triggerIssueCreatePayload?.additionalContext,
            triggerIssueCreatePayload?.defaultValues,
            isModalLoadInContext,
            setIsEpicLinkSelected,
            setIsForgeFieldsDetected,
            publish,
            isCreateLinkedIssue,
            setShouldAutoFocus,
            resetExpandedCollapsedArea,
            selectedClassification
        ]);
        const project = contextFields.project?.selectedProject;
        const issueType = contextFields.issuetype?.selectedIssueType;
        const requestType = contextFields.requestType?.selectedRequestType;
        const inlineError = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("br2XI")).transformInlineErrorMessage)(sectionMessage), [
            sectionMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, {
                fieldConfig: fieldConfig
            });
        }, [
            publish,
            fieldConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (areConfiguredFieldsModified && selectedProject && selectedIssueType) {
                setAreConfiguredFieldsModified(false);
                const userInputForRetentionParams = {
                    formState: getFormState.current(),
                    fieldConfig: fieldConfig,
                    dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                    retainedFieldsData: retainedFieldsData,
                    initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                    selectedClassification: selectedClassification
                };
                const issueCreateTypeFilter = ()=>{
                    const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                    return isModalLoadInContext && isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? {
                        issueCreateType: isCreateLinkedIssue ? (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).linkedIssue : (0, (0, parcelRequire("bGrWH")).ISSUE_CREATE_TYPE).standard,
                        additionalContext: {
                            linkedIssue: {
                                sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                                includeLinks: issuelinks?.includeLinks,
                                includeAttachments: issuelinks?.includeAttachments
                            }
                        }
                    } : {};
                };
                fetchConfig({
                    variables: {
                        ...(0, (0, parcelRequire("br2XI")).getQueryVariables)(selectedProject, selectedIssueType, (0, (0, parcelRequire("br2XI")).getUserInputForRetention)(userInputForRetentionParams)),
                        parentId: triggerIssueCreatePayload?.parentId,
                        ...isModalLoadInContext && {
                            additionalContext: triggerIssueCreatePayload?.additionalContext
                        },
                        ...issueCreateTypeFilter()
                    }
                });
                setIsEpicLinkSelected(false);
            }
        }, [
            isModalLoadInContext,
            fetchConfig,
            fieldConfig,
            selectedProject,
            selectedIssueType,
            areConfiguredFieldsModified,
            setAreConfiguredFieldsModified,
            dirtyFieldsCurrentSession,
            retainedFieldsData,
            setIsEpicLinkSelected,
            triggerIssueCreatePayload?.parentId,
            triggerIssueCreatePayload?.additionalContext,
            triggerIssueCreatePayload?.defaultValues,
            getFormState,
            isCreateLinkedIssue,
            selectedClassification
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isRestoring.current) {
                if (project || issueType) isRestoring.current = false;
                return;
            }
            if (project) setSelectedProject(project);
            if (issueType) {
                setSelectedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? requestType : issueType);
                setRequestBackedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? issueType : null);
            }
        }, [
            issueType,
            project,
            requestType,
            setSelectedIssueType,
            setSelectedProject,
            setRequestBackedIssueType
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const newMeta = {
                ...formMeta,
                ...meta
            };
            if (!(0, ($parcel$interopDefault($ajpes)))(formMeta, newMeta)) setMeta(newMeta);
        }, [
            formMeta,
            meta,
            setMeta
        ]);
        const { initialTransition: initialTransition, preselectedTransition: preselectedTransition } = statusFieldProps || {};
        (0, $5uXOq.useEffect)(()=>{
            setSelectedTransition(preselectedTransition || initialTransition || null);
        }, [
            initialTransition,
            preselectedTransition,
            setSelectedTransition
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setSelectedClassification(initialClassification || undefined);
        }, [
            initialClassification,
            setSelectedClassification
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setDataFetchError(error);
        }, [
            error,
            setDataFetchError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setInlineErrorMessage(inlineError);
        }, [
            inlineError,
            setInlineErrorMessage
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (presetSubmitErrorMessage) setSubmitErrorMessage(presetSubmitErrorMessage);
        }, [
            presetSubmitErrorMessage,
            setSubmitErrorMessage
        ]);
        (0, (0, parcelRequire("02X4k")).useDescriptionAnalytics)();
        const currentUIModificationsConsentState = (0, (0, parcelRequire("f8WR0")).useUIModificationsConsentStatus)();
        const onUIModificationsConsentRequiredMount = (analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, 'jiraUiModificationsObligatoryConsent gicHidden');
        const areForgeInlineFieldsStoredOrIdle = (0, $5uXOq.useCallback)(()=>Object.values(fields).every((fieldData)=>fieldData.status === (0, $3e5c7761c2e3cf02$export$9956c6a700e724c4) || fieldData.status === (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)), [
            fields
        ]);
        const isForgeInlineFieldsError = (0, $5uXOq.useCallback)(()=>Object.values(fields).some((fieldData)=>fieldData.status === (0, $3e5c7761c2e3cf02$export$742c877aeb0f3dbd)), [
            fields
        ]);
        const showInvitePrompt = (0, (0, parcelRequire("2tPtq")).useInvitePrompt)(selectedProject?.projectKey);
        const onCreateSuccess = ({ issueCreateResponse: issueCreateResponse, issueCreateFieldsUsed: issueCreateFieldsUsed, issueCreateContextUsed: issueCreateContextUsed, telemetryAttributes: telemetryAttributes = {}, collapsedFieldsLength: collapsedFieldsLength })=>{
            const { key: issueKey, id: issueId, watchers: watchersResponse } = issueCreateResponse;
            onIssueCreateSuccess({
                issueKey: issueKey,
                issueId: Number(issueId)
            }, shouldShowWatchers ? watchersResponse : undefined);
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('groot-aioli-v5');
            const cohort = expConfig.get('cohort', 'not-enrolled');
            if (cohort !== 'not-enrolled') showInvitePrompt(getFormState.current()?.values?.description);
            setSubmitting(false);
            const boardId = (0, (0, parcelRequire("dMnMc")).getBoardId)(window.location.href);
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                sessionId: sessionId,
                issueCreateFieldsUsed: issueCreateFieldsUsed,
                issueCreateContextUsed: issueCreateContextUsed,
                boardId: boardId !== null ? Number(boardId) : undefined,
                projectType: selectedProject?.projectType,
                issueType: (0, (0, parcelRequire("br2XI")).getAnalyticsIssueType)(selectedIssueType),
                ...!!selectedIssueType?.value && {
                    issueTypeId: selectedIssueType?.value
                },
                ...selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? {
                    hasRequestType: true,
                    requestTypeKey: selectedIssueType?.requestTypeKey
                } : {
                    hasRequestType: false
                },
                triggerPointKey: triggerPointKey,
                ...shouldShowWatchers && {
                    watchers: {
                        count: watchers?.length,
                        used: (0, (0, parcelRequire("br2XI")).isWatchersUsed)({
                            watchers: watchers,
                            isAutoWatchEnabled: watchersConfigurations?.isAutoWatchEnabled,
                            currentUserAccountId: currentUser.accountId
                        }),
                        ...watchersConfigurations
                    }
                },
                ...shouldShowLinkedAlerts && {
                    linkedAlerts: alertsToBeLinked
                },
                edition: selectedProject?.projectType && (0, (0, parcelRequire("ldyPw")).getEditionForProject)(selectedProject.projectType, appEditions),
                collapsedFieldsLength: collapsedFieldsLength
            };
            if (shouldShowStatus) {
                attributes.statusInGicEnabled = true;
                if (selectedTransition && !selectedTransition.isInitial) attributes.userChangedStatusTo = selectedTransition.to?.statusCategory?.name;
            }
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issue created', attributes);
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskSuccess', {
                task: 'createIssue',
                isNewGIC: true,
                isCreated: true,
                triggerPointKey: triggerPointKey,
                edition: selectedProject?.projectType && (0, (0, parcelRequire("ldyPw")).getEditionForProject)(selectedProject.projectType, appEditions),
                application: selectedProject?.projectType && (0, (0, parcelRequire("efvDm")).getApplicationForProject)(selectedProject.projectType),
                ...telemetryAttributes
            });
        };
        const findFirstTabIndexWithErrors = (0, $5uXOq.useCallback)((errors = {})=>{
            const index = fieldTabs.findIndex((tab)=>tab.items.find((item)=>errors && item === Object.keys(errors)[0]));
            return index > -1 ? index : 0;
        }, [
            fieldTabs
        ]);
        const onCreateFailure = ({ issueCreateError: err, telemetryAttributes: telemetryAttributes })=>{
            setSubmitting(false);
            if ((0, (0, parcelRequire("jJZqs")).isValidationError)(err)) {
                const { message: message } = err;
                if (message && message.length) setSubmitErrorMessage(message.split('; ').join('\r\n'));
                const errors = 'errors' in err ? (0, (0, parcelRequire("br2XI")).transformValidationErrors)(err.errors) : undefined;
                setSubmitFieldwiseErrors(errors);
                setCurrentActiveTabIndex(findFirstTabIndexWithErrors(errors));
                const customFieldError = (0, (0, parcelRequire("br2XI")).isDisplayConditionCFCausingError)('errors' in err ? err.errors : [], fieldConfig, filteredOutModules);
                if (customFieldError) {
                    const errorMessage = customFieldError.length > 1 ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).multipleRequiredCustomFieldsIssueCreationBlock, {
                        fieldsName: formatList(customFieldError, {
                            style: 'long',
                            type: 'conjunction'
                        })
                    }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).singleRequiredCustomFieldIssueCreationBlock, {
                        fieldName: formatList(customFieldError, {
                            style: 'short',
                            type: 'conjunction'
                        })
                    });
                    setSubmitErrorMessage(String(errorMessage));
                }
                return errors;
            }
            let description;
            if (isEmbedded) description = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).embeddedCreateErrorFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).embeddedCreateErrorFlagDescription;
            else description = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).createErrorFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).createErrorFlagDescription;
            showFlag({
                type: 'error',
                title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).createErrorFlagTitleIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).createErrorFlagTitle,
                description: description,
                testId: 'jira-issue-create.modal.create-form.error-flag'
            });
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskFail', {
                task: 'createIssue',
                isNewGIC: true,
                isCreated: true,
                triggerPointKey: triggerPointKey,
                edition: selectedProject?.projectType && (0, (0, parcelRequire("ldyPw")).getEditionForProject)(selectedProject.projectType, appEditions),
                application: selectedProject?.projectType && (0, (0, parcelRequire("efvDm")).getApplicationForProject)(selectedProject.projectType),
                ...telemetryAttributes
            });
            return undefined;
        };
        const onSubmit = async (formData, formApi)=>{
            if (selectedProject && selectedIssueType) {
                setSubmitting(true);
                setSubmitErrorMessage('');
                setSubmitFieldwiseErrors({});
                const telemetryAttributes = {
                    wasIssueCreatedWithCreateAnotherIssue: hasCreatedAnotherIssue,
                    view: minimizableModalView
                };
                if (isForgeInlineFieldsError()) {
                    const forgeInlineError = new (0, (0, parcelRequire("jJZqs")).ValidationError)('', Object.keys(fields).map((key)=>({
                            field: key,
                            error: formatMessage((0, (0, parcelRequire("cS2PJ")).default).createErrorForgeInlineField)
                        })));
                    return onCreateFailure({
                        issueCreateError: forgeInlineError,
                        telemetryAttributes: telemetryAttributes
                    });
                }
                const isForgeFieldFocused = Object.values(fields).some((field)=>field.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487));
                const isForgeIframe = (el)=>el.dataset?.forgeIframe === 'true';
                const activeElement = window.document?.activeElement;
                const isForgeIframeActive = activeElement instanceof HTMLElement && isForgeIframe(activeElement);
                const shouldFocusFormButton = isForgeFieldFocused || isForgeIframeActive;
                if (shouldFocusFormButton || !areForgeInlineFieldsStoredOrIdle() && forgeFieldBlockStatus !== (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5)) {
                    if (shouldFocusFormButton) {
                        previousForgeFieldsState.current = fields;
                        (0, (0, parcelRequire("gifeQ")).focusFormButton)((0, $c758c3cb80bbdb5a$export$2d077da71c26c1c5));
                    }
                    setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$30daef8830f2505d));
                    const timeout = setTimeout(()=>{
                        setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5));
                        clearTimeout(timeout);
                    }, (0, $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15));
                    return undefined;
                }
                try {
                    const payload = {
                        formData: {
                            ...(0, (0, parcelRequire("br2XI")).getContextFieldsForSubmit)(selectedProject, selectedIssueType, contextFields.requestType?.fieldId),
                            ...(0, (0, parcelRequire("br2XI")).getParentIdForSubmit)(triggerIssueCreatePayload?.parentId),
                            ...formData
                        },
                        onSuccess: (issueCreateSuccessProps)=>onCreateSuccess({
                                ...issueCreateSuccessProps,
                                telemetryAttributes: telemetryAttributes
                            }),
                        fieldConfig: fieldConfig,
                        ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                            fieldTabs: fieldTabs,
                            hasIssueAdjustmentModules: uiModificationsStatus === 'enabled'
                        },
                        ...(0, (0, parcelRequire("br2XI")).canSetContextForSubmit)(selectedProject, context) && {
                            context: context
                        },
                        ...(0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') && {
                            createLinkedIssuePayload: {
                                isCreateLinkedIssue: isCreateLinkedIssue,
                                sourceIssueKey: isCreateLinkedIssue ? triggerIssueCreatePayload?.defaultValues?.issueLinks?.linkedIssueKeys[0] : null
                            }
                        },
                        isSubTaskCreationOpen: isSubTaskCreationOpen,
                        triggerPointKey: triggerPointKey,
                        sessionId: sessionId,
                        interactedFields: interactedFields,
                        shouldShowStatus: shouldShowStatus
                    };
                    try {
                        if (selectedClassification) payload.formData.dataclassification = {
                            id: selectedClassification?.id ? (0, (0, parcelRequire("2P6J2")).PlatformClassificationTagAri).parse(selectedClassification.id)?.tagId : null
                        };
                    } catch (e) {}
                    if (shouldShowStatus && selectedTransition && !selectedTransition.isInitial) payload.transition = {
                        id: selectedTransition.id
                    };
                    if (shouldShowWatchers && watchersConfigurations?.canManageWatchers) {
                        payload.watchers = watchers?.map((watcher)=>watcher.accountId);
                        payload.skipAutoWatch = true;
                    }
                    await createIssue(payload);
                    setHasCreatedAnotherIssue(false);
                    if (forgeFieldBlockStatus === (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5)) {
                        const timedoutCFS = [];
                        Object.entries(fields).forEach(([key, value])=>{
                            if (value.status === (0, $3e5c7761c2e3cf02$export$f81c1d6b9217380c)) timedoutCFS.push(fieldConfig[key].fieldName);
                        });
                        if (timedoutCFS.length) showFlag({
                            type: 'warning',
                            title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).timeoutForgeInlineFieldTitleIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).timeoutForgeInlineFieldTitle,
                            description: [
                                (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cS2PJ")).default).timeoutForgeInlineFieldDescriptionIssueTermRefresh : (0, (0, parcelRequire("cS2PJ")).default).timeoutForgeInlineFieldDescription,
                                {
                                    fields: timedoutCFS.join(', '),
                                    bold: (str)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, str)
                                }
                            ],
                            testId: 'jira-issue-create.modal.create-form.forge-timeout-flag'
                        });
                    }
                    if (canCreateAnotherIssue) {
                        setShouldAutoFocus(true);
                        sectionMessage && clearSectionMessage();
                        setTimeout(()=>{
                            const fieldsReset = (0, (0, parcelRequire("br2XI")).resetFormFieldsForCreateAnother)(formData, fieldConfig, formApi.reset);
                            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, {
                                fieldsReset: fieldsReset ?? {}
                            });
                            setSelectedTransition(statusFieldProps?.initialTransition || null);
                            setSelectedClassification(classificationFieldProps?.initialClassification || undefined);
                            onFormFieldsReset?.();
                            setHasCreatedAnotherIssue(true);
                        }, 0);
                    }
                    const isSoftwareProjectSelected = selectedProject.projectType === 'software';
                    if (isSoftwareProjectSelected) showEnforcementIfStorageIsFull({
                        delayShow: minimizableModalView === 'modal' && canCreateAnotherIssue,
                        shouldOnlyShowInJSWContext: false,
                        touchpoint: 'global-issue-create'
                    });
                } catch (err) {
                    return onCreateFailure({
                        issueCreateError: err,
                        telemetryAttributes: telemetryAttributes
                    });
                }
            }
            resetState();
            return undefined;
        };
        (0, $5uXOq.useEffect)(()=>{
            if (forgeFieldBlockStatus !== (0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8)) {
                const isTimeout = forgeFieldBlockStatus === (0, $3e5c7761c2e3cf02$export$e784a07a62e2e0e5);
                const customUIFieldStateCheck = previousForgeFieldsState.current !== fields;
                if (areForgeInlineFieldsStoredOrIdle() && customUIFieldStateCheck || isTimeout) {
                    previousForgeFieldsState.current = fields;
                    setForgeFieldBlockStatus((0, $3e5c7761c2e3cf02$export$f86e250f1a7b07c8));
                    (0, (0, parcelRequire("9J85a")).submitForgeFormField)(formRef);
                } else dispatchFormSubmits();
            }
        }, [
            areForgeInlineFieldsStoredOrIdle,
            getFormState,
            forgeFieldBlockStatus,
            selectedTransition
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg')) (0, $5uXOq.useEffect)(()=>{
            if (isSmartFieldsToggled === true) {
                selectedProject && reloadForm(selectedProject, selectedIssueType, false);
                setIsSmartFieldsToggled(false);
            }
        }, [
            isSmartFieldsToggled,
            reloadForm,
            selectedIssueType,
            selectedProject,
            setIsSmartFieldsToggled
        ]);
        const onIssueCreateFormMount = (analyticsEvent)=>(0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(analyticsEvent, 'IssueCreateForm rendered');
        const handleFormDirty = (dirty)=>{
            let isDirty = dirty;
            if (dirtyFieldsCurrentSession && dirtyFieldsCurrentSession.current && Object.keys(dirtyFieldsCurrentSession.current).length) isDirty = true;
            setIsFormDirty(isDirty);
        };
        const getForm = ()=>{
            if (currentUIModificationsConsentState === (0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38)) {
                resetSummary.current = null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                    onMount: onUIModificationsConsentRequiredMount
                });
            }
            if (!isLoading && meta.queryErrorMessage) {
                resetSummary.current = null;
                return null;
            }
            if (isLoading || !(selectedProject && selectedIssueType)) {
                resetSummary.current = null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iblgc")).default), {
                    skeletonCount: 6
                });
            }
            if (fieldConfig && !meta.queryErrorMessage) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("efXp3")).default), {
                key: `${selectedProject.value}-${selectedIssueType.value}`,
                onSubmit: onSubmit,
                isDisabled: !meta.areRequiredFieldsSupported
            }, ({ formProps: formProps, getState: getState, dirty: dirty, reset: reset, setFieldValue: setFieldValue })=>{
                getFormState.current = getState;
                formSetFieldValue.current = setFieldValue;
                handleFormDirty(dirty);
                if (!resetSummary.current) {
                    resetSummary.current = reset;
                    setResetFormAction(reset);
                }
                const getLayoutRenderer = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7kEHt")).default), {
                        fieldConfig: fieldConfig,
                        fieldTabs: fieldTabs,
                        setFieldValue: setFieldValue,
                        getFormState: getState,
                        apiLatency: apiLatency,
                        fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
                    });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$WrapperDiv, null, (0, ($parcel$interopDefault($5uXOq))).createElement("form", {
                    ...formProps,
                    id: "issue-create.ui.modal.create-form",
                    ref: (ref)=>{
                        formRef.current = ref;
                    },
                    noValidate: true
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9QJ7Z")).FormApiProvider), {
                    getFormState: getState,
                    setFieldValue: setFieldValue
                }, getLayoutRenderer()))));
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
                onMount: onIssueCreateFormMount
            }));
            return null;
        };
        const getRequestTypeFieldsLayoutPreference = ()=>contextFields.requestType?.requestTypes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iSAdX")).RequestTypeFieldsLayoutPreference), {
                isRequestTypeSelected: selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44),
                onChange: ()=>selectedProject && reloadForm(selectedProject, selectedIssueType, false),
                overrideIsEnabled: overrideUseRequestTypeFieldsToggleState
            });
        const getProformaBanner = ()=>!isLoading && proformaConfiguration?.hasProformaForm && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("13Rnw")).ProformaBanner), {
                portalLink: proformaConfiguration.portalLink
            });
        const getClassificationField = ()=>classificationFieldProps?.availableClassifications?.length && classificationFieldProps.availableClassifications.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2p4Te")).default), {
                allowedValues: classificationFieldProps?.availableClassifications || [],
                value: selectedClassification,
                onChange: onClassificationOptionChange,
                width: isMini ? '100%' : undefined,
                nonEditableReason: classificationFieldProps.nonEditableMessage,
                ...classificationFieldProps,
                errorMessage: formMeta?.submitFieldwiseErrors?.dataclassification
            }) : null;
        const issueTypes = contextFields.issuetype?.issueTypes;
        const issueTypesMemoised = (0, $5uXOq.useMemo)(()=>issueTypes || [], [
            issueTypes
        ]);
        const projectPickerIsDisabled = isSubTaskCreationOpen || disableProjectDropdown;
        const oldContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMaIO")).default), {
            onChange: onProjectChange,
            value: selectedProject,
            renderOptionsLimit: 25,
            skipFetchProjects: !!meta.queryErrorMessage,
            disableFetchProject: projectPickerIsDisabled,
            isDisabled: projectPickerIsDisabled,
            width: isMini ? '100%' : undefined
        }), isMini && selectedProject?.projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$MiniIssueTypeStatusWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPuaG")).default), {
            issueTypes: issueTypesMemoised,
            requestTypes: contextFields.requestType?.requestTypes,
            onChange: onIssueTypeSelected,
            value: selectedIssueType,
            projectType: selectedProject?.projectType,
            isDisabled: disableIssueTypeDropdown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("64HID")).default), {
            isLoading: !!statusFieldProps.isTransitionsLoading,
            error: statusFieldProps.transitionsError,
            transitions: statusFieldProps.availableTransitions || [],
            isMini: true,
            value: selectedTransition,
            onChange: onChangeSelectedTransition
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPuaG")).default), {
            issueTypes: issueTypesMemoised,
            requestTypes: contextFields.requestType?.requestTypes,
            onChange: onIssueTypeSelected,
            value: selectedIssueType,
            projectType: selectedProject?.projectType,
            isDisabled: disableIssueTypeDropdown,
            isMini: isMini
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).Divider), null), shouldShowStatus && statusFieldProps && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("64HID")).default), {
            isLoading: !!statusFieldProps.isTransitionsLoading,
            error: statusFieldProps.transitionsError,
            transitions: statusFieldProps.availableTransitions || [],
            isMini: false,
            value: selectedTransition,
            onChange: onChangeSelectedTransition
        })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxNzI")).LinkedAlertsField), {
            value: alertsToBeLinked || [],
            onRemoveButtonClick: removeAlertFromAlertsToBeLinked
        }), getProformaBanner(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fp4bR")).ExternalControlsRenderer), {
            externalControls: ExternalControls,
            setFieldValue: formSetFieldValue.current,
            getFormState: getFormState.current
        }), getForm());
        const hasCollapsedFields = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? (0, $5uXOq.useMemo)(()=>fieldTabs.some((tab)=>!!tab.collapsedItems?.length), [
            fieldTabs
        ]) : undefined;
        const newContent = (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$RelativeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$FlexWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$RequiredMessage, {
            "aria-hidden": "true",
            isMini: !!isMini
        }, formatMessage((0, (0, parcelRequire("cS2PJ")).default).requiredFieldsSummary), " ", (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxqHl")).default), null)), displayHeaderActionContainer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f2cnb")).ActionsContainer), {
            watchersConfigurations: watchersConfigurations,
            fieldConfig: fieldConfig
        })), displaySitePicker && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gB2JP")).default), {
            onChange: onResetApolloCache,
            width: isMini ? '100%' : undefined
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMaIO")).default), {
            onChange: onProjectChange,
            value: selectedProject,
            renderOptionsLimit: 25,
            skipFetchProjects: !!meta.queryErrorMessage,
            disableFetchProject: projectPickerIsDisabled,
            isDisabled: projectPickerIsDisabled,
            width: isMini ? '100%' : undefined
        }), minimizableModalView === 'mini' && selectedProject?.projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($92ca13d1242468b8$var$MiniIssueTypeStatusWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPuaG")).default), {
            issueTypes: issueTypesMemoised,
            requestTypes: contextFields.requestType?.requestTypes,
            onChange: onIssueTypeSelected,
            value: selectedIssueType,
            projectType: selectedProject?.projectType,
            isDisabled: disableIssueTypeDropdown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("64HID")).default), {
            isLoading: !!statusFieldProps.isTransitionsLoading,
            error: statusFieldProps.transitionsError,
            transitions: statusFieldProps.availableTransitions || [],
            isMini: true,
            value: selectedTransition,
            onChange: onChangeSelectedTransition
        })), uiModificationsStatus !== 'enabled' && hasCollapsedFields && (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $92ca13d1242468b8$var$smartFieldMessageWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).Divider), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TbCg")).SmartFieldMessage), null))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPuaG")).default), {
            issueTypes: issueTypesMemoised,
            requestTypes: contextFields.requestType?.requestTypes,
            onChange: onIssueTypeSelected,
            value: selectedIssueType,
            projectType: selectedProject?.projectType,
            isDisabled: disableIssueTypeDropdown,
            isMini: isMini
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).Divider), null), uiModificationsStatus !== 'enabled' && hasCollapsedFields && (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TbCg")).SmartFieldMessage), null), shouldShowStatus && statusFieldProps && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("64HID")).default), {
            isLoading: !!statusFieldProps.isTransitionsLoading,
            error: statusFieldProps.transitionsError,
            transitions: statusFieldProps.availableTransitions || [],
            isMini: false,
            value: selectedTransition,
            onChange: onChangeSelectedTransition
        })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kxNzI")).LinkedAlertsField), {
            value: alertsToBeLinked || [],
            onRemoveButtonClick: removeAlertFromAlertsToBeLinked
        }), getProformaBanner(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fp4bR")).ExternalControlsRenderer), {
            externalControls: ExternalControls,
            setFieldValue: formSetFieldValue.current,
            getFormState: getFormState.current
        }), getForm());
        (0, $5uXOq.useEffect)(()=>{
            let forgeCustomFieldDetected = false;
            Object.values(fieldConfig).forEach((field)=>{
                if ((0, (0, parcelRequire("gifeQ")).isForgeCustomField)(field.fieldType)) forgeCustomFieldDetected = true;
            });
            setIsForgeFieldsDetected(forgeCustomFieldDetected);
        }, [
            fieldConfig,
            setIsForgeFieldsDetected
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: createFormScrollRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: (0, (0, parcelRequire("bGrWH")).FORM_DROPZONE_CONTAINER_ID)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hx2H6")).default), null), isGICPositioningEnabled() ? newContent : oldContent));
    };
    const $92ca13d1242468b8$var$CreateForm = (0, $5uXOq.memo)($92ca13d1242468b8$var$CreateFormBase);
    var $92ca13d1242468b8$export$2e2bcd8739ae039 = $92ca13d1242468b8$var$CreateForm;
    const $92ca13d1242468b8$var$WrapperDiv = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_35md1bgi _z6i1glyw",
                __cmplp.className
            ])
        });
    });
    const $92ca13d1242468b8$var$RelativeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm",
                __cmplp.className
            ])
        });
    });
    const $92ca13d1242468b8$var$MiniIssueTypeStatusWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1q9y _jw0lu2gc",
                __cmplp.className
            ])
        });
    });
    const $92ca13d1242468b8$var$RequiredMessage = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isMini: isMini, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1n3s",
                __cmplp.isMini ? "_11c8qk37" : "_11c81oud",
                __cmplp.className
            ])
        });
    });
    const $92ca13d1242468b8$var$FlexWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $92ca13d1242468b8$var$smartFieldMessageWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginBottom: 'space.300'
    });
});
parcelRegister("2P6J2", function(module, exports) {
    $parcel$export(module.exports, "PlatformClassificationTagAri", ()=>$20e58fb74fb2b59e$export$1810bec01081467);
    var $eGyuJ;
    var $9KGzW;
    var $1C2Ux;
    var $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^$"),
        resourceOwner: (0, (0, parcelRequire("eGyuJ")).PlatformClassificationTagAriResourceOwner),
        resourceType: (0, (0, parcelRequire("eGyuJ")).PlatformClassificationTagAriResourceType),
        resourceIdSlug: "{tagId}",
        resourceIdSegmentFormats: {
            tagId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
        }
    };
    var $20e58fb74fb2b59e$export$1810bec01081467 = class _PlatformClassificationTagAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._tagId = opts.resourceIdSegmentValues.tagId;
        }
        get tagId() {
            return this._tagId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.qualifier,
                platformQualifier: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.platformQualifier,
                cloudId: void 0,
                resourceOwner: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.resourceOwner,
                resourceType: $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts.resourceType,
                resourceId: `${opts.tagId}`,
                resourceIdSegmentValues: {
                    tagId: opts.tagId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts);
            return new _PlatformClassificationTagAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $20e58fb74fb2b59e$var$platformClassificationTagAriStaticOpts);
            return new _PlatformClassificationTagAri(opts);
        }
        getVariables() {
            return {
                tagId: this.tagId
            };
        }
    };
});
parcelRegister("eGyuJ", function(module, exports) {
    $parcel$export(module.exports, "PlatformClassificationTagAriResourceOwner", ()=>$ab0fbee1183049a6$export$ee6dbd2071d3ea9f);
    $parcel$export(module.exports, "PlatformClassificationTagAriResourceType", ()=>$ab0fbee1183049a6$export$8a038be1370dff6c);
    var $ab0fbee1183049a6$export$ee6dbd2071d3ea9f = "platform", $ab0fbee1183049a6$export$8a038be1370dff6c = "classification-tag";
});
parcelRegister("dMnMc", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$fe24052863a91d57$export$557c2f222778cea6);
    $parcel$export(module.exports, "default", ()=>$fe24052863a91d57$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    var $95bh0;
    var $556I0;
    var $5PyNy;
    var $79s9E;
    const $fe24052863a91d57$var$projectScopeDataMap = {
        routes: [
            /[&?]projectKey=(\w+)/i,
            /\/projects\/(\w+)/i,
            /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
            /\/plugins\/servlet\/project-config\/(\w+)/i,
            /\/servicedesk\/admin\/(\w+)/i,
            /\/browse\/(\w+)\/?(\?.*)?$/i
        ],
        meta: [
            'ghx-project-key',
            'projectKey',
            'ajs-project-key'
        ]
    };
    const $fe24052863a91d57$var$getProjectId = (url)=>{
        const projectIdRoutes = [
            /[&?]selectedProjectId=(\w+)/i,
            /[&?]pid=(\w+)/i,
            /[&?]projectId=(\w+)/i,
            /[&?]project\.id=(\w+)/i
        ];
        return projectIdRoutes.reduce((foundId, route)=>{
            if (foundId) return foundId;
            const match = url.match(route);
            if (match != null) {
                const [, projectId] = match;
                if (projectId) return projectId;
            }
            return null;
        }, null);
    };
    const $fe24052863a91d57$var$getProjectKey = (url, getMeta)=>{
        let projectKey = null;
        $fe24052863a91d57$var$projectScopeDataMap.meta.forEach((tagName)=>{
            const value = getMeta(tagName);
            if (value && projectKey == null) projectKey = value;
        });
        $fe24052863a91d57$var$projectScopeDataMap.routes.forEach((route)=>{
            const match = url.match(route);
            if (match != null && projectKey == null) [, projectKey] = match;
        });
        return projectKey || undefined;
    };
    const $fe24052863a91d57$export$557c2f222778cea6 = (url)=>{
        try {
            const parsed = (0, ($parcel$interopDefault($aZsz6)))(url, true);
            let boardId = parsed.query ? parsed.query.rapidView : null;
            if (boardId == null) {
                const match = url.match(/\/boards\/(\d+)/i);
                boardId = match ? match[1] : null;
            }
            return boardId;
        } catch (err) {
            return null;
        }
    };
    const $fe24052863a91d57$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, (0, parcelRequire("556I0")).default).some((regex)=>regex.test(url)) || (0, (0, parcelRequire("5PyNy")).default).some((regex)=>regex.test(url));
    const $fe24052863a91d57$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
        const isProject = ()=>{
            const routes = [
                /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
                /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
                /\/secure\/ReleaseNote.jspa.+projectId/i,
                /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
            ];
            return $fe24052863a91d57$var$isProjectSettingsConnectRoute({
                getMeta: getMeta,
                url: url
            }) || routes.some((regex)=>regex.test(url));
        };
        return projectKey || projectId && isProject();
    };
    const $fe24052863a91d57$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, (0, parcelRequire("79s9E")).default).some((route)=>url.match(route)) || $fe24052863a91d57$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        });
    const $fe24052863a91d57$var$getProjectPageType = (getMeta, url)=>{
        if ($fe24052863a91d57$var$isProjectSettingsPage({
            getMeta: getMeta,
            url: url
        })) return 'settings';
        const decorator = getMeta('decorator');
        const isSettings = getMeta('is-settings-page') === 'true';
        return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
    };
    var $fe24052863a91d57$export$2e2bcd8739ae039 = (url, getMeta)=>{
        const extractedData = {};
        const boardId = $fe24052863a91d57$export$557c2f222778cea6(url);
        if (boardId) extractedData.boardId = boardId;
        const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fe24052863a91d57$var$getProjectKey(url, getMeta);
        if (projectKey) extractedData.projectKey = projectKey;
        const projectId = $fe24052863a91d57$var$getProjectId(url);
        if (projectId) extractedData.projectId = projectId;
        const isProject = $fe24052863a91d57$var$isProjectPage({
            getMeta: getMeta,
            projectId: projectId,
            projectKey: projectKey,
            url: url
        });
        extractedData.pageType = isProject ? $fe24052863a91d57$var$getProjectPageType(getMeta, url) : undefined;
        const identifier = (0, (0, parcelRequire("95bh0")).getScopeIdentifier)({
            boardId: boardId,
            projectKey: projectKey,
            projectId: isProject ? projectId : null
        });
        return {
            ...extractedData,
            ...identifier
        };
    };
});
parcelRegister("556I0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2aff61bbf8b5a2cf$export$2e2bcd8739ae039);
    var $2aff61bbf8b5a2cf$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
    ];
});
parcelRegister("5PyNy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d489e15712c5e17$export$2e2bcd8739ae039);
    var $5d489e15712c5e17$export$2e2bcd8739ae039 = [
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
        /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
    ];
});
parcelRegister("79s9E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$efe7a2022eaf0f59$export$2e2bcd8739ae039);
    var $5PyNy;
    const $efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes = [
        /\/plugins\/servlet\/project-config/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
        /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
        /\/plugins\/servlet\/project-config\/.+\/fields/i,
        /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
        /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
        /\/plugins\/servlet\/project-config\/.+\/notifications/i,
        /\/plugins\/servlet\/project-config\/.+\/permissions/i,
        /\/plugins\/servlet\/project-config\/.+\/screens/i,
        /\/plugins\/servlet\/project-config\/.+\/workflows/i,
        /\/project\/DeleteProject!default\.jspa/i,
        /\/secure\/project\/EditProject!default\.jspa/i,
        /\/secure\/AddCollector/i,
        /\/secure\/InsertCollectorHelp/i,
        /\/ViewCollector!default\.jspa\?projectKey=/i,
        /\/ViewCollectors!default\.jspa\?projectKey=/i,
        /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
        /\/InstallHipChat\.jspa\?projectKey=/i,
        /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
        /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
    ];
    var $efe7a2022eaf0f59$export$2e2bcd8739ae039 = [
        ...$efe7a2022eaf0f59$var$commonClassicProjectSettingsRoutes,
        /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
        ...(0, (0, parcelRequire("5PyNy")).default),
        /\/servicedesk\/admin\/(\w+)/i,
        /\/projects\/\w+\/settings(\/\w+)*/i
    ];
});
parcelRegister("1F7mG", function(module, exports) {
    $parcel$export(module.exports, "useHasFinishedLoading", ()=>$c232e44d35217df2$export$282f17c8d715e155);
    $parcel$export(module.exports, "useUiModificationsEnabledStatus", ()=>$c232e44d35217df2$export$408eb757ebd7e139);
    var $3sQ5x;
    var $laCJ2;
    const $c232e44d35217df2$export$282f17c8d715e155 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("laCJ2")).store), {
        selector: (state)=>state.hasFinishedLoading
    });
    const $c232e44d35217df2$export$10b49abde6eddf71 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("laCJ2")).store), {
        selector: (state)=>state.shouldUiModificationsLoad
    });
    const $c232e44d35217df2$export$408eb757ebd7e139 = (hasForgeFinishedLoading)=>{
        const shouldUiModificationsLoad = $c232e44d35217df2$export$10b49abde6eddf71();
        const hasFinishedLoading = $c232e44d35217df2$export$282f17c8d715e155();
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const uimIsEnabled = hasForgeFinishedLoading && shouldUiModificationsLoad === 'yes' && hasFinishedLoading && adjustmentsAreEnabled;
        const uimIsDisabled = hasForgeFinishedLoading && (shouldUiModificationsLoad === 'no' || hasFinishedLoading && !adjustmentsAreEnabled);
        if (uimIsEnabled) return 'enabled';
        if (uimIsDisabled) return 'disabled';
        return 'unknown';
    };
});
parcelRegister("kxNzI", function(module, exports) {
    $parcel$export(module.exports, "LinkedAlertsField", ()=>$dcd299a9344f27f3$export$9fb52de2628d6fe0);
    var $5uXOq = parcelRequire("5uXOq");
    var $eoC0M;
    var $heNNl;
    var $bGEod;
    var $7C5S0;
    var $lfTZh;
    var $8bgG7;
    const $dcd299a9344f27f3$export$9fb52de2628d6fe0 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue.fields.linked-alerts",
            packageName: "AsyncLinkedAlertsField"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eoC0M")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            "data-testid": "issue-field-linked-alerts.field-container",
            width: "100%"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "linked-alerts-field",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGEod")).FieldLoader), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8bgG7")).AsyncLinkedAlertsField), props)))));
});
parcelRegister("eoC0M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7feb9746acf3ea52$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $2VYEV;
    var $2tKfK;
    var $hEySk;
    const $7feb9746acf3ea52$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
        const flagApi = (0, (0, parcelRequire("2tKfK")).default)();
        const intl = (0, (0, parcelRequire("koVbs")).default)();
        const defaultCatch = (0, (0, parcelRequire("2VYEV")).useDefaultCatch)();
        if (scope) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEySk")).ResponderNamesContainer), {
            flagApi: flagApi,
            intlApi: intl,
            scope: scope,
            defaultCatch: defaultCatch,
            displayName: "ResponderNamesWrapper"
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEySk")).ResponderNamesContainer), {
            flagApi: flagApi,
            intlApi: intl,
            isGlobal: isGlobal,
            defaultCatch: defaultCatch,
            displayName: "ResponderNamesWrapper"
        }, children);
    };
    var $7feb9746acf3ea52$export$2e2bcd8739ae039 = $7feb9746acf3ea52$var$ResponderNamesWrapper;
});
parcelRegister("2VYEV", function(module, exports) {
    $parcel$export(module.exports, "useDefaultCatch", ()=>$06138e726543d489$export$3ab31fcc1d7c2589);
    var $5uXOq = parcelRequire("5uXOq");
    var $kmpOn;
    var $8tpNZ;
    var $aI12f;
    var $cQDa6;
    function $06138e726543d489$export$3ab31fcc1d7c2589() {
        const reportError = (0, (0, parcelRequire("cQDa6")).useReportError)();
        const [error, setError] = (0, $5uXOq.useState)();
        if (error) throw error;
        return (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault((0, parcelRequire("kmpOn")))))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
                if (!(0, (0, parcelRequire("aI12f")).isNetworkError)(error)) return setError(new (0, (0, parcelRequire("8tpNZ")).EocError)(id, error));
                if (customReporter !== null) {
                    const reporter = customReporter ?? reportError;
                    reporter(id, error, attributes);
                }
                try {
                    return httpErrorHandler?.(error);
                } catch (handlerError) {
                    if (!(0, (0, parcelRequire("aI12f")).isNetworkError)(handlerError)) setError(new (0, (0, parcelRequire("8tpNZ")).EocError)(id, handlerError));
                    throw handlerError;
                }
            }), [
            reportError
        ]);
    }
});
parcelRegister("kmpOn", function(module, exports) {
    var $6CA7f;
    var $g7JQw;
    var $ed29e25cf476d3b2$var$curry = (0, parcelRequire("6CA7f"))(function curry(fn) {
        return (0, parcelRequire("g7JQw"))(fn.length, fn);
    });
    module.exports = $ed29e25cf476d3b2$var$curry;
});
parcelRegister("6CA7f", function(module, exports) {
    var $dtL0L;
    function $4d224e922cc0a345$var$_curry1(fn) {
        return function f1(a) {
            if (arguments.length === 0 || (0, parcelRequire("dtL0L"))(a)) return f1;
            else return fn.apply(this, arguments);
        };
    }
    module.exports = $4d224e922cc0a345$var$_curry1;
});
parcelRegister("dtL0L", function(module, exports) {
    function $9d027343e6afec73$var$_isPlaceholder(a) {
        return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }
    module.exports = $9d027343e6afec73$var$_isPlaceholder;
});
parcelRegister("g7JQw", function(module, exports) {
    var $dxgtl;
    var $6CA7f;
    var $18myW;
    var $90GZI;
    var $bbd0dce5f5e12876$var$curryN = (0, parcelRequire("18myW"))(function curryN(length, fn) {
        if (length === 1) return (0, parcelRequire("6CA7f"))(fn);
        return (0, parcelRequire("dxgtl"))(length, (0, parcelRequire("90GZI"))(length, [], fn));
    });
    module.exports = $bbd0dce5f5e12876$var$curryN;
});
parcelRegister("dxgtl", function(module, exports) {
    function $9dab227b64b88e13$var$_arity(n, fn) {
        switch(n){
            case 0:
                return function() {
                    return fn.apply(this, arguments);
                };
            case 1:
                return function(a0) {
                    return fn.apply(this, arguments);
                };
            case 2:
                return function(a0, a1) {
                    return fn.apply(this, arguments);
                };
            case 3:
                return function(a0, a1, a2) {
                    return fn.apply(this, arguments);
                };
            case 4:
                return function(a0, a1, a2, a3) {
                    return fn.apply(this, arguments);
                };
            case 5:
                return function(a0, a1, a2, a3, a4) {
                    return fn.apply(this, arguments);
                };
            case 6:
                return function(a0, a1, a2, a3, a4, a5) {
                    return fn.apply(this, arguments);
                };
            case 7:
                return function(a0, a1, a2, a3, a4, a5, a6) {
                    return fn.apply(this, arguments);
                };
            case 8:
                return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                    return fn.apply(this, arguments);
                };
            case 9:
                return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                    return fn.apply(this, arguments);
                };
            case 10:
                return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                    return fn.apply(this, arguments);
                };
            default:
                throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
        }
    }
    module.exports = $9dab227b64b88e13$var$_arity;
});
parcelRegister("18myW", function(module, exports) {
    var $6CA7f;
    var $dtL0L;
    function $0d380a4094fa43af$var$_curry2(fn) {
        return function f2(a, b) {
            switch(arguments.length){
                case 0:
                    return f2;
                case 1:
                    return (0, parcelRequire("dtL0L"))(a) ? f2 : (0, parcelRequire("6CA7f"))(function(_b) {
                        return fn(a, _b);
                    });
                default:
                    return (0, parcelRequire("dtL0L"))(a) && (0, parcelRequire("dtL0L"))(b) ? f2 : (0, parcelRequire("dtL0L"))(a) ? (0, parcelRequire("6CA7f"))(function(_a) {
                        return fn(_a, b);
                    }) : (0, parcelRequire("dtL0L"))(b) ? (0, parcelRequire("6CA7f"))(function(_b) {
                        return fn(a, _b);
                    }) : fn(a, b);
            }
        };
    }
    module.exports = $0d380a4094fa43af$var$_curry2;
});
parcelRegister("90GZI", function(module, exports) {
    var $dxgtl;
    var $dtL0L;
    function $01b160e2e45af68a$var$_curryN(length, received, fn) {
        return function() {
            var combined = [];
            var argsIdx = 0;
            var left = length;
            var combinedIdx = 0;
            while(combinedIdx < received.length || argsIdx < arguments.length){
                var result;
                if (combinedIdx < received.length && (!(0, parcelRequire("dtL0L"))(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
                else {
                    result = arguments[argsIdx];
                    argsIdx += 1;
                }
                combined[combinedIdx] = result;
                if (!(0, parcelRequire("dtL0L"))(result)) left -= 1;
                combinedIdx += 1;
            }
            return left <= 0 ? fn.apply(this, combined) : (0, parcelRequire("dxgtl"))(left, $01b160e2e45af68a$var$_curryN(length, combined, fn));
        };
    }
    module.exports = $01b160e2e45af68a$var$_curryN;
});
parcelRegister("8tpNZ", function(module, exports) {
    $parcel$export(module.exports, "EocError", ()=>$d534eb2e187b068b$export$e76fc0e0bc06f4df);
    function $d534eb2e187b068b$var$hasMessage(cause) {
        return typeof cause === 'object' && cause !== null && 'message' in cause;
    }
    class $d534eb2e187b068b$export$e76fc0e0bc06f4df extends Error {
        constructor(id, cause){
            super(`[${id}] ${$d534eb2e187b068b$var$hasMessage(cause) ? cause.message : cause}`), this.id = id, this.cause = cause;
            this.name = 'EocError';
        }
    }
});
parcelRegister("cQDa6", function(module, exports) {
    $parcel$export(module.exports, "useReportError", ()=>$c58a665a3c6a26b3$export$5a5695b638d078e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $aI12f;
    var $74BDp;
    function $c58a665a3c6a26b3$export$cad78388f408899e(error) {
        if (!(0, (0, parcelRequire("aI12f")).isNetworkError)(error)) return true;
        return !(0, (0, parcelRequire("aI12f")).isHTTPError)(error);
    }
    const $c58a665a3c6a26b3$export$5a5695b638d078e7 = ()=>{
        const { reporterAction: reporterAction } = (0, (0, parcelRequire("74BDp")).useGlobalContextActions)();
        return (0, $5uXOq.useMemo)(()=>(id, error, attributes)=>{
                if (!$c58a665a3c6a26b3$export$cad78388f408899e(error)) return;
                reporterAction({
                    id: id,
                    error: error,
                    attributes: attributes
                });
            }, [
            reporterAction
        ]);
    };
});
parcelRegister("74BDp", function(module, exports) {
    $parcel$export(module.exports, "GlobalContextContainer", ()=>$aca7a4d9aea0d818$export$8a0b5f75aa4dc446);
    $parcel$export(module.exports, "useExternalFlagService", ()=>$aca7a4d9aea0d818$export$6b9ad8a324c94098);
    $parcel$export(module.exports, "useSendMessage", ()=>$aca7a4d9aea0d818$export$fe8707b58c509543);
    $parcel$export(module.exports, "useGlobalContextActions", ()=>$aca7a4d9aea0d818$export$8a9eff51cb8da29e);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $51nlc;
    var $bMb9B;
    const $aca7a4d9aea0d818$export$390f32400eaf98c9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'global-context',
        initialState: {
            reporter: undefined
        },
        actions: (0, parcelRequire("bMb9B"))
    });
    const $aca7a4d9aea0d818$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages, config: config })=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($aca7a4d9aea0d818$var$OriginalGlobalContextContainer, {
            config: config,
            reporter: reporter,
            isGlobal: true,
            flagService: flagService
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            locale: locale,
            messages: messages && messages[locale]
        }, children));
    };
    const $aca7a4d9aea0d818$var$OriginalGlobalContextContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
        onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService, config: config })=>{
                !getState().flagService && setState({
                    flagService: flagService
                });
                if (config?.context) setState({
                    config: {
                        ...getState().config,
                        context: config.context
                    }
                });
                if (config?.messageHandler) setState({
                    config: {
                        ...getState().config,
                        messageHandler: config.messageHandler
                    }
                });
            },
        onUpdate: ()=>async ({ getState: getState, setState: setState }, { config: config })=>{
                if (config?.context) setState({
                    config: {
                        ...getState().config,
                        context: config.context
                    }
                });
                if (config?.messageHandler) setState({
                    config: {
                        ...getState().config,
                        messageHandler: config.messageHandler
                    }
                });
            }
    });
    const $aca7a4d9aea0d818$export$2041a7a7b51b1fce = (0, (0, parcelRequire("51nlc")).createSubscriber)($aca7a4d9aea0d818$export$390f32400eaf98c9);
    const $aca7a4d9aea0d818$export$6b9ad8a324c94098 = (0, (0, parcelRequire("3sQ5x")).createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
        selector: (state)=>state.flagService
    });
    const $aca7a4d9aea0d818$export$fe8707b58c509543 = (handlerClass)=>{
        const [{ handler: handler, context: context }] = $aca7a4d9aea0d818$var$useSendMessageInternal(handlerClass);
        return (params)=>{
            return handler(params, context);
        };
    };
    const $aca7a4d9aea0d818$var$useSendMessageInternal = (0, (0, parcelRequire("3sQ5x")).createHook)($aca7a4d9aea0d818$export$390f32400eaf98c9, {
        selector: (state, arg)=>{
            if (state.config && state.config.messageHandler && state.config.messageHandler instanceof arg) return {
                handler: state.config.messageHandler.handler.bind(state.config.messageHandler),
                context: state.config.context
            };
            throw new Error(`The messageHandler provided from nearest GlobalContextContainer doesn't implement the one from the inner tree. Please make sure you have a compatible GlobalContextContainer`);
        }
    });
    const $aca7a4d9aea0d818$export$8a9eff51cb8da29e = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($aca7a4d9aea0d818$export$390f32400eaf98c9);
});
parcelRegister("bMb9B", function(module, exports) {
    $parcel$export(module.exports, "reporterAction", ()=>$3a0e18e647f4c498$export$f3910000817a36c2);
    $parcel$export(module.exports, "getHorizontalNav", ()=>$3a0e18e647f4c498$export$7c79a3553de2e8e7);
    const $3a0e18e647f4c498$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
            if (reporter) {
                reporter({
                    id: id,
                    error: error,
                    attributes: attributes
                });
                return;
            }
        };
    const $3a0e18e647f4c498$export$7c79a3553de2e8e7 = ()=>({}, { config: config })=>{
            return config?.isNewNavigation || false;
        };
});
parcelRegister("2tKfK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c357df09fe3f96fe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $fWXJB;
    var $epfFv;
    var $bKCvK;
    var $hmVmJ;
    var $dH6Pi;
    var $74BDp;
    const $c357df09fe3f96fe$var$useFlags = ()=>{
        const [flagService] = (0, (0, parcelRequire("74BDp")).useExternalFlagService)();
        const serviceRef = (0, $5uXOq.useRef)(flagService);
        (0, (0, parcelRequire("hmVmJ")).assert)(!serviceRef.current || !!flagService, new (0, (0, parcelRequire("dH6Pi")).AssertionError)('GlobalContext', 'flagService was destroyed.'));
        return serviceRef.current !== undefined ? {
            showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
                const Component = ({ id: id, onDismissed: onDismissed })=>{
                    if (isAutoDismiss) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fWXJB")).default), {
                        ...props,
                        id: id,
                        onDismissed: (id, e)=>{
                            onDismissed(id.toString());
                            props.onDismissed?.(id, e);
                        }
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("epfFv")).default), {
                        ...props,
                        id: id,
                        onDismissed: (id, e)=>{
                            onDismissed(id.toString());
                            props.onDismissed?.(id, e);
                        }
                    });
                };
                const id = (0, $7Jxgt.v4)();
                Component.id = id;
                serviceRef.current.showFlag(Component);
                return ()=>{
                    serviceRef.current.dismissFlag({
                        id: id,
                        command: 'DISMISS'
                    });
                };
            }
        } : (0, (0, parcelRequire("bKCvK")).useFlags)();
    };
    var $c357df09fe3f96fe$export$2e2bcd8739ae039 = $c357df09fe3f96fe$var$useFlags;
});
parcelRegister("hmVmJ", function(module, exports) {
    $parcel$export(module.exports, "assert", ()=>$e903ea4af1073086$export$a7a9523472993e97);
    var $dH6Pi;
    const $e903ea4af1073086$export$a7a9523472993e97 = function(condition, err) {
        if (!condition) throw err;
    };
});
parcelRegister("dH6Pi", function(module, exports) {
    $parcel$export(module.exports, "AssertionError", ()=>$51d685c1b4e62326$export$7750cdfb4db2c3d);
    class $51d685c1b4e62326$export$7750cdfb4db2c3d extends Error {
        constructor(id, message){
            super(`[${id}] ${message}`), this.id = id;
        }
    }
});
parcelRegister("hEySk", function(module, exports) {
    $parcel$export(module.exports, "ResponderNamesContainer", ()=>$6d57183bc999b4da$export$ae46960d51ae2b7);
    $parcel$export(module.exports, "useResponderNamesStore", ()=>$6d57183bc999b4da$export$d2c212d52c0e4d25);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $eIMZo;
    var $jF6Os;
    const $6d57183bc999b4da$export$cd391a137954b857 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, (0, parcelRequire("jF6Os")).initialState),
        actions: (0, parcelRequire("eIMZo")).actions,
        name: 'ResponderNamesStore'
    });
    const $6d57183bc999b4da$export$ae46960d51ae2b7 = (0, (0, parcelRequire("gg7kZ")).createContainer)($6d57183bc999b4da$export$cd391a137954b857);
    const $6d57183bc999b4da$export$d2c212d52c0e4d25 = (0, (0, parcelRequire("3sQ5x")).createHook)($6d57183bc999b4da$export$cd391a137954b857);
});
parcelRegister("eIMZo", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$00dbd40d3cd5db38$export$e324594224ef24da);
    var $hmVmJ;
    var $dH6Pi;
    var $8eCQi;
    var $c3dSt;
    var $6DiJG;
    var $c8qzg;
    const $00dbd40d3cd5db38$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
            const { responders: responders } = getState();
            if (!Object.keys(missingResponders).length) return Promise.resolve();
            const errorItems = (0, (0, parcelRequire("c3dSt")).mapErrorForResponder)(missingResponders);
            setState({
                responders: {
                    ...responders,
                    ...missingResponders
                }
            });
            return (0, (0, parcelRequire("6DiJG")).getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                    id: id,
                    type: type
                }))).then((response)=>{
                const responseMap = response.values.map((r)=>({
                        isError: false,
                        isLoading: false,
                        acknowledged: true,
                        ...r
                    })).reduce((acc, r)=>{
                    acc[r.id] = r;
                    return acc;
                }, {});
                const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                    const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                    if (itemByEmail) {
                        acc[key] = {
                            ...errorItems[key],
                            ...itemByEmail
                        };
                        return acc;
                    }
                    const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                    if (itemByAtlassianIdentifier) {
                        acc[key] = {
                            ...errorItems[key],
                            ...itemByAtlassianIdentifier
                        };
                        return acc;
                    }
                    acc[key] = {
                        ...errorItems[key],
                        ...responseMap[key]
                    };
                    return acc;
                }, {});
                setState({
                    responders: {
                        ...getState().responders,
                        ...responderItemMap
                    }
                });
            }).catch(defaultCatch({
                id: 'fetchResponders',
                httpErrorHandler: ()=>{
                    const dismiss = flagApi.showFlag({
                        ...(0, (0, parcelRequire("8eCQi")).errorToastProps)(),
                        title: intlApi.formatMessage((0, (0, parcelRequire("c8qzg")).messages).fetchError),
                        isAutoDismiss: true,
                        actions: [
                            {
                                content: intlApi.formatMessage((0, (0, parcelRequire("c8qzg")).messages).retry),
                                onClick: ()=>{
                                    dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
                                    dismiss();
                                }
                            }
                        ]
                    });
                    const responders = Object.assign({}, getState().responders, errorItems);
                    setState({
                        responders: responders
                    });
                }
            }));
        };
    const $00dbd40d3cd5db38$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
            (0, (0, parcelRequire("hmVmJ")).assert)(displayName === 'ResponderNamesWrapper', new (0, (0, parcelRequire("dH6Pi")).AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
            const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
            if (!missingResponders.length) return;
            const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
                acc[r.id] = {
                    id: r.id,
                    type: r.type,
                    acknowledged: false,
                    isError: false,
                    isLoading: true
                };
                return acc;
            }, {});
            const existingResponders = getState().responders;
            const allResponderIds = [
                ...Object.keys(existingResponders),
                ...Object.keys(requestedRespondersMap)
            ];
            const allResponders = allResponderIds.reduce((acc, key)=>{
                acc[key] = {
                    ...requestedRespondersMap[key],
                    ...existingResponders[key]
                };
                return acc;
            }, {});
            setState({
                responders: allResponders
            });
            const timeoutState = getState().timeout;
            if (timeoutState !== undefined) clearTimeout(timeoutState);
            const timeout = setTimeout(()=>{
                const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, (0, parcelRequire("c3dSt")).isNotLoaded)(value)).map(([key, value])=>[
                        key,
                        {
                            ...value,
                            acknowledged: true
                        }
                    ]));
                if (Object.keys(missingResponders).length) dispatch($00dbd40d3cd5db38$var$fetchResponders(missingResponders));
            }, 10);
            setState({
                timeout: timeout
            });
        };
    const $00dbd40d3cd5db38$export$e324594224ef24da = {
        fetchResponders: $00dbd40d3cd5db38$var$fetchResponders,
        batchResponders: $00dbd40d3cd5db38$var$batchResponders
    };
});
parcelRegister("8eCQi", function(module, exports) {
    $parcel$export(module.exports, "errorToastProps", ()=>$06a51a880a3faae2$export$c37f1e5051cd0bbc);
    $parcel$export(module.exports, "warningToastProps", ()=>$06a51a880a3faae2$export$fe81a150e4e6ac02);
    $parcel$export(module.exports, "infoToastProps", ()=>$06a51a880a3faae2$export$e70d6574d157a39b);
    $parcel$export(module.exports, "successToastProps", ()=>$06a51a880a3faae2$export$b56198a940066d8f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8RXs9;
    var $dD7Zc;
    var $1jWct;
    var $c2i4s;
    var $bU3PY;
    var $2bUsm;
    const $06a51a880a3faae2$var$ErrorWithIntl = (0, (0, parcelRequire("8RXs9")).default)(({ intl: intl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dD7Zc"))))), {
            color: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`,
            LEGACY_size: "medium",
            label: intl.formatMessage((0, (0, parcelRequire("2bUsm")).default).error)
        }));
    const $06a51a880a3faae2$var$WarningWithIntl = (0, (0, parcelRequire("8RXs9")).default)(({ intl: intl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bU3PY"))))), {
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$c6930421db9fa514)})`,
            LEGACY_size: "medium",
            label: intl.formatMessage((0, (0, parcelRequire("2bUsm")).default).warning)
        }));
    const $06a51a880a3faae2$var$InfoWithIntl = (0, (0, parcelRequire("8RXs9")).default)(({ intl: intl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1jWct"))))), {
            color: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
            LEGACY_size: "medium",
            label: intl.formatMessage((0, (0, parcelRequire("2bUsm")).default).info)
        }));
    const $06a51a880a3faae2$var$SuccessWithIntl = (0, (0, parcelRequire("8RXs9")).default)(({ intl: intl })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c2i4s"))))), {
            color: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
            LEGACY_size: "medium",
            label: intl.formatMessage((0, (0, parcelRequire("2bUsm")).default).success)
        }));
    const $06a51a880a3faae2$export$c37f1e5051cd0bbc = ()=>({
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$ErrorWithIntl, null),
            appearance: 'normal'
        });
    const $06a51a880a3faae2$export$fe81a150e4e6ac02 = ()=>({
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$WarningWithIntl, null),
            appearance: 'normal'
        });
    const $06a51a880a3faae2$export$e70d6574d157a39b = ()=>({
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$InfoWithIntl, null),
            appearance: 'normal'
        });
    const $06a51a880a3faae2$export$b56198a940066d8f = ()=>({
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement($06a51a880a3faae2$var$SuccessWithIntl, null),
            appearance: 'normal',
            isAutoDismiss: true
        });
});
parcelRegister("1jWct", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));
    var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
    function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $0f64b62884a9bedb$var$InformationIcon = (props)=>$0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
            LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
        }, props));
    $0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
    var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;
});
parcelRegister("c2i4s", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));
    var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
    function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8c33b074f80a91d5$var$SuccessIcon = (props)=>$8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
            LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
        }, props));
    $8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
    var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;
});
parcelRegister("2bUsm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7145ce6f0cfaef60$export$2e2bcd8739ae039);
    var $7VHMR;
    const $7145ce6f0cfaef60$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        error: {
            id: 'eoc.common.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        },
        warning: {
            id: 'eoc.common.toast.warning',
            defaultMessage: 'Warning',
            description: 'The title for a warning as a single word.'
        },
        success: {
            id: 'eoc.common.toast.success',
            defaultMessage: 'Success',
            description: 'The title for success as a single word.'
        },
        info: {
            id: 'eoc.common.toast.info',
            defaultMessage: 'Information',
            description: 'The title for an information as a single word.'
        }
    });
    var $7145ce6f0cfaef60$export$2e2bcd8739ae039 = $7145ce6f0cfaef60$var$messages;
});
parcelRegister("c3dSt", function(module, exports) {
    $parcel$export(module.exports, "mapErrorForResponder", ()=>$f99f931354012934$export$245cebe8a9527ff0);
    $parcel$export(module.exports, "isNotLoaded", ()=>$f99f931354012934$export$ea78f980ad0c92fe);
    const $f99f931354012934$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
            acc[key] = {
                id: value.id,
                type: value.type,
                isError: true,
                acknowledged: true,
                isLoading: false
            };
            return acc;
        }, {});
    const $f99f931354012934$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);
});
parcelRegister("6DiJG", function(module, exports) {
    $parcel$export(module.exports, "getResponderNames", ()=>$721598a63b2bde28$export$7345ec3bad54e226);
    var $j74qU;
    const $721598a63b2bde28$export$7345ec3bad54e226 = (requestedResponders)=>{
        const responders = requestedResponders.reduce((acc, curr)=>{
            if (curr.type === 'unknown') return [
                ...acc,
                {
                    id: curr.id,
                    type: 'schedule'
                },
                {
                    id: curr.id,
                    type: 'user'
                },
                {
                    id: curr.id,
                    type: 'team'
                },
                {
                    id: curr.id,
                    type: 'escalation'
                }
            ];
            return [
                ...acc,
                curr
            ];
        }, []);
        return (0, (0, parcelRequire("j74qU")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: responders
            }
        });
    };
});
parcelRegister("c8qzg", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$43634ee9e12c5e07$export$defe85febe8b728c);
    var $7VHMR;
    const $43634ee9e12c5e07$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        fetchError: {
            id: `eoc.responder-names-fetch-error`,
            defaultMessage: "We couldn't fetch the responder names.",
            description: 'The text will be displayed when there is error'
        },
        retry: {
            id: `eoc.responder-names-retry`,
            defaultMessage: 'Retry',
            description: 'The title for retry as a single word.'
        }
    });
});
parcelRegister("jF6Os", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$f657b42bad68e54a$export$d4c72bab9d6cc13a);
    const $f657b42bad68e54a$export$d4c72bab9d6cc13a = {
        responders: {}
    };
});
parcelRegister("8bgG7", function(module, exports) {
    $parcel$export(module.exports, "AsyncLinkedAlertsField", ()=>$b77823321567a7bb$export$5dd38ea4ae79439a);
    var $kxZPA;
    const $b77823321567a7bb$export$5dd38ea4ae79439a = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("bJX2b")).then((module)=>module.LinkedAlertsField), {
        moduleId: "./src/packages/issue/fields/linked-alerts/src/ui/index.tsx"
    });
});
parcelRegister("bJX2b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jZ42S").then(()=>parcelRequire('jDraT'));
});
const $c758c3cb80bbdb5a$export$e5ea02c7e88c47a3 = 'issue-create.common.ui.footer.create-button';
const $c758c3cb80bbdb5a$export$2bb7a43aba04c7df = 'issue-create.common.ui.footer.cancel-button';
const $c758c3cb80bbdb5a$export$822eda80d997eca0 = 'issue-create.common.ui.footer.created-issue-link';
const $c758c3cb80bbdb5a$export$9184b2de35f96256 = 'issue-create.ui.modal.header.import-issues-button';
const $c758c3cb80bbdb5a$export$2d077da71c26c1c5 = 'issue-create.ui.modal.create-form';
const $c758c3cb80bbdb5a$export$108d230a18c70c1b = 'issue-create.ui.modal.create-form.section-messages.required-fields-message';
const $c758c3cb80bbdb5a$export$f0c65883f24e857a = 'issue-create.ui.modal.create-form.section-messages.query-error-message';
const $c758c3cb80bbdb5a$export$d72a09102cf8602a = 'issue-create.ui.modal.create-form.section-messages.submit-error-message';
const $c758c3cb80bbdb5a$export$8cdb63e5b4deba55 = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message';
const $c758c3cb80bbdb5a$export$59cdc95a37abd627 = 'issue-create.common.ui.incompatible-fields-actions.learn-more';
const $c758c3cb80bbdb5a$export$1ec63f57bc2aa892 = 'issue-create.ui.modal.create-form.section-messages.inline-create-errors';
const $c758c3cb80bbdb5a$export$e80c59cc84dd232e = 'issue-create.common.ui.incompatible-fields-actions.switch-old-experience';
const $c758c3cb80bbdb5a$export$565ca47ee76ce81a = 'issue-create.ui.modal.confirm-dismiss-modal.discard-issue-button';
const $c758c3cb80bbdb5a$export$832901d9b0ce6620 = 'issue-create.ui.modal.cancel-dismiss-modal.discard-issue-button';
const $c758c3cb80bbdb5a$export$43794d009bc9b43b = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message';
parcelRegister("jhPH1", function(module, exports) {
    $parcel$export(module.exports, "useInteractedFields", ()=>$d68972f47b0a2a6a$export$d5ae3b2773429294);
    var $5uXOq = parcelRequire("5uXOq");
    var $5eGnF;
    var $9svjh;
    var $45Cy1;
    const $d68972f47b0a2a6a$export$d5ae3b2773429294 = ()=>{
        const [interactedFields, { setInteractedWithField: setInteractedWithField }] = (0, (0, parcelRequire("45Cy1")).useFormContextInteractedFields)();
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, ({ fieldId: fieldId })=>{
                setInteractedWithField(fieldId);
            }), [
            setInteractedWithField,
            subscribe
        ]);
        return {
            interactedFields: interactedFields
        };
    };
});
parcelRegister("2tPtq", function(module, exports) {
    $parcel$export(module.exports, "useInvitePrompt", ()=>$886f597cf99c20e0$export$2d68d3093301b7c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kECas;
    var $1EwOz;
    var $9Bexu;
    var $jqts8;
    var $koeKL;
    var $9OXo1;
    const $886f597cf99c20e0$export$2d68d3093301b7c3 = (projectKey)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { cloudName: cloudName } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const triggerInviteExperiment = (0, (0, parcelRequire("9Bexu")).useInvitePromptExperimentV2)(projectKey);
        const { store: store } = (0, $5uXOq.useContext)((0, (0, parcelRequire("kECas")).SmartCardContext)) || {};
        return (0, $5uXOq.useCallback)(async (description)=>{
            if (description && store && projectKey) {
                const links = (0, (0, parcelRequire("jqts8")).getAllProductLinks)(description, store, cloudId, cloudName);
                for (const [link, data] of Object.entries(links)){
                    if (await triggerInviteExperiment(link, data, (0, (0, parcelRequire("1EwOz")).SOURCE).CREATE_ISSUE)) return;
                }
            }
        }, [
            cloudId,
            cloudName,
            projectKey,
            store,
            triggerInviteExperiment
        ]);
    };
});
parcelRegister("1EwOz", function(module, exports) {
    $parcel$export(module.exports, "SOURCE", ()=>$a7e3e8d343b53bb7$export$83c8d7110915321e);
    const $a7e3e8d343b53bb7$export$83c8d7110915321e = {
        ISSUE_VIEW: 'issue-view',
        CREATE_ISSUE: 'create-issue',
        CREATE_LINK: 'create-link'
    };
});
parcelRegister("9Bexu", function(module, exports) {
    $parcel$export(module.exports, "useInvitePrompt", ()=>$d9e060d187f9c4a4$export$2d68d3093301b7c3);
    $parcel$export(module.exports, "useInvitePromptExperimentV2", ()=>$d9e060d187f9c4a4$export$8551517136fa22af);
    $parcel$export(module.exports, "useInviteOnCreateLink", ()=>$d9e060d187f9c4a4$export$90eafb1d75365ab4);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $1zGR5;
    var $1EwOz;
    var $19mQY;
    var $dRLAK;
    var $mnb3H;
    var $8CNqK;
    var $jILEq;
    var $jqts8;
    var $8CLly;
    var $edMTV;
    var $jsq9P;
    var $junz0;
    var $hln6E;
    const $d9e060d187f9c4a4$export$2d68d3093301b7c3 = (createIssueProjectKey)=>{
        const canInvite = (0, (0, parcelRequire("mnb3H")).useCanInvite)();
        const getInvitees = (0, (0, parcelRequire("19mQY")).useInvitees)(createIssueProjectKey);
        const showInvitePromptFlag = (0, (0, parcelRequire("junz0")).useInvitePromptFlag)();
        const showInvitePromptFlagV5 = (0, (0, parcelRequire("jsq9P")).useInvitePromptFlagV5)();
        const showSuccessFlag = (0, (0, parcelRequire("hln6E")).useInviteSuccessFlag)();
        const showErrorFlag = (0, (0, parcelRequire("edMTV")).useInviteErrorFlag)();
        const inviteUsers = (0, (0, parcelRequire("8CNqK")).useInviteUsers)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, (0, parcelRequire("jILEq")).useOptOut)();
        return (0, $5uXOq.useCallback)(async (continueUrl, data, source = (0, (0, parcelRequire("1EwOz")).SOURCE).ISSUE_VIEW)=>{
            try {
                (0, (0, parcelRequire("8CLly")).invitePromptOnLinkInsertExperience).start();
                const { tenantId: tenantId, product: product, name: name } = data;
                const hasOptedOut = await getOptOutStatus();
                if (hasOptedOut) return;
                const canInviteToProduct = await canInvite(tenantId, product);
                if (!canInviteToProduct) return;
                const users = await getInvitees(tenantId, product, 10);
                if (users.length === 0) return;
                const targetPageLabel = name || await (0, (0, parcelRequire("dRLAK")).getPageTitle)(continueUrl);
                const isV5Eligible = (0, (0, parcelRequire("4R6GH")).fg)('groot-aioli-v5-gate') && (0, (0, parcelRequire("6s1PB")).expValEquals)('groot-aioli-v5', 'cohort', 'variation');
                const v1Scenario = product === (0, $c06e1abca7c13910$export$c811f21c9ad05dc2) && source === (0, (0, parcelRequire("1EwOz")).SOURCE).ISSUE_VIEW;
                if (!isV5Eligible && !v1Scenario) {
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'eligibility checked', {
                        flagKey: 'groot-aioli-v5',
                        flagCohort: 'not-enrolled',
                        ineligibilityReason: {
                            isV5Eligible: isV5Eligible,
                            product: product,
                            source: source
                        }
                    });
                    return;
                }
                const showFlag = isV5Eligible ? showInvitePromptFlagV5 : showInvitePromptFlag;
                const integration = isV5Eligible ? 'invitePromptOnLinkV5' : 'invitePromptOnLink';
                showFlag({
                    users: users,
                    product: product,
                    source: source,
                    targetPageLabel: targetPageLabel,
                    allowOptOut: await shouldShowOptOutOption(),
                    onSubmit: async ()=>{
                        try {
                            const response = await inviteUsers({
                                continueUrl: continueUrl,
                                users: users,
                                tenantId: tenantId,
                                product: product,
                                integration: integration
                            });
                            showSuccessFlag({
                                users: users,
                                product: product,
                                requireAdminApproval: response.accessRequested.length > 0,
                                isAIOLIV5: isV5Eligible
                            });
                        } catch  {
                            showErrorFlag();
                        }
                    },
                    onDismiss: incrementViewCount,
                    onOptOut: setOptOutStatus
                });
                (0, (0, parcelRequire("8CLly")).invitePromptOnLinkInsertExperience).success();
                return true;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useInvitePromptExperiment',
                        packageName: 'jiraInvitePromptOnLinkInsert'
                    },
                    error: error
                });
                (0, (0, parcelRequire("8CLly")).invitePromptOnLinkInsertExperience).failure();
            }
        }, [
            canInvite,
            getInvitees,
            getOptOutStatus,
            incrementViewCount,
            inviteUsers,
            setOptOutStatus,
            shouldShowOptOutOption,
            showErrorFlag,
            showInvitePromptFlag,
            showInvitePromptFlagV5,
            showSuccessFlag,
            createAnalyticsEvent
        ]);
    };
    const $d9e060d187f9c4a4$export$8551517136fa22af = (createIssueProjectKey)=>{
        return $d9e060d187f9c4a4$export$2d68d3093301b7c3(createIssueProjectKey);
    };
    const $d9e060d187f9c4a4$export$90eafb1d75365ab4 = (link)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const cloudName = (0, (0, parcelRequire("1zGR5")).useCloudName)();
        const triggerInviteExperiment = $d9e060d187f9c4a4$export$2d68d3093301b7c3();
        return (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("jqts8")).isConfluenceLink)(link, cloudName)) triggerInviteExperiment(link, {
                tenantId: cloudId,
                product: (0, $c06e1abca7c13910$export$c811f21c9ad05dc2)
            }, (0, (0, parcelRequire("1EwOz")).SOURCE).CREATE_LINK);
        }, [
            cloudId,
            cloudName,
            link,
            triggerInviteExperiment
        ]);
    };
});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';
parcelRegister("1zGR5", function(module, exports) {
    $parcel$export(module.exports, "useCloudName", ()=>$ad30617e06682b7f$export$4dd2f8d207dc8dbf);
    var $9OXo1;
    const $ad30617e06682b7f$export$4dd2f8d207dc8dbf = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.cloudName;
    };
});
parcelRegister("19mQY", function(module, exports) {
    $parcel$export(module.exports, "useInvitees", ()=>$002670f5df23816b$export$e2a3b21407d97a53);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gCtH;
    var $93Yeu;
    var $koeKL;
    var $jqts8;
    var $l3yfW;
    var $juFR2;
    const $002670f5df23816b$export$e2a3b21407d97a53 = (createIssueProjectKey)=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const currentProjectKey = (0, (0, parcelRequire("93Yeu")).useProjectKey)(issueKey);
        const projectKey = createIssueProjectKey || currentProjectKey;
        const currentProduct = (0, (0, parcelRequire("jqts8")).useCurrentProduct)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        return (0, $5uXOq.useCallback)((tenantId, destinationProduct, inviteesLimit = 10)=>$002670f5df23816b$export$31f1797930c2d46c(tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit), [
            cloudId,
            currentProduct,
            projectKey
        ]);
    };
    const $002670f5df23816b$export$31f1797930c2d46c = async (tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit = 10)=>{
        const isInvitingToCurrentProduct = tenantId === cloudId && destinationProduct === currentProduct;
        if (isInvitingToCurrentProduct) return [];
        const projectAssignees = await (0, (0, parcelRequire("l3yfW")).getProjectAssignees)(projectKey);
        if (projectAssignees.length === 0) return [];
        const accountIds = projectAssignees.map(({ id: id })=>id);
        const [usersWithoutAccessToCurrentProduct, usersWithoutAccessToDestinationProduct] = await Promise.all([
            (0, (0, parcelRequire("juFR2")).getUsersWithoutProductAccess)(cloudId, currentProduct, accountIds),
            (0, (0, parcelRequire("juFR2")).getUsersWithoutProductAccess)(tenantId, destinationProduct, accountIds)
        ]);
        const invitees = projectAssignees.filter(({ id: id })=>!usersWithoutAccessToCurrentProduct.includes(id)).filter(({ id: id })=>usersWithoutAccessToDestinationProduct.includes(id));
        return invitees.slice(0, inviteesLimit);
    };
});
parcelRegister("jqts8", function(module, exports) {
    $parcel$export(module.exports, "isConfluenceLink", ()=>$f0146e170e490984$export$313baaa1c3261c49);
    $parcel$export(module.exports, "getAllLinks", ()=>$f0146e170e490984$export$776644da31ab517e);
    $parcel$export(module.exports, "getAllProductLinks", ()=>$f0146e170e490984$export$577f918d7821fd77);
    $parcel$export(module.exports, "generateId", ()=>$f0146e170e490984$export$567fc7097e064344);
    $parcel$export(module.exports, "clampString", ()=>$f0146e170e490984$export$96ce25bdd1856c70);
    $parcel$export(module.exports, "getProductDisplayName", ()=>$f0146e170e490984$export$44fea6589b7ddc92);
    $parcel$export(module.exports, "getSiteAri", ()=>$f0146e170e490984$export$792aeacb7990bc6);
    $parcel$export(module.exports, "useCurrentProduct", ()=>$f0146e170e490984$export$495654df2a5da4a0);
    var $l1C1k;
    var $1J3t1;
    var $dXq4S;
    const $f0146e170e490984$export$69caceff42c0da80 = {
        [(0, $c06e1abca7c13910$export$c811f21c9ad05dc2)]: 'Confluence',
        [(0, $c06e1abca7c13910$export$202f50ee62667e32)]: 'Jira Product Discovery'
    };
    const $f0146e170e490984$var$getProductFromSubproduct = (subproduct)=>{
        switch(subproduct){
            case 'software':
            case 'jira_software':
                return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
            case 'servicedesk':
            case 'jira_service_management':
                return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
            case 'core':
            case 'jira_work_management':
                return 0, $c06e1abca7c13910$export$db515c8cec1e6f79;
            case 'polaris':
            case 'jira_product_discovery':
                return 0, $c06e1abca7c13910$export$202f50ee62667e32;
            default:
                return null;
        }
    };
    const $f0146e170e490984$export$313baaa1c3261c49 = (url, cloudName)=>{
        if (!url || !cloudName) return false;
        const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki`);
        return regex.test(url);
    };
    const $f0146e170e490984$export$776644da31ab517e = (doc)=>{
        const links = new Set();
        const handleLink = (link)=>{
            link && links.add(link);
        };
        const handleSmartLink = (node)=>handleLink(node.attrs?.url);
        (0, (0, parcelRequire("l1C1k")).traverse)(doc, {
            text: (node)=>{
                if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
            },
            inlineCard: handleSmartLink,
            blockCard: handleSmartLink,
            embedCard: handleSmartLink
        });
        return links;
    };
    const $f0146e170e490984$var$getSmartLinkData = (cloudId, details)=>{
        if (!details) return;
        const { name: name } = details.data;
        const { tenantId: tenantId, subproduct: subproduct } = details.meta;
        let { product: product } = details.meta;
        if (tenantId !== cloudId) return;
        product = product === 'jira' ? $f0146e170e490984$var$getProductFromSubproduct(subproduct) : product;
        if (!Object.keys($f0146e170e490984$export$69caceff42c0da80).includes(product)) return;
        return {
            name: name,
            tenantId: tenantId,
            product: product
        };
    };
    const $f0146e170e490984$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
        const links = {};
        const handleSmartLink = (node)=>{
            const { url: url } = node?.attrs;
            if (!url) return;
            const details = store.getState()[url]?.details;
            const data = $f0146e170e490984$var$getSmartLinkData(cloudId, details);
            if (data) links[url] = data;
        };
        const handleRawConfluenceLink = (url)=>{
            if ($f0146e170e490984$export$313baaa1c3261c49(url, cloudName)) links[url] = {
                tenantId: cloudId,
                product: (0, $c06e1abca7c13910$export$c811f21c9ad05dc2)
            };
        };
        (0, (0, parcelRequire("l1C1k")).traverse)(doc, {
            text: (node)=>{
                if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
            },
            inlineCard: handleSmartLink,
            blockCard: handleSmartLink,
            embedCard: handleSmartLink
        });
        return links;
    };
    let $f0146e170e490984$var$id = 0;
    const $f0146e170e490984$export$567fc7097e064344 = ()=>{
        $f0146e170e490984$var$id += 1;
        return String($f0146e170e490984$var$id);
    };
    const $f0146e170e490984$export$96ce25bdd1856c70 = (string, maxLength)=>{
        if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
        return string;
    };
    const $f0146e170e490984$export$44fea6589b7ddc92 = (product)=>$f0146e170e490984$export$69caceff42c0da80[product];
    const $f0146e170e490984$export$792aeacb7990bc6 = (tenantId, product)=>(0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: product,
            resourceType: 'site',
            resourceId: tenantId
        }).toString();
    const $f0146e170e490984$export$495654df2a5da4a0 = ()=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarNavigation)();
        return $f0146e170e490984$var$getProductFromSubproduct(data?.projectType) || (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    };
});
parcelRegister("l3yfW", function(module, exports) {
    $parcel$export(module.exports, "getProjectAssignees", ()=>$ca2b43e33d9b739b$export$b49ddf91eddfcea9);
    var $7f4tk;
    const $ca2b43e33d9b739b$var$getAssigneesUrl = (projectKey)=>`/rest/api/3/user/search/query?query=is assignee of ${projectKey}&maxResults=50`;
    const $ca2b43e33d9b739b$export$b49ddf91eddfcea9 = async (projectKey)=>{
        const users = await (0, (0, parcelRequire("7f4tk")).default)($ca2b43e33d9b739b$var$getAssigneesUrl(projectKey));
        return users.values.filter(({ active: active })=>active).map(({ accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: avatarUrls })=>({
                id: accountId,
                email: emailAddress,
                name: displayName || '',
                avatar: avatarUrls['48x48'] || avatarUrls['32x32'] || avatarUrls['24x24'] || Object.values(avatarUrls).pop() || ''
            }));
    };
});
parcelRegister("juFR2", function(module, exports) {
    $parcel$export(module.exports, "getUsersWithoutProductAccess", ()=>$d23da2540de8ce66$export$7121af075bd652a4);
    var $7f4tk;
    const $d23da2540de8ce66$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
    const $d23da2540de8ce66$export$7121af075bd652a4 = (cloudId, product, accountIds)=>(0, (0, parcelRequire("7f4tk")).default)($d23da2540de8ce66$var$getInviteesUrl, {
            method: 'POST',
            body: JSON.stringify({
                cloudId: cloudId,
                product: product,
                accountIds: accountIds
            })
        });
});
parcelRegister("dRLAK", function(module, exports) {
    $parcel$export(module.exports, "getPageTitle", ()=>$2319c2f0426c18c6$export$23286240952da4c9);
    var $7f4tk;
    const $2319c2f0426c18c6$var$resolverUrl = '/gateway/api/object-resolver/resolve';
    const $2319c2f0426c18c6$export$23286240952da4c9 = async (resourceUrl)=>{
        try {
            const response = await (0, (0, parcelRequire("7f4tk")).default)($2319c2f0426c18c6$var$resolverUrl, {
                method: 'POST',
                body: JSON.stringify({
                    resourceUrl: resourceUrl
                })
            });
            return response.data?.name;
        } catch  {
            return undefined;
        }
    };
});
parcelRegister("mnb3H", function(module, exports) {
    $parcel$export(module.exports, "useCanInvite", ()=>$82d755cbdc58f1c2$export$4fa512abf5d2ba5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7f4tk;
    var $dXq4S;
    const $82d755cbdc58f1c2$export$4fa512abf5d2ba5e = ()=>(0, $5uXOq.useCallback)((cloudId, product)=>$82d755cbdc58f1c2$export$39ebdf2aa7e6d740(cloudId, product), []);
    const $82d755cbdc58f1c2$export$8a4a12ca67f0b223 = (cloudId)=>`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`;
    const $82d755cbdc58f1c2$export$39ebdf2aa7e6d740 = async (cloudId, product)=>{
        const capabilities = await (0, (0, parcelRequire("7f4tk")).default)($82d755cbdc58f1c2$export$8a4a12ca67f0b223(cloudId));
        const capability = capabilities.find((cap)=>{
            const ari = (0, (0, parcelRequire("dXq4S")).getAriConfig)(cap.resourceARI);
            return ari.resourceOwner === product;
        });
        if (!capability) return false;
        return capability.directInvite?.mode === 'ANYONE' || capability.invitePendingApproval?.mode === 'ANYONE';
    };
});
parcelRegister("8CNqK", function(module, exports) {
    $parcel$export(module.exports, "useInviteUsers", ()=>$4c3052c658744a85$export$6162654a9c7a7b9a);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gQ83;
    var $jcw0u;
    var $8zOmE;
    var $2NMNM;
    var $jqts8;
    var $bNM9H;
    var $cs9Zr;
    const $4c3052c658744a85$var$RECAPTCHA_VALIDATION_ERROR = 'ValidationError';
    const $4c3052c658744a85$export$6162654a9c7a7b9a = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product, integration: integration })=>{
            try {
                const origin = new (0, (0, parcelRequire("2gQ83")).default)({
                    product: (0, (0, parcelRequire("cs9Zr")).getOriginProduct)(product)
                });
                const continueUrlWithOrigin = origin.addToUrl(continueUrl);
                const originAttributes = origin.toAnalyticsAttributes({
                    hasGeneratedId: true
                });
                const inviteApiResponse = await (0, (0, parcelRequire("bNM9H")).inviteWithinOrg)({
                    users: users,
                    continueUrl: continueUrlWithOrigin,
                    tenantId: tenantId,
                    product: product
                });
                const response = (0, (0, parcelRequire("cs9Zr")).handleInviteUsersSuccessResponse)(inviteApiResponse);
                [
                    ...response.invited,
                    ...response.accessRequested
                ].forEach((invited)=>{
                    const resourceAri = (0, (0, parcelRequire("jqts8")).getSiteAri)(tenantId, product);
                    const result = invited.results[resourceAri];
                    const userId = invited.id;
                    const analyticsAttributes = {
                        ...originAttributes,
                        userId: userId,
                        products: [
                            product
                        ],
                        inviteResult: [
                            {
                                resourceAri: resourceAri,
                                status: result
                            }
                        ],
                        integration: integration,
                        isInviteWithinOrg: true
                    };
                    if (result === 'INVITED') (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', userId, analyticsAttributes);
                    else if (result === 'INVITED_PENDING_APPROVAL') (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'promptOnLinkInvite succeeded', {
                    invited: response.invited.length,
                    requested: response.accessRequested.length,
                    errored: response.error.length,
                    integration: integration
                });
                return response;
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: error.statusCode === 400 && error.name === $4c3052c658744a85$var$RECAPTCHA_VALIDATION_ERROR ? 'useInviteUsers-recaptcha' : 'useInviteUsers',
                        packageName: 'jiraInvitePromptOnLinkInsert'
                    },
                    error: error
                });
                throw error;
            }
        }, [
            createAnalyticsEvent
        ]);
    };
});
parcelRegister("bNM9H", function(module, exports) {
    $parcel$export(module.exports, "inviteWithinOrg", ()=>$fa07c4267ef179ba$export$a106ce8e40b3d224);
    var $eusud;
    var $jqts8;
    const $fa07c4267ef179ba$export$da08225bbae46b1 = async ({ users: users, continueUrl: continueUrl, recaptchaToken: recaptchaToken, tenantId: tenantId, product: product })=>{
        const resources = [
            (0, (0, parcelRequire("jqts8")).getSiteAri)(tenantId, product)
        ];
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, $ab037afc3711e52a$export$ff111916f5a23b5a), {
            headers: {
                'Content-Type': 'application/json',
                ...recaptchaToken ? {
                    'G-Recaptcha-Token': recaptchaToken
                } : {}
            },
            body: JSON.stringify({
                continueUrl: continueUrl,
                resources: resources,
                users: users.map(({ email: email })=>({
                        email: email
                    }))
            })
        });
        return response;
    };
    const $fa07c4267ef179ba$export$a106ce8e40b3d224 = async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product })=>{
        const resources = [
            (0, (0, parcelRequire("jqts8")).getSiteAri)(tenantId, product)
        ];
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, $ab037afc3711e52a$export$f87741d20d2a10fb), {
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                continueUrl: continueUrl,
                resources: resources,
                userIds: users.map(({ id: id })=>id),
                cloudId: tenantId,
                experience: 'invite-on-link-insert'
            })
        });
        return response;
    };
});
const $ab037afc3711e52a$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $ab037afc3711e52a$export$f87741d20d2a10fb = '/gateway/api/growth/groot-invite-within-org/invite';
parcelRegister("cs9Zr", function(module, exports) {
    $parcel$export(module.exports, "handleInviteUsersSuccessResponse", ()=>$d19e810a3471b533$export$bf7ed6f1f1b884e);
    $parcel$export(module.exports, "getOriginProduct", ()=>$d19e810a3471b533$export$e4853a500db4c6bf);
    const $d19e810a3471b533$export$f6c02f8ff560b96f = (environment)=>{
        switch(environment){
            case 'prod':
                return 0, $f46589b0085bcc39$export$2c2f58a9d84da733;
            case 'staging':
                return 0, $f46589b0085bcc39$export$cd719d3567d9b31d;
            default:
                return 0, $f46589b0085bcc39$export$34c3413ecdf1b634;
        }
    };
    const $d19e810a3471b533$export$bf7ed6f1f1b884e = (response)=>response.reduce((accumulator, userResponse)=>{
            const user = {
                id: userResponse.id,
                email: userResponse.email
            };
            Object.keys(userResponse.results).forEach((resource)=>{
                switch(userResponse.results[resource]){
                    case 'INVITED':
                    case 'USER_EXISTS':
                        accumulator.invited.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'INVITED_PENDING_APPROVAL':
                    case 'PENDING_INVITE_EXISTS':
                        accumulator.accessRequested.push({
                            ...user,
                            results: userResponse.results
                        });
                        break;
                    case 'NOT_INVITED':
                    case 'ERROR':
                        accumulator.error.push({
                            ...user,
                            error: userResponse.errorReasons[resource]
                        });
                        break;
                    default:
                        throw new Error('Unexpected return type from invite user response');
                }
            });
            return accumulator;
        }, {
            invited: [],
            accessRequested: [],
            error: []
        });
    const $d19e810a3471b533$export$e4853a500db4c6bf = (product)=>{
        switch(product){
            case 0, $c06e1abca7c13910$export$202f50ee62667e32:
                return 'jira';
            default:
                return product;
        }
    };
});
const $f46589b0085bcc39$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $f46589b0085bcc39$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $f46589b0085bcc39$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';
parcelRegister("jILEq", function(module, exports) {
    $parcel$export(module.exports, "useOptOut", ()=>$6f9b71165d35a2e4$export$7f94797c6e99faf3);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $90yGq;
    var $3Wvty;
    const $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW = 'invite-prompt-on-link-insert-view';
    const $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT = 'invite-prompt-on-link-insert-opt-out';
    const $6f9b71165d35a2e4$var$MAX_VIEW_COUNT = 2;
    const $6f9b71165d35a2e4$var$shouldShowOptOutOption = async (accountId)=>{
        if (!accountId) return false;
        const viewCount = await $6f9b71165d35a2e4$var$getViewCount(accountId);
        return viewCount >= $6f9b71165d35a2e4$var$MAX_VIEW_COUNT;
    };
    const $6f9b71165d35a2e4$var$incrementViewCount = async (accountId)=>{
        if (!accountId) return;
        const viewCount = await $6f9b71165d35a2e4$var$getViewCount(accountId);
        if (viewCount < $6f9b71165d35a2e4$var$MAX_VIEW_COUNT) try {
            await (0, (0, parcelRequire("3Wvty")).setUserProperty)({
                accountId: accountId,
                propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
                propertyValue: viewCount + 1
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'incrementViewCount',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
        }
    };
    const $6f9b71165d35a2e4$var$getViewCount = async (accountId)=>(await (0, (0, parcelRequire("3Wvty")).getUserProperty)({
            accountId: accountId,
            propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
            defaultValue: 0
        })).value;
    const $6f9b71165d35a2e4$var$getOptOutInvitePrompt = async (accountId)=>{
        if (!accountId) return false;
        return (await (0, (0, parcelRequire("3Wvty")).getUserProperty)({
            accountId: accountId,
            propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
            defaultValue: false
        })).value;
    };
    const $6f9b71165d35a2e4$var$setOptOutInvitePrompt = async (accountId)=>{
        if (!accountId) return;
        try {
            await (0, (0, parcelRequire("3Wvty")).setUserProperty)({
                accountId: accountId,
                propertyKey: $6f9b71165d35a2e4$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
                propertyValue: true
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'setOptOutInvitePrompt',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
        }
    };
    const $6f9b71165d35a2e4$export$7f94797c6e99faf3 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        return (0, $5uXOq.useMemo)(()=>({
                shouldShowOptOutOption: ()=>$6f9b71165d35a2e4$var$shouldShowOptOutOption(accountId),
                incrementViewCount: ()=>$6f9b71165d35a2e4$var$incrementViewCount(accountId),
                getOptOutStatus: ()=>$6f9b71165d35a2e4$var$getOptOutInvitePrompt(accountId),
                setOptOutStatus: ()=>$6f9b71165d35a2e4$var$setOptOutInvitePrompt(accountId)
            }), [
            accountId
        ]);
    };
});
parcelRegister("3Wvty", function(module, exports) {
    $parcel$export(module.exports, "setUserProperty", ()=>$6f8b8e5b8e68f1c5$export$ba821ce5e177c7ef);
    $parcel$export(module.exports, "getUserProperty", ()=>$6f8b8e5b8e68f1c5$export$b3126db2ef6e34ed);
    var $eusud;
    const $6f8b8e5b8e68f1c5$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
    const $6f8b8e5b8e68f1c5$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
        const url = $6f8b8e5b8e68f1c5$var$getUserUrl(accountId, propertyKey);
        try {
            await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                body: JSON.stringify(propertyValue)
            });
        } catch (error) {
            throw new Error(`Saving ${propertyKey} user property failed. Error: ${error}`);
        }
    };
    const $6f8b8e5b8e68f1c5$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
        const url = $6f8b8e5b8e68f1c5$var$getUserUrl(accountId, propertyKey);
        try {
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            return response;
        } catch (error) {
            return {
                key: propertyKey,
                value: defaultValue
            };
        }
    };
});
parcelRegister("8CLly", function(module, exports) {
    $parcel$export(module.exports, "invitePromptOnLinkInsertExperience", ()=>$0c2a3336267cda18$export$adb25c37e478fcbe);
    var $atdLB;
    var $duUGa;
    const $0c2a3336267cda18$export$adb25c37e478fcbe = new (0, (0, parcelRequire("duUGa")).UFOExperience)('invite-prompt-on-link-insert', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).PageLoad
    });
});
parcelRegister("edMTV", function(module, exports) {
    $parcel$export(module.exports, "useInviteErrorFlag", ()=>$dd8e8c3c0cb6f6ea$export$e6d35b1c4e81af0e);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHfPB;
    var $3KRpp;
    var $pa9q9;
    var $koVbs;
    var $jqts8;
    var $dsKIR;
    const $dd8e8c3c0cb6f6ea$export$e6d35b1c4e81af0e = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, $5uXOq.useCallback)(()=>{
            const id = `error-${(0, (0, parcelRequire("jqts8")).generateId)()}`;
            const dismiss = ()=>dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
            showFlag({
                id: id,
                render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($dd8e8c3c0cb6f6ea$export$92c0939d1a977673, {
                        ...props,
                        id: id,
                        onDismiss: dismiss
                    })
            });
        }, [
            dismissFlag,
            showFlag
        ]);
    };
    const $dd8e8c3c0cb6f6ea$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
    const $dd8e8c3c0cb6f6ea$export$92c0939d1a977673 = ({ onDismiss: onDismiss, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).ErrorFlag), {
            ...props,
            onDismissed: onDismiss,
            title: formatMessage((0, (0, parcelRequire("dsKIR")).messages).title),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("dsKIR")).messages).description))),
            actions: [
                {
                    content: formatMessage((0, (0, parcelRequire("dsKIR")).messages).action),
                    href: $dd8e8c3c0cb6f6ea$var$JIRA_SUPPORT_LINK,
                    target: '_blank'
                }
            ]
        });
    };
});
parcelRegister("dsKIR", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$41b86c034044336a$export$defe85febe8b728c);
    var $7VHMR;
    const $41b86c034044336a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "invite-prompt-on-link-insert.invite-error-flag.title",
            "defaultMessage": "Something went wrong"
        },
        description: {
            "id": "invite-prompt-on-link-insert.invite-error-flag.description",
            "defaultMessage": "Try inviting your teammates again. If the problem persists, contact support."
        },
        action: {
            "id": "invite-prompt-on-link-insert.invite-error-flag.action",
            "defaultMessage": "Contact support"
        }
    });
});
parcelRegister("jsq9P", function(module, exports) {
    $parcel$export(module.exports, "useInvitePromptFlagV5", ()=>$74699cefb273b9dc$export$c5e7b28325c14e4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cgL5K;
    var $d4xRU;
    var $fHfPB;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1vvOR;
    var $jqts8;
    var $eSbDj;
    const $74699cefb273b9dc$export$c5e7b28325c14e4d = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(({ targetPageLabel: targetPageLabel, product: product, source: source, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut })=>{
            const id = `invite-v5-${(0, (0, parcelRequire("jqts8")).generateId)()}`;
            const dismissTheFlag = ()=>dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
            const attributes = {
                invitees: users.length,
                renderedPageTitle: !!targetPageLabel,
                allowOptOut: allowOptOut,
                inviteeIds: users.map((user)=>user.id),
                source: source,
                product: product
            };
            const submit = async ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsertV5', attributes);
                await onSubmit();
                dismissTheFlag();
            };
            const optOut = ()=>{
                dismissTheFlag();
                onOptOut();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsertV5', attributes);
            };
            const dismiss = ()=>{
                dismissTheFlag();
                onDismiss();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsertV5', attributes);
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsertV5', attributes);
            showFlag({
                id: id,
                isLowPriority: true,
                render: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($74699cefb273b9dc$export$5e4d45d040263819, {
                        id: id,
                        users: users,
                        onDismiss: dismiss,
                        onSubmit: submit,
                        onOptOut: allowOptOut ? optOut : undefined,
                        product: product,
                        targetPageLabel: targetPageLabel
                    })
            });
        }, [
            createAnalyticsEvent,
            dismissFlag,
            showFlag
        ]);
    };
    const $74699cefb273b9dc$export$5e4d45d040263819 = ({ id: id, onDismiss: onDismiss, onSubmit: onSubmit, onOptOut: onOptOut, users: users, product: product, targetPageLabel: targetPageLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const productDisplayName = (0, (0, parcelRequire("jqts8")).getProductDisplayName)(product);
        const maxLength = 40;
        const clampedTargetPageLabel = (0, (0, parcelRequire("jqts8")).clampString)(targetPageLabel || '', maxLength);
        const actions = (0, $5uXOq.useMemo)(()=>{
            const allActions = [
                {
                    content: formatMessage((0, (0, parcelRequire("eSbDj")).messages).addPeopleButton, {
                        inviteeCount: users.length,
                        displayName: users[0].name.split(' ')[0]
                    }),
                    onClick: onSubmit
                },
                {
                    content: formatMessage((0, (0, parcelRequire("eSbDj")).messages).dismiss, {}),
                    onClick: onOptOut
                }
            ];
            return onOptOut ? allActions : allActions.slice(0, 1);
        }, [
            users,
            onSubmit,
            onOptOut,
            formatMessage
        ]);
        const description = targetPageLabel ? formatMessage((0, (0, parcelRequire("eSbDj")).messages).descriptionWithPageTitleGeneric, {
            strong: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: users.length,
            title: clampedTargetPageLabel,
            productDisplayName: productDisplayName,
            displayName: users[0].name.split(' ')[0]
        }) : formatMessage((0, (0, parcelRequire("eSbDj")).messages).descriptionWithoutPageTitleGeneric, {
            strong: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                    as: "strong"
                }, chunks.join('')),
            inviteeCount: users.length,
            productDisplayName: productDisplayName,
            displayName: users[0].name.split(' ')[0]
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            id: id,
            onDismissed: onDismiss,
            title: formatMessage((0, (0, parcelRequire("eSbDj")).messages).titleGeneric, {
                inviteeCount: users.length,
                displayName: users[0].name
            }),
            description: description,
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1vvOR")).FlagCompatibleAvatarGroup), {
                data: users.map((user)=>({
                        name: user.name,
                        src: user.avatar
                    })),
                boundariesElement: "scrollParent",
                useSmallAvatars: true
            }),
            actions: actions
        });
    };
});
parcelRegister("d4xRU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$61381db0e069bc03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iNWLk;
    var $3KRpp;
    const $61381db0e069bc03$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNWLk")).FlagsBoundary), {
            packageName: packageName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).CommonFlag), {
            flagType: "info",
            ...props
        }));
    var $61381db0e069bc03$export$2e2bcd8739ae039 = $61381db0e069bc03$var$AkFlag;
});
parcelRegister("1vvOR", function(module, exports) {
    $parcel$export(module.exports, "FlagCompatibleAvatarGroup", ()=>$9673fbe34231f4e4$export$29beada2d5f93289);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $jnhNB;
    const $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED = 5;
    const $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED = 2;
    const $9673fbe34231f4e4$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
    const $9673fbe34231f4e4$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
    const $9673fbe34231f4e4$export$29beada2d5f93289 = ({ data: data, useSmallAvatars: useSmallAvatars, ...props })=>{
        const maxAvatarCount = useSmallAvatars ? $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED : $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED;
        const { data: customData, overrides: customOverrides } = (0, $5uXOq.useMemo)(()=>$9673fbe34231f4e4$export$bc55c1ff86d63c4d({
                data: data,
                useSmallAvatars: useSmallAvatars
            }), [
            data,
            useSmallAvatars
        ]);
        const avatarGroup = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jnhNB")).default), {
            maxCount: maxAvatarCount,
            data: customData,
            overrides: customOverrides,
            boundariesElement: "scrollParent",
            tooltipPosition: "top",
            onMoreClick: (0, ($parcel$interopDefault($8Rkzz))),
            size: useSmallAvatars ? 'small' : 'medium',
            ...props
        });
        return avatarGroup;
    };
    const $9673fbe34231f4e4$export$bc55c1ff86d63c4d = ({ data: users, useSmallAvatars: useSmallAvatars })=>{
        const maxAvatarCount = useSmallAvatars ? $9673fbe34231f4e4$var$MAX_SMALL_AVATARS_FEATURED : $9673fbe34231f4e4$var$MAX_AVATARS_FEATURED;
        const overflows = users.length > maxAvatarCount;
        const lastFeaturedUser = maxAvatarCount - 1;
        const featuredUsers = users.slice(0, lastFeaturedUser);
        const overflowUsers = users.slice(lastFeaturedUser);
        const overflowMarkerDummyUser = $9673fbe34231f4e4$export$1b8d8867a2d1ffbd(overflowUsers);
        const processedUsers = overflows ? [
            ...featuredUsers,
            overflowMarkerDummyUser
        ] : users;
        const overrides = {
            Avatar: {
                render: (AvatarComponent, avatarProps)=>{
                    if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $9673fbe34231f4e4$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length, useSmallAvatars);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement(AvatarComponent, avatarProps);
                }
            }
        };
        return {
            overrides: overrides,
            data: processedUsers
        };
    };
    const $9673fbe34231f4e4$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
            name: overflowUsers.map((u)=>u.name).join(', '),
            key: $9673fbe34231f4e4$var$OVERFLOW_USER_MARKER
        });
    const $9673fbe34231f4e4$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount, useSmallAvatars)=>{
        const Container = useSmallAvatars ? $9673fbe34231f4e4$var$SmallAvatarOverflowCountContainer : $9673fbe34231f4e4$var$AvatarOverflowCountContainer;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(AvatarComponent, {
            name: avatarProps.name,
            appearance: avatarProps.appearance,
            size: avatarProps.size,
            borderColor: avatarProps.borderColor,
            stackIndex: 0
        }, (avatarChildrenProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Container, avatarChildrenProps, `+${Math.min(overflowCount, $9673fbe34231f4e4$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`));
    };
    const $9673fbe34231f4e4$var$AvatarOverflowCountContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkj6p2 _syaz1ktl _y3gn1s23 _k48p124r",
                __cmplp.className
            ])
        });
    });
    const $9673fbe34231f4e4$var$SmallAvatarOverflowCountContainer = (0, $5uXOq.forwardRef)(({ as: C = $9673fbe34231f4e4$var$AvatarOverflowCountContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8lyfp _k48p124r",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("eSbDj", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$25f58964aaa069a8$export$defe85febe8b728c);
    var $7VHMR;
    const $25f58964aaa069a8$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addPeopleButton: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag-v5.add-people-button",
            "defaultMessage": "{inviteeCount, plural, one {Add {displayName}} other {Add # people}}"
        },
        dismiss: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag-v5.dismiss",
            "defaultMessage": "Don't show again"
        },
        titleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag-v5.title-generic",
            "defaultMessage": "{inviteeCount, plural, one {{displayName} may need access} other {Your team may need access}}"
        },
        descriptionWithoutPageTitleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag-v5.description-without-page-title-generic",
            "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to <strong>{productDisplayName}</strong>.} other {# project assignees need access to <strong>{productDisplayName}</strong>.}}"
        },
        descriptionWithPageTitleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag-v5.description-with-page-title-generic",
            "defaultMessage": "{inviteeCount, plural, one {Your project assignee <strong>{displayName}</strong> needs access to {productDisplayName} to view <strong>{title}</strong>.} other {# project assignees need access to {productDisplayName} to view <strong>{title}</strong>.}}"
        }
    });
});
parcelRegister("junz0", function(module, exports) {
    $parcel$export(module.exports, "useInvitePromptFlag", ()=>$eea5750da39a418b$export$ce7c2ea6d33a7cf4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $2rqOp;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $fHfPB;
    var $3KRpp;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $1vvOR;
    var $jqts8;
    var $dL5Pi;
    var $5UhXy;
    const $eea5750da39a418b$export$ce7c2ea6d33a7cf4 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(({ targetPageLabel: targetPageLabel, product: product, source: source, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut })=>{
            const id = `invite-${(0, (0, parcelRequire("jqts8")).generateId)()}`;
            const dismissTheFlag = ()=>dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
            const attributes = {
                invitees: users.length,
                renderedPageTitle: !!targetPageLabel,
                allowOptOut: allowOptOut,
                inviteeIds: users.map((user)=>user.id),
                source: source,
                product: product
            };
            const submit = async ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsert', attributes);
                await onSubmit();
                dismissTheFlag();
            };
            const optOut = ()=>{
                dismissTheFlag();
                onOptOut();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsert', attributes);
            };
            const dismiss = ()=>{
                dismissTheFlag();
                onDismiss();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsert', attributes);
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsert', attributes);
            showFlag({
                id: id,
                isLowPriority: true,
                render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$export$d6bef3efd7271258, {
                        ...props,
                        id: id,
                        users: users,
                        targetPageLabel: targetPageLabel,
                        onDismiss: dismiss,
                        onSubmit: submit,
                        onOptOut: allowOptOut ? optOut : undefined,
                        product: product
                    })
            });
        }, [
            createAnalyticsEvent,
            dismissFlag,
            showFlag
        ]);
    };
    const $eea5750da39a418b$export$d6bef3efd7271258 = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, targetPageLabel: targetPageLabel, product: product, ...props })=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const productDisplayName = (0, (0, parcelRequire("jqts8")).getProductDisplayName)(product);
        const handleOnSubmit = (0, $5uXOq.useCallback)(async ()=>{
            setIsLoading(true);
            await onSubmit();
        }, [
            onSubmit
        ]);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const optOutEnabled = onOptOut !== undefined;
        const customFlagFooterProps = (0, $5uXOq.useMemo)(()=>({
                actions: [
                    {
                        content: '',
                        onClick: ()=>{}
                    }
                ],
                linkComponent: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5UhXy")).RecaptchaTerms), null), (0, ($parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$var$ButtonsContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$var$ButtonItem, {
                        optOutEnabled: optOutEnabled
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
                        appearance: "primary",
                        onClick: handleOnSubmit,
                        spacing: "compact",
                        isLoading: isLoading
                    }, formatMessage((0, (0, parcelRequire("dL5Pi")).messages).addPeopleButton, {
                        inviteeCount: users.length
                    }))), optOutEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$var$ButtonItem, {
                        optOutEnabled: optOutEnabled
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                        appearance: "subtle-link",
                        onClick: onOptOut,
                        spacing: "compact",
                        isDisabled: isLoading
                    }, formatMessage((0, (0, parcelRequire("dL5Pi")).messages).dismiss, {})))))
            }), [
            onOptOut,
            optOutEnabled,
            handleOnSubmit,
            users,
            formatMessage,
            isLoading
        ]);
        const maxLength = 20;
        const clampedTargetPageLabel = (0, (0, parcelRequire("jqts8")).clampString)(targetPageLabel || '', maxLength);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).InfoFlag), {
            ...props,
            ...customFlagFooterProps,
            onDismissed: onDismiss,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $eea5750da39a418b$var$avatarsContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1vvOR")).FlagCompatibleAvatarGroup), {
                data: users.map((user)=>({
                        name: user.name,
                        src: user.avatar,
                        appearance: 'circle',
                        size: 'medium'
                    })),
                boundariesElement: "scrollParent"
            })), formatMessage((0, (0, parcelRequire("dL5Pi")).messages).titleGeneric, {
                inviteeCount: users.length,
                displayName: users[0].name,
                productDisplayName: productDisplayName
            })),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement($eea5750da39a418b$var$MainContentContainer, null, targetPageLabel ? formatMessage((0, (0, parcelRequire("dL5Pi")).messages).descriptionWithPageTitleGeneric, {
                strong: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunks.join('')),
                inviteeCount: users.length,
                title: clampedTargetPageLabel,
                productDisplayName: productDisplayName
            }) : formatMessage((0, (0, parcelRequire("dL5Pi")).messages).descriptionWithoutPageTitleGeneric, {
                inviteeCount: users.length,
                productDisplayName: productDisplayName
            }))
        });
    };
    const $eea5750da39a418b$var$avatarsContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.negative.025',
        marginTop: 'space.negative.025',
        marginBottom: 'space.050'
    });
    const $eea5750da39a418b$var$MainContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0ccj1k _1yyj11wp _sudp1e54 _1reo15vq _18m915vq _18s8ze3t",
                __cmplp.className
            ])
        });
    });
    const $eea5750da39a418b$var$ButtonsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2hwxmgjw",
                __cmplp.className
            ])
        });
    });
    const $eea5750da39a418b$var$ButtonItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { optOutEnabled: optOutEnabled, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.optOutEnabled ? "_p12f1lit" : "_p12fsb0t",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dL5Pi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2b136a60fe0ab8a3$export$defe85febe8b728c);
    var $7VHMR;
    const $2b136a60fe0ab8a3$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        addPeopleButton: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
            "defaultMessage": "{inviteeCount, plural, one {Add # person} other {Add # people}}"
        },
        dismiss: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
            "defaultMessage": "Don't show again"
        },
        titleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
            "defaultMessage": "{inviteeCount, plural, one {{displayName} needs access to {productDisplayName}} other {People need access to {productDisplayName}}}"
        },
        descriptionWithoutPageTitleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
            "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you.} other {Invite people who need access to collaborate with you.}}"
        },
        descriptionWithPageTitleGeneric: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
            "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you on <strong>{title}</strong>.} other {Invite people who need access to collaborate with you on <strong>{title}</strong>.}}"
        },
        selectPeopleButton: {
            "id": "invite-prompt-on-link-insert.invite-prompt-flag.select-people-button",
            "defaultMessage": "Select people"
        }
    });
});
parcelRegister("5UhXy", function(module, exports) {
    $parcel$export(module.exports, "RecaptchaTerms", ()=>$9977e18e63047c93$export$f393864b6f4d4337);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bRP7i;
    const $9977e18e63047c93$export$f393864b6f4d4337 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($9977e18e63047c93$var$RecaptchaContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bRP7i")).default), null));
    const $9977e18e63047c93$var$RecaptchaContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _syaz1rc1 _19pk12x7 _otyr1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bRP7i", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$730521d2a941a4bd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $e4yMr;
    var $gGlbH;
    var $bJNOA;
    const $730521d2a941a4bd$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGlbH")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("bJNOA")).default).termsAndPolicy,
            tagName: tagName,
            values: {
                privacyPolicy: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("bJNOA")).default).privacyPolicy)),
                termsOfService: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("bJNOA")).default).termsOfService))
            }
        }));
    var $730521d2a941a4bd$export$2e2bcd8739ae039 = $730521d2a941a4bd$var$RecaptchaTermsAndPolicy;
});
parcelRegister("gGlbH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4048fb6427e6a3bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $i5FdW;
    var $koVbs;
    var $24KH4;
    const $4048fb6427e6a3bc$var$IntlProvider = ({ children: children })=>{
        const { locale: locale } = (0, (0, parcelRequire("koVbs")).default)();
        const { messages: messages } = (0, (0, parcelRequire("24KH4")).useFetchMessagesByLocale)(locale);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i5FdW")).default), {
            messages: messages,
            key: locale,
            locale: locale
        }, children);
    };
    var $4048fb6427e6a3bc$export$2e2bcd8739ae039 = $4048fb6427e6a3bc$var$IntlProvider;
});
parcelRegister("24KH4", function(module, exports) {
    $parcel$export(module.exports, "useFetchMessagesByLocale", ()=>$ccf6d059612ab0c7$export$5ac26fa9b941854e);
    var $5uXOq = parcelRequire("5uXOq");
    function $ccf6d059612ab0c7$export$c08b58fa4727b0d2(locale) {
        switch(locale){
            case 'cs-CZ':
            case 'cs':
                return (parcelRequire("2LixU"));
            case 'da-DK':
            case 'da':
                return (parcelRequire("61C2Q"));
            case 'de-DE':
            case 'de':
                return (parcelRequire("24L8K"));
            case 'en-GB':
                return (parcelRequire("1mx5Z"));
            case 'en-US':
            case 'en':
                return (parcelRequire("c2UVA"));
            case 'en-ZZ':
                return (parcelRequire("7rxkO"));
            case 'es-ES':
            case 'es':
                return (parcelRequire("9px3L"));
            case 'fi-FI':
            case 'fi':
                return (parcelRequire("4VT5S"));
            case 'fr-FR':
            case 'fr':
                return (parcelRequire("lUT42"));
            case 'hu-HU':
            case 'hu':
                return (parcelRequire("5tuwM"));
            case 'it-IT':
            case 'it':
                return (parcelRequire("qVJqL"));
            case 'ja-JP':
            case 'ja':
                return (parcelRequire("1PgeP"));
            case 'ko-KR':
            case 'ko':
                return (parcelRequire("4CicZ"));
            case 'nb-NB':
            case 'nb':
                return (parcelRequire("7oXmS"));
            case 'nl-NL':
            case 'nl':
                return (parcelRequire("7qkFr"));
            case 'pl-PL':
            case 'pl':
                return (parcelRequire("j5d3L"));
            case 'pt-BR':
            case 'pt':
                return (parcelRequire("3jQyO"));
            case 'ru-RU':
            case 'ru':
                return (parcelRequire("i4Mwg"));
            case 'sv-SE':
            case 'sv':
                return (parcelRequire("iFryb"));
            case 'tr-TR':
            case 'tr':
                return (parcelRequire("jeamt"));
            case 'th-TH':
            case 'th':
                return (parcelRequire("6nzw7"));
            case 'uk-UK':
            case 'uk':
                return (parcelRequire("1T8RH"));
            case 'vi-VI':
            case 'vi':
                return (parcelRequire("6Yv8t"));
            case 'zh-TW':
            case 'zh-HK':
                return (parcelRequire("gcvNk"));
            case 'zh-ZH':
            case 'zh-CN':
            case 'zh':
                return (parcelRequire("6kRu3"));
        }
        return Promise.resolve({
            default: {}
        });
    }
    function $ccf6d059612ab0c7$export$5ac26fa9b941854e(locale) {
        const [messages, setMessages] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useEffect)(()=>{
            let isMounted = true;
            async function startToFetchMessagesByLocale() {
                const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
                try {
                    const module = await $ccf6d059612ab0c7$export$c08b58fa4727b0d2(finalLocale);
                    const newMessages = module.default || module;
                    if (isMounted) setMessages(newMessages);
                } catch (e) {}
            }
            startToFetchMessagesByLocale();
            return ()=>{
                isMounted = false;
            };
        }, [
            locale
        ]);
        return {
            messages: messages
        };
    }
});
parcelRegister("2LixU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cwr5r").then(()=>parcelRequire('fjLck'));
});
parcelRegister("61C2Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7ZW4t").then(()=>parcelRequire('9ymKp'));
});
parcelRegister("24L8K", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ldC3n").then(()=>parcelRequire('eL5Or'));
});
parcelRegister("1mx5Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fwQ9t").then(()=>parcelRequire('1Sv3T'));
});
parcelRegister("c2UVA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bRM3V").then(()=>parcelRequire('htGCb'));
});
parcelRegister("7rxkO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2t6GE").then(()=>parcelRequire('aUZ4r'));
});
parcelRegister("9px3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("exjvr").then(()=>parcelRequire('cKEZ7'));
});
parcelRegister("4VT5S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8pjeE").then(()=>parcelRequire('CVhck'));
});
parcelRegister("lUT42", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lC4tU").then(()=>parcelRequire('29mfh'));
});
parcelRegister("5tuwM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ekty5").then(()=>parcelRequire('5bpoy'));
});
parcelRegister("qVJqL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fUFiI").then(()=>parcelRequire('hTLmg'));
});
parcelRegister("1PgeP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3uYDe").then(()=>parcelRequire('jK0tf'));
});
parcelRegister("4CicZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("81wgj").then(()=>parcelRequire('2FRRj'));
});
parcelRegister("7oXmS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4EFeY").then(()=>parcelRequire('1f61U'));
});
parcelRegister("7qkFr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hbGDZ").then(()=>parcelRequire('6g2r3'));
});
parcelRegister("j5d3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("57lNh").then(()=>parcelRequire('cqCj3'));
});
parcelRegister("3jQyO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aQiPG").then(()=>parcelRequire('l3IeQ'));
});
parcelRegister("i4Mwg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eabHf").then(()=>parcelRequire('4nuwM'));
});
parcelRegister("iFryb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lc8Zw").then(()=>parcelRequire('7V4xb'));
});
parcelRegister("jeamt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2pbI3").then(()=>parcelRequire('LnaRi'));
});
parcelRegister("6nzw7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1jWhB").then(()=>parcelRequire('6V7VR'));
});
parcelRegister("1T8RH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a2rwr").then(()=>parcelRequire('dfsSU'));
});
parcelRegister("6Yv8t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ixUQv").then(()=>parcelRequire('2AT3N'));
});
parcelRegister("gcvNk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("l3d8V").then(()=>parcelRequire('hPWmW'));
});
parcelRegister("6kRu3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jOyGC").then(()=>parcelRequire('3dWFS'));
});
parcelRegister("bJNOA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$793295bcb5663181$export$2e2bcd8739ae039);
    var $7VHMR;
    const $793295bcb5663181$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        termsAndPolicy: {
            id: 'growth.google-recaptcha.terms-and-policy.text',
            description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
            defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
        },
        privacyPolicy: {
            id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
            description: 'Privacy Policy link text',
            defaultMessage: 'Privacy Policy'
        },
        termsOfService: {
            id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
            description: 'Terms of Service link text',
            defaultMessage: 'Terms of Service'
        }
    });
    var $793295bcb5663181$export$2e2bcd8739ae039 = $793295bcb5663181$var$messages;
});
parcelRegister("hln6E", function(module, exports) {
    $parcel$export(module.exports, "useInviteSuccessFlag", ()=>$659770b6de3b09e5$export$c323779e5ddf45d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $cgL5K;
    var $fHfPB;
    var $3KRpp;
    var $pa9q9;
    var $koVbs;
    var $jqts8;
    var $6KSw8;
    const $659770b6de3b09e5$export$c323779e5ddf45d0 = ()=>{
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        return (0, $5uXOq.useCallback)(({ users: users, product: product, requireAdminApproval: requireAdminApproval, isAIOLIV5: isAIOLIV5 })=>{
            const id = `success-${(0, (0, parcelRequire("jqts8")).generateId)()}`;
            const dismiss = ()=>dismissFlag((0, (0, parcelRequire("fHfPB")).dismissFlag)(id));
            showFlag({
                id: id,
                render: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($659770b6de3b09e5$export$6c436beee6e5593, {
                        ...props,
                        id: id,
                        users: users,
                        onDismiss: dismiss,
                        product: product,
                        requireAdminApproval: requireAdminApproval,
                        isAIOLIV5: isAIOLIV5
                    })
            });
        }, [
            dismissFlag,
            showFlag
        ]);
    };
    const $659770b6de3b09e5$export$6c436beee6e5593 = ({ users: users, onDismiss: onDismiss, product: product, requireAdminApproval: requireAdminApproval, isAIOLIV5: isAIOLIV5, ...props })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const maxLength = 25;
        const invitedEmail = (0, (0, parcelRequire("jqts8")).clampString)(users[0]?.email || users[0].name, maxLength);
        const productDisplayName = (0, (0, parcelRequire("jqts8")).getProductDisplayName)(product);
        const customFlagFooterProps = (0, $5uXOq.useMemo)(()=>({
                actions: [
                    {
                        content: '',
                        onClick: ()=>{}
                    }
                ],
                linkComponent: ()=>requireAdminApproval && (0, ($parcel$interopDefault($5uXOq))).createElement($659770b6de3b09e5$var$FooterParagraph, null, formatMessage(isAIOLIV5 ? (0, (0, parcelRequire("6KSw8")).messages).additionalInfoGenericV5 : (0, (0, parcelRequire("6KSw8")).messages).additionalInfoGeneric, {
                        strong: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                                as: "strong"
                            }, chunks.join('')),
                        productDisplayName: productDisplayName
                    }))
            }), [
            formatMessage,
            isAIOLIV5,
            requireAdminApproval,
            productDisplayName
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3KRpp")).SuccessFlag), {
            ...props,
            ...customFlagFooterProps,
            onDismissed: onDismiss,
            title: formatMessage((0, (0, parcelRequire("6KSw8")).messages).title, {
                inviteeCount: users.length
            }),
            description: (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage(isAIOLIV5 ? (0, (0, parcelRequire("6KSw8")).messages).descriptionGenericV5 : (0, (0, parcelRequire("6KSw8")).messages).descriptionGeneric, {
                strong: (...chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                        as: "strong"
                    }, chunks.join('')),
                inviteeCount: users.length,
                email: invitedEmail,
                productDisplayName: productDisplayName
            }))
        });
    };
    const $659770b6de3b09e5$var$FooterParagraph = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazjjyb _t9ec1gty",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6KSw8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$503d6782010ac6ce$export$defe85febe8b728c);
    var $7VHMR;
    const $503d6782010ac6ce$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.title",
            "defaultMessage": "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
        },
        dismiss: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.dismiss",
            "defaultMessage": "Ok, got it"
        },
        descriptionGeneric: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic",
            "defaultMessage": "{inviteeCount, plural, one {We emailed <strong>{email}</strong> inviting them to {productDisplayName}.} other {We emailed <strong># people</strong> inviting them to {productDisplayName}.}}"
        },
        additionalInfoGeneric: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic",
            "defaultMessage": "Some people might need your admin's approval before they can join {productDisplayName}."
        },
        descriptionGenericV5: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic-v-5",
            "defaultMessage": "{inviteeCount, plural, one {<strong># project assignee</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.} other {<strong># project assignees</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.}}"
        },
        additionalInfoGenericV5: {
            "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic-v-5",
            "defaultMessage": "Admin may need to approve some assignees before they can join <strong>{productDisplayName}</strong>."
        }
    });
});
parcelRegister("jE4bA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f965259f40571ce$export$2e2bcd8739ae039);
    var $gccSB = parcelRequire("gccSB");
    var $fr1K2 = parcelRequire("fr1K2");
    var $3NMrl = parcelRequire("3NMrl");
    var $jcw0u;
    var $4R6GH;
    var $jJZqs;
    var $1Nspv;
    var $3M1CO;
    var $8zOmE;
    var $2NMNM;
    var $cplCs;
    var $h1X40;
    var $daCGe;
    var $bEouw;
    const $6f965259f40571ce$var$useCreateIssueService = (selectedCloudId = '')=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { fireErrorAnalyticsEvent: fireErrorAnalyticsEvent } = (0, (0, parcelRequire("h1X40")).useIssueCreateErrorAnalyticsEvent)();
        const createIssue = ({ onSuccess: onSuccess, formData: formData, transition: inputTransition, watchers: watchers, skipAutoWatch: skipAutoWatch, fieldConfig: fieldConfig, fieldTabs: fieldTabs, hasIssueAdjustmentModules: hasIssueAdjustmentModules, context: context, createLinkedIssuePayload: createLinkedIssuePayload, interactedFields: interactedFields = {}, shouldShowStatus: shouldShowStatus = false, isSubTaskCreationOpen: isSubTaskCreationOpen, triggerPointKey: triggerPointKey })=>{
            let transformedData = (0, (0, parcelRequire("bEouw")).transformData)(formData, fieldConfig);
            const additionalFields = context?.submitApiData?.additionalFields || {};
            const issueList = context?.submitApiData?.issueList || null;
            const transition = inputTransition ?? context?.submitApiData?.transition;
            const { isCreateLinkedIssue: isCreateLinkedIssue, sourceIssueKey: sourceIssueKey } = createLinkedIssuePayload || {};
            if (isCreateLinkedIssue && sourceIssueKey && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view')) transformedData = (0, (0, parcelRequire("bEouw")).handleCopyLinksAndAttachments)({
                transformedData: transformedData,
                formData: formData,
                sourceIssueKey: sourceIssueKey
            });
            const updateFields = (0, (0, parcelRequire("bEouw")).getUpdateFields)(isCreateLinkedIssue && Boolean(sourceIssueKey) && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view'));
            const payload = {
                fields: {
                    ...additionalFields,
                    ...(0, ($parcel$interopDefault($fr1K2)))(transformedData, updateFields)
                },
                update: (0, ($parcel$interopDefault($3NMrl)))(transformedData, updateFields),
                ...!(0, ($parcel$interopDefault($gccSB)))(issueList) && {
                    issueList: issueList
                },
                transition: undefined,
                watchers: watchers,
                externalToken: (0, (0, parcelRequire("cplCs")).default)().toString()
            };
            if (transition) payload.transition = transition;
            (0, (0, parcelRequire("1Nspv")).GlobalIssueCreateModalSubmitUFOExperience).start();
            const getCollapsedFields = ()=>!hasIssueAdjustmentModules && fieldTabs ? fieldTabs.flatMap((tab)=>tab.collapsedItems || []) : [];
            const MAX_RETRIES = 1;
            const performPostRequestRetry = (retryCount)=>{
                const analyticsEvent = createAnalyticsEvent({});
                return (0, (0, parcelRequire("daCGe")).performPost)((0, (0, parcelRequire("3M1CO")).transformCreateIssueUrl)({
                    issueUrl: (0, (0, parcelRequire("bEouw")).getCreateIssueUrl)({
                        isCreateLinkedIssue: isCreateLinkedIssue || false,
                        skipAutoWatch: skipAutoWatch
                    }),
                    selectedCloudId: selectedCloudId
                }), {
                    body: JSON.stringify(payload)
                }).then((issueCreateResponse)=>{
                    let issueCreateFieldsUsed;
                    const statusWasSet = issueCreateResponse && issueCreateResponse.transition !== undefined;
                    const collapsedFields = getCollapsedFields();
                    let modifiedFieldConfig = fieldConfig;
                    let modifiedFormData = formData;
                    let modifiedInteractedFields = interactedFields;
                    if (shouldShowStatus) {
                        modifiedFieldConfig = {
                            ...fieldConfig,
                            status: {
                                ...fieldConfig.status,
                                defaultValue: true
                            }
                        };
                        modifiedFormData = {
                            ...formData,
                            status: true
                        };
                        if (statusWasSet) modifiedInteractedFields = {
                            ...interactedFields,
                            status: true
                        };
                    }
                    if ((0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs')) issueCreateFieldsUsed = (0, (0, parcelRequire("bEouw")).transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields, collapsedFields);
                    else issueCreateFieldsUsed = (0, (0, parcelRequire("bEouw")).transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields);
                    const issueCreateContextUsed = (0, (0, parcelRequire("bEouw")).transformContextDataUsedForCreate)(context);
                    (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).success();
                    (0, (0, parcelRequire("1Nspv")).GlobalIssueCreateModalSubmitUFOExperience).success();
                    if (issueCreateResponse?.transition?.status && issueCreateResponse.transition.status !== 200) (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'transitionIssue',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        attributes: {
                            status: issueCreateResponse.transition.status,
                            message: (issueCreateResponse.transition.errorCollection?.errorMessages || []).join('\n')
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    const collapsedFieldsLength = collapsedFields.length;
                    onSuccess({
                        issueCreateResponse: issueCreateResponse,
                        issueCreateFieldsUsed: issueCreateFieldsUsed,
                        issueCreateContextUsed: issueCreateContextUsed,
                        collapsedFieldsLength: collapsedFieldsLength
                    });
                    const attributes = {
                        isRetry: retryCount < MAX_RETRIES,
                        statusCode: '2xx'
                    };
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
                }).catch((error)=>{
                    if (String(error.statusCode).startsWith('5')) {
                        if (retryCount < MAX_RETRIES) {
                            const attributes = {
                                isRetry: true,
                                statusCode: '5xx'
                            };
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
                        }
                        if (retryCount > 0) return performPostRequestRetry(retryCount - 1);
                    }
                    let statusCode;
                    if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) statusCode = error?.statusCode;
                    if ((0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere')) fireErrorAnalyticsEvent({
                        meta: {
                            id: 'useCreateIssueService',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        statusCode: statusCode
                    });
                    else (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'useCreateIssueService',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            isSubtask: isSubTaskCreationOpen,
                            triggerPointKey: triggerPointKey,
                            statusCode: statusCode
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).failure();
                    (0, (0, parcelRequire("1Nspv")).GlobalIssueCreateModalSubmitUFOExperience).failure();
                    throw error;
                });
            };
            return performPostRequestRetry(MAX_RETRIES);
        };
        return [
            createIssue
        ];
    };
    var $6f965259f40571ce$export$2e2bcd8739ae039 = $6f965259f40571ce$var$useCreateIssueService;
});
parcelRegister("3NMrl", function(module, exports) {
    var $i2e26 = parcelRequire("i2e26");
    var $9SRAA = parcelRequire("9SRAA");
    var $2c4b85df1af41471$var$pick = $9SRAA(function(object, paths) {
        return object == null ? {} : $i2e26(object, paths);
    });
    module.exports = $2c4b85df1af41471$var$pick;
});
parcelRegister("i2e26", function(module, exports) {
    var $4gaCO = parcelRequire("4gaCO");
    var $fh9gH = parcelRequire("fh9gH");
    function $d2134c8f0f8064b1$var$basePick(object, paths) {
        return $4gaCO(object, paths, function(value, path) {
            return $fh9gH(object, path);
        });
    }
    module.exports = $d2134c8f0f8064b1$var$basePick;
});
parcelRegister("cplCs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d93bae87fe11db2e$export$2e2bcd8739ae039);
    const $d93bae87fe11db2e$var$MAX_UINT32 = 4294967296;
    function $d93bae87fe11db2e$export$2e2bcd8739ae039() {
        try {
            const buf = new Uint32Array(1);
            window.crypto.getRandomValues(buf);
            return buf[0] / $d93bae87fe11db2e$var$MAX_UINT32;
        } catch (e) {
            return Math.random();
        }
    }
});
parcelRegister("daCGe", function(module, exports) {
    $parcel$export(module.exports, "performPost", ()=>$d96b0a5921fffd0a$export$8fc3e0df78e1e7f5);
    var $aDvGo;
    var $jJZqs;
    var $51xpa;
    var $eusud;
    var $iwPwz;
    const $d96b0a5921fffd0a$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $d96b0a5921fffd0a$var$processResponseFromServer = (response)=>{
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $d96b0a5921fffd0a$var$handleNetworkErrors = (err)=>{
        if (err instanceof TypeError) throw new Error('Failed to fetch', {
            cause: err
        });
        throw err;
    };
    const $d96b0a5921fffd0a$var$handleErrors = async (response)=>{
        const clone = response.clone();
        const res = await response.json();
        const traceId = (0, (0, parcelRequire("iwPwz")).getTraceId)(response);
        if ([
            (0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977),
            (0, $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f),
            (0, $3cd8a0ece36fbae5$export$6763168a631449a2),
            (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07),
            (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
            (0, $3cd8a0ece36fbae5$export$a447d0a965e16776)
        ].find((i)=>i === response.status)) throw (0, (0, parcelRequire("eusud")).transformValidationErrorFromServer)(res, response.status, traceId);
        if (res?.errorMessages) throw res.errorMessages.join('\n');
        if (!response.ok) {
            if (traceId !== undefined && traceId.length > 0) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
        }
        return clone;
    };
    const $d96b0a5921fffd0a$export$8fc3e0df78e1e7f5 = (url, options = {})=>fetch(url, (0, (0, parcelRequire("51xpa")).applyObservabilityHeaders)(url, {
            ...$d96b0a5921fffd0a$var$postOptions,
            ...options
        })).then($d96b0a5921fffd0a$var$handleErrors).then($d96b0a5921fffd0a$var$processResponseFromServer).catch($d96b0a5921fffd0a$var$handleNetworkErrors);
});
parcelRegister("bEouw", function(module, exports) {
    $parcel$export(module.exports, "getCreateIssueUrl", ()=>$08caf312abbfcdbb$export$a92012cc19d68266);
    $parcel$export(module.exports, "transformData", ()=>$08caf312abbfcdbb$export$3ceb62baab058c6b);
    $parcel$export(module.exports, "transformDataToIssueCreateFieldsUsed", ()=>$08caf312abbfcdbb$export$cd0a7e468fa77da3);
    $parcel$export(module.exports, "transformContextDataUsedForCreate", ()=>$08caf312abbfcdbb$export$59dd9eec92eadfdd);
    $parcel$export(module.exports, "handleCopyLinksAndAttachments", ()=>$08caf312abbfcdbb$export$16a7d356b78628b0);
    $parcel$export(module.exports, "getUpdateFields", ()=>$08caf312abbfcdbb$export$3312ec73143db50);
    var $gccSB = parcelRequire("gccSB");
    var $4R6GH;
    var $5fc53;
    var $fCo6Y;
    var $gItVn;
    const $08caf312abbfcdbb$export$a92012cc19d68266 = ({ isCreateLinkedIssue: isCreateLinkedIssue = false, skipAutoWatch: skipAutoWatch = false })=>{
        const urlSearchParams = new URLSearchParams('updateHistory=true&applyDefaultValues=false');
        if (isCreateLinkedIssue && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view')) urlSearchParams.append('fromCreateLinkedIssueScreen', 'true');
        if (skipAutoWatch) urlSearchParams.append('skipAutoWatch', 'true');
        return `/rest/api/3/issue?${urlSearchParams.toString()}`;
    };
    const $08caf312abbfcdbb$export$3ceb62baab058c6b = (formData, fieldConfig)=>Object.keys(formData).reduce((acc, fieldId)=>{
            const fieldData = fieldConfig[fieldId];
            if (fieldData) {
                const transformFunction = (0, (0, parcelRequire("gItVn")).getGqlFieldMap)()[fieldData.gqlType]?.submitTransform;
                const transformedData = transformFunction && formData[fieldId] !== null && formData[fieldId] !== undefined ? transformFunction(formData[fieldId]) : formData[fieldId];
                return {
                    ...acc,
                    [fieldId]: transformedData
                };
            }
            return {
                ...acc,
                [fieldId]: formData[fieldId]
            };
        }, {});
    const $08caf312abbfcdbb$export$95572daab36eec17 = (fieldValue)=>{
        if (typeof fieldValue === 'object' && fieldValue !== null) {
            if ('issues' in fieldValue) return fieldValue.issues.length > 0;
            if ('content' in fieldValue && 'version' in fieldValue && 'type' in fieldValue) return !(0, (0, parcelRequire("fCo6Y")).isOnlyWhitespaceAdf)(fieldValue);
        }
        return typeof fieldValue === 'number' || typeof fieldValue === 'boolean' || !(0, ($parcel$interopDefault($gccSB)))(fieldValue);
    };
    const $08caf312abbfcdbb$export$cd0a7e468fa77da3 = (formData, fieldConfig, interactedFields, collapsedFields)=>{
        const issueCreateFieldsUsed = [];
        Object.keys(fieldConfig).forEach((fieldId)=>{
            const fieldValue = formData[fieldId];
            issueCreateFieldsUsed.push({
                issueFieldId: fieldId,
                issueFieldType: fieldConfig[fieldId].fieldType,
                gqlType: fieldConfig[fieldId].gqlType,
                isPopulated: $08caf312abbfcdbb$export$95572daab36eec17(fieldValue),
                isRequired: !!fieldConfig[fieldId].isRequired,
                hasDefaultValue: !!fieldConfig[fieldId].defaultValue,
                wasInteractedWith: !!interactedFields?.[fieldId],
                ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && collapsedFields && collapsedFields.length > 0 && {
                    wasCollapsed: collapsedFields.includes(fieldId)
                }
            });
        });
        return issueCreateFieldsUsed;
    };
    const $08caf312abbfcdbb$export$59dd9eec92eadfdd = (context)=>{
        if ((0, ($parcel$interopDefault($gccSB)))(context)) return {};
        return {
            wereAdditionalFieldsProvided: !(0, ($parcel$interopDefault($gccSB)))(context?.submitApiData?.additionalFields),
            isIssueListProvided: !(0, ($parcel$interopDefault($gccSB)))(context?.submitApiData?.issueList?.addTo)
        };
    };
    const $08caf312abbfcdbb$export$4c4230f34434cbdf = ({ attachments: attachments, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
            ...attachments ? [
                {
                    set: attachments
                }
            ] : [],
            ...issueLinksValue?.includeAttachments ? [
                {
                    copy: {
                        sourceIssues: [
                            {
                                key: sourceIssueKey
                            }
                        ]
                    }
                }
            ] : []
        ];
    const $08caf312abbfcdbb$export$8310c11186fc8627 = ({ issueLinksTransformedData: issueLinksTransformedData, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
            ...issueLinksTransformedData || [],
            ...issueLinksValue?.includeLinks ? [
                {
                    copy: {
                        sourceIssues: [
                            {
                                key: sourceIssueKey
                            }
                        ]
                    }
                }
            ] : []
        ];
    const $08caf312abbfcdbb$export$16a7d356b78628b0 = ({ transformedData: transformedData, formData: formData, sourceIssueKey: sourceIssueKey })=>{
        const issueLinksValue = formData[0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE];
        return {
            ...transformedData,
            [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: $08caf312abbfcdbb$export$4c4230f34434cbdf({
                attachments: transformedData[0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE],
                issueLinksValue: issueLinksValue,
                sourceIssueKey: sourceIssueKey
            }),
            [(0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE)]: $08caf312abbfcdbb$export$8310c11186fc8627({
                issueLinksTransformedData: transformedData[0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE],
                issueLinksValue: issueLinksValue,
                sourceIssueKey: sourceIssueKey
            })
        };
    };
    const $08caf312abbfcdbb$export$3312ec73143db50 = (isCreateLinkedIssue = false)=>isCreateLinkedIssue ? (0, (0, parcelRequire("gItVn")).UPDATE_FIELDS_CREATE_LINKED_ISSUE) : (0, (0, parcelRequire("gItVn")).UPDATE_FIELDS);
});
parcelRegister("fCo6Y", function(module, exports) {
    $parcel$export(module.exports, "emptyAdfObject", ()=>$79bd166f69131b05$export$202742e99f678c60);
    $parcel$export(module.exports, "removeCollectionFromAdf", ()=>$79bd166f69131b05$export$9e9311e676291037);
    $parcel$export(module.exports, "convertAdfStringToObject", ()=>$79bd166f69131b05$export$ee70d4eb14697455);
    $parcel$export(module.exports, "isOnlyWhitespaceAdf", ()=>$79bd166f69131b05$export$cf4bde415465976c);
    $parcel$export(module.exports, "removeNewLineCharactersFromAdf", ()=>$79bd166f69131b05$export$d6ce0667c33b94ff);
    $parcel$export(module.exports, "removeTrailingNewLineCharacters", ()=>$79bd166f69131b05$export$3688e35a300432d6);
    $parcel$export(module.exports, "simplifyAdf", ()=>$79bd166f69131b05$export$def86d25f0c7f0bc);
    $parcel$export(module.exports, "hasMediaFileNodes", ()=>$79bd166f69131b05$export$9a632b58fb9b287c);
    $parcel$export(module.exports, "hasMediaFileNodesUpdated", ()=>$79bd166f69131b05$export$80a6e90c7b29d88c);
    var $lmhF9;
    var $l1C1k;
    var $dJl1T;
    const $79bd166f69131b05$export$202742e99f678c60 = {
        type: 'doc',
        version: 1,
        content: []
    };
    const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
        if (adf === null || adf === undefined) return null;
        if (adf.type === 'media' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.type === 'mediaInline' && adf.attrs) return {
            ...adf,
            attrs: {
                ...adf.attrs,
                collection: ''
            }
        };
        if (adf.content) return {
            ...adf,
            content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
        };
        return adf;
    };
    const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
        if (typeof adf === 'string') try {
            return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
            return null;
        }
        return $79bd166f69131b05$export$9e9311e676291037(adf);
    };
    const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
            if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
            return false;
        }) : false;
    const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
        if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
        let len;
        for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
            if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
        }
        return {
            ...adf,
            content: adf.content.slice(0, len + 1)
        };
    };
    const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
    const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
    const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
        const mediaNodes = new Map();
        (0, (0, parcelRequire("l1C1k")).traverse)(doc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    };
    const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, (0, parcelRequire("l1C1k")).traverse)(newDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, (0, parcelRequire("l1C1k")).traverse)(currentDoc, {
            media: (node)=>{
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    };
    const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
        if (doc === null || doc === undefined) return false;
        const nonSimpleTextNodes = (0, (0, parcelRequire("lmhF9")).filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
        return nonSimpleTextNodes.length === 0;
    };
    const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
        const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("kOFhM")));
        const { WikiMarkupTransformer: WikiMarkupTransformer } = await Promise.resolve((parcelRequire("dN5CS")));
        const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("hYNZx")));
        const jsonTransformer = new JSONTransformer();
        const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
        if (node === null || node === undefined) return '';
        const pmNode = jsonTransformer.parse(node);
        return wikiMarkupTransformer.encode(pmNode);
    };
});
parcelRegister("lmhF9", function(module, exports) {
    $parcel$export(module.exports, "filter", ()=>$cb7d90be6f5f5975$export$3dea766d36a8935f);
    var $l1C1k;
    function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
        const result = [];
        (0, (0, parcelRequire("l1C1k")).traverse)(adf, {
            any: (node)=>{
                if (callback(node)) result.push(node);
            }
        });
        return result;
    }
});
parcelRegister("02X4k", function(module, exports) {
    $parcel$export(module.exports, "useDescriptionAnalytics", ()=>$49a4907630c8c548$export$df0e1df705c71ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $5eGnF;
    var $9svjh;
    var $8zOmE;
    var $2NMNM;
    const $49a4907630c8c548$export$df0e1df705c71ad = ()=>{
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const [hasSent, setHasSent] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribeFromChange = subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, (data)=>{
                if (!hasSent && data.fieldId === 'description') {
                    const analyticsEvent = createAnalyticsEvent({
                        actionSubject: 'description',
                        action: 'editStarted'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createIssueDescriptionTouched');
                    setHasSent(true);
                }
            });
            const unsubscribeFromBlur = subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_BLUR, (data)=>{
                if (data.fieldId === 'description') setHasSent(false);
            });
            return ()=>{
                unsubscribeFromChange();
                unsubscribeFromBlur();
            };
        }, [
            createAnalyticsEvent,
            subscribe,
            hasSent,
            setHasSent
        ]);
    };
});
parcelRegister("f2cnb", function(module, exports) {
    $parcel$export(module.exports, "ActionsContainer", ()=>$57267ca2380c8d3c$export$48377ae1c677702b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dC5iT;
    var $8CUq3;
    var $45Cy1;
    var $iUFy5;
    var $kNC83;
    var $c0dQj;
    var $akFPq;
    var $cWvpX;
    const $57267ca2380c8d3c$export$48377ae1c677702b = (props)=>{
        const hasWatchersInitialized = (0, $5uXOq.useRef)(false);
        const [{ dataFetchError: dataFetchError, selectedProject: selectedProject }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { view: view, isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const shouldDisableActions = dataFetchError !== null;
        const shouldDisableHeaderDropdown = Boolean(shouldDisableActions || selectedProject === null);
        const shouldRenderActionsContainer = view === 'modal' && isTransitionInState([
            'mini'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED) && !(0, (0, parcelRequire("c0dQj")).isMobileAndInMVPExperiment)();
        if (!shouldRenderActionsContainer) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57267ca2380c8d3c$var$ActionsContainerWrapper, {
            "data-testid": "issue-create.ui.modal.create-form.actions-container.actions-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cWvpX")).default), {
            configs: props.watchersConfigurations,
            hasWatchersInitialized: hasWatchersInitialized
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $57267ca2380c8d3c$var$dropdownContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("akFPq")).HeaderDropdown), {
            isDisabled: shouldDisableHeaderDropdown,
            fieldConfig: props.fieldConfig
        })));
    };
    const $57267ca2380c8d3c$var$ActionsContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _1pbykb7n",
                __cmplp.className
            ])
        });
    });
    const $57267ca2380c8d3c$var$dropdownContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("akFPq", function(module, exports) {
    $parcel$export(module.exports, "HeaderDropdown", ()=>$fbfaa47783d19306$export$e93b0271171ef3a);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $iwwXK;
    var $dC5iT;
    var $8CUq3;
    var $hYRTO;
    var $7CMCs;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $c7ZNt;
    var $45Cy1;
    var $8zOmE;
    var $2NMNM;
    var $9JXcu;
    var $koeKL;
    var $itmJb;
    var $axOs5;
    var $b6VJj;
    const $fbfaa47783d19306$var$testId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.dropdown-menu';
    const $fbfaa47783d19306$var$buttonTestId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.button';
    const $fbfaa47783d19306$var$LoadingPlaceholder = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hYRTO")).default), {
            name: "header-dropdown-smart-fields-gic-toggle",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $fbfaa47783d19306$var$loadingPlaceholderStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                width: "100%",
                isShimmering: true
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                width: "100%",
                isShimmering: true
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwwXK")).default), {
                width: "100%",
                isShimmering: true
            }))
        }, children);
    const $fbfaa47783d19306$export$e93b0271171ef3a = (props)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { isDisabled: isDisabled = false } = props;
        const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("9JXcu")).default));
        const showConfigureFieldsModal = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            toggleConfigureFieldsModalVisibility(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'configureFields', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
        };
        const showFindFieldModal = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            toggleFindFieldsModalVisibility(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'findYourField', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
        };
        const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
        const loadSmartFieldsAdminToggleQuery = (0, $5uXOq.useCallback)(()=>{
            loadQuery({
                cloudId: cloudId
            });
        }, [
            cloudId,
            loadQuery
        ]);
        const onOpenChange = (attributes)=>{
            if (attributes.isOpen) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'meatballMenu');
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg')) loadSmartFieldsAdminToggleQuery();
            }
        };
        const Wrapper = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? $fbfaa47783d19306$var$LoadingPlaceholder : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            placement: "bottom-end",
            shouldRenderToParent: true,
            trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...dropdownProps,
                    testId: $fbfaa47783d19306$var$buttonTestId,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: ""
                    }),
                    appearance: "subtle",
                    isDisabled: isDisabled,
                    ref: triggerRef,
                    "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("axOs5")).default).moreActionsIssueTermRefresh : (0, (0, parcelRequire("axOs5")).default).moreActions)
                }),
            onOpenChange: onOpenChange,
            testId: $fbfaa47783d19306$var$testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: showConfigureFieldsModal
        }, (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? formatMessage((0, (0, parcelRequire("axOs5")).default).configureFields) : formatMessage((0, (0, parcelRequire("axOs5")).default).showFields)), queryReference && (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "smartFieldsGicToggleDropdownItem",
            packageName: "jiraIssueCreate",
            fallback: "unmount",
            sendToPrivacyUnsafeSplunk: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b6VJj")).SmartFieldsDropdownItem), {
            queryReference: queryReference
        })) : null, showFindFieldOption() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: showFindFieldModal
        }, formatMessage((0, (0, parcelRequire("axOs5")).default).findField)))));
    };
    const $fbfaa47783d19306$var$loadingPlaceholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '204px'
    });
});
parcelRegister("9JXcu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aa88ec833f9083b$export$2e2bcd8739ae039);
    const $5aa88ec833f9083b$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "jira.create.smart.fields.is-enabled"
                ]
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "key"
        }, v3 = {
            "kind": "ScalarField",
            "name": "value"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "smartfieldsDropdownItemAdminToggleQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraApplicationProperty",
                                "kind": "LinkedField",
                                "name": "applicationPropertiesByKey",
                                "plural": true,
                                "selections": [
                                    v2,
                                    v3
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "smartfieldsDropdownItemAdminToggleQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraApplicationProperty",
                                "kind": "LinkedField",
                                "name": "applicationPropertiesByKey",
                                "plural": true,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b32a050756cd7c85fc5b8be21b06dd67137df07c58fb95dbd8b6376b34305d68",
                "metadata": {},
                "name": "smartfieldsDropdownItemAdminToggleQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5aa88ec833f9083b$var$node.hash = "dd574875cb62c2e1fc5d67c9f05f7bcf";
    var $5aa88ec833f9083b$export$2e2bcd8739ae039 = $5aa88ec833f9083b$var$node;
});
parcelRegister("axOs5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ce4ca280af153f6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ce4ca280af153f6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showFields: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.show-fields",
            "defaultMessage": "Show fields"
        },
        configureFields: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.configure-fields",
            "defaultMessage": "Configure fields"
        },
        findField: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.find-field",
            "defaultMessage": "Find your field"
        },
        moreActions: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions",
            "defaultMessage": "More actions for this issue"
        },
        moreActionsIssueTermRefresh: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions-issue-term-refresh",
            "defaultMessage": "More actions for this work item"
        }
    });
});
parcelRegister("b6VJj", function(module, exports) {
    $parcel$export(module.exports, "SmartFieldsDropdownItem", ()=>$156daf98187ae82d$export$7e458a2926172360);
    var $9JXcu;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $6B7KL;
    var $kgoHi;
    var $8CUq3;
    var $dTlW6;
    var $jcw0u;
    var $koVbs;
    var $45Cy1;
    var $gEEzS;
    var $8zOmE;
    var $aA974;
    var $2YP9W;
    var $1r5Yg;
    const $156daf98187ae82d$var$CustomToggleButton = (0, $5uXOq.forwardRef)(({ isChecked: isChecked, onChange: onChange, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            alignItems: "center",
            gap: "space.100",
            xcss: $156daf98187ae82d$var$customButtonStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: "toggle-smart-fields"
        }, formatMessage((0, (0, parcelRequire("1r5Yg")).default).smartFieldsLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            ...props,
            id: "toggle-smart-fields",
            isChecked: isChecked,
            onChange: onChange,
            ref: ref
        }));
    });
    const $156daf98187ae82d$export$f66e1f764818b2e = ()=>(0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("aA974")).gicSmartFieldsFeatureResource));
    const $156daf98187ae82d$export$7e458a2926172360 = ({ queryReference: queryReference })=>{
        const { loading: loading, data: data, update: updateResource } = $156daf98187ae82d$export$f66e1f764818b2e();
        const { updatePreferences: updatePreferences } = (0, (0, parcelRequire("gEEzS")).useSmartFieldsUpdateUserPreference)();
        const { setIsSmartFieldsToggled: setIsSmartFieldsToggled } = (0, (0, parcelRequire("45Cy1")).useFormContextActions)();
        const adminToggleStateData = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("9JXcu")).default), queryReference);
        const hasUserOptedOut = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
            data
        ]);
        const hasUserDismissedReadMore = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
            data
        ]);
        const hasUserDismissedGicOnboarding = (0, $5uXOq.useMemo)(()=>typeof data?.hasUserDismissedGicOnboarding === 'boolean' ? data.hasUserDismissedGicOnboarding : false, [
            data
        ]);
        const handleHideUnusedFieldsChange = async (_, analyticsEventUI)=>{
            const value = !hasUserOptedOut;
            updateResource(()=>({
                    hasUserOptedOut: value,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: false
                }));
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEventUI, 'toggleGicSmartFields', {
                isSmartFieldsOptOut: value
            });
            try {
                await updatePreferences({
                    hasUserOptedOut: value,
                    hasUserDismissedReadMore: false,
                    hasUserDismissedGicOnboarding: false
                });
                setIsSmartFieldsToggled(true);
            } catch (err) {
                updateResource(()=>({
                        hasUserOptedOut: hasUserOptedOut,
                        hasUserDismissedReadMore: hasUserDismissedReadMore,
                        hasUserDismissedGicOnboarding: hasUserDismissedGicOnboarding
                    }));
                const error = err instanceof Error ? err : new Error('GIC Smart Fields: Unknown error while toggling user preference');
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'toggleGicSmartFields',
                        packageName: 'jiraIssueCreate',
                        teamName: 'deliveroo'
                    }
                });
            }
        };
        const hasAdminDisabledSmartFields = (0, $5uXOq.useMemo)(()=>adminToggleStateData?.jira?.applicationPropertiesByKey?.filter((item)=>item.key === (0, $a11a54266737e598$export$5781c9f38e6a61fe))[0]?.value === 'false', [
            adminToggleStateData
        ]);
        if (loading || hasAdminDisabledSmartFields) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            component: $156daf98187ae82d$var$CustomToggleButton,
            isChecked: !hasUserOptedOut,
            onChange: handleHideUnusedFieldsChange
        });
    };
    const $156daf98187ae82d$var$customButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingInline: 'space.200',
        paddingBlock: 'space.100'
    });
});
parcelRegister("1r5Yg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58666566a51e36c1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $58666566a51e36c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        smartFieldsLabel: {
            "id": "issue-create.modal.create-form.actions-container.dropdown-menu.smartfields-dropdown-item.smart-fields-label",
            "defaultMessage": "Hide unused fields"
        }
    });
});
parcelRegister("cWvpX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$723322a375d88c13$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eh4UB;
    var $723322a375d88c13$export$2e2bcd8739ae039 = (props)=>{
        if (!props.configs?.canManageWatchers) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eh4UB")).default), props);
    };
});
parcelRegister("eh4UB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d774e6d7fcd5fe2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9fuVs;
    var $2vSU6;
    var $45Cy1;
    var $bq3cD;
    var $g84D6;
    var $cYlk7;
    const $4d774e6d7fcd5fe2$var$Watchers = ({ configs: configs, hasWatchersInitialized: hasWatchersInitializedForNewModal })=>{
        const hasWatchersInitializedForOldModal = (0, $5uXOq.useRef)(false);
        const hasWatchersInitialized = hasWatchersInitializedForNewModal || hasWatchersInitializedForOldModal;
        const { isAutoWatchEnabled: isAutoWatchEnabled, isWatchersEnabled: isWatchersEnabled } = configs || {};
        const { data: { user: currentUser }, loading: loading, error: error } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const [{ watchers: watchers, selectedProject: selectedProject }, { setWatchers: setWatchers }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous && !loading && !error && selectedProject.projectType !== (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT);
        const isWatching = watchers.some((watcher)=>watcher.accountId === currentUser.accountId);
        (0, $5uXOq.useEffect)(()=>{
            if (isAutoWatchEnabled && shouldShowWatchers && currentUser && !hasWatchersInitialized.current && !isWatching) {
                setWatchers([
                    ...watchers,
                    currentUser
                ]);
                hasWatchersInitialized.current = true;
            }
        }, [
            currentUser,
            shouldShowWatchers,
            isAutoWatchEnabled,
            setWatchers,
            watchers,
            isWatching,
            hasWatchersInitialized
        ]);
        if (!shouldShowWatchers) return null;
        if (!isWatchersEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g84D6")).default), {
            isDisabled: true
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bq3cD")).default), {
            watchers: watchers,
            projectKey: selectedProject.projectKey,
            setWatchers: setWatchers,
            isWatching: isWatching,
            currentUser: currentUser,
            ...configs
        }));
    };
    var $4d774e6d7fcd5fe2$export$2e2bcd8739ae039 = $4d774e6d7fcd5fe2$var$Watchers;
});
parcelRegister("bq3cD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2ab776e90af69e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $lfTZh;
    var $kxZPA;
    const $a2ab776e90af69e0$var$AsyncWatchers = (0, (0, parcelRequire("kxZPA")).lazyAfterPaint)(()=>(parcelRequire("ineHY")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/issue-create-watchers/src/ui/main.tsx"
    });
    const $a2ab776e90af69e0$var$Watchers = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-issue-create-watchers",
            packageName: "jiraIssueCreateWatchers"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-create-watchers-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a2ab776e90af69e0$var$AsyncWatchers, props)));
    var $a2ab776e90af69e0$export$2e2bcd8739ae039 = $a2ab776e90af69e0$var$Watchers;
});
parcelRegister("ineHY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a4p3d").then(()=>parcelRequire('jgRch'));
});
parcelRegister("g84D6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5dd8a4c925632328$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bH0nF;
    const $5dd8a4c925632328$var$BaseButton = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$Container, {
            "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.root"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            appearance: "subtle",
            spacing: "default",
            ref: ref
        }, children || (0, ($parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$ButtonContent, {
            "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.watch-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5dd8a4c925632328$var$ButtonIcon, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bH0nF"))))), {
            size: "medium",
            label: ""
        }))))));
    var $5dd8a4c925632328$export$2e2bcd8739ae039 = $5dd8a4c925632328$var$BaseButton;
    const $5dd8a4c925632328$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3 _2hwxu2gc _hyh1otz2 _a7a01txw _18iz1h6o",
                __cmplp.className
            ])
        });
    });
    const $5dd8a4c925632328$var$ButtonContent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $5dd8a4c925632328$var$ButtonIcon = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bH0nF", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8834017b673aa7e1$var$_react = $8834017b673aa7e1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $8834017b673aa7e1$var$_eyeOpen = $8834017b673aa7e1$var$_interopRequireDefault((parcelRequire("7eUVi")));
    function $8834017b673aa7e1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8834017b673aa7e1$var$WatchIcon = (props)=>$8834017b673aa7e1$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
        }, props, {
            newIcon: $8834017b673aa7e1$var$_eyeOpen.default
        }));
    $8834017b673aa7e1$var$WatchIcon.displayName = 'WatchIcon';
    var $8834017b673aa7e1$var$_default = module.exports.default = $8834017b673aa7e1$var$WatchIcon;
});
parcelRegister("7eUVi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5455fef624dfcc70$var$_react = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5455fef624dfcc70$var$_UNSAFE_baseNew = $5455fef624dfcc70$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $5455fef624dfcc70$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5455fef624dfcc70$var$EyeOpenIcon = (props)=>$5455fef624dfcc70$var$_react.default.createElement($5455fef624dfcc70$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 2.75c-3.255 0-6.086 2.039-7.13 4.888a1.06 1.06 0 0 0 0 .724C1.914 11.212 4.745 13.25 8 13.25s6.086-2.039 7.129-4.888a1.06 1.06 0 0 0 0-.724c-1.043-2.85-3.874-4.888-7.13-4.888Z"/><path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M10.25 8a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"/>`
        }, props));
    $5455fef624dfcc70$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
    var $5455fef624dfcc70$var$_default = module.exports.default = $5455fef624dfcc70$var$EyeOpenIcon;
});
parcelRegister("fp4bR", function(module, exports) {
    $parcel$export(module.exports, "ExternalControlsRenderer", ()=>$054cbdd0c0a5e4b2$export$1f4f83075c603162);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    var $co1wz;
    var $hULKg;
    var $gt8ej;
    const $054cbdd0c0a5e4b2$var$Controls = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
        const formAPI = (0, $5uXOq.useMemo)(()=>({
                getFormState: getFormState,
                setFieldValue: setFieldValue
            }), [
            getFormState,
            setFieldValue
        ]);
        const { fieldAPI: fieldAPI, getFormFieldValue: getFormFieldValue } = (0, (0, parcelRequire("gt8ej")).useExternalControlsAPI)(formAPI);
        const { Component: Component } = externalControls;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            fieldAPI: fieldAPI,
            getFormFieldValue: getFormFieldValue
        });
    };
    const $054cbdd0c0a5e4b2$export$1f4f83075c603162 = ({ externalControls: externalControls, getFormState: getFormState, setFieldValue: setFieldValue })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('external-controls-in-gic_9125o') && externalControls && getFormState && setFieldValue && (0, (0, parcelRequire("hULKg")).ALLOWED_EXTERNAL_CONTROLS).TRIGGER_POINTS.includes(externalControls.triggerPoint)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "externalControlsRenderer",
            packageName: "jiraIssueCreate",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($054cbdd0c0a5e4b2$var$Controls, {
            externalControls: externalControls,
            getFormState: getFormState,
            setFieldValue: setFieldValue
        }));
        return null;
    };
});
parcelRegister("gt8ej", function(module, exports) {
    $parcel$export(module.exports, "useExternalControlsAPI", ()=>$d0f9c9622d0b480c$export$b6e86f46675e84e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $hULKg;
    const $d0f9c9622d0b480c$export$b6e86f46675e84e5 = ({ getFormState: getFormState, setFieldValue: setFieldValue })=>{
        const getFormFieldValue = (0, $5uXOq.useCallback)((fieldId)=>getFormState()?.values[fieldId], [
            getFormState
        ]);
        const fieldAPI = (0, $5uXOq.useMemo)(()=>{
            const allowedFieldAPI = {};
            (0, (0, parcelRequire("hULKg")).ALLOWED_EXTERNAL_CONTROLS).FIELD_IDS.forEach((fieldId)=>{
                allowedFieldAPI[fieldId] = {
                    getValue: ()=>getFormFieldValue(fieldId),
                    setValue: (value)=>setFieldValue(fieldId, value)
                };
            });
            return allowedFieldAPI;
        }, [
            setFieldValue,
            getFormFieldValue
        ]);
        return {
            fieldAPI: fieldAPI,
            getFormFieldValue: getFormFieldValue
        };
    };
});
parcelRegister("7kEHt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6b4c30e66dfce2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gKZoD;
    var $fphHl;
    var $jxIT3;
    var $cte3m;
    var $7XYc4;
    var $4R6GH;
    var $a6X31;
    var $2jBOL;
    var $45Cy1;
    var $6gjIc;
    var $fGCY8;
    var $cu7BW;
    const $a6b4c30e66dfce2e$export$31d936b98297daf0 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("fGCY8")).default), (0, (0, parcelRequire("cu7BW")).FieldsContainer));
        const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency } = props;
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
        const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const tabs = fieldTabs.map(({ id: id, name: name })=>({
                label: name,
                content: null,
                key: id,
                testId: id
            }));
        const onSelect = (_, selectedIndex)=>{
            setCurrentActiveTabIndex(selectedIndex);
        };
        const handleChange = (index)=>{
            onSelect(null, index);
        };
        if (!fieldTabs.length) return null;
        const ComponentToRender = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("cu7BW")).FieldsContainer) : (0, (0, parcelRequire("fGCY8")).default);
        return fieldTabs.length === 1 ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            fieldConfig: fieldConfig,
            fields: fieldTabs[0].items,
            ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                collapsedFields: fieldTabs[0].collapsedItems,
                FieldRenderer: (0, parcelRequire("fGCY8")).default,
                tabIndex: 0
            },
            apiLatency: apiLatency,
            getFormState: getFormState,
            setFieldValue: setFieldValue,
            fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fphHl")).default), {
            testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
            selected: currentActiveTabIndex,
            onChange: handleChange,
            id: "issue-create-modal-tabs",
            shouldUnmountTabPanelOnChange: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cte3m")).default), null, tabs.map((tab)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxIT3")).default), {
                testId: tab.testId,
                key: tab.key
            }, tab.label)))), fieldTabs.map(({ id: id, items: items, collapsedItems: collapsedItems }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($a6b4c30e66dfce2e$var$Container, {
                key: id,
                isHidden: index !== currentActiveTabIndex
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                fieldConfig: fieldConfig,
                fields: items,
                ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                    collapsedFields: collapsedItems,
                    FieldRenderer: (0, parcelRequire("fGCY8")).default,
                    tabIndex: index
                },
                getFormState: getFormState,
                setFieldValue: setFieldValue,
                apiLatency: apiLatency,
                fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
            }))));
    };
    const $a6b4c30e66dfce2e$export$d919d8b7913413b3 = (props)=>{
        (0, (0, parcelRequire("gKZoD")).di)((0, (0, parcelRequire("fGCY8")).default), (0, (0, parcelRequire("cu7BW")).FieldsContainer));
        const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency } = props;
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
        const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const tabs = (0, $5uXOq.useMemo)(()=>fieldTabs.map(({ id: id, tabId: tabId, name: name, items: items, collapsedItems: collapsedItems })=>({
                    id: tabId || id,
                    name: name,
                    content: null,
                    testId: id,
                    items: items,
                    collapsedItems: collapsedItems
                })), [
            fieldTabs
        ]);
        const onSelect = (_, selectedIndex)=>{
            setCurrentActiveTabIndex(selectedIndex);
        };
        const handleChange = (index)=>{
            onSelect(null, index);
        };
        const { hasValidationErrors: hasValidationErrors, submitFailed: submitFailed } = getFormState();
        const { controlledTabs: controlledTabs, controlledSelected: controlledSelected, controlledOnChange: controlledOnChange } = (0, (0, parcelRequire("a6X31")).useScreenTabs)({
            tabs: tabs,
            viewProps: {
                shouldDisableScreenTabsControl: hasValidationErrors && submitFailed
            },
            selected: currentActiveTabIndex,
            onChange: handleChange
        });
        if (!fieldTabs.length) return null;
        const ComponentToRender = (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? (0, (0, parcelRequire("cu7BW")).FieldsContainer) : (0, (0, parcelRequire("fGCY8")).default);
        if (fieldTabs.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
            fieldConfig: fieldConfig,
            fields: fieldTabs[0].items,
            ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                collapsedFields: fieldTabs[0].collapsedItems,
                FieldRenderer: (0, parcelRequire("fGCY8")).default,
                tabIndex: 0
            },
            apiLatency: apiLatency,
            getFormState: getFormState,
            setFieldValue: setFieldValue,
            fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fphHl")).default), {
            testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
            selected: controlledSelected,
            onChange: controlledOnChange,
            id: "issue-create-modal-tabs",
            shouldUnmountTabPanelOnChange: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cte3m")).default), null, controlledTabs.map((tab)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2jBOL")).ConditionallyVisibleDiv), {
                key: tab.id,
                isVisible: tab.isVisible
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxIT3")).default), {
                testId: tab.testId,
                key: tab.id
            }, tab.name))))), controlledTabs.map(({ id: id, items: items, collapsedItems: collapsedItems, testId: testId }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2jBOL")).ConditionallyVisibleDiv), {
                id: `issue-create-modal-tabs-${index}-tab`,
                role: "tabpanel",
                key: id,
                isVisible: index === controlledSelected,
                testId: `tab-content-${testId}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentToRender, {
                fieldConfig: fieldConfig,
                fields: items,
                ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                    collapsedFields: collapsedItems,
                    FieldRenderer: (0, parcelRequire("fGCY8")).default,
                    tabIndex: index
                },
                getFormState: getFormState,
                setFieldValue: setFieldValue,
                apiLatency: apiLatency,
                fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
            }))));
    };
    const $a6b4c30e66dfce2e$var$LayoutRenderer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('forge_ui_modifications_for_screen_tabs'), $a6b4c30e66dfce2e$export$d919d8b7913413b3, $a6b4c30e66dfce2e$export$31d936b98297daf0);
    var $a6b4c30e66dfce2e$export$2e2bcd8739ae039 = $a6b4c30e66dfce2e$var$LayoutRenderer;
    const $a6b4c30e66dfce2e$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1ule",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fphHl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4810d6c8b7d5c95d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6QvkM;
    var $dWD6q;
    var $8emiI;
    function $4810d6c8b7d5c95d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $4810d6c8b7d5c95d$var$baseStyles = {
        name: "7i0hsw",
        styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
    };
    const $4810d6c8b7d5c95d$var$tabsStyles = (0, (0, parcelRequire("8emiI")).getTabsStyles)();
    const $4810d6c8b7d5c95d$var$analyticsAttributes = {
        componentName: 'tabs',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>tabPanel && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabPanelContext).Provider, {
            value: {
                role: 'tabpanel',
                id: `${tabsId}-${index}-tab`,
                hidden: isSelected ? undefined : true,
                'aria-labelledby': `${tabsId}-${index}`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tabPanel);
    const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
        const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
        const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
        const selected = SelectedType === undefined ? selectedState : SelectedType;
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter((child)=>Boolean(child));
        const [tabList, ...tabPanels] = childrenArray;
        const visited = (0, $5uXOq.useRef)(new Set([
            selected
        ]));
        if (!visited.current.has(selected)) visited.current.add(selected);
        const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
            if (onChangeProp) onChangeProp(index, analyticsEvent);
            setSelected(index);
        }, [
            onChangeProp
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("6QvkM")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'clicked',
            analyticsData: analyticsContext,
            ...$4810d6c8b7d5c95d$var$analyticsAttributes
        });
        const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[selected],
            index: selected,
            isSelected: true,
            tabsId: id
        }) : Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
                tabPanel: tabPanels[tabIndex],
                index: tabIndex,
                isSelected: tabIndex === selected,
                tabsId: id
            }));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $4810d6c8b7d5c95d$var$baseStyles,
                $4810d6c8b7d5c95d$var$tabsStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabListContext).Provider, {
            value: {
                selected: selected,
                onChange: onChangeAnalytics,
                tabsId: id
            }
        }, tabList), (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, tabPanelsWithContext)));
    };
    var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;
});
parcelRegister("dWD6q", function(module, exports) {
    $parcel$export(module.exports, "TabContext", ()=>$b47499898157cfdc$export$5a5d356ca5f10a0a);
    $parcel$export(module.exports, "TabListContext", ()=>$b47499898157cfdc$export$aa6907f9fd69e93b);
    $parcel$export(module.exports, "TabPanelContext", ()=>$b47499898157cfdc$export$2054129d247c3102);
    var $5uXOq = parcelRequire("5uXOq");
    const $b47499898157cfdc$export$5a5d356ca5f10a0a = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$aa6907f9fd69e93b = (0, $5uXOq.createContext)(null);
    const $b47499898157cfdc$export$2054129d247c3102 = (0, $5uXOq.createContext)(null);
});
parcelRegister("8emiI", function(module, exports) {
    $parcel$export(module.exports, "getTabsStyles", ()=>$899bec80a30728c7$export$dd5afd2190fb792c);
    $parcel$export(module.exports, "getTabListStyles", ()=>$899bec80a30728c7$export$42a3c683c377bcb2);
    $parcel$export(module.exports, "getTabListStylesOld", ()=>$899bec80a30728c7$export$f208f8acf591dbc2);
    var $f8Sb3;
    var $6VxaK;
    const $899bec80a30728c7$var$tabInlinePadding = "var(--ds-space-100, 8px)";
    const $899bec80a30728c7$var$tabBlockPadding = "var(--ds-space-075, 6px)";
    const $899bec80a30728c7$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
    const $899bec80a30728c7$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
    const $899bec80a30728c7$var$getTabPanelStyles = ()=>({
            flexGrow: 1,
            minHeight: '0%',
            display: 'flex'
        });
    const $899bec80a30728c7$export$dd5afd2190fb792c = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tabpanel"]': $899bec80a30728c7$var$getTabPanelStyles(),
            '& > [hidden]': {
                display: 'none'
            }
        });
    const $899bec80a30728c7$var$tabLineStyles = {
        content: '""',
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$42a3c683c377bcb2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$916c8b0fccbb37d2(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStyles,
                height: "var(--ds-border-width, 1px)",
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$916c8b0fccbb37d2 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStyles,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
    const $899bec80a30728c7$var$tabLineStylesOld = {
        content: '""',
        borderRadius: "var(--ds-border-radius-050, 2px)",
        bottom: 0,
        margin: 0,
        position: 'absolute',
        width: 'inherit',
        insetInlineStart: $899bec80a30728c7$var$tabInlinePadding,
        insetInlineEnd: 0
    };
    const $899bec80a30728c7$export$f208f8acf591dbc2 = ()=>(0, (0, parcelRequire("f8Sb3")).css)({
            '& [role="tab"]': $899bec80a30728c7$export$442d081208938078(),
            fontWeight: "var(--ds-font-weight-medium, 500)",
            marginInlineStart: $899bec80a30728c7$var$tabInlineMargin,
            '&::before': {
                ...$899bec80a30728c7$var$tabLineStylesOld,
                height: $899bec80a30728c7$var$underlineHeight,
                backgroundColor: (0, (0, parcelRequire("6VxaK")).tabLineColors).lineColor
            }
        });
    const $899bec80a30728c7$export$442d081208938078 = ()=>{
        const colors = (0, (0, parcelRequire("6VxaK")).tabColors);
        return {
            color: colors.labelColor,
            cursor: 'pointer',
            margin: 0,
            padding: `${$899bec80a30728c7$var$tabBlockPadding} ${$899bec80a30728c7$var$tabInlinePadding}`,
            position: 'relative',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            '&:hover': {
                color: colors.hoverLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).hoveredColor}`,
                    height: 0
                }
            },
            '&:active': {
                color: colors.activeLabelColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).activeColor}`,
                    height: 0
                }
            },
            '&[aria-selected="true"]': {
                color: colors.selectedColor,
                '&::after': {
                    ...$899bec80a30728c7$var$tabLineStylesOld,
                    insetInlineEnd: $899bec80a30728c7$var$tabInlinePadding,
                    borderBottom: `${$899bec80a30728c7$var$underlineHeight} solid ${(0, (0, parcelRequire("6VxaK")).tabLineColors).selectedColor}`,
                    height: 0
                }
            }
        };
    };
});
parcelRegister("6VxaK", function(module, exports) {
    $parcel$export(module.exports, "tabColors", ()=>$874e3836572be4cc$export$5159a1ad8efe50bc);
    $parcel$export(module.exports, "tabLineColors", ()=>$874e3836572be4cc$export$6be6fa4649b31472);
    const $874e3836572be4cc$export$5159a1ad8efe50bc = {
        labelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        activeLabelColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`,
        hoverLabelColor: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        selectedColor: `var(--ds-text-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`,
        focusBorderColor: `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`
    };
    const $874e3836572be4cc$export$6be6fa4649b31472 = {
        lineColor: `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`,
        hoveredColor: "var(--ds-border, transparent)",
        activeColor: "var(--ds-border, transparent)",
        selectedColor: `var(--ds-border-selected, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    };
});
parcelRegister("jxIT3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a23bdf24c904bdb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $jhVLw;
    var $cgL5K;
    var $eQ4wW;
    const $5a23bdf24c904bdb$var$Tab = (0, $5uXOq.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
        const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, (0, parcelRequire("eQ4wW")).useTab)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            onClick: onClick,
            id: id,
            "aria-controls": ariaControls,
            "aria-posinset": ariaPosinset,
            "aria-selected": ariaSelected,
            "aria-setsize": ariaSetsize,
            onKeyDown: onKeyDown,
            role: role,
            tabIndex: tabIndex,
            ref: ref
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("cgL5K")).default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1
        }, children)));
    });
    var $5a23bdf24c904bdb$export$2e2bcd8739ae039 = $5a23bdf24c904bdb$var$Tab;
});
parcelRegister("eQ4wW", function(module, exports) {
    $parcel$export(module.exports, "useTab", ()=>$4d8616502e4de6b0$export$fdf4756d5b8ef90a);
    $parcel$export(module.exports, "useTabList", ()=>$4d8616502e4de6b0$export$773e389e644c5874);
    $parcel$export(module.exports, "useTabPanel", ()=>$4d8616502e4de6b0$export$fae0121b5afe572d);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWD6q;
    const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
        const tabData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabContext));
        if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
        return tabData;
    };
    const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
        const tabListData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabListContext));
        if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
        return tabListData;
    };
    const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
        const tabPanelData = (0, $5uXOq.useContext)((0, (0, parcelRequire("dWD6q")).TabPanelContext));
        if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
        return tabPanelData;
    };
});
parcelRegister("cte3m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e15f9538b451f314$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $VSDnB;
    var $eQ4wW;
    var $dWD6q;
    var $8emiI;
    function $e15f9538b451f314$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e15f9538b451f314$var$baseStyles = {
        name: "g0wsdz",
        styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
    };
    const $e15f9538b451f314$var$tabListStyles = (0, (0, parcelRequire("8emiI")).getTabListStyles)();
    const $e15f9538b451f314$var$tabListStylesOld = (0, (0, parcelRequire("8emiI")).getTabListStylesOld)();
    const $e15f9538b451f314$var$TabList = ({ children: children })=>{
        const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, (0, parcelRequire("eQ4wW")).useTabList)();
        const ref = (0, $5uXOq.createRef)();
        const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
        const length = childrenArray.length;
        const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
            const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
            if (newSelectedNode) newSelectedNode.focus();
            onChange(index);
        }, [
            tabsId,
            ref,
            onChange
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (![
                'ArrowRight',
                'ArrowLeft',
                'Home',
                'End'
            ].includes(e.key)) return;
            e.preventDefault();
            const lastTabIndex = length - 1;
            if ([
                'Home',
                'End'
            ].includes(e.key)) {
                const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
                selectTabByIndex(newSelected);
                return;
            }
            const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
            const modifier = e.key === 'ArrowRight' ? 1 : -1;
            let newSelected = selectedIndex + modifier;
            if (newSelected < 0 || newSelected >= length) newSelected = newSelected < 0 ? lastTabIndex : 0;
            selectTabByIndex(newSelected);
        }, [
            length,
            selectTabByIndex
        ]);
        const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dWD6q")).TabContext).Provider, {
                value: {
                    onClick: ()=>onChange(index),
                    onKeyDown: onKeyDown,
                    'aria-setsize': length,
                    role: 'tab',
                    id: `${tabsId}-${index}`,
                    'aria-posinset': index + 1,
                    'aria-selected': isSelected,
                    'aria-controls': `${tabsId}-${index}-tab`,
                    tabIndex: isSelected ? 0 : -1
                },
                key: index
            }, tab), [
            length,
            onKeyDown,
            onChange,
            tabsId
        ]);
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "tablist",
            ref: ref,
            css: [
                $e15f9538b451f314$var$baseStyles,
                (0, (0, parcelRequire("VSDnB")).fg)('platform-component-visual-refresh') ? $e15f9538b451f314$var$tabListStyles : $e15f9538b451f314$var$tabListStylesOld
            ]
        }, childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))));
    };
    var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;
});
parcelRegister("a6X31", function(module, exports) {
    $parcel$export(module.exports, "useScreenTabs", ()=>$cb7e56e646f5ab97$export$64c8d02894d27e32);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $laCJ2;
    var $in0JC;
    var $f4drY;
    var $asu2W;
    var $i0uwa;
    const $cb7e56e646f5ab97$export$64c8d02894d27e32 = ({ tabs: tabs, viewProps: viewProps, selected: selected, onChange: onChange })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const viewType = (0, (0, parcelRequire("f4drY")).useViewType)();
        const [adjustedScreenTabs, { initializeNoScreenTab: initializeNoScreenTab, initializeScreenTabs: initializeScreenTabs, updateActiveScreenTab: updateActiveScreenTab }] = (0, (0, parcelRequire("asu2W")).useAdjustedScreenTabs)();
        const memoizedTabs = (0, (0, parcelRequire("i0uwa")).useMemoizedTabs)(tabs);
        const [triggerFieldInitializationKey] = (0, (0, parcelRequire("in0JC")).useTriggerFieldInitialization)();
        const selectedRef = (0, $5uXOq.useRef)(selected);
        selectedRef.current = selected;
        (0, $5uXOq.useEffect)(()=>{
            if (!adjustmentsAreEnabled) return;
            if (!memoizedTabs.length && !selectedRef.current) {
                initializeNoScreenTab();
                return;
            }
            if (memoizedTabs.length === 1) {
                initializeScreenTabs({
                    tabs: [],
                    selected: 0
                });
                return;
            }
            initializeScreenTabs({
                tabs: memoizedTabs,
                selected: selectedRef.current
            });
        }, [
            adjustmentsAreEnabled,
            viewType,
            memoizedTabs,
            initializeNoScreenTab,
            initializeScreenTabs,
            createAnalyticsEvent,
            triggerFieldInitializationKey
        ]);
        const controlledTabs = (0, $5uXOq.useMemo)(()=>{
            if (adjustmentsAreEnabled && Array.isArray(adjustedScreenTabs)) {
                const adjustedVisibilityMap = {};
                for (const adjustedScreenTab of adjustedScreenTabs)adjustedVisibilityMap[adjustedScreenTab.id] = adjustedScreenTab.isVisible;
                return tabs.map((inputTab)=>({
                        ...inputTab,
                        isVisible: adjustedVisibilityMap[inputTab.id] ?? true
                    }));
            }
            return tabs.map((inputTab)=>({
                    ...inputTab,
                    isVisible: true
                }));
        }, [
            adjustmentsAreEnabled,
            tabs,
            adjustedScreenTabs
        ]);
        const controlledSelected = (0, $5uXOq.useMemo)(()=>{
            if (!adjustmentsAreEnabled || !Array.isArray(adjustedScreenTabs) || !adjustedScreenTabs.length || viewProps?.shouldDisableScreenTabsControl) return selected;
            const activeAdjustedTab = adjustedScreenTabs.find((tab)=>tab.isActive);
            if (activeAdjustedTab) return memoizedTabs.findIndex((tab)=>tab.id === activeAdjustedTab.id);
            return selected;
        }, [
            adjustmentsAreEnabled,
            adjustedScreenTabs,
            viewProps?.shouldDisableScreenTabsControl,
            memoizedTabs,
            selected
        ]);
        const controlledOnChange = (0, $5uXOq.useCallback)((...args)=>{
            const [userNewSelected] = args;
            if (adjustmentsAreEnabled) updateActiveScreenTab({
                selected: userNewSelected
            });
            onChange?.(...args);
        }, [
            adjustmentsAreEnabled,
            onChange,
            updateActiveScreenTab
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (memoizedTabs.length > 0 && typeof controlledSelected === 'number' && controlledSelected !== selected) onChange?.(controlledSelected, createAnalyticsEvent({}));
        }, [
            controlledSelected,
            memoizedTabs,
            selected,
            onChange,
            createAnalyticsEvent
        ]);
        return {
            controlledTabs: controlledTabs,
            controlledSelected: controlledSelected,
            controlledOnChange: controlledOnChange
        };
    };
});
parcelRegister("in0JC", function(module, exports) {
    $parcel$export(module.exports, "useTriggerFieldInitialization", ()=>$6605e17eb4b9cb32$export$1c69013aaf9112f0);
    var $3sQ5x;
    var $asu2W;
    const $6605e17eb4b9cb32$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
    const $6605e17eb4b9cb32$export$1c69013aaf9112f0 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: $6605e17eb4b9cb32$var$selectTriggerFieldInitializationKey
    });
});
parcelRegister("f4drY", function(module, exports) {
    $parcel$export(module.exports, "useViewType", ()=>$7f36892f75f5122e$export$1568c16ff8af07a3);
    var $3sQ5x;
    var $asu2W;
    const $7f36892f75f5122e$export$1568c16ff8af07a3 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: (state)=>state.viewType
    });
});
parcelRegister("i0uwa", function(module, exports) {
    $parcel$export(module.exports, "useMemoizedTabs", ()=>$5028364015e9889a$export$df1fb9a4d15ebe6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $5028364015e9889a$var$mapTabKnownProps = (tabs)=>tabs.map(({ id: id })=>({
                id: id
            }));
    function $5028364015e9889a$export$df1fb9a4d15ebe6a(tabs) {
        const memoizedTabsRef = (0, $5uXOq.useRef)(tabs);
        return (0, $5uXOq.useMemo)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))($5028364015e9889a$var$mapTabKnownProps(memoizedTabsRef.current), $5028364015e9889a$var$mapTabKnownProps(tabs))) {
                memoizedTabsRef.current = tabs;
                return tabs;
            }
            return memoizedTabsRef.current;
        }, [
            tabs
        ]);
    }
});
parcelRegister("2jBOL", function(module, exports) {
    $parcel$export(module.exports, "ConditionallyVisibleDiv", ()=>$2d694a313665eb9b$export$f154ce6a32df6563);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $2d694a313665eb9b$var$conditionallyVisibleStyles = {
        visible: "_1e0c1ule",
        hidden: "_1e0cglyw"
    };
    function $2d694a313665eb9b$export$f154ce6a32df6563({ isVisible: isVisible = true, children: children, testId: testId, id: id, role: role }) {
        return $5uXOq.createElement("div", {
            id: id,
            role: role,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $2d694a313665eb9b$var$conditionallyVisibleStyles[isVisible ? 'visible' : 'hidden']
            ])
        }, children);
    }
});
parcelRegister("fGCY8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9f7b5ef8416e3ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9XE6b = parcelRequire("9XE6b");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $gSA3s;
    var $7CMCs;
    var $4R6GH;
    var $gifeQ;
    var $bPtOr;
    var $mTNgq;
    var $gEaAu;
    var $45Cy1;
    var $5rzqz;
    var $8zOmE;
    var $2NMNM;
    var $huY3x;
    var $lsFXb;
    var $gItVn;
    var $8XY8j;
    var $kHA0a;
    var $6gjIc;
    var $4UG9N;
    var $3uUt4;
    const $e9f7b5ef8416e3ce$var$useMemoizedGetFormState = (getFormState)=>{
        const ref = (0, $5uXOq.useRef)(getFormState);
        (0, $5uXOq.useMemo)(()=>{
            if (ref.current) return;
            ref.current = getFormState;
        }, [
            getFormState
        ]);
        return ref.current;
    };
    const $e9f7b5ef8416e3ce$export$90edc2cad754ca2e = (props)=>{
        const { onFieldMount: onFieldMount, onKeyDown: onKeyDown, fieldId: fieldId, componentProps: componentProps, Component: Component, apiLatency: apiLatency, isSubsequentLoad: isSubsequentLoad, issueAdjustmentModules: issueAdjustmentModules, wasStateRestored: wasStateRestored } = props;
        const [, { setIsFormLoaded: setIsFormLoaded }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const isMountEventFired = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isMountEventFired.current === false) {
                isMountEventFired.current = true;
                if ('requestIdleCallback' in window) window.requestIdleCallback(()=>onFieldMount(fieldId), {
                    timeout: 50
                });
                else setTimeout(()=>{
                    onFieldMount(fieldId);
                }, 50);
            }
        }, [
            onFieldMount,
            fieldId
        ]);
        const onLayoutDone = (0, $5uXOq.useCallback)(()=>{
            const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
            if (globalIssueCreateModalLoadMetric.state === 'started') {
                const stopTime = Math.floor(performance.now());
                const customData = {
                    apiLatency: apiLatency,
                    featureFlags: Object.fromEntries((0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed)),
                    tti: Math.floor(stopTime - globalIssueCreateModalLoadMetric.startTime),
                    isFirstTime: !isSubsequentLoad,
                    wasStateRestored: wasStateRestored
                };
                globalIssueCreateModalLoadMetric.stop({
                    customData: customData
                });
                (0, (0, parcelRequire("huY3x")).markGicTti)();
            }
            setIsFormLoaded(true);
        }, [
            apiLatency,
            isSubsequentLoad,
            setIsFormLoaded,
            wasStateRestored
        ]);
        const extendedComponentProps = {
            ...componentProps,
            onLayoutDone: onLayoutDone
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$var$FieldContainer, {
            onKeyDown: onKeyDown,
            key: fieldId,
            id: `${fieldId}-container`,
            "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
        }, issueAdjustmentModules.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "globalIssueCreateIssueAdjustmentsAdapter",
            packageName: "issueCreateModal",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null), (0, ($parcel$interopDefault($5uXOq))).createElement(Component, extendedComponentProps)),
            sendToPrivacyUnsafeSplunk: true,
            attributes: (error)=>({
                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                    viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                    fieldType: extendedComponentProps.fieldType,
                    fieldId: fieldId
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lsFXb")).FieldDecoratorAsync), {
            Component: Component,
            componentProps: extendedComponentProps
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement(Component, extendedComponentProps));
    };
    const $e9f7b5ef8416e3ce$var$FieldRendererBase = (props)=>{
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue, isSubsequentLoad: isSubsequentLoad, minimizableModalView: minimizableModalView, wasStateRestored: wasStateRestored, isMiniDesignEnabled: isMiniDesignEnabled, FieldWrapperComponent: FieldWrapperComponent, isModalOpen: isModalOpen }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { fieldConfig: fieldConfig, getFormState: getFormState, apiLatency: apiLatency, setFieldValue: setFieldValue, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive } = props;
        let fields = props.fields;
        if ((0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_fields_from_gic')) fields = fields.filter((fieldId)=>{
            const { gqlType: gqlType } = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, fieldId, {});
            return gqlType !== (0, $962656cd6986cb06$export$8723b724f0b3ac65) && gqlType !== (0, $962656cd6986cb06$export$670384150af5f49e);
        });
        const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
        const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, shouldAutoFocus: shouldAutoFocus, ecosystem: { forge: { customFields: customFields, filteredOutModules: filteredOutModules, issueAdjustmentModules: issueAdjustmentModules, hasFinishedLoading: hasFinishedLoading } }, currentActiveTabIndex: currentActiveTabIndex }, { setIsOperationInProgress: setIsOperationInProgress }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const renderAllFieldsInTabStartTime = (0, $5uXOq.useRef)(0);
        const [fieldsToRenderCount, setFieldsToRenderCount] = (0, $5uXOq.useState)(1);
        const fieldsMountedCount = (0, $5uXOq.useRef)(0);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
        const renderedAllFields = (0, $5uXOq.useRef)(false);
        const getFormStateMemoized = $e9f7b5ef8416e3ce$var$useMemoizedGetFormState(getFormState);
        (0, $5uXOq.useEffect)(()=>{
            renderAllFieldsInTabStartTime.current = performance.now();
            setIsOperationInProgress(true);
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderAllFieldsInTabStart', {});
            renderedAllFields.current = false;
        }, [
            setIsOperationInProgress,
            createAnalyticsEvent
        ]);
        const fieldsLength = fields.length;
        const fieldsRendererSessionId = (0, $5uXOq.useRef)('');
        const fieldsAlreadyFullyLoaded = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (!isModalOpen) return;
            fieldsRendererSessionId.current = (0, ($parcel$interopDefault($7Jxgt))).v4();
            fieldsAlreadyFullyLoaded.current = false;
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsToRenderTab', {
                fieldsLength: fieldsLength,
                fieldsRendererSessionId: fieldsRendererSessionId.current
            });
        }, [
            createAnalyticsEvent,
            fieldsLength,
            isModalOpen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isModalOpen || fieldsToRenderCount < fieldsLength || fieldsAlreadyFullyLoaded.current) return;
            fieldsAlreadyFullyLoaded.current = true;
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsFullyRenderedTab', {
                fieldsLength: fieldsLength,
                fieldsRendererSessionId: fieldsRendererSessionId.current
            });
        }, [
            createAnalyticsEvent,
            fieldsLength,
            fieldsToRenderCount,
            isModalOpen
        ]);
        const onFieldMount = ()=>{
            fieldsMountedCount.current += 1;
            if (fieldsMountedCount.current >= fieldsToRenderCount) setFieldsToRenderCount((currentCount)=>currentCount + (0, (0, parcelRequire("3uUt4")).getFieldsToRenderInOneBatch)(fields.length));
            if (fieldsMountedCount.current >= fields.length && !renderedAllFields.current) {
                setIsOperationInProgress(false);
                const analyticsEvent = createAnalyticsEvent({});
                const attributes = {
                    timeToRenderAllFieldsInTabMs: Math.floor(performance.now() - renderAllFieldsInTabStartTime.current),
                    fields: fields
                };
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderedAllFieldsInTab', attributes);
                renderedAllFields.current = true;
            }
            (0, (0, parcelRequire("huY3x")).globalIssueCreateTTIWithAdjustments).mark('gic-all-fields-loaded');
        };
        const fieldsToRender = fields.slice(0, fieldsToRenderCount).map((fieldId, index)=>{
            let content = null;
            const { gqlType: gqlType, ...rest } = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, fieldId, {});
            const { fieldName: fieldName, description: description, isRequired: isRequired, fieldType: fieldType } = rest;
            const FieldDetails = (0, (0, parcelRequire("gItVn")).getGqlFieldMap)()[gqlType];
            const extraProps = {
                autoFocus: index === 0 && currentActiveTabIndex === 0 && (0, (0, parcelRequire("4UG9N")).FIELDS_WITHOUT_DROPDOWN_MENU).includes(gqlType) && shouldAutoFocus,
                isSubTaskCreationOpen: isSubTaskCreationOpen,
                isDropdownMenuFixedAndLayered: true,
                selectedProject: (0, (0, parcelRequire("4UG9N")).FIELDS_WITH_SELECTED_PROJECT).includes(gqlType) ? selectedProject : undefined,
                selectedIssueType: (0, (0, parcelRequire("4UG9N")).FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType) ? selectedIssueType : undefined,
                useFormContext: (0, (0, parcelRequire("4UG9N")).FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType) ? (0, (0, parcelRequire("45Cy1")).useFormContext) : undefined,
                componentKey: (0, (0, parcelRequire("4UG9N")).FORCE_RENDER_ON_TAB_CHANGE).includes(gqlType) ? `${fieldId}-${currentActiveTabIndex}` : undefined,
                contextAndValuesOfIssueBeingCreated: (0, (0, parcelRequire("4UG9N")).FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType) ? {
                    getFormState: getFormState,
                    selectedIssueType: selectedIssueType,
                    fieldConfig: fieldConfig
                } : undefined,
                getFormState: (0, (0, parcelRequire("4UG9N")).FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType) ? getFormStateMemoized : undefined,
                onInProgressChange: (0, (0, parcelRequire("4UG9N")).FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType) ? setIsOperationInProgress : undefined,
                forge: fieldType !== undefined && (0, (0, parcelRequire("gifeQ")).isForgeCustomField)(fieldType) ? {
                    selectedProject: selectedProject,
                    selectedIssueType: selectedIssueType,
                    modules: customFields,
                    filteredOutModules: filteredOutModules,
                    hasFinishedLoading: hasFinishedLoading
                } : undefined,
                fieldHelpTextUrl: (0, (0, parcelRequire("3uUt4")).getHelpTextUrl)(gqlType),
                onLinkClickEvent: (0, (0, parcelRequire("3uUt4")).getOnLinkClickEvent)(gqlType),
                isCreateLinkedIssue: (0, (0, parcelRequire("4UG9N")).FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO).includes(gqlType) && (0, (0, parcelRequire("4R6GH")).fg)('create_linked_issues_trigger_point_issue_view') ? isCreateLinkedIssue : false,
                isMini: isMini,
                ...(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && {
                    isCollapsed: isCollapsed,
                    isFieldResponsive: isFieldResponsive
                }
            };
            if (isGICPositioningEnabled() && fieldPropsExtensions?.[fieldType] && (0, (0, parcelRequire("4UG9N")).FIELDS_WITH_EXTENSION_PROPS).includes(gqlType)) Object.assign(extraProps, fieldPropsExtensions[fieldType]);
            if (FieldDetails) {
                const { Component: Component, defaultValueKey: defaultValueKey } = FieldDetails;
                const fieldContainerWrapperProps = {
                    ...defaultValueKey === 'parentIssue' ? {} : {
                        onKeyDown: (0, (0, parcelRequire("kHA0a")).preventEscKeyPropagationKeyPressHandler)
                    },
                    fieldId: fieldId,
                    componentProps: {
                        ...rest,
                        ...extraProps,
                        fieldName: fieldName,
                        description: description,
                        gqlType: gqlType,
                        fieldWrapperElement: FieldWrapperComponent ? (0, ($parcel$interopDefault($5uXOq))).createElement(FieldWrapperComponent, {
                            fieldId: fieldId,
                            field: (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, fieldId),
                            setFieldValue: setFieldValue
                        }) : null
                    },
                    Component: Component,
                    onFieldMount: onFieldMount,
                    apiLatency: apiLatency,
                    isSubsequentLoad: isSubsequentLoad,
                    issueAdjustmentModules: issueAdjustmentModules,
                    setFieldValue: setFieldValue,
                    wasStateRestored: wasStateRestored
                };
                content = (0, ($parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$export$90edc2cad754ca2e, {
                    key: fieldId,
                    ...fieldContainerWrapperProps
                });
            } else content = (0, ($parcel$interopDefault($5uXOq))).createElement($e9f7b5ef8416e3ce$var$FieldContainer, {
                key: fieldId,
                "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8XY8j")).default), {
                fieldId: fieldId,
                fieldName: fieldName,
                isRequired: isRequired,
                description: description,
                projectType: selectedProject?.projectType,
                gqlType: gqlType,
                fieldType: fieldType,
                onFieldMount: onFieldMount,
                isMini: isMini
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                id: `globalIssueCreateIssue-field-renderer-${fieldId}`,
                key: `field-renderer-${fieldId}`,
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                onError: ()=>{
                    onFieldMount();
                },
                sendToPrivacyUnsafeSplunk: true
            }, content);
        });
        return fieldsToRender;
    };
    const $e9f7b5ef8416e3ce$var$FieldRenderer = (0, $5uXOq.memo)($e9f7b5ef8416e3ce$var$FieldRendererBase);
    var $e9f7b5ef8416e3ce$export$2e2bcd8739ae039 = $e9f7b5ef8416e3ce$var$FieldRenderer;
    const $e9f7b5ef8416e3ce$var$FieldContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkv47k _1rys1caa",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lsFXb", function(module, exports) {
    $parcel$export(module.exports, "FieldDecoratorAsync", ()=>$d064e2dcd7969aea$export$7bf1fdc8d847e1ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCJ2;
    var $d9r6K;
    var $c4xpz;
    const $d064e2dcd7969aea$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const undecoratedComponent = (0, ($parcel$interopDefault($5uXOq))).createElement(Component, componentProps);
        if ((0, (0, parcelRequire("d9r6K")).isFieldTypeSupported)((0, $380826ec5efdda82$export$e615b7e9b8fb4715), componentProps.fieldType) && adjustmentsAreEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c4xpz")).EnabledFieldDecorator), {
            Component: Component,
            componentProps: componentProps
        });
        return undecoratedComponent;
    };
    const $d064e2dcd7969aea$export$7bf1fdc8d847e1ea = (0, $5uXOq.memo)($d064e2dcd7969aea$var$FieldDecoratorAsyncNoMemo);
});
parcelRegister("c4xpz", function(module, exports) {
    $parcel$export(module.exports, "EnabledFieldDecorator", ()=>$bfbc6dd25b19b3d5$export$a39682472306ffd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9oZc;
    var $in0JC;
    var $asu2W;
    var $9QJ7Z;
    var $3WUWf;
    var $50yDw;
    const $bfbc6dd25b19b3d5$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
        const { fieldId: fieldId, fieldName: fieldName, description: description, fieldType: fieldType, isRequired: isRequired = false, gqlType: fieldRenderer, allowedValues: allowedValues } = componentProps;
        const { setFieldValue: setFieldValue, getFieldValue: getFieldValue } = (0, (0, parcelRequire("9QJ7Z")).useFormApi)();
        const [state, { initializeField: initializeField, clearAppliedValue: clearAppliedValue }] = (0, (0, parcelRequire("asu2W")).useAdjustedField)(fieldId);
        const [triggerFieldInitializationKey] = (0, (0, parcelRequire("in0JC")).useTriggerFieldInitialization)();
        const isBusy = (0, (0, parcelRequire("l9oZc")).useFieldIsBusy)(fieldId);
        const isVisible = state.isVisible ?? true;
        const isReadOnly = state.isReadOnly ?? false;
        const isRequiredFromUIM = state.isRequired ?? false;
        (0, $5uXOq.useEffect)(()=>{
            const field = {
                fieldName: fieldName,
                fieldId: fieldId,
                description: description,
                isVisible: isVisible,
                fieldType: fieldType,
                isReadOnly: isReadOnly,
                isRequired: isRequired,
                allowedValues: allowedValues,
                value: getFieldValue(fieldId)
            };
            initializeField({
                field: field,
                metadata: {
                    fieldRenderer: fieldRenderer
                }
            });
        }, [
            triggerFieldInitializationKey,
            getFieldValue
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (state.value !== undefined) {
                setFieldValue(fieldId, state.value);
                clearAppliedValue(fieldId);
            }
        }, [
            state.value,
            clearAppliedValue,
            fieldId,
            setFieldValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3WUWf")).ConditionallyVisibleDiv), {
            key: fieldId,
            isVisible: isVisible,
            "data-testid": `ui-modifications-view-gic.ui.field-decorator.enabled-field-decorator.visibility-wrapper.${fieldId}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
            ...componentProps,
            ...(0, (0, parcelRequire("50yDw")).pickPropertiesToOverwrite)(state),
            ...isBusy ? {
                isReadOnly: true
            } : {},
            areUiModificationsBusy: isBusy,
            isRequiredFromUIM: isRequiredFromUIM
        }));
    };
    const $bfbc6dd25b19b3d5$export$a39682472306ffd4 = (0, $5uXOq.memo)($bfbc6dd25b19b3d5$var$EnabledFieldDecoratorNoMemo);
});
parcelRegister("l9oZc", function(module, exports) {
    $parcel$export(module.exports, "useFieldIsBusy", ()=>$a8af5bc7e618963f$export$b4ae28da91c35ed4);
    var $e5wyW;
    var $4R6GH;
    var $f8WR0;
    var $cEm4b;
    const $a8af5bc7e618963f$export$ff04c0f3c2623b5f = (fieldId)=>{
        const [isBusy] = (0, (0, parcelRequire("cEm4b")).useFieldIsProcessingOld)(fieldId);
        const currentUIModificationsConsentStatus = (0, (0, parcelRequire("f8WR0")).useUIModificationsConsentStatus)();
        if (currentUIModificationsConsentStatus === (0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38)) return false;
        return isBusy;
    };
    const $a8af5bc7e618963f$export$3b3523eb1f597b08 = (fieldId)=>{
        const [isBusyData] = (0, (0, parcelRequire("cEm4b")).useFieldIsProcessingV2)(fieldId);
        const uimConsentMap = (0, (0, parcelRequire("f8WR0")).useUIModificationsConsentStatusForApps)();
        const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
        if (!isBusy) return false;
        return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $2aeb8c12bc7d07a0$export$d67d63332ce3ce38));
    };
    const $a8af5bc7e618963f$export$b4ae28da91c35ed4 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps'), $a8af5bc7e618963f$export$3b3523eb1f597b08, $a8af5bc7e618963f$export$ff04c0f3c2623b5f);
});
parcelRegister("cEm4b", function(module, exports) {
    $parcel$export(module.exports, "useFieldIsProcessingOld", ()=>$8ce6de046c6d8106$export$ec0aa14c1e4bcb95);
    $parcel$export(module.exports, "useFieldIsProcessingV2", ()=>$8ce6de046c6d8106$export$fd447cdc5de90a78);
    var $hGgHi = parcelRequire("hGgHi");
    var $3sQ5x;
    var $6dDSs;
    var $asu2W;
    const $8ce6de046c6d8106$export$b58fa93ff3e11506 = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.registeredFieldsDeprecated, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChanges, error, fieldId)=>{
        if (error) return false;
        return !!Object.values(registeredChanges).find((registeredChange)=>registeredChange?.includes(fieldId));
    });
    const $8ce6de046c6d8106$export$faa2043a29f9e75e = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
        if (error) return {
            isBusy: false,
            appsIds: []
        };
        const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, ($parcel$interopDefault($hGgHi)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
        return {
            isBusy: appsIds.length > 0,
            appsIds: appsIds
        };
    });
    const $8ce6de046c6d8106$export$ec0aa14c1e4bcb95 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: $8ce6de046c6d8106$export$b58fa93ff3e11506
    });
    const $8ce6de046c6d8106$export$fd447cdc5de90a78 = (0, (0, parcelRequire("3sQ5x")).createHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: $8ce6de046c6d8106$export$faa2043a29f9e75e
    });
});
parcelRegister("3WUWf", function(module, exports) {
    $parcel$export(module.exports, "ConditionallyVisibleDiv", ()=>$3a0420afd8037073$export$f154ce6a32df6563);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $3a0420afd8037073$export$f154ce6a32df6563 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.isVisible ? "_1e0c1bgi" : "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("50yDw", function(module, exports) {
    $parcel$export(module.exports, "pickPropertiesToOverwrite", ()=>$aa8f37246cd10ceb$export$7aa61edf4d7c035e);
    const $aa8f37246cd10ceb$export$7aa61edf4d7c035e = (field)=>{
        const overwriteProperties = [
            'fieldName',
            'description',
            'isReadOnly',
            'isRequired',
            'allowedValues'
        ];
        return overwriteProperties.reduce((acc, propertyName)=>{
            const propertyValue = field[propertyName];
            if (propertyValue !== undefined) acc[propertyName] = propertyValue;
            return acc;
        }, {});
    };
});
parcelRegister("8XY8j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43ed78b611d1872f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $7O4UO;
    var $7nnPp;
    var $ctg8C;
    var $kY99m;
    var $ousew;
    var $45JN1;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $lf13e;
    var $hLxXk;
    const $43ed78b611d1872f$var$IncompatibleField = (props)=>{
        const isMountEventFired = (0, $5uXOq.useRef)(false);
        const [isInfoMessageOpen, setInfoMessageOpen] = (0, $5uXOq.useState)(false);
        const { fieldId: fieldId, fieldName: fieldName, isRequired: isRequired = false, description: description, projectType: projectType, gqlType: gqlType, fieldType: fieldType, onFieldMount: onFieldMount, isMini: isMini } = props;
        (0, $5uXOq.useEffect)(()=>{
            if (isMountEventFired.current === false) {
                isMountEventFired.current = true;
                onFieldMount(fieldId);
            }
        }, [
            onFieldMount,
            fieldId
        ]);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const closeInfoMessage = ()=>{
            setInfoMessageOpen(false);
        };
        const toggleInfoMessageVisibility = ()=>{
            if (isInfoMessageOpen === true) {
                closeInfoMessage();
                return;
            }
            setInfoMessageOpen(true);
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'inlineDialog',
                action: 'viewed'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'globalIssueCreateFieldUnsupported');
        };
        (0, $5uXOq.useEffect)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'unsupported newGicField', {
                gqlType: gqlType,
                projectType: projectType,
                fieldType: fieldType
            });
        }, [
            createAnalyticsEvent,
            projectType,
            gqlType,
            fieldType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            id: fieldId,
            label: fieldName,
            isRequired: isRequired,
            name: fieldId
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$InlineMessageContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$FieldContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY99m")).default), {
                isDisabled: true,
                "aria-labelledby": fieldProps['aria-labelledby']
            })), !(0, (0, parcelRequire("lf13e")).UNSUPPORTED_FIELD_TYPES).includes(fieldType) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
                sourceName: "globalIssueCreateFieldUnsupported"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($43ed78b611d1872f$var$MessageContainer, {
                    "data-testid": (0, (0, parcelRequire("lf13e")).MESSAGE_CONTAINER_TEST_ID)
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                    ...(0, (0, parcelRequire("hLxXk")).default).incompatibleFieldMessageNoOptionToSwitchToOldModal,
                    values: {
                        fieldName: fieldName,
                        b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                    }
                })),
                isOpen: isInfoMessageOpen,
                onClose: closeInfoMessage
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                spacing: "none",
                appearance: "subtle",
                onClick: toggleInfoMessageVisibility,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                    label: "incompatible-field-info",
                    size: "medium",
                    primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N200})`
                }),
                testId: (0, (0, parcelRequire("lf13e")).ERROR_ICON_TEST_ID)
            })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
                description: description,
                fieldName: fieldName,
                isMini: isMini
            })));
    };
    var $43ed78b611d1872f$export$2e2bcd8739ae039 = $43ed78b611d1872f$var$IncompatibleField;
    const $43ed78b611d1872f$var$InlineMessageContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $43ed78b611d1872f$var$FieldContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1edt _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $43ed78b611d1872f$var$MessageContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1sum",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lf13e", function(module, exports) {
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES", ()=>$c748dea82b133b5e$export$50417837a224cc14);
    $parcel$export(module.exports, "ERROR_ICON_TEST_ID", ()=>$c748dea82b133b5e$export$373c21cf926631ed);
    $parcel$export(module.exports, "MESSAGE_CONTAINER_TEST_ID", ()=>$c748dea82b133b5e$export$b8c8ab4bbeae7cb);
    const $c748dea82b133b5e$export$50417837a224cc14 = [
        'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype'
    ];
    const $c748dea82b133b5e$export$373c21cf926631ed = 'issue-create.common.ui.fields.incompatible-field.error-button';
    const $c748dea82b133b5e$export$b8c8ab4bbeae7cb = 'issue-create.common.ui.fields.incompatible-field.message-container';
});
parcelRegister("hLxXk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02e7e40b90384429$export$2e2bcd8739ae039);
    var $7VHMR;
    var $02e7e40b90384429$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        incompatibleFieldMessageNoOptionToSwitchToOldModal: {
            "id": "issue-create.common.fields.incompatible-field.incompatible-field-message-no-option-to-switch-to-old-modal",
            "defaultMessage": "The <b>{fieldName}</b> field is not supported on this screen."
        }
    });
});
parcelRegister("4UG9N", function(module, exports) {
    $parcel$export(module.exports, "FIELDS_WITH_SELECTED_PROJECT", ()=>$fd6752bfd5158bba$export$dd0837d091307e0f);
    $parcel$export(module.exports, "FIELDS_WITH_SELECTED_ISSUE_TYPE", ()=>$fd6752bfd5158bba$export$389f9f87389af956);
    $parcel$export(module.exports, "FIELDS_NEEDING_FORM_CONTEXT", ()=>$fd6752bfd5158bba$export$f6b349b9a22679bc);
    $parcel$export(module.exports, "FIELDS_WITH_ON_INPROGRESS_CHANGE", ()=>$fd6752bfd5158bba$export$f014d1ea91bf0c23);
    $parcel$export(module.exports, "FORCE_RENDER_ON_TAB_CHANGE", ()=>$fd6752bfd5158bba$export$27466286b235cb0f);
    $parcel$export(module.exports, "FIELDS_NEEDING_COMPLETE_FORM_STATE", ()=>$fd6752bfd5158bba$export$9af9321e2bc27e84);
    $parcel$export(module.exports, "FIELDS_NEEDING_GET_FORM_STATE", ()=>$fd6752bfd5158bba$export$249f6ad3f1dce1f);
    $parcel$export(module.exports, "RENDER_BATCH_SIZE_DENOMINATOR", ()=>$fd6752bfd5158bba$export$397fe8aa4d206ed5);
    $parcel$export(module.exports, "FIELDS_WITH_EXTENSION_PROPS", ()=>$fd6752bfd5158bba$export$88f0fb0471bfaaff);
    $parcel$export(module.exports, "FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO", ()=>$fd6752bfd5158bba$export$9ff19636928638c9);
    $parcel$export(module.exports, "FIELDS_WITHOUT_DROPDOWN_MENU", ()=>$fd6752bfd5158bba$export$bd64b3c9a1b1c867);
    const $fd6752bfd5158bba$export$dd0837d091307e0f = [
        (0, $962656cd6986cb06$export$8723b724f0b3ac65),
        (0, $962656cd6986cb06$export$31a6c27df1f927b2),
        (0, $962656cd6986cb06$export$30b2c2de5e3007a4),
        (0, $962656cd6986cb06$export$76d811609080a7aa),
        (0, $962656cd6986cb06$export$a9b3195cbef5c5ad),
        (0, $962656cd6986cb06$export$597fa240de2bfd92),
        (0, $962656cd6986cb06$export$3e8dded8d83b5d95),
        (0, $962656cd6986cb06$export$670384150af5f49e),
        (0, $962656cd6986cb06$export$bf9df74e065af482),
        (0, $962656cd6986cb06$export$d64150fd9c66969c),
        (0, $962656cd6986cb06$export$64238d76a1dc0703),
        (0, $962656cd6986cb06$export$eca94ae30cb92d8),
        (0, $962656cd6986cb06$export$3849bb04b4eee607),
        (0, $962656cd6986cb06$export$2bb9d057bad89bfa)
    ];
    const $fd6752bfd5158bba$export$389f9f87389af956 = [
        (0, $962656cd6986cb06$export$3e8dded8d83b5d95),
        (0, $962656cd6986cb06$export$bf9df74e065af482),
        (0, $962656cd6986cb06$export$31a6c27df1f927b2)
    ];
    const $fd6752bfd5158bba$export$f6b349b9a22679bc = [
        (0, $962656cd6986cb06$export$670384150af5f49e),
        (0, $962656cd6986cb06$export$8723b724f0b3ac65)
    ];
    const $fd6752bfd5158bba$export$f014d1ea91bf0c23 = [
        (0, $962656cd6986cb06$export$a9b3195cbef5c5ad)
    ];
    const $fd6752bfd5158bba$export$27466286b235cb0f = [
        (0, $962656cd6986cb06$export$64c7789e86344de5),
        (0, $962656cd6986cb06$export$5bb498d4f2f54799),
        (0, $962656cd6986cb06$export$d10237d945259f96),
        (0, $962656cd6986cb06$export$2055419ff013de79),
        (0, $962656cd6986cb06$export$3a1ae3e0f2d9b1b9),
        (0, $962656cd6986cb06$export$eca94ae30cb92d8),
        (0, $962656cd6986cb06$export$30b2c2de5e3007a4),
        (0, $962656cd6986cb06$export$76d811609080a7aa)
    ];
    const $fd6752bfd5158bba$export$9af9321e2bc27e84 = [
        (0, $962656cd6986cb06$export$597fa240de2bfd92),
        (0, $962656cd6986cb06$export$fc69de49ba08ae77)
    ];
    const $fd6752bfd5158bba$export$249f6ad3f1dce1f = [
        (0, $962656cd6986cb06$export$31a6c27df1f927b2)
    ];
    const $fd6752bfd5158bba$export$397fe8aa4d206ed5 = 10;
    const $fd6752bfd5158bba$export$88f0fb0471bfaaff = [
        (0, $962656cd6986cb06$export$31a6c27df1f927b2)
    ];
    const $fd6752bfd5158bba$export$9ff19636928638c9 = [
        (0, $962656cd6986cb06$export$47af4d6f62c134cf)
    ];
    const $fd6752bfd5158bba$export$bd64b3c9a1b1c867 = [
        (0, $962656cd6986cb06$export$23ca38ad884e35f1),
        (0, $962656cd6986cb06$export$7e5590c7c7a403c0),
        (0, $962656cd6986cb06$export$8643f0b9cefed538),
        (0, $962656cd6986cb06$export$31a6c27df1f927b2),
        (0, $962656cd6986cb06$export$e4d5e04bc56680dc),
        (0, $962656cd6986cb06$export$d854193d90dc547d),
        (0, $962656cd6986cb06$export$e0ece81bd398c799),
        (0, $962656cd6986cb06$export$95433ac963f4aebe),
        (0, $962656cd6986cb06$export$a138d5648dda03f0),
        (0, $962656cd6986cb06$export$aecc734a7c3591d7)
    ];
});
parcelRegister("3uUt4", function(module, exports) {
    $parcel$export(module.exports, "getHelpTextUrl", ()=>$9329503d8e8dcd8f$export$6d35186636f2563a);
    $parcel$export(module.exports, "getOnLinkClickEvent", ()=>$9329503d8e8dcd8f$export$ac33bccf00c7d438);
    $parcel$export(module.exports, "getFieldsToRenderInOneBatch", ()=>$9329503d8e8dcd8f$export$e76bcc0cbf9cc086);
    var $aSoqm;
    var $dNpFP;
    var $4UG9N;
    const $9329503d8e8dcd8f$var$isFieldWithLearnMoreLink = (gqlType)=>Object.keys((0, (0, parcelRequire("aSoqm")).FIELDS_LEARN_MORE_LINKS)).includes(gqlType);
    const $9329503d8e8dcd8f$export$6d35186636f2563a = (gqlType)=>{
        if ($9329503d8e8dcd8f$var$isFieldWithLearnMoreLink(gqlType)) return (0, (0, parcelRequire("aSoqm")).FIELDS_LEARN_MORE_LINKS)[gqlType];
        return undefined;
    };
    const $9329503d8e8dcd8f$export$ac33bccf00c7d438 = (gqlType)=>{
        if ($9329503d8e8dcd8f$var$isFieldWithLearnMoreLink(gqlType)) return 0, (0, parcelRequire("dNpFP")).openInNewTabLinkClickEventHandler;
        return undefined;
    };
    const $9329503d8e8dcd8f$export$e76bcc0cbf9cc086 = (totalFields)=>Math.max(Math.floor(totalFields / (0, (0, parcelRequire("4UG9N")).RENDER_BATCH_SIZE_DENOMINATOR)), 10);
});
parcelRegister("dNpFP", function(module, exports) {
    $parcel$export(module.exports, "openInNewTabLinkClickEventHandler", ()=>$7a8e9940c4106313$export$90d78a8969dab02);
    const $7a8e9940c4106313$export$90d78a8969dab02 = (event)=>{
        const eventTarget = event.target;
        if (eventTarget instanceof HTMLAnchorElement) eventTarget.target = '_blank';
    };
});
parcelRegister("cu7BW", function(module, exports) {
    $parcel$export(module.exports, "FieldsContainer", ()=>$36c96cecf539181f$export$8cdf7afbd261e53d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $e4yMr;
    var $dC5iT;
    var $cgL5K;
    var $8CUq3;
    var $6s1PB;
    var $4R6GH;
    var $5Zxxp;
    var $koVbs;
    var $1F7mG;
    var $45Cy1;
    var $iUFy5;
    var $8zOmE;
    var $2m0b6;
    var $6DnvJ;
    var $EePad;
    const $36c96cecf539181f$export$2fe52feffe568f84 = '3svLIYAFXrcqQlJXtqEc6G';
    const $36c96cecf539181f$var$DEFAULT_USE_MINIMIZABLE_MODAL_RESULT = {
        view: 'modal',
        setView: (0, ($parcel$interopDefault($8Rkzz))),
        setShouldFocusChanger: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $36c96cecf539181f$export$8cdf7afbd261e53d = (props)=>{
        const { fields: propFields, collapsedFields: propsCollapsedFields = [], FieldRenderer: FieldRenderer, tabIndex: tabIndex = 0, ...rest } = props;
        const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const uiModificationsStatus = (0, (0, parcelRequire("1F7mG")).useUiModificationsEnabledStatus)(hasFinishedLoading);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { collapsedFields: collapsedFields, fields: fields } = (0, $5uXOq.useMemo)(()=>{
            let collapsedFieldsFound = uiModificationsStatus !== 'enabled' ? propsCollapsedFields : [];
            let fieldsFound = propFields.filter((field)=>!collapsedFieldsFound.includes(field));
            if (!fieldsFound.length && collapsedFieldsFound.length) {
                fieldsFound = collapsedFieldsFound;
                collapsedFieldsFound = [];
            }
            return {
                collapsedFields: collapsedFieldsFound,
                fields: fieldsFound
            };
        }, [
            propFields,
            propsCollapsedFields,
            uiModificationsStatus
        ]);
        const [isExpanded, { setExpandedCollapsedArea: setExpandedCollapsedArea }] = (0, (0, parcelRequire("45Cy1")).useIsCollapsedAreaExpanded)(tabIndex);
        const isCollapsed = (0, $5uXOq.useRef)(!isExpanded);
        const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? (0, (0, parcelRequire("iUFy5")).useMinimizableModal)() : $36c96cecf539181f$var$DEFAULT_USE_MINIMIZABLE_MODAL_RESULT;
        const openInProductHelp = (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? (0, (0, parcelRequire("5Zxxp")).useHelpPanelLink)() : (0, ($parcel$interopDefault($8Rkzz)));
        const handleOnReadMoreClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            if (view === 'modal') {
                setShouldFocusChanger?.(true);
                setView?.('mini');
            }
            openInProductHelp?.($36c96cecf539181f$export$2fe52feffe568f84);
        }, [
            view,
            openInProductHelp,
            setShouldFocusChanger,
            setView
        ]);
        if (!FieldRenderer) return null;
        const handleOnClick = (_, analyticsEvent)=>{
            isCollapsed.current = false;
            const isExpandedNewValue = !isExpanded;
            setExpandedCollapsedArea(tabIndex, isExpandedNewValue);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'moreFields', {
                isExpanded: isExpandedNewValue
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $36c96cecf539181f$var$fieldsContainerWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
            ...rest,
            fields: fields
        }), !!collapsedFields.length && (0, ($parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$var$CollapsibleWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6DnvJ")).CollapsibleAreaHeader), {
            totalFields: collapsedFields.length,
            isExpanded: isExpanded,
            onClick: handleOnClick
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$var$CollapsibleArea, {
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("EePad")).default).smartFieldsReadMoreIssueTermRefresh : (0, (0, parcelRequire("EePad")).default).smartFieldsReadMore, {
            link: (chunks)=>(0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
                    href: "https://support.atlassian.com",
                    appearance: "default",
                    onClick: handleOnReadMoreClick
                }, chunks) : (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                    href: "/jira/settings/personal/general#smart-fields-preference",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        })), isCollapsed.current ? (0, ($parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
            ...rest,
            fields: collapsedFields,
            isCollapsed: isCollapsed.current
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($36c96cecf539181f$export$b533c285325ee313, {
            ...rest,
            FieldRenderer: FieldRenderer,
            fields: collapsedFields
        }))));
    };
    const $36c96cecf539181f$export$b533c285325ee313 = ({ FieldRenderer: FieldRenderer, ...rest })=>{
        const [loaded, setLoaded] = (0, $5uXOq.useState)(false);
        const [isFieldResponsive, setIsFieldResponsive] = (0, $5uXOq.useState)(false);
        const collapsibleAreaRef = (0, $5uXOq.useRef)(null);
        (0, (0, parcelRequire("2m0b6")).useResizeObserver)({
            ref: collapsibleAreaRef,
            onResize () {
                setIsFieldResponsive(window.innerWidth < 560);
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            setLoaded(true);
        }, []);
        if (!loaded) return null;
        if (!FieldRenderer) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: collapsibleAreaRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(FieldRenderer, {
            ...rest,
            isFieldResponsive: isFieldResponsive
        }));
    };
    const $36c96cecf539181f$var$CollapsibleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1y44 _189et94y _1dqonqa1 _1h6dmuej _19pkpxbi",
                __cmplp.className
            ])
        });
    });
    const $36c96cecf539181f$var$CollapsibleArea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !__cmplp.isExpanded ? "_1e0cglyw" : "_18u01f4h _otyrpxbi _1yt4u2gc _u5f3pxbi _ca0qidpf",
                __cmplp.className
            ])
        });
    });
    const $36c96cecf539181f$var$fieldsContainerWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        paddingBottom: 'space.200'
    });
});
parcelRegister("5Zxxp", function(module, exports) {
    $parcel$export(module.exports, "useHelpPanelLink", ()=>$b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
    $parcel$export(module.exports, "default", ()=>$b0d1b3c2fea05784$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $bHDKL;
    var $e4yMr;
    var $4R6GH;
    var $6BNJk;
    var $kspz4;
    var $hsmeR;
    const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
        const { openRightSidebar: openRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [, { setNavigationData: setNavigationData }] = (0, (0, parcelRequire("kspz4")).useHelpPanelActions)();
        const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
            openRightSidebar((0, (0, parcelRequire("6BNJk")).HELP_PANEL_ID), (0, (0, parcelRequire("6BNJk")).HELP_PANEL_WIDTH), false, true);
            if (resetHistory) setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                },
                history: []
            });
            else setNavigationData({
                articleId: {
                    id: id,
                    type: (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]
                }
            });
        };
        return handleOnClick;
    };
    const $b0d1b3c2fea05784$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, ...props })=>{
        const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
        const handleOnClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) event.preventDefault();
            onClick?.(event, analyticsEvent);
            onOpenInProductHelpArticle(articleId, (0, (0, parcelRequire("bHDKL")).ARTICLE_TYPE)[type]);
        };
        if ((0, (0, parcelRequire("4R6GH")).fg)('help_panel_as_link')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e4yMr")).default), {
            ...props,
            onClick: handleOnClick,
            href: href ?? 'https://support.atlassian.com',
            appearance: "default",
            testId: props.testId
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            ...props,
            onClick: handleOnClick,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
            ])
        }, children);
    };
    var $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$var$HelpPanelLink;
    const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
});
parcelRegister("2m0b6", function(module, exports) {
    $parcel$export(module.exports, "createResizeObserverHook", ()=>$072291c9ed048772$export$87a9d3e287304ae4);
    $parcel$export(module.exports, "useResizeObserver", ()=>$072291c9ed048772$export$683480f191c0e3ea);
    $parcel$export(module.exports, "flushResizeObservers", ()=>$072291c9ed048772$export$a181ef2a6d0a1bb6);
    $parcel$export(module.exports, "useRectObserver", ()=>$072291c9ed048772$export$e58143dc89297272);
    var $5uXOq = parcelRequire("5uXOq");
    var $eUdQc;
    function $072291c9ed048772$export$87a9d3e287304ae4(params) {
        const group = new (0, (0, parcelRequire("eUdQc")).ResizeObserverGroup)(params?.debouncePeriod);
        function useResizeObserver({ ref: ref, onResize: onResize }) {
            const onResizeRef = (0, $5uXOq.useRef)(onResize);
            (0, $5uXOq.useEffect)(()=>{
                onResizeRef.current = onResize;
            });
            const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
            (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
                ref,
                stableOnResize
            ]);
        }
        return {
            useResizeObserver: useResizeObserver,
            flushResizeObservers: ()=>group.flush()
        };
    }
    const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
    function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
        const [rect, setRect] = (0, $5uXOq.useState)(null);
        const onResize = ()=>{
            if (ref.current) setRect(ref.current.getBoundingClientRect());
        };
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!ref.current) throw new Error([
                'useRectObserver: ref is not available on mount.',
                'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
                'This will not work properly. Please update your code so that refs are always attached to components on mount.'
            ].join('\n'));
            setRect(ref.current.getBoundingClientRect());
        }, [
            ref
        ]);
        useResizeObserverDI({
            ref: ref,
            onResize: onResize
        });
        return rect;
    }
});
parcelRegister("eUdQc", function(module, exports) {
    $parcel$export(module.exports, "ResizeObserverGroup", ()=>$52e6ab4254804b44$export$607798bbe2869c0);
    var $7nsd3 = parcelRequire("7nsd3");
    var $lFKmC = parcelRequire("lFKmC");
    class $52e6ab4254804b44$export$607798bbe2869c0 {
        constructor(debouncePeriod = 16){
            this.subscribers = new Map();
            this.pendingUpdates = new Map();
            this.onResize = (entries)=>{
                entries.forEach((entry)=>{
                    const subscriber = this.subscribers.get(entry.target);
                    if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
                });
                this.scheduleFlush();
            };
            this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
            this.scheduleFlush = debouncePeriod > 0 ? (0, ($parcel$interopDefault($lFKmC)))(()=>{
                this.flush();
            }, debouncePeriod, {
                trailing: true,
                maxWait: 32
            }) : ()=>{
                this.flush();
            };
        }
        observe(ref, callback) {
            if (!ref.current) return ()=>{};
            this.subscribers.set(ref.current, {
                element: ref.current,
                callback: callback
            });
            this.observer?.observe(ref.current);
            return ()=>{
                if (!ref.current) return;
                this.subscribers.delete(ref.current);
                this.pendingUpdates.delete(ref.current);
                this.observer?.unobserve(ref.current);
            };
        }
        flush() {
            const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
            this.pendingUpdates.clear();
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                entries.forEach(({ callback: callback })=>{
                    callback();
                });
            });
        }
    }
});
parcelRegister("6DnvJ", function(module, exports) {
    $parcel$export(module.exports, "CollapsibleAreaHeader", ()=>$27079f86692b96b1$export$8761b26214731920);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $c8Oei;
    var $hWZau;
    var $lj8SI;
    var $dC5iT;
    var $8CUq3;
    var $koVbs;
    var $9PMVi;
    var $daO0u;
    const $27079f86692b96b1$export$875f349363bf5c2a = 'issue-create.ui.modal.create-form.layout-renderer.fields-container.collapsible-area-header.collapsible-area-header';
    const $27079f86692b96b1$export$8761b26214731920 = ({ totalFields: totalFields, isExpanded: isExpanded, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const buttonAlt = isExpanded ? (0, (0, parcelRequire("9PMVi")).messages).hideMoreFields : (0, (0, parcelRequire("9PMVi")).messages).showMoreFields;
        const { isSmartFieldsNew: isSmartFieldsNew } = (0, (0, parcelRequire("daO0u")).useSyncNewLozenge)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $27079f86692b96b1$var$buttonContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($27079f86692b96b1$var$HeaderButton, {
            iconBefore: isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("c8Oei"))))), {
                color: "currentColor",
                label: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: ""
            }),
            appearance: "subtle-link",
            title: formatMessage(buttonAlt, {
                totalFields: totalFields
            }),
            onClick: onClick,
            testId: $27079f86692b96b1$export$875f349363bf5c2a,
            shouldFitContainer: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($27079f86692b96b1$var$HeaderButtonContent, null, formatMessage((0, (0, parcelRequire("9PMVi")).messages).moreFields, {
            totalFields: totalFields
        }), isSmartFieldsNew && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, ' ', (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("9PMVi")).messages).newLozenge))))));
    };
    const $27079f86692b96b1$var$buttonHeight = '40px';
    const $27079f86692b96b1$var$buttonContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: 'space.025'
    });
    const $27079f86692b96b1$var$HeaderButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp _y3gn1e5h",
                __cmplp.className
            ])
        });
    });
    const $27079f86692b96b1$var$HeaderButtonContent = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz41ylp _18u012x7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9PMVi", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4623e88dd25a0a65$export$defe85febe8b728c);
    var $7VHMR;
    const $4623e88dd25a0a65$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreFields: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.more-fields",
            "defaultMessage": "More fields ({totalFields})"
        },
        showMoreFields: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.show-more-fields",
            "defaultMessage": "{totalFields, plural, one {Show one more field} other {Show # more fields}}"
        },
        hideMoreFields: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.hide-more-fields",
            "defaultMessage": "{totalFields, plural, one {Hide one more field} other {Hide # more fields}}"
        },
        newLozenge: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.new-lozenge",
            "defaultMessage": "New"
        }
    });
});
parcelRegister("daO0u", function(module, exports) {
    $parcel$export(module.exports, "useSyncNewLozenge", ()=>$24f215d4e587d689$export$2eb02503266aeaa2);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $45Cy1;
    var $gEEzS;
    var $aA974;
    const $24f215d4e587d689$export$2eb02503266aeaa2 = ()=>{
        const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, dismissReadMore: dismissReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed } = (0, (0, parcelRequire("aA974")).useIsSmartFieldsOptIn)();
        const { updatePreferences: updatePreferences } = (0, (0, parcelRequire("gEEzS")).useSmartFieldsUpdateUserPreference)();
        const dismissLozenge = (0, $5uXOq.useCallback)(async ()=>{
            dismissReadMore();
            await updatePreferences({
                hasUserOptedOut: !isSmartFieldsOptIn,
                hasUserDismissedReadMore: true,
                hasUserDismissedGicOnboarding: (0, (0, parcelRequire("4R6GH")).fg)('smart_fields_gic_toggle_fg') ? !!isSmartFieldsGicOnboardingDismissed : undefined
            });
        }, [
            dismissReadMore,
            isSmartFieldsOptIn,
            updatePreferences,
            isSmartFieldsGicOnboardingDismissed
        ]);
        const [isSmartFieldsNew, { setIsSmartFieldsNew: setIsSmartFieldsNew }] = (0, (0, parcelRequire("45Cy1")).useIsSmartFieldsNew)();
        (0, $5uXOq.useEffect)(()=>{
            if (isSmartFieldsNew === undefined && !isSmartFieldDismissedReadMore) {
                setIsSmartFieldsNew(true);
                dismissLozenge();
            }
        }, [
            isSmartFieldsNew,
            isSmartFieldDismissedReadMore,
            setIsSmartFieldsNew,
            dismissLozenge
        ]);
        return {
            isSmartFieldsNew: isSmartFieldsNew
        };
    };
});
parcelRegister("EePad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b4800c69563af667$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b4800c69563af667$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        smartFieldsReadMore: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more",
            "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating issues</link>"
        },
        smartFieldsReadMoreIssueTermRefresh: {
            "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more-issue-term-refresh",
            "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating work items</link>"
        }
    });
});
parcelRegister("cS2PJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48e14ad889979328$export$2e2bcd8739ae039);
    var $7VHMR;
    var $48e14ad889979328$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectFieldLabel: {
            "id": "issue-create.modal.create-form.project-field-label",
            "defaultMessage": "Projects"
        },
        createSuccessFlagTitle: {
            "id": "issue-create.modal.create-form.create-success-flag-title",
            "defaultMessage": "Issue created"
        },
        createSuccessFlagDescription: {
            "id": "issue-create.modal.create-form.create-success-flag-description",
            "defaultMessage": "Issue \"{issueKey}\" has been successfully created."
        },
        createSuccessFlagCta: {
            "id": "issue-create.modal.create-form.create-success-flag-cta",
            "defaultMessage": "View issue"
        },
        createErrorFlagTitle: {
            "id": "issue-create.modal.create-form.create-error-flag-title",
            "defaultMessage": "Couldn't create the issue"
        },
        createErrorFlagDescription: {
            "id": "issue-create.modal.create-form.create-error-flag-description",
            "defaultMessage": "We're having some trouble creating the issue. Refresh the page and try again."
        },
        embeddedCreateErrorFlagDescription: {
            "id": "issue-create.modal.create-form.embedded-create-error-flag-description",
            "defaultMessage": "We weren't able to save your issue. Please try again."
        },
        embeddedCreateErrorFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.create-form.embedded-create-error-flag-description-issue-term-refresh",
            "defaultMessage": "We weren't able to save your work item. Please try again."
        },
        createErrorForgeInlineField: {
            "id": "issue-create.modal.create-form.create-error-forge-inline-field",
            "defaultMessage": "Unable to save the value for this custom field."
        },
        timeoutForgeInlineFieldTitle: {
            "id": "issue-create.modal.create-form.timeout-forge-inline-field-title",
            "defaultMessage": "Issue created with exceptions"
        },
        timeoutForgeInlineFieldDescription: {
            "id": "issue-create.modal.create-form.timeout-forge-inline-field-description",
            "defaultMessage": "We created your issue but couldn't save the value of <bold>{fields}</bold>. If this happens again, contact your Jira admin"
        },
        requiredFieldsSummary: {
            "id": "issue-create.modal.create-form.required-fields-summary",
            "defaultMessage": "Required fields are marked with an asterisk"
        },
        singleRequiredCustomFieldIssueCreationBlock: {
            "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block",
            "defaultMessage": "You can\u2019t create this issue because the required field {fieldName} is hidden. Contact your admin to fix this."
        },
        multipleRequiredCustomFieldsIssueCreationBlock: {
            "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block",
            "defaultMessage": "You can\u2019t create this issue because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
        },
        createSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.create-form.create-success-flag-title-issue-term-refresh",
            "defaultMessage": "Work item created"
        },
        createSuccessFlagCtaIssueTermRefresh: {
            "id": "issue-create.modal.create-form.create-success-flag-cta-issue-term-refresh",
            "defaultMessage": "View work item"
        },
        createErrorFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.create-form.create-error-flag-title-issue-term-refresh",
            "defaultMessage": "Couldn't create the work item"
        },
        createErrorFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.create-form.create-error-flag-description-issue-term-refresh",
            "defaultMessage": "We're having some trouble creating the work item. Refresh the page and try again."
        },
        timeoutForgeInlineFieldTitleIssueTermRefresh: {
            "id": "issue-create.modal.create-form.timeout-forge-inline-field-title-issue-term-refresh",
            "defaultMessage": "Work item created with exceptions"
        },
        timeoutForgeInlineFieldDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.create-form.timeout-forge-inline-field-description-issue-term-refresh",
            "defaultMessage": "We created your work item but couldn't save the value of the <bold>{fields}</bold> field. If this happens again, notify your admin"
        },
        singleRequiredCustomFieldIssueCreationBlockIssueTermRefresh: {
            "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block-issue-term-refresh",
            "defaultMessage": "You can\u2019t create this work item because the {fieldName} field is required but hidden. Contact your admin to fix this."
        },
        multipleRequiredCustomFieldsIssueCreationBlockIssueTermRefresh: {
            "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block-issue-term-refresh",
            "defaultMessage": "You can\u2019t create this work item because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
        }
    });
});
parcelRegister("13Rnw", function(module, exports) {
    $parcel$export(module.exports, "ProformaBanner", ()=>$e07d4af127fdfe6e$export$d53a0bf1f2b6e7a6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $17Ngn;
    var $92Z2l;
    var $ctz0s;
    var $6s1PB;
    var $koVbs;
    var $iXVV6;
    var $5oFIy;
    var $8zOmE;
    var $2NMNM;
    var $h6zwy;
    const $e07d4af127fdfe6e$export$d53a0bf1f2b6e7a6 = ({ portalLink: portalLink })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onOpenPortalLinkClick = ()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicProformaBannerOpenPortalButton clicked');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "gicProforma",
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e07d4af127fdfe6e$export$f316edcbf748c37b, {
            "data-testid": "issue-create.ui.modal.create-form.proforma-banner.banner-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "information",
            title: formatMessage((0, (0, parcelRequire("h6zwy")).default).title),
            actions: [
                (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctz0s")).default), {
                    key: "openPortalLink"
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    appearance: "link",
                    href: portalLink,
                    target: "_blank",
                    spacing: "none",
                    onClick: onOpenPortalLinkClick,
                    onAuxClick: onOpenPortalLinkClick,
                    iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement($e07d4af127fdfe6e$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("17Ngn"))))), {
                        label: formatMessage((0, (0, parcelRequire("h6zwy")).default).newTabIconDescription),
                        size: "small"
                    }))
                }, formatMessage((0, (0, parcelRequire("h6zwy")).default).openPortal)))
            ]
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("h6zwy")).default).textIssueTermRefresh : (0, (0, parcelRequire("h6zwy")).default).text))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
    const $e07d4af127fdfe6e$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01b66 _k48pi7a9",
                __cmplp.className
            ])
        });
    });
    const $e07d4af127fdfe6e$export$f316edcbf748c37b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h6zwy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$963642523b3eb7cd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $963642523b3eb7cd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-create.modal.create-form.proforma-banner.title",
            "defaultMessage": "This request type includes a form that can\u2019t be seen in this view"
        },
        text: {
            "id": "issue-create.modal.create-form.proforma-banner.text",
            "defaultMessage": "Create an issue using all fields on this request type and its form in the portal."
        },
        openPortal: {
            "id": "issue-create.modal.create-form.proforma-banner.open-portal",
            "defaultMessage": "Open portal"
        },
        newTabIconDescription: {
            "id": "issue-create.modal.create-form.proforma-banner.new-tab-icon-description",
            "defaultMessage": "This link will be opened in a new tab"
        },
        textIssueTermRefresh: {
            "id": "issue-create.modal.create-form.proforma-banner.text-issue-term-refresh",
            "defaultMessage": "Create a work item using all fields on this request type and its form in the portal."
        }
    });
});
parcelRegister("eMaIO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9eab9b20db31fe6e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $5tTFS;
    var $qfj8c;
    var $7O4UO;
    var $7K5PP;
    var $4R6GH;
    var $koVbs;
    var $7C5S0;
    var $3M1CO;
    var $45Cy1;
    var $9UhzQ;
    var $8zOmE;
    var $2NMNM;
    var $do1Fc;
    var $kHA0a;
    var $tr82Y;
    var $7V7Wy;
    var $8fYVB;
    const $9eab9b20db31fe6e$var$ProjectPicker = (props)=>{
        const { onChange: onChange, value: selectedProjectValue, renderOptionsLimit: renderOptionsLimit, skipFetchProjects: skipFetchProjects = false, isDisabled: isDisabled = false, disableFetchProject: disableFetchProject = false, width: width } = props;
        const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const [recentProjects, setRecentProjects] = (0, $5uXOq.useState)([]);
        const [filterQuery, setFilterQuery] = (0, $5uXOq.useState)('');
        const [allProjects, setAllProjects] = (0, $5uXOq.useState)([]);
        const [isLoading, setLoading] = (0, $5uXOq.useState)(true);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const shouldFetchProjects = (0, $5uXOq.useRef)(true);
        const [fetchProjects] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(!(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules') && !(0, (0, parcelRequire("4R6GH")).fg)('control-classificationtags-in-jiraprojects') ? (0, (0, parcelRequire("tr82Y")).PROJECTS_LIST_QUERY) : (0, (0, parcelRequire("tr82Y")).PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION), {
            fetchPolicy: 'no-cache',
            onCompleted: (data)=>{
                setRecentProjects((0, (0, parcelRequire("do1Fc")).transformProjects)((0, ($parcel$interopDefault($9XE6b)))(data, 'recentProjects.nodes', [])));
                setAllProjects((0, (0, parcelRequire("do1Fc")).transformProjects)((0, ($parcel$interopDefault($9XE6b)))(data, 'allProjects.nodes', [])));
                setLoading(false);
            }
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onProjectPickerInputChange = (query)=>{
            setFilterQuery(query);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (selectedProjectValue && shouldFetchProjects.current || skipFetchProjects) {
                shouldFetchProjects.current = false;
                disableFetchProject ? setLoading(false) : fetchProjects();
            }
        }, [
            fetchProjects,
            selectedProjectValue,
            skipFetchProjects,
            disableFetchProject
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (submitFieldwiseErrors?.project) (0, (0, parcelRequire("kHA0a")).scrollToElement)((0, $431713d0f28262cd$export$e2b449031137335a));
        }, [
            submitFieldwiseErrors?.project
        ]);
        const onOptionSelect = (project)=>{
            if (project?.value === projectValue?.value) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'option'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'project');
            onChange(project);
        };
        const filteredOptions = (0, $5uXOq.useMemo)(()=>{
            const { filteredAllProjects: filteredAllProjects, filteredRecentProjects: filteredRecentProjects } = (0, (0, parcelRequire("8fYVB")).getFilteredOptions)({
                recentProjects: recentProjects,
                allProjects: allProjects,
                filterQuery: filterQuery,
                renderOptionsLimit: renderOptionsLimit
            });
            return [
                {
                    label: formatMessage((0, (0, parcelRequire("7V7Wy")).default).recentProjects),
                    options: filteredRecentProjects
                },
                {
                    label: formatMessage((0, (0, parcelRequire("7V7Wy")).default).allProjects),
                    options: filteredAllProjects
                }
            ];
        }, [
            recentProjects,
            allProjects,
            filterQuery,
            formatMessage,
            renderOptionsLimit
        ]);
        const projectValue = (0, $5uXOq.useMemo)(()=>selectedProjectValue && {
                ...selectedProjectValue,
                iconUrl: (0, (0, parcelRequire("3M1CO")).transformStargateUrl)(selectedProjectValue?.iconUrl || '')
            }, [
            selectedProjectValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: "project",
            label: formatMessage((0, (0, parcelRequire("7V7Wy")).default).projectFieldLabel),
            isRequired: true
        }, ({ fieldProps: { id: id, isRequired: isRequired } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                inputId: id,
                required: isRequired,
                options: filteredOptions,
                onInputChange: onProjectPickerInputChange,
                filterOption: null,
                onChange: onOptionSelect,
                value: projectValue,
                isClearable: false,
                formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
                hideSelectedOptions: false,
                placeholder: "",
                isLoading: isLoading,
                isDisabled: isDisabled,
                id: (0, $431713d0f28262cd$export$e2b449031137335a),
                onKeyDown: (0, (0, parcelRequire("kHA0a")).preventEscKeyPropagationKeyPressHandler)
            }), submitFieldwiseErrors?.project && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, submitFieldwiseErrors.project))));
    };
    var $9eab9b20db31fe6e$export$2e2bcd8739ae039 = $9eab9b20db31fe6e$var$ProjectPicker;
});
const $431713d0f28262cd$export$e2b449031137335a = 'issue-create.ui.modal.create-form.project-picker.project-select';
parcelRegister("tr82Y", function(module, exports) {
    $parcel$export(module.exports, "PROJECTS_LIST_QUERY", ()=>$ed11748ca47a586d$export$5ea959507154c1b9);
    $parcel$export(module.exports, "PROJECTS_LIST_QUERY_WITHOUT_CLASSIFICATION", ()=>$ed11748ca47a586d$export$19f5ac56520dbc94);
    var $5cllN;
    var $7pXhQ;
    const $ed11748ca47a586d$export$5ea959507154c1b9 = (0, (0, parcelRequire("5cllN")).default)`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${(0, (0, parcelRequire("7pXhQ")).PROJECT)}
`;
    const $ed11748ca47a586d$export$19f5ac56520dbc94 = (0, (0, parcelRequire("5cllN")).default)`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${(0, (0, parcelRequire("7pXhQ")).PROJECT_WITHOUT_CLASSIFICATION)}
`;
});
parcelRegister("7V7Wy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36682c1aa36e1a71$export$2e2bcd8739ae039);
    var $7VHMR;
    var $36682c1aa36e1a71$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectFieldLabel: {
            "id": "issue-create.modal.create-form.project-picker.project-field-label",
            "defaultMessage": "Project"
        },
        recentProjects: {
            "id": "issue-create.modal.create-form.project-picker.recent-projects",
            "defaultMessage": "Recent Projects"
        },
        allProjects: {
            "id": "issue-create.modal.create-form.project-picker.all-projects",
            "defaultMessage": "All Projects"
        }
    });
});
parcelRegister("8fYVB", function(module, exports) {
    $parcel$export(module.exports, "getFilteredOptions", ()=>$581839d7453c2f44$export$25a7cbafb6ed84cb);
    const $581839d7453c2f44$export$25a7cbafb6ed84cb = ({ recentProjects: recentProjects, allProjects: allProjects, filterQuery: filterQuery, renderOptionsLimit: renderOptionsLimit })=>{
        const filteredRecentProjects = recentProjects.filter((project)=>project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase()));
        const filteredAllProjects = allProjects.filter((project, index)=>{
            if (filterQuery) return project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase());
            return index < renderOptionsLimit;
        });
        return {
            filteredRecentProjects: filteredRecentProjects,
            filteredAllProjects: filteredAllProjects
        };
    };
});
parcelRegister("iSAdX", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeFieldsLayoutPreference", ()=>$22b674860ebcc4b4$export$c35a954354cf6eee);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $fVnbM;
    var $kkuz9;
    var $1I7E8;
    var $cgL5K;
    var $dTlW6;
    var $gwIPs;
    var $6s1PB;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $hH1l8;
    var $7CGHP;
    const $22b674860ebcc4b4$export$c35a954354cf6eee = ({ isRequestTypeSelected: isRequestTypeSelected, overrideIsEnabled: overrideIsEnabled, onChange: onChangeCallback })=>{
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const [{ data: isEnabled, isLoading: isLoading }, { setPreference: setPreference }] = (0, (0, parcelRequire("hH1l8")).useRequestTypeFieldsLayoutPreference)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const [toggleWasClicked, setToggleWasClicked] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const isChecked = !toggleWasClicked && overrideIsEnabled !== undefined ? !!overrideIsEnabled : isEnabled;
        const onToggleChanged = (0, $5uXOq.useCallback)(()=>{
            const newValue = !isChecked;
            setToggleWasClicked(true);
            atlassianAccountId && setPreference(atlassianAccountId, newValue, createAnalyticsEvent, onChangeCallback);
        }, [
            atlassianAccountId,
            createAnalyticsEvent,
            isChecked,
            onChangeCallback,
            setPreference
        ]);
        const togglePopup = (0, $5uXOq.useCallback)(()=>{
            if (!isOpen) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeToggleLabelButton clicked');
            setIsOpen(!isOpen);
        }, [
            createAnalyticsEvent,
            isOpen
        ]);
        const popupContent = (0, $5uXOq.useCallback)(()=>{
            const popupTextRequestTypeSelected = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7CGHP")).default).createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh : (0, (0, parcelRequire("7CGHP")).default).createFormPopupTextWhenRequestTypeSelected;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($22b674860ebcc4b4$export$cca08eed9de89ba9, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "p",
                size: "UNSAFE_small"
            }, formatMessage(isRequestTypeSelected ? popupTextRequestTypeSelected : (0, (0, parcelRequire("7CGHP")).default).createFormPopupTextWhenNoRequestTypeSelected)));
        }, [
            formatMessage,
            isRequestTypeSelected
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1y6m _4cvr1h6o"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dTlW6")).default), {
            isDisabled: isLoading || !isRequestTypeSelected,
            onChange: onToggleChanged,
            isChecked: isChecked,
            id: "use-request-type-fields-toggle"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: "use-request-type-fields-toggle",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1ifp _11c8qk37"
            ])
        }, formatMessage((0, (0, parcelRequire("7CGHP")).default).toggleLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            placement: "right",
            shouldUseCaptureOnOutsideClick: true,
            isOpen: isOpen,
            onClose: togglePopup,
            content: popupContent,
            zIndex: (0, (0, parcelRequire("gwIPs")).layers).tooltip,
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _19bv1b66 _1sc11vlj"
                    ])
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...triggerProps,
                    appearance: "subtle-link",
                    spacing: "none",
                    onClick: togglePopup
                }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_x5v9sv3s _1b3i658d _syaz149c _30l31kum"
                    ]),
                    style: {
                        "--_qswcdb": (0, (0, parcelRequire("lD23V")).default)(isOpen ? 'var(--icon-accent-color)' : 'var(--icon-color)')
                    }
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
                    label: "info",
                    size: "small"
                }))))
        }));
    };
    const $22b674860ebcc4b4$export$cca08eed9de89ba9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1178 _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7CGHP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d78d733a6cf9cd8$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2d78d733a6cf9cd8$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toggleLabel: {
            "id": "issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label",
            "defaultMessage": "Use request type fields"
        },
        createFormPopupTextWhenRequestTypeSelected: {
            "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected",
            "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see issue type fields instead."
        },
        createFormPopupTextWhenNoRequestTypeSelected: {
            "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-no-request-type-selected",
            "defaultMessage": "Select a request type to enable this feature."
        },
        createFormPopupTextWhenRequestTypeSelectedIssueTermRefresh: {
            "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected-issue-term-refresh",
            "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see work type fields instead."
        }
    });
});
parcelRegister("hx2H6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47ae7601e56546c0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nnPp;
    var $92Z2l;
    var $6s1PB;
    var $4R6GH;
    var $ousew;
    var $45Cy1;
    var $iXVV6;
    var $8zOmE;
    var $2NMNM;
    var $9OXo1;
    var $2CSJW;
    var $lXZTi;
    var $i4fCB;
    var $eHwnM;
    const $47ae7601e56546c0$var$SectionMessages = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ meta: meta }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const [issueAdjustmentError] = (0, (0, parcelRequire("2CSJW")).useUiModificationsErrors)();
        const [uiModificationsNotification] = (0, (0, parcelRequire("lXZTi")).useUiModificationsNotifications)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (!meta.areRequiredFieldsSupported) {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'banner',
                    action: 'viewed'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'globalIssueCreateMandatoryFieldsUnsupported');
            }
        }, [
            createAnalyticsEvent,
            meta.areRequiredFieldsSupported
        ]);
        if (meta.queryErrorMessage !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: "issue-create.ui.modal.create-form.section-messages.query-error-message"
        }, meta.queryErrorMessage);
        if (meta.submitErrorMessage !== undefined && meta.submitErrorMessage !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: "issue-create.ui.modal.create-form.section-messages.submit-error-message"
        }, (0, (0, parcelRequire("eHwnM")).getDisplayErrorString)(meta.submitErrorMessage).map((error, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement($47ae7601e56546c0$var$MessageWrapper, {
                key: index
            }, error)));
        let infoMessage;
        if (isSiteAdmin) infoMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("i4fCB")).default).requiredFieldsUnsupportedForAdminIssueTermRefresh : (0, (0, parcelRequire("i4fCB")).default).requiredFieldsUnsupportedForAdmin;
        else infoMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("i4fCB")).default).requiredFieldsUnsupportedForUserIssueTermRefresh : (0, (0, parcelRequire("i4fCB")).default).requiredFieldsUnsupportedForUser;
        if (!meta.areRequiredFieldsSupported) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "globalIssueCreateMandatoryFieldsUnsupported",
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: "issue-create.ui.modal.create-form.section-messages.required-fields-message"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...infoMessage,
            values: {
                a: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: "/jira/contact-administrator"
                    }, chunks),
                button: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7nnPp"))))), {
                        label: "incompatible-field-error",
                        size: "medium",
                        primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$exports).N200})`
                    })
            }
        })));
        if (meta.inlineCreateError && meta.inlineCreateError?.errors.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: "issue-create.ui.modal.create-form.section-messages.inline-create-errors",
            title: meta.inlineCreateError.title || ''
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("ul", null, meta.inlineCreateError.errors.map((error, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: `inline-error-${index}`
            }, error))));
        if (issueAdjustmentError !== null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "error",
            testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
        }, issueAdjustmentError.message);
        if (uiModificationsNotification !== null && (0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: uiModificationsNotification.type,
            testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-notification-message"
        }, uiModificationsNotification.message);
        return null;
    };
    var $47ae7601e56546c0$export$2e2bcd8739ae039 = $47ae7601e56546c0$var$SectionMessages;
    const $47ae7601e56546c0$var$MessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81kw7 _o5721jtm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2CSJW", function(module, exports) {
    $parcel$export(module.exports, "useUiModificationsErrors", ()=>$58fca68b47c6ed0a$export$72f28c8f041a8bab);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dMXKH;
    var $Eg5r3;
    const $58fca68b47c6ed0a$export$72f28c8f041a8bab = ()=>{
        const error = (0, (0, parcelRequire("dMXKH")).useError)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [errorMessage, setErrorMessage] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!error) setErrorMessage(null);
            else {
                const message = (0, (0, parcelRequire("Eg5r3")).errorCodeToErrorMessageMap)[error.errorCode];
                const formattedMessage = formatMessage(message);
                setErrorMessage(formattedMessage);
            }
        }, [
            error,
            formatMessage
        ]);
        return errorMessage ? [
            {
                message: errorMessage
            }
        ] : [
            null
        ];
    };
});
parcelRegister("dMXKH", function(module, exports) {
    $parcel$export(module.exports, "useError", ()=>$da3038d66b91fa4d$export$5027865de34f9ec6);
    var $3sQ5x;
    var $asu2W;
    const $da3038d66b91fa4d$export$5027865de34f9ec6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: (state)=>state.error
    });
});
parcelRegister("Eg5r3", function(module, exports) {
    $parcel$export(module.exports, "errorCodeToErrorMessageMap", ()=>$64a1e22d648f2213$export$c36ca6969b1c2a38);
    var $7ze1Z;
    const $64a1e22d648f2213$export$c36ca6969b1c2a38 = {
        ON_BRIDGE_ERROR_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).applyingUimFailed,
        USE_REGISTER_FIELDS_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).applyingUimFailed,
        USE_SUBMIT_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).applyingUimFailed,
        PER_FIELD_HOOK_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).applyingUimFailed,
        SCOPES_MISSING_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).appDoesNotHaveRequiredScopes,
        ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, (0, parcelRequire("7ze1Z")).default).applyingUimFailed,
        ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, (0, parcelRequire("7ze1Z")).default).loadingUimFailed
    };
});
parcelRegister("7ze1Z", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9acf1903b7e802fb$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9acf1903b7e802fb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        loadingUimFailed: {
            "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed",
            "defaultMessage": "We couldn't load the UI modifications for this form."
        },
        loadingUimDataFailed: {
            "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed",
            "defaultMessage": "We couldn't load the UI modifications configuration for this form."
        },
        applyingUimFailed: {
            "id": "ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed",
            "defaultMessage": "We encountered an error while applying UI modifications to this form."
        },
        appDoesNotHaveRequiredScopes: {
            "id": "ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes",
            "defaultMessage": "We couldn\u2019t load some of the UI modifications apps for this page, because they don\u2019t have required scopes."
        }
    });
});
parcelRegister("lXZTi", function(module, exports) {
    $parcel$export(module.exports, "useUiModificationsNotifications", ()=>$b29798151379c10c$export$3a867504a28cd936);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $koVbs;
    var $4kgYC;
    var $3EZBv;
    const $b29798151379c10c$var$useUiModificationsNotificationsWithFFOn = ()=>{
        const notification = (0, (0, parcelRequire("4kgYC")).useNotification)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [notificationProperties, setNotificationProperties] = (0, $5uXOq.useState)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!notification) setNotificationProperties(null);
            else {
                const properties = (0, (0, parcelRequire("3EZBv")).notificationTypeToNotificationProperties)[notification.type];
                const formattedMessage = formatMessage(properties.message);
                setNotificationProperties({
                    message: formattedMessage,
                    type: properties.type
                });
            }
        }, [
            notification,
            formatMessage
        ]);
        return notificationProperties ? [
            notificationProperties
        ] : [
            null
        ];
    };
    const $b29798151379c10c$export$3a867504a28cd936 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ui_modifications_multiple_apps'), $b29798151379c10c$var$useUiModificationsNotificationsWithFFOn, ()=>[
            null
        ]);
});
parcelRegister("4kgYC", function(module, exports) {
    $parcel$export(module.exports, "useNotification", ()=>$c0233c8b44a851a4$export$9949bd9c713ba425);
    var $3sQ5x;
    var $asu2W;
    const $c0233c8b44a851a4$export$9949bd9c713ba425 = (0, (0, parcelRequire("3sQ5x")).createStateHook)((0, (0, parcelRequire("asu2W")).store), {
        selector: (state)=>state.notification
    });
});
parcelRegister("3EZBv", function(module, exports) {
    $parcel$export(module.exports, "notificationTypeToNotificationProperties", ()=>$c2ee6057cddfff25$export$3dd11dfb655fc1de);
    var $asCOJ;
    const $c2ee6057cddfff25$export$3dd11dfb655fc1de = {
        MULTIPLE_APPS_CONFLICTS: {
            message: (0, (0, parcelRequire("asCOJ")).default).multipleAppsConflicted,
            type: 'warning'
        },
        MULTIPLE_APPS_IN_CONTEXT: {
            message: (0, (0, parcelRequire("asCOJ")).default).uimMultipleApps,
            type: 'information'
        }
    };
});
parcelRegister("asCOJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e908fb1914785e5d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e908fb1914785e5d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        multipleAppsConflicted: {
            "id": "ui-modifications-view-gic.use-ui-modifications-notifications.multiple-apps-conflicted",
            "defaultMessage": "Multiple UI modification apps are trying to change the same field property. If you see unexpected changes to a field, report them to your Jira admin."
        },
        uimMultipleApps: {
            "id": "ui-modifications-view-gic.use-ui-modifications-notifications.uim-multiple-apps",
            "defaultMessage": "We have added support for multiple UI modification apps. Your admin has installed more than one app that can make changes to this screen."
        }
    });
});
parcelRegister("i4fCB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$65dda28a4aa21d82$export$2e2bcd8739ae039);
    var $7VHMR;
    var $65dda28a4aa21d82$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        requiredFieldsUnsupportedForAdmin: {
            "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin",
            "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, make the field(s) optional and remove the field(s) from this screen."
        },
        requiredFieldsUnsupportedForUser: {
            "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user",
            "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, <a>reach out to your Jira admin</a> to make the field(s) optional and remove the field(s) from this screen."
        },
        requiredFieldsUnsupportedForAdminIssueTermRefresh: {
            "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin-issue-term-refresh",
            "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, make the field(s) optional and remove the field(s) from this screen."
        },
        requiredFieldsUnsupportedForUserIssueTermRefresh: {
            "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user-issue-term-refresh",
            "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating work items, <a>reach out to your admin</a> to make the field(s) optional and remove the field(s) from this screen."
        }
    });
});
parcelRegister("eHwnM", function(module, exports) {
    $parcel$export(module.exports, "getDisplayErrorString", ()=>$2ca4b4c6fd5f260b$export$3455fb62ca5e4ef7);
    const $2ca4b4c6fd5f260b$export$3455fb62ca5e4ef7 = (submitErrorMessage)=>{
        try {
            const errsObj = JSON.parse(submitErrorMessage);
            if (errsObj.errors) {
                const values = Object.values(errsObj.errors).filter((value)=>typeof value === 'string');
                if (values.length > 0) return values;
            }
        } catch (error) {}
        return [
            submitErrorMessage
        ];
    };
});
parcelRegister("gB2JP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d956e7182da22b4d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $qfj8c;
    var $7O4UO;
    var $7K5PP;
    var $heNNl;
    var $7iJwP;
    var $4R6GH;
    var $koVbs;
    var $7C5S0;
    var $cKWWX;
    var $7wE6m;
    var $hOPPE;
    const $d956e7182da22b4d$var$SitePicker = (props)=>{
        const { classNamePrefix: classNamePrefix, onChange: onChange, width: width = 350 } = props;
        const [{ selectedCloudId: selectedCloudId }, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        const { sites: sites, error: error, isLoading: isLoading } = (0, (0, parcelRequire("7wE6m")).default)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [selectedValue, setSelectedValue] = (0, $5uXOq.useState)({});
        (0, $5uXOq.useEffect)(()=>{
            if (!sites) return;
            const currentSite = window.location.hostname.split('.')[0];
            const prefilledValue = sites?.filter((site)=>site.label === currentSite)?.[0] || {};
            if (selectedCloudId && selectedCloudId !== prefilledValue?.value && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) {
                const selectedSite = sites?.filter((site)=>site.value === selectedCloudId)?.[0] || {};
                const initialValue = selectedSite || prefilledValue;
                setSelectedValue(initialValue);
                return;
            }
            if (selectedCloudId) return;
            setSitePickerState({
                siteDomain: prefilledValue.url || ''
            });
            setSelectedValue(prefilledValue);
        }, [
            onChange,
            selectedCloudId,
            setSitePickerState,
            sites
        ]);
        const _onChange = (0, $5uXOq.useCallback)((option)=>{
            setSitePickerState({
                siteDomain: option?.url || '',
                selectedCloudId: option?.value || ''
            });
            onChange?.();
            setSelectedValue(option || {});
        }, [
            setSitePickerState,
            onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7iJwP")).default), {
            packageName: "jiraIssueCreate",
            id: "JiraSitePickerSelect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            width: width
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
            name: "site",
            label: formatMessage((0, (0, parcelRequire("hOPPE")).default).sitePickerFieldLabel)
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                inputId: fieldProps?.id,
                value: selectedValue,
                options: (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference') ? $d956e7182da22b4d$export$4dda509356982425(sites) : sites,
                onChange: _onChange,
                classNamePrefix: classNamePrefix,
                isLoading: isLoading
            }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, formatMessage((0, (0, parcelRequire("hOPPE")).default).sitePickerError)))))));
    };
    const $d956e7182da22b4d$export$4dda509356982425 = (siteOptions)=>{
        return siteOptions.sort((siteA, siteB)=>{
            return siteA?.label.localeCompare(siteB?.label);
        });
    };
    var $d956e7182da22b4d$export$2e2bcd8739ae039 = $d956e7182da22b4d$var$SitePicker;
});
parcelRegister("7wE6m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1cfbc54228e85991$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ld2hZ;
    var $eusud;
    const $1cfbc54228e85991$var$AVAILABLE_SITES_ENDPOINT = '/gateway/api/available-sites';
    const $1cfbc54228e85991$export$8f93d3ef836534e6 = ()=>[
            'jira-product-discovery'
        ];
    const $1cfbc54228e85991$var$fetchJiraAppLink = async ()=>(0, (0, parcelRequire("eusud")).performPostRequest)($1cfbc54228e85991$var$AVAILABLE_SITES_ENDPOINT, {
            body: JSON.stringify({
                products: [
                    'jira-software.ondemand',
                    'jira-core.ondemand',
                    'jira-servicedesk.ondemand',
                    ...$1cfbc54228e85991$export$8f93d3ef836534e6()
                ]
            })
        });
    const $1cfbc54228e85991$export$9d182d381b792de6 = (item)=>({
            label: item.displayName,
            value: item.cloudId,
            url: item.url
        });
    const $1cfbc54228e85991$export$905fc72a68d660cf = (sites)=>sites.map($1cfbc54228e85991$export$9d182d381b792de6);
    const $1cfbc54228e85991$var$useFetchJiraAvailableSites = ()=>{
        const { loading: loading, error: error, data: data, fetch: fetch } = (0, (0, parcelRequire("ld2hZ")).useService)($1cfbc54228e85991$var$fetchJiraAppLink);
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, [
            fetch
        ]);
        const sites = (0, $5uXOq.useMemo)(()=>{
            if (data && data.sites && data.sites.length) return $1cfbc54228e85991$export$905fc72a68d660cf(data.sites);
            return [];
        }, [
            data
        ]);
        return {
            isLoading: loading,
            error: error,
            sites: sites
        };
    };
    var $1cfbc54228e85991$export$2e2bcd8739ae039 = $1cfbc54228e85991$var$useFetchJiraAvailableSites;
});
parcelRegister("hOPPE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$de12e9afe29525fe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $de12e9afe29525fe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sitePickerFieldLabel: {
            "id": "issue-create.modal.create-form.site-picker.site-picker-field-label",
            "defaultMessage": "Site"
        },
        sitePickerError: {
            "id": "issue-create.modal.create-form.site-picker.site-picker-error",
            "defaultMessage": "Error in fetching the site options"
        }
    });
});
parcelRegister("9TbCg", function(module, exports) {
    $parcel$export(module.exports, "SmartFieldMessage", ()=>$674b03d1566318d3$export$ef68b7820636cd13);
    var $5uXOq = parcelRequire("5uXOq");
    var $42CjB;
    var $2C7j9;
    var $dC5iT;
    var $f5TWP;
    var $8CUq3;
    var $5Zxxp;
    var $koVbs;
    var $iUFy5;
    var $gEEzS;
    var $aA974;
    var $erRWO;
    const $674b03d1566318d3$export$ef68b7820636cd13 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, isSmartFieldsGicOnboardingDismissed: isSmartFieldsGicOnboardingDismissed, dismissGicOnboarding: dismissGicOnboarding } = (0, (0, parcelRequire("aA974")).useIsSmartFieldsOptIn)();
        const { updatePreferences: updatePreferences } = (0, (0, parcelRequire("gEEzS")).useSmartFieldsUpdateUserPreference)();
        const handleDismissMessage = (0, $5uXOq.useCallback)(()=>{
            dismissGicOnboarding();
            updatePreferences({
                hasUserOptedOut: !isSmartFieldsOptIn,
                hasUserDismissedGicOnboarding: true,
                hasUserDismissedReadMore: !!isSmartFieldDismissedReadMore
            });
        }, [
            dismissGicOnboarding,
            isSmartFieldDismissedReadMore,
            isSmartFieldsOptIn,
            updatePreferences
        ]);
        const { view: view, setView: setView, setShouldFocusChanger: setShouldFocusChanger } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const handleOnReadMoreClick = (0, $5uXOq.useCallback)(()=>{
            if (view === 'modal') {
                setShouldFocusChanger(true);
                setView('mini');
            }
        }, [
            view,
            setShouldFocusChanger,
            setView
        ]);
        return isSmartFieldsOptIn && isSmartFieldsGicOnboardingDismissed !== true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            backgroundColor: "color.background.discovery",
            padding: "space.100",
            xcss: $674b03d1566318d3$var$boxStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            spread: "space-between"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $674b03d1566318d3$var$helpTextStyles
        }, formatMessage((0, (0, parcelRequire("erRWO")).default).readMore, {
            link: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Zxxp")).default), {
                    articleId: "3svLIYAFXrcqQlJXtqEc6G",
                    appearance: "link",
                    spacing: "none",
                    fallbackComponent: null,
                    onClick: handleOnReadMoreClick
                }, chunks)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42CjB")).default), {
            appearance: "subtle",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2C7j9"))))),
            label: formatMessage((0, (0, parcelRequire("erRWO")).default).dismissButtonLabel),
            onClick: handleDismissMessage,
            spacing: "compact"
        }))) : null;
    };
    const $674b03d1566318d3$var$boxStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius'
    });
    const $674b03d1566318d3$var$helpTextStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        alignSelf: 'center'
    });
});
parcelRegister("erRWO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a70b90ddadbe55f1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a70b90ddadbe55f1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        readMore: {
            "id": "issue-create.modal.create-form.smart-field-message.read-more",
            "defaultMessage": "We\u2019ve surfaced the fields you use often, and hidden the ones you don\u2019t. <link>More about this change</link>"
        },
        dismissButtonLabel: {
            "id": "issue-create.modal.create-form.smart-field-message.dismiss-button-label",
            "defaultMessage": "Dismiss this message"
        }
    });
});
parcelRegister("64HID", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19ac611cd00dc10b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $qfj8c;
    var $2x3Cb;
    var $gtreQ;
    var $1wbtX;
    var $gwIPs;
    var $6s1PB;
    var $koVbs;
    var $7C5S0;
    var $hmK1M;
    var $8umLM;
    const $19ac611cd00dc10b$var$statusFieldMargin = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.25;
    const $19ac611cd00dc10b$var$StatusField = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const defaultProps = {
            isLoading: false,
            footer: undefined,
            fieldId: 'gic-status-field'
        };
        const getEnabledTransitions = (transitions)=>transitions.filter((transition)=>transition.isDisabled === false);
        const getFieldContent = ()=>{
            if (props.isLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldSkeleton, {
                isMini: props.isMini,
                "aria-busy": true
            });
            if (!props.value?.to) return (0, ($parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldErrorSkeleton, {
                isMini: props.isMini
            });
            if (props.error) return (0, ($parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$FieldErrorSkeleton, {
                isMini: props.isMini
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hmK1M")).StatusView), {
                ...defaultProps,
                appearance: "button",
                value: props.value?.to,
                selectedTransition: props.value,
                transitions: getEnabledTransitions(props.transitions),
                forceNoLabels: true,
                isDefaultSelect: props.isMini,
                onChange: props.onChange,
                customNoOptionsMessage: formatMessage((0, (0, parcelRequire("8umLM")).default).noEnabledTransitionsMessage),
                shouldFitContainer: false
            });
        };
        const getHelpOrWarningText = ()=>{
            if (props.error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).HelperMessage), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gtreQ"))))), {
                size: "small",
                primaryColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$exports).Y500})`,
                label: formatMessage((0, (0, parcelRequire("8umLM")).default).warningIconLabel)
            }), formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8umLM")).default).warningMessageIssueTermRefresh : (0, (0, parcelRequire("8umLM")).default).warningMessage));
            if (props.isMini) return null;
            const getHelperTextMessage = ()=>{
                if ((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false)) return (0, (0, parcelRequire("8umLM")).default).helperTextFade;
                return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8umLM")).default).helperTextIssueTermRefresh : (0, (0, parcelRequire("8umLM")).default).helperText;
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$HelperText, null, formatMessage(getHelperTextMessage()));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
            marginTop: $19ac611cd00dc10b$var$statusFieldMargin
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2x3Cb")).Label), {
            htmlFor: defaultProps.fieldId,
            id: "gic-status-field-label"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($19ac611cd00dc10b$var$LabelFlex, null, formatMessage((0, (0, parcelRequire("8umLM")).default).statusFieldLabel))), getFieldContent(), getHelpOrWarningText());
    };
    var $19ac611cd00dc10b$export$2e2bcd8739ae039 = $19ac611cd00dc10b$var$StatusField;
    const $19ac611cd00dc10b$var$HelperText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1wmz _11c81vlj _19pk12x7 _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $19ac611cd00dc10b$var$FieldSkeleton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("1wbtX")).Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyri2wt",
                __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
                __cmplp.className
            ])
        });
    });
    const $19ac611cd00dc10b$var$FieldErrorSkeleton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isMini: isMini, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otyr12x7 _bfhkqrzy",
                __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
                __cmplp.className
            ])
        });
    });
    const $19ac611cd00dc10b$var$LabelFlex = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hmK1M", function(module, exports) {
    $parcel$export(module.exports, "StatusView", ()=>$f4607509f8535f3b$export$a11134e1462e763);
    $parcel$export(module.exports, "default", ()=>$f4607509f8535f3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kgoHi;
    var $8CUq3;
    var $7K5PP;
    var $b9dFI;
    var $6sO8n;
    var $i0vxP;
    var $gULOk;
    var $4R6GH;
    var $koVbs;
    var $1XJ20;
    var $2OMDV;
    var $8zOmE;
    var $17mYr;
    var $44VbI;
    var $kTnV4;
    var $2NP8E;
    var $5uNOo;
    var $k92cH;
    var $coyc6;
    var $rNSQs;
    var $1khYv;
    const $f4607509f8535f3b$var$defaultPopperProps = {
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: 5,
                    rootBoundary: 'document'
                }
            }
        ],
        strategy: 'fixed'
    };
    const $f4607509f8535f3b$export$d5aa018254c8c065 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('statusField', {
        onOpen: 'openDropdown',
        onChange: 'transitionSelected'
    })((0, (0, parcelRequire("b9dFI")).default));
    const $f4607509f8535f3b$export$f35c79a5a21cbec1 = (0, (0, parcelRequire("2OMDV")).AnalyticsEventToProps)('statusField', {
        onOpen: 'openDropdown',
        onChange: 'transitionSelected'
    })((0, (0, parcelRequire("7K5PP")).default));
    const $f4607509f8535f3b$var$isOptionDisabled = (option)=>option.transition.isDisabled;
    const $f4607509f8535f3b$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, ($parcel$interopDefault($8Rkzz))), onOpen: onOpen = (0, ($parcel$interopDefault($8Rkzz))), onClose: onClose = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, defaultOpen: defaultOpen = false, shouldFitContainer: shouldFitContainer = true, onUpdateStatusMutation: onUpdateStatusMutation })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const childWrapperRef = (0, $5uXOq.useRef)(null);
        const wasChanged = (0, $5uXOq.useRef)(false);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const previousIsSaving = (0, (0, parcelRequire("1XJ20")).usePrevious)(isSaving);
        const previousTransitions = (0, (0, parcelRequire("1XJ20")).usePrevious)(transitions);
        const previousIsOpen = (0, (0, parcelRequire("1XJ20")).usePrevious)(isOpen);
        const wasFetchSuccessful = transitions != null;
        const filteredAndOrderedTransitions = (0, (0, parcelRequire("44VbI")).getFilteredOrderedTransitions)(transitions, value.id);
        const isGlobalOnly = (0, (0, parcelRequire("44VbI")).isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
        const showLabel = !(forceNoLabels || isGlobalOnly);
        const [isConfigureStatusModalOpen, setIsConfigureStatusModalOpen] = (0, $5uXOq.useState)(false);
        const formatTransitionOptionLabel = (0, $5uXOq.useCallback)((option, transitionProps)=>{
            if (showConfigureStatusButtons && projectId && issueTypeId && projectKey) {
                const status = {
                    id: option.transition.to.id,
                    statusName: option.transition.to.name,
                    statusCategory: (0, (0, parcelRequire("gULOk")).statusCategoryForId)(option.transition.to.statusCategory.id)
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1khYv")).Transition), {
                    transition: option.transition,
                    hasLabel: showLabel,
                    addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
                    contentAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5uNOo")).EditStatusButton), {
                        status: status,
                        projectId: projectId,
                        issueTypeId: issueTypeId,
                        projectKey: projectKey,
                        statusNames: transitions?.map((transition)=>transition.to.name),
                        onClick: ()=>setIsConfigureStatusModalOpen?.(true),
                        onClose: ()=>setIsConfigureStatusModalOpen?.(false)
                    }),
                    testId: "issue-field-status.ui.status-view.transition"
                });
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1khYv")).Transition), {
                transition: option.transition,
                hasLabel: showLabel,
                addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
                testId: "issue-field-status.ui.status-view.transition"
            });
        }, [
            showConfigureStatusButtons,
            projectId,
            issueTypeId,
            showLabel,
            transitions,
            projectKey,
            setIsConfigureStatusModalOpen
        ]);
        const getTransitionOptionLabel = (option)=>option.transition.isGlobal ? formatMessage((0, (0, parcelRequire("k92cH")).default).transitionTo, {
                statusName: option.label
            }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        const mergedPopperProps = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($1UikQ)))($f4607509f8535f3b$var$defaultPopperProps, popperProps), [
            popperProps
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (previousIsSaving === true && isSaving === false) childWrapperRef.current && childWrapperRef.current.children.length > 0 && childWrapperRef.current.children[0].focus();
        }, [
            isOpen,
            isSaving,
            previousIsOpen,
            previousIsSaving,
            previousTransitions,
            transitions
        ]);
        const handleChangeStatus = (0, $5uXOq.useCallback)((transition, analyticsEvent)=>{
            const { hasScreen: hasScreen } = transition;
            wasChanged.current = true;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
                hasScreen: hasScreen
            });
            onChange?.(transition, analyticsEvent);
        }, [
            onChange
        ]);
        const handleChange = (0, $5uXOq.useCallback)((option, action, analyticsEvent)=>{
            handleChangeStatus(option.transition, analyticsEvent);
        }, [
            handleChangeStatus
        ]);
        const handleOpen = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
            onOpen?.(analyticsEvent);
            setIsOpen(true);
        }, [
            onOpen
        ]);
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            wasChanged.current = false;
            onClose?.();
            setIsOpen(false);
        }, [
            onClose
        ]);
        const renderLozenge = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
            if (saving) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sO8n")).default), {
                border: false
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
                targetRef: targetRef,
                status: value,
                error: error
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).WrappedStatusLozenge), {
                ariaLabel: `${value.name} - ${formatMessage((0, (0, parcelRequire("k92cH")).default).changeStatus)}`,
                error: err,
                hasHoverState: true,
                isEditable: editable,
                isOpen: isOpen,
                status: value,
                targetRef: targetRef
            });
        }, [
            error,
            formatMessage,
            isOpen,
            value
        ]);
        const renderButton = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
            const statusButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rNSQs")).StatusButton), {
                ariaLabel: `${value.name} - ${formatMessage((0, (0, parcelRequire("k92cH")).default).changeStatus)}`,
                isEditable: editable,
                isOpen: isOpen,
                status: value,
                targetRef: targetRef,
                statusButtonRef: statusButtonRef,
                shouldFitContainer: shouldFitContainer
            });
            return saving ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sO8n")).default), null, statusButton) : statusButton;
        }, [
            formatMessage,
            isOpen,
            shouldFitContainer,
            statusButtonRef,
            value
        ]);
        const renderCommandPalette = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kTnV4")).CommandPaletteStatusView), {
                transitions: filteredAndOrderedTransitions,
                currentStatus: value,
                onSuccess: onSuccess,
                wasFetchSuccessful: wasFetchSuccessful,
                renderTransition: formatTransitionOptionLabel,
                onFetch: onFetch,
                isLoading: isLoading,
                onUpdateStatusMutation: onUpdateStatusMutation
            }), [
            filteredAndOrderedTransitions,
            value,
            onSuccess,
            wasFetchSuccessful,
            formatTransitionOptionLabel,
            onFetch,
            isLoading,
            onUpdateStatusMutation
        ]);
        const renderWithFocusWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: childWrapperRef
            }, children), []);
        const renderTarget = (0, $5uXOq.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
            if (value) {
                if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                    isEditable: editable,
                    isSaving: saving,
                    error: err,
                    targetRef: targetRef
                }));
                if (appearance === 'button') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderWithFocusWrapper(renderButton({
                    isEditable: editable,
                    isSaving: saving,
                    targetRef: targetRef
                })), registerInCommandPalette && renderCommandPalette());
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null);
        }, [
            appearance,
            registerInCommandPalette,
            renderButton,
            renderCommandPalette,
            renderLozenge,
            renderWithFocusWrapper,
            value
        ]);
        if (isSaving || !isEditable) return renderTarget({
            isSaving: isSaving,
            isEditable: isEditable,
            error: error
        });
        const getNoOptionsMessage = ()=>{
            if (customNoOptionsMessage) return customNoOptionsMessage;
            const noPermissionMessage = (0, (0, parcelRequire("4R6GH")).fg)('jira-issue-terminology-refresh-m3') ? (0, (0, parcelRequire("k92cH")).default).noPermissionIssueTermRefresh : (0, (0, parcelRequire("k92cH")).default).noPermission;
            return formatMessage(wasFetchSuccessful ? noPermissionMessage : (0, (0, parcelRequire("k92cH")).default).cannotLoadTransitions);
        };
        const renderFooter = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                direction: "column",
                xcss: $f4607509f8535f3b$var$statusViewFooterStyles
            }, showConfigureStatusButtons && projectKey && projectType && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2NP8E")).CreateStatusButton), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition.to.name),
                onClick: ()=>setIsConfigureStatusModalOpen(true),
                onClose: ()=>setIsConfigureStatusModalOpen(false)
            }), footer);
        const statusPopup = isDefaultSelect && selectedTransition ? (0, ($parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$export$f35c79a5a21cbec1, {
            label: formatMessage((0, (0, parcelRequire("k92cH")).default).selectStatus),
            inputId: fieldId,
            noOptionsMessage: getNoOptionsMessage,
            formatOptionLabel: formatTransitionOptionLabel,
            getOptionLabel: getTransitionOptionLabel,
            options: (0, (0, parcelRequire("44VbI")).transformOptions)(filteredAndOrderedTransitions || []),
            isLoading: isLoading,
            isDisabled: !isEditable,
            isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
            onChange: handleChange,
            value: (0, (0, parcelRequire("44VbI")).transformOptions)([
                selectedTransition
            ])[0],
            isSearchable: false,
            onOpen: handleOpen,
            onClose: handleClose,
            closeMenuOnSelect: true,
            components: {
                LoadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coyc6")).LoadingSpinner), null)
            },
            menuIsOpen: isConfigureStatusModalOpen && (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_inline_status_creation_prereqs') ? false : undefined,
            popperProps: mergedPopperProps,
            footer: (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_inline_status_creation_prereqs') ? renderFooter() : footer
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$export$d5aa018254c8c065, {
            inputId: fieldId,
            noOptionsMessage: getNoOptionsMessage,
            formatOptionLabel: formatTransitionOptionLabel,
            getOptionLabel: getTransitionOptionLabel,
            options: (0, (0, parcelRequire("44VbI")).transformOptions)(filteredAndOrderedTransitions || []),
            target: ({ ref: ref })=>renderTarget({
                    isEditable: isEditable,
                    isSaving: isSaving,
                    error: error,
                    targetRef: ref
                }),
            isLoading: isLoading,
            isDisabled: !isEditable,
            isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
            searchThreshold: 99999,
            onChange: handleChange,
            onOpen: handleOpen,
            handleClick: handleOpen,
            onClose: handleClose,
            closeMenuOnSelect: true,
            components: {
                LoadingMessage: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("coyc6")).LoadingSpinner), null)
            },
            isOpen: isConfigureStatusModalOpen && (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_inline_status_creation_prereqs') ? false : undefined,
            popperProps: mergedPopperProps,
            footer: (0, (0, parcelRequire("4R6GH")).fg)('jira_issue_view_inline_status_creation_prereqs') ? renderFooter() : footer,
            defaultIsOpen: defaultOpen,
            label: formatMessage((0, (0, parcelRequire("k92cH")).default).selectStatus)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i0vxP")).default), {
            onEscape: (0, ($parcel$interopDefault($8Rkzz)))
        }, statusPopup);
    };
    const $f4607509f8535f3b$var$statusViewFooterStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTop: `2px solid ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
    var $f4607509f8535f3b$export$2e2bcd8739ae039 = $f4607509f8535f3b$export$a11134e1462e763;
});
parcelRegister("6sO8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d332aa7c19a695ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    function $d332aa7c19a695ac$export$2e2bcd8739ae039(props) {
        const { border: border, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BlanketContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BackgroundContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$Background, {
            border: border
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$ComponentContainer, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$SpinnerContainer, {
            role: "status",
            "aria-label": "Loading"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), null)));
    }
    $d332aa7c19a695ac$export$2e2bcd8739ae039.defaultProps = {
        border: true
    };
    const $d332aa7c19a695ac$var$BlanketContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$BackgroundContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$Background = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { border: border, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
                __cmplp.border ? "_19it1qih" : "_19itglyw",
                __cmplp.className
            ])
        });
    });
    const $d332aa7c19a695ac$var$ComponentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i0vxP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e488d7f69150a6e1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fW62l = parcelRequire("fW62l");
    class $e488d7f69150a6e1$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                onEscape: null,
                onEnter: null,
                onBlur: null,
                className: undefined
            };
        }
        componentDidMount() {
            if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
        }
        componentWillUnmount() {
            if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
        }
        render() {
            return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                onBlur: this.props.onBlur,
                ref: this.setRef,
                className: this.props.className
            }, this.props.children));
        }
        constructor(...args){
            super(...args), this.setRef = (ref)=>{
                this.ref = ref;
            }, this.handleKeyDown = (event)=>{
                switch(event.keyCode){
                    case (0, ($parcel$interopDefault($fW62l)))('escape'):
                        if (this.props.onEscape) {
                            this.props.onEscape(event);
                            event.stopPropagation();
                        }
                        break;
                    case (0, ($parcel$interopDefault($fW62l)))('enter'):
                        if (this.props.onEnter) {
                            this.props.onEnter(event);
                            event.stopPropagation();
                        }
                        break;
                    default:
                        break;
                }
            };
        }
    }
});
parcelRegister("fW62l", function(module, exports) {
    function keyCode(searchInput) {
        if (searchInput && 'object' === typeof searchInput) {
            var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
            if (hasKeyCode) searchInput = hasKeyCode;
        }
        if ('number' === typeof searchInput) return names[searchInput];
        var search = String(searchInput);
        var foundNamedKey = codes[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        var foundNamedKey = aliases[search.toLowerCase()];
        if (foundNamedKey) return foundNamedKey;
        if (search.length === 1) return search.charCodeAt(0);
        return undefined;
    }
    keyCode.isEventKey = function isEventKey(event, nameOrCode) {
        if (event && 'object' === typeof event) {
            var keyCode = event.which || event.keyCode || event.charCode;
            if (keyCode === null || keyCode === undefined) return false;
            if (typeof nameOrCode === 'string') {
                var foundNamedKey = codes[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
                var foundNamedKey = aliases[nameOrCode.toLowerCase()];
                if (foundNamedKey) return foundNamedKey === keyCode;
            } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
            return false;
        }
    };
    exports = module.exports = keyCode;
    var codes = exports.code = exports.codes = {
        'backspace': 8,
        'tab': 9,
        'enter': 13,
        'shift': 16,
        'ctrl': 17,
        'alt': 18,
        'pause/break': 19,
        'caps lock': 20,
        'esc': 27,
        'space': 32,
        'page up': 33,
        'page down': 34,
        'end': 35,
        'home': 36,
        'left': 37,
        'up': 38,
        'right': 39,
        'down': 40,
        'insert': 45,
        'delete': 46,
        'command': 91,
        'left command': 91,
        'right command': 93,
        'numpad *': 106,
        'numpad +': 107,
        'numpad -': 109,
        'numpad .': 110,
        'numpad /': 111,
        'num lock': 144,
        'scroll lock': 145,
        'my computer': 182,
        'my calculator': 183,
        ';': 186,
        '=': 187,
        ',': 188,
        '-': 189,
        '.': 190,
        '/': 191,
        '`': 192,
        '[': 219,
        '\\': 220,
        ']': 221,
        "'": 222
    };
    var aliases = exports.aliases = {
        'windows': 91,
        "\u21E7": 16,
        "\u2325": 18,
        "\u2303": 17,
        "\u2318": 91,
        'ctl': 17,
        'control': 17,
        'option': 18,
        'pause': 19,
        'break': 19,
        'caps': 20,
        'return': 13,
        'escape': 27,
        'spc': 32,
        'spacebar': 32,
        'pgup': 33,
        'pgdn': 34,
        'ins': 45,
        'del': 46,
        'cmd': 91
    };
    for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
    for(var i = 48; i < 58; i++)codes[i - 48] = i;
    for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
    for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
    var names = exports.names = exports.title = {};
    for(i in codes)names[codes[i]] = i;
    for(var alias in aliases)codes[alias] = aliases[alias];
});
parcelRegister("17mYr", function(module, exports) {
    $parcel$export(module.exports, "TEST_ID_PREFIX", ()=>$390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
    $parcel$export(module.exports, "StatusLozenge", ()=>$390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
    $parcel$export(module.exports, "WrappedStatusLozenge", ()=>$390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $9yOBd;
    var $5LWLA;
    var $dC5iT;
    var $5ILhZ;
    var $8CUq3;
    var $aQhlk;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    var $kGDYq;
    var $5Ax7l;
    var $4YeLF;
    const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
    const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            width: 12,
            height: 12,
            viewBox: "5 5 13 13"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
            fill: "currentColor",
            fillRule: "evenodd"
        }));
    const $390c5e7bc7d9c77b$var$StatusLozengeNew = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
            "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
        }, isEditable === true || shouldShowDropdownIndication === true ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ax7l")).Lozenge), {
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
            label: ""
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Ax7l")).Lozenge), {
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, name)), hasHoverState && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
        }));
    const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
        const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...others } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
            xcss: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? $390c5e7bc7d9c77b$var$pressableStyles : $390c5e7bc7d9c77b$var$pressableStylesOld,
            ref: targetRef,
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {}
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
            ...others,
            isEditable: isEditable
        }));
    };
    const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YeLF")).LozengeOld), null, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
            label: ""
        })));
    const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
            hasHoverState: hasHoverState,
            statusCategoryId: statusCategory.id,
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
            ref: targetRef,
            "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
        }, isEditable === true || shouldShowDropdownIndication === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4YeLF")).LozengeOld), null, name)));
    const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
        const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yOBd")).default), {
            ref: targetRef,
            appearance: "subtle",
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            theme: (currentTheme, themeProps)=>{
                const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
                return {
                    buttonStyles: {
                        ...buttonStyles,
                        backgroundColor: 'transparent',
                        margin: 0,
                        width: 'auto',
                        height: 'auto',
                        padding: 0,
                        border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $829f609a65d26a98$exports).R300})` : 'transparent'}`,
                        borderRadius: '5px',
                        ...isEditable === true ? undefined : {
                            cursor: 'auto'
                        },
                        outline: 0,
                        boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})` : 'transparent'}`,
                        '& > span': {
                            margin: 0
                        },
                        '&:focus, &:focus-within': {
                            boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $829f609a65d26a98$exports).B200})`}`
                        }
                    },
                    spinnerStyles: spinnerStyles
                };
            },
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {
                interactionName: 'auto-generated.jira-issue-field-status.common.ui.status-lozenge.button'
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
            ...other,
            isEditable: isEditable
        }));
    };
    const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
    const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld);
    const $390c5e7bc7d9c77b$var$StyledLozenge = (0, $47bDC.default).span.withConfig({
        componentId: "wv585u-0"
    })`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).text : !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("aQhlk")).textColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]] : (0, (0, parcelRequire("aQhlk")).textColorOld)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).bg : (0, (0, parcelRequire("aQhlk")).bgColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).text : (0, (0, parcelRequire("aQhlk")).textHoverColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, (0, parcelRequire("aQhlk")).disabledColor).bg : (0, (0, parcelRequire("aQhlk")).bgHoverColor)[(0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
            pointerEvents: 'none'
        })}}}`;
    const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o",
                (0, (0, parcelRequire("kGDYq")).isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $390c5e7bc7d9c77b$var$StatusContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                (0, (0, parcelRequire("kGDYq")).isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
                __cmplp.className
            ])
        });
    });
    const $390c5e7bc7d9c77b$var$pressableStylesOld = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: 'none',
        padding: 'space.0',
        borderRadius: '3px',
        background: 'transparent',
        position: 'relative',
        width: '100%'
    });
    const $390c5e7bc7d9c77b$var$pressableStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        border: 'none',
        padding: 'space.0',
        borderRadius: '3px',
        background: 'transparent',
        position: 'relative',
        maxWidth: '100%'
    });
    const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'absolute',
        inset: '0',
        borderRadius: '3px',
        marginRight: 'space.025',
        ':hover': {
            opacity: 0.3,
            backgroundColor: 'color.background.inverse.subtle'
        }
    });
});
parcelRegister("aQhlk", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryToThemeMap", ()=>$58bc751e3aa4b554$export$d9e35f42afe1e488);
    $parcel$export(module.exports, "bgColor", ()=>$58bc751e3aa4b554$export$7dcbec377a25efc6);
    $parcel$export(module.exports, "textColor", ()=>$58bc751e3aa4b554$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "textColorOld", ()=>$58bc751e3aa4b554$export$26ac04004fa4ead4);
    $parcel$export(module.exports, "bgHoverColor", ()=>$58bc751e3aa4b554$export$69fdf3ba928b4c77);
    $parcel$export(module.exports, "textHoverColor", ()=>$58bc751e3aa4b554$export$99ec0cf2cf1b2082);
    $parcel$export(module.exports, "disabledColor", ()=>$58bc751e3aa4b554$export$b70f10fc4a6ba453);
    const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
    const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
    const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
    const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
        '1': $58bc751e3aa4b554$export$61137dce61763ec3,
        '2': $58bc751e3aa4b554$export$61137dce61763ec3,
        '3': $58bc751e3aa4b554$export$132676d06d92ad48,
        '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
    };
    const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`
    };
    const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    };
    const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    };
    const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $829f609a65d26a98$export$5f71e19f3a7ad9de)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $829f609a65d26a98$export$a49394138f7b8e85)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
    };
    const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
        [$58bc751e3aa4b554$export$61137dce61763ec3]: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        [$58bc751e3aa4b554$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        [$58bc751e3aa4b554$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`
    };
    const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
        bg: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$1ce2d1575d444ceb)})`,
        text: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$export$f563ee71e9ee74cd)})`
    };
});
parcelRegister("kGDYq", function(module, exports) {
    $parcel$export(module.exports, "isTabularGridFieldsEnabled", ()=>$4b98d8a4e0ed63d5$export$9605b1d5fe0c238b);
    var $co1wz;
    const $4b98d8a4e0ed63d5$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
    const $4b98d8a4e0ed63d5$export$9605b1d5fe0c238b = ()=>(0, (0, parcelRequire("co1wz")).ff)($4b98d8a4e0ed63d5$export$455240e4be839479, false);
});
parcelRegister("5Ax7l", function(module, exports) {
    $parcel$export(module.exports, "Lozenge", ()=>$bcba81c28add5d02$export$a31cbe1bf5463979);
    var $5uXOq = parcelRequire("5uXOq");
    var $lj8SI;
    var $aQhlk;
    const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
            appearance: (0, (0, parcelRequire("aQhlk")).statusCategoryToThemeMap)[statusCategoryId],
            isBold: true,
            ...isDisabled ? {
                style: {
                    color: (0, (0, parcelRequire("aQhlk")).disabledColor).text,
                    backgroundColor: (0, (0, parcelRequire("aQhlk")).disabledColor).bg
                }
            } : {}
        }, children);
});
parcelRegister("4YeLF", function(module, exports) {
    $parcel$export(module.exports, "LozengeOld", ()=>$bbacf745a667099a$export$26089816624d22fc);
    var $5uXOq = parcelRequire("5uXOq");
    const $bbacf745a667099a$var$containerStyles = {
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-block',
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-bold, 700)",
        maxWidth: '100%',
        padding: 0,
        textTransform: 'uppercase',
        verticalAlign: 'top'
    };
    const $bbacf745a667099a$var$contentStyles = {
        boxSizing: 'border-box',
        display: 'inline-block',
        maxWidth: 200,
        overflow: 'hidden',
        padding: `0 ${"var(--ds-space-050, 4px)"}`,
        textOverflow: 'ellipsis',
        verticalAlign: 'top',
        whiteSpace: 'nowrap',
        width: '100%'
    };
    const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: $bbacf745a667099a$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: $bbacf745a667099a$var$contentStyles
        }, children));
    $bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';
});
parcelRegister("44VbI", function(module, exports) {
    $parcel$export(module.exports, "isOnlyGlobalTransitions", ()=>$d665573e03a66c7e$export$10992041bf7e444a);
    $parcel$export(module.exports, "getFilteredOrderedTransitions", ()=>$d665573e03a66c7e$export$707115549202b9e4);
    $parcel$export(module.exports, "getLoopedTransitionsForStatus", ()=>$d665573e03a66c7e$export$38146914a8d06579);
    $parcel$export(module.exports, "transformOptions", ()=>$d665573e03a66c7e$export$8f4ed8ef83bcbf04);
    $parcel$export(module.exports, "getStatusShape", ()=>$d665573e03a66c7e$export$e2dafe47b17b2cfc);
    var $8QpSo;
    var $gULOk;
    const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
    const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
    const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
    const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, (0, parcelRequire("8QpSo")).default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
    const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
    const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
    const $d665573e03a66c7e$export$38146914a8d06579 = (0, (0, parcelRequire("8QpSo")).default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
    const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
                label: t.to.name,
                value: t.id,
                transition: t
            }));
    const $d665573e03a66c7e$var$memoizedTranformOptions = (0, (0, parcelRequire("8QpSo")).default)($d665573e03a66c7e$var$formatOptions);
    const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
    const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
        const statusCategoryId = (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[category] || (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).UNDEFINED];
        return {
            id: id,
            name: name,
            statusCategory: {
                id: statusCategoryId,
                name: name
            }
        };
    };
});
parcelRegister("kTnV4", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteStatusView", ()=>$95d268cd8622d793$export$d907a4132fe8618c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2NMNM;
    var $imUQY;
    var $lj8SI;
    var $5p1kJ;
    var $7C5Su;
    var $e34gT;
    var $eG9rp;
    var $6NI23;
    var $1Kt4o;
    var $fVMIs;
    var $jh7L9;
    var $jiSaf;
    var $d8lE2;
    var $cSD7y;
    var $koVbs;
    var $2gCtH;
    var $c6XT1;
    var $8zOmE;
    var $iokLh;
    var $99Vn3;
    var $fBoWB;
    const $95d268cd8622d793$export$3b70c533639eedc2 = ({ childrenProps: childrenProps, statusViewProps: statusViewProps })=>{
        const { setLoading: setLoading, setChildResult: setChildResult } = childrenProps;
        const { wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, isLoading: isLoading, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation } = statusViewProps;
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const issueId = (0, (0, parcelRequire("c6XT1")).useIssueAri)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { saveStatusField: saveStatusField } = (0, (0, parcelRequire("99Vn3")).useSaveStatusField)(issueKey, issueId, onUpdateStatusMutation);
        const loadTransitions = (0, $5uXOq.useCallback)(()=>{
            if (!wasFetchSuccessful) return {
                commands: []
            };
            const transitionCommands = transitions.map((transition)=>({
                    id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                    name: transition.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                                transition: transition
                            }, {
                                addTransitionArrowSpacing: true
                            }))
                    },
                    keywords: (0, (0, parcelRequire("fBoWB")).getTransitionKeywords)(transition),
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                hasScreen: transition.hasScreen,
                                isConditional: transition.isConditional
                            });
                            saveStatusField(transition, ()=>{
                                onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                            });
                        }
                    },
                    analytics: {
                        action: 'changeStatus',
                        actionCategory: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS)
                    }
                }));
            const commands = [
                {
                    id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                    name: currentStatus.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                                isBold: true
                            }, currentStatus.name)), (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, (0, parcelRequire("iokLh")).messages).current)))
                    },
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: (0, ($parcel$interopDefault($8Rkzz)))
                    }
                },
                ...transitionCommands
            ];
            return {
                commands: commands
            };
        }, [
            createAnalyticsEvent,
            currentStatus.id,
            currentStatus.name,
            currentStatus.statusCategory.id,
            formatMessage,
            onSuccess,
            renderTransition,
            saveStatusField,
            transitions,
            wasFetchSuccessful
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setLoading(isLoading);
        }, [
            isLoading,
            setLoading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setChildResult(loadTransitions());
        }, [
            loadTransitions,
            setChildResult
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Body, childrenProps);
    };
    const $95d268cd8622d793$export$3d254fd4c446ee4 = (props)=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const subscribeCommands = (0, (0, parcelRequire("fVMIs")).useSubscribeCommands)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ expandedCommand: expandedCommand, isOpen: isOpen }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const { onFetch: onFetch } = props;
        const renderChildren = (0, $5uXOq.useCallback)((childrenProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$export$3b70c533639eedc2, {
                childrenProps: childrenProps,
                statusViewProps: props
            }), [
            props
        ]);
        const renderHeader = (0, $5uXOq.useCallback)((base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NI23")).CommandFieldHeader), {
                ...base,
                issueKey: issueKey
            }), [
            issueKey
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const statusCommand = {
                id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
                name: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus),
                shortcut: 'd',
                placeholder: formatMessage((0, (0, parcelRequire("iokLh")).messages).searchTransition),
                keywords: getKeywords('changeStatusSynonyms'),
                section: (0, (0, parcelRequire("e34gT")).getCommandPaletteIssueActionsHeader)(issueKey),
                priority: (0, (0, parcelRequire("7C5Su")).getCommandPaletteIssueActionsPriority)('STATUS'),
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                            label: ""
                        })
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST,
                    fallback: {
                        onNoResults: {
                            label: formatMessage((0, (0, parcelRequire("iokLh")).messages).fallbackNoResults)
                        }
                    },
                    components: {
                        Body: renderChildren,
                        Header: renderHeader
                    }
                },
                analytics: {
                    action: 'changeStatusMenu'
                }
            };
            const unsubscribe = subscribeCommands((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
                statusCommand
            ]);
            return ()=>unsubscribe();
        }, [
            formatMessage,
            getKeywords,
            issueKey,
            renderChildren,
            renderHeader,
            subscribeCommands
        ]);
        const expandedCommandId = expandedCommand?.id;
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774) && onFetch) onFetch(createAnalyticsEvent({}));
        }, [
            expandedCommandId,
            isOpen,
            onFetch,
            createAnalyticsEvent
        ]);
        return null;
    };
    const $95d268cd8622d793$export$679497264cbfbf73 = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
        const issueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        const subscribeCommands = (0, (0, parcelRequire("fVMIs")).useSubscribeCommands)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteExpandedCommand)();
        const renderHeader = (0, $5uXOq.useCallback)((base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6NI23")).CommandFieldHeader), {
                ...base,
                issueKey: issueKey
            }), [
            issueKey
        ]);
        const issueId = (0, (0, parcelRequire("c6XT1")).useIssueAri)();
        const { saveStatusField: saveStatusField } = (0, (0, parcelRequire("99Vn3")).useSaveStatusField)(issueKey, issueId, onUpdateStatusMutation);
        const expandedCommandId = expandedCommand?.id;
        const loadTransitions = (0, $5uXOq.useCallback)(()=>{
            if (!wasFetchSuccessful) return {
                commands: []
            };
            const transitionCommands = transitions.map((transition)=>({
                    id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                    name: transition.name,
                    components: {
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                                transition: transition
                            }, {
                                addTransitionArrowSpacing: true
                            })),
                        LeftIcon: !expandedCommandId ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                                label: ""
                            }) : undefined
                    },
                    keywords: (0, (0, parcelRequire("fBoWB")).getTransitionKeywords)(transition),
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: ()=>{
                            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                hasScreen: transition.hasScreen,
                                isConditional: transition.isConditional
                            });
                            saveStatusField(transition, ()=>{
                                onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                            });
                        }
                    },
                    analytics: {
                        action: 'changeStatus',
                        actionCategory: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS)
                    }
                }));
            const currentCommand = expandedCommandId ? [
                {
                    id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                    name: currentStatus.name,
                    components: {
                        LeftIcon: !expandedCommandId ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                                label: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus)
                            }) : undefined,
                        Name: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lj8SI")).default), {
                                isBold: true
                            }, currentStatus.name)), (0, ($parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, (0, parcelRequire("iokLh")).messages).current)))
                    },
                    primaryAction: {
                        type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                        perform: (0, ($parcel$interopDefault($8Rkzz)))
                    }
                }
            ] : [];
            const commands = [
                ...currentCommand,
                ...transitionCommands
            ];
            return {
                commands: commands
            };
        }, [
            createAnalyticsEvent,
            currentStatus.id,
            currentStatus.name,
            currentStatus.statusCategory.id,
            formatMessage,
            onSuccess,
            renderTransition,
            saveStatusField,
            transitions,
            wasFetchSuccessful,
            expandedCommandId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const { commands: commands } = loadTransitions();
            const statusCommand = {
                id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
                name: formatMessage((0, (0, parcelRequire("iokLh")).messages).editStatus),
                shortcut: 'd',
                placeholder: formatMessage((0, (0, parcelRequire("iokLh")).messages).searchTransition),
                keywords: getKeywords('changeStatusSynonyms'),
                section: (0, (0, parcelRequire("e34gT")).getCommandPaletteIssueActionsHeader)(issueKey),
                priority: (0, (0, parcelRequire("7C5Su")).getCommandPaletteIssueActionsPriority)('STATUS'),
                components: {
                    LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("imUQY"))))), {
                            label: ""
                        })
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST,
                    fallback: {
                        onNoResults: {
                            label: formatMessage((0, (0, parcelRequire("iokLh")).messages).fallbackNoResults)
                        }
                    },
                    components: {
                        Header: renderHeader
                    },
                    commands: commands
                },
                analytics: {
                    action: 'changeStatusMenu'
                }
            };
            const unsubscribe = subscribeCommands((0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
                statusCommand
            ]);
            return ()=>unsubscribe();
        }, [
            formatMessage,
            getKeywords,
            issueKey,
            loadTransitions,
            renderHeader,
            subscribeCommands,
            expandedCommand?.id
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && onFetch) onFetch(createAnalyticsEvent({}));
        }, [
            isOpen,
            onFetch,
            createAnalyticsEvent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
        }, [
            expandedCommandId,
            isOpen,
            loadTransitions,
            setChildCommands
        ]);
        return null;
    };
    const $95d268cd8622d793$export$d907a4132fe8618c = (0, (0, parcelRequire("cSD7y")).componentWithFG)('command_palette_improve_status', $95d268cd8622d793$export$679497264cbfbf73, $95d268cd8622d793$export$3d254fd4c446ee4);
    const $95d268cd8622d793$var$TransitionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $95d268cd8622d793$var$SelectedStatusContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $95d268cd8622d793$var$CurrentStatusContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1a45",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("imUQY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d5f661f66d7a7026$var$_react = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $d5f661f66d7a7026$var$_task = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("4xPlE")));
    function $d5f661f66d7a7026$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d5f661f66d7a7026$var$TaskIcon = (props)=>$d5f661f66d7a7026$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $d5f661f66d7a7026$var$_task.default
        }));
    $d5f661f66d7a7026$var$TaskIcon.displayName = 'TaskIcon';
    var $d5f661f66d7a7026$var$_default = module.exports.default = $d5f661f66d7a7026$var$TaskIcon;
});
parcelRegister("4xPlE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $34f2132ab88342e6$var$_UNSAFE_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $34f2132ab88342e6$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $34f2132ab88342e6$var$TaskIcon = (props)=>$34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M3 14.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25Z"/>`
        }, props));
    $34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
    var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;
});
parcelRegister("7C5Su", function(module, exports) {
    $parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", ()=>$235d212bb3595e05$export$5164bb42fa883371);
    const $235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
        STATUS: 10,
        SUMMARY: 20,
        PARENT: 30,
        LINK_ISSUE: 40,
        CONTENT_FIRST_TAB: 50,
        PINNED_FIELDS: 60,
        DETAILS: 70,
        CONTENT_OTHER_TABS: 80,
        MORE_FIELDS: 90,
        OLD_ISSUE_FIELDS: 95,
        ADD_COMMENT: 100,
        GQL_FIELDS: 105,
        SUB_HEADER_ITEMS: 110,
        ISSUE_HEADER_ITEMS: 120
    };
    const $235d212bb3595e05$export$5164bb42fa883371 = (key)=>$235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];
});
parcelRegister("e34gT", function(module, exports) {
    $parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", ()=>$4ea99408c4a58cd0$export$cd9931655a8cfb04);
    var $5p1kJ;
    const $4ea99408c4a58cd0$export$cd9931655a8cfb04 = (issueKey)=>`${0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;
});
parcelRegister("eG9rp", function(module, exports) {
    $parcel$export(module.exports, "useCommandKeywords", ()=>$61ebfb9239c4f8e5$export$4d8fe3ef6385358);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dYWZb;
    const $61ebfb9239c4f8e5$export$4d8fe3ef6385358 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const getKeywords = (0, $5uXOq.useCallback)((keywordGroup)=>(0, (0, parcelRequire("dYWZb")).messages)[keywordGroup] ? formatMessage((0, (0, parcelRequire("dYWZb")).messages)[keywordGroup]) : undefined, [
            formatMessage
        ]);
        return {
            getKeywords: getKeywords
        };
    };
});
parcelRegister("dYWZb", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$df7d7dd7b88156b7$export$defe85febe8b728c);
    var $7VHMR;
    const $df7d7dd7b88156b7$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        searchYourIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
            "defaultMessage": "Find my ideas tickets requests tasks work"
        },
        changeStatusSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
            "defaultMessage": "Move through workflow  Progress Done Complete transition"
        },
        assignToMeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
            "defaultMessage": "self"
        },
        assignIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
            "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
        },
        startWatchingIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
            "defaultMessage": "Follow work Track Unwatch Unfollow"
        },
        backlogSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
            "defaultMessage": "Inventory Go"
        },
        boardSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
            "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
        },
        reportsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
            "defaultMessage": "Summary Insights Burndown Go"
        },
        timelineSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
            "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
        },
        quickSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
            "defaultMessage": "Search products across Atlassian Go to"
        },
        pageSearchSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
            "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
        },
        createIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
            "defaultMessage": "work Start idea New ticket task"
        },
        switchDarkThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
            "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        matchSystemThemeSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
            "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
        },
        copyCurrentPageUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
            "defaultMessage": "link website address"
        },
        getHelpSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
            "defaultMessage": "In-product Support Documentation Questions Answers"
        },
        viewKeyboardShortcutsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
            "defaultMessage": "Hotkeys Show See"
        },
        editDescriptionSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
            "defaultMessage": "Completion criteria Info Information Details Add Write"
        },
        addAttachmentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
            "defaultMessage": "Attach Upload Document Media"
        },
        addCommentSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
            "defaultMessage": "Write Message"
        },
        logWorkSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
            "defaultMessage": "Track Record hours Time spent"
        },
        addRemoveFlagSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
            "defaultMessage": "Unflag Mark Unmark Star Unstar"
        },
        cloneIssueSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
            "defaultMessage": "Copy Duplicate Task Idea Request"
        },
        linkConfluencePageSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
            "defaultMessage": "Relate Add Connect"
        },
        addAUrlSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
            "defaultMessage": "Connect Weblink Link Website Domain"
        },
        goToIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
            "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
        },
        goToPersonalSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
            "defaultMessage": "Preferences Notifications Theme Jira labs"
        },
        goToAccountSettingsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
            "defaultMessage": "Preferences Privacy Profile Your details Personal information"
        },
        viewAllIssuesSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
            "defaultMessage": "Site issues JQL View all"
        },
        viewAllProjectsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllPlansSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllBoardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllFiltersSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
            "defaultMessage": "List Go"
        },
        viewAllDashboardsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
            "defaultMessage": "List Go"
        },
        checkNotificationsSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
            "defaultMessage": "window See Updates"
        },
        goToUserManagementSynonyms: {
            "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
            "defaultMessage": "Permissions"
        }
    });
});
parcelRegister("6NI23", function(module, exports) {
    $parcel$export(module.exports, "CommandFieldHeader", ()=>$aaa7a329c29139ae$export$c6444eb1c6f44b2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $luBm6;
    var $jiSaf;
    var $2w83X;
    const $aaa7a329c29139ae$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Header, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("luBm6")).default), {
            space: "space.200"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w83X")).IssueTag), {
            issueKey: issueKey
        }), children));
});
parcelRegister("jiSaf", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dOktC;
    var $haBRL;
    var $dE25F;
    var $d4iCz;
    const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children, ...rest })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('fix_compal_name_wrapper')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), rest, children);
    };
    const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
        CommandRow: (0, parcelRequire("haBRL")).CommandRow,
        Name: $44cb4d9bf5d8b8a6$var$NameComponent,
        LeftIcon: (0, $5uXOq.Fragment),
        Wrapper: (0, $5uXOq.Fragment),
        Footer: (0, parcelRequire("dE25F")).Footer,
        Body: (0, (0, parcelRequire("dOktC")).CommandPaletteBody),
        Header: (0, parcelRequire("d4iCz")).Header
    };
});
parcelRegister("dOktC", function(module, exports) {
    $parcel$export(module.exports, "NoResultsContainer", ()=>$2bc4c9970ded9a96$export$2ab569a6937cb4e4);
    $parcel$export(module.exports, "CommandPaletteBody", ()=>$2bc4c9970ded9a96$export$b1023de69a8756e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2NMNM;
    var $4R6GH;
    var $d8lE2;
    var $gM5ou;
    var $bYCTm;
    var $38IFv;
    var $cLshs;
    var $4nfzy;
    var $eKTyH;
    var $5aF2z;
    var $64ZBB;
    const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const onHoverCommand = (index)=>{
            if (index === undefined) return;
            setActiveIndex(index);
        };
        const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
            executeCommand(result.command, {
                method: 'mouse',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result),
                    ...(0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
                }
            }, (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event));
        }, [
            activeRegistry,
            createAnalyticsEvent,
            executeCommand,
            registry
        ]);
        const localResultRefs = resultsRefs.current;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
            "data-testid": (0, (0, parcelRequire("5aF2z")).NO_RESULTS_TEST_ID)
        }, noResultsFallback), results.map((result, index)=>{
            if (result.isGroup) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYCTm")).CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                group: result.group,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
                "data-testid": (0, (0, parcelRequire("5aF2z")).GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nfzy")).CommandRowErrorBoundary), {
                key: index,
                teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
                onError: ()=>removeCommandsById([
                        result.command.id
                    ]),
                attributes: (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38IFv")).CommandPaletteSearchResultListItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                id: result.command.id,
                active: result.active,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKTyH")).CommandRow), {
                index: index,
                isSearchFieldFocused: isSearchFieldFocused,
                result: result,
                onHoverCommand: (ev)=>{
                    if (ev.movementX === 0 && ev.movementY === 0) return;
                    onHoverCommand(result.index);
                },
                onClickCommand: (event)=>onClickCommand(event, result),
                onMouseDownCommand: onMouseDownCommand
            })));
        }), renderAfterCommands?.({}));
    };
    const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
        const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
        const resultsRefs = (0, $5uXOq.useRef)([]);
        const modalBodyRef = (0, $5uXOq.useRef)(null);
        const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
            setActiveIndex(newActiveIndex);
        }, [
            setActiveIndex
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
            setPrevActiveIndex(activeIndex);
            const scrollTo = activeIndex > prevActiveIndex ? (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END : (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START;
            const scrollToIndex = (0, (0, parcelRequire("64ZBB")).getScrollToIndex)(results, activeIndex, scrollTo);
            const scrolledToResult = resultsRefs.current[scrollToIndex];
            if (scrolledToResult && !(0, (0, parcelRequire("64ZBB")).isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
                const lastIndex = results.length - 1;
                const firstIndex = results.findIndex((result)=>!result.isGroup);
                if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
                else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
                else {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('compal_smooth_transition_on_size_change')) {
                        (0, (0, parcelRequire("64ZBB")).scrollResultIntoView)({
                            target: scrolledToResult,
                            direction: scrollTo,
                            scrollContainer: modalBodyRef.current
                        });
                        return;
                    }
                    (0, (0, parcelRequire("64ZBB")).scrollResultIntoViewOld)(scrolledToResult, scrollTo);
                }
            }
        }, [
            activeIndex,
            prevActiveIndex,
            results
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current?.scrollTo) return;
            modalBodyRef.current.scrollTo(0, 0);
        }, [
            expandedCommand,
            search
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchFieldFocused) return ()=>{};
            const handleArrowScroll = (ev)=>{
                if (ev.key === 'ArrowUp') {
                    ev.preventDefault();
                    activeIndex > 0 && onArrowScroll(activeIndex - 1);
                }
                if (ev.key === 'ArrowDown') {
                    ev.preventDefault();
                    activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
                }
            };
            window.addEventListener('keydown', handleArrowScroll);
            return ()=>{
                window.removeEventListener('keydown', handleArrowScroll);
            };
        }, [
            isSearchFieldFocused,
            total,
            activeIndex,
            setActiveIndex,
            onArrowScroll
        ]);
        const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
            fallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLshs")).CommandPaletteSearchResultListWrapper), {
            ref: modalBodyRef,
            noResultsFallback: noResultsFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
            results: results,
            noResultsFallback: noResultsFallback,
            renderAfterCommands: renderAfterCommands,
            resultsRefs: resultsRefs
        }));
    };
    const $2bc4c9970ded9a96$var$GroupContainerComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_h2xaw7": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
                __cmplp.className
            ])
        });
    });
    const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _syaz1e9r _1yt4wd81",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bYCTm", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", ()=>$85a6ab23a77e1ea6$export$591c26128e5fd757);
    var $5uXOq = parcelRequire("5uXOq");
    const $85a6ab23a77e1ea6$export$591c26128e5fd757 = (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
            ...rest
        }));
});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';
parcelRegister("38IFv", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListItem", ()=>$9082b0edc4f10018$export$1f8fa9d1eef77b32);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {
                'aria-current': active,
                role: 'menuitem'
            } : {
                'aria-selected': active,
                role: 'option'
            },
            id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
            ...rest
        }));
});
parcelRegister("cLshs", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", ()=>$42c35fc284860d36$export$95554f6fb39a83c2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $zfug2;
    var $6LGvc;
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const resizerRef = (0, $5uXOq.useRef)(null);
        const height = (0, (0, parcelRequire("6LGvc")).useSmoothExpand)(resizerRef);
        (0, $5uXOq.useEffect)(()=>{
            if (ref && 'current' in ref && ref.current) {
                const currentRef = ref.current;
                currentRef.style.height = `${height}px`;
            }
        }, [
            height,
            ref
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $42c35fc284860d36$var$wrapperStyles,
            testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            ref: resizerRef,
            direction: "column",
            gap: "space.050"
        }, children));
    });
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($42c35fc284860d36$var$Wrapper, {
            "data-testid": (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        });
    });
    const $42c35fc284860d36$export$95554f6fb39a83c2 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('compal_smooth_transition_on_size_change', $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew, $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld);
    const $42c35fc284860d36$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
                __cmplp.className
            ])
        });
    });
    const $42c35fc284860d36$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: '0',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        transition: 'height 0.15s ease-out',
        overflowY: 'auto',
        maxHeight: '376px'
    });
});
parcelRegister("zfug2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2745ea1cb0c1a200$export$defe85febe8b728c);
    var $7VHMR;
    const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commandPaletteSearchResultListBoxLabel: {
            "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
            "defaultMessage": "List of commands"
        }
    });
});
parcelRegister("6LGvc", function(module, exports) {
    $parcel$export(module.exports, "useSmoothExpand", ()=>$38452c6bcba6455a$export$674ba8b02d2bfe86);
    var $5uXOq = parcelRequire("5uXOq");
    const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
    const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
    const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
    const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
        const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
        const callback = (0, $5uXOq.useCallback)(()=>{
            const contentClientHeight = content.current?.clientHeight;
            if (!contentClientHeight) return;
            if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
            else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
        }, [
            content
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (content.current && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(content.current);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            callback,
            content
        ]);
        return height;
    };
});
parcelRegister("4nfzy", function(module, exports) {
    $parcel$export(module.exports, "CommandRowErrorBoundary", ()=>$53a0c321a39d3b85$export$223f3c3c93a14a83);
    var $5uXOq = parcelRequire("5uXOq");
    var $7CMCs;
    const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: "command-palette-row",
            packageName: "jiraCommandPalette",
            fallback: "unmount",
            teamName: teamName,
            onError: onError,
            attributes: attributes
        }, children);
});
parcelRegister("eKTyH", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$9e51067b4d29f53f$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $haBRL;
    const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
        const { command: command } = result;
        const isActive = !!(result.active && isSearchFieldFocused);
        const isFirstCommand = result.index === 0;
        const rowProps = {
            index: index,
            isActive: isActive,
            command: command,
            isFirstCommand: isFirstCommand,
            onMouseMove: onHoverCommand,
            onClick: onClickCommand,
            onMouseDown: onMouseDownCommand,
            analyticsAttributes: (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result)
        };
        if (command.components?.CommandRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("haBRL")).CommandRow), rowProps);
    };
});
parcelRegister("haBRL", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$04586313afa284d7$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $dzeHJ;
    var $3m7XM;
    var $3sBlN;
    const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
        const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
            "data-testid": command.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
            index: index,
            active: isActive,
            "data-active": isActive,
            "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
            "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
            "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
        }, command.components?.LeftIcon && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
            alignItems: "center",
            justifyContent: "center",
            xcss: [
                $04586313afa284d7$var$iconStyles,
                isActive && $04586313afa284d7$var$iconActiveStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
            "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
            active: isActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), {
            "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
        }, command.mode)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3m7XM")).RenderCommandName), {
            command: command,
            isActive: isActive
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sBlN")).RightContent), {
            command: command,
            isFirstCommand: isFirstCommand,
            isActive: isActive
        }))));
    };
    const $04586313afa284d7$var$CommandContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _syazjjyb _1yt4swc3",
                !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainerInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandIconsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px',
        color: 'color.icon.subtle'
    });
    const $04586313afa284d7$var$iconActiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.icon'
    });
    const $04586313afa284d7$var$CommandLeftIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
                __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandLeftIconAndNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dzeHJ", function(module, exports) {
    $parcel$export(module.exports, "OutlinedLozenge", ()=>$0f9445e21ac061f1$export$224f9ad7f31e0de6);
    $parcel$export(module.exports, "FilledLozenge", ()=>$0f9445e21ac061f1$export$586a428fe10f5ae0);
    $parcel$export(module.exports, "SearchLozenge", ()=>$0f9445e21ac061f1$export$2ccc7861eeb7b337);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0f9445e21ac061f1$var$Lozenge = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _11c8qk37 _vwz41crf _syaz1aqp",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$224f9ad7f31e0de6 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81u0j _k48p1pd9 _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$586a428fe10f5ae0 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _11c81u0j _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
                __cmplp.className
            ])
        });
    });
    const $0f9445e21ac061f1$export$2ccc7861eeb7b337 = (0, $5uXOq.forwardRef)(({ as: C = $0f9445e21ac061f1$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4otz2 _1bsb1ris _11c81oud _vwz4dlk8 _bfhk1yrq",
                __cmplp.className
            ])
        });
    });
});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';
parcelRegister("3m7XM", function(module, exports) {
    $parcel$export(module.exports, "RenderCommandName", ()=>$c1bc24527d77cdc3$export$931d3f1d35f6c058);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hWZau;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $gGkxR;
    const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
        const renderCommandName = (0, $5uXOq.useCallback)(()=>{
            if (command.components?.Name) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
                isActive: isActive
            }, command.name);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGkxR")).TruncateWithTooltipOnActive), {
                isActive: isActive
            }, command.name);
        }, [
            command,
            isActive
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
            active: isActive
        }, command.breadcrumb?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
        }, command.breadcrumb.map((BreadCrumb, index, arr)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
                isParent: index !== arr.length - 1,
                "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
                active: isActive
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
                isActive: isActive
            })), index !== arr.length - 1 && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                justifyContent: "center",
                xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
                alignItems: "center",
                testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
                "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })))))) : renderCommandName());
    };
    const $c1bc24527d77cdc3$var$CommandNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
                __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_zek046": (0, (0, parcelRequire("lD23V")).default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N400})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !!__cmplp.isParent && "_syaz1bu1",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n _syazjwct",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px'
    });
});
parcelRegister("gGkxR", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnActive", ()=>$e999625ec19f201d$export$4495aca3d261add0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $k5uoT;
    var $jgArx;
    var $k7xca;
    const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!shouldShowTooltip,
            autoFocus: false,
            placement: "bottom-end",
            popupComponent: (0, (0, parcelRequire("jgArx")).PopupComponent),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
                }, children),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TriggerComponent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                    ...triggerProps
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).tooltip()
        });
    const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
        const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            xcss: [
                $e999625ec19f201d$var$tooltipContainerStyles,
                !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
            ]
        }, children), isActive && (0, ($parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
            shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
        }, showTooltip && customTooltip ? customTooltip : children));
    };
    const $e999625ec19f201d$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        flexGrow: 1,
        textTransform: 'none'
    });
    const $e999625ec19f201d$var$truncateTooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("jgArx", function(module, exports) {
    $parcel$export(module.exports, "TooltipComponent", ()=>$3c6ba86682bb18eb$export$e18e2f8e82cdc428);
    $parcel$export(module.exports, "TriggerComponent", ()=>$3c6ba86682bb18eb$export$534fc570264a52a4);
    $parcel$export(module.exports, "TooltipTrigger", ()=>$3c6ba86682bb18eb$export$8c610744efcf8a1d);
    $parcel$export(module.exports, "PopupComponent", ()=>$3c6ba86682bb18eb$export$9fac2d040f3ed438);
    $parcel$export(module.exports, "TruncateWithTooltipContainer", ()=>$3c6ba86682bb18eb$export$8cae238d61c8405a);
    $parcel$export(module.exports, "TooltipContent", ()=>$3c6ba86682bb18eb$export$e9003e2be37ec060);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $btzsC;
    var $koVbs;
    var $6nFD4;
    const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
            ...props,
            ref: ref
        }));
    const $3c6ba86682bb18eb$export$534fc570264a52a4 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
            ...props,
            role: "button",
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("6nFD4")).messages).tooltipTriggerAriaLabel)
        });
    });
    const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
            ...props,
            ref: ref
        }, children));
    const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$var$StyledPopupPrimitive = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8cae238d61c8405a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$e9003e2be37ec060 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1jfi _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8c610744efcf8a1d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6nFD4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87d1d47436abe24f$export$defe85febe8b728c);
    var $7VHMR;
    const $87d1d47436abe24f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltipTriggerAriaLabel: {
            "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
            "defaultMessage": "Command palette tool tip"
        }
    });
});
const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;
parcelRegister("k7xca", function(module, exports) {
    $parcel$export(module.exports, "useTruncatedTooltip", ()=>$ad951546dfa9fa2c$export$94b118b3187f12c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
        const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
        const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("gM5ou")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        (0, $5uXOq.useEffect)(()=>{
            const container = containerRef.current;
            if (!container) return;
            if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
            else setIsTruncated(false);
        }, [
            setIsTruncated,
            containerRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isTruncated && tooltipDelay === 0) {
                setShouldShowTruncatedTooltip(true);
                return ()=>{};
            }
            if (isTruncated && tooltipDelay > 0) {
                setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
                return ()=>{};
            }
            setShouldShowTruncatedTooltip(false);
            return ()=>{};
        }, [
            isTruncated,
            setShouldShowTruncatedTooltip,
            tooltipDelay,
            setTimeoutFunc
        ]);
        return {
            shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
        };
    };
});
const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';
parcelRegister("3sBlN", function(module, exports) {
    $parcel$export(module.exports, "RightContent", ()=>$a83ca30f957fd273$export$11dbab4b39f15d6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h1toL;
    var $koVbs;
    var $gM5ou;
    var $iLhkq;
    var $dSJBv;
    var $kbnU6;
    var $lHtdH;
    const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const transitionStep = (0, (0, parcelRequire("lHtdH")).useHoverTransitionStep)(command, isActive, isFirstCommand);
        const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gM5ou")).hasChildren)(command), [
            command
        ]);
        const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
        if (!shouldRenderRightContent) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
            "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
            label: formatMessage((0, (0, parcelRequire("iLhkq")).messages).rightChevronLabel)
        })), !!command.shortcut && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
            "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
            shouldHaveTransition: commandHasChildren,
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSJBv")).Shortcuts), {
            shortcut: command.shortcut
        })));
    };
    const $a83ca30f957fd273$var$animationFadeIn = null;
    const $a83ca30f957fd273$var$animationFadeOut = null;
    const $a83ca30f957fd273$var$RightContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$CommandRightChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
});
const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $0296d551a7f83620$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';
parcelRegister("iLhkq", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf35cee6e1d1204b$export$defe85febe8b728c);
    var $7VHMR;
    const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rightChevronLabel: {
            "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
            "defaultMessage": "Command with children icon"
        }
    });
});
parcelRegister("dSJBv", function(module, exports) {
    $parcel$export(module.exports, "Shortcuts", ()=>$57e6d30b2626ce39$export$b326d77e4b8b7664);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $bcTvL;
    var $gM5ou;
    var $dzeHJ;
    var $esPgL;
    const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).FilledLozenge), {
            "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
        }, shortcut));
    const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
            "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
        }, divisor);
    const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
        const replacer = replacers.shift();
        if (!replacer) {
            acc.push({
                type: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY,
                key: shortcut
            });
            types.push((0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY);
            return [
                acc,
                types
            ];
        }
        shortcut.split(replacer.char).forEach((str, index, self)=>{
            $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
            if (index < self.length - 1) {
                acc.push({
                    type: replacer.replacement
                });
                types.push(replacer.replacement);
            }
        });
        return [
            acc,
            types
        ];
    };
    const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, (0, parcelRequire("koVbs")).default)();
    const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
        const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
        const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, (0, parcelRequire("gM5ou")).getShortcutSpecialCharacters)()), [
            shortcut
        ]);
        const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
            if (types.length === 3) {
                if (types[0] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) {
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN) return (0, (0, parcelRequire("esPgL")).messages).shortcutThen;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR) return (0, (0, parcelRequire("esPgL")).messages).shortcutOr;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS) return (0, (0, parcelRequire("esPgL")).messages).shortcutPlus;
                }
            }
            return null;
        }, [
            types
        ]);
        const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
            switch(type){
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorThen);
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorOr);
                default:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorPlus);
            }
        }, [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
            "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
            "aria-hidden": true
        }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
            shortcutA: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[0].key
            }),
            shortcutB: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[2].key
            }),
            divisor: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                    divisor: chunk
                })
        }) : shortcuts.map((obj, index)=>{
            if (obj.type === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                key: index,
                shortcut: obj.key
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                key: index,
                divisor: formatTypeToMessage(obj.type)
            });
        }));
    };
    const $57e6d30b2626ce39$var$ShortcutDivider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8otz2",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$export$cde89099db64abe3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';
parcelRegister("esPgL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f430d579edd6c91$export$defe85febe8b728c);
    var $7VHMR;
    const $4f430d579edd6c91$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shortcutThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
            "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
        },
        shortcutOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
            "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
        },
        shortcutPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
            "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
        },
        divisorThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
            "defaultMessage": "then"
        },
        divisorOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
            "defaultMessage": "or"
        },
        divisorPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
            "defaultMessage": "+"
        }
    });
});
parcelRegister("kbnU6", function(module, exports) {
    $parcel$export(module.exports, "TRANSITION_STEP", ()=>$d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
    $parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$82cfc253a6c33f59);
    $parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$e092796a9af3633b);
    $parcel$export(module.exports, "TRANSITION_DURATION_MS", ()=>$d865f5b0afeb3acd$export$1cad4f611a1c0229);
    var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9;
    (function(TRANSITION_STEP) {
        TRANSITION_STEP["INITIAL"] = "initial";
        TRANSITION_STEP["DELAYING"] = "delaying";
        TRANSITION_STEP["TRANSITIONING"] = "transitioning";
        TRANSITION_STEP["FINISHED"] = "finished";
        TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
        TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    })($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 || ($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = {}));
    const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
    const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
    const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;
});
parcelRegister("lHtdH", function(module, exports) {
    $parcel$export(module.exports, "useHoverTransitionStep", ()=>$9c0e762a7fdf0cdc$export$eefd045a02bab4c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWt6p;
    var $jcw0u;
    var $gM5ou;
    var $kbnU6;
    const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
        const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
        const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        const timerRef = (0, $5uXOq.useRef)(null);
        const isReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const commandHasChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(command);
        (0, $5uXOq.useEffect)(()=>{
            setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
            if (timerRef.current) clearTimeout(timerRef.current);
        }, [
            command
        ]);
        const startTimerForNextStep = (nextStep, durationMs)=>{
            timerRef.current = setTimeout(()=>{
                setTransitionStep(nextStep);
                timerRef.current = null;
            }, durationMs);
        };
        const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
            if (isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED);
            else setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        }, [
            isActive
        ]);
        const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
            switch(transitionStep){
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL:
                    if (isActive) {
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING);
                        startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, (0, parcelRequire("kbnU6")).TRANSITION_INITIAL_DELAY_TIME_MS) : (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING:
                    if (!isActive) {
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = null;
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING:
                    if (isActive) {
                        if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                        if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED:
                    if (!isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT);
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    break;
                default:
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: new Error('Invalid transition step for command'),
                        meta: {
                            id: 'useTransitionStep',
                            packageName: 'jiraCommandPalette',
                            teamName: 'deliveroo'
                        }
                    });
            }
        }, [
            command.shortcut,
            hasTransitionedFirstCommand,
            isActive,
            isFirstCommand,
            transitionStep
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (commandHasChildren) {
                if (isReducedMotion) handleReducedMotionTransition();
                else handleWithMotionTransition();
            }
        }, [
            commandHasChildren,
            isReducedMotion,
            handleReducedMotionTransition,
            handleWithMotionTransition
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isFirstCommand) setHasTransitionedFirstCommand(false);
        }, [
            isFirstCommand
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            }, []);
        return transitionStep;
    };
});
parcelRegister("5aF2z", function(module, exports) {
    $parcel$export(module.exports, "GROUP_TEST_ID", ()=>$7ecce3582144481d$export$d83f892940e54128);
    $parcel$export(module.exports, "NO_RESULTS_TEST_ID", ()=>$7ecce3582144481d$export$bf182a53106ca02e);
    $parcel$export(module.exports, "SCROLL_DIRECTION", ()=>$7ecce3582144481d$export$a6d65a8fb7b912d6);
    const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
    const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
    const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
    const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
    const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
    var $7ecce3582144481d$export$a6d65a8fb7b912d6;
    (function(SCROLL_DIRECTION) {
        SCROLL_DIRECTION["START"] = "start";
        SCROLL_DIRECTION["END"] = "end";
    })($7ecce3582144481d$export$a6d65a8fb7b912d6 || ($7ecce3582144481d$export$a6d65a8fb7b912d6 = {}));
});
parcelRegister("64ZBB", function(module, exports) {
    $parcel$export(module.exports, "isElementVisibleInContainer", ()=>$6b9215d3fa38a855$export$b9dc8b6556026098);
    $parcel$export(module.exports, "getScrollToIndex", ()=>$6b9215d3fa38a855$export$56068eb4c4e3a63c);
    $parcel$export(module.exports, "scrollResultIntoView", ()=>$6b9215d3fa38a855$export$6be8a7238febd54f);
    $parcel$export(module.exports, "scrollResultIntoViewOld", ()=>$6b9215d3fa38a855$export$5ebacb7632dd32c7);
    var $gM5ou;
    var $5aF2z;
    const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
        const modalBodyRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
    };
    const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
        const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START && commandResultIndex > 0) {
            const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (prevActiveCommandIndex === -1) return 0;
        }
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (afterActiveCommandIndex === -1) return results.length - 1;
            return commandResultIndex;
        }
        const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
        return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
    };
    const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
        const targetRect = target.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const gapScroll = 4;
        if (direction === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = targetRect.bottom - containerRect.top;
            const amountToScroll = commandPosition - containerRect.height;
            const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
            scrollContainer.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = containerRect.top - targetRect.top;
            const amountToScroll = scrollContainer.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollContainer.scrollTo({
                top: pos
            });
        }
    };
    const $6b9215d3fa38a855$export$5ebacb7632dd32c7 = (scrollToResult, scrollTo)=>{
        if (!scrollToResult?.parentElement) return;
        const parent = scrollToResult.parentElement;
        const elemRect = scrollToResult.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const gapScroll = 4;
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = elemRect.bottom - parentRect.top;
            const amountToScroll = commandPosition - parentRect.height;
            const pos = amountToScroll + gapScroll + parent.scrollTop;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = parentRect.top - elemRect.top;
            const amountToScroll = parent.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        }
    };
});
parcelRegister("dE25F", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$842574a5e4b1a419$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
        const footerChildren = children || defaultFooterContent;
        if (!footerChildren) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
            "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
        }, footerChildren);
    };
    const $842574a5e4b1a419$var$ModalFooter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_mrkb1kw7 _1o0z1kw7 _1yt49l6b _x3doh6cr",
                __cmplp.className
            ])
        });
    });
});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';
parcelRegister("d4iCz", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$82822f3e363fec07$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82822f3e363fec07$var$headerStyles,
            testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
        }, children);
    const $82822f3e363fec07$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        padding: 'space.200',
        borderBottom: `solid 1px ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';
parcelRegister("2w83X", function(module, exports) {
    $parcel$export(module.exports, "IssueTag", ()=>$2ba2b027b9044740$export$a342a0ad2c552031);
    var $5uXOq = parcelRequire("5uXOq");
    var $f5TWP;
    var $8CUq3;
    var $eMpK2;
    var $jIHzq;
    var $co1wz;
    var $2gCtH;
    var $7wNl6;
    var $80wkc;
    const $2ba2b027b9044740$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
        const issueId = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') ? (0, (0, parcelRequire("2gCtH")).useIssueId)() : undefined;
        const [{ value: summary }] = (0, (0, parcelRequire("80wkc")).useSummaryField)({
            issueKey: issueKey,
            issueId: issueId
        });
        const [{ value: issueType }] = (0, (0, parcelRequire("7wNl6")).useIssueTypeField)({
            issueKey: issueKey
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $2ba2b027b9044740$var$issueTagContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f5TWP")).default), {
            xcss: $2ba2b027b9044740$var$issueTagStyles,
            space: "space.050",
            alignBlock: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eMpK2")).IssueLeftIcon), {
            issueTypeName: issueType?.name,
            iconUrl: issueType?.iconUrl
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jIHzq")).TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
    };
    const $2ba2b027b9044740$var$issueTagContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '100%',
        minWidth: '0'
    });
    const $2ba2b027b9044740$var$issueTagStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        maxWidth: '100%',
        padding: 'space.050',
        backgroundColor: 'color.background.neutral',
        borderRadius: 'border.radius.100',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        color: 'color.text.subtle',
        lineHeight: 1
    });
});
parcelRegister("eMpK2", function(module, exports) {
    $parcel$export(module.exports, "IssueLeftIcon", ()=>$f381ae85157eafc9$export$b1b562672a76ad84);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $dXXlv;
    const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: iconUrl,
            alt: formatMessage((0, (0, parcelRequire("dXXlv")).messages).issueIconAltText, {
                issueTypeName: issueTypeName
            }),
            height: "16"
        });
    };
});
parcelRegister("dXXlv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$91c46772185cf0df$export$defe85febe8b728c);
    var $7VHMR;
    const $91c46772185cf0df$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueIconAltText: {
            "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
            "defaultMessage": "Icon for the issue type {issueTypeName}"
        }
    });
});
parcelRegister("jIHzq", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnHover", ()=>$386c5138d16516b4$export$b2323503daaefa);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bDjY;
    var $jgArx;
    var $k7xca;
    const $386c5138d16516b4$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $386c5138d16516b4$export$b2323503daaefa = ({ children: children })=>{
        const containerRef = $386c5138d16516b4$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: 0
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: shouldShowTruncatedTooltip ? ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
                }, children) : '',
            component: (0, (0, parcelRequire("jgArx")).TooltipComponent),
            position: "bottom-end",
            delay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipTrigger), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
                ...tooltipProps
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TruncateWithTooltipContainer), {
                ref: containerRef
            }, children)));
    };
});
parcelRegister("7wNl6", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypeField", ()=>$6016ffb039edefae$export$3da96c4009e089ca);
    var $9XE6b = parcelRequire("9XE6b");
    var $lQE94;
    var $54wEF;
    var $5fc53;
    const $6016ffb039edefae$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
        const [{ value: fieldConfig }] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, (0, parcelRequire("5fc53")).ISSUE_TYPE));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, (0, parcelRequire("5fc53")).ISSUE_TYPE));
        const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: null,
            onSuccess: onSuccess,
            onFailure: onFailure
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig,
                loading: loading
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("lQE94", function(module, exports) {
    $parcel$export(module.exports, "useEditField", ()=>$c31e2d123e024ddc$export$343e962d356c0af1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $3BIWb;
    var $dJl1T;
    var $4R6GH;
    var $jJZqs;
    var $fZneA;
    var $ctrpc;
    var $2gCtH;
    var $6Ou5i;
    var $afs7f;
    var $15WDX;
    var $biQrn;
    var $8zOmE;
    var $3fAi8;
    var $99cgx;
    const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
        if (!response) return null;
        if (response.fields) {
            if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
            return null;
        }
        return response;
    };
    const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
        if (!response) return false;
        if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
        return true;
    };
    const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
        const baseUrl = '';
        const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, (0, parcelRequire("99cgx")).defaultSaveField), saveFieldById: saveFieldById = (0, (0, parcelRequire("99cgx")).defaultSaveFieldById), addValuesToField: addValuesToField = (0, (0, parcelRequire("99cgx")).defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, (0, parcelRequire("99cgx")).defaultRemoveValuesFromField), onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))) } = fieldOptions;
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
        const [error, setError] = (0, $5uXOq.useState)(null);
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const resetError = (0, $5uXOq.useCallback)(()=>{
            if (isMounted.current) setError(null);
        }, [
            setError,
            isMounted
        ]);
        const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
            isOptimistic: true
        })=>{
            let result;
            const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
            const analyticsData = {
                editOperationType: editOperationType,
                issueId: issueId,
                fieldKey: analyticsFieldKeyAlias ?? fieldKey,
                fieldType: actualFieldType
            };
            if (isMounted.current) {
                setLoading(true);
                setError(null);
            }
            try {
                onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
                if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
                result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
                const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
                $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
                onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                    analytics: analyticsEvent,
                    attributes: {
                        fieldType: actualFieldType
                    }
                });
            } catch (ex) {
                result = Promise.reject(ex);
                onFailure(ex, valuesForOperation);
                setFieldValue(issueKey, fieldKey, fieldValue);
                if (isMounted.current) setError(ex);
                const isValidationError = ex instanceof (0, (0, parcelRequire("jJZqs")).ValidationError);
                if (!isValidationError) (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                    fieldKey: fieldKey,
                    fieldType: analyticsFieldTypeAlias ?? fieldType,
                    isValidationError: isValidationError,
                    isClientFetchError: (0, (0, parcelRequire("fZneA")).isClientFetchError)(ex)
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) (0, (0, parcelRequire("ctrpc")).getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
            }
            if (isMounted.current) setLoading(false);
            return result;
        }, [
            issueId,
            analyticsFieldKeyAlias,
            fieldKey,
            analyticsFieldTypeAlias,
            fieldType,
            isMounted,
            onSubmit,
            fieldValue,
            setFieldValue,
            issueKey,
            onSuccess,
            onFailure,
            mapNonOptimisticResponse
        ]);
        const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
            editFieldValue,
            saveField
        ]);
        const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
                isOptimistic: false
            }), [
            editFieldValue,
            saveFieldById
        ]);
        const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
            editFieldValue,
            addValuesToField
        ]);
        const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
            editFieldValue,
            removeValuesFromField
        ]);
        return [
            {
                value: fieldValue,
                loading: loading,
                error: error
            },
            {
                saveById: saveById,
                saveValue: saveValue,
                addValues: addValues,
                removeValues: removeValues,
                resetError: resetError
            }
        ];
    };
    const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
        const contextualIssueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        const contextualIssueKey = (0, (0, parcelRequire("2gCtH")).useIssueKey)();
        return contextualIssueKey === issueKey ? contextualIssueId : null;
    };
    const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
        if (!meta || typeof meta === 'object') return {
            ...meta ?? {},
            isEditFromIssueView: isEditFromIssueView
        };
        return meta;
    };
    const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
        const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, ($parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, ($parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, ($parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
        const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, (0, parcelRequire("15WDX")).useIssueViewFieldUpdateEvents)();
        const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
        const issueId = issueIdFromFieldOptions ?? contextualIssueId;
        const isEditFromIssueView = (0, (0, parcelRequire("6Ou5i")).useIsEditFromIssueView);
        const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
            onSubmit(oldValue, newValue, meta, event);
            issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
        }, [
            fieldChangeRequested,
            fieldKey,
            issueId,
            onSubmit
        ]);
        const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
            onSuccess(fieldValue);
            issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, isEditFromIssueView(event)) : meta);
            if (!shouldPreventIssueViewSoftRefresh && !isEditFromIssueView(event)) try {
                const reason = (0, (0, parcelRequire("afs7f")).Reason).SoftRefresh;
                await (0, (0, parcelRequire("3BIWb")).default).refreshIssuePageThrowable(issueKey, reason);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
            }
        }, [
            fieldChanged,
            fieldKey,
            shouldPreventIssueViewSoftRefresh,
            isEditFromIssueView,
            issueId,
            issueKey,
            onSuccess
        ]);
        const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
            onFailure(error, failedValue);
            issueId && fieldChangeFailed(issueId, fieldKey);
        }, [
            fieldChangeFailed,
            fieldKey,
            issueId,
            onFailure
        ]);
        return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
            ...fieldOptions,
            onSubmit: onSubmitFn,
            onSuccess: onSuccessFn,
            onFailure: onFailureFn
        });
    };
});
parcelRegister("3BIWb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b65e83eb4ced9ce9$export$2e2bcd8739ae039);
    var $afs7f;
    const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
    const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
    const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
        document.addEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
        document.removeEventListener(event, callback);
    };
    const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
    const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = (0, (0, parcelRequire("afs7f")).Reason).OnDemand)=>{
        try {
            document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
                detail: [
                    issueKey,
                    {
                        mergeIntoCurrent: false,
                        reason: reason
                    }
                ]
            }));
            return Promise.resolve();
        } catch (e) {
            return Promise.reject(e);
        }
    };
    const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>$b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
    var $b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
        addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
        removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
        addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
        removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
        refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
        refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
    };
});
parcelRegister("afs7f", function(module, exports) {
    $parcel$export(module.exports, "Reason", ()=>$90b3aba4b3cc23bb$export$fe867595c4640fb1);
    const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
        OnDemand: 'ON_DEMAND',
        SoftRefresh: 'SOFT_REFRESH',
        Realtime: 'REALTIME'
    };
});
parcelRegister("ctrpc", function(module, exports) {
    $parcel$export(module.exports, "getUpdateAnalyticsFlowHelper", ()=>$a32e213c0a4381f7$export$f3b2b77402b2631f);
    var $7Jxgt = parcelRequire("7Jxgt");
    var $dJl1T;
    var $4R6GH;
    var $8zOmE;
    var $8ikZj;
    var $bximr;
    class $a32e213c0a4381f7$var$EventFlowManager {
        reset() {
            this.ids.clear();
            this.extraAttributes.clear();
        }
        push(key) {
            const id = (0, ($parcel$interopDefault($7Jxgt))).v4();
            this.ids.set(key, id);
            return id;
        }
        pull(key, shouldDelete = true) {
            const value = this.ids.get(key);
            if (shouldDelete) this.ids.delete(key);
            return value;
        }
        constructor(){
            this.ids = new Map();
            this.extraAttributes = new Map();
        }
    }
    const $a32e213c0a4381f7$export$87846400a9b428fc = new $a32e213c0a4381f7$var$EventFlowManager();
    const $a32e213c0a4381f7$var$concatAttributes = (fieldKey, updateSessionId, attributes)=>{
        let fieldTypeValue = attributes.fieldType;
        const extraAttributes = $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.get(fieldKey);
        if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) fieldTypeValue = extraAttributes?.fieldType ?? fieldTypeValue;
        const FIELD_TYPE_MAP = (0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg') ? (0, (0, parcelRequire("8ikZj")).FIELD_TYPE_MAP) : (0, (0, parcelRequire("8ikZj")).FIELD_TYPE_MAP_OLD);
        const fieldType = fieldTypeValue && FIELD_TYPE_MAP[fieldTypeValue] ? FIELD_TYPE_MAP[fieldTypeValue] : fieldTypeValue;
        return {
            updateSessionId: updateSessionId,
            ...(0, (0, parcelRequire("8ikZj")).DEFAULT_ATTRIBUTES),
            ...attributes,
            ...extraAttributes,
            fieldKey: fieldKey,
            fieldType: fieldType
        };
    };
    const $a32e213c0a4381f7$var$hasError = (e)=>e instanceof Error;
    const $a32e213c0a4381f7$var$updateAnalyticsFlowHelper = {
        fireAnalyticsStart (fieldKey, params) {
            try {
                if ((0, (0, parcelRequire("4R6GH")).fg)('one_event_rules_them_all_fg')) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, params.attributes);
                const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.push(fieldKey);
                const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(params.analytics, `${(0, (0, parcelRequire("8ikZj")).START_ACTION_SUBJECT)} ${(0, (0, parcelRequire("8ikZj")).START_ACTION)}`, (0, (0, parcelRequire("8ikZj")).START_ACTION_SUBJECT_ID), attributes);
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsStart', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
            }
        },
        fireAnalyticsEnd (fieldKey, params, isEndOfSession = true) {
            try {
                const sessionid = $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey, isEndOfSession);
                const attributes = $a32e213c0a4381f7$var$concatAttributes(fieldKey, sessionid, params.attributes);
                if (isEndOfSession) $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(params.analytics, `${(0, (0, parcelRequire("8ikZj")).END_ACTION_SUBJECT)} ${(0, (0, parcelRequire("8ikZj")).END_ACTION)}`, (0, (0, parcelRequire("8ikZj")).END_ACTION_SUBJECT_ID), attributes);
            } catch (e) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('issue.analytics.services.update-issue-field.fireAnalyticsEnd', $a32e213c0a4381f7$var$hasError(e) ? e.toString() : 'unknown error');
            }
        },
        setAttributes (fieldKey, attributes) {
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.set(fieldKey, attributes);
        },
        setActionTakenAttributes (fieldKey, oldValId, newValId) {
            if (oldValId !== newValId) this.setAttributes(fieldKey, {
                oldValId: oldValId,
                newValId: newValId,
                actionTaken: (0, (0, parcelRequire("bximr")).getActionTaken)(oldValId, newValId)
            });
        },
        endSession (fieldKey) {
            $a32e213c0a4381f7$export$87846400a9b428fc.pull(fieldKey);
            $a32e213c0a4381f7$export$87846400a9b428fc.extraAttributes.delete(fieldKey);
        },
        reset () {
            $a32e213c0a4381f7$export$87846400a9b428fc.reset();
        }
    };
    const $a32e213c0a4381f7$export$f3b2b77402b2631f = ()=>$a32e213c0a4381f7$var$updateAnalyticsFlowHelper;
});
parcelRegister("8ikZj", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ATTRIBUTES", ()=>$ba1d12fd09beb370$export$69665899d8392309);
    $parcel$export(module.exports, "START_ACTION", ()=>$ba1d12fd09beb370$export$c0a4673e0c78e972);
    $parcel$export(module.exports, "START_ACTION_SUBJECT", ()=>$ba1d12fd09beb370$export$34a5ae354a38cc7e);
    $parcel$export(module.exports, "START_ACTION_SUBJECT_ID", ()=>$ba1d12fd09beb370$export$bc373f59492dc6e2);
    $parcel$export(module.exports, "END_ACTION", ()=>$ba1d12fd09beb370$export$b19686c1fe99f85a);
    $parcel$export(module.exports, "END_ACTION_SUBJECT", ()=>$ba1d12fd09beb370$export$4ce67e80878d47ed);
    $parcel$export(module.exports, "END_ACTION_SUBJECT_ID", ()=>$ba1d12fd09beb370$export$e3d957ccc2d46469);
    $parcel$export(module.exports, "FIELD_TYPE_MAP_OLD", ()=>$ba1d12fd09beb370$export$403ea87111529de);
    $parcel$export(module.exports, "FIELD_TYPE_MAP", ()=>$ba1d12fd09beb370$export$d8ccf495ccc97a69);
    $parcel$export(module.exports, "ENTITY_FIELD_KEYS", ()=>$ba1d12fd09beb370$export$7d9dd31e187cb2db);
    var $5fc53;
    const $ba1d12fd09beb370$export$69665899d8392309 = {
        isInlineEditing: false,
        isCommandPaletteEditing: false,
        isDragEditing: false
    };
    const $ba1d12fd09beb370$export$c0a4673e0c78e972 = 'clicked';
    const $ba1d12fd09beb370$export$34a5ae354a38cc7e = 'item';
    const $ba1d12fd09beb370$export$bc373f59492dc6e2 = 'issue';
    const $ba1d12fd09beb370$export$b19686c1fe99f85a = 'updated';
    const $ba1d12fd09beb370$export$4ce67e80878d47ed = 'issue';
    const $ba1d12fd09beb370$export$e3d957ccc2d46469 = 'ended';
    const $ba1d12fd09beb370$export$403ea87111529de = {
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: 'singleUserPicker',
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: 'versions',
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: 'versions',
        [(0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)]: 'organizations',
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: 'link',
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: 'multiVersion',
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: 'singleSelect',
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: 'multiSelect',
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: 'singleUser',
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: 'radio',
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: 'url',
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: 'singleGroup',
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: 'multiGroup'
    };
    const $ba1d12fd09beb370$export$d8ccf495ccc97a69 = {
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: 'affectsVersions',
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: 'singleUserPicker',
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: 'attachment',
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: 'cascadingSelect',
        [(0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)]: 'components',
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: 'date',
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: 'dateTime',
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: 'fixVersions',
        [(0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE)]: 'flag',
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: 'goals',
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: 'singleGroup',
        [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)]: 'issuetype',
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: 'labels',
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: 'checkbox',
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: 'multiGroup',
        [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE)]: 'multiSelect',
        [(0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: 'multiVersion',
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: 'float',
        [(0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)]: 'organizations',
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: 'parent',
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: 'multiUser',
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: 'priority',
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: 'project',
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: 'radio',
        [(0, (0, parcelRequire("5fc53")).RANK_CF_TYPE)]: 'status',
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: 'singleSelect',
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: 'sprint',
        [(0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE)]: 'storyPointEstimate',
        [(0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE)]: 'storyPointEstimate',
        [(0, (0, parcelRequire("5fc53")).STATUS_TYPE)]: 'status',
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: 'richText',
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: 'singleLineText',
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: 'originalTimeEstimate',
        [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)]: 'timeTracking',
        [(0, (0, parcelRequire("5fc53")).URL_CF_TYPE)]: 'url',
        [(0, (0, parcelRequire("5fc53")).USER_CF_TYPE)]: 'singleUser',
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: 'version',
        [(0, (0, parcelRequire("5fc53")).VOTES_TYPE)]: 'votes',
        [(0, (0, parcelRequire("5fc53")).WATCHES_TYPE)]: 'watchers'
    };
    const $ba1d12fd09beb370$export$7d9dd31e187cb2db = {
        WEB_LINK: 'weblink',
        ATTACHMENT: 'attachment',
        ISSUE_LINKS: 'link'
    };
});
parcelRegister("bximr", function(module, exports) {
    $parcel$export(module.exports, "getActionTaken", ()=>$440267fcdb63291a$export$9d814e3464362b48);
    const $440267fcdb63291a$export$9d814e3464362b48 = (oldValId, newValId)=>{
        if (oldValId !== newValId) {
            if (newValId === null) return 'remove';
            if (oldValId === null || oldValId === undefined) return 'add';
        }
        return undefined;
    };
});
parcelRegister("6Ou5i", function(module, exports) {
    $parcel$export(module.exports, "useIsEditFromIssueView", ()=>$b57bb78db332aa99$export$870b996a6c1c7896);
    var $hBuqR;
    var $lhVtI;
    const $b57bb78db332aa99$export$870b996a6c1c7896 = (event)=>{
        const ISSUE_VIEW_SOURCES = [
            'fullIssueScreen',
            'boardIssueViewScreen',
            'agility-backlogScreen',
            'issueNavigatorEmbeddedIssueViewScreen',
            'globalIssueNavigatorIssueScreen',
            'mobileIssueScreen',
            'classicRoadmapScreen',
            'roadmapScreen',
            'versionDetailsIssueScreen',
            'bitbucketIssueScreen',
            'jsmQueueAgentViewSidebarScreen',
            'viewQueueIssueScreen',
            'jswModalIssueAppScreen',
            'jwmModalIssueAppScreen',
            'jswSidebarIssueAppScreen',
            'jwmSidebarIssueAppScreen'
        ];
        const { payload: { source: source } } = (0, (0, parcelRequire("lhVtI")).getEvent)(event);
        if (!source) return false;
        if (ISSUE_VIEW_SOURCES.includes(source)) return true;
        if (source.startsWith((0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3))) return true;
        return false;
    };
});
parcelRegister("15WDX", function(module, exports) {
    $parcel$export(module.exports, "useIssueViewFieldUpdateEvents", ()=>$947bdf396d8056bc$export$444af741f6d8f512);
    $parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", ()=>$947bdf396d8056bc$export$f9eb49cc2f0e28ce);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $5YMLs;
    var $3z81P;
    const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
            if (typeof eventHandler !== 'function') return ()=>{};
            const { eventHandlers: eventHandlers } = getState();
            const typeEventHandlers = eventHandlers[type];
            setState({
                eventHandlers: {
                    ...eventHandlers,
                    [type]: typeEventHandlers.concat([
                        eventHandler
                    ])
                }
            });
            return ()=>{
                const { eventHandlers: eventHandlersForUnregister } = getState();
                const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
                const newTypeEventHandlers = typeEventHandlersForUnregister.filter((handler)=>handler !== eventHandler);
                setState({
                    eventHandlers: {
                        ...eventHandlersForUnregister,
                        [type]: newTypeEventHandlers
                    }
                });
            };
        };
    const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    fieldId: fieldId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_FAILED
                });
            });
        };
    const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
            let value = fieldValue;
            if (aggFieldChangeProps) value = (0, (0, parcelRequire("5YMLs")).transformAggToLegacy)({
                fieldValue: fieldValue,
                aggFieldChangeProps: aggFieldChangeProps
            });
            const eventHandlers = getState().eventHandlers.onChange;
            eventHandlers.forEach((eventHandler)=>{
                eventHandler({
                    issueId: issueId,
                    meta: {
                        fieldId: fieldId,
                        fieldValue: value,
                        additionalProperties: additionalProperties
                    },
                    type: (0, (0, parcelRequire("3z81P")).ChangeEventTypes).FIELD_CHANGE_REQUESTED
                });
            });
        };
    const $947bdf396d8056bc$var$actions = {
        fieldChanged: $947bdf396d8056bc$var$fieldChanged,
        fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
        fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
        registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
    };
    const $947bdf396d8056bc$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-view-field-update-events',
        initialState: {
            eventHandlers: {
                onChange: []
            }
        },
        actions: $947bdf396d8056bc$var$actions
    });
    const $947bdf396d8056bc$export$444af741f6d8f512 = (0, (0, parcelRequire("3sQ5x")).createHook)($947bdf396d8056bc$var$store, {
        selector: null
    });
    const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, (0, parcelRequire("gg7kZ")).createContainer)($947bdf396d8056bc$var$store);
});
parcelRegister("5YMLs", function(module, exports) {
    $parcel$export(module.exports, "transformAggToLegacy", ()=>$1da8cbd2b672325c$export$d951e3c38e10736d);
    var $bMD69;
    var $5fc53;
    var $1pF6B;
    var $lTnWS;
    const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
        if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
        switch(aggFieldChangeProps.__typename){
            case 0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).URL_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD:
            case 0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type
                })?.value;
            case 0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD:
                return (0, (0, parcelRequire("lTnWS")).transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
            case 0, (0, parcelRequire("5fc53")).PARENT_GQL_FIELD:
                return (0, (0, parcelRequire("1pF6B")).transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
            case 0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    ...fieldValue
                })?.value;
            case 0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    originalEstimate: fieldValue.originalEstimate,
                    remainingEstimate: fieldValue.remainingEstimate,
                    timeSpent: fieldValue.timeSpent
                })?.value;
            case 0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    selectedOptions: fieldValue.selectedOptions,
                    checkboxesFieldOptions: fieldValue.fieldOptions
                })?.value;
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD:
                return (0, (0, parcelRequire("bMD69")).transformAggFieldToLegacyField)({
                    __typename: aggFieldChangeProps.__typename,
                    type: aggFieldChangeProps.type,
                    components: fieldValue.components,
                    selectedComponentsConnection: fieldValue.selectedComponentsConnection
                })?.value;
            default:
                throw new Error('__typename not implemented');
        }
    };
    const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
        const VALUE_KEYS = {
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: 'text',
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: 'number',
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: 'priority',
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: 'user',
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: 'date',
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: 'project',
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: 'dateTime',
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: 'uri',
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: 'securityLevel',
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: 'watch',
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: 'vote',
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: 'color',
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: 'issueType',
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: 'resolution',
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: 'status',
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: 'selectedOption',
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: 'richText'
        };
        const value = VALUE_KEYS[__typename];
        if (value) return value;
        throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
    };
});
parcelRegister("bMD69", function(module, exports) {
    $parcel$export(module.exports, "transformAggFieldToLegacyField", ()=>$af5e8bab0defb9c8$export$586ba15cbf3d3031);
    $parcel$export(module.exports, "transformAggFieldsToLegacyFields", ()=>$af5e8bab0defb9c8$export$ba106ff8c087e6b1);
    var $8QpSo;
    var $5fc53;
    var $9bgym;
    var $6iJEF;
    var $9UrtF;
    var $hsEaK;
    var $2qu1N;
    var $16Zia;
    var $iv8Rf;
    var $hDlc2;
    var $c3LW9;
    var $h92P3;
    var $aeO9V;
    var $6Tnq8;
    var $6mbsj;
    var $d3nG3;
    var $1xW6n;
    var $fW9XR;
    var $bKMMB;
    var $7JL37;
    var $dulCG;
    var $6vno6;
    var $as0vY;
    var $6dPLd;
    var $gKccZ;
    var $jnUrZ;
    var $iJtmd;
    var $iPyq0;
    var $384lj;
    var $axTS6;
    var $lfJ6H;
    var $9UXU7;
    var $b6BoU;
    var $gak3n;
    var $i47fO;
    var $gvljZ;
    var $6XFn2;
    var $6e1Ya;
    var $hBEiJ;
    var $1XNj2;
    var $f6zXW;
    var $fB4wX;
    var $cXBkk;
    var $iDKu3;
    var $aGv90;
    var $19DRh;
    var $lkW3a;
    var $lQAwK;
    var $8qOI6;
    var $cbd7V;
    var $6hj44;
    var $4nh4C;
    var $hA3EZ;
    var $2z4xE;
    var $cO2KQ;
    var $5sETx;
    var $f454b;
    var $aafIf;
    var $2yWre;
    var $lUeQj;
    var $6SWOK;
    var $cMc7B;
    var $38GNL;
    var $avV20;
    var $cbXvu;
    var $aSXJi;
    var $8uxcU;
    var $arKlm;
    var $hCKV6;
    var $d8wC0;
    const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
            [(0, (0, parcelRequire("5fc53")).AFFECTED_SERVICES_GQL_FIELD)]: (0, (0, parcelRequire("9bgym")).transformAggAffectedServicesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).BOOLEAN_GQL_FIELD)]: (0, (0, parcelRequire("9UrtF")).transformAggBooleanToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("hsEaK")).transformAggCascadingSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CHECKBOX_GQL_FIELD)]: (0, (0, parcelRequire("2qu1N")).transformAggCheckboxToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CMDB_GQL_FIELD)]: (0, (0, parcelRequire("16Zia")).transformAggCMDBToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("19DRh")).transformAggMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COMPONENTS_GQL_FIELD)]: (0, (0, parcelRequire("hDlc2")).transformAggComponentsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("c3LW9")).transformAggConnectDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("h92P3")).transformAggConnectMultipleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("aeO9V")).transformAggConnectNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("6Tnq8")).transformAggConnectRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("6mbsj")).transformAggConnectSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).CONNECT_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("d3nG3")).transformAggConnectTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).COLOR_GQL_FIELD)]: (0, (0, parcelRequire("iv8Rf")).transformAggColorToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("fW9XR")).transformAggDatePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATE_TIME_GQL_FIELD)]: (0, (0, parcelRequire("bKMMB")).transformAggDateTimePickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).EPIC_LINK_GQL_FIELD)]: (0, (0, parcelRequire("7JL37")).transformAggEpicLinkToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FLAG_GQL_FIELD)]: (0, (0, parcelRequire("dulCG")).transformAggFlagToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATETIME_GQL_FIELD)]: (0, (0, parcelRequire("as0vY")).transformAggForgeDateTimeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_DATE_GQL_FIELD)]: (0, (0, parcelRequire("6vno6")).transformAggForgeDateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUP_GQL_FIELD)]: (0, (0, parcelRequire("6dPLd")).transformAggForgeGroupToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_GROUPS_GQL_FIELD)]: (0, (0, parcelRequire("gKccZ")).transformAggForgeGroupsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("jnUrZ")).transformAggForgeNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_OBJECT_GQL_FIELD)]: (0, (0, parcelRequire("iJtmd")).transformAggForgeObjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRING_GQL_FIELD)]: (0, (0, parcelRequire("iPyq0")).transformAggForgeStringToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_STRINGS_GQL_FIELD)]: (0, (0, parcelRequire("384lj")).transformAggForgeStringsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USER_GQL_FIELD)]: (0, (0, parcelRequire("axTS6")).transformAggForgeUserToLegacyField),
            [(0, (0, parcelRequire("5fc53")).FORGE_USERS_GQL_FIELD)]: (0, (0, parcelRequire("lfJ6H")).transformAggForgeUsersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_GQL_FIELD)]: (0, (0, parcelRequire("b6BoU")).transformAggIssueRestrictionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("gak3n")).transformAggIssueTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_APPROVAL_GQL_FIELD)]: (0, (0, parcelRequire("i47fO")).transformAggJSMApprovalsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ASSETS_GQL_FIELD)]: (0, (0, parcelRequire("6iJEF")).transformAggAssetToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_MAJOR_INCIDENT_FIELD)]: (0, (0, parcelRequire("6XFn2")).transformAggJSMMajorIncidentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ORGANIZATION_GQL_FIELD)]: (0, (0, parcelRequire("6e1Ya")).transformAggJSMOrganizationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_ENTITLEMENTS_GQL_FIELD)]: (0, (0, parcelRequire("gvljZ")).transformAggJSMEntitlementsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_SENTIMENT_GQL_FIELD)]: (0, (0, parcelRequire("cXBkk")).transformAggJSMSentimentToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, (0, parcelRequire("hBEiJ")).transformAggJSMRequestFeedbackToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, (0, parcelRequire("1XNj2")).transformAggJSMRequestLanguageToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_REQUEST_TYPE_GQL_FIELD)]: (0, (0, parcelRequire("f6zXW")).transformAggJSMRequestTypeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).JSM_RESPONDERS_GQL_FIELD)]: (0, (0, parcelRequire("fB4wX")).transformAggJSMRespondersToLegacyField),
            [(0, (0, parcelRequire("5fc53")).LABEL_GQL_FIELD)]: (0, (0, parcelRequire("iDKu3")).transformAggLabelsNodeToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PRIORITY_GQL_FIELD)]: (0, (0, parcelRequire("6hj44")).transformAggPriorityToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aGv90")).transformAggMultiGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).NUMBER_GQL_FIELD)]: (0, (0, parcelRequire("8qOI6")).transformAggNumberToLegacyField),
            [(0, (0, parcelRequire("5fc53")).ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, (0, parcelRequire("cbd7V")).transformAggOriginalEstimateToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PEOPLE_GQL_FIELD)]: (0, (0, parcelRequire("lkW3a")).transformAggMultipleUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROFORMA_FORMS_GQL_FIELD)]: (0, (0, parcelRequire("4nh4C")).transformAggProformaFormsToLegacyField),
            [(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)]: (0, (0, parcelRequire("hA3EZ")).transformAggProjectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_GQL_FIELD)]: (0, (0, parcelRequire("lQAwK")).transformAggMultipleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RADIO_GQL_FIELD)]: (0, (0, parcelRequire("2z4xE")).transformAggRadioSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RICH_TEXT_GQL_FIELD)]: (0, (0, parcelRequire("5sETx")).transformAggRichTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).RESOLUTION_GQL_FIELD)]: (0, (0, parcelRequire("cO2KQ")).transformAggResolutionToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SECURITY_GQL_FIELD)]: (0, (0, parcelRequire("f454b")).transformAggSecurityLevelToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SPRINT_GQL_FIELD)]: (0, (0, parcelRequire("38GNL")).transformAggSprintToLegacyField),
            [(0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)]: (0, (0, parcelRequire("avV20")).transformAggStatusToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("aafIf")).transformAggSingleGroupPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).SINGLE_SELECT_GQL_FIELD)]: (0, (0, parcelRequire("lUeQj")).transformAggSingleSelectToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_GQL_FIELD)]: (0, (0, parcelRequire("cbXvu")).transformAggTeamToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEAM_VIEW_GQL_FIELD)]: (0, (0, parcelRequire("aSXJi")).transformAggTeamViewToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)]: (0, (0, parcelRequire("2yWre")).transformAggSingleLineTextToLegacyField),
            [(0, (0, parcelRequire("5fc53")).TIME_TRACKING_GQL_FIELD)]: (0, (0, parcelRequire("8uxcU")).transformAggTimeTrackingToLegacyField),
            [(0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)]: (0, (0, parcelRequire("6SWOK")).transformAggSingleSelectUserPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).URL_GQL_FIELD)]: (0, (0, parcelRequire("arKlm")).transformAggUrlToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VERSION_GQL_FIELD)]: (0, (0, parcelRequire("cMc7B")).transformAggSingleVersionPickerToLegacyField),
            [(0, (0, parcelRequire("5fc53")).VOTES_GQL_FIELD)]: (0, (0, parcelRequire("hCKV6")).transformAggVotesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).WATCHES_GQL_FIELD)]: (0, (0, parcelRequire("d8wC0")).transformAggWatchesToLegacyField),
            [(0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_FIELD)]: (0, (0, parcelRequire("1xW6n")).transformAggDataClassificationToLegacyField),
            [(0, (0, parcelRequire("5fc53")).GOALS_GQL_FIELD)]: (0, (0, parcelRequire("9UXU7")).transformAggGoalsToLegacyField)
        });
    const $af5e8bab0defb9c8$var$getTransformers = (0, (0, parcelRequire("8QpSo")).default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
    const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, context)=>{
        const typename = node.__typename;
        const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
        return transformer ? transformer(node, context) : undefined;
    };
    const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields)=>{
        if (fields == null) return {};
        return fields.reduce((fieldsState, fieldEdge)=>{
            if (fieldEdge?.node != null) {
                const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, fields);
                if (transformedField != null) {
                    const fieldData = 'key' in transformedField ? {
                        [transformedField.key]: transformedField
                    } : transformedField;
                    Object.assign(fieldsState, fieldData);
                }
            }
            return fieldsState;
        }, {});
    };
});
parcelRegister("9bgym", function(module, exports) {
    $parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", ()=>$0bce5d1c363f27e8$export$231e0419515441d4);
    var $5fc53;
    var $o7K5u;
    const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
            id: serviceId,
            name: name ?? undefined
        });
    const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE)) return undefined;
        const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SERVICE_ENTITY_CF_TYPE),
                items: 'service-entity-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';
parcelRegister("o7K5u", function(module, exports) {
    $parcel$export(module.exports, "transformAggNodeToLegacyField", ()=>$cfa10031dfb7ad46$export$e7ea61856a169c36);
    $parcel$export(module.exports, "transformAggConnection", ()=>$cfa10031dfb7ad46$export$daf92cda81d86cdc);
    $parcel$export(module.exports, "toLegacyConnectOption", ()=>$cfa10031dfb7ad46$export$b5de5f3d2de73afc);
    const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
            ari: 'id' in node ? node.id : undefined,
            key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
            title: 'name' in node ? node.name : '',
            editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
            required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
            autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
            allowedValues: [],
            value: null,
            schema: {
                type: 'type' in node ? node.type : '',
                custom: null,
                system: null
            },
            description: 'description' in node && node.description ? node.description : undefined
        });
    const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
        const edges = connection?.edges ?? [];
        if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
        return edges.map((edge)=>edge?.node).filter(Boolean);
    };
    const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
        if (!node) return null;
        return {
            value: node.value ?? null,
            id: parseInt(node.optionId, 10)
        };
    };
});
parcelRegister("6iJEF", function(module, exports) {
    $parcel$export(module.exports, "transformAggAssetToLegacyField", ()=>$b9f6b8590a60f3b3$export$2136dcd78a2ef18f);
    var $5fc53;
    var $o7K5u;
    const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE:
                {
                    const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                    const assetValue = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                            appKey: appKey,
                            originId: originId,
                            serializedOrigin: serializedOrigin,
                            value: value
                        })) : null;
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        autoCompleteUrl: node.searchUrl,
                        value: assetValue,
                        schema: {
                            custom: node.type,
                            system: null,
                            items: 'sd-asset',
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("9UrtF", function(module, exports) {
    $parcel$export(module.exports, "transformAggBooleanToLegacyField", ()=>$474331244347ccdb$export$4bd89b95f0d10de9);
    var $5fc53;
    var $o7K5u;
    const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: {
                        alertLinking: {
                            enabled: node.value
                        }
                    },
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: null,
                        custom: null,
                        system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hsEaK", function(module, exports) {
    $parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", ()=>$afb6a8576bf8d731$export$a8778af5ceb1017c);
    var $o7K5u;
    const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
        let value = null;
        if (node.cascadingOption) {
            const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
            const child = childOptionValue ? {
                child: {
                    id: childOptionValue.optionId,
                    value: childOptionValue.value
                }
            } : {};
            value = {
                id: parentOptionValue?.optionId,
                value: parentOptionValue?.value,
                ...child
            };
        }
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: [],
            schema: {
                type: 'option-with-child',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2qu1N", function(module, exports) {
    $parcel$export(module.exports, "transformAggCheckboxToLegacyField", ()=>$3efe07b8b545ea99$export$baa5afdbd8fd12d3);
    var $5fc53;
    var $o7K5u;
    const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: allowedValues,
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("16Zia", function(module, exports) {
    $parcel$export(module.exports, "transformAggCMDBToLegacyField", ()=>$4d2c21f2e394ef74$export$93506453d9bb56ae);
    var $5fc53;
    var $o7K5u;
    const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
            workspaceId: workspaceId,
            id: `${workspaceId}:${attribute.objectTypeId}`,
            name: attribute.name,
            objectSchemaId: attribute.objectSchemaId,
            objectTypeId: attribute.objectTypeId,
            icon: {
                id: attribute.icon.id,
                name: attribute.icon.name,
                url16: attribute.icon.url16,
                url48: attribute.icon.url48
            }
        });
    const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
        if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
            isInsightAvailable: node.isInsightAvailable
        } : {};
        return {
            cmdbFieldConfig: {
                multiple: node.cmdbFieldConfig.multiple,
                objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
                attributesDisplayedOnIssue: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
                attributesIncludedInAutoCompleteSearch: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
            },
            isInsightAvailable: node.isInsightAvailable,
            wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
        };
    };
    const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
        switch(type){
            case 'REFERENCED_OBJECT':
                return 1;
            case 'USER':
                return 2;
            case 'GROUP':
                return 4;
            case 'PROJECT':
                return 6;
            case 'STATUS':
                return 7;
            case 'BITBUCKET_REPO':
                return 8;
            case 'OPSGENIE_TEAM':
                return 9;
            case 'DEFAULT':
                return 0;
            default:
                console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
                return -1;
        }
    };
    const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
            id: node.objectGlobalId,
            workspaceId: node.workspaceId,
            objectKey: node.objectKey,
            label: node.label,
            avatar: node.avatar,
            objectId: node.objectId
        });
    const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
            avatarUrl: node.picture,
            displayName: node.name,
            name: node.name,
            key: node.accountId
        });
    const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
            avatarUrl: node.avatar?.large,
            id: Number(node.id),
            key: node.key,
            name: node.name
        });
    const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
            uuid: node.uuid,
            name: node.name,
            url: node.url,
            avatarUrl: node.avatarUrl
        });
    const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
            id: node.id,
            name: node.name,
            url: node.url
        });
    const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
            id: node.id,
            name: node.name,
            category: node.category
        });
    const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
        if (!node) return null;
        const defaultObjectValue = {
            displayValue: node.displayValue,
            searchValue: node.searchValue,
            ...node.value != null ? {
                value: node.value
            } : {}
        };
        if (node.referencedObject) return {
            ...defaultObjectValue,
            referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
        };
        if (node.user) return {
            ...defaultObjectValue,
            user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
        };
        if (node.group) return {
            ...defaultObjectValue,
            group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
        };
        if (node.project) return {
            ...defaultObjectValue,
            project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
        };
        if (node.bitbucketRepo) return {
            ...defaultObjectValue,
            bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
        };
        if (node.opsgenieTeam) return {
            ...defaultObjectValue,
            opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
        };
        if (node.status) return {
            ...defaultObjectValue,
            status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
        };
        return defaultObjectValue;
    };
    const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
        if (!node) return null;
        const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
        return {
            objectTypeAttributeId: objectTypeAttributeId,
            workspaceId: workspaceId,
            objectAttributeValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
            objectTypeAttribute: {
                id: objectTypeAttributeId,
                label: objectTypeAttribute.label,
                name: objectTypeAttribute.name,
                workspaceId: workspaceId,
                type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
                ...objectTypeAttribute.defaultType ? {
                    defaultType: {
                        id: objectTypeAttribute.defaultType.id,
                        name: objectTypeAttribute.defaultType.name
                    }
                } : {}
            }
        };
    };
    const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
        if (!node) return null;
        const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
        return {
            attributes: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
            avatar: avatar,
            label: label,
            id: objectGlobalId,
            objectId: objectId,
            objectKey: objectKey,
            workspaceId: workspaceId,
            links: {
                self: webUrl
            },
            objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
        };
    };
    const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
            configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).CMDB_OBJECT_CF_TYPE),
                items: 'cmdb-object-field',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iv8Rf", function(module, exports) {
    $parcel$export(module.exports, "transformAggColorToLegacyField", ()=>$b83a62ddd17b4586$export$587c178f1b45e5e9);
    var $5fc53;
    var $o7K5u;
    const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
        const value = node.color?.colorKey ?? null;
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_COLOR_TYPE:
            case 0, (0, parcelRequire("5fc53")).COLOR_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: value,
                    schema: {
                        configuration: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("hDlc2", function(module, exports) {
    $parcel$export(module.exports, "transformAggComponentsToLegacyField", ()=>$315456e18e2330f5$export$97a9275777684b77);
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
        if (component == null) return null;
        return {
            id: component.componentId,
            name: component.name,
            ...(0, (0, parcelRequire("co1wz")).ff)('compass-components-in-jira-components_xw42u', false) ? {
                ari: component.ari,
                metadata: component.metadata
            } : {}
        };
    };
    const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.components, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: 'component',
                renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)
            }
        };
    };
});
parcelRegister("c3LW9", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", ()=>$e80217ec1ee321d5$export$e6d015aa746cbdaf);
    var $5fc53;
    var $o7K5u;
    const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        });
});
parcelRegister("h92P3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", ()=>$1bb7cdf99e93ff64$export$edf5c98d20696686);
    var $5fc53;
    var $o7K5u;
    const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectMultiSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length ? value : null,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
                configuration: null
            }
        };
    };
});
parcelRegister("aeO9V", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectNumberToLegacyField", ()=>$b8a5823753f7873f$export$4638a5dd3285d8f2);
    var $5fc53;
    var $o7K5u;
    const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number ?? null,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        });
});
parcelRegister("6Tnq8", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", ()=>$f9558299012f1c2e$export$11063e1f9210f191);
    var $kz2lw;
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f9558299012f1c2e$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText.plainText == null) return '';
        return node.richText.plainText;
    };
    const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        const values = isPlainTextRenderer ? {
            value: $f9558299012f1c2e$var$getPlainTextValue(node)
        } : {
            adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            ...values,
            schema: {
                custom: (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE),
                renderer: renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            }
        };
    };
});
parcelRegister("dMYPq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4fed9edf4c76e19$export$2e2bcd8739ae039);
    var $dJl1T;
    const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
    const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
        try {
            if (!('renderer' in field)) return false;
            if (field?.renderer) return false;
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
            return true;
        } catch  {
            return false;
        }
    };
    var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;
});
parcelRegister("6mbsj", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", ()=>$ceb0872dd5eafe49$export$e44db7cf61369a28);
    var $5fc53;
    var $o7K5u;
    const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
        let value = null;
        if (node.fieldOption != null) value = {
            id: parseInt(node.fieldOption?.optionId, 10),
            value: node.fieldOption?.value
        };
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.connectSingleSelectFieldOptions, (0, (0, parcelRequire("o7K5u")).toLegacyConnectOption)),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                custom: node.type,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("d3nG3", function(module, exports) {
    $parcel$export(module.exports, "transformAggConnectTextToLegacyField", ()=>$145b645a3d2e801e$export$dd05277f5aa90657);
    var $5fc53;
    var $o7K5u;
    const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("1xW6n", function(module, exports) {
    $parcel$export(module.exports, "transformAggDataClassificationToLegacyField", ()=>$1a8d4561538d1d2b$export$b5edfdc89a7a2932);
    var $5fc53;
    var $o7K5u;
    const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE),
            value: node,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                custom: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).DATA_CLASSIFICATION_TYPE)
            }
        });
});
parcelRegister("fW9XR", function(module, exports) {
    $parcel$export(module.exports, "transformAggDatePickerToLegacyField", ()=>$c44a652aaa9bff90$export$3d6e51d37c0454a9);
    var $5fc53;
    var $o7K5u;
    const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        configuration: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_START_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).BASELINE_END_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: typeof node.date === 'string' ? node.date : null,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE),
                        custom: node.type,
                        configuration: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        system: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("bKMMB", function(module, exports) {
    $parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", ()=>$fb29b1af2f1467e0$export$3de22f1277f0c239);
    var $5fc53;
    var $o7K5u;
    const $fb29b1af2f1467e0$var$defaultSchema = {
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE),
        custom: null,
        system: null,
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime || '',
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RESOLUTION_DATE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        system: node.type,
                        renderer: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIRST_RESPONSE_DATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_DATE_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.dateTime ?? null,
                    schema: {
                        ...$fb29b1af2f1467e0$var$defaultSchema,
                        custom: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("7JL37", function(module, exports) {
    $parcel$export(module.exports, "transformAggEpicLinkToLegacyField", ()=>$3279d658ea1a4982$export$1311f30c94840aa2);
    var $kFsv3;
    var $5fc53;
    var $o7K5u;
    const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
        if (epic == null) return null;
        return {
            id: Number(epic.issueId),
            key: epic.key || '',
            done: !!epic.done,
            name: epic.name || '',
            summary: epic.summary || '',
            color: {
                key: epic.color ?? (0, (0, parcelRequire("kFsv3")).AgileColors).AGILE_COLOR_1
            },
            fromCache: false
        };
    };
    const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).EPIC_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl,
            value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
            schema: {
                configuration: null,
                items: null,
                renderer: 'jira-text-renderer',
                type: 'any',
                custom: (0, (0, parcelRequire("5fc53")).EPIC_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("dulCG", function(module, exports) {
    $parcel$export(module.exports, "transformAggFlagToLegacyField", ()=>$f31e97d89b497c1c$export$31555b6ea19f4c2);
    var $5fc53;
    var $o7K5u;
    const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
        if (flag == null || flag.isFlagged == null) return null;
        return [
            {
                value: flag.isFlagged
            }
        ];
    };
    const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).FLAGGED_CF_TYPE),
                items: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6vno6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateToLegacyField", ()=>$f5e60b2709763004$export$30fccfce22948120);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.date,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATE_CF_TYPE)
            }
        };
    };
});
parcelRegister("as0vY", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", ()=>$3520698819975afe$export$61b1f0cbd04c7b9c);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.dateTime,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_DATETIME_CF_TYPE)
            }
        };
    };
});
parcelRegister("6dPLd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupToLegacyField", ()=>$ce6b58a5b1f45912$export$60b03d63015cbb9f);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedGroup ? {
                name: node.selectedGroup.name
            } : null,
            autoCompleteUrl: null,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
            }
        };
    };
});
parcelRegister("gKccZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", ()=>$256d8054300c3cdf$export$2dfa4944fba5d1f5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedGroupsConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
                name: name
            })) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("jnUrZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeNumberToLegacyField", ()=>$c68528ed0dfd109c$export$5dab8986dc45db07);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.number,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iJtmd", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeObjectToLegacyField", ()=>$c814454c00552e79$export$fbdabdbae2a203b9);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = (()=>{
            if (node.object == null) return null;
            try {
                return JSON.parse(node.object);
            } catch (e) {
                throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
            }
        })();
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_OBJECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("iPyq0", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringToLegacyField", ()=>$29f719811f573640$export$3a581fb4b3e578bd);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("384lj", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeStringsToLegacyField", ()=>$0d30cb879c19e1ba$export$418a06cb5dc6aba5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
        const value = hasValue ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("axTS6", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUserToLegacyField", ()=>$0669940239efeaff$export$bc73c7a747f907e5);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null,
            autoCompleteUrl: node.searchUrl,
            schema: {
                configuration: null,
                items: null,
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE)
            }
        };
    };
});
parcelRegister("iob0v", function(module, exports) {
    $parcel$export(module.exports, "transformJiraUserToLegacyServerUser", ()=>$42550039db1edc00$export$d7b231260a016eaf);
    const $42550039db1edc00$var$getAccountType = (objectType)=>{
        switch(objectType){
            case 'AtlassianAccountUser':
                return 0, $145004f7a92e2423$export$981400c14dd99bc0;
            case 'CustomerUser':
                return 0, $145004f7a92e2423$export$2823897fb92cd040;
            case 'AppUser':
                return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
            default:
                return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
        }
    };
    const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
            '16x16': url,
            '24x24': url,
            '32x32': url,
            '48x48': url
        });
    const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
        if (!user) return null;
        const userOptionalKeysMap = {
            emailAddress: 'email',
            locale: 'locale',
            timeZone: 'zoneinfo'
        };
        const optionalValues = {};
        Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
            const aggValue = user[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        const avatars = user.picture != null ? {
            avatarUrl: user.picture,
            avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
        } : {};
        return {
            ...avatars,
            ...optionalValues,
            accountId: user.accountId,
            accountType: $42550039db1edc00$var$getAccountType(user.__typename),
            active: user.accountStatus === 'active',
            displayName: user.name
        };
    };
});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';
parcelRegister("lfJ6H", function(module, exports) {
    $parcel$export(module.exports, "transformAggForgeUsersToLegacyField", ()=>$eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);
    var $5fc53;
    var $o7K5u;
    var $dMYPq;
    var $iob0v;
    const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const value = node.selectedUsersConnection?.edges?.length ? (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                system: null,
                custom: node.type,
                renderer: node.renderer,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
            }
        };
    };
});
parcelRegister("9UXU7", function(module, exports) {
    $parcel$export(module.exports, "transformAggGoalsToLegacyField", ()=>$a8d444f432651533$export$158301a02ae4cbe7);
    var $5fc53;
    var $o7K5u;
    const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) return undefined;
        const value = node.selectedGoals ? {
            goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                    id: edge?.node?.id || '',
                    name: edge?.node?.name || '',
                    status: edge?.node?.status || null
                })) || [],
            totalCount: node.selectedGoals?.totalCount || 0
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
                items: null,
                renderer: null,
                system: null,
                type: (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)
            }
        };
    };
});
parcelRegister("b6BoU", function(module, exports) {
    $parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", ()=>$d0a0e03637cc83cd$export$62db794d5816e28e);
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
        if (role == null) return null;
        return {
            restrictionValue: role.roleId
        };
    };
    const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, context)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE)) return undefined;
        const roles = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
        const restrictions = roles.length > 0 ? {
            projectrole: roles
        } : {};
        const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                shouldDisplay: project.canSetIssueRestriction === true,
                issuerestrictions: restrictions
            },
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_RESTRICTION_TYPE),
                custom: null,
                system: node.type
            }
        };
    };
});
parcelRegister("hA3EZ", function(module, exports) {
    $parcel$export(module.exports, "getProjectType", ()=>$e3d5807b112803bd$export$3dd0da95519c1a33);
    $parcel$export(module.exports, "getSystemAggJiraProject", ()=>$e3d5807b112803bd$export$d100105d56da4a0a);
    $parcel$export(module.exports, "isAggJiraProjectClassic", ()=>$e3d5807b112803bd$export$3502ed01c034e451);
    $parcel$export(module.exports, "transformAggProjectToProjectContext", ()=>$e3d5807b112803bd$export$275f121d4e6f5165);
    $parcel$export(module.exports, "transformAggProjectToLegacyField", ()=>$e3d5807b112803bd$export$30c14b802399f417);
    var $2vSU6;
    var $5fc53;
    var $g5X3G;
    var $k5x3N;
    var $o7K5u;
    const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
        switch(status){
            case 'ACTIVE':
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
            case 'ARCHIVED':
                return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
            case 'DELETED':
                return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
            default:
                return 0, $cd476f3ecebdab63$export$62113557945f790a;
        }
    };
    const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
        switch(projectType){
            case 'SERVICE_DESK':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'BUSINESS':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'SOFTWARE':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'PRODUCT_DISCOVERY':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
        const projectField = fields?.find((edge)=>edge?.node?.__typename === (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, (0, parcelRequire("5fc53")).PROJECT_TYPE))?.node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        return projectField.project;
    };
    const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
    const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
    const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
        if (project == null) return null;
        const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
        return {
            name: name,
            id: projectId ?? undefined,
            key: (0, (0, parcelRequire("g5X3G")).toProjectKey)(key),
            avatarUrls: {
                '48x48': avatar.large
            }
        };
    };
    const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
        const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
        const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
        return {
            projectId: projectId,
            projectType: projectType,
            projectName: name,
            projectKey: key,
            projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
            avatarUrl: avatar.medium,
            isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
            boardId: navigationMetadata?.boardId
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE),
                system: null
            }
        });
    const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
        if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            key: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            title: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
            value: node.project?.similarIssues?.featureEnabled === true,
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SIMILAR_ISSUES_TYPE)
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
        if (node?.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, (0, parcelRequire("5fc53")).PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
        const projectField = node;
        if (projectField == null || projectField.__typename !== (0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
        if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, (0, parcelRequire("5fc53")).PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
        const project = projectField.project;
        const { projectType: type } = project;
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
        if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                projectType: projectType
            }
        };
    };
    const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
        const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
        if (projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
        return undefined;
    };
    const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
        if ((0, (0, parcelRequire("k5x3N")).isJPDDeliveryLinkTypeFilteringEnabled)()) switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
            default:
                return undefined;
        }
        else switch(node.type){
            case 0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
            default:
                return undefined;
        }
    };
});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';
parcelRegister("k5x3N", function(module, exports) {
    $parcel$export(module.exports, "isJPDDeliveryLinkTypeFilteringEnabled", ()=>$9be9ea07d5dfc538$export$8fac1563227555f2);
    var $co1wz;
    const $9be9ea07d5dfc538$export$8fac1563227555f2 = ()=>(0, (0, parcelRequire("co1wz")).ff)('polaris.jpd-panel-in-issue-view', false);
});
parcelRegister("gak3n", function(module, exports) {
    $parcel$export(module.exports, "getSystemAggJiraIssueType", ()=>$4f9b530de681b60e$export$b4644a0cc2f2935e);
    $parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", ()=>$4f9b530de681b60e$export$2356062173546155);
    $parcel$export(module.exports, "transformAggIssueTypeToLegacyField", ()=>$4f9b530de681b60e$export$de2eb3b47c7c887b);
    var $imYFg;
    var $5fc53;
    var $o7K5u;
    const $4f9b530de681b60e$export$d95e76b2d065f98d = {
        avatarId: 0,
        self: ''
    };
    const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
        const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE))?.node;
        if (issueTypeField == null || issueTypeField.__typename !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)} with ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
        if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
        return issueTypeField.issueType;
    };
    const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
            ...$4f9b530de681b60e$export$d95e76b2d065f98d,
            id: issueType.issueTypeId,
            iconUrl: issueType.avatar?.medium ?? '',
            name: issueType.name,
            description: 'description' in issueType && issueType.description != null ? issueType.description : '',
            hierarchyLevel: issueType.hierarchy.level,
            subtask: issueType.hierarchy.level === (0, (0, parcelRequire("imYFg")).ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
        });
    const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, (0, parcelRequire("5fc53")).ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
            }
        };
    };
});
parcelRegister("imYFg", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", ()=>$ccb1a8095461a82a$export$2fe6880f0073407c);
    var $g4tDr;
    const $ccb1a8095461a82a$export$2fe6880f0073407c = {
        SUBTASK_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_SUBTASK),
        BASE_LEVEL: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_BASE),
        LEVEL_ONE: (0, (0, parcelRequire("g4tDr")).ISSUE_HIERARCHY_LEVEL_EPIC),
        LEVEL_TWO: 2
    };
});
parcelRegister("g4tDr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", ()=>$03dd5f7faa501890$export$2294cfc7730248df);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", ()=>$03dd5f7faa501890$export$961a1d6da881600c);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", ()=>$03dd5f7faa501890$export$e11dea67b88ee556);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", ()=>$03dd5f7faa501890$export$9ad20e435294162a);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", ()=>$03dd5f7faa501890$export$a454b3474c5ee5f5);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", ()=>$03dd5f7faa501890$export$b69c1b48ce8f83de);
    $parcel$export(module.exports, "BASE_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$ba7c785763a2a58f);
    $parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$e09d07f2dcff2603);
    $parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$1165245f61159842);
    $parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$8a96a83b3f957e58);
    $parcel$export(module.exports, "toHierarchyLevel", ()=>$03dd5f7faa501890$export$c0c893ca5ccae9dd);
    $parcel$export(module.exports, "isBaseHierarchyLevel", ()=>$03dd5f7faa501890$export$bcf91a9d8c5b0f58);
    $parcel$export(module.exports, "isEpicHierarchyLevel", ()=>$03dd5f7faa501890$export$e415cf60723c7aae);
    $parcel$export(module.exports, "isSubtaskHierarchyLevel", ()=>$03dd5f7faa501890$export$41f00a40e2ebd6e8);
    $parcel$export(module.exports, "getHierarchyLevelType", ()=>$03dd5f7faa501890$export$556b686fea6fb229);
    $parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", ()=>$03dd5f7faa501890$export$638ac52227e67c8);
    const $03dd5f7faa501890$export$2294cfc7730248df = 4;
    const $03dd5f7faa501890$export$961a1d6da881600c = 3;
    const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
    const $03dd5f7faa501890$export$9ad20e435294162a = 1;
    const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
    const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
    const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
    const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
    const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
    const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
    const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
    const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return true;
        return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
    };
    const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
    };
    const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
    };
    const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
    const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
        if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
});
parcelRegister("i47fO", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", ()=>$448e6754d8bf50d1$export$b14d30f2a9e4c343);
    var $9ar3z;
    var $5fc53;
    var $g5X3G;
    var $o7K5u;
    var $iob0v;
    const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
        if (!approverPrincipal) return undefined;
        switch(approverPrincipal.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("g5X3G")).toAccountId)(approverPrincipal.user.accountId),
                    name: approverPrincipal.user.name,
                    meta: {
                        jiraRest: approverPrincipal.jiraRest
                    },
                    type: 'user',
                    avatarUrl: approverPrincipal.user.picture
                };
            case 0, (0, parcelRequire("5fc53")).JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
                return {
                    id: (0, (0, parcelRequire("9ar3z")).toGroupId)(approverPrincipal.groupId),
                    meta: {
                        memberCount: approverPrincipal.memberCount,
                        approvedCount: approverPrincipal.approvedCount
                    },
                    name: approverPrincipal.name,
                    type: 'group'
                };
            default:
                return undefined;
        }
    };
    const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
        switch(decision){
            case 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_APPROVED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_DECLINED;
            case 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING:
            default:
                return 0, (0, parcelRequire("9ar3z")).APPROVER_PENDING;
        }
    };
    const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
        if (!approvalNode) return undefined;
        const approver = (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(approvalNode.approver);
        if (!approver) return undefined;
        return {
            approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
            approver: approver
        };
    };
    const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
        const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
        const approverConfiguration = approversConfigurations[0];
        return {
            approvers: {
                type: approverConfiguration?.type ?? '',
                customFieldName: approverConfiguration?.fieldName ?? '',
                customFieldId: approverConfiguration?.fieldId ?? ''
            },
            condition: {
                type: condition?.type ?? '',
                value: condition?.value ?? ''
            }
        };
    };
    const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
            epochMillis: new Date(date).valueOf()
        });
    const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
            name: status.name || '',
            category: Number(status.categoryId)
        });
    const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
        const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
        return {
            id: id,
            approvalState: approvalState,
            approvedStatus: approvedStatus,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            name: name,
            pendingApprovalCount: pendingApprovalCount,
            canAnswerApproval: canAnswerApproval,
            approverPrincipals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
            configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            decisions: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
            excludedApprovers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(activeApproval.excludedApprovers, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
        };
    };
    const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
        if (!completedApproval) return undefined;
        const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
        return {
            id: id,
            name: name,
            finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
            createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
            completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
            status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
            approvers: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
        };
    };
    const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)) return undefined;
        const activeApproval = node.activeApproval ? {
            activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
        } : {};
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...activeApproval,
                completedApprovals: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE),
                type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_APPROVAL_TYPE)
            }
        };
    };
});
parcelRegister("9ar3z", function(module, exports) {
    $parcel$export(module.exports, "toGroupId", ()=>$4a7fc5eda3865b0e$export$779c261480444a4d);
    $parcel$export(module.exports, "APPROVER_PENDING", ()=>$4a7fc5eda3865b0e$export$3b59c4db06f5829b);
    $parcel$export(module.exports, "APPROVER_APPROVED", ()=>$4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
    $parcel$export(module.exports, "APPROVER_DECLINED", ()=>$4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
    $parcel$export(module.exports, "APPROVAL_OK", ()=>$4a7fc5eda3865b0e$export$2e6187b6a4348938);
    const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
    const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
    const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
    const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
    const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
    const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';
});
parcelRegister("gvljZ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", ()=>$b281bef34e07e20f$export$850fadda8a5e6f27);
    var $5fc53;
    var $o7K5u;
    const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.selectedEntitlement,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ENTITLEMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("6XFn2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", ()=>$926c732f6621d9fd$export$d4e0b2288fb31144);
    var $5fc53;
    var $o7K5u;
    const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.majorIncident,
            renderedValue: null,
            configuration: {},
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).MAJOR_INCIDENT_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        });
});
parcelRegister("6e1Ya", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", ()=>$0e4eebb31cef7087$export$7bd14951253a7c5f);
    var $5fc53;
    var $o7K5u;
    const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                    id: selectedNode.organizationId,
                    name: selectedNode.organizationName
                })),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).ORGANIZATIONS_CF_TYPE),
                items: 'sd-customerorganization',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("hBEiJ", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", ()=>$841fa8e5b9308ced$export$c52c6988b335096);
    var $5fc53;
    var $o7K5u;
    const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.feedback,
            schema: {
                type: 'sd-feedback',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_FEEDBACK_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("1XNj2", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", ()=>$1edf1c9b37cdb462$export$6a53240e225f742);
    var $5fc53;
    var $o7K5u;
    const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.language,
            allowedValues: [
                ...node.languages ?? []
            ],
            schema: {
                type: 'sd-request-lang',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_LANGUAGE_CF_TYPE),
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("f6zXW", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", ()=>$8030de3237296d5c$export$5ffaab1383177efa);
    var $5fc53;
    var $o7K5u;
    const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
        if (!requestType) return null;
        return {
            requestType: {
                id: parseInt(requestType.requestTypeId, 10),
                issueTypeId: requestType.issueType?.issueTypeId || '',
                name: requestType.name || '',
                icon: {
                    _links: {
                        iconUrls: {
                            '48x48': requestType.avatar?.large || ''
                        }
                    }
                }
            }
        };
    };
    const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).REQUEST_TYPE_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'sd-customerrequesttype'
            }
        };
    };
});
parcelRegister("fB4wX", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", ()=>$0ea07ade045943f7$export$5171c4d1ae5bcde5);
    var $5fc53;
    var $o7K5u;
    const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
        if (responder == null) return undefined;
        switch(responder.__typename){
            case 0, (0, parcelRequire("5fc53")).JSM_USER_RESPONDER_GQL_FIELD:
                if (responder.user === null) return undefined;
                return {
                    ari: responder.user.canonicalAccountId,
                    avatarUrl: responder.user.picture,
                    name: responder.user.name,
                    type: 'user'
                };
            case 0, (0, parcelRequire("5fc53")).JSM_TEAM_RESPONDER_FIELD:
                return {
                    ari: responder.teamId,
                    name: responder.teamName,
                    type: 'team'
                };
            default:
                return undefined;
        }
    };
    const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).RESPONDERS_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("cXBkk", function(module, exports) {
    $parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", ()=>$5dcf9f49c6a1536d$export$702d3754a4c7d90a);
    var $5fc53;
    var $o7K5u;
    const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.sentiment,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SENTIMENT_CF_TYPE),
                items: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("iDKu3", function(module, exports) {
    $parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", ()=>$5345161012c71e28$export$98e4f56e2e6c44fe);
    var $5fc53;
    var $o7K5u;
    const $5345161012c71e28$var$defaultSchema = {
        configuration: null,
        items: 'string',
        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
        const selectedLabels = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: selectedLabels.length === 0 ? null : selectedLabels,
                    schema: {
                        ...$5345161012c71e28$var$defaultSchema,
                        custom: node.type,
                        system: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("aGv90", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", ()=>$ee565846dd4aef42$export$f968da580693597d);
    var $o7K5u;
    const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
                groupId: groupNode.groupId,
                name: groupNode.name
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                type: 'array',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: 'group',
                configuration: null
            }
        };
    };
});
parcelRegister("19DRh", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", ()=>$d83d25c034b1d99f$export$869fb8fbcb97e0ee);
    var $5fc53;
    var $o7K5u;
    const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                {
                    const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedOptions, (option)=>({
                            id: option.optionId,
                            value: option.value ?? null,
                            ari: option.id
                        }));
                    return {
                        ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                        value: value.length ? value : null,
                        allowedValues: [],
                        schema: {
                            type: 'array',
                            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                            custom: node.type,
                            system: null,
                            items: 'option',
                            configuration: null
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lkW3a", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", ()=>$9b1f1d40e628c968$export$cdd9991119eb040e);
    var $2vSU6;
    var $co1wz;
    var $5fc53;
    var $o7K5u;
    var $hA3EZ;
    var $iob0v;
    const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, context)=>{
        const value = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedUsersConnection, (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser));
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value.length > 0 ? value : null,
            schema: {
                configuration: null,
                custom: node.type,
                items: 'user',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).REQUEST_PARTICIPANTS_CF_TYPE:
                {
                    if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-request-participants_itocm') && node.__typename === (0, (0, parcelRequire("5fc53")).MULTI_USER_PICKER_GQL_FIELD)) return {
                        ...legacyFieldValues,
                        value: value
                    };
                    const project = (0, (0, parcelRequire("hA3EZ")).getSystemAggJiraProject)(context);
                    if ((0, (0, parcelRequire("hA3EZ")).getProjectType)(project.projectType) !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return undefined;
                    return {
                        ...legacyFieldValues,
                        value: value
                    };
                }
            case 0, (0, parcelRequire("5fc53")).PARTICIPANTS_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_USER_CF_TYPE:
                return legacyFieldValues;
            case 0, (0, parcelRequire("5fc53")).APPROVERS_LIST_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                {
                    const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                        {
                            key: 'isMulti',
                            value: String(node.isMulti)
                        }
                    ] : null;
                    return {
                        ...legacyFieldValues,
                        autoCompleteUrl: node.searchUrl,
                        schema: {
                            ...legacyFieldValues.schema,
                            configuration: schemaConfig
                        }
                    };
                }
            default:
                return undefined;
        }
    };
});
parcelRegister("lQAwK", function(module, exports) {
    $parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", ()=>$dc0acfee4cadcdcd$export$6207ea60703068d8);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $dc0acfee4cadcdcd$var$defaultSchema = {
        configuration: null,
        custom: null,
        items: 'version',
        renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
        system: null,
        type: 'array'
    };
    const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE) && node.type !== (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)) return undefined;
        const legacyFieldValues = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: [],
            value: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedVersionsConnection, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion))
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE:
                return {
                    ...legacyFieldValues,
                    value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        custom: (0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
                return {
                    ...legacyFieldValues,
                    schema: {
                        ...$dc0acfee4cadcdcd$var$defaultSchema,
                        system: node.type
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("149sa", function(module, exports) {
    $parcel$export(module.exports, "transformAggVersionToLegacyVersion", ()=>$4617842fe98d5759$export$becef8d087e8b62b);
    var $jPhQo;
    const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
            id: version.versionId ?? '',
            name: version.name ?? '',
            description: version.description ?? '',
            archived: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).ARCHIVED,
            released: version.status === (0, (0, parcelRequire("jPhQo")).VersionStatus).RELEASED,
            ari: version.id
        });
});
parcelRegister("jPhQo", function(module, exports) {
    $parcel$export(module.exports, "VersionStatus", ()=>$b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
    var $imYFg;
    const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
        ARCHIVED: 'ARCHIVED',
        RELEASED: 'RELEASED',
        UNRELEASED: 'UNRELEASED'
    };
});
parcelRegister("8qOI6", function(module, exports) {
    $parcel$export(module.exports, "transformAggNumberToLegacyField", ()=>$b542e2b397d83c88$export$d754a24ed0096d2f);
    var $5fc53;
    var $o7K5u;
    const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
        const fieldType = node.isStoryPointField === true ? (0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE) : node.type;
        switch(fieldType){
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                return {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: node.number ?? null,
                    schema: {
                        configuration: null,
                        items: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: fieldType,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE)
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cbd7V", function(module, exports) {
    $parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", ()=>$47597066e94f8347$export$f08d02fdc74f920e);
    var $5fc53;
    var $o7K5u;
    const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.originalEstimate?.timeInSeconds ?? null,
            schema: {
                configuration: null,
                custom: null,
                system: node.type,
                items: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_NUMBER_CF_TYPE),
                renderer: null
            }
        };
    };
});
parcelRegister("6hj44", function(module, exports) {
    $parcel$export(module.exports, "transformAggPriorityToLegacyField", ()=>$47c25f6616be0140$export$9e966ce605f800d2);
    var $5fc53;
    var $o7K5u;
    const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
        if (priority == null) return null;
        return {
            id: priority.priorityId,
            iconUrl: String(priority.iconUrl || ''),
            name: priority.name || '',
            sequence: priority.sequence || undefined
        };
    };
    const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
            schema: {
                type: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
            }
        };
    };
});
parcelRegister("4nh4C", function(module, exports) {
    $parcel$export(module.exports, "transformAggProformaFormsToLegacyField", ()=>$27d464e5749e1114$export$fdcdbf17b0d4e36f);
    var $5fc53;
    var $o7K5u;
    const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.proformaForms,
            schema: {
                configuration: null,
                items: null,
                system: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS),
                custom: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).PROFORMA_FORMS)
            }
        };
    };
});
parcelRegister("2z4xE", function(module, exports) {
    $parcel$export(module.exports, "transformAggRadioSelectToLegacyField", ()=>$b545e68fef1c7c25$export$f147f1eb3a15ccfc);
    var $5fc53;
    var $o7K5u;
    const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)) return undefined;
        const value = node.selectedOption ? {
            id: node.selectedOption?.optionId,
            value: node.selectedOption?.value,
            isDisabled: node.selectedOption?.isDisabled
        } : null;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
                id: option.optionId,
                value: option.value ?? null,
                ari: option.id
            }));
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("cO2KQ", function(module, exports) {
    $parcel$export(module.exports, "transformAggResolutionToLegacyField", ()=>$b13d1a2c3ca9d3cb$export$179f600c7e1d0230);
    var $5fc53;
    var $o7K5u;
    const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
        if (resolution == null) return null;
        return {
            id: resolution.resolutionId,
            name: resolution.name || ''
        };
    };
    const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)) return undefined;
        const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            allowedValues: allowedValues,
            schema: {
                type: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE),
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("5sETx", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextToLegacyField", ()=>$181b5722dae42ee4$export$e65ff2ce94be106e);
    var $kz2lw;
    var $5fc53;
    var $fCo6Y;
    var $o7K5u;
    var $dMYPq;
    const $181b5722dae42ee4$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
        switch(aggType){
            case 0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE:
                return {
                    custom: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    system: null,
                    configuration: null,
                    items: null
                };
            case 0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE:
            case 0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE:
            default:
                return {
                    system: aggType,
                    renderer: renderer,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    configuration: null,
                    items: null
                };
        }
    };
    const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
        if (!node.richText) return null;
        if (node.richText?.plainText == null) return '';
        return node.richText?.plainText;
    };
    const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
        const { renderer: renderer } = node;
        if ((0, (0, parcelRequire("dMYPq")).default)(node)) return undefined;
        const isPlainTextRenderer = node.type !== (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
        if (isPlainTextRenderer) return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $181b5722dae42ee4$var$getPlainTextValue(node),
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
        const adfValueJson = node.richText?.adfValue?.json ?? null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            adfValue: adfValueJson ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
            value: null,
            schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
        };
    };
});
parcelRegister("f454b", function(module, exports) {
    $parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", ()=>$811c3c0495fb451c$export$45e25e2a6750ea5a);
    var $5fc53;
    var $o7K5u;
    const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
        if (securityLevel == null) return null;
        return {
            id: securityLevel.securityId,
            description: securityLevel.description || '',
            name: securityLevel.name || ''
        };
    };
    const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
            allowedValues: (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
            schema: {
                configuration: null,
                type: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE_OVERRIDE),
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).SECURITY_LEVEL_TYPE),
                items: null
            }
        });
});
parcelRegister("aafIf", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", ()=>$950a9b8297396bb3$export$e6697ec5bdac9ec0);
    var $o7K5u;
    const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
        const value = node.selectedGroup != null ? {
            groupId: node.selectedGroup.groupId,
            name: node.selectedGroup.name
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'group',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
});
parcelRegister("2yWre", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", ()=>$f5309f9bc8791ddf$export$31f32b3fd9e5ab6);
    var $5fc53;
    var $o7K5u;
    const $f5309f9bc8791ddf$var$defaultSchema = {
        configuration: null,
        items: null,
        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
    };
    const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
        const defaultTransformedField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.text
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_NAME_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_EDIT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MESSAGE_VIEW_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).READ_ONLY_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_PROPERTY_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).RANK_CF_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        custom: node.type,
                        system: null,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return {
                    ...defaultTransformedField,
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE),
                        custom: null,
                        system: node.type
                    }
                };
            case 0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE:
                return node.text != null ? {
                    ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
                    value: [
                        node.text
                    ],
                    schema: {
                        ...$f5309f9bc8791ddf$var$defaultSchema,
                        renderer: null,
                        custom: null,
                        system: node.type,
                        type: (0, (0, parcelRequire("5fc53")).SERVICEDESK_PRACTICES_TYPE)
                    }
                } : undefined;
            default:
                return undefined;
        }
    };
});
parcelRegister("lUeQj", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectToLegacyField", ()=>$9513f3f43c691d67$export$4e113f935e09d226);
    var $5fc53;
    var $o7K5u;
    const $9513f3f43c691d67$var$getField = (node, customType)=>{
        const value = node.fieldOption != null ? {
            ari: node.fieldOption.id,
            id: node.fieldOption.optionId,
            value: node.fieldOption.value
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                type: 'option',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                custom: customType || node.type,
                system: null,
                items: null,
                configuration: null
            }
        };
    };
    const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).EPIC_STATUS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                return $9513f3f43c691d67$var$getField(node);
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return $9513f3f43c691d67$var$getField(node, (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE));
            default:
                return undefined;
        }
    };
});
parcelRegister("6SWOK", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", ()=>$7348765074cf60a5$export$7bf73fc06c6d71be);
    var $5fc53;
    var $o7K5u;
    var $iob0v;
    const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
        const legacyField = {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.user ? (0, (0, parcelRequire("iob0v")).transformJiraUserToLegacyServerUser)(node.user) : null
        };
        switch(node.type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: null,
                        system: node.type,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).LAST_UPDATER_OR_COMMENTER_CF_TYPE:
                return {
                    ...legacyField,
                    schema: {
                        type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_USER_CF_TYPE),
                        custom: node.type,
                        system: null,
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null,
                        items: null
                    }
                };
            default:
                return undefined;
        }
    };
});
parcelRegister("cMc7B", function(module, exports) {
    $parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", ()=>$1c34fc6a70d0e0b4$export$d03f622577260442);
    var $5fc53;
    var $o7K5u;
    var $149sa;
    const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)) return undefined;
        const allowedValues = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.singlePickerVersions, (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion));
        const value = node.version ? (0, (0, parcelRequire("149sa")).transformAggVersionToLegacyVersion)(node.version) : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            allowedValues: allowedValues,
            value: value,
            schema: {
                configuration: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_VERSION_CF_TYPE),
                custom: (0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE),
                system: null
            }
        };
    };
});
parcelRegister("38GNL", function(module, exports) {
    $parcel$export(module.exports, "transformAggSprintToLegacyField", ()=>$05e0b9d6b707c3a6$export$9b5bb05d50970021);
    var $5fc53;
    var $o7K5u;
    const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
        goal: 'goal',
        completeDate: 'completionDate',
        startDate: 'startDate',
        endDate: 'endDate'
    };
    const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
        const optionalValues = {};
        Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
            const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
            const aggValue = sprint[aggKey];
            if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
        });
        return {
            id: Number(sprint.sprintId),
            name: sprint.name,
            state: sprint.state?.toLowerCase(),
            boardId: Number(sprint.boardName) || 0,
            ...optionalValues
        };
    };
    const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) return undefined;
        const sprints = (0, (0, parcelRequire("o7K5u")).transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: sprints,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
                items: 'json',
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'array'
            }
        };
    };
});
parcelRegister("avV20", function(module, exports) {
    $parcel$export(module.exports, "getStatusesDeprecatedValue", ()=>$e8b60f3bf3251c5a$export$b80ec59d806c2f94);
    $parcel$export(module.exports, "transformAggStatusToLegacyField", ()=>$e8b60f3bf3251c5a$export$c80e5acb1c882c48);
    var $gULOk;
    var $5fc53;
    var $o7K5u;
    const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
        const { status: status } = fields;
        if (!status || status.value == null) return {};
        const { value: value } = status;
        return {
            [value.id]: {
                id: value.id,
                name: value.name,
                statusCategory: (0, (0, parcelRequire("gULOk")).statusCategoryForId)(value.statusCategory?.id)
            }
        };
    };
    const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
        if (status == null) return null;
        const { statusCategory: statusCategory } = status;
        return {
            id: status.statusId,
            name: status.name || '',
            statusCategory: {
                id: Number(statusCategory.statusCategoryId)
            }
        };
    };
    const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).STATUS_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
            schema: {
                configuration: null,
                items: null,
                renderer: null,
                type: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                custom: null,
                system: (0, (0, parcelRequire("5fc53")).STATUS_TYPE)
            }
        };
    };
});
parcelRegister("cbXvu", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamToLegacyField", ()=>$2c8c4053c45e92fb$export$fb1b80497e96456f);
    var $5fc53;
    var $o7K5u;
    const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE)) return undefined;
        const value = node.selectedTeam ? {
            id: node.selectedTeam.teamId,
            title: node.selectedTeam.name,
            isShared: node.selectedTeam.isShared,
            avatarUrl: node.selectedTeam.avatar?.medium
        } : null;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: value,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_ANY_CF_TYPE)
            }
        };
    };
});
parcelRegister("aSXJi", function(module, exports) {
    $parcel$export(module.exports, "transformAggTeamViewToLegacyField", ()=>$b1861ddba2f2c1e6$export$6f6aaafb49bd4769);
    var $5fc53;
    var $o7K5u;
    const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
        if (team == null) return null;
        return {
            id: team.jiraSuppliedTeamId,
            name: team.jiraSuppliedName || '',
            isVisible: team.jiraSuppliedVisibility || false,
            avatarUrl: team.jiraSuppliedAvatar?.xsmall || ''
        };
    };
    const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: 'team'
            }
        };
    };
});
parcelRegister("8uxcU", function(module, exports) {
    $parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", ()=>$63b0d60fa2cc1a3e$export$874d9bd14269ec6f);
    var $5fc53;
    var $o7K5u;
    const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
        if (estimate) return {
            [key]: estimate.timeInSeconds || 0
        };
        return {};
    };
    const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)) return undefined;
        const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
        const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
        const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: {
                ...originalEstimate,
                ...remainingEstimate,
                ...timeSpent
            },
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE),
                type: (0, (0, parcelRequire("5fc53")).TIME_TRACKING_TYPE)
            }
        };
    };
});
parcelRegister("arKlm", function(module, exports) {
    $parcel$export(module.exports, "transformAggUrlToLegacyField", ()=>$86ba2c1106803d01$export$6e950e0ec9801f6c);
    var $5fc53;
    var $o7K5u;
    const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).URL_CF_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.uri ?? null,
            schema: {
                configuration: null,
                custom: (0, (0, parcelRequire("5fc53")).URL_CF_TYPE),
                items: null,
                renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                system: null,
                type: (0, (0, parcelRequire("5fc53")).ISSUE_FIELD_STRING_CF_TYPE)
            }
        };
    };
});
parcelRegister("hCKV6", function(module, exports) {
    $parcel$export(module.exports, "transformAggVotesToLegacyField", ()=>$78b4a5963398330d$export$8966614b8594736);
    var $5fc53;
    var $o7K5u;
    const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
            votes: vote.count != null ? Number(vote.count) : 0,
            hasVoted: vote.hasVoted ?? false
        });
    const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).VOTES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).VOTES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).VOTES_TYPE)
            }
        };
    };
});
parcelRegister("d8wC0", function(module, exports) {
    $parcel$export(module.exports, "transformAggWatchesToLegacyField", ()=>$a83bab4858993b2f$export$6730cb17d10d6156);
    var $5fc53;
    var $o7K5u;
    const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
            watchCount: watch.count != null ? Number(watch.count) : 0,
            isWatching: watch.isWatching ?? false
        });
    const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
        if (node.type !== (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)) return undefined;
        return {
            ...(0, (0, parcelRequire("o7K5u")).transformAggNodeToLegacyField)(node),
            value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
            schema: {
                configuration: null,
                custom: null,
                items: null,
                renderer: null,
                system: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE),
                type: (0, (0, parcelRequire("5fc53")).WATCHES_TYPE)
            }
        };
    };
});
parcelRegister("1pF6B", function(module, exports) {
    $parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", ()=>$f8196a61a82995ed$export$d8a5feb2bb0425b4);
    const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
        if (!parentIssue) return null;
        return {
            id: parentIssue.issueId,
            ari: parentIssue.id,
            key: parentIssue.key,
            self: parentIssue.webUrl,
            color: parentIssue.issueColorField?.color?.colorKey,
            fields: {
                summary: parentIssue.summaryField?.text,
                issuetype: {
                    name: parentIssue.issueTypeField?.issueType?.name,
                    iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                    id: '',
                    self: '',
                    description: '',
                    subtask: false,
                    avatarId: 0,
                    hierarchyLevel: 0
                }
            }
        };
    };
});
parcelRegister("lTnWS", function(module, exports) {
    $parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", ()=>$51ceecc021979aad$export$b3a2c3992977726e);
    var $kz2lw;
    var $fCo6Y;
    const $51ceecc021979aad$var$emptyAdfObject = (0, (0, parcelRequire("kz2lw")).getEmptyADF)();
    const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
        if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
        if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
            if (richText.plainText !== undefined) return richText.plainText;
            return richText?.adfValue?.convertedPlainText?.plainText;
        }
        return richText?.adfValue?.json ? (0, (0, parcelRequire("fCo6Y")).removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
    };
});
parcelRegister("3z81P", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$c6ffe75554a4bac3$export$8db21fc94823e1cc);
    const $c6ffe75554a4bac3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
    const $c6ffe75554a4bac3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
    const $c6ffe75554a4bac3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
    const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
        [$c6ffe75554a4bac3$export$8b9b8ed7fbac313c]: $c6ffe75554a4bac3$export$8b9b8ed7fbac313c,
        [$c6ffe75554a4bac3$export$7c15aaba9a26f469]: $c6ffe75554a4bac3$export$7c15aaba9a26f469,
        [$c6ffe75554a4bac3$export$f567ac9d3526e5ce]: $c6ffe75554a4bac3$export$f567ac9d3526e5ce
    };
});
parcelRegister("biQrn", function(module, exports) {
    $parcel$export(module.exports, "useIsMounted", ()=>$c6adaed2787020bf$export$80c2a3957bcb42ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
        const isMounted = (0, $5uXOq.useRef)(true);
        (0, $5uXOq.useEffect)(()=>{
            isMounted.current = true;
            return ()=>{
                isMounted.current = false;
            };
        }, [
            isMounted
        ]);
        return isMounted;
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
parcelRegister("99cgx", function(module, exports) {
    $parcel$export(module.exports, "defaultSaveField", ()=>$2a246664763defba$export$b74e6b7f831f1cb2);
    $parcel$export(module.exports, "defaultSaveFieldById", ()=>$2a246664763defba$export$b2c49aae5d84cced);
    $parcel$export(module.exports, "defaultAddValuesToField", ()=>$2a246664763defba$export$c46c7284cd9c5d3);
    $parcel$export(module.exports, "defaultRemoveValuesFromField", ()=>$2a246664763defba$export$33b78476f5d734b3);
    var $eusud;
    const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
            fields: {
                [fieldKey]: value
            }
        });
    const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'add',
                        value: valuesToAdd
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
    const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'remove',
                        value: valuesToRemove
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
});
parcelRegister("54wEF", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfig", ()=>$a5085d8f4019d625$export$5406c21e0d275680);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$217a0e2f2962f4ae);
    $parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", ()=>$a5085d8f4019d625$export$5f641a998c6dfa06);
    $parcel$export(module.exports, "useFieldConfig", ()=>$a5085d8f4019d625$export$70da50df1be2dbe1);
    $parcel$export(module.exports, "useFieldConfigWithoutRefetch", ()=>$a5085d8f4019d625$export$1eed575f8f3334eb);
    $parcel$export(module.exports, "useFieldConfigActions", ()=>$a5085d8f4019d625$export$28a22fd0dedf31b7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $e5wyW;
    var $4R6GH;
    var $jJZqs;
    var $eusud;
    var $iZIvy;
    var $eDXka;
    var $gXz4p;
    var $biQrn;
    var $2N3tQ;
    const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
    const $a5085d8f4019d625$var$fetchDataOld = async (issueKey)=>{
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce((result, field)=>({
                ...result,
                [field.key]: {
                    autoCompleteUrl: field.autoCompleteUrl,
                    allowedValues: field.allowedValues,
                    isEditable: field.editable,
                    isRequired: field.required,
                    schema: field.schema,
                    title: field.title,
                    ...field.description ? {
                        description: field.description
                    } : {}
                }
            }), {});
        return null;
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
        const errorMessageItem = errorMessage != null ? {
            errorMessage: errorMessage
        } : {};
        const traceIdItem = traceId != null ? {
            traceId: traceId
        } : {};
        return {
            experience: (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION,
            wasExperienceSuccesful: wasExperienceSuccessful,
            analyticsSource: 'Issue View Field Configuration Query',
            additionalAttributes: {
                method: 'GET',
                ...errorMessageItem,
                ...traceIdItem
            },
            application: null,
            edition: null
        };
    };
    const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
        (0, (0, parcelRequire("gXz4p")).sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
            wasExperienceSuccessful: wasExperienceSuccessful,
            ...error?.message != null ? {
                errorMessage: error.message
            } : {},
            ...error instanceof (0, (0, parcelRequire("jJZqs")).default) && error.traceId != null ? {
                traceId: error.traceId
            } : {}
        }));
    };
    const $a5085d8f4019d625$var$fetchDataWithExperienceTracking = async (issueKey)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)((0, (0, parcelRequire("iZIvy")).getGraphQlUrl)('', (0, (0, parcelRequire("eDXka")).IssueViewFetchOperations).FIELD_CONFIGURATION), {
                body: JSON.stringify({
                    query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                    variables: {
                        issueKey: issueKey
                    }
                })
            });
            if (response?.data?.issue?.fields) {
                const fieldConfigData = response.data.issue.fields.reduce((result, field)=>({
                        ...result,
                        [field.key]: {
                            autoCompleteUrl: field.autoCompleteUrl,
                            allowedValues: field.allowedValues,
                            isEditable: field.editable,
                            isRequired: field.required,
                            schema: field.schema,
                            title: field.title,
                            ...field.description ? {
                                description: field.description
                            } : {}
                        }
                    }), {});
                $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                    wasExperienceSuccessful: true
                });
                return fieldConfigData;
            }
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: new Error('Unexpected field configuration response')
            });
            return null;
        } catch (error) {
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: false,
                error: error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : undefined
            });
            return null;
        }
    };
    const $a5085d8f4019d625$var$fetchData = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jiv-18890-field-configuration-query-exp-tracking'), $a5085d8f4019d625$var$fetchDataWithExperienceTracking, $a5085d8f4019d625$var$fetchDataOld);
    const $a5085d8f4019d625$var$requestSet = new Set();
    const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
        skipRefresh: false
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const isMounted = (0, (0, parcelRequire("biQrn")).useIsMounted)();
        const [, { setIssueConfig: setIssueConfig }] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
        const getData = (0, $5uXOq.useCallback)(async ()=>{
            setLoading(true);
            $a5085d8f4019d625$var$requestSet.add(issueKey);
            const result = await $a5085d8f4019d625$var$fetchData(issueKey);
            setIssueConfig(issueKey, result);
            $a5085d8f4019d625$var$requestSet.delete(issueKey);
            if (isMounted.current) setLoading(false);
        }, [
            isMounted,
            issueKey,
            setIssueConfig
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const shouldGetData = (0, (0, parcelRequire("4R6GH")).fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
            if (shouldGetData) getData();
        }, [
            issueKey,
            value,
            getData,
            skipRefresh
        ]);
        return [
            {
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useIssueOverridesStore)({
            issueKey: issueKey
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) {
                const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                    acc[fieldKey] = {
                        ...fieldValues,
                        ...overrides[fieldKey]
                    };
                    return acc;
                }, {});
                return [
                    issueWithOverrides
                ];
            }
            return [
                value
            ];
        }, [
            value,
            overrides
        ]);
    };
    const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [overrides] = (0, (0, parcelRequire("2N3tQ")).useFieldOverridesStore)({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        if (!(0, ($parcel$interopDefault($hGgHi)))(value) && overrides !== undefined) return [
            {
                ...value,
                ...overrides
            }
        ];
        return [
            value
        ];
    };
    const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
        const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
            issueKey: issueKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
        const [value] = (0, (0, parcelRequire("2N3tQ")).useIssueFieldConfigStore)({
            issueKey: issueKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
        return [
            {
                value: value,
                loading: loading
            }
        ];
    };
    const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
        const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
            issueKey: issueKey,
            fieldKey: fieldKey
        });
        return [
            {
                value: value
            }
        ];
    };
    const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
        const [, setIssueConfigActions] = (0, (0, parcelRequire("2N3tQ")).useFieldConfigStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>{
            const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
            const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
            const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
            const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
            const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
            return {
                setIssueConfig: setIssueConfig,
                setIssuesConfig: setIssuesConfig,
                mergeIssueConfig: mergeIssueConfig,
                mergeIssuesConfig: mergeIssuesConfig,
                setFieldConfigValue: setFieldConfigValue
            };
        }, [
            setIssueConfigActions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("iZIvy", function(module, exports) {
    $parcel$export(module.exports, "getGraphQlUrl", ()=>$ef2130f553e5234b$export$5647e6bbf2b3526f);
    $parcel$export(module.exports, "getFieldDataOptions", ()=>$ef2130f553e5234b$export$f2fec0cacdfabaaf);
    var $96nmc;
    var $chLKn;
    const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, (0, parcelRequire("96nmc")).appendOperationQuery)(operation)}`;
    const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
            method: 'POST',
            body: JSON.stringify({
                query: (0, (0, parcelRequire("chLKn")).default)(issueKey, projectKey)
            })
        });
});
parcelRegister("chLKn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
    const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
        let result = '';
        substitutions.forEach((key, i)=>{
            result += literals[i];
            result += key.toString();
        });
        result += literals[literals.length - 1];
        return result;
    };
    const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
    const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
    const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
    const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
    const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
    var $2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;
});
parcelRegister("eDXka", function(module, exports) {
    $parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", ()=>$9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
    $parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", ()=>$9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
    $parcel$export(module.exports, "IssueViewFetchOperations", ()=>$9f0f96bc04f1e77a$export$b38f30d67f730bc4);
    const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
    const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
    const $9f0f96bc04f1e77a$export$757f91ad408a28d4 = 'jira.user.issue.filter.hide-done-subtasks';
    const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
        EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
        INITIAL_GRAPHQL: 'issueDataQuery',
        EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
        INITIAL_GIRA: 'issueViewInteractiveQuery',
        EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
        INITIAL_AGG: 'mainIssueAggQuery',
        EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
        NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
        VIEW_SCREEN_ID: 'viewScreenIdQuery',
        FIELD_CONFIGURATION: 'fieldConfigurationQuery',
        FIELD_DESCRIPTION: 'fieldDescriptionQuery',
        ATTACHMENT: 'attachmentsQuery'
    };
});
parcelRegister("gXz4p", function(module, exports) {
    $parcel$export(module.exports, "sendExperienceAnalytics", ()=>$b28eb6b892a8c2f7$export$4a95ada1b8228562);
    var $1UikQ = parcelRequire("1UikQ");
    var $gSA3s;
    var $hh0bW;
    var $j8DrX;
    const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, (0, parcelRequire("j8DrX")).default)('ajs-is-synthetic') === 'true';
    function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
        const additionalContext = {};
        const shard = (0, (0, parcelRequire("j8DrX")).default)('ajs-shard');
        const region = (0, (0, parcelRequire("j8DrX")).default)('ajs-region');
        Object.assign(additionalContext, {
            shard: shard,
            region: region
        });
        const enabledFeatureFlags = Object.fromEntries([
            ...(0, (0, parcelRequire("gSA3s")).allFeatureFlagsAccessed)
        ].filter(([, value])=>value));
        Object.assign(additionalContext, {
            enabledFeatureFlags: enabledFeatureFlags
        });
        const synthetics = {
            additionalAttributes: {
                synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
                ...additionalContext
            }
        };
        (0, ($parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
        (0, (0, parcelRequire("hh0bW")).default)(experienceDescription);
    }
});
parcelRegister("2N3tQ", function(module, exports) {
    $parcel$export(module.exports, "useIssueFieldConfigStore", ()=>$0471f3f4df57179c$export$52f51db4e2b3da57);
    $parcel$export(module.exports, "useFieldConfigStore", ()=>$0471f3f4df57179c$export$f9beb98c7488fd61);
    $parcel$export(module.exports, "useFieldConfigStoreActions", ()=>$0471f3f4df57179c$export$314199caf05d245);
    $parcel$export(module.exports, "useIssueOverridesStore", ()=>$0471f3f4df57179c$export$ff357cf5a96ec0c6);
    $parcel$export(module.exports, "useFieldOverridesStore", ()=>$0471f3f4df57179c$export$6e41e9c34587d557);
    $parcel$export(module.exports, "useFieldOverridesStoreWithLabel", ()=>$0471f3f4df57179c$export$e704d739927bd1d6);
    $parcel$export(module.exports, "useOverridesStoreActions", ()=>$0471f3f4df57179c$export$d94ae842140da412);
    $parcel$export(module.exports, "useFieldOptionsOverrides", ()=>$0471f3f4df57179c$export$bfea9bb9bad7bc8f);
    $parcel$export(module.exports, "useIsFieldBusy", ()=>$0471f3f4df57179c$export$982ff1008c2e2780);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
            setState({
                [issueKey]: issueConfiguration
            });
        };
    const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
            });
        };
    const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
            const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                    ...acc,
                    ...issue
                }), {});
            setState(newIssues);
        };
    const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
            if (issuesWithConfigurations.length === 0) return;
            const newIssues = {};
            issuesWithConfigurations.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfiguration = getState()[issueKey];
            if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: {
                        ...getState()[issueKey][fieldKey],
                        ...fieldConfiguration
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$actions = {
        setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
        setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
        mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
        mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
        setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
    };
    const $0471f3f4df57179c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-config',
        initialState: {},
        actions: $0471f3f4df57179c$var$actions
    });
    const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
    const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey] : null;
    });
    const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
        if (fieldConfig?.title === undefined) return fieldConfig;
        return {
            ...fieldConfig,
            label: fieldConfig.title
        };
    });
    const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
        if (issue == null) return issue;
        return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
    });
    const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$314199caf05d245 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$store, {
        selector: null
    });
    const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
            const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
            setState({
                [issueKey]: {
                    ...issueKeyFieldConfigurationWithOverrides,
                    [fieldKey]: {
                        ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                        ...fieldConfigOverrides
                    }
                }
            });
        };
    const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
            setState({
                [issueKey]: undefined
            });
        };
    const $0471f3f4df57179c$var$overridesActions = {
        setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
        resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
    };
    const $0471f3f4df57179c$var$overridesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-field-overrides',
        initialState: {},
        actions: $0471f3f4df57179c$var$overridesActions
    });
    const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIssueFieldConfig
    });
    const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfig
    });
    const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
    });
    const $0471f3f4df57179c$export$d94ae842140da412 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0471f3f4df57179c$var$overridesStore);
    const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, (0, parcelRequire("3sQ5x")).createHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
    });
    const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
        const { fieldId: fieldId, issueKey: issueKey } = args;
        return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
    };
    const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0471f3f4df57179c$var$overridesStore, {
        selector: $0471f3f4df57179c$var$getIsFieldBusySelector
    });
});
parcelRegister("80wkc", function(module, exports) {
    $parcel$export(module.exports, "useSummaryField", ()=>$3937341f26b89a45$export$a01f0885983ceff0);
    var $9XE6b = parcelRequire("9XE6b");
    var $co1wz;
    var $lQE94;
    var $54wEF;
    var $5fc53;
    var $lcPD8;
    const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
        const [fieldConfig] = (0, (0, parcelRequire("54wEF")).useFieldConfig)(issueKey, (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE));
        const fieldType = (0, ($parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
        const saveField = (0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') ? (0, (0, parcelRequire("lcPD8")).useSaveSummaryField)(issueId) : undefined;
        const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, (0, parcelRequire("lQE94")).useEditField)({
            fieldKey: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            issueKey: issueKey,
            fieldType: fieldType,
            initialValue: initialValue || null,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            ...(0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-summary_eog1v') && {
                saveField: saveField
            },
            ...onSaveField && {
                saveField: onSaveField
            }
        });
        return [
            {
                value: value,
                error: error,
                fieldConfig: fieldConfig
            },
            {
                saveValue: saveValue,
                resetError: resetError
            }
        ];
    };
});
parcelRegister("lcPD8", function(module, exports) {
    $parcel$export(module.exports, "useSaveSummaryField", ()=>$296ba0222c720503$export$2429979662d1fc23);
    var $883fO;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $lBwHJ;
    var $jJZqs;
    var $koeKL;
    const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [commit] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("883fO")).default));
        return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
                commit({
                    variables: {
                        input: {
                            id: (0, (0, parcelRequire("lBwHJ")).JiraIssuefieldvalueAri).create({
                                siteId: cloudId,
                                issueId: issueId || '',
                                fieldId: fieldId
                            }).toString(),
                            operation: {
                                operation: 'SET',
                                text: newValue
                            }
                        }
                    },
                    onCompleted (response) {
                        if (response.jira?.updateSingleLineTextField) {
                            const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                            if (success) {
                                resolve();
                                return;
                            }
                            if (responseErrors?.length) reject(responseErrors[0].message ? new (0, (0, parcelRequire("jJZqs")).ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                        } else reject(new Error('Unknown error when mutating summary'));
                    },
                    onError (error) {
                        reject(error);
                    }
                });
            }), [
            cloudId,
            commit,
            issueId
        ]);
    };
});
parcelRegister("883fO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d80cb93aeec4c927$export$2e2bcd8739ae039);
    const $d80cb93aeec4c927$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "success"
        }, v3 = {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "useSaveSummaryFieldMutation",
                "selections": [
                    {
                        "concreteType": "JiraMutation",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraSingleLineTextFieldPayload",
                                "kind": "LinkedField",
                                "name": "updateSingleLineTextField",
                                "plural": false,
                                "selections": [
                                    v2,
                                    v3,
                                    {
                                        "concreteType": "JiraSingleLineTextField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "fieldId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "text"
                                            },
                                            {
                                                "concreteType": "JiraFieldConfig",
                                                "kind": "LinkedField",
                                                "name": "fieldConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isRequired"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8b02759e10438a127aac20f64c8486592f4fd2cd831c3688a79bab526279fedf",
                "metadata": {},
                "name": "useSaveSummaryFieldMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
    var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;
});
parcelRegister("lBwHJ", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAri", ()=>$fba66c0f0a21639a$export$828c4931ae562af7);
    var $gB07r;
    var $9KGzW;
    var $1C2Ux;
    var $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts = {
        qualifier: "ari",
        platformQualifier: "cloud",
        cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
        resourceOwner: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceOwner),
        resourceType: (0, (0, parcelRequire("gB07r")).JiraIssuefieldvalueAriResourceType),
        resourceIdSlug: "{issueId}/{fieldId}",
        resourceIdSegmentFormats: {
            issueId: /[0-9]+/,
            fieldId: /[a-zA-Z0-9_\-]+/
        }
    };
    var $fba66c0f0a21639a$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, (0, parcelRequire("9KGzW")).RegisteredAri) {
        constructor(opts){
            super(opts);
            this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
        }
        get siteId() {
            return this._siteId;
        }
        get issueId() {
            return this._issueId;
        }
        get fieldId() {
            return this._fieldId;
        }
        static create(opts) {
            let derivedOpts = {
                qualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
                platformQualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
                cloudId: opts.siteId,
                resourceOwner: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
                resourceType: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
                resourceId: `${opts.issueId}/${opts.fieldId}`,
                resourceIdSegmentValues: {
                    issueId: opts.issueId,
                    fieldId: opts.fieldId
                }
            }, ariOpts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromOpts(derivedOpts, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(ariOpts);
        }
        static parse(maybeAri) {
            let opts = (0, (0, parcelRequire("1C2Ux")).AriParser).fromString(maybeAri, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
            return new _JiraIssuefieldvalueAri(opts);
        }
        getVariables() {
            return {
                siteId: this.siteId,
                issueId: this.issueId,
                fieldId: this.fieldId
            };
        }
    };
});
parcelRegister("gB07r", function(module, exports) {
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", ()=>$c15031ac9edfd973$export$39e9358142fbbc64);
    $parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", ()=>$c15031ac9edfd973$export$f9e57427271adc95);
    var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";
});
parcelRegister("1Kt4o", function(module, exports) {
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", ()=>$3add01bee0e3b846$export$689de18177335e39);
    $parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", ()=>$3add01bee0e3b846$export$96f61eb1261e42c3);
    const $3add01bee0e3b846$export$689de18177335e39 = {
        ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
        ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
        CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
        COPY_URL: 'COPY_URL',
        DESCRIPTION: 'DESCRIPTION',
        ISSUE_ACTIONS: 'ISSUE_ACTIONS',
        ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
        ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
        ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
        LOG_WORK: 'LOG_WORK',
        NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
        PARENT: 'PARENT',
        PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
        QUICK_ADD: 'QUICK_ADD',
        QUICK_SEARCH: 'QUICK_SEARCH',
        SHORTCUTS: 'SHORTCUTS',
        STATUS: 'STATUS',
        STORY_POINTS: 'STORY_POINTS',
        TEST: 'TEST',
        THEME_MODE: 'THEME_MODE'
    };
    const $3add01bee0e3b846$var$teams = {
        Deliveroo: 'Deliveroo'
    };
    const $3add01bee0e3b846$export$96f61eb1261e42c3 = {
        ADMIN_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ADMIN_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        CHECK_NOTIFICATIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.CHECK_NOTIFICATIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        COPY_URL: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.COPY_URL,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        DESCRIPTION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.DESCRIPTION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_FIELD_ASSIGN: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        ISSUE_SUB_HEADER_ACTIONS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        LOG_WORK: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.LOG_WORK,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        NAVIGATION_COMMANDS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.NAVIGATION_COMMANDS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PARENT: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PARENT,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        PROJECT_NAVIGATION: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.PROJECT_NAVIGATION,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_ADD: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_ADD,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        QUICK_SEARCH: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.QUICK_SEARCH,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        SHORTCUTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.SHORTCUTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STATUS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STATUS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        STORY_POINTS: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.STORY_POINTS,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        },
        THEME_MODE: {
            registryId: $3add01bee0e3b846$export$689de18177335e39.THEME_MODE,
            teamName: $3add01bee0e3b846$var$teams.Deliveroo
        }
    };
});
parcelRegister("fVMIs", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommands", ()=>$05800ad334e2646e$export$c13b008422be19c7);
    var $fIZf0;
    const $05800ad334e2646e$export$c13b008422be19c7 = (0, (0, parcelRequire("fIZf0")).useSubscribeCommandsWithRegistry);
});
parcelRegister("fIZf0", function(module, exports) {
    $parcel$export(module.exports, "useSubscribeCommandsWithRegistry", ()=>$72118e9f2599bc72$export$880fc01e31710b27);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    function $72118e9f2599bc72$export$880fc01e31710b27() {
        const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const subscribe = (0, $5uXOq.useCallback)((registrationId, commands)=>{
            updateActiveRegistry(registrationId, commands);
            addCommands(commands);
            return ()=>{
                removeCommands(commands);
                removeFromActiveRegistry(registrationId, commands);
            };
        }, [
            addCommands,
            removeCommands,
            removeFromActiveRegistry,
            updateActiveRegistry
        ]);
        return subscribe;
    }
});
parcelRegister("c6XT1", function(module, exports) {
    $parcel$export(module.exports, "useIssueAri", ()=>$be8be2fff6370f04$export$f56776f1b409b56d);
    var $2gCtH;
    var $dXq4S;
    var $koeKL;
    const $be8be2fff6370f04$export$f56776f1b409b56d = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const issueId = (0, (0, parcelRequire("2gCtH")).useIssueId)();
        return (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'issue',
            resourceId: issueId ?? ''
        });
    };
});
const $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';
parcelRegister("iokLh", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$7312d5cd39eb83d5$export$defe85febe8b728c);
    var $7VHMR;
    const $7312d5cd39eb83d5$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editStatus: {
            "id": "issue-field-status.status-view.command-palette.edit-status",
            "defaultMessage": "Edit status"
        },
        searchTransition: {
            "id": "issue-field-status.status-view.command-palette.search-transition",
            "defaultMessage": "Search a status or transition"
        },
        current: {
            "id": "issue-field-status.status-view.command-palette.current",
            "defaultMessage": "Current"
        },
        fallbackNoResults: {
            "id": "issue-field-status.status-view.command-palette.fallback-no-results",
            "defaultMessage": "No results match your search."
        },
        fallbackError: {
            "id": "issue-field-status.status-view.command-palette.fallback-error",
            "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
        }
    });
});
parcelRegister("99Vn3", function(module, exports) {
    $parcel$export(module.exports, "useSaveStatusField", ()=>$6b5b0ceb4c7d618c$export$c6a3d42f97df89c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8lE2;
    var $jcw0u;
    var $co1wz;
    var $4R6GH;
    var $eusud;
    var $pa9q9;
    var $koVbs;
    var $3fAi8;
    var $jpZIw;
    var $dTUtq;
    var $8zOmE;
    var $2NMNM;
    var $luzUm;
    const $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, (0, parcelRequire("d8lE2")).useCommandPaletteSessionId)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [, { setFieldValue: setFieldValue }] = (0, (0, parcelRequire("3fAi8")).useFieldValue)({
            issueKey: issueKey,
            fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
        });
        const onSaveSuccessfully = (0, $5uXOq.useCallback)((transition, callback)=>{
            const action = 'commandPalette';
            const actionSubject = 'changeStatus';
            const eventActionAndSubject = `${actionSubject} ${action}`;
            const event = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), transition.to);
            callback?.();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, eventActionAndSubject, {
                transitionId: transition.id,
                commandPaletteSessionId: commandPaletteSessionId
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
            !(0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showFlag({
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("luzUm")).messages).successFlagMessage)
            });
        }, [
            commandPaletteSessionId,
            createAnalyticsEvent,
            formatMessage,
            issueKey,
            setFieldValue,
            showFlag
        ]);
        const onFailSave = (0, $5uXOq.useCallback)((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'commandPaletteIssueStatus',
                    packageName: 'jiraIssueFieldStatus',
                    teamName: 'deliveroo'
                }
            });
            showFlag({
                type: 'error',
                title: formatMessage((0, (0, parcelRequire("luzUm")).messages).errorFlagTitle),
                description: formatMessage((0, (0, parcelRequire("luzUm")).messages).errorFlagDescription)
            });
        }, [
            formatMessage,
            showFlag
        ]);
        const openIssueTransitionModal = (0, (0, parcelRequire("jpZIw")).useOpenIssueTransitionModal)();
        const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, (0, parcelRequire("dTUtq")).useShowFlag)();
        const saveStatusField = (0, $5uXOq.useCallback)(async (transition, callback)=>{
            try {
                if (transition.hasScreen) {
                    const handleDialogSuccess = ()=>{
                        (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                        return onSaveSuccessfully(transition, callback);
                    };
                    const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                    const transitionId = transition.id;
                    openIssueTransitionModal({
                        payload: {
                            issueId: issueId,
                            issueKey: issueKey,
                            transitionId: transitionId
                        },
                        triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                        onDialogSuccess: handleDialogSuccess,
                        onDialogError: handleDialogError
                    });
                } else {
                    if ((0, (0, parcelRequire("co1wz")).ff)('relay-migration-issue-fields-status_qg82c') && onUpdateStatusMutation) await onUpdateStatusMutation?.({
                        transitionId: transition.id,
                        newStatus: transition.to
                    });
                    else await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                        body: JSON.stringify({
                            transition: transition
                        })
                    });
                    onSaveSuccessfully(transition, callback);
                    (0, (0, parcelRequire("4R6GH")).fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                }
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
                onFailSave(error);
            }
        }, [
            issueId,
            issueKey,
            onFailSave,
            onSaveSuccessfully,
            onUpdateStatusMutation,
            openIssueTransitionModal,
            showIssueTransitionSuccessFlag
        ]);
        return {
            saveStatusField: saveStatusField
        };
    };
});
parcelRegister("dTUtq", function(module, exports) {
    $parcel$export(module.exports, "useShowFlag", ()=>$4e3d7d0cd8105532$export$46b5557ad4264ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $pa9q9;
    var $koVbs;
    var $6OtcO;
    const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
            try {
                showFlag((0, (0, parcelRequire("6OtcO")).getTransitionSuccessFlag)(issueKey, status, formatMessage));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'showSuccessFlag',
                        packageName: 'jiraIssueTransitionUseShowFlag',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            formatMessage,
            showFlag
        ]);
        const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey)=>showFlag((0, (0, parcelRequire("6OtcO")).getTransitionFailureFlag)(issueKey, formatMessage)), [
            formatMessage,
            showFlag
        ]);
        return {
            showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
            showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
        };
    };
});
parcelRegister("6OtcO", function(module, exports) {
    $parcel$export(module.exports, "getTransitionSuccessFlag", ()=>$12ec3642dfb43880$export$8cfa71b43d733669);
    $parcel$export(module.exports, "getTransitionFailureFlag", ()=>$12ec3642dfb43880$export$d9438db72c9548f1);
    var $6s1PB;
    var $7HGHK;
    var $4O0IR;
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
    const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
    const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
        const showLinkToIssue = Boolean(issueKey && status);
        if (showLinkToIssue) return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
                issueKey: issueKey,
                status: status
            }),
            description: (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulFlagDescription
        };
        return {
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
            type: 'success',
            title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessfulIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionSuccessful)
        };
    };
    const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage)=>({
            id: (0, (0, parcelRequire("7HGHK")).toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
            type: 'error',
            title: issueKey ? formatMessage((0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureWithKey, {
                issueKey: issueKey
            }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailureIssueTermRefresh : (0, (0, parcelRequire("4O0IR")).default).issueTransitionFailure)
        });
});
parcelRegister("4O0IR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d201576bd998790a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d201576bd998790a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTransitionSuccessful: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
            "defaultMessage": "Issue has been updated."
        },
        issueTransitionSuccessfulWithIssueKeyAndStatus: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
            "defaultMessage": "{issueKey} moved to {status}."
        },
        issueTransitionSuccessfulFlagDescription: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
            "defaultMessage": "Kudos for keeping things up-to-date!"
        },
        issueTransitionFailure: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
            "defaultMessage": "Issue could not be updated."
        },
        issueTransitionFailureWithKey: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
            "defaultMessage": "We couldn't update {issueKey}."
        },
        viewIssue: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
            "defaultMessage": "View issue"
        },
        issueTransitionSuccessfulIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
            "defaultMessage": "Work item has been updated."
        },
        issueTransitionFailureIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
            "defaultMessage": "Work item could not be updated."
        },
        viewIssueIssueTermRefresh: {
            "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$498b2652a6d7832d = 'flag';
parcelRegister("luzUm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bd890bb183837c1d$export$defe85febe8b728c);
    var $7VHMR;
    const $bd890bb183837c1d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        successFlagMessage: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
            "defaultMessage": "Status updated"
        },
        errorFlagTitle: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
            "defaultMessage": "We're unable to edit status"
        },
        errorFlagDescription: {
            "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
            "defaultMessage": "Wait a few moments, then try again."
        }
    });
});
parcelRegister("fBoWB", function(module, exports) {
    $parcel$export(module.exports, "getTransitionKeywords", ()=>$b56280b3569df29a$export$258538e0d3d46460);
    const $b56280b3569df29a$export$258538e0d3d46460 = (transition)=>{
        if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
        return transition.name;
    };
});
parcelRegister("2NP8E", function(module, exports) {
    $parcel$export(module.exports, "CreateStatusButton", ()=>$003c9066e5f3dd12$export$d2e0b4f33d77a2b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $kgoHi;
    var $8CUq3;
    var $kM5sB;
    var $koVbs;
    var $2vLHS;
    var $2KAtx;
    var $8zOmE;
    var $2NMNM;
    var $koeKL;
    var $5BSCo;
    var $4zzYB;
    const $003c9066e5f3dd12$export$d2e0b4f33d77a2b8 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const handleClick = (0, $5uXOq.useCallback)((_e, analyticsEvent)=>{
            onClick();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'createStatusButton');
        }, [
            onClick
        ]);
        const onModalClose = (0, $5uXOq.useCallback)(()=>{
            onClose();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'closed',
                actionSubject: 'inlineCreateStatusModal'
            }));
        }, [
            createAnalyticsEvent,
            onClose
        ]);
        if (!projectId || !projectType || !issueTypeId) return null;
        const entryPointParams = {
            cloudId: cloudId,
            projectKey: projectKey
        };
        const entryPointProps = {
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: (0, parcelRequire("5BSCo")).createStatusExperience,
            source: (0, $a05d2e59d0770cd0$export$cafb161c2b21b455)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("kM5sB")).asyncInlineCreateStatusModal),
            entryPointProps: entryPointProps,
            entryPointParams: entryPointParams,
            interactionName: "create-status-modal",
            modalProps: (0, (0, parcelRequire("2vLHS")).defaultModalProps),
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                xcss: $003c9066e5f3dd12$var$flexContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($003c9066e5f3dd12$var$StyledButton, {
                appearance: "subtle",
                shouldFitContainer: true,
                interactionName: "issue.fields.status.create-status.popup.open",
                onClick: handleClick,
                ref: ref
            }, formatMessage((0, (0, parcelRequire("4zzYB")).messages).createStatus))));
    };
    const $003c9066e5f3dd12$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4cvr1h6o _y3gn1e5h _syazj3m3 _1yt41954 _4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $003c9066e5f3dd12$var$flexContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        flexGrow: 1,
        height: "var(--ds-space-500, 40px)"
    });
});
parcelRegister("kM5sB", function(module, exports) {
    $parcel$export(module.exports, "asyncInlineCreateStatusModal", ()=>$4f3a1403b068163e$export$64a761d25b20910a);
    var $8p8PB;
    var $eufEc;
    var $fEDBv;
    const $4f3a1403b068163e$export$64a761d25b20910a = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("e4F4f")), {
            moduleId: "32dc56f9"
        }),
        getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
                queries: {
                    inlineCreateStatusModal: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("8p8PB")).default,
                        variables: {
                            cloudId: cloudId,
                            projectKey: projectKey
                        }
                    }
                }
            })
    });
});
parcelRegister("8p8PB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32f21baf6b88fc48$export$2e2bcd8739ae039);
    const $32f21baf6b88fc48$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
            "metadata": {},
            "name": "srcAsyncInlineCreateStatusQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $32f21baf6b88fc48$export$2e2bcd8739ae039 = $32f21baf6b88fc48$var$node;
});
parcelRegister("e4F4f", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("dw9su")
    ]).then(()=>parcelRequire('e1HID'));
});
parcelRegister("2vLHS", function(module, exports) {
    $parcel$export(module.exports, "getProjectSettingsIssueTypesUrl", ()=>$1b4d3c262f1b4d6e$export$e2e29d5bcfe97104);
    $parcel$export(module.exports, "defaultModalProps", ()=>$1b4d3c262f1b4d6e$export$14c11acc66fd51b3);
    $parcel$export(module.exports, "useCanConfigureStatus", ()=>$1b4d3c262f1b4d6e$export$c330622bbe9077c2);
    $parcel$export(module.exports, "shouldShowConfigureStatusOption", ()=>$1b4d3c262f1b4d6e$export$33aa2c7a0150a75c);
    var $2vSU6;
    var $93Yeu;
    var $17Gip;
    const $1b4d3c262f1b4d6e$export$e2e29d5bcfe97104 = ({ projectKey: projectKey, projectType: projectType })=>{
        switch(projectType?.toLowerCase()){
            case 'service_desk':
                return `/plugins/servlet/project-config/${projectKey}/issueTypes`;
            case 'business':
                return `/jira/core/projects/${projectKey}/settings/issuetypes`;
            default:
                return `/jira/software/projects/${projectKey}/settings/issuetypes`;
        }
    };
    const $1b4d3c262f1b4d6e$export$14c11acc66fd51b3 = {
        width: 'small'
    };
    const $1b4d3c262f1b4d6e$export$c330622bbe9077c2 = (projectKey)=>{
        const isProjectAdmin = (0, (0, parcelRequire("17Gip")).useCanAdministerProject)(projectKey);
        const isTeamManaged = (0, (0, parcelRequire("93Yeu")).useIsSimplifiedProject)(projectKey);
        return isProjectAdmin && isTeamManaged;
    };
    const $1b4d3c262f1b4d6e$export$33aa2c7a0150a75c = (projectType)=>{
        return projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT);
    };
});
parcelRegister("17Gip", function(module, exports) {
    $parcel$export(module.exports, "useProjectPermissions", ()=>$0b32a3d32d712870$export$c6c6b35628cf47a8);
    $parcel$export(module.exports, "useCanAdministerProject", ()=>$0b32a3d32d712870$export$f39ed5a161efa614);
    $parcel$export(module.exports, "useCanAdministerJira", ()=>$0b32a3d32d712870$export$ec12ddafd19b95ac);
    $parcel$export(module.exports, "useCanConfigureIssue", ()=>$0b32a3d32d712870$export$e7267b8a084eadb3);
    $parcel$export(module.exports, "useCanUseServiceDeskAgentFeatures", ()=>$0b32a3d32d712870$export$756d7c97077a2f76);
    $parcel$export(module.exports, "useCanDownloadAttachments", ()=>$0b32a3d32d712870$export$d47dad3a7e3265ea);
    $parcel$export(module.exports, "useProjectPermissionsActions", ()=>$0b32a3d32d712870$export$86c656cdb87052cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $khL17;
    const $0b32a3d32d712870$export$c6c6b35628cf47a8 = (projectKey)=>{
        const [permissions, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            permissions,
            actions
        ];
    };
    const $0b32a3d32d712870$export$f39ed5a161efa614 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerProject;
    };
    const $0b32a3d32d712870$export$ec12ddafd19b95ac = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canAdministerJira;
    };
    const $0b32a3d32d712870$export$e7267b8a084eadb3 = (projectKey)=>{
        const canConfigureAdministerProject = $0b32a3d32d712870$export$f39ed5a161efa614(projectKey);
        const canAdministerJira = $0b32a3d32d712870$export$ec12ddafd19b95ac(projectKey);
        return canConfigureAdministerProject || canAdministerJira;
    };
    const $0b32a3d32d712870$export$756d7c97077a2f76 = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        const { appPermissions: appPermissions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return permissions.canUseServiceDeskAgentFeatures && appPermissions?.hasServiceDeskAccess;
    };
    const $0b32a3d32d712870$export$d47dad3a7e3265ea = (projectKey)=>{
        const [permissions] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStore)({
            projectKey: projectKey
        });
        return permissions.canExportIssue;
    };
    const $0b32a3d32d712870$export$86c656cdb87052cd = ()=>{
        const [, { setProjectPermissions: setProjectPermissions }] = (0, (0, parcelRequire("khL17")).useProjectPermissionsStoreActions)();
        const actions = (0, $5uXOq.useMemo)(()=>({
                setProjectPermissions: setProjectPermissions
            }), [
            setProjectPermissions
        ]);
        return [
            null,
            actions
        ];
    };
});
parcelRegister("khL17", function(module, exports) {
    $parcel$export(module.exports, "defaultPermissions", ()=>$472e428a487a401f$export$ccfee65526b322ca);
    $parcel$export(module.exports, "useProjectPermissionsStore", ()=>$472e428a487a401f$export$4919fa09a3d81224);
    $parcel$export(module.exports, "useProjectPermissionsStoreActions", ()=>$472e428a487a401f$export$e8436ef485b33bdb);
    var $3sQ5x;
    var $iXqE5;
    var $l5qXF;
    const $472e428a487a401f$export$ccfee65526b322ca = {
        canAddComments: false,
        canAdministerJira: false,
        canAdministerProject: false,
        canAssignIssues: false,
        canBeAssignedToIssues: false,
        canCloneIssue: false,
        canCreateAttachments: false,
        canCreateChildren: false,
        canCreateSubtask: false,
        canDeleteAllAttachments: false,
        canDeleteAllComments: false,
        canDeleteAllWorklogs: false,
        canDeleteIssue: false,
        canDeleteOwnAttachments: false,
        canDeleteOwnComments: false,
        canDeleteOwnWorklogs: false,
        canEditAllComments: false,
        canEditAllWorklogs: false,
        canEditIssues: false,
        canEditOwnComments: false,
        canEditOwnWorklogs: false,
        canLinkIssues: false,
        canLogWork: false,
        canManageWatchers: false,
        canMoveIssue: false,
        canModifyReporter: false,
        canScheduleIssues: false,
        canUseServiceDeskAgentFeatures: false,
        canBrowseUsers: false,
        canViewDevTools: false,
        canViewWatchers: false,
        canViewVoters: false,
        canCreateIssuesInClassicProjectEpic: false,
        canResolveIssues: false,
        canExportIssue: false,
        canArchiveIssue: false,
        canUnarchiveIssue: false
    };
    const $472e428a487a401f$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'project-permissions',
        initialState: {},
        actions: (0, parcelRequire("l5qXF"))
    });
    const $472e428a487a401f$var$getProjectPermissionSelector = (state, { projectKey: projectKey })=>state[projectKey] || $472e428a487a401f$export$ccfee65526b322ca;
    const $472e428a487a401f$export$4919fa09a3d81224 = (0, (0, parcelRequire("3sQ5x")).createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: $472e428a487a401f$var$getProjectPermissionSelector
    });
    const $472e428a487a401f$export$e8436ef485b33bdb = (0, (0, parcelRequire("3sQ5x")).createHook)($472e428a487a401f$export$6f57813fe9f31bf9, {
        selector: null
    });
});
parcelRegister("l5qXF", function(module, exports) {
    $parcel$export(module.exports, "setProjectPermissions", ()=>$f3418fe5fb58759f$export$53f5cc27627e5fe3);
    const $f3418fe5fb58759f$export$53f5cc27627e5fe3 = (projectKey, permissions)=>({ setState: setState })=>{
            setState({
                [projectKey]: permissions
            });
        };
});
const $a05d2e59d0770cd0$export$c766acff4513a976 = 'summaryView';
const $a05d2e59d0770cd0$export$4edb790587638895 = 'listView';
const $a05d2e59d0770cd0$export$cafb161c2b21b455 = 'issueView';
parcelRegister("5BSCo", function(module, exports) {
    $parcel$export(module.exports, "createStatusExperience", ()=>$eb41bcd877362d81$export$750cfa63c61c5008);
    $parcel$export(module.exports, "editStatusExperience", ()=>$eb41bcd877362d81$export$1c3aa89ea6d8c93d);
    var $atdLB;
    var $duUGa;
    const $eb41bcd877362d81$export$750cfa63c61c5008 = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-view.create-status', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    });
    const $eb41bcd877362d81$export$1c3aa89ea6d8c93d = new (0, (0, parcelRequire("duUGa")).UFOExperience)('issue-view.edit-status', {
        type: (0, (0, parcelRequire("atdLB")).ExperienceTypes).Operation,
        performanceType: (0, (0, parcelRequire("atdLB")).ExperiencePerformanceTypes).Custom
    });
});
parcelRegister("4zzYB", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$229b8164a902ee55$export$defe85febe8b728c);
    var $7VHMR;
    const $229b8164a902ee55$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statusNameButtonLabel: {
            "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
            "defaultMessage": "Edit {statusName} status"
        },
        statusEditNameTooltip: {
            "id": "issue-field-status.status-view.transition.configure-status.status-edit-name-tooltip",
            "defaultMessage": "Edit name"
        },
        createStatus: {
            "id": "issue-field-status.status-view.configure-status.create-status",
            "defaultMessage": "Create status"
        }
    });
});
parcelRegister("5uNOo", function(module, exports) {
    $parcel$export(module.exports, "EditStatusButton", ()=>$4d1ec0a4b4de57d9$export$bc1c056aa3d67f87);
    var $5uXOq = parcelRequire("5uXOq");
    var $4ChK1;
    var $5ILhZ;
    var $8CUq3;
    var $3bDjY;
    var $fA8Uw;
    var $koVbs;
    var $2vLHS;
    var $2KAtx;
    var $8zOmE;
    var $2NMNM;
    var $5BSCo;
    var $4zzYB;
    const $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87 = ({ status: status, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onButtonClick = (event, analyticsEvent)=>{
            onClick();
            event.stopPropagation();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'editStatusButton');
        };
        const onCloseModal = (0, $5uXOq.useCallback)(()=>{
            onClose();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineEditStatusModal',
                action: 'closed'
            }));
        }, [
            createAnalyticsEvent,
            onClose
        ]);
        const entryPointProps = {
            onClose: onCloseModal,
            status: status,
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            editStatusExperience: (0, parcelRequire("5BSCo")).editStatusExperience,
            statusNames: statusNames,
            source: (0, $a05d2e59d0770cd0$export$cafb161c2b21b455)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2KAtx")).ModalEntryPointPressableTrigger), {
            entryPoint: (0, (0, parcelRequire("fA8Uw")).asyncInlineEditStatusModal),
            entryPointProps: entryPointProps,
            interactionName: "edit-status-modal",
            modalProps: (0, (0, parcelRequire("2vLHS")).defaultModalProps),
            useInternalModal: true
        }, ({ ref: ref })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ILhZ")).default), {
                tabIndex: 0,
                xcss: $4d1ec0a4b4de57d9$var$iconButtonStyles,
                onClick: onButtonClick,
                "aria-label": formatMessage((0, (0, parcelRequire("4zzYB")).messages).statusNameButtonLabel, {
                    statusName: status.statusName
                }),
                "data-show-on-hover": true,
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                content: formatMessage((0, (0, parcelRequire("4zzYB")).messages).statusEditNameTooltip),
                position: "bottom"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4ChK1"))))), {
                label: "",
                LEGACY_size: "small",
                color: "var(--ds-icon, #44546F)"
            }))));
    };
    const $4d1ec0a4b4de57d9$var$iconButtonStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: 'border.radius',
        outlineOffset: 'space.0',
        padding: 'space.025',
        marginInline: 'space.100',
        opacity: 0,
        transition: 'opacity 0.3s ease',
        ':focus': {
            boxShadow: 'elevation.shadow.overflow',
            opacity: 1
        },
        ':hover': {
            backgroundColor: 'color.background.neutral.subtle.hovered',
            opacity: 1
        }
    });
});
parcelRegister("fA8Uw", function(module, exports) {
    $parcel$export(module.exports, "asyncInlineEditStatusModal", ()=>$df8f5b3d88f876e0$export$c3f451c40832a786);
    var $eufEc;
    var $fEDBv;
    const $df8f5b3d88f876e0$export$c3f451c40832a786 = (0, (0, parcelRequire("fEDBv")).createEntryPoint)({
        root: (0, (0, parcelRequire("eufEc")).JSResourceForInteraction)(()=>(parcelRequire("bC0A4")).then((module)=>module.AsyncInlineEditStatusModal), {
            moduleId: "7a687b9d",
            moduleName: "AsyncInlineEditStatusModal"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("bC0A4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("a9RoT").then(()=>parcelRequire('6REvz'));
});
parcelRegister("k92cH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d361f761a404638a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d361f761a404638a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noPermission: {
            "id": "issue-field-status.status-view.no-permission",
            "defaultMessage": "You don't have permission to transition this issue"
        },
        cannotLoadTransitions: {
            "id": "issue-field-status.status-view.cannot-load-transitions",
            "defaultMessage": "We couldn't load the statuses and transitions"
        },
        changeStatus: {
            "id": "issue-field-status.status-view.change-status",
            "defaultMessage": "Change status"
        },
        selectStatus: {
            "id": "issue-field-status.status-view.select-status",
            "defaultMessage": "Select status"
        },
        transitionTo: {
            "id": "issue-field-status.status-view.transition-to",
            "defaultMessage": "Transition to {statusName}"
        },
        noPermissionIssueTermRefresh: {
            "id": "issue-field-status.status-view.no-permission-issue-term-refresh",
            "defaultMessage": "You don't have permission to transition this issue"
        }
    });
});
parcelRegister("coyc6", function(module, exports) {
    $parcel$export(module.exports, "LoadingSpinner", ()=>$75fbb15d605c0a9c$export$b08b517936747730);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eZJjh;
    const $75fbb15d605c0a9c$export$b08b517936747730 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($75fbb15d605c0a9c$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eZJjh")).default), {
            interactionName: "issue.fields.status.options.loading"
        }));
    const $75fbb15d605c0a9c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4u2gc _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("rNSQs", function(module, exports) {
    $parcel$export(module.exports, "StatusButton", ()=>$acb4d573ba7a4450$export$517b7ecb2da8e76d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $6Ingq;
    var $3bDjY;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    var $9wjvq;
    var $2Z7Z6;
    const $acb4d573ba7a4450$var$getButtonStyles = ()=>{
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return {
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            '::after': {
                border: 'none'
            }
        };
        return {
            fontWeight: "var(--ds-font-weight-semibold, 600)"
        };
    };
    const $acb4d573ba7a4450$var$getButton = (categoryId)=>{
        switch(categoryId){
            case 2:
                return $acb4d573ba7a4450$var$ToDoButton;
            case 3:
                return 0, (0, parcelRequire("2Z7Z6")).DoneButton;
            case 4:
                return $acb4d573ba7a4450$var$InProgressButton;
            default:
                return $acb4d573ba7a4450$var$DefaultButton;
        }
    };
    const $acb4d573ba7a4450$export$517b7ecb2da8e76d = (props)=>{
        const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
        const Button = $acb4d573ba7a4450$var$getButton(status.statusCategory.id);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: targetRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: status.name
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9wjvq")).default), {
            status: status
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Button, {
            id: "issue.fields.status-view.status-button",
            ref: statusButtonRef,
            "aria-label": ariaLabel,
            "aria-expanded": isOpen,
            isDisabled: !isEditable,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6Ingq"))))), {
                label: ""
            }),
            testId: "issue-field-status.ui.status-view.status-button.status-button",
            shouldFitContainer: shouldFitContainer,
            ...(0, (0, parcelRequire("4R6GH")).fg)('issue-jiv-18579-status-field-interaction-name') ? {
                interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined
            } : {}
        }, status.name))));
    };
    const $acb4d573ba7a4450$var$InProgressComponentVisualRefresh = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gp2jz _11a4p2jz _dntb4viv _cp4g4viv _5xmd1185 _11sm4viv",
                __cmplp.className
            ])
        });
    });
    const $acb4d573ba7a4450$var$InProgressComponentCurrent = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
                __cmplp.className
            ])
        });
    });
    const $acb4d573ba7a4450$var$InProgressButton = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $acb4d573ba7a4450$var$InProgressComponentVisualRefresh, $acb4d573ba7a4450$var$InProgressComponentCurrent);
    const $acb4d573ba7a4450$var$ToDoButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
                __cmplp.className
            ])
        });
    });
    const $acb4d573ba7a4450$var$DefaultButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9wjvq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1216c2da1b38029$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $b1216c2da1b38029$var$DONE_ID = 3;
    class $b1216c2da1b38029$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
                shouldShow: this.props.status.statusCategory.id === $b1216c2da1b38029$var$DONE_ID
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b1216c2da1b38029$var$PulseContainer, {
                shouldShow: this.state.shouldShow
            }, this.props.children);
        }
        constructor(...args){
            super(...args), this.state = {
                shouldShow: false
            };
        }
    }
    const $b1216c2da1b38029$var$PulseAnimation = (0, $47bDC.keyframes)({
        to: {
            boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
        }
    });
    const $b1216c2da1b38029$var$PulseContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1qbqnkm": (0, (0, parcelRequire("lD23V")).default)($b1216c2da1b38029$var$PulseAnimation)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _1bsb1osq _2rko1l7b _16qs13jn",
                __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2Z7Z6", function(module, exports) {
    $parcel$export(module.exports, "DoneButton", ()=>$bb0c7ad61f4c3610$export$e6559310cd173125);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $7XYc4;
    var $4R6GH;
    var $dCm1o;
    const $bb0c7ad61f4c3610$var$getButtonStyles = ()=>{
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return {
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            '::after': {
                border: 'none'
            }
        };
        return {
            fontWeight: "var(--ds-font-weight-semibold, 600)"
        };
    };
    const $bb0c7ad61f4c3610$export$b7c3a2f69225ecf = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$97f73b7c6e2328e5 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gp2jz _11a4p2jz _dntb4viv _cp4g4viv _5xmd1185 _11sm4viv",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$var$InProgressComponentCurrent = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$8c94aeefd701630d = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh, $bb0c7ad61f4c3610$var$InProgressComponentCurrent);
    const $bb0c7ad61f4c3610$export$5392037c0e6ad119 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb4viv _cp4g4viv _5xmdqnrl _11sm4viv",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$5445f55445c67248 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_12r21pd9 _1n8wglyw",
                !__cmplp.isSelected && "_193g147y _11a4147y _dntb1gfe _cp4g1gfe _5xmdihng _11sm1gfe",
                __cmplp.className
            ])
        });
    });
    const $bb0c7ad61f4c3610$export$e6559310cd173125 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'), $bb0c7ad61f4c3610$export$5392037c0e6ad119, $bb0c7ad61f4c3610$export$5445f55445c67248);
});
parcelRegister("1khYv", function(module, exports) {
    $parcel$export(module.exports, "Transition", ()=>$548d8ec8e7bf977f$export$be58926105124dd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kkuz9;
    var $3bDjY;
    var $5f2o3;
    var $cPJPi;
    const $548d8ec8e7bf977f$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter, testId: testId })=>{
        if (transition.isDisabled === true) return (0, ($parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$DisabledTransition, {
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cPJPi")).TransitionWithoutLabel), {
            transition: transition,
            isDisabled: true
        }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            content: transition.unavailableReasonText
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$IconWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kkuz9"))))), {
            label: "",
            primaryColor: `var(--ds-text-disabled, ${(0, $829f609a65d26a98$exports).N200})`
        }))));
        const transitionComponent = hasLabel ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5f2o3")).TransitionWithLabel), {
            transition: transition,
            addTransitionArrowSpacing: addTransitionArrowSpacing
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cPJPi")).TransitionWithoutLabel), {
            transition: transition
        });
        return contentAfter ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
            ])
        }, transitionComponent, contentAfter) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": testId
        }, transitionComponent);
    };
    const $548d8ec8e7bf977f$var$DisabledTransition = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $548d8ec8e7bf977f$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3io7ao _1reoewfl _18m9ewfl _19pkr5cr",
                __cmplp.className
            ])
        });
    });
    const $548d8ec8e7bf977f$export$7ed12d2a5241e393 = {
        IconWrapper: $548d8ec8e7bf977f$var$IconWrapper
    };
    const $548d8ec8e7bf977f$var$transitionWrapperStyles = null;
});
parcelRegister("5f2o3", function(module, exports) {
    $parcel$export(module.exports, "TransitionWithLabel", ()=>$ce0d296e0359021c$export$20d2722b94f01359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8RBk4;
    var $kgoHi;
    var $4R6GH;
    var $aWse0;
    var $dCm1o;
    var $17mYr;
    var $cnQeu;
    const $ce0d296e0359021c$var$getLabel = (transition, intl)=>{
        if (transition.isGlobal) {
            if (transition.name !== transition.to.name) return transition.name;
            return intl.formatMessage((0, (0, parcelRequire("cnQeu")).default).globalTransition);
        }
        return transition.name;
    };
    const $ce0d296e0359021c$export$20d2722b94f01359 = (props)=>{
        const intl = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$147422f7450ccfac, null, $ce0d296e0359021c$var$getLabel(props.transition, intl)), (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$da4545fe0ca096cf, {
            visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$VerticalCenter, {
            addTransitionArrowSpacing: props.addTransitionArrowSpacing
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
            label: "",
            size: "small"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).StatusLozenge), {
            status: props.transition.to,
            isDisabled: props.isDisabled
        })));
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            gap: "space.100"
        }, content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$Wrapper, null, content);
    };
    const $ce0d296e0359021c$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$export$147422f7450ccfac = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$export$da4545fe0ca096cf = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf _1e0c1txw",
                __cmplp.visualRefresh && "_4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $ce0d296e0359021c$var$VerticalCenter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _4cvr1h6o",
                __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("cnQeu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1c9e2137350f319$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a1c9e2137350f319$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        globalTransition: {
            "id": "issue-field-status.status-view.transition.with-label.global-transition",
            "defaultMessage": "Transition to"
        }
    });
});
parcelRegister("cPJPi", function(module, exports) {
    $parcel$export(module.exports, "TransitionWithoutLabel", ()=>$35e7b9f215fedcad$export$4cf2c7e5a408120e);
    var $5uXOq = parcelRequire("5uXOq");
    var $17mYr;
    const $35e7b9f215fedcad$export$4cf2c7e5a408120e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17mYr")).StatusLozenge), {
            status: props.transition.to,
            isDisabled: props.isDisabled
        });
});
parcelRegister("8umLM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c153c4d673a3bed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $8c153c4d673a3bed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        statusFieldLabel: {
            "id": "issue-create.modal.create-form.status-field.status-field-label",
            "defaultMessage": "Status"
        },
        unavailableStatusText: {
            "id": "issue-create.modal.create-form.status-field.unavailable-status-text",
            "defaultMessage": "Your workflow doesn't allow issues to be created in this status"
        },
        helperTextFade: {
            "id": "issue-create.modal.create-form.status-field.helper-text",
            "defaultMessage": "This is the initial status upon creation"
        },
        helperText: {
            "id": "issue-create.modal.create-form.status-field.helper-text-to-be-faded",
            "defaultMessage": "This is the issue's initial status upon creation"
        },
        noEnabledTransitionsMessage: {
            "id": "issue-create.modal.create-form.status-field.no-enabled-transitions-message",
            "defaultMessage": "There are no statuses available for you to use"
        },
        warningIconLabel: {
            "id": "issue-create.modal.create-form.status-field.warning-icon-label",
            "defaultMessage": "Warning"
        },
        warningMessage: {
            "id": "issue-create.modal.create-form.status-field.warning-message",
            "defaultMessage": "This field isn\u2019t working right now. You can still create your issue and update the status later."
        },
        unavailableStatusTextIssueTermRefresh: {
            "id": "issue-create.modal.create-form.status-field.unavailable-status-text-issue-term-refresh",
            "defaultMessage": "Your workflow doesn't allow work items to be created in this status"
        },
        helperTextIssueTermRefresh: {
            "id": "issue-create.modal.create-form.status-field.helper-text-issue-term-refresh",
            "defaultMessage": "This is the initial status once created."
        },
        warningMessageIssueTermRefresh: {
            "id": "issue-create.modal.create-form.status-field.warning-message-issue-term-refresh",
            "defaultMessage": "This field isn\u2019t working right now. You can still create your work item and update the status later."
        }
    });
});
parcelRegister("aPuaG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$80155aca30b752b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $qfj8c;
    var $7O4UO;
    var $7K5PP;
    var $2vSU6;
    var $gwIPs;
    var $7CMCs;
    var $6s1PB;
    var $4R6GH;
    var $bPtOr;
    var $koVbs;
    var $3IJWP;
    var $59xJP;
    var $mTNgq;
    var $45JN1;
    var $7C5S0;
    var $45Cy1;
    var $9UhzQ;
    var $9QJ7Z;
    var $5fc53;
    var $1XJ20;
    var $8zOmE;
    var $2NMNM;
    var $lsFXb;
    var $2eeg1;
    var $kHA0a;
    var $dNpFP;
    var $30fo0;
    var $iwPB7;
    var $fjTud;
    var $f1j0c;
    var $5FQop;
    const $80155aca30b752b4$var$typePickerMargin = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.25;
    const $80155aca30b752b4$var$TypePicker = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onChange: onChange, issueTypes: issueTypes, requestTypes: requestTypes, value: selectedRequestOrIssueType, projectType: projectType, isDisabled: isDisabled = false, isMini: isMini } = props;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const previousSelectedRequestOrIssueType = (0, (0, parcelRequire("1XJ20")).usePrevious)(selectedRequestOrIssueType);
        (0, $5uXOq.useEffect)(()=>{
            if (requestTypes && previousSelectedRequestOrIssueType === null && selectedRequestOrIssueType && selectedRequestOrIssueType.type === (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)) {
                const firstMatchingRequestType = (0, (0, parcelRequire("5FQop")).getFirstMatchingRequestType)({
                    issueType: selectedRequestOrIssueType,
                    allRequestTypes: requestTypes
                });
                if (firstMatchingRequestType) {
                    onChange(firstMatchingRequestType);
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect forceDefaultNotNone');
                }
            }
        }, [
            createAnalyticsEvent,
            onChange,
            previousSelectedRequestOrIssueType,
            requestTypes,
            selectedRequestOrIssueType
        ]);
        const getIssueTypeHelpText = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("45JN1")).FieldMessage), {
                fieldHelpTextUrl: (0, $9f7a9355e2f380ff$export$4435027827ccff2d),
                fieldName: "Issue Type",
                onLinkClickEvent: (0, (0, parcelRequire("dNpFP")).openInNewTabLinkClickEventHandler),
                isMini: isMini
            }), [
            isMini
        ]);
        const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        (0, $5uXOq.useEffect)(()=>{
            if (submitFieldwiseErrors?.issuetype) (0, (0, parcelRequire("kHA0a")).scrollToElement)((0, $9f7a9355e2f380ff$export$f1623876ce3d4391));
        }, [
            submitFieldwiseErrors?.issuetype
        ]);
        const fields = (0, $5uXOq.useMemo)(()=>{
            let fieldsNode;
            const projectTypeCheck = (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) || projectType === (0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT) : projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
            if (projectTypeCheck && requestTypes !== undefined) {
                const { issueTypeOptions: issueTypeOptions, requestTypeOptions: requestTypeOptions } = (0, (0, parcelRequire("5FQop")).getRequestAndIssueTypeOptionsGroup)(issueTypes, requestTypes, formatMessage);
                const { issueType: selectedIssueType, requestType: selectedRequestType } = (0, (0, parcelRequire("5FQop")).getIssueTypeAndRequestType)({
                    allIssueTypes: issueTypeOptions,
                    requestOrIssueType: selectedRequestOrIssueType,
                    formatMessage: formatMessage
                });
                const onIssueTypeSelectOpen = ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
                const onRequestTypeSelectOpen = ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect open');
                const onIssueTypeChange = (issueType)=>{
                    if (issueType.value === selectedIssueType?.value) return;
                    const firstMatchingRequestType = (0, (0, parcelRequire("5FQop")).getFirstMatchingRequestType)({
                        issueType: issueType,
                        allRequestTypes: requestTypes
                    });
                    onChange(firstMatchingRequestType || issueType);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect selected');
                };
                const onRequestTypeChange = (requestTypeOrNone)=>{
                    if (requestTypeOrNone.value === selectedRequestType?.value) return;
                    let isNoneSelected = true;
                    if (requestTypeOrNone.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)) {
                        onChange(requestTypeOrNone);
                        isNoneSelected = false;
                    } else if (selectedIssueType !== null) onChange(selectedIssueType);
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect selected', {
                        isNoneSelected: isNoneSelected
                    });
                };
                const requestTypeHelpText = selectedRequestType && selectedRequestType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedRequestType.helpText : '';
                fieldsNode = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
                    width: isMini ? '100%' : undefined,
                    marginTop: $80155aca30b752b4$var$typePickerMargin
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    name: "issue-type-picker",
                    label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("30fo0")).default).issueTypeFieldLabelIssueTermRefresh : (0, (0, parcelRequire("30fo0")).default).issueTypeFieldLabel),
                    isRequired: true
                }, ({ fieldProps: { id: id, isRequired: isRequired } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                        inputId: id,
                        required: isRequired,
                        options: issueTypeOptions,
                        value: selectedIssueType,
                        onChange: onIssueTypeChange,
                        onMenuOpen: onIssueTypeSelectOpen,
                        isClearable: false,
                        formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
                        placeholder: "",
                        id: (0, $9f7a9355e2f380ff$export$f1623876ce3d4391),
                        isDisabled: isDisabled,
                        onKeyDown: (0, (0, parcelRequire("kHA0a")).preventEscKeyPropagationKeyPressHandler)
                    }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, submitFieldwiseErrors.issuetype)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
                    width: "100%",
                    marginTop: $80155aca30b752b4$var$typePickerMargin
                }, (0, ($parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequestTypeFieldWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                    name: "request-type-picker",
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequestTypeFieldLabelWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, (0, parcelRequire("30fo0")).default).requestTypeFieldLabel), (0, ($parcel$interopDefault($5uXOq))).createElement($80155aca30b752b4$var$RequiredIndicator, null, "*")), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iwPB7")).WhatsThis), null))
                }, ({ fieldProps: { id: id } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f1j0c")).RequestTypeSelect), {
                        inputId: id,
                        options: requestTypeOptions,
                        value: selectedRequestType,
                        onChange: onRequestTypeChange,
                        onMenuOpen: onRequestTypeSelectOpen,
                        id: "issue-create.ui.modal.create-form.type-picker.request-type-select"
                    }))), requestTypeHelpText && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjTud")).RequestTypeHelpText), {
                    helpText: requestTypeHelpText
                })));
            } else {
                const label = (0, (0, parcelRequire("5FQop")).getFieldLabel)(Boolean(requestTypes?.length), formatMessage);
                const onIssueTypeChange = (selectedIssueType)=>{
                    if (selectedIssueType.value === selectedRequestOrIssueType?.value) return;
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'selected',
                        actionSubject: 'option'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueType');
                    onChange(selectedIssueType);
                };
                const Component = (componentProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                        id: "withFormField",
                        packageName: "jiraIssueCreateModal",
                        sendToPrivacyUnsafeSplunk: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7O4UO")).default), {
                        name: "type-picker",
                        label: label,
                        isRequired: true,
                        elementAfterLabel: componentProps.areUiModificationsBusy ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("59xJP")).FieldBusyIndicator), {
                            fieldId: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
                        }) : undefined
                    }, ({ fieldProps: fieldProps })=>{
                        const renderFieldContent = ({ id: id, isRequired: isRequired })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
                                inputId: id,
                                required: isRequired,
                                options: componentProps.allowedValues,
                                onChange: onIssueTypeChange,
                                value: selectedRequestOrIssueType,
                                isClearable: false,
                                formatOptionLabel: (0, (0, parcelRequire("9UhzQ")).formatOptionLabel),
                                placeholder: "",
                                id: (0, $9f7a9355e2f380ff$export$f1623876ce3d4391),
                                isDisabled: !!(isDisabled || componentProps.isReadOnly),
                                onKeyDown: (0, (0, parcelRequire("kHA0a")).preventEscKeyPropagationKeyPressHandler)
                            }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("qfj8c")).ErrorMessage), null, submitFieldwiseErrors.issuetype));
                        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassOutput), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                            id: "issueAdjustmentsFieldValueDecorator",
                            packageName: "jiraIssueCreateModal",
                            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps)),
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: (error)=>({
                                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                                    viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                                    fieldId: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                                    fieldType: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)
                                })
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2eeg1")).FieldValueDecoratorAsync), {
                            fieldId: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                            fieldType: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                            fieldProps: {
                                ...fieldProps,
                                value: selectedRequestOrIssueType
                            }
                        }, (interceptedFieldProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IJWP")).ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps)))));
                    }));
                const typePickerComponentProps = {
                    fieldId: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                    fieldName: label,
                    fieldType: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
                    isRequired: true,
                    gqlType: '',
                    allowedValues: issueTypes
                };
                const setFieldValue = (_, value)=>onIssueTypeChange(value);
                const getFormState = ()=>({
                        values: {
                            [typePickerComponentProps.fieldId]: selectedRequestOrIssueType
                        }
                    });
                fieldsNode = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9QJ7Z")).FormApiProvider), {
                    setFieldValue: setFieldValue,
                    getFormState: getFormState
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7C5S0")).FieldContainer), {
                    width: isMini ? '100%' : undefined,
                    marginTop: $80155aca30b752b4$var$typePickerMargin
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
                    id: "globalIssueCreateIssueAdjustmentsAdapter",
                    packageName: "issueCreateModal",
                    fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("mTNgq")).IssueAdjustmentsErrorHandler), null), (0, ($parcel$interopDefault($5uXOq))).createElement(Component, typePickerComponentProps)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (error)=>({
                            errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error),
                            viewType: (0, $380826ec5efdda82$export$e615b7e9b8fb4715),
                            fieldId: typePickerComponentProps.fieldId,
                            fieldType: typePickerComponentProps.fieldType
                        })
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lsFXb")).FieldDecoratorAsync), {
                    Component: Component,
                    componentProps: typePickerComponentProps
                }))));
            }
            return fieldsNode;
        }, [
            createAnalyticsEvent,
            formatMessage,
            issueTypes,
            onChange,
            projectType,
            requestTypes,
            selectedRequestOrIssueType,
            getIssueTypeHelpText,
            submitFieldwiseErrors?.issuetype,
            isDisabled,
            isMini
        ]);
        return fields;
    };
    var $80155aca30b752b4$export$2e2bcd8739ae039 = $80155aca30b752b4$var$TypePicker;
    const $80155aca30b752b4$var$RequestTypeFieldWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "cz2iu2-0"
    })({
        '> div': {
            '> label': {
                width: '100%'
            }
        }
    });
    const $80155aca30b752b4$var$RequiredIndicator = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1ick _19bvv77o",
                __cmplp.className
            ])
        });
    });
    const $80155aca30b752b4$var$RequestTypeFieldLabelWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1q9y _1bah1yb4 _1bsb1osq _4t3i1osq _19pk12x7",
                __cmplp.className
            ])
        });
    });
});
const $9f7a9355e2f380ff$export$4435027827ccff2d = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';
const $9f7a9355e2f380ff$export$f1623876ce3d4391 = 'issue-create.ui.modal.create-form.type-picker.issue-type-select';
parcelRegister("30fo0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53b43b84b88f3b1f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $53b43b84b88f3b1f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypeFieldLabel: {
            "id": "issue-create.modal.create-form.type-picker.issue-type-field-label",
            "defaultMessage": "Issue type"
        },
        requestTypeFieldLabel: {
            "id": "issue-create.modal.create-form.type-picker.request-type-field-label",
            "defaultMessage": "Request type"
        },
        typeFieldLabel: {
            "id": "issue-create.modal.create-form.type-picker.type-field-label",
            "defaultMessage": "Type"
        },
        issueTypeGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.issue-type-group-label",
            "defaultMessage": "Issue types"
        },
        requestTypeGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.request-type-group-label",
            "defaultMessage": "Request types"
        },
        unassignedRequestTypeGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.unassigned-request-type-group-label",
            "defaultMessage": "Unassigned"
        },
        serviceRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.service-request-group-label",
            "defaultMessage": "Service requests"
        },
        incidentRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.incident-request-group-label",
            "defaultMessage": "Incidents"
        },
        postIncidentReviewRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.post-incident-review-request-group-label",
            "defaultMessage": "Post-incident reviews"
        },
        developerEscalationRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.developer-escalation-request-group-label",
            "defaultMessage": "Developer escalations"
        },
        problemRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.problem-request-group-label",
            "defaultMessage": "Problems"
        },
        changeRequestGroupLabel: {
            "id": "issue-create.modal.create-form.type-picker.change-request-group-label",
            "defaultMessage": "Changes"
        },
        noRequestTypeLabel: {
            "id": "issue-create.modal.create-form.type-picker.no-request-type-label",
            "defaultMessage": "No request type"
        },
        issueTypeHelpText: {
            "id": "issue-create.modal.create-form.type-picker.issue-type-help-text",
            "defaultMessage": "Learn more"
        },
        issueTypeFieldLabelIssueTermRefresh: {
            "id": "issue-create.modal.create-form.type-picker.issue-type-field-label-issue-term-refresh",
            "defaultMessage": "Work type"
        },
        issueTypeGroupLabelIssueTermRefresh: {
            "id": "issue-create.modal.create-form.type-picker.issue-type-group-label-issue-term-refresh",
            "defaultMessage": "Work types"
        }
    });
});
parcelRegister("iwPB7", function(module, exports) {
    $parcel$export(module.exports, "WhatsThis", ()=>$0d98e1ee11ab43db$export$9fb74911aca1203);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $ctg8C;
    var $cgL5K;
    var $6s1PB;
    var $ousew;
    var $aWse0;
    var $8zOmE;
    var $2NMNM;
    var $dWeb7;
    const $0d98e1ee11ab43db$export$9fb74911aca1203 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const toggleDialog = (0, $5uXOq.useCallback)(()=>{
            if (!isOpen) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeHelpDialogButton clicked');
            setIsOpen(!isOpen);
        }, [
            createAnalyticsEvent,
            isOpen
        ]);
        const dialogContent = (0, $5uXOq.useMemo)(()=>{
            const onClickLearnMoreLink = ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeLearnMoreLink clicked');
            return (0, ($parcel$interopDefault($5uXOq))).createElement($0d98e1ee11ab43db$var$DialogContainer, {
                "data-testid": "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.dialog-container"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
                as: "p"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...(0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("dWeb7")).default).whatsThisDialogBodyIssueTermRefresh : (0, (0, parcelRequire("dWeb7")).default).whatsThisDialogBody,
                values: {
                    learnMoreAboutRequestTypesLink: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                        href: (0, $c741ce656e4e30c0$export$2e27f6d0b2889d14),
                        target: "_blank",
                        onClick: onClickLearnMoreLink,
                        onAuxClick: onClickLearnMoreLink
                    }, formatMessage((0, (0, parcelRequire("dWeb7")).default).learnMoreAboutRequestTypesLink))
                }
            })));
        }, [
            createAnalyticsEvent,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ctg8C")).default), {
            content: dialogContent,
            isOpen: isOpen,
            placement: "bottom-end",
            onClose: toggleDialog
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0d98e1ee11ab43db$var$WhatsThisButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            spacing: "none",
            onClick: toggleDialog
        }, formatMessage((0, (0, parcelRequire("dWeb7")).default).whatsThisDialogTrigger))));
    };
    const $0d98e1ee11ab43db$var$WhatsThisButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _11c81vlj",
                __cmplp.className
            ])
        });
    });
    const $0d98e1ee11ab43db$var$DialogContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1178",
                __cmplp.className
            ])
        });
    });
});
const $c741ce656e4e30c0$export$2e27f6d0b2889d14 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-request-types/';
parcelRegister("dWeb7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e267979802c002e5$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e267979802c002e5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        whatsThisDialogTrigger: {
            "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-trigger",
            "defaultMessage": "What\u2019s this?"
        },
        whatsThisDialogBody: {
            "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body",
            "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the issue view, and access work categories. {learnMoreAboutRequestTypesLink}."
        },
        learnMoreAboutRequestTypesLink: {
            "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.learn-more-about-request-types-link",
            "defaultMessage": "Learn more about request types"
        },
        whatsThisDialogBodyIssueTermRefresh: {
            "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body-issue-term-refresh",
            "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the detailed view of the work item, and access work categories. {learnMoreAboutRequestTypesLink}."
        }
    });
});
parcelRegister("fjTud", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeHelpText", ()=>$aa6f2d8eff006264$export$f97ad894319e2545);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $fVnbM;
    var $3RZIb;
    var $koVbs;
    var $hrR5y;
    var $kjgMT;
    const $aa6f2d8eff006264$export$6167fae6d6ed332c = (element)=>element ? element.scrollHeight !== element.offsetHeight : false;
    const $aa6f2d8eff006264$export$f97ad894319e2545 = ({ helpText: helpText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [shouldCollapse, setShouldCollapse] = (0, $5uXOq.useState)(false);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const toggleIsOpen = ()=>setIsOpen(!isOpen);
        const helpTextRef = (0, $5uXOq.useRef)(undefined);
        const [windowWidth, windowHeight] = (0, (0, parcelRequire("hrR5y")).useWindowSize)();
        (0, $5uXOq.useEffect)(()=>{
            const newShouldCollapse = $aa6f2d8eff006264$export$6167fae6d6ed332c(helpTextRef.current);
            setShouldCollapse(newShouldCollapse);
            if (!newShouldCollapse) setIsOpen(false);
        }, [
            shouldCollapse,
            helpText,
            windowWidth,
            windowHeight
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$Collapser, {
            isOpen: isOpen
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$HelpText, {
            isOpen: isOpen,
            innerRef: helpTextRef
        }, helpText)), shouldCollapse && (0, ($parcel$interopDefault($5uXOq))).createElement($aa6f2d8eff006264$var$ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            spacing: "none",
            appearance: "subtle-link",
            onClick: toggleIsOpen
        }, formatMessage(isOpen ? (0, (0, parcelRequire("kjgMT")).default).showLess : (0, (0, parcelRequire("kjgMT")).default).showMore))));
    };
    const $aa6f2d8eff006264$var$HelpText = (0, $47bDC.default).p.withConfig({
        componentId: "jy4tmi-0"
    })({
        color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N200})`,
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }, ({ isOpen: isOpen })=>!isOpen ? `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    ` : '');
    const $aa6f2d8eff006264$var$Collapser = (0, $47bDC.default).div.withConfig({
        componentId: "jy4tmi-1"
    })((props)=>({
            marginTop: "var(--ds-space-100, 8px)",
            overflow: 'hidden',
            maxHeight: props.isOpen ? 'fit-content' : '32px'
        }));
    const $aa6f2d8eff006264$var$ButtonWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "jy4tmi-2"
    })`${(0, (0, parcelRequire("3RZIb")).h100)()};font:${"var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"};padding:0;margin:0;margin-top:${"var(--ds-space-075, 6px)"};button{padding:0;margin:0;border:0;}`;
});
parcelRegister("hrR5y", function(module, exports) {
    $parcel$export(module.exports, "useWindowSize", ()=>$2ff720dc5374fa2c$export$42c02f33970a2afa);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    const $2ff720dc5374fa2c$export$42c02f33970a2afa = ()=>{
        const isClient = !false;
        const getSize = ()=>({
                width: isClient ? window.innerWidth : undefined,
                height: isClient ? window.innerHeight : undefined
            });
        const [windowSize, setWindowSize] = (0, $5uXOq.useState)(getSize());
        const onResize = ()=>{
            setWindowSize(getSize());
        };
        const onResizeDebounced = (0, ($parcel$interopDefault($lFKmC)))(onResize, 100, {
            leading: true,
            trailing: true
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isClient) return undefined;
            window.addEventListener('resize', onResizeDebounced);
            return ()=>{
                window.removeEventListener('resize', onResizeDebounced);
            };
        }, [
            onResizeDebounced,
            isClient
        ]);
        return [
            windowSize.width,
            windowSize.height
        ];
    };
});
parcelRegister("kjgMT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bde34240bd1e2f2c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bde34240bd1e2f2c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showMore: {
            "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-more",
            "defaultMessage": "Show more\u2026"
        },
        showLess: {
            "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-less",
            "defaultMessage": "Show less\u2026"
        }
    });
});
parcelRegister("f1j0c", function(module, exports) {
    $parcel$export(module.exports, "RequestTypeSelect", ()=>$933e94b9786a21b2$export$3b6e21307c2d4f74);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $7K5PP;
    var $3RZIb;
    var $6s1PB;
    var $7mok3;
    var $koVbs;
    var $kHA0a;
    var $52O4s;
    const $933e94b9786a21b2$var$selectStyles = {
        control: (supplied)=>({
                ...supplied,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        valueContainer: (supplied)=>({
                ...supplied,
                padding: '0',
                paddingLeft: "var(--ds-space-150, 12px)",
                height: '42px'
            }),
        menuList: (supplied)=>({
                ...supplied,
                padding: 0
            }),
        group: (supplied)=>({
                ...supplied,
                padding: 0
            }),
        groupHeading: (supplied)=>({
                ...supplied,
                margin: 0,
                paddingTop: "var(--ds-space-200, 16px)",
                paddingBottom: "var(--ds-space-100, 8px)",
                font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text, ${(0, $829f609a65d26a98$exports).N600})`,
                textTransform: 'none'
            }),
        singleValue: (supplied)=>({
                ...supplied,
                top: 0,
                left: "var(--ds-space-150, 12px)",
                textOverflow: 'ellipsis',
                transform: 'none',
                whiteSpace: 'nowrap',
                width: '100%',
                paddingRight: "var(--ds-space-400, 32px)"
            }),
        option: (supplied)=>({
                ...supplied,
                cursor: 'pointer',
                paddingLeft: "var(--ds-space-200, 16px)",
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)",
                margin: 0
            })
    };
    const $933e94b9786a21b2$export$3b6e21307c2d4f74 = (0, $5uXOq.memo)((props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const formatOptionLabel = (0, $5uXOq.useCallback)((option, { context: context })=>{
            const description = option.type === 'NONE' ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("52O4s")).default).noRequestTypeOptionDescriptionIssueTermRefresh : (0, (0, parcelRequire("52O4s")).default).noRequestTypeOptionDescription) : option.description;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$FlexRow, null, (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$IconWrapper, null, option.type === 'NONE' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7mok3")).default), {
                label: ""
            }) : Boolean(option.iconUrl) && (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Icon, {
                src: option.iconUrl,
                alt: option.label
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$FlexColumn, {
                isMenu: context === 'menu'
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Label, {
                "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.label",
                isMenu: context === 'menu'
            }, option.label), (0, ($parcel$interopDefault($5uXOq))).createElement($933e94b9786a21b2$var$Description, {
                "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.description",
                isMenu: context === 'menu'
            }, description)));
        }, [
            formatMessage
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7K5PP")).default), {
            ...props,
            isClearable: false,
            formatOptionLabel: formatOptionLabel,
            hideSelectedOptions: false,
            placeholder: "",
            maxMenuHeight: 256,
            styles: $933e94b9786a21b2$var$selectStyles,
            onKeyDown: (0, (0, parcelRequire("kHA0a")).preventEscKeyPropagationKeyPressHandler),
            "aria-label": formatMessage((0, (0, parcelRequire("52O4s")).default).ariaLabel)
        }));
    });
    const $933e94b9786a21b2$var$FlexRow = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1y6m",
                __cmplp.className
            ])
        });
    });
    const $933e94b9786a21b2$var$FlexColumn = (0, $47bDC.default).div.withConfig({
        componentId: "sc-1l270fi-0"
    })((props)=>({
            flexDirection: 'column',
            display: 'flex',
            width: `calc(100% - ${props.isMenu ? 40 : 14}px)`
        }));
    const $933e94b9786a21b2$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxpxbi _1bsb1tcg _4t3i1tcg",
                __cmplp.className
            ])
        });
    });
    const $933e94b9786a21b2$var$Label = (0, $47bDC.default).p.withConfig({
        componentId: "sc-1l270fi-1"
    })`font:${"var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"};${(0, (0, parcelRequire("3RZIb"))).h400()};height:18px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;`;
    const $933e94b9786a21b2$var$Icon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg",
                __cmplp.className
            ])
        });
    });
    const $933e94b9786a21b2$var$Description = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf _syaz1n3s _19pkidpf _ca0q1b66 _11c81oud _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7mok3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1dd79b0e9c517f00$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $1dd79b0e9c517f00$var$PresenceUnavailableSVG = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            "data-testid": props['data-testid'],
            "aria-label": props['aria-label'],
            className: props.className
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            "fill-opacity": "0.01"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12Z",
            fill: "#42526E"
        }));
    const $1dd79b0e9c517f00$var$PresenceUnavailableIcon = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            ...props,
            glyph: $1dd79b0e9c517f00$var$PresenceUnavailableSVG
        });
    var $1dd79b0e9c517f00$export$2e2bcd8739ae039 = $1dd79b0e9c517f00$var$PresenceUnavailableIcon;
});
parcelRegister("52O4s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1436307c5a3f8ddc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1436307c5a3f8ddc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noRequestTypeOptionDescription: {
            "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description",
            "defaultMessage": "Issues can\u2019t be shared with customers, and may not work as expected."
        },
        ariaLabel: {
            "id": "issue-create.modal.create-form.type-picker.request-type-select.aria-label",
            "defaultMessage": "Select request type"
        },
        noRequestTypeOptionDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description-issue-term-refresh",
            "defaultMessage": "Work items can\u2019t be shared with customers, and may not work as expected."
        }
    });
});
parcelRegister("5FQop", function(module, exports) {
    $parcel$export(module.exports, "getFieldLabel", ()=>$d340f5cdbd034415$export$da6819d9a95804cf);
    $parcel$export(module.exports, "getRequestAndIssueTypeOptionsGroup", ()=>$d340f5cdbd034415$export$37e41f5d9a3e8f14);
    $parcel$export(module.exports, "getIssueTypeAndRequestType", ()=>$d340f5cdbd034415$export$2f84784d8e92f69c);
    $parcel$export(module.exports, "getFirstMatchingRequestType", ()=>$d340f5cdbd034415$export$f0a2ba1b9d3328b);
    var $fn8B5 = parcelRequire("fn8B5");
    var $6s1PB;
    var $30fo0;
    const $d340f5cdbd034415$export$da6819d9a95804cf = (hasRequestTypes, formatMessage)=>hasRequestTypes ? formatMessage((0, (0, parcelRequire("30fo0")).default).typeFieldLabel) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("30fo0")).default).issueTypeFieldLabelIssueTermRefresh : (0, (0, parcelRequire("30fo0")).default).issueTypeFieldLabel);
    const $d340f5cdbd034415$export$8e45723e9c86b276 = (practice, formatMessage)=>{
        if (practice === (0, $4cff3ad70ea80f75$export$b92ccb6dc3cdb548)) return formatMessage((0, (0, parcelRequire("30fo0")).default).changeRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$48c144830383423)) return formatMessage((0, (0, parcelRequire("30fo0")).default).incidentRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$1ea6ead7bcee4494)) return formatMessage((0, (0, parcelRequire("30fo0")).default).problemRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$3d1cda9bd50505e8)) return formatMessage((0, (0, parcelRequire("30fo0")).default).serviceRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$a4a741b969f6509c)) return formatMessage((0, (0, parcelRequire("30fo0")).default).postIncidentReviewRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$81e62964cc725098)) return formatMessage((0, (0, parcelRequire("30fo0")).default).developerEscalationRequestGroupLabel);
        if (practice === (0, $4cff3ad70ea80f75$export$c835df30ebbd529d)) return formatMessage((0, (0, parcelRequire("30fo0")).default).unassignedRequestTypeGroupLabel);
        return formatMessage((0, (0, parcelRequire("30fo0")).default).requestTypeGroupLabel);
    };
    const $d340f5cdbd034415$var$reorderRequestTypeGroups = (requestTypeGroupKeys)=>{
        const allPractices = [
            (0, $4cff3ad70ea80f75$export$3d1cda9bd50505e8),
            (0, $4cff3ad70ea80f75$export$48c144830383423),
            (0, $4cff3ad70ea80f75$export$1ea6ead7bcee4494),
            (0, $4cff3ad70ea80f75$export$b92ccb6dc3cdb548),
            (0, $4cff3ad70ea80f75$export$a4a741b969f6509c),
            (0, $4cff3ad70ea80f75$export$81e62964cc725098),
            (0, $4cff3ad70ea80f75$export$c835df30ebbd529d),
            (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)
        ];
        const groupKeySet = new Set(requestTypeGroupKeys);
        return allPractices.filter((practice)=>groupKeySet.has(practice));
    };
    const $d340f5cdbd034415$var$createNoneOption = (formatMessage)=>({
            label: formatMessage((0, (0, parcelRequire("30fo0")).default).noRequestTypeLabel),
            value: 'none',
            type: 'NONE'
        });
    const $d340f5cdbd034415$export$37e41f5d9a3e8f14 = (issueTypes, requestTypes, formatMessage)=>{
        const groupedRequestTypes = (0, ($parcel$interopDefault($fn8B5)))(requestTypes, (o)=>o.practice);
        const groupKeys = $d340f5cdbd034415$var$reorderRequestTypeGroups(Object.keys(groupedRequestTypes));
        const requestTypesOptions = groupKeys.map((practice)=>({
                label: $d340f5cdbd034415$export$8e45723e9c86b276(practice, formatMessage),
                options: groupedRequestTypes[practice]
            }));
        return {
            issueTypeOptions: issueTypes,
            requestTypeOptions: [
                $d340f5cdbd034415$var$createNoneOption(formatMessage),
                ...requestTypesOptions
            ]
        };
    };
    const $d340f5cdbd034415$export$2f84784d8e92f69c = ({ requestOrIssueType: requestOrIssueType, allIssueTypes: allIssueTypes, formatMessage: formatMessage })=>{
        const noneOption = $d340f5cdbd034415$var$createNoneOption(formatMessage);
        let issueType = null;
        let requestType = null;
        if (requestOrIssueType !== null) switch(requestOrIssueType.type){
            case 0, $4cff3ad70ea80f75$export$ebb48b08205007c5:
                issueType = requestOrIssueType;
                requestType = noneOption;
                break;
            case 0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44:
                issueType = allIssueTypes.find(({ value: value })=>value === requestOrIssueType.issueTypeId) || null;
                requestType = requestOrIssueType;
                break;
            default:
        }
        return {
            issueType: issueType,
            requestType: requestType
        };
    };
    const $d340f5cdbd034415$export$f0a2ba1b9d3328b = ({ issueType: issueType, allRequestTypes: allRequestTypes })=>allRequestTypes.find(({ issueTypeId: issueTypeId })=>issueTypeId === issueType.value);
});
parcelRegister("br2XI", function(module, exports) {
    $parcel$export(module.exports, "transformValidationErrors", ()=>$884976b576d5c059$export$8726164bd96601cc);
    $parcel$export(module.exports, "getQueryVariables", ()=>$884976b576d5c059$export$8c3d6ce16880e58e);
    $parcel$export(module.exports, "getContextFieldsForSubmit", ()=>$884976b576d5c059$export$2975feebfec7def8);
    $parcel$export(module.exports, "getParentIdForSubmit", ()=>$884976b576d5c059$export$b208d5bc9f5e315f);
    $parcel$export(module.exports, "resetFormFieldsForCreateAnother", ()=>$884976b576d5c059$export$d8f1f19cbcdc5ccf);
    $parcel$export(module.exports, "getUserInputForRetention", ()=>$884976b576d5c059$export$ffde08d8190479bd);
    $parcel$export(module.exports, "transformInlineErrorMessage", ()=>$884976b576d5c059$export$cc6683ccc73b073);
    $parcel$export(module.exports, "getIssueCreateProjectForMount", ()=>$884976b576d5c059$export$ce9d0b4bb614f329);
    $parcel$export(module.exports, "canSetContextForSubmit", ()=>$884976b576d5c059$export$fbc6cb29c318fa3a);
    $parcel$export(module.exports, "shouldShowStatusField", ()=>$884976b576d5c059$export$3a332740e4aa9440);
    $parcel$export(module.exports, "shouldShowLinkedAlertsField", ()=>$884976b576d5c059$export$d89be2967c4b3fcf);
    $parcel$export(module.exports, "isWatchersUsed", ()=>$884976b576d5c059$export$8625e37c02bbfb71);
    $parcel$export(module.exports, "getAnalyticsIssueType", ()=>$884976b576d5c059$export$385bf01e57223a7c);
    $parcel$export(module.exports, "isDisplayConditionCFCausingError", ()=>$884976b576d5c059$export$cbe00e1e05a1451f);
    var $gccSB = parcelRequire("gccSB");
    var $2vSU6;
    var $jcw0u;
    var $5fc53;
    var $gItVn;
    var $1lvym;
    const $884976b576d5c059$export$8726164bd96601cc = (errors)=>{
        let validationErrors;
        if (errors.length) {
            validationErrors = {};
            errors.forEach(({ field: field, error: error })=>{
                validationErrors = {
                    ...validationErrors,
                    [field]: error
                };
            });
        }
        return validationErrors;
    };
    const $884976b576d5c059$export$8c3d6ce16880e58e = (selectedProject, selectedIssueType, defaultValues)=>{
        const projectId = selectedProject?.value || null;
        let issueTypeId = null;
        let requestTypeKey = null;
        if (selectedIssueType) {
            issueTypeId = selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
            requestTypeKey = selectedIssueType.requestTypeKey !== undefined ? selectedIssueType.requestTypeKey : null;
        }
        return {
            project: projectId ? {
                projectId: projectId
            } : null,
            issueType: issueTypeId !== null ? {
                issueTypeId: issueTypeId
            } : null,
            requestType: requestTypeKey !== null ? {
                key: requestTypeKey
            } : null,
            defaultValues: defaultValues || null
        };
    };
    const $884976b576d5c059$export$2975feebfec7def8 = (selectedProject, selectedIssueType, requestTypeId)=>{
        const projectId = selectedProject.value;
        let issueTypeId;
        let requestTypeKey;
        if (selectedIssueType.type === (0, $4cff3ad70ea80f75$export$92ab80c1dc9baf44)) {
            issueTypeId = selectedIssueType.issueTypeId;
            requestTypeKey = selectedIssueType.requestTypeKey;
        } else issueTypeId = selectedIssueType.value;
        const requestTypePayload = requestTypeId !== undefined ? {
            [requestTypeId]: requestTypeKey
        } : {};
        return {
            project: {
                id: projectId
            },
            issuetype: {
                id: issueTypeId
            },
            ...requestTypePayload
        };
    };
    const $884976b576d5c059$export$b208d5bc9f5e315f = (parentId)=>parentId && parentId.parentId ? {
            parent: {
                id: parentId.parentId
            }
        } : {};
    const $884976b576d5c059$export$d8f1f19cbcdc5ccf = (formData, fieldConfig, resetForm)=>{
        const resetFormData = {
            ...formData
        };
        (0, (0, parcelRequire("1lvym")).NON_RETAINED_FIELDS_CREATE_ANOTHER).forEach((field)=>{
            if (!(0, ($parcel$interopDefault($gccSB)))(formData[field.fieldId])) resetFormData[field.fieldId] = field.getClearedDefaultValue(fieldConfig);
        });
        const resetObject = {
            ...resetFormData,
            [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: ''
        };
        resetForm(resetObject);
        return resetObject;
    };
    const $884976b576d5c059$export$77b34f1a71743196 = (fieldConfig, fieldValues)=>{
        const dirtyCheckboxFieldIds = {};
        Object.keys(fieldValues).forEach((fieldId)=>{
            const fieldData = fieldConfig[fieldId];
            const { gqlType: gqlType } = fieldData || {};
            if ((0, (0, parcelRequire("1lvym")).FIELDS_TO_RETAIN_FIELD_VALUE).includes(gqlType) && !(0, ($parcel$interopDefault($gccSB)))(fieldValues[fieldId])) dirtyCheckboxFieldIds[fieldId] = true;
        });
        return dirtyCheckboxFieldIds;
    };
    const $884976b576d5c059$export$ffde08d8190479bd = ({ formState: formState, fieldConfig: fieldConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, retainedFieldsData: retainedFieldsData, initialDefaultValues: initialDefaultValues = {}, selectedClassification: selectedClassification })=>{
        let classificationRetainValue = {};
        if (selectedClassification?.id) classificationRetainValue = {
            dataClassification: {
                dataClassificationId: selectedClassification.id
            }
        };
        if (!formState) return initialDefaultValues;
        if (!retainedFieldsData || !retainedFieldsData.current) return initialDefaultValues;
        const { dirtyFields: dirtyFields, values: values } = formState;
        const dirtyCheckboxFieldIds = $884976b576d5c059$export$77b34f1a71743196(fieldConfig, values);
        dirtyFieldsCurrentSession.current = {
            ...dirtyFieldsCurrentSession.current,
            ...dirtyFields,
            ...dirtyCheckboxFieldIds
        };
        Object.keys(dirtyFieldsCurrentSession.current).forEach((fieldId)=>{
            const fieldData = fieldConfig[fieldId];
            if (fieldData) {
                const retainUserInputTransform = (0, (0, parcelRequire("gItVn")).getGqlFieldMap)()[fieldData.gqlType]?.retainUserInputTransform || null;
                const userInput = values[fieldId];
                if (retainUserInputTransform && userInput) try {
                    const userInputToBeRetained = retainUserInputTransform(userInput, fieldId);
                    if (userInputToBeRetained) {
                        const arrWithoutStaleValues = retainedFieldsData.current.filter((itr)=>{
                            if (itr && itr.fieldId && itr.fieldId === fieldId) return false;
                            return true;
                        });
                        retainedFieldsData.current = [
                            ...arrWithoutStaleValues,
                            userInputToBeRetained
                        ];
                    }
                } catch (error) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'getUserInputForRetention',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
        });
        const retVal = {};
        retainedFieldsData.current.forEach((fieldData)=>{
            const { mutationGroup: mutationGroup, ...rest } = fieldData;
            if (mutationGroup) {
                if (!retVal[mutationGroup]) retVal[mutationGroup] = [];
                retVal[mutationGroup].push(rest);
            } else Object.keys(rest).forEach((key)=>{
                retVal[key] = rest[key];
            });
        });
        return {
            ...classificationRetainValue,
            ...initialDefaultValues,
            ...retVal
        };
    };
    const $884976b576d5c059$export$cc6683ccc73b073 = (sectionMessage)=>{
        if (sectionMessage && sectionMessage.type === 'error') {
            const { title: title, displayList: errors } = sectionMessage;
            return {
                title: title,
                errors: errors
            };
        }
        return null;
    };
    const $884976b576d5c059$export$ce9d0b4bb614f329 = (projectContext)=>{
        if (projectContext?.projectId) return {
            label: projectContext.projectName,
            value: projectContext.projectId.toString(),
            iconUrl: '',
            projectKey: projectContext.projectKey,
            projectType: projectContext.projectType,
            isSimplified: projectContext.simplified
        };
        return null;
    };
    const $884976b576d5c059$export$fbc6cb29c318fa3a = (selectedProject, context)=>context?.projectId === selectedProject.value;
    const $884976b576d5c059$export$3a332740e4aa9440 = (projectType, fieldConfig)=>{
        if (projectType !== (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && projectType !== (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)) return false;
        return !!fieldConfig.status;
    };
    const $884976b576d5c059$export$d89be2967c4b3fcf = (projectType, selectedIssueType, alertsToBeLinked)=>{
        if (!alertsToBeLinked) return false;
        if (!projectType || projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)) return false;
        if (selectedIssueType?.type === (0, $4cff3ad70ea80f75$export$ebb48b08205007c5)) return false;
        return selectedIssueType?.practice === (0, $4cff3ad70ea80f75$export$48c144830383423);
    };
    const $884976b576d5c059$export$8625e37c02bbfb71 = ({ currentUserAccountId: currentUserAccountId, isAutoWatchEnabled: isAutoWatchEnabled = false, watchers: watchers = [] })=>{
        if (isAutoWatchEnabled) {
            if (watchers.length !== 1) return true;
            return watchers.every((watcher)=>watcher.accountId !== currentUserAccountId);
        }
        return watchers.length > 0;
    };
    const $884976b576d5c059$export$385bf01e57223a7c = (selectedIssueType)=>{
        const allowedIssueTypeValues = [
            'bug',
            'story',
            'task',
            'subtask',
            'epic'
        ];
        const issueTypeLabel = selectedIssueType?.label.toLowerCase();
        if (issueTypeLabel) return allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
        return undefined;
    };
    const $884976b576d5c059$export$cbe00e1e05a1451f = (errors, fieldConfig, filteredOutModules)=>{
        const customFieldsWithError = [];
        try {
            for (const error of errors){
                const fieldData = fieldConfig[error.field];
                if (fieldData) {
                    const { isRequired: isRequired, fieldType: fieldType } = fieldData;
                    if (isRequired) filteredOutModules.forEach((customField)=>{
                        if (customField.properties.displayConditions !== undefined && customField.id === fieldType) customFieldsWithError.push(fieldData.fieldName);
                    });
                }
            }
            return customFieldsWithError.length !== 0 ? customFieldsWithError : null;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'isDisplayConditionCFCausingError',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return null;
        }
    };
});
parcelRegister("1lvym", function(module, exports) {
    $parcel$export(module.exports, "FIELDS_TO_RETAIN_FIELD_VALUE", ()=>$10b548a577ae91ad$export$992fccb91ee5793d);
    $parcel$export(module.exports, "NON_RETAINED_FIELDS_CREATE_ANOTHER", ()=>$10b548a577ae91ad$export$d36a2604491a5bc6);
    var $h2h4F;
    var $1K3Xb;
    var $5fc53;
    const $10b548a577ae91ad$export$992fccb91ee5793d = [
        (0, $962656cd6986cb06$export$d10237d945259f96)
    ];
    const $10b548a577ae91ad$export$d36a2604491a5bc6 = [
        {
            fieldId: (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE),
            getClearedDefaultValue: (fieldConfig)=>{
                if (fieldConfig) {
                    const descriptionFieldData = fieldConfig[0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE];
                    return descriptionFieldData.gqlType === (0, $962656cd6986cb06$export$31a6c27df1f927b2) ? {
                        resetRequired: true,
                        ...(0, (0, parcelRequire("1K3Xb")).convertTextToAdf)('')
                    } : descriptionFieldData.defaultValue;
                }
                return undefined;
            }
        },
        {
            fieldId: (0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE),
            getClearedDefaultValue: ()=>({
                    shouldClear: true
                })
        },
        {
            fieldId: (0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE),
            getClearedDefaultValue: (fieldConfig)=>{
                if (fieldConfig) {
                    const { defaultValue: defaultValue } = fieldConfig[0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE];
                    if (Array.isArray(defaultValue)) {
                        const issueLinks = [];
                        defaultValue.forEach((issueLink)=>{
                            if (issueLink !== undefined && issueLink !== null && (typeof issueLink.id === 'string' || issueLink.id === null) && issueLink.relatedBy !== null && typeof issueLink.relatedBy === 'object' && typeof issueLink.relatedBy.linkTypeName === 'string' && typeof issueLink.relatedBy.relationName === 'string' && typeof issueLink.relatedBy.linkTypeId === 'string' && (issueLink.relatedBy.direction === 'INWARD' || issueLink.relatedBy.direction === 'OUTWARD') && typeof issueLink.issue === 'object' && issueLink.issue !== null && typeof issueLink.issue.avatar === 'object' && issueLink.issue.avatar !== null && typeof issueLink.issue.avatar.small === 'string' && typeof issueLink.issue.avatar.medium === 'string' && typeof issueLink.issue.id === 'string' && typeof issueLink.issue.issueId === 'string' && typeof issueLink.issue.key === 'string') {
                                const issueLinkExact = {
                                    id: issueLink.id,
                                    relatedBy: {
                                        linkTypeName: issueLink.relatedBy.linkTypeName,
                                        relationName: issueLink.relatedBy.relationName,
                                        linkTypeId: issueLink.relatedBy.linkTypeId,
                                        direction: issueLink.relatedBy.direction
                                    },
                                    issue: {
                                        avatar: {
                                            medium: issueLink.issue.avatar.medium,
                                            small: issueLink.issue.avatar.small
                                        },
                                        id: issueLink.issue.id,
                                        issueId: issueLink.issue.issueId,
                                        key: issueLink.issue.key
                                    }
                                };
                                issueLinks.push(issueLinkExact);
                            }
                        });
                        return (0, (0, parcelRequire("h2h4F")).transformDefaultIssueLinksValue)(issueLinks);
                    }
                }
                return undefined;
            }
        }
    ];
});
parcelRegister("7qfv0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6285d5bf788f097d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hTEpF;
    var $bTyOW;
    var $iVgQf;
    var $koVbs;
    var $e3PDz;
    const $6285d5bf788f097d$var$MAX_IMAGE_WIDTH_PX = 188;
    const $6285d5bf788f097d$var$MAX_IMAGE_HEIGHT_PX = 250;
    const $6285d5bf788f097d$var$IMAGE_WIDTH_PX = 188;
    const $6285d5bf788f097d$var$renderImage = ()=>(0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default))({
            imageWidth: $6285d5bf788f097d$var$IMAGE_WIDTH_PX,
            maxImageWidth: $6285d5bf788f097d$var$MAX_IMAGE_WIDTH_PX,
            maxImageHeight: $6285d5bf788f097d$var$MAX_IMAGE_HEIGHT_PX
        });
    const $6285d5bf788f097d$var$ErrorState = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6285d5bf788f097d$export$412bc65ea3f44cf1, {
            "data-test-id": "issue-create.ui.modal.error-state.fetch-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hTEpF")).default), {
            renderImage: $6285d5bf788f097d$var$renderImage,
            header: formatMessage((0, (0, parcelRequire("e3PDz")).default).header),
            description: formatMessage((0, (0, parcelRequire("e3PDz")).default).description),
            width: "narrow"
        }));
    });
    var $6285d5bf788f097d$export$2e2bcd8739ae039 = $6285d5bf788f097d$var$ErrorState;
    const $6285d5bf788f097d$export$412bc65ea3f44cf1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("iVgQf", function(module, exports) {
    $parcel$export(module.exports, "getAkEmptyStateRenderImageFn", ()=>$7affac5c7e698fc8$export$ebf64b9217c1b2a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $4Bpvs;
    function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, (0, parcelRequire("4Bpvs")).default)) {
        return ({ maxImageWidth: maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
            const Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
                    ...__cmplp,
                    style: {
                        ...__cmpls,
                        "--_yv3y2x": (0, (0, parcelRequire("lD23V")).default)(maxImageWidth, "px"),
                        "--_nq7wev": (0, (0, parcelRequire("lD23V")).default)(maxImageHeight, "px")
                    },
                    ref: __cmplr,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                        __cmplp.className
                    ])
                });
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
                alt: "",
                role: "presentation",
                width: imageWidth || 'auto',
                height: imageHeight || 'auto'
            }));
        };
    }
});
parcelRegister("4Bpvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$029e22a35a3f42f7$export$2e2bcd8739ae039);
    var $dCLgq;
    var $kbo4z = parcelRequire("kbo4z");
    var $3uP2Y = parcelRequire("3uP2Y");
    const $029e22a35a3f42f7$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3uP2Y)),
        srcDark: ($parcel$interopDefault($kbo4z))
    });
    var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
    const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
        0,
        0,
        235,
        210
    ];
});
parcelRegister("kbo4z", function(module, exports) {
    module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();
});
parcelRegister("3uP2Y", function(module, exports) {
    module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();
});
parcelRegister("e3PDz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a65e16b060ca91c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a65e16b060ca91c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        header: {
            "id": "issue-create.modal.error-state.header",
            "defaultMessage": "Something's gone wrong"
        },
        description: {
            "id": "issue-create.modal.error-state.description",
            "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
        }
    });
});
parcelRegister("lFNHi", function(module, exports) {
    $parcel$export(module.exports, "ExistingGICWarning", ()=>$21854fdf8fa5d9c7$export$e0cf9a7a2f315b80);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $1R1Ge;
    var $7QSqG;
    var $juxqI;
    var $jgVsb;
    var $gofOI;
    var $9fuVs;
    var $6s1PB;
    var $koVbs;
    var $c7ZNt;
    var $5eGnF;
    var $9svjh;
    var $45Cy1;
    var $5rzqz;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $8exBF;
    const $21854fdf8fa5d9c7$export$e0cf9a7a2f315b80 = ()=>{
        const [{ wasModalRetriggered: wasModalRetriggered }, { resetWasModalRetriggered: resetWasModalRetriggered }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const [{ resetFormAction: resetFormAction, selectedProject: selectedProject, isFormDirty: isCreateFormDirty }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectId = selectedProject && selectedProject.value;
        const projectType = selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : '';
        const { publish: publish } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (wasModalRetriggered && !isCreateFormDirty) resetWasModalRetriggered(true);
        }, [
            wasModalRetriggered,
            isCreateFormDirty,
            resetWasModalRetriggered
        ]);
        const onClickDiscardButton = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'discardExistingGicWarning', {
                projectType: projectType
            });
            resetWasModalRetriggered(true);
            resetFormAction && resetFormAction();
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, {});
        }, [
            publish,
            projectType,
            resetWasModalRetriggered,
            resetFormAction
        ]);
        const onClickKeepEditingButton = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keepEditingExistingGicWarning', {
                projectType: projectType
            });
            resetWasModalRetriggered();
            publish((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, {});
        }, [
            projectType,
            publish,
            resetWasModalRetriggered
        ]);
        if (!wasModalRetriggered || !isCreateFormDirty || !selectedProject) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
            sourceName: "existingGicWarning",
            containerType: "project",
            containerId: projectId || '',
            attributes: {
                projectType: projectType
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            onClose: ()=>resetWasModalRetriggered(),
            width: "medium",
            testId: "issue-create.ui.modal.existing-gic-warning.modal-dialog"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8exBF")).default).headingIssueTermRefresh : (0, (0, parcelRequire("8exBF")).default).heading))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8exBF")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("8exBF")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClickDiscardButton,
            appearance: "subtle",
            testId: "issue-create.ui.modal.existing-gic-warning.discard-button"
        }, formatMessage((0, (0, parcelRequire("8exBF")).default).discardButton)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            onClick: onClickKeepEditingButton,
            appearance: "warning",
            testId: "issue-create.ui.modal.existing-gic-warning.keep-editing"
        }, formatMessage((0, (0, parcelRequire("8exBF")).default).keepEditingButton))))));
    };
});
parcelRegister("8exBF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c75da2af9c7bc608$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c75da2af9c7bc608$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        heading: {
            "id": "issue-create.modal.existing-gic-warning.heading",
            "defaultMessage": "Draft issue in progress"
        },
        description: {
            "id": "issue-create.modal.existing-gic-warning.description",
            "defaultMessage": "It looks like you\u2019re already creating an issue. Creating a new issue will discard your draft and any changes you\u2019ve made won\u2019t be saved."
        },
        discardButton: {
            "id": "issue-create.modal.existing-gic-warning.discard-button",
            "defaultMessage": "Discard draft"
        },
        keepEditingButton: {
            "id": "issue-create.modal.existing-gic-warning.keep-editing-button",
            "defaultMessage": "Keep editing"
        },
        headingIssueTermRefresh: {
            "id": "issue-create.modal.existing-gic-warning.heading-issue-term-refresh",
            "defaultMessage": "Draft work item in progress"
        },
        descriptionIssueTermRefresh: {
            "id": "issue-create.modal.existing-gic-warning.description-issue-term-refresh",
            "defaultMessage": "It looks like you\u2019re already creating a work item. Creating a new one will discard your draft and any changes you\u2019ve made won\u2019t be saved."
        }
    });
});
parcelRegister("hXutx", function(module, exports) {
    $parcel$export(module.exports, "JsmRequestTypeFieldsChangeboarding", ()=>$c86210bec9ac1847$export$3c3f6e745ff8955);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $cgL5K;
    var $92Z2l;
    var $6s1PB;
    var $aWse0;
    var $iXVV6;
    var $8zOmE;
    var $isuse;
    var $2NMNM;
    var $hH1l8;
    var $31Qad;
    const $c86210bec9ac1847$var$learnMoreLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
    const $c86210bec9ac1847$export$3c3f6e745ff8955 = ()=>{
        const [{ data: isRequestTypeFieldsLayoutEnabled }] = (0, (0, parcelRequire("hH1l8")).useRequestTypeFieldsLayoutPreference)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onClickLearnMoreLink = ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'jsmRequestTypeFieldsChangeboardingLearnMoreLink clicked');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$238d30785c4bca84),
            sourceName: "jsmRequestTypeFieldsChangeboarding"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("92Z2l")).default), {
            appearance: "discovery",
            actions: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                appearance: "link",
                spacing: "none",
                onClick: onClickLearnMoreLink,
                onAuxClick: onClickLearnMoreLink,
                href: $c86210bec9ac1847$var$learnMoreLink,
                target: "_blank"
            }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("31Qad")).default).sectionMessageLearnMoreWhenToggleOffIssueTermRefresh : (0, (0, parcelRequire("31Qad")).default).sectionMessageLearnMoreWhenToggleOff) : formatMessage((0, (0, parcelRequire("31Qad")).default).sectionMessageLearnMore))
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cgL5K")).default), {
            as: "p"
        }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("31Qad")).default).sectionMessageBodyWhenToggleOffIssueTermRefresh : (0, (0, parcelRequire("31Qad")).default).sectionMessageBodyWhenToggleOff, {
            bold: (message)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, message)
        }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("31Qad")).default).sectionMessageBodyIssueTermRefresh : (0, (0, parcelRequire("31Qad")).default).sectionMessageBody))));
    };
});
parcelRegister("31Qad", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28e2d2fad6134821$export$2e2bcd8739ae039);
    var $7VHMR;
    var $28e2d2fad6134821$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sectionMessageBody: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body",
            "defaultMessage": "Since a request type has been selected for this issue, these fields can\u2019t be edited here."
        },
        sectionMessageBodyWhenToggleOff: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off",
            "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating issues."
        },
        sectionMessageLearnMore: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more",
            "defaultMessage": "Learn more about editing the fields of a request type"
        },
        sectionMessageLearnMoreWhenToggleOff: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off",
            "defaultMessage": "Learn more about using request type fields while creating issues"
        },
        sectionMessageBodyIssueTermRefresh: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-issue-term-refresh",
            "defaultMessage": "Since a request type has been selected for this work item, these fields can\u2019t be edited here."
        },
        sectionMessageBodyWhenToggleOffIssueTermRefresh: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off-issue-term-refresh",
            "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating work items."
        },
        sectionMessageLearnMoreWhenToggleOffIssueTermRefresh: {
            "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off-issue-term-refresh",
            "defaultMessage": "Learn more about using request type fields while creating work items"
        }
    });
});
parcelRegister("eF4iR", function(module, exports) {
    $parcel$export(module.exports, "ModalWrapper", ()=>$29af1391730b0075$export$858bfd02c3f2fba5);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $anKMC;
    var $9fuVs;
    var $7CMCs;
    var $6ikhl;
    var $bPtOr;
    var $gLdtQ;
    var $45Cy1;
    var $iUFy5;
    var $h1cYs;
    var $boiMK;
    var $eHMxp;
    var $573IZ;
    var $1JVJe;
    var $5rzqz;
    var $l8ruj;
    var $8LWdH;
    var $PpuOf;
    var $6gjIc;
    var $bMoTh;
    var $jWbdK;
    var $dDDBO;
    var $l2y6R;
    var $31ArW;
    var $2NKLM;
    var $7qb4M;
    var $6mZXS;
    const $29af1391730b0075$var$ModalBodyNext = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: (0, (0, parcelRequire("gLdtQ")).ISSUE_CREATE_MODAL_BODY_SELECTOR),
            ref: ref,
            ...props
        })));
    const $29af1391730b0075$var$OldModal = ({ children: children, onModalCloseWithConfirm: onModalCloseWithConfirm, shouldDisableActions: shouldDisableActions, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, watchersConfigurations: watchersConfigurations, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "large",
            height: "100vh",
            autoFocus: false,
            onClose: onModalCloseWithConfirm('issueCreateModalEscapeClick'),
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: false,
            testId: "issue-create.ui.modal.modal-wrapper.modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("31ArW")).default), {
            shouldDisableActions: shouldDisableActions,
            watchersConfigurations: watchersConfigurations
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$ModalBodyNext, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8LWdH")).default), {
            onClose: onModalCloseWithConfirm('cancel'),
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            isOperationInProgress: isOperationInProgress,
            canCreateAnotherIssue: canCreateAnotherIssue,
            onCreateAnotherChange: onCreateAnotherChange,
            shouldDisableSubmit: getShouldDisableSubmit(),
            createdIssues: createdIssues,
            displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
            showIssuesCreated: showIssuesCreated,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        })));
    const $29af1391730b0075$var$MinimizableModalContainer = ({ children: children })=>{
        const { initialSummaryValue: initialSummaryValue } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        const { view: view } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const summaryValue = (0, (0, parcelRequire("7qb4M")).useSetSummary)(initialSummaryValue);
        (0, (0, parcelRequire("6mZXS")).useViewChangerDisabler)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1JVJe")).ModalTransition), {
            renderCondition: view === 'modal'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2NKLM")).MinimizableModalModal), {
            "data-testid": "issue-create.ui.modal.modal-wrapper.modal"
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHMxp")).MiniTransition), {
            renderCondition: view === 'mini'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dDDBO")).MinimizableModalMini), {
                ...transitionProps,
                summaryValue: summaryValue
            }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boiMK")).FullscreenTransition), {
            renderCondition: view === 'fullscreen'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWbdK")).MinimizableFullscreen), transitionProps, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("573IZ")).MinimizedTransition), {
            renderCondition: view === 'minimized'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l2y6R")).MinimizableModalMinimized), {
                ...transitionProps,
                summaryValue: summaryValue
            })));
    };
    const $29af1391730b0075$var$OldModalWrapper = (props)=>{
        const [{ disableGICPositioning: disableGICPositioning }, { setDisableGICPositioning: setDisableGICPositioning }] = (0, (0, parcelRequire("PpuOf")).useGICPositioningEnabledController)();
        (0, $5uXOq.useEffect)(()=>{
            if (!disableGICPositioning) setDisableGICPositioning(true);
        }, [
            disableGICPositioning,
            setDisableGICPositioning
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$OldModal, props);
    };
    const $29af1391730b0075$export$858bfd02c3f2fba5 = ({ children: children, ...rest })=>{
        const [{ minimizableModalView: minimizableModalView, displayMinimizableButtons: displayMinimizableButtons }, { setMinimizableModalView: setMinimizableModalView }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const [, { dispatchFormSubmits: dispatchForgeInlineFormSubmits }] = (0, (0, parcelRequire("6ikhl")).useInlineFields)();
        const [{ isFormLoaded: isFormLoaded }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const renderOldModal = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($29af1391730b0075$var$OldModalWrapper, rest, children);
        const onViewChange = (0, $5uXOq.useCallback)((newView)=>{
            setMinimizableModalView(newView);
            dispatchForgeInlineFormSubmits();
        }, [
            setMinimizableModalView,
            dispatchForgeInlineFormSubmits
        ]);
        if (isGICPositioningEnabled()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "issue-create-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CMCs")).JSErrorBoundary), {
            id: isFormLoaded ? 'issue-create-app-loaded' : 'issue-create-app',
            packageName: "jiraIssueCreateModal",
            fallback: renderOldModal,
            sendToPrivacyUnsafeSplunk: true,
            attributes: (error)=>({
                    errorType: (0, (0, parcelRequire("bPtOr")).getErrorType)(error)
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bMoTh")).MinimizableModalWrapperPropsProvider), rest, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h1cYs")).MinimizableModal), {
            view: minimizableModalView,
            onViewChange: onViewChange,
            Container: $29af1391730b0075$var$MinimizableModalContainer,
            onClose: rest.onModalCloseWithConfirm('cancel'),
            displayMinimizableButtons: displayMinimizableButtons
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("anKMC")).ClipboardContextBoundaryContainer), null, children)))));
        return renderOldModal();
    };
});
parcelRegister("anKMC", function(module, exports) {
    $parcel$export(module.exports, "ClipboardContextBoundaryContainer", ()=>$870f392021d774f7$export$fd0a7836bfa6a893);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $46dC9;
    const $870f392021d774f7$var$invisibleDivStyles = null;
    const $870f392021d774f7$var$ClipboardContextBoundaryProvider = ({ children: children })=>{
        const { setClipBoardContext: setClipBoardContext } = (0, (0, parcelRequire("46dC9")).useClipboardContextActions)();
        const setRef = (0, $5uXOq.useCallback)((node)=>{
            setClipBoardContext(node);
        }, [
            setClipBoardContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: setRef,
            "data-testid": "clipboard.controllers.boundary.clipboard-boundary",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _4t3i1kw7 _1bsb1kw7"
            ])
        }, children);
    };
    const $870f392021d774f7$export$fd0a7836bfa6a893 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("46dC9")).ClipboardStoreContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($870f392021d774f7$var$ClipboardContextBoundaryProvider, null, children));
    const $870f392021d774f7$var$ClipboardContainerSetEffector = ({ container: container })=>{
        const { setClipBoardContext: setClipBoardContext } = (0, (0, parcelRequire("46dC9")).useClipboardContextActions)();
        (0, $5uXOq.useEffect)(()=>setClipBoardContext(container), [
            setClipBoardContext,
            container
        ]);
        return null;
    };
    const $870f392021d774f7$export$99c5c2d165547316 = ({ children: children, container: container, intent: intent })=>{
        const currentContainer = (0, (0, parcelRequire("46dC9")).useClipboardContextBoundary)();
        if (!container || currentContainer && intent === 'support') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("46dC9")).ClipboardStoreContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($870f392021d774f7$var$ClipboardContainerSetEffector, {
            container: container
        }), children);
    };
});
parcelRegister("h1cYs", function(module, exports) {
    $parcel$export(module.exports, "MinimizableModal", ()=>$4c8c59050f25d92e$export$fe110805c6d6ede4);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MHPe;
    var $iUFy5;
    var $isEfy;
    var $4Ads7;
    const $4c8c59050f25d92e$export$fe110805c6d6ede4 = ({ children: children, Container: Container = (0, (0, parcelRequire("isEfy")).ModalContainer), initialView: initialView, onClose: onClose, view: view, onViewChange: onViewChange, displayMinimizableButtons: displayMinimizableButtons })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iUFy5")).MinimizableModalProvider), {
            initialView: initialView,
            onClose: onClose,
            view: view,
            onViewChange: onViewChange,
            displayMinimizableButtons: displayMinimizableButtons
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Ads7")).ReParenter), {
            Parent: Container
        }, children)));
});
parcelRegister("isEfy", function(module, exports) {
    $parcel$export(module.exports, "ModalContainer", ()=>$de64b73b456d385d$export$c9554889b3e706cd);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFy5;
    var $boiMK;
    var $fVPqx;
    var $eHMxp;
    var $dVZve;
    var $573IZ;
    var $4TqWb;
    var $bSvOl;
    var $1JVJe;
    var $6BEt4;
    const $de64b73b456d385d$var$DefaultHeader = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSvOl")).ModalHeader), props);
    const $de64b73b456d385d$var$DefaultMiniHeader = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSvOl")).MiniHeader), props);
    const $de64b73b456d385d$export$c9554889b3e706cd = ({ children: children, components: components })=>{
        const { view: view } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1JVJe")).ModalTransition), {
            renderCondition: view === 'modal'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6BEt4")).Modal), {
            components: components || {
                Header: $de64b73b456d385d$var$DefaultHeader
            }
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHMxp")).MiniTransition), {
            renderCondition: view === 'mini'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVZve")).Mini), {
                ...transitionProps,
                components: components || {
                    Header: $de64b73b456d385d$var$DefaultMiniHeader
                }
            }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boiMK")).FullscreenTransition), {
            renderCondition: view === 'fullscreen'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVPqx")).Fullscreen), {
                ...transitionProps,
                components: components || {
                    Header: $de64b73b456d385d$var$DefaultMiniHeader
                }
            }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("573IZ")).MinimizedTransition), {
            renderCondition: view === 'minimized'
        }, ({ transitionProps: transitionProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4TqWb")).Minimized), transitionProps)));
    };
});
parcelRegister("boiMK", function(module, exports) {
    $parcel$export(module.exports, "FullscreenTransition", ()=>$0927d7c7ed49ea45$export$d6c32f25d5187e12);
    var $5uXOq = parcelRequire("5uXOq");
    var $35XSW;
    var $4uxPN;
    var $dWt6p;
    var $kUthR;
    const $0927d7c7ed49ea45$export$d6c32f25d5187e12 = ({ children: children, renderCondition: renderCondition })=>{
        const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, (0, parcelRequire("kUthR")).useTransitionView)('fullscreen', renderCondition);
        if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)()) {
            if (renderCondition) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
                transitionProps: {}
            }));
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), null, shouldRenderView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uxPN")).default), {
            entranceDirection: "bottom",
            exitDirection: "bottom",
            duration: (0, $6d7c07b2b614afad$export$3749e1104328fde4),
            onFinish: onFinishAnimation
        }, (fadeInProps)=>children({
                transitionProps: {
                    ...fadeInProps
                }
            })));
    };
});
const $6d7c07b2b614afad$export$3749e1104328fde4 = 250;
parcelRegister("kUthR", function(module, exports) {
    $parcel$export(module.exports, "useTransitionView", ()=>$9176435670b8d931$export$4ebb8b85ce67f755);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFy5;
    var $kNC83;
    const $9176435670b8d931$export$4ebb8b85ce67f755 = (view, renderCondition)=>{
        const { setTransitionState: setTransitionState, isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const shouldRenderView = (0, $5uXOq.useMemo)(()=>{
            if (view === 'modal') return renderCondition && isTransitionInState([
                'mini',
                'minimized'
            ], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
            if (view === 'mini') return renderCondition && isTransitionInState([
                'modal',
                'minimized'
            ], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
            if (view === 'minimized') return renderCondition && isTransitionInState([
                'mini',
                'modal'
            ], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
            if (view === 'fullscreen') return renderCondition && isTransitionInState([], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
            return false;
        }, [
            renderCondition,
            isTransitionInState,
            view
        ]);
        const isAnimationComplete = (0, $5uXOq.useRef)(false);
        const isInitialised = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isInitialised.current) isAnimationComplete.current = false;
        }, [
            shouldRenderView
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldRenderView && !isAnimationComplete.current) {
                isInitialised.current = true;
                setTransitionState(view, (0, (0, parcelRequire("kNC83")).TransitionState).TRANSITIONING);
            } else if (!shouldRenderView && !isAnimationComplete.current && isInitialised.current) setTransitionState(view, (0, (0, parcelRequire("kNC83")).TransitionState).TRANSITIONING);
        }, [
            shouldRenderView,
            setTransitionState,
            view
        ]);
        const onFinishAnimation = (0, $5uXOq.useCallback)((state)=>{
            isAnimationComplete.current = true;
            if (state === 'entering') setTransitionState(view, (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
            if (state === 'exiting') setTransitionState(view, (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        }, [
            setTransitionState,
            view
        ]);
        return {
            onFinishAnimation: onFinishAnimation,
            shouldRenderView: shouldRenderView
        };
    };
});
parcelRegister("fVPqx", function(module, exports) {
    $parcel$export(module.exports, "FullscreenBody", ()=>$9109127f603187a0$export$cf81465aa48f28a8);
    $parcel$export(module.exports, "Fullscreen", ()=>$9109127f603187a0$export$159cd03be7087f39);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $isuse;
    var $iUFy5;
    var $kNC83;
    var $8TEtS;
    const $9109127f603187a0$export$cf81465aa48f28a8 = ({ children: children, containerStyle: containerStyle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TEtS")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$var$FullscreenBodyWrapper, {
            style: containerStyle
        }, children));
    const $9109127f603187a0$export$159cd03be7087f39 = (0, $5uXOq.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
        const { Header: Header = (0, $5uXOq.Fragment), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
        const { isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const isViewEntered = isTransitionInState([
            'fullscreen'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$export$a07082e2094b8119, {
            ref: ref,
            transitionClass: className,
            "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.fullscreen'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), components ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null), (0, ($parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$export$cf81465aa48f28a8, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children));
    });
    const $9109127f603187a0$export$a07082e2094b8119 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($9109127f603187a0$var$FullscreenWrapperExperimentStyles, {
            className: props.transitionClass,
            ...props
        });
    const $9109127f603187a0$var$FullscreenBodyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v47k",
                __cmplp.className
            ])
        });
    });
    const $9109127f603187a0$var$FullscreenWrapperExperimentStyles = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _kqsw1n9t _154iidpf _1ltvidpf _11q71bhr _1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8TEtS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2a414aafbb3e82fd$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $jhVLw;
    var $8AVUY;
    var $4DoYe;
    var $iOmTz;
    var $2WOqJ;
    var $dbCdn;
    const $2a414aafbb3e82fd$var$ScrollContainer = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
        const [hasSiblings, setSiblings] = (0, (0, parcelRequire("iOmTz")).default)({
            previous: false,
            next: false
        });
        const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
        const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
        const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
        const scrollableRef = (0, $5uXOq.useRef)(null);
        const setLazySiblings = (0, (0, parcelRequire("4DoYe")).default)(setSiblings);
        const setLazyContentFocus = (0, (0, parcelRequire("4DoYe")).default)((0, (0, parcelRequire("dbCdn")).rafSchedule)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        }));
        const setLazyKeylines = (0, (0, parcelRequire("4DoYe")).default)((0, (0, parcelRequire("dbCdn")).rafSchedule)(()=>{
            const target = scrollableRef.current;
            if (target) {
                const scrollableDistance = target.scrollHeight - target.clientHeight;
                if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, (0, parcelRequire("2WOqJ")).keylineHeight));
                if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, (0, parcelRequire("2WOqJ")).keylineHeight));
            }
        }));
        (0, $5uXOq.useEffect)(()=>{
            const target = scrollableRef.current;
            window.addEventListener('resize', setLazyKeylines, false);
            target?.addEventListener('scroll', setLazyKeylines, false);
            setLazyContentFocus();
            setLazyKeylines();
            setLazySiblings({
                previous: Boolean(target?.previousElementSibling),
                next: Boolean(target?.nextElementSibling)
            });
            return ()=>{
                window.removeEventListener('resize', setLazyKeylines, false);
                target?.removeEventListener('scroll', setLazyKeylines, false);
            };
        }, [
            setLazyContentFocus,
            setLazyKeylines,
            setLazySiblings
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2a414aafbb3e82fd$var$ScrollContainerWrapper, {
            tabIndex: showContentFocus ? 0 : undefined,
            "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
            ref: (0, (0, parcelRequire("8AVUY")).default)([
                ref,
                scrollableRef
            ]),
            showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
            showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
        }, children));
    });
    $2a414aafbb3e82fd$var$ScrollContainer.displayName = 'ScrollContainer';
    var $2a414aafbb3e82fd$export$2e2bcd8739ae039 = $2a414aafbb3e82fd$var$ScrollContainer;
    const $2a414aafbb3e82fd$var$ScrollContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1dv6fab": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("2WOqJ")).keylineColor))
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1kw7 _2lx21kw7 _1reo15vq _18m91wug _1d2sn7od _1utt1wug",
                __cmplp.showTopKeyline ? "_x3do9gv1" : "_x3doglyw",
                __cmplp.showBottomKeyline ? "_n7zl9gv1" : "_n7zlglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8AVUY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69e4e6541c9abeb4$export$2e2bcd8739ae039);
    function $69e4e6541c9abeb4$export$2e2bcd8739ae039(refs) {
        return (value)=>{
            refs.forEach((ref)=>{
                if (typeof ref === 'function') ref(value);
                else if (ref !== null) ref.current = value;
            });
        };
    }
});
parcelRegister("4DoYe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab16856141d7038e$export$2e2bcd8739ae039);
    var $beBSN;
    function $ab16856141d7038e$export$2e2bcd8739ae039(callback) {
        const ref = (0, (0, parcelRequire("beBSN")).default)(()=>callback);
        return ref.current;
    }
});
parcelRegister("beBSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cab05653bdb7a660$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $cab05653bdb7a660$var$uniqueReferencedValue = {};
    function $cab05653bdb7a660$export$2e2bcd8739ae039(initializer) {
        const ref = (0, $5uXOq.useRef)($cab05653bdb7a660$var$uniqueReferencedValue);
        if (ref.current === $cab05653bdb7a660$var$uniqueReferencedValue) ref.current = initializer();
        return ref;
    }
});
parcelRegister("iOmTz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6530274a8996f773$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $6530274a8996f773$export$2e2bcd8739ae039(initialState) {
        const [value, setValue] = (0, $5uXOq.useState)(initialState);
        const valueRef = (0, $5uXOq.useRef)(value);
        valueRef.current = value;
        return [
            valueRef,
            setValue
        ];
    }
});
parcelRegister("2WOqJ", function(module, exports) {
    $parcel$export(module.exports, "keylineHeight", ()=>$d8212265224e9df6$export$4c317248f944c2a9);
    $parcel$export(module.exports, "keylineColor", ()=>$d8212265224e9df6$export$d901150a4cc83165);
    const $d8212265224e9df6$export$4c317248f944c2a9 = 2;
    const $d8212265224e9df6$export$d901150a4cc83165 = `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
});
parcelRegister("dbCdn", function(module, exports) {
    $parcel$export(module.exports, "rafSchedule", ()=>$15f8df8d72ae6633$export$3c6851d470650c35);
    const $15f8df8d72ae6633$export$3c6851d470650c35 = (fn)=>{
        let frameId = null;
        const wrapperFn = ()=>{
            if (frameId) return;
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                fn();
            });
        };
        wrapperFn.cancel = ()=>{
            if (!frameId) return;
            cancelAnimationFrame(frameId);
            frameId = null;
        };
        return wrapperFn;
    };
});
parcelRegister("eHMxp", function(module, exports) {
    $parcel$export(module.exports, "MiniTransition", ()=>$f884f60e67b8d25c$export$1f36cb33f56bd06e);
    var $5uXOq = parcelRequire("5uXOq");
    var $35XSW;
    var $4uxPN;
    var $dWt6p;
    var $kUthR;
    const $f884f60e67b8d25c$export$1f36cb33f56bd06e = ({ children: children, renderCondition: renderCondition })=>{
        const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, (0, parcelRequire("kUthR")).useTransitionView)('mini', renderCondition);
        if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)()) {
            if (renderCondition) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
                transitionProps: {}
            }));
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), null, shouldRenderView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uxPN")).default), {
            entranceDirection: "bottom",
            exitDirection: "bottom",
            duration: (0, $6d7c07b2b614afad$export$3749e1104328fde4),
            onFinish: onFinishAnimation
        }, (fadeInProps)=>children({
                transitionProps: {
                    ...fadeInProps
                }
            })));
    };
});
parcelRegister("dVZve", function(module, exports) {
    $parcel$export(module.exports, "MiniBody", ()=>$3240aef3134a48d2$export$b7d0c8df4a39a4c7);
    $parcel$export(module.exports, "Mini", ()=>$3240aef3134a48d2$export$87d5d88f89bf43b);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $9fuVs;
    var $ACELo;
    var $8zOmE;
    var $isuse;
    var $iUFy5;
    var $kNC83;
    var $lfEUW;
    const $3240aef3134a48d2$export$b7d0c8df4a39a4c7 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfEUW")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$var$MiniBodyWrapper, null, children));
    const $3240aef3134a48d2$export$87d5d88f89bf43b = (0, $5uXOq.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
        const { Header: Header = (0, $5uXOq.Fragment), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
        const { isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const isViewEntered = isTransitionInState([
            'mini'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ACELo")).JiraBottomRightCornerOutlet), {
            orderFromRight: 3,
            id: "issue-create-mini-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$var$MiniWrapper, {
            ref: ref,
            className: className,
            "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.mini'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), components ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null), (0, ($parcel$interopDefault($5uXOq))).createElement($3240aef3134a48d2$export$b7d0c8df4a39a4c7, null, children), (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children))));
    });
    const $3240aef3134a48d2$var$MiniWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb12hx _4t3i1diq _11q71bhr _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _16qszotn _2rkoftgi",
                __cmplp.className
            ])
        });
    });
    const $3240aef3134a48d2$var$MiniBodyWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41azu",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ACELo", function(module, exports) {
    $parcel$export(module.exports, "JiraBottomRightCornerOutlet", ()=>$8d24666022201b4c$export$ee54e6ed235df65e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $heNNl;
    var $hvrWv;
    const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
        const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
        const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (container) {
                const indexToRender = insertBottomRightCornerPortal({
                    orderFromRight: orderFromRight,
                    id: id
                });
                container.insertBefore(portalWrapper.current, container.children[indexToRender]);
            }
            const portalCurrent = portalWrapper.current;
            return ()=>{
                container?.removeChild(portalCurrent);
                removeBottomRightCornerPortal(id);
            };
        }, [
            container,
            id,
            orderFromRight,
            insertBottomRightCornerPortal,
            removeBottomRightCornerPortal
        ]);
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
    };
    const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-outlet",
            packageName: "jira-bottom-right-corner-controller",
            extraEventData: {
                portalId: props.id
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
    const $8d24666022201b4c$var$StyledOutlet = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1vgl1wug _1ko9pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lfEUW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0b97525d65936cd1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $jhVLw;
    var $4R6GH;
    var $8AVUY;
    var $4DoYe;
    var $iOmTz;
    var $6ytKy;
    var $6UCIg;
    const $0b97525d65936cd1$var$ScrollContainer = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
        const [hasSiblings, setSiblings] = (0, (0, parcelRequire("iOmTz")).default)({
            previous: false,
            next: false
        });
        const [showContentFocus, setContentFocus] = (0, $5uXOq.useState)(false);
        const [showTopKeyline, setTopKeyline] = (0, $5uXOq.useState)(false);
        const [showBottomKeyline, setBottomKeyline] = (0, $5uXOq.useState)(false);
        const scrollableRef = (0, $5uXOq.useRef)(null);
        const setLazySiblings = (0, (0, parcelRequire("4DoYe")).default)(setSiblings);
        const setLazyContentFocus = (0, (0, parcelRequire("4DoYe")).default)((0, (0, parcelRequire("6UCIg")).rafSchedule)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        }));
        const setLazyKeylines = (0, (0, parcelRequire("4DoYe")).default)((0, (0, parcelRequire("6UCIg")).rafSchedule)(()=>{
            const target = scrollableRef.current;
            if (target) {
                const scrollableDistance = target.scrollHeight - target.clientHeight;
                if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, (0, parcelRequire("6ytKy")).keylineHeight));
                if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, (0, parcelRequire("6ytKy")).keylineHeight));
            }
        }));
        (0, $5uXOq.useEffect)(()=>{
            const target = scrollableRef.current;
            window.addEventListener('resize', setLazyKeylines, false);
            target?.addEventListener('scroll', setLazyKeylines, false);
            setLazyContentFocus();
            setLazyKeylines();
            setLazySiblings({
                previous: Boolean(target?.previousElementSibling),
                next: Boolean(target?.nextElementSibling)
            });
            return ()=>{
                window.removeEventListener('resize', setLazyKeylines, false);
                target?.removeEventListener('scroll', setLazyKeylines, false);
            };
        }, [
            setLazyContentFocus,
            setLazyKeylines,
            setLazySiblings
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0b97525d65936cd1$var$ScrollContainerWrapper, {
            tabIndex: showContentFocus ? 0 : undefined,
            "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
            innerRef: (0, (0, parcelRequire("8AVUY")).default)([
                ref,
                scrollableRef
            ]),
            showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
            showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
        }, children));
    });
    $0b97525d65936cd1$var$ScrollContainer.displayName = 'ScrollContainer';
    var $0b97525d65936cd1$export$2e2bcd8739ae039 = $0b97525d65936cd1$var$ScrollContainer;
    const $0b97525d65936cd1$var$ScrollContainerWrapper = (0, $47bDC.default).div.attrs({
        style: ({ showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline })=>({
                borderTop: `${showTopKeyline ? `${0, (0, parcelRequire("6ytKy")).keylineHeight}px solid ${0, (0, parcelRequire("6ytKy")).keylineColor}` : 'none'}`,
                borderBottom: `${showBottomKeyline ? `${0, (0, parcelRequire("6ytKy")).keylineHeight}px solid ${0, (0, parcelRequire("6ytKy")).keylineColor}` : 'none'}`
            })
    }).withConfig({
        componentId: "sc-12dk2la-0"
    })`display:inherit;margin:0;flex:inherit;flex-direction:inherit;${()=>(0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') && 'flex-grow: 1;'} overflow-x:hidden;overflow-y:auto;@media (min-width:480px){height:unset;overflow-y:auto;}`;
});
parcelRegister("6ytKy", function(module, exports) {
    $parcel$export(module.exports, "keylineHeight", ()=>$7b14f915cb039103$export$4c317248f944c2a9);
    $parcel$export(module.exports, "keylineColor", ()=>$7b14f915cb039103$export$d901150a4cc83165);
    const $7b14f915cb039103$export$4c317248f944c2a9 = 2;
    const $7b14f915cb039103$export$d901150a4cc83165 = `var(--ds-border, ${(0, $829f609a65d26a98$export$3e51e8f1440314ba)})`;
});
parcelRegister("6UCIg", function(module, exports) {
    $parcel$export(module.exports, "rafSchedule", ()=>$e7fa10d9d0d08428$export$3c6851d470650c35);
    const $e7fa10d9d0d08428$export$3c6851d470650c35 = (fn)=>{
        let frameId = null;
        const wrapperFn = ()=>{
            if (frameId) return;
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                fn();
            });
        };
        wrapperFn.cancel = ()=>{
            if (!frameId) return;
            cancelAnimationFrame(frameId);
            frameId = null;
        };
        return wrapperFn;
    };
});
parcelRegister("573IZ", function(module, exports) {
    $parcel$export(module.exports, "MinimizedTransition", ()=>$8e63bbc9eb829a67$export$a483cc235b11f289);
    var $5uXOq = parcelRequire("5uXOq");
    var $35XSW;
    var $4uxPN;
    var $dWt6p;
    var $kUthR;
    const $8e63bbc9eb829a67$export$a483cc235b11f289 = ({ children: children, renderCondition: renderCondition })=>{
        const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, (0, parcelRequire("kUthR")).useTransitionView)('minimized', renderCondition);
        if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)()) {
            if (renderCondition) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children({
                transitionProps: {}
            }));
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("35XSW")).default), null, shouldRenderView && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uxPN")).default), {
            entranceDirection: "bottom",
            exitDirection: "bottom",
            duration: (0, $6d7c07b2b614afad$export$3749e1104328fde4),
            onFinish: onFinishAnimation
        }, (fadeInProps)=>children({
                transitionProps: {
                    ...fadeInProps
                }
            })));
    };
});
parcelRegister("4TqWb", function(module, exports) {
    $parcel$export(module.exports, "Minimized", ()=>$1500855dbb649f82$export$b41d27d203c8df67);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jhVLw;
    var $koVbs;
    var $bGrWH;
    var $ACELo;
    var $8zOmE;
    var $isuse;
    var $2NMNM;
    var $2hqdj;
    var $iUFy5;
    var $kNC83;
    var $g61N0;
    const $1500855dbb649f82$export$b41d27d203c8df67 = ({ children: children, isItalic: isItalic, className: className })=>{
        const { unminimizeModal: unminimizeModal, previousView: previousView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { minimizedButtonRef: minimizedButtonRef, onKeyDown: onKeyDown, wrapperRef: wrapperRef } = (0, (0, parcelRequire("2hqdj")).useEnterFocusState)();
        const isViewEntered = isTransitionInState([
            'minimized'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
        const unminimize = ()=>{
            if (!isViewEntered) return;
            setShouldFocusChanger(true);
            unminimizeModal('modal');
            const analyticsEvent = createAnalyticsEvent({
                action: 'container clicked',
                actionSubject: 'minimized'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                source: 'globalIssueCreateModal',
                previousGICViewState: previousView
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ACELo")).JiraBottomRightCornerOutlet), {
            orderFromRight: 3,
            id: "issue-create-minimised-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedOuterWrapper, {
            id: (0, (0, parcelRequire("bGrWH")).MINIMISED_DROPZONE_CONTAINER_ID),
            tabIndex: -1,
            ref: wrapperRef,
            "data-testid": isViewEntered ? 'minimizable-modal.ui.modal-container.minimized-outer-wrapper' : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jhVLw")).default), {
            isInset: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedWrapper, {
            ref: minimizedButtonRef,
            "data-testid": isViewEntered ? 'minimizable-modal.ui.modal-container.minimized' : undefined,
            onKeyDown: onKeyDown,
            onClick: unminimize,
            isItalic: isItalic,
            className: className,
            "aria-label": formatMessage((0, (0, parcelRequire("g61N0")).default).ariaLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1500855dbb649f82$var$MinimizedText, null, children)))));
    };
    const $1500855dbb649f82$var$MinimizedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19itidpf _vchhusvi _11q7hp5a _4t3ickbl _1bsb1mjv _2rkoftgi _1e0c1txw _4cvr1h6o _1yt4119w _80omtlke _v5649dqc _16qs6ae0 _1spjglyw _ymio1r31 _ypr0glyw _zcxs1o36 _19lcxwku _1dit1r31 _ksodglyw _4hz81o36 _j6xtxwku _1q5t1r31 _1ohyglyw _1r9x1o36",
                __cmplp.className
            ])
        });
    });
    const $1500855dbb649f82$var$MinimizedText = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz2l1e _11c81bk4",
                __cmplp.className
            ])
        });
    });
    const $1500855dbb649f82$var$MinimizedOuterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_nt751r31 _49pcglyw _1hvw1o36",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2hqdj", function(module, exports) {
    $parcel$export(module.exports, "useEnterFocusState", ()=>$7836e0c3ac104eed$export$cda941d4347e19b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFy5;
    var $kNC83;
    const $7836e0c3ac104eed$export$cda941d4347e19b6 = ()=>{
        const { view: view, setTransitionByKeyboardFrom: setTransitionByKeyboardFrom, transitionByKeyboardFrom: transitionByKeyboardFrom, isTransitionInState: isTransitionInState, shouldFocusChanger: shouldFocusChanger, setShouldFocusChanger: setShouldFocusChanger } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const minimizedButtonRef = (0, $5uXOq.useRef)(null);
        const modalButtonRef = (0, $5uXOq.useRef)(null);
        const miniButtonRef = (0, $5uXOq.useRef)(null);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const [init, setInit] = (0, $5uXOq.useState)(false);
        const isViewEntered = isTransitionInState([
            view
        ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
        const onKeyDown = (0, $5uXOq.useCallback)((ev)=>{
            if (!isViewEntered) return;
            setTransitionByKeyboardFrom([
                13,
                32
            ].includes(ev.keyCode) ? view : null);
        }, [
            setTransitionByKeyboardFrom,
            isViewEntered,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!init && isViewEntered && shouldFocusChanger) {
                setInit(true);
                setShouldFocusChanger(false);
                const buttonRef = {
                    modal: modalButtonRef.current,
                    mini: miniButtonRef.current,
                    minimized: minimizedButtonRef.current,
                    fullscreen: null
                };
                requestAnimationFrame(()=>{
                    const buttonToFocus = transitionByKeyboardFrom !== null && view === 'minimized' ? 'minimized' : transitionByKeyboardFrom;
                    if (buttonToFocus && buttonRef[buttonToFocus]) {
                        buttonRef[buttonToFocus].focus();
                        setTransitionByKeyboardFrom(null);
                    } else if (wrapperRef.current) wrapperRef.current.focus();
                });
            }
        }, [
            transitionByKeyboardFrom,
            setTransitionByKeyboardFrom,
            init,
            view,
            isViewEntered,
            shouldFocusChanger,
            setShouldFocusChanger
        ]);
        return {
            onKeyDown: onKeyDown,
            minimizedButtonRef: minimizedButtonRef,
            modalButtonRef: modalButtonRef,
            miniButtonRef: miniButtonRef,
            wrapperRef: wrapperRef
        };
    };
});
parcelRegister("g61N0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c26e4d368b5bfad7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c26e4d368b5bfad7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        ariaLabel: {
            "id": "minimizable-modal.modal-container.minimized.messaged.aria-label",
            "defaultMessage": "Minimized modal"
        }
    });
});
parcelRegister("bSvOl", function(module, exports) {
    $parcel$export(module.exports, "ModalHeader", ()=>$58cf9d8ffbd68381$export$f50a68e3694789ee);
    $parcel$export(module.exports, "MiniHeader", ()=>$58cf9d8ffbd68381$export$1d38987b2afcba7e);
    $parcel$export(module.exports, "ModalTitle", ()=>$58cf9d8ffbd68381$export$b26fae16ba5468aa);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $lLLkM;
    var $6LXPU;
    var $4rRW5;
    var $jgVsb;
    var $gofOI;
    var $3bDjY;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $2NMNM;
    var $dCm1o;
    var $2hqdj;
    var $iUFy5;
    var $kNC83;
    var $3b05o;
    var $k80q0;
    var $iezXC;
    const $58cf9d8ffbd68381$export$b89ab188a65746a6 = ({ isMini: isMini = false, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>{
        const { view: view, setView: setView, onClose: onClose, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger, displayMinimizableButtons: displayMinimizableButtons } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { minimizedButtonRef: minimizedButtonRef, modalButtonRef: modalButtonRef, miniButtonRef: miniButtonRef, wrapperRef: wrapperRef, onKeyDown: onKeyDown } = (0, (0, parcelRequire("2hqdj")).useEnterFocusState)();
        const onViewChange = (0, $5uXOq.useCallback)((newView)=>()=>{
                if (!isTransitionInState([
                    view
                ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED)) return;
                setShouldFocusChanger(true);
                setView(newView);
                const analyticsEvent = createAnalyticsEvent({
                    action: 'button clicked',
                    actionSubject: newView
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                    source: 'globalIssueCreateModal',
                    previousGICViewState: view
                });
            }, [
            setView,
            isTransitionInState
        ]);
        const onUpdateView = (0, $5uXOq.useCallback)((newView)=>{
            if (!isTransitionInState([
                view
            ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED)) return;
            setShouldFocusChanger(true);
            setView(newView);
            const analyticsEvent = createAnalyticsEvent({
                action: 'button clicked',
                actionSubject: newView
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, {
                source: 'globalIssueCreateModal',
                previousGICViewState: view
            });
        }, [
            isTransitionInState,
            view,
            setShouldFocusChanger,
            setView,
            createAnalyticsEvent
        ]);
        const onViewChangeToMinimized = (0, $5uXOq.useCallback)(()=>onUpdateView('minimized'), [
            onUpdateView
        ]);
        const onViewChangeToMini = (0, $5uXOq.useCallback)(()=>onUpdateView('mini'), [
            onUpdateView
        ]);
        const onViewChangeToModal = (0, $5uXOq.useCallback)(()=>onUpdateView('modal'), [
            onUpdateView
        ]);
        const { shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage: customDisabledViewChangerButtonsMessage } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        (0, $5uXOq.useEffect)(()=>{
            if (shouldDisableViewChangerButtons) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({
                action: 'disabled',
                actionSubject: 'view changer buttons'
            }));
        }, [
            createAnalyticsEvent,
            customDisabledViewChangerButtonsMessage,
            shouldDisableViewChangerButtons
        ]);
        (0, (0, parcelRequire("3b05o")).useNestedModalDetector)();
        const Wrapper = ViewChangerContainer || (0, $5uXOq.Fragment);
        const ButtonWrapper = isMini ? $58cf9d8ffbd68381$var$MiniButtonWrapper : $58cf9d8ffbd68381$var$ModalButtonWrapper;
        const expandMessage = (0, (0, parcelRequire("iezXC")).default).fullScreen;
        const dockMessage = (0, (0, parcelRequire("iezXC")).default).fullScreenExit;
        const dockDisabledMessage = (0, (0, parcelRequire("iezXC")).default).fullScreenExitDisabled;
        let closeBtn;
        if (dismissModalEntryPointWrapper) {
            const DismissModalEntryPointWrapper = dismissModalEntryPointWrapper;
            closeBtn = (0, ($parcel$interopDefault($5uXOq))).createElement(DismissModalEntryPointWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
                position: "top",
                content: formatMessage((0, (0, parcelRequire("iezXC")).default).close)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButton, {
                testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
                onClick: onClose,
                spacing: "none",
                isMini: isMini
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
                label: formatMessage((0, (0, parcelRequire("iezXC")).default).close)
            })))));
        } else closeBtn = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("iezXC")).default).close)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButton, {
            testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
            onClick: onClose,
            spacing: "none",
            isMini: isMini
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lLLkM"))))), {
            label: formatMessage((0, (0, parcelRequire("iezXC")).default).close)
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ViewChangerWrapper, {
            tabIndex: -1,
            ref: wrapperRef,
            isMini: isMini,
            "data-testid": "minimizable-modal.ui.modal-container.modal-header.view-changer-wrapper"
        }, !displayMinimizableButtons ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            "data-testid": "minimizable-modal.ui.modal-container.modal-header.tool-tip",
            position: "top",
            content: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage((0, (0, parcelRequire("iezXC")).default).minimizeDisabled) : formatMessage((0, (0, parcelRequire("iezXC")).default).minimize)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButton, {
            testId: "minimizable-modal.ui.modal-container.modal-header.minimized-button",
            onClick: (0, (0, parcelRequire("4R6GH")).fg)('fix_failed_to_remove_node_error_for_gic') ? onViewChangeToMinimized : onViewChange('minimized'),
            onKeyDown: onKeyDown,
            spacing: "none",
            ref: minimizedButtonRef,
            isDisabled: shouldDisableViewChangerButtons,
            isMini: isMini
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k80q0")).MinimizeIcon), {
            label: formatMessage((0, (0, parcelRequire("iezXC")).default).minimize)
        })))), !isMini && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            "data-testid": "minimizable-modal.ui.modal-container.modal-header.tool-tip",
            position: "top",
            content: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage(dockDisabledMessage) : formatMessage(dockMessage)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButton, {
            id: "minimizable-modal.ui.modal-container.modal-header.mini-button",
            testId: "minimizable-modal.ui.modal-container.modal-header.mini-button",
            onClick: (0, (0, parcelRequire("4R6GH")).fg)('fix_failed_to_remove_node_error_for_gic') ? onViewChangeToMini : onViewChange('mini'),
            onKeyDown: onKeyDown,
            spacing: "none",
            ref: miniButtonRef,
            isDisabled: shouldDisableViewChangerButtons
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4rRW5"))))), {
            label: formatMessage(dockMessage)
        })))), isMini && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bDjY")).default), {
            position: "top",
            content: formatMessage(expandMessage)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ButtonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButton, {
            testId: "minimizable-modal.ui.modal-container.modal-header.modal-button",
            onClick: (0, (0, parcelRequire("4R6GH")).fg)('fix_failed_to_remove_node_error_for_gic') ? onViewChangeToModal : onViewChange('modal'),
            onKeyDown: onKeyDown,
            spacing: "none",
            ref: modalButtonRef,
            isMini: isMini
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6LXPU"))))), {
            label: formatMessage(expandMessage)
        }))))), closeBtn));
    };
    const $58cf9d8ffbd68381$export$f50a68e3694789ee = ({ children: children, ViewChangerContainer: ViewChangerContainer, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$HeaderWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), rest, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, children), (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$export$b89ab188a65746a6, {
            ViewChangerContainer: ViewChangerContainer,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        })));
    const $58cf9d8ffbd68381$export$1d38987b2afcba7e = ({ children: children, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$MiniHeaderWrapper, rest, children, (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$export$b89ab188a65746a6, {
            isMini: true,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        }));
    const $58cf9d8ffbd68381$export$b26fae16ba5468aa = (props)=>{
        const { view: view } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        if (view === 'mini' || view === 'minimized') return (0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$MiniTitle, props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", props);
    };
    const $58cf9d8ffbd68381$var$ViewChangerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isMini: isMini, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1bahesu3 _1o9zidpf _nt751r31 _49pcglyw _1hvw1o36",
                __cmplp.isMini && "_u5f31b66",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$HeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_otcopxbi _17ugpxbi _1eompxbi",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$MiniHeaderWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bahesu3 _syaz1fxt _n7zl1ktc _16qs1bc2 _18s8s8vo _1yt4rd6f",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$MiniTitle = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1fxt _11c81il0 _1yt4h8dc _1o9zkb7n _16jlkb7n _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$ModalButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8n8ld _vwz4kb7n",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$MiniButtonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$DISABLED_STYLED_NEW = {
        pointsEvents: 'none'
    };
    const $58cf9d8ffbd68381$var$ToolbarButtonExperiment = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("fVnbM")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_17521tcg _w8l51tcg _i5iqv77o",
                __cmplp.isMini && "_peycv77o _d16p1b66 _6q26idpf _gncuidpf _ujqdidpf _t7blidpf",
                __cmplp.isMini && __cmplp.isVisualRefreshEnabled && "_19iti319",
                __cmplp.className
            ])
        });
    });
    const $58cf9d8ffbd68381$var$ToolbarButton = (0, $5uXOq.forwardRef)(({ appearance: appearance = 'subtle', ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($58cf9d8ffbd68381$var$ToolbarButtonExperiment, {
            isVisualRefreshEnabled: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)(),
            appearance: appearance,
            ...rest,
            ref: ref
        }));
});
parcelRegister("4rRW5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $33d3859773cf17e9$var$_react = $33d3859773cf17e9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $33d3859773cf17e9$var$_shrinkDiagonal = $33d3859773cf17e9$var$_interopRequireDefault((parcelRequire("8KRBa")));
    function $33d3859773cf17e9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $33d3859773cf17e9$var$VidFullScreenOffIcon = (props)=>$33d3859773cf17e9$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M9 15.003v2.995a1 1 0 1 0 2 0v-3.896C11 13.494 10.507 13 9.9 13H6a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M3.74 20.294a.997.997 0 0 0 1.407.005l5.152-5.152a1 1 0 0 0-.005-1.407l-.034-.034a.997.997 0 0 0-1.407-.005l-5.152 5.152a1 1 0 0 0 .005 1.407z"/><path d="M19.067 3.321 13.32 9.066a1.115 1.115 0 0 0 .005 1.57l.036.037a1.11 1.11 0 0 0 1.571.005l5.747-5.744a1.116 1.116 0 0 0-.006-1.57l-.037-.037a1.117 1.117 0 0 0-1.57-.006"/><path d="M13 6.002v3.896c0 .608.493 1.102 1.1 1.102H18a1 1 0 0 0 0-2.003h-3V6.002a1 1 0 1 0-2 0"/></g></svg>`
        }, props, {
            newIcon: $33d3859773cf17e9$var$_shrinkDiagonal.default
        }));
    $33d3859773cf17e9$var$VidFullScreenOffIcon.displayName = 'VidFullScreenOffIcon';
    var $33d3859773cf17e9$var$_default = module.exports.default = $33d3859773cf17e9$var$VidFullScreenOffIcon;
});
parcelRegister("8KRBa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $65fc322a3db160cb$var$_react = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $65fc322a3db160cb$var$_UNSAFE_baseNew = $65fc322a3db160cb$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $65fc322a3db160cb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $65fc322a3db160cb$var$ShrinkDiagonalIcon = (props)=>$65fc322a3db160cb$var$_react.default.createElement($65fc322a3db160cb$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $65fc322a3db160cb$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $65fc322a3db160cb$var$_default = module.exports.default = $65fc322a3db160cb$var$ShrinkDiagonalIcon;
});
parcelRegister("3b05o", function(module, exports) {
    $parcel$export(module.exports, "useNestedModalDetector", ()=>$e5437dd22c0b7edd$export$d9e46b281508f5e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $iUFy5;
    const $e5437dd22c0b7edd$export$d9e46b281508f5e9 = ()=>{
        const { setIsNestedModal: setIsNestedModal } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        (0, $5uXOq.useEffect)(()=>{
            const modalElements = document.querySelectorAll('div.atlaskit-portal [aria-modal="true"]');
            if (modalElements.length > 1) setIsNestedModal(true);
        }, [
            setIsNestedModal
        ]);
    };
});
parcelRegister("k80q0", function(module, exports) {
    $parcel$export(module.exports, "MinimizeIcon", ()=>$827fc3c1a590dea3$export$95300d23f5f56d39);
    var $5uXOq = parcelRequire("5uXOq");
    var $5LWLA;
    const $827fc3c1a590dea3$export$ab3e03e3b7ae2f0c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            ...props,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("rect", {
            width: "24",
            height: "24",
            fill: "white",
            fillOpacity: "0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M18.6667 16C19.403 16 20 16.4477 20 17C20 17.5128 19.4853 17.9355 18.8221 17.9933L18.6667 18H5.33333C4.59695 18 4 17.5523 4 17C4 16.4872 4.51474 16.0645 5.17786 16.0067L5.33333 16H18.6667Z",
            fill: "currentColor"
        }));
    const $827fc3c1a590dea3$export$95300d23f5f56d39 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5LWLA")).default), {
            glyph: $827fc3c1a590dea3$export$ab3e03e3b7ae2f0c,
            size: props.size || null,
            label: props.label,
            primaryColor: props.primaryColor
        });
});
parcelRegister("iezXC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a612173ce9fd1b1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6a612173ce9fd1b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        minimize: {
            "id": "minimizable-modal.modal-container.modal-header.minimize",
            "defaultMessage": "Minimize"
        },
        minimizeDisabled: {
            "id": "minimizable-modal.modal-container.modal-header.minimize-disabled",
            "defaultMessage": "Can't minimize this view"
        },
        dock: {
            "id": "minimizable-modal.modal-container.modal-header.dock",
            "defaultMessage": "Dock to bottom"
        },
        dockDisabled: {
            "id": "minimizable-modal.modal-container.modal-header.dock-disabled",
            "defaultMessage": "Can't dock this view"
        },
        fullScreenExit: {
            "id": "minimizable-modal.modal-container.modal-header.full-screen-exit",
            "defaultMessage": "Exit full screen"
        },
        fullScreenExitDisabled: {
            "id": "minimizable-modal.modal-container.modal-header.full-screen-exit-disabled",
            "defaultMessage": "Can't exit full screen"
        },
        expand: {
            "id": "minimizable-modal.modal-container.modal-header.expand",
            "defaultMessage": "Expand"
        },
        fullScreen: {
            "id": "minimizable-modal.modal-container.modal-header.full-screen",
            "defaultMessage": "Go full screen"
        },
        close: {
            "id": "minimizable-modal.modal-container.modal-header.close",
            "defaultMessage": "Close"
        },
        onboardingSpotlightTitle: {
            "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title",
            "defaultMessage": "Welcome to the new issue create experience"
        },
        onboardingSpotlightActionGotIt: {
            "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-got-it",
            "defaultMessage": "Got it"
        },
        onboardingSpotlightActionLearnMore: {
            "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-learn-more",
            "defaultMessage": "Learn more"
        },
        onboardingSpotlightDescription: {
            "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-description",
            "defaultMessage": "A consistent, fast, and optimized way to capture work in your project."
        }
    });
});
parcelRegister("1JVJe", function(module, exports) {
    $parcel$export(module.exports, "ModalTransition", ()=>$3591ee95e2cbe3ad$export$f0a3ab1cc2e7e9a6);
    var $5uXOq = parcelRequire("5uXOq");
    var $i8Qvm;
    var $dWt6p;
    var $iUFy5;
    var $kNC83;
    const $3591ee95e2cbe3ad$export$f0a3ab1cc2e7e9a6 = ({ children: children, renderCondition: renderCondition })=>{
        const { isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        if ((0, (0, parcelRequire("dWt6p")).isReducedMotion)()) {
            if (renderCondition) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
            return null;
        }
        const shouldRenderModalView = renderCondition && isTransitionInState([
            'mini',
            'minimized'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).EXITED);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i8Qvm")).default), null, shouldRenderModalView && children);
    };
});
parcelRegister("6BEt4", function(module, exports) {
    $parcel$export(module.exports, "Modal", ()=>$b8d0d70af0708712$export$2b77a92f1a5ad772);
    var $5uXOq = parcelRequire("5uXOq");
    var $1R1Ge;
    var $7QSqG;
    var $dWt6p;
    var $9fuVs;
    var $4R6GH;
    var $8zOmE;
    var $isuse;
    var $iUFy5;
    var $kNC83;
    var $kUthR;
    const $b8d0d70af0708712$export$2b77a92f1a5ad772 = ({ children: children, components: components, onClose: onCloseFromProps, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, 'data-testid': dataTestId, ...rest })=>{
        const { onClose: onClose, isTransitionInState: isTransitionInState } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const { onFinishAnimation: onFinishAnimation } = (0, (0, parcelRequire("kUthR")).useTransitionView)('modal', true);
        const onOpenComplete = ()=>{
            onFinishAnimation('entering');
        };
        const onCloseComplete = ()=>{
            onFinishAnimation('exiting');
        };
        const isViewEntered = isTransitionInState([
            'modal'
        ], (0, (0, parcelRequire("kNC83")).TransitionState).ENTERED);
        const { Header: Header = (0, $5uXOq.Fragment), Body: Body = (0, (0, parcelRequire("7QSqG")).default), Footer: Footer = (0, $5uXOq.Fragment) } = components || {};
        const onMount = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("8zOmE")).fireScreenAnalyticsDeferred)(event, {
                isReducedMotion: (0, (0, parcelRequire("dWt6p")).isReducedMotion)()
            });
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1R1Ge")).default), {
            width: "large",
            height: (0, (0, parcelRequire("4R6GH")).fg)('migrate_gic_smart_fields_jira_labs') ? undefined : '100vh',
            autoFocus: false,
            onClose: onCloseFromProps || onClose,
            shouldCloseOnEscapePress: true,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            testId: isViewEntered ? dataTestId || 'minimizable-modal.ui.modal-container.modal' : undefined,
            onOpenComplete: onOpenComplete,
            onCloseComplete: onCloseComplete,
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: onMount
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(Header, null), (0, ($parcel$interopDefault($5uXOq))).createElement(Body, null, children === undefined ? null : children), (0, ($parcel$interopDefault($5uXOq))).createElement(Footer, null)));
    };
});
parcelRegister("4Ads7", function(module, exports) {
    $parcel$export(module.exports, "ReParenter", ()=>$ffd89c5b1c439476$export$c74b59dc6ffb3f46);
    var $5uXOq = parcelRequire("5uXOq");
    var $botCU = parcelRequire("botCU");
    var $9MHPe;
    const $ffd89c5b1c439476$export$c74b59dc6ffb3f46 = ({ children: children, Parent: Parent })=>{
        const portalNode = (0, $5uXOq.useMemo)(()=>(0, $botCU.createHtmlPortalNode)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $botCU.InPortal), {
            node: portalNode
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MHPe")).Layering), {
            isDisabled: false
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement(Parent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $botCU.OutPortal), {
            node: portalNode
        })));
    };
});
parcelRegister("botCU", function(module, exports) {
    $parcel$export(module.exports, "InPortal", ()=>$84b8ead67181cdc9$export$82590d10982cb172);
    $parcel$export(module.exports, "OutPortal", ()=>$84b8ead67181cdc9$export$6677f336551ad316);
    $parcel$export(module.exports, "createHtmlPortalNode", ()=>$84b8ead67181cdc9$export$c08cb61f0c65e152);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $84b8ead67181cdc9$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = function(d, b) {
            extendStatics = Object.setPrototypeOf || ({
                __proto__: []
            }) instanceof Array && function(d, b) {
                d.__proto__ = b;
            } || function(d, b) {
                for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
            };
            return extendStatics(d, b);
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML = 'html';
    var $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG = 'svg';
    var $84b8ead67181cdc9$var$SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var $84b8ead67181cdc9$var$validateElementType = function(domElement, elementType) {
        if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML) return domElement instanceof HTMLElement;
        if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG) return domElement instanceof SVGElement;
        throw new Error("Unrecognized element type \"" + elementType + "\" for validateElementType.");
    };
    var $84b8ead67181cdc9$var$createPortalNode = function(elementType, options) {
        var initialProps = {};
        var parent;
        var lastPlaceholder;
        var element;
        if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML) element = document.createElement('div');
        else if (elementType === $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG) element = document.createElementNS($84b8ead67181cdc9$var$SVG_NAMESPACE, 'g');
        else throw new Error("Invalid element type \"" + elementType + "\" for createPortalNode: must be \"html\" or \"svg\".");
        if (options && typeof options === "object") for(var _i = 0, _a = Object.entries(options.attributes); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            element.setAttribute(key, value);
        }
        var portalNode = {
            element: element,
            elementType: elementType,
            setPortalProps: function(props) {
                initialProps = props;
            },
            getInitialPortalProps: function() {
                return initialProps;
            },
            mount: function(newParent, newPlaceholder) {
                if (newPlaceholder === lastPlaceholder) return;
                portalNode.unmount();
                if (newParent !== parent) {
                    if (!$84b8ead67181cdc9$var$validateElementType(newParent, elementType)) throw new Error("Invalid element type for portal: \"" + elementType + "\" portalNodes must be used with " + elementType + " elements, but OutPortal is within <" + newParent.tagName + ">.");
                }
                newParent.replaceChild(portalNode.element, newPlaceholder);
                parent = newParent;
                lastPlaceholder = newPlaceholder;
            },
            unmount: function(expectedPlaceholder) {
                if (expectedPlaceholder && expectedPlaceholder !== lastPlaceholder) return;
                if (parent && lastPlaceholder) {
                    parent.replaceChild(lastPlaceholder, portalNode.element);
                    parent = undefined;
                    lastPlaceholder = undefined;
                }
            }
        };
        return portalNode;
    };
    var $84b8ead67181cdc9$export$82590d10982cb172 = function(_super) {
        $84b8ead67181cdc9$var$__extends(InPortal, _super);
        function InPortal(props) {
            var _this = _super.call(this, props) || this;
            _this.addPropsChannel = function() {
                Object.assign(_this.props.node, {
                    setPortalProps: function(props) {
                        _this.setState({
                            nodeProps: props
                        });
                    }
                });
            };
            _this.state = {
                nodeProps: _this.props.node.getInitialPortalProps()
            };
            return _this;
        }
        InPortal.prototype.componentDidMount = function() {
            this.addPropsChannel();
        };
        InPortal.prototype.componentDidUpdate = function() {
            this.addPropsChannel();
        };
        InPortal.prototype.render = function() {
            var _this = this;
            var _a = this.props, children = _a.children, node = _a.node;
            return $7nsd3.createPortal($5uXOq.Children.map(children, function(child) {
                if (!$5uXOq.isValidElement(child)) return child;
                return $5uXOq.cloneElement(child, _this.state.nodeProps);
            }), node.element);
        };
        return InPortal;
    }($5uXOq.PureComponent);
    var $84b8ead67181cdc9$export$6677f336551ad316 = function(_super) {
        $84b8ead67181cdc9$var$__extends(OutPortal, _super);
        function OutPortal(props) {
            var _this = _super.call(this, props) || this;
            _this.placeholderNode = $5uXOq.createRef();
            _this.passPropsThroughPortal();
            return _this;
        }
        OutPortal.prototype.passPropsThroughPortal = function() {
            var propsForTarget = Object.assign({}, this.props, {
                node: undefined
            });
            this.props.node.setPortalProps(propsForTarget);
        };
        OutPortal.prototype.componentDidMount = function() {
            var node = this.props.node;
            this.currentPortalNode = node;
            var placeholder = this.placeholderNode.current;
            var parent = placeholder.parentNode;
            node.mount(parent, placeholder);
            this.passPropsThroughPortal();
        };
        OutPortal.prototype.componentDidUpdate = function() {
            var node = this.props.node;
            if (this.currentPortalNode && node !== this.currentPortalNode) {
                this.currentPortalNode.unmount(this.placeholderNode.current);
                this.currentPortalNode = node;
            }
            var placeholder = this.placeholderNode.current;
            var parent = placeholder.parentNode;
            node.mount(parent, placeholder);
            this.passPropsThroughPortal();
        };
        OutPortal.prototype.componentWillUnmount = function() {
            var node = this.props.node;
            node.unmount(this.placeholderNode.current);
        };
        OutPortal.prototype.render = function() {
            return $5uXOq.createElement("div", {
                ref: this.placeholderNode
            });
        };
        return OutPortal;
    }($5uXOq.PureComponent);
    var $84b8ead67181cdc9$export$c08cb61f0c65e152 = $84b8ead67181cdc9$var$createPortalNode.bind(null, $84b8ead67181cdc9$var$ELEMENT_TYPE_HTML);
    var $84b8ead67181cdc9$export$6ac597db63d00ad3 = $84b8ead67181cdc9$var$createPortalNode.bind(null, $84b8ead67181cdc9$var$ELEMENT_TYPE_SVG);
});
parcelRegister("8LWdH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d3d9c5f6f4d0480$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $fVnbM;
    var $2rqOp;
    var $kkJfY;
    var $kJ541;
    var $juxqI;
    var $3bDjY;
    var $6s1PB;
    var $koVbs;
    var $5rzqz;
    var $8zOmE;
    var $6gjIc;
    var $2K6wP;
    var $fya6v;
    var $eGLQ7;
    const $1d3d9c5f6f4d0480$var$PassThroughWrapper = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    const $1d3d9c5f6f4d0480$var$ModalFooter = (props)=>{
        const { isMiniVariant: isMiniVariant, containerStyle: containerStyle, children: children } = props;
        if (isMiniVariant) return (0, ($parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$export$c93769792f0dbc05, {
            style: containerStyle
        }, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juxqI")).default), null, children);
    };
    const $1d3d9c5f6f4d0480$export$a06f1c675e846f6f = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onClose: onClose, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress = false, onCreateAnotherChange: onCreateAnotherChange, canCreateAnotherIssue: canCreateAnotherIssue, shouldDisableSubmit: shouldDisableSubmit = false, createdIssues: createdIssues, variant: variant = (0, (0, parcelRequire("fya6v")).GIC_VARIANTS).DEFAULT, displayCreateAnotherIssueToggle: newDisplayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, containerStyle: containerStyle, showCancelButton: showCancelButton } = props;
        const numberOfIssuesCreated = createdIssues.length;
        let displayCreateAnotherIssueToggle = newDisplayCreateAnotherIssueToggle;
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        const isMiniVariant = isGICPositioningEnabled() && variant === (0, (0, parcelRequire("fya6v")).GIC_VARIANTS).MINI;
        if (!isGICPositioningEnabled()) {
            const [{ displayCreateAnotherIssueToggle: oldDisplayCreateAnotherIssueToggle }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
            displayCreateAnotherIssueToggle = oldDisplayCreateAnotherIssueToggle;
        }
        const onViewIssuesLinkClicked = (_, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'viewIssue');
        };
        const getPrimaryButtonCopy = ()=>{
            if (isMiniVariant) return (0, (0, parcelRequire("eGLQ7")).default).createButtonInMiniView;
            return (0, (0, parcelRequire("eGLQ7")).default).createButton;
        };
        const IssuesCreatedTooltip = isMiniVariant ? (0, (0, parcelRequire("3bDjY")).default) : $1d3d9c5f6f4d0480$var$PassThroughWrapper;
        const showIssueCreatedTooltip = Boolean(numberOfIssuesCreated) && Boolean(showIssuesCreated);
        const cancelBtn = props?.dismissModalEntryPointWrapper ? (0, ($parcel$interopDefault($5uXOq))).createElement(props.dismissModalEntryPointWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: onClose,
            isDisabled: isSubmitting,
            testId: "issue-create.common.ui.footer.cancel-button",
            interactionName: "global-issue.create-modal.cancel"
        }, formatMessage((0, (0, parcelRequire("eGLQ7")).default).cancelButton))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            onClick: onClose,
            isDisabled: isSubmitting,
            testId: "issue-create.common.ui.footer.cancel-button",
            interactionName: "global-issue.create-modal.cancel"
        }, formatMessage((0, (0, parcelRequire("eGLQ7")).default).cancelButton));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$ModalFooter, {
            isMiniVariant: isMiniVariant,
            containerStyle: containerStyle
        }, displayCreateAnotherIssueToggle && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kkJfY")).default), {
            onChange: onCreateAnotherChange,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false) ? (0, (0, parcelRequire("eGLQ7")).default).createAnotherFade : (0, (0, parcelRequire("eGLQ7")).default).createAnother),
            isChecked: canCreateAnotherIssue,
            isDisabled: shouldDisableSubmit,
            testId: "issue-create.common.ui.footer.checkbox"
        }), showIssueCreatedTooltip && (0, ($parcel$interopDefault($5uXOq))).createElement(IssuesCreatedTooltip, {
            content: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eGLQ7")).default).issuesCreatedLinkIssueTermRefresh : (0, (0, parcelRequire("eGLQ7")).default).issuesCreatedLink, {
                issueCount: numberOfIssuesCreated
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$IssueLinkContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("kJ541"))))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$exports).G400})`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
            appearance: "subtle-link",
            spacing: "none",
            href: (0, (0, parcelRequire("2K6wP")).getIssueDiscoveryUrl)(createdIssues),
            target: "_blank",
            onClick: onViewIssuesLinkClicked,
            testId: "issue-create.common.ui.footer.created-issue-link",
            interactionName: "global-issue.create-modal.created-issue-link"
        }, isMiniVariant ? numberOfIssuesCreated : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eGLQ7")).default).issuesCreatedLinkIssueTermRefresh : (0, (0, parcelRequire("eGLQ7")).default).issuesCreatedLink, {
            issueCount: numberOfIssuesCreated
        })))), (!isMiniVariant || showCancelButton) && (0, ($parcel$interopDefault($5uXOq))).createElement($1d3d9c5f6f4d0480$var$CloseButtonContainer, null, cancelBtn), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2rqOp")).default), {
            appearance: "primary",
            onClick: onSubmit,
            isLoading: isSubmitting || isOperationInProgress,
            isDisabled: isSubmitting || shouldDisableSubmit,
            type: "submit",
            form: (0, $c758c3cb80bbdb5a$export$2d077da71c26c1c5),
            testId: "issue-create.common.ui.footer.create-button",
            interactionName: "global-issue.create-modal.submit"
        }, isGICPositioningEnabled() ? formatMessage(getPrimaryButtonCopy()) : formatMessage((0, (0, parcelRequire("eGLQ7")).default).createButton)));
    };
    var $1d3d9c5f6f4d0480$export$2e2bcd8739ae039 = $1d3d9c5f6f4d0480$export$a06f1c675e846f6f;
    const $1d3d9c5f6f4d0480$var$CloseButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $1d3d9c5f6f4d0480$var$IssueLinkContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _18u0pxbi _2hwx1wug",
                __cmplp.className
            ])
        });
    });
    const $1d3d9c5f6f4d0480$export$c93769792f0dbc05 = (0, $5uXOq.forwardRef)(({ as: C = "footer", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _zulp1b66 _16jlidpf _1o9zidpf _i0dl1wug _18s8s8vo _1yt4rd6f _x3do1ktc _16qs1lnm",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fya6v", function(module, exports) {
    $parcel$export(module.exports, "GIC_VARIANTS", ()=>$778d15254cf65a27$export$409069fd677aa1c3);
    const $778d15254cf65a27$export$409069fd677aa1c3 = {
        DEFAULT: 'default',
        MINI: 'mini'
    };
});
parcelRegister("eGLQ7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d36addc4343e3e14$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d36addc4343e3e14$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createButton: {
            "id": "issue-create.common.footer.create-button",
            "defaultMessage": "Create"
        },
        createButtonInMiniView: {
            "id": "issue-create.common.footer.create-button-in-mini-view",
            "defaultMessage": "Create"
        },
        cancelButton: {
            "id": "issue-create.common.footer.cancel-button",
            "defaultMessage": "Cancel"
        },
        createAnotherFade: {
            "id": "issue-create.common.footer.create-another-fade",
            "defaultMessage": "Create another"
        },
        createAnother: {
            "id": "issue-create.common.footer.create-another",
            "defaultMessage": "Create another issue"
        },
        copyToNextIssue: {
            "id": "issue-create.common.footer.copy-to-next-issue",
            "defaultMessage": "Copy to next issue"
        },
        copyToNextIssueIssueTermRefresh: {
            "id": "issue-create.common.footer.copy-to-next-issue-issue-term-refresh",
            "defaultMessage": "Copy to next work item"
        },
        issuesCreatedLink: {
            "id": "issue-create.common.footer.issues-created-link",
            "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} created"
        },
        issuesCreatedLinkIssueTermRefresh: {
            "id": "issue-create.common.footer.issues-created-link-issue-term-refresh",
            "defaultMessage": "{issueCount} {issueCount, plural, one {work item} other {work items}} created"
        },
        createDropdownOptionCreateAnother: {
            "id": "issue-create.common.footer.create-dropdown-option-create-another",
            "defaultMessage": "Create and start another"
        },
        createDropdownOptionCopy: {
            "id": "issue-create.common.footer.create-dropdown-option-copy",
            "defaultMessage": "Create and copy"
        },
        toggleOnTooltip: {
            "id": "issue-create.common.footer.toggle-on-tooltip",
            "defaultMessage": "Toggle off to finish creating issues."
        },
        toggleOnTooltipIssueTermRefresh: {
            "id": "issue-create.common.footer.toggle-on-tooltip-issue-term-refresh",
            "defaultMessage": "Toggle off to finish"
        },
        toggleOffTooltip: {
            "id": "issue-create.common.footer.toggle-off-tooltip",
            "defaultMessage": "After selecting {createButton}, immediately start a new issue with these details and fields."
        },
        toggleOffTooltipIssueTermRefresh: {
            "id": "issue-create.common.footer.toggle-off-tooltip-issue-term-refresh",
            "defaultMessage": "After selecting {createButton}, immediately start a new work item with these details and fields."
        }
    });
});
parcelRegister("bMoTh", function(module, exports) {
    $parcel$export(module.exports, "useMinimizableModalWrapperProps", ()=>$841dc183f56b8336$export$48c73e38324bf86b);
    $parcel$export(module.exports, "MinimizableModalWrapperPropsProvider", ()=>$841dc183f56b8336$export$a81052d98ff4e3f6);
    var $5uXOq = parcelRequire("5uXOq");
    const $841dc183f56b8336$var$MinimizableModalWrapperPropsContext = (0, $5uXOq.createContext)(null);
    const $841dc183f56b8336$export$48c73e38324bf86b = ()=>{
        const context = (0, $5uXOq.useContext)($841dc183f56b8336$var$MinimizableModalWrapperPropsContext);
        if (context === undefined || context === null) throw new Error('No provider for useMinimizableModalWrapperProps');
        return context;
    };
    const $841dc183f56b8336$export$a81052d98ff4e3f6 = ({ children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement($841dc183f56b8336$var$MinimizableModalWrapperPropsContext.Provider, {
            value: rest
        }, children);
});
parcelRegister("jWbdK", function(module, exports) {
    $parcel$export(module.exports, "MinimizableFullscreen", ()=>$c959effeaa72bfea$export$b31191b6904db55b);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVPqx;
    var $5rzqz;
    var $fya6v;
    var $8LWdH;
    var $bMoTh;
    const $c959effeaa72bfea$export$b31191b6904db55b = (0, $5uXOq.forwardRef)(({ children: children, ...rest }, ref)=>{
        const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        const [{ containerStyle: containerStyle }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVPqx")).Fullscreen), {
            ref: ref,
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVPqx")).FullscreenBody), {
            containerStyle: containerStyle
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8LWdH")).default), {
            onClose: onModalCloseWithConfirm('cancel'),
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            isOperationInProgress: isOperationInProgress,
            canCreateAnotherIssue: canCreateAnotherIssue,
            onCreateAnotherChange: onCreateAnotherChange,
            shouldDisableSubmit: getShouldDisableSubmit(),
            createdIssues: createdIssues,
            variant: (0, (0, parcelRequire("fya6v")).GIC_VARIANTS).MINI,
            displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
            containerStyle: containerStyle,
            showCancelButton: true,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        })));
    });
});
parcelRegister("dDDBO", function(module, exports) {
    $parcel$export(module.exports, "MinimizableModalMini", ()=>$fed0bfa878c145d1$export$c752bd88450266e0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ixNeq;
    var $2vSU6;
    var $jcw0u;
    var $dVZve;
    var $5rzqz;
    var $6k7U1;
    var $dAfqg;
    var $cn7wb;
    var $fya6v;
    var $8LWdH;
    var $hifTJ;
    var $fjI6w;
    var $bMoTh;
    var $d3Crn;
    const $fed0bfa878c145d1$export$c752bd88450266e0 = (0, $5uXOq.forwardRef)(({ children: children, summaryValue: summaryValue, ...rest }, ref)=>{
        const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, selectedIssueType: selectedIssueType, projectType: projectType, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        const issueTypeRef = (0, $5uXOq.useRef)(selectedIssueType);
        const { parseSummaryValue: parseSummaryValue } = (0, (0, parcelRequire("fjI6w")).useParseSummaryValue)();
        const [shouldRenderMiniModalSpotlight, setShouldRenderMiniModalSpotlight] = (0, $5uXOq.useState)(false);
        const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight, triggerPointKey: triggerPointKey }, { dismissModalSpotlight: dismissModalSpotlight }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const [userTraits, { setUserTraits: setUserTraits }] = (0, (0, parcelRequire("ixNeq")).useUserTraits)();
        const fetchUserTraits = (0, (0, parcelRequire("ixNeq")).useFetchUserTraitsOld)();
        const setUserTraitsIfNotAvailable = (0, $5uXOq.useCallback)(async ()=>{
            const newTraits = await fetchUserTraits();
            if (newTraits !== false) setUserTraits(newTraits);
        }, [
            fetchUserTraits,
            setUserTraits
        ]);
        const { updateIsDiscoPushComplete: updateIsDiscoPushComplete } = (0, (0, parcelRequire("cn7wb")).usePersistentIssueCreateModalViewResource)();
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const markMiniModalAsSeen = (0, $5uXOq.useCallback)(()=>{
            try {
                const shouldDismiss = (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(triggerPointKey) && projectContext?.projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
                if (shouldDismiss) {
                    updateIsDiscoPushComplete(true);
                    dismissModalSpotlight();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'setMiniModalSpotlightPreference',
                        packageName: 'jiraIssueCreate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            dismissModalSpotlight,
            triggerPointKey,
            updateIsDiscoPushComplete,
            projectContext?.projectType
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                markMiniModalAsSeen();
            }, [
            markMiniModalAsSeen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (selectedIssueType) issueTypeRef.current = selectedIssueType;
        }, [
            selectedIssueType
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!userTraits?.attributes?.length && userTraits?.attributes !== null) setUserTraitsIfNotAvailable();
            else {
                const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
                const aWeekAgo = new Date(Date.now() - 604800000);
                let isNewUser = false;
                if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
                setShouldRenderMiniModalSpotlight(!!shouldShowMiniModalSpotlight && !isNewUser);
            }
        }, [
            userTraits,
            shouldShowMiniModalSpotlight,
            setUserTraitsIfNotAvailable
        ]);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVZve")).Mini), {
            ref: ref,
            ...rest
        }, shouldRenderMiniModalSpotlight && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d3Crn")).SpotlightContainer), {
            shouldShowSpotlight: shouldRenderMiniModalSpotlight,
            onCloseSpotlight: markMiniModalAsSeen
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hifTJ")).MiniHeader), {
            title: parseSummaryValue(summaryValue, issueTypeRef.current?.label),
            isItalic: !summaryValue,
            iconUrl: issueTypeRef.current?.iconUrl,
            showHeaderIcon: projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT),
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dVZve")).MiniBody), null, children), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8LWdH")).default), {
            onClose: onModalCloseWithConfirm('cancel'),
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            isOperationInProgress: isOperationInProgress,
            canCreateAnotherIssue: canCreateAnotherIssue,
            onCreateAnotherChange: onCreateAnotherChange,
            shouldDisableSubmit: getShouldDisableSubmit(),
            createdIssues: createdIssues,
            variant: (0, (0, parcelRequire("fya6v")).GIC_VARIANTS).MINI,
            displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle
        })));
    });
});
parcelRegister("ixNeq", function(module, exports) {
    $parcel$export(module.exports, "useFetchUserTraitsOld", ()=>$5e172a254cf471a7$export$d5a27009aa54a078);
    $parcel$export(module.exports, "useUserTraits", ()=>$5e172a254cf471a7$export$49363c8b904e0dc7);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $90yGq;
    var $koeKL;
    var $3sQ5x;
    var $iXqE5;
    const $5e172a254cf471a7$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
            const currentUserTraits = getState();
            setState({
                ...currentUserTraits,
                attributes: newTraits
            });
        };
    const $5e172a254cf471a7$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
            const currentUserTraits = getState();
            if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
            setState({
                attributes: currentUserTraits.attributes?.concat(trait) ?? [
                    trait
                ]
            });
        };
    const $5e172a254cf471a7$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
            if (!accountId) return null;
            const state = getState();
            if (state.attributes !== null) return;
            const getUserTraits = async ()=>{
                try {
                    const userTraitsData = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                    return userTraitsData?.attributes ?? [];
                } catch  {
                    return null;
                }
            };
            const userTraits = await getUserTraits();
            setState({
                attributes: userTraits
            });
        };
    const $5e172a254cf471a7$var$actions = {
        setUserTraits: $5e172a254cf471a7$var$setUserTraits,
        fetchUserTraits: $5e172a254cf471a7$var$fetchUserTraits,
        addUserTrait: $5e172a254cf471a7$var$addUserTrait
    };
    const $5e172a254cf471a7$var$initialState = {
        attributes: null
    };
    const $5e172a254cf471a7$export$d5a27009aa54a078 = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        return (0, $5uXOq.useCallback)(async ()=>{
            if (!accountId) return null;
            const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
            const getUserTraits = async ()=>{
                try {
                    setLoading(true);
                    const userTraitsData = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
                    return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
                } catch  {
                    return null;
                } finally{
                    setLoading(false);
                }
            };
            if (!loading) {
                const userTraits = await getUserTraits();
                return userTraits;
            }
            return false;
        }, [
            accountId,
            cloudId,
            loading
        ]);
    };
    const $5e172a254cf471a7$export$6e688ed53ae076d5 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $5e172a254cf471a7$var$initialState,
        actions: $5e172a254cf471a7$var$actions,
        name: 'UserTraits'
    });
    const $5e172a254cf471a7$export$49363c8b904e0dc7 = (0, (0, parcelRequire("3sQ5x")).createHook)($5e172a254cf471a7$export$6e688ed53ae076d5);
    const $5e172a254cf471a7$export$4f249a943026a90b = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($5e172a254cf471a7$export$6e688ed53ae076d5);
});
parcelRegister("hifTJ", function(module, exports) {
    $parcel$export(module.exports, "MiniHeader", ()=>$725c03a0b529e1ca$export$1d38987b2afcba7e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jjlQu;
    var $bSvOl;
    const $725c03a0b529e1ca$export$1d38987b2afcba7e = ({ title: title, iconUrl: iconUrl, isItalic: isItalic, showHeaderIcon: showHeaderIcon, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSvOl")).MiniHeader), {
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        }, showHeaderIcon && iconUrl && (0, ($parcel$interopDefault($5uXOq))).createElement($725c03a0b529e1ca$var$IconContainer, {
            "data-testid": "issue-create.common.ui.minimizable-modal-mini-header.icon-container"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
            width: 16,
            alt: title,
            url: iconUrl
        })), (0, ($parcel$interopDefault($5uXOq))).createElement($725c03a0b529e1ca$var$MinimizableModalTitle, {
            "data-testid": "minimizable-modal.ui.modal-container-mini-header.mini-header",
            isItalic: isItalic
        }, title));
    const $725c03a0b529e1ca$var$IconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $725c03a0b529e1ca$var$MinimizableModalTitle = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("bSvOl")).ModalTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0ccj1k _syaz2l1e _1wybpxbi _k48p1pd9 _ca0qidpf _u5f3ftgi _n3tdidpf _19bvftgi _1yyjcs5v _sudp1e54 _o5724jg8 _1bto4jg8 _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jjlQu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e7f7206d8a029d15$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $47bDC = parcelRequire("47bDC");
    var $dC5iT;
    var $8CUq3;
    var $gwIPs;
    var $4R6GH;
    const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                url: undefined,
                title: undefined,
                alt: undefined,
                width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
                fallback: undefined
            };
        }
        render() {
            const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
            const width = this.convertSize(this.props.width);
            const height = this.convertSize(this.props.height);
            if (this.state.isBroken && fallback) return fallback();
            if (url) return (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
                src: url,
                width: width,
                height: height,
                title: title ?? undefined,
                alt: alt ?? '',
                onError: this.onError,
                draggable: false
            });
            return (0, (0, parcelRequire("4R6GH")).fg)('jfp-1020-use-compiled') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
                xcss: $e7f7206d8a029d15$var$placeholderStyles,
                style: {
                    height: height,
                    width: width
                },
                backgroundColor: "color.background.input.hovered",
                testId: "common-components-async-icon.placeholder"
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$ImagePlaceholder, {
                width: width,
                height: height,
                "data-testid": "common-components-async-icon.placeholder"
            });
        }
        constructor(...args){
            super(...args), this.state = {
                isBroken: false
            }, this.onError = ()=>{
                this.setState({
                    isBroken: true
                });
            }, this.convertSize = (size)=>size ? `${size}px` : '0';
        }
    }
    const $e7f7206d8a029d15$var$ImagePlaceholder = (0, $47bDC.default).span.withConfig({
        componentId: "owe24v-0"
    })((props)=>({
            height: props.height,
            width: props.width,
            backgroundColor: (0, $829f609a65d26a98$exports).N30,
            borderRadius: '3px',
            display: 'flex',
            flex: 'none'
        }));
    const $e7f7206d8a029d15$var$placeholderStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    });
    const $e7f7206d8a029d15$var$Image = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fjI6w", function(module, exports) {
    $parcel$export(module.exports, "useParseSummaryValue", ()=>$8e71caad01a577e6$export$f753c33a187faf7c);
    var $6s1PB;
    var $koVbs;
    var $4Ju2T;
    const $8e71caad01a577e6$export$f753c33a187faf7c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const parseSummaryValue = (summaryValue, issueType)=>{
            if (summaryValue === null) return issueType ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4Ju2T")).default).noSummaryWithIssueTypeIssueTermRefresh : (0, (0, parcelRequire("4Ju2T")).default).noSummaryWithIssueType, {
                issueType: issueType
            }) : '';
            if (summaryValue) return summaryValue;
            return issueType ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4Ju2T")).default).noSummaryWithIssueTypeIssueTermRefresh : (0, (0, parcelRequire("4Ju2T")).default).noSummaryWithIssueType, {
                issueType: issueType
            }) : formatMessage((0, (0, parcelRequire("4Ju2T")).default).noSummary);
        };
        return {
            parseSummaryValue: parseSummaryValue
        };
    };
});
parcelRegister("d3Crn", function(module, exports) {
    $parcel$export(module.exports, "SpotlightContainer", ()=>$f05b3fdf39d8df72$export$d0f55839b708c0a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5ujeO;
    var $ousew;
    var $koVbs;
    var $4Ju2T;
    const $f05b3fdf39d8df72$export$d0f55839b708c0a0 = ({ shouldShowSpotlight: shouldShowSpotlight, onCloseSpotlight: onCloseSpotlight })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($f05b3fdf39d8df72$var$SpotlightPopoverWrapper, {
            "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-mini.modal-spotlight.wrapper"
        }, shouldShowSpotlight && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            heading: formatMessage((0, (0, parcelRequire("4Ju2T")).default).miniModalSpotlightHeading),
            width: 290,
            actions: [
                {
                    onClick: onCloseSpotlight,
                    text: formatMessage((0, (0, parcelRequire("4Ju2T")).default).miniModalSpotlightActionMessage)
                }
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("4Ju2T")).default).miniModalSpotlightMessage,
            values: {
                br: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("br", null), (0, ($parcel$interopDefault($5uXOq))).createElement("br", null))
            }
        })));
    };
    const $f05b3fdf39d8df72$var$SpotlightPopoverWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltv1vvt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("l2y6R", function(module, exports) {
    $parcel$export(module.exports, "MinimizableModalMinimized", ()=>$495c812cfd89d501$export$72c64a34c513900);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $jjlQu;
    var $2vSU6;
    var $4TqWb;
    var $fjI6w;
    var $bMoTh;
    const $495c812cfd89d501$export$72c64a34c513900 = (0, $5uXOq.forwardRef)(({ className: className, summaryValue: summaryValue }, ref)=>{
        const { parseSummaryValue: parseSummaryValue } = (0, (0, parcelRequire("fjI6w")).useParseSummaryValue)();
        const { selectedIssueType: selectedIssueType, projectType: projectType } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$StyledMinimized, {
            ref: ref,
            isItalic: !summaryValue,
            transitionClass: className
        }, selectedIssueType?.iconUrl && projectType !== (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT) ? (0, ($parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$TitleContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($495c812cfd89d501$var$IconContainer, {
            "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-minimized.issue-type-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jjlQu")).default), {
            width: 16,
            alt: `${selectedIssueType?.label} icon`,
            url: selectedIssueType?.iconUrl
        })), parseSummaryValue(summaryValue, selectedIssueType?.label)) : parseSummaryValue(summaryValue, selectedIssueType?.label)));
    });
    const $495c812cfd89d501$var$IconContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxpxbi _1e0c116y",
                __cmplp.className
            ])
        });
    });
    const $495c812cfd89d501$var$TitleContainer = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $495c812cfd89d501$var$StyledMinimized = (0, $47bDC.default)((0, (0, parcelRequire("4TqWb")).Minimized)).attrs({
        className: (props)=>props.transitionClass
    }).withConfig({
        componentId: "sc-1pohfgc-0"
    })``;
});
parcelRegister("31ArW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd1b47c4e9711ac8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jgVsb;
    var $gofOI;
    var $dC5iT;
    var $8CUq3;
    var $6s1PB;
    var $koVbs;
    var $45Cy1;
    var $bSvOl;
    var $5rzqz;
    var $6gjIc;
    var $cWvpX;
    var $gYiXv;
    var $1B7A8;
    var $6NEf0;
    const $bd1b47c4e9711ac8$export$a9dbcd01d58b1c3b = ({ shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        let titleMsg = (()=>{
            if ((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false)) return (0, (0, parcelRequire("1B7A8")).default).titleFade;
            return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1B7A8")).default).titleIssueTermRefresh : (0, (0, parcelRequire("1B7A8")).default).title;
        })();
        if (isSubTaskCreationOpen) titleMsg = (0, (0, parcelRequire("1B7A8")).default).subtaskTitle;
        else if (isCreateLinkedIssue) titleMsg = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1B7A8")).default).createLinkedIssueDialogTitleIssueTermRefresh : (0, (0, parcelRequire("1B7A8")).default).createLinkedIssueDialogTitle;
        const shouldShowChangerSpotlightBoolean = !!shouldShowChangerSpotlight;
        const ViewChangerContainer = shouldShowChangerSpotlightBoolean ? (0, (0, parcelRequire("6NEf0")).SpotlightContainer) : undefined;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bSvOl")).ModalHeader), {
            ViewChangerContainer: ViewChangerContainer,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        }, title !== null && title !== '' ? title : formatMessage(titleMsg))));
    };
    const $bd1b47c4e9711ac8$var$OldHeader = ({ shouldDisableActions: shouldDisableActions, watchersConfigurations: watchersConfigurations })=>{
        const [{ selectedProject: selectedProject }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const shouldDisableHeaderDropdown = ()=>Boolean(shouldDisableActions || selectedProject === null);
        let titleMsg = (()=>{
            if ((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m1-fade', 'isIssueTermFaded', false)) return (0, (0, parcelRequire("1B7A8")).default).titleFade;
            return (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1B7A8")).default).titleIssueTermRefresh : (0, (0, parcelRequire("1B7A8")).default).title;
        })();
        if (isSubTaskCreationOpen) titleMsg = (0, (0, parcelRequire("1B7A8")).default).subtaskTitle;
        else if (isCreateLinkedIssue) titleMsg = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("1B7A8")).default).createLinkedIssueDialogTitleIssueTermRefresh : (0, (0, parcelRequire("1B7A8")).default).createLinkedIssueDialogTitle;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgVsb")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gofOI")).default), null, title !== null && title !== '' ? title : formatMessage(titleMsg))), (0, ($parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$var$ActionsContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cWvpX")).default), {
            configs: watchersConfigurations
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $bd1b47c4e9711ac8$var$dropdownContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gYiXv")).default), {
            isDisabled: shouldDisableHeaderDropdown()
        }))))));
    };
    const $bd1b47c4e9711ac8$export$8b251419efc915eb = (props)=>{
        const isGICPositioningEnabled = (0, (0, parcelRequire("6gjIc")).useIsGICPositioningEnabled)();
        if (isGICPositioningEnabled()) return (0, ($parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$export$a9dbcd01d58b1c3b, {
            shouldShowChangerSpotlight: props.shouldShowChangerSpotlight,
            dismissModalEntryPointWrapper: props.dismissModalEntryPointWrapper
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($bd1b47c4e9711ac8$var$OldHeader, props);
    };
    var $bd1b47c4e9711ac8$export$2e2bcd8739ae039 = $bd1b47c4e9711ac8$export$8b251419efc915eb;
    const $bd1b47c4e9711ac8$var$ActionsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u01wug _1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $bd1b47c4e9711ac8$var$dropdownContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("gYiXv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f50c13c24c254b34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fVnbM;
    var $BLPHT;
    var $6B7KL;
    var $aRoVz;
    var $3oUqw;
    var $koVbs;
    var $c7ZNt;
    var $45Cy1;
    var $8zOmE;
    var $2NMNM;
    var $itmJb;
    var $fOw0O;
    const $f50c13c24c254b34$var$HeaderDropdown = (props)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { isDisabled: isDisabled = false } = props;
        const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const showConfigureFieldsModal = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            toggleConfigureFieldsModalVisibility(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'configureFields', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
        };
        const showFindFieldModal = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            toggleFindFieldsModalVisibility(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'findYourField', {
                projectType: selectedProject ? (0, (0, parcelRequire("c7ZNt")).transformProjectType)(selectedProject.projectType) : 'none'
            });
        };
        const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
        const onOpenChange = (attributes)=>{
            if (attributes.isOpen) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'meatballMenu');
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("BLPHT")).default), {
            placement: "bottom-end",
            trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fVnbM")).default), {
                    ...dropdownProps,
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3oUqw"))))), {
                        label: "more"
                    }),
                    appearance: "subtle",
                    ref: triggerRef,
                    isDisabled: isDisabled
                }),
            onOpenChange: onOpenChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aRoVz")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: showConfigureFieldsModal
        }, formatMessage((0, (0, parcelRequire("fOw0O")).default).showFields)), showFindFieldOption() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6B7KL")).default), {
            onClick: showFindFieldModal
        }, formatMessage((0, (0, parcelRequire("fOw0O")).default).findField))));
    };
    var $f50c13c24c254b34$export$2e2bcd8739ae039 = $f50c13c24c254b34$var$HeaderDropdown;
});
parcelRegister("fOw0O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c9830fe1e229697$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4c9830fe1e229697$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        showFields: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.show-fields",
            "defaultMessage": "Show fields"
        },
        findField: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.find-field",
            "defaultMessage": "Find your field"
        }
    });
});
parcelRegister("1B7A8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b6269d8953ea86b1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b6269d8953ea86b1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        titleFade: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title",
            "defaultMessage": "Create"
        },
        title: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-to-be-faded",
            "defaultMessage": "Create issue"
        },
        subtaskTitle: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title",
            "defaultMessage": "Create subtask"
        },
        createLinkedIssueDialogTitle: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title",
            "defaultMessage": "Create linked issue"
        },
        changerButtonsDisabledForgeFields: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields",
            "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
        },
        titleIssueTermRefresh: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title-issue-term-refresh",
            "defaultMessage": "Create work item"
        },
        createLinkedIssueDialogTitleIssueTermRefresh: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title-issue-term-refresh",
            "defaultMessage": "Create linked work item"
        },
        changerButtonsDisabledForgeFieldsIssueTermRefresh: {
            "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields-issue-term-refresh",
            "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
        }
    });
});
parcelRegister("6NEf0", function(module, exports) {
    $parcel$export(module.exports, "SpotlightContainer", ()=>$94f1f60818fb1297$export$d0f55839b708c0a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $5ujeO;
    var $k6T4f;
    var $k5uoT;
    var $6s1PB;
    var $koVbs;
    var $4Ju2T;
    const $94f1f60818fb1297$export$d0f55839b708c0a0 = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($94f1f60818fb1297$var$SpotlightContainerWrapper, {
            "data-testid": "issue-create.ui.modal.header.spotlight-container.wrapper"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($94f1f60818fb1297$var$SpotlightPopoverWrapper, {
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).spotlight()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ujeO")).default), {
            width: 275
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4Ju2T")).default).resizeSpotlightMessageIssueTermRefresh : (0, (0, parcelRequire("4Ju2T")).default).resizeSpotlightMessage)))));
    };
    const $94f1f60818fb1297$var$SpotlightPopoverWrapper = (0, $47bDC.default).div.withConfig({
        componentId: "ovmtxf-0"
    })({
        position: 'absolute',
        top: 'calc(100% + 5px)',
        right: "var(--ds-space-negative-025, -2px)"
    }, ({ zIndex: zIndex })=>zIndex && (0, $47bDC.css)({
            zIndex: zIndex
        }));
    const $94f1f60818fb1297$var$SpotlightContainerWrapper = (0, $47bDC.default)((0, (0, parcelRequire("k6T4f")).Pulse)).withConfig({
        componentId: "ovmtxf-1"
    })({
        position: 'relative'
    });
});
parcelRegister("2NKLM", function(module, exports) {
    $parcel$export(module.exports, "MinimizableModalModal", ()=>$325627811178cea7$export$8b041304f822d4d4);
    var $5uXOq = parcelRequire("5uXOq");
    var $7QSqG;
    var $1F7mG;
    var $gLdtQ;
    var $45Cy1;
    var $iUFy5;
    var $6BEt4;
    var $8zOmE;
    var $2NMNM;
    var $8LWdH;
    var $bMoTh;
    var $31ArW;
    const $325627811178cea7$var$HeaderComponent = ()=>{
        const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("31ArW")).default), {
            shouldDisableActions: false,
            shouldShowChangerSpotlight: shouldShowChangerSpotlight,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        });
    };
    const $325627811178cea7$var$ModalBodyNext = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7QSqG")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: (0, (0, parcelRequire("gLdtQ")).ISSUE_CREATE_MODAL_BODY_SELECTOR),
            ref: ref,
            ...props
        })));
    const $325627811178cea7$var$FooterComponent = ()=>{
        const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, dismissModalEntryPointWrapper: dismissModalEntryPointWrapper } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        const shouldDisableSubmit = getShouldDisableSubmit();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8LWdH")).default), {
            onClose: onModalCloseWithConfirm('cancel'),
            onSubmit: onSubmit,
            isSubmitting: isSubmitting,
            isOperationInProgress: isOperationInProgress,
            canCreateAnotherIssue: canCreateAnotherIssue,
            onCreateAnotherChange: onCreateAnotherChange,
            shouldDisableSubmit: shouldDisableSubmit,
            createdIssues: createdIssues,
            displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
            showIssuesCreated: showIssuesCreated,
            dismissModalEntryPointWrapper: dismissModalEntryPointWrapper
        });
    };
    const $325627811178cea7$export$8b041304f822d4d4 = ({ 'data-testid': dataTestId, children: children })=>{
        const [{ isFormDirty: isFormDirty, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const uiModificationsStatus = (0, (0, parcelRequire("1F7mG")).useUiModificationsEnabledStatus)(hasFinishedLoading);
        const { setView: setView, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, onClose: onClose } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const onModalCloseOverride = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            const isEscapePress = event?.key === 'Escape' || event?.key === 'Esc' || event?.keyCode === 27;
            const isBlanketClick = !isEscapePress;
            if (isBlanketClick && (!hasFinishedLoading || uiModificationsStatus !== 'disabled')) return;
            if (isBlanketClick || isFormDirty) {
                setView('mini');
                const dockAnalyticsEvent = createAnalyticsEvent({
                    action: 'docked',
                    actionSubject: 'modalDialog'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(dockAnalyticsEvent, 'modalDialog docked', {
                    isBlanketClick: isBlanketClick
                });
            } else onClose?.(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            hasFinishedLoading,
            isFormDirty,
            onClose,
            setView,
            uiModificationsStatus
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6BEt4")).Modal), {
            "data-testid": dataTestId,
            components: {
                Header: $325627811178cea7$var$HeaderComponent,
                Footer: $325627811178cea7$var$FooterComponent,
                Body: $325627811178cea7$var$ModalBodyNext
            },
            onClose: !shouldDisableViewChangerButtons ? onModalCloseOverride : undefined,
            shouldCloseOnOverlayClick: !shouldDisableViewChangerButtons
        }, children);
    };
});
parcelRegister("7qb4M", function(module, exports) {
    $parcel$export(module.exports, "useSetSummary", ()=>$3ce05a20d11d1674$export$2e036b125a865e82);
    var $5uXOq = parcelRequire("5uXOq");
    var $hGgHi = parcelRequire("hGgHi");
    var $5eGnF;
    var $9svjh;
    const $3ce05a20d11d1674$export$2e036b125a865e82 = (initialSummaryValue)=>{
        const [summaryValue, setSummary] = (0, $5uXOq.useState)(initialSummaryValue || initialSummaryValue === null ? initialSummaryValue : '');
        const hasSetInitialValue = (0, $5uXOq.useRef)(false);
        if (!hasSetInitialValue.current && !(0, ($parcel$interopDefault($hGgHi)))(initialSummaryValue)) {
            hasSetInitialValue.current = true;
            setSummary(initialSummaryValue);
        }
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        (0, $5uXOq.useEffect)(()=>{
            subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, async (data)=>{
                if (data.fieldId === 'summary') setSummary(data.value.toString());
            });
            subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, async ()=>{
                setSummary('');
            });
        }, [
            subscribe,
            setSummary
        ]);
        (0, $5uXOq.useEffect)(()=>subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async ()=>{
                setSummary('');
            }), [
            subscribe,
            setSummary
        ]);
        return summaryValue;
    };
});
parcelRegister("6mZXS", function(module, exports) {
    $parcel$export(module.exports, "useViewChangerDisabler", ()=>$9363df13396c3799$export$db29ac8670837568);
    var $5uXOq = parcelRequire("5uXOq");
    var $6s1PB;
    var $koVbs;
    var $1F7mG;
    var $laCJ2;
    var $45Cy1;
    var $iUFy5;
    var $5rzqz;
    var $bMoTh;
    var $f5aZe;
    const $9363df13396c3799$export$db29ac8670837568 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ disableMinimizableModal: disableMinimizableModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { isNestedModal: isNestedModal, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons, setView: setView, view: view } = (0, (0, parcelRequire("iUFy5")).useMinimizableModal)();
        const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const adjustmentsAreEnabled = (0, (0, parcelRequire("laCJ2")).useAdjustmentsEnabled)();
        const uiModificationsStatus = (0, (0, parcelRequire("1F7mG")).useUiModificationsEnabledStatus)(hasFinishedLoading);
        const { setShouldRestore: setShouldRestore } = (0, (0, parcelRequire("bMoTh")).useMinimizableModalWrapperProps)();
        const disableViewChangerButtonsHandler = (0, $5uXOq.useCallback)((disableViewChangerButtons, customDisabledViewChangerButtonsMessage)=>{
            setShouldDisableViewChangerButtons(disableViewChangerButtons, customDisabledViewChangerButtonsMessage);
            setShouldRestore?.(!disableViewChangerButtons);
        }, [
            setShouldDisableViewChangerButtons,
            setShouldRestore
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (disableMinimizableModal || isNestedModal) disableViewChangerButtonsHandler(true);
            else if (uiModificationsStatus === 'enabled' || adjustmentsAreEnabled) disableViewChangerButtonsHandler(true, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("f5aZe")).default).changerButtonsDisabledForgeFieldsIssueTermRefresh : (0, (0, parcelRequire("f5aZe")).default).changerButtonsDisabledForgeFields));
            else disableViewChangerButtonsHandler(false);
        }, [
            adjustmentsAreEnabled,
            disableMinimizableModal,
            disableViewChangerButtonsHandler,
            formatMessage,
            isNestedModal,
            setShouldDisableViewChangerButtons,
            uiModificationsStatus
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (view === 'fullscreen') return;
            if (shouldDisableViewChangerButtons) setView('modal', true);
        }, [
            setView,
            view,
            shouldDisableViewChangerButtons
        ]);
    };
});
parcelRegister("f5aZe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f219cb02032feb7c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f219cb02032feb7c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changerButtonsDisabledForgeFields: {
            "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields",
            "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
        },
        changerButtonsDisabledForgeFieldsIssueTermRefresh: {
            "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh",
            "defaultMessage": "Some fields in this project and work type don\u2019t allow resizing or minimizing"
        }
    });
});
parcelRegister("7beZ9", function(module, exports) {
    $parcel$export(module.exports, "NavigateWithoutRestorePrompt", ()=>$c308ab93c9dea3af$export$f92d4f53cfa676ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $45Cy1;
    var $lVJAU;
    var $9AReS;
    var $9U8fV;
    const $c308ab93c9dea3af$export$f92d4f53cfa676ca = ({ setShouldRestore: setShouldRestore, isNavigationDiscardFeatureEnabled: isNavigationDiscardFeatureEnabled = false })=>{
        const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, (0, parcelRequire("9U8fV")).useNavigationDiscardChanges)();
        const [{ isFormDirty: isFormDirty }] = (0, (0, parcelRequire("45Cy1")).useFormContext)();
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const onConfirmHandler = (0, $5uXOq.useCallback)(()=>{
            setShouldRestore && setShouldRestore(false);
        }, [
            setShouldRestore
        ]);
        const onCancelHandler = (0, $5uXOq.useCallback)(()=>{
            setDeferredNavigationLink('');
        }, [
            setDeferredNavigationLink
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (deferredNavigationLink && !isFormDirty) {
                setShouldRestore && setShouldRestore(false);
                push(deferredNavigationLink);
                setDeferredNavigationLink('');
            }
        }, [
            deferredNavigationLink,
            isFormDirty,
            push,
            setDeferredNavigationLink,
            setShouldRestore
        ]);
        if (!isNavigationDiscardFeatureEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AReS")).NavigationDiscardChangesPrompt), {
            navigateLink: isFormDirty ? deferredNavigationLink : '',
            onConfirm: onConfirmHandler,
            onCancel: onCancelHandler
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
    };
});
parcelRegister("42ZoK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2c0ad2d4a2f759b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $btivG;
    var $6s1PB;
    var $d4xRU;
    var $7HGHK;
    var $pa9q9;
    var $koVbs;
    var $bnNZI;
    var $9WKj5;
    var $isrQ5;
    const $2c0ad2d4a2f759b7$export$93bd4963a1d00fd5 = (props)=>{
        const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const getDynamicFlagType = ()=>{
            if (successFlagParams) {
                const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
                if (isRankable && isWorkMode) {
                    if (boardType === (0, $976eff6d67d3515b$export$4498412e32a31fb6) && canManageSprints) return 0, $797f94a2e49d6094$export$407f3b8bfd90ad8d;
                    if (boardType === (0, $976eff6d67d3515b$export$b4e9cdb19cfa0abb)) return 0, $797f94a2e49d6094$export$256b368007db542a;
                }
            }
            return 0, $797f94a2e49d6094$export$858ff9c1b12e1d84;
        };
        const getDefaultFlagTitle = ()=>{
            const areMultipleIssuesCreated = issueList.length > 1;
            return areMultipleIssuesCreated ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSuccessFlagTitle, {
                issueCount: issueList.length
            }) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).createSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).createSuccessFlagTitle, {
                issueKey: issueList[0].issueKey
            });
        };
        const FlagConfigs = {
            Default: ()=>({
                    flagTitle: getDefaultFlagTitle(),
                    flagDescription: '',
                    flagActions: (0, (0, parcelRequire("9WKj5")).getDefaultFlagActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    })
                }),
            IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                        issueCount: issuesExcludingEpics.length
                    }),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintSuccessFlagDescription, {
                        issueKey: issuesWithNoSprint[0].issueKey,
                        issueCount: issuesExcludingEpics.length
                    }),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getNewScrumIssuesWithNoSprintsActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl,
                        issuesWithNoSprint: issuesWithNoSprint,
                        sprints: sprints
                    })
                }),
            IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                        issueCount: issuesExcludingEpics.length
                    }),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintSuccessFlagDescription, {
                        issueKey: issuesWithNoSprint[0].issueKey,
                        issueCount: issuesExcludingEpics.length
                    }),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getDefaultFlagActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    })
                }),
            MultipleIssuesSomeNoSprint: ()=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getDefaultFlagActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    })
                }),
            HiddenScrumIssues: (issues, isFiltered)=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).createdHiddenIssueSuccessFlagTitle, {
                        issueCount: issues.length
                    }),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                        issueCount: issues.length
                    }),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getHiddenIssuesActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl,
                        isFiltered: isFiltered
                    })
                }),
            IssuesInBacklog: (issues)=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                        issueCount: issues.length
                    }),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).issueCreatedInBacklogSuccessFlagDescription, {
                        issueKey: issues[0].issueKey,
                        issueCount: issues.length
                    }),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getDefaultFlagActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    })
                }),
            MultipleIssuesSomeInBacklog: ()=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getDefaultFlagActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    })
                }),
            HiddenKanbanIssues: (issues, isFiltered)=>({
                    flagTitle: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).createdHiddenIssueSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).createdHiddenIssueSuccessFlagTitle, {
                        issueCount: issues.length
                    }),
                    flagDescription: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("isrQ5")).default).kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh : (0, (0, parcelRequire("isrQ5")).default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                        issueCount: issues.length
                    }),
                    flagActions: (0, (0, parcelRequire("9WKj5")).getHiddenIssuesActions)({
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl,
                        isFiltered: isFiltered
                    })
                })
        };
        const getFlagContent = ()=>{
            if (successFlagParams) {
                if (getDynamicFlagType() === (0, $797f94a2e49d6094$export$407f3b8bfd90ad8d)) {
                    const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                    if (issuesWithNoSprint.length > 0) {
                        if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                            if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                            return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                        }
                        return FlagConfigs.MultipleIssuesSomeNoSprint();
                    }
                    if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
                } else if (getDynamicFlagType() === (0, $797f94a2e49d6094$export$256b368007db542a)) {
                    const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                    if (kanbanIssuesInBacklog.length > 0) {
                        if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                        return FlagConfigs.MultipleIssuesSomeInBacklog();
                    }
                    if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
                }
            }
            return FlagConfigs.Default();
        };
        const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
            "data-testid": (0, $797f94a2e49d6094$export$2e4c8b336846b593)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d4xRU")).default), {
            icon: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("btivG"))))), {
                primaryColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$940e1f69e873f202)})`,
                label: "Success"
            }),
            id: (0, (0, parcelRequire("7HGHK")).fromFlagId)(id),
            key: flagKey,
            title: flagTitle,
            description: flagDescription,
            actions: flagActions,
            onDismissed: ()=>{
                dismissFlag(id);
            }
        }));
    };
    const $2c0ad2d4a2f759b7$var$SuccessFlagWithContext = (props)=>{
        const { id: id } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bnNZI")).AddToSprintActionStatesContainer), {
            scope: id.valueOf(),
            key: id.valueOf()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2c0ad2d4a2f759b7$export$93bd4963a1d00fd5, props));
    };
    var $2c0ad2d4a2f759b7$export$2e2bcd8739ae039 = $2c0ad2d4a2f759b7$var$SuccessFlagWithContext;
});
const $976eff6d67d3515b$export$9a958daafd9a03ed = 'agility-board';
const $976eff6d67d3515b$export$de6b9ed6cd36bad1 = 'core-board';
const $976eff6d67d3515b$export$b4e9cdb19cfa0abb = 'kanban';
const $976eff6d67d3515b$export$4498412e32a31fb6 = 'scrum';
parcelRegister("bnNZI", function(module, exports) {
    $parcel$export(module.exports, "AddToSprintActionStatesContainer", ()=>$69e54ec8a90ab75a$export$4ae31d89b87a513);
    $parcel$export(module.exports, "useAddToSprintFlagActionStateController", ()=>$69e54ec8a90ab75a$export$dc7fffa2c4559368);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    const $69e54ec8a90ab75a$var$initialState = {
        addToSprintCTAsEnabled: true
    };
    const $69e54ec8a90ab75a$var$actions = {
        disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
                setState({
                    addToSprintCTAsEnabled: false
                });
            }
    };
    const $69e54ec8a90ab75a$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $69e54ec8a90ab75a$var$initialState,
        actions: $69e54ec8a90ab75a$var$actions,
        name: 'SuccessFlagAddToSprintActionStateController'
    });
    const $69e54ec8a90ab75a$export$4ae31d89b87a513 = (0, (0, parcelRequire("gg7kZ")).createContainer)($69e54ec8a90ab75a$var$Store);
    const $69e54ec8a90ab75a$export$dc7fffa2c4559368 = (0, (0, parcelRequire("3sQ5x")).createHook)($69e54ec8a90ab75a$var$Store);
});
parcelRegister("9WKj5", function(module, exports) {
    $parcel$export(module.exports, "getDefaultFlagActions", ()=>$dbbf75d458151c43$export$6de10317e135f24);
    $parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", ()=>$dbbf75d458151c43$export$882355824d3fc905);
    $parcel$export(module.exports, "getHiddenIssuesActions", ()=>$dbbf75d458151c43$export$f5c2849658ba2a03);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $aWse0;
    var $gEaAu;
    var $8zOmE;
    var $2NMNM;
    var $bnNZI;
    var $fHXGa;
    const $dbbf75d458151c43$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const fireViewIssueAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$71ce489a3b20fc93), {
                isNewGIC: true
            });
        }, [
            createAnalyticsEvent
        ]);
        return {
            content: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fHXGa")).default).viewIssueCtaIssueTermRefresh : (0, (0, parcelRequire("fHXGa")).default).viewIssueCta, {
                issueCount: issueList.length
            }),
            href: issueDiscoveryUrl,
            onClick: fireViewIssueAnalyticsEvent
        };
    };
    const $dbbf75d458151c43$var$CopyLinkCta = (issueDiscoveryUrl)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            let timeoutId;
            if (isCopied) timeoutId = setTimeout(()=>{
                setCopied(false);
            }, 2000);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }, [
            isCopied
        ]);
        const copyToClipboard = (0, $5uXOq.useCallback)(async ()=>{
            try {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'link'
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('jfp-magma-undefined-navigator')) await globalThis.navigator.clipboard.writeText(`${globalThis.location.origin}${issueDiscoveryUrl}`);
                else await navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
                setCopied(true);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$3a43d61edae693a9));
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'copyToClipboard',
                        packageName: 'jiraIssueCreate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }, [
            createAnalyticsEvent,
            issueDiscoveryUrl
        ]);
        return {
            content: isCopied ? (0, ($parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, (0, parcelRequire("fHXGa")).default).linkCopied)) : formatMessage((0, (0, parcelRequire("fHXGa")).default).copyLinkCta),
            onClick: copyToClipboard
        };
    };
    const $dbbf75d458151c43$var$ClearFiltersCta = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [isCompleted, setIsCompleted] = (0, $5uXOq.useState)(false);
        const clearFiltersAction = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("gEaAu")).successFlagClearFiltersAction).start();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            const { GH: GH } = window;
            setIsLoading(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$bc715896f18417a3), {
                isNewGIC: true
            });
            GH.WorkController.clearFilters().done(()=>{
                (0, (0, parcelRequire("gEaAu")).successFlagClearFiltersAction).stop();
                setIsCompleted(true);
                setIsLoading(false);
            }).fail(()=>{
                (0, (0, parcelRequire("gEaAu")).successFlagClearFiltersAction).stop();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'clearFilters',
                        packageName: 'jiraIssueCreate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            createAnalyticsEvent
        ]);
        if (isLoading) return {
            content: formatMessage((0, (0, parcelRequire("fHXGa")).default).clearFiltersCtaLoading)
        };
        if (isCompleted) return {
            content: (0, ($parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, (0, parcelRequire("fHXGa")).default).clearFiltersCtaCompleted))
        };
        return {
            content: formatMessage((0, (0, parcelRequire("fHXGa")).default).clearFiltersCta),
            onClick: clearFiltersAction
        };
    };
    const $dbbf75d458151c43$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [isCompleted, setIsCompleted] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, (0, parcelRequire("bnNZI")).useAddToSprintFlagActionStateController)();
        const addToSprintAction = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("gEaAu")).successFlagAddToSprintAction).start();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            const { GH: GH } = window;
            disableOtherAddToSprintCTAs();
            setIsLoading(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, $2144e1d48c8e9f2b$export$31bef7c6ffa89efa), {
                isNewGIC: true
            });
            GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
                (0, (0, parcelRequire("gEaAu")).successFlagAddToSprintAction).stop();
                setIsCompleted(true);
                setIsLoading(false);
            }).fail(()=>{
                (0, (0, parcelRequire("gEaAu")).successFlagAddToSprintAction).stop();
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'addToSprint',
                        packageName: 'jiraIssueCreate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }, [
            createAnalyticsEvent,
            sprint,
            issuesWithNoSprint,
            disableOtherAddToSprintCTAs
        ]);
        if (isLoading) return [
            {
                content: formatMessage((0, (0, parcelRequire("fHXGa")).default).addIssuesToSprintCtaLoading)
            }
        ];
        if (isCompleted) return [
            {
                content: (0, ($parcel$interopDefault($5uXOq))).createElement($dbbf75d458151c43$var$ActionSuccess, null, formatMessage((0, (0, parcelRequire("fHXGa")).default).addIssuesToSprintCtaCompleted))
            }
        ];
        if (addToSprintCTAsEnabled) return [
            {
                content: formatMessage((0, (0, parcelRequire("fHXGa")).default).addAllIssuesToSprintCta, {
                    sprintName: sprint.name
                }),
                onClick: addToSprintAction
            }
        ];
        return [];
    };
    const $dbbf75d458151c43$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
        const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
        const totalCreatedIssuesCount = issueList.length;
        let ctaList = [];
        editableSprints.forEach((sprint)=>{
            ctaList = ctaList.concat($dbbf75d458151c43$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
        });
        return ctaList;
    };
    const $dbbf75d458151c43$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
            $dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
            $dbbf75d458151c43$var$CopyLinkCta(issueDiscoveryUrl)
        ];
    const $dbbf75d458151c43$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
        const ctaList = $dbbf75d458151c43$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
        ctaList.push($dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
        return ctaList;
    };
    const $dbbf75d458151c43$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
        const ctaList = [
            $dbbf75d458151c43$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
        ];
        if (isFiltered) ctaList.push($dbbf75d458151c43$var$ClearFiltersCta());
        return ctaList;
    };
    const $dbbf75d458151c43$var$ActionSuccess = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syazocqs",
                __cmplp.className
            ])
        });
    });
});
const $2144e1d48c8e9f2b$export$71ce489a3b20fc93 = 'viewIssues';
const $2144e1d48c8e9f2b$export$3a43d61edae693a9 = 'copyLink';
const $2144e1d48c8e9f2b$export$31bef7c6ffa89efa = 'addToSprint';
const $2144e1d48c8e9f2b$export$bc715896f18417a3 = 'clearFilters';
parcelRegister("fHXGa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c1205559fab8abcd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c1205559fab8abcd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewIssueCta: {
            "id": "issue-create.modal.success-flag.actions.view-issue-cta",
            "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
        },
        copyLinkCta: {
            "id": "issue-create.modal.success-flag.actions.copy-link-cta",
            "defaultMessage": "Copy link"
        },
        linkCopied: {
            "id": "issue-create.modal.success-flag.actions.link-copied",
            "defaultMessage": "Copied"
        },
        addAllIssuesToSprintCta: {
            "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
            "defaultMessage": "Add to {sprintName}"
        },
        clearFiltersCta: {
            "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
            "defaultMessage": "Clear filters"
        },
        clearFiltersCtaLoading: {
            "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
            "defaultMessage": "Clearing..."
        },
        clearFiltersCtaCompleted: {
            "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
            "defaultMessage": "Filters cleared"
        },
        addIssuesToSprintCtaLoading: {
            "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
            "defaultMessage": "Adding..."
        },
        addIssuesToSprintCtaCompleted: {
            "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
            "defaultMessage": "Added to sprint"
        },
        viewIssueCtaIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.actions.view-issue-cta-issue-term-refresh",
            "defaultMessage": "View {issueCount, plural, one {work item} other {work items}}"
        }
    });
});
const $797f94a2e49d6094$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $797f94a2e49d6094$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $797f94a2e49d6094$export$256b368007db542a = 'cmp-kanban-flag';
const $797f94a2e49d6094$export$858ff9c1b12e1d84 = 'default-success-flag';
parcelRegister("isrQ5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60639d580c79b6fe$export$2e2bcd8739ae039);
    var $7VHMR;
    var $60639d580c79b6fe$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.create-success-flag-title",
            "defaultMessage": "You've created \"{issueKey}\" issue"
        },
        multiplesIssuesCreatedSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
            "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
        },
        issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
            "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
        },
        issueCreatedNoSprintSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
            "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
        },
        multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
            "defaultMessage": "Issues added to sprint(s) and backlog"
        },
        multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
            "defaultMessage": "Some of your issues weren't added to a sprint."
        },
        createdHiddenIssueSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
            "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
        },
        scrumCreatedHiddenIssueSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
            "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
        },
        issueCreatedInBacklogSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
            "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
        },
        multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
            "defaultMessage": "Issues added to board and backlog"
        },
        multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
            "defaultMessage": "Your issues have been created, but some aren't on the board."
        },
        kanbanCreatedHiddenIssueSuccessFlagDescription: {
            "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
            "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
        },
        createSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.create-success-flag-title-issue-term-refresh",
            "defaultMessage": "You've created \"{issueKey}\" work item"
        },
        multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title-issue-term-refresh",
            "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}"
        },
        issueCreatedNoSprintOrInBacklogSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} added to the backlog"
        },
        issueCreatedNoSprintSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has} other {Your work items have}} been created and added to the backlog."
        },
        multiplesIssuesCreatedSomeNoSprintSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title-issue-term-refresh",
            "defaultMessage": "Work items added to sprint(s) and backlog"
        },
        multiplesIssuesCreatedSomeNoSprintSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description-issue-term-refresh",
            "defaultMessage": "Some of your work items weren't added to a sprint."
        },
        createdHiddenIssueSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {Work item} other {Work items}} created but not visible"
        },
        scrumCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item was added to a different sprint, it may not be visible} other {If the board has active filters, or the work items were added to a different sprint, they may not be visible}}."
        },
        issueCreatedInBacklogSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {Your work item {issueKey} has been created, but isn't on the board} other {Your work items have been created, but aren't on the board}}."
        },
        multiplesIssuesCreatedSomeInBacklogSuccessFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title-issue-term-refresh",
            "defaultMessage": "Work items added to board and backlog"
        },
        multiplesIssuesCreatedSomeInBacklogSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description-issue-term-refresh",
            "defaultMessage": "Your work items have been created, but some aren't on the board."
        },
        kanbanCreatedHiddenIssueSuccessFlagDescriptionIssueTermRefresh: {
            "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description-issue-term-refresh",
            "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the work item wasn't added to the board, it may not be visible} other {If the board has active filters, or the work items weren't added to the board, they may not be visible}}."
        }
    });
});
parcelRegister("dXTIs", function(module, exports) {
    $parcel$export(module.exports, "getFirstFieldIdWithError", ()=>$7823f1c3d8b410e7$export$f15841b83bf0d927);
    $parcel$export(module.exports, "publishCreatedIssues", ()=>$7823f1c3d8b410e7$export$d46eb3aee2ce61a5);
    $parcel$export(module.exports, "getTabIndexWithError", ()=>$7823f1c3d8b410e7$export$1d81ee131c803e88);
    $parcel$export(module.exports, "getWatchersFlagConfigFromResponse", ()=>$7823f1c3d8b410e7$export$47ea475ac70a5697);
    var $gccSB = parcelRequire("gccSB");
    var $4Xk2W = parcelRequire("4Xk2W");
    var $dvqhI;
    var $jcw0u;
    var $6s1PB;
    var $eusud;
    var $bGrWH;
    var $5eGnF;
    var $l12V4;
    var $a1SNr;
    const $7823f1c3d8b410e7$export$8d7a103b266a4496 = '/rest/api/3/search';
    let $7823f1c3d8b410e7$var$issueDataTillNow = {};
    let $7823f1c3d8b410e7$var$activePromises = {};
    const $7823f1c3d8b410e7$export$f15841b83bf0d927 = ({ fields: fields, emptyRequiredFields: emptyRequiredFields })=>{
        if (emptyRequiredFields) return fields.find((fieldId)=>{
            if (emptyRequiredFields.includes(fieldId)) return true;
            if ((0, (0, parcelRequire("bGrWH")).MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId]) return emptyRequiredFields.some((key)=>(0, (0, parcelRequire("bGrWH")).MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId].includes(key));
            return false;
        });
        return undefined;
    };
    const $7823f1c3d8b410e7$var$fetchIssueListPromise = (jql, fieldsToAddInPublishedData, fetchAllFields)=>{
        if ($7823f1c3d8b410e7$var$activePromises[jql] === undefined) {
            if (fetchAllFields) $7823f1c3d8b410e7$var$activePromises[jql] = (0, (0, parcelRequire("eusud")).performPostRequest)($7823f1c3d8b410e7$export$8d7a103b266a4496, {
                body: JSON.stringify({
                    jql: jql,
                    fields: [
                        ...new Set([
                            '*all'
                        ])
                    ]
                })
            });
            else $7823f1c3d8b410e7$var$activePromises[jql] = (0, (0, parcelRequire("eusud")).performPostRequest)($7823f1c3d8b410e7$export$8d7a103b266a4496, {
                body: JSON.stringify({
                    jql: jql,
                    fields: [
                        ...new Set([
                            'summary',
                            'status',
                            'assignee',
                            'duedate',
                            'project',
                            'issuetype',
                            'priority',
                            'issuelinks',
                            ...fieldsToAddInPublishedData
                        ])
                    ]
                })
            });
        }
        return $7823f1c3d8b410e7$var$activePromises[jql];
    };
    const $7823f1c3d8b410e7$var$getIssueList = async (createdIssues, fieldsToAddInPublishedData, fetchAllFields)=>{
        const issuesToFetch = createdIssues.filter(({ issueKey: issueKey })=>!$7823f1c3d8b410e7$var$issueDataTillNow[issueKey]);
        let newIssueDetails = {
            issues: []
        };
        if (issuesToFetch.length) {
            const jql = issuesToFetch.reduce((jqlQuery, { issueKey: issueKey }, index)=>`${jqlQuery}issuekey=${issueKey}${index !== issuesToFetch.length - 1 ? ' OR ' : ''}`, '');
            try {
                newIssueDetails = await $7823f1c3d8b410e7$var$fetchIssueListPromise(jql, fieldsToAddInPublishedData, fetchAllFields);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'getIssueList',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                $7823f1c3d8b410e7$var$activePromises[jql] = undefined;
            }
        }
        const prefetchedIssueDetails = createdIssues.filter(({ issueKey: issueKey })=>$7823f1c3d8b410e7$var$issueDataTillNow[issueKey]).map(({ issueKey: issueKey })=>$7823f1c3d8b410e7$var$issueDataTillNow[issueKey].createdIssueDetails);
        return {
            issues: [
                ...prefetchedIssueDetails,
                ...newIssueDetails.issues
            ]
        };
    };
    const $7823f1c3d8b410e7$var$merge = (obj, obj2)=>({
            ...obj,
            ...obj2
        });
    const $7823f1c3d8b410e7$export$d46eb3aee2ce61a5 = async ({ createdIssues: createdIssues, globalEventNamespaces: globalEventNamespaces = [
        (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
    ], fieldsToAddInPublishedData: fieldsToAddInPublishedData = [], alertsToBeLinked: alertsToBeLinked = [], isSessionComplete: isSessionComplete = false, onIssueCreate: onIssueCreate, siteDomain: siteDomain, selectedCloudId: selectedCloudId, onClose: onClose, triggerPointKey: triggerPointKey, publishGICLifecycle: publishGICLifecycle, isIssueCreateSuccess: isIssueCreateSuccess, callbackPayload: callbackPayload, jqlSwimlaneId: jqlSwimlaneId, ecosystemCallback: ecosystemCallback }, fireErrorAnalytics = (0, (0, parcelRequire("jcw0u")).default))=>{
        let fetchAllFields = false;
        if (ecosystemCallback && ecosystemCallback.callbackFunction) fetchAllFields = true;
        if (createdIssues.length) {
            let oldFlagUnbindSuccess = false;
            try {
                window.require('jira/common/header').unbind();
                oldFlagUnbindSuccess = true;
            } catch (err) {
                oldFlagUnbindSuccess = false;
            }
            try {
                const issueSearchRequest = $7823f1c3d8b410e7$var$getIssueList(createdIssues, fieldsToAddInPublishedData, fetchAllFields);
                const [issueList, Events] = await Promise.all([
                    issueSearchRequest,
                    (0, (0, parcelRequire("dvqhI")).apiReady)()
                ]);
                const issueData = (0, ($parcel$interopDefault($4Xk2W)))(issueList.issues, 'key');
                const createdIssuesWithIssueData = createdIssues.map((createdIssue)=>{
                    const createdIssueDetails = issueData[createdIssue.issueKey];
                    const summary = createdIssueDetails?.fields?.summary;
                    return {
                        ...createdIssue,
                        summary: summary,
                        createdIssueDetails: createdIssueDetails,
                        selectedCloudId: selectedCloudId,
                        jqlSwimlaneId: jqlSwimlaneId
                    };
                });
                $7823f1c3d8b410e7$var$issueDataTillNow = $7823f1c3d8b410e7$var$merge($7823f1c3d8b410e7$var$issueDataTillNow, (0, ($parcel$interopDefault($4Xk2W)))(createdIssuesWithIssueData, 'issueKey'));
                if (isIssueCreateSuccess) createdIssuesWithIssueData.forEach((createdIssue)=>{
                    onIssueCreate?.(siteDomain ? {
                        ...createdIssue,
                        siteDomain: siteDomain
                    } : createdIssue, alertsToBeLinked);
                    publishGICLifecycle?.((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, {
                        createdIssueData: createdIssue,
                        callbackPayload: callbackPayload
                    });
                });
                if (isSessionComplete) {
                    if (fetchAllFields) (0, (0, parcelRequire("l12V4")).executeEcosystemAPICallback)(ecosystemCallback, createdIssuesWithIssueData);
                    globalEventNamespaces.forEach((namespace)=>{
                        if (triggerPointKey !== undefined) Events?.trigger?.(`${namespace}.sessionComplete`, [
                            createdIssuesWithIssueData,
                            triggerPointKey
                        ]);
                        else Events?.trigger?.(`${namespace}.sessionComplete`, [
                            createdIssuesWithIssueData
                        ]);
                    });
                    onClose?.(createdIssuesWithIssueData);
                }
            } catch (error) {
                fireErrorAnalytics({
                    meta: {
                        id: 'publishCreatedIssues',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            if (isSessionComplete) {
                $7823f1c3d8b410e7$var$issueDataTillNow = {};
                $7823f1c3d8b410e7$var$activePromises = {};
            }
            if (oldFlagUnbindSuccess && isSessionComplete) window.require('jira/common/header').initialize();
        } else if (isSessionComplete) {
            if (fetchAllFields) (0, (0, parcelRequire("l12V4")).executeEcosystemAPICallback)(ecosystemCallback, []);
            onClose && onClose([]);
        }
    };
    const $7823f1c3d8b410e7$export$1d81ee131c803e88 = (fieldTabs, fieldValues, requiredFieldsData)=>{
        if (!fieldValues) return -1;
        const emptyRequiredField = Object.keys(fieldValues)?.find((id)=>requiredFieldsData[id] && Boolean(requiredFieldsData[id].isRequired) && fieldValues && (0, ($parcel$interopDefault($gccSB)))(fieldValues[id]));
        const tabIndex = fieldTabs?.findIndex((tab)=>tab.items.find((item)=>item === emptyRequiredField));
        return tabIndex > -1 ? tabIndex : -1;
    };
    const $7823f1c3d8b410e7$export$47ea475ac70a5697 = (response)=>{
        if (response?.errorCollection && response.errorCollection.errorMessages[0]) return {
            type: 'error',
            title: (0, (0, parcelRequire("a1SNr")).default).watchersErrorFlagTitle,
            description: response.errorCollection.errorMessages[0]
        };
        if (response?.warningCollection && response.warningCollection.warnings[0]) return {
            type: 'warning',
            title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("a1SNr")).default).watchersWarningFlagTitleIssueTermRefresh : (0, (0, parcelRequire("a1SNr")).default).watchersWarningFlagTitle,
            description: response.warningCollection.warnings[0]
        };
        return undefined;
    };
});
parcelRegister("4Xk2W", function(module, exports) {
    var $1m3dq = parcelRequire("1m3dq");
    var $4CZTG = parcelRequire("4CZTG");
    var $39bc38f0156cacc0$var$keyBy = $4CZTG(function(result, value, key) {
        $1m3dq(result, key, value);
    });
    module.exports = $39bc38f0156cacc0$var$keyBy;
});
parcelRegister("dvqhI", function(module, exports) {
    $parcel$export(module.exports, "apiReady", ()=>$548c078b9ef136c5$export$330fb1a04c974aad);
    var $6BZYo;
    let $548c078b9ef136c5$var$currentBridge;
    const $548c078b9ef136c5$export$330fb1a04c974aad = async ()=>{
        if ($548c078b9ef136c5$var$currentBridge) return $548c078b9ef136c5$var$currentBridge;
        const Events = await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'jira/util/events',
            wrmKeys: 'wrc!jira.webresources:jira-events'
        });
        $548c078b9ef136c5$var$currentBridge = Events;
        return Events;
    };
});
parcelRegister("l12V4", function(module, exports) {
    $parcel$export(module.exports, "executeEcosystemAPICallback", ()=>$82c70d8098d8adb3$export$352b0ab2ba913578);
    var $bU57W;
    const $82c70d8098d8adb3$var$sanitizeIssues = (issuesData)=>{
        const sanitizedIssues = [];
        for (const issueData of issuesData){
            const sanitizedIssue = {
                id: '',
                key: '',
                self: '',
                fields: {}
            };
            const issue = issueData.createdIssueDetails;
            sanitizedIssue.id = issue.id;
            sanitizedIssue.key = issue.key;
            sanitizedIssue.self = issue.self;
            sanitizedIssue.fields = issue.fields;
            for(const field in sanitizedIssue.fields)if ((0, (0, parcelRequire("bU57W")).isAdfObject)(sanitizedIssue.fields[field])) sanitizedIssue.fields[field] = (0, (0, parcelRequire("bU57W")).convertAdfToWiki)(sanitizedIssue.fields[field]);
            sanitizedIssues.push(sanitizedIssue);
        }
        return sanitizedIssues;
    };
    const $82c70d8098d8adb3$export$352b0ab2ba913578 = (ecosystemCallback, issuesData)=>{
        if (ecosystemCallback && ecosystemCallback.callbackFunction) {
            const sanitizedIssues = $82c70d8098d8adb3$var$sanitizeIssues(issuesData);
            ecosystemCallback.callbackFunction.call({}, sanitizedIssues);
        }
    };
});
parcelRegister("bU57W", function(module, exports) {
    $parcel$export(module.exports, "convertAdfToWiki", ()=>$cfb4ed7bbd624bae$export$4aa84bff5b13655f);
    $parcel$export(module.exports, "isAdfObject", ()=>$cfb4ed7bbd624bae$export$9acea0de85f3957);
    var $kOFhM;
    var $hYNZx;
    var $dN5CS;
    const $cfb4ed7bbd624bae$export$4aa84bff5b13655f = (document)=>{
        try {
            const jsonTransformer = new (0, (0, parcelRequire("hYNZx")).JSONTransformer)();
            const wikiMarkupTransformer = new (0, (0, parcelRequire("dN5CS")).WikiMarkupTransformer)((0, (0, parcelRequire("kOFhM")).defaultSchema));
            if (document === null || document === undefined) return '';
            return wikiMarkupTransformer.encode(jsonTransformer.parse(document));
        } catch (error) {
            return '';
        }
    };
    const $cfb4ed7bbd624bae$export$9acea0de85f3957 = (field)=>{
        return field && field.type === 'doc' && Array.isArray(field.content);
    };
});
parcelRegister("a1SNr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffcb1a584fb62af3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ffcb1a584fb62af3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        watchersWarningFlagTitle: {
            "id": "issue-create.modal.watchers-warning-flag-title",
            "defaultMessage": "Watchers not added to your issue"
        },
        watchersErrorFlagTitle: {
            "id": "issue-create.modal.watchers-error-flag-title",
            "defaultMessage": "Something went wrong"
        },
        watchersWarningFlagTitleIssueTermRefresh: {
            "id": "issue-create.modal.watchers-warning-flag-title-issue-term-refresh",
            "defaultMessage": "Watchers not added to your work item"
        }
    });
});
